'use strict';
var $i_$0021style$002dloader$0021css$002dloader$0021ol$002fol$002ecss = require("!style-loader!css-loader!ol/ol.css");
var $i_hammerjs$002fhammer = require("hammerjs/hammer");
var $i_ol = require("ol");
var $i_ol$002fCollection = require("ol/Collection");
var $i_ol$002fFeature = require("ol/Feature");
var $i_ol$002fGeolocation = require("ol/Geolocation");
var $i_ol$002fMap = require("ol/Map");
var $i_ol$002fMapBrowserEventType = require("ol/MapBrowserEventType");
var $i_ol$002fObservable = require("ol/Observable");
var $i_ol$002fcontrol = require("ol/control");
var $i_ol$002fcontrol$002fScaleLine = require("ol/control/ScaleLine");
var $i_ol$002fextent = require("ol/extent");
var $i_ol$002fformat = require("ol/format");
var $i_ol$002fformat$002fWMTSCapabilities = require("ol/format/WMTSCapabilities");
var $i_ol$002fgeom$002fGeometryType = require("ol/geom/GeometryType");
var $i_ol$002fgeom$002fLineString = require("ol/geom/LineString");
var $i_ol$002fgeom$002fPoint = require("ol/geom/Point");
var $i_ol$002finteraction = require("ol/interaction");
var $i_ol$002flayer$002fImage = require("ol/layer/Image");
var $i_ol$002flayer$002fTile = require("ol/layer/Tile");
var $i_ol$002flayer$002fVector = require("ol/layer/Vector");
var $i_ol$002floadingstrategy = require("ol/loadingstrategy");
var $i_ol$002fproj = require("ol/proj");
var $i_ol$002fproj$002fUnits = require("ol/proj/Units");
var $i_ol$002fproj$002fproj4 = require("ol/proj/proj4");
var $i_ol$002fsource = require("ol/source");
var $i_ol$002fsource$002fOSM = require("ol/source/OSM");
var $i_ol$002fsource$002fVector = require("ol/source/Vector");
var $i_ol$002fsource$002fWMSServerType = require("ol/source/WMSServerType");
var $i_ol$002fsource$002fWMTS = require("ol/source/WMTS");
var $i_ol$002fsource$002fXYZ = require("ol/source/XYZ");
var $i_ol$002fsphere = require("ol/sphere");
var $i_ol$002fstyle = require("ol/style");
var $i_ol$002fstyle$002fCircle = require("ol/style/Circle");
var $i_ol$002fstyle$002fFill = require("ol/style/Fill");
var $i_ol$002fstyle$002fStroke = require("ol/style/Stroke");
var $i_ol$002fstyle$002fText = require("ol/style/Text");
var $i_ol$002ftilegrid$002fWMTS = require("ol/tilegrid/WMTS");
var $i_ol$002futil = require("ol/util");
var $i_proj4 = require("proj4");
var $i_react = require("react");
var $i_react$002ddom = require("react-dom");
var $i_three = require("three");
var $i_three$002fexamples$002fjsm$002fcontrols$002fOrbitControls = require("three/examples/jsm/controls/OrbitControls");
var $i_three$002fexamples$002fjsm$002floaders$002fOBJLoader = require("three/examples/jsm/loaders/OBJLoader");
var $i_three$002fexamples$002fjsm$002futils$002fBufferGeometryUtils = require("three/examples/jsm/utils/BufferGeometryUtils");
var $i_three$002fsrc$002fcameras$002fPerspectiveCamera = require("three/src/cameras/PerspectiveCamera");
var $i_three$002fsrc$002fmaterials$002fMeshPhysicalMaterial = require("three/src/materials/MeshPhysicalMaterial");
var $i_three$002fsrc$002frenderers$002fWebGLRenderer = require("three/src/renderers/WebGLRenderer");
var $i_three$002fsrc$002fscenes$002fScene = require("three/src/scenes/Scene");
var $linkingInfo = Object.freeze({
  "esVersion": 6,
  "assumingES6": true,
  "productionMode": false,
  "linkerVersion": "1.14.0",
  "fileLevelThis": this
});
var $getOwnPropertyDescriptors = (Object.getOwnPropertyDescriptors || (() => {
  var ownKeysFun;
  if ((((typeof Reflect) !== "undefined") && Reflect.ownKeys)) {
    ownKeysFun = Reflect.ownKeys
  } else {
    var getOwnPropertySymbols = (Object.getOwnPropertySymbols || ((o) => []));
    ownKeysFun = ((o) => Object.getOwnPropertyNames(o).concat(getOwnPropertySymbols(o)))
  };
  return ((o) => {
    var ownKeys = ownKeysFun(o);
    var descriptors = {};
    var len = (ownKeys.length | 0);
    var i = 0;
    while ((i !== len)) {
      var key = ownKeys[i];
      Object.defineProperty(descriptors, key, {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": Object.getOwnPropertyDescriptor(o, key)
      });
      i = ((i + 1) | 0)
    };
    return descriptors
  })
})());
var $L0;
function $propertyName(arg0) {
  for (var prop in arg0) {
    return prop
  }
}
function $Char(c) {
  this.c = c
}
$Char.prototype.toString = (function() {
  return String.fromCharCode(this.c)
});
function $valueDescription(arg0) {
  return (((typeof arg0) === "number") ? (((arg0 === 0) && ((1 / arg0) < 0)) ? "number(-0)" : (("number(" + arg0) + ")")) : ((arg0 instanceof $c_RTLong) ? "long" : ((arg0 instanceof $Char) ? "char" : ((!(!(arg0 && arg0.$classData))) ? arg0.$classData.name : (typeof arg0)))))
}
function $throwClassCastException(arg0, arg1) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_ClassCastException__T__(new $c_jl_ClassCastException(), (($valueDescription(arg0) + " cannot be cast to ") + arg1)))
}
function $throwArrayCastException(arg0, arg1, arg2) {
  while ((--arg2)) {
    arg1 = ("[" + arg1)
  };
  $throwClassCastException(arg0, arg1)
}
function $throwArrayIndexOutOfBoundsException(arg0) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((arg0 === null) ? null : ("" + arg0))))
}
function $throwArrayStoreException(arg0) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_ArrayStoreException(((arg0 === null) ? null : $valueDescription(arg0))))
}
function $throwNegativeArraySizeException() {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_NegativeArraySizeException())
}
function $throwNullPointerException() {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_NullPointerException__(new $c_jl_NullPointerException()))
}
function $n(arg0) {
  if ((arg0 === null)) {
    $throwNullPointerException()
  };
  return arg0
}
function $noIsInstance(arg0) {
  throw new TypeError("Cannot call isInstance() on a Class representing a JS trait/object")
}
function $newArrayObject(arg0, arg1) {
  return $newArrayObjectInternal(arg0, arg1, 0)
}
function $newArrayObjectInternal(arg0, arg1, arg2) {
  var result = new arg0.constr(arg1[arg2]);
  if ((arg2 < (arg1.length - 1))) {
    var subArrayClassData = arg0.componentData;
    var subLengthIndex = (arg2 + 1);
    var underlying = result.u;
    for (var i = 0; (i < underlying.length); (i++)) {
      underlying[i] = $newArrayObjectInternal(subArrayClassData, arg1, subLengthIndex)
    }
  };
  return result
}
function $objectClone(arg0) {
  return Object.create(Object.getPrototypeOf(arg0), $getOwnPropertyDescriptors(arg0))
}
function $objectOrArrayClone(arg0) {
  return (arg0.$classData.isArrayClass ? arg0.clone__O() : $objectClone(arg0))
}
function $objectGetClass(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return $d_T.getClassOf()
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return $d_jl_Byte.getClassOf()
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return $d_jl_Short.getClassOf()
        } else {
          return $d_jl_Integer.getClassOf()
        }
      } else if ($isFloat(arg0)) {
        return $d_jl_Float.getClassOf()
      } else {
        return $d_jl_Double.getClassOf()
      }
    }
    case "boolean": {
      return $d_jl_Boolean.getClassOf()
    }
    case "undefined": {
      return $d_jl_Void.getClassOf()
    }
    default: {
      if ((arg0 === null)) {
        $throwNullPointerException()
      } else if ((arg0 instanceof $c_RTLong)) {
        return $d_jl_Long.getClassOf()
      } else if ((arg0 instanceof $Char)) {
        return $d_jl_Character.getClassOf()
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.getClassOf()
      } else {
        return null
      }
    }
  }
}
function $objectClassName(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return "java.lang.String"
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return "java.lang.Byte"
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return "java.lang.Short"
        } else {
          return "java.lang.Integer"
        }
      } else if ($isFloat(arg0)) {
        return "java.lang.Float"
      } else {
        return "java.lang.Double"
      }
    }
    case "boolean": {
      return "java.lang.Boolean"
    }
    case "undefined": {
      return "java.lang.Void"
    }
    default: {
      if ((arg0 === null)) {
        $throwNullPointerException()
      } else if ((arg0 instanceof $c_RTLong)) {
        return "java.lang.Long"
      } else if ((arg0 instanceof $Char)) {
        return "java.lang.Character"
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.name
      } else {
        return $throwNullPointerException()
      }
    }
  }
}
function $dp_charAt__I__C(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__charAt__I__C(instance, x0)
  } else {
    return instance.charAt__I__C(x0)
  }
}
function $dp_codePointAt__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__codePointAt__I__I(instance, x0)
  } else {
    return instance.codePointAt__I__I(x0)
  }
}
function $dp_compareTo__O__I(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__compareTo__O__I(instance, x0)
    }
    case "number": {
      return $f_jl_Double__compareTo__O__I(instance, x0)
    }
    case "boolean": {
      return $f_jl_Boolean__compareTo__O__I(instance, x0)
    }
    default: {
      if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__compareTo__O__I(instance, x0)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__compareTo__O__I($uC(instance), x0)
      } else {
        return instance.compareTo__O__I(x0)
      }
    }
  }
}
function $dp_compareTo__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareTo__T__I(instance, x0)
  } else {
    return instance.compareTo__T__I(x0)
  }
}
function $dp_endsWith__T__Z(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__endsWith__T__Z(instance, x0)
  } else {
    return instance.endsWith__T__Z(x0)
  }
}
function $dp_equals__O__Z(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__equals__O__Z(instance, x0)
    }
    case "number": {
      return $f_jl_Double__equals__O__Z(instance, x0)
    }
    case "boolean": {
      return $f_jl_Boolean__equals__O__Z(instance, x0)
    }
    case "undefined": {
      return $f_jl_Void__equals__O__Z(instance, x0)
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.equals__O__Z(x0)
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__equals__O__Z(instance, x0)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__equals__O__Z($uC(instance), x0)
      } else {
        return $c_O.prototype.equals__O__Z.call(instance, x0)
      }
    }
  }
}
function $dp_getChars__I__I__AC__I__V(instance, x0, x1, x2, x3) {
  if (((typeof instance) === "string")) {
    return $f_T__getChars__I__I__AC__I__V(instance, x0, x1, x2, x3)
  } else {
    return instance.getChars__I__I__AC__I__V(x0, x1, x2, x3)
  }
}
function $dp_hashCode__I(instance) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__hashCode__I(instance)
    }
    case "number": {
      return $f_jl_Double__hashCode__I(instance)
    }
    case "boolean": {
      return $f_jl_Boolean__hashCode__I(instance)
    }
    case "undefined": {
      return $f_jl_Void__hashCode__I(instance)
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.hashCode__I()
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__hashCode__I(instance)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__hashCode__I($uC(instance))
      } else {
        return $c_O.prototype.hashCode__I.call(instance)
      }
    }
  }
}
function $dp_indexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I(instance, x0)
  } else {
    return instance.indexOf__I__I(x0)
  }
}
function $dp_indexOf__I__I__I(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I__I(instance, x0, x1)
  } else {
    return instance.indexOf__I__I__I(x0, x1)
  }
}
function $dp_lastIndexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__lastIndexOf__I__I(instance, x0)
  } else {
    return instance.lastIndexOf__I__I(x0)
  }
}
function $dp_length__I(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__length__I(instance)
  } else {
    return instance.length__I()
  }
}
function $dp_repeat__I__T(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__repeat__I__T(instance, x0)
  } else {
    return instance.repeat__I__T(x0)
  }
}
function $dp_replaceAll__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceAll__T__T__T(instance, x0, x1)
  } else {
    return instance.replaceAll__T__T__T(x0, x1)
  }
}
function $dp_replaceFirst__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceFirst__T__T__T(instance, x0, x1)
  } else {
    return instance.replaceFirst__T__T__T(x0, x1)
  }
}
function $dp_split__T__I__AT(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__split__T__I__AT(instance, x0, x1)
  } else {
    return instance.split__T__I__AT(x0, x1)
  }
}
function $dp_subSequence__I__I__jl_CharSequence(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__subSequence__I__I__jl_CharSequence(instance, x0, x1)
  } else {
    return instance.subSequence__I__I__jl_CharSequence(x0, x1)
  }
}
function $dp_toCharArray__AC(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__toCharArray__AC(instance)
  } else {
    return instance.toCharArray__AC()
  }
}
function $dp_toString__T(instance) {
  return ((instance === (void 0)) ? "undefined" : instance.toString())
}
function $dp_trim__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__trim__T(instance)
  } else {
    return instance.trim__T()
  }
}
function $intDiv(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  } else {
    return ((arg0 / arg1) | 0)
  }
}
function $intMod(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  } else {
    return ((arg0 % arg1) | 0)
  }
}
function $doubleToInt(arg0) {
  return ((arg0 > 2147483647) ? 2147483647 : ((arg0 < (-2147483648)) ? (-2147483648) : (arg0 | 0)))
}
function $charAt(arg0, arg1) {
  var r = arg0.charCodeAt(arg1);
  if ((r !== r)) {
    throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), arg1))
  } else {
    return r
  }
}
function $resolveSuperRef(arg0, arg1) {
  var getPrototypeOf = Object.getPrototyeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var superProto = arg0.prototype;
  while ((superProto !== null)) {
    var desc = getOwnPropertyDescriptor(superProto, arg1);
    if ((desc !== (void 0))) {
      return desc
    };
    superProto = getPrototypeOf(superProto)
  }
}
function $superGet(arg0, arg1, arg2) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var getter = desc.get;
    return ((getter !== (void 0)) ? getter.call(arg1) : getter.value)
  }
}
function $superSet(arg0, arg1, arg2, arg3) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var setter = desc.set;
    if ((setter !== (void 0))) {
      setter.call(arg1, arg3);
      return (void 0)
    }
  };
  throw new TypeError((("super has no setter '" + arg2) + "'."))
}
function $moduleDefault(arg0) {
  return (((arg0 && ((typeof arg0) === "object")) && ("default" in arg0)) ? arg0["default"] : arg0)
}
function $arraycopyCheckBounds(arg0, arg1, arg2, arg3, arg4) {
  if ((((((arg1 < 0) || (arg3 < 0)) || (arg4 < 0)) || (arg1 > ((arg0 - arg4) | 0))) || (arg3 > ((arg2 - arg4) | 0)))) {
    $throwArrayIndexOutOfBoundsException(null)
  }
}
function $arraycopyGeneric(arg0, arg1, arg2, arg3, arg4) {
  $arraycopyCheckBounds(arg0.length, arg1, arg2.length, arg3, arg4);
  if ((((arg0 !== arg2) || (arg3 < arg1)) || (((arg1 + arg4) | 0) < arg3))) {
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)]
    }
  } else {
    for (var i = ((arg4 - 1) | 0); (i >= 0); i = ((i - 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)]
    }
  }
}
function $systemArraycopy(arg0, arg1, arg2, arg3, arg4) {
  arg0.copyTo(arg1, arg2, arg3, arg4)
}
function $systemArraycopyRefs(arg0, arg1, arg2, arg3, arg4) {
  if (arg2.$classData.isAssignableFrom(arg0.$classData)) {
    $arraycopyGeneric(arg0.u, arg1, arg2.u, arg3, arg4)
  } else {
    var srcArray = arg0.u;
    $arraycopyCheckBounds(srcArray.length, arg1, arg2.u.length, arg3, arg4);
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2.set(((arg3 + i) | 0), srcArray[((arg1 + i) | 0)])
    }
  }
}
function $systemArraycopyFull(arg0, arg1, arg2, arg3, arg4) {
  var srcData = (arg0 && arg0.$classData);
  if ((srcData === (arg2 && arg2.$classData))) {
    if ((srcData && srcData.isArrayClass)) {
      $systemArraycopy(arg0, arg1, arg2, arg3, arg4)
    } else {
      $throwArrayStoreException(null)
    }
  } else if (((arg0 instanceof $ac_O) && (arg2 instanceof $ac_O))) {
    $systemArraycopyRefs(arg0, arg1, arg2, arg3, arg4)
  } else {
    $throwArrayStoreException(null)
  }
}
var $lastIDHash = 0;
var $idHashCodeMap = new WeakMap();
function $systemIdentityHashCode(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj)
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj)
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj)
      };
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32))
      };
      return biHash
    }
    case "boolean": {
      return (obj ? 1231 : 1237)
    }
    case "undefined": {
      return 0
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description))
    }
    default: {
      if ((obj === null)) {
        return 0
      } else {
        var hash = $idHashCodeMap.get(obj);
        if ((hash === (void 0))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          $idHashCodeMap.set(obj, hash)
        };
        return hash
      }
    }
  }
}
function $isByte(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 24) >> 24) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isShort(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 16) >> 16) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isInt(arg0) {
  return ((((typeof arg0) === "number") && ((arg0 | 0) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isFloat(arg0) {
  return (((typeof arg0) === "number") && ((arg0 !== arg0) || (Math.fround(arg0) === arg0)))
}
function $bC(arg0) {
  return new $Char(arg0)
}
var $bC0 = $bC(0);
function $uV(arg0) {
  return (((arg0 === (void 0)) || (arg0 === null)) ? (void 0) : $throwClassCastException(arg0, "java.lang.Void"))
}
function $uZ(arg0) {
  return ((((typeof arg0) === "boolean") || (arg0 === null)) ? (!(!arg0)) : $throwClassCastException(arg0, "java.lang.Boolean"))
}
function $uC(arg0) {
  return (((arg0 instanceof $Char) || (arg0 === null)) ? ((arg0 === null) ? 0 : arg0.c) : $throwClassCastException(arg0, "java.lang.Character"))
}
function $uB(arg0) {
  return (($isByte(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Byte"))
}
function $uS(arg0) {
  return (($isShort(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Short"))
}
function $uI(arg0) {
  return (($isInt(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Integer"))
}
function $uJ(arg0) {
  return (((arg0 instanceof $c_RTLong) || (arg0 === null)) ? ((arg0 === null) ? $L0 : arg0) : $throwClassCastException(arg0, "java.lang.Long"))
}
function $uF(arg0) {
  return (($isFloat(arg0) || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Float"))
}
function $uD(arg0) {
  return ((((typeof arg0) === "number") || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Double"))
}
function $uT(arg0) {
  return ((((typeof arg0) === "string") || (arg0 === null)) ? ((arg0 === null) ? "" : arg0) : $throwClassCastException(arg0, "java.lang.String"))
}
function $ct_O__($thiz) {
  return $thiz
}
/** @constructor */
function $c_O() {
  /*<skip>*/
}
$c_O.prototype.constructor = $c_O;
/** @constructor */
function $h_O() {
  /*<skip>*/
}
$h_O.prototype = $c_O.prototype;
$c_O.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this)
});
$c_O.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_O.prototype.toString__T = (function() {
  var i = this.hashCode__I();
  return (($objectClassName(this) + "@") + $as_T($uD((i >>> 0.0)).toString(16)))
});
$c_O.prototype.toString = (function() {
  return this.toString__T()
});
function $ac_O(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException()
    };
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = null
    }
  } else {
    this.u = arg
  }
}
$ac_O.prototype = new $h_O();
$ac_O.prototype.constructor = $ac_O;
$ac_O.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_O.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_O.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
});
$ac_O.prototype.clone__O = (function() {
  return new $ac_O(this.u.slice())
});
function $ah_O() {
  /*<skip>*/
}
$ah_O.prototype = $ac_O.prototype;
function $ac_Z(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException()
    };
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = false
    }
  } else {
    this.u = arg
  }
}
$ac_Z.prototype = new $h_O();
$ac_Z.prototype.constructor = $ac_Z;
$ac_Z.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_Z.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_Z.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
});
$ac_Z.prototype.clone__O = (function() {
  return new $ac_Z(this.u.slice())
});
function $ac_C(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException()
    };
    this.u = new Uint16Array(arg)
  } else {
    this.u = arg
  }
}
$ac_C.prototype = new $h_O();
$ac_C.prototype.constructor = $ac_C;
$ac_C.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_C.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_C.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_C.prototype.clone__O = (function() {
  return new $ac_C(this.u.slice())
});
function $ac_B(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException()
    };
    this.u = new Int8Array(arg)
  } else {
    this.u = arg
  }
}
$ac_B.prototype = new $h_O();
$ac_B.prototype.constructor = $ac_B;
$ac_B.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_B.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_B.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_B.prototype.clone__O = (function() {
  return new $ac_B(this.u.slice())
});
function $ac_S(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException()
    };
    this.u = new Int16Array(arg)
  } else {
    this.u = arg
  }
}
$ac_S.prototype = new $h_O();
$ac_S.prototype.constructor = $ac_S;
$ac_S.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_S.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_S.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_S.prototype.clone__O = (function() {
  return new $ac_S(this.u.slice())
});
function $ac_I(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException()
    };
    this.u = new Int32Array(arg)
  } else {
    this.u = arg
  }
}
$ac_I.prototype = new $h_O();
$ac_I.prototype.constructor = $ac_I;
$ac_I.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_I.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_I.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_I.prototype.clone__O = (function() {
  return new $ac_I(this.u.slice())
});
function $ac_J(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException()
    };
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = $L0
    }
  } else {
    this.u = arg
  }
}
$ac_J.prototype = new $h_O();
$ac_J.prototype.constructor = $ac_J;
$ac_J.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_J.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_J.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
});
$ac_J.prototype.clone__O = (function() {
  return new $ac_J(this.u.slice())
});
function $ac_F(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException()
    };
    this.u = new Float32Array(arg)
  } else {
    this.u = arg
  }
}
$ac_F.prototype = new $h_O();
$ac_F.prototype.constructor = $ac_F;
$ac_F.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_F.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_F.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_F.prototype.clone__O = (function() {
  return new $ac_F(this.u.slice())
});
function $ac_D(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException()
    };
    this.u = new Float64Array(arg)
  } else {
    this.u = arg
  }
}
$ac_D.prototype = new $h_O();
$ac_D.prototype.constructor = $ac_D;
$ac_D.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_D.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_D.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_D.prototype.clone__O = (function() {
  return new $ac_D(this.u.slice())
});
function $TypeData() {
  this.constr = (void 0);
  this.ancestors = null;
  this.componentData = null;
  this.arrayBase = null;
  this.arrayDepth = 0;
  this.zero = null;
  this.arrayEncodedName = "";
  this._classOf = (void 0);
  this._arrayOf = (void 0);
  this.isAssignableFromFun = (void 0);
  this.wrapArray = (void 0);
  this.isJSType = false;
  this.name = "";
  this.isPrimitive = false;
  this.isInterface = false;
  this.isArrayClass = false;
  this.isInstance = (void 0)
}
$TypeData.prototype.initPrim = (function(zero, arrayEncodedName, displayName, arrayClass, typedArrayClass) {
  this.ancestors = {};
  this.zero = zero;
  this.arrayEncodedName = arrayEncodedName;
  var self = this;
  this.isAssignableFromFun = ((that) => (that === self));
  this.name = displayName;
  this.isPrimitive = true;
  this.isInstance = ((obj) => false);
  if ((arrayClass !== (void 0))) {
    this._arrayOf = new $TypeData().initSpecializedArray(this, arrayClass, typedArrayClass)
  };
  return this
});
$TypeData.prototype.initClass = (function(internalNameObj, isInterface, fullName, ancestors, isJSType, parentData, isInstance) {
  var internalName = $propertyName(internalNameObj);
  this.ancestors = ancestors;
  this.arrayEncodedName = (("L" + fullName) + ";");
  this.isAssignableFromFun = ((that) => (!(!that.ancestors[internalName])));
  this.isJSType = (!(!isJSType));
  this.name = fullName;
  this.isInterface = isInterface;
  this.isInstance = (isInstance || ((obj) => (!(!((obj && obj.$classData) && obj.$classData.ancestors[internalName])))));
  return this
});
$TypeData.prototype.initSpecializedArray = (function(componentData, arrayClass, typedArrayClass, isAssignableFromFun) {
  arrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = arrayClass;
  this.ancestors = {
    O: 1,
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  };
  this.componentData = componentData;
  this.arrayBase = componentData;
  this.arrayDepth = 1;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var self = this;
  this.isAssignableFromFun = (isAssignableFromFun || ((that) => (self === that)));
  this.wrapArray = (typedArrayClass ? ((array) => new arrayClass(new typedArrayClass(array))) : ((array) => new arrayClass(array)));
  this.isInstance = ((obj) => (obj instanceof arrayClass));
  return this
});
$TypeData.prototype.initArray = (function(componentData) {
  function ArrayClass(arg) {
    if (((typeof arg) === "number")) {
      if ((arg < 0)) {
        $throwNegativeArraySizeException()
      };
      this.u = new Array(arg);
      for (var i = 0; (i < arg); (i++)) {
        this.u[i] = null
      }
    } else {
      this.u = arg
    }
  }
  ArrayClass.prototype = new $ah_O();
  ArrayClass.prototype.constructor = ArrayClass;
  ArrayClass.prototype.set = (function(i, v) {
    if (((i < 0) || (i >= this.u.length))) {
      $throwArrayIndexOutOfBoundsException(i)
    };
    if ((((v !== null) && (!componentData.isJSType)) && (!componentData.isInstance(v)))) {
      $throwArrayStoreException(v)
    };
    this.u[i] = v
  });
  ArrayClass.prototype.copyTo = (function(srcPos, dest, destPos, length) {
    $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
  });
  ArrayClass.prototype.clone__O = (function() {
    return new ArrayClass(this.u.slice())
  });
  var arrayBase = (componentData.arrayBase || componentData);
  var arrayDepth = (componentData.arrayDepth + 1);
  ArrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = ArrayClass;
  this.ancestors = {
    O: 1,
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  };
  this.componentData = componentData;
  this.arrayBase = arrayBase;
  this.arrayDepth = arrayDepth;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var isAssignableFromFun = ((that) => {
    var thatDepth = that.arrayDepth;
    return ((thatDepth === arrayDepth) ? arrayBase.isAssignableFromFun(that.arrayBase) : ((thatDepth > arrayDepth) && (arrayBase === $d_O)))
  });
  this.isAssignableFromFun = isAssignableFromFun;
  this.wrapArray = ((array) => new ArrayClass(array));
  var self = this;
  this.isInstance = ((obj) => {
    var data = (obj && obj.$classData);
    return ((!(!data)) && ((data === self) || isAssignableFromFun(data)))
  });
  return this
});
$TypeData.prototype.getArrayOf = (function() {
  if ((!this._arrayOf)) {
    this._arrayOf = new $TypeData().initArray(this)
  };
  return this._arrayOf
});
$TypeData.prototype.getClassOf = (function() {
  if ((!this._classOf)) {
    this._classOf = new $c_jl_Class(this)
  };
  return this._classOf
});
$TypeData.prototype.isAssignableFrom = (function(that) {
  return ((this === that) || this.isAssignableFromFun(that))
});
$TypeData.prototype.checkCast = (function(obj) {
  if ((((obj !== null) && (!this.isJSType)) && (!this.isInstance(obj)))) {
    $throwClassCastException(obj, this.name)
  }
});
$TypeData.prototype.getSuperclass = (function() {
  return (this.parentData ? this.parentData.getClassOf() : null)
});
$TypeData.prototype.getComponentType = (function() {
  return (this.componentData ? this.componentData.getClassOf() : null)
});
$TypeData.prototype.newArrayOfThisClass = (function(lengths) {
  var arrayClassData = this;
  for (var i = 0; (i < lengths.length); (i++)) {
    arrayClassData = arrayClassData.getArrayOf()
  };
  return $newArrayObject(arrayClassData, lengths)
});
function $isArrayOf_O(obj, depth) {
  var data = (obj && obj.$classData);
  if ((!data)) {
    return false
  } else {
    var arrayDepth = data.arrayDepth;
    return ((arrayDepth === depth) ? (!data.arrayBase.isPrimitive) : (arrayDepth > depth))
  }
}
function $isArrayOf_Z(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_Z))))
}
function $isArrayOf_C(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_C))))
}
function $isArrayOf_B(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_B))))
}
function $isArrayOf_S(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_S))))
}
function $isArrayOf_I(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_I))))
}
function $isArrayOf_J(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_J))))
}
function $isArrayOf_F(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_F))))
}
function $isArrayOf_D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_D))))
}
function $asArrayOf_O(obj, depth) {
  if (($isArrayOf_O(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "Ljava.lang.Object;", depth)
  }
}
function $asArrayOf_Z(obj, depth) {
  if (($isArrayOf_Z(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "Z", depth)
  }
}
function $asArrayOf_C(obj, depth) {
  if (($isArrayOf_C(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "C", depth)
  }
}
function $asArrayOf_B(obj, depth) {
  if (($isArrayOf_B(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "B", depth)
  }
}
function $asArrayOf_S(obj, depth) {
  if (($isArrayOf_S(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "S", depth)
  }
}
function $asArrayOf_I(obj, depth) {
  if (($isArrayOf_I(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "I", depth)
  }
}
function $asArrayOf_J(obj, depth) {
  if (($isArrayOf_J(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "J", depth)
  }
}
function $asArrayOf_F(obj, depth) {
  if (($isArrayOf_F(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "F", depth)
  }
}
function $asArrayOf_D(obj, depth) {
  if (($isArrayOf_D(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "D", depth)
  }
}
var $d_O = new $TypeData();
$d_O.ancestors = {
  O: 1
};
$d_O.arrayEncodedName = "Ljava.lang.Object;";
$d_O.isAssignableFromFun = ((that) => (!that.isPrimitive));
$d_O.name = "java.lang.Object";
$d_O.isInstance = ((obj) => (obj !== null));
$d_O._arrayOf = new $TypeData().initSpecializedArray($d_O, $ac_O, (void 0), ((that) => {
  var thatDepth = that.arrayDepth;
  return ((thatDepth === 1) ? (!that.arrayBase.isPrimitive) : (thatDepth > 1))
}));
$c_O.prototype.$classData = $d_O;
var $d_V = new $TypeData().initPrim((void 0), "V", "void", (void 0), (void 0));
var $d_Z = new $TypeData().initPrim(false, "Z", "boolean", $ac_Z, (void 0));
var $d_C = new $TypeData().initPrim(0, "C", "char", $ac_C, Uint16Array);
var $d_B = new $TypeData().initPrim(0, "B", "byte", $ac_B, Int8Array);
var $d_S = new $TypeData().initPrim(0, "S", "short", $ac_S, Int16Array);
var $d_I = new $TypeData().initPrim(0, "I", "int", $ac_I, Int32Array);
var $d_J = new $TypeData().initPrim(null, "J", "long", $ac_J, (void 0));
var $d_F = new $TypeData().initPrim(0.0, "F", "float", $ac_F, Float32Array);
var $d_D = new $TypeData().initPrim(0.0, "D", "double", $ac_D, Float64Array);
/** @constructor */
function $c_Lcats_EvalInstances1() {
  /*<skip>*/
}
$c_Lcats_EvalInstances1.prototype = new $h_O();
$c_Lcats_EvalInstances1.prototype.constructor = $c_Lcats_EvalInstances1;
/** @constructor */
function $h_Lcats_EvalInstances1() {
  /*<skip>*/
}
$h_Lcats_EvalInstances1.prototype = $c_Lcats_EvalInstances1.prototype;
function $f_Lcats_SemigroupalArityFunctions__imap2__O__O__F2__F1__Lcats_Semigroupal__Lcats_Invariant__O($thiz, f0, f1, f, g, semigroupal, invariant) {
  return $n(invariant).imap__O__F1__F1__O($n(semigroupal).product__O__O__O(f0, f1), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var a0 = $n(x0$1)._1__O();
      var a1 = $n(x0$1)._2__O();
      return $n(f).apply__O__O__O(a0, a1)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })), new $c_sjsr_AnonFunction1(((z$2) => {
    var x1 = $as_T2($n(g).apply__O__O(z$2));
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var a0$1 = $n(x1)._1__O();
    var a1$1 = $n(x1)._2__O();
    return $ct_T2__O__O__(new $c_T2(), a0$1, a1$1)
  })))
}
function $f_Lcats_SemigroupalArityFunctions__tuple2__O__O__Lcats_Semigroupal__Lcats_Invariant__O($thiz, f0, f1, semigroupal, invariant) {
  var f = new $c_sjsr_AnonFunction2(((x$3$2, x$4$2) => $ct_T2__O__O__(new $c_T2(), x$3$2, x$4$2)));
  var g = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T2(x$2);
    return x
  }));
  return $f_Lcats_SemigroupalArityFunctions__imap2__O__O__F2__F1__Lcats_Semigroupal__Lcats_Invariant__O($thiz, f0, f1, f, g, semigroupal, invariant)
}
/** @constructor */
function $c_Lcats_data_AndThenInstances1() {
  /*<skip>*/
}
$c_Lcats_data_AndThenInstances1.prototype = new $h_O();
$c_Lcats_data_AndThenInstances1.prototype.constructor = $c_Lcats_data_AndThenInstances1;
/** @constructor */
function $h_Lcats_data_AndThenInstances1() {
  /*<skip>*/
}
$h_Lcats_data_AndThenInstances1.prototype = $c_Lcats_data_AndThenInstances1.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances1() {
  /*<skip>*/
}
$c_Lcats_data_NonEmptyListInstances1.prototype = new $h_O();
$c_Lcats_data_NonEmptyListInstances1.prototype.constructor = $c_Lcats_data_NonEmptyListInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances1() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances1.prototype = $c_Lcats_data_NonEmptyListInstances1.prototype;
function $f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated($thiz, e) {
  return new $c_Lcats_data_Validated$Invalid(new $c_Lcats_data_NonEmptyList(e, $m_sci_Nil$()))
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances2() {
  /*<skip>*/
}
$c_Lcats_data_ValidatedInstances2.prototype = new $h_O();
$c_Lcats_data_ValidatedInstances2.prototype.constructor = $c_Lcats_data_ValidatedInstances2;
/** @constructor */
function $h_Lcats_data_ValidatedInstances2() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances2.prototype = $c_Lcats_data_ValidatedInstances2.prototype;
function $f_Lcats_instances_EquivInstances__$init$__V($thiz) {
  $thiz.cats$instances$EquivInstances$_setter_$catsContravariantMonoidalForEquiv_$eq__Lcats_ContravariantMonoidal__V(new $c_Lcats_instances_EquivInstances$$anon$1($thiz))
}
function $f_Lcats_instances_FunctionInstancesBinCompat0__$init$__V($thiz) {
  $thiz.cats$instances$FunctionInstancesBinCompat0$_setter_$catsSddDeferForFunction0_$eq__Lcats_Defer__V(new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$2($thiz))
}
function $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$4($thiz));
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$7($thiz))
}
function $f_Lcats_instances_ListInstancesBinCompat0__$init$__V($thiz) {
  $thiz.cats$instances$ListInstancesBinCompat0$_setter_$catsStdTraverseFilterForList_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_ListInstancesBinCompat0$$anon$6($thiz))
}
function $f_Lcats_instances_MapInstancesBinCompat0__$init$__V($thiz) {
  $thiz.cats$instances$MapInstancesBinCompat0$_setter_$catsStdComposeForMap_$eq__Lcats_arrow_Compose__V(new $c_Lcats_instances_MapInstancesBinCompat0$$anon$3($thiz))
}
function $f_Lcats_instances_OptionInstancesBinCompat0__$init$__V($thiz) {
  $thiz.cats$instances$OptionInstancesBinCompat0$_setter_$catsStdTraverseFilterForOption_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3($thiz))
}
function $f_Lcats_instances_OrderingInstances__$init$__V($thiz) {
  $thiz.cats$instances$OrderingInstances$_setter_$catsContravariantMonoidalForOrdering_$eq__Lcats_ContravariantMonoidal__V(new $c_Lcats_instances_OrderingInstances$$anon$1($thiz))
}
function $f_Lcats_instances_PartialOrderingInstances__$init$__V($thiz) {
  $thiz.cats$instances$PartialOrderingInstances$_setter_$catsContravariantMonoidalForPartialOrdering_$eq__Lcats_ContravariantMonoidal__V(new $c_Lcats_instances_PartialOrderingInstances$$anon$1($thiz))
}
function $f_Lcats_instances_SortedSetInstancesBinCompat0__$init$__V($thiz) {
  $thiz.cats$instances$SortedSetInstancesBinCompat0$_setter_$catsStdSemigroupalForSortedSet_$eq__Lcats_Semigroupal__V(new $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3($thiz))
}
function $f_Lcats_instances_StreamInstancesBinCompat0__$init$__V($thiz) {
  $thiz.cats$instances$StreamInstancesBinCompat0$_setter_$catsStdTraverseFilterForStream_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7($thiz))
}
function $f_Lcats_instances_Tuple2InstancesBinCompat0__$init$__V($thiz) {
  $thiz.cats$instances$Tuple2InstancesBinCompat0$_setter_$catsDataFunctorForPair_$eq__Lcats_Functor__V(new $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2($thiz))
}
function $f_Lcats_instances_VectorInstancesBinCompat0__$init$__V($thiz) {
  $thiz.cats$instances$VectorInstancesBinCompat0$_setter_$catsStdTraverseFilterForVector_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6($thiz))
}
/** @constructor */
function $c_Lcats_kernel_EqFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_EqFunctions.prototype = new $h_O();
$c_Lcats_kernel_EqFunctions.prototype.constructor = $c_Lcats_kernel_EqFunctions;
/** @constructor */
function $h_Lcats_kernel_EqFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_EqFunctions.prototype = $c_Lcats_kernel_EqFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_SemigroupFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_SemigroupFunctions.prototype = new $h_O();
$c_Lcats_kernel_SemigroupFunctions.prototype.constructor = $c_Lcats_kernel_SemigroupFunctions;
/** @constructor */
function $h_Lcats_kernel_SemigroupFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_SemigroupFunctions.prototype = $c_Lcats_kernel_SemigroupFunctions.prototype;
function $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_BigDecimalOrder());
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigDecimalGroup())
}
function $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_BigIntOrder());
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigIntGroup())
}
function $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_PartialOrder__V(new $c_Lcats_kernel_instances_BitSetPartialOrder());
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_BitSetSemilattice())
}
function $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_ByteOrder());
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ByteGroup())
}
function $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_DoubleOrder());
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DoubleGroup())
}
function $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_DurationOrder());
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DurationGroup())
}
function $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_FiniteDurationOrder());
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FiniteDurationGroup())
}
function $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_FloatOrder());
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FloatGroup())
}
function $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_IntOrder());
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_IntGroup())
}
function $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_LongOrder());
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_LongGroup())
}
function $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_ShortOrder());
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ShortGroup())
}
function $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_StringOrder());
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V(new $c_Lcats_kernel_instances_StringMonoid())
}
function $f_Lcats_kernel_instances_UUIDInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$UUIDInstances$_setter_$catsKernelStdOrderForUUID_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_UUIDInstances$$anon$1($thiz))
}
function $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_Order__V(new $c_Lcats_kernel_instances_UnitOrder());
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_UnitAlgebra())
}
/** @constructor */
function $c_Lcats_package$() {
  this.Lcats_package$__f_catsInstancesForId = null;
  this.Lcats_package$__f_Eq = null;
  this.Lcats_package$__f_PartialOrder = null;
  this.Lcats_package$__f_Order = null;
  this.Lcats_package$__f_Hash = null;
  this.Lcats_package$__f_Semigroup = null;
  $n_Lcats_package$ = this;
  this.Lcats_package$__f_catsInstancesForId = new $c_Lcats_package$$anon$1();
  new $c_Lcats_package$$anon$2();
  var evidence$32 = this.Lcats_package$__f_catsInstancesForId;
  new $c_Lcats_Parallel$$anon$2(evidence$32);
  this.Lcats_package$__f_Eq = $m_Lcats_kernel_Eq$();
  this.Lcats_package$__f_PartialOrder = $m_Lcats_kernel_PartialOrder$();
  this.Lcats_package$__f_Order = $m_Lcats_kernel_Order$();
  $m_Lcats_kernel_Comparison$();
  this.Lcats_package$__f_Hash = $m_Lcats_kernel_Hash$();
  this.Lcats_package$__f_Semigroup = $m_Lcats_kernel_Semigroup$()
}
$c_Lcats_package$.prototype = new $h_O();
$c_Lcats_package$.prototype.constructor = $c_Lcats_package$;
/** @constructor */
function $h_Lcats_package$() {
  /*<skip>*/
}
$h_Lcats_package$.prototype = $c_Lcats_package$.prototype;
var $d_Lcats_package$ = new $TypeData().initClass({
  Lcats_package$: 0
}, false, "cats.package$", {
  Lcats_package$: 1,
  O: 1
});
$c_Lcats_package$.prototype.$classData = $d_Lcats_package$;
var $n_Lcats_package$;
function $m_Lcats_package$() {
  if ((!$n_Lcats_package$)) {
    $n_Lcats_package$ = new $c_Lcats_package$()
  };
  return $n_Lcats_package$
}
/** @constructor */
function $c_Lcom_iz2use_common_Filter$() {
  this.Lcom_iz2use_common_Filter$__f_defaultSeparators = null;
  this.Lcom_iz2use_common_Filter$__f_defaultFilter = null;
  $n_Lcom_iz2use_common_Filter$ = this;
  this.Lcom_iz2use_common_Filter$__f_defaultSeparators = " \t\r\n!\"#$%&'()*+,-./:;<=>?@[\\]^_{|}~\u00b0";
  this.Lcom_iz2use_common_Filter$__f_defaultFilter = new $c_Lcom_iz2use_common_Filter$DefaultFilter(this.Lcom_iz2use_common_Filter$__f_defaultSeparators)
}
$c_Lcom_iz2use_common_Filter$.prototype = new $h_O();
$c_Lcom_iz2use_common_Filter$.prototype.constructor = $c_Lcom_iz2use_common_Filter$;
/** @constructor */
function $h_Lcom_iz2use_common_Filter$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Filter$.prototype = $c_Lcom_iz2use_common_Filter$.prototype;
var $d_Lcom_iz2use_common_Filter$ = new $TypeData().initClass({
  Lcom_iz2use_common_Filter$: 0
}, false, "com.iz2use.common.Filter$", {
  Lcom_iz2use_common_Filter$: 1,
  O: 1
});
$c_Lcom_iz2use_common_Filter$.prototype.$classData = $d_Lcom_iz2use_common_Filter$;
var $n_Lcom_iz2use_common_Filter$;
function $m_Lcom_iz2use_common_Filter$() {
  if ((!$n_Lcom_iz2use_common_Filter$)) {
    $n_Lcom_iz2use_common_Filter$ = new $c_Lcom_iz2use_common_Filter$()
  };
  return $n_Lcom_iz2use_common_Filter$
}
/** @constructor */
function $c_Lcom_iz2use_common_Key$() {
  /*<skip>*/
}
$c_Lcom_iz2use_common_Key$.prototype = new $h_O();
$c_Lcom_iz2use_common_Key$.prototype.constructor = $c_Lcom_iz2use_common_Key$;
/** @constructor */
function $h_Lcom_iz2use_common_Key$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Key$.prototype = $c_Lcom_iz2use_common_Key$.prototype;
$c_Lcom_iz2use_common_Key$.prototype.from__F1__F1 = (function(f) {
  return new $c_sjsr_AnonFunction1(((in$2) => {
    var key = $as_T($n(f).apply__O__O(in$2));
    return key
  }))
});
var $d_Lcom_iz2use_common_Key$ = new $TypeData().initClass({
  Lcom_iz2use_common_Key$: 0
}, false, "com.iz2use.common.Key$", {
  Lcom_iz2use_common_Key$: 1,
  O: 1
});
$c_Lcom_iz2use_common_Key$.prototype.$classData = $d_Lcom_iz2use_common_Key$;
var $n_Lcom_iz2use_common_Key$;
function $m_Lcom_iz2use_common_Key$() {
  if ((!$n_Lcom_iz2use_common_Key$)) {
    $n_Lcom_iz2use_common_Key$ = new $c_Lcom_iz2use_common_Key$()
  };
  return $n_Lcom_iz2use_common_Key$
}
/** @constructor */
function $c_Lcom_iz2use_common_KeyImports$RichKey(outer, key) {
  this.Lcom_iz2use_common_KeyImports$RichKey__f_key = null;
  this.Lcom_iz2use_common_KeyImports$RichKey__f_key = key;
  if ((outer === null)) {
    $n(null)
  }
}
$c_Lcom_iz2use_common_KeyImports$RichKey.prototype = new $h_O();
$c_Lcom_iz2use_common_KeyImports$RichKey.prototype.constructor = $c_Lcom_iz2use_common_KeyImports$RichKey;
/** @constructor */
function $h_Lcom_iz2use_common_KeyImports$RichKey() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_KeyImports$RichKey.prototype = $c_Lcom_iz2use_common_KeyImports$RichKey.prototype;
var $d_Lcom_iz2use_common_KeyImports$RichKey = new $TypeData().initClass({
  Lcom_iz2use_common_KeyImports$RichKey: 0
}, false, "com.iz2use.common.KeyImports$RichKey", {
  Lcom_iz2use_common_KeyImports$RichKey: 1,
  O: 1
});
$c_Lcom_iz2use_common_KeyImports$RichKey.prototype.$classData = $d_Lcom_iz2use_common_KeyImports$RichKey;
/** @constructor */
function $c_Lcom_iz2use_common_KeyMapper$() {
  this.Lcom_iz2use_common_KeyMapper$__f_fromString = null;
  this.Lcom_iz2use_common_KeyMapper$__f_fromUUID = null;
  this.Lcom_iz2use_common_KeyMapper$__f_fromInt = null;
  $n_Lcom_iz2use_common_KeyMapper$ = this;
  this.Lcom_iz2use_common_KeyMapper$__f_fromString = new $c_Lcom_iz2use_common_KeyMapper$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_ju_UUID(x$1$2);
    return $n(x$1).toString__T()
  }));
  var ev = this.Lcom_iz2use_common_KeyMapper$__f_fromString;
  this.Lcom_iz2use_common_KeyMapper$__f_fromUUID = new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f);
  var f$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $uI(x$2$2);
    return ("" + x$2)
  }));
  var ev$1 = this.Lcom_iz2use_common_KeyMapper$__f_fromString;
  this.Lcom_iz2use_common_KeyMapper$__f_fromInt = new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev$1, f$1)
}
$c_Lcom_iz2use_common_KeyMapper$.prototype = new $h_O();
$c_Lcom_iz2use_common_KeyMapper$.prototype.constructor = $c_Lcom_iz2use_common_KeyMapper$;
/** @constructor */
function $h_Lcom_iz2use_common_KeyMapper$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_KeyMapper$.prototype = $c_Lcom_iz2use_common_KeyMapper$.prototype;
var $d_Lcom_iz2use_common_KeyMapper$ = new $TypeData().initClass({
  Lcom_iz2use_common_KeyMapper$: 0
}, false, "com.iz2use.common.KeyMapper$", {
  Lcom_iz2use_common_KeyMapper$: 1,
  O: 1
});
$c_Lcom_iz2use_common_KeyMapper$.prototype.$classData = $d_Lcom_iz2use_common_KeyMapper$;
var $n_Lcom_iz2use_common_KeyMapper$;
function $m_Lcom_iz2use_common_KeyMapper$() {
  if ((!$n_Lcom_iz2use_common_KeyMapper$)) {
    $n_Lcom_iz2use_common_KeyMapper$ = new $c_Lcom_iz2use_common_KeyMapper$()
  };
  return $n_Lcom_iz2use_common_KeyMapper$
}
/** @constructor */
function $c_Lcom_iz2use_common_MathParser$() {
  this.Lcom_iz2use_common_MathParser$__f_White = null;
  $n_Lcom_iz2use_common_MathParser$ = this;
  this.Lcom_iz2use_common_MathParser$__f_White = new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Lfastparse_ParsingRun(ctx$2);
    var index$macro$2 = $n(ctx).Lfastparse_ParsingRun__f_index;
    var input$macro$3 = $n(ctx).Lfastparse_ParsingRun__f_input;
    var start$macro$4 = index$macro$2;
    while (true) {
      if ($n(input$macro$3).isReachable__I__Z(index$macro$2)) {
        var this$2 = $n(input$macro$3);
        var index = index$macro$2;
        var this$3 = $n(this$2.Lfastparse_IndexedParserInput__f_data);
        var x1$2 = $charAt(this$3, index);
        switch (x1$2) {
          case 32: {
            var $$x1 = true;
            break
          }
          case 9: {
            var $$x1 = true;
            break
          }
          default: {
            var $$x1 = false
          }
        }
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        index$macro$2 = ((1 + index$macro$2) | 0)
      } else {
        break
      }
    };
    var res = ((index$macro$2 >= start$macro$4) ? $n(ctx).freshSuccessUnit__I__Lfastparse_ParsingRun(index$macro$2) : $n(ctx).freshFailure__Lfastparse_ParsingRun());
    if ($n(ctx).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(ctx).aggregateTerminal__I__F0__V(start$macro$4, new $c_sjsr_AnonFunction0((() => "[ \\t]")))
    };
    return res
  }))
}
$c_Lcom_iz2use_common_MathParser$.prototype = new $h_O();
$c_Lcom_iz2use_common_MathParser$.prototype.constructor = $c_Lcom_iz2use_common_MathParser$;
/** @constructor */
function $h_Lcom_iz2use_common_MathParser$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_MathParser$.prototype = $c_Lcom_iz2use_common_MathParser$.prototype;
$c_Lcom_iz2use_common_MathParser$.prototype.digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$1) {
  var startIndex = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$1).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value, startIndex)
  };
  var index$macro$2 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var input$macro$3 = $n(evidence$1).Lfastparse_ParsingRun__f_input;
  var start$macro$4 = index$macro$2;
  var goal$macro$5 = ((1 + start$macro$4) | 0);
  while (true) {
    if ($n(input$macro$3).isReachable__I__Z(index$macro$2)) {
      var this$1 = $n(input$macro$3);
      var index = index$macro$2;
      var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
      var x1$3 = $charAt(this$2, index);
      var $$x1 = ((x1$3 >= 48) && (x1$3 <= 57))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index$macro$2 = ((1 + index$macro$2) | 0)
    } else {
      break
    }
  };
  var res = ((index$macro$2 >= goal$macro$5) ? $n(evidence$1).freshSuccessUnit__I__Lfastparse_ParsingRun(index$macro$2) : $n(evidence$1).freshFailure__Lfastparse_ParsingRun());
  if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$1).aggregateTerminal__I__F0__V(start$macro$4, new $c_sjsr_AnonFunction0((() => "[0-9]")))
  };
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value, $n(res).Lfastparse_ParsingRun__f_index, $n(res).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(res).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(res);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(res).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(res).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(res).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(res);
      var self = new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$10 = $n($n(res).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$10)
    }
  };
  return res
});
$c_Lcom_iz2use_common_MathParser$.prototype.number__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$2) {
  var startIndex = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$2).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("number").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var startPos = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$80 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var input$macro$89 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var startPos$2 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
  $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
  $m_Lfastparse_package$();
  var input = $n(evidence$2).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$2 = $n(input);
    var this$3 = $n(this$2.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$3, index) === 45)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$2).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"-\"")))
  };
  var postSuccess = $n(evidence$2).Lfastparse_ParsingRun__f_isSuccess;
  if (postSuccess) {
    var res$2 = $n(evidence$2).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$2), (void 0)));
    $n(res$2).Lfastparse_ParsingRun__f_cut = (!(!($n(res$2).Lfastparse_ParsingRun__f_cut | startCut)))
  } else if ($n(evidence$2).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var res$3 = $n(evidence$2).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos$2);
    $n(res$3).Lfastparse_ParsingRun__f_cut = (!(!($n(res$3).Lfastparse_ParsingRun__f_cut | startCut)))
  };
  if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
    var msg = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    var agg = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ((!postSuccess)) {
      $n(evidence$2).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$2, new $c_sjsr_AnonFunction0((() => {
        var this$6 = $n(msg);
        return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".?")
      })), agg)
    }
  };
  if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$81 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$84 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$87 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$81 > preLhsIndex$macro$80) && $n(evidence$2).checkForDrop__Z())) {
      $n(input$macro$89)
    };
    $n(evidence$2);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$2);
    if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$82 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
        var oldCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
        $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
        var startPos$3 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$();
        $m_Lfastparse_Implicits$Sequencer$();
        var preLhsIndex$macro$13 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
        var input$macro$22 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
        $m_Lfastparse_package$();
        var input$2 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
        var index$2 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
        if ($n(input$2).isReachable__I__Z(index$2)) {
          var this$9 = $n(input$2);
          var this$10 = $n(this$9.Lfastparse_IndexedParserInput__f_data);
          var $$x2 = ($charAt(this$10, index$2) === 46)
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
        } else {
          $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$2).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\".\"")))
        };
        if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
          /*<skip>*/
        } else {
          var postLhsIndex$macro$14 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
          var lhsAggregate$macro$17 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var lhsMsg$macro$20 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
          $n(evidence$2).Lfastparse_ParsingRun__f_cut = true;
          if (((postLhsIndex$macro$14 > preLhsIndex$macro$13) && $n(evidence$2).checkForDrop__Z())) {
            $n(input$macro$22)
          };
          $n(evidence$2);
          $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$2);
          if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
            if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
              /*<skip>*/
            } else {
              var preRhsIndex$macro$15 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
              var elem = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
              var elem$1 = false;
              elem$1 = elem;
              var startIndex$macro$4 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
              var count$macro$5 = 0;
              var lastAgg$macro$10 = null;
              while (true) {
                $n(evidence$2).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 1));
                $m_Lfastparse_package$();
                $m_Lcom_iz2use_common_MathParser$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$2);
                var parsedMsg$macro$9 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
                var parsedAgg$macro$11 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
                elem$1 = (!(!(elem$1 | $n(evidence$2).Lfastparse_ParsingRun__f_cut)));
                if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
                  var res$1 = ($n(evidence$2).Lfastparse_ParsingRun__f_cut ? evidence$2 : ((count$macro$5 < 1) ? $n(evidence$2).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$2).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$4, elem$1)));
                  if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
                    var $$x6 = $n(evidence$2);
                    var $$x5 = startIndex$macro$4;
                    var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
                      var this$14 = $n(parsedMsg$macro$9);
                      return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$14.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
                    }))(parsedMsg$macro$9));
                    if ((lastAgg$macro$10 === null)) {
                      var $$x3 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate
                    } else {
                      var rassoc$1 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
                      var $$x3 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
                    };
                    $n($$x6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x5, $$x4, $$x3)
                  };
                  break
                } else {
                  var beforeSepIndex$macro$6 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                  $n(evidence$2);
                  $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
                  if ((this.Lcom_iz2use_common_MathParser$__f_White !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
                    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$2)
                  };
                  if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
                    break
                  } else {
                    $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
                    var temp$count$macro$5 = ((1 + count$macro$5) | 0);
                    startIndex$macro$4 = beforeSepIndex$macro$6;
                    count$macro$5 = temp$count$macro$5;
                    lastAgg$macro$10 = parsedAgg$macro$11
                  }
                }
              };
              var rhsAggregate$macro$18 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$19 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
                $n(evidence$2).Lfastparse_ParsingRun__f_cut = true;
                var res$macro$25 = evidence$2
              } else {
                var postRhsIndex$macro$16 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$21 = (postRhsIndex$macro$16 > preRhsIndex$macro$15);
                var nextIndex$macro$24 = (((!rhsMadeProgress$macro$21) && $n(input$macro$22).isReachable__I__Z(postRhsIndex$macro$16)) ? postLhsIndex$macro$14 : postRhsIndex$macro$16);
                if ((rhsMadeProgress$macro$21 && $n(evidence$2).checkForDrop__Z())) {
                  $n(input$macro$22)
                };
                var $$x7 = $n(evidence$2);
                $n(evidence$2);
                var v = (void 0);
                var res$macro$25 = $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$24)
              };
              if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$13, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$20, rhsMsg$macro$19), $n(lhsAggregate$macro$17).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$18), (preRhsIndex$macro$15 === $n(evidence$2).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          }
        };
        var lhsMsg = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
        var lhsAggregate = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
          $n(evidence$2).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$2).Lfastparse_ParsingRun__f_cut | oldCut)))
        } else if ((!$n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
          var verboseFailures = $n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures;
          $n(evidence$2).Lfastparse_ParsingRun__f_index = startPos$3;
          if (verboseFailures) {
            var this$16 = $n(evidence$2);
            this$16.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, lhsMsg, lhsAggregate, false)
          };
          $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
          $m_Lfastparse_Implicits$Sequencer$();
          var preLhsIndex$macro$65 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
          var input$macro$74 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          var elem$2 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
          var elem$3 = false;
          elem$3 = elem$2;
          var startIndex$macro$30 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
          var count$macro$31 = 0;
          var lastAgg$macro$36 = null;
          while (true) {
            $n(evidence$2).Lfastparse_ParsingRun__f_cut = (elem$3 && (count$macro$31 < 1));
            $m_Lfastparse_package$();
            $m_Lcom_iz2use_common_MathParser$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$2);
            var parsedMsg$macro$35 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
            var parsedAgg$macro$37 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
            elem$3 = (!(!(elem$3 | $n(evidence$2).Lfastparse_ParsingRun__f_cut)));
            if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
              var res$6 = ($n(evidence$2).Lfastparse_ParsingRun__f_cut ? evidence$2 : ((count$macro$31 < 1) ? $n(evidence$2).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$30, elem$3) : $n(evidence$2).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$30, elem$3)));
              if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
                var $$x11 = $n(evidence$2);
                var $$x10 = startIndex$macro$30;
                var $$x9 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$35) => (() => {
                  var this$20 = $n(parsedMsg$macro$35);
                  return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$20.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
                }))(parsedMsg$macro$35));
                if ((lastAgg$macro$36 === null)) {
                  var $$x8 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate
                } else {
                  var rassoc$3 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
                  var $$x8 = $n(lastAgg$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3)
                };
                $n($$x11).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x10, $$x9, $$x8)
              };
              break
            } else {
              var beforeSepIndex$macro$32 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
              $n(evidence$2);
              $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
              if ((this.Lcom_iz2use_common_MathParser$__f_White !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
                $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$2)
              };
              if ((!((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut))) {
                $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
                var temp$count$macro$31 = ((1 + count$macro$31) | 0);
                startIndex$macro$30 = beforeSepIndex$macro$32;
                count$macro$31 = temp$count$macro$31;
                lastAgg$macro$36 = parsedAgg$macro$37;
                continue
              };
              break
            }
          };
          if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$66 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$69 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$72 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
            if (((postLhsIndex$macro$66 > preLhsIndex$macro$65) && $n(evidence$2).checkForDrop__Z())) {
              $n(input$macro$74)
            };
            $n(evidence$2);
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$2);
            if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
              if ((!((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut))) {
                var preRhsIndex$macro$67 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                var startPos$4 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                var startCut$2 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
                $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
                $m_Lfastparse_package$();
                $m_Lfastparse_Implicits$Sequencer$();
                var preLhsIndex$macro$50 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                var input$macro$59 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
                $m_Lfastparse_package$();
                var input$3 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
                var index$3 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                if ($n(input$3).isReachable__I__Z(index$3)) {
                  var this$23 = $n(input$3);
                  var this$24 = $n(this$23.Lfastparse_IndexedParserInput__f_data);
                  var $$x12 = ($charAt(this$24, index$3) === 46)
                } else {
                  var $$x12 = false
                };
                if ($$x12) {
                  $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$3) | 0))
                } else {
                  $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
                };
                if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
                  $n(evidence$2).aggregateTerminal__I__F0__V(index$3, new $c_sjsr_AnonFunction0((() => "\".\"")))
                };
                if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
                  /*<skip>*/
                } else {
                  var postLhsIndex$macro$51 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                  var lhsAggregate$macro$54 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
                  var lhsMsg$macro$57 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
                  if (((postLhsIndex$macro$51 > preLhsIndex$macro$50) && $n(evidence$2).checkForDrop__Z())) {
                    $n(input$macro$59)
                  };
                  $n(evidence$2);
                  $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$2);
                  if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
                    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
                      /*<skip>*/
                    } else {
                      var preRhsIndex$macro$52 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                      var elem$4 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
                      var elem$5 = false;
                      elem$5 = elem$4;
                      var startIndex$macro$41 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                      var count$macro$42 = 0;
                      var lastAgg$macro$47 = null;
                      while (true) {
                        $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
                        $m_Lfastparse_package$();
                        $m_Lcom_iz2use_common_MathParser$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$2);
                        var parsedMsg$macro$46 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
                        var parsedAgg$macro$48 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
                        elem$5 = (!(!(elem$5 | $n(evidence$2).Lfastparse_ParsingRun__f_cut)));
                        if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
                          var res$7 = ($n(evidence$2).Lfastparse_ParsingRun__f_cut ? evidence$2 : $n(evidence$2).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$41, elem$5));
                          if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
                            var $$x16 = $n(evidence$2);
                            var $$x15 = startIndex$macro$41;
                            var $$x14 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$46) => (() => {
                              var this$28 = $n(parsedMsg$macro$46);
                              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$28.Lfastparse_internal_Msgs__f_value) + ".rep")
                            }))(parsedMsg$macro$46));
                            if ((lastAgg$macro$47 === null)) {
                              var $$x13 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate
                            } else {
                              var rassoc$4 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
                              var $$x13 = $n(lastAgg$macro$47).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$4)
                            };
                            $n($$x16).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x15, $$x14, $$x13)
                          };
                          break
                        } else {
                          var beforeSepIndex$macro$43 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                          $n(evidence$2);
                          $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
                          if ((this.Lcom_iz2use_common_MathParser$__f_White !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
                            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$2)
                          };
                          if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
                            break
                          } else {
                            $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
                            var temp$count$macro$42 = ((1 + count$macro$42) | 0);
                            startIndex$macro$41 = beforeSepIndex$macro$43;
                            count$macro$42 = temp$count$macro$42;
                            lastAgg$macro$47 = parsedAgg$macro$48
                          }
                        }
                      };
                      var rhsAggregate$macro$55 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
                      var rhsMsg$macro$56 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
                      if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
                        var res$macro$62 = evidence$2
                      } else {
                        var postRhsIndex$macro$53 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                        var rhsMadeProgress$macro$58 = (postRhsIndex$macro$53 > preRhsIndex$macro$52);
                        var nextIndex$macro$61 = (((!rhsMadeProgress$macro$58) && $n(input$macro$59).isReachable__I__Z(postRhsIndex$macro$53)) ? postLhsIndex$macro$51 : postRhsIndex$macro$53);
                        if ((rhsMadeProgress$macro$58 && $n(evidence$2).checkForDrop__Z())) {
                          $n(input$macro$59)
                        };
                        var $$x17 = $n(evidence$2);
                        $n(evidence$2);
                        var v$1 = (void 0);
                        var res$macro$62 = $n($$x17).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$61)
                      };
                      if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
                        $n(evidence$2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$50, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$57, rhsMsg$macro$56), $n(lhsAggregate$macro$54).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$55), (preRhsIndex$macro$52 === $n(evidence$2).Lfastparse_ParsingRun__f_traceIndex))
                      }
                    }
                  }
                };
                var postSuccess$2 = $n(evidence$2).Lfastparse_ParsingRun__f_isSuccess;
                if (postSuccess$2) {
                  var res$7$1 = $n(evidence$2).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$2), (void 0)));
                  $n(res$7$1).Lfastparse_ParsingRun__f_cut = (!(!($n(res$7$1).Lfastparse_ParsingRun__f_cut | startCut$2)))
                } else if ($n(evidence$2).Lfastparse_ParsingRun__f_cut) {
                  /*<skip>*/
                } else {
                  var res$8 = $n(evidence$2).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos$4);
                  $n(res$8).Lfastparse_ParsingRun__f_cut = (!(!($n(res$8).Lfastparse_ParsingRun__f_cut | startCut$2)))
                };
                if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
                  var msg$2 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
                  var agg$2 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
                  if ((!postSuccess$2)) {
                    $n(evidence$2).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$4, new $c_sjsr_AnonFunction0((() => {
                      var this$30 = $n(msg$2);
                      return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$30.Lfastparse_internal_Msgs__f_value) + ".?")
                    })), agg$2)
                  }
                };
                var rhsAggregate$macro$70 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var rhsMsg$macro$71 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
                if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
                  /*<skip>*/
                } else {
                  var postRhsIndex$macro$68 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
                  var rhsMadeProgress$macro$73 = (postRhsIndex$macro$68 > preRhsIndex$macro$67);
                  var nextIndex$macro$76 = (((!rhsMadeProgress$macro$73) && $n(input$macro$74).isReachable__I__Z(postRhsIndex$macro$68)) ? postLhsIndex$macro$66 : postRhsIndex$macro$68);
                  if ((rhsMadeProgress$macro$73 && $n(evidence$2).checkForDrop__Z())) {
                    $n(input$macro$74)
                  };
                  var $$x18 = $n(evidence$2);
                  $n(evidence$2);
                  var v$2 = (void 0);
                  $n($$x18).freshSuccess__O__I__Lfastparse_ParsingRun(v$2, nextIndex$macro$76)
                };
                if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
                  $n(evidence$2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$65, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$72, rhsMsg$macro$71), $n(lhsAggregate$macro$69).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$70), (preRhsIndex$macro$67 === $n(evidence$2).Lfastparse_ParsingRun__f_traceIndex))
                }
              }
            }
          };
          var rhsMsg = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
          var rhsCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
          var endCut = (!(!(rhsCut | oldCut)));
          if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
            $n(evidence$2).freshFailure__I__Lfastparse_ParsingRun(startPos$3)
          };
          $n(evidence$2).Lfastparse_ParsingRun__f_cut = endCut;
          if (verboseFailures) {
            var this$31 = $n(evidence$2);
            var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
            var rassoc$3$1 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$1);
            this$31.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, msgToSet, msgToAggregate, false)
          }
        };
        var rhsAggregate$macro$85 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$86 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$92 = evidence$2
        } else {
          var postRhsIndex$macro$83 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$88 = (postRhsIndex$macro$83 > preRhsIndex$macro$82);
          var nextIndex$macro$91 = (((!rhsMadeProgress$macro$88) && $n(input$macro$89).isReachable__I__Z(postRhsIndex$macro$83)) ? postLhsIndex$macro$81 : postRhsIndex$macro$83);
          if ((rhsMadeProgress$macro$88 && $n(evidence$2).checkForDrop__Z())) {
            $n(input$macro$89)
          };
          var $$x19 = $n(evidence$2);
          $n(evidence$2);
          var v$3 = (void 0);
          var res$macro$92 = $n($$x19).freshSuccess__O__I__Lfastparse_ParsingRun(v$3, nextIndex$macro$91)
        };
        if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$80, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$87, rhsMsg$macro$86), $n(lhsAggregate$macro$84).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$85), (preRhsIndex$macro$82 === $n(evidence$2).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0$4 = ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) ? evidence$2 : $n(evidence$2).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$2).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$2).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0$4).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$26 = parse0$4
  } else {
    var $$x20 = $n(parse0$4);
    var arg1 = $as_T($n(parse0$4).Lfastparse_ParsingRun__f_successValue);
    $m_sc_StringOps$();
    $$x20.Lfastparse_ParsingRun__f_successValue = $m_jl_Double$().parseDouble__T__D(arg1);
    var x1$26 = parse0$4
  };
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("number").Lsourcecode_Name__f_value, $n(x1$26).Lfastparse_ParsingRun__f_index, $n(x1$26).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$26).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x21 = $n(x1$26);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("number").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x21).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$26).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$26).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$26).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x22 = $n(x1$26);
      var self = new $c_Lsourcecode_Name("number").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$42 = $n($n(x1$26).Lfastparse_ParsingRun__f_failureStack);
      $$x22.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$42)
    }
  };
  return x1$26
});
$c_Lcom_iz2use_common_MathParser$.prototype.parens__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$3) {
  var startIndex = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$3).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("parens").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$17 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$3).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$3).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var input = $n(evidence$3).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$3 = $n(input);
    var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$4, index) === 40)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$3).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$3).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$3).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"(\"")))
  };
  if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$3).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$3).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$3);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$3);
    if ($n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$3).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$4 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
        this.addSub__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$3);
        var rhsAggregate$macro$7 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$3).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$14 = evidence$3
        } else {
          var postRhsIndex$macro$5 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$3).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x2 = $n(evidence$3);
          var v = $uD($n(evidence$3).Lfastparse_ParsingRun__f_successValue);
          var res$macro$14 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
        };
        if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$3).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$8 = evidence$3
  } else {
    var postLhsIndex$macro$18 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$3).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$3).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$3);
    if ($n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$3).Lfastparse_ParsingRun__f_cut)) {
        var x1$8 = evidence$3
      } else {
        var preRhsIndex$macro$19 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
        var input$2 = $n(evidence$3).Lfastparse_ParsingRun__f_input;
        var index$2 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
        if ($n(input$2).isReachable__I__Z(index$2)) {
          var this$8 = $n(input$2);
          var this$9 = $n(this$8.Lfastparse_IndexedParserInput__f_data);
          var $$x3 = ($charAt(this$9, index$2) === 41)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $n(evidence$3).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
        } else {
          $n(evidence$3).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$3).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\")\"")))
        };
        var rhsAggregate$macro$22 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$23 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$29 = evidence$3
        } else {
          var postRhsIndex$macro$20 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
          var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
          if ((rhsMadeProgress$macro$25 && $n(evidence$3).checkForDrop__Z())) {
            $n(input$macro$26)
          };
          var $$x4 = $n(evidence$3);
          $n(x1$3);
          var t = $uD(lhsValue$macro$27);
          $n(evidence$3);
          var res$macro$29 = $n($$x4).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$28)
        };
        if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$3).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$8 = res$macro$29
      }
    } else {
      var x1$8 = evidence$3
    }
  };
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("parens").Lsourcecode_Name__f_value, $n(x1$8).Lfastparse_ParsingRun__f_index, $n(x1$8).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$8).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$8);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("parens").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$8).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$8).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$8).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$8);
      var self = new $c_Lsourcecode_Name("parens").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$17 = $n($n(x1$8).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$17)
    }
  };
  return x1$8
});
$c_Lcom_iz2use_common_MathParser$.prototype.factor__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$4) {
  var startIndex = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$4).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("factor").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$4).Lfastparse_ParsingRun__f_cut;
  $n(evidence$4).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  this.parens__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$4);
  var lhsMsg = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$4).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$3 = evidence$4
  } else if ($n(evidence$4).Lfastparse_ParsingRun__f_cut) {
    var x1$3 = evidence$4
  } else {
    var verboseFailures = $n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$4).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$2 = $n(evidence$4);
      this$2.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = false;
    this.number__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$4);
    var rhsMsg = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$4).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$4).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$3 = $n(evidence$4);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$3.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$3 = evidence$4
  };
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("factor").Lsourcecode_Name__f_value, $n(x1$3).Lfastparse_ParsingRun__f_index, $n(x1$3).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$3).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(x1$3);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("factor").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$3).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$3).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(x1$3);
      var self = new $c_Lsourcecode_Name("factor").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$3).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$11)
    }
  };
  return x1$3
});
$c_Lcom_iz2use_common_MathParser$.prototype.divMul__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$5) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$5).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$5).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("divMul").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$28 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var input$macro$37 = $n(evidence$5).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  this.factor__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$5);
  if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$6$1 = evidence$5
  } else {
    var postLhsIndex$macro$29 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$32 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$35 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$29 > preLhsIndex$macro$28) && $n(evidence$5).checkForDrop__Z())) {
      $n(input$macro$37)
    };
    var lhsValue$macro$38 = $n(evidence$5).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$5);
    if ($n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$5).Lfastparse_ParsingRun__f_cut)) {
        var x1$6$1 = evidence$5
      } else {
        var preRhsIndex$macro$30 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
        var this$3 = $m_Lfastparse_Implicits$Repeater$();
        var x1$5 = this$3.GenericRepeatedImplicit0__Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$();
        var elem = $n(evidence$5).Lfastparse_ParsingRun__f_cut;
        var elem$1 = false;
        elem$1 = elem;
        $n(x1$5);
        var acc$macro$18 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
        var startIndex$macro$19 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
        var count$macro$20 = 0;
        var lastAgg$macro$25 = null;
        while (true) {
          $n(evidence$5).Lfastparse_ParsingRun__f_cut = false;
          $m_Lfastparse_package$();
          var this$7 = $m_Lfastparse_Implicits$Sequencer$();
          var x1$2 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$7));
          var preLhsIndex$macro$2 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
          var input$macro$11 = $n(evidence$5).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          var startPos = $n(evidence$5).Lfastparse_ParsingRun__f_index;
          var oldCapturing = $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer;
          $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer = true;
          $m_Lfastparse_package$();
          var index = $n(evidence$5).Lfastparse_ParsingRun__f_index;
          if ((!$n($n(evidence$5).Lfastparse_ParsingRun__f_input).isReachable__I__Z(index))) {
            $n(evidence$5).freshFailure__Lfastparse_ParsingRun()
          } else {
            var this$8 = $n($n(evidence$5).Lfastparse_ParsingRun__f_input);
            var index$1 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
            var this$9 = $n(this$8.Lfastparse_IndexedParserInput__f_data);
            var x1$5$1 = $charAt(this$9, index$1);
            switch (x1$5$1) {
              case 42: {
                var x1$6 = true;
                break
              }
              case 47: {
                var x1$6 = true;
                break
              }
              default: {
                var x1$6 = false
              }
            };
            if ((x1$6 === true)) {
              $n(evidence$5).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
            } else {
              if ((x1$6 !== false)) {
                throw new $c_s_MatchError(x1$6)
              };
              $n(evidence$5).freshFailure__Lfastparse_ParsingRun()
            }
          };
          if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$5).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "[*/]")))
          };
          $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
          if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
            /*<skip>*/
          } else {
            $n(evidence$5).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$5).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$5).Lfastparse_ParsingRun__f_index))
          };
          if ($n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$3 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$6 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$9 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
            $n(evidence$5).Lfastparse_ParsingRun__f_cut = true;
            if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$5).checkForDrop__Z())) {
              $n(input$macro$11)
            };
            var lhsValue$macro$12 = $n(evidence$5).Lfastparse_ParsingRun__f_successValue;
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lcom_iz2use_common_MathParser$().Lcom_iz2use_common_MathParser$__f_White, evidence$5);
            if ($n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) {
              if ((!((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$5).Lfastparse_ParsingRun__f_cut))) {
                var preRhsIndex$macro$4 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
                $m_Lcom_iz2use_common_MathParser$().factor__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$5);
                var rhsAggregate$macro$7 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var rhsMsg$macro$8 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
                if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
                  $n(evidence$5).Lfastparse_ParsingRun__f_cut = true
                } else {
                  var postRhsIndex$macro$5 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
                  var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
                  var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
                  if ((rhsMadeProgress$macro$10 && $n(evidence$5).checkForDrop__Z())) {
                    $n(input$macro$11)
                  };
                  $n(evidence$5).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$2).apply__O__O__O($as_T(lhsValue$macro$12), $uD($n(evidence$5).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$13)
                };
                if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
                  $n(evidence$5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$5).Lfastparse_ParsingRun__f_traceIndex))
                }
              }
            }
          };
          var parsedMsg$macro$24 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$26 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$1 = (!(!(elem$1 | $n(evidence$5).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
            if ($n(evidence$5).Lfastparse_ParsingRun__f_cut) {
              var res$1 = evidence$5
            } else {
              var $$x1 = $n(evidence$5);
              $n(x1$5);
              var this$14 = $n(acc$macro$18);
              var res$1 = $n($$x1).freshSuccess__O__I__Z__Lfastparse_ParsingRun($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$14), startIndex$macro$19, elem$1)
            };
            if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x5 = $n(evidence$5);
              var $$x4 = startIndex$macro$19;
              var $$x3 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
                var this$15 = $n(parsedMsg$macro$24);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$15.Lfastparse_internal_Msgs__f_value) + ".rep")
              }))(parsedMsg$macro$24));
              if ((lastAgg$macro$25 === null)) {
                var $$x2 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$2 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x2 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
              };
              $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x4, $$x3, $$x2)
            };
            break
          } else {
            var beforeSepIndex$macro$21 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
            $n(x1$5);
            var t = $as_T2($n(evidence$5).Lfastparse_ParsingRun__f_successValue);
            var this$17 = $n(acc$macro$18);
            this$17.addOne__O__scm_Growable(t);
            $n(evidence$5).Lfastparse_ParsingRun__f_cut = false;
            if ((this.Lcom_iz2use_common_MathParser$__f_White !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$5)
            };
            if (((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$5).Lfastparse_ParsingRun__f_cut)) {
              break
            } else {
              $n(evidence$5).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$20 = ((1 + count$macro$20) | 0);
              startIndex$macro$19 = beforeSepIndex$macro$21;
              count$macro$20 = temp$count$macro$20;
              lastAgg$macro$25 = parsedAgg$macro$26
            }
          }
        };
        var rhsAggregate$macro$33 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$34 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$40 = evidence$5
        } else {
          var postRhsIndex$macro$31 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$36 = (postRhsIndex$macro$31 > preRhsIndex$macro$30);
          var nextIndex$macro$39 = (((!rhsMadeProgress$macro$36) && $n(input$macro$37).isReachable__I__Z(postRhsIndex$macro$31)) ? postLhsIndex$macro$29 : postRhsIndex$macro$31);
          if ((rhsMadeProgress$macro$36 && $n(evidence$5).checkForDrop__Z())) {
            $n(input$macro$37)
          };
          var res$macro$40 = $n(evidence$5).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($uD(lhsValue$macro$38), $as_sci_Seq($n(evidence$5).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$39)
        };
        if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$28, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$35, rhsMsg$macro$34), $n(lhsAggregate$macro$32).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$33), (preRhsIndex$macro$30 === $n(evidence$5).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$6$1 = res$macro$40
      }
    } else {
      var x1$6$1 = evidence$5
    }
  };
  if (instrument) {
    $n($n(evidence$5).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("divMul").Lsourcecode_Name__f_value, $n(x1$6$1).Lfastparse_ParsingRun__f_index, $n(x1$6$1).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$6$1).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x6 = $n(x1$6$1);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("divMul").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$6$1).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$6$1).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$6$1).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x7 = $n(x1$6$1);
      var self = new $c_Lsourcecode_Name("divMul").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$25 = $n($n(x1$6$1).Lfastparse_ParsingRun__f_failureStack);
      $$x7.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$25)
    }
  };
  if ((!$n(x1$6$1).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$6$1
  } else {
    var $$x8 = $n(x1$6$1);
    var arg1 = $as_T2($n(x1$6$1).Lfastparse_ParsingRun__f_successValue);
    $$x8.Lfastparse_ParsingRun__f_successValue = $m_Lcom_iz2use_common_MathParser$().eval__T2__D(arg1);
    return x1$6$1
  }
});
$c_Lcom_iz2use_common_MathParser$.prototype.addSub__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$6) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$6).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("addSub").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$28 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$37 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  this.divMul__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$6$1 = evidence$6
  } else {
    var postLhsIndex$macro$29 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$32 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$35 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$29 > preLhsIndex$macro$28) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$37)
    };
    var lhsValue$macro$38 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$6);
    if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
        var x1$6$1 = evidence$6
      } else {
        var preRhsIndex$macro$30 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var this$3 = $m_Lfastparse_Implicits$Repeater$();
        var x1$5 = this$3.GenericRepeatedImplicit0__Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$();
        var elem = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
        var elem$1 = false;
        elem$1 = elem;
        $n(x1$5);
        var acc$macro$18 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
        var startIndex$macro$19 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var count$macro$20 = 0;
        var lastAgg$macro$25 = null;
        while (true) {
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
          $m_Lfastparse_package$();
          var this$7 = $m_Lfastparse_Implicits$Sequencer$();
          var x1$2 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$7));
          var preLhsIndex$macro$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var input$macro$11 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          var startPos = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var oldCapturing = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
          $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
          $m_Lfastparse_package$();
          var index = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          if ((!$n($n(evidence$6).Lfastparse_ParsingRun__f_input).isReachable__I__Z(index))) {
            $n(evidence$6).freshFailure__Lfastparse_ParsingRun()
          } else {
            var this$8 = $n($n(evidence$6).Lfastparse_ParsingRun__f_input);
            var index$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
            var this$9 = $n(this$8.Lfastparse_IndexedParserInput__f_data);
            var x1$5$1 = $charAt(this$9, index$1);
            switch (x1$5$1) {
              case 43: {
                var x1$6 = true;
                break
              }
              case 45: {
                var x1$6 = true;
                break
              }
              default: {
                var x1$6 = false
              }
            };
            if ((x1$6 === true)) {
              $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
            } else {
              if ((x1$6 !== false)) {
                throw new $c_s_MatchError(x1$6)
              };
              $n(evidence$6).freshFailure__Lfastparse_ParsingRun()
            }
          };
          if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$6).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "[+\\\\-]")))
          };
          $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
          if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
            /*<skip>*/
          } else {
            $n(evidence$6).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$6).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$6).Lfastparse_ParsingRun__f_index))
          };
          if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$3 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$6 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$9 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = true;
            if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$6).checkForDrop__Z())) {
              $n(input$macro$11)
            };
            var lhsValue$macro$12 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lcom_iz2use_common_MathParser$().Lcom_iz2use_common_MathParser$__f_White, evidence$6);
            if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
              if ((!((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut))) {
                var preRhsIndex$macro$4 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
                $m_Lcom_iz2use_common_MathParser$().divMul__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
                var rhsAggregate$macro$7 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var rhsMsg$macro$8 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
                if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
                  $n(evidence$6).Lfastparse_ParsingRun__f_cut = true
                } else {
                  var postRhsIndex$macro$5 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
                  var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
                  var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
                  if ((rhsMadeProgress$macro$10 && $n(evidence$6).checkForDrop__Z())) {
                    $n(input$macro$11)
                  };
                  $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$2).apply__O__O__O($as_T(lhsValue$macro$12), $uD($n(evidence$6).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$13)
                };
                if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
                  $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
                }
              }
            }
          };
          var parsedMsg$macro$24 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$26 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$1 = (!(!(elem$1 | $n(evidence$6).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
            if ($n(evidence$6).Lfastparse_ParsingRun__f_cut) {
              var res$1 = evidence$6
            } else {
              var $$x1 = $n(evidence$6);
              $n(x1$5);
              var this$14 = $n(acc$macro$18);
              var res$1 = $n($$x1).freshSuccess__O__I__Z__Lfastparse_ParsingRun($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$14), startIndex$macro$19, elem$1)
            };
            if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x5 = $n(evidence$6);
              var $$x4 = startIndex$macro$19;
              var $$x3 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
                var this$15 = $n(parsedMsg$macro$24);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$15.Lfastparse_internal_Msgs__f_value) + ".rep")
              }))(parsedMsg$macro$24));
              if ((lastAgg$macro$25 === null)) {
                var $$x2 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$2 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x2 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
              };
              $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x4, $$x3, $$x2)
            };
            break
          } else {
            var beforeSepIndex$macro$21 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
            $n(x1$5);
            var t = $as_T2($n(evidence$6).Lfastparse_ParsingRun__f_successValue);
            var this$17 = $n(acc$macro$18);
            this$17.addOne__O__scm_Growable(t);
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
            if ((this.Lcom_iz2use_common_MathParser$__f_White !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$6)
            };
            if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
              break
            } else {
              $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$20 = ((1 + count$macro$20) | 0);
              startIndex$macro$19 = beforeSepIndex$macro$21;
              count$macro$20 = temp$count$macro$20;
              lastAgg$macro$25 = parsedAgg$macro$26
            }
          }
        };
        var rhsAggregate$macro$33 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$34 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$40 = evidence$6
        } else {
          var postRhsIndex$macro$31 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$36 = (postRhsIndex$macro$31 > preRhsIndex$macro$30);
          var nextIndex$macro$39 = (((!rhsMadeProgress$macro$36) && $n(input$macro$37).isReachable__I__Z(postRhsIndex$macro$31)) ? postLhsIndex$macro$29 : postRhsIndex$macro$31);
          if ((rhsMadeProgress$macro$36 && $n(evidence$6).checkForDrop__Z())) {
            $n(input$macro$37)
          };
          var res$macro$40 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($uD(lhsValue$macro$38), $as_sci_Seq($n(evidence$6).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$39)
        };
        if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$28, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$35, rhsMsg$macro$34), $n(lhsAggregate$macro$32).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$33), (preRhsIndex$macro$30 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$6$1 = res$macro$40
      }
    } else {
      var x1$6$1 = evidence$6
    }
  };
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("addSub").Lsourcecode_Name__f_value, $n(x1$6$1).Lfastparse_ParsingRun__f_index, $n(x1$6$1).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$6$1).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x6 = $n(x1$6$1);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("addSub").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$6$1).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$6$1).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$6$1).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x7 = $n(x1$6$1);
      var self = new $c_Lsourcecode_Name("addSub").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$25 = $n($n(x1$6$1).Lfastparse_ParsingRun__f_failureStack);
      $$x7.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$25)
    }
  };
  if ((!$n(x1$6$1).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$6$1
  } else {
    var $$x8 = $n(x1$6$1);
    var arg1 = $as_T2($n(x1$6$1).Lfastparse_ParsingRun__f_successValue);
    $$x8.Lfastparse_ParsingRun__f_successValue = $m_Lcom_iz2use_common_MathParser$().eval__T2__D(arg1);
    return x1$6$1
  }
});
$c_Lcom_iz2use_common_MathParser$.prototype.expr__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$7) {
  var startIndex = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$7).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("expr").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$17 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$7).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$7).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$().Start__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
  if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$7).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$7);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$7);
    if ($n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$7).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$4 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
        this.addSub__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
        var rhsAggregate$macro$7 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$14 = evidence$7
        } else {
          var postRhsIndex$macro$5 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$7).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x1 = $n(evidence$7);
          var v = $uD($n(evidence$7).Lfastparse_ParsingRun__f_successValue);
          var res$macro$14 = $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
        };
        if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$7).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$6 = evidence$7
  } else {
    var postLhsIndex$macro$18 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$7).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$7).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lcom_iz2use_common_MathParser$__f_White, evidence$7);
    if ($n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$7).Lfastparse_ParsingRun__f_cut)) {
        var x1$6 = evidence$7
      } else {
        var preRhsIndex$macro$19 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
        var rhsAggregate$macro$22 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$23 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$29 = evidence$7
        } else {
          var postRhsIndex$macro$20 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
          var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
          if ((rhsMadeProgress$macro$25 && $n(evidence$7).checkForDrop__Z())) {
            $n(input$macro$26)
          };
          var $$x2 = $n(evidence$7);
          $n(x1$3);
          var t = $uD(lhsValue$macro$27);
          $n(evidence$7);
          var res$macro$29 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$28)
        };
        if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$7).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$6 = res$macro$29
      }
    } else {
      var x1$6 = evidence$7
    }
  };
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("expr").Lsourcecode_Name__f_value, $n(x1$6).Lfastparse_ParsingRun__f_index, $n(x1$6).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$6).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x3 = $n(x1$6);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("expr").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$6).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$6).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$6).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x4 = $n(x1$6);
      var self = new $c_Lsourcecode_Name("expr").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$13 = $n($n(x1$6).Lfastparse_ParsingRun__f_failureStack);
      $$x4.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$13)
    }
  };
  return x1$6
});
$c_Lcom_iz2use_common_MathParser$.prototype.eval__T2__D = (function(tree) {
  if ((tree === null)) {
    throw new $c_s_MatchError(tree)
  };
  var base = $n(tree)._1$mcD$sp__D();
  var ops = $as_sci_Seq($n(tree)._2__O());
  return $uD($n(ops).foldLeft__O__F2__O(base, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $uD(x0$1$2);
    var x1$1 = $as_T2(x1$1$2);
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
    var left = $uD(x1.T2__f__1);
    var p2 = $as_T2(x1.T2__f__2);
    if ((p2 !== null)) {
      var op = $as_T($n(p2)._1__O());
      var right = $n(p2)._2$mcD$sp__D();
      switch (op) {
        case "+": {
          return (left + right);
          break
        }
        case "-": {
          return (left - right);
          break
        }
        case "*": {
          return (left * right);
          break
        }
        case "/": {
          return (left / right);
          break
        }
        default: {
          throw new $c_s_MatchError(op)
        }
      }
    };
    throw new $c_s_MatchError(x1)
  }))))
});
var $d_Lcom_iz2use_common_MathParser$ = new $TypeData().initClass({
  Lcom_iz2use_common_MathParser$: 0
}, false, "com.iz2use.common.MathParser$", {
  Lcom_iz2use_common_MathParser$: 1,
  O: 1
});
$c_Lcom_iz2use_common_MathParser$.prototype.$classData = $d_Lcom_iz2use_common_MathParser$;
var $n_Lcom_iz2use_common_MathParser$;
function $m_Lcom_iz2use_common_MathParser$() {
  if ((!$n_Lcom_iz2use_common_MathParser$)) {
    $n_Lcom_iz2use_common_MathParser$ = new $c_Lcom_iz2use_common_MathParser$()
  };
  return $n_Lcom_iz2use_common_MathParser$
}
function $f_Lcom_iz2use_common_PlatformSpecifics__$init$__V($thiz) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T(x$1$2);
    return x$1
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  $thiz.Lcom_iz2use_common_package$__f_reuseKey = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
}
function $p_Lcom_iz2use_common_PlatformSpecifics$Normalizer$__Form$lzycompute$1__V($thiz) {
  if (($thiz.Lcom_iz2use_common_PlatformSpecifics$Normalizer$__f_Form$module === null)) {
    $thiz.Lcom_iz2use_common_PlatformSpecifics$Normalizer$__f_Form$module = new $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$($thiz)
  }
}
/** @constructor */
function $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$(outer) {
  this.Lcom_iz2use_common_PlatformSpecifics$Normalizer$__f_Form$module = null
}
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$.prototype = new $h_O();
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$.prototype.constructor = $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$;
/** @constructor */
function $h_Lcom_iz2use_common_PlatformSpecifics$Normalizer$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_PlatformSpecifics$Normalizer$.prototype = $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$.prototype;
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$.prototype.Form__Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$ = (function() {
  if ((this.Lcom_iz2use_common_PlatformSpecifics$Normalizer$__f_Form$module === null)) {
    $p_Lcom_iz2use_common_PlatformSpecifics$Normalizer$__Form$lzycompute$1__V(this)
  };
  return this.Lcom_iz2use_common_PlatformSpecifics$Normalizer$__f_Form$module
});
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$.prototype.normalize__T__Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form__T = (function(in$1, form) {
  return $as_T(in$1.normalize(($n(form), $m_sjs_js_UnicodeNormalizationForm$().sjs_js_UnicodeNormalizationForm$__f_NFD)))
});
var $d_Lcom_iz2use_common_PlatformSpecifics$Normalizer$ = new $TypeData().initClass({
  Lcom_iz2use_common_PlatformSpecifics$Normalizer$: 0
}, false, "com.iz2use.common.PlatformSpecifics$Normalizer$", {
  Lcom_iz2use_common_PlatformSpecifics$Normalizer$: 1,
  O: 1
});
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$.prototype.$classData = $d_Lcom_iz2use_common_PlatformSpecifics$Normalizer$;
function $p_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$__NFD$lzycompute$1__V($thiz) {
  if (($thiz.Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$__f_NFD$module === null)) {
    $thiz.Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$__f_NFD$module = new $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$($thiz)
  }
}
/** @constructor */
function $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$(outer) {
  this.Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$__f_NFD$module = null
}
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$.prototype = new $h_O();
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$.prototype.constructor = $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$;
/** @constructor */
function $h_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$.prototype = $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$.prototype;
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$.prototype.NFD__Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$ = (function() {
  if ((this.Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$__f_NFD$module === null)) {
    $p_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$__NFD$lzycompute$1__V(this)
  };
  return this.Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$__f_NFD$module
});
var $d_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$ = new $TypeData().initClass({
  Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$: 0
}, false, "com.iz2use.common.PlatformSpecifics$Normalizer$Form$", {
  Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$: 1,
  O: 1
});
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$.prototype.$classData = $d_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$;
function $f_Lcom_iz2use_common_TimeParser__fromReference__Ljava_time_LocalDate__I__s_Option__s_Option__Ljava_time_LocalDate($thiz, reference, d, m, y) {
  var this$1 = $n(y);
  if (this$1.isEmpty__Z()) {
    var fy = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x0$1 = $uI(arg1);
    if ((x0$1 < 100)) {
      var this$2 = $n(reference);
      var ny = this$2.Ljava_time_LocalDate__f_year;
      var c = ((ny / 100) | 0);
      var $$x1 = ((Math.imul(100, ((x0$1 >= ((25 + ((((ny - Math.imul(100, c)) | 0) % 100) | 0)) | 0)) ? (((-1) + c) | 0) : c)) + x0$1) | 0)
    } else {
      var $$x1 = x0$1
    };
    var fy = new $c_s_Some($$x1)
  };
  var base = $as_Ljava_time_LocalDate($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(m)).foldLeft__O__F2__O($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(fy)).foldLeft__O__F2__O(reference, new $c_sjsr_AnonFunction2(((x$10$2, x$11$2) => {
    var x$10 = $as_Ljava_time_LocalDate(x$10$2);
    var x$11 = $uI(x$11$2);
    return $n(x$10).withYear__I__Ljava_time_LocalDate(x$11)
  }))), new $c_sjsr_AnonFunction2(((x$12$2, x$13$2) => {
    var x$12 = $as_Ljava_time_LocalDate(x$12$2);
    var x$13 = $uI(x$13$2);
    return $n(x$12).withMonth__I__Ljava_time_LocalDate(x$13)
  }))));
  var $$x2 = $n(base);
  var this$4 = $n(base);
  var value = ((d - $p_Ljava_time_LocalDate__day__S(this$4)) | 0);
  var hi = (value >> 31);
  return $n($$x2).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(value, hi))
}
function $f_Lcom_iz2use_common_TimeParser__$init$__V($thiz) {
  $thiz.Lcom_iz2use_common_TimeParser$__f_ddmmyy = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(\\d{2})(\\d{2})(\\d{4}|\\d{2}|)", $m_sci_Nil$()));
  $thiz.Lcom_iz2use_common_TimeParser$__f_dmy = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(\\d{1,2})([/.-])(\\d{1,2})\\2(\\d{1,4})", $m_sci_Nil$()));
  $m_sc_StringOps$();
  $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(\\d{1,2})([/.-])(\\d{1,2})", $m_sci_Nil$());
  $thiz.Lcom_iz2use_common_TimeParser$__f_my = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(\\d{1,2})([/.-])(\\d{4})", $m_sci_Nil$()));
  $thiz.Lcom_iz2use_common_TimeParser$__f_d = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(0[1-9]|[1-9]\\d?)", $m_sci_Nil$()));
  $thiz.Lcom_iz2use_common_TimeParser$__f_relative = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([+-]\\d+|0)", $m_sci_Nil$()));
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array = [$ct_T2__O__O__(new $c_T2(), "aujourdhui", 0), $ct_T2__O__O__(new $c_T2(), "demain", 1), $ct_T2__O__O__(new $c_T2(), "hier", (-1)), $ct_T2__O__O__(new $c_T2(), "apresdemain", 2), $ct_T2__O__O__(new $c_T2(), "avanthier", (-2))];
  $thiz.Lcom_iz2use_common_TimeParser$__f_namedDayValues = $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
}
/** @constructor */
function $c_Lcom_iz2use_common_TimeParser$PossibleDays$(outer) {
  this.Lcom_iz2use_common_TimeParser$PossibleDays$__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_common_TimeParser$PossibleDays$__f_$outer = outer
  }
}
$c_Lcom_iz2use_common_TimeParser$PossibleDays$.prototype = new $h_O();
$c_Lcom_iz2use_common_TimeParser$PossibleDays$.prototype.constructor = $c_Lcom_iz2use_common_TimeParser$PossibleDays$;
/** @constructor */
function $h_Lcom_iz2use_common_TimeParser$PossibleDays$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TimeParser$PossibleDays$.prototype = $c_Lcom_iz2use_common_TimeParser$PossibleDays$.prototype;
$c_Lcom_iz2use_common_TimeParser$PossibleDays$.prototype.unapply__T__s_Option = (function(in$1) {
  var find = $n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T(in$1);
  return $n($n(this.Lcom_iz2use_common_TimeParser$PossibleDays$__f_$outer).Lcom_iz2use_common_TimeParser$__f_namedDayValues).collectFirst__s_PartialFunction__s_Option(new $c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1(this, find))
});
var $d_Lcom_iz2use_common_TimeParser$PossibleDays$ = new $TypeData().initClass({
  Lcom_iz2use_common_TimeParser$PossibleDays$: 0
}, false, "com.iz2use.common.TimeParser$PossibleDays$", {
  Lcom_iz2use_common_TimeParser$PossibleDays$: 1,
  O: 1
});
$c_Lcom_iz2use_common_TimeParser$PossibleDays$.prototype.$classData = $d_Lcom_iz2use_common_TimeParser$PossibleDays$;
/** @constructor */
function $c_Lcom_iz2use_common_TokenMatcher$() {
  this.Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher = null;
  $n_Lcom_iz2use_common_TokenMatcher$ = this;
  this.Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher = new $c_Lcom_iz2use_common_BestPositionByTokenMatcher()
}
$c_Lcom_iz2use_common_TokenMatcher$.prototype = new $h_O();
$c_Lcom_iz2use_common_TokenMatcher$.prototype.constructor = $c_Lcom_iz2use_common_TokenMatcher$;
/** @constructor */
function $h_Lcom_iz2use_common_TokenMatcher$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TokenMatcher$.prototype = $c_Lcom_iz2use_common_TokenMatcher$.prototype;
var $d_Lcom_iz2use_common_TokenMatcher$ = new $TypeData().initClass({
  Lcom_iz2use_common_TokenMatcher$: 0
}, false, "com.iz2use.common.TokenMatcher$", {
  Lcom_iz2use_common_TokenMatcher$: 1,
  O: 1
});
$c_Lcom_iz2use_common_TokenMatcher$.prototype.$classData = $d_Lcom_iz2use_common_TokenMatcher$;
var $n_Lcom_iz2use_common_TokenMatcher$;
function $m_Lcom_iz2use_common_TokenMatcher$() {
  if ((!$n_Lcom_iz2use_common_TokenMatcher$)) {
    $n_Lcom_iz2use_common_TokenMatcher$ = new $c_Lcom_iz2use_common_TokenMatcher$()
  };
  return $n_Lcom_iz2use_common_TokenMatcher$
}
/** @constructor */
function $c_Lcom_iz2use_common_TraversableImplicits$RichCollection(outer, in$1) {
  this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in = null;
  this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_$outer = null;
  this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in = in$1;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_$outer = outer
  }
}
$c_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype = new $h_O();
$c_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype.constructor = $c_Lcom_iz2use_common_TraversableImplicits$RichCollection;
/** @constructor */
function $h_Lcom_iz2use_common_TraversableImplicits$RichCollection() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype = $c_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype;
$c_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype.moveAtIndex__I__I__sc_Factory__sci_Seq = (function(from, to, cbf) {
  return (((from === (-1)) || (to === (-1))) ? this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in : ((from === to) ? this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in : this.moveOffset__I__I__sc_Factory__sci_Seq(from, ((to - from) | 0), cbf)))
});
$c_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype.moveOffset__I__I__sc_Factory__sci_Seq = (function(from, offset, cbf) {
  if ((offset === 0)) {
    return this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in
  } else {
    var $$x3 = $as_sc_SeqOps($n(this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in).patch__I__sc_IterableOnce__I__O(from, $m_s_package$().s_package$__f_Nil, 1));
    var $$x2 = $n(this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in).length__I();
    var $$x1 = $m_s_package$().s_package$__f_Seq;
    var array = [$n(this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in).apply__I__O(from)];
    return $as_sci_Seq($n($as_sc_IterableOnceOps($n($$x3).patch__I__sc_IterableOnce__I__O(((from + $intMod(offset, $$x2)) | 0), $n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), 0))).to__sc_Factory__O(cbf))
  }
});
$c_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype.moveWhere__F1__F1__sc_Factory__sci_Seq = (function(fromWhere, toWhere, cbf) {
  var this$1 = $n(this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in);
  var $$x1 = this$1.indexWhere__F1__I__I(fromWhere, 0);
  var this$2 = $n(this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in);
  return this.moveAtIndex__I__I__sc_Factory__sci_Seq($$x1, this$2.indexWhere__F1__I__I(toWhere, 0), cbf)
});
$c_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype.toggleTraversable__sci_List__F2__sc_Factory__sci_Seq = (function(toggleList, eq, cbf) {
  var this$1 = $n(toggleList);
  var z = this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in;
  var acc = z;
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = acc;
    var arg2 = $n(these).head__O();
    var acc$1 = $as_sci_Seq(arg1);
    var this$2 = $n(this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_$outer);
    acc = new $c_Lcom_iz2use_common_TraversableImplicits$RichCollection(this$2, acc$1).toggleItem__O__F2__sc_Factory__sci_Seq(arg2, eq, cbf);
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return $as_sci_Seq(acc)
});
$c_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype.toggleItem__O__F2__sc_Factory__sci_Seq = (function(item, eq, cbf) {
  var this$2 = $n(this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in);
  var p = new $c_sjsr_AnonFunction1(((x$1$2) => $uZ($n(eq).apply__O__O__O(x$1$2, item))));
  var x1 = this$2.indexWhere__F1__I__I(p, 0);
  if ((x1 === (-1))) {
    var this$3 = $n(this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in);
    return $as_sci_Seq($n($as_sc_IterableOnceOps(this$3.appended__O__O(item))).to__sc_Factory__O(cbf))
  } else {
    return $as_sci_Seq($n($as_sc_IterableOnceOps($n(this.Lcom_iz2use_common_TraversableImplicits$RichCollection__f_in).patch__I__sc_IterableOnce__I__O(x1, $m_s_package$().s_package$__f_Nil, 1))).to__sc_Factory__O(cbf))
  }
});
var $d_Lcom_iz2use_common_TraversableImplicits$RichCollection = new $TypeData().initClass({
  Lcom_iz2use_common_TraversableImplicits$RichCollection: 0
}, false, "com.iz2use.common.TraversableImplicits$RichCollection", {
  Lcom_iz2use_common_TraversableImplicits$RichCollection: 1,
  O: 1
});
$c_Lcom_iz2use_common_TraversableImplicits$RichCollection.prototype.$classData = $d_Lcom_iz2use_common_TraversableImplicits$RichCollection;
function $is_Lcom_iz2use_common_internal_tokenizer_Tokenized(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_common_internal_tokenizer_Tokenized)))
}
function $as_Lcom_iz2use_common_internal_tokenizer_Tokenized(obj) {
  return (($is_Lcom_iz2use_common_internal_tokenizer_Tokenized(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.internal.tokenizer.Tokenized"))
}
function $isArrayOf_Lcom_iz2use_common_internal_tokenizer_Tokenized(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_internal_tokenizer_Tokenized)))
}
function $asArrayOf_Lcom_iz2use_common_internal_tokenizer_Tokenized(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_internal_tokenizer_Tokenized(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.internal.tokenizer.Tokenized;", depth))
}
function $is_Lcom_iz2use_common_internal_tokenizer_Tokenizer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_common_internal_tokenizer_Tokenizer)))
}
function $as_Lcom_iz2use_common_internal_tokenizer_Tokenizer(obj) {
  return (($is_Lcom_iz2use_common_internal_tokenizer_Tokenizer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.internal.tokenizer.Tokenizer"))
}
function $isArrayOf_Lcom_iz2use_common_internal_tokenizer_Tokenizer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_internal_tokenizer_Tokenizer)))
}
function $asArrayOf_Lcom_iz2use_common_internal_tokenizer_Tokenizer(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_internal_tokenizer_Tokenizer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.internal.tokenizer.Tokenizer;", depth))
}
function $p_Lcom_iz2use_react_components_Button$__go$1__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($thiz, e, f$1) {
  var this$ = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$().asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(($m_Ljapgolly_scalajs_react_package$(), f$1), e);
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Button$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Button$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Button$.prototype.constructor = $c_Lcom_iz2use_react_components_Button$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Button$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Button$.prototype = $c_Lcom_iz2use_react_components_Button$.prototype;
$c_Lcom_iz2use_react_components_Button$.prototype.apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf = (function(f) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_button;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("button", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lcom_iz2use_react_components_Button$__go$1__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this, e$2, f)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_Button$.prototype.submit__Ljapgolly_scalajs_react_vdom_TagOf = (function() {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_button;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("submit", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  return $n($n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($m_sci_Nil$())
});
var $d_Lcom_iz2use_react_components_Button$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Button$: 0
}, false, "com.iz2use.react.components.Button$", {
  Lcom_iz2use_react_components_Button$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Button$.prototype.$classData = $d_Lcom_iz2use_react_components_Button$;
var $n_Lcom_iz2use_react_components_Button$;
function $m_Lcom_iz2use_react_components_Button$() {
  if ((!$n_Lcom_iz2use_react_components_Button$)) {
    $n_Lcom_iz2use_react_components_Button$ = new $c_Lcom_iz2use_react_components_Button$()
  };
  return $n_Lcom_iz2use_react_components_Button$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Card$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Card$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Card$.prototype.constructor = $c_Lcom_iz2use_react_components_Card$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Card$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Card$.prototype = $c_Lcom_iz2use_react_components_Card$.prototype;
$c_Lcom_iz2use_react_components_Card$.prototype.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(title, headerStart, headerEnd, containerStyle, children) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_cardContainer;
  var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_cardHeader;
  var $$x4 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$1);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$10 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n(arg1).Lcom_iz2use_react_style_Style__f_cardTitle;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s$2), title];
  var array$1 = [$$x4, headerStart, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), headerEnd];
  var $$x2 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$19 = $m_s_$less$colon$less$();
  var array$2 = [$$x6, containerStyle, $$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(children, this$19.s_$less$colon$less$__f_singleton)];
  return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
var $d_Lcom_iz2use_react_components_Card$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Card$: 0
}, false, "com.iz2use.react.components.Card$", {
  Lcom_iz2use_react_components_Card$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Card$.prototype.$classData = $d_Lcom_iz2use_react_components_Card$;
var $n_Lcom_iz2use_react_components_Card$;
function $m_Lcom_iz2use_react_components_Card$() {
  if ((!$n_Lcom_iz2use_react_components_Card$)) {
    $n_Lcom_iz2use_react_components_Card$ = new $c_Lcom_iz2use_react_components_Card$()
  };
  return $n_Lcom_iz2use_react_components_Card$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Dialog$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Dialog$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Dialog$.prototype.constructor = $c_Lcom_iz2use_react_components_Dialog$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Dialog$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Dialog$.prototype = $c_Lcom_iz2use_react_components_Dialog$.prototype;
$c_Lcom_iz2use_react_components_Dialog$.prototype.push__F0__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  return $m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lcom_iz2use_react_components_Dialog$Push($as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f).apply__O())))
});
$c_Lcom_iz2use_react_components_Dialog$.prototype.header__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(title) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_dialogHeader;
  var $$x7 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$9 = $m_s_$less$colon$less$();
  var array = [$n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(title, this$9.s_$less$colon$less$__f_singleton)];
  var $$x4 = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$15 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_dialogClose;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$15, s$1);
  var $$x1 = $m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline($m_Lcom_iz2use_react_components_Dialog$Pop$()));
  var array$1 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("button", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_close, "", "24px")];
  var array$2 = [$$x2, $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var array$3 = [$$x7, $$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  return $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
var $d_Lcom_iz2use_react_components_Dialog$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Dialog$: 0
}, false, "com.iz2use.react.components.Dialog$", {
  Lcom_iz2use_react_components_Dialog$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Dialog$.prototype.$classData = $d_Lcom_iz2use_react_components_Dialog$;
var $n_Lcom_iz2use_react_components_Dialog$;
function $m_Lcom_iz2use_react_components_Dialog$() {
  if ((!$n_Lcom_iz2use_react_components_Dialog$)) {
    $n_Lcom_iz2use_react_components_Dialog$ = new $c_Lcom_iz2use_react_components_Dialog$()
  };
  return $n_Lcom_iz2use_react_components_Dialog$
}
function $is_Lcom_iz2use_react_components_Dialog$Event(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_Dialog$Event)))
}
function $as_Lcom_iz2use_react_components_Dialog$Event(obj) {
  return (($is_Lcom_iz2use_react_components_Dialog$Event(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Dialog$Event"))
}
function $isArrayOf_Lcom_iz2use_react_components_Dialog$Event(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Dialog$Event)))
}
function $asArrayOf_Lcom_iz2use_react_components_Dialog$Event(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Dialog$Event(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Dialog$Event;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Dialog$Placeholder$() {
  this.Lcom_iz2use_react_components_Dialog$Placeholder$__f_component = null;
  $n_Lcom_iz2use_react_components_Dialog$Placeholder$ = this;
  var this$9 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DialogPlaceHolder", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_Dialog$Placeholder$Props(p$2);
    return $m_sci_Nil$()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_Dialog$Placeholder$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_Dialog$Placeholder$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_Dialog$Placeholder$Props__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_sci_List($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var listenable = new $c_sjsr_AnonFunction1(((x$3$3$2) => {
    $as_Lcom_iz2use_react_components_Dialog$Placeholder$Props(x$3$3$2);
    return $m_Lcom_iz2use_react_components_Dialog$Broadcaster$()
  }));
  var makeListener = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$2);
    return $n($as_Lcom_iz2use_react_components_Dialog$Placeholder$Backend($n(\u03b4).backend__O())).Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_handleEvent
  }));
  var evidence$3 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_ListenableF$();
  var this$8 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var f = $n($$x3).listen__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(listenable, makeListener, this$8.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync, evidence$3);
  this.Lcom_iz2use_react_components_Dialog$Placeholder$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$9))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_Dialog$Placeholder$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Dialog$Placeholder$.prototype.constructor = $c_Lcom_iz2use_react_components_Dialog$Placeholder$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Dialog$Placeholder$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Dialog$Placeholder$.prototype = $c_Lcom_iz2use_react_components_Dialog$Placeholder$.prototype;
$c_Lcom_iz2use_react_components_Dialog$Placeholder$.prototype.apply__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function() {
  var c = this.Lcom_iz2use_react_components_Dialog$Placeholder$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_Dialog$Placeholder$Props();
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_Dialog$Placeholder$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Dialog$Placeholder$: 0
}, false, "com.iz2use.react.components.Dialog$Placeholder$", {
  Lcom_iz2use_react_components_Dialog$Placeholder$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$.prototype.$classData = $d_Lcom_iz2use_react_components_Dialog$Placeholder$;
var $n_Lcom_iz2use_react_components_Dialog$Placeholder$;
function $m_Lcom_iz2use_react_components_Dialog$Placeholder$() {
  if ((!$n_Lcom_iz2use_react_components_Dialog$Placeholder$)) {
    $n_Lcom_iz2use_react_components_Dialog$Placeholder$ = new $c_Lcom_iz2use_react_components_Dialog$Placeholder$()
  };
  return $n_Lcom_iz2use_react_components_Dialog$Placeholder$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$() {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$__f_component = null;
  $n_Lcom_iz2use_react_components_FetchCacheAndRender$ = this;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$__f_component = this.typedComponent__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot()
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.fetch__Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__O__Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__Ljapgolly_scalajs_react_Reusable__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline = (function(props, criterion, state, dispatch, ec) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(($m_Ljapgolly_scalajs_react_Reusable$(), $n(dispatch).value__O()))).pending__O__Ljapgolly_scalajs_react_callback_Trampoline(criterion), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => $n($n($as_s_concurrent_Future($n($n(props).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_fetcher).apply__O__O(criterion))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((data$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(($m_Ljapgolly_scalajs_react_Reusable$(), $n(dispatch).value__O()))).success__O__O__Ljapgolly_scalajs_react_callback_Trampoline(criterion, data$2)))), ec)).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1(dispatch, criterion), ec))), ec))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.typedComponent__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function() {
  var this$8 = $m_Lcom_iz2use_react_hooks_package$();
  var this$5 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Props(props$2);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Lcom_iz2use_react_components_FetchCacheAndRender$().hook__F2__F2__s_concurrent_ExecutionContext__F1($n(props).Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_reusableC, $n(props).Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_reusableT, $n(props).Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_ec), $n(props).Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_request))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$4 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$4);
  var this$7 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$5, hook, step, d)));
  var f = new $c_sjsr_AnonFunction2(((props$3$2, state$2) => {
    var props$3 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Props(props$3$2);
    var state = $as_Ldiode_data_Pot(state$2);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(props$3).Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_renderFn).apply__O__O(state))
  }));
  var this$6 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$6);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$7, f, step$1, s);
  return new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$8, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("com.iz2use.react.components.FetchCacheAndRender.typedComponent"))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.reducer__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((s$2, a$2) => {
    var s = $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(s$2);
    var a = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Action(a$2);
    if ((a instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion)) {
      var x2 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion(a);
      var nextCriterion = $n(x2).Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion__f_nextCriterion;
      var this$2 = $n(s);
      var x$2 = this$2.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data;
      var this$3 = $n(s);
      var x$3 = this$3.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache;
      $n(s);
      return new $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(x$2, nextCriterion, x$3)
    } else if ((a instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending)) {
      var x3 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Pending(a);
      var criterion = $n(x3).Lcom_iz2use_react_components_FetchCacheAndRender$Pending__f_criterion;
      var y = $n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(criterion, y)) {
        $n(s);
        var data = $n($n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data).pending__J__Ldiode_data_Pot($n($n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data).pending$default$1__J());
        var this$5 = $n(s);
        var criterion$1 = this$5.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
        var this$6 = $n(s);
        var updateCache = this$6.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache;
        return new $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(data, criterion$1, updateCache)
      } else {
        return s
      }
    } else if ((a instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed)) {
      var x4 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Failed(a);
      var criterion$2 = $n(x4).Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_criterion;
      var throwable = $n(x4).Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_throwable;
      var y$1 = $n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(criterion$2, y$1)) {
        $n(s);
        var data$1 = $n($n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data).fail__jl_Throwable__Ldiode_data_Pot(throwable);
        var this$8 = $n(s);
        var criterion$3 = this$8.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
        var this$9 = $n(s);
        var updateCache$1 = this$9.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache;
        return new $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(data$1, criterion$3, updateCache$1)
      } else {
        return s
      }
    } else if ((a instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Success)) {
      var x5 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Success(a);
      var criterion$3$1 = $n(x5).Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_criterion;
      var data$2 = $n(x5).Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_data;
      var y$2 = $n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(criterion$3$1, y$2)) {
        $n(s);
        $n($n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data);
        var this$11 = $n($n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data);
        if (this$11.isEmpty__Z()) {
          var value = data$2
        } else {
          var arg1 = this$11.get__O();
          var value = $n($n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache).apply__O__O__O(arg1, data$2)
        };
        var data$3 = new $c_Ldiode_data_Ready(value);
        var this$13 = $n(s);
        var criterion$4 = this$13.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
        var this$14 = $n(s);
        var updateCache$2 = this$14.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache;
        return new $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(data$3, criterion$4, updateCache$2)
      } else {
        return s
      }
    } else if ((a instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache)) {
      var x6 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache(a);
      var nextUpdateCache = $n(x6).Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache__f_nextUpdateCache;
      var this$16 = $n(s);
      var x$5 = this$16.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data;
      var this$17 = $n(s);
      var x$6 = this$17.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
      $n(s);
      return new $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(x$5, x$6, nextUpdateCache)
    } else if ((a instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache)) {
      var x7 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache(a);
      var value$1 = $n(x7).Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache__f_value;
      $n(s);
      $n($n(s).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data);
      var data$4 = new $c_Ldiode_data_Ready(value$1);
      var this$20 = $n(s);
      var criterion$5 = this$20.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
      var this$21 = $n(s);
      var updateCache$3 = this$21.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache;
      return new $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(data$4, criterion$5, updateCache$3)
    } else {
      throw new $c_s_MatchError(a)
    }
  }))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.hook__F2__F2__s_concurrent_ExecutionContext__F1 = (function(reusableC, reusableT, ec) {
  var this$5 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var reducer = new $c_sjsr_AnonFunction1(((props$2) => {
    $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(props$2);
    return $m_Lcom_iz2use_react_components_FetchCacheAndRender$().reducer__F2()
  }));
  var initialState = new $c_sjsr_AnonFunction1(((props$3$2) => {
    var props$3 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(props$3$2);
    return new $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState($m_Ldiode_data_Empty$(), $n(props$3).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_criterion, $n(props$3).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_updateCache)
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$8 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducerBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$5, reducer, initialState, step)));
  var deps = new $c_sjsr_AnonFunction2(((props$4$2, reducer$2) => {
    $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(props$4$2);
    var reducer$1 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$2);
    return $n(reducer$1).Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_originalDispatch
  }));
  var create = new $c_sjsr_AnonFunction2(((props$5$2, reducer$3$2) => {
    $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(props$5$2);
    var reducer$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$3$2);
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      $as_Ljapgolly_scalajs_react_Reusable(x$1$2);
      return new $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1(reducer$3)
    }))
  }));
  var r = $m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2();
  var this$7 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$7);
  var this$12 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$8, deps, create, r, step$1)));
  var deps$1 = new $c_sjsr_AnonFunction3(((props$6$2, x$2$2, x$3$2) => {
    var props$6 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(props$6$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$2$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$3$2);
    return $n(props$6).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_updateCache
  }));
  var effect = new $c_sjsr_AnonFunction3(((props$7$2, reducer$4$2, x$4$2) => {
    var props$7 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(props$7$2);
    var reducer$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$4$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$4$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_F2(x$5$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(reducer$4).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache($n(props$7).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_updateCache))).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$10 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r$1 = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$10.byRef__F2(), this$10.by_$eq$eq__F2());
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$11);
  var this$18 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$12, deps$1, effect, a, r$1, step$2)));
  var deps$2 = new $c_sjsr_AnonFunction3(((props$8$2, state$2, x$6$2) => {
    var props$8 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(props$8$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$6$2);
    return $n(props$8).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_criterion
  }));
  var effect$1 = new $c_sjsr_AnonFunction3(((props$9$2, state$3$2, dispatcher$2) => {
    var props$9 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(props$9$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$3$2);
    var dispatcher = $as_Ljapgolly_scalajs_react_Reusable(dispatcher$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      var $$x4 = $n($n(props$9).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_expandQuery);
      var this$13 = $n(state$3);
      var nextCriterion = $n($$x4).apply__O__O__O($n($as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(this$13.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion, $n(props$9).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_criterion);
      var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x6 = $n($as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(($m_Ljapgolly_scalajs_react_Reusable$(), $n(dispatcher).value__O()))).newCriterion__O__Ljapgolly_scalajs_react_callback_Trampoline(nextCriterion);
      var $$x5 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
      var this$15 = $n(state$3);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x7).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x6, $n($$x5).fetch__Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__O__Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__Ljapgolly_scalajs_react_Reusable__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(props$9, nextCriterion, $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(this$15.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0]), dispatcher, ec)))
    }))
  }));
  var a$1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$17 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$17);
  var this$23 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$18, deps$2, effect$1, a$1, reusableC, step$3)));
  var initialState$1 = new $c_sjsr_AnonFunction3(((x$8$2, x$9$2, dispatcher$3$2) => {
    $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(x$8$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$9$2);
    var dispatcher$3 = $as_Ljapgolly_scalajs_react_Reusable(dispatcher$3$2);
    $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
    var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x8;
        var p2 = $as_s_Option(x1.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x = $m_s_None$();
        if ((x === p2)) {
          var $$x8 = cb;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1.T2__f__1);
        var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v = $n(x5).s_Some__f_value;
          var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(($m_Ljapgolly_scalajs_react_Reusable$(), $n(dispatcher$3).value__O()))).update__O__Ljapgolly_scalajs_react_callback_Trampoline(v), cb$2);
          break matchEnd7
        };
        throw new $c_s_MatchError(x1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x8)
    }));
    return new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn($m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f))
  }));
  var this$22 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$22);
  var $$x3 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$23, initialState$1, step$4)));
  var $$x1 = new $c_sjsr_AnonFunction4(((x$10$2, state$4$2, x$11$2, stateSnapshot$2) => {
    $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(x$10$2);
    var state$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$4$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$11$2);
    var stateSnapshot = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(stateSnapshot$2);
    var this$24 = $n(state$4);
    return $n($n($as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(this$24.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$12$2) => {
      var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
      var this$25 = $n(stateSnapshot);
      return $n($$x2).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($n($as_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn(this$25.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])).Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn__f_japgolly$scalajs$react$extra$internal$StateSnapshot$withReuse$FromSetStateFn$$set, x$12$2, reusableT)
    })))
  }));
  var this$26 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x3).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44(this$26))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(query, fetcher, renderFn, reusableC, reusableT, ec) {
  return this.range__O__F2__F1__F2__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(query, new $c_sjsr_AnonFunction2(((a$2, b$2) => b$2)), fetcher, new $c_sjsr_AnonFunction2(((a$3$2, b$3$2) => b$3$2)), renderFn, reusableC, reusableT, ec)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.range__O__F2__F1__F2__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(query, expandQuery, fetcher, updateCache, renderFn, reusableC, reusableT, ec) {
  var c = this.Lcom_iz2use_react_components_FetchCacheAndRender$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_FetchCacheAndRender$Props(renderFn, new $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(query, expandQuery, fetcher, updateCache), reusableC, reusableT, ec);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(fetcher, renderFn, reusableT, ec) {
  var $$x1 = new $c_sjsr_AnonFunction1(((x$13$2) => {
    $as_jl_Void(x$13$2);
    return $as_s_concurrent_Future($n(fetcher).apply__O())
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  return this.query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot((void 0), $$x1, renderFn, this$2.always__F2(), reusableT, ec)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.withKey__T__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_vdom_VdomElement = (function(key, fetcher, renderFn, reusableT, ec) {
  var $$x2 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x1 = new $c_sjsr_AnonFunction1(((x$14$2) => {
    $as_jl_Void(x$14$2);
    return $as_s_concurrent_Future($n(fetcher).apply__O())
  }));
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  var u = this.query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot((void 0), $$x1, renderFn, this$5.always__F2(), reusableT, ec);
  var this$7 = $n(u);
  var n = this$7.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  return $n($$x2).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(key, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$", {
  Lcom_iz2use_react_components_FetchCacheAndRender$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$;
var $n_Lcom_iz2use_react_components_FetchCacheAndRender$;
function $m_Lcom_iz2use_react_components_FetchCacheAndRender$() {
  if ((!$n_Lcom_iz2use_react_components_FetchCacheAndRender$)) {
    $n_Lcom_iz2use_react_components_FetchCacheAndRender$ = new $c_Lcom_iz2use_react_components_FetchCacheAndRender$()
  };
  return $n_Lcom_iz2use_react_components_FetchCacheAndRender$
}
function $is_Lcom_iz2use_react_components_FetchCacheAndRender$Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$Action)))
}
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$Action(obj) {
  return (($is_Lcom_iz2use_react_components_FetchCacheAndRender$Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$Action"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$Action)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Action(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$Action;", depth))
}
function $is_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher)))
}
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(obj) {
  return (($is_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$QueryDispatcher"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$QueryDispatcher;", depth))
}
function $is_Lcom_iz2use_react_components_FormContext(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_FormContext)))
}
function $as_Lcom_iz2use_react_components_FormContext(obj) {
  return (($is_Lcom_iz2use_react_components_FormContext(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FormContext"))
}
function $isArrayOf_Lcom_iz2use_react_components_FormContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FormContext)))
}
function $asArrayOf_Lcom_iz2use_react_components_FormContext(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FormContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FormContext;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_FormContext$() {
  this.Lcom_iz2use_react_components_FormContext$__f_context = null;
  this.Lcom_iz2use_react_components_FormContext$__f_provide = null;
  $n_Lcom_iz2use_react_components_FormContext$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_React$();
  var defaultValue = $m_Lcom_iz2use_react_components_FormContext$Empty$();
  this.Lcom_iz2use_react_components_FormContext$__f_context = $n(this$1.Ljapgolly_scalajs_react_React$__f_Context).apply__T__O__Ljapgolly_scalajs_react_feature_Context("FormContext", defaultValue);
  this.Lcom_iz2use_react_components_FormContext$__f_provide = new $c_sjsr_AnonFunction1(((value$2) => {
    var value = $as_Lcom_iz2use_react_components_FormContext(value$2);
    var this$3 = $n($m_Lcom_iz2use_react_components_FormContext$().Lcom_iz2use_react_components_FormContext$__f_context);
    return $f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$3, value)
  }));
  new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    var this$4 = $n($m_Lcom_iz2use_react_components_FormContext$().Lcom_iz2use_react_components_FormContext$__f_context);
    return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$4, f)
  }))
}
$c_Lcom_iz2use_react_components_FormContext$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FormContext$.prototype.constructor = $c_Lcom_iz2use_react_components_FormContext$;
/** @constructor */
function $h_Lcom_iz2use_react_components_FormContext$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FormContext$.prototype = $c_Lcom_iz2use_react_components_FormContext$.prototype;
var $d_Lcom_iz2use_react_components_FormContext$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_FormContext$: 0
}, false, "com.iz2use.react.components.FormContext$", {
  Lcom_iz2use_react_components_FormContext$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_FormContext$.prototype.$classData = $d_Lcom_iz2use_react_components_FormContext$;
var $n_Lcom_iz2use_react_components_FormContext$;
function $m_Lcom_iz2use_react_components_FormContext$() {
  if ((!$n_Lcom_iz2use_react_components_FormContext$)) {
    $n_Lcom_iz2use_react_components_FormContext$ = new $c_Lcom_iz2use_react_components_FormContext$()
  };
  return $n_Lcom_iz2use_react_components_FormContext$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Gesture$() {
  this.Lcom_iz2use_react_components_Gesture$__f_component = null;
  $n_Lcom_iz2use_react_components_Gesture$ = this;
  var this$6 = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Gesture", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_Gesture$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_Gesture$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_Gesture$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_Gesture$Props__jl_Void__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_jl_Void($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)), $n(x$3).propsChildren__sjs_js_Any())
  }))));
  var f = $m_Ljapgolly_scalajs_react_extra_OnUnmount$().install__F1();
  var this$9 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$6)));
  var f$1 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$2);
    var $$x3 = $as_Lcom_iz2use_react_components_Gesture$Backend($n(\u03b4).backend__O());
    var this$7 = $n(\u03b4);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).initHammer__Lcom_iz2use_react_components_Gesture$Props__Ljapgolly_scalajs_react_callback_Trampoline($as_Lcom_iz2use_react_components_Gesture$Props($n(this$7.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lcom_iz2use_react_components_Gesture$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$9, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$1, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_Gesture$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Gesture$.prototype.constructor = $c_Lcom_iz2use_react_components_Gesture$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Gesture$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Gesture$.prototype = $c_Lcom_iz2use_react_components_Gesture$.prototype;
$c_Lcom_iz2use_react_components_Gesture$.prototype.apply__sci_Seq__F1__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(events, cbo, children) {
  var c = this.Lcom_iz2use_react_components_Gesture$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_Gesture$Props(events, cbo);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lcom_iz2use_react_components_Gesture$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Gesture$: 0
}, false, "com.iz2use.react.components.Gesture$", {
  Lcom_iz2use_react_components_Gesture$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Gesture$.prototype.$classData = $d_Lcom_iz2use_react_components_Gesture$;
var $n_Lcom_iz2use_react_components_Gesture$;
function $m_Lcom_iz2use_react_components_Gesture$() {
  if ((!$n_Lcom_iz2use_react_components_Gesture$)) {
    $n_Lcom_iz2use_react_components_Gesture$ = new $c_Lcom_iz2use_react_components_Gesture$()
  };
  return $n_Lcom_iz2use_react_components_Gesture$
}
function $is_Lcom_iz2use_react_components_Gesture$GestureType(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_Gesture$GestureType)))
}
function $as_Lcom_iz2use_react_components_Gesture$GestureType(obj) {
  return (($is_Lcom_iz2use_react_components_Gesture$GestureType(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Gesture$GestureType"))
}
function $isArrayOf_Lcom_iz2use_react_components_Gesture$GestureType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Gesture$GestureType)))
}
function $asArrayOf_Lcom_iz2use_react_components_Gesture$GestureType(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Gesture$GestureType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Gesture$GestureType;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Gesture$GestureType$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Gesture$GestureType$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Gesture$GestureType$.prototype.constructor = $c_Lcom_iz2use_react_components_Gesture$GestureType$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Gesture$GestureType$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Gesture$GestureType$.prototype = $c_Lcom_iz2use_react_components_Gesture$GestureType$.prototype;
$c_Lcom_iz2use_react_components_Gesture$GestureType$.prototype.unapply__T__s_Option = (function(in$1) {
  var this$1 = $n(in$1);
  var x1 = $as_T(this$1.toLowerCase());
  switch (x1) {
    case "swipeleft": {
      return new $c_s_Some($m_Lcom_iz2use_react_components_Gesture$SwipeLeft$());
      break
    }
    case "swiperight": {
      return new $c_s_Some($m_Lcom_iz2use_react_components_Gesture$SwipeRight$());
      break
    }
    default: {
      return $m_s_None$()
    }
  }
});
var $d_Lcom_iz2use_react_components_Gesture$GestureType$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Gesture$GestureType$: 0
}, false, "com.iz2use.react.components.Gesture$GestureType$", {
  Lcom_iz2use_react_components_Gesture$GestureType$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Gesture$GestureType$.prototype.$classData = $d_Lcom_iz2use_react_components_Gesture$GestureType$;
var $n_Lcom_iz2use_react_components_Gesture$GestureType$;
function $m_Lcom_iz2use_react_components_Gesture$GestureType$() {
  if ((!$n_Lcom_iz2use_react_components_Gesture$GestureType$)) {
    $n_Lcom_iz2use_react_components_Gesture$GestureType$ = new $c_Lcom_iz2use_react_components_Gesture$GestureType$()
  };
  return $n_Lcom_iz2use_react_components_Gesture$GestureType$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Icon$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Icon$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Icon$.prototype.constructor = $c_Lcom_iz2use_react_components_Icon$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Icon$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Icon$.prototype = $c_Lcom_iz2use_react_components_Icon$.prototype;
$c_Lcom_iz2use_react_components_Icon$.prototype.apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf = (function(source, label, size) {
  var $$x3 = $n($n(source).render__Ljapgolly_scalajs_react_vdom_TagOf());
  var $$x2 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(label, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$5 = $n(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(size, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  $m_sc_StringOps$();
  var this$4 = $n(size);
  var condition = (!(this$4 === ""));
  var $$x1 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$5, condition);
  var this$10 = $n(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(size, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  $m_sc_StringOps$();
  var this$9 = $n(size);
  var condition$1 = (!(this$9 === ""));
  var array = [$$x2, $$x1, $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$10, condition$1)];
  return $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_Icon$.prototype.conditional__Z__Lcom_iz2use_react_components_IconSource__Lcom_iz2use_react_components_IconSource__T__T__T__Ljapgolly_scalajs_react_vdom_TagOf = (function(condition, iconIfTrue, iconIfFalse, labelIfTrue, labelIfFalse, size) {
  return (condition ? this.apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf(iconIfTrue, labelIfTrue, size) : this.apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf(iconIfFalse, labelIfFalse, size))
});
var $d_Lcom_iz2use_react_components_Icon$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Icon$: 0
}, false, "com.iz2use.react.components.Icon$", {
  Lcom_iz2use_react_components_Icon$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Icon$.prototype.$classData = $d_Lcom_iz2use_react_components_Icon$;
var $n_Lcom_iz2use_react_components_Icon$;
function $m_Lcom_iz2use_react_components_Icon$() {
  if ((!$n_Lcom_iz2use_react_components_Icon$)) {
    $n_Lcom_iz2use_react_components_Icon$ = new $c_Lcom_iz2use_react_components_Icon$()
  };
  return $n_Lcom_iz2use_react_components_Icon$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_IconSource$() {
  this.Lcom_iz2use_react_components_IconSource$__f_add = null;
  this.Lcom_iz2use_react_components_IconSource$__f_arrowLeft = null;
  this.Lcom_iz2use_react_components_IconSource$__f_arrowRight = null;
  this.Lcom_iz2use_react_components_IconSource$__f_assignmentLate = null;
  this.Lcom_iz2use_react_components_IconSource$__f_assignmentTurnedIn = null;
  this.Lcom_iz2use_react_components_IconSource$__f_chat = null;
  this.Lcom_iz2use_react_components_IconSource$__f_checkbox = null;
  this.Lcom_iz2use_react_components_IconSource$__f_checkboxChecked = null;
  this.Lcom_iz2use_react_components_IconSource$__f_checkboxIndeterminate = null;
  this.Lcom_iz2use_react_components_IconSource$__f_close = null;
  this.Lcom_iz2use_react_components_IconSource$__f_cloudDone = null;
  this.Lcom_iz2use_react_components_IconSource$__f_cloudOff = null;
  this.Lcom_iz2use_react_components_IconSource$__f_cloudQueue = null;
  this.Lcom_iz2use_react_components_IconSource$__f_create = null;
  this.Lcom_iz2use_react_components_IconSource$__f_delete = null;
  this.Lcom_iz2use_react_components_IconSource$__f_done = null;
  this.Lcom_iz2use_react_components_IconSource$__f_dynamicFeed = null;
  this.Lcom_iz2use_react_components_IconSource$__f_expandLess = null;
  this.Lcom_iz2use_react_components_IconSource$__f_expandMore = null;
  this.Lcom_iz2use_react_components_IconSource$__f_factCheck = null;
  this.Lcom_iz2use_react_components_IconSource$__f_ignore = null;
  this.Lcom_iz2use_react_components_IconSource$__f_link = null;
  this.Lcom_iz2use_react_components_IconSource$__f_localShipment = null;
  this.Lcom_iz2use_react_components_IconSource$__f_pending = null;
  this.Lcom_iz2use_react_components_IconSource$__f_pendingActions = null;
  this.Lcom_iz2use_react_components_IconSource$__f_pinDrop = null;
  this.Lcom_iz2use_react_components_IconSource$__f_recordVoiceOver = null;
  this.Lcom_iz2use_react_components_IconSource$__f_rule = null;
  this.Lcom_iz2use_react_components_IconSource$__f_search = null;
  this.Lcom_iz2use_react_components_IconSource$__f_shoppingCart = null;
  this.Lcom_iz2use_react_components_IconSource$__f_store = null;
  this.Lcom_iz2use_react_components_IconSource$__f_timeToLeave = null;
  this.Lcom_iz2use_react_components_IconSource$__f_thumbDown = null;
  this.Lcom_iz2use_react_components_IconSource$__f_thumbUp = null;
  this.Lcom_iz2use_react_components_IconSource$__f_unknown = null;
  this.Lcom_iz2use_react_components_IconSource$__f_viewList = null;
  this.Lcom_iz2use_react_components_IconSource$__f_visibility = null;
  this.Lcom_iz2use_react_components_IconSource$__f_visibilityOff = null;
  this.Lcom_iz2use_react_components_IconSource$__f_warehouse = null;
  $n_Lcom_iz2use_react_components_IconSource$ = this;
  this.Lcom_iz2use_react_components_IconSource$__f_add = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z");
  this.Lcom_iz2use_react_components_IconSource$__f_arrowLeft = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"));
  this.Lcom_iz2use_react_components_IconSource$__f_arrowRight = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z");
  this.Lcom_iz2use_react_components_IconSource$__f_assignmentLate = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z");
  this.Lcom_iz2use_react_components_IconSource$__f_assignmentTurnedIn = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"));
  this.Lcom_iz2use_react_components_IconSource$__f_chat = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z");
  this.Lcom_iz2use_react_components_IconSource$__f_checkbox = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"));
  this.Lcom_iz2use_react_components_IconSource$__f_checkboxChecked = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"));
  this.Lcom_iz2use_react_components_IconSource$__f_checkboxIndeterminate = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"));
  this.Lcom_iz2use_react_components_IconSource$__f_close = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z");
  this.Lcom_iz2use_react_components_IconSource$__f_cloudDone = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z");
  this.Lcom_iz2use_react_components_IconSource$__f_cloudOff = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"));
  this.Lcom_iz2use_react_components_IconSource$__f_cloudQueue = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z");
  this.Lcom_iz2use_react_components_IconSource$__f_create = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z");
  this.Lcom_iz2use_react_components_IconSource$__f_delete = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"));
  this.Lcom_iz2use_react_components_IconSource$__f_done = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19.77 5.03l1.4 1.4L8.43 19.17l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 5.03m0-2.83L8.43 13.54l-4.2-4.2L0 13.57 8.43 22 24 6.43 19.77 2.2z");
  this.Lcom_iz2use_react_components_IconSource$__f_dynamicFeed = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M8,8H6v7c0,1.1,0.9,2,2,2h9v-2H8V8z M20,3h-8c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V5C22,3.9,21.1,3,20,3z M20,11h-8V7h8V11z M4,12H2v7c0,1.1,0.9,2,2,2h9v-2H4V12z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z");
  this.Lcom_iz2use_react_components_IconSource$__f_expandLess = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"));
  this.Lcom_iz2use_react_components_IconSource$__f_expandMore = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"));
  this.Lcom_iz2use_react_components_IconSource$__f_factCheck = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M20,3H4C2.9,3,2,3.9,2,5v14c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V5 C22,3.9,21.1,3,20,3z M10,17H5v-2h5V17z M10,13H5v-2h5V13z M10,9H5V7h5V9z M14.82,15L12,12.16l1.41-1.41l1.41,1.42L17.99,9 l1.42,1.42L14.82,15z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M8.1 20H16v-3q0-1.6-1.2-2.8-1-1.2-2.7-1.2-1.6 0-2.7 1.2Q8 15.4 8 17.1zm3.9-9q1.6 0 2.7-1.2Q16 8.6 16 6.9V4H8v3q0 1.7 1.2 2.9 1 1.2 2.7 1.2ZM4.5 21.5v-1.4h2.2v-3q0-1.7.9-3 .9-1.5 2.4-2.1-1.5-.6-2.4-2-.9-1.4-.9-3V4H4.5V2.4h15v1.4h-2.2v3q0 1.7-.9 3-.9 1.5-2.4 2.1 1.5.6 2.4 2 .9 1.4.9 3v3h2.2v1.5z");
  this.Lcom_iz2use_react_components_IconSource$__f_ignore = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6h-4c0 1.62-1.38 3-3 3s-3-1.38-3-3H5V5h14v4zm-4 7h6v3c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z");
  this.Lcom_iz2use_react_components_IconSource$__f_link = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z");
  this.Lcom_iz2use_react_components_IconSource$__f_localShipment = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M4.4 19.5q-.8 0-1.4-.5-.5-.6-.5-1.4V6.4q0-.8.5-1.4.6-.5 1.4-.5h15.2q.8 0 1.4.5.5.6.5 1.4v11.2q0 .8-.5 1.4-.6.5-1.4.5zM12 13 4.4 8.2v9.4h15.2V8.2Zm0-1.8 7.6-4.7H4.4ZM4.4 8.2V6.4v11.2Z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z");
  this.Lcom_iz2use_react_components_IconSource$__f_pending = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M7,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C8.5,12.83,7.83,13.5,7,13.5z M12,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C13.5,12.83,12.83,13.5,12,13.5z M17,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C18.5,12.83,17.83,13.5,17,13.5z"));
  this.Lcom_iz2use_react_components_IconSource$__f_pendingActions = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M17,12c-2.76,0-5,2.24-5,5s2.24,5,5,5c2.76,0,5-2.24,5-5S19.76,12,17,12z M18.65,19.35l-2.15-2.15V14h1v2.79l1.85,1.85 L18.65,19.35z M18,3h-3.18C14.4,1.84,13.3,1,12,1S9.6,1.84,9.18,3H6C4.9,3,4,3.9,4,5v15c0,1.1,0.9,2,2,2h6.11 c-0.59-0.57-1.07-1.25-1.42-2H6V5h2v3h8V5h2v5.08c0.71,0.1,1.38,0.31,2,0.6V5C20,3.9,19.1,3,18,3z M12,5c-0.55,0-1-0.45-1-1 c0-0.55,0.45-1,1-1c0.55,0,1,0.45,1,1C13,4.55,12.55,5,12,5z"));
  this.Lcom_iz2use_react_components_IconSource$__f_pinDrop = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M1.5 17.6v-2.2q0-.9.4-1.5.4-.7 1.2-1 1.4-.7 3-1 1.4-.5 3-.5 1.2 0 2.4.3l2.4.6-.5.6-.4.6-2-.5q-.9-.2-1.9-.2-1.4 0-2.8.4l-2.6 1q-.4 0-.6.4l-.2.8v.8H12v.7l.1.7zM9 16.2zm0-6.2q-1.5 0-2.5-1t-1-2.6q0-1.5 1-2.5t2.5-1q1.5 0 2.6 1 1 1 1 2.5t-1 2.5q-1 1-2.6 1zm0-1.5q1 0 1.5-.6.7-.6.7-1.5T10.6 5q-.6-.6-1.5-.6t-1.5.6Q7 5.5 7 6.4q0 1 .6 1.5.6.6 1.5.6zm0-2zm8.6 0q0 1.4-1 2.4T14 10h-.6l-.5-.1q.6-.7.9-1.6l.2-1.8q0-1-.3-1.8-.2-.9-.8-1.6l.5-.1h.6q1.5 0 2.6 1 1 1 1 2.5zM18 21q-1.9 0-3.2-1.3-1.3-1.3-1.3-3.2 0-1.8 1.3-3.2 1.3-1.3 3.2-1.3 1.9 0 3.2 1.3 1.3 1.4 1.3 3.3 0 1.8-1.3 3.1T18 21.1Zm-1-2.5 3.3-3.2-.5-.5-2.7 2.7-1.3-1.4-.6.5z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z");
  this.Lcom_iz2use_react_components_IconSource$__f_recordVoiceOver = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z M13,9 A4,4 0 0 1 9,13 4,4 0 0 1 5,9 4,4 0 0 1 9,5 4,4 0 0 1 13,9z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M11 7h2v2.92l6.91 6.91 1.09-1.1V8.27L15.73 3H8.27L7.18 4.1 11 7.92zm11.27 14.73l-20-20.01L1 2.99l3.64 3.64L3 8.27v7.46L8.27 21h7.46l1.64-1.63L21 23l1.27-1.27zM12 17.3c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z");
  this.Lcom_iz2use_react_components_IconSource$__f_rule = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M16.54,11L13,7.46l1.41-1.41l2.12,2.12l4.24-4.24l1.41,1.41L16.54,11z M11,7H2v2h9V7z M21,13.41L19.59,12L17,14.59 L14.41,12L13,13.41L15.59,16L13,18.59L14.41,20L17,17.41L19.59,20L21,18.59L18.41,16L21,13.41z M11,15H2v2h9V15z"));
  this.Lcom_iz2use_react_components_IconSource$__f_search = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M3 19.5v-15L21 12zm1.4-2.2 13-5.3-13-5.4v4l5.8 1.4-5.8 1.4zm0 0V6.6Z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M19.1 13a7 7 0 0 0 0-2l2-1.5c.2-.2.3-.4.2-.6l-2-3.3a.5.5 0 0 0-.5-.3l-2.4 1a7 7 0 0 0-1.6-1l-.4-2.5c0-.2-.2-.4-.5-.4h-3.8c-.3 0-.4.2-.5.4l-.3 2.5-1.7 1-2.4-1c-.2 0-.4 0-.5.3l-2 3.3c0 .2 0 .4.2.6l2 1.6-.1.9v1l-2 1.5c-.1.2-.2.4 0 .6l1.8 3.3c.2.3.4.3.6.3l2.4-1 1.6 1 .4 2.5c0 .2.2.4.5.4h3.8c.3 0 .5-.2.5-.4l.4-2.6 1.6-.9 2.4 1c.2 0 .4 0 .6-.3l1.9-3.3-.1-.6-2-1.6zM12 15.5a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2z");
  this.Lcom_iz2use_react_components_IconSource$__f_shoppingCart = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"));
  this.Lcom_iz2use_react_components_IconSource$__f_store = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M22,8l-4-4v3H3v2h15v3L22,8z M2,16l4,4v-3h15v-2H6v-3L2,16z");
  this.Lcom_iz2use_react_components_IconSource$__f_timeToLeave = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"));
  this.Lcom_iz2use_react_components_IconSource$__f_thumbDown = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"));
  this.Lcom_iz2use_react_components_IconSource$__f_thumbUp = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M 45,5 H 27 v 6 H 45 Z M 33,44 h 6 V 26 h -6 z m 24,-20 4,-4 c -1,-2 -3,-3 -4,-4 l -4,4 c -5,-4 -10,-6 -17,-6 -15,0 -27,12 -27,27 0,15 12,27 27,27 C 51,68 63,55 63,41 63,34 61,28 57,24 Z M 36,62 c -12,0 -21,-9 -21,-21 0,-12 9,-21 21,-21 12,0 21,9 21,21 0,12 -9,21 -21,21 z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z");
  this.Lcom_iz2use_react_components_IconSource$__f_unknown = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M3 15h8v-2H3v2zm0 4h8v-2H3v2zm0-8h8V9H3v2zm0-6v2h8V5H3zm10 0h8v14h-8V5z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z");
  this.Lcom_iz2use_react_components_IconSource$__f_viewList = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"));
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M4 18h17v-6H4v6zM4 5v6h17V5H4z");
  $m_Lcom_iz2use_react_components_IconSource$();
  new $c_Lcom_iz2use_react_components_IconSourceShape("M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z");
  this.Lcom_iz2use_react_components_IconSource$__f_visibility = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"));
  this.Lcom_iz2use_react_components_IconSource$__f_visibilityOff = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"));
  this.Lcom_iz2use_react_components_IconSource$__f_warehouse = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M12 3L2 12L5 12L5 20L19 20L19 12L22 12L12 3z M6 11L9 11L9 13L6 13L6 11z M6 14L9 14L9 16L6 16L6 14z M10 14L13 14L13 16L10 16L10 14z M6 17L9 17L9 19L6 19L6 17z M10 17L13 17L13 19L10 19L10 17z M14 17L17 17L17 19L14 19L14 17z "))
}
$c_Lcom_iz2use_react_components_IconSource$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_IconSource$.prototype.constructor = $c_Lcom_iz2use_react_components_IconSource$;
/** @constructor */
function $h_Lcom_iz2use_react_components_IconSource$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_IconSource$.prototype = $c_Lcom_iz2use_react_components_IconSource$.prototype;
var $d_Lcom_iz2use_react_components_IconSource$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_IconSource$: 0
}, false, "com.iz2use.react.components.IconSource$", {
  Lcom_iz2use_react_components_IconSource$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_IconSource$.prototype.$classData = $d_Lcom_iz2use_react_components_IconSource$;
var $n_Lcom_iz2use_react_components_IconSource$;
function $m_Lcom_iz2use_react_components_IconSource$() {
  if ((!$n_Lcom_iz2use_react_components_IconSource$)) {
    $n_Lcom_iz2use_react_components_IconSource$ = new $c_Lcom_iz2use_react_components_IconSource$()
  };
  return $n_Lcom_iz2use_react_components_IconSource$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Layout$() {
  this.Lcom_iz2use_react_components_Layout$__f_vertical = null;
  this.Lcom_iz2use_react_components_Layout$__f_horizontal = null;
  $n_Lcom_iz2use_react_components_Layout$ = this;
  this.Lcom_iz2use_react_components_Layout$__f_vertical = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).justChildren__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $n($as_Ljapgolly_scalajs_react_PropsChildren(c$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var this$2 = $m_Lcom_iz2use_react_components_StyleConsumer$();
    var arg1 = this$2.Lcom_iz2use_react_components_StyleConsumer$__f_style;
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$5 = $m_Lscalacss_ScalaCssReact$();
    var s = $n(arg1).Lcom_iz2use_react_style_Style__f_verticalLayout;
    var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c))];
    return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })));
  this.Lcom_iz2use_react_components_Layout$__f_horizontal = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).justChildren__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $n($as_Ljapgolly_scalajs_react_PropsChildren(c$3$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var this$12 = $m_Lcom_iz2use_react_components_StyleConsumer$();
    var arg1$1 = this$12.Lcom_iz2use_react_components_StyleConsumer$__f_style;
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$15 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $n(arg1$1).Lcom_iz2use_react_style_Style__f_horizontalLayout;
    var array$1 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$15, s$1), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c$3))];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  })))
}
$c_Lcom_iz2use_react_components_Layout$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Layout$.prototype.constructor = $c_Lcom_iz2use_react_components_Layout$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Layout$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Layout$.prototype = $c_Lcom_iz2use_react_components_Layout$.prototype;
var $d_Lcom_iz2use_react_components_Layout$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Layout$: 0
}, false, "com.iz2use.react.components.Layout$", {
  Lcom_iz2use_react_components_Layout$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Layout$.prototype.$classData = $d_Lcom_iz2use_react_components_Layout$;
var $n_Lcom_iz2use_react_components_Layout$;
function $m_Lcom_iz2use_react_components_Layout$() {
  if ((!$n_Lcom_iz2use_react_components_Layout$)) {
    $n_Lcom_iz2use_react_components_Layout$ = new $c_Lcom_iz2use_react_components_Layout$()
  };
  return $n_Lcom_iz2use_react_components_Layout$
}
function $p_Lcom_iz2use_react_components_Link$__go$1__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($thiz, e, f$1) {
  var this$ = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$().asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(($m_Ljapgolly_scalajs_react_package$(), f$1), e);
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Link$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Link$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Link$.prototype.constructor = $c_Lcom_iz2use_react_components_Link$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Link$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Link$.prototype = $c_Lcom_iz2use_react_components_Link$.prototype;
$c_Lcom_iz2use_react_components_Link$.prototype.apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf = (function(f) {
  var $$x1 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$());
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$3 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$3.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#"), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lcom_iz2use_react_components_Link$__go$1__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this, e$2, f)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lcom_iz2use_react_components_Link$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Link$: 0
}, false, "com.iz2use.react.components.Link$", {
  Lcom_iz2use_react_components_Link$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Link$.prototype.$classData = $d_Lcom_iz2use_react_components_Link$;
var $n_Lcom_iz2use_react_components_Link$;
function $m_Lcom_iz2use_react_components_Link$() {
  if ((!$n_Lcom_iz2use_react_components_Link$)) {
    $n_Lcom_iz2use_react_components_Link$ = new $c_Lcom_iz2use_react_components_Link$()
  };
  return $n_Lcom_iz2use_react_components_Link$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_LinkedView$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_LinkedView$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_LinkedView$.prototype.constructor = $c_Lcom_iz2use_react_components_LinkedView$;
/** @constructor */
function $h_Lcom_iz2use_react_components_LinkedView$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_LinkedView$.prototype = $c_Lcom_iz2use_react_components_LinkedView$.prototype;
$c_Lcom_iz2use_react_components_LinkedView$.prototype.withKey__T__Ljapgolly_scalajs_react_vdom_VdomNode__I__Z__Z__F1__s_PartialFunction__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagOf = (function(key, view, index, isReduced, reducedSize, toggleSize, close, style) {
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(style).Lcom_iz2use_react_style_Style__f_linkedView;
  var $$x12 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var $$x11 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(key, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  if (isReduced) {
    var this$4 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $n(style).Lcom_iz2use_react_style_Style__f_linkedViewReducedContainer;
    var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1)
  } else {
    var this$5 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $n(style).Lcom_iz2use_react_style_Style__f_linkedViewActiveContainer;
    var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s$2)
  };
  var this$6 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $n(style).Lcom_iz2use_react_style_Style__f_linkedViewReducedSize;
  var this$7 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s$3));
  var $$x9 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$7, reducedSize);
  if ($n(close).isDefinedAt__O__Z(index)) {
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$10 = $m_Lscalacss_ScalaCssReact$();
    var s$4 = $n(style).Lcom_iz2use_react_style_Style__f_linkedViewClose;
    var $$x7 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s$4);
    var $$x6 = $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_arrowLeft, "", "24px");
    var $$x5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(close).apply__O__O(index))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    var this$12 = $m_Lscalacss_ScalaCssReact$();
    var s$5 = $n(style).Lcom_iz2use_react_style_Style__f_linkedViewCloseIcon;
    var array = [$$x5, $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$12, s$5)];
    var array$1 = [$$x7, $n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var $$x4 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  } else {
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var c = $m_Lcom_iz2use_react_components_Layout$().Lcom_iz2use_react_components_Layout$__f_horizontal;
  var this$35 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$22 = $m_Lscalacss_ScalaCssReact$();
  var s$6 = $n(style).Lcom_iz2use_react_style_Style__f_linkedViewContent;
  var array$2 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$22, s$6), view];
  var $$x2 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$28 = $m_Lscalacss_ScalaCssReact$();
  var s$7 = $n(style).Lcom_iz2use_react_style_Style__f_linkedViewReducer;
  var array$3 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$28, s$7), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(toggleSize).apply__O__O(index))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var array$4 = [$$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var children = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$35.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$35.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children));
  var this$37 = $n(u);
  var n = this$37.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$5 = [$$x12, $$x11, $$x10, $$x9, $$x4, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
});
var $d_Lcom_iz2use_react_components_LinkedView$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_LinkedView$: 0
}, false, "com.iz2use.react.components.LinkedView$", {
  Lcom_iz2use_react_components_LinkedView$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_LinkedView$.prototype.$classData = $d_Lcom_iz2use_react_components_LinkedView$;
var $n_Lcom_iz2use_react_components_LinkedView$;
function $m_Lcom_iz2use_react_components_LinkedView$() {
  if ((!$n_Lcom_iz2use_react_components_LinkedView$)) {
    $n_Lcom_iz2use_react_components_LinkedView$ = new $c_Lcom_iz2use_react_components_LinkedView$()
  };
  return $n_Lcom_iz2use_react_components_LinkedView$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_LinkedViews$() {
  this.Lcom_iz2use_react_components_LinkedViews$__f_component = null;
  $n_Lcom_iz2use_react_components_LinkedViews$ = this;
  this.Lcom_iz2use_react_components_LinkedViews$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("LinkedViews", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_LinkedViews$Props(p$2);
    return $m_s_package$().s_package$__f_Nil
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_LinkedViews$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_LinkedViews$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_LinkedViews$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_LinkedViews$Props__sci_List__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_sci_List($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)), $n(x$3).propsChildren__sjs_js_Any())
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_LinkedViews$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_LinkedViews$.prototype.constructor = $c_Lcom_iz2use_react_components_LinkedViews$;
/** @constructor */
function $h_Lcom_iz2use_react_components_LinkedViews$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_LinkedViews$.prototype = $c_Lcom_iz2use_react_components_LinkedViews$.prototype;
$c_Lcom_iz2use_react_components_LinkedViews$.prototype.apply__sci_Seq__s_PartialFunction__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(children, close) {
  var c = this.Lcom_iz2use_react_components_LinkedViews$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_LinkedViews$Props(close);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lcom_iz2use_react_components_LinkedViews$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_LinkedViews$: 0
}, false, "com.iz2use.react.components.LinkedViews$", {
  Lcom_iz2use_react_components_LinkedViews$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_LinkedViews$.prototype.$classData = $d_Lcom_iz2use_react_components_LinkedViews$;
var $n_Lcom_iz2use_react_components_LinkedViews$;
function $m_Lcom_iz2use_react_components_LinkedViews$() {
  if ((!$n_Lcom_iz2use_react_components_LinkedViews$)) {
    $n_Lcom_iz2use_react_components_LinkedViews$ = new $c_Lcom_iz2use_react_components_LinkedViews$()
  };
  return $n_Lcom_iz2use_react_components_LinkedViews$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Media$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Media$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Media$.prototype.constructor = $c_Lcom_iz2use_react_components_Media$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Media$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Media$.prototype = $c_Lcom_iz2use_react_components_Media$.prototype;
$c_Lcom_iz2use_react_components_Media$.prototype.page__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_TagOf = (function(node) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_paperPage;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_paperPageContent;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$1), node];
  var array$1 = [$$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lcom_iz2use_react_components_Media$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Media$: 0
}, false, "com.iz2use.react.components.Media$", {
  Lcom_iz2use_react_components_Media$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Media$.prototype.$classData = $d_Lcom_iz2use_react_components_Media$;
var $n_Lcom_iz2use_react_components_Media$;
function $m_Lcom_iz2use_react_components_Media$() {
  if ((!$n_Lcom_iz2use_react_components_Media$)) {
    $n_Lcom_iz2use_react_components_Media$ = new $c_Lcom_iz2use_react_components_Media$()
  };
  return $n_Lcom_iz2use_react_components_Media$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_MultiviewRefiner() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_MultiviewRefiner.prototype = new $h_O();
$c_Lcom_iz2use_react_components_MultiviewRefiner.prototype.constructor = $c_Lcom_iz2use_react_components_MultiviewRefiner;
/** @constructor */
function $h_Lcom_iz2use_react_components_MultiviewRefiner() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_MultiviewRefiner.prototype = $c_Lcom_iz2use_react_components_MultiviewRefiner.prototype;
function $as_Lcom_iz2use_react_components_MultiviewRefiner(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_MultiviewRefiner) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.MultiviewRefiner"))
}
function $isArrayOf_Lcom_iz2use_react_components_MultiviewRefiner(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_MultiviewRefiner)))
}
function $asArrayOf_Lcom_iz2use_react_components_MultiviewRefiner(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_MultiviewRefiner(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.MultiviewRefiner;", depth))
}
function $p_Lcom_iz2use_react_components_MultiviewRefiner$__traverse__sci_List__Lcom_iz2use_react_components_NextRefinerRenderer__Lcom_iz2use_react_components_internal_multiview_HasIterator__F2__F1__Lcom_iz2use_react_components_NextRefinerRenderer($thiz, in$1, lastRenderer, iterable, reusabilityT, reusabilityC) {
  while (true) {
    var x1 = in$1;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      return lastRenderer
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var refiner = $as_Lcom_iz2use_react_components_MultiviewRefiner($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      var temp$lastRenderer = new $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent(refiner, lastRenderer, iterable, reusabilityT, reusabilityC);
      in$1 = tail;
      lastRenderer = temp$lastRenderer
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lcom_iz2use_react_components_MultiviewRefiner$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_MultiviewRefiner$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_MultiviewRefiner$.prototype.constructor = $c_Lcom_iz2use_react_components_MultiviewRefiner$;
/** @constructor */
function $h_Lcom_iz2use_react_components_MultiviewRefiner$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_MultiviewRefiner$.prototype = $c_Lcom_iz2use_react_components_MultiviewRefiner$.prototype;
var $d_Lcom_iz2use_react_components_MultiviewRefiner$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_MultiviewRefiner$: 0
}, false, "com.iz2use.react.components.MultiviewRefiner$", {
  Lcom_iz2use_react_components_MultiviewRefiner$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_MultiviewRefiner$.prototype.$classData = $d_Lcom_iz2use_react_components_MultiviewRefiner$;
var $n_Lcom_iz2use_react_components_MultiviewRefiner$;
function $m_Lcom_iz2use_react_components_MultiviewRefiner$() {
  if ((!$n_Lcom_iz2use_react_components_MultiviewRefiner$)) {
    $n_Lcom_iz2use_react_components_MultiviewRefiner$ = new $c_Lcom_iz2use_react_components_MultiviewRefiner$()
  };
  return $n_Lcom_iz2use_react_components_MultiviewRefiner$
}
function $f_Lcom_iz2use_react_components_Platform__isMobile__Z($thiz) {
  $m_sc_StringOps$();
  var isMobileRegex = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), ".*(android|bb|blackberry|ipad|iphone|ipod|meego|mobile|opera mini|windows.+(mobile|phone)|webos).*", $m_sci_Nil$());
  var $$x1 = console;
  var this$3 = $n($as_T(window.navigator.userAgent));
  $$x1.log($as_T(this$3.toLowerCase()));
  var this$4 = $n($as_T(window.navigator.userAgent));
  var x1 = $as_T(this$4.toLowerCase());
  if ((x1 !== null)) {
    var o8 = isMobileRegex.unapplySeq__jl_CharSequence__s_Option(x1);
    if ((!$n(o8).isEmpty__Z())) {
      return true
    }
  };
  return false
}
function $is_Lcom_iz2use_react_components_Platform(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_Platform)))
}
function $as_Lcom_iz2use_react_components_Platform(obj) {
  return (($is_Lcom_iz2use_react_components_Platform(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Platform"))
}
function $isArrayOf_Lcom_iz2use_react_components_Platform(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Platform)))
}
function $asArrayOf_Lcom_iz2use_react_components_Platform(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Platform(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Platform;", depth))
}
function $p_Lcom_iz2use_react_components_PlatformDependent$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("PlatformDependent", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_PlatformDependent$TypedProps(p$2);
    return $n($n(p).Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_f).apply__O__O($m_Lcom_iz2use_react_components_Platform$())
  })))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_PlatformDependent$() {
  this.Lcom_iz2use_react_components_PlatformDependent$__f_component = null;
  $n_Lcom_iz2use_react_components_PlatformDependent$ = this;
  this.Lcom_iz2use_react_components_PlatformDependent$__f_component = $n($n($n($p_Lcom_iz2use_react_components_PlatformDependent$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_PlatformDependent$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    $n($as_Lcom_iz2use_react_components_PlatformDependent$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var p = $as_Lcom_iz2use_react_components_PlatformDependent$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    var s = $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_render).apply__O__O(s))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_PlatformDependent$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_PlatformDependent$.prototype.constructor = $c_Lcom_iz2use_react_components_PlatformDependent$;
/** @constructor */
function $h_Lcom_iz2use_react_components_PlatformDependent$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_PlatformDependent$.prototype = $c_Lcom_iz2use_react_components_PlatformDependent$.prototype;
$c_Lcom_iz2use_react_components_PlatformDependent$.prototype.apply__F1__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(f, render) {
  var c = this.Lcom_iz2use_react_components_PlatformDependent$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_PlatformDependent$TypedProps(f, render);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_PlatformDependent$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_PlatformDependent$: 0
}, false, "com.iz2use.react.components.PlatformDependent$", {
  Lcom_iz2use_react_components_PlatformDependent$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_PlatformDependent$.prototype.$classData = $d_Lcom_iz2use_react_components_PlatformDependent$;
var $n_Lcom_iz2use_react_components_PlatformDependent$;
function $m_Lcom_iz2use_react_components_PlatformDependent$() {
  if ((!$n_Lcom_iz2use_react_components_PlatformDependent$)) {
    $n_Lcom_iz2use_react_components_PlatformDependent$ = new $c_Lcom_iz2use_react_components_PlatformDependent$()
  };
  return $n_Lcom_iz2use_react_components_PlatformDependent$
}
function $f_Lcom_iz2use_react_components_Selector__itemClass__Lcom_iz2use_react_components_Selector$ItemState__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagMod($thiz, state, style) {
  var x = $m_Lcom_iz2use_react_components_Selector$Active$();
  if ((x === state)) {
    return ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $m_Ljapgolly_scalajs_react_vdom_Attr$ClassName$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("active", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
  } else {
    var x$3 = $m_Lcom_iz2use_react_components_Selector$Focused$();
    if ((x$3 === state)) {
      return ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $m_Ljapgolly_scalajs_react_vdom_Attr$ClassName$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("focused", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
    } else {
      return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
    }
  }
}
function $f_Lcom_iz2use_react_components_Selector__wrapList__sci_Seq__sci_Seq($thiz, items) {
  return ($n(items).isEmpty__Z() ? $m_Lcom_iz2use_react_components_Selector$().Lcom_iz2use_react_components_Selector$__f_emptyList : items)
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$() {
  this.Lcom_iz2use_react_components_Selector$__f_emptyList = null;
  this.Lcom_iz2use_react_components_Selector$__f_component = null;
  $n_Lcom_iz2use_react_components_Selector$ = this;
  var $$x2 = $m_s_package$().s_package$__f_Seq;
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("vide"))];
  var array$1 = [$n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  this.Lcom_iz2use_react_components_Selector$__f_emptyList = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
  this.Lcom_iz2use_react_components_Selector$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Selector", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_Selector$TypedProps(p$2);
    return $m_s_None$()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_Selector$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x4 = $n($as_Lcom_iz2use_react_components_Selector$TypedBackend($n(x$3).backend__O()));
    var this$12 = $n(x$3);
    var $$x3 = $as_Lcom_iz2use_react_components_Selector$TypedProps($n(this$12.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$13 = $n(x$3);
    return $n($$x4).render__Lcom_iz2use_react_components_Selector$TypedProps__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement($$x3, $as_s_Option($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$13)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_Selector$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$.prototype = $c_Lcom_iz2use_react_components_Selector$.prototype;
$c_Lcom_iz2use_react_components_Selector$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1__F1__Lcom_iz2use_react_components_Selector$Focusable__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_Selector__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(items, active, label, deleteable, renderItem, modifier, ev, keyMapper, out) {
  var c = this.Lcom_iz2use_react_components_Selector$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_Selector$TypedProps(items, active, renderItem, modifier, label, deleteable, ev, out, keyMapper);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lcom_iz2use_react_components_Selector$.prototype.apply$default$6__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1 = (function(items, active, label, deleteable) {
  return new $c_sjsr_AnonFunction1(((x$16$2) => $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom))
});
var $d_Lcom_iz2use_react_components_Selector$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$: 0
}, false, "com.iz2use.react.components.Selector$", {
  Lcom_iz2use_react_components_Selector$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Selector$.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$;
var $n_Lcom_iz2use_react_components_Selector$;
function $m_Lcom_iz2use_react_components_Selector$() {
  if ((!$n_Lcom_iz2use_react_components_Selector$)) {
    $n_Lcom_iz2use_react_components_Selector$ = new $c_Lcom_iz2use_react_components_Selector$()
  };
  return $n_Lcom_iz2use_react_components_Selector$
}
function $is_Lcom_iz2use_react_components_Selector$ItemState(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_Selector$ItemState)))
}
function $as_Lcom_iz2use_react_components_Selector$ItemState(obj) {
  return (($is_Lcom_iz2use_react_components_Selector$ItemState(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Selector$ItemState"))
}
function $isArrayOf_Lcom_iz2use_react_components_Selector$ItemState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Selector$ItemState)))
}
function $asArrayOf_Lcom_iz2use_react_components_Selector$ItemState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Selector$ItemState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Selector$ItemState;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$ItemState$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Selector$ItemState$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$ItemState$.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$ItemState$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$ItemState$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$ItemState$.prototype = $c_Lcom_iz2use_react_components_Selector$ItemState$.prototype;
$c_Lcom_iz2use_react_components_Selector$ItemState$.prototype.from__Z__Z__s_Product = (function(focused, active) {
  return (focused ? $m_Lcom_iz2use_react_components_Selector$Focused$() : (active ? $m_Lcom_iz2use_react_components_Selector$Active$() : $m_Lcom_iz2use_react_components_Selector$Idle$()))
});
var $d_Lcom_iz2use_react_components_Selector$ItemState$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$ItemState$: 0
}, false, "com.iz2use.react.components.Selector$ItemState$", {
  Lcom_iz2use_react_components_Selector$ItemState$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Selector$ItemState$.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$ItemState$;
var $n_Lcom_iz2use_react_components_Selector$ItemState$;
function $m_Lcom_iz2use_react_components_Selector$ItemState$() {
  if ((!$n_Lcom_iz2use_react_components_Selector$ItemState$)) {
    $n_Lcom_iz2use_react_components_Selector$ItemState$ = new $c_Lcom_iz2use_react_components_Selector$ItemState$()
  };
  return $n_Lcom_iz2use_react_components_Selector$ItemState$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_SideBySideLayout$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_SideBySideLayout$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_SideBySideLayout$.prototype.constructor = $c_Lcom_iz2use_react_components_SideBySideLayout$;
/** @constructor */
function $h_Lcom_iz2use_react_components_SideBySideLayout$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_SideBySideLayout$.prototype = $c_Lcom_iz2use_react_components_SideBySideLayout$.prototype;
$c_Lcom_iz2use_react_components_SideBySideLayout$.prototype.apply__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(containerStyle, children) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_sideBySideLayoutContainer;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$7 = $m_s_$less$colon$less$();
  var array = [$$x2, containerStyle, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(children, this$7.s_$less$colon$less$__f_singleton)];
  return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lcom_iz2use_react_components_SideBySideLayout$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_SideBySideLayout$: 0
}, false, "com.iz2use.react.components.SideBySideLayout$", {
  Lcom_iz2use_react_components_SideBySideLayout$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_SideBySideLayout$.prototype.$classData = $d_Lcom_iz2use_react_components_SideBySideLayout$;
var $n_Lcom_iz2use_react_components_SideBySideLayout$;
function $m_Lcom_iz2use_react_components_SideBySideLayout$() {
  if ((!$n_Lcom_iz2use_react_components_SideBySideLayout$)) {
    $n_Lcom_iz2use_react_components_SideBySideLayout$ = new $c_Lcom_iz2use_react_components_SideBySideLayout$()
  };
  return $n_Lcom_iz2use_react_components_SideBySideLayout$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Skeleton$() {
  this.Lcom_iz2use_react_components_Skeleton$__f_skeletonList = null;
  this.Lcom_iz2use_react_components_Skeleton$__f_skeletonLink = null;
  $n_Lcom_iz2use_react_components_Skeleton$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lcom_iz2use_react_components_Skeleton$__f_skeletonList = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x3 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1fr")));
    $n(dsl);
    var a$1 = $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_gridGap;
    var array = [$$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, ".25em")))];
    return $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })), new $c_Lsourcecode_Name("skeletonList"));
  var this$17 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$1 = "div";
  this.Lcom_iz2use_react_components_Skeleton$__f_skeletonLink = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$17, v$1)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x9 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var $$x8 = $m_Lscalacss_internal_Attrs$borderBottom$();
    $n(dsl$3);
    $n(dsl$3);
    var this$ = 1;
    var u = $m_Lscalacss_internal_LengthUnit$px$();
    var f$1 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl$3);
    $n(dsl$3);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl$3);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var $$x7 = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    $n(dsl$3);
    $n(dsl$3);
    var f$3 = $m_Lscalacss_internal_Literal$Typed$solid$();
    $n(dsl$3);
    $n(dsl$3);
    var this$29 = $m_Lscalacss_internal_ValueT$Rule$();
    var ab$1 = this$29.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lscalacss_internal_Literal(x$2$2);
      return $n(x$2).Lscalacss_internal_Literal__f_value
    })));
    $n(dsl$3);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$1)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
    var r$1 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var $$x6 = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$3);
    $n(dsl$3);
    $n(dsl$3);
    var f$5 = new $c_Lscalacss_internal_ValueT("grey");
    $n(dsl$3);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
      var x$1$3 = $as_Lscalacss_internal_ValueT(x$1$2$2);
      return $n(x$1$3)
    }));
    var r$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x8.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x7, $$x6, r$2.apply__O__Lscalacss_internal_ValueT(f$5))));
    $n(dsl$3);
    var this$48 = $m_Lscalacss_internal_Attrs$marginBottom$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$1 = 0.25;
    var u$1 = $m_Lscalacss_internal_LengthUnit$em$();
    var f$7 = new $c_Lscalacss_internal_Length(this$$1, u$1);
    $n(dsl$3);
    $n(dsl$3);
    var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      var x$3$1 = $as_Lscalacss_internal_Length(x$3$2$1);
      return $n(x$3$1).value__T()
    })));
    $n(dsl$3);
    var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
      var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$3);
      return $n(x$1$4)
    }));
    var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
    var r$3 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
    var v$2 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$7);
    var v$3 = $n(v$2).Lscalacss_internal_ValueT__f_value;
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$48.Lscalacss_internal_Attrs$marginBottom$__f_attr, v$3)));
    $n(dsl$3);
    var this$50 = $m_Lscalacss_internal_Attrs$width$();
    var array$1 = [$$x5, $$x4, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$50.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "fit-content")))];
    return $as_sci_Seq($n($$x9).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })), new $c_Lsourcecode_Name("skeletonLink"))
}
$c_Lcom_iz2use_react_components_Skeleton$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Skeleton$.prototype.constructor = $c_Lcom_iz2use_react_components_Skeleton$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Skeleton$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Skeleton$.prototype = $c_Lcom_iz2use_react_components_Skeleton$.prototype;
$c_Lcom_iz2use_react_components_Skeleton$.prototype.list__I__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(size, repeat) {
  return $m_Lcom_iz2use_react_components_Skeleton$RandomSize$().apply__I__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(size, new $c_sjsr_AnonFunction1(((size$2$2) => {
    var size$2 = $uI(size$2$2);
    var $$x3 = $n($m_Lcom_iz2use_react_components_Skeleton$().Lcom_iz2use_react_components_Skeleton$__f_skeletonList);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var isEmpty = (size$2 <= 0);
    var scala$collection$immutable$Range$$lastElement = (((-1) + size$2) | 0);
    var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
      $uI(x$2$2);
      var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$10 = $m_s_$less$colon$less$();
      return $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(repeat, this$10.s_$less$colon$less$__f_singleton)
    }));
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_TagMod$();
    var this$12 = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
    var array = [$n($$x2).fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sc_Iterator$$anon$9(this$12, f))];
    return $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })))
});
$c_Lcom_iz2use_react_components_Skeleton$.prototype.link__I__Ljapgolly_scalajs_react_vdom_TagOf = (function(chars) {
  var $$x1 = $n(this.Lcom_iz2use_react_components_Skeleton$__f_skeletonLink);
  var u = this.text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(chars);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_Skeleton$.prototype.text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(chars) {
  return $m_Lcom_iz2use_react_components_Skeleton$RandomSize$().apply__I__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(chars, new $c_sjsr_AnonFunction1(((chars$2$2) => {
    var chars$2 = $uI(chars$2$2);
    var this$2 = $m_Lcom_iz2use_react_components_StyleConsumer$();
    var arg1 = this$2.Lcom_iz2use_react_components_StyleConsumer$__f_style;
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$5 = $m_Lscalacss_ScalaCssReact$();
    var s = $n(arg1).Lcom_iz2use_react_style_Style__f_skeletonText;
    var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((chars$2 + "em"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })))
});
var $d_Lcom_iz2use_react_components_Skeleton$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Skeleton$: 0
}, false, "com.iz2use.react.components.Skeleton$", {
  Lcom_iz2use_react_components_Skeleton$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Skeleton$.prototype.$classData = $d_Lcom_iz2use_react_components_Skeleton$;
var $n_Lcom_iz2use_react_components_Skeleton$;
function $m_Lcom_iz2use_react_components_Skeleton$() {
  if ((!$n_Lcom_iz2use_react_components_Skeleton$)) {
    $n_Lcom_iz2use_react_components_Skeleton$ = new $c_Lcom_iz2use_react_components_Skeleton$()
  };
  return $n_Lcom_iz2use_react_components_Skeleton$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Skeleton$RandomSize$() {
  this.Lcom_iz2use_react_components_Skeleton$RandomSize$__f_component = null;
  $n_Lcom_iz2use_react_components_Skeleton$RandomSize$ = this;
  var this$15 = $m_Lcom_iz2use_react_hooks_package$();
  var this$11 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var initialState = new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Lcom_iz2use_react_components_Skeleton$RandomSize$Props(ctx$2);
    var size = $n(ctx).Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_size;
    var delta = ((size / 4) | 0);
    $m_Ljapgolly_scalajs_react_Reusable$();
    var r = $n(ctx).Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_f;
    var $$x1 = $as_F1($n(r).value__O());
    var x = (2.0 * ($uD(Math.random()) * delta));
    var this$9 = $m_RTLong$();
    var value = $uD(Math.round(x));
    var lo = this$9.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($$x1).apply__O__O(((((size + lo) | 0) - delta) | 0)))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$14 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useStateBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$11, initialState, step)));
  var f = new $c_sjsr_AnonFunction2(((x$1$2, result$2) => {
    $as_Lcom_iz2use_react_components_Skeleton$RandomSize$Props(x$1$2);
    var result = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(result$2);
    var this$12 = $n(result);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode(this$12.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])
  }));
  var this$13 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$13);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$14, f, step$1, s);
  this.Lcom_iz2use_react_components_Skeleton$RandomSize$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$15, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("com.iz2use.react.components.Skeleton.RandomSize.component"))
}
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$.prototype.constructor = $c_Lcom_iz2use_react_components_Skeleton$RandomSize$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Skeleton$RandomSize$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Skeleton$RandomSize$.prototype = $c_Lcom_iz2use_react_components_Skeleton$RandomSize$.prototype;
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$.prototype.apply__I__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(size, f) {
  var c = this.Lcom_iz2use_react_components_Skeleton$RandomSize$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props(size, $m_Ljapgolly_scalajs_react_Reusable$fn$().apply__F1__Ljapgolly_scalajs_react_Reusable(f));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_Skeleton$RandomSize$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Skeleton$RandomSize$: 0
}, false, "com.iz2use.react.components.Skeleton$RandomSize$", {
  Lcom_iz2use_react_components_Skeleton$RandomSize$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$.prototype.$classData = $d_Lcom_iz2use_react_components_Skeleton$RandomSize$;
var $n_Lcom_iz2use_react_components_Skeleton$RandomSize$;
function $m_Lcom_iz2use_react_components_Skeleton$RandomSize$() {
  if ((!$n_Lcom_iz2use_react_components_Skeleton$RandomSize$)) {
    $n_Lcom_iz2use_react_components_Skeleton$RandomSize$ = new $c_Lcom_iz2use_react_components_Skeleton$RandomSize$()
  };
  return $n_Lcom_iz2use_react_components_Skeleton$RandomSize$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_StateProvider$() {
  this.Lcom_iz2use_react_components_StateProvider$__f_component = null;
  $n_Lcom_iz2use_react_components_StateProvider$ = this;
  this.Lcom_iz2use_react_components_StateProvider$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("StateProvider", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_StateProvider$TypedProps(p$2);
    return $n($n(p).Lcom_iz2use_react_components_StateProvider$TypedProps__f_initial).value__O()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_StateProvider$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_StateProvider$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_StateProvider$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_StateProvider$TypedProps__O__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_StateProvider$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_StateProvider$.prototype.constructor = $c_Lcom_iz2use_react_components_StateProvider$;
/** @constructor */
function $h_Lcom_iz2use_react_components_StateProvider$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_StateProvider$.prototype = $c_Lcom_iz2use_react_components_StateProvider$.prototype;
$c_Lcom_iz2use_react_components_StateProvider$.prototype.apply__Ljapgolly_scalajs_react_Reusable__F1__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(init, render, reuseT) {
  var c = this.Lcom_iz2use_react_components_StateProvider$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_StateProvider$TypedProps(init, render, reuseT);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_StateProvider$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_StateProvider$: 0
}, false, "com.iz2use.react.components.StateProvider$", {
  Lcom_iz2use_react_components_StateProvider$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_StateProvider$.prototype.$classData = $d_Lcom_iz2use_react_components_StateProvider$;
var $n_Lcom_iz2use_react_components_StateProvider$;
function $m_Lcom_iz2use_react_components_StateProvider$() {
  if ((!$n_Lcom_iz2use_react_components_StateProvider$)) {
    $n_Lcom_iz2use_react_components_StateProvider$ = new $c_Lcom_iz2use_react_components_StateProvider$()
  };
  return $n_Lcom_iz2use_react_components_StateProvider$
}
function $ct_Lcom_iz2use_react_components_StateProvider$TypedBackend__($thiz) {
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$();
  var $$x1 = $thiz.Lcom_iz2use_react_components_StateProvider$Backend__f_$;
  var this$1 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$1.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  $thiz.Lcom_iz2use_react_components_StateProvider$TypedBackend__f_stateUpdater = $$x2.prepareVia__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_Reusable($$x1, w);
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_StateProvider$TypedBackend() {
  this.Lcom_iz2use_react_components_StateProvider$TypedBackend__f_stateUpdater = null
}
$c_Lcom_iz2use_react_components_StateProvider$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_StateProvider$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_StateProvider$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_StateProvider$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_StateProvider$TypedBackend.prototype = $c_Lcom_iz2use_react_components_StateProvider$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_StateProvider$TypedBackend.prototype.render__Lcom_iz2use_react_components_StateProvider$TypedProps__O__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lcom_iz2use_react_components_StateProvider$TypedProps__f_render).apply__O__O($m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$().apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this.Lcom_iz2use_react_components_StateProvider$TypedBackend__f_stateUpdater, s, $n(p).Lcom_iz2use_react_components_StateProvider$TypedProps__f_reuseT)))
});
function $as_Lcom_iz2use_react_components_StateProvider$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_StateProvider$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.StateProvider$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_StateProvider$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_StateProvider$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_StateProvider$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_StateProvider$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.StateProvider$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_StyleConsumer$() {
  this.Lcom_iz2use_react_components_StyleConsumer$__f_style = null
}
$c_Lcom_iz2use_react_components_StyleConsumer$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_StyleConsumer$.prototype.constructor = $c_Lcom_iz2use_react_components_StyleConsumer$;
/** @constructor */
function $h_Lcom_iz2use_react_components_StyleConsumer$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_StyleConsumer$.prototype = $c_Lcom_iz2use_react_components_StyleConsumer$.prototype;
var $d_Lcom_iz2use_react_components_StyleConsumer$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_StyleConsumer$: 0
}, false, "com.iz2use.react.components.StyleConsumer$", {
  Lcom_iz2use_react_components_StyleConsumer$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_StyleConsumer$.prototype.$classData = $d_Lcom_iz2use_react_components_StyleConsumer$;
var $n_Lcom_iz2use_react_components_StyleConsumer$;
function $m_Lcom_iz2use_react_components_StyleConsumer$() {
  if ((!$n_Lcom_iz2use_react_components_StyleConsumer$)) {
    $n_Lcom_iz2use_react_components_StyleConsumer$ = new $c_Lcom_iz2use_react_components_StyleConsumer$()
  };
  return $n_Lcom_iz2use_react_components_StyleConsumer$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_UserPreference$() {
  this.Lcom_iz2use_react_components_UserPreference$__f_component = null;
  $n_Lcom_iz2use_react_components_UserPreference$ = this;
  var this$11 = $n($n($n(this.typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_UserPreference$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_UserPreference$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_UserPreference$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_UserPreference$TypedProps__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_s_Option($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(c$2);
    var this$5 = $n(c);
    var ec = $n($as_Lcom_iz2use_react_components_UserPreference$TypedProps($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lcom_iz2use_react_components_UserPreference$TypedProps__f_ec;
    var this$6 = $n(c);
    var decoder = $n($as_Lcom_iz2use_react_components_UserPreference$TypedProps($n(this$6.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lcom_iz2use_react_components_UserPreference$TypedProps__f_decoder;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
      var this$7 = $n(c);
      var $$x3 = $n($as_Lcom_iz2use_react_components_UserPreference$TypedProps($n(this$7.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lcom_iz2use_react_components_UserPreference$TypedProps__f_store;
      var this$8 = $n(c);
      return $n($n($$x3).get__T__Lio_circe_Decoder__s_concurrent_Future($n($n($as_Lcom_iz2use_react_components_UserPreference$TypedProps($n(this$8.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lcom_iz2use_react_components_UserPreference$TypedProps__f_name).Lsourcecode_FullName__f_value, decoder)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((v$2) => {
        var v = $as_s_Option(v$2);
        var this$9 = $n(c);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$9, v))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      })), ec)
    })), ec))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lcom_iz2use_react_components_UserPreference$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$11, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillMount__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_UserPreference$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_UserPreference$.prototype.constructor = $c_Lcom_iz2use_react_components_UserPreference$;
/** @constructor */
function $h_Lcom_iz2use_react_components_UserPreference$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_UserPreference$.prototype = $c_Lcom_iz2use_react_components_UserPreference$.prototype;
$c_Lcom_iz2use_react_components_UserPreference$.prototype.typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2 = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("UserPreference", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_UserPreference$TypedProps(p$2);
    return $m_s_None$()
  })))
});
$c_Lcom_iz2use_react_components_UserPreference$.prototype.apply__F1__Lsourcecode_FullName__Lcom_iz2use_react_components_UserPreferenceStore__Lio_circe_Encoder__Lio_circe_Decoder__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(f, name, store, encoder, decoder, ec) {
  var c = this.Lcom_iz2use_react_components_UserPreference$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_UserPreference$TypedProps(f, name, store, encoder, decoder, ec);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_UserPreference$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_UserPreference$: 0
}, false, "com.iz2use.react.components.UserPreference$", {
  Lcom_iz2use_react_components_UserPreference$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_UserPreference$.prototype.$classData = $d_Lcom_iz2use_react_components_UserPreference$;
var $n_Lcom_iz2use_react_components_UserPreference$;
function $m_Lcom_iz2use_react_components_UserPreference$() {
  if ((!$n_Lcom_iz2use_react_components_UserPreference$)) {
    $n_Lcom_iz2use_react_components_UserPreference$ = new $c_Lcom_iz2use_react_components_UserPreference$()
  };
  return $n_Lcom_iz2use_react_components_UserPreference$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_WrapField$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_WrapField$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_WrapField$.prototype.constructor = $c_Lcom_iz2use_react_components_WrapField$;
/** @constructor */
function $h_Lcom_iz2use_react_components_WrapField$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_WrapField$.prototype = $c_Lcom_iz2use_react_components_WrapField$.prototype;
$c_Lcom_iz2use_react_components_WrapField$.prototype.apply__Ljapgolly_scalajs_react_vdom_TagMod__Z__sci_Seq__sci_Seq__Z__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(label, focused, infos, errors, empty, children) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_formField;
  var $$x19 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
  var this$5 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_formFieldNotEmpty;
  var this$6 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s$1));
  var condition = (!empty);
  var $$x18 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$6, condition);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n(arg1).Lcom_iz2use_react_style_Style__f_formFieldHasFocus;
  var this$8 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$2));
  var $$x17 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$8, focused);
  var this$9 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $n(arg1).Lcom_iz2use_react_style_Style__f_formFieldInvalid;
  var this$11 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$9, s$3));
  var this$10 = $n(errors);
  var condition$1 = (!this$10.isEmpty__Z());
  var $$x16 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$11, condition$1);
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$14 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $n(arg1).Lcom_iz2use_react_style_Style__f_formFieldInputWrapper;
  var $$x14 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$14, s$4);
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$17 = $m_s_$less$colon$less$();
  var $$x12 = $n($$x13).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(children, this$17.s_$less$colon$less$__f_singleton);
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$20 = $m_Lscalacss_ScalaCssReact$();
  var s$5 = $n(arg1).Lcom_iz2use_react_style_Style__f_formFieldLabelWrapper;
  var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$20, s$5);
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$23 = $m_Lscalacss_ScalaCssReact$();
  var s$6 = $n(arg1).Lcom_iz2use_react_style_Style__f_formFieldLabel;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$23, s$6), label];
  var array$1 = [$$x10, $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("label", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var array$2 = [$$x14, $$x12, $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var $$x8 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$35 = $m_Lscalacss_ScalaCssReact$();
  var s$7 = $n(arg1).Lcom_iz2use_react_style_Style__f_formFieldUnderline;
  var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$35, s$7);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$38 = $m_Lscalacss_ScalaCssReact$();
  var s$8 = $n(arg1).Lcom_iz2use_react_style_Style__f_formFieldUnderlineRipple;
  var array$3 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$38, s$8)];
  var array$4 = [$$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var $$x4 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$47 = $m_Lscalacss_ScalaCssReact$();
  var s$9 = $n(arg1).Lcom_iz2use_react_style_Style__f_formFieldSubscript;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$47, s$9);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$48 = $n($n(errors).headOption__s_Option());
  var o = (this$48.isEmpty__Z() ? $n(infos).headOption__s_Option() : this$48);
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O);
  var this$51 = $m_s_$less$colon$less$();
  var array$5 = [$$x2, $$x1.whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(this$51.s_$less$colon$less$__f_singleton)];
  var array$6 = [$$x19, $$x18, $$x17, $$x16, $$x8, $$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  return $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
});
var $d_Lcom_iz2use_react_components_WrapField$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_WrapField$: 0
}, false, "com.iz2use.react.components.WrapField$", {
  Lcom_iz2use_react_components_WrapField$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_WrapField$.prototype.$classData = $d_Lcom_iz2use_react_components_WrapField$;
var $n_Lcom_iz2use_react_components_WrapField$;
function $m_Lcom_iz2use_react_components_WrapField$() {
  if ((!$n_Lcom_iz2use_react_components_WrapField$)) {
    $n_Lcom_iz2use_react_components_WrapField$ = new $c_Lcom_iz2use_react_components_WrapField$()
  };
  return $n_Lcom_iz2use_react_components_WrapField$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_Optioner() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_Optioner.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_Optioner.prototype.constructor = $c_Lcom_iz2use_react_components_internal_Optioner;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_Optioner() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_Optioner.prototype = $c_Lcom_iz2use_react_components_internal_Optioner.prototype;
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  if ((b$1$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  if ((b$2$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$lzycompute$2__sr_LazyRef__F2($thiz, b$1$lzy$2) {
  if ((b$1$lzy$2 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$1$lzy$2).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($thiz.Lcom_iz2use_react_components_internal_ReusabilityImplicits$__f_tokenReuse);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$2).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$2__sr_LazyRef__F2($thiz, b$1$lzy$2) {
  return ($n(b$1$lzy$2).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$lzycompute$2__sr_LazyRef__F2($thiz, b$1$lzy$2))
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$lzycompute$2__sr_LazyRef__F2($thiz, b$2$lzy$2) {
  if ((b$2$lzy$2 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$2$lzy$2).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$2).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$2__sr_LazyRef__F2($thiz, b$2$lzy$2) {
  return ($n(b$2$lzy$2).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$lzycompute$2__sr_LazyRef__F2($thiz, b$2$lzy$2))
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$lzycompute$3__sr_LazyRef__F2($thiz, b$1$lzy$3) {
  if ((b$1$lzy$3 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$1$lzy$3).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$3).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($thiz.seqReusability__F2__F2($thiz.Lcom_iz2use_react_components_internal_ReusabilityImplicits$__f_tokenMatchReuse));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$3).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$3__sr_LazyRef__F2($thiz, b$1$lzy$3) {
  return ($n(b$1$lzy$3).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$3).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$lzycompute$3__sr_LazyRef__F2($thiz, b$1$lzy$3))
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$lzycompute$3__sr_LazyRef__F2($thiz, b$2$lzy$3) {
  if ((b$2$lzy$3 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$2$lzy$3).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$3).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().double__D__F2(0.001));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$3).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$3__sr_LazyRef__F2($thiz, b$2$lzy$3) {
  return ($n(b$2$lzy$3).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$3).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$lzycompute$3__sr_LazyRef__F2($thiz, b$2$lzy$3))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$() {
  this.Lcom_iz2use_react_components_internal_ReusabilityImplicits$__f_tokenReuse = null;
  this.Lcom_iz2use_react_components_internal_ReusabilityImplicits$__f_tokenMatchReuse = null;
  $n_Lcom_iz2use_react_components_internal_ReusabilityImplicits$ = this;
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lcom_iz2use_common_internal_tokenizer_Token(a$2);
    var b = $as_Lcom_iz2use_common_internal_tokenizer_Token(b$2);
    if ($uZ($n($p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_common_internal_tokenizer_Token__f_repr, $n(b).Lcom_iz2use_common_internal_tokenizer_Token__f_repr))) {
      var this$3 = $n($p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$1__sr_LazyRef__F2(this, b$2$lzy));
      var v1 = $n(a).Lcom_iz2use_common_internal_tokenizer_Token__f_start;
      var v2 = $n(b).Lcom_iz2use_common_internal_tokenizer_Token__f_start;
      var $$x1 = $uZ(this$3.apply__O__O__O(v1, v2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var this$4 = $n($p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$1__sr_LazyRef__F2(this, b$2$lzy));
      var v1$1 = $n(a).Lcom_iz2use_common_internal_tokenizer_Token__f_end;
      var v2$1 = $n(b).Lcom_iz2use_common_internal_tokenizer_Token__f_end;
      return $uZ(this$4.apply__O__O__O(v1$1, v2$1))
    } else {
      return false
    }
  }));
  elem = f;
  this.Lcom_iz2use_react_components_internal_ReusabilityImplicits$__f_tokenReuse = $n($$x3).$bar$bar$extension__F2__F2__F2($$x2, $as_F2(elem));
  var $$x5 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x4 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem$1 = null;
  elem$1 = null;
  var b$1$lzy$2 = new $c_sr_LazyRef();
  var b$2$lzy$2 = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction2(((a$3$2, b$3$2) => {
    var a$3 = $as_Lcom_iz2use_common_TokenMatch(a$3$2);
    var b$3 = $as_Lcom_iz2use_common_TokenMatch(b$3$2);
    if (($uZ($n($p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$2__sr_LazyRef__F2(this, b$1$lzy$2)).apply__O__O__O($n(a$3).Lcom_iz2use_common_TokenMatch__f_searchToken, $n(b$3).Lcom_iz2use_common_TokenMatch__f_searchToken)) && $uZ($n($p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$2__sr_LazyRef__F2(this, b$1$lzy$2)).apply__O__O__O($n(a$3).Lcom_iz2use_common_TokenMatch__f_itemToken, $n(b$3).Lcom_iz2use_common_TokenMatch__f_itemToken)))) {
      var this$7 = $n($p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$2__sr_LazyRef__F2(this, b$2$lzy$2));
      var v1$2 = $n(a$3).Lcom_iz2use_common_TokenMatch__f_index;
      var v2$2 = $n(b$3).Lcom_iz2use_common_TokenMatch__f_index;
      return $uZ(this$7.apply__O__O__O(v1$2, v2$2))
    } else {
      return false
    }
  }));
  elem$1 = f$1;
  this.Lcom_iz2use_react_components_internal_ReusabilityImplicits$__f_tokenMatchReuse = $n($$x5).$bar$bar$extension__F2__F2__F2($$x4, $as_F2(elem$1))
}
$c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_ReusabilityImplicits$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_ReusabilityImplicits$.prototype = $c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$.prototype;
$c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$.prototype.seqReusability__F2__F2 = (function(evidence$1) {
  return $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().byRef__F2(), $m_Ljapgolly_scalajs_react_Reusability$().byIterator__F2__F2(evidence$1))
});
$c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$.prototype.tokenMatchesReuse__F2 = (function() {
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lcom_iz2use_common_TokenMatches(a$2);
    var b = $as_Lcom_iz2use_common_TokenMatches(b$2);
    if ($uZ($n($p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$1$3__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_common_TokenMatches__f_matches, $n(b).Lcom_iz2use_common_TokenMatches__f_matches))) {
      var this$3 = $n($p_Lcom_iz2use_react_components_internal_ReusabilityImplicits$__b$2$3__sr_LazyRef__F2(this, b$2$lzy));
      var v1 = $n(a).Lcom_iz2use_common_TokenMatches__f_score;
      var v2 = $n(b).Lcom_iz2use_common_TokenMatches__f_score;
      return $uZ(this$3.apply__O__O__O(v1, v2))
    } else {
      return false
    }
  }));
  elem = f;
  return $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
});
$c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$.prototype.seqTokenizedReuse__F2 = (function() {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(x$1$2);
    return $n(x$1).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens
  }));
  var r = this.seqReusability__F2__F2(this.Lcom_iz2use_react_components_internal_ReusabilityImplicits$__f_tokenReuse);
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
});
var $d_Lcom_iz2use_react_components_internal_ReusabilityImplicits$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_ReusabilityImplicits$: 0
}, false, "com.iz2use.react.components.internal.ReusabilityImplicits$", {
  Lcom_iz2use_react_components_internal_ReusabilityImplicits$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_ReusabilityImplicits$;
var $n_Lcom_iz2use_react_components_internal_ReusabilityImplicits$;
function $m_Lcom_iz2use_react_components_internal_ReusabilityImplicits$() {
  if ((!$n_Lcom_iz2use_react_components_internal_ReusabilityImplicits$)) {
    $n_Lcom_iz2use_react_components_internal_ReusabilityImplicits$ = new $c_Lcom_iz2use_react_components_internal_ReusabilityImplicits$()
  };
  return $n_Lcom_iz2use_react_components_internal_ReusabilityImplicits$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_TokenizeSearch$() {
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$__f_propsReuse = null;
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_TokenizeSearch$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps(x$1$2);
    return $n(x$1).Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_search
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$__f_propsReuse = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  var this$10 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("TokenizeSearch", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps(p$2);
    return $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$().tokenize__T__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_SeqTokenized($n(p).Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_search, $n(p).Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_filter)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    $n($as_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    var p$1 = $as_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3);
    var s = $as_Lcom_iz2use_common_internal_tokenizer_SeqTokenized($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6));
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p$1).Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_renderFn).apply__O__O(s))
  }))));
  var f$1 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(\u03b4$2);
    var this$8 = $n(\u03b4);
    var newState = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$().tokenize__T__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_SeqTokenized($n($as_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps($n(\u03b4).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)).Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_search, $n($as_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps($n(\u03b4).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)).Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_filter);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$8, newState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$15 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$10, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$1, G));
  $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$1 = this.Lcom_iz2use_react_components_internal_TokenizeSearch$__f_propsReuse;
  var evidence$2 = $m_Lcom_iz2use_react_components_internal_ReusabilityImplicits$().seqTokenizedReuse__F2();
  var this$13 = $m_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$();
  var f$2 = $n(this$13.Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$__f_reusabilityOverrideInDev).apply__F2__F2__F1(evidence$1, evidence$2);
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$2).apply__O__O(this$15))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_TokenizeSearch$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_TokenizeSearch$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_TokenizeSearch$.prototype = $c_Lcom_iz2use_react_components_internal_TokenizeSearch$.prototype;
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$.prototype.apply__T__F1__Lcom_iz2use_common_Filter__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(search, renderFn, filter) {
  var c = this.Lcom_iz2use_react_components_internal_TokenizeSearch$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps(search, renderFn, filter);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_TokenizeSearch$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_TokenizeSearch$: 0
}, false, "com.iz2use.react.components.internal.TokenizeSearch$", {
  Lcom_iz2use_react_components_internal_TokenizeSearch$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_TokenizeSearch$;
var $n_Lcom_iz2use_react_components_internal_TokenizeSearch$;
function $m_Lcom_iz2use_react_components_internal_TokenizeSearch$() {
  if ((!$n_Lcom_iz2use_react_components_internal_TokenizeSearch$)) {
    $n_Lcom_iz2use_react_components_internal_TokenizeSearch$ = new $c_Lcom_iz2use_react_components_internal_TokenizeSearch$()
  };
  return $n_Lcom_iz2use_react_components_internal_TokenizeSearch$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$() {
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$ = this;
  var this$6 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("CheckboxComponent", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(false, false)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__Ljapgolly_scalajs_react_vdom_TagOf($$x1, $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var f = $m_Ljapgolly_scalajs_react_extra_OnUnmount$().install__F1();
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$6))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$.prototype = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$.prototype;
var $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent$: 0
}, false, "com.iz2use.react.components.internal.editor.CheckboxComponent$", {
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$;
var $n_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$;
function $m_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$() {
  if ((!$n_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$)) {
    $n_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$ = new $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$()
  };
  return $n_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$() {
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_editor_MultilineComponent$ = this;
  var this$9 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("MultilineComponent", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(new $c_Ldiode_data_Ready($n($n(p).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $m_s_None$(), $m_Ldiode_data_Empty$(), false, false, false)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Ljapgolly_scalajs_react_vdom_TagOf($$x1, $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(c$2);
    var $$x4 = $n($as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend($n(c).backend__O()));
    var this$6 = $n(c);
    var $$x3 = $n($$x4).setText__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__F1($as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps($n(this$6.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()));
    var this$7 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).apply__O__O($n($n($as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps($n(this$7.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$13 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$9, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillMount__Ljapgolly_scalajs_react_internal_Lens(), f, G));
  var f$1 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$3$2);
    var $$x6 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend($n(c$3).backend__O());
    var this$10 = $n(c$3);
    var $$x5 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$10));
    var this$11 = $n(c$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x6).onPropsChange__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($$x5, $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps($n(this$11.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()), $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps($n(c$3).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$14 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$13, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1));
  var f$2 = $m_Ljapgolly_scalajs_react_extra_OnUnmount$().install__F1();
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$2).apply__O__O(this$14))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$.prototype = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$.prototype;
var $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_MultilineComponent$: 0
}, false, "com.iz2use.react.components.internal.editor.MultilineComponent$", {
  Lcom_iz2use_react_components_internal_editor_MultilineComponent$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent$;
var $n_Lcom_iz2use_react_components_internal_editor_MultilineComponent$;
function $m_Lcom_iz2use_react_components_internal_editor_MultilineComponent$() {
  if ((!$n_Lcom_iz2use_react_components_internal_editor_MultilineComponent$)) {
    $n_Lcom_iz2use_react_components_internal_editor_MultilineComponent$ = new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$()
  };
  return $n_Lcom_iz2use_react_components_internal_editor_MultilineComponent$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_TextComponent$() {
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_editor_TextComponent$ = this;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper = $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$();
  var this$7 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("TextComponent", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(new $c_Ldiode_data_Ready($n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $m_s_None$(), $m_Ldiode_data_Empty$(), false, false, true, false)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_vdom_TagOf($$x1, $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((x$18$2) => {
    var x$18 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(x$18$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend($n(x$18).backend__O())).resetText__Ljapgolly_scalajs_react_callback_Trampoline())
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$11 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$7, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillMount__Ljapgolly_scalajs_react_internal_Lens(), f, G));
  var f$1 = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    var $$x5 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend($n(c).backend__O());
    var this$8 = $n(c);
    var $$x4 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps($n(this$8.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var $$x3 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps);
    var this$9 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).onPropsChange__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline($$x4, $$x3, $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$9))))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$15 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$11, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1));
  var f$2 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(c$3$2);
    var $$x7 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend($n(c$3).backend__O());
    var this$12 = $n(c$3);
    var $$x6 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps($n(this$12.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$13 = $n(c$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x7).saveOnUnmount__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline($$x6, $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState($n(this$13.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O())))
  }));
  var G$2 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$16 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$15, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillUnmount__Ljapgolly_scalajs_react_internal_Lens(), f$2, G$2));
  var f$3 = $m_Ljapgolly_scalajs_react_extra_OnUnmount$().install__F1();
  var this$20 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$3).apply__O__O(this$16)));
  var x$2$2 = new $c_sjsr_AnonFunction1(((c$4$2) => {
    var c$4 = $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(c$4$2);
    var this$17 = $n(c$4);
    return $n($as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend($f_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot__backend__O(this$17))).documentMouseDown__F1()
  }));
  var x$3$3 = new $c_sjsr_AnonFunction1(((x$19$2) => {
    $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$19$2);
    return document
  }));
  var f$4 = $m_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$().install$extension__Z__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(true, "mousedown", x$2$2, x$3$3, false, $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$4).apply__O__O(this$20))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_TextComponent$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_TextComponent$.prototype = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$.prototype;
var $d_Lcom_iz2use_react_components_internal_editor_TextComponent$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_TextComponent$: 0
}, false, "com.iz2use.react.components.internal.editor.TextComponent$", {
  Lcom_iz2use_react_components_internal_editor_TextComponent$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_TextComponent$;
var $n_Lcom_iz2use_react_components_internal_editor_TextComponent$;
function $m_Lcom_iz2use_react_components_internal_editor_TextComponent$() {
  if ((!$n_Lcom_iz2use_react_components_internal_editor_TextComponent$)) {
    $n_Lcom_iz2use_react_components_internal_editor_TextComponent$ = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$()
  };
  return $n_Lcom_iz2use_react_components_internal_editor_TextComponent$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_package$RichPot(pot) {
  this.Lcom_iz2use_react_components_internal_editor_package$RichPot__f_pot = null;
  this.Lcom_iz2use_react_components_internal_editor_package$RichPot__f_pot = pot
}
$c_Lcom_iz2use_react_components_internal_editor_package$RichPot.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_package$RichPot.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_package$RichPot;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_package$RichPot() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_package$RichPot.prototype = $c_Lcom_iz2use_react_components_internal_editor_package$RichPot.prototype;
$c_Lcom_iz2use_react_components_internal_editor_package$RichPot.prototype.withTry__s_util_Try__Ldiode_data_Pot = (function(result) {
  if ((result instanceof $c_s_util_Success)) {
    var x2 = $as_s_util_Success(result);
    var v = $n(x2).s_util_Success__f_value;
    $n(this.Lcom_iz2use_react_components_internal_editor_package$RichPot__f_pot);
    return new $c_Ldiode_data_Ready(v)
  };
  if ((result instanceof $c_s_util_Failure)) {
    var x3 = $as_s_util_Failure(result);
    var p4 = $n(x3).s_util_Failure__f_exception;
    if ((p4 !== null)) {
      var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(p4);
      if ((!$n(o11).isEmpty__Z())) {
        var e = $as_jl_Throwable($n(o11).get__O());
        return $n(this.Lcom_iz2use_react_components_internal_editor_package$RichPot__f_pot).fail__jl_Throwable__Ldiode_data_Pot(e)
      }
    }
  };
  throw new $c_s_MatchError(result)
});
var $d_Lcom_iz2use_react_components_internal_editor_package$RichPot = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_package$RichPot: 0
}, false, "com.iz2use.react.components.internal.editor.package$RichPot", {
  Lcom_iz2use_react_components_internal_editor_package$RichPot: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_editor_package$RichPot.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_package$RichPot;
function $p_Lcom_iz2use_react_components_internal_multiview_Axes__plainKey$1__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Lcom_iz2use_react_components_internal_multiview_AxesContext__F0($thiz, e$1, axesContext$3) {
  $m_Ljapgolly_scalajs_react_package$();
  $m_Ljapgolly_scalajs_react_package$();
  var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
  var x$6 = $thiz.actionOnPlayKeys__Lcom_iz2use_react_components_internal_multiview_AxesContext__s_PartialFunction(axesContext$3);
  return qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e$1, $uI(e$1.keyCode), false, false, false, false, x$6)
}
function $p_Lcom_iz2use_react_components_internal_multiview_Axes__shiftKey$1__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Lcom_iz2use_react_components_internal_multiview_AxesContext__F0($thiz, e$1, axesContext$3) {
  $m_Ljapgolly_scalajs_react_package$();
  $m_Ljapgolly_scalajs_react_package$();
  var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
  var x$6 = $thiz.actionOnShiftKey__Lcom_iz2use_react_components_internal_multiview_AxesContext__s_PartialFunction(axesContext$3);
  return qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e$1, $uI(e$1.keyCode), false, false, false, true, x$6)
}
function $p_Lcom_iz2use_react_components_internal_multiview_Axes__ctrlKey$1__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Lcom_iz2use_react_components_internal_multiview_AxesContext__F0($thiz, e$1, axesContext$3) {
  $m_Ljapgolly_scalajs_react_package$();
  $m_Ljapgolly_scalajs_react_package$();
  var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
  var x$6 = $thiz.actionOnCtrlKey__Lcom_iz2use_react_components_internal_multiview_AxesContext__s_PartialFunction(axesContext$3);
  return qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e$1, $uI(e$1.keyCode), false, true, false, false, x$6)
}
function $ct_Lcom_iz2use_react_components_internal_multiview_Axes__s_PartialFunction__s_PartialFunction__($thiz, primaryAxis, secondaryAxis) {
  $thiz.Lcom_iz2use_react_components_internal_multiview_Axes__f_primaryAxis = primaryAxis;
  $thiz.Lcom_iz2use_react_components_internal_multiview_Axes__f_secondaryAxis = secondaryAxis;
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Axes() {
  this.Lcom_iz2use_react_components_internal_multiview_Axes__f_primaryAxis = null;
  this.Lcom_iz2use_react_components_internal_multiview_Axes__f_secondaryAxis = null
}
$c_Lcom_iz2use_react_components_internal_multiview_Axes.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Axes.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Axes;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Axes() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Axes.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Axes.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Axes.prototype.actionOnPlayKeys__Lcom_iz2use_react_components_internal_multiview_AxesContext__s_PartialFunction = (function(axesContext) {
  var this$3 = new $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1(this, axesContext);
  var this$2 = new $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1();
  var k = $n(axesContext).gotoBoundItem__s_PartialFunction();
  var that = new $c_s_PartialFunction$Combined(this$2, k);
  var this$5 = new $c_s_PartialFunction$OrElse(this$3, that);
  var this$4 = $n(this.Lcom_iz2use_react_components_internal_multiview_Axes__f_primaryAxis);
  var k$1 = $n(axesContext).changePrimarySelection__s_PartialFunction();
  var that$1 = new $c_s_PartialFunction$Combined(this$4, k$1);
  var this$7 = $n(this$5.orElse__s_PartialFunction__s_PartialFunction$OrElse(that$1));
  var this$6 = $n(this.Lcom_iz2use_react_components_internal_multiview_Axes__f_secondaryAxis);
  var k$2 = $n(axesContext).changeSecondarySelection__s_PartialFunction();
  var that$2 = new $c_s_PartialFunction$Combined(this$6, k$2);
  return this$7.orElse__s_PartialFunction__s_PartialFunction$OrElse(that$2)
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes.prototype.actionOnShiftKey__Lcom_iz2use_react_components_internal_multiview_AxesContext__s_PartialFunction = (function(axesContext) {
  var this$1 = $n(this.Lcom_iz2use_react_components_internal_multiview_Axes__f_primaryAxis);
  var k = $n(axesContext).extendPrimarySelection__s_PartialFunction();
  var this$3 = new $c_s_PartialFunction$Combined(this$1, k);
  var this$2 = $n(this.Lcom_iz2use_react_components_internal_multiview_Axes__f_secondaryAxis);
  var k$1 = $n(axesContext).extendSecondarySelection__s_PartialFunction();
  var that = new $c_s_PartialFunction$Combined(this$2, k$1);
  return new $c_s_PartialFunction$OrElse(this$3, that)
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes.prototype.actionOnCtrlKey__Lcom_iz2use_react_components_internal_multiview_AxesContext__s_PartialFunction = (function(axesContext) {
  var this$2 = new $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1(this, axesContext);
  var this$1 = $n(this.Lcom_iz2use_react_components_internal_multiview_Axes__f_primaryAxis);
  var k = $n(axesContext).movePrimaryFocus__s_PartialFunction();
  var that = new $c_s_PartialFunction$Combined(this$1, k);
  var this$4 = new $c_s_PartialFunction$OrElse(this$2, that);
  var this$3 = $n(this.Lcom_iz2use_react_components_internal_multiview_Axes__f_secondaryAxis);
  var k$1 = $n(axesContext).moveSecondaryFocus__s_PartialFunction();
  var that$1 = new $c_s_PartialFunction$Combined(this$3, k$1);
  return this$4.orElse__s_PartialFunction__s_PartialFunction$OrElse(that$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes.prototype.handleKey__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Lcom_iz2use_react_components_internal_multiview_AxesContext__F0 = (function(e, axesContext) {
  var $$x1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$();
  $m_Ljapgolly_scalajs_react_package$();
  var self = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().orElse$extension__F0__F0__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().orElse$extension__F0__F0__F0($p_Lcom_iz2use_react_components_internal_multiview_Axes__plainKey$1__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Lcom_iz2use_react_components_internal_multiview_AxesContext__F0(this, e, axesContext), $p_Lcom_iz2use_react_components_internal_multiview_Axes__shiftKey$1__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Lcom_iz2use_react_components_internal_multiview_AxesContext__F0(this, e, axesContext)), $p_Lcom_iz2use_react_components_internal_multiview_Axes__ctrlKey$1__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Lcom_iz2use_react_components_internal_multiview_AxesContext__F0(this, e, axesContext));
  return $n($$x1).asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0(self, e)
});
function $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__childrenCount__I($thiz) {
  var this$1 = $n($thiz.children__sci_List());
  var acc = 0;
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = acc;
    var arg2 = $n(these).head__O();
    var x$3 = $uI(arg1);
    var x$4 = $as_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(arg2);
    acc = ((x$3 + $n(x$4).childrenCount__I()) | 0);
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return $uI(acc)
}
function $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__maxLevel__I($thiz) {
  var this$1 = $n($thiz.children__sci_List());
  var acc = 0;
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = acc;
    var arg2 = $n(these).head__O();
    var acc$1 = $uI(arg1);
    var c = $as_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(arg2);
    var that = $n(c).maxLevel__I();
    acc = ((acc$1 > that) ? acc$1 : that);
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return (($uI(acc) + ($thiz.newLevel__Z() ? 1 : 0)) | 0)
}
function $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List($thiz, level, context) {
  if ((level < 0)) {
    return $m_s_package$().s_package$__f_Nil
  } else {
    $n($m_s_package$().s_package$__f_List);
    var this$2 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$1 = $n($thiz.children__sci_List());
    var rest = this$1;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var x$5 = $as_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(arg1);
      var it = $n($n(x$5).renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List(level, context)).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx
        } else {
          $n(t).sci_$colon$colon__f_next = nx
        };
        t = nx
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    var ns = ((h === null) ? $m_sci_Nil$() : h);
    var array = [$p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$2, null, ns)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  }
}
function $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, map, editing) {
  var this$3 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var this$2 = $n($thiz.children__sci_List());
  var f = ((x$6$2) => {
    var x$6 = $as_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(x$6$2);
    return $n(x$6).renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode(map, $m_s_None$())
  });
  if ((this$2 === $m_sci_Nil$())) {
    var ns = $m_sci_Nil$()
  } else {
    var arg1 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var ns = h
  };
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$3, null, ns)
}
function $is_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_internal_multiview_ColumnFragment)))
}
function $as_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(obj) {
  return (($is_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.ColumnFragment"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_ColumnFragment)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_ColumnFragment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.ColumnFragment;", depth))
}
function $p_Lcom_iz2use_react_components_internal_multiview_CompareView$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("CompareView", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState()
  })))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_CompareView$() {
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_multiview_CompareView$ = this;
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$__f_component = $n($n($n($p_Lcom_iz2use_react_components_internal_multiview_CompareView$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_CompareView$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_CompareView$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$.prototype.apply__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_RenderCompare__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(items, renderItem, keyMapper, context, iterator) {
  var c = this.Lcom_iz2use_react_components_internal_multiview_CompareView$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps(items, renderItem, keyMapper, context, iterator);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_multiview_CompareView$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_CompareView$: 0
}, false, "com.iz2use.react.components.internal.multiview.CompareView$", {
  Lcom_iz2use_react_components_internal_multiview_CompareView$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_CompareView$;
var $n_Lcom_iz2use_react_components_internal_multiview_CompareView$;
function $m_Lcom_iz2use_react_components_internal_multiview_CompareView$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_CompareView$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_CompareView$ = new $c_Lcom_iz2use_react_components_internal_multiview_CompareView$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_CompareView$
}
function $ct_Lcom_iz2use_react_components_internal_multiview_Direction__I__($thiz, value) {
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Direction() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_Direction.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Direction.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Direction;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Direction() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Direction.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Direction.prototype;
function $as_Lcom_iz2use_react_components_internal_multiview_Direction(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_Direction) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.Direction"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_Direction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_Direction)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_Direction(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_Direction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.Direction;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Format$() {
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_string = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_double = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_integer = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_boolean = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_instant = null;
  $n_Lcom_iz2use_react_components_internal_multiview_Format$ = this;
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_string = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2();
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_double = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3();
  new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4();
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_integer = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5();
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_boolean = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6();
  this.Lcom_iz2use_react_components_internal_multiview_Format$__f_instant = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7()
}
$c_Lcom_iz2use_react_components_internal_multiview_Format$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Format$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Format$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Format$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Format$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Format$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_Format$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Format$: 0
}, false, "com.iz2use.react.components.internal.multiview.Format$", {
  Lcom_iz2use_react_components_internal_multiview_Format$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Format$;
var $n_Lcom_iz2use_react_components_internal_multiview_Format$;
function $m_Lcom_iz2use_react_components_internal_multiview_Format$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_Format$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_Format$ = new $c_Lcom_iz2use_react_components_internal_multiview_Format$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_Format$
}
function $f_Lcom_iz2use_react_components_internal_multiview_HasIterator__update__O__O__Lcom_iz2use_common_KeyMapper__O($thiz, in$1, item, keyMapper) {
  var key = $as_T($n(keyMapper).apply__O__O(item));
  return $thiz.map__O__F1__O(in$1, new $c_sjsr_AnonFunction1(((entry$2) => {
    var x = $n(keyMapper).apply__O__O(entry$2);
    if (((x === null) ? (key === null) : $dp_equals__O__Z($n(x), key))) {
      return item
    } else {
      return entry$2
    }
  })))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$() {
  this.Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable = null;
  $n_Lcom_iz2use_react_components_internal_multiview_HasIterator$ = this;
  new $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1();
  this.Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable = new $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2()
}
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_HasIterator$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_HasIterator$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_HasIterator$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_HasIterator$: 0
}, false, "com.iz2use.react.components.internal.multiview.HasIterator$", {
  Lcom_iz2use_react_components_internal_multiview_HasIterator$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_HasIterator$;
var $n_Lcom_iz2use_react_components_internal_multiview_HasIterator$;
function $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_HasIterator$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_HasIterator$ = new $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_HasIterator$
}
function $f_Lcom_iz2use_react_components_internal_multiview_MultiviewApi__$init$__V($thiz) {
  $m_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$();
  $m_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$()
}
function $f_Lcom_iz2use_react_components_internal_multiview_MultiviewContext__toggleOrAddOrder__Lcom_iz2use_react_components_internal_multiview_Order__Ljapgolly_scalajs_react_callback_Trampoline($thiz, order) {
  return $thiz.modSort__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_sci_List(x$1$2);
    return $p_Lcom_iz2use_react_components_internal_multiview_MultiviewContext__loop$1__sci_List__sci_List__Z__Lcom_iz2use_react_components_internal_multiview_Order__sci_List($thiz, x$1, $m_s_package$().s_package$__f_Nil, false, order)
  })))
}
function $p_Lcom_iz2use_react_components_internal_multiview_MultiviewContext__loop$1__sci_List__sci_List__Z__Lcom_iz2use_react_components_internal_multiview_Order__sci_List($thiz, in$1, acc, done, order$1) {
  while (true) {
    var x1 = in$1;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var x1$2 = done;
      if ((x1$2 === true)) {
        return $n(acc).reverse__sci_List()
      } else if ((x1$2 === false)) {
        var this$1 = $n($n(acc).reverse__sci_List());
        return this$1.prepended__O__sci_List(order$1)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $as_Lcom_iz2use_react_components_internal_multiview_Order($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      var x1$3 = ((!done) && ($n(head).Lcom_iz2use_react_components_internal_multiview_Order__f_field === $n(order$1).Lcom_iz2use_react_components_internal_multiview_Order__f_field));
      if ((x1$3 === true)) {
        var x$1 = (!$n(head).Lcom_iz2use_react_components_internal_multiview_Order__f_ascending);
        var this$2 = $n(head);
        var x$2$2 = this$2.Lcom_iz2use_react_components_internal_multiview_Order__f_field;
        $n(head);
        var rassoc$2 = new $c_Lcom_iz2use_react_components_internal_multiview_Order(x$2$2, x$1);
        var this$4 = $n(acc);
        var temp$acc = new $c_sci_$colon$colon(rassoc$2, this$4);
        in$1 = tail;
        acc = temp$acc;
        done = true
      } else if ((x1$3 === false)) {
        var this$5 = $n(acc);
        var temp$acc$2 = new $c_sci_$colon$colon(head, this$5);
        in$1 = tail;
        acc = temp$acc$2
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator.prototype;
function $as_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.MultiviewDecorator"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.MultiviewDecorator;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$() {
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$__f_emptySingleton = null;
  $n_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$ = this;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$__f_emptySingleton = new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1()
}
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$: 0
}, false, "com.iz2use.react.components.internal.multiview.MultiviewDecorator$", {
  Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$;
var $n_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$;
function $m_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$ = new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$() {
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$ = this;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("MultiviewSettings", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props(p$2);
    return false
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__Z__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $uZ($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)), $n(x$3).propsChildren__sjs_js_Any())
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$.prototype.apply__Lcom_iz2use_react_style_Style__F1__Ljapgolly_scalajs_react_vdom_VdomNode__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(style, moveActive, selector, children) {
  var c = this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props(style, moveActive, selector);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$: 0
}, false, "com.iz2use.react.components.internal.multiview.MultiviewSettings$", {
  Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$;
var $n_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$;
function $m_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$ = new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_QueryParser$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.prefixFieldName__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$1) {
  var startIndex = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$1).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("prefixFieldName").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$1).Lfastparse_ParsingRun__f_cut;
  $n(evidence$1).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var input = $n(evidence$1).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$1 = $n(input);
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$2, index) === 43)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$1).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$1).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$1).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"+\"")))
  };
  var lhsMsg = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$1).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$1).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$5 = evidence$1
  } else if ($n(evidence$1).Lfastparse_ParsingRun__f_cut) {
    var x1$5 = evidence$1
  } else {
    var verboseFailures = $n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$1).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$5 = $n(evidence$1);
      this$5.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$1).Lfastparse_ParsingRun__f_cut = false;
    var input$2 = $n(evidence$1).Lfastparse_ParsingRun__f_input;
    var index$2 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
    if ($n(input$2).isReachable__I__Z(index$2)) {
      var this$6 = $n(input$2);
      var this$7 = $n(this$6.Lfastparse_IndexedParserInput__f_data);
      var $$x2 = ($charAt(this$7, index$2) === 45)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      $n(evidence$1).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
    } else {
      $n(evidence$1).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$1).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"-\"")))
    };
    var rhsMsg = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$1).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$1).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$1).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$8 = $n(evidence$1);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$8.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$5 = evidence$1
  };
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("prefixFieldName").Lsourcecode_Name__f_value, $n(x1$5).Lfastparse_ParsingRun__f_index, $n(x1$5).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x3 = $n(x1$5);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("prefixFieldName").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x4 = $n(x1$5);
      var self = new $c_Lsourcecode_Name("prefixFieldName").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$15 = $n($n(x1$5).Lfastparse_ParsingRun__f_failureStack);
      $$x4.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$15)
    }
  };
  return x1$5
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.fieldOperator__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$2) {
  var startIndex = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$2).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("fieldOperator").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
  $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var oldCut$2 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
  $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
  var startPos$2 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var oldCut$3 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
  $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
  var startPos$3 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var oldCut$4 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
  $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
  var startPos$4 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var oldCut$5 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
  $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
  var startPos$5 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var oldCut$6 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
  $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
  var startPos$6 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var input = $n(evidence$2).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$1 = $n(input);
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$2, index) === 58)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$2).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\":\"")))
  };
  var lhsMsg = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$2).Lfastparse_ParsingRun__f_cut | oldCut$6)))
  } else if ($n(evidence$2).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures = $n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$2).Lfastparse_ParsingRun__f_index = startPos$6;
    if (verboseFailures) {
      var this$5 = $n(evidence$2);
      this$5.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$6, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
    var index$2 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    var end = ((2 + index$2) | 0);
    var input$2 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
    if ($n(input$2).isReachable__I__Z((((-1) + end) | 0))) {
      var this$6 = $n(input$2);
      var this$7 = $n(this$6.Lfastparse_IndexedParserInput__f_data);
      if (($charAt(this$7, index$2) === 60)) {
        var this$8 = $n(input$2);
        var index$1 = ((1 + index$2) | 0);
        var this$9 = $n(this$8.Lfastparse_IndexedParserInput__f_data);
        var $$x2 = ($charAt(this$9, index$1) === 61)
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
    } else {
      $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$2).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"<=\"")))
    };
    var rhsMsg = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut$6)));
    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$2).freshFailure__I__Lfastparse_ParsingRun(startPos$6)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$10 = $n(evidence$2);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$10.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$6, msgToSet, msgToAggregate, false)
    }
  };
  var lhsMsg$2 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate$2 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$2).Lfastparse_ParsingRun__f_cut | oldCut$5)))
  } else if ($n(evidence$2).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures$2 = $n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$2).Lfastparse_ParsingRun__f_index = startPos$5;
    if (verboseFailures$2) {
      var this$12 = $n(evidence$2);
      this$12.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, lhsMsg$2, lhsAggregate$2, false)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
    var input$3 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
    var index$3 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    if ($n(input$3).isReachable__I__Z(index$3)) {
      var this$13 = $n(input$3);
      var this$14 = $n(this$13.Lfastparse_IndexedParserInput__f_data);
      var $$x3 = ($charAt(this$14, index$3) === 60)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$3) | 0))
    } else {
      $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$2).aggregateTerminal__I__F0__V(index$3, new $c_sjsr_AnonFunction0((() => "\"<\"")))
    };
    var rhsMsg$2 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut$2 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
    var endCut$2 = (!(!(rhsCut$2 | oldCut$5)));
    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2))) {
      $n(evidence$2).freshFailure__I__Lfastparse_ParsingRun(startPos$5)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = endCut$2;
    if (verboseFailures$2) {
      var this$15 = $n(evidence$2);
      var msgToSet$1 = $n(lhsMsg$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2);
      var rassoc$3$2 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate$1 = $n(lhsAggregate$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
      this$15.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, msgToSet$1, msgToAggregate$1, false)
    }
  };
  var lhsMsg$3 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate$3 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$2).Lfastparse_ParsingRun__f_cut | oldCut$4)))
  } else if ($n(evidence$2).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures$3 = $n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$2).Lfastparse_ParsingRun__f_index = startPos$4;
    if (verboseFailures$3) {
      var this$17 = $n(evidence$2);
      this$17.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$4, lhsMsg$3, lhsAggregate$3, false)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
    var input$4 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
    var index$4 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    if ($n(input$4).isReachable__I__Z(index$4)) {
      var this$18 = $n(input$4);
      var this$19 = $n(this$18.Lfastparse_IndexedParserInput__f_data);
      var $$x4 = ($charAt(this$19, index$4) === 61)
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$4) | 0))
    } else {
      $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$2).aggregateTerminal__I__F0__V(index$4, new $c_sjsr_AnonFunction0((() => "\"=\"")))
    };
    var rhsMsg$3 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut$3 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
    var endCut$3 = (!(!(rhsCut$3 | oldCut$4)));
    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$3))) {
      $n(evidence$2).freshFailure__I__Lfastparse_ParsingRun(startPos$4)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = endCut$3;
    if (verboseFailures$3) {
      var this$20 = $n(evidence$2);
      var msgToSet$2 = $n(lhsMsg$3).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$3);
      var rassoc$3$3 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate$2 = $n(lhsAggregate$3).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$3);
      this$20.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$4, msgToSet$2, msgToAggregate$2, false)
    }
  };
  var lhsMsg$4 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate$4 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$2).Lfastparse_ParsingRun__f_cut | oldCut$3)))
  } else if ($n(evidence$2).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures$4 = $n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$2).Lfastparse_ParsingRun__f_index = startPos$3;
    if (verboseFailures$4) {
      var this$22 = $n(evidence$2);
      this$22.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, lhsMsg$4, lhsAggregate$4, false)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
    var index$5 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    var end$2 = ((2 + index$5) | 0);
    var input$5 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
    if ($n(input$5).isReachable__I__Z((((-1) + end$2) | 0))) {
      var this$23 = $n(input$5);
      var this$24 = $n(this$23.Lfastparse_IndexedParserInput__f_data);
      if (($charAt(this$24, index$5) === 61)) {
        var this$25 = $n(input$5);
        var index$6 = ((1 + index$5) | 0);
        var this$26 = $n(this$25.Lfastparse_IndexedParserInput__f_data);
        var $$x5 = ($charAt(this$26, index$6) === 61)
      } else {
        var $$x5 = false
      }
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(end$2)
    } else {
      $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$2).aggregateTerminal__I__F0__V(index$5, new $c_sjsr_AnonFunction0((() => "\"==\"")))
    };
    var rhsMsg$4 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut$4 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
    var endCut$4 = (!(!(rhsCut$4 | oldCut$3)));
    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$4))) {
      $n(evidence$2).freshFailure__I__Lfastparse_ParsingRun(startPos$3)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = endCut$4;
    if (verboseFailures$4) {
      var this$27 = $n(evidence$2);
      var msgToSet$3 = $n(lhsMsg$4).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$4);
      var rassoc$3$4 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate$3 = $n(lhsAggregate$4).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$4);
      this$27.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, msgToSet$3, msgToAggregate$3, false)
    }
  };
  var lhsMsg$5 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate$5 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$2).Lfastparse_ParsingRun__f_cut | oldCut$2)))
  } else if ($n(evidence$2).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures$5 = $n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$2).Lfastparse_ParsingRun__f_index = startPos$2;
    if (verboseFailures$5) {
      var this$29 = $n(evidence$2);
      this$29.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg$5, lhsAggregate$5, false)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
    var index$6$1 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    var end$3 = ((2 + index$6$1) | 0);
    var input$6 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
    if ($n(input$6).isReachable__I__Z((((-1) + end$3) | 0))) {
      var this$30 = $n(input$6);
      var this$31 = $n(this$30.Lfastparse_IndexedParserInput__f_data);
      if (($charAt(this$31, index$6$1) === 62)) {
        var this$32 = $n(input$6);
        var index$7 = ((1 + index$6$1) | 0);
        var this$33 = $n(this$32.Lfastparse_IndexedParserInput__f_data);
        var $$x6 = ($charAt(this$33, index$7) === 61)
      } else {
        var $$x6 = false
      }
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(end$3)
    } else {
      $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$2).aggregateTerminal__I__F0__V(index$6$1, new $c_sjsr_AnonFunction0((() => "\">=\"")))
    };
    var rhsMsg$5 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut$5 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
    var endCut$5 = (!(!(rhsCut$5 | oldCut$2)));
    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$5))) {
      $n(evidence$2).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = endCut$5;
    if (verboseFailures$5) {
      var this$34 = $n(evidence$2);
      var msgToSet$4 = $n(lhsMsg$5).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$5);
      var rassoc$3$5 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate$4 = $n(lhsAggregate$5).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$5);
      this$34.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet$4, msgToAggregate$4, false)
    }
  };
  var lhsMsg$6 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate$6 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$2).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$15 = evidence$2
  } else if ($n(evidence$2).Lfastparse_ParsingRun__f_cut) {
    var x1$15 = evidence$2
  } else {
    var verboseFailures$6 = $n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$2).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures$6) {
      var this$36 = $n(evidence$2);
      this$36.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg$6, lhsAggregate$6, false)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
    var input$7 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
    var index$7$1 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    if ($n(input$7).isReachable__I__Z(index$7$1)) {
      var this$37 = $n(input$7);
      var this$38 = $n(this$37.Lfastparse_IndexedParserInput__f_data);
      var $$x7 = ($charAt(this$38, index$7$1) === 62)
    } else {
      var $$x7 = false
    };
    if ($$x7) {
      $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$7$1) | 0))
    } else {
      $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$2).aggregateTerminal__I__F0__V(index$7$1, new $c_sjsr_AnonFunction0((() => "\">\"")))
    };
    var rhsMsg$6 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut$6 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
    var endCut$6 = (!(!(rhsCut$6 | oldCut)));
    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$6))) {
      $n(evidence$2).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = endCut$6;
    if (verboseFailures$6) {
      var this$39 = $n(evidence$2);
      var msgToSet$5 = $n(lhsMsg$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$6);
      var rassoc$3$6 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate$5 = $n(lhsAggregate$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$6);
      this$39.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet$5, msgToAggregate$5, false)
    };
    var x1$15 = evidence$2
  };
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("fieldOperator").Lsourcecode_Name__f_value, $n(x1$15).Lfastparse_ParsingRun__f_index, $n(x1$15).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$15).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x8 = $n(x1$15);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("fieldOperator").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$15).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$15).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$15).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x9 = $n(x1$15);
      var self = new $c_Lsourcecode_Name("fieldOperator").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$46 = $n($n(x1$15).Lfastparse_ParsingRun__f_failureStack);
      $$x9.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$46)
    }
  };
  return x1$15
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.fieldValue__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$3) {
  var startIndex = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$3).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("fieldValue").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$3).Lfastparse_ParsingRun__f_cut;
  $n(evidence$3).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var startPos$2 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$3).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$3).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var x1$5 = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $uC(x$5$2);
    return (x$5 !== 32)
  }));
  var index = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var input = $n(evidence$3).Lfastparse_ParsingRun__f_input;
  var start = index;
  var goal = ((1 + start) | 0);
  while (true) {
    if ($n(input).isReachable__I__Z(index)) {
      var this$2 = $n(input);
      var index$1 = index;
      var this$3 = $n(this$2.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = $uZ(x1$5.apply__O__O($bC($charAt(this$3, index$1))))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index = ((1 + index) | 0)
    } else {
      break
    }
  };
  if ((index >= goal)) {
    $n(evidence$3).freshSuccessUnit__I__Lfastparse_ParsingRun(index)
  } else {
    $n(evidence$3).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$3).aggregateTerminal__I__F0__V(start, new $c_sjsr_AnonFunction0((() => (("chars-while(" + x1$5) + ", 1)"))))
  };
  $n(evidence$3).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    $n(evidence$3).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$3).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$2, $n(evidence$3).Lfastparse_ParsingRun__f_index))
  };
  var lhsMsg = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$3).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$3).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$6 = evidence$3
  } else if ($n(evidence$3).Lfastparse_ParsingRun__f_cut) {
    var x1$6 = evidence$3
  } else {
    var verboseFailures = $n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$3).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$6 = $n(evidence$3);
      this$6.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$3).Lfastparse_ParsingRun__f_cut = false;
    this.fieldStringValue__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$3);
    var rhsMsg = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$3).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$3).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$3).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$7 = $n(evidence$3);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$7.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$6 = evidence$3
  };
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("fieldValue").Lsourcecode_Name__f_value, $n(x1$6).Lfastparse_ParsingRun__f_index, $n(x1$6).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$6).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(x1$6);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("fieldValue").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$6).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$6).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$6).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(x1$6);
      var self = new $c_Lsourcecode_Name("fieldValue").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$14 = $n($n(x1$6).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$14)
    }
  };
  return x1$6
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.fieldStringValue__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$4) {
  var startIndex = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$4).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("fieldStringValue").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$4).Lfastparse_ParsingRun__f_cut;
  $n(evidence$4).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$4 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$17 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var input = $n(evidence$4).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$3 = $n(input);
    var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$4, index) === 39)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$4).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$4).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$4).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"'\"")))
  };
  if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$4).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$4);
    if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$4).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$4 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      var startPos$2 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      var oldCapturing = $n(evidence$4).Lfastparse_ParsingRun__f_noDropBuffer;
      $n(evidence$4).Lfastparse_ParsingRun__f_noDropBuffer = true;
      $m_Lfastparse_package$();
      var x1$10 = new $c_sjsr_AnonFunction1(((x$6$2) => {
        var x$6 = $uC(x$6$2);
        return (x$6 !== 39)
      }));
      var index$2 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      var input$2 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
      var start = index$2;
      var goal = ((1 + start) | 0);
      while (true) {
        if ($n(input$2).isReachable__I__Z(index$2)) {
          var this$7 = $n(input$2);
          var index$1 = index$2;
          var this$8 = $n(this$7.Lfastparse_IndexedParserInput__f_data);
          var $$x2 = $uZ(x1$10.apply__O__O($bC($charAt(this$8, index$1))))
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          index$2 = ((1 + index$2) | 0)
        } else {
          break
        }
      };
      if ((index$2 >= goal)) {
        $n(evidence$4).freshSuccessUnit__I__Lfastparse_ParsingRun(index$2)
      } else {
        $n(evidence$4).freshFailure__Lfastparse_ParsingRun()
      };
      if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$4).aggregateTerminal__I__F0__V(start, new $c_sjsr_AnonFunction0((() => (("chars-while(" + x1$10) + ", 1)"))))
      };
      $n(evidence$4).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
      if ($n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) {
        $n(evidence$4).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$4).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$2, $n(evidence$4).Lfastparse_ParsingRun__f_index))
      };
      var rhsAggregate$macro$7 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$4
      } else {
        var postRhsIndex$macro$5 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$4).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x3 = $n(evidence$4);
        var v = $as_T($n(evidence$4).Lfastparse_ParsingRun__f_successValue);
        var res$macro$14 = $n($$x3).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
      };
      if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$4).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$18 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$4).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$4).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$4).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$19 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      var input$3 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
      var index$3 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      if ($n(input$3).isReachable__I__Z(index$3)) {
        var this$11 = $n(input$3);
        var this$12 = $n(this$11.Lfastparse_IndexedParserInput__f_data);
        var $$x4 = ($charAt(this$12, index$3) === 39)
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        $n(evidence$4).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$3) | 0))
      } else {
        $n(evidence$4).freshFailure__Lfastparse_ParsingRun()
      };
      if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$4).aggregateTerminal__I__F0__V(index$3, new $c_sjsr_AnonFunction0((() => "\"'\"")))
      };
      var rhsAggregate$macro$22 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$23 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$29 = evidence$4
      } else {
        var postRhsIndex$macro$20 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
        var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
        if ((rhsMadeProgress$macro$25 && $n(evidence$4).checkForDrop__Z())) {
          $n(input$macro$26)
        };
        var $$x5 = $n(evidence$4);
        $n(x1$4);
        var t = $as_T(lhsValue$macro$27);
        $n(evidence$4);
        var res$macro$29 = $n($$x5).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$28)
      };
      if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$4).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  var lhsMsg = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$4).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$21 = evidence$4
  } else if ($n(evidence$4).Lfastparse_ParsingRun__f_cut) {
    var x1$21 = evidence$4
  } else {
    var verboseFailures = $n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$4).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$15 = $n(evidence$4);
      this$15.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = false;
    var this$16 = $m_Lfastparse_Implicits$Sequencer$();
    var x1$13 = this$16.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
    var preLhsIndex$macro$47 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    var input$macro$56 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex$macro$32 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    var input$macro$41 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    var input$4 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
    var index$4 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    if ($n(input$4).isReachable__I__Z(index$4)) {
      var this$18 = $n(input$4);
      var this$19 = $n(this$18.Lfastparse_IndexedParserInput__f_data);
      var $$x6 = ($charAt(this$19, index$4) === 34)
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      $n(evidence$4).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$4) | 0))
    } else {
      $n(evidence$4).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$4).aggregateTerminal__I__F0__V(index$4, new $c_sjsr_AnonFunction0((() => "\"\\\"\"")))
    };
    if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
      /*<skip>*/
    } else {
      var postLhsIndex$macro$33 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$36 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$39 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
      if (((postLhsIndex$macro$33 > preLhsIndex$macro$32) && $n(evidence$4).checkForDrop__Z())) {
        $n(input$macro$41)
      };
      $n(evidence$4);
      if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$4).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$34 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        var startPos$3 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        var oldCapturing$2 = $n(evidence$4).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$4).Lfastparse_ParsingRun__f_noDropBuffer = true;
        $m_Lfastparse_package$();
        var x1$19 = new $c_sjsr_AnonFunction1(((x$7$2) => {
          var x$7 = $uC(x$7$2);
          return (x$7 !== 34)
        }));
        var index$5 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        var input$5 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
        var start$2 = index$5;
        var goal$2 = ((1 + start$2) | 0);
        while (true) {
          if ($n(input$5).isReachable__I__Z(index$5)) {
            var this$21 = $n(input$5);
            var index$6 = index$5;
            var this$22 = $n(this$21.Lfastparse_IndexedParserInput__f_data);
            var $$x7 = $uZ(x1$19.apply__O__O($bC($charAt(this$22, index$6))))
          } else {
            var $$x7 = false
          };
          if ($$x7) {
            index$5 = ((1 + index$5) | 0)
          } else {
            break
          }
        };
        if ((index$5 >= goal$2)) {
          $n(evidence$4).freshSuccessUnit__I__Lfastparse_ParsingRun(index$5)
        } else {
          $n(evidence$4).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$4).aggregateTerminal__I__F0__V(start$2, new $c_sjsr_AnonFunction0((() => (("chars-while(" + x1$19) + ", 1)"))))
        };
        $n(evidence$4).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing$2;
        if ($n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) {
          $n(evidence$4).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$4).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$3, $n(evidence$4).Lfastparse_ParsingRun__f_index))
        };
        var rhsAggregate$macro$37 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$38 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$44 = evidence$4
        } else {
          var postRhsIndex$macro$35 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$40 = (postRhsIndex$macro$35 > preRhsIndex$macro$34);
          var nextIndex$macro$43 = (((!rhsMadeProgress$macro$40) && $n(input$macro$41).isReachable__I__Z(postRhsIndex$macro$35)) ? postLhsIndex$macro$33 : postRhsIndex$macro$35);
          if ((rhsMadeProgress$macro$40 && $n(evidence$4).checkForDrop__Z())) {
            $n(input$macro$41)
          };
          var $$x8 = $n(evidence$4);
          var v$2 = $as_T($n(evidence$4).Lfastparse_ParsingRun__f_successValue);
          var res$macro$44 = $n($$x8).freshSuccess__O__I__Lfastparse_ParsingRun(v$2, nextIndex$macro$43)
        };
        if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$32, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$39, rhsMsg$macro$38), $n(lhsAggregate$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$37), (preRhsIndex$macro$34 === $n(evidence$4).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    };
    if ($n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) {
      var postLhsIndex$macro$48 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$51 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$54 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
      if (((postLhsIndex$macro$48 > preLhsIndex$macro$47) && $n(evidence$4).checkForDrop__Z())) {
        $n(input$macro$56)
      };
      var lhsValue$macro$57 = $n(evidence$4).Lfastparse_ParsingRun__f_successValue;
      if ((!((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$4).Lfastparse_ParsingRun__f_cut))) {
        var preRhsIndex$macro$49 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        var input$6 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
        var index$6$1 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        if ($n(input$6).isReachable__I__Z(index$6$1)) {
          var this$25 = $n(input$6);
          var this$26 = $n(this$25.Lfastparse_IndexedParserInput__f_data);
          var $$x9 = ($charAt(this$26, index$6$1) === 34)
        } else {
          var $$x9 = false
        };
        if ($$x9) {
          $n(evidence$4).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$6$1) | 0))
        } else {
          $n(evidence$4).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$4).aggregateTerminal__I__F0__V(index$6$1, new $c_sjsr_AnonFunction0((() => "\"\\\"\"")))
        };
        var rhsAggregate$macro$52 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$53 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
          /*<skip>*/
        } else {
          var postRhsIndex$macro$50 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$55 = (postRhsIndex$macro$50 > preRhsIndex$macro$49);
          var nextIndex$macro$58 = (((!rhsMadeProgress$macro$55) && $n(input$macro$56).isReachable__I__Z(postRhsIndex$macro$50)) ? postLhsIndex$macro$48 : postRhsIndex$macro$50);
          if ((rhsMadeProgress$macro$55 && $n(evidence$4).checkForDrop__Z())) {
            $n(input$macro$56)
          };
          var $$x10 = $n(evidence$4);
          $n(x1$13);
          var t$1 = $as_T(lhsValue$macro$57);
          $n(evidence$4);
          $n($$x10).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$58)
        };
        if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$47, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$54, rhsMsg$macro$53), $n(lhsAggregate$macro$51).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$52), (preRhsIndex$macro$49 === $n(evidence$4).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    };
    var rhsMsg = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$4).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$4).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$28 = $n(evidence$4);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3$2 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
      this$28.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$21 = evidence$4
  };
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("fieldStringValue").Lsourcecode_Name__f_value, $n(x1$21).Lfastparse_ParsingRun__f_index, $n(x1$21).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$21).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x11 = $n(x1$21);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("fieldStringValue").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x11).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$21).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$21).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$21).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x12 = $n(x1$21);
      var self = new $c_Lsourcecode_Name("fieldStringValue").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$35 = $n($n(x1$21).Lfastparse_ParsingRun__f_failureStack);
      $$x12.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$35)
    }
  };
  return x1$21
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.fieldName__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$5) {
  var startIndex = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$5).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$5).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("fieldName").Lsourcecode_Name__f_value, startIndex)
  };
  var startPos = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var index$macro$2 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var input$macro$3 = $n(evidence$5).Lfastparse_ParsingRun__f_input;
  var start$macro$4 = index$macro$2;
  var goal$macro$5 = ((1 + start$macro$4) | 0);
  while (true) {
    if ($n(input$macro$3).isReachable__I__Z(index$macro$2)) {
      var this$1 = $n(input$macro$3);
      var index = index$macro$2;
      var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
      var x1$4 = $charAt(this$2, index);
      var $$x1 = (((x1$4 >= 97) && (x1$4 <= 122)) || ((x1$4 >= 65) && (x1$4 <= 90)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index$macro$2 = ((1 + index$macro$2) | 0)
    } else {
      break
    }
  };
  if ((index$macro$2 >= goal$macro$5)) {
    $n(evidence$5).freshSuccessUnit__I__Lfastparse_ParsingRun(index$macro$2)
  } else {
    $n(evidence$5).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$5).aggregateTerminal__I__F0__V(start$macro$4, new $c_sjsr_AnonFunction0((() => "[a-zA-Z]")))
  };
  $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var x1$5 = ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) ? evidence$5 : $n(evidence$5).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$5).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$5).Lfastparse_ParsingRun__f_index)));
  if (instrument) {
    $n($n(evidence$5).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("fieldName").Lsourcecode_Name__f_value, $n(x1$5).Lfastparse_ParsingRun__f_index, $n(x1$5).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(x1$5);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("fieldName").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(x1$5);
      var self = new $c_Lsourcecode_Name("fieldName").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$5).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$11)
    }
  };
  return x1$5
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.fieldMatch__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$6) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$6).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("fieldMatch").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$107 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$116 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.Lfastparse_Implicits$Sequencer$__f_BaseSequencer6;
  var preLhsIndex$macro$92 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$101 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$3 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$7 = this$3.Lfastparse_Implicits$Sequencer$__f_BaseSequencer5;
  var preLhsIndex$macro$77 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$86 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$4 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$9 = this$4.Lfastparse_Implicits$Sequencer$__f_BaseSequencer4;
  var preLhsIndex$macro$62 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$71 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$5 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$11 = this$5.Lfastparse_Implicits$Sequencer$__f_BaseSequencer3;
  var preLhsIndex$macro$47 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$56 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$6 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$13 = this$6.Lfastparse_Implicits$Sequencer$__f_BaseSequencer2;
  var preLhsIndex$macro$32 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$41 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$7 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$15 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$7));
  var preLhsIndex$macro$17 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var oldCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
  $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$().Start__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
  var lhsMsg = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$6).Lfastparse_ParsingRun__f_cut | oldCut)))
  } else if ($n(evidence$6).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures = $n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$6).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$10 = $n(evidence$6);
      this$10.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
    var input = $n(evidence$6).Lfastparse_ParsingRun__f_input;
    var index = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    if ($n(input).isReachable__I__Z(index)) {
      var this$11 = $n(input);
      var this$12 = $n(this$11.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$12, index) === 32)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
    } else {
      $n(evidence$6).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$6).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\" \"")))
    };
    var rhsMsg = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$6).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$14 = $n(evidence$6);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$14.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$6);
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$4 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$().Index__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
      var rhsAggregate$macro$7 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$6
      } else {
        var postRhsIndex$macro$5 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$6).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x2 = $n(evidence$6);
        var v = $uI($n(evidence$6).Lfastparse_ParsingRun__f_successValue);
        var res$macro$14 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$18 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$19 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var this$17 = $m_Lfastparse_Implicits$Optioner$();
      var x1$21 = this$17.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
      var startPos$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var startCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
      $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
      $m_Lfastparse_package$();
      var startPos$3 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var oldCapturing = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
      $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
      $m_Lfastparse_package$();
      this.prefixFieldName__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
      $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
      if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
        /*<skip>*/
      } else {
        $n(evidence$6).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$6).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$3, $n(evidence$6).Lfastparse_ParsingRun__f_index))
      };
      var postSuccess = $n(evidence$6).Lfastparse_ParsingRun__f_isSuccess;
      if (postSuccess) {
        var $$x3 = $n(evidence$6);
        $n(x1$21);
        var value = $as_T($n(evidence$6).Lfastparse_ParsingRun__f_successValue);
        var res$2 = $n($$x3).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value));
        $n(res$2).Lfastparse_ParsingRun__f_cut = (!(!($n(res$2).Lfastparse_ParsingRun__f_cut | startCut)));
        var res$4 = res$2
      } else if ($n(evidence$6).Lfastparse_ParsingRun__f_cut) {
        var res$4 = evidence$6
      } else {
        var res$3 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$21), $m_s_None$()), startPos$2);
        $n(res$3).Lfastparse_ParsingRun__f_cut = (!(!($n(res$3).Lfastparse_ParsingRun__f_cut | startCut)));
        var res$4 = res$3
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        var msg = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
        var agg = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ((!postSuccess)) {
          $n(evidence$6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$2, new $c_sjsr_AnonFunction0((() => {
            var this$22 = $n(msg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$22.Lfastparse_internal_Msgs__f_value) + ".?")
          })), agg)
        }
      };
      if ($n(res$4).Lfastparse_ParsingRun__f_isSuccess) {
        var $$x4 = $n(res$4);
        var arg1 = $as_s_Option($n(res$4).Lfastparse_ParsingRun__f_successValue);
        $$x4.Lfastparse_ParsingRun__f_successValue = $n(arg1).contains__O__Z("-")
      };
      var rhsAggregate$macro$22 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$23 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$29 = evidence$6
      } else {
        var postRhsIndex$macro$20 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
        var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
        if ((rhsMadeProgress$macro$25 && $n(evidence$6).checkForDrop__Z())) {
          $n(input$macro$26)
        };
        var res$macro$29 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$15).apply__O__O__O($uI(lhsValue$macro$27), $uZ($n(evidence$6).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$28)
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$33 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$36 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$39 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$33 > preLhsIndex$macro$32) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$41)
    };
    var lhsValue$macro$42 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$34 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      this.fieldName__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
      var rhsAggregate$macro$37 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$38 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$44 = evidence$6
      } else {
        var postRhsIndex$macro$35 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$40 = (postRhsIndex$macro$35 > preRhsIndex$macro$34);
        var nextIndex$macro$43 = (((!rhsMadeProgress$macro$40) && $n(input$macro$41).isReachable__I__Z(postRhsIndex$macro$35)) ? postLhsIndex$macro$33 : postRhsIndex$macro$35);
        if ((rhsMadeProgress$macro$40 && $n(evidence$6).checkForDrop__Z())) {
          $n(input$macro$41)
        };
        var res$macro$44 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$13).apply__O__O__O($as_T2(lhsValue$macro$42), $as_T($n(evidence$6).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$43)
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$32, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$39, rhsMsg$macro$38), $n(lhsAggregate$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$37), (preRhsIndex$macro$34 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$48 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$51 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$54 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$48 > preLhsIndex$macro$47) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$56)
    };
    var lhsValue$macro$57 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$49 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var startPos$4 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var oldCapturing$2 = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
      $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
      $m_Lfastparse_package$();
      this.fieldOperator__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
      $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing$2;
      if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
        $n(evidence$6).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$6).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$4, $n(evidence$6).Lfastparse_ParsingRun__f_index))
      };
      var rhsAggregate$macro$52 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$53 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$59 = evidence$6
      } else {
        var postRhsIndex$macro$50 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$55 = (postRhsIndex$macro$50 > preRhsIndex$macro$49);
        var nextIndex$macro$58 = (((!rhsMadeProgress$macro$55) && $n(input$macro$56).isReachable__I__Z(postRhsIndex$macro$50)) ? postLhsIndex$macro$48 : postRhsIndex$macro$50);
        if ((rhsMadeProgress$macro$55 && $n(evidence$6).checkForDrop__Z())) {
          $n(input$macro$56)
        };
        var res$macro$59 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$11).apply__O__O__O($as_T3(lhsValue$macro$57), $as_T($n(evidence$6).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$58)
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$47, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$54, rhsMsg$macro$53), $n(lhsAggregate$macro$51).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$52), (preRhsIndex$macro$49 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$63 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$66 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$69 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$63 > preLhsIndex$macro$62) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$71)
    };
    var lhsValue$macro$72 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$64 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$().Index__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
      var rhsAggregate$macro$67 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$68 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$74 = evidence$6
      } else {
        var postRhsIndex$macro$65 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$70 = (postRhsIndex$macro$65 > preRhsIndex$macro$64);
        var nextIndex$macro$73 = (((!rhsMadeProgress$macro$70) && $n(input$macro$71).isReachable__I__Z(postRhsIndex$macro$65)) ? postLhsIndex$macro$63 : postRhsIndex$macro$65);
        if ((rhsMadeProgress$macro$70 && $n(evidence$6).checkForDrop__Z())) {
          $n(input$macro$71)
        };
        var res$macro$74 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$9).apply__O__O__O($as_T4(lhsValue$macro$72), $uI($n(evidence$6).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$73)
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$62, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$69, rhsMsg$macro$68), $n(lhsAggregate$macro$66).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$67), (preRhsIndex$macro$64 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$78 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$81 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$84 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$78 > preLhsIndex$macro$77) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$86)
    };
    var lhsValue$macro$87 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$79 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var startPos$5 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var oldCapturing$3 = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
      $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
      $m_Lfastparse_package$();
      var this$29 = $m_Lfastparse_Implicits$Optioner$();
      var x1$27 = this$29.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
      var startPos$6 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var startCut$2 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
      $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
      $m_Lfastparse_package$();
      this.fieldValue__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
      var postSuccess$2 = $n(evidence$6).Lfastparse_ParsingRun__f_isSuccess;
      if (postSuccess$2) {
        var $$x5 = $n(evidence$6);
        $n(x1$27);
        var value$1 = $as_T($n(evidence$6).Lfastparse_ParsingRun__f_successValue);
        var res$5 = $n($$x5).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value$1));
        $n(res$5).Lfastparse_ParsingRun__f_cut = (!(!($n(res$5).Lfastparse_ParsingRun__f_cut | startCut$2)))
      } else if ($n(evidence$6).Lfastparse_ParsingRun__f_cut) {
        /*<skip>*/
      } else {
        var res$6 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$27), $m_s_None$()), startPos$6);
        $n(res$6).Lfastparse_ParsingRun__f_cut = (!(!($n(res$6).Lfastparse_ParsingRun__f_cut | startCut$2)))
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        var msg$2 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
        var agg$2 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ((!postSuccess$2)) {
          $n(evidence$6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$6, new $c_sjsr_AnonFunction0((() => {
            var this$33 = $n(msg$2);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$33.Lfastparse_internal_Msgs__f_value) + ".?")
          })), agg$2)
        }
      };
      $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing$3;
      if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
        $n(evidence$6).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$6).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$5, $n(evidence$6).Lfastparse_ParsingRun__f_index))
      };
      var rhsAggregate$macro$82 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$83 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$89 = evidence$6
      } else {
        var postRhsIndex$macro$80 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$85 = (postRhsIndex$macro$80 > preRhsIndex$macro$79);
        var nextIndex$macro$88 = (((!rhsMadeProgress$macro$85) && $n(input$macro$86).isReachable__I__Z(postRhsIndex$macro$80)) ? postLhsIndex$macro$78 : postRhsIndex$macro$80);
        if ((rhsMadeProgress$macro$85 && $n(evidence$6).checkForDrop__Z())) {
          $n(input$macro$86)
        };
        var res$macro$89 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$7).apply__O__O__O($as_T5(lhsValue$macro$87), $as_T($n(evidence$6).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$88)
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$77, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$84, rhsMsg$macro$83), $n(lhsAggregate$macro$81).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$82), (preRhsIndex$macro$79 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$93 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$96 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$99 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$93 > preLhsIndex$macro$92) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$101)
    };
    var lhsValue$macro$102 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$94 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$().Index__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
      var rhsAggregate$macro$97 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$98 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$104 = evidence$6
      } else {
        var postRhsIndex$macro$95 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$100 = (postRhsIndex$macro$95 > preRhsIndex$macro$94);
        var nextIndex$macro$103 = (((!rhsMadeProgress$macro$100) && $n(input$macro$101).isReachable__I__Z(postRhsIndex$macro$95)) ? postLhsIndex$macro$93 : postRhsIndex$macro$95);
        if ((rhsMadeProgress$macro$100 && $n(evidence$6).checkForDrop__Z())) {
          $n(input$macro$101)
        };
        var res$macro$104 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$5).apply__O__O__O($as_T6(lhsValue$macro$102), $uI($n(evidence$6).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$103)
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$92, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$99, rhsMsg$macro$98), $n(lhsAggregate$macro$96).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$97), (preRhsIndex$macro$94 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$29 = evidence$6
  } else {
    var postLhsIndex$macro$108 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$111 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$114 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$108 > preLhsIndex$macro$107) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$116)
    };
    var lhsValue$macro$117 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
      var x1$29 = evidence$6
    } else {
      var preRhsIndex$macro$109 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var oldCut$2 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
      $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
      var startPos$7 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      $m_Lfastparse_package$();
      var startPos$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var startCut$1 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
      var oldNoCut = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
      $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
      var input$1 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
      var index$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      if ($n(input$1).isReachable__I__Z(index$1)) {
        var this$38 = $n(input$1);
        var this$39 = $n(this$38.Lfastparse_IndexedParserInput__f_data);
        var $$x6 = ($charAt(this$39, index$1) === 32)
      } else {
        var $$x6 = false
      };
      if ($$x6) {
        $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$1) | 0))
      } else {
        $n(evidence$6).freshFailure__Lfastparse_ParsingRun()
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).aggregateTerminal__I__F0__V(index$1, new $c_sjsr_AnonFunction0((() => "\" \"")))
      };
      $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
      var msg$1 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      var res$8 = ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$1) : evidence$6);
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
        $n(evidence$6).setMsg__I__F0__V(startPos$1, new $c_sjsr_AnonFunction0((() => {
          if ($is_sci_Seq(msg$1)) {
            var x2 = $as_sci_Seq(msg$1);
            $m_sci_Seq$();
            if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x2), true) && ($n(x2).lengthCompare__I__I(1) === 0))) {
              var this$45 = $n(msg$1);
              return (("&(" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$45.Lfastparse_internal_Msgs__f_value)) + ")")
            }
          };
          var this$46 = $n(msg$1);
          return ("&" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$46.Lfastparse_internal_Msgs__f_value))
        })))
      };
      $n(res$8).Lfastparse_ParsingRun__f_cut = startCut$1;
      var lhsMsg$2 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      var lhsAggregate$2 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
        $n(evidence$6).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$6).Lfastparse_ParsingRun__f_cut | oldCut$2)))
      } else if ((!$n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
        var verboseFailures$2 = $n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures;
        $n(evidence$6).Lfastparse_ParsingRun__f_index = startPos$7;
        if (verboseFailures$2) {
          var this$48 = $n(evidence$6);
          this$48.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$7, lhsMsg$2, lhsAggregate$2, false)
        };
        $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
        $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
        var rhsMsg$2 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
        var rhsCut$2 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
        var endCut$2 = (!(!(rhsCut$2 | oldCut$2)));
        if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2))) {
          $n(evidence$6).freshFailure__I__Lfastparse_ParsingRun(startPos$7)
        };
        $n(evidence$6).Lfastparse_ParsingRun__f_cut = endCut$2;
        if (verboseFailures$2) {
          var this$49 = $n(evidence$6);
          var msgToSet$1 = $n(lhsMsg$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2);
          var rassoc$3$3 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var msgToAggregate$1 = $n(lhsAggregate$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$3);
          this$49.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$7, msgToSet$1, msgToAggregate$1, false)
        }
      };
      var rhsAggregate$macro$112 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$113 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$119 = evidence$6
      } else {
        var postRhsIndex$macro$110 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$115 = (postRhsIndex$macro$110 > preRhsIndex$macro$109);
        var nextIndex$macro$118 = (((!rhsMadeProgress$macro$115) && $n(input$macro$116).isReachable__I__Z(postRhsIndex$macro$110)) ? postLhsIndex$macro$108 : postRhsIndex$macro$110);
        if ((rhsMadeProgress$macro$115 && $n(evidence$6).checkForDrop__Z())) {
          $n(input$macro$116)
        };
        var $$x7 = $n(evidence$6);
        $n(x1$3);
        var t = $as_T7(lhsValue$macro$117);
        $n(evidence$6);
        var res$macro$119 = $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$118)
      };
      if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$107, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$114, rhsMsg$macro$113), $n(lhsAggregate$macro$111).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$112), (preRhsIndex$macro$109 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$29 = res$macro$119
    }
  };
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("fieldMatch").Lsourcecode_Name__f_value, $n(x1$29).Lfastparse_ParsingRun__f_index, $n(x1$29).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$29).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x8 = $n(x1$29);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("fieldMatch").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$29).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$29).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$29).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x9 = $n(x1$29);
      var self = new $c_Lsourcecode_Name("fieldMatch").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$57 = $n($n(x1$29).Lfastparse_ParsingRun__f_failureStack);
      $$x9.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$57)
    }
  };
  if ((!$n(x1$29).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$29
  } else {
    var $$x10 = $n(x1$29);
    var this$59 = $m_Lcom_iz2use_react_components_internal_multiview_FieldMatch$();
    $$x10.Lfastparse_ParsingRun__f_successValue = $n($f_F7__tupled__F1(this$59)).apply__O__O($as_T7($n(x1$29).Lfastparse_ParsingRun__f_successValue));
    return x1$29
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.rest__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$7) {
  var startIndex = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$7).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("rest").Lsourcecode_Name__f_value, startIndex)
  };
  var startPos = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var elem = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  var startIndex$macro$45 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var count$macro$46 = 0;
  var lastAgg$macro$51 = null;
  while (true) {
    $n(evidence$7).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$46 < 1));
    $m_Lfastparse_package$();
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex$macro$28 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
    var input$macro$37 = $n(evidence$7).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    $m_Lfastparse_package$();
    var startPos$1 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
    var startCut = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
    var oldNoCut = $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer;
    $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer = true;
    var startTerminals = $n(evidence$7).Lfastparse_ParsingRun__f_failureTerminalAggregate;
    var oldCut = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
    $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
    var startPos$2 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
    $m_Lfastparse_package$();
    $m_Lcom_iz2use_react_components_internal_multiview_QueryParser$().fieldMatch__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
    var lhsMsg = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
    var lhsAggregate = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ($n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) {
      $n(evidence$7).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$7).Lfastparse_ParsingRun__f_cut | oldCut)))
    } else if ((!$n(evidence$7).Lfastparse_ParsingRun__f_cut)) {
      var verboseFailures = $n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures;
      $n(evidence$7).Lfastparse_ParsingRun__f_index = startPos$2;
      if (verboseFailures) {
        var this$7 = $n(evidence$7);
        this$7.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg, lhsAggregate, false)
      };
      $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
      $m_Lfastparse_Implicits$Sequencer$();
      var preLhsIndex$macro$13 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      var input$macro$22 = $n(evidence$7).Lfastparse_ParsingRun__f_input;
      $m_Lfastparse_package$();
      var elem$2 = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
      var elem$3 = false;
      elem$3 = elem$2;
      var startIndex$macro$4 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      var count$macro$5 = 0;
      var lastAgg$macro$10 = null;
      while (true) {
        $n(evidence$7).Lfastparse_ParsingRun__f_cut = (elem$3 && (count$macro$5 < 1));
        var input = $n(evidence$7).Lfastparse_ParsingRun__f_input;
        var index = $n(evidence$7).Lfastparse_ParsingRun__f_index;
        if ($n(input).isReachable__I__Z(index)) {
          var this$10 = $n(input);
          var this$11 = $n(this$10.Lfastparse_IndexedParserInput__f_data);
          var $$x1 = ($charAt(this$11, index) === 32)
        } else {
          var $$x1 = false
        };
        if ($$x1) {
          $n(evidence$7).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
        } else {
          $n(evidence$7).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$7).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\" \"")))
        };
        var parsedMsg$macro$9 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
        var parsedAgg$macro$11 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
        elem$3 = (!(!(elem$3 | $n(evidence$7).Lfastparse_ParsingRun__f_cut)));
        if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$1 = ($n(evidence$7).Lfastparse_ParsingRun__f_cut ? evidence$7 : ((count$macro$5 < 1) ? $n(evidence$7).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$3) : $n(evidence$7).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$4, elem$3)));
          if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
            var $$x5 = $n(evidence$7);
            var $$x4 = startIndex$macro$4;
            var $$x3 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
              var this$13 = $n(parsedMsg$macro$9);
              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$13.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
            }))(parsedMsg$macro$9));
            if ((lastAgg$macro$10 === null)) {
              var $$x2 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate
            } else {
              var rassoc$1 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var $$x2 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
            };
            $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x4, $$x3, $$x2)
          };
          break
        } else {
          var beforeSepIndex$macro$6 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
          $n(evidence$7);
          $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
          if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$7)
          };
          if ((!((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$7).Lfastparse_ParsingRun__f_cut))) {
            $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
            var temp$count$macro$5 = ((1 + count$macro$5) | 0);
            startIndex$macro$4 = beforeSepIndex$macro$6;
            count$macro$5 = temp$count$macro$5;
            lastAgg$macro$10 = parsedAgg$macro$11;
            continue
          };
          break
        }
      };
      if ($n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) {
        var postLhsIndex$macro$14 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
        var lhsAggregate$macro$17 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var lhsMsg$macro$20 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
        if (((postLhsIndex$macro$14 > preLhsIndex$macro$13) && $n(evidence$7).checkForDrop__Z())) {
          $n(input$macro$22)
        };
        $n(evidence$7);
        if ((!((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$7).Lfastparse_ParsingRun__f_cut))) {
          var preRhsIndex$macro$15 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
          var rhsAggregate$macro$18 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var rhsMsg$macro$19 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
          if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
            /*<skip>*/
          } else {
            var postRhsIndex$macro$16 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
            var rhsMadeProgress$macro$21 = (postRhsIndex$macro$16 > preRhsIndex$macro$15);
            var nextIndex$macro$24 = (((!rhsMadeProgress$macro$21) && $n(input$macro$22).isReachable__I__Z(postRhsIndex$macro$16)) ? postLhsIndex$macro$14 : postRhsIndex$macro$16);
            if ((rhsMadeProgress$macro$21 && $n(evidence$7).checkForDrop__Z())) {
              $n(input$macro$22)
            };
            var $$x6 = $n(evidence$7);
            $n(evidence$7);
            var v = (void 0);
            $n($$x6).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$24)
          };
          if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$13, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$20, rhsMsg$macro$19), $n(lhsAggregate$macro$17).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$18), (preRhsIndex$macro$15 === $n(evidence$7).Lfastparse_ParsingRun__f_traceIndex))
          }
        }
      };
      var rhsMsg = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
      var rhsCut = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
      var endCut = (!(!(rhsCut | oldCut)));
      if (((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
        $n(evidence$7).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
      };
      $n(evidence$7).Lfastparse_ParsingRun__f_cut = endCut;
      if (verboseFailures) {
        var this$15 = $n(evidence$7);
        var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
        var rassoc$3 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
        this$15.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet, msgToAggregate, false)
      }
    };
    $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
    var msg = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
    var res$2 = ($n(evidence$7).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$7).freshFailure__I__Lfastparse_ParsingRun(startPos$1) : $n(evidence$7).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$1));
    if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$7).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
      $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
      $n(evidence$7).setMsg__I__F0__V(startPos$1, new $c_sjsr_AnonFunction0(((msg) => (() => {
        var this$16 = $n(msg);
        return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$16.Lfastparse_internal_Msgs__f_value))
      }))(msg)))
    };
    $n(res$2).Lfastparse_ParsingRun__f_cut = startCut;
    if ($n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) {
      var postLhsIndex$macro$29 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$32 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$35 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
      if (((postLhsIndex$macro$29 > preLhsIndex$macro$28) && $n(evidence$7).checkForDrop__Z())) {
        $n(input$macro$37)
      };
      $n(evidence$7);
      if ((!((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$7).Lfastparse_ParsingRun__f_cut))) {
        var preRhsIndex$macro$30 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
        var rhsAggregate$macro$33 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$34 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
          /*<skip>*/
        } else {
          var postRhsIndex$macro$31 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$36 = (postRhsIndex$macro$31 > preRhsIndex$macro$30);
          var nextIndex$macro$39 = (((!rhsMadeProgress$macro$36) && $n(input$macro$37).isReachable__I__Z(postRhsIndex$macro$31)) ? postLhsIndex$macro$29 : postRhsIndex$macro$31);
          if ((rhsMadeProgress$macro$36 && $n(evidence$7).checkForDrop__Z())) {
            $n(input$macro$37)
          };
          var $$x7 = $n(evidence$7);
          $n(evidence$7);
          var v$1 = (void 0);
          $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$39)
        };
        if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$28, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$35, rhsMsg$macro$34), $n(lhsAggregate$macro$32).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$33), (preRhsIndex$macro$30 === $n(evidence$7).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    };
    var parsedMsg$macro$50 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$52 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$7).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
      var res$3 = ($n(evidence$7).Lfastparse_ParsingRun__f_cut ? evidence$7 : ((count$macro$46 < 1) ? $n(evidence$7).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$45, elem$1) : $n(evidence$7).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$45, elem$1)));
      if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x11 = $n(evidence$7);
        var $$x10 = startIndex$macro$45;
        var $$x9 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$50) => (() => {
          var this$18 = $n(parsedMsg$macro$50);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$18.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
        }))(parsedMsg$macro$50));
        if ((lastAgg$macro$51 === null)) {
          var $$x8 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$4 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x8 = $n(lastAgg$macro$51).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$4)
        };
        $n($$x11).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x10, $$x9, $$x8)
      };
      break
    } else {
      var beforeSepIndex$macro$47 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      $n(evidence$7);
      $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
      if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$7)
      };
      if ((!((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$7).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$46 = ((1 + count$macro$46) | 0);
        startIndex$macro$45 = beforeSepIndex$macro$47;
        count$macro$46 = temp$count$macro$46;
        lastAgg$macro$51 = parsedAgg$macro$52;
        continue
      };
      break
    }
  };
  $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var x1$5$1 = ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) ? evidence$7 : $n(evidence$7).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$7).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$7).Lfastparse_ParsingRun__f_index)));
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("rest").Lsourcecode_Name__f_value, $n(x1$5$1).Lfastparse_ParsingRun__f_index, $n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5$1).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x12 = $n(x1$5$1);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("rest").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x12).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5$1).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5$1).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x13 = $n(x1$5$1);
      var self = new $c_Lsourcecode_Name("rest").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$27 = $n($n(x1$5$1).Lfastparse_ParsingRun__f_failureStack);
      $$x13.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$27)
    }
  };
  return x1$5$1
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.parseQuery__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$8) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$8).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$8).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("parseQuery").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$65 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var input$macro$74 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$50 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var input$macro$59 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$24 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var input$macro$33 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var elem = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  var startIndex$macro$4 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var count$macro$5 = 0;
  var lastAgg$macro$10 = null;
  while (true) {
    $n(evidence$8).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 0));
    var input = $n(evidence$8).Lfastparse_ParsingRun__f_input;
    var index = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    if ($n(input).isReachable__I__Z(index)) {
      var this$5 = $n(input);
      var this$6 = $n(this$5.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$6, index) === 32)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(evidence$8).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
    } else {
      $n(evidence$8).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$8).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\" \"")))
    };
    var parsedMsg$macro$9 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$11 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$8).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
      var res$1 = ($n(evidence$8).Lfastparse_ParsingRun__f_cut ? evidence$8 : ((count$macro$5 < 0) ? $n(evidence$8).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$8).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$4, elem$1)));
      if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x5 = $n(evidence$8);
        var $$x4 = startIndex$macro$4;
        var $$x3 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
          var this$8 = $n(parsedMsg$macro$9);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".rep")
        }))(parsedMsg$macro$9));
        if ((lastAgg$macro$10 === null)) {
          var $$x2 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$1 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x2 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
        };
        $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x4, $$x3, $$x2)
      };
      break
    } else {
      var beforeSepIndex$macro$6 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      $n(evidence$8);
      $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
      if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$8)
      };
      if ((!((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$5 = ((1 + count$macro$5) | 0);
        startIndex$macro$4 = beforeSepIndex$macro$6;
        count$macro$5 = temp$count$macro$5;
        lastAgg$macro$10 = parsedAgg$macro$11;
        continue
      };
      break
    }
  };
  if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$25 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$28 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$31 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$25 > preLhsIndex$macro$24) && $n(evidence$8).checkForDrop__Z())) {
      $n(input$macro$33)
    };
    $n(evidence$8);
    if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$26 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var this$10 = $m_Lfastparse_Implicits$Repeater$();
      var x1$11 = this$10.GenericRepeatedImplicit0__Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$();
      var elem$2 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
      var elem$3 = false;
      elem$3 = elem$2;
      $n(x1$11);
      var acc$macro$14 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
      var startIndex$macro$15 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var count$macro$16 = 0;
      var lastAgg$macro$21 = null;
      while (true) {
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
        $m_Lfastparse_package$();
        var oldCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
        var startPos = $n(evidence$8).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$();
        $m_Lcom_iz2use_react_components_internal_multiview_QueryParser$().fieldMatch__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
        var lhsMsg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
        var lhsAggregate = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
          $n(evidence$8).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$8).Lfastparse_ParsingRun__f_cut | oldCut)))
        } else if ((!$n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
          var verboseFailures = $n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures;
          $n(evidence$8).Lfastparse_ParsingRun__f_index = startPos;
          if (verboseFailures) {
            var this$15 = $n(evidence$8);
            this$15.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
          };
          $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
          $m_Lcom_iz2use_react_components_internal_multiview_QueryParser$().rest__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
          var rhsMsg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
          var rhsCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
          var endCut = (!(!(rhsCut | oldCut)));
          if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
            $n(evidence$8).freshFailure__I__Lfastparse_ParsingRun(startPos)
          };
          $n(evidence$8).Lfastparse_ParsingRun__f_cut = endCut;
          if (verboseFailures) {
            var this$16 = $n(evidence$8);
            var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
            var rassoc$3 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
            this$16.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
          }
        };
        var parsedMsg$macro$20 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
        var parsedAgg$macro$22 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
        elem$3 = (!(!(elem$3 | $n(evidence$8).Lfastparse_ParsingRun__f_cut)));
        if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
          if ($n(evidence$8).Lfastparse_ParsingRun__f_cut) {
            var res$2 = evidence$8
          } else {
            var $$x6 = $n(evidence$8);
            $n(x1$11);
            var this$18 = $n(acc$macro$14);
            var res$2 = $n($$x6).freshSuccess__O__I__Z__Lfastparse_ParsingRun($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$18), startIndex$macro$15, elem$3)
          };
          if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
            var $$x10 = $n(evidence$8);
            var $$x9 = startIndex$macro$15;
            var $$x8 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$20) => (() => {
              var this$19 = $n(parsedMsg$macro$20);
              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$19.Lfastparse_internal_Msgs__f_value) + ".rep")
            }))(parsedMsg$macro$20));
            if ((lastAgg$macro$21 === null)) {
              var $$x7 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate
            } else {
              var rassoc$2 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var $$x7 = $n(lastAgg$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
            };
            $n($$x10).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x9, $$x8, $$x7)
          };
          break
        } else {
          var beforeSepIndex$macro$17 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          $n(x1$11);
          var t = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
          var this$21 = $n(acc$macro$14);
          this$21.addOne__O__scm_Growable(t);
          $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
          if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$8)
          };
          if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
            break
          } else {
            $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
            var temp$count$macro$16 = ((1 + count$macro$16) | 0);
            startIndex$macro$15 = beforeSepIndex$macro$17;
            count$macro$16 = temp$count$macro$16;
            lastAgg$macro$21 = parsedAgg$macro$22
          }
        }
      };
      var rhsAggregate$macro$29 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$30 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$36 = evidence$8
      } else {
        var postRhsIndex$macro$27 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$32 = (postRhsIndex$macro$27 > preRhsIndex$macro$26);
        var nextIndex$macro$35 = (((!rhsMadeProgress$macro$32) && $n(input$macro$33).isReachable__I__Z(postRhsIndex$macro$27)) ? postLhsIndex$macro$25 : postRhsIndex$macro$27);
        if ((rhsMadeProgress$macro$32 && $n(evidence$8).checkForDrop__Z())) {
          $n(input$macro$33)
        };
        var $$x11 = $n(evidence$8);
        var v = $as_sci_Seq($n(evidence$8).Lfastparse_ParsingRun__f_successValue);
        var res$macro$36 = $n($$x11).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$35)
      };
      if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$24, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$31, rhsMsg$macro$30), $n(lhsAggregate$macro$28).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$29), (preRhsIndex$macro$26 === $n(evidence$8).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$51 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$54 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$57 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$51 > preLhsIndex$macro$50) && $n(evidence$8).checkForDrop__Z())) {
      $n(input$macro$59)
    };
    var lhsValue$macro$60 = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$52 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var elem$4 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
      var elem$5 = false;
      elem$5 = elem$4;
      var startIndex$macro$41 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var count$macro$42 = 0;
      var lastAgg$macro$47 = null;
      while (true) {
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = (elem$5 && (count$macro$42 < 0));
        var input$1 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
        var index$1 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
        if ($n(input$1).isReachable__I__Z(index$1)) {
          var this$24 = $n(input$1);
          var this$25 = $n(this$24.Lfastparse_IndexedParserInput__f_data);
          var $$x12 = ($charAt(this$25, index$1) === 32)
        } else {
          var $$x12 = false
        };
        if ($$x12) {
          $n(evidence$8).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$1) | 0))
        } else {
          $n(evidence$8).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$8).aggregateTerminal__I__F0__V(index$1, new $c_sjsr_AnonFunction0((() => "\" \"")))
        };
        var parsedMsg$macro$46 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
        var parsedAgg$macro$48 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
        elem$5 = (!(!(elem$5 | $n(evidence$8).Lfastparse_ParsingRun__f_cut)));
        if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$4 = ($n(evidence$8).Lfastparse_ParsingRun__f_cut ? evidence$8 : ((count$macro$42 < 0) ? $n(evidence$8).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$41, elem$5) : $n(evidence$8).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$41, elem$5)));
          if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
            var $$x16 = $n(evidence$8);
            var $$x15 = startIndex$macro$41;
            var $$x14 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$46) => (() => {
              var this$27 = $n(parsedMsg$macro$46);
              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$27.Lfastparse_internal_Msgs__f_value) + ".rep")
            }))(parsedMsg$macro$46));
            if ((lastAgg$macro$47 === null)) {
              var $$x13 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate
            } else {
              var rassoc$4 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var $$x13 = $n(lastAgg$macro$47).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$4)
            };
            $n($$x16).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x15, $$x14, $$x13)
          };
          break
        } else {
          var beforeSepIndex$macro$43 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          $n(evidence$8);
          $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
          if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$8)
          };
          if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
            break
          } else {
            $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
            var temp$count$macro$42 = ((1 + count$macro$42) | 0);
            startIndex$macro$41 = beforeSepIndex$macro$43;
            count$macro$42 = temp$count$macro$42;
            lastAgg$macro$47 = parsedAgg$macro$48
          }
        }
      };
      var rhsAggregate$macro$55 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$56 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$62 = evidence$8
      } else {
        var postRhsIndex$macro$53 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$58 = (postRhsIndex$macro$53 > preRhsIndex$macro$52);
        var nextIndex$macro$61 = (((!rhsMadeProgress$macro$58) && $n(input$macro$59).isReachable__I__Z(postRhsIndex$macro$53)) ? postLhsIndex$macro$51 : postRhsIndex$macro$53);
        if ((rhsMadeProgress$macro$58 && $n(evidence$8).checkForDrop__Z())) {
          $n(input$macro$59)
        };
        var $$x17 = $n(evidence$8);
        $n(x1$5);
        var t$1 = $as_sci_Seq(lhsValue$macro$60);
        $n(evidence$8);
        var res$macro$62 = $n($$x17).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$61)
      };
      if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$50, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$57, rhsMsg$macro$56), $n(lhsAggregate$macro$54).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$55), (preRhsIndex$macro$52 === $n(evidence$8).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$14 = evidence$8
  } else {
    var postLhsIndex$macro$66 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$69 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$72 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$66 > preLhsIndex$macro$65) && $n(evidence$8).checkForDrop__Z())) {
      $n(input$macro$74)
    };
    var lhsValue$macro$75 = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
      var x1$14 = evidence$8
    } else {
      var preRhsIndex$macro$67 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
      var rhsAggregate$macro$70 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$71 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$77 = evidence$8
      } else {
        var postRhsIndex$macro$68 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$73 = (postRhsIndex$macro$68 > preRhsIndex$macro$67);
        var nextIndex$macro$76 = (((!rhsMadeProgress$macro$73) && $n(input$macro$74).isReachable__I__Z(postRhsIndex$macro$68)) ? postLhsIndex$macro$66 : postRhsIndex$macro$68);
        if ((rhsMadeProgress$macro$73 && $n(evidence$8).checkForDrop__Z())) {
          $n(input$macro$74)
        };
        var $$x18 = $n(evidence$8);
        $n(x1$3);
        var t$2 = $as_sci_Seq(lhsValue$macro$75);
        $n(evidence$8);
        var res$macro$77 = $n($$x18).freshSuccess__O__I__Lfastparse_ParsingRun(t$2, nextIndex$macro$76)
      };
      if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$65, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$72, rhsMsg$macro$71), $n(lhsAggregate$macro$69).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$70), (preRhsIndex$macro$67 === $n(evidence$8).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$14 = res$macro$77
    }
  };
  if (instrument) {
    $n($n(evidence$8).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("parseQuery").Lsourcecode_Name__f_value, $n(x1$14).Lfastparse_ParsingRun__f_index, $n(x1$14).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$14).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x19 = $n(x1$14);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("parseQuery").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x19).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$14).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$14).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$14).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x20 = $n(x1$14);
      var self = new $c_Lsourcecode_Name("parseQuery").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$38 = $n($n(x1$14).Lfastparse_ParsingRun__f_failureStack);
      $$x20.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$38)
    }
  };
  if ((!$n(x1$14).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$14
  } else {
    var $$x21 = $n(x1$14);
    var arg1 = $as_sci_Seq($n(x1$14).Lfastparse_ParsingRun__f_successValue);
    $$x21.Lfastparse_ParsingRun__f_successValue = $as_T2($n(arg1).foldLeft__O__F2__O($ct_T2__O__O__(new $c_T2(), $m_s_package$().s_package$__f_Nil, $m_s_package$().s_package$__f_Nil), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1$2);
      var p2 = $as_T2(x1.T2__f__1);
      var c = x1.T2__f__2;
      if ((p2 !== null)) {
        var str = $as_sci_Seq($n(p2)._1__O());
        var fields = $as_sci_Seq($n(p2)._2__O());
        if (((typeof c) === "string")) {
          var x3 = $as_T(c);
          var this$41 = $n(str);
          return $ct_T2__O__O__(new $c_T2(), this$41.appended__O__O(x3), fields)
        }
      };
      var p4 = $as_T2(x1.T2__f__1);
      var c$2 = x1.T2__f__2;
      if ((p4 !== null)) {
        var str$2 = $as_sci_Seq($n(p4)._1__O());
        var fields$2 = $as_sci_Seq($n(p4)._2__O());
        if ((c$2 instanceof $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch)) {
          var x5 = $as_Lcom_iz2use_react_components_internal_multiview_FieldMatch(c$2);
          var this$42 = $n(fields$2);
          return $ct_T2__O__O__(new $c_T2(), str$2, this$42.appended__O__O(x5))
        }
      };
      throw new $c_s_MatchError(x1)
    }))));
    return x1$14
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.fieldExists__s_Option__T__Lcats_data_Validated = (function(fieldOpt, fieldId) {
  $m_Lcats_data_Validated$();
  var this$2 = $n(fieldOpt);
  if (this$2.isEmpty__Z()) {
    $m_Lcats_data_NonEmptyList$();
    var head = new $c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError(fieldId, "field not found");
    var tail = $m_sci_Nil$();
    var e = new $c_Lcats_data_NonEmptyList(head, tail);
    var $$x1 = new $c_Lcats_data_Validated$Invalid(e)
  } else {
    var arg1 = this$2.get__O();
    var $$x1 = new $c_Lcats_data_Validated$Valid(arg1)
  };
  return $as_Lcats_data_Validated($$x1)
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.fieldParsing__Lcom_iz2use_react_components_internal_multiview_FieldRenderer__T__T__Lcats_data_Validated = (function(fieldRenderer, name, value) {
  var x1 = $n(fieldRenderer).parse__T__s_util_Try(value);
  if ((x1 instanceof $c_s_util_Success)) {
    var x2 = $as_s_util_Success(x1);
    var v = $n(x2).s_util_Success__f_value;
    $m_Lcats_data_Validated$();
    return new $c_Lcats_data_Validated$Valid(v)
  } else if ((x1 instanceof $c_s_util_Failure)) {
    var x3 = $as_s_util_Failure(x1);
    var e = $n(x3).s_util_Failure__f_exception;
    var this$2 = $m_Lcats_data_Validated$();
    var e$1 = new $c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError(name, $n(e).getMessage__T());
    return $f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$2, e$1)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.apply__T__Lcom_iz2use_common_Filter__sci_Seq__Lcats_data_Validated = (function(in$1, filter, fieldRenderers) {
  var $$x1 = $m_Lfastparse_package$();
  var conv = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    return new $c_Lfastparse_IndexedParserInput(s)
  }));
  var x1 = $n($$x1).parse__Lfastparse_ParserInputSource__F1__Z__I__Lfastparse_internal_Instrument__Lfastparse_Parsed(new $c_Lfastparse_ParserInputSource$fromParserInput(in$1, conv), new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Lfastparse_ParsingRun(x$10$2);
    return $m_Lcom_iz2use_react_components_internal_multiview_QueryParser$().parseQuery__Lfastparse_ParsingRun__Lfastparse_ParsingRun(x$10)
  })), ($m_Lfastparse_package$(), false), ($m_Lfastparse_package$(), 0), ($m_Lfastparse_package$(), null));
  if ((x1 instanceof $c_Lfastparse_Parsed$Success)) {
    var x2 = $as_Lfastparse_Parsed$Success(x1);
    var p3 = $as_T2($n(x2).Lfastparse_Parsed$Success__f_value);
    if ((p3 !== null)) {
      var str = $as_sci_Seq($n(p3)._1__O());
      var fields = $as_sci_Seq($n(p3)._2__O());
      if ($n(fields).isEmpty__Z()) {
        $m_Lcats_data_Validated$();
        var tokenized = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$().tokenize__T__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_SeqTokenized(in$1, filter);
        var a = new $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(in$1, $m_s_package$().s_package$__f_Nil, in$1, tokenized);
        return new $c_Lcats_data_Validated$Valid(a)
      } else {
        var this$15 = $n($as_Lcats_data_Validated($n($as_sc_IterableOnceOps($n(fields).map__F1__O(new $c_sjsr_AnonFunction1(((field$2) => {
          var field = $as_Lcom_iz2use_react_components_internal_multiview_FieldMatch(field$2);
          var search = $n(filter).prepare__T__T($n(field).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_name);
          var fieldOpt = $n(fieldRenderers).collectFirst__s_PartialFunction__s_Option(new $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1(search));
          var this$5 = $n(fieldOpt);
          if (this$5.isEmpty__Z()) {
            var name = $n(field).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_name
          } else {
            var arg1 = this$5.get__O();
            var x$11 = $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(arg1);
            var name = $n($n(x$11).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key).s_Symbol__f_name
          };
          var validated = $m_Lcom_iz2use_react_components_internal_multiview_QueryParser$().fieldExists__s_Option__T__Lcats_data_Validated(fieldOpt, name);
          var this$7 = new $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated(validated);
          var this$8 = $n(this$7.Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated__f_validated);
          if ((this$8 instanceof $c_Lcats_data_Validated$Valid)) {
            var x2$1 = $as_Lcats_data_Validated$Valid(this$8);
            var a$1 = $n(x2$1).Lcats_data_Validated$Valid__f_a;
            var fieldRenderer = $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(a$1);
            var this$9 = $n($m_Lcom_iz2use_react_components_internal_multiview_QueryParser$().fieldParsing__Lcom_iz2use_react_components_internal_multiview_FieldRenderer__T__T__Lcats_data_Validated(fieldRenderer, name, $n(field).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_value));
            if ((this$9 instanceof $c_Lcats_data_Validated$Invalid)) {
              var x2$2 = $as_Lcats_data_Validated$Invalid(this$9);
              return x2$2
            } else {
              if ((!(this$9 instanceof $c_Lcats_data_Validated$Valid))) {
                throw new $c_s_MatchError(this$9)
              };
              var x4 = $as_Lcats_data_Validated$Valid(this$9);
              var a$2 = $n(x4).Lcats_data_Validated$Valid__f_a;
              $n($m_s_package$().s_package$__f_List);
              var array = [new $c_Lcom_iz2use_react_components_internal_multiview_MatchingField($n(field).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_negative, name, $n(field).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_operator, a$2, fieldRenderer)];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return new $c_Lcats_data_Validated$Valid($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems))
            }
          } else if ((this$8 instanceof $c_Lcats_data_Validated$Invalid)) {
            var x3 = $as_Lcats_data_Validated$Invalid(this$8);
            return x3
          } else {
            throw new $c_s_MatchError(this$8)
          }
        }))))).reduceLeft__F2__O(new $c_sjsr_AnonFunction2(((x$12$2, x$13$2) => {
          var x$12 = $as_Lcats_data_Validated(x$12$2);
          var x$13 = $as_Lcats_data_Validated(x$13$2);
          return $n(x$12).combine__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_kernel_Semigroup__Lcats_data_Validated(x$13, $m_Lcats_data_NonEmptyList$().catsDataSemigroupForNonEmptyList__Lcats_kernel_Semigroup(), ($m_Lcats_implicits$(), new $c_Lcats_kernel_instances_ListMonoid()))
        })))));
        if ((this$15 instanceof $c_Lcats_data_Validated$Invalid)) {
          var x2$3 = $as_Lcats_data_Validated$Invalid(this$15);
          return x2$3
        } else if ((this$15 instanceof $c_Lcats_data_Validated$Valid)) {
          var x4$1 = $as_Lcats_data_Validated$Valid(this$15);
          var a$3 = $n(x4$1).Lcats_data_Validated$Valid__f_a;
          var filters = $as_sci_List(a$3);
          var this$16 = $n(str);
          var rest = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$16, "", " ", "");
          var tokenized$1 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$().tokenize__T__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_SeqTokenized(rest, filter);
          return new $c_Lcats_data_Validated$Valid(new $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(in$1, $n(filters), rest, tokenized$1))
        } else {
          throw new $c_s_MatchError(this$15)
        }
      }
    }
  };
  if ((x1 instanceof $c_Lfastparse_Parsed$Failure)) {
    var x5 = $as_Lfastparse_Parsed$Failure(x1);
    var o12 = $m_Lfastparse_Parsed$Failure$().unapply__Lfastparse_Parsed$Failure__s_Option(x5);
    if ((!$n(o12).isEmpty__Z())) {
      var this$17 = $m_Lcats_data_Validated$();
      var e = new $c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError($n(x5).toString__T());
      return $f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$17, e)
    }
  };
  throw new $c_s_MatchError(x1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_QueryParser$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_QueryParser$: 0
}, false, "com.iz2use.react.components.internal.multiview.QueryParser$", {
  Lcom_iz2use_react_components_internal_multiview_QueryParser$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_QueryParser$;
var $n_Lcom_iz2use_react_components_internal_multiview_QueryParser$;
function $m_Lcom_iz2use_react_components_internal_multiview_QueryParser$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_QueryParser$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_QueryParser$ = new $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_QueryParser$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated(validated) {
  this.Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated__f_validated = null;
  this.Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated__f_validated = validated
}
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated.prototype = $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated: 0
}, false, "com.iz2use.react.components.internal.multiview.QueryParser$RichValidated", {
  Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_QueryParser$RichValidated;
function $is_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState)))
}
function $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState(obj) {
  return (($is_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.SearchRefiner$InternalState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.SearchRefiner$InternalState;", depth))
}
function $p_Lcom_iz2use_react_components_internal_multiview_SlideshowView$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("SlideshowView", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState()
  })))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$() {
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_multiview_SlideshowView$ = this;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$__f_component = $n($n($n($p_Lcom_iz2use_react_components_internal_multiview_SlideshowView$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$.prototype.apply__s_Option__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_RenderItem__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(active, items, renderItem, keyMapper, context, iterator) {
  var c = this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps(active, items, renderItem, keyMapper, context, iterator);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_multiview_SlideshowView$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SlideshowView$: 0
}, false, "com.iz2use.react.components.internal.multiview.SlideshowView$", {
  Lcom_iz2use_react_components_internal_multiview_SlideshowView$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SlideshowView$;
var $n_Lcom_iz2use_react_components_internal_multiview_SlideshowView$;
function $m_Lcom_iz2use_react_components_internal_multiview_SlideshowView$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_SlideshowView$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_SlideshowView$ = new $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_SlideshowView$
}
function $is_Lcom_iz2use_react_components_internal_multiview_Updateable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_internal_multiview_Updateable)))
}
function $as_Lcom_iz2use_react_components_internal_multiview_Updateable(obj) {
  return (($is_Lcom_iz2use_react_components_internal_multiview_Updateable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.Updateable"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_Updateable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_Updateable)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_Updateable(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_Updateable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.Updateable;", depth))
}
function $is_Lcom_iz2use_react_components_internal_multiview_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_internal_multiview_View)))
}
function $as_Lcom_iz2use_react_components_internal_multiview_View(obj) {
  return (($is_Lcom_iz2use_react_components_internal_multiview_View(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.View"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_View)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_View(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_View(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.View;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_View$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_View$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_View$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_View$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_View$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_View$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_View$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_View$.prototype.keyMapper__F1 = (function() {
  return $m_Lcom_iz2use_common_Key$().from__F1__F1(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lcom_iz2use_react_components_internal_multiview_View(x$1$2);
    return $n(x$1).name__T()
  })))
});
$c_Lcom_iz2use_react_components_internal_multiview_View$.prototype.defaultViewOrdering__s_math_Ordering = (function() {
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lcom_iz2use_react_components_internal_multiview_View(x$2$2);
    return $n(x$2).defaultOrder__I()
  }));
  var ord = $m_s_math_Ordering$Int$();
  return new $c_s_math_Ordering$$anon$5(ord, f)
});
var $d_Lcom_iz2use_react_components_internal_multiview_View$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_View$: 0
}, false, "com.iz2use.react.components.internal.multiview.View$", {
  Lcom_iz2use_react_components_internal_multiview_View$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_View$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_View$;
var $n_Lcom_iz2use_react_components_internal_multiview_View$;
function $m_Lcom_iz2use_react_components_internal_multiview_View$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_View$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_View$ = new $c_Lcom_iz2use_react_components_internal_multiview_View$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_View$
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  if ((b$1$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().always__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  if ((b$2$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  if ((b$3$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$3$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    $m_Lcom_iz2use_react_components_package$();
    var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$2.byRef__F2(), this$2.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$3$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  return ($n(b$3$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  if ((b$4$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$4$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$4$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  return ($n(b$4$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$5$lzycompute$1__sr_LazyRef__F2($thiz, b$5$lzy$1) {
  if ((b$5$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$5$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$5$1__sr_LazyRef__F2($thiz, b$5$lzy$1) {
  return ($n(b$5$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$5$lzycompute$1__sr_LazyRef__F2($thiz, b$5$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$6$lzycompute$1__sr_LazyRef__F2($thiz, b$6$lzy$1) {
  if ((b$6$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$6$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$6$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$6$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$6$1__sr_LazyRef__F2($thiz, b$6$lzy$1) {
  return ($n(b$6$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$6$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$6$lzycompute$1__sr_LazyRef__F2($thiz, b$6$lzy$1))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$() {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$__f_newIcon = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_multiview_grid_GridView$ = this;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$__f_newIcon = (("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" width=\"24\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\" opacity=\"0\" /><path d=\"" + $n($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_add).Lcom_iz2use_react_components_IconSourceShape__f_shapePath) + "\" /></svg>");
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  var b$3$lzy = new $c_sr_LazyRef();
  var b$4$lzy = new $c_sr_LazyRef();
  var b$5$lzy = new $c_sr_LazyRef();
  var b$6$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(a$2);
    var b = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(b$2);
    return ((((($uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items)) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_active, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_active))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$3$1__sr_LazyRef__F2(this, b$3$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$4$1__sr_LazyRef__F2(this, b$4$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderer, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderer))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$5$1__sr_LazyRef__F2(this, b$5$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_itemSimpleActions, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_itemSimpleActions))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$__b$6$1__sr_LazyRef__F2(this, b$6$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderable, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderable)))
  }));
  elem = f;
  $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem));
  var $$x4 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var a$1$2 = $m_Ljapgolly_scalajs_react_Reusability$().always__F2();
  $n($$x4).$bar$bar$extension__F2__F2__F2($$x3, a$1$2);
  var stabilizer$1 = $n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("GridView", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x6 = $n($as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    var $$x5 = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3);
    return $n($$x6).render__Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement($$x5, $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6)))
  })));
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$__f_component = $n($n(stabilizer$1).componentDidUpdate__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(c$2);
    var $$x7 = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend($n(c).backend__O());
    var this$7 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x7).onUpdate__Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState__Ljapgolly_scalajs_react_callback_Trampoline($as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState($n(this$7.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O())))
  })), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$())).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$.prototype.apply__Ldiode_data_Pot__s_Option__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_GridRenderer__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_grid_GridRenderable__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(items, active, keyMapper, renderer, itemSimpleActions, renderable, context, hasIterator, decorator) {
  var c = this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(items, active, keyMapper, renderer, itemSimpleActions, renderable, context, hasIterator, decorator);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridView$", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$;
var $n_Lcom_iz2use_react_components_internal_multiview_grid_GridView$;
function $m_Lcom_iz2use_react_components_internal_multiview_grid_GridView$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_grid_GridView$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_grid_GridView$ = new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_grid_GridView$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$() {
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_multiview_list_ListItem$ = this;
  var b = new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ListItem", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$());
  var this$4 = $m_s_$less$colon$less$();
  var ev = this$4.s_$less$colon$less$__f_singleton;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$__f_component = $n($n(($n(ev), b).noBackend__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3()).render_P__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps(p$2);
    var model = $n(p).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_model;
    var gen = $n(p).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_map;
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$10 = $m_Lscalacss_ScalaCssReact$();
    var s = $n($n(p).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_style).Lcom_iz2use_react_style_Style__f_listItem;
    var $$x12 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s);
    var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x10 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("__check", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var $$x9 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$();
    var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("checkbox", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    var array$1 = [$$x10, $n($$x9).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var $$x8 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $n($n(p).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_renderer).Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_fields;
    var $$x5 = $n($$x6).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((field$2) => {
      var field = $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(field$2);
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$22 = $m_Lscalacss_ScalaCssReact$();
      var s$1 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_style).Lcom_iz2use_react_style_Style__f_listItemField;
      var array$2 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$22, s$1), $n(field).renderInlineFieldWithLabel__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_TagMod(gen, $m_s_None$())];
      return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    })));
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $n($n(p).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_itemSimpleActions);
    var as$1 = $m_s_package$().s_package$__f_Nil;
    var array$5 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((a$2) => {
      var a = $as_Lcom_iz2use_react_components_internal_multiview_Action(a$2);
      var x1 = $n(a).icon__Lcom_iz2use_react_components_IconSource();
      var x = $m_Lcom_iz2use_react_components_NoIconSource$();
      if ((x === x1)) {
        var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = $n(a).name__T();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(a).description__T(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(a).action__F1()).apply__O__O(model))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
        return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      } else {
        var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$4 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($n(a).icon__Lcom_iz2use_react_components_IconSource(), "", "24px"), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(a).name__T(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(a).action__F1()).apply__O__O(model))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
        return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
      }
    })))];
    var array$6 = [$$x12, $$x8, $$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_list_ListItem$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_list_ListItem$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$.prototype.withKey__T__O__sci_Map__Lcom_iz2use_react_components_internal_multiview_ListRenderer__s_Option__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, model, map, renderer, editing, itemSimpleActions, style) {
  var c = this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps(key, model, map, renderer, editing, itemSimpleActions, style);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_multiview_list_ListItem$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_list_ListItem$: 0
}, false, "com.iz2use.react.components.internal.multiview.list.ListItem$", {
  Lcom_iz2use_react_components_internal_multiview_list_ListItem$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_list_ListItem$;
var $n_Lcom_iz2use_react_components_internal_multiview_list_ListItem$;
function $m_Lcom_iz2use_react_components_internal_multiview_list_ListItem$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_list_ListItem$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_list_ListItem$ = new $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_list_ListItem$
}
function $is_Lcom_iz2use_react_components_internal_multiview_table_Editing(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_internal_multiview_table_Editing)))
}
function $as_Lcom_iz2use_react_components_internal_multiview_table_Editing(obj) {
  return (($is_Lcom_iz2use_react_components_internal_multiview_table_Editing(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.table.Editing"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_Editing(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_table_Editing)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_table_Editing(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_Editing(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.table.Editing;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_Editing$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_table_Editing$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_Editing$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_Editing$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_Editing$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_Editing$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_Editing$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_Editing$.prototype.reuseEditingItem__F2__F2 = (function(ev) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lcom_iz2use_react_components_internal_multiview_table_Editing(x$1$2);
    return $n($n(x$1).item__T2())._1__O()
  }));
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(ev, f)
});
var $d_Lcom_iz2use_react_components_internal_multiview_table_Editing$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_Editing$: 0
}, false, "com.iz2use.react.components.internal.multiview.table.Editing$", {
  Lcom_iz2use_react_components_internal_multiview_table_Editing$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_Editing$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_Editing$;
var $n_Lcom_iz2use_react_components_internal_multiview_table_Editing$;
function $m_Lcom_iz2use_react_components_internal_multiview_table_Editing$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_table_Editing$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_table_Editing$ = new $c_Lcom_iz2use_react_components_internal_multiview_table_Editing$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_table_Editing$
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__reuseEditingItem$1__F2($thiz) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lcom_iz2use_react_components_internal_multiview_table_Editing(x$1$2);
    return $n(x$1).item__T2()
  }));
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().by_$eq$eq__F2();
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = $n($$x2).tuple2__F2__F2__F2($$x1, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$2.byRef__F2(), this$2.by_$eq$eq__F2()));
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  if ((b$1$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  if ((b$2$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  if ((b$3$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$3$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$3$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  return ($n(b$3$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  if ((b$4$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$4$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$4$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  return ($n(b$4$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$5$lzycompute$1__sr_LazyRef__F2($thiz, b$5$lzy$1) {
  if ((b$5$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$5$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__reuseEditingItem$1__F2($thiz);
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$5$1__sr_LazyRef__F2($thiz, b$5$lzy$1) {
  return ($n(b$5$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$5$lzycompute$1__sr_LazyRef__F2($thiz, b$5$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$6$lzycompute$1__sr_LazyRef__F2($thiz, b$6$lzy$1) {
  if ((b$6$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$6$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$6$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$6$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$6$1__sr_LazyRef__F2($thiz, b$6$lzy$1) {
  return ($n(b$6$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$6$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$6$lzycompute$1__sr_LazyRef__F2($thiz, b$6$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$7$lzycompute$1__sr_LazyRef__F2($thiz, b$7$lzy$1) {
  if ((b$7$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$7$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$7$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$7$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$7$1__sr_LazyRef__F2($thiz, b$7$lzy$1) {
  return ($n(b$7$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$7$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$7$lzycompute$1__sr_LazyRef__F2($thiz, b$7$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$8$lzycompute$1__sr_LazyRef__F2($thiz, b$8$lzy$1) {
  if ((b$8$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$8$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$8$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$2.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$8$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$8$1__sr_LazyRef__F2($thiz, b$8$lzy$1) {
  return ($n(b$8$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$8$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$8$lzycompute$1__sr_LazyRef__F2($thiz, b$8$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$9$lzycompute$1__sr_LazyRef__F2($thiz, b$9$lzy$1) {
  if ((b$9$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$9$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$9$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$9$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$9$1__sr_LazyRef__F2($thiz, b$9$lzy$1) {
  return ($n(b$9$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$9$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$9$lzycompute$1__sr_LazyRef__F2($thiz, b$9$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$10$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$10$lzy$1, reuseDecorator$1) {
  if ((b$10$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$10$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$10$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability(reuseDecorator$1);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$10$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$10$1__sr_LazyRef__F2__F2($thiz, b$10$lzy$1, reuseDecorator$1) {
  return ($n(b$10$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$10$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$10$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$10$lzy$1, reuseDecorator$1))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$() {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$ = this;
  var this$10 = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("TabularLine", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x1 = $n($as_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    return $n($$x1).render__Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__Ljapgolly_scalajs_react_vdom_VdomNode($as_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()))
  }))));
  $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$1 = this.reusableProps__F2();
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$2 = this$5.always__F2();
  var this$8 = $m_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$();
  var f = $n(this$8.Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$__f_reusabilityOverrideInDev).apply__F2__F2__F1(evidence$1, evidence$2);
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$10))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$.prototype.reusableProps__F2 = (function() {
  var reuseDecorator = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  var b$3$lzy = new $c_sr_LazyRef();
  var b$4$lzy = new $c_sr_LazyRef();
  var b$5$lzy = new $c_sr_LazyRef();
  var b$6$lzy = new $c_sr_LazyRef();
  var b$7$lzy = new $c_sr_LazyRef();
  var b$8$lzy = new $c_sr_LazyRef();
  var b$9$lzy = new $c_sr_LazyRef();
  var b$10$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(a$2);
    var b = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(b$2);
    return ((((((((((($uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_key, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_key)) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$3$1__sr_LazyRef__F2(this, b$3$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_map, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_map))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$4$1__sr_LazyRef__F2(this, b$4$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_renderer, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_renderer))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$5$1__sr_LazyRef__F2(this, b$5$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_editing, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_editing))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$6$1__sr_LazyRef__F2(this, b$6$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_itemSimpleActions, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_itemSimpleActions))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$7$1__sr_LazyRef__F2(this, b$7$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_selected, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_selected))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$7$1__sr_LazyRef__F2(this, b$7$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_focused, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_focused))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$8$1__sr_LazyRef__F2(this, b$8$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_ref, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_ref))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$9$1__sr_LazyRef__F2(this, b$9$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActive, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActive))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$9$1__sr_LazyRef__F2(this, b$9$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActiveAndSelectView, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActiveAndSelectView))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__b$10$1__sr_LazyRef__F2__F2(this, b$10$lzy, reuseDecorator)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_decorator, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_decorator)))
  }));
  elem = f;
  return $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$.prototype.withKey__T__O__sci_Map__Lcom_iz2use_react_components_internal_multiview_TableRenderer__s_Option__Lcom_iz2use_react_components_internal_multiview_Actions__Z__Z__s_Option__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_Reusable__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, model, map, renderer, editing, itemSimpleActions, selected, focused, ref, setActive, setActiveAndSelectView, decorator) {
  var c = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(key, model, map, renderer, editing, itemSimpleActions, selected, focused, ref, setActive, setActiveAndSelectView, decorator);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_TabularLine$: 0
}, false, "com.iz2use.react.components.internal.multiview.table.TabularLine$", {
  Lcom_iz2use_react_components_internal_multiview_table_TabularLine$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$;
var $n_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$;
function $m_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$ = new $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  if ((b$1$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().always__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  if ((b$2$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  if ((b$3$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$3$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    $m_Lcom_iz2use_react_components_package$();
    var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$2.byRef__F2(), this$2.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$3$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  return ($n(b$3$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  if ((b$4$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$4$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$4$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  return ($n(b$4$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$5$lzycompute$1__sr_LazyRef__F2($thiz, b$5$lzy$1) {
  if ((b$5$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$5$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$5$1__sr_LazyRef__F2($thiz, b$5$lzy$1) {
  return ($n(b$5$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$5$lzycompute$1__sr_LazyRef__F2($thiz, b$5$lzy$1))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$() {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_multiview_table_TabularView$ = this;
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  var b$3$lzy = new $c_sr_LazyRef();
  var b$4$lzy = new $c_sr_LazyRef();
  var b$5$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(a$2);
    var b = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(b$2);
    return (((($uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items)) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_active, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_active))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$3$1__sr_LazyRef__F2(this, b$3$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$4$1__sr_LazyRef__F2(this, b$4$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$__b$5$1__sr_LazyRef__F2(this, b$5$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_itemSimpleActions, $n(b).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_itemSimpleActions)))
  }));
  elem = f;
  $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem));
  var $$x4 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem$1 = null;
  elem$1 = null;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState(x$1$2);
    return $n(x$1).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__f_editing
  }));
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lcom_iz2use_react_components_internal_multiview_table_Editing$().reuseEditingItem__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().by_$eq$eq__F2());
  var r = this$5.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3);
  elem$1 = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f$1);
  $n($$x4).$bar$bar$extension__F2__F2__F2($$x3, $as_F2(elem$1));
  var stabilizer$1 = $n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("TabularView", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState($m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x6 = $n($as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend($n(x$3).backend__O()));
    var this$7 = $n(x$3);
    var $$x5 = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps($n(this$7.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$8 = $n(x$3);
    return $n($$x6).render__Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement($$x5, $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$8)))
  })));
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$__f_component = $n($n(stabilizer$1).componentDidUpdate__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(c$2);
    var $$x7 = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend($n(c).backend__O());
    var this$9 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x7).onUpdate__Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__Ljapgolly_scalajs_react_callback_Trampoline($as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState($n(this$9.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O())))
  })), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$())).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$.prototype.apply__Ldiode_data_Pot__s_Option__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_TableRenderer__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(items, active, keyMapper, renderer, itemSimpleActions, context, hasIterator, decorator) {
  var c = this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(items, active, keyMapper, renderer, itemSimpleActions, context, hasIterator, decorator);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$: 0
}, false, "com.iz2use.react.components.internal.multiview.table.TabularView$", {
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$;
var $n_Lcom_iz2use_react_components_internal_multiview_table_TabularView$;
function $m_Lcom_iz2use_react_components_internal_multiview_table_TabularView$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_table_TabularView$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_table_TabularView$ = new $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_table_TabularView$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$ = this;
  var this$9 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("SuggestionHelper", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    var u = $n($$x2).render__Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x1, $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)));
    var this$7 = $n(u);
    var n = this$7.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }))));
  var f = $m_Ljapgolly_scalajs_react_extra_OnUnmount$().install__F1();
  var this$13 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$9)));
  var listenable = new $c_sjsr_AnonFunction1(((p$3$2) => {
    var p$3 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(p$3$2);
    return $n($n(p$3).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context).Lcom_iz2use_react_components_internal_TextEditorContext__f_onKeyDown
  }));
  var makeListener = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(x$5$2);
    return $n($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend($n(x$5).backend__O())).handleKeyDown__F1()
  }));
  var evidence$3 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_ListenableF$();
  var this$12 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var f$1 = $n($$x3).listen__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(listenable, makeListener, this$12.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync, evidence$3);
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$1).apply__O__O(this$13))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$.prototype;
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$;
var $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$;
function $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$() {
  if ((!$n_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$)) {
    $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$ = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$()
  };
  return $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder(search, open, context, focusHandler, fetcher, fetcherBackend, filter, keyOf, equiv, handleNonexistent, tokenMatcher, tokenizer, highlighter) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_search = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_open = false;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_context = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_focusHandler = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_fetcher = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_fetcherBackend = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_filter = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_keyOf = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_equiv = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_handleNonexistent = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_tokenMatcher = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_tokenizer = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_highlighter = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_search = search;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_open = open;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_context = context;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_focusHandler = focusHandler;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_fetcher = fetcher;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_fetcherBackend = fetcherBackend;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_filter = filter;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_keyOf = keyOf;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_equiv = equiv;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_handleNonexistent = handleNonexistent;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_tokenMatcher = tokenMatcher;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_tokenizer = tokenizer;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_highlighter = highlighter
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder.prototype.apply__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(renderItem) {
  var c = $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$().Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_search, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_open, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_context, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_focusHandler, renderItem, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_fetcher, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_fetcherBackend, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_filter, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_keyOf, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_equiv, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_handleNonexistent, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_tokenMatcher, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_tokenizer, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder__f_highlighter);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$Builder", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$__f_propsReuse = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$__f_stateReuse = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps(x$1$2);
    return $n(x$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_matches
  }));
  var r = $m_Lcom_iz2use_react_components_internal_ReusabilityImplicits$().tokenMatchesReuse__F2();
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$__f_propsReuse = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$__f_stateReuse = $m_Ljapgolly_scalajs_react_Reusability$().by_$eq$eq__F2();
  var this$11 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("SuggestionItem", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState($n(p).render__Ljapgolly_scalajs_react_vdom_VdomElement())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    $n($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3);
    var s = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6));
    return $n(s).Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState__f_rendered
  }))));
  var f$1 = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    var $$x3 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend($n(c).backend__O());
    var this$8 = $n(c);
    var $$x2 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps($n(this$8.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var $$x1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps);
    var this$9 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).onPropsChange__Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState__Ljapgolly_scalajs_react_callback_Trampoline($$x2, $$x1, $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$9))))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$16 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$11, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$1, G));
  $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$1 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$__f_propsReuse;
  var evidence$2 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$__f_stateReuse;
  var this$14 = $m_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$();
  var f$2 = $n(this$14.Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$__f_reusabilityOverrideInDev).apply__F2__F2__F1(evidence$1, evidence$2);
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$2).apply__O__O(this$16))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$.prototype.apply__O__Lcom_iz2use_common_TokenMatches__Lcom_iz2use_react_components_internal_Highlighter__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(item, matches, highlighter, f) {
  var c = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps(item, matches, highlighter, f);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionItem$", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$;
var $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$;
function $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$() {
  if ((!$n_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$)) {
    $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$ = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$()
  };
  return $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$
}
function $p_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$__typedComponent__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($thiz) {
  return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps(p$2);
    var u$2 = $m_Lcom_iz2use_react_components_internal_TokenizeSearch$().apply__T__F1__Lcom_iz2use_common_Filter__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_search, new $c_sjsr_AnonFunction1(((tokenizedSearch$2) => {
      var tokenizedSearch = $as_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(tokenizedSearch$2);
      var u$1 = $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$().apply__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__Lcom_iz2use_react_components_internal_suggestion_FetcherBackend__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_TokenMatcher__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(tokenizedSearch, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcher, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcherBackend, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_filter, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenizer, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenMatcher, new $c_sjsr_AnonFunction1(((items$2) => {
        var items = $as_Ldiode_data_Pot(items$2);
        var u = $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$().apply__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_TextEditorContext__Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler__F1__s_math_Equiv__Lcom_iz2use_react_components_internal_Highlighter__F2__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(items, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_context, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_focusHandler, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_keyOf, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_equiv, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_highlighter, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_renderItem, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_create);
        var this$3 = $n(u);
        var n = this$3.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      })));
      var this$6 = $n(u$1);
      var n$1 = this$6.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    })), $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter);
    var this$9 = $n(u$2);
    var n$2 = this$9.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$ = this;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$__f_component = $p_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$__typedComponent__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this)
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$.prototype.apply__T__Lcom_iz2use_react_components_internal_TextEditorContext__F2__Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__Lcom_iz2use_react_components_internal_suggestion_FetcherBackend__Lcom_iz2use_common_Filter__F1__s_math_Equiv__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_react_components_internal_Highlighter__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(search, context, renderItem, focusHandler, create, fetcher, fetcherBackend, filter, keyOf, equiv, tokenizer, tokenMatcher, highlighter) {
  var c = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps(search, context, focusHandler, create, fetcher, fetcherBackend, filter, keyOf, equiv, tokenizer, tokenMatcher, highlighter, renderItem);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionList$: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionList$", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionList$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$;
var $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$;
function $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$() {
  if ((!$n_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$)) {
    $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$ = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$()
  };
  return $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_propsReuse = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_showedItemsReuse = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_stateReuse = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(x$2$2);
    return $n(x$2).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizedSearch
  }));
  var r = $m_Lcom_iz2use_react_components_internal_ReusabilityImplicits$().seqTokenizedReuse__F2();
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_propsReuse = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_T2(x$3$2);
    return $as_Lcom_iz2use_common_TokenMatches($n(x$3)._2__O())
  }));
  var r$1 = $m_Lcom_iz2use_react_components_internal_ReusabilityImplicits$().tokenMatchesReuse__F2();
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_showedItemsReuse = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r$1, f$1);
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$2 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(x$4$2);
    var this$4 = $n($n(x$4).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems);
    return $as_sci_Seq((this$4.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$4.get__O()))
  }));
  var r$2 = $m_Lcom_iz2use_react_components_internal_ReusabilityImplicits$().seqReusability__F2__F2(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_showedItemsReuse);
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_stateReuse = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r$2, f$2);
  var this$14 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("SuggestionListFetcher", new $c_sjsr_AnonFunction1(((x$22$2) => {
    var x$22 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(x$22$2);
    $n(x$22);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState($m_Ldiode_data_Empty$(), $m_Ldiode_data_Empty$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$5) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$5);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$6$2);
    $n($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend($n(x$6).backend__O()));
    var this$9 = $n(x$6);
    var p = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps($n(this$9.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$10 = $n(x$6);
    var s = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$10));
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_renderFn).apply__O__O($n(s).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems))
  }))));
  var f$3 = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(c$2);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend($n(c).backend__O());
    var this$12 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).onMount__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps($n(this$12.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$18 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$14, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillMount__Ljapgolly_scalajs_react_internal_Lens(), f$3, G));
  var f$4 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$3$2);
    var $$x4 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend($n(c$3).backend__O());
    var this$15 = $n(c$3);
    var $$x3 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps($n(this$15.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var $$x2 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps($n(c$3).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps);
    var this$16 = $n(c$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x4).onPropsChange__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__Ljapgolly_scalajs_react_callback_Trampoline($$x3, $$x2, $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$16))))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$20 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$18, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$4, G$1));
  var f$5 = $m_Ljapgolly_scalajs_react_extra_Listenable$().listenToUnit__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(new $c_sjsr_AnonFunction1(((p$2) => {
    var p$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(p$2);
    return $n(p$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcher
  })), new $c_sjsr_AnonFunction1(((x$23$2) => {
    var x$23 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(x$23$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend($n(x$23).backend__O())).handleSourceUpdate__Ljapgolly_scalajs_react_callback_Trampoline())
  })), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$25 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$5).apply__O__O(this$20)));
  $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$1 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_propsReuse;
  var evidence$2 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_stateReuse;
  var this$23 = $m_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$();
  var f$6 = $n(this$23.Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$__f_reusabilityOverrideInDev).apply__F2__F2__F1(evidence$1, evidence$2);
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$6).apply__O__O(this$25))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$.prototype.apply__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__Lcom_iz2use_react_components_internal_suggestion_FetcherBackend__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_TokenMatcher__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(tokenizedSearch, fetcher, fetcherBackend, filter, tokenizer, tokenMatcher, renderFn) {
  var c = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(tokenizedSearch, fetcher, fetcherBackend, filter, tokenizer, tokenMatcher, renderFn);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFetcher$", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$;
var $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$;
function $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$() {
  if ((!$n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$)) {
    $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$ = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$()
  };
  return $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$__f_propsItemReuse = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T2(x$1$2);
    return $as_Lcom_iz2use_common_TokenMatches($n(x$1)._2__O())
  }));
  var r = $m_Lcom_iz2use_react_components_internal_ReusabilityImplicits$().tokenMatchesReuse__F2();
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$__f_propsItemReuse = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(x$2$2);
    var this$3 = $n($n(x$2).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items);
    return $as_sci_Seq((this$3.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$3.get__O()))
  }));
  var r$1 = $m_Lcom_iz2use_react_components_internal_ReusabilityImplicits$().seqReusability__F2__F2(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$__f_propsItemReuse);
  $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r$1, f$1);
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$5.byRef__F2(), this$5.by_$eq$eq__F2());
  var stabilizer$1 = $n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("SuggestionListFocuser", new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(x$10$2);
    $n(x$10);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState($m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$3) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$3);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$4$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend($n(x$4).backend__O()));
    var this$8 = $n(x$4);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps($n(this$8.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$9 = $n(x$4);
    return $n($$x2).render__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$9)))
  })));
  var this$14 = $n($n(stabilizer$1).componentDidUpdate__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(c$2);
    var $$x3 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend($n(c).backend__O());
    var this$10 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).onUpdate__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps($n(this$10.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())))
  })), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()));
  var f$2 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(\u03b4$2);
    var $$x4 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend($n(\u03b4).backend__O());
    var this$12 = $n(\u03b4);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x4).onPropsChange__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps($n(this$12.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()), $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps($n(\u03b4).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$17 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$14, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$2, G));
  var f$3 = new $c_sjsr_AnonFunction1(((\u03b4$3$2) => {
    var \u03b4$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(\u03b4$3$2);
    var $$x5 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend($n(\u03b4$3).backend__O());
    var this$15 = $n(\u03b4$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).onMount__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps($n(this$15.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$21 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$17, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillMount__Ljapgolly_scalajs_react_internal_Lens(), f$3, G$1));
  var listenable = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(p$2);
    return $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_context).Lcom_iz2use_react_components_internal_TextEditorContext__f_onKeyDown
  }));
  var makeListener = new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(x$11$2);
    return $n($as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend($n(x$11).backend__O())).handleKeyDown__F1()
  }));
  var evidence$3 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var $$x6 = $m_Ljapgolly_scalajs_react_extra_ListenableF$();
  var this$20 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var f$4 = $n($$x6).listen__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(listenable, makeListener, this$20.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync, evidence$3);
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$4).apply__O__O(this$21))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$.prototype.apply__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_TextEditorContext__Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler__F1__s_math_Equiv__Lcom_iz2use_react_components_internal_Highlighter__F2__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(items, context, focusHandler, keyOf, equiv, highlighter, renderItem, create) {
  var c = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(items, context, focusHandler, keyOf, equiv, highlighter, renderItem, create);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFocuser$", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$;
var $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$;
function $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$() {
  if ((!$n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$)) {
    $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$ = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$()
  };
  return $n_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$
}
function $f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf($thiz, v) {
  return new $c_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf($ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(new $c_Ljapgolly_scalajs_react_vdom_TagOf(), v, $m_s_package$().s_package$__f_Nil))
}
/** @constructor */
function $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(outer, ev) {
  this.Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot__f_ev = null;
  this.Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot__f_ev = ev;
  if ((outer === null)) {
    $n(null)
  }
}
$c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot.prototype = new $h_O();
$c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot.prototype.constructor = $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot;
/** @constructor */
function $h_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot.prototype = $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot.prototype;
$c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot.prototype.withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(name) {
  var $$x3 = $n(this.Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot__f_ev).raw__sjs_js_Any();
  var $$x2 = $m_s_Predef$();
  $m_sc_ArrayOps$();
  var $$x1 = $m_sc_StringOps$();
  var x = $n(name).Lsourcecode_Enclosing__f_value;
  var xs = $n($$x1).split$extension__T__C__AT(x, 46);
  $m_sc_ArrayOps$();
  $m_sc_ArrayOps$();
  var from = 0;
  _return: {
    var i = from;
    while ((i < $n(xs).u.length)) {
      var x1 = i;
      var arg1 = $n(xs).get(x1);
      var x$1 = $as_T(arg1);
      var this$5 = $n(x$1);
      var c = $charAt(this$5, 0);
      var this$8 = $m_jl_Character$();
      if ((!this$8.isLowerCase__I__Z(c))) {
        var i$1 = i;
        break _return
      };
      i = ((1 + i) | 0)
    };
    var i$1 = (-1)
  };
  var lo = ((i$1 < 0) ? $n(xs).u.length : i$1);
  var this$9 = $n($n($$x2).wrapRefArray__AO__scm_ArraySeq$ofRef($asArrayOf_O($m_sc_ArrayOps$().slice$extension__O__I__I__O(xs, lo, $n(xs).u.length), 1)));
  var s = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$9, "", ".", "");
  $$x3.displayName = s;
  return this.Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot__f_ev
});
var $d_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot = new $TypeData().initClass({
  Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot: 0
}, false, "com.iz2use.react.hooks.HooksApiExt$RichJsComponentWithRoot", {
  Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot: 1,
  O: 1
});
$c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot.prototype.$classData = $d_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot;
/** @constructor */
function $c_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(v) {
  this.Lcom_iz2use_react_hooks_StyledComponent$RichTagOf__f_com$iz2use$react$hooks$StyledComponent$RichTagOf$$v = null;
  this.Lcom_iz2use_react_hooks_StyledComponent$RichTagOf__f_com$iz2use$react$hooks$StyledComponent$RichTagOf$$v = v
}
$c_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf.prototype = new $h_O();
$c_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf.prototype.constructor = $c_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf;
/** @constructor */
function $h_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf.prototype = $c_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf.prototype;
$c_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf.prototype.styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf = (function(builder, name) {
  var dsl = new $c_Lcom_iz2use_react_hooks_SuppliedDsl($n(name).Lsourcecode_Name__f_value, builder);
  var this$1 = $m_Lcom_iz2use_react_style_StyleSettings$();
  var s = $f_Lcom_iz2use_react_style_MyDev__cssStringRenderer__Lscalacss_internal_Renderer(this$1);
  var r = new $c_Lscalacss_ScalatagsJsDomRenderer(s);
  $m_Lcom_iz2use_react_style_StyleSettings$();
  var env = $m_Lscalacss_internal_Env$().Lscalacss_internal_Env$__f_empty;
  var rendered = $n($as_Lscalatags_JsDom$TypedTag($n(dsl.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister).render__Lscalacss_internal_Renderer__Lscalacss_internal_Env__O(r, env))).render__Lorg_scalajs_dom_Element();
  document.head.appendChild(rendered);
  var $$x1 = $n(this.Lcom_iz2use_react_hooks_StyledComponent$RichTagOf__f_com$iz2use$react$hooks$StyledComponent$RichTagOf$$v);
  var this$5 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = dsl.Lcom_iz2use_react_hooks_SuppliedDsl__f_entry;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s$1)];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf = new $TypeData().initClass({
  Lcom_iz2use_react_hooks_StyledComponent$RichTagOf: 0
}, false, "com.iz2use.react.hooks.StyledComponent$RichTagOf", {
  Lcom_iz2use_react_hooks_StyledComponent$RichTagOf: 1,
  O: 1
});
$c_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf.prototype.$classData = $d_Lcom_iz2use_react_hooks_StyledComponent$RichTagOf;
function $f_Lcom_iz2use_react_style_ExtendedStyles__$init$__V($thiz) {
  $thiz.Lcom_iz2use_react_style_package$__f_gridGap = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("grid-gap")
}
function $ct_Lcom_iz2use_react_style_MaterialDesign$Elevation__Lcom_iz2use_react_style_MaterialDesign__J__($thiz, outer, dpi) {
  $thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_dpi = dpi;
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_$outer = outer
  };
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_style_MaterialDesign$Elevation() {
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_dpi = $L0;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_$outer = null
}
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation.prototype = new $h_O();
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation.prototype.constructor = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation;
/** @constructor */
function $h_Lcom_iz2use_react_style_MaterialDesign$Elevation() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_MaterialDesign$Elevation.prototype = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation.prototype;
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation.prototype.style__Lscalacss_internal_StyleS = (function() {
  return $n(this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_$outer).pureWhiteframe__J__Lscalacss_internal_StyleS(this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_dpi)
});
function $p_Lcom_iz2use_react_style_MaterialDesign$Elevation$__Card$lzycompute$1__V($thiz) {
  if (($thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Card$module === null)) {
    $thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Card$module = new $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$($thiz)
  }
}
function $p_Lcom_iz2use_react_style_MaterialDesign$Elevation$__Button$lzycompute$1__V($thiz) {
  if (($thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Button$module === null)) {
    $thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Button$module = new $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$($thiz)
  }
}
function $p_Lcom_iz2use_react_style_MaterialDesign$Elevation$__ModalBottomSheet$lzycompute$1__V($thiz) {
  if (($thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_ModalBottomSheet$module === null)) {
    $thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_ModalBottomSheet$module = new $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$($thiz)
  }
}
function $p_Lcom_iz2use_react_style_MaterialDesign$Elevation$__Picker$lzycompute$1__V($thiz) {
  if (($thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Picker$module === null)) {
    $thiz.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Picker$module = new $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$($thiz)
  }
}
/** @constructor */
function $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$(outer) {
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Card$module = null;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Button$module = null;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_ModalBottomSheet$module = null;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Picker$module = null;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$.prototype = new $h_O();
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$.prototype.constructor = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$;
/** @constructor */
function $h_Lcom_iz2use_react_style_MaterialDesign$Elevation$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_MaterialDesign$Elevation$.prototype = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$.prototype;
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$.prototype.Card__Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$ = (function() {
  if ((this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Card$module === null)) {
    $p_Lcom_iz2use_react_style_MaterialDesign$Elevation$__Card$lzycompute$1__V(this)
  };
  return this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Card$module
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$.prototype.Button__Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$ = (function() {
  if ((this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Button$module === null)) {
    $p_Lcom_iz2use_react_style_MaterialDesign$Elevation$__Button$lzycompute$1__V(this)
  };
  return this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Button$module
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$.prototype.ModalBottomSheet__Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$ = (function() {
  if ((this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_ModalBottomSheet$module === null)) {
    $p_Lcom_iz2use_react_style_MaterialDesign$Elevation$__ModalBottomSheet$lzycompute$1__V(this)
  };
  return this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_ModalBottomSheet$module
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$.prototype.Picker__Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$ = (function() {
  if ((this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Picker$module === null)) {
    $p_Lcom_iz2use_react_style_MaterialDesign$Elevation$__Picker$lzycompute$1__V(this)
  };
  return this.Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_Picker$module
});
var $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_MaterialDesign$Elevation$: 0
}, false, "com.iz2use.react.style.MaterialDesign$Elevation$", {
  Lcom_iz2use_react_style_MaterialDesign$Elevation$: 1,
  O: 1
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$.prototype.$classData = $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$;
function $ct_Lcom_iz2use_react_style_OpacityLevel__D__($thiz, level) {
  $thiz.Lcom_iz2use_react_style_OpacityLevel__f_level = level;
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_style_OpacityLevel() {
  this.Lcom_iz2use_react_style_OpacityLevel__f_level = 0.0
}
$c_Lcom_iz2use_react_style_OpacityLevel.prototype = new $h_O();
$c_Lcom_iz2use_react_style_OpacityLevel.prototype.constructor = $c_Lcom_iz2use_react_style_OpacityLevel;
/** @constructor */
function $h_Lcom_iz2use_react_style_OpacityLevel() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_OpacityLevel.prototype = $c_Lcom_iz2use_react_style_OpacityLevel.prototype;
/** @constructor */
function $c_Lcom_iz2use_react_style_ThemeColorWithInverse$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_style_ThemeColorWithInverse$.prototype = new $h_O();
$c_Lcom_iz2use_react_style_ThemeColorWithInverse$.prototype.constructor = $c_Lcom_iz2use_react_style_ThemeColorWithInverse$;
/** @constructor */
function $h_Lcom_iz2use_react_style_ThemeColorWithInverse$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_ThemeColorWithInverse$.prototype = $c_Lcom_iz2use_react_style_ThemeColorWithInverse$.prototype;
$c_Lcom_iz2use_react_style_ThemeColorWithInverse$.prototype.apply__I__I__I__I__I__I__Lcom_iz2use_react_style_ThemeColor = (function(h, s, l, hi, si, li) {
  return new $c_Lcom_iz2use_react_style_ThemeColor(new $c_Lcom_iz2use_react_style_ThemeOneColor(h, s, l), new $c_Lcom_iz2use_react_style_ThemeOneColor(hi, si, li))
});
var $d_Lcom_iz2use_react_style_ThemeColorWithInverse$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_ThemeColorWithInverse$: 0
}, false, "com.iz2use.react.style.ThemeColorWithInverse$", {
  Lcom_iz2use_react_style_ThemeColorWithInverse$: 1,
  O: 1
});
$c_Lcom_iz2use_react_style_ThemeColorWithInverse$.prototype.$classData = $d_Lcom_iz2use_react_style_ThemeColorWithInverse$;
var $n_Lcom_iz2use_react_style_ThemeColorWithInverse$;
function $m_Lcom_iz2use_react_style_ThemeColorWithInverse$() {
  if ((!$n_Lcom_iz2use_react_style_ThemeColorWithInverse$)) {
    $n_Lcom_iz2use_react_style_ThemeColorWithInverse$ = new $c_Lcom_iz2use_react_style_ThemeColorWithInverse$()
  };
  return $n_Lcom_iz2use_react_style_ThemeColorWithInverse$
}
/** @constructor */
function $c_Lcom_iz2use_react_style_package$RichToThemedStyle(v) {
  this.Lcom_iz2use_react_style_package$RichToThemedStyle__f_com$iz2use$react$style$RichToThemedStyle$$v = null;
  this.Lcom_iz2use_react_style_package$RichToThemedStyle__f_com$iz2use$react$style$RichToThemedStyle$$v = v
}
$c_Lcom_iz2use_react_style_package$RichToThemedStyle.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$RichToThemedStyle.prototype.constructor = $c_Lcom_iz2use_react_style_package$RichToThemedStyle;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$RichToThemedStyle() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$RichToThemedStyle.prototype = $c_Lcom_iz2use_react_style_package$RichToThemedStyle.prototype;
var $d_Lcom_iz2use_react_style_package$RichToThemedStyle = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$RichToThemedStyle: 0
}, false, "com.iz2use.react.style.package$RichToThemedStyle", {
  Lcom_iz2use_react_style_package$RichToThemedStyle: 1,
  O: 1
});
$c_Lcom_iz2use_react_style_package$RichToThemedStyle.prototype.$classData = $d_Lcom_iz2use_react_style_package$RichToThemedStyle;
function $is_Lcom_iz2use_react_style_package$ToThemedStyle(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_style_package$ToThemedStyle)))
}
function $as_Lcom_iz2use_react_style_package$ToThemedStyle(obj) {
  return (($is_Lcom_iz2use_react_style_package$ToThemedStyle(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.style.package$ToThemedStyle"))
}
function $isArrayOf_Lcom_iz2use_react_style_package$ToThemedStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_style_package$ToThemedStyle)))
}
function $asArrayOf_Lcom_iz2use_react_style_package$ToThemedStyle(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_style_package$ToThemedStyle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.style.package$ToThemedStyle;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(outer, v) {
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_com$iz2use$react$style$WithThemedSupport$RichAttr$$v = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_$outer = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_com$iz2use$react$style$WithThemedSupport$RichAttr$$v = v;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr.prototype.constructor = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr.prototype = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr.prototype;
var $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr: 0
}, false, "com.iz2use.react.style.package$WithThemedSupport$RichAttr", {
  Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr: 1,
  O: 1
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr.prototype.$classData = $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr;
/** @constructor */
function $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(outer, v) {
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_com$iz2use$react$style$WithThemedSupport$RichTypedAttrBase$$v = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_$outer = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_com$iz2use$react$style$WithThemedSupport$RichTypedAttrBase$$v = v;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase.prototype.constructor = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase.prototype = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase.prototype;
var $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase: 0
}, false, "com.iz2use.react.style.package$WithThemedSupport$RichTypedAttrBase", {
  Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase: 1,
  O: 1
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase.prototype.$classData = $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase;
function $p_Ldiode_ActionHandler__liftedHandler$lzycompute__F1($thiz) {
  if ((!$thiz.Ldiode_ActionHandler__f_bitmap$0)) {
    $thiz.Ldiode_ActionHandler__f_liftedHandler = $n($thiz.handle__s_PartialFunction()).lift__F1();
    $thiz.Ldiode_ActionHandler__f_bitmap$0 = true
  };
  return $thiz.Ldiode_ActionHandler__f_liftedHandler
}
function $ct_Ldiode_ActionHandler__Ldiode_ModelRW__($thiz, modelRW) {
  $thiz.Ldiode_ActionHandler__f_modelRW = modelRW;
  $thiz.Ldiode_ActionHandler__f_currentModel = $n($n(modelRW).root__Ldiode_ModelR()).value__O();
  return $thiz
}
/** @constructor */
function $c_Ldiode_ActionHandler() {
  this.Ldiode_ActionHandler__f_liftedHandler = null;
  this.Ldiode_ActionHandler__f_modelRW = null;
  this.Ldiode_ActionHandler__f_currentModel = null;
  this.Ldiode_ActionHandler__f_bitmap$0 = false
}
$c_Ldiode_ActionHandler.prototype = new $h_O();
$c_Ldiode_ActionHandler.prototype.constructor = $c_Ldiode_ActionHandler;
/** @constructor */
function $h_Ldiode_ActionHandler() {
  /*<skip>*/
}
$h_Ldiode_ActionHandler.prototype = $c_Ldiode_ActionHandler.prototype;
$c_Ldiode_ActionHandler.prototype.liftedHandler__F1 = (function() {
  return ((!this.Ldiode_ActionHandler__f_bitmap$0) ? $p_Ldiode_ActionHandler__liftedHandler$lzycompute__F1(this) : this.Ldiode_ActionHandler__f_liftedHandler)
});
$c_Ldiode_ActionHandler.prototype.handleAction__O__O__s_Option = (function(model, action) {
  this.Ldiode_ActionHandler__f_currentModel = model;
  return $as_s_Option($n(this.liftedHandler__F1()).apply__O__O(action))
});
$c_Ldiode_ActionHandler.prototype.updated__O__Ldiode_ActionResult = (function(newValue) {
  return new $c_Ldiode_ActionResult$ModelUpdate($n(this.Ldiode_ActionHandler__f_modelRW).updatedWith__O__O__O(this.Ldiode_ActionHandler__f_currentModel, newValue))
});
$c_Ldiode_ActionHandler.prototype.updated__O__Ldiode_Effect__Ldiode_ActionResult = (function(newValue, effect) {
  return new $c_Ldiode_ActionResult$ModelUpdateEffect($n(this.Ldiode_ActionHandler__f_modelRW).updatedWith__O__O__O(this.Ldiode_ActionHandler__f_currentModel, newValue), effect)
});
/** @constructor */
function $c_Ldiode_ActionHandler$() {
  /*<skip>*/
}
$c_Ldiode_ActionHandler$.prototype = new $h_O();
$c_Ldiode_ActionHandler$.prototype.constructor = $c_Ldiode_ActionHandler$;
/** @constructor */
function $h_Ldiode_ActionHandler$() {
  /*<skip>*/
}
$h_Ldiode_ActionHandler$.prototype = $c_Ldiode_ActionHandler$.prototype;
$c_Ldiode_ActionHandler$.prototype.extractHandler__Ldiode_ActionHandler__F2 = (function(actionHandler) {
  return new $c_sjsr_AnonFunction2(((model$2, action$2) => $n(actionHandler).handleAction__O__O__s_Option(model$2, action$2)))
});
var $d_Ldiode_ActionHandler$ = new $TypeData().initClass({
  Ldiode_ActionHandler$: 0
}, false, "diode.ActionHandler$", {
  Ldiode_ActionHandler$: 1,
  O: 1
});
$c_Ldiode_ActionHandler$.prototype.$classData = $d_Ldiode_ActionHandler$;
var $n_Ldiode_ActionHandler$;
function $m_Ldiode_ActionHandler$() {
  if ((!$n_Ldiode_ActionHandler$)) {
    $n_Ldiode_ActionHandler$ = new $c_Ldiode_ActionHandler$()
  };
  return $n_Ldiode_ActionHandler$
}
function $is_Ldiode_ActionProcessor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ldiode_ActionProcessor)))
}
function $as_Ldiode_ActionProcessor(obj) {
  return (($is_Ldiode_ActionProcessor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ActionProcessor"))
}
function $isArrayOf_Ldiode_ActionProcessor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ActionProcessor)))
}
function $asArrayOf_Ldiode_ActionProcessor(obj, depth) {
  return (($isArrayOf_Ldiode_ActionProcessor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ActionProcessor;", depth))
}
function $is_Ldiode_ActionResult(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ldiode_ActionResult)))
}
function $as_Ldiode_ActionResult(obj) {
  return (($is_Ldiode_ActionResult(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ActionResult"))
}
function $isArrayOf_Ldiode_ActionResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ActionResult)))
}
function $asArrayOf_Ldiode_ActionResult(obj, depth) {
  return (($isArrayOf_Ldiode_ActionResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ActionResult;", depth))
}
/** @constructor */
function $c_Ldiode_ActionResult$() {
  /*<skip>*/
}
$c_Ldiode_ActionResult$.prototype = new $h_O();
$c_Ldiode_ActionResult$.prototype.constructor = $c_Ldiode_ActionResult$;
/** @constructor */
function $h_Ldiode_ActionResult$() {
  /*<skip>*/
}
$h_Ldiode_ActionResult$.prototype = $c_Ldiode_ActionResult$.prototype;
$c_Ldiode_ActionResult$.prototype.apply__s_Option__s_Option__Ldiode_ActionResult = (function(model, effect) {
  if ((model instanceof $c_s_Some)) {
    var x4 = $as_s_Some(model);
    var m = $n(x4).s_Some__f_value;
    if ((effect instanceof $c_s_Some)) {
      var x5 = $as_s_Some(effect);
      var e = $as_Ldiode_Effect($n(x5).s_Some__f_value);
      return new $c_Ldiode_ActionResult$ModelUpdateEffect(m, e)
    }
  };
  if ((model instanceof $c_s_Some)) {
    var x8 = $as_s_Some(model);
    var m$2 = $n(x8).s_Some__f_value;
    var x = $m_s_None$();
    if ((x === effect)) {
      return new $c_Ldiode_ActionResult$ModelUpdate(m$2)
    }
  };
  var x$3 = $m_s_None$();
  if (((x$3 === model) && (effect instanceof $c_s_Some))) {
    var x12 = $as_s_Some(effect);
    var e$2 = $as_Ldiode_Effect($n(x12).s_Some__f_value);
    return new $c_Ldiode_ActionResult$EffectOnly(e$2)
  };
  return $m_Ldiode_ActionResult$NoChange$()
});
var $d_Ldiode_ActionResult$ = new $TypeData().initClass({
  Ldiode_ActionResult$: 0
}, false, "diode.ActionResult$", {
  Ldiode_ActionResult$: 1,
  O: 1
});
$c_Ldiode_ActionResult$.prototype.$classData = $d_Ldiode_ActionResult$;
var $n_Ldiode_ActionResult$;
function $m_Ldiode_ActionResult$() {
  if ((!$n_Ldiode_ActionResult$)) {
    $n_Ldiode_ActionResult$ = new $c_Ldiode_ActionResult$()
  };
  return $n_Ldiode_ActionResult$
}
function $is_Ldiode_Effect(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ldiode_Effect)))
}
function $as_Ldiode_Effect(obj) {
  return (($is_Ldiode_Effect(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.Effect"))
}
function $isArrayOf_Ldiode_Effect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_Effect)))
}
function $asArrayOf_Ldiode_Effect(obj, depth) {
  return (($isArrayOf_Ldiode_Effect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.Effect;", depth))
}
/** @constructor */
function $c_Ldiode_Effect$() {
  /*<skip>*/
}
$c_Ldiode_Effect$.prototype = new $h_O();
$c_Ldiode_Effect$.prototype.constructor = $c_Ldiode_Effect$;
/** @constructor */
function $h_Ldiode_Effect$() {
  /*<skip>*/
}
$h_Ldiode_Effect$.prototype = $c_Ldiode_Effect$.prototype;
$c_Ldiode_Effect$.prototype.action__F0__Ldiode_ActionType__s_concurrent_ExecutionContext__Ldiode_EffectSingle = (function(action, evidence$10, ec) {
  return new $c_Ldiode_EffectSingle(new $c_sjsr_AnonFunction0((() => $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n(action).apply__O()))), ec)
});
var $d_Ldiode_Effect$ = new $TypeData().initClass({
  Ldiode_Effect$: 0
}, false, "diode.Effect$", {
  Ldiode_Effect$: 1,
  O: 1
});
$c_Ldiode_Effect$.prototype.$classData = $d_Ldiode_Effect$;
var $n_Ldiode_Effect$;
function $m_Ldiode_Effect$() {
  if ((!$n_Ldiode_Effect$)) {
    $n_Ldiode_Effect$ = new $c_Ldiode_Effect$()
  };
  return $n_Ldiode_Effect$
}
function $f_Ldiode_EffectSetExecutionOps__executeWith__F1__s_concurrent_Future($thiz, f) {
  var $$x3 = $m_s_concurrent_Future$();
  var this$1 = $n($n($as_Ldiode_EffectSet($thiz)).Ldiode_EffectSet__f_tail);
  var elem = $n($as_Ldiode_EffectSet($thiz)).Ldiode_EffectSet__f_head;
  var $$x2 = this$1.incl__O__sci_SetOps(elem);
  var $$x1 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ldiode_Effect(x$1$2);
    return $as_s_concurrent_Future($n(f).apply__O__O(x$1))
  }));
  var this$3 = $m_sc_BuildFrom$();
  var e = new $c_sc_BuildFromLowPriority2$$anon$11(this$3);
  return $n($$x3).traverse__sc_IterableOnce__F1__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future($$x2, $$x1, e, $n($as_Ldiode_EffectBase($thiz)).Ldiode_EffectBase__f_ec)
}
function $f_Ldiode_ModelRO__$eq$bang$eq__O__Z($thiz, that) {
  return (!$thiz.$eq$eq$eq__O__Z(that))
}
function $is_Ldiode_ModelRO(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ldiode_ModelRO)))
}
function $as_Ldiode_ModelRO(obj) {
  return (($is_Ldiode_ModelRO(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ModelRO"))
}
function $isArrayOf_Ldiode_ModelRO(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ModelRO)))
}
function $asArrayOf_Ldiode_ModelRO(obj, depth) {
  return (($isArrayOf_Ldiode_ModelRO(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ModelRO;", depth))
}
function $f_Ldiode_data_PendingBase__duration__J__I($thiz, currentTime) {
  var b = $thiz.startTime__J();
  var alo = currentTime.RTLong__f_lo;
  var ahi = currentTime.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo - b.RTLong__f_lo) | 0);
  return lo
}
function $is_Ldiode_data_PendingBase(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ldiode_data_PendingBase)))
}
function $as_Ldiode_data_PendingBase(obj) {
  return (($is_Ldiode_data_PendingBase(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.data.PendingBase"))
}
function $isArrayOf_Ldiode_data_PendingBase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_data_PendingBase)))
}
function $asArrayOf_Ldiode_data_PendingBase(obj, depth) {
  return (($isArrayOf_Ldiode_data_PendingBase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.data.PendingBase;", depth))
}
function $f_Ldiode_react_ReactConnector__wrap__Ldiode_ModelRO__F1__F1__O($thiz, modelReader, compB, ev) {
  var aType$module = new $c_sr_LazyRef();
  return $n(compB).apply__O__O(new $c_Ldiode_react_ModelProxy(modelReader, new $c_sjsr_AnonFunction1(((action$2) => {
    var this$2 = $n($as_Ldiode_Circuit($thiz));
    var evidence$6 = $p_Ldiode_react_ReactConnector__aType$2__sr_LazyRef__Ldiode_react_ReactConnector$aType$1$($thiz, aType$module);
    $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V(this$2, action$2, evidence$6)
  })), $thiz))
}
function $f_Ldiode_react_ReactConnector__connect__F1__Ldiode_FastEq__Ljapgolly_scalajs_react_CtorType$Props($thiz, zoomFunc, feq) {
  var this$1 = $n($as_Ldiode_Circuit($thiz));
  var this$2 = $n(this$1.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$modelRW);
  var modelReader = $f_Ldiode_BaseModelR__zoom__F1__Ldiode_FastEq__Ldiode_ZoomModelR(this$2, zoomFunc, feq);
  return $f_Ldiode_react_ReactConnector__connect__Ldiode_ModelRO__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType$Props($thiz, modelReader, (void 0))
}
function $f_Ldiode_react_ReactConnector__connect__Ldiode_ModelRO__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType$Props($thiz, modelReader, key) {
  var this$7 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialState$extension__T__F0__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DiodeWrapper", new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(modelReader);
    return this$2.value__O()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Ldiode_react_ReactConnector$Backend$1($thiz, x, modelReader)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x3 = $n($as_Ldiode_react_ReactConnector$Backend$1($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x2 = $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4);
    var this$5 = $n(x$3);
    return $n($$x3).render__O__F1__Ljapgolly_scalajs_react_vdom_VdomElement($$x2, $as_F1($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()))
  }))));
  var f = new $c_sjsr_AnonFunction1(((x$3$3$2) => {
    var x$3$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(x$3$3$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ldiode_react_ReactConnector$Backend$1($n(x$3$3).backend__O())).didMount__Ljapgolly_scalajs_react_callback_Trampoline())
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$9 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$7, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f, G));
  var f$1 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(x$4$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ldiode_react_ReactConnector$Backend$1($n(x$4).backend__O())).willUnmount__Ljapgolly_scalajs_react_callback_Trampoline())
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var c = $n($n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$9, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillUnmount__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1)).shouldComponentUpdatePure__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((scope$2) => {
    var scope = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(scope$2);
    var this$10 = $n(scope);
    if ((!Object.is($n(this$10.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O(), $n(scope).Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextState))) {
      return true
    } else {
      var this$11 = $n(scope);
      return (!Object.is($n(this$11.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O(), $n(scope).Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextProps))
    }
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)));
  var $$x4 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  var $$x1 = $m_sjs_js_$bar$();
  var this$14 = $m_s_$less$colon$less$();
  return $as_Ljapgolly_scalajs_react_CtorType$Props($n($$x4).withRawProp__T__sjs_js_Any__Ljapgolly_scalajs_react_CtorType("key", $n($$x1).undefOr2jsAny__sjs_js_$bar__F1__sjs_js_Any(key, this$14.s_$less$colon$less$__f_singleton)))
}
function $p_Ldiode_react_ReactConnector__aType$lzycompute$1__sr_LazyRef__Ldiode_react_ReactConnector$aType$1$($thiz, aType$module$1) {
  if ((aType$module$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return ($n(aType$module$1).sr_LazyRef__f__initialized ? $as_Ldiode_react_ReactConnector$aType$1$($n(aType$module$1).sr_LazyRef__f__value) : $as_Ldiode_react_ReactConnector$aType$1$($n(aType$module$1).initialize__O__O(new $c_Ldiode_react_ReactConnector$aType$1$($thiz))))
}
function $p_Ldiode_react_ReactConnector__aType$2__sr_LazyRef__Ldiode_react_ReactConnector$aType$1$($thiz, aType$module$1) {
  return ($n(aType$module$1).sr_LazyRef__f__initialized ? $as_Ldiode_react_ReactConnector$aType$1$($n(aType$module$1).sr_LazyRef__f__value) : $p_Ldiode_react_ReactConnector__aType$lzycompute$1__sr_LazyRef__Ldiode_react_ReactConnector$aType$1$($thiz, aType$module$1))
}
function $p_Ldiode_react_ReactConnector$Backend$1__changeHandler__Ldiode_ModelRO__V($thiz, cursor) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Ldiode_react_ReactConnector$Backend$1__f_t).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((state$2) => {
    var this$2 = $n($thiz.Ldiode_react_ReactConnector$Backend$1__f_modelReader$1);
    return $f_Ldiode_ModelRO__$eq$bang$eq__O__Z(this$2, state$2)
  }));
  var this$4 = $n(this$);
  var stateHasChanged = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$4, f);
  var f$1 = new $c_sjsr_AnonFunction1(((shouldUpdate$2) => {
    var shouldUpdate = $uZ(shouldUpdate$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Ldiode_react_ReactConnector$Backend$1__updateState$1__Z__Ldiode_ModelRO__Ljapgolly_scalajs_react_callback_Trampoline($thiz, shouldUpdate, cursor))
  }));
  var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(stateHasChanged, f$1);
  var this$7 = $n(this$$1);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$7)
}
function $p_Ldiode_react_ReactConnector$Backend$1__updateState$1__Z__Ldiode_ModelRO__Ljapgolly_scalajs_react_callback_Trampoline($thiz, shouldUpdate, cursor$1) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  if (shouldUpdate) {
    var this$3 = $n($thiz.Ldiode_react_ReactConnector$Backend$1__f_t);
    var this$2 = $n(cursor$1);
    var newState = this$2.value__O();
    var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$3, newState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
}
/** @constructor */
function $c_Ldiode_react_ReactConnector$Backend$1(outer, t, modelReader$1) {
  this.Ldiode_react_ReactConnector$Backend$1__f_t = null;
  this.Ldiode_react_ReactConnector$Backend$1__f_unsubscribe = null;
  this.Ldiode_react_ReactConnector$Backend$1__f_$outer = null;
  this.Ldiode_react_ReactConnector$Backend$1__f_modelReader$1 = null;
  this.Ldiode_react_ReactConnector$Backend$1__f_t = t;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ldiode_react_ReactConnector$Backend$1__f_$outer = outer
  };
  this.Ldiode_react_ReactConnector$Backend$1__f_modelReader$1 = modelReader$1;
  this.Ldiode_react_ReactConnector$Backend$1__f_unsubscribe = $m_s_None$()
}
$c_Ldiode_react_ReactConnector$Backend$1.prototype = new $h_O();
$c_Ldiode_react_ReactConnector$Backend$1.prototype.constructor = $c_Ldiode_react_ReactConnector$Backend$1;
/** @constructor */
function $h_Ldiode_react_ReactConnector$Backend$1() {
  /*<skip>*/
}
$h_Ldiode_react_ReactConnector$Backend$1.prototype = $c_Ldiode_react_ReactConnector$Backend$1.prototype;
$c_Ldiode_react_ReactConnector$Backend$1.prototype.didMount__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($as_Ldiode_Circuit(this.Ldiode_react_ReactConnector$Backend$1__f_$outer));
    var cursor$1 = $as_Ldiode_ModelR(this.Ldiode_react_ReactConnector$Backend$1__f_modelReader$1);
    var listener = new $c_sjsr_AnonFunction1(((cursor$2) => {
      var cursor = $as_Ldiode_ModelRO(cursor$2);
      $p_Ldiode_react_ReactConnector$Backend$1__changeHandler__Ldiode_ModelRO__V(this, cursor)
    }));
    this.Ldiode_react_ReactConnector$Backend$1__f_unsubscribe = new $c_s_Some($f_Ldiode_Circuit__subscribe__Ldiode_ModelR__F1__F0(this$2, cursor$1, listener))
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1);
  var this$7 = $n(this.Ldiode_react_ReactConnector$Backend$1__f_t);
  var this$6 = $n(this.Ldiode_react_ReactConnector$Backend$1__f_modelReader$1);
  var newState = this$6.value__O();
  return $n($$x2).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$7, newState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
});
$c_Ldiode_react_ReactConnector$Backend$1.prototype.willUnmount__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(this.Ldiode_react_ReactConnector$Backend$1__f_unsubscribe);
    if ((!this$2.isEmpty__Z())) {
      var arg1 = this$2.get__O();
      var f = $as_F0(arg1);
      var this$3 = $n(f);
      this$3.apply__O()
    };
    this.Ldiode_react_ReactConnector$Backend$1__f_unsubscribe = $m_s_None$()
  }));
  var f$2 = new $c_sjsr_AnonFunction0((() => {
    f$1.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2)
});
$c_Ldiode_react_ReactConnector$Backend$1.prototype.render__O__F1__Ljapgolly_scalajs_react_vdom_VdomElement = (function(s, compB) {
  var this$3 = $n(this.Ldiode_react_ReactConnector$Backend$1__f_$outer);
  var modelReader = this.Ldiode_react_ReactConnector$Backend$1__f_modelReader$1;
  var this$2 = $m_s_$less$colon$less$();
  var ev = this$2.s_$less$colon$less$__f_singleton;
  return $as_Ljapgolly_scalajs_react_vdom_VdomElement($f_Ldiode_react_ReactConnector__wrap__Ldiode_ModelRO__F1__F1__O(this$3, modelReader, compB, ev))
});
function $as_Ldiode_react_ReactConnector$Backend$1(obj) {
  return (((obj instanceof $c_Ldiode_react_ReactConnector$Backend$1) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.react.ReactConnector$Backend$1"))
}
function $isArrayOf_Ldiode_react_ReactConnector$Backend$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_react_ReactConnector$Backend$1)))
}
function $asArrayOf_Ldiode_react_ReactConnector$Backend$1(obj, depth) {
  return (($isArrayOf_Ldiode_react_ReactConnector$Backend$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.react.ReactConnector$Backend$1;", depth))
}
var $d_Ldiode_react_ReactConnector$Backend$1 = new $TypeData().initClass({
  Ldiode_react_ReactConnector$Backend$1: 0
}, false, "diode.react.ReactConnector$Backend$1", {
  Ldiode_react_ReactConnector$Backend$1: 1,
  O: 1
});
$c_Ldiode_react_ReactConnector$Backend$1.prototype.$classData = $d_Ldiode_react_ReactConnector$Backend$1;
/** @constructor */
function $c_Ldiode_react_ReactPot$potWithReact$() {
  /*<skip>*/
}
$c_Ldiode_react_ReactPot$potWithReact$.prototype = new $h_O();
$c_Ldiode_react_ReactPot$potWithReact$.prototype.constructor = $c_Ldiode_react_ReactPot$potWithReact$;
/** @constructor */
function $h_Ldiode_react_ReactPot$potWithReact$() {
  /*<skip>*/
}
$h_Ldiode_react_ReactPot$potWithReact$.prototype = $c_Ldiode_react_ReactPot$potWithReact$.prototype;
$c_Ldiode_react_ReactPot$potWithReact$.prototype.render$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(this$, f) {
  var this$1 = $n(this$);
  if ((!this$1.isEmpty__Z())) {
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f).apply__O__O($n(this$).get__O()))
  } else {
    return $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  }
});
$c_Ldiode_react_ReactPot$potWithReact$.prototype.renderReady$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(this$, f) {
  return ($n(this$).isReady__Z() ? $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f).apply__O__O($n(this$).get__O())) : $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom)
});
$c_Ldiode_react_ReactPot$potWithReact$.prototype.renderPending$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(this$, f) {
  if ($n(this$).isPending__Z()) {
    var qual$1 = $as_Ldiode_data_PendingBase(this$);
    $n(qual$1);
    var this$3 = $ct_ju_Date__(new $c_ju_Date());
    var t = this$3.ju_Date__f_java$util$Date$$millis;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$4 = $n(qual$1);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f).apply__O__O($f_Ldiode_data_PendingBase__duration__J__I(this$4, new $c_RTLong(lo, hi))))
  } else {
    return $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  }
});
$c_Ldiode_react_ReactPot$potWithReact$.prototype.renderPending$extension__Ldiode_data_Pot__F1__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(this$, b, f) {
  if ($n(this$).isPending__Z()) {
    var qual$1 = $as_Ldiode_data_PendingBase(this$);
    $n(qual$1);
    var this$3 = $ct_ju_Date__(new $c_ju_Date());
    var t = this$3.ju_Date__f_java$util$Date$$millis;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$4 = $n(qual$1);
    var duration = $f_Ldiode_data_PendingBase__duration__J__I(this$4, new $c_RTLong(lo, hi));
    return ($n(b).apply$mcZI$sp__I__Z(duration) ? $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f).apply__O__O(duration)) : $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom)
  } else {
    return $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  }
});
$c_Ldiode_react_ReactPot$potWithReact$.prototype.renderFailed$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(this$, f) {
  var this$1 = $n($n(this$).exceptionOption__s_Option());
  var this$2 = $n((this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O()))));
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode((this$2.isEmpty__Z() ? $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom : this$2.get__O()))
});
var $d_Ldiode_react_ReactPot$potWithReact$ = new $TypeData().initClass({
  Ldiode_react_ReactPot$potWithReact$: 0
}, false, "diode.react.ReactPot$potWithReact$", {
  Ldiode_react_ReactPot$potWithReact$: 1,
  O: 1
});
$c_Ldiode_react_ReactPot$potWithReact$.prototype.$classData = $d_Ldiode_react_ReactPot$potWithReact$;
var $n_Ldiode_react_ReactPot$potWithReact$;
function $m_Ldiode_react_ReactPot$potWithReact$() {
  if ((!$n_Ldiode_react_ReactPot$potWithReact$)) {
    $n_Ldiode_react_ReactPot$potWithReact$ = new $c_Ldiode_react_ReactPot$potWithReact$()
  };
  return $n_Ldiode_react_ReactPot$potWithReact$
}
/** @constructor */
function $c_Leu_timepit_refined_internal_RefinePartiallyApplied(rt) {
  this.Leu_timepit_refined_internal_RefinePartiallyApplied__f_rt = null;
  this.Leu_timepit_refined_internal_RefinePartiallyApplied__f_rt = rt
}
$c_Leu_timepit_refined_internal_RefinePartiallyApplied.prototype = new $h_O();
$c_Leu_timepit_refined_internal_RefinePartiallyApplied.prototype.constructor = $c_Leu_timepit_refined_internal_RefinePartiallyApplied;
/** @constructor */
function $h_Leu_timepit_refined_internal_RefinePartiallyApplied() {
  /*<skip>*/
}
$h_Leu_timepit_refined_internal_RefinePartiallyApplied.prototype = $c_Leu_timepit_refined_internal_RefinePartiallyApplied.prototype;
$c_Leu_timepit_refined_internal_RefinePartiallyApplied.prototype.apply__O__Leu_timepit_refined_api_Validate__s_util_Either = (function(t, v) {
  var res = $n(v).validate__O__Leu_timepit_refined_api_Result(t);
  if ($n(res).isPassed__Z()) {
    $n($m_s_package$().s_package$__f_Right);
    var value = $n(this.Leu_timepit_refined_internal_RefinePartiallyApplied__f_rt).unsafeWrap__O__O(t);
    return new $c_s_util_Right(value)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    var value$1 = $n(v).showResult__O__Leu_timepit_refined_api_Result__T(t, res);
    return new $c_s_util_Left(value$1)
  }
});
var $d_Leu_timepit_refined_internal_RefinePartiallyApplied = new $TypeData().initClass({
  Leu_timepit_refined_internal_RefinePartiallyApplied: 0
}, false, "eu.timepit.refined.internal.RefinePartiallyApplied", {
  Leu_timepit_refined_internal_RefinePartiallyApplied: 1,
  O: 1
});
$c_Leu_timepit_refined_internal_RefinePartiallyApplied.prototype.$classData = $d_Leu_timepit_refined_internal_RefinePartiallyApplied;
/** @constructor */
function $c_Leu_timepit_refined_internal_Resources$() {
  this.Leu_timepit_refined_internal_Resources$__f_passed = null;
  this.Leu_timepit_refined_internal_Resources$__f_failed = null;
  this.Leu_timepit_refined_internal_Resources$__f_Predicate = null;
  this.Leu_timepit_refined_internal_Resources$__f_predicate = null;
  $n_Leu_timepit_refined_internal_Resources$ = this;
  this.Leu_timepit_refined_internal_Resources$__f_passed = "passed";
  this.Leu_timepit_refined_internal_Resources$__f_failed = "failed";
  this.Leu_timepit_refined_internal_Resources$__f_Predicate = "Predicate";
  var this$1 = $n(this.Leu_timepit_refined_internal_Resources$__f_Predicate);
  this.Leu_timepit_refined_internal_Resources$__f_predicate = $as_T(this$1.toLowerCase())
}
$c_Leu_timepit_refined_internal_Resources$.prototype = new $h_O();
$c_Leu_timepit_refined_internal_Resources$.prototype.constructor = $c_Leu_timepit_refined_internal_Resources$;
/** @constructor */
function $h_Leu_timepit_refined_internal_Resources$() {
  /*<skip>*/
}
$h_Leu_timepit_refined_internal_Resources$.prototype = $c_Leu_timepit_refined_internal_Resources$.prototype;
$c_Leu_timepit_refined_internal_Resources$.prototype.predicateResult__Leu_timepit_refined_api_Result__T = (function(r) {
  return ((this.Leu_timepit_refined_internal_Resources$__f_Predicate + " ") + $as_T($n(r).morph__O__O__O(this.Leu_timepit_refined_internal_Resources$__f_passed, this.Leu_timepit_refined_internal_Resources$__f_failed)))
});
$c_Leu_timepit_refined_internal_Resources$.prototype.predicateResultDetail__Leu_timepit_refined_api_Result__T__T = (function(r, detail) {
  return ((this.predicateResult__Leu_timepit_refined_api_Result__T(r) + ": ") + detail)
});
$c_Leu_timepit_refined_internal_Resources$.prototype.predicateResultDetailDot__Leu_timepit_refined_api_Result__T__T = (function(r, detail) {
  return (this.predicateResultDetail__Leu_timepit_refined_api_Result__T__T(r, detail) + ".")
});
$c_Leu_timepit_refined_internal_Resources$.prototype.showResultNotInnerPassed__T__T = (function(expr) {
  return (((this.Leu_timepit_refined_internal_Resources$__f_Predicate + " ") + expr) + " did not fail.")
});
$c_Leu_timepit_refined_internal_Resources$.prototype.showResultNotInnerFailed__T__T = (function(expr) {
  return (((this.Leu_timepit_refined_internal_Resources$__f_Predicate + " ") + expr) + " did not pass.")
});
var $d_Leu_timepit_refined_internal_Resources$ = new $TypeData().initClass({
  Leu_timepit_refined_internal_Resources$: 0
}, false, "eu.timepit.refined.internal.Resources$", {
  Leu_timepit_refined_internal_Resources$: 1,
  O: 1
});
$c_Leu_timepit_refined_internal_Resources$.prototype.$classData = $d_Leu_timepit_refined_internal_Resources$;
var $n_Leu_timepit_refined_internal_Resources$;
function $m_Leu_timepit_refined_internal_Resources$() {
  if ((!$n_Leu_timepit_refined_internal_Resources$)) {
    $n_Leu_timepit_refined_internal_Resources$ = new $c_Leu_timepit_refined_internal_Resources$()
  };
  return $n_Leu_timepit_refined_internal_Resources$
}
/** @constructor */
function $c_Leu_timepit_refined_package$() {
  $n_Leu_timepit_refined_package$ = this;
  $m_Lshapeless_Witness$()
}
$c_Leu_timepit_refined_package$.prototype = new $h_O();
$c_Leu_timepit_refined_package$.prototype.constructor = $c_Leu_timepit_refined_package$;
/** @constructor */
function $h_Leu_timepit_refined_package$() {
  /*<skip>*/
}
$h_Leu_timepit_refined_package$.prototype = $c_Leu_timepit_refined_package$.prototype;
var $d_Leu_timepit_refined_package$ = new $TypeData().initClass({
  Leu_timepit_refined_package$: 0
}, false, "eu.timepit.refined.package$", {
  Leu_timepit_refined_package$: 1,
  O: 1
});
$c_Leu_timepit_refined_package$.prototype.$classData = $d_Leu_timepit_refined_package$;
var $n_Leu_timepit_refined_package$;
function $m_Leu_timepit_refined_package$() {
  if ((!$n_Leu_timepit_refined_package$)) {
    $n_Leu_timepit_refined_package$ = new $c_Leu_timepit_refined_package$()
  };
  return $n_Leu_timepit_refined_package$
}
function $is_Lfastparse_Implicits$Sequencer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfastparse_Implicits$Sequencer)))
}
function $as_Lfastparse_Implicits$Sequencer(obj) {
  return (($is_Lfastparse_Implicits$Sequencer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.Implicits$Sequencer"))
}
function $isArrayOf_Lfastparse_Implicits$Sequencer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_Implicits$Sequencer)))
}
function $asArrayOf_Lfastparse_Implicits$Sequencer(obj, depth) {
  return (($isArrayOf_Lfastparse_Implicits$Sequencer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.Implicits$Sequencer;", depth))
}
function $f_Lfastparse_LowestPriSequencer__Sequencer1__O($thiz) {
  var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => $ct_T2__O__O__(new $c_T2(), x0$1$2, x1$1$2)));
  return new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f)
}
function $ct_Lfastparse_Parsed__Z__($thiz, isSuccess) {
  return $thiz
}
/** @constructor */
function $c_Lfastparse_Parsed() {
  /*<skip>*/
}
$c_Lfastparse_Parsed.prototype = new $h_O();
$c_Lfastparse_Parsed.prototype.constructor = $c_Lfastparse_Parsed;
/** @constructor */
function $h_Lfastparse_Parsed() {
  /*<skip>*/
}
$h_Lfastparse_Parsed.prototype = $c_Lfastparse_Parsed.prototype;
/** @constructor */
function $c_Lfastparse_Parsed$() {
  /*<skip>*/
}
$c_Lfastparse_Parsed$.prototype = new $h_O();
$c_Lfastparse_Parsed$.prototype.constructor = $c_Lfastparse_Parsed$;
/** @constructor */
function $h_Lfastparse_Parsed$() {
  /*<skip>*/
}
$h_Lfastparse_Parsed$.prototype = $c_Lfastparse_Parsed$.prototype;
$c_Lfastparse_Parsed$.prototype.fromParsingRun__Lfastparse_ParsingRun__Lfastparse_Parsed = (function(p) {
  if ($n(p).Lfastparse_ParsingRun__f_isSuccess) {
    return new $c_Lfastparse_Parsed$Success($n(p).Lfastparse_ParsingRun__f_successValue, $n(p).Lfastparse_ParsingRun__f_index)
  } else {
    var this$1 = $n($m_s_Option$().apply__O__s_Option($n(p).Lfastparse_ParsingRun__f_lastFailureMsg));
    if (this$1.isEmpty__Z()) {
      var $$x1 = ""
    } else {
      var arg1 = this$1.get__O();
      var x$1 = $as_Lfastparse_internal_Msgs(arg1);
      var this$2 = $n(x$1);
      var $$x1 = $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$2.Lfastparse_internal_Msgs__f_value)
    };
    var label = $as_T($$x1);
    var index = $n(p).Lfastparse_ParsingRun__f_index;
    var extra = new $c_Lfastparse_Parsed$Extra($n(p).Lfastparse_ParsingRun__f_input, $n(p).Lfastparse_ParsingRun__f_startIndex, $n(p).Lfastparse_ParsingRun__f_index, $n(p).Lfastparse_ParsingRun__f_originalParser, $n(p).Lfastparse_ParsingRun__f_failureStack);
    return new $c_Lfastparse_Parsed$Failure(label, index, extra)
  }
});
var $d_Lfastparse_Parsed$ = new $TypeData().initClass({
  Lfastparse_Parsed$: 0
}, false, "fastparse.Parsed$", {
  Lfastparse_Parsed$: 1,
  O: 1
});
$c_Lfastparse_Parsed$.prototype.$classData = $d_Lfastparse_Parsed$;
var $n_Lfastparse_Parsed$;
function $m_Lfastparse_Parsed$() {
  if ((!$n_Lfastparse_Parsed$)) {
    $n_Lfastparse_Parsed$ = new $c_Lfastparse_Parsed$()
  };
  return $n_Lfastparse_Parsed$
}
/** @constructor */
function $c_Lfastparse_Parsed$Extra(input, startIndex, index, originalParser, stack) {
  this.Lfastparse_Parsed$Extra__f_input = null;
  this.Lfastparse_Parsed$Extra__f_startIndex = 0;
  this.Lfastparse_Parsed$Extra__f_index = 0;
  this.Lfastparse_Parsed$Extra__f_originalParser = null;
  this.Lfastparse_Parsed$Extra__f_stack = null;
  this.Lfastparse_Parsed$Extra__f_input = input;
  this.Lfastparse_Parsed$Extra__f_startIndex = startIndex;
  this.Lfastparse_Parsed$Extra__f_index = index;
  this.Lfastparse_Parsed$Extra__f_originalParser = originalParser;
  this.Lfastparse_Parsed$Extra__f_stack = stack
}
$c_Lfastparse_Parsed$Extra.prototype = new $h_O();
$c_Lfastparse_Parsed$Extra.prototype.constructor = $c_Lfastparse_Parsed$Extra;
/** @constructor */
function $h_Lfastparse_Parsed$Extra() {
  /*<skip>*/
}
$h_Lfastparse_Parsed$Extra.prototype = $c_Lfastparse_Parsed$Extra.prototype;
$c_Lfastparse_Parsed$Extra.prototype.trace__Z__Lfastparse_Parsed$TracedFailure = (function(enableLogging) {
  $n(this.Lfastparse_Parsed$Extra__f_input);
  var $$x1 = $m_Lfastparse_Parsed$TracedFailure$();
  var x$1 = this.Lfastparse_Parsed$Extra__f_input;
  var x$2 = this.Lfastparse_Parsed$Extra__f_originalParser;
  var x$3 = this.Lfastparse_Parsed$Extra__f_startIndex;
  var x$4 = this.Lfastparse_Parsed$Extra__f_index;
  $m_Lfastparse_package$();
  var x$7 = null;
  return $n($$x1).fromParsingRun__Lfastparse_ParsingRun__Lfastparse_Parsed$TracedFailure($m_Lfastparse_package$().parseInputRaw__Lfastparse_ParserInput__F1__Z__I__I__Lfastparse_internal_Instrument__Z__Lfastparse_ParsingRun(x$1, x$2, true, x$3, x$4, x$7, enableLogging))
});
function $as_Lfastparse_Parsed$Extra(obj) {
  return (((obj instanceof $c_Lfastparse_Parsed$Extra) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.Parsed$Extra"))
}
function $isArrayOf_Lfastparse_Parsed$Extra(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_Parsed$Extra)))
}
function $asArrayOf_Lfastparse_Parsed$Extra(obj, depth) {
  return (($isArrayOf_Lfastparse_Parsed$Extra(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.Parsed$Extra;", depth))
}
var $d_Lfastparse_Parsed$Extra = new $TypeData().initClass({
  Lfastparse_Parsed$Extra: 0
}, false, "fastparse.Parsed$Extra", {
  Lfastparse_Parsed$Extra: 1,
  O: 1
});
$c_Lfastparse_Parsed$Extra.prototype.$classData = $d_Lfastparse_Parsed$Extra;
/** @constructor */
function $c_Lfastparse_Parsed$Failure$() {
  /*<skip>*/
}
$c_Lfastparse_Parsed$Failure$.prototype = new $h_O();
$c_Lfastparse_Parsed$Failure$.prototype.constructor = $c_Lfastparse_Parsed$Failure$;
/** @constructor */
function $h_Lfastparse_Parsed$Failure$() {
  /*<skip>*/
}
$h_Lfastparse_Parsed$Failure$.prototype = $c_Lfastparse_Parsed$Failure$.prototype;
$c_Lfastparse_Parsed$Failure$.prototype.unapply__Lfastparse_Parsed$Failure__s_Option = (function(x) {
  return ((x !== null) ? new $c_s_Some(new $c_T3($n(x).Lfastparse_Parsed$Failure__f_label, $n(x).Lfastparse_Parsed$Failure__f_index, $n(x).Lfastparse_Parsed$Failure__f_extra)) : $m_s_None$())
});
$c_Lfastparse_Parsed$Failure$.prototype.formatMsg__Lfastparse_ParserInput__sci_List__I__T = (function(input, stack, index) {
  return ((("Expected " + $m_Lfastparse_Parsed$Failure$().formatStack__Lfastparse_ParserInput__sci_List__T(input, stack)) + ", found ") + $m_Lfastparse_Parsed$Failure$().formatTrailing__Lfastparse_ParserInput__I__T(input, index))
});
$c_Lfastparse_Parsed$Failure$.prototype.formatStack__Lfastparse_ParserInput__sci_List__T = (function(input, stack) {
  var this$2 = $n(stack);
  var f = ((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var s = $as_T($n(x0$1)._1__O());
      var i = $n(x0$1)._2$mcI$sp__I();
      return ((s + ":") + $n(input).prettyIndex__I__T(i))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  });
  if ((this$2 === $m_sci_Nil$())) {
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x1 = h
  };
  var this$3 = $n($$x1);
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", " / ", "")
});
$c_Lfastparse_Parsed$Failure$.prototype.formatTrailing__Lfastparse_ParserInput__I__T = (function(input, index) {
  return $m_Lfastparse_internal_Util$().literalize__sci_IndexedSeq__Z__T($m_s_Predef$().wrapString__T__sci_WrappedString($n(input).slice__I__I__T(index, ((10 + index) | 0))), false)
});
var $d_Lfastparse_Parsed$Failure$ = new $TypeData().initClass({
  Lfastparse_Parsed$Failure$: 0
}, false, "fastparse.Parsed$Failure$", {
  Lfastparse_Parsed$Failure$: 1,
  O: 1
});
$c_Lfastparse_Parsed$Failure$.prototype.$classData = $d_Lfastparse_Parsed$Failure$;
var $n_Lfastparse_Parsed$Failure$;
function $m_Lfastparse_Parsed$Failure$() {
  if ((!$n_Lfastparse_Parsed$Failure$)) {
    $n_Lfastparse_Parsed$Failure$ = new $c_Lfastparse_Parsed$Failure$()
  };
  return $n_Lfastparse_Parsed$Failure$
}
/** @constructor */
function $c_Lfastparse_ParsingRun(input, startIndex, originalParser, traceIndex, instrument, failureTerminalAggregate, failureGroupAggregate, shortParserMsg, lastFailureMsg, failureStack, isSuccess, logDepth, index, cut, successValue, verboseFailures, noDropBuffer, misc) {
  this.Lfastparse_ParsingRun__f_input = null;
  this.Lfastparse_ParsingRun__f_startIndex = 0;
  this.Lfastparse_ParsingRun__f_originalParser = null;
  this.Lfastparse_ParsingRun__f_traceIndex = 0;
  this.Lfastparse_ParsingRun__f_instrument = null;
  this.Lfastparse_ParsingRun__f_failureTerminalAggregate = null;
  this.Lfastparse_ParsingRun__f_failureGroupAggregate = null;
  this.Lfastparse_ParsingRun__f_shortParserMsg = null;
  this.Lfastparse_ParsingRun__f_lastFailureMsg = null;
  this.Lfastparse_ParsingRun__f_failureStack = null;
  this.Lfastparse_ParsingRun__f_isSuccess = false;
  this.Lfastparse_ParsingRun__f_index = 0;
  this.Lfastparse_ParsingRun__f_cut = false;
  this.Lfastparse_ParsingRun__f_successValue = null;
  this.Lfastparse_ParsingRun__f_verboseFailures = false;
  this.Lfastparse_ParsingRun__f_noDropBuffer = false;
  this.Lfastparse_ParsingRun__f_input = input;
  this.Lfastparse_ParsingRun__f_startIndex = startIndex;
  this.Lfastparse_ParsingRun__f_originalParser = originalParser;
  this.Lfastparse_ParsingRun__f_traceIndex = traceIndex;
  this.Lfastparse_ParsingRun__f_instrument = instrument;
  this.Lfastparse_ParsingRun__f_failureTerminalAggregate = failureTerminalAggregate;
  this.Lfastparse_ParsingRun__f_failureGroupAggregate = failureGroupAggregate;
  this.Lfastparse_ParsingRun__f_shortParserMsg = shortParserMsg;
  this.Lfastparse_ParsingRun__f_lastFailureMsg = lastFailureMsg;
  this.Lfastparse_ParsingRun__f_failureStack = failureStack;
  this.Lfastparse_ParsingRun__f_isSuccess = isSuccess;
  this.Lfastparse_ParsingRun__f_index = index;
  this.Lfastparse_ParsingRun__f_cut = cut;
  this.Lfastparse_ParsingRun__f_successValue = successValue;
  this.Lfastparse_ParsingRun__f_verboseFailures = verboseFailures;
  this.Lfastparse_ParsingRun__f_noDropBuffer = noDropBuffer
}
$c_Lfastparse_ParsingRun.prototype = new $h_O();
$c_Lfastparse_ParsingRun.prototype.constructor = $c_Lfastparse_ParsingRun;
/** @constructor */
function $h_Lfastparse_ParsingRun() {
  /*<skip>*/
}
$h_Lfastparse_ParsingRun.prototype = $c_Lfastparse_ParsingRun.prototype;
$c_Lfastparse_ParsingRun.prototype.aggregateMsg__I__F0__Lfastparse_internal_Msgs__V = (function(startIndex, msgToSet, msgToAggregate) {
  $m_sci_List$();
  var array = [new $c_Lfastparse_internal_Lazy(msgToSet)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var msgToSet$1 = new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  this.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, msgToSet$1, msgToAggregate, false)
});
$c_Lfastparse_ParsingRun.prototype.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V = (function(startIndex, msgToSet, msgToAggregate, forceAggregate) {
  if (((!this.Lfastparse_ParsingRun__f_isSuccess) && (this.Lfastparse_ParsingRun__f_lastFailureMsg === null))) {
    this.Lfastparse_ParsingRun__f_lastFailureMsg = msgToSet
  };
  this.Lfastparse_ParsingRun__f_shortParserMsg = msgToSet;
  if ((this.checkAggregate__I__Z(startIndex) && (!forceAggregate))) {
    this.Lfastparse_ParsingRun__f_failureGroupAggregate = msgToSet
  } else {
    this.Lfastparse_ParsingRun__f_failureGroupAggregate = msgToAggregate
  }
});
$c_Lfastparse_ParsingRun.prototype.aggregateTerminal__I__F0__V = (function(startIndex, f) {
  var f2 = new $c_Lfastparse_internal_Lazy(f);
  if ((!this.Lfastparse_ParsingRun__f_isSuccess)) {
    if ((this.Lfastparse_ParsingRun__f_index === this.Lfastparse_ParsingRun__f_traceIndex)) {
      this.Lfastparse_ParsingRun__f_failureTerminalAggregate = $n(this.Lfastparse_ParsingRun__f_failureTerminalAggregate).$colon$colon__Lfastparse_internal_Lazy__Lfastparse_internal_Msgs(f2)
    };
    if ((this.Lfastparse_ParsingRun__f_lastFailureMsg === null)) {
      $m_sci_List$();
      var array = [f2];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      this.Lfastparse_ParsingRun__f_lastFailureMsg = new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems))
    }
  };
  if ((startIndex >= this.Lfastparse_ParsingRun__f_traceIndex)) {
    $m_sci_List$();
    var array$1 = [f2];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var $$x1 = new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1))
  } else {
    var $$x1 = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty
  };
  this.Lfastparse_ParsingRun__f_shortParserMsg = $$x1;
  this.Lfastparse_ParsingRun__f_failureGroupAggregate = (this.checkAggregate__I__Z(startIndex) ? this.Lfastparse_ParsingRun__f_shortParserMsg : $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty)
});
$c_Lfastparse_ParsingRun.prototype.setMsg__I__F0__V = (function(startIndex, f) {
  $m_sci_List$();
  var array = [new $c_Lfastparse_internal_Lazy(f)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.setMsg__I__Lfastparse_internal_Msgs__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)))
});
$c_Lfastparse_ParsingRun.prototype.setMsg__I__Lfastparse_internal_Msgs__V = (function(startIndex, f) {
  if (((!this.Lfastparse_ParsingRun__f_isSuccess) && (this.Lfastparse_ParsingRun__f_lastFailureMsg === null))) {
    this.Lfastparse_ParsingRun__f_lastFailureMsg = f
  };
  this.Lfastparse_ParsingRun__f_shortParserMsg = ((startIndex >= this.Lfastparse_ParsingRun__f_traceIndex) ? f : $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty);
  this.Lfastparse_ParsingRun__f_failureGroupAggregate = (this.checkAggregate__I__Z(startIndex) ? this.Lfastparse_ParsingRun__f_shortParserMsg : $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty)
});
$c_Lfastparse_ParsingRun.prototype.checkAggregate__I__Z = (function(startIndex) {
  return ((((!this.Lfastparse_ParsingRun__f_cut) && (!this.Lfastparse_ParsingRun__f_isSuccess)) && (startIndex <= this.Lfastparse_ParsingRun__f_traceIndex)) && (this.Lfastparse_ParsingRun__f_traceIndex <= this.Lfastparse_ParsingRun__f_index))
});
$c_Lfastparse_ParsingRun.prototype.freshSuccess__O__Lfastparse_ParsingRun = (function(value) {
  this.Lfastparse_ParsingRun__f_isSuccess = true;
  this.Lfastparse_ParsingRun__f_successValue = value;
  return this
});
$c_Lfastparse_ParsingRun.prototype.freshSuccessUnit__Lfastparse_ParsingRun = (function() {
  this.Lfastparse_ParsingRun__f_isSuccess = true;
  this.Lfastparse_ParsingRun__f_successValue = (void 0);
  return this
});
$c_Lfastparse_ParsingRun.prototype.freshSuccessUnit__I__Lfastparse_ParsingRun = (function(index) {
  this.Lfastparse_ParsingRun__f_isSuccess = true;
  this.Lfastparse_ParsingRun__f_successValue = (void 0);
  this.Lfastparse_ParsingRun__f_index = index;
  return this
});
$c_Lfastparse_ParsingRun.prototype.freshSuccess__O__I__Lfastparse_ParsingRun = (function(value, index) {
  this.Lfastparse_ParsingRun__f_isSuccess = true;
  this.Lfastparse_ParsingRun__f_successValue = value;
  this.Lfastparse_ParsingRun__f_index = index;
  return this
});
$c_Lfastparse_ParsingRun.prototype.freshSuccess__O__Z__Lfastparse_ParsingRun = (function(value, cut) {
  this.Lfastparse_ParsingRun__f_isSuccess = true;
  this.Lfastparse_ParsingRun__f_successValue = value;
  this.Lfastparse_ParsingRun__f_cut = cut;
  return this
});
$c_Lfastparse_ParsingRun.prototype.freshSuccess__O__I__Z__Lfastparse_ParsingRun = (function(value, index, cut) {
  this.Lfastparse_ParsingRun__f_isSuccess = true;
  this.Lfastparse_ParsingRun__f_successValue = value;
  this.Lfastparse_ParsingRun__f_index = index;
  this.Lfastparse_ParsingRun__f_cut = cut;
  return this
});
$c_Lfastparse_ParsingRun.prototype.freshFailure__Lfastparse_ParsingRun = (function() {
  if (this.Lfastparse_ParsingRun__f_verboseFailures) {
    this.Lfastparse_ParsingRun__f_lastFailureMsg = null;
    this.Lfastparse_ParsingRun__f_failureStack = $m_sci_Nil$()
  };
  this.Lfastparse_ParsingRun__f_isSuccess = false;
  return this
});
$c_Lfastparse_ParsingRun.prototype.freshFailure__I__Lfastparse_ParsingRun = (function(startPos) {
  if (this.Lfastparse_ParsingRun__f_verboseFailures) {
    this.Lfastparse_ParsingRun__f_lastFailureMsg = null;
    this.Lfastparse_ParsingRun__f_failureStack = $m_sci_Nil$()
  };
  this.Lfastparse_ParsingRun__f_isSuccess = false;
  this.Lfastparse_ParsingRun__f_index = startPos;
  return this
});
$c_Lfastparse_ParsingRun.prototype.augmentFailure__I__Lfastparse_ParsingRun = (function(index) {
  this.Lfastparse_ParsingRun__f_index = index;
  return this
});
$c_Lfastparse_ParsingRun.prototype.augmentFailure__I__Z__Lfastparse_ParsingRun = (function(index, cut) {
  this.Lfastparse_ParsingRun__f_index = index;
  this.Lfastparse_ParsingRun__f_cut = cut;
  return this
});
$c_Lfastparse_ParsingRun.prototype.checkForDrop__Z = (function() {
  return ((!this.Lfastparse_ParsingRun__f_noDropBuffer) && this.Lfastparse_ParsingRun__f_cut)
});
function $as_Lfastparse_ParsingRun(obj) {
  return (((obj instanceof $c_Lfastparse_ParsingRun) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.ParsingRun"))
}
function $isArrayOf_Lfastparse_ParsingRun(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_ParsingRun)))
}
function $asArrayOf_Lfastparse_ParsingRun(obj, depth) {
  return (($isArrayOf_Lfastparse_ParsingRun(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.ParsingRun;", depth))
}
var $d_Lfastparse_ParsingRun = new $TypeData().initClass({
  Lfastparse_ParsingRun: 0
}, false, "fastparse.ParsingRun", {
  Lfastparse_ParsingRun: 1,
  O: 1
});
$c_Lfastparse_ParsingRun.prototype.$classData = $d_Lfastparse_ParsingRun;
function $p_Lfastparse_internal_Lazy__force$lzycompute__O($thiz) {
  if ((!$thiz.Lfastparse_internal_Lazy__f_bitmap$0)) {
    $thiz.Lfastparse_internal_Lazy__f_force = $n($thiz.Lfastparse_internal_Lazy__f_calc0).apply__O();
    $thiz.Lfastparse_internal_Lazy__f_bitmap$0 = true
  };
  $thiz.Lfastparse_internal_Lazy__f_calc0 = null;
  return $thiz.Lfastparse_internal_Lazy__f_force
}
/** @constructor */
function $c_Lfastparse_internal_Lazy(calc0) {
  this.Lfastparse_internal_Lazy__f_force = null;
  this.Lfastparse_internal_Lazy__f_calc0 = null;
  this.Lfastparse_internal_Lazy__f_bitmap$0 = false;
  this.Lfastparse_internal_Lazy__f_calc0 = calc0
}
$c_Lfastparse_internal_Lazy.prototype = new $h_O();
$c_Lfastparse_internal_Lazy.prototype.constructor = $c_Lfastparse_internal_Lazy;
/** @constructor */
function $h_Lfastparse_internal_Lazy() {
  /*<skip>*/
}
$h_Lfastparse_internal_Lazy.prototype = $c_Lfastparse_internal_Lazy.prototype;
$c_Lfastparse_internal_Lazy.prototype.force__O = (function() {
  return ((!this.Lfastparse_internal_Lazy__f_bitmap$0) ? $p_Lfastparse_internal_Lazy__force$lzycompute__O(this) : this.Lfastparse_internal_Lazy__f_force)
});
function $as_Lfastparse_internal_Lazy(obj) {
  return (((obj instanceof $c_Lfastparse_internal_Lazy) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.internal.Lazy"))
}
function $isArrayOf_Lfastparse_internal_Lazy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_internal_Lazy)))
}
function $asArrayOf_Lfastparse_internal_Lazy(obj, depth) {
  return (($isArrayOf_Lfastparse_internal_Lazy(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.internal.Lazy;", depth))
}
var $d_Lfastparse_internal_Lazy = new $TypeData().initClass({
  Lfastparse_internal_Lazy: 0
}, false, "fastparse.internal.Lazy", {
  Lfastparse_internal_Lazy: 1,
  O: 1
});
$c_Lfastparse_internal_Lazy.prototype.$classData = $d_Lfastparse_internal_Lazy;
function $p_Lfastparse_internal_RepImpls$__end$1__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun($thiz, successIndex, index, count, endCut, actualMin$1, ctx$6, repeater$6, acc$1) {
  return ((count < actualMin$1) ? $n(ctx$6).augmentFailure__I__Z__Lfastparse_ParsingRun(index, endCut) : $n(ctx$6).freshSuccess__O__I__Z__Lfastparse_ParsingRun($n(repeater$6).result__O__O(acc$1), successIndex, endCut))
}
function $p_Lfastparse_internal_RepImpls$__end$2__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun($thiz, successIndex, index, count, endCut, min$5, ctx$7, repeater$7, acc$2) {
  return ((count < min$5) ? $n(ctx$7).augmentFailure__I__Z__Lfastparse_ParsingRun(index, endCut) : $n(ctx$7).freshSuccess__O__I__Z__Lfastparse_ParsingRun($n(repeater$7).result__O__O(acc$2), successIndex, endCut))
}
function $p_Lfastparse_internal_RepImpls$__end$3__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun($thiz, successIndex, index, count, endCut, actualMin$2, ctx$8, repeater$8, acc$3) {
  return ((count < actualMin$2) ? $n(ctx$8).augmentFailure__I__Z__Lfastparse_ParsingRun(index, endCut) : $n(ctx$8).freshSuccess__O__I__Z__Lfastparse_ParsingRun($n(repeater$8).result__O__O(acc$3), successIndex, endCut))
}
function $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun($thiz, successIndex, index, count, endCut, min$7, ctx$9, repeater$9, acc$4) {
  return ((count < min$7) ? $n(ctx$9).augmentFailure__I__Z__Lfastparse_ParsingRun(index, endCut) : $n(ctx$9).freshSuccess__O__I__Z__Lfastparse_ParsingRun($n(repeater$9).result__O__O(acc$4), successIndex, endCut))
}
/** @constructor */
function $c_Lfastparse_internal_RepImpls$() {
  /*<skip>*/
}
$c_Lfastparse_internal_RepImpls$.prototype = new $h_O();
$c_Lfastparse_internal_RepImpls$.prototype.constructor = $c_Lfastparse_internal_RepImpls$;
/** @constructor */
function $h_Lfastparse_internal_RepImpls$() {
  /*<skip>*/
}
$h_Lfastparse_internal_RepImpls$.prototype = $c_Lfastparse_internal_RepImpls$.prototype;
var $d_Lfastparse_internal_RepImpls$ = new $TypeData().initClass({
  Lfastparse_internal_RepImpls$: 0
}, false, "fastparse.internal.RepImpls$", {
  Lfastparse_internal_RepImpls$: 1,
  O: 1
});
$c_Lfastparse_internal_RepImpls$.prototype.$classData = $d_Lfastparse_internal_RepImpls$;
var $n_Lfastparse_internal_RepImpls$;
function $m_Lfastparse_internal_RepImpls$() {
  if ((!$n_Lfastparse_internal_RepImpls$)) {
    $n_Lfastparse_internal_RepImpls$ = new $c_Lfastparse_internal_RepImpls$()
  };
  return $n_Lfastparse_internal_RepImpls$
}
/** @constructor */
function $c_Lfastparse_internal_Util$() {
  /*<skip>*/
}
$c_Lfastparse_internal_Util$.prototype = new $h_O();
$c_Lfastparse_internal_Util$.prototype.constructor = $c_Lfastparse_internal_Util$;
/** @constructor */
function $h_Lfastparse_internal_Util$() {
  /*<skip>*/
}
$h_Lfastparse_internal_Util$.prototype = $c_Lfastparse_internal_Util$.prototype;
$c_Lfastparse_internal_Util$.prototype.parenthize__sci_Seq__T = (function(fs) {
  var this$3 = $n($n(fs).reverseIterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lfastparse_internal_Lazy(x$1$2);
    var this$2 = $n(x$1);
    return $as_T(this$2.force__O())
  }));
  var this$4 = new $c_sc_Iterator$$anon$9(this$3, f);
  var x1 = $as_sci_Seq($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$4)).distinct__O());
  if ((x1 !== null)) {
    $m_sci_Seq$();
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x1), true) && ($n(x1).lengthCompare__I__I(1) === 0))) {
      var x = $as_T($n(x1).apply__I__O(0));
      return x
    }
  };
  var this$11 = $n(x1);
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$11, "(", " | ", ")")
});
$c_Lfastparse_internal_Util$.prototype.joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs = (function(lhs, rhs) {
  if ($n($n(lhs).Lfastparse_internal_Msgs__f_value).isEmpty__Z()) {
    return rhs
  } else if ($n($n(rhs).Lfastparse_internal_Msgs__f_value).isEmpty__Z()) {
    return lhs
  } else {
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => {
      var this$2 = $n(lhs);
      var $$x1 = $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$2.Lfastparse_internal_Msgs__f_value);
      var this$3 = $n(rhs);
      return (($$x1 + " ~ ") + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$3.Lfastparse_internal_Msgs__f_value))
    })))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems))
  }
});
$c_Lfastparse_internal_Util$.prototype.consumeWhitespace__F1__Lfastparse_ParsingRun__V = (function(whitespace, ctx) {
  var oldCapturing = $n(ctx).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(ctx).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $n(whitespace).apply__O__O(ctx);
  $n(ctx).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing
});
$c_Lfastparse_internal_Util$.prototype.lineNumberLookup__T__AI = (function(data) {
  var lineStarts = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var i = 0;
  var col = 1;
  var cr = false;
  var prev = null;
  while (true) {
    var $$x1 = i;
    var this$1 = $n(data);
    if (($$x1 < this$1.length)) {
      $m_sc_StringOps$();
      var i$1 = i;
      var this$4 = $n(data);
      var char = $charAt(this$4, i$1);
      if ((char === 13)) {
        var x = prev;
        if (((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, $bC(10))) && (col === 1))) {
          var elem = i;
          lineStarts.addOne__O__scm_ArrayBuffer(elem)
        };
        col = 1;
        cr = true
      } else if ((char === 10)) {
        var x$1 = prev;
        if (((!$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, $bC(13))) && (col === 1))) {
          var elem$1 = i;
          lineStarts.addOne__O__scm_ArrayBuffer(elem$1)
        };
        col = 1;
        cr = false
      } else {
        if ((col === 1)) {
          var elem$2 = i;
          lineStarts.addOne__O__scm_ArrayBuffer(elem$2)
        };
        col = ((1 + col) | 0);
        cr = false
      };
      prev = $bC(char);
      i = ((1 + i) | 0)
    } else {
      break
    }
  };
  if ((col === 1)) {
    var elem$3 = i;
    lineStarts.addOne__O__scm_ArrayBuffer(elem$3)
  };
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((lineStarts.scm_ArrayBuffer__f_size0 >= 0)) {
    var len = lineStarts.scm_ArrayBuffer__f_size0;
    var destination = new $ac_I(len);
    lineStarts.copyToArray__O__I__I__I(destination, 0, 2147483647);
    return destination
  } else {
    var capacity = 0;
    var jsElems = null;
    capacity = 0;
    jsElems = [];
    var it = $n(lineStarts.view__scm_ArrayBufferView()).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem$4 = $n(it).next__O();
      var unboxedElem = ((elem$4 === null) ? 0 : elem$4);
      jsElems.push(unboxedElem)
    };
    return new $ac_I(new Int32Array(jsElems))
  }
});
$c_Lfastparse_internal_Util$.prototype.literalize__sci_IndexedSeq__Z__T = (function(s, unicode) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  sb.append__C__scm_StringBuilder(34);
  var i = 0;
  var len = $n(s).length__I();
  while ((i < len)) {
    var x1 = $uC($n(s).apply__I__O(i));
    switch (x1) {
      case 34: {
        sb.append__T__scm_StringBuilder("\\\"");
        break
      }
      case 92: {
        sb.append__T__scm_StringBuilder("\\\\");
        break
      }
      case 8: {
        sb.append__T__scm_StringBuilder("\\b");
        break
      }
      case 12: {
        sb.append__T__scm_StringBuilder("\\f");
        break
      }
      case 10: {
        sb.append__T__scm_StringBuilder("\\n");
        break
      }
      case 13: {
        sb.append__T__scm_StringBuilder("\\r");
        break
      }
      case 9: {
        sb.append__T__scm_StringBuilder("\\t");
        break
      }
      default: {
        if (((x1 < 32) || ((x1 > 126) && unicode))) {
          var $$x1 = $m_sc_StringOps$();
          var array = [x1];
          sb.append__T__scm_StringBuilder($n($$x1).format$extension__T__sci_Seq__T("\\u%04x", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
        } else {
          sb.append__C__scm_StringBuilder(x1)
        }
      }
    };
    i = ((1 + i) | 0)
  };
  sb.append__C__scm_StringBuilder(34);
  return $n(sb.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
var $d_Lfastparse_internal_Util$ = new $TypeData().initClass({
  Lfastparse_internal_Util$: 0
}, false, "fastparse.internal.Util$", {
  Lfastparse_internal_Util$: 1,
  O: 1
});
$c_Lfastparse_internal_Util$.prototype.$classData = $d_Lfastparse_internal_Util$;
var $n_Lfastparse_internal_Util$;
function $m_Lfastparse_internal_Util$() {
  if ((!$n_Lfastparse_internal_Util$)) {
    $n_Lfastparse_internal_Util$ = new $c_Lfastparse_internal_Util$()
  };
  return $n_Lfastparse_internal_Util$
}
/** @constructor */
function $c_Lfastparse_package$() {
  /*<skip>*/
}
$c_Lfastparse_package$.prototype = new $h_O();
$c_Lfastparse_package$.prototype.constructor = $c_Lfastparse_package$;
/** @constructor */
function $h_Lfastparse_package$() {
  /*<skip>*/
}
$h_Lfastparse_package$.prototype = $c_Lfastparse_package$.prototype;
$c_Lfastparse_package$.prototype.parse__Lfastparse_ParserInputSource__F1__Z__I__Lfastparse_internal_Instrument__Lfastparse_Parsed = (function(input, parser, verboseFailures, startIndex, instrument) {
  var $$x1 = $m_Lfastparse_Parsed$();
  var this$1 = $n(input);
  var arg1 = $n(this$1.Lfastparse_ParserInputSource$fromParserInput__f_conv).apply__O__O(this$1.Lfastparse_ParserInputSource$fromParserInput__f_t);
  var x$1 = $as_Lfastparse_ParserInput(arg1);
  return $n($$x1).fromParsingRun__Lfastparse_ParsingRun__Lfastparse_Parsed($m_Lfastparse_package$().parseInputRaw__Lfastparse_ParserInput__F1__Z__I__I__Lfastparse_internal_Instrument__Z__Lfastparse_ParsingRun(x$1, parser, verboseFailures, startIndex, (-1), instrument, ($m_Lfastparse_package$(), true)))
});
$c_Lfastparse_package$.prototype.parseInputRaw__Lfastparse_ParserInput__F1__Z__I__I__Lfastparse_internal_Instrument__Z__Lfastparse_ParsingRun = (function(input, parser, verboseFailures, startIndex, traceIndex, instrument, enableLogging) {
  return $as_Lfastparse_ParsingRun($n(parser).apply__O__O(new $c_Lfastparse_ParsingRun(input, startIndex, parser, traceIndex, instrument, $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty, $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty, $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty, null, ($m_sci_List$(), $m_sci_Nil$()), true, (enableLogging ? 0 : (-1)), startIndex, true, (void 0), verboseFailures, false, $as_scm_Map($m_scm_Map$().empty__O()))))
});
$c_Lfastparse_package$.prototype.End__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(ctx) {
  var startIndex = $n(ctx).Lfastparse_ParsingRun__f_index;
  var res = ((!$n($n(ctx).Lfastparse_ParsingRun__f_input).isReachable__I__Z(startIndex)) ? $n(ctx).freshSuccessUnit__Lfastparse_ParsingRun() : $n(ctx).freshFailure__Lfastparse_ParsingRun());
  if ($n(ctx).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(ctx).aggregateTerminal__I__F0__V(startIndex, new $c_sjsr_AnonFunction0((() => "end-of-input")))
  };
  return res
});
$c_Lfastparse_package$.prototype.Start__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(ctx) {
  var startIndex = $n(ctx).Lfastparse_ParsingRun__f_index;
  var res = ((startIndex === 0) ? $n(ctx).freshSuccessUnit__Lfastparse_ParsingRun() : $n(ctx).freshFailure__Lfastparse_ParsingRun());
  if ($n(ctx).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(ctx).aggregateTerminal__I__F0__V(startIndex, new $c_sjsr_AnonFunction0((() => "start-of-input")))
  };
  return res
});
$c_Lfastparse_package$.prototype.Pass__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(ctx) {
  var res = $n(ctx).freshSuccessUnit__Lfastparse_ParsingRun();
  if ($n(ctx).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(ctx).setMsg__I__F0__V($n(ctx).Lfastparse_ParsingRun__f_index, new $c_sjsr_AnonFunction0((() => "Pass")))
  };
  return res
});
$c_Lfastparse_package$.prototype.Pass__O__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(v, ctx) {
  var res = $n(ctx).freshSuccess__O__Lfastparse_ParsingRun(v);
  if ($n(ctx).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(ctx).setMsg__I__F0__V($n(ctx).Lfastparse_ParsingRun__f_index, new $c_sjsr_AnonFunction0((() => "Pass")))
  };
  return res
});
$c_Lfastparse_package$.prototype.Fail__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(ctx) {
  var res = $n(ctx).freshFailure__Lfastparse_ParsingRun();
  if ($n(ctx).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(ctx).setMsg__I__F0__V($n(ctx).Lfastparse_ParsingRun__f_index, new $c_sjsr_AnonFunction0((() => "fail")))
  };
  return res
});
$c_Lfastparse_package$.prototype.Index__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(ctx) {
  var res = $n(ctx).freshSuccess__O__Lfastparse_ParsingRun($n(ctx).Lfastparse_ParsingRun__f_index);
  if ($n(ctx).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(ctx).setMsg__I__F0__V($n(ctx).Lfastparse_ParsingRun__f_index, new $c_sjsr_AnonFunction0((() => "Index")))
  };
  return res
});
$c_Lfastparse_package$.prototype.AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(ctx) {
  var startIndex = $n(ctx).Lfastparse_ParsingRun__f_index;
  var res = ((!$n($n(ctx).Lfastparse_ParsingRun__f_input).isReachable__I__Z($n(ctx).Lfastparse_ParsingRun__f_index)) ? $n(ctx).freshFailure__Lfastparse_ParsingRun() : $n(ctx).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + $n(ctx).Lfastparse_ParsingRun__f_index) | 0)));
  if ($n(ctx).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(ctx).aggregateTerminal__I__F0__V(startIndex, new $c_sjsr_AnonFunction0((() => "any-character")))
  };
  return res
});
var $d_Lfastparse_package$ = new $TypeData().initClass({
  Lfastparse_package$: 0
}, false, "fastparse.package$", {
  Lfastparse_package$: 1,
  O: 1
});
$c_Lfastparse_package$.prototype.$classData = $d_Lfastparse_package$;
var $n_Lfastparse_package$;
function $m_Lfastparse_package$() {
  if ((!$n_Lfastparse_package$)) {
    $n_Lfastparse_package$ = new $c_Lfastparse_package$()
  };
  return $n_Lfastparse_package$
}
/** @constructor */
function $c_Lhammer_RecognizerOptions$() {
  /*<skip>*/
}
$c_Lhammer_RecognizerOptions$.prototype = new $h_O();
$c_Lhammer_RecognizerOptions$.prototype.constructor = $c_Lhammer_RecognizerOptions$;
/** @constructor */
function $h_Lhammer_RecognizerOptions$() {
  /*<skip>*/
}
$h_Lhammer_RecognizerOptions$.prototype = $c_Lhammer_RecognizerOptions$.prototype;
$c_Lhammer_RecognizerOptions$.prototype.apply__I__Lhammer_RecognizerOptions = (function(direction) {
  var array = [$ct_T2__O__O__(new $c_T2(), "direction", direction)];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
});
var $d_Lhammer_RecognizerOptions$ = new $TypeData().initClass({
  Lhammer_RecognizerOptions$: 0
}, false, "hammer.RecognizerOptions$", {
  Lhammer_RecognizerOptions$: 1,
  O: 1
});
$c_Lhammer_RecognizerOptions$.prototype.$classData = $d_Lhammer_RecognizerOptions$;
var $n_Lhammer_RecognizerOptions$;
function $m_Lhammer_RecognizerOptions$() {
  if ((!$n_Lhammer_RecognizerOptions$)) {
    $n_Lhammer_RecognizerOptions$ = new $c_Lhammer_RecognizerOptions$()
  };
  return $n_Lhammer_RecognizerOptions$
}
/** @constructor */
function $c_Lhammer_Recognizers$() {
  this.Lhammer_Recognizers$__f_swipe = null;
  this.Lhammer_Recognizers$__f_swipe = "swipe"
}
$c_Lhammer_Recognizers$.prototype = new $h_O();
$c_Lhammer_Recognizers$.prototype.constructor = $c_Lhammer_Recognizers$;
/** @constructor */
function $h_Lhammer_Recognizers$() {
  /*<skip>*/
}
$h_Lhammer_Recognizers$.prototype = $c_Lhammer_Recognizers$.prototype;
var $d_Lhammer_Recognizers$ = new $TypeData().initClass({
  Lhammer_Recognizers$: 0
}, false, "hammer.Recognizers$", {
  Lhammer_Recognizers$: 1,
  O: 1
});
$c_Lhammer_Recognizers$.prototype.$classData = $d_Lhammer_Recognizers$;
var $n_Lhammer_Recognizers$;
function $m_Lhammer_Recognizers$() {
  if ((!$n_Lhammer_Recognizers$)) {
    $n_Lhammer_Recognizers$ = new $c_Lhammer_Recognizers$()
  };
  return $n_Lhammer_Recognizers$
}
function $is_Lio_circe_CursorOp$Selection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_CursorOp$Selection)))
}
function $as_Lio_circe_CursorOp$Selection(obj) {
  return (($is_Lio_circe_CursorOp$Selection(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$Selection"))
}
function $isArrayOf_Lio_circe_CursorOp$Selection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$Selection)))
}
function $asArrayOf_Lio_circe_CursorOp$Selection(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$Selection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$Selection;", depth))
}
/** @constructor */
function $c_Lio_circe_Encoder$LowPriorityAsObjectEncoders() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$LowPriorityAsObjectEncoders.prototype = new $h_O();
$c_Lio_circe_Encoder$LowPriorityAsObjectEncoders.prototype.constructor = $c_Lio_circe_Encoder$LowPriorityAsObjectEncoders;
/** @constructor */
function $h_Lio_circe_Encoder$LowPriorityAsObjectEncoders() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$LowPriorityAsObjectEncoders.prototype = $c_Lio_circe_Encoder$LowPriorityAsObjectEncoders.prototype;
/** @constructor */
function $c_Lio_circe_Printer$SizePredictor() {
  /*<skip>*/
}
$c_Lio_circe_Printer$SizePredictor.prototype = new $h_O();
$c_Lio_circe_Printer$SizePredictor.prototype.constructor = $c_Lio_circe_Printer$SizePredictor;
/** @constructor */
function $h_Lio_circe_Printer$SizePredictor() {
  /*<skip>*/
}
$h_Lio_circe_Printer$SizePredictor.prototype = $c_Lio_circe_Printer$SizePredictor.prototype;
/** @constructor */
function $c_Lio_circe_generic_extras_util_RecordToMap() {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_util_RecordToMap.prototype = new $h_O();
$c_Lio_circe_generic_extras_util_RecordToMap.prototype.constructor = $c_Lio_circe_generic_extras_util_RecordToMap;
/** @constructor */
function $h_Lio_circe_generic_extras_util_RecordToMap() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_util_RecordToMap.prototype = $c_Lio_circe_generic_extras_util_RecordToMap.prototype;
/** @constructor */
function $c_Lio_circe_generic_extras_util_RecordToMap$() {
  this.Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap = null;
  $n_Lio_circe_generic_extras_util_RecordToMap$ = this;
  this.Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$1()
}
$c_Lio_circe_generic_extras_util_RecordToMap$.prototype = new $h_O();
$c_Lio_circe_generic_extras_util_RecordToMap$.prototype.constructor = $c_Lio_circe_generic_extras_util_RecordToMap$;
/** @constructor */
function $h_Lio_circe_generic_extras_util_RecordToMap$() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_util_RecordToMap$.prototype = $c_Lio_circe_generic_extras_util_RecordToMap$.prototype;
var $d_Lio_circe_generic_extras_util_RecordToMap$ = new $TypeData().initClass({
  Lio_circe_generic_extras_util_RecordToMap$: 0
}, false, "io.circe.generic.extras.util.RecordToMap$", {
  Lio_circe_generic_extras_util_RecordToMap$: 1,
  O: 1
});
$c_Lio_circe_generic_extras_util_RecordToMap$.prototype.$classData = $d_Lio_circe_generic_extras_util_RecordToMap$;
var $n_Lio_circe_generic_extras_util_RecordToMap$;
function $m_Lio_circe_generic_extras_util_RecordToMap$() {
  if ((!$n_Lio_circe_generic_extras_util_RecordToMap$)) {
    $n_Lio_circe_generic_extras_util_RecordToMap$ = new $c_Lio_circe_generic_extras_util_RecordToMap$()
  };
  return $n_Lio_circe_generic_extras_util_RecordToMap$
}
function $p_Lio_circe_scalajs_package$__convertAnyToJsonUnsafe__O__Lio_circe_Json($thiz, input) {
  if (((typeof input) === "string")) {
    var x2 = $as_T(input);
    $m_Lio_circe_Json$();
    return new $c_Lio_circe_Json$JString(x2)
  } else if (((typeof input) === "number")) {
    var x3 = $uD(input);
    return $m_Lio_circe_Json$().fromDoubleOrNull__D__Lio_circe_Json(x3)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(true, input)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_True
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(false, input)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_False
  } else if ((input === null)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null
  } else if ($uZ((input instanceof Array))) {
    $m_Lio_circe_Json$();
    var len = $uI(input.length);
    var res = new Array(len);
    var i = 0;
    while ((i < len)) {
      var $$x1 = i;
      var arg1 = input[i];
      res[$$x1] = $p_Lio_circe_scalajs_package$__convertAnyToJsonUnsafe__O__Lio_circe_Json($m_Lio_circe_scalajs_package$(), arg1);
      i = ((1 + i) | 0)
    };
    var values = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res);
    return new $c_Lio_circe_Json$JArray($m_sci_Vector$().from__sc_IterableOnce__sci_Vector(values))
  } else if ($uZ((input instanceof Object))) {
    var $$x2 = $m_Lio_circe_Json$();
    var this$7 = new $c_sjs_js_WrappedDictionary(input);
    var f = new $c_sjsr_AnonFunction1(((input$2$2) => $p_Lio_circe_scalajs_package$__convertAnyToJsonUnsafe__O__Lio_circe_Json($m_Lio_circe_scalajs_package$(), input$2$2)));
    var this$8 = new $c_sc_MapView$MapValues(this$7, f);
    return $n($$x2).fromFields__sc_Iterable__Lio_circe_Json($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$8))
  } else if ((input === (void 0))) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null
  } else {
    throw new $c_s_MatchError(input)
  }
}
/** @constructor */
function $c_Lio_circe_scalajs_package$() {
  this.Lio_circe_scalajs_package$__f_toJsAnyFolder = null;
  $n_Lio_circe_scalajs_package$ = this;
  this.Lio_circe_scalajs_package$__f_toJsAnyFolder = new $c_Lio_circe_scalajs_package$$anon$1()
}
$c_Lio_circe_scalajs_package$.prototype = new $h_O();
$c_Lio_circe_scalajs_package$.prototype.constructor = $c_Lio_circe_scalajs_package$;
/** @constructor */
function $h_Lio_circe_scalajs_package$() {
  /*<skip>*/
}
$h_Lio_circe_scalajs_package$.prototype = $c_Lio_circe_scalajs_package$.prototype;
$c_Lio_circe_scalajs_package$.prototype.convertJsToJson__sjs_js_Any__s_util_Either = (function(input) {
  try {
    $n($m_s_package$().s_package$__f_Right);
    var value = $p_Lio_circe_scalajs_package$__convertAnyToJsonUnsafe__O__Lio_circe_Json(this, input);
    return new $c_s_util_Right(value)
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(o11).isEmpty__Z())) {
      var exception = $as_jl_Throwable($n(o11).get__O());
      $n($m_s_package$().s_package$__f_Left);
      return new $c_s_util_Left(exception)
    };
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
  }
});
$c_Lio_circe_scalajs_package$.prototype.decodeJs__sjs_js_Any__Lio_circe_Decoder__s_util_Either = (function(input, d) {
  var x1 = this.convertJsToJson__sjs_js_Any__s_util_Either(input);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var json = $as_Lio_circe_Json($n(x2).s_util_Right__f_value);
    var this$1 = $n(d);
    return $f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either(this$1, json)
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lio_circe_scalajs_package$.prototype.convertJsonToJs__Lio_circe_Json__sjs_js_Any = (function(input) {
  return $n(input).foldWith__Lio_circe_Json$Folder__O(this.Lio_circe_scalajs_package$__f_toJsAnyFolder)
});
var $d_Lio_circe_scalajs_package$ = new $TypeData().initClass({
  Lio_circe_scalajs_package$: 0
}, false, "io.circe.scalajs.package$", {
  Lio_circe_scalajs_package$: 1,
  O: 1
});
$c_Lio_circe_scalajs_package$.prototype.$classData = $d_Lio_circe_scalajs_package$;
var $n_Lio_circe_scalajs_package$;
function $m_Lio_circe_scalajs_package$() {
  if ((!$n_Lio_circe_scalajs_package$)) {
    $n_Lio_circe_scalajs_package$ = new $c_Lio_circe_scalajs_package$()
  };
  return $n_Lio_circe_scalajs_package$
}
/** @constructor */
function $c_Lio_circe_scalajs_package$EncoderJsOps$() {
  /*<skip>*/
}
$c_Lio_circe_scalajs_package$EncoderJsOps$.prototype = new $h_O();
$c_Lio_circe_scalajs_package$EncoderJsOps$.prototype.constructor = $c_Lio_circe_scalajs_package$EncoderJsOps$;
/** @constructor */
function $h_Lio_circe_scalajs_package$EncoderJsOps$() {
  /*<skip>*/
}
$h_Lio_circe_scalajs_package$EncoderJsOps$.prototype = $c_Lio_circe_scalajs_package$EncoderJsOps$.prototype;
$c_Lio_circe_scalajs_package$EncoderJsOps$.prototype.asJsAny$extension__O__Lio_circe_Encoder__sjs_js_Any = (function(this$, encoder) {
  return $m_Lio_circe_scalajs_package$().convertJsonToJs__Lio_circe_Json__sjs_js_Any($n(encoder).apply__O__Lio_circe_Json(this$))
});
var $d_Lio_circe_scalajs_package$EncoderJsOps$ = new $TypeData().initClass({
  Lio_circe_scalajs_package$EncoderJsOps$: 0
}, false, "io.circe.scalajs.package$EncoderJsOps$", {
  Lio_circe_scalajs_package$EncoderJsOps$: 1,
  O: 1
});
$c_Lio_circe_scalajs_package$EncoderJsOps$.prototype.$classData = $d_Lio_circe_scalajs_package$EncoderJsOps$;
var $n_Lio_circe_scalajs_package$EncoderJsOps$;
function $m_Lio_circe_scalajs_package$EncoderJsOps$() {
  if ((!$n_Lio_circe_scalajs_package$EncoderJsOps$)) {
    $n_Lio_circe_scalajs_package$EncoderJsOps$ = new $c_Lio_circe_scalajs_package$EncoderJsOps$()
  };
  return $n_Lio_circe_scalajs_package$EncoderJsOps$
}
function $is_Ljapgolly_scalajs_react_ComponentDom(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_ComponentDom)))
}
function $as_Ljapgolly_scalajs_react_ComponentDom(obj) {
  return (($is_Ljapgolly_scalajs_react_ComponentDom(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.ComponentDom"))
}
function $isArrayOf_Ljapgolly_scalajs_react_ComponentDom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_ComponentDom)))
}
function $asArrayOf_Ljapgolly_scalajs_react_ComponentDom(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_ComponentDom(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.ComponentDom;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_ComponentDom$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_ComponentDom$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ComponentDom$.prototype.constructor = $c_Ljapgolly_scalajs_react_ComponentDom$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ComponentDom$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ComponentDom$.prototype = $c_Ljapgolly_scalajs_react_ComponentDom$.prototype;
$c_Ljapgolly_scalajs_react_ComponentDom$.prototype.apply__sjs_js_$bar__Ljapgolly_scalajs_react_ComponentDom = (function(i) {
  if ($uZ((i instanceof Element))) {
    return new $c_Ljapgolly_scalajs_react_ComponentDom$Element(i)
  } else if ($uZ((i instanceof Text))) {
    return new $c_Ljapgolly_scalajs_react_ComponentDom$Text(i)
  } else if (((i === null) || (i === (void 0)))) {
    return $m_Ljapgolly_scalajs_react_ComponentDom$Unmounted$()
  } else {
    throw new $c_s_MatchError(i)
  }
});
$c_Ljapgolly_scalajs_react_ComponentDom$.prototype.findDOMNode__sjs_js_$bar__Ljapgolly_scalajs_react_ComponentDom = (function(a) {
  try {
    var b = $i_react$002ddom.findDOMNode(a)
  } catch (e) {
    var b = null
  };
  return this.apply__sjs_js_$bar__Ljapgolly_scalajs_react_ComponentDom(b)
});
var $d_Ljapgolly_scalajs_react_ComponentDom$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ComponentDom$: 0
}, false, "japgolly.scalajs.react.ComponentDom$", {
  Ljapgolly_scalajs_react_ComponentDom$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_ComponentDom$.prototype.$classData = $d_Ljapgolly_scalajs_react_ComponentDom$;
var $n_Ljapgolly_scalajs_react_ComponentDom$;
function $m_Ljapgolly_scalajs_react_ComponentDom$() {
  if ((!$n_Ljapgolly_scalajs_react_ComponentDom$)) {
    $n_Ljapgolly_scalajs_react_ComponentDom$ = new $c_Ljapgolly_scalajs_react_ComponentDom$()
  };
  return $n_Ljapgolly_scalajs_react_ComponentDom$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_CtorType.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_CtorType.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType.prototype = $c_Ljapgolly_scalajs_react_CtorType.prototype;
$c_Ljapgolly_scalajs_react_CtorType.prototype.withRawProp__T__sjs_js_Any__Ljapgolly_scalajs_react_CtorType = (function(name, value) {
  return this.addMod__F1__Ljapgolly_scalajs_react_CtorType(new $c_sjsr_AnonFunction1(((x$1$2) => {
    x$1$2[name] = value
  })))
});
$c_Ljapgolly_scalajs_react_CtorType.prototype.withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType = (function(k) {
  if ((k instanceof $c_RTLong)) {
    var t = $uJ(k);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var s = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
    var $$x1 = s
  } else {
    var $$x1 = k
  };
  return this.withRawProp__T__sjs_js_Any__Ljapgolly_scalajs_react_CtorType("key", $$x1)
});
function $as_Ljapgolly_scalajs_react_CtorType(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_CtorType) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.CtorType"))
}
function $isArrayOf_Ljapgolly_scalajs_react_CtorType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_CtorType)))
}
function $asArrayOf_Ljapgolly_scalajs_react_CtorType(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_CtorType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.CtorType;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_CtorType$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_CtorType$.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$.prototype = $c_Ljapgolly_scalajs_react_CtorType$.prototype;
$c_Ljapgolly_scalajs_react_CtorType$.prototype.japgolly$scalajs$react$CtorType$$modAppend__sjs_js_$bar__F1__sjs_js_$bar = (function(mods, f) {
  if ((mods === (void 0))) {
    var a = new $c_Ljapgolly_scalajs_react_CtorType$Mod(f)
  } else {
    var x$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Mod(mods)).Ljapgolly_scalajs_react_CtorType$Mod__f_mod;
    var a = new $c_Ljapgolly_scalajs_react_CtorType$Mod($m_Ljapgolly_scalajs_react_CtorType$Mod$().$greater$greater$extension__F1__F1__F1(x$2, f))
  };
  return a
});
var $d_Ljapgolly_scalajs_react_CtorType$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$: 0
}, false, "japgolly.scalajs.react.CtorType$", {
  Ljapgolly_scalajs_react_CtorType$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_CtorType$.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$;
var $n_Ljapgolly_scalajs_react_CtorType$;
function $m_Ljapgolly_scalajs_react_CtorType$() {
  if ((!$n_Ljapgolly_scalajs_react_CtorType$)) {
    $n_Ljapgolly_scalajs_react_CtorType$ = new $c_Ljapgolly_scalajs_react_CtorType$()
  };
  return $n_Ljapgolly_scalajs_react_CtorType$
}
function $p_Ljapgolly_scalajs_react_CtorType$Summoner$__prepareForMutation__sjs_js_Object__sjs_js_Object($thiz, o) {
  return ($uZ((o instanceof Object)) ? o : {})
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$Summoner$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$Summoner$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$Summoner$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype = $c_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype;
$c_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype.summonN__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner = (function(s) {
  var f = new $c_sjsr_AnonFunction1(((rc$2) => new $c_Ljapgolly_scalajs_react_CtorType$Nullary($i_react.createElement(rc$2, $n(s).Ljapgolly_scalajs_react_internal_Singleton__f_value), new $c_sjsr_AnonFunction1(((m$2) => {
    var m = $n($as_Ljapgolly_scalajs_react_CtorType$Mod(m$2)).Ljapgolly_scalajs_react_CtorType$Mod__f_mod;
    return $i_react.createElement(rc$2, $m_Ljapgolly_scalajs_react_CtorType$Mod$().applyAndCast$extension__F1__sjs_js_Object__sjs_js_Object(m, $n($n(s).Ljapgolly_scalajs_react_internal_Singleton__f_mutableObj).apply__O()))
  })), (void 0))));
  var p = $m_Ljapgolly_scalajs_react_CtorType$ProfunctorN$();
  return new $c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1(f, p)
});
$c_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype.summonC__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner = (function(s) {
  var f = new $c_sjsr_AnonFunction1(((rc$2) => new $c_Ljapgolly_scalajs_react_CtorType$Children(new $c_sjsr_AnonFunction2(((mm$2, c$2) => {
    var c = $as_sci_Seq(c$2);
    if ((mm$2 === (void 0))) {
      var p = $n(s).Ljapgolly_scalajs_react_internal_Singleton__f_value
    } else {
      var x$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Mod(mm$2)).Ljapgolly_scalajs_react_CtorType$Mod__f_mod;
      var p = $m_Ljapgolly_scalajs_react_CtorType$Mod$().applyAndCast$extension__F1__sjs_js_Object__sjs_js_Object(x$3, $n($n(s).Ljapgolly_scalajs_react_internal_Singleton__f_mutableObj).apply__O())
    };
    var $$x1 = $i_react;
    var seq = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().formatChildren__sci_Seq__sci_Seq(c);
    return $$x1.createElement(rc$2, p, ...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(seq))
  })), (void 0))));
  var p$1 = $m_Ljapgolly_scalajs_react_CtorType$ProfunctorC$();
  return new $c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1(f, p$1)
});
$c_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype.summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner = (function(w) {
  var f = new $c_sjsr_AnonFunction1(((rc$2) => new $c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(new $c_sjsr_AnonFunction3(((p$2, mm$2, c$2) => {
    var c = $as_sci_Seq(c$2);
    if ((mm$2 === (void 0))) {
      var p2 = p$2
    } else {
      var x$4 = $n($as_Ljapgolly_scalajs_react_CtorType$Mod(mm$2)).Ljapgolly_scalajs_react_CtorType$Mod__f_mod;
      var p2 = $m_Ljapgolly_scalajs_react_CtorType$Mod$().applyAndCast$extension__F1__sjs_js_Object__sjs_js_Object(x$4, $p_Ljapgolly_scalajs_react_CtorType$Summoner$__prepareForMutation__sjs_js_Object__sjs_js_Object($m_Ljapgolly_scalajs_react_CtorType$Summoner$(), p$2))
    };
    var $$x1 = $i_react;
    var seq = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().formatChildren__sci_Seq__sci_Seq(c);
    return $$x1.createElement(rc$2, p2, ...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(seq))
  })), (void 0))));
  var p = $m_Ljapgolly_scalajs_react_CtorType$ProfunctorF$();
  return new $c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1(f, p)
});
$c_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype.summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner = (function(w) {
  var f = new $c_sjsr_AnonFunction1(((rc$2) => new $c_Ljapgolly_scalajs_react_CtorType$Props(new $c_sjsr_AnonFunction2(((p$2, mm$2) => {
    if ((mm$2 === (void 0))) {
      var p2 = p$2
    } else {
      var x$5 = $n($as_Ljapgolly_scalajs_react_CtorType$Mod(mm$2)).Ljapgolly_scalajs_react_CtorType$Mod__f_mod;
      var p2 = $m_Ljapgolly_scalajs_react_CtorType$Mod$().applyAndCast$extension__F1__sjs_js_Object__sjs_js_Object(x$5, $p_Ljapgolly_scalajs_react_CtorType$Summoner$__prepareForMutation__sjs_js_Object__sjs_js_Object($m_Ljapgolly_scalajs_react_CtorType$Summoner$(), p$2))
    };
    return $i_react.createElement(rc$2, p2)
  })), (void 0))));
  var p = $m_Ljapgolly_scalajs_react_CtorType$ProfunctorP$();
  return new $c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1(f, p)
});
$c_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype.formatChildren__sci_Seq__sci_Seq = (function(c) {
  return ($n(c).isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : $as_sci_Seq($n(c).map__F1__O(new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(x$6$2);
    return $n(x$6).rawNode__sjs_js_$bar()
  })))))
});
var $d_Ljapgolly_scalajs_react_CtorType$Summoner$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$Summoner$: 0
}, false, "japgolly.scalajs.react.CtorType$Summoner$", {
  Ljapgolly_scalajs_react_CtorType$Summoner$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_CtorType$Summoner$.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$Summoner$;
var $n_Ljapgolly_scalajs_react_CtorType$Summoner$;
function $m_Ljapgolly_scalajs_react_CtorType$Summoner$() {
  if ((!$n_Ljapgolly_scalajs_react_CtorType$Summoner$)) {
    $n_Ljapgolly_scalajs_react_CtorType$Summoner$ = new $c_Ljapgolly_scalajs_react_CtorType$Summoner$()
  };
  return $n_Ljapgolly_scalajs_react_CtorType$Summoner$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_PropsChildren(self) {
  this.Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self = null;
  this.Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self = self
}
$c_Ljapgolly_scalajs_react_PropsChildren.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_PropsChildren.prototype.constructor = $c_Ljapgolly_scalajs_react_PropsChildren;
/** @constructor */
function $h_Ljapgolly_scalajs_react_PropsChildren() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_PropsChildren.prototype = $c_Ljapgolly_scalajs_react_PropsChildren.prototype;
$c_Ljapgolly_scalajs_react_PropsChildren.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_PropsChildren$().toString$extension__sjs_js_Any__T(this.Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self)
});
$c_Ljapgolly_scalajs_react_PropsChildren.prototype.hashCode__I = (function() {
  var this$ = this.Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
  return $dp_hashCode__I($n(this$))
});
$c_Ljapgolly_scalajs_react_PropsChildren.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_PropsChildren$().equals$extension__sjs_js_Any__O__Z(this.Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self, x$1)
});
function $as_Ljapgolly_scalajs_react_PropsChildren(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_PropsChildren) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.PropsChildren"))
}
function $isArrayOf_Ljapgolly_scalajs_react_PropsChildren(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_PropsChildren)))
}
function $asArrayOf_Ljapgolly_scalajs_react_PropsChildren(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_PropsChildren(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.PropsChildren;", depth))
}
var $d_Ljapgolly_scalajs_react_PropsChildren = new $TypeData().initClass({
  Ljapgolly_scalajs_react_PropsChildren: 0
}, false, "japgolly.scalajs.react.PropsChildren", {
  Ljapgolly_scalajs_react_PropsChildren: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_PropsChildren.prototype.$classData = $d_Ljapgolly_scalajs_react_PropsChildren;
/** @constructor */
function $c_Ljapgolly_scalajs_react_PropsChildren$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_PropsChildren$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_PropsChildren$.prototype.constructor = $c_Ljapgolly_scalajs_react_PropsChildren$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_PropsChildren$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_PropsChildren$.prototype = $c_Ljapgolly_scalajs_react_PropsChildren$.prototype;
$c_Ljapgolly_scalajs_react_PropsChildren$.prototype.fromRawProps__sjs_js_Object__sjs_js_Any = (function(p) {
  if ((p === (void 0))) {
    var c = (void 0)
  } else {
    var a = p.children;
    var c = a
  };
  return c
});
$c_Ljapgolly_scalajs_react_PropsChildren$.prototype.toString$extension__sjs_js_Any__T = (function(this$) {
  var this$1 = $n($m_Ljapgolly_scalajs_react_PropsChildren$().iterator$extension__sjs_js_Any__sc_Iterator(this$));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "PropsChildren(", ", ", ")")
});
$c_Ljapgolly_scalajs_react_PropsChildren$.prototype.iterator$extension__sjs_js_Any__sc_Iterator = (function(this$) {
  var array = $m_Ljapgolly_scalajs_react_PropsChildren$().toJsArray$extension__sjs_js_Any__sjs_js_Array(this$);
  return new $c_sjs_js_ArrayOps$ArrayIterator(array)
});
$c_Ljapgolly_scalajs_react_PropsChildren$.prototype.toJsArray$extension__sjs_js_Any__sjs_js_Array = (function(this$) {
  return $i_react.Children.toArray(this$)
});
$c_Ljapgolly_scalajs_react_PropsChildren$.prototype.toList$extension__sjs_js_Any__sci_List = (function(this$) {
  var this$1 = $n($m_Ljapgolly_scalajs_react_PropsChildren$().iterator$extension__sjs_js_Any__sc_Iterator(this$));
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1)
});
$c_Ljapgolly_scalajs_react_PropsChildren$.prototype.equals$extension__sjs_js_Any__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_PropsChildren)) {
    var PropsChildren$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_PropsChildren(x$1)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this$, PropsChildren$1)
  } else {
    return false
  }
});
var $d_Ljapgolly_scalajs_react_PropsChildren$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_PropsChildren$: 0
}, false, "japgolly.scalajs.react.PropsChildren$", {
  Ljapgolly_scalajs_react_PropsChildren$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_PropsChildren$.prototype.$classData = $d_Ljapgolly_scalajs_react_PropsChildren$;
var $n_Ljapgolly_scalajs_react_PropsChildren$;
function $m_Ljapgolly_scalajs_react_PropsChildren$() {
  if ((!$n_Ljapgolly_scalajs_react_PropsChildren$)) {
    $n_Ljapgolly_scalajs_react_PropsChildren$ = new $c_Ljapgolly_scalajs_react_PropsChildren$()
  };
  return $n_Ljapgolly_scalajs_react_PropsChildren$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_React$() {
  this.Ljapgolly_scalajs_react_React$__f_Context = null;
  this.Ljapgolly_scalajs_react_React$__f_Fragment = null;
  $n_Ljapgolly_scalajs_react_React$ = this;
  this.Ljapgolly_scalajs_react_React$__f_Context = $m_Ljapgolly_scalajs_react_feature_Context$();
  this.Ljapgolly_scalajs_react_React$__f_Fragment = $m_Ljapgolly_scalajs_react_feature_ReactFragment$()
}
$c_Ljapgolly_scalajs_react_React$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_React$.prototype.constructor = $c_Ljapgolly_scalajs_react_React$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_React$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_React$.prototype = $c_Ljapgolly_scalajs_react_React$.prototype;
$c_Ljapgolly_scalajs_react_React$.prototype.memo__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot__F2__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_Generic$ComponentSimple = (function(c, r, s) {
  var ev$1 = new $c_Ljapgolly_scalajs_react_Reusability(r);
  var r$1 = ev$1.Ljapgolly_scalajs_react_Reusability__f_test;
  var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().box__F2__F2(r$1));
  var r2 = e.Ljapgolly_scalajs_react_Reusability__f_test;
  var c2 = $i_react.memo($n(c).raw__sjs_js_Any(), $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(r2));
  return $n($n($m_Ljapgolly_scalajs_react_internal_CoreGeneral$().Ljapgolly_scalajs_react_internal_CoreGeneral$__f_JsComponent).force__O__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(c2, s)).cmapCtorProps__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$1$2) => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var array = [$ct_T2__O__O__(new $c_T2(), "a", x$1$2)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  })))
});
$c_Ljapgolly_scalajs_react_React$.prototype.StrictMode__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement = (function(ns) {
  var $$x2 = $i_react;
  var $$x1 = $i_react.StrictMode;
  var seq = $as_sci_Seq($n(ns).map__F1__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(x$2$2);
    return $n(x$2).rawNode__sjs_js_$bar()
  }))));
  var n = $$x2.createElement($$x1, null, ...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(seq));
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Ljapgolly_scalajs_react_React$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_React$: 0
}, false, "japgolly.scalajs.react.React$", {
  Ljapgolly_scalajs_react_React$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_React$.prototype.$classData = $d_Ljapgolly_scalajs_react_React$;
var $n_Ljapgolly_scalajs_react_React$;
function $m_Ljapgolly_scalajs_react_React$() {
  if ((!$n_Ljapgolly_scalajs_react_React$)) {
    $n_Ljapgolly_scalajs_react_React$ = new $c_Ljapgolly_scalajs_react_React$()
  };
  return $n_Ljapgolly_scalajs_react_React$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent(e, F) {
  this.Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent__f_e = null;
  this.Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent__f_F = null;
  this.Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent__f_e = e;
  this.Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent__f_F = F
}
$c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent.prototype.constructor = $c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent.prototype = $c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent.prototype;
$c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent.prototype.preventDefaultCB__O = (function() {
  $n(this.Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent__f_F);
  var a = new $c_sjsr_AnonFunction0((() => {
    this.Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent__f_e.preventDefault()
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
});
var $d_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent: 0
}, false, "japgolly.scalajs.react.ReactExt_DomEvent", {
  Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent.prototype.$classData = $d_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent;
/** @constructor */
function $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e, F) {
  this.Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent__f_japgolly$scalajs$react$ReactExt_ReactEvent$$e = null;
  this.Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent__f_F = null;
  this.Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent__f_japgolly$scalajs$react$ReactExt_ReactEvent$$e = e;
  this.Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent__f_F = F
}
$c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent.prototype.constructor = $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent.prototype = $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent.prototype;
$c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent.prototype.preventDefaultCB__O = (function() {
  $n(this.Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent__f_F);
  var a = new $c_sjsr_AnonFunction0((() => {
    this.Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent__f_japgolly$scalajs$react$ReactExt_ReactEvent$$e.preventDefault()
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
});
$c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent.prototype.stopPropagationCB__O = (function() {
  $n(this.Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent__f_F);
  var a = new $c_sjsr_AnonFunction0((() => {
    this.Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent__f_japgolly$scalajs$react$ReactExt_ReactEvent$$e.stopPropagation()
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
});
var $d_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent: 0
}, false, "japgolly.scalajs.react.ReactExt_ReactEvent", {
  Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent.prototype.$classData = $d_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent;
/** @constructor */
function $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$.prototype.constructor = $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$.prototype = $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$.prototype;
$c_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$.prototype.pressedModifierKeys$extension__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Z__Z__Z__Z__Z = (function(this$, altKey, ctrlKey, metaKey, shiftKey) {
  return (((($uZ(this$.altKey) === altKey) && ($uZ(this$.ctrlKey) === ctrlKey)) && ($uZ(this$.metaKey) === metaKey)) && ($uZ(this$.shiftKey) === shiftKey))
});
var $d_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$: 0
}, false, "japgolly.scalajs.react.ReactExt_ReactKeyboardEvent$", {
  Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$.prototype.$classData = $d_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$;
var $n_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$;
function $m_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$() {
  if ((!$n_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$)) {
    $n_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$ = new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$()
  };
  return $n_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_ReactMouseEvent$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_ReactMouseEvent$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ReactMouseEvent$.prototype.constructor = $c_Ljapgolly_scalajs_react_ReactMouseEvent$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ReactMouseEvent$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ReactMouseEvent$.prototype = $c_Ljapgolly_scalajs_react_ReactMouseEvent$.prototype;
$c_Ljapgolly_scalajs_react_ReactMouseEvent$.prototype.targetsNewTab_$qmark__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Z = (function(e) {
  return (($uZ(e.metaKey) || $uZ(e.ctrlKey)) || ($uI(e.button) === 1))
});
var $d_Ljapgolly_scalajs_react_ReactMouseEvent$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ReactMouseEvent$: 0
}, false, "japgolly.scalajs.react.ReactMouseEvent$", {
  Ljapgolly_scalajs_react_ReactMouseEvent$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_ReactMouseEvent$.prototype.$classData = $d_Ljapgolly_scalajs_react_ReactMouseEvent$;
var $n_Ljapgolly_scalajs_react_ReactMouseEvent$;
function $m_Ljapgolly_scalajs_react_ReactMouseEvent$() {
  if ((!$n_Ljapgolly_scalajs_react_ReactMouseEvent$)) {
    $n_Ljapgolly_scalajs_react_ReactMouseEvent$ = new $c_Ljapgolly_scalajs_react_ReactMouseEvent$()
  };
  return $n_Ljapgolly_scalajs_react_ReactMouseEvent$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Ref$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_Ref$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_Ref$.prototype.constructor = $c_Ljapgolly_scalajs_react_Ref$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Ref$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Ref$.prototype = $c_Ljapgolly_scalajs_react_Ref$.prototype;
$c_Ljapgolly_scalajs_react_Ref$.prototype.apply__Ljapgolly_scalajs_react_Ref$FullF = (function() {
  return this.fromJs__Ljapgolly_scalajs_react_facade_React$RefHandle__Ljapgolly_scalajs_react_Ref$FullF($i_react.createRef())
});
$c_Ljapgolly_scalajs_react_Ref$.prototype.fromJs__Ljapgolly_scalajs_react_facade_React$RefHandle__Ljapgolly_scalajs_react_Ref$FullF = (function(raw) {
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var l = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  var r = new $c_sjsr_AnonFunction1(((x$1$2) => new $c_s_Some(x$1$2)));
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var FF = this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  return new $c_Ljapgolly_scalajs_react_Ref$$anon$1(FF, l, r, raw)
});
var $d_Ljapgolly_scalajs_react_Ref$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Ref$: 0
}, false, "japgolly.scalajs.react.Ref$", {
  Ljapgolly_scalajs_react_Ref$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_Ref$.prototype.$classData = $d_Ljapgolly_scalajs_react_Ref$;
var $n_Ljapgolly_scalajs_react_Ref$;
function $m_Ljapgolly_scalajs_react_Ref$() {
  if ((!$n_Ljapgolly_scalajs_react_Ref$)) {
    $n_Ljapgolly_scalajs_react_Ref$ = new $c_Ljapgolly_scalajs_react_Ref$()
  };
  return $n_Ljapgolly_scalajs_react_Ref$
}
function $f_Ljapgolly_scalajs_react_Ref$GetF__foreach__F1__O($thiz, f) {
  var f$1 = new $c_sjsr_AnonFunction1(((a$2) => {
    $n($thiz.Ljapgolly_scalajs_react_Ref$$anon$1__f_FF$1);
    var a = new $c_sjsr_AnonFunction0((() => {
      $n(f).apply__O__O(a$2)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
  }));
  return $f_Ljapgolly_scalajs_react_Ref$GetF__foreachCB__F1__O($thiz, f$1)
}
function $f_Ljapgolly_scalajs_react_Ref$GetF__foreachCB__F1__O($thiz, f) {
  $n($thiz.Ljapgolly_scalajs_react_Ref$$anon$1__f_FF$1);
  var fa = $thiz.Ljapgolly_scalajs_react_Ref$$anon$1__f_get;
  var f$1 = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    if ((x0$1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x0$1);
      var a = $n(x2).s_Some__f_value;
      return $n(f).apply__O__O(a)
    } else {
      var x = $m_s_None$();
      if ((x === x0$1)) {
        var this$2 = $n($thiz.Ljapgolly_scalajs_react_Ref$$anon$1__f_FF$1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    }
  }));
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, f$1))
}
function $is_Ljapgolly_scalajs_react_Ref$GetF(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_Ref$GetF)))
}
function $as_Ljapgolly_scalajs_react_Ref$GetF(obj) {
  return (($is_Ljapgolly_scalajs_react_Ref$GetF(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.Ref$GetF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_Ref$GetF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_Ref$GetF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_Ref$GetF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_Ref$GetF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.Ref$GetF;", depth))
}
function $f_Ljapgolly_scalajs_react_Ref$SetF__rawSetFn__sjs_js_Function1($thiz) {
  return ((arg1$2) => {
    $f_Ljapgolly_scalajs_react_Ref$SetF__japgolly$scalajs$react$Ref$SetF$$$anonfun$rawSetFn$1__sjs_js_$bar__V($thiz, arg1$2)
  })
}
function $f_Ljapgolly_scalajs_react_Ref$SetF__japgolly$scalajs$react$Ref$SetF$$$anonfun$rawSetFn$1__sjs_js_$bar__V($thiz, n) {
  $n($thiz.Ljapgolly_scalajs_react_Ref$$anon$1__f_FF$1);
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.set__s_Option__O($m_s_Option$().apply__O__s_Option(n)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$4 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4)
}
function $is_Ljapgolly_scalajs_react_Ref$SetF(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_Ref$SetF)))
}
function $as_Ljapgolly_scalajs_react_Ref$SetF(obj) {
  return (($is_Ljapgolly_scalajs_react_Ref$SetF(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.Ref$SetF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_Ref$SetF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_Ref$SetF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_Ref$SetF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_Ref$SetF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.Ref$SetF;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Reusability(test) {
  this.Ljapgolly_scalajs_react_Reusability__f_test = null;
  this.Ljapgolly_scalajs_react_Reusability__f_test = test
}
$c_Ljapgolly_scalajs_react_Reusability.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_Reusability.prototype.constructor = $c_Ljapgolly_scalajs_react_Reusability;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Reusability() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Reusability.prototype = $c_Ljapgolly_scalajs_react_Reusability.prototype;
$c_Ljapgolly_scalajs_react_Reusability.prototype.hashCode__I = (function() {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var this$ = this.Ljapgolly_scalajs_react_Reusability__f_test;
  var this$2 = $n(this$);
  return $systemIdentityHashCode(this$2)
});
$c_Ljapgolly_scalajs_react_Reusability.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_Reusability$().equals$extension__F2__O__Z(this.Ljapgolly_scalajs_react_Reusability__f_test, x$1)
});
function $as_Ljapgolly_scalajs_react_Reusability(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_Reusability) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.Reusability"))
}
function $isArrayOf_Ljapgolly_scalajs_react_Reusability(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_Reusability)))
}
function $asArrayOf_Ljapgolly_scalajs_react_Reusability(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_Reusability(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.Reusability;", depth))
}
var $d_Ljapgolly_scalajs_react_Reusability = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Reusability: 0
}, false, "japgolly.scalajs.react.Reusability", {
  Ljapgolly_scalajs_react_Reusability: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_Reusability.prototype.$classData = $d_Ljapgolly_scalajs_react_Reusability;
function $p_Ljapgolly_scalajs_react_Reusable__b$lzycompute$1__sr_LazyRef__F1__O($thiz, b$lzy$1, f$1) {
  if ((b$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return ($n(b$lzy$1).sr_LazyRef__f__initialized ? $n(b$lzy$1).sr_LazyRef__f__value : $n(b$lzy$1).initialize__O__O($n(f$1).apply__O__O($n($thiz.Ljapgolly_scalajs_react_Reusable__f_lazyValue).apply__O())))
}
function $p_Ljapgolly_scalajs_react_Reusable__b$1__sr_LazyRef__F1__O($thiz, b$lzy$1, f$1) {
  return ($n(b$lzy$1).sr_LazyRef__f__initialized ? $n(b$lzy$1).sr_LazyRef__f__value : $p_Ljapgolly_scalajs_react_Reusable__b$lzycompute$1__sr_LazyRef__F1__O($thiz, b$lzy$1, f$1))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Reusable(lazyValue, root, isReusable) {
  this.Ljapgolly_scalajs_react_Reusable__f_lazyValue = null;
  this.Ljapgolly_scalajs_react_Reusable__f_japgolly$scalajs$react$Reusable$$root = null;
  this.Ljapgolly_scalajs_react_Reusable__f_isReusable = null;
  this.Ljapgolly_scalajs_react_Reusable__f_lazyValue = lazyValue;
  this.Ljapgolly_scalajs_react_Reusable__f_japgolly$scalajs$react$Reusable$$root = root;
  this.Ljapgolly_scalajs_react_Reusable__f_isReusable = isReusable
}
$c_Ljapgolly_scalajs_react_Reusable.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_Reusable.prototype.constructor = $c_Ljapgolly_scalajs_react_Reusable;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Reusable() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Reusable.prototype = $c_Ljapgolly_scalajs_react_Reusable.prototype;
$c_Ljapgolly_scalajs_react_Reusable.prototype.toString__T = (function() {
  return (("Reusable(" + this.value__O()) + ")")
});
$c_Ljapgolly_scalajs_react_Reusable.prototype.hashCode__I = (function() {
  var x = this.value__O();
  return $m_sr_Statics$().anyHash__O__I(x)
});
$c_Ljapgolly_scalajs_react_Reusable.prototype.value__O = (function() {
  return $n(this.Ljapgolly_scalajs_react_Reusable__f_lazyValue).apply__O()
});
$c_Ljapgolly_scalajs_react_Reusable.prototype.map__F1__Ljapgolly_scalajs_react_Reusable = (function(f) {
  var b$lzy = new $c_sr_LazyRef();
  return new $c_Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction0((() => $p_Ljapgolly_scalajs_react_Reusable__b$1__sr_LazyRef__F1__O(this, b$lzy, f))), this.Ljapgolly_scalajs_react_Reusable__f_japgolly$scalajs$react$Reusable$$root, this.Ljapgolly_scalajs_react_Reusable__f_isReusable)
});
$c_Ljapgolly_scalajs_react_Reusable.prototype.withValue__O__Ljapgolly_scalajs_react_Reusable = (function(b) {
  return new $c_Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction0((() => b)), this.Ljapgolly_scalajs_react_Reusable__f_japgolly$scalajs$react$Reusable$$root, this.Ljapgolly_scalajs_react_Reusable__f_isReusable)
});
function $as_Ljapgolly_scalajs_react_Reusable(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_Reusable) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.Reusable"))
}
function $isArrayOf_Ljapgolly_scalajs_react_Reusable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_Reusable)))
}
function $asArrayOf_Ljapgolly_scalajs_react_Reusable(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_Reusable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.Reusable;", depth))
}
var $d_Ljapgolly_scalajs_react_Reusable = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Reusable: 0
}, false, "japgolly.scalajs.react.Reusable", {
  Ljapgolly_scalajs_react_Reusable: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_Reusable.prototype.$classData = $d_Ljapgolly_scalajs_react_Reusable;
function $p_Ljapgolly_scalajs_react_Reusable$__root__O__F1__Ljapgolly_scalajs_react_Reusable($thiz, a, isReusable) {
  return new $c_Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction0((() => a)), a, isReusable)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Reusable$() {
  this.Ljapgolly_scalajs_react_Reusable$__f_reusabilityInstance = null;
  $n_Ljapgolly_scalajs_react_Reusable$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $as_Ljapgolly_scalajs_react_Reusable(x$2);
    var y = $as_Ljapgolly_scalajs_react_Reusable(y$2);
    return ($uZ($n($n(x).Ljapgolly_scalajs_react_Reusable__f_isReusable).apply__O__O(y)) && $uZ($n($n(y).Ljapgolly_scalajs_react_Reusable__f_isReusable).apply__O__O(x)))
  }));
  this.Ljapgolly_scalajs_react_Reusable$__f_reusabilityInstance = f
}
$c_Ljapgolly_scalajs_react_Reusable$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_Reusable$.prototype.constructor = $c_Ljapgolly_scalajs_react_Reusable$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Reusable$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Reusable$.prototype = $c_Ljapgolly_scalajs_react_Reusable$.prototype;
$c_Ljapgolly_scalajs_react_Reusable$.prototype.apply__O__F2__s_reflect_ClassTag__Ljapgolly_scalajs_react_Reusable = (function(a, reuse, evidence$1) {
  return $p_Ljapgolly_scalajs_react_Reusable$__root__O__F1__Ljapgolly_scalajs_react_Reusable(this, a, new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Ljapgolly_scalajs_react_Reusable(x$6$2);
    var x1 = $n(x$6).Ljapgolly_scalajs_react_Reusable__f_japgolly$scalajs$react$Reusable$$root;
    if ((x1 !== null)) {
      var o9 = $n(evidence$1).unapply__O__s_Option(x1);
      if (((!$n(o9).isEmpty__Z()) && ($n(o9).get__O() !== null))) {
        return $uZ($n(reuse).apply__O__O__O(a, x1))
      }
    };
    return false
  })))
});
$c_Ljapgolly_scalajs_react_Reusable$.prototype.implicitly__O__s_reflect_ClassTag__F2__Ljapgolly_scalajs_react_Reusable = (function(a, evidence$2, evidence$3) {
  var e = new $c_Ljapgolly_scalajs_react_Reusability(evidence$3);
  var r = e.Ljapgolly_scalajs_react_Reusability__f_test;
  return this.apply__O__F2__s_reflect_ClassTag__Ljapgolly_scalajs_react_Reusable(a, r, evidence$2)
});
$c_Ljapgolly_scalajs_react_Reusable$.prototype.const__O__Z__Ljapgolly_scalajs_react_Reusable = (function(a, isReusable) {
  return $p_Ljapgolly_scalajs_react_Reusable$__root__O__F1__Ljapgolly_scalajs_react_Reusable(this, a, new $c_sjsr_AnonFunction1(((x$7$2) => {
    $as_Ljapgolly_scalajs_react_Reusable(x$7$2);
    return isReusable
  })))
});
$c_Ljapgolly_scalajs_react_Reusable$.prototype.byRef__O__Ljapgolly_scalajs_react_Reusable = (function(a) {
  return $p_Ljapgolly_scalajs_react_Reusable$__root__O__F1__Ljapgolly_scalajs_react_Reusable(this, a, new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Ljapgolly_scalajs_react_Reusable(x$9$2);
    var x1 = $n(x$9).Ljapgolly_scalajs_react_Reusable__f_japgolly$scalajs$react$Reusable$$root;
    return ((x1 !== null) && Object.is(a, x1))
  })))
});
$c_Ljapgolly_scalajs_react_Reusable$.prototype.reusableReusability__F2 = (function() {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var this$ = this.Ljapgolly_scalajs_react_Reusable$__f_reusabilityInstance;
  return this$
});
var $d_Ljapgolly_scalajs_react_Reusable$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Reusable$: 0
}, false, "japgolly.scalajs.react.Reusable$", {
  Ljapgolly_scalajs_react_Reusable$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_Reusable$.prototype.$classData = $d_Ljapgolly_scalajs_react_Reusable$;
var $n_Ljapgolly_scalajs_react_Reusable$;
function $m_Ljapgolly_scalajs_react_Reusable$() {
  if ((!$n_Ljapgolly_scalajs_react_Reusable$)) {
    $n_Ljapgolly_scalajs_react_Reusable$ = new $c_Ljapgolly_scalajs_react_Reusable$()
  };
  return $n_Ljapgolly_scalajs_react_Reusable$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Reusable$FnInternals$() {
  this.Ljapgolly_scalajs_react_Reusable$FnInternals$__f__reusabilityFn1 = null;
  $n_Ljapgolly_scalajs_react_Reusable$FnInternals$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $as_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1(x$2);
    var y = $as_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1(y$2);
    return ((x === y) || ($n(x).Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1__f_f === $n(y).Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1__f_f))
  }));
  this.Ljapgolly_scalajs_react_Reusable$FnInternals$__f__reusabilityFn1 = f;
  $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$()
}
$c_Ljapgolly_scalajs_react_Reusable$FnInternals$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_Reusable$FnInternals$.prototype.constructor = $c_Ljapgolly_scalajs_react_Reusable$FnInternals$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Reusable$FnInternals$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Reusable$FnInternals$.prototype = $c_Ljapgolly_scalajs_react_Reusable$FnInternals$.prototype;
var $d_Ljapgolly_scalajs_react_Reusable$FnInternals$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Reusable$FnInternals$: 0
}, false, "japgolly.scalajs.react.Reusable$FnInternals$", {
  Ljapgolly_scalajs_react_Reusable$FnInternals$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_Reusable$FnInternals$.prototype.$classData = $d_Ljapgolly_scalajs_react_Reusable$FnInternals$;
var $n_Ljapgolly_scalajs_react_Reusable$FnInternals$;
function $m_Ljapgolly_scalajs_react_Reusable$FnInternals$() {
  if ((!$n_Ljapgolly_scalajs_react_Reusable$FnInternals$)) {
    $n_Ljapgolly_scalajs_react_Reusable$FnInternals$ = new $c_Ljapgolly_scalajs_react_Reusable$FnInternals$()
  };
  return $n_Ljapgolly_scalajs_react_Reusable$FnInternals$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Reusable$fn$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_Reusable$fn$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_Reusable$fn$.prototype.constructor = $c_Ljapgolly_scalajs_react_Reusable$fn$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Reusable$fn$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Reusable$fn$.prototype = $c_Ljapgolly_scalajs_react_Reusable$fn$.prototype;
$c_Ljapgolly_scalajs_react_Reusable$fn$.prototype.apply__F1__Ljapgolly_scalajs_react_Reusable = (function(f) {
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusable$();
  var $$x2 = new $c_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1(f);
  var $$x1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1.getClassOf());
  var this$2 = $m_Ljapgolly_scalajs_react_Reusable$FnInternals$();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var this$ = this$2.Ljapgolly_scalajs_react_Reusable$FnInternals$__f__reusabilityFn1;
  return $n($$x3).implicitly__O__s_reflect_ClassTag__F2__Ljapgolly_scalajs_react_Reusable($$x2, $$x1, this$)
});
var $d_Ljapgolly_scalajs_react_Reusable$fn$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Reusable$fn$: 0
}, false, "japgolly.scalajs.react.Reusable$fn$", {
  Ljapgolly_scalajs_react_Reusable$fn$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_Reusable$fn$.prototype.$classData = $d_Ljapgolly_scalajs_react_Reusable$fn$;
var $n_Ljapgolly_scalajs_react_Reusable$fn$;
function $m_Ljapgolly_scalajs_react_Reusable$fn$() {
  if ((!$n_Ljapgolly_scalajs_react_Reusable$fn$)) {
    $n_Ljapgolly_scalajs_react_Reusable$fn$ = new $c_Ljapgolly_scalajs_react_Reusable$fn$()
  };
  return $n_Ljapgolly_scalajs_react_Reusable$fn$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$() {
  this.Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$__f_reusabilityOverrideInDev = null;
  $n_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$ = this;
  this.Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$__f_reusabilityOverrideInDev = $m_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$().Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$__f_default
}
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$.prototype.constructor = $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$.prototype = $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$.prototype;
var $d_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$: 0
}, false, "japgolly.scalajs.react.ScalaJsReactConfig$Defaults$", {
  Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$.prototype.$classData = $d_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$;
var $n_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$;
function $m_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$() {
  if ((!$n_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$)) {
    $n_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$ = new $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$()
  };
  return $n_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$() {
  this.Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$__f_default = null;
  $n_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$ = this;
  this.Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$__f_default = new $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1()
}
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$.prototype.constructor = $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$.prototype = $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$.prototype;
var $d_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$: 0
}, false, "japgolly.scalajs.react.ScalaJsReactConfig$ReusabilityOverride$", {
  Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$.prototype.$classData = $d_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$;
var $n_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$;
function $m_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$() {
  if ((!$n_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$)) {
    $n_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$ = new $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$()
  };
  return $n_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$
}
function $f_Ljapgolly_scalajs_react_StateAccess$Base__async__F1__O($thiz, f) {
  return $n($thiz.A__Ljapgolly_scalajs_react_util_Effect$Async()).async___F1__O(new $c_sjsr_AnonFunction1(((r$2) => $n($thiz.F__Ljapgolly_scalajs_react_util_Effect$UnsafeSync()).toJsFn__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
    var $$x1 = $n(f);
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return $n($$x1).apply__O__O(new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().fromJsFn__sjs_js_Function0__Ljapgolly_scalajs_react_callback_Trampoline(r$2)))
  }))))))
}
function $f_Ljapgolly_scalajs_react_StateAccessorImplicits2__stateAccess__Ljapgolly_scalajs_react_StateAccessor$ReadWrite($thiz) {
  var r = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Ljapgolly_scalajs_react_StateAccess(x$5$2);
    return $n(x$5).state__O()
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_util_Util$();
  var w = this$2.Ljapgolly_scalajs_react_util_Util$__f_identity;
  return new $c_Ljapgolly_scalajs_react_StateAccessor$$anon$3(r, w)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_AsyncCallback(underlyingRepr) {
  this.Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr = null;
  this.Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr = underlyingRepr
}
$c_Ljapgolly_scalajs_react_callback_AsyncCallback.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_AsyncCallback.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_AsyncCallback;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_AsyncCallback() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_AsyncCallback.prototype = $c_Ljapgolly_scalajs_react_callback_AsyncCallback.prototype;
$c_Ljapgolly_scalajs_react_callback_AsyncCallback.prototype.hashCode__I = (function() {
  $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var this$ = this.Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr;
  return $n(this$).hashCode__I()
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().equals$extension__F1__O__Z(this.Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, x$1)
});
function $as_Ljapgolly_scalajs_react_callback_AsyncCallback(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_callback_AsyncCallback) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.AsyncCallback"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_AsyncCallback(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_AsyncCallback)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_AsyncCallback(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_AsyncCallback(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.AsyncCallback;", depth))
}
var $d_Ljapgolly_scalajs_react_callback_AsyncCallback = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_AsyncCallback: 0
}, false, "japgolly.scalajs.react.callback.AsyncCallback", {
  Ljapgolly_scalajs_react_callback_AsyncCallback: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_AsyncCallback;
function $p_Ljapgolly_scalajs_react_callback_AsyncCallback$__tryUnit$lzycompute__s_util_Try($thiz) {
  if (((((1 & $thiz.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_bitmap$0) << 24) >> 24) === 0)) {
    try {
      var $$x1 = new $c_s_util_Success((void 0))
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $$x1;
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!$n(o11).isEmpty__Z())) {
          var e$3 = $as_jl_Throwable($n(o11).get__O());
          var $$x1 = new $c_s_util_Failure(e$3);
          break matchEnd8
        };
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
      }
    };
    $thiz.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_tryUnit = $$x1;
    $thiz.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_bitmap$0 = (((1 | $thiz.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_tryUnit
}
function $p_Ljapgolly_scalajs_react_callback_AsyncCallback$__tryUnit__s_util_Try($thiz) {
  return (((((1 & $thiz.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljapgolly_scalajs_react_callback_AsyncCallback$__tryUnit$lzycompute__s_util_Try($thiz) : $thiz.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_tryUnit)
}
function $p_Ljapgolly_scalajs_react_callback_AsyncCallback$__liftedTree1$1__F0__s_util_Try($thiz, t$1) {
  try {
    return new $c_s_util_Failure($as_jl_Throwable($n(t$1).apply__O()))
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    return new $c_s_util_Failure(e$2)
  }
}
function $p_Ljapgolly_scalajs_react_callback_AsyncCallback$__log$1__T__O__sci_Seq__F1($thiz, prefix, message$1, optionalParams$1) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($m_Ljapgolly_scalajs_react_callback_Callback$().log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline((("" + prefix) + message$1), optionalParams$1))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_AsyncCallback$() {
  this.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_tryUnit = null;
  this.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_newState = null;
  this.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_defaultCompleteWith = null;
  this.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_bitmap$0 = 0;
  $n_Ljapgolly_scalajs_react_callback_AsyncCallback$ = this;
  var f = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback$State()));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  this.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_newState = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
  this.Ljapgolly_scalajs_react_callback_AsyncCallback$__f_defaultCompleteWith = new $c_sjsr_AnonFunction1(((x$4$2) => {
    $as_s_util_Try(x$4$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  }));
  this.pure__O__F1((void 0))
}
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_AsyncCallback$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_AsyncCallback$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype = $c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype;
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.apply__F1__F1 = (function(f) {
  return new $c_sjsr_AnonFunction1(((x$5$2) => {
    $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(x$5$2);
    return f
  }))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.delay__F0__F1 = (function(a) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().apply__F1__F1(new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var f$1 = new $c_sjsr_AnonFunction0((() => $m_Ljapgolly_scalajs_react_util_Util$().catchAll__F0__s_util_Try(a)));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1), f))
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.pure__O__F1 = (function(a) {
  return this.const__s_util_Try__F1(new $c_s_util_Success(a))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.throwException__F0__F1 = (function(t) {
  return this.const__s_util_Try__F1($p_Ljapgolly_scalajs_react_callback_AsyncCallback$__liftedTree1$1__F0__s_util_Try(this, t))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.const__s_util_Try__F1 = (function(t) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().apply__F1__F1(new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_F1(x$8$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(x$8).apply__O__O(t))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.suspend__F0__F1 = (function(f) {
  $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var this$ = this.delay__F0__F1(f);
  var this$2 = $m_s_$less$colon$less$();
  var ev = this$2.s_$less$colon$less$__f_singleton;
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1(this$, ev)
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.traverse__F0__F1__sc_BuildFrom__F1 = (function(ta, f, cbf) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().suspend__F0__F1(new $c_sjsr_AnonFunction0((() => {
    var _ta = $as_sc_Iterable($n(ta).apply__O());
    var this$3 = $n($n(_ta).iterator__sc_Iterator());
    var factory = $m_s_package$().s_package$__f_Vector;
    var factory$1 = new $c_sc_IterableFactory$ToFactory(factory);
    var as = $as_sci_Vector(factory$1.fromSpecific__sc_IterableOnce__O(this$3));
    var this$4 = $n(as);
    if ($f_sc_SeqOps__isEmpty__Z(this$4)) {
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().pure__O__F1($n($n(cbf).newBuilder__O__scm_Builder(_ta)).result__O())
    } else {
      var discard = new $c_sjsr_AnonFunction2(((x$9$2, x$10$2) => (void 0)));
      var bs = new Array($n(as).length__I());
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var this$5 = $n(as);
      var end = this$5.length__I();
      var this$7 = $n(new $c_sci_Range$Exclusive(0, end, 1).iterator__sc_Iterator());
      var f$1 = new $c_sjsr_AnonFunction1(((i$2) => {
        var i = $uI(i$2);
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(f).apply__O__O($n(as).apply__I__O(i)))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, new $c_sjsr_AnonFunction1(((b$2) => {
          bs[i] = b$2
        }))))
      }));
      var this$8 = new $c_sc_Iterator$$anon$9(this$7, f$1);
      var op = new $c_sjsr_AnonFunction2(((x$11$2, x$12$2) => {
        var x$11 = $n($as_Ljapgolly_scalajs_react_callback_AsyncCallback(x$11$2)).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr;
        var x$12 = $n($as_Ljapgolly_scalajs_react_callback_AsyncCallback(x$12$2)).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr;
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().zipWith$extension__F1__F1__F2__F1(x$11, x$12, discard))
      }));
      var $$x1 = $n($$x2).map$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($f_sc_IterableOnceOps__reduceLeft__F2__O(this$8, op))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, new $c_sjsr_AnonFunction1(((x$13$2) => {
        $as_jl_Void(x$13$2);
        return $as_sc_Iterable($n(cbf).fromSpecific__O__sc_IterableOnce__O(_ta, $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), bs)))
      })))
    };
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($$x1)
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.traverseOption__F0__F1__F1 = (function(oa, f) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().delay__F0__F1(oa), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    if ((x0$1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x0$1);
      var a = $n(x2).s_Some__f_value;
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(f).apply__O__O(a))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, new $c_sjsr_AnonFunction1(((x$14$2) => new $c_s_Some(x$14$2))))
    } else {
      var x = $m_s_None$();
      if ((x === x0$1)) {
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().pure__O__F1($m_s_None$())
      } else {
        var $$x1;
        throw new $c_s_MatchError(x0$1)
      }
    };
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($$x1)
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.fromFuture__F0__s_concurrent_ExecutionContext__F1 = (function(fa, ec) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().apply__F1__F1(new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    $m_Ljapgolly_scalajs_react_callback_Callback$();
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      var future = $as_s_concurrent_Future($n(fa).apply__O());
      var this$2 = $n(future);
      var x1 = $m_s_Option$().apply__O__s_Option($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(this$2));
      if ((x1 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x1);
        var value = $as_s_util_Try($n(x2).s_Some__f_value);
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(value))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$4 = $n(this$);
        $as_jl_Void($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4))
      } else {
        var x = $m_s_None$();
        if ((x === x1)) {
          $n(future).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1(((x$15$2) => {
            var x$15 = $as_s_util_Try(x$15$2);
            var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(x$15))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var this$6 = $n(this$$1);
            $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$6)
          })), ec)
        } else {
          throw new $c_s_MatchError(x1)
        }
      }
    }));
    var f$3 = new $c_sjsr_AnonFunction0((() => {
      f$1.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.fromJsPromise__F0__F1 = (function(pa) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().apply__F1__F1(new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    $m_Ljapgolly_scalajs_react_callback_Callback$();
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      $m_Ljapgolly_scalajs_react_util_JsUtil$().runPromiseAsync__F0__F1__V(pa, new $c_sjsr_AnonFunction1(((x$17$2) => {
        var x$17 = $as_s_util_Try(x$17$2);
        return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toJsFn$extension__Ljapgolly_scalajs_react_callback_Trampoline__sjs_js_Function0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(x$17))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      })))
    }));
    var f$3 = new $c_sjsr_AnonFunction0((() => {
      f$1.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.viaCallback__F1__F1 = (function(onCompletion) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($m_Ljapgolly_scalajs_react_callback_SyncPromise$().apply__Ljapgolly_scalajs_react_callback_Trampoline()), new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Ljapgolly_scalajs_react_callback_SyncPromise(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(onCompletion).apply__O__O($n($n(p).Ljapgolly_scalajs_react_callback_SyncPromise__f_complete).apply__O__O($p_Ljapgolly_scalajs_react_callback_AsyncCallback$__tryUnit__s_util_Try($m_Ljapgolly_scalajs_react_callback_AsyncCallback$()))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$20$2) => {
      $as_jl_Void(x$20$2);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().apply__F1__F1($n(p).onComplete__F1()))
    }))))
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.completeWith$extension__F1__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, f) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().Ljapgolly_scalajs_react_callback_AsyncCallback$__f_newState, new $c_sjsr_AnonFunction1(((x$31$2) => {
    var x$31 = $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(x$31$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(this$).apply__O__O(x$31))).apply__O__O(f))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.map$extension__F1__F1__F1 = (function(this$, f) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1(this$, new $c_sjsr_AnonFunction1(((a$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().pure__O__F1($n(f).apply__O__O(a$2))))))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.flatMap$extension__F1__F1__F1 = (function(this$, f) {
  return new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(s$2);
    return new $c_sjsr_AnonFunction1(((g$2) => {
      var g = $as_F1(g$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(s).cancelably__F0__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(this$).apply__O__O(s))).apply__O__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
        var x0$1 = $as_s_util_Try(x0$1$2);
        if ((x0$1 instanceof $c_s_util_Success)) {
          var x2 = $as_s_util_Success(x0$1);
          var a = $n(x2).s_util_Success__f_value;
          $m_Ljapgolly_scalajs_react_util_Util$();
          try {
            var x1$2 = new $c_s_util_Success(new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(f).apply__O__O(a))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr))
          } catch (e) {
            var e$1 = e;
            var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
            var x1$2 = new $c_s_util_Failure(e$2)
          };
          if ((x1$2 instanceof $c_s_util_Success)) {
            var x2$2 = $as_s_util_Success(x1$2);
            var next = $n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(x2$2).s_util_Success__f_value)).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr;
            var $$x1 = $n(s).cancelably__F0__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(next).apply__O__O(s))).apply__O__O(g))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))))
          } else if ((x1$2 instanceof $c_s_util_Failure)) {
            var x3 = $as_s_util_Failure(x1$2);
            var e$3 = $n(x3).s_util_Failure__f_exception;
            var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(g).apply__O__O(new $c_s_util_Failure(e$3)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
          } else {
            var $$x1;
            throw new $c_s_MatchError(x1$2)
          }
        } else if ((x0$1 instanceof $c_s_util_Failure)) {
          var x3$2 = $as_s_util_Failure(x0$1);
          var e$2$1 = $n(x3$2).s_util_Failure__f_exception;
          var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(g).apply__O__O(new $c_s_util_Failure(e$2$1)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
        } else {
          var $$x1;
          throw new $c_s_MatchError(x0$1)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)))))
    }))
  }))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.$greater$greater$extension__F1__F1__F1 = (function(this$, runNext) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1(this$, new $c_sjsr_AnonFunction1(((x$32$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback(runNext))))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.zipWith$extension__F1__F1__F2__F1 = (function(this$, that, f) {
  return new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(s$2);
    return new $c_sjsr_AnonFunction1(((cc$2) => {
      var cc = $as_F1(cc$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(s).cancelably__F0__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
        var f$7 = new $c_sjsr_AnonFunction0((() => {
          var elem = $m_s_None$();
          var ra = new $c_sr_ObjectRef(elem);
          var elem$1 = $m_s_None$();
          var rb = new $c_sr_ObjectRef(elem$1);
          var elem$2 = $m_s_None$();
          var r = new $c_sr_ObjectRef(elem$2);
          $m_Ljapgolly_scalajs_react_callback_Callback$();
          var f$1 = new $c_sjsr_AnonFunction0((() => {
            if ($n($as_s_Option(r.sr_ObjectRef__f_elem)).isEmpty__Z()) {
              var x1 = $ct_T2__O__O__(new $c_T2(), $as_s_Option(ra.sr_ObjectRef__f_elem), $as_s_Option(rb.sr_ObjectRef__f_elem));
              matchEnd39: {
                var p2 = $as_s_Option(x1.T2__f__1);
                var p3 = $as_s_Option(x1.T2__f__2);
                if ((p2 instanceof $c_s_Some)) {
                  var x4 = $as_s_Some(p2);
                  var p5 = $as_s_util_Try($n(x4).s_Some__f_value);
                  if ((p5 instanceof $c_s_util_Success)) {
                    var x6 = $as_s_util_Success(p5);
                    var a = $n(x6).s_util_Success__f_value;
                    if ((p3 instanceof $c_s_Some)) {
                      var x7 = $as_s_Some(p3);
                      var p8 = $as_s_util_Try($n(x7).s_Some__f_value);
                      if ((p8 instanceof $c_s_util_Success)) {
                        var x9 = $as_s_util_Success(p8);
                        var b = $n(x9).s_util_Success__f_value;
                        $m_Ljapgolly_scalajs_react_util_Util$();
                        try {
                          var $$x1 = new $c_s_util_Success($n(f).apply__O__O__O(a, b))
                        } catch (e) {
                          var e$1 = e;
                          var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
                          var $$x1 = new $c_s_util_Failure(e$2)
                        };
                        r.sr_ObjectRef__f_elem = new $c_s_Some($$x1);
                        break matchEnd39
                      }
                    }
                  }
                };
                var p10 = $as_s_Option(x1.T2__f__1);
                if ((p10 instanceof $c_s_Some)) {
                  var x12 = $as_s_Some(p10);
                  var p13 = $as_s_util_Try($n(x12).s_Some__f_value);
                  if ((p13 instanceof $c_s_util_Failure)) {
                    var x14 = $as_s_util_Failure(p13);
                    var e$3 = $n(x14).s_util_Failure__f_exception;
                    r.sr_ObjectRef__f_elem = new $c_s_Some(new $c_s_util_Failure(e$3));
                    break matchEnd39
                  }
                };
                var p16 = $as_s_Option(x1.T2__f__2);
                if ((p16 instanceof $c_s_Some)) {
                  var x17 = $as_s_Some(p16);
                  var p18 = $as_s_util_Try($n(x17).s_Some__f_value);
                  if ((p18 instanceof $c_s_util_Failure)) {
                    var x19 = $as_s_util_Failure(p18);
                    var e$2$1 = $n(x19).s_util_Failure__f_exception;
                    r.sr_ObjectRef__f_elem = new $c_s_Some(new $c_s_util_Failure(e$2$1));
                    break matchEnd39
                  }
                };
                matchEnd45: {
                  var $$x2;
                  var p20 = $as_s_Option(x1.T2__f__1);
                  var p21 = $as_s_Option(x1.T2__f__2);
                  if ((p20 instanceof $c_s_Some)) {
                    var x22 = $as_s_Some(p20);
                    var p23 = $as_s_util_Try($n(x22).s_Some__f_value);
                    if ((p23 instanceof $c_s_util_Success)) {
                      var x = $m_s_None$();
                      var $$x3 = (x === p21)
                    } else {
                      var $$x3 = false
                    };
                    if ($$x3) {
                      var $$x2 = true;
                      break matchEnd45
                    }
                  };
                  var p26 = $as_s_Option(x1.T2__f__1);
                  var p27 = $as_s_Option(x1.T2__f__2);
                  var x$3 = $m_s_None$();
                  if (((x$3 === p26) && (p27 instanceof $c_s_Some))) {
                    var x28 = $as_s_Some(p27);
                    var p29 = $as_s_util_Try($n(x28).s_Some__f_value);
                    if ((p29 instanceof $c_s_util_Success)) {
                      var $$x2 = true;
                      break matchEnd45
                    }
                  };
                  var p32 = $as_s_Option(x1.T2__f__1);
                  var p33 = $as_s_Option(x1.T2__f__2);
                  var x$5 = $m_s_None$();
                  if ((x$5 === p32)) {
                    var x$7 = $m_s_None$();
                    var $$x4 = (x$7 === p33)
                  } else {
                    var $$x4 = false
                  };
                  if ($$x4) {
                    var $$x2 = true;
                    break matchEnd45
                  };
                  var $$x2 = false
                };
                if ($$x2) {
                  break matchEnd39
                };
                throw new $c_s_MatchError(x1)
              };
              var this$7 = $n($as_s_Option(r.sr_ObjectRef__f_elem));
              if ((!this$7.isEmpty__Z())) {
                var arg1 = this$7.get__O();
                var x$37 = $as_s_util_Try(arg1);
                var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(cc).apply__O__O(x$37))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
                var this$9 = $n(this$$1);
                $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$9)
              }
            }
          }));
          var f$2 = new $c_sjsr_AnonFunction0((() => {
            f$1.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          var respond = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(this$).apply__O__O(s))).apply__O__O(new $c_sjsr_AnonFunction1(((e$2$2) => {
            var e$4 = $as_s_util_Try(e$2$2);
            var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            $m_Ljapgolly_scalajs_react_callback_Callback$();
            var f$3 = new $c_sjsr_AnonFunction0((() => {
              ra.sr_ObjectRef__f_elem = new $c_s_Some(e$4)
            }));
            var f$4 = new $c_sjsr_AnonFunction0((() => {
              f$3.apply__O()
            }));
            $m_Ljapgolly_scalajs_react_callback_Trampoline$();
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$4), respond))
          }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(that).apply__O__O(s))).apply__O__O(new $c_sjsr_AnonFunction1(((e$3$2) => {
            var e$3$1 = $as_s_util_Try(e$3$2);
            var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            $m_Ljapgolly_scalajs_react_callback_Callback$();
            var f$5 = new $c_sjsr_AnonFunction0((() => {
              rb.sr_ObjectRef__f_elem = new $c_s_Some(e$3$1)
            }));
            var f$6 = new $c_sjsr_AnonFunction0((() => {
              f$5.apply__O()
            }));
            $m_Ljapgolly_scalajs_react_callback_Trampoline$();
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x6).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$6), respond))
          }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        var this$$2 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$7);
        var this$22 = $m_s_$less$colon$less$();
        var ev = this$22.s_$less$colon$less$__f_singleton;
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$2, ev))
      }))))
    }))
  }))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.$times$greater$extension__F1__F1__F1 = (function(this$, next) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().zipWith$extension__F1__F1__F2__F1(this$, next, new $c_sjsr_AnonFunction2(((x$38$2, b$2) => b$2)))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.$less$times$extension__F1__F1__F1 = (function(this$, next) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().zipWith$extension__F1__F1__F2__F1(this$, next, new $c_sjsr_AnonFunction2(((a$2, x$39$2) => a$2)))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.ret$extension__F1__O__F1 = (function(this$, b) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1(this$, new $c_sjsr_AnonFunction1(((x$40$2) => b)))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.attempt$extension__F1__F1 = (function(this$) {
  return new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(s$2);
    return new $c_sjsr_AnonFunction1(((f$2) => {
      var f = $as_F1(f$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(this$).apply__O__O(s))).apply__O__O(new $c_sjsr_AnonFunction1(((e$2) => {
        var e = $as_s_util_Try(e$2);
        if ((e instanceof $c_s_util_Success)) {
          var x2 = $as_s_util_Success(e);
          var a = $n(x2).s_util_Success__f_value;
          $n($m_s_package$().s_package$__f_Right);
          var $$x1 = new $c_s_util_Right(a)
        } else {
          if ((!(e instanceof $c_s_util_Failure))) {
            throw new $c_s_MatchError(e)
          };
          var x3 = $as_s_util_Failure(e);
          var t = $n(x3).s_util_Failure__f_exception;
          $n($m_s_package$().s_package$__f_Left);
          var $$x1 = new $c_s_util_Left(t)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(new $c_s_util_Success($$x1)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))
  }))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.handleError$extension__F1__F1__F1 = (function(this$, f) {
  return new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(s$2);
    return new $c_sjsr_AnonFunction1(((g$2) => {
      var g = $as_F1(g$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(this$).apply__O__O(s))).apply__O__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
        var x0$1 = $as_s_util_Try(x0$1$2);
        if ((x0$1 instanceof $c_s_util_Success)) {
          var x2 = $as_s_util_Success(x0$1);
          var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(g).apply__O__O(x2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
        } else if ((x0$1 instanceof $c_s_util_Failure)) {
          var x4 = $as_s_util_Failure(x0$1);
          var t = $n(x4).s_util_Failure__f_exception;
          var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(f).apply__O__O(t))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr).apply__O__O(s))).apply__O__O(g))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
        } else {
          var $$x1;
          throw new $c_s_MatchError(x0$1)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))
  }))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.logAround$extension__F1__O__sci_Seq__F1 = (function(this$, message, optionalParams) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().$less$times$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().$times$greater$extension__F1__F1__F1($p_Ljapgolly_scalajs_react_callback_AsyncCallback$__log$1__T__O__sci_Seq__F1(this, "\u2192  Starting: ", message, optionalParams), this$), $p_Ljapgolly_scalajs_react_callback_AsyncCallback$__log$1__T__O__sci_Seq__F1(this, " \u2190 Finished: ", message, optionalParams))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.delayMs$extension__F1__D__F1 = (function(this$, milliseconds) {
  return ((milliseconds <= 0.0) ? this$ : new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(s$2);
    return new $c_sjsr_AnonFunction1(((f$2) => {
      var f = $as_F1(f$2);
      $m_Ljapgolly_scalajs_react_callback_Callback$();
      var f$1 = new $c_sjsr_AnonFunction0((() => $m_sjs_js_timers_package$().setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle(milliseconds, new $c_sjsr_AnonFunction0((() => {
        var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(this$).apply__O__O(s))).apply__O__O(f))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$3 = $n(this$$1);
        $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$3)
      })))));
      var f$3 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
    }))
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.finallyRun$extension__F1__F1__F1 = (function(this$, runFinally) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().attempt$extension__F1__F1(this$), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_util_Either(x0$1$2);
    if ((x0$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(x0$1);
      var a = $n(x2).s_util_Right__f_value;
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().ret$extension__F1__O__F1(runFinally, a)
    } else if ((x0$1 instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(x0$1);
      var e = $as_jl_Throwable($n(x3).s_util_Left__f_value);
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().attempt$extension__F1__F1(runFinally);
      var this$2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      try {
        var $$x2 = new $c_s_util_Failure(e)
      } catch (e$1) {
        var e$2 = e$1;
        var e$2$1 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
        var $$x2 = new $c_s_util_Failure(e$2$1)
      };
      var $$x1 = $n($$x4).$greater$greater$extension__F1__F1__F1($$x3, this$2.const__s_util_Try__F1($$x2))
    } else {
      var $$x1;
      throw new $c_s_MatchError(x0$1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($$x1)
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().Ljapgolly_scalajs_react_callback_AsyncCallback$__f_newState, new $c_sjsr_AnonFunction1(((x$50$2) => {
    var x$50 = $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(x$50$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(this$).apply__O__O(x$50))).apply__O__O($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().Ljapgolly_scalajs_react_callback_AsyncCallback$__f_defaultCompleteWith))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.asCallbackToFuture$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().Ljapgolly_scalajs_react_callback_AsyncCallback$__f_newState, new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(s$2);
    var f$2 = new $c_sjsr_AnonFunction0((() => {
      var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(this$).apply__O__O(s))).apply__O__O(new $c_sjsr_AnonFunction1(((t$2) => {
        var t = $as_s_util_Try(t$2);
        $m_Ljapgolly_scalajs_react_callback_Callback$();
        var f = new $c_sjsr_AnonFunction0((() => p.tryComplete__s_util_Try__Z(t)));
        var f$1 = new $c_sjsr_AnonFunction0((() => {
          f.apply__O()
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$7 = $n(this$$1);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$7);
      return p
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
  })))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.unsafeToFuture$extension__F1__s_concurrent_Future = (function(this$) {
  var this$$1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().asCallbackToFuture$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$);
  var this$2 = $n(this$$1);
  return $as_s_concurrent_Future($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.runNow$extension__F1__V = (function(this$) {
  var this$$1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$);
  var this$2 = $n(this$$1);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.flatMapSync$extension__F1__F1__F1 = (function(this$, f) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1(this$, new $c_sjsr_AnonFunction1(((x$52$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(x$52$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)))))
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.equals$extension__F1__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_callback_AsyncCallback)) {
    var AsyncCallback$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_callback_AsyncCallback(x$1)).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr);
    return ((this$ === null) ? (AsyncCallback$1 === null) : $n(this$).equals__O__Z(AsyncCallback$1))
  } else {
    return false
  }
});
var $d_Ljapgolly_scalajs_react_callback_AsyncCallback$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_AsyncCallback$: 0
}, false, "japgolly.scalajs.react.callback.AsyncCallback$", {
  Ljapgolly_scalajs_react_callback_AsyncCallback$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_AsyncCallback$;
var $n_Ljapgolly_scalajs_react_callback_AsyncCallback$;
function $m_Ljapgolly_scalajs_react_callback_AsyncCallback$() {
  if ((!$n_Ljapgolly_scalajs_react_callback_AsyncCallback$)) {
    $n_Ljapgolly_scalajs_react_callback_AsyncCallback$ = new $c_Ljapgolly_scalajs_react_callback_AsyncCallback$()
  };
  return $n_Ljapgolly_scalajs_react_callback_AsyncCallback$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_AsyncCallback$State() {
  this.Ljapgolly_scalajs_react_callback_AsyncCallback$State__f_cancelled = false;
  this.Ljapgolly_scalajs_react_callback_AsyncCallback$State__f_cancelled = false
}
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$State.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$State.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_AsyncCallback$State;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_AsyncCallback$State() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_AsyncCallback$State.prototype = $c_Ljapgolly_scalajs_react_callback_AsyncCallback$State.prototype;
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$State.prototype.cancelably__F0__Ljapgolly_scalajs_react_callback_Trampoline = (function(c) {
  $m_Ljapgolly_scalajs_react_callback_Callback$();
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljapgolly_scalajs_react_callback_Callback$();
    var cond = this.Ljapgolly_scalajs_react_callback_AsyncCallback$State__f_cancelled;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.when__Z__F0__Ljapgolly_scalajs_react_callback_Trampoline((!cond), c))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().suspend__F0__Ljapgolly_scalajs_react_callback_Trampoline(f)
});
function $as_Ljapgolly_scalajs_react_callback_AsyncCallback$State(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_callback_AsyncCallback$State) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.AsyncCallback$State"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_AsyncCallback$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_AsyncCallback$State)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_AsyncCallback$State(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_AsyncCallback$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.AsyncCallback$State;", depth))
}
var $d_Ljapgolly_scalajs_react_callback_AsyncCallback$State = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_AsyncCallback$State: 0
}, false, "japgolly.scalajs.react.callback.AsyncCallback$State", {
  Ljapgolly_scalajs_react_callback_AsyncCallback$State: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_AsyncCallback$State.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_AsyncCallback$State;
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_Callback$() {
  this.Ljapgolly_scalajs_react_callback_Callback$__f_empty = null;
  $n_Ljapgolly_scalajs_react_callback_Callback$ = this;
  this.Ljapgolly_scalajs_react_callback_Callback$__f_empty = $m_Ljapgolly_scalajs_react_callback_Trampoline$().Ljapgolly_scalajs_react_callback_Trampoline$__f_unit
}
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_Callback$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_Callback$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_Callback$.prototype = $c_Ljapgolly_scalajs_react_callback_Callback$.prototype;
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline = (function(f, ec) {
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    $n($as_s_concurrent_Future($n(f).apply__O())).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_s_util_Try(x0$1$2);
      if ((x0$1 instanceof $c_s_util_Success)) {
        var x2 = $as_s_util_Success(x0$1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(x2).s_util_Success__f_value)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$3 = $n(cb);
        return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$3)
      } else if ((x0$1 instanceof $c_s_util_Failure)) {
        var x3 = $as_s_util_Failure(x0$1);
        var t = $n(x3).s_util_Failure__f_exception;
        throw ((t instanceof $c_sjs_js_JavaScriptException) ? t.sjs_js_JavaScriptException__f_exception : $n(t))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })), ec)
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.when__Z__F0__Ljapgolly_scalajs_react_callback_Trampoline = (function(cond, c) {
  if (cond) {
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(c).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.traverse__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(ta, f) {
  $m_Ljapgolly_scalajs_react_callback_Callback$();
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($n($as_sc_IterableOnce($n(ta).apply__O())).iterator__sc_Iterator());
    while (this$2.hasNext__Z()) {
      var arg1 = this$2.next__O();
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(arg1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$4 = $n(this$);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4)
    }
  }));
  var f$2 = new $c_sjsr_AnonFunction0((() => {
    f$1.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2)
});
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(oa, f) {
  $m_Ljapgolly_scalajs_react_callback_Callback$();
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($as_s_Option($n(oa).apply__O()));
    if ((!this$2.isEmpty__Z())) {
      var arg1 = this$2.get__O();
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(arg1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$4 = $n(this$);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4)
    }
  }));
  var f$2 = new $c_sjsr_AnonFunction0((() => {
    f$1.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2)
});
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.runAll__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline = (function(callbacks) {
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(callbacks).foldLeft__O__F2__O(new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Ljapgolly_scalajs_react_callback_Callback$__f_empty), new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var y = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(y$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(x, $m_Ljapgolly_scalajs_react_callback_CallbackTo$().reset$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(y)))
  }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline = (function(message, optionalParams) {
  $m_Ljapgolly_scalajs_react_callback_Callback$();
  var f = new $c_sjsr_AnonFunction0((() => {
    console.log(message, ...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(optionalParams))
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.warn__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline = (function(message, optionalParams) {
  $m_Ljapgolly_scalajs_react_callback_Callback$();
  var f = new $c_sjsr_AnonFunction0((() => {
    console.warn(message, ...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(optionalParams))
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.alert__T__Ljapgolly_scalajs_react_callback_Trampoline = (function(message) {
  $m_Ljapgolly_scalajs_react_callback_Callback$();
  var f = new $c_sjsr_AnonFunction0((() => {
    window.alert(message)
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
var $d_Ljapgolly_scalajs_react_callback_Callback$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_Callback$: 0
}, false, "japgolly.scalajs.react.callback.Callback$", {
  Ljapgolly_scalajs_react_callback_Callback$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_Callback$.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_Callback$;
var $n_Ljapgolly_scalajs_react_callback_Callback$;
function $m_Ljapgolly_scalajs_react_callback_Callback$() {
  if ((!$n_Ljapgolly_scalajs_react_callback_Callback$)) {
    $n_Ljapgolly_scalajs_react_callback_Callback$ = new $c_Ljapgolly_scalajs_react_callback_Callback$()
  };
  return $n_Ljapgolly_scalajs_react_callback_Callback$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_CallbackOption(underlyingRepr) {
  this.Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr = null;
  this.Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr = underlyingRepr
}
$c_Ljapgolly_scalajs_react_callback_CallbackOption.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_CallbackOption.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_CallbackOption;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_CallbackOption() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_CallbackOption.prototype = $c_Ljapgolly_scalajs_react_callback_CallbackOption.prototype;
$c_Ljapgolly_scalajs_react_callback_CallbackOption.prototype.hashCode__I = (function() {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$ = this.Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr;
  var this$2 = $n(this$);
  return $systemIdentityHashCode(this$2)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().equals$extension__F0__O__Z(this.Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr, x$1)
});
function $as_Ljapgolly_scalajs_react_callback_CallbackOption(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_callback_CallbackOption) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.CallbackOption"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_CallbackOption(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_CallbackOption)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_CallbackOption(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_CallbackOption(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.CallbackOption;", depth))
}
var $d_Ljapgolly_scalajs_react_callback_CallbackOption = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_CallbackOption: 0
}, false, "japgolly.scalajs.react.callback.CallbackOption", {
  Ljapgolly_scalajs_react_callback_CallbackOption: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_CallbackOption;
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_CallbackOption$() {
  this.Ljapgolly_scalajs_react_callback_CallbackOption$__f_someUnit = null;
  $n_Ljapgolly_scalajs_react_callback_CallbackOption$ = this;
  this.Ljapgolly_scalajs_react_callback_CallbackOption$__f_someUnit = new $c_s_Some((void 0))
}
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_CallbackOption$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_CallbackOption$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype = $c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype;
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.pass__F0 = (function() {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var a = this.Ljapgolly_scalajs_react_callback_CallbackOption$__f_someUnit;
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a);
  var this$3 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$3.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.fail__F0 = (function() {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var a = $m_s_None$();
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a);
  var this$3 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$3.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.pure__O__F0 = (function(a) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var a$1 = new $c_s_Some(a);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a$1);
  var this$3 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$3.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.delay__F0__F0 = (function(a) {
  return this.option__F0__F0(new $c_sjsr_AnonFunction0((() => new $c_s_Some($n(a).apply__O()))))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.option__F0__F0 = (function(oa) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(oa);
  var this$3 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$3.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.maybe__F0__Ljapgolly_scalajs_react_util_OptionLike__F0 = (function(oa, O) {
  return this.option__F0__F0(new $c_sjsr_AnonFunction0((() => $n(O).toOption__O__s_Option($n(oa).apply__O()))))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.optionCallback__F0__F0 = (function(oc) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$2 = $m_Ljapgolly_scalajs_react_util_Util$();
  var $$x1 = this$1.traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(oc, this$2.Ljapgolly_scalajs_react_util_Util$__f_identity);
  var this$3 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$3.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.require__F0__F0 = (function(condition) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(condition);
    if ($uZ(this$2.apply__O())) {
      return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().Ljapgolly_scalajs_react_callback_CallbackOption$__f_someUnit
    } else {
      return $m_s_None$()
    }
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
  var this$5 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$5.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.unless__F0__F0 = (function(condition) {
  return this.require__F0__F0(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(condition);
    return (!$uZ(this$2.apply__O()))
  })))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.matchPF__F0__s_PartialFunction__F0 = (function(a, pf) {
  return this.option__F0__F0(new $c_sjsr_AnonFunction0((() => $as_s_Option($n($n(pf).lift__F1()).apply__O__O($n(a).apply__O())))))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, ev) {
  $m_Ljapgolly_scalajs_react_callback_Callback$();
  var f = new $c_sjsr_AnonFunction0((() => {
    $n(this$).apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0 = (function(this$, f, ev) {
  return new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($as_s_Option($n(this$).apply__O()));
    return (this$2.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$2.get__O())))
  }))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.flatMapOption$extension__F0__F1__F0 = (function(this$, f) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var this$$1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(this$);
  var f$1 = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_s_Option(x$6$2);
    var this$5 = $n(x$6);
    return (this$5.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(f).apply__O__O(this$5.get__O())))
  }));
  var $$x1 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$1);
  var this$7 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$7.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.flatMapCB$extension__F0__F1__F0 = (function(this$, f) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, new $c_sjsr_AnonFunction1(((x$7$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(x$7$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)))))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.flatMap$extension__F0__F1__F0 = (function(this$, f) {
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(($m_Ljapgolly_scalajs_react_callback_CallbackOption$(), $m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(this$)), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    if ((x0$1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x0$1);
      var a = $n(x2).s_Some__f_value;
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackOption($n(f).apply__O__O(a))).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr;
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      var $$x2 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(this$$1)
    } else {
      var x = $m_s_None$();
      if ((x === x0$1)) {
        var a$1 = $m_s_None$();
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        var $$x2 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a$1)
      } else {
        var $$x2;
        throw new $c_s_MatchError(x0$1)
      }
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  })));
  var this$10 = $m_s_$less$colon$less$();
  return $n($$x3).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$10.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.filter$extension__F0__F1__F0 = (function(this$, condition) {
  return new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($as_s_Option($n(this$).apply__O()));
    return ((this$2.isEmpty__Z() || $uZ($n(condition).apply__O__O(this$2.get__O()))) ? this$2 : $m_s_None$())
  }))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.filterNot$extension__F0__F1__F0 = (function(this$, condition) {
  return new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($as_s_Option($n(this$).apply__O()));
    return ((this$2.isEmpty__Z() || (!$uZ($n(condition).apply__O__O(this$2.get__O())))) ? this$2 : $m_s_None$())
  }))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.$greater$greater$extension__F0__F0__F0 = (function(this$, next) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, new $c_sjsr_AnonFunction1(((x$8$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption(next))))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.$less$times$extension__F0__F0__F0 = (function(this$, next) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, new $c_sjsr_AnonFunction1(((a$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0(next, new $c_sjsr_AnonFunction1(((x$10$2) => a$2)), null)))))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.void$extension__F0__F0 = (function(this$) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0(this$, new $c_sjsr_AnonFunction1(((x$11$2) => (void 0))), null)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.when$extension__F0__F0__F0 = (function(this$, cond) {
  return new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(cond);
    if ($uZ(this$2.apply__O())) {
      return $as_s_Option($n(this$).apply__O())
    } else {
      return $m_s_None$()
    }
  }))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.orElse$extension__F0__F0__F0 = (function(this$, tryNext) {
  return new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($as_s_Option($n(this$).apply__O()));
    return (this$2.isEmpty__Z() ? $as_s_Option($n(tryNext).apply__O()) : this$2)
  }))
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.handleError$extension__F0__F1__F0 = (function(this$, f) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().handleError$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(($m_Ljapgolly_scalajs_react_callback_CallbackOption$(), $m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(this$)), new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13 = $as_jl_Throwable(x$13$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackOption($n(f).apply__O__O(x$13))).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr;
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(this$$1))
  })));
  var this$8 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$8.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.finallyRun$extension__F0__F0__F0 = (function(this$, runFinally) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().finallyRun$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(($m_Ljapgolly_scalajs_react_callback_CallbackOption$(), $m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(this$)), ($m_Ljapgolly_scalajs_react_callback_CallbackOption$(), $m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(runFinally)));
  var this$7 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$7.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.equals$extension__F0__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_callback_CallbackOption)) {
    var CallbackOption$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_callback_CallbackOption(x$1)).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr);
    if ((this$ === null)) {
      return (CallbackOption$1 === null)
    } else {
      var this$1 = $n(this$);
      return (this$1 === CallbackOption$1)
    }
  } else {
    return false
  }
});
var $d_Ljapgolly_scalajs_react_callback_CallbackOption$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_CallbackOption$: 0
}, false, "japgolly.scalajs.react.callback.CallbackOption$", {
  Ljapgolly_scalajs_react_callback_CallbackOption$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_CallbackOption$.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_CallbackOption$;
var $n_Ljapgolly_scalajs_react_callback_CallbackOption$;
function $m_Ljapgolly_scalajs_react_callback_CallbackOption$() {
  if ((!$n_Ljapgolly_scalajs_react_callback_CallbackOption$)) {
    $n_Ljapgolly_scalajs_react_callback_CallbackOption$ = new $c_Ljapgolly_scalajs_react_callback_CallbackOption$()
  };
  return $n_Ljapgolly_scalajs_react_callback_CallbackOption$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_CallbackTo(trampoline) {
  this.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline = null;
  this.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline = trampoline
}
$c_Ljapgolly_scalajs_react_callback_CallbackTo.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_CallbackTo.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_CallbackTo;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_CallbackTo() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_CallbackTo.prototype = $c_Ljapgolly_scalajs_react_callback_CallbackTo.prototype;
$c_Ljapgolly_scalajs_react_callback_CallbackTo.prototype.hashCode__I = (function() {
  var this$ = this.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  return $systemIdentityHashCode(this$2)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().equals$extension__Ljapgolly_scalajs_react_callback_Trampoline__O__Z(this.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, x$1)
});
function $as_Ljapgolly_scalajs_react_callback_CallbackTo(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_callback_CallbackTo) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.CallbackTo"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_CallbackTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_CallbackTo)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_CallbackTo(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_CallbackTo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.CallbackTo;", depth))
}
var $d_Ljapgolly_scalajs_react_callback_CallbackTo = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_CallbackTo: 0
}, false, "japgolly.scalajs.react.callback.CallbackTo", {
  Ljapgolly_scalajs_react_callback_CallbackTo: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_CallbackTo;
function $p_Ljapgolly_scalajs_react_callback_CallbackTo$__log$1__T__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline($thiz, prefix, message$4, optionalParams$1) {
  return $m_Ljapgolly_scalajs_react_callback_Callback$().log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline((("" + prefix) + message$4), optionalParams$1)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_CallbackTo$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_CallbackTo$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_CallbackTo$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype = $c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype;
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.fromJsFn__sjs_js_Function0__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction0((() => f()));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.suspend__F0__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var s = new $c_sjsr_AnonFunction0((() => $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Suspend(s)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.traverse__F0__F1__sc_BuildFrom__Ljapgolly_scalajs_react_callback_Trampoline = (function(ta, f, cbf) {
  var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$().std$extension__F1__sc_BuildFrom__Ljapgolly_scalajs_react_callback_Trampoline(f, cbf);
  var f$1 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_F1(x$4$2);
    return $as_sc_Iterable($n(x$4).apply__O__O($n(ta).apply__O()))
  }));
  var this$3 = $n(this$);
  return $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$3, f$1)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(oa, f) {
  var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$().option$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(f);
  var f$1 = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_F1(x$5$2);
    return $as_s_Option($n(x$5).apply__O__O($n(oa).apply__O()))
  }));
  var this$3 = $n(this$);
  return $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$3, f$1)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.prompt__T__Ljapgolly_scalajs_react_callback_Trampoline = (function(message) {
  var f = new $c_sjsr_AnonFunction0((() => $m_s_Option$().apply__O__s_Option($as_T(window.prompt(message)))));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.prompt__T__T__Ljapgolly_scalajs_react_callback_Trampoline = (function(message, default$1) {
  var f = new $c_sjsr_AnonFunction0((() => $m_s_Option$().apply__O__s_Option($as_T(window.prompt(message, default$1)))));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.confirm__T__Ljapgolly_scalajs_react_callback_Trampoline = (function(message) {
  var f = new $c_sjsr_AnonFunction0((() => $uZ(window.confirm(message))));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, f) {
  var this$2 = $n(this$);
  var f$1 = new $c_sjsr_AnonFunction1(((x$10$2) => $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(x$10$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap(this$2, f$1)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, runNext) {
  return ($m_Ljapgolly_scalajs_react_callback_CallbackTo$().isEmpty_$qmark$extension__Ljapgolly_scalajs_react_callback_Trampoline__Z(this$) ? runNext : $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, new $c_sjsr_AnonFunction1(((x$12$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(runNext)))))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.flatTap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, t) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, new $c_sjsr_AnonFunction1(((a$2) => {
    var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(t).apply__O__O(a$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((x$14$2) => a$2));
    var this$3 = $n(this$$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$3, f))
  })))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.zip$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, cb) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().zipWith$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__F2__Ljapgolly_scalajs_react_callback_Trampoline(this$, cb, new $c_sjsr_AnonFunction2(((x$15$2, x$16$2) => $ct_T2__O__O__(new $c_T2(), x$15$2, x$16$2))))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.zipWith$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__F2__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, cb, f) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, new $c_sjsr_AnonFunction1(((a$2) => {
    var f$1 = new $c_sjsr_AnonFunction1(((b$2) => $n(f).apply__O__O__O(a$2, b$2)));
    var this$3 = $n(cb);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$3, f$1))
  })))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, next) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatTap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, new $c_sjsr_AnonFunction1(((x$17$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(next))))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.attemptTry$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$) {
  var f = new $c_sjsr_AnonFunction0((() => {
    $m_Ljapgolly_scalajs_react_util_Util$();
    try {
      var this$4 = $n(this$);
      return new $c_s_util_Success($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4))
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      return new $c_s_util_Failure(e$2)
    }
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.handleError$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, f) {
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    try {
      var this$3 = $n(this$);
      return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$3)
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(e$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$6 = $n(this$$1);
      return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$6)
    }
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.reset$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$) {
  $m_Ljapgolly_scalajs_react_callback_Callback$();
  var f = new $c_sjsr_AnonFunction0((() => {
    try {
      var this$3 = $n(this$);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$3)
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      e$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
    }
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.when$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, cond) {
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(cond);
    if ($uZ(this$2.apply__O())) {
      var this$4 = $n(this$);
      return new $c_s_Some($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4))
    } else {
      return $m_s_None$()
    }
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.unless$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, cond) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().when$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline(this$, new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(cond);
    return (!$uZ(this$2.apply__O()))
  })))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.logAround$extension__Ljapgolly_scalajs_react_callback_Trampoline__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, message, optionalParams) {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$$1 = $p_Ljapgolly_scalajs_react_callback_CallbackTo$__log$1__T__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline(this, "\u2192  Starting: ", message, optionalParams);
  return $n($$x1).$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, this$), $p_Ljapgolly_scalajs_react_callback_CallbackTo$__log$1__T__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline(this, " \u2190 Finished: ", message, optionalParams))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.finallyRun$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, runFinally) {
  var f = new $c_sjsr_AnonFunction0((() => {
    try {
      var this$3 = $n(this$);
      return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$3)
    } finally {
      var this$5 = $n(runFinally);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$5)
    }
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.toJsFn$extension__Ljapgolly_scalajs_react_callback_Trampoline__sjs_js_Function0 = (function(this$) {
  return $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
    var this$3 = $n(this$);
    return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$3)
  })))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.isEmpty_$qmark$extension__Ljapgolly_scalajs_react_callback_Trampoline__Z = (function(this$) {
  return (this$ === $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1 = (function(this$) {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var eta$0$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().attemptTry$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$);
  return $n($$x1).apply__F1__F1(new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(eta$0$1, f))
  })))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.delayMs$extension__Ljapgolly_scalajs_react_callback_Trampoline__D__F1 = (function(this$, startInMilliseconds) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().delayMs$extension__F1__D__F1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1(this$), startInMilliseconds)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0 = (function(this$, ev) {
  $n(ev);
  var x = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$);
  var this$$1 = x.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_sjsr_AnonFunction0((() => {
    var this$4 = $n(this$$1);
    return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4)
  }))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0 = (function(this$) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var f = new $c_sjsr_AnonFunction1(((x$20$2) => new $c_s_Some(x$20$2)));
  var this$3 = $n(this$);
  var $$x1 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$3, f);
  var this$4 = $m_s_$less$colon$less$();
  return $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$4.s_$less$colon$less$__f_singleton)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.requireCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0 = (function(this$, ev) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $n(ev);
  var x = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$);
  return $n($$x2).flatMap$extension__F0__F1__F0($n($$x1).toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(x.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$21$2) => {
    var x$21 = $uZ(x$21$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().require__F0__F0(new $c_sjsr_AnonFunction0((() => x$21))))
  })))
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.bool2$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__F2__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, b, op, ev) {
  $n(ev);
  var x = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$);
  var this$$1 = x.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var x$1 = new $c_sjsr_AnonFunction0((() => {
    var this$4 = $n(this$$1);
    return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4)
  }));
  var y = new $c_sjsr_AnonFunction0((() => {
    var this$7 = $n(b);
    return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$7)
  }));
  var f = new $c_sjsr_AnonFunction0((() => $uZ($n(op).apply__O__O__O(x$1, y))));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.$bar$bar$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, b, ev) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().bool2$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__F2__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(this$, b, new $c_sjsr_AnonFunction2(((x$25$2, x$26$2) => {
    var x$25 = $as_F0(x$25$2);
    var x$26 = $as_F0(x$26$2);
    var this$2 = $n(x$25);
    if ($uZ(this$2.apply__O())) {
      return true
    } else {
      var this$3 = $n(x$26);
      return $uZ(this$3.apply__O())
    }
  })), ev)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.equals$extension__Ljapgolly_scalajs_react_callback_Trampoline__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_callback_CallbackTo)) {
    var CallbackTo$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x$1)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    if ((this$ === null)) {
      return (CallbackTo$1 === null)
    } else {
      var this$1 = $n(this$);
      return (this$1 === CallbackTo$1)
    }
  } else {
    return false
  }
});
var $d_Ljapgolly_scalajs_react_callback_CallbackTo$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_CallbackTo$: 0
}, false, "japgolly.scalajs.react.callback.CallbackTo$", {
  Ljapgolly_scalajs_react_callback_CallbackTo$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_CallbackTo$;
var $n_Ljapgolly_scalajs_react_callback_CallbackTo$;
function $m_Ljapgolly_scalajs_react_callback_CallbackTo$() {
  if ((!$n_Ljapgolly_scalajs_react_callback_CallbackTo$)) {
    $n_Ljapgolly_scalajs_react_callback_CallbackTo$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo$()
  };
  return $n_Ljapgolly_scalajs_react_callback_CallbackTo$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$.prototype = $c_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$.prototype;
$c_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$.prototype.std$extension__F1__sc_BuildFrom__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, cbf) {
  var f = new $c_sjsr_AnonFunction0((() => new $c_sjsr_AnonFunction1(((ta$2) => {
    var ta = $as_sc_Iterable(ta$2);
    var r = $n(cbf).newBuilder__O__scm_Builder(ta);
    var this$2 = $n($n(ta).iterator__sc_Iterator());
    while (this$2.hasNext__Z()) {
      var arg1 = this$2.next__O();
      var this$5 = $n(r);
      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this$).apply__O__O(arg1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$4 = $n(this$$1);
      var elem = $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4);
      $as_scm_Builder(this$5.addOne__O__scm_Growable(elem))
    };
    return $as_sc_Iterable($n(r).result__O())
  }))));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$.prototype.option$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$) {
  var f = new $c_sjsr_AnonFunction0((() => new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_s_Option(x$2$2);
    var this$2 = $n(x$2);
    if (this$2.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this$).apply__O__O(arg1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$4 = $n(this$$1);
      return new $c_s_Some($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4))
    }
  }))));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
var $d_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$: 0
}, false, "japgolly.scalajs.react.callback.CallbackTo$LiftTraverseDsl$", {
  Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$;
var $n_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$;
function $m_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$() {
  if ((!$n_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$)) {
    $n_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$()
  };
  return $n_Ljapgolly_scalajs_react_callback_CallbackTo$LiftTraverseDsl$
}
function $f_Ljapgolly_scalajs_react_callback_Exports__$init$__V($thiz) {
  $thiz.Ljapgolly_scalajs_react_package$__f_AsyncCallback = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  $thiz.Ljapgolly_scalajs_react_package$__f_Callback = $m_Ljapgolly_scalajs_react_callback_Callback$();
  $thiz.Ljapgolly_scalajs_react_package$__f_CallbackTo = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $thiz.Ljapgolly_scalajs_react_package$__f_CallbackOption = $m_Ljapgolly_scalajs_react_callback_CallbackOption$()
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_SyncPromise() {
  this.Ljapgolly_scalajs_react_callback_SyncPromise__f_result = null;
  this.Ljapgolly_scalajs_react_callback_SyncPromise__f_callbacks = null;
  this.Ljapgolly_scalajs_react_callback_SyncPromise__f_complete = null;
  this.Ljapgolly_scalajs_react_callback_SyncPromise__f_result = $m_s_None$();
  this.Ljapgolly_scalajs_react_callback_SyncPromise__f_callbacks = ($n($m_s_package$().s_package$__f_List), $m_sci_Nil$());
  this.Ljapgolly_scalajs_react_callback_SyncPromise__f_complete = new $c_sjsr_AnonFunction1(((t$2) => {
    var t = $as_s_util_Try(t$2);
    $m_Ljapgolly_scalajs_react_callback_Callback$();
    var f = new $c_sjsr_AnonFunction0((() => {
      if ($n(this.Ljapgolly_scalajs_react_callback_SyncPromise__f_result).isEmpty__Z()) {
        this.Ljapgolly_scalajs_react_callback_SyncPromise__f_result = new $c_s_Some(t);
        try {
          var this$4 = $n(this.Ljapgolly_scalajs_react_callback_SyncPromise__f_callbacks);
          var these = this$4;
          while ((!$n(these).isEmpty__Z())) {
            var arg1 = $n(these).head__O();
            var x$1 = $as_F1(arg1);
            var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(x$1).apply__O__O(t))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var this$6 = $n(this$);
            $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$6);
            these = $as_sci_List($n(these).tail__O())
          }
        } finally {
          this.Ljapgolly_scalajs_react_callback_SyncPromise__f_callbacks = $m_s_package$().s_package$__f_Nil
        }
      }
    }));
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      f.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
  }))
}
$c_Ljapgolly_scalajs_react_callback_SyncPromise.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_SyncPromise.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_SyncPromise;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_SyncPromise() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_SyncPromise.prototype = $c_Ljapgolly_scalajs_react_callback_SyncPromise.prototype;
$c_Ljapgolly_scalajs_react_callback_SyncPromise.prototype.onComplete__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    $m_Ljapgolly_scalajs_react_callback_Callback$();
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      var x1 = this.Ljapgolly_scalajs_react_callback_SyncPromise__f_result;
      if ((x1 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x1);
        var t = $as_s_util_Try($n(x2).s_Some__f_value);
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(t))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$3 = $n(this$);
        $as_jl_Void($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$3))
      } else {
        var x = $m_s_None$();
        if ((x === x1)) {
          var this$4 = $n(this.Ljapgolly_scalajs_react_callback_SyncPromise__f_callbacks);
          this.Ljapgolly_scalajs_react_callback_SyncPromise__f_callbacks = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$4, f))
        } else {
          throw new $c_s_MatchError(x1)
        }
      }
    }));
    var f$3 = new $c_sjsr_AnonFunction0((() => {
      f$1.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
  }))
});
function $as_Ljapgolly_scalajs_react_callback_SyncPromise(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_callback_SyncPromise) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.SyncPromise"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_SyncPromise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_SyncPromise)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_SyncPromise(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_SyncPromise(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.SyncPromise;", depth))
}
var $d_Ljapgolly_scalajs_react_callback_SyncPromise = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_SyncPromise: 0
}, false, "japgolly.scalajs.react.callback.SyncPromise", {
  Ljapgolly_scalajs_react_callback_SyncPromise: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_SyncPromise.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_SyncPromise;
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_SyncPromise$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_callback_SyncPromise$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_SyncPromise$.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_SyncPromise$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_SyncPromise$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_SyncPromise$.prototype = $c_Ljapgolly_scalajs_react_callback_SyncPromise$.prototype;
$c_Ljapgolly_scalajs_react_callback_SyncPromise$.prototype.apply__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var f = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_SyncPromise()));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
var $d_Ljapgolly_scalajs_react_callback_SyncPromise$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_SyncPromise$: 0
}, false, "japgolly.scalajs.react.callback.SyncPromise$", {
  Ljapgolly_scalajs_react_callback_SyncPromise$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_SyncPromise$.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_SyncPromise$;
var $n_Ljapgolly_scalajs_react_callback_SyncPromise$;
function $m_Ljapgolly_scalajs_react_callback_SyncPromise$() {
  if ((!$n_Ljapgolly_scalajs_react_callback_SyncPromise$)) {
    $n_Ljapgolly_scalajs_react_callback_SyncPromise$ = new $c_Ljapgolly_scalajs_react_callback_SyncPromise$()
  };
  return $n_Ljapgolly_scalajs_react_callback_SyncPromise$
}
function $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline($thiz, f) {
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap($thiz, $n(f).andThen__F1__F1(new $c_sjsr_AnonFunction1(((x$1$2) => new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(x$1$2)))))
}
function $is_Ljapgolly_scalajs_react_callback_Trampoline(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_callback_Trampoline)))
}
function $as_Ljapgolly_scalajs_react_callback_Trampoline(obj) {
  return (($is_Ljapgolly_scalajs_react_callback_Trampoline(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.Trampoline"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_Trampoline)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_Trampoline(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.Trampoline;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_Trampoline$() {
  this.Ljapgolly_scalajs_react_callback_Trampoline$__f_unit = null;
  $n_Ljapgolly_scalajs_react_callback_Trampoline$ = this;
  this.Ljapgolly_scalajs_react_callback_Trampoline$__f_unit = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure((void 0))
}
$c_Ljapgolly_scalajs_react_callback_Trampoline$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_Trampoline$.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_Trampoline$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_Trampoline$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_Trampoline$.prototype = $c_Ljapgolly_scalajs_react_callback_Trampoline$.prototype;
$c_Ljapgolly_scalajs_react_callback_Trampoline$.prototype.run__Ljapgolly_scalajs_react_callback_Trampoline__O = (function(initial) {
  var next = initial;
  var stack = [];
  while (true) {
    var x1 = next;
    if ((x1 instanceof $c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap)) {
      var x2 = $as_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap(x1);
      stack.push($n(x2).Ljapgolly_scalajs_react_callback_Trampoline$FlatMap__f_f);
      next = $n(x2).Ljapgolly_scalajs_react_callback_Trampoline$FlatMap__f_from
    } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_callback_Trampoline$Suspend)) {
      var x3 = $as_Ljapgolly_scalajs_react_callback_Trampoline$Suspend(x1);
      next = $as_Ljapgolly_scalajs_react_callback_Trampoline($n($n(x3).Ljapgolly_scalajs_react_callback_Trampoline$Suspend__f_suspension).apply__O())
    } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure)) {
      var x4 = $as_Ljapgolly_scalajs_react_callback_Trampoline$Pure(x1);
      if (($uI(stack.length) === 0)) {
        return $n(x4).Ljapgolly_scalajs_react_callback_Trampoline$Pure__f_value
      } else {
        next = $as_Ljapgolly_scalajs_react_callback_Trampoline($n($as_F1(stack.pop())).apply__O__O($n(x4).Ljapgolly_scalajs_react_callback_Trampoline$Pure__f_value))
      }
    } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay)) {
      var x5 = $as_Ljapgolly_scalajs_react_callback_Trampoline$Delay(x1);
      if (($uI(stack.length) === 0)) {
        return $n($n(x5).Ljapgolly_scalajs_react_callback_Trampoline$Delay__f_value).apply__O()
      } else {
        next = $as_Ljapgolly_scalajs_react_callback_Trampoline($n($as_F1(stack.pop())).apply__O__O($n($n(x5).Ljapgolly_scalajs_react_callback_Trampoline$Delay__f_value).apply__O()))
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
var $d_Ljapgolly_scalajs_react_callback_Trampoline$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_Trampoline$: 0
}, false, "japgolly.scalajs.react.callback.Trampoline$", {
  Ljapgolly_scalajs_react_callback_Trampoline$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_callback_Trampoline$.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_Trampoline$;
var $n_Ljapgolly_scalajs_react_callback_Trampoline$;
function $m_Ljapgolly_scalajs_react_callback_Trampoline$() {
  if ((!$n_Ljapgolly_scalajs_react_callback_Trampoline$)) {
    $n_Ljapgolly_scalajs_react_callback_Trampoline$ = new $c_Ljapgolly_scalajs_react_callback_Trampoline$()
  };
  return $n_Ljapgolly_scalajs_react_callback_Trampoline$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Generic$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_Generic$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_Generic$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Generic$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Generic$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Generic$.prototype = $c_Ljapgolly_scalajs_react_component_Generic$.prototype;
var $d_Ljapgolly_scalajs_react_component_Generic$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_Generic$: 0
}, false, "japgolly.scalajs.react.component.Generic$", {
  Ljapgolly_scalajs_react_component_Generic$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_Generic$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_Generic$;
var $n_Ljapgolly_scalajs_react_component_Generic$;
function $m_Ljapgolly_scalajs_react_component_Generic$() {
  if ((!$n_Ljapgolly_scalajs_react_component_Generic$)) {
    $n_Ljapgolly_scalajs_react_component_Generic$ = new $c_Ljapgolly_scalajs_react_component_Generic$()
  };
  return $n_Ljapgolly_scalajs_react_component_Generic$
}
function $is_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_component_Generic$UnmountedRaw)))
}
function $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(obj) {
  return (($is_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.Generic$UnmountedRaw"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_Generic$UnmountedRaw)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.Generic$UnmountedRaw;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_JsForwardRef$() {
  $n_Ljapgolly_scalajs_react_component_JsForwardRef$ = this;
  new $c_sjsr_AnonFunction1(((x$2$2) => (void 0)))
}
$c_Ljapgolly_scalajs_react_component_JsForwardRef$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_JsForwardRef$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_JsForwardRef$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_JsForwardRef$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_JsForwardRef$.prototype = $c_Ljapgolly_scalajs_react_component_JsForwardRef$.prototype;
var $d_Ljapgolly_scalajs_react_component_JsForwardRef$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_JsForwardRef$: 0
}, false, "japgolly.scalajs.react.component.JsForwardRef$", {
  Ljapgolly_scalajs_react_component_JsForwardRef$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_JsForwardRef$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_JsForwardRef$;
var $n_Ljapgolly_scalajs_react_component_JsForwardRef$;
function $m_Ljapgolly_scalajs_react_component_JsForwardRef$() {
  if ((!$n_Ljapgolly_scalajs_react_component_JsForwardRef$)) {
    $n_Ljapgolly_scalajs_react_component_JsForwardRef$ = new $c_Ljapgolly_scalajs_react_component_JsForwardRef$()
  };
  return $n_Ljapgolly_scalajs_react_component_JsForwardRef$
}
function $p_Ljapgolly_scalajs_react_component_ScalaFn$__create__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($thiz, render, s) {
  var jsRender = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1($n(render).andThen__F1__F1(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(x$1$2);
    return $n(x$1).rawNode__sjs_js_$bar()
  }))));
  return $n($n($m_Ljapgolly_scalajs_react_component_JsFn$().force__O__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(jsRender, s)).cmapCtorProps__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$2$2) => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var array = [$ct_T2__O__O__(new $c_T2(), "a", x$2$2)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  })))).mapUnmounted__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(x$3$2);
    return $n(x$3).mapUnmountedProps__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((x$4$2) => x$4$2.a)))
  })))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_ScalaFn$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_ScalaFn$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_ScalaFn$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_ScalaFn$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_ScalaFn$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_ScalaFn$.prototype = $c_Ljapgolly_scalajs_react_component_ScalaFn$.prototype;
$c_Ljapgolly_scalajs_react_component_ScalaFn$.prototype.apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(render, s) {
  return $p_Ljapgolly_scalajs_react_component_ScalaFn$__create__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this, new $c_sjsr_AnonFunction1(((b$2) => $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(b$2.a)))), s)
});
$c_Ljapgolly_scalajs_react_component_ScalaFn$.prototype.withChildren__F2__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(render, s) {
  return $p_Ljapgolly_scalajs_react_component_ScalaFn$__create__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this, new $c_sjsr_AnonFunction1(((b$2) => {
    var $$x1 = b$2.a;
    var a = b$2.children;
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O__O($$x1, new $c_Ljapgolly_scalajs_react_PropsChildren(a)))
  })), s)
});
$c_Ljapgolly_scalajs_react_component_ScalaFn$.prototype.justChildren__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(render) {
  return $p_Ljapgolly_scalajs_react_component_ScalaFn$__create__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this, new $c_sjsr_AnonFunction1(((b$2) => {
    var a = b$2.children;
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(new $c_Ljapgolly_scalajs_react_PropsChildren(a)))
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonC__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner($m_Ljapgolly_scalajs_react_internal_Singleton$().Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit))
});
var $d_Ljapgolly_scalajs_react_component_ScalaFn$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_ScalaFn$: 0
}, false, "japgolly.scalajs.react.component.ScalaFn$", {
  Ljapgolly_scalajs_react_component_ScalaFn$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_ScalaFn$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_ScalaFn$;
var $n_Ljapgolly_scalajs_react_component_ScalaFn$;
function $m_Ljapgolly_scalajs_react_component_ScalaFn$() {
  if ((!$n_Ljapgolly_scalajs_react_component_ScalaFn$)) {
    $n_Ljapgolly_scalajs_react_component_ScalaFn$ = new $c_Ljapgolly_scalajs_react_component_ScalaFn$()
  };
  return $n_Ljapgolly_scalajs_react_component_ScalaFn$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_ScalaForwardRef$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_ScalaForwardRef$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_ScalaForwardRef$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_ScalaForwardRef$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_ScalaForwardRef$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_ScalaForwardRef$.prototype = $c_Ljapgolly_scalajs_react_component_ScalaForwardRef$.prototype;
var $d_Ljapgolly_scalajs_react_component_ScalaForwardRef$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_ScalaForwardRef$: 0
}, false, "japgolly.scalajs.react.component.ScalaForwardRef$", {
  Ljapgolly_scalajs_react_component_ScalaForwardRef$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_ScalaForwardRef$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_ScalaForwardRef$;
var $n_Ljapgolly_scalajs_react_component_ScalaForwardRef$;
function $m_Ljapgolly_scalajs_react_component_ScalaForwardRef$() {
  if ((!$n_Ljapgolly_scalajs_react_component_ScalaForwardRef$)) {
    $n_Ljapgolly_scalajs_react_component_ScalaForwardRef$ = new $c_Ljapgolly_scalajs_react_component_ScalaForwardRef$()
  };
  return $n_Ljapgolly_scalajs_react_component_ScalaForwardRef$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$.prototype = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$.prototype;
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$.prototype.fromReactComponentClass__sjs_js_Function1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(rc, ctorType) {
  var x = $m_Ljapgolly_scalajs_react_component_Js$().component__sjs_js_Function1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(rc, ctorType);
  return $n($n(x).cmapCtorProps__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$16$2) => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var array = [$ct_T2__O__O__(new $c_T2(), "a", x$16$2)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  })))).mapUnmounted__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$17$2) => {
    var x$17 = $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(x$17$2);
    return $n($n(x$17).mapUnmountedProps__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((x$18$2) => x$18$2.a)))).mapMounted__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((x$2) => {
      var x$1 = $as_Ljapgolly_scalajs_react_component_Js$MountedWithRoot(x$2);
      return new $c_Ljapgolly_scalajs_react_component_Scala$$anon$1(x$1)
    })))
  })))
});
var $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$: 0
}, false, "japgolly.scalajs.react.component.builder.ComponentBuilder$", {
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$;
var $n_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$;
function $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$() {
  if ((!$n_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$)) {
    $n_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$ = new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$()
  };
  return $n_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$
}
function $p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppend__Ljapgolly_scalajs_react_internal_Lens__F1__F2__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($thiz, lens, g, s) {
  var x$1 = $n($thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).append__Ljapgolly_scalajs_react_internal_Lens__F1__F2__Ljapgolly_scalajs_react_component_builder_LifecycleF(lens, g, s);
  var x$2 = $thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_name;
  var x$3 = $thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_initState;
  var x$4 = $thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_backendFn;
  var x$5 = $thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_renderFn;
  return new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(x$2, x$3, x$4, x$5, x$1)
}
function $p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($thiz, lens, g, G) {
  var $$x2 = $n($thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle);
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var this$2 = $n(this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
  var $$x1 = $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatchFn1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(this$2, g, G);
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var x$1 = $n($$x2).append__Ljapgolly_scalajs_react_internal_Lens__F1__F2__Ljapgolly_scalajs_react_component_builder_LifecycleF(lens, $$x1, $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_semigroupSyncUnit);
  var x$2 = $thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_name;
  var x$3 = $thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_initState;
  var x$4 = $thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_backendFn;
  var x$5 = $thiz.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_renderFn;
  return new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(x$2, x$3, x$4, x$5, x$1)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(name, initState, backendFn, renderFn, lifecycle) {
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_name = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_initState = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_backendFn = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_renderFn = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_name = name;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_initState = initState;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_backendFn = backendFn;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_renderFn = renderFn;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle = lifecycle
}
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep.prototype = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep.prototype;
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep.prototype.componentDidUpdate__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep = (function(f, G) {
  var lc = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidUpdate__Ljapgolly_scalajs_react_internal_Lens(), f, G)).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle;
  return new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_name, this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_initState, this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_backendFn, this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_renderFn, lc)
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep.prototype.shouldComponentUpdate__F1__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep = (function(f, G) {
  var $$x2 = $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().shouldComponentUpdate__Ljapgolly_scalajs_react_internal_Lens();
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var this$2 = $n(this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
  var $$x1 = $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSyncFn1__F1__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__F1(this$2, f, G);
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return $p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppend__Ljapgolly_scalajs_react_internal_Lens__F1__F2__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this, $$x2, $$x1, $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_semigroupSyncOr)
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep.prototype.shouldComponentUpdatePure__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep = (function(f) {
  var $$x1 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(\u03b4$2);
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    var a = new $c_sjsr_AnonFunction0((() => $uZ($n(f).apply__O__O(\u03b4))));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
  }));
  var this$6 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this.shouldComponentUpdate__F1__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($$x1, this$6.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep.prototype.build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(ctorType) {
  var c = $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$().apply__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__sjs_js_Function1(this);
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$().fromReactComponentClass__sjs_js_Function1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(c, ctorType)
});
function $as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.ComponentBuilder$LastStep"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.ComponentBuilder$LastStep;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep: 0
}, false, "japgolly.scalajs.react.component.builder.ComponentBuilder$LastStep", {
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1(name) {
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1__f_japgolly$scalajs$react$component$builder$ComponentBuilder$Step1$$name = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1__f_japgolly$scalajs$react$component$builder$ComponentBuilder$Step1$$name = name
}
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1.prototype = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1.prototype;
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1.prototype.hashCode__I = (function() {
  var this$ = this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1__f_japgolly$scalajs$react$component$builder$ComponentBuilder$Step1$$name;
  return $f_T__hashCode__I($n(this$))
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().equals$extension__T__O__Z(this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1__f_japgolly$scalajs$react$component$builder$ComponentBuilder$Step1$$name, x$1)
});
function $as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.ComponentBuilder$Step1"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.ComponentBuilder$Step1;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1: 0
}, false, "japgolly.scalajs.react.component.builder.ComponentBuilder$Step1", {
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype;
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype.getDerivedStateFromPropsAndState$extension__T__F2__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2 = (function(this$, f) {
  return new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this$, new $c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState(f))
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype.initialState$extension__T__F0__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2 = (function(this$, s) {
  return new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this$, new $c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState(new $c_sjsr_AnonFunction1(((x$1$2) => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var value = $n(s).apply__O();
    var array = [$ct_T2__O__O__(new $c_T2(), "a", value)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  }))))
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype.initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2 = (function(this$, f) {
  return new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this$, new $c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState(new $c_sjsr_AnonFunction1(((p$2) => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var value = $n(f).apply__O__O(p$2.a);
    var array = [$ct_T2__O__O__(new $c_T2(), "a", value)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  }))))
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype.initialStateCallback$extension__T__O__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2 = (function(this$, cb, G) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialState$extension__T__F0__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this$, new $c_sjsr_AnonFunction0((() => {
    $n(G);
    var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$4 = $n(this$$1);
    return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4)
  })))
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype.equals$extension__T__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1)) {
    var Step1$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1(x$1)).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1__f_japgolly$scalajs$react$component$builder$ComponentBuilder$Step1$$name);
    return (this$ === Step1$1)
  } else {
    return false
  }
});
var $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$: 0
}, false, "japgolly.scalajs.react.component.builder.ComponentBuilder$Step1$", {
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$;
var $n_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$;
function $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$() {
  if ((!$n_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$)) {
    $n_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$ = new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$()
  };
  return $n_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(name, initState) {
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2__f_name = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2__f_initState = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2__f_name = name;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2__f_initState = initState
}
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2.prototype = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2.prototype;
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2.prototype.backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3 = (function(f) {
  return new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2__f_name, this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2__f_initState, f)
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2.prototype.noBackend__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3 = (function() {
  return this.backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2$2) => {
    $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2$2)
  })))
});
var $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2: 0
}, false, "japgolly.scalajs.react.component.builder.ComponentBuilder$Step2", {
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(name, initState, backendFn) {
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_name = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_initState = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_backendFn = null;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_name = name;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_initState = initState;
  this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_backendFn = backendFn
}
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3.prototype = $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3.prototype;
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3.prototype.renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep = (function(r) {
  var lc = new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF($m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
  var x1 = this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_initState;
  if (false) {
    var x2 = $as_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromProps(x1);
    var f = $n(x2).fn__F1();
    var qual$1 = lc;
    var x$1 = new $c_s_Some(new $c_sjsr_AnonFunction2(((p$2, x$3$2) => new $c_s_Some($n(f).apply__O__O(p$2)))));
    var this$4 = $n(qual$1);
    var x$2 = this$4.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
    var this$5 = $n(qual$1);
    var x$3$3 = this$5.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
    var this$6 = $n(qual$1);
    var x$4 = this$6.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
    var this$7 = $n(qual$1);
    var x$5 = this$7.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
    var this$8 = $n(qual$1);
    var x$6 = this$8.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
    var this$9 = $n(qual$1);
    var x$7 = this$9.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
    var this$10 = $n(qual$1);
    var x$8 = this$10.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
    var this$11 = $n(qual$1);
    var x$9 = this$11.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
    var this$12 = $n(qual$1);
    var x$10 = this$12.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
    $n(qual$1);
    lc = new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$2, x$3$3, x$4, x$5, x$6, x$7, x$8, x$1, x$9, x$10)
  } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState)) {
    var x3 = $as_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState(x1);
    var f$2 = $n(x3).Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState__f_fn;
    var qual$2 = lc;
    var x$11 = new $c_s_Some(new $c_sjsr_AnonFunction2(((p$3$2, s$2) => new $c_s_Some($n(f$2).apply__O__O__O(p$3$2, new $c_s_Some(s$2))))));
    var this$14 = $n(qual$2);
    var x$12 = this$14.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
    var this$15 = $n(qual$2);
    var x$13 = this$15.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
    var this$16 = $n(qual$2);
    var x$14 = this$16.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
    var this$17 = $n(qual$2);
    var x$15 = this$17.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
    var this$18 = $n(qual$2);
    var x$16 = this$18.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
    var this$19 = $n(qual$2);
    var x$17 = this$19.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
    var this$20 = $n(qual$2);
    var x$18 = this$20.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
    var this$21 = $n(qual$2);
    var x$19 = this$21.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
    var this$22 = $n(qual$2);
    var x$20 = this$22.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
    $n(qual$2);
    lc = new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$12, x$13, x$14, x$15, x$16, x$17, x$18, x$11, x$19, x$20)
  };
  return new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_name, this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_initState, this.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3__f_backendFn, r, lc)
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3.prototype.render_P__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep = (function(r) {
  return this.renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(\u03b4$2);
    var this$2 = $n(\u03b4);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(r).apply__O__O($n(this$2.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()))
  })))
});
var $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3: 0
}, false, "japgolly.scalajs.react.component.builder.ComponentBuilder$Step3", {
  Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3;
function $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__($thiz, raw, f, a) {
  $thiz.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = raw;
  $thiz.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = f;
  $thiz.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = a;
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base() {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base.prototype.F__Ljapgolly_scalajs_react_util_Effect$UnsafeSync = (function() {
  return this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base.prototype.A__Ljapgolly_scalajs_react_util_Effect$Async = (function() {
  return this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base.prototype.backend__O = (function() {
  return this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw.backend
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base.prototype.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot = (function() {
  return $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw.mountedImpure)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base.prototype.mountedPure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot = (function() {
  var this$1 = $n($as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw.mountedPure));
  var G = this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f;
  var this$2 = $n(this$1.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(G));
  var G$1 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a;
  return $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(this$2.withAsyncEffect__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(G$1))
});
function $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.LifecycleF$Base"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.LifecycleF$Base;", depth))
}
function $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$___defineProperties__sjs_js_Object__sjs_js_Array__V($thiz, target, props) {
  var len = $uI(props.length);
  var i = 0;
  while ((i < len)) {
    var arg1 = props[i];
    arg1.configurable = true;
    var $$x1 = $m_sjs_js_Any$ObjectCompanionOps$();
    var self = Object;
    if ($n($$x1).hasProperty$extension__sjs_js_Object$__sjs_js_Object__T__Z(self, arg1, "value")) {
      arg1.writable = true
    };
    Object.defineProperty(target, $as_T(arg1.key), arg1);
    i = ((1 + i) | 0)
  }
}
function $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$___createClass__sjs_js_Object__sjs_js_Array__sjs_js_Array__V($thiz, c, protoProps, staticProps) {
  $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$___defineProperties__sjs_js_Object__sjs_js_Array__V($thiz, c.prototype, protoProps);
  $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$___defineProperties__sjs_js_Object__sjs_js_Array__V($thiz, c, staticProps)
}
function $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$___possibleConstructorReturn__sjs_js_Any__sjs_js_Any__sjs_js_Any($thiz, self, call) {
  return (($uZ((call instanceof Object)) || $uZ((call instanceof Function))) ? call : self)
}
function $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$___inherits__sjs_js_Object__sjs_js_Object__V($thiz, subClass, superClass) {
  var $$x3 = Object;
  var $$x2 = superClass.prototype;
  var array = [$ct_T2__O__O__(new $c_T2(), "value", subClass), $ct_T2__O__O__(new $c_T2(), "enumerable", false), $ct_T2__O__O__(new $c_T2(), "writable", true), $ct_T2__O__O__(new $c_T2(), "configurable", true)];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "constructor", $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields))];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var $$x1 = $$x3.create($$x2, $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1));
  subClass.prototype = $$x1;
  (0, $thiz.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f__setPrototypeOf)(subClass, superClass)
}
function $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__boxStateOrNull__s_Option__Ljapgolly_scalajs_react_internal_Box($thiz, o) {
  var x = $m_s_None$();
  if ((x === o)) {
    return null
  } else if ((o instanceof $c_s_Some)) {
    var x3 = $as_s_Some(o);
    var s2 = $n(x3).s_Some__f_value;
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var array = [$ct_T2__O__O__(new $c_T2(), "a", s2)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  } else {
    throw new $c_s_MatchError(o)
  }
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$() {
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_x$4 = null;
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f__getPrototypeOf = null;
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f__setPrototypeOf = null;
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_ReactComponent = null;
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_anyToBoxUnit = null;
  $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ = this;
  var f = Object.setPrototypeOf;
  var x1 = ((f === (void 0)) ? $m_s_None$() : new $c_s_Some(f));
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var set = $n(x2).s_Some__f_value;
    var _1 = new $c_sjsr_AnonFunction1(((o$2) => Object.getPrototypeOf(o$2)));
    var x1$2___1 = _1;
    var x1$2___2 = set
  } else {
    var x = $m_s_None$();
    if ((!(x === x1))) {
      throw new $c_s_MatchError(x1)
    };
    var get = new $c_sjsr_AnonFunction1(((x$1$2) => x$1$2.__proto__));
    var set$2 = ((arg1$2, arg2$2) => {
      $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$().japgolly$scalajs$react$component$builder$ViaReactComponent$$$anonfun$x$4$3__sjs_js_Object__sjs_js_Object__V(arg1$2, arg2$2)
    });
    var x1$2___1 = get;
    var x1$2___2 = set$2
  };
  var _getPrototypeOf = $as_F1(x1$2___1);
  var _setPrototypeOf = x1$2___2;
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_x$4 = $ct_T2__O__O__(new $c_T2(), _getPrototypeOf, _setPrototypeOf);
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f__getPrototypeOf = $as_F1($n(this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_x$4)._1__O());
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f__setPrototypeOf = $n(this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_x$4)._2__O();
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_ReactComponent = $i_react.Component;
  this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_anyToBoxUnit = new $c_sjsr_AnonFunction1(((x$5$2) => $m_Ljapgolly_scalajs_react_internal_Box$().Ljapgolly_scalajs_react_internal_Box$__f_Unit))
}
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$.prototype = $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$.prototype;
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$.prototype.japgolly$scalajs$react$component$builder$ViaReactComponent$$Method__T__sjs_js_Any__Ljapgolly_scalajs_react_component_builder_ViaReactComponent$Method = (function(_key, _value) {
  var array = [$ct_T2__O__O__(new $c_T2(), "key", _key), $ct_T2__O__O__(new $c_T2(), "value", _value)];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$.prototype.apply__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__sjs_js_Function1 = (function(builder) {
  var backendFn = $n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_backendFn;
  var renderFn = $n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_renderFn;
  var x1 = $n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_initState;
  if ((x1 instanceof $c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState)) {
    var x2 = $as_Ljapgolly_scalajs_react_component_builder_InitState$InitialState(x1);
    var f = $n(x2).Ljapgolly_scalajs_react_component_builder_InitState$InitialState__f_fn;
    var initStateFn = f
  } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState)) {
    var x3 = $as_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState(x1);
    var f$2 = $n(x3).Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState__f_fn;
    var initStateFn = new $c_sjsr_AnonFunction1(((bp$2) => {
      $m_Ljapgolly_scalajs_react_internal_Box$();
      var value = $n(f$2).apply__O__O__O(bp$2.a, $m_s_None$());
      var array = [$ct_T2__O__O__(new $c_T2(), "a", value)];
      var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
    }))
  } else {
    var initStateFn = this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_anyToBoxUnit
  };
  var MyComponent = new $c_sr_ObjectRef(null);
  MyComponent.sr_ObjectRef__f_elem = (function(arg1$2) {
    return $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$().japgolly$scalajs$react$component$builder$ViaReactComponent$$$anonfun$apply$2__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_internal_Box__sr_ObjectRef__F1__F1__Ljapgolly_scalajs_react_facade_React$Component(this, arg1$2, MyComponent, backendFn, initStateFn)
  });
  $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$___inherits__sjs_js_Object__sjs_js_Object__V(this, MyComponent.sr_ObjectRef__f_elem, this.Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f_ReactComponent);
  var protoProps = $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().$lessinit$greater$default$1__sjs_js_Array();
  var staticProps = $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$().$lessinit$greater$default$1__sjs_js_Array();
  $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add0$extension__sjs_js_Array__T__F1__V(protoProps, "render", new $c_sjsr_AnonFunction1(((_this$2) => {
    var this$8 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var $$x1 = this$8.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var this$9 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return $n($as_Ljapgolly_scalajs_react_vdom_VdomNode($n(renderFn).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(_this$2, $$x1, this$9.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).rawNode__sjs_js_$bar()
  })));
  var this$10 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch);
  if ((!this$10.isEmpty__Z())) {
    var arg1 = this$10.get__O();
    var f$3 = $as_F1(arg1);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add2$extension__sjs_js_Array__T__F3__V(protoProps, "componentDidCatch", new $c_sjsr_AnonFunction3(((_this$2$1, e$2, i$2) => {
      var this$12 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$12.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var this$14 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x2 = this$14.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var this$15 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f$3).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch(_this$2$1, e$2, i$2, $$x2, this$15.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$17 = $n(this$);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$17)
    })))
  };
  var this$18 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount);
  if ((!this$18.isEmpty__Z())) {
    var arg1$1 = this$18.get__O();
    var f$4 = $as_F1(arg1$1);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add0$extension__sjs_js_Array__T__F1__V(protoProps, "componentDidMount", new $c_sjsr_AnonFunction1(((_this$2$2) => {
      var this$20 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$20.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var this$22 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x3 = this$22.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var this$23 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f$4).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(_this$2$2, $$x3, this$23.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$25 = $n(this$$1);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$25)
    })))
  };
  var this$26 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate);
  if ((!this$26.isEmpty__Z())) {
    var arg1$3 = this$26.get__O();
    var f$5 = $as_F1(arg1$3);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add3$extension__sjs_js_Array__T__F4__V(protoProps, "componentDidUpdate", new $c_sjsr_AnonFunction4(((_this$2$3, p$2, s$2, ss$2) => {
      var this$28 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$28.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var $$x6 = p$2.a;
      var $$x5 = s$2.a;
      var this$30 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x4 = this$30.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var this$31 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f$5).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(_this$2$3, $$x6, $$x5, ss$2, $$x4, this$31.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$33 = $n(this$$2);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$33)
    })))
  };
  var this$34 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount);
  if ((!this$34.isEmpty__Z())) {
    var arg1$4 = this$34.get__O();
    var f$6 = $as_F1(arg1$4);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add0$extension__sjs_js_Array__T__F1__V(protoProps, "componentWillMount", new $c_sjsr_AnonFunction1(((_this$2$4) => {
      var this$36 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$36.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var this$38 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x7 = this$38.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var this$39 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f$6).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(_this$2$4, $$x7, this$39.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$41 = $n(this$$3);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$41)
    })))
  };
  var this$42 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps);
  if ((!this$42.isEmpty__Z())) {
    var arg1$5 = this$42.get__O();
    var f$7 = $as_F1(arg1$5);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add1$extension__sjs_js_Array__T__F2__V(protoProps, "componentWillReceiveProps", new $c_sjsr_AnonFunction2(((_this$2$5, p$2$1) => {
      var this$44 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$44.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var $$x9 = p$2$1.a;
      var this$46 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x8 = this$46.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var this$47 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$$4 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f$7).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(_this$2$5, $$x9, $$x8, this$47.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$49 = $n(this$$4);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$49)
    })))
  };
  var this$50 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount);
  if ((!this$50.isEmpty__Z())) {
    var arg1$6 = this$50.get__O();
    var f$8 = $as_F1(arg1$6);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add0$extension__sjs_js_Array__T__F1__V(protoProps, "componentWillUnmount", new $c_sjsr_AnonFunction1(((_this$2$6) => {
      var this$52 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$52.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var this$54 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x10 = this$54.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var this$55 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$$5 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f$8).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(_this$2$6, $$x10, this$55.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$57 = $n(this$$5);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$57)
    })))
  };
  var this$58 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate);
  if ((!this$58.isEmpty__Z())) {
    var arg1$7 = this$58.get__O();
    var f$9 = $as_F1(arg1$7);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add2$extension__sjs_js_Array__T__F3__V(protoProps, "componentWillUpdate", new $c_sjsr_AnonFunction3(((_this$2$7, p$2$2, s$2$1) => {
      var this$60 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$60.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var $$x13 = p$2$2.a;
      var $$x12 = s$2$1.a;
      var this$62 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x11 = this$62.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var this$63 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$$6 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f$9).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate(_this$2$7, $$x13, $$x12, $$x11, this$63.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$65 = $n(this$$6);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$65)
    })))
  };
  var this$66 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps);
  if ((!this$66.isEmpty__Z())) {
    var arg1$8 = this$66.get__O();
    var f$10 = $as_F2(arg1$8);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$().add2$extension__sjs_js_Array__T__F2__V(staticProps, "getDerivedStateFromProps", new $c_sjsr_AnonFunction2(((p$2$3, s$2$2) => $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__boxStateOrNull__s_Option__Ljapgolly_scalajs_react_internal_Box($m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$(), $as_s_Option($n(f$10).apply__O__O__O(p$2$3.a, s$2$2.a))))))
  };
  var this$68 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate);
  if ((!this$68.isEmpty__Z())) {
    var arg1$9 = this$68.get__O();
    var f$11 = $as_F1(arg1$9);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add2$extension__sjs_js_Array__T__F3__V(protoProps, "getSnapshotBeforeUpdate", new $c_sjsr_AnonFunction3(((_this$2$8, p$2$4, s$2$3) => {
      var this$70 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$70.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var $$x16 = p$2$4.a;
      var $$x15 = s$2$3.a;
      var this$72 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x14 = this$72.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var this$73 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$$7 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f$11).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate(_this$2$8, $$x16, $$x15, $$x14, this$73.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$75 = $n(this$$7);
      return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$75)
    })))
  };
  var this$76 = $n($n($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_lifecycle).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate);
  if ((!this$76.isEmpty__Z())) {
    var arg1$10 = this$76.get__O();
    var f$12 = $as_F1(arg1$10);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add2$extension__sjs_js_Array__T__F3__V(protoProps, "shouldComponentUpdate", new $c_sjsr_AnonFunction3(((_this$2$9, p$2$5, s$2$4) => {
      var this$78 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$78.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var $$x19 = p$2$5.a;
      var $$x18 = s$2$4.a;
      var this$80 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x17 = this$80.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var this$81 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$$8 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f$12).apply__O__O(new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(_this$2$9, $$x19, $$x18, $$x17, this$81.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$83 = $n(this$$8);
      return $uZ($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$83))
    })))
  };
  var this$84 = $n($m_s_Option$().apply__O__s_Option($n(builder).Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__f_name));
  if ((!this$84.isEmpty__Z())) {
    var arg1$11 = this$84.get__O();
    var n = $as_T(arg1$11);
    $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$().add$extension__sjs_js_Array__T__sjs_js_Any__V(staticProps, "displayName", n)
  };
  $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$___createClass__sjs_js_Object__sjs_js_Array__sjs_js_Array__V(this, MyComponent.sr_ObjectRef__f_elem, protoProps, staticProps);
  return MyComponent.sr_ObjectRef__f_elem
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$.prototype.japgolly$scalajs$react$component$builder$ViaReactComponent$$$anonfun$x$4$3__sjs_js_Object__sjs_js_Object__V = (function(x$2, x$3) {
  x$2.__proto__ = x$3
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$.prototype.japgolly$scalajs$react$component$builder$ViaReactComponent$$$anonfun$apply$2__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_internal_Box__sr_ObjectRef__F1__F1__Ljapgolly_scalajs_react_facade_React$Component = (function(this$1, props, MyComponent$1, backendFn$1, initStateFn$1) {
  var _this = $p_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$___possibleConstructorReturn__sjs_js_Any__sjs_js_Any__sjs_js_Any($m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$(), this$1, $n($m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$().Ljapgolly_scalajs_react_component_builder_ViaReactComponent$__f__getPrototypeOf).apply__O__O($n(MyComponent$1).sr_ObjectRef__f_elem).call(this$1, props));
  var this$3 = new $c_Ljapgolly_scalajs_react_component_Js$$anon$3(_this);
  _this.mountedImpure = new $c_Ljapgolly_scalajs_react_component_Scala$$anon$1(this$3);
  var this$6 = $n($as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(_this.mountedImpure));
  var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  _this.mountedPure = $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(this$6.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(G));
  _this.backend = $n(backendFn$1).apply__O__O($as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(_this.mountedPure));
  _this.state = $n(initStateFn$1).apply__O__O(props);
  return _this
});
var $d_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_ViaReactComponent$: 0
}, false, "japgolly.scalajs.react.component.builder.ViaReactComponent$", {
  Ljapgolly_scalajs_react_component_builder_ViaReactComponent$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$;
var $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$;
function $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$() {
  if ((!$n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$)) {
    $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ = new $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$()
  };
  return $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype = $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype;
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype.$lessinit$greater$default$1__sjs_js_Array = (function() {
  return []
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype.add$extension__sjs_js_Array__T__sjs_js_Any__V = (function(this$, k, v) {
  this$.push($m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$().japgolly$scalajs$react$component$builder$ViaReactComponent$$Method__T__sjs_js_Any__Ljapgolly_scalajs_react_component_builder_ViaReactComponent$Method(k, v))
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype.add0$extension__sjs_js_Array__T__F1__V = (function(this$, k, f) {
  $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add$extension__sjs_js_Array__T__sjs_js_Any__V(this$, k, $m_sjs_js_ThisFunction$().fromFunction1__F1__sjs_js_ThisFunction0(f))
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype.add1$extension__sjs_js_Array__T__F2__V = (function(this$, k, f) {
  $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add$extension__sjs_js_Array__T__sjs_js_Any__V(this$, k, $m_sjs_js_ThisFunction$().fromFunction2__F2__sjs_js_ThisFunction1(f))
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype.add2$extension__sjs_js_Array__T__F3__V = (function(this$, k, f) {
  $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add$extension__sjs_js_Array__T__sjs_js_Any__V(this$, k, $m_sjs_js_ThisFunction$().fromFunction3__F3__sjs_js_ThisFunction2(f))
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype.add3$extension__sjs_js_Array__T__F4__V = (function(this$, k, f) {
  $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$().add$extension__sjs_js_Array__T__sjs_js_Any__V(this$, k, $m_sjs_js_ThisFunction$().fromFunction4__F4__sjs_js_ThisFunction3(f))
});
var $d_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$: 0
}, false, "japgolly.scalajs.react.component.builder.ViaReactComponent$ProtoProps$", {
  Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$;
var $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$;
function $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$() {
  if ((!$n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$)) {
    $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$ = new $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$()
  };
  return $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$ProtoProps$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$.prototype = $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$.prototype;
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$.prototype.$lessinit$greater$default$1__sjs_js_Array = (function() {
  return []
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$.prototype.add$extension__sjs_js_Array__T__sjs_js_Any__V = (function(this$, k, v) {
  this$.push($m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$().japgolly$scalajs$react$component$builder$ViaReactComponent$$Method__T__sjs_js_Any__Ljapgolly_scalajs_react_component_builder_ViaReactComponent$Method(k, v))
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$.prototype.add2$extension__sjs_js_Array__T__F2__V = (function(this$, k, f) {
  $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$().add$extension__sjs_js_Array__T__sjs_js_Any__V(this$, k, $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(f))
});
var $d_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$: 0
}, false, "japgolly.scalajs.react.component.builder.ViaReactComponent$StaticProps$", {
  Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$;
var $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$;
function $m_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$() {
  if ((!$n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$)) {
    $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$ = new $c_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$()
  };
  return $n_Ljapgolly_scalajs_react_component_builder_ViaReactComponent$StaticProps$
}
function $ct_Ljapgolly_scalajs_react_extra_EventListenerF__($thiz) {
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_EventListenerF() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_EventListenerF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_EventListenerF.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_EventListenerF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_EventListenerF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_EventListenerF.prototype = $c_Ljapgolly_scalajs_react_extra_EventListenerF.prototype;
$c_Ljapgolly_scalajs_react_extra_EventListenerF.prototype.install__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1 = (function(eventType, listener, target, useCapture, F, G) {
  return $m_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$().install$extension__Z__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(true, eventType, new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(\u03b4$2);
    var cb = $n(listener).apply__O__O(\u03b4);
    return new $c_sjsr_AnonFunction1(((x$1$2) => cb))
  })), target, useCapture, F, G)
});
$c_Ljapgolly_scalajs_react_extra_EventListenerF.prototype.install___T__O__F0__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1 = (function(eventType, listener, target, useCapture, F, G) {
  return this.install__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(eventType, new $c_sjsr_AnonFunction1(((x$2$2) => {
    $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$2$2);
    return listener
  })), new $c_sjsr_AnonFunction1(((x$3$2) => {
    $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$3$2);
    return $n(target).apply__O()
  })), useCapture, F, G)
});
var $d_Ljapgolly_scalajs_react_extra_EventListenerF = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_EventListenerF: 0
}, false, "japgolly.scalajs.react.extra.EventListenerF", {
  Ljapgolly_scalajs_react_extra_EventListenerF: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_EventListenerF.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_EventListenerF;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$.prototype = $c_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$.prototype;
$c_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$.prototype.install$extension__Z__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1 = (function(this$, eventType, listener, target, useCapture, F, G) {
  return $n($m_Ljapgolly_scalajs_react_extra_OnUnmountF$().install__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(F)).andThen__F1__F1(new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(x$5$2);
    var this$3 = $n(x$5);
    var f$2 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
      var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$2);
      var et = $n(target).apply__O__O($n(\u03b4).mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot());
      var ge = $as_F1($n(listener).apply__O__O($n(\u03b4).mountedPure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()));
      var f = ((arg1$2) => {
        $m_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$().japgolly$scalajs$react$extra$EventListenerF$OfEventType$$$anonfun$install$5__Lorg_scalajs_dom_Event__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1__V(arg1$2, G, ge)
      });
      var add = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
        et.addEventListener(eventType, f, useCapture)
      })));
      var del = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
        et.removeEventListener(eventType, f, useCapture)
      })));
      var $$x1 = $n(F);
      var this$2 = $n($as_Ljapgolly_scalajs_react_extra_OnUnmountF($n(\u03b4).backend__O()));
      var f$1 = new $c_sjsr_AnonFunction0((() => del));
      return $n($$x1).chain__O__O__O(add, $f_Ljapgolly_scalajs_react_extra_OnUnmountF__onUnmount__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$2, f$1, F))
    }));
    return $p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$3, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$2, F)
  })))
});
$c_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$.prototype.japgolly$scalajs$react$extra$EventListenerF$OfEventType$$$anonfun$install$5__Lorg_scalajs_dom_Event__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1__V = (function(e, G$1, ge$1) {
  $n(G$1).dispatch__O__V($n(ge$1).apply__O__O(e))
});
var $d_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$: 0
}, false, "japgolly.scalajs.react.extra.EventListenerF$OfEventType$", {
  Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$;
var $n_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$;
function $m_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$)) {
    $n_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$ = new $c_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$()
  };
  return $n_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_Listenable$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_Listenable$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_Listenable$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_Listenable$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_Listenable$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_Listenable$.prototype = $c_Ljapgolly_scalajs_react_extra_Listenable$.prototype;
$c_Ljapgolly_scalajs_react_extra_Listenable$.prototype.listenToUnit__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1 = (function(listenable, makeListener, evidence$4) {
  var makeListener$1 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      $as_jl_Void(x$4$2);
      return $n(makeListener).apply__O__O(\u03b4)
    }))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_ListenableF$();
  var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return $n($$x1).listen__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(listenable, makeListener$1, this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync, evidence$4)
});
var $d_Ljapgolly_scalajs_react_extra_Listenable$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_Listenable$: 0
}, false, "japgolly.scalajs.react.extra.Listenable$", {
  Ljapgolly_scalajs_react_extra_Listenable$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_Listenable$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_Listenable$;
var $n_Ljapgolly_scalajs_react_extra_Listenable$;
function $m_Ljapgolly_scalajs_react_extra_Listenable$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_Listenable$)) {
    $n_Ljapgolly_scalajs_react_extra_Listenable$ = new $c_Ljapgolly_scalajs_react_extra_Listenable$()
  };
  return $n_Ljapgolly_scalajs_react_extra_Listenable$
}
function $f_Ljapgolly_scalajs_react_extra_ListenableF__registerF__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, listener, G) {
  var this$1 = $n($thiz.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync());
  var listener$1 = $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatchFn1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(this$1, listener, G);
  return $f_Ljapgolly_scalajs_react_extra_BroadcasterF__register__F1__O($thiz, listener$1)
}
function $is_Ljapgolly_scalajs_react_extra_ListenableF(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_extra_ListenableF)))
}
function $as_Ljapgolly_scalajs_react_extra_ListenableF(obj) {
  return (($is_Ljapgolly_scalajs_react_extra_ListenableF(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.ListenableF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_ListenableF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_ListenableF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_ListenableF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_ListenableF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.ListenableF;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_ListenableF$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_ListenableF$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_ListenableF$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_ListenableF$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_ListenableF$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_ListenableF$.prototype = $c_Ljapgolly_scalajs_react_extra_ListenableF$.prototype;
$c_Ljapgolly_scalajs_react_extra_ListenableF$.prototype.listen__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1 = (function(listenable, makeListener, F, G) {
  return $n($m_Ljapgolly_scalajs_react_extra_OnUnmountF$().install__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(F)).andThen__F1__F1(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(x$1$2);
    var this$5 = $n(x$1);
    var f$2 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
      var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$2);
      var this$2 = $n(\u03b4);
      var this$3 = $n($as_Ljapgolly_scalajs_react_extra_ListenableF($n(listenable).apply__O__O($n(this$2.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())));
      var listener = new $c_sjsr_AnonFunction1(((a$2) => $n($as_F1($n(makeListener).apply__O__O(\u03b4))).apply__O__O(a$2)));
      var f = $f_Ljapgolly_scalajs_react_extra_ListenableF__registerF__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$3, listener, G);
      return $n(F).flatMap__O__F1__O(f, new $c_sjsr_AnonFunction1(((x$2$2) => {
        var this$4 = $n($as_Ljapgolly_scalajs_react_extra_OnUnmountF($n(\u03b4).backend__O()));
        var f$1 = new $c_sjsr_AnonFunction0((() => x$2$2));
        return $f_Ljapgolly_scalajs_react_extra_OnUnmountF__onUnmount__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$4, f$1, F)
      })))
    }));
    return $p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$5, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$2, F)
  })))
});
$c_Ljapgolly_scalajs_react_extra_ListenableF$.prototype.listenToUnit__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1 = (function(listenable, makeListener, evidence$1, evidence$2) {
  return this.listen__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(listenable, new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      $as_jl_Void(x$3$2);
      return $n(makeListener).apply__O__O(\u03b4)
    }))
  })), evidence$1, evidence$2)
});
var $d_Ljapgolly_scalajs_react_extra_ListenableF$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_ListenableF$: 0
}, false, "japgolly.scalajs.react.extra.ListenableF$", {
  Ljapgolly_scalajs_react_extra_ListenableF$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_ListenableF$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_ListenableF$;
var $n_Ljapgolly_scalajs_react_extra_ListenableF$;
function $m_Ljapgolly_scalajs_react_extra_ListenableF$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_ListenableF$)) {
    $n_Ljapgolly_scalajs_react_extra_ListenableF$ = new $c_Ljapgolly_scalajs_react_extra_ListenableF$()
  };
  return $n_Ljapgolly_scalajs_react_extra_ListenableF$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_OnUnmount$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_OnUnmount$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_OnUnmount$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_OnUnmount$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_OnUnmount$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_OnUnmount$.prototype = $c_Ljapgolly_scalajs_react_extra_OnUnmount$.prototype;
$c_Ljapgolly_scalajs_react_extra_OnUnmount$.prototype.install__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(x$3$2);
    var this$4 = $n(x$3);
    var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(x$4$2);
      var this$2 = $n($as_Ljapgolly_scalajs_react_extra_OnUnmountF($n(x$4).backend__O()));
      return $f_Ljapgolly_scalajs_react_extra_OnUnmountF__unmount__O(this$2)
    }));
    var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    return $p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$4, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillUnmount__Ljapgolly_scalajs_react_internal_Lens(), f, G)
  }))
});
var $d_Ljapgolly_scalajs_react_extra_OnUnmount$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_OnUnmount$: 0
}, false, "japgolly.scalajs.react.extra.OnUnmount$", {
  Ljapgolly_scalajs_react_extra_OnUnmount$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_OnUnmount$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_OnUnmount$;
var $n_Ljapgolly_scalajs_react_extra_OnUnmount$;
function $m_Ljapgolly_scalajs_react_extra_OnUnmount$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_OnUnmount$)) {
    $n_Ljapgolly_scalajs_react_extra_OnUnmount$ = new $c_Ljapgolly_scalajs_react_extra_OnUnmount$()
  };
  return $n_Ljapgolly_scalajs_react_extra_OnUnmount$
}
function $f_Ljapgolly_scalajs_react_extra_OnUnmountF__unmount__O($thiz) {
  $n($thiz.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync());
  $n($thiz.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync());
  var fas = new $c_sjsr_AnonFunction0((() => $thiz.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List()));
  var this$3 = $m_Ljapgolly_scalajs_react_callback_Callback$();
  var this$4 = $m_Ljapgolly_scalajs_react_util_Util$();
  var fa = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.traverse__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(fas, this$4.Ljapgolly_scalajs_react_util_Util$__f_identity));
  $n($thiz.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync());
  var a = new $c_sjsr_AnonFunction0((() => {
    $thiz.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V($m_s_package$().s_package$__f_Nil)
  }));
  var fb = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)));
  var fa$1 = fa.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var fb$1 = fb.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, fb$1))
}
function $f_Ljapgolly_scalajs_react_extra_OnUnmountF__onUnmount__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, f, G) {
  $n($thiz.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync());
  var a = new $c_sjsr_AnonFunction0((() => {
    var this$3 = $n($thiz.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List());
    var this$2 = $n($thiz.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync());
    var elem = $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatch__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$2, f, G);
    $thiz.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V(new $c_sci_$colon$colon(elem, this$3))
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
}
function $is_Ljapgolly_scalajs_react_extra_OnUnmountF(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_extra_OnUnmountF)))
}
function $as_Ljapgolly_scalajs_react_extra_OnUnmountF(obj) {
  return (($is_Ljapgolly_scalajs_react_extra_OnUnmountF(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.OnUnmountF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_OnUnmountF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_OnUnmountF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_OnUnmountF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_OnUnmountF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.OnUnmountF;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_OnUnmountF$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_OnUnmountF$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_OnUnmountF$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_OnUnmountF$.prototype = $c_Ljapgolly_scalajs_react_extra_OnUnmountF$.prototype;
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$.prototype.install__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1 = (function(evidence$1) {
  return new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(x$1$2);
    var this$3 = $n(x$1);
    var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(x$2$2);
      var this$2 = $n($as_Ljapgolly_scalajs_react_extra_OnUnmountF($n(x$2).backend__O()));
      return $f_Ljapgolly_scalajs_react_extra_OnUnmountF__unmount__O(this$2)
    }));
    return $p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$3, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillUnmount__Ljapgolly_scalajs_react_internal_Lens(), f, evidence$1)
  }))
});
var $d_Ljapgolly_scalajs_react_extra_OnUnmountF$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_OnUnmountF$: 0
}, false, "japgolly.scalajs.react.extra.OnUnmountF$", {
  Ljapgolly_scalajs_react_extra_OnUnmountF$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_OnUnmountF$;
var $n_Ljapgolly_scalajs_react_extra_OnUnmountF$;
function $m_Ljapgolly_scalajs_react_extra_OnUnmountF$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_OnUnmountF$)) {
    $n_Ljapgolly_scalajs_react_extra_OnUnmountF$ = new $c_Ljapgolly_scalajs_react_extra_OnUnmountF$()
  };
  return $n_Ljapgolly_scalajs_react_extra_OnUnmountF$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_StateSnapshotF$() {
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF$__f_reusabilityInstance = null;
  $n_Ljapgolly_scalajs_react_extra_StateSnapshotF$ = this;
  var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2());
  var f = e.Ljapgolly_scalajs_react_Reusability__f_test;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$2);
    var y = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(y$2);
    return ((x === y) || (($uZ($n(f).apply__O__O__O($n(x).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn, $n(y).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn)) && $uZ($n($n(x).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_reusability).apply__O__O__O($n(x).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, $n(y).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))) && $uZ($n($n(y).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_reusability).apply__O__O__O($n(x).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, $n(y).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))))
  }));
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF$__f_reusabilityInstance = f$1
}
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_StateSnapshotF$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_StateSnapshotF$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_StateSnapshotF$.prototype = $c_Ljapgolly_scalajs_react_extra_StateSnapshotF$.prototype;
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF$.prototype.reusability__F2 = (function() {
  var ev$1 = new $c_Ljapgolly_scalajs_react_Reusability(this.Ljapgolly_scalajs_react_extra_StateSnapshotF$__f_reusabilityInstance);
  return ev$1.Ljapgolly_scalajs_react_Reusability__f_test
});
var $d_Ljapgolly_scalajs_react_extra_StateSnapshotF$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_StateSnapshotF$: 0
}, false, "japgolly.scalajs.react.extra.StateSnapshotF$", {
  Ljapgolly_scalajs_react_extra_StateSnapshotF$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_StateSnapshotF$;
var $n_Ljapgolly_scalajs_react_extra_StateSnapshotF$;
function $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_StateSnapshotF$)) {
    $n_Ljapgolly_scalajs_react_extra_StateSnapshotF$ = new $c_Ljapgolly_scalajs_react_extra_StateSnapshotF$()
  };
  return $n_Ljapgolly_scalajs_react_extra_StateSnapshotF$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$.prototype = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$.prototype;
var $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$: 0
}, false, "japgolly.scalajs.react.extra.internal.StateSnapshot$", {
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$;
var $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$;
function $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$)) {
    $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$ = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()
  };
  return $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$
}
function $ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__($thiz, api) {
  $thiz.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__f_api = api;
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary() {
  this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__f_api = null
}
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary.prototype = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary.prototype;
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary.prototype.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(initialState, step) {
  return this.useStateSnapshotBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((x$14$2) => $n(initialState).apply__O())), step)
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary.prototype.useStateSnapshotBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(initialState, step) {
  var this$4 = $n(this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__f_api);
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => {
    var initialValue = new $c_sjsr_AnonFunction0((() => $n(initialState).apply__O__O(ctx$2)));
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$().hook__F0__F2__F1(initialValue, $m_Ljapgolly_scalajs_react_Reusability$().never__F2()))
  }));
  var this$3 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$3);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$4, hook, step, d)
});
var $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary: 0
}, false, "japgolly.scalajs.react.extra.internal.StateSnapshot$HooksApiExt$Primary", {
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$.prototype = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$.prototype;
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$.prototype.hook__F0__F2__F1 = (function(initialValue, rs) {
  var this$2 = $n($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$6 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$2, initialValue, step)));
  var initialValue$1 = new $c_sjsr_AnonFunction0((() => {
    $n($m_s_package$().s_package$__f_List);
    return $m_sci_Nil$()
  }));
  var this$5 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$5);
  var this$16 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRef__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$6, initialValue$1, step$1)));
  var init = new $c_sjsr_AnonFunction3(((x$2$2, x$3$2, delayedCallbacks$2) => {
    $as_jl_Void(x$2$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$3$2);
    var delayedCallbacks = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(delayedCallbacks$2);
    var this$7 = $n(delayedCallbacks);
    var cbs = $as_sci_List(this$7.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current);
    if ($n(cbs).isEmpty__Z()) {
      var this$8 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$9 = $n(this$8.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$9.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    } else {
      var this$10 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$10.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var this$11 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$11.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var fa = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_Callback$().runAll__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline(cbs));
      var fb = $n(delayedCallbacks).set__O__O($m_s_package$().s_package$__f_Nil);
      var fa$1 = fa.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var fb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fb)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, fb$1))
    }
  }));
  var $$x6 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$();
  var this$14 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var a = $n($$x6).unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(this$14.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
  var this$15 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$15);
  var $$x5 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$16, init, a, step$2)));
  var $$x1 = new $c_sjsr_AnonFunction3(((x$4$2, state$2, delayedCallbacks$3$2) => {
    $as_jl_Void(x$4$2);
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    var delayedCallbacks$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(delayedCallbacks$3$2);
    var setFn = new $c_sjsr_AnonFunction2(((os$2, cb$2) => {
      var os = $as_s_Option(os$2);
      if ((os instanceof $c_s_Some)) {
        var x2 = $as_s_Some(os);
        var s = $n(x2).s_Some__f_value;
        $m_Ljapgolly_scalajs_react_Reusable$();
        var this$17 = $n(state);
        var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$17);
        var updateState = $n($as_F1($n(r).value__O())).apply__O__O(s);
        var this$19 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        $n(this$19.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
        var f = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ($m_Ljapgolly_scalajs_react_callback_CallbackTo$().isEmpty_$qmark$extension__Ljapgolly_scalajs_react_callback_Trampoline__Z(f)) {
          return updateState
        } else {
          var this$21 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          $n(this$21.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
          var this$23 = $n(delayedCallbacks$3);
          var f$1 = new $c_sjsr_AnonFunction1(((x$5$2) => {
            var x$5 = $as_sci_List(x$5$2);
            var this$22 = $n(x$5);
            return new $c_sci_$colon$colon(cb$2, this$22)
          }));
          var fa$2 = $f_Ljapgolly_scalajs_react_NonEmptyRef$FullF__mod__F1__O(this$23, f$1);
          var fa$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var fb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(updateState)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$3, fb$2))
        }
      } else {
        var x = $m_s_None$();
        if ((x === os)) {
          return cb$2
        } else {
          throw new $c_s_MatchError(os)
        }
      }
    }));
    var this$25 = $n(state);
    var $$x4 = this$25.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var $$x3 = $n($n(state).Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_originalSetState).withValue__O__Ljapgolly_scalajs_react_Reusable(setFn);
    var this$26 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var $$x2 = this$26.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var this$27 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return new $c_Ljapgolly_scalajs_react_extra_StateSnapshotF($$x4, $$x3, rs, $$x2, this$27.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)
  }));
  var this$28 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x5).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$28))
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$.prototype.prepareVia__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_Reusable = (function(i, t) {
  var this$1 = $n(t);
  var $$x1 = $as_Ljapgolly_scalajs_react_StateAccess$Write($n(this$1.Ljapgolly_scalajs_react_StateAccessor$$anon$3__f_write).apply__O__O(i));
  var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var w = $as_Ljapgolly_scalajs_react_StateAccess$Write($n($$x1).withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync));
  var f = new $c_sjsr_AnonFunction2(((x$6$2, x$7$2) => {
    var x$6 = $as_s_Option(x$6$2);
    var $$x3 = $n(w);
    var $$x2 = new $c_sjsr_AnonFunction0((() => x$7$2));
    var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return $n($$x3).setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(x$6, $$x2, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
  }));
  return $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f)
});
var $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$: 0
}, false, "japgolly.scalajs.react.extra.internal.StateSnapshot$withReuse$", {
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$;
var $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$;
function $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$)) {
    $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$ = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$()
  };
  return $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$.prototype = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$.prototype;
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$.prototype.prepare$extension__Ljapgolly_scalajs_react_internal_Lens__F2__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn = (function(this$, modify) {
  var f = new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
    var ot = $as_s_Option(ot$2);
    return $n(modify).apply__O__O__O($n(this$).setO__s_Option__F1(ot), cb$2)
  }));
  return new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn(this$, $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f))
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$.prototype.prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn = (function(this$, i, t) {
  var this$1 = $n(t);
  var $$x1 = $as_Ljapgolly_scalajs_react_StateAccess$Write($n(this$1.Ljapgolly_scalajs_react_StateAccessor$$anon$3__f_write).apply__O__O(i));
  var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var w = $as_Ljapgolly_scalajs_react_StateAccess$Write($n($$x1).withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync));
  return $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$().prepare$extension__Ljapgolly_scalajs_react_internal_Lens__F2__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn(this$, new $c_sjsr_AnonFunction2(((x$8$2, x$9$2) => {
    var x$8 = $as_F1(x$8$2);
    var $$x3 = $n(w);
    var $$x2 = new $c_sjsr_AnonFunction0((() => x$9$2));
    var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return $n($$x3).modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(x$8, $$x2, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
  })))
});
var $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$: 0
}, false, "japgolly.scalajs.react.extra.internal.StateSnapshot$withReuse$FromLens$", {
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$;
var $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$;
function $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$)) {
    $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$ = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$()
  };
  return $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn(l, set) {
  this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn__f_l = null;
  this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn__f_set = null;
  this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn__f_l = l;
  this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn__f_set = set
}
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn.prototype = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn.prototype;
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn.prototype.apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF = (function(value, r) {
  var value$1 = $n($n(this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn__f_l).Ljapgolly_scalajs_react_internal_Lens__f_get).apply__O__O(value);
  var set = this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn__f_set;
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var $$x1 = this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return new $c_Ljapgolly_scalajs_react_extra_StateSnapshotF(value$1, set, r, $$x1, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)
});
var $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn: 0
}, false, "japgolly.scalajs.react.extra.internal.StateSnapshot$withReuse$FromLensSetStateFn", {
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn(set) {
  this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn__f_japgolly$scalajs$react$extra$internal$StateSnapshot$withReuse$FromSetStateFn$$set = null;
  this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn__f_japgolly$scalajs$react$extra$internal$StateSnapshot$withReuse$FromSetStateFn$$set = set
}
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn.prototype = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn.prototype;
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn.prototype.hashCode__I = (function() {
  var this$ = this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn__f_japgolly$scalajs$react$extra$internal$StateSnapshot$withReuse$FromSetStateFn$$set;
  var this$2 = $n(this$);
  var x = this$2.value__O();
  return $m_sr_Statics$().anyHash__O__I(x)
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$().equals$extension__Ljapgolly_scalajs_react_Reusable__O__Z(this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn__f_japgolly$scalajs$react$extra$internal$StateSnapshot$withReuse$FromSetStateFn$$set, x$1)
});
function $as_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.internal.StateSnapshot$withReuse$FromSetStateFn"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.internal.StateSnapshot$withReuse$FromSetStateFn;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn: 0
}, false, "japgolly.scalajs.react.extra.internal.StateSnapshot$withReuse$FromSetStateFn", {
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$.prototype = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$.prototype;
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$.prototype.apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF = (function(this$, value, r) {
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var $$x1 = this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return new $c_Ljapgolly_scalajs_react_extra_StateSnapshotF(value, this$, r, $$x1, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$.prototype.equals$extension__Ljapgolly_scalajs_react_Reusable__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn)) {
    var FromSetStateFn$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn(x$1)).Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn__f_japgolly$scalajs$react$extra$internal$StateSnapshot$withReuse$FromSetStateFn$$set);
    if ((this$ === null)) {
      return (FromSetStateFn$1 === null)
    } else {
      var this$1 = $n(this$);
      return (this$1 === FromSetStateFn$1)
    }
  } else {
    return false
  }
});
var $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$: 0
}, false, "japgolly.scalajs.react.extra.internal.StateSnapshot$withReuse$FromSetStateFn$", {
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$;
var $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$;
function $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$)) {
    $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$ = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$()
  };
  return $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$.prototype = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$.prototype;
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$.prototype.apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF = (function(this$, set) {
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(set);
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$().never__F2();
  var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var $$x1 = this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return new $c_Ljapgolly_scalajs_react_extra_StateSnapshotF(this$, $$x3, $$x2, $$x1, this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async)
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$.prototype.setStateVia$extension__O__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_StateSnapshotF = (function(this$, i, t) {
  return $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$, new $c_sjsr_AnonFunction2(((x$10$2, x$11$2) => {
    var x$10 = $as_s_Option(x$10$2);
    var this$2 = $n(t);
    var $$x2 = $n($as_Ljapgolly_scalajs_react_StateAccess$Write($n(this$2.Ljapgolly_scalajs_react_StateAccessor$$anon$3__f_write).apply__O__O(i)));
    var $$x1 = new $c_sjsr_AnonFunction0((() => x$11$2));
    var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return $n($$x2).setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(x$10, $$x1, this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
  })))
});
var $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$: 0
}, false, "japgolly.scalajs.react.extra.internal.StateSnapshot$withoutReuse$FromValue$", {
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$;
var $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$;
function $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$)) {
    $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$ = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$()
  };
  return $n_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_PathLike() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_PathLike.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_PathLike.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_PathLike;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_PathLike() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_PathLike.prototype = $c_Ljapgolly_scalajs_react_extra_router_PathLike.prototype;
$c_Ljapgolly_scalajs_react_extra_router_PathLike.prototype.$plus__T__Ljapgolly_scalajs_react_extra_router_PathLike = (function(p) {
  var arg1 = this.str__Ljapgolly_scalajs_react_extra_router_PathLike__T(this);
  return this.make__T__Ljapgolly_scalajs_react_extra_router_PathLike((("" + arg1) + p))
});
$c_Ljapgolly_scalajs_react_extra_router_PathLike.prototype.$div__Ljapgolly_scalajs_react_extra_router_PathLike__Ljapgolly_scalajs_react_extra_router_PathLike = (function(p) {
  var p$1 = this.str__Ljapgolly_scalajs_react_extra_router_PathLike__T(p);
  return $n(this.endWith_$div__Ljapgolly_scalajs_react_extra_router_PathLike()).$plus__T__Ljapgolly_scalajs_react_extra_router_PathLike(p$1)
});
$c_Ljapgolly_scalajs_react_extra_router_PathLike.prototype.endWith_$div__Ljapgolly_scalajs_react_extra_router_PathLike = (function() {
  var arg1 = this.str__Ljapgolly_scalajs_react_extra_router_PathLike__T(this);
  return this.make__T__Ljapgolly_scalajs_react_extra_router_PathLike($f_T__replaceFirst__T__T__T($n(arg1), "/*$", "/"))
});
$c_Ljapgolly_scalajs_react_extra_router_PathLike.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.str__Ljapgolly_scalajs_react_extra_router_PathLike__T(this));
  return (this$1 === "")
});
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouteCmd() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouteCmd() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouteCmd.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd.prototype.$greater$greater__Ljapgolly_scalajs_react_extra_router_RouteCmd__Ljapgolly_scalajs_react_extra_router_RouteCmd = (function(next) {
  if ((this instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence)) {
    var x2 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence(this);
    var x = $n(x2).Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_init;
    var y = $n(x2).Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_last;
    var this$1 = $n(x);
    var init = $as_sci_Vector(this$1.appended__O__O(y))
  } else {
    $n($m_s_package$().s_package$__f_Vector);
    var this$3 = $m_sci_Vector0$();
    var init = this$3.appended__O__sci_Vector(this)
  };
  return new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence(init, next)
});
function $as_Ljapgolly_scalajs_react_extra_router_RouteCmd(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouteCmd"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouteCmd)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouteCmd;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouteCmd$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouteCmd$.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$.prototype.setRoute__Ljapgolly_scalajs_react_extra_router_AbsUrl__Ljapgolly_scalajs_react_extra_router_SetRouteVia__Ljapgolly_scalajs_react_extra_router_RouteCmd = (function(url, via) {
  var x = $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$();
  if ((x === via)) {
    return new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState(url)
  } else {
    var x$3 = $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$();
    if ((x$3 === via)) {
      return new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState(url)
    } else {
      var x$5 = $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$();
      if ((x$5 === via)) {
        return new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation(url)
      } else {
        throw new $c_s_MatchError(via)
      }
    }
  }
});
var $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouteCmd$: 0
}, false, "japgolly.scalajs.react.extra.router.RouteCmd$", {
  Ljapgolly_scalajs_react_extra_router_RouteCmd$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$;
var $n_Ljapgolly_scalajs_react_extra_router_RouteCmd$;
function $m_Ljapgolly_scalajs_react_extra_router_RouteCmd$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_RouteCmd$)) {
    $n_Ljapgolly_scalajs_react_extra_router_RouteCmd$ = new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_RouteCmd$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterConfig$() {
  this.Ljapgolly_scalajs_react_extra_router_RouterConfig$__f_nopLogger = null;
  $n_Ljapgolly_scalajs_react_extra_router_RouterConfig$ = this;
  var f = (() => {
    $m_Ljapgolly_scalajs_react_extra_router_RouterConfig$()
  });
  this.Ljapgolly_scalajs_react_extra_router_RouterConfig$__f_nopLogger = new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_F0(x$1$2);
    return f
  }))
}
$c_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterConfig$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterConfig$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype.consoleLogger__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_F0(s$2);
    return (() => {
      $m_Ljapgolly_scalajs_react_extra_router_RouterConfig$().japgolly$scalajs$react$extra$router$RouterConfig$$$anonfun$consoleLogger$2__F0__V(s)
    })
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype.defaultRenderFn__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((x$2$2, r$2) => {
    $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(x$2$2);
    var r = $as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(r$2);
    return $n(r).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_renderP
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype.defaultPostRenderFn__Ljapgolly_scalajs_react_util_Effect$Sync__F3 = (function(F) {
  $n(F);
  var a = new $c_sjsr_AnonFunction0((() => {
    window.scrollTo(0, 0)
  }));
  var cb = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)));
  return new $c_sjsr_AnonFunction3(((x$3$2, x$4$2, x$5$2) => {
    $as_s_Option(x$3$2);
    return cb
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype.withDefaults__Ljapgolly_scalajs_react_extra_router_RoutingRulesF__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = (function(rules, evidence$1) {
  return new $c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(rules, this.defaultRenderFn__F2(), this.defaultPostRenderFn__Ljapgolly_scalajs_react_util_Effect$Sync__F3(evidence$1), this.Ljapgolly_scalajs_react_extra_router_RouterConfig$__f_nopLogger, evidence$1)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype.japgolly$scalajs$react$extra$router$RouterConfig$$$anonfun$consoleLogger$2__F0__V = (function(s$1) {
  var x = ("[Router] " + $n(s$1).apply__O());
  var this$2 = $m_s_Console$();
  var this$3 = $n(this$2.out__Ljava_io_PrintStream());
  this$3.java$lang$JSConsoleBasedPrintStream$$printString__T__V((x + "\n"))
});
var $d_Ljapgolly_scalajs_react_extra_router_RouterConfig$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterConfig$: 0
}, false, "japgolly.scalajs.react.extra.router.RouterConfig$", {
  Ljapgolly_scalajs_react_extra_router_RouterConfig$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfig$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterConfig$;
var $n_Ljapgolly_scalajs_react_extra_router_RouterConfig$;
function $m_Ljapgolly_scalajs_react_extra_router_RouterConfig$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_RouterConfig$)) {
    $n_Ljapgolly_scalajs_react_extra_router_RouterConfig$ = new $c_Ljapgolly_scalajs_react_extra_router_RouterConfig$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_RouterConfig$
}
function $p_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl___\uff3fstring1__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($thiz, regex) {
  var $$x1 = new $c_sjsr_AnonFunction1(((g$2) => {
    var g = $as_F1(g$2);
    return new $c_s_Some($n(g).apply__O__O(0))
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_util_Util$();
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(regex, 1, $$x1, this$2.Ljapgolly_scalajs_react_util_Util$__f_identity)
}
function $p_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__onPage$1__F1__O__F1__s_Option($thiz, f, page, op$1) {
  var this$1 = $n($as_s_Option($n(op$1).apply__O__O(page)));
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl() {
  this.Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__f_int = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__f_uuid = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__f_int = new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("(-?\\d+)", 1, new $c_sjsr_AnonFunction1(((g$2) => {
    var g = $as_F1(g$2);
    $m_sc_StringOps$();
    var x = $as_T($n(g).apply__O__O(0));
    var this$4 = $m_jl_Integer$();
    return new $c_s_Some(this$4.parseInt__T__I__I(x, 10))
  })), new $c_sjsr_AnonFunction1(((x$44$2) => {
    var x$44 = $uI(x$44$2);
    return ("" + x$44)
  })));
  new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("(-?\\d+)", 1, new $c_sjsr_AnonFunction1(((g$3$2) => {
    var g$3 = $as_F1(g$3$2);
    $m_sc_StringOps$();
    var x$1 = $as_T($n(g$3).apply__O__O(0));
    var this$8 = $m_jl_Long$();
    return new $c_s_Some(this$8.parseLong__T__I__J(x$1, 10))
  })), new $c_sjsr_AnonFunction1(((x$45$2) => {
    var t = $uJ(x$45$2);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi)
  })));
  this.Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__f_uuid = new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("([A-Fa-f0-9]{8}(?:-[A-Fa-f0-9]{4}){3}-[A-Fa-f0-9]{12})", 1, new $c_sjsr_AnonFunction1(((g$4$2) => {
    var g$4 = $as_F1(g$4$2);
    var name = $as_T($n(g$4).apply__O__O(0));
    return new $c_s_Some($m_ju_UUID$().fromString__T__ju_UUID(name))
  })), new $c_sjsr_AnonFunction1(((x$46$2) => {
    var x$46 = $as_ju_UUID(x$46$2);
    return $n(x$46).toString__T()
  })))
}
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.string__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB = (function(regex) {
  return $p_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl___\uff3fstring1__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this, (("(" + regex) + ")"))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route = (function(r, ev) {
  return $n($as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n(ev).apply__O__O(r))).route__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route()
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.render__F0__F1__Ljapgolly_scalajs_react_extra_router_RendererF = (function(a, ev) {
  var $$x1 = new $c_sjsr_AnonFunction1(((x$47$2) => {
    $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(x$47$2);
    return new $c_sjsr_AnonFunction1(((x$48$2) => $as_Ljapgolly_scalajs_react_vdom_VdomElement($n(ev).apply__O__O($n(a).apply__O()))))
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return new $c_Ljapgolly_scalajs_react_extra_router_RendererF($$x1, this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.renderRP__F2__F1__Ljapgolly_scalajs_react_extra_router_RendererF = (function(g, ev) {
  var $$x1 = new $c_sjsr_AnonFunction1(((r$2) => {
    var r = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(r$2);
    return new $c_sjsr_AnonFunction1(((props$2) => $as_Ljapgolly_scalajs_react_vdom_VdomElement($n(ev).apply__O__O($n(g).apply__O__O__O(r, props$2)))))
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return new $c_Ljapgolly_scalajs_react_extra_router_RendererF($$x1, this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.dynRender__F1__F1__F1 = (function(g, ev) {
  return new $c_sjsr_AnonFunction1(((p$2) => {
    var $$x1 = new $c_sjsr_AnonFunction1(((x$51$2) => {
      $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(x$51$2);
      return new $c_sjsr_AnonFunction1(((x$52$2) => $as_Ljapgolly_scalajs_react_vdom_VdomElement($n(ev).apply__O__O($n(g).apply__O__O(p$2)))))
    }));
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return new $c_Ljapgolly_scalajs_react_extra_router_RendererF($$x1, this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.dynRenderRP__F3__F1__F1 = (function(g, ev) {
  return new $c_sjsr_AnonFunction1(((p$2) => {
    var $$x1 = new $c_sjsr_AnonFunction1(((r$2) => {
      var r = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(r$2);
      return new $c_sjsr_AnonFunction1(((props$2) => $as_Ljapgolly_scalajs_react_vdom_VdomElement($n(ev).apply__O__O($n(g).apply__O__O__O__O(p$2, r, props$2)))))
    }));
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return new $c_Ljapgolly_scalajs_react_extra_router_RendererF($$x1, this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype._auto_notFound_from_parsed__O__F1__F1 = (function(a, ev) {
  return new $c_sjsr_AnonFunction1(((x$55$2) => {
    $as_Ljapgolly_scalajs_react_extra_router_Path(x$55$2);
    return $as_s_util_Either($n(ev).apply__O__O(a))
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype._auto_pToAction_from_action__F0__F1 = (function(a) {
  return new $c_sjsr_AnonFunction1(((x$59$2) => $as_Ljapgolly_scalajs_react_extra_router_ActionF($n(a).apply__O())))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.staticRoute__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__O__F1 = (function(r, page) {
  var r$1 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($n(r).const__O__O__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(page, (void 0)));
  var pf = new $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1(this, page);
  var dyn = this.dynamicRouteF__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__F1__F1(r$1, new $c_s_PartialFunction$Lifted(pf));
  return new $c_sjsr_AnonFunction1(((a$2) => {
    var a = $as_F0(a$2);
    var g = this._auto_pToAction_from_action__F0__F1(a);
    return $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(dyn).apply__O__O(g))
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.dynamicRouteF__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__F1__F1 = (function(r, op) {
  return new $c_sjsr_AnonFunction1(((a$2) => {
    var a = $as_F1(a$2);
    var $$x1 = new $c_sjsr_AnonFunction1(((path$2) => {
      var path = $as_Ljapgolly_scalajs_react_extra_router_Path(path$2);
      var o = $n(r).parse__Ljapgolly_scalajs_react_extra_router_Path__s_Option(path);
      var this$2 = $n(o);
      if (this$2.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1 = this$2.get__O();
        $n($m_s_package$().s_package$__f_Right);
        return new $c_s_Some(new $c_s_util_Right(arg1))
      }
    }));
    var eta$0$1 = new $c_sjsr_AnonFunction1(((a$2$2) => $n(r).pathFor__O__Ljapgolly_scalajs_react_extra_router_Path(a$2$2)));
    return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom($$x1, new $c_sjsr_AnonFunction1(((page$2) => $p_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__onPage$1__F1__O__F1__s_Option(this, eta$0$1, page$2, op))), new $c_sjsr_AnonFunction2(((x$60$2, p$2) => {
      $as_Ljapgolly_scalajs_react_extra_router_Path(x$60$2);
      return $p_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__onPage$1__F1__O__F1__s_Option(this, a, p$2, op)
    })))
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1 = (function(r, ct) {
  return this.dynamicRouteF__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__F1__F1(r, new $c_sjsr_AnonFunction1(((x$2) => $n(ct).unapply__O__s_Option(x$2))))
});
function $as_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouterConfigDsl"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouterConfigDsl)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouterConfigDsl;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterConfigDsl: 0
}, false, "japgolly.scalajs.react.extra.router.RouterConfigDsl", {
  Ljapgolly_scalajs_react_extra_router_RouterConfigDsl: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface.prototype;
var $d_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface: 0
}, false, "japgolly.scalajs.react.extra.router.RouterConfigDsl$BuildInterface", {
  Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterCtlF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RouterCtlF = (function(G) {
  var this$1 = $n(G);
  var g = this.F__Ljapgolly_scalajs_react_util_Effect$Sync();
  return $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(((this$1 === g) ? this : new $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect(this, G)))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype.urlFor__O__Ljapgolly_scalajs_react_extra_router_AbsUrl = (function(route) {
  var this$1 = $n(this.pathFor__O__Ljapgolly_scalajs_react_extra_router_Path(route));
  var base = this.baseUrl__Ljapgolly_scalajs_react_extra_router_BaseUrl();
  return $n(base).apply__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_AbsUrl(this$1)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype.setEH__O__F1 = (function(route) {
  return new $c_sjsr_AnonFunction1(((e$2) => $m_Ljapgolly_scalajs_react_internal_EffectUtil$().asEventDefault___Ljapgolly_scalajs_react_facade_SyntheticEvent__F0__Ljapgolly_scalajs_react_util_Effect$Sync__O(e$2, new $c_sjsr_AnonFunction0((() => this.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))), this.F__Ljapgolly_scalajs_react_util_Effect$Sync())))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype.onLinkClick__O__F1 = (function(route) {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    var cond = $m_Ljapgolly_scalajs_react_ReactMouseEvent$().targetsNewTab_$qmark__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Z(e$2);
    var cond$1 = (!cond);
    return (cond$1 ? new $c_s_Some($n(this.setEH__O__F1(route)).apply__O__O(e$2)) : $m_s_None$())
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype.setOnLinkClick__O__Ljapgolly_scalajs_react_vdom_TagMod = (function(route) {
  var $$x2 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick);
  var $$x1 = $n(this.onLinkClick__O__F1(route)).andThen__F1__F1(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_s_Option(x$1$2);
    var this$2 = $n(x$1);
    if (this$2.isEmpty__Z()) {
      var this$3 = $n(this.F__Ljapgolly_scalajs_react_util_Effect$Sync());
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    } else {
      return this$2.get__O()
    }
  })));
  var this$4 = $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$();
  var F = this.F__Ljapgolly_scalajs_react_util_Effect$Sync();
  return $n($$x2).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod($$x1, $f_Ljapgolly_scalajs_react_vdom_Attr$EventCallback2__dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(this$4, F))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF.prototype.link__O__Ljapgolly_scalajs_react_vdom_TagOf = (function(route) {
  var $$x1 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$());
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$3 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
  var a = $n(this.urlFor__O__Ljapgolly_scalajs_react_extra_router_AbsUrl(route)).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value;
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$3.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a), this.setOnLinkClick__O__Ljapgolly_scalajs_react_vdom_TagMod(route)];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
function $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouterCtlF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterCtlF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouterCtlF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouterCtlF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterCtlF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouterCtlF;", depth))
}
function $p_Ljapgolly_scalajs_react_extra_router_RouterCtlF$__reuseF__F2($thiz) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(x$2);
    var y = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(y$2);
    return $p_Ljapgolly_scalajs_react_extra_router_RouterCtlF$__test$1__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Z($thiz, x, y)
  }));
  return f
}
function $p_Ljapgolly_scalajs_react_extra_router_RouterCtlF$__reuse$lzycompute__F2($thiz) {
  if ((!$thiz.Ljapgolly_scalajs_react_extra_router_RouterCtlF$__f_bitmap$0)) {
    $thiz.Ljapgolly_scalajs_react_extra_router_RouterCtlF$__f_reuse = $p_Ljapgolly_scalajs_react_extra_router_RouterCtlF$__reuseF__F2($thiz);
    $thiz.Ljapgolly_scalajs_react_extra_router_RouterCtlF$__f_bitmap$0 = true
  };
  return $thiz.Ljapgolly_scalajs_react_extra_router_RouterCtlF$__f_reuse
}
function $p_Ljapgolly_scalajs_react_extra_router_RouterCtlF$__reuse__F2($thiz) {
  return ((!$thiz.Ljapgolly_scalajs_react_extra_router_RouterCtlF$__f_bitmap$0) ? $p_Ljapgolly_scalajs_react_extra_router_RouterCtlF$__reuse$lzycompute__F2($thiz) : $thiz.Ljapgolly_scalajs_react_extra_router_RouterCtlF$__f_reuse)
}
function $p_Ljapgolly_scalajs_react_extra_router_RouterCtlF$__test$1__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Z($thiz, x, y) {
  while (true) {
    if ((x === y)) {
      return true
    } else {
      var _1 = x;
      var _2 = y;
      if ((_1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap)) {
        var x4 = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(_1);
        var ac = $n(x4).Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u;
        var af = $n(x4).Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_f;
        if ((_2 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap)) {
          var x5 = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(_2);
          var bc = $n(x5).Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u;
          var bf = $n(x5).Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_f;
          if ((af === bf)) {
            x = ac;
            y = bc;
            continue
          } else {
            return false
          }
        }
      };
      return false
    }
  }
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$() {
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$__f_reuse = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$__f_bitmap$0 = false
}
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterCtlF$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterCtlF$.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$.prototype.reusability__F2 = (function() {
  var ev$1 = new $c_Ljapgolly_scalajs_react_Reusability($p_Ljapgolly_scalajs_react_extra_router_RouterCtlF$__reuse__F2(this));
  return ev$1.Ljapgolly_scalajs_react_Reusability__f_test
});
var $d_Ljapgolly_scalajs_react_extra_router_RouterCtlF$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterCtlF$: 0
}, false, "japgolly.scalajs.react.extra.router.RouterCtlF$", {
  Ljapgolly_scalajs_react_extra_router_RouterCtlF$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterCtlF$;
var $n_Ljapgolly_scalajs_react_extra_router_RouterCtlF$;
function $m_Ljapgolly_scalajs_react_extra_router_RouterCtlF$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_RouterCtlF$)) {
    $n_Ljapgolly_scalajs_react_extra_router_RouterCtlF$ = new $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_RouterCtlF$
}
function $p_Ljapgolly_scalajs_react_extra_router_RouterWithProps$__isIE11__Z($thiz) {
  var this$1 = $n($as_T(window.navigator.userAgent));
  return ($uI(this$1.indexOf("Trident")) !== (-1))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterWithProps$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterWithProps$.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$.prototype.apply__Ljapgolly_scalajs_react_extra_router_BaseUrl__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(baseUrl, cfg) {
  return $n(this.componentUnbuilt__Ljapgolly_scalajs_react_extra_router_BaseUrl__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(baseUrl, cfg)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$.prototype.componentUnbuilt__Ljapgolly_scalajs_react_extra_router_BaseUrl__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep = (function(baseUrl, cfg) {
  return this.componentUnbuiltC__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__Ljapgolly_scalajs_react_extra_router_RouterLogicF__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(cfg, new $c_Ljapgolly_scalajs_react_extra_router_RouterLogicF(baseUrl, cfg))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$.prototype.componentUnbuiltC__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__Ljapgolly_scalajs_react_extra_router_RouterLogicF__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep = (function(cfg, lgc) {
  var EL = $ct_Ljapgolly_scalajs_react_extra_EventListenerF__(new $c_Ljapgolly_scalajs_react_extra_EventListenerF());
  var this$6 = $n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateCallback$extension__T__O__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Router", $n(lgc).Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_syncToWindowUrl, $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2$2) => {
    $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2$2);
    var F = $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect;
    return new $c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1(F)
  }))));
  var r = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(\u03b4$2);
    var $$x2 = $n(lgc);
    var this$4 = $n(\u03b4);
    var $$x1 = $as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4));
    var this$5 = $n(\u03b4);
    return $n($$x2).render__Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__O__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())
  }));
  var this$9 = $n(this$6.renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(r));
  var f = new $c_sjsr_AnonFunction1(((\u03b4$3$2) => {
    var \u03b4$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$3$2);
    var $$x5 = $n($n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn);
    var $$x4 = $m_s_None$();
    var this$7 = $n(\u03b4$3);
    var $$x3 = $n($as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$7))).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page;
    var this$8 = $n(\u03b4$3);
    return $n($$x5).apply__O__O__O__O($$x4, $$x3, $n(this$8.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())
  }));
  var G = $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect;
  var stabilizer$1 = $p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$9, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f, G);
  var this$16 = $n($n(stabilizer$1).componentDidUpdate__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((i$2) => {
    var i = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(i$2);
    var $$x8 = $n($n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn);
    var $$x7 = new $c_s_Some($n($as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps($n(i).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevState)).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page);
    var this$10 = $n(i);
    var $$x6 = $n($as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps($n(this$10.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O())).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page;
    var this$11 = $n(i);
    return $n($$x8).apply__O__O__O__O($$x7, $$x6, $n(this$11.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())
  })), $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect));
  var f$2 = $m_Ljapgolly_scalajs_react_extra_ListenableF$().listenToUnit__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(new $c_sjsr_AnonFunction1(((x$3$2) => lgc)), new $c_sjsr_AnonFunction1(((\u03b4$4$2) => {
    var \u03b4$4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$4$2);
    $n($n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var fa = $n(lgc).Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_syncToWindowUrl;
    var f$1 = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(s$2);
      var this$14 = $n($n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
      var ga = new $c_sjsr_AnonFunction0((() => {
        var this$12 = $n(\u03b4$4);
        return $f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$12, s)
      }));
      var this$13 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var g = this$13.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$14, ga, g)
    }));
    var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, f$1))
  })), $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect, $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var this$17 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$2).apply__O__O(this$16)));
  var f$3 = EL.install___T__O__F0__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1("popstate", $n($n(lgc).Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_ctl).refresh__O(), new $c_sjsr_AnonFunction0((() => window)), false, $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect, $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var this$18 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$3).apply__O__O(this$17)));
  var cond = $p_Ljapgolly_scalajs_react_extra_router_RouterWithProps$__isIE11__Z(this);
  var f$4 = new $c_sjsr_AnonFunction0((() => EL.install___T__O__F0__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1("hashchange", $n($n(lgc).Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_ctl).refresh__O(), new $c_sjsr_AnonFunction0((() => window)), false, $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect, $n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect)));
  if (cond) {
    var f$5 = $as_F1(f$4.apply__O());
    return $as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$5).apply__O__O(this$18))
  } else {
    return this$18
  }
});
var $d_Ljapgolly_scalajs_react_extra_router_RouterWithProps$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterWithProps$: 0
}, false, "japgolly.scalajs.react.extra.router.RouterWithProps$", {
  Ljapgolly_scalajs_react_extra_router_RouterWithProps$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterWithProps$;
var $n_Ljapgolly_scalajs_react_extra_router_RouterWithProps$;
function $m_Ljapgolly_scalajs_react_extra_router_RouterWithProps$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_RouterWithProps$)) {
    $n_Ljapgolly_scalajs_react_extra_router_RouterWithProps$ = new $c_Ljapgolly_scalajs_react_extra_router_RouterWithProps$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_RouterWithProps$
}
function $f_Ljapgolly_scalajs_react_extra_router_RoutingRule__prefixPath_$div__T__Ljapgolly_scalajs_react_extra_router_RoutingRule($thiz, prefix) {
  var pre = new $c_Ljapgolly_scalajs_react_extra_router_Path(prefix);
  return $thiz.modPath__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Ljapgolly_scalajs_react_extra_router_Path(p$2);
    return ($n(p).isEmpty__Z() ? pre : $as_Ljapgolly_scalajs_react_extra_router_Path(pre.$div__Ljapgolly_scalajs_react_extra_router_PathLike__Ljapgolly_scalajs_react_extra_router_PathLike(p)))
  })), new $c_sjsr_AnonFunction1(((p$3$2) => {
    var p$3 = $as_Ljapgolly_scalajs_react_extra_router_Path(p$3$2);
    return (($n(p$3).Ljapgolly_scalajs_react_extra_router_Path__f_value === prefix) ? new $c_s_Some(new $c_Ljapgolly_scalajs_react_extra_router_Path("")) : $n(p$3).removePrefix__T__s_Option((prefix + "/")))
  })))
}
function $f_Ljapgolly_scalajs_react_extra_router_RoutingRule__noFallback__Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF($thiz) {
  var fallbackPath = new $c_sjsr_AnonFunction1(((page$2) => {
    $m_s_sys_package$().error__T__E((("Unspecified path for page " + page$2) + "."))
  }));
  var fallbackAction = new $c_sjsr_AnonFunction2(((path$2, page$3$2) => {
    var path = $as_Ljapgolly_scalajs_react_extra_router_Path(path$2);
    $m_s_sys_package$().error__T__E((((("Unspecified action for page " + page$3$2) + " at ") + path) + "."))
  }));
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF($thiz, fallbackPath, fallbackAction, this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
}
function $is_Ljapgolly_scalajs_react_extra_router_RoutingRule(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_extra_router_RoutingRule)))
}
function $as_Ljapgolly_scalajs_react_extra_router_RoutingRule(obj) {
  return (($is_Ljapgolly_scalajs_react_extra_router_RoutingRule(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RoutingRule"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RoutingRule)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RoutingRule;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RoutingRule$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RoutingRule$.prototype = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$.prototype.empty__Ljapgolly_scalajs_react_extra_router_RoutingRule = (function() {
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(new $c_sjsr_AnonFunction1(((x$34$2) => {
    $as_Ljapgolly_scalajs_react_extra_router_Path(x$34$2);
    return $m_s_None$()
  })), new $c_sjsr_AnonFunction1(((x$35$2) => $m_s_None$())), new $c_sjsr_AnonFunction2(((x$36$2, x$37$2) => {
    $as_Ljapgolly_scalajs_react_extra_router_Path(x$36$2);
    return $m_s_None$()
  })))
});
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRule$: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRule$", {
  Ljapgolly_scalajs_react_extra_router_RoutingRule$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$;
var $n_Ljapgolly_scalajs_react_extra_router_RoutingRule$;
function $m_Ljapgolly_scalajs_react_extra_router_RoutingRule$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_RoutingRule$)) {
    $n_Ljapgolly_scalajs_react_extra_router_RoutingRule$ = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_RoutingRule$
}
function $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$__unambiguousRule__sci_List__F1__F1__Ljapgolly_scalajs_react_util_Effect$Sync__O($thiz, xs, staticErr, dynErr, F) {
  var x1 = $m_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$().partition__sci_List__Ljapgolly_scalajs_react_util_Effect$Sync__T2(xs, F);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var statics = $as_sci_List($n(x1)._1__O());
  var dynamics = $as_sci_List($n(x1)._2__O());
  $n(F);
  $n(F);
  var fas = new $c_sjsr_AnonFunction0((() => dynamics));
  var this$4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$3 = $m_sc_BuildFrom$();
  var cbf = new $c_sc_BuildFromLowPriority2$$anon$11(this$3);
  var this$5 = $m_Ljapgolly_scalajs_react_util_Util$();
  var fa$4 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.traverse__F0__F1__sc_BuildFrom__Ljapgolly_scalajs_react_callback_Trampoline(fas, this$5.Ljapgolly_scalajs_react_util_Util$__f_identity, cbf));
  var f$2 = new $c_sjsr_AnonFunction1(((dynamicOptions$2) => {
    var dynamicOptions = $as_sci_List(dynamicOptions$2);
    $n(F);
    var fa$2 = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$__unambiguousOption__sci_List__F1__Ljapgolly_scalajs_react_util_Effect$Sync__O($m_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$(), dynamicOptions, dynErr, F);
    var f$1 = new $c_sjsr_AnonFunction1(((dynamicOption$2) => {
      var dynamicOption = $as_s_Option(dynamicOption$2);
      $n(F);
      var fa = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$__unambiguousOption__sci_List__F1__Ljapgolly_scalajs_react_util_Effect$Sync__O($m_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$(), statics, staticErr, F);
      var f = new $c_sjsr_AnonFunction1(((staticOption$2) => {
        var staticOption = $as_s_Option(staticOption$2);
        var this$6 = $n(dynamicOption);
        return (this$6.isEmpty__Z() ? staticOption : this$6)
      }));
      var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$9 = $n(fa$1);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$9, f))
    }));
    var fa$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$3, f$1))
  }));
  var fa$5 = fa$4.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$5, f$2))
}
function $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$__unambiguousOption__sci_List__F1__Ljapgolly_scalajs_react_util_Effect$Sync__O($thiz, input, errMsg, F) {
  var as = $n(input).collect__s_PartialFunction__sci_List(new $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1());
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (as === null) : $n(x).equals__O__Z(as))) {
    $n(F);
    var a = $m_s_None$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a)))
  };
  if ((as instanceof $c_sci_$colon$colon)) {
    var x3 = $as_sci_$colon$colon(as);
    var a$1 = $n(x3).sci_$colon$colon__f_head;
    var p4 = $n(x3).sci_$colon$colon__f_next;
    var x$3 = $m_s_package$().s_package$__f_Nil;
    if (((x$3 === null) ? (p4 === null) : $n(x$3).equals__O__Z(p4))) {
      $n(F);
      var a$2 = new $c_s_Some(a$1);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a$2)))
    }
  };
  $n(F);
  var a$3 = new $c_sjsr_AnonFunction0((() => {
    throw new $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$Exception($as_T($n(errMsg).apply__O__O(as)))
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$3)))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$.prototype = $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$.prototype.selectParsed__Ljapgolly_scalajs_react_extra_router_Path__F1__Ljapgolly_scalajs_react_util_Effect$Sync__O = (function(path, parse, F) {
  return $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$__unambiguousRule__sci_List__F1__F1__Ljapgolly_scalajs_react_util_Effect$Sync__O(this, $as_sci_List($n(parse).apply__O__O(path)), new $c_sjsr_AnonFunction1(((as$2) => {
    var as = $as_sci_List(as$2);
    var this$2 = $n(as);
    return ((("Multiple (" + this$2.length__I()) + ") (unconditional) routes specified for path ") + $n(path).Ljapgolly_scalajs_react_extra_router_Path__f_value)
  })), new $c_sjsr_AnonFunction1(((as$3$2) => {
    var as$3 = $as_sci_List(as$3$2);
    var this$3 = $n(as$3);
    return ((("Multiple (" + this$3.length__I()) + ") conditional routes active for path ") + $n(path).Ljapgolly_scalajs_react_extra_router_Path__f_value)
  })), F)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$.prototype.selectAction__Ljapgolly_scalajs_react_extra_router_Path__O__F2__Ljapgolly_scalajs_react_util_Effect$Sync__O = (function(path, page, action, F) {
  return $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$__unambiguousRule__sci_List__F1__F1__Ljapgolly_scalajs_react_util_Effect$Sync__O(this, $as_sci_List($n(action).apply__O__O__O(path, page)), new $c_sjsr_AnonFunction1(((as$2) => {
    var as = $as_sci_List(as$2);
    var this$2 = $n(as);
    return ((((("Multiple (" + this$2.length__I()) + ") (unconditional) actions specified for ") + page) + " at path ") + $n(path).Ljapgolly_scalajs_react_extra_router_Path__f_value)
  })), new $c_sjsr_AnonFunction1(((as$3$2) => {
    var as$3 = $as_sci_List(as$3$2);
    var this$3 = $n(as$3);
    return ((((("Multiple (" + this$3.length__I()) + ") conditional actions active for ") + page) + " at path ") + $n(path).Ljapgolly_scalajs_react_extra_router_Path__f_value)
  })), F)
});
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRulesF$SharedLogic$", {
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$;
var $n_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$;
function $m_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$)) {
    $n_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$ = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$() {
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$__f_someUnit = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$__f_$div = null;
  $n_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$ = this;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$__f_someUnit = new $c_s_Some((void 0));
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$__f_$div = this.literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("/")
}
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$.prototype = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$.prototype.literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB = (function(s) {
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($m_ju_regex_Pattern$().quote__T__T(s), 0, new $c_sjsr_AnonFunction1(((x$33$2) => {
    $as_F1(x$33$2);
    return $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$__f_someUnit
  })), new $c_sjsr_AnonFunction1(((x$34$2) => {
    $as_jl_Void(x$34$2);
    return s
  })))
});
var $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$: 0
}, false, "japgolly.scalajs.react.extra.router.StaticDsl$RouteB$", {
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$;
var $n_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$;
function $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$)) {
    $n_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$ = new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$
}
function $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($thiz, fa, fb) {
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB((("" + $n(fa).Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_regex) + $n(fb).Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_regex), (($n(fa).Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_matchGroups + $n(fb).Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_matchGroups) | 0), new $c_sjsr_AnonFunction1(((g$2) => {
    var g = $as_F1(g$2);
    var this$2 = $n($as_s_Option($n($n(fa).Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_parse).apply__O__O(g)));
    if (this$2.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var this$3 = $n($as_s_Option($n($n(fb).Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_parse).apply__O__O(new $c_sjsr_AnonFunction1(((i$2) => {
        var i = $uI(i$2);
        return $as_T($n(g).apply__O__O(((i + $n(fa).Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_matchGroups) | 0)))
      })))));
      if (this$3.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1$1 = this$3.get__O();
        return new $c_s_Some($n($thiz.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1__f_gc).apply__O__O__O(arg1, arg1$1))
      }
    }
  })), new $c_sjsr_AnonFunction1(((c$2) => (("" + $as_T($n($n(fa).Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_build).apply__O__O($n($thiz.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1__f_ga).apply__O__O(c$2)))) + $n($n(fb).Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_build).apply__O__O($n($thiz.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1__f_gb).apply__O__O(c$2))))))
}
function $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLowest__$times$times$times__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition($thiz) {
  var a = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T2(x$1$2);
    return $n(x$1)._1__O()
  }));
  var b = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_T2(x$2$2);
    return $n(x$2)._2__O()
  }));
  var c = new $c_sjsr_AnonFunction2(((x$3$2, x$4$2) => $ct_T2__O__O__(new $c_T2(), x$3$2, x$4$2)));
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1(a, b, c)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon.prototype = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon.prototype;
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon.prototype.xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon = (function(b, a) {
  return this.pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((a$2$2) => new $c_s_Some($n(b).apply__O__O(a$2$2)))), a)
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon.prototype.const__O__O__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon = (function(b, ev) {
  return this.xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((x$36$2) => b)), new $c_sjsr_AnonFunction1(((x$37$2) => ev)))
});
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$.prototype = $c_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$.prototype.$bar$bar$extension__F1__F1__F1 = (function(this$, g) {
  return new $c_sjsr_AnonFunction1(((a$2) => {
    var this$2 = $n($as_s_Option($n(this$).apply__O__O(a$2)));
    return (this$2.isEmpty__Z() ? $as_s_Option($n(g).apply__O__O(a$2)) : this$2)
  }))
});
$c_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$.prototype.$bar$extension__F1__F1__F1 = (function(this$, g) {
  return new $c_sjsr_AnonFunction1(((a$2) => {
    var this$2 = $n($as_s_Option($n(this$).apply__O__O(a$2)));
    return (this$2.isEmpty__Z() ? $n(g).apply__O__O(a$2) : this$2.get__O())
  }))
});
var $d_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$: 0
}, false, "japgolly.scalajs.react.extra.router.package$OptionFnExt$", {
  Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$;
var $n_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$;
function $m_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$)) {
    $n_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$ = new $c_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$
}
function $f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided($thiz, value) {
  return new $c_Ljapgolly_scalajs_react_feature_Context$$anon$1($thiz, value)
}
function $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement($thiz, f) {
  var childFn = ((arg1$2) => $f_Ljapgolly_scalajs_react_feature_Context__japgolly$scalajs$react$feature$Context$$$anonfun$consume$1__O__F1__sjs_js_$bar($thiz, arg1$2, f));
  var e = $i_react.createElement($thiz.Ljapgolly_scalajs_react_feature_Context$$anon$3__f_raw.Consumer, null, childFn);
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(e)
}
function $f_Ljapgolly_scalajs_react_feature_Context__japgolly$scalajs$react$feature$Context$$$anonfun$consume$1__O__F1__sjs_js_$bar($thiz, a, f$1) {
  return $n($as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f$1).apply__O__O(a))).rawNode__sjs_js_$bar()
}
function $is_Ljapgolly_scalajs_react_feature_Context(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_feature_Context)))
}
function $as_Ljapgolly_scalajs_react_feature_Context(obj) {
  return (($is_Ljapgolly_scalajs_react_feature_Context(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.feature.Context"))
}
function $isArrayOf_Ljapgolly_scalajs_react_feature_Context(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_feature_Context)))
}
function $asArrayOf_Ljapgolly_scalajs_react_feature_Context(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_feature_Context(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.feature.Context;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_feature_Context$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_feature_Context$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_feature_Context$.prototype.constructor = $c_Ljapgolly_scalajs_react_feature_Context$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_feature_Context$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_feature_Context$.prototype = $c_Ljapgolly_scalajs_react_feature_Context$.prototype;
$c_Ljapgolly_scalajs_react_feature_Context$.prototype.apply__T__O__Ljapgolly_scalajs_react_feature_Context = (function(displayName, defaultValue) {
  var ctx = new $c_Ljapgolly_scalajs_react_feature_Context$$anon$3(defaultValue);
  ctx.Ljapgolly_scalajs_react_feature_Context$$anon$3__f_raw.displayName = displayName;
  return ctx
});
var $d_Ljapgolly_scalajs_react_feature_Context$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_feature_Context$: 0
}, false, "japgolly.scalajs.react.feature.Context$", {
  Ljapgolly_scalajs_react_feature_Context$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_feature_Context$.prototype.$classData = $d_Ljapgolly_scalajs_react_feature_Context$;
var $n_Ljapgolly_scalajs_react_feature_Context$;
function $m_Ljapgolly_scalajs_react_feature_Context$() {
  if ((!$n_Ljapgolly_scalajs_react_feature_Context$)) {
    $n_Ljapgolly_scalajs_react_feature_Context$ = new $c_Ljapgolly_scalajs_react_feature_Context$()
  };
  return $n_Ljapgolly_scalajs_react_feature_Context$
}
function $is_Ljapgolly_scalajs_react_feature_Context$Provided(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_feature_Context$Provided)))
}
function $as_Ljapgolly_scalajs_react_feature_Context$Provided(obj) {
  return (($is_Ljapgolly_scalajs_react_feature_Context$Provided(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.feature.Context$Provided"))
}
function $isArrayOf_Ljapgolly_scalajs_react_feature_Context$Provided(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_feature_Context$Provided)))
}
function $asArrayOf_Ljapgolly_scalajs_react_feature_Context$Provided(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_feature_Context$Provided(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.feature.Context$Provided;", depth))
}
function $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($thiz, props, ns) {
  var $$x2 = $i_react;
  var $$x1 = $i_react.Fragment;
  var seq = $as_sci_Seq($n(ns).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(x$1$2);
    return $n(x$1).rawNode__sjs_js_$bar()
  }))));
  var n = $$x2.createElement($$x1, props, ...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(seq));
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_feature_ReactFragment$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_feature_ReactFragment$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_feature_ReactFragment$.prototype.constructor = $c_Ljapgolly_scalajs_react_feature_ReactFragment$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_feature_ReactFragment$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_feature_ReactFragment$.prototype = $c_Ljapgolly_scalajs_react_feature_ReactFragment$.prototype;
$c_Ljapgolly_scalajs_react_feature_ReactFragment$.prototype.withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement = (function(key, ns) {
  var array = [$ct_T2__O__O__(new $c_T2(), "key", key)];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var props = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this, props, ns)
});
var $d_Ljapgolly_scalajs_react_feature_ReactFragment$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_feature_ReactFragment$: 0
}, false, "japgolly.scalajs.react.feature.ReactFragment$", {
  Ljapgolly_scalajs_react_feature_ReactFragment$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_feature_ReactFragment$.prototype.$classData = $d_Ljapgolly_scalajs_react_feature_ReactFragment$;
var $n_Ljapgolly_scalajs_react_feature_ReactFragment$;
function $m_Ljapgolly_scalajs_react_feature_ReactFragment$() {
  if ((!$n_Ljapgolly_scalajs_react_feature_ReactFragment$)) {
    $n_Ljapgolly_scalajs_react_feature_ReactFragment$ = new $c_Ljapgolly_scalajs_react_feature_ReactFragment$()
  };
  return $n_Ljapgolly_scalajs_react_feature_ReactFragment$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Api$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Api$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Api$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Api$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Api$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Api$.prototype = $c_Ljapgolly_scalajs_react_hooks_Api$.prototype;
var $d_Ljapgolly_scalajs_react_hooks_Api$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Api$: 0
}, false, "japgolly.scalajs.react.hooks.Api$", {
  Ljapgolly_scalajs_react_hooks_Api$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_Api$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Api$;
var $n_Ljapgolly_scalajs_react_hooks_Api$;
function $m_Ljapgolly_scalajs_react_hooks_Api$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Api$)) {
    $n_Ljapgolly_scalajs_react_hooks_Api$ = new $c_Ljapgolly_scalajs_react_hooks_Api$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Api$
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__custom__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__F1__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O($thiz, hook, step, a, d) {
  return $n(d).apply__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O__F1__F1__O(step, new $c_sjsr_AnonFunction1(((ctx$2) => $n(hook).apply__O__O($n(a).apply__O__O(ctx$2)))), new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_F1(x$1$2);
    return $thiz.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(x$1, step)
  })), new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_F1(x$2$2);
    return $thiz.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(x$2, step)
  })))
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O($thiz, hook, step, d) {
  return $n(d).apply__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O__F1__F1__O(step, new $c_sjsr_AnonFunction1(((ctx$2) => $n($n($as_Ljapgolly_scalajs_react_hooks_CustomHook($n(hook).apply__O__O(ctx$2))).Ljapgolly_scalajs_react_hooks_CustomHook__f_unsafeInit).apply__O__O((void 0)))), new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_F1(x$3$2);
    return $thiz.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(x$3, step)
  })), new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_F1(x$4$2);
    return $thiz.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(x$4, step)
  })))
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useCallbackBy__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, callback, a, step) {
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$().apply__F0__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F1(new $c_sjsr_AnonFunction0((() => $n(callback).apply__O__O(ctx$2))), a))));
  var this$2 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$2);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O($thiz, hook, step, d)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useCallbackWithDepsBy__F1__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, deps, callback, a, r, step) {
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$().withDeps__F0__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__F1(new $c_sjsr_AnonFunction0((() => $n(deps).apply__O__O(ctx$2))), $as_F1($n(callback).apply__O__O(ctx$2)), a, r))));
  var this$2 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$2);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O($thiz, hook, step, d)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, ctx, step) {
  var f = new $c_sjsr_AnonFunction1(((x$14$2) => ctx));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContextBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, f, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContextBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, f, step) {
  return $thiz.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Ljapgolly_scalajs_react_feature_Context($n(f).apply__O__O(ctx$2));
    return $i_react.useContext($n(ctx).Ljapgolly_scalajs_react_feature_Context$$anon$3__f_raw)
  })), step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useEffectBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, init, a, step) {
  return $thiz.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((ctx$2) => {
    $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$().unsafeCreate__O__F1__V($n(init).apply__O__O(ctx$2), a)
  })), step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useEffectOnMountBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, effect, a, step) {
  return $thiz.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((ctx$2) => {
    $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$().unsafeCreateOnMount__O__F1__V($n(effect).apply__O__O(ctx$2), a)
  })), step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useEffectWithDepsBy__F1__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, deps, effect, a, r, step) {
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$().useEffect__F0__F1__F1__F2__F1(new $c_sjsr_AnonFunction0((() => $n(deps).apply__O__O(ctx$2))), $as_F1($n(effect).apply__O__O(ctx$2)), a, r))));
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2();
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O($thiz, hook, step, d)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useMemo__F0__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, deps, create, r, step) {
  var deps$1 = new $c_sjsr_AnonFunction1(((x$20$2) => $n(deps).apply__O()));
  var create$1 = new $c_sjsr_AnonFunction1(((x$21$2) => create));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useMemoBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, deps$1, create$1, r, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useMemoBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, deps, create, r, step) {
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$().apply__F0__F1__F2__F1(new $c_sjsr_AnonFunction0((() => $n(deps).apply__O__O(ctx$2))), $as_F1($n(create).apply__O__O(ctx$2)), r))));
  var this$2 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$2);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O($thiz, hook, step, d)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducer__F2__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, reducer, initialState, step) {
  var reducer$1 = new $c_sjsr_AnonFunction1(((x$22$2) => reducer));
  var initialState$1 = new $c_sjsr_AnonFunction1(((x$23$2) => $n(initialState).apply__O()));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducerBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, reducer$1, initialState$1, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducerBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, reducer, initialState, step) {
  return $thiz.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((ctx$2) => {
    var this$2 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$();
    var reducer$1 = $as_F2($n(reducer).apply__O__O(ctx$2));
    var initialState$1 = new $c_sjsr_AnonFunction0((() => $n(initialState).apply__O__O(ctx$2)));
    return this$2.unsafeCreate__F2__O__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$1, null, new $c_sjsr_AnonFunction1(((x$7$2) => {
      if ((x$7$2 !== null)) {
        throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException())
      };
      return initialState$1.apply__O()
    })))
  })), step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefToVdom__s_reflect_ClassTag__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, evidence$1, step) {
  return $thiz.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((x$25$2) => {
    var this$2 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$();
    var this$3 = $n(this$2.unsafeCreateSimple__Ljapgolly_scalajs_react_Ref$FullF());
    return $f_Ljapgolly_scalajs_react_Ref$FullF__narrowOption__s_reflect_ClassTag__Ljapgolly_scalajs_react_Ref$FullF(this$3, evidence$1)
  })), step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRef__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, initialValue, step) {
  var initialValue$1 = new $c_sjsr_AnonFunction1(((x$31$2) => $n(initialValue).apply__O()));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, initialValue$1, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, initialValue, step) {
  return $thiz.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((ctx$2) => $m_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$().unsafeCreate__O__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF($n(initialValue).apply__O__O(ctx$2)))), step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, initialState, step) {
  var initialState$1 = new $c_sjsr_AnonFunction1(((x$32$2) => $n(initialState).apply__O()));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useStateBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, initialState$1, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useStateBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, initialState, step) {
  return $thiz.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((ctx$2) => $m_Ljapgolly_scalajs_react_hooks_Hooks$UseState$().unsafeCreate__F0__Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(new $c_sjsr_AnonFunction0((() => $n(initialState).apply__O__O(ctx$2)))))), step)
}
function $is_Ljapgolly_scalajs_react_hooks_Api$Primary(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_hooks_Api$Primary)))
}
function $as_Ljapgolly_scalajs_react_hooks_Api$Primary(obj) {
  return (($is_Ljapgolly_scalajs_react_hooks_Api$Primary(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.Api$Primary"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_Api$Primary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_Api$Primary)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_Api$Primary(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_Api$Primary(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.Api$Primary;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook(unsafeInit) {
  this.Ljapgolly_scalajs_react_hooks_CustomHook__f_unsafeInit = null;
  this.Ljapgolly_scalajs_react_hooks_CustomHook__f_unsafeInit = unsafeInit
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook.prototype;
$c_Ljapgolly_scalajs_react_hooks_CustomHook.prototype.hashCode__I = (function() {
  var this$ = this.Ljapgolly_scalajs_react_hooks_CustomHook__f_unsafeInit;
  return $n(this$).hashCode__I()
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_hooks_CustomHook$().equals$extension__F1__O__Z(this.Ljapgolly_scalajs_react_hooks_CustomHook__f_unsafeInit, x$1)
});
function $as_Ljapgolly_scalajs_react_hooks_CustomHook(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_CustomHook) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.CustomHook"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_CustomHook)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.CustomHook;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_CustomHook = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook", {
  Ljapgolly_scalajs_react_hooks_CustomHook: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype;
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype.apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First = (function() {
  return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First(new $c_sjsr_AnonFunction1(((x$2$2) => (void 0))))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype.reusableDeps__F2__F1 = (function(r) {
  var this$3 = $n($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var $$x2 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, initialState, step)));
  var $$x1 = new $c_sjsr_AnonFunction2(((getDeps$2, depsState$2) => {
    var getDeps = $as_F0(getDeps$2);
    var depsState = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(depsState$2);
    var next = $n(getDeps).apply__O();
    var rc5 = false;
    var x2 = null;
    var this$4 = $n(depsState);
    var x1 = $as_s_Option(this$4.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    matchEnd6: {
      var nextDepState;
      if ((x1 instanceof $c_s_Some)) {
        rc5 = true;
        x2 = $as_s_Some(x1);
        var s = $as_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState($n(x2).s_Some__f_value);
        if ($n(s).Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_skipTest) {
          $n(s).Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_skipTest = false;
          var nextDepState = s;
          break matchEnd6
        }
      };
      if (rc5) {
        var prevState = $as_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState($n(x2).s_Some__f_value);
        if ($uZ($n(r).apply__O__O__O($n(prevState).Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_value, next))) {
          var nextDepState = prevState;
          break matchEnd6
        }
      };
      var this$5 = $n(x1);
      if (this$5.isEmpty__Z()) {
        var nextRev = 1
      } else {
        var arg1 = this$5.get__O();
        var x$9 = $as_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState(arg1);
        var nextRev = ((1 + $n(x$9).Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_rev) | 0)
      };
      var nextState = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState(next, nextRev);
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$6 = $n(depsState);
      var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$6);
      var updateState = $n($as_F1($n(r$1).value__O())).apply__O__O(new $c_s_Some(nextState));
      var this$8 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      $n(this$8.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(updateState)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$11 = $n(this$);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$11);
      var nextDepState = nextState
    };
    return $n(nextDepState).Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_asTuple
  }));
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$12))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype.reusableByDeps__F2__F2__F1 = (function(create, r) {
  return $m_Ljapgolly_scalajs_react_hooks_CustomHook$().map$extension__F1__F1__F1(this.reusableDeps__F2__F1(r), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var d = $n(x0$1)._1__O();
      var rev = $n(x0$1)._2$mcI$sp__I();
      var this$5 = $m_Ljapgolly_scalajs_react_Reusable$();
      $m_s_reflect_ManifestFactory$IntManifest$();
      var this$4 = $m_Ljapgolly_scalajs_react_Reusability$();
      var evidence$3 = this$4.by_$eq$eq__F2();
      var e = new $c_Ljapgolly_scalajs_react_Reusability(evidence$3);
      var r$1 = e.Ljapgolly_scalajs_react_Reusability__f_test;
      return $n($p_Ljapgolly_scalajs_react_Reusable$__root__O__F1__Ljapgolly_scalajs_react_Reusable(this$5, rev, new $c_sjsr_AnonFunction1(((x$6$2) => {
        var x$6 = $as_Ljapgolly_scalajs_react_Reusable(x$6$2);
        var x1 = $n(x$6).Ljapgolly_scalajs_react_Reusable__f_japgolly$scalajs$react$Reusable$$root;
        if ((x1 !== null)) {
          if ($isInt(x1)) {
            var x2 = $uI(x1);
            var o9 = new $c_s_Some(x2)
          } else {
            var o9 = $m_s_None$()
          };
          if (((!$n(o9).isEmpty__Z()) && ($n(o9).get__O() !== null))) {
            return $uZ($n(r$1).apply__O__O__O(rev, x1))
          }
        };
        return false
      })))).withValue__O__Ljapgolly_scalajs_react_Reusable($n(create).apply__O__O__O(d, rev))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype.shouldComponentUpdate__F1__F2__F1 = (function(render, r) {
  return $m_Ljapgolly_scalajs_react_hooks_CustomHook$().map$extension__F1__F1__F1(this.reusableDeps__F2__F1(r), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var d = $n(x0$1)._1__O();
      var rev = $n(x0$1)._2$mcI$sp__I();
      return $m_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$().apply__I__F0__Ljapgolly_scalajs_react_vdom_VdomNode(rev, new $c_sjsr_AnonFunction0((() => $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(d)))))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype.apply$extension__F1__O__F1 = (function(this$, i) {
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_jl_Void(x$1$2);
    return $n(this$).apply__O__O(i)
  }));
  return f
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype.map$extension__F1__F1__F1 = (function(this$, f) {
  var f$1 = new $c_sjsr_AnonFunction1(((i$2) => $n(f).apply__O__O($n(this$).apply__O__O(i$2))));
  return f$1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype.equals$extension__F1__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_hooks_CustomHook)) {
    var CustomHook$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_hooks_CustomHook(x$1)).Ljapgolly_scalajs_react_hooks_CustomHook__f_unsafeInit);
    return ((this$ === null) ? (CustomHook$1 === null) : $n(this$).equals__O__Z(CustomHook$1))
  } else {
    return false
  }
});
var $d_Ljapgolly_scalajs_react_hooks_CustomHook$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook$: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook$", {
  Ljapgolly_scalajs_react_hooks_CustomHook$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook$;
var $n_Ljapgolly_scalajs_react_hooks_CustomHook$;
function $m_Ljapgolly_scalajs_react_hooks_CustomHook$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_CustomHook$)) {
    $n_Ljapgolly_scalajs_react_hooks_CustomHook$ = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_CustomHook$
}
function $is_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn)))
}
function $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(obj) {
  return (($is_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.CustomHook$Builder$BuildFn"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.CustomHook$Builder$BuildFn;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$.prototype = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$.prototype.apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First = (function() {
  return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First(new $c_sjsr_AnonFunction1(((x$1$2) => (void 0))))
});
var $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$: 0
}, false, "japgolly.scalajs.react.hooks.HookComponentBuilder$", {
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$;
var $n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$;
function $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$)) {
    $n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$
}
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I0__O__($thiz, input) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input = input;
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$I0() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I0.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I0.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I0;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$I0() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$I0.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I0.prototype;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P0__O__($thiz, props) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = props;
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P0() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P0.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P0.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P0;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P0() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P0.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P0.prototype;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$.prototype;
var $d_Ljapgolly_scalajs_react_hooks_Hooks$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$", {
  Ljapgolly_scalajs_react_hooks_Hooks$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$.prototype.useEffect__F0__F1__F1__F2__F1 = (function(deps, effect, a, r) {
  return $m_Ljapgolly_scalajs_react_hooks_CustomHook$().map$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Ljapgolly_scalajs_react_hooks_CustomHook$().reusableDeps__F2__F1(r), deps), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var d = $n(x0$1)._1__O();
      var rev = $n(x0$1)._2$mcI$sp__I();
      var $$x2 = $i_react;
      var $$x1 = $n(a).apply__O__O($n(effect).apply__O__O(d));
      var a$1 = [rev];
      $$x2.useEffect($$x1, a$1)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))
});
var $d_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$ReusableEffect$", {
  Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$ReusableEffect$
}
function $p_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$__create__O__sjs_js_$bar__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__Ljapgolly_scalajs_react_Reusable($thiz, in$1, deps, a) {
  return $as_Ljapgolly_scalajs_react_Reusable($n($n(a).Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1__f_g$1).apply__O__O($i_react.useCallback($n($n(a).Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1__f_f$1).apply__O__O(in$1), deps)))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$.prototype.apply__F0__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F1 = (function(callback, a) {
  var f = new $c_sjsr_AnonFunction0((() => {
    var $$x2 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$();
    var $$x1 = $n(callback).apply__O();
    var a$1 = [];
    return $p_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$__create__O__sjs_js_$bar__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__Ljapgolly_scalajs_react_Reusable($n($$x2), $$x1, a$1, a)
  }));
  var f$1 = new $c_sjsr_AnonFunction1(((x$3$2) => {
    $as_jl_Void(x$3$2);
    return f.apply__O()
  }));
  return f$1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$.prototype.withDeps__F0__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__F1 = (function(deps, callback, a, r) {
  return $m_Ljapgolly_scalajs_react_hooks_CustomHook$().map$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Ljapgolly_scalajs_react_hooks_CustomHook$().reusableDeps__F2__F1(r), deps), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var d = $n(x0$1)._1__O();
      var rev = $n(x0$1)._2$mcI$sp__I();
      var $$x2 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$();
      var $$x1 = $n(callback).apply__O__O(d);
      var a$1 = [rev];
      return $p_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$__create__O__sjs_js_$bar__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__Ljapgolly_scalajs_react_Reusable($n($$x2), $$x1, a$1, a)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))
});
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseCallback$", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$UseCallback$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$.prototype.unsafeCreate__O__F1__V = (function(effect, a) {
  $i_react.useEffect($n(a).apply__O__O(effect))
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$.prototype.unsafeCreateOnMount__O__F1__V = (function(effect, a) {
  var $$x2 = $i_react;
  var $$x1 = $n(a).apply__O__O(effect);
  var a$1 = [];
  $$x2.useEffect($$x1, a$1)
});
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseEffect$", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$UseEffect$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$.prototype.apply__F0__F1__F2__F1 = (function(deps, create, r) {
  return $m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Ljapgolly_scalajs_react_hooks_CustomHook$().reusableByDeps__F2__F2__F1(new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x1$1 = $uI(x1$1$2);
    var $$x1 = $i_react;
    var a = [x1$1];
    return $$x1.useMemo((() => $n(create).apply__O__O(x0$1$2)), a)
  })), r), deps)
});
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseMemo$", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$UseMemo$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$.prototype.unsafeCreate__O__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF = (function(initialValue) {
  var $$x1 = $i_react.useRef(initialValue);
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF($$x1, this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$.prototype.unsafeCreateSimple__Ljapgolly_scalajs_react_Ref$FullF = (function() {
  return $m_Ljapgolly_scalajs_react_Ref$().fromJs__Ljapgolly_scalajs_react_facade_React$RefHandle__Ljapgolly_scalajs_react_Ref$FullF($i_react.useRef(null))
});
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseRef$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseRef$", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseRef$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$UseRef$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseState$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseState$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseState$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseState$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseState$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseState$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseState$.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseState$.prototype.unsafeCreate__F0__Ljapgolly_scalajs_react_hooks_Hooks$UseStateF = (function(initialState) {
  var initialStateFn = (() => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var value = $n(initialState).apply__O();
    var array = [$ct_T2__O__O__(new $c_T2(), "a", value)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  });
  var originalResult = $i_react.useState(initialStateFn);
  var originalSetState = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(originalResult[1]);
  var this$11 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var f = this$11.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var this$19 = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2(f, originalResult, originalSetState);
  var f$1 = new $c_sjsr_AnonFunction1(((x$11$2) => x$11$2.a));
  var g = new $c_sjsr_AnonFunction1(((value$2) => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "a", value$2)];
    var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1)
  }));
  return $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__xmap__F1__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$19, f$1, g)
});
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseState$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseState$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseState$", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseState$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseState$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseState$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$UseState$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$UseState$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$UseState$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$UseState$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseState$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$UseState$
}
function $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable($thiz) {
  return $n($thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_originalSetState).withValue__O__Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction1(((s$2) => {
    $n($thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_f$5);
    var a = new $c_sjsr_AnonFunction0((() => {
      (0, $thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[1])(s$2)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
  })))
}
function $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable($thiz) {
  return $n($thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_originalSetState).withValue__O__Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    $n($thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_f$5);
    var a = new $c_sjsr_AnonFunction0((() => {
      var f$1 = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(f);
      (0, $thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[1])(f$1)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
  })))
}
function $p_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__newSetStateJs__F1__F1__sjs_js_Function1($thiz, givenValue, givenFn) {
  return ((arg1$2) => {
    $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__japgolly$scalajs$react$hooks$Hooks$UseStateF$$$anonfun$newSetStateJs$1__sjs_js_$bar__F1__F1__V($thiz, arg1$2, givenFn, givenValue)
  })
}
function $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__xmap__F1__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseStateF($thiz, f, g) {
  var newSetState = $p_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__newSetStateJs__F1__F1__sjs_js_Function1($thiz, new $c_sjsr_AnonFunction1(((t$2) => {
    var $$x1 = $thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[1];
    var a = $n(g).apply__O__O(t$2);
    $$x1(a)
  })), new $c_sjsr_AnonFunction1(((m$2) => {
    var $$x2 = $thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[1];
    var a$1 = ((arg1$2) => $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__japgolly$scalajs$react$hooks$Hooks$UseStateF$$$anonfun$xmap$3__O__F1__sjs_js_Function1__F1__O($thiz, arg1$2, g, m$2, f));
    $$x2(a$1)
  })));
  var _1 = $n(f).apply__O__O($thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
  var r = [_1, newSetState];
  var oss = $thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_originalSetState;
  var this$10 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var f$1 = this$10.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  return new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2(f$1, r, oss)
}
function $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__japgolly$scalajs$react$hooks$Hooks$UseStateF$$$anonfun$newSetStateJs$1__sjs_js_$bar__F1__F1__V($thiz, tOrFn, givenFn$1, givenValue$1) {
  if (($as_T((typeof tOrFn)) === "function")) {
    $n(givenFn$1).apply__O__O(tOrFn)
  } else {
    $n(givenValue$1).apply__O__O(tOrFn)
  }
}
function $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__japgolly$scalajs$react$hooks$Hooks$UseStateF$$$anonfun$xmap$3__O__F1__sjs_js_Function1__F1__O($thiz, s, g$2, m$1, f$7) {
  return $n(g$2).apply__O__O(m$1($n(f$7).apply__O__O(s)))
}
function $is_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF)))
}
function $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(obj) {
  return (($is_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.Hooks$UseStateF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.Hooks$UseStateF;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$.prototype.reusability__F2__F2 = (function(evidence$2) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$12$2);
    var this$2 = $n(x$12);
    return this$2.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]
  }));
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(evidence$2, f)
});
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseStateF$", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$
}
function $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg($thiz, Z) {
  var f = new $c_sjsr_AnonFunction1(((z$2) => {
    var z = $as_F1(z$2);
    return ((arg1$2) => {
      $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__japgolly$scalajs$react$hooks$UseCallbackArgInstances$$$anonfun$c1$2__O__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1__V($thiz, arg1$2, Z, z)
    })
  }));
  var g = new $c_sjsr_AnonFunction1(((z$3$2) => $n($m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(z$3$2)).withValue__O__Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction1(((a$2) => $n(Z).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    z$3$2(a$2)
  }))))))));
  return new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1(f, g)
}
function $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c3__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg($thiz, Z) {
  var f = new $c_sjsr_AnonFunction1(((z$2) => {
    var z = $as_F3(z$2);
    return ((arg1$2, arg2$2, arg3$2) => {
      $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__japgolly$scalajs$react$hooks$UseCallbackArgInstances$$$anonfun$c3$2__O__O__O__Ljapgolly_scalajs_react_util_Effect$Dispatch__F3__V($thiz, arg1$2, arg2$2, arg3$2, Z, z)
    })
  }));
  var g = new $c_sjsr_AnonFunction1(((z$3$2) => $n($m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(z$3$2)).withValue__O__Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction3(((a$2, b$2, c$2) => $n(Z).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    z$3$2(a$2, b$2, c$2)
  }))))))));
  return new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1(f, g)
}
function $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__japgolly$scalajs$react$hooks$UseCallbackArgInstances$$$anonfun$c1$2__O__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1__V($thiz, a, Z$1, z$1) {
  $n(Z$1).dispatch__O__V($n(z$1).apply__O__O(a))
}
function $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__japgolly$scalajs$react$hooks$UseCallbackArgInstances$$$anonfun$c3$2__O__O__O__Ljapgolly_scalajs_react_util_Effect$Dispatch__F3__V($thiz, a, b, c, Z$3, z$5) {
  $n(Z$3).dispatch__O__V($n(z$5).apply__O__O__O__O(a, b, c))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_Box$() {
  this.Ljapgolly_scalajs_react_internal_Box$__f_Unit = null;
  $n_Ljapgolly_scalajs_react_internal_Box$ = this;
  $m_Ljapgolly_scalajs_react_internal_Box$();
  var array = [$ct_T2__O__O__(new $c_T2(), "a", (void 0))];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Ljapgolly_scalajs_react_internal_Box$__f_Unit = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
}
$c_Ljapgolly_scalajs_react_internal_Box$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_Box$.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_Box$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_Box$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_Box$.prototype = $c_Ljapgolly_scalajs_react_internal_Box$.prototype;
var $d_Ljapgolly_scalajs_react_internal_Box$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_Box$: 0
}, false, "japgolly.scalajs.react.internal.Box$", {
  Ljapgolly_scalajs_react_internal_Box$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_Box$.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_Box$;
var $n_Ljapgolly_scalajs_react_internal_Box$;
function $m_Ljapgolly_scalajs_react_internal_Box$() {
  if ((!$n_Ljapgolly_scalajs_react_internal_Box$)) {
    $n_Ljapgolly_scalajs_react_internal_Box$ = new $c_Ljapgolly_scalajs_react_internal_Box$()
  };
  return $n_Ljapgolly_scalajs_react_internal_Box$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_EffectUtil$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_internal_EffectUtil$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_EffectUtil$.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_EffectUtil$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_EffectUtil$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_EffectUtil$.prototype = $c_Ljapgolly_scalajs_react_internal_EffectUtil$.prototype;
$c_Ljapgolly_scalajs_react_internal_EffectUtil$.prototype.asEventDefault___Ljapgolly_scalajs_react_facade_SyntheticEvent__F0__Ljapgolly_scalajs_react_util_Effect$Sync__O = (function(e, fa, F) {
  $n(F);
  var a = new $c_sjsr_AnonFunction0((() => {
    if ((!$uZ(e.defaultPrevented))) {
      $n(F);
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(fa).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$5 = $n(this$);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$5);
      e.preventDefault()
    }
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
});
$c_Ljapgolly_scalajs_react_internal_EffectUtil$.prototype.unsafeKeyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__s_Option = (function(e, a, altKey, ctrlKey, metaKey, shiftKey, switch$1) {
  return ((!$m_Ljapgolly_scalajs_react_ReactExt\uff3fReactKeyboardEvent$().pressedModifierKeys$extension__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Z__Z__Z__Z__Z(($m_Ljapgolly_scalajs_react_internal_CoreGeneral$(), e), altKey, ctrlKey, metaKey, shiftKey)) ? $m_s_None$() : $as_s_Option($n($n(switch$1).lift__F1()).apply__O__O(a)))
});
var $d_Ljapgolly_scalajs_react_internal_EffectUtil$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_EffectUtil$: 0
}, false, "japgolly.scalajs.react.internal.EffectUtil$", {
  Ljapgolly_scalajs_react_internal_EffectUtil$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_EffectUtil$.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_EffectUtil$;
var $n_Ljapgolly_scalajs_react_internal_EffectUtil$;
function $m_Ljapgolly_scalajs_react_internal_EffectUtil$() {
  if ((!$n_Ljapgolly_scalajs_react_internal_EffectUtil$)) {
    $n_Ljapgolly_scalajs_react_internal_EffectUtil$ = new $c_Ljapgolly_scalajs_react_internal_EffectUtil$()
  };
  return $n_Ljapgolly_scalajs_react_internal_EffectUtil$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_Lens(get, set) {
  this.Ljapgolly_scalajs_react_internal_Lens__f_get = null;
  this.Ljapgolly_scalajs_react_internal_Lens__f_set = null;
  this.Ljapgolly_scalajs_react_internal_Lens__f_mod = null;
  this.Ljapgolly_scalajs_react_internal_Lens__f_get = get;
  this.Ljapgolly_scalajs_react_internal_Lens__f_set = set;
  this.Ljapgolly_scalajs_react_internal_Lens__f_mod = new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    return new $c_sjsr_AnonFunction1(((a$2) => $n($as_F1($n(this.Ljapgolly_scalajs_react_internal_Lens__f_set).apply__O__O($n(f).apply__O__O($n(this.Ljapgolly_scalajs_react_internal_Lens__f_get).apply__O__O(a$2))))).apply__O__O(a$2)))
  }))
}
$c_Ljapgolly_scalajs_react_internal_Lens.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_Lens.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_Lens;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_Lens() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_Lens.prototype = $c_Ljapgolly_scalajs_react_internal_Lens.prototype;
$c_Ljapgolly_scalajs_react_internal_Lens.prototype.setO__s_Option__F1 = (function(o) {
  var this$1 = $n(o);
  if (this$1.isEmpty__Z()) {
    var $$x1 = new $c_sjsr_AnonFunction1(((x$2$2) => $m_s_None$()))
  } else {
    var arg1 = this$1.get__O();
    var $$x1 = $n($as_F1($n(this.Ljapgolly_scalajs_react_internal_Lens__f_set).apply__O__O(arg1))).andThen__F1__F1(new $c_sjsr_AnonFunction1(((value$2) => new $c_s_Some(value$2))))
  };
  return $as_F1($$x1)
});
$c_Ljapgolly_scalajs_react_internal_Lens.prototype.modO__F1__F1 = (function(f) {
  return new $c_sjsr_AnonFunction1(((a$2) => {
    var this$2 = $n($as_s_Option($n(f).apply__O__O($n(this.Ljapgolly_scalajs_react_internal_Lens__f_get).apply__O__O(a$2))));
    if (this$2.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      return new $c_s_Some($n($as_F1($n(this.Ljapgolly_scalajs_react_internal_Lens__f_set).apply__O__O(arg1))).apply__O__O(a$2))
    }
  }))
});
var $d_Ljapgolly_scalajs_react_internal_Lens = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_Lens: 0
}, false, "japgolly.scalajs.react.internal.Lens", {
  Ljapgolly_scalajs_react_internal_Lens: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_Lens.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_Lens;
function $p_Ljapgolly_scalajs_react_internal_Lens$___id__Ljapgolly_scalajs_react_internal_Lens($thiz) {
  var get = new $c_sjsr_AnonFunction1(((a$2) => a$2));
  var set = new $c_sjsr_AnonFunction1(((a$3$2) => new $c_sjsr_AnonFunction1(((x$5$2) => a$3$2))));
  return new $c_Ljapgolly_scalajs_react_internal_Lens(get, set)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_Lens$() {
  this.Ljapgolly_scalajs_react_internal_Lens$__f_idInstance = null;
  $n_Ljapgolly_scalajs_react_internal_Lens$ = this;
  this.Ljapgolly_scalajs_react_internal_Lens$__f_idInstance = $p_Ljapgolly_scalajs_react_internal_Lens$___id__Ljapgolly_scalajs_react_internal_Lens(this)
}
$c_Ljapgolly_scalajs_react_internal_Lens$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_Lens$.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_Lens$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_Lens$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_Lens$.prototype = $c_Ljapgolly_scalajs_react_internal_Lens$.prototype;
var $d_Ljapgolly_scalajs_react_internal_Lens$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_Lens$: 0
}, false, "japgolly.scalajs.react.internal.Lens$", {
  Ljapgolly_scalajs_react_internal_Lens$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_Lens$.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_Lens$;
var $n_Ljapgolly_scalajs_react_internal_Lens$;
function $m_Ljapgolly_scalajs_react_internal_Lens$() {
  if ((!$n_Ljapgolly_scalajs_react_internal_Lens$)) {
    $n_Ljapgolly_scalajs_react_internal_Lens$ = new $c_Ljapgolly_scalajs_react_internal_Lens$()
  };
  return $n_Ljapgolly_scalajs_react_internal_Lens$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$.prototype = $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$.prototype;
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$.prototype.asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0 = (function(this$, e) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var this$$1 = $n($$x2).$less$times$extension__F0__F0__F0(this$, $n($$x1).toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e, this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
  var cond = new $c_sjsr_AnonFunction0((() => $uZ(e.defaultPrevented)));
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().when$extension__F0__F0__F0(this$$1, new $c_sjsr_AnonFunction0((() => (!$uZ(cond.apply__O())))))
});
var $d_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$: 0
}, false, "japgolly.scalajs.react.internal.ReactCallbackExtensions$CallbackOptionExt$", {
  Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$;
var $n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$;
function $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$() {
  if ((!$n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$)) {
    $n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$ = new $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$()
  };
  return $n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$.prototype = $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$.prototype;
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$.prototype.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0 = (function(e, a, altKey, ctrlKey, metaKey, shiftKey, switch$1) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().option__F0__F0(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($m_Ljapgolly_scalajs_react_internal_EffectUtil$().unsafeKeyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__s_Option(e, a, altKey, ctrlKey, metaKey, shiftKey, switch$1));
    if (this$2.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(arg1)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$4 = $n(x$1);
      return new $c_s_Some($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4))
    }
  })))
});
var $d_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$: 0
}, false, "japgolly.scalajs.react.internal.ReactCallbackExtensions$CallbackOptionObjExt$", {
  Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$;
var $n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$;
function $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$() {
  if ((!$n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$)) {
    $n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$ = new $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$()
  };
  return $n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$.prototype = $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$.prototype;
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$.prototype.asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(this$, e) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return $n($$x2).unless$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline($n($$x1).$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e, this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction0((() => $uZ(e.defaultPrevented))))
});
var $d_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$: 0
}, false, "japgolly.scalajs.react.internal.ReactCallbackExtensions$CallbackToExt$", {
  Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$;
var $n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$;
function $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$() {
  if ((!$n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$)) {
    $n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$ = new $c_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$()
  };
  return $n_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$() {
  this.Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$__f_reusability = null;
  this.Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$__f_Component = null;
  $n_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T2(x$1$2);
    return $n(x$1)._1$mcI$sp__I()
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  this.Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$__f_reusability = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  var b = new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1("");
  var b$1 = b.Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1__f_japgolly$scalajs$react$component$builder$ComponentBuilder$Step1$$name;
  var this$13 = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(b$1, $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).noBackend__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3()).render_P__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_T2(x$2$2);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($as_F0($n(x$2)._2__O())).apply__O())
  }))));
  $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$1 = this.Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$__f_reusability;
  var this$8 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$2 = this$8.always__F2();
  var this$11 = $m_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$();
  var f$1 = $n(this$11.Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$__f_reusabilityOverrideInDev).apply__F2__F2__F1(evidence$1, evidence$2);
  this.Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$__f_Component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$1).apply__O__O(this$13))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$.prototype = $c_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$.prototype;
$c_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$.prototype.apply__I__F0__Ljapgolly_scalajs_react_vdom_VdomNode = (function(rev, vdom) {
  var c = this.Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$__f_Component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = $ct_T2__O__O__(new $c_T2(), rev, vdom);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$: 0
}, false, "japgolly.scalajs.react.internal.ShouldComponentUpdateComponent$", {
  Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$;
var $n_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$;
function $m_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$() {
  if ((!$n_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$)) {
    $n_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$ = new $c_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$()
  };
  return $n_Ljapgolly_scalajs_react_internal_ShouldComponentUpdateComponent$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_Singleton(value, mutableObj) {
  this.Ljapgolly_scalajs_react_internal_Singleton__f_value = null;
  this.Ljapgolly_scalajs_react_internal_Singleton__f_mutableObj = null;
  this.Ljapgolly_scalajs_react_internal_Singleton__f_value = value;
  this.Ljapgolly_scalajs_react_internal_Singleton__f_mutableObj = mutableObj
}
$c_Ljapgolly_scalajs_react_internal_Singleton.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_Singleton.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_Singleton;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_Singleton() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_Singleton.prototype = $c_Ljapgolly_scalajs_react_internal_Singleton.prototype;
var $d_Ljapgolly_scalajs_react_internal_Singleton = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_Singleton: 0
}, false, "japgolly.scalajs.react.internal.Singleton", {
  Ljapgolly_scalajs_react_internal_Singleton: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_Singleton.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_Singleton;
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_Singleton$() {
  this.Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit = null;
  $n_Ljapgolly_scalajs_react_internal_Singleton$ = this;
  new $c_Ljapgolly_scalajs_react_internal_Singleton(null, new $c_sjsr_AnonFunction0((() => ({}))));
  new $c_Ljapgolly_scalajs_react_internal_Singleton((void 0), new $c_sjsr_AnonFunction0((() => ({}))));
  this.Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit = new $c_Ljapgolly_scalajs_react_internal_Singleton($m_Ljapgolly_scalajs_react_internal_Box$().Ljapgolly_scalajs_react_internal_Box$__f_Unit, new $c_sjsr_AnonFunction0((() => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var array = [$ct_T2__O__O__(new $c_T2(), "a", (void 0))];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  })))
}
$c_Ljapgolly_scalajs_react_internal_Singleton$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_Singleton$.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_Singleton$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_Singleton$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_Singleton$.prototype = $c_Ljapgolly_scalajs_react_internal_Singleton$.prototype;
var $d_Ljapgolly_scalajs_react_internal_Singleton$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_Singleton$: 0
}, false, "japgolly.scalajs.react.internal.Singleton$", {
  Ljapgolly_scalajs_react_internal_Singleton$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_internal_Singleton$.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_Singleton$;
var $n_Ljapgolly_scalajs_react_internal_Singleton$;
function $m_Ljapgolly_scalajs_react_internal_Singleton$() {
  if ((!$n_Ljapgolly_scalajs_react_internal_Singleton$)) {
    $n_Ljapgolly_scalajs_react_internal_Singleton$ = new $c_Ljapgolly_scalajs_react_internal_Singleton$()
  };
  return $n_Ljapgolly_scalajs_react_internal_Singleton$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_userdefined_Effects() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_userdefined_Effects.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_userdefined_Effects.prototype.constructor = $c_Ljapgolly_scalajs_react_userdefined_Effects;
/** @constructor */
function $h_Ljapgolly_scalajs_react_userdefined_Effects() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_userdefined_Effects.prototype = $c_Ljapgolly_scalajs_react_userdefined_Effects.prototype;
function $p_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__id$lzycompute__Ljapgolly_scalajs_react_util_Effect$UnsafeSync($thiz) {
  if ((!$thiz.Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__f_bitmap$0)) {
    $thiz.Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__f_id = new $c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1();
    $thiz.Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__f_bitmap$0 = true
  };
  return $thiz.Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__f_id
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$() {
  this.Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__f_id = null;
  this.Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__f_bitmap$0 = false
}
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$.prototype = $c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$.prototype;
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$.prototype.id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync = (function() {
  return ((!this.Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__f_bitmap$0) ? $p_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__id$lzycompute__Ljapgolly_scalajs_react_util_Effect$UnsafeSync(this) : this.Ljapgolly_scalajs_react_util_Effect$UnsafeSync$__f_id)
});
var $d_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_Effect$UnsafeSync$: 0
}, false, "japgolly.scalajs.react.util.Effect$UnsafeSync$", {
  Ljapgolly_scalajs_react_util_Effect$UnsafeSync$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$;
var $n_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$;
function $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$() {
  if ((!$n_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$)) {
    $n_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$ = new $c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$()
  };
  return $n_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$
}
function $p_Ljapgolly_scalajs_react_util_JsUtil$__fail$1__jl_Throwable__sjs_js_Function1__O($thiz, t, reject$1) {
  if ((t instanceof $c_sjs_js_JavaScriptException)) {
    var x2 = $as_sjs_js_JavaScriptException(t);
    var e = $n(x2).sjs_js_JavaScriptException__f_exception;
    var $$x1 = e
  } else {
    var $$x1 = t
  };
  return reject$1($$x1)
}
function $p_Ljapgolly_scalajs_react_util_JsUtil$__next$1__s_util_Try__F1__sjs_js_Thenable($thiz, ta, complete$2) {
  var x1 = $thiz.newPromise__T2();
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var p = $n(x1)._1__O();
  var pc = $as_F1($n(x1)._2__O());
  try {
    var $$x1 = new $c_s_util_Success(($n(complete$2).apply__O__O(ta)(), (void 0)))
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $$x1;
      var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(o11).isEmpty__Z())) {
        var e$3 = $as_jl_Throwable($n(o11).get__O());
        var $$x1 = new $c_s_util_Failure(e$3);
        break matchEnd8
      };
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
    }
  };
  $n(pc).apply__O__O($$x1)();
  return p
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_JsUtil$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_JsUtil$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_JsUtil$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_JsUtil$.prototype = $c_Ljapgolly_scalajs_react_util_JsUtil$.prototype;
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype.safeToString__O__T = (function(a) {
  try {
    if ((a !== null)) {
      var o7 = $m_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$().unapply__O__s_Option(a);
      if ((!$n(o7).isEmpty__Z())) {
        var s = $n(o7).get__O();
        return this.symbolToString__sjs_js_Symbol__T(s)
      }
    };
    return $dp_toString__T($n(a))
  } catch (e) {
    return "?"
  }
});
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype.symbolToString__sjs_js_Symbol__T = (function(s) {
  try {
    return $as_T(s.toString())
  } catch (e) {
    var value = Symbol.keyFor(s);
    var x1 = ((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value));
    if ((x1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x1);
      var k = $as_T($n(x2).s_Some__f_value);
      return (("Symbol(" + k) + ")")
    } else {
      var x = $m_s_None$();
      if ((x === x1)) {
        return "Symbol(?)"
      } else {
        throw new $c_s_MatchError(x1)
      }
    }
  }
});
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype.objectIterator__sjs_js_Object__sc_Iterator = (function(o) {
  var $$x1 = $m_sjs_js_Any$ObjectCompanionOps$();
  var self = Object;
  var array = $n($$x1).properties$extension__sjs_js_Object$__sjs_js_Any__sjs_js_Array(self, o);
  var this$8 = new $c_sjs_js_ArrayOps$ArrayIterator(array);
  var f = new $c_sjsr_AnonFunction1(((n$2) => {
    var n = $as_T(n$2);
    try {
      var v = o[n]
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      var v = $m_Ljapgolly_scalajs_react_util_JsUtil$().safeToString__O__T(e$2)
    };
    return $ct_T2__O__O__(new $c_T2(), n, v)
  }));
  return new $c_sc_Iterator$$anon$9(this$8, f)
});
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype.newPromise__T2 = (function() {
  var complete = new $c_sr_ObjectRef(null);
  var p = new Promise(((arg1$2, arg2$2) => {
    $m_Ljapgolly_scalajs_react_util_JsUtil$().japgolly$scalajs$react$util$JsUtil$$$anonfun$newPromise$1__sjs_js_Function1__sjs_js_Function1__sr_ObjectRef__V(arg1$2, arg2$2, complete)
  }));
  return $ct_T2__O__O__(new $c_T2(), p, $as_F1(complete.sr_ObjectRef__f_elem))
});
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype.runPromiseAsync__F0__F1__V = (function(pa, complete) {
  var ok = new $c_sjsr_AnonFunction1(((a$2) => {
    var a = $p_Ljapgolly_scalajs_react_util_JsUtil$__next$1__s_util_Try__F1__sjs_js_Thenable(this, new $c_s_util_Success(a$2), complete);
    return a
  }));
  var ko = new $c_sjsr_AnonFunction1(((e$2) => {
    if ((e$2 instanceof $c_jl_Throwable)) {
      var x2 = $as_jl_Throwable(e$2);
      var $$x1 = x2
    } else {
      var $$x1 = new $c_sjs_js_JavaScriptException(e$2)
    };
    var a$1 = $p_Ljapgolly_scalajs_react_util_JsUtil$__next$1__s_util_Try__F1__sjs_js_Thenable(this, new $c_s_util_Failure($$x1), complete);
    return a$1
  }));
  var $$x3 = $n(pa).apply__O();
  var $$x2 = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(ok);
  var a$3 = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(ko);
  $$x3.then($$x2, a$3)
});
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype.japgolly$scalajs$react$util$JsUtil$$$anonfun$newPromise$3__sjs_js_Function1__O__V = (function(respond$1, a$1) {
  respond$1(a$1)
});
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype.japgolly$scalajs$react$util$JsUtil$$$anonfun$newPromise$1__sjs_js_Function1__sjs_js_Function1__sr_ObjectRef__V = (function(respond, reject, complete$1) {
  $n(complete$1).sr_ObjectRef__f_elem = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_util_Try(x0$1$2);
    if ((x0$1 instanceof $c_s_util_Success)) {
      var x2 = $as_s_util_Success(x0$1);
      var a = $n(x2).s_util_Success__f_value;
      return (() => {
        $m_Ljapgolly_scalajs_react_util_JsUtil$().japgolly$scalajs$react$util$JsUtil$$$anonfun$newPromise$3__sjs_js_Function1__O__V(respond, a)
      })
    } else if ((x0$1 instanceof $c_s_util_Failure)) {
      var x3 = $as_s_util_Failure(x0$1);
      var e = $n(x3).s_util_Failure__f_exception;
      return (() => {
        var this$2 = $m_Ljapgolly_scalajs_react_util_JsUtil$();
        $p_Ljapgolly_scalajs_react_util_JsUtil$__fail$1__jl_Throwable__sjs_js_Function1__O(this$2, e, reject)
      })
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))
});
var $d_Ljapgolly_scalajs_react_util_JsUtil$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_JsUtil$: 0
}, false, "japgolly.scalajs.react.util.JsUtil$", {
  Ljapgolly_scalajs_react_util_JsUtil$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_util_JsUtil$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_JsUtil$;
var $n_Ljapgolly_scalajs_react_util_JsUtil$;
function $m_Ljapgolly_scalajs_react_util_JsUtil$() {
  if ((!$n_Ljapgolly_scalajs_react_util_JsUtil$)) {
    $n_Ljapgolly_scalajs_react_util_JsUtil$ = new $c_Ljapgolly_scalajs_react_util_JsUtil$()
  };
  return $n_Ljapgolly_scalajs_react_util_JsUtil$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$.prototype = $c_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$.prototype;
$c_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$.prototype.unapply__O__s_Option = (function(a) {
  var x1 = $as_T((typeof a));
  return ((x1 === "symbol") ? new $c_s_Some(a) : $m_s_None$())
});
var $d_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$: 0
}, false, "japgolly.scalajs.react.util.JsUtil$JsSymbol$", {
  Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$;
var $n_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$;
function $m_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$() {
  if ((!$n_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$)) {
    $n_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$ = new $c_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$()
  };
  return $n_Ljapgolly_scalajs_react_util_JsUtil$JsSymbol$
}
function $f_Ljapgolly_scalajs_react_util_Monad__chain__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((x$1$2) => fb)))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_OptionLike$() {
  this.Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance = null;
  $n_Ljapgolly_scalajs_react_util_OptionLike$ = this;
  this.Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance = new $c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1();
  new $c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2()
}
$c_Ljapgolly_scalajs_react_util_OptionLike$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_OptionLike$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_OptionLike$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_OptionLike$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_OptionLike$.prototype = $c_Ljapgolly_scalajs_react_util_OptionLike$.prototype;
var $d_Ljapgolly_scalajs_react_util_OptionLike$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_OptionLike$: 0
}, false, "japgolly.scalajs.react.util.OptionLike$", {
  Ljapgolly_scalajs_react_util_OptionLike$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_util_OptionLike$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_OptionLike$;
var $n_Ljapgolly_scalajs_react_util_OptionLike$;
function $m_Ljapgolly_scalajs_react_util_OptionLike$() {
  if ((!$n_Ljapgolly_scalajs_react_util_OptionLike$)) {
    $n_Ljapgolly_scalajs_react_util_OptionLike$ = new $c_Ljapgolly_scalajs_react_util_OptionLike$()
  };
  return $n_Ljapgolly_scalajs_react_util_OptionLike$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_Util$() {
  this.Ljapgolly_scalajs_react_util_Util$__f_identity = null;
  $n_Ljapgolly_scalajs_react_util_Util$ = this;
  this.Ljapgolly_scalajs_react_util_Util$__f_identity = new $c_sjsr_AnonFunction1(((a$2) => a$2))
}
$c_Ljapgolly_scalajs_react_util_Util$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_Util$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_Util$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_Util$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_Util$.prototype = $c_Ljapgolly_scalajs_react_util_Util$.prototype;
$c_Ljapgolly_scalajs_react_util_Util$.prototype.catchAll__F0__s_util_Try = (function(a) {
  try {
    return new $c_s_util_Success($n(a).apply__O())
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    return new $c_s_util_Failure(e$2)
  }
});
$c_Ljapgolly_scalajs_react_util_Util$.prototype.intercalateInto__scm_Builder__sc_Iterator__O__V = (function(b, it, sep) {
  if ($n(it).hasNext__Z()) {
    var first = $n(it).next__O();
    var this$1 = $n(b);
    this$1.addOne__O__scm_Growable(first);
    var this$2 = $n(it);
    while (this$2.hasNext__Z()) {
      var arg1 = this$2.next__O();
      var this$3 = $n(b);
      this$3.addOne__O__scm_Growable(sep);
      var this$4 = $n(b);
      $as_scm_Builder(this$4.addOne__O__scm_Growable(arg1))
    }
  }
});
var $d_Ljapgolly_scalajs_react_util_Util$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_Util$: 0
}, false, "japgolly.scalajs.react.util.Util$", {
  Ljapgolly_scalajs_react_util_Util$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_util_Util$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_Util$;
var $n_Ljapgolly_scalajs_react_util_Util$;
function $m_Ljapgolly_scalajs_react_util_Util$() {
  if ((!$n_Ljapgolly_scalajs_react_util_Util$)) {
    $n_Ljapgolly_scalajs_react_util_Util$ = new $c_Ljapgolly_scalajs_react_util_Util$()
  };
  return $n_Ljapgolly_scalajs_react_util_Util$
}
function $ct_Ljapgolly_scalajs_react_vdom_Attr__T__($thiz, attrName) {
  $thiz.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = attrName;
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Attr() {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null
}
$c_Ljapgolly_scalajs_react_vdom_Attr.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_Attr.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Attr;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Attr() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Attr.prototype = $c_Ljapgolly_scalajs_react_vdom_Attr.prototype;
$c_Ljapgolly_scalajs_react_vdom_Attr.prototype.toString__T = (function() {
  return (("VdomAttr{name=" + this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName) + "}")
});
$c_Ljapgolly_scalajs_react_vdom_Attr.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I($n(this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName))
});
$c_Ljapgolly_scalajs_react_vdom_Attr.prototype.equals__O__Z = (function(any) {
  if ((any instanceof $c_Ljapgolly_scalajs_react_vdom_Attr)) {
    var x2 = $as_Ljapgolly_scalajs_react_vdom_Attr(any);
    return (this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName === $n(x2).Ljapgolly_scalajs_react_vdom_Attr__f_attrName)
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_vdom_Attr(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_vdom_Attr) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.vdom.Attr"))
}
function $isArrayOf_Ljapgolly_scalajs_react_vdom_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_vdom_Attr)))
}
function $asArrayOf_Ljapgolly_scalajs_react_vdom_Attr(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_vdom_Attr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.vdom.Attr;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Attr$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_Attr$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_Attr$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Attr$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Attr$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Attr$.prototype = $c_Ljapgolly_scalajs_react_vdom_Attr$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_Attr$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Attr$: 0
}, false, "japgolly.scalajs.react.vdom.Attr$", {
  Ljapgolly_scalajs_react_vdom_Attr$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Attr$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Attr$;
var $n_Ljapgolly_scalajs_react_vdom_Attr$;
function $m_Ljapgolly_scalajs_react_vdom_Attr$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_Attr$)) {
    $n_Ljapgolly_scalajs_react_vdom_Attr$ = new $c_Ljapgolly_scalajs_react_vdom_Attr$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_Attr$
}
function $f_Ljapgolly_scalajs_react_vdom_Attr$EventCallback1__reusableDispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($thiz, F) {
  return new $c_sjsr_AnonFunction1(((fa$2) => {
    var fa = $as_F0(fa$2);
    return $n(F).dispatchFn__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r = $as_Ljapgolly_scalajs_react_Reusable($n(fa).apply__O());
      return $n(r).value__O()
    })))
  }))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Attr$ValueType$() {
  this.Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_direct = null;
  this.Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_string = null;
  $n_Ljapgolly_scalajs_react_vdom_Attr$ValueType$ = this;
  var fn = new $c_sjsr_AnonFunction2(((x$4$2, x$5$2) => {
    var x$4 = $as_F1(x$4$2);
    $n(x$4).apply__O__O(x$5$2)
  }));
  this.Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_direct = fn;
  var fn$1 = new $c_sjsr_AnonFunction2(((x$6$2, x$7$2) => {
    var x$6 = $as_F1(x$6$2);
    var x$7 = $as_T(x$7$2);
    $n(x$6).apply__O__O(x$7)
  }));
  this.Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_string = fn$1
}
$c_Ljapgolly_scalajs_react_vdom_Attr$ValueType$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_Attr$ValueType$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Attr$ValueType$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Attr$ValueType$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Attr$ValueType$.prototype = $c_Ljapgolly_scalajs_react_vdom_Attr$ValueType$.prototype;
$c_Ljapgolly_scalajs_react_vdom_Attr$ValueType$.prototype.byImplicit__F1__F2 = (function(f) {
  var fn = new $c_sjsr_AnonFunction2(((b$2, a$2) => {
    var b = $as_F1(b$2);
    $n(b).apply__O__O($n(f).apply__O__O(a$2))
  }));
  return fn
});
$c_Ljapgolly_scalajs_react_vdom_Attr$ValueType$.prototype.apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod = (function(this$, name, value) {
  $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  var f = new $c_sjsr_AnonFunction1(((b$2) => {
    var b = $as_Ljapgolly_scalajs_react_vdom_VdomBuilder(b$2);
    $n(this$).apply__O__O__O(new $c_sjsr_AnonFunction1(((x$3$2) => {
      $n($n(b).Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addAttr).apply__O__O__O(name, x$3$2)
    })), value)
  }));
  return new $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3(f)
});
var $d_Ljapgolly_scalajs_react_vdom_Attr$ValueType$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Attr$ValueType$: 0
}, false, "japgolly.scalajs.react.vdom.Attr$ValueType$", {
  Ljapgolly_scalajs_react_vdom_Attr$ValueType$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Attr$ValueType$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Attr$ValueType$;
var $n_Ljapgolly_scalajs_react_vdom_Attr$ValueType$;
function $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_Attr$ValueType$)) {
    $n_Ljapgolly_scalajs_react_vdom_Attr$ValueType$ = new $c_Ljapgolly_scalajs_react_vdom_Attr$ValueType$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_Attr$ValueType$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_CssUnits$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_CssUnits$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_CssUnits$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_CssUnits$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_CssUnits$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_CssUnits$.prototype = $c_Ljapgolly_scalajs_react_vdom_CssUnits$.prototype;
$c_Ljapgolly_scalajs_react_vdom_CssUnits$.prototype.addSuffix$extension__O__T__T = (function(this$, suffix) {
  var s = $dp_toString__T($n(this$));
  return ((s === "0") ? s : (("" + s) + suffix))
});
var $d_Ljapgolly_scalajs_react_vdom_CssUnits$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_CssUnits$: 0
}, false, "japgolly.scalajs.react.vdom.CssUnits$", {
  Ljapgolly_scalajs_react_vdom_CssUnits$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_CssUnits$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_CssUnits$;
var $n_Ljapgolly_scalajs_react_vdom_CssUnits$;
function $m_Ljapgolly_scalajs_react_vdom_CssUnits$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_CssUnits$)) {
    $n_Ljapgolly_scalajs_react_vdom_CssUnits$ = new $c_Ljapgolly_scalajs_react_vdom_CssUnits$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_CssUnits$
}
function $ct_Ljapgolly_scalajs_react_vdom_Exports__($thiz) {
  $thiz.Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom = $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty;
  $thiz.Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $thiz.Ljapgolly_scalajs_react_vdom_Exports__f_TagMod = $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  $thiz.Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr = $m_Ljapgolly_scalajs_react_vdom_Attr$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  $thiz.Ljapgolly_scalajs_react_vdom_Exports__f_VdomStyle = $m_Ljapgolly_scalajs_react_vdom_Style$();
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Exports() {
  this.Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_TagMod = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomStyle = null
}
$c_Ljapgolly_scalajs_react_vdom_Exports.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_Exports.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Exports;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Exports() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Exports.prototype = $c_Ljapgolly_scalajs_react_vdom_Exports.prototype;
function $f_Ljapgolly_scalajs_react_vdom_HtmlAttrs__$init$__V($thiz) {
  $thiz.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$key_$eq__Ljapgolly_scalajs_react_vdom_Attr$Key$__V($m_Ljapgolly_scalajs_react_vdom_Attr$Key$());
  $thiz.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$onChange_$eq__Ljapgolly_scalajs_react_vdom_Attr$Event__V(new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onChange"));
  $thiz.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$onClick_$eq__Ljapgolly_scalajs_react_vdom_Attr$Event__V(new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onClick"));
  $thiz.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$onClickCapture_$eq__Ljapgolly_scalajs_react_vdom_Attr$Event__V(new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onClickCapture"));
  $thiz.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$src_$eq__Ljapgolly_scalajs_react_vdom_Attr__V(($n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr), $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "src")));
  $thiz.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$title_$eq__Ljapgolly_scalajs_react_vdom_Attr__V(($n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr), $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "title")));
  $thiz.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$type_$eq__Ljapgolly_scalajs_react_vdom_Attr__V(($n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr), $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "type")));
  $thiz.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$value_$eq__Ljapgolly_scalajs_react_vdom_Attr__V(($n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr), $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "value")))
}
function $f_Ljapgolly_scalajs_react_vdom_HtmlTags__br__T($thiz) {
  return "br"
}
function $f_Ljapgolly_scalajs_react_vdom_HtmlTags__hr__T($thiz) {
  return "hr"
}
function $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T($thiz) {
  return "img"
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O) {
  this.Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt__f_o = null;
  this.Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt__f_O = null;
  this.Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt__f_o = o;
  this.Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt__f_O = O
}
$c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt.prototype = $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt.prototype;
$c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt.prototype.whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod = (function(f) {
  return $as_Ljapgolly_scalajs_react_vdom_TagMod($n(this.Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt__f_O).fold__O__F0__F1__O(this.Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt__f_o, new $c_sjsr_AnonFunction0((() => $m_Ljapgolly_scalajs_react_vdom_TagMod$().Ljapgolly_scalajs_react_vdom_TagMod$__f_empty)), f))
});
var $d_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt: 0
}, false, "japgolly.scalajs.react.vdom.ImplicitsForTagMod$OptionExt", {
  Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$.prototype = $c_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$.prototype;
$c_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$.prototype.mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod = (function(this$, start, sep, end, f) {
  $n($m_s_package$().s_package$__f_Vector);
  var b = new $c_sci_VectorBuilder();
  if ((start !== $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty)) {
    b.addOne__O__sci_VectorBuilder(start)
  };
  var $$x1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var this$2 = $n($n(this$).iterator__sc_Iterator());
  $n($$x1).intercalateInto__scm_Builder__sc_Iterator__O__V(b, new $c_sc_Iterator$$anon$9(this$2, f), sep);
  if ((end !== $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty)) {
    b.addOne__O__sci_VectorBuilder(end)
  };
  return $m_Ljapgolly_scalajs_react_vdom_TagMod$().fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(b.result__sci_Vector())
});
$c_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$.prototype.toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod = (function(this$, f) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  var this$1 = $n($n(this$).iterator__sc_Iterator());
  return $n($$x1).fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sc_Iterator$$anon$9(this$1, f))
});
var $d_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$: 0
}, false, "japgolly.scalajs.react.vdom.ImplicitsForVdomNode$TraversableOnceExt$", {
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$;
var $n_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$;
function $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$)) {
    $n_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$ = new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Style$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_Style$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_Style$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Style$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Style$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Style$.prototype = $c_Ljapgolly_scalajs_react_vdom_Style$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_Style$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Style$: 0
}, false, "japgolly.scalajs.react.vdom.Style$", {
  Ljapgolly_scalajs_react_vdom_Style$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Style$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Style$;
var $n_Ljapgolly_scalajs_react_vdom_Style$;
function $m_Ljapgolly_scalajs_react_vdom_Style$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_Style$)) {
    $n_Ljapgolly_scalajs_react_vdom_Style$ = new $c_Ljapgolly_scalajs_react_vdom_Style$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_Style$
}
function $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod($thiz, condition) {
  return (condition ? $thiz : $m_Ljapgolly_scalajs_react_vdom_TagMod$().Ljapgolly_scalajs_react_vdom_TagMod$__f_empty)
}
function $is_Ljapgolly_scalajs_react_vdom_TagMod(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_vdom_TagMod)))
}
function $as_Ljapgolly_scalajs_react_vdom_TagMod(obj) {
  return (($is_Ljapgolly_scalajs_react_vdom_TagMod(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.vdom.TagMod"))
}
function $isArrayOf_Ljapgolly_scalajs_react_vdom_TagMod(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_vdom_TagMod)))
}
function $asArrayOf_Ljapgolly_scalajs_react_vdom_TagMod(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_vdom_TagMod(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.vdom.TagMod;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_TagMod$() {
  this.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty = null;
  $n_Ljapgolly_scalajs_react_vdom_TagMod$ = this;
  this.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty = new $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2()
}
$c_Ljapgolly_scalajs_react_vdom_TagMod$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_TagMod$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_TagMod$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_TagMod$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_TagMod$.prototype = $c_Ljapgolly_scalajs_react_vdom_TagMod$.prototype;
$c_Ljapgolly_scalajs_react_vdom_TagMod$.prototype.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod = (function(t) {
  var this$2 = $n($n(t).iterator__sc_Iterator());
  var factory = $m_s_package$().s_package$__f_Vector;
  var factory$1 = new $c_sc_IterableFactory$ToFactory(factory);
  var v = $as_sci_Vector(factory$1.fromSpecific__sc_IterableOnce__O(this$2));
  var x1 = $n(v).length__I();
  switch (x1) {
    case 1: {
      return $as_Ljapgolly_scalajs_react_vdom_TagMod($n(v).head__O());
      break
    }
    case 0: {
      return this.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
      break
    }
    default: {
      return new $c_Ljapgolly_scalajs_react_vdom_TagMod$Composite(v)
    }
  }
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$.prototype.when__Z__F0__Ljapgolly_scalajs_react_vdom_TagMod = (function(cond, t) {
  return (cond ? $as_Ljapgolly_scalajs_react_vdom_TagMod($n(t).apply__O()) : this.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty)
});
var $d_Ljapgolly_scalajs_react_vdom_TagMod$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_TagMod$: 0
}, false, "japgolly.scalajs.react.vdom.TagMod$", {
  Ljapgolly_scalajs_react_vdom_TagMod$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_TagMod$;
var $n_Ljapgolly_scalajs_react_vdom_TagMod$;
function $m_Ljapgolly_scalajs_react_vdom_TagMod$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_TagMod$)) {
    $n_Ljapgolly_scalajs_react_vdom_TagMod$ = new $c_Ljapgolly_scalajs_react_vdom_TagMod$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_TagMod$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_VdomArray$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_VdomArray$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_VdomArray$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_VdomArray$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_VdomArray$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_VdomArray$.prototype = $c_Ljapgolly_scalajs_react_vdom_VdomArray$.prototype;
$c_Ljapgolly_scalajs_react_vdom_VdomArray$.prototype.empty__Ljapgolly_scalajs_react_vdom_VdomArray = (function() {
  return new $c_Ljapgolly_scalajs_react_vdom_VdomArray([])
});
var $d_Ljapgolly_scalajs_react_vdom_VdomArray$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_VdomArray$: 0
}, false, "japgolly.scalajs.react.vdom.VdomArray$", {
  Ljapgolly_scalajs_react_vdom_VdomArray$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_VdomArray$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_VdomArray$;
var $n_Ljapgolly_scalajs_react_vdom_VdomArray$;
function $m_Ljapgolly_scalajs_react_vdom_VdomArray$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_VdomArray$)) {
    $n_Ljapgolly_scalajs_react_vdom_VdomArray$ = new $c_Ljapgolly_scalajs_react_vdom_VdomArray$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_VdomArray$
}
function $f_Ljapgolly_scalajs_react_vdom_VdomBuilder__addStyles__sjs_js_Any__V($thiz, j) {
  $n($thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addStylesObject).apply__O__O(j)
}
function $is_Ljapgolly_scalajs_react_vdom_VdomBuilder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_vdom_VdomBuilder)))
}
function $as_Ljapgolly_scalajs_react_vdom_VdomBuilder(obj) {
  return (($is_Ljapgolly_scalajs_react_vdom_VdomBuilder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.vdom.VdomBuilder"))
}
function $isArrayOf_Ljapgolly_scalajs_react_vdom_VdomBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_vdom_VdomBuilder)))
}
function $asArrayOf_Ljapgolly_scalajs_react_vdom_VdomBuilder(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_vdom_VdomBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.vdom.VdomBuilder;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$() {
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$__f_build = null;
  $n_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$ = this;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$__f_build = new $c_sjsr_AnonFunction4(((tag$2, props$2, key$2, children$2) => {
    var tag = $as_T(tag$2);
    if ((key$2 !== (void 0))) {
      props$2.key = key$2
    };
    var $$x1 = $i_react;
    var seq = $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), children$2));
    return $$x1.createElement(tag, props$2, ...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(seq))
  }))
}
$c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$.prototype = $c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$: 0
}, false, "japgolly.scalajs.react.vdom.VdomBuilder$ToRawReactElement$", {
  Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$;
var $n_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$;
function $m_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$)) {
    $n_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$ = new $c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_VdomNode$() {
  this.Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty = null;
  $n_Ljapgolly_scalajs_react_vdom_VdomNode$ = this;
  this.Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(null)
}
$c_Ljapgolly_scalajs_react_vdom_VdomNode$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_VdomNode$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_VdomNode$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_VdomNode$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_VdomNode$.prototype = $c_Ljapgolly_scalajs_react_vdom_VdomNode$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_VdomNode$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_VdomNode$: 0
}, false, "japgolly.scalajs.react.vdom.VdomNode$", {
  Ljapgolly_scalajs_react_vdom_VdomNode$: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_VdomNode$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_VdomNode$;
var $n_Ljapgolly_scalajs_react_vdom_VdomNode$;
function $m_Ljapgolly_scalajs_react_vdom_VdomNode$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_VdomNode$)) {
    $n_Ljapgolly_scalajs_react_vdom_VdomNode$ = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_VdomNode$
}
function $is_jl_Comparable(obj) {
  return ((((((!(!((obj && obj.$classData) && obj.$classData.ancestors.jl_Comparable))) || ((typeof obj) === "string")) || ((typeof obj) === "number")) || ((typeof obj) === "boolean")) || (obj instanceof $c_RTLong)) || (obj instanceof $Char))
}
function $as_jl_Comparable(obj) {
  return (($is_jl_Comparable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Comparable"))
}
function $isArrayOf_jl_Comparable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Comparable)))
}
function $asArrayOf_jl_Comparable(obj, depth) {
  return (($isArrayOf_jl_Comparable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Comparable;", depth))
}
/** @constructor */
function $c_jl_FloatingPointBits$() {
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = false;
  this.jl_FloatingPointBits$__f_arrayBuffer = null;
  this.jl_FloatingPointBits$__f_int32Array = null;
  this.jl_FloatingPointBits$__f_float32Array = null;
  this.jl_FloatingPointBits$__f_float64Array = null;
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = false;
  this.jl_FloatingPointBits$__f_highOffset = 0;
  this.jl_FloatingPointBits$__f_lowOffset = 0;
  this.jl_FloatingPointBits$__f_floatPowsOf2 = null;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$doublePowsOf2 = null;
  $n_jl_FloatingPointBits$ = this;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = true;
  this.jl_FloatingPointBits$__f_arrayBuffer = new ArrayBuffer(8);
  this.jl_FloatingPointBits$__f_int32Array = new Int32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2);
  this.jl_FloatingPointBits$__f_float32Array = new Float32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2);
  this.jl_FloatingPointBits$__f_float64Array = new Float64Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 1);
  this.jl_FloatingPointBits$__f_int32Array[0] = 16909060;
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = ($uB(new Int8Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 8)[0]) === 1);
  this.jl_FloatingPointBits$__f_highOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 0 : 1);
  this.jl_FloatingPointBits$__f_lowOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 1 : 0);
  this.jl_FloatingPointBits$__f_floatPowsOf2 = null;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$doublePowsOf2 = null
}
$c_jl_FloatingPointBits$.prototype = new $h_O();
$c_jl_FloatingPointBits$.prototype.constructor = $c_jl_FloatingPointBits$;
/** @constructor */
function $h_jl_FloatingPointBits$() {
  /*<skip>*/
}
$h_jl_FloatingPointBits$.prototype = $c_jl_FloatingPointBits$.prototype;
$c_jl_FloatingPointBits$.prototype.numberHashCode__D__I = (function(value) {
  var iv = $uI((value | 0.0));
  if (((iv === value) && ((1.0 / value) !== (-Infinity)))) {
    return iv
  } else {
    this.jl_FloatingPointBits$__f_float64Array[0] = value;
    return ($uI(this.jl_FloatingPointBits$__f_int32Array[0]) ^ $uI(this.jl_FloatingPointBits$__f_int32Array[1]))
  }
});
$c_jl_FloatingPointBits$.prototype.intBitsToFloat__I__F = (function(bits) {
  this.jl_FloatingPointBits$__f_int32Array[0] = bits;
  return $uF(this.jl_FloatingPointBits$__f_float32Array[0])
});
$c_jl_FloatingPointBits$.prototype.floatToIntBits__F__I = (function(value) {
  this.jl_FloatingPointBits$__f_float32Array[0] = value;
  return $uI(this.jl_FloatingPointBits$__f_int32Array[0])
});
$c_jl_FloatingPointBits$.prototype.doubleToLongBits__D__J = (function(value) {
  this.jl_FloatingPointBits$__f_float64Array[0] = value;
  var value$1 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_highOffset]);
  var value$2 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_lowOffset]);
  return new $c_RTLong(value$2, value$1)
});
var $d_jl_FloatingPointBits$ = new $TypeData().initClass({
  jl_FloatingPointBits$: 0
}, false, "java.lang.FloatingPointBits$", {
  jl_FloatingPointBits$: 1,
  O: 1
});
$c_jl_FloatingPointBits$.prototype.$classData = $d_jl_FloatingPointBits$;
var $n_jl_FloatingPointBits$;
function $m_jl_FloatingPointBits$() {
  if ((!$n_jl_FloatingPointBits$)) {
    $n_jl_FloatingPointBits$ = new $c_jl_FloatingPointBits$()
  };
  return $n_jl_FloatingPointBits$
}
/** @constructor */
function $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, paddingZeros, overflowBarrier) {
  this.jl_Long$StringRadixInfo__f_chunkLength = 0;
  this.jl_Long$StringRadixInfo__f_radixPowLength = $L0;
  this.jl_Long$StringRadixInfo__f_paddingZeros = null;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = $L0;
  this.jl_Long$StringRadixInfo__f_chunkLength = chunkLength;
  this.jl_Long$StringRadixInfo__f_radixPowLength = radixPowLength;
  this.jl_Long$StringRadixInfo__f_paddingZeros = paddingZeros;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = overflowBarrier
}
$c_jl_Long$StringRadixInfo.prototype = new $h_O();
$c_jl_Long$StringRadixInfo.prototype.constructor = $c_jl_Long$StringRadixInfo;
/** @constructor */
function $h_jl_Long$StringRadixInfo() {
  /*<skip>*/
}
$h_jl_Long$StringRadixInfo.prototype = $c_jl_Long$StringRadixInfo.prototype;
function $as_jl_Long$StringRadixInfo(obj) {
  return (((obj instanceof $c_jl_Long$StringRadixInfo) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long$StringRadixInfo"))
}
function $isArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long$StringRadixInfo)))
}
function $asArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (($isArrayOf_jl_Long$StringRadixInfo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long$StringRadixInfo;", depth))
}
var $d_jl_Long$StringRadixInfo = new $TypeData().initClass({
  jl_Long$StringRadixInfo: 0
}, false, "java.lang.Long$StringRadixInfo", {
  jl_Long$StringRadixInfo: 1,
  O: 1
});
$c_jl_Long$StringRadixInfo.prototype.$classData = $d_jl_Long$StringRadixInfo;
/** @constructor */
function $c_jl_Math$() {
  /*<skip>*/
}
$c_jl_Math$.prototype = new $h_O();
$c_jl_Math$.prototype.constructor = $c_jl_Math$;
/** @constructor */
function $h_jl_Math$() {
  /*<skip>*/
}
$h_jl_Math$.prototype = $c_jl_Math$.prototype;
$c_jl_Math$.prototype.nextUp__F__F = (function(a) {
  if (((a !== a) || (a === Infinity))) {
    return a
  } else if ((a === (-0))) {
    return 1.401298464324817E-45
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? ((1 + abits) | 0) : (((-1) + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits)
  }
});
$c_jl_Math$.prototype.nextDown__F__F = (function(a) {
  if (((a !== a) || (a === (-Infinity)))) {
    return a
  } else if ((a === 0.0)) {
    return (-1.401298464324817E-45)
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? (((-1) + abits) | 0) : ((1 + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits)
  }
});
$c_jl_Math$.prototype.addExact__I__I__I = (function(a, b) {
  var res = ((a + b) | 0);
  var resSgnBit = (res < 0);
  if (((resSgnBit === (a < 0)) || (resSgnBit === (b < 0)))) {
    return res
  } else {
    throw new $c_jl_ArithmeticException("Integer overflow")
  }
});
$c_jl_Math$.prototype.addExact__J__J__J = (function(a, b) {
  var alo = a.RTLong__f_lo;
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo + b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  var resSgnBit = (hi < 0);
  var ahi$1 = a.RTLong__f_hi;
  if ((resSgnBit === (ahi$1 < 0))) {
    var $$x1 = true
  } else {
    var ahi$2 = b.RTLong__f_hi;
    var $$x1 = (resSgnBit === (ahi$2 < 0))
  };
  if ($$x1) {
    return new $c_RTLong(lo, hi)
  } else {
    throw new $c_jl_ArithmeticException("Long overflow")
  }
});
$c_jl_Math$.prototype.subtractExact__J__J__J = (function(a, b) {
  var alo = a.RTLong__f_lo;
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo - b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
  var resSgnBit = (hi < 0);
  var ahi$1 = a.RTLong__f_hi;
  if ((resSgnBit === (ahi$1 < 0))) {
    var $$x1 = true
  } else {
    var ahi$2 = b.RTLong__f_hi;
    var $$x1 = (resSgnBit === ((ahi$2 === 0) ? (b.RTLong__f_lo !== 0) : (ahi$2 > 0)))
  };
  if ($$x1) {
    return new $c_RTLong(lo, hi)
  } else {
    throw new $c_jl_ArithmeticException("Long overflow")
  }
});
$c_jl_Math$.prototype.multiplyExact__I__I__I = (function(a, b) {
  var overflow = ((b > 0) ? ((a > $intDiv(2147483647, b)) || (a < $intDiv((-2147483648), b))) : ((b < (-1)) ? ((a > $intDiv((-2147483648), b)) || (a < $intDiv(2147483647, b))) : ((b === (-1)) && (a === (-2147483648)))));
  if ((!overflow)) {
    return Math.imul(a, b)
  } else {
    throw new $c_jl_ArithmeticException("Integer overflow")
  }
});
$c_jl_Math$.prototype.multiplyExact__J__J__J = (function(a, b) {
  var ahi = b.RTLong__f_hi;
  if (((ahi === 0) ? (b.RTLong__f_lo !== 0) : (ahi > 0))) {
    var this$1 = $m_RTLong$();
    var lo = this$1.divideImpl__I__I__I__I__I((-1), 2147483647, b.RTLong__f_lo, b.RTLong__f_hi);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var ahi$1 = a.RTLong__f_hi;
    if (((ahi$1 === hi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ lo)) : (ahi$1 > hi))) {
      var overflow = true
    } else {
      var this$2 = $m_RTLong$();
      var lo$1 = this$2.divideImpl__I__I__I__I__I(0, (-2147483648), b.RTLong__f_lo, b.RTLong__f_hi);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var ahi$2 = a.RTLong__f_hi;
      var overflow = ((ahi$2 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$2 < hi$1))
    }
  } else {
    var ahi$3 = b.RTLong__f_hi;
    if (((ahi$3 === (-1)) ? (b.RTLong__f_lo !== (-1)) : (ahi$3 < (-1)))) {
      var this$3 = $m_RTLong$();
      var lo$2 = this$3.divideImpl__I__I__I__I__I(0, (-2147483648), b.RTLong__f_lo, b.RTLong__f_hi);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var ahi$4 = a.RTLong__f_hi;
      if (((ahi$4 === hi$2) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ lo$2)) : (ahi$4 > hi$2))) {
        var overflow = true
      } else {
        var this$4 = $m_RTLong$();
        var lo$3 = this$4.divideImpl__I__I__I__I__I((-1), 2147483647, b.RTLong__f_lo, b.RTLong__f_hi);
        var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var ahi$5 = a.RTLong__f_hi;
        var overflow = ((ahi$5 === hi$3) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$3)) : (ahi$5 < hi$3))
      }
    } else {
      var overflow = (((b.RTLong__f_lo === (-1)) && (b.RTLong__f_hi === (-1))) && ((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === (-2147483648))))
    }
  };
  if ((!overflow)) {
    var alo = a.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return new $c_RTLong(lo$4, hi$4)
  } else {
    throw new $c_jl_ArithmeticException("Long overflow")
  }
});
$c_jl_Math$.prototype.toIntExact__J__I = (function(a) {
  var ahi = a.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ a.RTLong__f_lo) >= 0) : (ahi > (-1)))) {
    var ahi$1 = a.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ a.RTLong__f_lo) <= (-1)) : (ahi$1 < 0))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return a.RTLong__f_lo
  } else {
    throw new $c_jl_ArithmeticException("Integer overflow")
  }
});
$c_jl_Math$.prototype.floorDiv__J__J__J = (function(a, b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var ahi = a.RTLong__f_hi;
  var ahi$1 = b.RTLong__f_hi;
  if (((ahi < 0) === (ahi$1 < 0))) {
    var $$x1 = true
  } else {
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & lo);
    var a1 = ((lo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(lo, b.RTLong__f_hi) + Math.imul(hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var $$x1 = ((lo$1 === a.RTLong__f_lo) && (hi$1 === a.RTLong__f_hi))
  };
  if ($$x1) {
    return new $c_RTLong(lo, hi)
  } else {
    var lo$2 = (((-1) + lo) | 0);
    var hi$2 = ((lo$2 !== (-1)) ? hi : (((-1) + hi) | 0));
    return new $c_RTLong(lo$2, hi$2)
  }
});
$c_jl_Math$.prototype.floorMod__I__I__I = (function(a, b) {
  var rem = $intMod(a, b);
  return ((((a < 0) === (b < 0)) || (rem === 0)) ? rem : ((rem + b) | 0))
});
$c_jl_Math$.prototype.floorMod__J__J__J = (function(a, b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var ahi = a.RTLong__f_hi;
  var ahi$1 = b.RTLong__f_hi;
  if ((((ahi < 0) === (ahi$1 < 0)) || ((lo === 0) && (hi === 0)))) {
    return new $c_RTLong(lo, hi)
  } else {
    var bhi = b.RTLong__f_hi;
    var lo$1 = ((lo + b.RTLong__f_lo) | 0);
    var hi$1 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi + bhi) | 0)) | 0) : ((hi + bhi) | 0));
    return new $c_RTLong(lo$1, hi$1)
  }
});
var $d_jl_Math$ = new $TypeData().initClass({
  jl_Math$: 0
}, false, "java.lang.Math$", {
  jl_Math$: 1,
  O: 1
});
$c_jl_Math$.prototype.$classData = $d_jl_Math$;
var $n_jl_Math$;
function $m_jl_Math$() {
  if ((!$n_jl_Math$)) {
    $n_jl_Math$ = new $c_jl_Math$()
  };
  return $n_jl_Math$
}
var $d_jl_Runnable = new $TypeData().initClass({
  jl_Runnable: 0
}, true, "java.lang.Runnable", {
  jl_Runnable: 1,
  O: 1
});
function $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines) {
  var NormalizedFrameLine = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^([^@]*)@(.*?):([0-9]+)(?::([0-9]+))?$");
  var trace = [];
  var i = 0;
  while ((i < $uI(lines.length))) {
    var line = $as_T(lines[i]);
    var this$1 = $n(line);
    if ((!(this$1 === ""))) {
      var mtch = NormalizedFrameLine.exec(line);
      if ((mtch !== null)) {
        var x = mtch[1];
        var classAndMethodName = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, $as_T(x));
        var $$x6 = $as_T(classAndMethodName[0]);
        var $$x5 = $as_T(classAndMethodName[1]);
        var x$1 = mtch[2];
        var $$x4 = $as_T(x$1);
        var x$2 = mtch[3];
        var s = $as_T(x$2);
        var $$x3 = $uI(parseInt(s));
        var x$3 = mtch[4];
        if ((x$3 !== (void 0))) {
          var x$1$1 = $as_T(x$3);
          var $$x2 = $uI(parseInt(x$1$1))
        } else {
          var $$x2 = (-1)
        };
        var $$x1 = trace.push(new $c_jl_StackTraceElement($$x6, $$x5, $$x4, $$x3, $$x2));
        $uI($$x1)
      } else {
        $uI(trace.push(new $c_jl_StackTraceElement("<jscode>", line, null, (-1), (-1))))
      }
    };
    i = ((1 + i) | 0)
  };
  var len = $uI(trace.length);
  var result = new ($d_jl_StackTraceElement.getArrayOf().constr)(len);
  i = 0;
  while ((i < len)) {
    $n(result).set(i, $as_jl_StackTraceElement(trace[i]));
    i = ((1 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractClassMethod__T__O($thiz, functionName) {
  var PatBC = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$[bc]_([^\\.]+)(?:\\.prototype)?\\.([^\\.]+)$");
  var PatS = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$(?:ps?|s|f)_((?:_[^_]|[^_])+)__([^\\.]+)$");
  var PatCT = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$ct_((?:_[^_]|[^_])+)__([^\\.]*)$");
  var PatN = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^new (?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$c_([^\\.]+)$");
  var PatM = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$m_([^\\.]+)$");
  var matchBC = PatBC.exec(functionName);
  var matchBCOrS = ((matchBC !== null) ? matchBC : PatS.exec(functionName));
  if ((matchBCOrS !== null)) {
    var x = matchBCOrS[1];
    var $$x1 = $p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x));
    var x$1 = matchBCOrS[2];
    return [$$x1, $p_jl_StackTrace$__decodeMethodName__T__T($thiz, $as_T(x$1))]
  } else {
    var matchCT = PatCT.exec(functionName);
    var matchCTOrN = ((matchCT !== null) ? matchCT : PatN.exec(functionName));
    if ((matchCTOrN !== null)) {
      var x$2 = matchCTOrN[1];
      return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$2)), "<init>"]
    } else {
      var matchM = PatM.exec(functionName);
      if ((matchM !== null)) {
        var x$3 = matchM[1];
        return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$3)), "<clinit>"]
      } else {
        return ["<jscode>", functionName]
      }
    }
  }
}
function $p_jl_StackTrace$__decodeClassName__T__T($thiz, encodedName) {
  var dict = $p_jl_StackTrace$__decompressedClasses__O($thiz);
  if ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, encodedName))) {
    var dict$1 = $p_jl_StackTrace$__decompressedClasses__O($thiz);
    var base = $as_T(dict$1[encodedName])
  } else {
    var base = $p_jl_StackTrace$__loop$1__I__T__T($thiz, 0, encodedName)
  };
  var this$3 = $n(base);
  var this$4 = $n($as_T(this$3.split("_").join(".")));
  return $as_T(this$4.split("\uff3f").join("_"))
}
function $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = {};
    dict.O = "java_lang_Object";
    dict.T = "java_lang_String";
    var index = 0;
    while ((index <= 22)) {
      if ((index >= 2)) {
        var key = ("T" + index);
        var value = ("scala_Tuple" + index);
        dict[key] = value
      };
      var key$1 = ("F" + index);
      var value$1 = ("scala_Function" + index);
      dict[key$1] = value$1;
      index = ((1 + index) | 0)
    };
    $thiz.jl_StackTrace$__f_decompressedClasses = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((1 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_StackTrace$__f_decompressedClasses
}
function $p_jl_StackTrace$__decompressedClasses__O($thiz) {
  return (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedClasses)
}
function $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = {};
    dict.sjsr_ = "scala_scalajs_runtime_";
    dict.sjs_ = "scala_scalajs_";
    dict.sci_ = "scala_collection_immutable_";
    dict.scm_ = "scala_collection_mutable_";
    dict.scg_ = "scala_collection_generic_";
    dict.sc_ = "scala_collection_";
    dict.sr_ = "scala_runtime_";
    dict.s_ = "scala_";
    dict.jl_ = "java_lang_";
    dict.ju_ = "java_util_";
    $thiz.jl_StackTrace$__f_decompressedPrefixes = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((2 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_StackTrace$__f_decompressedPrefixes
}
function $p_jl_StackTrace$__decompressedPrefixes__O($thiz) {
  return (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedPrefixes)
}
function $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) {
  if (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_StackTrace$__f_compressedPrefixes = Object.keys($p_jl_StackTrace$__decompressedPrefixes__O($thiz));
    $thiz.jl_StackTrace$__f_bitmap$0 = (((4 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_StackTrace$__f_compressedPrefixes
}
function $p_jl_StackTrace$__compressedPrefixes__O($thiz) {
  return (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_compressedPrefixes)
}
function $p_jl_StackTrace$__decodeMethodName__T__T($thiz, encodedName) {
  var this$1 = $n(encodedName);
  if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 7)) === "init___"))) {
    return "<init>"
  } else {
    var this$2 = $n(encodedName);
    var methodNameLen = $uI(this$2.indexOf("__"));
    return ((methodNameLen < 0) ? encodedName : $as_T(encodedName.substring(0, methodNameLen)))
  }
}
function $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, e) {
  return ($uZ((!(!(!e)))) ? [] : ($uZ((!(!(e.arguments && e.stack)))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : ($uZ((!(!(e.stack && e.sourceURL)))) ? $p_jl_StackTrace$__extractSafari__O__O($thiz, e) : ($uZ((!(!(e.stack && e.number)))) ? $p_jl_StackTrace$__extractIE__O__O($thiz, e) : ($uZ((!(!(e.stack && e.fileName)))) ? $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) : ($uZ((!(!(e.message && e["opera#sourceloc"])))) ? ($uZ((!(!(!e.stacktrace)))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : ($uZ((!(!((e.message.indexOf("\n") > (-1.0)) && (e.message.split("\n").length > e.stacktrace.split("\n").length))))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e))) : ($uZ((!(!((e.message && e.stack) && e.stacktrace)))) ? ($uZ((!(!(e.stacktrace.indexOf("called from line") < 0.0)))) ? $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera11__O__O($thiz, e)) : ($uZ((!(!(e.stack && (!e.fileName))))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : $p_jl_StackTrace$__extractOther__O__O($thiz, e)))))))))
}
function $p_jl_StackTrace$__extractChrome__O__O($thiz, e) {
  return $as_T($as_T($as_T($as_T($as_T(($as_T(e.stack) + "\n").replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("^[\\s\\S]+?\\s+at\\s+"), " at ")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^\\s+(at eval )?at\\s+", "gm"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+?)([\\n])", "gm"), "{anonymous}() ($1)$2")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^Object.<anonymous>\\s*\\(([^\\)]+)\\)", "gm"), "{anonymous}() ($1)")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\)) \\((.+)\\)$", "gm"), "$1@$2")).split("\n").slice(0, (-1))
}
function $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) {
  return $as_T($as_T($as_T(e.stack).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("(?:\\n@:0)?\\s+$", "m"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^(?:\\((\\S*)\\))?@", "gm"), "{anonymous}($1)@")).split("\n")
}
function $p_jl_StackTrace$__extractIE__O__O($thiz, e) {
  var qual$1 = $as_T($as_T($as_T($as_T(e.stack).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^\\s*at\\s+(.*)$", "gm"), "$1")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^Anonymous function\\s+", "gm"), "{anonymous}() ")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\))\\s+\\((.+)\\)$", "gm"), "$1@$2")).split("\n");
  return qual$1.slice(1)
}
function $p_jl_StackTrace$__extractSafari__O__O($thiz, e) {
  return $as_T($as_T($as_T($as_T(e.stack).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("\\[native code\\]\\n", "m"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^(?=\\w+Error\\:).*$\\n", "m"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^@", "gm"), "{anonymous}()@")).split("\n")
}
function $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension1__T__T__O("Line (\\d+).*script (?:in )?(\\S+)", "i");
  var lines = $as_T(e.message).split("\n");
  var result = [];
  var i = 2;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[2];
      var x$1 = mtch[1];
      var $$x1 = result.push(((("{anonymous}()@" + x) + ":") + x$1));
      $uI($$x1)
    };
    i = ((2 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension1__T__T__O("Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$", "i");
  var lines = $as_T(e.stacktrace).split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[3];
      var fnName = $as_T(((x !== (void 0)) ? x : "{anonymous}"));
      var x$1 = mtch[2];
      var x$2 = mtch[1];
      var $$x1 = result.push(((((fnName + "()@") + x$1) + ":") + x$2));
      $uI($$x1)
    };
    i = ((2 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(.*)@(.+):(\\d+)$");
  var lines = $as_T(e.stacktrace).split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[1];
      if ((x !== (void 0))) {
        var x$2 = $as_T(x);
        var fnName = (x$2 + "()")
      } else {
        var fnName = "global code"
      };
      var x$1 = mtch[2];
      var x$3 = mtch[3];
      var $$x1 = result.push(((((fnName + "@") + x$1) + ":") + x$3));
      $uI($$x1)
    };
    i = ((1 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOpera11__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^.*line (\\d+), column (\\d+)(?: in (.+))? in (\\S+):$");
  var lines = $as_T(e.stacktrace).split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[4];
      var $$x1 = $as_T(x);
      var x$1 = mtch[1];
      var x$2 = mtch[2];
      var location = (((($$x1 + ":") + x$1) + ":") + x$2);
      var x$3 = mtch[2];
      var fnName0 = $as_T(((x$3 !== (void 0)) ? x$3 : "global code"));
      var fnName = $as_T($as_T(fnName0.replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("<anonymous function: (\\S+)>"), "$1")).replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("<anonymous function>"), "{anonymous}"));
      $uI(result.push(((fnName + "@") + location)))
    };
    i = ((2 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOther__O__O($thiz, e) {
  return []
}
function $p_jl_StackTrace$__loop$1__I__T__T($thiz, i, encodedName$1) {
  while (true) {
    if ((i < $uI($p_jl_StackTrace$__compressedPrefixes__O($thiz).length))) {
      var prefix = $as_T($p_jl_StackTrace$__compressedPrefixes__O($thiz)[i]);
      var this$1 = $n(encodedName$1);
      if ((this$1.length >= 0)) {
        var this$2 = $n(prefix);
        var $$x2 = this$1.substring(0, this$2.length);
        var $$x1 = ($as_T($$x2) === prefix)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var dict = $p_jl_StackTrace$__decompressedPrefixes__O($thiz);
        var $$x4 = $as_T(dict[prefix]);
        var this$4 = $n(prefix);
        var $$x3 = encodedName$1.substring(this$4.length);
        return (("" + $$x4) + $as_T($$x3))
      } else {
        i = ((1 + i) | 0)
      }
    } else {
      var this$5 = $n(encodedName$1);
      if (((this$5.length >= 0) && ($as_T(this$5.substring(0, 1)) === "L"))) {
        return $as_T(encodedName$1.substring(1))
      } else {
        return encodedName$1
      }
    }
  }
}
/** @constructor */
function $c_jl_StackTrace$() {
  this.jl_StackTrace$__f_decompressedClasses = null;
  this.jl_StackTrace$__f_decompressedPrefixes = null;
  this.jl_StackTrace$__f_compressedPrefixes = null;
  this.jl_StackTrace$__f_bitmap$0 = 0
}
$c_jl_StackTrace$.prototype = new $h_O();
$c_jl_StackTrace$.prototype.constructor = $c_jl_StackTrace$;
/** @constructor */
function $h_jl_StackTrace$() {
  /*<skip>*/
}
$h_jl_StackTrace$.prototype = $c_jl_StackTrace$.prototype;
$c_jl_StackTrace$.prototype.extract__O__Ajl_StackTraceElement = (function(jsError) {
  var lines = $p_jl_StackTrace$__normalizeStackTraceLines__O__O(this, jsError);
  return $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement(this, lines)
});
var $d_jl_StackTrace$ = new $TypeData().initClass({
  jl_StackTrace$: 0
}, false, "java.lang.StackTrace$", {
  jl_StackTrace$: 1,
  O: 1
});
$c_jl_StackTrace$.prototype.$classData = $d_jl_StackTrace$;
var $n_jl_StackTrace$;
function $m_jl_StackTrace$() {
  if ((!$n_jl_StackTrace$)) {
    $n_jl_StackTrace$ = new $c_jl_StackTrace$()
  };
  return $n_jl_StackTrace$
}
/** @constructor */
function $c_jl_StackTrace$StringRE$() {
  /*<skip>*/
}
$c_jl_StackTrace$StringRE$.prototype = new $h_O();
$c_jl_StackTrace$StringRE$.prototype.constructor = $c_jl_StackTrace$StringRE$;
/** @constructor */
function $h_jl_StackTrace$StringRE$() {
  /*<skip>*/
}
$h_jl_StackTrace$StringRE$.prototype = $c_jl_StackTrace$StringRE$.prototype;
$c_jl_StackTrace$StringRE$.prototype.re$extension0__T__O = (function(this$) {
  return new RegExp(this$)
});
$c_jl_StackTrace$StringRE$.prototype.re$extension1__T__T__O = (function(this$, mods) {
  return new RegExp(this$, mods)
});
var $d_jl_StackTrace$StringRE$ = new $TypeData().initClass({
  jl_StackTrace$StringRE$: 0
}, false, "java.lang.StackTrace$StringRE$", {
  jl_StackTrace$StringRE$: 1,
  O: 1
});
$c_jl_StackTrace$StringRE$.prototype.$classData = $d_jl_StackTrace$StringRE$;
var $n_jl_StackTrace$StringRE$;
function $m_jl_StackTrace$StringRE$() {
  if ((!$n_jl_StackTrace$StringRE$)) {
    $n_jl_StackTrace$StringRE$ = new $c_jl_StackTrace$StringRE$()
  };
  return $n_jl_StackTrace$StringRE$
}
/** @constructor */
function $c_jl_System$Streams$() {
  this.jl_System$Streams$__f_out = null;
  this.jl_System$Streams$__f_err = null;
  $n_jl_System$Streams$ = this;
  this.jl_System$Streams$__f_out = new $c_jl_JSConsoleBasedPrintStream(false);
  this.jl_System$Streams$__f_err = new $c_jl_JSConsoleBasedPrintStream(true)
}
$c_jl_System$Streams$.prototype = new $h_O();
$c_jl_System$Streams$.prototype.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
  /*<skip>*/
}
$h_jl_System$Streams$.prototype = $c_jl_System$Streams$.prototype;
var $d_jl_System$Streams$ = new $TypeData().initClass({
  jl_System$Streams$: 0
}, false, "java.lang.System$Streams$", {
  jl_System$Streams$: 1,
  O: 1
});
$c_jl_System$Streams$.prototype.$classData = $d_jl_System$Streams$;
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$()
  };
  return $n_jl_System$Streams$
}
function $p_jl_System$SystemProperties$__loadSystemProperties__O($thiz) {
  var result = {};
  result["java.version"] = "1.8";
  result["java.vm.specification.version"] = "1.8";
  result["java.vm.specification.vendor"] = "Oracle Corporation";
  result["java.vm.specification.name"] = "Java Virtual Machine Specification";
  result["java.vm.name"] = "Scala.js";
  var value = $as_T($linkingInfo.linkerVersion);
  result["java.vm.version"] = value;
  result["java.specification.version"] = "1.8";
  result["java.specification.vendor"] = "Oracle Corporation";
  result["java.specification.name"] = "Java Platform API Specification";
  result["file.separator"] = "/";
  result["path.separator"] = ":";
  result["line.separator"] = "\n";
  return result
}
/** @constructor */
function $c_jl_System$SystemProperties$() {
  this.jl_System$SystemProperties$__f_dict = null;
  this.jl_System$SystemProperties$__f_properties = null;
  $n_jl_System$SystemProperties$ = this;
  this.jl_System$SystemProperties$__f_dict = $p_jl_System$SystemProperties$__loadSystemProperties__O(this);
  this.jl_System$SystemProperties$__f_properties = null
}
$c_jl_System$SystemProperties$.prototype = new $h_O();
$c_jl_System$SystemProperties$.prototype.constructor = $c_jl_System$SystemProperties$;
/** @constructor */
function $h_jl_System$SystemProperties$() {
  /*<skip>*/
}
$h_jl_System$SystemProperties$.prototype = $c_jl_System$SystemProperties$.prototype;
$c_jl_System$SystemProperties$.prototype.getProperty__T__T__T = (function(key, default$1) {
  if ((this.jl_System$SystemProperties$__f_dict !== null)) {
    var dict = this.jl_System$SystemProperties$__f_dict;
    return $as_T(($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, key)) ? dict[key] : default$1))
  } else {
    return $n(this.jl_System$SystemProperties$__f_properties).getProperty__T__T__T(key, default$1)
  }
});
var $d_jl_System$SystemProperties$ = new $TypeData().initClass({
  jl_System$SystemProperties$: 0
}, false, "java.lang.System$SystemProperties$", {
  jl_System$SystemProperties$: 1,
  O: 1
});
$c_jl_System$SystemProperties$.prototype.$classData = $d_jl_System$SystemProperties$;
var $n_jl_System$SystemProperties$;
function $m_jl_System$SystemProperties$() {
  if ((!$n_jl_System$SystemProperties$)) {
    $n_jl_System$SystemProperties$ = new $c_jl_System$SystemProperties$()
  };
  return $n_jl_System$SystemProperties$
}
/** @constructor */
function $c_jl_Thread$() {
  this.jl_Thread$__f_SingleThread = null;
  $n_jl_Thread$ = this;
  this.jl_Thread$__f_SingleThread = new $c_jl_Thread((void 0))
}
$c_jl_Thread$.prototype = new $h_O();
$c_jl_Thread$.prototype.constructor = $c_jl_Thread$;
/** @constructor */
function $h_jl_Thread$() {
  /*<skip>*/
}
$h_jl_Thread$.prototype = $c_jl_Thread$.prototype;
var $d_jl_Thread$ = new $TypeData().initClass({
  jl_Thread$: 0
}, false, "java.lang.Thread$", {
  jl_Thread$: 1,
  O: 1
});
$c_jl_Thread$.prototype.$classData = $d_jl_Thread$;
var $n_jl_Thread$;
function $m_jl_Thread$() {
  if ((!$n_jl_Thread$)) {
    $n_jl_Thread$ = new $c_jl_Thread$()
  };
  return $n_jl_Thread$
}
function $ct_jl_ThreadLocal__($thiz) {
  $thiz.jl_ThreadLocal__f_hasValue = false;
  return $thiz
}
/** @constructor */
function $c_jl_ThreadLocal() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null
}
$c_jl_ThreadLocal.prototype = new $h_O();
$c_jl_ThreadLocal.prototype.constructor = $c_jl_ThreadLocal;
/** @constructor */
function $h_jl_ThreadLocal() {
  /*<skip>*/
}
$h_jl_ThreadLocal.prototype = $c_jl_ThreadLocal.prototype;
$c_jl_ThreadLocal.prototype.initialValue__O = (function() {
  return null
});
$c_jl_ThreadLocal.prototype.get__O = (function() {
  if ((!this.jl_ThreadLocal__f_hasValue)) {
    this.set__O__V(this.initialValue__O())
  };
  return this.jl_ThreadLocal__f_v
});
$c_jl_ThreadLocal.prototype.set__O__V = (function(o) {
  this.jl_ThreadLocal__f_v = o;
  this.jl_ThreadLocal__f_hasValue = true
});
var $d_jl_ThreadLocal = new $TypeData().initClass({
  jl_ThreadLocal: 0
}, false, "java.lang.ThreadLocal", {
  jl_ThreadLocal: 1,
  O: 1
});
$c_jl_ThreadLocal.prototype.$classData = $d_jl_ThreadLocal;
/** @constructor */
function $c_jl_Utils$Cache$() {
  this.jl_Utils$Cache$__f_safeHasOwnProperty = null;
  $n_jl_Utils$Cache$ = this;
  this.jl_Utils$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty
}
$c_jl_Utils$Cache$.prototype = new $h_O();
$c_jl_Utils$Cache$.prototype.constructor = $c_jl_Utils$Cache$;
/** @constructor */
function $h_jl_Utils$Cache$() {
  /*<skip>*/
}
$h_jl_Utils$Cache$.prototype = $c_jl_Utils$Cache$.prototype;
var $d_jl_Utils$Cache$ = new $TypeData().initClass({
  jl_Utils$Cache$: 0
}, false, "java.lang.Utils$Cache$", {
  jl_Utils$Cache$: 1,
  O: 1
});
$c_jl_Utils$Cache$.prototype.$classData = $d_jl_Utils$Cache$;
var $n_jl_Utils$Cache$;
function $m_jl_Utils$Cache$() {
  if ((!$n_jl_Utils$Cache$)) {
    $n_jl_Utils$Cache$ = new $c_jl_Utils$Cache$()
  };
  return $n_jl_Utils$Cache$
}
function $f_jl_Void__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_jl_Void__hashCode__I($thiz) {
  return 0
}
function $f_jl_Void__toString__T($thiz) {
  return "undefined"
}
function $as_jl_Void(obj) {
  return (((obj === (void 0)) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Void"))
}
function $isArrayOf_jl_Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Void)))
}
function $asArrayOf_jl_Void(obj, depth) {
  return (($isArrayOf_jl_Void(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Void;", depth))
}
var $d_jl_Void = new $TypeData().initClass({
  jl_Void: 0
}, false, "java.lang.Void", {
  jl_Void: 1,
  O: 1
}, (void 0), (void 0), ((x) => (x === (void 0))));
function $p_jl_reflect_Array$__mismatch__O__E($thiz, array) {
  var this$1 = $n(array);
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument type mismatch")
}
/** @constructor */
function $c_jl_reflect_Array$() {
  /*<skip>*/
}
$c_jl_reflect_Array$.prototype = new $h_O();
$c_jl_reflect_Array$.prototype.constructor = $c_jl_reflect_Array$;
/** @constructor */
function $h_jl_reflect_Array$() {
  /*<skip>*/
}
$h_jl_reflect_Array$.prototype = $c_jl_reflect_Array$.prototype;
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__I__O = (function(componentType, length) {
  return $n(componentType).newArrayOfThisClass__O__O([length])
});
$c_jl_reflect_Array$.prototype.getLength__O__I = (function(array) {
  if ((array instanceof $ac_O)) {
    var x2 = $asArrayOf_O(array, 1);
    return $n(x2).u.length
  } else if ((array instanceof $ac_Z)) {
    var x3 = $asArrayOf_Z(array, 1);
    return $n(x3).u.length
  } else if ((array instanceof $ac_C)) {
    var x4 = $asArrayOf_C(array, 1);
    return $n(x4).u.length
  } else if ((array instanceof $ac_B)) {
    var x5 = $asArrayOf_B(array, 1);
    return $n(x5).u.length
  } else if ((array instanceof $ac_S)) {
    var x6 = $asArrayOf_S(array, 1);
    return $n(x6).u.length
  } else if ((array instanceof $ac_I)) {
    var x7 = $asArrayOf_I(array, 1);
    return $n(x7).u.length
  } else if ((array instanceof $ac_J)) {
    var x8 = $asArrayOf_J(array, 1);
    return $n(x8).u.length
  } else if ((array instanceof $ac_F)) {
    var x9 = $asArrayOf_F(array, 1);
    return $n(x9).u.length
  } else if ((array instanceof $ac_D)) {
    var x10 = $asArrayOf_D(array, 1);
    return $n(x10).u.length
  } else {
    $p_jl_reflect_Array$__mismatch__O__E(this, array)
  }
});
var $d_jl_reflect_Array$ = new $TypeData().initClass({
  jl_reflect_Array$: 0
}, false, "java.lang.reflect.Array$", {
  jl_reflect_Array$: 1,
  O: 1
});
$c_jl_reflect_Array$.prototype.$classData = $d_jl_reflect_Array$;
var $n_jl_reflect_Array$;
function $m_jl_reflect_Array$() {
  if ((!$n_jl_reflect_Array$)) {
    $n_jl_reflect_Array$ = new $c_jl_reflect_Array$()
  };
  return $n_jl_reflect_Array$
}
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = quot;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = rem
}
$c_Ljava_math_BigInteger$QuotAndRem.prototype = new $h_O();
$c_Ljava_math_BigInteger$QuotAndRem.prototype.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $c_Ljava_math_BigInteger$QuotAndRem.prototype;
$c_Ljava_math_BigInteger$QuotAndRem.prototype.toArray__ALjava_math_BigInteger = (function() {
  return new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$QuotAndRem__f_quot, this.Ljava_math_BigInteger$QuotAndRem__f_rem])
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $TypeData().initClass({
  Ljava_math_BigInteger$QuotAndRem: 0
}, false, "java.math.BigInteger$QuotAndRem", {
  Ljava_math_BigInteger$QuotAndRem: 1,
  O: 1
});
$c_Ljava_math_BigInteger$QuotAndRem.prototype.$classData = $d_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $c_Ljava_math_BitLevel$() {
  /*<skip>*/
}
$c_Ljava_math_BitLevel$.prototype = new $h_O();
$c_Ljava_math_BitLevel$.prototype.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
  /*<skip>*/
}
$h_Ljava_math_BitLevel$.prototype = $c_Ljava_math_BitLevel$.prototype;
$c_Ljava_math_BitLevel$.prototype.bitLength__Ljava_math_BigInteger__I = (function(bi) {
  if (($n(bi).Ljava_math_BigInteger__f_sign === 0)) {
    return 0
  } else {
    var bLength = ($n(bi).Ljava_math_BigInteger__f_numberLength << 5);
    var highDigit = $n($n(bi).Ljava_math_BigInteger__f_digits).get((((-1) + $n(bi).Ljava_math_BigInteger__f_numberLength) | 0));
    if (($n(bi).Ljava_math_BigInteger__f_sign < 0)) {
      var i = $n(bi).getFirstNonzeroDigit__I();
      if ((i === (((-1) + $n(bi).Ljava_math_BigInteger__f_numberLength) | 0))) {
        highDigit = (((-1) + highDigit) | 0)
      }
    };
    var $$x1 = bLength;
    var i$1 = highDigit;
    bLength = (($$x1 - $uI(Math.clz32(i$1))) | 0);
    return bLength
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  var offset = ((andCount === 0) ? 0 : 1);
  var resLength = (((($n(source).Ljava_math_BigInteger__f_numberLength + intCount) | 0) + offset) | 0);
  $m_Ljava_math_BigInteger$().checkRangeBasedOnIntArrayLength__I__V(resLength);
  var resDigits = new $ac_I(resLength);
  this.shiftLeft__AI__AI__I__I__V(resDigits, $n(source).Ljava_math_BigInteger__f_digits, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), $n(source).Ljava_math_BigInteger__f_sign, resLength, resDigits);
  result.cutOffLeadingZeroes__V();
  return result
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__AI__AI__I__I__V = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var x4 = (($n(result).u.length - intCount) | 0);
    $systemArraycopy($n(source), 0, $n(result), intCount, x4)
  } else {
    var rightShiftCount = ((32 - count) | 0);
    $n(result).set((((-1) + $n(result).u.length) | 0), 0);
    var i = (((-1) + $n(result).u.length) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      $n(result).set(ev$1, ($n(result).get(ev$1) | (($n(source).get((((-1) + ((i - intCount) | 0)) | 0)) >>> rightShiftCount) | 0)));
      $n(result).set((((-1) + i) | 0), ($n(source).get((((-1) + ((i - intCount) | 0)) | 0)) << count));
      i = (((-1) + i) | 0)
    }
  };
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var i$2$2 = i$1;
    $n(result).set(i$2$2, 0);
    i$1 = ((1 + i$1) | 0)
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(source) {
  var srcLen = $n(source).Ljava_math_BigInteger__f_numberLength;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $ac_I(resLen);
  this.shiftLeftOneBit__AI__AI__I__V(resDigits, $n(source).Ljava_math_BigInteger__f_digits, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), $n(source).Ljava_math_BigInteger__f_sign, resLen, resDigits);
  result.cutOffLeadingZeroes__V();
  return result
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__AI__AI__I__V = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var i$2 = i;
    var iVal = $n(source).get(i$2);
    $n(result).set(i$2, ((iVal << 1) | elem));
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0)
  };
  if ((elem !== 0)) {
    $n(result).set(srcLen, elem)
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  if ((intCount >= $n(source).Ljava_math_BigInteger__f_numberLength)) {
    return (($n(source).Ljava_math_BigInteger__f_sign < 0) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO)
  } else {
    var resLength = (($n(source).Ljava_math_BigInteger__f_numberLength - intCount) | 0);
    var resDigits = new $ac_I(((1 + resLength) | 0));
    this.shiftRight__AI__I__AI__I__I__Z(resDigits, resLength, $n(source).Ljava_math_BigInteger__f_digits, intCount, andCount);
    if (($n(source).Ljava_math_BigInteger__f_sign < 0)) {
      var i = 0;
      while (((i < intCount) && ($n($n(source).Ljava_math_BigInteger__f_digits).get(i) === 0))) {
        i = ((1 + i) | 0)
      };
      var cmp = (($n($n(source).Ljava_math_BigInteger__f_digits).get(i) << ((32 - andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && ($n(resDigits).get(i) === (-1)))) {
          $n(resDigits).set(i, 0);
          i = ((1 + i) | 0)
        };
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0)
        };
        var ev$1 = i;
        $n(resDigits).set(ev$1, ((1 + $n(resDigits).get(ev$1)) | 0))
      }
    };
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), $n(source).Ljava_math_BigInteger__f_sign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__AI__I__AI__I__I__Z = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & ($n(source).get(i) === 0))));
    i = ((1 + i) | 0)
  };
  if ((count === 0)) {
    $systemArraycopy($n(source), intCount, $n(result), 0, resultLen)
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & (($n(source).get(i) << leftShiftCount) === 0))));
    i = 0;
    while ((i < (((-1) + resultLen) | 0))) {
      $n(result).set(i, ((($n(source).get(((i + intCount) | 0)) >>> count) | 0) | ($n(source).get(((1 + ((i + intCount) | 0)) | 0)) << leftShiftCount)));
      i = ((1 + i) | 0)
    };
    $n(result).set(i, (($n(source).get(((i + intCount) | 0)) >>> count) | 0));
    i = ((1 + i) | 0)
  };
  return allZero
});
var $d_Ljava_math_BitLevel$ = new $TypeData().initClass({
  Ljava_math_BitLevel$: 0
}, false, "java.math.BitLevel$", {
  Ljava_math_BitLevel$: 1,
  O: 1
});
$c_Ljava_math_BitLevel$.prototype.$classData = $d_Ljava_math_BitLevel$;
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$()
  };
  return $n_Ljava_math_BitLevel$
}
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var this$1 = $n(s);
  var len = this$1.length;
  while (true) {
    if ((zeroPrefixLength < len)) {
      var this$2 = $n(s);
      var index = zeroPrefixLength;
      var $$x1 = ($charAt(this$2, index) === 48)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      zeroPrefixLength = ((1 + zeroPrefixLength) | 0)
    } else {
      break
    }
  };
  var this$3 = $n(s);
  var beginIndex = zeroPrefixLength;
  if (((beginIndex < 0) || (beginIndex > this$3.length))) {
    $charAt(this$3, beginIndex)
  };
  return $as_T(this$3.substring(beginIndex))
}
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.Ljava_math_Conversion$__f_DigitFitInInt = null;
  this.Ljava_math_Conversion$__f_BigRadices = null;
  $n_Ljava_math_Conversion$ = this;
  this.Ljava_math_Conversion$__f_DigitFitInInt = new $ac_I(new Int32Array([(-1), (-1), 31, 19, 15, 13, 11, 11, 10, 9, 9, 8, 8, 8, 8, 7, 7, 7, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 5]));
  this.Ljava_math_Conversion$__f_BigRadices = new $ac_I(new Int32Array([(-2147483648), 1162261467, 1073741824, 1220703125, 362797056, 1977326743, 1073741824, 387420489, 1000000000, 214358881, 429981696, 815730721, 1475789056, 170859375, 268435456, 410338673, 612220032, 893871739, 1280000000, 1801088541, 113379904, 148035889, 191102976, 244140625, 308915776, 387420489, 481890304, 594823321, 729000000, 887503681, 1073741824, 1291467969, 1544804416, 1838265625, 60466176]))
}
$c_Ljava_math_Conversion$.prototype = new $h_O();
$c_Ljava_math_Conversion$.prototype.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
  /*<skip>*/
}
$h_Ljava_math_Conversion$.prototype = $c_Ljava_math_Conversion$.prototype;
$c_Ljava_math_Conversion$.prototype.bigInteger2String__Ljava_math_BigInteger__I__T = (function(bi, radix) {
  var sign = $n(bi).Ljava_math_BigInteger__f_sign;
  var numberLength = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var digits = $n(bi).Ljava_math_BigInteger__f_digits;
  var radixOutOfBounds = ((radix < 2) || (radix > 36));
  if ((sign === 0)) {
    return "0"
  } else if ((numberLength === 1)) {
    var highDigit = $n(digits).get((((-1) + numberLength) | 0));
    var v__lo = highDigit;
    var v__hi = 0;
    if ((sign < 0)) {
      var this$2__lo = v__lo;
      var this$2__hi = v__hi;
      var lo = this$2__lo;
      var hi$1 = this$2__hi;
      var lo$1 = ((-lo) | 0);
      var hi$2 = ((lo !== 0) ? (~hi$1) : ((-hi$1) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$2;
      v__lo = $$x1__lo;
      v__hi = $$x1__hi
    };
    var this$5 = $m_jl_Long$();
    var i__lo = v__lo;
    var i__hi = v__hi;
    return ((((radix === 10) || (radix < 2)) || (radix > 36)) ? $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(i__lo, i__hi) : this$5.java$lang$Long$$toStringImpl__J__I__T(new $c_RTLong(i__lo, i__hi), radix))
  } else if (((radix === 10) || radixOutOfBounds)) {
    var this$6 = $n(bi);
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$6)
  } else {
    var bitsForRadixDigit = 0.0;
    var a = radix;
    bitsForRadixDigit = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
    var addForSign = ((sign < 0) ? 1 : 0);
    var this$9 = $n($n(bi).abs__Ljava_math_BigInteger());
    var biAbsLen = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$9);
    var resLenInChars = ((1 + $doubleToInt(((biAbsLen / bitsForRadixDigit) + addForSign))) | 0);
    var elem = null;
    elem = "";
    var elem$1 = 0;
    elem$1 = resLenInChars;
    var elem$2 = 0;
    elem$2 = 0;
    if ((radix !== 16)) {
      var temp = new $ac_I(numberLength);
      $systemArraycopy($n(digits), 0, temp, 0, numberLength);
      var elem$3 = 0;
      elem$3 = numberLength;
      var charsPerInt = $n(this.Ljava_math_Conversion$__f_DigitFitInInt).get(radix);
      var bigRadix = $n(this.Ljava_math_Conversion$__f_BigRadices).get((((-2) + radix) | 0));
      while (true) {
        elem$2 = $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(temp, temp, elem$3, bigRadix);
        var previous = elem$1;
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var this$14 = $m_jl_Character$().forDigit__I__I__C($intMod(elem$2, radix), radix);
          elem = (("" + $as_T(String.fromCharCode(this$14))) + $as_T(elem));
          elem$2 = $intDiv(elem$2, radix);
          if (((elem$2 !== 0) && (elem$1 !== 0))) {
            continue
          };
          break
        };
        var delta = ((((charsPerInt - previous) | 0) + elem$1) | 0);
        var i$1 = 0;
        while (((i$1 < delta) && (elem$1 > 0))) {
          elem$1 = (((-1) + elem$1) | 0);
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0)
        };
        i$1 = (((-1) + elem$3) | 0);
        while (((i$1 > 0) && ($n(temp).get(i$1) === 0))) {
          i$1 = (((-1) + i$1) | 0)
        };
        elem$3 = ((1 + i$1) | 0);
        if ((!((elem$3 === 1) && ($n(temp).get(0) === 0)))) {
          continue
        };
        break
      }
    } else {
      var i$2 = 0;
      while ((i$2 < numberLength)) {
        var i$2$1 = i$2;
        var j = 0;
        while (((j < 8) && (elem$1 > 0))) {
          elem$2 = (15 & ($n(digits).get(i$2$1) >> (j << 2)));
          elem$1 = (((-1) + elem$1) | 0);
          var i$3 = elem$2;
          elem = (("" + $as_T($uD((i$3 >>> 0.0)).toString(16))) + $as_T(elem));
          j = ((1 + j) | 0)
        };
        i$2 = ((1 + i$2) | 0)
      }
    };
    var dropLen = 0;
    while (true) {
      var this$19 = $n($as_T(elem));
      var index = dropLen;
      if (($charAt(this$19, index) === 48)) {
        dropLen = ((1 + dropLen) | 0)
      } else {
        break
      }
    };
    if ((dropLen !== 0)) {
      var this$20 = $n($as_T(elem));
      var beginIndex = dropLen;
      if (((beginIndex < 0) || (beginIndex > this$20.length))) {
        $charAt(this$20, beginIndex)
      };
      elem = $as_T(this$20.substring(beginIndex))
    };
    return ((sign === (-1)) ? ("-" + $as_T(elem)) : $as_T(elem))
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__Ljava_math_BigInteger__T = (function(bi) {
  var sign = $n(bi).Ljava_math_BigInteger__f_sign;
  var numberLength = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var digits = $n(bi).Ljava_math_BigInteger__f_digits;
  if ((sign === 0)) {
    return "0"
  } else if ((numberLength === 1)) {
    var i = $n(digits).get(0);
    var absStr = $as_T($uD((i >>> 0.0)).toString(10));
    return ((sign < 0) ? ("-" + absStr) : absStr)
  } else {
    var result = "";
    var temp = new $ac_I(numberLength);
    var tempLen = numberLength;
    var x4 = tempLen;
    $systemArraycopy($n(digits), 0, temp, 0, x4);
    while (true) {
      var rem = 0;
      var i$1 = (((-1) + tempLen) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = $n(temp).get(i$1);
        var this$5 = $m_RTLong$();
        var lo = this$5.divideUnsignedImpl__I__I__I__I__I(value$1, value, 1000000000, 0);
        $n(temp).set(i$1, lo);
        var hi$3 = (lo >> 31);
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = Math.imul(51712, b0);
        var a1b0 = Math.imul(15258, b0);
        var a0b1 = Math.imul(51712, b1);
        var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$4 = ((((((Math.imul(1000000000, hi$3) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$2 = ((value$1 - lo$1) | 0);
        rem = lo$2;
        i$1 = (((-1) + i$1) | 0)
      };
      var this$8 = rem;
      var remStr = ("" + this$8);
      var beginIndex = remStr.length;
      if (((beginIndex < 0) || (beginIndex > 9))) {
        $charAt("000000000", beginIndex)
      };
      var padding = $as_T("000000000".substring(beginIndex));
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && ($n(temp).get((((-1) + tempLen) | 0)) === 0))) {
        tempLen = (((-1) + tempLen) | 0)
      };
      if ((tempLen !== 0)) {
        /*<skip>*/
      } else {
        break
      }
    };
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result)
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__J__I__T = (function(value, scale) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === 0))) {
    switch (scale) {
      case 0: {
        return "0";
        break
      }
      case 1: {
        return "0.0";
        break
      }
      case 2: {
        return "0.00";
        break
      }
      case 3: {
        return "0.000";
        break
      }
      case 4: {
        return "0.0000";
        break
      }
      case 5: {
        return "0.00000";
        break
      }
      case 6: {
        return "0.000000";
        break
      }
      default: {
        if ((scale === (-2147483648))) {
          var scaleVal = "2147483648"
        } else {
          var i = ((-scale) | 0);
          var scaleVal = ("" + i)
        };
        var result = ((scale < 0) ? "0E+" : "0E");
        return (result + scaleVal)
      }
    }
  } else {
    var ahi = value.RTLong__f_hi;
    var negNumber = (ahi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var t = new $c_RTLong(x__lo, x__hi)
    } else {
      var t = value
    };
    var lo$2 = t.RTLong__f_lo;
    var hi$2 = t.RTLong__f_hi;
    var v__lo = lo$2;
    var v__hi = hi$2;
    while (true) {
      var prev__lo = v__lo;
      var prev__hi = v__hi;
      var this$5__lo = v__lo;
      var this$5__hi = v__hi;
      var this$6 = $m_RTLong$();
      var lo$3 = this$6.divideImpl__I__I__I__I__I(this$5__lo, this$5__hi, 10, 0);
      var hi$3 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x1__lo = lo$3;
      var $$x1__hi = hi$3;
      v__lo = $$x1__lo;
      v__hi = $$x1__hi;
      currentChar = (((-1) + currentChar) | 0);
      var b__lo = v__lo;
      var b__hi = v__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(10, b0);
      var a0b1 = Math.imul(10, b1);
      var lo$4 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((Math.imul(10, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var alo = prev__lo;
      var ahi$1 = prev__hi;
      var lo$5 = ((alo - lo$4) | 0);
      elem = (("" + lo$5) + $as_T(elem));
      var this$9__lo = v__lo;
      var this$9__hi = v__hi;
      if ((!((this$9__lo === 0) && (this$9__hi === 0)))) {
        /*<skip>*/
      } else {
        break
      }
    };
    var value$1 = ((18 - currentChar) | 0);
    var hi$6 = (value$1 >> 31);
    var hi$7 = (scale >> 31);
    var lo$6 = ((value$1 - scale) | 0);
    var hi$8 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ value$1)) ? (((-1) + ((hi$6 - hi$7) | 0)) | 0) : ((hi$6 - hi$7) | 0));
    var lo$7 = (((-1) + lo$6) | 0);
    var hi$9 = ((lo$7 !== (-1)) ? hi$8 : (((-1) + hi$8) | 0));
    if (((scale > 0) && ((hi$9 === (-1)) ? (((-2147483648) ^ lo$7) >= 2147483642) : (hi$9 > (-1))))) {
      var index = ((1 + lo$7) | 0);
      if ((index > 0)) {
        var this$14 = $n($as_T(elem));
        if ((index > this$14.length)) {
          $charAt(this$14, index)
        };
        if ((index < 0)) {
          $charAt(this$14, (-1))
        };
        var $$x2 = $as_T(this$14.substring(0, index));
        var this$15 = $n($as_T(elem));
        if (((index < 0) || (index > this$15.length))) {
          $charAt(this$15, index)
        };
        elem = (($$x2 + ".") + $as_T(this$15.substring(index)))
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0)
        };
        elem = ("0." + $as_T(elem))
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$9 === 0) ? (lo$7 !== 0) : (hi$9 > 0)) ? ("E+" + new $c_RTLong(lo$7, hi$9)) : ("E" + new $c_RTLong(lo$7, hi$9)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$18 = $n($as_T(elem));
        if ((this$18.length < 1)) {
          $charAt(this$18, 1)
        };
        var $$x3 = $as_T(this$18.substring(0, 1));
        var this$19 = $n($as_T(elem));
        if ((this$19.length < 1)) {
          $charAt(this$19, 1)
        };
        elem = ((($$x3 + ".") + $as_T(this$19.substring(1))) + exponentStr)
      } else {
        elem = ($as_T(elem) + exponentStr)
      }
    };
    return (negNumber ? ("-" + $as_T(elem)) : $as_T(elem))
  }
});
var $d_Ljava_math_Conversion$ = new $TypeData().initClass({
  Ljava_math_Conversion$: 0
}, false, "java.math.Conversion$", {
  Ljava_math_Conversion$: 1,
  O: 1
});
$c_Ljava_math_Conversion$.prototype.$classData = $d_Ljava_math_Conversion$;
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$()
  };
  return $n_Ljava_math_Conversion$
}
/** @constructor */
function $c_Ljava_math_Division$() {
  /*<skip>*/
}
$c_Ljava_math_Division$.prototype = new $h_O();
$c_Ljava_math_Division$.prototype.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
  /*<skip>*/
}
$h_Ljava_math_Division$.prototype = $c_Ljava_math_Division$.prototype;
$c_Ljava_math_Division$.prototype.divide__AI__I__AI__I__AI__I__AI = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $ac_I(((1 + aLength) | 0));
  var normB = new $ac_I(((1 + bLength) | 0));
  var i = $n(b).get((((-1) + bLength) | 0));
  var divisorShift = $uI(Math.clz32(i));
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normA, a, 0, divisorShift)
  } else {
    $systemArraycopy($n(a), 0, normA, 0, aLength);
    $systemArraycopy($n(b), 0, normB, 0, bLength)
  };
  var firstDivisorDigit = $n(normB).get((((-1) + bLength) | 0));
  var i$1 = (((-1) + quotLength) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if (($n(normA).get(elem) === firstDivisorDigit)) {
      elem$1 = (-1)
    } else {
      var value = $n(normA).get(elem);
      var value$1 = $n(normA).get((((-1) + elem) | 0));
      var this$8 = $m_RTLong$();
      var lo = this$8.divideUnsignedImpl__I__I__I__I__I(value$1, value, firstDivisorDigit, 0);
      var hi$3 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      elem$1 = lo;
      var a0 = (65535 & lo);
      var a1 = ((lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((Math.imul(hi$3, firstDivisorDigit) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((value$1 - lo$1) | 0);
      var elem$2 = 0;
      elem$2 = lo$2;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var value$2 = elem$1;
          var value$3 = $n(normB).get((((-2) + bLength) | 0));
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = Math.imul(a0$1, b0$1);
          var a1b0$1 = Math.imul(a1$1, b0$1);
          var a0b1$1 = Math.imul(a0$1, b1$1);
          var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$8 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = $n(normA).get((((-2) + elem) | 0));
          var value$6 = elem$2;
          var lo$4 = ((value$6 + firstDivisorDigit) | 0);
          var hi$13 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$6)) ? 1 : 0);
          if ((hi$13 === 0)) {
            elem$2 = lo$4;
            var hi$14 = ((-2147483648) ^ hi$8);
            var hi$15 = ((-2147483648) ^ value$4);
            if (((hi$14 === hi$15) ? (((-2147483648) ^ lo$3) > ((-2147483648) ^ value$5)) : (hi$14 > hi$15))) {
              continue
            }
          };
          break
        }
      }
    };
    if ((elem$1 !== 0)) {
      var borrow = $m_Ljava_math_Division$().multiplyAndSubtract__AI__I__AI__I__I__I(normA, ((elem - bLength) | 0), normB, bLength, elem$1);
      if ((borrow !== 0)) {
        elem$1 = (((-1) + elem$1) | 0);
        var elem$3__lo = 0;
        var elem$3__hi = 0;
        var $$x1__lo = 0;
        var $$x1__hi = 0;
        elem$3__lo = $$x1__lo;
        elem$3__hi = $$x1__hi;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var k$2 = i$2;
          var this$25__lo = elem$3__lo;
          var this$25__hi = elem$3__hi;
          var value$7 = $n(normA).get(((((elem - bLength) | 0) + k$2) | 0));
          var value$8 = $n(normB).get(k$2);
          var lo$5 = ((value$7 + value$8) | 0);
          var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ value$7)) ? 1 : 0);
          var alo = this$25__lo;
          var ahi = this$25__hi;
          var lo$6 = ((alo + lo$5) | 0);
          var hi$19 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$18) | 0)) | 0) : ((ahi + hi$18) | 0));
          var $$x2__lo = lo$6;
          var $$x2__hi = hi$19;
          elem$3__lo = $$x2__lo;
          elem$3__hi = $$x2__hi;
          var $$x4 = $n(normA);
          var $$x3 = elem;
          var this$27__lo = elem$3__lo;
          var this$27__hi = elem$3__hi;
          $$x4.set((((($$x3 - bLength) | 0) + k$2) | 0), this$27__lo);
          var this$28__lo = elem$3__lo;
          var this$28__hi = elem$3__hi;
          var hi$20 = this$28__hi;
          var $$x5__lo = hi$20;
          var $$x5__hi = 0;
          elem$3__lo = $$x5__lo;
          elem$3__hi = $$x5__hi;
          i$2 = ((1 + i$2) | 0)
        }
      }
    };
    if ((quot !== null)) {
      $n(quot).set(i$1, elem$1)
    };
    elem = (((-1) + elem) | 0);
    i$1 = (((-1) + i$1) | 0)
  };
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftRight__AI__I__AI__I__I__Z(normB, bLength, normA, 0, divisorShift);
    return normB
  } else {
    $systemArraycopy(normA, 0, normB, 0, bLength);
    return normA
  }
});
$c_Ljava_math_Division$.prototype.divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem = (function(bi, divisor, divisorSign) {
  var valDigits = $n(bi).Ljava_math_BigInteger__f_digits;
  var valLen = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var valSign = $n(bi).Ljava_math_BigInteger__f_sign;
  if ((valLen === 1)) {
    var valDigit = $n(valDigits).get(0);
    if ((divisor === 0)) {
      var value = $intDiv(0, 0)
    } else {
      var n = ($uD((valDigit >>> 0.0)) / $uD((divisor >>> 0.0)));
      var value = $uI((n | 0.0))
    };
    var quo__lo = value;
    var quo__hi = 0;
    if ((divisor === 0)) {
      var value$1 = $intMod(0, 0)
    } else {
      var n$1 = ($uD((valDigit >>> 0.0)) % $uD((divisor >>> 0.0)));
      var value$1 = $uI((n$1 | 0.0))
    };
    var rem__lo = value$1;
    var rem__hi = 0;
    if ((valSign !== divisorSign)) {
      var this$5__lo = quo__lo;
      var this$5__hi = quo__hi;
      var lo = this$5__lo;
      var hi$2 = this$5__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$3;
      quo__lo = $$x1__lo;
      quo__hi = $$x1__hi
    };
    if ((valSign < 0)) {
      var this$8__lo = rem__lo;
      var this$8__hi = rem__hi;
      var lo$2 = this$8__lo;
      var hi$4 = this$8__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$5;
      rem__lo = $$x2__lo;
      rem__hi = $$x2__hi
    };
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(quo__lo, quo__hi)), $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(rem__lo, rem__hi)))
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $ac_I(valLen);
    var div = this.divideArrayByInt__AI__AI__I__I__I(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $ac_I(new Int32Array([div]));
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.cutOffLeadingZeroes__V();
    result1.cutOffLeadingZeroes__V();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1)
  }
});
$c_Ljava_math_Division$.prototype.divideArrayByInt__AI__AI__I__I__I = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = (((-1) + srcLength) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = $n(src).get(i);
    var this$4 = $m_RTLong$();
    var lo = this$4.divideUnsignedImpl__I__I__I__I__I(value$1, value, divisor, 0);
    var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var a0 = (65535 & lo);
    var a1 = ((lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    var b1 = ((divisor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((((((Math.imul(hi$3, divisor) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((value$1 - lo$1) | 0);
    rem = lo$2;
    $n(dest).set(i, lo);
    i = (((-1) + i) | 0)
  };
  return rem
});
$c_Ljava_math_Division$.prototype.multiplyAndSubtract__AI__I__AI__I__I__I = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var i$2 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = $n(b).get(i$2);
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    var value = $n(a).get(((start + i$2) | 0));
    var lo$2 = ((value - lo$1) | 0);
    var hi$6 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$1 = elem$1;
    var hi$7 = (value$1 >> 31);
    var lo$3 = ((lo$2 + value$1) | 0);
    var hi$8 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$2)) ? ((1 + ((hi$6 + hi$7) | 0)) | 0) : ((hi$6 + hi$7) | 0));
    $n(a).set(((start + i$2) | 0), lo$3);
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0)
  };
  var value$2 = $n(a).get(((start + bLen) | 0));
  var value$3 = elem;
  var lo$4 = ((value$2 - value$3) | 0);
  var hi$13 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ value$2)) ? (-1) : 0);
  var value$4 = elem$1;
  var hi$14 = (value$4 >> 31);
  var lo$5 = ((lo$4 + value$4) | 0);
  var hi$15 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$13 + hi$14) | 0)) | 0) : ((hi$13 + hi$14) | 0));
  $n(a).set(((start + bLen) | 0), lo$5);
  return hi$15
});
var $d_Ljava_math_Division$ = new $TypeData().initClass({
  Ljava_math_Division$: 0
}, false, "java.math.Division$", {
  Ljava_math_Division$: 1,
  O: 1
});
$c_Ljava_math_Division$.prototype.$classData = $d_Ljava_math_Division$;
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$()
  };
  return $n_Ljava_math_Division$
}
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res
}
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = $n(a).get(0);
  var value$1 = $n(b).get(0);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
  $n(res).set(0, lo);
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = $n(a).get(i);
      var value$3 = $n(b).get(i);
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ value$2)) ? 1 : 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$6) | 0) : hi$6);
      $n(res).set(i, lo$2);
      carry = hi$8;
      i = ((1 + i) | 0)
    };
    while ((i < aSize)) {
      var value$5 = $n(a).get(i);
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ value$5)) ? 1 : 0);
      $n(res).set(i, lo$3);
      carry = hi$12;
      i = ((1 + i) | 0)
    }
  } else {
    while ((i < aSize)) {
      var value$7 = $n(a).get(i);
      var value$8 = $n(b).get(i);
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$7)) ? 1 : 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$16) | 0) : hi$16);
      $n(res).set(i, lo$5);
      carry = hi$18;
      i = ((1 + i) | 0)
    };
    while ((i < bSize)) {
      var value$10 = $n(b).get(i);
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ value$10)) ? 1 : 0);
      $n(res).set(i, lo$6);
      carry = hi$22;
      i = ((1 + i) | 0)
    }
  };
  if ((carry !== 0)) {
    $n(res).set(i, carry)
  }
}
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res
}
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = $n(a).get(i);
    var value$1 = $n(b).get(i);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$2 + hi$3) | 0)) | 0) : ((hi$2 + hi$3) | 0));
    $n(res).set(i, lo$1);
    borrow = hi$4;
    i = ((1 + i) | 0)
  };
  while ((i < aSize)) {
    var value$3 = $n(a).get(i);
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ value$3)) ? ((1 + hi$7) | 0) : hi$7);
    $n(res).set(i, lo$2);
    borrow = hi$8;
    i = ((1 + i) | 0)
  }
}
/** @constructor */
function $c_Ljava_math_Elementary$() {
  /*<skip>*/
}
$c_Ljava_math_Elementary$.prototype = new $h_O();
$c_Ljava_math_Elementary$.prototype.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
  /*<skip>*/
}
$h_Ljava_math_Elementary$.prototype = $c_Ljava_math_Elementary$.prototype;
$c_Ljava_math_Elementary$.prototype.add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = $n(op1).Ljava_math_BigInteger__f_sign;
  var op2Sign = $n(op2).Ljava_math_BigInteger__f_sign;
  var op1Len = $n(op1).Ljava_math_BigInteger__f_numberLength;
  var op2Len = $n(op2).Ljava_math_BigInteger__f_numberLength;
  if ((op1Sign === 0)) {
    return op2
  } else if ((op2Sign === 0)) {
    return op1
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = $n($n(op1).Ljava_math_BigInteger__f_digits).get(0);
    var value$1 = $n($n(op2).Ljava_math_BigInteger__f_digits).get(0);
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $ac_I(new Int32Array([lo, hi$2]))))
    } else {
      var $$x1 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value$1)) ? (-1) : 0);
        var x__lo = lo$1;
        var x__hi = hi$3
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
        var x__lo = lo$2;
        var x__hi = hi$4
      };
      return $n($$x1).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(x__lo, x__hi))
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var res$2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len));
      var x1___1 = op1Sign;
      var x1___2 = res$2
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.compareArrays__AI__AI__I__I($n(op1).Ljava_math_BigInteger__f_digits, $n(op2).Ljava_math_BigInteger__f_digits, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
      };
      if ((cmp === 1)) {
        var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len);
        var x1___1 = op1Sign;
        var x1___2 = _2
      } else {
        var _2$1 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len);
        var x1___1 = op2Sign;
        var x1___2 = _2$1
      }
    };
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, $n(resDigits).u.length, resDigits);
    res$3.cutOffLeadingZeroes__V();
    return res$3
  }
});
$c_Ljava_math_Elementary$.prototype.compareArrays__AI__AI__I__I = (function(a, b, size) {
  var i = (((-1) + size) | 0);
  while (((i >= 0) && ($n(a).get(i) === $n(b).get(i)))) {
    i = (((-1) + i) | 0)
  };
  if ((i < 0)) {
    return 0
  } else {
    var value = $n(a).get(i);
    var value$1 = $n(b).get(i);
    if ((((-2147483648) ^ value) < ((-2147483648) ^ value$1))) {
      return (-1)
    } else {
      return 1
    }
  }
});
$c_Ljava_math_Elementary$.prototype.inplaceAdd__AI__I__I__I = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = $n(a).get(i);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
    $n(a).set(i, lo);
    carry = hi$2;
    i = ((1 + i) | 0)
  };
  return carry
});
$c_Ljava_math_Elementary$.prototype.subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = $n(op1).Ljava_math_BigInteger__f_sign;
  var op2Sign = $n(op2).Ljava_math_BigInteger__f_sign;
  var op1Len = $n(op1).Ljava_math_BigInteger__f_numberLength;
  var op2Len = $n(op2).Ljava_math_BigInteger__f_numberLength;
  if ((op2Sign === 0)) {
    return op1
  } else if ((op1Sign === 0)) {
    return $n(op2).negate__Ljava_math_BigInteger()
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = $n($n(op1).Ljava_math_BigInteger__f_digits).get(0);
    var a__lo = value;
    var a__hi = 0;
    var value$1 = $n($n(op2).Ljava_math_BigInteger__f_digits).get(0);
    var b__lo = value$1;
    var b__hi = 0;
    if ((op1Sign < 0)) {
      var this$3__lo = a__lo;
      var this$3__hi = a__hi;
      var lo = this$3__lo;
      var hi$2 = this$3__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$3;
      a__lo = $$x1__lo;
      a__hi = $$x1__hi
    };
    if ((op2Sign < 0)) {
      var this$6__lo = b__lo;
      var this$6__hi = b__hi;
      var lo$2 = this$6__lo;
      var hi$4 = this$6__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$5;
      b__lo = $$x2__lo;
      b__hi = $$x2__hi
    };
    var $$x3 = $m_Ljava_math_BigInteger$();
    var this$9__lo = a__lo;
    var this$9__hi = a__hi;
    var b$1__lo = b__lo;
    var b$1__hi = b__hi;
    var alo = this$9__lo;
    var ahi = this$9__hi;
    var bhi = b$1__hi;
    var lo$4 = ((alo - b$1__lo) | 0);
    var hi$6 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
    return $n($$x3).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$4, hi$6))
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I($n(op1).Ljava_math_BigInteger__f_digits, $n(op2).Ljava_math_BigInteger__f_digits, op1Len));
    if (((op1Sign === op2Sign) && (cmp === 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
    };
    if ((cmp === (-1))) {
      var res = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len));
      var _1 = ((-op2Sign) | 0);
      var x1___1 = _1;
      var x1___2 = res
    } else if ((op1Sign === op2Sign)) {
      var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2
    } else {
      var _2$1 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2$1
    };
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, $n(resDigits).u.length, resDigits);
    res$2.cutOffLeadingZeroes__V();
    return res$2
  }
});
var $d_Ljava_math_Elementary$ = new $TypeData().initClass({
  Ljava_math_Elementary$: 0
}, false, "java.math.Elementary$", {
  Ljava_math_Elementary$: 1,
  O: 1
});
$c_Ljava_math_Elementary$.prototype.$classData = $d_Ljava_math_Elementary$;
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$()
  };
  return $n_Ljava_math_Elementary$
}
/** @constructor */
function $c_Ljava_math_MathContext(setPrecision, setRoundingMode) {
  this.Ljava_math_MathContext__f_precision = 0;
  this.Ljava_math_MathContext__f_roundingMode = null;
  this.Ljava_math_MathContext__f_precision = setPrecision;
  this.Ljava_math_MathContext__f_roundingMode = setRoundingMode
}
$c_Ljava_math_MathContext.prototype = new $h_O();
$c_Ljava_math_MathContext.prototype.constructor = $c_Ljava_math_MathContext;
/** @constructor */
function $h_Ljava_math_MathContext() {
  /*<skip>*/
}
$h_Ljava_math_MathContext.prototype = $c_Ljava_math_MathContext.prototype;
$c_Ljava_math_MathContext.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_MathContext)) {
    var x2 = $as_Ljava_math_MathContext(x);
    if ((this.Ljava_math_MathContext__f_precision === $n(x2).Ljava_math_MathContext__f_precision)) {
      var x$2 = this.Ljava_math_MathContext__f_roundingMode;
      var x$3 = $n(x2).Ljava_math_MathContext__f_roundingMode;
      if ((x$2 === null)) {
        return (x$3 === null)
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$3)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_math_MathContext.prototype.hashCode__I = (function() {
  return ((this.Ljava_math_MathContext__f_precision << 3) | $n(this.Ljava_math_MathContext__f_roundingMode).jl_Enum__f__ordinal)
});
$c_Ljava_math_MathContext.prototype.toString__T = (function() {
  return ((("precision=" + this.Ljava_math_MathContext__f_precision) + " roundingMode=") + this.Ljava_math_MathContext__f_roundingMode)
});
function $as_Ljava_math_MathContext(obj) {
  return (((obj instanceof $c_Ljava_math_MathContext) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.MathContext"))
}
function $isArrayOf_Ljava_math_MathContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_MathContext)))
}
function $asArrayOf_Ljava_math_MathContext(obj, depth) {
  return (($isArrayOf_Ljava_math_MathContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.MathContext;", depth))
}
var $d_Ljava_math_MathContext = new $TypeData().initClass({
  Ljava_math_MathContext: 0
}, false, "java.math.MathContext", {
  Ljava_math_MathContext: 1,
  O: 1
});
$c_Ljava_math_MathContext.prototype.$classData = $d_Ljava_math_MathContext;
/** @constructor */
function $c_Ljava_math_MathContext$() {
  this.Ljava_math_MathContext$__f_DECIMAL128 = null;
  $n_Ljava_math_MathContext$ = this;
  $m_Ljava_math_MathContext$();
  var roundingMode = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL128 = new $c_Ljava_math_MathContext(34, roundingMode);
  $m_Ljava_math_MathContext$();
  var roundingMode$1 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  new $c_Ljava_math_MathContext(7, roundingMode$1);
  $m_Ljava_math_MathContext$();
  var roundingMode$2 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  new $c_Ljava_math_MathContext(16, roundingMode$2);
  $m_Ljava_math_MathContext$();
  var roundingMode$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
  new $c_Ljava_math_MathContext(0, roundingMode$3)
}
$c_Ljava_math_MathContext$.prototype = new $h_O();
$c_Ljava_math_MathContext$.prototype.constructor = $c_Ljava_math_MathContext$;
/** @constructor */
function $h_Ljava_math_MathContext$() {
  /*<skip>*/
}
$h_Ljava_math_MathContext$.prototype = $c_Ljava_math_MathContext$.prototype;
var $d_Ljava_math_MathContext$ = new $TypeData().initClass({
  Ljava_math_MathContext$: 0
}, false, "java.math.MathContext$", {
  Ljava_math_MathContext$: 1,
  O: 1
});
$c_Ljava_math_MathContext$.prototype.$classData = $d_Ljava_math_MathContext$;
var $n_Ljava_math_MathContext$;
function $m_Ljava_math_MathContext$() {
  if ((!$n_Ljava_math_MathContext$)) {
    $n_Ljava_math_MathContext$ = new $c_Ljava_math_MathContext$()
  };
  return $n_Ljava_math_MathContext$
}
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem__lo = 0;
  var elem__hi = 0;
  var $$x1__lo = 1;
  var $$x1__hi = 0;
  elem__lo = $$x1__lo;
  elem__hi = $$x1__hi;
  var i = 0;
  while ((i < 32)) {
    var i$2 = i;
    if ((i$2 <= 18)) {
      $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).set(i$2, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(elem__lo, elem__hi)));
      var $$x3 = $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows);
      var $$x2 = $m_Ljava_math_BigInteger$();
      var this$4__lo = elem__lo;
      var this$4__hi = elem__hi;
      var lo = this$4__lo;
      var lo$1 = (((32 & i$2) === 0) ? (lo << i$2) : 0);
      var hi = (((32 & i$2) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - i$2) | 0)) | 0) | (this$4__hi << i$2)) : (lo << i$2));
      $$x3.set(i$2, $n($$x2).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$1, hi)));
      var b__lo = elem__lo;
      var b__hi = elem__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(5, b0);
      var a0b1 = Math.imul(5, b1);
      var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(5, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var $$x4__lo = lo$2;
      var $$x4__hi = hi$1;
      elem__lo = $$x4__lo;
      elem__hi = $$x4__hi
    } else {
      $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).set(i$2, $n($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).get((((-1) + i$2) | 0))).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).get(1)));
      $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).set(i$2, $n($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).get((((-1) + i$2) | 0))).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN))
    };
    i = ((1 + i) | 0)
  }
}
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var i$2 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = $n(a).get(i$2);
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    $n(res).set(i$2, lo$1);
    elem = hi$4;
    i = ((1 + i) | 0)
  };
  return elem
}
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.square__AI__I__AI__AI(a, aLen, t)
  } else {
    var i = 0;
    while ((i < aLen)) {
      var i$2 = i;
      var elem = 0;
      elem = 0;
      var aI = $n(a).get(i$2);
      var this$6 = new $c_ju_ScalaOps$SimpleRange(0, bLen);
      var i$1 = this$6.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$start;
      while ((i$1 < this$6.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$end)) {
        var j$2 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = $n(b).get(j$2);
        var c = $n(t).get(((i$2 + j$2) | 0));
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
        $n(t).set(((i$2 + j$2) | 0), lo$2);
        elem = hi$6;
        i$1 = ((1 + i$1) | 0)
      };
      $n(t).set(((i$2 + bLen) | 0), elem);
      i = ((1 + i) | 0)
    }
  }
}
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  var result = new $ac_I(len);
  $n(result).set(0, 1);
  var i = 1;
  while ((i < len)) {
    var i$2 = i;
    $n(result).set(i$2, Math.imul($n(result).get((((-1) + i$2) | 0)), pow));
    i = ((1 + i) | 0)
  };
  return result
}
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.Ljava_math_Multiplication$__f_TenPows = null;
  this.Ljava_math_Multiplication$__f_BigTenPows = null;
  this.Ljava_math_Multiplication$__f_BigFivePows = null;
  $n_Ljava_math_Multiplication$ = this;
  this.Ljava_math_Multiplication$__f_TenPows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.Ljava_math_Multiplication$__f_BigTenPows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  this.Ljava_math_Multiplication$__f_BigFivePows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this)
}
$c_Ljava_math_Multiplication$.prototype = new $h_O();
$c_Ljava_math_Multiplication$.prototype.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
  /*<skip>*/
}
$h_Ljava_math_Multiplication$.prototype = $c_Ljava_math_Multiplication$.prototype;
$c_Ljava_math_Multiplication$.prototype.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(bi, factor) {
  var resSign = $n(bi).Ljava_math_BigInteger__f_sign;
  var aNumberLength = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var aDigits = $n(bi).Ljava_math_BigInteger__f_digits;
  if ((resSign === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
  } else if ((aNumberLength === 1)) {
    var a = $n(aDigits).get(0);
    var a0 = (65535 & a);
    var a1 = ((a >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))))
  } else {
    var resLength = ((1 + aNumberLength) | 0);
    var resDigits = new $ac_I(resLength);
    $n(resDigits).set(aNumberLength, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aNumberLength, factor));
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger = (function(bi, exp) {
  var value = $n(this.Ljava_math_Multiplication$__f_TenPows).u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ exp.RTLong__f_lo) < ((-2147483648) ^ value)) : (ahi < hi))) {
    return this.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger(bi, $n(this.Ljava_math_Multiplication$__f_TenPows).get(exp.RTLong__f_lo))
  } else {
    return $n(bi).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.powerOf10__J__Ljava_math_BigInteger(exp))
  }
});
$c_Ljava_math_Multiplication$.prototype.square__AI__I__AI__AI = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var i$2 = i;
    elem = 0;
    var _\uff3fself = ((1 + i$2) | 0);
    var this$6 = new $c_ju_ScalaOps$SimpleRange(_\uff3fself, aLen);
    var i$1 = this$6.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$start;
    while ((i$1 < this$6.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$end)) {
      var j$2 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = $n(a).get(i$2);
      var b = $n(a).get(j$2);
      var c = $n(res).get(((i$2 + j$2) | 0));
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
      $n(res).set(((i$2 + j$2) | 0), lo$2);
      elem = hi$6;
      i$1 = ((1 + i$1) | 0)
    };
    $n(res).set(((i$2 + aLen) | 0), elem);
    i = ((1 + i) | 0)
  };
  $m_Ljava_math_BitLevel$().shiftLeftOneBit__AI__AI__I__V(res, res, (aLen << 1));
  elem = 0;
  var i$3 = 0;
  var index = 0;
  while ((i$3 < aLen)) {
    var a$2 = $n(a).get(i$3);
    var b$1 = $n(a).get(i$3);
    var c$1 = $n(res).get(index);
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ lo$3)) ? ((1 + hi$9) | 0) : hi$9);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$11) | 0) : hi$11);
    $n(res).set(index, lo$5);
    index = ((1 + index) | 0);
    var value = $n(res).get(index);
    var lo$6 = ((hi$13 + value) | 0);
    var hi$15 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ hi$13)) ? 1 : 0);
    $n(res).set(index, lo$6);
    elem = hi$15;
    i$3 = ((1 + i$3) | 0);
    index = ((1 + index) | 0)
  };
  return res
});
$c_Ljava_math_Multiplication$.prototype.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(val1, val2) {
  if (($n(val2).Ljava_math_BigInteger__f_numberLength > $n(val1).Ljava_math_BigInteger__f_numberLength)) {
    var x1___1 = val2;
    var x1___2 = val1
  } else {
    var x1___1 = val1;
    var x1___2 = val2
  };
  var op1 = $as_Ljava_math_BigInteger(x1___1);
  var op2 = $as_Ljava_math_BigInteger(x1___2);
  if (($n(op2).Ljava_math_BigInteger__f_numberLength < 63)) {
    return this.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, op2)
  } else {
    var ndiv2 = (((-2) & $n(op1).Ljava_math_BigInteger__f_numberLength) << 4);
    var upperOp1 = $n(op1).shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var upperOp2 = $n(op2).shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var this$1 = $n(op1);
    var bi = $n(upperOp1).shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$1, bi);
    var this$2 = $n(op2);
    var bi$1 = $n(upperOp2).shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp2 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, bi$1);
    var upper = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, upperOp2);
    var lower = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp1, lowerOp2);
    var this$3 = $n(upperOp1);
    var $$x1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, lowerOp1);
    var this$4 = $n(lowerOp2);
    var middle = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1, $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, upperOp2));
    var this$5 = $n(middle);
    var bi$2 = upper;
    var this$6 = $n($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$5, bi$2));
    middle = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$6, lower);
    middle = $n(middle).shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    upper = $n(upper).shiftLeft__I__Ljava_math_BigInteger((ndiv2 << 1));
    var this$7 = $n(upper);
    var bi$3 = middle;
    var this$8 = $n($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$7, bi$3));
    return $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, lower)
  }
});
$c_Ljava_math_Multiplication$.prototype.multArraysPAP__AI__I__AI__I__AI__V = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      $n(resDigits).set(bLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, $n(aDigits).get(0)))
    } else if ((bLen === 1)) {
      $n(resDigits).set(aLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, $n(bDigits).get(0)))
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen)
    }
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(a, b) {
  var aLen = $n(a).Ljava_math_BigInteger__f_numberLength;
  var bLen = $n(b).Ljava_math_BigInteger__f_numberLength;
  var resLength = ((aLen + bLen) | 0);
  var resSign = (($n(a).Ljava_math_BigInteger__f_sign !== $n(b).Ljava_math_BigInteger__f_sign) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = $n($n(a).Ljava_math_BigInteger__f_digits).get(0);
    var b$1 = $n($n(b).Ljava_math_BigInteger__f_digits).get(0);
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))))
  } else {
    var aDigits = $n(a).Ljava_math_BigInteger__f_digits;
    var bDigits = $n(b).Ljava_math_BigInteger__f_digits;
    var resDigits = new $ac_I(resLength);
    this.multArraysPAP__AI__I__AI__I__AI__V(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_Multiplication$.prototype.pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc) : res);
    if (($n(acc).Ljava_math_BigInteger__f_numberLength === 1)) {
      var acc2 = $n(acc).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc)
    } else {
      var a = new $ac_I(($n(acc).Ljava_math_BigInteger__f_numberLength << 1));
      var sq = this.square__AI__I__AI__AI($n(acc).Ljava_math_BigInteger__f_digits, $n(acc).Ljava_math_BigInteger__f_numberLength, a);
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, sq)
    };
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2
  };
  return $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc)
});
$c_Ljava_math_Multiplication$.prototype.powerOf10__J__Ljava_math_BigInteger = (function(exp) {
  var value = $n(this.Ljava_math_Multiplication$__f_BigTenPows).u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ exp.RTLong__f_lo) < ((-2147483648) ^ value)) : (ahi < hi))) {
    return $n(this.Ljava_math_Multiplication$__f_BigTenPows).get(exp.RTLong__f_lo)
  } else {
    var ahi$1 = exp.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-2147483598)) : (ahi$1 < 0))) {
      return $n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo)
    } else {
      var ahi$2 = exp.RTLong__f_hi;
      if (((ahi$2 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-1)) : (ahi$2 < 0))) {
        return $n($n($n(this.Ljava_math_Multiplication$__f_BigFivePows).get(1)).pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo)).shiftLeft__I__Ljava_math_BigInteger(exp.RTLong__f_lo)
      } else {
        var powerOfFive = $n($n(this.Ljava_math_Multiplication$__f_BigFivePows).get(1)).pow__I__Ljava_math_BigInteger(2147483647);
        var res = powerOfFive;
        var bhi = exp.RTLong__f_hi;
        var lo = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$1 = ((((-2147483648) ^ lo) < 1) ? bhi : (((-1) + bhi) | 0));
        var longExp__lo = lo;
        var longExp__hi = hi$1;
        var this$3 = $m_RTLong$();
        var lo$1 = this$3.remainderImpl__I__I__I__I__I(exp.RTLong__f_lo, exp.RTLong__f_hi, 2147483647, 0);
        while (true) {
          var this$4__lo = longExp__lo;
          var this$4__hi = longExp__hi;
          var ahi$3 = this$4__hi;
          if (((ahi$3 === 0) ? (((-2147483648) ^ this$4__lo) > (-1)) : (ahi$3 > 0))) {
            res = $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(powerOfFive);
            var b__lo = longExp__lo;
            var b__hi = longExp__hi;
            var bhi$1 = b__hi;
            var lo$2 = (((-2147483647) + b__lo) | 0);
            var hi$3 = ((((-2147483648) ^ lo$2) < 1) ? bhi$1 : (((-1) + bhi$1) | 0));
            var $$x1__lo = lo$2;
            var $$x1__hi = hi$3;
            longExp__lo = $$x1__lo;
            longExp__hi = $$x1__hi
          } else {
            break
          }
        };
        res = $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($n(this.Ljava_math_Multiplication$__f_BigFivePows).get(1)).pow__I__Ljava_math_BigInteger(lo$1));
        res = $n(res).shiftLeft__I__Ljava_math_BigInteger(2147483647);
        var bhi$2 = exp.RTLong__f_hi;
        var lo$3 = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$4 = ((((-2147483648) ^ lo$3) < 1) ? bhi$2 : (((-1) + bhi$2) | 0));
        var $$x2__lo = lo$3;
        var $$x2__hi = hi$4;
        longExp__lo = $$x2__lo;
        longExp__hi = $$x2__hi;
        while (true) {
          var this$7__lo = longExp__lo;
          var this$7__hi = longExp__hi;
          var ahi$4 = this$7__hi;
          if (((ahi$4 === 0) ? (((-2147483648) ^ this$7__lo) > (-1)) : (ahi$4 > 0))) {
            res = $n(res).shiftLeft__I__Ljava_math_BigInteger(2147483647);
            var b$1__lo = longExp__lo;
            var b$1__hi = longExp__hi;
            var bhi$3 = b$1__hi;
            var lo$4 = (((-2147483647) + b$1__lo) | 0);
            var hi$5 = ((((-2147483648) ^ lo$4) < 1) ? bhi$3 : (((-1) + bhi$3) | 0));
            var $$x3__lo = lo$4;
            var $$x3__hi = hi$5;
            longExp__lo = $$x3__lo;
            longExp__hi = $$x3__hi
          } else {
            break
          }
        };
        return $n(res).shiftLeft__I__Ljava_math_BigInteger(lo$1)
      }
    }
  }
});
var $d_Ljava_math_Multiplication$ = new $TypeData().initClass({
  Ljava_math_Multiplication$: 0
}, false, "java.math.Multiplication$", {
  Ljava_math_Multiplication$: 1,
  O: 1
});
$c_Ljava_math_Multiplication$.prototype.$classData = $d_Ljava_math_Multiplication$;
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$()
  };
  return $n_Ljava_math_Multiplication$
}
function $p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($thiz, m, size, v) {
  var this$2 = $n(m);
  if ((this$2.knownSize__I() >= 0)) {
    var len = this$2.knownSize__I();
    var destination = new ($d_T.getArrayOf().constr)(len);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
    var original = destination
  } else {
    var capacity = 0;
    var jsElems = null;
    capacity = 0;
    jsElems = [];
    var it = this$2.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    var original = new ($d_T.getArrayOf().constr)(jsElems)
  };
  var p = $asArrayOf_T($m_ju_Arrays$().copyOf__AO__I__AO(original, size), 1);
  var x = $n(m).length__I();
  var isEmpty = (x >= size);
  var scala$collection$immutable$Range$$lastElement = (((-1) + size) | 0);
  if ((!isEmpty)) {
    var i = x;
    while (true) {
      var v1 = i;
      $n(p).set(v1, v);
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break
      };
      i = ((1 + i) | 0)
    }
  };
  return p
}
function $p_Ljava_text_DateFormatSymbols$__padAndCopyDays__sci_List__I__T__AT($thiz, m, size, v) {
  var v$2 = new ($d_T.getArrayOf().constr)(size);
  var isEmpty = (size <= 0);
  var scala$collection$immutable$Range$$lastElement = (((-1) + size) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var v1 = i;
      if (((v1 === 0) || (v1 > $n(m).length__I()))) {
        $n(v$2).set(v1, "")
      } else {
        var $$x1 = $n(v$2);
        var this$6 = $n(m);
        var n = (((-1) + v1) | 0);
        $$x1.set(v1, $as_T($f_sc_LinearSeqOps__apply__I__O(this$6, n)))
      };
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break
      };
      i = ((1 + i) | 0)
    }
  };
  return v$2
}
function $p_Ljava_text_DateFormatSymbols$__toDFS__ju_Locale__Ljava_text_DateFormatSymbols__Llocales_cldr_LDML__Ljava_text_DateFormatSymbols($thiz, locale, dfs, ldml) {
  var read = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Llocales_cldr_CalendarSymbols(x$3$2);
    return $n(x$3).Llocales_cldr_CalendarSymbols__f_months
  }));
  var this$3 = $n($p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Llocales_cldr_CalendarSymbols(c$2);
    return $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__Llocales_cldr_CalendarSymbols__F1__s_Option($thiz, c, read)
  }))));
  var this$4 = $n((this$3.isEmpty__Z() ? new $c_s_Some($m_sci_Nil$()) : this$3));
  if ((!this$4.isEmpty__Z())) {
    var arg1 = this$4.get__O();
    var l = $as_sci_List(arg1);
    $n(dfs).setMonths__AT__V($p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($m_Ljava_text_DateFormatSymbols$(), l, 13, ""))
  };
  var read$1 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Llocales_cldr_CalendarSymbols(x$4$2);
    return $n(x$4).Llocales_cldr_CalendarSymbols__f_shortMonths
  }));
  var this$6 = $n($p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1(((c$2$1) => {
    var c$1 = $as_Llocales_cldr_CalendarSymbols(c$2$1);
    return $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__Llocales_cldr_CalendarSymbols__F1__s_Option($thiz, c$1, read$1)
  }))));
  var this$7 = $n((this$6.isEmpty__Z() ? new $c_s_Some($m_sci_Nil$()) : this$6));
  if ((!this$7.isEmpty__Z())) {
    var arg1$1 = this$7.get__O();
    var l$3 = $as_sci_List(arg1$1);
    $n(dfs).setShortMonths__AT__V($p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($m_Ljava_text_DateFormatSymbols$(), l$3, 13, ""))
  };
  var read$2 = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Llocales_cldr_CalendarSymbols(x$5$2);
    return $n(x$5).Llocales_cldr_CalendarSymbols__f_weekdays
  }));
  var this$9 = $n($p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1(((c$2$2) => {
    var c$3 = $as_Llocales_cldr_CalendarSymbols(c$2$2);
    return $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__Llocales_cldr_CalendarSymbols__F1__s_Option($thiz, c$3, read$2)
  }))));
  var this$10 = $n((this$9.isEmpty__Z() ? new $c_s_Some($m_sci_Nil$()) : this$9));
  if ((!this$10.isEmpty__Z())) {
    var arg1$2 = this$10.get__O();
    var l$4 = $as_sci_List(arg1$2);
    $n(dfs).setWeekdays__AT__V($p_Ljava_text_DateFormatSymbols$__padAndCopyDays__sci_List__I__T__AT($m_Ljava_text_DateFormatSymbols$(), l$4, 8, ""))
  };
  var read$3 = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Llocales_cldr_CalendarSymbols(x$6$2);
    return $n(x$6).Llocales_cldr_CalendarSymbols__f_shortWeekdays
  }));
  var this$12 = $n($p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1(((c$2$3) => {
    var c$4 = $as_Llocales_cldr_CalendarSymbols(c$2$3);
    return $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__Llocales_cldr_CalendarSymbols__F1__s_Option($thiz, c$4, read$3)
  }))));
  var this$13 = $n((this$12.isEmpty__Z() ? new $c_s_Some($m_sci_Nil$()) : this$12));
  if ((!this$13.isEmpty__Z())) {
    var arg1$3 = this$13.get__O();
    var l$5 = $as_sci_List(arg1$3);
    $n(dfs).setShortWeekdays__AT__V($p_Ljava_text_DateFormatSymbols$__padAndCopyDays__sci_List__I__T__AT($m_Ljava_text_DateFormatSymbols$(), l$5, 8, ""))
  };
  var read$4 = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Llocales_cldr_CalendarSymbols(x$7$2);
    return $n(x$7).Llocales_cldr_CalendarSymbols__f_amPm
  }));
  var this$15 = $n($p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1(((c$2$4) => {
    var c$5 = $as_Llocales_cldr_CalendarSymbols(c$2$4);
    return $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__Llocales_cldr_CalendarSymbols__F1__s_Option($thiz, c$5, read$4)
  }))));
  var this$16 = $n((this$15.isEmpty__Z() ? new $c_s_Some($m_sci_Nil$()) : this$15));
  if ((!this$16.isEmpty__Z())) {
    var arg1$4 = this$16.get__O();
    var l$6 = $as_sci_List(arg1$4);
    $n(dfs).setAmPmStrings__AT__V($p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($m_Ljava_text_DateFormatSymbols$(), l$6, 2, ""))
  };
  var read$5 = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_Llocales_cldr_CalendarSymbols(x$8$2);
    return $n(x$8).Llocales_cldr_CalendarSymbols__f_eras
  }));
  var this$18 = $n($p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1(((c$2$5) => {
    var c$6 = $as_Llocales_cldr_CalendarSymbols(c$2$5);
    return $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__Llocales_cldr_CalendarSymbols__F1__s_Option($thiz, c$6, read$5)
  }))));
  var this$19 = $n((this$18.isEmpty__Z() ? new $c_s_Some($m_sci_Nil$()) : this$18));
  if ((!this$19.isEmpty__Z())) {
    var arg1$5 = this$19.get__O();
    var l$7 = $as_sci_List(arg1$5);
    $n(dfs).setEras__AT__V($p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($m_Ljava_text_DateFormatSymbols$(), l$7, 2, ""))
  };
  return dfs
}
function $p_Ljava_text_DateFormatSymbols$__parentSymbols$1__Llocales_cldr_LDML__s_Option($thiz, ldml) {
  var this$1 = $n($n(ldml).Llocales_cldr_LDML__f_calendarSymbols);
  if (this$1.isEmpty__Z()) {
    var this$2 = $n($n(ldml).Llocales_cldr_LDML__f_parent);
    if (this$2.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var ldml$1 = $as_Llocales_cldr_LDML(arg1);
      return $p_Ljava_text_DateFormatSymbols$__parentSymbols$1__Llocales_cldr_LDML__s_Option($thiz, ldml$1)
    }
  } else {
    return this$1
  }
}
function $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, read) {
  var this$1 = $n($p_Ljava_text_DateFormatSymbols$__parentSymbols$1__Llocales_cldr_LDML__s_Option($thiz, ldml));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var s = $as_Llocales_cldr_CalendarSymbols(arg1);
    var this$2 = $n($as_s_Option($n(read).apply__O__O(s)));
    if (this$2.isEmpty__Z()) {
      var this$3 = $n($n(ldml).Llocales_cldr_LDML__f_parent);
      if (this$3.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1$1 = this$3.get__O();
        var x$2 = $as_Llocales_cldr_LDML(arg1$1);
        return $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, x$2, read)
      }
    } else {
      return this$2
    }
  }
}
function $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__Llocales_cldr_CalendarSymbols__F1__s_Option($thiz, c, read$2) {
  var x1 = $as_sci_List($n(read$2).apply__O__O(c));
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(x1)) {
    return $m_s_None$()
  } else {
    return new $c_s_Some(x1)
  }
}
/** @constructor */
function $c_Ljava_text_DateFormatSymbols$() {
  /*<skip>*/
}
$c_Ljava_text_DateFormatSymbols$.prototype = new $h_O();
$c_Ljava_text_DateFormatSymbols$.prototype.constructor = $c_Ljava_text_DateFormatSymbols$;
/** @constructor */
function $h_Ljava_text_DateFormatSymbols$() {
  /*<skip>*/
}
$h_Ljava_text_DateFormatSymbols$.prototype = $c_Ljava_text_DateFormatSymbols$.prototype;
$c_Ljava_text_DateFormatSymbols$.prototype.getInstance__ju_Locale__Ljava_text_DateFormatSymbols = (function(locale) {
  return this.java$text$DateFormatSymbols$$initialize__ju_Locale__Ljava_text_DateFormatSymbols__Ljava_text_DateFormatSymbols(locale, new $c_Ljava_text_DateFormatSymbols(locale))
});
$c_Ljava_text_DateFormatSymbols$.prototype.java$text$DateFormatSymbols$$initialize__ju_Locale__Ljava_text_DateFormatSymbols__Ljava_text_DateFormatSymbols = (function(locale, dfs) {
  var this$1 = $n($m_Llocales_LocalesDb$().ldml__ju_Locale__s_Option(locale));
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var l = $as_Llocales_cldr_LDML(arg1);
    var $$x1 = new $c_s_Some($p_Ljava_text_DateFormatSymbols$__toDFS__ju_Locale__Ljava_text_DateFormatSymbols__Llocales_cldr_LDML__Ljava_text_DateFormatSymbols($m_Ljava_text_DateFormatSymbols$(), locale, dfs, l))
  };
  var this$2 = $n($$x1);
  return $as_Ljava_text_DateFormatSymbols((this$2.isEmpty__Z() ? dfs : this$2.get__O()))
});
var $d_Ljava_text_DateFormatSymbols$ = new $TypeData().initClass({
  Ljava_text_DateFormatSymbols$: 0
}, false, "java.text.DateFormatSymbols$", {
  Ljava_text_DateFormatSymbols$: 1,
  O: 1
});
$c_Ljava_text_DateFormatSymbols$.prototype.$classData = $d_Ljava_text_DateFormatSymbols$;
var $n_Ljava_text_DateFormatSymbols$;
function $m_Ljava_text_DateFormatSymbols$() {
  if ((!$n_Ljava_text_DateFormatSymbols$)) {
    $n_Ljava_text_DateFormatSymbols$ = new $c_Ljava_text_DateFormatSymbols$()
  };
  return $n_Ljava_text_DateFormatSymbols$
}
/** @constructor */
function $c_Ljava_text_ParsePosition(index) {
  this.Ljava_text_ParsePosition__f_index = 0;
  this.Ljava_text_ParsePosition__f_errorIndex = 0;
  this.Ljava_text_ParsePosition__f_index = index;
  this.Ljava_text_ParsePosition__f_errorIndex = (-1)
}
$c_Ljava_text_ParsePosition.prototype = new $h_O();
$c_Ljava_text_ParsePosition.prototype.constructor = $c_Ljava_text_ParsePosition;
/** @constructor */
function $h_Ljava_text_ParsePosition() {
  /*<skip>*/
}
$h_Ljava_text_ParsePosition.prototype = $c_Ljava_text_ParsePosition.prototype;
$c_Ljava_text_ParsePosition.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_text_ParsePosition)) {
    var x2 = $as_Ljava_text_ParsePosition(other);
    return ((this.Ljava_text_ParsePosition__f_errorIndex === $n(x2).Ljava_text_ParsePosition__f_errorIndex) && (this.Ljava_text_ParsePosition__f_index === $n(x2).Ljava_text_ParsePosition__f_index))
  } else {
    return false
  }
});
$c_Ljava_text_ParsePosition.prototype.hashCode__I = (function() {
  var $$x1 = $m_sci_Seq$();
  var array = [this.Ljava_text_ParsePosition__f_errorIndex, this.Ljava_text_ParsePosition__f_index];
  var state = $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  return $uI($n($as_sc_IterableOnceOps($n(state).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $uI(x$1$2);
    return x$1
  }))))).foldLeft__O__F2__O(0, new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $uI(a$2);
    var b = $uI(b$2);
    return ((Math.imul(31, a) + b) | 0)
  }))))
});
$c_Ljava_text_ParsePosition.prototype.toString__T = (function() {
  return (((("java.text.ParsePosition[index=" + this.Ljava_text_ParsePosition__f_index) + ",errorIndex=") + this.Ljava_text_ParsePosition__f_errorIndex) + "]")
});
function $as_Ljava_text_ParsePosition(obj) {
  return (((obj instanceof $c_Ljava_text_ParsePosition) || (obj === null)) ? obj : $throwClassCastException(obj, "java.text.ParsePosition"))
}
function $isArrayOf_Ljava_text_ParsePosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_text_ParsePosition)))
}
function $asArrayOf_Ljava_text_ParsePosition(obj, depth) {
  return (($isArrayOf_Ljava_text_ParsePosition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.text.ParsePosition;", depth))
}
var $d_Ljava_text_ParsePosition = new $TypeData().initClass({
  Ljava_text_ParsePosition: 0
}, false, "java.text.ParsePosition", {
  Ljava_text_ParsePosition: 1,
  O: 1
});
$c_Ljava_text_ParsePosition.prototype.$classData = $d_Ljava_text_ParsePosition;
/** @constructor */
function $c_Ljava_time_Clock() {
  /*<skip>*/
}
$c_Ljava_time_Clock.prototype = new $h_O();
$c_Ljava_time_Clock.prototype.constructor = $c_Ljava_time_Clock;
/** @constructor */
function $h_Ljava_time_Clock() {
  /*<skip>*/
}
$h_Ljava_time_Clock.prototype = $c_Ljava_time_Clock.prototype;
/** @constructor */
function $c_Ljava_time_Clock$() {
  /*<skip>*/
}
$c_Ljava_time_Clock$.prototype = new $h_O();
$c_Ljava_time_Clock$.prototype.constructor = $c_Ljava_time_Clock$;
/** @constructor */
function $h_Ljava_time_Clock$() {
  /*<skip>*/
}
$h_Ljava_time_Clock$.prototype = $c_Ljava_time_Clock$.prototype;
$c_Ljava_time_Clock$.prototype.system__Ljava_time_ZoneId__Ljava_time_Clock = (function(zone) {
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  return new $c_Ljava_time_Clock$SystemClock(zone)
});
var $d_Ljava_time_Clock$ = new $TypeData().initClass({
  Ljava_time_Clock$: 0
}, false, "java.time.Clock$", {
  Ljava_time_Clock$: 1,
  O: 1
});
$c_Ljava_time_Clock$.prototype.$classData = $d_Ljava_time_Clock$;
var $n_Ljava_time_Clock$;
function $m_Ljava_time_Clock$() {
  if ((!$n_Ljava_time_Clock$)) {
    $n_Ljava_time_Clock$ = new $c_Ljava_time_Clock$()
  };
  return $n_Ljava_time_Clock$
}
/** @constructor */
function $c_Ljava_time_chrono_Chronology$() {
  /*<skip>*/
}
$c_Ljava_time_chrono_Chronology$.prototype = new $h_O();
$c_Ljava_time_chrono_Chronology$.prototype.constructor = $c_Ljava_time_chrono_Chronology$;
/** @constructor */
function $h_Ljava_time_chrono_Chronology$() {
  /*<skip>*/
}
$h_Ljava_time_chrono_Chronology$.prototype = $c_Ljava_time_chrono_Chronology$.prototype;
$c_Ljava_time_chrono_Chronology$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology = (function(temporal) {
  if ((temporal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "temporal")
  };
  var obj = $as_Ljava_time_chrono_Chronology($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()));
  return ((obj !== null) ? obj : $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology())
});
var $d_Ljava_time_chrono_Chronology$ = new $TypeData().initClass({
  Ljava_time_chrono_Chronology$: 0
}, false, "java.time.chrono.Chronology$", {
  Ljava_time_chrono_Chronology$: 1,
  O: 1
});
$c_Ljava_time_chrono_Chronology$.prototype.$classData = $d_Ljava_time_chrono_Chronology$;
var $n_Ljava_time_chrono_Chronology$;
function $m_Ljava_time_chrono_Chronology$() {
  if ((!$n_Ljava_time_chrono_Chronology$)) {
    $n_Ljava_time_chrono_Chronology$ = new $c_Ljava_time_chrono_Chronology$()
  };
  return $n_Ljava_time_chrono_Chronology$
}
function $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException($thiz, text, ex) {
  var abbr = (($dp_length__I($n(text)) > 64) ? ($dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n(text), 0, 64))) + "...") : $dp_toString__T($n(text)));
  return new $c_Ljava_time_format_DateTimeParseException(((("Text '" + abbr) + "' could not be parsed: ") + $n(ex).getMessage__T()), text, 0, ex)
}
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter(printerParser, locale, decimalStyle, resolverStyle, resolverFields, chrono, zone) {
  this.Ljava_time_format_DateTimeFormatter__f_printerParser = null;
  this.Ljava_time_format_DateTimeFormatter__f_locale = null;
  this.Ljava_time_format_DateTimeFormatter__f_decimalStyle = null;
  this.Ljava_time_format_DateTimeFormatter__f_resolverStyle = null;
  this.Ljava_time_format_DateTimeFormatter__f_resolverFields = null;
  this.Ljava_time_format_DateTimeFormatter__f_chrono = null;
  this.Ljava_time_format_DateTimeFormatter__f_zone = null;
  this.Ljava_time_format_DateTimeFormatter__f_printerParser = printerParser;
  this.Ljava_time_format_DateTimeFormatter__f_locale = locale;
  this.Ljava_time_format_DateTimeFormatter__f_decimalStyle = decimalStyle;
  this.Ljava_time_format_DateTimeFormatter__f_resolverStyle = resolverStyle;
  this.Ljava_time_format_DateTimeFormatter__f_resolverFields = resolverFields;
  this.Ljava_time_format_DateTimeFormatter__f_chrono = chrono;
  this.Ljava_time_format_DateTimeFormatter__f_zone = zone;
  if ((printerParser === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "printerParser")
  };
  if ((locale === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "locale")
  };
  if ((decimalStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "decimalStyle")
  };
  if ((resolverStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "resolverStyle")
  }
}
$c_Ljava_time_format_DateTimeFormatter.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatter.prototype.constructor = $c_Ljava_time_format_DateTimeFormatter;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatter.prototype = $c_Ljava_time_format_DateTimeFormatter.prototype;
$c_Ljava_time_format_DateTimeFormatter.prototype.withLocale__ju_Locale__Ljava_time_format_DateTimeFormatter = (function(locale) {
  var x = this.Ljava_time_format_DateTimeFormatter__f_locale;
  if (((x === null) ? (locale === null) : $n(x).equals__O__Z(locale))) {
    return this
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.Ljava_time_format_DateTimeFormatter__f_printerParser, locale, this.Ljava_time_format_DateTimeFormatter__f_decimalStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields, this.Ljava_time_format_DateTimeFormatter__f_chrono, this.Ljava_time_format_DateTimeFormatter__f_zone)
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter = (function(chrono) {
  var a = this.Ljava_time_format_DateTimeFormatter__f_chrono;
  if ((a === null)) {
    var $$x1 = (chrono === null)
  } else {
    var this$2 = $n(a);
    var $$x1 = $f_Ljava_time_chrono_Chronology__equals__O__Z(this$2, chrono)
  };
  if ($$x1) {
    return this
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.Ljava_time_format_DateTimeFormatter__f_printerParser, this.Ljava_time_format_DateTimeFormatter__f_locale, this.Ljava_time_format_DateTimeFormatter__f_decimalStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields, chrono, this.Ljava_time_format_DateTimeFormatter__f_zone)
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.withZone__Ljava_time_ZoneId__Ljava_time_format_DateTimeFormatter = (function(zone) {
  var a = this.Ljava_time_format_DateTimeFormatter__f_zone;
  if (((a === null) ? (zone === null) : $n(a).equals__O__Z(zone))) {
    return this
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.Ljava_time_format_DateTimeFormatter__f_printerParser, this.Ljava_time_format_DateTimeFormatter__f_locale, this.Ljava_time_format_DateTimeFormatter__f_decimalStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields, this.Ljava_time_format_DateTimeFormatter__f_chrono, zone)
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter = (function(resolverStyle) {
  if ((resolverStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "resolverStyle")
  };
  var a = this.Ljava_time_format_DateTimeFormatter__f_resolverStyle;
  if ((a === null)) {
    var $$x1 = (resolverStyle === null)
  } else {
    var this$3 = $n(a);
    var $$x1 = (this$3 === resolverStyle)
  };
  if ($$x1) {
    return this
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.Ljava_time_format_DateTimeFormatter__f_printerParser, this.Ljava_time_format_DateTimeFormatter__f_locale, this.Ljava_time_format_DateTimeFormatter__f_decimalStyle, resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields, this.Ljava_time_format_DateTimeFormatter__f_chrono, this.Ljava_time_format_DateTimeFormatter__f_zone)
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.format__Ljava_time_temporal_TemporalAccessor__T = (function(temporal) {
  var buf = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
  this.formatTo__Ljava_time_temporal_TemporalAccessor__jl_Appendable__V(temporal, buf);
  return buf.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_format_DateTimeFormatter.prototype.formatTo__Ljava_time_temporal_TemporalAccessor__jl_Appendable__V = (function(temporal, appendable) {
  if ((temporal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "temporal")
  };
  if ((appendable === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "appendable")
  };
  try {
    var context = $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__(new $c_Ljava_time_format_internal_TTBPDateTimePrintContext(), temporal, this);
    if ((appendable instanceof $c_jl_StringBuilder)) {
      $n(this.Ljava_time_format_DateTimeFormatter__f_printerParser).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, $as_jl_StringBuilder(appendable))
    } else {
      var buf = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
      $n(this.Ljava_time_format_DateTimeFormatter__f_printerParser).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf);
      $n(appendable).append__jl_CharSequence__jl_Appendable(buf)
    }
  } catch (e) {
    if (false) {
      var ex = $as_Ljava_io_IOException(e);
      throw $ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $c_Ljava_time_DateTimeException(), $n(ex).getMessage__T(), ex)
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O = (function(text, type) {
  if ((text === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "text")
  };
  if ((type === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "type")
  };
  try {
    var builder = $n(this.java$time$format$DateTimeFormatter$$parseToBuilder__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_DateTimeBuilder(text, null)).resolve__Ljava_time_format_ResolverStyle__ju_Set__Ljava_time_format_DateTimeBuilder(this.Ljava_time_format_DateTimeFormatter__f_resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields);
    var this$3 = $n(builder);
    return $n(type).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this$3)
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    if ((e$2 instanceof $c_Ljava_time_format_DateTimeParseException)) {
      var ex$2 = $as_Ljava_time_format_DateTimeParseException(e$2);
      throw ((ex$2 === null) ? $n(null) : ex$2)
    } else if ((e$2 instanceof $c_jl_RuntimeException)) {
      var ex = $as_jl_RuntimeException(e$2);
      var x = $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException(this, text, ex);
      throw ((x === null) ? $n(null) : x)
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.java$time$format$DateTimeFormatter$$parseToBuilder__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_DateTimeBuilder = (function(text, position) {
  var pos = ((position !== null) ? position : new $c_Ljava_text_ParsePosition(0));
  var result = this.java$time$format$DateTimeFormatter$$parseUnresolved0__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(text, pos);
  if ((((result === null) || ($n(pos).Ljava_text_ParsePosition__f_errorIndex >= 0)) || ((position === null) && ($n(pos).Ljava_text_ParsePosition__f_index < $dp_length__I($n(text)))))) {
    var abbr = (($dp_length__I($n(text)) > 64) ? ($dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n(text), 0, 64))) + "...") : $dp_toString__T($n(text)));
    if (($n(pos).Ljava_text_ParsePosition__f_errorIndex >= 0)) {
      throw new $c_Ljava_time_format_DateTimeParseException(((("Text '" + abbr) + "' could not be parsed at index ") + $n(pos).Ljava_text_ParsePosition__f_errorIndex), text, $n(pos).Ljava_text_ParsePosition__f_errorIndex, null)
    } else {
      throw new $c_Ljava_time_format_DateTimeParseException(((("Text '" + abbr) + "' could not be parsed, unparsed text found at index ") + $n(pos).Ljava_text_ParsePosition__f_index), text, $n(pos).Ljava_text_ParsePosition__f_index, null)
    }
  };
  return $n(result).toBuilder__Ljava_time_format_DateTimeBuilder()
});
$c_Ljava_time_format_DateTimeFormatter.prototype.java$time$format$DateTimeFormatter$$parseUnresolved0__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = (function(text, position) {
  if ((text === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "text")
  };
  if ((position === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "position")
  };
  var context = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), this);
  var pos = $n(this.Ljava_time_format_DateTimeFormatter__f_printerParser).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, $n(position).Ljava_text_ParsePosition__f_index);
  if ((pos < 0)) {
    $n(position).Ljava_text_ParsePosition__f_errorIndex = (~pos);
    return null
  } else {
    $n(position).Ljava_text_ParsePosition__f_index = pos;
    return $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(context)
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.toString__T = (function() {
  var pattern = $n(this.Ljava_time_format_DateTimeFormatter__f_printerParser).toString__T();
  var this$1 = $n(pattern);
  if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 1)) === "["))) {
    return pattern
  } else {
    var this$3 = $n(pattern);
    var this$2 = $n(pattern);
    var endIndex = (((-1) + this$2.length) | 0);
    if ((endIndex > this$3.length)) {
      $charAt(this$3, endIndex)
    };
    if ((endIndex < 1)) {
      $charAt(this$3, (-1))
    };
    return $as_T(this$3.substring(1, endIndex))
  }
});
var $d_Ljava_time_format_DateTimeFormatter = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatter: 0
}, false, "java.time.format.DateTimeFormatter", {
  Ljava_time_format_DateTimeFormatter: 1,
  O: 1
});
$c_Ljava_time_format_DateTimeFormatter.prototype.$classData = $d_Ljava_time_format_DateTimeFormatter;
function $p_Ljava_time_format_DateTimeFormatter$__ISO_LOCAL_DATE$lzycompute__Ljava_time_format_DateTimeFormatter($thiz) {
  if (((1 & $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0) === 0)) {
    var this$1 = $n($n($n($n($n($ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField(), 4, 10, $m_Ljava_time_format_SignStyle$().EXCEEDS_PAD__Ljava_time_format_SignStyle())).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(45)).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField(), 2)).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(45)).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField(), 2));
    var style = $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    $thiz.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE = $n($n(this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter($p_ju_Locale$__defaultLocale__ju_Locale(this$2))).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style)).withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0 = (1 | $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0)
  };
  return $thiz.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE
}
function $p_Ljava_time_format_DateTimeFormatter$__ISO_LOCAL_TIME$lzycompute__Ljava_time_format_DateTimeFormatter($thiz) {
  if (((8 & $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0) === 0)) {
    var this$1 = $n($n($n($n($n($n($n($n($ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), 2)).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58)).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), 2)).optionalStart__Ljava_time_format_DateTimeFormatterBuilder()).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58)).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), 2)).optionalStart__Ljava_time_format_DateTimeFormatterBuilder()).appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), 0, 9, true));
    var style = $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    $thiz.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIME = $n(this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter($p_ju_Locale$__defaultLocale__ju_Locale(this$2))).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style);
    $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0 = (8 | $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0)
  };
  return $thiz.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIME
}
function $p_Ljava_time_format_DateTimeFormatter$__ISO_LOCAL_DATE_TIME$lzycompute__Ljava_time_format_DateTimeFormatter($thiz) {
  if (((64 & $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0) === 0)) {
    var this$1 = $n($n($n($n($ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder()).append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder($thiz.ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter())).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(84)).append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder($thiz.ISO_LOCAL_TIME__Ljava_time_format_DateTimeFormatter()));
    var style = $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    $thiz.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIME = $n($n(this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter($p_ju_Locale$__defaultLocale__ju_Locale(this$2))).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style)).withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0 = (64 | $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0)
  };
  return $thiz.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIME
}
function $p_Ljava_time_format_DateTimeFormatter$__ISO_INSTANT$lzycompute__Ljava_time_format_DateTimeFormatter($thiz) {
  if (((4096 & $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0) === 0)) {
    var this$1 = $n($n($ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder()).appendInstant__Ljava_time_format_DateTimeFormatterBuilder());
    var style = $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    $thiz.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT = $n(this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter($p_ju_Locale$__defaultLocale__ju_Locale(this$2))).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style);
    $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0 = (4096 | $thiz.Ljava_time_format_DateTimeFormatter$__f_bitmap$0)
  };
  return $thiz.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT
}
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter$() {
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIME = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIME = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT = null;
  this.Ljava_time_format_DateTimeFormatter$__f_bitmap$0 = 0
}
$c_Ljava_time_format_DateTimeFormatter$.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatter$.prototype.constructor = $c_Ljava_time_format_DateTimeFormatter$;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter$() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatter$.prototype = $c_Ljava_time_format_DateTimeFormatter$.prototype;
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter = (function() {
  return (((1 & this.Ljava_time_format_DateTimeFormatter$__f_bitmap$0) === 0) ? $p_Ljava_time_format_DateTimeFormatter$__ISO_LOCAL_DATE$lzycompute__Ljava_time_format_DateTimeFormatter(this) : this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE)
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_LOCAL_TIME__Ljava_time_format_DateTimeFormatter = (function() {
  return (((8 & this.Ljava_time_format_DateTimeFormatter$__f_bitmap$0) === 0) ? $p_Ljava_time_format_DateTimeFormatter$__ISO_LOCAL_TIME$lzycompute__Ljava_time_format_DateTimeFormatter(this) : this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_TIME)
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_LOCAL_DATE_TIME__Ljava_time_format_DateTimeFormatter = (function() {
  return (((64 & this.Ljava_time_format_DateTimeFormatter$__f_bitmap$0) === 0) ? $p_Ljava_time_format_DateTimeFormatter$__ISO_LOCAL_DATE_TIME$lzycompute__Ljava_time_format_DateTimeFormatter(this) : this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE_TIME)
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_INSTANT__Ljava_time_format_DateTimeFormatter = (function() {
  return (((4096 & this.Ljava_time_format_DateTimeFormatter$__f_bitmap$0) === 0) ? $p_Ljava_time_format_DateTimeFormatter$__ISO_INSTANT$lzycompute__Ljava_time_format_DateTimeFormatter(this) : this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT)
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ofPattern__T__Ljava_time_format_DateTimeFormatter = (function(pattern) {
  var this$1 = $n($ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).appendPattern__T__Ljava_time_format_DateTimeFormatterBuilder(pattern));
  var this$2 = $m_ju_Locale$();
  return this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter($p_ju_Locale$__defaultLocale__ju_Locale(this$2))
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ofPattern__T__ju_Locale__Ljava_time_format_DateTimeFormatter = (function(pattern, locale) {
  return $n($ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).appendPattern__T__Ljava_time_format_DateTimeFormatterBuilder(pattern)).toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(locale)
});
var $d_Ljava_time_format_DateTimeFormatter$ = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatter$: 0
}, false, "java.time.format.DateTimeFormatter$", {
  Ljava_time_format_DateTimeFormatter$: 1,
  O: 1
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.$classData = $d_Ljava_time_format_DateTimeFormatter$;
var $n_Ljava_time_format_DateTimeFormatter$;
function $m_Ljava_time_format_DateTimeFormatter$() {
  if ((!$n_Ljava_time_format_DateTimeFormatter$)) {
    $n_Ljava_time_format_DateTimeFormatter$ = new $c_Ljava_time_format_DateTimeFormatter$()
  };
  return $n_Ljava_time_format_DateTimeFormatter$
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz) {
  if (((((1 & $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeFormatterBuilder.scala: 184")
  };
  return $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__active_$eq__Ljava_time_format_DateTimeFormatterBuilder__V($thiz, x$1) {
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active = x$1;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = (((1 | $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24)
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__printerParsers__ju_List($thiz) {
  if (((((2 & $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeFormatterBuilder.scala: 187")
  };
  return $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__padNextWidth__I($thiz) {
  if (((((4 & $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeFormatterBuilder.scala: 191")
  };
  return $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__padNextWidth_$eq__I__V($thiz, x$1) {
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = x$1;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = (((4 | $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24)
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__padNextChar__C($thiz) {
  if (((((8 & $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeFormatterBuilder.scala: 194")
  };
  return $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__padNextChar_$eq__C__V($thiz, x$1) {
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = x$1;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = (((8 | $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24)
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex__I($thiz) {
  if (((((16 & $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeFormatterBuilder.scala: 197")
  };
  return $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex_$eq__I__V($thiz, x$1) {
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = x$1;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = (((16 | $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24)
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder($thiz, pp) {
  if ((($p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex__I($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz))) >= 0) && ($n($p_Ljava_time_format_DateTimeFormatterBuilder__printerParsers__ju_List($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)))).get__I__O($p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex__I($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)))) instanceof $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser))) {
    var activeValueParser = $p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex__I($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)));
    var basePP = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser($n($p_Ljava_time_format_DateTimeFormatterBuilder__printerParsers__ju_List($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)))).get__I__O(activeValueParser));
    if ((($n(pp).Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === $n(pp).Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) && ($n(pp).Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle()))) {
      basePP = $n(basePP).withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser($n(pp).Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth);
      $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I($thiz, $n(pp).withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser());
      $p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex_$eq__I__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)), activeValueParser)
    } else {
      basePP = $n(basePP).withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser();
      $p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex_$eq__I__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)), $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I($thiz, pp))
    };
    $n($p_Ljava_time_format_DateTimeFormatterBuilder__printerParsers__ju_List($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)))).set__I__O__O(activeValueParser, basePP)
  } else {
    $p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex_$eq__I__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)), $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I($thiz, pp))
  };
  return $thiz
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__parsePattern__T__V($thiz, pattern) {
  var pos = 0;
  while (true) {
    var $$x11 = pos;
    var this$1 = $n(pattern);
    if (($$x11 < this$1.length)) {
      var this$2 = $n(pattern);
      var index = pos;
      var cur = $charAt(this$2, index);
      if ((((cur >= 65) && (cur <= 90)) || ((cur >= 97) && (cur <= 122)))) {
        var start = pos;
        pos = ((1 + pos) | 0);
        while (true) {
          var $$x2 = pos;
          var this$3 = $n(pattern);
          if (($$x2 < this$3.length)) {
            var this$4 = $n(pattern);
            var index$1 = pos;
            var $$x1 = ($charAt(this$4, index$1) === cur)
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            pos = ((1 + pos) | 0)
          } else {
            break
          }
        };
        var count = ((pos - start) | 0);
        if ((cur === 112)) {
          var pad = 0;
          var $$x3 = pos;
          var this$5 = $n(pattern);
          if (($$x3 < this$5.length)) {
            var this$6 = $n(pattern);
            var index$2 = pos;
            cur = $charAt(this$6, index$2);
            if ((((cur >= 65) && (cur <= 90)) || ((cur >= 97) && (cur <= 122)))) {
              pad = count;
              start = pos;
              pos = ((1 + pos) | 0);
              while (true) {
                var $$x5 = pos;
                var this$7 = $n(pattern);
                if (($$x5 < this$7.length)) {
                  var this$8 = $n(pattern);
                  var index$3 = pos;
                  var $$x4 = ($charAt(this$8, index$3) === cur)
                } else {
                  var $$x4 = false
                };
                if ($$x4) {
                  pos = ((1 + pos) | 0)
                } else {
                  break
                }
              };
              count = ((pos - start) | 0)
            }
          };
          if ((pad === 0)) {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Pad letter 'p' must be followed by valid pad pattern: " + pattern))
          };
          var padWidth = pad;
          $thiz.padNext__I__C__Ljava_time_format_DateTimeFormatterBuilder(padWidth, 32)
        };
        var field = $as_Ljava_time_temporal_TemporalField($n($m_Ljava_time_format_DateTimeFormatterBuilder$().java$time$format$DateTimeFormatterBuilder$$FIELD_MAP__ju_Map()).get__O__O($bC(cur)));
        if ((field !== null)) {
          $p_Ljava_time_format_DateTimeFormatterBuilder__parseField__C__I__Ljava_time_temporal_TemporalField__V($thiz, cur, count, field)
        } else if ((cur === 122)) {
          if ((count > 4)) {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $bC(cur)))
          } else if ((count === 4)) {
            $thiz.appendZoneText__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle())
          } else {
            $thiz.appendZoneText__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle())
          }
        } else if ((cur === 86)) {
          if ((count !== 2)) {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Pattern letter count must be 2: " + $bC(cur)))
          };
          $thiz.appendZoneId__Ljava_time_format_DateTimeFormatterBuilder()
        } else if ((cur === 90)) {
          if ((count < 4)) {
            $thiz.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder("+HHMM", "+0000")
          } else if ((count === 4)) {
            $thiz.appendLocalizedOffset__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle())
          } else if ((count === 5)) {
            $thiz.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder("+HH:MM:ss", "Z")
          } else {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $bC(cur)))
          }
        } else if ((cur === 79)) {
          if ((count === 1)) {
            $thiz.appendLocalizedOffset__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle())
          } else if ((count === 4)) {
            $thiz.appendLocalizedOffset__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle())
          } else {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Pattern letter count must be 1 or 4: " + $bC(cur)))
          }
        } else if ((cur === 88)) {
          if ((count > 5)) {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $bC(cur)))
          };
          $thiz.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder($n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().PATTERNS__AT()).get(((count + ((count === 1) ? 0 : 1)) | 0)), "Z")
        } else if ((cur === 120)) {
          if ((count > 5)) {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $bC(cur)))
          };
          var zero = ((count === 1) ? "+00" : ((((count % 2) | 0) === 0) ? "+0000" : "+00:00"));
          $thiz.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder($n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().PATTERNS__AT()).get(((count + ((count === 1) ? 0 : 1)) | 0)), zero)
        } else if ((cur === 87)) {
          if ((count > 1)) {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $bC(cur)))
          };
          $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(87, count))
        } else if ((cur === 119)) {
          if ((count > 2)) {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $bC(cur)))
          };
          $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(119, count))
        } else if ((cur === 89)) {
          $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(89, count))
        } else {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Unknown pattern letter: " + $bC(cur)))
        };
        pos = (((-1) + pos) | 0)
      } else if ((cur === 39)) {
        var start$2 = pos;
        pos = ((1 + pos) | 0);
        var break$1 = false;
        while (true) {
          if ((!break$1)) {
            var $$x9 = pos;
            var this$9 = $n(pattern);
            var $$x8 = ($$x9 < this$9.length)
          } else {
            var $$x8 = false
          };
          if ($$x8) {
            var this$10 = $n(pattern);
            var index$4 = pos;
            if (($charAt(this$10, index$4) === 39)) {
              var $$x7 = pos;
              var this$11 = $n(pattern);
              if ((((1 + $$x7) | 0) < this$11.length)) {
                var this$12 = $n(pattern);
                var index$5 = ((1 + pos) | 0);
                var $$x6 = ($charAt(this$12, index$5) === 39)
              } else {
                var $$x6 = false
              };
              if ($$x6) {
                pos = ((1 + pos) | 0)
              } else {
                break$1 = true
              }
            };
            if ((!break$1)) {
              pos = ((1 + pos) | 0)
            }
          } else {
            break
          }
        };
        var $$x10 = pos;
        var this$13 = $n(pattern);
        if (($$x10 >= this$13.length)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Pattern ends with an incomplete string literal: " + pattern))
        };
        var this$14 = $n(pattern);
        var beginIndex = ((1 + start$2) | 0);
        var endIndex = pos;
        if ((beginIndex < 0)) {
          $charAt(this$14, beginIndex)
        };
        if ((endIndex > this$14.length)) {
          $charAt(this$14, endIndex)
        };
        if ((endIndex < beginIndex)) {
          $charAt(this$14, (-1))
        };
        var str = $as_T(this$14.substring(beginIndex, endIndex));
        var this$15 = $n(str);
        if ((this$15.length === 0)) {
          $thiz.appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(39)
        } else {
          var this$16 = $n(str);
          $thiz.appendLiteral__T__Ljava_time_format_DateTimeFormatterBuilder($as_T(this$16.split("''").join("'")))
        }
      } else if ((cur === 91)) {
        $thiz.optionalStart__Ljava_time_format_DateTimeFormatterBuilder()
      } else if ((cur === 93)) {
        if (($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)).Ljava_time_format_DateTimeFormatterBuilder__f_parent === null)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Pattern invalid as it contains ] without previous [")
        };
        $thiz.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder()
      } else if ((((cur === 123) || (cur === 125)) || (cur === 35))) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("Pattern includes reserved character: '" + $bC(cur)) + "'"))
      } else {
        $thiz.appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(cur)
      };
      pos = ((1 + pos) | 0)
    } else {
      break
    }
  }
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__parseField__C__I__Ljava_time_temporal_TemporalField__V($thiz, cur, count, field) {
  var exc = $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $bC(cur)));
  switch (cur) {
    case 117:
    case 121: {
      if ((count === 2)) {
        $thiz.appendValueReduced__Ljava_time_temporal_TemporalField__I__I__Ljava_time_chrono_ChronoLocalDate__Ljava_time_format_DateTimeFormatterBuilder(field, 2, 2, $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$().BASE_DATE__Ljava_time_LocalDate())
      } else if ((count < 4)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder(field, count, 19, $m_Ljava_time_format_SignStyle$().NORMAL__Ljava_time_format_SignStyle())
      } else {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder(field, count, 19, $m_Ljava_time_format_SignStyle$().EXCEEDS_PAD__Ljava_time_format_SignStyle())
      };
      break
    }
    case 77:
    case 81: {
      switch (count) {
        case 1: {
          $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field);
          break
        }
        case 2: {
          $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, 2);
          break
        }
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle());
          break
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle());
          break
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().NARROW__Ljava_time_format_TextStyle());
          break
        }
        default: {
          throw exc
        }
      };
      break
    }
    case 76:
    case 113: {
      switch (count) {
        case 1: {
          $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field);
          break
        }
        case 2: {
          $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, 2);
          break
        }
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().SHORT_STANDALONE__Ljava_time_format_TextStyle());
          break
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().FULL_STANDALONE__Ljava_time_format_TextStyle());
          break
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().NARROW_STANDALONE__Ljava_time_format_TextStyle());
          break
        }
        default: {
          throw exc
        }
      };
      break
    }
    case 101: {
      switch (count) {
        case 1:
        case 2: {
          $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(101, count));
          break
        }
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle());
          break
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle());
          break
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().NARROW__Ljava_time_format_TextStyle());
          break
        }
        default: {
          throw exc
        }
      };
      break
    }
    case 99: {
      switch (count) {
        case 1: {
          $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(99, count));
          break
        }
        case 2: {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid number of pattern letters: " + $bC(cur)));
          break
        }
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().SHORT_STANDALONE__Ljava_time_format_TextStyle());
          break
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().FULL_STANDALONE__Ljava_time_format_TextStyle());
          break
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().NARROW_STANDALONE__Ljava_time_format_TextStyle());
          break
        }
        default: {
          throw exc
        }
      };
      break
    }
    case 97: {
      if ((count === 1)) {
        $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle())
      } else {
        throw exc
      };
      break
    }
    case 69:
    case 71: {
      switch (count) {
        case 1:
        case 2:
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle());
          break
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle());
          break
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $m_Ljava_time_format_TextStyle$().NARROW__Ljava_time_format_TextStyle());
          break
        }
        default: {
          throw exc
        }
      };
      break
    }
    case 83: {
      $thiz.appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), count, count, false);
      break
    }
    case 70: {
      if ((count === 1)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field)
      } else {
        throw exc
      };
      break
    }
    case 100:
    case 104:
    case 72:
    case 107:
    case 75:
    case 109:
    case 115: {
      if ((count === 1)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field)
      } else if ((count === 2)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, count)
      } else {
        throw exc
      };
      break
    }
    case 68: {
      if ((count === 1)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field)
      } else if ((count <= 3)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, count)
      } else {
        throw exc
      };
      break
    }
    default: {
      if ((count === 1)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field)
      } else {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, count)
      }
    }
  }
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I($thiz, pp) {
  var _pp = pp;
  var obj = _pp;
  if ((obj === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "pp")
  };
  if (($p_Ljava_time_format_DateTimeFormatterBuilder__padNextWidth__I($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz))) > 0)) {
    if ((_pp !== null)) {
      _pp = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(_pp, $p_Ljava_time_format_DateTimeFormatterBuilder__padNextWidth__I($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz))), $p_Ljava_time_format_DateTimeFormatterBuilder__padNextChar__C($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz))))
    };
    $p_Ljava_time_format_DateTimeFormatterBuilder__padNextWidth_$eq__I__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)), 0);
    $p_Ljava_time_format_DateTimeFormatterBuilder__padNextChar_$eq__C__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)), 0)
  };
  $n($p_Ljava_time_format_DateTimeFormatterBuilder__printerParsers__ju_List($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)))).add__O__Z(_pp);
  $p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex_$eq__I__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)), (-1));
  return (((-1) + $n($p_Ljava_time_format_DateTimeFormatterBuilder__printerParsers__ju_List($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder($thiz)))).size__I()) | 0)
}
function $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, parent, optional) {
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_parent = parent;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_optional = optional;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active = $thiz;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = (((1 | $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24);
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = (((2 | $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24);
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = (((4 | $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24);
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = (((8 | $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24);
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = (-1);
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = (((16 | $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0) << 24) >> 24);
  return $thiz
}
function $ct_Ljava_time_format_DateTimeFormatterBuilder__($thiz) {
  $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, null, false);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder() {
  this.Ljava_time_format_DateTimeFormatterBuilder__f_parent = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_optional = false;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = 0;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_bitmap$init$0 = 0
}
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatterBuilder.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$().INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser());
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder = (function(field) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, 1, 19, $m_Ljava_time_format_SignStyle$().NORMAL__Ljava_time_format_SignStyle()));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder = (function(field, width) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  if (((width < 1) || (width > 19))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The width must be from 1 to 19 inclusive but was " + width))
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, width, width, $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle()));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder = (function(field, minWidth, maxWidth, signStyle) {
  if (((minWidth === maxWidth) && (signStyle === $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle()))) {
    return this.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, maxWidth)
  };
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  if ((signStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "signStyle")
  };
  if (((minWidth < 1) || (minWidth > 19))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The minimum width must be from 1 to 19 inclusive but was " + minWidth))
  };
  if (((maxWidth < 1) || (maxWidth > 19))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The maximum width must be from 1 to 19 inclusive but was " + maxWidth))
  };
  if ((maxWidth < minWidth)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("The maximum width must exceed or equal the minimum width but " + maxWidth) + " < ") + minWidth))
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, minWidth, maxWidth, signStyle));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValueReduced__Ljava_time_temporal_TemporalField__I__I__Ljava_time_chrono_ChronoLocalDate__Ljava_time_format_DateTimeFormatterBuilder = (function(field, width, maxWidth, baseDate) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  if ((baseDate === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "baseDate")
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(), field, width, maxWidth, 0, baseDate));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder = (function(field, minWidth, maxWidth, decimalPoint) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder = (function(field, textStyle) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  if ((textStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "textStyle")
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser(field, textStyle, $m_Ljava_time_format_internal_TTBPDateTimeTextProvider$().Provider__Ljava_time_format_internal_TTBPDateTimeTextProvider()));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendInstant__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser((-2)));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder = (function(pattern, noOffsetText) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser(noOffsetText, pattern));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendLocalizedOffset__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder = (function(style) {
  if ((style === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "style")
  };
  if (((style !== $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle()) && (style !== $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle()))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Style must be either full or short")
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser(style));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendZoneId__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery(), "ZoneId()"));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendZoneText__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder = (function(textStyle) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser(textStyle));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder = (function(literal) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser(literal));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendLiteral__T__Ljava_time_format_DateTimeFormatterBuilder = (function(literal) {
  if ((literal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "literal")
  };
  var this$2 = $n(literal);
  if ((this$2.length > 0)) {
    var this$3 = $n(literal);
    if ((this$3.length === 1)) {
      var this$4 = $n(literal);
      $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser($charAt(this$4, 0)))
    } else {
      $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser(literal))
    }
  };
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder = (function(formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter")
  };
  var this$2 = $n(formatter);
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, $n(this$2.Ljava_time_format_DateTimeFormatter__f_printerParser).withOptional__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(false));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendPattern__T__Ljava_time_format_DateTimeFormatterBuilder = (function(pattern) {
  if ((pattern === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "pattern")
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__parsePattern__T__V(this, pattern);
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.padNext__I__C__Ljava_time_format_DateTimeFormatterBuilder = (function(padWidth, padChar) {
  if ((padWidth < 1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The pad width must be at least one but was " + padWidth))
  };
  $p_Ljava_time_format_DateTimeFormatterBuilder__padNextWidth_$eq__I__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)), padWidth);
  $p_Ljava_time_format_DateTimeFormatterBuilder__padNextChar_$eq__C__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)), padChar);
  $p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex_$eq__I__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)), (-1));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.optionalStart__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__valueParserIndex_$eq__I__V($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)), (-1));
  $p_Ljava_time_format_DateTimeFormatterBuilder__active_$eq__Ljava_time_format_DateTimeFormatterBuilder__V(this, $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__(new $c_Ljava_time_format_DateTimeFormatterBuilder(), $p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this), true));
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  if (($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)).Ljava_time_format_DateTimeFormatterBuilder__f_parent === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot call optionalEnd() as there was no previous call to optionalStart()")
  };
  if (($n($p_Ljava_time_format_DateTimeFormatterBuilder__printerParsers__ju_List($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)))).size__I() > 0)) {
    var cpp = $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), $p_Ljava_time_format_DateTimeFormatterBuilder__printerParsers__ju_List($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this))), $n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)).Ljava_time_format_DateTimeFormatterBuilder__f_optional);
    $p_Ljava_time_format_DateTimeFormatterBuilder__active_$eq__Ljava_time_format_DateTimeFormatterBuilder__V(this, $n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)).Ljava_time_format_DateTimeFormatterBuilder__f_parent);
    $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__I(this, cpp)
  } else {
    $p_Ljava_time_format_DateTimeFormatterBuilder__active_$eq__Ljava_time_format_DateTimeFormatterBuilder__V(this, $n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)).Ljava_time_format_DateTimeFormatterBuilder__f_parent)
  };
  return this
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter = (function(locale) {
  if ((locale === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "locale")
  };
  while (($n($p_Ljava_time_format_DateTimeFormatterBuilder__active__Ljava_time_format_DateTimeFormatterBuilder(this)).Ljava_time_format_DateTimeFormatterBuilder__f_parent !== null)) {
    this.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder()
  };
  var pp = $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), $p_Ljava_time_format_DateTimeFormatterBuilder__printerParsers__ju_List(this), false);
  return new $c_Ljava_time_format_DateTimeFormatter(pp, locale, $m_Ljava_time_format_DecimalStyle$().STANDARD__Ljava_time_format_DecimalStyle(), $m_Ljava_time_format_ResolverStyle$().SMART__Ljava_time_format_ResolverStyle(), null, null, null)
});
var $d_Ljava_time_format_DateTimeFormatterBuilder = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatterBuilder: 0
}, false, "java.time.format.DateTimeFormatterBuilder", {
  Ljava_time_format_DateTimeFormatterBuilder: 1,
  O: 1
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.$classData = $d_Ljava_time_format_DateTimeFormatterBuilder;
function $p_Ljava_time_format_DateTimeFormatterBuilder$__FIELD_MAP$lzycompute__ju_Map($thiz) {
  if (((((2 & $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_bitmap$0) << 24) >> 24) === 0)) {
    var map = $ct_ju_HashMap__(new $c_ju_HashMap());
    var value = $m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(71), value, 71, false);
    var value$1 = $m_Ljava_time_temporal_ChronoField$().YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(121), value$1, 121, false);
    var value$2 = $m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(117), value$2, 117, false);
    var value$3 = $m_Ljava_time_temporal_IsoFields$().QUARTER_OF_YEAR__Ljava_time_temporal_TemporalField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(81), value$3, 81, false);
    var value$4 = $m_Ljava_time_temporal_IsoFields$().QUARTER_OF_YEAR__Ljava_time_temporal_TemporalField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(113), value$4, 113, false);
    var value$5 = $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(77), value$5, 77, false);
    var value$6 = $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(76), value$6, 76, false);
    var value$7 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(68), value$7, 68, false);
    var value$8 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(100), value$8, 100, false);
    var value$9 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(70), value$9, 70, false);
    var value$10 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(69), value$10, 69, false);
    var value$11 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(99), value$11, 99, false);
    var value$12 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(101), value$12, 101, false);
    var value$13 = $m_Ljava_time_temporal_ChronoField$().AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(97), value$13, 97, false);
    var value$14 = $m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(72), value$14, 72, false);
    var value$15 = $m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(107), value$15, 107, false);
    var value$16 = $m_Ljava_time_temporal_ChronoField$().HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(75), value$16, 75, false);
    var value$17 = $m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(104), value$17, 104, false);
    var value$18 = $m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(109), value$18, 109, false);
    var value$19 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(115), value$19, 115, false);
    var value$20 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(83), value$20, 83, false);
    var value$21 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(65), value$21, 65, false);
    var value$22 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(110), value$22, 110, false);
    var value$23 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(78), value$23, 78, false);
    $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_java$time$format$DateTimeFormatterBuilder$$FIELD_MAP = map;
    $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_bitmap$0 = (((2 | $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_java$time$format$DateTimeFormatterBuilder$$FIELD_MAP
}
function $p_Ljava_time_format_DateTimeFormatterBuilder$__LENGTH_SORT$lzycompute__ju_Comparator($thiz) {
  if (((((4 & $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT = new $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2();
    $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_bitmap$0 = (((4 | $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT
}
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder$() {
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_java$time$format$DateTimeFormatterBuilder$$FIELD_MAP = null;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT = null;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_bitmap$0 = 0
}
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder$;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder$() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatterBuilder$.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder$.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.java$time$format$DateTimeFormatterBuilder$$FIELD_MAP__ju_Map = (function() {
  return (((((2 & this.Ljava_time_format_DateTimeFormatterBuilder$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_DateTimeFormatterBuilder$__FIELD_MAP$lzycompute__ju_Map(this) : this.Ljava_time_format_DateTimeFormatterBuilder$__f_java$time$format$DateTimeFormatterBuilder$$FIELD_MAP)
});
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.LENGTH_SORT__ju_Comparator = (function() {
  return (((((4 & this.Ljava_time_format_DateTimeFormatterBuilder$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_DateTimeFormatterBuilder$__LENGTH_SORT$lzycompute__ju_Comparator(this) : this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT)
});
var $d_Ljava_time_format_DateTimeFormatterBuilder$ = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatterBuilder$: 0
}, false, "java.time.format.DateTimeFormatterBuilder$", {
  Ljava_time_format_DateTimeFormatterBuilder$: 1,
  O: 1
});
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.$classData = $d_Ljava_time_format_DateTimeFormatterBuilder$;
var $n_Ljava_time_format_DateTimeFormatterBuilder$;
function $m_Ljava_time_format_DateTimeFormatterBuilder$() {
  if ((!$n_Ljava_time_format_DateTimeFormatterBuilder$)) {
    $n_Ljava_time_format_DateTimeFormatterBuilder$ = new $c_Ljava_time_format_DateTimeFormatterBuilder$()
  };
  return $n_Ljava_time_format_DateTimeFormatterBuilder$
}
/** @constructor */
function $c_Ljava_time_format_DecimalStyle(zeroDigit, positiveSign, negativeSign, decimalSeparator) {
  this.Ljava_time_format_DecimalStyle__f_zeroDigit = 0;
  this.Ljava_time_format_DecimalStyle__f_positiveSign = 0;
  this.Ljava_time_format_DecimalStyle__f_negativeSign = 0;
  this.Ljava_time_format_DecimalStyle__f_decimalSeparator = 0;
  this.Ljava_time_format_DecimalStyle__f_zeroDigit = zeroDigit;
  this.Ljava_time_format_DecimalStyle__f_positiveSign = positiveSign;
  this.Ljava_time_format_DecimalStyle__f_negativeSign = negativeSign;
  this.Ljava_time_format_DecimalStyle__f_decimalSeparator = decimalSeparator
}
$c_Ljava_time_format_DecimalStyle.prototype = new $h_O();
$c_Ljava_time_format_DecimalStyle.prototype.constructor = $c_Ljava_time_format_DecimalStyle;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle() {
  /*<skip>*/
}
$h_Ljava_time_format_DecimalStyle.prototype = $c_Ljava_time_format_DecimalStyle.prototype;
$c_Ljava_time_format_DecimalStyle.prototype.convertToDigit__C__I = (function(ch) {
  var value = ((ch - this.Ljava_time_format_DecimalStyle__f_zeroDigit) | 0);
  return (((value >= 0) && (value <= 9)) ? value : (-1))
});
$c_Ljava_time_format_DecimalStyle.prototype.convertNumberToI18N__T__T = (function(numericText) {
  if ((this.Ljava_time_format_DecimalStyle__f_zeroDigit === 48)) {
    return numericText
  };
  var diff = (((-48) + this.Ljava_time_format_DecimalStyle__f_zeroDigit) | 0);
  var array = $f_T__toCharArray__AC($n(numericText));
  var i = 0;
  while ((i < $n(array).u.length)) {
    $n(array).set(i, (65535 & (($n(array).get(i) + diff) | 0)));
    i = ((1 + i) | 0)
  };
  var this$1 = $m_jl_String$();
  return this$1.new__AC__I__I__T(array, 0, $n(array).u.length)
});
$c_Ljava_time_format_DecimalStyle.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_format_DecimalStyle)) {
    var x2 = $as_Ljava_time_format_DecimalStyle(obj);
    return ((this === x2) || ((((this.Ljava_time_format_DecimalStyle__f_zeroDigit === $n(x2).Ljava_time_format_DecimalStyle__f_zeroDigit) && (this.Ljava_time_format_DecimalStyle__f_positiveSign === $n(x2).Ljava_time_format_DecimalStyle__f_positiveSign)) && (this.Ljava_time_format_DecimalStyle__f_negativeSign === $n(x2).Ljava_time_format_DecimalStyle__f_negativeSign)) && (this.Ljava_time_format_DecimalStyle__f_decimalSeparator === $n(x2).Ljava_time_format_DecimalStyle__f_decimalSeparator)))
  } else {
    return false
  }
});
$c_Ljava_time_format_DecimalStyle.prototype.hashCode__I = (function() {
  return ((((((this.Ljava_time_format_DecimalStyle__f_zeroDigit + this.Ljava_time_format_DecimalStyle__f_positiveSign) | 0) + this.Ljava_time_format_DecimalStyle__f_negativeSign) | 0) + this.Ljava_time_format_DecimalStyle__f_decimalSeparator) | 0)
});
$c_Ljava_time_format_DecimalStyle.prototype.toString__T = (function() {
  return ((((("DecimalStyle[" + $bC(this.Ljava_time_format_DecimalStyle__f_zeroDigit)) + $bC(this.Ljava_time_format_DecimalStyle__f_positiveSign)) + $bC(this.Ljava_time_format_DecimalStyle__f_negativeSign)) + $bC(this.Ljava_time_format_DecimalStyle__f_decimalSeparator)) + "]")
});
function $as_Ljava_time_format_DecimalStyle(obj) {
  return (((obj instanceof $c_Ljava_time_format_DecimalStyle) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.DecimalStyle"))
}
function $isArrayOf_Ljava_time_format_DecimalStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_DecimalStyle)))
}
function $asArrayOf_Ljava_time_format_DecimalStyle(obj, depth) {
  return (($isArrayOf_Ljava_time_format_DecimalStyle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.DecimalStyle;", depth))
}
var $d_Ljava_time_format_DecimalStyle = new $TypeData().initClass({
  Ljava_time_format_DecimalStyle: 0
}, false, "java.time.format.DecimalStyle", {
  Ljava_time_format_DecimalStyle: 1,
  O: 1
});
$c_Ljava_time_format_DecimalStyle.prototype.$classData = $d_Ljava_time_format_DecimalStyle;
function $p_Ljava_time_format_DecimalStyle$__STANDARD$lzycompute__Ljava_time_format_DecimalStyle($thiz) {
  if (((((1 & $thiz.Ljava_time_format_DecimalStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_DecimalStyle$__f_STANDARD = new $c_Ljava_time_format_DecimalStyle(48, 43, 45, 46);
    $thiz.Ljava_time_format_DecimalStyle$__f_bitmap$0 = (((1 | $thiz.Ljava_time_format_DecimalStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_DecimalStyle$__f_STANDARD
}
/** @constructor */
function $c_Ljava_time_format_DecimalStyle$() {
  this.Ljava_time_format_DecimalStyle$__f_STANDARD = null;
  this.Ljava_time_format_DecimalStyle$__f_bitmap$0 = 0
}
$c_Ljava_time_format_DecimalStyle$.prototype = new $h_O();
$c_Ljava_time_format_DecimalStyle$.prototype.constructor = $c_Ljava_time_format_DecimalStyle$;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle$() {
  /*<skip>*/
}
$h_Ljava_time_format_DecimalStyle$.prototype = $c_Ljava_time_format_DecimalStyle$.prototype;
$c_Ljava_time_format_DecimalStyle$.prototype.STANDARD__Ljava_time_format_DecimalStyle = (function() {
  return (((((1 & this.Ljava_time_format_DecimalStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_DecimalStyle$__STANDARD$lzycompute__Ljava_time_format_DecimalStyle(this) : this.Ljava_time_format_DecimalStyle$__f_STANDARD)
});
var $d_Ljava_time_format_DecimalStyle$ = new $TypeData().initClass({
  Ljava_time_format_DecimalStyle$: 0
}, false, "java.time.format.DecimalStyle$", {
  Ljava_time_format_DecimalStyle$: 1,
  O: 1
});
$c_Ljava_time_format_DecimalStyle$.prototype.$classData = $d_Ljava_time_format_DecimalStyle$;
var $n_Ljava_time_format_DecimalStyle$;
function $m_Ljava_time_format_DecimalStyle$() {
  if ((!$n_Ljava_time_format_DecimalStyle$)) {
    $n_Ljava_time_format_DecimalStyle$ = new $c_Ljava_time_format_DecimalStyle$()
  };
  return $n_Ljava_time_format_DecimalStyle$
}
function $is_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser)))
}
function $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(obj) {
  return (($is_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.TTBPDateTimeFormatterBuilder$DateTimePrinterParser"))
}
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser)))
}
function $asArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.TTBPDateTimeFormatterBuilder$DateTimePrinterParser;", depth))
}
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 0
}, true, "java.time.format.internal.TTBPDateTimeFormatterBuilder$DateTimePrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1,
  O: 1
});
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_0000_TO_1970 = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_bitmap$init$0 = 0;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = this;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS = new $c_RTLong(2036907392, 73);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_bitmap$init$0 = (((1 | this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_0000_TO_1970 = new $c_RTLong(2037677056, 14);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_bitmap$init$0 = (((2 | this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype.java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS__jl_Long = (function() {
  if (((((1 & this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 937")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype.java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_0000_TO_1970__jl_Long = (function() {
  if (((((2 & this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 938")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_0000_TO_1970
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_bitmap$init$0 = false;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = this;
  var array = [0, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000];
  var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  $m_s_reflect_ManifestFactory$IntManifest$();
  var len = xs.length__I();
  var array$1 = new $ac_I(len);
  var this$7 = new $c_sc_IndexedSeqView$Id(xs);
  var iterator = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$7);
  var i = 0;
  while ((iterator.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)) {
    array$1.set(i, $uI(iterator.next__O()));
    i = ((1 + i) | 0)
  };
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS = array$1;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_bitmap$init$0 = true
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype.EXCEED_POINTS__AI = (function() {
  if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 326")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_bitmap$init$0 = 0;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ = this;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS = new ($d_T.getArrayOf().constr)(["+HH", "+HHmm", "+HH:mm", "+HHMM", "+HH:MM", "+HHMMss", "+HH:MM:ss", "+HHMMSS", "+HH:MM:SS"]);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_bitmap$init$0 = (((1 | this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser("Z", "+HH:MM:ss");
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_bitmap$init$0 = (((2 | this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype.PATTERNS__AT = (function() {
  if (((((1 & this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 1076")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype.INSTANCE_ID__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser = (function() {
  if (((((2 & this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 1085")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_BASE_DATE = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_bitmap$init$0 = false;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ = this;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_BASE_DATE = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(2000, 1, 1);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_bitmap$init$0 = true
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype.BASE_DATE__Ljava_time_LocalDate = (function() {
  if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 582")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_BASE_DATE
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ReducedPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$cachedSubstringTree = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_bitmap$init$0 = false;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$cachedSubstringTree = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_bitmap$init$0 = true
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$cachedSubstringTree__ju_Map$Entry = (function() {
  if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 1455")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$cachedSubstringTree
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$cachedSubstringTree_$eq__ju_Map$Entry__V = (function(x$1) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$cachedSubstringTree = x$1;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_bitmap$init$0 = true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$prepareParser__ju_Set__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree = (function(availableIDs) {
  var ids = $ct_ju_ArrayList__ju_Collection__(new $c_ju_ArrayList(), availableIDs);
  var c = $m_Ljava_time_format_DateTimeFormatterBuilder$().LENGTH_SORT__ju_Comparator();
  $f_ju_List__sort__ju_Comparator__V(ids, c);
  var this$2 = $n($as_T(ids.get__I__O(0)));
  var tree = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(this$2.length);
  var idsIterator = ids.listIterator__I__ju_ListIterator(0);
  while ($n(idsIterator).hasNext__Z()) {
    var id = $as_T($n(idsIterator).next__O());
    tree.add__T__V(id)
  };
  return tree
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__substringMap__ju_Map($thiz) {
  if (((((1 & $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 1485")
  };
  return $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__substringMapCI__ju_Map($thiz) {
  if (((((2 & $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 1489")
  };
  return $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(length) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_bitmap$init$0 = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length = length;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_bitmap$init$0 = (((1 | this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_bitmap$init$0 = (((2 | this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.get__jl_CharSequence__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree = (function(substring2, caseSensitive) {
  if (caseSensitive) {
    return $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree($n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__substringMap__ju_Map(this)).get__O__O(substring2))
  } else {
    var $$x1 = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__substringMapCI__ju_Map(this);
    var string = $dp_toString__T($n(substring2));
    var this$2 = $n(string);
    return $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree($n($$x1).get__O__O($as_T(this$2.toLowerCase())))
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.add__T__V = (function(newSubstring) {
  var _$this = this;
  while (true) {
    var this$1 = $n(newSubstring);
    var idLen = this$1.length;
    if ((idLen === $n(_$this).Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length)) {
      $n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__substringMap__ju_Map($n(_$this))).put__O__O__O(newSubstring, null);
      var $$x1 = $n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__substringMapCI__ju_Map($n(_$this)));
      var this$3 = $n(newSubstring);
      $n($$x1).put__O__O__O($as_T(this$3.toLowerCase()), null)
    } else if ((idLen > $n(_$this).Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length)) {
      var this$4 = $n(newSubstring);
      var endIndex = $n(_$this).Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length;
      if ((endIndex > this$4.length)) {
        $charAt(this$4, endIndex)
      };
      if ((endIndex < 0)) {
        $charAt(this$4, (-1))
      };
      var substring = $as_T(this$4.substring(0, endIndex));
      var parserTree = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree($n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__substringMap__ju_Map($n(_$this))).get__O__O(substring));
      if ((parserTree === null)) {
        parserTree = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(idLen);
        $n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__substringMap__ju_Map($n(_$this))).put__O__O__O(substring, parserTree);
        var $$x2 = $n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__substringMapCI__ju_Map($n(_$this)));
        var this$6 = $n(substring);
        $n($$x2).put__O__O__O($as_T(this$6.toLowerCase()), parserTree)
      };
      _$this = parserTree;
      continue
    };
    break
  }
});
function $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(obj) {
  return (((obj instanceof $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree"))
}
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree)))
}
function $asArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree;", depth))
}
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__LENGTH_COMPARATOR$lzycompute__s_math_Ordering($thiz) {
  if ((!$thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_bitmap$0)) {
    $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$LENGTH_COMPARATOR = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1();
    $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_bitmap$0 = true
  };
  return $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$LENGTH_COMPARATOR
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$LENGTH_COMPARATOR = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_bitmap$0 = false
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype.java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$LENGTH_COMPARATOR__s_math_Ordering = (function() {
  return ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_bitmap$0) ? $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__LENGTH_COMPARATOR$lzycompute__s_math_Ordering(this) : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$LENGTH_COMPARATOR)
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$
}
function $p_Ljava_time_format_internal_TTBPDateTimeParseContext__parsed__ju_ArrayList($thiz) {
  if ((!$thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeParseContext.scala: 88")
  };
  return $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed
}
function $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($thiz) {
  return $as_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__parsed__ju_ArrayList($thiz)).get__I__O((((-1) + $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__parsed__ju_ArrayList($thiz)).size__I()) | 0)))
}
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, locale, symbols, overrideChronology, overrideZone, caseSensitive, strict) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale = locale;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols = symbols;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology = overrideChronology;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_java$time$format$internal$TTBPDateTimeParseContext$$overrideZone = overrideZone;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = caseSensitive;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = strict;
  var list = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  list.add__O__Z(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($thiz));
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed = list;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_bitmap$init$0 = true;
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__($thiz, formatter) {
  var this$1 = $n(formatter);
  var $$x3 = this$1.Ljava_time_format_DateTimeFormatter__f_locale;
  var this$2 = $n(formatter);
  var $$x2 = this$2.Ljava_time_format_DateTimeFormatter__f_decimalStyle;
  var this$3 = $n(formatter);
  var $$x1 = this$3.Ljava_time_format_DateTimeFormatter__f_chrono;
  var this$4 = $n(formatter);
  $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, $$x3, $$x2, $$x1, this$4.Ljava_time_format_DateTimeFormatter__f_zone, true, true);
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__($thiz, other) {
  $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, $n(other).Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale, $n(other).Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols, $n(other).Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology, $n(other).Ljava_time_format_internal_TTBPDateTimeParseContext__f_java$time$format$internal$TTBPDateTimeParseContext$$overrideZone, $n(other).Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive, $n(other).Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext() {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_java$time$format$internal$TTBPDateTimeParseContext$$overrideZone = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_bitmap$init$0 = false
}
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype = $c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.getEffectiveChronology__Ljava_time_chrono_Chronology = (function() {
  var chrono = $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this)).chrono__Ljava_time_chrono_Chronology();
  if ((chrono === null)) {
    chrono = this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology;
    if ((chrono === null)) {
      chrono = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
    }
  };
  return chrono
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z = (function(cs1, offset1, cs2, offset2, length) {
  if (((((offset1 + length) | 0) > $dp_length__I($n(cs1))) || (((offset2 + length) | 0) > $dp_length__I($n(cs2))))) {
    return false
  };
  if (this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive) {
    var i = 0;
    while ((i < length)) {
      var ch1 = $dp_charAt__I__C($n(cs1), ((offset1 + i) | 0));
      var ch2 = $dp_charAt__I__C($n(cs2), ((offset2 + i) | 0));
      if ((ch1 !== ch2)) {
        return false
      };
      i = ((1 + i) | 0)
    }
  } else {
    var i$2 = 0;
    while ((i$2 < length)) {
      var ch1$2 = $dp_charAt__I__C($n(cs1), ((offset1 + i$2) | 0));
      var ch2$2 = $dp_charAt__I__C($n(cs2), ((offset2 + i$2) | 0));
      if ((((ch1$2 !== ch2$2) && ($m_jl_Character$().toUpperCase__C__C(ch1$2) !== $m_jl_Character$().toUpperCase__C__C(ch2$2))) && ($m_jl_Character$().toLowerCase__C__C(ch1$2) !== $m_jl_Character$().toLowerCase__C__C(ch2$2)))) {
        return false
      };
      i$2 = ((1 + i$2) | 0)
    }
  };
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.charEquals__C__C__Z = (function(ch1, ch2) {
  return (this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive ? (ch1 === ch2) : $m_Ljava_time_format_internal_TTBPDateTimeParseContext$().charEqualsIgnoreCase__C__C__Z(ch1, ch2))
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.startOptional__V = (function() {
  $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__parsed__ju_ArrayList(this)).add__O__Z($n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this)).copy__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed())
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.endOptional__Z__V = (function(successful) {
  if (successful) {
    $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__parsed__ju_ArrayList(this)).remove__I__O((((-2) + $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__parsed__ju_ArrayList(this)).size__I()) | 0))
  } else {
    $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__parsed__ju_ArrayList(this)).remove__I__O((((-1) + $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__parsed__ju_ArrayList(this)).size__I()) | 0))
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.getParsed__Ljava_time_temporal_TemporalField__jl_Long = (function(field) {
  return $as_jl_Long($n($n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this)).fieldValues__ju_Map()).get__O__O(field))
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I = (function(field, value, errorPos, successPos) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  var old = $as_jl_Long($n($n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this)).fieldValues__ju_Map()).put__O__O__O(field, value));
  if ((old !== null)) {
    var this$3 = $n(old);
    var this$4 = $uJ(this$3);
    var $$x1 = (!((this$4.RTLong__f_lo === value.RTLong__f_lo) && (this$4.RTLong__f_hi === value.RTLong__f_hi)))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return (~errorPos)
  } else {
    return successPos
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.addChronologyChangedParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__J__I__I__V = (function(reducedPrinterParser, value, errorPos, successPos) {
  var _currentParsed = $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this);
  if (($n(_currentParsed).callbacks__ju_List() === null)) {
    $n(_currentParsed).callbacks_$eq__ju_List__V($ct_ju_ArrayList__I__(new $c_ju_ArrayList(), 2))
  };
  $n($n(_currentParsed).callbacks__ju_List()).add__O__Z(new $ac_O([reducedPrinterParser, value, errorPos, successPos]))
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.setParsed__Ljava_time_ZoneId__V = (function(zone) {
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this)).zone_$eq__Ljava_time_ZoneId__V(zone)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.toString__T = (function() {
  return $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this)).toString__T()
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeParseContext: 0
}, false, "java.time.format.internal.TTBPDateTimeParseContext", {
  Ljava_time_format_internal_TTBPDateTimeParseContext: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeParseContext;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
  /*<skip>*/
}
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype.charEqualsIgnoreCase__C__C__Z = (function(c1, c2) {
  return (((c1 === c2) || ($m_jl_Character$().toUpperCase__C__C(c1) === $m_jl_Character$().toUpperCase__C__C(c2))) || ($m_jl_Character$().toLowerCase__C__C(c1) === $m_jl_Character$().toLowerCase__C__C(c2)))
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeParseContext$: 0
}, false, "java.time.format.internal.TTBPDateTimeParseContext$", {
  Ljava_time_format_internal_TTBPDateTimeParseContext$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeParseContext$;
var $n_Ljava_time_format_internal_TTBPDateTimeParseContext$;
function $m_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeParseContext$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeParseContext$ = new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeParseContext$
}
function $p_Ljava_time_format_internal_TTBPDateTimePrintContext__optional__I($thiz) {
  if ((!$thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimePrintContext.scala: 153")
  };
  return $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional
}
function $p_Ljava_time_format_internal_TTBPDateTimePrintContext__optional_$eq__I__V($thiz, x$1) {
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = x$1;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_bitmap$init$0 = true
}
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, temporal, locale, symbols) {
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal = temporal;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale = locale;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols = symbols;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = 0;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_bitmap$init$0 = true;
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__($thiz, temporal, formatter) {
  var $$x2 = $m_Ljava_time_format_internal_TTBPDateTimePrintContext$().adjust__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__Ljava_time_temporal_TemporalAccessor(temporal, formatter);
  var this$1 = $n(formatter);
  var $$x1 = this$1.Ljava_time_format_DateTimeFormatter__f_locale;
  var this$2 = $n(formatter);
  $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, $$x2, $$x1, this$2.Ljava_time_format_DateTimeFormatter__f_decimalStyle);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = 0;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_bitmap$init$0 = false
}
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.startOptional__V = (function() {
  $p_Ljava_time_format_internal_TTBPDateTimePrintContext__optional_$eq__I__V(this, ((1 + $p_Ljava_time_format_internal_TTBPDateTimePrintContext__optional__I(this)) | 0))
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.endOptional__V = (function() {
  $p_Ljava_time_format_internal_TTBPDateTimePrintContext__optional_$eq__I__V(this, (((-1) + $p_Ljava_time_format_internal_TTBPDateTimePrintContext__optional__I(this)) | 0))
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.getValue__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var result = $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal).query__Ljava_time_temporal_TemporalQuery__O(query);
  if (((result === null) && ($p_Ljava_time_format_internal_TTBPDateTimePrintContext__optional__I(this) === 0))) {
    var this$1 = $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal);
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unable to extract value: " + $objectGetClass(this$1)))
  } else {
    return result
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.getValue__Ljava_time_temporal_TemporalField__jl_Long = (function(field) {
  try {
    var t = $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal).getLong__Ljava_time_temporal_TemporalField__J(field);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_RTLong(lo, hi)
  } catch (e) {
    if ((e instanceof $c_Ljava_time_DateTimeException)) {
      var ex = $as_Ljava_time_DateTimeException(e);
      if (($p_Ljava_time_format_internal_TTBPDateTimePrintContext__optional__I(this) > 0)) {
        return null
      } else {
        throw ((ex === null) ? $n(null) : ex)
      }
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.toString__T = (function() {
  return $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal).toString__T()
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimePrintContext: 0
}, false, "java.time.format.internal.TTBPDateTimePrintContext", {
  Ljava_time_format_internal_TTBPDateTimePrintContext: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimePrintContext;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
  /*<skip>*/
}
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.adjust__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__Ljava_time_temporal_TemporalAccessor = (function(temporal, formatter) {
  var this$1 = $n(formatter);
  var elem = this$1.Ljava_time_format_DateTimeFormatter__f_chrono;
  var overrideChrono = new $c_sr_ObjectRef(elem);
  var this$3 = $n(formatter);
  var overrideZone = this$3.Ljava_time_format_DateTimeFormatter__f_zone;
  if ((($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) === null) && (overrideZone === null))) {
    return temporal
  } else {
    var temporalChrono = $as_Ljava_time_chrono_Chronology($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()));
    var temporalZone = $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()));
    var b = $as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem);
    if ((temporalChrono === null)) {
      var $$x1 = (b === null)
    } else {
      var this$5 = $n(temporalChrono);
      var $$x1 = $f_Ljava_time_chrono_Chronology__equals__O__Z(this$5, b)
    };
    if ($$x1) {
      overrideChrono.sr_ObjectRef__f_elem = null
    };
    var b$1 = overrideZone;
    if (((temporalZone === null) ? (b$1 === null) : $n(temporalZone).equals__O__Z(b$1))) {
      overrideZone = null
    };
    if ((($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) === null) && (overrideZone === null))) {
      return temporal
    };
    var effectiveChrono = (($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) !== null) ? $as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) : temporalChrono);
    var effectiveZone = ((overrideZone !== null) ? overrideZone : temporalZone);
    if ((overrideZone !== null)) {
      if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
        var chrono = ((effectiveChrono !== null) ? effectiveChrono : $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
        $n(chrono);
        var instant = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(temporal);
        var zone = overrideZone;
        return $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(instant, zone)
      };
      var normalizedOffset = $n(overrideZone).normalized__Ljava_time_ZoneId();
      var temporalOffset = $as_Ljava_time_ZoneOffset($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()));
      if ((((normalizedOffset instanceof $c_Ljava_time_ZoneOffset) && (temporalOffset !== null)) && (!((normalizedOffset === null) ? (temporalOffset === null) : $n(normalizedOffset).equals__O__Z(temporalOffset))))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid override zone for temporal: " + overrideZone) + " ") + temporal))
      }
    };
    if (($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) !== null)) {
      if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
        $n(effectiveChrono);
        var effectiveDate = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)
      } else {
        if ((!(($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) === $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()) && (temporalChrono === null)))) {
          $m_sc_ArrayOps$();
          var xs = $m_Ljava_time_temporal_ChronoField$().values__ALjava_time_temporal_ChronoField();
          var f$1 = ((f$2) => {
            var f = $as_Ljava_time_temporal_ChronoField(f$2);
            if (($n(f).isDateBased__Z() && $n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z(f))) {
              throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid override chronology for temporal: " + $as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem)) + " ") + temporal))
            }
          });
          var len = $n(xs).u.length;
          var i = 0;
          if ((xs !== null)) {
            while ((i < len)) {
              var arg1 = $n(xs).get(i);
              f$1(arg1);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_I)) {
            var x3 = $asArrayOf_I(xs, 1);
            while ((i < len)) {
              var arg1$1 = $n(x3).get(i);
              f$1(arg1$1);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_D)) {
            var x4 = $asArrayOf_D(xs, 1);
            while ((i < len)) {
              var arg1$2 = $n(x4).get(i);
              f$1(arg1$2);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_J)) {
            var x5 = $asArrayOf_J(xs, 1);
            while ((i < len)) {
              var t = $n(x5).get(i);
              var lo = t.RTLong__f_lo;
              var hi = t.RTLong__f_hi;
              f$1(new $c_RTLong(lo, hi));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_F)) {
            var x6 = $asArrayOf_F(xs, 1);
            while ((i < len)) {
              var arg1$3 = $n(x6).get(i);
              f$1(arg1$3);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_C)) {
            var x7 = $asArrayOf_C(xs, 1);
            while ((i < len)) {
              var arg1$4 = $n(x7).get(i);
              f$1($bC(arg1$4));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_B)) {
            var x8 = $asArrayOf_B(xs, 1);
            while ((i < len)) {
              var arg1$5 = $n(x8).get(i);
              f$1(arg1$5);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_S)) {
            var x9 = $asArrayOf_S(xs, 1);
            while ((i < len)) {
              var arg1$6 = $n(x9).get(i);
              f$1(arg1$6);
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_Z)) {
            var x10 = $asArrayOf_Z(xs, 1);
            while ((i < len)) {
              var arg1$7 = $n(x10).get(i);
              f$1(arg1$7);
              i = ((1 + i) | 0)
            }
          } else {
            throw new $c_s_MatchError(xs)
          }
        };
        var effectiveDate = null
      }
    } else {
      var effectiveDate = null
    };
    return new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1(effectiveDate, temporal, effectiveChrono, effectiveZone)
  }
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimePrintContext$: 0
}, false, "java.time.format.internal.TTBPDateTimePrintContext$", {
  Ljava_time_format_internal_TTBPDateTimePrintContext$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimePrintContext$;
var $n_Ljava_time_format_internal_TTBPDateTimePrintContext$;
function $m_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimePrintContext$)) {
    $n_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimePrintContext$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeTextProvider() {
  /*<skip>*/
}
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeTextProvider;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeTextProvider() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeTextProvider.prototype = $c_Ljava_time_format_internal_TTBPDateTimeTextProvider.prototype;
function $p_Ljava_time_format_internal_TTBPDateTimeTextProvider$__Provider$lzycompute__Ljava_time_format_internal_TTBPDateTimeTextProvider($thiz) {
  if ((!$thiz.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_bitmap$0)) {
    $thiz.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Provider = new $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider();
    $thiz.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_bitmap$0 = true
  };
  return $thiz.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Provider
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$() {
  this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Provider = null;
  this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_bitmap$0 = false
}
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeTextProvider$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype.Provider__Ljava_time_format_internal_TTBPDateTimeTextProvider = (function() {
  return ((!this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_bitmap$0) ? $p_Ljava_time_format_internal_TTBPDateTimeTextProvider$__Provider$lzycompute__Ljava_time_format_internal_TTBPDateTimeTextProvider(this) : this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Provider)
});
var $d_Ljava_time_format_internal_TTBPDateTimeTextProvider$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeTextProvider$: 0
}, false, "java.time.format.internal.TTBPDateTimeTextProvider$", {
  Ljava_time_format_internal_TTBPDateTimeTextProvider$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeTextProvider$;
var $n_Ljava_time_format_internal_TTBPDateTimeTextProvider$;
function $m_Ljava_time_format_internal_TTBPDateTimeTextProvider$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeTextProvider$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeTextProvider$ = new $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeTextProvider$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$() {
  /*<skip>*/
}
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype.constructor = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype;
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype.java$time$format$internal$TTBPSimpleDateTimeTextProvider$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore = (function(valueTextMap) {
  var $$x2 = $n(valueTextMap);
  var self = $m_Ljava_time_format_TextStyle$().FULL_STANDALONE__Ljava_time_format_TextStyle();
  var this$3 = $n($n(valueTextMap).get__O__s_Option($m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle()));
  var this$2 = $m_s_$less$colon$less$();
  var ev = this$2.s_$less$colon$less$__f_singleton;
  var y = (this$3.isEmpty__Z() ? ($n(ev), null) : this$3.get__O());
  var $$x1 = $n($$x2).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self, y));
  var self$1 = $m_Ljava_time_format_TextStyle$().SHORT_STANDALONE__Ljava_time_format_TextStyle();
  var this$8 = $n($n(valueTextMap).get__O__s_Option($m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle()));
  var this$7 = $m_s_$less$colon$less$();
  var ev$1 = this$7.s_$less$colon$less$__f_singleton;
  var y$1 = (this$8.isEmpty__Z() ? ($n(ev$1), null) : this$8.get__O());
  var tmp1 = $as_sci_Map($n($$x1).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self$1, y$1)));
  if (($n(valueTextMap).contains__O__Z($m_Ljava_time_format_TextStyle$().NARROW__Ljava_time_format_TextStyle()) && (!$n(valueTextMap).contains__O__Z($m_Ljava_time_format_TextStyle$().NARROW_STANDALONE__Ljava_time_format_TextStyle())))) {
    var self$2 = $m_Ljava_time_format_TextStyle$().NARROW_STANDALONE__Ljava_time_format_TextStyle();
    var this$13 = $n($n(valueTextMap).get__O__s_Option($m_Ljava_time_format_TextStyle$().NARROW__Ljava_time_format_TextStyle()));
    var this$12 = $m_s_$less$colon$less$();
    var ev$2 = this$12.s_$less$colon$less$__f_singleton;
    var y$2 = (this$13.isEmpty__Z() ? ($n(ev$2), null) : this$13.get__O());
    var tmp2 = $as_sci_Map($n(tmp1).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self$2, y$2)))
  } else {
    var tmp2 = tmp1
  };
  return new $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(tmp2)
});
var $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$: 0
}, false, "java.time.format.internal.TTBPSimpleDateTimeTextProvider$", {
  Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype.$classData = $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$;
var $n_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$;
function $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$() {
  if ((!$n_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$)) {
    $n_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ = new $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$()
  };
  return $n_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$
}
function $p_Ljava_time_temporal_IsoFields$__QUARTER_OF_YEAR$lzycompute__Ljava_time_temporal_TemporalField($thiz) {
  if (((((2 & $thiz.Ljava_time_temporal_IsoFields$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEAR = $m_Ljava_time_temporal_IsoFields$Field$().QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field();
    $thiz.Ljava_time_temporal_IsoFields$__f_bitmap$0 = (((2 | $thiz.Ljava_time_temporal_IsoFields$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEAR
}
function $p_Ljava_time_temporal_IsoFields$__WEEK_BASED_YEAR$lzycompute__Ljava_time_temporal_TemporalField($thiz) {
  if (((((8 & $thiz.Ljava_time_temporal_IsoFields$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEAR = $m_Ljava_time_temporal_IsoFields$Field$().WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
    $thiz.Ljava_time_temporal_IsoFields$__f_bitmap$0 = (((8 | $thiz.Ljava_time_temporal_IsoFields$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEAR
}
function $p_Ljava_time_temporal_IsoFields$__WEEK_BASED_YEARS$lzycompute__Ljava_time_temporal_TemporalUnit($thiz) {
  if (((((16 & $thiz.Ljava_time_temporal_IsoFields$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARS = $m_Ljava_time_temporal_IsoFields$Unit$().WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit();
    $thiz.Ljava_time_temporal_IsoFields$__f_bitmap$0 = (((16 | $thiz.Ljava_time_temporal_IsoFields$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARS
}
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$() {
  this.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEAR = null;
  this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEAR = null;
  this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARS = null;
  this.Ljava_time_temporal_IsoFields$__f_bitmap$0 = 0
}
$c_Ljava_time_temporal_IsoFields$.prototype = new $h_O();
$c_Ljava_time_temporal_IsoFields$.prototype.constructor = $c_Ljava_time_temporal_IsoFields$;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_IsoFields$.prototype = $c_Ljava_time_temporal_IsoFields$.prototype;
$c_Ljava_time_temporal_IsoFields$.prototype.QUARTER_OF_YEAR__Ljava_time_temporal_TemporalField = (function() {
  return (((((2 & this.Ljava_time_temporal_IsoFields$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_IsoFields$__QUARTER_OF_YEAR$lzycompute__Ljava_time_temporal_TemporalField(this) : this.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEAR)
});
$c_Ljava_time_temporal_IsoFields$.prototype.WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField = (function() {
  return (((((8 & this.Ljava_time_temporal_IsoFields$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_IsoFields$__WEEK_BASED_YEAR$lzycompute__Ljava_time_temporal_TemporalField(this) : this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEAR)
});
$c_Ljava_time_temporal_IsoFields$.prototype.WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit = (function() {
  return (((((16 & this.Ljava_time_temporal_IsoFields$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_IsoFields$__WEEK_BASED_YEARS$lzycompute__Ljava_time_temporal_TemporalUnit(this) : this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARS)
});
var $d_Ljava_time_temporal_IsoFields$ = new $TypeData().initClass({
  Ljava_time_temporal_IsoFields$: 0
}, false, "java.time.temporal.IsoFields$", {
  Ljava_time_temporal_IsoFields$: 1,
  O: 1
});
$c_Ljava_time_temporal_IsoFields$.prototype.$classData = $d_Ljava_time_temporal_IsoFields$;
var $n_Ljava_time_temporal_IsoFields$;
function $m_Ljava_time_temporal_IsoFields$() {
  if ((!$n_Ljava_time_temporal_IsoFields$)) {
    $n_Ljava_time_temporal_IsoFields$ = new $c_Ljava_time_temporal_IsoFields$()
  };
  return $n_Ljava_time_temporal_IsoFields$
}
function $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange($thiz, field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ($thiz.isSupported__Ljava_time_temporal_TemporalField__Z(field)) {
      return $n(field).range__Ljava_time_temporal_ValueRange()
    } else {
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
    }
  } else {
    return $n(field).rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange($thiz)
  }
}
function $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  return $n($thiz.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($thiz.getLong__Ljava_time_temporal_TemporalField__J(field), field)
}
function $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $$x2 = (query === null)
  } else {
    var this$1 = $n(x);
    var $$x2 = (this$1 === query)
  };
  if ($$x2) {
    var $$x1 = true
  } else {
    var x$3 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
    if ((x$3 === null)) {
      var $$x3 = (query === null)
    } else {
      var this$2 = $n(x$3);
      var $$x3 = (this$2 === query)
    };
    if ($$x3) {
      var $$x1 = true
    } else {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === null)) {
        var $$x1 = (query === null)
      } else {
        var this$3 = $n(x$5);
        var $$x1 = (this$3 === query)
      }
    }
  };
  if ($$x1) {
    return null
  } else {
    return $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O($thiz)
  }
}
function $is_Ljava_time_temporal_TemporalAccessor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_temporal_TemporalAccessor)))
}
function $as_Ljava_time_temporal_TemporalAccessor(obj) {
  return (($is_Ljava_time_temporal_TemporalAccessor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.TemporalAccessor"))
}
function $isArrayOf_Ljava_time_temporal_TemporalAccessor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_TemporalAccessor)))
}
function $asArrayOf_Ljava_time_temporal_TemporalAccessor(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_TemporalAccessor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.TemporalAccessor;", depth))
}
function $is_Ljava_time_temporal_TemporalField(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_temporal_TemporalField)))
}
function $as_Ljava_time_temporal_TemporalField(obj) {
  return (($is_Ljava_time_temporal_TemporalField(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.TemporalField"))
}
function $isArrayOf_Ljava_time_temporal_TemporalField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_TemporalField)))
}
function $asArrayOf_Ljava_time_temporal_TemporalField(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_TemporalField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.TemporalField;", depth))
}
function $p_Ljava_time_temporal_TemporalQueries$__zoneId$lzycompute__Ljava_time_temporal_TemporalQuery($thiz) {
  if (((((1 & $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_TemporalQueries$__f_zoneId = new $c_Ljava_time_temporal_TemporalQueries$$anon$1();
    $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0 = (((1 | $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_TemporalQueries$__f_zoneId
}
function $p_Ljava_time_temporal_TemporalQueries$__chronology$lzycompute__Ljava_time_temporal_TemporalQuery($thiz) {
  if (((((2 & $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_TemporalQueries$__f_chronology = new $c_Ljava_time_temporal_TemporalQueries$$anon$2();
    $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0 = (((2 | $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_TemporalQueries$__f_chronology
}
function $p_Ljava_time_temporal_TemporalQueries$__precision$lzycompute__Ljava_time_temporal_TemporalQuery($thiz) {
  if (((((4 & $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_TemporalQueries$__f_precision = new $c_Ljava_time_temporal_TemporalQueries$$anon$3();
    $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0 = (((4 | $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_TemporalQueries$__f_precision
}
function $p_Ljava_time_temporal_TemporalQueries$__offset$lzycompute__Ljava_time_temporal_TemporalQuery($thiz) {
  if (((((8 & $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_TemporalQueries$__f_offset = new $c_Ljava_time_temporal_TemporalQueries$$anon$4();
    $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0 = (((8 | $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_TemporalQueries$__f_offset
}
function $p_Ljava_time_temporal_TemporalQueries$__zone$lzycompute__Ljava_time_temporal_TemporalQuery($thiz) {
  if (((((16 & $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_TemporalQueries$__f_zone = new $c_Ljava_time_temporal_TemporalQueries$$anon$5();
    $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0 = (((16 | $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_TemporalQueries$__f_zone
}
function $p_Ljava_time_temporal_TemporalQueries$__localDate$lzycompute__Ljava_time_temporal_TemporalQuery($thiz) {
  if (((((32 & $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_TemporalQueries$__f_localDate = new $c_Ljava_time_temporal_TemporalQueries$$anon$6();
    $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0 = (((32 | $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_TemporalQueries$__f_localDate
}
function $p_Ljava_time_temporal_TemporalQueries$__localTime$lzycompute__Ljava_time_temporal_TemporalQuery($thiz) {
  if (((((64 & $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_TemporalQueries$__f_localTime = new $c_Ljava_time_temporal_TemporalQueries$$anon$7();
    $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0 = (((64 | $thiz.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_TemporalQueries$__f_localTime
}
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$() {
  this.Ljava_time_temporal_TemporalQueries$__f_zoneId = null;
  this.Ljava_time_temporal_TemporalQueries$__f_chronology = null;
  this.Ljava_time_temporal_TemporalQueries$__f_precision = null;
  this.Ljava_time_temporal_TemporalQueries$__f_offset = null;
  this.Ljava_time_temporal_TemporalQueries$__f_zone = null;
  this.Ljava_time_temporal_TemporalQueries$__f_localDate = null;
  this.Ljava_time_temporal_TemporalQueries$__f_localTime = null;
  this.Ljava_time_temporal_TemporalQueries$__f_bitmap$0 = 0
}
$c_Ljava_time_temporal_TemporalQueries$.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$.prototype = $c_Ljava_time_temporal_TemporalQueries$.prototype;
$c_Ljava_time_temporal_TemporalQueries$.prototype.zoneId__Ljava_time_temporal_TemporalQuery = (function() {
  return (((((1 & this.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_TemporalQueries$__zoneId$lzycompute__Ljava_time_temporal_TemporalQuery(this) : this.Ljava_time_temporal_TemporalQueries$__f_zoneId)
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.chronology__Ljava_time_temporal_TemporalQuery = (function() {
  return (((((2 & this.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_TemporalQueries$__chronology$lzycompute__Ljava_time_temporal_TemporalQuery(this) : this.Ljava_time_temporal_TemporalQueries$__f_chronology)
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.precision__Ljava_time_temporal_TemporalQuery = (function() {
  return (((((4 & this.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_TemporalQueries$__precision$lzycompute__Ljava_time_temporal_TemporalQuery(this) : this.Ljava_time_temporal_TemporalQueries$__f_precision)
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.offset__Ljava_time_temporal_TemporalQuery = (function() {
  return (((((8 & this.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_TemporalQueries$__offset$lzycompute__Ljava_time_temporal_TemporalQuery(this) : this.Ljava_time_temporal_TemporalQueries$__f_offset)
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.zone__Ljava_time_temporal_TemporalQuery = (function() {
  return (((((16 & this.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_TemporalQueries$__zone$lzycompute__Ljava_time_temporal_TemporalQuery(this) : this.Ljava_time_temporal_TemporalQueries$__f_zone)
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.localDate__Ljava_time_temporal_TemporalQuery = (function() {
  return (((((32 & this.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_TemporalQueries$__localDate$lzycompute__Ljava_time_temporal_TemporalQuery(this) : this.Ljava_time_temporal_TemporalQueries$__f_localDate)
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.localTime__Ljava_time_temporal_TemporalQuery = (function() {
  return (((((64 & this.Ljava_time_temporal_TemporalQueries$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_TemporalQueries$__localTime$lzycompute__Ljava_time_temporal_TemporalQuery(this) : this.Ljava_time_temporal_TemporalQueries$__f_localTime)
});
var $d_Ljava_time_temporal_TemporalQueries$ = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$: 0
}, false, "java.time.temporal.TemporalQueries$", {
  Ljava_time_temporal_TemporalQueries$: 1,
  O: 1
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$;
var $n_Ljava_time_temporal_TemporalQueries$;
function $m_Ljava_time_temporal_TemporalQueries$() {
  if ((!$n_Ljava_time_temporal_TemporalQueries$)) {
    $n_Ljava_time_temporal_TemporalQueries$ = new $c_Ljava_time_temporal_TemporalQueries$()
  };
  return $n_Ljava_time_temporal_TemporalQueries$
}
function $is_Ljava_time_temporal_TemporalUnit(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_temporal_TemporalUnit)))
}
function $as_Ljava_time_temporal_TemporalUnit(obj) {
  return (($is_Ljava_time_temporal_TemporalUnit(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.TemporalUnit"))
}
function $isArrayOf_Ljava_time_temporal_TemporalUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_TemporalUnit)))
}
function $asArrayOf_Ljava_time_temporal_TemporalUnit(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_TemporalUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.TemporalUnit;", depth))
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRules() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneRules.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRules.prototype.constructor = $c_Ljava_time_zone_ZoneRules;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRules.prototype = $c_Ljava_time_zone_ZoneRules.prototype;
function $as_Ljava_time_zone_ZoneRules(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRules) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRules"))
}
function $isArrayOf_Ljava_time_zone_ZoneRules(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRules)))
}
function $asArrayOf_Ljava_time_zone_ZoneRules(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRules(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRules;", depth))
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneRules$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRules$.prototype.constructor = $c_Ljava_time_zone_ZoneRules$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRules$.prototype = $c_Ljava_time_zone_ZoneRules$.prototype;
$c_Ljava_time_zone_ZoneRules$.prototype.of__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_ZoneRules = (function(baseStandardOffset, baseWallOffset, standardOffsetTransitionList, transitionList, lastRules) {
  if ((baseStandardOffset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "baseStandardOffset")
  };
  if ((baseWallOffset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "baseWallOffset")
  };
  if ((standardOffsetTransitionList === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "standardOffsetTransitionList")
  };
  if ((transitionList === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "transitionList")
  };
  if ((lastRules === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "lastRules")
  };
  return $m_Ljava_time_zone_StandardZoneRules$().apply__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_StandardZoneRules(baseStandardOffset, baseWallOffset, standardOffsetTransitionList, transitionList, lastRules)
});
$c_Ljava_time_zone_ZoneRules$.prototype.of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules = (function(offset) {
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  return new $c_Ljava_time_zone_ZoneRules$Fixed(offset)
});
var $d_Ljava_time_zone_ZoneRules$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneRules$: 0
}, false, "java.time.zone.ZoneRules$", {
  Ljava_time_zone_ZoneRules$: 1,
  O: 1
});
$c_Ljava_time_zone_ZoneRules$.prototype.$classData = $d_Ljava_time_zone_ZoneRules$;
var $n_Ljava_time_zone_ZoneRules$;
function $m_Ljava_time_zone_ZoneRules$() {
  if ((!$n_Ljava_time_zone_ZoneRules$)) {
    $n_Ljava_time_zone_ZoneRules$ = new $c_Ljava_time_zone_ZoneRules$()
  };
  return $n_Ljava_time_zone_ZoneRules$
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesInitializer() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneRulesInitializer.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesInitializer.prototype.constructor = $c_Ljava_time_zone_ZoneRulesInitializer;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesInitializer() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRulesInitializer.prototype = $c_Ljava_time_zone_ZoneRulesInitializer.prototype;
function $as_Ljava_time_zone_ZoneRulesInitializer(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRulesInitializer) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRulesInitializer"))
}
function $isArrayOf_Ljava_time_zone_ZoneRulesInitializer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRulesInitializer)))
}
function $asArrayOf_Ljava_time_zone_ZoneRulesInitializer(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRulesInitializer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRulesInitializer;", depth))
}
function $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED$lzycompute__ju_concurrent_atomic_AtomicBoolean($thiz) {
  if (((((2 & $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED = new $c_ju_concurrent_atomic_AtomicBoolean(false);
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_bitmap$0 = (((2 | $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED
}
function $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED__ju_concurrent_atomic_AtomicBoolean($thiz) {
  return (((((2 & $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED$lzycompute__ju_concurrent_atomic_AtomicBoolean($thiz) : $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED)
}
function $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER$lzycompute__ju_concurrent_atomic_AtomicReference($thiz) {
  if (((((4 & $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_bitmap$0 = (((4 | $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER
}
function $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference($thiz) {
  return (((((4 & $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER$lzycompute__ju_concurrent_atomic_AtomicReference($thiz) : $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER)
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesInitializer$() {
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED = null;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER = null;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_bitmap$0 = 0
}
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype.constructor = $c_Ljava_time_zone_ZoneRulesInitializer$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesInitializer$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRulesInitializer$.prototype = $c_Ljava_time_zone_ZoneRulesInitializer$.prototype;
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype.initialize__V = (function() {
  if ($n($p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED__ju_concurrent_atomic_AtomicBoolean(this)).getAndSet__Z__Z(true)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Already initialized")
  };
  $n($p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference(this)).compareAndSet__O__O__Z(null, new $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer());
  $n($as_Ljava_time_zone_ZoneRulesInitializer($n($p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference(this)).ju_concurrent_atomic_AtomicReference__f_value)).initializeProviders__V()
});
var $d_Ljava_time_zone_ZoneRulesInitializer$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneRulesInitializer$: 0
}, false, "java.time.zone.ZoneRulesInitializer$", {
  Ljava_time_zone_ZoneRulesInitializer$: 1,
  O: 1
});
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype.$classData = $d_Ljava_time_zone_ZoneRulesInitializer$;
var $n_Ljava_time_zone_ZoneRulesInitializer$;
function $m_Ljava_time_zone_ZoneRulesInitializer$() {
  if ((!$n_Ljava_time_zone_ZoneRulesInitializer$)) {
    $n_Ljava_time_zone_ZoneRulesInitializer$ = new $c_Ljava_time_zone_ZoneRulesInitializer$()
  };
  return $n_Ljava_time_zone_ZoneRulesInitializer$
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesProvider() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneRulesProvider.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesProvider.prototype.constructor = $c_Ljava_time_zone_ZoneRulesProvider;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesProvider() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRulesProvider.prototype = $c_Ljava_time_zone_ZoneRulesProvider.prototype;
function $as_Ljava_time_zone_ZoneRulesProvider(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRulesProvider) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRulesProvider"))
}
function $isArrayOf_Ljava_time_zone_ZoneRulesProvider(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRulesProvider)))
}
function $asArrayOf_Ljava_time_zone_ZoneRulesProvider(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRulesProvider(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRulesProvider;", depth))
}
function $p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS$lzycompute__ju_ArrayList($thiz) {
  if (((((1 & $thiz.Ljava_time_zone_ZoneRulesProvider$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS = $ct_ju_ArrayList__(new $c_ju_ArrayList());
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_bitmap$0 = (((1 | $thiz.Ljava_time_zone_ZoneRulesProvider$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS
}
function $p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS__ju_ArrayList($thiz) {
  return (((((1 & $thiz.Ljava_time_zone_ZoneRulesProvider$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS$lzycompute__ju_ArrayList($thiz) : $thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS)
}
function $p_Ljava_time_zone_ZoneRulesProvider$__ZONES$lzycompute__ju_Map($thiz) {
  if (((((2 & $thiz.Ljava_time_zone_ZoneRulesProvider$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONES = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_bitmap$0 = (((2 | $thiz.Ljava_time_zone_ZoneRulesProvider$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONES
}
function $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz) {
  return (((((2 & $thiz.Ljava_time_zone_ZoneRulesProvider$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_zone_ZoneRulesProvider$__ZONES$lzycompute__ju_Map($thiz) : $thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONES)
}
function $p_Ljava_time_zone_ZoneRulesProvider$__getProvider__T__Ljava_time_zone_ZoneRulesProvider($thiz, zoneId) {
  var provider = $as_Ljava_time_zone_ZoneRulesProvider($n($p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz)).get__O__O(zoneId));
  if ((provider === null)) {
    if ($n($p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz)).isEmpty__Z()) {
      throw new $c_Ljava_time_zone_ZoneRulesException("No time-zone data files registered")
    } else {
      throw new $c_Ljava_time_zone_ZoneRulesException(("Unknown time-zone ID: " + zoneId))
    }
  } else {
    return provider
  }
}
function $p_Ljava_time_zone_ZoneRulesProvider$__registerProvider0__Ljava_time_zone_ZoneRulesProvider__V($thiz, provider) {
  var zoneIds = $n($n(provider).provideZoneIds__ju_Set()).iterator__ju_Iterator();
  while ($n(zoneIds).hasNext__Z()) {
    var zoneId = $as_T($n(zoneIds).next__O());
    if ((zoneId === null)) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId")
    };
    var old = $as_Ljava_time_zone_ZoneRulesProvider($n($p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz)).put__O__O__O(zoneId, provider));
    if ((old !== null)) {
      throw new $c_Ljava_time_zone_ZoneRulesException(((("Unable to register zone as one already registered with that ID: " + zoneId) + ", currently loading from provider: ") + provider))
    }
  }
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesProvider$() {
  this.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS = null;
  this.Ljava_time_zone_ZoneRulesProvider$__f_ZONES = null;
  this.Ljava_time_zone_ZoneRulesProvider$__f_bitmap$0 = 0;
  $n_Ljava_time_zone_ZoneRulesProvider$ = this;
  $m_Ljava_time_zone_ZoneRulesInitializer$().initialize__V()
}
$c_Ljava_time_zone_ZoneRulesProvider$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.constructor = $c_Ljava_time_zone_ZoneRulesProvider$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesProvider$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRulesProvider$.prototype = $c_Ljava_time_zone_ZoneRulesProvider$.prototype;
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.getAvailableZoneIds__ju_Set = (function() {
  var a = $n($p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map(this)).keySet__ju_Set();
  return new $c_ju_Collections$UnmodifiableSet(a)
});
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.getRules__T__Z__Ljava_time_zone_ZoneRules = (function(zoneId, forCaching) {
  if ((zoneId === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId")
  };
  return $n($p_Ljava_time_zone_ZoneRulesProvider$__getProvider__T__Ljava_time_zone_ZoneRulesProvider(this, zoneId)).provideRules__T__Z__Ljava_time_zone_ZoneRules(zoneId, forCaching)
});
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.registerProvider__Ljava_time_zone_ZoneRulesProvider__V = (function(provider) {
  if ((provider === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "provider")
  };
  $p_Ljava_time_zone_ZoneRulesProvider$__registerProvider0__Ljava_time_zone_ZoneRulesProvider__V(this, provider);
  $n($p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS__ju_ArrayList(this)).add__O__Z(provider)
});
var $d_Ljava_time_zone_ZoneRulesProvider$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneRulesProvider$: 0
}, false, "java.time.zone.ZoneRulesProvider$", {
  Ljava_time_zone_ZoneRulesProvider$: 1,
  O: 1
});
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.$classData = $d_Ljava_time_zone_ZoneRulesProvider$;
var $n_Ljava_time_zone_ZoneRulesProvider$;
function $m_Ljava_time_zone_ZoneRulesProvider$() {
  if ((!$n_Ljava_time_zone_ZoneRulesProvider$)) {
    $n_Ljava_time_zone_ZoneRulesProvider$ = new $c_Ljava_time_zone_ZoneRulesProvider$()
  };
  return $n_Ljava_time_zone_ZoneRulesProvider$
}
/** @constructor */
function $c_ju_AbstractMap$() {
  /*<skip>*/
}
$c_ju_AbstractMap$.prototype = new $h_O();
$c_ju_AbstractMap$.prototype.constructor = $c_ju_AbstractMap$;
/** @constructor */
function $h_ju_AbstractMap$() {
  /*<skip>*/
}
$h_ju_AbstractMap$.prototype = $c_ju_AbstractMap$.prototype;
$c_ju_AbstractMap$.prototype.java$util$AbstractMap$$entryEquals__ju_Map$Entry__O__Z = (function(entry, other) {
  if ($is_ju_Map$Entry(other)) {
    var x2 = $as_ju_Map$Entry(other);
    var a = $n(entry).getKey__O();
    var b = $n(x2).getKey__O();
    if (((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b))) {
      var a$1 = $n(entry).getValue__O();
      var b$1 = $n(x2).getValue__O();
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z($n(a$1), b$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_AbstractMap$.prototype.java$util$AbstractMap$$entryHashCode__ju_Map$Entry__I = (function(entry) {
  var o = $n(entry).getKey__O();
  var $$x1 = ((o === null) ? 0 : $dp_hashCode__I($n(o)));
  var o$1 = $n(entry).getValue__O();
  return ($$x1 ^ ((o$1 === null) ? 0 : $dp_hashCode__I($n(o$1))))
});
var $d_ju_AbstractMap$ = new $TypeData().initClass({
  ju_AbstractMap$: 0
}, false, "java.util.AbstractMap$", {
  ju_AbstractMap$: 1,
  O: 1
});
$c_ju_AbstractMap$.prototype.$classData = $d_ju_AbstractMap$;
var $n_ju_AbstractMap$;
function $m_ju_AbstractMap$() {
  if ((!$n_ju_AbstractMap$)) {
    $n_ju_AbstractMap$ = new $c_ju_AbstractMap$()
  };
  return $n_ju_AbstractMap$
}
/** @constructor */
function $c_ju_Arrays$() {
  /*<skip>*/
}
$c_ju_Arrays$.prototype = new $h_O();
$c_ju_Arrays$.prototype.constructor = $c_ju_Arrays$;
/** @constructor */
function $h_ju_Arrays$() {
  /*<skip>*/
}
$h_ju_Arrays$.prototype = $c_ju_Arrays$.prototype;
$c_ju_Arrays$.prototype.sort__AI__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_I(length), 0, end, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AI__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex)
  };
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i)
  };
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_I(length), fromIndex, toIndex, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AJ__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_J(length), 0, end, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AJ__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex)
  };
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i)
  };
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_J(length), fromIndex, toIndex, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AS__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_S(length), 0, end, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AS__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex)
  };
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i)
  };
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_S(length), fromIndex, toIndex, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AC__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_C(length), 0, end, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AC__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex)
  };
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i)
  };
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_C(length), fromIndex, toIndex, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AB__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_B(length), 0, end, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AB__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex)
  };
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i)
  };
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_B(length), fromIndex, toIndex, comparator, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AO__ju_Comparator__V = (function(array, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  var end = $n(array).u.length;
  if ((end > 16)) {
    var length = $n(array).u.length;
    var this$2 = $n(array);
    var clazz = $objectGetClass(this$2);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(clazz.getComponentType__jl_Class(), length), 1), 0, end, comparator$1, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, 0, end, comparator$1, ops)
  }
});
$c_ju_Arrays$.prototype.sort__AO__I__I__ju_Comparator__V = (function(array, fromIndex, toIndex, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    $n(array).get(fromIndex)
  };
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(array).get(i)
  };
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(array).u.length;
    var this$2 = $n(array);
    var clazz = $objectGetClass(this$2);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(clazz.getComponentType__jl_Class(), length), 1), fromIndex, toIndex, comparator$1, ops)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, fromIndex, toIndex, comparator$1, ops)
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V = (function(a, temp, start, end, comparator, ops) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + ((length / 2) | 0)) | 0);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, temp, start, middle, comparator, ops);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, temp, middle, end, comparator, ops);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || ($n(comparator).compare__O__O__I($n(ops).get__O__I__O(a, leftInIndex), $n(ops).get__O__I__O(a, rightInIndex)) <= 0)))) {
        $n(ops).set__O__I__O__V(temp, outIndex, $n(ops).get__O__I__O(a, leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0)
      } else {
        $n(ops).set__O__I__O__V(temp, outIndex, $n(ops).get__O__I__O(a, rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0)
      };
      outIndex = ((1 + outIndex) | 0)
    };
    $systemArraycopyFull($n(temp), start, $n(a), start, length)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, start, end, comparator, ops)
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V = (function(a, start, end, comparator, ops) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    var aStart = $n(ops).get__O__I__O(a, start);
    var aStartPlusOne = $n(ops).get__O__I__O(a, ((1 + start) | 0));
    if (($n(comparator).compare__O__O__I(aStart, aStartPlusOne) > 0)) {
      $n(ops).set__O__I__O__V(a, start, aStartPlusOne);
      $n(ops).set__O__I__O__V(a, ((1 + start) | 0), aStart)
    };
    var m = 2;
    while ((m < n)) {
      var next = $n(ops).get__O__I__O(a, ((start + m) | 0));
      if (($n(comparator).compare__O__O__I(next, $n(ops).get__O__I__O(a, (((-1) + ((start + m) | 0)) | 0))) < 0)) {
        var iA = start;
        var iB = (((-1) + ((start + m) | 0)) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if (($n(comparator).compare__O__O__I(next, $n(ops).get__O__I__O(a, ix)) < 0)) {
            iB = ix
          } else {
            iA = ix
          }
        };
        var ix$2 = ((iA + (($n(comparator).compare__O__O__I(next, $n(ops).get__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          $n(ops).set__O__I__O__V(a, i, $n(ops).get__O__I__O(a, (((-1) + i) | 0)));
          i = (((-1) + i) | 0)
        };
        $n(ops).set__O__I__O__V(a, ix$2, next)
      };
      m = ((1 + m) | 0)
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AJ__J__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = $n(a).u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var t = $n(a).get(mid);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $uJ(new $c_RTLong(lo, hi));
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(key.RTLong__f_lo, key.RTLong__f_hi, lo$1, hi$1);
      if ((cmp < 0)) {
        endIndex = mid
      } else if ((cmp === 0)) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AI__I__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = $n(a).u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = $n(a).get(mid);
      var cmp = ((key === elem) ? 0 : ((key < elem) ? (-1) : 1));
      if ((cmp < 0)) {
        endIndex = mid
      } else if ((cmp === 0)) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AO__O__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = $n(a).u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = $n(a).get(mid);
      var cmp = $dp_compareTo__O__I($n($as_jl_Comparable(key)), elem);
      if ((cmp < 0)) {
        endIndex = mid
      } else if ((cmp === 0)) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.equals__AJ__AJ__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var t = $n(a).get(i$1);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var i$2 = i;
    var t$1 = $n(b).get(i$2);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((!((lo === lo$1) && (hi === hi$1)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AI__AI__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AS__AS__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AC__AC__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AB__AB__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AZ__AZ__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AD__AD__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!Object.is(a$1, b$1))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AF__AF__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!Object.is(a$1, b$1))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AO__AO__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z($n(a$1), b$1)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.fill__AJ__I__I__J__V = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex)
  };
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i)
  };
  var i$1 = fromIndex;
  while ((i$1 !== toIndex)) {
    var i$2 = i$1;
    $n(a).set(i$2, value);
    i$1 = ((1 + i$1) | 0)
  }
});
$c_ju_Arrays$.prototype.fill__AO__O__V = (function(a, value) {
  var toIndex = $n(a).u.length;
  var i = 0;
  while ((i !== toIndex)) {
    var i$1 = i;
    $n(a).set(i$1, value);
    i = ((1 + i) | 0)
  }
});
$c_ju_Arrays$.prototype.fill__AO__I__I__O__V = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex)
  };
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i)
  };
  var i$1 = fromIndex;
  while ((i$1 !== toIndex)) {
    var i$2 = i$1;
    $n(a).set(i$2, value);
    i$1 = ((1 + i$1) | 0)
  }
});
$c_ju_Arrays$.prototype.copyOf__AO__I__AO = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var this$3 = $n(original);
  var clazz = $objectGetClass(this$3);
  var ret = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(clazz.getComponentType__jl_Class(), newLength), 1);
  $systemArraycopyRefs($n(original), 0, $n(ret), 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AO__I__jl_Class__AO = (function(original, newLength, newType) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O($n(newType).getComponentType__jl_Class(), newLength), 1);
  $systemArraycopyRefs($n(original), 0, $n(ret), 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AB__I__AB = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_B(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AS__I__AS = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_S(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AI__I__AI = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_I(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AJ__I__AJ = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_J(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AC__I__AC = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_C(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AF__I__AF = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_F(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AD__I__AD = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_D(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AZ__I__AZ = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_Z(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AO__I__I__AO = (function(original, from, to) {
  if ((from > to)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((from + " > ") + to))
  };
  var len = $n(original).u.length;
  var retLength = ((to - from) | 0);
  var b = ((len - from) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var this$3 = $n(original);
  var clazz = $objectGetClass(this$3);
  var ret = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(clazz.getComponentType__jl_Class(), retLength), 1);
  $systemArraycopyRefs($n(original), from, $n(ret), 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AB__I__I__AB = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_B(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AS__I__I__AS = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_S(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AI__I__I__AI = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_I(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AJ__I__I__AJ = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_J(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AC__I__I__AC = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_C(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AF__I__I__AF = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_F(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AD__I__I__AD = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_D(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AZ__I__I__AZ = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_Z(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.asList__AO__ju_List = (function(a) {
  return new $c_ju_Arrays$$anon$1(a)
});
$c_ju_Arrays$.prototype.hashCode__AJ__I = (function(a) {
  if ((a === null)) {
    return 0
  } else {
    var acc = 1;
    var len = $n(a).u.length;
    var i = 0;
    while ((i !== len)) {
      var $$x1 = acc;
      var i$1 = i;
      var t = $n(a).get(i$1);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      acc = ((Math.imul(31, $$x1) + (lo ^ hi)) | 0);
      i = ((1 + i) | 0)
    };
    return acc
  }
});
$c_ju_Arrays$.prototype.hashCode__AO__I = (function(a) {
  if ((a === null)) {
    return 0
  } else {
    var acc = 1;
    var len = $n(a).u.length;
    var i = 0;
    while ((i !== len)) {
      var $$x1 = acc;
      var i$1 = i;
      var o = $n(a).get(i$1);
      acc = ((Math.imul(31, $$x1) + ((o === null) ? 0 : $dp_hashCode__I($n(o)))) | 0);
      i = ((1 + i) | 0)
    };
    return acc
  }
});
var $d_ju_Arrays$ = new $TypeData().initClass({
  ju_Arrays$: 0
}, false, "java.util.Arrays$", {
  ju_Arrays$: 1,
  O: 1
});
$c_ju_Arrays$.prototype.$classData = $d_ju_Arrays$;
var $n_ju_Arrays$;
function $m_ju_Arrays$() {
  if ((!$n_ju_Arrays$)) {
    $n_ju_Arrays$ = new $c_ju_Arrays$()
  };
  return $n_ju_Arrays$
}
function $p_ju_Collections$__EMPTY_LIST$lzycompute__ju_List($thiz) {
  if (((((2 & $thiz.ju_Collections$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.ju_Collections$__f_EMPTY_LIST = new $c_ju_Collections$ImmutableList(new $c_ju_Collections$$anon$2());
    $thiz.ju_Collections$__f_bitmap$0 = (((2 | $thiz.ju_Collections$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.ju_Collections$__f_EMPTY_LIST
}
/** @constructor */
function $c_ju_Collections$() {
  this.ju_Collections$__f_EMPTY_LIST = null;
  this.ju_Collections$__f_bitmap$0 = 0
}
$c_ju_Collections$.prototype = new $h_O();
$c_ju_Collections$.prototype.constructor = $c_ju_Collections$;
/** @constructor */
function $h_ju_Collections$() {
  /*<skip>*/
}
$h_ju_Collections$.prototype = $c_ju_Collections$.prototype;
$c_ju_Collections$.prototype.EMPTY_LIST__ju_List = (function() {
  return (((((2 & this.ju_Collections$__f_bitmap$0) << 24) >> 24) === 0) ? $p_ju_Collections$__EMPTY_LIST$lzycompute__ju_List(this) : this.ju_Collections$__f_EMPTY_LIST)
});
$c_ju_Collections$.prototype.singletonList__O__ju_List = (function(o) {
  return new $c_ju_Collections$ImmutableList(new $c_ju_Collections$$anon$15(o))
});
var $d_ju_Collections$ = new $TypeData().initClass({
  ju_Collections$: 0
}, false, "java.util.Collections$", {
  ju_Collections$: 1,
  O: 1
});
$c_ju_Collections$.prototype.$classData = $d_ju_Collections$;
var $n_ju_Collections$;
function $m_ju_Collections$() {
  if ((!$n_ju_Collections$)) {
    $n_ju_Collections$ = new $c_ju_Collections$()
  };
  return $n_ju_Collections$
}
function $is_ju_Formattable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Formattable)))
}
function $as_ju_Formattable(obj) {
  return (($is_ju_Formattable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Formattable"))
}
function $isArrayOf_ju_Formattable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Formattable)))
}
function $asArrayOf_ju_Formattable(obj, depth) {
  return (($isArrayOf_ju_Formattable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Formattable;", depth))
}
/** @constructor */
function $c_ju_Formatter$() {
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = null;
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = null;
  $n_ju_Formatter$ = this;
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = new RegExp("(?:(\\d+)\\$)?([-#+ 0,\\(<]*)(\\d+)?(?:\\.(\\d+))?[%A-Za-z]", "g");
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = new $ac_I(new Int32Array([96, 126, 638, 770, 32, 256, 2, 126, (-1), (-1), (-1), (-1), (-1), (-1), 800, (-1), (-1), (-1), 124, (-1), (-1), (-1), (-1), 544, (-1), (-1)]))
}
$c_ju_Formatter$.prototype = new $h_O();
$c_ju_Formatter$.prototype.constructor = $c_ju_Formatter$;
/** @constructor */
function $h_ju_Formatter$() {
  /*<skip>*/
}
$h_ju_Formatter$.prototype = $c_ju_Formatter$.prototype;
$c_ju_Formatter$.prototype.java$util$Formatter$$strOfZeros__I__T = (function(count) {
  if ((count <= 20)) {
    if ((count > 20)) {
      $charAt("00000000000000000000", count)
    };
    if ((count < 0)) {
      $charAt("00000000000000000000", (-1))
    };
    return $as_T("00000000000000000000".substring(0, count))
  } else {
    var result = "";
    var remaining = count;
    while ((remaining > 20)) {
      result = (result + "00000000000000000000");
      remaining = (((-20) + remaining) | 0)
    };
    var $$x1 = result;
    var endIndex = remaining;
    if ((endIndex > 20)) {
      $charAt("00000000000000000000", endIndex)
    };
    if ((endIndex < 0)) {
      $charAt("00000000000000000000", (-1))
    };
    return (("" + $$x1) + $as_T("00000000000000000000".substring(0, endIndex)))
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal = (function(x) {
  if ((x === 0.0)) {
    var negative = ((1.0 / x) < 0.0);
    return new $c_ju_Formatter$Decimal(negative, "0", 0)
  } else {
    var negative$2 = (x < 0.0);
    var d = (negative$2 ? (-x) : x);
    var s = ("" + d);
    var ePos = $f_T__indexOf__I__I(s, 101);
    if ((ePos < 0)) {
      var e = 0
    } else {
      var $$x2 = parseInt;
      var beginIndex = ((1 + ePos) | 0);
      if (((beginIndex < 0) || (beginIndex > s.length))) {
        $charAt(s, beginIndex)
      };
      var $$x1 = $$x2($as_T(s.substring(beginIndex)));
      var e = $uI($$x1)
    };
    var significandEnd = ((ePos < 0) ? s.length : ePos);
    var dotPos = $f_T__indexOf__I__I(s, 46);
    if ((dotPos < 0)) {
      if ((significandEnd > s.length)) {
        $charAt(s, significandEnd)
      };
      if ((significandEnd < 0)) {
        $charAt(s, (-1))
      };
      var unscaledValue = $as_T(s.substring(0, significandEnd));
      var scale = ((-e) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue, scale)
    } else {
      if ((dotPos > s.length)) {
        $charAt(s, dotPos)
      };
      if ((dotPos < 0)) {
        $charAt(s, (-1))
      };
      var $$x3 = $as_T(s.substring(0, dotPos));
      var beginIndex$1 = ((1 + dotPos) | 0);
      if ((beginIndex$1 < 0)) {
        $charAt(s, beginIndex$1)
      };
      if ((significandEnd > s.length)) {
        $charAt(s, significandEnd)
      };
      if ((significandEnd < beginIndex$1)) {
        $charAt(s, (-1))
      };
      var digits = (("" + $$x3) + $as_T(s.substring(beginIndex$1, significandEnd)));
      var digitsLen = digits.length;
      var i = 0;
      while (true) {
        if ((i < digitsLen)) {
          var index = i;
          var $$x4 = ($charAt(digits, index) === 48)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          i = ((1 + i) | 0)
        } else {
          break
        }
      };
      var beginIndex$2 = i;
      if (((beginIndex$2 < 0) || (beginIndex$2 > digits.length))) {
        $charAt(digits, beginIndex$2)
      };
      var unscaledValue$2 = $as_T(digits.substring(beginIndex$2));
      var scale$2 = ((((-e) | 0) + ((significandEnd - ((1 + dotPos) | 0)) | 0)) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue$2, scale$2)
    }
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal = (function(x) {
  var this$1 = $n(x);
  var this$2 = $n(this$1.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
  var unscaledValueWithSign = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$2);
  if ((unscaledValueWithSign === "0")) {
    return new $c_ju_Formatter$Decimal(false, "0", 0)
  } else {
    var this$4 = $n(unscaledValueWithSign);
    var negative = ($charAt(this$4, 0) === 45);
    if (negative) {
      var this$5 = $n(unscaledValueWithSign);
      if ((this$5.length < 1)) {
        $charAt(this$5, 1)
      };
      var unscaledValue = $as_T(this$5.substring(1))
    } else {
      var unscaledValue = unscaledValueWithSign
    };
    var this$6 = $n(x);
    var scale = this$6.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    return new $c_ju_Formatter$Decimal(negative, unscaledValue, scale)
  }
});
var $d_ju_Formatter$ = new $TypeData().initClass({
  ju_Formatter$: 0
}, false, "java.util.Formatter$", {
  ju_Formatter$: 1,
  O: 1
});
$c_ju_Formatter$.prototype.$classData = $d_ju_Formatter$;
var $n_ju_Formatter$;
function $m_ju_Formatter$() {
  if ((!$n_ju_Formatter$)) {
    $n_ju_Formatter$ = new $c_ju_Formatter$()
  };
  return $n_ju_Formatter$
}
function $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal($thiz, roundingPos) {
  var digits = $thiz.ju_Formatter$Decimal__f_unscaledValue;
  var this$1 = $n(digits);
  var digitsLen = this$1.length;
  if ((roundingPos < 0)) {
    var negative = $thiz.ju_Formatter$Decimal__f_negative;
    return new $c_ju_Formatter$Decimal(negative, "0", 0)
  } else if ((roundingPos >= digitsLen)) {
    return $thiz
  } else {
    var this$3 = $n(digits);
    if (($charAt(this$3, roundingPos) < 53)) {
      if ((roundingPos === 0)) {
        var negative$1 = $thiz.ju_Formatter$Decimal__f_negative;
        return new $c_ju_Formatter$Decimal(negative$1, "0", 0)
      } else {
        var $$x1 = $thiz.ju_Formatter$Decimal__f_negative;
        var this$5 = $n(digits);
        if ((roundingPos > this$5.length)) {
          $charAt(this$5, roundingPos)
        };
        if ((roundingPos < 0)) {
          $charAt(this$5, (-1))
        };
        return new $c_ju_Formatter$Decimal($$x1, $as_T(this$5.substring(0, roundingPos)), (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - roundingPos) | 0)) | 0))
      }
    } else {
      var lastNonNinePos = (((-1) + roundingPos) | 0);
      while (true) {
        if ((lastNonNinePos >= 0)) {
          var this$6 = $n(digits);
          var index = lastNonNinePos;
          var $$x2 = ($charAt(this$6, index) === 57)
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          lastNonNinePos = (((-1) + lastNonNinePos) | 0)
        } else {
          break
        }
      };
      if ((lastNonNinePos < 0)) {
        var newUnscaledValue = "1"
      } else {
        var this$7 = $n(digits);
        var endIndex = lastNonNinePos;
        if ((endIndex > this$7.length)) {
          $charAt(this$7, endIndex)
        };
        if ((endIndex < 0)) {
          $charAt(this$7, (-1))
        };
        var $$x3 = $as_T(this$7.substring(0, endIndex));
        var this$8 = $n(digits);
        var index$1 = lastNonNinePos;
        var newUnscaledValue = (("" + $$x3) + $bC((65535 & ((1 + $charAt(this$8, index$1)) | 0))))
      };
      var pos = ((1 + lastNonNinePos) | 0);
      var newScale = (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - pos) | 0)) | 0);
      return new $c_ju_Formatter$Decimal($thiz.ju_Formatter$Decimal__f_negative, newUnscaledValue, newScale)
    }
  }
}
/** @constructor */
function $c_ju_Formatter$Decimal(negative, unscaledValue, scale) {
  this.ju_Formatter$Decimal__f_negative = false;
  this.ju_Formatter$Decimal__f_unscaledValue = null;
  this.ju_Formatter$Decimal__f_scale = 0;
  this.ju_Formatter$Decimal__f_negative = negative;
  this.ju_Formatter$Decimal__f_unscaledValue = unscaledValue;
  this.ju_Formatter$Decimal__f_scale = scale
}
$c_ju_Formatter$Decimal.prototype = new $h_O();
$c_ju_Formatter$Decimal.prototype.constructor = $c_ju_Formatter$Decimal;
/** @constructor */
function $h_ju_Formatter$Decimal() {
  /*<skip>*/
}
$h_ju_Formatter$Decimal.prototype = $c_ju_Formatter$Decimal.prototype;
$c_ju_Formatter$Decimal.prototype.isZero__Z = (function() {
  return (this.ju_Formatter$Decimal__f_unscaledValue === "0")
});
$c_ju_Formatter$Decimal.prototype.round__I__ju_Formatter$Decimal = (function(precision) {
  $m_ju_Formatter$();
  var condition = (precision > 0);
  if ((!condition)) {
    throw new $c_jl_AssertionError("Decimal.round() called with non-positive precision")
  };
  return $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, precision)
});
$c_ju_Formatter$Decimal.prototype.setScale__I__ju_Formatter$Decimal = (function(newScale) {
  var this$1 = $n(this.ju_Formatter$Decimal__f_unscaledValue);
  var roundingPos = ((((this$1.length + newScale) | 0) - this.ju_Formatter$Decimal__f_scale) | 0);
  var rounded = $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, roundingPos);
  $m_ju_Formatter$();
  var condition = ($n(rounded).isZero__Z() || ($n(rounded).ju_Formatter$Decimal__f_scale <= newScale));
  if ((!condition)) {
    throw new $c_jl_AssertionError("roundAtPos returned a non-zero value with a scale too large")
  };
  return (($n(rounded).isZero__Z() || ($n(rounded).ju_Formatter$Decimal__f_scale === newScale)) ? rounded : new $c_ju_Formatter$Decimal(this.ju_Formatter$Decimal__f_negative, (("" + $n(rounded).ju_Formatter$Decimal__f_unscaledValue) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((newScale - $n(rounded).ju_Formatter$Decimal__f_scale) | 0))), newScale))
});
$c_ju_Formatter$Decimal.prototype.toString__T = (function() {
  return (((((("Decimal(" + this.ju_Formatter$Decimal__f_negative) + ", ") + this.ju_Formatter$Decimal__f_unscaledValue) + ", ") + this.ju_Formatter$Decimal__f_scale) + ")")
});
var $d_ju_Formatter$Decimal = new $TypeData().initClass({
  ju_Formatter$Decimal: 0
}, false, "java.util.Formatter$Decimal", {
  ju_Formatter$Decimal: 1,
  O: 1
});
$c_ju_Formatter$Decimal.prototype.$classData = $d_ju_Formatter$Decimal;
/** @constructor */
function $c_ju_Formatter$LocaleInfo() {
  /*<skip>*/
}
$c_ju_Formatter$LocaleInfo.prototype = new $h_O();
$c_ju_Formatter$LocaleInfo.prototype.constructor = $c_ju_Formatter$LocaleInfo;
/** @constructor */
function $h_ju_Formatter$LocaleInfo() {
  /*<skip>*/
}
$h_ju_Formatter$LocaleInfo.prototype = $c_ju_Formatter$LocaleInfo.prototype;
function $p_ju_Locale__updateSpecialLanguages__T__T($thiz, l) {
  return ((l === "iw") ? "he" : ((l === "ji") ? "yi" : ((l === "in") ? "id" : l)))
}
function $p_ju_Locale__translateSpecialLanguages__T__T($thiz, l) {
  return ((l === "he") ? "iw" : ((l === "yi") ? "ji" : ((l === "id") ? "in" : l)))
}
function $p_ju_Locale__isEqual__ju_Locale__Z($thiz, l) {
  if (((($thiz.ju_Locale__f_language === $n(l).getLanguage__T()) && ($thiz.ju_Locale__f_country === $n(l).getCountry__T())) && ($thiz.ju_Locale__f_variant === $n(l).ju_Locale__f_variant))) {
    var this$1 = $n($thiz.ju_Locale__f_script);
    if (this$1.isEmpty__Z()) {
      var $$x1 = true
    } else {
      var arg1 = this$1.get__O();
      var x$15 = $as_T(arg1);
      var $$x1 = (x$15 === $n(l).getScript__T())
    }
  } else {
    var $$x1 = false
  };
  if ((($$x1 && $n($thiz.ju_Locale__f_extensions).forall__F1__Z(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var this$3 = $n(x0$1);
      var k = $uC(this$3._1__O());
      var v = $as_T($n(x0$1)._2__O());
      return ($n(l).getExtension__C__T(k) === v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))) && $n($thiz.ju_Locale__f_unicodeExtensions).forall__F1__Z(new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_T2(x0$2$2);
    if ((x0$2 !== null)) {
      var k$1 = $as_T($n(x0$2)._1__O());
      var v$1 = $as_T($n(x0$2)._2__O());
      return ($n(l).getUnicodeLocaleType__T__T(k$1) === v$1)
    } else {
      throw new $c_s_MatchError(x0$2)
    }
  }))))) {
    var x = $thiz.ju_Locale__f_unicodeAttributes;
    var x$2 = $n($m_sc_JavaConverters$().asScalaSetConverter__ju_Set__sc_JavaConverters$AsScala($n(l).getUnicodeLocaleAttributes__ju_Set())).asScala__O();
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
}
/** @constructor */
function $c_ju_Locale(language, country, variant, script, _extensions, unicodeExtensions, unicodeAttributes, supportSpecialCases) {
  this.ju_Locale__f_language = null;
  this.ju_Locale__f_country = null;
  this.ju_Locale__f_variant = null;
  this.ju_Locale__f_script = null;
  this.ju_Locale__f_unicodeExtensions = null;
  this.ju_Locale__f_unicodeAttributes = null;
  this.ju_Locale__f_extensions = null;
  this.ju_Locale__f_language = language;
  this.ju_Locale__f_country = country;
  this.ju_Locale__f_variant = variant;
  this.ju_Locale__f_script = script;
  this.ju_Locale__f_unicodeExtensions = unicodeExtensions;
  this.ju_Locale__f_unicodeAttributes = unicodeAttributes;
  if ((((language === null) || (country === null)) || (variant === null))) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Null argument to constructor not allowed")
  };
  var x = new $c_T3(language, country, variant);
  var x$2 = new $c_T3("ja", "JP", "JP");
  if ((x.equals__O__Z(x$2) && supportSpecialCases)) {
    var self = $m_ju_Locale$().UNICODE_LOCALE_EXTENSION__C();
    var $$x1 = $as_sc_Map($n(_extensions).$plus__T2__sc_IterableOps($ct_T2__O__O__(new $c_T2(), $bC(self), "ca-japanese")))
  } else {
    var x$3 = new $c_T3(language, country, variant);
    var x$4 = new $c_T3("th", "TH", "TH");
    if ((x$3.equals__O__Z(x$4) && supportSpecialCases)) {
      var self$1 = $m_ju_Locale$().UNICODE_LOCALE_EXTENSION__C();
      var $$x1 = $as_sc_Map($n(_extensions).$plus__T2__sc_IterableOps($ct_T2__O__O__(new $c_T2(), $bC(self$1), "nu-thai")))
    } else {
      var $$x1 = _extensions
    }
  };
  this.ju_Locale__f_extensions = $$x1
}
$c_ju_Locale.prototype = new $h_O();
$c_ju_Locale.prototype.constructor = $c_ju_Locale;
/** @constructor */
function $h_ju_Locale() {
  /*<skip>*/
}
$h_ju_Locale.prototype = $c_ju_Locale.prototype;
$c_ju_Locale.prototype.getLanguage__T = (function() {
  var this$1 = $n(this.ju_Locale__f_language);
  return $p_ju_Locale__translateSpecialLanguages__T__T(this, $as_T(this$1.toLowerCase()))
});
$c_ju_Locale.prototype.getScript__T = (function() {
  var this$1 = $n(this.ju_Locale__f_script);
  return $as_T((this$1.isEmpty__Z() ? "" : this$1.get__O()))
});
$c_ju_Locale.prototype.getCountry__T = (function() {
  var this$1 = $n(this.ju_Locale__f_country);
  return $as_T(this$1.toUpperCase())
});
$c_ju_Locale.prototype.hasExtensions__Z = (function() {
  var this$1 = $n(this.ju_Locale__f_extensions);
  if ((!this$1.isEmpty__Z())) {
    return true
  } else {
    var this$2 = $n(this.ju_Locale__f_unicodeExtensions);
    return (!this$2.isEmpty__Z())
  }
});
$c_ju_Locale.prototype.getExtension__C__T = (function(key) {
  if ((key === $m_ju_Locale$().UNICODE_LOCALE_EXTENSION__C())) {
    var this$1 = $n(this.ju_Locale__f_unicodeExtensions);
    var $$x1 = (!this$1.isEmpty__Z())
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var this$2 = $n($as_sc_IterableOnceOps($n(this.ju_Locale__f_unicodeExtensions).collect__s_PartialFunction__O(new $c_ju_Locale$$anonfun$getExtension$1(this))));
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "-", "")
  } else {
    var this$4 = $n($n(this.ju_Locale__f_extensions).get__O__s_Option($bC(key)));
    var this$3 = $m_s_$less$colon$less$();
    var ev = this$3.s_$less$colon$less$__f_singleton;
    return $as_T((this$4.isEmpty__Z() ? ($n(ev), null) : this$4.get__O()))
  }
});
$c_ju_Locale.prototype.getUnicodeLocaleAttributes__ju_Set = (function() {
  return $as_ju_Set($n($m_sc_JavaConverters$().setAsJavaSetConverter__sc_Set__sc_JavaConverters$AsJava(this.ju_Locale__f_unicodeAttributes)).asJava__O())
});
$c_ju_Locale.prototype.getUnicodeLocaleType__T__T = (function(key) {
  var this$2 = $n($n(this.ju_Locale__f_unicodeExtensions).get__O__s_Option(key));
  var this$1 = $m_s_$less$colon$less$();
  var ev = this$1.s_$less$colon$less$__f_singleton;
  return $as_T((this$2.isEmpty__Z() ? ($n(ev), null) : this$2.get__O()))
});
$c_ju_Locale.prototype.toString__T = (function() {
  $m_sc_StringOps$();
  var x = this.ju_Locale__f_variant;
  var this$3 = $n(x);
  var hasVariant = (!(this$3 === ""));
  $m_sc_StringOps$();
  var x$1 = this.getCountry__T();
  var this$6 = $n(x$1);
  var hasCountry = (!(this$6 === ""));
  $m_sc_StringOps$();
  var x$2 = this.getLanguage__T();
  var this$9 = $n(x$2);
  var hasLanguage = (!(this$9 === ""));
  $m_sc_StringOps$();
  var x$3 = this.getScript__T();
  var this$12 = $n(x$3);
  var hasScript = (!(this$12 === ""));
  var countryPart = (hasCountry ? ("_" + this.getCountry__T()) : ((hasVariant || hasScript) ? "_" : ""));
  var variantPart = (hasVariant ? ("_" + this.ju_Locale__f_variant) : (hasScript ? "_" : ""));
  var scriptPart = ((hasScript && this.hasExtensions__Z()) ? (("#" + this.getScript__T()) + "_") : (hasScript ? ("#" + this.getScript__T()) : (this.hasExtensions__Z() ? "_#" : "")));
  var this$15 = $n($as_sc_IterableOnceOps($n(this.ju_Locale__f_extensions).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var this$14 = $n(x0$1);
      var x$4 = $uC(this$14._1__O());
      var v = $as_T($n(x0$1)._2__O());
      return (($bC(x$4) + "-") + v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))));
  var extensionsPart = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$15, "", "", "");
  return ((hasLanguage || hasCountry) ? ((((this.getLanguage__T() + countryPart) + variantPart) + scriptPart) + extensionsPart) : "")
});
$c_ju_Locale.prototype.toLanguageTag__T = (function() {
  $m_sc_StringOps$();
  var x = this.getLanguage__T();
  var this$3 = $n(x);
  if (((!(this$3 === "")) && $m_ju_Locale$().checkLanguage__T__Z(this.getLanguage__T()))) {
    var language = $p_ju_Locale__updateSpecialLanguages__T__T(this, this.getLanguage__T())
  } else {
    var language = "und"
  };
  var country = ($m_ju_Locale$().checkRegion__T__Z(this.getCountry__T()) ? ("-" + this.getCountry__T()) : "");
  var this$4 = $n(this.ju_Locale__f_variant);
  var variantSegments = $f_T__split__T__I__AT(this$4, "-|_", 0);
  $m_sc_ArrayOps$();
  _return: {
    var i = 0;
    while ((i < $n(variantSegments).u.length)) {
      var x1 = i;
      var arg1 = $n(variantSegments).get(x1);
      var l = $as_T(arg1);
      if ((!$m_ju_Locale$().checkVariantSegment__T__Z(l))) {
        var allSegmentsWellFormed = false;
        break _return
      };
      i = ((1 + i) | 0)
    };
    var allSegmentsWellFormed = true
  };
  $m_sc_ArrayOps$();
  _return$1: {
    var i$1 = 0;
    while ((i$1 < $n(variantSegments).u.length)) {
      var x1$1 = i$1;
      var arg1$1 = $n(variantSegments).get(x1$1);
      var l$3 = $as_T(arg1$1);
      if ((!$m_ju_Locale$().checkAcceptableVariantSegment__T__Z(l$3))) {
        var allAcceptableSegments = false;
        break _return$1
      };
      i$1 = ((1 + i$1) | 0)
    };
    var allAcceptableSegments = true
  };
  if (allSegmentsWellFormed) {
    var this$9 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(variantSegments));
    var variant = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$9, "-", "-", "")
  } else if (allAcceptableSegments) {
    $m_sc_ArrayOps$();
    $m_sc_ArrayOps$();
    var $$x1 = $m_s_reflect_ClassTag$();
    var this$13 = $n(variantSegments);
    var evidence$1 = $n($$x1).apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$13).getComponentType__jl_Class());
    var res1 = new $c_scm_ArrayBuilder$generic($n(evidence$1).runtimeClass__jl_Class());
    $m_sc_ArrayOps$();
    var $$x2 = $m_s_reflect_ClassTag$();
    var this$17 = $n(variantSegments);
    var evidence$1$1 = $n($$x2).apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$17).getComponentType__jl_Class());
    var res2 = new $c_scm_ArrayBuilder$generic($n(evidence$1$1).runtimeClass__jl_Class());
    var i$2 = 0;
    while ((i$2 < $n(variantSegments).u.length)) {
      var x1$2 = i$2;
      var x$1 = $n(variantSegments).get(x1$2);
      var l$4 = $as_T(x$1);
      var this$20 = $n(($m_ju_Locale$().checkVariantSegment__T__Z(l$4) ? res1 : res2));
      this$20.addOne__O__scm_ArrayBuilder$generic(x$1);
      i$2 = ((1 + i$2) | 0)
    };
    var _1 = res1.result__O();
    var _2 = res2.result__O();
    var wellFormed = $asArrayOf_T(_1, 1);
    var acceptable = $asArrayOf_T(_2, 1);
    if (($m_sc_ArrayOps$(), ($n(wellFormed).u.length !== 0))) {
      var this$25 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($asArrayOf_O(($m_sc_ArrayOps$(), $m_sc_ArrayOps$().slice$extension__O__I__I__O(wellFormed, 0, 1)), 1)));
      var pre = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$25, "-", "-", "-")
    } else {
      var pre = "-"
    };
    var $$x3 = $m_s_Predef$();
    $m_sc_ArrayOps$();
    var xs = $m_sc_ArrayOps$().drop$extension__O__I__O(wellFormed, 1);
    $m_sc_ArrayOps$();
    var this$32 = $m_s_Array$();
    var newLength = (($n(acceptable).u.length + $m_jl_reflect_Array$().getLength__O__I(xs)) | 0);
    var this$33 = $n(acceptable);
    if ($d_T.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$33).getComponentType__jl_Class())) {
      var dest$1 = ($d_T.getClassOf().isPrimitive__Z() ? this$32.copyOf__O__I__O(acceptable, newLength) : $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(acceptable, newLength, $d_T.getArrayOf().getClassOf()))
    } else {
      var dest = new ($d_T.getArrayOf().constr)(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(acceptable, 0, dest, 0, $n(acceptable).u.length);
      var dest$1 = dest
    };
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest$1, $n(acceptable).u.length, $m_jl_reflect_Array$().getLength__O__I(xs));
    var this$36 = $n($n($$x3).wrapRefArray__AO__scm_ArraySeq$ofRef($asArrayOf_O(dest$1, 1)));
    var variant = ((pre + "x-lvariant") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$36, "-", "-", ""))
  } else {
    var variant = ""
  };
  var this$37 = $n(this.ju_Locale__f_extensions);
  if ((!this$37.isEmpty__Z())) {
    var this$39 = $n($as_sc_IterableOnceOps($n(this.ju_Locale__f_extensions).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var this$38 = $n(x0$1);
        var x$2 = $uC(this$38._1__O());
        var v = $as_T($n(x0$1)._2__O());
        return (($bC(x$2) + "-") + v)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })))));
    var ext = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$39, "-", "-", "")
  } else {
    var ext = ""
  };
  var this$40 = $n(this.ju_Locale__f_script);
  if (this$40.isEmpty__Z()) {
    var $$x4 = $m_s_None$()
  } else {
    var arg1$2 = this$40.get__O();
    $as_T(arg1$2);
    var $$x4 = new $c_s_Some(("-" + this.getScript__T()))
  };
  var this$41 = $n($$x4);
  var script = $as_T((this$41.isEmpty__Z() ? "" : this$41.get__O()));
  return ((((this.getLanguage__T() === "no") && (this.getCountry__T() === "NO")) && (this.ju_Locale__f_variant === "NY")) ? "nn-NO" : ((((("" + language) + script) + country) + ext) + variant))
});
$c_ju_Locale.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_ju_Locale)) {
    var x2 = $as_ju_Locale(x);
    return $p_ju_Locale__isEqual__ju_Locale__Z(this, x2)
  } else {
    return false
  }
});
$c_ju_Locale.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I($n(this.toLanguageTag__T()))
});
function $as_ju_Locale(obj) {
  return (((obj instanceof $c_ju_Locale) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Locale"))
}
function $isArrayOf_ju_Locale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale)))
}
function $asArrayOf_ju_Locale(obj, depth) {
  return (($isArrayOf_ju_Locale(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Locale;", depth))
}
var $d_ju_Locale = new $TypeData().initClass({
  ju_Locale: 0
}, false, "java.util.Locale", {
  ju_Locale: 1,
  O: 1
});
$c_ju_Locale.prototype.$classData = $d_ju_Locale;
function $p_ju_Locale$__ENGLISH$lzycompute__ju_Locale($thiz) {
  if (((1 & $thiz.ju_Locale$__f_bitmap$0) === 0)) {
    var this$1 = $n($m_Llocales_LocalesDb$().localeForLanguageTag__T__s_Option("en"));
    $thiz.ju_Locale$__f_ENGLISH = $as_ju_Locale((this$1.isEmpty__Z() ? $m_ju_Locale$().ROOT__ju_Locale() : this$1.get__O()));
    $thiz.ju_Locale$__f_bitmap$0 = (1 | $thiz.ju_Locale$__f_bitmap$0)
  };
  return $thiz.ju_Locale$__f_ENGLISH
}
function $p_ju_Locale$__FRENCH$lzycompute__ju_Locale($thiz) {
  if (((2 & $thiz.ju_Locale$__f_bitmap$0) === 0)) {
    var this$1 = $n($m_Llocales_LocalesDb$().localeForLanguageTag__T__s_Option("fr"));
    $thiz.ju_Locale$__f_FRENCH = $as_ju_Locale((this$1.isEmpty__Z() ? $m_ju_Locale$().ROOT__ju_Locale() : this$1.get__O()));
    $thiz.ju_Locale$__f_bitmap$0 = (2 | $thiz.ju_Locale$__f_bitmap$0)
  };
  return $thiz.ju_Locale$__f_FRENCH
}
function $p_ju_Locale$__ROOT$lzycompute__ju_Locale($thiz) {
  if (((2097152 & $thiz.ju_Locale$__f_bitmap$0) === 0)) {
    $thiz.ju_Locale$__f_ROOT = $n($m_Llocales_LocalesDb$().root__Llocales_cldr_LDML()).toLocale__ju_Locale();
    $thiz.ju_Locale$__f_bitmap$0 = (2097152 | $thiz.ju_Locale$__f_bitmap$0)
  };
  return $thiz.ju_Locale$__f_ROOT
}
function $p_ju_Locale$__defaultLocale__ju_Locale($thiz) {
  if (((((16 & $thiz.ju_Locale$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-locales/scala-java-locales/core/shared/src/main/scala/java/util/Locale.scala: 297")
  };
  return $thiz.ju_Locale$__f_defaultLocale
}
/** @constructor */
function $c_ju_Locale$() {
  this.ju_Locale$__f_ENGLISH = null;
  this.ju_Locale$__f_FRENCH = null;
  this.ju_Locale$__f_ROOT = null;
  this.ju_Locale$__f_UNICODE_LOCALE_EXTENSION = 0;
  this.ju_Locale$__f_defaultLocale = null;
  this.ju_Locale$__f_bitmap$0 = 0;
  this.ju_Locale$__f_bitmap$init$0 = 0;
  $n_ju_Locale$ = this;
  this.ju_Locale$__f_bitmap$init$0 = (((1 | this.ju_Locale$__f_bitmap$init$0) << 24) >> 24);
  this.ju_Locale$__f_UNICODE_LOCALE_EXTENSION = 117;
  this.ju_Locale$__f_bitmap$init$0 = (((2 | this.ju_Locale$__f_bitmap$init$0) << 24) >> 24);
  this.ju_Locale$__f_defaultLocale = $m_Llocales_DefaultLocale$().platformLocale__ju_Locale();
  this.ju_Locale$__f_bitmap$init$0 = (((16 | this.ju_Locale$__f_bitmap$init$0) << 24) >> 24);
  var $$x10 = $m_s_Predef$();
  $m_sc_ArrayOps$();
  var this$1 = $m_ju_Locale$Category$();
  var xs = $p_ju_Locale$Category$__categories__Aju_Locale$Category(this$1);
  var f = ((x$6$2) => {
    var x$6 = $as_ju_Locale$Category(x$6$2);
    var y = new $c_s_Some($p_ju_Locale$__defaultLocale__ju_Locale($m_ju_Locale$()));
    return $ct_T2__O__O__(new $c_T2(), x$6, y)
  });
  var len = $n(xs).u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $$x1 = i;
        var arg1 = $n(xs).get(i);
        ys.set($$x1, f(arg1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var $$x2 = i;
        var arg1$1 = $n(x3).get(i);
        ys.set($$x2, f(arg1$1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var $$x3 = i;
        var arg1$2 = $n(x4).get(i);
        ys.set($$x3, f(arg1$2));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var $$x4 = i;
        var t = $n(x5).get(i);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($$x4, f(new $c_RTLong(lo, hi)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var $$x5 = i;
        var arg1$3 = $n(x6).get(i);
        ys.set($$x5, f(arg1$3));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var $$x6 = i;
        var arg1$4 = $n(x7).get(i);
        ys.set($$x6, f($bC(arg1$4)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var $$x7 = i;
        var arg1$5 = $n(x8).get(i);
        ys.set($$x7, f(arg1$5));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var $$x8 = i;
        var arg1$6 = $n(x9).get(i);
        ys.set($$x8, f(arg1$6));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var $$x9 = i;
        var arg1$7 = $n(x10).get(i);
        ys.set($$x9, f(arg1$7));
        i = ((1 + i) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs)
    }
  };
  var this$9 = $n($n($$x10).wrapRefArray__AO__scm_ArraySeq$ofRef(ys));
  var this$8 = $m_s_$less$colon$less$();
  $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$9);
  this.ju_Locale$__f_bitmap$init$0 = (((32 | this.ju_Locale$__f_bitmap$init$0) << 24) >> 24)
}
$c_ju_Locale$.prototype = new $h_O();
$c_ju_Locale$.prototype.constructor = $c_ju_Locale$;
/** @constructor */
function $h_ju_Locale$() {
  /*<skip>*/
}
$h_ju_Locale$.prototype = $c_ju_Locale$.prototype;
$c_ju_Locale$.prototype.ENGLISH__ju_Locale = (function() {
  return (((1 & this.ju_Locale$__f_bitmap$0) === 0) ? $p_ju_Locale$__ENGLISH$lzycompute__ju_Locale(this) : this.ju_Locale$__f_ENGLISH)
});
$c_ju_Locale$.prototype.FRENCH__ju_Locale = (function() {
  return (((2 & this.ju_Locale$__f_bitmap$0) === 0) ? $p_ju_Locale$__FRENCH$lzycompute__ju_Locale(this) : this.ju_Locale$__f_FRENCH)
});
$c_ju_Locale$.prototype.ROOT__ju_Locale = (function() {
  return (((2097152 & this.ju_Locale$__f_bitmap$0) === 0) ? $p_ju_Locale$__ROOT$lzycompute__ju_Locale(this) : this.ju_Locale$__f_ROOT)
});
$c_ju_Locale$.prototype.UNICODE_LOCALE_EXTENSION__C = (function() {
  if (((((2 & this.ju_Locale$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-locales/scala-java-locales/core/shared/src/main/scala/java/util/Locale.scala: 45")
  };
  return this.ju_Locale$__f_UNICODE_LOCALE_EXTENSION
});
$c_ju_Locale$.prototype.checkRegex__s_util_matching_Regex__T__Z = (function(regex, s) {
  if ((s !== null)) {
    var o7 = $n(regex).unapplySeq__jl_CharSequence__s_Option(s);
    if (((!$n(o7).isEmpty__Z()) && (($n(o7).get__O() !== null) && ($n($as_sci_List($n(o7).get__O())).lengthCompare__I__I(0) === 0)))) {
      return true
    }
  };
  return false
});
$c_ju_Locale$.prototype.checkLanguage__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z(($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{2,8}", $m_sci_Nil$())), l)
});
$c_ju_Locale$.prototype.checkScript__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z(($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{4}", $m_sci_Nil$())), l)
});
$c_ju_Locale$.prototype.checkRegion__T__Z = (function(l) {
  return (this.checkRegex__s_util_matching_Regex__T__Z(($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{2}", $m_sci_Nil$())), l) || this.checkRegex__s_util_matching_Regex__T__Z(($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9]{3}", $m_sci_Nil$())), l))
});
$c_ju_Locale$.prototype.checkAcceptableVariantSegment__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z(($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9a-zA-Z]{1,8}", $m_sci_Nil$())), l)
});
$c_ju_Locale$.prototype.checkVariantSegment__T__Z = (function(l) {
  return (this.checkRegex__s_util_matching_Regex__T__Z(($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9][0-9a-zA-Z]{3}", $m_sci_Nil$())), l) || this.checkRegex__s_util_matching_Regex__T__Z(($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9a-zA-Z]{5,8}", $m_sci_Nil$())), l))
});
$c_ju_Locale$.prototype.checkVariant__T__Z = (function(l) {
  var this$1 = $n(l);
  var parts = $f_T__split__T__I__AT(this$1, "-|_", 0);
  $m_sc_ArrayOps$();
  var i = 0;
  while ((i < $n(parts).u.length)) {
    var x1 = i;
    var arg1 = $n(parts).get(x1);
    var l$2 = $as_T(arg1);
    if ((!$m_ju_Locale$().checkVariantSegment__T__Z(l$2))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
var $d_ju_Locale$ = new $TypeData().initClass({
  ju_Locale$: 0
}, false, "java.util.Locale$", {
  ju_Locale$: 1,
  O: 1
});
$c_ju_Locale$.prototype.$classData = $d_ju_Locale$;
var $n_ju_Locale$;
function $m_ju_Locale$() {
  if ((!$n_ju_Locale$)) {
    $n_ju_Locale$ = new $c_ju_Locale$()
  };
  return $n_ju_Locale$
}
/** @constructor */
function $c_ju_Locale$Builder() {
  this.ju_Locale$Builder__f_builder = null;
  this.ju_Locale$Builder__f_builder = new $c_ju_Locale$LocaleBuilder(true, $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $as_sc_Map($m_sc_Map$().empty__O()), $as_sc_Map($m_sc_Map$().empty__O()), $as_sc_Set($m_sc_Set$().empty__O()))
}
$c_ju_Locale$Builder.prototype = new $h_O();
$c_ju_Locale$Builder.prototype.constructor = $c_ju_Locale$Builder;
/** @constructor */
function $h_ju_Locale$Builder() {
  /*<skip>*/
}
$h_ju_Locale$Builder.prototype = $c_ju_Locale$Builder.prototype;
$c_ju_Locale$Builder.prototype.setLanguage__T__ju_Locale$Builder = (function(language) {
  var this$1 = $n($n(this.ju_Locale$Builder__f_builder).language__T__s_Option(language));
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid language " + language))
  };
  var arg1 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(arg1);
  this.ju_Locale$Builder__f_builder = x;
  return this
});
$c_ju_Locale$Builder.prototype.setScript__T__ju_Locale$Builder = (function(script) {
  var this$1 = $n($n(this.ju_Locale$Builder__f_builder).script__T__s_Option(script));
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid script " + script))
  };
  var arg1 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(arg1);
  this.ju_Locale$Builder__f_builder = x;
  return this
});
$c_ju_Locale$Builder.prototype.setRegion__T__ju_Locale$Builder = (function(region) {
  var this$1 = $n($n(this.ju_Locale$Builder__f_builder).region__T__s_Option(region));
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid region " + region))
  };
  var arg1 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(arg1);
  this.ju_Locale$Builder__f_builder = x;
  return this
});
$c_ju_Locale$Builder.prototype.setVariant__T__ju_Locale$Builder = (function(variant) {
  var this$1 = $n($n(this.ju_Locale$Builder__f_builder).variant__T__s_Option(variant));
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid variant " + variant))
  };
  var arg1 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(arg1);
  this.ju_Locale$Builder__f_builder = x;
  return this
});
$c_ju_Locale$Builder.prototype.build__ju_Locale = (function() {
  return $n(this.ju_Locale$Builder__f_builder).build__ju_Locale()
});
var $d_ju_Locale$Builder = new $TypeData().initClass({
  ju_Locale$Builder: 0
}, false, "java.util.Locale$Builder", {
  ju_Locale$Builder: 1,
  O: 1
});
$c_ju_Locale$Builder.prototype.$classData = $d_ju_Locale$Builder;
function $f_ju_Map__computeIfAbsent__O__ju_function_Function__O($thiz, key, mappingFunction) {
  var oldValue = $thiz.get__O__O(key);
  if ((oldValue !== null)) {
    return oldValue
  } else {
    var newValue = $n(mappingFunction).apply__O__O(key);
    if ((newValue !== null)) {
      $thiz.put__O__O__O(key, newValue)
    };
    return newValue
  }
}
function $f_ju_Map__compute__O__ju_function_BiFunction__O($thiz, key, remappingFunction) {
  var oldValue = $thiz.get__O__O(key);
  var newValue = $n(remappingFunction).apply__O__O__O(key, oldValue);
  $p_ju_Map__putOrRemove__O__O__V($thiz, key, newValue);
  return newValue
}
function $p_ju_Map__putOrRemove__O__O__V($thiz, key, value) {
  if ((value !== null)) {
    $thiz.put__O__O__O(key, value)
  } else {
    $thiz.remove__O__O(key)
  }
}
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map)))
}
function $as_ju_Map(obj) {
  return (($is_ju_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map"))
}
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map)))
}
function $asArrayOf_ju_Map(obj, depth) {
  return (($isArrayOf_ju_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map;", depth))
}
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map$Entry)))
}
function $as_ju_Map$Entry(obj) {
  return (($is_ju_Map$Entry(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map$Entry"))
}
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map$Entry)))
}
function $asArrayOf_ju_Map$Entry(obj, depth) {
  return (($isArrayOf_ju_Map$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map$Entry;", depth))
}
function $is_ju_RandomAccess(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_RandomAccess)))
}
function $as_ju_RandomAccess(obj) {
  return (($is_ju_RandomAccess(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.RandomAccess"))
}
function $isArrayOf_ju_RandomAccess(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_RandomAccess)))
}
function $asArrayOf_ju_RandomAccess(obj, depth) {
  return (($isArrayOf_ju_RandomAccess(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.RandomAccess;", depth))
}
/** @constructor */
function $c_ju_ScalaOps$SimpleRange(start, end) {
  this.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$start = 0;
  this.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$end = 0;
  this.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$start = start;
  this.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$end = end
}
$c_ju_ScalaOps$SimpleRange.prototype = new $h_O();
$c_ju_ScalaOps$SimpleRange.prototype.constructor = $c_ju_ScalaOps$SimpleRange;
/** @constructor */
function $h_ju_ScalaOps$SimpleRange() {
  /*<skip>*/
}
$h_ju_ScalaOps$SimpleRange.prototype = $c_ju_ScalaOps$SimpleRange.prototype;
var $d_ju_ScalaOps$SimpleRange = new $TypeData().initClass({
  ju_ScalaOps$SimpleRange: 0
}, false, "java.util.ScalaOps$SimpleRange", {
  ju_ScalaOps$SimpleRange: 1,
  O: 1
});
$c_ju_ScalaOps$SimpleRange.prototype.$classData = $d_ju_ScalaOps$SimpleRange;
/** @constructor */
function $c_ju_regex_IndicesBuilder(pattern, flags, node, groupCount, jsRegExpForFind, jsRegExpForMatches) {
  this.ju_regex_IndicesBuilder__f_pattern = null;
  this.ju_regex_IndicesBuilder__f_flags = null;
  this.ju_regex_IndicesBuilder__f_node = null;
  this.ju_regex_IndicesBuilder__f_groupCount = 0;
  this.ju_regex_IndicesBuilder__f_jsRegExpForFind = null;
  this.ju_regex_IndicesBuilder__f_jsRegExpForMatches = null;
  this.ju_regex_IndicesBuilder__f_pattern = pattern;
  this.ju_regex_IndicesBuilder__f_flags = flags;
  this.ju_regex_IndicesBuilder__f_node = node;
  this.ju_regex_IndicesBuilder__f_groupCount = groupCount;
  this.ju_regex_IndicesBuilder__f_jsRegExpForFind = jsRegExpForFind;
  this.ju_regex_IndicesBuilder__f_jsRegExpForMatches = jsRegExpForMatches
}
$c_ju_regex_IndicesBuilder.prototype = new $h_O();
$c_ju_regex_IndicesBuilder.prototype.constructor = $c_ju_regex_IndicesBuilder;
/** @constructor */
function $h_ju_regex_IndicesBuilder() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder.prototype = $c_ju_regex_IndicesBuilder.prototype;
$c_ju_regex_IndicesBuilder.prototype.apply__Z__T__I__O = (function(forMatches, string, index) {
  var regExp = (forMatches ? this.ju_regex_IndicesBuilder__f_jsRegExpForMatches : this.ju_regex_IndicesBuilder__f_jsRegExpForFind);
  regExp.lastIndex = index;
  var allMatchResult = regExp.exec(string);
  if (((allMatchResult === null) || ($uI(allMatchResult.index) !== index))) {
    throw new $c_jl_AssertionError((((((("[Internal error] Executed '" + regExp) + "' on ") + ((("'" + string) + "' at position ") + index)) + ", got an error.\n") + ((("Original pattern '" + this.ju_regex_IndicesBuilder__f_pattern) + "' with flags '") + this.ju_regex_IndicesBuilder__f_flags)) + "' did match however."))
  };
  var x = allMatchResult[0];
  var this$2 = $n($as_T(x));
  var end = ((index + this$2.length) | 0);
  var len = ((1 + this.ju_regex_IndicesBuilder__f_groupCount) | 0);
  var indices = new Array(len);
  indices[0] = [index, end];
  var i = 1;
  while ((i !== len)) {
    indices[i] = (void 0);
    i = ((1 + i) | 0)
  };
  $n(this.ju_regex_IndicesBuilder__f_node).propagate__O__O__I__I__V(allMatchResult, indices, index, end);
  return indices
});
var $d_ju_regex_IndicesBuilder = new $TypeData().initClass({
  ju_regex_IndicesBuilder: 0
}, false, "java.util.regex.IndicesBuilder", {
  ju_regex_IndicesBuilder: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder.prototype.$classData = $d_ju_regex_IndicesBuilder;
/** @constructor */
function $c_ju_regex_IndicesBuilder$() {
  /*<skip>*/
}
$c_ju_regex_IndicesBuilder$.prototype = new $h_O();
$c_ju_regex_IndicesBuilder$.prototype.constructor = $c_ju_regex_IndicesBuilder$;
/** @constructor */
function $h_ju_regex_IndicesBuilder$() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$.prototype = $c_ju_regex_IndicesBuilder$.prototype;
$c_ju_regex_IndicesBuilder$.prototype.apply__T__T__ju_regex_IndicesBuilder = (function(pattern, flags) {
  var parser = new $c_ju_regex_IndicesBuilder$Parser(pattern);
  var node = $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node(parser);
  $n(node).setNewGroup__I__I(1);
  var allMatchingPattern = $n(node).buildRegex__O__T(parser.ju_regex_IndicesBuilder$Parser__f_groupNodeMap);
  var jsRegExpForFind = new RegExp(allMatchingPattern, (flags + "g"));
  var jsRegExpForMatches = new RegExp((("^(?:" + allMatchingPattern) + ")$"), flags);
  return new $c_ju_regex_IndicesBuilder(pattern, flags, node, parser.parsedGroupCount__I(), jsRegExpForFind, jsRegExpForMatches)
});
var $d_ju_regex_IndicesBuilder$ = new $TypeData().initClass({
  ju_regex_IndicesBuilder$: 0
}, false, "java.util.regex.IndicesBuilder$", {
  ju_regex_IndicesBuilder$: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder$.prototype.$classData = $d_ju_regex_IndicesBuilder$;
var $n_ju_regex_IndicesBuilder$;
function $m_ju_regex_IndicesBuilder$() {
  if ((!$n_ju_regex_IndicesBuilder$)) {
    $n_ju_regex_IndicesBuilder$ = new $c_ju_regex_IndicesBuilder$()
  };
  return $n_ju_regex_IndicesBuilder$
}
/** @constructor */
function $c_ju_regex_IndicesBuilder$Node() {
  this.ju_regex_IndicesBuilder$Node__f_newGroup = 0
}
$c_ju_regex_IndicesBuilder$Node.prototype = new $h_O();
$c_ju_regex_IndicesBuilder$Node.prototype.constructor = $c_ju_regex_IndicesBuilder$Node;
/** @constructor */
function $h_ju_regex_IndicesBuilder$Node() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$Node.prototype = $c_ju_regex_IndicesBuilder$Node.prototype;
$c_ju_regex_IndicesBuilder$Node.prototype.setNewGroup__I__I = (function(newGroupIndex) {
  this.ju_regex_IndicesBuilder$Node__f_newGroup = newGroupIndex;
  return ((1 + newGroupIndex) | 0)
});
$c_ju_regex_IndicesBuilder$Node.prototype.propagateFromEnd__O__O__I__V = (function(matchResult, indices, end) {
  var x = matchResult[this.ju_regex_IndicesBuilder$Node__f_newGroup];
  if ((x !== (void 0))) {
    var matched = $as_T(x);
    var this$2 = $n(matched);
    var start = ((end - this$2.length) | 0)
  } else {
    var start = (-1)
  };
  this.propagate__O__O__I__I__V(matchResult, indices, start, end)
});
$c_ju_regex_IndicesBuilder$Node.prototype.propagateFromStart__O__O__I__I = (function(matchResult, indices, start) {
  var x = matchResult[this.ju_regex_IndicesBuilder$Node__f_newGroup];
  if ((x !== (void 0))) {
    var matched = $as_T(x);
    var this$2 = $n(matched);
    var end = ((start + this$2.length) | 0)
  } else {
    var end = (-1)
  };
  this.propagate__O__O__I__I__V(matchResult, indices, start, end);
  return end
});
function $as_ju_regex_IndicesBuilder$Node(obj) {
  return (((obj instanceof $c_ju_regex_IndicesBuilder$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.regex.IndicesBuilder$Node"))
}
function $isArrayOf_ju_regex_IndicesBuilder$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_regex_IndicesBuilder$Node)))
}
function $asArrayOf_ju_regex_IndicesBuilder$Node(obj, depth) {
  return (($isArrayOf_ju_regex_IndicesBuilder$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.regex.IndicesBuilder$Node;", depth))
}
function $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz) {
  var alternatives = [];
  var sequence = [];
  while (true) {
    var dispatchCP = $f_T__codePointAt__I__I($n($thiz.ju_regex_IndicesBuilder$Parser__f_pattern), $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex);
    switch (dispatchCP) {
      case 124: {
        alternatives.push($p_ju_regex_IndicesBuilder$Parser__completeSequence$1__O__ju_regex_IndicesBuilder$Node($thiz, sequence));
        sequence = [];
        $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0);
        var baseNode = null;
        break
      }
      case 41: {
        var baseNode;
        $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0);
        var lastAlternative = $p_ju_regex_IndicesBuilder$Parser__completeSequence$1__O__ju_regex_IndicesBuilder$Node($thiz, sequence);
        if (($uI(alternatives.length) === 0)) {
          return lastAlternative
        } else {
          alternatives.push(lastAlternative);
          return new $c_ju_regex_IndicesBuilder$AlternativesNode(alternatives)
        };
        break
      }
      case 40: {
        var indicator = $as_T($thiz.ju_regex_IndicesBuilder$Parser__f_pattern.substring(((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0), ((3 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0)));
        if (((indicator === "?=") || (indicator === "?!"))) {
          $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((3 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0);
          var inner = $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz);
          var baseNode = new $c_ju_regex_IndicesBuilder$LookAroundNode(false, indicator, inner)
        } else if ((indicator === "?<")) {
          var fullIndicator = $as_T($thiz.ju_regex_IndicesBuilder$Parser__f_pattern.substring(((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0), ((4 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0)));
          $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((4 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0);
          var inner$2 = $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz);
          var baseNode = new $c_ju_regex_IndicesBuilder$LookAroundNode(true, fullIndicator, inner$2)
        } else if ((indicator === "?:")) {
          $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((3 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0);
          var inner$3 = $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz);
          var baseNode = ((inner$3 instanceof $c_ju_regex_IndicesBuilder$LeafRegexNode) ? new $c_ju_regex_IndicesBuilder$SequenceNode([inner$3]) : inner$3)
        } else {
          $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0);
          var groupIndex = $uI($thiz.ju_regex_IndicesBuilder$Parser__f_groupNodeMap.length);
          $thiz.ju_regex_IndicesBuilder$Parser__f_groupNodeMap.push(null);
          var inner$4 = $p_ju_regex_IndicesBuilder$Parser__parseInsideParensAndClosingParen__ju_regex_IndicesBuilder$Node($thiz);
          var groupNode = new $c_ju_regex_IndicesBuilder$GroupNode(groupIndex, inner$4);
          $thiz.ju_regex_IndicesBuilder$Parser__f_groupNodeMap[groupIndex] = groupNode;
          var baseNode = groupNode
        };
        break
      }
      case 92: {
        var startIndex = $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex;
        var this$2 = $n($thiz.ju_regex_IndicesBuilder$Parser__f_pattern);
        var index = ((1 + startIndex) | 0);
        var c = $charAt(this$2, index);
        $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((2 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0);
        if (((c >= 48) && (c <= 57))) {
          while (true) {
            var this$3 = $n($thiz.ju_regex_IndicesBuilder$Parser__f_pattern);
            var index$1 = $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex;
            var c$1 = $charAt(this$3, index$1);
            if (((c$1 >= 48) && (c$1 <= 57))) {
              $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0)
            } else {
              break
            }
          };
          var this$4 = $m_jl_Integer$();
          var s = $as_T($thiz.ju_regex_IndicesBuilder$Parser__f_pattern.substring(((1 + startIndex) | 0), $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex));
          var baseNode = new $c_ju_regex_IndicesBuilder$BackReferenceNode(this$4.parseInt__T__I__I(s, 10))
        } else {
          if (((c === 112) || (c === 80))) {
            while (true) {
              var this$5 = $n($thiz.ju_regex_IndicesBuilder$Parser__f_pattern);
              var index$2 = $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex;
              if (($charAt(this$5, index$2) !== 125)) {
                $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0)
              } else {
                break
              }
            };
            $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0)
          };
          var baseNode = new $c_ju_regex_IndicesBuilder$LeafRegexNode($as_T($thiz.ju_regex_IndicesBuilder$Parser__f_pattern.substring(startIndex, $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex)))
        };
        break
      }
      case 91: {
        var startIndex$2 = $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex;
        $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = $p_ju_regex_IndicesBuilder$Parser__loop$1__I__I($thiz, ((1 + startIndex$2) | 0));
        var regex = $as_T($thiz.ju_regex_IndicesBuilder$Parser__f_pattern.substring(startIndex$2, $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex));
        var baseNode = new $c_ju_regex_IndicesBuilder$LeafRegexNode(regex);
        break
      }
      default: {
        var start = $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex;
        $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = (($thiz.ju_regex_IndicesBuilder$Parser__f_pIndex + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
        var baseNode = new $c_ju_regex_IndicesBuilder$LeafRegexNode($as_T($thiz.ju_regex_IndicesBuilder$Parser__f_pattern.substring(start, $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex)))
      }
    };
    if ((baseNode !== null)) {
      var this$7 = $n($thiz.ju_regex_IndicesBuilder$Parser__f_pattern);
      var index$3 = $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex;
      var x1$2 = $charAt(this$7, index$3);
      switch (x1$2) {
        case 43:
        case 42:
        case 63: {
          var startIndex$3 = $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex;
          var this$8 = $n($thiz.ju_regex_IndicesBuilder$Parser__f_pattern);
          var index$4 = ((1 + startIndex$3) | 0);
          if (($charAt(this$8, index$4) === 63)) {
            $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((2 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0)
          } else {
            $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0)
          };
          var repeater = $as_T($thiz.ju_regex_IndicesBuilder$Parser__f_pattern.substring(startIndex$3, $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex));
          $uI(sequence.push(new $c_ju_regex_IndicesBuilder$RepeatedNode(baseNode, repeater)));
          break
        }
        case 123: {
          var startIndex$4 = $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex;
          var this$9 = $n($thiz.ju_regex_IndicesBuilder$Parser__f_pattern);
          var fromIndex = ((1 + startIndex$4) | 0);
          $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((1 + $uI(this$9.indexOf("}", fromIndex))) | 0);
          var this$10 = $n($thiz.ju_regex_IndicesBuilder$Parser__f_pattern);
          var index$5 = $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex;
          if (($charAt(this$10, index$5) === 63)) {
            $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex = ((1 + $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex) | 0)
          };
          var repeater$2 = $as_T($thiz.ju_regex_IndicesBuilder$Parser__f_pattern.substring(startIndex$4, $thiz.ju_regex_IndicesBuilder$Parser__f_pIndex));
          $uI(sequence.push(new $c_ju_regex_IndicesBuilder$RepeatedNode(baseNode, repeater$2)));
          break
        }
        default: {
          var sequenceLen = $uI(sequence.length);
          if ((((sequenceLen !== 0) && (baseNode instanceof $c_ju_regex_IndicesBuilder$LeafRegexNode)) && (sequence[(((-1) + sequenceLen) | 0)] instanceof $c_ju_regex_IndicesBuilder$LeafRegexNode))) {
            var fused = new $c_ju_regex_IndicesBuilder$LeafRegexNode((("" + $n($as_ju_regex_IndicesBuilder$LeafRegexNode(sequence[(((-1) + sequenceLen) | 0)])).ju_regex_IndicesBuilder$LeafRegexNode__f_regex) + $n($as_ju_regex_IndicesBuilder$LeafRegexNode(baseNode)).ju_regex_IndicesBuilder$LeafRegexNode__f_regex));
            sequence[(((-1) + sequenceLen) | 0)] = fused
          } else {
            $uI(sequence.push(baseNode))
          }
        }
      }
    }
  }
}
function $p_ju_regex_IndicesBuilder$Parser__completeSequence$1__O__ju_regex_IndicesBuilder$Node($thiz, sequence) {
  var x1 = $uI(sequence.length);
  switch (x1) {
    case 0: {
      return new $c_ju_regex_IndicesBuilder$LeafRegexNode("");
      break
    }
    case 1: {
      return $as_ju_regex_IndicesBuilder$Node(sequence[0]);
      break
    }
    default: {
      return new $c_ju_regex_IndicesBuilder$SequenceNode(sequence)
    }
  }
}
function $p_ju_regex_IndicesBuilder$Parser__loop$1__I__I($thiz, pIndex) {
  while (true) {
    var this$1 = $n($thiz.ju_regex_IndicesBuilder$Parser__f_pattern);
    var index = pIndex;
    var x1 = $charAt(this$1, index);
    switch (x1) {
      case 92: {
        pIndex = ((2 + pIndex) | 0);
        break
      }
      case 93: {
        return ((1 + pIndex) | 0);
        break
      }
      default: {
        pIndex = ((1 + pIndex) | 0)
      }
    }
  }
}
/** @constructor */
function $c_ju_regex_IndicesBuilder$Parser(pattern0) {
  this.ju_regex_IndicesBuilder$Parser__f_pattern = null;
  this.ju_regex_IndicesBuilder$Parser__f_pIndex = 0;
  this.ju_regex_IndicesBuilder$Parser__f_groupNodeMap = null;
  this.ju_regex_IndicesBuilder$Parser__f_pattern = (pattern0 + ")");
  this.ju_regex_IndicesBuilder$Parser__f_pIndex = 0;
  this.ju_regex_IndicesBuilder$Parser__f_groupNodeMap = [null]
}
$c_ju_regex_IndicesBuilder$Parser.prototype = new $h_O();
$c_ju_regex_IndicesBuilder$Parser.prototype.constructor = $c_ju_regex_IndicesBuilder$Parser;
/** @constructor */
function $h_ju_regex_IndicesBuilder$Parser() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$Parser.prototype = $c_ju_regex_IndicesBuilder$Parser.prototype;
$c_ju_regex_IndicesBuilder$Parser.prototype.parsedGroupCount__I = (function() {
  return (((-1) + $uI(this.ju_regex_IndicesBuilder$Parser__f_groupNodeMap.length)) | 0)
});
var $d_ju_regex_IndicesBuilder$Parser = new $TypeData().initClass({
  ju_regex_IndicesBuilder$Parser: 0
}, false, "java.util.regex.IndicesBuilder$Parser", {
  ju_regex_IndicesBuilder$Parser: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder$Parser.prototype.$classData = $d_ju_regex_IndicesBuilder$Parser;
function $p_ju_regex_PatternCompiler__parseError__T__E($thiz, desc) {
  throw new $c_ju_regex_PatternSyntaxException(desc, $thiz.ju_regex_PatternCompiler__f_pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex)
}
function $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V($thiz) {
  var m = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp.exec($thiz.ju_regex_PatternCompiler__f_pattern);
  if ((m !== null)) {
    var x = m[1];
    if ((x !== (void 0))) {
      var chars = $as_T(x);
      var this$3 = $n(chars);
      var end = this$3.length;
      var i = 0;
      while ((i < end)) {
        var i$2 = i;
        var $$x2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags;
        var $$x1 = $m_ju_regex_PatternCompiler$();
        var this$5 = $n(chars);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($$x2 | $n($$x1).java$util$regex$PatternCompiler$$charToFlag__C__I($charAt(this$5, i$2)));
        i = ((1 + i) | 0)
      }
    };
    if (((256 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags)
    };
    var x$1 = m[2];
    if ((x$1 !== (void 0))) {
      var chars$3 = $as_T(x$1);
      var this$8 = $n(chars$3);
      var end$1 = this$8.length;
      var i$1 = 0;
      while ((i$1 < end$1)) {
        var i$2$1 = i$1;
        var $$x4 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags;
        var $$x3 = $m_ju_regex_PatternCompiler$();
        var this$10 = $n(chars$3);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($$x4 & (~$n($$x3).java$util$regex$PatternCompiler$$charToFlag__C__I($charAt(this$10, i$2$1))));
        i$1 = ((1 + i$1) | 0)
      }
    };
    var $$x5 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var x$2 = m[0];
    var this$12 = $n($as_T(x$2));
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($$x5 + this$12.length) | 0)
  }
}
function $p_ju_regex_PatternCompiler__literal__T__T($thiz, s) {
  var result = "";
  var this$1 = $n(s);
  var len = this$1.length;
  var i = 0;
  while ((i !== len)) {
    var cp = $f_T__codePointAt__I__I($n(s), i);
    result = (("" + result) + $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp));
    i = ((i + ((cp >= 65536) ? 2 : 1)) | 0)
  };
  return result
}
function $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(cp);
  if ((cp < 128)) {
    switch (cp) {
      case 94:
      case 36:
      case 92:
      case 46:
      case 42:
      case 43:
      case 63:
      case 40:
      case 41:
      case 91:
      case 93:
      case 123:
      case 125:
      case 124: {
        return ("\\" + s);
        break
      }
      default: {
        return (((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 2) ? s : (((cp >= 65) && (cp <= 90)) ? ((("[" + s) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + cp) | 0))) + "]") : (((cp >= 97) && (cp <= 122)) ? ((("[" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + cp) | 0))) + s) + "]") : s)))
      }
    }
  } else {
    return ((((-1024) & cp) === 56320) ? (("(?:" + s) + ")") : s)
  }
}
function $p_ju_regex_PatternCompiler__skipComments__V($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$2 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1 = $charAt(this$2, index);
      switch (x1) {
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          continue;
          break
        }
        case 35: {
          $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V();
          continue;
          break
        }
      }
    };
    break
  }
}
function $p_ju_regex_PatternCompiler__compileRepeater__I__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((startOfRepeater === len)) {
    var repeaterDispatchChar = 46
  } else {
    var this$2 = $n(pattern);
    var repeaterDispatchChar = $charAt(this$2, startOfRepeater)
  };
  if (((((repeaterDispatchChar === 63) || (repeaterDispatchChar === 42)) || (repeaterDispatchChar === 43)) || (repeaterDispatchChar === 123))) {
    var this$3 = $n(compiledToken);
    var x1 = $charAt(this$3, 0);
    switch (x1) {
      case 94:
      case 36: {
        var isTokenAnAssertion = true;
        break
      }
      case 40: {
        var this$4 = $n(compiledToken);
        if (($charAt(this$4, 1) === 63)) {
          var this$5 = $n(compiledToken);
          var isTokenAnAssertion = ($charAt(this$5, 2) !== 58)
        } else {
          var isTokenAnAssertion = false
        };
        break
      }
      case 92: {
        var this$6 = $n(compiledToken);
        var c = $charAt(this$6, 1);
        var isTokenAnAssertion = ((c === 98) || (c === 66));
        break
      }
      default: {
        var isTokenAnAssertion = false
      }
    };
    var wrappedToken = (isTokenAnAssertion ? (("(?:" + compiledToken) + ")") : compiledToken);
    var baseRepeater = $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar);
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$7 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1$2 = $charAt(this$7, index);
      switch (x1$2) {
        case 43: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, wrappedToken, baseRepeater);
          break
        }
        case 63: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return ((("" + wrappedToken) + baseRepeater) + "?");
          break
        }
        default: {
          return (("" + wrappedToken) + baseRepeater)
        }
      }
    } else {
      return (("" + wrappedToken) + baseRepeater)
    }
  } else {
    return compiledToken
  }
}
function $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if ((repeaterDispatchChar === 123)) {
    var this$1 = $n(pattern);
    var len = this$1.length;
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $$x1 = true
    } else {
      var this$2 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = $charAt(this$2, index);
      var $$x1 = (!((c >= 48) && (c <= 57)))
    };
    if ($$x1) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition")
    };
    while (true) {
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
        var this$4 = $n(pattern);
        var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var c$1 = $charAt(this$4, index$1);
        var $$x2 = ((c$1 >= 48) && (c$1 <= 57))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
      } else {
        break
      }
    };
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition")
    };
    var this$6 = $n(pattern);
    var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    if (($charAt(this$6, index$2) === 44)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      while (true) {
        if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
          var this$7 = $n(pattern);
          var index$3 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c$2 = $charAt(this$7, index$3);
          var $$x3 = ((c$2 >= 48) && (c$2 <= 57))
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
        } else {
          break
        }
      }
    };
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $$x4 = true
    } else {
      var this$9 = $n(pattern);
      var index$4 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var $$x4 = ($charAt(this$9, index$4) !== 125)
    };
    if ($$x4) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition")
    };
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
  };
  return $as_T(pattern.substring(startOfRepeater, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex))
}
function $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater) {
  var end = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length);
  var i = 0;
  while ((i < end)) {
    var i$2 = i;
    var mapped = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[i$2]);
    if ((mapped > compiledGroupCountBeforeThisToken)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[i$2] = ((1 + mapped) | 0)
    };
    i = ((1 + i) | 0)
  };
  var amendedToken = $as_T(compiledToken.replace($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp, ((arg1$2, arg2$2, arg3$2) => {
    var arg1 = $as_T(arg1$2);
    var arg2 = $as_T(arg2$2);
    var arg3 = $as_T(arg3$2);
    return $thiz.java$util$regex$PatternCompiler$$$anonfun$buildPossessiveQuantifier$2__T__T__T__I__T(arg1, arg2, arg3, compiledGroupCountBeforeThisToken)
  })));
  $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
  var myGroupNumber = ((1 + compiledGroupCountBeforeThisToken) | 0);
  return ((((("(?:(?=(" + amendedToken) + baseRepeater) + "))\\") + myGroupNumber) + ")")
}
function $p_ju_regex_PatternCompiler__compileEscape__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  if ((((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0) === len)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\ at end of pattern")
  };
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var this$2 = $n(pattern);
  var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  var dispatchChar = $charAt(this$2, index);
  switch (dispatchChar) {
    case 100:
    case 68:
    case 104:
    case 72:
    case 115:
    case 83:
    case 118:
    case 86:
    case 119:
    case 87:
    case 112:
    case 80: {
      var cls = $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar);
      var x1$2 = $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_kind;
      switch (x1$2) {
        case 0: {
          return (("\\p{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break
        }
        case 1: {
          return (("\\P{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break
        }
        case 2: {
          return (("[" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data) + "]");
          break
        }
        case 3: {
          return $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data);
          break
        }
        default: {
          throw new $c_jl_AssertionError(x1$2)
        }
      };
      break
    }
    case 98: {
      if (($as_T(pattern.substring($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0))) === "b{g}")) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\b{g} is not supported")
      } else if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\b with UNICODE_CASE", "2018")
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\b"
      };
      break
    }
    case 66: {
      if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\B with UNICODE_CASE", "2018")
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\B"
      };
      break
    }
    case 65: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "^";
      break
    }
    case 71: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\G in the middle of a pattern is not supported");
      break
    }
    case 90: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var lineTerminator = (((1 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "(?:\r\n?|[\n\u0085\u2028\u2029])");
      return (("(?=" + lineTerminator) + "?$)");
      break
    }
    case 122: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "$";
      break
    }
    case 82: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:\r\n|[\n-\r\u0085\u2028\u2029])";
      break
    }
    case 88: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\X is not supported");
      break
    }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57: {
      var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var end = ((1 + start) | 0);
      while (true) {
        if ((end !== len)) {
          var this$7 = $n(pattern);
          var index$1 = end;
          var c = $charAt(this$7, index$1);
          var $$x2 = ((c >= 48) && (c <= 57))
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          var s = $as_T(pattern.substring(start, ((1 + end) | 0)));
          var $$x1 = ($uI(parseInt(s, 10)) <= (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0))
        } else {
          var $$x1 = false
        };
        if ($$x1) {
          end = ((1 + end) | 0)
        } else {
          break
        }
      };
      var groupString = $as_T(pattern.substring(start, end));
      var groupNumber = $uI(parseInt(groupString, 10));
      if ((groupNumber > (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("numbered capturing group <" + groupNumber) + "> does not exist"))
      };
      var compiledGroupNumber = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
      return (("(?:\\" + compiledGroupNumber) + ")");
      break
    }
    case 107: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
        var $$x3 = true
      } else {
        var this$11 = $n(pattern);
        var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var $$x3 = ($charAt(this$11, index$2) !== 60)
      };
      if ($$x3) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\k is not followed by '<' for named capturing group")
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var groupName = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
      var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
      if ((!$uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, groupName)))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + groupName) + "> does not exit"))
      };
      var groupNumber$2 = $uI(dict[groupName]);
      var compiledGroupNumber$2 = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber$2]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (("(?:\\" + compiledGroupNumber$2) + ")");
      break
    }
    case 81: {
      var start$2 = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var this$13 = $n(pattern);
      var end$2 = $uI(this$13.indexOf("\\E", start$2));
      if ((end$2 < 0)) {
        var this$14 = $n(pattern);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = this$14.length;
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2)))
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end$2) | 0);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2, end$2)))
      };
      break
    }
    default: {
      return $p_ju_regex_PatternCompiler__literal__I__T($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz))
    }
  }
}
function $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var x1 = $f_T__codePointAt__I__I($n(pattern), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
  switch (x1) {
    case 48: {
      return $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz);
      break
    }
    case 120: {
      return $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz);
      break
    }
    case 117: {
      return $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz);
      break
    }
    case 78: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\N is not supported");
      break
    }
    case 97: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 7;
      break
    }
    case 116: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 9;
      break
    }
    case 110: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 10;
      break
    }
    case 102: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 12;
      break
    }
    case 114: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 13;
      break
    }
    case 101: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 27;
      break
    }
    case 99: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var $$x1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var this$1 = $n(pattern);
      if (($$x1 === this$1.length)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal control escape sequence")
      };
      var cp = $f_T__codePointAt__I__I($n(pattern), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cp >= 65536) ? 2 : 1)) | 0);
      return (64 ^ cp);
      break
    }
    default: {
      if ((((x1 >= 65) && (x1 <= 90)) || ((x1 >= 97) && (x1 <= 122)))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal/unsupported escape sequence")
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      return x1
    }
  }
}
function $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) < len)) {
    var this$2 = $n(pattern);
    var index = ((1 + start) | 0);
    var d1 = (((-48) + $charAt(this$2, index)) | 0)
  } else {
    var d1 = (-1)
  };
  if (((d1 < 0) || (d1 > 7))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal octal escape sequence")
  };
  if ((((2 + start) | 0) < len)) {
    var this$3 = $n(pattern);
    var index$1 = ((2 + start) | 0);
    var d2 = (((-48) + $charAt(this$3, index$1)) | 0)
  } else {
    var d2 = (-1)
  };
  if (((d2 < 0) || (d2 > 7))) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return d1
  } else if ((d1 > 3)) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return (((d1 << 3) + d2) | 0)
  } else {
    if ((((3 + start) | 0) < len)) {
      var this$4 = $n(pattern);
      var index$2 = ((3 + start) | 0);
      var d3 = (((-48) + $charAt(this$4, index$2)) | 0)
    } else {
      var d3 = (-1)
    };
    if (((d3 < 0) || (d3 > 7))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((d1 << 3) + d2) | 0)
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((((d1 << 6) + (d2 << 3)) | 0) + d3) | 0)
    }
  }
}
function $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if ((start !== len)) {
    var this$2 = $n(pattern);
    var $$x1 = ($charAt(this$2, start) === 123)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var innerStart = ((1 + start) | 0);
    var this$3 = $n(pattern);
    var innerEnd = $uI(this$3.indexOf("}", innerStart));
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed hexadecimal escape sequence")
    };
    var cp = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, innerStart, innerEnd, "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + innerEnd) | 0);
    return cp
  } else {
    var cp$2 = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, ((2 + start) | 0), "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + start) | 0);
    return cp$2
  }
}
function $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var end = ((4 + start) | 0);
  var codeUnit = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, "Unicode");
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
  var lowStart = ((2 + end) | 0);
  var lowEnd = ((4 + lowStart) | 0);
  if (((((-1024) & codeUnit) === 55296) && ($as_T(pattern.substring(end, lowStart)) === "\\u"))) {
    var low = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, lowStart, lowEnd, "Unicode");
    if ((((-1024) & low) === 56320)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = lowEnd;
      return ((((64 + (1023 & codeUnit)) | 0) << 10) | (1023 & low))
    } else {
      return codeUnit
    }
  } else {
    return codeUnit
  }
}
function $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, nameForError) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  if (((start === end) || (end > len))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"))
  };
  var i = start;
  while ((i < end)) {
    var i$2 = i;
    var this$4 = $n(pattern);
    var c = $charAt(this$4, i$2);
    if ((!((((c >= 48) && (c <= 57)) || ((c >= 65) && (c <= 70))) || ((c >= 97) && (c <= 102))))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"))
    };
    i = ((1 + i) | 0)
  };
  if ((((end - start) | 0) > 6)) {
    var cp = 1114112
  } else {
    var s = $as_T(pattern.substring(start, end));
    var cp = $uI(parseInt(s, 16))
  };
  if ((cp > 1114111)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Hexadecimal codepoint is too big")
  };
  return cp
}
function $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar) {
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  switch (dispatchChar) {
    case 100:
    case 68: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit;
      break
    }
    case 104:
    case 72: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace;
      break
    }
    case 115:
    case 83: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace;
      break
    }
    case 118:
    case 86: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace;
      break
    }
    case 119:
    case 87: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar;
      break
    }
    case 112:
    case 80: {
      var positive = $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz);
      break
    }
    default: {
      var positive;
      throw new $c_jl_AssertionError($bC(dispatchChar))
    }
  };
  return ((dispatchChar >= 97) ? positive : $n(positive).negated__ju_regex_PatternCompiler$CompiledCharClass())
}
function $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((start === len)) {
    var property = "?"
  } else {
    var this$2 = $n(pattern);
    if (($charAt(this$2, start) === 123)) {
      var innerStart = ((1 + start) | 0);
      var this$3 = $n(pattern);
      var innerEnd = $uI(this$3.indexOf("}", innerStart));
      if ((innerEnd < 0)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character family")
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = innerEnd;
      var property = $as_T(pattern.substring(innerStart, innerEnd))
    } else {
      var property = $as_T(pattern.substring(start, ((1 + start) | 0)))
    }
  };
  var dict = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  if ((!$uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, property)))) {
    $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Unicode character family", "2018")
  };
  var property2 = ((((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2) && ((property === "Lower") || (property === "Upper"))) ? "Alpha" : property);
  var dict$1 = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  var result = $as_ju_regex_PatternCompiler$CompiledCharClass(dict$1[property2]);
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  return result
}
function $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var this$2 = $n(pattern);
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var isNegated = ($charAt(this$2, index) === 94)
  } else {
    var isNegated = false
  };
  if (isNegated) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
  };
  var builder = new $c_ju_regex_PatternCompiler$CharacterClassBuilder(((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2), isNegated);
  while (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var x1 = $f_T__codePointAt__I__I($n(pattern), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (x1) {
        case 93: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return builder.finish__T();
          break
        }
        case 38: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
            var this$3 = $n(pattern);
            var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
            var $$x1 = ($charAt(this$3, index$1) === 38)
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            builder.startNewConjunct__V()
          } else {
            $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, 38, len, pattern, builder)
          };
          break matchResult;
          break
        }
        case 91: {
          var cls = $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz);
          $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(builder, cls);
          break matchResult;
          break
        }
        case 92: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
            $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal escape sequence")
          };
          var this$4 = $n(pattern);
          var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c2 = $charAt(this$4, index$2);
          switch (c2) {
            case 100:
            case 68:
            case 104:
            case 72:
            case 115:
            case 83:
            case 118:
            case 86:
            case 119:
            case 87:
            case 112:
            case 80: {
              builder.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V($p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, c2));
              break
            }
            case 81: {
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
              var this$5 = $n(pattern);
              var fromIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
              var end = $uI(this$5.indexOf("\\E", fromIndex));
              if ((end < 0)) {
                $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class")
              };
              builder.addCodePointsInString__T__I__I__V(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, end);
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end) | 0);
              break
            }
            default: {
              $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz), len, pattern, builder)
            }
          };
          break matchResult;
          break
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
          } else {
            break
          };
          break matchResult;
          break
        }
        case 35: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V()
          } else {
            break
          };
          break matchResult;
          break
        }
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, x1, len, pattern, builder)
    }
  };
  $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class")
}
function $p_ju_regex_PatternCompiler__compileGroup__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) === len)) {
    var $$x1 = true
  } else {
    var this$2 = $n(pattern);
    var index = ((1 + start) | 0);
    var $$x1 = ($charAt(this$2, index) !== 63)
  };
  if ($$x1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + start) | 0);
    $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
    return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")")
  } else {
    if ((((2 + start) | 0) === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group")
    };
    var this$3 = $n(pattern);
    var index$1 = ((2 + start) | 0);
    var c1 = $charAt(this$3, index$1);
    if ((((c1 === 58) || (c1 === 61)) || (c1 === 33))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      return ((("" + $as_T(pattern.substring(start, ((3 + start) | 0)))) + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")")
    } else if ((c1 === 60)) {
      if ((((3 + start) | 0) === len)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group")
      };
      var this$4 = $n(pattern);
      var index$2 = ((3 + start) | 0);
      var c2 = $charAt(this$4, index$2);
      if ((((c2 >= 65) && (c2 <= 90)) || ((c2 >= 97) && (c2 <= 122)))) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
        var name = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
        var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        if ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, name))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + name) + "> is already defined"))
        };
        $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
        var dict$1 = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        var value = (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0);
        dict$1[name] = value;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")")
      } else {
        if (((c2 !== 61) && (c2 !== 33))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unknown look-behind group")
        };
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Look-behind group", "2018")
      }
    } else if ((c1 === 62)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
      var groupNumber = $thiz.ju_regex_PatternCompiler__f_compiledGroupCount;
      return (((("(?:(?=(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + "))\\") + groupNumber) + ")")
    } else {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Embedded flag expression in the middle of a pattern is not supported")
    }
  }
}
function $p_ju_regex_PatternCompiler__parseGroupName__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$2 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = $charAt(this$2, index);
      var $$x1 = ((((c >= 65) && (c <= 90)) || ((c >= 97) && (c <= 122))) || ((c >= 48) && (c <= 57)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
    } else {
      break
    }
  };
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
    var $$x2 = true
  } else {
    var this$4 = $n(pattern);
    var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $$x2 = ($charAt(this$4, index$1) !== 62)
  };
  if ($$x2) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "named capturing group is missing trailing '>'")
  };
  return $as_T(pattern.substring(start, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex))
}
function $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, startCodePoint, len$2, pattern$3, builder$1) {
  if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__skipComments__V($thiz)
  };
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len$2)) {
    var this$1 = $n(pattern$3);
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $$x1 = ($charAt(this$1, index) === 45)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $p_ju_regex_PatternCompiler__skipComments__V($thiz)
    };
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len$2)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class")
    };
    var cpEnd = $f_T__codePointAt__I__I($n(pattern$3), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    if (((cpEnd === 91) || (cpEnd === 93))) {
      $n(builder$1).addSingleCodePoint__I__V(startCodePoint);
      $n(builder$1).addSingleCodePoint__I__V(45)
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cpEnd >= 65536) ? 2 : 1)) | 0);
      var endCodePoint = ((cpEnd === 92) ? $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) : cpEnd);
      if ((endCodePoint < startCodePoint)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal character range")
      };
      $n(builder$1).addCodePointRange__I__I__V(startCodePoint, endCodePoint)
    }
  } else {
    $n(builder$1).addSingleCodePoint__I__V(startCodePoint)
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler(pattern, flags) {
  this.ju_regex_PatternCompiler__f_pattern = null;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = 0;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = null;
  this.ju_regex_PatternCompiler__f_namedGroups = null;
  this.ju_regex_PatternCompiler__f_pattern = pattern;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = flags;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = [0];
  this.ju_regex_PatternCompiler__f_namedGroups = {}
}
$c_ju_regex_PatternCompiler.prototype = new $h_O();
$c_ju_regex_PatternCompiler.prototype.constructor = $c_ju_regex_PatternCompiler;
/** @constructor */
function $h_ju_regex_PatternCompiler() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler.prototype = $c_ju_regex_PatternCompiler.prototype;
$c_ju_regex_PatternCompiler.prototype.compile__ju_regex_Pattern = (function() {
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags)
  };
  var isLiteral = ((16 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0);
  if ((!isLiteral)) {
    $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V(this)
  };
  if (((128 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "CANON_EQ is not supported")
  };
  if (((8 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("MULTILINE", "2018")
  };
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("UNICODE_CHARACTER_CLASS", "2018")
  };
  if (isLiteral) {
    var jsPattern = $p_ju_regex_PatternCompiler__literal__T__T(this, this.ju_regex_PatternCompiler__f_pattern)
  } else {
    if (($as_T(this.ju_regex_PatternCompiler__f_pattern.substring(this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0))) === "\\G")) {
      this.ju_regex_PatternCompiler__f_sticky = true;
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
    };
    var jsPattern = this.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(false)
  };
  var baseJSFlags = ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "us" : "u");
  var jsFlags = (((66 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 66) ? (baseJSFlags + "i") : baseJSFlags);
  return new $c_ju_regex_Pattern(this.ju_regex_PatternCompiler__f_pattern, this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags, jsPattern, jsFlags, this.ju_regex_PatternCompiler__f_sticky, (((-1) + $uI(this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0), this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap, this.ju_regex_PatternCompiler__f_namedGroups)
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E = (function(purpose, es) {
  $p_ju_regex_PatternCompiler__parseError__T__E(this, (((((((purpose + " is not supported because it requires RegExp features of ECMAScript ") + es) + ".\n") + ((("If you only target environments with ES" + es) + "+, you can enable ES") + es)) + " features with\n") + ("  scalaJSLinkerConfig ~= { _.withESFeatures(_.withESVersion(ESVersion.ES" + es)) + ")) }\nor an equivalent configuration depending on your build tool."))
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T = (function(insideGroup) {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var result = "";
  while ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var dispatchCP = $f_T__codePointAt__I__I($n(pattern), this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (dispatchCP) {
        case 41: {
          if ((!insideGroup)) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unmatched closing ')'")
          };
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return result;
          break
        }
        case 124: {
          if ((this.ju_regex_PatternCompiler__f_sticky && (!insideGroup))) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "\\G is not supported when there is an alternative at the top level")
          };
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          result = (result + "|");
          break matchResult;
          break
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
          } else {
            break
          };
          break matchResult;
          break
        }
        case 35: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.java$util$regex$PatternCompiler$$skipSharpComment__V()
          } else {
            break
          };
          break matchResult;
          break
        }
        case 63:
        case 42:
        case 43:
        case 123: {
          $p_ju_regex_PatternCompiler__parseError__T__E(this, (("Dangling meta character '" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(dispatchCP)) + "'"));
          break
        }
      };
      var compiledGroupCountBeforeThisToken = this.ju_regex_PatternCompiler__f_compiledGroupCount;
      switch (dispatchCP) {
        case 92: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileEscape__T(this);
          break
        }
        case 91: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileCharacterClass__T(this);
          break
        }
        case 40: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileGroup__T(this);
          break
        }
        case 94: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "^";
          break
        }
        case 36: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "$";
          break
        }
        case 46: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var rejected = (((32 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "" : (((1 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "\n\r\u0085\u2028\u2029"));
          var compiledToken = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(rejected);
          break
        }
        default: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
          var compiledToken = $p_ju_regex_PatternCompiler__literal__I__T(this, dispatchCP)
        }
      };
      result = (("" + result) + $p_ju_regex_PatternCompiler__compileRepeater__I__T__T(this, compiledGroupCountBeforeThisToken, compiledToken))
    }
  };
  if (insideGroup) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unclosed group")
  };
  return result
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$skipSharpComment__V = (function() {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  while (true) {
    if ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$2 = $n(pattern);
      var index = this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = $charAt(this$2, index);
      var $$x1 = (!(((((c === 10) || (c === 13)) || (c === 133)) || (c === 8232)) || (c === 8233)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
    } else {
      break
    }
  }
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$$anonfun$buildPossessiveQuantifier$2__T__T__T__I__T = (function(str, backslashes, groupString, compiledGroupCountBeforeThisToken$1) {
  var this$1 = $n(backslashes);
  if ((((this$1.length % 2) | 0) === 0)) {
    return str
  } else {
    var groupNumber = $uI(parseInt(groupString, 10));
    return ((groupNumber > compiledGroupCountBeforeThisToken$1) ? (("" + backslashes) + ((1 + groupNumber) | 0)) : str)
  }
});
var $d_ju_regex_PatternCompiler = new $TypeData().initClass({
  ju_regex_PatternCompiler: 0
}, false, "java.util.regex.PatternCompiler", {
  ju_regex_PatternCompiler: 1,
  O: 1
});
$c_ju_regex_PatternCompiler.prototype.$classData = $d_ju_regex_PatternCompiler;
function $p_ju_regex_PatternCompiler$__featureTest__T__Z($thiz, flags) {
  try {
    new RegExp("", flags);
    return true
  } catch (e) {
    return false
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler$() {
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsIndices = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = null;
  $n_ju_regex_PatternCompiler$ = this;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = new RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = new RegExp("(\\\\+)(\\d+)", "g");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "us");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsIndices = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "d");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "Nd");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t \u00a0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "White_Space");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\n-\r\u0085\u2028\u2029");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-zA-Z_0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\\p{Alphabetic}\\p{Mn}\\p{Me}\\p{Mc}\\p{Nd}\\p{Pc}\\p{Join_Control}");
  var r = {};
  var value = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-z");
  r.Lower = value;
  var value$1 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Z");
  r.Upper = value$1;
  var value$2 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u007f");
  r.ASCII = value$2;
  var value$3 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Za-z");
  r.Alpha = value$3;
  var value$4 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  r.Digit = value$4;
  var value$5 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Za-z");
  r.Alnum = value$5;
  var value$6 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-/:-@[-`{-~");
  r.Punct = value$6;
  var value$7 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-~");
  r.Graph = value$7;
  var value$8 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, " -~");
  r.Print = value$8;
  var value$9 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t ");
  r.Blank = value$9;
  var value$10 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u001f\u007f");
  r.Cntrl = value$10;
  var value$11 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Fa-f");
  r.XDigit = value$11;
  var value$12 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  r.Space = value$12;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = r;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = new RegExp("(?:^|_)[a-z]", "g")
}
$c_ju_regex_PatternCompiler$.prototype = new $h_O();
$c_ju_regex_PatternCompiler$.prototype.constructor = $c_ju_regex_PatternCompiler$;
/** @constructor */
function $h_ju_regex_PatternCompiler$() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler$.prototype = $c_ju_regex_PatternCompiler$.prototype;
$c_ju_regex_PatternCompiler$.prototype.compile__T__I__ju_regex_Pattern = (function(regex, flags) {
  return new $c_ju_regex_PatternCompiler(regex, flags).compile__ju_regex_Pattern()
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$charToFlag__C__I = (function(c) {
  switch (c) {
    case 105: {
      return 2;
      break
    }
    case 100: {
      return 1;
      break
    }
    case 109: {
      return 8;
      break
    }
    case 115: {
      return 32;
      break
    }
    case 117: {
      return 64;
      break
    }
    case 120: {
      return 4;
      break
    }
    case 85: {
      return 256;
      break
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "bad in-pattern flag")
    }
  }
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointNotAmong__T__T = (function(characters) {
  return ((characters !== "") ? (("[^" + characters) + "]") : ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "." : "[\\d\\D]"))
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointToString__I__T = (function(codePoint) {
  return $as_T(String.fromCodePoint(codePoint))
});
var $d_ju_regex_PatternCompiler$ = new $TypeData().initClass({
  ju_regex_PatternCompiler$: 0
}, false, "java.util.regex.PatternCompiler$", {
  ju_regex_PatternCompiler$: 1,
  O: 1
});
$c_ju_regex_PatternCompiler$.prototype.$classData = $d_ju_regex_PatternCompiler$;
var $n_ju_regex_PatternCompiler$;
function $m_ju_regex_PatternCompiler$() {
  if ((!$n_ju_regex_PatternCompiler$)) {
    $n_ju_regex_PatternCompiler$ = new $c_ju_regex_PatternCompiler$()
  };
  return $n_ju_regex_PatternCompiler$
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V($thiz, alt) {
  if (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "")) {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = alt
  } else {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct + "|") + alt)
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T($thiz) {
  if ($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated) {
    var negThisSegment = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? negThisSegment : (((("(?:(?!" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")") + negThisSegment) + ")"))
  } else {
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment === "") ? (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? "[^\\d\\D]" : (("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")")) : (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? (("[" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "]") : (((("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + "|[") + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "])")))
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T($thiz, codePoint) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(codePoint);
  return (((((codePoint === 93) || (codePoint === 92)) || (codePoint === 45)) || (codePoint === 94)) ? ("\\" + s) : s)
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CharacterClassBuilder(asciiCaseInsensitive, isNegated) {
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = asciiCaseInsensitive;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = isNegated;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ""
}
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.constructor = $c_ju_regex_PatternCompiler$CharacterClassBuilder;
/** @constructor */
function $h_ju_regex_PatternCompiler$CharacterClassBuilder() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = $c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype;
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.finish__T = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  return ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction === "") ? conjunct : ((("(?:" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction) + conjunct) + ")"))
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.startNewConjunct__V = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction + (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated ? (conjunct + "|") : (("(?=" + conjunct) + ")")));
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ""
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V = (function(cls) {
  var x1 = $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_kind;
  switch (x1) {
    case 0: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\p{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break
    }
    case 1: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\P{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break
    }
    case 2: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data);
      break
    }
    case 3: {
      $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(this, $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data));
      break
    }
    default: {
      throw new $c_jl_AssertionError(x1)
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointsInString__T__I__I__V = (function(str, start, end) {
  var i = start;
  while ((i !== end)) {
    var codePoint = $f_T__codePointAt__I__I($n(str), i);
    this.addSingleCodePoint__I__V(codePoint);
    i = ((i + ((codePoint >= 65536) ? 2 : 1)) | 0)
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addSingleCodePoint__I__V = (function(codePoint) {
  var s = $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, codePoint);
  if ((((-1024) & codePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + s) + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment)
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + s)
  };
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    if (((codePoint >= 65) && (codePoint <= 90))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + codePoint) | 0)))
    } else if (((codePoint >= 97) && (codePoint <= 122))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + codePoint) | 0)))
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointRange__I__I__V = (function(startCodePoint, endCodePoint) {
  var s = (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, startCodePoint) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, endCodePoint));
  if ((((-1024) & startCodePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (s + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment)
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + s)
  };
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    var start = ((startCodePoint > 65) ? startCodePoint : 65);
    var end = ((endCodePoint < 90) ? endCodePoint : 90);
    if ((start <= end)) {
      var $$x1 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$1 = ((32 + start) | 0);
      var end$1 = ((32 + end) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($$x1 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$1) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$1)))
    };
    var start$2 = ((startCodePoint > 97) ? startCodePoint : 97);
    var end$2 = ((endCodePoint < 122) ? endCodePoint : 122);
    if ((start$2 <= end$2)) {
      var $$x2 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$3 = (((-32) + start$2) | 0);
      var end$3 = (((-32) + end$2) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($$x2 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$3) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$3)))
    }
  }
});
var $d_ju_regex_PatternCompiler$CharacterClassBuilder = new $TypeData().initClass({
  ju_regex_PatternCompiler$CharacterClassBuilder: 0
}, false, "java.util.regex.PatternCompiler$CharacterClassBuilder", {
  ju_regex_PatternCompiler$CharacterClassBuilder: 1,
  O: 1
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.$classData = $d_ju_regex_PatternCompiler$CharacterClassBuilder;
function $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  if ((!$thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0)) {
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated = new $c_ju_regex_PatternCompiler$CompiledCharClass((1 ^ $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_kind), $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_data);
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = true
  };
  return $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CompiledCharClass(kind, data) {
  this.ju_regex_PatternCompiler$CompiledCharClass__f_negated = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = 0;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = false;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = kind;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = data
}
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.constructor = $c_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $h_ju_regex_PatternCompiler$CompiledCharClass() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler$CompiledCharClass.prototype = $c_ju_regex_PatternCompiler$CompiledCharClass.prototype;
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.negated__ju_regex_PatternCompiler$CompiledCharClass = (function() {
  return ((!this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0) ? $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass(this) : this.ju_regex_PatternCompiler$CompiledCharClass__f_negated)
});
function $as_ju_regex_PatternCompiler$CompiledCharClass(obj) {
  return (((obj instanceof $c_ju_regex_PatternCompiler$CompiledCharClass) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.regex.PatternCompiler$CompiledCharClass"))
}
function $isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_regex_PatternCompiler$CompiledCharClass)))
}
function $asArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (($isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.regex.PatternCompiler$CompiledCharClass;", depth))
}
var $d_ju_regex_PatternCompiler$CompiledCharClass = new $TypeData().initClass({
  ju_regex_PatternCompiler$CompiledCharClass: 0
}, false, "java.util.regex.PatternCompiler$CompiledCharClass", {
  ju_regex_PatternCompiler$CompiledCharClass: 1,
  O: 1
});
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.$classData = $d_ju_regex_PatternCompiler$CompiledCharClass;
function $p_Llocales_DefaultLocale$__window$lzycompute__Llocales_Window($thiz) {
  if ((!$thiz.Llocales_DefaultLocale$__f_bitmap$0)) {
    $thiz.Llocales_DefaultLocale$__f_window = window;
    $thiz.Llocales_DefaultLocale$__f_bitmap$0 = true
  };
  return $thiz.Llocales_DefaultLocale$__f_window
}
/** @constructor */
function $c_Llocales_DefaultLocale$() {
  this.Llocales_DefaultLocale$__f_window = null;
  this.Llocales_DefaultLocale$__f_bitmap$0 = false
}
$c_Llocales_DefaultLocale$.prototype = new $h_O();
$c_Llocales_DefaultLocale$.prototype.constructor = $c_Llocales_DefaultLocale$;
/** @constructor */
function $h_Llocales_DefaultLocale$() {
  /*<skip>*/
}
$h_Llocales_DefaultLocale$.prototype = $c_Llocales_DefaultLocale$.prototype;
$c_Llocales_DefaultLocale$.prototype.window__Llocales_Window = (function() {
  return ((!this.Llocales_DefaultLocale$__f_bitmap$0) ? $p_Llocales_DefaultLocale$__window$lzycompute__Llocales_Window(this) : this.Llocales_DefaultLocale$__f_window)
});
$c_Llocales_DefaultLocale$.prototype.platformLocale__ju_Locale = (function() {
  try {
    var lang = new $c_s_Some($as_T(this.window__Llocales_Window().navigator.language))
  } catch (e) {
    var lang = $m_s_None$()
  };
  var this$2 = $n(lang);
  if (this$2.isEmpty__Z()) {
    var $$x1 = true
  } else {
    var arg1 = this$2.get__O();
    var key = $as_T(arg1);
    var $$x1 = $n($m_Llocales_LocalesDb$().ldmls__sci_Map()).contains__O__Z(key)
  };
  var this$3 = $n(($$x1 ? this$2 : $m_s_None$()));
  var l = $as_T((this$3.isEmpty__Z() ? "en" : this$3.get__O()));
  var this$4 = $n($m_Llocales_LocalesDb$().localeForLanguageTag__T__s_Option(l));
  return $as_ju_Locale((this$4.isEmpty__Z() ? $n($m_Llocales_LocalesDb$().root__Llocales_cldr_LDML()).toLocale__ju_Locale() : this$4.get__O()))
});
var $d_Llocales_DefaultLocale$ = new $TypeData().initClass({
  Llocales_DefaultLocale$: 0
}, false, "locales.DefaultLocale$", {
  Llocales_DefaultLocale$: 1,
  O: 1
});
$c_Llocales_DefaultLocale$.prototype.$classData = $d_Llocales_DefaultLocale$;
var $n_Llocales_DefaultLocale$;
function $m_Llocales_DefaultLocale$() {
  if ((!$n_Llocales_DefaultLocale$)) {
    $n_Llocales_DefaultLocale$ = new $c_Llocales_DefaultLocale$()
  };
  return $n_Llocales_DefaultLocale$
}
/** @constructor */
function $c_Llocales_LocalesDb$() {
  this.Llocales_LocalesDb$__f_provider = null;
  this.Llocales_LocalesDb$__f_root = null;
  this.Llocales_LocalesDb$__f_ldmls = null;
  this.Llocales_LocalesDb$__f_bitmap$init$0 = 0;
  $n_Llocales_LocalesDb$ = this;
  var this$2 = $n($m_sjs_reflect_Reflect$().lookupLoadableModuleClass__T__s_Option("locales.cldr.data.LocalesProvider$"));
  if (this$2.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var m = $as_sjs_reflect_LoadableModuleClass(arg1);
    var $$x1 = new $c_s_Some($as_Llocales_cldr_LocalesProvider($n(m).loadModule__O()))
  };
  var this$3 = $n($$x1);
  this.Llocales_LocalesDb$__f_provider = $as_Llocales_cldr_LocalesProvider((this$3.isEmpty__Z() ? $m_Llocales_cldr_fallback_LocalesProvider$() : this$3.get__O()));
  this.Llocales_LocalesDb$__f_bitmap$init$0 = (((1 | this.Llocales_LocalesDb$__f_bitmap$init$0) << 24) >> 24);
  this.Llocales_LocalesDb$__f_root = $n(this.provider__Llocales_cldr_LocalesProvider()).root__Llocales_cldr_LDML();
  this.Llocales_LocalesDb$__f_bitmap$init$0 = (((2 | this.Llocales_LocalesDb$__f_bitmap$init$0) << 24) >> 24);
  $n(this.provider__Llocales_cldr_LocalesProvider()).latn__Llocales_cldr_NumberingSystem();
  this.Llocales_LocalesDb$__f_bitmap$init$0 = (((4 | this.Llocales_LocalesDb$__f_bitmap$init$0) << 24) >> 24);
  this.Llocales_LocalesDb$__f_ldmls = $n(this.provider__Llocales_cldr_LocalesProvider()).ldmls__sci_Map();
  this.Llocales_LocalesDb$__f_bitmap$init$0 = (((8 | this.Llocales_LocalesDb$__f_bitmap$init$0) << 24) >> 24);
  $n(this.provider__Llocales_cldr_LocalesProvider()).metadata__Llocales_cldr_CLDRMetadata();
  this.Llocales_LocalesDb$__f_bitmap$init$0 = (((16 | this.Llocales_LocalesDb$__f_bitmap$init$0) << 24) >> 24);
  $n(this.provider__Llocales_cldr_LocalesProvider()).currencyData__Llocales_cldr_CurrencyData();
  this.Llocales_LocalesDb$__f_bitmap$init$0 = (((32 | this.Llocales_LocalesDb$__f_bitmap$init$0) << 24) >> 24)
}
$c_Llocales_LocalesDb$.prototype = new $h_O();
$c_Llocales_LocalesDb$.prototype.constructor = $c_Llocales_LocalesDb$;
/** @constructor */
function $h_Llocales_LocalesDb$() {
  /*<skip>*/
}
$h_Llocales_LocalesDb$.prototype = $c_Llocales_LocalesDb$.prototype;
$c_Llocales_LocalesDb$.prototype.provider__Llocales_cldr_LocalesProvider = (function() {
  if (((((1 & this.Llocales_LocalesDb$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-locales/scala-java-locales/core/shared/src/main/scala/locales/LocalesDb.scala: 12")
  };
  return this.Llocales_LocalesDb$__f_provider
});
$c_Llocales_LocalesDb$.prototype.root__Llocales_cldr_LDML = (function() {
  if (((((2 & this.Llocales_LocalesDb$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-locales/scala-java-locales/core/shared/src/main/scala/locales/LocalesDb.scala: 21")
  };
  return this.Llocales_LocalesDb$__f_root
});
$c_Llocales_LocalesDb$.prototype.ldmls__sci_Map = (function() {
  if (((((8 & this.Llocales_LocalesDb$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-locales/scala-java-locales/core/shared/src/main/scala/locales/LocalesDb.scala: 25")
  };
  return this.Llocales_LocalesDb$__f_ldmls
});
$c_Llocales_LocalesDb$.prototype.localeForLanguageTag__T__s_Option = (function(languageTag) {
  if ((languageTag === "und")) {
    return new $c_s_Some($m_ju_Locale$().ROOT__ju_Locale())
  } else {
    var this$1 = $n($n($n(this.provider__Llocales_cldr_LocalesProvider()).ldmls__sci_Map()).get__O__s_Option(languageTag));
    if (this$1.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$1.get__O();
      var x$1 = $as_Llocales_cldr_LDML(arg1);
      return new $c_s_Some($n(x$1).toLocale__ju_Locale())
    }
  }
});
$c_Llocales_LocalesDb$.prototype.ldml__ju_Locale__s_Option = (function(locale) {
  var tag = (($n(locale).toLanguageTag__T() === "zh-CN") ? "zh-Hans-CN" : (($n(locale).toLanguageTag__T() === "zh-TW") ? "zh-Hant-TW" : $n(locale).toLanguageTag__T()));
  return $n($n(this.provider__Llocales_cldr_LocalesProvider()).ldmls__sci_Map()).get__O__s_Option(tag)
});
var $d_Llocales_LocalesDb$ = new $TypeData().initClass({
  Llocales_LocalesDb$: 0
}, false, "locales.LocalesDb$", {
  Llocales_LocalesDb$: 1,
  O: 1
});
$c_Llocales_LocalesDb$.prototype.$classData = $d_Llocales_LocalesDb$;
var $n_Llocales_LocalesDb$;
function $m_Llocales_LocalesDb$() {
  if ((!$n_Llocales_LocalesDb$)) {
    $n_Llocales_LocalesDb$ = new $c_Llocales_LocalesDb$()
  };
  return $n_Llocales_LocalesDb$
}
function $is_Llocales_cldr_LocalesProvider(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llocales_cldr_LocalesProvider)))
}
function $as_Llocales_cldr_LocalesProvider(obj) {
  return (($is_Llocales_cldr_LocalesProvider(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.LocalesProvider"))
}
function $isArrayOf_Llocales_cldr_LocalesProvider(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LocalesProvider)))
}
function $asArrayOf_Llocales_cldr_LocalesProvider(obj, depth) {
  return (($isArrayOf_Llocales_cldr_LocalesProvider(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.LocalesProvider;", depth))
}
function $p_Llocales_cldr_data_\uff3fall\uff3f$__all$lzycompute__ALlocales_cldr_LDML($thiz) {
  if ((!$thiz.Llocales_cldr_data_\uff3fall\uff3f$__f_bitmap$0)) {
    $thiz.Llocales_cldr_data_\uff3fall\uff3f$__f_all = new ($d_Llocales_cldr_LDML.getArrayOf().constr)([$m_Llocales_cldr_data_\uff3fen$(), $m_Llocales_cldr_data_\uff3ffr$(), $m_Llocales_cldr_data_\uff3froot$(), $m_Llocales_cldr_data_\uff3ffr\uff3fFR$()]);
    $thiz.Llocales_cldr_data_\uff3fall\uff3f$__f_bitmap$0 = true
  };
  return $thiz.Llocales_cldr_data_\uff3fall\uff3f$__f_all
}
/** @constructor */
function $c_Llocales_cldr_data_\uff3fall\uff3f$() {
  this.Llocales_cldr_data_\uff3fall\uff3f$__f_all = null;
  this.Llocales_cldr_data_\uff3fall\uff3f$__f_bitmap$0 = false
}
$c_Llocales_cldr_data_\uff3fall\uff3f$.prototype = new $h_O();
$c_Llocales_cldr_data_\uff3fall\uff3f$.prototype.constructor = $c_Llocales_cldr_data_\uff3fall\uff3f$;
/** @constructor */
function $h_Llocales_cldr_data_\uff3fall\uff3f$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_\uff3fall\uff3f$.prototype = $c_Llocales_cldr_data_\uff3fall\uff3f$.prototype;
$c_Llocales_cldr_data_\uff3fall\uff3f$.prototype.all__ALlocales_cldr_LDML = (function() {
  return ((!this.Llocales_cldr_data_\uff3fall\uff3f$__f_bitmap$0) ? $p_Llocales_cldr_data_\uff3fall\uff3f$__all$lzycompute__ALlocales_cldr_LDML(this) : this.Llocales_cldr_data_\uff3fall\uff3f$__f_all)
});
var $d_Llocales_cldr_data_\uff3fall\uff3f$ = new $TypeData().initClass({
  Llocales_cldr_data_\uff3fall\uff3f$: 0
}, false, "locales.cldr.data._all_$", {
  Llocales_cldr_data_\uff3fall\uff3f$: 1,
  O: 1
});
$c_Llocales_cldr_data_\uff3fall\uff3f$.prototype.$classData = $d_Llocales_cldr_data_\uff3fall\uff3f$;
var $n_Llocales_cldr_data_\uff3fall\uff3f$;
function $m_Llocales_cldr_data_\uff3fall\uff3f$() {
  if ((!$n_Llocales_cldr_data_\uff3fall\uff3f$)) {
    $n_Llocales_cldr_data_\uff3fall\uff3f$ = new $c_Llocales_cldr_data_\uff3fall\uff3f$()
  };
  return $n_Llocales_cldr_data_\uff3fall\uff3f$
}
/** @constructor */
function $c_Llocales_cldr_data_\uff3fen\uff3fdata$() {
  /*<skip>*/
}
$c_Llocales_cldr_data_\uff3fen\uff3fdata$.prototype = new $h_O();
$c_Llocales_cldr_data_\uff3fen\uff3fdata$.prototype.constructor = $c_Llocales_cldr_data_\uff3fen\uff3fdata$;
/** @constructor */
function $h_Llocales_cldr_data_\uff3fen\uff3fdata$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_\uff3fen\uff3fdata$.prototype = $c_Llocales_cldr_data_\uff3fen\uff3fdata$.prototype;
$c_Llocales_cldr_data_\uff3fen\uff3fdata$.prototype.currencies__sci_List = (function() {
  $n($m_s_package$().s_package$__f_List);
  var $$x1 = $m_sci_Nil$();
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Llocales_cldr_CurrencyDisplayName("Euro", $m_s_None$()), new $c_Llocales_cldr_CurrencyDisplayName("euro", new $c_s_Some("one")), new $c_Llocales_cldr_CurrencyDisplayName("euros", new $c_s_Some("other"))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [new $c_Llocales_cldr_NumberCurrency("EUR", $$x1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems))];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)
});
$c_Llocales_cldr_data_\uff3fen\uff3fdata$.prototype.symbols__sci_List = (function() {
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Llocales_cldr_Symbols($m_Llocales_cldr_data_numericsystems$().latn__Llocales_cldr_NumberingSystem(), $m_s_None$(), new $c_s_Some($bC(46)), new $c_s_Some($bC(44)), new $c_s_Some($bC(59)), new $c_s_Some($bC(37)), new $c_s_Some($bC(45)), new $c_s_Some($bC(8240)), new $c_s_Some("\u221e"), new $c_s_Some("NaN"), new $c_s_Some("E"))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
var $d_Llocales_cldr_data_\uff3fen\uff3fdata$ = new $TypeData().initClass({
  Llocales_cldr_data_\uff3fen\uff3fdata$: 0
}, false, "locales.cldr.data._en_data$", {
  Llocales_cldr_data_\uff3fen\uff3fdata$: 1,
  O: 1
});
$c_Llocales_cldr_data_\uff3fen\uff3fdata$.prototype.$classData = $d_Llocales_cldr_data_\uff3fen\uff3fdata$;
var $n_Llocales_cldr_data_\uff3fen\uff3fdata$;
function $m_Llocales_cldr_data_\uff3fen\uff3fdata$() {
  if ((!$n_Llocales_cldr_data_\uff3fen\uff3fdata$)) {
    $n_Llocales_cldr_data_\uff3fen\uff3fdata$ = new $c_Llocales_cldr_data_\uff3fen\uff3fdata$()
  };
  return $n_Llocales_cldr_data_\uff3fen\uff3fdata$
}
/** @constructor */
function $c_Llocales_cldr_data_\uff3ffr\uff3fdata$() {
  /*<skip>*/
}
$c_Llocales_cldr_data_\uff3ffr\uff3fdata$.prototype = new $h_O();
$c_Llocales_cldr_data_\uff3ffr\uff3fdata$.prototype.constructor = $c_Llocales_cldr_data_\uff3ffr\uff3fdata$;
/** @constructor */
function $h_Llocales_cldr_data_\uff3ffr\uff3fdata$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_\uff3ffr\uff3fdata$.prototype = $c_Llocales_cldr_data_\uff3ffr\uff3fdata$.prototype;
$c_Llocales_cldr_data_\uff3ffr\uff3fdata$.prototype.currencies__sci_List = (function() {
  $n($m_s_package$().s_package$__f_List);
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Llocales_cldr_CurrencySymbol("\u20ac", $m_s_None$()), new $c_Llocales_cldr_CurrencySymbol("\u20ac", new $c_s_Some("narrow"))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $n($m_s_package$().s_package$__f_List);
  var array$1 = [new $c_Llocales_cldr_CurrencyDisplayName("euro", $m_s_None$()), new $c_Llocales_cldr_CurrencyDisplayName("euro", new $c_s_Some("one")), new $c_Llocales_cldr_CurrencyDisplayName("euros", new $c_s_Some("other"))];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var array$2 = [new $c_Llocales_cldr_NumberCurrency("EUR", $$x1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1))];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2)
});
$c_Llocales_cldr_data_\uff3ffr\uff3fdata$.prototype.symbols__sci_List = (function() {
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Llocales_cldr_Symbols($m_Llocales_cldr_data_numericsystems$().latn__Llocales_cldr_NumberingSystem(), $m_s_None$(), new $c_s_Some($bC(44)), new $c_s_Some($bC(8239)), new $c_s_Some($bC(59)), new $c_s_Some($bC(37)), new $c_s_Some($bC(45)), new $c_s_Some($bC(8240)), new $c_s_Some("\u221e"), new $c_s_Some("NaN"), new $c_s_Some("E"))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
var $d_Llocales_cldr_data_\uff3ffr\uff3fdata$ = new $TypeData().initClass({
  Llocales_cldr_data_\uff3ffr\uff3fdata$: 0
}, false, "locales.cldr.data._fr_data$", {
  Llocales_cldr_data_\uff3ffr\uff3fdata$: 1,
  O: 1
});
$c_Llocales_cldr_data_\uff3ffr\uff3fdata$.prototype.$classData = $d_Llocales_cldr_data_\uff3ffr\uff3fdata$;
var $n_Llocales_cldr_data_\uff3ffr\uff3fdata$;
function $m_Llocales_cldr_data_\uff3ffr\uff3fdata$() {
  if ((!$n_Llocales_cldr_data_\uff3ffr\uff3fdata$)) {
    $n_Llocales_cldr_data_\uff3ffr\uff3fdata$ = new $c_Llocales_cldr_data_\uff3ffr\uff3fdata$()
  };
  return $n_Llocales_cldr_data_\uff3ffr\uff3fdata$
}
/** @constructor */
function $c_Llocales_cldr_data_\uff3froot\uff3fdata$() {
  /*<skip>*/
}
$c_Llocales_cldr_data_\uff3froot\uff3fdata$.prototype = new $h_O();
$c_Llocales_cldr_data_\uff3froot\uff3fdata$.prototype.constructor = $c_Llocales_cldr_data_\uff3froot\uff3fdata$;
/** @constructor */
function $h_Llocales_cldr_data_\uff3froot\uff3fdata$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_\uff3froot\uff3fdata$.prototype = $c_Llocales_cldr_data_\uff3froot\uff3fdata$.prototype;
$c_Llocales_cldr_data_\uff3froot\uff3fdata$.prototype.currencies__sci_List = (function() {
  $n($m_s_package$().s_package$__f_List);
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Llocales_cldr_CurrencySymbol("\u20ac", $m_s_None$()), new $c_Llocales_cldr_CurrencySymbol("\u20ac", new $c_s_Some("narrow"))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [new $c_Llocales_cldr_NumberCurrency("EUR", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), $m_sci_Nil$())];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)
});
$c_Llocales_cldr_data_\uff3froot\uff3fdata$.prototype.symbols__sci_List = (function() {
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Llocales_cldr_Symbols($m_Llocales_cldr_data_numericsystems$().latn__Llocales_cldr_NumberingSystem(), $m_s_None$(), new $c_s_Some($bC(46)), new $c_s_Some($bC(44)), new $c_s_Some($bC(59)), new $c_s_Some($bC(37)), new $c_s_Some($bC(45)), new $c_s_Some($bC(8240)), new $c_s_Some("\u221e"), new $c_s_Some("NaN"), new $c_s_Some("E"))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
var $d_Llocales_cldr_data_\uff3froot\uff3fdata$ = new $TypeData().initClass({
  Llocales_cldr_data_\uff3froot\uff3fdata$: 0
}, false, "locales.cldr.data._root_data$", {
  Llocales_cldr_data_\uff3froot\uff3fdata$: 1,
  O: 1
});
$c_Llocales_cldr_data_\uff3froot\uff3fdata$.prototype.$classData = $d_Llocales_cldr_data_\uff3froot\uff3fdata$;
var $n_Llocales_cldr_data_\uff3froot\uff3fdata$;
function $m_Llocales_cldr_data_\uff3froot\uff3fdata$() {
  if ((!$n_Llocales_cldr_data_\uff3froot\uff3fdata$)) {
    $n_Llocales_cldr_data_\uff3froot\uff3fdata$ = new $c_Llocales_cldr_data_\uff3froot\uff3fdata$()
  };
  return $n_Llocales_cldr_data_\uff3froot\uff3fdata$
}
/** @constructor */
function $c_Llocales_cldr_data_currencydata$() {
  this.Llocales_cldr_data_currencydata$__f_currencyTypes = null;
  this.Llocales_cldr_data_currencydata$__f_fractions = null;
  this.Llocales_cldr_data_currencydata$__f_regions = null;
  this.Llocales_cldr_data_currencydata$__f_numericCodes = null;
  $n_Llocales_cldr_data_currencydata$ = this;
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Llocales_cldr_CurrencyType("EUR", "Euro")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Llocales_cldr_data_currencydata$__f_currencyTypes = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $n($m_s_package$().s_package$__f_List);
  var array$1 = [new $c_Llocales_cldr_CurrencyDataFractionsInfo("DEFAULT", 2, 0, $m_s_None$(), $m_s_None$())];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Llocales_cldr_data_currencydata$__f_fractions = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  $n($m_s_package$().s_package$__f_List);
  $n($m_s_package$().s_package$__f_List);
  var array$2 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var $$x38 = new $c_Llocales_cldr_CurrencyDataRegion("AT", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2));
  $n($m_s_package$().s_package$__f_List);
  var array$3 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2002-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var $$x37 = new $c_Llocales_cldr_CurrencyDataRegion("ME", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3));
  $n($m_s_package$().s_package$__f_List);
  var array$4 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var $$x36 = new $c_Llocales_cldr_CurrencyDataRegion("ES", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4));
  $n($m_s_package$().s_package$__f_List);
  var array$5 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var $$x35 = new $c_Llocales_cldr_CurrencyDataRegion("SM", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5));
  $n($m_s_package$().s_package$__f_List);
  var array$6 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var $$x34 = new $c_Llocales_cldr_CurrencyDataRegion("BL", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$6));
  $n($m_s_package$().s_package$__f_List);
  var array$7 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var $$x33 = new $c_Llocales_cldr_CurrencyDataRegion("GP", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$7));
  $n($m_s_package$().s_package$__f_List);
  var array$8 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var $$x32 = new $c_Llocales_cldr_CurrencyDataRegion("AX", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$8));
  $n($m_s_package$().s_package$__f_List);
  var array$9 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var $$x31 = new $c_Llocales_cldr_CurrencyDataRegion("EA", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$9));
  $n($m_s_package$().s_package$__f_List);
  var array$10 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2007-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var $$x30 = new $c_Llocales_cldr_CurrencyDataRegion("SI", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$10));
  $n($m_s_package$().s_package$__f_List);
  var array$11 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var $$x29 = new $c_Llocales_cldr_CurrencyDataRegion("AD", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$11));
  $n($m_s_package$().s_package$__f_List);
  var array$12 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var $$x28 = new $c_Llocales_cldr_CurrencyDataRegion("LU", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$12));
  $n($m_s_package$().s_package$__f_List);
  var array$13 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var $$x27 = new $c_Llocales_cldr_CurrencyDataRegion("IE", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$13));
  $n($m_s_package$().s_package$__f_List);
  var array$14 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var $$x26 = new $c_Llocales_cldr_CurrencyDataRegion("BE", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$14));
  $n($m_s_package$().s_package$__f_List);
  var array$15 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var $$x25 = new $c_Llocales_cldr_CurrencyDataRegion("FI", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$15));
  $n($m_s_package$().s_package$__f_List);
  var array$16 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2011-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var $$x24 = new $c_Llocales_cldr_CurrencyDataRegion("EE", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$16));
  $n($m_s_package$().s_package$__f_List);
  var array$17 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2015-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var $$x23 = new $c_Llocales_cldr_CurrencyDataRegion("LT", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$17));
  $n($m_s_package$().s_package$__f_List);
  var array$18 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  var $$x22 = new $c_Llocales_cldr_CurrencyDataRegion("TF", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$18));
  $n($m_s_package$().s_package$__f_List);
  var array$19 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2014-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$19 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19);
  var $$x21 = new $c_Llocales_cldr_CurrencyDataRegion("LV", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$19));
  $n($m_s_package$().s_package$__f_List);
  var array$20 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2008-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$20 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20);
  var $$x20 = new $c_Llocales_cldr_CurrencyDataRegion("CY", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$20));
  $n($m_s_package$().s_package$__f_List);
  var array$21 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$21 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21);
  var $$x19 = new $c_Llocales_cldr_CurrencyDataRegion("MF", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$21));
  $n($m_s_package$().s_package$__f_List);
  var array$22 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$22 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22);
  var $$x18 = new $c_Llocales_cldr_CurrencyDataRegion("PM", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$22));
  $n($m_s_package$().s_package$__f_List);
  var array$23 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$23 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23);
  var $$x17 = new $c_Llocales_cldr_CurrencyDataRegion("FR", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$23));
  $n($m_s_package$().s_package$__f_List);
  var array$24 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$24 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24);
  var $$x16 = new $c_Llocales_cldr_CurrencyDataRegion("GF", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$24));
  $n($m_s_package$().s_package$__f_List);
  var array$25 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2008-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$25 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25);
  var $$x15 = new $c_Llocales_cldr_CurrencyDataRegion("MT", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$25));
  $n($m_s_package$().s_package$__f_List);
  var array$26 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$26 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$26);
  var $$x14 = new $c_Llocales_cldr_CurrencyDataRegion("PT", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$26));
  $n($m_s_package$().s_package$__f_List);
  var array$27 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2003-02-04"), new $c_s_Some("2006-06-03"), $m_s_None$())];
  var elems$27 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$27);
  var $$x13 = new $c_Llocales_cldr_CurrencyDataRegion("CS", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$27));
  $n($m_s_package$().s_package$__f_List);
  var array$28 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$28 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$28);
  var $$x12 = new $c_Llocales_cldr_CurrencyDataRegion("EU", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$28));
  $n($m_s_package$().s_package$__f_List);
  var array$29 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$29 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$29);
  var $$x11 = new $c_Llocales_cldr_CurrencyDataRegion("MC", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$29));
  $n($m_s_package$().s_package$__f_List);
  var array$30 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$30 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$30);
  var $$x10 = new $c_Llocales_cldr_CurrencyDataRegion("MQ", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$30));
  $n($m_s_package$().s_package$__f_List);
  var array$31 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$31 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$31);
  var $$x9 = new $c_Llocales_cldr_CurrencyDataRegion("YT", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$31));
  $n($m_s_package$().s_package$__f_List);
  var array$32 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$32 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$32);
  var $$x8 = new $c_Llocales_cldr_CurrencyDataRegion("IT", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$32));
  $n($m_s_package$().s_package$__f_List);
  var array$33 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$33 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$33);
  var $$x7 = new $c_Llocales_cldr_CurrencyDataRegion("RE", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$33));
  $n($m_s_package$().s_package$__f_List);
  var array$34 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2001-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$34 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$34);
  var $$x6 = new $c_Llocales_cldr_CurrencyDataRegion("GR", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$34));
  $n($m_s_package$().s_package$__f_List);
  var array$35 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2009-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$35 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$35);
  var $$x5 = new $c_Llocales_cldr_CurrencyDataRegion("SK", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$35));
  $n($m_s_package$().s_package$__f_List);
  var array$36 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$36 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$36);
  var $$x4 = new $c_Llocales_cldr_CurrencyDataRegion("IC", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$36));
  $n($m_s_package$().s_package$__f_List);
  var array$37 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$37 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$37);
  var $$x3 = new $c_Llocales_cldr_CurrencyDataRegion("NL", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$37));
  $n($m_s_package$().s_package$__f_List);
  var array$38 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$38 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$38);
  var $$x2 = new $c_Llocales_cldr_CurrencyDataRegion("VA", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$38));
  $n($m_s_package$().s_package$__f_List);
  var array$39 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("2002-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$39 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$39);
  var $$x1 = new $c_Llocales_cldr_CurrencyDataRegion("XK", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$39));
  $n($m_s_package$().s_package$__f_List);
  var array$40 = [new $c_Llocales_cldr_CurrencyDataRegionCurrency("EUR", new $c_s_Some("1999-01-01"), $m_s_None$(), $m_s_None$())];
  var elems$40 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$40);
  var array$41 = [$$x38, $$x37, $$x36, $$x35, $$x34, $$x33, $$x32, $$x31, $$x30, $$x29, $$x28, $$x27, $$x26, $$x25, $$x24, $$x23, $$x22, $$x21, $$x20, $$x19, $$x18, $$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Llocales_cldr_CurrencyDataRegion("DE", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$40))];
  var elems$41 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$41);
  this.Llocales_cldr_data_currencydata$__f_regions = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$41);
  $n($m_s_package$().s_package$__f_List);
  var array$42 = [new $c_Llocales_cldr_CurrencyNumericCode("EUR", 978)];
  var elems$42 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$42);
  this.Llocales_cldr_data_currencydata$__f_numericCodes = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$42)
}
$c_Llocales_cldr_data_currencydata$.prototype = new $h_O();
$c_Llocales_cldr_data_currencydata$.prototype.constructor = $c_Llocales_cldr_data_currencydata$;
/** @constructor */
function $h_Llocales_cldr_data_currencydata$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_currencydata$.prototype = $c_Llocales_cldr_data_currencydata$.prototype;
var $d_Llocales_cldr_data_currencydata$ = new $TypeData().initClass({
  Llocales_cldr_data_currencydata$: 0
}, false, "locales.cldr.data.currencydata$", {
  Llocales_cldr_data_currencydata$: 1,
  O: 1
});
$c_Llocales_cldr_data_currencydata$.prototype.$classData = $d_Llocales_cldr_data_currencydata$;
var $n_Llocales_cldr_data_currencydata$;
function $m_Llocales_cldr_data_currencydata$() {
  if ((!$n_Llocales_cldr_data_currencydata$)) {
    $n_Llocales_cldr_data_currencydata$ = new $c_Llocales_cldr_data_currencydata$()
  };
  return $n_Llocales_cldr_data_currencydata$
}
function $p_Llocales_cldr_data_metadata$__isoCountries$lzycompute__AT($thiz) {
  if (((((1 & $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Llocales_cldr_data_metadata$__f_isoCountries = new ($d_T.getArrayOf().constr)(["FR"]);
    $thiz.Llocales_cldr_data_metadata$__f_bitmap$0 = (((1 | $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Llocales_cldr_data_metadata$__f_isoCountries
}
function $p_Llocales_cldr_data_metadata$__isoLanguages$lzycompute__AT($thiz) {
  if (((((2 & $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Llocales_cldr_data_metadata$__f_isoLanguages = new ($d_T.getArrayOf().constr)(["en", "fr"]);
    $thiz.Llocales_cldr_data_metadata$__f_bitmap$0 = (((2 | $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Llocales_cldr_data_metadata$__f_isoLanguages
}
function $p_Llocales_cldr_data_metadata$__iso3Countries$lzycompute__sci_Map($thiz) {
  if (((((4 & $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$6 = $n($m_s_Predef$().s_Predef$__f_Map);
    var array = [$ct_T2__O__O__(new $c_T2(), "FR", "FRA")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Llocales_cldr_data_metadata$__f_iso3Countries = this$6.from__sc_IterableOnce__sci_Map(elems);
    $thiz.Llocales_cldr_data_metadata$__f_bitmap$0 = (((4 | $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Llocales_cldr_data_metadata$__f_iso3Countries
}
function $p_Llocales_cldr_data_metadata$__iso3Languages$lzycompute__sci_Map($thiz) {
  if (((((8 & $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$8 = $n($m_s_Predef$().s_Predef$__f_Map);
    var array = [$ct_T2__O__O__(new $c_T2(), "fr", "fra"), $ct_T2__O__O__(new $c_T2(), "en", "eng")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Llocales_cldr_data_metadata$__f_iso3Languages = this$8.from__sc_IterableOnce__sci_Map(elems);
    $thiz.Llocales_cldr_data_metadata$__f_bitmap$0 = (((8 | $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Llocales_cldr_data_metadata$__f_iso3Languages
}
function $p_Llocales_cldr_data_metadata$__scripts$lzycompute__AT($thiz) {
  if (((((16 & $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0)) {
    var xs = $m_sci_Nil$();
    var len = xs.length__I();
    var array = new ($d_T.getArrayOf().constr)(len);
    var iterator = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i = 0;
    while ($n(iterator).hasNext__Z()) {
      array.set(i, $n(iterator).next__O());
      i = ((1 + i) | 0)
    };
    $thiz.Llocales_cldr_data_metadata$__f_scripts = array;
    $thiz.Llocales_cldr_data_metadata$__f_bitmap$0 = (((16 | $thiz.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Llocales_cldr_data_metadata$__f_scripts
}
/** @constructor */
function $c_Llocales_cldr_data_metadata$() {
  this.Llocales_cldr_data_metadata$__f_isoCountries = null;
  this.Llocales_cldr_data_metadata$__f_isoLanguages = null;
  this.Llocales_cldr_data_metadata$__f_iso3Countries = null;
  this.Llocales_cldr_data_metadata$__f_iso3Languages = null;
  this.Llocales_cldr_data_metadata$__f_scripts = null;
  this.Llocales_cldr_data_metadata$__f_bitmap$0 = 0
}
$c_Llocales_cldr_data_metadata$.prototype = new $h_O();
$c_Llocales_cldr_data_metadata$.prototype.constructor = $c_Llocales_cldr_data_metadata$;
/** @constructor */
function $h_Llocales_cldr_data_metadata$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_metadata$.prototype = $c_Llocales_cldr_data_metadata$.prototype;
$c_Llocales_cldr_data_metadata$.prototype.isoCountries__AT = (function() {
  return (((((1 & this.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Llocales_cldr_data_metadata$__isoCountries$lzycompute__AT(this) : this.Llocales_cldr_data_metadata$__f_isoCountries)
});
$c_Llocales_cldr_data_metadata$.prototype.isoLanguages__AT = (function() {
  return (((((2 & this.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Llocales_cldr_data_metadata$__isoLanguages$lzycompute__AT(this) : this.Llocales_cldr_data_metadata$__f_isoLanguages)
});
$c_Llocales_cldr_data_metadata$.prototype.iso3Countries__sci_Map = (function() {
  return (((((4 & this.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Llocales_cldr_data_metadata$__iso3Countries$lzycompute__sci_Map(this) : this.Llocales_cldr_data_metadata$__f_iso3Countries)
});
$c_Llocales_cldr_data_metadata$.prototype.iso3Languages__sci_Map = (function() {
  return (((((8 & this.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Llocales_cldr_data_metadata$__iso3Languages$lzycompute__sci_Map(this) : this.Llocales_cldr_data_metadata$__f_iso3Languages)
});
$c_Llocales_cldr_data_metadata$.prototype.scripts__AT = (function() {
  return (((((16 & this.Llocales_cldr_data_metadata$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Llocales_cldr_data_metadata$__scripts$lzycompute__AT(this) : this.Llocales_cldr_data_metadata$__f_scripts)
});
var $d_Llocales_cldr_data_metadata$ = new $TypeData().initClass({
  Llocales_cldr_data_metadata$: 0
}, false, "locales.cldr.data.metadata$", {
  Llocales_cldr_data_metadata$: 1,
  O: 1
});
$c_Llocales_cldr_data_metadata$.prototype.$classData = $d_Llocales_cldr_data_metadata$;
var $n_Llocales_cldr_data_metadata$;
function $m_Llocales_cldr_data_metadata$() {
  if ((!$n_Llocales_cldr_data_metadata$)) {
    $n_Llocales_cldr_data_metadata$ = new $c_Llocales_cldr_data_metadata$()
  };
  return $n_Llocales_cldr_data_metadata$
}
function $p_Llocales_cldr_data_numericsystems$__latn$lzycompute__Llocales_cldr_NumberingSystem($thiz) {
  if ((!$thiz.Llocales_cldr_data_numericsystems$__f_bitmap$0)) {
    $n($m_s_package$().s_package$__f_List);
    var array = [$bC(48), $bC(49), $bC(50), $bC(51), $bC(52), $bC(53), $bC(54), $bC(55), $bC(56), $bC(57)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Llocales_cldr_data_numericsystems$__f_latn = new $c_Llocales_cldr_NumberingSystem("latn", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
    $thiz.Llocales_cldr_data_numericsystems$__f_bitmap$0 = true
  };
  return $thiz.Llocales_cldr_data_numericsystems$__f_latn
}
/** @constructor */
function $c_Llocales_cldr_data_numericsystems$() {
  this.Llocales_cldr_data_numericsystems$__f_latn = null;
  this.Llocales_cldr_data_numericsystems$__f_bitmap$0 = false
}
$c_Llocales_cldr_data_numericsystems$.prototype = new $h_O();
$c_Llocales_cldr_data_numericsystems$.prototype.constructor = $c_Llocales_cldr_data_numericsystems$;
/** @constructor */
function $h_Llocales_cldr_data_numericsystems$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_numericsystems$.prototype = $c_Llocales_cldr_data_numericsystems$.prototype;
$c_Llocales_cldr_data_numericsystems$.prototype.latn__Llocales_cldr_NumberingSystem = (function() {
  return ((!this.Llocales_cldr_data_numericsystems$__f_bitmap$0) ? $p_Llocales_cldr_data_numericsystems$__latn$lzycompute__Llocales_cldr_NumberingSystem(this) : this.Llocales_cldr_data_numericsystems$__f_latn)
});
var $d_Llocales_cldr_data_numericsystems$ = new $TypeData().initClass({
  Llocales_cldr_data_numericsystems$: 0
}, false, "locales.cldr.data.numericsystems$", {
  Llocales_cldr_data_numericsystems$: 1,
  O: 1
});
$c_Llocales_cldr_data_numericsystems$.prototype.$classData = $d_Llocales_cldr_data_numericsystems$;
var $n_Llocales_cldr_data_numericsystems$;
function $m_Llocales_cldr_data_numericsystems$() {
  if ((!$n_Llocales_cldr_data_numericsystems$)) {
    $n_Llocales_cldr_data_numericsystems$ = new $c_Llocales_cldr_data_numericsystems$()
  };
  return $n_Llocales_cldr_data_numericsystems$
}
function $p_Llocales_cldr_fallback_data_\uff3fall\uff3f$__all$lzycompute__ALlocales_cldr_LDML($thiz) {
  if ((!$thiz.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_bitmap$0)) {
    $thiz.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all = new ($d_Llocales_cldr_LDML.getArrayOf().constr)([$m_Llocales_cldr_fallback_data_\uff3fen$(), $m_Llocales_cldr_fallback_data_\uff3froot$()]);
    $thiz.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_bitmap$0 = true
  };
  return $thiz.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all = null;
  this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_bitmap$0 = false
}
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = new $h_O();
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype;
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.all__ALlocales_cldr_LDML = (function() {
  return ((!this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_bitmap$0) ? $p_Llocales_cldr_fallback_data_\uff3fall\uff3f$__all$lzycompute__ALlocales_cldr_LDML(this) : this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all)
});
var $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $TypeData().initClass({
  Llocales_cldr_fallback_data_\uff3fall\uff3f$: 0
}, false, "locales.cldr.fallback.data._all_$", {
  Llocales_cldr_fallback_data_\uff3fall\uff3f$: 1,
  O: 1
});
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.$classData = $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
var $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
function $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fall\uff3f$)) {
    $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$()
  };
  return $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$
}
function $p_Llocales_cldr_fallback_data_numericsystems$__latn$lzycompute__Llocales_cldr_NumberingSystem($thiz) {
  if ((!$thiz.Llocales_cldr_fallback_data_numericsystems$__f_bitmap$0)) {
    $m_sci_List$();
    var array = [$bC(48), $bC(49), $bC(50), $bC(51), $bC(52), $bC(53), $bC(54), $bC(55), $bC(56), $bC(57)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Llocales_cldr_fallback_data_numericsystems$__f_latn = new $c_Llocales_cldr_NumberingSystem("latn", $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
    $thiz.Llocales_cldr_fallback_data_numericsystems$__f_bitmap$0 = true
  };
  return $thiz.Llocales_cldr_fallback_data_numericsystems$__f_latn
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_numericsystems$() {
  this.Llocales_cldr_fallback_data_numericsystems$__f_latn = null;
  this.Llocales_cldr_fallback_data_numericsystems$__f_bitmap$0 = false
}
$c_Llocales_cldr_fallback_data_numericsystems$.prototype = new $h_O();
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.constructor = $c_Llocales_cldr_fallback_data_numericsystems$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_numericsystems$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_data_numericsystems$.prototype = $c_Llocales_cldr_fallback_data_numericsystems$.prototype;
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.latn__Llocales_cldr_NumberingSystem = (function() {
  return ((!this.Llocales_cldr_fallback_data_numericsystems$__f_bitmap$0) ? $p_Llocales_cldr_fallback_data_numericsystems$__latn$lzycompute__Llocales_cldr_NumberingSystem(this) : this.Llocales_cldr_fallback_data_numericsystems$__f_latn)
});
var $d_Llocales_cldr_fallback_data_numericsystems$ = new $TypeData().initClass({
  Llocales_cldr_fallback_data_numericsystems$: 0
}, false, "locales.cldr.fallback.data.numericsystems$", {
  Llocales_cldr_fallback_data_numericsystems$: 1,
  O: 1
});
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.$classData = $d_Llocales_cldr_fallback_data_numericsystems$;
var $n_Llocales_cldr_fallback_data_numericsystems$;
function $m_Llocales_cldr_fallback_data_numericsystems$() {
  if ((!$n_Llocales_cldr_fallback_data_numericsystems$)) {
    $n_Llocales_cldr_fallback_data_numericsystems$ = new $c_Llocales_cldr_fallback_data_numericsystems$()
  };
  return $n_Llocales_cldr_fallback_data_numericsystems$
}
/** @constructor */
function $c_Lorg_scalajs_dom_HttpMethod$() {
  this.Lorg_scalajs_dom_HttpMethod$__f_POST = null;
  this.Lorg_scalajs_dom_HttpMethod$__f_POST = "POST"
}
$c_Lorg_scalajs_dom_HttpMethod$.prototype = new $h_O();
$c_Lorg_scalajs_dom_HttpMethod$.prototype.constructor = $c_Lorg_scalajs_dom_HttpMethod$;
/** @constructor */
function $h_Lorg_scalajs_dom_HttpMethod$() {
  /*<skip>*/
}
$h_Lorg_scalajs_dom_HttpMethod$.prototype = $c_Lorg_scalajs_dom_HttpMethod$.prototype;
var $d_Lorg_scalajs_dom_HttpMethod$ = new $TypeData().initClass({
  Lorg_scalajs_dom_HttpMethod$: 0
}, false, "org.scalajs.dom.HttpMethod$", {
  Lorg_scalajs_dom_HttpMethod$: 1,
  O: 1
});
$c_Lorg_scalajs_dom_HttpMethod$.prototype.$classData = $d_Lorg_scalajs_dom_HttpMethod$;
var $n_Lorg_scalajs_dom_HttpMethod$;
function $m_Lorg_scalajs_dom_HttpMethod$() {
  if ((!$n_Lorg_scalajs_dom_HttpMethod$)) {
    $n_Lorg_scalajs_dom_HttpMethod$ = new $c_Lorg_scalajs_dom_HttpMethod$()
  };
  return $n_Lorg_scalajs_dom_HttpMethod$
}
/** @constructor */
function $c_Lorg_scalajs_dom_IDBTransactionMode$() {
  this.Lorg_scalajs_dom_IDBTransactionMode$__f_readonly = null;
  this.Lorg_scalajs_dom_IDBTransactionMode$__f_readwrite = null;
  this.Lorg_scalajs_dom_IDBTransactionMode$__f_readonly = "readonly";
  this.Lorg_scalajs_dom_IDBTransactionMode$__f_readwrite = "readwrite"
}
$c_Lorg_scalajs_dom_IDBTransactionMode$.prototype = new $h_O();
$c_Lorg_scalajs_dom_IDBTransactionMode$.prototype.constructor = $c_Lorg_scalajs_dom_IDBTransactionMode$;
/** @constructor */
function $h_Lorg_scalajs_dom_IDBTransactionMode$() {
  /*<skip>*/
}
$h_Lorg_scalajs_dom_IDBTransactionMode$.prototype = $c_Lorg_scalajs_dom_IDBTransactionMode$.prototype;
var $d_Lorg_scalajs_dom_IDBTransactionMode$ = new $TypeData().initClass({
  Lorg_scalajs_dom_IDBTransactionMode$: 0
}, false, "org.scalajs.dom.IDBTransactionMode$", {
  Lorg_scalajs_dom_IDBTransactionMode$: 1,
  O: 1
});
$c_Lorg_scalajs_dom_IDBTransactionMode$.prototype.$classData = $d_Lorg_scalajs_dom_IDBTransactionMode$;
var $n_Lorg_scalajs_dom_IDBTransactionMode$;
function $m_Lorg_scalajs_dom_IDBTransactionMode$() {
  if ((!$n_Lorg_scalajs_dom_IDBTransactionMode$)) {
    $n_Lorg_scalajs_dom_IDBTransactionMode$ = new $c_Lorg_scalajs_dom_IDBTransactionMode$()
  };
  return $n_Lorg_scalajs_dom_IDBTransactionMode$
}
/** @constructor */
function $c_Lorg_scalajs_dom_MIMEType$() {
  this.Lorg_scalajs_dom_MIMEType$__f_text$divxml = null;
  this.Lorg_scalajs_dom_MIMEType$__f_text$divxml = "text/xml"
}
$c_Lorg_scalajs_dom_MIMEType$.prototype = new $h_O();
$c_Lorg_scalajs_dom_MIMEType$.prototype.constructor = $c_Lorg_scalajs_dom_MIMEType$;
/** @constructor */
function $h_Lorg_scalajs_dom_MIMEType$() {
  /*<skip>*/
}
$h_Lorg_scalajs_dom_MIMEType$.prototype = $c_Lorg_scalajs_dom_MIMEType$.prototype;
var $d_Lorg_scalajs_dom_MIMEType$ = new $TypeData().initClass({
  Lorg_scalajs_dom_MIMEType$: 0
}, false, "org.scalajs.dom.MIMEType$", {
  Lorg_scalajs_dom_MIMEType$: 1,
  O: 1
});
$c_Lorg_scalajs_dom_MIMEType$.prototype.$classData = $d_Lorg_scalajs_dom_MIMEType$;
var $n_Lorg_scalajs_dom_MIMEType$;
function $m_Lorg_scalajs_dom_MIMEType$() {
  if ((!$n_Lorg_scalajs_dom_MIMEType$)) {
    $n_Lorg_scalajs_dom_MIMEType$ = new $c_Lorg_scalajs_dom_MIMEType$()
  };
  return $n_Lorg_scalajs_dom_MIMEType$
}
/** @constructor */
function $c_Lorg_scalajs_dom_RequestCache$() {
  this.Lorg_scalajs_dom_RequestCache$__f_no$minusstore = null;
  this.Lorg_scalajs_dom_RequestCache$__f_force$minuscache = null;
  this.Lorg_scalajs_dom_RequestCache$__f_no$minusstore = "no-store";
  this.Lorg_scalajs_dom_RequestCache$__f_force$minuscache = "force-cache"
}
$c_Lorg_scalajs_dom_RequestCache$.prototype = new $h_O();
$c_Lorg_scalajs_dom_RequestCache$.prototype.constructor = $c_Lorg_scalajs_dom_RequestCache$;
/** @constructor */
function $h_Lorg_scalajs_dom_RequestCache$() {
  /*<skip>*/
}
$h_Lorg_scalajs_dom_RequestCache$.prototype = $c_Lorg_scalajs_dom_RequestCache$.prototype;
var $d_Lorg_scalajs_dom_RequestCache$ = new $TypeData().initClass({
  Lorg_scalajs_dom_RequestCache$: 0
}, false, "org.scalajs.dom.RequestCache$", {
  Lorg_scalajs_dom_RequestCache$: 1,
  O: 1
});
$c_Lorg_scalajs_dom_RequestCache$.prototype.$classData = $d_Lorg_scalajs_dom_RequestCache$;
var $n_Lorg_scalajs_dom_RequestCache$;
function $m_Lorg_scalajs_dom_RequestCache$() {
  if ((!$n_Lorg_scalajs_dom_RequestCache$)) {
    $n_Lorg_scalajs_dom_RequestCache$ = new $c_Lorg_scalajs_dom_RequestCache$()
  };
  return $n_Lorg_scalajs_dom_RequestCache$
}
/** @constructor */
function $c_Lorg_scalajs_dom_RequestCredentials$() {
  this.Lorg_scalajs_dom_RequestCredentials$__f_include = null;
  this.Lorg_scalajs_dom_RequestCredentials$__f_include = "include"
}
$c_Lorg_scalajs_dom_RequestCredentials$.prototype = new $h_O();
$c_Lorg_scalajs_dom_RequestCredentials$.prototype.constructor = $c_Lorg_scalajs_dom_RequestCredentials$;
/** @constructor */
function $h_Lorg_scalajs_dom_RequestCredentials$() {
  /*<skip>*/
}
$h_Lorg_scalajs_dom_RequestCredentials$.prototype = $c_Lorg_scalajs_dom_RequestCredentials$.prototype;
var $d_Lorg_scalajs_dom_RequestCredentials$ = new $TypeData().initClass({
  Lorg_scalajs_dom_RequestCredentials$: 0
}, false, "org.scalajs.dom.RequestCredentials$", {
  Lorg_scalajs_dom_RequestCredentials$: 1,
  O: 1
});
$c_Lorg_scalajs_dom_RequestCredentials$.prototype.$classData = $d_Lorg_scalajs_dom_RequestCredentials$;
var $n_Lorg_scalajs_dom_RequestCredentials$;
function $m_Lorg_scalajs_dom_RequestCredentials$() {
  if ((!$n_Lorg_scalajs_dom_RequestCredentials$)) {
    $n_Lorg_scalajs_dom_RequestCredentials$ = new $c_Lorg_scalajs_dom_RequestCredentials$()
  };
  return $n_Lorg_scalajs_dom_RequestCredentials$
}
/** @constructor */
function $c_RTLong(lo, hi) {
  this.RTLong__f_lo = 0;
  this.RTLong__f_hi = 0;
  this.RTLong__f_lo = lo;
  this.RTLong__f_hi = hi
}
$c_RTLong.prototype = new $h_O();
$c_RTLong.prototype.constructor = $c_RTLong;
/** @constructor */
function $h_RTLong() {
  /*<skip>*/
}
$h_RTLong.prototype = $c_RTLong.prototype;
$c_RTLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_RTLong(that);
    return ((this.RTLong__f_lo === $n(x2).RTLong__f_lo) && (this.RTLong__f_hi === $n(x2).RTLong__f_hi))
  } else {
    return false
  }
});
$c_RTLong.prototype.hashCode__I = (function() {
  return (this.RTLong__f_lo ^ this.RTLong__f_hi)
});
$c_RTLong.prototype.toString__T = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.toInt__I = (function() {
  return this.RTLong__f_lo
});
$c_RTLong.prototype.toFloat__F = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.toDouble__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.byteValue__B = (function() {
  return ((this.RTLong__f_lo << 24) >> 24)
});
$c_RTLong.prototype.shortValue__S = (function() {
  return ((this.RTLong__f_lo << 16) >> 16)
});
$c_RTLong.prototype.intValue__I = (function() {
  return this.RTLong__f_lo
});
$c_RTLong.prototype.longValue__J = (function() {
  return $uJ(this)
});
$c_RTLong.prototype.floatValue__F = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.doubleValue__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.compareTo__O__I = (function(that) {
  var b = $as_RTLong(that);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, $n(b).RTLong__f_lo, $n(b).RTLong__f_hi)
});
$c_RTLong.prototype.compareTo__jl_Long__I = (function(that) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, $n(that).RTLong__f_lo, $n(that).RTLong__f_hi)
});
$c_RTLong.prototype.equals__RTLong__Z = (function(b) {
  return ((this.RTLong__f_lo === $n(b).RTLong__f_lo) && (this.RTLong__f_hi === $n(b).RTLong__f_hi))
});
$c_RTLong.prototype.notEquals__RTLong__Z = (function(b) {
  return (!((this.RTLong__f_lo === $n(b).RTLong__f_lo) && (this.RTLong__f_hi === $n(b).RTLong__f_hi)))
});
$c_RTLong.prototype.$less__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) < ((-2147483648) ^ $n(b).RTLong__f_lo)) : (ahi < bhi))
});
$c_RTLong.prototype.$less$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) <= ((-2147483648) ^ $n(b).RTLong__f_lo)) : (ahi < bhi))
});
$c_RTLong.prototype.$greater__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) > ((-2147483648) ^ $n(b).RTLong__f_lo)) : (ahi > bhi))
});
$c_RTLong.prototype.$greater$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) >= ((-2147483648) ^ $n(b).RTLong__f_lo)) : (ahi > bhi))
});
$c_RTLong.prototype.unary_$tilde__RTLong = (function() {
  return new $c_RTLong((~this.RTLong__f_lo), (~this.RTLong__f_hi))
});
$c_RTLong.prototype.$bar__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo | $n(b).RTLong__f_lo), (this.RTLong__f_hi | $n(b).RTLong__f_hi))
});
$c_RTLong.prototype.$amp__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo & $n(b).RTLong__f_lo), (this.RTLong__f_hi & $n(b).RTLong__f_hi))
});
$c_RTLong.prototype.$up__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo ^ $n(b).RTLong__f_lo), (this.RTLong__f_hi ^ $n(b).RTLong__f_hi))
});
$c_RTLong.prototype.$less$less__I__RTLong = (function(n) {
  var lo = this.RTLong__f_lo;
  return new $c_RTLong((((32 & n) === 0) ? (lo << n) : 0), (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (this.RTLong__f_hi << n)) : (lo << n)))
});
$c_RTLong.prototype.$greater$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : ((hi >>> n) | 0)), (((32 & n) === 0) ? ((hi >>> n) | 0) : 0))
});
$c_RTLong.prototype.$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n)), (((32 & n) === 0) ? (hi >> n) : (hi >> 31)))
});
$c_RTLong.prototype.unary_$minus__RTLong = (function() {
  var lo = this.RTLong__f_lo;
  var hi = this.RTLong__f_hi;
  return new $c_RTLong(((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)))
});
$c_RTLong.prototype.$plus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  var lo = ((alo + $n(b).RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0)))
});
$c_RTLong.prototype.$minus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  var lo = ((alo - $n(b).RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0)))
});
$c_RTLong.prototype.$times__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var blo = $n(b).RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, $n(b).RTLong__f_hi) + Math.imul(this.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi)
});
$c_RTLong.prototype.$div__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, $n(b).RTLong__f_lo, $n(b).RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
$c_RTLong.prototype.$percent__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, $n(b).RTLong__f_lo, $n(b).RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
function $as_RTLong(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "org.scalajs.linker.runtime.RuntimeLong"))
}
function $isArrayOf_RTLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.RTLong)))
}
function $asArrayOf_RTLong(obj, depth) {
  return (($isArrayOf_RTLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lorg.scalajs.linker.runtime.RuntimeLong;", depth))
}
var $d_RTLong = new $TypeData().initClass({
  RTLong: 0
}, false, "org.scalajs.linker.runtime.RuntimeLong", {
  RTLong: 1,
  O: 1
});
$c_RTLong.prototype.$classData = $d_RTLong;
function $p_RTLong$__toUnsignedString__I__I__T($thiz, lo, hi) {
  if ((((-2097152) & hi) === 0)) {
    var this$1 = ((4.294967296E9 * hi) + $uD((lo >>> 0.0)));
    return ("" + this$1)
  } else {
    return $as_T($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, lo, hi, 1000000000, 0, 2))
  }
}
function $p_RTLong$__unsigned_$div__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0.0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0.0)));
      var rDouble = (aDouble / bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0.0));
      return $uI((rDouble | 0.0))
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    var pow = ((31 - $uI(Math.clz32(blo))) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((ahi >>> pow) | 0);
    return (((alo >>> pow) | 0) | ((ahi << 1) << ((31 - pow) | 0)))
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    var pow$2 = ((31 - $uI(Math.clz32(bhi))) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return ((ahi >>> pow$2) | 0)
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 0))
  }
}
function $p_RTLong$__unsigned_$percent__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0.0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0.0)));
      var rDouble = (aDouble % bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0.0));
      return $uI((rDouble | 0.0))
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return (alo & (((-1) + blo) | 0))
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (ahi & (((-1) + bhi) | 0));
    return alo
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 1))
  }
}
function $p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, ask) {
  var shift = ((((bhi !== 0) ? $uI(Math.clz32(bhi)) : ((32 + $uI(Math.clz32(blo))) | 0)) - ((ahi !== 0) ? $uI(Math.clz32(ahi)) : ((32 + $uI(Math.clz32(alo))) | 0))) | 0);
  var n = shift;
  var lo = (((32 & n) === 0) ? (blo << n) : 0);
  var hi = (((32 & n) === 0) ? (((((blo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (bhi << n)) : (blo << n));
  var bShiftLo = lo;
  var bShiftHi = hi;
  var remLo = alo;
  var remHi = ahi;
  var quotLo = 0;
  var quotHi = 0;
  while (((shift >= 0) && (((-2097152) & remHi) !== 0))) {
    var alo$1 = remLo;
    var ahi$1 = remHi;
    var blo$1 = bShiftLo;
    var bhi$1 = bShiftHi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ alo$1) >= ((-2147483648) ^ blo$1)) : (((-2147483648) ^ ahi$1) >= ((-2147483648) ^ bhi$1)))) {
      var lo$1 = remLo;
      var hi$1 = remHi;
      var lo$2 = bShiftLo;
      var hi$2 = bShiftHi;
      var lo$3 = ((lo$1 - lo$2) | 0);
      var hi$3 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      remLo = lo$3;
      remHi = hi$3;
      if ((shift < 32)) {
        quotLo = (quotLo | (1 << shift))
      } else {
        quotHi = (quotHi | (1 << shift))
      }
    };
    shift = (((-1) + shift) | 0);
    var lo$4 = bShiftLo;
    var hi$4 = bShiftHi;
    var lo$5 = (((lo$4 >>> 1) | 0) | (hi$4 << 31));
    var hi$5 = ((hi$4 >>> 1) | 0);
    bShiftLo = lo$5;
    bShiftHi = hi$5
  };
  var alo$2 = remLo;
  var ahi$2 = remHi;
  if (((ahi$2 === bhi) ? (((-2147483648) ^ alo$2) >= ((-2147483648) ^ blo)) : (((-2147483648) ^ ahi$2) >= ((-2147483648) ^ bhi)))) {
    var lo$6 = remLo;
    var hi$6 = remHi;
    var remDouble = ((4.294967296E9 * hi$6) + $uD((lo$6 >>> 0.0)));
    var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0.0)));
    if ((ask !== 1)) {
      var x = (remDouble / bDouble);
      var lo$7 = $uI((x | 0.0));
      var x$1 = (x / 4.294967296E9);
      var hi$7 = $uI((x$1 | 0.0));
      var lo$8 = quotLo;
      var hi$8 = quotHi;
      var lo$9 = ((lo$8 + lo$7) | 0);
      var hi$9 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$8)) ? ((1 + ((hi$8 + hi$7) | 0)) | 0) : ((hi$8 + hi$7) | 0));
      quotLo = lo$9;
      quotHi = hi$9
    };
    if ((ask !== 0)) {
      var rem_mod_bDouble = (remDouble % bDouble);
      remLo = $uI((rem_mod_bDouble | 0.0));
      var x$2 = (rem_mod_bDouble / 4.294967296E9);
      remHi = $uI((x$2 | 0.0))
    }
  };
  if ((ask === 0)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = quotHi;
    return quotLo
  } else if ((ask === 1)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = remHi;
    return remLo
  } else {
    var lo$10 = quotLo;
    var hi$10 = quotHi;
    var quot = ((4.294967296E9 * hi$10) + $uD((lo$10 >>> 0.0)));
    var this$7 = remLo;
    var remStr = ("" + this$7);
    var start = remStr.length;
    return ((("" + quot) + $as_T("000000000".substring(start))) + remStr)
  }
}
/** @constructor */
function $c_RTLong$() {
  this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0
}
$c_RTLong$.prototype = new $h_O();
$c_RTLong$.prototype.constructor = $c_RTLong$;
/** @constructor */
function $h_RTLong$() {
  /*<skip>*/
}
$h_RTLong$.prototype = $c_RTLong$.prototype;
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T = (function(lo, hi) {
  return ((hi === (lo >> 31)) ? ("" + lo) : ((hi < 0) ? ("-" + $p_RTLong$__toUnsignedString__I__I__T(this, ((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)))) : $p_RTLong$__toUnsignedString__I__I__T(this, lo, hi)))
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D = (function(lo, hi) {
  if ((hi < 0)) {
    var x = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var $$x1 = $uD((x >>> 0.0));
    var x$1 = ((-lo) | 0);
    return (-((4.294967296E9 * $$x1) + $uD((x$1 >>> 0.0))))
  } else {
    return ((4.294967296E9 * hi) + $uD((lo >>> 0.0)))
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F = (function(lo, hi) {
  if ((hi < 0)) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var abs__lo = lo$1;
    var abs__hi = hi$1
  } else {
    var abs__lo = lo;
    var abs__hi = hi
  };
  var hi$2 = abs__hi;
  if (((((-2097152) & hi$2) === 0) || ((65535 & abs__lo) === 0))) {
    var compressedAbsLo = abs__lo
  } else {
    var compressedAbsLo = (32768 | ((-65536) & abs__lo))
  };
  var x = abs__hi;
  var absRes = ((4.294967296E9 * $uD((x >>> 0.0))) + $uD((compressedAbsLo >>> 0.0)));
  return Math.fround(((hi < 0) ? (-absRes) : absRes))
});
$c_RTLong$.prototype.fromInt__I__RTLong = (function(value) {
  return new $c_RTLong(value, (value >> 31))
});
$c_RTLong$.prototype.fromDouble__D__RTLong = (function(value) {
  var lo = this.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  return new $c_RTLong(lo, this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I = (function(value) {
  if ((value < (-9.223372036854776E18))) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-2147483648);
    return 0
  } else if ((value >= 9.223372036854776E18)) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 2147483647;
    return (-1)
  } else {
    var rawLo = $uI((value | 0.0));
    var x = (value / 4.294967296E9);
    var rawHi = $uI((x | 0.0));
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (((value < 0.0) && (rawLo !== 0)) ? (((-1) + rawHi) | 0) : rawHi);
    return rawLo
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo === blo) ? 0 : ((((-2147483648) ^ alo) < ((-2147483648) ^ blo)) ? (-1) : 1)) : ((ahi < bhi) ? (-1) : 1))
});
$c_RTLong$.prototype.divideImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if (((alo === (-2147483648)) && (blo === (-1)))) {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return (-2147483648)
      } else {
        var lo = $intDiv(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-1);
      return (-1)
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi
    };
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi
    };
    var absRLo = $p_RTLong$__unsigned_$div__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if (((ahi ^ bhi) >= 0)) {
      return absRLo
    } else {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0)
    }
  }
});
$c_RTLong$.prototype.divideUnsignedImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === 0)) {
    if ((bhi === 0)) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      if ((blo === 0)) {
        return $intDiv(0, 0)
      } else {
        var n = ($uD((alo >>> 0.0)) / $uD((blo >>> 0.0)));
        return $uI((n | 0.0))
      }
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else {
    return $p_RTLong$__unsigned_$div__I__I__I__I__I(this, alo, ahi, blo, bhi)
  }
});
$c_RTLong$.prototype.remainderImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if ((blo !== (-1))) {
        var lo = $intMod(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo
      } else {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return 0
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi
    };
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi
    };
    var absRLo = $p_RTLong$__unsigned_$percent__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if ((ahi < 0)) {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0)
    } else {
      return absRLo
    }
  }
});
var $d_RTLong$ = new $TypeData().initClass({
  RTLong$: 0
}, false, "org.scalajs.linker.runtime.RuntimeLong$", {
  RTLong$: 1,
  O: 1
});
$c_RTLong$.prototype.$classData = $d_RTLong$;
var $n_RTLong$;
function $m_RTLong$() {
  if ((!$n_RTLong$)) {
    $n_RTLong$ = new $c_RTLong$()
  };
  return $n_RTLong$
}
function $is_Lreactbuild_Loc(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_Loc)))
}
function $as_Lreactbuild_Loc(obj) {
  return (($is_Lreactbuild_Loc(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc"))
}
function $isArrayOf_Lreactbuild_Loc(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc)))
}
function $asArrayOf_Lreactbuild_Loc(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc;", depth))
}
/** @constructor */
function $c_Lreactbuild_Loc$() {
  this.Lreactbuild_Loc$__f_pages = null;
  $n_Lreactbuild_Loc$ = this;
  $n($m_s_package$().s_package$__f_List);
  var array = [$m_Lreactbuild_Loc$Home$(), $m_Lreactbuild_Loc$Dashboard$(), $m_Lreactbuild_Loc$Inbox$(), new $c_Lreactbuild_Loc$Project(new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary($m_s_None$())), new $c_Lreactbuild_Loc$Person($m_s_None$()), new $c_Lreactbuild_Loc$TimeReport($m_s_None$()), $m_Lreactbuild_Loc$DocumentList$(), new $c_Lreactbuild_Loc$Resource($m_s_None$()), new $c_Lreactbuild_Loc$Crossed($m_s_None$()), $m_Lreactbuild_Loc$Render$(), new $c_Lreactbuild_Loc$BusinessOpportunities($m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$()), $m_Lreactbuild_Loc$Reconcile$(), $m_Lreactbuild_Loc$TaskScheduler$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_Loc$__f_pages = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $m_Lshapeless_Witness$();
  var this$6 = $m_s_Symbol$();
  var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "title"));
  var w = new $c_Lshapeless_Witness$$anon$1(value0);
  var this$9 = new $c_Lshapeless_syntax_SingletonOps$$anon$1(w);
  $as_s_Symbol($n(this$9.Lshapeless_syntax_SingletonOps$$anon$1__f_witness).value__O())
}
$c_Lreactbuild_Loc$.prototype = new $h_O();
$c_Lreactbuild_Loc$.prototype.constructor = $c_Lreactbuild_Loc$;
/** @constructor */
function $h_Lreactbuild_Loc$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$.prototype = $c_Lreactbuild_Loc$.prototype;
$c_Lreactbuild_Loc$.prototype.keyMapper__Lcom_iz2use_common_KeyMapper = (function() {
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_Loc(x$1$2);
    var this$2 = $n(x$1);
    return $objectGetClass(this$2).toString__T()
  }));
  var ev = $m_Lcom_iz2use_common_KeyMapper$().Lcom_iz2use_common_KeyMapper$__f_fromString;
  return new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f)
});
var $d_Lreactbuild_Loc$ = new $TypeData().initClass({
  Lreactbuild_Loc$: 0
}, false, "reactbuild.Loc$", {
  Lreactbuild_Loc$: 1,
  O: 1
});
$c_Lreactbuild_Loc$.prototype.$classData = $d_Lreactbuild_Loc$;
var $n_Lreactbuild_Loc$;
function $m_Lreactbuild_Loc$() {
  if ((!$n_Lreactbuild_Loc$)) {
    $n_Lreactbuild_Loc$ = new $c_Lreactbuild_Loc$()
  };
  return $n_Lreactbuild_Loc$
}
function $s_Lreactbuild_analyze_cost_Main__main__AT__V(args) {
  $m_Lreactbuild_analyze_cost_Main$().main__AT__V(args)
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_Main$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_Main$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_Main$.prototype.constructor = $c_Lreactbuild_analyze_cost_Main$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_Main$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_Main$.prototype = $c_Lreactbuild_analyze_cost_Main$.prototype;
$c_Lreactbuild_analyze_cost_Main$.prototype.main__AT__V = (function(args) {
  var style = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents;
  $m_Lcom_iz2use_react_components_StyleConsumer$().Lcom_iz2use_react_components_StyleConsumer$__f_style = style;
  var this$6 = $m_Lreactbuild_Style$();
  var this$2 = $m_Lreactbuild_package$CssSettings$();
  var s = $f_Lreactbuild_package$MyDev__cssStringRenderer__Lscalacss_internal_Renderer(this$2);
  var r = new $c_Lscalacss_ScalatagsJsDomRenderer(s);
  $m_Lreactbuild_package$CssSettings$();
  var env = $m_Lscalacss_internal_Env$().Lscalacss_internal_Env$__f_empty;
  var rendered = $n($as_Lscalatags_JsDom$TypedTag($n(this$6.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister).render__Lscalacss_internal_Renderer__Lscalacss_internal_Env__O(r, env))).render__Lorg_scalajs_dom_Element();
  document.head.appendChild(rendered);
  var this$7 = $m_Lscalatags_JsDom$all$();
  var $$x1 = this$7.div__Lscalatags_JsDom$TypedTag();
  var this$8 = $m_Lscalacss_ScalatagsCss$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_rootContainer;
  var array = [new $c_Lscalacss_ScalatagsJsDomImplicits$$anon$1(this$8, s$1)];
  var container = $n($n($$x1).apply__sci_Seq__Lscalatags_JsDom$TypedTag($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))).render__Lorg_scalajs_dom_Element();
  document.body.appendChild(container);
  var this$13 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var zoomFunc = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_analyze_cost_services_RootModel(x$2$2);
    return $n(x$2).Lreactbuild_analyze_cost_services_RootModel__f_model
  }));
  var feq = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  var modelWrapper = $f_Ldiode_react_ReactConnector__connect__F1__Ldiode_FastEq__Ljapgolly_scalajs_react_CtorType$Props(this$13, zoomFunc, feq);
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_router_RouterWithProps$();
  var this$14 = $m_Ljapgolly_scalajs_react_extra_router_BaseUrl$();
  var $$x2 = $as_Ljapgolly_scalajs_react_extra_router_BaseUrl($n(this$14.fromWindowOrigin__Ljapgolly_scalajs_react_extra_router_BaseUrl()).endWith_$div__Ljapgolly_scalajs_react_extra_router_PathLike());
  var this$15 = $m_Lreactbuild_analyze_cost_RouterConfig$();
  var router = $n($$x3).apply__Ljapgolly_scalajs_react_extra_router_BaseUrl__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($$x2, this$15.Lreactbuild_analyze_cost_RouterConfig$__f_routerConfig);
  var this$21 = $n(modelWrapper);
  var props = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Ldiode_react_ModelProxy(p$2);
    var this$17 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(router).ctor__Ljapgolly_scalajs_react_CtorType()));
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$17.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(p, this$17.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$19 = $n(u);
    var n = this$19.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var connected = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot($n(this$21.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$21.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var $$x4 = $m_Ljapgolly_scalajs_react_React$();
  var this$23 = $n(connected);
  var n$1 = this$23.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  var this$31 = $n($n($$x4).StrictMode__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
  $i_react$002ddom.render($f_Ljapgolly_scalajs_react_vdom_VdomElement__rawNode__sjs_js_$bar(this$31), container);
  var this$32 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var action = $m_Lreactbuild_analyze_cost_actions_ApplicationStarted$();
  var evidence$6 = $m_Ldiode_Action$aType$();
  $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V(this$32, action, evidence$6)
});
var $d_Lreactbuild_analyze_cost_Main$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_Main$: 0
}, false, "reactbuild.analyze.cost.Main$", {
  Lreactbuild_analyze_cost_Main$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_Main$.prototype.$classData = $d_Lreactbuild_analyze_cost_Main$;
var $n_Lreactbuild_analyze_cost_Main$;
function $m_Lreactbuild_analyze_cost_Main$() {
  if ((!$n_Lreactbuild_analyze_cost_Main$)) {
    $n_Lreactbuild_analyze_cost_Main$ = new $c_Lreactbuild_analyze_cost_Main$()
  };
  return $n_Lreactbuild_analyze_cost_Main$
}
function $is_Lreactbuild_analyze_cost_ReconciliationReportOrder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_ReconciliationReportOrder)))
}
function $as_Lreactbuild_analyze_cost_ReconciliationReportOrder(obj) {
  return (($is_Lreactbuild_analyze_cost_ReconciliationReportOrder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ReconciliationReportOrder"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ReconciliationReportOrder)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ReconciliationReportOrder;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$() {
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$__f_codecForReconciliationReportOrder = null;
  $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$ = this;
  var inst$macro$14 = new $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$14));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$__f_codecForReconciliationReportOrder = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$.prototype.constructor = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ReconciliationReportOrder$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ReconciliationReportOrder$.prototype = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$.prototype;
var $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ReconciliationReportOrder$: 0
}, false, "reactbuild.analyze.cost.ReconciliationReportOrder$", {
  Lreactbuild_analyze_cost_ReconciliationReportOrder$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$.prototype.$classData = $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$;
var $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$;
function $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$() {
  if ((!$n_Lreactbuild_analyze_cost_ReconciliationReportOrder$)) {
    $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$ = new $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$()
  };
  return $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$
}
function $p_Lreactbuild_analyze_cost_RouterConfig$__parseLocalDate$1__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_T(v$2);
    try {
      var this$3 = $n(v);
      var text = $as_T(this$3.split("/").join("-"));
      var this$4 = $m_Ljava_time_LocalDate$();
      var $$x1 = new $c_s_util_Success(this$4.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_LocalDate(text, $m_Ljava_time_format_DateTimeFormatter$().ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter()))
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $$x1;
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!$n(o11).isEmpty__Z())) {
          var e$3 = $as_jl_Throwable($n(o11).get__O());
          var $$x1 = new $c_s_util_Failure(e$3);
          break matchEnd8
        };
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
      }
    };
    return $n($$x1).map__F1__s_util_Try(new $c_sjsr_AnonFunction1(((d$2) => {
      var d = $as_Ljava_time_LocalDate(d$2);
      var $$x2 = $n(d);
      var value = (((-1) + $n($n(d).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I()) | 0);
      var hi = (value >> 31);
      return $n($$x2).minusDays__J__Ljava_time_LocalDate(new $c_RTLong(value, hi))
    })))
  }))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_RouterConfig$() {
  this.Lreactbuild_analyze_cost_RouterConfig$__f_routerConfig = null;
  $n_Lreactbuild_analyze_cost_RouterConfig$ = this;
  new $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface();
  var f$2 = new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl(dsl$2);
    $n(dsl);
    var this$ = $n(dsl).staticRoute__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__O__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(($n(dsl), new $c_Ljapgolly_scalajs_react_extra_router_Path("")), new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Ljapgolly_scalajs_react_extra_router_Path(p$2);
      $n(dsl);
      return $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n(p).Ljapgolly_scalajs_react_extra_router_Path__f_value)
    }))), $m_Lreactbuild_Loc$Home$());
    var a = new $c_sjsr_AnonFunction0((() => {
      var $$x2 = $n(dsl);
      var $$x1 = new $c_sjsr_AnonFunction2(((ctl$2, p$2$1) => {
        $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$2);
        $as_Ldiode_react_ModelProxy(p$2$1);
        return $m_Lreactbuild_analyze_cost_modules_Home$().apply__Ljapgolly_scalajs_react_vdom_VdomElement()
      }));
      var this$7 = $m_s_$less$colon$less$();
      return $n($$x2).renderRP__F2__F1__Ljapgolly_scalajs_react_extra_router_RendererF($$x1, this$7.s_$less$colon$less$__f_singleton)
    }));
    var this$23 = $n($as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$).apply__O__O(a)));
    var $$x4 = $n(dsl);
    var this$15 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("processing")));
    var this$12 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("/")));
    var next = $m_Lreactbuild_analyze_cost_RouterConfigCommon$().refTo__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(dsl);
    var this$11 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var c = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$11);
    var this$13 = $n(c);
    var next$1 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$13, this$12, next)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB()).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((ref$2) => {
      var ref = $as_s_Option(ref$2);
      return new $c_Lreactbuild_Loc$Processing(ref)
    })), new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lreactbuild_Loc$Processing(x$1$2);
      return $n(x$1).Lreactbuild_Loc$Processing__f_ref
    }))));
    var this$14 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var c$1 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$14);
    var this$16 = $n(c$1);
    var $$x3 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$16, this$15, next$1);
    var this$18 = $m_s_$less$colon$less$();
    var this$$1 = $n($$x4).dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x3, this$18.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_Loc$Processing.getClassOf()));
    var $$x6 = $n(dsl);
    var $$x5 = new $c_sjsr_AnonFunction3(((rt$2, ctl$2$1, p$3$2) => {
      var rt = $as_Lreactbuild_Loc$Processing(rt$2);
      $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$2$1);
      $as_Ldiode_react_ModelProxy(p$3$2);
      return $m_Lreactbuild_analyze_cost_modules_Processing$().apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement($n(rt).Lreactbuild_Loc$Processing__f_ref)
    }));
    var this$21 = $m_s_$less$colon$less$();
    var g = $n($$x6).dynRenderRP__F3__F1__F1($$x5, this$21.s_$less$colon$less$__f_singleton);
    var that = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$1).apply__O__O(g));
    var this$38 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$23, that);
    var $$x8 = $n(dsl);
    var this$30 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("receipt")));
    var this$27 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("/")));
    var next$2 = $m_Lreactbuild_analyze_cost_RouterConfigCommon$().refTo__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(dsl);
    var this$26 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var c$2 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$26);
    var this$28 = $n(c$2);
    var next$3 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$28, this$27, next$2)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB()).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((ref$3$2) => {
      var ref$3 = $as_s_Option(ref$3$2);
      return new $c_Lreactbuild_Loc$SendReceipt(ref$3)
    })), new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lreactbuild_Loc$SendReceipt(x$2$2);
      return $n(x$2).Lreactbuild_Loc$SendReceipt__f_ref
    }))));
    var this$29 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var c$3 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$29);
    var this$31 = $n(c$3);
    var $$x7 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$31, this$30, next$3);
    var this$33 = $m_s_$less$colon$less$();
    var this$$2 = $n($$x8).dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x7, this$33.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_Loc$SendReceipt.getClassOf()));
    var $$x10 = $n(dsl);
    var $$x9 = new $c_sjsr_AnonFunction3(((rt$3$2, ctl$3$2, p$4$2) => {
      var rt$3 = $as_Lreactbuild_Loc$SendReceipt(rt$3$2);
      $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$3$2);
      $as_Ldiode_react_ModelProxy(p$4$2);
      return $m_Lreactbuild_analyze_cost_modules_SendReceipt$().apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement($n(rt$3).Lreactbuild_Loc$SendReceipt__f_ref)
    }));
    var this$36 = $m_s_$less$colon$less$();
    var g$1 = $n($$x10).dynRenderRP__F3__F1__F1($$x9, this$36.s_$less$colon$less$__f_singleton);
    var that$1 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$2).apply__O__O(g$1));
    var this$53 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$38, that$1);
    var $$x12 = $n(dsl);
    var this$45 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("crossed")));
    var this$42 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("-")));
    var next$4 = $n(dsl).Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__f_int;
    var this$41 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var c$4 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$41);
    var this$43 = $n(c$4);
    var next$5 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$43, this$42, next$4)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB()).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((index$2) => {
      var index = $as_s_Option(index$2);
      return new $c_Lreactbuild_Loc$Crossed(index)
    })), new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lreactbuild_Loc$Crossed(x$3$2);
      return $n(x$3).Lreactbuild_Loc$Crossed__f_index
    }))));
    var this$44 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var c$5 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$44);
    var this$46 = $n(c$5);
    var $$x11 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$46, this$45, next$5);
    var this$48 = $m_s_$less$colon$less$();
    var this$$3 = $n($$x12).dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x11, this$48.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_Loc$Crossed.getClassOf()));
    var $$x14 = $n(dsl);
    var $$x13 = new $c_sjsr_AnonFunction3(((rt$4$2, ctl$4$2, p$5$2) => {
      var rt$4 = $as_Lreactbuild_Loc$Crossed(rt$4$2);
      $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$4$2);
      $as_Ldiode_react_ModelProxy(p$5$2);
      return $m_Lreactbuild_analyze_cost_modules_Crossed$().apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement($n(rt$4).Lreactbuild_Loc$Crossed__f_index)
    }));
    var this$51 = $m_s_$less$colon$less$();
    var g$2 = $n($$x14).dynRenderRP__F3__F1__F1($$x13, this$51.s_$less$colon$less$__f_singleton);
    var that$2 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$3).apply__O__O(g$2));
    var this$62 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$53, that$2);
    var $$x18 = $n(dsl);
    var $$x17 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("person")));
    var $$x16 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n($m_Lreactbuild_analyze_cost_RouterConfigCommon$().refTo__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(dsl)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB()).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((ref$4$2) => {
      var ref$4 = $as_s_Option(ref$4$2);
      return new $c_Lreactbuild_Loc$Person(ref$4)
    })), new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lreactbuild_Loc$Person(x$4$2);
      return $n(x$4).Lreactbuild_Loc$Person__f_ref
    }))));
    var this$55 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var $$x15 = $n($$x17).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x16, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$55));
    var this$57 = $m_s_$less$colon$less$();
    var this$$4 = $n($$x18).dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x15, this$57.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_Loc$Person.getClassOf()));
    var $$x20 = $n(dsl);
    var $$x19 = new $c_sjsr_AnonFunction3(((rt$5$2, ctl$5$2, p$6$2) => {
      var rt$5 = $as_Lreactbuild_Loc$Person(rt$5$2);
      $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$5$2);
      $as_Ldiode_react_ModelProxy(p$6$2);
      return $m_Lreactbuild_analyze_cost_modules_Persons$().apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement($n(rt$5).Lreactbuild_Loc$Person__f_ref)
    }));
    var this$60 = $m_s_$less$colon$less$();
    var g$3 = $n($$x20).dynRenderRP__F3__F1__F1($$x19, this$60.s_$less$colon$less$__f_singleton);
    var that$3 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$4).apply__O__O(g$3));
    var this$65 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$62, that$3);
    var this$63 = $n($m_Lreactbuild_analyze_cost_modules_Projects$().routes__Ljapgolly_scalajs_react_extra_router_RoutingRule());
    var this$64 = $n($f_Ljapgolly_scalajs_react_extra_router_RoutingRule__prefixPath_$div__T__Ljapgolly_scalajs_react_extra_router_RoutingRule(this$63, "project"));
    var f = $m_Lreactbuild_Loc$Project$();
    var pf = new $c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1();
    var that$4 = this$64.pmapF__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule(f, new $c_s_PartialFunction$Lifted(pf));
    var this$74 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$65, that$4);
    var $$x24 = $n(dsl);
    var $$x23 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("resource")));
    var $$x22 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n($m_Lreactbuild_analyze_cost_RouterConfigCommon$().refTo__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(dsl)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB()).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((ref$5$2) => {
      var ref$5 = $as_s_Option(ref$5$2);
      return new $c_Lreactbuild_Loc$Resource(ref$5)
    })), new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lreactbuild_Loc$Resource(x$5$2);
      return $n(x$5).Lreactbuild_Loc$Resource__f_ref
    }))));
    var this$67 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var $$x21 = $n($$x23).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x22, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$67));
    var this$69 = $m_s_$less$colon$less$();
    var this$$5 = $n($$x24).dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x21, this$69.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_Loc$Resource.getClassOf()));
    var $$x26 = $n(dsl);
    var $$x25 = new $c_sjsr_AnonFunction3(((rt$6$2, ctl$6$2, p$7$2) => {
      var rt$6 = $as_Lreactbuild_Loc$Resource(rt$6$2);
      $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$6$2);
      $as_Ldiode_react_ModelProxy(p$7$2);
      return $m_Lreactbuild_analyze_cost_modules_Resources$().apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement($n(rt$6).Lreactbuild_Loc$Resource__f_ref)
    }));
    var this$72 = $m_s_$less$colon$less$();
    var g$4 = $n($$x26).dynRenderRP__F3__F1__F1($$x25, this$72.s_$less$colon$less$__f_singleton);
    var that$5 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$5).apply__O__O(g$4));
    var this$88 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$74, that$5);
    var $$x32 = $n(dsl);
    var $$x31 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("notebook")));
    $n(dsl);
    var $$x30 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("template");
    var $$x29 = $n($m_Lreactbuild_analyze_cost_RouterConfigCommon$().refTo__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(dsl)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB();
    var this$77 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var this$79 = $n($n($$x30).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x29, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$77)));
    var next$6 = $n($m_Lreactbuild_analyze_cost_RouterConfigCommon$().refTo__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(dsl)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB();
    var this$78 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var c$6 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLowest__$times$times$times__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$78);
    var this$80 = $n(c$6);
    var $$x28 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$80, this$79, next$6)).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((t$2) => {
      var t = $as_T2(t$2);
      return new $c_Lreactbuild_Loc$Notebook($as_s_Option($n(t)._1__O()), $as_s_Option($n(t)._2__O()))
    })), new $c_sjsr_AnonFunction1(((c$2$1) => {
      var c$7 = $as_Lreactbuild_Loc$Notebook(c$2$1);
      return $ct_T2__O__O__(new $c_T2(), $n(c$7).Lreactbuild_Loc$Notebook__f_templateRef, $n(c$7).Lreactbuild_Loc$Notebook__f_ref)
    }))));
    var this$81 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var $$x27 = $n($$x31).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x28, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$81));
    var this$83 = $m_s_$less$colon$less$();
    var this$$6 = $n($$x32).dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x27, this$83.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_Loc$Notebook.getClassOf()));
    var $$x34 = $n(dsl);
    var $$x33 = new $c_sjsr_AnonFunction3(((rt$7$2, ctl$7$2, p$8$2) => {
      var rt$7 = $as_Lreactbuild_Loc$Notebook(rt$7$2);
      $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$7$2);
      $as_Ldiode_react_ModelProxy(p$8$2);
      return $m_Lreactbuild_project_notebook_Notebook$().apply__s_Option__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement($n(rt$7).Lreactbuild_Loc$Notebook__f_templateRef, $n(rt$7).Lreactbuild_Loc$Notebook__f_ref)
    }));
    var this$86 = $m_s_$less$colon$less$();
    var g$5 = $n($$x34).dynRenderRP__F3__F1__F1($$x33, this$86.s_$less$colon$less$__f_singleton);
    var that$6 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$6).apply__O__O(g$5));
    var this$93 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$88, that$6);
    var this$$7 = $n(dsl).staticRoute__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__O__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route("dashboard", new $c_sjsr_AnonFunction1(((l$2) => {
      var l = $as_T(l$2);
      $n(dsl);
      return $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(l)
    }))), $m_Lreactbuild_Loc$Dashboard$());
    var a$1 = new $c_sjsr_AnonFunction0((() => {
      var $$x36 = $n(dsl);
      var $$x35 = new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_Dashboard$().apply__Ljapgolly_scalajs_react_vdom_TagOf()));
      var this$91 = $m_s_$less$colon$less$();
      return $n($$x36).render__F0__F1__Ljapgolly_scalajs_react_extra_router_RendererF($$x35, this$91.s_$less$colon$less$__f_singleton)
    }));
    var that$7 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$7).apply__O__O(a$1));
    var this$96 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$93, that$7);
    var this$94 = $n($m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$().routes__Ljapgolly_scalajs_react_extra_router_RoutingRule());
    var this$95 = $n($f_Ljapgolly_scalajs_react_extra_router_RoutingRule__prefixPath_$div__T__Ljapgolly_scalajs_react_extra_router_RoutingRule(this$94, "opportunities"));
    var f$1 = $m_Lreactbuild_Loc$BusinessOpportunities$();
    var pf$1 = new $c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2();
    var that$8 = this$95.pmapF__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule(f$1, new $c_s_PartialFunction$Lifted(pf$1));
    var this$102 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$96, that$8);
    var this$$8 = $n(dsl).staticRoute__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__O__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route("task-scheduler", new $c_sjsr_AnonFunction1(((l$3$2) => {
      var l$3 = $as_T(l$3$2);
      $n(dsl);
      return $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(l$3)
    }))), $m_Lreactbuild_Loc$TaskScheduler$());
    var a$2 = new $c_sjsr_AnonFunction0((() => $n(dsl).render__F0__F1__Ljapgolly_scalajs_react_extra_router_RendererF(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_task_TaskScheduler$().apply__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot())), new $c_sjsr_AnonFunction1(((u$2) => {
      var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(u$2);
      var this$99 = $n(u);
      var n = this$99.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    })))));
    var that$9 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$8).apply__O__O(a$2));
    var this$107 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$102, that$9);
    var this$$9 = $n(dsl).staticRoute__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__O__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route("reconcile", new $c_sjsr_AnonFunction1(((l$4$2) => {
      var l$4 = $as_T(l$4$2);
      $n(dsl);
      return $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(l$4)
    }))), $m_Lreactbuild_Loc$Reconcile$());
    var a$3 = new $c_sjsr_AnonFunction0((() => {
      var $$x38 = $n(dsl);
      var $$x37 = new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$().apply__Ljapgolly_scalajs_react_vdom_VdomElement()));
      var this$105 = $m_s_$less$colon$less$();
      return $n($$x38).render__F0__F1__Ljapgolly_scalajs_react_extra_router_RendererF($$x37, this$105.s_$less$colon$less$__f_singleton)
    }));
    var that$10 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$9).apply__O__O(a$3));
    var this$112 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$107, that$10);
    var this$$10 = $n(dsl).staticRoute__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__O__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route("inbox", new $c_sjsr_AnonFunction1(((l$5$2) => {
      var l$5 = $as_T(l$5$2);
      $n(dsl);
      return $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(l$5)
    }))), $m_Lreactbuild_Loc$Inbox$());
    var a$4 = new $c_sjsr_AnonFunction0((() => {
      var $$x40 = $n(dsl);
      var $$x39 = new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_views_Inbox$().apply__Ljapgolly_scalajs_react_vdom_VdomElement()));
      var this$110 = $m_s_$less$colon$less$();
      return $n($$x40).render__F0__F1__Ljapgolly_scalajs_react_extra_router_RendererF($$x39, this$110.s_$less$colon$less$__f_singleton)
    }));
    var that$11 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$10).apply__O__O(a$4));
    var this$117 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$112, that$11);
    var this$$11 = $n(dsl).staticRoute__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__O__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route("render", new $c_sjsr_AnonFunction1(((l$6$2) => {
      var l$6 = $as_T(l$6$2);
      $n(dsl);
      return $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(l$6)
    }))), $m_Lreactbuild_Loc$Render$());
    var a$5 = new $c_sjsr_AnonFunction0((() => {
      var $$x42 = $n(dsl);
      var $$x41 = new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_views_Admin$().apply__Ljapgolly_scalajs_react_vdom_VdomElement()));
      var this$115 = $m_s_$less$colon$less$();
      return $n($$x42).render__F0__F1__Ljapgolly_scalajs_react_extra_router_RendererF($$x41, this$115.s_$less$colon$less$__f_singleton)
    }));
    var that$12 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$11).apply__O__O(a$5));
    var this$122 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$117, that$12);
    var this$$12 = $n(dsl).staticRoute__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__O__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route("documents", new $c_sjsr_AnonFunction1(((l$7$2) => {
      var l$7 = $as_T(l$7$2);
      $n(dsl);
      return $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(l$7)
    }))), $m_Lreactbuild_Loc$DocumentList$());
    var a$6 = new $c_sjsr_AnonFunction0((() => {
      var $$x44 = $n(dsl);
      var $$x43 = new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_DocumentList$().apply__Ljapgolly_scalajs_react_vdom_VdomElement()));
      var this$120 = $m_s_$less$colon$less$();
      return $n($$x44).render__F0__F1__Ljapgolly_scalajs_react_extra_router_RendererF($$x43, this$120.s_$less$colon$less$__f_singleton)
    }));
    var that$13 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$12).apply__O__O(a$6));
    var this$131 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$122, that$13);
    var $$x48 = $n(dsl);
    var $$x47 = $n(($n(dsl), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("time-report")));
    var $$x46 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n($n($n(dsl).string__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("(\\d{4}[-/.]\\d{2}[-/.]\\d{2})")).pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(new $c_sjsr_AnonFunction1(((x$2$3$2) => {
      var x$2$3 = $as_T(x$2$3$2);
      return $n($as_s_util_Try($n($p_Lreactbuild_analyze_cost_RouterConfig$__parseLocalDate$1__F1(this)).apply__O__O(x$2$3))).toOption__s_Option()
    })), new $c_sjsr_AnonFunction1(((x$3$3$2) => {
      var x$3$3 = $as_Ljava_time_LocalDate(x$3$3$2);
      return $n(x$3$3).toString__T()
    })))).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB()).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((date$2) => {
      var date = $as_s_Option(date$2);
      return new $c_Lreactbuild_Loc$TimeReport(date)
    })), new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Lreactbuild_Loc$TimeReport(x$6$2);
      return $n(x$6).Lreactbuild_Loc$TimeReport__f_date
    }))));
    var this$124 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
    var $$x45 = $n($$x47).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x46, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$124));
    var this$126 = $m_s_$less$colon$less$();
    var this$$13 = $n($$x48).dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1($n(dsl)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x45, this$126.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_Loc$TimeReport.getClassOf()));
    var $$x50 = $n(dsl);
    var $$x49 = new $c_sjsr_AnonFunction3(((rt$8$2, ctl$8$2, p$9$2) => {
      var rt$8 = $as_Lreactbuild_Loc$TimeReport(rt$8$2);
      $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$8$2);
      $as_Ldiode_react_ModelProxy(p$9$2);
      return $m_Lreactbuild_analyze_cost_modules_Report$().apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement($n(rt$8).Lreactbuild_Loc$TimeReport__f_date)
    }));
    var this$129 = $m_s_$less$colon$less$();
    var g$6 = $n($$x50).dynRenderRP__F3__F1__F1($$x49, this$129.s_$less$colon$less$__f_singleton);
    var that$14 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$13).apply__O__O(g$6));
    var r = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$131, that$14);
    var $$x51 = $f_Ljapgolly_scalajs_react_extra_router_RoutingRule__noFallback__Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF(r);
    $n(dsl);
    var page = $m_Lreactbuild_Loc$Home$();
    var via = $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$();
    return $n($n($$x51).notFound__F1__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF($n(dsl)._auto_notFound_from_parsed__O__F1__F1(new $c_Ljapgolly_scalajs_react_extra_router_RedirectToPage(page, via), new $c_sjsr_AnonFunction1(((r$2) => {
      var r$1 = $as_Ljapgolly_scalajs_react_extra_router_Redirect(r$2);
      $n(dsl);
      $n($m_s_package$().s_package$__f_Left);
      return new $c_s_util_Left(r$1)
    }))))).setTitleP__F2__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(new $c_sjsr_AnonFunction2(((p$10$2, props$2) => {
      var p$10 = $as_Lreactbuild_Loc(p$10$2);
      $as_Ldiode_react_ModelProxy(props$2);
      return ($n(p$10).title__T() + ", ReactBuild")
    })))
  }));
  var this$140 = $n($n($as_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(f$2.apply__O__O(new $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl()))).renderWithP__F2__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(new $c_sjsr_AnonFunction2(((c$2$2, r$2$1) => {
    var c$8 = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(c$2$2);
    var r$3 = $as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(r$2$1);
    return new $c_sjsr_AnonFunction1(((p$2$2) => {
      var p$11 = $as_Ldiode_react_ModelProxy(p$2$2);
      var u$1 = $m_Lreactbuild_analyze_cost_components_Root$().apply__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(p$11, c$8, r$3);
      var this$138 = $n(u$1);
      var n$1 = this$138.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    }))
  }))));
  this.Lreactbuild_analyze_cost_RouterConfig$__f_routerConfig = this$140.logWith__F1__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF($m_Ljapgolly_scalajs_react_extra_router_RouterConfig$().consoleLogger__F1())
}
$c_Lreactbuild_analyze_cost_RouterConfig$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_RouterConfig$.prototype.constructor = $c_Lreactbuild_analyze_cost_RouterConfig$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_RouterConfig$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_RouterConfig$.prototype = $c_Lreactbuild_analyze_cost_RouterConfig$.prototype;
var $d_Lreactbuild_analyze_cost_RouterConfig$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_RouterConfig$: 0
}, false, "reactbuild.analyze.cost.RouterConfig$", {
  Lreactbuild_analyze_cost_RouterConfig$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_RouterConfig$.prototype.$classData = $d_Lreactbuild_analyze_cost_RouterConfig$;
var $n_Lreactbuild_analyze_cost_RouterConfig$;
function $m_Lreactbuild_analyze_cost_RouterConfig$() {
  if ((!$n_Lreactbuild_analyze_cost_RouterConfig$)) {
    $n_Lreactbuild_analyze_cost_RouterConfig$ = new $c_Lreactbuild_analyze_cost_RouterConfig$()
  };
  return $n_Lreactbuild_analyze_cost_RouterConfig$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_RouterConfigCommon$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_RouterConfigCommon$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_RouterConfigCommon$.prototype.constructor = $c_Lreactbuild_analyze_cost_RouterConfigCommon$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_RouterConfigCommon$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_RouterConfigCommon$.prototype = $c_Lreactbuild_analyze_cost_RouterConfigCommon$.prototype;
$c_Lreactbuild_analyze_cost_RouterConfigCommon$.prototype.refTo__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB = (function(dsl) {
  return $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n(dsl).Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__f_uuid).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_ju_UUID(s$2);
    return new $c_Lreactbuild_common_model_RefTo(s)
  })), new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_common_model_RefTo(x$1$2);
    return $n(x$1).Lreactbuild_common_model_RefTo__f_id
  }))))
});
var $d_Lreactbuild_analyze_cost_RouterConfigCommon$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_RouterConfigCommon$: 0
}, false, "reactbuild.analyze.cost.RouterConfigCommon$", {
  Lreactbuild_analyze_cost_RouterConfigCommon$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_RouterConfigCommon$.prototype.$classData = $d_Lreactbuild_analyze_cost_RouterConfigCommon$;
var $n_Lreactbuild_analyze_cost_RouterConfigCommon$;
function $m_Lreactbuild_analyze_cost_RouterConfigCommon$() {
  if ((!$n_Lreactbuild_analyze_cost_RouterConfigCommon$)) {
    $n_Lreactbuild_analyze_cost_RouterConfigCommon$ = new $c_Lreactbuild_analyze_cost_RouterConfigCommon$()
  };
  return $n_Lreactbuild_analyze_cost_RouterConfigCommon$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_AutoScrollArea$() {
  this.Lreactbuild_analyze_cost_components_AutoScrollArea$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_AutoScrollArea$ = this;
  this.Lreactbuild_analyze_cost_components_AutoScrollArea$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).justChildren__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $n($as_Ljapgolly_scalajs_react_PropsChildren(c$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$4 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_autoScrollAreaContainerWrapper;
    var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$7 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_autoScrollAreaContainer;
    var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$1), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c))];
    var array$1 = [$$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  })))
}
$c_Lreactbuild_analyze_cost_components_AutoScrollArea$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_AutoScrollArea$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_AutoScrollArea$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_AutoScrollArea$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_AutoScrollArea$.prototype = $c_Lreactbuild_analyze_cost_components_AutoScrollArea$.prototype;
$c_Lreactbuild_analyze_cost_components_AutoScrollArea$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_analyze_cost_components_AutoScrollArea$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_components_AutoScrollArea$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_AutoScrollArea$: 0
}, false, "reactbuild.analyze.cost.components.AutoScrollArea$", {
  Lreactbuild_analyze_cost_components_AutoScrollArea$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_AutoScrollArea$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_AutoScrollArea$;
var $n_Lreactbuild_analyze_cost_components_AutoScrollArea$;
function $m_Lreactbuild_analyze_cost_components_AutoScrollArea$() {
  if ((!$n_Lreactbuild_analyze_cost_components_AutoScrollArea$)) {
    $n_Lreactbuild_analyze_cost_components_AutoScrollArea$ = new $c_Lreactbuild_analyze_cost_components_AutoScrollArea$()
  };
  return $n_Lreactbuild_analyze_cost_components_AutoScrollArea$
}
function $p_Lreactbuild_analyze_cost_components_AutomaticallySave$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("AutomaticallySave", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps(p$2);
    return $n(p).deriveState__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState()
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_AutomaticallySave$() {
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$__f_reusableKey = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_AutomaticallySave$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((key$2) => {
    var key = $as_T(key$2);
    return key
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$__f_reusableKey = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  var this$9 = $n($n($n($p_Lreactbuild_analyze_cost_components_AutomaticallySave$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var f$1 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(\u03b4$2);
    var $$x5 = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend($n(\u03b4).backend__O());
    var this$6 = $n(\u03b4);
    var $$x4 = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps($n(this$6.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var $$x3 = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps($n(\u03b4).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps);
    var this$7 = $n(\u03b4);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).onPropsChange__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__Ljapgolly_scalajs_react_callback_Trampoline($$x4, $$x3, $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$7))))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$11 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$9, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$1, G));
  var f$2 = new $c_sjsr_AnonFunction1(((\u03b4$3$2) => {
    var \u03b4$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(\u03b4$3$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend($n(\u03b4$3).backend__O())).onUnmount__Ljapgolly_scalajs_react_callback_Trampoline())
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$15 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$11, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillUnmount__Ljapgolly_scalajs_react_internal_Lens(), f$2, G$1));
  var this$13 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var evidence$1 = this$13.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var f$3 = $m_Ljapgolly_scalajs_react_extra_OnUnmountF$().install__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(evidence$1);
  var this$19 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$3).apply__O__O(this$15)));
  var x$2$2 = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(c$2);
    var this$16 = $n(c);
    var eta$0$1 = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend($f_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot__backend__O(this$16));
    return new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(eta$0$1).onUnload__Lorg_scalajs_dom_BeforeUnloadEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$2))))
  }));
  var x$3$3 = new $c_sjsr_AnonFunction1(((x$7$2) => {
    $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$7$2);
    return window
  }));
  var f$4 = $m_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$().install$extension__Z__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(true, "beforeunload", x$2$2, x$3$3, false, $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$4).apply__O__O(this$19))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_AutomaticallySave$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_AutomaticallySave$.prototype = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$.prototype;
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__F1__F1__F2__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(state, updater, render, reusableT, keyMapper) {
  var c = this.Lreactbuild_analyze_cost_components_AutomaticallySave$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps(state, updater, render, reusableT, keyMapper);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_AutomaticallySave$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_AutomaticallySave$: 0
}, false, "reactbuild.analyze.cost.components.AutomaticallySave$", {
  Lreactbuild_analyze_cost_components_AutomaticallySave$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_AutomaticallySave$;
var $n_Lreactbuild_analyze_cost_components_AutomaticallySave$;
function $m_Lreactbuild_analyze_cost_components_AutomaticallySave$() {
  if ((!$n_Lreactbuild_analyze_cost_components_AutomaticallySave$)) {
    $n_Lreactbuild_analyze_cost_components_AutomaticallySave$ = new $c_Lreactbuild_analyze_cost_components_AutomaticallySave$()
  };
  return $n_Lreactbuild_analyze_cost_components_AutomaticallySave$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Changelog$() {
  this.Lreactbuild_analyze_cost_components_Changelog$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_Changelog$ = this;
  this.Lreactbuild_analyze_cost_components_Changelog$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_jl_Void(x$1$2);
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $m_Lreactbuild_analyze_cost_components_Changelog$().changelog__sci_List();
    var array$1 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((ev$2) => {
      var ev = $as_Lreactbuild_analyze_cost_components_Changelog$Event(ev$2);
      var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("list-item", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n(ev).render__Ljapgolly_scalajs_react_vdom_TagMod()];
      return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    })))];
    var array$2 = [$n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ol", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonN__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner($m_Ljapgolly_scalajs_react_internal_Singleton$().Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit))
}
$c_Lreactbuild_analyze_cost_components_Changelog$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Changelog$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Changelog$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Changelog$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Changelog$.prototype = $c_Lreactbuild_analyze_cost_components_Changelog$.prototype;
$c_Lreactbuild_analyze_cost_components_Changelog$.prototype.apply__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function() {
  var c = this.Lreactbuild_analyze_cost_components_Changelog$__f_component;
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n($as_Ljapgolly_scalajs_react_CtorType$Nullary($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).apply__O())
});
$c_Lreactbuild_analyze_cost_components_Changelog$.prototype.changelog__sci_List = (function() {
  $n($m_s_package$().s_package$__f_List);
  var $$x21 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Dans les listes, il est possible de cliquer sur une ligne pour la s\u00e9lectionner", $m_s_package$().s_package$__f_Nil);
  var $$x20 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Les vues documents on maintenant une option permettant de passer sur chaque document avec l'image d'un c\u00f4t\u00e9 et le d\u00e9tails de l'autre", $m_s_package$().s_package$__f_Nil);
  var $$x19 = $m_s_package$().s_package$__f_Seq;
  var array = ["Ressources", "s\u00e9lectionner une ressource", "Usage"];
  var $$x18 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Ajout d'une vue utilisation des ressources", $as_sci_Seq($n($$x19).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))));
  var $$x17 = $m_s_package$().s_package$__f_Seq;
  var array$1 = ["Tableau de bord", "Mettre \u00e0 jour le relev\u00e9 d'heures"];
  var $$x16 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Ajout d'un mini-calendrier sur la mise \u00e0 jour des relev\u00e9s d'heures", $as_sci_Seq($n($$x17).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))));
  var $$x15 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Possibilit\u00e9 de basculer d'une vue des cumuls \u00e0 une vue des valeurs sur les tableaux de cumuls", $m_s_package$().s_package$__f_Nil);
  var $$x14 = $m_s_package$().s_package$__f_Seq;
  var array$2 = ["Projets", "s\u00e9lectionner un projet", "Liste de travail"];
  var $$x13 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Liste de travail sur chaque projet (liste de choses restantes \u00e0 faire)", $as_sci_Seq($n($$x14).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))));
  var $$x12 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Changement du nom du bouton Accueil par Tableau de bord et ajout d'un nouveau bouton Accueil en haut \u00e0 gauche redirigeant vers la liste des projets en vente", $m_s_package$().s_package$__f_Nil);
  var $$x11 = $m_s_package$().s_package$__f_Seq;
  var array$3 = ["Personnes", "s\u00e9lectionner un fournisseur", "Produits"];
  var $$x10 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Possibilit\u00e9 d'enregistrer le corps d'\u00e9tat par d\u00e9faut sur un produit de la liste de produits d'un fournisseur", $as_sci_Seq($n($$x11).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))));
  var $$x9 = $m_s_package$().s_package$__f_Seq;
  var array$4 = ["Factures", "clic droit sur bouton afficher d'une facture", "ouvrir dans un nouvel onglet"];
  var $$x8 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Correctifs sur le traitement des factures (ascenseur qui se d\u00e9calait lorsqu'on tapait une recherche, changement des priorit\u00e9s pour les r\u00e9sultats de recherche, agrandissement de certaines colonnes)", $as_sci_Seq($n($$x9).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))));
  var $$x7 = $m_s_package$().s_package$__f_Seq;
  var array$5 = ["Factures", "clic droit sur bouton afficher d'une facture", "ouvrir dans un nouvel onglet"];
  var $$x6 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Possibilit\u00e9 de s\u00e9lectioner des lignes de d\u00e9tails d'une facture et de pouvoir affecter un projet \u00e0 toute la s\u00e9lection", $as_sci_Seq($n($$x7).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))));
  var $$x5 = $m_s_package$().s_package$__f_Seq;
  var array$6 = ["Tableau de bord", "Mettre \u00e0 jour le relev\u00e9 d'heures"];
  var $$x4 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Possibilit\u00e9 de voir les diff\u00e9rentes heures enregistr\u00e9es par les badges et de pouvoir affecter le temps sur un couple projet-corps d'\u00e9tat", $as_sci_Seq($n($$x5).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))));
  var $$x3 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Les tableaux ont maintenant leurs en-t\u00eates fixes. Lorsqu'on descend plus bas ou plus \u00e0 droite dans le tableau les en-t\u00eate de colonnes et de lignes restent \u00e0 l'\u00e9cran.", $m_s_package$().s_package$__f_Nil);
  var $$x2 = new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Ajout du support des badges d'utilisateur pour enregistrer les horaires d'entr\u00e9es/sorties", $m_s_package$().s_package$__f_Nil);
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array$7 = ["Personnes", "s\u00e9lectionner un fournisseur", "Produits"];
  var array$8 = [$$x21, $$x20, $$x18, $$x16, $$x15, $$x13, $$x12, $$x10, $$x8, $$x6, $$x4, $$x3, $$x2, new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Liste des produits des fournisseurs avec \u00e9volution des tarifs dans le temps", $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)))), new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Sur mobile, les PDF ne sont pas affich\u00e9s mais d\u00e9sormais un bouton appara\u00eet permettant au moins de le t\u00e9l\u00e9charger", $m_s_package$().s_package$__f_Nil), new $c_Lreactbuild_analyze_cost_components_Changelog$Event("Sur les projets, il y a maintenant une option pour voir le Temps pass\u00e9, le Co\u00fbt du travail et des achats", $m_s_package$().s_package$__f_Nil)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
var $d_Lreactbuild_analyze_cost_components_Changelog$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Changelog$: 0
}, false, "reactbuild.analyze.cost.components.Changelog$", {
  Lreactbuild_analyze_cost_components_Changelog$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_Changelog$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Changelog$;
var $n_Lreactbuild_analyze_cost_components_Changelog$;
function $m_Lreactbuild_analyze_cost_components_Changelog$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Changelog$)) {
    $n_Lreactbuild_analyze_cost_components_Changelog$ = new $c_Lreactbuild_analyze_cost_components_Changelog$()
  };
  return $n_Lreactbuild_analyze_cost_components_Changelog$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$() {
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_DocumentPageEditor$ = this;
  var this$20 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DocumentPageEditor", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(new $c_Lreactbuild_model_InvoiceDetail(($m_Lreactbuild_model_InvoiceDetail$(), $m_ju_UUID$().randomUUID__ju_UUID()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), $m_s_package$().s_package$__f_Nil, $m_Ldiode_data_Empty$(), $m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend($n(x$3).backend__O()));
    var this$15 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props($n(this$15.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$16 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__Lreactbuild_analyze_cost_components_DocumentPageEditor$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$16)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    var $$x5 = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend($n(c).backend__O());
    var this$17 = $n(c);
    var $$x4 = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props($n(this$17.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var $$x3 = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps);
    var this$18 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).onPropsChange__Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__Lreactbuild_analyze_cost_components_DocumentPageEditor$State__Ljapgolly_scalajs_react_callback_Trampoline($$x4, $$x3, $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$18))))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$20, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DocumentPageEditor$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DocumentPageEditor$.prototype = $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$.prototype;
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$.prototype.apply__Ldiode_data_Pot__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(document, pageProps) {
  if ($n(document).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(document).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(document);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(document).get__O();
      var document$2 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
      var $$x9 = $m_Lreactbuild_analyze_cost_components_AutomaticallySave$();
      var $$x4 = new $c_sjsr_AnonFunction1(((v$2) => {
        var v$1 = $as_Lreactbuild_model_InvoicePage(v$2);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
          var this$13 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var $$x8 = new $c_Lautowire_ClientProxy(this$13).Lautowire_ClientProxy__f_self;
          var $$x7 = $m_s_package$().s_package$__f_Seq;
          var array$1 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistInvoicePage"];
          var $$x6 = $as_sci_Seq($n($$x7).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
          var this$28 = $n($m_s_Predef$().s_Predef$__f_Map);
          var this$18 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$19 = $n(new $c_Lautowire_ClientProxy(this$18).Lautowire_ClientProxy__f_self);
          var evidence$2 = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
          var y = this$19.write__O__Lio_circe_Encoder__Lio_circe_Json(v$1, evidence$2);
          var $$x5 = $ct_T2__O__O__(new $c_T2(), "x", y);
          var this$22 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$23 = $n(new $c_Lautowire_ClientProxy(this$22).Lautowire_ClientProxy__f_self);
          var evidence$2$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
          var y$1 = this$23.write__O__Lio_circe_Encoder__Lio_circe_Json(1, evidence$2$1);
          var array$2 = [$$x5, $ct_T2__O__O__(new $c_T2(), "way", y$1)];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
          return $n($n($n($$x8).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x6, this$28.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
            var x$1 = $as_Lio_circe_Json(x$1$2);
            var this$29 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var this$31 = $n(new $c_Lautowire_ClientProxy(this$29).Lautowire_ClientProxy__f_self);
            $m_Lio_circe_Decoder$();
            var d = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
            var evidence$1 = new $c_Lio_circe_Decoder$$anon$39(d);
            return $as_s_Option(this$31.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
          })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$57$2) => {
            $as_s_Option(x$57$2);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
          })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue))
      }));
      var $$x3 = new $c_sjsr_AnonFunction1(((doc$2) => {
        var doc = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(doc$2);
        var c = $m_Lreactbuild_analyze_cost_components_DocumentPageEditor$().Lreactbuild_analyze_cost_components_DocumentPageEditor$__f_component;
        var this$33 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
        var props = new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(doc, pageProps);
        var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$33.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$33.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
        var this$35 = $n(u);
        var n = this$35.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      }));
      $m_Lreactbuild_model_Implicits$();
      var this$38 = $m_Ljapgolly_scalajs_react_Reusability$();
      var u$1 = $n($$x9).apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__F1__F1__F2__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(document$2, $$x4, $$x3, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$38.byRef__F2(), this$38.by_$eq$eq__F2()), $m_Lreactbuild_model_InvoicePage$().keyMapper__Lcom_iz2use_common_KeyMapper());
      var this$40 = $n(u$1);
      var n$1 = this$40.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    } else if ($n(document).isPending__Z()) {
      return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    }
  }
});
var $d_Lreactbuild_analyze_cost_components_DocumentPageEditor$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DocumentPageEditor$: 0
}, false, "reactbuild.analyze.cost.components.DocumentPageEditor$", {
  Lreactbuild_analyze_cost_components_DocumentPageEditor$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DocumentPageEditor$;
var $n_Lreactbuild_analyze_cost_components_DocumentPageEditor$;
function $m_Lreactbuild_analyze_cost_components_DocumentPageEditor$() {
  if ((!$n_Lreactbuild_analyze_cost_components_DocumentPageEditor$)) {
    $n_Lreactbuild_analyze_cost_components_DocumentPageEditor$ = new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$()
  };
  return $n_Lreactbuild_analyze_cost_components_DocumentPageEditor$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$() {
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$ = this;
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().getDerivedStateFromPropsAndState$extension__T__F2__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DocumentPageGroupEditor", new $c_sjsr_AnonFunction2(((p$2, s$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props(p$2);
    var s = $as_s_Option(s$2);
    return $n($n(p).Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_invoicePageGroup).flatMap__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((group$2) => {
      var group = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(group$2);
      var $$x5 = $m_Ldiode_data_Pot$();
      var this$4 = $n($n($n($as_Lreactbuild_model_InvoicePageGroup($n(group).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePageGroup__f_pages).find__F1__s_Option(new $c_sjsr_AnonFunction1(((p$2$1) => {
        var p$1 = $as_Lreactbuild_model_InvoicePage(p$2$1);
        var this$2 = $n(s);
        if ((!this$2.isEmpty__Z())) {
          var arg1 = this$2.get__O();
          var x$12 = $as_Ldiode_data_Pot(arg1);
          var this$3 = $n(x$12);
          if ((!this$3.isEmpty__Z())) {
            var arg1$1 = this$3.get__O();
            var x$13 = $as_Lreactbuild_common_model_RefTo(arg1$1);
            var x$2 = $n(p$1).Lreactbuild_model_InvoicePage__f__id;
            return ((x$13 === null) ? (x$2 === null) : $n(x$13).equals__O__Z(x$2))
          } else {
            return false
          }
        } else {
          return false
        }
      }))));
      if (this$4.isEmpty__Z()) {
        var this$6 = $n($n($as_Lreactbuild_model_InvoicePageGroup($n(group).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePageGroup__f_pages);
        var f = new $c_sjsr_AnonFunction1(((x$14$2) => {
          var x$14 = $as_Lreactbuild_model_InvoicePage(x$14$2);
          return $n(x$14).Lreactbuild_model_InvoicePage__f_pageIndex
        }));
        var ord = $m_s_math_Ordering$Int$();
        var ord$1 = new $c_s_math_Ordering$O$1(ord);
        var $$x3 = $n($as_sc_IterableOps($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$6, f, ord$1))).headOption__s_Option()
      } else {
        var $$x3 = this$4
      };
      var this$7 = $n($$x3);
      if (this$7.isEmpty__Z()) {
        var $$x4 = $m_s_None$()
      } else {
        var arg1$2 = this$7.get__O();
        var x$15 = $as_Lreactbuild_model_InvoicePage(arg1$2);
        var $$x4 = new $c_s_Some($n(x$15).Lreactbuild_model_InvoicePage__f__id)
      };
      return $n($$x5).fromOption__s_Option__Ldiode_data_Pot($$x4)
    })))
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2$1) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2$1);
    return new $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend($n(x$3).backend__O()));
    var this$8 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props($n(this$8.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$9 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__Ldiode_data_Pot__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Ldiode_data_Pot($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$9)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$.prototype = $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$.prototype;
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$.prototype.apply__Ldiode_data_Pot__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(invoicePageGroup, pageProps) {
  var c = this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props(invoicePageGroup, pageProps);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$: 0
}, false, "reactbuild.analyze.cost.components.DocumentPageGroupEditor$", {
  Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$;
var $n_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$;
function $m_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$() {
  if ((!$n_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$)) {
    $n_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$ = new $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$()
  };
  return $n_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DocumentPageList$() {
  this.Lreactbuild_analyze_cost_components_DocumentPageList$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_DocumentPageList$ = this;
  this.Lreactbuild_analyze_cost_components_DocumentPageList$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_DocumentPageList$Props(p$2);
    var this$5 = $n($as_sc_SeqOps($n($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_invoicePageGroup).Lreactbuild_model_InvoicePageGroup__f_pages).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lreactbuild_model_InvoicePage(x$1$2);
      return $n(x$1).Lreactbuild_model_InvoicePage__f__id
    })))));
    var f = new $c_sjsr_AnonFunction1(((id$2) => {
      var id = $as_Lreactbuild_common_model_RefTo(id$2);
      var this$2 = $n($n($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_invoicePageGroup).Lreactbuild_model_InvoicePageGroup__f_pages).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2 = $as_Lreactbuild_model_InvoicePage(x$2$2);
        var x = $n(x$2).Lreactbuild_model_InvoicePage__f__id;
        return ((x === null) ? (id === null) : $n(x).equals__O__Z(id))
      }))));
      if (this$2.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1 = this$2.get__O();
        var x$3 = $as_Lreactbuild_model_InvoicePage(arg1);
        return new $c_s_Some($n(x$3).Lreactbuild_model_InvoicePage__f_pageIndex)
      }
    }));
    var ord = $m_s_math_Ordering$Int$();
    var ord$1 = new $c_s_math_Ordering$O$1(ord);
    var ord$2 = new $c_s_math_Ordering$O$1(ord$1);
    var x$1$3 = $as_sci_Seq($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$5, f, ord$2));
    var x$2$1 = $n(p).Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_active;
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var x$3$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Pages");
    var x$5$2 = new $c_sjsr_AnonFunction1(((pageRef$2) => {
      var pageRef = $as_Lreactbuild_common_model_RefTo(pageRef$2);
      var pageOpt = $n($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_invoicePageGroup).Lreactbuild_model_InvoicePageGroup__f_pages).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$4$2) => {
        var x$4 = $as_Lreactbuild_model_InvoicePage(x$4$2);
        var x$5 = $n(x$4).Lreactbuild_model_InvoicePage__f__id;
        return ((x$5 === null) ? (pageRef === null) : $n(x$5).equals__O__Z(pageRef))
      })));
      var this$8 = $n(pageOpt);
      if (this$8.isEmpty__Z()) {
        var $$x1 = $m_s_None$()
      } else {
        var arg1$1 = this$8.get__O();
        var x$5$1 = $as_Lreactbuild_model_InvoicePage(arg1$1);
        var $$x1 = $n(x$5$1).Lreactbuild_model_InvoicePage__f_pageIndex
      };
      var this$9 = $n($$x1);
      if (this$9.isEmpty__Z()) {
        var text = "?"
      } else {
        var arg1$2 = this$9.get__O();
        var x$6 = $uI(arg1$2);
        var text = ("" + x$6)
      };
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$11 = $n(pageOpt);
      if (this$11.isEmpty__Z()) {
        var o = $m_s_None$()
      } else {
        var arg1$3 = this$11.get__O();
        var x$7 = $as_Lreactbuild_model_InvoicePage(arg1$3);
        var o = $n(x$7).Lreactbuild_model_InvoicePage__f_deletedAt
      };
      var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var color = new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((p$2$1) => {
        $as_Ljava_time_Instant(p$2$1);
        return ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#808080", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
      })));
      var this$26 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var array = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "borderRadius")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).justifyContent__Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("24px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "border")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1px solid black", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), color, ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(text))];
      var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return this$26.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
    }));
    var x$6$1 = $m_Lcom_iz2use_react_components_Selector$().apply$default$6__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1(x$1$3, x$2$1, x$3$1, false);
    var $$x2 = $m_Lcom_iz2use_react_components_Selector$();
    var this$27 = $m_Lcom_iz2use_react_components_Selector$Focusable$();
    var u = $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1__F1__Lcom_iz2use_react_components_Selector$Focusable__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_Selector__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(x$1$3, x$2$1, x$3$1, false, x$5$2, x$6$1, new $c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3(this$27), $m_Lreactbuild_common_model_RefTo$().keyMapper__Lcom_iz2use_common_KeyMapper(), ($m_Lcom_iz2use_react_components_Selector$(), new $c_Lcom_iz2use_react_components_Selector$$anon$2()));
    var this$30 = $n(u);
    var n = this$30.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_DocumentPageList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DocumentPageList$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DocumentPageList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DocumentPageList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DocumentPageList$.prototype = $c_Lreactbuild_analyze_cost_components_DocumentPageList$.prototype;
$c_Lreactbuild_analyze_cost_components_DocumentPageList$.prototype.apply__Ldiode_data_Pot__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomNode = (function(invoicePageGroup, active) {
  if ($n(invoicePageGroup).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(invoicePageGroup).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(invoicePageGroup);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(invoicePageGroup).get__O();
      var invoicePageGroup$2 = $as_Lreactbuild_model_InvoicePageGroup(arg1);
      var c = $m_Lreactbuild_analyze_cost_components_DocumentPageList$().Lreactbuild_analyze_cost_components_DocumentPageList$__f_component;
      var this$13 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
      var props = new $c_Lreactbuild_analyze_cost_components_DocumentPageList$Props(invoicePageGroup$2, active);
      var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$13.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$13.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
      var this$15 = $n(u);
      var n = this$15.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    } else if ($n(invoicePageGroup).isPending__Z()) {
      return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    }
  }
});
var $d_Lreactbuild_analyze_cost_components_DocumentPageList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DocumentPageList$: 0
}, false, "reactbuild.analyze.cost.components.DocumentPageList$", {
  Lreactbuild_analyze_cost_components_DocumentPageList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageList$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DocumentPageList$;
var $n_Lreactbuild_analyze_cost_components_DocumentPageList$;
function $m_Lreactbuild_analyze_cost_components_DocumentPageList$() {
  if ((!$n_Lreactbuild_analyze_cost_components_DocumentPageList$)) {
    $n_Lreactbuild_analyze_cost_components_DocumentPageList$ = new $c_Lreactbuild_analyze_cost_components_DocumentPageList$()
  };
  return $n_Lreactbuild_analyze_cost_components_DocumentPageList$
}
function $p_Lreactbuild_analyze_cost_components_DropArea$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DropArea", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_components_DropArea$TypedProps(p$2);
    return new $c_Lreactbuild_analyze_cost_components_DropArea$TypedState(false, $m_Ldiode_data_Empty$())
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DropArea$() {
  this.Lreactbuild_analyze_cost_components_DropArea$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_DropArea$ = this;
  this.Lreactbuild_analyze_cost_components_DropArea$__f_component = $n($n($n($p_Lreactbuild_analyze_cost_components_DropArea$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_DropArea$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_DropArea$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_DropArea$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_DropArea$TypedProps__Lreactbuild_analyze_cost_components_DropArea$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_components_DropArea$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_DropArea$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DropArea$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DropArea$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DropArea$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DropArea$.prototype = $c_Lreactbuild_analyze_cost_components_DropArea$.prototype;
$c_Lreactbuild_analyze_cost_components_DropArea$.prototype.apply__F1__F1__F1__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(handler, render, preview, whenValid) {
  var c = this.Lreactbuild_analyze_cost_components_DropArea$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_DropArea$TypedProps(handler, render, preview, whenValid);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_DropArea$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DropArea$: 0
}, false, "reactbuild.analyze.cost.components.DropArea$", {
  Lreactbuild_analyze_cost_components_DropArea$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_DropArea$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DropArea$;
var $n_Lreactbuild_analyze_cost_components_DropArea$;
function $m_Lreactbuild_analyze_cost_components_DropArea$() {
  if ((!$n_Lreactbuild_analyze_cost_components_DropArea$)) {
    $n_Lreactbuild_analyze_cost_components_DropArea$ = new $c_Lreactbuild_analyze_cost_components_DropArea$()
  };
  return $n_Lreactbuild_analyze_cost_components_DropArea$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_ExpandableCard$() {
  this.Lreactbuild_analyze_cost_components_ExpandableCard$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_ExpandableCard$ = this;
  this.Lreactbuild_analyze_cost_components_ExpandableCard$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ExpandableCard", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_components_ExpandableCard$Props(p$2);
    return false
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_ExpandableCard$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_ExpandableCard$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_ExpandableCard$Props__Z__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $uZ($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)), $n(x$3).propsChildren__sjs_js_Any())
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_ExpandableCard$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_ExpandableCard$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_ExpandableCard$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_ExpandableCard$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_ExpandableCard$.prototype = $c_Lreactbuild_analyze_cost_components_ExpandableCard$.prototype;
$c_Lreactbuild_analyze_cost_components_ExpandableCard$.prototype.apply__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(title, children) {
  var c = this.Lreactbuild_analyze_cost_components_ExpandableCard$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_ExpandableCard$Props(title);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_components_ExpandableCard$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_ExpandableCard$: 0
}, false, "reactbuild.analyze.cost.components.ExpandableCard$", {
  Lreactbuild_analyze_cost_components_ExpandableCard$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_ExpandableCard$;
var $n_Lreactbuild_analyze_cost_components_ExpandableCard$;
function $m_Lreactbuild_analyze_cost_components_ExpandableCard$() {
  if ((!$n_Lreactbuild_analyze_cost_components_ExpandableCard$)) {
    $n_Lreactbuild_analyze_cost_components_ExpandableCard$ = new $c_Lreactbuild_analyze_cost_components_ExpandableCard$()
  };
  return $n_Lreactbuild_analyze_cost_components_ExpandableCard$
}
function $p_Lreactbuild_analyze_cost_components_Feature$__content$1__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_components_FeatureState__Lreactbuild_analyze_cost_components_Feature$Props__sjs_js_Any__Ljapgolly_scalajs_react_vdom_TagMod($thiz, expanded$1, fState$1, props$1, children$1) {
  var this$28 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var this$4 = $n(this$3.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  var condition = $uZ($n(expanded$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var condition$1 = (!condition);
  var $$x7 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$4, condition$1);
  var this$5 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_featureStateDescription;
  var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n(fState$1).description__Lsourcecode_Enclosing__sci_Seq($n(props$1).Lreactbuild_analyze_cost_components_Feature$Props__f_program);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  var this$7 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  var sep = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_vdom_HtmlTags__br__T(this$7), $m_sci_Nil$());
  var this$9 = $m_s_$less$colon$less$();
  var f = this$9.s_$less$colon$less$__f_singleton;
  var array = [$$x7, $$x6, $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f)];
  var $$x4 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("p", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$16 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_featureStateWrapper;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$16, s$1);
  var this$17 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var cond = $n(props$1).Lreactbuild_analyze_cost_components_Feature$Props__f_fullSpace;
  if (cond) {
    var this$18 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_featureStateWrapperFullSpace;
    var $$x1 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$18, s$2)
  } else {
    var $$x1 = this$17.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  };
  var array$1 = [$$x2, $$x1, ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(children$1))];
  var array$2 = [$$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  return this$28.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Feature$() {
  this.Lreactbuild_analyze_cost_components_Feature$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_Feature$ = this;
  var this$37 = $m_Lcom_iz2use_react_hooks_package$();
  var api = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First();
  var this$36 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshotBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(props$2);
    return $n($n($as_Lreactbuild_analyze_cost_components_Feature$Props($n(props).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)).Lreactbuild_analyze_cost_components_Feature$Props__f_state).initiallyExpanded__Z()
  })), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep())));
  var f = new $c_sjsr_AnonFunction3(((props$3$2, children$2, expanded$2) => {
    var props$3 = $as_Lreactbuild_analyze_cost_components_Feature$Props(props$3$2);
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var expanded = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(expanded$2);
    var fState = $n(props$3).Lreactbuild_analyze_cost_components_Feature$Props__f_state;
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$7 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_featureStateContainer;
    var $$x8 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s);
    var this$8 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var cond = $n(props$3).Lreactbuild_analyze_cost_components_Feature$Props__f_fullSpace;
    if (cond) {
      var this$9 = $m_Lscalacss_ScalaCssReact$();
      var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_featureStateContainerFullSpace;
      var $$x7 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$9, s$1)
    } else {
      var $$x7 = this$8.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
    };
    var this$10 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $n(fState).style__Lscalacss_internal_StyleA();
    var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s$2);
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$13 = $m_Lscalacss_ScalaCssReact$();
    var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_featureStateTitle;
    var $$x4 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$13, s$3);
    var $$x3 = $m_Lcom_iz2use_react_components_Link$();
    var this$14 = $n(expanded);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$15 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$16 = $n(this$15.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$16.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$17 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$17.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$14.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$1 = $uZ(arg1);
    var arg1$1 = (!x$1);
    var $$x2 = $n($$x3).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$14.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var this$18 = $n(fState);
    var array = [this$18.title__Ljapgolly_scalajs_react_vdom_VdomNode()];
    var array$1 = [$$x4, $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var $$x1 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var this$25 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var cond$1 = ((!$n($n(props$3).Lreactbuild_analyze_cost_components_Feature$Props__f_state).globallyExpanded__Z()) || $uZ($n(expanded).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
    var array$2 = [$$x8, $$x7, $$x6, $$x1, (cond$1 ? $p_Lreactbuild_analyze_cost_components_Feature$__content$1__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_components_FeatureState__Lreactbuild_analyze_cost_components_Feature$Props__sjs_js_Any__Ljapgolly_scalajs_react_vdom_TagMod(this, expanded, fState, props$3, children) : this$25.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty)];
    var result = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    if ($n(props$3).Lreactbuild_analyze_cost_components_Feature$Props__f_fullSpace) {
      var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$31 = $m_Lscalacss_ScalaCssReact$();
      var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_featureStateContainerParentFullSpace;
      var array$3 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$31, s$4), result];
      return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    } else {
      return result
    }
  }));
  var this$35 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$35);
  var s$5 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$36, f, step, s$5);
  this.Lreactbuild_analyze_cost_components_Feature$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$37, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.components.Feature.component"))
}
$c_Lreactbuild_analyze_cost_components_Feature$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Feature$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Feature$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Feature$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Feature$.prototype = $c_Lreactbuild_analyze_cost_components_Feature$.prototype;
$c_Lreactbuild_analyze_cost_components_Feature$.prototype.notImplemented__Z__sci_Seq__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_vdom_TagOf = (function(full, children, program) {
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x1 = this$3.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var c = this.Lreactbuild_analyze_cost_components_Feature$__f_component;
  var this$5 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_Feature$Props($m_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$(), program, full);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$5.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$5.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children));
  var this$7 = $n(u);
  var n = this$7.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_analyze_cost_components_Feature$.prototype.workInProgress__Z__sci_Seq__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(full, children, program) {
  var c = this.Lreactbuild_analyze_cost_components_Feature$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_Feature$Props($m_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$(), program, full);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_components_Feature$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Feature$: 0
}, false, "reactbuild.analyze.cost.components.Feature$", {
  Lreactbuild_analyze_cost_components_Feature$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_Feature$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Feature$;
var $n_Lreactbuild_analyze_cost_components_Feature$;
function $m_Lreactbuild_analyze_cost_components_Feature$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Feature$)) {
    $n_Lreactbuild_analyze_cost_components_Feature$ = new $c_Lreactbuild_analyze_cost_components_Feature$()
  };
  return $n_Lreactbuild_analyze_cost_components_Feature$
}
function $is_Lreactbuild_analyze_cost_components_Handle(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_components_Handle)))
}
function $as_Lreactbuild_analyze_cost_components_Handle(obj) {
  return (($is_Lreactbuild_analyze_cost_components_Handle(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Handle"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Handle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Handle)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Handle(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Handle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Handle;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$() {
  $n_Lreactbuild_analyze_cost_components_Handle$ = this;
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_components_Handle(x$1$2);
    return $n(x$1).order__I()
  }));
  var ord = $m_s_math_Ordering$Int$();
  new $c_s_math_Ordering$$anon$5(ord, f)
}
$c_Lreactbuild_analyze_cost_components_Handle$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$.prototype.apply__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_Handle__Ljapgolly_scalajs_react_vdom_TagOf = (function(area, handle) {
  var pt = $n(handle).getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point(area);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
  var array = [this$3.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("absolute", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((($n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_x - 2.0) + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("top")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((($n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_y - 2.0) + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lreactbuild_analyze_cost_components_Handle$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$: 0
}, false, "reactbuild.analyze.cost.components.Handle$", {
  Lreactbuild_analyze_cost_components_Handle$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$;
var $n_Lreactbuild_analyze_cost_components_Handle$;
function $m_Lreactbuild_analyze_cost_components_Handle$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$ = new $c_Lreactbuild_analyze_cost_components_Handle$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_LateralBar$() {
  this.Lreactbuild_analyze_cost_components_LateralBar$__f_notConnectedPages = null;
  this.Lreactbuild_analyze_cost_components_LateralBar$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_LateralBar$ = this;
  var this$2 = $n($m_Lreactbuild_Loc$().Lreactbuild_Loc$__f_pages);
  var f = ((x$1$2) => {
    var x$1 = $as_Lreactbuild_Loc(x$1$2);
    return $n(x$1).isPubliclyAvailable__Z()
  });
  var l = this$2;
  block: {
    var result;
    while (true) {
      if ($n(l).isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break
      } else {
        var h = $n(l).head__O();
        var t = $as_sci_List($n(l).tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue
        };
        var start = l;
        var remaining = t;
        while (true) {
          if ($n(remaining).isEmpty__Z()) {
            var result = start;
            break block
          } else {
            var x = $n(remaining).head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List($n(remaining).tail__O());
              continue
            };
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List($n(start).tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
              $n(currentLast).sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List($n(toProcess).tail__O())
            };
            var next = $as_sci_List($n(firstMiss).tail__O());
            var nextToCopy = next;
            while ((!$n(next).isEmpty__Z())) {
              var head = $n(next).head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List($n(next).tail__O())
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                };
                nextToCopy = $as_sci_List($n(next).tail__O());
                next = $as_sci_List($n(next).tail__O())
              }
            };
            if ((!$n(nextToCopy).isEmpty__Z())) {
              $n(currentLast).sci_$colon$colon__f_next = nextToCopy
            };
            var result = newHead;
            break block
          }
        }
      }
    }
  };
  this.Lreactbuild_analyze_cost_components_LateralBar$__f_notConnectedPages = result;
  this.Lreactbuild_analyze_cost_components_LateralBar$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("LateralBar", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_components_LateralBar$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_components_LateralBar$State(false)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_LateralBar$Backend(x$3)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3$1 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_LateralBar$Backend($n(x$3$1).backend__O()));
    var this$5 = $n(x$3$1);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_LateralBar$Props($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3$1);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_LateralBar$Props__Lreactbuild_analyze_cost_components_LateralBar$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_components_LateralBar$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_LateralBar$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_LateralBar$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_LateralBar$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_LateralBar$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_LateralBar$.prototype = $c_Lreactbuild_analyze_cost_components_LateralBar$.prototype;
$c_Lreactbuild_analyze_cost_components_LateralBar$.prototype.apply__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(m, c, r) {
  var c$1 = this.Lreactbuild_analyze_cost_components_LateralBar$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c$1).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType("LateralBar")));
  var props = new $c_Lreactbuild_analyze_cost_components_LateralBar$Props(m, c, r);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_LateralBar$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_LateralBar$: 0
}, false, "reactbuild.analyze.cost.components.LateralBar$", {
  Lreactbuild_analyze_cost_components_LateralBar$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_LateralBar$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_LateralBar$;
var $n_Lreactbuild_analyze_cost_components_LateralBar$;
function $m_Lreactbuild_analyze_cost_components_LateralBar$() {
  if ((!$n_Lreactbuild_analyze_cost_components_LateralBar$)) {
    $n_Lreactbuild_analyze_cost_components_LateralBar$ = new $c_Lreactbuild_analyze_cost_components_LateralBar$()
  };
  return $n_Lreactbuild_analyze_cost_components_LateralBar$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_MaybeRelated$() {
  this.Lreactbuild_analyze_cost_components_MaybeRelated$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_MaybeRelated$ = this;
  var this$8 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("MaybeRelated", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_components_MaybeRelated$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_components_MaybeRelated$State($m_Ldiode_data_Unavailable$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_MaybeRelated$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_MaybeRelated$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_MaybeRelated$Props__Lreactbuild_analyze_cost_components_MaybeRelated$State__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lreactbuild_analyze_cost_components_MaybeRelated$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    var $$x3 = $as_Lreactbuild_analyze_cost_components_MaybeRelated$Backend($n(c).backend__O());
    var this$6 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).onPropsChange__Lreactbuild_analyze_cost_components_MaybeRelated$Props__Lreactbuild_analyze_cost_components_MaybeRelated$Props__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_analyze_cost_components_MaybeRelated$Props($n(this$6.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()), $as_Lreactbuild_analyze_cost_components_MaybeRelated$Props($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$13 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$8, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G));
  var f$1 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(c$3$2);
    var $$x12 = $as_Lreactbuild_analyze_cost_components_MaybeRelated$Backend($n(c$3).backend__O());
    var $$x11 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
    var $$x10 = $m_s_None$();
    var $$x9 = $m_s_None$();
    var $$x8 = $m_s_None$();
    var $$x7 = $m_s_None$();
    var $$x6 = $m_s_None$();
    var this$9 = $n(c$3);
    var $$x5 = $n($as_Lreactbuild_analyze_cost_components_MaybeRelated$Props($n(this$9.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_router;
    var this$10 = $n(c$3);
    var $$x4 = new $c_Lreactbuild_analyze_cost_components_MaybeRelated$Props($$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $n($as_Lreactbuild_analyze_cost_components_MaybeRelated$Props($n(this$10.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_update);
    var this$11 = $n(c$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x12).onPropsChange__Lreactbuild_analyze_cost_components_MaybeRelated$Props__Lreactbuild_analyze_cost_components_MaybeRelated$Props__Ljapgolly_scalajs_react_callback_Trampoline($$x4, $as_Lreactbuild_analyze_cost_components_MaybeRelated$Props($n(this$11.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_components_MaybeRelated$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$13, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_MaybeRelated$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_MaybeRelated$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_MaybeRelated$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_MaybeRelated$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_MaybeRelated$.prototype = $c_Lreactbuild_analyze_cost_components_MaybeRelated$.prototype;
var $d_Lreactbuild_analyze_cost_components_MaybeRelated$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_MaybeRelated$: 0
}, false, "reactbuild.analyze.cost.components.MaybeRelated$", {
  Lreactbuild_analyze_cost_components_MaybeRelated$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_MaybeRelated$;
var $n_Lreactbuild_analyze_cost_components_MaybeRelated$;
function $m_Lreactbuild_analyze_cost_components_MaybeRelated$() {
  if ((!$n_Lreactbuild_analyze_cost_components_MaybeRelated$)) {
    $n_Lreactbuild_analyze_cost_components_MaybeRelated$ = new $c_Lreactbuild_analyze_cost_components_MaybeRelated$()
  };
  return $n_Lreactbuild_analyze_cost_components_MaybeRelated$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFPage$() {
  this.Lreactbuild_analyze_cost_components_PDFPage$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_PDFPage$ = this;
  this.Lreactbuild_analyze_cost_components_PDFPage$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("PDFPage", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_PDFPage$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x1 = $n($as_Lreactbuild_analyze_cost_components_PDFPage$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    return $n($$x1).render__Lreactbuild_analyze_cost_components_PDFPage$Props__Ljapgolly_scalajs_react_vdom_VdomNode($as_Lreactbuild_analyze_cost_components_PDFPage$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_PDFPage$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFPage$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFPage$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFPage$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFPage$.prototype = $c_Lreactbuild_analyze_cost_components_PDFPage$.prototype;
$c_Lreactbuild_analyze_cost_components_PDFPage$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_model_PdfPage__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(state, page) {
  var c = this.Lreactbuild_analyze_cost_components_PDFPage$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_PDFPage$Props(state, page);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_PDFPage$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFPage$: 0
}, false, "reactbuild.analyze.cost.components.PDFPage$", {
  Lreactbuild_analyze_cost_components_PDFPage$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_PDFPage$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFPage$;
var $n_Lreactbuild_analyze_cost_components_PDFPage$;
function $m_Lreactbuild_analyze_cost_components_PDFPage$() {
  if ((!$n_Lreactbuild_analyze_cost_components_PDFPage$)) {
    $n_Lreactbuild_analyze_cost_components_PDFPage$ = new $c_Lreactbuild_analyze_cost_components_PDFPage$()
  };
  return $n_Lreactbuild_analyze_cost_components_PDFPage$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFPageContent$() {
  this.Lreactbuild_analyze_cost_components_PDFPageContent$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_PDFPageContent$ = this;
  var b = new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("PDFPageContent", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$());
  var this$4 = $m_s_$less$colon$less$();
  var ev = this$4.s_$less$colon$less$__f_singleton;
  this.Lreactbuild_analyze_cost_components_PDFPageContent$__f_component = $n($n(($n(ev), b).noBackend__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3()).render_P__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((page$2) => {
    var page = $as_Lreactbuild_model_PdfPage(page$2);
    var this$23 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$8 = $n($n(page).parts__sci_List());
    var rest = this$8;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var part = $as_Lreactbuild_model_PdfWord(arg1);
      var this$9 = $n($m_s_Predef$().wrapString__T__sci_WrappedString($n(part).Lreactbuild_model_PdfWord__f_text));
      var that = $n(part).Lreactbuild_model_PdfWord__f_textPositions;
      var it = $n($as_sci_IndexedSeq($n($n($as_sc_IterableOps($f_sc_IterableOps__zip__sc_IterableOnce__O(this$9, that))).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$4$2) => {
        var check$ifrefutable$4 = $as_T2(check$ifrefutable$4$2);
        return (check$ifrefutable$4 !== null)
      })))).map__F1__O(new $c_sjsr_AnonFunction1(((x$27$2) => {
        var x$27 = $as_T2(x$27$2);
        if ((x$27 !== null)) {
          var this$10 = $n(x$27);
          var text = $uC(this$10._1__O());
          var textPos = $as_Lreactbuild_model_PdfTextPosition($n(x$27)._2__O());
          var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var this$13 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
          var $$x6 = this$13.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("absolute", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          var $$x5 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("transparent", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          var $$x4 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(textPos).Lreactbuild_model_PdfTextPosition__f_x + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          var $$x3 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("top")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(textPos).Lreactbuild_model_PdfTextPosition__f_y + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          var $$x2 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((($bC(text) + ", ") + textPos), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          var $$x1 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontSize__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(textPos).Lreactbuild_model_PdfTextPosition__f_size + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var v = ("" + $bC(text));
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
          return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
        } else {
          throw new $c_s_MatchError(x$27)
        }
      }))))).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx
        } else {
          $n(t).sci_$colon$colon__f_next = nx
        };
        t = nx
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    var ns = ((h === null) ? $m_sci_Nil$() : h);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$23, null, ns)
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_PDFPageContent$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFPageContent$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFPageContent$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFPageContent$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFPageContent$.prototype = $c_Lreactbuild_analyze_cost_components_PDFPageContent$.prototype;
$c_Lreactbuild_analyze_cost_components_PDFPageContent$.prototype.apply__Lreactbuild_model_PdfPage__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(page) {
  var c = this.Lreactbuild_analyze_cost_components_PDFPageContent$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType("content")));
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(page, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_PDFPageContent$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFPageContent$: 0
}, false, "reactbuild.analyze.cost.components.PDFPageContent$", {
  Lreactbuild_analyze_cost_components_PDFPageContent$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_PDFPageContent$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFPageContent$;
var $n_Lreactbuild_analyze_cost_components_PDFPageContent$;
function $m_Lreactbuild_analyze_cost_components_PDFPageContent$() {
  if ((!$n_Lreactbuild_analyze_cost_components_PDFPageContent$)) {
    $n_Lreactbuild_analyze_cost_components_PDFPageContent$ = new $c_Lreactbuild_analyze_cost_components_PDFPageContent$()
  };
  return $n_Lreactbuild_analyze_cost_components_PDFPageContent$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$() {
  this.Lreactbuild_analyze_cost_components_PDFText$__f_reuseArea = null;
  this.Lreactbuild_analyze_cost_components_PDFText$__f_reusabilityProps = null;
  this.Lreactbuild_analyze_cost_components_PDFText$__f_reusabilityState = null;
  this.Lreactbuild_analyze_cost_components_PDFText$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_PDFText$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_components_PDFText$__f_reuseArea = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_components_PDFText$__f_reusabilityProps = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$2.byRef__F2(), this$2.by_$eq$eq__F2());
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_components_PDFText$__f_reusabilityState = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$3.byRef__F2(), this$3.by_$eq$eq__F2());
  var this$23 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("PDFText", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_components_PDFText$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_components_PDFText$State($m_s_package$().s_package$__f_Nil, $m_s_None$(), $m_Lreactbuild_analyze_cost_components_PDFText$Idle$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_PDFText$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_PDFText$Backend($n(x$3).backend__O()));
    var this$8 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_PDFText$Props($n(this$8.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$9 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_PDFText$Props__Lreactbuild_analyze_cost_components_PDFText$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_components_PDFText$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$9)))
  }))));
  var f = $m_Ljapgolly_scalajs_react_Reusability$().shouldComponentUpdateAnd__F1__F2__F2__Ljapgolly_scalajs_react_util_Effect$Sync__F1(new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult(c$2);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var this$10 = $n(c);
    var this$11 = $n(this$10.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self);
    var x$1 = $n(this$11.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O();
    var this$12 = $n(c);
    var y = $n(this$12.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self).Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextState;
    var cond = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y));
    if (cond) {
      var $$x6 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
      $m_sc_StringOps$();
      var this$14 = $n(c);
      var this$15 = $n(this$14.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self);
      var $$x5 = $n($as_Lreactbuild_analyze_cost_components_PDFText$State($n(this$15.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O())).Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
      var this$16 = $n(c);
      var $$x4 = $n($as_Lreactbuild_analyze_cost_components_PDFText$State($n(this$16.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self).Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextState)).Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
      var this$17 = $n(c);
      var this$18 = $n($n($as_Lreactbuild_analyze_cost_components_PDFText$State($n(this$17.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self).Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextState)).Lreactbuild_analyze_cost_components_PDFText$State__f_areas);
      var x$4 = (((((("\n                |PDFText\n                |Current state :\n                |   " + $$x5) + "\n                |Next state :\n                |   ") + $$x4) + "\n                |Areas :\n                |   ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$18, "", "\n", "")) + "\n              ");
      var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x6).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline($m_sc_StringOps$().stripMargin$extension__T__C__T(x$4, 124), $m_sci_Nil$())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x3)
  })), this.Lreactbuild_analyze_cost_components_PDFText$__f_reusabilityProps, this.Lreactbuild_analyze_cost_components_PDFText$__f_reusabilityState, $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$26 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$23)));
  var f$1 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(c$3$2);
    var $$x8 = $as_Lreactbuild_analyze_cost_components_PDFText$Backend($n(c$3).backend__O());
    var $$x7 = $m_s_None$();
    var this$24 = $n(c$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x8).onUpdate__s_Option__Lreactbuild_analyze_cost_components_PDFText$Props__Ljapgolly_scalajs_react_callback_Trampoline($$x7, $as_Lreactbuild_analyze_cost_components_PDFText$Props($n(this$24.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$29 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$26, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillMount__Ljapgolly_scalajs_react_internal_Lens(), f$1, G));
  var f$2 = new $c_sjsr_AnonFunction1(((c$4$2) => {
    var c$4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$4$2);
    var $$x9 = $as_Lreactbuild_analyze_cost_components_PDFText$Backend($n(c$4).backend__O());
    var this$27 = $n(c$4);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x9).onUpdate__s_Option__Lreactbuild_analyze_cost_components_PDFText$Props__Ljapgolly_scalajs_react_callback_Trampoline(new $c_s_Some($n(this$27.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()), $as_Lreactbuild_analyze_cost_components_PDFText$Props($n(c$4).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_components_PDFText$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$29, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$2, G$1)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_PDFText$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$.prototype.apply__Lreactbuild_common_model_RefTo__Lreactbuild_model_PdfContent__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(supplier, content) {
  var c = this.Lreactbuild_analyze_cost_components_PDFText$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_PDFText$Props(supplier, content);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_PDFText$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$: 0
}, false, "reactbuild.analyze.cost.components.PDFText$", {
  Lreactbuild_analyze_cost_components_PDFText$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$;
var $n_Lreactbuild_analyze_cost_components_PDFText$;
function $m_Lreactbuild_analyze_cost_components_PDFText$() {
  if ((!$n_Lreactbuild_analyze_cost_components_PDFText$)) {
    $n_Lreactbuild_analyze_cost_components_PDFText$ = new $c_Lreactbuild_analyze_cost_components_PDFText$()
  };
  return $n_Lreactbuild_analyze_cost_components_PDFText$
}
function $is_Lreactbuild_analyze_cost_components_PDFText$ActionState(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_components_PDFText$ActionState)))
}
function $as_Lreactbuild_analyze_cost_components_PDFText$ActionState(obj) {
  return (($is_Lreactbuild_analyze_cost_components_PDFText$ActionState(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$ActionState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$ActionState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$ActionState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$ActionState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$ActionState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$ActionState;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea(area) {
  this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area = null;
  this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area = area
}
$c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype.findColumn$default$2__sci_List = (function() {
  return $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_columns
});
$c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype.classifyPoint__Lreactbuild_analyze_cost_components_PDFText$Point__D__s_Option = (function(pt, max) {
  var a = ($n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_centerX - $n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
  var absDeltaCenterX = $uD(Math.abs(a));
  var a$1 = ($n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_centerY - $n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
  var absDeltaCenterY = $uD(Math.abs(a$1));
  var deltaX = (absDeltaCenterX - $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_halfWidth);
  var deltaY = (absDeltaCenterY - $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_halfHeight);
  var absDeltaX = $uD(Math.abs(deltaX));
  var absDeltaY = $uD(Math.abs(deltaY));
  if ((((absDeltaX < max) || (deltaX < 0.0)) && ((absDeltaY < max) || (deltaY < 0.0)))) {
    if (((absDeltaCenterX < max) && (absDeltaCenterY < max))) {
      return new $c_s_Some($m_Lreactbuild_analyze_cost_components_Handle$Center$())
    } else if (((deltaX < (-max)) && (deltaY < (-max)))) {
      var position = $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_left;
      var rest = this.findColumn$default$2__sci_List();
      var $$x1;
      while (true) {
        var x1 = rest;
        var x = $m_s_package$().s_package$__f_Nil;
        if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
          var $$x1 = $m_s_None$();
          break
        } else {
          if ((!(x1 instanceof $c_sci_$colon$colon))) {
            throw new $c_s_MatchError(x1)
          };
          var x3 = $as_sci_$colon$colon(x1);
          var c = $as_Lreactbuild_person_DocumentParserColumn($n(x3).sci_$colon$colon__f_head);
          var tail = $n(x3).sci_$colon$colon__f_next;
          var acc = (position + $n(c).Lreactbuild_person_DocumentParserColumn__f_width);
          var a$2 = (acc - $n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
          if (($uD(Math.abs(a$2)) < 10.0)) {
            var x1$2 = new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn($n(c).Lreactbuild_person_DocumentParserColumn__f_id))
          } else {
            var x1$2 = $m_s_None$()
          };
          var x$3 = $m_s_None$();
          if ((x$3 === x1$2)) {
            position = acc;
            rest = tail;
            continue
          };
          var $$x1 = x1$2;
          break
        }
      };
      var this$6 = $n($$x1);
      return (this$6.isEmpty__Z() ? new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn(($n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_x - $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_left))) : this$6)
    } else if (((absDeltaX < max) && (absDeltaY < max))) {
      var east = ($n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_x > $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_centerX);
      return (($n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_y < $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_centerY) ? new $c_s_Some((east ? $m_Lreactbuild_analyze_cost_components_Handle$NorthEast$() : $m_Lreactbuild_analyze_cost_components_Handle$NorthWest$())) : new $c_s_Some((east ? $m_Lreactbuild_analyze_cost_components_Handle$SouthEast$() : $m_Lreactbuild_analyze_cost_components_Handle$SouthWest$())))
    } else {
      return ((absDeltaX < max) ? new $c_s_Some((($n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_x > $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_centerX) ? $m_Lreactbuild_analyze_cost_components_Handle$East$() : $m_Lreactbuild_analyze_cost_components_Handle$West$())) : new $c_s_Some((($n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_y < $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_centerY) ? $m_Lreactbuild_analyze_cost_components_Handle$North$() : $m_Lreactbuild_analyze_cost_components_Handle$South$())))
    }
  } else {
    return $m_s_None$()
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype.contains__Lreactbuild_model_PdfTextPosition__Z = (function(textPos) {
  var a = ($n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_centerX - $n(textPos).Lreactbuild_model_PdfTextPosition__f_x);
  if (($uD(Math.abs(a)) < $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_halfWidth)) {
    var a$1 = ($n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_centerY - $n(textPos).Lreactbuild_model_PdfTextPosition__f_y);
    return ($uD(Math.abs(a$1)) < $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_halfHeight)
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype.iterateOverColumns__sci_List__sci_List__D__sci_Map__sci_Map = (function(rest, columns, acc, results) {
  while (true) {
    var x1 = columns;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      return results
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var col = $as_Lreactbuild_person_DocumentParserColumn($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      var next = (acc + $n(col).Lreactbuild_person_DocumentParserColumn__f_width);
      var this$1 = $n(rest);
      var acc$1 = acc;
      var s = this$1;
      while (true) {
        var this$2 = $n(s);
        if ((!this$2.isEmpty__Z())) {
          var arg1 = $n(s).head__O();
          var x$3 = $as_T2(arg1);
          var $$x1 = ($n($as_Lreactbuild_model_PdfTextPosition($n(x$3)._2__O())).Lreactbuild_model_PdfTextPosition__f_x < acc$1)
        } else {
          var $$x1 = false
        };
        if ($$x1) {
          s = $as_sc_LinearSeq($n(s).tail__O())
        } else {
          break
        }
      };
      var this$3 = $n($as_sci_List(s));
      var b = new $c_scm_ListBuffer();
      var these = this$3;
      while (true) {
        if ((!$n(these).isEmpty__Z())) {
          var arg1$1 = $n(these).head__O();
          var x$4 = $as_T2(arg1$1);
          var $$x2 = ($n($as_Lreactbuild_model_PdfTextPosition($n(x$4)._2__O())).Lreactbuild_model_PdfTextPosition__f_x < next)
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          var elem = $n(these).head__O();
          b.addOne__O__scm_ListBuffer(elem);
          these = $as_sci_List($n(these).tail__O())
        } else {
          break
        }
      };
      var _1 = b.toList__sci_List();
      var _2 = these;
      var $$x4 = results;
      var this$6 = $n(_1);
      var f = ((x$6$2) => {
        var x$6 = $as_T2(x$6$2);
        var this$5 = $n(x$6);
        return $bC($uC(this$5._1__O()))
      });
      if ((this$6 === $m_sci_Nil$())) {
        var $$x3 = $m_sci_Nil$()
      } else {
        var arg1$2 = this$6.head__O();
        var h = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
        var t = h;
        var rest$1 = $as_sci_List(this$6.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$3 = $n(rest$1).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest$1 = $as_sci_List($n(rest$1).tail__O())
        };
        var $$x3 = h
      };
      var this$7 = $n($$x3);
      var y = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$7, "", "", "");
      var temp$results = $as_sci_Map($n($$x4).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), col, y)));
      rest = _2;
      columns = tail;
      acc = next;
      results = temp$results
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype.processPage__Lreactbuild_model_PdfPage__Lreactbuild_analyze_cost_components_PDFText$Result = (function(page) {
  if ($n($n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_columns).isEmpty__Z()) {
    var this$1 = $n($n(page).parts__sci_List());
    var rest = this$1;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var part = $as_Lreactbuild_model_PdfWord(arg1);
      var this$2 = $n($m_s_Predef$().wrapString__T__sci_WrappedString($n(part).Lreactbuild_model_PdfWord__f_text));
      var that = $n(part).Lreactbuild_model_PdfWord__f_textPositions;
      var it = $n($as_sci_IndexedSeq($n($n($n($as_sc_IterableOps($f_sc_IterableOps__zip__sc_IterableOnce__O(this$2, that))).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
        var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
        return (check$ifrefutable$1 !== null)
      })))).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((x$7$2) => {
        var x$7 = $as_T2(x$7$2);
        if ((x$7 !== null)) {
          var textPos = $as_Lreactbuild_model_PdfTextPosition($n(x$7)._2__O());
          return this.contains__Lreactbuild_model_PdfTextPosition__Z(textPos)
        } else {
          throw new $c_s_MatchError(x$7)
        }
      })))).map__F1__O(new $c_sjsr_AnonFunction1(((x$8$2) => {
        var x$8 = $as_T2(x$8$2);
        if ((x$8 !== null)) {
          var this$4 = $n(x$8);
          var text = $uC(this$4._1__O());
          return $bC(text)
        } else {
          throw new $c_s_MatchError(x$8)
        }
      }))))).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx
        } else {
          $n(t).sci_$colon$colon__f_next = nx
        };
        t = nx
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    var textFound = ((h === null) ? $m_sci_Nil$() : h);
    var $$x1 = this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area;
    var this$5 = $n(textFound);
    return new $c_Lreactbuild_analyze_cost_components_PDFText$FieldResult($$x1, $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", "", ""))
  } else {
    var this$6 = $n($n(page).parts__sci_List());
    var f = ((part$3$2) => {
      var part$3 = $as_Lreactbuild_model_PdfWord(part$3$2);
      return this.contains__Lreactbuild_model_PdfTextPosition__Z($as_Lreactbuild_model_PdfTextPosition($n($n(part$3).Lreactbuild_model_PdfWord__f_textPositions).head__O()))
    });
    var l = this$6;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break
        } else {
          var h$1 = $n(l).head__O();
          var t$1 = $as_sci_List($n(l).tail__O());
          if (($uZ(f(h$1)) === false)) {
            l = t$1;
            continue
          };
          var start = l;
          var remaining = t$1;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block
            } else {
              var x = $n(remaining).head__O();
              if (($uZ(f(x)) !== false)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue
              };
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O())
              };
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f(head)) !== false)) {
                  next = $as_sci_List($n(next).tail__O())
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                  };
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O())
                }
              };
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy
              };
              var result = newHead;
              break block
            }
          }
        }
      }
    };
    var this$7 = $n(result);
    var m = $as_scm_Map($m_scm_Map$().empty__O());
    var it$1 = this$7.iterator__sc_Iterator();
    while ($n(it$1).hasNext__Z()) {
      var elem = $n(it$1).next__O();
      var p = $as_Lreactbuild_model_PdfWord(elem);
      var key = $n($as_Lreactbuild_model_PdfTextPosition($n($n(p).Lreactbuild_model_PdfWord__f_textPositions).head__O())).Lreactbuild_model_PdfTextPosition__f_y;
      var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => {
        $m_sci_List$();
        return new $c_scm_ListBuffer()
      }))));
      var this$9 = $n(bldr);
      this$9.addOne__O__scm_Growable(elem)
    };
    var this$10 = $m_sci_HashMap$();
    var result$1 = this$10.sci_HashMap$__f_EmptyMap;
    var mapIt = $n(m).iterator__sc_Iterator();
    while ($n(mapIt).hasNext__Z()) {
      var x1 = $as_T2($n(mapIt).next__O());
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1)
      };
      var k = $n(x1)._1__O();
      var v = $as_scm_Builder($n(x1)._2__O());
      result$1 = $n(result$1).updated__O__O__sci_HashMap(k, $n(v).result__O())
    };
    var this$11 = $n(result$1);
    $m_sci_List$();
    var this$13 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$11));
    var f$1 = new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9 = $as_T2(x$9$2);
      return $uF($n(x$9)._1__O())
    }));
    var ord = $m_s_math_Ordering$DeprecatedFloatOrdering$();
    var partInAreaOnSameLine = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$13, f$1, ord));
    var $$x2 = this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area;
    var this$14 = $n(partInAreaOnSameLine);
    var p$1 = new $c_sjsr_AnonFunction1(((check$ifrefutable$2$2) => {
      var check$ifrefutable$2 = $as_T2(check$ifrefutable$2$2);
      return (check$ifrefutable$2 !== null)
    }));
    return new $c_Lreactbuild_analyze_cost_components_PDFText$TableResult($$x2, $as_sci_List($ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this$14, p$1).map__F1__O(new $c_sjsr_AnonFunction1(((x$12$2) => {
      var x$12 = $as_T2(x$12$2);
      if ((x$12 !== null)) {
        var row = $as_sci_List($n(x$12)._2__O());
        var this$15 = $n(row);
        var rest$1 = this$15;
        var h$2 = null;
        var t$2 = null;
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$1 = $n(rest$1).head__O();
          var part$1 = $as_Lreactbuild_model_PdfWord(arg1$1);
          var this$16 = $n($m_s_Predef$().wrapString__T__sci_WrappedString($n(part$1).Lreactbuild_model_PdfWord__f_text));
          var that$1 = $n(part$1).Lreactbuild_model_PdfWord__f_textPositions;
          var it$2 = $n($as_sci_IndexedSeq($n($n($as_sc_IterableOps($f_sc_IterableOps__zip__sc_IterableOnce__O(this$16, that$1))).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$3$2) => {
            var check$ifrefutable$3 = $as_T2(check$ifrefutable$3$2);
            return (check$ifrefutable$3 !== null)
          })))).map__F1__O(new $c_sjsr_AnonFunction1(((x$10$2) => {
            var x$10 = $as_T2(x$10$2);
            if ((x$10 !== null)) {
              var this$17 = $n(x$10);
              var text$1 = $uC(this$17._1__O());
              var textPos$1 = $as_Lreactbuild_model_PdfTextPosition($n(x$10)._2__O());
              return $ct_T2__O__O__(new $c_T2(), $bC(text$1), textPos$1)
            } else {
              throw new $c_s_MatchError(x$10)
            }
          }))))).iterator__sc_Iterator();
          while ($n(it$2).hasNext__Z()) {
            var nx$1 = new $c_sci_$colon$colon($n(it$2).next__O(), $m_sci_Nil$());
            if ((t$2 === null)) {
              h$2 = nx$1
            } else {
              $n(t$2).sci_$colon$colon__f_next = nx$1
            };
            t$2 = nx$1
          };
          rest$1 = $as_sci_List($n(rest$1).tail__O())
        };
        var textOnRow = ((h$2 === null) ? $m_sci_Nil$() : h$2);
        var this$20 = $n(textOnRow);
        var f$2 = new $c_sjsr_AnonFunction1(((x$11$2) => {
          var x$11 = $as_T2(x$11$2);
          return $n($as_Lreactbuild_model_PdfTextPosition($n(x$11)._2__O())).Lreactbuild_model_PdfTextPosition__f_x
        }));
        var ord$1 = $m_s_math_Ordering$DeprecatedFloatOrdering$();
        var sortedText = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$20, f$2, ord$1));
        return new $c_Lreactbuild_analyze_cost_components_PDFText$RowResult(this.iterateOverColumns__sci_List__sci_List__D__sci_Map__sci_Map(sortedText, $n(this.Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea__f_area).Lreactbuild_person_DocumentParserArea__f_columns, 0.0, ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$())))
      } else {
        throw new $c_s_MatchError(x$12)
      }
    })))))
  }
});
var $d_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea: 0
}, false, "reactbuild.analyze.cost.components.PDFText$RichDocumentParserArea", {
  Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea;
function $f_Lreactbuild_analyze_cost_components_PDFText$Selectable__updateAreas__sci_List__T__sci_List($thiz, areas, name) {
  var this$1 = $n(areas);
  _return: {
    var i = 0;
    var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$1, 0, this$1);
    while (true) {
      var this$4 = $n(these);
      if ((!this$4.isEmpty__Z())) {
        var arg1 = $n(these).head__O();
        var x$13 = $as_Lreactbuild_person_DocumentParserArea(arg1);
        var x = $n(x$13).Lreactbuild_person_DocumentParserArea__f_id;
        var x$2 = $thiz.area__ju_UUID();
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          var x1 = i;
          break _return
        };
        i = ((1 + i) | 0);
        these = $as_sc_LinearSeq($n(these).tail__O())
      } else {
        break
      }
    };
    var x1 = (-1)
  };
  if ((x1 === (-1))) {
    return areas
  } else {
    var this$9 = $n(areas);
    var $$x1 = $n($m_s_package$().s_package$__f_Seq);
    var this$5 = $n(areas);
    var array = [$thiz.update__Lreactbuild_person_DocumentParserArea__T__Lreactbuild_person_DocumentParserArea($as_Lreactbuild_person_DocumentParserArea($f_sc_LinearSeqOps__apply__I__O(this$5, x1)), name)];
    var other = $n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    return $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$9, x1, other, 1))
  }
}
function $is_Lreactbuild_analyze_cost_components_PDFText$Selectable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_components_PDFText$Selectable)))
}
function $as_Lreactbuild_analyze_cost_components_PDFText$Selectable(obj) {
  return (($is_Lreactbuild_analyze_cost_components_PDFText$Selectable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$Selectable"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Selectable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$Selectable)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$Selectable(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Selectable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$Selectable;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFViewer$() {
  this.Lreactbuild_analyze_cost_components_PDFViewer$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_PDFViewer$ = this;
  this.Lreactbuild_analyze_cost_components_PDFViewer$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("PDFViewer", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_components_PDFViewer$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_components_PDFViewer$State($m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_PDFViewer$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_PDFViewer$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_PDFViewer$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_PDFViewer$Props__Lreactbuild_analyze_cost_components_PDFViewer$State__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lreactbuild_analyze_cost_components_PDFViewer$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_PDFViewer$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFViewer$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFViewer$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFViewer$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFViewer$.prototype = $c_Lreactbuild_analyze_cost_components_PDFViewer$.prototype;
$c_Lreactbuild_analyze_cost_components_PDFViewer$.prototype.apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(ref) {
  var c = this.Lreactbuild_analyze_cost_components_PDFViewer$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_PDFViewer$Props(new $c_Ldiode_data_Ready(ref));
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$.prototype.apply__Ldiode_data_Pot__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(ref) {
  var c = this.Lreactbuild_analyze_cost_components_PDFViewer$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_PDFViewer$Props(ref);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_PDFViewer$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFViewer$: 0
}, false, "reactbuild.analyze.cost.components.PDFViewer$", {
  Lreactbuild_analyze_cost_components_PDFViewer$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFViewer$;
var $n_Lreactbuild_analyze_cost_components_PDFViewer$;
function $m_Lreactbuild_analyze_cost_components_PDFViewer$() {
  if ((!$n_Lreactbuild_analyze_cost_components_PDFViewer$)) {
    $n_Lreactbuild_analyze_cost_components_PDFViewer$ = new $c_Lreactbuild_analyze_cost_components_PDFViewer$()
  };
  return $n_Lreactbuild_analyze_cost_components_PDFViewer$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PeriodProvider$() {
  this.Lreactbuild_analyze_cost_components_PeriodProvider$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_PeriodProvider$ = this;
  this.Lreactbuild_analyze_cost_components_PeriodProvider$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("PeriodProvider", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_PeriodProvider$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_PeriodProvider$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_PeriodProvider$Props__jl_Void__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_jl_Void($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_PeriodProvider$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PeriodProvider$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PeriodProvider$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PeriodProvider$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PeriodProvider$.prototype = $c_Lreactbuild_analyze_cost_components_PeriodProvider$.prototype;
$c_Lreactbuild_analyze_cost_components_PeriodProvider$.prototype.apply__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(render, proxy) {
  var c = this.Lreactbuild_analyze_cost_components_PeriodProvider$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_PeriodProvider$Props(render, proxy);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_PeriodProvider$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PeriodProvider$: 0
}, false, "reactbuild.analyze.cost.components.PeriodProvider$", {
  Lreactbuild_analyze_cost_components_PeriodProvider$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PeriodProvider$;
var $n_Lreactbuild_analyze_cost_components_PeriodProvider$;
function $m_Lreactbuild_analyze_cost_components_PeriodProvider$() {
  if ((!$n_Lreactbuild_analyze_cost_components_PeriodProvider$)) {
    $n_Lreactbuild_analyze_cost_components_PeriodProvider$ = new $c_Lreactbuild_analyze_cost_components_PeriodProvider$()
  };
  return $n_Lreactbuild_analyze_cost_components_PeriodProvider$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PeriodSelector$() {
  this.Lreactbuild_analyze_cost_components_PeriodSelector$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_PeriodSelector$ = this;
  this.Lreactbuild_analyze_cost_components_PeriodSelector$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("PeriodSelector", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_PeriodSelector$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Ljapgolly_scalajs_react_extra_StateSnapshotF__jl_Void__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_jl_Void($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_PeriodSelector$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PeriodSelector$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PeriodSelector$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PeriodSelector$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PeriodSelector$.prototype = $c_Lreactbuild_analyze_cost_components_PeriodSelector$.prototype;
$c_Lreactbuild_analyze_cost_components_PeriodSelector$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(state) {
  var c = this.Lreactbuild_analyze_cost_components_PeriodSelector$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(state, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_PeriodSelector$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PeriodSelector$: 0
}, false, "reactbuild.analyze.cost.components.PeriodSelector$", {
  Lreactbuild_analyze_cost_components_PeriodSelector$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_PeriodSelector$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PeriodSelector$;
var $n_Lreactbuild_analyze_cost_components_PeriodSelector$;
function $m_Lreactbuild_analyze_cost_components_PeriodSelector$() {
  if ((!$n_Lreactbuild_analyze_cost_components_PeriodSelector$)) {
    $n_Lreactbuild_analyze_cost_components_PeriodSelector$ = new $c_Lreactbuild_analyze_cost_components_PeriodSelector$()
  };
  return $n_Lreactbuild_analyze_cost_components_PeriodSelector$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Progress$() {
  this.Lreactbuild_analyze_cost_components_Progress$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_Progress$ = this;
  var this$9 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Progress", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_components_Progress$Props(p$2);
    return $m_Lreactbuild_analyze_cost_components_Progress$Idle$()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_Progress$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_components_Progress$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_components_Progress$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_components_Progress$Props__Lreactbuild_analyze_cost_components_Progress$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_components_Progress$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var this$7 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var evidence$1 = this$7.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var f = $m_Ljapgolly_scalajs_react_extra_OnUnmountF$().install__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(evidence$1);
  this.Lreactbuild_analyze_cost_components_Progress$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$9))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_Progress$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Progress$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Progress$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Progress$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Progress$.prototype = $c_Lreactbuild_analyze_cost_components_Progress$.prototype;
$c_Lreactbuild_analyze_cost_components_Progress$.prototype.apply__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(f) {
  var c = this.Lreactbuild_analyze_cost_components_Progress$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_Progress$Props(f);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_analyze_cost_components_Progress$.prototype.withKey__T__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, f) {
  var c = this.Lreactbuild_analyze_cost_components_Progress$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_components_Progress$Props(f);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_Progress$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Progress$: 0
}, false, "reactbuild.analyze.cost.components.Progress$", {
  Lreactbuild_analyze_cost_components_Progress$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_Progress$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Progress$;
var $n_Lreactbuild_analyze_cost_components_Progress$;
function $m_Lreactbuild_analyze_cost_components_Progress$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Progress$)) {
    $n_Lreactbuild_analyze_cost_components_Progress$ = new $c_Lreactbuild_analyze_cost_components_Progress$()
  };
  return $n_Lreactbuild_analyze_cost_components_Progress$
}
function $f_Lreactbuild_analyze_cost_components_Progress$State__render__Ljapgolly_scalajs_react_vdom_VdomNode($thiz) {
  var $$x1 = $n($m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($thiz.icon__Lcom_iz2use_react_components_IconSource(), "", "24px"));
  var array = [$thiz.style__Ljapgolly_scalajs_react_vdom_TagMod()];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
}
function $is_Lreactbuild_analyze_cost_components_Progress$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_components_Progress$State)))
}
function $as_Lreactbuild_analyze_cost_components_Progress$State(obj) {
  return (($is_Lreactbuild_analyze_cost_components_Progress$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Progress$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Progress$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Progress$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Progress$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Progress$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Progress$State;", depth))
}
function $p_Lreactbuild_analyze_cost_components_Refine$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Refine", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_Refine$TypedProps(p$2);
    return $n($n(p).Lreactbuild_analyze_cost_components_Refine$TypedProps__f_refiner).apply__O__O($n(p).Lreactbuild_analyze_cost_components_Refine$TypedProps__f_value)
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Refine$() {
  this.Lreactbuild_analyze_cost_components_Refine$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_Refine$ = this;
  var this$7 = $n($n($n($p_Lreactbuild_analyze_cost_components_Refine$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_components_Refine$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    $n($as_Lreactbuild_analyze_cost_components_Refine$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var p = $as_Lreactbuild_analyze_cost_components_Refine$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    var s = $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lreactbuild_analyze_cost_components_Refine$TypedProps__f_render).apply__O__O(s))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_analyze_cost_components_Refine$TypedBackend($n(c).backend__O())).onUpdate__Lreactbuild_analyze_cost_components_Refine$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_analyze_cost_components_Refine$TypedProps($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_components_Refine$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$7, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_components_Refine$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Refine$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Refine$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Refine$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Refine$.prototype = $c_Lreactbuild_analyze_cost_components_Refine$.prototype;
$c_Lreactbuild_analyze_cost_components_Refine$.prototype.apply__O__F1__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(value, refiner, render) {
  var c = this.Lreactbuild_analyze_cost_components_Refine$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_Refine$TypedProps(value, refiner, render);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_Refine$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Refine$: 0
}, false, "reactbuild.analyze.cost.components.Refine$", {
  Lreactbuild_analyze_cost_components_Refine$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_Refine$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Refine$;
var $n_Lreactbuild_analyze_cost_components_Refine$;
function $m_Lreactbuild_analyze_cost_components_Refine$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Refine$)) {
    $n_Lreactbuild_analyze_cost_components_Refine$ = new $c_Lreactbuild_analyze_cost_components_Refine$()
  };
  return $n_Lreactbuild_analyze_cost_components_Refine$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_RenderPot$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_RenderPot$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_RenderPot$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_RenderPot$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_RenderPot$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_RenderPot$.prototype = $c_Lreactbuild_analyze_cost_components_RenderPot$.prototype;
$c_Lreactbuild_analyze_cost_components_RenderPot$.prototype.apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(pot, ifPending, renderFn) {
  if ($n(pot).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(pot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$10 = $n(pot);
    if ((!this$10.isEmpty__Z())) {
      return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(renderFn).apply__O__O($n(pot).get__O()))
    } else if ($n(pot).isPending__Z()) {
      return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(ifPending).apply__O())
    } else {
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    }
  }
});
$c_Lreactbuild_analyze_cost_components_RenderPot$.prototype.apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode = (function() {
  return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "progress"), $m_sci_Nil$())
});
$c_Lreactbuild_analyze_cost_components_RenderPot$.prototype.onlyReady__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(pot, ifPending, renderFn) {
  if ($n(pot).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(pot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else if ($n(pot).isReady__Z()) {
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(renderFn).apply__O__O($n(pot).get__O()))
  } else if ($n(pot).isPending__Z()) {
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(ifPending).apply__O())
  } else {
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
    return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  }
});
var $d_Lreactbuild_analyze_cost_components_RenderPot$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_RenderPot$: 0
}, false, "reactbuild.analyze.cost.components.RenderPot$", {
  Lreactbuild_analyze_cost_components_RenderPot$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_RenderPot$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_RenderPot$;
var $n_Lreactbuild_analyze_cost_components_RenderPot$;
function $m_Lreactbuild_analyze_cost_components_RenderPot$() {
  if ((!$n_Lreactbuild_analyze_cost_components_RenderPot$)) {
    $n_Lreactbuild_analyze_cost_components_RenderPot$ = new $c_Lreactbuild_analyze_cost_components_RenderPot$()
  };
  return $n_Lreactbuild_analyze_cost_components_RenderPot$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$.prototype = $c_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$.prototype;
$c_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$.prototype.one__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(children) {
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_responsiveColumnLayout;
  var $$x4 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$6 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $as_Lscalacss_internal_StyleA($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_responsiveColumnLayoutBody).apply__O__O(1));
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s$1);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$9 = $m_s_$less$colon$less$();
  var array = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(children, this$9.s_$less$colon$less$__f_singleton)];
  var array$1 = [$$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$: 0
}, false, "reactbuild.analyze.cost.components.ResponsiveColumnLayout$", {
  Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$;
var $n_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$;
function $m_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$() {
  if ((!$n_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$)) {
    $n_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$ = new $c_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$()
  };
  return $n_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Root$() {
  this.Lreactbuild_analyze_cost_components_Root$__f_reactbuild$analyze$cost$components$Root$$inputs = null;
  this.Lreactbuild_analyze_cost_components_Root$__f_component = null;
  $n_Lreactbuild_analyze_cost_components_Root$ = this;
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array = ["SELECT", "TEXTAREA", "INPUT"];
  this.Lreactbuild_analyze_cost_components_Root$__f_reactbuild$analyze$cost$components$Root$$inputs = $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var this$44 = $m_Lcom_iz2use_react_hooks_package$();
  var this$7 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var initialState = new $c_sjsr_AnonFunction0((() => 0));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$27 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$7, initialState, step)));
  var effect = new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Ljapgolly_scalajs_react_hooks_HookCtx$P1(x$1$2);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f$3 = new $c_sjsr_AnonFunction0((() => {
      var handleFindKey = new $c_Lreactbuild_analyze_cost_components_Root$$anonfun$1();
      var handleEscKey = new $c_Lreactbuild_analyze_cost_components_Root$$anonfun$2();
      var handler = new $c_sjsr_AnonFunction1(((ev$2) => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
        var cond = $uZ(ev$2.defaultPrevented);
        var cond$1 = (!cond);
        if (cond$1) {
          $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).matchPF__F0__s_PartialFunction__F0(new $c_sjsr_AnonFunction0((() => ev$2)), new $c_s_PartialFunction$OrElse(handleFindKey, handleEscKey)), new $c_sjsr_AnonFunction1(((cb$2) => {
            var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
            var c = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(cb, new $c_sjsr_AnonFunction1(((x$4$2) => {
              $as_jl_Void(x$4$2);
              $m_Ljapgolly_scalajs_react_package$();
              var this$10 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
              var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent(ev$2, this$10.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
              var f = new $c_sjsr_AnonFunction1(((x$3$2) => {
                $as_jl_Void(x$3$2)
              }));
              var this$12 = $n(this$);
              return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$12, f))
            })));
            return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
          })));
          var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var this$15 = $m_s_$less$colon$less$();
          var this$$1 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$15.s_$less$colon$less$__f_singleton)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
        } else {
          var $$x2 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
      }));
      var nativeHandler = new $c_sjsr_AnonFunction1(((ev$3$2) => {
        var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(handler.apply__O__O(ev$3$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$18 = $n(this$$2);
        $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$18)
      }));
      window.addEventListener("keydown", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(nativeHandler));
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        window.removeEventListener("keydown", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(nativeHandler))
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$26 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$26);
  var this$43 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useEffectOnMountBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$27, effect, a, step$1)));
  var f$4 = new $c_sjsr_AnonFunction2(((p$2, x$5$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_Root$Props(p$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$5$2);
    var this$28 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
    var value = new $c_Lreactbuild_package$PageProps($n(p).Lreactbuild_analyze_cost_components_Root$Props__f_c, $n(p).Lreactbuild_analyze_cost_components_Root$Props__f_m);
    var $$x6 = $n($f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$28, value));
    var this$38 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var u = $m_Lreactbuild_analyze_cost_components_LateralBar$().apply__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lreactbuild_analyze_cost_components_Root$Props__f_m, $n(p).Lreactbuild_analyze_cost_components_Root$Props__f_c, $n(p).Lreactbuild_analyze_cost_components_Root$Props__f_r);
    var this$30 = $n(u);
    var n = this$30.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x5 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var $$x4 = $m_Lreactbuild_analyze_cost_components_RootView$().apply__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__Ljapgolly_scalajs_react_vdom_VdomElement($n(p).Lreactbuild_analyze_cost_components_Root$Props__f_m, $n(p).Lreactbuild_analyze_cost_components_Root$Props__f_c, $n(p).Lreactbuild_analyze_cost_components_Root$Props__f_r);
    var u$1 = $m_Lcom_iz2use_react_components_Dialog$Placeholder$().apply__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot();
    var this$33 = $n(u$1);
    var n$1 = this$33.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$1 = [$$x5, $$x4, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var array$2 = [$p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$38, null, ns)];
    return $n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  }));
  var this$42 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$42);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$43, f$4, step$2, s);
  this.Lreactbuild_analyze_cost_components_Root$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$44, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.components.Root.component"))
}
$c_Lreactbuild_analyze_cost_components_Root$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Root$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Root$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Root$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Root$.prototype = $c_Lreactbuild_analyze_cost_components_Root$.prototype;
$c_Lreactbuild_analyze_cost_components_Root$.prototype.apply__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(m, c, r) {
  var c$1 = this.Lreactbuild_analyze_cost_components_Root$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c$1).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_Root$Props(m, c, r);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_Root$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Root$: 0
}, false, "reactbuild.analyze.cost.components.Root$", {
  Lreactbuild_analyze_cost_components_Root$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_Root$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Root$;
var $n_Lreactbuild_analyze_cost_components_Root$;
function $m_Lreactbuild_analyze_cost_components_Root$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Root$)) {
    $n_Lreactbuild_analyze_cost_components_Root$ = new $c_Lreactbuild_analyze_cost_components_Root$()
  };
  return $n_Lreactbuild_analyze_cost_components_Root$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_RootView$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_RootView$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_RootView$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_RootView$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_RootView$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_RootView$.prototype = $c_Lreactbuild_analyze_cost_components_RootView$.prototype;
$c_Lreactbuild_analyze_cost_components_RootView$.prototype.apply__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__Ljapgolly_scalajs_react_vdom_VdomElement = (function(m, c, r) {
  var $$x1 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var this$1 = $n($n(r).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page);
  var a = $n($objectGetClass(this$1)).toString__T();
  var array = [$as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(r).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_renderP).apply__O__O(m))];
  return $n($$x1).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lreactbuild_analyze_cost_components_RootView$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_RootView$: 0
}, false, "reactbuild.analyze.cost.components.RootView$", {
  Lreactbuild_analyze_cost_components_RootView$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_RootView$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_RootView$;
var $n_Lreactbuild_analyze_cost_components_RootView$;
function $m_Lreactbuild_analyze_cost_components_RootView$() {
  if ((!$n_Lreactbuild_analyze_cost_components_RootView$)) {
    $n_Lreactbuild_analyze_cost_components_RootView$ = new $c_Lreactbuild_analyze_cost_components_RootView$()
  };
  return $n_Lreactbuild_analyze_cost_components_RootView$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_ScrollBlockContainer$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_ScrollBlockContainer$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_ScrollBlockContainer$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_ScrollBlockContainer$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_ScrollBlockContainer$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_ScrollBlockContainer$.prototype = $c_Lreactbuild_analyze_cost_components_ScrollBlockContainer$.prototype;
$c_Lreactbuild_analyze_cost_components_ScrollBlockContainer$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(children) {
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_scrollBlockContainer;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$6 = $m_s_$less$colon$less$();
  var array = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(children, this$6.s_$less$colon$less$__f_singleton)];
  return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lreactbuild_analyze_cost_components_ScrollBlockContainer$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_ScrollBlockContainer$: 0
}, false, "reactbuild.analyze.cost.components.ScrollBlockContainer$", {
  Lreactbuild_analyze_cost_components_ScrollBlockContainer$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_ScrollBlockContainer$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_ScrollBlockContainer$;
var $n_Lreactbuild_analyze_cost_components_ScrollBlockContainer$;
function $m_Lreactbuild_analyze_cost_components_ScrollBlockContainer$() {
  if ((!$n_Lreactbuild_analyze_cost_components_ScrollBlockContainer$)) {
    $n_Lreactbuild_analyze_cost_components_ScrollBlockContainer$ = new $c_Lreactbuild_analyze_cost_components_ScrollBlockContainer$()
  };
  return $n_Lreactbuild_analyze_cost_components_ScrollBlockContainer$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Tabs$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Tabs$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Tabs$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Tabs$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Tabs$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Tabs$.prototype = $c_Lreactbuild_analyze_cost_components_Tabs$.prototype;
$c_Lreactbuild_analyze_cost_components_Tabs$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__F1__Ljapgolly_scalajs_react_vdom_TagOf = (function(list, atStart, atEnd, isSelected, render) {
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_tabs;
  var array$1 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s), atStart, $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), list), new $c_sjsr_AnonFunction1(((item$2) => {
    var tab = $as_Lreactbuild_analyze_cost_components_Tab($n(render).apply__O__O(item$2));
    var $$x3 = $n($n(tab).Lreactbuild_analyze_cost_components_Tab__f_link);
    var this$6 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_tab;
    var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s$1);
    var $$x1 = $n(tab).Lreactbuild_analyze_cost_components_Tab__f_name;
    var this$7 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_tabSelected;
    var this$8 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$2));
    var condition = $uZ($n(isSelected).apply__O__O(item$2));
    var array = [$$x2, $$x1, $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$8, condition)];
    return $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }))), atEnd];
  return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lreactbuild_analyze_cost_components_Tabs$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Tabs$: 0
}, false, "reactbuild.analyze.cost.components.Tabs$", {
  Lreactbuild_analyze_cost_components_Tabs$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_Tabs$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Tabs$;
var $n_Lreactbuild_analyze_cost_components_Tabs$;
function $m_Lreactbuild_analyze_cost_components_Tabs$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Tabs$)) {
    $n_Lreactbuild_analyze_cost_components_Tabs$ = new $c_Lreactbuild_analyze_cost_components_Tabs$()
  };
  return $n_Lreactbuild_analyze_cost_components_Tabs$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Toolbar$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Toolbar$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Toolbar$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Toolbar$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Toolbar$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Toolbar$.prototype = $c_Lreactbuild_analyze_cost_components_Toolbar$.prototype;
$c_Lreactbuild_analyze_cost_components_Toolbar$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomNode__Z__Ljapgolly_scalajs_react_vdom_TagOf = (function(content, main) {
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_toolbar;
  var $$x1 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_toolbarMain;
  var this$5 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1));
  var array = [$$x1, $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$5, main), content];
  return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lreactbuild_analyze_cost_components_Toolbar$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Toolbar$: 0
}, false, "reactbuild.analyze.cost.components.Toolbar$", {
  Lreactbuild_analyze_cost_components_Toolbar$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_Toolbar$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Toolbar$;
var $n_Lreactbuild_analyze_cost_components_Toolbar$;
function $m_Lreactbuild_analyze_cost_components_Toolbar$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Toolbar$)) {
    $n_Lreactbuild_analyze_cost_components_Toolbar$ = new $c_Lreactbuild_analyze_cost_components_Toolbar$()
  };
  return $n_Lreactbuild_analyze_cost_components_Toolbar$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_TouchableList$() {
  this.Lreactbuild_analyze_cost_components_TouchableList$__f_touchableList = null;
  this.Lreactbuild_analyze_cost_components_TouchableList$__f_touchableListItem = null;
  $n_Lreactbuild_analyze_cost_components_TouchableList$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "ul";
  this.Lreactbuild_analyze_cost_components_TouchableList$__f_touchableList = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Lscalacss_internal_DslBase(x$1$2);
    return $m_s_package$().s_package$__f_Nil
  })), new $c_Lsourcecode_Name("touchableList"));
  var this$7 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$1 = "li";
  this.Lreactbuild_analyze_cost_components_TouchableList$__f_touchableListItem = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$7, v$1)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$minHeight$();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, "2.5rem")));
    $n(dsl);
    $n(dsl);
    var a$1 = $m_Lscalacss_internal_Attrs$margin$();
    var array = [$$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1.Lscalacss_internal_Attrs$margin$__f_attr, "0.5rem 1rem")))];
    return $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })), new $c_Lsourcecode_Name("touchableListItem"))
}
$c_Lreactbuild_analyze_cost_components_TouchableList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_TouchableList$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_TouchableList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_TouchableList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_TouchableList$.prototype = $c_Lreactbuild_analyze_cost_components_TouchableList$.prototype;
$c_Lreactbuild_analyze_cost_components_TouchableList$.prototype.component__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function() {
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_TouchableList$Props(p$2);
    var $$x3 = $n($m_Lreactbuild_analyze_cost_components_TouchableList$().Lreactbuild_analyze_cost_components_TouchableList$__f_touchableList);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $n(p).Lreactbuild_analyze_cost_components_TouchableList$Props__f_ite;
    var array$1 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((item$2) => {
      var $$x2 = $n($m_Lreactbuild_analyze_cost_components_TouchableList$().Lreactbuild_analyze_cost_components_TouchableList$__f_touchableListItem);
      var array = [$as_Ljapgolly_scalajs_react_vdom_TagMod($n($n(p).Lreactbuild_analyze_cost_components_TouchableList$Props__f_f).apply__O__O(item$2))];
      return $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    })))];
    return $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  }));
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  return $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f, s)
});
$c_Lreactbuild_analyze_cost_components_TouchableList$.prototype.apply__sc_Iterable__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(in$1, f) {
  var c = this.component__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot();
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_TouchableList$Props(in$1, f);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_components_TouchableList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_TouchableList$: 0
}, false, "reactbuild.analyze.cost.components.TouchableList$", {
  Lreactbuild_analyze_cost_components_TouchableList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_components_TouchableList$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_TouchableList$;
var $n_Lreactbuild_analyze_cost_components_TouchableList$;
function $m_Lreactbuild_analyze_cost_components_TouchableList$() {
  if ((!$n_Lreactbuild_analyze_cost_components_TouchableList$)) {
    $n_Lreactbuild_analyze_cost_components_TouchableList$ = new $c_Lreactbuild_analyze_cost_components_TouchableList$()
  };
  return $n_Lreactbuild_analyze_cost_components_TouchableList$
}
function $p_Lreactbuild_analyze_cost_modules_AccumulatingTable$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().getDerivedStateFromPropsAndState$extension__T__F2__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("AccumulatingTable", new $c_sjsr_AnonFunction2(((p$2, s$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(p$2);
    var s = $as_s_Option(s$2);
    $n(p);
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accumulatings);
    var m = $as_scm_Map($m_scm_Map$().empty__O());
    var it = this$2.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var v = $as_T2(elem);
      var $$x1 = $as_Ljava_time_LocalDate($n($as_T2($n(v)._1__O()))._1__O());
      var value = (((-1) + $n($n($as_Ljava_time_LocalDate($n($as_T2($n(v)._1__O()))._1__O())).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I()) | 0);
      var hi = (value >> 31);
      var key = $ct_T2__O__O__(new $c_T2(), $n($$x1).minusDays__J__Ljava_time_LocalDate(new $c_RTLong(value, hi)), $n($as_T2($n(v)._1__O()))._2__O());
      var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$2) => (() => this$2.newSpecificBuilder__scm_Builder()))(this$2))));
      var this$4 = $n(bldr);
      this$4.addOne__O__scm_Growable(elem)
    };
    var this$5 = $m_sci_HashMap$();
    var result = this$5.sci_HashMap$__f_EmptyMap;
    var mapIt = $n(m).iterator__sc_Iterator();
    while ($n(mapIt).hasNext__Z()) {
      var x1 = $as_T2($n(mapIt).next__O());
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1)
      };
      var k = $n(x1)._1__O();
      var v$1 = $as_scm_Builder($n(x1)._2__O());
      result = $n(result).updated__O__O__sci_HashMap(k, $n(v$1).result__O())
    };
    var this$6 = $n(result);
    $m_sci_HashMap$();
    var b = new $c_sci_HashMapBuilder();
    var it$1 = this$6.iterator__sc_Iterator();
    while ($n(it$1).hasNext__Z()) {
      var arg1 = $n(it$1).next__O();
      var v$3 = $as_T2(arg1);
      var _1 = $n(v$3)._1__O();
      var _2 = $n($as_sc_IterableOnceOps($n(v$3)._2__O())).foldLeft__O__F2__O($n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric).zero__O(), new $c_sjsr_AnonFunction2(((p) => ((acc$2, c$2) => {
        var c = $as_T2(c$2);
        return $n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric).plus__O__O__O(acc$2, $n(c)._2__O())
      }))(p)));
      $p_sci_HashMapBuilder__ensureUnaliased__V(b);
      var h = $m_sr_Statics$().anyHash__O__I(_1);
      var im = $m_sc_Hashing$().improve__I__I(h);
      b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, _1, _2, h, im, 0)
    };
    var this$8 = $n(b.result__sci_HashMap());
    var pred = new $c_sjsr_AnonFunction1(((i$2) => {
      var i = $as_T2(i$2);
      return $uZ($n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_predicate).apply__O__O($n(i)._1__O()))
    }));
    var accumulatings = this$8.filterImpl__F1__Z__sci_HashMap(pred, false);
    var this$9 = $n(s);
    var qual$1 = $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState((this$9.isEmpty__Z() ? new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState($m_s_package$().s_package$__f_Nil, ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()), $m_s_package$().s_package$__f_Nil, true) : this$9.get__O()));
    var $$x2 = $m_sci_SortedSet$();
    var this$14 = $n(accumulatings);
    var x$1 = $n($as_sc_IterableOnceOps($n($$x2).apply__sci_Seq__O__O($n($as_sc_IterableOnceOps($n(this$14.keySet__sci_Set()).map__F1__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_T2(x$2$2);
      return $as_Ljava_time_LocalDate($n(x$2)._1__O())
    }))))).toSeq__sci_Seq(), $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering))).toSeq__sci_Seq();
    var this$15 = $n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_items);
    var this$16 = $n($as_sc_SeqOps($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$15)).map__F1__O(new $c_sjsr_AnonFunction1(((x$3$2) => new $c_s_Some(x$3$2))))));
    var elem$1 = $m_s_None$();
    var x$3$3 = $as_sci_Seq(this$16.appended__O__O(elem$1));
    var this$17 = $n(qual$1);
    var x$4 = this$17.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_accumulate;
    $n(qual$1);
    return new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState(x$1, accumulatings, x$3$3, x$4)
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$() {
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$__f_yearFormatter = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_AccumulatingTable$ = this;
  var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$__f_yearFormatter = $m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__ju_Locale__Ljava_time_format_DateTimeFormatter("yy", locale);
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$__f_component = $n($n($n($p_Lreactbuild_analyze_cost_modules_AccumulatingTable$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_AccumulatingTable$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_AccumulatingTable$.prototype = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$.prototype;
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$.prototype.apply__Ldiode_react_ModelProxy__sci_SortedSet__sci_Map__F1__s_Option__s_Option__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_Textualizable__s_math_Numeric__s_reflect_ClassTag__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(proxy, items, accumulatings, seeMore, from, to, rTextualizable, accTextualizable, accNumeric, ctt) {
  var c = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$__f_component;
  var $$x1 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  var a = $n($n(ctt).runtimeClass__jl_Class()).getSimpleName__T();
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x1).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
  var props = new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(proxy, items, accumulatings, seeMore, rTextualizable, accTextualizable, accNumeric, from, to);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_AccumulatingTable$: 0
}, false, "reactbuild.analyze.cost.modules.AccumulatingTable$", {
  Lreactbuild_analyze_cost_modules_AccumulatingTable$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$;
var $n_Lreactbuild_analyze_cost_modules_AccumulatingTable$;
function $m_Lreactbuild_analyze_cost_modules_AccumulatingTable$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_AccumulatingTable$)) {
    $n_Lreactbuild_analyze_cost_modules_AccumulatingTable$ = new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$()
  };
  return $n_Lreactbuild_analyze_cost_modules_AccumulatingTable$
}
function $p_Lreactbuild_analyze_cost_modules_BusinessOpportunities$__viewPoint$1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($thiz, coords$1, dsl$1, coord$1) {
  var this$8 = $n(coords$1);
  var this$3 = $n(($n(dsl$1), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(",")));
  var this$2 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$2);
  var this$4 = $n(c);
  var next = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$4, this$3, coord$1)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB()).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_s_Option(x$2$2);
    var this$6 = $n(x$2);
    return $uD((this$6.isEmpty__Z() ? 20.0 : this$6.get__O()))
  })), new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $uD(x$3$2);
    return $m_s_Option$().apply__O__s_Option(x$3)
  }))));
  var this$7 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$1 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLowest__$times$times$times__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$7);
  var this$9 = $n(c$1);
  var $$x1 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$9, this$8, next);
  var this$10 = new $c_sjsr_AnonFunction2(((coords$2, zoom$2) => {
    var zoom = $uD(zoom$2);
    return new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(coords$2, zoom)
  }));
  return $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n($$x1).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon($f_F2__tupled__F1(this$10), new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(v$2);
    return $ct_T2__O__O__(new $c_T2(), $n(v).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords, $n(v).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom)
  })))).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon($m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$(), new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(v$3$2);
    return $n(v$3).Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom__f_viewPoint
  }))))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$() {
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x5 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    $n(dsl);
    var this$16 = $m_Lscalacss_internal_Attrs$gap$();
    $n(dsl);
    $n(dsl);
    var this$ = 1;
    var u = $m_Lscalacss_internal_LengthUnit$em$();
    var f$1 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var both = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$1 = $n(both).Lscalacss_internal_ValueT__f_value;
    var $$x3 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$16.Lscalacss_internal_Attrs$gap$__f_attr, v$1)));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1fr")));
    $n(dsl);
    $n(dsl);
    var a$1 = $m_Lscalacss_internal_Attrs$width$();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "100%")));
    $n(dsl);
    $n(dsl);
    var a$2 = $m_Lscalacss_internal_Attrs$height$();
    var array = [$$x4, $$x3, $$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "100%")))];
    return $as_sci_Seq($n($$x5).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })), new $c_Lsourcecode_Name("SideBySideView"));
  var this$86 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f$2 = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props(props$2);
    var x1 = $n(props).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_step;
    var x = $m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$();
    if ((x === x1)) {
      var u$1 = $m_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$().apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(props).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_ctl);
      var this$33 = $n(u$1);
      var n = this$33.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var content = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom)) {
      var x3 = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(x1);
      var viewPoint = $n(x3).Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom__f_viewPoint;
      var $$x12 = $m_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$();
      var $$x11 = $n(props).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_ctl;
      var $$x10 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$();
      var u$8 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$().apply__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((geolocation$2) => {
        var geolocation = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result(geolocation$2);
        var u$7 = $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$().apply__Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(geolocation, new $c_sjsr_AnonFunction1(((sources$2) => {
          var sources = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers(sources$2);
          var u$6 = $m_Lreactbuild_analyze_cost_modules_MapLogic$().apply__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__F3__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(props).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_proxy, geolocation, sources, new $c_sjsr_AnonFunction3(((init$2, visibleLayers$2, map$2) => {
            var init = $as_Lreactbuild_analyze_cost_modules_MapLogic$Init(init$2);
            var visibleLayers = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(visibleLayers$2);
            var $$x9 = $m_Lreactbuild_analyze_cost_modules_ControllerAndView$();
            var this$44 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
            var u$2 = $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$().apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__Lreactbuild_analyze_cost_modules_MapLogic$Init__Ltypings_ol_mapMod$default__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(sources, init, map$2, $n(props).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_proxy);
            var this$36 = $n(u$2);
            var n$1 = this$36.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
            var $$x7 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
            var $$x6 = $m_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$().withKey__T__Ljapgolly_scalajs_react_vdom_VdomElement("parcels");
            var u$3 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$().withKey__T__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot("layers", $n(props).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_proxy, visibleLayers);
            var this$39 = $n(u$3);
            var n$2 = this$39.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
            var array$1 = [$$x7, $$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
            var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
            var $$x8 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$44, null, ns);
            var u$4 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_sci_Nil$());
            var this$46 = $n(u$4);
            var n$3 = this$46.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
            var u$5 = $n($$x9).apply__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x8, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3));
            var this$49 = $n(u$5);
            var n$4 = this$49.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
            return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4)
          })));
          var this$52 = $n(u$6);
          var n$5 = this$52.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$5)
        })));
        var this$55 = $n(u$7);
        var n$6 = this$55.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$6)
      })));
      var this$58 = $n(u$8);
      var n$7 = this$58.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$7)];
      var u$9 = $n($$x10).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var this$64 = $n(u$9);
      var n$8 = this$64.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$8)];
      var u$10 = $n($$x12).apply__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__Ljapgolly_scalajs_react_extra_router_RouterCtlF__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(viewPoint, $$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
      var this$70 = $n(u$10);
      var n$9 = this$70.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var content = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$9)
    } else if (false) {
      var $$x13 = $n($n($n(props).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_ctl).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())))));
      var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("valider les parcelles"))];
      var content = $n($$x13).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
    } else {
      if ((!(x1 instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject))) {
        throw new $c_s_MatchError(x1)
      };
      var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("afficher le projet"))];
      var content = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
    };
    return content
  }));
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f$2, s);
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$86, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.BusinessOpportunities.component"))
}
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$.prototype = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$.prototype;
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$.prototype.routes__Ljapgolly_scalajs_react_extra_router_RoutingRule = (function() {
  new $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface();
  var arg1 = new $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl();
  var coord = $n(arg1.string__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("-?[0-9]{0,3}.[0-9]+")).pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(new $c_sjsr_AnonFunction1(((input$2) => {
    var input = $as_T(input$2);
    try {
      var $$x1 = new $c_s_util_Success(($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(input)))
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $$x1;
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!$n(o11).isEmpty__Z())) {
          var e$3 = $as_jl_Throwable($n(o11).get__O());
          var $$x1 = new $c_s_util_Failure(e$3);
          break matchEnd8
        };
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
      }
    };
    return $n($$x1).toOption__s_Option()
  })), new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $uD(x$1$2);
    return ("" + x$1)
  })));
  var this$9 = $n(coord);
  var next = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(",");
  var this$8 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed__Ato___Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$8);
  var this$10 = $n(c);
  var this$12 = $n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$10, this$9, next));
  var this$11 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$1 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLowest__$times$times$times__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$11);
  var this$13 = $n(c$1);
  var coords = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$13, this$12, coord)).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T2(x$2);
    return [$n(x)._2$mcD$sp__D(), $n(x)._1$mcD$sp__D()]
  })), new $c_sjsr_AnonFunction1(((a$2) => new $c_T2$mcDD$sp($uD(a$2[1]), $uD(a$2[0]))))));
  var this$15 = $n(coord);
  var next$1 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(",");
  var this$14 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$2 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed__Ato___Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$14);
  var this$16 = $n(c$2);
  var this$18 = $n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$16, this$15, next$1));
  var this$17 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$3 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLowest__$times$times$times__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$17);
  var this$19 = $n(c$3);
  var this$21 = $n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$19, this$18, coord));
  var next$2 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(",");
  var this$20 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$4 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed__Ato___Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$20);
  var this$22 = $n(c$4);
  var this$24 = $n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$22, this$21, next$2));
  var this$23 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$5 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLow__T3__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$23);
  var this$25 = $n(c$5);
  var this$27 = $n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$25, this$24, coord));
  var next$3 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(",");
  var this$26 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$6 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed__Ato___Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$26);
  var this$28 = $n(c$6);
  var this$30 = $n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$28, this$27, next$3));
  var this$29 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$7 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLow__T4__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$29);
  var this$31 = $n(c$7);
  $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$31, this$30, coord);
  arg1.string__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("[^|]*");
  var this$37 = $n($m_Ljapgolly_scalajs_react_extra_router_RoutingRule$().empty__Ljapgolly_scalajs_react_extra_router_RoutingRule());
  var r = new $c_Ljapgolly_scalajs_react_extra_router_Path("");
  var this$ = arg1.staticRoute__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__O__F1($n($m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(r.Ljapgolly_scalajs_react_extra_router_Path__f_value)).route__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(), $m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$());
  var a = new $c_sjsr_AnonFunction0((() => arg1.renderRP__F2__F1__Ljapgolly_scalajs_react_extra_router_RendererF(new $c_sjsr_AnonFunction2(((ctl$2, p$2) => {
    var ctl = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$2);
    var p = $as_Ldiode_react_ModelProxy(p$2);
    return $m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$().apply__Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props($m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$(), ctl, p))
  })), new $c_sjsr_AnonFunction1(((u$2) => {
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(u$2);
    var this$34 = $n(u);
    var n = this$34.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })))));
  var that = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$).apply__O__O(a));
  var this$46 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$37, that);
  var $$x4 = $n($m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("position"));
  var $$x3 = $p_Lreactbuild_analyze_cost_modules_BusinessOpportunities$__viewPoint$1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this, coords, arg1, coord);
  var this$38 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var $$x2 = $n($$x4).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x3, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$38));
  var this$40 = $m_s_$less$colon$less$();
  var this$$1 = arg1.dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1(arg1._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x2, this$40.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.getClassOf()));
  var g = arg1.dynRenderRP__F3__F1__F1(new $c_sjsr_AnonFunction3(((page$2, ctl$2$1, p$3$2) => {
    var page = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(page$2);
    var ctl$1 = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$2$1);
    var p$3 = $as_Ldiode_react_ModelProxy(p$3$2);
    return $m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$().apply__Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props(page, ctl$1, p$3))
  })), new $c_sjsr_AnonFunction1(((u$2$1) => {
    var u$1 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(u$2$1);
    var this$43 = $n(u$1);
    var n$1 = this$43.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  })));
  var that$1 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$1).apply__O__O(g));
  var this$55 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$46, that$1);
  var $$x7 = $n($m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("project"));
  var $$x6 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($m_Lreactbuild_analyze_cost_RouterConfigCommon$().refTo__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(arg1)).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((project$2) => {
    var project = $as_Lreactbuild_common_model_RefTo(project$2);
    return new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(project)
  })), new $c_sjsr_AnonFunction1(((x$1$3$2) => {
    var x$1$3 = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(x$1$3$2);
    return $n(x$1$3).Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject__f_project
  }))));
  var this$47 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var $$x5 = $n($$x7).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x6, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$47));
  var this$49 = $m_s_$less$colon$less$();
  var this$$2 = arg1.dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1(arg1._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x5, this$49.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.getClassOf()));
  var g$1 = arg1.dynRenderRP__F3__F1__F1(new $c_sjsr_AnonFunction3(((page$3$2, ctl$3$2, p$4$2) => {
    var page$3 = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(page$3$2);
    var ctl$3 = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$3$2);
    var p$4 = $as_Ldiode_react_ModelProxy(p$4$2);
    return $m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$().apply__Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props(page$3, ctl$3, p$4))
  })), new $c_sjsr_AnonFunction1(((u$3$2) => {
    var u$3 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(u$3$2);
    var this$52 = $n(u$3);
    var n$2 = this$52.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
  })));
  var that$2 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$2).apply__O__O(g$1));
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$55, that$2)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$.prototype.apply__Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(props) {
  var c = this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$: 0
}, false, "reactbuild.analyze.cost.modules.BusinessOpportunities$", {
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$;
var $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$;
function $m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$)) {
    $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$ = new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$()
  };
  return $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$
}
function $is_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step)))
}
function $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.BusinessOpportunities$Step"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.BusinessOpportunities$Step;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$() {
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$ = this;
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var this$10 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction0((() => $m_s_None$())), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep())));
  var deps = new $c_sjsr_AnonFunction2(((x$4$2, search$2) => {
    $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(x$4$2);
    var search = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(search$2);
    var this$5 = $n($as_s_Option($n(search).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
    var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lreactbuild_analyze_cost_modules_mapview_MapSearch(x$5$2);
      return $n(x$5).Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_input
    }));
    return (this$5.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$5.get__O())))
  }));
  var effect = new $c_sjsr_AnonFunction2(((props$2, search$3$2) => {
    $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(props$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(search$3$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      $as_s_Option(x$6$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline("", $m_sci_Nil$()))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$8 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$7 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = this$7.by_$eq$eq__F2();
  var r = this$8.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3);
  var this$9 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$9);
  var this$70 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$10, deps, effect, a, r, step)));
  var f$1 = new $c_sjsr_AnonFunction2(((ctl$2, state$2) => {
    var ctl = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(ctl$2);
    var state = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(state$2);
    var $$x16 = $m_Lreactbuild_analyze_cost_components_ResponsiveColumnLayout$();
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chercher par adresse"))];
    var $$x14 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h4", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$20 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_searchBoxContainer;
    var $$x12 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$20, s);
    var u = $m_Lreactbuild_analyze_cost_modules_mapview_SearchBox$().withKey__T__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot("search", state, new $c_sjsr_AnonFunction2(((coords$2, text$2) => {
      var text = $as_T(text$2);
      var $$x11 = $n($n(ctl).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(coords$2, 20.0))));
      var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(text))];
      return $n($$x11).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    })));
    var this$27 = $n(u);
    var n = this$27.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$2 = [$$x12, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    var $$x10 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var $$x9 = $m_Lreactbuild_analyze_cost_components_Feature$();
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Derni\u00e8res recherches"))];
    var $$x7 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h4", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("[ Derni\u00e8re adresse cherch\u00e9e ]"))];
    var array$5 = [$n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var $$x4 = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Position actuelle"))];
    var $$x2 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h4", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    var $$x1 = $m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).alert__T__Ljapgolly_scalajs_react_callback_Trampoline("Pas encore impl\u00e9ment\u00e9"));
    var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Se placer sur la carte o\u00f9 je suis actuellement"))];
    var array$8 = [$$x7, $$x4, $$x2, $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
    var array$9 = [$$x14, $$x10, $n($$x9).notImplemented__Z__sci_Seq__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_vdom_TagOf(true, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8), new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.BusinessOpportunitiesInitialStep.component"))];
    return $n($$x16).one__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
  }));
  var this$69 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$69);
  var s$1 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$__f_component = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$70, f$1, step$1, s$1)
}
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$.prototype = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$.prototype;
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(ctl) {
  var c = this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(ctl, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$: 0
}, false, "reactbuild.analyze.cost.modules.BusinessOpportunitiesInitialStep$", {
  Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$;
var $n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$;
function $m_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$)) {
    $n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$ = new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$()
  };
  return $n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$() {
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$().double__D__F2(1.0E-7);
  var this$28 = $m_Lcom_iz2use_react_hooks_package$();
  var api = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshotBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(x$7$2);
    return $n($as_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props($n(x$7).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)).Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_viewPoint
  })), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep()));
  var $$x4 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var this$7 = new $c_s_concurrent_duration_package$DurationInt(1000);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$ = this$7.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var length = new $c_RTLong(this$, (this$ >> 31));
  var $$x3 = new $c_s_concurrent_duration_FiniteDuration(length, unit);
  var $$x2 = new $c_sjsr_AnonFunction3(((props$2, x$8$2, viewPoint$2) => {
    $as_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(props$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$8$2));
    var viewPoint = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(viewPoint$2);
    return viewPoint
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var this$16 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x4.useDebouncedBy__s_concurrent_duration_FiniteDuration__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$11))));
  var deps = new $c_sjsr_AnonFunction4(((x$9$2, x$10$2, x$11$2, v$2) => {
    $as_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(x$9$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$10$2));
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$11$2);
    var v = $as_s_Option(v$2);
    return v
  }));
  var effect = new $c_sjsr_AnonFunction4(((props$3$2, x$12$2, viewPoint$3$2, v$3$2) => {
    var props$3 = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(props$3$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$12$2));
    var viewPoint$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(viewPoint$3$2);
    var v$3 = $as_s_Option(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$13$2) => {
      $as_s_Option(x$13$2);
      var $$x5 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
      var this$12 = $n(v$3);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).when__Z__F0__Ljapgolly_scalajs_react_callback_Trampoline(((!this$12.isEmpty__Z()) && $uZ($n($m_Ljapgolly_scalajs_react_Reusability$().testNot$extension__F2__F2($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$().Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseViewPoint)).apply__O__O__O($n(viewPoint$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, $n(props$3).Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_viewPoint))), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(props$3).Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_ctl).set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint($n(viewPoint$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)), $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)))))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$14 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var r = this$14.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3);
  var this$15 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22(this$15);
  var this$27 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$16, deps, effect, a, r, step)));
  var f = new $c_sjsr_AnonFunction4(((props$4$2, children$2, viewPoint$4$2, x$14$2) => {
    $as_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(props$4$2);
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var viewPoint$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(viewPoint$4$2);
    $as_s_Option(x$14$2);
    var $$x6 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$();
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(children))];
    var u = $n($$x6).apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(viewPoint$4, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var this$24 = $n(u);
    var n = this$24.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$26 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22(this$26);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$27, f, step$1, s);
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$28, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.BusinessOpportunitiesWithPositionAndZoom.component"))
}
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$.prototype = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$.prototype;
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__Ljapgolly_scalajs_react_extra_router_RouterCtlF__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(viewPoint, ctl, children) {
  var c = this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(viewPoint, ctl);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$: 0
}, false, "reactbuild.analyze.cost.modules.BusinessOpportunitiesWithPositionAndZoom$", {
  Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$;
var $n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$;
function $m_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$)) {
    $n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$ = new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$()
  };
  return $n_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ControllerAndView$() {
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerAndViewStyled = null;
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerStyled = null;
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ViewStyled = null;
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_SeparationStyled = null;
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerScrollArea = null;
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerArea = null;
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ControllerAndView$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerAndViewStyled = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x8 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x7 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    var this$8 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$8.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row-reverse")));
    $n(dsl);
    var this$11 = $n(dsl);
    $n(dsl);
    var this$10 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x = $f_Lscalacss_internal_Media$FeatureOps__portrait__O(this$10);
    var x$1 = $as_Lscalacss_internal_Media$Query(x);
    var $$x5 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$1), this$11);
    $n(dsl);
    var this$13 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var array = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$13.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")))];
    var x$2 = $$x5.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle(x$2);
    $n(dsl);
    var this$21 = $n(dsl);
    $n(dsl);
    var this$20 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x$3 = $n(this$20.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$());
    var x$3$1 = $as_Lscalacss_internal_Media$Query(x$3);
    var $$x3 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$3$1), this$21);
    $n(dsl);
    var this$23 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$1 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$2 = v$1.Lscalacss_internal_Literal__f_value;
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$23.Lscalacss_internal_Attrs$overflow$__f_attr, v$2)));
    $n(dsl);
    var this$32 = $m_Lscalacss_internal_Attrs$width$();
    $n(dsl);
    $n(dsl);
    var this$ = 100;
    var f$1 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lscalacss_internal_Percentage(x$4$2);
      return $n(x$4).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var v$3 = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$4 = $n(v$3).Lscalacss_internal_ValueT__f_value;
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$32.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$4)));
    $n(dsl);
    var this$41 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl);
    $n(dsl);
    var this$$1 = 100;
    var f$3 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$1);
    $n(dsl);
    $n(dsl);
    var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$1) => {
      var x$4$1 = $as_Lscalacss_internal_Percentage(x$4$2$1);
      return $n(x$4$1).value__T()
    })));
    $n(dsl);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$3 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$3)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
    var r$1 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var v$5 = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$3);
    var v$6 = $n(v$5).Lscalacss_internal_ValueT__f_value;
    var array$1 = [$$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$41.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$6)))];
    var x$5 = $$x3.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$2 = [$$x7, $$x6, $$x4, new $c_Lscalacss_internal_DslBase$ToStyle(x$5)];
    return $as_sci_Seq($n($$x8).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)))
  })), new $c_Lsourcecode_Name("ControllerAndViewStyled"));
  var this$52 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$7 = "div";
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerStyled = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$52, v$7)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x16 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var this$61 = $m_Lscalacss_internal_Attrs$maxWidth$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$2 = 50;
    var f$5 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$2);
    $n(dsl$3);
    $n(dsl$3);
    var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$2) => {
      var x$4$3 = $as_Lscalacss_internal_Percentage(x$4$2$2);
      return $n(x$4$3).value__T()
    })));
    $n(dsl$3);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
      var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$2);
      return $n(x$1$4)
    }));
    var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
    var r$2 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
    var v$8 = $n(r$2).apply__O__Lscalacss_internal_ValueT(f$5);
    var v$9 = $n(v$8).Lscalacss_internal_ValueT__f_value;
    var $$x15 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$61.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$9)));
    $n(dsl$3);
    var this$63 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$10 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$11 = v$10.Lscalacss_internal_Literal__f_value;
    var $$x14 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$63.Lscalacss_internal_Attrs$overflow$__f_attr, v$11)));
    $n(dsl$3);
    var this$72 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$3 = 100;
    var f$7 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$3);
    $n(dsl$3);
    $n(dsl$3);
    var ab$3 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$3) => {
      var x$4$4 = $as_Lscalacss_internal_Percentage(x$4$2$3);
      return $n(x$4$4).value__T()
    })));
    $n(dsl$3);
    var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
      var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$3);
      return $n(x$1$5)
    }));
    var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
    var r$3 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
    var v$12 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$7);
    var v$13 = $n(v$12).Lscalacss_internal_ValueT__f_value;
    var $$x13 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$72.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$13)));
    $n(dsl$3);
    var this$75 = $n(dsl$3);
    $n(dsl$3);
    var this$74 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x$6 = $f_Lscalacss_internal_Media$FeatureOps__portrait__O(this$74);
    var x$7 = $as_Lscalacss_internal_Media$Query(x$6);
    var $$x12 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl$3).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$7), this$75);
    $n(dsl$3);
    var this$84 = $m_Lscalacss_internal_Attrs$maxHeight$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$4 = 50;
    var f$9 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$4);
    $n(dsl$3);
    $n(dsl$3);
    var ab$4 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$4) => {
      var x$4$5 = $as_Lscalacss_internal_Percentage(x$4$2$4);
      return $n(x$4$5).value__T()
    })));
    $n(dsl$3);
    var f$8 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
      var x$1$6 = $as_Lscalacss_internal_ValueT(x$1$2$4);
      return $n(x$1$6)
    }));
    var bc$4 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$8);
    var r$4 = $n(ab$4).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$4);
    var v$14 = $n(r$4).apply__O__Lscalacss_internal_ValueT(f$9);
    var v$15 = $n(v$14).Lscalacss_internal_ValueT__f_value;
    var $$x11 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$84.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$15)));
    $n(dsl$3);
    var this$93 = $m_Lscalacss_internal_Attrs$width$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$5 = 100;
    var f$11 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$5);
    $n(dsl$3);
    $n(dsl$3);
    var ab$5 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$5) => {
      var x$4$6 = $as_Lscalacss_internal_Percentage(x$4$2$5);
      return $n(x$4$6).value__T()
    })));
    $n(dsl$3);
    var f$10 = new $c_sjsr_AnonFunction1(((x$1$2$5) => {
      var x$1$7 = $as_Lscalacss_internal_ValueT(x$1$2$5);
      return $n(x$1$7)
    }));
    var bc$5 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$10);
    var r$5 = $n(ab$5).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$5);
    var v$16 = $n(r$5).apply__O__Lscalacss_internal_ValueT(f$11);
    var v$17 = $n(v$16).Lscalacss_internal_ValueT__f_value;
    var $$x10 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$93.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$17)));
    $n(dsl$3);
    var this$102 = $m_Lscalacss_internal_Attrs$maxWidth$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$6 = 100;
    var f$13 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$6);
    $n(dsl$3);
    $n(dsl$3);
    var ab$6 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$6) => {
      var x$4$7 = $as_Lscalacss_internal_Percentage(x$4$2$6);
      return $n(x$4$7).value__T()
    })));
    $n(dsl$3);
    var f$12 = new $c_sjsr_AnonFunction1(((x$1$2$6) => {
      var x$1$8 = $as_Lscalacss_internal_ValueT(x$1$2$6);
      return $n(x$1$8)
    }));
    var bc$6 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$12);
    var r$6 = $n(ab$6).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$6);
    var v$18 = $n(r$6).apply__O__Lscalacss_internal_ValueT(f$13);
    var v$19 = $n(v$18).Lscalacss_internal_ValueT__f_value;
    var $$x9 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$102.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$19)));
    $n(dsl$3);
    var this$104 = $m_Lscalacss_internal_Attrs$height$();
    var v$20 = $m_Lscalacss_internal_Literal$Typed$auto$();
    var v$21 = v$20.Lscalacss_internal_Literal__f_value;
    var array$3 = [$$x11, $$x10, $$x9, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$104.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$21)))];
    var x$8 = $$x12.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$4 = [$$x15, $$x14, $$x13, new $c_Lscalacss_internal_DslBase$ToStyle(x$8)];
    return $as_sci_Seq($n($$x16).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)))
  })), new $c_Lsourcecode_Name("ControllerStyled"));
  var this$115 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$22 = "div";
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ViewStyled = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$115, v$22)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$4$2) => {
    var dsl$4 = $as_Lscalacss_internal_DslBase(dsl$4$2);
    var $$x17 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$4);
    $n(dsl$4);
    var a = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var array$5 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1")))];
    return $as_sci_Seq($n($$x17).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
  })), new $c_Lsourcecode_Name("ViewStyled"));
  var this$124 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$23 = "div";
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_SeparationStyled = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$124, v$23)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$5$2) => {
    var dsl$5 = $as_Lscalacss_internal_DslBase(dsl$5$2);
    var $$x21 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$5);
    var this$134 = $m_Lscalacss_internal_Attrs$width$();
    $n(dsl$5);
    $n(dsl$5);
    var this$$7 = 1;
    var u = $m_Lscalacss_internal_LengthUnit$em$();
    var f$15 = new $c_Lscalacss_internal_Length(this$$7, u);
    $n(dsl$5);
    $n(dsl$5);
    var ab$7 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3$3).value__T()
    })));
    $n(dsl$5);
    var f$14 = new $c_sjsr_AnonFunction1(((x$1$2$7) => {
      var x$1$9 = $as_Lscalacss_internal_ValueT(x$1$2$7);
      return $n(x$1$9)
    }));
    var bc$7 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$14);
    var r$7 = $n(ab$7).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$7);
    var v$24 = $n(r$7).apply__O__Lscalacss_internal_ValueT(f$15);
    var v$25 = $n(v$24).Lscalacss_internal_ValueT__f_value;
    var $$x20 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$134.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$25)));
    $n(dsl$5);
    var this$137 = $n(dsl$5);
    $n(dsl$5);
    var this$136 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x$9 = $f_Lscalacss_internal_Media$FeatureOps__portrait__O(this$136);
    var x$10 = $as_Lscalacss_internal_Media$Query(x$9);
    var $$x19 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl$5).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$10), this$137);
    $n(dsl$5);
    var this$139 = $m_Lscalacss_internal_Attrs$width$();
    var v$26 = $m_Lscalacss_internal_Literal$Typed$inherit$();
    var v$27 = v$26.Lscalacss_internal_Literal__f_value;
    var $$x18 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$139.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$27)));
    $n(dsl$5);
    var this$150 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl$5);
    $n(dsl$5);
    var this$$8 = 1;
    var u$1 = $m_Lscalacss_internal_LengthUnit$em$();
    var f$17 = new $c_Lscalacss_internal_Length(this$$8, u$1);
    $n(dsl$5);
    $n(dsl$5);
    var ab$8 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      var x$3$4 = $as_Lscalacss_internal_Length(x$3$2$1);
      return $n(x$3$4).value__T()
    })));
    $n(dsl$5);
    var f$16 = new $c_sjsr_AnonFunction1(((x$1$2$8) => {
      var x$1$10 = $as_Lscalacss_internal_ValueT(x$1$2$8);
      return $n(x$1$10)
    }));
    var bc$8 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$16);
    var r$8 = $n(ab$8).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$8);
    var v$28 = $n(r$8).apply__O__Lscalacss_internal_ValueT(f$17);
    var v$29 = $n(v$28).Lscalacss_internal_ValueT__f_value;
    var array$6 = [$$x18, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$150.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$29)))];
    var x$11 = $$x19.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$7 = [$$x20, new $c_Lscalacss_internal_DslBase$ToStyle(x$11)];
    return $as_sci_Seq($n($$x21).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)))
  })), new $c_Lsourcecode_Name("SeparationStyled"));
  var this$161 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$30 = "div";
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerScrollArea = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$161, v$30)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$6$2) => {
    var dsl$6 = $as_Lscalacss_internal_DslBase(dsl$6$2);
    var $$x23 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$6);
    var this$170 = $m_Lscalacss_internal_Attrs$maxHeight$();
    $n(dsl$6);
    $n(dsl$6);
    var this$$9 = 100;
    var f$19 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$9);
    $n(dsl$6);
    $n(dsl$6);
    var ab$9 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$7) => {
      var x$4$8 = $as_Lscalacss_internal_Percentage(x$4$2$7);
      return $n(x$4$8).value__T()
    })));
    $n(dsl$6);
    var f$18 = new $c_sjsr_AnonFunction1(((x$1$2$9) => {
      var x$1$11 = $as_Lscalacss_internal_ValueT(x$1$2$9);
      return $n(x$1$11)
    }));
    var bc$9 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$18);
    var r$9 = $n(ab$9).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$9);
    var v$31 = $n(r$9).apply__O__Lscalacss_internal_ValueT(f$19);
    var v$32 = $n(v$31).Lscalacss_internal_ValueT__f_value;
    var $$x22 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$170.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$32)));
    $n(dsl$6);
    var this$172 = $m_Lscalacss_internal_Attrs$overflowY$();
    var v$33 = $m_Lscalacss_internal_Literal$Typed$auto$();
    var v$34 = v$33.Lscalacss_internal_Literal__f_value;
    var array$8 = [$$x22, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$172.Lscalacss_internal_Attrs$overflowY$__f_attr, v$34)))];
    return $as_sci_Seq($n($$x23).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8)))
  })), new $c_Lsourcecode_Name("ControllerScrollArea"));
  var this$178 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$35 = "div";
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerArea = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$178, v$35)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$7$2) => {
    var dsl$7 = $as_Lscalacss_internal_DslBase(dsl$7$2);
    var $$x25 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$7);
    var this$180 = $m_Lscalacss_internal_Attrs$display$();
    var $$x24 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$7).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$180.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$7);
    var this$182 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var array$9 = [$$x24, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$7).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$182.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")))];
    return $as_sci_Seq($n($$x25).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9)))
  })), new $c_Lsourcecode_Name("ControllerArea"));
  var this$203 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f$20 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_ControllerAndView$Props(p$2);
    var $$x32 = $n($m_Lreactbuild_analyze_cost_modules_ControllerAndView$().Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerAndViewStyled);
    var $$x31 = $n($m_Lreactbuild_analyze_cost_modules_ControllerAndView$().Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerStyled);
    var $$x30 = $m_Lreactbuild_analyze_cost_modules_ControllerAndView$().Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerScrollArea;
    var $$x29 = $m_Lreactbuild_analyze_cost_modules_ControllerAndView$().Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ControllerArea;
    var array$10 = [$n(p).Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_controller];
    var array$11 = [$n($$x29).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
    var array$12 = [$n($$x30).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
    var $$x28 = $n($$x31).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
    var $$x27 = $n($m_Lreactbuild_analyze_cost_modules_ControllerAndView$().Lreactbuild_analyze_cost_modules_ControllerAndView$__f_SeparationStyled).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($m_sci_Nil$());
    var $$x26 = $m_Lreactbuild_analyze_cost_modules_ControllerAndView$().Lreactbuild_analyze_cost_modules_ControllerAndView$__f_ViewStyled;
    var array$13 = [$n(p).Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_view];
    var array$14 = [$$x28, $$x27, $n($$x26).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
    return $n($$x32).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))
  }));
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f$20, s);
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$203, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.ControllerAndView.component"))
}
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ControllerAndView$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ControllerAndView$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ControllerAndView$.prototype = $c_Lreactbuild_analyze_cost_modules_ControllerAndView$.prototype;
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(controller, view) {
  var c = this.Lreactbuild_analyze_cost_modules_ControllerAndView$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props(controller, view);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_ControllerAndView$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ControllerAndView$: 0
}, false, "reactbuild.analyze.cost.modules.ControllerAndView$", {
  Lreactbuild_analyze_cost_modules_ControllerAndView$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ControllerAndView$;
var $n_Lreactbuild_analyze_cost_modules_ControllerAndView$;
function $m_Lreactbuild_analyze_cost_modules_ControllerAndView$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ControllerAndView$)) {
    $n_Lreactbuild_analyze_cost_modules_ControllerAndView$ = new $c_Lreactbuild_analyze_cost_modules_ControllerAndView$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ControllerAndView$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Crossed$() {
  this.Lreactbuild_analyze_cost_modules_Crossed$__f_crossTypes = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_Crossed$ = this;
  var $$x22 = $m_s_package$().s_package$__f_Seq;
  var array$9 = [new $c_Lreactbuild_analyze_cost_modules_CrossType(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x3 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "loadAmountByBuildingPartBuildingSite"];
    var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$6 = $n($m_s_Predef$().s_Predef$__f_Map);
    var elems = $m_sci_Nil$();
    return $n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$6.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$13 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
      var this$12 = $m_Lreactbuild_model_package$();
      $m_s_DummyImplicit$();
      var ev = new $c_Lshapeless_Refute$$anon$2();
      var this$11 = $m_Lio_circe_Decoder$();
      $m_Lio_circe_Decoder$();
      var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
      var decodeA0 = new $c_Lio_circe_Decoder$$anon$39(d);
      $m_Lio_circe_Decoder$();
      var d$1 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
      var decodeA1 = new $c_Lio_circe_Decoder$$anon$39(d$1);
      var decodeK = new $c_Lio_circe_TupleDecoders$$anon$2(this$11, decodeA0, decodeA1);
      var decodeV = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
      var evidence$1 = $f_Lreactbuild_common_CirceExtendedImplicits__decodeOtherMap__Lshapeless_Refute__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder(this$12, ev, decodeK, decodeV);
      return $as_sci_Map(this$13.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $as_s_Option(x1$1$2);
    var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x7 = new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self;
    var $$x6 = $m_s_package$().s_package$__f_Seq;
    var array$1 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listInvoicePagesByBuildingPartBuildingSite"];
    var $$x5 = $as_sci_Seq($n($$x6).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
    var this$31 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$19 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$21 = $n(new $c_Lautowire_ClientProxy(this$19).Lautowire_ClientProxy__f_self);
    $m_Lio_circe_Encoder$();
    var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var evidence$2 = new $c_Lio_circe_Encoder$$anon$21(e);
    var y = this$21.write__O__Lio_circe_Encoder__Lio_circe_Json(x0$1, evidence$2);
    var $$x4 = $ct_T2__O__O__(new $c_T2(), "buildingPart", y);
    var this$24 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$26 = $n(new $c_Lautowire_ClientProxy(this$24).Lautowire_ClientProxy__f_self);
    $m_Lio_circe_Encoder$();
    var e$1 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var evidence$2$1 = new $c_Lio_circe_Encoder$$anon$21(e$1);
    var y$1 = this$26.write__O__Lio_circe_Encoder__Lio_circe_Json(x1$1, evidence$2$1);
    var array$2 = [$$x4, $ct_T2__O__O__(new $c_T2(), "buildingSite", y$1)];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    return $n($n($$x7).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x5, this$31.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lio_circe_Json(x$2$2);
      var this$32 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$34 = $n(new $c_Lautowire_ClientProxy(this$32).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
      var evidence$1$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$34.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2, evidence$1$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), $m_Lreactbuild_analyze_cost_modules_CrossSpec$().Lreactbuild_analyze_cost_modules_CrossSpec$__f_buildingPart, $m_Lreactbuild_analyze_cost_modules_CrossSpec$().Lreactbuild_analyze_cost_modules_CrossSpec$__f_buildingSiteName), new $c_Lreactbuild_analyze_cost_modules_CrossType(new $c_sjsr_AnonFunction0((() => {
    var this$35 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x10 = new $c_Lautowire_ClientProxy(this$35).Lautowire_ClientProxy__f_self;
    var $$x9 = $m_s_package$().s_package$__f_Seq;
    var array$3 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "loadAmountBySupplierBuildingSite"];
    var $$x8 = $as_sci_Seq($n($$x9).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)));
    var this$39 = $n($m_s_Predef$().s_Predef$__f_Map);
    var elems$2 = $m_sci_Nil$();
    return $n($n($$x10).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x8, this$39.from__sc_IterableOnce__sci_Map(elems$2)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lio_circe_Json(x$3$2);
      var this$40 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$46 = $n(new $c_Lautowire_ClientProxy(this$40).Lautowire_ClientProxy__f_self);
      var this$45 = $m_Lreactbuild_model_package$();
      $m_s_DummyImplicit$();
      var ev$1 = new $c_Lshapeless_Refute$$anon$2();
      var this$44 = $m_Lio_circe_Decoder$();
      $m_Lio_circe_Decoder$();
      var d$2 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
      var decodeA0$1 = new $c_Lio_circe_Decoder$$anon$39(d$2);
      $m_Lio_circe_Decoder$();
      var d$3 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
      var decodeA1$1 = new $c_Lio_circe_Decoder$$anon$39(d$3);
      var decodeK$1 = new $c_Lio_circe_TupleDecoders$$anon$2(this$44, decodeA0$1, decodeA1$1);
      var decodeV$1 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
      var evidence$1$2 = $f_Lreactbuild_common_CirceExtendedImplicits__decodeOtherMap__Lshapeless_Refute__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder(this$45, ev$1, decodeK$1, decodeV$1);
      return $as_sci_Map(this$46.read__Lio_circe_Json__Lio_circe_Decoder__O(x$3, evidence$1$2))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), new $c_sjsr_AnonFunction2(((x0$2$2, x1$2$2) => {
    var x0$2 = $as_s_Option(x0$2$2);
    var x1$2 = $as_s_Option(x1$2$2);
    var this$47 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x14 = new $c_Lautowire_ClientProxy(this$47).Lautowire_ClientProxy__f_self;
    var $$x13 = $m_s_package$().s_package$__f_Seq;
    var array$4 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listInvoicePagesBySupplierBuildingSite"];
    var $$x12 = $as_sci_Seq($n($$x13).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)));
    var this$64 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$52 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$54 = $n(new $c_Lautowire_ClientProxy(this$52).Lautowire_ClientProxy__f_self);
    $m_Lio_circe_Encoder$();
    var e$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var evidence$2$2 = new $c_Lio_circe_Encoder$$anon$21(e$2);
    var y$2 = this$54.write__O__Lio_circe_Encoder__Lio_circe_Json(x0$2, evidence$2$2);
    var $$x11 = $ct_T2__O__O__(new $c_T2(), "supplier", y$2);
    var this$57 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$59 = $n(new $c_Lautowire_ClientProxy(this$57).Lautowire_ClientProxy__f_self);
    $m_Lio_circe_Encoder$();
    var e$3 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var evidence$2$3 = new $c_Lio_circe_Encoder$$anon$21(e$3);
    var y$3 = this$59.write__O__Lio_circe_Encoder__Lio_circe_Json(x1$2, evidence$2$3);
    var array$5 = [$$x11, $ct_T2__O__O__(new $c_T2(), "buildingSite", y$3)];
    var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
    return $n($n($$x14).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x12, this$64.from__sc_IterableOnce__sci_Map(elems$3)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lio_circe_Json(x$4$2);
      var this$65 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$67 = $n(new $c_Lautowire_ClientProxy(this$65).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA$1 = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
      var evidence$1$3 = new $c_Lio_circe_Decoder$$anon$44(decodeA$1);
      return $as_sci_List(this$67.read__Lio_circe_Json__Lio_circe_Decoder__O(x$4, evidence$1$3))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), $m_Lreactbuild_analyze_cost_modules_CrossSpec$().Lreactbuild_analyze_cost_modules_CrossSpec$__f_supplier, $m_Lreactbuild_analyze_cost_modules_CrossSpec$().Lreactbuild_analyze_cost_modules_CrossSpec$__f_buildingSiteName), new $c_Lreactbuild_analyze_cost_modules_CrossType(new $c_sjsr_AnonFunction0((() => {
    var this$68 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x17 = new $c_Lautowire_ClientProxy(this$68).Lautowire_ClientProxy__f_self;
    var $$x16 = $m_s_package$().s_package$__f_Seq;
    var array$6 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "loadAmountBySupplierBuildingPart"];
    var $$x15 = $as_sci_Seq($n($$x16).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6)));
    var this$72 = $n($m_s_Predef$().s_Predef$__f_Map);
    var elems$4 = $m_sci_Nil$();
    return $n($n($$x17).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x15, this$72.from__sc_IterableOnce__sci_Map(elems$4)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lio_circe_Json(x$5$2);
      var this$73 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$79 = $n(new $c_Lautowire_ClientProxy(this$73).Lautowire_ClientProxy__f_self);
      var this$78 = $m_Lreactbuild_model_package$();
      $m_s_DummyImplicit$();
      var ev$2 = new $c_Lshapeless_Refute$$anon$2();
      var this$77 = $m_Lio_circe_Decoder$();
      $m_Lio_circe_Decoder$();
      var d$4 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
      var decodeA0$2 = new $c_Lio_circe_Decoder$$anon$39(d$4);
      $m_Lio_circe_Decoder$();
      var d$5 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
      var decodeA1$2 = new $c_Lio_circe_Decoder$$anon$39(d$5);
      var decodeK$2 = new $c_Lio_circe_TupleDecoders$$anon$2(this$77, decodeA0$2, decodeA1$2);
      var decodeV$2 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
      var evidence$1$4 = $f_Lreactbuild_common_CirceExtendedImplicits__decodeOtherMap__Lshapeless_Refute__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder(this$78, ev$2, decodeK$2, decodeV$2);
      return $as_sci_Map(this$79.read__Lio_circe_Json__Lio_circe_Decoder__O(x$5, evidence$1$4))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), new $c_sjsr_AnonFunction2(((x0$3$2, x1$3$2) => {
    var x0$3 = $as_s_Option(x0$3$2);
    var x1$3 = $as_s_Option(x1$3$2);
    var this$80 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x21 = new $c_Lautowire_ClientProxy(this$80).Lautowire_ClientProxy__f_self;
    var $$x20 = $m_s_package$().s_package$__f_Seq;
    var array$7 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listInvoicePagesBySupplierBuildingPart"];
    var $$x19 = $as_sci_Seq($n($$x20).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)));
    var this$97 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$85 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$87 = $n(new $c_Lautowire_ClientProxy(this$85).Lautowire_ClientProxy__f_self);
    $m_Lio_circe_Encoder$();
    var e$4 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var evidence$2$4 = new $c_Lio_circe_Encoder$$anon$21(e$4);
    var y$4 = this$87.write__O__Lio_circe_Encoder__Lio_circe_Json(x0$3, evidence$2$4);
    var $$x18 = $ct_T2__O__O__(new $c_T2(), "supplier", y$4);
    var this$90 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$92 = $n(new $c_Lautowire_ClientProxy(this$90).Lautowire_ClientProxy__f_self);
    $m_Lio_circe_Encoder$();
    var e$5 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var evidence$2$5 = new $c_Lio_circe_Encoder$$anon$21(e$5);
    var y$5 = this$92.write__O__Lio_circe_Encoder__Lio_circe_Json(x1$3, evidence$2$5);
    var array$8 = [$$x18, $ct_T2__O__O__(new $c_T2(), "buildingPart", y$5)];
    var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
    return $n($n($$x21).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x19, this$97.from__sc_IterableOnce__sci_Map(elems$5)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Lio_circe_Json(x$6$2);
      var this$98 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$100 = $n(new $c_Lautowire_ClientProxy(this$98).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA$2 = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
      var evidence$1$5 = new $c_Lio_circe_Decoder$$anon$44(decodeA$2);
      return $as_sci_List(this$100.read__Lio_circe_Json__Lio_circe_Decoder__O(x$6, evidence$1$5))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), $m_Lreactbuild_analyze_cost_modules_CrossSpec$().Lreactbuild_analyze_cost_modules_CrossSpec$__f_supplier, $m_Lreactbuild_analyze_cost_modules_CrossSpec$().Lreactbuild_analyze_cost_modules_CrossSpec$__f_buildingPart)];
  this.Lreactbuild_analyze_cost_modules_Crossed$__f_crossTypes = $as_sci_Seq($n($$x22).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9)));
  this.Lreactbuild_analyze_cost_modules_Crossed$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Crossed", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_Crossed$TypedProps(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_Crossed$TypedState($m_Ldiode_data_Empty$(), $m_s_package$().s_package$__f_Nil)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2$1) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2$1);
    return new $c_Lreactbuild_analyze_cost_modules_Crossed$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
    var x$3$1 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2$1);
    var $$x24 = $n($as_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend($n(x$3$1).backend__O()));
    var this$106 = $n(x$3$1);
    var $$x23 = $as_Lreactbuild_analyze_cost_modules_Crossed$TypedProps($n(this$106.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$107 = $n(x$3$1);
    return $n($$x24).render__Lreactbuild_analyze_cost_modules_Crossed$TypedProps__Lreactbuild_analyze_cost_modules_Crossed$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x23, $as_Lreactbuild_analyze_cost_modules_Crossed$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$107)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_Crossed$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Crossed$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Crossed$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Crossed$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Crossed$.prototype = $c_Lreactbuild_analyze_cost_modules_Crossed$.prototype;
$c_Lreactbuild_analyze_cost_modules_Crossed$.prototype.apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement = (function(idx) {
  var this$9 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_modules_Crossed$().Lreactbuild_analyze_cost_modules_Crossed$__f_component;
    var this$5 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var $$x4 = $n(pageProps).Lreactbuild_package$PageProps__f_router;
    var $$x3 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var $$x2 = $m_Lreactbuild_analyze_cost_modules_Crossed$().Lreactbuild_analyze_cost_modules_Crossed$__f_crossTypes;
    var this$3 = $n(idx);
    if (this$3.isEmpty__Z()) {
      var $$x1 = true
    } else {
      var arg1 = this$3.get__O();
      var x$14 = $uI(arg1);
      var $$x1 = (x$14 < $n($m_Lreactbuild_analyze_cost_modules_Crossed$().Lreactbuild_analyze_cost_modules_Crossed$__f_crossTypes).length__I())
    };
    var this$4 = $n(($$x1 ? this$3 : $m_s_None$()));
    var props = new $c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps($$x4, $$x3, $as_Lreactbuild_analyze_cost_modules_CrossType($n($$x2).apply__I__O($uI((this$4.isEmpty__Z() ? 0 : this$4.get__O())))));
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$5.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$5.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$7 = $n(u);
    var n = this$7.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$9, f)
});
var $d_Lreactbuild_analyze_cost_modules_Crossed$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Crossed$: 0
}, false, "reactbuild.analyze.cost.modules.Crossed$", {
  Lreactbuild_analyze_cost_modules_Crossed$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_Crossed$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Crossed$;
var $n_Lreactbuild_analyze_cost_modules_Crossed$;
function $m_Lreactbuild_analyze_cost_modules_Crossed$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_Crossed$)) {
    $n_Lreactbuild_analyze_cost_modules_Crossed$ = new $c_Lreactbuild_analyze_cost_modules_Crossed$()
  };
  return $n_Lreactbuild_analyze_cost_modules_Crossed$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedDetails$() {
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_CrossedDetails$ = this;
  var this$8 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("CrossedDetails", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState($m_Ldiode_data_Unavailable$(), $m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    var $$x3 = $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend($n(c).backend__O());
    var this$6 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).onPropsChange__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($n(this$6.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()), $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$15 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$8, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G));
  var f$1 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(c$3$2);
    var $$x9 = $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend($n(c$3).backend__O());
    var this$9 = $n(c$3);
    var $$x8 = $n($as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($n(this$9.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_proxy;
    var this$10 = $n(c$3);
    var $$x7 = $n($as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($n(this$10.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType;
    var this$11 = $n(c$3);
    var $$x6 = $n($as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($n(this$11.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_getRef;
    var $$x5 = $ct_T2__O__O__(new $c_T2(), $m_s_None$(), $m_s_None$());
    var this$12 = $n(c$3);
    var $$x4 = new $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($$x8, $$x7, $$x6, $$x5, (-1), $n($as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($n(this$12.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_router);
    var this$13 = $n(c$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x9).onPropsChange__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($$x4, $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($n(this$13.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$15, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedDetails$.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$.prototype;
var $d_Lreactbuild_analyze_cost_modules_CrossedDetails$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossedDetails$: 0
}, false, "reactbuild.analyze.cost.modules.CrossedDetails$", {
  Lreactbuild_analyze_cost_modules_CrossedDetails$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossedDetails$;
var $n_Lreactbuild_analyze_cost_modules_CrossedDetails$;
function $m_Lreactbuild_analyze_cost_modules_CrossedDetails$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_CrossedDetails$)) {
    $n_Lreactbuild_analyze_cost_modules_CrossedDetails$ = new $c_Lreactbuild_analyze_cost_modules_CrossedDetails$()
  };
  return $n_Lreactbuild_analyze_cost_modules_CrossedDetails$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedTable$() {
  this.Lreactbuild_analyze_cost_modules_CrossedTable$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_CrossedTable$ = this;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("CrossedTable", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_CrossedTable$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__Lreactbuild_analyze_cost_modules_CrossedTable$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_CrossedTable$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossedTable$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedTable$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedTable$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedTable$.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedTable$.prototype;
var $d_Lreactbuild_analyze_cost_modules_CrossedTable$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossedTable$: 0
}, false, "reactbuild.analyze.cost.modules.CrossedTable$", {
  Lreactbuild_analyze_cost_modules_CrossedTable$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossedTable$;
var $n_Lreactbuild_analyze_cost_modules_CrossedTable$;
function $m_Lreactbuild_analyze_cost_modules_CrossedTable$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_CrossedTable$)) {
    $n_Lreactbuild_analyze_cost_modules_CrossedTable$ = new $c_Lreactbuild_analyze_cost_modules_CrossedTable$()
  };
  return $n_Lreactbuild_analyze_cost_modules_CrossedTable$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Dashboard$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_Dashboard$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Dashboard$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Dashboard$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Dashboard$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Dashboard$.prototype = $c_Lreactbuild_analyze_cost_modules_Dashboard$.prototype;
$c_Lreactbuild_analyze_cost_modules_Dashboard$.prototype.apply__Ljapgolly_scalajs_react_vdom_TagOf = (function() {
  var $$x12 = $m_Lreactbuild_analyze_cost_components_ScrollBlockContainer$();
  var $$x10 = $m_Lreactbuild_analyze_cost_components_ExpandableCard$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Nouveaut\u00e9s sur reactbuild");
  var u = $m_Lreactbuild_analyze_cost_components_Changelog$().apply__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot();
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  var u$1 = $n($$x10).apply__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x9, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var this$10 = $n(u$1);
  var n$1 = this$10.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x11 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
  var $$x7 = $m_Lreactbuild_analyze_cost_components_ExpandableCard$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Mettre \u00e0 jour le relev\u00e9 d'heures");
  var array$1 = [$m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$().apply__Ljapgolly_scalajs_react_vdom_VdomElement()];
  var u$2 = $n($$x7).apply__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var this$18 = $n(u$2);
  var n$2 = this$18.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2);
  var $$x4 = $m_Lreactbuild_analyze_cost_components_ExpandableCard$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Synth\u00e8se des heures");
  var array$2 = [$m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$().apply__Ljapgolly_scalajs_react_vdom_VdomElement()];
  var u$3 = $n($$x4).apply__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var this$26 = $n(u$3);
  var n$3 = this$26.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x5 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3);
  var $$x2 = $m_Lreactbuild_analyze_cost_components_ExpandableCard$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9cup\u00e9rer les donn\u00e9es des fournisseurs");
  var u$4 = $m_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$().apply__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot();
  var this$31 = $n(u$4);
  var n$4 = this$31.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4)];
  var u$5 = $n($$x2).apply__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var this$37 = $n(u$5);
  var n$5 = this$37.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$4 = [$$x11, $$x8, $$x5, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$5)];
  return $n($$x12).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
var $d_Lreactbuild_analyze_cost_modules_Dashboard$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Dashboard$: 0
}, false, "reactbuild.analyze.cost.modules.Dashboard$", {
  Lreactbuild_analyze_cost_modules_Dashboard$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_Dashboard$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Dashboard$;
var $n_Lreactbuild_analyze_cost_modules_Dashboard$;
function $m_Lreactbuild_analyze_cost_modules_Dashboard$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_Dashboard$)) {
    $n_Lreactbuild_analyze_cost_modules_Dashboard$ = new $c_Lreactbuild_analyze_cost_modules_Dashboard$()
  };
  return $n_Lreactbuild_analyze_cost_modules_Dashboard$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_DocumentList$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_DocumentList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_DocumentList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_DocumentList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_DocumentList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_DocumentList$.prototype = $c_Lreactbuild_analyze_cost_modules_DocumentList$.prototype;
$c_Lreactbuild_analyze_cost_modules_DocumentList$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomElement = (function() {
  var this$740 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f$5 = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var $$x185 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
    var $$x181 = new $c_sjsr_AnonFunction0((() => {
      var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x184 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
      var $$x183 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listAllInvoices"];
      var $$x182 = $as_sci_Seq($n($$x183).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$6 = $n($m_s_Predef$().s_Predef$__f_Map);
      var elems = $m_sci_Nil$();
      return $n($n($$x184).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x182, this$6.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2 = $as_Lio_circe_Json(x$2$2);
        var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$9 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lreactbuild_model_InvoicePageGroup$().Lreactbuild_model_InvoicePageGroup$__f_codecForInvoicePageGroup;
        var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
        return $as_sci_List(this$9.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var $$x2 = new $c_sjsr_AnonFunction1(((invoicePageGroups$2) => {
      var invoicePageGroups = $as_Ldiode_data_Pot(invoicePageGroups$2);
      var $$x180 = $m_Lcom_iz2use_react_components_Multiview$();
      var $$x179 = new $c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler();
      var this$11 = $m_s_Symbol$();
      var $$x177 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "organization"));
      var this$12 = $m_s_Symbol$();
      var $$x176 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "supplier"));
      var this$13 = $m_s_Symbol$();
      var $$x175 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "date"));
      var this$14 = $m_s_Symbol$();
      var $$x174 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "entryNumber"));
      var this$15 = $m_s_Symbol$();
      var $$x173 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "reference"));
      var this$16 = $m_s_Symbol$();
      var $$x172 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "pages"));
      var this$17 = $m_s_Symbol$();
      var $$x171 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "totalAmount"));
      var this$18 = $m_s_Symbol$();
      var $$x170 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "expectedAmount"));
      var this$19 = $m_s_Symbol$();
      var $$x169 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "received"));
      var this$20 = $m_s_Symbol$();
      var labels = new $c_Lshapeless_$colon$colon($$x177, new $c_Lshapeless_$colon$colon($$x176, new $c_Lshapeless_$colon$colon($$x175, new $c_Lshapeless_$colon$colon($$x174, new $c_Lshapeless_$colon$colon($$x173, new $c_Lshapeless_$colon$colon($$x172, new $c_Lshapeless_$colon$colon($$x171, new $c_Lshapeless_$colon$colon($$x170, new $c_Lshapeless_$colon$colon($$x169, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "category")), $m_Lshapeless_HNil$()))))))))));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
      var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
        var x0$3 = $as_Lreactbuild_model_InvoicePageGroup(x0$3$2);
        if ((x0$3 !== null)) {
          var organization$macro$31 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_organization;
          var supplier$macro$32 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_supplier;
          var date$macro$33 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_date;
          var entryNumber$macro$34 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
          var reference$macro$35 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_reference;
          var pages$macro$36 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_pages;
          var totalAmount$macro$37 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
          var expectedAmount$macro$38 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
          var received$macro$39 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_received;
          var category$macro$40 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_category;
          return new $c_Lshapeless_$colon$colon(organization$macro$31, new $c_Lshapeless_$colon$colon(supplier$macro$32, new $c_Lshapeless_$colon$colon(date$macro$33, new $c_Lshapeless_$colon$colon(entryNumber$macro$34, new $c_Lshapeless_$colon$colon(reference$macro$35, new $c_Lshapeless_$colon$colon(pages$macro$36, new $c_Lshapeless_$colon$colon(totalAmount$macro$37, new $c_Lshapeless_$colon$colon(expectedAmount$macro$38, new $c_Lshapeless_$colon$colon(received$macro$39, new $c_Lshapeless_$colon$colon(category$macro$40, $m_Lshapeless_HNil$()))))))))))
        } else {
          throw new $c_s_MatchError(x0$3)
        }
      }));
      var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
        var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
        if ((x0$4 !== null)) {
          var organization$macro$21 = $as_Lreactbuild_common_model_RefTo($n(x0$4).Lshapeless_$colon$colon__f_head);
          var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
          if ((p2 !== null)) {
            var supplier$macro$22 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
            var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
            if ((p3 !== null)) {
              var date$macro$23 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
              var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
              if ((p4 !== null)) {
                var entryNumber$macro$24 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
                var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
                if ((p5 !== null)) {
                  var reference$macro$25 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                  var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                  if ((p6 !== null)) {
                    var pages$macro$26 = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
                    var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                    if ((p7 !== null)) {
                      var totalAmount$macro$27 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                      var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                      if ((p8 !== null)) {
                        var expectedAmount$macro$28 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                        var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                        if ((p9 !== null)) {
                          var received$macro$29 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                          var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                          if ((p10 !== null)) {
                            var category$macro$30 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                            var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                            var x = $m_Lshapeless_HNil$();
                            if ((x === p11)) {
                              return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$21, supplier$macro$22, date$macro$23, entryNumber$macro$24, reference$macro$25, pages$macro$26, totalAmount$macro$27, expectedAmount$macro$28, received$macro$29, category$macro$30)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
        throw new $c_s_MatchError(x0$4)
      }));
      var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$23 = $m_s_Symbol$();
      var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "category"));
      new $c_Lshapeless_Witness$$anon$1(value0);
      var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
      $m_Lshapeless_Witness$();
      var this$26 = $m_s_Symbol$();
      var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "received"));
      new $c_Lshapeless_Witness$$anon$1(value0$1);
      var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
      $m_Lshapeless_Witness$();
      var this$29 = $m_s_Symbol$();
      var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "expectedAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$2);
      var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
      $m_Lshapeless_Witness$();
      var this$32 = $m_s_Symbol$();
      var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "totalAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$3);
      var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
      $m_Lshapeless_Witness$();
      var this$35 = $m_s_Symbol$();
      var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "pages"));
      new $c_Lshapeless_Witness$$anon$1(value0$4);
      var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
      $m_Lshapeless_Witness$();
      var this$38 = $m_s_Symbol$();
      var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "reference"));
      new $c_Lshapeless_Witness$$anon$1(value0$5);
      var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
      $m_Lshapeless_Witness$();
      var this$41 = $m_s_Symbol$();
      var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "entryNumber"));
      new $c_Lshapeless_Witness$$anon$1(value0$6);
      var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
      $m_Lshapeless_Witness$();
      var this$44 = $m_s_Symbol$();
      var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "date"));
      new $c_Lshapeless_Witness$$anon$1(value0$7);
      var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
      $m_Lshapeless_Witness$();
      var this$47 = $m_s_Symbol$();
      var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "supplier"));
      new $c_Lshapeless_Witness$$anon$1(value0$8);
      var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
      $m_Lshapeless_Witness$();
      var this$50 = $m_s_Symbol$();
      var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "organization"));
      new $c_Lshapeless_Witness$$anon$1(value0$9);
      var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
      var this$53 = $m_s_$less$colon$less$();
      var ev = this$53.s_$less$colon$less$__f_singleton;
      var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
      $m_Lshapeless_Witness$();
      var this$55 = $m_s_Symbol$();
      var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "category"));
      var wk = new $c_Lshapeless_Witness$$anon$1(value0$10);
      var tailToMap = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk);
      var keyLub = new $c_Lshapeless_Lub$$anon$4();
      var valueLub = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$60 = $m_s_Symbol$();
      var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "received"));
      var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
      var tailToMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap, keyLub, valueLub, wk$1);
      var keyLub$1 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$1 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$65 = $m_s_Symbol$();
      var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "expectedAmount"));
      var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$12);
      var tailToMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$2);
      var keyLub$2 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$2 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$70 = $m_s_Symbol$();
      var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$70, "totalAmount"));
      var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$13);
      var tailToMap$3 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$2, keyLub$2, valueLub$2, wk$3);
      var keyLub$3 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$3 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$75 = $m_s_Symbol$();
      var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$75, "pages"));
      var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$14);
      var tailToMap$4 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$3, keyLub$3, valueLub$3, wk$4);
      var keyLub$4 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$4 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$80 = $m_s_Symbol$();
      var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "reference"));
      var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$15);
      var tailToMap$5 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$4, keyLub$4, valueLub$4, wk$5);
      var keyLub$5 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$5 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$85 = $m_s_Symbol$();
      var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "entryNumber"));
      var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$16);
      var tailToMap$6 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$5, keyLub$5, valueLub$5, wk$6);
      var keyLub$6 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$6 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$90 = $m_s_Symbol$();
      var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "date"));
      var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$17);
      var tailToMap$7 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$6, keyLub$6, valueLub$6, wk$7);
      var keyLub$7 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$7 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$95 = $m_s_Symbol$();
      var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$95, "supplier"));
      var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$18);
      var tailToMap$8 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$7, keyLub$7, valueLub$7, wk$8);
      var keyLub$8 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$8 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$100 = $m_s_Symbol$();
      var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$100, "organization"));
      var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$19);
      var toMap = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$8, keyLub$8, valueLub$8, wk$9);
      $m_Lshapeless_Witness$();
      var this$103 = $m_s_Symbol$();
      var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$103, "organization"));
      var wk$19 = new $c_Lshapeless_Witness$$anon$1(value0$20);
      var tv$9 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
      $m_Lshapeless_Witness$();
      var this$105 = $m_s_Symbol$();
      var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$105, "supplier"));
      var wk$18 = new $c_Lshapeless_Witness$$anon$1(value0$21);
      var tv$8 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
      $m_Lshapeless_Witness$();
      var this$107 = $m_s_Symbol$();
      var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$107, "date"));
      var wk$17 = new $c_Lshapeless_Witness$$anon$1(value0$22);
      var tv$7 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_Date.getClassOf(), new $c_sjsr_AnonFunction0((() => "Date"))));
      $m_Lshapeless_Witness$();
      var this$109 = $m_s_Symbol$();
      var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$109, "entryNumber"));
      var wk$16 = new $c_Lshapeless_Witness$$anon$1(value0$23);
      var tv$6 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_intTypeable);
      $m_Lshapeless_Witness$();
      var this$111 = $m_s_Symbol$();
      var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$111, "reference"));
      var wk$15 = new $c_Lshapeless_Witness$$anon$1(value0$24);
      var tv$5 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
      $m_Lshapeless_Witness$();
      var this$113 = $m_s_Symbol$();
      var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$113, "pages"));
      var wk$14 = new $c_Lshapeless_Witness$$anon$1(value0$25);
      var tv$4 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_InvoicePage.getClassOf(), new $c_sjsr_AnonFunction0((() => "InvoicePage"))));
      $m_Lshapeless_Witness$();
      var this$116 = $m_s_Symbol$();
      var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$116, "totalAmount"));
      var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$26);
      var tv$3 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
      $m_Lshapeless_Witness$();
      var this$118 = $m_s_Symbol$();
      var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$118, "expectedAmount"));
      var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$27);
      var tv$2 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
      $m_Lshapeless_Witness$();
      var this$120 = $m_s_Symbol$();
      var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$120, "received"));
      var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$28);
      var tv$1 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_Instant.getClassOf(), new $c_sjsr_AnonFunction0((() => "Instant"))));
      $m_Lshapeless_Witness$();
      var this$122 = $m_s_Symbol$();
      var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$122, "category"));
      var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$29);
      var tv = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_DocumentCategory.getClassOf(), new $c_sjsr_AnonFunction0((() => "DocumentCategory"))));
      var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
      var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$10, tv, fmt);
      var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$11, tv$1, fmt$1);
      var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$12, tv$2, fmt$2);
      var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$13, tv$3, fmt$3);
      var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$14, tv$4, fmt$4);
      var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$15, tv$5, fmt$5);
      var fmt$7 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$16, tv$6, fmt$6);
      var fmt$8 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$17, tv$7, fmt$7);
      var fmt$9 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$18, tv$8, fmt$8);
      var fromMap = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$19, tv$9, fmt$9);
      var $$x178 = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap, gen$1, fromMap);
      $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$();
      var this$466 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$465 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$464 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$463 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$136 = $m_s_Symbol$();
      var $$x81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$136, "organization"));
      var this$137 = $m_s_Symbol$();
      var $$x80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$137, "supplier"));
      var this$138 = $m_s_Symbol$();
      var $$x79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$138, "date"));
      var this$139 = $m_s_Symbol$();
      var $$x78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$139, "entryNumber"));
      var this$140 = $m_s_Symbol$();
      var $$x77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$140, "reference"));
      var this$141 = $m_s_Symbol$();
      var $$x76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$141, "pages"));
      var this$142 = $m_s_Symbol$();
      var $$x75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$142, "totalAmount"));
      var this$143 = $m_s_Symbol$();
      var $$x74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$143, "expectedAmount"));
      var this$144 = $m_s_Symbol$();
      var $$x73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$144, "received"));
      var this$145 = $m_s_Symbol$();
      var labels$1 = new $c_Lshapeless_$colon$colon($$x81, new $c_Lshapeless_$colon$colon($$x80, new $c_Lshapeless_$colon$colon($$x79, new $c_Lshapeless_$colon$colon($$x78, new $c_Lshapeless_$colon$colon($$x77, new $c_Lshapeless_$colon$colon($$x76, new $c_Lshapeless_$colon$colon($$x75, new $c_Lshapeless_$colon$colon($$x74, new $c_Lshapeless_$colon$colon($$x73, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$145, "category")), $m_Lshapeless_HNil$()))))))))));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
      var f$1 = new $c_sjsr_AnonFunction1(((x0$7$2) => {
        var x0$7 = $as_Lreactbuild_model_InvoicePageGroup(x0$7$2);
        if ((x0$7 !== null)) {
          var organization$macro$71 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_organization;
          var supplier$macro$72 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_supplier;
          var date$macro$73 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_date;
          var entryNumber$macro$74 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
          var reference$macro$75 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_reference;
          var pages$macro$76 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_pages;
          var totalAmount$macro$77 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
          var expectedAmount$macro$78 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
          var received$macro$79 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_received;
          var category$macro$80 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_category;
          return new $c_Lshapeless_$colon$colon(organization$macro$71, new $c_Lshapeless_$colon$colon(supplier$macro$72, new $c_Lshapeless_$colon$colon(date$macro$73, new $c_Lshapeless_$colon$colon(entryNumber$macro$74, new $c_Lshapeless_$colon$colon(reference$macro$75, new $c_Lshapeless_$colon$colon(pages$macro$76, new $c_Lshapeless_$colon$colon(totalAmount$macro$77, new $c_Lshapeless_$colon$colon(expectedAmount$macro$78, new $c_Lshapeless_$colon$colon(received$macro$79, new $c_Lshapeless_$colon$colon(category$macro$80, $m_Lshapeless_HNil$()))))))))))
        } else {
          throw new $c_s_MatchError(x0$7)
        }
      }));
      var g$1 = new $c_sjsr_AnonFunction1(((x0$8$2) => {
        var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
        if ((x0$8 !== null)) {
          var organization$macro$61 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
          var p2$1 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
          if ((p2$1 !== null)) {
            var supplier$macro$62 = $as_s_Option($n(p2$1).Lshapeless_$colon$colon__f_head);
            var p3$1 = $as_Lshapeless_$colon$colon($n(p2$1).Lshapeless_$colon$colon__f_tail);
            if ((p3$1 !== null)) {
              var date$macro$63 = $as_s_Option($n(p3$1).Lshapeless_$colon$colon__f_head);
              var p4$1 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
              if ((p4$1 !== null)) {
                var entryNumber$macro$64 = $as_s_Option($n(p4$1).Lshapeless_$colon$colon__f_head);
                var p5$1 = $as_Lshapeless_$colon$colon($n(p4$1).Lshapeless_$colon$colon__f_tail);
                if ((p5$1 !== null)) {
                  var reference$macro$65 = $as_s_Option($n(p5$1).Lshapeless_$colon$colon__f_head);
                  var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
                  if ((p6$1 !== null)) {
                    var pages$macro$66 = $as_sci_Seq($n(p6$1).Lshapeless_$colon$colon__f_head);
                    var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                    if ((p7$1 !== null)) {
                      var totalAmount$macro$67 = $as_s_Option($n(p7$1).Lshapeless_$colon$colon__f_head);
                      var p8$1 = $as_Lshapeless_$colon$colon($n(p7$1).Lshapeless_$colon$colon__f_tail);
                      if ((p8$1 !== null)) {
                        var expectedAmount$macro$68 = $as_s_Option($n(p8$1).Lshapeless_$colon$colon__f_head);
                        var p9$1 = $as_Lshapeless_$colon$colon($n(p8$1).Lshapeless_$colon$colon__f_tail);
                        if ((p9$1 !== null)) {
                          var received$macro$69 = $as_s_Option($n(p9$1).Lshapeless_$colon$colon__f_head);
                          var p10$1 = $as_Lshapeless_$colon$colon($n(p9$1).Lshapeless_$colon$colon__f_tail);
                          if ((p10$1 !== null)) {
                            var category$macro$70 = $as_s_Option($n(p10$1).Lshapeless_$colon$colon__f_head);
                            var p11$1 = $as_Lshapeless_HNil($n(p10$1).Lshapeless_$colon$colon__f_tail);
                            var x$1 = $m_Lshapeless_HNil$();
                            if ((x$1 === p11$1)) {
                              return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$61, supplier$macro$62, date$macro$63, entryNumber$macro$64, reference$macro$65, pages$macro$66, totalAmount$macro$67, expectedAmount$macro$68, received$macro$69, category$macro$70)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
        throw new $c_s_MatchError(x0$8)
      }));
      var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$10 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$148 = $m_s_Symbol$();
      var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$148, "category"));
      new $c_Lshapeless_Witness$$anon$1(value0$30);
      var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
      $m_Lshapeless_Witness$();
      var this$151 = $m_s_Symbol$();
      var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$151, "received"));
      new $c_Lshapeless_Witness$$anon$1(value0$31);
      var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
      $m_Lshapeless_Witness$();
      var this$154 = $m_s_Symbol$();
      var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$154, "expectedAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$32);
      var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
      $m_Lshapeless_Witness$();
      var this$157 = $m_s_Symbol$();
      var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$157, "totalAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$33);
      var zipWithKeys$14 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
      $m_Lshapeless_Witness$();
      var this$160 = $m_s_Symbol$();
      var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$160, "pages"));
      new $c_Lshapeless_Witness$$anon$1(value0$34);
      var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
      $m_Lshapeless_Witness$();
      var this$163 = $m_s_Symbol$();
      var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$163, "reference"));
      new $c_Lshapeless_Witness$$anon$1(value0$35);
      var zipWithKeys$16 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
      $m_Lshapeless_Witness$();
      var this$166 = $m_s_Symbol$();
      var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$166, "entryNumber"));
      new $c_Lshapeless_Witness$$anon$1(value0$36);
      var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
      $m_Lshapeless_Witness$();
      var this$169 = $m_s_Symbol$();
      var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$169, "date"));
      new $c_Lshapeless_Witness$$anon$1(value0$37);
      var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
      $m_Lshapeless_Witness$();
      var this$172 = $m_s_Symbol$();
      var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$172, "supplier"));
      new $c_Lshapeless_Witness$$anon$1(value0$38);
      var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
      $m_Lshapeless_Witness$();
      var this$175 = $m_s_Symbol$();
      var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$175, "organization"));
      new $c_Lshapeless_Witness$$anon$1(value0$39);
      var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
      var this$178 = $m_s_$less$colon$less$();
      var ev$1 = this$178.s_$less$colon$less$__f_singleton;
      new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$1);
      var this$295 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      $m_Lshapeless_Witness$();
      var this$180 = $m_s_Symbol$();
      var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$180, "organization"));
      var witness$8 = new $c_Lshapeless_Witness$$anon$1(value0$40);
      var $$x85 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      var this$182 = $m_Lreactbuild_model_Implicits$();
      var format = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$182);
      var $$x84 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format);
      var this$186 = $m_Lreactbuild_model_Implicits$();
      var this$185 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$185, proxy);
      var $$x83 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$186, ev$2)));
      var $$x82 = new $c_Lcom_iz2use_react_components_NotEditable();
      var this$189 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$189, proxy$1);
      var fieldRenderable$8 = $n($$x85).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x84, $$x83, $$x82, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
      var this$294 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      $m_Lshapeless_Witness$();
      var this$191 = $m_s_Symbol$();
      var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$191, "supplier"));
      var witness$7 = new $c_Lshapeless_Witness$$anon$1(value0$41);
      var $$x89 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var this$193 = $m_Lreactbuild_model_Implicits$();
      var format$1 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$193);
      var format$2 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$1);
      var $$x88 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$2);
      var this$198 = $m_Lreactbuild_model_Implicits$();
      var this$197 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$3 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$197, proxy$2);
      var ord = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$198, ev$3);
      var $$x87 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord)));
      var $$x86 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$202 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$3 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var textualizable$1 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$202, proxy$3);
      var textualizable$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1);
      var fieldRenderable$7 = $n($$x89).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x88, $$x87, $$x86, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$2), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
      var this$293 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      $m_Lshapeless_Witness$();
      var this$205 = $m_s_Symbol$();
      var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$205, "date"));
      var witness$6 = new $c_Lshapeless_Witness$$anon$1(value0$42);
      var $$x93 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
      var format$4 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$3);
      var $$x92 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$4);
      var ord$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
      var $$x91 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$1)));
      var $$x90 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var textualizable$4 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$3);
      var fieldRenderable$6 = $n($$x93).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x92, $$x91, $$x90, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$4), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
      var this$292 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      $m_Lshapeless_Witness$();
      var this$213 = $m_s_Symbol$();
      var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$213, "entryNumber"));
      var witness$5 = new $c_Lshapeless_Witness$$anon$1(value0$43);
      var $$x98 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$5 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
      var format$6 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$5);
      var $$x97 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$6);
      var ord$2 = $m_s_math_Ordering$Int$();
      var $$x96 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$2)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$4);
      var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var resolver = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
      var $$x95 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner, resolver);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var textualizable$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
      var $$x94 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$5);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var fieldRenderable$5 = $n($$x98).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x97, $$x96, $$x95, $$x94, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$5))));
      var this$291 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      $m_Lshapeless_Witness$();
      var this$226 = $m_s_Symbol$();
      var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$226, "reference"));
      var witness$4 = new $c_Lshapeless_Witness$$anon$1(value0$44);
      var $$x103 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$7 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
      var format$8 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$7);
      var $$x102 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$8);
      var ord$3 = $m_s_math_Ordering$String$();
      var $$x101 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$3)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$6);
      var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$7);
      var resolver$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
      var $$x100 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$1, resolver$1);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var textualizable$6 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$3);
      var $$x99 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$6);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var fieldRenderable$4 = $n($$x103).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x102, $$x101, $$x100, $$x99, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$8))));
      var this$290 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.InvoicePageGroup", "Seq[reactbuild.model.InvoicePage]");
      var this$289 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      $m_Lshapeless_Witness$();
      var this$241 = $m_s_Symbol$();
      var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$241, "totalAmount"));
      var witness$3 = new $c_Lshapeless_Witness$$anon$1(value0$45);
      var $$x108 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$10 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$9);
      var $$x107 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$10);
      var ord$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x106 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$4)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$9);
      var optioner$2 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
      var $$x105 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$2, resolver$2);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$8 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$7);
      var $$x104 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$8);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$10 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var fieldRenderable$3 = $n($$x108).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x107, $$x106, $$x105, $$x104, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$10))));
      var this$288 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      $m_Lshapeless_Witness$();
      var this$253 = $m_s_Symbol$();
      var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$253, "expectedAmount"));
      var witness$2 = new $c_Lshapeless_Witness$$anon$1(value0$46);
      var $$x113 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$12 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$11);
      var $$x112 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$12);
      var ord$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x111 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$5)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$11);
      var optioner$3 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
      var $$x110 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$3, resolver$3);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$10 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$9);
      var $$x109 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$10);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var fieldRenderable$2 = $n($$x113).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x112, $$x111, $$x110, $$x109, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$12))));
      var this$287 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      $m_Lshapeless_Witness$();
      var this$265 = $m_s_Symbol$();
      var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$265, "received"));
      var witness$1 = new $c_Lshapeless_Witness$$anon$1(value0$47);
      var $$x117 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$13 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
      var format$14 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$13);
      var $$x116 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$14);
      var ord$6 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
      var $$x115 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$6)));
      var $$x114 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$271 = $m_Lreactbuild_model_Implicits$();
      var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
      var textualizable$11 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$271, locale);
      var textualizable$12 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$11);
      var fieldRenderable$1 = $n($$x117).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x116, $$x115, $$x114, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$12), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
      var this$286 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
      $m_Lshapeless_Witness$();
      var this$274 = $m_s_Symbol$();
      var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$274, "category"));
      var witness = new $c_Lshapeless_Witness$$anon$1(value0$48);
      var $$x122 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$15 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
      var format$16 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$15);
      var $$x121 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$16);
      var ord$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
      var $$x120 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$7)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$13);
      var optioner$4 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var resolver$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
      var $$x119 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$4, resolver$4);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      var textualizable$14 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$13);
      var $$x118 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$14);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$14 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      var fieldRenderable = $n($$x122).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x121, $$x120, $$x119, $$x118, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$14))));
      var tail = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4();
      var tail$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$286, fieldRenderable, witness, tail);
      var tail$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$287, fieldRenderable$1, witness$1, tail$1);
      var tail$3 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$288, fieldRenderable$2, witness$2, tail$2);
      var tail$4 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$289, fieldRenderable$3, witness$3, tail$3);
      var tail$5 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$290, tail$4);
      var tail$6 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$291, fieldRenderable$4, witness$4, tail$5);
      var tail$7 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$292, fieldRenderable$5, witness$5, tail$6);
      var tail$8 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$293, fieldRenderable$6, witness$6, tail$7);
      var tail$9 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$294, fieldRenderable$7, witness$7, tail$8);
      var renderer = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$295, fieldRenderable$8, witness$8, tail$9);
      $m_s_DummyImplicit$();
      new $c_Lshapeless_Refute$$anon$2();
      var view$2 = new $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1(renderer);
      var this$461 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      $m_Lreactbuild_model_Implicits$();
      var renderItem = new $c_Lreactbuild_model_Implicits$$anon$29(pageProps);
      var view$1 = new $c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1(renderItem);
      var this$300 = $m_s_Symbol$();
      var $$x131 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$300, "organization"));
      var this$301 = $m_s_Symbol$();
      var $$x130 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$301, "supplier"));
      var this$302 = $m_s_Symbol$();
      var $$x129 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$302, "date"));
      var this$303 = $m_s_Symbol$();
      var $$x128 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$303, "entryNumber"));
      var this$304 = $m_s_Symbol$();
      var $$x127 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$304, "reference"));
      var this$305 = $m_s_Symbol$();
      var $$x126 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$305, "pages"));
      var this$306 = $m_s_Symbol$();
      var $$x125 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$306, "totalAmount"));
      var this$307 = $m_s_Symbol$();
      var $$x124 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$307, "expectedAmount"));
      var this$308 = $m_s_Symbol$();
      var $$x123 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$308, "received"));
      var this$309 = $m_s_Symbol$();
      var labels$2 = new $c_Lshapeless_$colon$colon($$x131, new $c_Lshapeless_$colon$colon($$x130, new $c_Lshapeless_$colon$colon($$x129, new $c_Lshapeless_$colon$colon($$x128, new $c_Lshapeless_$colon$colon($$x127, new $c_Lshapeless_$colon$colon($$x126, new $c_Lshapeless_$colon$colon($$x125, new $c_Lshapeless_$colon$colon($$x124, new $c_Lshapeless_$colon$colon($$x123, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$309, "category")), $m_Lshapeless_HNil$()))))))))));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
      var f$2 = new $c_sjsr_AnonFunction1(((x0$11$2) => {
        var x0$11 = $as_Lreactbuild_model_InvoicePageGroup(x0$11$2);
        if ((x0$11 !== null)) {
          var organization$macro$111 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_organization;
          var supplier$macro$112 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_supplier;
          var date$macro$113 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_date;
          var entryNumber$macro$114 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
          var reference$macro$115 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_reference;
          var pages$macro$116 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_pages;
          var totalAmount$macro$117 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
          var expectedAmount$macro$118 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
          var received$macro$119 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_received;
          var category$macro$120 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_category;
          return new $c_Lshapeless_$colon$colon(organization$macro$111, new $c_Lshapeless_$colon$colon(supplier$macro$112, new $c_Lshapeless_$colon$colon(date$macro$113, new $c_Lshapeless_$colon$colon(entryNumber$macro$114, new $c_Lshapeless_$colon$colon(reference$macro$115, new $c_Lshapeless_$colon$colon(pages$macro$116, new $c_Lshapeless_$colon$colon(totalAmount$macro$117, new $c_Lshapeless_$colon$colon(expectedAmount$macro$118, new $c_Lshapeless_$colon$colon(received$macro$119, new $c_Lshapeless_$colon$colon(category$macro$120, $m_Lshapeless_HNil$()))))))))))
        } else {
          throw new $c_s_MatchError(x0$11)
        }
      }));
      var g$2 = new $c_sjsr_AnonFunction1(((x0$12$2) => {
        var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
        if ((x0$12 !== null)) {
          var organization$macro$101 = $as_Lreactbuild_common_model_RefTo($n(x0$12).Lshapeless_$colon$colon__f_head);
          var p2$2 = $as_Lshapeless_$colon$colon($n(x0$12).Lshapeless_$colon$colon__f_tail);
          if ((p2$2 !== null)) {
            var supplier$macro$102 = $as_s_Option($n(p2$2).Lshapeless_$colon$colon__f_head);
            var p3$2 = $as_Lshapeless_$colon$colon($n(p2$2).Lshapeless_$colon$colon__f_tail);
            if ((p3$2 !== null)) {
              var date$macro$103 = $as_s_Option($n(p3$2).Lshapeless_$colon$colon__f_head);
              var p4$2 = $as_Lshapeless_$colon$colon($n(p3$2).Lshapeless_$colon$colon__f_tail);
              if ((p4$2 !== null)) {
                var entryNumber$macro$104 = $as_s_Option($n(p4$2).Lshapeless_$colon$colon__f_head);
                var p5$2 = $as_Lshapeless_$colon$colon($n(p4$2).Lshapeless_$colon$colon__f_tail);
                if ((p5$2 !== null)) {
                  var reference$macro$105 = $as_s_Option($n(p5$2).Lshapeless_$colon$colon__f_head);
                  var p6$2 = $as_Lshapeless_$colon$colon($n(p5$2).Lshapeless_$colon$colon__f_tail);
                  if ((p6$2 !== null)) {
                    var pages$macro$106 = $as_sci_Seq($n(p6$2).Lshapeless_$colon$colon__f_head);
                    var p7$2 = $as_Lshapeless_$colon$colon($n(p6$2).Lshapeless_$colon$colon__f_tail);
                    if ((p7$2 !== null)) {
                      var totalAmount$macro$107 = $as_s_Option($n(p7$2).Lshapeless_$colon$colon__f_head);
                      var p8$2 = $as_Lshapeless_$colon$colon($n(p7$2).Lshapeless_$colon$colon__f_tail);
                      if ((p8$2 !== null)) {
                        var expectedAmount$macro$108 = $as_s_Option($n(p8$2).Lshapeless_$colon$colon__f_head);
                        var p9$2 = $as_Lshapeless_$colon$colon($n(p8$2).Lshapeless_$colon$colon__f_tail);
                        if ((p9$2 !== null)) {
                          var received$macro$109 = $as_s_Option($n(p9$2).Lshapeless_$colon$colon__f_head);
                          var p10$2 = $as_Lshapeless_$colon$colon($n(p9$2).Lshapeless_$colon$colon__f_tail);
                          if ((p10$2 !== null)) {
                            var category$macro$110 = $as_s_Option($n(p10$2).Lshapeless_$colon$colon__f_head);
                            var p11$2 = $as_Lshapeless_HNil($n(p10$2).Lshapeless_$colon$colon__f_tail);
                            var x$3 = $m_Lshapeless_HNil$();
                            if ((x$3 === p11$2)) {
                              return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$101, supplier$macro$102, date$macro$103, entryNumber$macro$104, reference$macro$105, pages$macro$106, totalAmount$macro$107, expectedAmount$macro$108, received$macro$109, category$macro$110)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
        throw new $c_s_MatchError(x0$12)
      }));
      var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$20 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$312 = $m_s_Symbol$();
      var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$312, "category"));
      new $c_Lshapeless_Witness$$anon$1(value0$49);
      var zipWithKeys$21 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
      $m_Lshapeless_Witness$();
      var this$315 = $m_s_Symbol$();
      var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$315, "received"));
      new $c_Lshapeless_Witness$$anon$1(value0$50);
      var zipWithKeys$22 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
      $m_Lshapeless_Witness$();
      var this$318 = $m_s_Symbol$();
      var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$318, "expectedAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$51);
      var zipWithKeys$23 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
      $m_Lshapeless_Witness$();
      var this$321 = $m_s_Symbol$();
      var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$321, "totalAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$52);
      var zipWithKeys$24 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$23);
      $m_Lshapeless_Witness$();
      var this$324 = $m_s_Symbol$();
      var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$324, "pages"));
      new $c_Lshapeless_Witness$$anon$1(value0$53);
      var zipWithKeys$25 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$24);
      $m_Lshapeless_Witness$();
      var this$327 = $m_s_Symbol$();
      var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$327, "reference"));
      new $c_Lshapeless_Witness$$anon$1(value0$54);
      var zipWithKeys$26 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$25);
      $m_Lshapeless_Witness$();
      var this$330 = $m_s_Symbol$();
      var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$330, "entryNumber"));
      new $c_Lshapeless_Witness$$anon$1(value0$55);
      var zipWithKeys$27 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$26);
      $m_Lshapeless_Witness$();
      var this$333 = $m_s_Symbol$();
      var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$333, "date"));
      new $c_Lshapeless_Witness$$anon$1(value0$56);
      var zipWithKeys$28 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$27);
      $m_Lshapeless_Witness$();
      var this$336 = $m_s_Symbol$();
      var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$336, "supplier"));
      new $c_Lshapeless_Witness$$anon$1(value0$57);
      var zipWithKeys$29 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$28);
      $m_Lshapeless_Witness$();
      var this$339 = $m_s_Symbol$();
      var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$339, "organization"));
      new $c_Lshapeless_Witness$$anon$1(value0$58);
      var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$29);
      var this$342 = $m_s_$less$colon$less$();
      var ev$15 = this$342.s_$less$colon$less$__f_singleton;
      new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$15);
      var this$454 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$344 = $m_s_Symbol$();
      var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$344, "organization"));
      var witness$17 = new $c_Lshapeless_Witness$$anon$1(value0$59);
      var $$x135 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      var this$346 = $m_Lreactbuild_model_Implicits$();
      var format$17 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$346);
      var $$x134 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$17);
      var this$350 = $m_Lreactbuild_model_Implicits$();
      var this$349 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$4 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$16 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$349, proxy$4);
      var $$x133 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$350, ev$16)));
      var $$x132 = new $c_Lcom_iz2use_react_components_NotEditable();
      var this$353 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$5 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var textualizable$15 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$353, proxy$5);
      var columnRenderable$8 = $n($$x135).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x134, $$x133, $$x132, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$15));
      var this$453 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$355 = $m_s_Symbol$();
      var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$355, "supplier"));
      var witness$16 = new $c_Lshapeless_Witness$$anon$1(value0$60);
      var $$x139 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var this$357 = $m_Lreactbuild_model_Implicits$();
      var format$18 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$357);
      var format$19 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$18);
      var $$x138 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$19);
      var this$362 = $m_Lreactbuild_model_Implicits$();
      var this$361 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$6 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$17 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$361, proxy$6);
      var ord$8 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$362, ev$17);
      var $$x137 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$8)));
      var $$x136 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$366 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$7 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var textualizable$16 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$366, proxy$7);
      var textualizable$17 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$16);
      var columnRenderable$7 = $n($$x139).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x138, $$x137, $$x136, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$17));
      var this$452 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$369 = $m_s_Symbol$();
      var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$369, "date"));
      var witness$15 = new $c_Lshapeless_Witness$$anon$1(value0$61);
      var $$x143 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$20 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
      var format$21 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$20);
      var $$x142 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$21);
      var ord$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
      var $$x141 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$9)));
      var $$x140 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$18 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var textualizable$19 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$18);
      var columnRenderable$6 = $n($$x143).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x142, $$x141, $$x140, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$19));
      var this$451 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$377 = $m_s_Symbol$();
      var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$377, "entryNumber"));
      var witness$14 = new $c_Lshapeless_Witness$$anon$1(value0$62);
      var $$x147 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$22 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
      var format$23 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$22);
      var $$x146 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$23);
      var ord$10 = $m_s_math_Ordering$Int$();
      var $$x145 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$10)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$18 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$18);
      var optioner$5 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var resolver$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
      var $$x144 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$5, resolver$5);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var textualizable$20 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$8);
      var columnRenderable$5 = $n($$x147).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x146, $$x145, $$x144, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$20));
      var this$450 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$389 = $m_s_Symbol$();
      var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$389, "reference"));
      var witness$13 = new $c_Lshapeless_Witness$$anon$1(value0$63);
      var $$x151 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$24 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
      var format$25 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$24);
      var $$x150 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$25);
      var ord$11 = $m_s_math_Ordering$String$();
      var $$x149 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$11)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$19 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$19);
      var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$6 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$20 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$5 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$20);
      var resolver$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
      var $$x148 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$6, resolver$6);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var textualizable$21 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$10);
      var columnRenderable$4 = $n($$x151).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x150, $$x149, $$x148, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$21));
      var this$449 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.InvoicePageGroup", "Seq[reactbuild.model.InvoicePage]");
      var this$448 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$403 = $m_s_Symbol$();
      var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$403, "totalAmount"));
      var witness$12 = new $c_Lshapeless_Witness$$anon$1(value0$64);
      var $$x155 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$26 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$27 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$26);
      var $$x154 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$27);
      var ord$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x153 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$12)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$21 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$21);
      var optioner$7 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
      var $$x152 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$7, resolver$7);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$22 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$23 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$22);
      var columnRenderable$3 = $n($$x155).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x154, $$x153, $$x152, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$23));
      var this$447 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$414 = $m_s_Symbol$();
      var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$414, "expectedAmount"));
      var witness$11 = new $c_Lshapeless_Witness$$anon$1(value0$65);
      var $$x159 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$28 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$29 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$28);
      var $$x158 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$29);
      var ord$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x157 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$13)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$22 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$22);
      var optioner$8 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
      var $$x156 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$8, resolver$8);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$24 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$25 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$24);
      var columnRenderable$2 = $n($$x159).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x158, $$x157, $$x156, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$25));
      var this$446 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$425 = $m_s_Symbol$();
      var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$425, "received"));
      var witness$10 = new $c_Lshapeless_Witness$$anon$1(value0$66);
      var $$x163 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$30 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
      var format$31 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$30);
      var $$x162 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$31);
      var ord$14 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
      var $$x161 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$14)));
      var $$x160 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$431 = $m_Lreactbuild_model_Implicits$();
      var locale$1 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
      var textualizable$26 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$431, locale$1);
      var textualizable$27 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$26);
      var columnRenderable$1 = $n($$x163).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x162, $$x161, $$x160, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$27));
      var this$445 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$434 = $m_s_Symbol$();
      var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$434, "category"));
      var witness$9 = new $c_Lshapeless_Witness$$anon$1(value0$67);
      var $$x167 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$32 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
      var format$33 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$32);
      var $$x166 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$33);
      var ord$15 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
      var $$x165 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$15)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$23 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$23);
      var optioner$9 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var resolver$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
      var $$x164 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$9, resolver$9);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$28 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      var textualizable$29 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$28);
      var columnRenderable = $n($$x167).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x166, $$x165, $$x164, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$29));
      var tail$10 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
      var tail$11 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$445, columnRenderable, witness$9, tail$10);
      var tail$12 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$446, columnRenderable$1, witness$10, tail$11);
      var tail$13 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$447, columnRenderable$2, witness$11, tail$12);
      var tail$14 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$448, columnRenderable$3, witness$12, tail$13);
      var tail$15 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$449, tail$14);
      var tail$16 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$450, columnRenderable$4, witness$13, tail$15);
      var tail$17 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$451, columnRenderable$5, witness$14, tail$16);
      var tail$18 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$452, columnRenderable$6, witness$15, tail$17);
      var tail$19 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$453, columnRenderable$7, witness$16, tail$18);
      var renderer$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$454, columnRenderable$8, witness$17, tail$19);
      $m_s_DummyImplicit$();
      new $c_Lshapeless_Refute$$anon$2();
      var columnFragment = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$1);
      var view = new $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment);
      var tail$20 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2();
      var tail$21 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view, tail$20);
      var tail$22 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$1, tail$21);
      var tail$23 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$461, tail$22);
      var tail$24 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$2, tail$23);
      var tail$25 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$463, tail$24);
      var tail$26 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$464, tail$25);
      var tail$27 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$465, tail$26);
      var mat = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$466, tail$27);
      $m_s_DummyImplicit$();
      new $c_Lshapeless_Refute$$anon$2();
      var $$x168 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViews(mat.apply__sci_List());
      var $$x72 = $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$().Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable;
      var this$469 = $m_s_Symbol$();
      var $$x29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$469, "organization"));
      var this$470 = $m_s_Symbol$();
      var $$x28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$470, "supplier"));
      var this$471 = $m_s_Symbol$();
      var $$x27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$471, "date"));
      var this$472 = $m_s_Symbol$();
      var $$x26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$472, "entryNumber"));
      var this$473 = $m_s_Symbol$();
      var $$x25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$473, "reference"));
      var this$474 = $m_s_Symbol$();
      var $$x24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$474, "pages"));
      var this$475 = $m_s_Symbol$();
      var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$475, "totalAmount"));
      var this$476 = $m_s_Symbol$();
      var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$476, "expectedAmount"));
      var this$477 = $m_s_Symbol$();
      var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$477, "received"));
      var this$478 = $m_s_Symbol$();
      var labels$3 = new $c_Lshapeless_$colon$colon($$x29, new $c_Lshapeless_$colon$colon($$x28, new $c_Lshapeless_$colon$colon($$x27, new $c_Lshapeless_$colon$colon($$x26, new $c_Lshapeless_$colon$colon($$x25, new $c_Lshapeless_$colon$colon($$x24, new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$478, "category")), $m_Lshapeless_HNil$()))))))))));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
      var f$3 = new $c_sjsr_AnonFunction1(((x0$15$2) => {
        var x0$15 = $as_Lreactbuild_model_InvoicePageGroup(x0$15$2);
        if ((x0$15 !== null)) {
          var organization$macro$151 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_organization;
          var supplier$macro$152 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_supplier;
          var date$macro$153 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_date;
          var entryNumber$macro$154 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
          var reference$macro$155 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_reference;
          var pages$macro$156 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_pages;
          var totalAmount$macro$157 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
          var expectedAmount$macro$158 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
          var received$macro$159 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_received;
          var category$macro$160 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_category;
          return new $c_Lshapeless_$colon$colon(organization$macro$151, new $c_Lshapeless_$colon$colon(supplier$macro$152, new $c_Lshapeless_$colon$colon(date$macro$153, new $c_Lshapeless_$colon$colon(entryNumber$macro$154, new $c_Lshapeless_$colon$colon(reference$macro$155, new $c_Lshapeless_$colon$colon(pages$macro$156, new $c_Lshapeless_$colon$colon(totalAmount$macro$157, new $c_Lshapeless_$colon$colon(expectedAmount$macro$158, new $c_Lshapeless_$colon$colon(received$macro$159, new $c_Lshapeless_$colon$colon(category$macro$160, $m_Lshapeless_HNil$()))))))))))
        } else {
          throw new $c_s_MatchError(x0$15)
        }
      }));
      var g$3 = new $c_sjsr_AnonFunction1(((x0$16$2) => {
        var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
        if ((x0$16 !== null)) {
          var organization$macro$141 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
          var p2$3 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
          if ((p2$3 !== null)) {
            var supplier$macro$142 = $as_s_Option($n(p2$3).Lshapeless_$colon$colon__f_head);
            var p3$3 = $as_Lshapeless_$colon$colon($n(p2$3).Lshapeless_$colon$colon__f_tail);
            if ((p3$3 !== null)) {
              var date$macro$143 = $as_s_Option($n(p3$3).Lshapeless_$colon$colon__f_head);
              var p4$3 = $as_Lshapeless_$colon$colon($n(p3$3).Lshapeless_$colon$colon__f_tail);
              if ((p4$3 !== null)) {
                var entryNumber$macro$144 = $as_s_Option($n(p4$3).Lshapeless_$colon$colon__f_head);
                var p5$3 = $as_Lshapeless_$colon$colon($n(p4$3).Lshapeless_$colon$colon__f_tail);
                if ((p5$3 !== null)) {
                  var reference$macro$145 = $as_s_Option($n(p5$3).Lshapeless_$colon$colon__f_head);
                  var p6$3 = $as_Lshapeless_$colon$colon($n(p5$3).Lshapeless_$colon$colon__f_tail);
                  if ((p6$3 !== null)) {
                    var pages$macro$146 = $as_sci_Seq($n(p6$3).Lshapeless_$colon$colon__f_head);
                    var p7$3 = $as_Lshapeless_$colon$colon($n(p6$3).Lshapeless_$colon$colon__f_tail);
                    if ((p7$3 !== null)) {
                      var totalAmount$macro$147 = $as_s_Option($n(p7$3).Lshapeless_$colon$colon__f_head);
                      var p8$3 = $as_Lshapeless_$colon$colon($n(p7$3).Lshapeless_$colon$colon__f_tail);
                      if ((p8$3 !== null)) {
                        var expectedAmount$macro$148 = $as_s_Option($n(p8$3).Lshapeless_$colon$colon__f_head);
                        var p9$3 = $as_Lshapeless_$colon$colon($n(p8$3).Lshapeless_$colon$colon__f_tail);
                        if ((p9$3 !== null)) {
                          var received$macro$149 = $as_s_Option($n(p9$3).Lshapeless_$colon$colon__f_head);
                          var p10$3 = $as_Lshapeless_$colon$colon($n(p9$3).Lshapeless_$colon$colon__f_tail);
                          if ((p10$3 !== null)) {
                            var category$macro$150 = $as_s_Option($n(p10$3).Lshapeless_$colon$colon__f_head);
                            var p11$3 = $as_Lshapeless_HNil($n(p10$3).Lshapeless_$colon$colon__f_tail);
                            var x$4 = $m_Lshapeless_HNil$();
                            if ((x$4 === p11$3)) {
                              return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$141, supplier$macro$142, date$macro$143, entryNumber$macro$144, reference$macro$145, pages$macro$146, totalAmount$macro$147, expectedAmount$macro$148, received$macro$149, category$macro$150)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
        throw new $c_s_MatchError(x0$16)
      }));
      var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$30 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$481 = $m_s_Symbol$();
      var value0$68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$481, "category"));
      new $c_Lshapeless_Witness$$anon$1(value0$68);
      var zipWithKeys$31 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$30);
      $m_Lshapeless_Witness$();
      var this$484 = $m_s_Symbol$();
      var value0$69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$484, "received"));
      new $c_Lshapeless_Witness$$anon$1(value0$69);
      var zipWithKeys$32 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$31);
      $m_Lshapeless_Witness$();
      var this$487 = $m_s_Symbol$();
      var value0$70 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$487, "expectedAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$70);
      var zipWithKeys$33 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$32);
      $m_Lshapeless_Witness$();
      var this$490 = $m_s_Symbol$();
      var value0$71 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$490, "totalAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$71);
      var zipWithKeys$34 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$33);
      $m_Lshapeless_Witness$();
      var this$493 = $m_s_Symbol$();
      var value0$72 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$493, "pages"));
      new $c_Lshapeless_Witness$$anon$1(value0$72);
      var zipWithKeys$35 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$34);
      $m_Lshapeless_Witness$();
      var this$496 = $m_s_Symbol$();
      var value0$73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$496, "reference"));
      new $c_Lshapeless_Witness$$anon$1(value0$73);
      var zipWithKeys$36 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$35);
      $m_Lshapeless_Witness$();
      var this$499 = $m_s_Symbol$();
      var value0$74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$499, "entryNumber"));
      new $c_Lshapeless_Witness$$anon$1(value0$74);
      var zipWithKeys$37 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$36);
      $m_Lshapeless_Witness$();
      var this$502 = $m_s_Symbol$();
      var value0$75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$502, "date"));
      new $c_Lshapeless_Witness$$anon$1(value0$75);
      var zipWithKeys$38 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$37);
      $m_Lshapeless_Witness$();
      var this$505 = $m_s_Symbol$();
      var value0$76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$505, "supplier"));
      new $c_Lshapeless_Witness$$anon$1(value0$76);
      var zipWithKeys$39 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$38);
      $m_Lshapeless_Witness$();
      var this$508 = $m_s_Symbol$();
      var value0$77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$508, "organization"));
      new $c_Lshapeless_Witness$$anon$1(value0$77);
      var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$39);
      var this$511 = $m_s_$less$colon$less$();
      var ev$24 = this$511.s_$less$colon$less$__f_singleton;
      new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$24);
      $m_Lshapeless_Witness$();
      var this$513 = $m_s_Symbol$();
      var value0$78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$513, "organization"));
      var witness$26 = new $c_Lshapeless_Witness$$anon$1(value0$78);
      var $$x33 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      var this$515 = $m_Lreactbuild_model_Implicits$();
      var format$34 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$515);
      var $$x32 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$34);
      var this$519 = $m_Lreactbuild_model_Implicits$();
      var this$518 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$8 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$25 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$518, proxy$8);
      var $$x31 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$519, ev$25)));
      var $$x30 = new $c_Lcom_iz2use_react_components_NotEditable();
      var this$522 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$9 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var textualizable$30 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$522, proxy$9);
      var fieldRenderable$17 = $n($$x33).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x32, $$x31, $$x30, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$30), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
      $m_Lshapeless_Witness$();
      var this$524 = $m_s_Symbol$();
      var value0$79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$524, "supplier"));
      var witness$25 = new $c_Lshapeless_Witness$$anon$1(value0$79);
      var $$x37 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var this$526 = $m_Lreactbuild_model_Implicits$();
      var format$35 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$526);
      var format$36 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$35);
      var $$x36 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$36);
      var this$531 = $m_Lreactbuild_model_Implicits$();
      var this$530 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$10 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$26 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$530, proxy$10);
      var ord$16 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$531, ev$26);
      var $$x35 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$16)));
      var $$x34 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$535 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$11 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var textualizable$31 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$535, proxy$11);
      var textualizable$32 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$31);
      var fieldRenderable$16 = $n($$x37).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x36, $$x35, $$x34, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$32), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
      $m_Lshapeless_Witness$();
      var this$538 = $m_s_Symbol$();
      var value0$80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$538, "date"));
      var witness$24 = new $c_Lshapeless_Witness$$anon$1(value0$80);
      var $$x41 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$37 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
      var format$38 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$37);
      var $$x40 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$38);
      var ord$17 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
      var $$x39 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$17)));
      var $$x38 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$33 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var textualizable$34 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$33);
      var fieldRenderable$15 = $n($$x41).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x40, $$x39, $$x38, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$34), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
      $m_Lshapeless_Witness$();
      var this$546 = $m_s_Symbol$();
      var value0$81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$546, "entryNumber"));
      var witness$23 = new $c_Lshapeless_Witness$$anon$1(value0$81);
      var $$x46 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$39 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
      var format$40 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$39);
      var $$x45 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$40);
      var ord$18 = $m_s_math_Ordering$Int$();
      var $$x44 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$18)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$27 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$27);
      var optioner$10 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var resolver$10 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$8);
      var $$x43 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$10, resolver$10);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var textualizable$35 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$15);
      var $$x42 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$35);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$28 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var fieldRenderable$14 = $n($$x46).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x45, $$x44, $$x43, $$x42, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$28))));
      $m_Lshapeless_Witness$();
      var this$559 = $m_s_Symbol$();
      var value0$82 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$559, "reference"));
      var witness$22 = new $c_Lshapeless_Witness$$anon$1(value0$82);
      var $$x51 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$41 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
      var format$42 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$41);
      var $$x50 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$42);
      var ord$19 = $m_s_math_Ordering$String$();
      var $$x49 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$19)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$29 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$29);
      var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$11 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$30 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$9 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$30);
      var resolver$11 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$9);
      var $$x48 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$11, resolver$11);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var textualizable$36 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$17);
      var $$x47 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$36);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$31 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var fieldRenderable$13 = $n($$x51).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x50, $$x49, $$x48, $$x47, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$31))));
      var this$623 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
      $m_Lshapeless_Witness$();
      var this$574 = $m_s_Symbol$();
      var value0$83 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$574, "totalAmount"));
      var witness$21 = new $c_Lshapeless_Witness$$anon$1(value0$83);
      var $$x56 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$43 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$44 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$43);
      var $$x55 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$44);
      var ord$20 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x54 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$20)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$32 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$32);
      var optioner$12 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$10 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$12 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$10);
      var $$x53 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$12, resolver$12);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$37 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$38 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$37);
      var $$x52 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$38);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$33 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var fieldRenderable$12 = $n($$x56).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x55, $$x54, $$x53, $$x52, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$33))));
      $m_Lshapeless_Witness$();
      var this$586 = $m_s_Symbol$();
      var value0$84 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$586, "expectedAmount"));
      var witness$20 = new $c_Lshapeless_Witness$$anon$1(value0$84);
      var $$x61 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$45 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$46 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$45);
      var $$x60 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$46);
      var ord$21 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x59 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$21)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$34 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$34);
      var optioner$13 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$13 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$11);
      var $$x58 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$13, resolver$13);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$39 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$40 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$39);
      var $$x57 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$40);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$35 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var fieldRenderable$11 = $n($$x61).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x60, $$x59, $$x58, $$x57, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$35))));
      $m_Lshapeless_Witness$();
      var this$598 = $m_s_Symbol$();
      var value0$85 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$598, "received"));
      var witness$19 = new $c_Lshapeless_Witness$$anon$1(value0$85);
      var $$x65 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$47 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
      var format$48 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$47);
      var $$x64 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$48);
      var ord$22 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
      var $$x63 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$22)));
      var $$x62 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$604 = $m_Lreactbuild_model_Implicits$();
      var locale$2 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
      var textualizable$41 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$604, locale$2);
      var textualizable$42 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$41);
      var fieldRenderable$10 = $n($$x65).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x64, $$x63, $$x62, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$42), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
      $m_Lshapeless_Witness$();
      var this$607 = $m_s_Symbol$();
      var value0$86 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$607, "category"));
      var witness$18 = new $c_Lshapeless_Witness$$anon$1(value0$86);
      var $$x70 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$49 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
      var format$50 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$49);
      var $$x69 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$50);
      var ord$23 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
      var $$x68 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$23)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$36 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$36);
      var optioner$14 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var resolver$14 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
      var $$x67 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$14, resolver$14);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$43 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      var textualizable$44 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$43);
      var $$x66 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$44);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$37 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      var fieldRenderable$9 = $n($$x70).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x69, $$x68, $$x67, $$x66, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$37))));
      var tail$28 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3();
      var tail$29 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$9, witness$18, tail$28);
      var tail$30 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$10, witness$19, tail$29);
      var tail$31 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$11, witness$20, tail$30);
      var tail$32 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$12, witness$21, tail$31);
      var tail$33 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$623, tail$32);
      var tail$34 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$13, witness$22, tail$33);
      var tail$35 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$14, witness$23, tail$34);
      var tail$36 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$15, witness$24, tail$35);
      var tail$37 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$16, witness$25, tail$36);
      var renderer$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$17, witness$26, tail$37);
      var $$x71 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$2);
      var $$x20 = $m_Lreactbuild_model_InvoicePageGroup$().keyMapperInvoicePageGroup__Lcom_iz2use_common_KeyMapper();
      var $$x19 = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
      var $$x18 = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
      var this$630 = $m_s_Symbol$();
      var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$630, "organization"));
      var this$631 = $m_s_Symbol$();
      var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$631, "supplier"));
      var this$632 = $m_s_Symbol$();
      var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$632, "date"));
      var this$633 = $m_s_Symbol$();
      var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$633, "entryNumber"));
      var this$634 = $m_s_Symbol$();
      var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$634, "reference"));
      var this$635 = $m_s_Symbol$();
      var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$635, "pages"));
      var this$636 = $m_s_Symbol$();
      var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$636, "totalAmount"));
      var this$637 = $m_s_Symbol$();
      var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$637, "expectedAmount"));
      var this$638 = $m_s_Symbol$();
      var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$638, "received"));
      var this$639 = $m_s_Symbol$();
      var labels$4 = new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$639, "category")), $m_Lshapeless_HNil$()))))))))));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$4);
      var f$4 = new $c_sjsr_AnonFunction1(((x0$19$2) => {
        var x0$19 = $as_Lreactbuild_model_InvoicePageGroup(x0$19$2);
        if ((x0$19 !== null)) {
          var organization$macro$191 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_organization;
          var supplier$macro$192 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_supplier;
          var date$macro$193 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_date;
          var entryNumber$macro$194 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
          var reference$macro$195 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_reference;
          var pages$macro$196 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_pages;
          var totalAmount$macro$197 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
          var expectedAmount$macro$198 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
          var received$macro$199 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_received;
          var category$macro$200 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_category;
          return new $c_Lshapeless_$colon$colon(organization$macro$191, new $c_Lshapeless_$colon$colon(supplier$macro$192, new $c_Lshapeless_$colon$colon(date$macro$193, new $c_Lshapeless_$colon$colon(entryNumber$macro$194, new $c_Lshapeless_$colon$colon(reference$macro$195, new $c_Lshapeless_$colon$colon(pages$macro$196, new $c_Lshapeless_$colon$colon(totalAmount$macro$197, new $c_Lshapeless_$colon$colon(expectedAmount$macro$198, new $c_Lshapeless_$colon$colon(received$macro$199, new $c_Lshapeless_$colon$colon(category$macro$200, $m_Lshapeless_HNil$()))))))))))
        } else {
          throw new $c_s_MatchError(x0$19)
        }
      }));
      var g$4 = new $c_sjsr_AnonFunction1(((x0$20$2) => {
        var x0$20 = $as_Lshapeless_$colon$colon(x0$20$2);
        if ((x0$20 !== null)) {
          var organization$macro$181 = $as_Lreactbuild_common_model_RefTo($n(x0$20).Lshapeless_$colon$colon__f_head);
          var p2$4 = $as_Lshapeless_$colon$colon($n(x0$20).Lshapeless_$colon$colon__f_tail);
          if ((p2$4 !== null)) {
            var supplier$macro$182 = $as_s_Option($n(p2$4).Lshapeless_$colon$colon__f_head);
            var p3$4 = $as_Lshapeless_$colon$colon($n(p2$4).Lshapeless_$colon$colon__f_tail);
            if ((p3$4 !== null)) {
              var date$macro$183 = $as_s_Option($n(p3$4).Lshapeless_$colon$colon__f_head);
              var p4$4 = $as_Lshapeless_$colon$colon($n(p3$4).Lshapeless_$colon$colon__f_tail);
              if ((p4$4 !== null)) {
                var entryNumber$macro$184 = $as_s_Option($n(p4$4).Lshapeless_$colon$colon__f_head);
                var p5$4 = $as_Lshapeless_$colon$colon($n(p4$4).Lshapeless_$colon$colon__f_tail);
                if ((p5$4 !== null)) {
                  var reference$macro$185 = $as_s_Option($n(p5$4).Lshapeless_$colon$colon__f_head);
                  var p6$4 = $as_Lshapeless_$colon$colon($n(p5$4).Lshapeless_$colon$colon__f_tail);
                  if ((p6$4 !== null)) {
                    var pages$macro$186 = $as_sci_Seq($n(p6$4).Lshapeless_$colon$colon__f_head);
                    var p7$4 = $as_Lshapeless_$colon$colon($n(p6$4).Lshapeless_$colon$colon__f_tail);
                    if ((p7$4 !== null)) {
                      var totalAmount$macro$187 = $as_s_Option($n(p7$4).Lshapeless_$colon$colon__f_head);
                      var p8$4 = $as_Lshapeless_$colon$colon($n(p7$4).Lshapeless_$colon$colon__f_tail);
                      if ((p8$4 !== null)) {
                        var expectedAmount$macro$188 = $as_s_Option($n(p8$4).Lshapeless_$colon$colon__f_head);
                        var p9$4 = $as_Lshapeless_$colon$colon($n(p8$4).Lshapeless_$colon$colon__f_tail);
                        if ((p9$4 !== null)) {
                          var received$macro$189 = $as_s_Option($n(p9$4).Lshapeless_$colon$colon__f_head);
                          var p10$4 = $as_Lshapeless_$colon$colon($n(p9$4).Lshapeless_$colon$colon__f_tail);
                          if ((p10$4 !== null)) {
                            var category$macro$190 = $as_s_Option($n(p10$4).Lshapeless_$colon$colon__f_head);
                            var p11$4 = $as_Lshapeless_HNil($n(p10$4).Lshapeless_$colon$colon__f_tail);
                            var x$5 = $m_Lshapeless_HNil$();
                            if ((x$5 === p11$4)) {
                              return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$181, supplier$macro$182, date$macro$183, entryNumber$macro$184, reference$macro$185, pages$macro$186, totalAmount$macro$187, expectedAmount$macro$188, received$macro$189, category$macro$190)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
        throw new $c_s_MatchError(x0$20)
      }));
      var gen$8 = new $c_Lshapeless_Generic$$anon$1(f$4, g$4);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$40 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$642 = $m_s_Symbol$();
      var value0$87 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$642, "category"));
      new $c_Lshapeless_Witness$$anon$1(value0$87);
      var zipWithKeys$41 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$40);
      $m_Lshapeless_Witness$();
      var this$645 = $m_s_Symbol$();
      var value0$88 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$645, "received"));
      new $c_Lshapeless_Witness$$anon$1(value0$88);
      var zipWithKeys$42 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$41);
      $m_Lshapeless_Witness$();
      var this$648 = $m_s_Symbol$();
      var value0$89 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$648, "expectedAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$89);
      var zipWithKeys$43 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$42);
      $m_Lshapeless_Witness$();
      var this$651 = $m_s_Symbol$();
      var value0$90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$651, "totalAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$90);
      var zipWithKeys$44 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$43);
      $m_Lshapeless_Witness$();
      var this$654 = $m_s_Symbol$();
      var value0$91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$654, "pages"));
      new $c_Lshapeless_Witness$$anon$1(value0$91);
      var zipWithKeys$45 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$44);
      $m_Lshapeless_Witness$();
      var this$657 = $m_s_Symbol$();
      var value0$92 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$657, "reference"));
      new $c_Lshapeless_Witness$$anon$1(value0$92);
      var zipWithKeys$46 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$45);
      $m_Lshapeless_Witness$();
      var this$660 = $m_s_Symbol$();
      var value0$93 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$660, "entryNumber"));
      new $c_Lshapeless_Witness$$anon$1(value0$93);
      var zipWithKeys$47 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$46);
      $m_Lshapeless_Witness$();
      var this$663 = $m_s_Symbol$();
      var value0$94 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$663, "date"));
      new $c_Lshapeless_Witness$$anon$1(value0$94);
      var zipWithKeys$48 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$47);
      $m_Lshapeless_Witness$();
      var this$666 = $m_s_Symbol$();
      var value0$95 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$666, "supplier"));
      new $c_Lshapeless_Witness$$anon$1(value0$95);
      var zipWithKeys$49 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$48);
      $m_Lshapeless_Witness$();
      var this$669 = $m_s_Symbol$();
      var value0$96 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$669, "organization"));
      new $c_Lshapeless_Witness$$anon$1(value0$96);
      var zip$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$49);
      var this$672 = $m_s_$less$colon$less$();
      var ev$38 = this$672.s_$less$colon$less$__f_singleton;
      var gen$9 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$4, gen$8, ev$38);
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$674 = $m_s_Symbol$();
      var value0$97 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$674, "organization"));
      var witness$36 = new $c_Lshapeless_Witness$$anon$1(value0$97);
      var this$678 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
      var this$677 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$12 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var textualizable$45 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$677, proxy$12);
      var ev$39 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
      var ht$9 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$678, textualizable$45, ev$39)));
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$679 = $m_s_Symbol$();
      var value0$98 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$679, "supplier"));
      var witness$35 = new $c_Lshapeless_Witness$$anon$1(value0$98);
      var this$684 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$682 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$13 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var textualizable$46 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$682, proxy$13);
      var textualizable$47 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$46);
      var ev$40 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
      var ht$8 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$684, textualizable$47, ev$40)));
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$685 = $m_s_Symbol$();
      var value0$99 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$685, "date"));
      var witness$34 = new $c_Lshapeless_Witness$$anon$1(value0$99);
      var this$688 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$48 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var textualizable$49 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$48);
      var ev$41 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
      var ht$7 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$688, textualizable$49, ev$41)));
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$689 = $m_s_Symbol$();
      var value0$100 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$689, "entryNumber"));
      var witness$33 = new $c_Lshapeless_Witness$$anon$1(value0$100);
      var this$693 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$21 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var textualizable$50 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$21);
      var ev$42 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
      var ht$6 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$693, textualizable$50, ev$42)));
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$694 = $m_s_Symbol$();
      var value0$101 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$694, "reference"));
      var witness$32 = new $c_Lshapeless_Witness$$anon$1(value0$101);
      var this$698 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$22 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var textualizable$51 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$22);
      var ev$43 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
      var ht$5 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$698, textualizable$51, ev$43)));
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$699 = $m_s_Symbol$();
      var value0$102 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$699, "pages"));
      var witness$31 = new $c_Lshapeless_Witness$$anon$1(value0$102);
      var ht$4 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$701 = $m_s_Symbol$();
      var value0$103 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$701, "totalAmount"));
      var witness$30 = new $c_Lshapeless_Witness$$anon$1(value0$103);
      var this$704 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$52 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$53 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$52);
      var ev$44 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
      var ht$3 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$704, textualizable$53, ev$44)));
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$705 = $m_s_Symbol$();
      var value0$104 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$705, "expectedAmount"));
      var witness$29 = new $c_Lshapeless_Witness$$anon$1(value0$104);
      var this$708 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$54 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$55 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$54);
      var ev$45 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
      var ht$2 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$708, textualizable$55, ev$45)));
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$709 = $m_s_Symbol$();
      var value0$105 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$709, "received"));
      var witness$28 = new $c_Lshapeless_Witness$$anon$1(value0$105);
      var this$713 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$711 = $m_Lreactbuild_model_Implicits$();
      var locale$3 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
      var textualizable$56 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$711, locale$3);
      var textualizable$57 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$56);
      var ev$46 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
      var ht$1 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$713, textualizable$57, ev$46)));
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$714 = $m_s_Symbol$();
      var value0$106 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$714, "category"));
      var witness$27 = new $c_Lshapeless_Witness$$anon$1(value0$106);
      var this$717 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$58 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      var textualizable$59 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$58);
      var ev$47 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
      var ht = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$717, textualizable$59, ev$47)));
      var tt = $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$().Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil;
      var tt$1 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt, ht, witness$27);
      var tt$2 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$28);
      var tt$3 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$2, ht$2, witness$29);
      var tt$4 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$3, ht$3, witness$30);
      var tt$5 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$4, ht$4, witness$31);
      var tt$6 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$5, ht$5, witness$32);
      var tt$7 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$6, ht$6, witness$33);
      var tt$8 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$7, ht$7, witness$34);
      var tt$9 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$8, ht$8, witness$35);
      var tokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$9, ht$9, witness$36);
      var $$x17 = new $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer, gen$9);
      var $$x7 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
      var $$x6 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
      var $$x5 = new $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1();
      var $$x4 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
      var $$x3 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
      $m_Lreactbuild_model_Implicits$();
      var this$731 = $m_Ljapgolly_scalajs_react_Reusability$();
      var u = $n($$x180).noExternalStateNorActive__O__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(invoicePageGroups, $$x179, $$x178, $$x168, $$x72, $$x71, $$x20, $$x19, $$x18, $$x17, $$x7, $$x6, $$x5, $$x4, $$x3, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$731.byRef__F2(), this$731.by_$eq$eq__F2()), new $c_sjsr_AnonFunction1(((evT$2) => {
        var evT = $n($as_Ljapgolly_scalajs_react_Reusability(evT$2)).Ljapgolly_scalajs_react_Reusability__f_test;
        return new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityMultiviewItemColl__F2__F2(evT))
      })), $m_Lcom_iz2use_react_components_internal_multiview_View$().defaultViewOrdering__s_math_Ordering());
      var this$733 = $n(u);
      var n = this$733.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    }));
    var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$();
    $m_Lreactbuild_model_Implicits$();
    var this$736 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u$1 = $n($$x185).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x181, $$x2, $n($$x1).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$736.byRef__F2(), this$736.by_$eq$eq__F2())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var this$738 = $n(u$1);
    var n$1 = this$738.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$740, f$5)
});
var $d_Lreactbuild_analyze_cost_modules_DocumentList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_DocumentList$: 0
}, false, "reactbuild.analyze.cost.modules.DocumentList$", {
  Lreactbuild_analyze_cost_modules_DocumentList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_DocumentList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_DocumentList$;
var $n_Lreactbuild_analyze_cost_modules_DocumentList$;
function $m_Lreactbuild_analyze_cost_modules_DocumentList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_DocumentList$)) {
    $n_Lreactbuild_analyze_cost_modules_DocumentList$ = new $c_Lreactbuild_analyze_cost_modules_DocumentList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_DocumentList$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$() {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$reusabilityType = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$defaultType = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$resolverType = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$typeHelper = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_EditListEntry$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$reusabilityType = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$defaultType = new $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$resolverType = new $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$typeHelper = new $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("EditListEntry", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_EditListEntry$Props(p$2);
    var this$3 = $n(p);
    return $f_Lreactbuild_analyze_cost_modules_EditListEntry$Props__initialState__Lreactbuild_analyze_cost_modules_EditListEntry$State(this$3)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_EditListEntry$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_EditListEntry$Props__Lreactbuild_analyze_cost_modules_EditListEntry$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_EditListEntry$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$.prototype.apply__Lreactbuild_analyze_cost_modules_EditListEntry$Props__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(props) {
  var c = this.Lreactbuild_analyze_cost_modules_EditListEntry$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$", {
  Lreactbuild_analyze_cost_modules_EditListEntry$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$;
var $n_Lreactbuild_analyze_cost_modules_EditListEntry$;
function $m_Lreactbuild_analyze_cost_modules_EditListEntry$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_EditListEntry$)) {
    $n_Lreactbuild_analyze_cost_modules_EditListEntry$ = new $c_Lreactbuild_analyze_cost_modules_EditListEntry$()
  };
  return $n_Lreactbuild_analyze_cost_modules_EditListEntry$
}
function $f_Lreactbuild_analyze_cost_modules_EditListEntry$Props__initialState__Lreactbuild_analyze_cost_modules_EditListEntry$State($thiz) {
  var this$1 = $n($thiz.title__T());
  if ((this$1 === "")) {
    var titles = $m_sci_Nil$()
  } else {
    var self = $m_ju_UUID$().randomUUID__ju_UUID();
    var rassoc$7 = $ct_T2__O__O__(new $c_T2(), self, "");
    var this$4 = $m_sci_Nil$();
    var titles = new $c_sci_$colon$colon(rassoc$7, this$4)
  };
  var $$x4 = $thiz.tpe__Lreactbuild_model_ListEntryType();
  var self$1 = $m_ju_UUID$().randomUUID__ju_UUID();
  var y = $thiz.title__T();
  var rassoc$8 = $ct_T2__O__O__(new $c_T2(), self$1, y);
  var this$7 = $n(titles);
  var $$x3 = new $c_sci_$colon$colon(rassoc$8, this$7);
  var $$x2 = $thiz.terms__sci_ListSet();
  var this$8 = $n($thiz.created__s_Option());
  if (this$8.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$8.get__O();
    var x$27 = $as_Ljava_time_Instant(arg1);
    var this$9 = $n(x$27);
    var offset = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
    var this$10 = $n($m_Ljava_time_OffsetDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime(this$9, offset));
    var this$11 = $n(this$10.Ljava_time_OffsetDateTime__f_dateTime);
    var $$x1 = new $c_s_Some(this$11.Ljava_time_LocalDateTime__f_date)
  };
  return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State($$x4, $$x3, $$x2, $$x1, $thiz.template__s_Option(), false, $thiz.validation__Lreactbuild_model_ListEntryValidation())
}
function $is_Lreactbuild_analyze_cost_modules_EditListEntry$Props(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$Props)))
}
function $as_Lreactbuild_analyze_cost_modules_EditListEntry$Props(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_EditListEntry$Props(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditListEntry$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditListEntry$Props;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditPerson$() {
  this.Lreactbuild_analyze_cost_modules_EditPerson$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_EditPerson$ = this;
  this.Lreactbuild_analyze_cost_modules_EditPerson$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("EditPerson", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_EditPerson$Props(p$2);
    return $n(p).deriveState__Lreactbuild_analyze_cost_modules_EditPerson$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_EditPerson$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_EditPerson$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_EditPerson$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_EditPerson$Props__Lreactbuild_analyze_cost_modules_EditPerson$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_EditPerson$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_EditPerson$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditPerson$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditPerson$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditPerson$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditPerson$.prototype = $c_Lreactbuild_analyze_cost_modules_EditPerson$.prototype;
$c_Lreactbuild_analyze_cost_modules_EditPerson$.prototype.withKey__T__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, router, proxy, snapshot) {
  var c = this.Lreactbuild_analyze_cost_modules_EditPerson$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_EditPerson$Props(router, proxy, snapshot);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_EditPerson$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditPerson$: 0
}, false, "reactbuild.analyze.cost.modules.EditPerson$", {
  Lreactbuild_analyze_cost_modules_EditPerson$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditPerson$;
var $n_Lreactbuild_analyze_cost_modules_EditPerson$;
function $m_Lreactbuild_analyze_cost_modules_EditPerson$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_EditPerson$)) {
    $n_Lreactbuild_analyze_cost_modules_EditPerson$ = new $c_Lreactbuild_analyze_cost_modules_EditPerson$()
  };
  return $n_Lreactbuild_analyze_cost_modules_EditPerson$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditProject$() {
  this.Lreactbuild_analyze_cost_modules_EditProject$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_EditProject$ = this;
  this.Lreactbuild_analyze_cost_modules_EditProject$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("EditProject", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_EditProject$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_EditProject$State($m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_EditProject$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_EditProject$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_EditProject$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_EditProject$Props__Lreactbuild_analyze_cost_modules_EditProject$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_EditProject$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_EditProject$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditProject$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditProject$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditProject$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditProject$.prototype = $c_Lreactbuild_analyze_cost_modules_EditProject$.prototype;
$c_Lreactbuild_analyze_cost_modules_EditProject$.prototype.withKey__T__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, pageProps, projectProxy) {
  var c = this.Lreactbuild_analyze_cost_modules_EditProject$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_EditProject$Props(pageProps, projectProxy);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_EditProject$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditProject$: 0
}, false, "reactbuild.analyze.cost.modules.EditProject$", {
  Lreactbuild_analyze_cost_modules_EditProject$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_EditProject$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditProject$;
var $n_Lreactbuild_analyze_cost_modules_EditProject$;
function $m_Lreactbuild_analyze_cost_modules_EditProject$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_EditProject$)) {
    $n_Lreactbuild_analyze_cost_modules_EditProject$ = new $c_Lreactbuild_analyze_cost_modules_EditProject$()
  };
  return $n_Lreactbuild_analyze_cost_modules_EditProject$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditResource$() {
  this.Lreactbuild_analyze_cost_modules_EditResource$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_EditResource$ = this;
  this.Lreactbuild_analyze_cost_modules_EditResource$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("EditResource", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_EditResource$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_EditResource$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_EditResource$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_EditResource$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_EditResource$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_EditResource$Props__Lreactbuild_analyze_cost_modules_EditResource$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_EditResource$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_EditResource$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditResource$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditResource$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditResource$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditResource$.prototype = $c_Lreactbuild_analyze_cost_modules_EditResource$.prototype;
$c_Lreactbuild_analyze_cost_modules_EditResource$.prototype.withKey__T__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, proxy, resourceProxy) {
  var c = this.Lreactbuild_analyze_cost_modules_EditResource$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_EditResource$Props(proxy, resourceProxy);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_EditResource$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditResource$: 0
}, false, "reactbuild.analyze.cost.modules.EditResource$", {
  Lreactbuild_analyze_cost_modules_EditResource$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_EditResource$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditResource$;
var $n_Lreactbuild_analyze_cost_modules_EditResource$;
function $m_Lreactbuild_analyze_cost_modules_EditResource$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_EditResource$)) {
    $n_Lreactbuild_analyze_cost_modules_EditResource$ = new $c_Lreactbuild_analyze_cost_modules_EditResource$()
  };
  return $n_Lreactbuild_analyze_cost_modules_EditResource$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryList$() {
  this.Lreactbuild_analyze_cost_modules_EntryList$__f_fill = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_EntryList$ = this;
  this.Lreactbuild_analyze_cost_modules_EntryList$__f_fill = $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "fill");
  this.Lreactbuild_analyze_cost_modules_EntryList$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("EntryList", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_EntryList$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_EntryList$State(($n($m_s_Predef$().s_Predef$__f_Set), $m_sci_Set$EmptySet$()), true)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_EntryList$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_EntryList$Backend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_EntryList$Props($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_EntryList$Props__Lreactbuild_analyze_cost_modules_EntryList$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_EntryList$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_EntryList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EntryList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryList$.prototype = $c_Lreactbuild_analyze_cost_modules_EntryList$.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryList$.prototype.apply__Lreactbuild_common_model_Project__Lreactbuild_common_model_RefTo__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(project, user, proxy) {
  var $$x12 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
  var $$x11 = $n(project).Lreactbuild_common_model_Project__f__id;
  var $$x7 = new $c_sjsr_AnonFunction1(((ref$2) => {
    var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x10 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x9 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "project", "ListEntryApi", "listEntriesFor"];
    var $$x8 = $as_sci_Seq($n($$x9).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$13 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
    var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(ref, evidence$2);
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "source", y)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($$x10).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x8, this$13.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$16 = $n(new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_model_WithChildren$().decodeWithChildren__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_model_ListEntry$().Lreactbuild_model_ListEntry$__f_decodeListEntry, $m_Lreactbuild_model_ListEntryEvent$().Lreactbuild_model_ListEntryEvent$__f_codecForListEntryEvent);
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$16.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  }));
  var $$x3 = new $c_sjsr_AnonFunction1(((ss$2) => {
    var ss = $as_Ldiode_data_Pot(ss$2);
    if ($n(ss).isFailed__Z()) {
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(ss).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$2 = [$$x4, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    } else {
      var this$27 = $n(ss);
      if ((!this$27.isEmpty__Z())) {
        var arg1 = $n(ss).get__O();
        var v$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
        var c = $m_Lreactbuild_analyze_cost_modules_EntryList$().Lreactbuild_analyze_cost_modules_EntryList$__f_component;
        var this$29 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
        var props = new $c_Lreactbuild_analyze_cost_modules_EntryList$Props(project, v$1, proxy, user);
        var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$29.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$29.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
        var this$31 = $n(u);
        var n = this$31.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      } else if ($n(ss).isPending__Z()) {
        return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      }
    }
  }));
  var $$x2 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Lreactbuild_model_Implicits$();
  var this$41 = $m_Ljapgolly_scalajs_react_Reusability$();
  return $n($$x12).query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x11, $$x7, $$x3, $$x2, $n($$x1).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$41.byRef__F2(), this$41.by_$eq$eq__F2())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
});
var $d_Lreactbuild_analyze_cost_modules_EntryList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryList$: 0
}, false, "reactbuild.analyze.cost.modules.EntryList$", {
  Lreactbuild_analyze_cost_modules_EntryList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryList$;
var $n_Lreactbuild_analyze_cost_modules_EntryList$;
function $m_Lreactbuild_analyze_cost_modules_EntryList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_EntryList$)) {
    $n_Lreactbuild_analyze_cost_modules_EntryList$ = new $c_Lreactbuild_analyze_cost_modules_EntryList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_EntryList$
}
function $is_Lreactbuild_analyze_cost_modules_EntryList$Updater(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_EntryList$Updater)))
}
function $as_Lreactbuild_analyze_cost_modules_EntryList$Updater(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_EntryList$Updater(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EntryList$Updater"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EntryList$Updater(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EntryList$Updater)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EntryList$Updater(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EntryList$Updater(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EntryList$Updater;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryListEntry$() {
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$__f_component = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$__f_custom = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$__f_templated = null;
  $n_Lreactbuild_analyze_cost_modules_EntryListEntry$ = this;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("EntryListEntry", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_EntryListEntry$State(false)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_EntryListEntry$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_EntryListEntry$Props__Lreactbuild_analyze_cost_modules_EntryListEntry$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_EntryListEntry$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)));
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$__f_custom = new $c_sjsr_AnonFunction3(((context$2, entry$2, update$2) => {
    var context = $as_Lreactbuild_analyze_cost_modules_EditListEntry$Context(context$2);
    var entry = $as_Lreactbuild_model_WithChildren(entry$2);
    var update = $as_Lreactbuild_analyze_cost_modules_EntryList$Updater(update$2);
    return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps(context, entry, update)
  }));
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$__f_templated = new $c_sjsr_AnonFunction4(((context$3$2, entry$3$2, templateEntry$2, update$3$2) => {
    var context$3 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$Context(context$3$2);
    var entry$3 = $as_s_Option(entry$3$2);
    var templateEntry = $as_Lreactbuild_model_ListTemplateEntry(templateEntry$2);
    var update$3 = $as_Lreactbuild_analyze_cost_modules_EntryList$Updater(update$3$2);
    return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(context$3, entry$3, templateEntry, update$3)
  }))
}
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryListEntry$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryListEntry$.prototype = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$.prototype.apply__Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(props) {
  return $m_Lreactbuild_analyze_cost_components_Progress$().withKey__T__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(("" + $n(props).permanentId__Lreactbuild_common_model_RefTo()), new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Lreactbuild_analyze_cost_components_ProgressContext(ctx$2);
    var c = $m_Lreactbuild_analyze_cost_modules_EntryListEntry$().Lreactbuild_analyze_cost_modules_EntryListEntry$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props$1 = new $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(ctx, props);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props$1, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })))
});
var $d_Lreactbuild_analyze_cost_modules_EntryListEntry$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryListEntry$: 0
}, false, "reactbuild.analyze.cost.modules.EntryListEntry$", {
  Lreactbuild_analyze_cost_modules_EntryListEntry$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryListEntry$;
var $n_Lreactbuild_analyze_cost_modules_EntryListEntry$;
function $m_Lreactbuild_analyze_cost_modules_EntryListEntry$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_EntryListEntry$)) {
    $n_Lreactbuild_analyze_cost_modules_EntryListEntry$ = new $c_Lreactbuild_analyze_cost_modules_EntryListEntry$()
  };
  return $n_Lreactbuild_analyze_cost_modules_EntryListEntry$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$() {
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ExpandablePicker$ = this;
  var this$8 = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ExpandablePicker", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x1 = $n($as_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    return $n($$x1).render__Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode($as_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()), $n(x$3).propsChildren__sjs_js_Any())
  }))));
  var x$2$2 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(\u03b4$2);
    var this$5 = $n(\u03b4);
    return $n($as_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend($f_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot__backend__O(this$5))).Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_close
  }));
  var x$3$3 = new $c_sjsr_AnonFunction1(((x$22$2) => {
    $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$22$2);
    return window
  }));
  var f = $m_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$().install$extension__Z__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(true, "mousedown", x$2$2, x$3$3, false, $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$8))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ExpandablePicker$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ExpandablePicker$.prototype = $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$.prototype;
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$.prototype.apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_Ref$FullF__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(close, activateButton, children) {
  var c = this.Lreactbuild_analyze_cost_modules_ExpandablePicker$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props(close, activateButton);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_modules_ExpandablePicker$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ExpandablePicker$: 0
}, false, "reactbuild.analyze.cost.modules.ExpandablePicker$", {
  Lreactbuild_analyze_cost_modules_ExpandablePicker$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ExpandablePicker$;
var $n_Lreactbuild_analyze_cost_modules_ExpandablePicker$;
function $m_Lreactbuild_analyze_cost_modules_ExpandablePicker$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ExpandablePicker$)) {
    $n_Lreactbuild_analyze_cost_modules_ExpandablePicker$ = new $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ExpandablePicker$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_FlatList$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_FlatList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_FlatList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_FlatList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_FlatList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_FlatList$.prototype = $c_Lreactbuild_analyze_cost_modules_FlatList$.prototype;
$c_Lreactbuild_analyze_cost_modules_FlatList$.prototype.apply__sci_Seq__sci_Seq = (function(xs) {
  return $as_sci_Seq($n(xs).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$18$2) => {
    var x$18 = $as_Lreactbuild_analyze_cost_modules_FlatListItem(x$18$2);
    return $n(x$18).values__sci_Seq()
  }))))
});
var $d_Lreactbuild_analyze_cost_modules_FlatList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_FlatList$: 0
}, false, "reactbuild.analyze.cost.modules.FlatList$", {
  Lreactbuild_analyze_cost_modules_FlatList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_FlatList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_FlatList$;
var $n_Lreactbuild_analyze_cost_modules_FlatList$;
function $m_Lreactbuild_analyze_cost_modules_FlatList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_FlatList$)) {
    $n_Lreactbuild_analyze_cost_modules_FlatList$ = new $c_Lreactbuild_analyze_cost_modules_FlatList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_FlatList$
}
function $is_Lreactbuild_analyze_cost_modules_FlatListItem(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_FlatListItem)))
}
function $as_Lreactbuild_analyze_cost_modules_FlatListItem(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_FlatListItem(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.FlatListItem"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_FlatListItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_FlatListItem)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_FlatListItem(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_FlatListItem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.FlatListItem;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Home$() {
  this.Lreactbuild_analyze_cost_modules_Home$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_Home$ = this;
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var self = new $c_Lreactbuild_Loc$BusinessOpportunities($m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$());
  var array = [$ct_T2__O__O__(new $c_T2(), self, "Consulter la carte")];
  $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  this.Lreactbuild_analyze_cost_modules_Home$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_package$PageProps(p$2);
    var this$8 = $n($n(p).Lreactbuild_package$PageProps__f_proxy);
    var this$9 = $n(this$8.Ldiode_react_ModelProxy__f_modelReader);
    var x1 = $n($n($as_Lreactbuild_analyze_cost_services_Model(this$9.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged).isEmpty__Z();
    if ((x1 === true)) {
      var $$x5 = $m_Lreactbuild_analyze_cost_modules_home_HomeLayout$();
      var $$x4 = $m_Lreactbuild_analyze_cost_modules_Home$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Premi\u00e8re fois sur ReactBuild ?");
      var $$x2 = $m_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$();
      var this$12 = $n($n(p).Lreactbuild_package$PageProps__f_router);
      var f = new $c_sjsr_AnonFunction1(((step$2) => {
        var step = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(step$2);
        return new $c_Lreactbuild_Loc$BusinessOpportunities(step)
      }));
      var u = $n($$x2).apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(this$12, f, this$12.F__Ljapgolly_scalajs_react_util_Effect$Sync()));
      var this$14 = $n(u);
      var n = this$14.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$1 = [$n($$x4).renderBlock__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf($$x3, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)), $m_Lreactbuild_analyze_cost_modules_Home$().renderBlock__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("J'ai d\u00e9j\u00e0 un compte :")), $m_Lreactbuild_common_components_UserConnection$().apply__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lreactbuild_common_components_UserConnection$().apply$default$1__T()))];
      var u$1 = $n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var this$22 = $n(u$1);
      var n$1 = this$22.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    } else if ((x1 === false)) {
      var $$x9 = $m_Lreactbuild_analyze_cost_modules_home_HomeLayout$();
      var u$2 = $m_Lreactbuild_analyze_cost_modules_home_TodayList$().apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(p);
      var this$25 = $n(u$2);
      var n$2 = this$25.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2);
      var u$3 = $m_Lreactbuild_analyze_cost_modules_home_ProjectList$().apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(p);
      var this$28 = $n(u$3);
      var n$3 = this$28.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x7 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3);
      var u$4 = $m_Lreactbuild_analyze_cost_modules_home_OtherActionList$().apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(p);
      var this$31 = $n(u$4);
      var n$4 = this$31.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4);
      var u$5 = $m_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$().apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(p);
      var this$34 = $n(u$5);
      var n$5 = this$34.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$2 = [$$x8, $$x7, $$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$5)];
      var u$6 = $n($$x9).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var this$40 = $n(u$6);
      var n$6 = this$40.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$6)
    } else {
      throw new $c_s_MatchError(x1)
    }
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_Home$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Home$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Home$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Home$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Home$.prototype = $c_Lreactbuild_analyze_cost_modules_Home$.prototype;
$c_Lreactbuild_analyze_cost_modules_Home$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomElement = (function() {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_modules_Home$().Lreactbuild_analyze_cost_modules_Home$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(pageProps, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
$c_Lreactbuild_analyze_cost_modules_Home$.prototype.renderBlock__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf = (function(title, content) {
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1rem", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), title];
  var $$x2 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1rem", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), content];
  var array$2 = [$$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
var $d_Lreactbuild_analyze_cost_modules_Home$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Home$: 0
}, false, "reactbuild.analyze.cost.modules.Home$", {
  Lreactbuild_analyze_cost_modules_Home$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_Home$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Home$;
var $n_Lreactbuild_analyze_cost_modules_Home$;
function $m_Lreactbuild_analyze_cost_modules_Home$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_Home$)) {
    $n_Lreactbuild_analyze_cost_modules_Home$ = new $c_Lreactbuild_analyze_cost_modules_Home$()
  };
  return $n_Lreactbuild_analyze_cost_modules_Home$
}
function $p_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__loop$3__sci_List__sci_Map__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary($thiz, rest, userStatus, user$2) {
  while (true) {
    var x1 = rest;
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x2 = $as_sci_$colon$colon(x1);
      var head = $as_Lreactbuild_model_ListEntryEvent($n(x2).sci_$colon$colon__f_head);
      var tl = $n(x2).sci_$colon$colon__f_next;
      var x1$2 = $n(head).Lreactbuild_model_ListEntryEvent__f_body;
      var x = $m_Lreactbuild_model_ListEntryEventBody$Approved$();
      if ((x === x1$2)) {
        var v = $m_Lreactbuild_model_ListEntryEventBody$Approved$();
        var userStatus$1 = userStatus;
        var temp$userStatus = $as_sci_Map($n(userStatus$1).updated__O__O__sci_MapOps($n(head).Lreactbuild_model_ListEntryEvent__f_user, v));
        rest = tl;
        userStatus = temp$userStatus
      } else if ((x1$2 instanceof $c_Lreactbuild_model_ListEntryEventBody$Rejected)) {
        var x3 = $as_Lreactbuild_model_ListEntryEventBody$Rejected(x1$2);
        var userStatus$1$1 = userStatus;
        var temp$userStatus$2 = $as_sci_Map($n(userStatus$1$1).updated__O__O__sci_MapOps($n(head).Lreactbuild_model_ListEntryEvent__f_user, x3));
        rest = tl;
        userStatus = temp$userStatus$2
      } else {
        var x$3 = $m_Lreactbuild_model_ListEntryEventBody$Read$();
        if ((x$3 === x1$2)) {
          var v$1 = $m_Lreactbuild_model_ListEntryEventBody$Read$();
          var userStatus$1$2 = userStatus;
          var temp$userStatus$3 = $as_sci_Map($n(userStatus$1$2).updated__O__O__sci_MapOps($n(head).Lreactbuild_model_ListEntryEvent__f_user, v$1));
          rest = tl;
          userStatus = temp$userStatus$3
        } else {
          rest = tl
        }
      }
    } else {
      var x$5 = $m_sci_Nil$();
      if (x$5.equals__O__Z(x1)) {
        var this$5 = $n($as_sc_IterableOps($n(userStatus).filterNot__F1__O(new $c_sjsr_AnonFunction1(((x$70$2) => {
          var x$70 = $as_T2(x$70$2);
          var this$2 = $n($n(x$70)._2__O());
          var x$1 = $objectGetClass(this$2);
          if ((x$1 !== null)) {
            var this$4 = $n(x$1);
            return (this$4 === $d_Lreactbuild_model_ListEntryEventBody$Read$.getClassOf())
          } else {
            return false
          }
        })))));
        var m = $as_scm_Map($m_scm_Map$().empty__O());
        var it = this$5.iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var elem = $n(it).next__O();
          var x$71 = $as_T2(elem);
          var this$6 = $n($n(x$71)._2__O());
          var key = $objectGetClass(this$6);
          var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$5) => (() => this$5.newSpecificBuilder__scm_Builder()))(this$5))));
          var this$7 = $n(bldr);
          this$7.addOne__O__scm_Growable(elem)
        };
        var this$8 = $m_sci_HashMap$();
        var result = this$8.sci_HashMap$__f_EmptyMap;
        var mapIt = $n(m).iterator__sc_Iterator();
        while ($n(mapIt).hasNext__Z()) {
          var x1$1 = $as_T2($n(mapIt).next__O());
          if ((x1$1 === null)) {
            throw new $c_s_MatchError(x1$1)
          };
          var k = $n(x1$1)._1__O();
          var v$2 = $as_scm_Builder($n(x1$1)._2__O());
          result = $n(result).updated__O__O__sci_HashMap(k, $n(v$2).result__O())
        };
        var allStatus = result;
        if ($n(allStatus).isEmpty__Z()) {
          var allStatusText = $m_s_None$()
        } else {
          var $$x1 = $m_s_Option$();
          var this$13 = $n($as_sc_SortedMapOps($m_sci_SortedMap$().apply__sci_Seq__s_math_Ordering__O($m_sci_Nil$(), $m_s_math_Ordering$String$())));
          var this$9 = $n(allStatus);
          $m_sci_HashMap$();
          var b = new $c_sci_HashMapBuilder();
          var it$1 = this$9.iterator__sc_Iterator();
          while ($n(it$1).hasNext__Z()) {
            var arg1 = $n(it$1).next__O();
            var p = $as_T2(arg1);
            var self = $n($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_listEntryEventIssues).apply__O__O($n(p)._1__O());
            var y = $n($as_sc_IterableOnceOps($n(p)._2__O())).size__I();
            $p_sci_HashMapBuilder__ensureUnaliased__V(b);
            var h = $m_sr_Statics$().anyHash__O__I(self);
            var im = $m_sc_Hashing$().improve__I__I(h);
            b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, self, y, h, im, 0)
          };
          var xs = b.result__sci_HashMap();
          var this$14 = $n($as_sc_IterableOnceOps($n(this$13.concat__sc_IterableOnce__sc_Map(xs)).map__F1__O(new $c_sjsr_AnonFunction1(((v$2$1) => {
            var v$3 = $as_T2(v$2$1);
            return (($n(v$3)._2$mcI$sp__I() + " ") + $n(v$3)._1__O())
          })))));
          var allStatusText = $n($$x1).apply__O__s_Option($f_sc_IterableOnceOps__mkString__T__T__T__T(this$14, "", ", ", "."))
        };
        var this$15 = $n(allStatus);
        $m_sci_List$();
        var x1$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$15);
        matchEnd7$2: {
          var displayedStatus;
          var x$7 = $m_sci_Nil$();
          if (x$7.equals__O__Z(x1$3)) {
            var displayedStatus = $m_s_None$();
            break matchEnd7$2
          };
          if ((x1$3 instanceof $c_sci_$colon$colon)) {
            var x3$2 = $as_sci_$colon$colon(x1$3);
            var head$2 = $as_T2($n(x3$2).sci_$colon$colon__f_head);
            var p4 = $n(x3$2).sci_$colon$colon__f_next;
            var x$9 = $m_sci_Nil$();
            if (x$9.equals__O__Z(p4)) {
              var displayedStatus = new $c_s_Some($n($as_T2($n($as_sc_IterableOps($n(head$2)._2__O())).head__O()))._2__O());
              break matchEnd7$2
            }
          };
          var displayedStatus = $m_s_None$()
        };
        var this$17 = $n($n(userStatus).get__O__s_Option(user$2));
        if (this$17.isEmpty__Z()) {
          var $$x2 = $m_s_None$()
        } else {
          var arg1$1 = this$17.get__O();
          var v$3$1 = $as_Lreactbuild_model_ListEntryEventIssue(arg1$1);
          var $$x3 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_eventTypes;
          var this$18 = $n(v$3$1);
          var $$x2 = new $c_s_Some($n($as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType($n($$x3).apply__O__O($objectGetClass(this$18)))).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name)
        };
        return new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary(displayedStatus, allStatusText, $$x2)
      } else {
        throw new $c_s_MatchError(x1)
      }
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$() {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_listEntryEventIssues = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_eventTypes = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_headers = null;
  $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$ = this;
  var this$12 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array = [$ct_T2__O__O__(new $c_T2(), $d_Lreactbuild_model_ListEntryEventBody$Approved$.getClassOf(), "approuv\u00e9"), $ct_T2__O__O__(new $c_T2(), $d_Lreactbuild_model_ListEntryEventBody$Read$.getClassOf(), "lu"), $ct_T2__O__O__(new $c_T2(), $d_Lreactbuild_model_ListEntryEventBody$Rejected.getClassOf(), "rejet\u00e9")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_listEntryEventIssues = this$12.from__sc_IterableOnce__sci_Map(elems);
  var this$49 = $n($m_s_Predef$().s_Predef$__f_Map);
  var $$x25 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Reset$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_checkbox, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$(), "effac\u00e9", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x24 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Approved$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_thumbUp, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$(), "approuv\u00e9e", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x23 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Ordered$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_store, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$(), "command\u00e9", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x22 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Shipped$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_localShipment, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$(), "exp\u00e9di\u00e9", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x21 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Pickup$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_timeToLeave, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$(), "attente en drive", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x20 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Received$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_pinDrop, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$(), "re\u00e7u", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x19 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$InStock$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_warehouse, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$(), "en stock", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x18 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Read$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_visibility, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$(), "lu", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x17 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Compliant$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_assignmentTurnedIn, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$(), "conforme", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x16 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  var $$x15 = $m_Lreactbuild_model_ListEntryEventBody$Done$();
  var $$x14 = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_checkboxChecked;
  var $$x13 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$();
  var this$22 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_strike;
  var $$x12 = $n($$x16).fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($$x15, $$x14, $$x13, "termin\u00e9", $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$22, s));
  var $$x11 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  var $$x10 = $m_Lreactbuild_model_ListEntryEventBody$Followed$();
  var $$x9 = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_done;
  var $$x8 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$();
  var this$23 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_strike;
  var $$x7 = $n($$x11).fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($$x10, $$x9, $$x8, "suivie", $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$23, s$1));
  var $$x6 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Ignored$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_ignore, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$(), "ignor\u00e9", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var $$x5 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2($m_Lreactbuild_model_ListEntryEventBody$Pending$(), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_checkboxIndeterminate, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$(), "en cours", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty));
  var this$28 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  var body = $m_Lreactbuild_model_ListEntryEventBody$Rejected$();
  var iconSource = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_thumbDown;
  var color = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$();
  var this$27 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_strike;
  $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$27, s$2);
  var y = this$28.fromPrompt__T__F1__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType("Veuillez pr\u00e9ciser la raison :", body, iconSource, color, "rejet\u00e9e", $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), $d_Lreactbuild_model_ListEntryEventBody$Rejected.getClassOf(), y);
  var this$32 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  var body$1 = $m_Lreactbuild_model_ListEntryEventBody$NonCompliant$();
  var iconSource$1 = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_assignmentLate;
  var color$1 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$();
  $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var y$1 = this$32.fromPrompt__T__F1__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType("Veuillez pr\u00e9ciser la raison :", body$1, iconSource$1, color$1, "non-conforme", $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), $d_Lreactbuild_model_ListEntryEventBody$NonCompliant.getClassOf(), y$1);
  var this$36 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  var body$2 = $m_Lreactbuild_model_ListEntryEventBody$NotApplicable$();
  var iconSource$2 = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_visibilityOff;
  var color$2 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$();
  var this$35 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_strike;
  $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$35, s$3);
  var y$2 = this$36.fromPrompt__T__F1__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType("Veuillez pr\u00e9ciser la raison :", body$2, iconSource$2, color$2, "non applicable", $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), $d_Lreactbuild_model_ListEntryEventBody$NotApplicable.getClassOf(), y$2);
  var this$40 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  var body$3 = $m_Lreactbuild_model_ListEntryEventBody$Comment$();
  var iconSource$3 = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_chat;
  var color$3 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$();
  $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var y$3 = this$40.fromPrompt__T__F1__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType("Veuillez ajouter un commentaire :", body$3, iconSource$3, color$3, "commentaire", $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), $d_Lreactbuild_model_ListEntryEventBody$Comment.getClassOf(), y$3);
  var this$44 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  var body$4 = $m_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$();
  var iconSource$4 = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_pending;
  var color$4 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$();
  $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var y$4 = this$44.fromPrompt__T__F1__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType("Veuillez ajouter un commentaire :", body$4, iconSource$4, color$4, "en attente de plus de d\u00e9tails", $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty);
  var array$1 = [$$x25, $$x24, $$x23, $$x22, $$x21, $$x20, $$x19, $$x18, $$x17, $$x12, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), $d_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.getClassOf(), y$4)];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_eventTypes = this$49.from__sc_IterableOnce__sci_Map(elems$1);
  var this$61 = $n($m_Lreactbuild_model_ListEntryType$().Lreactbuild_model_ListEntryType$__f_orderedList);
  var f = ((v$2) => {
    var v = $as_Lreactbuild_model_ListEntryType(v$2);
    var x = $m_Lreactbuild_model_ListEntryType$CheckList$();
    if ((x === v)) {
      var y$5 = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(v, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_factCheck, "Liste de contr\u00f4le", $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$().fromEvents__s_PartialFunction__F2(new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1()), $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$__f_unknown)
    } else {
      var x$3 = $m_Lreactbuild_model_ListEntryType$Supply$();
      if ((x$3 === v)) {
        var y$5 = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(v, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_shoppingCart, "Approvisionnements", $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$().fromEvents__s_PartialFunction__F2(new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2()), new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_checkbox, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$(), "non command\u00e9", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty), ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0())))
      } else {
        var x$5 = $m_Lreactbuild_model_ListEntryType$Guideline$();
        if ((x$5 === v)) {
          var y$5 = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(v, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_rule, "Recommandations", $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$().fromEvents__s_PartialFunction__F2(new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3()), $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$__f_unknown)
        } else {
          var x$7 = $m_Lreactbuild_model_ListEntryType$Issue$();
          if ((x$7 === v)) {
            var y$5 = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(v, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_recordVoiceOver, "Demandes", new $c_sjsr_AnonFunction2(((events$2, user$2) => {
              var events = $as_sci_List(events$2);
              var user = $as_Lreactbuild_common_model_RefTo(user$2);
              return $p_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__loop$3__sci_List__sci_Map__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary(this, events, ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()), user)
            })), $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$__f_unknown)
          } else {
            var x$9 = $m_Lreactbuild_model_ListEntryType$TaskList$();
            if ((!(x$9 === v))) {
              throw new $c_s_MatchError(v)
            };
            var y$5 = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(v, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_pendingActions, "Liste de travail", $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$().fromEvents__s_PartialFunction__F2(new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4()), new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_checkbox, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$(), "non commenc\u00e9e", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty), ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0())))
          }
        }
      }
    };
    return $ct_T2__O__O__(new $c_T2(), v, y$5)
  });
  if ((this$61 === $m_sci_Nil$())) {
    var $$x26 = $m_sci_Nil$()
  } else {
    var arg1 = this$61.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$61.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x26 = h
  };
  var this$63 = $n($$x26);
  var this$62 = $m_s_$less$colon$less$();
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_headers = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$63);
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_Lreactbuild_model_ListEntryType(v$3$2);
    return $n($as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader($n($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_headers).apply__O__O(v$3))).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_render
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$.prototype;
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$;
var $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$;
function $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$)) {
    $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$ = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader.prototype;
function $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ListEntryTypeSection$AbstractHeader"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ListEntryTypeSection$AbstractHeader;", depth))
}
function $ct_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__($thiz, value) {
  $thiz.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value = value;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor() {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value = null
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor.prototype;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_MapLogic$() {
  this.Lreactbuild_analyze_cost_modules_MapLogic$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_MapLogic$ = this;
  var this$83 = $m_Lcom_iz2use_react_hooks_package$();
  var this$3 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context;
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, ctx, step));
  var $$x5 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api);
  var $$x4 = new $c_sjsr_AnonFunction0((() => $m_s_package$().s_package$__f_Nil));
  var this$6 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x5.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x4, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$6)));
  var $$x6 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x3 = new $c_sjsr_AnonFunction0((() => {
    $n($m_s_package$().s_package$__f_List);
    var array = [$m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$(), $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Site, $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Building, $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUPatrimoine, $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$()];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  }));
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$2 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x6.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x3, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$12)));
  var $$x7 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$2);
  var $$x2 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$14 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$3 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x7.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x2, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$14)));
  var $$x8 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$3);
  var $$x1 = new $c_sjsr_AnonFunction0((() => $m_s_package$().s_package$__f_Nil));
  var this$16 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$45 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x8.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$16))));
  var initialState = new $c_sjsr_AnonFunction6(((p$2, x$1$2, areas$2, visibleLayers$2, showLegends$2, x$2$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_MapLogic$Props(p$2);
    $as_s_Option(x$1$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(areas$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(visibleLayers$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(showLegends$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$2$2);
    var $$x17 = $n($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_list).map__F1__sci_List(new $c_sjsr_AnonFunction1(((layer$2) => {
      var layer = $as_Lreactbuild_analyze_cost_modules_mapview_Layer(layer$2);
      return $ct_T2__O__O__(new $c_T2(), layer, $n(layer).render__Ltypings_ol_layerBaseMod$default())
    })));
    var this$43 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x16 = $n($n(p).Lreactbuild_analyze_cost_modules_MapLogic$Props__f_geolocation).Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_control;
    var $$x14 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$();
    var $$x13 = $i_ol$002fcontrol.ScaleLine;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ScaleLineOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var a = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ScaleLineUnits.METRIC);
    _\uff3fobj.units = a;
    var $$x12 = new $$x13(_\uff3fobj);
    var u = $n($$x14).apply__Ltypings_ol_controlControlMod$default__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x12);
    var this$26 = $n(u);
    var n = this$26.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x15 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var $$x11 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$();
    var $$x10 = $i_ol$002fcontrol.OverviewMap;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OverviewMapOptions);
    var fields$1 = $m_sci_Nil$();
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    var array$1 = [$m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$().render__Ltypings_ol_layerBaseMod$default()];
    var value = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var value$1 = [...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(value)];
    _\uff3fobj$1.layers = value$1;
    var $$x9 = new $$x10(_\uff3fobj$1);
    var u$1 = $n($$x11).apply__Ltypings_ol_controlControlMod$default__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x9);
    var this$38 = $n(u$1);
    var n$1 = this$38.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$2 = [$$x16, $$x15, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    return new $c_Lreactbuild_analyze_cost_modules_MapLogic$Init($$x17, $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$43, null, ns))
  }));
  var this$44 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(this$44);
  var this$66 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$45, initialState, step$1)));
  var deps = new $c_sjsr_AnonFunction7(((x$3$2, x$4$2, x$5$2, x$6$2, x$7$2, selection$2, init$2) => {
    $as_Lreactbuild_analyze_cost_modules_MapLogic$Props(x$3$2);
    $as_s_Option(x$4$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$5$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$6$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$7$2);
    var selection = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(selection$2);
    var init = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(init$2);
    return $ct_T2__O__O__(new $c_T2(), $n(selection).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, init)
  }));
  var effect = new $c_sjsr_AnonFunction7(((p$3$2, x$8$2, x$9$2, x$10$2, x$11$2, selection$3$2, init$3$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_MapLogic$Props(p$3$2);
    $as_s_Option(x$8$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$9$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$10$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$11$2);
    var selection$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(selection$3$2);
    var init$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(init$3$2);
    return new $c_sjsr_AnonFunction1(((x$12$2) => {
      $as_T2(x$12$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
        var this$46 = $n(init$3);
        return $n($as_Lreactbuild_analyze_cost_modules_MapLogic$Init(this$46.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])).getParcelSource__s_Option()
      })), new $c_sjsr_AnonFunction1(((source$2) => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
        var f = new $c_sjsr_AnonFunction0((() => {
          var selected = $as_sci_List($n(selection$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
          var features = source$2.getFeatures();
          var filteredFeatures = $m_sjs_js_ArrayOps$().filter$extension__sjs_js_Array__F1__sjs_js_Array(features, new $c_sjsr_AnonFunction1(((x$13$2) => {
            var value$2 = x$13$2.get("idu");
            var p$1 = new $c_sjsr_AnonFunction1(((idu$2) => {
              var idu = $as_T(idu$2);
              return $n(selected).exists__F1__Z(new $c_sjsr_AnonFunction1(((x$14$2) => {
                var x$14 = $as_Lreactbuild_analyze_cost_modules_mapview_Parcel(x$14$2);
                return ($n(x$14).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId === idu)
              })))
            }));
            return ((value$2 !== (void 0)) && $uZ(p$1.apply__O__O(value$2)))
          })));
          var $$x19 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$();
          var $$x18 = $n($n(p$3).Lreactbuild_analyze_cost_modules_MapLogic$Props__f_mapInteractionLayers).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_selected.getSource();
          var a$1 = $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), filteredFeatures));
          $n($$x19).updateFeatureList__Ltypings_ol_sourceVectorMod$default__sci_Seq__V($$x18, a$1)
        }));
        var f$1 = new $c_sjsr_AnonFunction0((() => {
          f.apply__O()
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
      }))))
    }))
  }));
  var a$2 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r = $m_Ljapgolly_scalajs_react_Reusability$().tuple2__F2__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_analyze_cost_modules_mapview_Parcel$().Lreactbuild_analyze_cost_modules_mapview_Parcel$__f_reusabilityParcel), $m_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$().reusability__F2__F2($m_Lreactbuild_analyze_cost_modules_MapLogic$Init$().Lreactbuild_analyze_cost_modules_MapLogic$Init$__f_reuseInit));
  var this$65 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6(this$65);
  var this$82 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$66, deps, effect, a$2, r, step$2)));
  var f$3 = new $c_sjsr_AnonFunction7(((p$4$2, mapOpt$2, areas$3$2, visibleLayers$3$2, showLegends$3$2, selectedParcels$2, init$4$2) => {
    var p$4 = $as_Lreactbuild_analyze_cost_modules_MapLogic$Props(p$4$2);
    var mapOpt = $as_s_Option(mapOpt$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(areas$3$2);
    var visibleLayers$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(visibleLayers$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(showLegends$3$2);
    var selectedParcels = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(selectedParcels$2);
    var init$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(init$4$2);
    var this$67 = $n(init$4);
    var memo = $as_Lreactbuild_analyze_cost_modules_MapLogic$Init(this$67.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    var this$68 = $n($m_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$().Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$__f_context);
    var $$x23 = $n($f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$68, selectedParcels));
    var this$77 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var u$2 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$().apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(memo).renderLayers__sci_List__Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__sci_List($as_sci_List($n(visibleLayers$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $n(p$4).Lreactbuild_analyze_cost_modules_MapLogic$Props__f_mapInteractionLayers));
    var this$70 = $n(u$2);
    var n$2 = this$70.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x22 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2);
    var $$x21 = $n(memo).Lreactbuild_analyze_cost_modules_MapLogic$Init__f_controls;
    var this$73 = $n(mapOpt);
    var ifEmpty = new $c_sjsr_AnonFunction0((() => $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom));
    var f$2 = new $c_sjsr_AnonFunction1(((map$2) => {
      var $$x20 = $n(p$4).Lreactbuild_analyze_cost_modules_MapLogic$Props__f_f;
      var this$72 = $n(init$4);
      return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($$x20).apply__O__O__O__O(this$72.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0], visibleLayers$3, map$2))
    }));
    var array$3 = [$$x22, $$x21, $as_Ljapgolly_scalajs_react_vdom_VdomNode((this$73.isEmpty__Z() ? ifEmpty.apply__O() : f$2.apply__O__O(this$73.get__O())))];
    var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    var array$4 = [$p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$77, null, ns$1)];
    return $n($$x23).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
  }));
  var this$81 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6(this$81);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$5 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$82, f$3, step$3, s);
  this.Lreactbuild_analyze_cost_modules_MapLogic$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$83, ev$5).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.MapLogic.component"))
}
$c_Lreactbuild_analyze_cost_modules_MapLogic$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_MapLogic$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_MapLogic$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_MapLogic$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_MapLogic$.prototype = $c_Lreactbuild_analyze_cost_modules_MapLogic$.prototype;
$c_Lreactbuild_analyze_cost_modules_MapLogic$.prototype.apply__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__F3__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(proxy, geolocation, mapInteractionLayers, f) {
  var c = this.Lreactbuild_analyze_cost_modules_MapLogic$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_MapLogic$Props(proxy, geolocation, mapInteractionLayers, f);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_MapLogic$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_MapLogic$: 0
}, false, "reactbuild.analyze.cost.modules.MapLogic$", {
  Lreactbuild_analyze_cost_modules_MapLogic$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_MapLogic$;
var $n_Lreactbuild_analyze_cost_modules_MapLogic$;
function $m_Lreactbuild_analyze_cost_modules_MapLogic$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_MapLogic$)) {
    $n_Lreactbuild_analyze_cost_modules_MapLogic$ = new $c_Lreactbuild_analyze_cost_modules_MapLogic$()
  };
  return $n_Lreactbuild_analyze_cost_modules_MapLogic$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Persons$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_Persons$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Persons$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Persons$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Persons$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Persons$.prototype = $c_Lreactbuild_analyze_cost_modules_Persons$.prototype;
$c_Lreactbuild_analyze_cost_modules_Persons$.prototype.apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement = (function(active) {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var $$x3 = $m_Lreactbuild_analyze_cost_ui_ItemDetailView$();
    var $$x2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var $$x1 = new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler($n(pageProps).Lreactbuild_package$PageProps__f_router);
    $m_Lreactbuild_model_Implicits$();
    var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u = $n($$x3).apply__Ldiode_react_ModelProxy__s_Option__Lreactbuild_analyze_cost_ui_ItemDetailViewHandler__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x2, active, $$x1, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$3.byRef__F2(), this$3.by_$eq$eq__F2()));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
var $d_Lreactbuild_analyze_cost_modules_Persons$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Persons$: 0
}, false, "reactbuild.analyze.cost.modules.Persons$", {
  Lreactbuild_analyze_cost_modules_Persons$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_Persons$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Persons$;
var $n_Lreactbuild_analyze_cost_modules_Persons$;
function $m_Lreactbuild_analyze_cost_modules_Persons$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_Persons$)) {
    $n_Lreactbuild_analyze_cost_modules_Persons$ = new $c_Lreactbuild_analyze_cost_modules_Persons$()
  };
  return $n_Lreactbuild_analyze_cost_modules_Persons$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Processing$() {
  this.Lreactbuild_analyze_cost_modules_Processing$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_Processing$ = this;
  var this$9 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Processing", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_Processing$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_Processing$State($m_Ldiode_data_Unavailable$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_Processing$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_Processing$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_Processing$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_analyze_cost_modules_Processing$State__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lreactbuild_analyze_cost_modules_Processing$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    var $$x5 = $as_Lreactbuild_analyze_cost_modules_Processing$Backend($n(c).backend__O());
    var this$6 = $n(c);
    var $$x4 = $as_Lreactbuild_analyze_cost_modules_Processing$Props($n(this$6.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var $$x3 = $as_Lreactbuild_analyze_cost_modules_Processing$Props($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps);
    var this$7 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).onPropsChange__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_analyze_cost_modules_Processing$State__Ljapgolly_scalajs_react_callback_Trampoline($$x4, $$x3, $as_Lreactbuild_analyze_cost_modules_Processing$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$7))))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$16 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$9, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G));
  var f$1 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(c$3$2);
    var $$x8 = $as_Lreactbuild_analyze_cost_modules_Processing$Backend($n(c$3).backend__O());
    var this$10 = $n(c$3);
    var qual$1 = $as_Lreactbuild_analyze_cost_modules_Processing$Props($n(this$10.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var x$1 = $m_s_None$();
    var this$11 = $n(qual$1);
    var x$2$1 = this$11.Lreactbuild_analyze_cost_modules_Processing$Props__f_pageProps;
    $n(qual$1);
    var $$x7 = new $c_Lreactbuild_analyze_cost_modules_Processing$Props(x$2$1, x$1);
    var this$13 = $n(c$3);
    var $$x6 = $as_Lreactbuild_analyze_cost_modules_Processing$Props($n(this$13.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$14 = $n(c$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x8).onPropsChange__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_analyze_cost_modules_Processing$State__Ljapgolly_scalajs_react_callback_Trampoline($$x7, $$x6, $as_Lreactbuild_analyze_cost_modules_Processing$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$14))))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$20 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$16, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1));
  var x$4 = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(\u03b4$2);
    var this$17 = $n(\u03b4);
    return $n($as_Lreactbuild_analyze_cost_modules_Processing$Backend($f_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot__backend__O(this$17))).onKeyDown__F1()
  }));
  var x$5 = new $c_sjsr_AnonFunction1(((x$8$2) => {
    $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$8$2);
    return window
  }));
  var f$2 = $m_Ljapgolly_scalajs_react_extra_EventListenerF$OfEventType$().install$extension__Z__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(true, "keydown", x$4, x$5, false, $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  this.Lreactbuild_analyze_cost_modules_Processing$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$2).apply__O__O(this$20))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_Processing$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Processing$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Processing$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Processing$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Processing$.prototype = $c_Lreactbuild_analyze_cost_modules_Processing$.prototype;
$c_Lreactbuild_analyze_cost_modules_Processing$.prototype.apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement = (function(ref) {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_modules_Processing$().Lreactbuild_analyze_cost_modules_Processing$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_modules_Processing$Props(pageProps, ref);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
var $d_Lreactbuild_analyze_cost_modules_Processing$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Processing$: 0
}, false, "reactbuild.analyze.cost.modules.Processing$", {
  Lreactbuild_analyze_cost_modules_Processing$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_Processing$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Processing$;
var $n_Lreactbuild_analyze_cost_modules_Processing$;
function $m_Lreactbuild_analyze_cost_modules_Processing$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_Processing$)) {
    $n_Lreactbuild_analyze_cost_modules_Processing$ = new $c_Lreactbuild_analyze_cost_modules_Processing$()
  };
  return $n_Lreactbuild_analyze_cost_modules_Processing$
}
function $p_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$__loop$1__sci_List__Z__I__D__sc_Iterator__Z__Z__Z($thiz, distinctPriceList, isDescending, lineCount, lastPrice, ite$1, hideFixedPriceLines$1, hideDescendingPriceLines$1) {
  while ($n(ite$1).hasNext__Z()) {
    var next = $n($n($as_Lreactbuild_model_PriceEvolutionProductEntry($n(ite$1).next__O())).Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice).Lreactbuild_model_Price__f_amount;
    var isDistinct = (hideFixedPriceLines$1 && (!$n(distinctPriceList).contains__O__Z(next)));
    if (isDistinct) {
      var this$1 = $n(distinctPriceList);
      var temp$distinctPriceList = new $c_sci_$colon$colon(next, this$1)
    } else {
      var temp$distinctPriceList = distinctPriceList
    };
    var temp$isDescending = ((!hideDescendingPriceLines$1) || (isDescending && (next <= lastPrice)));
    var temp$lineCount = ((1 + lineCount) | 0);
    distinctPriceList = temp$distinctPriceList;
    isDescending = temp$isDescending;
    lineCount = temp$lineCount;
    lastPrice = next
  };
  return (((!hideFixedPriceLines$1) || ($n(distinctPriceList).length__I() > 1)) && ((!hideDescendingPriceLines$1) || (!isDescending)))
}
function $p_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$__linkTo$1__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_vdom_TagOf($thiz, page, router$1) {
  return $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$()).toNewWindow__T__Z__Z__Ljapgolly_scalajs_react_vdom_TagOf($n($n(router$1).urlFor__O__Ljapgolly_scalajs_react_extra_router_AbsUrl(new $c_Lreactbuild_Loc$Processing(new $c_s_Some(page)))).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value, ($n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$()), true), ($n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$()), false))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype = $c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype;
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype.keep__Z__Z__F1 = (function(hideFixedPriceLines, hideDescendingPriceLines) {
  return (((!hideFixedPriceLines) && (!hideDescendingPriceLines)) ? new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Lreactbuild_model_PriceEvolutionProduct(x$1$2);
    return true
  })) : new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_model_PriceEvolutionProduct(v$2);
    var ite = $n($n(v).Lreactbuild_model_PriceEvolutionProduct__f_events).iterator__sc_Iterator();
    if ($n(ite).hasNext__Z()) {
      var next = $n($n($as_Lreactbuild_model_PriceEvolutionProductEntry($n(ite).next__O())).Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice).Lreactbuild_model_Price__f_amount;
      $n($m_s_package$().s_package$__f_List);
      var array = [next];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $p_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$__loop$1__sci_List__Z__I__D__sc_Iterator__Z__Z__Z(this, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), true, 1, next, ite, hideFixedPriceLines, hideDescendingPriceLines)
    } else {
      return false
    }
  })))
});
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype.apply__Ljava_time_LocalDate__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Lreactbuild_person_Person__Z__Z__Z__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf = (function(from, router, person, hideFixedPriceLines, hideDescendingPriceLines, showOnlyReferencePrice, r, proxy) {
  var this$3 = $n($as_sci_List($m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O(proxy, new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_model_CommonData(x$2$2);
    return $n(x$2).Lreactbuild_model_CommonData__f_products
  })), new $c_Lreactbuild_package$DefaultCommonData$$anon$1())));
  var p = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_model_Product(x$3$2);
    var x = $n(x$3).Lreactbuild_model_Product__f_supplier;
    var x$2$1 = $n(person).Lreactbuild_person_Person__f__id;
    return ((x === null) ? (x$2$1 === null) : $n(x).equals__O__Z(x$2$1))
  }));
  var products = $p_sci_List__filterCommon__F1__Z__sci_List(this$3, p, false);
  var list = $as_sci_List($n(r).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var $$x81 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$6 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_crossedTable;
  var $$x33 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
  var $$x32 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$1);
  var $$x31 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x28 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Libell\u00e9")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("8em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x26 = $n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x24 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Corps d'\u00e9tat");
  var $$x23 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("15em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$34 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
  var array$2 = [$$x24, $$x23, $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$34, s$2)];
  var $$x22 = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Evolution du prix"))];
  var $$x20 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Diff\u00e9rence de prix")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("3em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x18 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x16 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Quantit\u00e9 restante");
  var $$x15 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$58 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
  var array$5 = [$$x16, $$x15, $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$58, s$3)];
  var $$x14 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Unit\u00e9")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x12 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Document"))];
  var $$x10 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$8 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x8 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$9 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Quantit\u00e9")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("3em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$10 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix unitaire")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$11 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Montant")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x2 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$12 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Origine"))];
  var array$13 = [$$x28, $$x26, $$x22, $$x20, $$x18, $$x14, $$x12, $$x10, $$x8, $$x6, $$x4, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  var array$14 = [$n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
  var array$29 = [$$x33, $$x32, $n($$x31).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14)), $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), list), new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_model_PriceEvolutionProduct(v$2);
    var rows = (showOnlyReferencePrice ? 1 : ((1 + $n($n(v).Lreactbuild_model_PriceEvolutionProduct__f_events).length__I()) | 0));
    var $$x80 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$132 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var cond = $uZ($n($m_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$().keep__Z__Z__F1(hideFixedPriceLines, hideDescendingPriceLines)).apply__O__O(v));
    var t = new $c_sjsr_AnonFunction0((() => {
      var this$131 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var $$x78 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "opacity")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0.25", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var this$127 = $m_Lscalacss_ScalaCssReact$();
      var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
      var array$15 = [$$x78, $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$127, s$4)];
      var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
      return this$131.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
    }));
    var $$x79 = this$132.when__Z__F0__Ljapgolly_scalajs_react_vdom_TagMod((!cond), t);
    var $$x77 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x76 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$139 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rowSpan");
    var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x75 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$139.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, rows);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = $n(v).Lreactbuild_model_PriceEvolutionProduct__f__id;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$16 = [$$x75, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    var $$x74 = $n($$x76).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
    var $$x73 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$149 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rowSpan");
    var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x72 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$149.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, rows);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$151 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x71 = this$151.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("left", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$3 = $n(v).Lreactbuild_model_PriceEvolutionProduct__f_description;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$17 = [$$x72, $$x71, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
    var $$x70 = $n($$x73).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17));
    var $$x69 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$161 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rowSpan");
    var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x67 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$161.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, rows);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$163 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x66 = this$163.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("left", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$164 = $m_Lscalacss_ScalaCssReact$();
    var s$5 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
    var $$x65 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$164, s$5);
    var productOpt = $n(products).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lreactbuild_model_Product(x$4$2);
      return ($n(x$4).Lreactbuild_model_Product__f_reference === $n(v).Lreactbuild_model_PriceEvolutionProduct__f__id)
    })));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Corps d'\u00e9tat associ\u00e9");
    var $$x61 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var this$167 = $n(productOpt);
    var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lreactbuild_model_Product(x$5$2);
      return $n(x$5).Lreactbuild_model_Product__f_buildingPart
    }));
    var value = (this$167.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f.apply__O__O(this$167.get__O())));
    var state = $n($$x61).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x62;
        var p2 = $as_s_Option(x1.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$1 = $m_s_None$();
        if ((x$1 === p2)) {
          var $$x62 = cb;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1.T2__f__1);
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var i = $as_s_Option($n(x5).s_Some__f_value);
          var this$179 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var cond$1 = ($n(productOpt).isEmpty__Z() && $n(i).isEmpty__Z());
          var c = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).confirm__T__Ljapgolly_scalajs_react_callback_Trampoline("Souhaitez-vous mettre \u00e0 jour toutes les lignes de d\u00e9tails des documents ayant cette r\u00e9f\u00e9rence de produit ?"), new $c_sjsr_AnonFunction1(((withUpdate$2) => {
            var withUpdate = $uZ(withUpdate$2);
            var $$x63 = $n(proxy);
            var this$176 = $n(productOpt);
            var ifEmpty = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_model_Product(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())), $n(person).Lreactbuild_person_Person__f_organization, $n(v).Lreactbuild_model_PriceEvolutionProduct__f__id, $n(v).Lreactbuild_model_PriceEvolutionProduct__f_description, $n(person).Lreactbuild_person_Person__f__id, i)));
            var f$1 = new $c_sjsr_AnonFunction1(((x$6$2) => {
              var x$6 = $as_Lreactbuild_model_Product(x$6$2);
              var this$170 = $n(x$6);
              var x$2$3 = this$170.Lreactbuild_model_Product__f__id;
              var this$171 = $n(x$6);
              var x$3$1 = this$171.Lreactbuild_model_Product__f_organization;
              var this$172 = $n(x$6);
              var x$4$1 = this$172.Lreactbuild_model_Product__f_reference;
              var this$173 = $n(x$6);
              var x$5$1 = this$173.Lreactbuild_model_Product__f_name;
              var this$174 = $n(x$6);
              var x$6$2$1 = this$174.Lreactbuild_model_Product__f_supplier;
              $n(x$6);
              return new $c_Lreactbuild_model_Product(x$2$3, x$3$1, x$4$1, x$5$1, x$6$2$1, i)
            }));
            var this$ = $n($$x63).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_analyze_cost_actions_PersistProduct(withUpdate, $as_Lreactbuild_model_Product((this$176.isEmpty__Z() ? ifEmpty.apply__O() : f$1.apply__O__O(this$176.get__O())))), $m_Ldiode_Action$aType$());
            var f$2 = new $c_sjsr_AnonFunction1(((x$7$2) => {
              $as_jl_Void(x$7$2)
            }));
            var this$178 = $n(this$);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$178, f$2))
          }))))));
          var $$x62 = this$179.when__Z__F0__Ljapgolly_scalajs_react_callback_Trampoline((!cond$1), c);
          break matchEnd7
        };
        throw new $c_s_MatchError(x1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x62)
    })));
    var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var this$182 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var organization = $m_s_None$();
    var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$16(this$182, proxy, organization);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$184 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var organization$1 = $m_s_None$();
    var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$16(this$184, proxy, organization$1);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$188 = $m_Lreactbuild_model_Implicits$();
    var this$187 = $m_Lreactbuild_model_Implicits$();
    var ev = $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$187, proxy);
    var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$188, ev);
    var $$x64 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$1, explainError, equiv);
    var $$x60 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$190 = $n($n($n(v).Lreactbuild_model_PriceEvolutionProduct__f_events).flatMap__F1__sci_List(new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_Lreactbuild_model_PriceEvolutionProductEntry(x$8$2);
      return $n(x$8).Lreactbuild_model_PriceEvolutionProductEntry__f_buildingPart
    }))));
    var as = $as_sc_IterableOnce($f_sc_SeqOps__distinct__O(this$190));
    var array$19 = [$$x67, $$x66, $$x65, $$x64, $n($$x60).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((ref$2) => {
      var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
      var $$x68 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$194 = $m_Lreactbuild_model_Implicits$();
      var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$194, proxy);
      var v$4 = $n(ev$2).stringify__O__T(ref);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$18 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
      return $n($$x68).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))
    })))];
    var $$x59 = $n($$x69).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19));
    var $$x58 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$208 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rowSpan");
    var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x57 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$208.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, rows);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$210 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x56 = this$210.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("left", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$219 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var t$5 = new $c_sjsr_AnonFunction0((() => {
      var $$x54 = $m_Lreactbuild_analyze_cost_ui_GraphOverTime$();
      var this$211 = $m_Ljava_time_LocalDate$();
      var u = $n($$x54).apply__I__I__Lcom_iz2use_common_TypedRange__sc_Iterable__F1__F1__F1__s_math_Numeric__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(300, 50, new $c_Lcom_iz2use_common_TypedRange(from, this$211.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId())), $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering), $n(v).Lreactbuild_model_PriceEvolutionProduct__f_events, new $c_sjsr_AnonFunction1(((x$9$2) => {
        var x$9 = $as_Lreactbuild_model_PriceEvolutionProductEntry(x$9$2);
        return $n(x$9).Lreactbuild_model_PriceEvolutionProductEntry__f_date
      })), new $c_sjsr_AnonFunction1(((x$10$2) => {
        var x$10 = $as_Lreactbuild_model_PriceEvolutionProductEntry(x$10$2);
        return $n($n(x$10).Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice).Lreactbuild_model_Price__f_amount
      })), new $c_sjsr_AnonFunction1(((v$2$1) => {
        var v$5 = $as_Lreactbuild_model_PriceEvolutionProductEntry(v$2$1);
        return new $c_sjsr_AnonFunction1(((x$11$2) => {
          var x$11 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(x$11$2);
          var $$x55 = $n($p_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$__linkTo$1__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_vdom_TagOf(this, $n(v$5).Lreactbuild_model_PriceEvolutionProductEntry__f_invoicePage, router));
          var array$20 = [x$11];
          return $n($$x55).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20))
        }))
      })), $m_s_math_Numeric$DoubleIsFractional$());
      var this$217 = $n(u);
      var n = this$217.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    }));
    var array$21 = [$$x57, $$x56, this$219.when__Z__F0__Ljapgolly_scalajs_react_vdom_TagMod((!showOnlyReferencePrice), t$5)];
    var $$x53 = $n($$x58).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21));
    var $$x52 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$227 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rowSpan");
    var t$6 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x51 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$6, this$227.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, rows);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$229 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x50 = this$229.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$237 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var t$7 = new $c_sjsr_AnonFunction0((() => {
      var unitPriceBase = $m_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$().unitPrice__Lreactbuild_model_PriceEvolutionProductEntry__D($as_Lreactbuild_model_PriceEvolutionProductEntry($n($m_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$().bestPrice__sci_List__Ljava_time_LocalDate__s_Option($n(v).Lreactbuild_model_PriceEvolutionProduct__f_events, from)).get__O()));
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$233 = $n($n(v).Lreactbuild_model_PriceEvolutionProduct__f_events);
      var op = new $c_sjsr_AnonFunction2(((acc$2, c$2) => {
        var acc = $uD(acc$2);
        var c$1 = $as_Lreactbuild_model_PriceEvolutionProductEntry(c$2);
        var this$231 = $n($n(c$1).Lreactbuild_model_PriceEvolutionProductEntry__f_quantity);
        var p$1 = new $c_sjsr_AnonFunction1(((x$12$2) => {
          $uD(x$12$2);
          var x$13 = $n(c$1).Lreactbuild_model_PriceEvolutionProductEntry__f_category;
          var x$2$4 = $m_Lreactbuild_model_DocumentCategory$Invoice$();
          if ((x$13 !== null)) {
            var this$230 = $n(x$13);
            return (this$230 === x$2$4)
          } else {
            return false
          }
        }));
        var this$232 = $n(((this$231.isEmpty__Z() || $uZ(p$1.apply__O__O(this$231.get__O()))) ? this$231 : $m_s_None$()));
        var ifEmpty$1 = new $c_sjsr_AnonFunction0((() => 0.0));
        var f$3 = new $c_sjsr_AnonFunction1(((qty$2) => {
          var qty = $uD(qty$2);
          return ((($n($n(c$1).Lreactbuild_model_PriceEvolutionProductEntry__f_amount).Lreactbuild_model_Price__f_amount / qty) - unitPriceBase) * qty)
        }));
        return (acc + $uD((this$232.isEmpty__Z() ? ifEmpty$1.apply__O() : f$3.apply__O__O(this$232.get__O()))))
      }));
      var v$6 = new $c_Lreactbuild_model_Price($uD($f_sc_LinearSeqOps__foldLeft__O__F2__O(this$233, 0.0, op)));
      var ev$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var v$7 = $n(ev$3).stringify__O__T(v$6);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)
    }));
    var array$22 = [$$x51, $$x50, this$237.when__Z__F0__Ljapgolly_scalajs_react_vdom_TagMod((!showOnlyReferencePrice), t$7)];
    var $$x49 = $n($$x52).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22));
    var $$x48 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$245 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rowSpan");
    var t$8 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x47 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$8, this$245.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, rows);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$247 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x46 = this$247.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$248 = $m_Lscalacss_ScalaCssReact$();
    var s$6 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
    var $$x45 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$248, s$6);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$252 = $n($n(v).Lreactbuild_model_PriceEvolutionProduct__f_events);
    var op$1 = new $c_sjsr_AnonFunction2(((acc$2$1, c$2$1) => {
      var acc$1 = $uD(acc$2$1);
      var c$3 = $as_Lreactbuild_model_PriceEvolutionProductEntry(c$2$1);
      var this$250 = $n($n(c$3).Lreactbuild_model_PriceEvolutionProductEntry__f_quantity);
      var p$2 = new $c_sjsr_AnonFunction1(((x$13$2) => {
        $uD(x$13$2);
        var x$14 = $n(c$3).Lreactbuild_model_PriceEvolutionProductEntry__f_category;
        var x$2$5 = $m_Lreactbuild_model_DocumentCategory$Invoice$();
        if ((x$14 !== null)) {
          var this$249 = $n(x$14);
          return (this$249 === x$2$5)
        } else {
          return false
        }
      }));
      var this$251 = $n(((this$250.isEmpty__Z() || $uZ(p$2.apply__O__O(this$250.get__O()))) ? this$250 : $m_s_None$()));
      var default$1 = new $c_sjsr_AnonFunction0((() => 0.0));
      return (acc$1 + $uD((this$251.isEmpty__Z() ? default$1.apply__O() : this$251.get__O())))
    }));
    var v$8 = $f_sc_LinearSeqOps__foldLeft__O__F2__O(this$252, 0.0, op$1);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var v$9 = $n(parsable).stringify__O__T(v$8);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$23 = [$$x47, $$x46, $$x45, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$9)];
    var $$x44 = $n($$x48).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23));
    var $$x43 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$264 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rowSpan");
    var t$9 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x42 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$9, this$264.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, rows);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$266 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x41 = this$266.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("left", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$10 = $n(v).Lreactbuild_model_PriceEvolutionProduct__f_unit;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$4 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
    var v$11 = ev$4.stringify__s_Option__T(v$10);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$24 = [$$x42, $$x41, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$11)];
    var $$x40 = $n($$x43).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24));
    if ((showOnlyReferencePrice === false)) {
      var $$x38 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$279 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
      var t$10 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
      var array$25 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$10, this$279.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 6)];
      var $$x37 = $n($$x38).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25))
    } else if ((showOnlyReferencePrice === true)) {
      var $$x39 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as$1 = $m_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$().renderEvents__sci_List__F1__Ldiode_react_ModelProxy__sci_List($n($m_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$().bestPrice__sci_List__Ljava_time_LocalDate__s_Option($n(v).Lreactbuild_model_PriceEvolutionProduct__f_events, from)).toList__sci_List(), new $c_sjsr_AnonFunction1(((page$2) => {
        var page = $as_Lreactbuild_common_model_RefTo(page$2);
        return $p_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$__linkTo$1__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_vdom_TagOf(this, page, router)
      })), proxy);
      var this$285 = $m_s_$less$colon$less$();
      var $$x37 = $n($$x39).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, this$285.s_$less$colon$less$__f_singleton)
    } else {
      var $$x37;
      throw new $c_s_MatchError(showOnlyReferencePrice)
    };
    var array$26 = [$$x74, $$x70, $$x59, $$x53, $$x49, $$x44, $$x40, $$x37];
    var $$x36 = $n($$x77).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$26));
    var this$295 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var t$11 = new $c_sjsr_AnonFunction0((() => {
      var $$x34 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as$2 = $m_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$().renderEvents__sci_List__F1__Ldiode_react_ModelProxy__sci_List($n(v).Lreactbuild_model_PriceEvolutionProduct__f_events, new $c_sjsr_AnonFunction1(((page$2$1) => {
        var page$1 = $as_Lreactbuild_common_model_RefTo(page$2$1);
        return $p_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$__linkTo$1__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_vdom_TagOf(this, page$1, router)
      })), proxy);
      return $n($$x34).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$2, new $c_sjsr_AnonFunction1(((x$14$2) => {
        var x$14$1 = $as_Ljapgolly_scalajs_react_vdom_VdomElement(x$14$2);
        var $$x35 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$27 = [x$14$1];
        return $n($$x35).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$27))
      })))
    }));
    var array$28 = [$$x79, $$x36, this$295.when__Z__F0__Ljapgolly_scalajs_react_vdom_TagMod((!showOnlyReferencePrice), t$11)];
    return $n($$x80).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$28))
  })))];
  return $n($$x81).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$29))
});
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype.unitPrice__Lreactbuild_model_PriceEvolutionProductEntry__D = (function(v) {
  var this$1 = $n($n(v).Lreactbuild_model_PriceEvolutionProductEntry__f_quantity);
  if (this$1.isEmpty__Z()) {
    return $n($n(v).Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice).Lreactbuild_model_Price__f_amount
  } else {
    var arg1 = this$1.get__O();
    var qty = $uD(arg1);
    return ($n($n(v).Lreactbuild_model_PriceEvolutionProductEntry__f_amount).Lreactbuild_model_Price__f_amount / qty)
  }
});
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype.bestPrice__sci_List__Ljava_time_LocalDate__s_Option = (function(events, from) {
  var this$1 = $n($n(events).reverse__sci_List());
  var pf = new $c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1(from);
  var this$2 = $n($f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this$1, pf));
  if (this$2.isEmpty__Z()) {
    var $$x1 = $m_s_Option$();
    var this$4 = $n(events);
    var f = ((e$2) => {
      var e = $as_Lreactbuild_model_PriceEvolutionProductEntry(e$2);
      return ($n(from).compareTo__Ljava_time_chrono_ChronoLocalDate__I($n(e).Lreactbuild_model_PriceEvolutionProductEntry__f_date) <= 0)
    });
    var l = this$4;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break
        } else {
          var h = $n(l).head__O();
          var t = $as_sci_List($n(l).tail__O());
          if (($uZ(f(h)) === false)) {
            l = t;
            continue
          };
          var start = l;
          var remaining = t;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block
            } else {
              var x = $n(remaining).head__O();
              if (($uZ(f(x)) !== false)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue
              };
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O())
              };
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f(head)) !== false)) {
                  next = $as_sci_List($n(next).tail__O())
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                  };
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O())
                }
              };
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy
              };
              var result = newHead;
              break block
            }
          }
        }
      }
    };
    var this$5 = $n(result);
    var f$1 = new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_Lreactbuild_model_PriceEvolutionProductEntry(v$2);
      return $m_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$().unitPrice__Lreactbuild_model_PriceEvolutionProductEntry__D(v)
    }));
    var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
    return $n($$x1).apply__O__s_Option($f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O(this$5, f$1, ord))
  } else {
    return this$2
  }
});
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype.renderEvents__sci_List__F1__Ldiode_react_ModelProxy__sci_List = (function(events, linkTo, proxy) {
  var this$90 = $n(events);
  var f = ((ev$2) => {
    var ev = $as_Lreactbuild_model_PriceEvolutionProductEntry(ev$2);
    var this$89 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$5 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x25 = this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("left", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$6 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
    var $$x24 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x23 = $as_Ljapgolly_scalajs_react_vdom_TagOf($n(linkTo).apply__O__O($n(ev).Lreactbuild_model_PriceEvolutionProductEntry__f_invoicePage));
    var this$20 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v = $n(ev).Lreactbuild_model_PriceEvolutionProductEntry__f_category;
    var ev$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    var v$1 = $n(ev$1).stringify__O__T(v);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x22 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x21 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$2 = $n(ev).Lreactbuild_model_PriceEvolutionProductEntry__f_reference;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$3 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
    var v$3 = ev$3.stringify__s_Option__T(v$2);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x22, $$x21, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
    var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var array$1 = [this$20.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)];
    var array$2 = [$$x25, $$x24, $n($$x23).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    var $$x20 = $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$30 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x18 = this$30.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$31 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
    var $$x17 = this$31.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$4 = $n(ev).Lreactbuild_model_PriceEvolutionProductEntry__f_date;
    var ev$4 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
    var v$5 = $n(ev$4).stringify__O__T(v$4);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$3 = [$$x18, $$x17, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
    var $$x16 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$41 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x14 = this$41.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$42 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
    var $$x13 = this$42.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$6 = $n(ev).Lreactbuild_model_PriceEvolutionProductEntry__f_quantity;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var ev$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
    var v$7 = ev$5.stringify__s_Option__T(v$6);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$4 = [$$x14, $$x13, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)];
    var $$x12 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$54 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x10 = this$54.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$55 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
    var $$x9 = this$55.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$8 = $n(ev).Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice;
    var ev$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var v$9 = $n(ev$6).stringify__O__T(v$8);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$5 = [$$x10, $$x9, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$9)];
    var $$x8 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$65 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x6 = this$65.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$66 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
    var $$x5 = this$66.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$10 = $n(ev).Lreactbuild_model_PriceEvolutionProductEntry__f_amount;
    var ev$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var v$11 = $n(ev$7).stringify__O__T(v$10);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$6 = [$$x6, $$x5, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$11)];
    var $$x4 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$76 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x2 = this$76.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("left", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$77 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
    var $$x1 = this$77.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$12 = $n(ev).Lreactbuild_model_PriceEvolutionProductEntry__f_supplier;
    $m_Lcom_iz2use_common_Textualizable$();
    var this$78 = $m_Lreactbuild_model_Implicits$();
    var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$78, proxy);
    var ev$8 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
    var v$13 = ev$8.stringify__s_Option__T(v$12);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$7 = [$$x2, $$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$13)];
    var array$8 = [$$x20, $$x16, $$x12, $$x8, $$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$89, null, ns)
  });
  if ((this$90 === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var arg1 = this$90.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$90.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    return h
  }
});
var $d_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$: 0
}, false, "reactbuild.analyze.cost.modules.ProductPriceEvolutions$", {
  Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$;
var $n_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$;
function $m_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$)) {
    $n_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$ = new $c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$
}
function $p_Lreactbuild_analyze_cost_modules_Projects$__activeProject$1__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($thiz, dsl$1) {
  return $n($m_Lreactbuild_analyze_cost_RouterConfigCommon$().refTo__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(dsl$1)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB()
}
function $p_Lreactbuild_analyze_cost_modules_Projects$__view$2__T__F1__s_reflect_ClassTag__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_RoutingRule($thiz, name, target, ct, dsl$1) {
  var $$x4 = $n(dsl$1);
  var $$x3 = $p_Lreactbuild_analyze_cost_modules_Projects$__activeProject$1__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($thiz, dsl$1);
  $n(dsl$1);
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(name);
  var this$2 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var $$x1 = $n($n($$x3).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x2, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed__Ato___Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$2))).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(target, new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView(x$1$2);
    return $n(x$1).active__s_Option()
  })));
  var this$5 = $m_s_$less$colon$less$();
  var this$ = $n($$x4).dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1($n(dsl$1)._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x1, this$5.s_$less$colon$less$__f_singleton), ct);
  var $$x6 = $n(dsl$1);
  var $$x5 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView(x$2$2);
    return $m_Lreactbuild_analyze_cost_modules_Projects$().apply__Lreactbuild_analyze_cost_modules_project_ProjectView__Ljapgolly_scalajs_react_vdom_VdomElement(x$2)
  }));
  var this$7 = $m_s_$less$colon$less$();
  var g = $n($$x6).dynRender__F1__F1__F1($$x5, this$7.s_$less$colon$less$__f_singleton);
  return $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$).apply__O__O(g))
}
function $p_Lreactbuild_analyze_cost_modules_Projects$__withSubprojectsRule$1__T__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($thiz, name, dsl$1) {
  var $$x2 = $n($p_Lreactbuild_analyze_cost_modules_Projects$__activeProject$1__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($thiz, dsl$1));
  var this$7 = $n(($n(dsl$1), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(name)));
  var next = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($n(($n(dsl$1), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("-withSubprojects"))).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB()).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_s_Option(x$3$2);
    var this$4 = $n(x$3);
    return (!this$4.isEmpty__Z())
  })), new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $uZ(x$4$2);
    return (x$4 ? new $c_s_Some((void 0)) : $m_s_None$())
  }))));
  var this$6 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$6);
  var this$8 = $n(c);
  var $$x1 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$8, this$7, next);
  var this$9 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  return $n($$x2).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x1, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLowest__$times$times$times__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$9))
}
function $p_Lreactbuild_analyze_cost_modules_Projects$__generatorRule$1__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($thiz, dsl$1) {
  var $$x2 = $n($p_Lreactbuild_analyze_cost_modules_Projects$__activeProject$1__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($thiz, dsl$1));
  var this$9 = $n(($n(dsl$1), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("generator")));
  var this$6 = $n(($n(dsl$1), $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().literal__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("-")));
  var next = $n($n(dsl$1).string__T__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB("[^/]+")).pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_T(v$2);
    var this$4 = $n($m_Lreactbuild_project_generator_DocumentType$().Lreactbuild_project_generator_DocumentType$__f_list);
    var these = this$4;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x$5 = $as_Lreactbuild_project_generator_DocumentType(arg1);
      if (($n(x$5).Lreactbuild_project_generator_DocumentType__f_id === v)) {
        return new $c_s_Some($n(these).head__O())
      };
      these = $as_sci_List($n(these).tail__O())
    };
    return $m_s_None$()
  })), new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Lreactbuild_project_generator_DocumentType(x$6$2);
    return $n(x$6).Lreactbuild_project_generator_DocumentType__f_id
  })));
  var this$5 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$5);
  var this$7 = $n(c);
  var next$1 = $n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$7, this$6, next)).option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB();
  var this$8 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$1 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$8);
  var this$10 = $n(c$1);
  var $$x1 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$10, this$9, next$1);
  var this$11 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  return $n($$x2).$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($$x1, $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLowest__$times$times$times__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$11))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Projects$() {
  this.Lreactbuild_analyze_cost_modules_Projects$__f_reuseProps = null;
  this.Lreactbuild_analyze_cost_modules_Projects$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_Projects$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_Ldiode_react_ModelProxy(x$11$2);
    var this$2 = $n(x$11);
    var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
    return $n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_commonData
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$4.byRef__F2(), this$4.by_$eq$eq__F2());
  $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  var this$6 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_Projects$__f_reuseProps = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$6.byRef__F2(), this$6.by_$eq$eq__F2());
  var this$1353 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).useCommonDataBy__F1__F1__Lreactbuild_package$DefaultCommonData__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12 = $as_Lreactbuild_analyze_cost_modules_Projects$Props(x$12$2);
    return $n($n(x$12).Lreactbuild_analyze_cost_modules_Projects$Props__f_pageProps).Lreactbuild_package$PageProps__f_proxy
  })), new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13 = $as_Lreactbuild_model_CommonData(x$13$2);
    return $n(x$13).Lreactbuild_model_CommonData__f_buildingSites
  })), new $c_Lreactbuild_package$DefaultCommonData$$anon$1(), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x4 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var $$x3 = new $c_sjsr_AnonFunction2(((p$2, s$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_Projects$Props(p$2);
    $as_Ljapgolly_scalajs_react_Reusable(s$2);
    return p
  }));
  var $$x2 = new $c_sjsr_AnonFunction2(((p$3$2, s$3$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_Projects$Props(p$3$2);
    $as_Ljapgolly_scalajs_react_Reusable(s$3$2);
    return new $c_sjsr_AnonFunction1(((x$14$2) => {
      $as_Lreactbuild_analyze_cost_modules_Projects$Props(x$14$2);
      return p$3
    }))
  }));
  var $$x1 = this.Lreactbuild_analyze_cost_modules_Projects$__f_reuseProps;
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$1352 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($$x4.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$12))));
  var f$12 = new $c_sjsr_AnonFunction3(((p$4$2, s$4$2, pRef$2) => {
    var p$4 = $as_Lreactbuild_analyze_cost_modules_Projects$Props(p$4$2);
    var s$4 = $as_Ljapgolly_scalajs_react_Reusable(s$4$2);
    var pRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(pRef$2);
    $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
    var f$1 = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x5;
        var p2 = $as_s_Option(x1.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x = $m_s_None$();
        if ((x === p2)) {
          var $$x5 = cb;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1.T2__f__1);
        var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4 instanceof $c_s_Some)) {
          var $$x5 = cb$2;
          break matchEnd7
        };
        throw new $c_s_MatchError(x1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x5)
    }));
    var update = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$1);
    $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
    var f$3 = new $c_sjsr_AnonFunction2(((x0$2$2, x1$2$2) => {
      var x0$2 = $as_s_Option(x0$2$2);
      var x1$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$3 = $ct_T2__O__O__(new $c_T2(), x0$2, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2));
      matchEnd7$1: {
        var $$x6;
        var p2$1 = $as_s_Option(x1$3.T2__f__1);
        var cb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$1 = $m_s_None$();
        if ((x$1 === p2$1)) {
          var $$x6 = cb$1;
          break matchEnd7$1
        };
        var p4$1 = $as_s_Option(x1$3.T2__f__1);
        var cb$2$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4$1 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4$1);
          var opt = $as_s_Option($n(x5).s_Some__f_value);
          var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var this$17 = $n($n($n(p$4).Lreactbuild_analyze_cost_modules_Projects$Props__f_pageProps).Lreactbuild_package$PageProps__f_router);
          var $$x7 = $n(p$4).Lreactbuild_analyze_cost_modules_Projects$Props__f_view;
          var this$16 = $n(opt);
          var f$2 = new $c_sjsr_AnonFunction1(((key$2) => {
            var key = $as_T(key$2);
            var this$15 = $m_Lcom_iz2use_common_package$();
            var name = new $c_Lcom_iz2use_common_KeyImports$RichKey(this$15, key).Lcom_iz2use_common_KeyImports$RichKey__f_key;
            return new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().fromString__T__ju_UUID(name))
          }));
          var route = new $c_Lreactbuild_Loc$Project($n($$x7).withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView((this$16.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$2.apply__O__O(this$16.get__O())))));
          var $$x6 = $n($$x8).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$17.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2$1);
          break matchEnd7$1
        };
        throw new $c_s_MatchError(x1$3)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x6)
    }));
    var active = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$3);
    $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
    var f$4 = new $c_sjsr_AnonFunction2(((x0$3$2, x1$3$2) => {
      var x0$3 = $as_s_Option(x0$3$2);
      var x1$3$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$4 = $ct_T2__O__O__(new $c_T2(), x0$3, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3$1));
      matchEnd7$2: {
        var $$x9;
        var p2$2 = $as_s_Option(x1$4.T2__f__1);
        var cb$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$4.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$2 = $m_s_None$();
        if ((x$2 === p2$2)) {
          var $$x9 = cb$3;
          break matchEnd7$2
        };
        var p4$2 = $as_s_Option(x1$4.T2__f__1);
        if ((p4$2 instanceof $c_s_Some)) {
          var x5$1 = $as_s_Some(p4$2);
          var opt$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView($n(x5$1).s_Some__f_value);
          var this$20 = $n($n($n(p$4).Lreactbuild_analyze_cost_modules_Projects$Props__f_pageProps).Lreactbuild_package$PageProps__f_router);
          var route$1 = new $c_Lreactbuild_Loc$Project($n(opt$1).withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView($n($n(p$4).Lreactbuild_analyze_cost_modules_Projects$Props__f_view).active__s_Option()));
          var $$x9 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$20.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route$1, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          break matchEnd7$2
        };
        throw new $c_s_MatchError(x1$4)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x9)
    }));
    var reuseView = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$4);
    var pageProps = $n(p$4).Lreactbuild_analyze_cost_modules_Projects$Props__f_pageProps;
    $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$().apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(reuseView, $n(p$4).Lreactbuild_analyze_cost_modules_Projects$Props__f_view, $m_Lreactbuild_analyze_cost_modules_RenderProject$().Lreactbuild_analyze_cost_modules_RenderProject$__f_reuseProjectView);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f$5 = new $c_sjsr_AnonFunction0((() => {
      var this$23 = $n(pRef);
      return $n($as_Lreactbuild_analyze_cost_modules_Projects$Props(this$23.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_Projects$Props__f_view
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var viewState = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$5);
    var $$x299 = $m_Lcom_iz2use_react_components_Multiview$();
    var $$x298 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
    var $$x297 = $n(s$4).value__O();
    var $$x296 = $m_Ljapgolly_scalajs_react_Reusability$();
    $m_Lreactbuild_model_Implicits$();
    var this$27 = $m_Ljapgolly_scalajs_react_Reusability$();
    var $$x295 = $n($$x298).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(update, $$x297, $n($$x296).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$27.byRef__F2(), this$27.by_$eq$eq__F2())));
    var $$x294 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
    var this$31 = $n($n($n(p$4).Lreactbuild_analyze_cost_modules_Projects$Props__f_view).active__s_Option());
    var f$6 = new $c_sjsr_AnonFunction1(((ref$2) => {
      var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
      var key$1 = $n($n(ref).Lreactbuild_common_model_RefTo__f_id).toString__T();
      return key$1
    }));
    var $$x293 = (this$31.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$6.apply__O__O(this$31.get__O())));
    var this$32 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = $m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_reuseKey;
    var $$x292 = $n($$x294).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(active, $$x293, this$32.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    var $$x291 = new $c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler();
    var this$34 = $m_s_Symbol$();
    var $$x287 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "_id"));
    var this$35 = $m_s_Symbol$();
    var $$x286 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "organizations"));
    var this$36 = $m_s_Symbol$();
    var $$x285 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "name"));
    var this$37 = $m_s_Symbol$();
    var $$x284 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "title"));
    var this$38 = $m_s_Symbol$();
    var $$x283 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "description"));
    var this$39 = $m_s_Symbol$();
    var $$x282 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "images"));
    var this$40 = $m_s_Symbol$();
    var $$x281 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "location"));
    var this$41 = $m_s_Symbol$();
    var $$x280 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "areas"));
    var this$42 = $m_s_Symbol$();
    var $$x279 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "price"));
    var this$43 = $m_s_Symbol$();
    var $$x278 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "soldOut"));
    var this$44 = $m_s_Symbol$();
    var $$x277 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "privacy"));
    var this$45 = $m_s_Symbol$();
    var $$x276 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "scenes"));
    var this$46 = $m_s_Symbol$();
    var $$x275 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "renderSettings"));
    var this$47 = $m_s_Symbol$();
    var $$x274 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "city"));
    var this$48 = $m_s_Symbol$();
    var $$x273 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "district"));
    var this$49 = $m_s_Symbol$();
    var $$x272 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "topic"));
    var this$50 = $m_s_Symbol$();
    var $$x271 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "modelSource"));
    var this$51 = $m_s_Symbol$();
    var $$x270 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "procedureState"));
    var this$52 = $m_s_Symbol$();
    var $$x269 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "summary"));
    var this$53 = $m_s_Symbol$();
    var $$x268 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "archived"));
    var this$54 = $m_s_Symbol$();
    var $$x267 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "parent"));
    var this$55 = $m_s_Symbol$();
    var $$x266 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "address"));
    var this$56 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x287, new $c_Lshapeless_$colon$colon($$x286, new $c_Lshapeless_$colon$colon($$x285, new $c_Lshapeless_$colon$colon($$x284, new $c_Lshapeless_$colon$colon($$x283, new $c_Lshapeless_$colon$colon($$x282, new $c_Lshapeless_$colon$colon($$x281, new $c_Lshapeless_$colon$colon($$x280, new $c_Lshapeless_$colon$colon($$x279, new $c_Lshapeless_$colon$colon($$x278, new $c_Lshapeless_$colon$colon($$x277, new $c_Lshapeless_$colon$colon($$x276, new $c_Lshapeless_$colon$colon($$x275, new $c_Lshapeless_$colon$colon($$x274, new $c_Lshapeless_$colon$colon($$x273, new $c_Lshapeless_$colon$colon($$x272, new $c_Lshapeless_$colon$colon($$x271, new $c_Lshapeless_$colon$colon($$x270, new $c_Lshapeless_$colon$colon($$x269, new $c_Lshapeless_$colon$colon($$x268, new $c_Lshapeless_$colon$colon($$x267, new $c_Lshapeless_$colon$colon($$x266, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "reference")), $m_Lshapeless_HNil$())))))))))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f$7 = new $c_sjsr_AnonFunction1(((x0$6$2) => {
      var x0$6 = $as_Lreactbuild_common_model_Project(x0$6$2);
      return new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f__id, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_organizations, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_name, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_title, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_description, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_images, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_location, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_areas, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_price, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_soldOut, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_privacy, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_scenes, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_renderSettings, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_city, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_district, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_topic, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_modelSource, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_procedureState, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_summary, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_archived, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_parent, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_address, new $c_Lshapeless_$colon$colon($n(x0$6).Lreactbuild_common_model_Project__f_reference, $m_Lshapeless_HNil$())))))))))))))))))))))))
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lshapeless_$colon$colon(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$25 = $as_Lreactbuild_common_model_RefTo($n(x0$7).Lshapeless_$colon$colon__f_head);
        var p2$3 = $as_Lshapeless_$colon$colon($n(x0$7).Lshapeless_$colon$colon__f_tail);
        if ((p2$3 !== null)) {
          var organizations$macro$26 = $as_sci_Seq($n(p2$3).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2$3).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$27 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4$3 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4$3 !== null)) {
              var title$macro$28 = $as_T($n(p4$3).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4$3).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var description$macro$29 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var images$macro$30 = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var location$macro$31 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var areas$macro$32 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var price$macro$33 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var soldOut$macro$34 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                          if ((p11 !== null)) {
                            var privacy$macro$35 = $as_s_Option($n(p11).Lshapeless_$colon$colon__f_head);
                            var p12 = $as_Lshapeless_$colon$colon($n(p11).Lshapeless_$colon$colon__f_tail);
                            if ((p12 !== null)) {
                              var scenes$macro$36 = $as_s_Option($n(p12).Lshapeless_$colon$colon__f_head);
                              var p13 = $as_Lshapeless_$colon$colon($n(p12).Lshapeless_$colon$colon__f_tail);
                              if ((p13 !== null)) {
                                var renderSettings$macro$37 = $as_s_Option($n(p13).Lshapeless_$colon$colon__f_head);
                                var p14 = $as_Lshapeless_$colon$colon($n(p13).Lshapeless_$colon$colon__f_tail);
                                if ((p14 !== null)) {
                                  var city$macro$38 = $as_s_Option($n(p14).Lshapeless_$colon$colon__f_head);
                                  var p15 = $as_Lshapeless_$colon$colon($n(p14).Lshapeless_$colon$colon__f_tail);
                                  if ((p15 !== null)) {
                                    var district$macro$39 = $as_s_Option($n(p15).Lshapeless_$colon$colon__f_head);
                                    var p16 = $as_Lshapeless_$colon$colon($n(p15).Lshapeless_$colon$colon__f_tail);
                                    if ((p16 !== null)) {
                                      var topic$macro$40 = $as_s_Option($n(p16).Lshapeless_$colon$colon__f_head);
                                      var p17 = $as_Lshapeless_$colon$colon($n(p16).Lshapeless_$colon$colon__f_tail);
                                      if ((p17 !== null)) {
                                        var modelSource$macro$41 = $as_s_Option($n(p17).Lshapeless_$colon$colon__f_head);
                                        var p18 = $as_Lshapeless_$colon$colon($n(p17).Lshapeless_$colon$colon__f_tail);
                                        if ((p18 !== null)) {
                                          var procedureState$macro$42 = $as_s_Option($n(p18).Lshapeless_$colon$colon__f_head);
                                          var p19 = $as_Lshapeless_$colon$colon($n(p18).Lshapeless_$colon$colon__f_tail);
                                          if ((p19 !== null)) {
                                            var summary$macro$43 = $as_s_Option($n(p19).Lshapeless_$colon$colon__f_head);
                                            var p20 = $as_Lshapeless_$colon$colon($n(p19).Lshapeless_$colon$colon__f_tail);
                                            if ((p20 !== null)) {
                                              var archived$macro$44 = $as_s_Option($n(p20).Lshapeless_$colon$colon__f_head);
                                              var p21 = $as_Lshapeless_$colon$colon($n(p20).Lshapeless_$colon$colon__f_tail);
                                              if ((p21 !== null)) {
                                                var parent$macro$45 = $as_s_Option($n(p21).Lshapeless_$colon$colon__f_head);
                                                var p22 = $as_Lshapeless_$colon$colon($n(p21).Lshapeless_$colon$colon__f_tail);
                                                if ((p22 !== null)) {
                                                  var address$macro$46 = $as_Lreactbuild_common_model_ProjectAddress($n(p22).Lshapeless_$colon$colon__f_head);
                                                  var p23 = $as_Lshapeless_$colon$colon($n(p22).Lshapeless_$colon$colon__f_tail);
                                                  if ((p23 !== null)) {
                                                    var reference$macro$47 = $as_T($n(p23).Lshapeless_$colon$colon__f_head);
                                                    var p24 = $as_Lshapeless_HNil($n(p23).Lshapeless_$colon$colon__f_tail);
                                                    var x$3 = $m_Lshapeless_HNil$();
                                                    if ((x$3 === p24)) {
                                                      return new $c_Lreactbuild_common_model_Project(_id$macro$25, organizations$macro$26, name$macro$27, title$macro$28, description$macro$29, images$macro$30, location$macro$31, areas$macro$32, price$macro$33, soldOut$macro$34, privacy$macro$35, scenes$macro$36, renderSettings$macro$37, city$macro$38, district$macro$39, topic$macro$40, modelSource$macro$41, procedureState$macro$42, summary$macro$43, archived$macro$44, parent$macro$45, address$macro$46, reference$macro$47)
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$7)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f$7, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$62 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "address"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$68 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "archived"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$71 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$71, "summary"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$74 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "procedureState"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$77 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$77, "modelSource"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$80 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "topic"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$83 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "district"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$86 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$86, "city"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$89 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$89, "renderSettings"));
    new $c_Lshapeless_Witness$$anon$1(value0$10);
    var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    $m_Lshapeless_Witness$();
    var this$92 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "scenes"));
    new $c_Lshapeless_Witness$$anon$1(value0$11);
    var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
    $m_Lshapeless_Witness$();
    var this$95 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$95, "privacy"));
    new $c_Lshapeless_Witness$$anon$1(value0$12);
    var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
    $m_Lshapeless_Witness$();
    var this$98 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$98, "soldOut"));
    new $c_Lshapeless_Witness$$anon$1(value0$13);
    var zipWithKeys$14 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
    $m_Lshapeless_Witness$();
    var this$101 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$101, "price"));
    new $c_Lshapeless_Witness$$anon$1(value0$14);
    var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
    $m_Lshapeless_Witness$();
    var this$104 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$104, "areas"));
    new $c_Lshapeless_Witness$$anon$1(value0$15);
    var zipWithKeys$16 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
    $m_Lshapeless_Witness$();
    var this$107 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$107, "location"));
    new $c_Lshapeless_Witness$$anon$1(value0$16);
    var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
    $m_Lshapeless_Witness$();
    var this$110 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$110, "images"));
    new $c_Lshapeless_Witness$$anon$1(value0$17);
    var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
    $m_Lshapeless_Witness$();
    var this$113 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$113, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$18);
    var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
    $m_Lshapeless_Witness$();
    var this$116 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$116, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$19);
    var zipWithKeys$20 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
    $m_Lshapeless_Witness$();
    var this$119 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$119, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$20);
    var zipWithKeys$21 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
    $m_Lshapeless_Witness$();
    var this$122 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$122, "organizations"));
    new $c_Lshapeless_Witness$$anon$1(value0$21);
    var zipWithKeys$22 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
    $m_Lshapeless_Witness$();
    var this$125 = $m_s_Symbol$();
    var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$125, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$22);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
    var this$128 = $m_s_$less$colon$less$();
    var ev = this$128.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    $m_Lshapeless_Witness$();
    var this$130 = $m_s_Symbol$();
    var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$130, "reference"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$23);
    var tailToMap = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk);
    var keyLub = new $c_Lshapeless_Lub$$anon$4();
    var valueLub = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$135 = $m_s_Symbol$();
    var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$135, "address"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$24);
    var tailToMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap, keyLub, valueLub, wk$1);
    var keyLub$1 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$1 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$140 = $m_s_Symbol$();
    var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$140, "parent"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$25);
    var tailToMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$2);
    var keyLub$2 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$2 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$145 = $m_s_Symbol$();
    var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$145, "archived"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$26);
    var tailToMap$3 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$2, keyLub$2, valueLub$2, wk$3);
    var keyLub$3 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$3 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$150 = $m_s_Symbol$();
    var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$150, "summary"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$27);
    var tailToMap$4 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$3, keyLub$3, valueLub$3, wk$4);
    var keyLub$4 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$4 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$155 = $m_s_Symbol$();
    var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$155, "procedureState"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$28);
    var tailToMap$5 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$4, keyLub$4, valueLub$4, wk$5);
    var keyLub$5 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$5 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$160 = $m_s_Symbol$();
    var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$160, "modelSource"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$29);
    var tailToMap$6 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$5, keyLub$5, valueLub$5, wk$6);
    var keyLub$6 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$6 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$165 = $m_s_Symbol$();
    var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$165, "topic"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$30);
    var tailToMap$7 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$6, keyLub$6, valueLub$6, wk$7);
    var keyLub$7 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$7 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$170 = $m_s_Symbol$();
    var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$170, "district"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$31);
    var tailToMap$8 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$7, keyLub$7, valueLub$7, wk$8);
    var keyLub$8 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$8 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$175 = $m_s_Symbol$();
    var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$175, "city"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$32);
    var tailToMap$9 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$8, keyLub$8, valueLub$8, wk$9);
    var keyLub$9 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$9 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$180 = $m_s_Symbol$();
    var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$180, "renderSettings"));
    var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$33);
    var tailToMap$10 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$9, keyLub$9, valueLub$9, wk$10);
    var keyLub$10 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$10 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$185 = $m_s_Symbol$();
    var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$185, "scenes"));
    var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$34);
    var tailToMap$11 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$10, keyLub$10, valueLub$10, wk$11);
    var keyLub$11 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$11 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$190 = $m_s_Symbol$();
    var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$190, "privacy"));
    var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$35);
    var tailToMap$12 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$11, keyLub$11, valueLub$11, wk$12);
    var keyLub$12 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$12 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$195 = $m_s_Symbol$();
    var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$195, "soldOut"));
    var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$36);
    var tailToMap$13 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$12, keyLub$12, valueLub$12, wk$13);
    var keyLub$13 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$13 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$200 = $m_s_Symbol$();
    var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$200, "price"));
    var wk$14 = new $c_Lshapeless_Witness$$anon$1(value0$37);
    var tailToMap$14 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$13, keyLub$13, valueLub$13, wk$14);
    var keyLub$14 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$14 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$205 = $m_s_Symbol$();
    var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$205, "areas"));
    var wk$15 = new $c_Lshapeless_Witness$$anon$1(value0$38);
    var tailToMap$15 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$14, keyLub$14, valueLub$14, wk$15);
    var keyLub$15 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$15 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$210 = $m_s_Symbol$();
    var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$210, "location"));
    var wk$16 = new $c_Lshapeless_Witness$$anon$1(value0$39);
    var tailToMap$16 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$15, keyLub$15, valueLub$15, wk$16);
    var keyLub$16 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$16 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$215 = $m_s_Symbol$();
    var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$215, "images"));
    var wk$17 = new $c_Lshapeless_Witness$$anon$1(value0$40);
    var tailToMap$17 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$16, keyLub$16, valueLub$16, wk$17);
    var keyLub$17 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$17 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$220 = $m_s_Symbol$();
    var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$220, "description"));
    var wk$18 = new $c_Lshapeless_Witness$$anon$1(value0$41);
    var tailToMap$18 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$17, keyLub$17, valueLub$17, wk$18);
    var keyLub$18 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$18 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$225 = $m_s_Symbol$();
    var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$225, "title"));
    var wk$19 = new $c_Lshapeless_Witness$$anon$1(value0$42);
    var tailToMap$19 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$18, keyLub$18, valueLub$18, wk$19);
    var keyLub$19 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$19 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$230 = $m_s_Symbol$();
    var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$230, "name"));
    var wk$20 = new $c_Lshapeless_Witness$$anon$1(value0$43);
    var tailToMap$20 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$19, keyLub$19, valueLub$19, wk$20);
    var keyLub$20 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$20 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$235 = $m_s_Symbol$();
    var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$235, "organizations"));
    var wk$21 = new $c_Lshapeless_Witness$$anon$1(value0$44);
    var tailToMap$21 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$20, keyLub$20, valueLub$20, wk$21);
    var keyLub$21 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$21 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$240 = $m_s_Symbol$();
    var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$240, "_id"));
    var wk$22 = new $c_Lshapeless_Witness$$anon$1(value0$45);
    var toMap = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$21, keyLub$21, valueLub$21, wk$22);
    $m_Lshapeless_Witness$();
    var this$243 = $m_s_Symbol$();
    var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$243, "_id"));
    var wk$45 = new $c_Lshapeless_Witness$$anon$1(value0$46);
    var tv$22 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
    $m_Lshapeless_Witness$();
    var this$245 = $m_s_Symbol$();
    var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$245, "organizations"));
    var wk$44 = new $c_Lshapeless_Witness$$anon$1(value0$47);
    var tv$21 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
    $m_Lshapeless_Witness$();
    var this$248 = $m_s_Symbol$();
    var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$248, "name"));
    var wk$43 = new $c_Lshapeless_Witness$$anon$1(value0$48);
    var tv$20 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")));
    $m_Lshapeless_Witness$();
    var this$250 = $m_s_Symbol$();
    var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$250, "title"));
    var wk$42 = new $c_Lshapeless_Witness$$anon$1(value0$49);
    var tv$19 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")));
    $m_Lshapeless_Witness$();
    var this$252 = $m_s_Symbol$();
    var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$252, "description"));
    var wk$41 = new $c_Lshapeless_Witness$$anon$1(value0$50);
    var tv$18 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lcom_iz2use_common_Multiline.getClassOf(), new $c_sjsr_AnonFunction0((() => "Multiline"))));
    $m_Lshapeless_Witness$();
    var this$254 = $m_s_Symbol$();
    var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$254, "images"));
    var wk$40 = new $c_Lshapeless_Witness$$anon$1(value0$51);
    var tv$17 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_Image.getClassOf(), new $c_sjsr_AnonFunction0((() => "Image"))));
    $m_Lshapeless_Witness$();
    var this$257 = $m_s_Symbol$();
    var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$257, "location"));
    var wk$39 = new $c_Lshapeless_Witness$$anon$1(value0$52);
    var tv$16 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_Coordinates.getClassOf(), new $c_sjsr_AnonFunction0((() => "Coordinates"))));
    $m_Lshapeless_Witness$();
    var this$259 = $m_s_Symbol$();
    var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$259, "areas"));
    var wk$38 = new $c_Lshapeless_Witness$$anon$1(value0$53);
    var tv$15 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_Area.getClassOf(), new $c_sjsr_AnonFunction0((() => "Area")))));
    $m_Lshapeless_Witness$();
    var this$262 = $m_s_Symbol$();
    var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$262, "price"));
    var wk$37 = new $c_Lshapeless_Witness$$anon$1(value0$54);
    var tv$14 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_doubleTypeable);
    $m_Lshapeless_Witness$();
    var this$264 = $m_s_Symbol$();
    var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$264, "soldOut"));
    var wk$36 = new $c_Lshapeless_Witness$$anon$1(value0$55);
    var tv$13 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable);
    $m_Lshapeless_Witness$();
    var this$266 = $m_s_Symbol$();
    var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$266, "privacy"));
    var wk$35 = new $c_Lshapeless_Witness$$anon$1(value0$56);
    var tv$12 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
    $m_Lshapeless_Witness$();
    var this$268 = $m_s_Symbol$();
    var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$268, "scenes"));
    var wk$34 = new $c_Lshapeless_Witness$$anon$1(value0$57);
    var $$x289 = $m_Lshapeless_Typeable$();
    var $$x288 = $m_Lshapeless_Typeable$();
    var this$270 = $m_s_$less$colon$less$();
    var tv$11 = $n($$x289).optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($n($$x288).genMapTypeable__s_$less$colon$less__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable__Lshapeless_Typeable(this$270.s_$less$colon$less$__f_singleton, new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Map.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")))));
    $m_Lshapeless_Witness$();
    var this$272 = $m_s_Symbol$();
    var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$272, "renderSettings"));
    var wk$33 = new $c_Lshapeless_Witness$$anon$1(value0$58);
    var tv$10 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RenderSettings.getClassOf(), new $c_sjsr_AnonFunction0((() => "RenderSettings"))));
    $m_Lshapeless_Witness$();
    var this$274 = $m_s_Symbol$();
    var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$274, "city"));
    var wk$32 = new $c_Lshapeless_Witness$$anon$1(value0$59);
    var tv$9 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
    $m_Lshapeless_Witness$();
    var this$276 = $m_s_Symbol$();
    var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$276, "district"));
    var wk$31 = new $c_Lshapeless_Witness$$anon$1(value0$60);
    var tv$8 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
    $m_Lshapeless_Witness$();
    var this$278 = $m_s_Symbol$();
    var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$278, "topic"));
    var wk$30 = new $c_Lshapeless_Witness$$anon$1(value0$61);
    var tv$7 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
    $m_Lshapeless_Witness$();
    var this$280 = $m_s_Symbol$();
    var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$280, "modelSource"));
    var wk$29 = new $c_Lshapeless_Witness$$anon$1(value0$62);
    var tv$6 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lcom_iz2use_common_Multiline.getClassOf(), new $c_sjsr_AnonFunction0((() => "Multiline"))));
    $m_Lshapeless_Witness$();
    var this$282 = $m_s_Symbol$();
    var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$282, "procedureState"));
    var wk$28 = new $c_Lshapeless_Witness$$anon$1(value0$63);
    var tv$5 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lcom_iz2use_common_Multiline.getClassOf(), new $c_sjsr_AnonFunction0((() => "Multiline"))));
    $m_Lshapeless_Witness$();
    var this$284 = $m_s_Symbol$();
    var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$284, "summary"));
    var wk$27 = new $c_Lshapeless_Witness$$anon$1(value0$64);
    var tv$4 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lcom_iz2use_common_Multiline.getClassOf(), new $c_sjsr_AnonFunction0((() => "Multiline"))));
    $m_Lshapeless_Witness$();
    var this$286 = $m_s_Symbol$();
    var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$286, "archived"));
    var wk$26 = new $c_Lshapeless_Witness$$anon$1(value0$65);
    var tv$3 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_Date.getClassOf(), new $c_sjsr_AnonFunction0((() => "Date"))));
    $m_Lshapeless_Witness$();
    var this$288 = $m_s_Symbol$();
    var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$288, "parent"));
    var wk$25 = new $c_Lshapeless_Witness$$anon$1(value0$66);
    var tv$2 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
    $m_Lshapeless_Witness$();
    var this$290 = $m_s_Symbol$();
    var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$290, "address"));
    var wk$24 = new $c_Lshapeless_Witness$$anon$1(value0$67);
    var tv$1 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_ProjectAddress.getClassOf(), new $c_sjsr_AnonFunction0((() => "ProjectAddress")));
    $m_Lshapeless_Witness$();
    var this$292 = $m_s_Symbol$();
    var value0$68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$292, "reference"));
    var wk$23 = new $c_Lshapeless_Witness$$anon$1(value0$68);
    var tv = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")));
    var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
    var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$23, tv, fmt);
    var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$24, tv$1, fmt$1);
    var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$25, tv$2, fmt$2);
    var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$26, tv$3, fmt$3);
    var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$27, tv$4, fmt$4);
    var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$28, tv$5, fmt$5);
    var fmt$7 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$29, tv$6, fmt$6);
    var fmt$8 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$30, tv$7, fmt$7);
    var fmt$9 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$31, tv$8, fmt$8);
    var fmt$10 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$32, tv$9, fmt$9);
    var fmt$11 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$33, tv$10, fmt$10);
    var fmt$12 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$34, tv$11, fmt$11);
    var fmt$13 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$35, tv$12, fmt$12);
    var fmt$14 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$36, tv$13, fmt$13);
    var fmt$15 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$37, tv$14, fmt$14);
    var fmt$16 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$38, tv$15, fmt$15);
    var fmt$17 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$39, tv$16, fmt$16);
    var fmt$18 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$40, tv$17, fmt$17);
    var fmt$19 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$41, tv$18, fmt$18);
    var fmt$20 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$42, tv$19, fmt$19);
    var fmt$21 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$43, tv$20, fmt$20);
    var fmt$22 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$44, tv$21, fmt$21);
    var fromMap = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$45, tv$22, fmt$22);
    var $$x290 = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap, gen$1, fromMap);
    $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$();
    var this$867 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    $m_Lreactbuild_analyze_cost_modules_Projects$();
    var renderList = new $c_Lreactbuild_analyze_cost_modules_Projects$$anon$3(pageProps);
    var view$6 = new $c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1(renderList);
    $m_Lreactbuild_analyze_cost_modules_Projects$();
    var view$5 = new $c_Lreactbuild_analyze_cost_modules_Projects$$anon$4(pageProps);
    $m_Lreactbuild_analyze_cost_modules_Projects$();
    var renderable = new $c_Lreactbuild_analyze_cost_modules_Projects$$anon$2();
    var view$4 = new $c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1(renderable);
    var this$324 = $m_s_Symbol$();
    var $$x140 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$324, "_id"));
    var this$325 = $m_s_Symbol$();
    var $$x139 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$325, "organizations"));
    var this$326 = $m_s_Symbol$();
    var $$x138 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$326, "name"));
    var this$327 = $m_s_Symbol$();
    var $$x137 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$327, "title"));
    var this$328 = $m_s_Symbol$();
    var $$x136 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$328, "description"));
    var this$329 = $m_s_Symbol$();
    var $$x135 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$329, "images"));
    var this$330 = $m_s_Symbol$();
    var $$x134 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$330, "location"));
    var this$331 = $m_s_Symbol$();
    var $$x133 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$331, "areas"));
    var this$332 = $m_s_Symbol$();
    var $$x132 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$332, "price"));
    var this$333 = $m_s_Symbol$();
    var $$x131 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$333, "soldOut"));
    var this$334 = $m_s_Symbol$();
    var $$x130 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$334, "privacy"));
    var this$335 = $m_s_Symbol$();
    var $$x129 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$335, "scenes"));
    var this$336 = $m_s_Symbol$();
    var $$x128 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$336, "renderSettings"));
    var this$337 = $m_s_Symbol$();
    var $$x127 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$337, "city"));
    var this$338 = $m_s_Symbol$();
    var $$x126 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$338, "district"));
    var this$339 = $m_s_Symbol$();
    var $$x125 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$339, "topic"));
    var this$340 = $m_s_Symbol$();
    var $$x124 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$340, "modelSource"));
    var this$341 = $m_s_Symbol$();
    var $$x123 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$341, "procedureState"));
    var this$342 = $m_s_Symbol$();
    var $$x122 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$342, "summary"));
    var this$343 = $m_s_Symbol$();
    var $$x121 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$343, "archived"));
    var this$344 = $m_s_Symbol$();
    var $$x120 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$344, "parent"));
    var this$345 = $m_s_Symbol$();
    var $$x119 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$345, "address"));
    var this$346 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x140, new $c_Lshapeless_$colon$colon($$x139, new $c_Lshapeless_$colon$colon($$x138, new $c_Lshapeless_$colon$colon($$x137, new $c_Lshapeless_$colon$colon($$x136, new $c_Lshapeless_$colon$colon($$x135, new $c_Lshapeless_$colon$colon($$x134, new $c_Lshapeless_$colon$colon($$x133, new $c_Lshapeless_$colon$colon($$x132, new $c_Lshapeless_$colon$colon($$x131, new $c_Lshapeless_$colon$colon($$x130, new $c_Lshapeless_$colon$colon($$x129, new $c_Lshapeless_$colon$colon($$x128, new $c_Lshapeless_$colon$colon($$x127, new $c_Lshapeless_$colon$colon($$x126, new $c_Lshapeless_$colon$colon($$x125, new $c_Lshapeless_$colon$colon($$x124, new $c_Lshapeless_$colon$colon($$x123, new $c_Lshapeless_$colon$colon($$x122, new $c_Lshapeless_$colon$colon($$x121, new $c_Lshapeless_$colon$colon($$x120, new $c_Lshapeless_$colon$colon($$x119, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$346, "reference")), $m_Lshapeless_HNil$())))))))))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var f$8 = new $c_sjsr_AnonFunction1(((x0$10$2) => {
      var x0$10 = $as_Lreactbuild_common_model_Project(x0$10$2);
      return new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f__id, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_organizations, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_name, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_title, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_description, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_images, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_location, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_areas, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_price, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_soldOut, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_privacy, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_scenes, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_renderSettings, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_city, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_district, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_topic, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_modelSource, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_procedureState, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_summary, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_archived, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_parent, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_address, new $c_Lshapeless_$colon$colon($n(x0$10).Lreactbuild_common_model_Project__f_reference, $m_Lshapeless_HNil$())))))))))))))))))))))))
    }));
    var g$1 = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lshapeless_$colon$colon(x0$11$2);
      if ((x0$11 !== null)) {
        var _id$macro$73 = $as_Lreactbuild_common_model_RefTo($n(x0$11).Lshapeless_$colon$colon__f_head);
        var p2$4 = $as_Lshapeless_$colon$colon($n(x0$11).Lshapeless_$colon$colon__f_tail);
        if ((p2$4 !== null)) {
          var organizations$macro$74 = $as_sci_Seq($n(p2$4).Lshapeless_$colon$colon__f_head);
          var p3$1 = $as_Lshapeless_$colon$colon($n(p2$4).Lshapeless_$colon$colon__f_tail);
          if ((p3$1 !== null)) {
            var name$macro$75 = $as_T($n(p3$1).Lshapeless_$colon$colon__f_head);
            var p4$4 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
            if ((p4$4 !== null)) {
              var title$macro$76 = $as_T($n(p4$4).Lshapeless_$colon$colon__f_head);
              var p5$1 = $as_Lshapeless_$colon$colon($n(p4$4).Lshapeless_$colon$colon__f_tail);
              if ((p5$1 !== null)) {
                var description$macro$77 = $as_s_Option($n(p5$1).Lshapeless_$colon$colon__f_head);
                var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
                if ((p6$1 !== null)) {
                  var images$macro$78 = $as_sci_Seq($n(p6$1).Lshapeless_$colon$colon__f_head);
                  var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                  if ((p7$1 !== null)) {
                    var location$macro$79 = $as_s_Option($n(p7$1).Lshapeless_$colon$colon__f_head);
                    var p8$1 = $as_Lshapeless_$colon$colon($n(p7$1).Lshapeless_$colon$colon__f_tail);
                    if ((p8$1 !== null)) {
                      var areas$macro$80 = $as_s_Option($n(p8$1).Lshapeless_$colon$colon__f_head);
                      var p9$1 = $as_Lshapeless_$colon$colon($n(p8$1).Lshapeless_$colon$colon__f_tail);
                      if ((p9$1 !== null)) {
                        var price$macro$81 = $as_s_Option($n(p9$1).Lshapeless_$colon$colon__f_head);
                        var p10$1 = $as_Lshapeless_$colon$colon($n(p9$1).Lshapeless_$colon$colon__f_tail);
                        if ((p10$1 !== null)) {
                          var soldOut$macro$82 = $as_s_Option($n(p10$1).Lshapeless_$colon$colon__f_head);
                          var p11$1 = $as_Lshapeless_$colon$colon($n(p10$1).Lshapeless_$colon$colon__f_tail);
                          if ((p11$1 !== null)) {
                            var privacy$macro$83 = $as_s_Option($n(p11$1).Lshapeless_$colon$colon__f_head);
                            var p12$1 = $as_Lshapeless_$colon$colon($n(p11$1).Lshapeless_$colon$colon__f_tail);
                            if ((p12$1 !== null)) {
                              var scenes$macro$84 = $as_s_Option($n(p12$1).Lshapeless_$colon$colon__f_head);
                              var p13$1 = $as_Lshapeless_$colon$colon($n(p12$1).Lshapeless_$colon$colon__f_tail);
                              if ((p13$1 !== null)) {
                                var renderSettings$macro$85 = $as_s_Option($n(p13$1).Lshapeless_$colon$colon__f_head);
                                var p14$1 = $as_Lshapeless_$colon$colon($n(p13$1).Lshapeless_$colon$colon__f_tail);
                                if ((p14$1 !== null)) {
                                  var city$macro$86 = $as_s_Option($n(p14$1).Lshapeless_$colon$colon__f_head);
                                  var p15$1 = $as_Lshapeless_$colon$colon($n(p14$1).Lshapeless_$colon$colon__f_tail);
                                  if ((p15$1 !== null)) {
                                    var district$macro$87 = $as_s_Option($n(p15$1).Lshapeless_$colon$colon__f_head);
                                    var p16$1 = $as_Lshapeless_$colon$colon($n(p15$1).Lshapeless_$colon$colon__f_tail);
                                    if ((p16$1 !== null)) {
                                      var topic$macro$88 = $as_s_Option($n(p16$1).Lshapeless_$colon$colon__f_head);
                                      var p17$1 = $as_Lshapeless_$colon$colon($n(p16$1).Lshapeless_$colon$colon__f_tail);
                                      if ((p17$1 !== null)) {
                                        var modelSource$macro$89 = $as_s_Option($n(p17$1).Lshapeless_$colon$colon__f_head);
                                        var p18$1 = $as_Lshapeless_$colon$colon($n(p17$1).Lshapeless_$colon$colon__f_tail);
                                        if ((p18$1 !== null)) {
                                          var procedureState$macro$90 = $as_s_Option($n(p18$1).Lshapeless_$colon$colon__f_head);
                                          var p19$1 = $as_Lshapeless_$colon$colon($n(p18$1).Lshapeless_$colon$colon__f_tail);
                                          if ((p19$1 !== null)) {
                                            var summary$macro$91 = $as_s_Option($n(p19$1).Lshapeless_$colon$colon__f_head);
                                            var p20$1 = $as_Lshapeless_$colon$colon($n(p19$1).Lshapeless_$colon$colon__f_tail);
                                            if ((p20$1 !== null)) {
                                              var archived$macro$92 = $as_s_Option($n(p20$1).Lshapeless_$colon$colon__f_head);
                                              var p21$1 = $as_Lshapeless_$colon$colon($n(p20$1).Lshapeless_$colon$colon__f_tail);
                                              if ((p21$1 !== null)) {
                                                var parent$macro$93 = $as_s_Option($n(p21$1).Lshapeless_$colon$colon__f_head);
                                                var p22$1 = $as_Lshapeless_$colon$colon($n(p21$1).Lshapeless_$colon$colon__f_tail);
                                                if ((p22$1 !== null)) {
                                                  var address$macro$94 = $as_Lreactbuild_common_model_ProjectAddress($n(p22$1).Lshapeless_$colon$colon__f_head);
                                                  var p23$1 = $as_Lshapeless_$colon$colon($n(p22$1).Lshapeless_$colon$colon__f_tail);
                                                  if ((p23$1 !== null)) {
                                                    var reference$macro$95 = $as_T($n(p23$1).Lshapeless_$colon$colon__f_head);
                                                    var p24$1 = $as_Lshapeless_HNil($n(p23$1).Lshapeless_$colon$colon__f_tail);
                                                    var x$4 = $m_Lshapeless_HNil$();
                                                    if ((x$4 === p24$1)) {
                                                      return new $c_Lreactbuild_common_model_Project(_id$macro$73, organizations$macro$74, name$macro$75, title$macro$76, description$macro$77, images$macro$78, location$macro$79, areas$macro$80, price$macro$81, soldOut$macro$82, privacy$macro$83, scenes$macro$84, renderSettings$macro$85, city$macro$86, district$macro$87, topic$macro$88, modelSource$macro$89, procedureState$macro$90, summary$macro$91, archived$macro$92, parent$macro$93, address$macro$94, reference$macro$95)
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$11)
    }));
    var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$8, g$1);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$23 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$349 = $m_s_Symbol$();
    var value0$69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$349, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$69);
    var zipWithKeys$24 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$23);
    $m_Lshapeless_Witness$();
    var this$352 = $m_s_Symbol$();
    var value0$70 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$352, "address"));
    new $c_Lshapeless_Witness$$anon$1(value0$70);
    var zipWithKeys$25 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$24);
    $m_Lshapeless_Witness$();
    var this$355 = $m_s_Symbol$();
    var value0$71 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$355, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0$71);
    var zipWithKeys$26 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$25);
    $m_Lshapeless_Witness$();
    var this$358 = $m_s_Symbol$();
    var value0$72 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$358, "archived"));
    new $c_Lshapeless_Witness$$anon$1(value0$72);
    var zipWithKeys$27 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$26);
    $m_Lshapeless_Witness$();
    var this$361 = $m_s_Symbol$();
    var value0$73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$361, "summary"));
    new $c_Lshapeless_Witness$$anon$1(value0$73);
    var zipWithKeys$28 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$27);
    $m_Lshapeless_Witness$();
    var this$364 = $m_s_Symbol$();
    var value0$74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$364, "procedureState"));
    new $c_Lshapeless_Witness$$anon$1(value0$74);
    var zipWithKeys$29 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$28);
    $m_Lshapeless_Witness$();
    var this$367 = $m_s_Symbol$();
    var value0$75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$367, "modelSource"));
    new $c_Lshapeless_Witness$$anon$1(value0$75);
    var zipWithKeys$30 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$29);
    $m_Lshapeless_Witness$();
    var this$370 = $m_s_Symbol$();
    var value0$76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$370, "topic"));
    new $c_Lshapeless_Witness$$anon$1(value0$76);
    var zipWithKeys$31 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$30);
    $m_Lshapeless_Witness$();
    var this$373 = $m_s_Symbol$();
    var value0$77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$373, "district"));
    new $c_Lshapeless_Witness$$anon$1(value0$77);
    var zipWithKeys$32 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$31);
    $m_Lshapeless_Witness$();
    var this$376 = $m_s_Symbol$();
    var value0$78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$376, "city"));
    new $c_Lshapeless_Witness$$anon$1(value0$78);
    var zipWithKeys$33 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$32);
    $m_Lshapeless_Witness$();
    var this$379 = $m_s_Symbol$();
    var value0$79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$379, "renderSettings"));
    new $c_Lshapeless_Witness$$anon$1(value0$79);
    var zipWithKeys$34 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$33);
    $m_Lshapeless_Witness$();
    var this$382 = $m_s_Symbol$();
    var value0$80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$382, "scenes"));
    new $c_Lshapeless_Witness$$anon$1(value0$80);
    var zipWithKeys$35 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$34);
    $m_Lshapeless_Witness$();
    var this$385 = $m_s_Symbol$();
    var value0$81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$385, "privacy"));
    new $c_Lshapeless_Witness$$anon$1(value0$81);
    var zipWithKeys$36 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$35);
    $m_Lshapeless_Witness$();
    var this$388 = $m_s_Symbol$();
    var value0$82 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$388, "soldOut"));
    new $c_Lshapeless_Witness$$anon$1(value0$82);
    var zipWithKeys$37 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$36);
    $m_Lshapeless_Witness$();
    var this$391 = $m_s_Symbol$();
    var value0$83 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$391, "price"));
    new $c_Lshapeless_Witness$$anon$1(value0$83);
    var zipWithKeys$38 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$37);
    $m_Lshapeless_Witness$();
    var this$394 = $m_s_Symbol$();
    var value0$84 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$394, "areas"));
    new $c_Lshapeless_Witness$$anon$1(value0$84);
    var zipWithKeys$39 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$38);
    $m_Lshapeless_Witness$();
    var this$397 = $m_s_Symbol$();
    var value0$85 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$397, "location"));
    new $c_Lshapeless_Witness$$anon$1(value0$85);
    var zipWithKeys$40 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$39);
    $m_Lshapeless_Witness$();
    var this$400 = $m_s_Symbol$();
    var value0$86 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$400, "images"));
    new $c_Lshapeless_Witness$$anon$1(value0$86);
    var zipWithKeys$41 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$40);
    $m_Lshapeless_Witness$();
    var this$403 = $m_s_Symbol$();
    var value0$87 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$403, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$87);
    var zipWithKeys$42 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$41);
    $m_Lshapeless_Witness$();
    var this$406 = $m_s_Symbol$();
    var value0$88 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$406, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$88);
    var zipWithKeys$43 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$42);
    $m_Lshapeless_Witness$();
    var this$409 = $m_s_Symbol$();
    var value0$89 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$409, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$89);
    var zipWithKeys$44 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$43);
    $m_Lshapeless_Witness$();
    var this$412 = $m_s_Symbol$();
    var value0$90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$412, "organizations"));
    new $c_Lshapeless_Witness$$anon$1(value0$90);
    var zipWithKeys$45 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$44);
    $m_Lshapeless_Witness$();
    var this$415 = $m_s_Symbol$();
    var value0$91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$415, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$91);
    var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$45);
    var this$418 = $m_s_$less$colon$less$();
    var ev$1 = this$418.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$1);
    var this$590 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$420 = $m_s_Symbol$();
    var value0$92 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$420, "_id"));
    var witness$11 = new $c_Lshapeless_Witness$$anon$1(value0$92);
    var $$x144 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var this$422 = $m_Lreactbuild_model_Implicits$();
    var format = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$422);
    var $$x143 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format);
    var this$426 = $m_Lreactbuild_model_Implicits$();
    var this$425 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$425, proxy);
    var $$x142 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$426, ev$2)));
    var $$x141 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$429 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$429, proxy$1);
    var fieldRenderable$11 = $n($$x144).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x143, $$x142, $$x141, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$589 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Seq[reactbuild.common.model.RefTo[reactbuild.common.model.Organization]]");
    var this$588 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$431 = $m_s_Symbol$();
    var value0$93 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$431, "name"));
    var witness$10 = new $c_Lshapeless_Witness$$anon$1(value0$93);
    var $$x148 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$1 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var $$x147 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$1);
    var $$x146 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
    $m_Lcom_iz2use_common_Parsable$();
    var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var resolver = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    var $$x145 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner, resolver);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$10 = $n($$x148).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x147, $$x146, $$x145, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$1), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
    var this$587 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$439 = $m_s_Symbol$();
    var value0$94 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$439, "title"));
    var witness$9 = new $c_Lshapeless_Witness$$anon$1(value0$94);
    var $$x152 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$2 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var $$x151 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$2);
    var $$x150 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
    $m_Lcom_iz2use_common_Parsable$();
    var evDefault$1 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    var parser$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var resolver$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    var $$x149 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$1, resolver$1);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$9 = $n($$x152).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x151, $$x150, $$x149, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$3), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
    var this$586 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Option[com.iz2use.common.Multiline]");
    var this$585 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Seq[reactbuild.common.model.Image]");
    var this$584 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Option[reactbuild.common.model.Coordinates]");
    var this$583 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Option[Seq[reactbuild.common.model.Area]]");
    var this$582 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$447 = $m_s_Symbol$();
    var value0$95 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$447, "price"));
    var witness$8 = new $c_Lshapeless_Witness$$anon$1(value0$95);
    var $$x157 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$3 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_double;
    var format$4 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$3);
    var $$x156 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$4);
    var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
    var $$x155 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$3);
    var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$4);
    var resolver$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
    var $$x154 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$2, resolver$2);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var textualizable$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$5);
    var $$x153 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$1);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var fieldRenderable$8 = $n($$x157).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x156, $$x155, $$x154, $$x153, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$5))));
    var this$581 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$462 = $m_s_Symbol$();
    var value0$96 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$462, "soldOut"));
    var witness$7 = new $c_Lshapeless_Witness$$anon$1(value0$96);
    var $$x162 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$5 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_boolean;
    var format$6 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$5);
    var $$x161 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$6);
    var ord$1 = $m_s_math_Ordering$Boolean$();
    var $$x160 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$1)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$6);
    var evDefault$3 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var parser$3 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$7);
    var resolver$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
    var $$x159 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$3, resolver$3);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var textualizable$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$7);
    var $$x158 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$2);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var fieldRenderable$7 = $n($$x162).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x161, $$x160, $$x159, $$x158, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$8))));
    var this$580 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$477 = $m_s_Symbol$();
    var value0$97 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$477, "privacy"));
    var witness$6 = new $c_Lshapeless_Witness$$anon$1(value0$97);
    var $$x167 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$7 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$8 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$7);
    var $$x166 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$8);
    var ord$2 = $m_s_math_Ordering$String$();
    var $$x165 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$2)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$9);
    var evDefault$4 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$4);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$4 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$10);
    var resolver$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
    var $$x164 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$4, resolver$4);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$3 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$9);
    var $$x163 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$3);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$11 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$6 = $n($$x167).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x166, $$x165, $$x164, $$x163, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$11))));
    var this$579 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Option[Map[String,String]]");
    var this$578 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Option[reactbuild.common.model.RenderSettings]");
    var this$577 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$492 = $m_s_Symbol$();
    var value0$98 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$492, "city"));
    var witness$5 = new $c_Lshapeless_Witness$$anon$1(value0$98);
    var $$x172 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$9 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$10 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$9);
    var $$x171 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$10);
    var ord$3 = $m_s_math_Ordering$String$();
    var $$x170 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$3)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$12 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$12);
    var evDefault$5 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$5 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$5);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$13 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$5 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$13);
    var resolver$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
    var $$x169 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$5, resolver$5);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$11 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$4 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$11);
    var $$x168 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$4);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$14 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$5 = $n($$x172).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x171, $$x170, $$x169, $$x168, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$14))));
    var this$576 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$507 = $m_s_Symbol$();
    var value0$99 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$507, "district"));
    var witness$4 = new $c_Lshapeless_Witness$$anon$1(value0$99);
    var $$x177 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$11 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$12 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$11);
    var $$x176 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$12);
    var ord$4 = $m_s_math_Ordering$String$();
    var $$x175 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$4)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$15);
    var evDefault$6 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$6 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$6);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$16 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$6 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$16);
    var resolver$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
    var $$x174 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$6, resolver$6);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$13 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$13);
    var $$x173 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$5);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$4 = $n($$x177).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x176, $$x175, $$x174, $$x173, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$17))));
    var this$575 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$522 = $m_s_Symbol$();
    var value0$100 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$522, "topic"));
    var witness$3 = new $c_Lshapeless_Witness$$anon$1(value0$100);
    var $$x182 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$13 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$14 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$13);
    var $$x181 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$14);
    var ord$5 = $m_s_math_Ordering$String$();
    var $$x180 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$5)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$18 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$18);
    var evDefault$7 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$7 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$7);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$19 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$7 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$19);
    var resolver$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
    var $$x179 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$7, resolver$7);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$6 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$15);
    var $$x178 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$6);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$20 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$3 = $n($$x182).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x181, $$x180, $$x179, $$x178, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$20))));
    var this$574 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Option[com.iz2use.common.Multiline]");
    var this$573 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Option[com.iz2use.common.Multiline]");
    var this$572 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "Option[com.iz2use.common.Multiline]");
    var this$571 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$537 = $m_s_Symbol$();
    var value0$101 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$537, "archived"));
    var witness$2 = new $c_Lshapeless_Witness$$anon$1(value0$101);
    var $$x186 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$15 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
    var format$16 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$15);
    var $$x185 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$16);
    var ord$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
    var $$x184 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$6)));
    var $$x183 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
    var textualizable$8 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$7);
    var fieldRenderable$2 = $n($$x186).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x185, $$x184, $$x183, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$8), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$570 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$545 = $m_s_Symbol$();
    var value0$102 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$545, "parent"));
    var witness$1 = new $c_Lshapeless_Witness$$anon$1(value0$102);
    var $$x190 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var this$547 = $m_Lreactbuild_model_Implicits$();
    var format$17 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$547);
    var format$18 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$17);
    var $$x189 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$18);
    var this$552 = $m_Lreactbuild_model_Implicits$();
    var this$551 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$21 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$551, proxy$2);
    var ord$7 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$552, ev$21);
    var $$x188 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$7)));
    var $$x187 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$556 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$3 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var textualizable$9 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$556, proxy$3);
    var textualizable$10 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$9);
    var fieldRenderable$1 = $n($$x190).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x189, $$x188, $$x187, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$10), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$569 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Project", "reactbuild.common.model.ProjectAddress");
    var this$568 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$559 = $m_s_Symbol$();
    var value0$103 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$559, "reference"));
    var witness = new $c_Lshapeless_Witness$$anon$1(value0$103);
    var $$x194 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$19 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var $$x193 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$19);
    var $$x192 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
    $m_Lcom_iz2use_common_Parsable$();
    var evDefault$8 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$8 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$8);
    var parser$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var resolver$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$8);
    var $$x191 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$8, resolver$8);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable = $n($$x194).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x193, $$x192, $$x191, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$17), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
    var tail = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4();
    var tail$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$568, fieldRenderable, witness, tail);
    var tail$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$569, tail$1);
    var tail$3 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$570, fieldRenderable$1, witness$1, tail$2);
    var tail$4 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$571, fieldRenderable$2, witness$2, tail$3);
    var tail$5 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$572, tail$4);
    var tail$6 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$573, tail$5);
    var tail$7 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$574, tail$6);
    var tail$8 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$575, fieldRenderable$3, witness$3, tail$7);
    var tail$9 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$576, fieldRenderable$4, witness$4, tail$8);
    var tail$10 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$577, fieldRenderable$5, witness$5, tail$9);
    var tail$11 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$578, tail$10);
    var tail$12 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$579, tail$11);
    var tail$13 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$580, fieldRenderable$6, witness$6, tail$12);
    var tail$14 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$581, fieldRenderable$7, witness$7, tail$13);
    var tail$15 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$582, fieldRenderable$8, witness$8, tail$14);
    var tail$16 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$583, tail$15);
    var tail$17 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$584, tail$16);
    var tail$18 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$585, tail$17);
    var tail$19 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$586, tail$18);
    var tail$20 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$587, fieldRenderable$9, witness$9, tail$19);
    var tail$21 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$588, fieldRenderable$10, witness$10, tail$20);
    var tail$22 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$589, tail$21);
    var renderer = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$590, fieldRenderable$11, witness$11, tail$22);
    $m_s_DummyImplicit$();
    new $c_Lshapeless_Refute$$anon$2();
    var view$3 = new $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1(renderer);
    var this$862 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    $m_Lreactbuild_analyze_cost_modules_Projects$();
    var renderItem = new $c_Lreactbuild_analyze_cost_modules_Projects$$anon$1(pageProps, viewState);
    var view$2 = new $c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1(renderItem);
    var this$595 = $m_s_Symbol$();
    var $$x216 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$595, "_id"));
    var this$596 = $m_s_Symbol$();
    var $$x215 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$596, "organizations"));
    var this$597 = $m_s_Symbol$();
    var $$x214 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$597, "name"));
    var this$598 = $m_s_Symbol$();
    var $$x213 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$598, "title"));
    var this$599 = $m_s_Symbol$();
    var $$x212 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$599, "description"));
    var this$600 = $m_s_Symbol$();
    var $$x211 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$600, "images"));
    var this$601 = $m_s_Symbol$();
    var $$x210 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$601, "location"));
    var this$602 = $m_s_Symbol$();
    var $$x209 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$602, "areas"));
    var this$603 = $m_s_Symbol$();
    var $$x208 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$603, "price"));
    var this$604 = $m_s_Symbol$();
    var $$x207 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$604, "soldOut"));
    var this$605 = $m_s_Symbol$();
    var $$x206 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$605, "privacy"));
    var this$606 = $m_s_Symbol$();
    var $$x205 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$606, "scenes"));
    var this$607 = $m_s_Symbol$();
    var $$x204 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$607, "renderSettings"));
    var this$608 = $m_s_Symbol$();
    var $$x203 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$608, "city"));
    var this$609 = $m_s_Symbol$();
    var $$x202 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$609, "district"));
    var this$610 = $m_s_Symbol$();
    var $$x201 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$610, "topic"));
    var this$611 = $m_s_Symbol$();
    var $$x200 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$611, "modelSource"));
    var this$612 = $m_s_Symbol$();
    var $$x199 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$612, "procedureState"));
    var this$613 = $m_s_Symbol$();
    var $$x198 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$613, "summary"));
    var this$614 = $m_s_Symbol$();
    var $$x197 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$614, "archived"));
    var this$615 = $m_s_Symbol$();
    var $$x196 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$615, "parent"));
    var this$616 = $m_s_Symbol$();
    var $$x195 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$616, "address"));
    var this$617 = $m_s_Symbol$();
    var labels$2 = new $c_Lshapeless_$colon$colon($$x216, new $c_Lshapeless_$colon$colon($$x215, new $c_Lshapeless_$colon$colon($$x214, new $c_Lshapeless_$colon$colon($$x213, new $c_Lshapeless_$colon$colon($$x212, new $c_Lshapeless_$colon$colon($$x211, new $c_Lshapeless_$colon$colon($$x210, new $c_Lshapeless_$colon$colon($$x209, new $c_Lshapeless_$colon$colon($$x208, new $c_Lshapeless_$colon$colon($$x207, new $c_Lshapeless_$colon$colon($$x206, new $c_Lshapeless_$colon$colon($$x205, new $c_Lshapeless_$colon$colon($$x204, new $c_Lshapeless_$colon$colon($$x203, new $c_Lshapeless_$colon$colon($$x202, new $c_Lshapeless_$colon$colon($$x201, new $c_Lshapeless_$colon$colon($$x200, new $c_Lshapeless_$colon$colon($$x199, new $c_Lshapeless_$colon$colon($$x198, new $c_Lshapeless_$colon$colon($$x197, new $c_Lshapeless_$colon$colon($$x196, new $c_Lshapeless_$colon$colon($$x195, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$617, "reference")), $m_Lshapeless_HNil$())))))))))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
    var f$9 = new $c_sjsr_AnonFunction1(((x0$14$2) => {
      var x0$14 = $as_Lreactbuild_common_model_Project(x0$14$2);
      return new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f__id, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_organizations, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_name, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_title, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_description, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_images, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_location, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_areas, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_price, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_soldOut, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_privacy, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_scenes, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_renderSettings, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_city, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_district, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_topic, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_modelSource, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_procedureState, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_summary, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_archived, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_parent, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_address, new $c_Lshapeless_$colon$colon($n(x0$14).Lreactbuild_common_model_Project__f_reference, $m_Lshapeless_HNil$())))))))))))))))))))))))
    }));
    var g$2 = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lshapeless_$colon$colon(x0$15$2);
      if ((x0$15 !== null)) {
        var _id$macro$121 = $as_Lreactbuild_common_model_RefTo($n(x0$15).Lshapeless_$colon$colon__f_head);
        var p2$5 = $as_Lshapeless_$colon$colon($n(x0$15).Lshapeless_$colon$colon__f_tail);
        if ((p2$5 !== null)) {
          var organizations$macro$122 = $as_sci_Seq($n(p2$5).Lshapeless_$colon$colon__f_head);
          var p3$2 = $as_Lshapeless_$colon$colon($n(p2$5).Lshapeless_$colon$colon__f_tail);
          if ((p3$2 !== null)) {
            var name$macro$123 = $as_T($n(p3$2).Lshapeless_$colon$colon__f_head);
            var p4$5 = $as_Lshapeless_$colon$colon($n(p3$2).Lshapeless_$colon$colon__f_tail);
            if ((p4$5 !== null)) {
              var title$macro$124 = $as_T($n(p4$5).Lshapeless_$colon$colon__f_head);
              var p5$2 = $as_Lshapeless_$colon$colon($n(p4$5).Lshapeless_$colon$colon__f_tail);
              if ((p5$2 !== null)) {
                var description$macro$125 = $as_s_Option($n(p5$2).Lshapeless_$colon$colon__f_head);
                var p6$2 = $as_Lshapeless_$colon$colon($n(p5$2).Lshapeless_$colon$colon__f_tail);
                if ((p6$2 !== null)) {
                  var images$macro$126 = $as_sci_Seq($n(p6$2).Lshapeless_$colon$colon__f_head);
                  var p7$2 = $as_Lshapeless_$colon$colon($n(p6$2).Lshapeless_$colon$colon__f_tail);
                  if ((p7$2 !== null)) {
                    var location$macro$127 = $as_s_Option($n(p7$2).Lshapeless_$colon$colon__f_head);
                    var p8$2 = $as_Lshapeless_$colon$colon($n(p7$2).Lshapeless_$colon$colon__f_tail);
                    if ((p8$2 !== null)) {
                      var areas$macro$128 = $as_s_Option($n(p8$2).Lshapeless_$colon$colon__f_head);
                      var p9$2 = $as_Lshapeless_$colon$colon($n(p8$2).Lshapeless_$colon$colon__f_tail);
                      if ((p9$2 !== null)) {
                        var price$macro$129 = $as_s_Option($n(p9$2).Lshapeless_$colon$colon__f_head);
                        var p10$2 = $as_Lshapeless_$colon$colon($n(p9$2).Lshapeless_$colon$colon__f_tail);
                        if ((p10$2 !== null)) {
                          var soldOut$macro$130 = $as_s_Option($n(p10$2).Lshapeless_$colon$colon__f_head);
                          var p11$2 = $as_Lshapeless_$colon$colon($n(p10$2).Lshapeless_$colon$colon__f_tail);
                          if ((p11$2 !== null)) {
                            var privacy$macro$131 = $as_s_Option($n(p11$2).Lshapeless_$colon$colon__f_head);
                            var p12$2 = $as_Lshapeless_$colon$colon($n(p11$2).Lshapeless_$colon$colon__f_tail);
                            if ((p12$2 !== null)) {
                              var scenes$macro$132 = $as_s_Option($n(p12$2).Lshapeless_$colon$colon__f_head);
                              var p13$2 = $as_Lshapeless_$colon$colon($n(p12$2).Lshapeless_$colon$colon__f_tail);
                              if ((p13$2 !== null)) {
                                var renderSettings$macro$133 = $as_s_Option($n(p13$2).Lshapeless_$colon$colon__f_head);
                                var p14$2 = $as_Lshapeless_$colon$colon($n(p13$2).Lshapeless_$colon$colon__f_tail);
                                if ((p14$2 !== null)) {
                                  var city$macro$134 = $as_s_Option($n(p14$2).Lshapeless_$colon$colon__f_head);
                                  var p15$2 = $as_Lshapeless_$colon$colon($n(p14$2).Lshapeless_$colon$colon__f_tail);
                                  if ((p15$2 !== null)) {
                                    var district$macro$135 = $as_s_Option($n(p15$2).Lshapeless_$colon$colon__f_head);
                                    var p16$2 = $as_Lshapeless_$colon$colon($n(p15$2).Lshapeless_$colon$colon__f_tail);
                                    if ((p16$2 !== null)) {
                                      var topic$macro$136 = $as_s_Option($n(p16$2).Lshapeless_$colon$colon__f_head);
                                      var p17$2 = $as_Lshapeless_$colon$colon($n(p16$2).Lshapeless_$colon$colon__f_tail);
                                      if ((p17$2 !== null)) {
                                        var modelSource$macro$137 = $as_s_Option($n(p17$2).Lshapeless_$colon$colon__f_head);
                                        var p18$2 = $as_Lshapeless_$colon$colon($n(p17$2).Lshapeless_$colon$colon__f_tail);
                                        if ((p18$2 !== null)) {
                                          var procedureState$macro$138 = $as_s_Option($n(p18$2).Lshapeless_$colon$colon__f_head);
                                          var p19$2 = $as_Lshapeless_$colon$colon($n(p18$2).Lshapeless_$colon$colon__f_tail);
                                          if ((p19$2 !== null)) {
                                            var summary$macro$139 = $as_s_Option($n(p19$2).Lshapeless_$colon$colon__f_head);
                                            var p20$2 = $as_Lshapeless_$colon$colon($n(p19$2).Lshapeless_$colon$colon__f_tail);
                                            if ((p20$2 !== null)) {
                                              var archived$macro$140 = $as_s_Option($n(p20$2).Lshapeless_$colon$colon__f_head);
                                              var p21$2 = $as_Lshapeless_$colon$colon($n(p20$2).Lshapeless_$colon$colon__f_tail);
                                              if ((p21$2 !== null)) {
                                                var parent$macro$141 = $as_s_Option($n(p21$2).Lshapeless_$colon$colon__f_head);
                                                var p22$2 = $as_Lshapeless_$colon$colon($n(p21$2).Lshapeless_$colon$colon__f_tail);
                                                if ((p22$2 !== null)) {
                                                  var address$macro$142 = $as_Lreactbuild_common_model_ProjectAddress($n(p22$2).Lshapeless_$colon$colon__f_head);
                                                  var p23$2 = $as_Lshapeless_$colon$colon($n(p22$2).Lshapeless_$colon$colon__f_tail);
                                                  if ((p23$2 !== null)) {
                                                    var reference$macro$143 = $as_T($n(p23$2).Lshapeless_$colon$colon__f_head);
                                                    var p24$2 = $as_Lshapeless_HNil($n(p23$2).Lshapeless_$colon$colon__f_tail);
                                                    var x$5 = $m_Lshapeless_HNil$();
                                                    if ((x$5 === p24$2)) {
                                                      return new $c_Lreactbuild_common_model_Project(_id$macro$121, organizations$macro$122, name$macro$123, title$macro$124, description$macro$125, images$macro$126, location$macro$127, areas$macro$128, price$macro$129, soldOut$macro$130, privacy$macro$131, scenes$macro$132, renderSettings$macro$133, city$macro$134, district$macro$135, topic$macro$136, modelSource$macro$137, procedureState$macro$138, summary$macro$139, archived$macro$140, parent$macro$141, address$macro$142, reference$macro$143)
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$15)
    }));
    var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$9, g$2);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$46 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$620 = $m_s_Symbol$();
    var value0$104 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$620, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$104);
    var zipWithKeys$47 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$46);
    $m_Lshapeless_Witness$();
    var this$623 = $m_s_Symbol$();
    var value0$105 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$623, "address"));
    new $c_Lshapeless_Witness$$anon$1(value0$105);
    var zipWithKeys$48 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$47);
    $m_Lshapeless_Witness$();
    var this$626 = $m_s_Symbol$();
    var value0$106 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$626, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0$106);
    var zipWithKeys$49 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$48);
    $m_Lshapeless_Witness$();
    var this$629 = $m_s_Symbol$();
    var value0$107 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$629, "archived"));
    new $c_Lshapeless_Witness$$anon$1(value0$107);
    var zipWithKeys$50 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$49);
    $m_Lshapeless_Witness$();
    var this$632 = $m_s_Symbol$();
    var value0$108 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$632, "summary"));
    new $c_Lshapeless_Witness$$anon$1(value0$108);
    var zipWithKeys$51 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$50);
    $m_Lshapeless_Witness$();
    var this$635 = $m_s_Symbol$();
    var value0$109 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$635, "procedureState"));
    new $c_Lshapeless_Witness$$anon$1(value0$109);
    var zipWithKeys$52 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$51);
    $m_Lshapeless_Witness$();
    var this$638 = $m_s_Symbol$();
    var value0$110 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$638, "modelSource"));
    new $c_Lshapeless_Witness$$anon$1(value0$110);
    var zipWithKeys$53 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$52);
    $m_Lshapeless_Witness$();
    var this$641 = $m_s_Symbol$();
    var value0$111 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$641, "topic"));
    new $c_Lshapeless_Witness$$anon$1(value0$111);
    var zipWithKeys$54 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$53);
    $m_Lshapeless_Witness$();
    var this$644 = $m_s_Symbol$();
    var value0$112 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$644, "district"));
    new $c_Lshapeless_Witness$$anon$1(value0$112);
    var zipWithKeys$55 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$54);
    $m_Lshapeless_Witness$();
    var this$647 = $m_s_Symbol$();
    var value0$113 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$647, "city"));
    new $c_Lshapeless_Witness$$anon$1(value0$113);
    var zipWithKeys$56 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$55);
    $m_Lshapeless_Witness$();
    var this$650 = $m_s_Symbol$();
    var value0$114 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$650, "renderSettings"));
    new $c_Lshapeless_Witness$$anon$1(value0$114);
    var zipWithKeys$57 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$56);
    $m_Lshapeless_Witness$();
    var this$653 = $m_s_Symbol$();
    var value0$115 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$653, "scenes"));
    new $c_Lshapeless_Witness$$anon$1(value0$115);
    var zipWithKeys$58 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$57);
    $m_Lshapeless_Witness$();
    var this$656 = $m_s_Symbol$();
    var value0$116 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$656, "privacy"));
    new $c_Lshapeless_Witness$$anon$1(value0$116);
    var zipWithKeys$59 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$58);
    $m_Lshapeless_Witness$();
    var this$659 = $m_s_Symbol$();
    var value0$117 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$659, "soldOut"));
    new $c_Lshapeless_Witness$$anon$1(value0$117);
    var zipWithKeys$60 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$59);
    $m_Lshapeless_Witness$();
    var this$662 = $m_s_Symbol$();
    var value0$118 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$662, "price"));
    new $c_Lshapeless_Witness$$anon$1(value0$118);
    var zipWithKeys$61 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$60);
    $m_Lshapeless_Witness$();
    var this$665 = $m_s_Symbol$();
    var value0$119 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$665, "areas"));
    new $c_Lshapeless_Witness$$anon$1(value0$119);
    var zipWithKeys$62 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$61);
    $m_Lshapeless_Witness$();
    var this$668 = $m_s_Symbol$();
    var value0$120 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$668, "location"));
    new $c_Lshapeless_Witness$$anon$1(value0$120);
    var zipWithKeys$63 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$62);
    $m_Lshapeless_Witness$();
    var this$671 = $m_s_Symbol$();
    var value0$121 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$671, "images"));
    new $c_Lshapeless_Witness$$anon$1(value0$121);
    var zipWithKeys$64 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$63);
    $m_Lshapeless_Witness$();
    var this$674 = $m_s_Symbol$();
    var value0$122 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$674, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$122);
    var zipWithKeys$65 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$64);
    $m_Lshapeless_Witness$();
    var this$677 = $m_s_Symbol$();
    var value0$123 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$677, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$123);
    var zipWithKeys$66 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$65);
    $m_Lshapeless_Witness$();
    var this$680 = $m_s_Symbol$();
    var value0$124 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$680, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$124);
    var zipWithKeys$67 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$66);
    $m_Lshapeless_Witness$();
    var this$683 = $m_s_Symbol$();
    var value0$125 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$683, "organizations"));
    new $c_Lshapeless_Witness$$anon$1(value0$125);
    var zipWithKeys$68 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$67);
    $m_Lshapeless_Witness$();
    var this$686 = $m_s_Symbol$();
    var value0$126 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$686, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$126);
    var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$68);
    var this$689 = $m_s_$less$colon$less$();
    var ev$22 = this$689.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$22);
    var this$855 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$691 = $m_s_Symbol$();
    var value0$127 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$691, "_id"));
    var witness$23 = new $c_Lshapeless_Witness$$anon$1(value0$127);
    var $$x220 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    var this$693 = $m_Lreactbuild_model_Implicits$();
    var format$20 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$693);
    var $$x219 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$20);
    var this$697 = $m_Lreactbuild_model_Implicits$();
    var this$696 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$4 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$23 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$696, proxy$4);
    var $$x218 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$697, ev$23)));
    var $$x217 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$700 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$5 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var textualizable$11 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$700, proxy$5);
    var columnRenderable$11 = $n($$x220).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x219, $$x218, $$x217, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$11));
    var this$854 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Seq[reactbuild.common.model.RefTo[reactbuild.common.model.Organization]]");
    var this$853 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$702 = $m_s_Symbol$();
    var value0$128 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$702, "name"));
    var witness$22 = new $c_Lshapeless_Witness$$anon$1(value0$128);
    var $$x224 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    var format$21 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var $$x223 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$21);
    var $$x222 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
    $m_Lcom_iz2use_common_Parsable$();
    var evDefault$9 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$9 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$9);
    var parser$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var resolver$9 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$9);
    var $$x221 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$9, resolver$9);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$19 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var columnRenderable$10 = $n($$x224).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x223, $$x222, $$x221, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$19));
    var this$852 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$710 = $m_s_Symbol$();
    var value0$129 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$710, "title"));
    var witness$21 = new $c_Lshapeless_Witness$$anon$1(value0$129);
    var $$x228 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    var format$22 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var $$x227 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$22);
    var $$x226 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
    $m_Lcom_iz2use_common_Parsable$();
    var evDefault$10 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$10 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$10);
    var parser$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var resolver$10 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$10);
    var $$x225 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$10, resolver$10);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$21 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var columnRenderable$9 = $n($$x228).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x227, $$x226, $$x225, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$21));
    var this$851 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Option[com.iz2use.common.Multiline]");
    var this$850 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Seq[reactbuild.common.model.Image]");
    var this$849 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Option[reactbuild.common.model.Coordinates]");
    var this$848 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Option[Seq[reactbuild.common.model.Area]]");
    var this$847 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$718 = $m_s_Symbol$();
    var value0$130 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$718, "price"));
    var witness$20 = new $c_Lshapeless_Witness$$anon$1(value0$130);
    var $$x232 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$23 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_double;
    var format$24 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$23);
    var $$x231 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$24);
    var ord$8 = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
    var $$x230 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$8)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$24 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$24);
    var evDefault$11 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$11 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$11);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$25 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser$11 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$25);
    var resolver$11 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$11);
    var $$x229 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$11, resolver$11);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$23 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var textualizable$12 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$23);
    var columnRenderable$8 = $n($$x232).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x231, $$x230, $$x229, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$12));
    var this$846 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$732 = $m_s_Symbol$();
    var value0$131 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$732, "soldOut"));
    var witness$19 = new $c_Lshapeless_Witness$$anon$1(value0$131);
    var $$x236 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$25 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_boolean;
    var format$26 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$25);
    var $$x235 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$26);
    var ord$9 = $m_s_math_Ordering$Boolean$();
    var $$x234 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$9)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$26 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$26);
    var evDefault$12 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$12 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$12);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$27 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var parser$12 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$27);
    var resolver$12 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$12);
    var $$x233 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$12, resolver$12);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$25 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var textualizable$13 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$25);
    var columnRenderable$7 = $n($$x236).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x235, $$x234, $$x233, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$13));
    var this$845 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$746 = $m_s_Symbol$();
    var value0$132 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$746, "privacy"));
    var witness$18 = new $c_Lshapeless_Witness$$anon$1(value0$132);
    var $$x240 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$27 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$28 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$27);
    var $$x239 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$28);
    var ord$10 = $m_s_math_Ordering$String$();
    var $$x238 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$10)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$28 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$28);
    var evDefault$13 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$13 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$13);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$29 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$13 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$29);
    var resolver$13 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$13);
    var $$x237 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$13, resolver$13);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$27 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$14 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$27);
    var columnRenderable$6 = $n($$x240).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x239, $$x238, $$x237, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$14));
    var this$844 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Option[Map[String,String]]");
    var this$843 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Option[reactbuild.common.model.RenderSettings]");
    var this$842 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$760 = $m_s_Symbol$();
    var value0$133 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$760, "city"));
    var witness$17 = new $c_Lshapeless_Witness$$anon$1(value0$133);
    var $$x244 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$29 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$30 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$29);
    var $$x243 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$30);
    var ord$11 = $m_s_math_Ordering$String$();
    var $$x242 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$11)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$30 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$30);
    var evDefault$14 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$14 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$14);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$31 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$14 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$31);
    var resolver$14 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$14);
    var $$x241 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$14, resolver$14);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$29 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$15 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$29);
    var columnRenderable$5 = $n($$x244).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x243, $$x242, $$x241, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$15));
    var this$841 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$774 = $m_s_Symbol$();
    var value0$134 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$774, "district"));
    var witness$16 = new $c_Lshapeless_Witness$$anon$1(value0$134);
    var $$x248 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$31 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$32 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$31);
    var $$x247 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$32);
    var ord$12 = $m_s_math_Ordering$String$();
    var $$x246 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$12)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$32 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$32);
    var evDefault$15 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$15 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$15);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$33 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$15 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$33);
    var resolver$15 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$15);
    var $$x245 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$15, resolver$15);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$31 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$16 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$31);
    var columnRenderable$4 = $n($$x248).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x247, $$x246, $$x245, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$16));
    var this$840 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$788 = $m_s_Symbol$();
    var value0$135 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$788, "topic"));
    var witness$15 = new $c_Lshapeless_Witness$$anon$1(value0$135);
    var $$x252 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$33 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$34 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$33);
    var $$x251 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$34);
    var ord$13 = $m_s_math_Ordering$String$();
    var $$x250 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$13)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$34 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$34);
    var evDefault$16 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$16 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$16);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$35 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$16 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$35);
    var resolver$16 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$16);
    var $$x249 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$16, resolver$16);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$33 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$17 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$33);
    var columnRenderable$3 = $n($$x252).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x251, $$x250, $$x249, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$17));
    var this$839 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Option[com.iz2use.common.Multiline]");
    var this$838 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Option[com.iz2use.common.Multiline]");
    var this$837 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "Option[com.iz2use.common.Multiline]");
    var this$836 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$802 = $m_s_Symbol$();
    var value0$136 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$802, "archived"));
    var witness$14 = new $c_Lshapeless_Witness$$anon$1(value0$136);
    var $$x256 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$35 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
    var format$36 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$35);
    var $$x255 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$36);
    var ord$14 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
    var $$x254 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$14)));
    var $$x253 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$18 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
    var textualizable$19 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$18);
    var columnRenderable$2 = $n($$x256).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x255, $$x254, $$x253, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$19));
    var this$835 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$810 = $m_s_Symbol$();
    var value0$137 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$810, "parent"));
    var witness$13 = new $c_Lshapeless_Witness$$anon$1(value0$137);
    var $$x260 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var this$812 = $m_Lreactbuild_model_Implicits$();
    var format$37 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$812);
    var format$38 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$37);
    var $$x259 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$38);
    var this$817 = $m_Lreactbuild_model_Implicits$();
    var this$816 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$6 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$36 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$816, proxy$6);
    var ord$15 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$817, ev$36);
    var $$x258 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$15)));
    var $$x257 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$821 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$7 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var textualizable$20 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$821, proxy$7);
    var textualizable$21 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$20);
    var columnRenderable$1 = $n($$x260).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x259, $$x258, $$x257, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$21));
    var this$834 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Project", "reactbuild.common.model.ProjectAddress");
    var this$833 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$824 = $m_s_Symbol$();
    var value0$138 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$824, "reference"));
    var witness$12 = new $c_Lshapeless_Witness$$anon$1(value0$138);
    var $$x264 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    var format$39 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var $$x263 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$39);
    var $$x262 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
    $m_Lcom_iz2use_common_Parsable$();
    var evDefault$17 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$17 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$17);
    var parser$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var resolver$17 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$17);
    var $$x261 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$17, resolver$17);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$35 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var columnRenderable = $n($$x264).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x263, $$x262, $$x261, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$35));
    var tail$23 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
    var tail$24 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$833, columnRenderable, witness$12, tail$23);
    var tail$25 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$834, tail$24);
    var tail$26 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$835, columnRenderable$1, witness$13, tail$25);
    var tail$27 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$836, columnRenderable$2, witness$14, tail$26);
    var tail$28 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$837, tail$27);
    var tail$29 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$838, tail$28);
    var tail$30 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$839, tail$29);
    var tail$31 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$840, columnRenderable$3, witness$15, tail$30);
    var tail$32 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$841, columnRenderable$4, witness$16, tail$31);
    var tail$33 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$842, columnRenderable$5, witness$17, tail$32);
    var tail$34 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$843, tail$33);
    var tail$35 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$844, tail$34);
    var tail$36 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$845, columnRenderable$6, witness$18, tail$35);
    var tail$37 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$846, columnRenderable$7, witness$19, tail$36);
    var tail$38 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$847, columnRenderable$8, witness$20, tail$37);
    var tail$39 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$848, tail$38);
    var tail$40 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$849, tail$39);
    var tail$41 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$850, tail$40);
    var tail$42 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$851, tail$41);
    var tail$43 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$852, columnRenderable$9, witness$21, tail$42);
    var tail$44 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$853, columnRenderable$10, witness$22, tail$43);
    var tail$45 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$854, tail$44);
    var renderer$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$855, columnRenderable$11, witness$23, tail$45);
    $m_s_DummyImplicit$();
    new $c_Lshapeless_Refute$$anon$2();
    var columnFragment = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$1);
    var view$1 = new $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment);
    var tail$46 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2();
    var tail$47 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$1, tail$46);
    var tail$48 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$2, tail$47);
    var tail$49 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$862, tail$48);
    var tail$50 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$3, tail$49);
    var tail$51 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$4, tail$50);
    var tail$52 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$5, tail$51);
    var tail$53 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$6, tail$52);
    var mat = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$867, tail$53);
    $m_s_DummyImplicit$();
    new $c_Lshapeless_Refute$$anon$2();
    var $$x265 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViews(mat.apply__sci_List());
    var $$x118 = $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$().Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable;
    var this$870 = $m_s_Symbol$();
    var $$x62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$870, "_id"));
    var this$871 = $m_s_Symbol$();
    var $$x61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$871, "organizations"));
    var this$872 = $m_s_Symbol$();
    var $$x60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$872, "name"));
    var this$873 = $m_s_Symbol$();
    var $$x59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$873, "title"));
    var this$874 = $m_s_Symbol$();
    var $$x58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$874, "description"));
    var this$875 = $m_s_Symbol$();
    var $$x57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$875, "images"));
    var this$876 = $m_s_Symbol$();
    var $$x56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$876, "location"));
    var this$877 = $m_s_Symbol$();
    var $$x55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$877, "areas"));
    var this$878 = $m_s_Symbol$();
    var $$x54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$878, "price"));
    var this$879 = $m_s_Symbol$();
    var $$x53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$879, "soldOut"));
    var this$880 = $m_s_Symbol$();
    var $$x52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$880, "privacy"));
    var this$881 = $m_s_Symbol$();
    var $$x51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$881, "scenes"));
    var this$882 = $m_s_Symbol$();
    var $$x50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$882, "renderSettings"));
    var this$883 = $m_s_Symbol$();
    var $$x49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$883, "city"));
    var this$884 = $m_s_Symbol$();
    var $$x48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$884, "district"));
    var this$885 = $m_s_Symbol$();
    var $$x47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$885, "topic"));
    var this$886 = $m_s_Symbol$();
    var $$x46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$886, "modelSource"));
    var this$887 = $m_s_Symbol$();
    var $$x45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$887, "procedureState"));
    var this$888 = $m_s_Symbol$();
    var $$x44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$888, "summary"));
    var this$889 = $m_s_Symbol$();
    var $$x43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$889, "archived"));
    var this$890 = $m_s_Symbol$();
    var $$x42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$890, "parent"));
    var this$891 = $m_s_Symbol$();
    var $$x41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$891, "address"));
    var this$892 = $m_s_Symbol$();
    var labels$3 = new $c_Lshapeless_$colon$colon($$x62, new $c_Lshapeless_$colon$colon($$x61, new $c_Lshapeless_$colon$colon($$x60, new $c_Lshapeless_$colon$colon($$x59, new $c_Lshapeless_$colon$colon($$x58, new $c_Lshapeless_$colon$colon($$x57, new $c_Lshapeless_$colon$colon($$x56, new $c_Lshapeless_$colon$colon($$x55, new $c_Lshapeless_$colon$colon($$x54, new $c_Lshapeless_$colon$colon($$x53, new $c_Lshapeless_$colon$colon($$x52, new $c_Lshapeless_$colon$colon($$x51, new $c_Lshapeless_$colon$colon($$x50, new $c_Lshapeless_$colon$colon($$x49, new $c_Lshapeless_$colon$colon($$x48, new $c_Lshapeless_$colon$colon($$x47, new $c_Lshapeless_$colon$colon($$x46, new $c_Lshapeless_$colon$colon($$x45, new $c_Lshapeless_$colon$colon($$x44, new $c_Lshapeless_$colon$colon($$x43, new $c_Lshapeless_$colon$colon($$x42, new $c_Lshapeless_$colon$colon($$x41, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$892, "reference")), $m_Lshapeless_HNil$())))))))))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
    var f$10 = new $c_sjsr_AnonFunction1(((x0$18$2) => {
      var x0$18 = $as_Lreactbuild_common_model_Project(x0$18$2);
      return new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f__id, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_organizations, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_name, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_title, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_description, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_images, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_location, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_areas, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_price, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_soldOut, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_privacy, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_scenes, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_renderSettings, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_city, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_district, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_topic, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_modelSource, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_procedureState, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_summary, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_archived, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_parent, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_address, new $c_Lshapeless_$colon$colon($n(x0$18).Lreactbuild_common_model_Project__f_reference, $m_Lshapeless_HNil$())))))))))))))))))))))))
    }));
    var g$3 = new $c_sjsr_AnonFunction1(((x0$19$2) => {
      var x0$19 = $as_Lshapeless_$colon$colon(x0$19$2);
      if ((x0$19 !== null)) {
        var _id$macro$169 = $as_Lreactbuild_common_model_RefTo($n(x0$19).Lshapeless_$colon$colon__f_head);
        var p2$6 = $as_Lshapeless_$colon$colon($n(x0$19).Lshapeless_$colon$colon__f_tail);
        if ((p2$6 !== null)) {
          var organizations$macro$170 = $as_sci_Seq($n(p2$6).Lshapeless_$colon$colon__f_head);
          var p3$3 = $as_Lshapeless_$colon$colon($n(p2$6).Lshapeless_$colon$colon__f_tail);
          if ((p3$3 !== null)) {
            var name$macro$171 = $as_T($n(p3$3).Lshapeless_$colon$colon__f_head);
            var p4$6 = $as_Lshapeless_$colon$colon($n(p3$3).Lshapeless_$colon$colon__f_tail);
            if ((p4$6 !== null)) {
              var title$macro$172 = $as_T($n(p4$6).Lshapeless_$colon$colon__f_head);
              var p5$3 = $as_Lshapeless_$colon$colon($n(p4$6).Lshapeless_$colon$colon__f_tail);
              if ((p5$3 !== null)) {
                var description$macro$173 = $as_s_Option($n(p5$3).Lshapeless_$colon$colon__f_head);
                var p6$3 = $as_Lshapeless_$colon$colon($n(p5$3).Lshapeless_$colon$colon__f_tail);
                if ((p6$3 !== null)) {
                  var images$macro$174 = $as_sci_Seq($n(p6$3).Lshapeless_$colon$colon__f_head);
                  var p7$3 = $as_Lshapeless_$colon$colon($n(p6$3).Lshapeless_$colon$colon__f_tail);
                  if ((p7$3 !== null)) {
                    var location$macro$175 = $as_s_Option($n(p7$3).Lshapeless_$colon$colon__f_head);
                    var p8$3 = $as_Lshapeless_$colon$colon($n(p7$3).Lshapeless_$colon$colon__f_tail);
                    if ((p8$3 !== null)) {
                      var areas$macro$176 = $as_s_Option($n(p8$3).Lshapeless_$colon$colon__f_head);
                      var p9$3 = $as_Lshapeless_$colon$colon($n(p8$3).Lshapeless_$colon$colon__f_tail);
                      if ((p9$3 !== null)) {
                        var price$macro$177 = $as_s_Option($n(p9$3).Lshapeless_$colon$colon__f_head);
                        var p10$3 = $as_Lshapeless_$colon$colon($n(p9$3).Lshapeless_$colon$colon__f_tail);
                        if ((p10$3 !== null)) {
                          var soldOut$macro$178 = $as_s_Option($n(p10$3).Lshapeless_$colon$colon__f_head);
                          var p11$3 = $as_Lshapeless_$colon$colon($n(p10$3).Lshapeless_$colon$colon__f_tail);
                          if ((p11$3 !== null)) {
                            var privacy$macro$179 = $as_s_Option($n(p11$3).Lshapeless_$colon$colon__f_head);
                            var p12$3 = $as_Lshapeless_$colon$colon($n(p11$3).Lshapeless_$colon$colon__f_tail);
                            if ((p12$3 !== null)) {
                              var scenes$macro$180 = $as_s_Option($n(p12$3).Lshapeless_$colon$colon__f_head);
                              var p13$3 = $as_Lshapeless_$colon$colon($n(p12$3).Lshapeless_$colon$colon__f_tail);
                              if ((p13$3 !== null)) {
                                var renderSettings$macro$181 = $as_s_Option($n(p13$3).Lshapeless_$colon$colon__f_head);
                                var p14$3 = $as_Lshapeless_$colon$colon($n(p13$3).Lshapeless_$colon$colon__f_tail);
                                if ((p14$3 !== null)) {
                                  var city$macro$182 = $as_s_Option($n(p14$3).Lshapeless_$colon$colon__f_head);
                                  var p15$3 = $as_Lshapeless_$colon$colon($n(p14$3).Lshapeless_$colon$colon__f_tail);
                                  if ((p15$3 !== null)) {
                                    var district$macro$183 = $as_s_Option($n(p15$3).Lshapeless_$colon$colon__f_head);
                                    var p16$3 = $as_Lshapeless_$colon$colon($n(p15$3).Lshapeless_$colon$colon__f_tail);
                                    if ((p16$3 !== null)) {
                                      var topic$macro$184 = $as_s_Option($n(p16$3).Lshapeless_$colon$colon__f_head);
                                      var p17$3 = $as_Lshapeless_$colon$colon($n(p16$3).Lshapeless_$colon$colon__f_tail);
                                      if ((p17$3 !== null)) {
                                        var modelSource$macro$185 = $as_s_Option($n(p17$3).Lshapeless_$colon$colon__f_head);
                                        var p18$3 = $as_Lshapeless_$colon$colon($n(p17$3).Lshapeless_$colon$colon__f_tail);
                                        if ((p18$3 !== null)) {
                                          var procedureState$macro$186 = $as_s_Option($n(p18$3).Lshapeless_$colon$colon__f_head);
                                          var p19$3 = $as_Lshapeless_$colon$colon($n(p18$3).Lshapeless_$colon$colon__f_tail);
                                          if ((p19$3 !== null)) {
                                            var summary$macro$187 = $as_s_Option($n(p19$3).Lshapeless_$colon$colon__f_head);
                                            var p20$3 = $as_Lshapeless_$colon$colon($n(p19$3).Lshapeless_$colon$colon__f_tail);
                                            if ((p20$3 !== null)) {
                                              var archived$macro$188 = $as_s_Option($n(p20$3).Lshapeless_$colon$colon__f_head);
                                              var p21$3 = $as_Lshapeless_$colon$colon($n(p20$3).Lshapeless_$colon$colon__f_tail);
                                              if ((p21$3 !== null)) {
                                                var parent$macro$189 = $as_s_Option($n(p21$3).Lshapeless_$colon$colon__f_head);
                                                var p22$3 = $as_Lshapeless_$colon$colon($n(p21$3).Lshapeless_$colon$colon__f_tail);
                                                if ((p22$3 !== null)) {
                                                  var address$macro$190 = $as_Lreactbuild_common_model_ProjectAddress($n(p22$3).Lshapeless_$colon$colon__f_head);
                                                  var p23$3 = $as_Lshapeless_$colon$colon($n(p22$3).Lshapeless_$colon$colon__f_tail);
                                                  if ((p23$3 !== null)) {
                                                    var reference$macro$191 = $as_T($n(p23$3).Lshapeless_$colon$colon__f_head);
                                                    var p24$3 = $as_Lshapeless_HNil($n(p23$3).Lshapeless_$colon$colon__f_tail);
                                                    var x$6 = $m_Lshapeless_HNil$();
                                                    if ((x$6 === p24$3)) {
                                                      return new $c_Lreactbuild_common_model_Project(_id$macro$169, organizations$macro$170, name$macro$171, title$macro$172, description$macro$173, images$macro$174, location$macro$175, areas$macro$176, price$macro$177, soldOut$macro$178, privacy$macro$179, scenes$macro$180, renderSettings$macro$181, city$macro$182, district$macro$183, topic$macro$184, modelSource$macro$185, procedureState$macro$186, summary$macro$187, archived$macro$188, parent$macro$189, address$macro$190, reference$macro$191)
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$19)
    }));
    var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$10, g$3);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$69 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$895 = $m_s_Symbol$();
    var value0$139 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$895, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$139);
    var zipWithKeys$70 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$69);
    $m_Lshapeless_Witness$();
    var this$898 = $m_s_Symbol$();
    var value0$140 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$898, "address"));
    new $c_Lshapeless_Witness$$anon$1(value0$140);
    var zipWithKeys$71 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$70);
    $m_Lshapeless_Witness$();
    var this$901 = $m_s_Symbol$();
    var value0$141 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$901, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0$141);
    var zipWithKeys$72 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$71);
    $m_Lshapeless_Witness$();
    var this$904 = $m_s_Symbol$();
    var value0$142 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$904, "archived"));
    new $c_Lshapeless_Witness$$anon$1(value0$142);
    var zipWithKeys$73 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$72);
    $m_Lshapeless_Witness$();
    var this$907 = $m_s_Symbol$();
    var value0$143 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$907, "summary"));
    new $c_Lshapeless_Witness$$anon$1(value0$143);
    var zipWithKeys$74 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$73);
    $m_Lshapeless_Witness$();
    var this$910 = $m_s_Symbol$();
    var value0$144 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$910, "procedureState"));
    new $c_Lshapeless_Witness$$anon$1(value0$144);
    var zipWithKeys$75 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$74);
    $m_Lshapeless_Witness$();
    var this$913 = $m_s_Symbol$();
    var value0$145 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$913, "modelSource"));
    new $c_Lshapeless_Witness$$anon$1(value0$145);
    var zipWithKeys$76 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$75);
    $m_Lshapeless_Witness$();
    var this$916 = $m_s_Symbol$();
    var value0$146 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$916, "topic"));
    new $c_Lshapeless_Witness$$anon$1(value0$146);
    var zipWithKeys$77 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$76);
    $m_Lshapeless_Witness$();
    var this$919 = $m_s_Symbol$();
    var value0$147 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$919, "district"));
    new $c_Lshapeless_Witness$$anon$1(value0$147);
    var zipWithKeys$78 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$77);
    $m_Lshapeless_Witness$();
    var this$922 = $m_s_Symbol$();
    var value0$148 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$922, "city"));
    new $c_Lshapeless_Witness$$anon$1(value0$148);
    var zipWithKeys$79 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$78);
    $m_Lshapeless_Witness$();
    var this$925 = $m_s_Symbol$();
    var value0$149 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$925, "renderSettings"));
    new $c_Lshapeless_Witness$$anon$1(value0$149);
    var zipWithKeys$80 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$79);
    $m_Lshapeless_Witness$();
    var this$928 = $m_s_Symbol$();
    var value0$150 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$928, "scenes"));
    new $c_Lshapeless_Witness$$anon$1(value0$150);
    var zipWithKeys$81 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$80);
    $m_Lshapeless_Witness$();
    var this$931 = $m_s_Symbol$();
    var value0$151 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$931, "privacy"));
    new $c_Lshapeless_Witness$$anon$1(value0$151);
    var zipWithKeys$82 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$81);
    $m_Lshapeless_Witness$();
    var this$934 = $m_s_Symbol$();
    var value0$152 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$934, "soldOut"));
    new $c_Lshapeless_Witness$$anon$1(value0$152);
    var zipWithKeys$83 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$82);
    $m_Lshapeless_Witness$();
    var this$937 = $m_s_Symbol$();
    var value0$153 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$937, "price"));
    new $c_Lshapeless_Witness$$anon$1(value0$153);
    var zipWithKeys$84 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$83);
    $m_Lshapeless_Witness$();
    var this$940 = $m_s_Symbol$();
    var value0$154 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$940, "areas"));
    new $c_Lshapeless_Witness$$anon$1(value0$154);
    var zipWithKeys$85 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$84);
    $m_Lshapeless_Witness$();
    var this$943 = $m_s_Symbol$();
    var value0$155 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$943, "location"));
    new $c_Lshapeless_Witness$$anon$1(value0$155);
    var zipWithKeys$86 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$85);
    $m_Lshapeless_Witness$();
    var this$946 = $m_s_Symbol$();
    var value0$156 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$946, "images"));
    new $c_Lshapeless_Witness$$anon$1(value0$156);
    var zipWithKeys$87 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$86);
    $m_Lshapeless_Witness$();
    var this$949 = $m_s_Symbol$();
    var value0$157 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$949, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$157);
    var zipWithKeys$88 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$87);
    $m_Lshapeless_Witness$();
    var this$952 = $m_s_Symbol$();
    var value0$158 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$952, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$158);
    var zipWithKeys$89 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$88);
    $m_Lshapeless_Witness$();
    var this$955 = $m_s_Symbol$();
    var value0$159 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$955, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$159);
    var zipWithKeys$90 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$89);
    $m_Lshapeless_Witness$();
    var this$958 = $m_s_Symbol$();
    var value0$160 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$958, "organizations"));
    new $c_Lshapeless_Witness$$anon$1(value0$160);
    var zipWithKeys$91 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$90);
    $m_Lshapeless_Witness$();
    var this$961 = $m_s_Symbol$();
    var value0$161 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$961, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$161);
    var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$91);
    var this$964 = $m_s_$less$colon$less$();
    var ev$37 = this$964.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$37);
    $m_Lshapeless_Witness$();
    var this$966 = $m_s_Symbol$();
    var value0$162 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$966, "_id"));
    var witness$35 = new $c_Lshapeless_Witness$$anon$1(value0$162);
    var $$x66 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var this$968 = $m_Lreactbuild_model_Implicits$();
    var format$40 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$968);
    var $$x65 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$40);
    var this$972 = $m_Lreactbuild_model_Implicits$();
    var this$971 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$8 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$38 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$971, proxy$8);
    var $$x64 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$972, ev$38)));
    var $$x63 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$975 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$9 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var textualizable$22 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$975, proxy$9);
    var fieldRenderable$23 = $n($$x66).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x65, $$x64, $$x63, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$22), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$1135 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    $m_Lshapeless_Witness$();
    var this$977 = $m_s_Symbol$();
    var value0$163 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$977, "name"));
    var witness$34 = new $c_Lshapeless_Witness$$anon$1(value0$163);
    var $$x70 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$41 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var $$x69 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$41);
    var $$x68 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
    $m_Lcom_iz2use_common_Parsable$();
    var evDefault$18 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$18 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$18);
    var parser$18 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var resolver$18 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$18);
    var $$x67 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$18, resolver$18);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$37 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$22 = $n($$x70).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x69, $$x68, $$x67, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$37), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
    $m_Lshapeless_Witness$();
    var this$985 = $m_s_Symbol$();
    var value0$164 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$985, "title"));
    var witness$33 = new $c_Lshapeless_Witness$$anon$1(value0$164);
    var $$x74 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$42 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var $$x73 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$42);
    var $$x72 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
    $m_Lcom_iz2use_common_Parsable$();
    var evDefault$19 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$19 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$19);
    var parser$19 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var resolver$19 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$19);
    var $$x71 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$19, resolver$19);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$39 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$21 = $n($$x74).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x73, $$x72, $$x71, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$39), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
    var this$1132 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    var this$1131 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    var this$1130 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    var this$1129 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    $m_Lshapeless_Witness$();
    var this$993 = $m_s_Symbol$();
    var value0$165 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$993, "price"));
    var witness$32 = new $c_Lshapeless_Witness$$anon$1(value0$165);
    var $$x79 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$43 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_double;
    var format$44 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$43);
    var $$x78 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$44);
    var ord$16 = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
    var $$x77 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$16)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$39 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$39);
    var evDefault$20 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$20 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$20);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$40 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser$20 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$40);
    var resolver$20 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$20);
    var $$x76 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$20, resolver$20);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$41 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var textualizable$23 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$41);
    var $$x75 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$23);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$41 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var fieldRenderable$20 = $n($$x79).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x78, $$x77, $$x76, $$x75, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$41))));
    $m_Lshapeless_Witness$();
    var this$1008 = $m_s_Symbol$();
    var value0$166 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1008, "soldOut"));
    var witness$31 = new $c_Lshapeless_Witness$$anon$1(value0$166);
    var $$x84 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$45 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_boolean;
    var format$46 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$45);
    var $$x83 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$46);
    var ord$17 = $m_s_math_Ordering$Boolean$();
    var $$x82 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$17)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$42 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$42);
    var evDefault$21 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$21 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$21);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$43 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var parser$21 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$43);
    var resolver$21 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$21);
    var $$x81 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$21, resolver$21);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$43 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var textualizable$24 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$43);
    var $$x80 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$24);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$44 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var fieldRenderable$19 = $n($$x84).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x83, $$x82, $$x81, $$x80, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$44))));
    $m_Lshapeless_Witness$();
    var this$1023 = $m_s_Symbol$();
    var value0$167 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1023, "privacy"));
    var witness$30 = new $c_Lshapeless_Witness$$anon$1(value0$167);
    var $$x89 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$47 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$48 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$47);
    var $$x88 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$48);
    var ord$18 = $m_s_math_Ordering$String$();
    var $$x87 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$18)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$45 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$45);
    var evDefault$22 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$22 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$22);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$46 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$22 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$46);
    var resolver$22 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$22);
    var $$x86 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$22, resolver$22);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$45 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$25 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$45);
    var $$x85 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$25);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$47 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$18 = $n($$x89).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x88, $$x87, $$x86, $$x85, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$47))));
    var this$1125 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    var this$1124 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    $m_Lshapeless_Witness$();
    var this$1038 = $m_s_Symbol$();
    var value0$168 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1038, "city"));
    var witness$29 = new $c_Lshapeless_Witness$$anon$1(value0$168);
    var $$x94 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$49 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$50 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$49);
    var $$x93 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$50);
    var ord$19 = $m_s_math_Ordering$String$();
    var $$x92 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$19)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$48 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$48);
    var evDefault$23 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$23 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$23);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$49 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$23 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$49);
    var resolver$23 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$23);
    var $$x91 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$23, resolver$23);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$47 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$26 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$47);
    var $$x90 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$26);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$50 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$17 = $n($$x94).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x93, $$x92, $$x91, $$x90, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$50))));
    $m_Lshapeless_Witness$();
    var this$1053 = $m_s_Symbol$();
    var value0$169 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1053, "district"));
    var witness$28 = new $c_Lshapeless_Witness$$anon$1(value0$169);
    var $$x99 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$51 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$52 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$51);
    var $$x98 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$52);
    var ord$20 = $m_s_math_Ordering$String$();
    var $$x97 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$20)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$51 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$51);
    var evDefault$24 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$24 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$24);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$52 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$24 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$52);
    var resolver$24 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$24);
    var $$x96 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$24, resolver$24);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$49 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$27 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$49);
    var $$x95 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$27);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$53 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$16 = $n($$x99).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x98, $$x97, $$x96, $$x95, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$53))));
    $m_Lshapeless_Witness$();
    var this$1068 = $m_s_Symbol$();
    var value0$170 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1068, "topic"));
    var witness$27 = new $c_Lshapeless_Witness$$anon$1(value0$170);
    var $$x104 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$53 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$54 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$53);
    var $$x103 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$54);
    var ord$21 = $m_s_math_Ordering$String$();
    var $$x102 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$21)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$54 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$54);
    var evDefault$25 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$25 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$25);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$55 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$25 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$55);
    var resolver$25 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$25);
    var $$x101 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$25, resolver$25);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$51 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$28 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$51);
    var $$x100 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$28);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$56 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$15 = $n($$x104).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x103, $$x102, $$x101, $$x100, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$56))));
    var this$1120 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    var this$1119 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    var this$1118 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    $m_Lshapeless_Witness$();
    var this$1083 = $m_s_Symbol$();
    var value0$171 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1083, "archived"));
    var witness$26 = new $c_Lshapeless_Witness$$anon$1(value0$171);
    var $$x108 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$55 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
    var format$56 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$55);
    var $$x107 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$56);
    var ord$22 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
    var $$x106 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$22)));
    var $$x105 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$29 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
    var textualizable$30 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$29);
    var fieldRenderable$14 = $n($$x108).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x107, $$x106, $$x105, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$30), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    $m_Lshapeless_Witness$();
    var this$1091 = $m_s_Symbol$();
    var value0$172 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1091, "parent"));
    var witness$25 = new $c_Lshapeless_Witness$$anon$1(value0$172);
    var $$x112 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var this$1093 = $m_Lreactbuild_model_Implicits$();
    var format$57 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$1093);
    var format$58 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$57);
    var $$x111 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$58);
    var this$1098 = $m_Lreactbuild_model_Implicits$();
    var this$1097 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$10 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$57 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$1097, proxy$10);
    var ord$23 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$1098, ev$57);
    var $$x110 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$23)));
    var $$x109 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$1102 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$11 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var textualizable$31 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$1102, proxy$11);
    var textualizable$32 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$31);
    var fieldRenderable$13 = $n($$x112).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x111, $$x110, $$x109, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$32), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$1115 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    $m_Lshapeless_Witness$();
    var this$1105 = $m_s_Symbol$();
    var value0$173 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1105, "reference"));
    var witness$24 = new $c_Lshapeless_Witness$$anon$1(value0$173);
    var $$x116 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$59 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var $$x115 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$59);
    var $$x114 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
    $m_Lcom_iz2use_common_Parsable$();
    var evDefault$26 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$26 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$26);
    var parser$26 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var resolver$26 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$26);
    var $$x113 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$26, resolver$26);
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$53 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$12 = $n($$x116).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x115, $$x114, $$x113, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$53), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
    var tail$54 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3();
    var tail$55 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$12, witness$24, tail$54);
    var tail$56 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1115, tail$55);
    var tail$57 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$13, witness$25, tail$56);
    var tail$58 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$14, witness$26, tail$57);
    var tail$59 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1118, tail$58);
    var tail$60 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1119, tail$59);
    var tail$61 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1120, tail$60);
    var tail$62 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$15, witness$27, tail$61);
    var tail$63 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$16, witness$28, tail$62);
    var tail$64 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$17, witness$29, tail$63);
    var tail$65 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1124, tail$64);
    var tail$66 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1125, tail$65);
    var tail$67 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$18, witness$30, tail$66);
    var tail$68 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$19, witness$31, tail$67);
    var tail$69 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$20, witness$32, tail$68);
    var tail$70 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1129, tail$69);
    var tail$71 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1130, tail$70);
    var tail$72 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1131, tail$71);
    var tail$73 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1132, tail$72);
    var tail$74 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$21, witness$33, tail$73);
    var tail$75 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$22, witness$34, tail$74);
    var tail$76 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$1135, tail$75);
    var renderer$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$23, witness$35, tail$76);
    var $$x117 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$2);
    var $$x40 = $m_Lreactbuild_common_model_Project$().keyMapper__Lcom_iz2use_common_KeyMapper();
    var $$x39 = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
    var $$x38 = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
    var this$1138 = $m_s_Symbol$();
    var $$x36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1138, "_id"));
    var this$1139 = $m_s_Symbol$();
    var $$x35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1139, "organizations"));
    var this$1140 = $m_s_Symbol$();
    var $$x34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1140, "name"));
    var this$1141 = $m_s_Symbol$();
    var $$x33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1141, "title"));
    var this$1142 = $m_s_Symbol$();
    var $$x32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1142, "description"));
    var this$1143 = $m_s_Symbol$();
    var $$x31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1143, "images"));
    var this$1144 = $m_s_Symbol$();
    var $$x30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1144, "location"));
    var this$1145 = $m_s_Symbol$();
    var $$x29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1145, "areas"));
    var this$1146 = $m_s_Symbol$();
    var $$x28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1146, "price"));
    var this$1147 = $m_s_Symbol$();
    var $$x27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1147, "soldOut"));
    var this$1148 = $m_s_Symbol$();
    var $$x26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1148, "privacy"));
    var this$1149 = $m_s_Symbol$();
    var $$x25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1149, "scenes"));
    var this$1150 = $m_s_Symbol$();
    var $$x24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1150, "renderSettings"));
    var this$1151 = $m_s_Symbol$();
    var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1151, "city"));
    var this$1152 = $m_s_Symbol$();
    var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1152, "district"));
    var this$1153 = $m_s_Symbol$();
    var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1153, "topic"));
    var this$1154 = $m_s_Symbol$();
    var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1154, "modelSource"));
    var this$1155 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1155, "procedureState"));
    var this$1156 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1156, "summary"));
    var this$1157 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1157, "archived"));
    var this$1158 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1158, "parent"));
    var this$1159 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1159, "address"));
    var this$1160 = $m_s_Symbol$();
    var labels$4 = new $c_Lshapeless_$colon$colon($$x36, new $c_Lshapeless_$colon$colon($$x35, new $c_Lshapeless_$colon$colon($$x34, new $c_Lshapeless_$colon$colon($$x33, new $c_Lshapeless_$colon$colon($$x32, new $c_Lshapeless_$colon$colon($$x31, new $c_Lshapeless_$colon$colon($$x30, new $c_Lshapeless_$colon$colon($$x29, new $c_Lshapeless_$colon$colon($$x28, new $c_Lshapeless_$colon$colon($$x27, new $c_Lshapeless_$colon$colon($$x26, new $c_Lshapeless_$colon$colon($$x25, new $c_Lshapeless_$colon$colon($$x24, new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1160, "reference")), $m_Lshapeless_HNil$())))))))))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$4);
    var f$11 = new $c_sjsr_AnonFunction1(((x0$22$2) => {
      var x0$22 = $as_Lreactbuild_common_model_Project(x0$22$2);
      return new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f__id, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_organizations, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_name, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_title, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_description, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_images, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_location, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_areas, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_price, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_soldOut, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_privacy, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_scenes, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_renderSettings, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_city, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_district, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_topic, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_modelSource, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_procedureState, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_summary, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_archived, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_parent, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_address, new $c_Lshapeless_$colon$colon($n(x0$22).Lreactbuild_common_model_Project__f_reference, $m_Lshapeless_HNil$())))))))))))))))))))))))
    }));
    var g$4 = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lshapeless_$colon$colon(x0$23$2);
      if ((x0$23 !== null)) {
        var _id$macro$217 = $as_Lreactbuild_common_model_RefTo($n(x0$23).Lshapeless_$colon$colon__f_head);
        var p2$7 = $as_Lshapeless_$colon$colon($n(x0$23).Lshapeless_$colon$colon__f_tail);
        if ((p2$7 !== null)) {
          var organizations$macro$218 = $as_sci_Seq($n(p2$7).Lshapeless_$colon$colon__f_head);
          var p3$4 = $as_Lshapeless_$colon$colon($n(p2$7).Lshapeless_$colon$colon__f_tail);
          if ((p3$4 !== null)) {
            var name$macro$219 = $as_T($n(p3$4).Lshapeless_$colon$colon__f_head);
            var p4$7 = $as_Lshapeless_$colon$colon($n(p3$4).Lshapeless_$colon$colon__f_tail);
            if ((p4$7 !== null)) {
              var title$macro$220 = $as_T($n(p4$7).Lshapeless_$colon$colon__f_head);
              var p5$4 = $as_Lshapeless_$colon$colon($n(p4$7).Lshapeless_$colon$colon__f_tail);
              if ((p5$4 !== null)) {
                var description$macro$221 = $as_s_Option($n(p5$4).Lshapeless_$colon$colon__f_head);
                var p6$4 = $as_Lshapeless_$colon$colon($n(p5$4).Lshapeless_$colon$colon__f_tail);
                if ((p6$4 !== null)) {
                  var images$macro$222 = $as_sci_Seq($n(p6$4).Lshapeless_$colon$colon__f_head);
                  var p7$4 = $as_Lshapeless_$colon$colon($n(p6$4).Lshapeless_$colon$colon__f_tail);
                  if ((p7$4 !== null)) {
                    var location$macro$223 = $as_s_Option($n(p7$4).Lshapeless_$colon$colon__f_head);
                    var p8$4 = $as_Lshapeless_$colon$colon($n(p7$4).Lshapeless_$colon$colon__f_tail);
                    if ((p8$4 !== null)) {
                      var areas$macro$224 = $as_s_Option($n(p8$4).Lshapeless_$colon$colon__f_head);
                      var p9$4 = $as_Lshapeless_$colon$colon($n(p8$4).Lshapeless_$colon$colon__f_tail);
                      if ((p9$4 !== null)) {
                        var price$macro$225 = $as_s_Option($n(p9$4).Lshapeless_$colon$colon__f_head);
                        var p10$4 = $as_Lshapeless_$colon$colon($n(p9$4).Lshapeless_$colon$colon__f_tail);
                        if ((p10$4 !== null)) {
                          var soldOut$macro$226 = $as_s_Option($n(p10$4).Lshapeless_$colon$colon__f_head);
                          var p11$4 = $as_Lshapeless_$colon$colon($n(p10$4).Lshapeless_$colon$colon__f_tail);
                          if ((p11$4 !== null)) {
                            var privacy$macro$227 = $as_s_Option($n(p11$4).Lshapeless_$colon$colon__f_head);
                            var p12$4 = $as_Lshapeless_$colon$colon($n(p11$4).Lshapeless_$colon$colon__f_tail);
                            if ((p12$4 !== null)) {
                              var scenes$macro$228 = $as_s_Option($n(p12$4).Lshapeless_$colon$colon__f_head);
                              var p13$4 = $as_Lshapeless_$colon$colon($n(p12$4).Lshapeless_$colon$colon__f_tail);
                              if ((p13$4 !== null)) {
                                var renderSettings$macro$229 = $as_s_Option($n(p13$4).Lshapeless_$colon$colon__f_head);
                                var p14$4 = $as_Lshapeless_$colon$colon($n(p13$4).Lshapeless_$colon$colon__f_tail);
                                if ((p14$4 !== null)) {
                                  var city$macro$230 = $as_s_Option($n(p14$4).Lshapeless_$colon$colon__f_head);
                                  var p15$4 = $as_Lshapeless_$colon$colon($n(p14$4).Lshapeless_$colon$colon__f_tail);
                                  if ((p15$4 !== null)) {
                                    var district$macro$231 = $as_s_Option($n(p15$4).Lshapeless_$colon$colon__f_head);
                                    var p16$4 = $as_Lshapeless_$colon$colon($n(p15$4).Lshapeless_$colon$colon__f_tail);
                                    if ((p16$4 !== null)) {
                                      var topic$macro$232 = $as_s_Option($n(p16$4).Lshapeless_$colon$colon__f_head);
                                      var p17$4 = $as_Lshapeless_$colon$colon($n(p16$4).Lshapeless_$colon$colon__f_tail);
                                      if ((p17$4 !== null)) {
                                        var modelSource$macro$233 = $as_s_Option($n(p17$4).Lshapeless_$colon$colon__f_head);
                                        var p18$4 = $as_Lshapeless_$colon$colon($n(p17$4).Lshapeless_$colon$colon__f_tail);
                                        if ((p18$4 !== null)) {
                                          var procedureState$macro$234 = $as_s_Option($n(p18$4).Lshapeless_$colon$colon__f_head);
                                          var p19$4 = $as_Lshapeless_$colon$colon($n(p18$4).Lshapeless_$colon$colon__f_tail);
                                          if ((p19$4 !== null)) {
                                            var summary$macro$235 = $as_s_Option($n(p19$4).Lshapeless_$colon$colon__f_head);
                                            var p20$4 = $as_Lshapeless_$colon$colon($n(p19$4).Lshapeless_$colon$colon__f_tail);
                                            if ((p20$4 !== null)) {
                                              var archived$macro$236 = $as_s_Option($n(p20$4).Lshapeless_$colon$colon__f_head);
                                              var p21$4 = $as_Lshapeless_$colon$colon($n(p20$4).Lshapeless_$colon$colon__f_tail);
                                              if ((p21$4 !== null)) {
                                                var parent$macro$237 = $as_s_Option($n(p21$4).Lshapeless_$colon$colon__f_head);
                                                var p22$4 = $as_Lshapeless_$colon$colon($n(p21$4).Lshapeless_$colon$colon__f_tail);
                                                if ((p22$4 !== null)) {
                                                  var address$macro$238 = $as_Lreactbuild_common_model_ProjectAddress($n(p22$4).Lshapeless_$colon$colon__f_head);
                                                  var p23$4 = $as_Lshapeless_$colon$colon($n(p22$4).Lshapeless_$colon$colon__f_tail);
                                                  if ((p23$4 !== null)) {
                                                    var reference$macro$239 = $as_T($n(p23$4).Lshapeless_$colon$colon__f_head);
                                                    var p24$4 = $as_Lshapeless_HNil($n(p23$4).Lshapeless_$colon$colon__f_tail);
                                                    var x$7 = $m_Lshapeless_HNil$();
                                                    if ((x$7 === p24$4)) {
                                                      return new $c_Lreactbuild_common_model_Project(_id$macro$217, organizations$macro$218, name$macro$219, title$macro$220, description$macro$221, images$macro$222, location$macro$223, areas$macro$224, price$macro$225, soldOut$macro$226, privacy$macro$227, scenes$macro$228, renderSettings$macro$229, city$macro$230, district$macro$231, topic$macro$232, modelSource$macro$233, procedureState$macro$234, summary$macro$235, archived$macro$236, parent$macro$237, address$macro$238, reference$macro$239)
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$23)
    }));
    var gen$8 = new $c_Lshapeless_Generic$$anon$1(f$11, g$4);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$92 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$1163 = $m_s_Symbol$();
    var value0$174 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1163, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$174);
    var zipWithKeys$93 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$92);
    $m_Lshapeless_Witness$();
    var this$1166 = $m_s_Symbol$();
    var value0$175 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1166, "address"));
    new $c_Lshapeless_Witness$$anon$1(value0$175);
    var zipWithKeys$94 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$93);
    $m_Lshapeless_Witness$();
    var this$1169 = $m_s_Symbol$();
    var value0$176 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1169, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0$176);
    var zipWithKeys$95 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$94);
    $m_Lshapeless_Witness$();
    var this$1172 = $m_s_Symbol$();
    var value0$177 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1172, "archived"));
    new $c_Lshapeless_Witness$$anon$1(value0$177);
    var zipWithKeys$96 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$95);
    $m_Lshapeless_Witness$();
    var this$1175 = $m_s_Symbol$();
    var value0$178 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1175, "summary"));
    new $c_Lshapeless_Witness$$anon$1(value0$178);
    var zipWithKeys$97 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$96);
    $m_Lshapeless_Witness$();
    var this$1178 = $m_s_Symbol$();
    var value0$179 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1178, "procedureState"));
    new $c_Lshapeless_Witness$$anon$1(value0$179);
    var zipWithKeys$98 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$97);
    $m_Lshapeless_Witness$();
    var this$1181 = $m_s_Symbol$();
    var value0$180 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1181, "modelSource"));
    new $c_Lshapeless_Witness$$anon$1(value0$180);
    var zipWithKeys$99 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$98);
    $m_Lshapeless_Witness$();
    var this$1184 = $m_s_Symbol$();
    var value0$181 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1184, "topic"));
    new $c_Lshapeless_Witness$$anon$1(value0$181);
    var zipWithKeys$100 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$99);
    $m_Lshapeless_Witness$();
    var this$1187 = $m_s_Symbol$();
    var value0$182 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1187, "district"));
    new $c_Lshapeless_Witness$$anon$1(value0$182);
    var zipWithKeys$101 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$100);
    $m_Lshapeless_Witness$();
    var this$1190 = $m_s_Symbol$();
    var value0$183 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1190, "city"));
    new $c_Lshapeless_Witness$$anon$1(value0$183);
    var zipWithKeys$102 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$101);
    $m_Lshapeless_Witness$();
    var this$1193 = $m_s_Symbol$();
    var value0$184 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1193, "renderSettings"));
    new $c_Lshapeless_Witness$$anon$1(value0$184);
    var zipWithKeys$103 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$102);
    $m_Lshapeless_Witness$();
    var this$1196 = $m_s_Symbol$();
    var value0$185 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1196, "scenes"));
    new $c_Lshapeless_Witness$$anon$1(value0$185);
    var zipWithKeys$104 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$103);
    $m_Lshapeless_Witness$();
    var this$1199 = $m_s_Symbol$();
    var value0$186 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1199, "privacy"));
    new $c_Lshapeless_Witness$$anon$1(value0$186);
    var zipWithKeys$105 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$104);
    $m_Lshapeless_Witness$();
    var this$1202 = $m_s_Symbol$();
    var value0$187 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1202, "soldOut"));
    new $c_Lshapeless_Witness$$anon$1(value0$187);
    var zipWithKeys$106 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$105);
    $m_Lshapeless_Witness$();
    var this$1205 = $m_s_Symbol$();
    var value0$188 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1205, "price"));
    new $c_Lshapeless_Witness$$anon$1(value0$188);
    var zipWithKeys$107 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$106);
    $m_Lshapeless_Witness$();
    var this$1208 = $m_s_Symbol$();
    var value0$189 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1208, "areas"));
    new $c_Lshapeless_Witness$$anon$1(value0$189);
    var zipWithKeys$108 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$107);
    $m_Lshapeless_Witness$();
    var this$1211 = $m_s_Symbol$();
    var value0$190 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1211, "location"));
    new $c_Lshapeless_Witness$$anon$1(value0$190);
    var zipWithKeys$109 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$108);
    $m_Lshapeless_Witness$();
    var this$1214 = $m_s_Symbol$();
    var value0$191 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1214, "images"));
    new $c_Lshapeless_Witness$$anon$1(value0$191);
    var zipWithKeys$110 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$109);
    $m_Lshapeless_Witness$();
    var this$1217 = $m_s_Symbol$();
    var value0$192 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1217, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$192);
    var zipWithKeys$111 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$110);
    $m_Lshapeless_Witness$();
    var this$1220 = $m_s_Symbol$();
    var value0$193 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1220, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$193);
    var zipWithKeys$112 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$111);
    $m_Lshapeless_Witness$();
    var this$1223 = $m_s_Symbol$();
    var value0$194 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1223, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$194);
    var zipWithKeys$113 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$112);
    $m_Lshapeless_Witness$();
    var this$1226 = $m_s_Symbol$();
    var value0$195 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1226, "organizations"));
    new $c_Lshapeless_Witness$$anon$1(value0$195);
    var zipWithKeys$114 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$113);
    $m_Lshapeless_Witness$();
    var this$1229 = $m_s_Symbol$();
    var value0$196 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1229, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$196);
    var zip$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$114);
    var this$1232 = $m_s_$less$colon$less$();
    var ev$58 = this$1232.s_$less$colon$less$__f_singleton;
    var gen$9 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$4, gen$8, ev$58);
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1234 = $m_s_Symbol$();
    var value0$197 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1234, "_id"));
    var witness$58 = new $c_Lshapeless_Witness$$anon$1(value0$197);
    var this$1238 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    var this$1237 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$12 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var textualizable$33 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$1237, proxy$12);
    var ev$59 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$22 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1238, textualizable$33, ev$59)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1239 = $m_s_Symbol$();
    var value0$198 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1239, "organizations"));
    var witness$57 = new $c_Lshapeless_Witness$$anon$1(value0$198);
    var ht$21 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1241 = $m_s_Symbol$();
    var value0$199 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1241, "name"));
    var witness$56 = new $c_Lshapeless_Witness$$anon$1(value0$199);
    var ht$20 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$()));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1243 = $m_s_Symbol$();
    var value0$200 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1243, "title"));
    var witness$55 = new $c_Lshapeless_Witness$$anon$1(value0$200);
    var ht$19 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$()));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1245 = $m_s_Symbol$();
    var value0$201 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1245, "description"));
    var witness$54 = new $c_Lshapeless_Witness$$anon$1(value0$201);
    var this$1249 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$54 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableMultiline;
    var textualizable$34 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$54);
    var ev$60 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$18 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1249, textualizable$34, ev$60)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1250 = $m_s_Symbol$();
    var value0$202 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1250, "images"));
    var witness$53 = new $c_Lshapeless_Witness$$anon$1(value0$202);
    var ht$17 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1252 = $m_s_Symbol$();
    var value0$203 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1252, "location"));
    var witness$52 = new $c_Lshapeless_Witness$$anon$1(value0$203);
    var ht$16 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1254 = $m_s_Symbol$();
    var value0$204 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1254, "areas"));
    var witness$51 = new $c_Lshapeless_Witness$$anon$1(value0$204);
    var ht$15 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1256 = $m_s_Symbol$();
    var value0$205 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1256, "price"));
    var witness$50 = new $c_Lshapeless_Witness$$anon$1(value0$205);
    var this$1260 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$55 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var textualizable$35 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$55);
    var ev$61 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$14 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1260, textualizable$35, ev$61)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1261 = $m_s_Symbol$();
    var value0$206 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1261, "soldOut"));
    var witness$49 = new $c_Lshapeless_Witness$$anon$1(value0$206);
    var this$1265 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$56 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var textualizable$36 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$56);
    var ev$62 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$13 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1265, textualizable$36, ev$62)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1266 = $m_s_Symbol$();
    var value0$207 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1266, "privacy"));
    var witness$48 = new $c_Lshapeless_Witness$$anon$1(value0$207);
    var this$1270 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$57 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$37 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$57);
    var ev$63 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$12 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1270, textualizable$37, ev$63)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1271 = $m_s_Symbol$();
    var value0$208 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1271, "scenes"));
    var witness$47 = new $c_Lshapeless_Witness$$anon$1(value0$208);
    var ht$11 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1273 = $m_s_Symbol$();
    var value0$209 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1273, "renderSettings"));
    var witness$46 = new $c_Lshapeless_Witness$$anon$1(value0$209);
    var ht$10 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1275 = $m_s_Symbol$();
    var value0$210 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1275, "city"));
    var witness$45 = new $c_Lshapeless_Witness$$anon$1(value0$210);
    var this$1279 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$58 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$38 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$58);
    var ev$64 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$9 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1279, textualizable$38, ev$64)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1280 = $m_s_Symbol$();
    var value0$211 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1280, "district"));
    var witness$44 = new $c_Lshapeless_Witness$$anon$1(value0$211);
    var this$1284 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$59 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$39 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$59);
    var ev$65 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$8 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1284, textualizable$39, ev$65)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1285 = $m_s_Symbol$();
    var value0$212 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1285, "topic"));
    var witness$43 = new $c_Lshapeless_Witness$$anon$1(value0$212);
    var this$1289 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$60 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$40 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$60);
    var ev$66 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$7 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1289, textualizable$40, ev$66)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1290 = $m_s_Symbol$();
    var value0$213 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1290, "modelSource"));
    var witness$42 = new $c_Lshapeless_Witness$$anon$1(value0$213);
    var this$1294 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$61 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableMultiline;
    var textualizable$41 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$61);
    var ev$67 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$6 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1294, textualizable$41, ev$67)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1295 = $m_s_Symbol$();
    var value0$214 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1295, "procedureState"));
    var witness$41 = new $c_Lshapeless_Witness$$anon$1(value0$214);
    var this$1299 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$62 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableMultiline;
    var textualizable$42 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$62);
    var ev$68 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$5 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1299, textualizable$42, ev$68)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1300 = $m_s_Symbol$();
    var value0$215 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1300, "summary"));
    var witness$40 = new $c_Lshapeless_Witness$$anon$1(value0$215);
    var this$1304 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$63 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableMultiline;
    var textualizable$43 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$63);
    var ev$69 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$4 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1304, textualizable$43, ev$69)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1305 = $m_s_Symbol$();
    var value0$216 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1305, "archived"));
    var witness$39 = new $c_Lshapeless_Witness$$anon$1(value0$216);
    var this$1308 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$44 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
    var textualizable$45 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$44);
    var ev$70 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$3 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1308, textualizable$45, ev$70)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1309 = $m_s_Symbol$();
    var value0$217 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1309, "parent"));
    var witness$38 = new $c_Lshapeless_Witness$$anon$1(value0$217);
    var this$1314 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$1312 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$13 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var textualizable$46 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$1312, proxy$13);
    var textualizable$47 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$46);
    var ev$71 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$2 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$1314, textualizable$47, ev$71)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1315 = $m_s_Symbol$();
    var value0$218 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1315, "address"));
    var witness$37 = new $c_Lshapeless_Witness$$anon$1(value0$218);
    var ht$1 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$1317 = $m_s_Symbol$();
    var value0$219 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1317, "reference"));
    var witness$36 = new $c_Lshapeless_Witness$$anon$1(value0$219);
    var ht = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$()));
    var tt = $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$().Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil;
    var tt$1 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt, ht, witness$36);
    var tt$2 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$37);
    var tt$3 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$2, ht$2, witness$38);
    var tt$4 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$3, ht$3, witness$39);
    var tt$5 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$4, ht$4, witness$40);
    var tt$6 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$5, ht$5, witness$41);
    var tt$7 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$6, ht$6, witness$42);
    var tt$8 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$7, ht$7, witness$43);
    var tt$9 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$8, ht$8, witness$44);
    var tt$10 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$9, ht$9, witness$45);
    var tt$11 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$10, ht$10, witness$46);
    var tt$12 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$11, ht$11, witness$47);
    var tt$13 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$12, ht$12, witness$48);
    var tt$14 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$13, ht$13, witness$49);
    var tt$15 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$14, ht$14, witness$50);
    var tt$16 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$15, ht$15, witness$51);
    var tt$17 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$16, ht$16, witness$52);
    var tt$18 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$17, ht$17, witness$53);
    var tt$19 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$18, ht$18, witness$54);
    var tt$20 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$19, ht$19, witness$55);
    var tt$21 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$20, ht$20, witness$56);
    var tt$22 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$21, ht$21, witness$57);
    var tokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$22, ht$22, witness$58);
    var $$x37 = new $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer, gen$9);
    var $$x14 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var $$x13 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var $$x12 = new $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1();
    $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$14 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var $$x11 = new $c_Lcom_iz2use_common_MaybeImplicit(new $c_s_Some(new $c_Lreactbuild_model_Implicits$$anon$28(proxy$14)));
    var $$x10 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    $m_Lreactbuild_model_Implicits$();
    var this$1347 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u = $n($$x299).noExternalState__O__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x295, $$x292, $$x291, $$x290, $$x265, $$x118, $$x117, $$x40, $$x39, $$x38, $$x37, $$x14, $$x13, $$x12, $$x11, $$x10, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1347.byRef__F2(), this$1347.by_$eq$eq__F2()), new $c_sjsr_AnonFunction1(((evT$2) => {
      var evT = $n($as_Ljapgolly_scalajs_react_Reusability(evT$2)).Ljapgolly_scalajs_react_Reusability__f_test;
      return new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityMultiviewItemColl__F2__F2(evT))
    })), $m_Lcom_iz2use_react_components_internal_multiview_View$().defaultViewOrdering__s_math_Ordering());
    var this$1349 = $n(u);
    var n = this$1349.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$1351 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$1351);
  var s$1 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$72 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$1352, f$12, step, s$1);
  this.Lreactbuild_analyze_cost_modules_Projects$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$1353, ev$72).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.Projects.component"))
}
$c_Lreactbuild_analyze_cost_modules_Projects$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Projects$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Projects$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Projects$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Projects$.prototype = $c_Lreactbuild_analyze_cost_modules_Projects$.prototype;
$c_Lreactbuild_analyze_cost_modules_Projects$.prototype.apply__Lreactbuild_analyze_cost_modules_project_ProjectView__Ljapgolly_scalajs_react_vdom_VdomElement = (function(view) {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_modules_Projects$().Lreactbuild_analyze_cost_modules_Projects$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_modules_Projects$Props(pageProps, view);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
$c_Lreactbuild_analyze_cost_modules_Projects$.prototype.routes__Ljapgolly_scalajs_react_extra_router_RoutingRule = (function() {
  new $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$BuildInterface();
  var arg1 = new $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl();
  var this$4 = $n($m_Ljapgolly_scalajs_react_extra_router_RoutingRule$().empty__Ljapgolly_scalajs_react_extra_router_RoutingRule());
  var that = $p_Lreactbuild_analyze_cost_modules_Projects$__view$2__T__F1__s_reflect_ClassTag__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_RoutingRule(this, "summary", $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.getClassOf()), arg1);
  var this$6 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$4, that);
  var that$1 = $p_Lreactbuild_analyze_cost_modules_Projects$__view$2__T__F1__s_reflect_ClassTag__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_RoutingRule(this, "procedures", $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.getClassOf()), arg1);
  var this$8 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$6, that$1);
  var that$2 = $p_Lreactbuild_analyze_cost_modules_Projects$__view$2__T__F1__s_reflect_ClassTag__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_RoutingRule(this, "tasklist", $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.getClassOf()), arg1);
  var this$10 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$8, that$2);
  var that$3 = $p_Lreactbuild_analyze_cost_modules_Projects$__view$2__T__F1__s_reflect_ClassTag__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_RoutingRule(this, "supply", $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.getClassOf()), arg1);
  var this$12 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$10, that$3);
  var that$4 = $p_Lreactbuild_analyze_cost_modules_Projects$__view$2__T__F1__s_reflect_ClassTag__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_RoutingRule(this, "drawing", $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.getClassOf()), arg1);
  var this$14 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$12, that$4);
  var that$5 = $p_Lreactbuild_analyze_cost_modules_Projects$__view$2__T__F1__s_reflect_ClassTag__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_RoutingRule(this, "3d", $m_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.getClassOf()), arg1);
  var this$16 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$14, that$5);
  var that$6 = $p_Lreactbuild_analyze_cost_modules_Projects$__view$2__T__F1__s_reflect_ClassTag__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_RoutingRule(this, "details", $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.getClassOf()), arg1);
  var this$24 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$16, that$6);
  var $$x1 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($p_Lreactbuild_analyze_cost_modules_Projects$__withSubprojectsRule$1__T__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this, "documents", arg1)).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((t$2) => {
    var t = $as_T2(t$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments($as_s_Option($n(t)._1__O()), $n(t)._2$mcZ$sp__Z())
  })), new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(c$2);
    return $ct_T2__O__O__(new $c_T2(), $n(c).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_active, $n(c).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects)
  }))));
  var this$19 = $m_s_$less$colon$less$();
  var this$ = arg1.dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1(arg1._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x1, this$19.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.getClassOf()));
  var $$x2 = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(x$7$2);
    return $m_Lreactbuild_analyze_cost_modules_Projects$().apply__Lreactbuild_analyze_cost_modules_project_ProjectView__Ljapgolly_scalajs_react_vdom_VdomElement(x$7)
  }));
  var this$22 = $m_s_$less$colon$less$();
  var g = arg1.dynRender__F1__F1__F1($$x2, this$22.s_$less$colon$less$__f_singleton);
  var that$7 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$).apply__O__O(g));
  var this$31 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$24, that$7);
  var $$x3 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($p_Lreactbuild_analyze_cost_modules_Projects$__withSubprojectsRule$1__T__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this, "cost-analyze", arg1)).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((t$3$2) => {
    var t$3 = $as_T2(t$3$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze($as_s_Option($n(t$3)._1__O()), $n(t$3)._2$mcZ$sp__Z())
  })), new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(c$3$2);
    return $ct_T2__O__O__(new $c_T2(), $n(c$3).Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_active, $n(c$3).Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects)
  }))));
  var this$26 = $m_s_$less$colon$less$();
  var this$$1 = arg1.dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1(arg1._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x3, this$26.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.getClassOf()));
  var $$x4 = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(x$8$2);
    return $m_Lreactbuild_analyze_cost_modules_Projects$().apply__Lreactbuild_analyze_cost_modules_project_ProjectView__Ljapgolly_scalajs_react_vdom_VdomElement(x$8)
  }));
  var this$29 = $m_s_$less$colon$less$();
  var g$1 = arg1.dynRender__F1__F1__F1($$x4, this$29.s_$less$colon$less$__f_singleton);
  var that$8 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$1).apply__O__O(g$1));
  var this$38 = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$31, that$8);
  var $$x5 = $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB($n($p_Lreactbuild_analyze_cost_modules_Projects$__generatorRule$1__Ljapgolly_scalajs_react_extra_router_RouterConfigDsl__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this, arg1)).xmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon(new $c_sjsr_AnonFunction1(((t$4$2) => {
    var t$4 = $as_T2(t$4$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator($as_s_Option($n(t$4)._1__O()), $as_s_Option($n(t$4)._2__O()))
  })), new $c_sjsr_AnonFunction1(((c$4$2) => {
    var c$4 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(c$4$2);
    return $ct_T2__O__O__(new $c_T2(), $n(c$4).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_active, $n(c$4).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_documentType)
  }))));
  var this$33 = $m_s_$less$colon$less$();
  var this$$2 = arg1.dynamicRouteCT__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__s_reflect_ClassTag__F1(arg1._auto_route_from_routeB__O__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route($$x5, this$33.s_$less$colon$less$__f_singleton), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.getClassOf()));
  var $$x6 = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(x$9$2);
    return $m_Lreactbuild_analyze_cost_modules_Projects$().apply__Lreactbuild_analyze_cost_modules_project_ProjectView__Ljapgolly_scalajs_react_vdom_VdomElement(x$9)
  }));
  var this$36 = $m_s_$less$colon$less$();
  var g$2 = arg1.dynRender__F1__F1__F1($$x6, this$36.s_$less$colon$less$__f_singleton);
  var that$9 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule($n(this$$2).apply__O__O(g$2));
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(this$38, that$9)
});
var $d_Lreactbuild_analyze_cost_modules_Projects$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Projects$: 0
}, false, "reactbuild.analyze.cost.modules.Projects$", {
  Lreactbuild_analyze_cost_modules_Projects$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_Projects$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Projects$;
var $n_Lreactbuild_analyze_cost_modules_Projects$;
function $m_Lreactbuild_analyze_cost_modules_Projects$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_Projects$)) {
    $n_Lreactbuild_analyze_cost_modules_Projects$ = new $c_Lreactbuild_analyze_cost_modules_Projects$()
  };
  return $n_Lreactbuild_analyze_cost_modules_Projects$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$() {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$__f_reuseReconcileInvoicePageWithDeliveryForm = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$__f_reuseReconcileInvoicePageWithDeliveryForm = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReconcileDeliveryForm", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State($m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend($n(x$3).backend__O()));
    var this$7 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props($n(this$7.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$8 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$8)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomElement = (function() {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$().Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props($n(pageProps).Lreactbuild_package$PageProps__f_router, $n(pageProps).Lreactbuild_package$PageProps__f_proxy);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryForm$", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$;
var $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$;
function $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$)) {
    $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$ = new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$() {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$ = this;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReconcileDeliveryFormEditor", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State($m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$().apply$default$1__Lreactbuild_model_MissingDeliveryFormDetails())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_common_model_Date__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomElement = (function(invoiceDetails, reconciliationLines, date, active, deliveryForms) {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$().Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props(invoiceDetails, reconciliationLines, date, active, deliveryForms, $n(pageProps).Lreactbuild_package$PageProps__f_proxy);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$;
var $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$;
function $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$)) {
    $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$ = new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$() {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$ = this;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReconcileDeliveryLine", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__jl_Void__Ljapgolly_scalajs_react_vdom_TagOf($$x1, $as_jl_Void($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$.prototype.apply__s_Option__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_common_model_Date__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(invoiceDetail, reconciliationLine, date, active, deliveryForms, proxy) {
  var c = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props(invoiceDetail, reconciliationLine, date, active, deliveryForms, proxy);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryLine$", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$;
var $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$;
function $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$)) {
    $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$ = new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$
}
function $p_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$__renderRow__Lreactbuild_model_ReconciliationState__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf($thiz, row, proxy) {
  var color = $as_T($n(row).fold__F1__F2__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Lreactbuild_model_ChildWithParent(x$1$2);
    return "0"
  })), new $c_sjsr_AnonFunction2(((l$2, r$2) => {
    var l = $as_Lreactbuild_model_ChildWithParent(l$2);
    var r = $as_Lreactbuild_model_ChildWithParent(r$2);
    var this$3 = $n($n($as_Lreactbuild_model_InvoiceDetail($n(l).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_quantity);
    if ((!this$3.isEmpty__Z())) {
      var arg1 = this$3.get__O();
      var x$2 = $uD(arg1);
      var $$x1 = (x$2 === $n($as_Lreactbuild_model_DeliveryFormDetails($n(r).Lreactbuild_model_ChildWithParent__f_child)).deliveredQuantity__D())
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return "120"
    } else {
      return "36"
    }
  })), new $c_sjsr_AnonFunction1(((x$3$2) => {
    $as_Lreactbuild_model_ChildWithParent(x$3$2);
    return "180"
  }))));
  var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x21 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((("hsla(" + color) + ", 100%, 50%, 0.12)"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x8 = $as_Ljapgolly_scalajs_react_vdom_TagMod($n(row).foldLeft__F0__F1__O(new $c_sjsr_AnonFunction0((() => {
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$12 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$12.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 6), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ligne non rapproch\u00e9e d'une facture"))];
    return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_model_ChildWithParent(x0$1$2);
    if ((x0$1 !== null)) {
      var x = $as_Lreactbuild_model_InvoiceDetail($n(x0$1).Lreactbuild_model_ChildWithParent__f_child);
      var page = $as_Lreactbuild_model_InvoicePage($n(x0$1).Lreactbuild_model_ChildWithParent__f_parent);
      var this$78 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v = $n(page).Lreactbuild_model_InvoicePage__f_supplier;
      $m_Lcom_iz2use_common_Textualizable$();
      var this$20 = $m_Lreactbuild_model_Implicits$();
      var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$20, proxy);
      var ev = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
      var v$1 = ev.stringify__s_Option__T(v);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      var $$x19 = $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$2 = $n(page).Lreactbuild_model_InvoicePage__f_date;
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1);
      var v$3 = ev$1.stringify__s_Option__T(v$2);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
      var $$x17 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$4 = $n(page).Lreactbuild_model_InvoicePage__f_reference;
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var ev$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
      var v$5 = ev$2.stringify__s_Option__T(v$4);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
      var $$x15 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
      var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$6 = $n(x).Lreactbuild_model_InvoiceDetail__f_deliveryDate;
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var ev$3 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$2);
      var v$7 = ev$3.stringify__s_Option__T(v$6);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)];
      var $$x13 = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
      var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$8 = $n(x).Lreactbuild_model_InvoiceDetail__f_amount;
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var ev$4 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$3);
      var v$9 = ev$4.stringify__s_Option__T(v$8);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$5 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$9)];
      var $$x11 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
      var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$10 = $n(x).Lreactbuild_model_InvoiceDetail__f_quantity;
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
      var ev$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
      var v$11 = ev$5.stringify__s_Option__T(v$10);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$11)];
      var array$7 = [$$x19, $$x17, $$x15, $$x13, $$x11, $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
      var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
      return this$78.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))));
  var this$79 = $n($n(row).leftOption__s_Option());
  if (this$79.isEmpty__Z()) {
    var $$x2 = $m_s_None$()
  } else {
    var arg1$1 = this$79.get__O();
    var x$4 = $as_Lreactbuild_model_ChildWithParent(arg1$1);
    var $$x2 = new $c_s_Some($as_Lreactbuild_model_InvoiceDetail($n(x$4).Lreactbuild_model_ChildWithParent__f_child))
  };
  var this$80 = $n($$x2);
  var this$81 = $n((this$80.isEmpty__Z() ? $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(row).rightOption__s_Option())).collectFirst__s_PartialFunction__s_Option(new $c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1()) : this$80));
  if (this$81.isEmpty__Z()) {
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$86 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
    var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var array$8 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$86.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 2)];
    var $$x3 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  } else {
    var arg1$2 = this$81.get__O();
    var x$5 = $as_Lreactbuild_model_InvoiceDetail(arg1$2);
    var this$113 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$12 = $n(x$5).Lreactbuild_model_InvoiceDetail__f_reference;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$6 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$2);
    var v$13 = ev$6.stringify__s_Option__T(v$12);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$9 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$13)];
    var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$14 = $n(x$5).Lreactbuild_model_InvoiceDetail__f_description;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$7 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$3);
    var v$15 = ev$7.stringify__s_Option__T(v$14);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$10 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$15)];
    var array$11 = [$$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
    var ms$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
    var $$x3 = this$113.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1)
  };
  var array$18 = [$$x21, $$x8, $as_Ljapgolly_scalajs_react_vdom_TagMod($$x3), $as_Ljapgolly_scalajs_react_vdom_TagMod($n(row).foldRight__F0__F1__O(new $c_sjsr_AnonFunction0((() => {
    var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$118 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
    var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var array$12 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$118.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 4), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Pas de bon de livraison rapproch\u00e9 \u00e0 cette ligne de facture"))];
    return $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))
  })), new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_Lreactbuild_model_ChildWithParent(x0$2$2);
    if ((x0$2 !== null)) {
      var x$6 = $as_Lreactbuild_model_DeliveryFormDetails($n(x0$2).Lreactbuild_model_ChildWithParent__f_child);
      var form = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm($n(x0$2).Lreactbuild_model_ChildWithParent__f_parent);
      var this$162 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$16 = $n(x$6).deliveredQuantity__D();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
      var v$17 = $n(parsable$4).stringify__O__T(v$16);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$13 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$17)];
      var $$x28 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
      var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$18 = $n(x$6).amount__s_Option();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var ev$8 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$4);
      var v$19 = ev$8.stringify__s_Option__T(v$18);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$14 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$19)];
      var $$x26 = $n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
      var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$20 = $n(form).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference;
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var v$21 = $n(parsable$5).stringify__O__T(v$20);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$15 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$21)];
      var $$x24 = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15));
      var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$22 = $n(form).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_date;
      var ev$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var v$23 = $n(ev$9).stringify__O__T(v$22);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$16 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$23)];
      var array$17 = [$$x28, $$x26, $$x24, $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
      var ms$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
      return this$162.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$2)
    } else {
      throw new $c_s_MatchError(x0$2)
    }
  }))))];
  return $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))
}
function $p_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$__renderBlock__Lreactbuild_analyze_cost_components_Period__sci_List__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf($thiz, periodValue, block, proxy) {
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$5 = $n(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "border")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2pt solid black", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  var condition = ($n(block).length__I() > 1);
  var $$x2 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$5, condition);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$9 = $n(block);
  var f = ((x$5$2) => {
    var x$5 = $as_Lreactbuild_model_ReconciliationState(x$5$2);
    return $uZ($n(x$5).fold__F1__F2__F1__O(new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Lreactbuild_model_ChildWithParent(x$6$2);
      var this$7 = $n($n($as_Lreactbuild_model_InvoicePage($n(x$6).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f_date);
      if (this$7.isEmpty__Z()) {
        return true
      } else {
        var arg1 = this$7.get__O();
        var x$7 = $as_Lreactbuild_common_model_Date(arg1);
        return $uZ($n($n(periodValue).Lreactbuild_analyze_cost_components_Period__f_contains).apply__O__O($m_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$().dateToLocalDate__Lreactbuild_common_model_Date__Ljava_time_LocalDate(x$7)))
      }
    })), new $c_sjsr_AnonFunction2(((l$2, r$2) => {
      var l = $as_Lreactbuild_model_ChildWithParent(l$2);
      $as_Lreactbuild_model_ChildWithParent(r$2);
      var this$8 = $n($n($as_Lreactbuild_model_InvoicePage($n(l).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f_date);
      if (this$8.isEmpty__Z()) {
        return true
      } else {
        var arg1$1 = this$8.get__O();
        var x$8 = $as_Lreactbuild_common_model_Date(arg1$1);
        return $uZ($n($n(periodValue).Lreactbuild_analyze_cost_components_Period__f_contains).apply__O__O($m_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$().dateToLocalDate__Lreactbuild_common_model_Date__Ljava_time_LocalDate(x$8)))
      }
    })), new $c_sjsr_AnonFunction1(((r$3$2) => {
      var r$3 = $as_Lreactbuild_model_ChildWithParent(r$3$2);
      return $uZ($n($n(periodValue).Lreactbuild_analyze_cost_components_Period__f_contains).apply__O__O($m_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$().dateToLocalDate__Lreactbuild_common_model_Date__Ljava_time_LocalDate($n($as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm($n(r$3).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_date)))
    }))))
  });
  var l$1 = this$9;
  block: {
    var result;
    while (true) {
      if ($n(l$1).isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break
      } else {
        var h = $n(l$1).head__O();
        var t = $as_sci_List($n(l$1).tail__O());
        if (($uZ(f(h)) === false)) {
          l$1 = t;
          continue
        };
        var start = l$1;
        var remaining = t;
        while (true) {
          if ($n(remaining).isEmpty__Z()) {
            var result = start;
            break block
          } else {
            var x = $n(remaining).head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List($n(remaining).tail__O());
              continue
            };
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List($n(start).tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
              $n(currentLast).sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List($n(toProcess).tail__O())
            };
            var next = $as_sci_List($n(firstMiss).tail__O());
            var nextToCopy = next;
            while ((!$n(next).isEmpty__Z())) {
              var head = $n(next).head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List($n(next).tail__O())
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                };
                nextToCopy = $as_sci_List($n(next).tail__O());
                next = $as_sci_List($n(next).tail__O())
              }
            };
            if ((!$n(nextToCopy).isEmpty__Z())) {
              $n(currentLast).sci_$colon$colon__f_next = nextToCopy
            };
            var result = newHead;
            break block
          }
        }
      }
    }
  };
  var array = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(result, new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Lreactbuild_model_ReconciliationState(x$9$2);
    return $p_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$__renderRow__Lreactbuild_model_ReconciliationState__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf($m_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$(), x$9, proxy)
  })))];
  return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$.prototype = $c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$.prototype.dateToLocalDate__Lreactbuild_common_model_Date__Ljava_time_LocalDate = (function(v) {
  var this$1 = $n(v).Lreactbuild_common_model_Date__f_value;
  var this$2 = $m_RTLong$();
  var lo = this$2.divideImpl__I__I__I__I__I(this$1.RTLong__f_lo, this$1.RTLong__f_hi, 86400000, 0);
  var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi))
});
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$.prototype.apply__Lreactbuild_analyze_cost_components_Period__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf = (function(periodValue, r, proxy) {
  var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_crossedTable;
  var $$x38 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var $$x37 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x36 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).boxSizing__Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("border-box", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x35 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).borderCollapse__Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("collapse", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$13 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$13.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 6), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Factures"))];
  var $$x31 = $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$23 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var array$1 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$23.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 2), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Produit"))];
  var $$x29 = $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$33 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
  var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var array$2 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$33.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 4), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Bon de livraisons"))];
  var array$3 = [$$x31, $$x29, $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var $$x27 = $n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Agence"))];
  var $$x24 = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date"))];
  var $$x22 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence"))];
  var $$x20 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Livr\u00e9 le"))];
  var $$x18 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$8 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Total HT"))];
  var $$x16 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$9 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Quantit\u00e9"))];
  var $$x14 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$10 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence"))];
  var $$x12 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$11 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Description"))];
  var $$x10 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$12 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Quantit\u00e9"))];
  var $$x8 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$13 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Total HT"))];
  var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$14 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence"))];
  var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$15 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date"))];
  var array$16 = [$$x24, $$x22, $$x20, $$x18, $$x16, $$x14, $$x12, $$x10, $$x8, $$x6, $$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
  var array$17 = [$$x27, $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
  var $$x2 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $as_sc_IterableOnce($n(r).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var array$18 = [$$x38, $$x37, $$x36, $$x35, $$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_sci_List(x$10$2);
    return $p_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$__renderBlock__Lreactbuild_analyze_cost_components_Period__sci_List__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf($m_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$(), periodValue, x$10, proxy)
  })))];
  return $n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))
});
var $d_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconciliationReportTable$: 0
}, false, "reactbuild.analyze.cost.modules.ReconciliationReportTable$", {
  Lreactbuild_analyze_cost_modules_ReconciliationReportTable$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$;
var $n_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$;
function $m_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$)) {
    $n_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$ = new $c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_RenderProject$() {
  this.Lreactbuild_analyze_cost_modules_RenderProject$__f_reuseProjectView = null;
  this.Lreactbuild_analyze_cost_modules_RenderProject$__f_skeletonTitle = null;
  this.Lreactbuild_analyze_cost_modules_RenderProject$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_RenderProject$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_RenderProject$__f_reuseProjectView = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(10);
  var this$5 = $n(u);
  var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
  var u$1 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(32);
  var this$10 = $n(u$1);
  var n$1 = this$10.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [$$x2, $$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  this.Lreactbuild_analyze_cost_modules_RenderProject$__f_skeletonTitle = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var this$60 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var this$59 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).useCommonDataBy__F1__F1__Lreactbuild_package$DefaultCommonData__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((x$15$2) => {
    var x$15 = $as_Lreactbuild_analyze_cost_modules_RenderProject$Props(x$15$2);
    return $n($n(x$15).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_pageProps).Lreactbuild_package$PageProps__f_proxy
  })), new $c_sjsr_AnonFunction1(((x$16$2) => {
    var x$16 = $as_Lreactbuild_model_CommonData(x$16$2);
    return $n(x$16).Lreactbuild_model_CommonData__f_buildingSites
  })), new $c_Lreactbuild_package$DefaultCommonData$$anon$1(), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep())));
  var f$1 = new $c_sjsr_AnonFunction2(((p$2, allProjects$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_RenderProject$Props(p$2);
    var allProjects = $as_Ljapgolly_scalajs_react_Reusable(allProjects$2);
    var this$ = $n(p).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_viewState;
    var this$21 = $n(this$);
    var view = $as_Lreactbuild_analyze_cost_modules_project_ProjectView($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$21));
    var ss = $n($n(p).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_project).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((project$2) => {
      var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(project$2);
      var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
      $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
      var value = $n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      return $n($$x4).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
        var x0$1 = $as_s_Option(x0$1$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        matchEnd7: {
          var $$x5;
          var p2 = $as_s_Option(x1.T2__f__1);
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x = $m_s_None$();
          if ((x === p2)) {
            var $$x5 = cb;
            break matchEnd7
          };
          var p4 = $as_s_Option(x1.T2__f__1);
          var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          if ((p4 instanceof $c_s_Some)) {
            var x5 = $as_s_Some(p4);
            var v = $as_Lreactbuild_common_model_Project($n(x5).s_Some__f_value);
            var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var $$x6 = $n($n($n(p).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_pageProps).Lreactbuild_package$PageProps__f_proxy).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_analyze_cost_actions_PersistBuildingSite(v), $m_Ldiode_Action$aType$());
            var this$23 = $n(project);
            var mod = new $c_sjsr_AnonFunction1(((x$17$2) => {
              $as_Lreactbuild_common_model_Project(x$17$2);
              return v
            }));
            var $$x5 = $n($$x8).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($$x7).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x6, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$23, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), cb$2);
            break matchEnd7
          };
          throw new $c_s_MatchError(x1)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x5)
      })))
    })));
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$26 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
    var $$x23 = this$26.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$27 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
    var $$x22 = this$27.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x21 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x20 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$31 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
    var $$x19 = this$31.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x14 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode($n(p).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_project, new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_RenderProject$().Lreactbuild_analyze_cost_modules_RenderProject$__f_skeletonTitle)), new $c_sjsr_AnonFunction1(((projectState$2) => {
      var projectState = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(projectState$2);
      var project$1 = $as_Lreactbuild_common_model_Project($n(projectState).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
      var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$34 = $m_Lscalacss_ScalaCssReact$();
      var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
      var $$x17 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$34, s);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(project$1).Lreactbuild_common_model_Project__f_name;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x16 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x15 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$2 = $n(project$1).Lreactbuild_common_model_Project__f_title;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$1 = [$$x17, $$x16, $$x15, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      return $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    })));
    var $$x13 = $m_Lreactbuild_analyze_cost_components_Toolbar$();
    var $$x12 = $m_Lreactbuild_analyze_cost_components_Tabs$();
    var $$x11 = $m_Lreactbuild_analyze_cost_modules_RenderProject$();
    var this$44 = $n($n(p).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_project);
    var this$45 = $n(((!this$44.isEmpty__Z()) ? new $c_s_Some(this$44.get__O()) : $m_s_None$()));
    var f = new $c_sjsr_AnonFunction1(((x$18$2) => {
      var x$18 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$18$2);
      return $n($as_Lreactbuild_common_model_Project($n(x$18).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id
    }));
    var $$x10 = $n($$x11).tabList__s_Option__sci_List((this$45.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$45.get__O()))));
    var this$47 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var ms = $m_sci_Nil$();
    var $$x9 = this$47.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms);
    var this$49 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var ms$1 = $m_sci_Nil$();
    var array$2 = [$$x23, $$x22, $$x21, $$x20, $$x19, $$x14, $n($$x13).apply__Ljapgolly_scalajs_react_vdom_VdomNode__Z__Ljapgolly_scalajs_react_vdom_TagOf($n($$x12).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__F1__Ljapgolly_scalajs_react_vdom_TagOf($$x10, $$x9, this$49.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1), new $c_sjsr_AnonFunction1(((x$19$2) => {
      var x$19 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView(x$19$2);
      var this$50 = $n(x$19);
      var x$1 = $objectGetClass(this$50);
      var this$51 = $n(view);
      var x$2 = $objectGetClass(this$51);
      return (x$1 === x$2)
    })), new $c_sjsr_AnonFunction1(((item$2) => {
      var item = $as_Lreactbuild_analyze_cost_modules_project_ProjectView(item$2);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$3 = $n(item).title__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Lreactbuild_analyze_cost_components_Tab(new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3), $n($n($n(p).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_pageProps).Lreactbuild_package$PageProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$Project(item)))
    }))), false), $n(view).render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode(ss, $as_sci_List(($m_Ljapgolly_scalajs_react_Reusable$(), $n(allProjects).value__O())), $n(p).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_pageProps)];
    return $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  }));
  var this$58 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$58);
  var s$1 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$59, f$1, step, s$1);
  this.Lreactbuild_analyze_cost_modules_RenderProject$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$60, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.RenderProject.component"))
}
$c_Lreactbuild_analyze_cost_modules_RenderProject$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_RenderProject$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_RenderProject$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_RenderProject$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_RenderProject$.prototype = $c_Lreactbuild_analyze_cost_modules_RenderProject$.prototype;
$c_Lreactbuild_analyze_cost_modules_RenderProject$.prototype.tabList__s_Option__sci_List = (function(project) {
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary(project), new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures(project), new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList(project), new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply(project), new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview(project), new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview(project), new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(project, false), new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails(project), new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(project, true), new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(project, $m_s_None$())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
$c_Lreactbuild_analyze_cost_modules_RenderProject$.prototype.apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_callback_Trampoline__Ldiode_data_Pot__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(pageProps, viewState, project) {
  var c = this.Lreactbuild_analyze_cost_modules_RenderProject$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_RenderProject$Props(pageProps, viewState, project);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_RenderProject$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_RenderProject$: 0
}, false, "reactbuild.analyze.cost.modules.RenderProject$", {
  Lreactbuild_analyze_cost_modules_RenderProject$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_RenderProject$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_RenderProject$;
var $n_Lreactbuild_analyze_cost_modules_RenderProject$;
function $m_Lreactbuild_analyze_cost_modules_RenderProject$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_RenderProject$)) {
    $n_Lreactbuild_analyze_cost_modules_RenderProject$ = new $c_Lreactbuild_analyze_cost_modules_RenderProject$()
  };
  return $n_Lreactbuild_analyze_cost_modules_RenderProject$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Report$() {
  this.Lreactbuild_analyze_cost_modules_Report$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_Report$ = this;
  this.Lreactbuild_analyze_cost_modules_Report$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Report", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_Report$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_Report$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_Report$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_Report$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_Report$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_Report$Props__Lreactbuild_analyze_cost_modules_Report$State__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lreactbuild_analyze_cost_modules_Report$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_Report$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Report$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Report$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Report$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Report$.prototype = $c_Lreactbuild_analyze_cost_modules_Report$.prototype;
$c_Lreactbuild_analyze_cost_modules_Report$.prototype.apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement = (function(dateOpt) {
  var this$11 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var this$2 = $n(dateOpt);
    if (this$2.isEmpty__Z()) {
      var this$3 = $m_Ljava_time_LocalDate$();
      var $$x1 = this$3.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
    } else {
      var $$x1 = this$2.get__O()
    };
    var date = $as_Ljava_time_LocalDate($$x1);
    var $$x2 = $n(date);
    var value = (((-1) + $n($n(date).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I()) | 0);
    var hi = (value >> 31);
    var weekStart = $n($$x2).minusDays__J__Ljava_time_LocalDate(new $c_RTLong(value, hi));
    var c = $m_Lreactbuild_analyze_cost_modules_Report$().Lreactbuild_analyze_cost_modules_Report$__f_component;
    var this$7 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_modules_Report$Props($n(pageProps).Lreactbuild_package$PageProps__f_router, $n(pageProps).Lreactbuild_package$PageProps__f_proxy, new $c_Lreactbuild_analyze_cost_modules_PeriodRange(weekStart));
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$7.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$7.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$9 = $n(u);
    var n = this$9.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$11, f)
});
var $d_Lreactbuild_analyze_cost_modules_Report$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Report$: 0
}, false, "reactbuild.analyze.cost.modules.Report$", {
  Lreactbuild_analyze_cost_modules_Report$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_Report$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Report$;
var $n_Lreactbuild_analyze_cost_modules_Report$;
function $m_Lreactbuild_analyze_cost_modules_Report$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_Report$)) {
    $n_Lreactbuild_analyze_cost_modules_Report$ = new $c_Lreactbuild_analyze_cost_modules_Report$()
  };
  return $n_Lreactbuild_analyze_cost_modules_Report$
}
function $p_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReportAddLevelItem", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(false)
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$() {
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$ = this;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$__f_component = $n($n($n($p_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$.prototype = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$.prototype.apply__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_ReportFieldSpec__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(proxy, fieldSpec, done) {
  var c = this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps(proxy, fieldSpec, done);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportAddLevelItem$: 0
}, false, "reactbuild.analyze.cost.modules.ReportAddLevelItem$", {
  Lreactbuild_analyze_cost_modules_ReportAddLevelItem$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$;
var $n_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$;
function $m_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$)) {
    $n_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$ = new $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$
}
function $p_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReportExtractHeaders", new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps(x$1$2);
    var this$2 = $n(x$1);
    return $n(this$2.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_fieldSpec).actives__Lreactbuild_analyze_cost_modules_ReportContext__sci_Seq(this$2)
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$() {
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$ = this;
  var this$9 = $n($n($n($p_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    $n($as_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var p = $as_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    var s = $as_sci_Seq($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4));
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_f).apply__O__O(s))
  }))));
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p$1 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(p$2);
    var this$7 = $n(p$1);
    var this$6 = $n($as_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps($n(p$1).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps));
    var newState = $n(this$6.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_fieldSpec).actives__Lreactbuild_analyze_cost_modules_ReportContext__sci_Seq(this$6);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$7, newState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$9, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$.prototype = $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$.prototype.withKey__T__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__Lreactbuild_analyze_cost_modules_ReportFieldSpec__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, proxy, periodRange, timeReports, fieldSpec, f) {
  var c = this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps(proxy, periodRange, timeReports, fieldSpec, f);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportExtractHeaders$: 0
}, false, "reactbuild.analyze.cost.modules.ReportExtractHeaders$", {
  Lreactbuild_analyze_cost_modules_ReportExtractHeaders$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$;
var $n_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$;
function $m_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$)) {
    $n_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$ = new $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$
}
function $f_Lreactbuild_analyze_cost_modules_ReportFieldSpec__render__sci_List__sci_List__Lreactbuild_analyze_cost_modules_ReportContext__I__I__F2__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, parents, tail, reportContext, level, levels, updateTimeReports) {
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (tail === null) : $n(x).equals__O__Z(tail))) {
    return $m_Lreactbuild_analyze_cost_modules_ReportLevel$().apply__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__Lreactbuild_analyze_cost_modules_ReportFieldSpec__F2__Ljapgolly_scalajs_react_vdom_VdomNode($n(reportContext).proxy__Ldiode_react_ModelProxy(), $n(reportContext).periodRange__Lreactbuild_analyze_cost_modules_PeriodRange(), $n(reportContext).timeReports__sci_Seq(), $thiz, new $c_sjsr_AnonFunction2(((headers$2, adder$2) => {
      var headers = $as_sci_Seq(headers$2);
      var adder = $as_s_Option(adder$2);
      var this$52 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$8 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
      var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
      var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$8.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, levels)];
      var $$x9 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), headers), new $c_sjsr_AnonFunction1(((item$2) => {
        var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = $n($thiz.label__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable($n(reportContext).proxy__Ldiode_react_ModelProxy())).stringify__O__T(item$2);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
        return $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      })));
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var array$3 = [$$x9, $$x7, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(adder, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((x$9$2) => {
        var x$9 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(x$9$2);
        var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$2 = [x$9];
        return $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
      })))];
      var $$x6 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$35 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
      var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
      var array$4 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$35.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, levels)];
      var $$x3 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
      var this$45 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var ns = $as_sci_Seq($n(headers).map__F1__O(new $c_sjsr_AnonFunction1(((item$3$2) => {
        var $$x2 = $m_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$();
        var $$x1 = $dp_toString__T($n(item$3$2));
        var self = $thiz.symbol__s_Symbol();
        var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, item$3$2);
        var this$41 = $n(parents);
        var u = $n($$x2).withKey__T__sci_List__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__Lreactbuild_analyze_cost_modules_ReportFieldSpec__O__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x1, new $c_sci_$colon$colon(rassoc$1, this$41), $n(reportContext).proxy__Ldiode_react_ModelProxy(), $n(reportContext).periodRange__Lreactbuild_analyze_cost_modules_PeriodRange(), $n(reportContext).timeReports__sci_Seq(), $thiz, item$3$2, updateTimeReports);
        var this$43 = $n(u);
        var n = this$43.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      }))));
      var array$5 = [$$x3, $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$45, null, ns)];
      var array$6 = [$$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
      var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$52, null, ns$1)
    })))
  } else {
    return $m_Lreactbuild_analyze_cost_modules_ReportLevel$().apply__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__Lreactbuild_analyze_cost_modules_ReportFieldSpec__F2__Ljapgolly_scalajs_react_vdom_VdomNode($n(reportContext).proxy__Ldiode_react_ModelProxy(), $n(reportContext).periodRange__Lreactbuild_analyze_cost_modules_PeriodRange(), $n(reportContext).timeReports__sci_Seq(), $thiz, new $c_sjsr_AnonFunction2(((headers$3$2, adder$3$2) => {
      var headers$3 = $as_sci_Seq(headers$3$2);
      var adder$3 = $as_s_Option(adder$3$2);
      var this$85 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var this$59 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var ns$2 = $as_sci_Seq($n(headers$3).map__F1__O(new $c_sjsr_AnonFunction1(((item$2$1) => {
        var $$x18 = $m_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$();
        var $$x17 = $dp_toString__T($n(item$2$1));
        var self$1 = $thiz.symbol__s_Symbol();
        var rassoc$2 = $ct_T2__O__O__(new $c_T2(), self$1, item$2$1);
        var this$55 = $n(parents);
        var u$1 = $n($$x18).withKey__T__sci_List__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__Lreactbuild_analyze_cost_modules_ReportFieldSpec__sci_List__O__I__I__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x17, new $c_sci_$colon$colon(rassoc$2, this$55), $n(reportContext).proxy__Ldiode_react_ModelProxy(), $n(reportContext).periodRange__Lreactbuild_analyze_cost_modules_PeriodRange(), $n(reportContext).timeReports__sci_Seq(), $thiz, tail, item$2$1, level, levels, updateTimeReports);
        var this$57 = $n(u$1);
        var n$1 = this$57.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
      }))));
      var $$x19 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$59, null, ns$2);
      var this$81 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$60 = $n(adder$3);
      if (this$60.isEmpty__Z()) {
        var o = $m_s_None$()
      } else {
        var arg1 = this$60.get__O();
        var adder$2$1 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(arg1);
        var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        if ((level > 0)) {
          var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$67 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
          var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
          var array$7 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$67.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, level)];
          var $$x14 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
        } else {
          var $$x14 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
        };
        var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$8 = [adder$2$1];
        var array$9 = [$$x14, $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
        var o = new $c_s_Some($n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9)))
      };
      var O$1 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var this$80 = $m_s_$less$colon$less$();
      var f = this$80.s_$less$colon$less$__f_singleton;
      var array$10 = [$$x19, $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$81, o, O$1, f)];
      var ns$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$85, null, ns$3)
    })))
  }
}
function $is_Lreactbuild_analyze_cost_modules_ReportFieldSpec(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_ReportFieldSpec)))
}
function $as_Lreactbuild_analyze_cost_modules_ReportFieldSpec(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_ReportFieldSpec(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFieldSpec"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFieldSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFieldSpec)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFieldSpec(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFieldSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFieldSpec;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$() {
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_dateFormatter = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_keyMapperReportFieldSpec = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_localDateTextualizable = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_buildingSite = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_buildingStage = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_resource = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_date = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_defaultList = null;
  $n_Lreactbuild_analyze_cost_modules_ReportFieldSpec$ = this;
  var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_dateFormatter = $m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__ju_Locale__Ljava_time_format_DateTimeFormatter("EEEE dd LLL", locale);
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Lreactbuild_analyze_cost_modules_ReportFieldSpec(x$10$2);
    return $n(x$10).name__T()
  }));
  var ev = $m_Lcom_iz2use_common_KeyMapper$().Lcom_iz2use_common_KeyMapper$__f_fromString;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_keyMapperReportFieldSpec = new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f);
  $m_Lcom_iz2use_common_Textualizable$();
  var f$1 = new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_Ljava_time_LocalDate(x$11$2);
    var this$3 = $n(x$11);
    var formatter = $m_Lreactbuild_analyze_cost_modules_ReportFieldSpec$().Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_dateFormatter;
    return $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T(this$3, formatter)
  }));
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var this$6 = $n(parsable);
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_localDateTextualizable = new $c_Lcom_iz2use_common_Textualizable$$anon$1(this$6, f$1);
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_buildingSite = new $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1();
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_buildingStage = new $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2();
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_resource = new $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3();
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_date = new $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4();
  $m_sci_List$();
  var array = [this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_date, this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_resource, this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_buildingSite, this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_buildingStage];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_defaultList = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
}
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$.prototype;
var $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$: 0
}, false, "reactbuild.analyze.cost.modules.ReportFieldSpec$", {
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$;
var $n_Lreactbuild_analyze_cost_modules_ReportFieldSpec$;
function $m_Lreactbuild_analyze_cost_modules_ReportFieldSpec$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReportFieldSpec$)) {
    $n_Lreactbuild_analyze_cost_modules_ReportFieldSpec$ = new $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReportFieldSpec$
}
function $p_Lreactbuild_analyze_cost_modules_ReportFragment$__loop$1__sci_List__sci_List__sci_List__sci_List($thiz, allowed, dones, rest) {
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var this$1 = $n(dones);
      var suffix = allowed;
      return this$1.appendedAll__sc_IterableOnce__sci_List(suffix)
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $as_T($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      var this$2 = $n(allowed);
      _return: {
        var these = this$2;
        while ((!$n(these).isEmpty__Z())) {
          var arg1 = $n(these).head__O();
          var x$35 = $as_Lreactbuild_analyze_cost_modules_ReportFieldSpec(arg1);
          if (($n(x$35).id__T() === head)) {
            var x1$2 = new $c_s_Some($n(these).head__O());
            break _return
          };
          these = $as_sci_List($n(these).tail__O())
        };
        var x1$2 = $m_s_None$()
      };
      if ((x1$2 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x1$2);
        var found = $as_Lreactbuild_analyze_cost_modules_ReportFieldSpec($n(x2).s_Some__f_value);
        var this$3 = $n(allowed);
        var f = ((found) => ((x$36$2) => {
          var x$36 = $as_Lreactbuild_analyze_cost_modules_ReportFieldSpec(x$36$2);
          return (x$36 !== found)
        }))(found);
        var l = this$3;
        block$1: {
          var result;
          while (true) {
            if ($n(l).isEmpty__Z()) {
              var result = $m_sci_Nil$();
              break
            } else {
              var h = $n(l).head__O();
              var t = $as_sci_List($n(l).tail__O());
              if (($uZ(f(h)) === false)) {
                l = t;
                continue
              };
              var start = l;
              var remaining = t;
              while (true) {
                if ($n(remaining).isEmpty__Z()) {
                  var result = start;
                  break block$1
                } else {
                  var x$1 = $n(remaining).head__O();
                  if (($uZ(f(x$1)) !== false)) {
                    remaining = $as_sci_List($n(remaining).tail__O());
                    continue
                  };
                  var firstMiss = remaining;
                  var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                  var toProcess = $as_sci_List($n(start).tail__O());
                  var currentLast = newHead;
                  while ((toProcess !== firstMiss)) {
                    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem;
                    currentLast = newElem;
                    toProcess = $as_sci_List($n(toProcess).tail__O())
                  };
                  var next = $as_sci_List($n(firstMiss).tail__O());
                  var nextToCopy = next;
                  while ((!$n(next).isEmpty__Z())) {
                    var head$1 = $n(next).head__O();
                    if (($uZ(f(head$1)) !== false)) {
                      next = $as_sci_List($n(next).tail__O())
                    } else {
                      while ((nextToCopy !== next)) {
                        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                        currentLast = newElem$2;
                        nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                      };
                      nextToCopy = $as_sci_List($n(next).tail__O());
                      next = $as_sci_List($n(next).tail__O())
                    }
                  };
                  if ((!$n(nextToCopy).isEmpty__Z())) {
                    $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                  };
                  var result = newHead;
                  break block$1
                }
              }
            }
          }
        };
        var this$4 = $n(dones);
        var temp$dones = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$4, found));
        allowed = result;
        dones = temp$dones;
        rest = tail
      } else {
        var x$3 = $m_s_None$();
        if ((x$3 === x1$2)) {
          rest = tail
        } else {
          throw new $c_s_MatchError(x1$2)
        }
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragment$() {
  this.Lreactbuild_analyze_cost_modules_ReportFragment$__f_columns = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$__f_encodePreference = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$__f_decodePreference = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReportFragment$ = this;
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var f = new $c_sjsr_AnonFunction1(((i$2) => {
    $uI(i$2);
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var $$x1 = $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$ = 2;
    var array = [$$x1.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($m_Ljapgolly_scalajs_react_vdom_CssUnits$().addSuffix$extension__O__T__T(this$, "em"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  var this$16 = new $c_sci_RangeIterator(0, 1, 3, false);
  this.Lreactbuild_analyze_cost_modules_ReportFragment$__f_columns = $n($$x3).fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sc_Iterator$$anon$9(this$16, f));
  $m_Lio_circe_Encoder$();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var instance = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  var f$2 = new $c_sjsr_AnonFunction1(((x$33$2) => {
    var x$33 = $as_sci_List(x$33$2);
    var this$19 = $n(x$33);
    var f$1 = ((x$34$2) => {
      var x$34 = $as_Lreactbuild_analyze_cost_modules_ReportFieldSpec(x$34$2);
      return $n(x$34).id__T()
    });
    if ((this$19 === $m_sci_Nil$())) {
      return $m_sci_Nil$()
    } else {
      var arg1 = this$19.head__O();
      var h = new $c_sci_$colon$colon(f$1(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$19.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      return h
    }
  }));
  this.Lreactbuild_analyze_cost_modules_ReportFragment$__f_encodePreference = new $c_Lio_circe_Encoder$$anon$1(instance, f$2);
  $m_Lio_circe_Decoder$();
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var instance$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  var f$3 = new $c_sjsr_AnonFunction1(((lst$2) => {
    var lst = $as_sci_List(lst$2);
    return $p_Lreactbuild_analyze_cost_modules_ReportFragment$__loop$1__sci_List__sci_List__sci_List__sci_List(this, $m_Lreactbuild_analyze_cost_modules_ReportFieldSpec$().Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_defaultList, $m_s_package$().s_package$__f_Nil, lst)
  }));
  this.Lreactbuild_analyze_cost_modules_ReportFragment$__f_decodePreference = new $c_Lio_circe_Decoder$$anon$1(instance$1, f$3);
  var this$33 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReportFragment", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_ReportFragment$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReportFragment$State($m_Ldiode_data_Empty$(), new $c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem($m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$()))
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x5 = $n($as_Lreactbuild_analyze_cost_modules_ReportFragment$Backend($n(x$3).backend__O()));
    var this$28 = $n(x$3);
    var $$x4 = $as_Lreactbuild_analyze_cost_modules_ReportFragment$Props($n(this$28.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$29 = $n(x$3);
    return $n($$x5).render__Lreactbuild_analyze_cost_modules_ReportFragment$Props__Lreactbuild_analyze_cost_modules_ReportFragment$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x4, $as_Lreactbuild_analyze_cost_modules_ReportFragment$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$29)))
  }))));
  var f$4 = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(c$2);
    var this$31 = $n($as_Lreactbuild_analyze_cost_modules_ReportFragment$Backend($n(c).backend__O()));
    var this$30 = $n(c);
    var p$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragment$Props($n(this$30.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$31.refresh__Lreactbuild_analyze_cost_modules_ReportFragment$Props__Ljapgolly_scalajs_react_callback_Trampoline(p$1))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$36 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$33, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$4, G));
  var f$5 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$3$2);
    var $$x6 = $as_Lreactbuild_analyze_cost_modules_ReportFragment$Backend($n(c$3).backend__O());
    var this$34 = $n(c$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x6).onPropsChange__Lreactbuild_analyze_cost_modules_ReportFragment$Props__Lreactbuild_analyze_cost_modules_ReportFragment$Props__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_analyze_cost_modules_ReportFragment$Props($n(this$34.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()), $as_Lreactbuild_analyze_cost_modules_ReportFragment$Props($n(c$3).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_modules_ReportFragment$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$36, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$5, G$1)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReportFragment$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragment$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragment$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragment$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragment$.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragment$.prototype;
var $d_Lreactbuild_analyze_cost_modules_ReportFragment$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragment$: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragment$", {
  Lreactbuild_analyze_cost_modules_ReportFragment$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragment$;
var $n_Lreactbuild_analyze_cost_modules_ReportFragment$;
function $m_Lreactbuild_analyze_cost_modules_ReportFragment$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReportFragment$)) {
    $n_Lreactbuild_analyze_cost_modules_ReportFragment$ = new $c_Lreactbuild_analyze_cost_modules_ReportFragment$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReportFragment$
}
function $p_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReportFragmentDetails", new $c_sjsr_AnonFunction1(((x$45$2) => {
    var x$45 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps(x$45$2);
    return $n(x$45).deriveState__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState()
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$() {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_generic = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_fromMap = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f__idSymbol = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_durationSymbol = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_commentsSymbol = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$ = this;
  var this$1 = $m_s_Symbol$();
  var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
  var this$2 = $m_s_Symbol$();
  var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "date"));
  var this$3 = $m_s_Symbol$();
  var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "resource"));
  var this$4 = $m_s_Symbol$();
  var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "buildingSite"));
  var this$5 = $m_s_Symbol$();
  var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "buildingStage"));
  var this$6 = $m_s_Symbol$();
  var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "duration"));
  var this$7 = $m_s_Symbol$();
  var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "comments")), $m_Lshapeless_HNil$())))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
  var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
    var x0$3 = $as_Lreactbuild_model_TimeReport(x0$3$2);
    if ((x0$3 !== null)) {
      var _id$macro$22 = $n(x0$3).Lreactbuild_model_TimeReport__f__id;
      var date$macro$23 = $n(x0$3).Lreactbuild_model_TimeReport__f_date;
      var resource$macro$24 = $n(x0$3).Lreactbuild_model_TimeReport__f_resource;
      var buildingSite$macro$25 = $n(x0$3).Lreactbuild_model_TimeReport__f_buildingSite;
      var buildingStage$macro$26 = $n(x0$3).Lreactbuild_model_TimeReport__f_buildingStage;
      var duration$macro$27 = $n(x0$3).Lreactbuild_model_TimeReport__f_duration;
      var comments$macro$28 = $n(x0$3).Lreactbuild_model_TimeReport__f_comments;
      return new $c_Lshapeless_$colon$colon(_id$macro$22, new $c_Lshapeless_$colon$colon(date$macro$23, new $c_Lshapeless_$colon$colon(resource$macro$24, new $c_Lshapeless_$colon$colon(buildingSite$macro$25, new $c_Lshapeless_$colon$colon(buildingStage$macro$26, new $c_Lshapeless_$colon$colon(duration$macro$27, new $c_Lshapeless_$colon$colon(comments$macro$28, $m_Lshapeless_HNil$())))))))
    } else {
      throw new $c_s_MatchError(x0$3)
    }
  }));
  var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
    var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
    if ((x0$4 !== null)) {
      var _id$macro$15 = $as_Lreactbuild_common_model_RefTo($n(x0$4).Lshapeless_$colon$colon__f_head);
      var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
      if ((p2 !== null)) {
        var date$macro$16 = $as_Ljava_time_LocalDate($n(p2).Lshapeless_$colon$colon__f_head);
        var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
        if ((p3 !== null)) {
          var resource$macro$17 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
          var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
          if ((p4 !== null)) {
            var buildingSite$macro$18 = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
            var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
            if ((p5 !== null)) {
              var buildingStage$macro$19 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
              var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
              if ((p6 !== null)) {
                var duration$macro$20 = $as_Lreactbuild_model_Duration($n(p6).Lshapeless_$colon$colon__f_head);
                var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                if ((p7 !== null)) {
                  var comments$macro$21 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                  var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p8)) {
                    return new $c_Lreactbuild_model_TimeReport(_id$macro$15, date$macro$16, resource$macro$17, buildingSite$macro$18, buildingStage$macro$19, duration$macro$20, comments$macro$21)
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$4)
  }));
  var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$11 = $m_s_Symbol$();
  var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "comments"));
  new $c_Lshapeless_Witness$$anon$1(value0);
  var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
  $m_Lshapeless_Witness$();
  var this$14 = $m_s_Symbol$();
  var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "duration"));
  new $c_Lshapeless_Witness$$anon$1(value0$1);
  var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
  $m_Lshapeless_Witness$();
  var this$17 = $m_s_Symbol$();
  var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "buildingStage"));
  new $c_Lshapeless_Witness$$anon$1(value0$2);
  var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
  $m_Lshapeless_Witness$();
  var this$20 = $m_s_Symbol$();
  var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "buildingSite"));
  new $c_Lshapeless_Witness$$anon$1(value0$3);
  var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
  $m_Lshapeless_Witness$();
  var this$23 = $m_s_Symbol$();
  var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "resource"));
  new $c_Lshapeless_Witness$$anon$1(value0$4);
  var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
  $m_Lshapeless_Witness$();
  var this$26 = $m_s_Symbol$();
  var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "date"));
  new $c_Lshapeless_Witness$$anon$1(value0$5);
  var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
  $m_Lshapeless_Witness$();
  var this$29 = $m_s_Symbol$();
  var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$6);
  var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
  var this$32 = $m_s_$less$colon$less$();
  var ev = this$32.s_$less$colon$less$__f_singleton;
  var lgen = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_generic = lgen;
  $m_Lshapeless_Witness$();
  var this$35 = $m_s_Symbol$();
  var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "_id"));
  var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$7);
  var tv$6 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
  $m_Lshapeless_Witness$();
  var this$37 = $m_s_Symbol$();
  var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "date"));
  var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$8);
  var tv$5 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_LocalDate.getClassOf(), new $c_sjsr_AnonFunction0((() => "LocalDate")));
  $m_Lshapeless_Witness$();
  var this$39 = $m_s_Symbol$();
  var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "resource"));
  var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
  var tv$4 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
  $m_Lshapeless_Witness$();
  var this$41 = $m_s_Symbol$();
  var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "buildingSite"));
  var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
  var tv$3 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
  $m_Lshapeless_Witness$();
  var this$43 = $m_s_Symbol$();
  var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "buildingStage"));
  var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
  var tv$2 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
  $m_Lshapeless_Witness$();
  var this$45 = $m_s_Symbol$();
  var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "duration"));
  var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
  var tv$1 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Duration.getClassOf(), new $c_sjsr_AnonFunction0((() => "Duration")));
  $m_Lshapeless_Witness$();
  var this$47 = $m_s_Symbol$();
  var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "comments"));
  var wk = new $c_Lshapeless_Witness$$anon$1(value0$13);
  var tv = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
  var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
  var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk, tv, fmt);
  var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$1, tv$1, fmt$1);
  var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$2, tv$2, fmt$2);
  var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$3, tv$3, fmt$3);
  var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$4, tv$4, fmt$4);
  var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$5, tv$5, fmt$5);
  var fm = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$6, tv$6, fmt$6);
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_fromMap = fm;
  var this$58 = $m_s_Symbol$();
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f__idSymbol = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "_id"));
  var this$59 = $m_s_Symbol$();
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_durationSymbol = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "duration"));
  var this$60 = $m_s_Symbol$();
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_commentsSymbol = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "comments"));
  var this$65 = $n($n($n($p_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend(x$1)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x8 = $n($as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend($n(x$3).backend__O()));
    var this$61 = $n(x$3);
    var $$x7 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps($n(this$61.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$62 = $n(x$3);
    return $n($$x8).render__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x7, $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$62)))
  }))));
  var f$1 = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    var $$x9 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend($n(c).backend__O());
    var this$63 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x9).onPropsChange__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps($n(this$63.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()), $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$65, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$1, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$.prototype.withKey__T__sci_List__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__Lreactbuild_analyze_cost_modules_ReportFieldSpec__O__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, parents, proxy, periodRange, timeReports, fieldSpec, fieldValue, updateTimeReports) {
  var c = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps(parents, proxy, periodRange, timeReports, fieldSpec, fieldValue, updateTimeReports);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragmentDetails$: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragmentDetails$", {
  Lreactbuild_analyze_cost_modules_ReportFragmentDetails$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$;
var $n_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$;
function $m_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$)) {
    $n_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$ = new $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$
}
function $p_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReportFragmentGroup", new $c_sjsr_AnonFunction1(((x$48$2) => {
    var x$48 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps(x$48$2);
    return $n(x$48).deriveState__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState()
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$() {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$ = this;
  var this$7 = $n($n($n($p_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    var $$x3 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend($n(c).backend__O());
    var this$5 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).onPropsChange__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()), $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$7, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$.prototype.withKey__T__sci_List__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__Lreactbuild_analyze_cost_modules_ReportFieldSpec__sci_List__O__I__I__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, parents, proxy, periodRange, timeReports, fieldOrder, fieldOrderTail, fieldValue, level, levels, updateTimeReports) {
  var c = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps(parents, proxy, periodRange, timeReports, fieldOrder, fieldOrderTail, fieldValue, level, levels, updateTimeReports);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragmentGroup$", {
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$;
var $n_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$;
function $m_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$)) {
    $n_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$ = new $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportLevel$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ReportLevel$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportLevel$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportLevel$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportLevel$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportLevel$.prototype = $c_Lreactbuild_analyze_cost_modules_ReportLevel$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportLevel$.prototype.apply__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__Lreactbuild_analyze_cost_modules_ReportFieldSpec__F2__Ljapgolly_scalajs_react_vdom_VdomNode = (function(proxy, periodRange, timeReports, fieldSpec, f) {
  var p = new $c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps(proxy, periodRange, timeReports, fieldSpec, f);
  var u$2 = $m_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$().withKey__T__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__Lreactbuild_analyze_cost_modules_ReportFieldSpec__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(fieldSpec).id__T(), p.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_proxy, p.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_periodRange, p.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_timeReports, p.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_fieldSpec, new $c_sjsr_AnonFunction1(((headers$2) => {
    var headers = $as_sci_Seq(headers$2);
    var u$1 = $m_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$().withKey__T__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(fieldSpec).id__T(), new $c_sjsr_AnonFunction1(((additionalHeaders$2) => {
      var additionalHeaders = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(additionalHeaders$2);
      var this$2 = $n(headers);
      var suffix = $as_sc_IterableOnce($n($as_sc_IterableOps($n(additionalHeaders).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).filterNot__F1__O(new $c_sjsr_AnonFunction1(((x$4$2) => $n(headers).contains__O__Z(x$4$2)))));
      var allHeaders = $as_sci_Seq(this$2.appendedAll__sc_IterableOnce__O(suffix));
      var $$x2 = p.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_f;
      if ($n(fieldSpec).havingChoice__Z()) {
        var u = $m_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$().apply__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_ReportFieldSpec__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(p.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_proxy, p.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_fieldSpec, new $c_sjsr_AnonFunction1(((v$2) => {
          var this$3 = $n(additionalHeaders);
          var callback = new $c_sjsr_AnonFunction0((() => {
            var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
            var this$5 = $n(this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$5.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
          }));
          var this$6 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var G = this$6.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
          var arg1 = this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
          var s = $as_sci_Seq(arg1);
          var this$7 = $n($as_sc_SeqOps($n(s).filter__F1__O(new $c_sjsr_AnonFunction1(((x$5$2) => (!$m_sr_BoxesRunTime$().equals__O__O__Z(x$5$2, v$2)))))));
          var arg1$1 = $as_sci_Seq(this$7.appended__O__O(v$2));
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        })));
        var this$9 = $n(u);
        var n = this$9.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var $$x1 = new $c_s_Some(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n))
      } else {
        var $$x1 = $m_s_None$()
      };
      return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($$x2).apply__O__O__O(allHeaders, $$x1))
    })));
    var this$12 = $n(u$1);
    var n$1 = this$12.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  })));
  var this$15 = $n(u$2);
  var n$2 = this$15.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
});
var $d_Lreactbuild_analyze_cost_modules_ReportLevel$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportLevel$: 0
}, false, "reactbuild.analyze.cost.modules.ReportLevel$", {
  Lreactbuild_analyze_cost_modules_ReportLevel$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportLevel$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportLevel$;
var $n_Lreactbuild_analyze_cost_modules_ReportLevel$;
function $m_Lreactbuild_analyze_cost_modules_ReportLevel$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReportLevel$)) {
    $n_Lreactbuild_analyze_cost_modules_ReportLevel$ = new $c_Lreactbuild_analyze_cost_modules_ReportLevel$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReportLevel$
}
function $p_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReportSelectAdditionalHeaders", new $c_sjsr_AnonFunction1(((x$2$2) => {
    $as_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps(x$2$2);
    return $m_s_package$().s_package$__f_Nil
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$() {
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$ = this;
  var this$7 = $n($n($n($p_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_sci_Seq($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(p$2);
    var this$5 = $n(p);
    var mod = new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      $as_sci_Seq(x$3$2$1);
      return $m_s_package$().s_package$__f_Nil
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$5, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$7, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$.prototype = $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$.prototype.withKey__T__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, f) {
  var c = this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps(f);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$: 0
}, false, "reactbuild.analyze.cost.modules.ReportSelectAdditionalHeaders$", {
  Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$;
var $n_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$;
function $m_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$)) {
    $n_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$ = new $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportTotal$() {
  this.Lreactbuild_analyze_cost_modules_ReportTotal$__f_days = null;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_ReportTotal$ = this;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$__f_days = new $c_sci_Range$Exclusive(0, 7, 1);
  var this$8 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ReportTotal", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_ReportTotal$Props(p$2);
    return $n(p).deriveState__Lreactbuild_analyze_cost_modules_ReportTotal$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_ReportTotal$Backend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_ReportTotal$Props($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_ReportTotal$Props__Lreactbuild_analyze_cost_modules_ReportTotal$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_ReportTotal$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(\u03b4$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_analyze_cost_modules_ReportTotal$Backend($n(\u03b4).backend__O())).onPropsChange__Lreactbuild_analyze_cost_modules_ReportTotal$Props__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_analyze_cost_modules_ReportTotal$Props($n(\u03b4).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_modules_ReportTotal$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$8, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_ReportTotal$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportTotal$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportTotal$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportTotal$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportTotal$.prototype = $c_Lreactbuild_analyze_cost_modules_ReportTotal$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportTotal$.prototype.apply__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(proxy, periodRange, timeReports, changeWeek) {
  var c = this.Lreactbuild_analyze_cost_modules_ReportTotal$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_ReportTotal$Props(proxy, periodRange, timeReports, changeWeek);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_ReportTotal$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportTotal$: 0
}, false, "reactbuild.analyze.cost.modules.ReportTotal$", {
  Lreactbuild_analyze_cost_modules_ReportTotal$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportTotal$;
var $n_Lreactbuild_analyze_cost_modules_ReportTotal$;
function $m_Lreactbuild_analyze_cost_modules_ReportTotal$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReportTotal$)) {
    $n_Lreactbuild_analyze_cost_modules_ReportTotal$ = new $c_Lreactbuild_analyze_cost_modules_ReportTotal$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReportTotal$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Resources$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_Resources$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Resources$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Resources$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Resources$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Resources$.prototype = $c_Lreactbuild_analyze_cost_modules_Resources$.prototype;
$c_Lreactbuild_analyze_cost_modules_Resources$.prototype.apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement = (function(active) {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var $$x3 = $m_Lreactbuild_analyze_cost_ui_ItemDetailView$();
    var $$x2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var $$x1 = new $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler($n(pageProps).Lreactbuild_package$PageProps__f_router);
    $m_Lreactbuild_model_Implicits$();
    var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u = $n($$x3).apply__Ldiode_react_ModelProxy__s_Option__Lreactbuild_analyze_cost_ui_ItemDetailViewHandler__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x2, active, $$x1, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$3.byRef__F2(), this$3.by_$eq$eq__F2()));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
var $d_Lreactbuild_analyze_cost_modules_Resources$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Resources$: 0
}, false, "reactbuild.analyze.cost.modules.Resources$", {
  Lreactbuild_analyze_cost_modules_Resources$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_Resources$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Resources$;
var $n_Lreactbuild_analyze_cost_modules_Resources$;
function $m_Lreactbuild_analyze_cost_modules_Resources$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_Resources$)) {
    $n_Lreactbuild_analyze_cost_modules_Resources$ = new $c_Lreactbuild_analyze_cost_modules_Resources$()
  };
  return $n_Lreactbuild_analyze_cost_modules_Resources$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$() {
  this.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$ = this;
  this.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("RetrieveSupplierDocuments", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props__Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$.prototype = $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$.prototype;
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$.prototype.apply__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function() {
  var c = this.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props();
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$: 0
}, false, "reactbuild.analyze.cost.modules.RetrieveSupplierDocuments$", {
  Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$;
var $n_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$;
function $m_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$)) {
    $n_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$ = new $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$()
  };
  return $n_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_SendReceipt$() {
  this.Lreactbuild_analyze_cost_modules_SendReceipt$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_SendReceipt$ = this;
  this.Lreactbuild_analyze_cost_modules_SendReceipt$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("SendReceipt", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_SendReceipt$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_SendReceipt$State($m_Ldiode_data_Empty$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    $n($as_Lreactbuild_analyze_cost_modules_SendReceipt$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    $as_Lreactbuild_analyze_cost_modules_SendReceipt$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    $as_Lreactbuild_analyze_cost_modules_SendReceipt$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5));
    var this$7 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var ns = $m_sci_Nil$();
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, null, ns)
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_SendReceipt$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_SendReceipt$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_SendReceipt$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_SendReceipt$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_SendReceipt$.prototype = $c_Lreactbuild_analyze_cost_modules_SendReceipt$.prototype;
$c_Lreactbuild_analyze_cost_modules_SendReceipt$.prototype.apply__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement = (function(ref) {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_modules_SendReceipt$().Lreactbuild_analyze_cost_modules_SendReceipt$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_modules_SendReceipt$Props(pageProps, ref);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
var $d_Lreactbuild_analyze_cost_modules_SendReceipt$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_SendReceipt$: 0
}, false, "reactbuild.analyze.cost.modules.SendReceipt$", {
  Lreactbuild_analyze_cost_modules_SendReceipt$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_SendReceipt$;
var $n_Lreactbuild_analyze_cost_modules_SendReceipt$;
function $m_Lreactbuild_analyze_cost_modules_SendReceipt$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_SendReceipt$)) {
    $n_Lreactbuild_analyze_cost_modules_SendReceipt$ = new $c_Lreactbuild_analyze_cost_modules_SendReceipt$()
  };
  return $n_Lreactbuild_analyze_cost_modules_SendReceipt$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_SupplyList$() {
  this.Lreactbuild_analyze_cost_modules_SupplyList$__f_component = null;
  this.Lreactbuild_analyze_cost_modules_SupplyList$__f_reuseT = null;
  $n_Lreactbuild_analyze_cost_modules_SupplyList$ = this;
  this.Lreactbuild_analyze_cost_modules_SupplyList$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("SupplyList", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_SupplyList$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_SupplyList$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_SupplyList$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_SupplyList$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_SupplyList$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_SupplyList$Props__Lreactbuild_analyze_cost_modules_SupplyList$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_SupplyList$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)));
  var this$6 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_SupplyList$__f_reuseT = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$6.byRef__F2(), this$6.by_$eq$eq__F2())
}
$c_Lreactbuild_analyze_cost_modules_SupplyList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_SupplyList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_SupplyList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_SupplyList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_SupplyList$.prototype = $c_Lreactbuild_analyze_cost_modules_SupplyList$.prototype;
$c_Lreactbuild_analyze_cost_modules_SupplyList$.prototype.apply__s_Option__Lreactbuild_common_model_RefTo__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(project, user, proxy) {
  var $$x10 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
  var this$1 = $n(project);
  if (this$1.isEmpty__Z()) {
    var $$x9 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x$2 = $as_Lreactbuild_common_model_Project(arg1);
    var $$x9 = new $c_s_Some($n(x$2).Lreactbuild_common_model_Project__f__id)
  };
  var $$x5 = new $c_sjsr_AnonFunction1(((ref$2) => {
    var ref = $as_s_Option(ref$2);
    var this$3 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x8 = new $c_Lautowire_ClientProxy(this$3).Lautowire_ClientProxy__f_self;
    var $$x7 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "person", "SupplyApi", "listRowsFor"];
    var $$x6 = $as_sci_Seq($n($$x7).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$15 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$8 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$10 = $n(new $c_Lautowire_ClientProxy(this$8).Lautowire_ClientProxy__f_self);
    $m_Lio_circe_Encoder$();
    var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var evidence$2 = new $c_Lio_circe_Encoder$$anon$21(e);
    var y = this$10.write__O__Lio_circe_Encoder__Lio_circe_Json(ref, evidence$2);
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "project", y)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($$x8).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x6, this$15.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$16 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$17 = $n(new $c_Lautowire_ClientProxy(this$16).Lautowire_ClientProxy__f_self);
      var evidence$1 = $m_Lreactbuild_person_RowListing$().Lreactbuild_person_RowListing$__f_codecForRowListing;
      return $as_Lreactbuild_person_RowListing(this$17.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  }));
  var $$x1 = new $c_sjsr_AnonFunction1(((ss$2) => {
    var ss = $as_Ldiode_data_Pot(ss$2);
    if ($n(ss).isFailed__Z()) {
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(ss).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$2 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    } else {
      var this$28 = $n(ss);
      if ((!this$28.isEmpty__Z())) {
        var arg1$1 = $n(ss).get__O();
        var v$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1$1);
        var c = $m_Lreactbuild_analyze_cost_modules_SupplyList$().Lreactbuild_analyze_cost_modules_SupplyList$__f_component;
        var this$30 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
        var props = new $c_Lreactbuild_analyze_cost_modules_SupplyList$Props(project, v$1, proxy, user);
        var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$30.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$30.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
        var this$32 = $n(u);
        var n = this$32.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      } else if ($n(ss).isPending__Z()) {
        return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      }
    }
  }));
  var this$41 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  return $n($$x10).query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x9, $$x5, $$x1, this$41.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3), this.Lreactbuild_analyze_cost_modules_SupplyList$__f_reuseT, $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
});
var $d_Lreactbuild_analyze_cost_modules_SupplyList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_SupplyList$: 0
}, false, "reactbuild.analyze.cost.modules.SupplyList$", {
  Lreactbuild_analyze_cost_modules_SupplyList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_SupplyList$;
var $n_Lreactbuild_analyze_cost_modules_SupplyList$;
function $m_Lreactbuild_analyze_cost_modules_SupplyList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_SupplyList$)) {
    $n_Lreactbuild_analyze_cost_modules_SupplyList$ = new $c_Lreactbuild_analyze_cost_modules_SupplyList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_SupplyList$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermLevel$() {
  this.Lreactbuild_analyze_cost_modules_TermLevel$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_TermLevel$ = this;
  this.Lreactbuild_analyze_cost_modules_TermLevel$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_TermLevel$Props(p$2);
    $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context);
    var ref = $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term).Lreactbuild_model_Term__f__id;
    var s = $n($as_sc_SetOps($n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_expanded).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).contains__O__Z(ref);
    var create = $m_Lcom_iz2use_react_components_Dialog$().push__F0__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
      var u = $m_Lreactbuild_analyze_cost_modules_EditListEntry$().apply__Lreactbuild_analyze_cost_modules_EditListEntry$Props__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context, $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_data).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update, $m_s_None$(), new $c_s_Some($n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term).Lreactbuild_model_Term__f__id)));
      var this$3 = $n(u);
      var n = this$3.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    })));
    var matching = new $c_sjsr_AnonFunction1(((x$73$2) => {
      var x$73 = $as_sci_Set(x$73$2);
      return $n(x$73).contains__O__Z($n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term).Lreactbuild_model_Term__f__id)
    }));
    var this$7 = $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_expanded);
    var mod = new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_sci_Set(v$2);
      if ($n(v).contains__O__Z(ref)) {
        var this$5 = $n(v);
        return $as_sci_Set(this$5.excl__O__sci_SetOps(ref))
      } else {
        var this$6 = $n(v);
        return $as_sci_Set(this$6.incl__O__sci_SetOps(ref))
      }
    }));
    var toggle = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$7, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var count = $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_data).count__F1__I(matching);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).prompt__T__T__Ljapgolly_scalajs_react_callback_Trampoline("Changer le nom de cette liste", $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term).Lreactbuild_model_Term__f_label);
    var this$8 = $m_s_$less$colon$less$();
    var this$ = $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$8.s_$less$colon$less$__f_singleton);
    var f = new $c_sjsr_AnonFunction1(((newLabel$2) => {
      var newLabel = $as_T(newLabel$2);
      var this$9 = $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term);
      var x$2 = this$9.Lreactbuild_model_Term__f__id;
      var this$10 = $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term);
      var x$3 = this$10.Lreactbuild_model_Term__f_organization;
      var this$11 = $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term);
      var x$4 = this$11.Lreactbuild_model_Term__f_parent;
      $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term);
      var nextTerm = new $c_Lreactbuild_model_Term(x$2, x$3, newLabel, x$4);
      var async = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
        var this$13 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x5 = new $c_Lautowire_ClientProxy(this$13).Lautowire_ClientProxy__f_self;
        var $$x4 = $m_s_package$().s_package$__f_Seq;
        var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistTerm"];
        var $$x3 = $as_sci_Seq($n($$x4).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
        var this$24 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$18 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$19 = $n(new $c_Lautowire_ClientProxy(this$18).Lautowire_ClientProxy__f_self);
        var evidence$2 = $m_Lreactbuild_model_Term$().Lreactbuild_model_Term$__f_codecForTerm;
        var y = this$19.write__O__Lio_circe_Encoder__Lio_circe_Json(nextTerm, evidence$2);
        var array$1 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        return $n($n($$x5).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x3, this$24.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$5$2) => {
          var x$5 = $as_Lio_circe_Json(x$5$2);
          var this$25 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$26 = $n(new $c_Lautowire_ClientProxy(this$25).Lautowire_ClientProxy__f_self);
          var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
          this$26.read__Lio_circe_Json__Lio_circe_Decoder__O(x$5, evidence$1)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue), new $c_sjsr_AnonFunction1(((x$75$2) => {
        $as_jl_Void(x$75$2);
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_proxy).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_analyze_cost_actions_PersistTerm(nextTerm), $m_Ldiode_Action$aType$())), new $c_sjsr_AnonFunction1(((x$74$2) => {
          $as_jl_Void(x$74$2)
        }))))
      })));
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var c = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(async);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    }));
    var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, f);
    var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$30 = $m_s_$less$colon$less$();
    var edit = $n($$x6).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$30.s_$less$colon$less$__f_singleton);
    var header = $m_Lreactbuild_analyze_cost_modules_TermLevel$().renderHeader__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Z__I__T__Ljapgolly_scalajs_react_vdom_TagOf(create, edit, toggle, s, (((-1) + $n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_level) | 0), ((($n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term).Lreactbuild_model_Term__f_label + " (") + count) + ")"));
    if ((count === 0)) {
      var this$31 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var ns = $m_sci_Nil$();
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$31, null, ns)
    } else if (s) {
      var this$38 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var u$1 = $m_Lreactbuild_analyze_cost_modules_TermListEntries$().apply__Lreactbuild_analyze_cost_modules_EditListEntry$Context__Lreactbuild_analyze_cost_modules_IndexedListEntry__I__s_Option__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context, $n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_data).filter__F1__Lreactbuild_analyze_cost_modules_IndexedListEntry(matching), $n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_level, new $c_s_Some($n($n(p).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term).Lreactbuild_model_Term__f__id));
      var this$33 = $n(u$1);
      var n$1 = this$33.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$2 = [header, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
      var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$38, null, ns$1)
    } else {
      var this$42 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var array$3 = [header];
      var ns$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$42, null, ns$2)
    }
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_TermLevel$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermLevel$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermLevel$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermLevel$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermLevel$.prototype = $c_Lreactbuild_analyze_cost_modules_TermLevel$.prototype;
$c_Lreactbuild_analyze_cost_modules_TermLevel$.prototype.renderHeader__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Z__I__T__Ljapgolly_scalajs_react_vdom_TagOf = (function(create, edit, toggle, s, level, label) {
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_entryListHeader;
  var $$x11 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_entryStageLevel;
  var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$2);
  var $$x9 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "paddingLeft")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((level + "em"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x7 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(label);
  var $$x6 = $m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(create);
  var array = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_add, "", "24px")];
  var array$1 = [$$x7, $n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var $$x5 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var this$18 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var x$2 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty;
  if ((edit === null)) {
    var $$x2 = (x$2 === null)
  } else {
    var this$17 = $n(edit);
    var $$x2 = (this$17 === x$2)
  };
  var cond = (!$$x2);
  if (cond) {
    var $$x4 = $n($m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(edit));
    var array$2 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_create, "", "24px")];
    var $$x3 = $n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  } else {
    var $$x3 = this$18.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  };
  var $$x1 = $m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(toggle);
  var array$3 = [$m_Lcom_iz2use_react_components_Icon$().conditional__Z__Lcom_iz2use_react_components_IconSource__Lcom_iz2use_react_components_IconSource__T__T__T__Ljapgolly_scalajs_react_vdom_TagOf(s, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_expandLess, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_expandMore, "", "", "24px")];
  var array$4 = [$$x11, $$x10, $$x9, $$x5, $$x3, $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  return $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
$c_Lreactbuild_analyze_cost_modules_TermLevel$.prototype.apply__Lreactbuild_analyze_cost_modules_EditListEntry$Context__Lreactbuild_model_Term__I__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_modules_IndexedListEntry__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(context, term, level, expanded, data) {
  var c = this.Lreactbuild_analyze_cost_modules_TermLevel$__f_component;
  var $$x1 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  var a = ("" + $n(term).Lreactbuild_model_Term__f__id);
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x1).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
  var props = new $c_Lreactbuild_analyze_cost_modules_TermLevel$Props(context, term, level, expanded, data);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_TermLevel$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermLevel$: 0
}, false, "reactbuild.analyze.cost.modules.TermLevel$", {
  Lreactbuild_analyze_cost_modules_TermLevel$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_TermLevel$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermLevel$;
var $n_Lreactbuild_analyze_cost_modules_TermLevel$;
function $m_Lreactbuild_analyze_cost_modules_TermLevel$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_TermLevel$)) {
    $n_Lreactbuild_analyze_cost_modules_TermLevel$ = new $c_Lreactbuild_analyze_cost_modules_TermLevel$()
  };
  return $n_Lreactbuild_analyze_cost_modules_TermLevel$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermListEntries$() {
  this.Lreactbuild_analyze_cost_modules_TermListEntries$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_TermListEntries$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  this.Lreactbuild_analyze_cost_modules_TermListEntries$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("TermListEntries", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_TermListEntries$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_TermListEntries$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_TermListEntries$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_TermListEntries$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_TermListEntries$Props__Lreactbuild_analyze_cost_modules_TermListEntries$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_TermListEntries$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_TermListEntries$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermListEntries$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermListEntries$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermListEntries$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermListEntries$.prototype = $c_Lreactbuild_analyze_cost_modules_TermListEntries$.prototype;
$c_Lreactbuild_analyze_cost_modules_TermListEntries$.prototype.apply__Lreactbuild_analyze_cost_modules_EditListEntry$Context__Lreactbuild_analyze_cost_modules_IndexedListEntry__I__s_Option__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(context, data, level, term) {
  var c = this.Lreactbuild_analyze_cost_modules_TermListEntries$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_TermListEntries$Props(context, data, level, term);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_TermListEntries$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermListEntries$: 0
}, false, "reactbuild.analyze.cost.modules.TermListEntries$", {
  Lreactbuild_analyze_cost_modules_TermListEntries$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermListEntries$;
var $n_Lreactbuild_analyze_cost_modules_TermListEntries$;
function $m_Lreactbuild_analyze_cost_modules_TermListEntries$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_TermListEntries$)) {
    $n_Lreactbuild_analyze_cost_modules_TermListEntries$ = new $c_Lreactbuild_analyze_cost_modules_TermListEntries$()
  };
  return $n_Lreactbuild_analyze_cost_modules_TermListEntries$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermTree$() {
  this.Lreactbuild_analyze_cost_modules_TermTree$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_TermTree$ = this;
  this.Lreactbuild_analyze_cost_modules_TermTree$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("TermTree", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_TermTree$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_TermTree$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_TermTree$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_TermTree$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_TermTree$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_TermTree$Props__Lreactbuild_analyze_cost_modules_TermTree$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_TermTree$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_TermTree$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermTree$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermTree$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermTree$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermTree$.prototype = $c_Lreactbuild_analyze_cost_modules_TermTree$.prototype;
$c_Lreactbuild_analyze_cost_modules_TermTree$.prototype.apply__Lreactbuild_analyze_cost_modules_EditListEntry$Context__sci_List__Lreactbuild_analyze_cost_modules_IndexedListEntry__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(context, terms, data, expanded) {
  var c = this.Lreactbuild_analyze_cost_modules_TermTree$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_TermTree$Props(context, terms, data, expanded);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_TermTree$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermTree$: 0
}, false, "reactbuild.analyze.cost.modules.TermTree$", {
  Lreactbuild_analyze_cost_modules_TermTree$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_TermTree$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermTree$;
var $n_Lreactbuild_analyze_cost_modules_TermTree$;
function $m_Lreactbuild_analyze_cost_modules_TermTree$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_TermTree$)) {
    $n_Lreactbuild_analyze_cost_modules_TermTree$ = new $c_Lreactbuild_analyze_cost_modules_TermTree$()
  };
  return $n_Lreactbuild_analyze_cost_modules_TermTree$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_home_HomeLayout$() {
  this.Lreactbuild_analyze_cost_modules_home_HomeLayout$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_home_HomeLayout$ = this;
  this.Lreactbuild_analyze_cost_modules_home_HomeLayout$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).justChildren__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((children$2) => {
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var $$x4 = $m_Lreactbuild_analyze_cost_components_ScrollBlockContainer$();
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$4 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeLayout;
    var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$7 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeLayoutBody;
    var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$1), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(children))];
    var array$1 = [$$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var array$2 = [$n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    return $n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  })))
}
$c_Lreactbuild_analyze_cost_modules_home_HomeLayout$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_home_HomeLayout$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_home_HomeLayout$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_home_HomeLayout$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_home_HomeLayout$.prototype = $c_Lreactbuild_analyze_cost_modules_home_HomeLayout$.prototype;
$c_Lreactbuild_analyze_cost_modules_home_HomeLayout$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_analyze_cost_modules_home_HomeLayout$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_modules_home_HomeLayout$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_home_HomeLayout$: 0
}, false, "reactbuild.analyze.cost.modules.home.HomeLayout$", {
  Lreactbuild_analyze_cost_modules_home_HomeLayout$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_home_HomeLayout$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_home_HomeLayout$;
var $n_Lreactbuild_analyze_cost_modules_home_HomeLayout$;
function $m_Lreactbuild_analyze_cost_modules_home_HomeLayout$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_home_HomeLayout$)) {
    $n_Lreactbuild_analyze_cost_modules_home_HomeLayout$ = new $c_Lreactbuild_analyze_cost_modules_home_HomeLayout$()
  };
  return $n_Lreactbuild_analyze_cost_modules_home_HomeLayout$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$() {
  this.Lreactbuild_analyze_cost_modules_home_HomeMapSearch$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$ = this;
  this.Lreactbuild_analyze_cost_modules_home_HomeMapSearch$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_package$PageProps(p$2);
    var $$x6 = $m_Lcom_iz2use_react_components_Card$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chercher sur la carte");
    var $$x4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x3 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x2 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x1 = $m_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$();
    var this$7 = $n($n(p).Lreactbuild_package$PageProps__f_router);
    var f = new $c_sjsr_AnonFunction1(((step$2) => {
      var step = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(step$2);
      return new $c_Lreactbuild_Loc$BusinessOpportunities(step)
    }));
    var u = $n($$x1).apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(this$7, f, this$7.F__Ljapgolly_scalajs_react_util_Effect$Sync()));
    var this$9 = $n(u);
    var n = this$9.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    return $n($$x6).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x5, $$x4, $$x3, $$x2, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$.prototype = $c_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$.prototype;
$c_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$.prototype.apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(p) {
  var c = this.Lreactbuild_analyze_cost_modules_home_HomeMapSearch$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(p, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_home_HomeMapSearch$: 0
}, false, "reactbuild.analyze.cost.modules.home.HomeMapSearch$", {
  Lreactbuild_analyze_cost_modules_home_HomeMapSearch$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$;
var $n_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$;
function $m_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$)) {
    $n_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$ = new $c_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$()
  };
  return $n_Lreactbuild_analyze_cost_modules_home_HomeMapSearch$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_home_OtherActionList$() {
  this.Lreactbuild_analyze_cost_modules_home_OtherActionList$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_home_OtherActionList$ = this;
  this.Lreactbuild_analyze_cost_modules_home_OtherActionList$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_package$PageProps(p$2);
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    var self = new $c_Lreactbuild_Loc$BusinessOpportunities($m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$());
    var $$x1 = $ct_T2__O__O__(new $c_T2(), self, "Consulter la carte");
    var self$1 = $m_Lreactbuild_Loc$Dashboard$();
    var array = [$$x1, $ct_T2__O__O__(new $c_T2(), self$1, "Mettre \u00e0 jour le relev\u00e9 d'heure de la semaine")];
    var actions = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var $$x10 = $m_Lcom_iz2use_react_components_Card$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("...");
    var $$x8 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x7 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x6 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$17 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeProjectList;
    var array$3 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$17, s), $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), actions), new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var page = $as_s_Product($n(x0$1)._1__O());
        var label = $as_T($n(x0$1)._2__O());
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x3 = $n($n(p).Lreactbuild_package$PageProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(page);
        var this$21 = $m_Lscalacss_ScalaCssReact$();
        var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeOtherActionListItemLink;
        var array$1 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$21, s$1), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(label))];
        var array$2 = [$n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
        return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })))];
    var array$4 = [$n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    return $n($$x10).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x9, $$x8, $$x7, $$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_home_OtherActionList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_home_OtherActionList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_home_OtherActionList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_home_OtherActionList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_home_OtherActionList$.prototype = $c_Lreactbuild_analyze_cost_modules_home_OtherActionList$.prototype;
$c_Lreactbuild_analyze_cost_modules_home_OtherActionList$.prototype.apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(pageProps) {
  var c = this.Lreactbuild_analyze_cost_modules_home_OtherActionList$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(pageProps, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_home_OtherActionList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_home_OtherActionList$: 0
}, false, "reactbuild.analyze.cost.modules.home.OtherActionList$", {
  Lreactbuild_analyze_cost_modules_home_OtherActionList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_home_OtherActionList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_home_OtherActionList$;
var $n_Lreactbuild_analyze_cost_modules_home_OtherActionList$;
function $m_Lreactbuild_analyze_cost_modules_home_OtherActionList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_home_OtherActionList$)) {
    $n_Lreactbuild_analyze_cost_modules_home_OtherActionList$ = new $c_Lreactbuild_analyze_cost_modules_home_OtherActionList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_home_OtherActionList$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_home_ProjectList$() {
  this.Lreactbuild_analyze_cost_modules_home_ProjectList$__f_isSubproject = null;
  this.Lreactbuild_analyze_cost_modules_home_ProjectList$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_home_ProjectList$ = this;
  this.Lreactbuild_analyze_cost_modules_home_ProjectList$__f_isSubproject = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), ".*\\..+", $m_sci_Nil$()));
  this.Lreactbuild_analyze_cost_modules_home_ProjectList$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_package$PageProps(p$2);
    $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy = $n(p).Lreactbuild_package$PageProps__f_proxy;
    var e = new $c_Lreactbuild_model_Implicits$$anon$28(proxy);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var x$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Mes biens et projets en cours");
    var $$x1 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(e.createNew__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction1(((value$2) => {
      var value = $as_Lreactbuild_common_model_Project(value$2);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback(e.update__Lreactbuild_common_model_Project__F1(value))
    })))));
    var array = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_add, "", "24px")];
    var x$2 = $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var x$3 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var x$4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x14 = $m_sci_Seq$();
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$16 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeProjectList;
    var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$16, s);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$17 = $n($n(p).Lreactbuild_package$PageProps__f_proxy);
    var this$18 = $n(this$17.Ldiode_react_ModelProxy__f_modelReader);
    var this$19 = $n($n($as_Lreactbuild_analyze_cost_services_Model(this$18.value__O())).Lreactbuild_analyze_cost_services_Model__f_commonData);
    var o = ((!this$19.isEmpty__Z()) ? new $c_s_Some(this$19.get__O()) : $m_s_None$());
    var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
    var array$7 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((data$2) => {
      var data = $as_Lreactbuild_model_CommonData(data$2);
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$21 = $n($n(data).Lreactbuild_model_CommonData__f_buildingSites);
      var f = ((prj$2) => {
        var prj = $as_Lreactbuild_common_model_Project(prj$2);
        return ($n($n(prj).Lreactbuild_common_model_Project__f_archived).isEmpty__Z() && (!$n($m_Lreactbuild_analyze_cost_modules_home_ProjectList$().Lreactbuild_analyze_cost_modules_home_ProjectList$__f_isSubproject).matches__jl_CharSequence__Z($n(prj).Lreactbuild_common_model_Project__f_reference)))
      });
      var l = this$21;
      block: {
        var result;
        while (true) {
          if ($n(l).isEmpty__Z()) {
            var result = $m_sci_Nil$();
            break
          } else {
            var h = $n(l).head__O();
            var t = $as_sci_List($n(l).tail__O());
            if (($uZ(f(h)) === false)) {
              l = t;
              continue
            };
            var start = l;
            var remaining = t;
            while (true) {
              if ($n(remaining).isEmpty__Z()) {
                var result = start;
                break block
              } else {
                var x = $n(remaining).head__O();
                if (($uZ(f(x)) !== false)) {
                  remaining = $as_sci_List($n(remaining).tail__O());
                  continue
                };
                var firstMiss = remaining;
                var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                var toProcess = $as_sci_List($n(start).tail__O());
                var currentLast = newHead;
                while ((toProcess !== firstMiss)) {
                  var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem;
                  currentLast = newElem;
                  toProcess = $as_sci_List($n(toProcess).tail__O())
                };
                var next = $as_sci_List($n(firstMiss).tail__O());
                var nextToCopy = next;
                while ((!$n(next).isEmpty__Z())) {
                  var head = $n(next).head__O();
                  if (($uZ(f(head)) !== false)) {
                    next = $as_sci_List($n(next).tail__O())
                  } else {
                    while ((nextToCopy !== next)) {
                      var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                      $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                      currentLast = newElem$2;
                      nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                    };
                    nextToCopy = $as_sci_List($n(next).tail__O());
                    next = $as_sci_List($n(next).tail__O())
                  }
                };
                if ((!$n(nextToCopy).isEmpty__Z())) {
                  $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                };
                var result = newHead;
                break block
              }
            }
          }
        }
      };
      return $n($$x3).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(result, new $c_sjsr_AnonFunction1(((prj$3$2) => {
        var prj$3 = $as_Lreactbuild_common_model_Project(prj$3$2);
        $n($m_s_package$().s_package$__f_List);
        var array$1 = [$n(prj$3).Lreactbuild_common_model_Project__f_reference, $n(prj$3).Lreactbuild_common_model_Project__f_name, $n(prj$3).Lreactbuild_common_model_Project__f_title];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        var this$30 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
        var f$1 = ((x$1$2) => {
          var x$1$1 = $as_T(x$1$2);
          $m_sc_StringOps$();
          var this$29 = $n(x$1$1);
          return (!(this$29 === ""))
        });
        var l$1 = this$30;
        block$2: {
          var result$1;
          while (true) {
            if ($n(l$1).isEmpty__Z()) {
              var result$1 = $m_sci_Nil$();
              break
            } else {
              var h$1 = $n(l$1).head__O();
              var t$1 = $as_sci_List($n(l$1).tail__O());
              if (($uZ(f$1(h$1)) === false)) {
                l$1 = t$1;
                continue
              };
              var start$1 = l$1;
              var remaining$1 = t$1;
              while (true) {
                if ($n(remaining$1).isEmpty__Z()) {
                  var result$1 = start$1;
                  break block$2
                } else {
                  var x$5 = $n(remaining$1).head__O();
                  if (($uZ(f$1(x$5)) !== false)) {
                    remaining$1 = $as_sci_List($n(remaining$1).tail__O());
                    continue
                  };
                  var firstMiss$1 = remaining$1;
                  var newHead$1 = new $c_sci_$colon$colon($n(start$1).head__O(), $m_sci_Nil$());
                  var toProcess$1 = $as_sci_List($n(start$1).tail__O());
                  var currentLast$1 = newHead$1;
                  while ((toProcess$1 !== firstMiss$1)) {
                    var newElem$1 = new $c_sci_$colon$colon($n(toProcess$1).head__O(), $m_sci_Nil$());
                    $n(currentLast$1).sci_$colon$colon__f_next = newElem$1;
                    currentLast$1 = newElem$1;
                    toProcess$1 = $as_sci_List($n(toProcess$1).tail__O())
                  };
                  var next$1 = $as_sci_List($n(firstMiss$1).tail__O());
                  var nextToCopy$1 = next$1;
                  while ((!$n(next$1).isEmpty__Z())) {
                    var head$1 = $n(next$1).head__O();
                    if (($uZ(f$1(head$1)) !== false)) {
                      next$1 = $as_sci_List($n(next$1).tail__O())
                    } else {
                      while ((nextToCopy$1 !== next$1)) {
                        var newElem$2$1 = new $c_sci_$colon$colon($n(nextToCopy$1).head__O(), $m_sci_Nil$());
                        $n(currentLast$1).sci_$colon$colon__f_next = newElem$2$1;
                        currentLast$1 = newElem$2$1;
                        nextToCopy$1 = $as_sci_List($n(nextToCopy$1).tail__O())
                      };
                      nextToCopy$1 = $as_sci_List($n(next$1).tail__O());
                      next$1 = $as_sci_List($n(next$1).tail__O())
                    }
                  };
                  if ((!$n(nextToCopy$1).isEmpty__Z())) {
                    $n(currentLast$1).sci_$colon$colon__f_next = nextToCopy$1
                  };
                  var result$1 = newHead$1;
                  break block$2
                }
              }
            }
          }
        };
        var this$31 = $n(result$1);
        var labels = $as_sci_List($f_sc_SeqOps__distinct__O(this$31));
        var x$6 = $m_s_package$().s_package$__f_Nil;
        if (((x$6 === null) ? (labels === null) : $n(x$6).equals__O__Z(labels))) {
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Sans nom")
        } else {
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          var this$35 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          var sep = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_vdom_HtmlTags__br__T(this$35), $m_sci_Nil$());
          var f$2 = new $c_sjsr_AnonFunction1(((v$2) => {
            var v = $as_T(v$2);
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
          }));
          var label = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(labels, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$2)
        };
        var this$39 = $n($n($n(prj$3).Lreactbuild_common_model_Project__f_images).headOption__s_Option());
        if (this$39.isEmpty__Z()) {
          var imageUrlOpt = $m_s_None$()
        } else {
          var arg1 = this$39.get__O();
          var x$2$2 = $as_Lreactbuild_common_model_Image(arg1);
          var imageUrlOpt = new $c_s_Some($n(x$2$2).fullPath__T__T($m_Lreactbuild_package$().Lreactbuild_package$__f_scheme))
        };
        var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$42 = $m_Lscalacss_ScalaCssReact$();
        var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeProjectListItem;
        var $$x11 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$42, s$1);
        var $$x10 = $n($n(p).Lreactbuild_package$PageProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$Project(new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary($m_s_Option$().apply__O__s_Option($n(prj$3).Lreactbuild_common_model_Project__f__id))));
        var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$45 = $m_Lscalacss_ScalaCssReact$();
        var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeProjectListItemImage;
        var $$x8 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$45, s$2);
        var this$46 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var cond = $n(imageUrlOpt).isEmpty__Z();
        if (cond) {
          var this$47 = $m_Lscalacss_ScalaCssReact$();
          var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeProjectListItemImageAbsent;
          var $$x7 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$47, s$3)
        } else {
          var $$x7 = this$46.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
        };
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var O$1 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
        var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(imageUrlOpt, O$1).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((url$2) => {
          var url = $as_T(url$2);
          var this$53 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
          var array$2 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle("backgroundImage")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((("url(" + url) + ")"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
          var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
          return this$53.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
        })));
        var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$56 = $m_Lscalacss_ScalaCssReact$();
        var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeProjectListItemTitle;
        var array$3 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$56, s$4), label];
        var array$4 = [$$x8, $$x7, $$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
        var array$5 = [$n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
        var array$6 = [$$x11, $n($$x10).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
        return $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
      })))
    })))];
    var array$8 = [$n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
    var x$6$1 = $as_sci_Seq($n($$x14).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8)));
    return $m_Lcom_iz2use_react_components_Card$().apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(x$1, x$3, x$2, x$4, x$6$1)
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_home_ProjectList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_home_ProjectList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_home_ProjectList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_home_ProjectList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_home_ProjectList$.prototype = $c_Lreactbuild_analyze_cost_modules_home_ProjectList$.prototype;
$c_Lreactbuild_analyze_cost_modules_home_ProjectList$.prototype.apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(pageProps) {
  var c = this.Lreactbuild_analyze_cost_modules_home_ProjectList$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(pageProps, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_home_ProjectList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_home_ProjectList$: 0
}, false, "reactbuild.analyze.cost.modules.home.ProjectList$", {
  Lreactbuild_analyze_cost_modules_home_ProjectList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_home_ProjectList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_home_ProjectList$;
var $n_Lreactbuild_analyze_cost_modules_home_ProjectList$;
function $m_Lreactbuild_analyze_cost_modules_home_ProjectList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_home_ProjectList$)) {
    $n_Lreactbuild_analyze_cost_modules_home_ProjectList$ = new $c_Lreactbuild_analyze_cost_modules_home_ProjectList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_home_ProjectList$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_home_TodayList$() {
  this.Lreactbuild_analyze_cost_modules_home_TodayList$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_home_TodayList$ = this;
  this.Lreactbuild_analyze_cost_modules_home_TodayList$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((props$2) => {
    $as_Lreactbuild_package$PageProps(props$2);
    var $$x23 = $m_Lcom_iz2use_react_components_Card$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x22 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aujourd'hui");
    var $$x21 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x20 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x19 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$9 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_homeProjectList;
    var $$x17 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$9, s);
    var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Scanner un QRcode")), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Entrer ville + la phrase"))];
    var $$x15 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x13 = $m_Lcom_iz2use_react_components_Link$();
    var $$x12 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$();
    var u = $m_Lreactbuild_project_CreateOrSelectLocalizedProject$().apply__Lreactbuild_project_Activity__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_Lreactbuild_project_OpportunityStudy$());
    var this$23 = $n(u);
    var n = this$23.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x11 = $n($$x13).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x12).dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lcom_iz2use_react_components_Dialog$Push(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n))));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $m_Lreactbuild_project_OpportunityStudy$().Lreactbuild_project_OpportunityStudy$__f_title;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var array$2 = [$n($$x11).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    var $$x10 = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x8 = $m_Lcom_iz2use_react_components_Link$();
    var $$x7 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$();
    var u$1 = $m_Lreactbuild_project_CreateOrSelectLocalizedProject$().apply__Lreactbuild_project_Activity__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_Lreactbuild_project_SiteVisit$());
    var this$37 = $n(u$1);
    var n$1 = this$37.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x6 = $n($$x8).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x7).dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lcom_iz2use_react_components_Dialog$Push(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1))));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = $m_Lreactbuild_project_SiteVisit$().Lreactbuild_project_SiteVisit$__f_title;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    var array$4 = [$n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    var $$x5 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x3 = $m_Lcom_iz2use_react_components_Link$();
    var $$x2 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$();
    var u$2 = $m_Lreactbuild_project_CreateOrSelectLocalizedProject$().apply__Lreactbuild_project_Activity__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_Lreactbuild_project_OnSiteSurvey$());
    var this$51 = $n(u$2);
    var n$2 = this$51.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x1 = $n($$x3).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x2).dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lcom_iz2use_react_components_Dialog$Push(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2))));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$2 = $m_Lreactbuild_project_OnSiteSurvey$().Lreactbuild_project_OnSiteSurvey$__f_title;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$5 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
    var array$6 = [$n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var array$7 = [$$x17, $$x15, $$x10, $$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
    var array$8 = [$n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
    return $n($$x23).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x22, $$x21, $$x20, $$x19, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_home_TodayList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_home_TodayList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_home_TodayList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_home_TodayList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_home_TodayList$.prototype = $c_Lreactbuild_analyze_cost_modules_home_TodayList$.prototype;
$c_Lreactbuild_analyze_cost_modules_home_TodayList$.prototype.apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(pageProps) {
  var c = this.Lreactbuild_analyze_cost_modules_home_TodayList$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(pageProps, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_home_TodayList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_home_TodayList$: 0
}, false, "reactbuild.analyze.cost.modules.home.TodayList$", {
  Lreactbuild_analyze_cost_modules_home_TodayList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_home_TodayList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_home_TodayList$;
var $n_Lreactbuild_analyze_cost_modules_home_TodayList$;
function $m_Lreactbuild_analyze_cost_modules_home_TodayList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_home_TodayList$)) {
    $n_Lreactbuild_analyze_cost_modules_home_TodayList$ = new $c_Lreactbuild_analyze_cost_modules_home_TodayList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_home_TodayList$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$ = this;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("HomeTimeReport", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props(p$2);
    var this$3 = $m_Ljava_time_LocalDate$();
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(this$3.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId())), false)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomElement = (function() {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$().Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props($n(pageProps).Lreactbuild_package$PageProps__f_proxy);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$.prototype.apply__Lshapeless_$colon$colon__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(stack, proxy, context) {
  return $m_Lreactbuild_analyze_cost_components_Refine$().apply__O__F1__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(context).timeReports__sci_List(), new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_sci_List(x$1$2);
    var this$2 = $n(x$1);
    var m = $as_scm_Map($m_scm_Map$().empty__O());
    var it = this$2.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var x$2 = $as_Lreactbuild_model_TimeReport(elem);
      var key = $n(x$2).Lreactbuild_model_TimeReport__f_buildingStage;
      var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => {
        $m_sci_List$();
        return new $c_scm_ListBuffer()
      }))));
      var this$4 = $n(bldr);
      this$4.addOne__O__scm_Growable(elem)
    };
    var this$5 = $m_sci_HashMap$();
    var result = this$5.sci_HashMap$__f_EmptyMap;
    var mapIt = $n(m).iterator__sc_Iterator();
    while ($n(mapIt).hasNext__Z()) {
      var x1 = $as_T2($n(mapIt).next__O());
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1)
      };
      var k = $n(x1)._1__O();
      var v = $as_scm_Builder($n(x1)._2__O());
      result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
    };
    return result
  })), new $c_sjsr_AnonFunction1(((timeReportByBuildingStage$2) => {
    var timeReportByBuildingStage = $as_sci_Map(timeReportByBuildingStage$2);
    var projects = $n(context).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingSites;
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x12 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("details", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var this$8 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reportTable;
    var $$x11 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$8, s);
    var this$9 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
    var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$9, s$1);
    var this$10 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_strippedLinesTable;
    var $$x9 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s$2);
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Stade"))];
    var array$2 = [$n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), projects), new $c_sjsr_AnonFunction1(((prj$2) => {
      var prj = $as_Lreactbuild_common_model_RefTo(prj$2);
      var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$25 = $m_Lreactbuild_model_Implicits$();
      var ev = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$25, proxy);
      var v$1 = $n(ev).stringify__O__T(prj);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    })))];
    var array$3 = [$n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
    var $$x4 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$6 = [$m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$().apply__Lshapeless_HList__sci_List__F1__Ljapgolly_scalajs_react_vdom_VdomElement(stack, $n(context).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingStages, new $c_sjsr_AnonFunction1(((stack$2) => {
      var stack$1 = $as_Lshapeless_$colon$colon(stack$2);
      var stage = $as_s_Option($n(stack$1).Lshapeless_$colon$colon__f_head);
      var u$2 = $m_Lreactbuild_analyze_cost_components_Refine$().apply__O__F1__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(timeReportByBuildingStage, new $c_sjsr_AnonFunction1(((x$3$2) => {
        var x$3 = $as_sci_Map(x$3$2);
        var this$40 = $n(x$3);
        var default$1 = new $c_sjsr_AnonFunction1(((x$4$2) => {
          $as_s_Option(x$4$2);
          return $m_s_package$().s_package$__f_Nil
        }));
        var this$41 = $n($as_sc_IterableOps($f_sc_MapOps__applyOrElse__O__F1__O(this$40, stage, default$1)));
        var m$1 = $as_scm_Map($m_scm_Map$().empty__O());
        var it$1 = this$41.iterator__sc_Iterator();
        while ($n(it$1).hasNext__Z()) {
          var elem$1 = $n(it$1).next__O();
          var x$5 = $as_Lreactbuild_model_TimeReport(elem$1);
          var key$1 = $n(x$5).Lreactbuild_model_TimeReport__f_buildingSite;
          var bldr$1 = $as_scm_Builder($n(m$1).getOrElseUpdate__O__F0__O(key$1, new $c_sjsr_AnonFunction0(((this$41) => (() => this$41.newSpecificBuilder__scm_Builder()))(this$41))));
          var this$42 = $n(bldr$1);
          this$42.addOne__O__scm_Growable(elem$1)
        };
        var this$43 = $m_sci_HashMap$();
        var result$1 = this$43.sci_HashMap$__f_EmptyMap;
        var mapIt$1 = $n(m$1).iterator__sc_Iterator();
        while ($n(mapIt$1).hasNext__Z()) {
          var x1$1 = $as_T2($n(mapIt$1).next__O());
          if ((x1$1 === null)) {
            throw new $c_s_MatchError(x1$1)
          };
          var k$1 = $n(x1$1)._1__O();
          var v$2 = $as_scm_Builder($n(x1$1)._2__O());
          result$1 = $n(result$1).updated__O__O__sci_HashMap(k$1, $n(v$2).result__O())
        };
        return result$1
      })), new $c_sjsr_AnonFunction1(((timeReportByProject$2) => {
        var timeReportByProject = $as_sci_Map(timeReportByProject$2);
        var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$48 = $m_Lreactbuild_model_Implicits$();
        var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$48, proxy);
        var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
        var v$3 = ev$1.stringify__s_Option__T(stage);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
        var array$5 = [$n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)), $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$().apply__Lshapeless_HList__sci_List__F1__Ljapgolly_scalajs_react_vdom_VdomElement(stack$1, projects, new $c_sjsr_AnonFunction1(((stack$3) => {
          var stack$4 = $as_Lshapeless_$colon$colon(stack$3);
          var u$1 = $m_Lreactbuild_analyze_cost_components_Refine$().apply__O__F1__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(timeReportByProject, new $c_sjsr_AnonFunction1(((x$6$2) => {
            var x$6 = $as_sci_Map(x$6$2);
            var this$56 = $n(x$6);
            var x = $n(stack$4).Lshapeless_$colon$colon__f_head;
            var default$2 = new $c_sjsr_AnonFunction1(((x$7$2) => {
              $as_Lreactbuild_common_model_RefTo(x$7$2);
              return $m_s_package$().s_package$__f_Nil
            }));
            var this$57 = $n($as_sc_IterableOps($f_sc_MapOps__applyOrElse__O__F1__O(this$56, x, default$2)));
            var m$2 = $as_scm_Map($m_scm_Map$().empty__O());
            var it$2 = this$57.iterator__sc_Iterator();
            while ($n(it$2).hasNext__Z()) {
              var elem$2 = $n(it$2).next__O();
              var x$8 = $as_Lreactbuild_model_TimeReport(elem$2);
              var key$2 = $n(x$8).Lreactbuild_model_TimeReport__f_resource;
              var bldr$2 = $as_scm_Builder($n(m$2).getOrElseUpdate__O__F0__O(key$2, new $c_sjsr_AnonFunction0(((this$57) => (() => this$57.newSpecificBuilder__scm_Builder()))(this$57))));
              var this$58 = $n(bldr$2);
              this$58.addOne__O__scm_Growable(elem$2)
            };
            var this$59 = $m_sci_HashMap$();
            var result$2 = this$59.sci_HashMap$__f_EmptyMap;
            var mapIt$2 = $n(m$2).iterator__sc_Iterator();
            while ($n(mapIt$2).hasNext__Z()) {
              var x1$2 = $as_T2($n(mapIt$2).next__O());
              if ((x1$2 === null)) {
                throw new $c_s_MatchError(x1$2)
              };
              var k$2 = $n(x1$2)._1__O();
              var v$4 = $as_scm_Builder($n(x1$2)._2__O());
              result$2 = $n(result$2).updated__O__O__sci_HashMap(k$2, $n(v$4).result__O())
            };
            return result$2
          })), new $c_sjsr_AnonFunction1(((x$9$2) => {
            var x$9 = $as_sci_Map(x$9$2);
            var u = $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$().apply__sci_Map__Lshapeless_$colon$colon__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(x$9, stack$4, proxy, context);
            var this$61 = $n(u);
            var n = this$61.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
            return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
          })));
          var this$64 = $n(u$1);
          var n$1 = this$64.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
        })))];
        return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
      })));
      var this$70 = $n(u$2);
      var n$2 = this$70.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
    })))];
    var array$7 = [$$x12, $$x11, $$x10, $$x9, $$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
    return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
  })))
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportAssignments$", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$__f_touchAction = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$__f_userSelect = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$ = this;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$__f_touchAction = $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "touchAction");
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$__f_userSelect = $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "userSelect");
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("HomeTimeReportCell", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State($m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$.prototype.apply__sci_Map__Lshapeless_$colon$colon__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(resourceTimeReports, stack, proxy, context) {
  var c = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props(proxy, resourceTimeReports, stack, context);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$ = this;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("HomeTimeReportCellResource", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props(p$2);
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_resourceTimeReport);
    if (this$2.isEmpty__Z()) {
      var $$x3 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$6 = $as_Lreactbuild_model_TimeReport(arg1);
      var $$x3 = new $c_s_Some($n($n(x$6).Lreactbuild_model_TimeReport__f_duration).Lreactbuild_model_Duration__f_value)
    };
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle($$x3)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$.prototype.apply__s_Option__Lshapeless_$colon$colon__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(resourceTimeReport, stack, proxy, context) {
  var c = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$__f_component;
  var $$x1 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  var a = $n($n($as_Lreactbuild_common_model_RefTo($n(stack).Lshapeless_$colon$colon__f_head)).Lreactbuild_common_model_RefTo__f_id).toString__T();
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x1).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
  var props = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props(proxy, resourceTimeReport, stack, context);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$
}
function $is_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State)))
}
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$State;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$__f_textDecorationStyle = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$__f_textDecorationColor = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$ = this;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$__f_textDecorationStyle = $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "textDecorationStyle");
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$__f_textDecorationColor = $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "textDecorationColor");
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("HomeTimeReportDayIntervals", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_common_model_RefTo__Ljava_time_LocalDate__sci_List__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(events, resource, date, intervals) {
  var c = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(events, resource, date, intervals);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$ = this;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("HomeTimeReportResourceSummary", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__jl_Void__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_jl_Void($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$.prototype.apply__Ljava_time_LocalDate__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(date, includeAllUsers, proxy, context) {
  var c = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props(date, includeAllUsers, proxy, context);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportResourceSummary$", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$.prototype.apply__Lshapeless_HList__sci_List__F1__Ljapgolly_scalajs_react_vdom_VdomElement = (function(parentStack, values, renderFn) {
  var this$4 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var this$3 = $n(values);
  var f = ((head$2) => $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(renderFn).apply__O__O(new $c_Lshapeless_syntax_HListOps(parentStack).$colon$colon__O__Lshapeless_$colon$colon(head$2))));
  if ((this$3 === $m_sci_Nil$())) {
    var ns = $m_sci_Nil$()
  } else {
    var arg1 = this$3.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$3.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var ns = h
  };
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$4, null, ns)
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportStack$", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportStack$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$ = this;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("HomeTimeReportSummaryLine", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$.prototype.apply__Lreactbuild_common_model_RefTo__sci_List__Ljava_time_LocalDate__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(resource, events, date, proxy, context) {
  var c = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$__f_component;
  var $$x1 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  var a = $n($n(resource).Lreactbuild_common_model_RefTo__f_id).toString__T();
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x1).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
  var props = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props(proxy, context, resource, events, date);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_days = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_dateFormatter = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$ = this;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_days = new $c_sci_Range$Exclusive(0, 7, 1);
  var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_dateFormatter = $m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__ju_Locale__Ljava_time_format_DateTimeFormatter("LLL yyyy", locale);
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Multiweeks", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__I__I__Z__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(date, weekBefore, weekAfter, notFuture, render) {
  var c = this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props(date, weekBefore, weekAfter, notFuture, render);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$", {
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$
}
function $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  $n(b$2$lzy$1);
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
function $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  $n(b$3$lzy$1);
  if ($n(b$3$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityLocalDateTime__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$3$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  return ($n(b$3$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1))
}
function $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  $n(b$4$lzy$1);
  if ($n(b$4$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$4$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  return ($n(b$4$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__f_reusableTimeReportEvent = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$ = this;
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  var b$3$lzy = new $c_sr_LazyRef();
  var b$4$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_model_TimeReportEvent(a$2);
    var b = $as_Lreactbuild_model_TimeReportEvent(b$2);
    return (((($uZ($n($p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_model_TimeReportEvent__f__id, $n(b).Lreactbuild_model_TimeReportEvent__f__id)) && $uZ($n($p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lreactbuild_model_TimeReportEvent__f_resource, $n(b).Lreactbuild_model_TimeReportEvent__f_resource))) && $uZ($n($p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$3$1__sr_LazyRef__F2(this, b$3$lzy)).apply__O__O__O($n(a).Lreactbuild_model_TimeReportEvent__f_date, $n(b).Lreactbuild_model_TimeReportEvent__f_date))) && $uZ($n($p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$4$1__sr_LazyRef__F2(this, b$4$lzy)).apply__O__O__O($n(a).Lreactbuild_model_TimeReportEvent__f_ignore, $n(b).Lreactbuild_model_TimeReportEvent__f_ignore))) && $uZ($n($p_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__b$4$1__sr_LazyRef__F2(this, b$4$lzy)).apply__O__O__O($n(a).Lreactbuild_model_TimeReportEvent__f_manuallyAdded, $n(b).Lreactbuild_model_TimeReportEvent__f_manuallyAdded)))
  }));
  elem = f;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__f_reusableTimeReportEvent = $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem));
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("TimeReportSummary", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State($m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$().apply$default$1__Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(), $m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x4 = $n($as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    var $$x3 = $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$6 = $n(x$3);
    return $n($$x4).render__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x3, $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$6)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomElement = (function() {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$().Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props($n(pageProps).Lreactbuild_package$PageProps__f_proxy);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$", {
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$__f_dayFormatter = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$ = this;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$__f_dayFormatter = $m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__Ljava_time_format_DateTimeFormatter("EEEE d");
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("TimeReportSummaryMonth", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$.prototype.apply__Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__s_Option__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(range, resource, events) {
  var c = this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props(range, resource, events);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$", {
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.FeatureInfo"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.FeatureInfo;", depth))
}
function $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__($thiz) {
  $thiz.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = $n($m_ju_UUID$().randomUUID__ju_UUID()).toString__T();
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_Layer() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null
}
$c_Lreactbuild_analyze_cost_modules_mapview_Layer.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_Layer.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_Layer;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_Layer() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_Layer.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_Layer.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_Layer.prototype.getDocuments__sjs_js_Array__D__T__F1 = (function(coordinates, resolution, projection) {
  return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1($m_s_package$().s_package$__f_Nil)
});
function $as_Lreactbuild_analyze_cost_modules_mapview_Layer(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_Layer) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.Layer"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_Layer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_Layer)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_Layer(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_Layer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.Layer;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_Layer$() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer$__f_reusabilityLayer = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_Layer$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_Lreactbuild_analyze_cost_modules_mapview_Layer(x$8$2);
    return $n(x$8).Lreactbuild_analyze_cost_modules_mapview_Layer__f_id
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  this.Lreactbuild_analyze_cost_modules_mapview_Layer$__f_reusabilityLayer = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
}
$c_Lreactbuild_analyze_cost_modules_mapview_Layer$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_Layer$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_Layer$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_Layer$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_Layer$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_Layer$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_Layer$.prototype.getAndStripZero__Ltypings_ol_featureMod$default__T__sjs_js_$bar = (function(feature, name) {
  var value = feature.get(name);
  if ((value === (void 0))) {
    return (void 0)
  } else {
    var x$6 = $as_T(value);
    $m_sc_StringOps$();
    $m_sc_StringOps$();
    $m_sc_StringOps$();
    var from = 0;
    _return: {
      var this$9 = $n(x$6);
      var len = this$9.length;
      var i = from;
      while ((i < len)) {
        var this$10 = $n(x$6);
        var index = i;
        var arg1 = $charAt(this$10, index);
        if ((arg1 !== 48)) {
          var x1 = i;
          break _return
        };
        i = ((1 + i) | 0)
      };
      var x1 = (-1)
    };
    if ((x1 === (-1))) {
      var a = ""
    } else {
      var this$11 = $n(x$6);
      if (((x1 < 0) || (x1 > this$11.length))) {
        $charAt(this$11, x1)
      };
      var a = $as_T(this$11.substring(x1))
    };
    return a
  }
});
var $d_Lreactbuild_analyze_cost_modules_mapview_Layer$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_Layer$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.Layer$", {
  Lreactbuild_analyze_cost_modules_mapview_Layer$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_Layer$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_Layer$;
var $n_Lreactbuild_analyze_cost_modules_mapview_Layer$;
function $m_Lreactbuild_analyze_cost_modules_mapview_Layer$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_Layer$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_Layer$ = new $c_Lreactbuild_analyze_cost_modules_mapview_Layer$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_Layer$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_TiledOrthoPhotoMap = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmsAltimetrieUrl = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AltiA = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Geofoncier = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AltimetrieE = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUCityDivision = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUCommunications = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUPatrimoine = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUCanalisation = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_administrativeLimits = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Site = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_PEB = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_PEB2 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_PEB3 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Building = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_F_GEOL1M = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_D_GEOL50 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_F_GEOL250 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_H_RELIEF_GEOL50 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoLITHO_1M_SIMPLIFIEE = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoBSS = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoIDPR = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoGRAVI_BASE = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoGRAVI_STATION = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoAEROMAG_CAMPAGNE = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoBGM = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Inondations = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AleaArgile = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Faille = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_DeformationsRecentes = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_CaviteLoc = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_CaviteNonLoc = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_MouvementTerrainLoc = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_MouvementTerrainNonLoc = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Sismique = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AncienSiteIndustrielLoc = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AncienSiteIndustrielNonLoc = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_list = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_TiledOrthoPhotoMap = new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Photographie a\u00e9riennes", "ORTHOIMAGERY.ORTHOPHOTOS", "/api/geo/wmts/ortho", new $c_sjsr_AnonFunction1(((tg$2) => {
    tg$2.maxZoom = 19.0
  })), $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$6__F3());
  new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Photographie a\u00e9riennes [Non tuil\u00e9]", "ORTHOIMAGERY.ORTHOPHOTOS", "/api/geo/wmts/ortho", $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl = "/api/geo/wmts/altimetrie";
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmsAltimetrieUrl = "/api/geo/wms/altimetrie";
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AltiA = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Lignes de niveaux", "ELEVATION.CONTOUR.LINE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmsAltimetrieUrl, $m_s_None$(), $m_s_None$());
  new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Altitude", "ELEVATION.SLOPES", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmsAltimetrieUrl, $m_s_None$(), $m_s_None$());
  new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Cartes des pentes", "GEOGRAPHICALGRIDSYSTEMS.SLOPES.MOUNTAIN", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl, $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$5__F1(), $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$6__F3());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Geofoncier = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Geom\u00e8tres-experts", "DOSSIERS_EMPRISES,RFU_LIMITES,RFU_SOMMETS,DOSSIERS_LOCALISANTS", "/api/geo/wms/referentielsoge", new $c_s_Some("image/png"), $m_s_None$());
  new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Estompage", "ELEVATION.ELEVATIONGRIDCOVERAGE.SHADOW", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl, $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$5__F1(), $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$6__F3());
  new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Masque de source du RGE Alti", "ELEVATIONGRIDCOVERAGE.HIGHRES.QUALITY", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl, $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$5__F1(), $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$6__F3());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AltimetrieE = new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Mod\u00e8le num\u00e9rique de surface", "ELEVATION.ELEVATIONGRIDCOVERAGE.HIGHRES.MNS", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl);
  new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Mod\u00e8le num\u00e9rique de terrain BD Alti", "ELEVATION.ELEVATIONGRIDCOVERAGE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl);
  new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Mod\u00e8le num\u00e9rique de terrain RGE Alti", "ELEVATION.ELEVATIONGRIDCOVERAGE.HIGHRES", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmsAltimetrieUrl, new $c_s_Some("image/tiff"), $m_s_None$());
  new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Mod\u00e8le num\u00e9rique de terrain mondial SRTM3", "ELEVATION.ELEVATIONGRIDCOVERAGE.SRTM3", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl);
  new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Seuils de pentes - Epandage - pour l\u2019agriculture", "ELEVATION.ELEVATIONGRIDCOVERAGE.THRESHOLD", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl, $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$5__F1(), $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$6__F3());
  new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, "Trait de c\u00f4te", "ELEVATION.LEVEL0", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_wmtsAltimetrieUrl, $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$5__F1(), $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$6__F3());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUCityDivision = new $c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme("Zonage PLU", "zone_secteur", new $c_sci_Range$Inclusive(12, 1, 1), false);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUCommunications = new $c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme("Communication", "communication", new $c_sci_Range$Inclusive(1, 18, 1), false);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUPatrimoine = new $c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme("Conservation du patrimoine", "conservation_du_patrimoine", new $c_sci_Range$Inclusive(1, 18, 1), false);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUCanalisation = new $c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme("Canalisation", "canalisation", new $c_sci_Range$Inclusive(1, 18, 1), false);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_administrativeLimits = new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision, "Limites administratives", "LIMITES_ADMINISTRATIVES_EXPRESS.LATEST", "/api/geo/wmts/administratif", new $c_sjsr_AnonFunction1(((x$5$2) => {
    x$5$2.maxZoom = 18.0
  })), $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$().apply$default$6__F3());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Site = new $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision, "/api/geo/wfs/ign", "Parcelle", "CADASTRALPARCELS.PARCELLAIRE_EXPRESS:parcelle", new $c_sjsr_AnonFunction1(((x$6$2) => {
    x$6$2.color = "#000000";
    x$6$2.width = 1.0;
    return x$6$2
  })), $m_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$().apply$default$6__F1(), $m_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$().apply$default$7__F1());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_PEB = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision, "Plan Exposition aux Bruits", "DGAC-PEB_BDD_FXX_WM_WMS", "/api/geo/wms/transports", $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_PEB2 = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision, "Plans de g\u00eane sonore", "DGAC-PGS_BDD_FXX_WM_WMS", "/api/geo/wms/transports", $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_PEB3 = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision, "Plans de servitudes a\u00e9ronautiques", "TRANSPORTS.AIRNOISE", "/api/geo/wms/transports", $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Building = new $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision, "/api/geo/wfs/ign", "Construction", "CADASTRALPARCELS.PARCELLAIRE_EXPRESS:batiment", new $c_sjsr_AnonFunction1(((x$7$2) => {
    x$7$2.color = "#aaaaaa";
    x$7$2.width = 1.0;
    return x$7$2
  })), new $c_sjsr_AnonFunction1(((x$8$2) => {
    var a = [255.0, 255.0, 0.0, 0.4];
    x$8$2.color = a;
    return x$8$2
  })), $m_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$().apply$default$7__F1());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl = "/api/geo/wms/geologie";
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_F_GEOL1M = new $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "Carte g\u00e9ologique 1/1 000 000 France M\u00e9tropole", "SCAN_F_GEOL1M", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_Lreactbuild_analyze_cost_modules_mapview_Resolutions$().fromZoom__D__F1__sci_LazyList(5.0E-4, new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $uD(x$9$2);
    return (x$9 <= 0.02)
  }))));
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_D_GEOL50 = new $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "Cartes g\u00e9ologiques 1/50 000i\u00e8me papier", "SCAN_D_GEOL50", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_Lreactbuild_analyze_cost_modules_mapview_Resolutions$().fromZoom__D__F1__sci_LazyList(3.0E-5, new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $uD(x$10$2);
    return (x$10 <= 5.0E-4)
  }))));
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_F_GEOL250 = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "Cartes g\u00e9ologiques 1/250 000i\u00e8me", "SCAN_F_GEOL250", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_H_RELIEF_GEOL50 = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "Cartes g\u00e9ologiques MapCategory.Geological,1/50 000i\u00e8me harmonis\u00e9e", "SCAN_H_RELIEF_GEOL50", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoLITHO_1M_SIMPLIFIEE = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "Carte lithologique MapCategory.Geological,simplifi\u00e9e 1/1 000 000", "LITHO_1M_SIMPLIFIEE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoBSS = new $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "Banque du sous-sol", "BSS", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_Lreactbuild_analyze_cost_modules_mapview_Resolutions$().fromZoom__D__F1__sci_LazyList(5.0E-6, new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $uD(x$11$2);
    return (x$11 <= 0.02)
  }))));
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoIDPR = new $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "Indice de D\u00e9veloppement et de Persistance des R\u00e9seaux", "IDPR", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_Lreactbuild_analyze_cost_modules_mapview_Resolutions$().fromZoom__D__F1__sci_LazyList(9.0E-5, new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12 = $uD(x$12$2);
    return (x$12 <= 0.1)
  }))));
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoGRAVI_BASE = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "bases gravim\u00e9triques", "GRAVI_BASE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoGRAVI_STATION = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "stations gravim\u00e9triques", "GRAVI_STATION", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoAEROMAG_CAMPAGNE = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "campagnes a\u00e9romagn\u00e9tiques", "AEROMAG_CAMPAGNE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoBGM = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, "G\u00e9ologie Marine", "BGM", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_geoUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl = "/api/geo/wms/risques";
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Inondations = new $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Inondation potentielles", "MASQ_EAIP", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_Lreactbuild_analyze_cost_modules_mapview_Resolutions$().fromRange__D__D__I__sci_LazyList(3.5E-4, 0.0011, 4));
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AleaArgile = new $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Retrait gonflement argile", "ALEARG", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_Lreactbuild_analyze_cost_modules_mapview_Resolutions$().fromFactor__D__F1__F1__sci_LazyList(16906.138608, new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13 = $uD(x$13$2);
    return (x$13 >= 1.0E-5)
  })), new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $uD(v$2);
    return ((v < 1.0) ? (v / 4.0) : (v / 2.0))
  }))));
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Faille = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Faille", "NEOPAL_FAILLE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_DeformationsRecentes = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "D\u00e9formation r\u00e9cente", "NEOPAL_VALIDE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_CaviteLoc = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Cavit\u00e9 localis\u00e9e", "CAVITE_LOCALISEE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_CaviteNonLoc = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Cavit\u00e9 non localis\u00e9e", "CAVITE_COMMUNE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_MouvementTerrainLoc = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Mouvement de terrain localis\u00e9", "MVT_LOCALISE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_MouvementTerrainNonLoc = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Mouvement de terrain non localis\u00e9", "MVT_COMMUNE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Sismique = new $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Activit\u00e9 sismique", "SIS", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_Lreactbuild_analyze_cost_modules_mapview_Resolutions$().fromZoom__D__F1__sci_LazyList(4.0E-4, new $c_sjsr_AnonFunction1(((x$14$2) => {
    var x$14 = $uD(x$14$2);
    return (x$14 <= 0.02)
  }))));
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AncienSiteIndustrielLoc = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Ancien site industriel localis\u00e9", "BASIAS_LOCALISE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_s_None$(), $m_s_None$());
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AncienSiteIndustrielNonLoc = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer($m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard, "Ancien site industriel non localis\u00e9", "BASIAS_COMMUNE", this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_risqueUrl, $m_s_None$(), $m_s_None$());
  $n($m_s_package$().s_package$__f_List);
  var array = [$m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$(), this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_TiledOrthoPhotoMap, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AltiA, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AltimetrieE, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Geofoncier, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_administrativeLimits, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUCityDivision, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUCommunications, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUPatrimoine, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GPUCanalisation, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Building, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Site, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_PEB, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_PEB2, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_PEB3, $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$(), this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Inondations, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AleaArgile, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Faille, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_DeformationsRecentes, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_CaviteLoc, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_CaviteNonLoc, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_MouvementTerrainLoc, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_MouvementTerrainNonLoc, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Sismique, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AncienSiteIndustrielLoc, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_AncienSiteIndustrielNonLoc, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_F_GEOL1M, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_D_GEOL50, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_F_GEOL250, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoSCAN_H_RELIEF_GEOL50, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoLITHO_1M_SIMPLIFIEE, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoBSS, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoIDPR, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoGRAVI_BASE, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoGRAVI_STATION, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoAEROMAG_CAMPAGNE, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_GeoBGM, $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$(), $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$(), $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$(), $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_list = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$__f_component = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$__f_layerSelectionContainer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$__f_LayerCategoryHeader = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$ = this;
  var this$42 = $m_Lcom_iz2use_react_hooks_package$();
  var this$8 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var reducer = new $c_sjsr_AnonFunction2(((existing$2, cat$2) => {
    var existing = $as_sci_List(existing$2);
    var cat = $as_Lreactbuild_analyze_cost_modules_mapview_MapCategory(cat$2);
    var this$3 = $m_Lcom_iz2use_common_package$();
    var $$x1 = new $c_Lcom_iz2use_common_TraversableImplicits$RichCollection(this$3, existing);
    $m_Lreactbuild_model_Implicits$();
    var reuse = $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_reusabilityMapCategory;
    var this$5 = $m_sci_List$();
    return $as_sci_List($$x1.toggleItem__O__F2__sc_Factory__sci_Seq(cat, reuse, new $c_sc_IterableFactory$ToFactory(this$5)))
  }));
  var initialState = new $c_sjsr_AnonFunction0((() => $m_s_package$().s_package$__f_Nil));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$41 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducer__F2__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$8, reducer, initialState, step)));
  var f$1 = new $c_sjsr_AnonFunction2(((p$2, expandedCategory$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props(p$2);
    var expandedCategory = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(expandedCategory$2);
    if ((p === null)) {
      throw new $c_s_MatchError(p)
    };
    $n(p);
    var visibleLayers = $n(p).Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_visibleLayers;
    var $$x13 = $n($m_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$().Lreactbuild_analyze_cost_modules_mapview_LayerSelection$__f_layerSelectionContainer);
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$11 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
    var $$x4 = this$11.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$12 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
    var $$x3 = this$12.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_list;
    var array$3 = [$$x4, $$x3, $n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((cat$2$1) => {
      var cat$1 = $as_Lreactbuild_analyze_cost_modules_mapview_MapCategory(cat$2$1);
      var this$33 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var $$x11 = $m_Lcom_iz2use_react_components_Link$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r = $n(expandedCategory).dispatch__O__Ljapgolly_scalajs_react_Reusable(cat$1);
      var $$x10 = $n($n($$x11).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
      var $$x9 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$().Lreactbuild_analyze_cost_modules_mapview_LayerSelection$__f_LayerCategoryHeader;
      var $$x8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + cat$1), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(cat$1).Lreactbuild_analyze_cost_modules_mapview_MapCategory__f_title;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [$$x8, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      var array$1 = [$n($$x9).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
      var $$x7 = $n($$x10).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var this$24 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var this$23 = $n(expandedCategory);
      var cond = $n($as_sci_List(this$23.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).contains__O__Z(cat$1);
      if (cond) {
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var this$25 = $n($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_list);
        var f = ((x$2$2) => {
          var x$2 = $as_Lreactbuild_analyze_cost_modules_mapview_Layer(x$2$2);
          var x = $n(x$2).category__Lreactbuild_analyze_cost_modules_mapview_MapCategory();
          return ((x === null) ? (cat$1 === null) : $n(x).equals__O__Z(cat$1))
        });
        var l = this$25;
        block: {
          var result;
          while (true) {
            if ($n(l).isEmpty__Z()) {
              var result = $m_sci_Nil$();
              break
            } else {
              var h = $n(l).head__O();
              var t = $as_sci_List($n(l).tail__O());
              if (($uZ(f(h)) === false)) {
                l = t;
                continue
              };
              var start = l;
              var remaining = t;
              while (true) {
                if ($n(remaining).isEmpty__Z()) {
                  var result = start;
                  break block
                } else {
                  var x$1 = $n(remaining).head__O();
                  if (($uZ(f(x$1)) !== false)) {
                    remaining = $as_sci_List($n(remaining).tail__O());
                    continue
                  };
                  var firstMiss = remaining;
                  var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                  var toProcess = $as_sci_List($n(start).tail__O());
                  var currentLast = newHead;
                  while ((toProcess !== firstMiss)) {
                    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem;
                    currentLast = newElem;
                    toProcess = $as_sci_List($n(toProcess).tail__O())
                  };
                  var next = $as_sci_List($n(firstMiss).tail__O());
                  var nextToCopy = next;
                  while ((!$n(next).isEmpty__Z())) {
                    var head = $n(next).head__O();
                    if (($uZ(f(head)) !== false)) {
                      next = $as_sci_List($n(next).tail__O())
                    } else {
                      while ((nextToCopy !== next)) {
                        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                        currentLast = newElem$2;
                        nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                      };
                      nextToCopy = $as_sci_List($n(next).tail__O());
                      next = $as_sci_List($n(next).tail__O())
                    }
                  };
                  if ((!$n(nextToCopy).isEmpty__Z())) {
                    $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                  };
                  var result = newHead;
                  break block
                }
              }
            }
          }
        };
        var $$x5 = $n($$x6).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(result, new $c_sjsr_AnonFunction1(((layer$2) => {
          var layer = $as_Lreactbuild_analyze_cost_modules_mapview_Layer(layer$2);
          var u = $m_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$().apply__Lreactbuild_analyze_cost_modules_mapview_Layer__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(layer, visibleLayers);
          var this$28 = $n(u);
          var n = this$28.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
        })))
      } else {
        var $$x5 = this$24.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
      };
      var array$2 = [$$x7, $$x5];
      var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return this$33.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
    })))];
    var array$4 = [$n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    return $n($$x13).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
  }));
  var this$40 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$40);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$41, f$1, step$1, s);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$42, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.LayerSelection.component"));
  var this$45 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$1 = "div";
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$__f_layerSelectionContainer = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$45, v$1)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x15 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$47 = $m_Lscalacss_internal_Attrs$display$();
    var $$x14 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$47.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    var this$49 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var array$5 = [$$x14, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$49.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")))];
    return $as_sci_Seq($n($$x15).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
  })), new $c_Lsourcecode_Name("layerSelectionContainer"));
  var this$55 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$2 = "div";
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$__f_LayerCategoryHeader = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$55, v$2)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x21 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var $$x20 = $m_Lscalacss_internal_Attrs$borderBottom$();
    $n(dsl$3);
    $n(dsl$3);
    var this$ = 1;
    var u$1 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$3 = new $c_Lscalacss_internal_Length(this$, u$1);
    $n(dsl$3);
    $n(dsl$3);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl$3);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
    var r$1 = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var $$x19 = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$3);
    $n(dsl$3);
    $n(dsl$3);
    var f$5 = $m_Lscalacss_internal_Literal$Typed$solid$();
    $n(dsl$3);
    $n(dsl$3);
    var this$67 = $m_Lscalacss_internal_ValueT$Rule$();
    var ab$1 = this$67.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$1) => {
      var x$2$1 = $as_Lscalacss_internal_Literal(x$2$2$1);
      return $n(x$2$1).Lscalacss_internal_Literal__f_value
    })));
    $n(dsl$3);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$3 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$3)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
    var r$2 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var $$x18 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x20.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x19, $n(r$2).apply__O__Lscalacss_internal_ValueT(f$5))));
    $n(dsl$3);
    var $$x17 = $m_Lscalacss_internal_Attrs$padding$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$1 = 0.5;
    var u$2 = $m_Lscalacss_internal_LengthUnit$em$();
    var f$7 = new $c_Lscalacss_internal_Length(this$$1, u$2);
    $n(dsl$3);
    $n(dsl$3);
    var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      var x$3$1 = $as_Lscalacss_internal_Length(x$3$2$1);
      return $n(x$3$1).value__T()
    })));
    $n(dsl$3);
    var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
      var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$2);
      return $n(x$1$4)
    }));
    var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
    var r$3 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
    var $$x16 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$7);
    $n(dsl$3);
    $n(dsl$3);
    var this$$2 = 0.5;
    var u$3 = $m_Lscalacss_internal_LengthUnit$em$();
    var f$9 = new $c_Lscalacss_internal_Length(this$$2, u$3);
    $n(dsl$3);
    $n(dsl$3);
    var ab$3 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$2) => {
      var x$3$3 = $as_Lscalacss_internal_Length(x$3$2$2);
      return $n(x$3$3).value__T()
    })));
    $n(dsl$3);
    var f$8 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
      var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$3);
      return $n(x$1$5)
    }));
    var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$8);
    var r$4 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
    var array$6 = [$$x18, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x17.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x16, $n(r$4).apply__O__Lscalacss_internal_ValueT(f$9))))];
    return $as_sci_Seq($n($$x21).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6)))
  })), new $c_Lsourcecode_Name("LayerCategoryHeader"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$.prototype.withKey__T__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(key, proxy, visibleLayers) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props(proxy, visibleLayers);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerSelection$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerSelection$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerSelection$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$__f_LayerLine = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$__f_LayerLine = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x3 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    var this$8 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$8.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")));
    $n(dsl);
    var this$10 = $m_Lscalacss_internal_Attrs$alignItems$();
    var array = [$$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$10.Lscalacss_internal_Attrs$alignItems$__f_attr, "center")))];
    return $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })), new $c_Lsourcecode_Name("LayerLine"));
  var this$53 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props(x0$1$2);
    if ((x0$1 !== null)) {
      var layer = $n(x0$1).Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_layer;
      var visibleLayers = $n(x0$1).Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_visibleLayers;
      var $$x15 = $n($m_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$().Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$__f_LayerLine);
      var $$x14 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + $n(layer).Lreactbuild_analyze_cost_modules_mapview_Layer__f_id), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
      var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "borderRight")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1px solid", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $m_Lcom_iz2use_react_components_Icon$().conditional__Z__Lcom_iz2use_react_components_IconSource__Lcom_iz2use_react_components_IconSource__T__T__T__Ljapgolly_scalajs_react_vdom_TagOf($n($as_sci_List($n(visibleLayers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).contains__O__Z(layer), $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_checkboxChecked, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_checkbox, "", "", "24px")];
      var $$x12 = $n($n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
      var array$2 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$().toggleLayer__Lreactbuild_analyze_cost_modules_mapview_Layer__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_callback_Trampoline(layer, visibleLayers)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
      var $$x11 = $n($$x12).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x9 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).overflowWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("anywhere", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(layer).title__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$3 = [$$x9, $$x8, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      var $$x7 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
      var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x5 = $m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(($m_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$(), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).alert__T__Ljapgolly_scalajs_react_callback_Trampoline("L\u00e9gendes non fonctionnelles pour le moment")));
      var $$x4 = $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_viewList, "", "24px");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$39 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
      var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$4 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$39.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "grey")];
      var array$5 = [$n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
      var array$6 = [$n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
      var array$7 = [$$x14, $$x11, $$x7, $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
      return $n($$x15).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f, s);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$53, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.LayerSelectionLine.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_Layer__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(layer, visibleLayers) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props(layer, visibleLayers);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$.prototype.toggleLayer__Lreactbuild_analyze_cost_modules_mapview_Layer__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_callback_Trampoline = (function(layer, visibleLayers) {
  var this$1 = $n(visibleLayers);
  var callback = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var G = this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var arg1 = this$1.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var s = $as_sci_List(arg1);
  var this$5 = $m_Lcom_iz2use_common_package$();
  var $$x1 = new $c_Lcom_iz2use_common_TraversableImplicits$RichCollection(this$5, s);
  $m_Lreactbuild_model_Implicits$();
  var reuse = $m_Lreactbuild_analyze_cost_modules_mapview_Layer$().Lreactbuild_analyze_cost_modules_mapview_Layer$__f_reusabilityLayer;
  var this$7 = $m_sci_List$();
  var arg1$1 = $as_sci_List($$x1.toggleItem__O__F2__sc_Factory__sci_Seq(layer, reuse, new $c_sc_IterableFactory$ToFactory(this$7)));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$1.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerSelectionLine$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$() {
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableMap = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseLayer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseControl = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableInteraction = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableCoordinate = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableMap = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseLayer = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseControl = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableInteraction = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$2.byRef__F2(), this$2.by_$eq$eq__F2());
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$3.byRef__F2(), this$3.by_$eq$eq__F2());
  var reuseCoord = $m_Ljapgolly_scalajs_react_Reusability$().double__D__F2(1.0E-7);
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    if (($uI(x$2.length) === $uI(y$2.length))) {
      $n($m_s_package$().s_package$__f_Range);
      var end = $uI(x$2.length);
      var isEmpty = (end <= 0);
      var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
      var res = true;
      var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
      while ((res && it.sci_RangeIterator__f__hasNext)) {
        var arg1 = it.next__I();
        $m_Ljapgolly_scalajs_react_package$();
        var a = x$2[arg1];
        var a$1 = y$2[arg1];
        res = $uZ($n(reuseCoord).apply__O__O__O(a, a$1))
      };
      return res
    } else {
      return false
    }
  }));
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableCoordinate = f
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$.prototype.coordinatesToModel__sjs_js_Array__Lreactbuild_common_model_Coordinates = (function(v) {
  return new $c_Lreactbuild_common_model_Coordinates($uD(v[1]), $uD(v[0]))
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$.prototype.modelToCoordinates__Lreactbuild_common_model_Coordinates__sjs_js_Array = (function(v) {
  return [$n(v).Lreactbuild_common_model_Coordinates__f_lat, $n(v).Lreactbuild_common_model_Coordinates__f_lon]
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapImports$Implicits$", {
  Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$() {
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$ = this;
  var this$290 = $m_Lcom_iz2use_react_hooks_package$();
  var this$286 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var initialState = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props(p$2);
    var $$x28 = $n($n(p).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_geolocation).Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_layer;
    $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$();
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var $$x19 = $moduleDefault($i_ol$002fstyle$002fStroke);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions);
    var fields$1 = $m_sci_Nil$();
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    _\uff3fobj$1.width = 2.0;
    _\uff3fobj$1.color = "#0000ff";
    var value = new $$x19(_\uff3fobj$1);
    _\uff3fobj.stroke = value;
    var $$x20 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$2 = $m_sci_Nil$();
    var _\uff3fobj$2 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
    var a = [0.0, 0.0, 255.0, 0.0];
    _\uff3fobj$2.color = a;
    var value$1 = new $$x20(_\uff3fobj$2);
    _\uff3fobj.fill = value$1;
    var this$34 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$();
    var background = $n(this$34.convertColor__F1()).apply__O__O($as_T(this$34.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.backgroundColor));
    var foreground = $n(this$34.convertColor__F1()).apply__O__O($as_T(this$34.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.color));
    background[3] = 0.6;
    foreground[3] = 1.0;
    var $$x21 = $moduleDefault($i_ol$002fstyle$002fText);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TextOptions);
    var fields$3 = $m_sci_Nil$();
    var _\uff3fobj$3 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3);
    var s = new $$x21(_\uff3fobj$3);
    s.setTextBaseline("bottom");
    s.setPadding([2.0, 2.0, 2.0, 2.0]);
    var $$x23 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$4 = $m_sci_Nil$();
    var _\uff3fobj$4 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$4);
    _\uff3fobj$4.color = foreground;
    var $$x22 = new $$x23(_\uff3fobj$4);
    s.setFill($$x22);
    var $$x25 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$5 = $m_sci_Nil$();
    var _\uff3fobj$5 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$5);
    _\uff3fobj$5.color = background;
    var $$x24 = new $$x25(_\uff3fobj$5);
    s.setBackgroundFill($$x24);
    s.setFont((this$34.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_fontSize + "px Calibri,sans-serif"));
    s.setOffsetY((-$m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_offset));
    _\uff3fobj.text = s;
    var $$x27 = $moduleDefault($i_ol$002fstyle$002fCircle);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CircleStyleOptions);
    var array = [$ct_T2__O__O__(new $c_T2(), "radius", 2.0)];
    var fields$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var _\uff3fobj$6 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$6);
    var $$x26 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$7 = $m_sci_Nil$();
    var _\uff3fobj$7 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$7);
    var a$1 = [0.0, 0.0, 0.0, 0.25];
    _\uff3fobj$7.color = a$1;
    var value$2 = new $$x26(_\uff3fobj$7);
    _\uff3fobj$6.fill = value$2;
    var value$3 = new $$x27(_\uff3fobj$6);
    _\uff3fobj.image = value$3;
    var style = new $i_ol$002fstyle.Style(_\uff3fobj);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions);
    var fields$8 = $m_sci_Nil$();
    var _\uff3fobj$8 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$8);
    var value$6 = new $c_sjsr_AnonFunction2(((feature$2, res$2) => {
      var res = $uD(res$2);
      if ((res >= 1.0)) {
        var value$4 = feature$2.getGeometry();
        var f = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_pointOnTooLargeScale;
        var value$5 = ((value$4 === (void 0)) ? (void 0) : $n(f).apply__O__O(value$4));
        var result = ((value$5 === (void 0)) ? $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_emptyStyle : value$5);
        return result
      } else {
        return style
      }
    }));
    var value$7 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$6);
    _\uff3fobj$8.style = value$7;
    var r = new ($moduleDefault($i_ol$002flayer$002fVector))(_\uff3fobj$8);
    r.setSource(new ($moduleDefault($i_ol$002fsource$002fVector))());
    $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$();
    $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$();
    var showMeasure = true;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
    var fields$9 = $m_sci_Nil$();
    var _\uff3fobj$9 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$9);
    var $$x10 = $moduleDefault($i_ol$002fstyle$002fStroke);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions);
    var fields$10 = $m_sci_Nil$();
    var _\uff3fobj$10 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$10);
    _\uff3fobj$10.width = 2.0;
    _\uff3fobj$10.color = "#ffaa00";
    var value$8 = new $$x10(_\uff3fobj$10);
    _\uff3fobj$9.stroke = value$8;
    var $$x11 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$11 = $m_sci_Nil$();
    var _\uff3fobj$11 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$11);
    var a$2 = [255.0, 170.0, 0.0, 0.5];
    _\uff3fobj$11.color = a$2;
    var value$9 = new $$x11(_\uff3fobj$11);
    _\uff3fobj$9.fill = value$9;
    var this$126 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$();
    var background$1 = $n(this$126.convertColor__F1()).apply__O__O($as_T(this$126.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.backgroundColor));
    var foreground$1 = $n(this$126.convertColor__F1()).apply__O__O($as_T(this$126.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.color));
    background$1[3] = 0.6;
    foreground$1[3] = 1.0;
    var $$x12 = $moduleDefault($i_ol$002fstyle$002fText);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TextOptions);
    var fields$12 = $m_sci_Nil$();
    var _\uff3fobj$12 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$12);
    var s$1 = new $$x12(_\uff3fobj$12);
    s$1.setTextBaseline("bottom");
    s$1.setPadding([2.0, 2.0, 2.0, 2.0]);
    var $$x14 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$13 = $m_sci_Nil$();
    var _\uff3fobj$13 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$13);
    _\uff3fobj$13.color = foreground$1;
    var $$x13 = new $$x14(_\uff3fobj$13);
    s$1.setFill($$x13);
    var $$x16 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$14 = $m_sci_Nil$();
    var _\uff3fobj$14 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$14);
    _\uff3fobj$14.color = background$1;
    var $$x15 = new $$x16(_\uff3fobj$14);
    s$1.setBackgroundFill($$x15);
    s$1.setFont((this$126.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_fontSize + "px Calibri,sans-serif"));
    s$1.setOffsetY((-$m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_offset));
    _\uff3fobj$9.text = s$1;
    var $$x18 = $moduleDefault($i_ol$002fstyle$002fCircle);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CircleStyleOptions);
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "radius", 2.0)];
    var fields$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var _\uff3fobj$15 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$15);
    var $$x17 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$16 = $m_sci_Nil$();
    var _\uff3fobj$16 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$16);
    var a$3 = [0.0, 0.0, 0.0, 0.25];
    _\uff3fobj$16.color = a$3;
    var value$10 = new $$x17(_\uff3fobj$16);
    _\uff3fobj$15.fill = value$10;
    var value$11 = new $$x18(_\uff3fobj$15);
    _\uff3fobj$9.image = value$11;
    var style$1 = new $i_ol$002fstyle.Style(_\uff3fobj$9);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions);
    var fields$17 = $m_sci_Nil$();
    var _\uff3fobj$17 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$17);
    var value$14 = new $c_sjsr_AnonFunction2(((feature$2$1, res$2$1) => {
      var res$1 = $uD(res$2$1);
      if ((res$1 >= 1.0)) {
        var value$12 = feature$2$1.getGeometry();
        var f$1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_pointOnTooLargeScale;
        var value$13 = ((value$12 === (void 0)) ? (void 0) : $n(f$1).apply__O__O(value$12));
        var result$1 = ((value$13 === (void 0)) ? $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_emptyStyle : value$13);
        return result$1
      } else if ((showMeasure && (res$1 <= 0.2))) {
        var result$2 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature$2$1, res$1, ($m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$(), false));
        return result$2
      } else {
        return style$1
      }
    }));
    var value$15 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$14);
    _\uff3fobj$17.style = value$15;
    var r$1 = new ($moduleDefault($i_ol$002flayer$002fVector))(_\uff3fobj$17);
    r$1.setSource(new ($moduleDefault($i_ol$002fsource$002fVector))());
    $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$();
    $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$();
    var showMeasure$1 = true;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
    var fields$18 = $m_sci_Nil$();
    var _\uff3fobj$18 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$18);
    var $$x1 = $moduleDefault($i_ol$002fstyle$002fStroke);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions);
    var fields$19 = $m_sci_Nil$();
    var _\uff3fobj$19 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$19);
    _\uff3fobj$19.width = 2.0;
    _\uff3fobj$19.color = "#00aa00";
    var value$16 = new $$x1(_\uff3fobj$19);
    _\uff3fobj$18.stroke = value$16;
    var $$x2 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$20 = $m_sci_Nil$();
    var _\uff3fobj$20 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$20);
    var a$4 = [0.0, 170.0, 0.0, 0.0];
    _\uff3fobj$20.color = a$4;
    var value$17 = new $$x2(_\uff3fobj$20);
    _\uff3fobj$18.fill = value$17;
    var this$221 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$();
    var background$2 = $n(this$221.convertColor__F1()).apply__O__O($as_T(this$221.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.backgroundColor));
    var foreground$2 = $n(this$221.convertColor__F1()).apply__O__O($as_T(this$221.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.color));
    background$2[3] = 0.6;
    foreground$2[3] = 1.0;
    var $$x3 = $moduleDefault($i_ol$002fstyle$002fText);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TextOptions);
    var fields$21 = $m_sci_Nil$();
    var _\uff3fobj$21 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$21);
    var s$2 = new $$x3(_\uff3fobj$21);
    s$2.setTextBaseline("bottom");
    s$2.setPadding([2.0, 2.0, 2.0, 2.0]);
    var $$x5 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$22 = $m_sci_Nil$();
    var _\uff3fobj$22 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$22);
    _\uff3fobj$22.color = foreground$2;
    var $$x4 = new $$x5(_\uff3fobj$22);
    s$2.setFill($$x4);
    var $$x7 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$23 = $m_sci_Nil$();
    var _\uff3fobj$23 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$23);
    _\uff3fobj$23.color = background$2;
    var $$x6 = new $$x7(_\uff3fobj$23);
    s$2.setBackgroundFill($$x6);
    s$2.setFont((this$221.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_fontSize + "px Calibri,sans-serif"));
    s$2.setOffsetY((-$m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_offset));
    _\uff3fobj$18.text = s$2;
    var $$x9 = $moduleDefault($i_ol$002fstyle$002fCircle);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CircleStyleOptions);
    var array$2 = [$ct_T2__O__O__(new $c_T2(), "radius", 2.0)];
    var fields$24 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    var _\uff3fobj$24 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$24);
    var $$x8 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$25 = $m_sci_Nil$();
    var _\uff3fobj$25 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$25);
    var a$5 = [0.0, 0.0, 0.0, 0.25];
    _\uff3fobj$25.color = a$5;
    var value$18 = new $$x8(_\uff3fobj$25);
    _\uff3fobj$24.fill = value$18;
    var value$19 = new $$x9(_\uff3fobj$24);
    _\uff3fobj$18.image = value$19;
    var style$2 = new $i_ol$002fstyle.Style(_\uff3fobj$18);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions);
    var fields$26 = $m_sci_Nil$();
    var _\uff3fobj$26 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$26);
    var value$22 = new $c_sjsr_AnonFunction2(((feature$2$2, res$2$2) => {
      var res$3 = $uD(res$2$2);
      if ((res$3 >= 1.0)) {
        var value$20 = feature$2$2.getGeometry();
        var f$2 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_pointOnTooLargeScale;
        var value$21 = ((value$20 === (void 0)) ? (void 0) : $n(f$2).apply__O__O(value$20));
        var result$3 = ((value$21 === (void 0)) ? $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_emptyStyle : value$21);
        return result$3
      } else if ((showMeasure$1 && (res$3 <= 0.2))) {
        var result$2$1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature$2$2, res$3, ($m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$(), false));
        return result$2$1
      } else {
        return style$2
      }
    }));
    var value$23 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$22);
    _\uff3fobj$26.style = value$23;
    var r$2 = new ($moduleDefault($i_ol$002flayer$002fVector))(_\uff3fobj$26);
    r$2.setSource(new ($moduleDefault($i_ol$002fsource$002fVector))());
    return new $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers($$x28, r, r$1, r$2, $n($n(p).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_geolocation).Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_modGeolocation)
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$289 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useStateBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$286, initialState, step)));
  var f$3 = new $c_sjsr_AnonFunction2(((p$3$2, state$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props(p$3$2);
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    var $$x29 = $n(p$3).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_f;
    var this$287 = $n(state);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($$x29).apply__O__O(this$287.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]))
  }));
  var this$288 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$288);
  var s$3 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$52 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$289, f$3, step$1, s$3);
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$290, ev$52).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.MapInteractionLayerSource.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(geolocation, f) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props(f, geolocation);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapInteractionLayerSource$", {
  Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$() {
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_list = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_entryStyle = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_activeStyle = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_mapInteractionSelectorContainer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$ = this;
  $n($m_s_package$().s_package$__f_List);
  var array = [$m_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$(), $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$(), $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$(), $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$(), $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$(), $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$(), $m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$(), $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_list = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$9 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var this$5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var array$1 = [this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_entryStyle = this$9.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms);
  var this$15 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var array$2 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "boxShadow")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0px 2px 5px 1px hsl(225,80%,50%)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var ms$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_activeStyle = this$15.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1);
  var this$18 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_mapInteractionSelectorContainer = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$18, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x3 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$21 = $m_Lscalacss_internal_Attrs$display$();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$21.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1fr 1fr 1fr")));
    $n(dsl);
    var this$34 = $m_Lscalacss_internal_Attrs$gap$();
    $n(dsl);
    $n(dsl);
    var this$ = 1;
    var u = $m_Lscalacss_internal_LengthUnit$em$();
    var f$1 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var both = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$1 = $n(both).Lscalacss_internal_ValueT__f_value;
    var array$3 = [$$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$34.Lscalacss_internal_Attrs$gap$__f_attr, v$1)))];
    return $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)))
  })), new $c_Lsourcecode_Name("mapInteractionSelectorContainer"));
  var this$66 = $m_Lcom_iz2use_react_hooks_package$();
  var this$40 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var initialState = new $c_sjsr_AnonFunction0((() => false));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$65 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$40, initialState, step)));
  var f$2 = new $c_sjsr_AnonFunction2(((state$2, expanded$2) => {
    var state = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(state$2);
    var expanded = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(expanded$2);
    var active = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction($n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var this$41 = $n(expanded);
    if ($uZ(this$41.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])) {
      var $$x9 = $n($m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$().Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_mapInteractionSelectorContainer);
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as = $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$().Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_list;
      var array$5 = [$n($$x4).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((interaction$2) => {
        var interaction = $as_s_Product(interaction$2);
        var $$x8 = $m_Lcom_iz2use_react_components_Button$();
        var this$46 = $n(state);
        var callback = new $c_sjsr_AnonFunction0((() => {
          $m_Ljapgolly_scalajs_react_Reusable$();
          var this$43 = $n(expanded);
          var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$43);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$1$2$1) => {
            $uZ(x$1$2$1);
            return false
          }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        }));
        var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
        var $$x7 = $n($n($$x8).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$46, interaction, callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
        var $$x6 = $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$().Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_entryStyle;
        var this$48 = $n($m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$().Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_activeStyle);
        if ((active === null)) {
          var condition = (interaction === null)
        } else {
          var this$47 = $n(active);
          var condition = (this$47 === interaction)
        };
        var $$x5 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$48, condition);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v$2 = $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction(interaction)).title__T();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$4 = [$$x6, $$x5, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
        return $n($$x7).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
      })))];
      return $n($$x9).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
    } else {
      var $$x13 = $m_Lcom_iz2use_react_components_Button$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$57 = $n(expanded);
      var r$2 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$57);
      var $$x12 = $n($n($$x13).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$2).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
        $uZ(x$2$2);
        return true
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
      var $$x11 = $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$().Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_entryStyle;
      var $$x10 = $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$().Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_activeStyle;
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$3 = $n(active).title__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$6 = [$$x11, $$x10, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
      return $n($$x12).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
    }
  }));
  var this$64 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$64);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$65, f$2, step$1, s);
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$66, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.MapInteractionSelector.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(state) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(state, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapInteractionSelector$", {
  Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$() {
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$ = this;
  var this$14 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var this$13 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$())), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep())));
  var f = new $c_sjsr_AnonFunction2(((props$2, interaction$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$2);
    var interaction = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(interaction$2);
    var active = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction($n(interaction).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var this$11 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var u = $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractionSelector$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(interaction);
    var this$6 = $n(u);
    var n = this$6.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n), $n(active).interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomNode(props)];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$11, null, ns)
  }));
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$12);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$13, f, step, s);
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$14, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.MapInteractions.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__Lreactbuild_analyze_cost_modules_MapLogic$Init__Ltypings_ol_mapMod$default__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(sources, init, map, proxy) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(sources, init, map, proxy);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapInteractions$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapInteractions$", {
  Lreactbuild_analyze_cost_modules_mapview_MapInteractions$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$() {
  this.Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$__f_whitespaceImplicit = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$__f_whitespaceImplicit = new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Lfastparse_ParsingRun(ctx$2);
    return $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().whitespace__Lfastparse_ParsingRun__Lfastparse_ParsingRun(ctx)
  }))
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.whitespace__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$1) {
  var startIndex = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$1).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("whitespace").Lsourcecode_Name__f_value, startIndex)
  };
  var index$macro$2 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var input$macro$3 = $n(evidence$1).Lfastparse_ParsingRun__f_input;
  var start$macro$4 = index$macro$2;
  var goal$macro$5 = ((1 + start$macro$4) | 0);
  while (true) {
    if ($n(input$macro$3).isReachable__I__Z(index$macro$2)) {
      var this$1 = $n(input$macro$3);
      var index = index$macro$2;
      var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
      var x1$3 = $charAt(this$2, index);
      switch (x1$3) {
        case 32: {
          var $$x1 = true;
          break
        }
        case 9: {
          var $$x1 = true;
          break
        }
        default: {
          var $$x1 = false
        }
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index$macro$2 = ((1 + index$macro$2) | 0)
    } else {
      break
    }
  };
  var res = ((index$macro$2 >= goal$macro$5) ? $n(evidence$1).freshSuccessUnit__I__Lfastparse_ParsingRun(index$macro$2) : $n(evidence$1).freshFailure__Lfastparse_ParsingRun());
  if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$1).aggregateTerminal__I__F0__V(start$macro$4, new $c_sjsr_AnonFunction0((() => "[ \\t]")))
  };
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("whitespace").Lsourcecode_Name__f_value, $n(res).Lfastparse_ParsingRun__f_index, $n(res).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(res).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(res);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("whitespace").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(res).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(res).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(res).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(res);
      var self = new $c_Lsourcecode_Name("whitespace").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$10 = $n($n(res).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$10)
    }
  };
  return res
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.listSeparator__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$2) {
  var startIndex = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$2).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("listSeparator").Lsourcecode_Name__f_value, startIndex)
  };
  var input = $n(evidence$2).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$1 = $n(input);
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$2, index) === 44)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var res = $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    var res = $n(evidence$2).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$2).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\",\"")))
  };
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("listSeparator").Lsourcecode_Name__f_value, $n(res).Lfastparse_ParsingRun__f_index, $n(res).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(res).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(res);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("listSeparator").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(res).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(res).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(res).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(res);
      var self = new $c_Lsourcecode_Name("listSeparator").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$10 = $n($n(res).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$10)
    }
  };
  return res
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$3) {
  var startIndex = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$3).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value, startIndex)
  };
  var index = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  if ((!$n($n(evidence$3).Lfastparse_ParsingRun__f_input).isReachable__I__Z(index))) {
    var res = $n(evidence$3).freshFailure__Lfastparse_ParsingRun()
  } else {
    var this$1 = $n($n(evidence$3).Lfastparse_ParsingRun__f_input);
    var index$1 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    var x1$3 = $charAt(this$2, index$1);
    var x1$4 = ((x1$3 >= 48) && (x1$3 <= 57));
    if ((x1$4 === true)) {
      var res = $n(evidence$3).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
    } else {
      if ((x1$4 !== false)) {
        throw new $c_s_MatchError(x1$4)
      };
      var res = $n(evidence$3).freshFailure__Lfastparse_ParsingRun()
    }
  };
  if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$3).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "[0-9]")))
  };
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value, $n(res).Lfastparse_ParsingRun__f_index, $n(res).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(res).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(res);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(res).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(res).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(res).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(res);
      var self = new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$10 = $n($n(res).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$10)
    }
  };
  return res
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.letter__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$4) {
  var startIndex = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$4).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("letter").Lsourcecode_Name__f_value, startIndex)
  };
  var x1$3 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $uC(x$4$2);
    var this$4 = $m_jl_Character$();
    return this$4.isLetter__I__Z(x$4)
  }));
  var startIndex$2 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  if ($n($n(evidence$4).Lfastparse_ParsingRun__f_input).isReachable__I__Z($n(evidence$4).Lfastparse_ParsingRun__f_index)) {
    var this$5 = $n($n(evidence$4).Lfastparse_ParsingRun__f_input);
    var index = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    var this$6 = $n(this$5.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = $uZ(x1$3.apply__O__O($bC($charAt(this$6, index))))
  } else {
    var $$x1 = false
  };
  if ((!$$x1)) {
    var res = $n(evidence$4).freshFailure__Lfastparse_ParsingRun()
  } else {
    var res = $n(evidence$4).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + $n(evidence$4).Lfastparse_ParsingRun__f_index) | 0))
  };
  if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$4).aggregateTerminal__I__F0__V(startIndex$2, new $c_sjsr_AnonFunction0((() => (("char-pred(" + x1$3) + ")"))))
  };
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("letter").Lsourcecode_Name__f_value, $n(res).Lfastparse_ParsingRun__f_index, $n(res).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(res).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(res);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("letter").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(res).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(res).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(res).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(res);
      var self = new $c_Lsourcecode_Name("letter").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$13 = $n($n(res).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$13)
    }
  };
  return res
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.sheetNumber__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$6) {
  var startIndex = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$6).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("sheetNumber").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var startPos = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var repeater = $m_Lfastparse_Implicits$Repeater$UnitRepeater$();
  var this$3 = $m_Lfastparse_internal_RepImpls$();
  var startIndex$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  while (true) {
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
    var verboseFailures = $n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures;
    $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
    var parsedMsg = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
    if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$6 : $p_Lfastparse_internal_RepImpls$__end$1__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$6, repeater, (void 0)));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$5 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$5.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg)), $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$6);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$6 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
        }
      };
      break
    } else {
      var beforeSepIndex = $n(evidence$6).Lfastparse_ParsingRun__f_index;
      var t = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
      $as_jl_Void(t);
      var nextCount = ((1 + count) | 0);
      if ((nextCount !== 4)) {
        $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
        var sepCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
        startIndex$1 = beforeSepIndex;
        count = nextCount;
        precut = false;
        outerCut = endCut;
        sepMsg = null;
        lastAgg = parsedAgg;
        continue
      };
      var res$2 = $p_Lfastparse_internal_RepImpls$__end$1__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, beforeSepIndex, beforeSepIndex, nextCount, (!(!(outerCut | postCut))), 1, evidence$6, repeater, (void 0));
      if (verboseFailures) {
        $n(evidence$6).setMsg__I__F0__V(startIndex$1, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
          var this$7 = $n(parsedMsg);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".repX(1)")
        }))(parsedMsg)))
      };
      break
    }
  };
  $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0$1 = ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) ? evidence$6 : $n(evidence$6).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$6).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$6).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$4 = parse0$1
  } else {
    var $$x4 = $n(parse0$1);
    var arg1 = $as_T($n(parse0$1).Lfastparse_ParsingRun__f_successValue);
    $m_sc_StringOps$();
    var this$12 = $m_jl_Integer$();
    $$x4.Lfastparse_ParsingRun__f_successValue = this$12.parseInt__T__I__I(arg1, 10);
    var x1$4 = parse0$1
  };
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("sheetNumber").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("sheetNumber").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("sheetNumber").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$19 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$19)
    }
  };
  return x1$4
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.cityName__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$7) {
  var startIndex = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$7).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("cityName").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var startPos = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var repeater = $m_Lfastparse_Implicits$Repeater$UnitRepeater$();
  var this$3 = $m_Lfastparse_internal_RepImpls$();
  var startIndex$1 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  while (true) {
    $n(evidence$7).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
    var elem = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
    var elem$1 = false;
    elem$1 = elem;
    var startIndex$macro$4 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
    var count$macro$5 = 0;
    var lastAgg$macro$10 = null;
    while (true) {
      $n(evidence$7).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 2));
      $m_Lfastparse_package$();
      $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().letter__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
      var parsedMsg$macro$9 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
      var parsedAgg$macro$11 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
      elem$1 = (!(!(elem$1 | $n(evidence$7).Lfastparse_ParsingRun__f_cut)));
      if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
        var res = ($n(evidence$7).Lfastparse_ParsingRun__f_cut ? evidence$7 : ((count$macro$5 < 2) ? $n(evidence$7).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$7).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$4, elem$1)));
        if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
          var $$x4 = $n(evidence$7);
          var $$x3 = startIndex$macro$4;
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
            var this$6 = $n(parsedMsg$macro$9);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep(2)")
          }))(parsedMsg$macro$9));
          if ((lastAgg$macro$10 === null)) {
            var $$x1 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate
          } else {
            var rassoc$1 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var $$x1 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
          };
          $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x3, $$x2, $$x1)
        };
        break
      } else {
        var beforeSepIndex$macro$6 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
        $n(evidence$7);
        $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$5 = ((1 + count$macro$5) | 0);
        startIndex$macro$4 = beforeSepIndex$macro$6;
        count$macro$5 = temp$count$macro$5;
        lastAgg$macro$10 = parsedAgg$macro$11
      }
    };
    var parsedMsg = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
    var verboseFailures = $n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures;
    if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
      var res$1 = (postCut ? evidence$7 : $p_Lfastparse_internal_RepImpls$__end$2__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$7, repeater, (void 0)));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$7).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$8 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg)), $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x7 = $n(evidence$7);
          var $$x6 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$9 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$9.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x5 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x5 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x7).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x6, $$x5)
        }
      };
      break
    } else {
      var beforeSepIndex = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      var t = $n(evidence$7).Lfastparse_ParsingRun__f_successValue;
      $as_jl_Void(t);
      var nextCount = ((1 + count) | 0);
      $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
      var oldCut = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
      $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
      var startPos$1 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var input = $n(evidence$7).Lfastparse_ParsingRun__f_input;
      var index = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      if ($n(input).isReachable__I__Z(index)) {
        var this$10 = $n(input);
        var this$11 = $n(this$10.Lfastparse_IndexedParserInput__f_data);
        var $$x8 = ($charAt(this$11, index) === 32)
      } else {
        var $$x8 = false
      };
      if ($$x8) {
        $n(evidence$7).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
      } else {
        $n(evidence$7).freshFailure__Lfastparse_ParsingRun()
      };
      if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$7).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\" \"")))
      };
      var lhsMsg = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
      var lhsAggregate = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
      if ($n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) {
        $n(evidence$7).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$7).Lfastparse_ParsingRun__f_cut | oldCut)));
        var sep1 = evidence$7
      } else if ($n(evidence$7).Lfastparse_ParsingRun__f_cut) {
        var sep1 = evidence$7
      } else {
        var verboseFailures$1 = $n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures;
        $n(evidence$7).Lfastparse_ParsingRun__f_index = startPos$1;
        if (verboseFailures$1) {
          var this$14 = $n(evidence$7);
          this$14.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$1, lhsMsg, lhsAggregate, false)
        };
        $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
        var input$2 = $n(evidence$7).Lfastparse_ParsingRun__f_input;
        var index$2 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
        if ($n(input$2).isReachable__I__Z(index$2)) {
          var this$15 = $n(input$2);
          var this$16 = $n(this$15.Lfastparse_IndexedParserInput__f_data);
          var $$x9 = ($charAt(this$16, index$2) === 45)
        } else {
          var $$x9 = false
        };
        if ($$x9) {
          $n(evidence$7).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
        } else {
          $n(evidence$7).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$7).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"-\"")))
        };
        var rhsMsg = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
        var rhsCut = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!(rhsCut | oldCut)));
        if (((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
          $n(evidence$7).freshFailure__I__Lfastparse_ParsingRun(startPos$1)
        };
        $n(evidence$7).Lfastparse_ParsingRun__f_cut = endCut;
        if (verboseFailures$1) {
          var this$17 = $n(evidence$7);
          var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
          var rassoc$3 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
          this$17.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$1, msgToSet, msgToAggregate, false)
        };
        var sep1 = evidence$7
      };
      var sepCut = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
      var endCut$1 = (!(!((!(!(outerCut | postCut))) | sepCut)));
      if ((sep1 === null)) {
        startIndex$1 = beforeSepIndex;
        count = nextCount;
        precut = false;
        outerCut = endCut$1;
        sepMsg = null;
        lastAgg = parsedAgg;
        continue
      };
      if ($n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) {
        var temp$sepMsg$2 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
        startIndex$1 = beforeSepIndex;
        count = nextCount;
        precut = sepCut;
        outerCut = endCut$1;
        sepMsg = temp$sepMsg$2;
        lastAgg = parsedAgg;
        continue
      };
      var res$2$2 = (sepCut ? $n(evidence$7).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut$1) : $p_Lfastparse_internal_RepImpls$__end$2__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, beforeSepIndex, beforeSepIndex, nextCount, endCut$1, 1, evidence$7, repeater, (void 0)));
      if (verboseFailures) {
        var startIndex$3 = startIndex$1;
        var $$x11 = $n(evidence$7);
        var $$x10 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
          var this$19 = $n(parsedMsg);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$19.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
        }))(parsedMsg));
        var rassoc$1$1 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
        $n($$x11).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$3, $$x10, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1$1))
      };
      break
    }
  };
  $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0$1 = ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) ? evidence$7 : $n(evidence$7).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$7).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$7).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$4 = parse0$1
  } else {
    var $$x12 = $n(parse0$1);
    var arg1 = $as_T($n(parse0$1).Lfastparse_ParsingRun__f_successValue);
    var this$22 = $n(arg1);
    $$x12.Lfastparse_ParsingRun__f_successValue = $as_T(this$22.toUpperCase());
    var x1$4 = parse0$1
  };
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("cityName").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x13 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("cityName").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x13).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x14 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("cityName").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$29 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x14.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$29)
    }
  };
  return x1$4
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.division__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$8) {
  var startIndex = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$8).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$8).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("division").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var startPos = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var repeater = $m_Lfastparse_Implicits$Repeater$UnitRepeater$();
  var this$3 = $m_Lfastparse_internal_RepImpls$();
  var startIndex$1 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  while (true) {
    $n(evidence$8).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 0) && outerCut))));
    var verboseFailures = $n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures;
    $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().letter__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
    var parsedMsg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
    if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$8 : $p_Lfastparse_internal_RepImpls$__end$1__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 2, evidence$8, repeater, (void 0)));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$8).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$5 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$5.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
          }))(parsedMsg)), $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$8);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$6 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
        }
      };
      break
    } else {
      var beforeSepIndex = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var t = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
      $as_jl_Void(t);
      var nextCount = ((1 + count) | 0);
      if ((nextCount !== 2)) {
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
        var sepCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
        startIndex$1 = beforeSepIndex;
        count = nextCount;
        precut = false;
        outerCut = endCut;
        sepMsg = null;
        lastAgg = parsedAgg;
        continue
      };
      var res$2 = $p_Lfastparse_internal_RepImpls$__end$1__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, beforeSepIndex, beforeSepIndex, nextCount, (!(!(outerCut | postCut))), 2, evidence$8, repeater, (void 0));
      if (verboseFailures) {
        $n(evidence$8).setMsg__I__F0__V(startIndex$1, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
          var this$7 = $n(parsedMsg);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".repX")
        }))(parsedMsg)))
      };
      break
    }
  };
  $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0$1 = ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) ? evidence$8 : $n(evidence$8).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$8).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$8).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$4 = parse0$1
  } else {
    var $$x4 = $n(parse0$1);
    var arg1 = $as_T($n(parse0$1).Lfastparse_ParsingRun__f_successValue);
    var this$10 = $n(arg1);
    $$x4.Lfastparse_ParsingRun__f_successValue = $as_T(this$10.toUpperCase());
    var x1$4 = parse0$1
  };
  if (instrument) {
    $n($n(evidence$8).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("division").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("division").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("division").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$17 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$17)
    }
  };
  return x1$4
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.parcelNumber__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$9) {
  var startIndex = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$9).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$9).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("parcelNumber").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var startPos = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$9).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$9).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var elem = $n(evidence$9).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  var startIndex$macro$4 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var count$macro$5 = 0;
  var lastAgg$macro$10 = null;
  while (true) {
    $n(evidence$9).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 1));
    $m_Lfastparse_package$();
    $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$9);
    var parsedMsg$macro$9 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$11 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$9).Lfastparse_ParsingRun__f_cut)));
    if ($n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) {
      var beforeSepIndex$macro$6 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
      $n(evidence$9);
      $n(evidence$9).Lfastparse_ParsingRun__f_cut = false;
      var temp$count$macro$5 = ((1 + count$macro$5) | 0);
      startIndex$macro$4 = beforeSepIndex$macro$6;
      count$macro$5 = temp$count$macro$5;
      lastAgg$macro$10 = parsedAgg$macro$11;
      continue
    };
    var res = ($n(evidence$9).Lfastparse_ParsingRun__f_cut ? evidence$9 : ((count$macro$5 < 1) ? $n(evidence$9).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$9).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$4, elem$1)));
    if ($n(evidence$9).Lfastparse_ParsingRun__f_verboseFailures) {
      var $$x4 = $n(evidence$9);
      var $$x3 = startIndex$macro$4;
      var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
        var this$3 = $n(parsedMsg$macro$9);
        return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$3.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
      }))(parsedMsg$macro$9));
      if ((lastAgg$macro$10 === null)) {
        var $$x1 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate
      } else {
        var rassoc$1 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var $$x1 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
      };
      $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x3, $$x2, $$x1)
    };
    break
  };
  $n(evidence$9).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0$1 = ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) ? evidence$9 : $n(evidence$9).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$9).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$9).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$6 = parse0$1
  } else {
    var $$x5 = $n(parse0$1);
    var arg1 = $as_T($n(parse0$1).Lfastparse_ParsingRun__f_successValue);
    $m_sc_StringOps$();
    var this$8 = $m_jl_Integer$();
    $$x5.Lfastparse_ParsingRun__f_successValue = this$8.parseInt__T__I__I(arg1, 10);
    var x1$6 = parse0$1
  };
  if (instrument) {
    $n($n(evidence$9).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("parcelNumber").Lsourcecode_Name__f_value, $n(x1$6).Lfastparse_ParsingRun__f_index, $n(x1$6).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$6).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x6 = $n(x1$6);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("parcelNumber").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$6).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$6).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$6).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x7 = $n(x1$6);
      var self = new $c_Lsourcecode_Name("parcelNumber").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$15 = $n($n(x1$6).Lfastparse_ParsingRun__f_failureStack);
      $$x7.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$15)
    }
  };
  return x1$6
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.partialParcel__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$10) {
  var startIndex = $n(evidence$10).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$10).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$10).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("partialParcel").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.Lfastparse_Implicits$Sequencer$__f_BaseSequencer2;
  var preLhsIndex$macro$17 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$10).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$2));
  var preLhsIndex$macro$2 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$10).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var this$3 = $m_Lfastparse_Implicits$Optioner$();
  var x1$7 = this$3.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
  var startPos = $n(evidence$10).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$10).Lfastparse_ParsingRun__f_cut;
  $n(evidence$10).Lfastparse_ParsingRun__f_cut = false;
  $m_Lfastparse_package$();
  this.sheetNumber__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$10);
  var postSuccess = $n(evidence$10).Lfastparse_ParsingRun__f_isSuccess;
  if (postSuccess) {
    var $$x1 = $n(evidence$10);
    $n(x1$7);
    var value = $uI($n(evidence$10).Lfastparse_ParsingRun__f_successValue);
    var res = $n($$x1).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value));
    $n(res).Lfastparse_ParsingRun__f_cut = (!(!($n(res).Lfastparse_ParsingRun__f_cut | startCut)));
    var res$3 = res
  } else if ($n(evidence$10).Lfastparse_ParsingRun__f_cut) {
    var res$3 = evidence$10
  } else {
    var res$2 = $n(evidence$10).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$7), $m_s_None$()), startPos);
    $n(res$2).Lfastparse_ParsingRun__f_cut = (!(!($n(res$2).Lfastparse_ParsingRun__f_cut | startCut)));
    var res$3 = res$2
  };
  if ($n(evidence$10).Lfastparse_ParsingRun__f_verboseFailures) {
    var msg = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
    var agg = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ((!postSuccess)) {
      $n(evidence$10).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos, new $c_sjsr_AnonFunction0((() => {
        var this$8 = $n(msg);
        return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".?")
      })), agg)
    }
  };
  if ((!$n(res$3).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var $$x2 = $n(res$3);
    var arg1 = $as_s_Option($n(res$3).Lfastparse_ParsingRun__f_successValue);
    var this$10 = $n(arg1);
    $$x2.Lfastparse_ParsingRun__f_successValue = $uI((this$10.isEmpty__Z() ? 0 : this$10.get__O()))
  };
  if ((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$10).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$10).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$10).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$4 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
      this.division__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$10);
      var rhsAggregate$macro$7 = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$10
      } else {
        var postRhsIndex$macro$5 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$10).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var res$macro$14 = $n(evidence$10).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$5).apply__O__O__O($uI(lhsValue$macro$12), $as_T($n(evidence$10).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$13)
      };
      if ($n(evidence$10).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$10).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$10).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess)) {
    var parse0$3 = evidence$10
  } else {
    var postLhsIndex$macro$18 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$10).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$10).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$10).Lfastparse_ParsingRun__f_cut)) {
      var parse0$3 = evidence$10
    } else {
      var preRhsIndex$macro$19 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var this$14 = $m_Lfastparse_Implicits$Repeater$();
      var repeater = this$14.GenericRepeatedImplicit0__Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$();
      var whitespace = this.Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$__f_whitespaceImplicit;
      var this$16 = $m_Lfastparse_internal_RepImpls$();
      $n(repeater);
      var acc = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
      var startIndex$1 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
      var count = 0;
      var precut = false;
      var outerCut = $n(evidence$10).Lfastparse_ParsingRun__f_cut;
      var sepMsg = null;
      var lastAgg = null;
      while (true) {
        $n(evidence$10).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
        $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().parcelNumber__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$10);
        var parsedMsg = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
        var parsedAgg = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var postCut = $n(evidence$10).Lfastparse_ParsingRun__f_cut;
        var verboseFailures = $n(evidence$10).Lfastparse_ParsingRun__f_verboseFailures;
        if ((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$1 = (postCut ? evidence$10 : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$16, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$10, repeater, acc));
          if (verboseFailures) {
            var startIndex$2 = startIndex$1;
            var sepMsg$1 = sepMsg;
            var lastAgg$1 = lastAgg;
            var precut$1 = precut;
            if (((sepMsg$1 === null) || precut$1)) {
              $n(evidence$10).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$19 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$19.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg)), $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate)
            } else {
              var $$x5 = $n(evidence$10);
              var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$20 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$20.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg));
              if ((lastAgg$1 === null)) {
                var $$x3 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
              } else {
                var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
                var $$x3 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
              };
              $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x4, $$x3)
            }
          };
          break
        } else {
          var beforeSepIndex = $n(evidence$10).Lfastparse_ParsingRun__f_index;
          $n(repeater);
          var t = $n(evidence$10).Lfastparse_ParsingRun__f_successValue;
          var this$22 = $n(acc);
          this$22.addOne__O__scm_Growable(t);
          var nextCount = ((1 + count) | 0);
          if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$10)
          };
          if (((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$10).Lfastparse_ParsingRun__f_cut)) {
            break
          } else {
            $n(evidence$10).Lfastparse_ParsingRun__f_cut = false;
            var sep1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().listSeparator__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$10);
            var sepCut = $n(evidence$10).Lfastparse_ParsingRun__f_cut;
            var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
            if ((sep1 === null)) {
              startIndex$1 = beforeSepIndex;
              count = nextCount;
              precut = false;
              outerCut = endCut;
              sepMsg = null;
              lastAgg = parsedAgg
            } else if ($n(evidence$10).Lfastparse_ParsingRun__f_isSuccess) {
              if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
                $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$10)
              };
              var temp$sepMsg$2 = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
              startIndex$1 = beforeSepIndex;
              count = nextCount;
              precut = sepCut;
              outerCut = endCut;
              sepMsg = temp$sepMsg$2;
              lastAgg = parsedAgg
            } else {
              var res$2$1 = (sepCut ? $n(evidence$10).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut) : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$16, beforeSepIndex, beforeSepIndex, nextCount, endCut, 1, evidence$10, repeater, acc));
              if (verboseFailures) {
                var startIndex$3 = startIndex$1;
                var $$x7 = $n(evidence$10);
                var $$x6 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                  var this$24 = $n(parsedMsg);
                  return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$24.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
                }))(parsedMsg));
                var rassoc$1 = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
                $n($$x7).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$3, $$x6, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1))
              };
              break
            }
          }
        }
      };
      var rhsAggregate$macro$22 = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$23 = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$29 = evidence$10
      } else {
        var postRhsIndex$macro$20 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
        var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
        if ((rhsMadeProgress$macro$25 && $n(evidence$10).checkForDrop__Z())) {
          $n(input$macro$26)
        };
        var res$macro$29 = $n(evidence$10).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($as_T2(lhsValue$macro$27), $as_sci_Seq($n(evidence$10).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$28)
      };
      if ($n(evidence$10).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$10).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$10).Lfastparse_ParsingRun__f_traceIndex))
      };
      var parse0$3 = res$macro$29
    }
  };
  if ((!$n(parse0$3).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$10 = parse0$3
  } else {
    var $$x8 = $n(parse0$3);
    var this$26 = $m_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$();
    $$x8.Lfastparse_ParsingRun__f_successValue = $n($f_F3__tupled__F1(this$26)).apply__O__O($as_T3($n(parse0$3).Lfastparse_ParsingRun__f_successValue));
    var x1$10 = parse0$3
  };
  if (instrument) {
    $n($n(evidence$10).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("partialParcel").Lsourcecode_Name__f_value, $n(x1$10).Lfastparse_ParsingRun__f_index, $n(x1$10).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$10).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x9 = $n(x1$10);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("partialParcel").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x9).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$10).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$10).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$10).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x10 = $n(x1$10);
      var self = new $c_Lsourcecode_Name("partialParcel").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$33 = $n($n(x1$10).Lfastparse_ParsingRun__f_failureStack);
      $$x10.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$33)
    }
  };
  return x1$10
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.partialParcelList__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$11) {
  var startIndex = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$11).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$11).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("partialParcelList").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Repeater$();
  var repeater = this$2.GenericRepeatedImplicit0__Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$();
  var this$4 = $m_Lfastparse_internal_RepImpls$();
  $n(repeater);
  var acc = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
  var startIndex$1 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  var x1$2;
  while (true) {
    $n(evidence$11).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
    $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().partialParcel__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$11);
    var parsedMsg = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
    var verboseFailures = $n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures;
    if ((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$11 : $p_Lfastparse_internal_RepImpls$__end$2__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$11, repeater, acc));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$11).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$7 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg)), $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$11);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$8 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
        }
      };
      var x1$2 = res;
      break
    } else {
      var beforeSepIndex = $n(evidence$11).Lfastparse_ParsingRun__f_index;
      $n(repeater);
      var t = $n(evidence$11).Lfastparse_ParsingRun__f_successValue;
      var this$10 = $n(acc);
      this$10.addOne__O__scm_Growable(t);
      var nextCount = ((1 + count) | 0);
      $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
      var sep1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().listSeparator__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$11);
      var sepCut = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
      var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
      if ((sep1 === null)) {
        startIndex$1 = beforeSepIndex;
        count = nextCount;
        precut = false;
        outerCut = endCut;
        sepMsg = null;
        lastAgg = parsedAgg;
        continue
      };
      if ($n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) {
        var temp$sepMsg$2 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
        startIndex$1 = beforeSepIndex;
        count = nextCount;
        precut = sepCut;
        outerCut = endCut;
        sepMsg = temp$sepMsg$2;
        lastAgg = parsedAgg;
        continue
      };
      var res$2 = (sepCut ? $n(evidence$11).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut) : $p_Lfastparse_internal_RepImpls$__end$2__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, beforeSepIndex, beforeSepIndex, nextCount, endCut, 1, evidence$11, repeater, acc));
      if (verboseFailures) {
        var startIndex$3 = startIndex$1;
        var $$x5 = $n(evidence$11);
        var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
          var this$12 = $n(parsedMsg);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$12.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
        }))(parsedMsg));
        var rassoc$1 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
        $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$3, $$x4, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1))
      };
      var x1$2 = res$2;
      break
    }
  };
  if (instrument) {
    $n($n(evidence$11).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("partialParcelList").Lsourcecode_Name__f_value, $n(x1$2).Lfastparse_ParsingRun__f_index, $n(x1$2).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$2).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x6 = $n(x1$2);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("partialParcelList").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$2).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$2).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$2).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x7 = $n(x1$2);
      var self = new $c_Lsourcecode_Name("partialParcelList").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$19 = $n($n(x1$2).Lfastparse_ParsingRun__f_failureStack);
      $$x7.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$19)
    }
  };
  return x1$2
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.coordPart__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$12) {
  var startIndex = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$12).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$12).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("coordPart").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var startPos = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$12).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$12).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$58 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  var input$macro$67 = $n(evidence$12).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$17 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$12).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var startPos$2 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
  $n(evidence$12).Lfastparse_ParsingRun__f_cut = false;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$12).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var input = $n(evidence$12).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$4 = $n(input);
    var this$5 = $n(this$4.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$5, index) === 45)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$12).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$12).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$12).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"-\"")))
  };
  if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$12).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$12);
    if (((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$12).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$4 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
      var startPos$3 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
      var startCut$2 = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
      $n(evidence$12).Lfastparse_ParsingRun__f_cut = false;
      $m_Lfastparse_package$();
      this.whitespace__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$12);
      var postSuccess = $n(evidence$12).Lfastparse_ParsingRun__f_isSuccess;
      if (postSuccess) {
        var res$2 = $n(evidence$12).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$12), (void 0)));
        $n(res$2).Lfastparse_ParsingRun__f_cut = (!(!($n(res$2).Lfastparse_ParsingRun__f_cut | startCut$2)))
      } else if ($n(evidence$12).Lfastparse_ParsingRun__f_cut) {
        /*<skip>*/
      } else {
        var res$3 = $n(evidence$12).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos$3);
        $n(res$3).Lfastparse_ParsingRun__f_cut = (!(!($n(res$3).Lfastparse_ParsingRun__f_cut | startCut$2)))
      };
      if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
        var msg = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
        var agg = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ((!postSuccess)) {
          $n(evidence$12).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$3, new $c_sjsr_AnonFunction0((() => {
            var this$9 = $n(msg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$9.Lfastparse_internal_Msgs__f_value) + ".?")
          })), agg)
        }
      };
      var rhsAggregate$macro$7 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$12
      } else {
        var postRhsIndex$macro$5 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$12).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x2 = $n(evidence$12);
        $n(evidence$12);
        var v = (void 0);
        var res$macro$14 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
      };
      if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$12).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$12).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  var postSuccess$2 = $n(evidence$12).Lfastparse_ParsingRun__f_isSuccess;
  if (postSuccess$2) {
    var res$5 = $n(evidence$12).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$12), (void 0)));
    $n(res$5).Lfastparse_ParsingRun__f_cut = (!(!($n(res$5).Lfastparse_ParsingRun__f_cut | startCut)))
  } else if ($n(evidence$12).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var res$6 = $n(evidence$12).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos$2);
    $n(res$6).Lfastparse_ParsingRun__f_cut = (!(!($n(res$6).Lfastparse_ParsingRun__f_cut | startCut)))
  };
  if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
    var msg$2 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
    var agg$2 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ((!postSuccess$2)) {
      $n(evidence$12).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$2, new $c_sjsr_AnonFunction0((() => {
        var this$11 = $n(msg$2);
        return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$11.Lfastparse_internal_Msgs__f_value) + ".?")
      })), agg$2)
    }
  };
  if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$18 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$12).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    $n(evidence$12);
    if (((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$12).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$19 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var repeater = $m_Lfastparse_Implicits$Repeater$UnitRepeater$();
      var this$15 = $m_Lfastparse_internal_RepImpls$();
      var startIndex$1 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
      var count = 0;
      var precut = false;
      var outerCut = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
      var sepMsg = null;
      var lastAgg = null;
      while (true) {
        $n(evidence$12).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
        var verboseFailures = $n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures;
        $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$12);
        var parsedMsg = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
        var parsedAgg = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var postCut = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
        if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$1 = (postCut ? evidence$12 : $p_Lfastparse_internal_RepImpls$__end$1__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$15, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$12, repeater, (void 0)));
          if (verboseFailures) {
            var startIndex$2 = startIndex$1;
            var sepMsg$1 = sepMsg;
            var lastAgg$1 = lastAgg;
            var precut$1 = precut;
            if (((sepMsg$1 === null) || precut$1)) {
              $n(evidence$12).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$17 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$17.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg)), $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate)
            } else {
              var $$x5 = $n(evidence$12);
              var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$18 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$18.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg));
              if ((lastAgg$1 === null)) {
                var $$x3 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
              } else {
                var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
                var $$x3 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
              };
              $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x4, $$x3)
            }
          };
          break
        } else {
          var beforeSepIndex = $n(evidence$12).Lfastparse_ParsingRun__f_index;
          var t = $n(evidence$12).Lfastparse_ParsingRun__f_successValue;
          $as_jl_Void(t);
          var nextCount = ((1 + count) | 0);
          if ((nextCount === 3)) {
            var res$2$1 = $p_Lfastparse_internal_RepImpls$__end$1__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$15, beforeSepIndex, beforeSepIndex, nextCount, (!(!(outerCut | postCut))), 1, evidence$12, repeater, (void 0));
            if (verboseFailures) {
              $n(evidence$12).setMsg__I__F0__V(startIndex$1, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$19 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$19.Lfastparse_internal_Msgs__f_value) + ".repX(1)")
              }))(parsedMsg)))
            };
            break
          } else {
            $n(evidence$12).Lfastparse_ParsingRun__f_cut = false;
            var sepCut = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
            var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
            startIndex$1 = beforeSepIndex;
            count = nextCount;
            precut = false;
            outerCut = endCut;
            sepMsg = null;
            lastAgg = parsedAgg
          }
        }
      };
      var rhsAggregate$macro$22 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$23 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$29 = evidence$12
      } else {
        var postRhsIndex$macro$20 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
        var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
        if ((rhsMadeProgress$macro$25 && $n(evidence$12).checkForDrop__Z())) {
          $n(input$macro$26)
        };
        var $$x6 = $n(evidence$12);
        $n(evidence$12);
        var v$1 = (void 0);
        var res$macro$29 = $n($$x6).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$28)
      };
      if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$12).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$12).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$59 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$62 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$65 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$59 > preLhsIndex$macro$58) && $n(evidence$12).checkForDrop__Z())) {
      $n(input$macro$67)
    };
    $n(evidence$12);
    if (((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$12).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$60 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
      var startPos$4 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
      var startCut$3 = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
      $n(evidence$12).Lfastparse_ParsingRun__f_cut = false;
      $m_Lfastparse_package$();
      $m_Lfastparse_Implicits$Sequencer$();
      var preLhsIndex$macro$43 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
      var input$macro$52 = $n(evidence$12).Lfastparse_ParsingRun__f_input;
      $m_Lfastparse_package$();
      var index$2 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
      if ((!$n($n(evidence$12).Lfastparse_ParsingRun__f_input).isReachable__I__Z(index$2))) {
        $n(evidence$12).freshFailure__Lfastparse_ParsingRun()
      } else {
        var this$22 = $n($n(evidence$12).Lfastparse_ParsingRun__f_input);
        var index$1 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
        var this$23 = $n(this$22.Lfastparse_IndexedParserInput__f_data);
        var x1$19 = $charAt(this$23, index$1);
        var x1$20 = (x1$19 === 46);
        if ((x1$20 === true)) {
          $n(evidence$12).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
        } else {
          if ((x1$20 !== false)) {
            throw new $c_s_MatchError(x1$20)
          };
          $n(evidence$12).freshFailure__Lfastparse_ParsingRun()
        }
      };
      if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$12).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "[.]")))
      };
      if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
        /*<skip>*/
      } else {
        var postLhsIndex$macro$44 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
        var lhsAggregate$macro$47 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var lhsMsg$macro$50 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
        if (((postLhsIndex$macro$44 > preLhsIndex$macro$43) && $n(evidence$12).checkForDrop__Z())) {
          $n(input$macro$52)
        };
        $n(evidence$12);
        if (((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$12).Lfastparse_ParsingRun__f_cut)) {
          /*<skip>*/
        } else {
          var preRhsIndex$macro$45 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
          var elem = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
          var elem$1 = false;
          elem$1 = elem;
          var startIndex$macro$34 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
          var count$macro$35 = 0;
          var lastAgg$macro$40 = null;
          while (true) {
            $n(evidence$12).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$35 < 1));
            $m_Lfastparse_package$();
            $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$12);
            var parsedMsg$macro$39 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
            var parsedAgg$macro$41 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
            elem$1 = (!(!(elem$1 | $n(evidence$12).Lfastparse_ParsingRun__f_cut)));
            if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
              var res$9 = ($n(evidence$12).Lfastparse_ParsingRun__f_cut ? evidence$12 : ((count$macro$35 < 1) ? $n(evidence$12).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$34, elem$1) : $n(evidence$12).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$34, elem$1)));
              if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
                var $$x10 = $n(evidence$12);
                var $$x9 = startIndex$macro$34;
                var $$x8 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$39) => (() => {
                  var this$27 = $n(parsedMsg$macro$39);
                  return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$27.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
                }))(parsedMsg$macro$39));
                if ((lastAgg$macro$40 === null)) {
                  var $$x7 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate
                } else {
                  var rassoc$3 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
                  var $$x7 = $n(lastAgg$macro$40).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3)
                };
                $n($$x10).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x9, $$x8, $$x7)
              };
              break
            } else {
              var beforeSepIndex$macro$36 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
              $n(evidence$12);
              $n(evidence$12).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$35 = ((1 + count$macro$35) | 0);
              startIndex$macro$34 = beforeSepIndex$macro$36;
              count$macro$35 = temp$count$macro$35;
              lastAgg$macro$40 = parsedAgg$macro$41
            }
          };
          var rhsAggregate$macro$48 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var rhsMsg$macro$49 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
          if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$macro$55 = evidence$12
          } else {
            var postRhsIndex$macro$46 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
            var rhsMadeProgress$macro$51 = (postRhsIndex$macro$46 > preRhsIndex$macro$45);
            var nextIndex$macro$54 = (((!rhsMadeProgress$macro$51) && $n(input$macro$52).isReachable__I__Z(postRhsIndex$macro$46)) ? postLhsIndex$macro$44 : postRhsIndex$macro$46);
            if ((rhsMadeProgress$macro$51 && $n(evidence$12).checkForDrop__Z())) {
              $n(input$macro$52)
            };
            var $$x11 = $n(evidence$12);
            $n(evidence$12);
            var v$2 = (void 0);
            var res$macro$55 = $n($$x11).freshSuccess__O__I__Lfastparse_ParsingRun(v$2, nextIndex$macro$54)
          };
          if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$12).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$43, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$50, rhsMsg$macro$49), $n(lhsAggregate$macro$47).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$48), (preRhsIndex$macro$45 === $n(evidence$12).Lfastparse_ParsingRun__f_traceIndex))
          }
        }
      };
      var postSuccess$3 = $n(evidence$12).Lfastparse_ParsingRun__f_isSuccess;
      if (postSuccess$3) {
        var res$9$1 = $n(evidence$12).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$12), (void 0)));
        $n(res$9$1).Lfastparse_ParsingRun__f_cut = (!(!($n(res$9$1).Lfastparse_ParsingRun__f_cut | startCut$3)))
      } else if ($n(evidence$12).Lfastparse_ParsingRun__f_cut) {
        /*<skip>*/
      } else {
        var res$10 = $n(evidence$12).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos$4);
        $n(res$10).Lfastparse_ParsingRun__f_cut = (!(!($n(res$10).Lfastparse_ParsingRun__f_cut | startCut$3)))
      };
      if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
        var msg$3 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
        var agg$3 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ((!postSuccess$3)) {
          $n(evidence$12).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$4, new $c_sjsr_AnonFunction0((() => {
            var this$29 = $n(msg$3);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$29.Lfastparse_internal_Msgs__f_value) + ".?")
          })), agg$3)
        }
      };
      var rhsAggregate$macro$63 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$64 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$70 = evidence$12
      } else {
        var postRhsIndex$macro$61 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$66 = (postRhsIndex$macro$61 > preRhsIndex$macro$60);
        var nextIndex$macro$69 = (((!rhsMadeProgress$macro$66) && $n(input$macro$67).isReachable__I__Z(postRhsIndex$macro$61)) ? postLhsIndex$macro$59 : postRhsIndex$macro$61);
        if ((rhsMadeProgress$macro$66 && $n(evidence$12).checkForDrop__Z())) {
          $n(input$macro$67)
        };
        var $$x12 = $n(evidence$12);
        $n(evidence$12);
        var v$3 = (void 0);
        var res$macro$70 = $n($$x12).freshSuccess__O__I__Lfastparse_ParsingRun(v$3, nextIndex$macro$69)
      };
      if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$12).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$58, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$65, rhsMsg$macro$64), $n(lhsAggregate$macro$62).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$63), (preRhsIndex$macro$60 === $n(evidence$12).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  $n(evidence$12).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0$5 = ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess) ? evidence$12 : $n(evidence$12).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$12).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$12).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0$5).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$24 = parse0$5
  } else {
    var $$x13 = $n(parse0$5);
    var arg1 = $as_T($n(parse0$5).Lfastparse_ParsingRun__f_successValue);
    $m_sc_StringOps$();
    $m_sc_StringOps$();
    $m_sc_StringOps$();
    var this$35 = $n(arg1);
    var len = this$35.length;
    var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
    var i = 0;
    while ((i < len)) {
      var this$36 = $n(arg1);
      var index$3 = i;
      var x = $charAt(this$36, index$3);
      if ((!((x === 32) || (x === 9)))) {
        var str = $as_T(String.fromCharCode(x));
        sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
      };
      i = ((1 + i) | 0)
    };
    var x$1 = ((len === sb.length__I()) ? arg1 : sb.jl_StringBuilder__f_java$lang$StringBuilder$$content);
    $$x13.Lfastparse_ParsingRun__f_successValue = $m_jl_Double$().parseDouble__T__D(x$1);
    var x1$24 = parse0$5
  };
  if (instrument) {
    $n($n(evidence$12).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("coordPart").Lsourcecode_Name__f_value, $n(x1$24).Lfastparse_ParsingRun__f_index, $n(x1$24).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$24).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x14 = $n(x1$24);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("coordPart").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x14).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$24).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$24).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$24).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x15 = $n(x1$24);
      var self = new $c_Lsourcecode_Name("coordPart").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$46 = $n($n(x1$24).Lfastparse_ParsingRun__f_failureStack);
      $$x15.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$46)
    }
  };
  return x1$24
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.coordinates__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$13) {
  var startIndex = $n(evidence$13).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$13).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$13).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("coordinates").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Repeater$();
  var repeater = this$2.GenericRepeatedImplicit0__Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$();
  var whitespace = this.Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$__f_whitespaceImplicit;
  var this$4 = $m_Lfastparse_internal_RepImpls$();
  $n(repeater);
  var acc = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
  var startIndex$1 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$13).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  var parse0;
  while (true) {
    $n(evidence$13).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 0) && outerCut))));
    $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().coordPart__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$13);
    var parsedMsg = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$13).Lfastparse_ParsingRun__f_cut;
    var verboseFailures = $n(evidence$13).Lfastparse_ParsingRun__f_verboseFailures;
    if ((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$13 : $p_Lfastparse_internal_RepImpls$__end$3__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 2, evidence$13, repeater, acc));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$13).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$7 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
          }))(parsedMsg)), $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$13);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$8 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
        }
      };
      var parse0 = res;
      break
    } else {
      var beforeSepIndex = $n(evidence$13).Lfastparse_ParsingRun__f_index;
      $n(repeater);
      var t = $n(evidence$13).Lfastparse_ParsingRun__f_successValue;
      var this$10 = $n(acc);
      this$10.addOne__O__scm_Growable(t);
      var nextCount = ((1 + count) | 0);
      if ((nextCount === 2)) {
        var res$2 = $p_Lfastparse_internal_RepImpls$__end$3__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, beforeSepIndex, beforeSepIndex, nextCount, (!(!(outerCut | postCut))), 2, evidence$13, repeater, acc);
        if (verboseFailures) {
          $n(evidence$13).setMsg__I__F0__V(startIndex$1, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$11 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$11.Lfastparse_internal_Msgs__f_value) + ".rep")
          }))(parsedMsg)))
        };
        var parse0 = res$2;
        break
      } else {
        if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
          $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$13)
        };
        if (((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$13).Lfastparse_ParsingRun__f_cut)) {
          var parse0 = evidence$13;
          break
        } else {
          $n(evidence$13).Lfastparse_ParsingRun__f_cut = false;
          var sep1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().listSeparator__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$13);
          var sepCut = $n(evidence$13).Lfastparse_ParsingRun__f_cut;
          var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
          if ((sep1 === null)) {
            startIndex$1 = beforeSepIndex;
            count = nextCount;
            precut = false;
            outerCut = endCut;
            sepMsg = null;
            lastAgg = parsedAgg;
            continue
          };
          if ($n(evidence$13).Lfastparse_ParsingRun__f_isSuccess) {
            if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$13)
            };
            if ((!((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess) && sepCut))) {
              var temp$sepMsg$2 = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
              startIndex$1 = beforeSepIndex;
              count = nextCount;
              precut = sepCut;
              outerCut = endCut;
              sepMsg = temp$sepMsg$2;
              lastAgg = parsedAgg;
              continue
            };
            var parse0 = evidence$13;
            break
          } else {
            var res$3 = (sepCut ? $n(evidence$13).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut) : $p_Lfastparse_internal_RepImpls$__end$3__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, beforeSepIndex, beforeSepIndex, nextCount, endCut, 2, evidence$13, repeater, acc));
            if (verboseFailures) {
              var startIndex$3 = startIndex$1;
              var $$x5 = $n(evidence$13);
              var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$13 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$13.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
              }))(parsedMsg));
              var rassoc$1 = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
              $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$3, $$x4, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1))
            };
            var parse0 = res$3;
            break
          }
        }
      }
    }
  };
  if ((!$n(parse0).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$3 = parse0
  } else {
    var $$x6 = $n(parse0);
    var arg1 = $as_sci_Seq($n(parse0).Lfastparse_ParsingRun__f_successValue);
    $$x6.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates(new $c_T2$mcDD$sp($uD($n(arg1).apply__I__O(0)), $uD($n(arg1).apply__I__O(1))));
    var x1$3 = parse0
  };
  if (instrument) {
    $n($n(evidence$13).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("coordinates").Lsourcecode_Name__f_value, $n(x1$3).Lfastparse_ParsingRun__f_index, $n(x1$3).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$3).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x7 = $n(x1$3);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("coordinates").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$3).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$3).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x8 = $n(x1$3);
      var self = new $c_Lsourcecode_Name("coordinates").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$21 = $n($n(x1$3).Lfastparse_ParsingRun__f_failureStack);
      $$x8.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$21)
    }
  };
  return x1$3
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.postalCode__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$14) {
  var startIndex = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$14).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$14).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("postalCode").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$2 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$14).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var startPos = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$14).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$14).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var repeater = $m_Lfastparse_Implicits$Repeater$UnitRepeater$();
  var this$4 = $m_Lfastparse_internal_RepImpls$();
  var startIndex$1 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$14).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  while (true) {
    $n(evidence$14).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 0) && outerCut))));
    var verboseFailures = $n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures;
    $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$14);
    var parsedMsg = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$14).Lfastparse_ParsingRun__f_cut;
    if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$14 : $p_Lfastparse_internal_RepImpls$__end$1__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 5, evidence$14, repeater, (void 0)));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$14).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$6 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
          }))(parsedMsg)), $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$14);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$7 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
        }
      };
      break
    } else {
      var beforeSepIndex = $n(evidence$14).Lfastparse_ParsingRun__f_index;
      var t = $n(evidence$14).Lfastparse_ParsingRun__f_successValue;
      $as_jl_Void(t);
      var nextCount = ((1 + count) | 0);
      if ((nextCount !== 5)) {
        $n(evidence$14).Lfastparse_ParsingRun__f_cut = false;
        var sepCut = $n(evidence$14).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
        startIndex$1 = beforeSepIndex;
        count = nextCount;
        precut = false;
        outerCut = endCut;
        sepMsg = null;
        lastAgg = parsedAgg;
        continue
      };
      var res$2 = $p_Lfastparse_internal_RepImpls$__end$1__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, beforeSepIndex, beforeSepIndex, nextCount, (!(!(outerCut | postCut))), 5, evidence$14, repeater, (void 0));
      if (verboseFailures) {
        $n(evidence$14).setMsg__I__F0__V(startIndex$1, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
          var this$8 = $n(parsedMsg);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".repX")
        }))(parsedMsg)))
      };
      break
    }
  };
  $n(evidence$14).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    $n(evidence$14).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$14).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$14).Lfastparse_ParsingRun__f_index))
  };
  if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$5 = evidence$14
  } else {
    var postLhsIndex$macro$3 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$14).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$14).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$14).Lfastparse_ParsingRun__f_cut)) {
      var x1$5 = evidence$14
    } else {
      var preRhsIndex$macro$4 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var startPos$1 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
      var startCut = $n(evidence$14).Lfastparse_ParsingRun__f_cut;
      var oldNoCut = $n(evidence$14).Lfastparse_ParsingRun__f_noDropBuffer;
      $n(evidence$14).Lfastparse_ParsingRun__f_noDropBuffer = true;
      var startTerminals = $n(evidence$14).Lfastparse_ParsingRun__f_failureTerminalAggregate;
      $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$14);
      $n(evidence$14).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
      var msg = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
      var res$1 = ($n(evidence$14).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$14).freshFailure__I__Lfastparse_ParsingRun(startPos$1) : $n(evidence$14).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$1));
      if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$14).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
        $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
        $n(evidence$14).setMsg__I__F0__V(startPos$1, new $c_sjsr_AnonFunction0((() => {
          var this$13 = $n(msg);
          return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$13.Lfastparse_internal_Msgs__f_value))
        })))
      };
      $n(res$1).Lfastparse_ParsingRun__f_cut = startCut;
      var rhsAggregate$macro$7 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$14
      } else {
        var postRhsIndex$macro$5 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$14).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x4 = $n(evidence$14);
        $n(x1$3);
        var t$1 = $as_T(lhsValue$macro$12);
        $n(evidence$14);
        var res$macro$14 = $n($$x4).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$13)
      };
      if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$14).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$14).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$5 = res$macro$14
    }
  };
  if (instrument) {
    $n($n(evidence$14).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("postalCode").Lsourcecode_Name__f_value, $n(x1$5).Lfastparse_ParsingRun__f_index, $n(x1$5).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$5);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("postalCode").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$5);
      var self = new $c_Lsourcecode_Name("postalCode").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$21 = $n($n(x1$5).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$21)
    }
  };
  return x1$5
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.postalArea__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$15) {
  var startIndex = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$15).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$15).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("postalArea").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$15).Lfastparse_ParsingRun__f_cut;
  $n(evidence$15).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var parse0 = this.postalCode__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$15);
  if ((!$n(parse0).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var $$x1 = $n(parse0);
    var arg1 = $as_T($n(parse0).Lfastparse_ParsingRun__f_successValue);
    $$x1.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode(arg1)
  };
  var lhsMsg = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$15).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$15).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$5 = evidence$15
  } else if ($n(evidence$15).Lfastparse_ParsingRun__f_cut) {
    var x1$5 = evidence$15
  } else {
    var verboseFailures = $n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$15).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$3 = $n(evidence$15);
      this$3.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$15).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$();
    var parse0$2 = this.cityName__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$15);
    if ($n(parse0$2).Lfastparse_ParsingRun__f_isSuccess) {
      var $$x2 = $n(parse0$2);
      var arg1$1 = $as_T($n(parse0$2).Lfastparse_ParsingRun__f_successValue);
      $$x2.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName(arg1$1)
    };
    var rhsMsg = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$15).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$15).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$15).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$5 = $n(evidence$15);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$5.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$5 = evidence$15
  };
  if (instrument) {
    $n($n(evidence$15).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("postalArea").Lsourcecode_Name__f_value, $n(x1$5).Lfastparse_ParsingRun__f_index, $n(x1$5).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x3 = $n(x1$5);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("postalArea").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x4 = $n(x1$5);
      var self = new $c_Lsourcecode_Name("postalArea").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$12 = $n($n(x1$5).Lfastparse_ParsingRun__f_failureStack);
      $$x4.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$12)
    }
  };
  return x1$5
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.parcelAddress__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$16) {
  var startIndex = $n(evidence$16).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$16).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$16).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("parcelAddress").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$16).Lfastparse_ParsingRun__f_cut;
  $n(evidence$16).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$16).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$4 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$2 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$16).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  this.partialParcelList__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$16);
  if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
    var parse0$1 = evidence$16
  } else {
    var postLhsIndex$macro$3 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$16).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$16).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$__f_whitespaceImplicit, evidence$16);
    if ($n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$16).Lfastparse_ParsingRun__f_cut)) {
        var parse0$1 = evidence$16
      } else {
        var preRhsIndex$macro$4 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
        this.postalArea__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$16);
        var rhsAggregate$macro$7 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$14 = evidence$16
        } else {
          var postRhsIndex$macro$5 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$16).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var res$macro$14 = $n(evidence$16).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$4).apply__O__O__O($as_sci_Seq(lhsValue$macro$12), $as_s_Product($n(evidence$16).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$13)
        };
        if ($n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$16).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$16).Lfastparse_ParsingRun__f_traceIndex))
        };
        var parse0$1 = res$macro$14
      }
    } else {
      var parse0$1 = evidence$16
    }
  };
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var $$x1 = $n(parse0$1);
    var arg1 = $as_T2($n(parse0$1).Lfastparse_ParsingRun__f_successValue);
    if ((arg1 === null)) {
      throw new $c_s_MatchError(arg1)
    };
    var parcelList = $as_sci_Seq($n(arg1)._1__O());
    var postalArea = $as_s_Product($n(arg1)._2__O());
    $$x1.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress($as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(postalArea), parcelList)
  };
  var lhsMsg = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$16).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$16).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$11 = evidence$16
  } else if ($n(evidence$16).Lfastparse_ParsingRun__f_cut) {
    var x1$11 = evidence$16
  } else {
    var verboseFailures = $n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$16).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$5 = $n(evidence$16);
      this$5.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$16).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$();
    var this$6 = $m_Lfastparse_Implicits$Sequencer$();
    var x1$7 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$6));
    var preLhsIndex$macro$32 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
    var input$macro$41 = $n(evidence$16).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    this.postalArea__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$16);
    if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
      var parse0$5 = evidence$16
    } else {
      var postLhsIndex$macro$33 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$36 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$39 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
      if (((postLhsIndex$macro$33 > preLhsIndex$macro$32) && $n(evidence$16).checkForDrop__Z())) {
        $n(input$macro$41)
      };
      var lhsValue$macro$42 = $n(evidence$16).Lfastparse_ParsingRun__f_successValue;
      if (((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$16).Lfastparse_ParsingRun__f_cut)) {
        var parse0$5 = evidence$16
      } else {
        var preRhsIndex$macro$34 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_Implicits$Sequencer$();
        var preLhsIndex$macro$17 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
        var input$macro$26 = $n(evidence$16).Lfastparse_ParsingRun__f_input;
        $m_Lfastparse_package$();
        this.whitespace__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$16);
        if ($n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) {
          var postLhsIndex$macro$18 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
          var lhsAggregate$macro$21 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var lhsMsg$macro$24 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
          if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$16).checkForDrop__Z())) {
            $n(input$macro$26)
          };
          $n(evidence$16);
          if ((!((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$16).Lfastparse_ParsingRun__f_cut))) {
            var preRhsIndex$macro$19 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
            this.partialParcelList__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$16);
            var rhsAggregate$macro$22 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var rhsMsg$macro$23 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
            if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
              /*<skip>*/
            } else {
              var postRhsIndex$macro$20 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
              var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
              var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
              if ((rhsMadeProgress$macro$25 && $n(evidence$16).checkForDrop__Z())) {
                $n(input$macro$26)
              };
              var $$x2 = $n(evidence$16);
              var v = $as_sci_Seq($n(evidence$16).Lfastparse_ParsingRun__f_successValue);
              $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$28)
            };
            if ($n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures) {
              $n(evidence$16).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$16).Lfastparse_ParsingRun__f_traceIndex))
            }
          }
        };
        var rhsAggregate$macro$37 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$38 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$44 = evidence$16
        } else {
          var postRhsIndex$macro$35 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$40 = (postRhsIndex$macro$35 > preRhsIndex$macro$34);
          var nextIndex$macro$43 = (((!rhsMadeProgress$macro$40) && $n(input$macro$41).isReachable__I__Z(postRhsIndex$macro$35)) ? postLhsIndex$macro$33 : postRhsIndex$macro$35);
          if ((rhsMadeProgress$macro$40 && $n(evidence$16).checkForDrop__Z())) {
            $n(input$macro$41)
          };
          var res$macro$44 = $n(evidence$16).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$7).apply__O__O__O($as_s_Product(lhsValue$macro$42), $as_sci_Seq($n(evidence$16).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$43)
        };
        if ($n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$16).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$32, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$39, rhsMsg$macro$38), $n(lhsAggregate$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$37), (preRhsIndex$macro$34 === $n(evidence$16).Lfastparse_ParsingRun__f_traceIndex))
        };
        var parse0$5 = res$macro$44
      }
    };
    if ($n(parse0$5).Lfastparse_ParsingRun__f_isSuccess) {
      var $$x3 = $n(parse0$5);
      var arg1$1 = $as_T2($n(parse0$5).Lfastparse_ParsingRun__f_successValue);
      if ((arg1$1 === null)) {
        throw new $c_s_MatchError(arg1$1)
      };
      var postalArea$1 = $as_s_Product($n(arg1$1)._1__O());
      var parcelList$1 = $as_sci_Seq($n(arg1$1)._2__O());
      $$x3.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress($as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(postalArea$1), parcelList$1)
    };
    var rhsMsg = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$16).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$16).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$16).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$11 = $n(evidence$16);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3$2 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
      this$11.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$11 = evidence$16
  };
  if (instrument) {
    $n($n(evidence$16).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("parcelAddress").Lsourcecode_Name__f_value, $n(x1$11).Lfastparse_ParsingRun__f_index, $n(x1$11).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$11).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x4 = $n(x1$11);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("parcelAddress").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$11).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$11).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$11).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x5 = $n(x1$11);
      var self = new $c_Lsourcecode_Name("parcelAddress").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$18 = $n($n(x1$11).Lfastparse_ParsingRun__f_failureStack);
      $$x5.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$18)
    }
  };
  return x1$11
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.parseQuery__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$17) {
  var startIndex = $n(evidence$17).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$17).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$17).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("parseQuery").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$47 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
  var input$macro$56 = $n(evidence$17).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$32 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
  var input$macro$41 = $n(evidence$17).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$17 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$17).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$17).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$().Start__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$17);
  if ((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$17).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$17);
    if (((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$17).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$4 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
      var startPos = $n(evidence$17).Lfastparse_ParsingRun__f_index;
      var startCut = $n(evidence$17).Lfastparse_ParsingRun__f_cut;
      $n(evidence$17).Lfastparse_ParsingRun__f_cut = false;
      $m_Lfastparse_package$();
      this.whitespace__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$17);
      var postSuccess = $n(evidence$17).Lfastparse_ParsingRun__f_isSuccess;
      if (postSuccess) {
        var res = $n(evidence$17).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$17), (void 0)));
        $n(res).Lfastparse_ParsingRun__f_cut = (!(!($n(res).Lfastparse_ParsingRun__f_cut | startCut)))
      } else if ($n(evidence$17).Lfastparse_ParsingRun__f_cut) {
        /*<skip>*/
      } else {
        var res$2 = $n(evidence$17).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos);
        $n(res$2).Lfastparse_ParsingRun__f_cut = (!(!($n(res$2).Lfastparse_ParsingRun__f_cut | startCut)))
      };
      if ($n(evidence$17).Lfastparse_ParsingRun__f_verboseFailures) {
        var msg = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
        var agg = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ((!postSuccess)) {
          $n(evidence$17).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos, new $c_sjsr_AnonFunction0((() => {
            var this$8 = $n(msg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".?")
          })), agg)
        }
      };
      var rhsAggregate$macro$7 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$17
      } else {
        var postRhsIndex$macro$5 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$17).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x1 = $n(evidence$17);
        $n(evidence$17);
        var v = (void 0);
        var res$macro$14 = $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
      };
      if ($n(evidence$17).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$17).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$17).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$18 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$17).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    $n(evidence$17);
    if (((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$17).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$19 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
      var oldCut = $n(evidence$17).Lfastparse_ParsingRun__f_cut;
      $n(evidence$17).Lfastparse_ParsingRun__f_cut = false;
      var startPos$2 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      this.coordinates__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$17);
      var lhsMsg = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
      var lhsAggregate = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
      if ($n(evidence$17).Lfastparse_ParsingRun__f_isSuccess) {
        $n(evidence$17).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$17).Lfastparse_ParsingRun__f_cut | oldCut)))
      } else if ((!$n(evidence$17).Lfastparse_ParsingRun__f_cut)) {
        var verboseFailures = $n(evidence$17).Lfastparse_ParsingRun__f_verboseFailures;
        $n(evidence$17).Lfastparse_ParsingRun__f_index = startPos$2;
        if (verboseFailures) {
          var this$11 = $n(evidence$17);
          this$11.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg, lhsAggregate, false)
        };
        $n(evidence$17).Lfastparse_ParsingRun__f_cut = false;
        this.parcelAddress__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$17);
        var rhsMsg = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
        var rhsCut = $n(evidence$17).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!(rhsCut | oldCut)));
        if (((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
          $n(evidence$17).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
        };
        $n(evidence$17).Lfastparse_ParsingRun__f_cut = endCut;
        if (verboseFailures) {
          var this$12 = $n(evidence$17);
          var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
          var rassoc$3 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
          this$12.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet, msgToAggregate, false)
        }
      };
      var rhsAggregate$macro$22 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$23 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$29 = evidence$17
      } else {
        var postRhsIndex$macro$20 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
        var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
        if ((rhsMadeProgress$macro$25 && $n(evidence$17).checkForDrop__Z())) {
          $n(input$macro$26)
        };
        var $$x2 = $n(evidence$17);
        var v$1 = $as_s_Product($n(evidence$17).Lfastparse_ParsingRun__f_successValue);
        var res$macro$29 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$28)
      };
      if ($n(evidence$17).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$17).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$17).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$33 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$36 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$39 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$33 > preLhsIndex$macro$32) && $n(evidence$17).checkForDrop__Z())) {
      $n(input$macro$41)
    };
    var lhsValue$macro$42 = $n(evidence$17).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$17).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$34 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
      var startPos$3 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
      var startCut$2 = $n(evidence$17).Lfastparse_ParsingRun__f_cut;
      $n(evidence$17).Lfastparse_ParsingRun__f_cut = false;
      $m_Lfastparse_package$();
      this.whitespace__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$17);
      var postSuccess$2 = $n(evidence$17).Lfastparse_ParsingRun__f_isSuccess;
      if (postSuccess$2) {
        var res$4 = $n(evidence$17).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$17), (void 0)));
        $n(res$4).Lfastparse_ParsingRun__f_cut = (!(!($n(res$4).Lfastparse_ParsingRun__f_cut | startCut$2)))
      } else if ($n(evidence$17).Lfastparse_ParsingRun__f_cut) {
        /*<skip>*/
      } else {
        var res$5 = $n(evidence$17).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos$3);
        $n(res$5).Lfastparse_ParsingRun__f_cut = (!(!($n(res$5).Lfastparse_ParsingRun__f_cut | startCut$2)))
      };
      if ($n(evidence$17).Lfastparse_ParsingRun__f_verboseFailures) {
        var msg$2 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
        var agg$2 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ((!postSuccess$2)) {
          $n(evidence$17).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$3, new $c_sjsr_AnonFunction0((() => {
            var this$15 = $n(msg$2);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$15.Lfastparse_internal_Msgs__f_value) + ".?")
          })), agg$2)
        }
      };
      var rhsAggregate$macro$37 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$38 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$44 = evidence$17
      } else {
        var postRhsIndex$macro$35 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$40 = (postRhsIndex$macro$35 > preRhsIndex$macro$34);
        var nextIndex$macro$43 = (((!rhsMadeProgress$macro$40) && $n(input$macro$41).isReachable__I__Z(postRhsIndex$macro$35)) ? postLhsIndex$macro$33 : postRhsIndex$macro$35);
        if ((rhsMadeProgress$macro$40 && $n(evidence$17).checkForDrop__Z())) {
          $n(input$macro$41)
        };
        var $$x3 = $n(evidence$17);
        $n(x1$5);
        var t = $as_s_Product(lhsValue$macro$42);
        $n(evidence$17);
        var res$macro$44 = $n($$x3).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$43)
      };
      if ($n(evidence$17).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$17).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$32, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$39, rhsMsg$macro$38), $n(lhsAggregate$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$37), (preRhsIndex$macro$34 === $n(evidence$17).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$15 = evidence$17
  } else {
    var postLhsIndex$macro$48 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$51 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$54 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$48 > preLhsIndex$macro$47) && $n(evidence$17).checkForDrop__Z())) {
      $n(input$macro$56)
    };
    var lhsValue$macro$57 = $n(evidence$17).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$17).Lfastparse_ParsingRun__f_cut)) {
      var x1$15 = evidence$17
    } else {
      var preRhsIndex$macro$49 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$17);
      var rhsAggregate$macro$52 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$53 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$59 = evidence$17
      } else {
        var postRhsIndex$macro$50 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$55 = (postRhsIndex$macro$50 > preRhsIndex$macro$49);
        var nextIndex$macro$58 = (((!rhsMadeProgress$macro$55) && $n(input$macro$56).isReachable__I__Z(postRhsIndex$macro$50)) ? postLhsIndex$macro$48 : postRhsIndex$macro$50);
        if ((rhsMadeProgress$macro$55 && $n(evidence$17).checkForDrop__Z())) {
          $n(input$macro$56)
        };
        var $$x4 = $n(evidence$17);
        $n(x1$3);
        var t$1 = $as_s_Product(lhsValue$macro$57);
        $n(evidence$17);
        var res$macro$59 = $n($$x4).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$58)
      };
      if ($n(evidence$17).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$17).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$47, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$54, rhsMsg$macro$53), $n(lhsAggregate$macro$51).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$52), (preRhsIndex$macro$49 === $n(evidence$17).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$15 = res$macro$59
    }
  };
  if (instrument) {
    $n($n(evidence$17).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("parseQuery").Lsourcecode_Name__f_value, $n(x1$15).Lfastparse_ParsingRun__f_index, $n(x1$15).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$15).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$15);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("parseQuery").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$15).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$15).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$15).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$15);
      var self = new $c_Lsourcecode_Name("parseQuery").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$25 = $n($n(x1$15).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$25)
    }
  };
  return x1$15
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.apply__T__Lfastparse_Parsed = (function(in$1) {
  var $$x1 = $m_Lfastparse_package$();
  var conv = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    return new $c_Lfastparse_IndexedParserInput(s)
  }));
  return $n($$x1).parse__Lfastparse_ParserInputSource__F1__Z__I__Lfastparse_internal_Instrument__Lfastparse_Parsed(new $c_Lfastparse_ParserInputSource$fromParserInput(in$1, conv), new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13 = $as_Lfastparse_ParsingRun(x$13$2);
    return $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().parseQuery__Lfastparse_ParsingRun__Lfastparse_ParsingRun(x$13)
  })), ($m_Lfastparse_package$(), false), ($m_Lfastparse_package$(), 0), ($m_Lfastparse_package$(), null))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapSearchParser$", {
  Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_MapStyle$__loop$1__I__sjs_js_Array__sci_List__I__sjs_js_Array__sci_List($thiz, position, last, acc, len$1, coords$1) {
  while (true) {
    var index = (position << 1);
    if ((index < len$1)) {
      var until = ((2 + index) | 0);
      var current = coords$1.slice(((index > 0) ? index : 0), ((until > 0) ? until : 0));
      var $$x1 = $moduleDefault($i_ol$002fgeom$002fLineString);
      var a = last;
      var segment = new $$x1([a, current]);
      var label = $thiz.formatLength__Ltypings_ol_geomGeometryMod$default__T(segment);
      var segmentPoint = new ($moduleDefault($i_ol$002fgeom$002fPoint))(segment.getCoordinateAt(0.5));
      var s = $n($thiz.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_segmentStyles).apply__I__O(position);
      s.setGeometry(segmentPoint);
      s.getText().setText(label);
      var temp$position = ((1 + position) | 0);
      var this$11 = $n(acc);
      var temp$acc = new $c_sci_$colon$colon(s, this$11);
      position = temp$position;
      last = current;
      acc = temp$acc
    } else {
      return acc
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$() {
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_fontSize = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_offset = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_segmentStyle = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_segmentStyles = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_labelStyle = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_selectRightStyleDrawing = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_geometryToPoint = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_pointOnTooLargeScale = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_emptyStyle = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_MapStyle$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle = window.getComputedStyle(document.body);
  $m_sc_StringOps$();
  var x = $as_T(this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.fontSize);
  var this$3 = $m_sc_StringParsers$();
  var this$4 = $n((this$3.checkFloatFormat__T__Z(x) ? new $c_s_Some($m_jl_Float$().parseFloat__T__F(x)) : $m_s_None$()));
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_fontSize = $uF((this$4.isEmpty__Z() ? 16.0 : this$4.get__O()));
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_offset = (1.5 * this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_fontSize);
  var $$x5 = $i_ol$002fstyle.Style;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var value = this.defaultTextStyleOptions__F1__Ltypings_ol_styleTextMod$default(this.defaultTextStyleOptions$default$1__F1());
  _\uff3fobj.text = value;
  var $$x2 = $moduleDefault($i_ol$002fstyle$002fStroke);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions);
  var fields$1 = $m_sci_Nil$();
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  _\uff3fobj$1.color = "#ff800080";
  var value$1 = [10.0, 10.0];
  _\uff3fobj$1.lineDash = value$1;
  _\uff3fobj$1.width = 3.0;
  var value$2 = new $$x2(_\uff3fobj$1);
  _\uff3fobj.stroke = value$2;
  var $$x4 = $moduleDefault($i_ol$002fstyle$002fCircle);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CircleStyleOptions);
  var array = [$ct_T2__O__O__(new $c_T2(), "radius", 7.0)];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var _\uff3fobj$2 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  var $$x3 = $moduleDefault($i_ol$002fstyle$002fFill);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
  var fields$3 = $m_sci_Nil$();
  var _\uff3fobj$3 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3);
  _\uff3fobj$3.color = "#ff8000";
  var value$3 = new $$x3(_\uff3fobj$3);
  _\uff3fobj$2.fill = value$3;
  var value$4 = new $$x4(_\uff3fobj$2);
  _\uff3fobj.image = value$4;
  var $$x1 = new $$x5(_\uff3fobj);
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle = $$x1;
  var $$x8 = $i_ol$002fstyle.Style;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
  var fields$4 = $m_sci_Nil$();
  var _\uff3fobj$4 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$4);
  var value$5 = this.defaultTextStyleOptions__F1__Ltypings_ol_styleTextMod$default(this.defaultTextStyleOptions$default$1__F1());
  _\uff3fobj$4.text = value$5;
  var $$x7 = $moduleDefault($i_ol$002fstyle$002fFill);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
  var fields$5 = $m_sci_Nil$();
  var _\uff3fobj$5 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$5);
  var a = [255.0, 255.0, 255.0, 0.8];
  _\uff3fobj$5.color = a;
  var value$6 = new $$x7(_\uff3fobj$5);
  _\uff3fobj$4.fill = value$6;
  var $$x6 = new $$x8(_\uff3fobj$4);
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_segmentStyle = $$x6;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_segmentStyles = new $c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray(16, 1.2, new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().cloneObject__O__O($m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_segmentStyle))));
  var $$x15 = $i_ol$002fstyle.Style;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
  var fields$6 = $m_sci_Nil$();
  var _\uff3fobj$6 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$6);
  var background = $n(this.convertColor__F1()).apply__O__O($as_T(this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.backgroundColor));
  var foreground = $n(this.convertColor__F1()).apply__O__O($as_T(this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.color));
  background[3] = 0.6;
  foreground[3] = 1.0;
  var $$x10 = $moduleDefault($i_ol$002fstyle$002fText);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TextOptions);
  var fields$7 = $m_sci_Nil$();
  var _\uff3fobj$7 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$7);
  var s = new $$x10(_\uff3fobj$7);
  s.setTextBaseline("bottom");
  s.setPadding([2.0, 2.0, 2.0, 2.0]);
  var $$x12 = $moduleDefault($i_ol$002fstyle$002fFill);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
  var fields$8 = $m_sci_Nil$();
  var _\uff3fobj$8 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$8);
  _\uff3fobj$8.color = foreground;
  var $$x11 = new $$x12(_\uff3fobj$8);
  s.setFill($$x11);
  var $$x14 = $moduleDefault($i_ol$002fstyle$002fFill);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
  var fields$9 = $m_sci_Nil$();
  var _\uff3fobj$9 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$9);
  _\uff3fobj$9.color = background;
  var $$x13 = new $$x14(_\uff3fobj$9);
  s.setBackgroundFill($$x13);
  s.setFont((this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_fontSize + "px Calibri,sans-serif"));
  s.setOffsetY($m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_offset);
  _\uff3fobj$6.text = s;
  var $$x9 = new $$x15(_\uff3fobj$6);
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_labelStyle = $$x9;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_selectRightStyleDrawing = new $c_sjsr_AnonFunction1(((x$5$2) => {
    if ((x$5$2 !== null)) {
      var x$1 = x$5$2.getType();
      var y = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.POINT);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y)) {
        var o9 = new $c_s_Some(x$5$2)
      } else {
        var o9 = $m_s_None$()
      };
      if ((!$n(o9).isEmpty__Z())) {
        var geometry = $n(o9).get__O();
        var a$1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().pointStyleDrawing__Ltypings_ol_geomPointMod$default__Ltypings_ol_geomGeometryMod$default__sjs_js_Array(geometry, geometry);
        return a$1
      }
    };
    if ((x$5$2 !== null)) {
      var x$2 = x$5$2.getType();
      var y$1 = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.POLYGON);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)) {
        var o11 = new $c_s_Some(x$5$2)
      } else {
        var o11 = $m_s_None$()
      };
      if ((!$n(o11).isEmpty__Z())) {
        var geometry$2 = $n(o11).get__O();
        var a$2 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().polygonStyleDrawing__Ltypings_ol_geomPolygonMod$default__Ltypings_ol_geomGeometryMod$default__sjs_js_Array(geometry$2, geometry$2);
        return a$2
      }
    };
    if ((x$5$2 !== null)) {
      var x$3 = x$5$2.getType();
      var y$2 = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.MULTI_POLYGON);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y$2)) {
        var o13 = new $c_s_Some(x$5$2)
      } else {
        var o13 = $m_s_None$()
      };
      if ((!$n(o13).isEmpty__Z())) {
        var multi = $n(o13).get__O();
        var a$3 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().polygonStyleDrawing__Ltypings_ol_geomPolygonMod$default__Ltypings_ol_geomGeometryMod$default__sjs_js_Array(multi.getPolygon(0.0), x$5$2);
        return a$3
      }
    }
  }));
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_geometryToPoint = new $c_sjsr_AnonFunction1(((x$6$2) => {
    if ((x$6$2 !== null)) {
      var x$4 = x$6$2.getType();
      var y$3 = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.POINT);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$4, y$3)) {
        var o9$1 = new $c_s_Some(x$6$2)
      } else {
        var o9$1 = $m_s_None$()
      };
      if ((!$n(o9$1).isEmpty__Z())) {
        var geometry$1 = $n(o9$1).get__O();
        return geometry$1
      }
    };
    if ((x$6$2 !== null)) {
      var x$5 = x$6$2.getType();
      var y$4 = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.POLYGON);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$5, y$4)) {
        var o11$1 = new $c_s_Some(x$6$2)
      } else {
        var o11$1 = $m_s_None$()
      };
      if ((!$n(o11$1).isEmpty__Z())) {
        var geometry$2$1 = $n(o11$1).get__O();
        var a$4 = geometry$2$1.getInteriorPoint();
        return a$4
      }
    };
    if ((x$6$2 !== null)) {
      var x$6 = x$6$2.getType();
      var y$5 = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.MULTI_POLYGON);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$6, y$5)) {
        var o13$1 = new $c_s_Some(x$6$2)
      } else {
        var o13$1 = $m_s_None$()
      };
      if ((!$n(o13$1).isEmpty__Z())) {
        var geometry$3 = $n(o13$1).get__O();
        var a$5 = geometry$3.getPolygon(0.0).getInteriorPoint();
        return a$5
      }
    }
  }));
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_pointOnTooLargeScale = new $c_sjsr_AnonFunction1(((geometry$2$2) => {
    var value$7 = $n($m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_geometryToPoint).apply__O__O(geometry$2$2);
    if ((value$7 === (void 0))) {
      return (void 0)
    } else {
      $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle.setGeometry(value$7);
      var a$6 = [$m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle];
      return a$6
    }
  }));
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_emptyStyle = []
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapStyle$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.formatArea__Ltypings_ol_geomGeometryMod$default__T = (function(geom) {
  $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$();
  var area = $uD($i_ol$002fsphere.getArea(geom));
  var $$x1 = $m_sc_StringOps$();
  var x = (100.0 * area);
  var this$7 = $m_RTLong$();
  var value = $uD(Math.round(x));
  var lo = this$7.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var array = [($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi) / 100.0)];
  return $n($$x1).format$extension__T__sci_Seq__T("%.2f m\u00b2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.formatLength__Ltypings_ol_geomGeometryMod$default__T = (function(geom) {
  $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$();
  var len = $uD($i_ol$002fsphere.getLength(geom));
  var $$x1 = $m_sc_StringOps$();
  var x = (1000.0 * len);
  var this$7 = $m_RTLong$();
  var value = $uD(Math.round(x));
  var lo = this$7.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var array = [($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi) / 1000.0)];
  return $n($$x1).format$extension__T__sci_Seq__T("%.3f ml", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.convertColor__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_T(x$2$2);
    var $$x14 = $m_sjs_js_JSConverters$JSRichIterableOnce$();
    $m_sc_ArrayOps$();
    var $$x4 = $m_sc_StringOps$();
    var $$x3 = $m_sc_StringOps$();
    var $$x2 = $m_sc_StringOps$();
    var $$x1 = $m_sc_StringOps$();
    var x = $m_sc_StringOps$().stripPrefix$extension__T__T__T(x$2, "rgb");
    var x$1 = $n($$x1).stripPrefix$extension__T__T__T(x, "a");
    var x$3 = $n($$x2).stripPrefix$extension__T__T__T(x$1, "(");
    var x$4 = $n($$x3).stripSuffix$extension__T__T__T(x$3, ")");
    var xs = $n($$x4).split$extension__T__C__AT(x$4, 44);
    var f = ((x$3$2) => {
      var x$3$1 = $as_T(x$3$2);
      $m_sc_StringOps$();
      return $m_jl_Double$().parseDouble__T__D(x$3$1)
    });
    $m_s_reflect_ManifestFactory$DoubleManifest$();
    var len = $n(xs).u.length;
    var ys = new $ac_D(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $$x5 = i;
          var arg1 = $n(xs).get(i);
          ys.set($$x5, $uD(f(arg1)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_I)) {
        var x3 = $asArrayOf_I(xs, 1);
        while ((i < len)) {
          var $$x6 = i;
          var arg1$1 = $n(x3).get(i);
          ys.set($$x6, $uD(f(arg1$1)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_D)) {
        var x4 = $asArrayOf_D(xs, 1);
        while ((i < len)) {
          var $$x7 = i;
          var arg1$2 = $n(x4).get(i);
          ys.set($$x7, $uD(f(arg1$2)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_J)) {
        var x5 = $asArrayOf_J(xs, 1);
        while ((i < len)) {
          var $$x8 = i;
          var t = $n(x5).get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.set($$x8, $uD(f(new $c_RTLong(lo, hi))));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_F)) {
        var x6 = $asArrayOf_F(xs, 1);
        while ((i < len)) {
          var $$x9 = i;
          var arg1$3 = $n(x6).get(i);
          ys.set($$x9, $uD(f(arg1$3)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_C)) {
        var x7 = $asArrayOf_C(xs, 1);
        while ((i < len)) {
          var $$x10 = i;
          var arg1$4 = $n(x7).get(i);
          ys.set($$x10, $uD(f($bC(arg1$4))));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_B)) {
        var x8 = $asArrayOf_B(xs, 1);
        while ((i < len)) {
          var $$x11 = i;
          var arg1$5 = $n(x8).get(i);
          ys.set($$x11, $uD(f(arg1$5)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_S)) {
        var x9 = $asArrayOf_S(xs, 1);
        while ((i < len)) {
          var $$x12 = i;
          var arg1$6 = $n(x9).get(i);
          ys.set($$x12, $uD(f(arg1$6)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(xs, 1);
        while ((i < len)) {
          var $$x13 = i;
          var arg1$7 = $n(x10).get(i);
          ys.set($$x13, $uD(f(arg1$7)));
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(xs)
      }
    };
    return $n($$x14).toJSArray$extension__sc_IterableOnce__sjs_js_Array($m_s_Predef$().wrapDoubleArray__AD__scm_ArraySeq$ofDouble(ys))
  }))
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.defaultTextStyleOptions__F1__Ltypings_ol_styleTextMod$default = (function(f) {
  var background = $n(this.convertColor__F1()).apply__O__O($as_T(this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.backgroundColor));
  var foreground = $n(this.convertColor__F1()).apply__O__O($as_T(this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_bodyComputedStyle.color));
  background[3] = 0.6;
  foreground[3] = 1.0;
  var $$x1 = $moduleDefault($i_ol$002fstyle$002fText);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TextOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var s = new $$x1(_\uff3fobj);
  s.setTextBaseline("bottom");
  s.setPadding([2.0, 2.0, 2.0, 2.0]);
  var $$x3 = $moduleDefault($i_ol$002fstyle$002fFill);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
  var fields$1 = $m_sci_Nil$();
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  _\uff3fobj$1.color = foreground;
  var $$x2 = new $$x3(_\uff3fobj$1);
  s.setFill($$x2);
  var $$x5 = $moduleDefault($i_ol$002fstyle$002fFill);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
  var fields$2 = $m_sci_Nil$();
  var _\uff3fobj$2 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  _\uff3fobj$2.color = background;
  var $$x4 = new $$x5(_\uff3fobj$2);
  s.setBackgroundFill($$x4);
  s.setFont((this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_fontSize + "px Calibri,sans-serif"));
  $n(f).apply__O__O(s);
  return s
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.defaultTextStyleOptions$default$1__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$4$2) => (void 0)))
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.hidden__Ltypings_ol_styleMod$Style = (function() {
  var $$x2 = $i_ol$002fstyle.Style;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x1 = $moduleDefault($i_ol$002fstyle$002fFill);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
  var fields$1 = $m_sci_Nil$();
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  _\uff3fobj$1.color = "rgba(127,127,127,.2)";
  var value = new $$x1(_\uff3fobj$1);
  _\uff3fobj.fill = value;
  return new $$x2(_\uff3fobj)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.polygonStyleDrawing__Ltypings_ol_geomPolygonMod$default__Ltypings_ol_geomGeometryMod$default__sjs_js_Array = (function(polygon, geometry) {
  var point = polygon.getInteriorPoint();
  var label = this.formatArea__Ltypings_ol_geomGeometryMod$default__T(geometry);
  var coords = polygon.flatCoordinates;
  var len = $uI(coords.length);
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_labelStyle.setGeometry(point);
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_labelStyle.getText().setText(label);
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle.setGeometry(geometry);
  var $$x2 = $m_sjs_js_JSConverters$JSRichIterableOnce$();
  var $$x1 = coords.slice(0, 2);
  $n($m_s_package$().s_package$__f_List);
  var array = [this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle, this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_labelStyle];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var col = $p_Lreactbuild_analyze_cost_modules_mapview_MapStyle$__loop$1__I__sjs_js_Array__sci_List__I__sjs_js_Array__sci_List(this, 1, $$x1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), len, coords);
  return $n($$x2).toJSArray$extension__sc_IterableOnce__sjs_js_Array(col)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.pointStyleDrawing__Ltypings_ol_geomPointMod$default__Ltypings_ol_geomGeometryMod$default__sjs_js_Array = (function(pt, geometry) {
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle.setGeometry(pt);
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle.getText().setText("");
  var value = geometry.get("altitude");
  if ((value !== (void 0))) {
    var v = $uD(value);
    var $$x2 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle.getText();
    var $$x1 = $m_sc_StringOps$();
    var array = [v];
    $$x2.setText($n($$x1).format$extension__T__sci_Seq__T("\u2248 %+.02fm", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  };
  var value$1 = geometry.get("label");
  if ((value$1 !== (void 0))) {
    var v$3 = $as_T(value$1);
    $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle.getText().setText(v$3)
  };
  return [this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_defaultStyle]
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array = (function(feature, resolution, drawing) {
  var f = ((resolution > 1.0) ? this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_pointOnTooLargeScale : this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_selectRightStyleDrawing);
  var value = feature.getGeometry();
  if ((value === (void 0))) {
    var value$2 = (void 0)
  } else {
    var value$1 = $n(f).apply__O__O(value);
    var value$2 = ((value$1 === (void 0)) ? (void 0) : value$1)
  };
  return ((value$2 === (void 0)) ? $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().Lreactbuild_analyze_cost_modules_mapview_MapStyle$__f_emptyStyle : value$2)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapStyle$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapStyle$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapStyle$", {
  Lreactbuild_analyze_cost_modules_mapview_MapStyle$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapStyle$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapStyle$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapStyle$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapStyle$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapStyle$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray(initialSize, growFactor, fillValue) {
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_growFactor = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_fillValue = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_underlying = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_growFactor = growFactor;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_fillValue = fillValue;
  this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_underlying = [];
  this.update__I__I__V(0, initialSize)
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray.prototype.update__I__I__V = (function(from, until) {
  while ((from < until)) {
    this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_underlying[from] = $n(this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_fillValue).apply__O();
    from = ((1 + from) | 0)
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray.prototype.ensureSize__I__V = (function(minIndex) {
  var prevSize = $uI(this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_underlying.length);
  if ((prevSize < ((1 + minIndex) | 0))) {
    var nextSize = $doubleToInt((this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_growFactor * ((1 + minIndex) | 0)));
    this.update__I__I__V(prevSize, nextSize)
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray.prototype.apply__I__O = (function(index) {
  this.ensureSize__I__V(index);
  return this.Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray__f_underlying[index]
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapStyle$AutoGrowableArray", {
  Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapStyle$AutoGrowableArray;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$() {
  this.Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$__f_context = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_React$();
  this.Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$__f_context = $n(this$1.Ljapgolly_scalajs_react_React$__f_Context).apply__T__O__Ljapgolly_scalajs_react_feature_Context("ParcelSelectionContext", null);
  this.Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((ss$2) => {
    var ss = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(ss$2);
    var parcels = $as_sci_List($n(ss).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$5 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var cond = $n(parcels).isEmpty__Z();
    if (cond) {
      var this$6 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
      var $$x33 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
    } else {
      var $$x33 = this$5.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
    };
    var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x31 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$6 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), parcels), new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_analyze_cost_modules_mapview_Parcel(p$2);
      var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x28 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + $n(p).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
      var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x26 = $m_Lcom_iz2use_react_components_Link$();
      var this$17 = $n(ss);
      var callback = new $c_sjsr_AnonFunction0((() => {
        var this$18 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$19 = $n(this$18.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$19.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
      }));
      var this$20 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var G = this$20.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var arg1 = this$17.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var x$1 = $as_sci_List(arg1);
      var this$21 = $n(x$1);
      var f = ((x$2$2) => {
        var x$2 = $as_Lreactbuild_analyze_cost_modules_mapview_Parcel(x$2$2);
        return ($n(x$2).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId === $n(p).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId)
      });
      var l = this$21;
      block: {
        var result;
        while (true) {
          if ($n(l).isEmpty__Z()) {
            var result = $m_sci_Nil$();
            break
          } else {
            var h = $n(l).head__O();
            var t = $as_sci_List($n(l).tail__O());
            if (($uZ(f(h)) === true)) {
              l = t;
              continue
            };
            var start = l;
            var remaining = t;
            while (true) {
              if ($n(remaining).isEmpty__Z()) {
                var result = start;
                break block
              } else {
                var x = $n(remaining).head__O();
                if (($uZ(f(x)) !== true)) {
                  remaining = $as_sci_List($n(remaining).tail__O());
                  continue
                };
                var firstMiss = remaining;
                var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                var toProcess = $as_sci_List($n(start).tail__O());
                var currentLast = newHead;
                while ((toProcess !== firstMiss)) {
                  var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem;
                  currentLast = newElem;
                  toProcess = $as_sci_List($n(toProcess).tail__O())
                };
                var next = $as_sci_List($n(firstMiss).tail__O());
                var nextToCopy = next;
                while ((!$n(next).isEmpty__Z())) {
                  var head = $n(next).head__O();
                  if (($uZ(f(head)) !== true)) {
                    next = $as_sci_List($n(next).tail__O())
                  } else {
                    while ((nextToCopy !== next)) {
                      var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                      $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                      currentLast = newElem$2;
                      nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                    };
                    nextToCopy = $as_sci_List($n(next).tail__O());
                    next = $as_sci_List($n(next).tail__O())
                  }
                };
                if ((!$n(nextToCopy).isEmpty__Z())) {
                  $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                };
                var result = newHead;
                break block
              }
            }
          }
        }
      };
      var $$x25 = $n($$x26).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$17.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(result), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
      var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("-"))];
      var array$1 = [$n($$x25).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
      var $$x24 = $n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(p).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      var $$x22 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var this$40 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
      var $$x20 = this$40.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var $$x19 = $m_sc_StringOps$();
      var array$3 = [$n(p).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_area];
      var v$1 = $n($$x19).format$extension__T__sci_Seq__T("%.0f m\u00b2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$4 = [$$x20, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      var array$5 = [$$x28, $$x24, $$x22, $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
      return $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
    })))];
    var $$x18 = $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$58 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var this$57 = $n(parcels);
    var cond$1 = (!this$57.isEmpty__Z());
    if (cond$1) {
      var this$113 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x15 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("total", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
      var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
      var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Surface totale"))];
      var $$x12 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
      var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var this$73 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
      var $$x10 = this$73.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var $$x9 = $m_sc_StringOps$();
      var this$74 = $n(parcels);
      var acc = 0.0;
      var these = this$74;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$1 = acc;
        var arg2 = $n(these).head__O();
        var acc$1 = $uD(arg1$1);
        var c = $as_Lreactbuild_analyze_cost_modules_mapview_Parcel(arg2);
        acc = (acc$1 + $n(c).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_area);
        these = $as_sc_LinearSeq($n(these).tail__O())
      };
      var array$8 = [acc];
      var v$2 = $n($$x9).format$extension__T__sci_Seq__T("%.0fm\u00b2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$9 = [$$x10, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      var array$10 = [$$x15, $$x14, $$x12, $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))];
      var $$x8 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$94 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
      var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$94.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 2);
      var $$x3 = $m_Lcom_iz2use_react_components_Link$();
      var this$95 = $n(ss);
      var callback$1 = new $c_sjsr_AnonFunction0((() => {
        var this$96 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$97 = $n(this$96.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$97.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
      }));
      var this$98 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var G$1 = this$98.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var arg1$2 = this$95.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      $as_sci_List(arg1$2);
      var arg1$3 = $m_s_package$().s_package$__f_Nil;
      var $$x2 = $n($$x3).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$95.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$3), callback$1, G$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
      var array$11 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Effacer la s\u00e9lection"))];
      var array$12 = [$$x4, $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
      var array$13 = [$$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
      var array$14 = [$$x8, $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
      var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
      var $$x1 = this$113.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
    } else {
      var $$x1 = this$58.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
    };
    var array$15 = [$$x1];
    var array$16 = [$$x31, $$x18, $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tfoot", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
    var array$17 = [$$x33, $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
    return $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$.prototype.withKey__T__Ljapgolly_scalajs_react_vdom_VdomElement = (function(key) {
  var this$11 = $n(this.Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$__f_context);
  var f = new $c_sjsr_AnonFunction1(((context$2) => {
    var context = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(context$2);
    var c = $m_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$().Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$__f_component;
    var this$7 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$7.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(context, this$7.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$9 = $n(u);
    var n = this$9.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$11, f)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.ParcelSelection$", {
  Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$;
var $n_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$;
function $m_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$ = new $c_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.ParsedMapQuery;", depth))
}
function $is_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$CityArea"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.ParsedMapQuery$CityArea;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$() {
  this.Lreactbuild_analyze_cost_modules_mapview_Resolutions$__f_sqrt2 = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_Resolutions$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_Resolutions$__f_sqrt2 = ($m_Lreactbuild_math_package$SquareRoot$(), new $c_Lreactbuild_math_package$LazySquareRoot(2.0))
}
$c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_Resolutions$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_Resolutions$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$.prototype.fromZoom__D__F1__sci_LazyList = (function(start, f) {
  return $n($n($m_s_package$().s_package$__f_LazyList).iterate__F0__F1__sci_LazyList(new $c_sjsr_AnonFunction0((() => start)), new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $uD(x$1$2);
    $m_Lreactbuild_math_package$SquareRoot$();
    var sqrt = $m_Lreactbuild_analyze_cost_modules_mapview_Resolutions$().Lreactbuild_analyze_cost_modules_mapview_Resolutions$__f_sqrt2;
    var this$4 = $n(sqrt);
    var x1 = this$4.Lreactbuild_math_package$LazySquareRoot__f_sq;
    return (x$1 * ((0.0 === x1) ? $m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_zero : ((1.0 === x1) ? $m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_one : ((2.0 === x1) ? $m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_two : this$4.reactbuild$math$LazySquareRoot$$matImpl__D()))))
  })))).takeWhile__F1__sci_LazyList(f)
});
$c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$.prototype.fromRange__D__D__I__sci_LazyList = (function(from, to, resultCount) {
  var a = (to / from);
  var b = (1.0 / resultCount);
  var f = $uD(Math.pow(a, b));
  return ((from < to) ? $n($n($m_s_package$().s_package$__f_LazyList).iterate__F0__F1__sci_LazyList(new $c_sjsr_AnonFunction0((() => from)), new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $uD(x$2$2);
    return (x$2 * f)
  })))).takeWhile__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $uD(x$3$2);
    return (x$3 <= to)
  }))) : $n($n($m_s_package$().s_package$__f_LazyList).iterate__F0__F1__sci_LazyList(new $c_sjsr_AnonFunction0((() => from)), new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $uD(x$4$2);
    return (x$4 * f)
  })))).takeWhile__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $uD(x$5$2);
    return (x$5 >= to)
  }))))
});
$c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$.prototype.fromFactor__D__F1__F1__sci_LazyList = (function(start, f, factor) {
  return $n($n($m_s_package$().s_package$__f_LazyList).iterate__F0__F1__sci_LazyList(new $c_sjsr_AnonFunction0((() => start)), factor)).takeWhile__F1__sci_LazyList(f)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_Resolutions$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_Resolutions$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.Resolutions$", {
  Lreactbuild_analyze_cost_modules_mapview_Resolutions$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_Resolutions$;
var $n_Lreactbuild_analyze_cost_modules_mapview_Resolutions$;
function $m_Lreactbuild_analyze_cost_modules_mapview_Resolutions$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_Resolutions$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_Resolutions$ = new $c_Lreactbuild_analyze_cost_modules_mapview_Resolutions$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_Resolutions$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$() {
  this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_SearchBox$ = this;
  var this$33 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props(props$2);
    var this$31 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("search", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var this$5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
    var $$x6 = this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onSubmit");
    var $$x5 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => {
      $m_Ljapgolly_scalajs_react_package$();
      var this$9 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$9.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty))
    })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Adresse postale ou n\u00b0 de parcelle cadastrale (1 rue de Lyon 75012 ou 1CR2 75016)");
    var state = $n(props).Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_searchOpt;
    var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var ev = $m_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$();
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$14 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$14);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var this$16 = $m_Lcom_iz2use_react_components_ExplainError$();
    var explainError = new $c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1(this$16);
    var equiv = $m_Lreactbuild_analyze_cost_modules_mapview_MapSearch$().equivMapSearch__s_math_Equiv();
    var $$x4 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv);
    var $$x3 = $m_Lcom_iz2use_react_components_Button$().submit__Ljapgolly_scalajs_react_vdom_TagOf();
    var this$18 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignSelf__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$());
    var array = [this$18.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_search, "", "24px")];
    var array$1 = [$$x7, $$x6, $$x5, $$x4, $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var $$x2 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("form", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var x1 = $as_s_Option($n($n(props).Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_searchOpt).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var x = $m_s_None$();
    if ((x === x1)) {
      var $$x1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
    } else {
      if ((!(x1 instanceof $c_s_Some))) {
        throw new $c_s_MatchError(x1)
      };
      var x3 = $as_s_Some(x1);
      var query = $as_Lreactbuild_analyze_cost_modules_mapview_MapSearch($n(x3).s_Some__f_value);
      var u = $m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().apply__Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery__F2__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(query).Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_result, $n(props).Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_f);
      var this$26 = $n(u);
      var n = this$26.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    };
    var array$2 = [$$x2, $$x1];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$31, null, ns)
  }));
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f, s);
  this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$33, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.SearchBox.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_SearchBox$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_SearchBox$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$.prototype.withKey__T__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(key, value, f) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props(value, f);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_SearchBox$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_SearchBox$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.SearchBox$", {
  Lreactbuild_analyze_cost_modules_mapview_SearchBox$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_SearchBox$;
var $n_Lreactbuild_analyze_cost_modules_mapview_SearchBox$;
function $m_Lreactbuild_analyze_cost_modules_mapview_SearchBox$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_SearchBox$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_SearchBox$ = new $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_SearchBox$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$() {
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_Point = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_Feature = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_reuseParsedQuery = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_skeleton = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_Point = $m_Ltypings_geojson_mod$Point$();
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_Feature = $m_Ltypings_geojson_mod$Feature$();
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_reuseParsedQuery = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var $$x1 = $m_Lcom_iz2use_react_components_Skeleton$();
  var array = [$m_Lcom_iz2use_react_components_Skeleton$().link__I__Ljapgolly_scalajs_react_vdom_TagOf(25)];
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_skeleton = $n($$x1).list__I__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var this$35 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction0((() => $m_Ldiode_data_Empty$())), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x5 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var $$x4 = new $c_sjsr_AnonFunction2(((x$2$2, state$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(x$2$2);
    var state = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(state$2);
    return state
  }));
  var $$x3 = new $c_sjsr_AnonFunction2(((x$3$2, state$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(x$3$2);
    var state$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(state$3$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$4$2);
      return state$3
    }))
  }));
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$14 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x5.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x4, $$x3, $$x2, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$11))));
  var deps = new $c_sjsr_AnonFunction3(((props$2, x$5$2, x$6$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(props$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$5$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$6$2);
    return $n(props).Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_parsed
  }));
  var effect = new $c_sjsr_AnonFunction3(((props$3$2, x$7$2, resultList$2) => {
    var props$3 = $as_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(props$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$7$2);
    var resultList = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(resultList$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery(x$8$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().handleInput__Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline($n(props$3).Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_parsed, resultList))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r = this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_reuseParsedQuery;
  var this$13 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$13);
  var this$34 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$14, deps, effect, a, r, step)));
  var f = new $c_sjsr_AnonFunction3(((props$4$2, resultList$3$2, x$9$2) => {
    var props$4 = $as_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(props$4$2);
    var resultList$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(resultList$3$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$9$2);
    var this$32 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x8 = $m_Ldiode_react_ReactPot$potWithReact$();
    var pot = $as_Ldiode_data_Pot($n(resultList$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var $$x7 = $n($$x8).renderPending$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot, new $c_sjsr_AnonFunction1(((x$10$2) => {
      $uI(x$10$2);
      var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x9 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1rem", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var u = $m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_skeleton;
      var this$20 = $n(u);
      var n = this$20.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$1 = [$$x9, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
      return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    })));
    var $$x6 = $m_Ldiode_react_ReactPot$potWithReact$();
    var pot$1 = $as_Ldiode_data_Pot($n(resultList$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var array$2 = [$$x7, $n($$x6).renderReady$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot$1, new $c_sjsr_AnonFunction1(((list$2) => {
      var list = $as_sci_List(list$2);
      var u$1 = $m_Lreactbuild_analyze_cost_components_TouchableList$().apply__sc_Iterable__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(list, $m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().renderItem__Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__F1(props$4));
      var this$27 = $n(u$1);
      var n$1 = this$27.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    })))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$32, null, ns)
  }));
  var this$33 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$33);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$34, f, step$1, s);
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$35, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.SearchResultList.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.getResultItem__Ltypings_geojson_mod$Feature__s_Option = (function(line) {
  var dict = line.properties;
  var this$3 = $n(($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, "label")) ? new $c_s_Some(dict.label) : $m_s_None$()));
  if (this$3.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$3.get__O();
    var label = $as_T(arg1);
    var self = line.geometry.coordinates;
    var $$x1 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, label))
  };
  var this$6 = $n($$x1);
  if (this$6.isEmpty__Z()) {
    var dict$1 = line.properties;
    var this$9 = $n(($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict$1, "nom_com")) ? new $c_s_Some(dict$1.nom_com) : $m_s_None$()));
    if (this$9.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$1 = this$9.get__O();
      var city = $as_T(arg1$1);
      var dict$2 = line.properties;
      var this$12 = $n(($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict$2, "section")) ? new $c_s_Some(dict$2.section) : $m_s_None$()));
      if (this$12.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1$2 = this$12.get__O();
        var section = $as_T(arg1$2);
        var dict$3 = line.properties;
        var this$15 = $n(($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict$3, "feuille")) ? new $c_s_Some(dict$3.feuille) : $m_s_None$()));
        if (this$15.isEmpty__Z()) {
          return $m_s_None$()
        } else {
          var arg1$3 = this$15.get__O();
          var feuille = $uD(arg1$3);
          var dict$4 = line.properties;
          var this$18 = $n(($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict$4, "numero")) ? new $c_s_Some(dict$4.numero) : $m_s_None$()));
          if (this$18.isEmpty__Z()) {
            var $$x2 = $m_s_None$()
          } else {
            var arg1$4 = this$18.get__O();
            var numero = $as_T(arg1$4);
            var coords = line.geometry.coordinates;
            var $$x2 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), numero, coords))
          };
          var this$19 = $n($$x2);
          if (this$19.isEmpty__Z()) {
            return $m_s_None$()
          } else {
            var arg1$5 = this$19.get__O();
            var x$1 = $as_T2(arg1$5);
            if ((x$1 === null)) {
              throw new $c_s_MatchError(x$1)
            };
            var numero$1 = $as_T($n(x$1)._1__O());
            var coords$1 = $n(x$1)._2__O();
            var $$x4 = $m_sjs_js_ArrayOps$();
            var $$x3 = $m_sjs_js_ArrayOps$();
            var array = $m_sjs_js_ArrayOps$().head$extension__sjs_js_Array__O(coords$1);
            var array$1 = $n($$x3).head$extension__sjs_js_Array__O(array);
            var self$1 = $n($$x4).head$extension__sjs_js_Array__O(array$1);
            var y = ((((((city + " feuille ") + feuille) + " section ") + section) + " parcelle ") + numero$1);
            return new $c_s_Some($ct_T2__O__O__(new $c_T2(), self$1, y))
          }
        }
      }
    }
  } else {
    return this$6
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery__F2__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(parsed, f) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(parsed, f);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.searchByCityArea__Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea__s_concurrent_ExecutionContext__s_concurrent_Future = (function(postalArea, ec) {
  if ((postalArea instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode)) {
    var x2 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode(postalArea);
    var postalCode = $n(x2).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode__f_postalCode;
    var query = $ct_T2__O__O__(new $c_T2(), "codePostal", postalCode)
  } else if ((postalArea instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName)) {
    var x3 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName(postalArea);
    var cityName = $n(x3).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName__f_cityName;
    var query = $ct_T2__O__O__(new $c_T2(), "nom", cityName)
  } else {
    var query;
    throw new $c_s_MatchError(postalArea)
  };
  $n($m_s_package$().s_package$__f_List);
  var array = ["nom", "code", "codesPostaux", "codeDepartement"];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$10 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var y = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$10, "", ",", "");
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "fields", y), $ct_T2__O__O__(new $c_T2(), "format", "geojson"), $ct_T2__O__O__(new $c_T2(), "geometry", "centre"), query];
  return this.fetch__T__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future("/api/geo/service/communes", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), ec)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.fetch__T__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future = (function(path, params, ec) {
  var url = new URL(path, $as_T(document.location.href));
  $n(params).foreach__F1__V(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = $as_T($n(x0$1)._1__O());
      var v = $as_T($n(x0$1)._2__O());
      url.searchParams.append(k, v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })));
  var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
  var $$x1 = fetch;
  var a = $dp_toString__T($n(url));
  var p = $$x1(a, (() => {
    var this$2$1 = {};
    var a$1 = $m_Lorg_scalajs_dom_RequestCache$().Lorg_scalajs_dom_RequestCache$__f_force$minuscache;
    this$2$1.cache = a$1;
    var a$2 = $m_Lorg_scalajs_dom_RequestCredentials$().Lorg_scalajs_dom_RequestCredentials$__f_include;
    this$2$1.credentials = a$2;
    return this$2$1
  })());
  return $n($n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((r$2) => {
    var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
    var p$1 = r$2.json();
    return $n($n($$x3).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((json$2) => $n($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
      var array = json$2.features;
      var this$14 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
      $m_sci_List$();
      return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$14)
    })), ec)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((resultList$2) => {
      var resultList = $as_sci_List(resultList$2);
      return resultList
    })), ec))), ec)
  })), ec)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.searchByAddress__T__s_concurrent_ExecutionContext__s_concurrent_Future = (function(in$1, ec) {
  var array = [$ct_T2__O__O__(new $c_T2(), "q", in$1)];
  return this.fetch__T__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future("/api/geo/service/code-address", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ec)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.searchByParcel__T__I__T__I__s_concurrent_ExecutionContext__s_concurrent_Future = (function(cityCode, sheet, division, parcelNumber, ec) {
  var $$x5 = $ct_T2__O__O__(new $c_T2(), "code_insee", cityCode);
  var $$x3 = $m_sc_StringOps$();
  var array = [sheet];
  var y = $n($$x3).format$extension__T__sci_Seq__T("%04d", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "feuille", y);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "section", division);
  var $$x1 = $m_sc_StringOps$();
  var array$1 = [parcelNumber];
  var y$1 = $n($$x1).format$extension__T__sci_Seq__T("%04d", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var array$2 = [$$x5, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), "numero", y$1)];
  return this.fetch__T__sci_Seq__s_concurrent_ExecutionContext__s_concurrent_Future("/api/geo/service/parcelles", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), ec)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.handleInput__Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline = (function(search, resultList) {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$1 = $n(resultList);
  var this$6 = $n($as_Ljapgolly_scalajs_react_StateAccess$ModState(this$1.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
  var mod = new $c_sjsr_AnonFunction1(((x$11$2) => {
    $as_Ldiode_data_Pot(x$11$2);
    var this$5 = $ct_ju_Date__(new $c_ju_Date());
    var t = this$5.ju_Date__f_java$util$Date$$millis;
    var x$1 = new $c_RTLong(t.RTLong__f_lo, t.RTLong__f_hi);
    return new $c_Ldiode_data_Pending(x$1)
  }));
  return $n($$x1).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$6, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$15$2) => {
    $as_jl_Void(x$15$2);
    var $$x8 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
    if ((search instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates)) {
      var x2 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates(search);
      var coords = $n(x2).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates__f_coords;
      var $$x2 = $m_s_concurrent_Future$();
      $n($m_s_package$().s_package$__f_List);
      $n($m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_Feature);
      $n($m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().Lreactbuild_analyze_cost_modules_mapview_SearchResultList$__f_Point);
      var coordinates = [$n(coords)._1$mcD$sp__D(), $n(coords)._2$mcD$sp__D()];
      var array = [$ct_T2__O__O__(new $c_T2(), "coordinates", coordinates)];
      var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
      _\uff3fobj.type = "Point";
      var array$1 = [$ct_T2__O__O__(new $c_T2(), "label", "Coordonn\u00e9es entr\u00e9es")];
      var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      var properties$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
      var array$2 = [$ct_T2__O__O__(new $c_T2(), "geometry", _\uff3fobj), $ct_T2__O__O__(new $c_T2(), "properties", properties$1)];
      var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
      _\uff3fobj$1.type = "Feature";
      var array$3 = [_\uff3fobj$1];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
      var query = $n($$x2).successful__O__s_concurrent_Future($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems))
    } else if ($is_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(search)) {
      var query = $m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().searchByCityArea__Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea__s_concurrent_ExecutionContext__s_concurrent_Future($as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea(search), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
    } else if ((search instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other)) {
      var x4 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other(search);
      var input = $n(x4).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_rawSearch;
      var query = $m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().searchByAddress__T__s_concurrent_ExecutionContext__s_concurrent_Future(input, $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
    } else if ((search instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress)) {
      var x5 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress(search);
      var cityArea = $n(x5).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_cityArea;
      var parcelList = $n(x5).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_parcelList;
      var query = $n($m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().searchByCityArea__Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea__s_concurrent_ExecutionContext__s_concurrent_Future(cityArea, $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((cityCodeResults$2) => {
        var cityCodeResults = $as_sci_List(cityCodeResults$2);
        var $$x7 = $m_s_concurrent_Future$();
        var $$x3 = new $c_sjsr_AnonFunction1(((cityCode$2) => {
          var $$x6 = $m_s_concurrent_Future$();
          var $$x4 = new $c_sjsr_AnonFunction1(((parcel$2) => {
            var parcel = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel(parcel$2);
            var $$x5 = $m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$();
            var dict = cityCode$2.properties;
            return $n($n($$x5).searchByParcel__T__I__T__I__s_concurrent_ExecutionContext__s_concurrent_Future($as_T(new $c_sjs_js_WrappedDictionary(dict).apply__T__O("code")), $n(parcel).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_sheetNumber, $n(parcel).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_division, $uI($n($n(parcel).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_parcelNumbers).head__O()), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((results$2) => {
              var results = $as_sci_List(results$2);
              return results
            })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
          }));
          var this$35 = $m_sc_BuildFrom$();
          return $n($$x6).traverse__sc_IterableOnce__F1__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future(parcelList, $$x4, new $c_sc_BuildFromLowPriority2$$anon$11(this$35), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
        }));
        var this$37 = $m_sc_BuildFrom$();
        return $n($n($$x7).traverse__sc_IterableOnce__F1__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future(cityCodeResults, $$x3, new $c_sc_BuildFromLowPriority2$$anon$11(this$37), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((results$2$1) => {
          var results$1 = $as_sci_List(results$2$1);
          var this$41 = $n(results$1);
          var this$40 = $m_s_$less$colon$less$();
          var toIterableOnce = this$40.s_$less$colon$less$__f_singleton;
          var this$44 = $n($as_sc_StrictOptimizedIterableOps($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$41, toIterableOnce)));
          var this$43 = $m_s_$less$colon$less$();
          var toIterableOnce$1 = this$43.s_$less$colon$less$__f_singleton;
          return $as_sci_List($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$44, toIterableOnce$1))
        })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
    } else {
      var query;
      throw new $c_s_MatchError(search)
    };
    var this$ = $n($$x8).toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $n(query).transform__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((result$2) => {
      var result = $as_s_util_Try(result$2);
      return new $c_s_util_Success(result)
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((r$2) => {
      var r = $as_s_util_Try(r$2);
      var $$x9 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var this$49 = $n(resultList);
      var this$51 = $n($as_Ljapgolly_scalajs_react_StateAccess$ModState(this$49.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var mod$1 = new $c_sjsr_AnonFunction1(((pot$2) => {
        var pot = $as_Ldiode_data_Pot(pot$2);
        return $as_Ldiode_data_Pot($n(r).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((x$12$2) => {
          var x$12 = $as_jl_Throwable(x$12$2);
          return $n(pot).fail__jl_Throwable__Ldiode_data_Pot(x$12)
        })), new $c_sjsr_AnonFunction1(((x$13$2) => {
          var x$13 = $as_sci_List(x$13$2);
          $n(pot);
          return new $c_Ldiode_data_Ready(x$13)
        }))))
      }));
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x9).map$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($f_Ljapgolly_scalajs_react_StateAccess$ModState__modStateAsync__F1__O(this$51, mod$1))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, new $c_sjsr_AnonFunction1(((x$14$2) => {
        $as_jl_Void(x$14$2)
      }))))
    }))));
    var f = new $c_sjsr_AnonFunction1(((response$2) => {
      $as_jl_Void(response$2)
    }));
    var this$53 = $n(this$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$53, f))
  })))
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.renderItem__Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__F1 = (function(props) {
  return new $c_sjsr_AnonFunction1(((line$2) => {
    var r = $m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().getResultItem__Ltypings_geojson_mod$Feature__s_Option(line$2);
    var x = $m_s_None$();
    if ((x === r)) {
      var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Impossible d'afficher ce r\u00e9sultat : ");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $dp_toString__T($n(line$2));
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    };
    if ((r instanceof $c_s_Some)) {
      var x3 = $as_s_Some(r);
      var p4 = $as_T2($n(x3).s_Some__f_value);
      if ((p4 !== null)) {
        var position = $n(p4)._1__O();
        var text = $as_T($n(p4)._2__O());
        var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$1 = [$as_Ljapgolly_scalajs_react_vdom_TagMod($n($n(props).Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_f).apply__O__O__O(position, ("\u00bb " + text)))];
        return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      }
    };
    throw new $c_s_MatchError(r)
  }))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_SearchResultList$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.SearchResultList$", {
  Lreactbuild_analyze_cost_modules_mapview_SearchResultList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$;
var $n_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$;
function $m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$ = new $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.AccumulatingStoreConverter"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.AccumulatingStoreConverter;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$ = this;
  var this$136 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var this$8 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).useDerivedRefBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$2);
    return p
  })), new $c_sjsr_AnonFunction1(((p$3$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$3$2);
    return new $c_sjsr_AnonFunction1(((x$21$2) => {
      $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(x$21$2);
      return p$3
    }))
  })), $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$().Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$__f_reuseProps, new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep())));
  var hook = $m_Lreactbuild_hooks_VideoStreaming$().Lreactbuild_hooks_VideoStreaming$__f_hook;
  var this$5 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$5);
  var this$6 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$();
  var a = this$6.const__O__F1((void 0));
  var this$7 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$7);
  var this$11 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__custom__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__F1__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$8, hook, step, a, d)));
  var hook$1 = new $c_sjsr_AnonFunction3(((x$22$2, x$23$2, stream$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(x$22$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$23$2);
    var stream = $as_Ldiode_data_Pot(stream$2);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$().Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$__f_hook, stream))
  }));
  var this$9 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$9);
  var this$10 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d$1 = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$10);
  var this$15 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__customBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$11, hook$1, step$1, d$1)));
  var hook$2 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$().Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$__f_hook;
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$12);
  var this$13 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$();
  var a$1 = this$13.const__O__F1((void 0));
  var this$14 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d$2 = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$14);
  var this$19 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__custom__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__F1__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$15, hook$2, step$2, a$1, d$2)));
  var hook$3 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$().Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$__f_hook;
  var this$16 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$16);
  var this$17 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$();
  var a$2 = this$17.const__O__F1((void 0));
  var this$18 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d$3 = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$18);
  var this$21 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__custom__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__F1__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$19, hook$3, step$3, a$2, d$3)));
  var initialState = new $c_sjsr_AnonFunction0((() => false));
  var this$20 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(this$20);
  var this$135 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$21, initialState, step$4)));
  var f$5 = new $c_sjsr_AnonFunction7(((p$4$2, x$24$2, streaming$2, capture$2, orientation$2, geolocation$2, pending$2) => {
    var p$4 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$24$2);
    var streaming = $as_Ldiode_data_Pot(streaming$2);
    var capture = $as_Ldiode_data_Pot(capture$2);
    var orientation = $as_s_Option(orientation$2);
    var geolocation = $as_Ldiode_data_Pot(geolocation$2);
    var pending = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(pending$2);
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $m_Ljapgolly_scalajs_react_Reusable$();
    var this$22 = $n(pending);
    var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$22);
    var handler = $n($$x2).flatMap$extension__F1__F1__F1($n($$x1).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$25$2) => {
      $uZ(x$25$2);
      return true
    }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$29$2) => {
      $as_jl_Void(x$29$2);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(geolocation), new $c_sjsr_AnonFunction1(((positionData$2) => {
        var positionData = $as_Ldiode_data_Pot(positionData$2);
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(orientation), new $c_sjsr_AnonFunction1(((orientationData$2) => {
          var orientationData = $as_s_Option(orientationData$2);
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1(new $c_Lreactbuild_hooks_EnhancedPot(capture).toAsyncCallback__F0__F1(new $c_sjsr_AnonFunction0((() => $ct_jl_Exception__T__(new $c_jl_Exception(), "Image Capture not ready")))), new $c_sjsr_AnonFunction1(((imageCapture$2) => {
            var imageCapture = $as_F0(imageCapture$2);
            return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
              var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
              var p$1 = $n(imageCapture).apply__O();
              return $n($$x3).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)
            })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((blob$2) => {
              var $$x10 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
              var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
              $m_Ljapgolly_scalajs_react_Reusable$();
              var $$x8 = $n($n(p$4).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state);
              var $$x7 = $m_ju_UUID$().randomUUID__ju_UUID();
              var this$27 = $n($n(p$4).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state);
              var $$x6 = $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(this$27.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
              var this$28 = $n(positionData);
              var $$x5 = ((!this$28.isEmpty__Z()) ? new $c_s_Some(this$28.get__O()) : $m_s_None$());
              new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
              var $$x4 = $m_Ljava_time_Instant$();
              var this$33 = $m_RTLong$();
              var value = $uD(new Date().getTime());
              var lo = this$33.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
              var r$1 = $n($$x8).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken($$x7, $$x6, $$x5, orientationData, $n($$x4).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, this$33.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)), blob$2)));
              return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x10).flatMap$extension__F1__F1__F1($n($$x9).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$1).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$28$2) => {
                $as_jl_Void(x$28$2);
                var $$x12 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
                var $$x11 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
                $m_Ljapgolly_scalajs_react_Reusable$();
                var this$35 = $n(pending);
                var r$2 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$35);
                return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x12).map$extension__F1__F1__F1($n($$x11).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$2).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$26$2) => {
                  $uZ(x$26$2);
                  return false
                }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$27$2) => {
                  $as_jl_Void(x$27$2)
                }))))
              }))))
            }))))
          }))))
        }))))
      }))))
    })));
    var this$133 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$39 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
    var $$x38 = this$39.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("relative", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var u = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$().apply__Ldiode_data_Pot__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(streaming);
    var this$41 = $n(u);
    var n = this$41.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x37 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var $$x36 = $m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(handler));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x35 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("photo");
    var this$45 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_mapViewControlOverlay;
    var $$x34 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$45, s);
    var $$x33 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("right")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x32 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x31 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("top")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$49 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
    var $$x30 = this$49.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$50 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
    var array = [$$x35, $$x34, $$x33, $$x32, $$x31, $$x30, this$50.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("absolute", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    var array$1 = [$$x38, $$x37, $n($$x36).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var $$x29 = $n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$60 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x27 = this$60.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$63 = $n(orientation);
    var f = new $c_sjsr_AnonFunction1(((x$30$2) => {
      var x$30 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(x$30$2);
      return $n(x$30).headingToNorth__D()
    }));
    var as = $n($n((this$63.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$63.get__O())))).toList__sci_List()).map__F1__sci_List(new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $uD(v$2);
      var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var $$x24 = $m_sc_StringOps$();
      var array$2 = [v];
      var v$1 = $n($$x24).format$extension__T__sci_Seq__T("%+07.2f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      return $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("code", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    })));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var sep = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(", ");
    var this$78 = $m_s_$less$colon$less$();
    var f$1 = this$78.s_$less$colon$less$__f_singleton;
    var array$4 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$1)];
    var array$5 = [$$x27, $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var $$x23 = $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
    var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$3 = $n(streaming).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
    var $$x20 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$4 = $n(capture).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$7 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
    var $$x18 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$111 = $n(orientation);
    var f$4 = new $c_sjsr_AnonFunction1(((x$31$2) => {
      var x$31 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(x$31$2);
      var this$104 = $n(x$31);
      var this$106 = new $c_sr_ScalaRunTime$$anon$1(this$104);
      var f$2 = new $c_sjsr_AnonFunction1(((x$32$2) => $uD(x$32$2)));
      var this$110 = new $c_sc_Iterator$$anon$9(this$106, f$2);
      var f$3 = new $c_sjsr_AnonFunction1(((v$2$1) => {
        var v$5 = $uD(v$2$1);
        var $$x16 = $m_sc_StringOps$();
        var array$8 = [v$5];
        return $n($$x16).format$extension__T__sci_Seq__T("%.2f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
      }));
      return new $c_sc_Iterator$$anon$9(this$110, f$3)
    }));
    var v$6 = $n((this$111.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$4.apply__O__O(this$111.get__O())))).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$9 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$6)];
    var $$x15 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$7 = $n($n(geolocation).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((v$3$2) => {
      var v$3$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(v$3$2);
      var $$x13 = $m_sc_StringOps$();
      var array$10 = [$n(v$3$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_heading, $n(v$3$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_latitude, $n(v$3$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_longitude, $n(v$3$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_accuracy, $n(v$3$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitude, $n(v$3$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitudeAccuracy];
      return $n($$x13).format$extension__T__sci_Seq__T("%.0f\u00b0 %.3f,%.3f +/-%s alt %s +/- %s", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))
    })))).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$11 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)];
    var array$12 = [$$x20, $$x18, $$x15, $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
    var array$13 = [$$x29, $$x23, $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$133, null, ns)
  }));
  var this$134 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$5 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6(this$134);
  var s$1 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$135, f$5, step$5, s$1);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$136, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.CaptureArea.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(childProps) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(childProps, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.CaptureArea$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.CoproductSchemaBuilder"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.CoproductSchemaBuilder;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$.prototype.promiseIDBRequest__Lorg_scalajs_dom_IDBRequest__s_concurrent_Future = (function(request) {
  var promise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  request.onerror = ((arg1$2) => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$().reactbuild$analyze$cost$modules$mapview$interactions$CoproductSchemaBuilder$$$anonfun$promiseIDBRequest$1__Lorg_scalajs_dom_ErrorEvent__s_concurrent_Promise__s_concurrent_Promise(arg1$2, promise));
  request.onsuccess = ((arg1$2$1) => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$().reactbuild$analyze$cost$modules$mapview$interactions$CoproductSchemaBuilder$$$anonfun$promiseIDBRequest$3__Lorg_scalajs_dom_IDBEvent__s_concurrent_Promise__s_concurrent_Promise(arg1$2$1, promise));
  return promise
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$CoproductSchemaBuilder$$$anonfun$promiseIDBRequest$1__Lorg_scalajs_dom_ErrorEvent__s_concurrent_Promise__s_concurrent_Promise = (function(ev, promise$1) {
  var this$1 = $n(promise$1);
  var cause = $ct_jl_Exception__T__(new $c_jl_Exception(), ("Error from IDB Request : " + ev));
  return $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(this$1, cause)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$CoproductSchemaBuilder$$$anonfun$promiseIDBRequest$3__Lorg_scalajs_dom_IDBEvent__s_concurrent_Promise__s_concurrent_Promise = (function(ev, promise$1) {
  var this$1 = $n(promise$1);
  var value = ev.target.result;
  return $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$1, value)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.CoproductSchemaBuilder$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.DataStoreTransaction"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.DataStoreTransaction;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeString = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeBlob = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeInstant = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeString = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeBlob = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeInstant = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6()
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.FieldConverter$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.GetDocuments$Action"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.GetDocuments$Action;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$ = this;
  var this$14 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f = new $c_sjsr_AnonFunction1(((details$2) => {
    var details = $as_sci_List(details$2);
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x2 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $n(details).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1());
    var this$9 = $m_s_$less$colon$less$();
    var array = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$9.s_$less$colon$less$__f_singleton)];
    return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$14, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.GetDocumentsDetails.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$.prototype.apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(details) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(details, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.GetDocumentsDetails$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__installCallback$1__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__F1($thiz, potRef$1) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $m_Ljapgolly_scalajs_react_Reusable$();
  var this$1 = $n(potRef$1);
  var this$2 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$1.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
  var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$2);
  return $n($$x2).flatMap$extension__F1__F1__F1($n($$x1).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_Ldiode_data_Pot(x$11$2);
    return $n(x$11).pending__J__Ldiode_data_Pot($n(x$11).pending$default$1__J())
  }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$15$2) => {
    $as_jl_Void(x$15$2);
    var $$x9 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
    var x = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
      var $$x8 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$();
      var $$x7 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$().Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_DBNAME;
      var $$x6 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$().Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_DBVERSION;
      var this$5 = $m_s_Symbol$();
      var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "Feature"));
      var this$6 = $m_s_Symbol$();
      var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "File")), $m_Lshapeless_HNil$()));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
      var f = new $c_sjsr_AnonFunction1(((p$2) => {
        var p = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData(p$2);
        var $$x5 = $m_Lshapeless_Coproduct$();
        if ((p instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature)) {
          var $$x4 = 0
        } else if ((p instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File)) {
          var $$x4 = 1
        } else {
          var $$x4;
          throw new $c_s_MatchError(p)
        };
        return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
      }));
      var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
        return $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
      }));
      var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
      $m_Lshapeless_ops_coproduct$ZipWithKeys$();
      $m_Lshapeless_ops_coproduct$ZipWithKeys$();
      var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$9 = $m_s_Symbol$();
      var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "File"));
      new $c_Lshapeless_Witness$$anon$1(value0);
      var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
      $m_Lshapeless_Witness$();
      var this$12 = $m_s_Symbol$();
      var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "Feature"));
      new $c_Lshapeless_Witness$$anon$1(value0$1);
      var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
      var this$15 = $m_s_$less$colon$less$();
      var ev = this$15.s_$less$colon$less$__f_singleton;
      new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
      var inst$macro$167 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1().inst$macro$1__Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder();
      var t = new $c_sjsr_AnonFunction0((() => inst$macro$167));
      var decoder = new $c_Lshapeless_Lazy$$anon$1(t);
      return $n($$x8).apply__T__D__Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder__s_concurrent_Future($$x7, $$x6, new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15(decoder))
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x9).flatMap$extension__F1__F1__F1(new $c_Lreactbuild_hooks_EnhancedAsyncCallback(x).onError__F1__F1(new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_jl_Throwable(v$2);
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$21 = $n(potRef$1);
      var this$22 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$21.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$22);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$12$2) => {
        var x$12 = $as_Ldiode_data_Pot(x$12$2);
        return $n(x$12).fail__jl_Throwable__Ldiode_data_Pot(v)
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))), new $c_sjsr_AnonFunction1(((db$2) => {
      var db = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_Database(db$2);
      var $$x11 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x10 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$24 = $n(potRef$1);
      var this$25 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$24.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var r$2 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$25);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x11).map$extension__F1__F1__F1($n($$x10).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$2).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$13$2) => {
        var x$13 = $as_Ldiode_data_Pot(x$13$2);
        $n(x$13);
        return new $c_Ldiode_data_Ready(db)
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$14$2) => {
        $as_jl_Void(x$14$2)
      }))))
    }))))
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_DBNAME = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_DBVERSION = 0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_Context = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_reuseDatabase = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_DBNAME = "reactbuild-pictures";
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_DBVERSION = 2;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var this$2 = $m_Ljapgolly_scalajs_react_React$();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_Context = $n(this$2.Ljapgolly_scalajs_react_React$__f_Context).apply__T__O__Ljapgolly_scalajs_react_feature_Context("LocalData", null);
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_reuseDatabase = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$3.byRef__F2(), this$3.by_$eq$eq__F2());
  var this$27 = $m_Lcom_iz2use_react_hooks_package$();
  var this$8 = $n($n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First());
  var initialState = new $c_sjsr_AnonFunction0((() => $m_Ldiode_data_Empty$()));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$8, initialState, step));
  var $$x5 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x4 = new $c_sjsr_AnonFunction3(((x$3$2, x$4$2, state$2) => {
    $as_jl_Void(x$3$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$4$2));
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    return state
  }));
  var $$x3 = new $c_sjsr_AnonFunction3(((x$5$2, x$6$2, state$3$2) => {
    $as_jl_Void(x$5$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$6$2));
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$3$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$7$2);
      return state$3
    }))
  }));
  var $$x2 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$().reusability__F2__F2(this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_reuseDatabase);
  var this$10 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var this$13 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x5.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x4, $$x3, $$x2, new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$10))));
  var effect = new $c_sjsr_AnonFunction4(((x$8$2, x$9$2, x$10$2, potRef$2) => {
    $as_jl_Void(x$8$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$9$2));
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$10$2);
    var potRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(potRef$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__installCallback$1__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__F1(this, potRef))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$());
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22(this$12);
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$13, effect, a, step$1));
  var $$x6 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x1 = new $c_sjsr_AnonFunction0((() => 0));
  var this$15 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var this$26 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($$x6.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22(this$15))));
  var f = new $c_sjsr_AnonFunction5(((x$16$2, children$2, db$2, x$17$2, mutations$2) => {
    $as_jl_Void(x$16$2);
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var db = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(db$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$17$2);
    var mutations = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(mutations$2);
    var $$x7 = $m_Ldiode_react_ReactPot$potWithReact$();
    var this$16 = $n(db);
    var pot = $as_Ldiode_data_Pot(this$16.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    return $n($$x7).render$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot, new $c_sjsr_AnonFunction1(((db$2$2) => {
      var db$2$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_Database(db$2$2);
      var this$18 = $n($m_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$().Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_Context);
      var value = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(db$2$1, mutations);
      var $$x8 = $n($f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$18, value));
      var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(children))];
      return $n($$x8).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    })))
  }));
  var this$25 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23(this$25);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonC__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner($m_Ljapgolly_scalajs_react_internal_Singleton$().Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit);
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$26, f, step$2, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$27, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.LocalData.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_component;
  var this$5 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var array = [children];
  var children$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$5.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$5.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children$1))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.LocalData$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.LocalData$StoredData"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.LocalData$StoredData;", depth))
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.MapInteraction"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.MapInteraction;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$ = this;
  var this$56 = $m_Lcom_iz2use_react_hooks_package$();
  var this$3 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$().Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_Context;
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$7 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, ctx, step)));
  var initialState = new $c_sjsr_AnonFunction0((() => {
    $n($m_s_package$().s_package$__f_List);
    return $m_sci_Nil$()
  }));
  var this$6 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$6);
  var this$20 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$7, initialState, step$1)));
  var deps = new $c_sjsr_AnonFunction3(((p$2, data$2, x$11$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$2);
    var data = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(data$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$11$2);
    var this$8 = $n($n(p).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state);
    return $ct_T2__O__O__(new $c_T2(), $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(this$8.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken, $n($n(data).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_mutations).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
  }));
  var effect = new $c_sjsr_AnonFunction3(((p$3$2, data$3$2, lst$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$3$2);
    var data$3 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(data$3$2);
    var lst = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(lst$2);
    return new $c_sjsr_AnonFunction1(((x$12$2) => {
      $as_T2(x$12$2);
      var this$16 = $n($n(data$3).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_db);
      var mode = $m_Lorg_scalajs_dom_IDBTransactionMode$().Lorg_scalajs_dom_IDBTransactionMode$__f_readonly;
      var f = new $c_sjsr_AnonFunction1(((tx$2) => {
        var tx = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction(tx$2);
        var r = $n(tx).getAll__s_reflect_ClassTag__s_concurrent_Future(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.getClassOf()));
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => r)), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((results$2) => {
          var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
          var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          $m_Ljapgolly_scalajs_react_Reusable$();
          var this$11 = $n(lst);
          var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$11);
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x2).map$extension__F1__F1__F1($n($$x1).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$13$2) => {
            $as_sci_List(x$13$2);
            var this$14 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), results$2);
            $m_sci_List$();
            return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$14)
          }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$14$2) => {
            $as_jl_Void(x$14$2)
          }))))
        }))))
      }));
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(this$16.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_schema).withTransaction__Lorg_scalajs_dom_IDBTransactionMode__F1__Lorg_scalajs_dom_IDBDatabase__O(mode, f, this$16.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_database))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr)
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$());
  var $$x4 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$().reusablePotUpload__F2__F2($m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$().Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_reusePictureTaken));
  var this$18 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r$2 = $n($$x4).tuple2__F2__F2__F2($$x3, this$18.by_$eq$eq__F2());
  var this$19 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$19);
  var this$55 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$20, deps, effect, a, r$2, step$2)));
  var f$1 = new $c_sjsr_AnonFunction3(((p$4$2, x$15$2, list$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$4$2);
    $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(x$15$2);
    var list = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(list$2);
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Photos en attente d'envoi :"))];
    var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$30 = $n(list);
    var as = $as_sc_IterableOnce(this$30.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    var array$3 = [$$x6, $n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((feature$2) => {
      var feature = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(feature$2);
      var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v = $n(feature).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_instant;
      var this$34 = $m_Lreactbuild_model_Implicits$();
      var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
      var ev = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$34, locale);
      var v$1 = $n(ev).stringify__O__T(v);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" : ");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var o = $n(feature).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_position;
      var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var array$2 = [$$x9, $$x8, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((v$2) => {
        var $$x10 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var as$1 = v$2.getFlatCoordinates();
        return $n($$x10).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), as$1), new $c_sjsr_AnonFunction1(((c$2) => {
          var c = $uD(c$2);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var $$x11 = $m_sc_StringOps$();
          var array$1 = [c];
          var v$3 = $n($$x11).format$extension__T__sci_Seq__T("%.6f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
        })))
      })))];
      return $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    })))];
    return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  }));
  var this$54 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$54);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$55, f$1, step$3, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$56, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.PendingImages.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(childProps) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(childProps, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.PendingImages$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$ = this;
  var this$60 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var this$11 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).useDerivedRefBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$2);
    return p
  })), new $c_sjsr_AnonFunction1(((p$3$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$3$2);
    return new $c_sjsr_AnonFunction1(((x$33$2) => {
      $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(x$33$2);
      return p$3
    }))
  })), $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$().Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$__f_reuseProps, new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep())));
  var hook = new $c_sjsr_AnonFunction2(((p$4$2, x$34$2) => {
    var p$4 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$34$2);
    var $$x2 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$();
    var $$x1 = $n(p$4).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_parentProps;
    $n($m_s_package$().s_package$__f_List);
    var array = [$m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default(), $n($n($n(p$4).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_parentProps).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_hover.getSource()];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($n($$x2).apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__sci_List__Z__F1($$x1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), true))
  }));
  var this$9 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$9);
  var this$10 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$10);
  var this$53 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__customBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$11, hook, step, d)));
  var initialState = new $c_sjsr_AnonFunction3(((x$35$2, pRef$2, snap$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(x$35$2);
    var pRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(pRef$2);
    var $$x8 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$();
    $n($m_s_package$().s_package$__f_List);
    var $$x4 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$().apply__F1__Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).require__F0__F0(new $c_sjsr_AnonFunction0((() => ($as_T(ev$2.type) === $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_MapBrowserEventType.SINGLECLICK))))), new $c_sjsr_AnonFunction1(((x$37$2) => {
      $as_jl_Void(x$37$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
      var f = new $c_sjsr_AnonFunction0((() => {
        var $$x6 = $m_sjs_js_ArrayOps$();
        var $$x5 = $m_sjs_js_ArrayOps$();
        var array$1 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default().getFeaturesAtCoordinate(ev$2.coordinate);
        var array$2 = $n($$x5).map$extension__sjs_js_Array__F1__sjs_js_Array(array$1, new $c_sjsr_AnonFunction1(((feature$2) => {
          var y = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().getData__sjs_js_$bar__O(feature$2);
          return $ct_T2__O__O__(new $c_T2(), feature$2, y)
        })));
        return $n($$x6).collectFirst$extension__sjs_js_Array__s_PartialFunction__s_Option(array$2, new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1())
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      var c = $n($$x7).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f), new $c_sjsr_AnonFunction1(((featureFound$2) => {
        var featureFound = $as_s_Option(featureFound$2);
        matchEnd6$1: {
          var cb;
          if ((featureFound instanceof $c_s_Some)) {
            var x2 = $as_s_Some(featureFound);
            var p3 = $as_T2($n(x2).s_Some__f_value);
            if ((p3 !== null)) {
              var data = $as_Lreactbuild_model_MapFeature$Image($n(p3)._2__O());
              var this$21 = $n(pRef);
              var cb = $n($n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(this$21.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage($m_s_Option$().apply__O__s_Option(data)));
              break matchEnd6$1
            }
          };
          var x = $m_s_None$();
          if ((x === featureFound)) {
            $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections);
            var coordinate = ev$2.coordinate;
            var a = $as_T(ev$2.map.getView().getProjection().getCode());
            var a$1 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj;
            $i_ol$002fproj.transform(coordinate, a, a$1);
            var point = new ($moduleDefault($i_ol$002fgeom$002fPoint))(ev$2.coordinate);
            var this$29 = $n(pRef);
            var cb = $n($n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(this$29.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint($m_s_Option$().apply__O__s_Option(point)));
            break matchEnd6$1
          };
          throw new $c_s_MatchError(featureFound)
        };
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_Reusable$(), $n(cb).value__O()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f$1 = new $c_sjsr_AnonFunction1(((x$36$2) => {
          $as_jl_Void(x$36$2)
        }));
        var this$32 = $n(this$);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$32, f$1))
      })));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    })))))));
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var $$x3 = $i_ol$002finteraction.Draw;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_DrawOptions);
    var type = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.POINT);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    _\uff3fobj.type = type;
    var this$37 = $n(pRef);
    var value = $n($n($n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(this$37.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_parentProps).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_hover.getSource();
    _\uff3fobj.source = value;
    var value$1 = new $c_sjsr_AnonFunction2(((feature$2$1, res$2) => {
      var res = $uD(res$2);
      var a$2 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature$2$1, res, false);
      return a$2
    }));
    var value$2 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$1);
    _\uff3fobj.style = value$2;
    var interaction = new $$x3(_\uff3fobj);
    var array$3 = [$$x4, new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction, true), ($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$(), new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(snap$2, true))];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    return $n($$x8).apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1))
  }));
  var this$52 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$52);
  var this$59 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$53, initialState, step$1)));
  var f$2 = new $c_sjsr_AnonFunction4(((x$38$2, x$39$2, x$40$2, memo$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(x$38$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$39$2);
    var memo = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(memo$2);
    var this$54 = $n(memo);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(this$54.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    var this$56 = $n(u);
    var n = this$56.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$58 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$58);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$9 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$59, f$2, step$2, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$60, ev$9).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.PositionOnMap.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(childProps) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(childProps, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.PositionOnMap$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.StoreConverter"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.StoreConverter;", depth))
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$Action"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$Action;", depth))
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PotUpload"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PotUpload;", depth))
}
function $is_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$Action"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$Action;", depth))
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$__handleInputFile$1__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev, fileState$1) {
  $m_Ljapgolly_scalajs_react_Reusable$();
  var this$1 = $n(fileState$1);
  var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$1);
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$20$2) => {
    $as_sci_List(x$20$2);
    var domList = ev.target.files;
    var this$5 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList);
    $m_sci_List$();
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$5)
  }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$__f_UploadImageColumnStyle = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$__f_UploadImageColumnStyle = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x7 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    var this$8 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$8.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")));
    $n(dsl);
    var this$17 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl);
    $n(dsl);
    var this$ = 100;
    var f$1 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lscalacss_internal_Percentage(x$4$2);
      return $n(x$4).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var v$1 = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$2 = $n(v$1).Lscalacss_internal_ValueT__f_value;
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$17.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$2)));
    $n(dsl);
    var this$19 = $m_Lscalacss_internal_Attrs$alignContent$();
    var $$x3 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$19.Lscalacss_internal_Attrs$alignContent$__f_attr, "stretch")));
    var $$x2 = new $c_sjsr_AnonFunction1(((x$16$2) => {
      var x$16 = $as_T(x$16$2);
      return (x$16 + ">*:last-child")
    }));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1")));
    $n(dsl);
    var this$24 = $m_Lscalacss_internal_Attrs$alignContent$();
    var array = [$$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$24.Lscalacss_internal_Attrs$alignContent$__f_attr, "center")))];
    var array$1 = [$$x6, $$x5, $$x4, $$x3, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(dsl).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x2, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
    return $as_sci_Seq($n($$x7).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })), new $c_Lsourcecode_Name("UploadImageColumnStyle"));
  var this$80 = $m_Lcom_iz2use_react_hooks_package$();
  var this$36 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$().Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$__f_hook;
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$34 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$();
  var a$1 = this$34.const__O__F1((void 0));
  var this$35 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$35);
  var this$40 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__custom__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__F1__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$36, hook, step, a$1, d)));
  var hook$1 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$().Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$__f_hook;
  var this$37 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$37);
  var this$38 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$();
  var a$2 = this$38.const__O__F1((void 0));
  var this$39 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d$1 = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$39);
  var this$42 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__custom__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__F1__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$40, hook$1, step$1, a$2, d$1)));
  var initialState = new $c_sjsr_AnonFunction0((() => $m_s_package$().s_package$__f_Nil));
  var this$41 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$41);
  var this$79 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$42, initialState, step$2)));
  var f$3 = new $c_sjsr_AnonFunction4(((p$2, orientation$2, geolocation$2, fileState$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$2);
    var orientation = $as_s_Option(orientation$2);
    var geolocation = $as_Ldiode_data_Pot(geolocation$2);
    var fileState = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(fileState$2);
    var this$43 = $n(fileState);
    var fileList = $as_sci_List(this$43.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $m_Ljapgolly_scalajs_react_Reusable$();
    var this$44 = $n(fileState);
    var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$44);
    var submit = $n($$x8).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$17$2) => {
      $as_sci_List(x$17$2);
      return $m_s_package$().s_package$__f_Nil
    }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$19$2) => {
      $as_jl_Void(x$19$2);
      var $$x14 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var this$$1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).traverse__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => fileList)), new $c_sjsr_AnonFunction1(((image$2) => {
        var $$x13 = $n(p).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state;
        var $$x12 = $m_ju_UUID$().randomUUID__ju_UUID();
        var this$46 = $n($n(p).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state);
        var $$x11 = $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(this$46.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
        var this$47 = $n(geolocation);
        var $$x10 = ((!this$47.isEmpty__Z()) ? new $c_s_Some(this$47.get__O()) : $m_s_None$());
        new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        var $$x9 = $m_Ljava_time_Instant$();
        var this$52 = $m_RTLong$();
        var value = $uD(new Date().getTime());
        var lo = this$52.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
        var hi = this$52.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($$x13).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken($$x12, $$x11, $$x10, orientation, $n($$x9).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi)), image$2)))).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      })));
      var this$$2 = $n($$x14).toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_CallbackTo$().delayMs$extension__Ljapgolly_scalajs_react_callback_Trampoline__D__F1(this$$1, 1.0));
      var f$2 = new $c_sjsr_AnonFunction1(((x$18$2) => {
        $as_jl_Void(x$18$2)
      }));
      var this$55 = $n(this$$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$55, f$2))
    })));
    var $$x21 = $m_Lreactbuild_components_Form$();
    var $$x20 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(submit);
    var $$x19 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$().Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$__f_UploadImageColumnStyle;
    var this$56 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$());
    var $$x18 = $n(this$56.withType__T__Ljapgolly_scalajs_react_vdom_TagOf("file"));
    var $$x17 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$__handleInputFile$1__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__Ljapgolly_scalajs_react_callback_Trampoline(this, ev$2, fileState)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$59 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "accept");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array$2 = [$$x17, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$59.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "image/*")];
    var $$x16 = $n($$x18).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var $$x15 = $m_Lcom_iz2use_react_components_Button$().submit__Ljapgolly_scalajs_react_vdom_TagOf();
    var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("T\u00e9l\u00e9charger"))];
    var array$4 = [$$x16, $n($$x15).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    var array$5 = [$n($$x19).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var u = $n($$x21).apply__O__sci_Seq__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x20, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
    var this$76 = $n(u);
    var n = this$76.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$78 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$78);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$79, f$3, step$3, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$80, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.UploadImage.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(childProps) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(childProps, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.UploadImage$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$__handleInputFile$1__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev, p$1) {
  var $$x1 = $as_F1(($m_Ljapgolly_scalajs_react_Reusable$(), $n(p$1).value__O()));
  var domList = ev.target.files;
  var this$3 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList);
  $m_sci_List$();
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).apply__O__O($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$3)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$ = this;
  var this$8 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Ljapgolly_scalajs_react_Reusable(p$2);
    var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$());
    var $$x1 = $n(this$3.withType__T__Ljapgolly_scalajs_react_vdom_TagOf("file"));
    var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$__handleInputFile$1__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_callback_Trampoline(this, ev$2, p)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$8, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.Uploader.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$.prototype.apply__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(p) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(p, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.Uploader$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype.apply__T__D__Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder__s_concurrent_Future = (function(databaseName, version, builder) {
  var promise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var value = window.indexedDB;
  var x1 = ((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value));
  var x = $m_s_None$();
  if ((x === x1)) {
    var cause = $ct_jl_Exception__T__(new $c_jl_Exception(), "IndexedDB not found on browser session");
    $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(promise, cause)
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var factory = $n(x3).s_Some__f_value;
    var opening = factory.open(databaseName, version);
    opening.onblocked = ((arg1$2) => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$().reactbuild$analyze$cost$modules$mapview$interactions$WithDatabase$$$anonfun$apply$1__Lorg_scalajs_dom_IDBVersionChangeEvent__s_concurrent_Promise__s_concurrent_Promise(arg1$2, promise));
    opening.onupgradeneeded = ((arg1$2$1) => {
      $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$().reactbuild$analyze$cost$modules$mapview$interactions$WithDatabase$$$anonfun$apply$3__Lorg_scalajs_dom_IDBVersionChangeEvent__Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder__V(arg1$2$1, builder)
    });
    opening.onerror = ((arg1$2$2) => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$().reactbuild$analyze$cost$modules$mapview$interactions$WithDatabase$$$anonfun$apply$5__Lorg_scalajs_dom_ErrorEvent__s_concurrent_Promise__s_concurrent_Promise(arg1$2$2, promise));
    opening.onsuccess = ((arg1$2$3) => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$().reactbuild$analyze$cost$modules$mapview$interactions$WithDatabase$$$anonfun$apply$7__Lorg_scalajs_dom_IDBEvent__s_concurrent_Promise__s_concurrent_Promise(arg1$2$3, promise))
  } else {
    throw new $c_s_MatchError(x1)
  };
  return promise.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((db$2) => new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database(db$2, builder))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$WithDatabase$$$anonfun$apply$1__Lorg_scalajs_dom_IDBVersionChangeEvent__s_concurrent_Promise__s_concurrent_Promise = (function(ev, promise$2) {
  var this$1 = $n(promise$2);
  var cause = $ct_jl_Exception__T__(new $c_jl_Exception(), "IDB database blocked by another session");
  return $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(this$1, cause)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$WithDatabase$$$anonfun$apply$3__Lorg_scalajs_dom_IDBVersionChangeEvent__Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder__V = (function(ev, builder$1) {
  $n(builder$1).upgrade__Lorg_scalajs_dom_IDBDatabase__V(ev.target.result)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$WithDatabase$$$anonfun$apply$5__Lorg_scalajs_dom_ErrorEvent__s_concurrent_Promise__s_concurrent_Promise = (function(ev, promise$2) {
  var this$1 = $n(promise$2);
  var cause = $ct_jl_Exception__T__(new $c_jl_Exception(), ("IDB database error " + $as_T(ev.message)));
  return $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(this$1, cause)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$WithDatabase$$$anonfun$apply$7__Lorg_scalajs_dom_IDBEvent__s_concurrent_Promise__s_concurrent_Promise = (function(ev, promise$2) {
  var this$1 = $n(promise$2);
  var value = ev.target.result;
  return $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$1, value)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.WithDatabase$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_WithDatabase$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$.prototype.apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__sci_List__Z__F1 = (function(parent, additionalSources, defaultSources) {
  return $m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1(this.hook__F1(), new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props(parent, additionalSources, defaultSources))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$.prototype.hook__F1 = (function() {
  var this$8 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => {
    var $$x4 = $moduleDefault($i_ol$002fCollection);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CollectionOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    _\uff3fobj.unique = true;
    return new $$x4([], _\uff3fobj)
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$29 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$8, initialState, step)));
  var effect = new $c_sjsr_AnonFunction2(((props$2, coll$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props(props$2);
    var coll = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(coll$2);
    var this$9 = $n(coll);
    var snapCollection = this$9.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f$3 = new $c_sjsr_AnonFunction0((() => {
      var sources = $n(props).sources__sci_List();
      var push = ((arg1$2) => {
        $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$().reactbuild$analyze$cost$modules$mapview$interactions$WithSnap$$$anonfun$hook$4__Ltypings_ol_sourceVectorMod$VectorSourceEvent__Ltypings_ol_collectionMod$default__V(arg1$2, snapCollection)
      });
      var remove = ((arg1$2$1) => {
        $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$().reactbuild$analyze$cost$modules$mapview$interactions$WithSnap$$$anonfun$hook$5__Ltypings_ol_sourceVectorMod$VectorSourceEvent__Ltypings_ol_collectionMod$default__V(arg1$2$1, snapCollection)
      });
      var this$10 = $n(sources);
      var rest = this$10;
      var h = null;
      var t = null;
      while ((rest !== $m_sci_Nil$())) {
        var arg1 = $n(rest).head__O();
        $n($m_s_package$().s_package$__f_List);
        var array = [arg1.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "addfeature"), push), arg1.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "removefeature"), remove)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        var this$15 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
        var f = ((key$2) => key$2);
        if ((this$15 === $m_sci_Nil$())) {
          var $$x5 = $m_sci_Nil$()
        } else {
          var arg1$1 = this$15.head__O();
          var h$1 = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
          var t$1 = h$1;
          var rest$1 = $as_sci_List(this$15.tail__O());
          while ((rest$1 !== $m_sci_Nil$())) {
            var arg1$3 = $n(rest$1).head__O();
            var nx = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
            $n(t$1).sci_$colon$colon__f_next = nx;
            t$1 = nx;
            rest$1 = $as_sci_List($n(rest$1).tail__O())
          };
          var $$x5 = h$1
        };
        var it = $n($$x5).iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var nx$1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
          if ((t === null)) {
            h = nx$1
          } else {
            $n(t).sci_$colon$colon__f_next = nx$1
          };
          t = nx$1
        };
        rest = $as_sci_List($n(rest).tail__O())
      };
      var keys = ((h === null) ? $m_sci_Nil$() : h);
      var this$16 = $n(sources);
      var these = this$16;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$4 = $n(these).head__O();
        var array$1 = arg1$4.getFeatures();
        var len = $uI(array$1.length);
        var i = 0;
        while ((i < len)) {
          var arg1$5 = array$1[i];
          $uD(snapCollection.push(arg1$5));
          i = ((1 + i) | 0)
        };
        these = $as_sci_List($n(these).tail__O())
      };
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        snapCollection.clear();
        $n($n($n(props).Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature.getSource().clear();
        var this$19 = $n(keys);
        var these$1 = this$19;
        while ((!$n(these$1).isEmpty__Z())) {
          var arg1$6 = $n(these$1).head__O();
          $i_ol$002fObservable.unByKey(arg1$6);
          these$1 = $as_sci_List($n(these$1).tail__O())
        }
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$28 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$28);
  var $$x3 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$29, effect, a, step$1)));
  var $$x1 = new $c_sjsr_AnonFunction2(((x$1$2, coll$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props(x$1$2);
    var coll$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(coll$3$2);
    var $$x2 = $i_ol$002finteraction.Snap;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_SnapOptions);
    var fields$1 = $m_sci_Nil$();
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    var this$33 = $n(coll$3);
    var value = this$33.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    _\uff3fobj$1.features = value;
    return new $$x2(_\uff3fobj$1)
  }));
  var this$36 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x3).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$36))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$WithSnap$$$anonfun$hook$4__Ltypings_ol_sourceVectorMod$VectorSourceEvent__Ltypings_ol_collectionMod$default__V = (function(evt, snapCollection$1) {
  snapCollection$1.push(evt.feature)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$WithSnap$$$anonfun$hook$5__Ltypings_ol_sourceVectorMod$VectorSourceEvent__Ltypings_ol_collectionMod$default__V = (function(evt, snapCollection$1) {
  snapCollection$1.remove(evt.feature)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.WithSnap$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$__f_hook = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$().double__D__F2(0.1);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, initialState, step));
  var $$x7 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x6 = new $c_sjsr_AnonFunction2(((x$1$2, state$2) => {
    $as_jl_Void(x$1$2);
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    return state
  }));
  var $$x5 = new $c_sjsr_AnonFunction2(((x$2$2, state$3$2) => {
    $as_jl_Void(x$2$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$3$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$3$2);
      return state$3
    }))
  }));
  var $$x4 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$();
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$().Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$__f_reuseDeviceOrientationData;
  var $$x3 = $n($$x4).reusability__F2__F2(this$5.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var this$6 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var this$13 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x7.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x6, $$x5, $$x3, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$6))));
  var callback = new $c_sjsr_AnonFunction3(((x$4$2, x$5$2, stateRef$2) => {
    $as_jl_Void(x$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$5$2);
    var stateRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(stateRef$2);
    return new $c_sjsr_AnonFunction1(((e$2) => {
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$7 = $n(stateRef);
      var this$8 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$7.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$8);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$6$2) => {
        $as_s_Option(x$6$2);
        var $$x8 = $m_s_Option$();
        var eulerAngles = $n($m_Lreactbuild_geom_Quaternion$().computeQuaternion__D__D__D__D__Lreactbuild_geom_Quaternion($uD(e$2.alpha), $uD(e$2.beta), $uD(e$2.gamma), 0.0)).toEulerAngles__T3();
        return $n($$x8).apply__O__s_Option(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData($uD($n(eulerAngles).T3__f__1), $uD($n(eulerAngles).T3__f__2), $uD($n(eulerAngles).T3__f__3), $uD(e$2.alpha), $uD(e$2.beta), $uD(e$2.gamma)))
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))
  }));
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var a = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$11, Z);
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$12);
  var this$24 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackBy__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$13, callback, a, step$1)));
  var effect = new $c_sjsr_AnonFunction4(((x$7$2, x$8$2, x$9$2, cb$2) => {
    $as_jl_Void(x$7$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$8$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$9$2);
    var cb = $as_Ljapgolly_scalajs_react_Reusable(cb$2);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f$3 = new $c_sjsr_AnonFunction0((() => {
      var f = new $c_sjsr_AnonFunction1(((x$10$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(cb).value__O())).apply__O__O(x$10$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)));
      var g = new $c_sjsr_AnonFunction1(((x$11$2) => {
        var x$11 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x$11$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$15 = $n(x$11);
        $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$15)
      }));
      var handler = $f_F1__andThen__F1__F1(f, g);
      window.addEventListener("deviceorientation", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(handler));
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        window.removeEventListener("deviceorientation", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(handler))
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
  }));
  var a$1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$23 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44(this$23);
  var $$x2 = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$24, effect, a$1, step$2));
  var $$x1 = new $c_sjsr_AnonFunction4(((x$12$2, v$2, x$13$2, x$14$2) => {
    $as_jl_Void(x$12$2);
    var v = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(v$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$13$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$14$2);
    var this$25 = $n(v);
    return $as_s_Option(this$25.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])
  }));
  var this$26 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$__f_hook = $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44(this$26))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.DeviceOrientation$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientation$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$__f_hook = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$ = this;
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => $m_Ldiode_data_Empty$()));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, initialState, step));
  var $$x6 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x5 = new $c_sjsr_AnonFunction2(((x$1$2, state$2) => {
    $as_jl_Void(x$1$2);
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    return state
  }));
  var $$x4 = new $c_sjsr_AnonFunction2(((x$2$2, state$3$2) => {
    $as_jl_Void(x$2$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$3$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$3$2);
      return state$3
    }))
  }));
  var $$x3 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$().reusability__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().byRef__F2());
  var this$5 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var this$30 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x6.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x5, $$x4, $$x3, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$5))));
  var effect = new $c_sjsr_AnonFunction3(((x$4$2, x$5$2, stateRef$2) => {
    $as_jl_Void(x$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$5$2);
    var stateRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(stateRef$2);
    var options = Object();
    options.enableHighAccuracy = true;
    var handler = new $c_sjsr_AnonFunction1(((e$2) => {
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$6 = $n(stateRef);
      var this$7 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$6.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$7);
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$6$2) => {
        var x$6 = $as_Ldiode_data_Pot(x$6$2);
        $n(x$6);
        var value = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$().from__Lorg_scalajs_dom_Position__Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(e$2);
        return new $c_Ldiode_data_Ready(value)
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$11 = $n(this$);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$11)
    }));
    var error = new $c_sjsr_AnonFunction1(((e$3$2) => {
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$12 = $n(stateRef);
      var this$13 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$12.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$13);
      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$7$2) => {
        var x$7 = $as_Ldiode_data_Pot(x$7$2);
        return $n(x$7).fail__jl_Throwable__Ldiode_data_Pot(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException(e$3$2))
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$16 = $n(this$$1);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$16)
    }));
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f = new $c_sjsr_AnonFunction0((() => {
      window.navigator.geolocation.getCurrentPosition($m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(handler), $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(error), options);
      return $uI(window.navigator.geolocation.watchPosition($m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(handler), $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(error), options))
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var this$$2 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
    var f$3 = new $c_sjsr_AnonFunction1(((watchId$2) => {
      var watchId = $uI(watchId$2);
      var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        window.navigator.geolocation.clearWatch(watchId)
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      var $$x7 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2);
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$22 = $n(stateRef);
      var this$23 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$22.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var r$2 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$23);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x8).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x7, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$2).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$8$2) => {
        var x$8 = $as_Ldiode_data_Pot(x$8$2);
        $n(x$8);
        return $m_Ldiode_data_Unavailable$()
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$2, f$3))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$29 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$29);
  var $$x2 = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$30, effect, a, step$1));
  var $$x1 = new $c_sjsr_AnonFunction3(((x$9$2, state$4$2, x$10$2) => {
    $as_jl_Void(x$9$2);
    var state$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$10$2);
    var this$31 = $n(state$4);
    return $as_Ldiode_data_Pot(this$31.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])
  }));
  var this$32 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$__f_hook = $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$32))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.Geolocation$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_Geolocation$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$__f_reuseMediaStream = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$__f_reuseImageCapture = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$__f_hook = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$__f_reuseMediaStream = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$__f_reuseImageCapture = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var this$4 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => $m_Ldiode_data_Empty$()));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$4, initialState, step));
  var $$x4 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x3 = new $c_sjsr_AnonFunction2(((x$1$2, state$2) => {
    $as_Ldiode_data_Pot(x$1$2);
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    return state
  }));
  var $$x2 = new $c_sjsr_AnonFunction2(((x$2$2, state$3$2) => {
    $as_Ldiode_data_Pot(x$2$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$3$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$3$2);
      return state$3
    }))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$().reusability__F2__F2(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$__f_reuseImageCapture);
  var this$6 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var this$50 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x4.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$6))));
  var deps = new $c_sjsr_AnonFunction3(((p$2, x$4$2, x$5$2) => {
    var p = $as_Ldiode_data_Pot(p$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$5$2);
    var this$7 = $n(p);
    return ((!this$7.isEmpty__Z()) ? new $c_s_Some(this$7.get__O()) : $m_s_None$())
  }));
  var effect = new $c_sjsr_AnonFunction3(((p$3$2, x$6$2, stateRef$2) => {
    var p$3 = $as_Ldiode_data_Pot(p$3$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$6$2);
    var stateRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(stateRef$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      $as_s_Option(x$7$2);
      var $$x6 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$8 = $n(stateRef);
      var this$9 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$8.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$9);
      var cb = $n($$x6).flatMap$extension__F1__F1__F1($n($$x5).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$8$2) => {
        $as_Ldiode_data_Pot(x$8$2);
        return $m_Ldiode_data_Empty$()
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$16$2) => {
        $as_jl_Void(x$16$2);
        var $$x8 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
        if ((p$3 instanceof $c_Ldiode_data_Ready)) {
          var x2 = $as_Ldiode_data_Ready(p$3);
          var value = $n(x2).Ldiode_data_Ready__f_x;
          var $$x7 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(value)
        } else {
          var $$x7 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).throwException__F0__F1(new $c_sjsr_AnonFunction0((() => $ct_jl_Exception__T__(new $c_jl_Exception(), "Not ready"))))
        };
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x8).flatMap$extension__F1__F1__F1($$x7, new $c_sjsr_AnonFunction1(((stream$2) => {
          var $$x10 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
          var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          $m_Ljapgolly_scalajs_react_Reusable$();
          var this$12 = $n(stateRef);
          var this$13 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$12.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
          var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$13);
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x10).flatMap$extension__F1__F1__F1($n($$x9).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$9$2) => {
            var x$9 = $as_Ldiode_data_Pot(x$9$2);
            return $n(x$9).pending__J__Ldiode_data_Pot($n(x$9).pending$default$1__J())
          }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$15$2) => {
            $as_jl_Void(x$15$2);
            var $$x15 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
            var $$x14 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var $$x13 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
            var $$x12 = $uZ(stream$2.active);
            var $$x11 = $m_sjs_js_ArrayOps$();
            var array = stream$2.getVideoTracks();
            var array$1 = [$$x12, $n($$x11).map$extension__sjs_js_Array__F1__sjs_js_Array(array, new $c_sjsr_AnonFunction1(((t$2) => (($uZ(t$2.enabled) + " ") + t$2.readyState))))];
            return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x15).flatMap$extension__F1__F1__F1($n($$x14).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($$x13).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline("Stream state :", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))), new $c_sjsr_AnonFunction1(((x$14$2) => {
              $as_jl_Void(x$14$2);
              var $$x20 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
              var $$x19 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
              var $$x18 = ImageCapture;
              var $$x17 = $m_sjs_js_ArrayOps$();
              var array$2 = stream$2.getVideoTracks();
              var $$x16 = new $$x18($n($$x17).head$extension__sjs_js_Array__O(array$2));
              return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x20).flatMap$extension__F1__F1__F1($n($$x19).pure__O__F1($$x16), new $c_sjsr_AnonFunction1(((imageCapture$2) => {
                var $$x23 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
                var $$x22 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
                var $$x21 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
                var array$3 = [imageCapture$2];
                return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x23).flatMap$extension__F1__F1__F1($n($$x22).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($$x21).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline("image capture is ok", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))), new $c_sjsr_AnonFunction1(((x$13$2) => {
                  $as_jl_Void(x$13$2);
                  return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
                    var $$x24 = $m_sjs_js_Thenable$ThenableOps$();
                    var p$1 = imageCapture$2.getPhotoCapabilities();
                    return $n($$x24).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)
                  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((capabilities$2) => {
                    var $$x26 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
                    console.log("capabilities :", capabilities$2);
                    if ((($uD(capabilities$2.imageWidth.max) === 0.0) || ($uD(capabilities$2.imageHeight.max) === 0.0))) {
                      var $$x25 = true
                    } else {
                      var v = imageCapture$2.setOptions;
                      var $$x25 = (v === (void 0))
                    };
                    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x26).flatMap$extension__F1__F1__F1(($$x25 ? $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1((void 0)) : $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(imageCapture$2.setOptions((() => {
                      var capabilities$1 = null;
                      capabilities$1 = capabilities$2;
                      var this$28 = {};
                      var a = $uD(capabilities$1.imageWidth.max);
                      var a$1 = $uD(Math.min(a, 1920.0));
                      this$28.imageWidth = a$1;
                      var a$2 = $uD(capabilities$1.imageHeight.max);
                      var a$3 = $uD(Math.min(a$2, 1080.0));
                      this$28.imageHeight = a$3;
                      return this$28
                    })()))), new $c_sjsr_AnonFunction1(((x$12$2) => {
                      var $$x28 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
                      var $$x27 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
                      $m_Ljapgolly_scalajs_react_Reusable$();
                      var this$37 = $n(stateRef);
                      var this$38 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$37.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
                      var r$2 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$38);
                      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x28).map$extension__F1__F1__F1($n($$x27).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$2).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$10$2) => {
                        $as_Ldiode_data_Pot(x$10$2);
                        return $n(p$3).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((stream$2$1) => imageCapture$2)))
                      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$11$2) => {
                        $as_jl_Void(x$11$2)
                      }))))
                    }))))
                  }))))
                }))))
              }))))
            }))))
          }))))
        }))))
      })));
      var $$x31 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x30 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x29 = new $c_Lreactbuild_hooks_EnhancedAsyncCallback(cb).onError__F1__F1(new $c_sjsr_AnonFunction1(((t$2$1) => {
        var t = $as_jl_Throwable(t$2$1);
        $m_Ljapgolly_scalajs_react_Reusable$();
        var this$41 = $n(stateRef);
        var this$42 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$41.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
        var r$3 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$42);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$3).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$17$2) => {
          var x$17 = $as_Ldiode_data_Pot(x$17$2);
          return $n(x$17).fail__jl_Throwable__Ldiode_data_Pot(t)
        }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      })));
      var array$4 = [p$3];
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x31).toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($$x30).logAround$extension__F1__O__sci_Seq__F1($$x29, "ImageCapture", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))))
    }))
  }));
  var a$4 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$48 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$__f_reuseMediaStream;
  var r$4 = this$48.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3);
  var this$49 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$49);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$__f_hook = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$50, deps, effect, a$4, r$4, step$1))).buildReturning__F1__F1(new $c_sjsr_AnonFunction1(((x$18$2) => {
    var x$18 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I2(x$18$2);
    var this$51 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF($n(x$18).Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1));
    return $n($as_Ldiode_data_Pot(this$51.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((imageCapture$2$1) => new $c_sjsr_AnonFunction0((() => imageCapture$2$1.takePhoto())))))
  })))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.ImageCapture$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_ImageCapture$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_accelerometer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_gyroscope = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_magnetometer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_permissionsToRequest = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$ = this;
  var name = new $c_Lsourcecode_Name("accelerometer");
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_accelerometer = name.Lsourcecode_Name__f_value;
  var name$1 = new $c_Lsourcecode_Name("gyroscope");
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_gyroscope = name$1.Lsourcecode_Name__f_value;
  var name$2 = new $c_Lsourcecode_Name("magnetometer");
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_magnetometer = name$2.Lsourcecode_Name__f_value;
  $n($m_s_package$().s_package$__f_List);
  var array = [this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_accelerometer, this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_gyroscope, this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_magnetometer];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_permissionsToRequest = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$31 = $m_Lcom_iz2use_react_hooks_package$();
  var this$11 = $n($n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First());
  var initialState = new $c_sjsr_AnonFunction0((() => false));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep();
  var this$17 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$11, initialState, step)));
  var effect = new $c_sjsr_AnonFunction3(((p$2, x$1$2, state$2) => {
    $as_jl_Void(p$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$1$2));
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    var cb = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$().requestPermission__s_concurrent_Future())), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((x$4$2) => {
      $as_sci_List(x$4$2);
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$13 = $n(state);
      var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$13);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x2).map$extension__F1__F1__F1($n($$x1).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
        $uZ(x$2$2);
        return true
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$3$2) => {
        $as_jl_Void(x$3$2)
      }))))
    })));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(cb))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$16 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$16);
  var this$30 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$17, effect, a, step$1)));
  var f = new $c_sjsr_AnonFunction3(((x$5$2, children$2, state$3$2) => {
    $as_jl_Void(x$5$2);
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$3$2);
    var this$18 = $n(state$3);
    if ($uZ(this$18.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])) {
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(children)
    } else {
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Veuillez autoriser l'application \u00e0 utiliser les capteurs de votre appareil pour les photos."))];
      return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    }
  }));
  var this$29 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$29);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonC__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner($m_Ljapgolly_scalajs_react_internal_Singleton$().Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit);
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$30, f, step$2, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$31, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.takepicture.RequestPermissions.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$.prototype.requestPermission__s_concurrent_Future = (function() {
  var $$x4 = $m_s_concurrent_Future$();
  var $$x3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_permissionsToRequest;
  var $$x1 = new $c_sjsr_AnonFunction1(((permission$2) => {
    var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
    var p = window.navigator.permissions.query((() => {
      var permission$1 = null;
      permission$1 = permission$2;
      var this$2 = {};
      this$2.name = null;
      this$2.name = permission$1;
      return this$2
    })());
    return $n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
  }));
  var this$4 = $m_sc_BuildFrom$();
  return $n($$x4).traverse__sc_IterableOnce__F1__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future($$x3, $$x1, new $c_sc_BuildFromLowPriority2$$anon$11(this$4), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.RequestPermissions$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$__f_reuseMediaStream = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$__f_reuseMediaStream = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var this$46 = $m_Lcom_iz2use_react_hooks_package$();
  var this$4 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var evidence$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_scalajs_dom_HTMLVideoElement.getClassOf());
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$35 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefToVdom__s_reflect_ClassTag__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$4, evidence$1, step)));
  var deps = new $c_sjsr_AnonFunction2(((streaming$2, x$9$2) => {
    var streaming = $as_Ldiode_data_Pot(streaming$2);
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$9$2);
    var this$6 = $n(streaming);
    return ((!this$6.isEmpty__Z()) ? new $c_s_Some(this$6.get__O()) : $m_s_None$())
  }));
  var effect = new $c_sjsr_AnonFunction2(((streaming$3$2, videoRef$2) => {
    var streaming$3 = $as_Ldiode_data_Pot(streaming$3$2);
    var videoRef = $as_Ljapgolly_scalajs_react_Ref$FullF(videoRef$2);
    return new $c_sjsr_AnonFunction1(((x$10$2) => {
      $as_s_Option(x$10$2);
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(videoRef).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$7 = $m_s_$less$colon$less$();
      var cb = $n($$x3).flatMap$extension__F0__F1__F0($n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$7.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((ref$2) => {
        var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
        var f = new $c_sjsr_AnonFunction0((() => ((arg1$2) => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$().reactbuild$analyze$cost$modules$mapview$interactions$takepicture$VideoPart$$$anonfun$component$23__Lorg_scalajs_dom_Event__Lorg_scalajs_dom_HTMLVideoElement__sjs_js_$bar(arg1$2, ref$2))));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x5).flatMap$extension__F0__F1__F0($n($$x4).toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)), new $c_sjsr_AnonFunction1(((handler$2) => {
          var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f$2 = new $c_sjsr_AnonFunction0((() => {
            ref$2.addEventListener("loadeddata", handler$2);
            var this$15 = $n(streaming$3);
            var f$1 = new $c_sjsr_AnonFunction1(((v$2) => {
              ref$2.srcObject = v$2
            }));
            if ((!this$15.isEmpty__Z())) {
              f$1.apply__O__O(this$15.get__O())
            }
          }));
          var f$3 = new $c_sjsr_AnonFunction0((() => {
            f$2.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x7).map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($n($$x6).toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3)), new $c_sjsr_AnonFunction1(((x$11$2) => {
            $as_jl_Void(x$11$2);
            var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
            var f$4 = new $c_sjsr_AnonFunction0((() => {
              ref$2.pause();
              ref$2.removeEventListener("loadeddata", handler$2);
              ref$2.srcObject = (void 0)
            }));
            var f$5 = new $c_sjsr_AnonFunction0((() => {
              f$4.apply__O()
            }));
            $m_Ljapgolly_scalajs_react_callback_Trampoline$();
            var $$x8 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$5);
            var array = [streaming$3];
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x9).logAround$extension__Ljapgolly_scalajs_react_callback_Trampoline__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline($$x8, "clean <video>", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
          })), null))
        }))))
      })));
      var $$x11 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      var $$x10 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(cb);
      var array$1 = [streaming$3];
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x11).logAround$extension__Ljapgolly_scalajs_react_callback_Trampoline__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline($$x10, "install <video>", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().optionalCallback__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_OptionLike__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance);
  var this$33 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$__f_reuseMediaStream;
  var r = this$33.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3);
  var this$34 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$34);
  var this$45 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$35, deps, effect, a, r, step$1)));
  var f$6 = new $c_sjsr_AnonFunction2(((x$12$2, videoRef$3$2) => {
    $as_Ldiode_data_Pot(x$12$2);
    var videoRef$3 = $as_Ljapgolly_scalajs_react_Ref$FullF(videoRef$3$2);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var t = "video";
    var $$x12 = $n($ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(new $c_Ljapgolly_scalajs_react_vdom_TagOf(), t, $m_s_package$().s_package$__f_Nil).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(videoRef$3)));
    var array$2 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    return $n($$x12).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  }));
  var this$44 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$44);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$4 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$45, f$6, step$2, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$46, ev$4).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.takepicture.VideoPart.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$.prototype.apply__Ldiode_data_Pot__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(streaming) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(streaming, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$takepicture$VideoPart$$$anonfun$component$23__Lorg_scalajs_dom_Event__Lorg_scalajs_dom_HTMLVideoElement__sjs_js_$bar = (function(e, ref$1) {
  return ref$1.play()
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.VideoPart$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_VideoPart$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$ = this;
  var this$16 = $m_Lcom_iz2use_react_hooks_package$();
  var this$3 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context;
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$14 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, ctx, step)));
  var deps = new $c_sjsr_AnonFunction2(((props$2, mapCtx$2) => {
    var mapCtx = $as_s_Option(mapCtx$2);
    return $ct_T2__O__O__(new $c_T2(), props$2, mapCtx)
  }));
  var effect = new $c_sjsr_AnonFunction2(((props$3$2, mapCtx$3$2) => {
    var mapCtx$3 = $as_s_Option(mapCtx$3$2);
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      $as_T2(x$1$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => mapCtx$3)), new $c_sjsr_AnonFunction1(((map$2) => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
        var f$2 = new $c_sjsr_AnonFunction0((() => {
          map$2.addControl(props$3$2);
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f = new $c_sjsr_AnonFunction0((() => map$2.removeControl(props$3$2)));
          var f$1 = new $c_sjsr_AnonFunction0((() => {
            f.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
      }))))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().optionalCallback__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_OptionLike__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance);
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseControl;
  var this$12 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableMap;
  var r = $n($$x2).tuple2__F2__F2__F2($$x1, this$12.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var this$13 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$13);
  var ev = $n($as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$14, deps, effect, a, r, step$1))).render__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$2$2) => {
    $as_Ljapgolly_scalajs_react_hooks_HookCtx$P1(x$2$2);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(null)
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)));
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$16, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.openlayers.Control.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$.prototype.apply__Ltypings_ol_controlControlMod$default__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(control) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$__f_component;
  var $$x1 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Util);
  var a = $as_T($i_ol$002futil.getUid(control));
  var this$7 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x1).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$7.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(control, this$7.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Control$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$__modGeolocation$1__F1__Ltypings_ol_geolocationMod$default__Ltypings_ol_layerVectorMod$default__V($thiz, f, geolocation$1, geolocationLayer$1) {
  var nextState = $uZ($n(f).apply__O__O($uZ(geolocation$1.getTracking())));
  geolocationLayer$1.setVisible(nextState);
  geolocation$1.setTracking(nextState)
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$__f_hook = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$ = this;
  var this$96 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => {
    var fields = $m_sci_Nil$();
    var opts = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    opts.enableHighAccuracy = true;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeolocationOptions);
    var fields$1 = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    _\uff3fobj.trackingOptions = opts;
    var accuraryFeature = new ($moduleDefault($i_ol$002fFeature))();
    var positionFeature = new ($moduleDefault($i_ol$002fFeature))();
    var $$x5 = $moduleDefault($i_ol$002fstyle$002fCircle);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CircleStyleOptions);
    var array = [$ct_T2__O__O__(new $c_T2(), "radius", 6.0)];
    var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
    var $$x3 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$3 = $m_sci_Nil$();
    var _\uff3fobj$2 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3);
    _\uff3fobj$2.color = "#3399CC";
    var value = new $$x3(_\uff3fobj$2);
    _\uff3fobj$1.fill = value;
    var $$x4 = $moduleDefault($i_ol$002fstyle$002fStroke);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions);
    var fields$4 = $m_sci_Nil$();
    var _\uff3fobj$3 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$4);
    _\uff3fobj$3.width = 2.0;
    _\uff3fobj$3.color = "#fff";
    var value$1 = new $$x4(_\uff3fobj$3);
    _\uff3fobj$1.stroke = value$1;
    var circleStyle = new $$x5(_\uff3fobj$1);
    var $$x6 = $i_ol$002fstyle.Style;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
    var fields$5 = $m_sci_Nil$();
    var _\uff3fobj$4 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$5);
    _\uff3fobj$4.image = circleStyle;
    var a = new $$x6(_\uff3fobj$4);
    positionFeature.setStyle(a);
    var $$x8 = $i_ol$002fstyle.Style;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
    var fields$6 = $m_sci_Nil$();
    var _\uff3fobj$5 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$6);
    var $$x7 = $moduleDefault($i_ol$002fstyle$002fStroke);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions);
    var fields$7 = $m_sci_Nil$();
    var _\uff3fobj$6 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$7);
    _\uff3fobj$6.color = "#3399CC";
    var value$2 = new $$x7(_\uff3fobj$6);
    _\uff3fobj$5.stroke = value$2;
    var accuracyStyle = new $$x8(_\uff3fobj$5);
    accuraryFeature.setStyle(accuracyStyle);
    var geolocation = new ($moduleDefault($i_ol$002fGeolocation))(_\uff3fobj);
    geolocation.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "change:position"), ((arg1$2) => {
      $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$().reactbuild$analyze$cost$modules$mapview$openlayers$Geolocation$$$anonfun$hook$2__Ltypings_ol_objectMod$ObjectEvent__Ltypings_ol_geolocationMod$default__Ltypings_ol_featureMod$default__V(arg1$2, geolocation, positionFeature)
    }));
    geolocation.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "change:accuracyGeometry"), ((arg1$2$1) => {
      $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$().reactbuild$analyze$cost$modules$mapview$openlayers$Geolocation$$$anonfun$hook$4__Ltypings_ol_objectMod$ObjectEvent__Ltypings_ol_featureMod$default__Ltypings_ol_geolocationMod$default__V(arg1$2$1, accuraryFeature, geolocation)
    }));
    var geolocationFeatures = [accuraryFeature, positionFeature];
    $m_sjs_js_ArrayOps$().foreach$extension__sjs_js_Array__F1__V(geolocationFeatures, new $c_sjsr_AnonFunction1(((f$2) => {
      f$2.set("geolocId", true)
    })));
    var geolocationLayerSource = new ($moduleDefault($i_ol$002fsource$002fVector))();
    geolocationLayerSource.addFeatures(geolocationFeatures);
    var $$x9 = $moduleDefault($i_ol$002flayer$002fVector);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions);
    var fields$8 = $m_sci_Nil$();
    var _\uff3fobj$7 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$8);
    _\uff3fobj$7.source = geolocationLayerSource;
    var geolocationLayer = new $$x9(_\uff3fobj$7);
    $m_Ljapgolly_scalajs_react_package$();
    var n = document.createElement("button");
    n.onclick = ((arg1$2$2) => {
      $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$().reactbuild$analyze$cost$modules$mapview$openlayers$Geolocation$$$anonfun$hook$6__Lorg_scalajs_dom_MouseEvent__Ltypings_ol_geolocationMod$default__Ltypings_ol_layerVectorMod$default__V(arg1$2$2, geolocation, geolocationLayer)
    });
    $m_Ljapgolly_scalajs_react_package$();
    var n$1 = document.createElement("div");
    n$1.className = "ol-unselectable ol-control";
    n$1.style.top = "4.5em";
    n$1.style.left = ".5em";
    n$1.appendChild(n);
    var $$x10 = $i_ol$002fcontrol.Control;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ControlOptions);
    var fields$9 = $m_sci_Nil$();
    var _\uff3fobj$8 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$9);
    _\uff3fobj$8.element = n$1;
    var geolocationButton = new $$x10(_\uff3fobj$8);
    console.log(geolocation, geolocationLayer);
    var $$x11 = $m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Util);
    var a$1 = $as_T($i_ol$002futil.getUid(geolocationButton));
    var u = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Control$().apply__Ltypings_ol_controlControlMod$default__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(geolocationButton);
    var this$90 = $n(u);
    var n$2 = this$90.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
    return $ct_T2__O__O__(new $c_T2(), geolocation, new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result(geolocationLayer, $n($$x11).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a$1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)), new $c_sjsr_AnonFunction1(((f$3$2) => {
      var f$3 = $as_F1(f$3$2);
      $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$__modGeolocation$1__F1__Ltypings_ol_geolocationMod$default__Ltypings_ol_layerVectorMod$default__V(this, f$3, geolocation, geolocationLayer)
    }))))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$98 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$96, initialState, step)));
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context;
  var this$97 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$97);
  var this$109 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$98, ctx, step$1)));
  var deps = new $c_sjsr_AnonFunction3(((props$2, state$2, mapCtx$2) => {
    var props = $as_jl_Void(props$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    var mapCtx = $as_s_Option(mapCtx$2);
    return $ct_T2__O__O__(new $c_T2(), props, mapCtx)
  }));
  var effect = new $c_sjsr_AnonFunction3(((props$3$2, state$3$2, mapCtx$3$2) => {
    $as_jl_Void(props$3$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$3$2);
    var mapCtx$3 = $as_s_Option(mapCtx$3$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_T2(x$5$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => mapCtx$3)), new $c_sjsr_AnonFunction1(((map$2) => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
        var f = new $c_sjsr_AnonFunction0((() => {
          var this$99 = $n(state$3);
          var $$x12 = $n($as_T2(this$99.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]))._1__O();
          var a$2 = map$2.getView().getProjection();
          $$x12.setProjection(a$2)
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f))
      }))))
    }))
  }));
  var a$3 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var $$x14 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$106 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x13 = this$106.always__F2();
  var this$107 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableMap;
  var r = $n($$x14).tuple2__F2__F2__F2($$x13, this$107.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var this$108 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$108);
  var $$x2 = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$109, deps, effect, a$3, r, step$2));
  var $$x1 = new $c_sjsr_AnonFunction3(((x$6$2, state$4$2, x$7$2) => {
    $as_jl_Void(x$6$2);
    var state$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$4$2);
    $as_s_Option(x$7$2);
    var this$110 = $n(state$4);
    return $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result($n($as_T2(this$110.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]))._2__O())
  }));
  var this$111 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$__f_hook = $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$111));
  var this$119 = $m_Lcom_iz2use_react_hooks_package$();
  var this$116 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$__f_hook;
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$114 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$();
  var a$4 = this$114.const__O__F1((void 0));
  var this$115 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$115);
  var this$118 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__custom__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__F1__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$116, hook, step$3, a$4, d)));
  var f$1 = new $c_sjsr_AnonFunction2(((p$2, geolocation$2) => {
    var p = $as_F1(p$2);
    var geolocation$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result(geolocation$2);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(p).apply__O__O(geolocation$1))
  }));
  var this$117 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$117);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$22 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$118, f$1, step$4, s);
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$119, ev$22).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.openlayers.Geolocation.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$.prototype.apply__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(f) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(f, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$.prototype.reactbuild$analyze$cost$modules$mapview$openlayers$Geolocation$$$anonfun$hook$2__Ltypings_ol_objectMod$ObjectEvent__Ltypings_ol_geolocationMod$default__Ltypings_ol_featureMod$default__V = (function(x$1, geolocation$1, positionFeature$1) {
  var value = geolocation$1.getPosition();
  if ((value !== (void 0))) {
    positionFeature$1.setGeometry(new ($moduleDefault($i_ol$002fgeom$002fPoint))(value))
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$.prototype.reactbuild$analyze$cost$modules$mapview$openlayers$Geolocation$$$anonfun$hook$4__Ltypings_ol_objectMod$ObjectEvent__Ltypings_ol_featureMod$default__Ltypings_ol_geolocationMod$default__V = (function(x$2, accuraryFeature$1, geolocation$1) {
  accuraryFeature$1.setGeometry(geolocation$1.getAccuracyGeometry())
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$.prototype.reactbuild$analyze$cost$modules$mapview$openlayers$Geolocation$$$anonfun$hook$6__Lorg_scalajs_dom_MouseEvent__Ltypings_ol_geolocationMod$default__Ltypings_ol_layerVectorMod$default__V = (function(x$3, geolocation$1, geolocationLayer$1) {
  var arg1 = $uZ(geolocation$1.getTracking());
  var nextState = (!arg1);
  geolocationLayer$1.setVisible(nextState);
  geolocation$1.setTracking(nextState)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Geolocation$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ = this;
  var this$20 = $m_Lcom_iz2use_react_hooks_package$();
  var this$3 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context;
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$18 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, ctx, step)));
  var deps = new $c_sjsr_AnonFunction2(((props$2, mapCtx$2) => {
    var props = $as_sci_List(props$2);
    var mapCtx = $as_s_Option(mapCtx$2);
    return $ct_T2__O__O__(new $c_T2(), props, mapCtx)
  }));
  var effect = new $c_sjsr_AnonFunction2(((props$3$2, mapCtx$3$2) => {
    var props$3 = $as_sci_List(props$3$2);
    var mapCtx$3 = $as_s_Option(mapCtx$3$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      $as_T2(x$2$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => mapCtx$3)), new $c_sjsr_AnonFunction1(((map$2) => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
        var f$4 = new $c_sjsr_AnonFunction0((() => {
          var this$5 = $n(props$3);
          var p = new $c_sjsr_AnonFunction1(((child$2) => {
            var child = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(child$2);
            return $n(child).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active
          }));
          var this$6 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this$5, p);
          var f = new $c_sjsr_AnonFunction1(((child$3$2) => {
            var child$3 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(child$3$2);
            map$2.addInteraction($n(child$3).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction)
          }));
          $n(this$6.filtered__sc_Iterable()).foreach__F1__V(f);
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f$2 = new $c_sjsr_AnonFunction0((() => {
            var this$7 = $n(props$3);
            var p$1 = new $c_sjsr_AnonFunction1(((child$2$1) => {
              var child$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(child$2$1);
              return $n(child$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active
            }));
            var this$8 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this$7, p$1);
            var f$1 = new $c_sjsr_AnonFunction1(((child$3$2$1) => {
              var child$3$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(child$3$2$1);
              return map$2.removeInteraction($n(child$3$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction)
            }));
            $n(this$8.filtered__sc_Iterable()).foreach__F1__V(f$1)
          }));
          var f$3 = new $c_sjsr_AnonFunction0((() => {
            f$2.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$4))
      }))))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().optionalCallback__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_OptionLike__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance);
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$__f_reuseChild);
  var this$16 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableMap;
  var r = $n($$x2).tuple2__F2__F2__F2($$x1, this$16.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var this$17 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$17);
  var ev = $n($as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$18, deps, effect, a, r, step$1))).render__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$3$2) => {
    $as_Ljapgolly_scalajs_react_hooks_HookCtx$P1(x$3$2);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(null)
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)));
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$20, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.openlayers.Interactions.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$.prototype.apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(children, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Interactions$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.Interactions$Child"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.Interactions$Child;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$__f_reuseChild = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child(x$1$2);
    return $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(x$1)
  }));
  var r = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__f_reuseChildProps;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$__f_reuseChild = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$.prototype.apply__F1__Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps = (function(handler) {
  var $$x2 = $i_ol$002finteraction.Interaction;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_InteractionOptions);
  var handleEvent = new $c_sjsr_AnonFunction1(((ev$2) => {
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackOption($n(handler).apply__O__O(ev$2))).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr;
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var this$$1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(this$);
    var r = $as_s_Option($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$$1));
    return $n(r).isEmpty__Z()
  }));
  var array = [$ct_T2__O__O__(new $c_T2(), "handleEvent", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(handleEvent))];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x1 = new $$x2(_\uff3fobj);
  return new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps($$x1, true)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Interactions$Child$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$ = this;
  var this$15 = $m_Lcom_iz2use_react_hooks_package$();
  var this$5 = $n($n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First());
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(ctx$2);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$().Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$__f_hook, $n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props($n(ctx).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2();
  var this$7 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$5, hook, step, d)));
  var initialState = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep();
  var this$13 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$7, initialState, step$1)));
  var deps = new $c_sjsr_AnonFunction1(((ctx$3$2) => {
    var ctx$3 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(ctx$3$2);
    return $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props($n(ctx$3).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)
  }));
  var effect = new $c_sjsr_AnonFunction1(((ctx$4$2) => {
    var ctx$4 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(ctx$4$2);
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(x$1$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f = new $c_sjsr_AnonFunction0((() => {
        $n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props($n(ctx$4).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer.setVisible($n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props($n(ctx$4).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_visible)
      }));
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        f.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__f_reuseProps;
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$12);
  var ev = $n($as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useEffectWithDepsBy__F1__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$13, deps, effect, a, r, step$2))).render__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$2$2) => {
    $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(x$2$2);
    var this$14 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var ns = $m_sci_Nil$();
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$14, null, ns)
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)));
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$15, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.openlayers.Layer.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$.prototype.apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(layer, visible, children) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$__f_component;
  var $$x1 = $as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Util);
  var a = $as_T($i_ol$002futil.getUid(layer));
  var this$7 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n($$x1).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
  var props = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(layer, visible);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$7.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$7.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Layer$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$__f_hook = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$ = this;
  var this$2 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context;
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$4 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$2, ctx, step)));
  var ctx$1 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_context;
  var this$3 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$3);
  var this$11 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$4, ctx$1, step$1)));
  var deps = new $c_sjsr_AnonFunction3(((x$1$2, x$2$2, zIndex$2) => {
    $as_s_Option(x$2$2);
    var zIndex = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(zIndex$2);
    return zIndex
  }));
  var effect = new $c_sjsr_AnonFunction3(((layer$2, x$3$2, zIndex$3$2) => {
    $as_s_Option(x$3$2);
    var zIndex$3 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(zIndex$3$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(x$4$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f = new $c_sjsr_AnonFunction0((() => {
        layer$2.setZIndex($n(zIndex$3).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index__f_index)
      }));
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        f.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$__f_reuseIndex;
  var this$10 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$10);
  var this$21 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$11, deps, effect, a, r, step$2)));
  var deps$1 = new $c_sjsr_AnonFunction3(((layer$3$2, mapCtx$2, x$5$2) => {
    var mapCtx = $as_s_Option(mapCtx$2);
    $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(x$5$2);
    return $ct_T2__O__O__(new $c_T2(), layer$3$2, mapCtx)
  }));
  var effect$1 = new $c_sjsr_AnonFunction3(((layer$4$2, mapCtx$3$2, x$6$2) => {
    var mapCtx$3 = $as_s_Option(mapCtx$3$2);
    $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(x$6$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      $as_T2(x$7$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => mapCtx$3)), new $c_sjsr_AnonFunction1(((map$2) => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
        var f$4 = new $c_sjsr_AnonFunction0((() => {
          map$2.addLayer(layer$4$2);
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f$2 = new $c_sjsr_AnonFunction0((() => map$2.removeLayer(layer$4$2)));
          var f$3 = new $c_sjsr_AnonFunction0((() => {
            f$2.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$4))
      }))))
    }))
  }));
  var a$1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().optionalCallback__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_OptionLike__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance);
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseLayer;
  var this$19 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableMap;
  var r$1 = $n($$x2).tuple2__F2__F2__F2($$x1, this$19.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var this$20 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$20);
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$__f_hook = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$21, deps$1, effect$1, a$1, r$1, step$3))).build__F1()
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.LayerWrapper$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_LayerWrapper$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_context = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_reuseChild = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_React$();
  var defaultValue = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(0);
  $n(this$1.Ljapgolly_scalajs_react_React$__f_Context);
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_context = new $c_Ljapgolly_scalajs_react_feature_Context$$anon$3(defaultValue);
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_reuseChild = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$3.byRef__F2(), this$3.by_$eq$eq__F2());
  var this$18 = $m_Lcom_iz2use_react_hooks_package$();
  var this$17 = $n($n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First());
  var deps = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(x$2$2);
    return $m_Ljapgolly_scalajs_react_PropsChildren$().toList$extension__sjs_js_Any__sci_List($n(x$2).Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren)
  }));
  var create = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(props$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      $as_sci_List(x$3$2);
      var $$x1 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var this$9 = $n($m_Ljapgolly_scalajs_react_PropsChildren$().toList$extension__sjs_js_Any__sci_List($n(props).Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren));
      return $n($$x1).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("layers", $as_sci_Seq($n($n($as_sc_IterableOps($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$9))).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
        var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
        return (check$ifrefutable$1 !== null)
      })))).map__F1__O(new $c_sjsr_AnonFunction1(((x$4$2) => {
        var x$4 = $as_T2(x$4$2);
        if ((x$4 !== null)) {
          var props$1 = $n(x$4)._1__O();
          var index = $n(x$4)._2$mcI$sp__I();
          var this$10 = $n($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_context);
          var value = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(index);
          var $$x2 = $n($f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$10, value));
          var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(props$1))];
          return $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
        } else {
          throw new $c_s_MatchError(x$4)
        }
      })))))
    }))
  }));
  var r = $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2(this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_reuseChild);
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep();
  var ev$2 = $n($as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useMemoBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$17, deps, create, r, step))).renderWithReuseBy__F1__F1__Ljapgolly_scalajs_react_CtorType$Summoner__F2__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(x$5$2);
    return $as_Ljapgolly_scalajs_react_Reusable($n(x$5).Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1)
  })), new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Ljapgolly_scalajs_react_Reusable(x$6$2);
    return $as_Ljapgolly_scalajs_react_vdom_VdomElement($n(x$6).value__O())
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonC__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner($m_Ljapgolly_scalajs_react_internal_Singleton$().Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit), $m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2());
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$18, ev$2).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.openlayers.Layers.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Layers$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_reuseNode = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_reuseMap = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$ = this;
  $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$().apply__V();
  var this$1 = $m_Ljapgolly_scalajs_react_React$();
  var defaultValue = $m_s_None$();
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context = $n(this$1.Ljapgolly_scalajs_react_React$__f_Context).apply__T__O__Ljapgolly_scalajs_react_feature_Context("Map", defaultValue);
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_reuseNode = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$2.byRef__F2(), this$2.by_$eq$eq__F2());
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$3.byRef__F2(), this$3.by_$eq$eq__F2());
  var this$4 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableMap;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_reuseMap = this$4.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3);
  var this$55 = $m_Lcom_iz2use_react_hooks_package$();
  var this$8 = $n($n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First());
  var evidence$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_scalajs_dom_HTMLElement.getClassOf());
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep();
  var this$10 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefToVdom__s_reflect_ClassTag__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$8, evidence$1, step)));
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context;
  var this$9 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$9);
  var this$12 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$10, ctx, step$1)));
  var ctx$1 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_context;
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22(this$11);
  var this$22 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$12, ctx$1, step$2)));
  var effect = new $c_sjsr_AnonFunction5(((x$8$2, x$9$2, outerRef$2, mapOpt$2, view$2) => {
    $as_jl_Void(x$8$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$9$2));
    var outerRef = $as_Ljapgolly_scalajs_react_Ref$FullF(outerRef$2);
    var mapOpt = $as_s_Option(mapOpt$2);
    var view = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(view$2);
    var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(outerRef).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$14 = $m_s_$less$colon$less$();
    var cb = $n($$x3).flatMap$extension__F0__F1__F0($n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$14.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((elt$2) => {
      var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x4 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().connectMapWithCleanup__Lorg_scalajs_dom_HTMLElement__s_Option__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__Ljapgolly_scalajs_react_callback_Trampoline(elt$2, mapOpt, view);
      var this$15 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x6).map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($n($$x5).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x4, this$15.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((r$2) => {
        var r = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(r$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(r)
      })), null))
    })));
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(cb))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().optionalCallback__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_OptionLike__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance);
  var this$21 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23(this$21);
  var this$33 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$22, effect, a, step$3)));
  var deps = new $c_sjsr_AnonFunction5(((x$10$2, x$11$2, ref$2, map$2$2, x$12$2) => {
    $as_jl_Void(x$10$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$11$2));
    var ref = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$2);
    var map$2 = $as_s_Option(map$2$2);
    $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(x$12$2);
    return $ct_T2__O__O__(new $c_T2(), $n(ref).Ljapgolly_scalajs_react_Ref$$anon$1__f_raw.current, map$2)
  }));
  var effect$1 = new $c_sjsr_AnonFunction5(((x$13$2, x$14$2, ref$3$2, map$3$2, x$15$2) => {
    $as_jl_Void(x$13$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$14$2));
    var ref$3 = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$3$2);
    var map$3 = $as_s_Option(map$3$2);
    $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(x$15$2);
    return new $c_sjsr_AnonFunction1(((x$16$2) => {
      $as_T2(x$16$2);
      var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x7 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(ref$3).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$23 = $m_s_$less$colon$less$();
      var r$1 = $n($$x9).map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($n($$x8).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x7, this$23.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((v$2) => {
        var observer = new ResizeObserver(((arg1$2, arg2$2) => {
          $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().reactbuild$analyze$cost$modules$mapview$openlayers$Map$$$anonfun$component$16__sjs_js_Array__Lreactbuild_analyze_cost_modules_planner_ResizeObserver__s_Option__Lorg_scalajs_dom_HTMLElement__V(arg1$2, arg2$2, map$3, v$2)
        }));
        observer.observe(v$2);
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
        var f = new $c_sjsr_AnonFunction0((() => {
          observer.disconnect()
        }));
        var f$1 = new $c_sjsr_AnonFunction0((() => {
          f.apply__O()
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
      })), null);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(r$1))
    }))
  }));
  var a$1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().optionalCallback__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_OptionLike__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance);
  var r$3 = $m_Ljapgolly_scalajs_react_Reusability$().tuple2__F2__F2__F2(this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_reuseNode, this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_reuseMap);
  var this$32 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23(this$32);
  var this$54 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$33, deps, effect$1, a$1, r$3, step$4)));
  var f$2 = new $c_sjsr_AnonFunction5(((x$17$2, children$2, outerRef$3$2, map$4$2, x$18$2) => {
    $as_jl_Void(x$17$2);
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var outerRef$3 = $as_Ljapgolly_scalajs_react_Ref$FullF(outerRef$3$2);
    $as_s_Option(map$4$2);
    $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(x$18$2);
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x13 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("map", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var this$36 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_mapContainer;
    var $$x12 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$36, s);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var t = "div";
    var $$x11 = $ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(new $c_Ljapgolly_scalajs_react_vdom_TagOf(), t, $m_s_package$().s_package$__f_Nil).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(outerRef$3));
    var $$x10 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("map", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var this$41 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_mapWrapper;
    var array = [$$x10, $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$41, s$1), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    var array$1 = [$$x13, $$x12, $n($$x11).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(children))];
    return $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  }));
  var this$53 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$5 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23(this$53);
  var s$2 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonC__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner($m_Ljapgolly_scalajs_react_internal_Singleton$().Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit);
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$54, f$2, step$5, s$2);
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$55, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.openlayers.Map.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children))
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$.prototype.connectMapWithCleanup__Lorg_scalajs_dom_HTMLElement__s_Option__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__Ljapgolly_scalajs_react_callback_Trampoline = (function(elt, mapOpt, viewCtx) {
  return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => mapOpt)), new $c_sjsr_AnonFunction1(((map$2) => {
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var f = new $c_sjsr_AnonFunction0((() => {
      map$2.setTarget(elt);
      map$2.setView($n(viewCtx).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_view);
      return map$2.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "moveend"), ((arg1$2) => {
        $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().reactbuild$analyze$cost$modules$mapview$openlayers$Map$$$anonfun$connectMapWithCleanup$4__Ltypings_ol_mapEventMod$default__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__V(arg1$2, viewCtx)
      }))
    }));
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      f.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var this$ = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1);
    var f$4 = new $c_sjsr_AnonFunction1(((x$7$2) => {
      $as_jl_Void(x$7$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        map$2.setTarget()
      }));
      var f$3 = new $c_sjsr_AnonFunction0((() => {
        f$2.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$4))
  })))
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$.prototype.reactbuild$analyze$cost$modules$mapview$openlayers$Map$$$anonfun$connectMapWithCleanup$4__Ltypings_ol_mapEventMod$default__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__V = (function(ev, viewCtx$1) {
  var view = $n(viewCtx$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_view;
  console.log("move end", $uZ(view.getAnimating()), $uZ(view.getInteracting()));
  var value = view.getCenter();
  if ((value !== (void 0))) {
    var value$1 = view.getZoom();
    if ((value$1 !== (void 0))) {
      var zoom = $uD(value$1);
      $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections);
      var center = $i_ol$002fproj.toLonLat(value);
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r = $n(viewCtx$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_updateViewPoint;
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(center, zoom)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$14 = $n(this$);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$14)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$.prototype.reactbuild$analyze$cost$modules$mapview$openlayers$Map$$$anonfun$component$16__sjs_js_Array__Lreactbuild_analyze_cost_modules_planner_ResizeObserver__s_Option__Lorg_scalajs_dom_HTMLElement__V = (function(arr, obs, map$2, v$1) {
  var this$1 = $n(map$2);
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var rect = v$1.getBoundingClientRect();
    var _1$mcD$sp = $uD(rect.width);
    var _2$mcD$sp = $uD(rect.height);
    arg1.setSize([_1$mcD$sp, _2$mcD$sp])
  }
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Map$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$ = this;
  var this$31 = $m_Lcom_iz2use_react_hooks_package$();
  var api = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First();
  var this$21 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction0((() => {
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_MapOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    _\uff3fobj.moveTolerance = 5.0;
    var map = new ($moduleDefault($i_ol$002fMap))(_\uff3fobj);
    return $m_s_Option$().apply__O__s_Option(map)
  })), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep())));
  var effect = new $c_sjsr_AnonFunction3(((x$1$2, x$2$2, mapOpt$2) => {
    $as_jl_Void(x$1$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$2$2));
    var mapOpt = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(mapOpt$2);
    var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty;
    var f$2 = new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_jl_Void(x$5$2);
      var this$15 = $n(mapOpt);
      var callback = new $c_sjsr_AnonFunction0((() => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
        var f = new $c_sjsr_AnonFunction0((() => {
          var this$10 = $n($as_s_Option($n(mapOpt).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
          if ((!this$10.isEmpty__Z())) {
            var arg1 = this$10.get__O();
            arg1.dispose()
          }
        }));
        var f$1 = new $c_sjsr_AnonFunction0((() => {
          f.apply__O()
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
      }));
      var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
      var arg1$1 = this$15.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      $as_s_Option(arg1$1);
      var arg1$2 = $m_s_None$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$15.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$2), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    var this$17 = $n(this$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$17, f$2))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$20 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$20);
  var this$30 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$21, effect, a, step)));
  var f$3 = new $c_sjsr_AnonFunction3(((x$6$2, children$2, state$2) => {
    $as_jl_Void(x$6$2);
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var state = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(state$2);
    var this$22 = $n($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context);
    var value = $n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var $$x1 = $n($f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$22, value));
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(children))];
    return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  var this$29 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$29);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonC__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner($m_Ljapgolly_scalajs_react_internal_Singleton$().Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit);
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$30, f$3, step$1, s);
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$31, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.openlayers.MapProvider.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.MapProvider$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$__proj4Init$lzycompute__V($thiz) {
  if ((!$thiz.Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$__f_bitmap$0)) {
    $moduleDefault($i_proj4).defs("EPSG:2154", "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    $n($m_s_package$().s_package$__f_List);
    var array = ["IGNF:WGS84G", "WGS84G"];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$5 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
    var these = this$5;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var name = $as_T(arg1);
      $moduleDefault($i_proj4).defs(name, "+title=World Geodetic System 1984 +proj=longlat +nadgrids=null +wktext +towgs84=0.0000,0.0000,0.0000 +a=6378137.0000 +rf=298.2572221010000 +units=m +no_defs");
      these = $as_sci_List($n(these).tail__O())
    };
    var proj4 = $moduleDefault($i_proj4);
    $i_ol$002fproj$002fproj4.register(proj4);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$__f_bitmap$0 = true
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$__f_bitmap$0 = false;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$ = this;
  $i_$0021style$002dloader$0021css$002dloader$0021ol$002fol$002ecss
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$.prototype.proj4Init__V = (function() {
  if ((!this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$__f_bitmap$0)) {
    $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$__proj4Init$lzycompute__V(this)
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$.prototype.apply__V = (function() {
  $i_$0021style$002dloader$0021css$002dloader$0021ol$002fol$002ecss;
  this.proj4Init__V()
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Requirements$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_MercatorProj = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_Lambert93Proj = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_context = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$ = this;
  $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Requirements$().apply__V();
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections);
  $i_ol$002fproj.get("IGNF:WGS84G");
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj = ($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections), $i_ol$002fproj.get("EPSG:4326"));
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_MercatorProj = ($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections), $i_ol$002fproj.get("EPSG:3857"));
  new $c_T4((-2.63), 46.26, (-0.49), 47.15);
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_Lambert93Proj = ($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections), $i_ol$002fproj.get("EPSG:2154"));
  var this$17 = $m_Ljapgolly_scalajs_react_React$();
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_context = $n(this$17.Ljapgolly_scalajs_react_React$__f_Context).apply__T__O__Ljapgolly_scalajs_react_feature_Context("View", null);
  var this$71 = $m_Lcom_iz2use_react_hooks_package$();
  var this$22 = $n($n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First());
  var reducer = new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(x$1$2);
    return $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$().reducer__F2()
  }));
  var initialState = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint($n($n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props($n(p).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)).Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$().apply$default$2__D()), $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint($n($n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props($n(p).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)).Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint($n($n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props($n(p).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)).Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $m_s_package$().s_package$__f_Nil, "")
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep();
  var this$25 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducerBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$22, reducer, initialState, step)));
  var deps = new $c_sjsr_AnonFunction3(((p$3$2, x$2$2, x$3$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(p$3$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$2$2));
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$3$2);
    return $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint($n($n(p$3).Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
  }));
  var effect = new $c_sjsr_AnonFunction3(((p$4$2, x$4$2, state$2) => {
    var p$4 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(p$4$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$4$2));
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(x$5$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(state).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint($n($n(p$4).Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$().apply$default$2__D()))).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$().Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseViewPoint;
  var this$24 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$24);
  var this$32 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$25, deps, effect, a, r, step$1)));
  var deps$1 = new $c_sjsr_AnonFunction3(((p$5$2, x$6$2, state$3$2) => {
    var p$5 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(p$5$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$6$2));
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$3$2);
    var this$26 = $n(state$3);
    var next = $n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(this$26.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToProps;
    var $$x1 = $m_s_Option$();
    var x$2$1 = $n($n(p$5).Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    return $n($$x1).when__Z__F0__s_Option((!((next === null) ? (x$2$1 === null) : $n(next).equals__O__Z(x$2$1))), new $c_sjsr_AnonFunction0((() => next)))
  }));
  var effect$1 = new $c_sjsr_AnonFunction3(((p$6$2, x$7$2, state$4$2) => {
    var p$6 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(p$6$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$7$2));
    var state$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$4$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      $as_s_Option(x$8$2);
      var this$28 = $n($n(p$6).Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint);
      var mod = new $c_sjsr_AnonFunction1(((x$9$2) => {
        $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(x$9$2);
        var this$27 = $n(state$4);
        return $n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(this$27.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToProps
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$28, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))
  }));
  var a$1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$30 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$().Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseViewPoint;
  var r$1 = this$30.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3);
  var this$31 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$31);
  var this$36 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$32, deps$1, effect$1, a$1, r$1, step$2)));
  var f = new $c_sjsr_AnonFunction3(((x$10$2, x$11$2, viewState$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(x$10$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$11$2));
    var viewState = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(viewState$2);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ViewOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var view = new $i_ol.View(_\uff3fobj);
    var updateViewPoint = $m_Ljapgolly_scalajs_react_Reusable$fn$().apply__F1__Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction1(((point$2) => {
      var point = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(point$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(viewState).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView(point, $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$().apply$default$2__D()))).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    })));
    return new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(view, updateViewPoint)
  }));
  var this$35 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$35);
  var this$60 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useRefBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$36, f, step$3)));
  var deps$2 = new $c_sjsr_AnonFunction4(((x$12$2, x$13$2, state$5$2, x$14$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(x$12$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$13$2));
    var state$5 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$5$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$14$2);
    var this$37 = $n(state$5);
    return $n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(this$37.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToView
  }));
  var effect$2 = new $c_sjsr_AnonFunction4(((x$15$2, x$16$2, state$6$2, viewCtx$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(x$15$2);
    $n($as_Ljapgolly_scalajs_react_PropsChildren(x$16$2));
    var state$6 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$6$2);
    var viewCtx = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(viewCtx$2);
    return new $c_sjsr_AnonFunction1(((x$17$2) => {
      $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(x$17$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        var this$38 = $n(state$6);
        var viewPoint = $n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(this$38.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToView;
        $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections);
        var coordinate = $n(viewPoint).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords;
        var center = $i_ol$002fproj.fromLonLat(coordinate);
        var this$40 = $n(viewCtx);
        var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(this$40.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_view;
        $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_AnimationOptions);
        var fields$1 = $m_sci_Nil$();
        var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
        _\uff3fobj$1.center = center;
        var value = $n(viewPoint).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom;
        _\uff3fobj$1.zoom = value;
        _\uff3fobj$1.duration = 300.0;
        $$x2.animate(_\uff3fobj$1)
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    }))
  }));
  var a$2 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r$2 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$().Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseViewPoint;
  var this$59 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22(this$59);
  var this$70 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$60, deps$2, effect$2, a$2, r$2, step$4)));
  var f$3 = new $c_sjsr_AnonFunction4(((x$18$2, children$2, x$19$2, view$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(x$18$2);
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$19$2);
    var view$1 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(view$2);
    var this$62 = $n($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_context);
    var this$61 = $n(view$1);
    var value$1 = this$61.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current;
    var $$x3 = $n($f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$62, value$1));
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(children))];
    return $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  var this$69 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$5 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22(this$69);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$10 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$70, f$3, step$5, s);
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$71, ev$10).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.openlayers.View.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(viewPoint, children) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(viewPoint);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_View$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.View$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_View$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$
}
function $is_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction)))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewAction"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.ViewAction;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_person_package$() {
  this.Lreactbuild_analyze_cost_modules_person_package$__f_facetModifiers = null;
  this.Lreactbuild_analyze_cost_modules_person_package$__f_addressDetailsModifiers = null;
  $n_Lreactbuild_analyze_cost_modules_person_package$ = this;
  var $$x14 = $m_s_package$().s_package$__f_Seq;
  var empty = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_SupplierFacet(($m_Lreactbuild_person_SupplierFacet$(), $m_s_None$()), ($m_Lreactbuild_person_SupplierFacet$(), $m_s_None$()), ($m_Lreactbuild_person_SupplierFacet$(), $m_s_None$()), ($m_Lreactbuild_person_SupplierFacet$(), $m_s_None$()))));
  var editing = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$2);
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("N\u00b0 de compte client");
    var state = $n(s).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lreactbuild_person_SupplierFacet(x$1$2);
      return $n(x$1).Lreactbuild_person_SupplierFacet__f_reference
    })), new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_s_Option(v$2);
      return new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2 = $as_Lreactbuild_person_SupplierFacet(x$2$2);
        $n(x$2);
        var this$10 = $n(x$2);
        var paymentTermAndConditions = this$10.Lreactbuild_person_SupplierFacet__f_paymentTermAndConditions;
        var this$11 = $n(x$2);
        var group = this$11.Lreactbuild_person_SupplierFacet__f_group;
        var this$12 = $n(x$2);
        var documentParserSettings = this$12.Lreactbuild_person_SupplierFacet__f_documentParserSettings;
        return new $c_Lreactbuild_person_SupplierFacet(v, paymentTermAndConditions, group, documentParserSettings)
      }))
    })));
    var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    $m_Lcom_iz2use_common_Parsable$();
    var ev = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev);
    var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$18 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$18);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv = $m_s_math_Equiv$String$();
    var equiv = new $c_s_math_Equiv$OptionEquiv(eqv);
    var $$x11 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$1, explainError, equiv);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Modalit\u00e9s de paiement");
    var state$1 = $n(s).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lreactbuild_person_SupplierFacet(x$3$2);
      return $n(x$3).Lreactbuild_person_SupplierFacet__f_paymentTermAndConditions
    })), new $c_sjsr_AnonFunction1(((v$3$2) => {
      var v$3 = $as_s_Option(v$3$2);
      return new $c_sjsr_AnonFunction1(((x$4$2) => {
        var x$4 = $as_Lreactbuild_person_SupplierFacet(x$4$2);
        var this$25 = $n(x$4);
        var x$2$1 = this$25.Lreactbuild_person_SupplierFacet__f_reference;
        var this$26 = $n(x$4);
        var x$3$1 = this$26.Lreactbuild_person_SupplierFacet__f_group;
        var this$27 = $n(x$4);
        var x$4$2$1 = this$27.Lreactbuild_person_SupplierFacet__f_documentParserSettings;
        $n(x$4);
        return new $c_Lreactbuild_person_SupplierFacet(x$2$1, v$3, x$3$1, x$4$2$1)
      }))
    })));
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_paymentTermAndConditionsParsable;
    var ev$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$31 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$31);
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$34 = $m_s_math_Equiv$();
    var equiv$1 = this$34.universal__s_math_Equiv();
    var $$x10 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$2, explainError$1, equiv$1);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Groupe");
    var state$2 = $n(s).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lreactbuild_person_SupplierFacet(x$5$2);
      return $n(x$5).Lreactbuild_person_SupplierFacet__f_group
    })), new $c_sjsr_AnonFunction1(((v$4$2) => {
      var v$4 = $as_s_Option(v$4$2);
      return new $c_sjsr_AnonFunction1(((x$6$2) => {
        var x$6 = $as_Lreactbuild_person_SupplierFacet(x$6$2);
        var this$38 = $n(x$6);
        var x$6$2$1 = this$38.Lreactbuild_person_SupplierFacet__f_reference;
        var this$39 = $n(x$6);
        var x$7 = this$39.Lreactbuild_person_SupplierFacet__f_paymentTermAndConditions;
        var this$40 = $n(x$6);
        var x$8 = this$40.Lreactbuild_person_SupplierFacet__f_documentParserSettings;
        $n(x$6);
        return new $c_Lreactbuild_person_SupplierFacet(x$6$2$1, x$7, v$4, x$8)
      }))
    })));
    var optioner$2 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var ev$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_supplierGroupResolver;
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var helper$2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_supplierGroupHelper;
    var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
    var this$44 = $m_Lcom_iz2use_react_components_ExplainError$();
    var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1(this$44);
    var equiv$2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_supplierGroupOrdering;
    var array = [$$x11, $$x10, editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$2, optioner$2, ev$3, explainError$2, equiv$2)];
    return $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  var classTag = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_SupplierFacet.getClassOf());
  var $$x13 = new $c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier("Fournisseur", empty, editing, classTag);
  var empty$1 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_CustomerFacet()));
  var editing$1 = new $c_sjsr_AnonFunction1(((s$3$2) => {
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$3$2);
    return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), $m_sci_Nil$())
  }));
  var classTag$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_CustomerFacet.getClassOf());
  var $$x9 = new $c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier("Client", empty$1, editing$1, classTag$1);
  var empty$2 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_EstateAgentFacet(($m_Lreactbuild_person_EstateAgentFacet$(), false))));
  var editing$2 = new $c_sjsr_AnonFunction1(((s$4$2) => {
    var s$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$4$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Communiquer la grille de prix");
    var state$3 = $n(s$4).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7$1 = $as_Lreactbuild_person_EstateAgentFacet(x$7$2);
      return $n(x$7$1).Lreactbuild_person_EstateAgentFacet__f_showPrices
    })), new $c_sjsr_AnonFunction1(((v$2$1) => {
      var v$1 = $uZ(v$2$1);
      return new $c_sjsr_AnonFunction1(((x$8$2) => {
        var x$8$1 = $as_Lreactbuild_person_EstateAgentFacet(x$8$2);
        $n(x$8$1);
        return new $c_Lreactbuild_person_EstateAgentFacet(v$1)
      }))
    })));
    var evDefault$1 = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
    var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    var parser$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var ev$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
    var editorComponent$3 = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
    var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$3 = $m_s_math_Equiv$Boolean$();
    var this$62 = $n(editorComponent$3);
    return this$62.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$3, optioner$3, ev$4, explainError$3, equiv$3)
  }));
  var classTag$2 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_EstateAgentFacet.getClassOf());
  var $$x8 = new $c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier("Agence immobili\u00e8re", empty$2, editing$2, classTag$2);
  var empty$3 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_UserFacet(($m_Lreactbuild_person_UserFacet$(), $m_s_None$()))));
  var editing$3 = new $c_sjsr_AnonFunction1(((s$5$2) => {
    var s$5 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$5$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Adresse email de connexion");
    var state$4 = $n(s$5).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9 = $as_Lreactbuild_person_UserFacet(x$9$2);
      return $n(x$9).Lreactbuild_person_UserFacet__f_email
    })), new $c_sjsr_AnonFunction1(((v$2$2) => {
      var v$5 = $as_s_Option(v$2$2);
      return new $c_sjsr_AnonFunction1(((x$10$2) => {
        var x$10 = $as_Lreactbuild_person_UserFacet(x$10$2);
        $n(x$10);
        return new $c_Lreactbuild_person_UserFacet(v$5)
      }))
    })));
    var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$3 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$5);
    var ev$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$73 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$73);
    var editorComponent$4 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
    var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv$1 = $m_s_math_Equiv$String$();
    var equiv$4 = new $c_s_math_Equiv$OptionEquiv(eqv$1);
    return editorComponent$4.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$4, state$4, optioner$4, ev$6, explainError$4, equiv$4)
  }));
  var classTag$3 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_UserFacet.getClassOf());
  var $$x7 = new $c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier("Utilisateur", empty$3, editing$3, classTag$3);
  var empty$4 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_ResourceFacet(($m_Lreactbuild_person_ResourceFacet$(), $m_s_None$()), ($m_Lreactbuild_person_ResourceFacet$(), $m_s_None$()), ($m_Lreactbuild_person_ResourceFacet$(), $m_s_None$()))));
  var editing$4 = new $c_sjsr_AnonFunction1(((s$6$2) => {
    var s$6 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$6$2);
    var f = new $c_sjsr_AnonFunction0((() => {
      var this$83 = $m_Ljava_time_LocalDate$();
      return this$83.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
    }));
    var now = new $c_Lcom_iz2use_common_ParsingReference$Simple(f);
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$88 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
    var $$x5 = this$88.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$89 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
    var $$x4 = this$89.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x3 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Co\u00fbt horaire");
    var state$5 = $n(s$6).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$11$2) => {
      var x$11 = $as_Lreactbuild_person_ResourceFacet(x$11$2);
      return $n(x$11).Lreactbuild_person_ResourceFacet__f_costByHour
    })), new $c_sjsr_AnonFunction1(((v$2$3) => {
      var v$6 = $as_s_Option(v$2$3);
      return new $c_sjsr_AnonFunction1(((x$12$2) => {
        var x$12 = $as_Lreactbuild_person_ResourceFacet(x$12$2);
        var this$93 = $n(x$12);
        var x$10$1 = this$93.Lreactbuild_person_ResourceFacet__f_entry;
        var this$94 = $n(x$12);
        var x$11$1 = this$94.Lreactbuild_person_ResourceFacet__f_release;
        $n(x$12);
        return new $c_Lreactbuild_person_ResourceFacet(x$10$1, x$11$1, v$6)
      }))
    })));
    var evDefault$3 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$5 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser$4 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$7);
    var ev$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$100 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$4 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$100);
    var editorComponent$5 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$4);
    var explainError$5 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv$2 = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
    var equiv$5 = new $c_s_math_Equiv$OptionEquiv(eqv$2);
    var $$x2 = editorComponent$5.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$5, state$5, optioner$5, ev$8, explainError$5, equiv$5);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date d'entr\u00e9e");
    var state$6 = $n(s$6).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$13$2) => {
      var x$13 = $as_Lreactbuild_person_ResourceFacet(x$13$2);
      return $n(x$13).Lreactbuild_person_ResourceFacet__f_entry
    })), new $c_sjsr_AnonFunction1(((v$3$2$1) => {
      var v$3$1 = $as_s_Option(v$3$2$1);
      return new $c_sjsr_AnonFunction1(((x$14$2) => {
        var x$14 = $as_Lreactbuild_person_ResourceFacet(x$14$2);
        $n(x$14);
        var this$107 = $n(x$14);
        var release = this$107.Lreactbuild_person_ResourceFacet__f_release;
        var this$108 = $n(x$14);
        var costByHour = this$108.Lreactbuild_person_ResourceFacet__f_costByHour;
        return new $c_Lreactbuild_person_ResourceFacet(v$3$1, release, costByHour)
      }))
    })));
    var optioner$6 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    $m_Lcom_iz2use_common_Parsable$();
    var parser$5 = new $c_Lcom_iz2use_common_Parsable$$anon$4(now);
    var ev$9 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$113 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$5 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$113);
    var editorComponent$6 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$5);
    var explainError$6 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
    var $$x1 = editorComponent$6.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$6, state$6, optioner$6, ev$9, explainError$6, equiv$6);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$7 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date de sortie");
    var state$7 = $n(s$6).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$15$2) => {
      var x$15 = $as_Lreactbuild_person_ResourceFacet(x$15$2);
      return $n(x$15).Lreactbuild_person_ResourceFacet__f_release
    })), new $c_sjsr_AnonFunction1(((v$4$2$1) => {
      var v$4$1 = $as_s_Option(v$4$2$1);
      return new $c_sjsr_AnonFunction1(((x$16$2) => {
        var x$16 = $as_Lreactbuild_person_ResourceFacet(x$16$2);
        var this$119 = $n(x$16);
        var x$13$1 = this$119.Lreactbuild_person_ResourceFacet__f_entry;
        var this$120 = $n(x$16);
        var x$14$1 = this$120.Lreactbuild_person_ResourceFacet__f_costByHour;
        $n(x$16);
        return new $c_Lreactbuild_person_ResourceFacet(x$13$1, v$4$1, x$14$1)
      }))
    })));
    var optioner$7 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    $m_Lcom_iz2use_common_Parsable$();
    var parser$6 = new $c_Lcom_iz2use_common_Parsable$$anon$4(now);
    var ev$10 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$125 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$6 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$125);
    var editorComponent$7 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$6);
    var explainError$7 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
    var array$1 = [$$x5, $$x4, $$x3, $$x2, $$x1, editorComponent$7.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$7, state$7, optioner$7, ev$10, explainError$7, equiv$7)];
    return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  }));
  var classTag$4 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_ResourceFacet.getClassOf());
  var array$2 = [$$x13, $$x9, $$x8, $$x7, new $c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier("Ressource", empty$4, editing$4, classTag$4)];
  this.Lreactbuild_analyze_cost_modules_person_package$__f_facetModifiers = $as_sci_Seq($n($$x14).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
  var $$x21 = $m_s_package$().s_package$__f_Seq;
  var empty$5 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_Website("", $m_s_package$().s_package$__f_Nil)));
  var editing$5 = new $c_sjsr_AnonFunction1(((s$7$2) => {
    var s$7 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$7$2);
    var this$151 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Adresse du site web");
    var state$8 = $n(s$7).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$17$2) => {
      var x$17 = $as_Lreactbuild_person_Website(x$17$2);
      return $n(x$17).Lreactbuild_person_Website__f_url
    })), new $c_sjsr_AnonFunction1(((v$2$4) => {
      var v$7 = $as_T(v$2$4);
      return new $c_sjsr_AnonFunction1(((x$18$2) => {
        var x$18 = $as_Lreactbuild_person_Website(x$18$2);
        $n(x$18);
        var this$140 = $n(x$18);
        var credentials = this$140.Lreactbuild_person_Website__f_credentials;
        return new $c_Lreactbuild_person_Website(v$7, credentials)
      }))
    })));
    var evDefault$4 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$8 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$4);
    var parser$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$11 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$144 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$7 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$144);
    var editorComponent$8 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$7);
    var explainError$8 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$8 = $m_s_math_Equiv$String$();
    var array$3 = [editorComponent$8.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$8, state$8, optioner$8, ev$11, explainError$8, equiv$8)];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$151, null, ns)
  }));
  var classTag$5 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_Website.getClassOf());
  var $$x20 = new $c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier("Site web", empty$5, editing$5, classTag$5);
  var empty$6 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_Email("")));
  var editing$6 = new $c_sjsr_AnonFunction1(((s$8$2) => {
    var s$8 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$8$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Adresse e-mail");
    var state$9 = $n(s$8).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$19$2) => {
      var x$19 = $as_Lreactbuild_person_Email(x$19$2);
      return $n(x$19).Lreactbuild_person_Email__f_email
    })), new $c_sjsr_AnonFunction1(((v$2$5) => {
      var v$8 = $as_T(v$2$5);
      return new $c_sjsr_AnonFunction1(((x$20$2) => {
        var x$20 = $as_Lreactbuild_person_Email(x$20$2);
        $n(x$20);
        return new $c_Lreactbuild_person_Email(v$8)
      }))
    })));
    var evDefault$5 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$9 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$5);
    var parser$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$12 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$8);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$159 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$8 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$159);
    var editorComponent$9 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$8);
    var explainError$9 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$9 = $m_s_math_Equiv$String$();
    return editorComponent$9.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$9, state$9, optioner$9, ev$12, explainError$9, equiv$9)
  }));
  var classTag$6 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_Email.getClassOf());
  var $$x19 = new $c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier("Email", empty$6, editing$6, classTag$6);
  var empty$7 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_Phone("")));
  var editing$7 = new $c_sjsr_AnonFunction1(((s$9$2) => {
    var s$9 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$9$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$10 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("N\u00b0 de t\u00e9l\u00e9phone");
    var state$10 = $n(s$9).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$21$2) => {
      var x$21 = $as_Lreactbuild_person_Phone(x$21$2);
      return $n(x$21).Lreactbuild_person_Phone__f_number
    })), new $c_sjsr_AnonFunction1(((v$2$6) => {
      var v$9 = $as_T(v$2$6);
      return new $c_sjsr_AnonFunction1(((x$22$2) => {
        var x$22 = $as_Lreactbuild_person_Phone(x$22$2);
        $n(x$22);
        return new $c_Lreactbuild_person_Phone(v$9)
      }))
    })));
    var evDefault$6 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$10 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$6);
    var parser$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$13 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$9);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$170 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$9 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$170);
    var editorComponent$10 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$9);
    var explainError$10 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$10 = $m_s_math_Equiv$String$();
    return editorComponent$10.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$10, state$10, optioner$10, ev$13, explainError$10, equiv$10)
  }));
  var classTag$7 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_Phone.getClassOf());
  var $$x18 = new $c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier("T\u00e9l\u00e9phone", empty$7, editing$7, classTag$7);
  var empty$8 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_Postal("", "", "")));
  var editing$8 = new $c_sjsr_AnonFunction1(((s$10$2) => {
    var s$10 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$10$2);
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$11 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Rue");
    var state$11 = $n(s$10).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$23$2) => {
      var x$23 = $as_Lreactbuild_person_Postal(x$23$2);
      return $n(x$23).Lreactbuild_person_Postal__f_street
    })), new $c_sjsr_AnonFunction1(((v$2$7) => {
      var v$10 = $as_T(v$2$7);
      return new $c_sjsr_AnonFunction1(((x$24$2) => {
        var x$24 = $as_Lreactbuild_person_Postal(x$24$2);
        $n(x$24);
        var this$180 = $n(x$24);
        var postalCode = this$180.Lreactbuild_person_Postal__f_postalCode;
        var this$181 = $n(x$24);
        var city = this$181.Lreactbuild_person_Postal__f_city;
        return new $c_Lreactbuild_person_Postal(v$10, postalCode, city)
      }))
    })));
    var evDefault$7 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$11 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$7);
    var parser$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$14 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$10);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$185 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$10 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$185);
    var editorComponent$11 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$10);
    var explainError$11 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$11 = $m_s_math_Equiv$String$();
    var $$x16 = editorComponent$11.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$11, state$11, optioner$11, ev$14, explainError$11, equiv$11);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$12 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Code postal");
    var state$12 = $n(s$10).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$25$2) => {
      var x$25 = $as_Lreactbuild_person_Postal(x$25$2);
      return $n(x$25).Lreactbuild_person_Postal__f_postalCode
    })), new $c_sjsr_AnonFunction1(((v$3$2$2) => {
      var v$3$3 = $as_T(v$3$2$2);
      return new $c_sjsr_AnonFunction1(((x$26$2) => {
        var x$26 = $as_Lreactbuild_person_Postal(x$26$2);
        var this$191 = $n(x$26);
        var x$16$1 = this$191.Lreactbuild_person_Postal__f_street;
        var this$192 = $n(x$26);
        var x$17$1 = this$192.Lreactbuild_person_Postal__f_city;
        $n(x$26);
        return new $c_Lreactbuild_person_Postal(x$16$1, v$3$3, x$17$1)
      }))
    })));
    var evDefault$8 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$12 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$8);
    var parser$11 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$15 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$11);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$196 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$11 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$196);
    var editorComponent$12 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$11);
    var explainError$12 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$12 = $m_s_math_Equiv$String$();
    var $$x15 = editorComponent$12.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$12, state$12, optioner$12, ev$15, explainError$12, equiv$12);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$13 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ville");
    var state$13 = $n(s$10).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$27$2) => {
      var x$27 = $as_Lreactbuild_person_Postal(x$27$2);
      return $n(x$27).Lreactbuild_person_Postal__f_city
    })), new $c_sjsr_AnonFunction1(((v$4$2$2) => {
      var v$4$3 = $as_T(v$4$2$2);
      return new $c_sjsr_AnonFunction1(((x$28$2) => {
        var x$28 = $as_Lreactbuild_person_Postal(x$28$2);
        var this$202 = $n(x$28);
        var x$19$1 = this$202.Lreactbuild_person_Postal__f_street;
        var this$203 = $n(x$28);
        var x$20$1 = this$203.Lreactbuild_person_Postal__f_postalCode;
        $n(x$28);
        return new $c_Lreactbuild_person_Postal(x$19$1, x$20$1, v$4$3)
      }))
    })));
    var evDefault$9 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$13 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$9);
    var parser$12 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$16 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$12);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$207 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$12 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$207);
    var editorComponent$13 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$12);
    var explainError$13 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$13 = $m_s_math_Equiv$String$();
    var array$4 = [$$x16, $$x15, editorComponent$13.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$13, state$13, optioner$13, ev$16, explainError$13, equiv$13)];
    return $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
  }));
  var classTag$8 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_Postal.getClassOf());
  var array$5 = [$$x20, $$x19, $$x18, new $c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier("Adresse postale", empty$8, editing$8, classTag$8)];
  this.Lreactbuild_analyze_cost_modules_person_package$__f_addressDetailsModifiers = $as_sci_Seq($n($$x21).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
}
$c_Lreactbuild_analyze_cost_modules_person_package$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_person_package$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_person_package$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_person_package$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_person_package$.prototype = $c_Lreactbuild_analyze_cost_modules_person_package$.prototype;
var $d_Lreactbuild_analyze_cost_modules_person_package$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_person_package$: 0
}, false, "reactbuild.analyze.cost.modules.person.package$", {
  Lreactbuild_analyze_cost_modules_person_package$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_person_package$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_person_package$;
var $n_Lreactbuild_analyze_cost_modules_person_package$;
function $m_Lreactbuild_analyze_cost_modules_person_package$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_person_package$)) {
    $n_Lreactbuild_analyze_cost_modules_person_package$ = new $c_Lreactbuild_analyze_cost_modules_person_package$()
  };
  return $n_Lreactbuild_analyze_cost_modules_person_package$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier(label, empty, editing, classTag) {
  this.Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_label = null;
  this.Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_empty = null;
  this.Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_editing = null;
  this.Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_classTag = null;
  this.Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_label = label;
  this.Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_empty = empty;
  this.Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_editing = editing;
  this.Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_classTag = classTag
}
$c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier.prototype = $c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier.prototype;
function $as_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.person.package$AddressDetailsModifier"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.person.package$AddressDetailsModifier;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier: 0
}, false, "reactbuild.analyze.cost.modules.person.package$AddressDetailsModifier", {
  Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier(label, empty, editing, classTag) {
  this.Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_label = null;
  this.Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_empty = null;
  this.Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_editing = null;
  this.Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_classTag = null;
  this.Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_label = label;
  this.Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_empty = empty;
  this.Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_editing = editing;
  this.Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_classTag = classTag
}
$c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_person_package$FacetModifier() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_person_package$FacetModifier.prototype = $c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier.prototype;
function $as_Lreactbuild_analyze_cost_modules_person_package$FacetModifier(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.person.package$FacetModifier"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_person_package$FacetModifier(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_person_package$FacetModifier)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_person_package$FacetModifier(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_person_package$FacetModifier(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.person.package$FacetModifier;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_person_package$FacetModifier = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_person_package$FacetModifier: 0
}, false, "reactbuild.analyze.cost.modules.person.package$FacetModifier", {
  Lreactbuild_analyze_cost_modules_person_package$FacetModifier: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_person_package$FacetModifier.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_person_package$FacetModifier;
function $ct_Lreactbuild_analyze_cost_modules_planner_ChronoScale__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Lreactbuild_analyze_cost_modules_planner_UnitDescription__($thiz, primary, secondary) {
  $thiz.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_primary = primary;
  $thiz.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_secondary = secondary;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale() {
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_primary = null;
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_secondary = null
}
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_ChronoScale.prototype = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale.prototype;
function $as_Lreactbuild_analyze_cost_modules_planner_ChronoScale(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.ChronoScale"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_ChronoScale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_ChronoScale)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_ChronoScale(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_ChronoScale(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.ChronoScale;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$() {
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale$__f_list = null;
  $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$ = this;
  $n($m_s_package$().s_package$__f_List);
  var array = [$m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$(), $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$(), $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$(), $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$(), $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale$__f_list = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
}
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$.prototype;
var $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$: 0
}, false, "reactbuild.analyze.cost.modules.planner.ChronoScale$", {
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$;
var $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$;
function $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$ = new $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$
}
function $p_Lreactbuild_analyze_cost_modules_planner_IsRange$__loop$1__sci_List__sci_List__Lreactbuild_analyze_cost_modules_planner_IsRange__s_math_Ordering__sci_List($thiz, rest, done, isRange$1, orderingA$1) {
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var this$2 = $n(done);
      var f = ((x$1$2) => {
        var x$1 = $as_Lreactbuild_analyze_cost_modules_planner_RangeSet(x$1$2);
        return $n(x$1).Lreactbuild_analyze_cost_modules_planner_RangeSet__f_items
      });
      if ((this$2 === $m_sci_Nil$())) {
        return $m_sci_Nil$()
      } else {
        var arg1 = this$2.head__O();
        var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
        var t = h;
        var rest$1 = $as_sci_List(this$2.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$1 = $n(rest$1).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest$1 = $as_sci_List($n(rest$1).tail__O())
        };
        return h
      }
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $n(x3).sci_$colon$colon__f_head;
      var tl = $n(x3).sci_$colon$colon__f_next;
      $n(isRange$1);
      var item = $as_Lreactbuild_model_AllocatedTime(head);
      var from = $n(item).Lreactbuild_model_AllocatedTime__f_from;
      $n(isRange$1);
      var item$1 = $as_Lreactbuild_model_AllocatedTime(head);
      var until = $n(item$1).Lreactbuild_model_AllocatedTime__f_until;
      var this$5 = $n(done);
      _return: {
        var i = 0;
        var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$5, 0, this$5);
        while (true) {
          var this$8 = $n(these);
          if ((!this$8.isEmpty__Z())) {
            var arg1$2 = $n(these).head__O();
            var r = $as_Lreactbuild_analyze_cost_modules_planner_RangeSet(arg1$2);
            if ((!$n($n(r).Lreactbuild_analyze_cost_modules_planner_RangeSet__f_range).intersects__O__O__Z(from, until))) {
              var x1$2 = i;
              break _return
            };
            i = ((1 + i) | 0);
            these = $as_sc_LinearSeq($n(these).tail__O())
          } else {
            break
          }
        };
        var x1$2 = (-1)
      };
      if ((x1$2 === (-1))) {
        var this$9 = $n($m_s_package$().s_package$__f_Nil);
        var rassoc$2 = new $c_Lreactbuild_analyze_cost_modules_planner_RangeSet(new $c_sci_$colon$colon(head, this$9), new $c_Lcom_iz2use_common_TypedRange(from, until, orderingA$1), isRange$1);
        var this$10 = $n(done);
        var temp$done = new $c_sci_$colon$colon(rassoc$2, this$10);
        rest = tl;
        done = temp$done
      } else {
        var this$11 = $n(done);
        var current = $as_Lreactbuild_analyze_cost_modules_planner_RangeSet($f_sc_LinearSeqOps__apply__I__O(this$11, x1$2));
        $n(current);
        var this$12 = $n($n(current).Lreactbuild_analyze_cost_modules_planner_RangeSet__f_items);
        var items = new $c_sci_$colon$colon(head, this$12);
        var range = $n($n(current).Lreactbuild_analyze_cost_modules_planner_RangeSet__f_range).extendsWith__O__O__Lcom_iz2use_common_TypedRange(from, until);
        var next = new $c_Lreactbuild_analyze_cost_modules_planner_RangeSet(items, range, isRange$1);
        var this$15 = $n(done);
        var this$14 = $n($m_s_package$().s_package$__f_Nil);
        var other = new $c_sci_$colon$colon(next, this$14);
        var temp$done$2 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$15, x1$2, other, 1));
        rest = tl;
        done = temp$done$2
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_IsRange$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_planner_IsRange$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_IsRange$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_IsRange$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_IsRange$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_IsRange$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_IsRange$.prototype;
var $d_Lreactbuild_analyze_cost_modules_planner_IsRange$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_IsRange$: 0
}, false, "reactbuild.analyze.cost.modules.planner.IsRange$", {
  Lreactbuild_analyze_cost_modules_planner_IsRange$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_IsRange$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_IsRange$;
var $n_Lreactbuild_analyze_cost_modules_planner_IsRange$;
function $m_Lreactbuild_analyze_cost_modules_planner_IsRange$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_IsRange$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_IsRange$ = new $c_Lreactbuild_analyze_cost_modules_planner_IsRange$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_IsRange$
}
function $p_Lreactbuild_analyze_cost_modules_planner_LineRuler$__reuseAllocatedTime$1__Lreactbuild_model_AllocatedTime__Ljapgolly_scalajs_react_callback_Trampoline__F2__Ljapgolly_scalajs_react_callback_Trampoline($thiz, v, cb, updateEvent$1) {
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(updateEvent$1).apply__O__O__O(v, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
}
function $p_Lreactbuild_analyze_cost_modules_planner_LineRuler$__handleSelection$1__Lreactbuild_model_AllocatedTime__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__Ljapgolly_scalajs_react_callback_Trampoline($thiz, event, e, proxy$1, selection$1, updateEvent$1) {
  var $$x6 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
  $m_Ljapgolly_scalajs_react_package$();
  var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $m_Ljapgolly_scalajs_react_package$();
  var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var $$x3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e, this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).stopPropagationCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var $$x2 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$();
  var u = $m_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$().apply__s_util_Either__F2__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_s_util_Right(event), new $c_sjsr_AnonFunction2(((v$2, cb$2) => {
    var v = $as_Lreactbuild_model_AllocatedTime(v$2);
    var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lreactbuild_analyze_cost_modules_planner_LineRuler$__reuseAllocatedTime$1__Lreactbuild_model_AllocatedTime__Ljapgolly_scalajs_react_callback_Trampoline__F2__Ljapgolly_scalajs_react_callback_Trampoline($thiz, v, cb, updateEvent$1))
  })), proxy$1);
  var this$6 = $n(u);
  var n = this$6.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x1 = $n($$x4).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x3, $n($$x2).dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lcom_iz2use_react_components_Dialog$Push(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n))));
  var this$8 = $n(selection$1);
  var callback = new $c_sjsr_AnonFunction0((() => {
    var this$9 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$10 = $n(this$9.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$10.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$11 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var G = this$11.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var arg1 = this$8.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var s = $as_s_Option(arg1);
  var arg1$1 = ($n(s).contains__O__Z($n(event).Lreactbuild_model_AllocatedTime__f__id) ? $m_s_None$() : new $c_s_Some($n(event).Lreactbuild_model_AllocatedTime__f__id));
  var self = $n($$x5).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$8.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  var this$ = $n($$x6).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, e);
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
}
function $p_Lreactbuild_analyze_cost_modules_planner_LineRuler$__loop$1__sci_List__Z__sci_List__T__s_Option__Lcom_iz2use_common_MappedTypedRange__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ldiode_react_ModelProxy__F2__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, events, first, acc, title$1, leftColumn$1, mapped$1, selection$1, proxy$1, updateEvent$1) {
  while (true) {
    var x1 = events;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$3 = $m_Lscalacss_ScalaCssReact$();
      var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerHorizontalLine;
      var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s)];
      var rassoc$1 = $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      var this$7 = $n(acc);
      var withLine = new $c_sci_$colon$colon(rassoc$1, this$7);
      var this$8 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var ns = withLine.reverse__sci_List();
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$8, null, ns)
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var events$2 = $as_sci_List($n(x3).sci_$colon$colon__f_head);
      var tl = $n(x3).sci_$colon$colon__f_next;
      var this$79 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$11 = $m_Lscalacss_ScalaCssReact$();
      var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerEventLines;
      var $$x26 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$11, s$1);
      var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$14 = $m_Lscalacss_ScalaCssReact$();
      var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerLineSideHeader;
      var $$x24 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$14, s$2);
      var $$x23 = (first ? ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(title$1)) : ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("\u00a0")));
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var $$x22 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width");
      var this$20 = $n(leftColumn$1);
      var array$1 = [$$x24, $$x23, $$x22.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(((this$20.isEmpty__Z() ? 0.0 : this$20.get__O()) + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
      var $$x21 = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$26 = $m_Lscalacss_ScalaCssReact$();
      var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerEventLine;
      var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$26, s$3);
      var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as = $n(events$2).reverse__sci_List();
      var array$4 = [$$x3, $n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((mapped$1, selection$1, proxy$1, updateEvent$1) => ((event$2) => {
        var event = $as_Lreactbuild_model_AllocatedTime(event$2);
        var left = $uD($n(mapped$1).apply__O__O($n(event).Lreactbuild_model_AllocatedTime__f_from));
        var right = ($uD($n($n(mapped$1).Lcom_iz2use_common_MappedTypedRange__f_toRange).Lcom_iz2use_common_TypedRange__f_until) - $uD($n(mapped$1).apply__O__O($n(event).Lreactbuild_model_AllocatedTime__f_until)));
        var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$30 = $m_Lscalacss_ScalaCssReact$();
        var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerEvent;
        var $$x18 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$30, s$4);
        var this$31 = $m_Lscalacss_ScalaCssReact$();
        var s$5 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerEventSelected;
        var this$32 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$31, s$5));
        var condition = $n($as_s_Option($n(selection$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).contains__O__Z($n(event).Lreactbuild_model_AllocatedTime__f__id);
        var $$x17 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$32, condition);
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onPointerDown");
        var $$x16 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((x$1$2) => {
          $m_Ljapgolly_scalajs_react_package$();
          var this$36 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(x$1$2, this$36.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).stopPropagationCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
        var $$x15 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lreactbuild_analyze_cost_modules_planner_LineRuler$__handleSelection$1__Lreactbuild_model_AllocatedTime__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__Ljapgolly_scalajs_react_callback_Trampoline($thiz, event, e$2, proxy$1, selection$1, updateEvent$1)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
        var $$x14 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((left + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        var $$x13 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("right")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((right + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = $n(event).Lreactbuild_model_AllocatedTime__f_title;
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x12 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x11 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Lcom_iz2use_common_Textualizable$();
        var v$1 = $n(event).Lreactbuild_model_AllocatedTime__f_participant;
        var this$43 = $m_Lreactbuild_model_Implicits$();
        var ev = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$43, proxy$1);
        var v$2 = $n(ev).stringify__O__T(v$1);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x10 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var o = $n(event).Lreactbuild_model_AllocatedTime__f_stage;
        var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
        var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((x$2$2) => {
          var x$2 = $as_Lreactbuild_common_model_RefTo(x$2$2);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Lcom_iz2use_common_Textualizable$();
          var this$50 = $m_Lreactbuild_model_Implicits$();
          var ev$1 = $f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$50, proxy$1);
          var v$3 = $n(ev$1).stringify__O__T(x$2);
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
        })));
        var $$x7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title);
        $m_Lcom_iz2use_common_Textualizable$();
        var v$4 = $n(event).Lreactbuild_model_AllocatedTime__f_from;
        var this$54 = $m_Lreactbuild_model_Implicits$();
        var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__TextualizableLocalDateTime__Lcom_iz2use_common_Textualizable(this$54);
        var $$x6 = $n(ev$2).stringify__O__T(v$4);
        $m_Lcom_iz2use_common_Textualizable$();
        var v$5 = $n(event).Lreactbuild_model_AllocatedTime__f_until;
        var this$56 = $m_Lreactbuild_model_Implicits$();
        var ev$3 = $f_Lreactbuild_model_LowPriorityImplicits__TextualizableLocalDateTime__Lcom_iz2use_common_Textualizable(this$56);
        var $$x5 = $n($$x7).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((((($$x6 + "-") + $n(ev$3).stringify__O__T(v$5)) + "\n") + $n(event).Lreactbuild_model_AllocatedTime__f_title), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$60 = $m_Lscalacss_ScalaCssReact$();
        var s$6 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerEventProgress;
        var array$2 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$60, s$6), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#2196f3", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
        var array$3 = [$$x18, $$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
        return $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      }))(mapped$1, selection$1, proxy$1, updateEvent$1)))];
      var array$5 = [$$x26, $$x21, $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
      var array$6 = [$n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
      var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
      var body = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$79, null, ns$1);
      var this$80 = $n(acc);
      var temp$acc = new $c_sci_$colon$colon(body, this$80);
      events = tl;
      first = false;
      acc = temp$acc
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_LineRuler$() {
  this.Lreactbuild_analyze_cost_modules_planner_LineRuler$__f_isRangeAllocatedTime = null;
  $n_Lreactbuild_analyze_cost_modules_planner_LineRuler$ = this;
  this.Lreactbuild_analyze_cost_modules_planner_LineRuler$__f_isRangeAllocatedTime = new $c_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1()
}
$c_Lreactbuild_analyze_cost_modules_planner_LineRuler$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_LineRuler$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_LineRuler$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_LineRuler$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_LineRuler$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_LineRuler$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_LineRuler$.prototype.apply__T__sci_List__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__Lcom_iz2use_common_MappedTypedRange__s_Option__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_VdomElement = (function(title, events, selection, updateEvent, mapped, leftColumn, proxy) {
  var $$x5 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$6 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerLineTopHeader;
  var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(title);
  var this$9 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var this$11 = $n(this$9.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  var this$10 = $n(leftColumn);
  var condition = (!this$10.isEmpty__Z());
  var array = [$$x3, $$x2, $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$11, condition)];
  var $$x1 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var this$15 = $m_Lreactbuild_analyze_cost_modules_planner_IsRange$();
  var isRange = this.Lreactbuild_analyze_cost_modules_planner_LineRuler$__f_isRangeAllocatedTime;
  var orderingA = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateTimeOrdering;
  var array$1 = [$$x1, $p_Lreactbuild_analyze_cost_modules_planner_LineRuler$__loop$1__sci_List__Z__sci_List__T__s_Option__Lcom_iz2use_common_MappedTypedRange__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ldiode_react_ModelProxy__F2__Ljapgolly_scalajs_react_vdom_VdomNode(this, $p_Lreactbuild_analyze_cost_modules_planner_IsRange$__loop$1__sci_List__sci_List__Lreactbuild_analyze_cost_modules_planner_IsRange__s_math_Ordering__sci_List(this$15, events, $m_s_package$().s_package$__f_Nil, isRange, orderingA), true, $m_s_package$().s_package$__f_Nil, title, leftColumn, mapped, selection, proxy, updateEvent)];
  return $n($$x5).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(title, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lreactbuild_analyze_cost_modules_planner_LineRuler$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_LineRuler$: 0
}, false, "reactbuild.analyze.cost.modules.planner.LineRuler$", {
  Lreactbuild_analyze_cost_modules_planner_LineRuler$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_LineRuler$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_LineRuler$;
var $n_Lreactbuild_analyze_cost_modules_planner_LineRuler$;
function $m_Lreactbuild_analyze_cost_modules_planner_LineRuler$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_LineRuler$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_LineRuler$ = new $c_Lreactbuild_analyze_cost_modules_planner_LineRuler$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_LineRuler$
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityLocalDateTime__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_planner_Planner$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_Planner$() {
  this.Lreactbuild_analyze_cost_modules_planner_Planner$__f_reusabilityPeriod = null;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_planner_Planner$ = this;
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var a$1 = new $c_sr_ObjectRef(null);
  var b$1$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lcom_iz2use_common_TypedRange(a$2);
    var b = $as_Lcom_iz2use_common_TypedRange(b$2);
    return ($uZ($n($p_Lreactbuild_analyze_cost_modules_planner_Planner$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_common_TypedRange__f_from, $n(b).Lcom_iz2use_common_TypedRange__f_from)) && $uZ($n($p_Lreactbuild_analyze_cost_modules_planner_Planner$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_common_TypedRange__f_until, $n(b).Lcom_iz2use_common_TypedRange__f_until)))
  }));
  a$1.sr_ObjectRef__f_elem = f;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$__f_reusabilityPeriod = $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(a$1.sr_ObjectRef__f_elem));
  var this$102 = $m_Lcom_iz2use_react_hooks_package$();
  var this$7 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var evidence$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_scalajs_dom_HTMLElement.getClassOf());
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$10 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefToVdom__s_reflect_ClassTag__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$7, evidence$1, step)));
  var hook = new $c_sjsr_AnonFunction2(((x$5$2, ref$2) => {
    $as_Lreactbuild_analyze_cost_modules_planner_Planner$Props(x$5$2);
    var ref = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$2);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Lreactbuild_hooks_ClientSize$().Lreactbuild_hooks_ClientSize$__f_hook, ref))
  }));
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$8);
  var this$9 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$9);
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__customBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$10, hook, step$1, d));
  var $$x5 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api);
  var $$x3 = new $c_sjsr_AnonFunction0((() => {
    var $$x4 = $m_Lcom_iz2use_common_TypedRange$();
    var this$12 = $m_Ljava_time_LocalDate$();
    var this$14 = $n(this$12.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId())));
    return $n($$x4).fromStart__O__F1__s_math_Ordering__Lcom_iz2use_common_TypedRange($m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$14, $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime()), new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Ljava_time_LocalDateTime(x$6$2);
      return $n(x$6).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong(7, 0), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit())
    })), $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateTimeOrdering)
  }));
  var this$15 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$19 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x5.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x3, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$15))));
  var deps = new $c_sjsr_AnonFunction4(((x$7$2, x$8$2, size$2, period$2) => {
    $as_Lreactbuild_analyze_cost_modules_planner_Planner$Props(x$7$2);
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$8$2);
    var size = $as_s_Option(size$2);
    var period = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(period$2);
    var $$x6 = $as_Lcom_iz2use_common_TypedRange($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var this$16 = $n(size);
    var f$1 = new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9 = $as_Lreactbuild_hooks_ClientSize(x$9$2);
      return $n(x$9).Lreactbuild_hooks_ClientSize__f_width
    }));
    var this$17 = $n((this$16.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$1.apply__O__O(this$16.get__O()))));
    var default$1 = new $c_sjsr_AnonFunction0((() => 0.0));
    return new $c_Lreactbuild_analyze_cost_modules_planner_Planner$State($$x6, $uD((this$17.isEmpty__Z() ? default$1.apply__O() : this$17.get__O())), ($m_Lreactbuild_analyze_cost_modules_planner_Planner$State$(), false))
  }));
  var create = new $c_sjsr_AnonFunction4(((x$10$2, x$11$2, size$3$2, period$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_planner_Planner$Props(x$10$2);
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$11$2);
    $as_s_Option(size$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(period$3$2);
    return new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_modules_planner_Planner$State(s$2);
      return s
    }))
  }));
  var r = $m_Lreactbuild_analyze_cost_modules_planner_Planner$State$().Lreactbuild_analyze_cost_modules_planner_Planner$State$__f_reuseState;
  var this$18 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$18);
  var this$101 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$19, deps, create, r, step$2)));
  var f$2 = new $c_sjsr_AnonFunction5(((p$2, ref$3$2, clientSize$2, period$4$2, s$2$1) => {
    var p = $as_Lreactbuild_analyze_cost_modules_planner_Planner$Props(p$2);
    var ref$3 = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$3$2);
    $as_s_Option(clientSize$2);
    var period$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(period$4$2);
    var s$1 = $as_Ljapgolly_scalajs_react_Reusable(s$2$1);
    $n($as_Lreactbuild_analyze_cost_modules_planner_Planner$State(($m_Ljapgolly_scalajs_react_Reusable$(), $n(s$1).value__O()))).leftColumn__s_Option();
    var proxy = $n(p).Lreactbuild_analyze_cost_modules_planner_Planner$Props__f_proxy;
    var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$23 = $m_Lscalacss_ScalaCssReact$();
    var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerContainerWrapper;
    var $$x35 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$23, s$3);
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$26 = $m_Lscalacss_ScalaCssReact$();
    var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerContainer;
    var $$x33 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$26, s$4);
    var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$29 = $m_Lscalacss_ScalaCssReact$();
    var s$5 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerFixPositions;
    var $$x31 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$29, s$5);
    var $$x30 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x29 = $m_Ldiode_react_ReactPot$potWithReact$();
    var pot = $n($as_Lreactbuild_analyze_cost_modules_planner_Planner$State(($m_Ljapgolly_scalajs_react_Reusable$(), $n(s$1).value__O()))).mapped__Ldiode_data_Pot();
    var array = [$n($$x29).render$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot, new $c_sjsr_AnonFunction1(((mapped$2) => {
      var mapped = $as_Lcom_iz2use_common_MappedTypedRange(mapped$2);
      var u = $m_Lreactbuild_analyze_cost_modules_planner_TimeRuler$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_common_MappedTypedRange__Lreactbuild_analyze_cost_modules_planner_ChronoScale__s_Option__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(period$4, mapped, $n($as_Lreactbuild_analyze_cost_modules_planner_Planner$State(($m_Ljapgolly_scalajs_react_Reusable$(), $n(s$1).value__O()))).timeScale__Lreactbuild_analyze_cost_modules_planner_ChronoScale(), $n($as_Lreactbuild_analyze_cost_modules_planner_Planner$State(($m_Ljapgolly_scalajs_react_Reusable$(), $n(s$1).value__O()))).leftColumn__s_Option());
      var this$38 = $n(u);
      var n = this$38.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    })))];
    var $$x28 = $n($$x30).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("rulers", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var t = "div";
    var $$x27 = $ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(new $c_Ljapgolly_scalajs_react_vdom_TagOf(), t, $m_s_package$().s_package$__f_Nil).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(ref$3));
    var $$x26 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("content", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var this$47 = $m_Lscalacss_ScalaCssReact$();
    var s$6 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerContentWrapper;
    var $$x25 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$47, s$6);
    var $$x24 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
    var $$x23 = $n($as_Lreactbuild_analyze_cost_modules_planner_Planner$State(($m_Ljapgolly_scalajs_react_Reusable$(), $n(s$1).value__O()))).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period;
    var $$x22 = new $c_sjsr_AnonFunction2(((p$2$2, n$2) => {
      var p$2$1 = $as_Lcom_iz2use_common_TypedRange(p$2$2);
      var n$1 = $as_Lcom_iz2use_common_TypedRange(n$2);
      return $m_Lreactbuild_analyze_cost_modules_planner_Planner$().expandQuery__Lcom_iz2use_common_TypedRange__Lcom_iz2use_common_TypedRange__Lcom_iz2use_common_TypedRange(p$2$1, n$1)
    }));
    var $$x17 = new $c_sjsr_AnonFunction1(((period$2$2) => {
      var period$2$1 = $as_Lcom_iz2use_common_TypedRange(period$2$2);
      var this$49 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x21 = new $c_Lautowire_ClientProxy(this$49).Lautowire_ClientProxy__f_self;
      var $$x20 = $m_s_package$().s_package$__f_Seq;
      var array$1 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listAllocatedTimesForPeriod"];
      var $$x19 = $as_sci_Seq($n($$x20).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
      var this$64 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$54 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$55 = $n(new $c_Lautowire_ClientProxy(this$54).Lautowire_ClientProxy__f_self);
      var r$1 = $n(period$2$1).Lcom_iz2use_common_TypedRange__f_from;
      var evidence$2 = $m_Lio_circe_Encoder$().encodeLocalDateTime__Lio_circe_Encoder();
      var y = this$55.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2);
      var $$x18 = $ct_T2__O__O__(new $c_T2(), "from", y);
      var this$58 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$59 = $n(new $c_Lautowire_ClientProxy(this$58).Lautowire_ClientProxy__f_self);
      var r$2 = $n(period$2$1).Lcom_iz2use_common_TypedRange__f_until;
      var evidence$2$1 = $m_Lio_circe_Encoder$().encodeLocalDateTime__Lio_circe_Encoder();
      var y$1 = this$59.write__O__Lio_circe_Encoder__Lio_circe_Json(r$2, evidence$2$1);
      var array$2 = [$$x18, $ct_T2__O__O__(new $c_T2(), "until", y$1)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return $n($n($$x21).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x19, this$64.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$65 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$67 = $n(new $c_Lautowire_ClientProxy(this$65).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lreactbuild_model_AllocatedTime$().Lreactbuild_model_AllocatedTime$__f_codecForAllocatedTime;
        var evidence$1$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
        return $as_sci_List(this$67.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var $$x16 = new $c_sjsr_AnonFunction2(((p$3$2, n$3$2) => {
      $as_sci_List(p$3$2);
      var n$3 = $as_sci_List(n$3$2);
      $m_Lreactbuild_analyze_cost_modules_planner_Planner$();
      return n$3
    }));
    var $$x9 = new $c_sjsr_AnonFunction1(((x$14$2) => {
      var x$14 = $as_Ldiode_data_Pot(x$14$2);
      var $$x15 = $m_Lreactbuild_analyze_cost_modules_planner_PlannerContent$();
      var $$x14 = $n($as_Lreactbuild_analyze_cost_modules_planner_Planner$State(($m_Ljapgolly_scalajs_react_Reusable$(), $n(s$1).value__O()))).mapped__Ldiode_data_Pot();
      var $$x13 = $n($as_Lreactbuild_analyze_cost_modules_planner_Planner$State(($m_Ljapgolly_scalajs_react_Reusable$(), $n(s$1).value__O()))).leftColumn__s_Option();
      var $$x12 = new $c_sjsr_AnonFunction1(((x$12$2) => {
        var x$12 = $as_Lreactbuild_model_AllocatedTime(x$12$2);
        return $n(x$12).Lreactbuild_model_AllocatedTime__f_project
      }));
      var $$x11 = new $c_sjsr_AnonFunction1(((x$13$2) => {
        $as_Lreactbuild_model_AllocatedTime(x$13$2);
        var this$76 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("?"))];
        var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        return this$76.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
      }));
      var this$78 = $m_Lreactbuild_model_Implicits$();
      var this$77 = $m_Lreactbuild_model_Implicits$();
      var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$77, proxy);
      var $$x10 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$78, ev$2);
      var this$79 = $m_Lreactbuild_model_Implicits$();
      var u$1 = $n($$x15).apply__Ldiode_data_Pot__Ljapgolly_scalajs_react_extra_StateSnapshotF__s_Option__F1__F1__Ldiode_data_Pot__Ldiode_react_ModelProxy__s_math_Ordering__Lcom_iz2use_common_Textualizable__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x14, period$4, $$x13, $$x12, $$x11, x$14, proxy, $$x10, $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$79, proxy));
      var this$81 = $n(u$1);
      var n$4 = this$81.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4)
    }));
    var $$x8 = $m_Lreactbuild_analyze_cost_modules_planner_Planner$().Lreactbuild_analyze_cost_modules_planner_Planner$__f_reusabilityPeriod;
    var $$x7 = $m_Ljapgolly_scalajs_react_Reusability$();
    $m_Lreactbuild_model_Implicits$();
    var this$84 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u$2 = $n($$x24).range__O__F2__F1__F2__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x23, $$x22, $$x17, $$x16, $$x9, $$x8, $n($$x7).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$84.byRef__F2(), this$84.by_$eq$eq__F2())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var this$86 = $n(u$2);
    var n$5 = this$86.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$4 = [$$x26, $$x25, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$5)];
    var array$5 = [$$x31, $$x28, $n($$x27).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var array$6 = [$$x33, $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var array$7 = [$$x35, $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
    return $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
  }));
  var this$100 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$100);
  var s$7 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$3 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$101, f$2, step$3, s$7);
  this.Lreactbuild_analyze_cost_modules_planner_Planner$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$102, ev$3).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.planner.Planner.component"))
}
$c_Lreactbuild_analyze_cost_modules_planner_Planner$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_Planner$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_Planner$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_Planner$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_Planner$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_Planner$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_Planner$.prototype.expandQuery__Lcom_iz2use_common_TypedRange__Lcom_iz2use_common_TypedRange__Lcom_iz2use_common_TypedRange = (function(p, n) {
  var startInclusive = $as_Ljava_time_temporal_Temporal($n(n).Lcom_iz2use_common_TypedRange__f_from);
  var endExclusive = $as_Ljava_time_temporal_Temporal($n(p).Lcom_iz2use_common_TypedRange__f_from);
  var deltaBefore = $n($m_Ljava_time_Duration$().between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration(startInclusive, endExclusive)).multipliedBy__J__Ljava_time_Duration(new $c_RTLong(3, 0));
  var startInclusive$1 = $as_Ljava_time_temporal_Temporal($n(p).Lcom_iz2use_common_TypedRange__f_until);
  var endExclusive$1 = $as_Ljava_time_temporal_Temporal($n(n).Lcom_iz2use_common_TypedRange__f_until);
  var deltaAfter = $n($m_Ljava_time_Duration$().between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration(startInclusive$1, endExclusive$1)).multipliedBy__J__Ljava_time_Duration(new $c_RTLong(3, 0));
  if ((!$n(deltaBefore).isNegative__Z())) {
    var this$1 = $n($as_Ljava_time_LocalDateTime($n(p).Lcom_iz2use_common_TypedRange__f_from));
    var from = $as_Ljava_time_LocalDateTime($n(deltaBefore).subtractFrom__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this$1))
  } else {
    var from = $as_Ljava_time_LocalDateTime($n(p).Lcom_iz2use_common_TypedRange__f_from)
  };
  if ($n(deltaAfter).isNegative__Z()) {
    var until = $as_Ljava_time_LocalDateTime($n(p).Lcom_iz2use_common_TypedRange__f_until)
  } else {
    var this$2 = $n($as_Ljava_time_LocalDateTime($n(p).Lcom_iz2use_common_TypedRange__f_until));
    var until = $as_Ljava_time_LocalDateTime($n(deltaAfter).addTo__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this$2))
  };
  $n(n);
  var orderingT = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateTimeOrdering;
  return new $c_Lcom_iz2use_common_TypedRange(from, until, orderingT)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$.prototype.apply__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(proxy) {
  var c = this.Lreactbuild_analyze_cost_modules_planner_Planner$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_planner_Planner$Props(proxy);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_planner_Planner$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_Planner$: 0
}, false, "reactbuild.analyze.cost.modules.planner.Planner$", {
  Lreactbuild_analyze_cost_modules_planner_Planner$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_Planner$;
var $n_Lreactbuild_analyze_cost_modules_planner_Planner$;
function $m_Lreactbuild_analyze_cost_modules_planner_Planner$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_Planner$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_Planner$ = new $c_Lreactbuild_analyze_cost_modules_planner_Planner$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_Planner$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$() {
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$ = this;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("PlannerAllocatedTimeEditor", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props(p$2);
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_event);
    var e = new $c_s_util_Either$RightProjection(this$2).toOption__s_Option();
    var this$3 = $n($n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_event);
    var d = new $c_s_util_Either$LeftProjection(this$3).toOption__s_Option();
    var this$4 = $n(e);
    if (this$4.isEmpty__Z()) {
      var $$x11 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var x$31 = $as_Lreactbuild_model_AllocatedTime(arg1);
      var $$x11 = new $c_s_Some($n(x$31).Lreactbuild_model_AllocatedTime__f_organization)
    };
    var this$5 = $n($$x11);
    if (this$5.isEmpty__Z()) {
      var this$6 = $n($n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_proxy);
      var this$7 = $n(this$6.Ldiode_react_ModelProxy__f_modelReader);
      var $$x12 = $n($as_Lreactbuild_analyze_cost_services_Model(this$7.value__O())).Lreactbuild_analyze_cost_services_Model__f_activeOrganization
    } else {
      var $$x12 = this$5
    };
    var this$8 = $n(d);
    if (this$8.isEmpty__Z()) {
      var $$x9 = $m_s_None$()
    } else {
      var arg1$1 = this$8.get__O();
      var x$32 = $as_Ljava_time_LocalDate(arg1$1);
      var this$9 = $n(x$32);
      var $$x9 = new $c_s_Some($m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$9, $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime()))
    };
    var this$10 = $n($$x9);
    if (this$10.isEmpty__Z()) {
      var this$11 = $n(e);
      if (this$11.isEmpty__Z()) {
        var $$x10 = $m_s_None$()
      } else {
        var arg1$2 = this$11.get__O();
        var x$33 = $as_Lreactbuild_model_AllocatedTime(arg1$2);
        var $$x10 = new $c_s_Some($n(x$33).Lreactbuild_model_AllocatedTime__f_from)
      }
    } else {
      var $$x10 = this$10
    };
    var this$12 = $n(d);
    if (this$12.isEmpty__Z()) {
      var $$x7 = $m_s_None$()
    } else {
      var arg1$3 = this$12.get__O();
      var x$34 = $as_Ljava_time_LocalDate(arg1$3);
      var this$13 = $n($n(x$34).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)));
      var $$x7 = new $c_s_Some($m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$13, $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime()))
    };
    var this$14 = $n($$x7);
    if (this$14.isEmpty__Z()) {
      var this$15 = $n(e);
      if (this$15.isEmpty__Z()) {
        var $$x8 = $m_s_None$()
      } else {
        var arg1$4 = this$15.get__O();
        var x$35 = $as_Lreactbuild_model_AllocatedTime(arg1$4);
        var $$x8 = new $c_s_Some($n(x$35).Lreactbuild_model_AllocatedTime__f_until)
      }
    } else {
      var $$x8 = this$14
    };
    var this$16 = $n(e);
    if (this$16.isEmpty__Z()) {
      var $$x6 = $m_s_None$()
    } else {
      var arg1$5 = this$16.get__O();
      var x$36 = $as_Lreactbuild_model_AllocatedTime(arg1$5);
      var $$x6 = new $c_s_Some($n(x$36).Lreactbuild_model_AllocatedTime__f_title)
    };
    var this$17 = $n(e);
    if (this$17.isEmpty__Z()) {
      var $$x5 = $m_s_None$()
    } else {
      var arg1$6 = this$17.get__O();
      var x$37 = $as_Lreactbuild_model_AllocatedTime(arg1$6);
      var $$x5 = $n(x$37).Lreactbuild_model_AllocatedTime__f_stage
    };
    var this$18 = $n(e);
    if (this$18.isEmpty__Z()) {
      var $$x4 = $m_s_None$()
    } else {
      var arg1$7 = this$18.get__O();
      var x$38 = $as_Lreactbuild_model_AllocatedTime(arg1$7);
      var $$x4 = new $c_s_Some($n(x$38).Lreactbuild_model_AllocatedTime__f_participant)
    };
    var this$19 = $n(e);
    if (this$19.isEmpty__Z()) {
      var $$x3 = $m_s_None$()
    } else {
      var arg1$8 = this$19.get__O();
      var x$39 = $as_Lreactbuild_model_AllocatedTime(arg1$8);
      var $$x3 = new $c_s_Some($n(x$39).Lreactbuild_model_AllocatedTime__f_project)
    };
    return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State($$x12, $$x10, $$x8, $$x6, $$x5, $$x4, $$x3)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend($n(x$3).backend__O()));
    var this$20 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props($n(this$20.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$21 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$21)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$.prototype.apply__s_util_Either__F2__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(event, save, proxy) {
  return $m_Lreactbuild_analyze_cost_components_Progress$().apply__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Lreactbuild_analyze_cost_components_ProgressContext(ctx$2);
    var c = $m_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$().Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props(proxy, ctx, event, save);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })))
});
var $d_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$: 0
}, false, "reactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$", {
  Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$;
var $n_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$;
function $m_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$ = new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$
}
function $p_Lreactbuild_analyze_cost_modules_planner_PlannerContent$__updateEvent$1__Lreactbuild_model_AllocatedTime__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__F0($thiz, e, cb, p$2) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(p$2);
    var this$3 = $n($n($as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(this$2.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_source);
    return ((!this$3.isEmpty__Z()) ? new $c_s_Some(this$3.get__O()) : $m_s_None$())
  }))), new $c_sjsr_AnonFunction1(((ss$2) => {
    var ss = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(ss$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$5 = $n(ss);
    var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
    var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
    var arg1 = this$5.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var lst = $as_sci_List(arg1);
    var this$6 = $n(lst);
    _return: {
      var i = 0;
      var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$6, 0, this$6);
      while (true) {
        var this$9 = $n(these);
        if ((!this$9.isEmpty__Z())) {
          var arg1$1 = $n(these).head__O();
          var x$9 = $as_Lreactbuild_model_AllocatedTime(arg1$1);
          var x = $n(x$9).Lreactbuild_model_AllocatedTime__f__id;
          var x$2 = $n(e).Lreactbuild_model_AllocatedTime__f__id;
          if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
            var x1 = i;
            break _return
          };
          i = ((1 + i) | 0);
          these = $as_sc_LinearSeq($n(these).tail__O())
        } else {
          break
        }
      };
      var x1 = (-1)
    };
    if ((x1 === (-1))) {
      var this$10 = $n(lst);
      var arg1$2 = new $c_sci_$colon$colon(e, this$10)
    } else {
      var this$12 = $n(lst);
      var this$11 = $n($m_s_package$().s_package$__f_Nil);
      var other = new $c_sci_$colon$colon(e, this$11);
      var arg1$2 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$12, x1, other, 1))
    };
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$5.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$2), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((x$10$2) => {
      $as_jl_Void(x$10$2)
    }));
    var this$14 = $n(this$);
    var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$14, f);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  })))
}
function $p_Lreactbuild_analyze_cost_modules_planner_PlannerContent$__create$1__D__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline($thiz, x, p$2, s$2) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(p$2);
    var this$3 = $n($n($as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(this$2.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_mapped);
    return ((!this$3.isEmpty__Z()) ? new $c_s_Some(this$3.get__O()) : $m_s_None$())
  }))), new $c_sjsr_AnonFunction1(((mapped$2) => {
    var mapped = $as_Lcom_iz2use_common_MappedTypedRange(mapped$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$4 = $n(p$2);
    var proxy = $n($as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(this$4.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_proxy;
    var this$8 = $n($as_Ljava_time_LocalDateTime($n($n(mapped).Lcom_iz2use_common_MappedTypedRange__f_fromRange).Lcom_iz2use_common_TypedRange__f_from));
    var this$7 = $m_RTLong$();
    var $$x1 = $n(mapped).Lcom_iz2use_common_MappedTypedRange__f_fromAmplitude;
    var this$5 = $n(p$2);
    var this$6 = $n($n($as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(this$5.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_leftColumn);
    var value = (($$x1 * (x - $uD((this$6.isEmpty__Z() ? 0.0 : this$6.get__O())))) / $n(mapped).Lcom_iz2use_common_MappedTypedRange__f_toAmplitude);
    var lo = this$7.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var translatedOffset = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$8, this$8.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(lo, hi), $L0, 1);
    var $$x4 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$();
    var $$x2 = $m_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$();
    var this$10 = $n(translatedOffset);
    var u = $n($$x2).apply__s_util_Either__F2__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_s_util_Left(this$10.Ljava_time_LocalDateTime__f_date), new $c_sjsr_AnonFunction2(((v$2, cb$2) => {
      var v = $as_Lreactbuild_model_AllocatedTime(v$2);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$11 = $n(s$2);
      var co = $p_Lreactbuild_analyze_cost_modules_planner_PlannerContent$__updateEvent$1__Lreactbuild_model_AllocatedTime__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__F0($thiz, v, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_StateAccess$ModState(this$11.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$11$2) => {
        $as_s_Option(x$11$2);
        return new $c_s_Some($n(v).Lreactbuild_model_AllocatedTime__f__id)
      })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, p$2);
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$14 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$14.s_$less$colon$less$__f_singleton))
    })), proxy);
    var this$16 = $n(u);
    var n = this$16.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var this$ = $n($$x4).dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lcom_iz2use_react_components_Dialog$Push(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)));
    var f = new $c_sjsr_AnonFunction1(((x$12$2) => {
      $as_jl_Void(x$12$2)
    }));
    var this$19 = $n(this$);
    var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$19, f);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  })));
  var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$22 = $m_s_$less$colon$less$();
  return $n($$x5).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$1, this$22.s_$less$colon$less$__f_singleton)
}
function $p_Lreactbuild_analyze_cost_modules_planner_PlannerContent$__zoomAndTranslate$1__D__D__D__D__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline($thiz, originalX, factor, deltaX, deltaY, p$2) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(p$2);
    var this$3 = $n($n($as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(this$2.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_mapped);
    return ((!this$3.isEmpty__Z()) ? new $c_s_Some(this$3.get__O()) : $m_s_None$())
  }))), new $c_sjsr_AnonFunction1(((mapped$2) => {
    var mapped = $as_Lcom_iz2use_common_MappedTypedRange(mapped$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$4 = $n(p$2);
    var this$5 = $n($n($as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(this$4.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_leftColumn);
    var x = (originalX - $uD((this$5.isEmpty__Z() ? 0.0 : this$5.get__O())));
    var fromAmplitude = $n(mapped).Lcom_iz2use_common_MappedTypedRange__f_fromAmplitude;
    var targetAmplitude = (fromAmplitude * factor);
    var targetOffset = ($n(mapped).Lcom_iz2use_common_MappedTypedRange__f_fromOffset + ((($n(mapped).Lcom_iz2use_common_MappedTypedRange__f_fromAmplitude - targetAmplitude) * x) / $n(mapped).Lcom_iz2use_common_MappedTypedRange__f_toAmplitude));
    var translatedOffset = (targetOffset - ((deltaX * targetAmplitude) / $n(mapped).Lcom_iz2use_common_MappedTypedRange__f_toAmplitude));
    var translateY = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty;
    var this$6 = $n(p$2);
    var this$8 = $n($n($as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(this$6.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_period);
    var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(translateY)));
    var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
    var arg1 = this$8.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    $as_Lcom_iz2use_common_TypedRange(arg1);
    var this$9 = $m_RTLong$();
    var lo = this$9.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(translatedOffset);
    var hi = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var offset = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
    var $$x1 = $m_Ljava_time_LocalDateTime$().ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(new $c_RTLong(lo, hi), 0, offset);
    var this$10 = $m_RTLong$();
    var value = (translatedOffset + targetAmplitude);
    var lo$1 = this$10.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi$1 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var offset$1 = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
    var arg1$1 = new $c_Lcom_iz2use_common_TypedRange($$x1, $m_Ljava_time_LocalDateTime$().ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(new $c_RTLong(lo$1, hi$1), 0, offset$1), $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateTimeOrdering);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$8.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((x$13$2) => {
      $as_jl_Void(x$13$2)
    }));
    var this$12 = $n(this$);
    var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$12, f);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  })));
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$15 = $m_s_$less$colon$less$();
  return $n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$15.s_$less$colon$less$__f_singleton)
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$() {
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_planner_PlannerContent$ = this;
  var this$53 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var $$x7 = $ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api);
  var $$x6 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(p$2);
    return p
  }));
  var $$x5 = new $c_sjsr_AnonFunction1(((p$3$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(p$3$2);
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      $as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(x$1$2);
      return p$3
    }))
  }));
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x7.useDerivedRefBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x6, $$x5, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$5.byRef__F2(), this$5.by_$eq$eq__F2()), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x8 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x4 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$9 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$2 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x8.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x4, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$9)));
  var $$x9 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$2);
  var $$x3 = new $c_sjsr_AnonFunction3(((x$2$2, x$3$2, s$2) => {
    $as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(x$2$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$3$2);
    var s = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$2);
    return s
  }));
  var $$x2 = new $c_sjsr_AnonFunction3(((x$4$2, x$5$2, s$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(x$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$5$2);
    var s$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$3$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$6$2);
      return s$3
    }))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$15 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x9.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$11))));
  var initialState = new $c_sjsr_AnonFunction4(((x$7$2, p$4$2, x$8$2, s$4$2) => {
    $as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(x$7$2);
    var p$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(p$4$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$8$2);
    var s$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(s$4$2);
    return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerContext(new $c_sjsr_AnonFunction4(((originalX$2, factor$2, deltaX$2, deltaY$2) => {
      var originalX = $uD(originalX$2);
      var factor = $uD(factor$2);
      var deltaX = $uD(deltaX$2);
      var deltaY = $uD(deltaY$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lreactbuild_analyze_cost_modules_planner_PlannerContent$__zoomAndTranslate$1__D__D__D__D__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline(this, originalX, factor, deltaX, deltaY, p$4))
    })), new $c_sjsr_AnonFunction1(((x$2$1) => {
      var x = $uD(x$2$1);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lreactbuild_analyze_cost_modules_planner_PlannerContent$__create$1__D__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline(this, x, p$4, s$4))
    })), new $c_sjsr_AnonFunction2(((e$2, cb$2) => {
      var e = $as_Lreactbuild_model_AllocatedTime(e$2);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co = $p_Lreactbuild_analyze_cost_modules_planner_PlannerContent$__updateEvent$1__Lreactbuild_model_AllocatedTime__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__F0(this, e, cb, p$4);
      var $$x10 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$13 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x10).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$13.s_$less$colon$less$__f_singleton))
    })))
  }));
  var this$14 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$14);
  var this$52 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$15, initialState, step)));
  var f$3 = new $c_sjsr_AnonFunction5(((p$5$2, x$14$2, selection$2, x$15$2, context$2) => {
    var p$5 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(p$5$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$14$2);
    var selection = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(selection$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$15$2);
    var context = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(context$2);
    var $$x25 = $m_Lreactbuild_common_components_InteractionController$();
    var this$16 = $n(context);
    var $$x24 = this$16.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var $$x23 = $m_Lreactbuild_analyze_cost_modules_planner_package$().Lreactbuild_analyze_cost_modules_planner_package$__f_PlannerInteractions;
    $m_Lreactbuild_common_components_InteractionController$();
    var $$x22 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty;
    $m_Lreactbuild_common_components_InteractionController$();
    var $$x21 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty;
    var leftColumn = $n(p$5).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_leftColumn;
    var proxy = $n(p$5).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_proxy;
    var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$21 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerContent;
    var $$x18 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$21, s$1);
    var $$x13 = $m_Ldiode_react_ReactPot$potWithReact$();
    var pot = $n(p$5).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_source;
    var $$x12 = $n($$x13).render$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot, new $c_sjsr_AnonFunction1(((ss$2) => {
      var ss = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(ss$2);
      var $$x14 = $m_Ldiode_react_ReactPot$potWithReact$();
      var pot$1 = $n(p$5).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_mapped;
      return $n($$x14).render$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot$1, new $c_sjsr_AnonFunction1(((mapped$2) => {
        var mapped = $as_Lcom_iz2use_common_MappedTypedRange(mapped$2);
        var this$36 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
        var this$24 = $n($as_sci_List($n(ss).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
        var p$1 = new $c_sjsr_AnonFunction1(((v$2) => {
          var v = $as_Lreactbuild_model_AllocatedTime(v$2);
          return $n($n(mapped).Lcom_iz2use_common_MappedTypedRange__f_fromRange).intersects__O__O__Z($n(v).Lreactbuild_model_AllocatedTime__f_from, $n(v).Lreactbuild_model_AllocatedTime__f_until)
        }));
        var this$29 = $n($p_sci_List__filterCommon__F1__Z__sci_List(this$24, p$1, false));
        var f = new $c_sjsr_AnonFunction1(((v$3$2) => {
          var v$3 = $as_Lreactbuild_model_AllocatedTime(v$3$2);
          var startInclusive = $n(v$3).Lreactbuild_model_AllocatedTime__f_from;
          var endExclusive = $n(v$3).Lreactbuild_model_AllocatedTime__f_until;
          return $ct_T2__O__O__(new $c_T2(), $m_Ljava_time_Duration$().between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration(startInclusive, endExclusive), $n(v$3).Lreactbuild_model_AllocatedTime__f_until)
        }));
        var this$27 = $m_s_math_Ordering$();
        var this$26 = $m_s_$less$colon$less$();
        var asComparable = this$26.s_$less$colon$less$__f_singleton;
        var ord1 = new $c_s_math_LowPriorityOrderingImplicits$$anon$2(this$27, asComparable);
        var ord2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateTimeOrdering;
        var ord = new $c_s_math_Ordering$Tuple2Ordering(ord1, ord2);
        var this$30 = $n($as_sc_IterableOps($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$29, f, ord)));
        var f$1 = $n(p$5).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_group;
        var this$31 = $n($f_sc_IterableOps__groupBy__F1__sci_Map(this$30, f$1));
        $m_sci_List$();
        var this$33 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$31));
        var f$2 = new $c_sjsr_AnonFunction1(((x$16$2) => {
          var x$16 = $as_T2(x$16$2);
          return $as_Lreactbuild_common_model_RefTo($n(x$16)._1__O())
        }));
        var ord$1 = $n(p$5).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_ordering;
        var ns = $n($as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$33, f$2, ord$1))).map__F1__sci_List(new $c_sjsr_AnonFunction1(((i$2) => {
          var i = $as_T2(i$2);
          var $$x17 = $m_Lreactbuild_analyze_cost_modules_planner_LineRuler$();
          $m_Lcom_iz2use_common_Textualizable$();
          var v$1 = $n(i)._1__O();
          var ev = $n(p$5).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_textualizable;
          var $$x16 = $n(ev).stringify__O__T(v$1);
          var $$x15 = $as_sci_List($n(i)._2__O());
          var this$35 = $n(context);
          return $n($$x17).apply__T__sci_List__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__Lcom_iz2use_common_MappedTypedRange__s_Option__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_VdomElement($$x16, $$x15, selection, $n($as_Lreactbuild_analyze_cost_modules_planner_PlannerContext(this$35.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])).Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_updateEvent, mapped, leftColumn, proxy)
        })));
        return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$36, null, ns)
      })))
    })));
    var $$x11 = $m_Ldiode_react_ReactPot$potWithReact$();
    var pot$2 = $n(p$5).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_source;
    var array$1 = [$$x18, $$x12, $n($$x11).renderFailed$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot$2, new $c_sjsr_AnonFunction1(((v$2$1) => {
      var v$4 = $as_jl_Throwable(v$2$1);
      var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$5 = ("Une erreur s'est produite : " + v$4);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
      return $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    })))];
    var u = $n($$x25).apply__O__Lreactbuild_common_components_Interactions__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x24, $$x23, $$x22, $$x21, $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
    var this$49 = $n(u);
    var n = this$49.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$51 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$51);
  var s$5 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$52, f$3, step$1, s$5);
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$53, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.planner.PlannerContent.component"))
}
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_PlannerContent$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_PlannerContent$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$.prototype.apply__Ldiode_data_Pot__Ljapgolly_scalajs_react_extra_StateSnapshotF__s_Option__F1__F1__Ldiode_data_Pot__Ldiode_react_ModelProxy__s_math_Ordering__Lcom_iz2use_common_Textualizable__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(mapped, period, leftColumn, group, renderItem, source, proxy, ordering, textualizable) {
  var c = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(mapped, period, leftColumn, source, group, renderItem, ordering, textualizable, proxy);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_planner_PlannerContent$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_PlannerContent$: 0
}, false, "reactbuild.analyze.cost.modules.planner.PlannerContent$", {
  Lreactbuild_analyze_cost_modules_planner_PlannerContent$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_PlannerContent$;
var $n_Lreactbuild_analyze_cost_modules_planner_PlannerContent$;
function $m_Lreactbuild_analyze_cost_modules_planner_PlannerContent$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_PlannerContent$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_PlannerContent$ = new $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_PlannerContent$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$() {
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_planner_TimeRuler$ = this;
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("TimeRuler", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__Lreactbuild_analyze_cost_modules_planner_TimeRuler$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_TimeRuler$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_TimeRuler$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_common_MappedTypedRange__Lreactbuild_analyze_cost_modules_planner_ChronoScale__s_Option__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(period, mapped, timeScale, leftColumn) {
  var c = this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props(period, mapped, timeScale, leftColumn);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_planner_TimeRuler$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_TimeRuler$: 0
}, false, "reactbuild.analyze.cost.modules.planner.TimeRuler$", {
  Lreactbuild_analyze_cost_modules_planner_TimeRuler$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_TimeRuler$;
var $n_Lreactbuild_analyze_cost_modules_planner_TimeRuler$;
function $m_Lreactbuild_analyze_cost_modules_planner_TimeRuler$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_TimeRuler$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_TimeRuler$ = new $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_TimeRuler$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_package$() {
  this.Lreactbuild_analyze_cost_modules_planner_package$__f_PlannerInteractions = null;
  $n_Lreactbuild_analyze_cost_modules_planner_package$ = this;
  var array = [$m_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$(), $m_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$()];
  var interactions = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  $m_sci_List$();
  var orderedList = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(interactions);
  this.Lreactbuild_analyze_cost_modules_planner_package$__f_PlannerInteractions = new $c_Lreactbuild_common_components_Interactions(orderedList)
}
$c_Lreactbuild_analyze_cost_modules_planner_package$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_package$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_package$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_package$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_package$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_package$.prototype;
var $d_Lreactbuild_analyze_cost_modules_planner_package$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_package$: 0
}, false, "reactbuild.analyze.cost.modules.planner.package$", {
  Lreactbuild_analyze_cost_modules_planner_package$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_package$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_package$;
var $n_Lreactbuild_analyze_cost_modules_planner_package$;
function $m_Lreactbuild_analyze_cost_modules_planner_package$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_package$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_package$ = new $c_Lreactbuild_analyze_cost_modules_planner_package$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_package$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$() {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$ = this;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("CompareProjectTable", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$.prototype.apply__sci_List__Ldiode_data_Pot__F1__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(projects, resourceUsage, showDetails, pageProps) {
  var c = this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props(projects, resourceUsage, showDetails, pageProps);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjectTable$: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjectTable$", {
  Lreactbuild_analyze_cost_modules_project_CompareProjectTable$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$;
var $n_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$;
function $m_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$)) {
    $n_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$ = new $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$() {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$ = this;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props(p$2);
    var pageProps = $n(p).Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_pageProps;
    var this$13 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$12 = $n($n(p).Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_projects);
    var f = ((ref$2) => {
      var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
      var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$5 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$5, proxy);
      var v = $n(ev).stringify__O__T(ref);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    });
    if ((this$12 === $m_sci_Nil$())) {
      var ns = $m_sci_Nil$()
    } else {
      var arg1 = this$12.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$12.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var ns = h
    };
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$13, null, ns)
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$.prototype.apply__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(projects, pageProps) {
  var c = this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props(projects, pageProps);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjectTableHeader$", {
  Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$;
var $n_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$;
function $m_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$)) {
    $n_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$ = new $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$() {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_project_CompareProjects$ = this;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("CompareProjects", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State($m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__Lreactbuild_analyze_cost_modules_project_CompareProjects$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_project_CompareProjects$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjects$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjects$.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$.prototype.apply__Ldiode_data_Pot__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(projects, pageProps) {
  var c = this.Lreactbuild_analyze_cost_modules_project_CompareProjects$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props(projects, pageProps);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjects$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjects$: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjects$", {
  Lreactbuild_analyze_cost_modules_project_CompareProjects$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjects$;
var $n_Lreactbuild_analyze_cost_modules_project_CompareProjects$;
function $m_Lreactbuild_analyze_cost_modules_project_CompareProjects$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_CompareProjects$)) {
    $n_Lreactbuild_analyze_cost_modules_project_CompareProjects$ = new $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_CompareProjects$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$() {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$ = this;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().getDerivedStateFromPropsAndState$extension__T__F2__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ComputeCompareProjectsBuildingStageGroups", new $c_sjsr_AnonFunction2(((p$2, os$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props(p$2);
    var os = $as_s_Option(os$2);
    var $$x4 = $n($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_resourceUsage).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$13$2) => {
      var x$13 = $as_sci_List(x$13$2);
      var this$2 = $n(x$13);
      var m = $as_scm_Map($m_scm_Map$().empty__O());
      var it = this$2.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var elem = $n(it).next__O();
        var x$14 = $as_Lreactbuild_project_ResourceUsage(elem);
        var key = $as_s_Option($n(x$14).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((v$2) => {
          var v = $as_Lreactbuild_project_ProductResourceUsage(v$2);
          return $n(v).Lreactbuild_project_ProductResourceUsage__f_buildingStage
        })), new $c_sjsr_AnonFunction1(((x$15$2) => {
          $as_Lreactbuild_project_PersonResourceUsage(x$15$2);
          return $m_s_None$()
        }))));
        var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => {
          $m_sci_List$();
          return new $c_scm_ListBuffer()
        }))));
        var this$4 = $n(bldr);
        this$4.addOne__O__scm_Growable(elem)
      };
      var this$5 = $m_sci_HashMap$();
      var result = this$5.sci_HashMap$__f_EmptyMap;
      var mapIt = $n(m).iterator__sc_Iterator();
      while ($n(mapIt).hasNext__Z()) {
        var x1 = $as_T2($n(mapIt).next__O());
        if ((x1 === null)) {
          throw new $c_s_MatchError(x1)
        };
        var k = $n(x1)._1__O();
        var v$1 = $as_scm_Builder($n(x1)._2__O());
        result = $n(result).updated__O__O__sci_HashMap(k, $n(v$1).result__O())
      };
      return result
    })));
    var this$6 = $n(os);
    if (this$6.isEmpty__Z()) {
      var $$x3 = $m_s_None$()
    } else {
      var arg1 = this$6.get__O();
      var x$16 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State(arg1);
      var $$x3 = new $c_s_Some($n(x$16).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails)
    };
    var this$7 = $n($$x3);
    return new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State($$x4, $as_sci_Set((this$7.isEmpty__Z() ? ($n($m_s_Predef$().s_Predef$__f_Set), $m_sci_Set$EmptySet$()) : this$7.get__O())))
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend($n(x$3).backend__O()));
    var this$9 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props($n(this$9.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$10 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$10)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$.prototype.apply__sci_List__Ldiode_data_Pot__F1__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(projects, resourceUsage, showDetails, pageProps) {
  var c = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props(projects, resourceUsage, showDetails, pageProps);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$;
var $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$;
function $m_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$ = new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$() {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$ = this;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().getDerivedStateFromPropsAndState$extension__T__F2__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ComputeCompareProjectsGroup", new $c_sjsr_AnonFunction2(((p$2, os$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props(p$2);
    $as_s_Option(os$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State($n($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_resourceUsage).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$20$2) => {
      var x$20 = $as_sci_List(x$20$2);
      var this$8 = $n($as_sc_SortedMapOps($m_sci_SortedMap$().apply__sci_Seq__s_math_Ordering__O($m_sci_Nil$(), $m_s_math_Ordering$String$())));
      var this$2 = $n(x$20);
      var m = $as_scm_Map($m_scm_Map$().empty__O());
      var it = this$2.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var elem = $n(it).next__O();
        var x$21 = $as_Lreactbuild_project_ResourceUsage(elem);
        var key = $as_T($n(x$21).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((v$2) => {
          var v = $as_Lreactbuild_project_ProductResourceUsage(v$2);
          var this$3 = $n($n(v).Lreactbuild_project_ProductResourceUsage__f_reference);
          return $as_T((this$3.isEmpty__Z() ? $n(v).Lreactbuild_project_ProductResourceUsage__f_description : this$3.get__O()))
        })), new $c_sjsr_AnonFunction1(((x$22$2) => {
          var x$22 = $as_Lreactbuild_project_PersonResourceUsage(x$22$2);
          var this$4 = $n($n(x$22).Lreactbuild_project_PersonResourceUsage__f_person);
          return $m_sr_ScalaRunTime$()._toString__s_Product__T(this$4)
        }))));
        var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => {
          $m_sci_List$();
          return new $c_scm_ListBuffer()
        }))));
        var this$6 = $n(bldr);
        this$6.addOne__O__scm_Growable(elem)
      };
      var this$7 = $m_sci_HashMap$();
      var result = this$7.sci_HashMap$__f_EmptyMap;
      var mapIt = $n(m).iterator__sc_Iterator();
      while ($n(mapIt).hasNext__Z()) {
        var x1 = $as_T2($n(mapIt).next__O());
        if ((x1 === null)) {
          throw new $c_s_MatchError(x1)
        };
        var k = $n(x1)._1__O();
        var v$1 = $as_scm_Builder($n(x1)._2__O());
        result = $n(result).updated__O__O__sci_HashMap(k, $n(v$1).result__O())
      };
      var xs = result;
      return $as_sci_SortedMap(this$8.concat__sc_IterableOnce__sc_Map(xs))
    }))))
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend($n(x$3).backend__O()));
    var this$9 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props($n(this$9.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$10 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$10)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$.prototype.apply__sci_List__Ldiode_data_Pot__F1__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(projects, resourceUsage, showDetails, pageProps) {
  var c = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props(projects, resourceUsage, showDetails, pageProps);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$;
var $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$;
function $m_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$ = new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$() {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$__f_numPrice = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$ = this;
  var e = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_numericPrice;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$__f_numPrice = e;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ComputeCompareProjectsProductLine", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State(false)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$.prototype.apply__T__T__sci_List__Ldiode_data_Pot__F1__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, label, projects, resourceUsage, showDetails, pageProps) {
  var c = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props(label, projects, resourceUsage, showDetails, pageProps);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$;
var $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$;
function $m_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$ = new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$() {
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$__f_decodeEither = null;
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$__f_allowedFormat = null;
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_project_InsertionPoint$ = this;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var decodeB = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$__f_decodeEither = new $c_Lio_circe_Decoder$$anon$52("left", "right", decodeA, decodeB);
  $n($m_s_package$().s_package$__f_List);
  var array = ["jpeg", "png"];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$7 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var f = ((x$10$2) => {
    var x$10 = $as_T(x$10$2);
    return ("image/" + x$10)
  });
  if ((this$7 === $m_sci_Nil$())) {
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = this$7.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$7.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x1 = h
  };
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$__f_allowedFormat = $$x1;
  var this$37 = $m_Lcom_iz2use_react_hooks_package$();
  var this$11 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var evidence$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_scalajs_dom_Element.getClassOf());
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefToVdom__s_reflect_ClassTag__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$11, evidence$1, step));
  var $$x4 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x3 = new $c_sjsr_AnonFunction2(((p$2, ref$2) => {
    $as_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(p$2);
    var ref = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$2);
    return ref
  }));
  var $$x2 = new $c_sjsr_AnonFunction2(((p$3$2, ref$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(p$3$2);
    $as_Ljapgolly_scalajs_react_Ref$FullF(ref$3$2);
    var rassoc$1 = $m_Lreactbuild_analyze_cost_modules_project_ProjectImage$().Lreactbuild_analyze_cost_modules_project_ProjectImage$__f_contentType;
    var this$13 = $n($m_s_package$().s_package$__f_Nil);
    return new $c_Lreactbuild_hooks_AcceptDrop(new $c_sci_$colon$colon(rassoc$1, this$13), true)
  }));
  var this$14 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$36 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($$x4.useDropBy__O__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$14))));
  var f$2 = new $c_sjsr_AnonFunction3(((p$4$2, ref$4$2, drop$2) => {
    var p$4 = $as_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(p$4$2);
    var ref$4 = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$4$2);
    var drop = $as_Lreactbuild_hooks_Dnd$DropResult(drop$2);
    $n($n(drop).Lreactbuild_hooks_Dnd$DropResult__f_onDrop).apply__O__O(new $c_sjsr_AnonFunction1(((ev$2) => {
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().orElse$extension__F0__F0__F0($m_Lreactbuild_analyze_cost_modules_project_InsertionPoint$().handleFiles__Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__Lorg_scalajs_dom_DragEvent__F0(p$4, ev$2), $m_Lreactbuild_analyze_cost_modules_project_InsertionPoint$().handleProjectImage__Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__Lorg_scalajs_dom_DragEvent__F0(p$4, ev$2)), new $c_sjsr_AnonFunction1(((x$25$2) => {
        $as_jl_Void(x$25$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(p$4).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_resetDrag).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f$1 = new $c_sjsr_AnonFunction1(((x$24$2) => {
          $as_jl_Void(x$24$2)
        }));
        var this$16 = $n(this$);
        var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$16, f$1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
      })));
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$19 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$19.s_$less$colon$less$__f_singleton))
    })));
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var t$1 = "div";
    var $$x9 = $n($ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(new $c_Ljapgolly_scalajs_react_vdom_TagOf(), t$1, $m_s_package$().s_package$__f_Nil).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(ref$4)));
    var this$24 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_projectImageListInsertionPoint;
    var $$x8 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$24, s);
    var this$25 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_projectImageListInsertionPointDragging;
    var this$27 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$25, s$1));
    var this$26 = $n($as_s_Option($n($n($n(p$4).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragSource).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
    var condition = (!this$26.isEmpty__Z());
    var $$x7 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$27, condition);
    var this$28 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_projectImageListInsertionPointDragOver;
    var this$29 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$28, s$2));
    var condition$1 = $n(drop).Lreactbuild_hooks_Dnd$DropResult__f_isOver;
    var $$x6 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$29, condition$1);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = ("" + $n(p$4).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_index);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$1 = [$$x8, $$x7, $$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x9).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  }));
  var this$35 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$35);
  var s$3 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$36, f$2, step$1, s$3);
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$37, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.project.InsertionPoint.component"))
}
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_InsertionPoint$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_InsertionPoint$.prototype = $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$.prototype.handleFiles__Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__Lorg_scalajs_dom_DragEvent__F0 = (function(p, ev) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).pure__O__F0(ev.dataTransfer.files), new $c_sjsr_AnonFunction1(((files$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => {
    var this$3 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(files$2);
    return $f_sc_SeqOps__isEmpty__Z(this$3)
  }))), new $c_sjsr_AnonFunction1(((x$19$2) => {
    $as_jl_Void(x$19$2);
    var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$5 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(files$2);
    var p$1 = new $c_sjsr_AnonFunction1(((file$2) => $n($m_Lreactbuild_analyze_cost_modules_project_InsertionPoint$().Lreactbuild_analyze_cost_modules_project_InsertionPoint$__f_allowedFormat).contains__O__Z($as_T(file$2.type))));
    var x1$2 = $f_sc_IterableOps__span__F1__T2(this$5, p$1);
    if ((x1$2 !== null)) {
      var accepted = $as_sc_Seq($n(x1$2)._1__O());
      var rejected = $as_sc_Seq($n(x1$2)._2__O());
      var x$11 = $ct_T2__O__O__(new $c_T2(), accepted, rejected)
    } else {
      var x$11;
      throw new $c_s_MatchError(x1$2)
    };
    $as_sc_Seq($n(x$11)._1__O());
    var rejected$2 = $as_sc_Seq($n(x$11)._2__O());
    var this$6 = $n(rejected$2);
    if ((!this$6.isEmpty__Z())) {
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x2 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
      var this$7 = $n(rejected$2);
      var f = new $c_sjsr_AnonFunction1(((x$12$2) => $as_T(x$12$2.type)));
      var this$9 = $n($as_sc_IterableOnceOps($n($f_sc_IterableOps__groupBy__F1__sci_Map(this$7, f)).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
        var x0$1 = $as_T2(x0$1$2);
        if ((x0$1 !== null)) {
          var list = $as_sc_Seq($n(x0$1)._2__O());
          var this$8 = $n($as_sc_IterableOnceOps($n(list).map__F1__O(new $c_sjsr_AnonFunction1(((x$13$2) => $as_T(x$13$2.name))))));
          return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "", ", ", "")
        } else {
          throw new $c_s_MatchError(x0$1)
        }
      })))));
      var $$x1 = $n($$x4).$greater$greater$extension__F0__F0__F0($n($$x3).toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($$x2).alert__T__Ljapgolly_scalajs_react_callback_Trampoline(("Actuellement seules les images de type jpeg ou png sont accept\u00e9es. " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$9, "", "\n", "")))), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0())
    } else {
      var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).pass__F0()
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x5).flatMap$extension__F0__F1__F0($$x1, new $c_sjsr_AnonFunction1(((x$18$2) => {
      $as_jl_Void(x$18$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x15 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x14 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x13 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
      var $$x12 = new $c_sjsr_AnonFunction0((() => {
        var this$11 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(files$2);
        $m_sci_List$();
        return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$11)
      }));
      var $$x6 = new $c_sjsr_AnonFunction1(((file$2$1) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
        var withHeaders = new Headers();
        withHeaders.set("filename", $as_T(file$2$1.name));
        var $$x8 = $m_Lreactbuild_common_AjaxJson$();
        var a$3 = (() => {
          var file$1 = null;
          var withHeaders$1 = null;
          file$1 = file$2$1;
          withHeaders$1 = withHeaders;
          var this$16 = {};
          var a = $m_Lorg_scalajs_dom_HttpMethod$().Lorg_scalajs_dom_HttpMethod$__f_POST;
          this$16.method = a;
          var a$1 = file$1;
          this$16.body = a$1;
          var a$2 = withHeaders$1;
          this$16.headers = a$2;
          return this$16
        })();
        var $$x7 = $m_Lreactbuild_common_AjaxJson$().fetch$default$3__F0();
        $m_Lio_circe_Decoder$();
        var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
        var decodeV = $m_Lreactbuild_analyze_cost_modules_project_InsertionPoint$().Lreactbuild_analyze_cost_modules_project_InsertionPoint$__f_decodeEither;
        return $n($$x8).fetch__sjs_js_$bar__sjs_js_$bar__F0__Lio_circe_Decoder__s_concurrent_ExecutionContext__s_concurrent_Future("/api/file", a$3, $$x7, new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeV), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((result$2) => {
        var result = $as_sci_Map(result$2);
        var $$x11 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
        var this$38 = $n(result);
        var this$39 = $n($f_sc_IterableOps__headOption__s_Option(this$38));
        var f$1 = new $c_sjsr_AnonFunction1(((x$14$2) => {
          var x$14 = $as_T2(x$14$2);
          return $as_s_util_Either($n(x$14)._2__O())
        }));
        var this$45 = $n((this$39.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$1.apply__O__O(this$39.get__O()))));
        var ifEmpty = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).alert__T__Ljapgolly_scalajs_react_callback_Trampoline((("Le fichier " + $as_T(file$2$1.name)) + " n'a pas pu \u00eatre enregistr\u00e9.")))));
        var f$2 = new $c_sjsr_AnonFunction1(((x0$2$2) => {
          var x0$2 = $as_s_util_Either(x0$2$2);
          if ((x0$2 instanceof $c_s_util_Right)) {
            var x2 = $as_s_util_Right(x0$2);
            var value = $as_Lreactbuild_common_model_RefTo($n(x2).s_util_Right__f_value);
            var $$x10 = $n($n(p).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_update;
            $n($m_s_package$().s_package$__f_List);
            var array = [new $c_Lreactbuild_common_model_Image(("file/" + $n(value).Lreactbuild_common_model_RefTo__f_id), 1280, 720, "", $m_s_None$())];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            var $$x9 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x10).apply__O__O__O(new $c_s_util_Left($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $m_s_Option$().apply__O__s_Option($n(p).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_index)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
          } else if ((x0$2 instanceof $c_s_util_Left)) {
            var $$x9 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).alert__T__Ljapgolly_scalajs_react_callback_Trampoline(("Impossible de traiter le fichier " + $as_T(file$2$1.name)))
          } else {
            var $$x9;
            throw new $c_s_MatchError(x0$2)
          };
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x9)
        }));
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo((this$45.isEmpty__Z() ? ifEmpty.apply__O() : f$2.apply__O__O(this$45.get__O())))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x11).map$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1(cb), new $c_sjsr_AnonFunction1(((x$15$2) => {
          $as_jl_Void(x$15$2)
        }))))
      }))))));
      var this$46 = $m_sc_BuildFrom$();
      var c = $n($$x15).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($$x14).toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($$x13).traverse__F0__F1__sc_BuildFrom__F1($$x12, $$x6, new $c_sc_BuildFromLowPriority2$$anon$11(this$46))), new $c_sjsr_AnonFunction1(((x$17$2) => {
        $as_jl_Void(x$17$2);
        var $$x16 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
        var array$1 = [files$2];
        var this$ = $n($$x16).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline("handle files !!!", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
        var f$3 = new $c_sjsr_AnonFunction1(((x$16$2) => {
          $as_jl_Void(x$16$2)
        }));
        var this$51 = $n(this$);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$51, f$3))
      })));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    }))))
  })))))))
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$.prototype.handleProjectImage__Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__Lorg_scalajs_dom_DragEvent__F0 = (function(p, ev) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).pure__O__F0($as_T(ev.dataTransfer.getData($m_Lreactbuild_analyze_cost_modules_project_ProjectImage$().Lreactbuild_analyze_cost_modules_project_ProjectImage$__f_contentType))), new $c_sjsr_AnonFunction1(((data$2) => {
    var data = $as_T(data$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => {
      var this$2 = $n(data);
      return (this$2 === "")
    }))), new $c_sjsr_AnonFunction1(((x$23$2) => {
      $as_jl_Void(x$23$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x1 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
      var array = [data, ev.dataTransfer];
      var c$1 = $n($$x2).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($$x1).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline("handle project image !!!", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), new $c_sjsr_AnonFunction1(((x$22$2) => {
        $as_jl_Void(x$22$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => $as_s_Option($n($n($n(p).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragSource).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)))), new $c_sjsr_AnonFunction1(((source$2) => {
          var source = $as_Lreactbuild_common_model_Image(source$2);
          $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(p).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_indexOf).apply__O__O(source))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var f = new $c_sjsr_AnonFunction1(((sourceIndex$2) => {
            var sourceIndex = $uI(sourceIndex$2);
            var targetIndex = $n(p).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_index;
            return new $c_T2$mcII$sp(sourceIndex, targetIndex)
          }));
          var this$7 = $n(this$);
          var c = $n($$x3).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$7, f), new $c_sjsr_AnonFunction1(((x$21$2) => {
            var x$21 = $as_T2(x$21$2);
            if ((x$21 !== null)) {
              var sourceIndex$1 = $n(x$21)._1$mcI$sp__I();
              var targetIndex$1 = $n(x$21)._2$mcI$sp__I();
              var $$x5 = $n($n(p).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_update;
              $n($m_s_package$().s_package$__f_Range);
              var end = ((1 + sourceIndex$1) | 0);
              var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).apply__O__O__O(new $c_s_util_Right(new $c_sci_Range$Exclusive(sourceIndex$1, end, 1)), $m_s_Option$().apply__O__s_Option(targetIndex$1)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
              var f$1 = new $c_sjsr_AnonFunction1(((x$20$2) => {
                $as_jl_Void(x$20$2)
              }));
              var this$10 = $n(this$$1);
              var $$x4 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$10, f$1)
            } else {
              var $$x4;
              throw new $c_s_MatchError(x$21)
            };
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x4)
          })));
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
        })));
        var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$13 = $m_s_$less$colon$less$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x6).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$13.s_$less$colon$less$__f_singleton))
      })));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1))
    }))))
  })))
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$.prototype.apply__I__Lreactbuild_analyze_cost_modules_project_ProjectImageContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(index, context) {
  var c = this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(index, context);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_project_InsertionPoint$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_InsertionPoint$: 0
}, false, "reactbuild.analyze.cost.modules.project.InsertionPoint$", {
  Lreactbuild_analyze_cost_modules_project_InsertionPoint$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_InsertionPoint$;
var $n_Lreactbuild_analyze_cost_modules_project_InsertionPoint$;
function $m_Lreactbuild_analyze_cost_modules_project_InsertionPoint$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_InsertionPoint$)) {
    $n_Lreactbuild_analyze_cost_modules_project_InsertionPoint$ = new $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_InsertionPoint$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$() {
  this.Lreactbuild_analyze_cost_modules_project_ProjectImage$__f_contentType = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImage$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_project_ProjectImage$ = this;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImage$__f_contentType = "reactbuild/project-image-url";
  var this$23 = $m_Lcom_iz2use_react_hooks_package$();
  var this$4 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var evidence$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_scalajs_dom_Element.getClassOf());
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefToVdom__s_reflect_ClassTag__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$4, evidence$1, step));
  var $$x2 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x1 = new $c_sjsr_AnonFunction2(((x$26$2, ref$2) => {
    $as_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props(x$26$2);
    var ref = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$2);
    return ref
  }));
  var this$7 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$22 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($$x2.useDragBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$7))));
  var f = new $c_sjsr_AnonFunction3(((p$2, ref$3$2, drag$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props(p$2);
    var ref$3 = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$3$2);
    var drag = $as_Lreactbuild_hooks_Dnd$DragResult(drag$2);
    $n($n(drag).Lreactbuild_hooks_Dnd$DragResult__f_onStart).apply__O__O(new $c_sjsr_AnonFunction1(((dataTransfer$2) => {
      dataTransfer$2.setData($m_Lreactbuild_analyze_cost_modules_project_ProjectImage$().Lreactbuild_analyze_cost_modules_project_ProjectImage$__f_contentType, $n($n(p).Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_image).Lreactbuild_common_model_Image__f_url);
      var this$8 = $n($n($n(p).Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_context).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragSource);
      var callback = new $c_sjsr_AnonFunction0((() => {
        var this$9 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$10 = $n(this$9.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$10.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
      }));
      var this$11 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var G = this$11.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var arg1 = this$8.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      $as_s_Option(arg1);
      var arg1$1 = $m_s_Option$().apply__O__s_Option($n(p).Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_image);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$8.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    })));
    $n($n(drag).Lreactbuild_hooks_Dnd$DragResult__f_onEnd).apply__O__O($n($n(p).Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_context).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_resetDrag);
    var this$12 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    var t = $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T(this$12);
    var $$x5 = $n($ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(new $c_Ljapgolly_scalajs_react_vdom_TagOf(), t, $m_s_package$().s_package$__f_Nil).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(ref$3)));
    var $$x4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n($n(p).Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_image).fullPath__T__T($m_Lreactbuild_package$().Lreactbuild_package$__f_scheme), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$15 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_projectImageListEntry;
    var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$15, s);
    var this$16 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_projectImageListEntryDragged;
    var this$17 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$16, s$1));
    var condition = $n(drag).Lreactbuild_hooks_Dnd$DragResult__f_isDragging;
    var array = [$$x4, $$x3, $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$17, condition)];
    return $n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  var this$21 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$21);
  var s$2 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$22, f, step$1, s$2);
  this.Lreactbuild_analyze_cost_modules_project_ProjectImage$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$23, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.project.ProjectImage.component"))
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectImage$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectImage$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$.prototype.apply__Lreactbuild_common_model_Image__Lreactbuild_analyze_cost_modules_project_ProjectImageContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(image, context) {
  var c = this.Lreactbuild_analyze_cost_modules_project_ProjectImage$__f_component;
  var $$x1 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  var a = $n(image).Lreactbuild_common_model_Image__f_url;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x1).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
  var props = new $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props(image, context);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_project_ProjectImage$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectImage$: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectImage$", {
  Lreactbuild_analyze_cost_modules_project_ProjectImage$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectImage$;
var $n_Lreactbuild_analyze_cost_modules_project_ProjectImage$;
function $m_Lreactbuild_analyze_cost_modules_project_ProjectImage$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ProjectImage$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ProjectImage$ = new $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ProjectImage$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$() {
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$__f_reusableImage = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_project_ProjectImageList$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_common_model_Image(x$1$2);
    return $n(x$1).Lreactbuild_common_model_Image__f_url
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$__f_reusableImage = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ProjectImageList", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State($m_s_None$(), $m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend($n(x$3).backend__O()));
    var this$6 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props($n(this$6.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$7 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$7)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectImageList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectImageList$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$.prototype.updatedList__sci_Seq__s_util_Either__s_Option__sci_List = (function(images, source, target) {
  if ($n(target).isEmpty__Z()) {
    var toInsert = $m_s_package$().s_package$__f_Nil
  } else {
    var $$x1 = $m_s_util_Either$MergeableEither$();
    var this$1 = $n(source);
    if ((this$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$1);
      var b = $n(x2).s_util_Right__f_value;
      var range = $as_sci_Range(b);
      var x = new $c_s_util_Right($n($as_sc_IterableOnceOps($n(images).slice__I__I__O($n(range).sci_Range__f_start, $n(range).sci_Range__f_end))).toList__sci_List())
    } else {
      var x = this$1
    };
    var toInsert = $as_sci_List($n($$x1).merge$extension__s_util_Either__O(x))
  };
  var removed = $as_sci_Seq($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(source).toOption__s_Option())).foldLeft__O__F2__O(images, new $c_sjsr_AnonFunction2(((acc$2, range$3$2) => {
    var acc = $as_sci_Seq(acc$2);
    var range$3 = $as_sci_Range(range$3$2);
    return $as_sci_Seq($n(acc).patch__I__sc_IterableOnce__I__O($n(range$3).sci_Range__f_start, $m_s_package$().s_package$__f_Nil, $n(range$3).length__I()))
  }))));
  var added = $as_sci_Seq($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(target)).foldLeft__O__F2__O(removed, new $c_sjsr_AnonFunction2(((acc$3$2, target$2$2) => {
    var acc$3 = $as_sci_Seq(acc$3$2);
    var target$2 = $uI(target$2$2);
    var this$4 = $n(source);
    if ((this$4 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$4);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var rng = $as_sci_Range(b$1);
      var offsetedTarget = (($n(rng).sci_Range__f_start < target$2) ? ((target$2 - $n(rng).length__I()) | 0) : 0)
    } else {
      if ((!(this$4 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(this$4)
      };
      var x3 = $as_s_util_Left(this$4);
      var a = $n(x3).s_util_Left__f_value;
      $as_sci_List(a);
      var offsetedTarget = 0
    };
    return $as_sci_Seq($n(acc$3).patch__I__sc_IterableOnce__I__O(offsetedTarget, toInsert, 0))
  }))));
  return $n(added).toList__sci_List()
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(images) {
  var c = this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(images);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_modules_project_ProjectImageList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectImageList$: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectImageList$", {
  Lreactbuild_analyze_cost_modules_project_ProjectImageList$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectImageList$;
var $n_Lreactbuild_analyze_cost_modules_project_ProjectImageList$;
function $m_Lreactbuild_analyze_cost_modules_project_ProjectImageList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ProjectImageList$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ProjectImageList$ = new $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ProjectImageList$
}
function $p_Lreactbuild_analyze_cost_ui_GraphOverTime$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().getDerivedStateFromPropsAndState$extension__T__F2__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("GraphOverTime", new $c_sjsr_AnonFunction2(((p$2, s$2) => {
    var p = $as_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps(p$2);
    $as_s_Option(s$2);
    return $n(p).deriveState__Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState()
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_GraphOverTime$() {
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$__f_component = null;
  $n_Lreactbuild_analyze_cost_ui_GraphOverTime$ = this;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$__f_component = $n($n($n($p_Lreactbuild_analyze_cost_ui_GraphOverTime$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_GraphOverTime$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_GraphOverTime$.prototype = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$.prototype;
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$.prototype.apply__I__I__Lcom_iz2use_common_TypedRange__sc_Iterable__F1__F1__F1__s_math_Numeric__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(width, height, rangeDate, values, getDate, getNumeric, wrapPoint, numericU) {
  var c = this.Lreactbuild_analyze_cost_ui_GraphOverTime$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps(width, height, rangeDate, values, getDate, getNumeric, wrapPoint, numericU);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_ui_GraphOverTime$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_GraphOverTime$: 0
}, false, "reactbuild.analyze.cost.ui.GraphOverTime$", {
  Lreactbuild_analyze_cost_ui_GraphOverTime$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_GraphOverTime$;
var $n_Lreactbuild_analyze_cost_ui_GraphOverTime$;
function $m_Lreactbuild_analyze_cost_ui_GraphOverTime$() {
  if ((!$n_Lreactbuild_analyze_cost_ui_GraphOverTime$)) {
    $n_Lreactbuild_analyze_cost_ui_GraphOverTime$ = new $c_Lreactbuild_analyze_cost_ui_GraphOverTime$()
  };
  return $n_Lreactbuild_analyze_cost_ui_GraphOverTime$
}
function $p_Lreactbuild_analyze_cost_ui_ItemDetailView$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ItemDetailView", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps(p$2);
    return new $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState($m_s_package$().s_package$__f_Nil, $n($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler).initialState__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase(p))
  })))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_ItemDetailView$() {
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$__f_component = null;
  $n_Lreactbuild_analyze_cost_ui_ItemDetailView$ = this;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$__f_component = $n($n($n($p_Lreactbuild_analyze_cost_ui_ItemDetailView$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_ItemDetailView$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_ItemDetailView$.prototype = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$.prototype;
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$.prototype.apply__Ldiode_react_ModelProxy__s_Option__Lreactbuild_analyze_cost_ui_ItemDetailViewHandler__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(proxy, active, handler, reusability) {
  var c = this.Lreactbuild_analyze_cost_ui_ItemDetailView$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps(proxy, active, handler, reusability);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_ui_ItemDetailView$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_ItemDetailView$: 0
}, false, "reactbuild.analyze.cost.ui.ItemDetailView$", {
  Lreactbuild_analyze_cost_ui_ItemDetailView$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_ItemDetailView$;
var $n_Lreactbuild_analyze_cost_ui_ItemDetailView$;
function $m_Lreactbuild_analyze_cost_ui_ItemDetailView$() {
  if ((!$n_Lreactbuild_analyze_cost_ui_ItemDetailView$)) {
    $n_Lreactbuild_analyze_cost_ui_ItemDetailView$ = new $c_Lreactbuild_analyze_cost_ui_ItemDetailView$()
  };
  return $n_Lreactbuild_analyze_cost_ui_ItemDetailView$
}
function $is_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase)))
}
function $as_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase(obj) {
  return (($is_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ui.ItemDetailViewHandler$DetailStateBase"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ui.ItemDetailViewHandler$DetailStateBase;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_Admin$() {
  this.Lreactbuild_analyze_cost_views_Admin$__f_component = null;
  $n_Lreactbuild_analyze_cost_views_Admin$ = this;
  this.Lreactbuild_analyze_cost_views_Admin$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Admin", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_views_Admin$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_views_Admin$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_views_Admin$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_views_Admin$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_views_Admin$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_views_Admin$Props__Lreactbuild_analyze_cost_views_Admin$State__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lreactbuild_analyze_cost_views_Admin$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_views_Admin$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_Admin$.prototype.constructor = $c_Lreactbuild_analyze_cost_views_Admin$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_Admin$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_Admin$.prototype = $c_Lreactbuild_analyze_cost_views_Admin$.prototype;
$c_Lreactbuild_analyze_cost_views_Admin$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomElement = (function() {
  var this$44 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var $$x10 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
    var $$x6 = new $c_sjsr_AnonFunction0((() => {
      var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x9 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
      var $$x8 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "common", "CommonApi", "getLibrary"];
      var $$x7 = $as_sci_Seq($n($$x8).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$6 = $n($m_s_Predef$().s_Predef$__f_Map);
      var elems = $m_sci_Nil$();
      return $n($n($$x9).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x7, this$6.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$9 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lreactbuild_common_model_AssetDefinition$().Lreactbuild_common_model_AssetDefinition$__f_codecForAssetDefinition;
        var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
        return $as_sci_List(this$9.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
    }));
    var $$x2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$1 = $as_Ldiode_data_Pot(x$1$2$1);
      if ($n(x$1$1).isFailed__Z()) {
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = $n(x$1$1).toString__T();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$1 = [$$x3, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
        return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      } else {
        var this$21 = $n(x$1$1);
        if ((!this$21.isEmpty__Z())) {
          var arg1 = $n(x$1$1).get__O();
          var definitions = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
          var c = $m_Lreactbuild_analyze_cost_views_Admin$().Lreactbuild_analyze_cost_views_Admin$__f_component;
          var this$27 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType("admin")));
          var props = new $c_Lreactbuild_analyze_cost_views_Admin$Props($n(pageProps).Lreactbuild_package$PageProps__f_proxy, definitions, $n(pageProps).Lreactbuild_package$PageProps__f_router);
          var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$27.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$27.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
          var this$29 = $n(u);
          var n = this$29.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
        } else if ($n(x$1$1).isPending__Z()) {
          return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
        } else {
          var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
          return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
        }
      }
    }));
    var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$();
    $m_Lreactbuild_model_Implicits$();
    var this$39 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u$1 = $n($$x10).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x6, $$x2, $n($$x1).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$39.byRef__F2(), this$39.by_$eq$eq__F2())), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
    var this$42 = $n(u$1);
    var n$1 = this$42.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$44, f)
});
var $d_Lreactbuild_analyze_cost_views_Admin$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_Admin$: 0
}, false, "reactbuild.analyze.cost.views.Admin$", {
  Lreactbuild_analyze_cost_views_Admin$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_views_Admin$.prototype.$classData = $d_Lreactbuild_analyze_cost_views_Admin$;
var $n_Lreactbuild_analyze_cost_views_Admin$;
function $m_Lreactbuild_analyze_cost_views_Admin$() {
  if ((!$n_Lreactbuild_analyze_cost_views_Admin$)) {
    $n_Lreactbuild_analyze_cost_views_Admin$ = new $c_Lreactbuild_analyze_cost_views_Admin$()
  };
  return $n_Lreactbuild_analyze_cost_views_Admin$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_FilePreview$() {
  this.Lreactbuild_analyze_cost_views_FilePreview$__f_component = null;
  $n_Lreactbuild_analyze_cost_views_FilePreview$ = this;
  this.Lreactbuild_analyze_cost_views_FilePreview$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("FilePreview", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_common_model_RefTo(p$2);
    return new $c_Lreactbuild_analyze_cost_views_FilePreview$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_views_FilePreview$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_views_FilePreview$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_common_model_RefTo($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_views_FilePreview$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_views_FilePreview$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_views_FilePreview$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_FilePreview$.prototype.constructor = $c_Lreactbuild_analyze_cost_views_FilePreview$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_FilePreview$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_FilePreview$.prototype = $c_Lreactbuild_analyze_cost_views_FilePreview$.prototype;
$c_Lreactbuild_analyze_cost_views_FilePreview$.prototype.apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(fileRef) {
  var c = this.Lreactbuild_analyze_cost_views_FilePreview$__f_component;
  var $$x1 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  var a = $n($n(fileRef).Lreactbuild_common_model_RefTo__f_id).toString__T();
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x1).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(fileRef, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_views_FilePreview$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_FilePreview$: 0
}, false, "reactbuild.analyze.cost.views.FilePreview$", {
  Lreactbuild_analyze_cost_views_FilePreview$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_views_FilePreview$.prototype.$classData = $d_Lreactbuild_analyze_cost_views_FilePreview$;
var $n_Lreactbuild_analyze_cost_views_FilePreview$;
function $m_Lreactbuild_analyze_cost_views_FilePreview$() {
  if ((!$n_Lreactbuild_analyze_cost_views_FilePreview$)) {
    $n_Lreactbuild_analyze_cost_views_FilePreview$ = new $c_Lreactbuild_analyze_cost_views_FilePreview$()
  };
  return $n_Lreactbuild_analyze_cost_views_FilePreview$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_Inbox$() {
  this.Lreactbuild_analyze_cost_views_Inbox$__f_formatMultiline = null;
  this.Lreactbuild_analyze_cost_views_Inbox$__f_orderingMultiline = null;
  this.Lreactbuild_analyze_cost_views_Inbox$__f_parsableMultiline = null;
  this.Lreactbuild_analyze_cost_views_Inbox$__f_component = null;
  $n_Lreactbuild_analyze_cost_views_Inbox$ = this;
  $n($m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_Format);
  var format = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var this$2 = $n(format);
  this.Lreactbuild_analyze_cost_views_Inbox$__f_formatMultiline = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(this$2);
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $n($as_Lcom_iz2use_common_Multiline(x$1$2)).Lcom_iz2use_common_Multiline__f_underlying;
    return x$1
  }));
  var ord = $m_s_math_Ordering$String$();
  this.Lreactbuild_analyze_cost_views_Inbox$__f_orderingMultiline = new $c_s_math_Ordering$$anon$5(ord, f);
  $m_Lcom_iz2use_common_Parsable$();
  var ev = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var this$6 = $n(ev);
  var f$1 = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_T(v$2);
    return new $c_Lcom_iz2use_common_Multiline(v)
  }));
  var g = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $n($as_Lcom_iz2use_common_Multiline(x$2$2)).Lcom_iz2use_common_Multiline__f_underlying;
    return x$2
  }));
  this.Lreactbuild_analyze_cost_views_Inbox$__f_parsableMultiline = new $c_Lcom_iz2use_common_Parsable$$anon$1(this$6, f$1, g);
  this.Lreactbuild_analyze_cost_views_Inbox$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Inbox", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$3) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$3);
    return new $c_Lreactbuild_analyze_cost_views_Inbox$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$4$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_views_Inbox$Backend($n(x$4).backend__O()));
    var this$9 = $n(x$4);
    var $$x1 = $as_Lreactbuild_analyze_cost_views_Inbox$Props($n(this$9.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$10 = $n(x$4);
    return $n($$x2).render__Lreactbuild_analyze_cost_views_Inbox$Props__jl_Void__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_jl_Void($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$10)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_views_Inbox$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_Inbox$.prototype.constructor = $c_Lreactbuild_analyze_cost_views_Inbox$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_Inbox$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_Inbox$.prototype = $c_Lreactbuild_analyze_cost_views_Inbox$.prototype;
$c_Lreactbuild_analyze_cost_views_Inbox$.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomElement = (function() {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_analyze_cost_views_Inbox$Props($n(pageProps).Lreactbuild_package$PageProps__f_router, $n(pageProps).Lreactbuild_package$PageProps__f_proxy);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
var $d_Lreactbuild_analyze_cost_views_Inbox$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_Inbox$: 0
}, false, "reactbuild.analyze.cost.views.Inbox$", {
  Lreactbuild_analyze_cost_views_Inbox$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_views_Inbox$.prototype.$classData = $d_Lreactbuild_analyze_cost_views_Inbox$;
var $n_Lreactbuild_analyze_cost_views_Inbox$;
function $m_Lreactbuild_analyze_cost_views_Inbox$() {
  if ((!$n_Lreactbuild_analyze_cost_views_Inbox$)) {
    $n_Lreactbuild_analyze_cost_views_Inbox$ = new $c_Lreactbuild_analyze_cost_views_Inbox$()
  };
  return $n_Lreactbuild_analyze_cost_views_Inbox$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_ProcessTask$() {
  this.Lreactbuild_analyze_cost_views_ProcessTask$__f_component = null;
  $n_Lreactbuild_analyze_cost_views_ProcessTask$ = this;
  this.Lreactbuild_analyze_cost_views_ProcessTask$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ProcessTask", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_views_ProcessTask$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_views_ProcessTask$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_views_ProcessTask$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_views_ProcessTask$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_views_ProcessTask$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_views_ProcessTask$Props__Lreactbuild_analyze_cost_views_ProcessTask$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_views_ProcessTask$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_views_ProcessTask$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_ProcessTask$.prototype.constructor = $c_Lreactbuild_analyze_cost_views_ProcessTask$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_ProcessTask$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_ProcessTask$.prototype = $c_Lreactbuild_analyze_cost_views_ProcessTask$.prototype;
$c_Lreactbuild_analyze_cost_views_ProcessTask$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Ldiode_data_Pot__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(router, proxy, task, next) {
  var c = this.Lreactbuild_analyze_cost_views_ProcessTask$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_views_ProcessTask$Props(router, proxy, task, next);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_analyze_cost_views_ProcessTask$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_ProcessTask$: 0
}, false, "reactbuild.analyze.cost.views.ProcessTask$", {
  Lreactbuild_analyze_cost_views_ProcessTask$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$.prototype.$classData = $d_Lreactbuild_analyze_cost_views_ProcessTask$;
var $n_Lreactbuild_analyze_cost_views_ProcessTask$;
function $m_Lreactbuild_analyze_cost_views_ProcessTask$() {
  if ((!$n_Lreactbuild_analyze_cost_views_ProcessTask$)) {
    $n_Lreactbuild_analyze_cost_views_ProcessTask$ = new $c_Lreactbuild_analyze_cost_views_ProcessTask$()
  };
  return $n_Lreactbuild_analyze_cost_views_ProcessTask$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$() {
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$__f_component = null;
  $n_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$ = this;
  var this$7 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ProcessTaskCommunication", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props(p$2);
    return new $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(0)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend($n(c).backend__O())).reset__Ljapgolly_scalajs_react_callback_Trampoline())
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$7, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$.prototype.constructor = $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$.prototype = $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$.prototype;
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_common_model_RefTo__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_VdomElement = (function(router, proxy, communicationRef, task, next) {
  var $$x10 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
  var $$x9 = $n($n(communicationRef).Lreactbuild_common_model_RefTo__f_id).toString__T();
  var $$x5 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x8 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x7 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "getCommunication"];
    var $$x6 = $as_sci_Seq($n($$x7).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$13 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
    var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(communicationRef, evidence$2);
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "communicationRef", y)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($$x8).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x6, this$13.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$15 = $n(new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self);
      var evidence$1 = $m_Lreactbuild_model_Communication$().Lreactbuild_model_Communication$__f_codecForCommunication;
      return $as_Lreactbuild_model_Communication(this$15.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  }));
  var $$x1 = new $c_sjsr_AnonFunction1(((x$17$2) => {
    var x$17 = $as_Ldiode_data_Pot(x$17$2);
    if ($n(x$17).isFailed__Z()) {
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(x$17).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$2 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    } else {
      var this$26 = $n(x$17);
      if ((!this$26.isEmpty__Z())) {
        var arg1 = $n(x$17).get__O();
        var communication = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
        var c = $m_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$().Lreactbuild_analyze_cost_views_ProcessTaskCommunication$__f_component;
        var this$28 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
        var props = new $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props(router, proxy, $as_Lreactbuild_model_Communication($n(communication).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), task, next);
        var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$28.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$28.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
        var this$30 = $n(u);
        var n = this$30.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      } else if ($n(x$17).isPending__Z()) {
        return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      }
    }
  }));
  $m_Lreactbuild_model_Implicits$();
  var this$40 = $m_Ljapgolly_scalajs_react_Reusability$();
  return $n($$x10).withKey__T__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_vdom_VdomElement($$x9, $$x5, $$x1, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$40.byRef__F2(), this$40.by_$eq$eq__F2()), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
});
var $d_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_ProcessTaskCommunication$: 0
}, false, "reactbuild.analyze.cost.views.ProcessTaskCommunication$", {
  Lreactbuild_analyze_cost_views_ProcessTaskCommunication$: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$.prototype.$classData = $d_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$;
var $n_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$;
function $m_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$() {
  if ((!$n_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$)) {
    $n_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$ = new $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$()
  };
  return $n_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$
}
/** @constructor */
function $c_Lreactbuild_common_AjaxJson$() {
  /*<skip>*/
}
$c_Lreactbuild_common_AjaxJson$.prototype = new $h_O();
$c_Lreactbuild_common_AjaxJson$.prototype.constructor = $c_Lreactbuild_common_AjaxJson$;
/** @constructor */
function $h_Lreactbuild_common_AjaxJson$() {
  /*<skip>*/
}
$h_Lreactbuild_common_AjaxJson$.prototype = $c_Lreactbuild_common_AjaxJson$.prototype;
$c_Lreactbuild_common_AjaxJson$.prototype.fetch__sjs_js_$bar__sjs_js_$bar__F0__Lio_circe_Decoder__s_concurrent_ExecutionContext__s_concurrent_Future = (function(info, init, onUnauthorizedRequest, dec, ec) {
  var $$x1 = $m_sjs_js_Thenable$ThenableOps$();
  if ((init === (void 0))) {
    var a$1 = (() => {
      var this$5 = {};
      var a = $m_Lorg_scalajs_dom_RequestCredentials$().Lorg_scalajs_dom_RequestCredentials$__f_include;
      this$5.credentials = a;
      return this$5
    })();
    var value = a$1
  } else {
    var value = init
  };
  var p = ((value === (void 0)) ? fetch(info) : fetch(info, value));
  return $n($n($$x1).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((response$2) => {
    var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
    var p$1 = response$2.text();
    return $n($n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((responseText$2) => {
      var responseText = $as_T(responseText$2);
      if (($uI(response$2.status) === 401)) {
        var this$19 = $n(onUnauthorizedRequest);
        this$19.apply__O();
        var $$x3 = $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_Exception__T__(new $c_jl_Exception(), "Unauthorized"))
      } else {
        var $$x5 = $m_s_concurrent_Future$();
        var this$20 = $n($m_Lio_circe_parser_package$().parse__T__s_util_Either(responseText));
        var this$21 = new $c_s_util_Either$LeftProjection(this$20);
        var x1 = this$21.s_util_Either$LeftProjection__f_e;
        if ((x1 instanceof $c_s_util_Left)) {
          var x2 = $as_s_util_Left(x1);
          var a$2 = $n(x2).s_util_Left__f_value;
          var e = $as_Lio_circe_ParsingFailure(a$2);
          var $$x4 = new $c_s_util_Left($ct_jl_Exception__T__jl_Throwable__(new $c_jl_Exception(), ("JSON parse " + responseText), e))
        } else {
          var $$x4 = this$21.s_util_Either$LeftProjection__f_e
        };
        var this$22 = $m_s_$less$colon$less$();
        var $$x3 = $n($$x5).fromTry__s_util_Try__s_concurrent_Future($n($$x4).toTry__s_$less$colon$less__s_util_Try(this$22.s_$less$colon$less$__f_singleton))
      };
      return $n($$x3).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((parsed$2) => {
        var parsed = $as_Lio_circe_Json(parsed$2);
        var $$x7 = $m_s_concurrent_Future$();
        var this$23 = $n(parsed);
        var this$25 = $n($n(dec).apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(this$23, null, null)));
        var this$26 = new $c_s_util_Either$LeftProjection(this$25);
        var x1$1 = this$26.s_util_Either$LeftProjection__f_e;
        if ((x1$1 instanceof $c_s_util_Left)) {
          var x2$1 = $as_s_util_Left(x1$1);
          var a$3 = $n(x2$1).s_util_Left__f_value;
          var e$1 = $as_Lio_circe_DecodingFailure(a$3);
          var $$x6 = new $c_s_util_Left($ct_jl_Exception__T__jl_Throwable__(new $c_jl_Exception(), ("parse[T] " + parsed), e$1))
        } else {
          var $$x6 = this$26.s_util_Either$LeftProjection__f_e
        };
        var this$27 = $m_s_$less$colon$less$();
        return $n($n($$x7).fromTry__s_util_Try__s_concurrent_Future($n($$x6).toTry__s_$less$colon$less__s_util_Try(this$27.s_$less$colon$less$__f_singleton))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((transformed$2) => transformed$2)), ec)
      })), ec)
    })), ec)
  })), ec)
});
$c_Lreactbuild_common_AjaxJson$.prototype.fetch$default$3__F0 = (function() {
  return new $c_sjsr_AnonFunction0((() => (void 0)))
});
var $d_Lreactbuild_common_AjaxJson$ = new $TypeData().initClass({
  Lreactbuild_common_AjaxJson$: 0
}, false, "reactbuild.common.AjaxJson$", {
  Lreactbuild_common_AjaxJson$: 1,
  O: 1
});
$c_Lreactbuild_common_AjaxJson$.prototype.$classData = $d_Lreactbuild_common_AjaxJson$;
var $n_Lreactbuild_common_AjaxJson$;
function $m_Lreactbuild_common_AjaxJson$() {
  if ((!$n_Lreactbuild_common_AjaxJson$)) {
    $n_Lreactbuild_common_AjaxJson$ = new $c_Lreactbuild_common_AjaxJson$()
  };
  return $n_Lreactbuild_common_AjaxJson$
}
function $f_Lreactbuild_common_CirceExtendedImplicits__decodeOtherMap__Lshapeless_Refute__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($thiz, ev, decodeK, decodeV) {
  $m_Lio_circe_Decoder$();
  $m_Lio_circe_Decoder$();
  var this$1 = $m_Lio_circe_Decoder$();
  var decodeA = new $c_Lio_circe_TupleDecoders$$anon$2(this$1, decodeK, decodeV);
  var instance = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_sci_Seq(x$2$2);
    var this$6 = $n(x$2);
    var this$5 = $m_s_$less$colon$less$();
    return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$6)
  }));
  return new $c_Lio_circe_Decoder$$anon$1(instance, f)
}
function $f_Lreactbuild_common_CirceExtendedImplicits__$init$__V($thiz) {
  $thiz.reactbuild$common$CirceExtendedImplicits$_setter_$config_$eq__Lio_circe_generic_extras_Configuration__V($n($m_Lio_circe_generic_extras_Configuration$().Lio_circe_generic_extras_Configuration$__f_default).withDefaults__Lio_circe_generic_extras_Configuration())
}
function $f_Lreactbuild_common_ReferenceToModel__$init$__V($thiz) {
  $thiz.Lreactbuild_model_package$__f_RefTo = $m_Lreactbuild_common_model_RefTo$();
  $m_Lreactbuild_common_model_TypedRefTo$();
  $m_Lreactbuild_common_model_Edge$();
  $thiz.Lreactbuild_model_package$__f_Date = $m_Lreactbuild_common_model_Date$();
  $m_Lreactbuild_common_model_OrganizationUser$();
  $m_Lreactbuild_common_model_LoggedUser$();
  $m_Lreactbuild_common_model_ProjectRelease$();
  $m_Lreactbuild_common_model_Marker$();
  $m_Lreactbuild_common_model_ImageCoordinates$();
  $m_Lreactbuild_common_model_Image$();
  $m_Lreactbuild_common_model_File$();
  $m_Lreactbuild_common_model_Area$();
  $m_Lreactbuild_common_model_Country$();
  $m_Lreactbuild_common_model_CityCode$();
  $thiz.Lreactbuild_model_package$__f_Project = $m_Lreactbuild_common_model_Project$();
  $m_Lreactbuild_common_model_DeployableWebsite$();
  $m_Lreactbuild_common_model_ProjectSpecific$();
  $m_Lreactbuild_common_model_ProjectSpecifics$();
  $m_Lreactbuild_common_model_ListProjects$();
  $m_Lreactbuild_common_model_Organization$();
  $m_Lreactbuild_common_model_LoggedUserWithOrganizations$();
  $m_Lreactbuild_common_model_LoggedUserOrganization$();
  $thiz.Lreactbuild_model_package$__f_AssetDefinition = $m_Lreactbuild_common_model_AssetDefinition$();
  $thiz.Lreactbuild_model_package$__f_ComponentDetails = $m_Lreactbuild_common_model_ComponentDetails$()
}
/** @constructor */
function $c_Lreactbuild_common_components_ContextLoader$() {
  this.Lreactbuild_common_components_ContextLoader$__f_objLoader = null;
  this.Lreactbuild_common_components_ContextLoader$__f_loaders = null;
  $n_Lreactbuild_common_components_ContextLoader$ = this;
  this.Lreactbuild_common_components_ContextLoader$__f_objLoader = new $i_three$002fexamples$002fjsm$002floaders$002fOBJLoader.OBJLoader();
  var this$1 = $n($m_s_Predef$().s_Predef$__f_Map);
  var elems = $m_sci_Nil$();
  this.Lreactbuild_common_components_ContextLoader$__f_loaders = this$1.from__sc_IterableOnce__sci_Map(elems)
}
$c_Lreactbuild_common_components_ContextLoader$.prototype = new $h_O();
$c_Lreactbuild_common_components_ContextLoader$.prototype.constructor = $c_Lreactbuild_common_components_ContextLoader$;
/** @constructor */
function $h_Lreactbuild_common_components_ContextLoader$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_ContextLoader$.prototype = $c_Lreactbuild_common_components_ContextLoader$.prototype;
$c_Lreactbuild_common_components_ContextLoader$.prototype.reactbuild$common$components$ContextLoader$$$anonfun$apply$5__sjs_js_Any__s_concurrent_Promise__T__V = (function(msg, p$1, definition$1) {
  var this$1 = $n(p$1);
  var cause = $ct_jl_Exception__T__(new $c_jl_Exception(), ((("OBJLoader problem while loading " + definition$1) + " : ") + msg));
  $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(this$1, cause)
});
$c_Lreactbuild_common_components_ContextLoader$.prototype.reactbuild$common$components$ContextLoader$$$anonfun$apply$7__Lorg_denigma_threejs_Object3D__Lorg_denigma_threejs_Material__O = (function(o, componentMaterial$1) {
  var v = o.material;
  if ((!(v === (void 0)))) {
    o.material = componentMaterial$1;
    return (void 0)
  } else {
    return (void 0)
  }
});
var $d_Lreactbuild_common_components_ContextLoader$ = new $TypeData().initClass({
  Lreactbuild_common_components_ContextLoader$: 0
}, false, "reactbuild.common.components.ContextLoader$", {
  Lreactbuild_common_components_ContextLoader$: 1,
  O: 1
});
$c_Lreactbuild_common_components_ContextLoader$.prototype.$classData = $d_Lreactbuild_common_components_ContextLoader$;
var $n_Lreactbuild_common_components_ContextLoader$;
function $m_Lreactbuild_common_components_ContextLoader$() {
  if ((!$n_Lreactbuild_common_components_ContextLoader$)) {
    $n_Lreactbuild_common_components_ContextLoader$ = new $c_Lreactbuild_common_components_ContextLoader$()
  };
  return $n_Lreactbuild_common_components_ContextLoader$
}
/** @constructor */
function $c_Lreactbuild_common_components_DrawingViewer$() {
  this.Lreactbuild_common_components_DrawingViewer$__f_component = null;
  $n_Lreactbuild_common_components_DrawingViewer$ = this;
  var this$7 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DrawingViewer", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_common_components_DrawingViewer$Props(p$2);
    return new $c_Lreactbuild_common_components_DrawingViewer$State(false)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_common_components_DrawingViewer$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_common_components_DrawingViewer$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_common_components_DrawingViewer$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_common_components_DrawingViewer$Props__Lreactbuild_common_components_DrawingViewer$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_common_components_DrawingViewer$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Lreactbuild_common_components_DrawingViewer$Backend($n(\u03b4).backend__O())).onResize__Ljapgolly_scalajs_react_callback_Trampoline(), $n($as_Lreactbuild_common_components_DrawingViewer$Backend($n(\u03b4).backend__O())).init__Ljapgolly_scalajs_react_callback_Trampoline()))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var stabilizer$1 = $p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$7, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f, G);
  var this$13 = $n($n(stabilizer$1).componentDidUpdate__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((\u03b4$3$2) => {
    var \u03b4$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(\u03b4$3$2);
    var $$x4 = $as_Lreactbuild_common_components_DrawingViewer$Backend($n(\u03b4$3).backend__O());
    var $$x3 = $as_Lreactbuild_common_components_DrawingViewer$State($n(\u03b4$3).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevState);
    var this$8 = $n(\u03b4$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x4).onChange__Lreactbuild_common_components_DrawingViewer$State__Lreactbuild_common_components_DrawingViewer$State__Ljapgolly_scalajs_react_callback_Trampoline($$x3, $as_Lreactbuild_common_components_DrawingViewer$State($n(this$8.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O())))
  })), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()));
  var f$1 = $m_Ljapgolly_scalajs_react_extra_package$EventListener$().install__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1("resize", new $c_sjsr_AnonFunction1(((\u03b4$4$2) => {
    var \u03b4$4 = $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(\u03b4$4$2);
    var this$10 = $n(\u03b4$4);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_common_components_DrawingViewer$Backend($f_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot__backend__O(this$10))).onResize__Ljapgolly_scalajs_react_callback_Trampoline())
  })), new $c_sjsr_AnonFunction1(((x$8$2) => {
    $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$8$2);
    return window
  })), false, $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  this.Lreactbuild_common_components_DrawingViewer$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$1).apply__O__O(this$13))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_common_components_DrawingViewer$.prototype = new $h_O();
$c_Lreactbuild_common_components_DrawingViewer$.prototype.constructor = $c_Lreactbuild_common_components_DrawingViewer$;
/** @constructor */
function $h_Lreactbuild_common_components_DrawingViewer$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_DrawingViewer$.prototype = $c_Lreactbuild_common_components_DrawingViewer$.prototype;
$c_Lreactbuild_common_components_DrawingViewer$.prototype.withKey__T__sci_Seq__T__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, library, modelSource) {
  var c = this.Lreactbuild_common_components_DrawingViewer$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_common_components_DrawingViewer$Props(library, modelSource);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_common_components_DrawingViewer$ = new $TypeData().initClass({
  Lreactbuild_common_components_DrawingViewer$: 0
}, false, "reactbuild.common.components.DrawingViewer$", {
  Lreactbuild_common_components_DrawingViewer$: 1,
  O: 1
});
$c_Lreactbuild_common_components_DrawingViewer$.prototype.$classData = $d_Lreactbuild_common_components_DrawingViewer$;
var $n_Lreactbuild_common_components_DrawingViewer$;
function $m_Lreactbuild_common_components_DrawingViewer$() {
  if ((!$n_Lreactbuild_common_components_DrawingViewer$)) {
    $n_Lreactbuild_common_components_DrawingViewer$ = new $c_Lreactbuild_common_components_DrawingViewer$()
  };
  return $n_Lreactbuild_common_components_DrawingViewer$
}
function $ct_Lreactbuild_common_components_Input$CursorType__D__($thiz, precision) {
  $thiz.Lreactbuild_common_components_Input$CursorType__f_precision = precision;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$CursorType() {
  this.Lreactbuild_common_components_Input$CursorType__f_precision = 0.0
}
$c_Lreactbuild_common_components_Input$CursorType.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$CursorType.prototype.constructor = $c_Lreactbuild_common_components_Input$CursorType;
/** @constructor */
function $h_Lreactbuild_common_components_Input$CursorType() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$CursorType.prototype = $c_Lreactbuild_common_components_Input$CursorType.prototype;
function $is_Lreactbuild_common_components_Input$Event(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_common_components_Input$Event)))
}
function $as_Lreactbuild_common_components_Input$Event(obj) {
  return (($is_Lreactbuild_common_components_Input$Event(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Input$Event"))
}
function $isArrayOf_Lreactbuild_common_components_Input$Event(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Input$Event)))
}
function $asArrayOf_Lreactbuild_common_components_Input$Event(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Input$Event(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Input$Event;", depth))
}
function $is_Lreactbuild_common_components_Input$KeyboardLocation(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_common_components_Input$KeyboardLocation)))
}
function $as_Lreactbuild_common_components_Input$KeyboardLocation(obj) {
  return (($is_Lreactbuild_common_components_Input$KeyboardLocation(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Input$KeyboardLocation"))
}
function $isArrayOf_Lreactbuild_common_components_Input$KeyboardLocation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Input$KeyboardLocation)))
}
function $asArrayOf_Lreactbuild_common_components_Input$KeyboardLocation(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Input$KeyboardLocation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Input$KeyboardLocation;", depth))
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$KeyboardLocation$() {
  this.Lreactbuild_common_components_Input$KeyboardLocation$__f_keyboardLocationMap = null;
  $n_Lreactbuild_common_components_Input$KeyboardLocation$ = this;
  var this$12 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $uI(KeyboardEvent.DOM_KEY_LOCATION_RIGHT);
  var y = $m_Lreactbuild_common_components_Input$Right$();
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $uI(KeyboardEvent.DOM_KEY_LOCATION_STANDARD);
  var y$1 = $m_Lreactbuild_common_components_Input$Standard$();
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $uI(KeyboardEvent.DOM_KEY_LOCATION_LEFT);
  var y$2 = $m_Lreactbuild_common_components_Input$Left$();
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $uI(KeyboardEvent.DOM_KEY_LOCATION_NUMPAD);
  var y$3 = $m_Lreactbuild_common_components_Input$Numpad$();
  var array = [$$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$3, y$3)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_common_components_Input$KeyboardLocation$__f_keyboardLocationMap = this$12.from__sc_IterableOnce__sci_Map(elems)
}
$c_Lreactbuild_common_components_Input$KeyboardLocation$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$KeyboardLocation$.prototype.constructor = $c_Lreactbuild_common_components_Input$KeyboardLocation$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$KeyboardLocation$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$KeyboardLocation$.prototype = $c_Lreactbuild_common_components_Input$KeyboardLocation$.prototype;
$c_Lreactbuild_common_components_Input$KeyboardLocation$.prototype.from__D__Lreactbuild_common_components_Input$KeyboardLocation = (function(location) {
  return $as_Lreactbuild_common_components_Input$KeyboardLocation($n(this.Lreactbuild_common_components_Input$KeyboardLocation$__f_keyboardLocationMap).getOrElse__O__F0__O($doubleToInt(location), new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_common_components_Input$DontKnow$()))))
});
var $d_Lreactbuild_common_components_Input$KeyboardLocation$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$KeyboardLocation$: 0
}, false, "reactbuild.common.components.Input$KeyboardLocation$", {
  Lreactbuild_common_components_Input$KeyboardLocation$: 1,
  O: 1
});
$c_Lreactbuild_common_components_Input$KeyboardLocation$.prototype.$classData = $d_Lreactbuild_common_components_Input$KeyboardLocation$;
var $n_Lreactbuild_common_components_Input$KeyboardLocation$;
function $m_Lreactbuild_common_components_Input$KeyboardLocation$() {
  if ((!$n_Lreactbuild_common_components_Input$KeyboardLocation$)) {
    $n_Lreactbuild_common_components_Input$KeyboardLocation$ = new $c_Lreactbuild_common_components_Input$KeyboardLocation$()
  };
  return $n_Lreactbuild_common_components_Input$KeyboardLocation$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$ModifierKey$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$ModifierKey$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$ModifierKey$.prototype.constructor = $c_Lreactbuild_common_components_Input$ModifierKey$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$ModifierKey$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$ModifierKey$.prototype = $c_Lreactbuild_common_components_Input$ModifierKey$.prototype;
$c_Lreactbuild_common_components_Input$ModifierKey$.prototype.from__Lorg_scalajs_dom_ModifierKeyEvent__Lreactbuild_common_components_Input$ModifierKey = (function(m) {
  var s = $uZ(m.shiftKey);
  var c = $uZ(m.ctrlKey);
  var a = $uZ(m.altKey);
  return (((s && c) && a) ? $m_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$() : ((c && a) ? $m_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$() : ((s && a) ? $m_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$() : ((s && c) ? $m_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$() : (a ? $m_Lreactbuild_common_components_Input$ModifierKey$Alt$() : (c ? $m_Lreactbuild_common_components_Input$ModifierKey$Ctrl$() : (s ? $m_Lreactbuild_common_components_Input$ModifierKey$Shift$() : $m_Lreactbuild_common_components_Input$ModifierKey$None$())))))))
});
var $d_Lreactbuild_common_components_Input$ModifierKey$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$ModifierKey$: 0
}, false, "reactbuild.common.components.Input$ModifierKey$", {
  Lreactbuild_common_components_Input$ModifierKey$: 1,
  O: 1
});
$c_Lreactbuild_common_components_Input$ModifierKey$.prototype.$classData = $d_Lreactbuild_common_components_Input$ModifierKey$;
var $n_Lreactbuild_common_components_Input$ModifierKey$;
function $m_Lreactbuild_common_components_Input$ModifierKey$() {
  if ((!$n_Lreactbuild_common_components_Input$ModifierKey$)) {
    $n_Lreactbuild_common_components_Input$ModifierKey$ = new $c_Lreactbuild_common_components_Input$ModifierKey$()
  };
  return $n_Lreactbuild_common_components_Input$ModifierKey$
}
function $is_Lreactbuild_common_components_Input$MouseButton(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_common_components_Input$MouseButton)))
}
function $as_Lreactbuild_common_components_Input$MouseButton(obj) {
  return (($is_Lreactbuild_common_components_Input$MouseButton(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Input$MouseButton"))
}
function $isArrayOf_Lreactbuild_common_components_Input$MouseButton(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Input$MouseButton)))
}
function $asArrayOf_Lreactbuild_common_components_Input$MouseButton(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Input$MouseButton(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Input$MouseButton;", depth))
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$MouseButton$() {
  this.Lreactbuild_common_components_Input$MouseButton$__f_mouseButtonArray = null;
  this.Lreactbuild_common_components_Input$MouseButton$__f_mouseButtonMap = null;
  $n_Lreactbuild_common_components_Input$MouseButton$ = this;
  this.Lreactbuild_common_components_Input$MouseButton$__f_mouseButtonArray = new ($d_s_Product.getArrayOf().constr)([$m_Lreactbuild_common_components_Input$Left$(), $m_Lreactbuild_common_components_Input$Middle$(), $m_Lreactbuild_common_components_Input$Right$(), $m_Lreactbuild_common_components_Input$Back$(), $m_Lreactbuild_common_components_Input$Forward$()]);
  $m_sc_ArrayOps$();
  var $$x1 = $m_sc_ArrayOps$();
  var xs = new ($d_s_Product.getArrayOf().constr)([$m_Lreactbuild_common_components_Input$Left$(), $m_Lreactbuild_common_components_Input$Right$(), $m_Lreactbuild_common_components_Input$Middle$(), $m_Lreactbuild_common_components_Input$Back$(), $m_Lreactbuild_common_components_Input$Forward$()]);
  var xs$1 = $n($$x1).zipWithIndex$extension__O__AT2(xs);
  var f = ((p$2) => {
    var p = $as_T2(p$2);
    return $ct_T2__O__O__(new $c_T2(), $n(p)._1__O(), (1 << $n(p)._2$mcI$sp__I()))
  });
  var len = $n(xs$1).u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs$1 !== null)) {
      while ((i < len)) {
        var $$x2 = i;
        var arg1 = $n(xs$1).get(i);
        ys.set($$x2, f(arg1));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs$1, 1);
      while ((i < len)) {
        var $$x3 = i;
        var arg1$1 = $n(x3).get(i);
        ys.set($$x3, f(arg1$1));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs$1, 1);
      while ((i < len)) {
        var $$x4 = i;
        var arg1$2 = $n(x4).get(i);
        ys.set($$x4, f(arg1$2));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs$1, 1);
      while ((i < len)) {
        var $$x5 = i;
        var t = $n(x5).get(i);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($$x5, f(new $c_RTLong(lo, hi)));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs$1, 1);
      while ((i < len)) {
        var $$x6 = i;
        var arg1$3 = $n(x6).get(i);
        ys.set($$x6, f(arg1$3));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs$1, 1);
      while ((i < len)) {
        var $$x7 = i;
        var arg1$4 = $n(x7).get(i);
        ys.set($$x7, f($bC(arg1$4)));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs$1, 1);
      while ((i < len)) {
        var $$x8 = i;
        var arg1$5 = $n(x8).get(i);
        ys.set($$x8, f(arg1$5));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs$1, 1);
      while ((i < len)) {
        var $$x9 = i;
        var arg1$6 = $n(x9).get(i);
        ys.set($$x9, f(arg1$6));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs$1, 1);
      while ((i < len)) {
        var $$x10 = i;
        var arg1$7 = $n(x10).get(i);
        ys.set($$x10, f(arg1$7));
        i = ((1 + i) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs$1)
    }
  };
  this.Lreactbuild_common_components_Input$MouseButton$__f_mouseButtonMap = ys
}
$c_Lreactbuild_common_components_Input$MouseButton$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$MouseButton$.prototype.constructor = $c_Lreactbuild_common_components_Input$MouseButton$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$MouseButton$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$MouseButton$.prototype = $c_Lreactbuild_common_components_Input$MouseButton$.prototype;
$c_Lreactbuild_common_components_Input$MouseButton$.prototype.fromOne__I__Lreactbuild_common_components_Input$MouseButton = (function(button) {
  return $as_Lreactbuild_common_components_Input$MouseButton($n(this.Lreactbuild_common_components_Input$MouseButton$__f_mouseButtonArray).get(button))
});
$c_Lreactbuild_common_components_Input$MouseButton$.prototype.fromMultiple__I__sci_Seq = (function(buttons) {
  var $$x1 = $m_s_Predef$();
  $m_sc_ArrayOps$();
  var xs = this.Lreactbuild_common_components_Input$MouseButton$__f_mouseButtonMap;
  var pf = new $c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1(buttons);
  var fallback = $m_sc_ArrayOps$().sc_ArrayOps$__f_fallback;
  var capacity = 0;
  var jsElems = null;
  capacity = 0;
  jsElems = [];
  var i = 0;
  while ((i < $n(xs).u.length)) {
    var x1 = i;
    var x = $n(xs).get(x1);
    var v = pf.applyOrElse__T2__F1__O($as_T2(x), fallback);
    if ((v !== fallback)) {
      var unboxedElem = ((v === null) ? null : v);
      jsElems.push(unboxedElem)
    };
    i = ((1 + i) | 0)
  };
  return $n($$x1).copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(new ($d_s_Product.getArrayOf().constr)(jsElems))
});
var $d_Lreactbuild_common_components_Input$MouseButton$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$MouseButton$: 0
}, false, "reactbuild.common.components.Input$MouseButton$", {
  Lreactbuild_common_components_Input$MouseButton$: 1,
  O: 1
});
$c_Lreactbuild_common_components_Input$MouseButton$.prototype.$classData = $d_Lreactbuild_common_components_Input$MouseButton$;
var $n_Lreactbuild_common_components_Input$MouseButton$;
function $m_Lreactbuild_common_components_Input$MouseButton$() {
  if ((!$n_Lreactbuild_common_components_Input$MouseButton$)) {
    $n_Lreactbuild_common_components_Input$MouseButton$ = new $c_Lreactbuild_common_components_Input$MouseButton$()
  };
  return $n_Lreactbuild_common_components_Input$MouseButton$
}
function $is_Lreactbuild_common_components_Input$PointerButton(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_common_components_Input$PointerButton)))
}
function $as_Lreactbuild_common_components_Input$PointerButton(obj) {
  return (($is_Lreactbuild_common_components_Input$PointerButton(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Input$PointerButton"))
}
function $isArrayOf_Lreactbuild_common_components_Input$PointerButton(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Input$PointerButton)))
}
function $asArrayOf_Lreactbuild_common_components_Input$PointerButton(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Input$PointerButton(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Input$PointerButton;", depth))
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$PointerButton$() {
  this.Lreactbuild_common_components_Input$PointerButton$__f_pointerButtonArray = null;
  this.Lreactbuild_common_components_Input$PointerButton$__f_pointerButtonMap = null;
  $n_Lreactbuild_common_components_Input$PointerButton$ = this;
  this.Lreactbuild_common_components_Input$PointerButton$__f_pointerButtonArray = new ($d_s_Product.getArrayOf().constr)([$m_Lreactbuild_common_components_Input$NoChange$(), $m_Lreactbuild_common_components_Input$Left$(), $m_Lreactbuild_common_components_Input$Middle$(), $m_Lreactbuild_common_components_Input$Right$(), $m_Lreactbuild_common_components_Input$Back$(), $m_Lreactbuild_common_components_Input$Forward$()]);
  $m_sc_ArrayOps$();
  var $$x1 = $m_sc_ArrayOps$();
  var xs = new ($d_s_Product.getArrayOf().constr)([$m_Lreactbuild_common_components_Input$Left$(), $m_Lreactbuild_common_components_Input$Right$(), $m_Lreactbuild_common_components_Input$Middle$(), $m_Lreactbuild_common_components_Input$Back$(), $m_Lreactbuild_common_components_Input$Forward$()]);
  var xs$1 = $n($$x1).zipWithIndex$extension__O__AT2(xs);
  var f = ((p$2) => {
    var p = $as_T2(p$2);
    return $ct_T2__O__O__(new $c_T2(), $n(p)._1__O(), (1 << $n(p)._2$mcI$sp__I()))
  });
  var len = $n(xs$1).u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs$1 !== null)) {
      while ((i < len)) {
        var $$x2 = i;
        var arg1 = $n(xs$1).get(i);
        ys.set($$x2, f(arg1));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs$1, 1);
      while ((i < len)) {
        var $$x3 = i;
        var arg1$1 = $n(x3).get(i);
        ys.set($$x3, f(arg1$1));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs$1, 1);
      while ((i < len)) {
        var $$x4 = i;
        var arg1$2 = $n(x4).get(i);
        ys.set($$x4, f(arg1$2));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs$1, 1);
      while ((i < len)) {
        var $$x5 = i;
        var t = $n(x5).get(i);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($$x5, f(new $c_RTLong(lo, hi)));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs$1, 1);
      while ((i < len)) {
        var $$x6 = i;
        var arg1$3 = $n(x6).get(i);
        ys.set($$x6, f(arg1$3));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs$1, 1);
      while ((i < len)) {
        var $$x7 = i;
        var arg1$4 = $n(x7).get(i);
        ys.set($$x7, f($bC(arg1$4)));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs$1, 1);
      while ((i < len)) {
        var $$x8 = i;
        var arg1$5 = $n(x8).get(i);
        ys.set($$x8, f(arg1$5));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs$1, 1);
      while ((i < len)) {
        var $$x9 = i;
        var arg1$6 = $n(x9).get(i);
        ys.set($$x9, f(arg1$6));
        i = ((1 + i) | 0)
      }
    } else if ((xs$1 instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs$1, 1);
      while ((i < len)) {
        var $$x10 = i;
        var arg1$7 = $n(x10).get(i);
        ys.set($$x10, f(arg1$7));
        i = ((1 + i) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs$1)
    }
  };
  this.Lreactbuild_common_components_Input$PointerButton$__f_pointerButtonMap = ys
}
$c_Lreactbuild_common_components_Input$PointerButton$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$PointerButton$.prototype.constructor = $c_Lreactbuild_common_components_Input$PointerButton$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$PointerButton$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$PointerButton$.prototype = $c_Lreactbuild_common_components_Input$PointerButton$.prototype;
$c_Lreactbuild_common_components_Input$PointerButton$.prototype.fromOne__I__Lreactbuild_common_components_Input$PointerButton = (function(button) {
  return $as_Lreactbuild_common_components_Input$PointerButton($n(this.Lreactbuild_common_components_Input$PointerButton$__f_pointerButtonArray).get(((1 + button) | 0)))
});
$c_Lreactbuild_common_components_Input$PointerButton$.prototype.fromMultiple__I__sci_Seq = (function(buttons) {
  var $$x1 = $m_s_Predef$();
  $m_sc_ArrayOps$();
  var xs = this.Lreactbuild_common_components_Input$PointerButton$__f_pointerButtonMap;
  var pf = new $c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2(buttons);
  var fallback = $m_sc_ArrayOps$().sc_ArrayOps$__f_fallback;
  var capacity = 0;
  var jsElems = null;
  capacity = 0;
  jsElems = [];
  var i = 0;
  while ((i < $n(xs).u.length)) {
    var x1 = i;
    var x = $n(xs).get(x1);
    var v = pf.applyOrElse__T2__F1__O($as_T2(x), fallback);
    if ((v !== fallback)) {
      var unboxedElem = ((v === null) ? null : v);
      jsElems.push(unboxedElem)
    };
    i = ((1 + i) | 0)
  };
  return $n($$x1).copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(new ($d_s_Product.getArrayOf().constr)(jsElems))
});
var $d_Lreactbuild_common_components_Input$PointerButton$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$PointerButton$: 0
}, false, "reactbuild.common.components.Input$PointerButton$", {
  Lreactbuild_common_components_Input$PointerButton$: 1,
  O: 1
});
$c_Lreactbuild_common_components_Input$PointerButton$.prototype.$classData = $d_Lreactbuild_common_components_Input$PointerButton$;
var $n_Lreactbuild_common_components_Input$PointerButton$;
function $m_Lreactbuild_common_components_Input$PointerButton$() {
  if ((!$n_Lreactbuild_common_components_Input$PointerButton$)) {
    $n_Lreactbuild_common_components_Input$PointerButton$ = new $c_Lreactbuild_common_components_Input$PointerButton$()
  };
  return $n_Lreactbuild_common_components_Input$PointerButton$
}
function $is_Lreactbuild_common_components_Interaction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_common_components_Interaction)))
}
function $as_Lreactbuild_common_components_Interaction(obj) {
  return (($is_Lreactbuild_common_components_Interaction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Interaction"))
}
function $isArrayOf_Lreactbuild_common_components_Interaction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Interaction)))
}
function $asArrayOf_Lreactbuild_common_components_Interaction(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Interaction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Interaction;", depth))
}
function $p_Lreactbuild_common_components_InteractionController$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2($thiz) {
  return $m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("InteractionController", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_common_components_InteractionController$TypedProps(p$2);
    return new $c_Lreactbuild_common_components_InteractionController$TypedState($n(p).Lreactbuild_common_components_InteractionController$TypedProps__f_interactions, new $c_Lreactbuild_common_components_TrackedPointers($m_s_package$().s_package$__f_Nil), $m_s_package$().s_package$__f_Nil)
  })))
}
/** @constructor */
function $c_Lreactbuild_common_components_InteractionController$() {
  this.Lreactbuild_common_components_InteractionController$__f_component = null;
  $n_Lreactbuild_common_components_InteractionController$ = this;
  var this$11 = $n($n($n($p_Lreactbuild_common_components_InteractionController$__typedComponent__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2(this)).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_common_components_InteractionController$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_common_components_InteractionController$TypedBackend($n(x$3).backend__O()));
    var this$3 = $n(x$3);
    var $$x1 = $as_Lreactbuild_common_components_InteractionController$TypedProps($n(this$3.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$4 = $n(x$3);
    return $n($$x2).render__Lreactbuild_common_components_InteractionController$TypedProps__Lreactbuild_common_components_InteractionController$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_common_components_InteractionController$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$4)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(\u03b4$2);
    var x$1 = $n($as_Lreactbuild_common_components_InteractionController$TypedProps($n(\u03b4).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)).Lreactbuild_common_components_InteractionController$TypedProps__f_interactions;
    var this$5 = $n(\u03b4);
    var x$2$1 = $n($as_Lreactbuild_common_components_InteractionController$TypedProps($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())).Lreactbuild_common_components_InteractionController$TypedProps__f_interactions;
    if ((!((x$1 === null) ? (x$2$1 === null) : $n(x$1).equals__O__Z(x$2$1)))) {
      var this$9 = $n(\u03b4);
      var mod = new $c_sjsr_AnonFunction1(((x$5$2) => {
        var x$5 = $as_Lreactbuild_common_components_InteractionController$TypedState(x$5$2);
        $n(x$5);
        var interactions = $n($as_Lreactbuild_common_components_InteractionController$TypedProps($n(\u03b4).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)).Lreactbuild_common_components_InteractionController$TypedProps__f_interactions;
        var this$6 = $n(x$5);
        var trackedPointers = this$6.Lreactbuild_common_components_InteractionController$TypedState__f_trackedPointers;
        var this$7 = $n(x$5);
        var lastEvents = this$7.Lreactbuild_common_components_InteractionController$TypedState__f_lastEvents;
        return new $c_Lreactbuild_common_components_InteractionController$TypedState(interactions, trackedPointers, lastEvents)
      }));
      var $$x3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$9, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else {
      var $$x3 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x3)
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_common_components_InteractionController$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$11, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_common_components_InteractionController$.prototype = new $h_O();
$c_Lreactbuild_common_components_InteractionController$.prototype.constructor = $c_Lreactbuild_common_components_InteractionController$;
/** @constructor */
function $h_Lreactbuild_common_components_InteractionController$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_InteractionController$.prototype = $c_Lreactbuild_common_components_InteractionController$.prototype;
$c_Lreactbuild_common_components_InteractionController$.prototype.position__Lreactbuild_common_components_HasClientPosition__Lreactbuild_common_components_Input$CursorType__Lorg_scalajs_dom_Node__Lreactbuild_common_components_Input$Coords = (function(pos, cursor, node) {
  var rect = node.getBoundingClientRect();
  return new $c_Lreactbuild_common_components_Input$Coords(($uD(pos.clientX) - $uD(rect.left)), ($uD(pos.clientY) - $uD(rect.top)), cursor)
});
$c_Lreactbuild_common_components_InteractionController$.prototype.apply__O__Lreactbuild_common_components_Interactions__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(context, interactions, interactionDone, interactionEmpty, tag) {
  var c = this.Lreactbuild_common_components_InteractionController$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_common_components_InteractionController$TypedProps(tag, context, interactions, interactionDone, interactionEmpty);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_common_components_InteractionController$ = new $TypeData().initClass({
  Lreactbuild_common_components_InteractionController$: 0
}, false, "reactbuild.common.components.InteractionController$", {
  Lreactbuild_common_components_InteractionController$: 1,
  O: 1
});
$c_Lreactbuild_common_components_InteractionController$.prototype.$classData = $d_Lreactbuild_common_components_InteractionController$;
var $n_Lreactbuild_common_components_InteractionController$;
function $m_Lreactbuild_common_components_InteractionController$() {
  if ((!$n_Lreactbuild_common_components_InteractionController$)) {
    $n_Lreactbuild_common_components_InteractionController$ = new $c_Lreactbuild_common_components_InteractionController$()
  };
  return $n_Lreactbuild_common_components_InteractionController$
}
function $is_Lreactbuild_common_components_InteractionResult(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_common_components_InteractionResult)))
}
function $as_Lreactbuild_common_components_InteractionResult(obj) {
  return (($is_Lreactbuild_common_components_InteractionResult(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.InteractionResult"))
}
function $isArrayOf_Lreactbuild_common_components_InteractionResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_InteractionResult)))
}
function $asArrayOf_Lreactbuild_common_components_InteractionResult(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_InteractionResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.InteractionResult;", depth))
}
/** @constructor */
function $c_Lreactbuild_common_components_UserConnection$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_UserConnection$.prototype = new $h_O();
$c_Lreactbuild_common_components_UserConnection$.prototype.constructor = $c_Lreactbuild_common_components_UserConnection$;
/** @constructor */
function $h_Lreactbuild_common_components_UserConnection$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_UserConnection$.prototype = $c_Lreactbuild_common_components_UserConnection$.prototype;
$c_Lreactbuild_common_components_UserConnection$.prototype.apply__T__Ljapgolly_scalajs_react_vdom_TagOf = (function(path) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var state = $as_T(window.btoa(path));
  var $$x4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$());
  var this$2 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_button;
  var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$2, s);
  var $$x2 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontSize__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("150%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x1 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "padding")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".5em 1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$7 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
  var a = (((((("https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=" + $as_T(window.location.protocol)) + "//") + $as_T(window.location.host)) + "/oauth2/callback&response_type=code&include_granted_scopes=true&scope=email profile&access_type=offline&state=") + state) + "&client_id=873887578428-en50pamf50jifte8nfqm68tgjmbnmlsp.apps.googleusercontent.com");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array = [$$x3, $$x2, $$x1, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$7.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Se connecter avec Google"))];
  return $n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_common_components_UserConnection$.prototype.apply$default$1__T = (function() {
  return (("" + $as_T(window.location.pathname)) + $as_T(window.location.hash))
});
var $d_Lreactbuild_common_components_UserConnection$ = new $TypeData().initClass({
  Lreactbuild_common_components_UserConnection$: 0
}, false, "reactbuild.common.components.UserConnection$", {
  Lreactbuild_common_components_UserConnection$: 1,
  O: 1
});
$c_Lreactbuild_common_components_UserConnection$.prototype.$classData = $d_Lreactbuild_common_components_UserConnection$;
var $n_Lreactbuild_common_components_UserConnection$;
function $m_Lreactbuild_common_components_UserConnection$() {
  if ((!$n_Lreactbuild_common_components_UserConnection$)) {
    $n_Lreactbuild_common_components_UserConnection$ = new $c_Lreactbuild_common_components_UserConnection$()
  };
  return $n_Lreactbuild_common_components_UserConnection$
}
function $is_Lreactbuild_common_model_AssetDetails(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_common_model_AssetDetails)))
}
function $as_Lreactbuild_common_model_AssetDetails(obj) {
  return (($is_Lreactbuild_common_model_AssetDetails(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.AssetDetails"))
}
function $isArrayOf_Lreactbuild_common_model_AssetDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_AssetDetails)))
}
function $asArrayOf_Lreactbuild_common_model_AssetDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_AssetDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.AssetDetails;", depth))
}
/** @constructor */
function $c_Lreactbuild_common_model_AssetDetails$() {
  this.Lreactbuild_common_model_AssetDetails$__f_codecForAssetDetails = null;
  $n_Lreactbuild_common_model_AssetDetails$ = this;
  var inst$macro$160 = new $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$160));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_AssetDetails$__f_codecForAssetDetails = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_AssetDetails$.prototype = new $h_O();
$c_Lreactbuild_common_model_AssetDetails$.prototype.constructor = $c_Lreactbuild_common_model_AssetDetails$;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDetails$.prototype = $c_Lreactbuild_common_model_AssetDetails$.prototype;
var $d_Lreactbuild_common_model_AssetDetails$ = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDetails$: 0
}, false, "reactbuild.common.model.AssetDetails$", {
  Lreactbuild_common_model_AssetDetails$: 1,
  O: 1
});
$c_Lreactbuild_common_model_AssetDetails$.prototype.$classData = $d_Lreactbuild_common_model_AssetDetails$;
var $n_Lreactbuild_common_model_AssetDetails$;
function $m_Lreactbuild_common_model_AssetDetails$() {
  if ((!$n_Lreactbuild_common_model_AssetDetails$)) {
    $n_Lreactbuild_common_model_AssetDetails$ = new $c_Lreactbuild_common_model_AssetDetails$()
  };
  return $n_Lreactbuild_common_model_AssetDetails$
}
function $ct_Lreactbuild_common_model_Country__T__T__($thiz, code, name) {
  $thiz.Lreactbuild_common_model_Country__f_code = code;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_common_model_Country() {
  this.Lreactbuild_common_model_Country__f_code = null
}
$c_Lreactbuild_common_model_Country.prototype = new $h_O();
$c_Lreactbuild_common_model_Country.prototype.constructor = $c_Lreactbuild_common_model_Country;
/** @constructor */
function $h_Lreactbuild_common_model_Country() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Country.prototype = $c_Lreactbuild_common_model_Country.prototype;
function $as_Lreactbuild_common_model_Country(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Country) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Country"))
}
function $isArrayOf_Lreactbuild_common_model_Country(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Country)))
}
function $asArrayOf_Lreactbuild_common_model_Country(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Country(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Country;", depth))
}
/** @constructor */
function $c_Lreactbuild_common_model_Country$() {
  this.Lreactbuild_common_model_Country$__f_list = null;
  this.Lreactbuild_common_model_Country$__f_codecForCountry = null;
  $n_Lreactbuild_common_model_Country$ = this;
  var this$4 = $m_sci_ListSet$();
  var array = [$m_Lreactbuild_common_model_Country$France$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_common_model_Country$__f_list = this$4.from__sc_IterableOnce__sci_ListSet(elems);
  var this$5 = $n(this.Lreactbuild_common_model_Country$__f_list);
  var b = new $c_sci_ListSet$$anon$1();
  var it = this$5.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var arg1 = $n(it).next__O();
    var c = $as_Lreactbuild_common_model_Country(arg1);
    var self = $n(c).Lreactbuild_common_model_Country__f_code;
    var elem = $ct_T2__O__O__(new $c_T2(), self, c);
    b.addOne__O__sci_ListSet$$anon$1(elem)
  };
  var $$x1 = $n($as_sc_IterableOnceOps(b.scm_ImmutableBuilder__f_elems));
  var this$9 = $m_s_$less$colon$less$();
  $n($$x1).toMap__s_$less$colon$less__sci_Map(this$9.s_$less$colon$less$__f_singleton);
  var inst$macro$8 = new $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$8));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_Country$__f_codecForCountry = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_Country$.prototype = new $h_O();
$c_Lreactbuild_common_model_Country$.prototype.constructor = $c_Lreactbuild_common_model_Country$;
/** @constructor */
function $h_Lreactbuild_common_model_Country$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Country$.prototype = $c_Lreactbuild_common_model_Country$.prototype;
var $d_Lreactbuild_common_model_Country$ = new $TypeData().initClass({
  Lreactbuild_common_model_Country$: 0
}, false, "reactbuild.common.model.Country$", {
  Lreactbuild_common_model_Country$: 1,
  O: 1
});
$c_Lreactbuild_common_model_Country$.prototype.$classData = $d_Lreactbuild_common_model_Country$;
var $n_Lreactbuild_common_model_Country$;
function $m_Lreactbuild_common_model_Country$() {
  if ((!$n_Lreactbuild_common_model_Country$)) {
    $n_Lreactbuild_common_model_Country$ = new $c_Lreactbuild_common_model_Country$()
  };
  return $n_Lreactbuild_common_model_Country$
}
/** @constructor */
function $c_Lreactbuild_components_Form$() {
  this.Lreactbuild_components_Form$__f_landscapeRow = null;
  this.Lreactbuild_components_Form$__f_title = null;
  this.Lreactbuild_components_Form$__f_row = null;
  this.Lreactbuild_components_Form$__f_col = null;
  this.Lreactbuild_components_Form$__f_state = null;
  this.Lreactbuild_components_Form$__f_FormLayout = null;
  this.Lreactbuild_components_Form$__f_component = null;
  $n_Lreactbuild_components_Form$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_components_Form$__f_landscapeRow = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x9 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x8 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    var this$8 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x7 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$8.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")));
    $n(dsl);
    var this$10 = $m_Lscalacss_internal_Attrs$flexWrap$();
    var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$10.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
    $n(dsl);
    var this$12 = $m_Lscalacss_internal_Attrs$alignItems$();
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$12.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1")));
    $n(dsl);
    $n(dsl);
    var this$17 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var $$x3 = $n($n(dsl).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__portrait__O(this$17), new $c_sjsr_AnonFunction1(((x$2) => {
      var x = $as_Lscalacss_internal_Media$Query(x$2);
      return $n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x)
    }))));
    $n(dsl);
    var this$19 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$19.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")));
    $n(dsl);
    var this$21 = $m_Lscalacss_internal_Attrs$flexWrap$();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$21.Lscalacss_internal_Attrs$flexWrap$__f_attr, "nowrap")));
    $n(dsl);
    var this$23 = $m_Lscalacss_internal_Attrs$alignItems$();
    var array = [$$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$23.Lscalacss_internal_Attrs$alignItems$__f_attr, "stretch")))];
    var x$1 = $n($$x3).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$1 = [$$x8, $$x7, $$x6, $$x5, $$x4, new $c_Lscalacss_internal_DslBase$ToStyle(x$1)];
    return $as_sci_Seq($n($$x9).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })), new $c_Lsourcecode_Name("landscapeRow"));
  var this$34 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$1 = "div";
  this.Lreactbuild_components_Form$__f_title = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$34, v$1)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x13 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var this$36 = $m_Lscalacss_internal_Attrs$display$();
    var $$x12 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$36.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$3);
    var this$38 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x11 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$38.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")));
    $n(dsl$3);
    var this$40 = $m_Lscalacss_internal_Attrs$fontWeight$();
    var $$x10 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$40.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")));
    $n(dsl$3);
    var this$49 = $m_Lscalacss_internal_Attrs$fontSize$();
    $n(dsl$3);
    $n(dsl$3);
    var this$ = 120;
    var f$1 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$);
    $n(dsl$3);
    $n(dsl$3);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lscalacss_internal_Percentage(x$4$2);
      return $n(x$4).value__T()
    })));
    $n(dsl$3);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var v$2 = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$3 = $n(v$2).Lscalacss_internal_ValueT__f_value;
    var array$2 = [$$x12, $$x11, $$x10, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$49.Lscalacss_internal_Attrs$fontSize$__f_attr, v$3)))];
    return $as_sci_Seq($n($$x13).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)))
  })), new $c_Lsourcecode_Name("title"));
  var this$55 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$4 = "div";
  $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$55, v$4)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$4$2) => {
    var dsl$4 = $as_Lscalacss_internal_DslBase(dsl$4$2);
    var $$x18 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$4);
    var this$57 = $m_Lscalacss_internal_Attrs$display$();
    var $$x17 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$57.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$4);
    var this$59 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x16 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$59.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")));
    $n(dsl$4);
    var this$61 = $m_Lscalacss_internal_Attrs$flexWrap$();
    var $$x15 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$61.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
    $n(dsl$4);
    var this$63 = $m_Lscalacss_internal_Attrs$alignItems$();
    var $$x14 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$63.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
    $n(dsl$4);
    $n(dsl$4);
    var a$1 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var array$3 = [$$x17, $$x16, $$x15, $$x14, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, "1")))];
    return $as_sci_Seq($n($$x18).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)))
  })), new $c_Lsourcecode_Name("fullRow"));
  var this$72 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$5 = "div";
  this.Lreactbuild_components_Form$__f_row = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$72, v$5)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$5$2) => {
    var dsl$5 = $as_Lscalacss_internal_DslBase(dsl$5$2);
    var $$x22 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$5);
    var this$74 = $m_Lscalacss_internal_Attrs$display$();
    var $$x21 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$74.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$5);
    var this$76 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x20 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$76.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")));
    $n(dsl$5);
    var this$78 = $m_Lscalacss_internal_Attrs$flexWrap$();
    var $$x19 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$78.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
    $n(dsl$5);
    var this$80 = $m_Lscalacss_internal_Attrs$alignItems$();
    var array$4 = [$$x21, $$x20, $$x19, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$80.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")))];
    return $as_sci_Seq($n($$x22).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)))
  })), new $c_Lsourcecode_Name("row"));
  var this$86 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$6 = "div";
  this.Lreactbuild_components_Form$__f_col = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$86, v$6)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$6$2) => {
    var dsl$6 = $as_Lscalacss_internal_DslBase(dsl$6$2);
    var $$x26 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$6);
    var this$88 = $m_Lscalacss_internal_Attrs$display$();
    var $$x25 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$88.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$6);
    var this$90 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x24 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$90.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")));
    $n(dsl$6);
    $n(dsl$6);
    var a$2 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var $$x23 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2, "1")));
    $n(dsl$6);
    var this$95 = $m_Lscalacss_internal_Attrs$alignItems$();
    var array$5 = [$$x25, $$x24, $$x23, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$95.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")))];
    return $as_sci_Seq($n($$x26).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
  })), new $c_Lsourcecode_Name("col"));
  this.Lreactbuild_components_Form$__f_state = new $c_sjsr_AnonFunction2(((s$2, a$2$1) => {
    var s = $as_Lreactbuild_components_Form$State(s$2);
    var a$3 = $as_Lreactbuild_components_Form$Action(a$2$1);
    var x$3 = $m_Lreactbuild_components_Form$Pending$();
    if ((x$3 === a$3)) {
      var this$99 = $n($n(s).Lreactbuild_components_Form$State__f_events);
      var x$2$2 = new $c_sci_$colon$colon(a$3, this$99);
      var this$100 = $n(s);
      var x$3$1 = this$100.Lreactbuild_components_Form$State__f_context;
      $n(s);
      return new $c_Lreactbuild_components_Form$State(x$3$1, true, x$2$2)
    } else {
      var x$4$1 = $m_Lreactbuild_components_Form$Done$();
      if ((x$4$1 === a$3)) {
        var this$102 = $n($n(s).Lreactbuild_components_Form$State__f_events);
        var x$5$2 = new $c_sci_$colon$colon(a$3, this$102);
        var this$103 = $n(s);
        var x$6 = this$103.Lreactbuild_components_Form$State__f_context;
        $n(s);
        return new $c_Lreactbuild_components_Form$State(x$6, false, x$5$2)
      } else {
        throw new $c_s_MatchError(a$3)
      }
    }
  }));
  var this$107 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$7 = "form";
  this.Lreactbuild_components_Form$__f_FormLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$107, v$7)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$7$2) => {
    var dsl$7 = $as_Lscalacss_internal_DslBase(dsl$7$2);
    var $$x27 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$7);
    $n(dsl$7);
    var a$4 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var array$6 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$7).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$4, "1")))];
    return $as_sci_Seq($n($$x27).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6)))
  })), new $c_Lsourcecode_Name("FormLayout"));
  var this$163 = $m_Lcom_iz2use_react_hooks_package$();
  var this$118 = $n($n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First())).withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First());
  var reducer = this.Lreactbuild_components_Form$__f_state;
  var initialState = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_components_Form$State(new $c_Lcom_iz2use_react_components_FormContext$Simple(), false, $m_s_package$().s_package$__f_Nil)));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep();
  var this$122 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducer__F2__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$118, reducer, initialState, step)));
  var initialState$1 = new $c_sjsr_AnonFunction0((() => {
    var this$119 = $m_Ljava_time_LocalTime$();
    return this$119.now__Ljava_time_Clock__Ljava_time_LocalTime(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
  }));
  var this$121 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(this$121);
  var this$162 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$122, initialState$1, step$1)));
  var f$5 = new $c_sjsr_AnonFunction4(((p$2, children$2, state$2, time$2) => {
    var p = $as_Lreactbuild_components_Form$Props(p$2);
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(time$2);
    var submit = new $c_sjsr_AnonFunction1(((ev$2) => {
      var cb = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline("Submit ?", $m_sci_Nil$()), new $c_sjsr_AnonFunction1(((x$6$2) => {
        $as_jl_Void(x$6$2);
        var $$x28 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var this$123 = $n(state);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x28).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($n($as_Lreactbuild_components_Form$State(this$123.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_components_Form$State__f_context).check__Ljapgolly_scalajs_react_callback_Trampoline(), new $c_sjsr_AnonFunction1(((ready$2) => {
          var ready = $uZ(ready$2);
          var $$x30 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var $$x29 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
          var array$7 = [ready];
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x30).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($$x29).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline("Ready ?", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)), new $c_sjsr_AnonFunction1(((x$5$2$1) => {
            $as_jl_Void(x$5$2$1);
            $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
            var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).require__F0__F0(new $c_sjsr_AnonFunction0((() => ready))), new $c_sjsr_AnonFunction1(((x$4$2$1) => {
              $as_jl_Void(x$4$2$1);
              $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
              var $$x31 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
              $m_Ljapgolly_scalajs_react_package$();
              var this$128 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
              var c = $n($$x31).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$128.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$3$2) => {
                $as_jl_Void(x$3$2);
                var $$x32 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
                $m_Ljapgolly_scalajs_react_Reusable$();
                var r$1 = $n(state).dispatch__O__Ljapgolly_scalajs_react_Reusable($m_Lreactbuild_components_Form$Pending$());
                return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x32).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$1).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$2$2$1) => {
                  $as_jl_Void(x$2$2$1);
                  var $$x35 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
                  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
                  var f$2 = new $c_sjsr_AnonFunction0((() => {
                    $n($n(p).Lreactbuild_components_Form$Props$$anon$1__f_dispatcher).dispatch__O__V($n($n(p).Lreactbuild_components_Form$Props$$anon$1__f_dispatcher).finallyRun__F0__F0__O(new $c_sjsr_AnonFunction0((() => $n($n(p).Lreactbuild_components_Form$Props$$anon$1__f_dispatcher).handleError__F0__F1__O(new $c_sjsr_AnonFunction0((() => $n(p).Lreactbuild_components_Form$Props$$anon$1__f_submit)), new $c_sjsr_AnonFunction1(((ev$2$1) => {
                      var ev = $as_jl_Throwable(ev$2$1);
                      var $$x33 = $n($n(p).Lreactbuild_components_Form$Props$$anon$1__f_dispatcher);
                      var this$130 = $n(ev);
                      this$130.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
                      return $n($$x33).pure__O__O((void 0))
                    }))))), new $c_sjsr_AnonFunction0((() => {
                      var $$x34 = $n($n(p).Lreactbuild_components_Form$Props$$anon$1__f_dispatcher);
                      $m_Ljapgolly_scalajs_react_Reusable$();
                      var r$2 = $n(state).dispatch__O__Ljapgolly_scalajs_react_Reusable($m_Lreactbuild_components_Form$Done$());
                      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$2).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
                      var this$134 = $n(this$$1);
                      return $n($$x34).pure__O__O($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$134))
                    }))))
                  }));
                  var f$3 = new $c_sjsr_AnonFunction0((() => {
                    f$2.apply__O()
                  }));
                  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
                  var this$$2 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3);
                  var this$$3 = $n($$x35).toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_CallbackTo$().delayMs$extension__Ljapgolly_scalajs_react_callback_Trampoline__D__F1(this$$2, 1.0));
                  var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
                    $as_jl_Void(x$1$2$1)
                  }));
                  var this$140 = $n(this$$3);
                  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$140, f$4))
                }))))
              })));
              return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
            })));
            var $$x36 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
            var this$143 = $m_s_$less$colon$less$();
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x36).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$143.s_$less$colon$less$__f_singleton))
          }))))
        }))))
      })));
      var this$$4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().unless$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline(cb, new $c_sjsr_AnonFunction0((() => $uZ(ev$2.isDefaultPrevented()))));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$4, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty))
    }));
    var $$x40 = $m_Lcom_iz2use_react_components_FormContext$().Lcom_iz2use_react_components_FormContext$__f_provide;
    var this$145 = $n(state);
    var $$x39 = $n($as_Ljapgolly_scalajs_react_feature_Context$Provided($n($$x40).apply__O__O($n($as_Lreactbuild_components_Form$State(this$145.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_components_Form$State__f_context)));
    var $$x38 = $m_Lreactbuild_components_Form$().Lreactbuild_components_Form$__f_FormLayout;
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onSubmit");
    var $$x37 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(submit, $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$151 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "disabled");
    var this$150 = $n(state);
    var a$5 = $n($as_Lreactbuild_components_Form$State(this$150.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_components_Form$State__f_pending;
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
    var array$8 = [$$x37, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$151.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$5), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(children))];
    var array$9 = [$n($$x38).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
    return $n($$x39).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
  }));
  var this$161 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22(this$161);
  var s$1 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$162, f$5, step$2, s$1);
  this.Lreactbuild_components_Form$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$163, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.components.Form.component"))
}
$c_Lreactbuild_components_Form$.prototype = new $h_O();
$c_Lreactbuild_components_Form$.prototype.constructor = $c_Lreactbuild_components_Form$;
/** @constructor */
function $h_Lreactbuild_components_Form$() {
  /*<skip>*/
}
$h_Lreactbuild_components_Form$.prototype = $c_Lreactbuild_components_Form$.prototype;
$c_Lreactbuild_components_Form$.prototype.apply__O__sci_Seq__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(submit, children, dispatcher) {
  var c = this.Lreactbuild_components_Form$__f_component;
  var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_components_Form$Props$$anon$1(submit, dispatcher);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$3.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_components_Form$ = new $TypeData().initClass({
  Lreactbuild_components_Form$: 0
}, false, "reactbuild.components.Form$", {
  Lreactbuild_components_Form$: 1,
  O: 1
});
$c_Lreactbuild_components_Form$.prototype.$classData = $d_Lreactbuild_components_Form$;
var $n_Lreactbuild_components_Form$;
function $m_Lreactbuild_components_Form$() {
  if ((!$n_Lreactbuild_components_Form$)) {
    $n_Lreactbuild_components_Form$ = new $c_Lreactbuild_components_Form$()
  };
  return $n_Lreactbuild_components_Form$
}
function $is_Lreactbuild_components_Form$Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_components_Form$Action)))
}
function $as_Lreactbuild_components_Form$Action(obj) {
  return (($is_Lreactbuild_components_Form$Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.components.Form$Action"))
}
function $isArrayOf_Lreactbuild_components_Form$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_components_Form$Action)))
}
function $asArrayOf_Lreactbuild_components_Form$Action(obj, depth) {
  return (($isArrayOf_Lreactbuild_components_Form$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.components.Form$Action;", depth))
}
function $is_Lreactbuild_components_Form$Props(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_components_Form$Props)))
}
function $as_Lreactbuild_components_Form$Props(obj) {
  return (($is_Lreactbuild_components_Form$Props(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.components.Form$Props"))
}
function $isArrayOf_Lreactbuild_components_Form$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_components_Form$Props)))
}
function $asArrayOf_Lreactbuild_components_Form$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_components_Form$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.components.Form$Props;", depth))
}
/** @constructor */
function $c_Lreactbuild_components_ImageEditor$() {
  this.Lreactbuild_components_ImageEditor$__f_component = null;
  $n_Lreactbuild_components_ImageEditor$ = this;
  $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), $m_sci_Nil$());
  var this$6 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f = new $c_sjsr_AnonFunction1(((props$2) => {
    $as_Lreactbuild_components_ImageEditor$Props(props$2);
    return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  }));
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f, s);
  this.Lreactbuild_components_ImageEditor$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$6, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.components.ImageEditor.component"))
}
$c_Lreactbuild_components_ImageEditor$.prototype = new $h_O();
$c_Lreactbuild_components_ImageEditor$.prototype.constructor = $c_Lreactbuild_components_ImageEditor$;
/** @constructor */
function $h_Lreactbuild_components_ImageEditor$() {
  /*<skip>*/
}
$h_Lreactbuild_components_ImageEditor$.prototype = $c_Lreactbuild_components_ImageEditor$.prototype;
$c_Lreactbuild_components_ImageEditor$.prototype.apply__s_Option__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(urlOpt) {
  var c = this.Lreactbuild_components_ImageEditor$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_components_ImageEditor$Props(urlOpt);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_components_ImageEditor$ = new $TypeData().initClass({
  Lreactbuild_components_ImageEditor$: 0
}, false, "reactbuild.components.ImageEditor$", {
  Lreactbuild_components_ImageEditor$: 1,
  O: 1
});
$c_Lreactbuild_components_ImageEditor$.prototype.$classData = $d_Lreactbuild_components_ImageEditor$;
var $n_Lreactbuild_components_ImageEditor$;
function $m_Lreactbuild_components_ImageEditor$() {
  if ((!$n_Lreactbuild_components_ImageEditor$)) {
    $n_Lreactbuild_components_ImageEditor$ = new $c_Lreactbuild_components_ImageEditor$()
  };
  return $n_Lreactbuild_components_ImageEditor$
}
/** @constructor */
function $c_Lreactbuild_components_SearchBox$() {
  this.Lreactbuild_components_SearchBox$__f_reusableSearchResult = null;
  this.Lreactbuild_components_SearchBox$__f_searchBoxKey = null;
  this.Lreactbuild_components_SearchBox$__f_skeleton = null;
  this.Lreactbuild_components_SearchBox$__f_component = null;
  $n_Lreactbuild_components_SearchBox$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_components_SearchBox$__f_reusableSearchResult = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  this.Lreactbuild_components_SearchBox$__f_searchBoxKey = $m_ju_UUID$().randomUUID__ju_UUID();
  var $$x1 = $m_Lcom_iz2use_react_components_Skeleton$();
  var u = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(30);
  var this$3 = $n(u);
  var n = this$3.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  this.Lreactbuild_components_SearchBox$__f_skeleton = $n($$x1).list__I__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var this$134 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).usePageProps__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x3 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x2 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$14 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$133 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($$x3.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x2, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$14))));
  var f$3 = new $c_sjsr_AnonFunction3(((props$2, pageProps$2, search$2) => {
    $as_jl_Void(props$2);
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var search = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(search$2);
    var this$131 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Entrez votre recherche (nom de projet, r\u00e9f\u00e9rences, organisations ...)");
    var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    $m_Lcom_iz2use_common_Parsable$();
    var ev = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev);
    var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$21 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$21);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv = $m_s_math_Equiv$String$();
    var equiv = new $c_s_math_Equiv$OptionEquiv(eqv);
    var $$x32 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, search, optioner, ev$1, explainError, equiv);
    var $$x31 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
    var $$x30 = $n(search).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var $$x25 = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_s_Option(x$1$2);
      var this$26 = $n(x$1);
      if (this$26.isEmpty__Z()) {
        var $$x26 = $m_s_None$()
      } else {
        var arg1 = this$26.get__O();
        var search$1 = $as_T(arg1);
        var this$27 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x29 = new $c_Lautowire_ClientProxy(this$27).Lautowire_ClientProxy__f_self;
        var $$x28 = $m_s_package$().s_package$__f_Seq;
        var array$1 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "search"];
        var $$x27 = $as_sci_Seq($n($$x28).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
        var this$38 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$32 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$33 = $n(new $c_Lautowire_ClientProxy(this$32).Lautowire_ClientProxy__f_self);
        var evidence$2$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
        var y = this$33.write__O__Lio_circe_Encoder__Lio_circe_Json(search$1, evidence$2$1);
        var array$2 = [$ct_T2__O__O__(new $c_T2(), "input", y)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
        var $$x26 = new $c_s_Some($n($n($$x29).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x27, this$38.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2$1) => {
          var x$1$1 = $as_Lio_circe_Json(x$1$2$1);
          var this$39 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$41 = $n(new $c_Lautowire_ClientProxy(this$39).Lautowire_ClientProxy__f_self);
          $m_Lio_circe_Decoder$();
          var decodeA = $m_Lreactbuild_model_SearchResult$().Lreactbuild_model_SearchResult$__f_codecForSearchResult;
          var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
          return $as_sci_List(this$41.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1$1, evidence$1))
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue))
      };
      var this$42 = $n($$x26);
      return $as_s_concurrent_Future((this$42.isEmpty__Z() ? $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_s_package$().s_package$__f_Nil) : this$42.get__O()))
    }));
    var $$x4 = new $c_sjsr_AnonFunction1(((ss$2) => {
      var ss = $as_Ldiode_data_Pot(ss$2);
      var this$122 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var this$45 = $n(ss);
      if ((!this$45.isEmpty__Z())) {
        var arg1$1 = $n(ss).get__O();
        var ss$2$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1$1);
        var this$109 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
        var this$108 = $n($as_sci_List($n(ss$2$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
        var f$2 = ((x0$1$2) => {
          var x0$1 = $as_Lreactbuild_model_SearchResult(x0$1$2);
          if ((x0$1 instanceof $c_Lreactbuild_model_SearchResult$PersonReference)) {
            var x2 = $as_Lreactbuild_model_SearchResult$PersonReference(x0$1);
            var item = $n(x2).Lreactbuild_model_SearchResult$PersonReference__f_item;
            var $$x10 = $m_Lcom_iz2use_react_components_Link$();
            var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var $$x8 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline($m_Lcom_iz2use_react_components_Dialog$Pop$());
            var this$47 = $n($n(pageProps).Lreactbuild_package$PageProps__f_router);
            var route = new $c_Lreactbuild_Loc$Person($m_s_Option$().apply__O__s_Option($n(item).Lreactbuild_person_PersonReferenceEvent__f_person));
            var $$x7 = $n($n($$x10).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x9).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x8, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$47.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)));
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            $m_Lcom_iz2use_common_Textualizable$();
            var v = $n(item).Lreactbuild_person_PersonReferenceEvent__f_person;
            var this$49 = $m_Lreactbuild_model_Implicits$();
            $m_Lreactbuild_model_Implicits$();
            var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
            var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$49, proxy);
            var v$1 = $n(ev$2).stringify__O__T(v);
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
            var rassoc$1 = $n($$x7).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
            var this$66 = $n($n(item).Lreactbuild_person_PersonReferenceEvent__f_target);
            var f = ((target$2) => {
              var target = $as_Lreactbuild_common_model_RefTo(target$2);
              var $$x14 = $m_Lcom_iz2use_react_components_Link$();
              var $$x13 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
              var $$x12 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline($m_Lcom_iz2use_react_components_Dialog$Pop$());
              var this$57 = $n($n(pageProps).Lreactbuild_package$PageProps__f_router);
              var route$1 = new $c_Lreactbuild_Loc$Project(new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary($m_s_Option$().apply__O__s_Option(target)));
              var $$x11 = $n($n($$x14).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x13).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x12, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$57.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route$1, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)));
              $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
              $m_Lcom_iz2use_common_Textualizable$();
              var this$59 = $m_Lreactbuild_model_Implicits$();
              $m_Lreactbuild_model_Implicits$();
              var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
              var ev$3 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$59, proxy$1);
              var v$2 = $n(ev$3).stringify__O__T(target);
              $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
              var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
              return $n($$x11).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
            });
            if ((this$66 === $m_sci_Nil$())) {
              var $$x15 = $m_sci_Nil$()
            } else {
              var arg1$2 = this$66.head__O();
              var h = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
              var t = h;
              var rest = $as_sci_List(this$66.tail__O());
              while ((rest !== $m_sci_Nil$())) {
                var arg1$3 = $n(rest).head__O();
                var nx = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
                $n(t).sci_$colon$colon__f_next = nx;
                t = nx;
                rest = $as_sci_List($n(rest).tail__O())
              };
              var $$x15 = h
            };
            var this$67 = $n($$x15);
            var list = new $c_sci_$colon$colon(rassoc$1, this$67);
            var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            var $$x18 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            var as = $n(item).Lreactbuild_person_PersonReferenceEvent__f_details;
            var array$6 = [$n($$x18).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((detail$2) => {
              var detail = $as_Lreactbuild_person_PersonReferenceDetails(detail$2);
              var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
              $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
              $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
              $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
              var v$3 = $n(detail).Lreactbuild_person_PersonReferenceDetails__f_model;
              $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
              var $$x20 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3);
              $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
              $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
              var $$x19 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" : ");
              $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
              var v$4 = $n(detail).Lreactbuild_person_PersonReferenceDetails__f_value;
              $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
              var array$5 = [$$x20, $$x19, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
              return $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
            })))];
            var $$x17 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
            var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            var sep = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" \u2022 ");
            var this$93 = $m_s_$less$colon$less$();
            var f$1 = this$93.s_$less$colon$less$__f_singleton;
            var array$7 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(list, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$1)];
            var array$8 = [$$x17, $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
            return $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
          } else {
            var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            var v$5 = ("" + x0$1);
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            var array$9 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
            return $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
          }
        });
        if ((this$108 === $m_sci_Nil$())) {
          var ns = $m_sci_Nil$()
        } else {
          var arg1$4 = this$108.head__O();
          var h$1 = new $c_sci_$colon$colon(f$2(arg1$4), $m_sci_Nil$());
          var t$1 = h$1;
          var rest$1 = $as_sci_List(this$108.tail__O());
          while ((rest$1 !== $m_sci_Nil$())) {
            var arg1$5 = $n(rest$1).head__O();
            var nx$1 = new $c_sci_$colon$colon(f$2(arg1$5), $m_sci_Nil$());
            $n(t$1).sci_$colon$colon__f_next = nx$1;
            t$1 = nx$1;
            rest$1 = $as_sci_List($n(rest$1).tail__O())
          };
          var ns = h$1
        };
        var $$x6 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$109, null, ns)
      } else {
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      };
      if ($n(ss).isPending__Z()) {
        var qual$1 = $as_Ldiode_data_PendingBase(ss);
        $n(qual$1);
        var this$114 = $ct_ju_Date__(new $c_ju_Date());
        var t$2 = this$114.ju_Date__f_java$util$Date$$millis;
        var lo = t$2.RTLong__f_lo;
        var hi = t$2.RTLong__f_hi;
        var this$115 = $n(qual$1);
        $f_Ldiode_data_PendingBase__duration__J__I(this$115, new $c_RTLong(lo, hi));
        var u$1 = $m_Lreactbuild_components_SearchBox$().Lreactbuild_components_SearchBox$__f_skeleton;
        var this$117 = $n(u$1);
        var n$1 = this$117.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var $$x5 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
      } else {
        var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      };
      var array$10 = [$$x6, $$x5];
      var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$122, null, ns$1)
    }));
    var this$124 = $m_Ljapgolly_scalajs_react_Reusability$();
    var this$123 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = this$123.by_$eq$eq__F2();
    var u$2 = $n($$x31).query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x30, $$x25, $$x4, this$124.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3), $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_components_SearchBox$().Lreactbuild_components_SearchBox$__f_reusableSearchResult), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var this$126 = $n(u$2);
    var n$2 = this$126.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$11 = [$$x32, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
    var ns$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$131, null, ns$2)
  }));
  var this$132 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$132);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonN__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner($m_Ljapgolly_scalajs_react_internal_Singleton$().Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit);
  var ev$4 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$133, f$3, step, s);
  this.Lreactbuild_components_SearchBox$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$134, ev$4).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.components.SearchBox.component"))
}
$c_Lreactbuild_components_SearchBox$.prototype = new $h_O();
$c_Lreactbuild_components_SearchBox$.prototype.constructor = $c_Lreactbuild_components_SearchBox$;
/** @constructor */
function $h_Lreactbuild_components_SearchBox$() {
  /*<skip>*/
}
$h_Lreactbuild_components_SearchBox$.prototype = $c_Lreactbuild_components_SearchBox$.prototype;
$c_Lreactbuild_components_SearchBox$.prototype.apply__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function() {
  var c = this.Lreactbuild_components_SearchBox$__f_component;
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n($as_Ljapgolly_scalajs_react_CtorType$Nullary($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).apply__O())
});
$c_Lreactbuild_components_SearchBox$.prototype.show__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var key = this.Lreactbuild_components_SearchBox$__f_searchBoxKey;
  var $$x1 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$();
  var u = $m_Lreactbuild_components_SearchBox$().apply__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot();
  var this$3 = $n(u);
  var n = this$3.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return $n($$x1).dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lcom_iz2use_react_components_Dialog$PushWithKey(key, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)))
});
var $d_Lreactbuild_components_SearchBox$ = new $TypeData().initClass({
  Lreactbuild_components_SearchBox$: 0
}, false, "reactbuild.components.SearchBox$", {
  Lreactbuild_components_SearchBox$: 1,
  O: 1
});
$c_Lreactbuild_components_SearchBox$.prototype.$classData = $d_Lreactbuild_components_SearchBox$;
var $n_Lreactbuild_components_SearchBox$;
function $m_Lreactbuild_components_SearchBox$() {
  if ((!$n_Lreactbuild_components_SearchBox$)) {
    $n_Lreactbuild_components_SearchBox$ = new $c_Lreactbuild_components_SearchBox$()
  };
  return $n_Lreactbuild_components_SearchBox$
}
function $is_Lreactbuild_format_dxf_Decoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_format_dxf_Decoder)))
}
function $as_Lreactbuild_format_dxf_Decoder(obj) {
  return (($is_Lreactbuild_format_dxf_Decoder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Decoder"))
}
function $isArrayOf_Lreactbuild_format_dxf_Decoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Decoder)))
}
function $asArrayOf_Lreactbuild_format_dxf_Decoder(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Decoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Decoder;", depth))
}
function $is_Lreactbuild_format_dxf_Encoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_format_dxf_Encoder)))
}
function $as_Lreactbuild_format_dxf_Encoder(obj) {
  return (($is_Lreactbuild_format_dxf_Encoder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Encoder"))
}
function $isArrayOf_Lreactbuild_format_dxf_Encoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Encoder)))
}
function $asArrayOf_Lreactbuild_format_dxf_Encoder(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Encoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Encoder;", depth))
}
function $is_Lreactbuild_format_dxf_Entity(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_format_dxf_Entity)))
}
function $as_Lreactbuild_format_dxf_Entity(obj) {
  return (($is_Lreactbuild_format_dxf_Entity(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Entity"))
}
function $isArrayOf_Lreactbuild_format_dxf_Entity(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Entity)))
}
function $asArrayOf_Lreactbuild_format_dxf_Entity(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Entity(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Entity;", depth))
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Entity$() {
  this.Lreactbuild_format_dxf_Entity$__f_config = null;
  this.Lreactbuild_format_dxf_Entity$__f_encodeEntity = null;
  this.Lreactbuild_format_dxf_Entity$__f_decodeEntity = null;
  $n_Lreactbuild_format_dxf_Entity$ = this;
  this.Lreactbuild_format_dxf_Entity$__f_config = new $c_Lreactbuild_format_dxf_Entity$$anon$1();
  var inst$macro$414 = new $c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$414));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Entity$__f_encodeEntity = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$1023 = new $c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1().inst$macro$415__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$1023));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Entity$__f_decodeEntity = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Entity$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Entity$.prototype.constructor = $c_Lreactbuild_format_dxf_Entity$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Entity$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Entity$.prototype = $c_Lreactbuild_format_dxf_Entity$.prototype;
var $d_Lreactbuild_format_dxf_Entity$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Entity$: 0
}, false, "reactbuild.format.dxf.Entity$", {
  Lreactbuild_format_dxf_Entity$: 1,
  O: 1
});
$c_Lreactbuild_format_dxf_Entity$.prototype.$classData = $d_Lreactbuild_format_dxf_Entity$;
var $n_Lreactbuild_format_dxf_Entity$;
function $m_Lreactbuild_format_dxf_Entity$() {
  if ((!$n_Lreactbuild_format_dxf_Entity$)) {
    $n_Lreactbuild_format_dxf_Entity$ = new $c_Lreactbuild_format_dxf_Entity$()
  };
  return $n_Lreactbuild_format_dxf_Entity$
}
function $is_Lreactbuild_format_dxf_Parameter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_format_dxf_Parameter)))
}
function $as_Lreactbuild_format_dxf_Parameter(obj) {
  return (($is_Lreactbuild_format_dxf_Parameter(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Parameter"))
}
function $isArrayOf_Lreactbuild_format_dxf_Parameter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Parameter)))
}
function $asArrayOf_Lreactbuild_format_dxf_Parameter(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Parameter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Parameter;", depth))
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Parameter$() {
  this.Lreactbuild_format_dxf_Parameter$__f_config = null;
  this.Lreactbuild_format_dxf_Parameter$__f_encodeParameter = null;
  this.Lreactbuild_format_dxf_Parameter$__f_decodeParameter = null;
  $n_Lreactbuild_format_dxf_Parameter$ = this;
  this.Lreactbuild_format_dxf_Parameter$__f_config = new $c_Lreactbuild_format_dxf_Parameter$$anon$1();
  var inst$macro$66 = new $c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$66));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Parameter$__f_encodeParameter = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$179 = new $c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1().inst$macro$67__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$179));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Parameter$__f_decodeParameter = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Parameter$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Parameter$.prototype.constructor = $c_Lreactbuild_format_dxf_Parameter$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Parameter$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Parameter$.prototype = $c_Lreactbuild_format_dxf_Parameter$.prototype;
var $d_Lreactbuild_format_dxf_Parameter$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Parameter$: 0
}, false, "reactbuild.format.dxf.Parameter$", {
  Lreactbuild_format_dxf_Parameter$: 1,
  O: 1
});
$c_Lreactbuild_format_dxf_Parameter$.prototype.$classData = $d_Lreactbuild_format_dxf_Parameter$;
var $n_Lreactbuild_format_dxf_Parameter$;
function $m_Lreactbuild_format_dxf_Parameter$() {
  if ((!$n_Lreactbuild_format_dxf_Parameter$)) {
    $n_Lreactbuild_format_dxf_Parameter$ = new $c_Lreactbuild_format_dxf_Parameter$()
  };
  return $n_Lreactbuild_format_dxf_Parameter$
}
function $is_Lreactbuild_format_dxf_Parser(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_format_dxf_Parser)))
}
function $as_Lreactbuild_format_dxf_Parser(obj) {
  return (($is_Lreactbuild_format_dxf_Parser(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Parser"))
}
function $isArrayOf_Lreactbuild_format_dxf_Parser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Parser)))
}
function $asArrayOf_Lreactbuild_format_dxf_Parser(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Parser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Parser;", depth))
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Parser$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Parser$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Parser$.prototype.constructor = $c_Lreactbuild_format_dxf_Parser$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Parser$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Parser$.prototype = $c_Lreactbuild_format_dxf_Parser$.prototype;
$c_Lreactbuild_format_dxf_Parser$.prototype.parseString__Lreactbuild_format_dxf_Parser = (function() {
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return x
  }));
  return new $c_Lreactbuild_format_dxf_Parser$$anon$2(f)
});
$c_Lreactbuild_format_dxf_Parser$.prototype.parseDouble__Lreactbuild_format_dxf_Parser = (function() {
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T(x$1$2);
    $m_sc_StringOps$();
    return $m_jl_Double$().parseDouble__T__D(x$1)
  }));
  return new $c_Lreactbuild_format_dxf_Parser$$anon$2(f)
});
$c_Lreactbuild_format_dxf_Parser$.prototype.parseInt__Lreactbuild_format_dxf_Parser = (function() {
  var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_T(x$2$2);
    $m_sc_StringOps$();
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x$2, 10)
  }));
  return new $c_Lreactbuild_format_dxf_Parser$$anon$2(f)
});
var $d_Lreactbuild_format_dxf_Parser$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Parser$: 0
}, false, "reactbuild.format.dxf.Parser$", {
  Lreactbuild_format_dxf_Parser$: 1,
  O: 1
});
$c_Lreactbuild_format_dxf_Parser$.prototype.$classData = $d_Lreactbuild_format_dxf_Parser$;
var $n_Lreactbuild_format_dxf_Parser$;
function $m_Lreactbuild_format_dxf_Parser$() {
  if ((!$n_Lreactbuild_format_dxf_Parser$)) {
    $n_Lreactbuild_format_dxf_Parser$ = new $c_Lreactbuild_format_dxf_Parser$()
  };
  return $n_Lreactbuild_format_dxf_Parser$
}
function $is_Lreactbuild_format_dxf_Serializer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_format_dxf_Serializer)))
}
function $as_Lreactbuild_format_dxf_Serializer(obj) {
  return (($is_Lreactbuild_format_dxf_Serializer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Serializer"))
}
function $isArrayOf_Lreactbuild_format_dxf_Serializer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Serializer)))
}
function $asArrayOf_Lreactbuild_format_dxf_Serializer(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Serializer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Serializer;", depth))
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Serializer$() {
  $n_Lreactbuild_format_dxf_Serializer$ = this;
  var f = new $c_sjsr_AnonFunction1(((records$2) => {
    var records = $as_sci_List(records$2);
    var this$2 = $n(records);
    var rest = this$2;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var record = $as_Lreactbuild_format_dxf_Record(arg1);
      var $$x1 = $m_s_package$().s_package$__f_Seq;
      var array = [$n($n(record).Lreactbuild_format_dxf_Record__f_groupCode).Lreactbuild_format_dxf_GroupCode__f_code, $n(record).Lreactbuild_format_dxf_Record__f_data];
      var it = $n($as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx
        } else {
          $n(t).sci_$colon$colon__f_next = nx
        };
        t = nx
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    var this$6 = $n(((h === null) ? $m_sci_Nil$() : h));
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$6, "", "\r\n", "")
  }));
  new $c_Lreactbuild_format_dxf_Serializer$$anon$1(f)
}
$c_Lreactbuild_format_dxf_Serializer$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Serializer$.prototype.constructor = $c_Lreactbuild_format_dxf_Serializer$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Serializer$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Serializer$.prototype = $c_Lreactbuild_format_dxf_Serializer$.prototype;
$c_Lreactbuild_format_dxf_Serializer$.prototype.serializeString__Lreactbuild_format_dxf_Serializer = (function() {
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return x
  }));
  return new $c_Lreactbuild_format_dxf_Serializer$$anon$1(f)
});
$c_Lreactbuild_format_dxf_Serializer$.prototype.serializeDouble__Lreactbuild_format_dxf_Serializer = (function() {
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $uD(x$2);
    return ("" + x)
  }));
  return new $c_Lreactbuild_format_dxf_Serializer$$anon$1(f)
});
$c_Lreactbuild_format_dxf_Serializer$.prototype.serializeInt__Lreactbuild_format_dxf_Serializer = (function() {
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $uI(x$2);
    return ("" + x)
  }));
  return new $c_Lreactbuild_format_dxf_Serializer$$anon$1(f)
});
$c_Lreactbuild_format_dxf_Serializer$.prototype.serializeBitSetCaseClass__Lshapeless_Generic__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lreactbuild_format_dxf_Serializer = (function(gen, traversable, annots, traversableAnnots) {
  var f = new $c_sjsr_AnonFunction1(((a$2) => {
    var this$2 = $n(traversable);
    var l = $as_Lshapeless_HList($n(gen).to__O__O(a$2));
    var $$x1 = $as_sc_StrictOptimizedIterableOps($f_Lshapeless_ops_hlist$ToTraversable__apply__Lshapeless_HList__O(this$2, l));
    var this$4 = $n(traversableAnnots);
    var this$3 = $n(annots);
    var l$1 = this$3.apply__Lshapeless_HList();
    return $uI($n($as_sc_LinearSeqOps($n($$x1).zip__sc_IterableOnce__O($as_sc_IterableOnce($f_Lshapeless_ops_hlist$ToTraversable__apply__Lshapeless_HList__O(this$4, l$1))))).foldLeft__O__F2__O(0, new $c_sjsr_AnonFunction2(((acc$2, c$2) => {
      var acc = $uI(acc$2);
      var c = $as_T2(c$2);
      if ((c !== null)) {
        var p2 = $n(c)._1$mcZ$sp__Z();
        var p3 = $as_s_Some($n(c)._2__O());
        if (((p2 === true) && (p3 !== null))) {
          var p4 = $as_Lreactbuild_format_dxf_BitIndex($n(p3).s_Some__f_value);
          if ((p4 !== null)) {
            var idx = $n(p4).Lreactbuild_format_dxf_BitIndex__f_index;
            return (acc | (1 << idx))
          }
        }
      };
      return acc
    }))))
  }));
  var serializeB = this.serializeInt__Lreactbuild_format_dxf_Serializer();
  return new $c_Lreactbuild_format_dxf_Serializer$$anon$2(serializeB, f)
});
var $d_Lreactbuild_format_dxf_Serializer$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Serializer$: 0
}, false, "reactbuild.format.dxf.Serializer$", {
  Lreactbuild_format_dxf_Serializer$: 1,
  O: 1
});
$c_Lreactbuild_format_dxf_Serializer$.prototype.$classData = $d_Lreactbuild_format_dxf_Serializer$;
var $n_Lreactbuild_format_dxf_Serializer$;
function $m_Lreactbuild_format_dxf_Serializer$() {
  if ((!$n_Lreactbuild_format_dxf_Serializer$)) {
    $n_Lreactbuild_format_dxf_Serializer$ = new $c_Lreactbuild_format_dxf_Serializer$()
  };
  return $n_Lreactbuild_format_dxf_Serializer$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_Expressions$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_Expressions$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_Expressions$.prototype.constructor = $c_Lreactbuild_format_iz2use_Expressions$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_Expressions$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_Expressions$.prototype = $c_Lreactbuild_format_iz2use_Expressions$.prototype;
$c_Lreactbuild_format_iz2use_Expressions$.prototype.absoluteInt__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$26) {
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$26).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$26).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$26).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("absoluteInt").Lsourcecode_Name__f_value, startIndex)
  };
  var startPos = $n(evidence$26).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$26).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$26).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  $m_Lreactbuild_format_iz2use_Literals$().digits__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$26);
  $n(evidence$26).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var x1$3 = ((!$n(evidence$26).Lfastparse_ParsingRun__f_isSuccess) ? evidence$26 : $n(evidence$26).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$26).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$26).Lfastparse_ParsingRun__f_index)));
  if (instrument) {
    $n($n(evidence$26).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("absoluteInt").Lsourcecode_Name__f_value, $n(x1$3).Lfastparse_ParsingRun__f_index, $n(x1$3).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$3).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(x1$3);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("absoluteInt").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$3).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$3).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(x1$3);
      var self = new $c_Lsourcecode_Name("absoluteInt").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$9 = $n($n(x1$3).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$9)
    }
  };
  if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
    var parse0$1 = x1$3
  } else {
    var $$x3 = $n(x1$3);
    var arg1 = $as_T($n(x1$3).Lfastparse_ParsingRun__f_successValue);
    $m_sc_StringOps$();
    var this$13 = $m_jl_Integer$();
    $$x3.Lfastparse_ParsingRun__f_successValue = this$13.parseInt__T__I__I(arg1, 10);
    var parse0$1 = x1$3
  };
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var parse0$2 = parse0$1
  } else {
    var $$x5 = $n(parse0$1);
    var arg1$1 = $uI($n(parse0$1).Lfastparse_ParsingRun__f_successValue);
    $m_Leu_timepit_refined_package$();
    var this$16 = $n($m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType);
    var $$x4 = new $c_Leu_timepit_refined_internal_RefinePartiallyApplied(this$16);
    var v = $m_Leu_timepit_refined_numeric$Less$().lessValidate__Leu_timepit_refined_internal_WitnessAs__s_math_Numeric__Leu_timepit_refined_api_Validate($m_Leu_timepit_refined_internal_WitnessAs$().natWitnessAs__Lshapeless_Witness__Lshapeless_ops_nat$ToInt__s_math_Numeric__Leu_timepit_refined_internal_WitnessAs($m_Lshapeless_Witness$().Lshapeless_Witness$__f_witness0, $m_Lshapeless_ops_nat$ToInt$().Lshapeless_ops_nat$ToInt$__f_toInt0, $m_s_math_Numeric$IntIsIntegral$()), $m_s_math_Numeric$IntIsIntegral$());
    $$x5.Lfastparse_ParsingRun__f_successValue = $$x4.apply__O__Leu_timepit_refined_api_Validate__s_util_Either(arg1$1, new $c_Leu_timepit_refined_boolean$Not$$anon$1(v));
    var parse0$2 = parse0$1
  };
  if ((!$n(parse0$2).Lfastparse_ParsingRun__f_isSuccess)) {
    return parse0$2
  } else {
    var oldCapturing$2 = $n(parse0$2).Lfastparse_ParsingRun__f_noDropBuffer;
    var successValue = $n(parse0$2).Lfastparse_ParsingRun__f_successValue;
    $n(parse0$2).Lfastparse_ParsingRun__f_noDropBuffer = true;
    $n(parse0$2).freshSuccessUnit__Lfastparse_ParsingRun();
    $n(parse0$2).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing$2;
    if (((!$n(parse0$2).Lfastparse_ParsingRun__f_isSuccess) && $n(parse0$2).Lfastparse_ParsingRun__f_cut)) {
      return parse0$2
    } else {
      var arg1$2 = $as_s_util_Either(successValue);
      if ((arg1$2 instanceof $c_s_util_Left)) {
        return $m_Lfastparse_package$().Fail__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$26)
      } else {
        if ((!(arg1$2 instanceof $c_s_util_Right))) {
          throw new $c_s_MatchError(arg1$2)
        };
        var x3 = $as_s_util_Right(arg1$2);
        var v$1 = $as_jl_Integer($n($as_Leu_timepit_refined_api_Refined($n(x3).s_util_Right__f_value)).Leu_timepit_refined_api_Refined__f_value);
        return $m_Lfastparse_package$().Pass__O__Lfastparse_ParsingRun__Lfastparse_ParsingRun(new $c_Leu_timepit_refined_api_Refined(v$1), evidence$26)
      }
    }
  }
});
$c_Lreactbuild_format_iz2use_Expressions$.prototype.absoluteLength__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$28) {
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$28).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$28).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$28).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("absoluteLength").Lsourcecode_Name__f_value, startIndex)
  };
  var x1$2 = this.absoluteInt__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$28);
  if (instrument) {
    $n($n(evidence$28).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("absoluteLength").Lsourcecode_Name__f_value, $n(x1$2).Lfastparse_ParsingRun__f_index, $n(x1$2).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$2).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(x1$2);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("absoluteLength").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$2).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$2).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$2).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(x1$2);
      var self = new $c_Lsourcecode_Name("absoluteLength").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$8 = $n($n(x1$2).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$8)
    }
  };
  if ((!$n(x1$2).Lfastparse_ParsingRun__f_isSuccess)) {
    var parse0 = x1$2
  } else {
    var $$x5 = $n(x1$2);
    var ev$1 = $n(x1$2).Lfastparse_ParsingRun__f_successValue;
    var arg1 = new $c_Leu_timepit_refined_api_Refined(((ev$1 === null) ? null : $as_jl_Integer($n($as_Leu_timepit_refined_api_Refined(ev$1)).Leu_timepit_refined_api_Refined__f_value)));
    var l = $as_jl_Integer(arg1.Leu_timepit_refined_api_Refined__f_value);
    $m_Leu_timepit_refined_package$();
    var this$11 = $n($m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType);
    var $$x4 = new $c_Leu_timepit_refined_internal_RefinePartiallyApplied(this$11);
    var tp = new $c_Leu_timepit_refined_api_Refined(l);
    var rt = $m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType;
    var $$x3 = new $c_Lreactbuild_format_iz2use_package$Length($uI($n(rt).unwrap__O__O(tp)));
    var v = $m_Leu_timepit_refined_numeric$Less$().lessValidate__Leu_timepit_refined_internal_WitnessAs__s_math_Numeric__Leu_timepit_refined_api_Validate($m_Lreactbuild_format_iz2use_package$Length$().witnessAsLength__Lshapeless_Witness__Lshapeless_ops_nat$ToInt__Leu_timepit_refined_internal_WitnessAs($m_Lshapeless_Witness$().Lshapeless_Witness$__f_witness0, $m_Lshapeless_ops_nat$ToInt$().Lshapeless_ops_nat$ToInt$__f_toInt0), $m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_numericLength);
    $$x5.Lfastparse_ParsingRun__f_successValue = $$x4.apply__O__Leu_timepit_refined_api_Validate__s_util_Either($$x3, new $c_Leu_timepit_refined_boolean$Not$$anon$1(v));
    var parse0 = x1$2
  };
  if ((!$n(parse0).Lfastparse_ParsingRun__f_isSuccess)) {
    return parse0
  } else {
    var oldCapturing = $n(parse0).Lfastparse_ParsingRun__f_noDropBuffer;
    var successValue = $n(parse0).Lfastparse_ParsingRun__f_successValue;
    $n(parse0).Lfastparse_ParsingRun__f_noDropBuffer = true;
    $n(parse0).freshSuccessUnit__Lfastparse_ParsingRun();
    $n(parse0).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
    if (((!$n(parse0).Lfastparse_ParsingRun__f_isSuccess) && $n(parse0).Lfastparse_ParsingRun__f_cut)) {
      return parse0
    } else {
      var arg1$1 = $as_s_util_Either(successValue);
      if ((arg1$1 instanceof $c_s_util_Left)) {
        return $m_Lfastparse_package$().Fail__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$28)
      } else {
        if ((!(arg1$1 instanceof $c_s_util_Right))) {
          throw new $c_s_MatchError(arg1$1)
        };
        var x3 = $as_s_util_Right(arg1$1);
        var v$1 = $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined($n(x3).s_util_Right__f_value)).Leu_timepit_refined_api_Refined__f_value);
        return $m_Lfastparse_package$().Pass__O__Lfastparse_ParsingRun__Lfastparse_ParsingRun(new $c_Leu_timepit_refined_api_Refined(v$1), evidence$28)
      }
    }
  }
});
$c_Lreactbuild_format_iz2use_Expressions$.prototype.length__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$29) {
  var startIndex = $n(evidence$29).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$29).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$29).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("length").Lsourcecode_Name__f_value, startIndex)
  };
  var ev = $m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_numericLength;
  $m_Lfastparse_package$();
  var startIndex$1 = $n(evidence$29).Lfastparse_ParsingRun__f_index;
  var instrument$1 = ($n(evidence$29).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument$1) {
    $n($n(evidence$29).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("negatable").Lsourcecode_Name__f_value, startIndex$1)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$2 = $n(evidence$29).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$29).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var startPos = $n(evidence$29).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$29).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$29).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var startPos$2 = $n(evidence$29).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$29).Lfastparse_ParsingRun__f_cut;
  $n(evidence$29).Lfastparse_ParsingRun__f_cut = false;
  $m_Lfastparse_package$();
  var oldCut = $n(evidence$29).Lfastparse_ParsingRun__f_cut;
  $n(evidence$29).Lfastparse_ParsingRun__f_cut = false;
  var startPos$3 = $n(evidence$29).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var input = $n(evidence$29).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$29).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$2 = $n(input);
    var this$3 = $n(this$2.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$3, index) === 43)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$29).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$29).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$29).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$29).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"+\"")))
  };
  var lhsMsg = $n(evidence$29).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$29).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$29).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$29).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$29).Lfastparse_ParsingRun__f_cut | oldCut)))
  } else if ($n(evidence$29).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures = $n(evidence$29).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$29).Lfastparse_ParsingRun__f_index = startPos$3;
    if (verboseFailures) {
      var this$6 = $n(evidence$29);
      this$6.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$29).Lfastparse_ParsingRun__f_cut = false;
    var input$2 = $n(evidence$29).Lfastparse_ParsingRun__f_input;
    var index$2 = $n(evidence$29).Lfastparse_ParsingRun__f_index;
    if ($n(input$2).isReachable__I__Z(index$2)) {
      var this$7 = $n(input$2);
      var this$8 = $n(this$7.Lfastparse_IndexedParserInput__f_data);
      var $$x2 = ($charAt(this$8, index$2) === 45)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      $n(evidence$29).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
    } else {
      $n(evidence$29).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$29).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$29).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"-\"")))
    };
    var rhsMsg = $n(evidence$29).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$29).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$29).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$29).freshFailure__I__Lfastparse_ParsingRun(startPos$3)
    };
    $n(evidence$29).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$9 = $n(evidence$29);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$29).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$9.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, msgToSet, msgToAggregate, false)
    }
  };
  var postSuccess = $n(evidence$29).Lfastparse_ParsingRun__f_isSuccess;
  if (postSuccess) {
    var res$3 = $n(evidence$29).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$29), (void 0)));
    $n(res$3).Lfastparse_ParsingRun__f_cut = (!(!($n(res$3).Lfastparse_ParsingRun__f_cut | startCut)))
  } else if ($n(evidence$29).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var res$4 = $n(evidence$29).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos$2);
    $n(res$4).Lfastparse_ParsingRun__f_cut = (!(!($n(res$4).Lfastparse_ParsingRun__f_cut | startCut)))
  };
  if ($n(evidence$29).Lfastparse_ParsingRun__f_verboseFailures) {
    var msg = $n(evidence$29).Lfastparse_ParsingRun__f_shortParserMsg;
    var agg = $n(evidence$29).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ((!postSuccess)) {
      $n(evidence$29).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$2, new $c_sjsr_AnonFunction0((() => {
        var this$11 = $n(msg);
        return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$11.Lfastparse_internal_Msgs__f_value) + ".?")
      })), agg)
    }
  };
  $n(evidence$29).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  if ((!$n(evidence$29).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    $n(evidence$29).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$29).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$29).Lfastparse_ParsingRun__f_index))
  };
  if ((!$n(evidence$29).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$10 = evidence$29
  } else {
    var postLhsIndex$macro$3 = $n(evidence$29).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$29).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$29).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$29).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$29).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$29).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$29).Lfastparse_ParsingRun__f_cut)) {
      var x1$10 = evidence$29
    } else {
      var preRhsIndex$macro$4 = $n(evidence$29).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var parse0$2 = $m_Lreactbuild_format_iz2use_Expressions$().absoluteLength__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$29);
      if ($n(parse0$2).Lfastparse_ParsingRun__f_isSuccess) {
        var $$x3 = $n(parse0$2);
        var ev$1 = $n(parse0$2).Lfastparse_ParsingRun__f_successValue;
        var arg1 = new $c_Leu_timepit_refined_api_Refined(((ev$1 === null) ? null : $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(ev$1)).Leu_timepit_refined_api_Refined__f_value)));
        var x$12 = $as_Lreactbuild_format_iz2use_package$Length(arg1.Leu_timepit_refined_api_Refined__f_value);
        $$x3.Lfastparse_ParsingRun__f_successValue = x$12
      };
      var rhsAggregate$macro$7 = $n(evidence$29).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$29).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$29).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$29
      } else {
        var postRhsIndex$macro$5 = $n(evidence$29).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$29).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var res$macro$14 = $n(evidence$29).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($as_T(lhsValue$macro$12), $n(evidence$29).Lfastparse_ParsingRun__f_successValue), nextIndex$macro$13)
      };
      if ($n(evidence$29).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$29).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$29).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$10 = res$macro$14
    }
  };
  if (instrument$1) {
    $n($n(evidence$29).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("negatable").Lsourcecode_Name__f_value, $n(x1$10).Lfastparse_ParsingRun__f_index, $n(x1$10).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$10).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x4 = $n(x1$10);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("negatable").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex$1, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$10).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex$1 < $n(x1$10).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$10).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x5 = $n(x1$10);
      var self = new $c_Lsourcecode_Name("negatable").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex$1);
      var this$21 = $n($n(x1$10).Lfastparse_ParsingRun__f_failureStack);
      $$x5.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$21)
    }
  };
  if ((!$n(x1$10).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$2 = x1$10
  } else {
    var $$x7 = $n(x1$10);
    var arg1$1 = $as_T2($n(x1$10).Lfastparse_ParsingRun__f_successValue);
    matchEnd6: {
      var $$x6;
      if ((arg1$1 !== null)) {
        var p2 = $as_T($n(arg1$1)._1__O());
        var i = $n(arg1$1)._2__O();
        if ((p2 === "-")) {
          var $$x6 = $n(ev).negate__O__O(i);
          break matchEnd6
        }
      };
      if ((arg1$1 !== null)) {
        var i$2 = $n(arg1$1)._2__O();
        var $$x6 = i$2;
        break matchEnd6
      };
      throw new $c_s_MatchError(arg1$1)
    };
    $$x7.Lfastparse_ParsingRun__f_successValue = $$x6;
    var x1$2 = x1$10
  };
  if (instrument) {
    $n($n(evidence$29).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("length").Lsourcecode_Name__f_value, $n(x1$2).Lfastparse_ParsingRun__f_index, $n(x1$2).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$2).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x8 = $n(x1$2);
    $m_sci_List$();
    var array$1 = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("length").Lsourcecode_Name__f_value)))];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $n($$x8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)), $n(x1$2).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$2).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$2).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x9 = $n(x1$2);
      var self$1 = new $c_Lsourcecode_Name("length").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self$1, startIndex);
      var this$29 = $n($n(x1$2).Lfastparse_ParsingRun__f_failureStack);
      $$x9.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$29)
    }
  };
  return x1$2
});
var $d_Lreactbuild_format_iz2use_Expressions$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_Expressions$: 0
}, false, "reactbuild.format.iz2use.Expressions$", {
  Lreactbuild_format_iz2use_Expressions$: 1,
  O: 1
});
$c_Lreactbuild_format_iz2use_Expressions$.prototype.$classData = $d_Lreactbuild_format_iz2use_Expressions$;
var $n_Lreactbuild_format_iz2use_Expressions$;
function $m_Lreactbuild_format_iz2use_Expressions$() {
  if ((!$n_Lreactbuild_format_iz2use_Expressions$)) {
    $n_Lreactbuild_format_iz2use_Expressions$ = new $c_Lreactbuild_format_iz2use_Expressions$()
  };
  return $n_Lreactbuild_format_iz2use_Expressions$
}
function $p_Lreactbuild_format_iz2use_Literals$__ENDLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$30) {
  var startIndex = $n(evidence$30).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$30).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$30).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("ENDLINE").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$30).Lfastparse_ParsingRun__f_cut;
  $n(evidence$30).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$30).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var index = $n(evidence$30).Lfastparse_ParsingRun__f_index;
  var end = ((2 + index) | 0);
  var input = $n(evidence$30).Lfastparse_ParsingRun__f_input;
  if ($n(input).isReachable__I__Z((((-1) + end) | 0))) {
    var this$1 = $n(input);
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    if (($charAt(this$2, index) === 13)) {
      var this$3 = $n(input);
      var index$1 = ((1 + index) | 0);
      var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$4, index$1) === 10)
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$30).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
  } else {
    $n(evidence$30).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$30).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$30).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"\\r\\n\"")))
  };
  var lhsMsg = $n(evidence$30).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$30).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$30).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$30).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$30).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$5 = evidence$30
  } else if ($n(evidence$30).Lfastparse_ParsingRun__f_cut) {
    var x1$5 = evidence$30
  } else {
    var verboseFailures = $n(evidence$30).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$30).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$6 = $n(evidence$30);
      this$6.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$30).Lfastparse_ParsingRun__f_cut = false;
    var input$2 = $n(evidence$30).Lfastparse_ParsingRun__f_input;
    var index$2 = $n(evidence$30).Lfastparse_ParsingRun__f_index;
    if ($n(input$2).isReachable__I__Z(index$2)) {
      var this$7 = $n(input$2);
      var this$8 = $n(this$7.Lfastparse_IndexedParserInput__f_data);
      var $$x2 = ($charAt(this$8, index$2) === 10)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      $n(evidence$30).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
    } else {
      $n(evidence$30).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$30).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$30).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"\\n\"")))
    };
    var rhsMsg = $n(evidence$30).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$30).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$30).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$30).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$30).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$9 = $n(evidence$30);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$30).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$9.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$5 = evidence$30
  };
  if (instrument) {
    $n($n(evidence$30).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("ENDLINE").Lsourcecode_Name__f_value, $n(x1$5).Lfastparse_ParsingRun__f_index, $n(x1$5).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x3 = $n(x1$5);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("ENDLINE").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x4 = $n(x1$5);
      var self = new $c_Lsourcecode_Name("ENDLINE").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$16 = $n($n(x1$5).Lfastparse_ParsingRun__f_failureStack);
      $$x4.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$16)
    }
  };
  return x1$5
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_Literals$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_Literals$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_Literals$.prototype.constructor = $c_Lreactbuild_format_iz2use_Literals$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_Literals$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_Literals$.prototype = $c_Lreactbuild_format_iz2use_Literals$.prototype;
$c_Lreactbuild_format_iz2use_Literals$.prototype.NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$31) {
  var startIndex = $n(evidence$31).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$31).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$31).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("NEWLINE").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$31).Lfastparse_ParsingRun__f_cut;
  $n(evidence$31).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$31).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  $p_Lreactbuild_format_iz2use_Literals$__ENDLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(this, evidence$31);
  var lhsMsg = $n(evidence$31).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$31).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$31).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$31).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$31).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$3 = evidence$31
  } else if ($n(evidence$31).Lfastparse_ParsingRun__f_cut) {
    var x1$3 = evidence$31
  } else {
    var verboseFailures = $n(evidence$31).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$31).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$2 = $n(evidence$31);
      this$2.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$31).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$();
    var startPos$1 = $n(evidence$31).Lfastparse_ParsingRun__f_index;
    var startCut = $n(evidence$31).Lfastparse_ParsingRun__f_cut;
    var oldNoCut = $n(evidence$31).Lfastparse_ParsingRun__f_noDropBuffer;
    $n(evidence$31).Lfastparse_ParsingRun__f_noDropBuffer = true;
    $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$31);
    $n(evidence$31).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
    var msg = $n(evidence$31).Lfastparse_ParsingRun__f_shortParserMsg;
    var res = ($n(evidence$31).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$31).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$1) : evidence$31);
    if ($n(evidence$31).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$31).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
      $n(evidence$31).setMsg__I__F0__V(startPos$1, new $c_sjsr_AnonFunction0((() => {
        if ($is_sci_Seq(msg)) {
          var x2 = $as_sci_Seq(msg);
          $m_sci_Seq$();
          if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x2), true) && ($n(x2).lengthCompare__I__I(1) === 0))) {
            var this$8 = $n(msg);
            return (("&(" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value)) + ")")
          }
        };
        var this$9 = $n(msg);
        return ("&" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$9.Lfastparse_internal_Msgs__f_value))
      })))
    };
    $n(res).Lfastparse_ParsingRun__f_cut = startCut;
    var rhsMsg = $n(evidence$31).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$31).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$31).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$31).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$31).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$10 = $n(evidence$31);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$31).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$10.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$3 = evidence$31
  };
  if (instrument) {
    $n($n(evidence$31).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("NEWLINE").Lsourcecode_Name__f_value, $n(x1$3).Lfastparse_ParsingRun__f_index, $n(x1$3).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$3).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(x1$3);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("NEWLINE").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$3).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$3).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(x1$3);
      var self = new $c_Lsourcecode_Name("NEWLINE").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$17 = $n($n(x1$3).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$17)
    }
  };
  return x1$3
});
$c_Lreactbuild_format_iz2use_Literals$.prototype.digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$32) {
  var startIndex = $n(evidence$32).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$32).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$32).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value, startIndex)
  };
  var index = $n(evidence$32).Lfastparse_ParsingRun__f_index;
  if ((!$n($n(evidence$32).Lfastparse_ParsingRun__f_input).isReachable__I__Z(index))) {
    var res = $n(evidence$32).freshFailure__Lfastparse_ParsingRun()
  } else {
    var this$1 = $n($n(evidence$32).Lfastparse_ParsingRun__f_input);
    var index$1 = $n(evidence$32).Lfastparse_ParsingRun__f_index;
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    var x1$3 = $charAt(this$2, index$1);
    switch (x1$3) {
      case 48: {
        var x1$4 = true;
        break
      }
      case 49: {
        var x1$4 = true;
        break
      }
      case 50: {
        var x1$4 = true;
        break
      }
      case 51: {
        var x1$4 = true;
        break
      }
      case 52: {
        var x1$4 = true;
        break
      }
      case 53: {
        var x1$4 = true;
        break
      }
      case 54: {
        var x1$4 = true;
        break
      }
      case 55: {
        var x1$4 = true;
        break
      }
      case 56: {
        var x1$4 = true;
        break
      }
      case 57: {
        var x1$4 = true;
        break
      }
      default: {
        var x1$4 = false
      }
    };
    if ((x1$4 === true)) {
      var res = $n(evidence$32).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
    } else {
      if ((x1$4 !== false)) {
        throw new $c_s_MatchError(x1$4)
      };
      var res = $n(evidence$32).freshFailure__Lfastparse_ParsingRun()
    }
  };
  if ($n(evidence$32).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$32).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "[0123456789]")))
  };
  if (instrument) {
    $n($n(evidence$32).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value, $n(res).Lfastparse_ParsingRun__f_index, $n(res).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(res).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(res);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(res).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(res).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(res).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(res);
      var self = new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$10 = $n($n(res).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$10)
    }
  };
  return res
});
$c_Lreactbuild_format_iz2use_Literals$.prototype.digits__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$33) {
  var startIndex = $n(evidence$33).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$33).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$33).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("digits").Lsourcecode_Name__f_value, startIndex)
  };
  var elem = $n(evidence$33).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  var startIndex$macro$4 = $n(evidence$33).Lfastparse_ParsingRun__f_index;
  var count$macro$5 = 0;
  var lastAgg$macro$10 = null;
  var x1$4;
  while (true) {
    $n(evidence$33).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 1));
    $m_Lfastparse_package$();
    $m_Lreactbuild_format_iz2use_Literals$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$33);
    var parsedMsg$macro$9 = $n(evidence$33).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$11 = $n(evidence$33).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$33).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$33).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = ($n(evidence$33).Lfastparse_ParsingRun__f_cut ? evidence$33 : ((count$macro$5 < 1) ? $n(evidence$33).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$33).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$4, elem$1)));
      if ($n(evidence$33).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x4 = $n(evidence$33);
        var $$x3 = startIndex$macro$4;
        var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
          var this$3 = $n(parsedMsg$macro$9);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$3.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
        }))(parsedMsg$macro$9));
        if ((lastAgg$macro$10 === null)) {
          var $$x1 = $n(evidence$33).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$1 = $n(evidence$33).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x1 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
        };
        $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x3, $$x2, $$x1)
      };
      var x1$4 = res;
      break
    } else {
      var beforeSepIndex$macro$6 = $n(evidence$33).Lfastparse_ParsingRun__f_index;
      $n(evidence$33);
      $n(evidence$33).Lfastparse_ParsingRun__f_cut = false;
      if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$33)
      };
      if ((!((!$n(evidence$33).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$33).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$33).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$5 = ((1 + count$macro$5) | 0);
        startIndex$macro$4 = beforeSepIndex$macro$6;
        count$macro$5 = temp$count$macro$5;
        lastAgg$macro$10 = parsedAgg$macro$11;
        continue
      };
      var x1$4 = evidence$33;
      break
    }
  };
  if (instrument) {
    $n($n(evidence$33).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("digits").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("digits").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("digits").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$11)
    }
  };
  return x1$4
});
$c_Lreactbuild_format_iz2use_Literals$.prototype.ignoreSpaces__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$34) {
  var startIndex = $n(evidence$34).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$34).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$34).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("ignoreSpaces").Lsourcecode_Name__f_value, startIndex)
  };
  var elem = $n(evidence$34).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  var startIndex$macro$4 = $n(evidence$34).Lfastparse_ParsingRun__f_index;
  var count$macro$5 = 0;
  var lastAgg$macro$10 = null;
  var x1$4;
  while (true) {
    $n(evidence$34).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 0));
    $m_Lfastparse_package$();
    var oldCut = $n(evidence$34).Lfastparse_ParsingRun__f_cut;
    $n(evidence$34).Lfastparse_ParsingRun__f_cut = false;
    var startPos = $n(evidence$34).Lfastparse_ParsingRun__f_index;
    $m_Lfastparse_package$();
    var input = $n(evidence$34).Lfastparse_ParsingRun__f_input;
    var index = $n(evidence$34).Lfastparse_ParsingRun__f_index;
    if ($n(input).isReachable__I__Z(index)) {
      var this$3 = $n(input);
      var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$4, index) === 32)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(evidence$34).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
    } else {
      $n(evidence$34).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$34).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$34).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\" \"")))
    };
    var lhsMsg = $n(evidence$34).Lfastparse_ParsingRun__f_shortParserMsg;
    var lhsAggregate = $n(evidence$34).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ($n(evidence$34).Lfastparse_ParsingRun__f_isSuccess) {
      $n(evidence$34).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$34).Lfastparse_ParsingRun__f_cut | oldCut)))
    } else if ((!$n(evidence$34).Lfastparse_ParsingRun__f_cut)) {
      var verboseFailures = $n(evidence$34).Lfastparse_ParsingRun__f_verboseFailures;
      $n(evidence$34).Lfastparse_ParsingRun__f_index = startPos;
      if (verboseFailures) {
        var this$7 = $n(evidence$34);
        this$7.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
      };
      $n(evidence$34).Lfastparse_ParsingRun__f_cut = false;
      var input$2 = $n(evidence$34).Lfastparse_ParsingRun__f_input;
      var index$2 = $n(evidence$34).Lfastparse_ParsingRun__f_index;
      if ($n(input$2).isReachable__I__Z(index$2)) {
        var this$8 = $n(input$2);
        var this$9 = $n(this$8.Lfastparse_IndexedParserInput__f_data);
        var $$x2 = ($charAt(this$9, index$2) === 9)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        $n(evidence$34).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
      } else {
        $n(evidence$34).freshFailure__Lfastparse_ParsingRun()
      };
      if ($n(evidence$34).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$34).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"\\t\"")))
      };
      var rhsMsg = $n(evidence$34).Lfastparse_ParsingRun__f_shortParserMsg;
      var rhsCut = $n(evidence$34).Lfastparse_ParsingRun__f_cut;
      var endCut = (!(!(rhsCut | oldCut)));
      if (((!$n(evidence$34).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
        $n(evidence$34).freshFailure__I__Lfastparse_ParsingRun(startPos)
      };
      $n(evidence$34).Lfastparse_ParsingRun__f_cut = endCut;
      if (verboseFailures) {
        var this$10 = $n(evidence$34);
        var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
        var rassoc$3 = $n(evidence$34).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
        this$10.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
      }
    };
    var parsedMsg$macro$9 = $n(evidence$34).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$11 = $n(evidence$34).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$34).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$34).Lfastparse_ParsingRun__f_isSuccess)) {
      var res$1 = ($n(evidence$34).Lfastparse_ParsingRun__f_cut ? evidence$34 : ((count$macro$5 < 0) ? $n(evidence$34).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$34).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$4, elem$1)));
      if ($n(evidence$34).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x6 = $n(evidence$34);
        var $$x5 = startIndex$macro$4;
        var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
          var this$11 = $n(parsedMsg$macro$9);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$11.Lfastparse_internal_Msgs__f_value) + ".rep")
        }))(parsedMsg$macro$9));
        if ((lastAgg$macro$10 === null)) {
          var $$x3 = $n(evidence$34).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$1 = $n(evidence$34).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x3 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
        };
        $n($$x6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x5, $$x4, $$x3)
      };
      var x1$4 = res$1;
      break
    } else {
      var beforeSepIndex$macro$6 = $n(evidence$34).Lfastparse_ParsingRun__f_index;
      $n(evidence$34);
      $n(evidence$34).Lfastparse_ParsingRun__f_cut = false;
      if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$34)
      };
      if ((!((!$n(evidence$34).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$34).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$34).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$5 = ((1 + count$macro$5) | 0);
        startIndex$macro$4 = beforeSepIndex$macro$6;
        count$macro$5 = temp$count$macro$5;
        lastAgg$macro$10 = parsedAgg$macro$11;
        continue
      };
      var x1$4 = evidence$34;
      break
    }
  };
  if (instrument) {
    $n($n(evidence$34).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("ignoreSpaces").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x7 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("ignoreSpaces").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x8 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("ignoreSpaces").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$19 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x8.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$19)
    }
  };
  return x1$4
});
var $d_Lreactbuild_format_iz2use_Literals$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_Literals$: 0
}, false, "reactbuild.format.iz2use.Literals$", {
  Lreactbuild_format_iz2use_Literals$: 1,
  O: 1
});
$c_Lreactbuild_format_iz2use_Literals$.prototype.$classData = $d_Lreactbuild_format_iz2use_Literals$;
var $n_Lreactbuild_format_iz2use_Literals$;
function $m_Lreactbuild_format_iz2use_Literals$() {
  if ((!$n_Lreactbuild_format_iz2use_Literals$)) {
    $n_Lreactbuild_format_iz2use_Literals$ = new $c_Lreactbuild_format_iz2use_Literals$()
  };
  return $n_Lreactbuild_format_iz2use_Literals$
}
function $p_Lreactbuild_format_iz2use_Parser$__comment$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$1) {
  var startIndex = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$1).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("comment").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$43 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var input$macro$52 = $n(evidence$1).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$28 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var input$macro$37 = $n(evidence$1).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var input = $n(evidence$1).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$3 = $n(input);
    var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$4, index) === 35)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$1).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$1).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$1).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"#\"")))
  };
  if ((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$29 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$32 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$35 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$1).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$29 > preLhsIndex$macro$28) && $n(evidence$1).checkForDrop__Z())) {
      $n(input$macro$37)
    };
    $n(evidence$1);
    if (((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$1).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$30 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
      var elem = $n(evidence$1).Lfastparse_ParsingRun__f_cut;
      var elem$1 = false;
      elem$1 = elem;
      var startIndex$macro$19 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
      var count$macro$20 = 0;
      var lastAgg$macro$25 = null;
      while (true) {
        $n(evidence$1).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$20 < 0));
        $m_Lfastparse_package$();
        $m_Lfastparse_Implicits$Sequencer$();
        var preLhsIndex$macro$2 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
        var input$macro$11 = $n(evidence$1).Lfastparse_ParsingRun__f_input;
        $m_Lfastparse_package$();
        $m_Lfastparse_package$();
        var startPos = $n(evidence$1).Lfastparse_ParsingRun__f_index;
        var startCut = $n(evidence$1).Lfastparse_ParsingRun__f_cut;
        var oldNoCut = $n(evidence$1).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$1).Lfastparse_ParsingRun__f_noDropBuffer = true;
        var startTerminals = $n(evidence$1).Lfastparse_ParsingRun__f_failureTerminalAggregate;
        var oldCut = $n(evidence$1).Lfastparse_ParsingRun__f_cut;
        $n(evidence$1).Lfastparse_ParsingRun__f_cut = false;
        var startPos$1 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$();
        $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$1);
        var lhsMsg = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
        var lhsAggregate = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ($n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) {
          $n(evidence$1).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$1).Lfastparse_ParsingRun__f_cut | oldCut)))
        } else if ((!$n(evidence$1).Lfastparse_ParsingRun__f_cut)) {
          var verboseFailures = $n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures;
          $n(evidence$1).Lfastparse_ParsingRun__f_index = startPos$1;
          if (verboseFailures) {
            var this$13 = $n(evidence$1);
            this$13.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$1, lhsMsg, lhsAggregate, false)
          };
          $n(evidence$1).Lfastparse_ParsingRun__f_cut = false;
          $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$1);
          var rhsMsg = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
          var rhsCut = $n(evidence$1).Lfastparse_ParsingRun__f_cut;
          var endCut = (!(!(rhsCut | oldCut)));
          if (((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
            $n(evidence$1).freshFailure__I__Lfastparse_ParsingRun(startPos$1)
          };
          $n(evidence$1).Lfastparse_ParsingRun__f_cut = endCut;
          if (verboseFailures) {
            var this$14 = $n(evidence$1);
            var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
            var rassoc$3 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
            this$14.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$1, msgToSet, msgToAggregate, false)
          }
        };
        $n(evidence$1).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
        var msg = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
        var res$1 = ($n(evidence$1).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$1).freshFailure__I__Lfastparse_ParsingRun(startPos) : $n(evidence$1).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos));
        if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$1).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
          $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
          $n(evidence$1).setMsg__I__F0__V(startPos, new $c_sjsr_AnonFunction0(((msg) => (() => {
            var this$15 = $n(msg);
            return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$15.Lfastparse_internal_Msgs__f_value))
          }))(msg)))
        };
        $n(res$1).Lfastparse_ParsingRun__f_cut = startCut;
        if ($n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) {
          var postLhsIndex$macro$3 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
          var lhsAggregate$macro$6 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var lhsMsg$macro$9 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
          if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$1).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          $n(evidence$1);
          if ((!((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$1).Lfastparse_ParsingRun__f_cut))) {
            var preRhsIndex$macro$4 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
            $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$1);
            var rhsAggregate$macro$7 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var rhsMsg$macro$8 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
            if ((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess)) {
              /*<skip>*/
            } else {
              var postRhsIndex$macro$5 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
              var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
              var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
              if ((rhsMadeProgress$macro$10 && $n(evidence$1).checkForDrop__Z())) {
                $n(input$macro$11)
              };
              var $$x2 = $n(evidence$1);
              $n(evidence$1);
              var v = (void 0);
              $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
            };
            if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
              $n(evidence$1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$1).Lfastparse_ParsingRun__f_traceIndex))
            }
          }
        };
        var parsedMsg$macro$24 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
        var parsedAgg$macro$26 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
        elem$1 = (!(!(elem$1 | $n(evidence$1).Lfastparse_ParsingRun__f_cut)));
        if ((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$2 = ($n(evidence$1).Lfastparse_ParsingRun__f_cut ? evidence$1 : ((count$macro$20 < 0) ? $n(evidence$1).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19, elem$1) : $n(evidence$1).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19, elem$1)));
          if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
            var $$x6 = $n(evidence$1);
            var $$x5 = startIndex$macro$19;
            var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
              var this$17 = $n(parsedMsg$macro$24);
              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$17.Lfastparse_internal_Msgs__f_value) + ".rep")
            }))(parsedMsg$macro$24));
            if ((lastAgg$macro$25 === null)) {
              var $$x3 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate
            } else {
              var rassoc$2 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var $$x3 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
            };
            $n($$x6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x5, $$x4, $$x3)
          };
          break
        } else {
          var beforeSepIndex$macro$21 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
          $n(evidence$1);
          $n(evidence$1).Lfastparse_ParsingRun__f_cut = false;
          if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$1)
          };
          if (((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$1).Lfastparse_ParsingRun__f_cut)) {
            break
          } else {
            $n(evidence$1).Lfastparse_ParsingRun__f_cut = false;
            var temp$count$macro$20 = ((1 + count$macro$20) | 0);
            startIndex$macro$19 = beforeSepIndex$macro$21;
            count$macro$20 = temp$count$macro$20;
            lastAgg$macro$25 = parsedAgg$macro$26
          }
        }
      };
      var rhsAggregate$macro$33 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$34 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess)) {
        $n(evidence$1).Lfastparse_ParsingRun__f_cut = true;
        var res$macro$40 = evidence$1
      } else {
        var postRhsIndex$macro$31 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$36 = (postRhsIndex$macro$31 > preRhsIndex$macro$30);
        var nextIndex$macro$39 = (((!rhsMadeProgress$macro$36) && $n(input$macro$37).isReachable__I__Z(postRhsIndex$macro$31)) ? postLhsIndex$macro$29 : postRhsIndex$macro$31);
        if ((rhsMadeProgress$macro$36 && $n(evidence$1).checkForDrop__Z())) {
          $n(input$macro$37)
        };
        var $$x7 = $n(evidence$1);
        $n(evidence$1);
        var v$1 = (void 0);
        var res$macro$40 = $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$39)
      };
      if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$28, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$35, rhsMsg$macro$34), $n(lhsAggregate$macro$32).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$33), (preRhsIndex$macro$30 === $n(evidence$1).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$9 = evidence$1
  } else {
    var postLhsIndex$macro$44 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$47 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$50 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$44 > preLhsIndex$macro$43) && $n(evidence$1).checkForDrop__Z())) {
      $n(input$macro$52)
    };
    $n(evidence$1);
    if (((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$1).Lfastparse_ParsingRun__f_cut)) {
      var x1$9 = evidence$1
    } else {
      var preRhsIndex$macro$45 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var startPos$2 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
      var startCut$1 = $n(evidence$1).Lfastparse_ParsingRun__f_cut;
      var oldNoCut$1 = $n(evidence$1).Lfastparse_ParsingRun__f_noDropBuffer;
      $n(evidence$1).Lfastparse_ParsingRun__f_noDropBuffer = true;
      var oldCut$1 = $n(evidence$1).Lfastparse_ParsingRun__f_cut;
      $n(evidence$1).Lfastparse_ParsingRun__f_cut = false;
      var startPos$3 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$1);
      var lhsMsg$1 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
      var lhsAggregate$1 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
      if ($n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) {
        $n(evidence$1).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$1).Lfastparse_ParsingRun__f_cut | oldCut$1)))
      } else if ((!$n(evidence$1).Lfastparse_ParsingRun__f_cut)) {
        var verboseFailures$1 = $n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures;
        $n(evidence$1).Lfastparse_ParsingRun__f_index = startPos$3;
        if (verboseFailures$1) {
          var this$21 = $n(evidence$1);
          this$21.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, lhsMsg$1, lhsAggregate$1, false)
        };
        $n(evidence$1).Lfastparse_ParsingRun__f_cut = false;
        $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$1);
        var rhsMsg$1 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
        var rhsCut$1 = $n(evidence$1).Lfastparse_ParsingRun__f_cut;
        var endCut$1 = (!(!(rhsCut$1 | oldCut$1)));
        if (((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$1))) {
          $n(evidence$1).freshFailure__I__Lfastparse_ParsingRun(startPos$3)
        };
        $n(evidence$1).Lfastparse_ParsingRun__f_cut = endCut$1;
        if (verboseFailures$1) {
          var this$22 = $n(evidence$1);
          var msgToSet$1 = $n(lhsMsg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$1);
          var rassoc$3$1 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var msgToAggregate$1 = $n(lhsAggregate$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$1);
          this$22.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, msgToSet$1, msgToAggregate$1, false)
        }
      };
      $n(evidence$1).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut$1;
      var msg$1 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
      var res$3 = ($n(evidence$1).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$1).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$2) : evidence$1);
      if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
        $n(evidence$1).setMsg__I__F0__V(startPos$2, new $c_sjsr_AnonFunction0((() => {
          if ($is_sci_Seq(msg$1)) {
            var x2 = $as_sci_Seq(msg$1);
            $m_sci_Seq$();
            if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x2), true) && ($n(x2).lengthCompare__I__I(1) === 0))) {
              var this$27 = $n(msg$1);
              return (("&(" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$27.Lfastparse_internal_Msgs__f_value)) + ")")
            }
          };
          var this$28 = $n(msg$1);
          return ("&" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$28.Lfastparse_internal_Msgs__f_value))
        })))
      };
      $n(res$3).Lfastparse_ParsingRun__f_cut = startCut$1;
      var rhsAggregate$macro$48 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$49 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$55 = evidence$1
      } else {
        var postRhsIndex$macro$46 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$51 = (postRhsIndex$macro$46 > preRhsIndex$macro$45);
        var nextIndex$macro$54 = (((!rhsMadeProgress$macro$51) && $n(input$macro$52).isReachable__I__Z(postRhsIndex$macro$46)) ? postLhsIndex$macro$44 : postRhsIndex$macro$46);
        if ((rhsMadeProgress$macro$51 && $n(evidence$1).checkForDrop__Z())) {
          $n(input$macro$52)
        };
        var $$x8 = $n(evidence$1);
        $n(evidence$1);
        var v$2 = (void 0);
        var res$macro$55 = $n($$x8).freshSuccess__O__I__Lfastparse_ParsingRun(v$2, nextIndex$macro$54)
      };
      if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$43, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$50, rhsMsg$macro$49), $n(lhsAggregate$macro$47).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$48), (preRhsIndex$macro$45 === $n(evidence$1).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$9 = res$macro$55
    }
  };
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("comment").Lsourcecode_Name__f_value, $n(x1$9).Lfastparse_ParsingRun__f_index, $n(x1$9).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$9).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x9 = $n(x1$9);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("comment").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x9).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$9).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$9).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$9).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x10 = $n(x1$9);
      var self = new $c_Lsourcecode_Name("comment").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$35 = $n($n(x1$9).Lfastparse_ParsingRun__f_failureStack);
      $$x10.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$35)
    }
  };
  return x1$9
}
function $p_Lreactbuild_format_iz2use_Parser$__forget$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$2) {
  var startIndex = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$2).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("forget").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$32 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var input$macro$41 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$17 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$2).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var startPos = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
  var oldNoCut = $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer = true;
  var startTerminals = $n(evidence$2).Lfastparse_ParsingRun__f_failureTerminalAggregate;
  $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$2);
  $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
  var msg = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
  var res = ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$2).freshFailure__I__Lfastparse_ParsingRun(startPos) : $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos));
  if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$2).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
    $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
    $n(evidence$2).setMsg__I__F0__V(startPos, new $c_sjsr_AnonFunction0((() => {
      var this$6 = $n(msg);
      return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value))
    })))
  };
  $n(res).Lfastparse_ParsingRun__f_cut = startCut;
  if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$2).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$2);
    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$4 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
      $m_Lreactbuild_format_iz2use_Literals$().ignoreSpaces__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$2);
      var rhsAggregate$macro$7 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$2
      } else {
        var postRhsIndex$macro$5 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$2).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x1 = $n(evidence$2);
        $n(evidence$2);
        var v = (void 0);
        var res$macro$14 = $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
      };
      if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$2).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$18 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$2).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    $n(evidence$2);
    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$19 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
      var startPos$1 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
      var startCut$1 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
      $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
      $m_Lfastparse_package$();
      $p_Lreactbuild_format_iz2use_Parser$__comment$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun($thiz, evidence$2);
      var postSuccess = $n(evidence$2).Lfastparse_ParsingRun__f_isSuccess;
      if (postSuccess) {
        var res$1 = $n(evidence$2).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$2), (void 0)));
        $n(res$1).Lfastparse_ParsingRun__f_cut = (!(!($n(res$1).Lfastparse_ParsingRun__f_cut | startCut$1)))
      } else if ($n(evidence$2).Lfastparse_ParsingRun__f_cut) {
        /*<skip>*/
      } else {
        var res$2 = $n(evidence$2).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos$1);
        $n(res$2).Lfastparse_ParsingRun__f_cut = (!(!($n(res$2).Lfastparse_ParsingRun__f_cut | startCut$1)))
      };
      if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
        var msg$1 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
        var agg = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
        if ((!postSuccess)) {
          $n(evidence$2).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$1, new $c_sjsr_AnonFunction0((() => {
            var this$10 = $n(msg$1);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$10.Lfastparse_internal_Msgs__f_value) + ".?")
          })), agg)
        }
      };
      var rhsAggregate$macro$22 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$23 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$29 = evidence$2
      } else {
        var postRhsIndex$macro$20 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
        var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
        if ((rhsMadeProgress$macro$25 && $n(evidence$2).checkForDrop__Z())) {
          $n(input$macro$26)
        };
        var $$x2 = $n(evidence$2);
        $n(evidence$2);
        var v$1 = (void 0);
        var res$macro$29 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$28)
      };
      if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$2).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$10 = evidence$2
  } else {
    var postLhsIndex$macro$33 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$36 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$39 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$33 > preLhsIndex$macro$32) && $n(evidence$2).checkForDrop__Z())) {
      $n(input$macro$41)
    };
    $n(evidence$2);
    if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
      var x1$10 = evidence$2
    } else {
      var preRhsIndex$macro$34 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var startPos$2 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
      var startCut$2 = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
      var oldNoCut$1 = $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer;
      $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer = true;
      var oldCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
      $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
      var startPos$3 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$2);
      var lhsMsg = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
      var lhsAggregate = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      if ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) {
        $n(evidence$2).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$2).Lfastparse_ParsingRun__f_cut | oldCut)))
      } else if ((!$n(evidence$2).Lfastparse_ParsingRun__f_cut)) {
        var verboseFailures = $n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures;
        $n(evidence$2).Lfastparse_ParsingRun__f_index = startPos$3;
        if (verboseFailures) {
          var this$14 = $n(evidence$2);
          this$14.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, lhsMsg, lhsAggregate, false)
        };
        $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
        $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$2);
        var rhsMsg = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
        var rhsCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!(rhsCut | oldCut)));
        if (((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
          $n(evidence$2).freshFailure__I__Lfastparse_ParsingRun(startPos$3)
        };
        $n(evidence$2).Lfastparse_ParsingRun__f_cut = endCut;
        if (verboseFailures) {
          var this$15 = $n(evidence$2);
          var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
          var rassoc$3 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
          this$15.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, msgToSet, msgToAggregate, false)
        }
      };
      $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut$1;
      var msg$2 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
      var res$4 = ($n(evidence$2).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$2).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$2) : evidence$2);
      if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
        $n(evidence$2).setMsg__I__F0__V(startPos$2, new $c_sjsr_AnonFunction0((() => {
          if ($is_sci_Seq(msg$2)) {
            var x2 = $as_sci_Seq(msg$2);
            $m_sci_Seq$();
            if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x2), true) && ($n(x2).lengthCompare__I__I(1) === 0))) {
              var this$20 = $n(msg$2);
              return (("&(" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$20.Lfastparse_internal_Msgs__f_value)) + ")")
            }
          };
          var this$21 = $n(msg$2);
          return ("&" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$21.Lfastparse_internal_Msgs__f_value))
        })))
      };
      $n(res$4).Lfastparse_ParsingRun__f_cut = startCut$2;
      var rhsAggregate$macro$37 = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$38 = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$44 = evidence$2
      } else {
        var postRhsIndex$macro$35 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$40 = (postRhsIndex$macro$35 > preRhsIndex$macro$34);
        var nextIndex$macro$43 = (((!rhsMadeProgress$macro$40) && $n(input$macro$41).isReachable__I__Z(postRhsIndex$macro$35)) ? postLhsIndex$macro$33 : postRhsIndex$macro$35);
        if ((rhsMadeProgress$macro$40 && $n(evidence$2).checkForDrop__Z())) {
          $n(input$macro$41)
        };
        var $$x3 = $n(evidence$2);
        $n(evidence$2);
        var v$2 = (void 0);
        var res$macro$44 = $n($$x3).freshSuccess__O__I__Lfastparse_ParsingRun(v$2, nextIndex$macro$43)
      };
      if ($n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$32, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$39, rhsMsg$macro$38), $n(lhsAggregate$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$37), (preRhsIndex$macro$34 === $n(evidence$2).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$10 = res$macro$44
    }
  };
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("forget").Lsourcecode_Name__f_value, $n(x1$10).Lfastparse_ParsingRun__f_index, $n(x1$10).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$10).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x4 = $n(x1$10);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("forget").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$10).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$10).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$10).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x5 = $n(x1$10);
      var self = new $c_Lsourcecode_Name("forget").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$28 = $n($n(x1$10).Lfastparse_ParsingRun__f_failureStack);
      $$x5.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$28)
    }
  };
  return x1$10
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_Parser$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_Parser$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_Parser$.prototype.constructor = $c_Lreactbuild_format_iz2use_Parser$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_Parser$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_Parser$.prototype = $c_Lreactbuild_format_iz2use_Parser$.prototype;
$c_Lreactbuild_format_iz2use_Parser$.prototype.whitespace__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Lfastparse_ParsingRun(ctx$2);
    $m_Lfastparse_package$();
    var repeater = $m_Lreactbuild_format_iz2use_Repeater$UnitRepeater$();
    var whitespace = $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$();
    var this$4 = $m_Lfastparse_internal_RepImpls$();
    var startIndex = $n(ctx).Lfastparse_ParsingRun__f_index;
    var count = 0;
    var precut = false;
    var outerCut = $n(ctx).Lfastparse_ParsingRun__f_cut;
    var sepMsg = null;
    var lastAgg = null;
    while (true) {
      $n(ctx).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 0) && outerCut))));
      $p_Lreactbuild_format_iz2use_Parser$__forget$1__Lfastparse_ParsingRun__Lfastparse_ParsingRun(this, ctx);
      var parsedMsg = $n(ctx).Lfastparse_ParsingRun__f_shortParserMsg;
      var parsedAgg = $n(ctx).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var postCut = $n(ctx).Lfastparse_ParsingRun__f_cut;
      var verboseFailures = $n(ctx).Lfastparse_ParsingRun__f_verboseFailures;
      if ((!$n(ctx).Lfastparse_ParsingRun__f_isSuccess)) {
        var res = (postCut ? ctx : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, startIndex, startIndex, count, (!(!(outerCut | postCut))), 0, ctx, repeater, (void 0)));
        if (verboseFailures) {
          var startIndex$1 = startIndex;
          var sepMsg$1 = sepMsg;
          var lastAgg$1 = lastAgg;
          var precut$1 = precut;
          if (((sepMsg$1 === null) || precut$1)) {
            $n(ctx).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$1, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
              var this$6 = $n(parsedMsg);
              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
            }))(parsedMsg)), $n(ctx).Lfastparse_ParsingRun__f_failureGroupAggregate)
          } else {
            var $$x3 = $n(ctx);
            var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
              var this$7 = $n(parsedMsg);
              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
            }))(parsedMsg));
            if ((lastAgg$1 === null)) {
              var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
            } else {
              var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
              var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
            };
            $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$1, $$x2, $$x1)
          }
        };
        return res
      } else {
        var beforeSepIndex = $n(ctx).Lfastparse_ParsingRun__f_index;
        var t = $n(ctx).Lfastparse_ParsingRun__f_successValue;
        $as_jl_Void(t);
        var nextCount = ((1 + count) | 0);
        if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
          $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, ctx)
        };
        if (((!$n(ctx).Lfastparse_ParsingRun__f_isSuccess) && $n(ctx).Lfastparse_ParsingRun__f_cut)) {
          return ctx
        } else {
          $n(ctx).Lfastparse_ParsingRun__f_cut = false;
          var sep1 = $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(ctx);
          var sepCut = $n(ctx).Lfastparse_ParsingRun__f_cut;
          var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
          if ((sep1 === null)) {
            startIndex = beforeSepIndex;
            count = nextCount;
            precut = false;
            outerCut = endCut;
            sepMsg = null;
            lastAgg = parsedAgg
          } else if ($n(ctx).Lfastparse_ParsingRun__f_isSuccess) {
            if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, ctx)
            };
            var temp$sepMsg$2 = $n(ctx).Lfastparse_ParsingRun__f_shortParserMsg;
            startIndex = beforeSepIndex;
            count = nextCount;
            precut = sepCut;
            outerCut = endCut;
            sepMsg = temp$sepMsg$2;
            lastAgg = parsedAgg
          } else {
            var res$2 = (sepCut ? $n(ctx).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut) : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, beforeSepIndex, beforeSepIndex, nextCount, endCut, 0, ctx, repeater, (void 0)));
            if (verboseFailures) {
              var startIndex$2 = startIndex;
              var $$x5 = $n(ctx);
              var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$9 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$9.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
              }))(parsedMsg));
              var rassoc$1 = $n(ctx).Lfastparse_ParsingRun__f_failureGroupAggregate;
              $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x4, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1))
            };
            return res$2
          }
        }
      }
    }
  }))
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.point__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$3) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$3).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("point").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$17 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$3).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$2 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$3).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lreactbuild_format_iz2use_Expressions$().length__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$3);
  if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$3).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$3).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$3);
    if ($n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$3).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$4 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
        var input = $n(evidence$3).Lfastparse_ParsingRun__f_input;
        var index = $n(evidence$3).Lfastparse_ParsingRun__f_index;
        if ($n(input).isReachable__I__Z(index)) {
          var this$4 = $n(input);
          var this$5 = $n(this$4.Lfastparse_IndexedParserInput__f_data);
          var $$x1 = ($charAt(this$5, index) === 44)
        } else {
          var $$x1 = false
        };
        if ($$x1) {
          $n(evidence$3).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
        } else {
          $n(evidence$3).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$3).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\",\"")))
        };
        var rhsAggregate$macro$7 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$14 = evidence$3
        } else {
          var postRhsIndex$macro$5 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$3).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x2 = $n(evidence$3);
          $n(x1$5);
          var t = $as_Lreactbuild_format_iz2use_package$Length(lhsValue$macro$12);
          $n(evidence$3);
          var res$macro$14 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$13)
        };
        if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$3).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$7 = evidence$3
  } else {
    var postLhsIndex$macro$18 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$3).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$3).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$3);
    if ($n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$3).Lfastparse_ParsingRun__f_cut)) {
        var x1$7 = evidence$3
      } else {
        var preRhsIndex$macro$19 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Expressions$().length__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$3);
        var rhsAggregate$macro$22 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$23 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$29 = evidence$3
        } else {
          var postRhsIndex$macro$20 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
          var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
          if ((rhsMadeProgress$macro$25 && $n(evidence$3).checkForDrop__Z())) {
            $n(input$macro$26)
          };
          var res$macro$29 = $n(evidence$3).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($as_Lreactbuild_format_iz2use_package$Length(lhsValue$macro$27), $as_Lreactbuild_format_iz2use_package$Length($n(evidence$3).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$28)
        };
        if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$3).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$7 = res$macro$29
      }
    } else {
      var x1$7 = evidence$3
    }
  };
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("point").Lsourcecode_Name__f_value, $n(x1$7).Lfastparse_ParsingRun__f_index, $n(x1$7).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$7).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x3 = $n(x1$7);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("point").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$7).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$7).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$7).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x4 = $n(x1$7);
      var self = new $c_Lsourcecode_Name("point").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$15 = $n($n(x1$7).Lfastparse_ParsingRun__f_failureStack);
      $$x4.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$15)
    }
  };
  if ((!$n(x1$7).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$7
  } else {
    var $$x5 = $n(x1$7);
    var arg1 = $as_T2($n(x1$7).Lfastparse_ParsingRun__f_successValue);
    if ((arg1 === null)) {
      throw new $c_s_MatchError(arg1)
    };
    var x1$2 = $n(arg1)._1__O();
    var x2 = $n(arg1)._2__O();
    var x = $as_Lreactbuild_format_iz2use_package$Length(x1$2);
    var y = $as_Lreactbuild_format_iz2use_package$Length(x2);
    $$x5.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_format_iz2use_package$Vector2D(x, y);
    return x1$7
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.edge__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$4) {
  var startIndex = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$4).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("edge").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$4).Lfastparse_ParsingRun__f_cut;
  $n(evidence$4).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var input = $n(evidence$4).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$2 = $n(input);
    var this$3 = $n(this$2.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$3, index) === 86)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$4).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$4).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$4).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"V\"")))
  };
  if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
    var parse0 = evidence$4
  } else {
    var postLhsIndex$macro$3 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$4).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$4);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$4);
    if ($n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$4).Lfastparse_ParsingRun__f_cut)) {
        var parse0 = evidence$4
      } else {
        var preRhsIndex$macro$4 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Expressions$().length__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$4);
        var rhsAggregate$macro$7 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$4).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$14 = evidence$4
        } else {
          var postRhsIndex$macro$5 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$4).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x2 = $n(evidence$4);
          var v = $as_Lreactbuild_format_iz2use_package$Length($n(evidence$4).Lfastparse_ParsingRun__f_successValue);
          var res$macro$14 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
        };
        if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$4).Lfastparse_ParsingRun__f_traceIndex))
        };
        var parse0 = res$macro$14
      }
    } else {
      var parse0 = evidence$4
    }
  };
  if ((!$n(parse0).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var $$x3 = $n(parse0);
    var arg1 = $as_Lreactbuild_format_iz2use_package$Length($n(parse0).Lfastparse_ParsingRun__f_successValue);
    $m_Lreactbuild_format_iz2use_package$Vector2D$();
    var x$2 = $m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_Zero;
    $$x3.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_format_iz2use_package$Vector2D(x$2, arg1)
  };
  var lhsMsg = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$4).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$11 = evidence$4
  } else if ($n(evidence$4).Lfastparse_ParsingRun__f_cut) {
    var x1$11 = evidence$4
  } else {
    var verboseFailures = $n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$4).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$9 = $n(evidence$4);
      this$9.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$();
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex$macro$17 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    var input$macro$26 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    var input$2 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
    var index$2 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    if ($n(input$2).isReachable__I__Z(index$2)) {
      var this$11 = $n(input$2);
      var this$12 = $n(this$11.Lfastparse_IndexedParserInput__f_data);
      var $$x4 = ($charAt(this$12, index$2) === 72)
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      $n(evidence$4).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
    } else {
      $n(evidence$4).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$4).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"H\"")))
    };
    if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var parse0$2 = evidence$4
    } else {
      var postLhsIndex$macro$18 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$21 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$24 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
      $n(evidence$4).Lfastparse_ParsingRun__f_cut = true;
      if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$4).checkForDrop__Z())) {
        $n(input$macro$26)
      };
      $n(evidence$4);
      $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$4);
      if ($n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) {
        if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$4).Lfastparse_ParsingRun__f_cut)) {
          var parse0$2 = evidence$4
        } else {
          var preRhsIndex$macro$19 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
          $m_Lreactbuild_format_iz2use_Expressions$().length__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$4);
          var rhsAggregate$macro$22 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var rhsMsg$macro$23 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
          if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
            $n(evidence$4).Lfastparse_ParsingRun__f_cut = true;
            var res$macro$29 = evidence$4
          } else {
            var postRhsIndex$macro$20 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
            var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
            var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
            if ((rhsMadeProgress$macro$25 && $n(evidence$4).checkForDrop__Z())) {
              $n(input$macro$26)
            };
            var $$x5 = $n(evidence$4);
            var v$1 = $as_Lreactbuild_format_iz2use_package$Length($n(evidence$4).Lfastparse_ParsingRun__f_successValue);
            var res$macro$29 = $n($$x5).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$28)
          };
          if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$4).Lfastparse_ParsingRun__f_traceIndex))
          };
          var parse0$2 = res$macro$29
        }
      } else {
        var parse0$2 = evidence$4
      }
    };
    if ($n(parse0$2).Lfastparse_ParsingRun__f_isSuccess) {
      var $$x6 = $n(parse0$2);
      var arg1$1 = $as_Lreactbuild_format_iz2use_package$Length($n(parse0$2).Lfastparse_ParsingRun__f_successValue);
      $$x6.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_format_iz2use_package$Vector2D(arg1$1, ($m_Lreactbuild_format_iz2use_package$Vector2D$(), $m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_Zero))
    };
    var rhsMsg = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$4).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$4).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$16 = $n(evidence$4);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$16.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$11 = evidence$4
  };
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("edge").Lsourcecode_Name__f_value, $n(x1$11).Lfastparse_ParsingRun__f_index, $n(x1$11).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$11).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x7 = $n(x1$11);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("edge").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$11).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$11).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$11).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x8 = $n(x1$11);
      var self = new $c_Lsourcecode_Name("edge").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$23 = $n($n(x1$11).Lfastparse_ParsingRun__f_failureStack);
      $$x8.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$23)
    }
  };
  return x1$11
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.edges__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$5) {
  var startIndex = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$5).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$5).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("edges").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$2 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$5).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var this$3 = $m_Lreactbuild_format_iz2use_Repeater$();
  var repeater = this$3.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
  var whitespace = this.whitespace__F1();
  var this$5 = $m_Lfastparse_internal_RepImpls$();
  $n(repeater);
  var acc = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
  var startIndex$1 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$5).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  while (true) {
    $n(evidence$5).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
    $m_Lreactbuild_format_iz2use_Parser$().edge__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$5);
    var parsedMsg = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$5).Lfastparse_ParsingRun__f_cut;
    var verboseFailures = $n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures;
    if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$5 : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$5, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$5, repeater, acc));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$8 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg)), $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$5);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$9 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$9.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
        }
      };
      break
    } else {
      var beforeSepIndex = $n(evidence$5).Lfastparse_ParsingRun__f_index;
      $n(repeater);
      var t = $n(evidence$5).Lfastparse_ParsingRun__f_successValue;
      var this$11 = $n(acc);
      this$11.addOne__O__scm_Growable(t);
      var nextCount = ((1 + count) | 0);
      if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$5)
      };
      if (((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$5).Lfastparse_ParsingRun__f_cut)) {
        break
      } else {
        $n(evidence$5).Lfastparse_ParsingRun__f_cut = false;
        var startIndex$3 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$();
        var input = $n(evidence$5).Lfastparse_ParsingRun__f_input;
        var index = $n(evidence$5).Lfastparse_ParsingRun__f_index;
        if ($n(input).isReachable__I__Z(index)) {
          var this$12 = $n(input);
          var this$13 = $n(this$12.Lfastparse_IndexedParserInput__f_data);
          var $$x4 = ($charAt(this$13, index) === 59)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          var res$1 = $n(evidence$5).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
        } else {
          var res$1 = $n(evidence$5).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$5).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\";\"")))
        };
        var index$2 = $n(res$1).Lfastparse_ParsingRun__f_index;
        if ((!$n(res$1).Lfastparse_ParsingRun__f_isSuccess)) {
          var sep1 = $n(res$1).augmentFailure__I__Lfastparse_ParsingRun(index$2)
        } else {
          var progress = (index$2 > startIndex$3);
          if ((progress && $n(res$1).checkForDrop__Z())) {
            $n($n(res$1).Lfastparse_ParsingRun__f_input)
          };
          var sep1 = $n(res$1).freshSuccess__O__Z__Lfastparse_ParsingRun($n(res$1).Lfastparse_ParsingRun__f_successValue, (!(!($n(res$1).Lfastparse_ParsingRun__f_cut | progress))))
        };
        var sepCut = $n(evidence$5).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
        if ((sep1 === null)) {
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = false;
          outerCut = endCut;
          sepMsg = null;
          lastAgg = parsedAgg;
          continue
        };
        if ($n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) {
          if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$5)
          };
          var temp$sepMsg$2 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = sepCut;
          outerCut = endCut;
          sepMsg = temp$sepMsg$2;
          lastAgg = parsedAgg;
          continue
        };
        var res$2 = (sepCut ? $n(evidence$5).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut) : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$5, beforeSepIndex, beforeSepIndex, nextCount, endCut, 1, evidence$5, repeater, acc));
        if (verboseFailures) {
          var startIndex$4 = startIndex$1;
          var $$x6 = $n(evidence$5);
          var $$x5 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$17 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$17.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          var rassoc$1 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
          $n($$x6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$4, $$x5, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1))
        };
        break
      }
    }
  };
  if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$4 = evidence$5
  } else {
    var postLhsIndex$macro$3 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$5).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$5).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$5);
    if ($n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$5).Lfastparse_ParsingRun__f_cut)) {
        var x1$4 = evidence$5
      } else {
        var preRhsIndex$macro$4 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$5);
        var rhsAggregate$macro$7 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$14 = evidence$5
        } else {
          var postRhsIndex$macro$5 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$5).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x7 = $n(evidence$5);
          $n(x1$3);
          var t$1 = $as_sci_List(lhsValue$macro$12);
          $n(evidence$5);
          var res$macro$14 = $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$13)
        };
        if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$5).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$4 = res$macro$14
      }
    } else {
      var x1$4 = evidence$5
    }
  };
  if (instrument) {
    $n($n(evidence$5).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("edges").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x8 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("edges").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x9 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("edges").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$26 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x9.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$26)
    }
  };
  return x1$4
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.material__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$6) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$6).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("material").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$62 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$71 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$47 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$56 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$3 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$7 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$3));
  var preLhsIndex$macro$32 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$41 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$4 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$9 = this$4.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$17 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var input = $n(evidence$6).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$6 = $n(input);
    var this$7 = $n(this$6.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$7, index) === 123)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$6).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$6).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"{\"")))
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$6);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$6);
    if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$4 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var startIndex$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var instrument$1 = ($n(evidence$6).Lfastparse_ParsingRun__f_instrument !== null);
        if (instrument$1) {
          $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, startIndex$1)
        };
        var startPos = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var oldCapturing = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
        $m_Lfastparse_package$();
        var elem = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
        var elem$1 = false;
        elem$1 = elem;
        var startIndex$macro$19 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var count$macro$20 = 0;
        var lastAgg$macro$25 = null;
        while (true) {
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$20 < 1));
          $m_Lfastparse_package$();
          $m_Lfastparse_Implicits$Sequencer$();
          var preLhsIndex$macro$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var input$macro$11$1 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$();
          var startPos$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var startCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
          var oldNoCut = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
          $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
          var startTerminals = $n(evidence$6).Lfastparse_ParsingRun__f_failureTerminalAggregate;
          var oldCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
          var startPos$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          var oldCut$2 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
          var startPos$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
          var lhsMsg = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$6).Lfastparse_ParsingRun__f_cut | oldCut$2)))
          } else if ($n(evidence$6).Lfastparse_ParsingRun__f_cut) {
            /*<skip>*/
          } else {
            var verboseFailures = $n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$6).Lfastparse_ParsingRun__f_index = startPos$2$1;
            if (verboseFailures) {
              var this$17 = $n(evidence$6);
              this$17.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, lhsMsg, lhsAggregate, false)
            };
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
            $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
            var rhsMsg = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
            var endCut = (!(!(rhsCut | oldCut$2)));
            if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
              $n(evidence$6).freshFailure__I__Lfastparse_ParsingRun(startPos$2$1)
            };
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = endCut;
            if (verboseFailures) {
              var this$18 = $n(evidence$6);
              var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
              var rassoc$3 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
              this$18.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, msgToSet, msgToAggregate, false)
            }
          };
          var lhsMsg$2 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$2 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$6).Lfastparse_ParsingRun__f_cut | oldCut)))
          } else if ((!$n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
            var verboseFailures$2 = $n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$6).Lfastparse_ParsingRun__f_index = startPos$2;
            if (verboseFailures$2) {
              var this$20 = $n(evidence$6);
              this$20.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg$2, lhsAggregate$2, false)
            };
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
            var input$1 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
            var index$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
            if ($n(input$1).isReachable__I__Z(index$1)) {
              var this$21 = $n(input$1);
              var this$22 = $n(this$21.Lfastparse_IndexedParserInput__f_data);
              var $$x2 = ($charAt(this$22, index$1) === 58)
            } else {
              var $$x2 = false
            };
            if ($$x2) {
              $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$1) | 0))
            } else {
              $n(evidence$6).freshFailure__Lfastparse_ParsingRun()
            };
            if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
              $n(evidence$6).aggregateTerminal__I__F0__V(index$1, new $c_sjsr_AnonFunction0((() => "\":\"")))
            };
            var rhsMsg$2 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$2 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
            var endCut$2 = (!(!(rhsCut$2 | oldCut)));
            if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2))) {
              $n(evidence$6).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
            };
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = endCut$2;
            if (verboseFailures$2) {
              var this$24 = $n(evidence$6);
              var msgToSet$1 = $n(lhsMsg$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2);
              var rassoc$3$2 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$1 = $n(lhsAggregate$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
              this$24.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet$1, msgToAggregate$1, false)
            }
          };
          $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
          var msg = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
          var res$2 = ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$6).freshFailure__I__Lfastparse_ParsingRun(startPos$1) : $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$1));
          if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$6).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
            $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
            $n(evidence$6).setMsg__I__F0__V(startPos$1, new $c_sjsr_AnonFunction0(((msg) => (() => {
              var this$25 = $n(msg);
              return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$25.Lfastparse_internal_Msgs__f_value))
            }))(msg)))
          };
          $n(res$2).Lfastparse_ParsingRun__f_cut = startCut;
          if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$3$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$6$1 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$9$1 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
            if (((postLhsIndex$macro$3$1 > preLhsIndex$macro$2$1) && $n(evidence$6).checkForDrop__Z())) {
              $n(input$macro$11$1)
            };
            $n(evidence$6);
            if ((!((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut))) {
              var preRhsIndex$macro$4$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
              $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
              var rhsAggregate$macro$7 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$8 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
                /*<skip>*/
              } else {
                var postRhsIndex$macro$5 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4$1);
                var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11$1).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3$1 : postRhsIndex$macro$5);
                if ((rhsMadeProgress$macro$10 && $n(evidence$6).checkForDrop__Z())) {
                  $n(input$macro$11$1)
                };
                var $$x3 = $n(evidence$6);
                $n(evidence$6);
                var v = (void 0);
                $n($$x3).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
              };
              if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2$1, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9$1, rhsMsg$macro$8), $n(lhsAggregate$macro$6$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4$1 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          };
          var parsedMsg$macro$24 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$26 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$1 = (!(!(elem$1 | $n(evidence$6).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$3 = ($n(evidence$6).Lfastparse_ParsingRun__f_cut ? evidence$6 : ((count$macro$20 < 1) ? $n(evidence$6).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19, elem$1) : $n(evidence$6).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19, elem$1)));
            if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x7 = $n(evidence$6);
              var $$x6 = startIndex$macro$19;
              var $$x5 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
                var this$27 = $n(parsedMsg$macro$24);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$27.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$macro$24));
              if ((lastAgg$macro$25 === null)) {
                var $$x4 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$2 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x4 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
              };
              $n($$x7).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x6, $$x5, $$x4)
            };
            break
          } else {
            var beforeSepIndex$macro$21 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
            $n(evidence$6);
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
            if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$6)
            };
            if ((!((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut))) {
              $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$20 = ((1 + count$macro$20) | 0);
              startIndex$macro$19 = beforeSepIndex$macro$21;
              count$macro$20 = temp$count$macro$20;
              lastAgg$macro$25 = parsedAgg$macro$26;
              continue
            };
            break
          }
        };
        $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
        var x1$5$1 = ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) ? evidence$6 : $n(evidence$6).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$6).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$6).Lfastparse_ParsingRun__f_index)));
        if (instrument$1) {
          $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, $n(x1$5$1).Lfastparse_ParsingRun__f_index, $n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)
        };
        if ($n(x1$5$1).Lfastparse_ParsingRun__f_verboseFailures) {
          var $$x8 = $n(x1$5$1);
          $m_sci_List$();
          var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value)))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          $n($$x8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex$1, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5$1).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex$1 < $n(x1$5$1).Lfastparse_ParsingRun__f_traceIndex));
          if ((!$n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)) {
            var $$x9 = $n(x1$5$1);
            var self = new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value;
            var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex$1);
            var this$35 = $n($n(x1$5$1).Lfastparse_ParsingRun__f_failureStack);
            $$x9.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$35)
          }
        };
        var rhsAggregate$macro$7$1 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8$1 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$14$1 = evidence$6
        } else {
          var postRhsIndex$macro$5$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10$1 = (postRhsIndex$macro$5$1 > preRhsIndex$macro$4);
          var nextIndex$macro$13$1 = (((!rhsMadeProgress$macro$10$1) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5$1)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5$1);
          if ((rhsMadeProgress$macro$10$1 && $n(evidence$6).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x10 = $n(evidence$6);
          var v$1 = $as_T($n(evidence$6).Lfastparse_ParsingRun__f_successValue);
          var res$macro$14$1 = $n($$x10).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$13$1)
        };
        if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8$1), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7$1), (preRhsIndex$macro$4 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$18 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$6);
    if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$19 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var input$2 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
        var index$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        if ($n(input$2).isReachable__I__Z(index$2)) {
          var this$37 = $n(input$2);
          var this$38 = $n(this$37.Lfastparse_IndexedParserInput__f_data);
          var $$x11 = ($charAt(this$38, index$2) === 58)
        } else {
          var $$x11 = false
        };
        if ($$x11) {
          $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
        } else {
          $n(evidence$6).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$6).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\":\"")))
        };
        var rhsAggregate$macro$22 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$23 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$29 = evidence$6
        } else {
          var postRhsIndex$macro$20 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
          var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
          if ((rhsMadeProgress$macro$25 && $n(evidence$6).checkForDrop__Z())) {
            $n(input$macro$26)
          };
          var $$x12 = $n(evidence$6);
          $n(x1$9);
          var t = $as_T(lhsValue$macro$27);
          $n(evidence$6);
          var res$macro$29 = $n($$x12).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$28)
        };
        if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$33 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$36 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$39 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$33 > preLhsIndex$macro$32) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$41)
    };
    var lhsValue$macro$42 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$6);
    if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$34 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var startIndex$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var instrument$2 = ($n(evidence$6).Lfastparse_ParsingRun__f_instrument !== null);
        if (instrument$2) {
          $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, startIndex$2)
        };
        var startPos$3 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var oldCapturing$1 = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
        $m_Lfastparse_package$();
        var elem$2 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
        var elem$3 = false;
        elem$3 = elem$2;
        var startIndex$macro$19$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var count$macro$20$1 = 0;
        var lastAgg$macro$25$1 = null;
        while (true) {
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = (elem$3 && (count$macro$20$1 < 1));
          $m_Lfastparse_package$();
          $m_Lfastparse_Implicits$Sequencer$();
          var preLhsIndex$macro$2$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var input$macro$11$2 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$();
          var startPos$4 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var startCut$1 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
          var oldNoCut$1 = $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer;
          $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = true;
          var startTerminals$1 = $n(evidence$6).Lfastparse_ParsingRun__f_failureTerminalAggregate;
          var oldCut$1 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
          var startPos$5 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          var oldCut$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
          var startPos$2$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
          var lhsMsg$1 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$1 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$6).Lfastparse_ParsingRun__f_cut | oldCut$2$1)))
          } else if ($n(evidence$6).Lfastparse_ParsingRun__f_cut) {
            /*<skip>*/
          } else {
            var verboseFailures$1 = $n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$6).Lfastparse_ParsingRun__f_index = startPos$2$2;
            if (verboseFailures$1) {
              var this$48 = $n(evidence$6);
              this$48.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$2, lhsMsg$1, lhsAggregate$1, false)
            };
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
            $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
            var rhsMsg$1 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$1 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
            var endCut$1 = (!(!(rhsCut$1 | oldCut$2$1)));
            if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$1))) {
              $n(evidence$6).freshFailure__I__Lfastparse_ParsingRun(startPos$2$2)
            };
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = endCut$1;
            if (verboseFailures$1) {
              var this$49 = $n(evidence$6);
              var msgToSet$2 = $n(lhsMsg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$1);
              var rassoc$3$1 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$2 = $n(lhsAggregate$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$1);
              this$49.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$2, msgToSet$2, msgToAggregate$2, false)
            }
          };
          var lhsMsg$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$6).Lfastparse_ParsingRun__f_cut | oldCut$1)))
          } else if ((!$n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
            var verboseFailures$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$6).Lfastparse_ParsingRun__f_index = startPos$5;
            if (verboseFailures$2$1) {
              var this$51 = $n(evidence$6);
              this$51.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, lhsMsg$2$1, lhsAggregate$2$1, false)
            };
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
            var input$3 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
            var index$3 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
            if ($n(input$3).isReachable__I__Z(index$3)) {
              var this$52 = $n(input$3);
              var this$53 = $n(this$52.Lfastparse_IndexedParserInput__f_data);
              var $$x13 = ($charAt(this$53, index$3) === 125)
            } else {
              var $$x13 = false
            };
            if ($$x13) {
              $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$3) | 0))
            } else {
              $n(evidence$6).freshFailure__Lfastparse_ParsingRun()
            };
            if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
              $n(evidence$6).aggregateTerminal__I__F0__V(index$3, new $c_sjsr_AnonFunction0((() => "\"}\"")))
            };
            var rhsMsg$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
            var endCut$2$1 = (!(!(rhsCut$2$1 | oldCut$1)));
            if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2$1))) {
              $n(evidence$6).freshFailure__I__Lfastparse_ParsingRun(startPos$5)
            };
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = endCut$2$1;
            if (verboseFailures$2$1) {
              var this$55 = $n(evidence$6);
              var msgToSet$3 = $n(lhsMsg$2$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2$1);
              var rassoc$3$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$3 = $n(lhsAggregate$2$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2$1);
              this$55.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, msgToSet$3, msgToAggregate$3, false)
            }
          };
          $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut$1;
          var msg$1 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
          var res$5 = ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$6).freshFailure__I__Lfastparse_ParsingRun(startPos$4) : $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$4));
          if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$6).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals$1;
            $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
            $n(evidence$6).setMsg__I__F0__V(startPos$4, new $c_sjsr_AnonFunction0(((msg$1) => (() => {
              var this$56 = $n(msg$1);
              return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$56.Lfastparse_internal_Msgs__f_value))
            }))(msg$1)))
          };
          $n(res$5).Lfastparse_ParsingRun__f_cut = startCut$1;
          if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$3$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$6$2 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$9$2 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
            if (((postLhsIndex$macro$3$2 > preLhsIndex$macro$2$2) && $n(evidence$6).checkForDrop__Z())) {
              $n(input$macro$11$2)
            };
            $n(evidence$6);
            if ((!((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut))) {
              var preRhsIndex$macro$4$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
              $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
              var rhsAggregate$macro$7$2 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$8$2 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
                /*<skip>*/
              } else {
                var postRhsIndex$macro$5$2 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$10$2 = (postRhsIndex$macro$5$2 > preRhsIndex$macro$4$2);
                var nextIndex$macro$13$2 = (((!rhsMadeProgress$macro$10$2) && $n(input$macro$11$2).isReachable__I__Z(postRhsIndex$macro$5$2)) ? postLhsIndex$macro$3$2 : postRhsIndex$macro$5$2);
                if ((rhsMadeProgress$macro$10$2 && $n(evidence$6).checkForDrop__Z())) {
                  $n(input$macro$11$2)
                };
                var $$x14 = $n(evidence$6);
                $n(evidence$6);
                var v$3 = (void 0);
                $n($$x14).freshSuccess__O__I__Lfastparse_ParsingRun(v$3, nextIndex$macro$13$2)
              };
              if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9$2, rhsMsg$macro$8$2), $n(lhsAggregate$macro$6$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7$2), (preRhsIndex$macro$4$2 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          };
          var parsedMsg$macro$24$1 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$26$1 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$3 = (!(!(elem$3 | $n(evidence$6).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$6 = ($n(evidence$6).Lfastparse_ParsingRun__f_cut ? evidence$6 : ((count$macro$20$1 < 1) ? $n(evidence$6).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19$1, elem$3) : $n(evidence$6).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19$1, elem$3)));
            if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x18 = $n(evidence$6);
              var $$x17 = startIndex$macro$19$1;
              var $$x16 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24$1) => (() => {
                var this$58 = $n(parsedMsg$macro$24$1);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$58.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$macro$24$1));
              if ((lastAgg$macro$25$1 === null)) {
                var $$x15 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$2$1 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x15 = $n(lastAgg$macro$25$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2$1)
              };
              $n($$x18).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x17, $$x16, $$x15)
            };
            break
          } else {
            var beforeSepIndex$macro$21$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
            $n(evidence$6);
            $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
            if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$6)
            };
            if ((!((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut))) {
              $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$20$1 = ((1 + count$macro$20$1) | 0);
              startIndex$macro$19$1 = beforeSepIndex$macro$21$1;
              count$macro$20$1 = temp$count$macro$20$1;
              lastAgg$macro$25$1 = parsedAgg$macro$26$1;
              continue
            };
            break
          }
        };
        $n(evidence$6).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing$1;
        var x1$5$2 = ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) ? evidence$6 : $n(evidence$6).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$6).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$3, $n(evidence$6).Lfastparse_ParsingRun__f_index)));
        if (instrument$2) {
          $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, $n(x1$5$2).Lfastparse_ParsingRun__f_index, $n(x1$5$2).Lfastparse_ParsingRun__f_isSuccess)
        };
        if ($n(x1$5$2).Lfastparse_ParsingRun__f_verboseFailures) {
          var $$x19 = $n(x1$5$2);
          $m_sci_List$();
          var array$1 = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value)))];
          var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
          $n($$x19).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex$2, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)), $n(x1$5$2).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex$2 < $n(x1$5$2).Lfastparse_ParsingRun__f_traceIndex));
          if ((!$n(x1$5$2).Lfastparse_ParsingRun__f_isSuccess)) {
            var $$x20 = $n(x1$5$2);
            var self$1 = new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value;
            var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self$1, startIndex$2);
            var this$66 = $n($n(x1$5$2).Lfastparse_ParsingRun__f_failureStack);
            $$x20.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$66)
          }
        };
        var rhsAggregate$macro$37 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$38 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$44 = evidence$6
        } else {
          var postRhsIndex$macro$35 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$40 = (postRhsIndex$macro$35 > preRhsIndex$macro$34);
          var nextIndex$macro$43 = (((!rhsMadeProgress$macro$40) && $n(input$macro$41).isReachable__I__Z(postRhsIndex$macro$35)) ? postLhsIndex$macro$33 : postRhsIndex$macro$35);
          if ((rhsMadeProgress$macro$40 && $n(evidence$6).checkForDrop__Z())) {
            $n(input$macro$41)
          };
          var res$macro$44 = $n(evidence$6).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$7).apply__O__O__O($as_T(lhsValue$macro$42), $as_T($n(evidence$6).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$43)
        };
        if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$32, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$39, rhsMsg$macro$38), $n(lhsAggregate$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$37), (preRhsIndex$macro$34 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$48 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$51 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$54 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$48 > preLhsIndex$macro$47) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$56)
    };
    var lhsValue$macro$57 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$6);
    if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$49 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        var input$3$1 = $n(evidence$6).Lfastparse_ParsingRun__f_input;
        var index$3$1 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        if ($n(input$3$1).isReachable__I__Z(index$3$1)) {
          var this$68 = $n(input$3$1);
          var this$69 = $n(this$68.Lfastparse_IndexedParserInput__f_data);
          var $$x21 = ($charAt(this$69, index$3$1) === 125)
        } else {
          var $$x21 = false
        };
        if ($$x21) {
          $n(evidence$6).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$3$1) | 0))
        } else {
          $n(evidence$6).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$6).aggregateTerminal__I__F0__V(index$3$1, new $c_sjsr_AnonFunction0((() => "\"}\"")))
        };
        var rhsAggregate$macro$52 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$53 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$59 = evidence$6
        } else {
          var postRhsIndex$macro$50 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$55 = (postRhsIndex$macro$50 > preRhsIndex$macro$49);
          var nextIndex$macro$58 = (((!rhsMadeProgress$macro$55) && $n(input$macro$56).isReachable__I__Z(postRhsIndex$macro$50)) ? postLhsIndex$macro$48 : postRhsIndex$macro$50);
          if ((rhsMadeProgress$macro$55 && $n(evidence$6).checkForDrop__Z())) {
            $n(input$macro$56)
          };
          var $$x22 = $n(evidence$6);
          $n(x1$5);
          var t$1 = $as_T2(lhsValue$macro$57);
          $n(evidence$6);
          var res$macro$59 = $n($$x22).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$58)
        };
        if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$47, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$54, rhsMsg$macro$53), $n(lhsAggregate$macro$51).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$52), (preRhsIndex$macro$49 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$15 = evidence$6
  } else {
    var postLhsIndex$macro$63 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$66 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$69 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$63 > preLhsIndex$macro$62) && $n(evidence$6).checkForDrop__Z())) {
      $n(input$macro$71)
    };
    var lhsValue$macro$72 = $n(evidence$6).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$6);
    if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$6).Lfastparse_ParsingRun__f_cut)) {
        var x1$15 = evidence$6
      } else {
        var preRhsIndex$macro$64 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$6);
        var rhsAggregate$macro$67 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$68 = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$6).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$74 = evidence$6
        } else {
          var postRhsIndex$macro$65 = $n(evidence$6).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$70 = (postRhsIndex$macro$65 > preRhsIndex$macro$64);
          var nextIndex$macro$73 = (((!rhsMadeProgress$macro$70) && $n(input$macro$71).isReachable__I__Z(postRhsIndex$macro$65)) ? postLhsIndex$macro$63 : postRhsIndex$macro$65);
          if ((rhsMadeProgress$macro$70 && $n(evidence$6).checkForDrop__Z())) {
            $n(input$macro$71)
          };
          var $$x23 = $n(evidence$6);
          $n(x1$3);
          var t$2 = $as_T2(lhsValue$macro$72);
          $n(evidence$6);
          var res$macro$74 = $n($$x23).freshSuccess__O__I__Lfastparse_ParsingRun(t$2, nextIndex$macro$73)
        };
        if ($n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$62, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$69, rhsMsg$macro$68), $n(lhsAggregate$macro$66).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$67), (preRhsIndex$macro$64 === $n(evidence$6).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$15 = res$macro$74
      }
    } else {
      var x1$15 = evidence$6
    }
  };
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("material").Lsourcecode_Name__f_value, $n(x1$15).Lfastparse_ParsingRun__f_index, $n(x1$15).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$15).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x24 = $n(x1$15);
    $m_sci_List$();
    var array$2 = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("material").Lsourcecode_Name__f_value)))];
    var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    $n($$x24).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2)), $n(x1$15).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$15).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$15).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x25 = $n(x1$15);
      var self$2 = new $c_Lsourcecode_Name("material").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self$2, startIndex);
      var this$79 = $n($n(x1$15).Lfastparse_ParsingRun__f_failureStack);
      $$x25.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$79)
    }
  };
  if ((!$n(x1$15).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$15
  } else {
    $n(x1$15).Lfastparse_ParsingRun__f_successValue = ($as_T2($n(x1$15).Lfastparse_ParsingRun__f_successValue), (void 0));
    return x1$15
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.materials__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$7) {
  var startIndex = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$7).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("materials").Lsourcecode_Name__f_value, startIndex)
  };
  var elem = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  var startIndex$macro$4 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var count$macro$5 = 0;
  var lastAgg$macro$10 = null;
  var x1$4;
  while (true) {
    $n(evidence$7).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 0));
    $m_Lfastparse_package$();
    $m_Lreactbuild_format_iz2use_Parser$().material__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
    var parsedMsg$macro$9 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$11 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$7).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = ($n(evidence$7).Lfastparse_ParsingRun__f_cut ? evidence$7 : ((count$macro$5 < 0) ? $n(evidence$7).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$7).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$4, elem$1)));
      if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x4 = $n(evidence$7);
        var $$x3 = startIndex$macro$4;
        var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
          var this$3 = $n(parsedMsg$macro$9);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$3.Lfastparse_internal_Msgs__f_value) + ".rep")
        }))(parsedMsg$macro$9));
        if ((lastAgg$macro$10 === null)) {
          var $$x1 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$1 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x1 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
        };
        $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x3, $$x2, $$x1)
      };
      var x1$4 = res;
      break
    } else {
      var beforeSepIndex$macro$6 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      $n(evidence$7);
      $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
      if ((this.whitespace__F1() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$7)
      };
      if ((!((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$7).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$7).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$5 = ((1 + count$macro$5) | 0);
        startIndex$macro$4 = beforeSepIndex$macro$6;
        count$macro$5 = temp$count$macro$5;
        lastAgg$macro$10 = parsedAgg$macro$11;
        continue
      };
      var x1$4 = evidence$7;
      break
    }
  };
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("materials").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("materials").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("materials").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$11)
    }
  };
  return x1$4
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.roofType__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$8) {
  var startIndex = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$8).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$8).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("roofType").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
  $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var oldCut$2 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
  $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
  var startPos$2 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var startPos$3 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var index = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var end = ((6 + index) | 0);
  var input = $n(evidence$8).Lfastparse_ParsingRun__f_input;
  if ($n(input).isReachable__I__Z((((-1) + end) | 0))) {
    var this$1 = $n(input);
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    if (($charAt(this$2, index) === 97)) {
      var this$3 = $n(input);
      var index$1 = ((1 + index) | 0);
      var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
      var $$x5 = ($charAt(this$4, index$1) === 98)
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var this$5 = $n(input);
      var index$2 = ((2 + index) | 0);
      var this$6 = $n(this$5.Lfastparse_IndexedParserInput__f_data);
      var $$x4 = ($charAt(this$6, index$2) === 115)
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var this$7 = $n(input);
      var index$3 = ((3 + index) | 0);
      var this$8 = $n(this$7.Lfastparse_IndexedParserInput__f_data);
      var $$x3 = ($charAt(this$8, index$3) === 101)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var this$9 = $n(input);
      var index$4 = ((4 + index) | 0);
      var this$10 = $n(this$9.Lfastparse_IndexedParserInput__f_data);
      var $$x2 = ($charAt(this$10, index$4) === 110)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var this$11 = $n(input);
      var index$5 = ((5 + index) | 0);
      var this$12 = $n(this$11.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$12, index$5) === 116)
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$8).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
  } else {
    $n(evidence$8).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$8).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"absent\"")))
  };
  $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0 = ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) ? evidence$8 : $n(evidence$8).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$8).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$3, $n(evidence$8).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    $n(parse0).Lfastparse_ParsingRun__f_successValue = ($as_T($n(parse0).Lfastparse_ParsingRun__f_successValue), $m_Lreactbuild_format_iz2use_package$AbsentRoof$())
  };
  var lhsMsg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$8).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$8).Lfastparse_ParsingRun__f_cut | oldCut$2)))
  } else if ($n(evidence$8).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures = $n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$8).Lfastparse_ParsingRun__f_index = startPos$2;
    if (verboseFailures) {
      var this$16 = $n(evidence$8);
      this$16.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$();
    var this$17 = $m_Lfastparse_Implicits$Sequencer$();
    var x1$8 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$17));
    var preLhsIndex$macro$36 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var input$macro$45 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex$macro$6 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var input$macro$15 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    var index$2$1 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var end$2 = ((8 + index$2$1) | 0);
    var input$2 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
    if ($n(input$2).isReachable__I__Z((((-1) + end$2) | 0))) {
      var this$19 = $n(input$2);
      var this$20 = $n(this$19.Lfastparse_IndexedParserInput__f_data);
      if (($charAt(this$20, index$2$1) === 98)) {
        var this$21 = $n(input$2);
        var index$6 = ((1 + index$2$1) | 0);
        var this$22 = $n(this$21.Lfastparse_IndexedParserInput__f_data);
        var $$x12 = ($charAt(this$22, index$6) === 97)
      } else {
        var $$x12 = false
      };
      if ($$x12) {
        var this$23 = $n(input$2);
        var index$7 = ((2 + index$2$1) | 0);
        var this$24 = $n(this$23.Lfastparse_IndexedParserInput__f_data);
        var $$x11 = ($charAt(this$24, index$7) === 99)
      } else {
        var $$x11 = false
      };
      if ($$x11) {
        var this$25 = $n(input$2);
        var index$8 = ((3 + index$2$1) | 0);
        var this$26 = $n(this$25.Lfastparse_IndexedParserInput__f_data);
        var $$x10 = ($charAt(this$26, index$8) === 97)
      } else {
        var $$x10 = false
      };
      if ($$x10) {
        var this$27 = $n(input$2);
        var index$9 = ((4 + index$2$1) | 0);
        var this$28 = $n(this$27.Lfastparse_IndexedParserInput__f_data);
        var $$x9 = ($charAt(this$28, index$9) === 99)
      } else {
        var $$x9 = false
      };
      if ($$x9) {
        var this$29 = $n(input$2);
        var index$10 = ((5 + index$2$1) | 0);
        var this$30 = $n(this$29.Lfastparse_IndexedParserInput__f_data);
        var $$x8 = ($charAt(this$30, index$10) === 105)
      } else {
        var $$x8 = false
      };
      if ($$x8) {
        var this$31 = $n(input$2);
        var index$11 = ((6 + index$2$1) | 0);
        var this$32 = $n(this$31.Lfastparse_IndexedParserInput__f_data);
        var $$x7 = ($charAt(this$32, index$11) === 101)
      } else {
        var $$x7 = false
      };
      if ($$x7) {
        var this$33 = $n(input$2);
        var index$12 = ((7 + index$2$1) | 0);
        var this$34 = $n(this$33.Lfastparse_IndexedParserInput__f_data);
        var $$x6 = ($charAt(this$34, index$12) === 114)
      } else {
        var $$x6 = false
      }
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      $n(evidence$8).freshSuccessUnit__I__Lfastparse_ParsingRun(end$2)
    } else {
      $n(evidence$8).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$8).aggregateTerminal__I__F0__V(index$2$1, new $c_sjsr_AnonFunction0((() => "\"bacacier\"")))
    };
    if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
      /*<skip>*/
    } else {
      var postLhsIndex$macro$7 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$10 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$13 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
      if (((postLhsIndex$macro$7 > preLhsIndex$macro$6) && $n(evidence$8).checkForDrop__Z())) {
        $n(input$macro$15)
      };
      $n(evidence$8);
      $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$8);
      if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
        if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
          /*<skip>*/
        } else {
          var preRhsIndex$macro$8 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          var this$36 = $m_Lfastparse_Implicits$Optioner$();
          var x1$13 = this$36.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
          var startPos$4 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          var startCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
          $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
          $m_Lfastparse_package$();
          $m_Lreactbuild_format_iz2use_Expressions$().absoluteInt__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
          var postSuccess = $n(evidence$8).Lfastparse_ParsingRun__f_isSuccess;
          if (postSuccess) {
            var $$x13 = $n(evidence$8);
            $n(x1$13);
            var ev$1 = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
            var value = new $c_Leu_timepit_refined_api_Refined(((ev$1 === null) ? null : $as_jl_Integer($n($as_Leu_timepit_refined_api_Refined(ev$1)).Leu_timepit_refined_api_Refined__f_value)));
            var res$3 = $n($$x13).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value));
            $n(res$3).Lfastparse_ParsingRun__f_cut = (!(!($n(res$3).Lfastparse_ParsingRun__f_cut | startCut)))
          } else if ($n(evidence$8).Lfastparse_ParsingRun__f_cut) {
            /*<skip>*/
          } else {
            var res$4 = $n(evidence$8).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$13), $m_s_None$()), startPos$4);
            $n(res$4).Lfastparse_ParsingRun__f_cut = (!(!($n(res$4).Lfastparse_ParsingRun__f_cut | startCut)))
          };
          if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
            var msg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
            var agg = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
            if ((!postSuccess)) {
              $n(evidence$8).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$4, new $c_sjsr_AnonFunction0((() => {
                var this$40 = $n(msg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$40.Lfastparse_internal_Msgs__f_value) + ".?")
              })), agg)
            }
          };
          var rhsAggregate$macro$11 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var rhsMsg$macro$12 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
          if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$macro$18 = evidence$8
          } else {
            var postRhsIndex$macro$9 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
            var rhsMadeProgress$macro$14 = (postRhsIndex$macro$9 > preRhsIndex$macro$8);
            var nextIndex$macro$17 = (((!rhsMadeProgress$macro$14) && $n(input$macro$15).isReachable__I__Z(postRhsIndex$macro$9)) ? postLhsIndex$macro$7 : postRhsIndex$macro$9);
            if ((rhsMadeProgress$macro$14 && $n(evidence$8).checkForDrop__Z())) {
              $n(input$macro$15)
            };
            var $$x14 = $n(evidence$8);
            var v = $as_s_Option($n(evidence$8).Lfastparse_ParsingRun__f_successValue);
            var res$macro$18 = $n($$x14).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$17)
          };
          if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$6, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$13, rhsMsg$macro$12), $n(lhsAggregate$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$11), (preRhsIndex$macro$8 === $n(evidence$8).Lfastparse_ParsingRun__f_traceIndex))
          }
        }
      }
    };
    if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
      var parse0$5 = evidence$8
    } else {
      var postLhsIndex$macro$37 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$40 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$43 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
      if (((postLhsIndex$macro$37 > preLhsIndex$macro$36) && $n(evidence$8).checkForDrop__Z())) {
        $n(input$macro$45)
      };
      var lhsValue$macro$46 = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
      $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$8);
      if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
        if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
          var parse0$5 = evidence$8
        } else {
          var preRhsIndex$macro$38 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          var this$42 = $m_Lfastparse_Implicits$Optioner$();
          var x1$15 = this$42.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
          var startPos$5 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          var startCut$2 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
          $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
          $m_Lfastparse_package$();
          $m_Lfastparse_Implicits$Sequencer$();
          var preLhsIndex$macro$21 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          var input$macro$30 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          var input$3 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
          var index$3$1 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          if ($n(input$3).isReachable__I__Z(index$3$1)) {
            var this$44 = $n(input$3);
            var this$45 = $n(this$44.Lfastparse_IndexedParserInput__f_data);
            var $$x15 = ($charAt(this$45, index$3$1) === 43)
          } else {
            var $$x15 = false
          };
          if ($$x15) {
            $n(evidence$8).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$3$1) | 0))
          } else {
            $n(evidence$8).freshFailure__Lfastparse_ParsingRun()
          };
          if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$8).aggregateTerminal__I__F0__V(index$3$1, new $c_sjsr_AnonFunction0((() => "\"+\"")))
          };
          if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
            /*<skip>*/
          } else {
            var postLhsIndex$macro$22 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$25 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$28 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
            if (((postLhsIndex$macro$22 > preLhsIndex$macro$21) && $n(evidence$8).checkForDrop__Z())) {
              $n(input$macro$30)
            };
            $n(evidence$8);
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$8);
            if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
              if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
                /*<skip>*/
              } else {
                var preRhsIndex$macro$23 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
                $m_Lreactbuild_format_iz2use_Expressions$().absoluteLength__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
                var rhsAggregate$macro$26 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var rhsMsg$macro$27 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
                if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
                  var res$macro$33 = evidence$8
                } else {
                  var postRhsIndex$macro$24 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
                  var rhsMadeProgress$macro$29 = (postRhsIndex$macro$24 > preRhsIndex$macro$23);
                  var nextIndex$macro$32 = (((!rhsMadeProgress$macro$29) && $n(input$macro$30).isReachable__I__Z(postRhsIndex$macro$24)) ? postLhsIndex$macro$22 : postRhsIndex$macro$24);
                  if ((rhsMadeProgress$macro$29 && $n(evidence$8).checkForDrop__Z())) {
                    $n(input$macro$30)
                  };
                  var $$x16 = $n(evidence$8);
                  var ev$2 = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
                  var v$1 = new $c_Leu_timepit_refined_api_Refined(((ev$2 === null) ? null : $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(ev$2)).Leu_timepit_refined_api_Refined__f_value)));
                  var res$macro$33 = $n($$x16).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$32)
                };
                if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
                  $n(evidence$8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$21, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$28, rhsMsg$macro$27), $n(lhsAggregate$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$26), (preRhsIndex$macro$23 === $n(evidence$8).Lfastparse_ParsingRun__f_traceIndex))
                }
              }
            }
          };
          var postSuccess$2 = $n(evidence$8).Lfastparse_ParsingRun__f_isSuccess;
          if (postSuccess$2) {
            var $$x17 = $n(evidence$8);
            $n(x1$15);
            var ev$3 = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
            var value$1 = new $c_Leu_timepit_refined_api_Refined(((ev$3 === null) ? null : $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(ev$3)).Leu_timepit_refined_api_Refined__f_value)));
            var res$7 = $n($$x17).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value$1));
            $n(res$7).Lfastparse_ParsingRun__f_cut = (!(!($n(res$7).Lfastparse_ParsingRun__f_cut | startCut$2)))
          } else if ($n(evidence$8).Lfastparse_ParsingRun__f_cut) {
            /*<skip>*/
          } else {
            var res$8 = $n(evidence$8).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$15), $m_s_None$()), startPos$5);
            $n(res$8).Lfastparse_ParsingRun__f_cut = (!(!($n(res$8).Lfastparse_ParsingRun__f_cut | startCut$2)))
          };
          if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
            var msg$2 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
            var agg$2 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
            if ((!postSuccess$2)) {
              $n(evidence$8).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$5, new $c_sjsr_AnonFunction0((() => {
                var this$50 = $n(msg$2);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$50.Lfastparse_internal_Msgs__f_value) + ".?")
              })), agg$2)
            }
          };
          var rhsAggregate$macro$41 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var rhsMsg$macro$42 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
          if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$macro$48 = evidence$8
          } else {
            var postRhsIndex$macro$39 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
            var rhsMadeProgress$macro$44 = (postRhsIndex$macro$39 > preRhsIndex$macro$38);
            var nextIndex$macro$47 = (((!rhsMadeProgress$macro$44) && $n(input$macro$45).isReachable__I__Z(postRhsIndex$macro$39)) ? postLhsIndex$macro$37 : postRhsIndex$macro$39);
            if ((rhsMadeProgress$macro$44 && $n(evidence$8).checkForDrop__Z())) {
              $n(input$macro$45)
            };
            var res$macro$48 = $n(evidence$8).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$8).apply__O__O__O($as_s_Option(lhsValue$macro$46), $as_s_Option($n(evidence$8).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$47)
          };
          if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$36, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$43, rhsMsg$macro$42), $n(lhsAggregate$macro$40).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$41), (preRhsIndex$macro$38 === $n(evidence$8).Lfastparse_ParsingRun__f_traceIndex))
          };
          var parse0$5 = res$macro$48
        }
      } else {
        var parse0$5 = evidence$8
      }
    };
    if ($n(parse0$5).Lfastparse_ParsingRun__f_isSuccess) {
      var $$x18 = $n(parse0$5);
      var this$52 = $m_Lreactbuild_format_iz2use_package$Bacacier$();
      $$x18.Lfastparse_ParsingRun__f_successValue = $n($f_F2__tupled__F1(this$52)).apply__O__O($as_T2($n(parse0$5).Lfastparse_ParsingRun__f_successValue))
    };
    var rhsMsg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut$2)));
    if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$8).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
    };
    $n(evidence$8).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$53 = $n(evidence$8);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3$2 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
      this$53.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet, msgToAggregate, false)
    }
  };
  var lhsMsg$2 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate$2 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$8).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$8).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$25 = evidence$8
  } else if ($n(evidence$8).Lfastparse_ParsingRun__f_cut) {
    var x1$25 = evidence$8
  } else {
    var verboseFailures$2 = $n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$8).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures$2) {
      var this$55 = $n(evidence$8);
      this$55.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg$2, lhsAggregate$2, false)
    };
    $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$();
    var this$56 = $m_Lfastparse_Implicits$Optioner$();
    var x1$21 = this$56.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
    var startPos$6 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var startCut$3 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
    $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$();
    var startPos$7 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var oldCapturing$2 = $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer;
    $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = true;
    $m_Lfastparse_package$();
    var index$4$1 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var end$3 = ((14 + index$4$1) | 0);
    var input$4 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
    if ($n(input$4).isReachable__I__Z((((-1) + end$3) | 0))) {
      var this$57 = $n(input$4);
      var this$58 = $n(this$57.Lfastparse_IndexedParserInput__f_data);
      if (($charAt(this$58, index$4$1) === 115)) {
        var this$59 = $n(input$4);
        var index$13 = ((1 + index$4$1) | 0);
        var this$60 = $n(this$59.Lfastparse_IndexedParserInput__f_data);
        var $$x31 = ($charAt(this$60, index$13) === 101)
      } else {
        var $$x31 = false
      };
      if ($$x31) {
        var this$61 = $n(input$4);
        var index$14 = ((2 + index$4$1) | 0);
        var this$62 = $n(this$61.Lfastparse_IndexedParserInput__f_data);
        var $$x30 = ($charAt(this$62, index$14) === 99)
      } else {
        var $$x30 = false
      };
      if ($$x30) {
        var this$63 = $n(input$4);
        var index$15 = ((3 + index$4$1) | 0);
        var this$64 = $n(this$63.Lfastparse_IndexedParserInput__f_data);
        var $$x29 = ($charAt(this$64, index$15) === 111)
      } else {
        var $$x29 = false
      };
      if ($$x29) {
        var this$65 = $n(input$4);
        var index$16 = ((4 + index$4$1) | 0);
        var this$66 = $n(this$65.Lfastparse_IndexedParserInput__f_data);
        var $$x28 = ($charAt(this$66, index$16) === 110)
      } else {
        var $$x28 = false
      };
      if ($$x28) {
        var this$67 = $n(input$4);
        var index$17 = ((5 + index$4$1) | 0);
        var this$68 = $n(this$67.Lfastparse_IndexedParserInput__f_data);
        var $$x27 = ($charAt(this$68, index$17) === 100)
      } else {
        var $$x27 = false
      };
      if ($$x27) {
        var this$69 = $n(input$4);
        var index$18 = ((6 + index$4$1) | 0);
        var this$70 = $n(this$69.Lfastparse_IndexedParserInput__f_data);
        var $$x26 = ($charAt(this$70, index$18) === 97)
      } else {
        var $$x26 = false
      };
      if ($$x26) {
        var this$71 = $n(input$4);
        var index$19 = ((7 + index$4$1) | 0);
        var this$72 = $n(this$71.Lfastparse_IndexedParserInput__f_data);
        var $$x25 = ($charAt(this$72, index$19) === 114)
      } else {
        var $$x25 = false
      };
      if ($$x25) {
        var this$73 = $n(input$4);
        var index$20 = ((8 + index$4$1) | 0);
        var this$74 = $n(this$73.Lfastparse_IndexedParserInput__f_data);
        var $$x24 = ($charAt(this$74, index$20) === 121)
      } else {
        var $$x24 = false
      };
      if ($$x24) {
        var this$75 = $n(input$4);
        var index$21 = ((9 + index$4$1) | 0);
        var this$76 = $n(this$75.Lfastparse_IndexedParserInput__f_data);
        var $$x23 = ($charAt(this$76, index$21) === 45)
      } else {
        var $$x23 = false
      };
      if ($$x23) {
        var this$77 = $n(input$4);
        var index$22 = ((10 + index$4$1) | 0);
        var this$78 = $n(this$77.Lfastparse_IndexedParserInput__f_data);
        var $$x22 = ($charAt(this$78, index$22) === 97)
      } else {
        var $$x22 = false
      };
      if ($$x22) {
        var this$79 = $n(input$4);
        var index$23 = ((11 + index$4$1) | 0);
        var this$80 = $n(this$79.Lfastparse_IndexedParserInput__f_data);
        var $$x21 = ($charAt(this$80, index$23) === 120)
      } else {
        var $$x21 = false
      };
      if ($$x21) {
        var this$81 = $n(input$4);
        var index$24 = ((12 + index$4$1) | 0);
        var this$82 = $n(this$81.Lfastparse_IndexedParserInput__f_data);
        var $$x20 = ($charAt(this$82, index$24) === 105)
      } else {
        var $$x20 = false
      };
      if ($$x20) {
        var this$83 = $n(input$4);
        var index$25 = ((13 + index$4$1) | 0);
        var this$84 = $n(this$83.Lfastparse_IndexedParserInput__f_data);
        var $$x19 = ($charAt(this$84, index$25) === 115)
      } else {
        var $$x19 = false
      }
    } else {
      var $$x19 = false
    };
    if ($$x19) {
      $n(evidence$8).freshSuccessUnit__I__Lfastparse_ParsingRun(end$3)
    } else {
      $n(evidence$8).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$8).aggregateTerminal__I__F0__V(index$4$1, new $c_sjsr_AnonFunction0((() => "\"secondary-axis\"")))
    };
    $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing$2;
    if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
      /*<skip>*/
    } else {
      $n(evidence$8).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$8).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$7, $n(evidence$8).Lfastparse_ParsingRun__f_index))
    };
    var postSuccess$3 = $n(evidence$8).Lfastparse_ParsingRun__f_isSuccess;
    if (postSuccess$3) {
      var $$x32 = $n(evidence$8);
      $n(x1$21);
      var value$2 = $as_T($n(evidence$8).Lfastparse_ParsingRun__f_successValue);
      var res$11 = $n($$x32).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value$2));
      $n(res$11).Lfastparse_ParsingRun__f_cut = (!(!($n(res$11).Lfastparse_ParsingRun__f_cut | startCut$3)));
      var res$13 = res$11
    } else if ($n(evidence$8).Lfastparse_ParsingRun__f_cut) {
      var res$13 = evidence$8
    } else {
      var res$12 = $n(evidence$8).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$21), $m_s_None$()), startPos$6);
      $n(res$12).Lfastparse_ParsingRun__f_cut = (!(!($n(res$12).Lfastparse_ParsingRun__f_cut | startCut$3)));
      var res$13 = res$12
    };
    if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
      var msg$3 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
      var agg$3 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      if ((!postSuccess$3)) {
        $n(evidence$8).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$6, new $c_sjsr_AnonFunction0((() => {
          var this$89 = $n(msg$3);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$89.Lfastparse_internal_Msgs__f_value) + ".?")
        })), agg$3)
      }
    };
    if ($n(res$13).Lfastparse_ParsingRun__f_isSuccess) {
      var $$x33 = $n(res$13);
      var arg1$1 = $as_s_Option($n(res$13).Lfastparse_ParsingRun__f_successValue);
      var this$91 = $n(arg1$1);
      $$x33.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_format_iz2use_package$CanalTile35Percent((!this$91.isEmpty__Z()))
    };
    var rhsMsg$2 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut$2 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
    var endCut$2 = (!(!(rhsCut$2 | oldCut)));
    if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2))) {
      $n(evidence$8).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$8).Lfastparse_ParsingRun__f_cut = endCut$2;
    if (verboseFailures$2) {
      var this$92 = $n(evidence$8);
      var msgToSet$1 = $n(lhsMsg$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2);
      var rassoc$3$3 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate$1 = $n(lhsAggregate$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$3);
      this$92.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet$1, msgToAggregate$1, false)
    };
    var x1$25 = evidence$8
  };
  if (instrument) {
    $n($n(evidence$8).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("roofType").Lsourcecode_Name__f_value, $n(x1$25).Lfastparse_ParsingRun__f_index, $n(x1$25).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$25).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x34 = $n(x1$25);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("roofType").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x34).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$25).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$25).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$25).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x35 = $n(x1$25);
      var self = new $c_Lsourcecode_Name("roofType").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$99 = $n($n(x1$25).Lfastparse_ParsingRun__f_failureStack);
      $$x35.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$99)
    }
  };
  return x1$25
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.roof__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$9) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$9).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$9).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("roof").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$60 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var input$macro$69 = $n(evidence$9).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$2));
  var preLhsIndex$macro$45 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var input$macro$54 = $n(evidence$9).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$3 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$7 = this$3.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$19 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var input$macro$28 = $n(evidence$9).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$4 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var input$macro$13 = $n(evidence$9).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var index = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var end = ((2 + index) | 0);
  var input = $n(evidence$9).Lfastparse_ParsingRun__f_input;
  if ($n(input).isReachable__I__Z((((-1) + end) | 0))) {
    var this$5 = $n(input);
    var this$6 = $n(this$5.Lfastparse_IndexedParserInput__f_data);
    if (($charAt(this$6, index) === 94)) {
      var this$7 = $n(input);
      var index$1 = ((1 + index) | 0);
      var this$8 = $n(this$7.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$8, index$1) === 94)
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$9).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
  } else {
    $n(evidence$9).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$9).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$9).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"^^\"")))
  };
  if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$5 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$8 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$11 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$9).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$5 > preLhsIndex$macro$4) && $n(evidence$9).checkForDrop__Z())) {
      $n(input$macro$13)
    };
    $n(evidence$9);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$9);
    if ($n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$9).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$6 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
        this.roofType__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$9);
        var rhsAggregate$macro$9 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$10 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$9).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$16 = evidence$9
        } else {
          var postRhsIndex$macro$7 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$12 = (postRhsIndex$macro$7 > preRhsIndex$macro$6);
          var nextIndex$macro$15 = (((!rhsMadeProgress$macro$12) && $n(input$macro$13).isReachable__I__Z(postRhsIndex$macro$7)) ? postLhsIndex$macro$5 : postRhsIndex$macro$7);
          if ((rhsMadeProgress$macro$12 && $n(evidence$9).checkForDrop__Z())) {
            $n(input$macro$13)
          };
          var $$x2 = $n(evidence$9);
          var v = $as_s_Product($n(evidence$9).Lfastparse_ParsingRun__f_successValue);
          var res$macro$16 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$15)
        };
        if ($n(evidence$9).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$9).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$4, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$11, rhsMsg$macro$10), $n(lhsAggregate$macro$8).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$9), (preRhsIndex$macro$6 === $n(evidence$9).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$20 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$23 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$26 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$9).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$20 > preLhsIndex$macro$19) && $n(evidence$9).checkForDrop__Z())) {
      $n(input$macro$28)
    };
    var lhsValue$macro$29 = $n(evidence$9).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$9);
    if ($n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$9).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$21 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$9);
        var rhsAggregate$macro$24 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$25 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$9).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$31 = evidence$9
        } else {
          var postRhsIndex$macro$22 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$27 = (postRhsIndex$macro$22 > preRhsIndex$macro$21);
          var nextIndex$macro$30 = (((!rhsMadeProgress$macro$27) && $n(input$macro$28).isReachable__I__Z(postRhsIndex$macro$22)) ? postLhsIndex$macro$20 : postRhsIndex$macro$22);
          if ((rhsMadeProgress$macro$27 && $n(evidence$9).checkForDrop__Z())) {
            $n(input$macro$28)
          };
          var $$x3 = $n(evidence$9);
          $n(x1$7);
          var t = $as_s_Product(lhsValue$macro$29);
          $n(evidence$9);
          var res$macro$31 = $n($$x3).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$30)
        };
        if ($n(evidence$9).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$9).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$19, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$26, rhsMsg$macro$25), $n(lhsAggregate$macro$23).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$24), (preRhsIndex$macro$21 === $n(evidence$9).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$46 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$49 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$52 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$46 > preLhsIndex$macro$45) && $n(evidence$9).checkForDrop__Z())) {
      $n(input$macro$54)
    };
    var lhsValue$macro$55 = $n(evidence$9).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$9);
    if ($n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$9).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$47 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$();
        var this$13 = $m_Lreactbuild_format_iz2use_Repeater$();
        var x1$12 = this$13.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
        var elem = $n(evidence$9).Lfastparse_ParsingRun__f_cut;
        var elem$1 = false;
        elem$1 = elem;
        $n(x1$12);
        var acc$macro$35 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
        var startIndex$macro$36 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
        var count$macro$37 = 0;
        var lastAgg$macro$42 = null;
        var parse0$3;
        while (true) {
          $n(evidence$9).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$37 < 0));
          $m_Lfastparse_package$();
          $m_Lfastparse_package$();
          var parse0$2 = $m_Lreactbuild_format_iz2use_Parser$().edges__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$9);
          if ($n(parse0$2).Lfastparse_ParsingRun__f_isSuccess) {
            var $$x5 = $n(parse0$2);
            var arg1 = $as_sci_List($n(parse0$2).Lfastparse_ParsingRun__f_successValue);
            var this$19 = $n(arg1);
            var f = ((x$4$2) => {
              var x$4 = $as_Lreactbuild_format_iz2use_package$Vector2D(x$4$2);
              return new $c_Lreactbuild_format_iz2use_package$Side(x$4, $m_s_package$().s_package$__f_Nil)
            });
            if ((this$19 === $m_sci_Nil$())) {
              var $$x4 = $m_sci_Nil$()
            } else {
              var arg1$1 = this$19.head__O();
              var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
              var t$1 = h;
              var rest = $as_sci_List(this$19.tail__O());
              while ((rest !== $m_sci_Nil$())) {
                var arg1$2 = $n(rest).head__O();
                var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
                $n(t$1).sci_$colon$colon__f_next = nx;
                t$1 = nx;
                rest = $as_sci_List($n(rest).tail__O())
              };
              var $$x4 = h
            };
            $$x5.Lfastparse_ParsingRun__f_successValue = $$x4
          };
          var parsedMsg$macro$41 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$43 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$1 = (!(!(elem$1 | $n(evidence$9).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$1 = ($n(evidence$9).Lfastparse_ParsingRun__f_cut ? evidence$9 : ((count$macro$37 < 0) ? $n(evidence$9).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$36, elem$1) : $n(evidence$9).freshSuccess__O__I__Z__Lfastparse_ParsingRun(($n(x1$12), $n(acc$macro$35).toList__sci_List()), startIndex$macro$36, elem$1)));
            if ($n(evidence$9).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x9 = $n(evidence$9);
              var $$x8 = startIndex$macro$36;
              var $$x7 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$41) => (() => {
                var this$21 = $n(parsedMsg$macro$41);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$21.Lfastparse_internal_Msgs__f_value) + ".rep")
              }))(parsedMsg$macro$41));
              if ((lastAgg$macro$42 === null)) {
                var $$x6 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$3 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x6 = $n(lastAgg$macro$42).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3)
              };
              $n($$x9).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x8, $$x7, $$x6)
            };
            var parse0$3 = res$1;
            break
          } else {
            var beforeSepIndex$macro$38 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
            $n(x1$12);
            var t$2 = $as_sci_List($n(evidence$9).Lfastparse_ParsingRun__f_successValue);
            var this$23 = $n(acc$macro$35);
            this$23.addOne__O__scm_Growable(t$2);
            $n(evidence$9).Lfastparse_ParsingRun__f_cut = false;
            if ((this.whitespace__F1() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$9)
            };
            if ((!((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$9).Lfastparse_ParsingRun__f_cut))) {
              $n(evidence$9).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$37 = ((1 + count$macro$37) | 0);
              startIndex$macro$36 = beforeSepIndex$macro$38;
              count$macro$37 = temp$count$macro$37;
              lastAgg$macro$42 = parsedAgg$macro$43;
              continue
            };
            var parse0$3 = evidence$9;
            break
          }
        };
        if ($n(parse0$3).Lfastparse_ParsingRun__f_isSuccess) {
          var $$x10 = $n(parse0$3);
          var arg1$3 = $as_sci_List($n(parse0$3).Lfastparse_ParsingRun__f_successValue);
          var this$27 = $n(arg1$3);
          var this$26 = $m_s_$less$colon$less$();
          var toIterableOnce = this$26.s_$less$colon$less$__f_singleton;
          $$x10.Lfastparse_ParsingRun__f_successValue = $as_sci_List($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$27, toIterableOnce))
        };
        var rhsAggregate$macro$50 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$51 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$57 = evidence$9
        } else {
          var postRhsIndex$macro$48 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$53 = (postRhsIndex$macro$48 > preRhsIndex$macro$47);
          var nextIndex$macro$56 = (((!rhsMadeProgress$macro$53) && $n(input$macro$54).isReachable__I__Z(postRhsIndex$macro$48)) ? postLhsIndex$macro$46 : postRhsIndex$macro$48);
          if ((rhsMadeProgress$macro$53 && $n(evidence$9).checkForDrop__Z())) {
            $n(input$macro$54)
          };
          var res$macro$57 = $n(evidence$9).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$5).apply__O__O__O($as_s_Product(lhsValue$macro$55), $as_sci_List($n(evidence$9).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$56)
        };
        if ($n(evidence$9).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$9).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$45, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$52, rhsMsg$macro$51), $n(lhsAggregate$macro$49).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$50), (preRhsIndex$macro$47 === $n(evidence$9).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$14 = evidence$9
  } else {
    var postLhsIndex$macro$61 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$64 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$67 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$61 > preLhsIndex$macro$60) && $n(evidence$9).checkForDrop__Z())) {
      $n(input$macro$69)
    };
    var lhsValue$macro$70 = $n(evidence$9).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$9);
    if ($n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$9).Lfastparse_ParsingRun__f_cut)) {
        var x1$14 = evidence$9
      } else {
        var preRhsIndex$macro$62 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
        this.materials__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$9);
        var rhsAggregate$macro$65 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$66 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$72 = evidence$9
        } else {
          var postRhsIndex$macro$63 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$68 = (postRhsIndex$macro$63 > preRhsIndex$macro$62);
          var nextIndex$macro$71 = (((!rhsMadeProgress$macro$68) && $n(input$macro$69).isReachable__I__Z(postRhsIndex$macro$63)) ? postLhsIndex$macro$61 : postRhsIndex$macro$63);
          if ((rhsMadeProgress$macro$68 && $n(evidence$9).checkForDrop__Z())) {
            $n(input$macro$69)
          };
          var $$x11 = $n(evidence$9);
          $n(x1$3);
          var t$3 = $as_T2(lhsValue$macro$70);
          $n(evidence$9);
          var res$macro$72 = $n($$x11).freshSuccess__O__I__Lfastparse_ParsingRun(t$3, nextIndex$macro$71)
        };
        if ($n(evidence$9).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$9).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$60, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$67, rhsMsg$macro$66), $n(lhsAggregate$macro$64).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$65), (preRhsIndex$macro$62 === $n(evidence$9).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$14 = res$macro$72
      }
    } else {
      var x1$14 = evidence$9
    }
  };
  if (instrument) {
    $n($n(evidence$9).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("roof").Lsourcecode_Name__f_value, $n(x1$14).Lfastparse_ParsingRun__f_index, $n(x1$14).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$14).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x12 = $n(x1$14);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("roof").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x12).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$14).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$14).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$14).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x13 = $n(x1$14);
      var self = new $c_Lsourcecode_Name("roof").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$36 = $n($n(x1$14).Lfastparse_ParsingRun__f_failureStack);
      $$x13.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$36)
    }
  };
  if ((!$n(x1$14).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$14
  } else {
    var $$x14 = $n(x1$14);
    var this$38 = $m_Lreactbuild_format_iz2use_package$Roof$();
    $$x14.Lfastparse_ParsingRun__f_successValue = $n($f_F2__tupled__F1(this$38)).apply__O__O($as_T2($n(x1$14).Lfastparse_ParsingRun__f_successValue));
    return x1$14
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.roofs__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$10) {
  var startIndex = $n(evidence$10).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$10).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$10).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("roofs").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lreactbuild_format_iz2use_Repeater$();
  var x1$3 = this$1.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
  var elem = $n(evidence$10).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  $n(x1$3);
  var acc$macro$3 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
  var startIndex$macro$4 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
  var count$macro$5 = 0;
  var lastAgg$macro$10 = null;
  var x1$4;
  while (true) {
    $n(evidence$10).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 0));
    $m_Lfastparse_package$();
    $m_Lreactbuild_format_iz2use_Parser$().roof__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$10);
    var parsedMsg$macro$9 = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$11 = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$10).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = ($n(evidence$10).Lfastparse_ParsingRun__f_cut ? evidence$10 : ((count$macro$5 < 0) ? $n(evidence$10).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$10).freshSuccess__O__I__Z__Lfastparse_ParsingRun(($n(x1$3), $n(acc$macro$3).toList__sci_List()), startIndex$macro$4, elem$1)));
      if ($n(evidence$10).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x4 = $n(evidence$10);
        var $$x3 = startIndex$macro$4;
        var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
          var this$6 = $n(parsedMsg$macro$9);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep")
        }))(parsedMsg$macro$9));
        if ((lastAgg$macro$10 === null)) {
          var $$x1 = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$1 = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x1 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
        };
        $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x3, $$x2, $$x1)
      };
      var x1$4 = res;
      break
    } else {
      var beforeSepIndex$macro$6 = $n(evidence$10).Lfastparse_ParsingRun__f_index;
      $n(x1$3);
      var t = $as_Lreactbuild_format_iz2use_package$Roof($n(evidence$10).Lfastparse_ParsingRun__f_successValue);
      var this$8 = $n(acc$macro$3);
      this$8.addOne__O__scm_Growable(t);
      $n(evidence$10).Lfastparse_ParsingRun__f_cut = false;
      if ((this.whitespace__F1() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$10)
      };
      if ((!((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$10).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$10).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$5 = ((1 + count$macro$5) | 0);
        startIndex$macro$4 = beforeSepIndex$macro$6;
        count$macro$5 = temp$count$macro$5;
        lastAgg$macro$10 = parsedAgg$macro$11;
        continue
      };
      var x1$4 = evidence$10;
      break
    }
  };
  if (instrument) {
    $n($n(evidence$10).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("roofs").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("roofs").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("roofs").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$16 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$16)
    }
  };
  return x1$4
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.component__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$11) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$11).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$11).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("component").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$2 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$11).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Optioner$();
  var x1$5 = this$2.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
  var startPos = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
  $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
  $m_Lfastparse_package$();
  var startPos$2 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$11).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$11).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var input = $n(evidence$11).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$3 = $n(input);
    var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$4, index) === 45)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$11).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$11).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$11).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"-\"")))
  };
  $n(evidence$11).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  if ((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    $n(evidence$11).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$11).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$2, $n(evidence$11).Lfastparse_ParsingRun__f_index))
  };
  var postSuccess = $n(evidence$11).Lfastparse_ParsingRun__f_isSuccess;
  if (postSuccess) {
    var $$x2 = $n(evidence$11);
    $n(x1$5);
    var value = $as_T($n(evidence$11).Lfastparse_ParsingRun__f_successValue);
    var res$2 = $n($$x2).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value));
    $n(res$2).Lfastparse_ParsingRun__f_cut = (!(!($n(res$2).Lfastparse_ParsingRun__f_cut | startCut)));
    var res$4 = res$2
  } else if ($n(evidence$11).Lfastparse_ParsingRun__f_cut) {
    var res$4 = evidence$11
  } else {
    var res$3 = $n(evidence$11).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$5), $m_s_None$()), startPos);
    $n(res$3).Lfastparse_ParsingRun__f_cut = (!(!($n(res$3).Lfastparse_ParsingRun__f_cut | startCut)));
    var res$4 = res$3
  };
  if ($n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures) {
    var msg = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
    var agg = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ((!postSuccess)) {
      $n(evidence$11).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos, new $c_sjsr_AnonFunction0((() => {
        var this$10 = $n(msg);
        return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$10.Lfastparse_internal_Msgs__f_value) + ".?")
      })), agg)
    }
  };
  if ((!$n(res$4).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var $$x3 = $n(res$4);
    var arg1 = $as_s_Option($n(res$4).Lfastparse_ParsingRun__f_successValue);
    var this$12 = $n(arg1);
    $$x3.Lfastparse_ParsingRun__f_successValue = (!this$12.isEmpty__Z())
  };
  if ((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$9 = evidence$11
  } else {
    var postLhsIndex$macro$3 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$11).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$11).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$11);
    if ($n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$11).Lfastparse_ParsingRun__f_cut)) {
        var x1$9 = evidence$11
      } else {
        var preRhsIndex$macro$4 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
        var startIndex$1 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
        var instrument$1 = ($n(evidence$11).Lfastparse_ParsingRun__f_instrument !== null);
        if (instrument$1) {
          $n($n(evidence$11).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, startIndex$1)
        };
        var startPos$1 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
        var oldCapturing$1 = $n(evidence$11).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$11).Lfastparse_ParsingRun__f_noDropBuffer = true;
        $m_Lfastparse_package$();
        var elem = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
        var elem$1 = false;
        elem$1 = elem;
        var startIndex$macro$19 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
        var count$macro$20 = 0;
        var lastAgg$macro$25 = null;
        while (true) {
          $n(evidence$11).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$20 < 1));
          $m_Lfastparse_package$();
          $m_Lfastparse_Implicits$Sequencer$();
          var preLhsIndex$macro$2$1 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
          var input$macro$11$1 = $n(evidence$11).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$();
          var startPos$3 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
          var startCut$1 = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
          var oldNoCut = $n(evidence$11).Lfastparse_ParsingRun__f_noDropBuffer;
          $n(evidence$11).Lfastparse_ParsingRun__f_noDropBuffer = true;
          var startTerminals = $n(evidence$11).Lfastparse_ParsingRun__f_failureTerminalAggregate;
          var oldCut = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
          $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
          var startPos$4 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          var oldCut$2 = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
          $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
          var startPos$2$1 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$11);
          var lhsMsg = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$11).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$11).Lfastparse_ParsingRun__f_cut | oldCut$2)))
          } else if ($n(evidence$11).Lfastparse_ParsingRun__f_cut) {
            /*<skip>*/
          } else {
            var verboseFailures = $n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$11).Lfastparse_ParsingRun__f_index = startPos$2$1;
            if (verboseFailures) {
              var this$21 = $n(evidence$11);
              this$21.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, lhsMsg, lhsAggregate, false)
            };
            $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
            $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$11);
            var rhsMsg = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
            var endCut = (!(!(rhsCut | oldCut$2)));
            if (((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
              $n(evidence$11).freshFailure__I__Lfastparse_ParsingRun(startPos$2$1)
            };
            $n(evidence$11).Lfastparse_ParsingRun__f_cut = endCut;
            if (verboseFailures) {
              var this$22 = $n(evidence$11);
              var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
              var rassoc$3 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
              this$22.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, msgToSet, msgToAggregate, false)
            }
          };
          var lhsMsg$2 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$2 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$11).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$11).Lfastparse_ParsingRun__f_cut | oldCut)))
          } else if ((!$n(evidence$11).Lfastparse_ParsingRun__f_cut)) {
            var verboseFailures$2 = $n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$11).Lfastparse_ParsingRun__f_index = startPos$4;
            if (verboseFailures$2) {
              var this$24 = $n(evidence$11);
              this$24.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$4, lhsMsg$2, lhsAggregate$2, false)
            };
            $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
            var oldCut$1 = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
            $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
            var startPos$5 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
            $m_Lfastparse_package$();
            var input$1 = $n(evidence$11).Lfastparse_ParsingRun__f_input;
            var index$1 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
            if ($n(input$1).isReachable__I__Z(index$1)) {
              var this$25 = $n(input$1);
              var this$26 = $n(this$25.Lfastparse_IndexedParserInput__f_data);
              var $$x4 = ($charAt(this$26, index$1) === 43)
            } else {
              var $$x4 = false
            };
            if ($$x4) {
              $n(evidence$11).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$1) | 0))
            } else {
              $n(evidence$11).freshFailure__Lfastparse_ParsingRun()
            };
            if ($n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures) {
              $n(evidence$11).aggregateTerminal__I__F0__V(index$1, new $c_sjsr_AnonFunction0((() => "\"+\"")))
            };
            var lhsMsg$1 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
            var lhsAggregate$1 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
            if ($n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) {
              $n(evidence$11).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$11).Lfastparse_ParsingRun__f_cut | oldCut$1)))
            } else if ((!$n(evidence$11).Lfastparse_ParsingRun__f_cut)) {
              var verboseFailures$1 = $n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures;
              $n(evidence$11).Lfastparse_ParsingRun__f_index = startPos$5;
              if (verboseFailures$1) {
                var this$29 = $n(evidence$11);
                this$29.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, lhsMsg$1, lhsAggregate$1, false)
              };
              $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
              var input$2 = $n(evidence$11).Lfastparse_ParsingRun__f_input;
              var index$2 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
              if ($n(input$2).isReachable__I__Z(index$2)) {
                var this$30 = $n(input$2);
                var this$31 = $n(this$30.Lfastparse_IndexedParserInput__f_data);
                var $$x5 = ($charAt(this$31, index$2) === 44)
              } else {
                var $$x5 = false
              };
              if ($$x5) {
                $n(evidence$11).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
              } else {
                $n(evidence$11).freshFailure__Lfastparse_ParsingRun()
              };
              if ($n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$11).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\",\"")))
              };
              var rhsMsg$1 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
              var rhsCut$1 = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
              var endCut$1 = (!(!(rhsCut$1 | oldCut$1)));
              if (((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$1))) {
                $n(evidence$11).freshFailure__I__Lfastparse_ParsingRun(startPos$5)
              };
              $n(evidence$11).Lfastparse_ParsingRun__f_cut = endCut$1;
              if (verboseFailures$1) {
                var this$32 = $n(evidence$11);
                var msgToSet$1 = $n(lhsMsg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$1);
                var rassoc$3$1 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var msgToAggregate$1 = $n(lhsAggregate$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$1);
                this$32.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, msgToSet$1, msgToAggregate$1, false)
              }
            };
            var rhsMsg$2 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$2 = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
            var endCut$2 = (!(!(rhsCut$2 | oldCut)));
            if (((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2))) {
              $n(evidence$11).freshFailure__I__Lfastparse_ParsingRun(startPos$4)
            };
            $n(evidence$11).Lfastparse_ParsingRun__f_cut = endCut$2;
            if (verboseFailures$2) {
              var this$33 = $n(evidence$11);
              var msgToSet$2 = $n(lhsMsg$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2);
              var rassoc$3$2 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$2 = $n(lhsAggregate$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
              this$33.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$4, msgToSet$2, msgToAggregate$2, false)
            }
          };
          $n(evidence$11).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
          var msg$1 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
          var res$5 = ($n(evidence$11).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$11).freshFailure__I__Lfastparse_ParsingRun(startPos$3) : $n(evidence$11).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$3));
          if ($n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$11).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
            $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
            $n(evidence$11).setMsg__I__F0__V(startPos$3, new $c_sjsr_AnonFunction0(((msg$1) => (() => {
              var this$34 = $n(msg$1);
              return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$34.Lfastparse_internal_Msgs__f_value))
            }))(msg$1)))
          };
          $n(res$5).Lfastparse_ParsingRun__f_cut = startCut$1;
          if ($n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$3$1 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$6$1 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$9$1 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
            if (((postLhsIndex$macro$3$1 > preLhsIndex$macro$2$1) && $n(evidence$11).checkForDrop__Z())) {
              $n(input$macro$11$1)
            };
            $n(evidence$11);
            if ((!((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$11).Lfastparse_ParsingRun__f_cut))) {
              var preRhsIndex$macro$4$1 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
              $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$11);
              var rhsAggregate$macro$7 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$8 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess)) {
                /*<skip>*/
              } else {
                var postRhsIndex$macro$5 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4$1);
                var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11$1).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3$1 : postRhsIndex$macro$5);
                if ((rhsMadeProgress$macro$10 && $n(evidence$11).checkForDrop__Z())) {
                  $n(input$macro$11$1)
                };
                var $$x6 = $n(evidence$11);
                $n(evidence$11);
                var v = (void 0);
                $n($$x6).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
              };
              if ($n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$11).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2$1, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9$1, rhsMsg$macro$8), $n(lhsAggregate$macro$6$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4$1 === $n(evidence$11).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          };
          var parsedMsg$macro$24 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$26 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$1 = (!(!(elem$1 | $n(evidence$11).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$6 = ($n(evidence$11).Lfastparse_ParsingRun__f_cut ? evidence$11 : ((count$macro$20 < 1) ? $n(evidence$11).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19, elem$1) : $n(evidence$11).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19, elem$1)));
            if ($n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x10 = $n(evidence$11);
              var $$x9 = startIndex$macro$19;
              var $$x8 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
                var this$36 = $n(parsedMsg$macro$24);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$36.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$macro$24));
              if ((lastAgg$macro$25 === null)) {
                var $$x7 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$2 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x7 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
              };
              $n($$x10).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x9, $$x8, $$x7)
            };
            break
          } else {
            var beforeSepIndex$macro$21 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
            $n(evidence$11);
            $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
            if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$11)
            };
            if ((!((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$11).Lfastparse_ParsingRun__f_cut))) {
              $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$20 = ((1 + count$macro$20) | 0);
              startIndex$macro$19 = beforeSepIndex$macro$21;
              count$macro$20 = temp$count$macro$20;
              lastAgg$macro$25 = parsedAgg$macro$26;
              continue
            };
            break
          }
        };
        $n(evidence$11).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing$1;
        var x1$5$1 = ((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) ? evidence$11 : $n(evidence$11).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$11).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$1, $n(evidence$11).Lfastparse_ParsingRun__f_index)));
        if (instrument$1) {
          $n($n(evidence$11).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, $n(x1$5$1).Lfastparse_ParsingRun__f_index, $n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)
        };
        if ($n(x1$5$1).Lfastparse_ParsingRun__f_verboseFailures) {
          var $$x11 = $n(x1$5$1);
          $m_sci_List$();
          var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value)))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          $n($$x11).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex$1, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5$1).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex$1 < $n(x1$5$1).Lfastparse_ParsingRun__f_traceIndex));
          if ((!$n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)) {
            var $$x12 = $n(x1$5$1);
            var self = new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value;
            var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex$1);
            var this$44 = $n($n(x1$5$1).Lfastparse_ParsingRun__f_failureStack);
            $$x12.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$44)
          }
        };
        var rhsAggregate$macro$7$1 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8$1 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$14$1 = evidence$11
        } else {
          var postRhsIndex$macro$5$1 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10$1 = (postRhsIndex$macro$5$1 > preRhsIndex$macro$4);
          var nextIndex$macro$13$1 = (((!rhsMadeProgress$macro$10$1) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5$1)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5$1);
          if ((rhsMadeProgress$macro$10$1 && $n(evidence$11).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var res$macro$14$1 = $n(evidence$11).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($uZ(lhsValue$macro$12), $as_T($n(evidence$11).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$13$1)
        };
        if ($n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$11).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8$1), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7$1), (preRhsIndex$macro$4 === $n(evidence$11).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$9 = res$macro$14$1
      }
    } else {
      var x1$9 = evidence$11
    }
  };
  if (instrument) {
    $n($n(evidence$11).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("component").Lsourcecode_Name__f_value, $n(x1$9).Lfastparse_ParsingRun__f_index, $n(x1$9).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$9).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x13 = $n(x1$9);
    $m_sci_List$();
    var array$1 = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("component").Lsourcecode_Name__f_value)))];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $n($$x13).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)), $n(x1$9).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$9).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$9).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x14 = $n(x1$9);
      var self$1 = new $c_Lsourcecode_Name("component").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self$1, startIndex);
      var this$51 = $n($n(x1$9).Lfastparse_ParsingRun__f_failureStack);
      $$x14.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$51)
    }
  };
  if ((!$n(x1$9).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$9
  } else {
    var $$x15 = $n(x1$9);
    var this$53 = $m_Lreactbuild_format_iz2use_package$ComponentInstance$();
    $$x15.Lfastparse_ParsingRun__f_successValue = $n($f_F2__tupled__F1(this$53)).apply__O__O($as_T2($n(x1$9).Lfastparse_ParsingRun__f_successValue));
    return x1$9
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.componentColumn__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$12) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$12).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$12).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("componentColumn").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var this$2 = $m_Lreactbuild_format_iz2use_Repeater$();
  var repeater = this$2.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
  var whitespace = this.whitespace__F1();
  var this$4 = $m_Lfastparse_internal_RepImpls$();
  $n(repeater);
  var acc = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
  var startIndex$1 = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  var x1$2;
  while (true) {
    $n(evidence$12).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
    $m_Lreactbuild_format_iz2use_Parser$().component__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$12);
    var parsedMsg = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
    var verboseFailures = $n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures;
    if ((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$12 : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$12, repeater, acc));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$12).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$7 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg)), $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$12);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$8 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
        }
      };
      var x1$2 = res;
      break
    } else {
      var beforeSepIndex = $n(evidence$12).Lfastparse_ParsingRun__f_index;
      $n(repeater);
      var t = $n(evidence$12).Lfastparse_ParsingRun__f_successValue;
      var this$10 = $n(acc);
      this$10.addOne__O__scm_Growable(t);
      var nextCount = ((1 + count) | 0);
      if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$12)
      };
      if (((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$12).Lfastparse_ParsingRun__f_cut)) {
        var x1$2 = evidence$12;
        break
      } else {
        $n(evidence$12).Lfastparse_ParsingRun__f_cut = false;
        var input = $n(evidence$12).Lfastparse_ParsingRun__f_input;
        var index = $n(evidence$12).Lfastparse_ParsingRun__f_index;
        if ($n(input).isReachable__I__Z(index)) {
          var this$11 = $n(input);
          var this$12 = $n(this$11.Lfastparse_IndexedParserInput__f_data);
          var $$x4 = ($charAt(this$12, index) === 43)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          var res$1 = $n(evidence$12).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
        } else {
          var res$1 = $n(evidence$12).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$12).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"+\"")))
        };
        var sepCut = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
        if ((res$1 === null)) {
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = false;
          outerCut = endCut;
          sepMsg = null;
          lastAgg = parsedAgg;
          continue
        };
        if ($n(evidence$12).Lfastparse_ParsingRun__f_isSuccess) {
          if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$12)
          };
          var temp$sepMsg$2 = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = sepCut;
          outerCut = endCut;
          sepMsg = temp$sepMsg$2;
          lastAgg = parsedAgg;
          continue
        };
        var res$2 = (sepCut ? $n(evidence$12).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut) : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, beforeSepIndex, beforeSepIndex, nextCount, endCut, 1, evidence$12, repeater, acc));
        if (verboseFailures) {
          var startIndex$3 = startIndex$1;
          var $$x6 = $n(evidence$12);
          var $$x5 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$15 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$15.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          var rassoc$1 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
          $n($$x6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$3, $$x5, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1))
        };
        var x1$2 = res$2;
        break
      }
    }
  };
  if (instrument) {
    $n($n(evidence$12).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("componentColumn").Lsourcecode_Name__f_value, $n(x1$2).Lfastparse_ParsingRun__f_index, $n(x1$2).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$2).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x7 = $n(x1$2);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("componentColumn").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$2).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$2).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$2).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x8 = $n(x1$2);
      var self = new $c_Lsourcecode_Name("componentColumn").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$22 = $n($n(x1$2).Lfastparse_ParsingRun__f_failureStack);
      $$x8.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$22)
    }
  };
  if ((!$n(x1$2).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$2
  } else {
    var $$x9 = $n(x1$2);
    var arg1 = $as_sci_List($n(x1$2).Lfastparse_ParsingRun__f_successValue);
    $$x9.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_format_iz2use_package$ComponentColumn(arg1);
    return x1$2
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.componentColumns__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$13) {
  var startIndex = $n(evidence$13).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$13).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$13).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("componentColumns").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var this$2 = $m_Lreactbuild_format_iz2use_Repeater$();
  var repeater = this$2.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
  var whitespace = this.whitespace__F1();
  var this$4 = $m_Lfastparse_internal_RepImpls$();
  $n(repeater);
  var acc = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
  var startIndex$1 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$13).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  var x1$2;
  while (true) {
    $n(evidence$13).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
    $m_Lreactbuild_format_iz2use_Parser$().componentColumn__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$13);
    var parsedMsg = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$13).Lfastparse_ParsingRun__f_cut;
    var verboseFailures = $n(evidence$13).Lfastparse_ParsingRun__f_verboseFailures;
    if ((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$13 : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$13, repeater, acc));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$13).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$7 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg)), $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$13);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$8 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
        }
      };
      var x1$2 = res;
      break
    } else {
      var beforeSepIndex = $n(evidence$13).Lfastparse_ParsingRun__f_index;
      $n(repeater);
      var t = $n(evidence$13).Lfastparse_ParsingRun__f_successValue;
      var this$10 = $n(acc);
      this$10.addOne__O__scm_Growable(t);
      var nextCount = ((1 + count) | 0);
      if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$13)
      };
      if (((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$13).Lfastparse_ParsingRun__f_cut)) {
        var x1$2 = evidence$13;
        break
      } else {
        $n(evidence$13).Lfastparse_ParsingRun__f_cut = false;
        var input = $n(evidence$13).Lfastparse_ParsingRun__f_input;
        var index = $n(evidence$13).Lfastparse_ParsingRun__f_index;
        if ($n(input).isReachable__I__Z(index)) {
          var this$11 = $n(input);
          var this$12 = $n(this$11.Lfastparse_IndexedParserInput__f_data);
          var $$x4 = ($charAt(this$12, index) === 44)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          var res$1 = $n(evidence$13).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
        } else {
          var res$1 = $n(evidence$13).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$13).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$13).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\",\"")))
        };
        var sepCut = $n(evidence$13).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
        if ((res$1 === null)) {
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = false;
          outerCut = endCut;
          sepMsg = null;
          lastAgg = parsedAgg;
          continue
        };
        if ($n(evidence$13).Lfastparse_ParsingRun__f_isSuccess) {
          if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$13)
          };
          var temp$sepMsg$2 = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = sepCut;
          outerCut = endCut;
          sepMsg = temp$sepMsg$2;
          lastAgg = parsedAgg;
          continue
        };
        var res$2 = (sepCut ? $n(evidence$13).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut) : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$4, beforeSepIndex, beforeSepIndex, nextCount, endCut, 1, evidence$13, repeater, acc));
        if (verboseFailures) {
          var startIndex$3 = startIndex$1;
          var $$x6 = $n(evidence$13);
          var $$x5 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$15 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$15.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          var rassoc$1 = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
          $n($$x6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$3, $$x5, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1))
        };
        var x1$2 = res$2;
        break
      }
    }
  };
  if (instrument) {
    $n($n(evidence$13).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("componentColumns").Lsourcecode_Name__f_value, $n(x1$2).Lfastparse_ParsingRun__f_index, $n(x1$2).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$2).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x7 = $n(x1$2);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("componentColumns").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$2).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$2).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$2).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x8 = $n(x1$2);
      var self = new $c_Lsourcecode_Name("componentColumns").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$22 = $n($n(x1$2).Lfastparse_ParsingRun__f_failureStack);
      $$x8.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$22)
    }
  };
  return x1$2
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.componentGroupOffset__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$14) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$14).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$14).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("componentGroupOffset").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$32 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var input$macro$41 = $n(evidence$14).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Optioner$();
  var x1$5 = this$2.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
  var startPos = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$14).Lfastparse_ParsingRun__f_cut;
  $n(evidence$14).Lfastparse_ParsingRun__f_cut = false;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$14).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var input = $n(evidence$14).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$4 = $n(input);
    var this$5 = $n(this$4.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$5, index) === 43)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$14).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$14).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$14).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"+\"")))
  };
  if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$14).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$14).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$14);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$14);
    if ($n(evidence$14).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$14).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$4 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Expressions$().absoluteLength__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$14);
        var rhsAggregate$macro$7 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$14).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$14 = evidence$14
        } else {
          var postRhsIndex$macro$5 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$14).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x2 = $n(evidence$14);
          var ev$1 = $n(evidence$14).Lfastparse_ParsingRun__f_successValue;
          var v = new $c_Leu_timepit_refined_api_Refined(((ev$1 === null) ? null : $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(ev$1)).Leu_timepit_refined_api_Refined__f_value)));
          var res$macro$14 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
        };
        if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$14).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$14).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  var postSuccess = $n(evidence$14).Lfastparse_ParsingRun__f_isSuccess;
  if (postSuccess) {
    var $$x3 = $n(evidence$14);
    $n(x1$5);
    var ev$2 = $n(evidence$14).Lfastparse_ParsingRun__f_successValue;
    var value = new $c_Leu_timepit_refined_api_Refined(((ev$2 === null) ? null : $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(ev$2)).Leu_timepit_refined_api_Refined__f_value)));
    var res$2 = $n($$x3).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value));
    $n(res$2).Lfastparse_ParsingRun__f_cut = (!(!($n(res$2).Lfastparse_ParsingRun__f_cut | startCut)))
  } else if ($n(evidence$14).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var res$3 = $n(evidence$14).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$5), $m_s_None$()), startPos);
    $n(res$3).Lfastparse_ParsingRun__f_cut = (!(!($n(res$3).Lfastparse_ParsingRun__f_cut | startCut)))
  };
  if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
    var msg = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
    var agg = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ((!postSuccess)) {
      $n(evidence$14).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos, new $c_sjsr_AnonFunction0((() => {
        var this$11 = $n(msg);
        return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$11.Lfastparse_internal_Msgs__f_value) + ".?")
      })), agg)
    }
  };
  if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$14 = evidence$14
  } else {
    var postLhsIndex$macro$33 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$36 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$39 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$33 > preLhsIndex$macro$32) && $n(evidence$14).checkForDrop__Z())) {
      $n(input$macro$41)
    };
    var lhsValue$macro$42 = $n(evidence$14).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$14);
    if ($n(evidence$14).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$14).Lfastparse_ParsingRun__f_cut)) {
        var x1$14 = evidence$14
      } else {
        var preRhsIndex$macro$34 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
        var this$13 = $m_Lfastparse_Implicits$Optioner$();
        var x1$10 = this$13.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
        var startPos$2 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
        var startCut$2 = $n(evidence$14).Lfastparse_ParsingRun__f_cut;
        $n(evidence$14).Lfastparse_ParsingRun__f_cut = false;
        $m_Lfastparse_package$();
        $m_Lfastparse_Implicits$Sequencer$();
        var preLhsIndex$macro$17 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
        var input$macro$26 = $n(evidence$14).Lfastparse_ParsingRun__f_input;
        $m_Lfastparse_package$();
        var input$2 = $n(evidence$14).Lfastparse_ParsingRun__f_input;
        var index$2 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
        if ($n(input$2).isReachable__I__Z(index$2)) {
          var this$15 = $n(input$2);
          var this$16 = $n(this$15.Lfastparse_IndexedParserInput__f_data);
          var $$x4 = ($charAt(this$16, index$2) === 45)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          $n(evidence$14).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
        } else {
          $n(evidence$14).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$14).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"-\"")))
        };
        if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
          /*<skip>*/
        } else {
          var postLhsIndex$macro$18 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
          var lhsAggregate$macro$21 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var lhsMsg$macro$24 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
          $n(evidence$14).Lfastparse_ParsingRun__f_cut = true;
          if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$14).checkForDrop__Z())) {
            $n(input$macro$26)
          };
          $n(evidence$14);
          $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$14);
          if ($n(evidence$14).Lfastparse_ParsingRun__f_isSuccess) {
            if (((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$14).Lfastparse_ParsingRun__f_cut)) {
              /*<skip>*/
            } else {
              var preRhsIndex$macro$19 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
              $m_Lreactbuild_format_iz2use_Expressions$().absoluteLength__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$14);
              var rhsAggregate$macro$22 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$23 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
                $n(evidence$14).Lfastparse_ParsingRun__f_cut = true;
                var res$macro$29 = evidence$14
              } else {
                var postRhsIndex$macro$20 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
                var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
                if ((rhsMadeProgress$macro$25 && $n(evidence$14).checkForDrop__Z())) {
                  $n(input$macro$26)
                };
                var $$x5 = $n(evidence$14);
                var ev$3 = $n(evidence$14).Lfastparse_ParsingRun__f_successValue;
                var v$1 = new $c_Leu_timepit_refined_api_Refined(((ev$3 === null) ? null : $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(ev$3)).Leu_timepit_refined_api_Refined__f_value)));
                var res$macro$29 = $n($$x5).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$28)
              };
              if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$14).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$14).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          }
        };
        var postSuccess$2 = $n(evidence$14).Lfastparse_ParsingRun__f_isSuccess;
        if (postSuccess$2) {
          var $$x6 = $n(evidence$14);
          $n(x1$10);
          var ev$4 = $n(evidence$14).Lfastparse_ParsingRun__f_successValue;
          var value$1 = new $c_Leu_timepit_refined_api_Refined(((ev$4 === null) ? null : $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(ev$4)).Leu_timepit_refined_api_Refined__f_value)));
          var res$6 = $n($$x6).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value$1));
          $n(res$6).Lfastparse_ParsingRun__f_cut = (!(!($n(res$6).Lfastparse_ParsingRun__f_cut | startCut$2)))
        } else if ($n(evidence$14).Lfastparse_ParsingRun__f_cut) {
          /*<skip>*/
        } else {
          var res$7 = $n(evidence$14).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$10), $m_s_None$()), startPos$2);
          $n(res$7).Lfastparse_ParsingRun__f_cut = (!(!($n(res$7).Lfastparse_ParsingRun__f_cut | startCut$2)))
        };
        if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
          var msg$2 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
          var agg$2 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ((!postSuccess$2)) {
            $n(evidence$14).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$2, new $c_sjsr_AnonFunction0((() => {
              var this$21 = $n(msg$2);
              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$21.Lfastparse_internal_Msgs__f_value) + ".?")
            })), agg$2)
          }
        };
        var rhsAggregate$macro$37 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$38 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$44 = evidence$14
        } else {
          var postRhsIndex$macro$35 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$40 = (postRhsIndex$macro$35 > preRhsIndex$macro$34);
          var nextIndex$macro$43 = (((!rhsMadeProgress$macro$40) && $n(input$macro$41).isReachable__I__Z(postRhsIndex$macro$35)) ? postLhsIndex$macro$33 : postRhsIndex$macro$35);
          if ((rhsMadeProgress$macro$40 && $n(evidence$14).checkForDrop__Z())) {
            $n(input$macro$41)
          };
          var res$macro$44 = $n(evidence$14).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($as_s_Option(lhsValue$macro$42), $as_s_Option($n(evidence$14).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$43)
        };
        if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$14).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$32, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$39, rhsMsg$macro$38), $n(lhsAggregate$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$37), (preRhsIndex$macro$34 === $n(evidence$14).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$14 = res$macro$44
      }
    } else {
      var x1$14 = evidence$14
    }
  };
  if (instrument) {
    $n($n(evidence$14).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("componentGroupOffset").Lsourcecode_Name__f_value, $n(x1$14).Lfastparse_ParsingRun__f_index, $n(x1$14).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$14).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x7 = $n(x1$14);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("componentGroupOffset").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$14).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$14).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$14).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x8 = $n(x1$14);
      var self = new $c_Lsourcecode_Name("componentGroupOffset").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$28 = $n($n(x1$14).Lfastparse_ParsingRun__f_failureStack);
      $$x8.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$28)
    }
  };
  if ((!$n(x1$14).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$14
  } else {
    var $$x12 = $n(x1$14);
    var arg1 = $as_T2($n(x1$14).Lfastparse_ParsingRun__f_successValue);
    matchEnd19: {
      var $$x9;
      if ((arg1 !== null)) {
        var p2 = $as_s_Option($n(arg1)._1__O());
        var p3 = $as_s_Option($n(arg1)._2__O());
        var x = $m_s_None$();
        if ((x === p2)) {
          var x$3 = $m_s_None$();
          var $$x10 = (x$3 === p3)
        } else {
          var $$x10 = false
        };
        if ($$x10) {
          var $$x9 = $m_Lreactbuild_format_iz2use_package$NoOffset$();
          break matchEnd19
        }
      };
      if ((arg1 !== null)) {
        var p6 = $as_s_Option($n(arg1)._1__O());
        var p7 = $as_s_Option($n(arg1)._2__O());
        if ((p6 instanceof $c_s_Some)) {
          var x8 = $as_s_Some(p6);
          var p = $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined($n(x8).s_Some__f_value)).Leu_timepit_refined_api_Refined__f_value);
          var x$5 = $m_s_None$();
          if ((x$5 === p7)) {
            var tp = new $c_Leu_timepit_refined_api_Refined(p);
            var rt = $m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType;
            var $$x9 = new $c_Lreactbuild_format_iz2use_package$PositiveOffset($as_Lreactbuild_format_iz2use_package$Length($n(rt).unwrap__O__O(tp)));
            break matchEnd19
          }
        }
      };
      if ((arg1 !== null)) {
        var p10 = $as_s_Option($n(arg1)._1__O());
        var p11 = $as_s_Option($n(arg1)._2__O());
        var x$7 = $m_s_None$();
        if (((x$7 === p10) && (p11 instanceof $c_s_Some))) {
          var x12 = $as_s_Some(p11);
          var m = $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined($n(x12).s_Some__f_value)).Leu_timepit_refined_api_Refined__f_value);
          var tp$1 = new $c_Leu_timepit_refined_api_Refined(m);
          var rt$1 = $m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType;
          var $$x9 = new $c_Lreactbuild_format_iz2use_package$NegativeOffset($as_Lreactbuild_format_iz2use_package$Length($n(rt$1).unwrap__O__O(tp$1)));
          break matchEnd19
        }
      };
      if ((arg1 !== null)) {
        var p14 = $as_s_Option($n(arg1)._1__O());
        var p15 = $as_s_Option($n(arg1)._2__O());
        if ((p14 instanceof $c_s_Some)) {
          var x16 = $as_s_Some(p14);
          var p$2 = $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined($n(x16).s_Some__f_value)).Leu_timepit_refined_api_Refined__f_value);
          if ((p15 instanceof $c_s_Some)) {
            var x17 = $as_s_Some(p15);
            var m$2 = $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined($n(x17).s_Some__f_value)).Leu_timepit_refined_api_Refined__f_value);
            var tp$2 = new $c_Leu_timepit_refined_api_Refined(p$2);
            var rt$2 = $m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType;
            var $$x11 = $as_Lreactbuild_format_iz2use_package$Length($n(rt$2).unwrap__O__O(tp$2));
            var tp$3 = new $c_Leu_timepit_refined_api_Refined(m$2);
            var rt$3 = $m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType;
            var $$x9 = new $c_Lreactbuild_format_iz2use_package$BothOffset($$x11, $as_Lreactbuild_format_iz2use_package$Length($n(rt$3).unwrap__O__O(tp$3)));
            break matchEnd19
          }
        }
      };
      throw new $c_s_MatchError(arg1)
    };
    $$x12.Lfastparse_ParsingRun__f_successValue = $$x9;
    return x1$14
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.componentGroup__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$15) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$15).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$15).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("componentGroup").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$109 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var input$macro$118 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.Lfastparse_Implicits$Sequencer$__f_BaseSequencer3;
  var preLhsIndex$macro$94 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var input$macro$103 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$3 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$7 = this$3.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$79 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var input$macro$88 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$4 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$9 = this$4.Lfastparse_Implicits$Sequencer$__f_BaseSequencer2;
  var preLhsIndex$macro$64 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var input$macro$73 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$5 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$11 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$5));
  var preLhsIndex$macro$34 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var input$macro$43 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$4 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var input$macro$13 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var index = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var end = ((2 + index) | 0);
  var input = $n(evidence$15).Lfastparse_ParsingRun__f_input;
  if ($n(input).isReachable__I__Z((((-1) + end) | 0))) {
    var this$7 = $n(input);
    var this$8 = $n(this$7.Lfastparse_IndexedParserInput__f_data);
    if (($charAt(this$8, index) === 32)) {
      var this$9 = $n(input);
      var index$1 = ((1 + index) | 0);
      var this$10 = $n(this$9.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$10, index$1) === 32)
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$15).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
  } else {
    $n(evidence$15).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$15).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"  \"")))
  };
  if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$5 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$8 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$11 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$15).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$5 > preLhsIndex$macro$4) && $n(evidence$15).checkForDrop__Z())) {
      $n(input$macro$13)
    };
    $n(evidence$15);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$15);
    if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$15).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$6 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        this.componentGroupOffset__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$15);
        var rhsAggregate$macro$9 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$10 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$15).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$16 = evidence$15
        } else {
          var postRhsIndex$macro$7 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$12 = (postRhsIndex$macro$7 > preRhsIndex$macro$6);
          var nextIndex$macro$15 = (((!rhsMadeProgress$macro$12) && $n(input$macro$13).isReachable__I__Z(postRhsIndex$macro$7)) ? postLhsIndex$macro$5 : postRhsIndex$macro$7);
          if ((rhsMadeProgress$macro$12 && $n(evidence$15).checkForDrop__Z())) {
            $n(input$macro$13)
          };
          var $$x2 = $n(evidence$15);
          var v = $as_s_Product($n(evidence$15).Lfastparse_ParsingRun__f_successValue);
          var res$macro$16 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$15)
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$15).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$4, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$11, rhsMsg$macro$10), $n(lhsAggregate$macro$8).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$9), (preRhsIndex$macro$6 === $n(evidence$15).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$35 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$38 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$41 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$35 > preLhsIndex$macro$34) && $n(evidence$15).checkForDrop__Z())) {
      $n(input$macro$43)
    };
    var lhsValue$macro$44 = $n(evidence$15).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$15);
    if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$15).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$36 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        var this$13 = $m_Lfastparse_Implicits$Optioner$();
        var x1$16 = this$13.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
        var startPos = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        var startCut = $n(evidence$15).Lfastparse_ParsingRun__f_cut;
        $n(evidence$15).Lfastparse_ParsingRun__f_cut = false;
        $m_Lfastparse_package$();
        $m_Lfastparse_Implicits$Sequencer$();
        var preLhsIndex$macro$19 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        var input$macro$28 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
        $m_Lfastparse_package$();
        var input$2 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
        var index$2 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        if ($n(input$2).isReachable__I__Z(index$2)) {
          var this$15 = $n(input$2);
          var this$16 = $n(this$15.Lfastparse_IndexedParserInput__f_data);
          var $$x3 = ($charAt(this$16, index$2) === 64)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $n(evidence$15).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
        } else {
          $n(evidence$15).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$15).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"@\"")))
        };
        if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
          /*<skip>*/
        } else {
          var postLhsIndex$macro$20 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
          var lhsAggregate$macro$23 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var lhsMsg$macro$26 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
          $n(evidence$15).Lfastparse_ParsingRun__f_cut = true;
          if (((postLhsIndex$macro$20 > preLhsIndex$macro$19) && $n(evidence$15).checkForDrop__Z())) {
            $n(input$macro$28)
          };
          $n(evidence$15);
          $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$15);
          if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
            if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$15).Lfastparse_ParsingRun__f_cut)) {
              /*<skip>*/
            } else {
              var preRhsIndex$macro$21 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
              $m_Lreactbuild_format_iz2use_Expressions$().length__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$15);
              var rhsAggregate$macro$24 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$25 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
                $n(evidence$15).Lfastparse_ParsingRun__f_cut = true;
                var res$macro$31 = evidence$15
              } else {
                var postRhsIndex$macro$22 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$27 = (postRhsIndex$macro$22 > preRhsIndex$macro$21);
                var nextIndex$macro$30 = (((!rhsMadeProgress$macro$27) && $n(input$macro$28).isReachable__I__Z(postRhsIndex$macro$22)) ? postLhsIndex$macro$20 : postRhsIndex$macro$22);
                if ((rhsMadeProgress$macro$27 && $n(evidence$15).checkForDrop__Z())) {
                  $n(input$macro$28)
                };
                var $$x4 = $n(evidence$15);
                var v$1 = $as_Lreactbuild_format_iz2use_package$Length($n(evidence$15).Lfastparse_ParsingRun__f_successValue);
                var res$macro$31 = $n($$x4).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$30)
              };
              if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$15).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$19, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$26, rhsMsg$macro$25), $n(lhsAggregate$macro$23).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$24), (preRhsIndex$macro$21 === $n(evidence$15).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          }
        };
        var postSuccess = $n(evidence$15).Lfastparse_ParsingRun__f_isSuccess;
        if (postSuccess) {
          var $$x5 = $n(evidence$15);
          $n(x1$16);
          var value = $as_Lreactbuild_format_iz2use_package$Length($n(evidence$15).Lfastparse_ParsingRun__f_successValue);
          var res$3 = $n($$x5).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value));
          $n(res$3).Lfastparse_ParsingRun__f_cut = (!(!($n(res$3).Lfastparse_ParsingRun__f_cut | startCut)))
        } else if ($n(evidence$15).Lfastparse_ParsingRun__f_cut) {
          /*<skip>*/
        } else {
          var res$4 = $n(evidence$15).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$16), $m_s_None$()), startPos);
          $n(res$4).Lfastparse_ParsingRun__f_cut = (!(!($n(res$4).Lfastparse_ParsingRun__f_cut | startCut)))
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          var msg = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
          var agg = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ((!postSuccess)) {
            $n(evidence$15).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos, new $c_sjsr_AnonFunction0((() => {
              var this$21 = $n(msg);
              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$21.Lfastparse_internal_Msgs__f_value) + ".?")
            })), agg)
          }
        };
        var rhsAggregate$macro$39 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$40 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$46 = evidence$15
        } else {
          var postRhsIndex$macro$37 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$42 = (postRhsIndex$macro$37 > preRhsIndex$macro$36);
          var nextIndex$macro$45 = (((!rhsMadeProgress$macro$42) && $n(input$macro$43).isReachable__I__Z(postRhsIndex$macro$37)) ? postLhsIndex$macro$35 : postRhsIndex$macro$37);
          if ((rhsMadeProgress$macro$42 && $n(evidence$15).checkForDrop__Z())) {
            $n(input$macro$43)
          };
          var res$macro$46 = $n(evidence$15).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$11).apply__O__O__O($as_s_Product(lhsValue$macro$44), $as_s_Option($n(evidence$15).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$45)
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$15).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$34, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$41, rhsMsg$macro$40), $n(lhsAggregate$macro$38).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$39), (preRhsIndex$macro$36 === $n(evidence$15).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$65 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$68 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$71 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$65 > preLhsIndex$macro$64) && $n(evidence$15).checkForDrop__Z())) {
      $n(input$macro$73)
    };
    var lhsValue$macro$74 = $n(evidence$15).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$15);
    if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$15).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$66 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        var this$23 = $m_Lfastparse_Implicits$Optioner$();
        var x1$21 = this$23.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$();
        var startPos$2 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        var startCut$2 = $n(evidence$15).Lfastparse_ParsingRun__f_cut;
        $n(evidence$15).Lfastparse_ParsingRun__f_cut = false;
        $m_Lfastparse_package$();
        $m_Lfastparse_Implicits$Sequencer$();
        var preLhsIndex$macro$49 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        var input$macro$58 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
        $m_Lfastparse_package$();
        var input$3 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
        var index$3 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        if ($n(input$3).isReachable__I__Z(index$3)) {
          var this$25 = $n(input$3);
          var this$26 = $n(this$25.Lfastparse_IndexedParserInput__f_data);
          var $$x6 = ($charAt(this$26, index$3) === 124)
        } else {
          var $$x6 = false
        };
        if ($$x6) {
          $n(evidence$15).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$3) | 0))
        } else {
          $n(evidence$15).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$15).aggregateTerminal__I__F0__V(index$3, new $c_sjsr_AnonFunction0((() => "\"|\"")))
        };
        if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
          /*<skip>*/
        } else {
          var postLhsIndex$macro$50 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
          var lhsAggregate$macro$53 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var lhsMsg$macro$56 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
          $n(evidence$15).Lfastparse_ParsingRun__f_cut = true;
          if (((postLhsIndex$macro$50 > preLhsIndex$macro$49) && $n(evidence$15).checkForDrop__Z())) {
            $n(input$macro$58)
          };
          $n(evidence$15);
          $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$15);
          if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
            if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$15).Lfastparse_ParsingRun__f_cut)) {
              /*<skip>*/
            } else {
              var preRhsIndex$macro$51 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
              $m_Lreactbuild_format_iz2use_Expressions$().absoluteLength__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$15);
              var rhsAggregate$macro$54 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$55 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
                $n(evidence$15).Lfastparse_ParsingRun__f_cut = true;
                var res$macro$61 = evidence$15
              } else {
                var postRhsIndex$macro$52 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$57 = (postRhsIndex$macro$52 > preRhsIndex$macro$51);
                var nextIndex$macro$60 = (((!rhsMadeProgress$macro$57) && $n(input$macro$58).isReachable__I__Z(postRhsIndex$macro$52)) ? postLhsIndex$macro$50 : postRhsIndex$macro$52);
                if ((rhsMadeProgress$macro$57 && $n(evidence$15).checkForDrop__Z())) {
                  $n(input$macro$58)
                };
                var $$x7 = $n(evidence$15);
                var ev$1 = $n(evidence$15).Lfastparse_ParsingRun__f_successValue;
                var v$2 = new $c_Leu_timepit_refined_api_Refined(((ev$1 === null) ? null : $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(ev$1)).Leu_timepit_refined_api_Refined__f_value)));
                var res$macro$61 = $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(v$2, nextIndex$macro$60)
              };
              if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$15).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$49, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$56, rhsMsg$macro$55), $n(lhsAggregate$macro$53).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$54), (preRhsIndex$macro$51 === $n(evidence$15).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          }
        };
        var postSuccess$2 = $n(evidence$15).Lfastparse_ParsingRun__f_isSuccess;
        if (postSuccess$2) {
          var $$x8 = $n(evidence$15);
          $n(x1$21);
          var ev$2 = $n(evidence$15).Lfastparse_ParsingRun__f_successValue;
          var value$1 = new $c_Leu_timepit_refined_api_Refined(((ev$2 === null) ? null : $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(ev$2)).Leu_timepit_refined_api_Refined__f_value)));
          var res$7 = $n($$x8).freshSuccess__O__Lfastparse_ParsingRun(new $c_s_Some(value$1));
          $n(res$7).Lfastparse_ParsingRun__f_cut = (!(!($n(res$7).Lfastparse_ParsingRun__f_cut | startCut$2)))
        } else if ($n(evidence$15).Lfastparse_ParsingRun__f_cut) {
          /*<skip>*/
        } else {
          var res$8 = $n(evidence$15).freshSuccess__O__I__Lfastparse_ParsingRun(($n(x1$21), $m_s_None$()), startPos$2);
          $n(res$8).Lfastparse_ParsingRun__f_cut = (!(!($n(res$8).Lfastparse_ParsingRun__f_cut | startCut$2)))
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          var msg$2 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
          var agg$2 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ((!postSuccess$2)) {
            $n(evidence$15).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos$2, new $c_sjsr_AnonFunction0((() => {
              var this$31 = $n(msg$2);
              return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$31.Lfastparse_internal_Msgs__f_value) + ".?")
            })), agg$2)
          }
        };
        var rhsAggregate$macro$69 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$70 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$76 = evidence$15
        } else {
          var postRhsIndex$macro$67 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$72 = (postRhsIndex$macro$67 > preRhsIndex$macro$66);
          var nextIndex$macro$75 = (((!rhsMadeProgress$macro$72) && $n(input$macro$73).isReachable__I__Z(postRhsIndex$macro$67)) ? postLhsIndex$macro$65 : postRhsIndex$macro$67);
          if ((rhsMadeProgress$macro$72 && $n(evidence$15).checkForDrop__Z())) {
            $n(input$macro$73)
          };
          var res$macro$76 = $n(evidence$15).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$9).apply__O__O__O($as_T2(lhsValue$macro$74), $as_s_Option($n(evidence$15).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$75)
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$15).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$64, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$71, rhsMsg$macro$70), $n(lhsAggregate$macro$68).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$69), (preRhsIndex$macro$66 === $n(evidence$15).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$80 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$83 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$86 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$80 > preLhsIndex$macro$79) && $n(evidence$15).checkForDrop__Z())) {
      $n(input$macro$88)
    };
    var lhsValue$macro$89 = $n(evidence$15).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$15);
    if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$15).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$81 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        var input$4 = $n(evidence$15).Lfastparse_ParsingRun__f_input;
        var index$4 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        if ($n(input$4).isReachable__I__Z(index$4)) {
          var this$33 = $n(input$4);
          var this$34 = $n(this$33.Lfastparse_IndexedParserInput__f_data);
          var $$x9 = ($charAt(this$34, index$4) === 58)
        } else {
          var $$x9 = false
        };
        if ($$x9) {
          $n(evidence$15).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$4) | 0))
        } else {
          $n(evidence$15).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$15).aggregateTerminal__I__F0__V(index$4, new $c_sjsr_AnonFunction0((() => "\":\"")))
        };
        var rhsAggregate$macro$84 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$85 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$91 = evidence$15
        } else {
          var postRhsIndex$macro$82 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$87 = (postRhsIndex$macro$82 > preRhsIndex$macro$81);
          var nextIndex$macro$90 = (((!rhsMadeProgress$macro$87) && $n(input$macro$88).isReachable__I__Z(postRhsIndex$macro$82)) ? postLhsIndex$macro$80 : postRhsIndex$macro$82);
          if ((rhsMadeProgress$macro$87 && $n(evidence$15).checkForDrop__Z())) {
            $n(input$macro$88)
          };
          var $$x10 = $n(evidence$15);
          $n(x1$7);
          var t = $as_T3(lhsValue$macro$89);
          $n(evidence$15);
          var res$macro$91 = $n($$x10).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$90)
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$15).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$79, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$86, rhsMsg$macro$85), $n(lhsAggregate$macro$83).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$84), (preRhsIndex$macro$81 === $n(evidence$15).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$95 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$98 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$101 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$15).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$95 > preLhsIndex$macro$94) && $n(evidence$15).checkForDrop__Z())) {
      $n(input$macro$103)
    };
    var lhsValue$macro$104 = $n(evidence$15).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$15);
    if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$15).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$96 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        this.componentColumns__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$15);
        var rhsAggregate$macro$99 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$100 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$15).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$106 = evidence$15
        } else {
          var postRhsIndex$macro$97 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$102 = (postRhsIndex$macro$97 > preRhsIndex$macro$96);
          var nextIndex$macro$105 = (((!rhsMadeProgress$macro$102) && $n(input$macro$103).isReachable__I__Z(postRhsIndex$macro$97)) ? postLhsIndex$macro$95 : postRhsIndex$macro$97);
          if ((rhsMadeProgress$macro$102 && $n(evidence$15).checkForDrop__Z())) {
            $n(input$macro$103)
          };
          var res$macro$106 = $n(evidence$15).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$5).apply__O__O__O($as_T3(lhsValue$macro$104), $as_sci_List($n(evidence$15).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$105)
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$15).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$94, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$101, rhsMsg$macro$100), $n(lhsAggregate$macro$98).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$99), (preRhsIndex$macro$96 === $n(evidence$15).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$26 = evidence$15
  } else {
    var postLhsIndex$macro$110 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$113 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$116 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$110 > preLhsIndex$macro$109) && $n(evidence$15).checkForDrop__Z())) {
      $n(input$macro$118)
    };
    var lhsValue$macro$119 = $n(evidence$15).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$15);
    if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$15).Lfastparse_ParsingRun__f_cut)) {
        var x1$26 = evidence$15
      } else {
        var preRhsIndex$macro$111 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$15);
        var rhsAggregate$macro$114 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$115 = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$121 = evidence$15
        } else {
          var postRhsIndex$macro$112 = $n(evidence$15).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$117 = (postRhsIndex$macro$112 > preRhsIndex$macro$111);
          var nextIndex$macro$120 = (((!rhsMadeProgress$macro$117) && $n(input$macro$118).isReachable__I__Z(postRhsIndex$macro$112)) ? postLhsIndex$macro$110 : postRhsIndex$macro$112);
          if ((rhsMadeProgress$macro$117 && $n(evidence$15).checkForDrop__Z())) {
            $n(input$macro$118)
          };
          var $$x11 = $n(evidence$15);
          $n(x1$3);
          var t$1 = $as_T4(lhsValue$macro$119);
          $n(evidence$15);
          var res$macro$121 = $n($$x11).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$120)
        };
        if ($n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$15).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$109, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$116, rhsMsg$macro$115), $n(lhsAggregate$macro$113).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$114), (preRhsIndex$macro$111 === $n(evidence$15).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$26 = res$macro$121
      }
    } else {
      var x1$26 = evidence$15
    }
  };
  if (instrument) {
    $n($n(evidence$15).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("componentGroup").Lsourcecode_Name__f_value, $n(x1$26).Lfastparse_ParsingRun__f_index, $n(x1$26).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$26).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x12 = $n(x1$26);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("componentGroup").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x12).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$26).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$26).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$26).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x13 = $n(x1$26);
      var self = new $c_Lsourcecode_Name("componentGroup").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$45 = $n($n(x1$26).Lfastparse_ParsingRun__f_failureStack);
      $$x13.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$45)
    }
  };
  if ((!$n(x1$26).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$26
  } else {
    var $$x14 = $n(x1$26);
    var this$47 = $m_Lreactbuild_format_iz2use_package$ComponentGroup$();
    $$x14.Lfastparse_ParsingRun__f_successValue = $n($f_F4__tupled__F1(this$47)).apply__O__O($as_T4($n(x1$26).Lfastparse_ParsingRun__f_successValue));
    return x1$26
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.sidesLine__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$16) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$16).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$16).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$16).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("sidesLine").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$13 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
  var input$macro$22 = $n(evidence$16).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  this.edges__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$16);
  if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$6 = evidence$16
  } else {
    var postLhsIndex$macro$14 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$17 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$20 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$14 > preLhsIndex$macro$13) && $n(evidence$16).checkForDrop__Z())) {
      $n(input$macro$22)
    };
    var lhsValue$macro$23 = $n(evidence$16).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$16);
    if ($n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$16).Lfastparse_ParsingRun__f_cut)) {
        var x1$6 = evidence$16
      } else {
        var preRhsIndex$macro$15 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
        var this$3 = $m_Lreactbuild_format_iz2use_Repeater$();
        var x1$5 = this$3.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
        var elem = $n(evidence$16).Lfastparse_ParsingRun__f_cut;
        var elem$1 = false;
        elem$1 = elem;
        $n(x1$5);
        var acc$macro$3 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
        var startIndex$macro$4 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
        var count$macro$5 = 0;
        var lastAgg$macro$10 = null;
        while (true) {
          $n(evidence$16).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 0));
          $m_Lfastparse_package$();
          $m_Lreactbuild_format_iz2use_Parser$().componentGroup__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$16);
          var parsedMsg$macro$9 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$11 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$1 = (!(!(elem$1 | $n(evidence$16).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
            var res = ($n(evidence$16).Lfastparse_ParsingRun__f_cut ? evidence$16 : ((count$macro$5 < 0) ? $n(evidence$16).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$16).freshSuccess__O__I__Z__Lfastparse_ParsingRun(($n(x1$5), $n(acc$macro$3).toList__sci_List()), startIndex$macro$4, elem$1)));
            if ($n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x4 = $n(evidence$16);
              var $$x3 = startIndex$macro$4;
              var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
                var this$8 = $n(parsedMsg$macro$9);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".rep")
              }))(parsedMsg$macro$9));
              if ((lastAgg$macro$10 === null)) {
                var $$x1 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$1 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x1 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
              };
              $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x3, $$x2, $$x1)
            };
            break
          } else {
            var beforeSepIndex$macro$6 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
            $n(x1$5);
            var t = $as_Lreactbuild_format_iz2use_package$ComponentGroup($n(evidence$16).Lfastparse_ParsingRun__f_successValue);
            var this$10 = $n(acc$macro$3);
            this$10.addOne__O__scm_Growable(t);
            $n(evidence$16).Lfastparse_ParsingRun__f_cut = false;
            if ((this.whitespace__F1() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$16)
            };
            if (((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$16).Lfastparse_ParsingRun__f_cut)) {
              break
            } else {
              $n(evidence$16).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$5 = ((1 + count$macro$5) | 0);
              startIndex$macro$4 = beforeSepIndex$macro$6;
              count$macro$5 = temp$count$macro$5;
              lastAgg$macro$10 = parsedAgg$macro$11
            }
          }
        };
        var rhsAggregate$macro$18 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$19 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$25 = evidence$16
        } else {
          var postRhsIndex$macro$16 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$21 = (postRhsIndex$macro$16 > preRhsIndex$macro$15);
          var nextIndex$macro$24 = (((!rhsMadeProgress$macro$21) && $n(input$macro$22).isReachable__I__Z(postRhsIndex$macro$16)) ? postLhsIndex$macro$14 : postRhsIndex$macro$16);
          if ((rhsMadeProgress$macro$21 && $n(evidence$16).checkForDrop__Z())) {
            $n(input$macro$22)
          };
          var res$macro$25 = $n(evidence$16).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($as_sci_List(lhsValue$macro$23), $as_sci_List($n(evidence$16).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$24)
        };
        if ($n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$16).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$13, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$20, rhsMsg$macro$19), $n(lhsAggregate$macro$17).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$18), (preRhsIndex$macro$15 === $n(evidence$16).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$6 = res$macro$25
      }
    } else {
      var x1$6 = evidence$16
    }
  };
  if (instrument) {
    $n($n(evidence$16).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("sidesLine").Lsourcecode_Name__f_value, $n(x1$6).Lfastparse_ParsingRun__f_index, $n(x1$6).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$6).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$6);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("sidesLine").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$6).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$6).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$6).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$6);
      var self = new $c_Lsourcecode_Name("sidesLine").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$18 = $n($n(x1$6).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$18)
    }
  };
  if ((!$n(x1$6).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$6
  } else {
    var $$x9 = $n(x1$6);
    var arg1 = $as_T2($n(x1$6).Lfastparse_ParsingRun__f_successValue);
    matchEnd5: {
      var $$x7;
      if ((arg1 !== null)) {
        var p2 = $as_sci_List($n(arg1)._1__O());
        var componentGroups = $as_sci_List($n(arg1)._2__O());
        if ((p2 !== null)) {
          var o8 = $n($m_s_package$().s_package$__f_$colon$plus).unapply__sc_SeqOps__s_Option(p2);
          if ((!$n(o8).isEmpty__Z())) {
            var init = $as_sci_List($n($as_T2($n(o8).get__O()))._1__O());
            var last = $as_Lreactbuild_format_iz2use_package$Vector2D($n($as_T2($n(o8).get__O()))._2__O());
            var this$21 = $n(init);
            var f = ((x$8$2) => {
              var x$8 = $as_Lreactbuild_format_iz2use_package$Vector2D(x$8$2);
              return new $c_Lreactbuild_format_iz2use_package$Side(x$8, $m_s_package$().s_package$__f_Nil)
            });
            if ((this$21 === $m_sci_Nil$())) {
              var $$x8 = $m_sci_Nil$()
            } else {
              var arg1$1 = this$21.head__O();
              var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
              var t$1 = h;
              var rest = $as_sci_List(this$21.tail__O());
              while ((rest !== $m_sci_Nil$())) {
                var arg1$2 = $n(rest).head__O();
                var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
                $n(t$1).sci_$colon$colon__f_next = nx;
                t$1 = nx;
                rest = $as_sci_List($n(rest).tail__O())
              };
              var $$x8 = h
            };
            var this$22 = $n($$x8);
            var elem$2 = new $c_Lreactbuild_format_iz2use_package$Side(last, componentGroups);
            var $$x7 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$22, elem$2));
            break matchEnd5
          }
        }
      };
      throw new $c_s_MatchError(arg1)
    };
    $$x9.Lfastparse_ParsingRun__f_successValue = $$x7;
    return x1$6
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.sides__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$17) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$17).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$17).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$17).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("sides").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lreactbuild_format_iz2use_Repeater$();
  var x1$3 = this$1.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
  var elem = $n(evidence$17).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  $n(x1$3);
  var acc$macro$3 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
  var startIndex$macro$4 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
  var count$macro$5 = 0;
  var lastAgg$macro$10 = null;
  var x1$4;
  while (true) {
    $n(evidence$17).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 1));
    $m_Lfastparse_package$();
    $m_Lreactbuild_format_iz2use_Parser$().sidesLine__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$17);
    var parsedMsg$macro$9 = $n(evidence$17).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$11 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$17).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = ($n(evidence$17).Lfastparse_ParsingRun__f_cut ? evidence$17 : ((count$macro$5 < 1) ? $n(evidence$17).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$17).freshSuccess__O__I__Z__Lfastparse_ParsingRun(($n(x1$3), $n(acc$macro$3).toList__sci_List()), startIndex$macro$4, elem$1)));
      if ($n(evidence$17).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x4 = $n(evidence$17);
        var $$x3 = startIndex$macro$4;
        var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
          var this$6 = $n(parsedMsg$macro$9);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
        }))(parsedMsg$macro$9));
        if ((lastAgg$macro$10 === null)) {
          var $$x1 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$1 = $n(evidence$17).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x1 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
        };
        $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x3, $$x2, $$x1)
      };
      var x1$4 = res;
      break
    } else {
      var beforeSepIndex$macro$6 = $n(evidence$17).Lfastparse_ParsingRun__f_index;
      $n(x1$3);
      var t = $as_sci_List($n(evidence$17).Lfastparse_ParsingRun__f_successValue);
      var this$8 = $n(acc$macro$3);
      this$8.addOne__O__scm_Growable(t);
      $n(evidence$17).Lfastparse_ParsingRun__f_cut = false;
      if ((this.whitespace__F1() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$17)
      };
      if ((!((!$n(evidence$17).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$17).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$17).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$5 = ((1 + count$macro$5) | 0);
        startIndex$macro$4 = beforeSepIndex$macro$6;
        count$macro$5 = temp$count$macro$5;
        lastAgg$macro$10 = parsedAgg$macro$11;
        continue
      };
      var x1$4 = evidence$17;
      break
    }
  };
  if (instrument) {
    $n($n(evidence$17).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("sides").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("sides").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("sides").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$16 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$16)
    }
  };
  if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$4
  } else {
    var $$x7 = $n(x1$4);
    var arg1 = $as_sci_List($n(x1$4).Lfastparse_ParsingRun__f_successValue);
    var this$20 = $n(arg1);
    var this$19 = $m_s_$less$colon$less$();
    var toIterableOnce = this$19.s_$less$colon$less$__f_singleton;
    $$x7.Lfastparse_ParsingRun__f_successValue = $as_sci_List($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$20, toIterableOnce));
    return x1$4
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.room__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$18) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$18).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$18).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("room").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.Lfastparse_Implicits$Sequencer$__f_BaseSequencer2;
  var preLhsIndex$macro$68 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var input$macro$77 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$53 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var input$macro$62 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$3 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$7 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$3));
  var preLhsIndex$macro$38 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var input$macro$47 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$4 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$9 = this$4.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$23 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var input$macro$32 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$8 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var input$macro$17 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var startPos = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
  var oldNoCut = $n(evidence$18).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$18).Lfastparse_ParsingRun__f_noDropBuffer = true;
  var startTerminals = $n(evidence$18).Lfastparse_ParsingRun__f_failureTerminalAggregate;
  var oldCut = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
  $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
  var startPos$1 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var oldCut$2 = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
  $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
  var startPos$2 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var oldCut$3 = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
  $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
  var startPos$3 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var index = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var end = ((2 + index) | 0);
  var input = $n(evidence$18).Lfastparse_ParsingRun__f_input;
  if ($n(input).isReachable__I__Z((((-1) + end) | 0))) {
    var this$8 = $n(input);
    var this$9 = $n(this$8.Lfastparse_IndexedParserInput__f_data);
    if (($charAt(this$9, index) === 32)) {
      var this$10 = $n(input);
      var index$1 = ((1 + index) | 0);
      var this$11 = $n(this$10.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$11, index$1) === 32)
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$18).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
  } else {
    $n(evidence$18).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$18).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"  \"")))
  };
  var lhsMsg = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$18).Lfastparse_ParsingRun__f_cut | oldCut$3)))
  } else if ($n(evidence$18).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures = $n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$18).Lfastparse_ParsingRun__f_index = startPos$3;
    if (verboseFailures) {
      var this$13 = $n(evidence$18);
      this$13.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
    var index$2 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
    var end$2 = ((2 + index$2) | 0);
    var input$2 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
    if ($n(input$2).isReachable__I__Z((((-1) + end$2) | 0))) {
      var this$14 = $n(input$2);
      var this$15 = $n(this$14.Lfastparse_IndexedParserInput__f_data);
      if (($charAt(this$15, index$2) === 94)) {
        var this$16 = $n(input$2);
        var index$3 = ((1 + index$2) | 0);
        var this$17 = $n(this$16.Lfastparse_IndexedParserInput__f_data);
        var $$x2 = ($charAt(this$17, index$3) === 94)
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      $n(evidence$18).freshSuccessUnit__I__Lfastparse_ParsingRun(end$2)
    } else {
      $n(evidence$18).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$18).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"^^\"")))
    };
    var rhsMsg = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut$3)));
    if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$18).freshFailure__I__Lfastparse_ParsingRun(startPos$3)
    };
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$18 = $n(evidence$18);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$18.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$3, msgToSet, msgToAggregate, false)
    }
  };
  var lhsMsg$2 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate$2 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$18).Lfastparse_ParsingRun__f_cut | oldCut$2)))
  } else if ($n(evidence$18).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures$2 = $n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$18).Lfastparse_ParsingRun__f_index = startPos$2;
    if (verboseFailures$2) {
      var this$20 = $n(evidence$18);
      this$20.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg$2, lhsAggregate$2, false)
    };
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
    var index$3$1 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
    var end$3 = ((2 + index$3$1) | 0);
    var input$3 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
    if ($n(input$3).isReachable__I__Z((((-1) + end$3) | 0))) {
      var this$21 = $n(input$3);
      var this$22 = $n(this$21.Lfastparse_IndexedParserInput__f_data);
      if (($charAt(this$22, index$3$1) === 45)) {
        var this$23 = $n(input$3);
        var index$4 = ((1 + index$3$1) | 0);
        var this$24 = $n(this$23.Lfastparse_IndexedParserInput__f_data);
        var $$x3 = ($charAt(this$24, index$4) === 45)
      } else {
        var $$x3 = false
      }
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      $n(evidence$18).freshSuccessUnit__I__Lfastparse_ParsingRun(end$3)
    } else {
      $n(evidence$18).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$18).aggregateTerminal__I__F0__V(index$3$1, new $c_sjsr_AnonFunction0((() => "\"--\"")))
    };
    var rhsMsg$2 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut$2 = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
    var endCut$2 = (!(!(rhsCut$2 | oldCut$2)));
    if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2))) {
      $n(evidence$18).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
    };
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = endCut$2;
    if (verboseFailures$2) {
      var this$25 = $n(evidence$18);
      var msgToSet$1 = $n(lhsMsg$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2);
      var rassoc$3$2 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate$1 = $n(lhsAggregate$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
      this$25.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet$1, msgToAggregate$1, false)
    }
  };
  var lhsMsg$3 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate$3 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$18).Lfastparse_ParsingRun__f_cut | oldCut)))
  } else if ((!$n(evidence$18).Lfastparse_ParsingRun__f_cut)) {
    var verboseFailures$3 = $n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$18).Lfastparse_ParsingRun__f_index = startPos$1;
    if (verboseFailures$3) {
      var this$27 = $n(evidence$18);
      this$27.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$1, lhsMsg$3, lhsAggregate$3, false)
    };
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
    var input$4 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
    var index$4$1 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
    if ($n(input$4).isReachable__I__Z(index$4$1)) {
      var this$28 = $n(input$4);
      var this$29 = $n(this$28.Lfastparse_IndexedParserInput__f_data);
      var $$x4 = ($charAt(this$29, index$4$1) === 123)
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      $n(evidence$18).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$4$1) | 0))
    } else {
      $n(evidence$18).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$18).aggregateTerminal__I__F0__V(index$4$1, new $c_sjsr_AnonFunction0((() => "\"{\"")))
    };
    var rhsMsg$3 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut$3 = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
    var endCut$3 = (!(!(rhsCut$3 | oldCut)));
    if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$3))) {
      $n(evidence$18).freshFailure__I__Lfastparse_ParsingRun(startPos$1)
    };
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = endCut$3;
    if (verboseFailures$3) {
      var this$30 = $n(evidence$18);
      var msgToSet$2 = $n(lhsMsg$3).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$3);
      var rassoc$3$3 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate$2 = $n(lhsAggregate$3).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$3);
      this$30.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$1, msgToSet$2, msgToAggregate$2, false)
    }
  };
  $n(evidence$18).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
  var msg = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
  var res$1 = ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$18).freshFailure__I__Lfastparse_ParsingRun(startPos) : $n(evidence$18).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos));
  if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$18).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
    $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
    $n(evidence$18).setMsg__I__F0__V(startPos, new $c_sjsr_AnonFunction0((() => {
      var this$31 = $n(msg);
      return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$31.Lfastparse_internal_Msgs__f_value))
    })))
  };
  $n(res$1).Lfastparse_ParsingRun__f_cut = startCut;
  if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$9 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$12 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$15 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$9 > preLhsIndex$macro$8) && $n(evidence$18).checkForDrop__Z())) {
      $n(input$macro$17)
    };
    $n(evidence$18);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$18);
    if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$18).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$10 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
        var startIndex$1 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
        var instrument$1 = ($n(evidence$18).Lfastparse_ParsingRun__f_instrument !== null);
        if (instrument$1) {
          $n($n(evidence$18).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, startIndex$1)
        };
        var startPos$4 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
        var oldCapturing = $n(evidence$18).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$18).Lfastparse_ParsingRun__f_noDropBuffer = true;
        $m_Lfastparse_package$();
        var elem = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
        var elem$1 = false;
        elem$1 = elem;
        var startIndex$macro$19 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
        var count$macro$20 = 0;
        var lastAgg$macro$25 = null;
        while (true) {
          $n(evidence$18).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$20 < 1));
          $m_Lfastparse_package$();
          $m_Lfastparse_Implicits$Sequencer$();
          var preLhsIndex$macro$2 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
          var input$macro$11 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$();
          var startPos$5 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
          var startCut$1 = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
          var oldNoCut$1 = $n(evidence$18).Lfastparse_ParsingRun__f_noDropBuffer;
          $n(evidence$18).Lfastparse_ParsingRun__f_noDropBuffer = true;
          var startTerminals$1 = $n(evidence$18).Lfastparse_ParsingRun__f_failureTerminalAggregate;
          var oldCut$1 = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
          $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
          var startPos$6 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          var oldCut$2$1 = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
          $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
          var startPos$2$1 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$18);
          var lhsMsg$1 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$1 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$18).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$18).Lfastparse_ParsingRun__f_cut | oldCut$2$1)))
          } else if ($n(evidence$18).Lfastparse_ParsingRun__f_cut) {
            /*<skip>*/
          } else {
            var verboseFailures$1 = $n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$18).Lfastparse_ParsingRun__f_index = startPos$2$1;
            if (verboseFailures$1) {
              var this$40 = $n(evidence$18);
              this$40.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, lhsMsg$1, lhsAggregate$1, false)
            };
            $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
            $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$18);
            var rhsMsg$1 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$1 = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
            var endCut$1 = (!(!(rhsCut$1 | oldCut$2$1)));
            if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$1))) {
              $n(evidence$18).freshFailure__I__Lfastparse_ParsingRun(startPos$2$1)
            };
            $n(evidence$18).Lfastparse_ParsingRun__f_cut = endCut$1;
            if (verboseFailures$1) {
              var this$41 = $n(evidence$18);
              var msgToSet$3 = $n(lhsMsg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$1);
              var rassoc$3$1 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$3 = $n(lhsAggregate$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$1);
              this$41.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, msgToSet$3, msgToAggregate$3, false)
            }
          };
          var lhsMsg$2$1 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$2$1 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$18).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$18).Lfastparse_ParsingRun__f_cut | oldCut$1)))
          } else if ((!$n(evidence$18).Lfastparse_ParsingRun__f_cut)) {
            var verboseFailures$2$1 = $n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$18).Lfastparse_ParsingRun__f_index = startPos$6;
            if (verboseFailures$2$1) {
              var this$43 = $n(evidence$18);
              this$43.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$6, lhsMsg$2$1, lhsAggregate$2$1, false)
            };
            $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
            var input$1 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
            var index$5 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
            if ($n(input$1).isReachable__I__Z(index$5)) {
              var this$44 = $n(input$1);
              var this$45 = $n(this$44.Lfastparse_IndexedParserInput__f_data);
              var $$x5 = ($charAt(this$45, index$5) === 58)
            } else {
              var $$x5 = false
            };
            if ($$x5) {
              $n(evidence$18).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$5) | 0))
            } else {
              $n(evidence$18).freshFailure__Lfastparse_ParsingRun()
            };
            if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
              $n(evidence$18).aggregateTerminal__I__F0__V(index$5, new $c_sjsr_AnonFunction0((() => "\":\"")))
            };
            var rhsMsg$2$1 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$2$1 = $n(evidence$18).Lfastparse_ParsingRun__f_cut;
            var endCut$2$1 = (!(!(rhsCut$2$1 | oldCut$1)));
            if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2$1))) {
              $n(evidence$18).freshFailure__I__Lfastparse_ParsingRun(startPos$6)
            };
            $n(evidence$18).Lfastparse_ParsingRun__f_cut = endCut$2$1;
            if (verboseFailures$2$1) {
              var this$47 = $n(evidence$18);
              var msgToSet$4 = $n(lhsMsg$2$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2$1);
              var rassoc$3$2$1 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$4 = $n(lhsAggregate$2$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2$1);
              this$47.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$6, msgToSet$4, msgToAggregate$4, false)
            }
          };
          $n(evidence$18).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut$1;
          var msg$1 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
          var res$6 = ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$18).freshFailure__I__Lfastparse_ParsingRun(startPos$5) : $n(evidence$18).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$5));
          if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$18).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals$1;
            $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
            $n(evidence$18).setMsg__I__F0__V(startPos$5, new $c_sjsr_AnonFunction0(((msg$1) => (() => {
              var this$48 = $n(msg$1);
              return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$48.Lfastparse_internal_Msgs__f_value))
            }))(msg$1)))
          };
          $n(res$6).Lfastparse_ParsingRun__f_cut = startCut$1;
          if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$3 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$6 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$9 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
            if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$18).checkForDrop__Z())) {
              $n(input$macro$11)
            };
            $n(evidence$18);
            if ((!((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$18).Lfastparse_ParsingRun__f_cut))) {
              var preRhsIndex$macro$4 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
              $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$18);
              var rhsAggregate$macro$7 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$8 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
                /*<skip>*/
              } else {
                var postRhsIndex$macro$5 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
                var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
                if ((rhsMadeProgress$macro$10 && $n(evidence$18).checkForDrop__Z())) {
                  $n(input$macro$11)
                };
                var $$x6 = $n(evidence$18);
                $n(evidence$18);
                var v = (void 0);
                $n($$x6).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
              };
              if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$18).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$18).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          };
          var parsedMsg$macro$24 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$26 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$1 = (!(!(elem$1 | $n(evidence$18).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$7 = ($n(evidence$18).Lfastparse_ParsingRun__f_cut ? evidence$18 : ((count$macro$20 < 1) ? $n(evidence$18).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19, elem$1) : $n(evidence$18).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19, elem$1)));
            if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x10 = $n(evidence$18);
              var $$x9 = startIndex$macro$19;
              var $$x8 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
                var this$50 = $n(parsedMsg$macro$24);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$50.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$macro$24));
              if ((lastAgg$macro$25 === null)) {
                var $$x7 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$2 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x7 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
              };
              $n($$x10).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x9, $$x8, $$x7)
            };
            break
          } else {
            var beforeSepIndex$macro$21 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
            $n(evidence$18);
            $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
            if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$18)
            };
            if ((!((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$18).Lfastparse_ParsingRun__f_cut))) {
              $n(evidence$18).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$20 = ((1 + count$macro$20) | 0);
              startIndex$macro$19 = beforeSepIndex$macro$21;
              count$macro$20 = temp$count$macro$20;
              lastAgg$macro$25 = parsedAgg$macro$26;
              continue
            };
            break
          }
        };
        $n(evidence$18).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
        var x1$5$1 = ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) ? evidence$18 : $n(evidence$18).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$18).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$4, $n(evidence$18).Lfastparse_ParsingRun__f_index)));
        if (instrument$1) {
          $n($n(evidence$18).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, $n(x1$5$1).Lfastparse_ParsingRun__f_index, $n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)
        };
        if ($n(x1$5$1).Lfastparse_ParsingRun__f_verboseFailures) {
          var $$x11 = $n(x1$5$1);
          $m_sci_List$();
          var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value)))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          $n($$x11).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex$1, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5$1).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex$1 < $n(x1$5$1).Lfastparse_ParsingRun__f_traceIndex));
          if ((!$n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)) {
            var $$x12 = $n(x1$5$1);
            var self = new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value;
            var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex$1);
            var this$58 = $n($n(x1$5$1).Lfastparse_ParsingRun__f_failureStack);
            $$x12.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$58)
          }
        };
        var rhsAggregate$macro$13 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$14 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$20 = evidence$18
        } else {
          var postRhsIndex$macro$11 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$16 = (postRhsIndex$macro$11 > preRhsIndex$macro$10);
          var nextIndex$macro$19 = (((!rhsMadeProgress$macro$16) && $n(input$macro$17).isReachable__I__Z(postRhsIndex$macro$11)) ? postLhsIndex$macro$9 : postRhsIndex$macro$11);
          if ((rhsMadeProgress$macro$16 && $n(evidence$18).checkForDrop__Z())) {
            $n(input$macro$17)
          };
          var $$x13 = $n(evidence$18);
          var v$1 = $as_T($n(evidence$18).Lfastparse_ParsingRun__f_successValue);
          var res$macro$20 = $n($$x13).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$19)
        };
        if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$18).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$8, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$15, rhsMsg$macro$14), $n(lhsAggregate$macro$12).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$13), (preRhsIndex$macro$10 === $n(evidence$18).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$24 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$27 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$30 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$24 > preLhsIndex$macro$23) && $n(evidence$18).checkForDrop__Z())) {
      $n(input$macro$32)
    };
    var lhsValue$macro$33 = $n(evidence$18).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$18);
    if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$18).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$25 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
        var input$5 = $n(evidence$18).Lfastparse_ParsingRun__f_input;
        var index$6 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
        if ($n(input$5).isReachable__I__Z(index$6)) {
          var this$60 = $n(input$5);
          var this$61 = $n(this$60.Lfastparse_IndexedParserInput__f_data);
          var $$x14 = ($charAt(this$61, index$6) === 58)
        } else {
          var $$x14 = false
        };
        if ($$x14) {
          $n(evidence$18).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$6) | 0))
        } else {
          $n(evidence$18).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$18).aggregateTerminal__I__F0__V(index$6, new $c_sjsr_AnonFunction0((() => "\":\"")))
        };
        var rhsAggregate$macro$28 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$29 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$35 = evidence$18
        } else {
          var postRhsIndex$macro$26 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$31 = (postRhsIndex$macro$26 > preRhsIndex$macro$25);
          var nextIndex$macro$34 = (((!rhsMadeProgress$macro$31) && $n(input$macro$32).isReachable__I__Z(postRhsIndex$macro$26)) ? postLhsIndex$macro$24 : postRhsIndex$macro$26);
          if ((rhsMadeProgress$macro$31 && $n(evidence$18).checkForDrop__Z())) {
            $n(input$macro$32)
          };
          var $$x15 = $n(evidence$18);
          $n(x1$9);
          var t = $as_T(lhsValue$macro$33);
          $n(evidence$18);
          var res$macro$35 = $n($$x15).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$34)
        };
        if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$18).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$23, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$30, rhsMsg$macro$29), $n(lhsAggregate$macro$27).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$28), (preRhsIndex$macro$25 === $n(evidence$18).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$39 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$42 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$45 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$18).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$39 > preLhsIndex$macro$38) && $n(evidence$18).checkForDrop__Z())) {
      $n(input$macro$47)
    };
    var lhsValue$macro$48 = $n(evidence$18).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$18);
    if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$18).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$40 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
        this.point__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$18);
        var rhsAggregate$macro$43 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$44 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$18).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$50 = evidence$18
        } else {
          var postRhsIndex$macro$41 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$46 = (postRhsIndex$macro$41 > preRhsIndex$macro$40);
          var nextIndex$macro$49 = (((!rhsMadeProgress$macro$46) && $n(input$macro$47).isReachable__I__Z(postRhsIndex$macro$41)) ? postLhsIndex$macro$39 : postRhsIndex$macro$41);
          if ((rhsMadeProgress$macro$46 && $n(evidence$18).checkForDrop__Z())) {
            $n(input$macro$47)
          };
          var res$macro$50 = $n(evidence$18).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$7).apply__O__O__O($as_T(lhsValue$macro$48), $as_Lreactbuild_format_iz2use_package$Vector2D($n(evidence$18).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$49)
        };
        if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$18).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$38, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$45, rhsMsg$macro$44), $n(lhsAggregate$macro$42).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$43), (preRhsIndex$macro$40 === $n(evidence$18).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$54 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$57 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$60 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$54 > preLhsIndex$macro$53) && $n(evidence$18).checkForDrop__Z())) {
      $n(input$macro$62)
    };
    var lhsValue$macro$63 = $n(evidence$18).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$18);
    if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$18).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$55 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$18);
        var rhsAggregate$macro$58 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$59 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$65 = evidence$18
        } else {
          var postRhsIndex$macro$56 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$61 = (postRhsIndex$macro$56 > preRhsIndex$macro$55);
          var nextIndex$macro$64 = (((!rhsMadeProgress$macro$61) && $n(input$macro$62).isReachable__I__Z(postRhsIndex$macro$56)) ? postLhsIndex$macro$54 : postRhsIndex$macro$56);
          if ((rhsMadeProgress$macro$61 && $n(evidence$18).checkForDrop__Z())) {
            $n(input$macro$62)
          };
          var $$x16 = $n(evidence$18);
          $n(x1$5);
          var t$1 = $as_T2(lhsValue$macro$63);
          $n(evidence$18);
          var res$macro$65 = $n($$x16).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$64)
        };
        if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$18).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$53, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$60, rhsMsg$macro$59), $n(lhsAggregate$macro$57).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$58), (preRhsIndex$macro$55 === $n(evidence$18).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$13 = evidence$18
  } else {
    var postLhsIndex$macro$69 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$72 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$75 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$69 > preLhsIndex$macro$68) && $n(evidence$18).checkForDrop__Z())) {
      $n(input$macro$77)
    };
    var lhsValue$macro$78 = $n(evidence$18).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$18);
    if ($n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$18).Lfastparse_ParsingRun__f_cut)) {
        var x1$13 = evidence$18
      } else {
        var preRhsIndex$macro$70 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
        this.sides__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$18);
        var rhsAggregate$macro$73 = $n(evidence$18).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$74 = $n(evidence$18).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$18).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$80 = evidence$18
        } else {
          var postRhsIndex$macro$71 = $n(evidence$18).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$76 = (postRhsIndex$macro$71 > preRhsIndex$macro$70);
          var nextIndex$macro$79 = (((!rhsMadeProgress$macro$76) && $n(input$macro$77).isReachable__I__Z(postRhsIndex$macro$71)) ? postLhsIndex$macro$69 : postRhsIndex$macro$71);
          if ((rhsMadeProgress$macro$76 && $n(evidence$18).checkForDrop__Z())) {
            $n(input$macro$77)
          };
          var res$macro$80 = $n(evidence$18).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($as_T2(lhsValue$macro$78), $as_sci_List($n(evidence$18).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$79)
        };
        if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$18).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$68, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$75, rhsMsg$macro$74), $n(lhsAggregate$macro$72).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$73), (preRhsIndex$macro$70 === $n(evidence$18).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$13 = res$macro$80
      }
    } else {
      var x1$13 = evidence$18
    }
  };
  if (instrument) {
    $n($n(evidence$18).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("room").Lsourcecode_Name__f_value, $n(x1$13).Lfastparse_ParsingRun__f_index, $n(x1$13).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$13).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x17 = $n(x1$13);
    $m_sci_List$();
    var array$1 = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("room").Lsourcecode_Name__f_value)))];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $n($$x17).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)), $n(x1$13).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$13).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$13).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x18 = $n(x1$13);
      var self$1 = new $c_Lsourcecode_Name("room").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self$1, startIndex);
      var this$73 = $n($n(x1$13).Lfastparse_ParsingRun__f_failureStack);
      $$x18.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$73)
    }
  };
  if ((!$n(x1$13).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$13
  } else {
    var $$x19 = $n(x1$13);
    var this$75 = $m_Lreactbuild_format_iz2use_package$Room$();
    $$x19.Lfastparse_ParsingRun__f_successValue = $n($f_F3__tupled__F1(this$75)).apply__O__O($as_T3($n(x1$13).Lfastparse_ParsingRun__f_successValue));
    return x1$13
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.rooms__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$19) {
  var startIndex = $n(evidence$19).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$19).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$19).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("rooms").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lreactbuild_format_iz2use_Repeater$();
  var x1$3 = this$1.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
  var elem = $n(evidence$19).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  $n(x1$3);
  var acc$macro$3 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
  var startIndex$macro$4 = $n(evidence$19).Lfastparse_ParsingRun__f_index;
  var count$macro$5 = 0;
  var lastAgg$macro$10 = null;
  var x1$4;
  while (true) {
    $n(evidence$19).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 0));
    $m_Lfastparse_package$();
    $m_Lreactbuild_format_iz2use_Parser$().room__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$19);
    var parsedMsg$macro$9 = $n(evidence$19).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$11 = $n(evidence$19).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$19).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$19).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = ($n(evidence$19).Lfastparse_ParsingRun__f_cut ? evidence$19 : ((count$macro$5 < 0) ? $n(evidence$19).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$19).freshSuccess__O__I__Z__Lfastparse_ParsingRun(($n(x1$3), $n(acc$macro$3).toList__sci_List()), startIndex$macro$4, elem$1)));
      if ($n(evidence$19).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x4 = $n(evidence$19);
        var $$x3 = startIndex$macro$4;
        var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
          var this$6 = $n(parsedMsg$macro$9);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep")
        }))(parsedMsg$macro$9));
        if ((lastAgg$macro$10 === null)) {
          var $$x1 = $n(evidence$19).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$1 = $n(evidence$19).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x1 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
        };
        $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x3, $$x2, $$x1)
      };
      var x1$4 = res;
      break
    } else {
      var beforeSepIndex$macro$6 = $n(evidence$19).Lfastparse_ParsingRun__f_index;
      $n(x1$3);
      var t = $as_Lreactbuild_format_iz2use_package$Room($n(evidence$19).Lfastparse_ParsingRun__f_successValue);
      var this$8 = $n(acc$macro$3);
      this$8.addOne__O__scm_Growable(t);
      $n(evidence$19).Lfastparse_ParsingRun__f_cut = false;
      if ((this.whitespace__F1() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$19)
      };
      if ((!((!$n(evidence$19).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$19).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$19).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$5 = ((1 + count$macro$5) | 0);
        startIndex$macro$4 = beforeSepIndex$macro$6;
        count$macro$5 = temp$count$macro$5;
        lastAgg$macro$10 = parsedAgg$macro$11;
        continue
      };
      var x1$4 = evidence$19;
      break
    }
  };
  if (instrument) {
    $n($n(evidence$19).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("rooms").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("rooms").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("rooms").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$16 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$16)
    }
  };
  return x1$4
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.storey__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$20) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$20).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$20).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$20).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("storey").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.Lfastparse_Implicits$Sequencer$__f_BaseSequencer2;
  var preLhsIndex$macro$32 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
  var input$macro$41 = $n(evidence$20).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$2));
  var preLhsIndex$macro$17 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$20).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$20).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  this.materials__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$20);
  if ((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$20).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$20).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$20).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$20);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$20);
    if ($n(evidence$20).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$20).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$4 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
        this.sides__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$20);
        var rhsAggregate$macro$7 = $n(evidence$20).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$20).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$14 = evidence$20
        } else {
          var postRhsIndex$macro$5 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$20).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x1 = $n(evidence$20);
          var v = $as_sci_List($n(evidence$20).Lfastparse_ParsingRun__f_successValue);
          var res$macro$14 = $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
        };
        if ($n(evidence$20).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$20).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$20).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$18 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$20).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$20).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$20).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$20).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$20);
    if ($n(evidence$20).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$20).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$19 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
        this.rooms__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$20);
        var rhsAggregate$macro$22 = $n(evidence$20).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$23 = $n(evidence$20).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$29 = evidence$20
        } else {
          var postRhsIndex$macro$20 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
          var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
          if ((rhsMadeProgress$macro$25 && $n(evidence$20).checkForDrop__Z())) {
            $n(input$macro$26)
          };
          var res$macro$29 = $n(evidence$20).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$5).apply__O__O__O($as_sci_List(lhsValue$macro$27), $as_sci_List($n(evidence$20).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$28)
        };
        if ($n(evidence$20).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$20).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$20).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$8 = evidence$20
  } else {
    var postLhsIndex$macro$33 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$36 = $n(evidence$20).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$39 = $n(evidence$20).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$33 > preLhsIndex$macro$32) && $n(evidence$20).checkForDrop__Z())) {
      $n(input$macro$41)
    };
    var lhsValue$macro$42 = $n(evidence$20).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$20);
    if ($n(evidence$20).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$20).Lfastparse_ParsingRun__f_cut)) {
        var x1$8 = evidence$20
      } else {
        var preRhsIndex$macro$34 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
        this.roofs__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$20);
        var rhsAggregate$macro$37 = $n(evidence$20).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$38 = $n(evidence$20).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$44 = evidence$20
        } else {
          var postRhsIndex$macro$35 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$40 = (postRhsIndex$macro$35 > preRhsIndex$macro$34);
          var nextIndex$macro$43 = (((!rhsMadeProgress$macro$40) && $n(input$macro$41).isReachable__I__Z(postRhsIndex$macro$35)) ? postLhsIndex$macro$33 : postRhsIndex$macro$35);
          if ((rhsMadeProgress$macro$40 && $n(evidence$20).checkForDrop__Z())) {
            $n(input$macro$41)
          };
          var res$macro$44 = $n(evidence$20).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($as_T2(lhsValue$macro$42), $as_sci_List($n(evidence$20).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$43)
        };
        if ($n(evidence$20).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$20).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$32, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$39, rhsMsg$macro$38), $n(lhsAggregate$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$37), (preRhsIndex$macro$34 === $n(evidence$20).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$8 = res$macro$44
      }
    } else {
      var x1$8 = evidence$20
    }
  };
  if (instrument) {
    $n($n(evidence$20).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("storey").Lsourcecode_Name__f_value, $n(x1$8).Lfastparse_ParsingRun__f_index, $n(x1$8).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$8).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(x1$8);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("storey").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$8).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$8).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$8).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(x1$8);
      var self = new $c_Lsourcecode_Name("storey").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$14 = $n($n(x1$8).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$14)
    }
  };
  if ((!$n(x1$8).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$8
  } else {
    var $$x4 = $n(x1$8);
    var this$16 = $m_Lreactbuild_format_iz2use_package$Storey$();
    $$x4.Lfastparse_ParsingRun__f_successValue = $n($f_F3__tupled__F1(this$16)).apply__O__O($as_T3($n(x1$8).Lfastparse_ParsingRun__f_successValue));
    return x1$8
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.settings__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$21) {
  var startIndex = $n(evidence$21).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$21).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$21).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("settings").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$32 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
  var input$macro$41 = $n(evidence$21).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$2));
  var preLhsIndex$macro$17 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$21).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$3 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$7 = this$3.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$2 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$21).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var startIndex$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
  var instrument$1 = ($n(evidence$21).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument$1) {
    $n($n(evidence$21).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, startIndex$1)
  };
  var startPos = $n(evidence$21).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var elem = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  var startIndex$macro$19 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
  var count$macro$20 = 0;
  var lastAgg$macro$25 = null;
  while (true) {
    $n(evidence$21).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$20 < 1));
    $m_Lfastparse_package$();
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex$macro$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
    var input$macro$11$1 = $n(evidence$21).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    $m_Lfastparse_package$();
    var startPos$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
    var startCut = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
    var oldNoCut = $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer;
    $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer = true;
    var startTerminals = $n(evidence$21).Lfastparse_ParsingRun__f_failureTerminalAggregate;
    var oldCut = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
    $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
    var startPos$2 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
    $m_Lfastparse_package$();
    var oldCut$2 = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
    $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
    var startPos$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
    $m_Lfastparse_package$();
    $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$21);
    var lhsMsg = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
    var lhsAggregate = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) {
      $n(evidence$21).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$21).Lfastparse_ParsingRun__f_cut | oldCut$2)))
    } else if ($n(evidence$21).Lfastparse_ParsingRun__f_cut) {
      /*<skip>*/
    } else {
      var verboseFailures = $n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures;
      $n(evidence$21).Lfastparse_ParsingRun__f_index = startPos$2$1;
      if (verboseFailures) {
        var this$11 = $n(evidence$21);
        this$11.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, lhsMsg, lhsAggregate, false)
      };
      $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
      $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$21);
      var rhsMsg = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
      var rhsCut = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
      var endCut = (!(!(rhsCut | oldCut$2)));
      if (((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
        $n(evidence$21).freshFailure__I__Lfastparse_ParsingRun(startPos$2$1)
      };
      $n(evidence$21).Lfastparse_ParsingRun__f_cut = endCut;
      if (verboseFailures) {
        var this$12 = $n(evidence$21);
        var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
        var rassoc$3 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
        this$12.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, msgToSet, msgToAggregate, false)
      }
    };
    var lhsMsg$2 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
    var lhsAggregate$2 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) {
      $n(evidence$21).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$21).Lfastparse_ParsingRun__f_cut | oldCut)))
    } else if ((!$n(evidence$21).Lfastparse_ParsingRun__f_cut)) {
      var verboseFailures$2 = $n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures;
      $n(evidence$21).Lfastparse_ParsingRun__f_index = startPos$2;
      if (verboseFailures$2) {
        var this$14 = $n(evidence$21);
        this$14.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg$2, lhsAggregate$2, false)
      };
      $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
      var input = $n(evidence$21).Lfastparse_ParsingRun__f_input;
      var index = $n(evidence$21).Lfastparse_ParsingRun__f_index;
      if ($n(input).isReachable__I__Z(index)) {
        var this$15 = $n(input);
        var this$16 = $n(this$15.Lfastparse_IndexedParserInput__f_data);
        var $$x1 = ($charAt(this$16, index) === 61)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        $n(evidence$21).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
      } else {
        $n(evidence$21).freshFailure__Lfastparse_ParsingRun()
      };
      if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$21).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"=\"")))
      };
      var rhsMsg$2 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
      var rhsCut$2 = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
      var endCut$2 = (!(!(rhsCut$2 | oldCut)));
      if (((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2))) {
        $n(evidence$21).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
      };
      $n(evidence$21).Lfastparse_ParsingRun__f_cut = endCut$2;
      if (verboseFailures$2) {
        var this$18 = $n(evidence$21);
        var msgToSet$1 = $n(lhsMsg$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2);
        var rassoc$3$2 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var msgToAggregate$1 = $n(lhsAggregate$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
        this$18.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet$1, msgToAggregate$1, false)
      }
    };
    $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
    var msg = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
    var res$1 = ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$21).freshFailure__I__Lfastparse_ParsingRun(startPos$1) : $n(evidence$21).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$1));
    if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$21).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
      $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
      $n(evidence$21).setMsg__I__F0__V(startPos$1, new $c_sjsr_AnonFunction0(((msg) => (() => {
        var this$19 = $n(msg);
        return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$19.Lfastparse_internal_Msgs__f_value))
      }))(msg)))
    };
    $n(res$1).Lfastparse_ParsingRun__f_cut = startCut;
    if ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) {
      var postLhsIndex$macro$3 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$6 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$9 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
      if (((postLhsIndex$macro$3 > preLhsIndex$macro$2$1) && $n(evidence$21).checkForDrop__Z())) {
        $n(input$macro$11$1)
      };
      $n(evidence$21);
      if ((!((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$21).Lfastparse_ParsingRun__f_cut))) {
        var preRhsIndex$macro$4 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$21);
        var rhsAggregate$macro$7 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
          /*<skip>*/
        } else {
          var postRhsIndex$macro$5 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11$1).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$21).checkForDrop__Z())) {
            $n(input$macro$11$1)
          };
          var $$x2 = $n(evidence$21);
          $n(evidence$21);
          var v = (void 0);
          $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
        };
        if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$21).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2$1, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$21).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    };
    var parsedMsg$macro$24 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$26 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$21).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
      var res$2 = ($n(evidence$21).Lfastparse_ParsingRun__f_cut ? evidence$21 : ((count$macro$20 < 1) ? $n(evidence$21).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19, elem$1) : $n(evidence$21).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19, elem$1)));
      if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x6 = $n(evidence$21);
        var $$x5 = startIndex$macro$19;
        var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
          var this$21 = $n(parsedMsg$macro$24);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$21.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
        }))(parsedMsg$macro$24));
        if ((lastAgg$macro$25 === null)) {
          var $$x3 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$2 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x3 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
        };
        $n($$x6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x5, $$x4, $$x3)
      };
      break
    } else {
      var beforeSepIndex$macro$21 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
      $n(evidence$21);
      $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
      if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$21)
      };
      if ((!((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$21).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$20 = ((1 + count$macro$20) | 0);
        startIndex$macro$19 = beforeSepIndex$macro$21;
        count$macro$20 = temp$count$macro$20;
        lastAgg$macro$25 = parsedAgg$macro$26;
        continue
      };
      break
    }
  };
  $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var x1$5$1 = ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) ? evidence$21 : $n(evidence$21).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$21).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$21).Lfastparse_ParsingRun__f_index)));
  if (instrument$1) {
    $n($n(evidence$21).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, $n(x1$5$1).Lfastparse_ParsingRun__f_index, $n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5$1).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x7 = $n(x1$5$1);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex$1, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5$1).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex$1 < $n(x1$5$1).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x8 = $n(x1$5$1);
      var self = new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex$1);
      var this$29 = $n($n(x1$5$1).Lfastparse_ParsingRun__f_failureStack);
      $$x8.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$29)
    }
  };
  if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6$1 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9$1 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3$1 > preLhsIndex$macro$2) && $n(evidence$21).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12$1 = $n(evidence$21).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$21);
    if ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$21).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$4$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
        var input$1 = $n(evidence$21).Lfastparse_ParsingRun__f_input;
        var index$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
        if ($n(input$1).isReachable__I__Z(index$1)) {
          var this$31 = $n(input$1);
          var this$32 = $n(this$31.Lfastparse_IndexedParserInput__f_data);
          var $$x9 = ($charAt(this$32, index$1) === 61)
        } else {
          var $$x9 = false
        };
        if ($$x9) {
          $n(evidence$21).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$1) | 0))
        } else {
          $n(evidence$21).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$21).aggregateTerminal__I__F0__V(index$1, new $c_sjsr_AnonFunction0((() => "\"=\"")))
        };
        var rhsAggregate$macro$7$1 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8$1 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$14$1 = evidence$21
        } else {
          var postRhsIndex$macro$5$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10$1 = (postRhsIndex$macro$5$1 > preRhsIndex$macro$4$1);
          var nextIndex$macro$13$1 = (((!rhsMadeProgress$macro$10$1) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5$1)) ? postLhsIndex$macro$3$1 : postRhsIndex$macro$5$1);
          if ((rhsMadeProgress$macro$10$1 && $n(evidence$21).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x10 = $n(evidence$21);
          $n(x1$7);
          var t = $as_T(lhsValue$macro$12$1);
          $n(evidence$21);
          var res$macro$14$1 = $n($$x10).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$13$1)
        };
        if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$21).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9$1, rhsMsg$macro$8$1), $n(lhsAggregate$macro$6$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7$1), (preRhsIndex$macro$4$1 === $n(evidence$21).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$18 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$21).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$21).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$21).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$21);
    if ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$21).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$19 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
        var startIndex$2 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
        var instrument$2 = ($n(evidence$21).Lfastparse_ParsingRun__f_instrument !== null);
        if (instrument$2) {
          $n($n(evidence$21).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, startIndex$2)
        };
        var startPos$3 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
        var oldCapturing$1 = $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer = true;
        $m_Lfastparse_package$();
        var elem$2 = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
        var elem$3 = false;
        elem$3 = elem$2;
        var startIndex$macro$19$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
        var count$macro$20$1 = 0;
        var lastAgg$macro$25$1 = null;
        while (true) {
          $n(evidence$21).Lfastparse_ParsingRun__f_cut = (elem$3 && (count$macro$20$1 < 1));
          $m_Lfastparse_package$();
          $m_Lfastparse_Implicits$Sequencer$();
          var preLhsIndex$macro$2$2 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
          var input$macro$11$2 = $n(evidence$21).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$();
          var startPos$4 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
          var startCut$1 = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
          var oldNoCut$1 = $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer;
          $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer = true;
          var startTerminals$1 = $n(evidence$21).Lfastparse_ParsingRun__f_failureTerminalAggregate;
          var oldCut$1 = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
          $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
          var startPos$5 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          var oldCut$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
          $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
          var startPos$2$2 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$21);
          var lhsMsg$1 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$1 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$21).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$21).Lfastparse_ParsingRun__f_cut | oldCut$2$1)))
          } else if ($n(evidence$21).Lfastparse_ParsingRun__f_cut) {
            /*<skip>*/
          } else {
            var verboseFailures$1 = $n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$21).Lfastparse_ParsingRun__f_index = startPos$2$2;
            if (verboseFailures$1) {
              var this$42 = $n(evidence$21);
              this$42.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$2, lhsMsg$1, lhsAggregate$1, false)
            };
            $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
            $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$21);
            var rhsMsg$1 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$1 = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
            var endCut$1 = (!(!(rhsCut$1 | oldCut$2$1)));
            if (((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$1))) {
              $n(evidence$21).freshFailure__I__Lfastparse_ParsingRun(startPos$2$2)
            };
            $n(evidence$21).Lfastparse_ParsingRun__f_cut = endCut$1;
            if (verboseFailures$1) {
              var this$43 = $n(evidence$21);
              var msgToSet$2 = $n(lhsMsg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$1);
              var rassoc$3$1 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$2 = $n(lhsAggregate$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$1);
              this$43.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$2, msgToSet$2, msgToAggregate$2, false)
            }
          };
          var lhsMsg$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$21).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$21).Lfastparse_ParsingRun__f_cut | oldCut$1)))
          } else if ((!$n(evidence$21).Lfastparse_ParsingRun__f_cut)) {
            var verboseFailures$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$21).Lfastparse_ParsingRun__f_index = startPos$5;
            if (verboseFailures$2$1) {
              var this$45 = $n(evidence$21);
              this$45.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, lhsMsg$2$1, lhsAggregate$2$1, false)
            };
            $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
            $m_Lfastparse_package$().Fail__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$21);
            var rhsMsg$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_cut;
            var endCut$2$1 = (!(!(rhsCut$2$1 | oldCut$1)));
            if (((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2$1))) {
              $n(evidence$21).freshFailure__I__Lfastparse_ParsingRun(startPos$5)
            };
            $n(evidence$21).Lfastparse_ParsingRun__f_cut = endCut$2$1;
            if (verboseFailures$2$1) {
              var this$46 = $n(evidence$21);
              var msgToSet$3 = $n(lhsMsg$2$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2$1);
              var rassoc$3$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$3 = $n(lhsAggregate$2$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2$1);
              this$46.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, msgToSet$3, msgToAggregate$3, false)
            }
          };
          $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut$1;
          var msg$1 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
          var res$4 = ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$21).freshFailure__I__Lfastparse_ParsingRun(startPos$4) : $n(evidence$21).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$4));
          if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$21).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals$1;
            $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
            $n(evidence$21).setMsg__I__F0__V(startPos$4, new $c_sjsr_AnonFunction0(((msg$1) => (() => {
              var this$47 = $n(msg$1);
              return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$47.Lfastparse_internal_Msgs__f_value))
            }))(msg$1)))
          };
          $n(res$4).Lfastparse_ParsingRun__f_cut = startCut$1;
          if ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$3$2 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$6$2 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$9$2 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
            if (((postLhsIndex$macro$3$2 > preLhsIndex$macro$2$2) && $n(evidence$21).checkForDrop__Z())) {
              $n(input$macro$11$2)
            };
            $n(evidence$21);
            if ((!((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$21).Lfastparse_ParsingRun__f_cut))) {
              var preRhsIndex$macro$4$2 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
              $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$21);
              var rhsAggregate$macro$7$2 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$8$2 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
                /*<skip>*/
              } else {
                var postRhsIndex$macro$5$2 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$10$2 = (postRhsIndex$macro$5$2 > preRhsIndex$macro$4$2);
                var nextIndex$macro$13$2 = (((!rhsMadeProgress$macro$10$2) && $n(input$macro$11$2).isReachable__I__Z(postRhsIndex$macro$5$2)) ? postLhsIndex$macro$3$2 : postRhsIndex$macro$5$2);
                if ((rhsMadeProgress$macro$10$2 && $n(evidence$21).checkForDrop__Z())) {
                  $n(input$macro$11$2)
                };
                var $$x11 = $n(evidence$21);
                $n(evidence$21);
                var v$2 = (void 0);
                $n($$x11).freshSuccess__O__I__Lfastparse_ParsingRun(v$2, nextIndex$macro$13$2)
              };
              if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$21).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9$2, rhsMsg$macro$8$2), $n(lhsAggregate$macro$6$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7$2), (preRhsIndex$macro$4$2 === $n(evidence$21).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          };
          var parsedMsg$macro$24$1 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$26$1 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$3 = (!(!(elem$3 | $n(evidence$21).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$5 = ($n(evidence$21).Lfastparse_ParsingRun__f_cut ? evidence$21 : ((count$macro$20$1 < 1) ? $n(evidence$21).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19$1, elem$3) : $n(evidence$21).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19$1, elem$3)));
            if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x15 = $n(evidence$21);
              var $$x14 = startIndex$macro$19$1;
              var $$x13 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24$1) => (() => {
                var this$49 = $n(parsedMsg$macro$24$1);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$49.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$macro$24$1));
              if ((lastAgg$macro$25$1 === null)) {
                var $$x12 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$2$1 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x12 = $n(lastAgg$macro$25$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2$1)
              };
              $n($$x15).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x14, $$x13, $$x12)
            };
            break
          } else {
            var beforeSepIndex$macro$21$1 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
            $n(evidence$21);
            $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
            if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$21)
            };
            if ((!((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$21).Lfastparse_ParsingRun__f_cut))) {
              $n(evidence$21).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$20$1 = ((1 + count$macro$20$1) | 0);
              startIndex$macro$19$1 = beforeSepIndex$macro$21$1;
              count$macro$20$1 = temp$count$macro$20$1;
              lastAgg$macro$25$1 = parsedAgg$macro$26$1;
              continue
            };
            break
          }
        };
        $n(evidence$21).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing$1;
        var x1$5$2 = ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) ? evidence$21 : $n(evidence$21).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$21).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$3, $n(evidence$21).Lfastparse_ParsingRun__f_index)));
        if (instrument$2) {
          $n($n(evidence$21).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, $n(x1$5$2).Lfastparse_ParsingRun__f_index, $n(x1$5$2).Lfastparse_ParsingRun__f_isSuccess)
        };
        if ($n(x1$5$2).Lfastparse_ParsingRun__f_verboseFailures) {
          var $$x16 = $n(x1$5$2);
          $m_sci_List$();
          var array$1 = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value)))];
          var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
          $n($$x16).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex$2, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)), $n(x1$5$2).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex$2 < $n(x1$5$2).Lfastparse_ParsingRun__f_traceIndex));
          if ((!$n(x1$5$2).Lfastparse_ParsingRun__f_isSuccess)) {
            var $$x17 = $n(x1$5$2);
            var self$1 = new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value;
            var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self$1, startIndex$2);
            var this$57 = $n($n(x1$5$2).Lfastparse_ParsingRun__f_failureStack);
            $$x17.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$57)
          }
        };
        var rhsAggregate$macro$22 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$23 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$21).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$29 = evidence$21
        } else {
          var postRhsIndex$macro$20 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
          var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
          if ((rhsMadeProgress$macro$25 && $n(evidence$21).checkForDrop__Z())) {
            $n(input$macro$26)
          };
          var res$macro$29 = $n(evidence$21).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$5).apply__O__O__O($as_T(lhsValue$macro$27), $as_T($n(evidence$21).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$28)
        };
        if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$21).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$21).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$9 = evidence$21
  } else {
    var postLhsIndex$macro$33 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$36 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$39 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$21).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$33 > preLhsIndex$macro$32) && $n(evidence$21).checkForDrop__Z())) {
      $n(input$macro$41)
    };
    var lhsValue$macro$42 = $n(evidence$21).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$21);
    if ($n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$21).Lfastparse_ParsingRun__f_cut)) {
        var x1$9 = evidence$21
      } else {
        var preRhsIndex$macro$34 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$21);
        var rhsAggregate$macro$37 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$38 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$21).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$44 = evidence$21
        } else {
          var postRhsIndex$macro$35 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$40 = (postRhsIndex$macro$35 > preRhsIndex$macro$34);
          var nextIndex$macro$43 = (((!rhsMadeProgress$macro$40) && $n(input$macro$41).isReachable__I__Z(postRhsIndex$macro$35)) ? postLhsIndex$macro$33 : postRhsIndex$macro$35);
          if ((rhsMadeProgress$macro$40 && $n(evidence$21).checkForDrop__Z())) {
            $n(input$macro$41)
          };
          var $$x18 = $n(evidence$21);
          $n(x1$3);
          var t$1 = $as_T2(lhsValue$macro$42);
          $n(evidence$21);
          var res$macro$44 = $n($$x18).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$43)
        };
        if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$21).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$32, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$39, rhsMsg$macro$38), $n(lhsAggregate$macro$36).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$37), (preRhsIndex$macro$34 === $n(evidence$21).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$9 = res$macro$44
      }
    } else {
      var x1$9 = evidence$21
    }
  };
  if (instrument) {
    $n($n(evidence$21).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("settings").Lsourcecode_Name__f_value, $n(x1$9).Lfastparse_ParsingRun__f_index, $n(x1$9).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$9).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x19 = $n(x1$9);
    $m_sci_List$();
    var array$2 = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("settings").Lsourcecode_Name__f_value)))];
    var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    $n($$x19).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2)), $n(x1$9).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$9).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$9).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x20 = $n(x1$9);
      var self$2 = new $c_Lsourcecode_Name("settings").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self$2, startIndex);
      var this$66 = $n($n(x1$9).Lfastparse_ParsingRun__f_failureStack);
      $$x20.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$66)
    }
  };
  return x1$9
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.building__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$22) {
  $m_Lfastparse_package$();
  var startIndex = $n(evidence$22).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$22).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$22).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("building").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.Lfastparse_Implicits$Sequencer$__f_BaseSequencer3;
  var preLhsIndex$macro$116 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
  var input$macro$125 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.Lfastparse_Implicits$Sequencer$__f_BaseSequencer2;
  var preLhsIndex$macro$90 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
  var input$macro$99 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$3 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$7 = this$3.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$64 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
  var input$macro$73 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$4 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$9 = this$4.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$49 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
  var input$macro$58 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$5 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$11 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$5));
  var preLhsIndex$macro$34 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
  var input$macro$43 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$6 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$13 = this$6.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$19 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
  var input$macro$28 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$4 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
  var input$macro$13 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var index = $n(evidence$22).Lfastparse_ParsingRun__f_index;
  var end = ((2 + index) | 0);
  var input = $n(evidence$22).Lfastparse_ParsingRun__f_input;
  if ($n(input).isReachable__I__Z((((-1) + end) | 0))) {
    var this$8 = $n(input);
    var this$9 = $n(this$8.Lfastparse_IndexedParserInput__f_data);
    if (($charAt(this$9, index) === 45)) {
      var this$10 = $n(input);
      var index$1 = ((1 + index) | 0);
      var this$11 = $n(this$10.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$11, index$1) === 45)
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$22).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
  } else {
    $n(evidence$22).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$22).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"--\"")))
  };
  if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$5 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$8 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$11 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$22).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$5 > preLhsIndex$macro$4) && $n(evidence$22).checkForDrop__Z())) {
      $n(input$macro$13)
    };
    $n(evidence$22);
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$22);
    if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$6 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var startIndex$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var instrument$1 = ($n(evidence$22).Lfastparse_ParsingRun__f_instrument !== null);
        if (instrument$1) {
          $n($n(evidence$22).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, startIndex$1)
        };
        var startPos = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var oldCapturing = $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer = true;
        $m_Lfastparse_package$();
        var elem = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
        var elem$1 = false;
        elem$1 = elem;
        var startIndex$macro$19 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var count$macro$20 = 0;
        var lastAgg$macro$25 = null;
        while (true) {
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$20 < 1));
          $m_Lfastparse_package$();
          $m_Lfastparse_Implicits$Sequencer$();
          var preLhsIndex$macro$2 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var input$macro$11 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$();
          var startPos$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var startCut = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
          var oldNoCut = $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer;
          $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer = true;
          var startTerminals = $n(evidence$22).Lfastparse_ParsingRun__f_failureTerminalAggregate;
          var oldCut = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
          var startPos$2 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          var oldCut$2 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
          var startPos$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
          var lhsMsg = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$22).Lfastparse_ParsingRun__f_cut | oldCut$2)))
          } else if ($n(evidence$22).Lfastparse_ParsingRun__f_cut) {
            /*<skip>*/
          } else {
            var verboseFailures = $n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$22).Lfastparse_ParsingRun__f_index = startPos$2$1;
            if (verboseFailures) {
              var this$20 = $n(evidence$22);
              this$20.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, lhsMsg, lhsAggregate, false)
            };
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
            $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
            var rhsMsg = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
            var endCut = (!(!(rhsCut | oldCut$2)));
            if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
              $n(evidence$22).freshFailure__I__Lfastparse_ParsingRun(startPos$2$1)
            };
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = endCut;
            if (verboseFailures) {
              var this$21 = $n(evidence$22);
              var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
              var rassoc$3 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
              this$21.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$1, msgToSet, msgToAggregate, false)
            }
          };
          var lhsMsg$2 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$2 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$22).Lfastparse_ParsingRun__f_cut | oldCut)))
          } else if ((!$n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
            var verboseFailures$2 = $n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$22).Lfastparse_ParsingRun__f_index = startPos$2;
            if (verboseFailures$2) {
              var this$23 = $n(evidence$22);
              this$23.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg$2, lhsAggregate$2, false)
            };
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
            var input$1 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
            var index$2 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
            if ($n(input$1).isReachable__I__Z(index$2)) {
              var this$24 = $n(input$1);
              var this$25 = $n(this$24.Lfastparse_IndexedParserInput__f_data);
              var $$x2 = ($charAt(this$25, index$2) === 58)
            } else {
              var $$x2 = false
            };
            if ($$x2) {
              $n(evidence$22).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
            } else {
              $n(evidence$22).freshFailure__Lfastparse_ParsingRun()
            };
            if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
              $n(evidence$22).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\":\"")))
            };
            var rhsMsg$2 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$2 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
            var endCut$2 = (!(!(rhsCut$2 | oldCut)));
            if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2))) {
              $n(evidence$22).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
            };
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = endCut$2;
            if (verboseFailures$2) {
              var this$27 = $n(evidence$22);
              var msgToSet$1 = $n(lhsMsg$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2);
              var rassoc$3$2 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$1 = $n(lhsAggregate$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
              this$27.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet$1, msgToAggregate$1, false)
            }
          };
          $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
          var msg = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var res$2 = ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$22).freshFailure__I__Lfastparse_ParsingRun(startPos$1) : $n(evidence$22).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$1));
          if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$22).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
            $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
            $n(evidence$22).setMsg__I__F0__V(startPos$1, new $c_sjsr_AnonFunction0(((msg) => (() => {
              var this$28 = $n(msg);
              return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$28.Lfastparse_internal_Msgs__f_value))
            }))(msg)))
          };
          $n(res$2).Lfastparse_ParsingRun__f_cut = startCut;
          if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$3 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$6 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$9 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
            if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$22).checkForDrop__Z())) {
              $n(input$macro$11)
            };
            $n(evidence$22);
            if ((!((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut))) {
              var preRhsIndex$macro$4 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
              $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
              var rhsAggregate$macro$7 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$8 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
                /*<skip>*/
              } else {
                var postRhsIndex$macro$5 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
                var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
                if ((rhsMadeProgress$macro$10 && $n(evidence$22).checkForDrop__Z())) {
                  $n(input$macro$11)
                };
                var $$x3 = $n(evidence$22);
                $n(evidence$22);
                var v = (void 0);
                $n($$x3).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
              };
              if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$22).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$22).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          };
          var parsedMsg$macro$24 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$26 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$1 = (!(!(elem$1 | $n(evidence$22).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$3 = ($n(evidence$22).Lfastparse_ParsingRun__f_cut ? evidence$22 : ((count$macro$20 < 1) ? $n(evidence$22).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19, elem$1) : $n(evidence$22).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19, elem$1)));
            if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x7 = $n(evidence$22);
              var $$x6 = startIndex$macro$19;
              var $$x5 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
                var this$30 = $n(parsedMsg$macro$24);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$30.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$macro$24));
              if ((lastAgg$macro$25 === null)) {
                var $$x4 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$2 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x4 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
              };
              $n($$x7).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x6, $$x5, $$x4)
            };
            break
          } else {
            var beforeSepIndex$macro$21 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
            $n(evidence$22);
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
            if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$22)
            };
            if ((!((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut))) {
              $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$20 = ((1 + count$macro$20) | 0);
              startIndex$macro$19 = beforeSepIndex$macro$21;
              count$macro$20 = temp$count$macro$20;
              lastAgg$macro$25 = parsedAgg$macro$26;
              continue
            };
            break
          }
        };
        $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
        var x1$5$1 = ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) ? evidence$22 : $n(evidence$22).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$22).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$22).Lfastparse_ParsingRun__f_index)));
        if (instrument$1) {
          $n($n(evidence$22).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, $n(x1$5$1).Lfastparse_ParsingRun__f_index, $n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)
        };
        if ($n(x1$5$1).Lfastparse_ParsingRun__f_verboseFailures) {
          var $$x8 = $n(x1$5$1);
          $m_sci_List$();
          var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value)))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          $n($$x8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex$1, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5$1).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex$1 < $n(x1$5$1).Lfastparse_ParsingRun__f_traceIndex));
          if ((!$n(x1$5$1).Lfastparse_ParsingRun__f_isSuccess)) {
            var $$x9 = $n(x1$5$1);
            var self = new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value;
            var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex$1);
            var this$38 = $n($n(x1$5$1).Lfastparse_ParsingRun__f_failureStack);
            $$x9.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$38)
          }
        };
        var rhsAggregate$macro$9 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$10 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$16 = evidence$22
        } else {
          var postRhsIndex$macro$7 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$12 = (postRhsIndex$macro$7 > preRhsIndex$macro$6);
          var nextIndex$macro$15 = (((!rhsMadeProgress$macro$12) && $n(input$macro$13).isReachable__I__Z(postRhsIndex$macro$7)) ? postLhsIndex$macro$5 : postRhsIndex$macro$7);
          if ((rhsMadeProgress$macro$12 && $n(evidence$22).checkForDrop__Z())) {
            $n(input$macro$13)
          };
          var $$x10 = $n(evidence$22);
          var v$1 = $as_T($n(evidence$22).Lfastparse_ParsingRun__f_successValue);
          var res$macro$16 = $n($$x10).freshSuccess__O__I__Lfastparse_ParsingRun(v$1, nextIndex$macro$15)
        };
        if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$22).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$4, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$11, rhsMsg$macro$10), $n(lhsAggregate$macro$8).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$9), (preRhsIndex$macro$6 === $n(evidence$22).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$20 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$23 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$26 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$20 > preLhsIndex$macro$19) && $n(evidence$22).checkForDrop__Z())) {
      $n(input$macro$28)
    };
    var lhsValue$macro$29 = $n(evidence$22).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$22);
    if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$21 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var input$2 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
        var index$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        if ($n(input$2).isReachable__I__Z(index$2$1)) {
          var this$40 = $n(input$2);
          var this$41 = $n(this$40.Lfastparse_IndexedParserInput__f_data);
          var $$x11 = ($charAt(this$41, index$2$1) === 58)
        } else {
          var $$x11 = false
        };
        if ($$x11) {
          $n(evidence$22).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2$1) | 0))
        } else {
          $n(evidence$22).freshFailure__Lfastparse_ParsingRun()
        };
        if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$22).aggregateTerminal__I__F0__V(index$2$1, new $c_sjsr_AnonFunction0((() => "\":\"")))
        };
        var rhsAggregate$macro$24 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$25 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$31 = evidence$22
        } else {
          var postRhsIndex$macro$22 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$27 = (postRhsIndex$macro$22 > preRhsIndex$macro$21);
          var nextIndex$macro$30 = (((!rhsMadeProgress$macro$27) && $n(input$macro$28).isReachable__I__Z(postRhsIndex$macro$22)) ? postLhsIndex$macro$20 : postRhsIndex$macro$22);
          if ((rhsMadeProgress$macro$27 && $n(evidence$22).checkForDrop__Z())) {
            $n(input$macro$28)
          };
          var $$x12 = $n(evidence$22);
          $n(x1$13);
          var t = $as_T(lhsValue$macro$29);
          $n(evidence$22);
          var res$macro$31 = $n($$x12).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$30)
        };
        if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$22).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$19, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$26, rhsMsg$macro$25), $n(lhsAggregate$macro$23).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$24), (preRhsIndex$macro$21 === $n(evidence$22).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$35 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$38 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$41 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$35 > preLhsIndex$macro$34) && $n(evidence$22).checkForDrop__Z())) {
      $n(input$macro$43)
    };
    var lhsValue$macro$44 = $n(evidence$22).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$22);
    if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$36 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var startIndex$2 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var instrument$2 = ($n(evidence$22).Lfastparse_ParsingRun__f_instrument !== null);
        if (instrument$2) {
          $n($n(evidence$22).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, startIndex$2)
        };
        var startPos$3 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var oldCapturing$1 = $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer = true;
        $m_Lfastparse_package$();
        var elem$2 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
        var elem$3 = false;
        elem$3 = elem$2;
        var startIndex$macro$19$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var count$macro$20$1 = 0;
        var lastAgg$macro$25$1 = null;
        while (true) {
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = (elem$3 && (count$macro$20$1 < 1));
          $m_Lfastparse_package$();
          $m_Lfastparse_Implicits$Sequencer$();
          var preLhsIndex$macro$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var input$macro$11$1 = $n(evidence$22).Lfastparse_ParsingRun__f_input;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$();
          var startPos$4 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var startCut$1 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
          var oldNoCut$1 = $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer;
          $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer = true;
          var startTerminals$1 = $n(evidence$22).Lfastparse_ParsingRun__f_failureTerminalAggregate;
          var oldCut$1 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
          var startPos$5 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          var oldCut$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
          var startPos$2$2 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          $m_Lfastparse_package$();
          $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
          var lhsMsg$1 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$1 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$22).Lfastparse_ParsingRun__f_cut | oldCut$2$1)))
          } else if ($n(evidence$22).Lfastparse_ParsingRun__f_cut) {
            /*<skip>*/
          } else {
            var verboseFailures$1 = $n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$22).Lfastparse_ParsingRun__f_index = startPos$2$2;
            if (verboseFailures$1) {
              var this$51 = $n(evidence$22);
              this$51.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$2, lhsMsg$1, lhsAggregate$1, false)
            };
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
            $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
            var rhsMsg$1 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$1 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
            var endCut$1 = (!(!(rhsCut$1 | oldCut$2$1)));
            if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$1))) {
              $n(evidence$22).freshFailure__I__Lfastparse_ParsingRun(startPos$2$2)
            };
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = endCut$1;
            if (verboseFailures$1) {
              var this$52 = $n(evidence$22);
              var msgToSet$2 = $n(lhsMsg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$1);
              var rassoc$3$1 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$2 = $n(lhsAggregate$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$1);
              this$52.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2$2, msgToSet$2, msgToAggregate$2, false)
            }
          };
          var lhsMsg$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var lhsAggregate$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
          if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$22).Lfastparse_ParsingRun__f_cut | oldCut$1)))
          } else if ((!$n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
            var verboseFailures$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures;
            $n(evidence$22).Lfastparse_ParsingRun__f_index = startPos$5;
            if (verboseFailures$2$1) {
              var this$54 = $n(evidence$22);
              this$54.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, lhsMsg$2$1, lhsAggregate$2$1, false)
            };
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
            $m_Lfastparse_package$().Fail__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
            var rhsMsg$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
            var rhsCut$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
            var endCut$2$1 = (!(!(rhsCut$2$1 | oldCut$1)));
            if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2$1))) {
              $n(evidence$22).freshFailure__I__Lfastparse_ParsingRun(startPos$5)
            };
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = endCut$2$1;
            if (verboseFailures$2$1) {
              var this$55 = $n(evidence$22);
              var msgToSet$3 = $n(lhsMsg$2$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2$1);
              var rassoc$3$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var msgToAggregate$3 = $n(lhsAggregate$2$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2$1);
              this$55.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$5, msgToSet$3, msgToAggregate$3, false)
            }
          };
          $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut$1;
          var msg$1 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var res$4 = ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$22).freshFailure__I__Lfastparse_ParsingRun(startPos$4) : $n(evidence$22).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$4));
          if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
            $n(evidence$22).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals$1;
            $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
            $n(evidence$22).setMsg__I__F0__V(startPos$4, new $c_sjsr_AnonFunction0(((msg$1) => (() => {
              var this$56 = $n(msg$1);
              return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$56.Lfastparse_internal_Msgs__f_value))
            }))(msg$1)))
          };
          $n(res$4).Lfastparse_ParsingRun__f_cut = startCut$1;
          if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
            var postLhsIndex$macro$3$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
            var lhsAggregate$macro$6$1 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
            var lhsMsg$macro$9$1 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
            if (((postLhsIndex$macro$3$1 > preLhsIndex$macro$2$1) && $n(evidence$22).checkForDrop__Z())) {
              $n(input$macro$11$1)
            };
            $n(evidence$22);
            if ((!((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut))) {
              var preRhsIndex$macro$4$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
              $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
              var rhsAggregate$macro$7$1 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
              var rhsMsg$macro$8$1 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
              if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
                /*<skip>*/
              } else {
                var postRhsIndex$macro$5$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
                var rhsMadeProgress$macro$10$1 = (postRhsIndex$macro$5$1 > preRhsIndex$macro$4$1);
                var nextIndex$macro$13$1 = (((!rhsMadeProgress$macro$10$1) && $n(input$macro$11$1).isReachable__I__Z(postRhsIndex$macro$5$1)) ? postLhsIndex$macro$3$1 : postRhsIndex$macro$5$1);
                if ((rhsMadeProgress$macro$10$1 && $n(evidence$22).checkForDrop__Z())) {
                  $n(input$macro$11$1)
                };
                var $$x13 = $n(evidence$22);
                $n(evidence$22);
                var v$3 = (void 0);
                $n($$x13).freshSuccess__O__I__Lfastparse_ParsingRun(v$3, nextIndex$macro$13$1)
              };
              if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
                $n(evidence$22).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2$1, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9$1, rhsMsg$macro$8$1), $n(lhsAggregate$macro$6$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7$1), (preRhsIndex$macro$4$1 === $n(evidence$22).Lfastparse_ParsingRun__f_traceIndex))
              }
            }
          };
          var parsedMsg$macro$24$1 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$26$1 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$3 = (!(!(elem$3 | $n(evidence$22).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$5 = ($n(evidence$22).Lfastparse_ParsingRun__f_cut ? evidence$22 : ((count$macro$20$1 < 1) ? $n(evidence$22).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19$1, elem$3) : $n(evidence$22).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19$1, elem$3)));
            if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x17 = $n(evidence$22);
              var $$x16 = startIndex$macro$19$1;
              var $$x15 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24$1) => (() => {
                var this$58 = $n(parsedMsg$macro$24$1);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$58.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$macro$24$1));
              if ((lastAgg$macro$25$1 === null)) {
                var $$x14 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$2$1 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x14 = $n(lastAgg$macro$25$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2$1)
              };
              $n($$x17).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x16, $$x15, $$x14)
            };
            break
          } else {
            var beforeSepIndex$macro$21$1 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
            $n(evidence$22);
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
            if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$22)
            };
            if ((!((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut))) {
              $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$20$1 = ((1 + count$macro$20$1) | 0);
              startIndex$macro$19$1 = beforeSepIndex$macro$21$1;
              count$macro$20$1 = temp$count$macro$20$1;
              lastAgg$macro$25$1 = parsedAgg$macro$26$1;
              continue
            };
            break
          }
        };
        $n(evidence$22).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing$1;
        var x1$5$2 = ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) ? evidence$22 : $n(evidence$22).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$22).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos$3, $n(evidence$22).Lfastparse_ParsingRun__f_index)));
        if (instrument$2) {
          $n($n(evidence$22).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value, $n(x1$5$2).Lfastparse_ParsingRun__f_index, $n(x1$5$2).Lfastparse_ParsingRun__f_isSuccess)
        };
        if ($n(x1$5$2).Lfastparse_ParsingRun__f_verboseFailures) {
          var $$x18 = $n(x1$5$2);
          $m_sci_List$();
          var array$1 = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value)))];
          var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
          $n($$x18).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex$2, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)), $n(x1$5$2).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex$2 < $n(x1$5$2).Lfastparse_ParsingRun__f_traceIndex));
          if ((!$n(x1$5$2).Lfastparse_ParsingRun__f_isSuccess)) {
            var $$x19 = $n(x1$5$2);
            var self$1 = new $c_Lsourcecode_Name("textUntil").Lsourcecode_Name__f_value;
            var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self$1, startIndex$2);
            var this$66 = $n($n(x1$5$2).Lfastparse_ParsingRun__f_failureStack);
            $$x19.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$66)
          }
        };
        var rhsAggregate$macro$39 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$40 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$46 = evidence$22
        } else {
          var postRhsIndex$macro$37 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$42 = (postRhsIndex$macro$37 > preRhsIndex$macro$36);
          var nextIndex$macro$45 = (((!rhsMadeProgress$macro$42) && $n(input$macro$43).isReachable__I__Z(postRhsIndex$macro$37)) ? postLhsIndex$macro$35 : postRhsIndex$macro$37);
          if ((rhsMadeProgress$macro$42 && $n(evidence$22).checkForDrop__Z())) {
            $n(input$macro$43)
          };
          var res$macro$46 = $n(evidence$22).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$11).apply__O__O__O($as_T(lhsValue$macro$44), $as_T($n(evidence$22).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$45)
        };
        if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$22).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$34, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$41, rhsMsg$macro$40), $n(lhsAggregate$macro$38).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$39), (preRhsIndex$macro$36 === $n(evidence$22).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$50 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$53 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$56 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$22).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$50 > preLhsIndex$macro$49) && $n(evidence$22).checkForDrop__Z())) {
      $n(input$macro$58)
    };
    var lhsValue$macro$59 = $n(evidence$22).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$22);
    if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$51 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_format_iz2use_Literals$().NEWLINE__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
        var rhsAggregate$macro$54 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$55 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = true;
          var res$macro$61 = evidence$22
        } else {
          var postRhsIndex$macro$52 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$57 = (postRhsIndex$macro$52 > preRhsIndex$macro$51);
          var nextIndex$macro$60 = (((!rhsMadeProgress$macro$57) && $n(input$macro$58).isReachable__I__Z(postRhsIndex$macro$52)) ? postLhsIndex$macro$50 : postRhsIndex$macro$52);
          if ((rhsMadeProgress$macro$57 && $n(evidence$22).checkForDrop__Z())) {
            $n(input$macro$58)
          };
          var $$x20 = $n(evidence$22);
          $n(x1$9);
          var t$1 = $as_T2(lhsValue$macro$59);
          $n(evidence$22);
          var res$macro$61 = $n($$x20).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$60)
        };
        if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$22).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$49, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$56, rhsMsg$macro$55), $n(lhsAggregate$macro$53).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$54), (preRhsIndex$macro$51 === $n(evidence$22).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$65 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$68 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$71 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$65 > preLhsIndex$macro$64) && $n(evidence$22).checkForDrop__Z())) {
      $n(input$macro$73)
    };
    var lhsValue$macro$74 = $n(evidence$22).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$22);
    if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$66 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        this.materials__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
        var rhsAggregate$macro$69 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$70 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$76 = evidence$22
        } else {
          var postRhsIndex$macro$67 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$72 = (postRhsIndex$macro$67 > preRhsIndex$macro$66);
          var nextIndex$macro$75 = (((!rhsMadeProgress$macro$72) && $n(input$macro$73).isReachable__I__Z(postRhsIndex$macro$67)) ? postLhsIndex$macro$65 : postRhsIndex$macro$67);
          if ((rhsMadeProgress$macro$72 && $n(evidence$22).checkForDrop__Z())) {
            $n(input$macro$73)
          };
          var $$x21 = $n(evidence$22);
          $n(x1$7);
          var t$2 = $as_T2(lhsValue$macro$74);
          $n(evidence$22);
          var res$macro$76 = $n($$x21).freshSuccess__O__I__Lfastparse_ParsingRun(t$2, nextIndex$macro$75)
        };
        if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$22).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$64, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$71, rhsMsg$macro$70), $n(lhsAggregate$macro$68).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$69), (preRhsIndex$macro$66 === $n(evidence$22).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$91 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$94 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$97 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$91 > preLhsIndex$macro$90) && $n(evidence$22).checkForDrop__Z())) {
      $n(input$macro$99)
    };
    var lhsValue$macro$100 = $n(evidence$22).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$22);
    if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
        /*<skip>*/
      } else {
        var preRhsIndex$macro$92 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var this$72 = $m_Lreactbuild_format_iz2use_Repeater$();
        var x1$19 = this$72.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
        var elem$4 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
        var elem$5 = false;
        elem$5 = elem$4;
        $n(x1$19);
        var acc$macro$80 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
        var startIndex$macro$81 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var count$macro$82 = 0;
        var lastAgg$macro$87 = null;
        while (true) {
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = (elem$5 && (count$macro$82 < 0));
          $m_Lfastparse_package$();
          $m_Lreactbuild_format_iz2use_Parser$().settings__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
          var parsedMsg$macro$86 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$88 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$5 = (!(!(elem$5 | $n(evidence$22).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$6 = ($n(evidence$22).Lfastparse_ParsingRun__f_cut ? evidence$22 : ((count$macro$82 < 0) ? $n(evidence$22).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$81, elem$5) : $n(evidence$22).freshSuccess__O__I__Z__Lfastparse_ParsingRun(($n(x1$19), $n(acc$macro$80).toList__sci_List()), startIndex$macro$81, elem$5)));
            if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x25 = $n(evidence$22);
              var $$x24 = startIndex$macro$81;
              var $$x23 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$86) => (() => {
                var this$77 = $n(parsedMsg$macro$86);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$77.Lfastparse_internal_Msgs__f_value) + ".rep")
              }))(parsedMsg$macro$86));
              if ((lastAgg$macro$87 === null)) {
                var $$x22 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$6 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x22 = $n(lastAgg$macro$87).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$6)
              };
              $n($$x25).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x24, $$x23, $$x22)
            };
            break
          } else {
            var beforeSepIndex$macro$83 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
            $n(x1$19);
            var t$3 = $as_T2($n(evidence$22).Lfastparse_ParsingRun__f_successValue);
            var this$79 = $n(acc$macro$80);
            this$79.addOne__O__scm_Growable(t$3);
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
            if ((this.whitespace__F1() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$22)
            };
            if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
              break
            } else {
              $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$82 = ((1 + count$macro$82) | 0);
              startIndex$macro$81 = beforeSepIndex$macro$83;
              count$macro$82 = temp$count$macro$82;
              lastAgg$macro$87 = parsedAgg$macro$88
            }
          }
        };
        var rhsAggregate$macro$95 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$96 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$102 = evidence$22
        } else {
          var postRhsIndex$macro$93 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$98 = (postRhsIndex$macro$93 > preRhsIndex$macro$92);
          var nextIndex$macro$101 = (((!rhsMadeProgress$macro$98) && $n(input$macro$99).isReachable__I__Z(postRhsIndex$macro$93)) ? postLhsIndex$macro$91 : postRhsIndex$macro$93);
          if ((rhsMadeProgress$macro$98 && $n(evidence$22).checkForDrop__Z())) {
            $n(input$macro$99)
          };
          var res$macro$102 = $n(evidence$22).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$5).apply__O__O__O($as_T2(lhsValue$macro$100), $as_sci_List($n(evidence$22).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$101)
        };
        if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$22).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$90, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$97, rhsMsg$macro$96), $n(lhsAggregate$macro$94).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$95), (preRhsIndex$macro$92 === $n(evidence$22).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    }
  };
  if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$22 = evidence$22
  } else {
    var postLhsIndex$macro$117 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$120 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$123 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$117 > preLhsIndex$macro$116) && $n(evidence$22).checkForDrop__Z())) {
      $n(input$macro$125)
    };
    var lhsValue$macro$126 = $n(evidence$22).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$22);
    if ($n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
        var x1$22 = evidence$22
      } else {
        var preRhsIndex$macro$118 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var this$81 = $m_Lreactbuild_format_iz2use_Repeater$();
        var x1$21 = this$81.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$();
        var elem$6 = $n(evidence$22).Lfastparse_ParsingRun__f_cut;
        var elem$7 = false;
        elem$7 = elem$6;
        $n(x1$21);
        var acc$macro$106 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
        var startIndex$macro$107 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
        var count$macro$108 = 0;
        var lastAgg$macro$113 = null;
        while (true) {
          $n(evidence$22).Lfastparse_ParsingRun__f_cut = (elem$7 && (count$macro$108 < 0));
          $m_Lfastparse_package$();
          $m_Lreactbuild_format_iz2use_Parser$().storey__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$22);
          var parsedMsg$macro$112 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
          var parsedAgg$macro$114 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
          elem$7 = (!(!(elem$7 | $n(evidence$22).Lfastparse_ParsingRun__f_cut)));
          if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
            var res$7 = ($n(evidence$22).Lfastparse_ParsingRun__f_cut ? evidence$22 : ((count$macro$108 < 0) ? $n(evidence$22).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$107, elem$7) : $n(evidence$22).freshSuccess__O__I__Z__Lfastparse_ParsingRun(($n(x1$21), $n(acc$macro$106).toList__sci_List()), startIndex$macro$107, elem$7)));
            if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
              var $$x29 = $n(evidence$22);
              var $$x28 = startIndex$macro$107;
              var $$x27 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$112) => (() => {
                var this$86 = $n(parsedMsg$macro$112);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$86.Lfastparse_internal_Msgs__f_value) + ".rep")
              }))(parsedMsg$macro$112));
              if ((lastAgg$macro$113 === null)) {
                var $$x26 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate
              } else {
                var rassoc$8 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var $$x26 = $n(lastAgg$macro$113).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$8)
              };
              $n($$x29).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x28, $$x27, $$x26)
            };
            break
          } else {
            var beforeSepIndex$macro$109 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
            $n(x1$21);
            var t$4 = $as_Lreactbuild_format_iz2use_package$Storey($n(evidence$22).Lfastparse_ParsingRun__f_successValue);
            var this$88 = $n(acc$macro$106);
            this$88.addOne__O__scm_Growable(t$4);
            $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
            if ((this.whitespace__F1() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
              $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$22)
            };
            if (((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$22).Lfastparse_ParsingRun__f_cut)) {
              break
            } else {
              $n(evidence$22).Lfastparse_ParsingRun__f_cut = false;
              var temp$count$macro$108 = ((1 + count$macro$108) | 0);
              startIndex$macro$107 = beforeSepIndex$macro$109;
              count$macro$108 = temp$count$macro$108;
              lastAgg$macro$113 = parsedAgg$macro$114
            }
          }
        };
        var rhsAggregate$macro$121 = $n(evidence$22).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$122 = $n(evidence$22).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$22).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$128 = evidence$22
        } else {
          var postRhsIndex$macro$119 = $n(evidence$22).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$124 = (postRhsIndex$macro$119 > preRhsIndex$macro$118);
          var nextIndex$macro$127 = (((!rhsMadeProgress$macro$124) && $n(input$macro$125).isReachable__I__Z(postRhsIndex$macro$119)) ? postLhsIndex$macro$117 : postRhsIndex$macro$119);
          if ((rhsMadeProgress$macro$124 && $n(evidence$22).checkForDrop__Z())) {
            $n(input$macro$125)
          };
          var res$macro$128 = $n(evidence$22).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($as_T3(lhsValue$macro$126), $as_sci_List($n(evidence$22).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$127)
        };
        if ($n(evidence$22).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$22).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$116, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$123, rhsMsg$macro$122), $n(lhsAggregate$macro$120).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$121), (preRhsIndex$macro$118 === $n(evidence$22).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$22 = res$macro$128
      }
    } else {
      var x1$22 = evidence$22
    }
  };
  if (instrument) {
    $n($n(evidence$22).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("building").Lsourcecode_Name__f_value, $n(x1$22).Lfastparse_ParsingRun__f_index, $n(x1$22).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$22).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x30 = $n(x1$22);
    $m_sci_List$();
    var array$2 = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("building").Lsourcecode_Name__f_value)))];
    var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    $n($$x30).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2)), $n(x1$22).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$22).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$22).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x31 = $n(x1$22);
      var self$2 = new $c_Lsourcecode_Name("building").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self$2, startIndex);
      var this$95 = $n($n(x1$22).Lfastparse_ParsingRun__f_failureStack);
      $$x31.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$95)
    }
  };
  if ((!$n(x1$22).Lfastparse_ParsingRun__f_isSuccess)) {
    return x1$22
  } else {
    var $$x32 = $n(x1$22);
    var this$97 = $m_Lreactbuild_format_iz2use_package$Building$();
    $$x32.Lfastparse_ParsingRun__f_successValue = $n($f_F4__tupled__F1(this$97)).apply__O__O($as_T4($n(x1$22).Lfastparse_ParsingRun__f_successValue));
    return x1$22
  }
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.root__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$23) {
  var startIndex = $n(evidence$23).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$23).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$23).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("root").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$2 = $n(evidence$23).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$23).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  this.building__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$23);
  if ((!$n(evidence$23).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$4 = evidence$23
  } else {
    var postLhsIndex$macro$3 = $n(evidence$23).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$23).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$23).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$23).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$23).Lfastparse_ParsingRun__f_successValue;
    $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(this.whitespace__F1(), evidence$23);
    if ($n(evidence$23).Lfastparse_ParsingRun__f_isSuccess) {
      if (((!$n(evidence$23).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$23).Lfastparse_ParsingRun__f_cut)) {
        var x1$4 = evidence$23
      } else {
        var preRhsIndex$macro$4 = $n(evidence$23).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$23);
        var rhsAggregate$macro$7 = $n(evidence$23).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$23).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$23).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$macro$14 = evidence$23
        } else {
          var postRhsIndex$macro$5 = $n(evidence$23).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$23).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x1 = $n(evidence$23);
          $n(x1$3);
          var t = $as_Lreactbuild_format_iz2use_package$Building(lhsValue$macro$12);
          $n(evidence$23);
          var res$macro$14 = $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$13)
        };
        if ($n(evidence$23).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$23).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$23).Lfastparse_ParsingRun__f_traceIndex))
        };
        var x1$4 = res$macro$14
      }
    } else {
      var x1$4 = evidence$23
    }
  };
  if (instrument) {
    $n($n(evidence$23).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("root").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("root").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("root").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$11)
    }
  };
  return x1$4
});
var $d_Lreactbuild_format_iz2use_Parser$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_Parser$: 0
}, false, "reactbuild.format.iz2use.Parser$", {
  Lreactbuild_format_iz2use_Parser$: 1,
  O: 1
});
$c_Lreactbuild_format_iz2use_Parser$.prototype.$classData = $d_Lreactbuild_format_iz2use_Parser$;
var $n_Lreactbuild_format_iz2use_Parser$;
function $m_Lreactbuild_format_iz2use_Parser$() {
  if ((!$n_Lreactbuild_format_iz2use_Parser$)) {
    $n_Lreactbuild_format_iz2use_Parser$ = new $c_Lreactbuild_format_iz2use_Parser$()
  };
  return $n_Lreactbuild_format_iz2use_Parser$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$() {
  this.Lreactbuild_format_iz2use_package$__f_componentLengthPattern = null;
  $n_Lreactbuild_format_iz2use_package$ = this;
  this.Lreactbuild_format_iz2use_package$__f_componentLengthPattern = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[A-Za-z]+([0-9]+)[A-Za-z]*", $m_sci_Nil$()))
}
$c_Lreactbuild_format_iz2use_package$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$.prototype = $c_Lreactbuild_format_iz2use_package$.prototype;
var $d_Lreactbuild_format_iz2use_package$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$: 0
}, false, "reactbuild.format.iz2use.package$", {
  Lreactbuild_format_iz2use_package$: 1,
  O: 1
});
$c_Lreactbuild_format_iz2use_package$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$;
var $n_Lreactbuild_format_iz2use_package$;
function $m_Lreactbuild_format_iz2use_package$() {
  if ((!$n_Lreactbuild_format_iz2use_package$)) {
    $n_Lreactbuild_format_iz2use_package$ = new $c_Lreactbuild_format_iz2use_package$()
  };
  return $n_Lreactbuild_format_iz2use_package$
}
function $is_Lreactbuild_format_iz2use_package$ComponentGroupOffset(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_format_iz2use_package$ComponentGroupOffset)))
}
function $as_Lreactbuild_format_iz2use_package$ComponentGroupOffset(obj) {
  return (($is_Lreactbuild_format_iz2use_package$ComponentGroupOffset(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$ComponentGroupOffset"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$ComponentGroupOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$ComponentGroupOffset)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$ComponentGroupOffset(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$ComponentGroupOffset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$ComponentGroupOffset;", depth))
}
function $is_Lreactbuild_format_iz2use_package$RoofType(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_format_iz2use_package$RoofType)))
}
function $as_Lreactbuild_format_iz2use_package$RoofType(obj) {
  return (($is_Lreactbuild_format_iz2use_package$RoofType(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$RoofType"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$RoofType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$RoofType)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$RoofType(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$RoofType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$RoofType;", depth))
}
/** @constructor */
function $c_Lreactbuild_geom_Bounds2$() {
  /*<skip>*/
}
$c_Lreactbuild_geom_Bounds2$.prototype = new $h_O();
$c_Lreactbuild_geom_Bounds2$.prototype.constructor = $c_Lreactbuild_geom_Bounds2$;
/** @constructor */
function $h_Lreactbuild_geom_Bounds2$() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Bounds2$.prototype = $c_Lreactbuild_geom_Bounds2$.prototype;
$c_Lreactbuild_geom_Bounds2$.prototype.isNear__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Point2Based__D__Z = (function(pt, a, b, maxDistance) {
  var v = $n(pt).x__D();
  var a$1 = $n(a).x__D();
  var b$1 = $n(b).x__D();
  if (((a$1 <= b$1) ? (((a$1 - maxDistance) <= v) && (v <= (b$1 + maxDistance))) : (((b$1 - maxDistance) <= v) && (v <= (a$1 + maxDistance))))) {
    var v$1 = $n(pt).y__D();
    var a$2 = $n(a).y__D();
    var b$2 = $n(b).y__D();
    return ((a$2 <= b$2) ? (((a$2 - maxDistance) <= v$1) && (v$1 <= (b$2 + maxDistance))) : (((b$2 - maxDistance) <= v$1) && (v$1 <= (a$2 + maxDistance))))
  } else {
    return false
  }
});
var $d_Lreactbuild_geom_Bounds2$ = new $TypeData().initClass({
  Lreactbuild_geom_Bounds2$: 0
}, false, "reactbuild.geom.Bounds2$", {
  Lreactbuild_geom_Bounds2$: 1,
  O: 1
});
$c_Lreactbuild_geom_Bounds2$.prototype.$classData = $d_Lreactbuild_geom_Bounds2$;
var $n_Lreactbuild_geom_Bounds2$;
function $m_Lreactbuild_geom_Bounds2$() {
  if ((!$n_Lreactbuild_geom_Bounds2$)) {
    $n_Lreactbuild_geom_Bounds2$ = new $c_Lreactbuild_geom_Bounds2$()
  };
  return $n_Lreactbuild_geom_Bounds2$
}
function $p_Lreactbuild_geom_Polygon2$__loop$1__sci_List__D__D__D__T2($thiz, points, signedArea, centroidX, centroidY) {
  while (true) {
    var x1 = points;
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x2 = $as_sci_$colon$colon(x1);
      var a = $as_Lreactbuild_geom_Point2Based($n(x2).sci_$colon$colon__f_head);
      var tail = $n(x2).sci_$colon$colon__f_next;
      if ((tail instanceof $c_sci_$colon$colon)) {
        var x3 = $as_sci_$colon$colon(tail);
        var b = $as_Lreactbuild_geom_Point2Based($n(x3).sci_$colon$colon__f_head);
        var this$1 = $n(a);
        var area = $f_Lreactbuild_geom_Vector2Based__cross__Lreactbuild_geom_Vector2Based__D(this$1, b);
        var temp$signedArea = (signedArea + area);
        var temp$centroidX = (centroidX + (($n(a).x__D() + $n(b).x__D()) * area));
        var temp$centroidY = (centroidY + (($n(a).y__D() + $n(b).y__D()) * area));
        points = x3;
        signedArea = temp$signedArea;
        centroidX = temp$centroidX;
        centroidY = temp$centroidY;
        continue
      }
    };
    var finalArea = (0.5 * signedArea);
    return ((finalArea !== 0.0) ? $ct_T2__O__O__(new $c_T2(), finalArea, new $c_Lreactbuild_geom_Vector2((centroidX / (6.0 * finalArea)), (centroidY / (6.0 * finalArea)))) : $ct_T2__O__O__(new $c_T2(), 0.0, $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero))
  }
}
/** @constructor */
function $c_Lreactbuild_geom_Polygon2$() {
  /*<skip>*/
}
$c_Lreactbuild_geom_Polygon2$.prototype = new $h_O();
$c_Lreactbuild_geom_Polygon2$.prototype.constructor = $c_Lreactbuild_geom_Polygon2$;
/** @constructor */
function $h_Lreactbuild_geom_Polygon2$() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Polygon2$.prototype = $c_Lreactbuild_geom_Polygon2$.prototype;
var $d_Lreactbuild_geom_Polygon2$ = new $TypeData().initClass({
  Lreactbuild_geom_Polygon2$: 0
}, false, "reactbuild.geom.Polygon2$", {
  Lreactbuild_geom_Polygon2$: 1,
  O: 1
});
$c_Lreactbuild_geom_Polygon2$.prototype.$classData = $d_Lreactbuild_geom_Polygon2$;
var $n_Lreactbuild_geom_Polygon2$;
function $m_Lreactbuild_geom_Polygon2$() {
  if ((!$n_Lreactbuild_geom_Polygon2$)) {
    $n_Lreactbuild_geom_Polygon2$ = new $c_Lreactbuild_geom_Polygon2$()
  };
  return $n_Lreactbuild_geom_Polygon2$
}
function $f_Lreactbuild_geom_Vector2Based__cross__Lreactbuild_geom_Vector2Based__D($thiz, that) {
  return (($thiz.x__D() * $n(that).y__D()) - ($thiz.y__D() * $n(that).x__D()))
}
function $is_Lreactbuild_geom_Vector2Based(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_geom_Vector2Based)))
}
function $as_Lreactbuild_geom_Vector2Based(obj) {
  return (($is_Lreactbuild_geom_Vector2Based(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.geom.Vector2Based"))
}
function $isArrayOf_Lreactbuild_geom_Vector2Based(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_geom_Vector2Based)))
}
function $asArrayOf_Lreactbuild_geom_Vector2Based(obj, depth) {
  return (($isArrayOf_Lreactbuild_geom_Vector2Based(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.geom.Vector2Based;", depth))
}
/** @constructor */
function $c_Lreactbuild_hooks_Dnd$() {
  /*<skip>*/
}
$c_Lreactbuild_hooks_Dnd$.prototype = new $h_O();
$c_Lreactbuild_hooks_Dnd$.prototype.constructor = $c_Lreactbuild_hooks_Dnd$;
/** @constructor */
function $h_Lreactbuild_hooks_Dnd$() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_Dnd$.prototype = $c_Lreactbuild_hooks_Dnd$.prototype;
$c_Lreactbuild_hooks_Dnd$.prototype.hookDrag__F1 = (function() {
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => false));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, initialState, step));
  var $$x9 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x8 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I1(x$1$2);
    return $as_Ljapgolly_scalajs_react_Ref$FullF($n(x$1).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input)
  }));
  var this$5 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x9.useEventHandlerOnMountBy__F1__T__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x8, "dragstart", new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$5)));
  var $$x10 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var $$x7 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I2(x$2$2);
    return $as_Ljapgolly_scalajs_react_Ref$FullF($n(x$2).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input)
  }));
  var this$7 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var this$9 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($$x10.useEventHandlerOnMountBy__F1__T__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x7, "dragend", new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$7))));
  var initialValue = new $c_sjsr_AnonFunction0((() => (void 0)));
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44(this$8);
  var this$11 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRef__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$9, initialValue, step$1)));
  var initialValue$1 = new $c_sjsr_AnonFunction0((() => (void 0)));
  var this$10 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46(this$10);
  var $$x6 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRef__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$11, initialValue$1, step$2)));
  var $$x1 = new $c_sjsr_AnonFunction6(((x$3$2, dragging$2, onStart$2, onEnd$2, startHandler$2, endHandler$2) => {
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$3$2);
    var dragging = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(dragging$2);
    var onStart = $as_F1(onStart$2);
    var onEnd = $as_F1(onEnd$2);
    var startHandler = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(startHandler$2);
    var endHandler = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(endHandler$2);
    $n(onStart).apply__O__O(new $c_sjsr_AnonFunction1(((ev$2) => {
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$12 = $n(dragging);
      var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$12);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(true))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$5$2) => {
        $as_jl_Void(x$5$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
          var this$14 = $n(startHandler);
          var value = this$14.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current;
          return ((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value))
        }))), new $c_sjsr_AnonFunction1(((opt$2) => {
          var opt = $as_F1(opt$2);
          $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(opt).apply__O__O(ev$2.dataTransfer))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
            $as_jl_Void(x$4$2);
            ev$2.dataTransfer.dropEffect = "move"
          }));
          var this$21 = $n(this$);
          var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$21, f);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
        })));
        var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$24 = $m_s_$less$colon$less$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$24.s_$less$colon$less$__f_singleton))
      }))))
    })));
    $n(onEnd).apply__O__O(new $c_sjsr_AnonFunction1(((ev$3$2) => {
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$25 = $n(dragging);
      var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$25);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x4).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(false))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$7$2) => {
        $as_jl_Void(x$7$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var co$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
          var this$27 = $n(endHandler);
          var value$1 = this$27.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current;
          return ((value$1 === (void 0)) ? $m_s_None$() : new $c_s_Some(value$1))
        }))), new $c_sjsr_AnonFunction1(((opt$2$1) => {
          var opt$1 = $as_F0(opt$2$1);
          $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(opt$1).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var f$1 = new $c_sjsr_AnonFunction1(((x$6$2) => {
            $as_jl_Void(x$6$2)
          }));
          var this$34 = $n(this$$1);
          var c$1 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$34, f$1);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1))
        })));
        var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$37 = $m_s_$less$colon$less$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$1, this$37.s_$less$colon$less$__f_singleton))
      }))))
    })));
    var this$38 = $n(dragging);
    return new $c_Lreactbuild_hooks_Dnd$DragResult($uZ(this$38.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]), new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_F1(x$8$2);
      var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(startHandler).set__O__O(x$8))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$43 = $n(this$$2);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$43)
    })), new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9 = $as_F0(x$9$2);
      var this$$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(endHandler).set__O__O(x$9))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$48 = $n(this$$3);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$48)
    })))
  }));
  var this$49 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x6).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48(this$49))
});
$c_Lreactbuild_hooks_Dnd$.prototype.hookDrop__F1 = (function() {
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => false));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, initialState, step));
  var $$x16 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x15 = new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I1(x$10$2);
    return $as_Ljapgolly_scalajs_react_Ref$FullF($n($as_T2($n(x$10).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input))._1__O())
  }));
  var this$5 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x16.useEventHandlerOnMountBy__F1__T__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x15, "dragenter", new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$5)));
  var $$x17 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var $$x14 = new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I2(x$11$2);
    return $as_Ljapgolly_scalajs_react_Ref$FullF($n($as_T2($n(x$11).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input))._1__O())
  }));
  var this$7 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var api$2 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x17.useEventHandlerOnMountBy__F1__T__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x14, "dragover", new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$7)));
  var $$x18 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$2);
  var $$x13 = new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I3(x$12$2);
    return $as_Ljapgolly_scalajs_react_Ref$FullF($n($as_T2($n(x$12).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input))._1__O())
  }));
  var this$9 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var api$3 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x18.useEventHandlerOnMountBy__F1__T__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x13, "dragleave", new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44(this$9)));
  var $$x19 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$3);
  var $$x12 = new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I4(x$13$2);
    return $as_Ljapgolly_scalajs_react_Ref$FullF($n($as_T2($n(x$13).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input))._1__O())
  }));
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var this$13 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($$x19.useEventHandlerOnMountBy__F1__T__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x12, "drop", new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46(this$11))));
  var initialValue = new $c_sjsr_AnonFunction0((() => (void 0)));
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48(this$12);
  var $$x11 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRef__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$13, initialValue, step$1)));
  var $$x1 = new $c_sjsr_AnonFunction7(((props$2, dropping$2, onEnter$2, onOver$2, onLeave$2, onDrop$2, dropHandler$2) => {
    var props = $as_T2(props$2);
    var dropping = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(dropping$2);
    var onEnter = $as_F1(onEnter$2);
    var onOver = $as_F1(onOver$2);
    var onLeave = $as_F1(onLeave$2);
    var onDrop = $as_F1(onDrop$2);
    var dropHandler = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(dropHandler$2);
    $n(onEnter).apply__O__O(new $c_sjsr_AnonFunction1(((ev$2) => {
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev$2.defaultPrevented)))), new $c_sjsr_AnonFunction1(((x$15$2) => {
        $as_jl_Void(x$15$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_Reusable$();
        var this$14 = $n(dropping);
        var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$14);
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(true))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f = new $c_sjsr_AnonFunction1(((x$14$2) => {
          $as_jl_Void(x$14$2)
        }));
        var this$17 = $n(this$);
        var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$17, f);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
      })));
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$20 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$20.s_$less$colon$less$__f_singleton))
    })));
    $n(onOver).apply__O__O(new $c_sjsr_AnonFunction1(((ev$3$2) => {
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev$3$2.defaultPrevented)))), new $c_sjsr_AnonFunction1(((x$18$2) => {
        $as_jl_Void(x$18$2);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).require__F0__F0(new $c_sjsr_AnonFunction0((() => {
          if ($n($as_Lreactbuild_hooks_AcceptDrop($n(props)._2__O())).Lreactbuild_hooks_AcceptDrop__f_acceptFiles) {
            var $$x4 = $m_sjs_js_ArrayOps$();
            var array = ev$3$2.dataTransfer.types;
            var $$x3 = $n($$x4).contains$extension__sjs_js_Array__O__Z(array, "Files")
          } else {
            var $$x3 = false
          };
          if ($$x3) {
            return true
          } else {
            return $n($n($as_Lreactbuild_hooks_AcceptDrop($n(props)._2__O())).Lreactbuild_hooks_AcceptDrop__f_contentTypes).exists__F1__Z(new $c_sjsr_AnonFunction1(((v$2) => {
              var v = $as_T(v$2);
              var $$x5 = $m_sjs_js_ArrayOps$();
              var array$1 = ev$3$2.dataTransfer.types;
              return $n($$x5).contains$extension__sjs_js_Array__O__Z(array$1, v)
            })))
          }
        }))), new $c_sjsr_AnonFunction1(((x$17$2) => {
          $as_jl_Void(x$17$2);
          $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          $m_Ljapgolly_scalajs_react_package$();
          var this$24 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent(ev$3$2, this$24.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var f$1 = new $c_sjsr_AnonFunction1(((x$16$2) => {
            $as_jl_Void(x$16$2);
            ev$3$2.dataTransfer.dropEffect = "move"
          }));
          var this$26 = $n(this$$1);
          var c$1 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$26, f$1);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1))
        }))))
      })));
      var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$29 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x6).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$1, this$29.s_$less$colon$less$__f_singleton))
    })));
    $n(onLeave).apply__O__O(new $c_sjsr_AnonFunction1(((ev$4$2) => {
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co$2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev$4$2.defaultPrevented)))), new $c_sjsr_AnonFunction1(((x$20$2) => {
        $as_jl_Void(x$20$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_Reusable$();
        var this$30 = $n(dropping);
        var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$30);
        var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(false))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f$2 = new $c_sjsr_AnonFunction1(((x$19$2) => {
          $as_jl_Void(x$19$2)
        }));
        var this$33 = $n(this$$2);
        var c$2 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$33, f$2);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$2))
      })));
      var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$36 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x7).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$2, this$36.s_$less$colon$less$__f_singleton))
    })));
    $n(onDrop).apply__O__O(new $c_sjsr_AnonFunction1(((ev$5$2) => {
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co$4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev$5$2.defaultPrevented)))), new $c_sjsr_AnonFunction1(((x$24$2) => {
        $as_jl_Void(x$24$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        $m_Ljapgolly_scalajs_react_Reusable$();
        var this$37 = $n(dropping);
        var r$2 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$37);
        var c$4 = $n($$x8).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$2).value__O())).apply__O__O(false))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$23$2) => {
          $as_jl_Void(x$23$2);
          $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var co$3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
            var this$39 = $n(dropHandler);
            var value = this$39.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current;
            return ((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value))
          }))), new $c_sjsr_AnonFunction1(((opt$2) => {
            var opt = $as_F1(opt$2);
            $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
            var c$3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(opt).apply__O__O(ev$5$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$22$2) => {
              $as_jl_Void(x$22$2);
              $m_Ljapgolly_scalajs_react_package$();
              var this$46 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
              var this$$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent(ev$5$2, this$46.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
              var f$3 = new $c_sjsr_AnonFunction1(((x$21$2) => {
                $as_jl_Void(x$21$2)
              }));
              var this$48 = $n(this$$3);
              return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$48, f$3))
            })));
            return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$3))
          })));
          var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var this$51 = $m_s_$less$colon$less$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x9).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$3, this$51.s_$less$colon$less$__f_singleton))
        })));
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$4))
      })));
      var $$x10 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$54 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x10).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$4, this$54.s_$less$colon$less$__f_singleton))
    })));
    var this$55 = $n(dropping);
    return new $c_Lreactbuild_hooks_Dnd$DropResult($uZ(this$55.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]), new $c_sjsr_AnonFunction1(((x$25$2) => {
      var x$25 = $as_F1(x$25$2);
      var this$$4 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(dropHandler).set__O__O(x$25))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$60 = $n(this$$4);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$60)
    })))
  }));
  var this$61 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x11).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50(this$61))
});
var $d_Lreactbuild_hooks_Dnd$ = new $TypeData().initClass({
  Lreactbuild_hooks_Dnd$: 0
}, false, "reactbuild.hooks.Dnd$", {
  Lreactbuild_hooks_Dnd$: 1,
  O: 1
});
$c_Lreactbuild_hooks_Dnd$.prototype.$classData = $d_Lreactbuild_hooks_Dnd$;
var $n_Lreactbuild_hooks_Dnd$;
function $m_Lreactbuild_hooks_Dnd$() {
  if ((!$n_Lreactbuild_hooks_Dnd$)) {
    $n_Lreactbuild_hooks_Dnd$ = new $c_Lreactbuild_hooks_Dnd$()
  };
  return $n_Lreactbuild_hooks_Dnd$
}
/** @constructor */
function $c_Lreactbuild_hooks_EnhancedAsyncCallback(v) {
  this.Lreactbuild_hooks_EnhancedAsyncCallback__f_v = null;
  this.Lreactbuild_hooks_EnhancedAsyncCallback__f_v = v
}
$c_Lreactbuild_hooks_EnhancedAsyncCallback.prototype = new $h_O();
$c_Lreactbuild_hooks_EnhancedAsyncCallback.prototype.constructor = $c_Lreactbuild_hooks_EnhancedAsyncCallback;
/** @constructor */
function $h_Lreactbuild_hooks_EnhancedAsyncCallback() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_EnhancedAsyncCallback.prototype = $c_Lreactbuild_hooks_EnhancedAsyncCallback.prototype;
$c_Lreactbuild_hooks_EnhancedAsyncCallback.prototype.onError__F1__F1 = (function(f) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().handleError$extension__F1__F1__F1(this.Lreactbuild_hooks_EnhancedAsyncCallback__f_v, new $c_sjsr_AnonFunction1(((throwable$2) => {
    var throwable = $as_jl_Throwable(throwable$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O(throwable))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_jl_Void(x$5$2);
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var this$2 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback);
      try {
        var $$x1 = new $c_s_util_Failure(throwable)
      } catch (e) {
        var e$1 = e;
        var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
        var $$x1 = new $c_s_util_Failure(e$2)
      };
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x2).map$extension__F1__F1__F1(this$2.const__s_util_Try__F1($$x1), new $c_sjsr_AnonFunction1(((v$2) => {
        throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException())
      }))))
    }))))
  })))
});
var $d_Lreactbuild_hooks_EnhancedAsyncCallback = new $TypeData().initClass({
  Lreactbuild_hooks_EnhancedAsyncCallback: 0
}, false, "reactbuild.hooks.EnhancedAsyncCallback", {
  Lreactbuild_hooks_EnhancedAsyncCallback: 1,
  O: 1
});
$c_Lreactbuild_hooks_EnhancedAsyncCallback.prototype.$classData = $d_Lreactbuild_hooks_EnhancedAsyncCallback;
/** @constructor */
function $c_Lreactbuild_hooks_EnhancedOption(v) {
  this.Lreactbuild_hooks_EnhancedOption__f_v = null;
  this.Lreactbuild_hooks_EnhancedOption__f_v = v
}
$c_Lreactbuild_hooks_EnhancedOption.prototype = new $h_O();
$c_Lreactbuild_hooks_EnhancedOption.prototype.constructor = $c_Lreactbuild_hooks_EnhancedOption;
/** @constructor */
function $h_Lreactbuild_hooks_EnhancedOption() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_EnhancedOption.prototype = $c_Lreactbuild_hooks_EnhancedOption.prototype;
$c_Lreactbuild_hooks_EnhancedOption.prototype.toAsyncCallback__F0__F1 = (function(ifEmpty) {
  var this$1 = $n(this.Lreactbuild_hooks_EnhancedOption__f_v);
  if (this$1.isEmpty__Z()) {
    var $$x1 = new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).throwException__F0__F1(ifEmpty))
  } else {
    var arg1 = this$1.get__O();
    var $$x1 = new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(arg1))
  };
  return $n($$x1).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr
});
var $d_Lreactbuild_hooks_EnhancedOption = new $TypeData().initClass({
  Lreactbuild_hooks_EnhancedOption: 0
}, false, "reactbuild.hooks.EnhancedOption", {
  Lreactbuild_hooks_EnhancedOption: 1,
  O: 1
});
$c_Lreactbuild_hooks_EnhancedOption.prototype.$classData = $d_Lreactbuild_hooks_EnhancedOption;
/** @constructor */
function $c_Lreactbuild_hooks_EnhancedPot(v) {
  this.Lreactbuild_hooks_EnhancedPot__f_v = null;
  this.Lreactbuild_hooks_EnhancedPot__f_v = v
}
$c_Lreactbuild_hooks_EnhancedPot.prototype = new $h_O();
$c_Lreactbuild_hooks_EnhancedPot.prototype.constructor = $c_Lreactbuild_hooks_EnhancedPot;
/** @constructor */
function $h_Lreactbuild_hooks_EnhancedPot() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_EnhancedPot.prototype = $c_Lreactbuild_hooks_EnhancedPot.prototype;
$c_Lreactbuild_hooks_EnhancedPot.prototype.toAsyncCallback__F0__F1 = (function(ifEmpty) {
  var this$1 = $n(this.Lreactbuild_hooks_EnhancedPot__f_v);
  if (this$1.isEmpty__Z()) {
    var $$x1 = new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).throwException__F0__F1(ifEmpty))
  } else {
    var arg1 = this$1.get__O();
    var $$x1 = new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(arg1))
  };
  return $n($$x1).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr
});
var $d_Lreactbuild_hooks_EnhancedPot = new $TypeData().initClass({
  Lreactbuild_hooks_EnhancedPot: 0
}, false, "reactbuild.hooks.EnhancedPot", {
  Lreactbuild_hooks_EnhancedPot: 1,
  O: 1
});
$c_Lreactbuild_hooks_EnhancedPot.prototype.$classData = $d_Lreactbuild_hooks_EnhancedPot;
/** @constructor */
function $c_Lreactbuild_hooks_EventHandler$() {
  /*<skip>*/
}
$c_Lreactbuild_hooks_EventHandler$.prototype = new $h_O();
$c_Lreactbuild_hooks_EventHandler$.prototype.constructor = $c_Lreactbuild_hooks_EventHandler$;
/** @constructor */
function $h_Lreactbuild_hooks_EventHandler$() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_EventHandler$.prototype = $c_Lreactbuild_hooks_EventHandler$.prototype;
$c_Lreactbuild_hooks_EventHandler$.prototype.hook__F1 = (function() {
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialValue = new $c_sjsr_AnonFunction0((() => (void 0)));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$27 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRef__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, initialValue, step)));
  var effect = new $c_sjsr_AnonFunction2(((props$2, handlerRef$2) => {
    var props = $as_T2(props$2);
    var handlerRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(handlerRef$2);
    if ((props === null)) {
      throw new $c_s_MatchError(props)
    };
    var targetRef = $as_Ljapgolly_scalajs_react_Ref$FullF($n(props)._1__O());
    var eventName = $as_T($n(props)._2__O());
    var eventHandler = new $c_sjsr_AnonFunction1(((event$2) => {
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(targetRef).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$4 = $m_s_$less$colon$less$();
      var cb = $n($$x5).flatMap$extension__F0__F1__F0($n($$x4).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x3, this$4.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((target$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
        var this$5 = $n(handlerRef);
        var value = this$5.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current;
        return ((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value))
      }))), new $c_sjsr_AnonFunction1(((opt$2) => {
        var opt = $as_F1(opt$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(opt).apply__O__O(event$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
          $as_jl_Void(x$2$2)
        }));
        var this$12 = $n(this$);
        var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$12, f);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
      })))))));
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$15 = $m_s_$less$colon$less$();
      var this$$1 = $n($$x6).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(cb, this$15.s_$less$colon$less$__f_singleton);
      var this$17 = $n(this$$1);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$17)
    }));
    var this$$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(targetRef).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f$2 = new $c_sjsr_AnonFunction1(((target$2$1) => {
      var target = $as_s_Option(target$2$1);
      var this$18 = $n(target);
      if ((!this$18.isEmpty__Z())) {
        var arg1 = this$18.get__O();
        arg1.addEventListener(eventName, $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(eventHandler))
      };
      var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(targetRef).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var f$1 = new $c_sjsr_AnonFunction1(((target$2$2) => {
        var target$2$3 = $as_s_Option(target$2$2);
        var this$19 = $n(target$2$3);
        if ((!this$19.isEmpty__Z())) {
          var arg1$1 = this$19.get__O();
          arg1$1.removeEventListener(eventName, $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(eventHandler))
        }
      }));
      var this$21 = $n(this$$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$21, f$1))
    }));
    var this$23 = $n(this$$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$23, f$2))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$26 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$26);
  var $$x2 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$27, effect, a, step$1)));
  var $$x1 = new $c_sjsr_AnonFunction2(((props$3$2, handlerRef$3$2) => {
    $as_T2(props$3$2);
    var handlerRef$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(handlerRef$3$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_F1(x$5$2);
      var this$$4 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(handlerRef$3).set__O__O(x$5))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$32 = $n(this$$4);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$32)
    }))
  }));
  var this$33 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$33))
});
var $d_Lreactbuild_hooks_EventHandler$ = new $TypeData().initClass({
  Lreactbuild_hooks_EventHandler$: 0
}, false, "reactbuild.hooks.EventHandler$", {
  Lreactbuild_hooks_EventHandler$: 1,
  O: 1
});
$c_Lreactbuild_hooks_EventHandler$.prototype.$classData = $d_Lreactbuild_hooks_EventHandler$;
var $n_Lreactbuild_hooks_EventHandler$;
function $m_Lreactbuild_hooks_EventHandler$() {
  if ((!$n_Lreactbuild_hooks_EventHandler$)) {
    $n_Lreactbuild_hooks_EventHandler$ = new $c_Lreactbuild_hooks_EventHandler$()
  };
  return $n_Lreactbuild_hooks_EventHandler$
}
function $ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__($thiz, api) {
  $thiz.Lreactbuild_hooks_HooksApiExt$Primary__f_api = api;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_hooks_HooksApiExt$Primary() {
  this.Lreactbuild_hooks_HooksApiExt$Primary__f_api = null
}
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype = new $h_O();
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype.constructor = $c_Lreactbuild_hooks_HooksApiExt$Primary;
/** @constructor */
function $h_Lreactbuild_hooks_HooksApiExt$Primary() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_HooksApiExt$Primary.prototype = $c_Lreactbuild_hooks_HooksApiExt$Primary.prototype;
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype.useCommonDataBy__F1__F1__Lreactbuild_package$DefaultCommonData__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(getProxy, f, ev, step) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Ldiode_react_ModelProxy(p$2);
    var this$2 = $n(p);
    var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
    return $n($n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_commonData).map__F1__Ldiode_data_Pot(f)
  }));
  var r = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var reuse = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f$1);
  var this$5 = $n(this.Lreactbuild_hooks_HooksApiExt$Primary__f_api);
  var create = new $c_sjsr_AnonFunction1(((p$3$2) => new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Ldiode_react_ModelProxy(x$1$2);
    return $m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O($as_Ldiode_react_ModelProxy($n(getProxy).apply__O__O(p$3$2)), f, ev)
  }))));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useMemoBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$5, getProxy, create, reuse, step)
});
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype.usePageProps__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(step) {
  var this$1 = $n(this.Lreactbuild_hooks_HooksApiExt$Primary__f_api);
  var ctx = $m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context;
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$1, ctx, step)
});
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype.useEventHandlerOnMountBy__F1__T__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(ref, eventName, step) {
  var this$3 = $n(this.Lreactbuild_hooks_HooksApiExt$Primary__f_api);
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Lreactbuild_hooks_EventHandler$().hook__F1(), $ct_T2__O__O__(new $c_T2(), $n(ref).apply__O__O(ctx$2), eventName)))));
  var this$2 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$2);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$3, hook, step, d)
});
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype.useLocalStorage__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Lio_circe_Encoder__Lio_circe_Decoder__F2__Lsourcecode_Pkg__Lsourcecode_FileName__O = (function(default$1, step, encoder, decoder, reuse, pkg, name) {
  var this$3 = $n(this.Lreactbuild_hooks_HooksApiExt$Primary__f_api);
  var hook = $m_Lreactbuild_hooks_UseLocalStorage$().hook__T__F0__Lio_circe_Encoder__Lio_circe_Decoder__F2__F1(((pkg + ".") + name), default$1, encoder, decoder, reuse);
  var this$1 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$();
  var a = this$1.const__O__F1((void 0));
  var this$2 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$2);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__custom__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__F1__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$3, hook, step, a, d)
});
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype.useDragBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(ref, step) {
  var this$3 = $n(this.Lreactbuild_hooks_HooksApiExt$Primary__f_api);
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Lreactbuild_hooks_Dnd$().hookDrag__F1(), $n(ref).apply__O__O(ctx$2)))));
  var this$2 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$2);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$3, hook, step, d)
});
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype.useDropBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(ref, accept, step) {
  var this$3 = $n(this.Lreactbuild_hooks_HooksApiExt$Primary__f_api);
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Lreactbuild_hooks_Dnd$().hookDrop__F1(), $ct_T2__O__O__(new $c_T2(), $n(ref).apply__O__O(ctx$2), $n(accept).apply__O__O(ctx$2))))));
  var this$2 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$2);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$3, hook, step, d)
});
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype.useDerivedRefBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(deps, create, r, step) {
  var this$3 = $n(this.Lreactbuild_hooks_HooksApiExt$Primary__f_api);
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Lreactbuild_hooks_UseDerivedRef$().apply__F0__F1__F2__F1(new $c_sjsr_AnonFunction0((() => $n(deps).apply__O__O(ctx$2))), $as_F1($n(create).apply__O__O(ctx$2)), r))));
  var this$2 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$2);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$3, hook, step, d)
});
var $d_Lreactbuild_hooks_HooksApiExt$Primary = new $TypeData().initClass({
  Lreactbuild_hooks_HooksApiExt$Primary: 0
}, false, "reactbuild.hooks.HooksApiExt$Primary", {
  Lreactbuild_hooks_HooksApiExt$Primary: 1,
  O: 1
});
$c_Lreactbuild_hooks_HooksApiExt$Primary.prototype.$classData = $d_Lreactbuild_hooks_HooksApiExt$Primary;
/** @constructor */
function $c_Lreactbuild_hooks_UseDebounce$() {
  /*<skip>*/
}
$c_Lreactbuild_hooks_UseDebounce$.prototype = new $h_O();
$c_Lreactbuild_hooks_UseDebounce$.prototype.constructor = $c_Lreactbuild_hooks_UseDebounce$;
/** @constructor */
function $h_Lreactbuild_hooks_UseDebounce$() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_UseDebounce$.prototype = $c_Lreactbuild_hooks_UseDebounce$.prototype;
$c_Lreactbuild_hooks_UseDebounce$.prototype.useDebouncedBy__s_concurrent_duration_FiniteDuration__F0__F2__F1 = (function(interval, deps, r) {
  var this$4 = $n($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialValue = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$7 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRef__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$4, initialValue, step)));
  var initialState = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$6 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$6);
  var this$24 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$7, initialState, step$1)));
  var deps$1 = new $c_sjsr_AnonFunction3(((x$1$2, x$2$2, x$3$2) => {
    $as_jl_Void(x$1$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$2$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$3$2);
    return $n(deps).apply__O()
  }));
  var effect = new $c_sjsr_AnonFunction3(((x$4$2, handle$2, state$2) => {
    $as_jl_Void(x$4$2);
    var handle = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(handle$2);
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    return new $c_sjsr_AnonFunction1(((deps$2) => {
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_callback_Callback$();
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        var this$8 = $n(handle);
        var this$9 = $n($as_s_Option(this$8.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
        var f = new $c_sjsr_AnonFunction1(((handle$2$1) => {
          $m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(handle$2$1)
        }));
        if ((!this$9.isEmpty__Z())) {
          f.apply__O__O(this$9.get__O())
        }
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2), new $c_sjsr_AnonFunction1(((v$2) => {
        $as_jl_Void(v$2);
        var $$x5 = $m_s_Option$();
        $m_Ljapgolly_scalajs_react_Reusable$();
        var this$13 = $n(state);
        var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$13);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((prev$2) => {
          var prev = $as_s_Option(prev$2);
          var $$x4 = $m_s_Option$();
          var this$16 = $n(prev);
          var ifEmpty = new $c_sjsr_AnonFunction0((() => 0));
          var f$3 = new $c_sjsr_AnonFunction1(((x$5$2) => {
            var x$5 = $as_T2(x$5$2);
            return ((1 + $n(x$5)._2$mcI$sp__I()) | 0)
          }));
          var y = (this$16.isEmpty__Z() ? ifEmpty.apply__O() : f$3.apply__O__O(this$16.get__O()));
          return $n($$x4).apply__O__s_Option($ct_T2__O__O__(new $c_T2(), deps$2, y))
        }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(handle).set__O__O($n($$x5).apply__O__s_Option($m_sjs_js_timers_package$().setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle(interval, new $c_sjsr_AnonFunction0((() => {
          var this$19 = $n(cb);
          $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$19)
        }))))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f$4 = new $c_sjsr_AnonFunction1(((x$6$2) => {
          $as_jl_Void(x$6$2)
        }));
        var this$21 = $n(this$);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$21, f$4))
      }))))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$23 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$23);
  var $$x2 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$24, deps$1, effect, a, r, step$2)));
  var $$x1 = new $c_sjsr_AnonFunction3(((x$7$2, x$8$2, state$3$2) => {
    $as_jl_Void(x$7$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$8$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$3$2);
    var this$25 = $n(state$3);
    var this$26 = $n($as_s_Option(this$25.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]));
    var f$5 = new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9 = $as_T2(x$9$2);
      return $n(x$9)._1__O()
    }));
    return (this$26.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$5.apply__O__O(this$26.get__O())))
  }));
  var this$27 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$27))
});
var $d_Lreactbuild_hooks_UseDebounce$ = new $TypeData().initClass({
  Lreactbuild_hooks_UseDebounce$: 0
}, false, "reactbuild.hooks.UseDebounce$", {
  Lreactbuild_hooks_UseDebounce$: 1,
  O: 1
});
$c_Lreactbuild_hooks_UseDebounce$.prototype.$classData = $d_Lreactbuild_hooks_UseDebounce$;
var $n_Lreactbuild_hooks_UseDebounce$;
function $m_Lreactbuild_hooks_UseDebounce$() {
  if ((!$n_Lreactbuild_hooks_UseDebounce$)) {
    $n_Lreactbuild_hooks_UseDebounce$ = new $c_Lreactbuild_hooks_UseDebounce$()
  };
  return $n_Lreactbuild_hooks_UseDebounce$
}
/** @constructor */
function $c_Lreactbuild_hooks_UseDerivedRef$() {
  /*<skip>*/
}
$c_Lreactbuild_hooks_UseDerivedRef$.prototype = new $h_O();
$c_Lreactbuild_hooks_UseDerivedRef$.prototype.constructor = $c_Lreactbuild_hooks_UseDerivedRef$;
/** @constructor */
function $h_Lreactbuild_hooks_UseDerivedRef$() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_UseDerivedRef$.prototype = $c_Lreactbuild_hooks_UseDerivedRef$.prototype;
$c_Lreactbuild_hooks_UseDerivedRef$.prototype.apply__F0__F1__F2__F1 = (function(deps, create, r) {
  var this$2 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$5 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useMemo__F0__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$2, deps, create, r, step)));
  var initialValue = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I1(x$1$2);
    return $n($as_Ljapgolly_scalajs_react_Reusable($n(x$1).Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1)).value__O()
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$4);
  var this$8 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$5, initialValue, step$1)));
  var deps$1 = new $c_sjsr_AnonFunction3(((x$2$2, memo$2, ref$2) => {
    $as_jl_Void(x$2$2);
    var memo = $as_Ljapgolly_scalajs_react_Reusable(memo$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(ref$2);
    return memo
  }));
  var effect = new $c_sjsr_AnonFunction3(((x$3$2, memo$3$2, ref$3$2) => {
    $as_jl_Void(x$3$2);
    var memo$3 = $as_Ljapgolly_scalajs_react_Reusable(memo$3$2);
    var ref$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(ref$3$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      $as_Ljapgolly_scalajs_react_Reusable(x$4$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(ref$3).set__O__O($n(memo$3).value__O()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r$1 = $m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2();
  var this$7 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$7);
  var $$x2 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$8, deps$1, effect, a, r$1, step$2)));
  var $$x1 = new $c_sjsr_AnonFunction3(((x$5$2, x$6$2, ref$4$2) => {
    $as_jl_Void(x$5$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$6$2);
    var ref$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(ref$4$2);
    return ref$4
  }));
  var this$9 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$9))
});
var $d_Lreactbuild_hooks_UseDerivedRef$ = new $TypeData().initClass({
  Lreactbuild_hooks_UseDerivedRef$: 0
}, false, "reactbuild.hooks.UseDerivedRef$", {
  Lreactbuild_hooks_UseDerivedRef$: 1,
  O: 1
});
$c_Lreactbuild_hooks_UseDerivedRef$.prototype.$classData = $d_Lreactbuild_hooks_UseDerivedRef$;
var $n_Lreactbuild_hooks_UseDerivedRef$;
function $m_Lreactbuild_hooks_UseDerivedRef$() {
  if ((!$n_Lreactbuild_hooks_UseDerivedRef$)) {
    $n_Lreactbuild_hooks_UseDerivedRef$ = new $c_Lreactbuild_hooks_UseDerivedRef$()
  };
  return $n_Lreactbuild_hooks_UseDerivedRef$
}
/** @constructor */
function $c_Lreactbuild_hooks_UseLocalStorage$() {
  /*<skip>*/
}
$c_Lreactbuild_hooks_UseLocalStorage$.prototype = new $h_O();
$c_Lreactbuild_hooks_UseLocalStorage$.prototype.constructor = $c_Lreactbuild_hooks_UseLocalStorage$;
/** @constructor */
function $h_Lreactbuild_hooks_UseLocalStorage$() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_UseLocalStorage$.prototype = $c_Lreactbuild_hooks_UseLocalStorage$.prototype;
$c_Lreactbuild_hooks_UseLocalStorage$.prototype.hook__T__F0__Lio_circe_Encoder__Lio_circe_Decoder__F2__F1 = (function(key, default$1, encoder, decoder, reuse) {
  var api = $m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First();
  var this$20 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction0((() => {
    var this$3 = $n($m_s_Option$().apply__O__s_Option($as_T(window.localStorage.getItem(key))));
    var left = new $c_sjsr_AnonFunction0((() => $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("Cannot read " + key) + " entry"))));
    if (this$3.isEmpty__Z()) {
      $n($m_s_package$().s_package$__f_Left);
      var value = left.apply__O();
      var $$x3 = new $c_s_util_Left(value)
    } else {
      $n($m_s_package$().s_package$__f_Right);
      var value$1 = this$3.get__O();
      var $$x3 = new $c_s_util_Right(value$1)
    };
    var cb = $n($$x3).flatMap__F1__s_util_Either(new $c_sjsr_AnonFunction1(((found$2) => {
      var found = $as_T(found$2);
      return $n($m_Lio_circe_parser_package$().parse__T__s_util_Either(found)).flatMap__F1__s_util_Either(new $c_sjsr_AnonFunction1(((json$2) => {
        var json = $as_Lio_circe_Json(json$2);
        var this$6 = $n(json);
        return $n($n(decoder).apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(this$6, null, null))).map__F1__s_util_Either(new $c_sjsr_AnonFunction1(((r$2) => r$2)))
      })))
    })));
    return $n(cb).getOrElse__F0__O(default$1)
  })), new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep())));
  var deps = new $c_sjsr_AnonFunction2(((x$1$2, state$2) => {
    $as_jl_Void(x$1$2);
    var state = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(state$2);
    return $n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value
  }));
  var create = new $c_sjsr_AnonFunction2(((x$2$2, state$3$2) => {
    $as_jl_Void(x$2$2);
    var state$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(state$3$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      var f$2 = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
        var x0$1 = $as_s_Option(x0$1$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        matchEnd7: {
          var $$x4;
          var p2 = $as_s_Option(x1.T2__f__1);
          var cb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x = $m_s_None$();
          if ((x === p2)) {
            var $$x4 = cb$1;
            break matchEnd7
          };
          var p4 = $as_s_Option(x1.T2__f__1);
          var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          if ((p4 instanceof $c_s_Some)) {
            var x5 = $as_s_Some(p4);
            var next = $n(x5).s_Some__f_value;
            var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            $m_Ljapgolly_scalajs_react_callback_Callback$();
            var f = new $c_sjsr_AnonFunction0((() => {
              var $$x5 = window.localStorage;
              var this$11 = $n($n(encoder).apply__O__Lio_circe_Json(next));
              $$x5.setItem(key, $n($m_Lio_circe_Printer$().Lio_circe_Printer$__f_spaces2).print__Lio_circe_Json__T(this$11))
            }));
            var f$1 = new $c_sjsr_AnonFunction0((() => {
              f.apply__O()
            }));
            $m_Ljapgolly_scalajs_react_callback_Trampoline$();
            var $$x6 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1);
            var this$16 = $n(state$3);
            var mod = new $c_sjsr_AnonFunction1(((x$4$2) => next));
            var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)));
            var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
            var $$x4 = $n($$x7).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x6, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$16, mod, callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
            break matchEnd7
          };
          throw new $c_s_MatchError(x1)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x4)
      }));
      return new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn($m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$2))
    }))
  }));
  var this$19 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$19);
  var $$x2 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$20, deps, create, reuse, step)));
  var $$x1 = new $c_sjsr_AnonFunction3(((x$5$2, s$2, ss$2) => {
    $as_jl_Void(x$5$2);
    var s = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(s$2);
    var ss = $as_Ljapgolly_scalajs_react_Reusable(ss$2);
    return $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$().apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($n($as_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn($n(ss).value__O())).Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn__f_japgolly$scalajs$react$extra$internal$StateSnapshot$withReuse$FromSetStateFn$$set, $n(s).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, reuse)
  }));
  var this$21 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$21))
});
var $d_Lreactbuild_hooks_UseLocalStorage$ = new $TypeData().initClass({
  Lreactbuild_hooks_UseLocalStorage$: 0
}, false, "reactbuild.hooks.UseLocalStorage$", {
  Lreactbuild_hooks_UseLocalStorage$: 1,
  O: 1
});
$c_Lreactbuild_hooks_UseLocalStorage$.prototype.$classData = $d_Lreactbuild_hooks_UseLocalStorage$;
var $n_Lreactbuild_hooks_UseLocalStorage$;
function $m_Lreactbuild_hooks_UseLocalStorage$() {
  if ((!$n_Lreactbuild_hooks_UseLocalStorage$)) {
    $n_Lreactbuild_hooks_UseLocalStorage$ = new $c_Lreactbuild_hooks_UseLocalStorage$()
  };
  return $n_Lreactbuild_hooks_UseLocalStorage$
}
function $p_Lreactbuild_hooks_VideoStreaming$__cleanCallback$1__Lorg_scalajs_dom_MediaStream__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__F1($thiz, stream, stateRef$1) {
  var $$x5 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x3 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
  var $$x2 = $uZ(stream.active);
  var $$x1 = $m_sjs_js_ArrayOps$();
  var array = stream.getTracks();
  var array$1 = [$$x2, $n($$x1).map$extension__sjs_js_Array__F1__sjs_js_Array(array, new $c_sjsr_AnonFunction1(((x$6$2) => $uZ(x$6$2.enabled))))];
  return $n($$x5).flatMap$extension__F1__F1__F1($n($$x4).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($$x3).warn__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline("Ready to clean ...", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))), new $c_sjsr_AnonFunction1(((x$14$2) => {
    $as_jl_Void(x$14$2);
    var $$x7 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
    var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $m_Ljapgolly_scalajs_react_Reusable$();
    var this$6 = $n(stateRef$1);
    var this$7 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$6.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
    var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$7);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x7).flatMap$extension__F1__F1__F1($n($$x6).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$7$2) => {
      $as_Ldiode_data_Pot(x$7$2);
      return $m_Ldiode_data_Empty$()
    }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$13$2) => {
      $as_jl_Void(x$13$2);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().attempt$extension__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
        var $$x8 = $m_sjs_js_ArrayOps$();
        var array$2 = stream.getTracks();
        $n($$x8).foreach$extension__sjs_js_Array__F1__V(array$2, new $c_sjsr_AnonFunction1(((x$8$2) => {
          x$8$2.stop()
        })))
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())), new $c_sjsr_AnonFunction1(((v$2) => {
        $as_s_util_Either(v$2);
        var $$x13 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
        var $$x12 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var $$x11 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
        var $$x10 = $uZ(stream.active);
        var $$x9 = $m_sjs_js_ArrayOps$();
        var array$3 = stream.getTracks();
        var array$4 = [$$x10, $n($$x9).map$extension__sjs_js_Array__F1__sjs_js_Array(array$3, new $c_sjsr_AnonFunction1(((x$9$2) => $uZ(x$9$2.enabled))))];
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x13).flatMap$extension__F1__F1__F1($n($$x12).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($$x11).warn__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline("stopped tracks ...", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))), new $c_sjsr_AnonFunction1(((x$12$2) => {
          $as_jl_Void(x$12$2);
          var $$x15 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
          var $$x14 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          $m_Ljapgolly_scalajs_react_Reusable$();
          var this$17 = $n(stateRef$1);
          var this$18 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$17.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
          var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$18);
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x15).map$extension__F1__F1__F1($n($$x14).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$10$2) => {
            var x$10 = $as_Ldiode_data_Pot(x$10$2);
            $n(x$10);
            return $m_Ldiode_data_Unavailable$()
          }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$11$2) => {
            $as_jl_Void(x$11$2)
          }))))
        }))))
      }))))
    }))))
  })))
}
function $p_Lreactbuild_hooks_VideoStreaming$__installCallback$1__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__F1($thiz, stateRef$1, unmountCbRef$1) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $m_Ljapgolly_scalajs_react_Reusable$();
  var this$1 = $n(stateRef$1);
  var this$2 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$1.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
  var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$2);
  return $n($$x2).flatMap$extension__F1__F1__F1($n($$x1).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$15$2) => {
    var x$15 = $as_Ldiode_data_Pot(x$15$2);
    return $n(x$15).pending__J__Ldiode_data_Pot($n(x$15).pending$default$1__J())
  }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$20$2) => {
    $as_jl_Void(x$20$2);
    var $$x4 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
    var x = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
      var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
      var p = $m_Lreactbuild_hooks_VideoStreaming$().requestUserMedia__sjs_js_Promise();
      return $n($$x3).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x4).flatMap$extension__F1__F1__F1(new $c_Lreactbuild_hooks_EnhancedAsyncCallback(x).onError__F1__F1(new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_jl_Throwable(v$2);
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$8 = $n(stateRef$1);
      var this$9 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$8.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$9);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$16$2) => {
        var x$16 = $as_Ldiode_data_Pot(x$16$2);
        return $n(x$16).fail__jl_Throwable__Ldiode_data_Pot(v)
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))), new $c_sjsr_AnonFunction1(((stream$2) => {
      var $$x6 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var this$11 = $n(stateRef$1);
      var this$12 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$11.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
      var r$2 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$12);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x6).flatMap$extension__F1__F1__F1($n($$x5).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$2).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$17$2) => {
        var x$17 = $as_Ldiode_data_Pot(x$17$2);
        $n(x$17);
        return new $c_Ldiode_data_Ready(stream$2)
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$19$2) => {
        $as_jl_Void(x$19$2);
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(unmountCbRef$1).set__O__O(new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($p_Lreactbuild_hooks_VideoStreaming$__cleanCallback$1__Lorg_scalajs_dom_MediaStream__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__F1($thiz, stream$2, stateRef$1)))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$18$2) => {
          $as_jl_Void(x$18$2)
        }))))
      }))))
    }))))
  })))
}
/** @constructor */
function $c_Lreactbuild_hooks_VideoStreaming$() {
  this.Lreactbuild_hooks_VideoStreaming$__f_reusePot = null;
  this.Lreactbuild_hooks_VideoStreaming$__f_hook = null;
  $n_Lreactbuild_hooks_VideoStreaming$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_hooks_VideoStreaming$__f_reusePot = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var this$5 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => $m_Ldiode_data_Empty$()));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$5, initialState, step));
  var $$x6 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x5 = new $c_sjsr_AnonFunction2(((x$1$2, state$2) => {
    $as_jl_Void(x$1$2);
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$2);
    return state
  }));
  var $$x4 = new $c_sjsr_AnonFunction2(((x$2$2, state$3$2) => {
    $as_jl_Void(x$2$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$3$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$3$2);
      return state$3
    }))
  }));
  var $$x3 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$().reusability__F2__F2(this.Lreactbuild_hooks_VideoStreaming$__f_reusePot);
  var this$7 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var this$9 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($$x6.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x5, $$x4, $$x3, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$7))));
  var initialValue = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)));
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$8);
  var this$21 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRef__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$9, initialValue, step$1)));
  var effect = new $c_sjsr_AnonFunction4(((x$4$2, x$5$2, stateRef$2, unmountCbRef$2) => {
    $as_jl_Void(x$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$5$2);
    var stateRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(stateRef$2);
    var unmountCbRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(unmountCbRef$2);
    var this$$1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().logAround$extension__F1__O__sci_Seq__F1($p_Lreactbuild_hooks_VideoStreaming$__installCallback$1__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__F1(this, stateRef, unmountCbRef), "install stream", $m_sci_Nil$()));
    var f$1 = new $c_sjsr_AnonFunction1(((x$21$2) => {
      $as_jl_Void(x$21$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
      var f = new $c_sjsr_AnonFunction0((() => {
        var this$10 = $n(unmountCbRef);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$10.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      var this$ = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
      var this$14 = $m_s_$less$colon$less$();
      var ev = this$14.s_$less$colon$less$__f_singleton;
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, ev))
    }));
    var this$17 = $n(this$$1);
    var cb = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$17, f$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$20 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44(this$20);
  var $$x2 = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$21, effect, a, step$2));
  var $$x1 = new $c_sjsr_AnonFunction4(((x$22$2, state$4$2, x$23$2, x$24$2) => {
    $as_jl_Void(x$22$2);
    var state$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(state$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$23$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$24$2);
    var this$22 = $n(state$4);
    return $as_Ldiode_data_Pot(this$22.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])
  }));
  var this$23 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  this.Lreactbuild_hooks_VideoStreaming$__f_hook = $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44(this$23))
}
$c_Lreactbuild_hooks_VideoStreaming$.prototype = new $h_O();
$c_Lreactbuild_hooks_VideoStreaming$.prototype.constructor = $c_Lreactbuild_hooks_VideoStreaming$;
/** @constructor */
function $h_Lreactbuild_hooks_VideoStreaming$() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_VideoStreaming$.prototype = $c_Lreactbuild_hooks_VideoStreaming$.prototype;
$c_Lreactbuild_hooks_VideoStreaming$.prototype.requestUserMedia__sjs_js_Promise = (function() {
  return window.navigator.mediaDevices.getUserMedia((() => {
    var this$1 = {};
    this$1.audio = false;
    var a$1 = (() => {
      var outer = null;
      outer = this$1;
      var this$6 = {};
      var a = [(() => {
        var outer$1 = null;
        outer$1 = this$6;
        var this$7 = {};
        this$7.width = 640;
        this$7.height = 480;
        this$7.facingMode = "environment";
        return this$7
      })()];
      this$6.advanced = a;
      return this$6
    })();
    this$1.video = a$1;
    return this$1
  })())
});
var $d_Lreactbuild_hooks_VideoStreaming$ = new $TypeData().initClass({
  Lreactbuild_hooks_VideoStreaming$: 0
}, false, "reactbuild.hooks.VideoStreaming$", {
  Lreactbuild_hooks_VideoStreaming$: 1,
  O: 1
});
$c_Lreactbuild_hooks_VideoStreaming$.prototype.$classData = $d_Lreactbuild_hooks_VideoStreaming$;
var $n_Lreactbuild_hooks_VideoStreaming$;
function $m_Lreactbuild_hooks_VideoStreaming$() {
  if ((!$n_Lreactbuild_hooks_VideoStreaming$)) {
    $n_Lreactbuild_hooks_VideoStreaming$ = new $c_Lreactbuild_hooks_VideoStreaming$()
  };
  return $n_Lreactbuild_hooks_VideoStreaming$
}
/** @constructor */
function $c_Lreactbuild_math_package$SquareRoot$() {
  this.Lreactbuild_math_package$SquareRoot$__f_zero = 0.0;
  this.Lreactbuild_math_package$SquareRoot$__f_one = 0.0;
  this.Lreactbuild_math_package$SquareRoot$__f_two = 0.0;
  this.Lreactbuild_math_package$SquareRoot$__f_cache = null;
  $n_Lreactbuild_math_package$SquareRoot$ = this;
  this.Lreactbuild_math_package$SquareRoot$__f_zero = 0.0;
  this.Lreactbuild_math_package$SquareRoot$__f_one = 1.0;
  this.Lreactbuild_math_package$SquareRoot$__f_two = $uD(Math.sqrt(2.0));
  var this$2 = $m_scm_ArrayBuffer$();
  var elems = $m_sci_Nil$();
  this.Lreactbuild_math_package$SquareRoot$__f_cache = this$2.from__sc_IterableOnce__scm_ArrayBuffer(elems)
}
$c_Lreactbuild_math_package$SquareRoot$.prototype = new $h_O();
$c_Lreactbuild_math_package$SquareRoot$.prototype.constructor = $c_Lreactbuild_math_package$SquareRoot$;
/** @constructor */
function $h_Lreactbuild_math_package$SquareRoot$() {
  /*<skip>*/
}
$h_Lreactbuild_math_package$SquareRoot$.prototype = $c_Lreactbuild_math_package$SquareRoot$.prototype;
var $d_Lreactbuild_math_package$SquareRoot$ = new $TypeData().initClass({
  Lreactbuild_math_package$SquareRoot$: 0
}, false, "reactbuild.math.package$SquareRoot$", {
  Lreactbuild_math_package$SquareRoot$: 1,
  O: 1
});
$c_Lreactbuild_math_package$SquareRoot$.prototype.$classData = $d_Lreactbuild_math_package$SquareRoot$;
var $n_Lreactbuild_math_package$SquareRoot$;
function $m_Lreactbuild_math_package$SquareRoot$() {
  if ((!$n_Lreactbuild_math_package$SquareRoot$)) {
    $n_Lreactbuild_math_package$SquareRoot$ = new $c_Lreactbuild_math_package$SquareRoot$()
  };
  return $n_Lreactbuild_math_package$SquareRoot$
}
function $is_Lreactbuild_model_CommunicationBody(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_CommunicationBody)))
}
function $as_Lreactbuild_model_CommunicationBody(obj) {
  return (($is_Lreactbuild_model_CommunicationBody(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommunicationBody"))
}
function $isArrayOf_Lreactbuild_model_CommunicationBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommunicationBody)))
}
function $asArrayOf_Lreactbuild_model_CommunicationBody(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommunicationBody(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommunicationBody;", depth))
}
var $d_Lreactbuild_model_CommunicationBody = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody: 0
}, true, "reactbuild.model.CommunicationBody", {
  Lreactbuild_model_CommunicationBody: 1,
  O: 1
});
/** @constructor */
function $c_Lreactbuild_model_CommunicationBody$() {
  this.Lreactbuild_model_CommunicationBody$__f_codecForCommunicationBody = null;
  $n_Lreactbuild_model_CommunicationBody$ = this;
  var inst$macro$80 = new $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$80));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_CommunicationBody$__f_codecForCommunicationBody = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_CommunicationBody$.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationBody$.prototype.constructor = $c_Lreactbuild_model_CommunicationBody$;
/** @constructor */
function $h_Lreactbuild_model_CommunicationBody$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationBody$.prototype = $c_Lreactbuild_model_CommunicationBody$.prototype;
var $d_Lreactbuild_model_CommunicationBody$ = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody$: 0
}, false, "reactbuild.model.CommunicationBody$", {
  Lreactbuild_model_CommunicationBody$: 1,
  O: 1
});
$c_Lreactbuild_model_CommunicationBody$.prototype.$classData = $d_Lreactbuild_model_CommunicationBody$;
var $n_Lreactbuild_model_CommunicationBody$;
function $m_Lreactbuild_model_CommunicationBody$() {
  if ((!$n_Lreactbuild_model_CommunicationBody$)) {
    $n_Lreactbuild_model_CommunicationBody$ = new $c_Lreactbuild_model_CommunicationBody$()
  };
  return $n_Lreactbuild_model_CommunicationBody$
}
function $is_Lreactbuild_model_CommunicationRole(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_CommunicationRole)))
}
function $as_Lreactbuild_model_CommunicationRole(obj) {
  return (($is_Lreactbuild_model_CommunicationRole(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommunicationRole"))
}
function $isArrayOf_Lreactbuild_model_CommunicationRole(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommunicationRole)))
}
function $asArrayOf_Lreactbuild_model_CommunicationRole(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommunicationRole(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommunicationRole;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_CommunicationRole$() {
  this.Lreactbuild_model_CommunicationRole$__f_codecForCommunicationRole = null;
  $n_Lreactbuild_model_CommunicationRole$ = this;
  var inst$macro$14 = new $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$14));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_CommunicationRole$__f_codecForCommunicationRole = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_CommunicationRole$.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationRole$.prototype.constructor = $c_Lreactbuild_model_CommunicationRole$;
/** @constructor */
function $h_Lreactbuild_model_CommunicationRole$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationRole$.prototype = $c_Lreactbuild_model_CommunicationRole$.prototype;
var $d_Lreactbuild_model_CommunicationRole$ = new $TypeData().initClass({
  Lreactbuild_model_CommunicationRole$: 0
}, false, "reactbuild.model.CommunicationRole$", {
  Lreactbuild_model_CommunicationRole$: 1,
  O: 1
});
$c_Lreactbuild_model_CommunicationRole$.prototype.$classData = $d_Lreactbuild_model_CommunicationRole$;
var $n_Lreactbuild_model_CommunicationRole$;
function $m_Lreactbuild_model_CommunicationRole$() {
  if ((!$n_Lreactbuild_model_CommunicationRole$)) {
    $n_Lreactbuild_model_CommunicationRole$ = new $c_Lreactbuild_model_CommunicationRole$()
  };
  return $n_Lreactbuild_model_CommunicationRole$
}
/** @constructor */
function $c_Lreactbuild_model_DeliveryFormDetails() {
  /*<skip>*/
}
$c_Lreactbuild_model_DeliveryFormDetails.prototype = new $h_O();
$c_Lreactbuild_model_DeliveryFormDetails.prototype.constructor = $c_Lreactbuild_model_DeliveryFormDetails;
/** @constructor */
function $h_Lreactbuild_model_DeliveryFormDetails() {
  /*<skip>*/
}
$h_Lreactbuild_model_DeliveryFormDetails.prototype = $c_Lreactbuild_model_DeliveryFormDetails.prototype;
function $as_Lreactbuild_model_DeliveryFormDetails(obj) {
  return (((obj instanceof $c_Lreactbuild_model_DeliveryFormDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.DeliveryFormDetails"))
}
function $isArrayOf_Lreactbuild_model_DeliveryFormDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_DeliveryFormDetails)))
}
function $asArrayOf_Lreactbuild_model_DeliveryFormDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_DeliveryFormDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.DeliveryFormDetails;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_DeliveryFormDetails$() {
  this.Lreactbuild_model_DeliveryFormDetails$__f_codecForDeliveryFormDetails = null;
  $n_Lreactbuild_model_DeliveryFormDetails$ = this;
  var inst$macro$124 = new $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$124));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_DeliveryFormDetails$__f_codecForDeliveryFormDetails = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_DeliveryFormDetails$.prototype = new $h_O();
$c_Lreactbuild_model_DeliveryFormDetails$.prototype.constructor = $c_Lreactbuild_model_DeliveryFormDetails$;
/** @constructor */
function $h_Lreactbuild_model_DeliveryFormDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_model_DeliveryFormDetails$.prototype = $c_Lreactbuild_model_DeliveryFormDetails$.prototype;
var $d_Lreactbuild_model_DeliveryFormDetails$ = new $TypeData().initClass({
  Lreactbuild_model_DeliveryFormDetails$: 0
}, false, "reactbuild.model.DeliveryFormDetails$", {
  Lreactbuild_model_DeliveryFormDetails$: 1,
  O: 1
});
$c_Lreactbuild_model_DeliveryFormDetails$.prototype.$classData = $d_Lreactbuild_model_DeliveryFormDetails$;
var $n_Lreactbuild_model_DeliveryFormDetails$;
function $m_Lreactbuild_model_DeliveryFormDetails$() {
  if ((!$n_Lreactbuild_model_DeliveryFormDetails$)) {
    $n_Lreactbuild_model_DeliveryFormDetails$ = new $c_Lreactbuild_model_DeliveryFormDetails$()
  };
  return $n_Lreactbuild_model_DeliveryFormDetails$
}
function $ct_Lreactbuild_model_DocumentCategory__T__($thiz, code) {
  $thiz.Lreactbuild_model_DocumentCategory__f_code = code;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_model_DocumentCategory() {
  this.Lreactbuild_model_DocumentCategory__f_code = null
}
$c_Lreactbuild_model_DocumentCategory.prototype = new $h_O();
$c_Lreactbuild_model_DocumentCategory.prototype.constructor = $c_Lreactbuild_model_DocumentCategory;
/** @constructor */
function $h_Lreactbuild_model_DocumentCategory() {
  /*<skip>*/
}
$h_Lreactbuild_model_DocumentCategory.prototype = $c_Lreactbuild_model_DocumentCategory.prototype;
function $as_Lreactbuild_model_DocumentCategory(obj) {
  return (((obj instanceof $c_Lreactbuild_model_DocumentCategory) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.DocumentCategory"))
}
function $isArrayOf_Lreactbuild_model_DocumentCategory(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_DocumentCategory)))
}
function $asArrayOf_Lreactbuild_model_DocumentCategory(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_DocumentCategory(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.DocumentCategory;", depth))
}
var $d_Lreactbuild_model_DocumentCategory = new $TypeData().initClass({
  Lreactbuild_model_DocumentCategory: 0
}, false, "reactbuild.model.DocumentCategory", {
  Lreactbuild_model_DocumentCategory: 1,
  O: 1
});
$c_Lreactbuild_model_DocumentCategory.prototype.$classData = $d_Lreactbuild_model_DocumentCategory;
/** @constructor */
function $c_Lreactbuild_model_DocumentCategory$() {
  this.Lreactbuild_model_DocumentCategory$__f_list = null;
  this.Lreactbuild_model_DocumentCategory$__f_mapFromCode = null;
  this.Lreactbuild_model_DocumentCategory$__f_encodeDocumentCategory = null;
  this.Lreactbuild_model_DocumentCategory$__f_decodeDocumentCategory = null;
  $n_Lreactbuild_model_DocumentCategory$ = this;
  var this$4 = $m_sci_ListSet$();
  var array = [$m_Lreactbuild_model_DocumentCategory$Order$(), $m_Lreactbuild_model_DocumentCategory$Invoice$(), $m_Lreactbuild_model_DocumentCategory$Certificate$(), $m_Lreactbuild_model_DocumentCategory$Statement$(), $m_Lreactbuild_model_DocumentCategory$Quote$(), $m_Lreactbuild_model_DocumentCategory$PriceOffer$(), $m_Lreactbuild_model_DocumentCategory$DeliveryForm$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_model_DocumentCategory$__f_list = this$4.from__sc_IterableOnce__sci_ListSet(elems);
  var this$5 = $n(this.Lreactbuild_model_DocumentCategory$__f_list);
  var b = new $c_sci_ListSet$$anon$1();
  var it = this$5.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var arg1 = $n(it).next__O();
    var c = $as_Lreactbuild_model_DocumentCategory(arg1);
    var self = $n(c).Lreactbuild_model_DocumentCategory__f_code;
    var elem = $ct_T2__O__O__(new $c_T2(), self, c);
    b.addOne__O__sci_ListSet$$anon$1(elem)
  };
  var $$x1 = $as_sc_IterableOnceOps(b.scm_ImmutableBuilder__f_elems);
  var this$9 = $m_s_$less$colon$less$();
  this.Lreactbuild_model_DocumentCategory$__f_mapFromCode = $n($$x1).toMap__s_$less$colon$less__sci_Map(this$9.s_$less$colon$less$__f_singleton);
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var this$11 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_model_DocumentCategory(x$3$2);
    return $n(x$3).Lreactbuild_model_DocumentCategory__f_code
  }));
  this.Lreactbuild_model_DocumentCategory$__f_encodeDocumentCategory = new $c_Lio_circe_Encoder$$anon$1(this$11, f);
  $m_Lio_circe_Decoder$();
  var instance$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$13 = $n(instance$1);
  var f$1 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_T(x$4$2);
    return $as_Lreactbuild_model_DocumentCategory($n($m_Lreactbuild_model_DocumentCategory$().Lreactbuild_model_DocumentCategory$__f_mapFromCode).apply__O__O(x$4))
  }));
  this.Lreactbuild_model_DocumentCategory$__f_decodeDocumentCategory = new $c_Lio_circe_Decoder$$anon$1(this$13, f$1)
}
$c_Lreactbuild_model_DocumentCategory$.prototype = new $h_O();
$c_Lreactbuild_model_DocumentCategory$.prototype.constructor = $c_Lreactbuild_model_DocumentCategory$;
/** @constructor */
function $h_Lreactbuild_model_DocumentCategory$() {
  /*<skip>*/
}
$h_Lreactbuild_model_DocumentCategory$.prototype = $c_Lreactbuild_model_DocumentCategory$.prototype;
var $d_Lreactbuild_model_DocumentCategory$ = new $TypeData().initClass({
  Lreactbuild_model_DocumentCategory$: 0
}, false, "reactbuild.model.DocumentCategory$", {
  Lreactbuild_model_DocumentCategory$: 1,
  O: 1
});
$c_Lreactbuild_model_DocumentCategory$.prototype.$classData = $d_Lreactbuild_model_DocumentCategory$;
var $n_Lreactbuild_model_DocumentCategory$;
function $m_Lreactbuild_model_DocumentCategory$() {
  if ((!$n_Lreactbuild_model_DocumentCategory$)) {
    $n_Lreactbuild_model_DocumentCategory$ = new $c_Lreactbuild_model_DocumentCategory$()
  };
  return $n_Lreactbuild_model_DocumentCategory$
}
function $is_Lreactbuild_model_Expression(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_Expression)))
}
function $as_Lreactbuild_model_Expression(obj) {
  return (($is_Lreactbuild_model_Expression(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Expression"))
}
function $isArrayOf_Lreactbuild_model_Expression(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Expression)))
}
function $asArrayOf_Lreactbuild_model_Expression(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Expression(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Expression;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_Expression$() {
  /*<skip>*/
}
$c_Lreactbuild_model_Expression$.prototype = new $h_O();
$c_Lreactbuild_model_Expression$.prototype.constructor = $c_Lreactbuild_model_Expression$;
/** @constructor */
function $h_Lreactbuild_model_Expression$() {
  /*<skip>*/
}
$h_Lreactbuild_model_Expression$.prototype = $c_Lreactbuild_model_Expression$.prototype;
$c_Lreactbuild_model_Expression$.prototype.encodeExpression__Lio_circe_Encoder = (function() {
  var this$2 = $n($m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeUnit);
  var f = new $c_sjsr_AnonFunction1(((x$27$2) => {
    $as_Lreactbuild_model_Expression(x$27$2)
  }));
  return new $c_Lio_circe_Encoder$$anon$1(this$2, f)
});
$c_Lreactbuild_model_Expression$.prototype.decodeExpression__Lio_circe_Decoder = (function() {
  var this$2 = $n($m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit);
  var f = new $c_sjsr_AnonFunction1(((x$28$2) => {
    $as_jl_Void(x$28$2);
    return new $c_Lreactbuild_model_Expression$$anon$82()
  }));
  return new $c_Lio_circe_Decoder$$anon$1(this$2, f)
});
var $d_Lreactbuild_model_Expression$ = new $TypeData().initClass({
  Lreactbuild_model_Expression$: 0
}, false, "reactbuild.model.Expression$", {
  Lreactbuild_model_Expression$: 1,
  O: 1
});
$c_Lreactbuild_model_Expression$.prototype.$classData = $d_Lreactbuild_model_Expression$;
var $n_Lreactbuild_model_Expression$;
function $m_Lreactbuild_model_Expression$() {
  if ((!$n_Lreactbuild_model_Expression$)) {
    $n_Lreactbuild_model_Expression$ = new $c_Lreactbuild_model_Expression$()
  };
  return $n_Lreactbuild_model_Expression$
}
function $is_Lreactbuild_model_FromClient(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_FromClient)))
}
function $as_Lreactbuild_model_FromClient(obj) {
  return (($is_Lreactbuild_model_FromClient(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.FromClient"))
}
function $isArrayOf_Lreactbuild_model_FromClient(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_FromClient)))
}
function $asArrayOf_Lreactbuild_model_FromClient(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_FromClient(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.FromClient;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_FromClient$() {
  this.Lreactbuild_model_FromClient$__f_codecForFromClient = null;
  $n_Lreactbuild_model_FromClient$ = this;
  var inst$macro$32 = new $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1().inst$macro$1__Lio_circe_generic_codec_DerivedAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$32));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_FromClient$__f_codecForFromClient = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_FromClient$.prototype = new $h_O();
$c_Lreactbuild_model_FromClient$.prototype.constructor = $c_Lreactbuild_model_FromClient$;
/** @constructor */
function $h_Lreactbuild_model_FromClient$() {
  /*<skip>*/
}
$h_Lreactbuild_model_FromClient$.prototype = $c_Lreactbuild_model_FromClient$.prototype;
var $d_Lreactbuild_model_FromClient$ = new $TypeData().initClass({
  Lreactbuild_model_FromClient$: 0
}, false, "reactbuild.model.FromClient$", {
  Lreactbuild_model_FromClient$: 1,
  O: 1
});
$c_Lreactbuild_model_FromClient$.prototype.$classData = $d_Lreactbuild_model_FromClient$;
var $n_Lreactbuild_model_FromClient$;
function $m_Lreactbuild_model_FromClient$() {
  if ((!$n_Lreactbuild_model_FromClient$)) {
    $n_Lreactbuild_model_FromClient$ = new $c_Lreactbuild_model_FromClient$()
  };
  return $n_Lreactbuild_model_FromClient$
}
function $is_Lreactbuild_model_ListEntry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ListEntry)))
}
function $as_Lreactbuild_model_ListEntry(obj) {
  return (($is_Lreactbuild_model_ListEntry(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntry"))
}
function $isArrayOf_Lreactbuild_model_ListEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntry)))
}
function $asArrayOf_Lreactbuild_model_ListEntry(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntry;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_ListEntry$() {
  this.Lreactbuild_model_ListEntry$__f_encodeTemplatedListEntry = null;
  this.Lreactbuild_model_ListEntry$__f_decodeTemplatedListEntry = null;
  this.Lreactbuild_model_ListEntry$__f_encodeCustomListEntry = null;
  this.Lreactbuild_model_ListEntry$__f_decodeCustomListEntry = null;
  this.Lreactbuild_model_ListEntry$__f_encodeListEntry = null;
  this.Lreactbuild_model_ListEntry$__f_decodeListEntry = null;
  $n_Lreactbuild_model_ListEntry$ = this;
  var inst$macro$44 = new $c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8().inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var encode = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_ListEntry$__f_encodeTemplatedListEntry = $as_Lio_circe_Encoder$AsObject(encode.value__O());
  var inst$macro$88 = new $c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1().inst$macro$45__Lio_circe_generic_extras_decoding_ConfiguredDecoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$88));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_model_ListEntry$__f_decodeTemplatedListEntry = $as_Lio_circe_Decoder(decode.value__O());
  var inst$macro$156 = new $c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1().inst$macro$89__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder();
  var t$2 = new $c_sjsr_AnonFunction0((() => inst$macro$156));
  var encode$1 = new $c_Lshapeless_Lazy$$anon$1(t$2);
  this.Lreactbuild_model_ListEntry$__f_encodeCustomListEntry = $as_Lio_circe_Encoder$AsObject(encode$1.value__O());
  var inst$macro$224 = new $c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1().inst$macro$157__Lio_circe_generic_extras_decoding_ConfiguredDecoder();
  var t$3 = new $c_sjsr_AnonFunction0((() => inst$macro$224));
  var decode$1 = new $c_Lshapeless_Lazy$$anon$1(t$3);
  this.Lreactbuild_model_ListEntry$__f_decodeCustomListEntry = $as_Lio_circe_Decoder(decode$1.value__O());
  $m_Lio_circe_Encoder$AsObject$();
  var f = new $c_sjsr_AnonFunction1(((x0$33$2) => {
    var x0$33 = $as_Lreactbuild_model_ListEntry(x0$33$2);
    if ((x0$33 instanceof $c_Lreactbuild_model_InstanceListEntry)) {
      var x2 = $as_Lreactbuild_model_InstanceListEntry(x0$33);
      var encoder = $m_Lreactbuild_model_ListEntry$().Lreactbuild_model_ListEntry$__f_encodeTemplatedListEntry;
      return $n(encoder).encodeObject__O__Lio_circe_JsonObject(x2)
    } else if ((x0$33 instanceof $c_Lreactbuild_model_CustomListEntry)) {
      var x3 = $as_Lreactbuild_model_CustomListEntry(x0$33);
      var encoder$1 = $m_Lreactbuild_model_ListEntry$().Lreactbuild_model_ListEntry$__f_encodeCustomListEntry;
      return $n(encoder$1).encodeObject__O__Lio_circe_JsonObject(x3)
    } else {
      throw new $c_s_MatchError(x0$33)
    }
  }));
  this.Lreactbuild_model_ListEntry$__f_encodeListEntry = new $c_Lio_circe_Encoder$AsObject$$anon$67(f);
  $n($m_s_package$().s_package$__f_List);
  var this$16 = $m_Lcats_syntax_package$functor$();
  $m_Lio_circe_Decoder$();
  var instance = this.Lreactbuild_model_ListEntry$__f_decodeTemplatedListEntry;
  var tc = $as_Lcats_Functor($m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decoderInstances);
  var this$17 = new $c_Lcats_Functor$ToFunctorOps$$anon$4(this$16, instance, tc);
  $n(this$17.Lcats_Functor$ToFunctorOps$$anon$4__f_typeClassInstance);
  var fa = this$17.Lcats_Functor$ToFunctorOps$$anon$4__f_self;
  var $$x1 = $as_Lio_circe_Decoder(fa);
  var this$20 = $m_Lcats_syntax_package$functor$();
  $m_Lio_circe_Decoder$();
  var instance$1 = this.Lreactbuild_model_ListEntry$__f_decodeCustomListEntry;
  var tc$1 = $as_Lcats_Functor($m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decoderInstances);
  var this$21 = new $c_Lcats_Functor$ToFunctorOps$$anon$4(this$20, instance$1, tc$1);
  $n(this$21.Lcats_Functor$ToFunctorOps$$anon$4__f_typeClassInstance);
  var fa$1 = this$21.Lcats_Functor$ToFunctorOps$$anon$4__f_self;
  var array = [$$x1, $as_Lio_circe_Decoder(fa$1)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$28 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var f$1 = ((x$25$2, x$26$2) => {
    var x$25 = $as_Lio_circe_Decoder(x$25$2);
    var x$26 = $as_Lio_circe_Decoder(x$26$2);
    var this$27 = $n(x$25);
    var d = new $c_sjsr_AnonFunction0((() => x$26));
    return new $c_Lio_circe_Decoder$$anon$9(this$27, d)
  });
  matchEnd4: {
    var $$x2;
    if ($is_sc_IndexedSeq(this$28)) {
      var x2$1 = $as_sc_IndexedSeq(this$28);
      if (($n(x2$1).length__I() > 0)) {
        var z = $n(x2$1).apply__I__O(0);
        var at = 1;
        var end = $n(x2$1).length__I();
        var acc = z;
        while (true) {
          if ((at !== end)) {
            var temp$at = ((1 + at) | 0);
            var arg1 = acc;
            var arg2 = $n(x2$1).apply__I__O(at);
            var temp$acc = f$1(arg1, arg2);
            at = temp$at;
            acc = temp$acc;
            continue
          };
          var $$x2 = acc;
          break matchEnd4
        }
      }
    };
    if ((this$28.knownSize__I() === 0)) {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
    };
    var it = this$28.iterator__sc_Iterator();
    if ((!$n(it).hasNext__Z())) {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
    };
    var acc$1 = $n(it).next__O();
    while ($n(it).hasNext__Z()) {
      var arg1$1 = acc$1;
      var arg2$1 = $n(it).next__O();
      acc$1 = f$1(arg1$1, arg2$1)
    };
    var $$x2 = acc$1
  };
  this.Lreactbuild_model_ListEntry$__f_decodeListEntry = $as_Lio_circe_Decoder($$x2)
}
$c_Lreactbuild_model_ListEntry$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntry$.prototype.constructor = $c_Lreactbuild_model_ListEntry$;
/** @constructor */
function $h_Lreactbuild_model_ListEntry$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntry$.prototype = $c_Lreactbuild_model_ListEntry$.prototype;
var $d_Lreactbuild_model_ListEntry$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntry$: 0
}, false, "reactbuild.model.ListEntry$", {
  Lreactbuild_model_ListEntry$: 1,
  O: 1
});
$c_Lreactbuild_model_ListEntry$.prototype.$classData = $d_Lreactbuild_model_ListEntry$;
var $n_Lreactbuild_model_ListEntry$;
function $m_Lreactbuild_model_ListEntry$() {
  if ((!$n_Lreactbuild_model_ListEntry$)) {
    $n_Lreactbuild_model_ListEntry$ = new $c_Lreactbuild_model_ListEntry$()
  };
  return $n_Lreactbuild_model_ListEntry$
}
function $is_Lreactbuild_model_ListEntryEventBody(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ListEntryEventBody)))
}
function $as_Lreactbuild_model_ListEntryEventBody(obj) {
  return (($is_Lreactbuild_model_ListEntryEventBody(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$() {
  this.Lreactbuild_model_ListEntryEventBody$__f_codecForListEntryEventBody = null;
  $n_Lreactbuild_model_ListEntryEventBody$ = this;
  var inst$macro$184 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$184));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_ListEntryEventBody$__f_codecForListEntryEventBody = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_ListEntryEventBody$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$.prototype = $c_Lreactbuild_model_ListEntryEventBody$.prototype;
var $d_Lreactbuild_model_ListEntryEventBody$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$: 0
}, false, "reactbuild.model.ListEntryEventBody$", {
  Lreactbuild_model_ListEntryEventBody$: 1,
  O: 1
});
$c_Lreactbuild_model_ListEntryEventBody$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$;
var $n_Lreactbuild_model_ListEntryEventBody$;
function $m_Lreactbuild_model_ListEntryEventBody$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$)) {
    $n_Lreactbuild_model_ListEntryEventBody$ = new $c_Lreactbuild_model_ListEntryEventBody$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$
}
function $is_Lreactbuild_model_ListEntryType(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ListEntryType)))
}
function $as_Lreactbuild_model_ListEntryType(obj) {
  return (($is_Lreactbuild_model_ListEntryType(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryType"))
}
function $isArrayOf_Lreactbuild_model_ListEntryType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryType)))
}
function $asArrayOf_Lreactbuild_model_ListEntryType(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryType;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryType$() {
  this.Lreactbuild_model_ListEntryType$__f_orderedList = null;
  this.Lreactbuild_model_ListEntryType$__f_codecForListEntryType = null;
  $n_Lreactbuild_model_ListEntryType$ = this;
  $n($m_s_package$().s_package$__f_List);
  var array = [$m_Lreactbuild_model_ListEntryType$CheckList$(), $m_Lreactbuild_model_ListEntryType$TaskList$(), $m_Lreactbuild_model_ListEntryType$Supply$(), $m_Lreactbuild_model_ListEntryType$Issue$(), $m_Lreactbuild_model_ListEntryType$Guideline$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_model_ListEntryType$__f_orderedList = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var inst$macro$16 = new $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$16));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_ListEntryType$__f_codecForListEntryType = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_ListEntryType$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryType$.prototype.constructor = $c_Lreactbuild_model_ListEntryType$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryType$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryType$.prototype = $c_Lreactbuild_model_ListEntryType$.prototype;
var $d_Lreactbuild_model_ListEntryType$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryType$: 0
}, false, "reactbuild.model.ListEntryType$", {
  Lreactbuild_model_ListEntryType$: 1,
  O: 1
});
$c_Lreactbuild_model_ListEntryType$.prototype.$classData = $d_Lreactbuild_model_ListEntryType$;
var $n_Lreactbuild_model_ListEntryType$;
function $m_Lreactbuild_model_ListEntryType$() {
  if ((!$n_Lreactbuild_model_ListEntryType$)) {
    $n_Lreactbuild_model_ListEntryType$ = new $c_Lreactbuild_model_ListEntryType$()
  };
  return $n_Lreactbuild_model_ListEntryType$
}
function $is_Lreactbuild_model_ListEntryValidation(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ListEntryValidation)))
}
function $as_Lreactbuild_model_ListEntryValidation(obj) {
  return (($is_Lreactbuild_model_ListEntryValidation(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryValidation"))
}
function $isArrayOf_Lreactbuild_model_ListEntryValidation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryValidation)))
}
function $asArrayOf_Lreactbuild_model_ListEntryValidation(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryValidation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryValidation;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryValidation$() {
  this.Lreactbuild_model_ListEntryValidation$__f_codecForListEntryValidation = null;
  $n_Lreactbuild_model_ListEntryValidation$ = this;
  var inst$macro$10 = new $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$10));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_ListEntryValidation$__f_codecForListEntryValidation = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_ListEntryValidation$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryValidation$.prototype.constructor = $c_Lreactbuild_model_ListEntryValidation$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryValidation$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryValidation$.prototype = $c_Lreactbuild_model_ListEntryValidation$.prototype;
var $d_Lreactbuild_model_ListEntryValidation$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryValidation$: 0
}, false, "reactbuild.model.ListEntryValidation$", {
  Lreactbuild_model_ListEntryValidation$: 1,
  O: 1
});
$c_Lreactbuild_model_ListEntryValidation$.prototype.$classData = $d_Lreactbuild_model_ListEntryValidation$;
var $n_Lreactbuild_model_ListEntryValidation$;
function $m_Lreactbuild_model_ListEntryValidation$() {
  if ((!$n_Lreactbuild_model_ListEntryValidation$)) {
    $n_Lreactbuild_model_ListEntryValidation$ = new $c_Lreactbuild_model_ListEntryValidation$()
  };
  return $n_Lreactbuild_model_ListEntryValidation$
}
function $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable($thiz, locale) {
  var pattern = $thiz.Lreactbuild_model_Implicits$__f_dateTimePattern;
  var $$x1 = $n($n($m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__Ljava_time_format_DateTimeFormatter(pattern)).withLocale__ju_Locale__Ljava_time_format_DateTimeFormatter(locale));
  var aliasMap = $m_Ljava_time_ZoneId$().SHORT_IDS__ju_Map();
  var dateFormatter = $n($$x1).withZone__Ljava_time_ZoneId__Ljava_time_format_DateTimeFormatter($m_Ljava_time_ZoneId$().of__T__ju_Map__Ljava_time_ZoneId("ECT", aliasMap));
  $m_Lcom_iz2use_common_Textualizable$();
  var f = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljava_time_Instant(x$3$2);
    return $n(dateFormatter).format__Ljava_time_temporal_TemporalAccessor__T(x$3)
  }));
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var this$4 = $n(parsable);
  return new $c_Lcom_iz2use_common_Textualizable$$anon$1(this$4, f)
}
function $f_Lreactbuild_model_LowPriorityImplicits__TextualizableLocalDateTime__Lcom_iz2use_common_Textualizable($thiz) {
  var pattern = $thiz.Lreactbuild_model_Implicits$__f_dateTimePattern;
  var datetimeFormatter = $m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__Ljava_time_format_DateTimeFormatter(pattern);
  $m_Lcom_iz2use_common_Textualizable$();
  var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Ljava_time_LocalDateTime(x$4$2);
    return $n(datetimeFormatter).format__Ljava_time_temporal_TemporalAccessor__T(x$4)
  }));
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var this$4 = $n(parsable);
  return new $c_Lcom_iz2use_common_Textualizable$$anon$1(this$4, f)
}
function $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format($thiz) {
  $n($m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_Format);
  var format = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var this$2 = $n(format);
  return new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(this$2)
}
function $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable($thiz, proxy) {
  $m_Lcom_iz2use_common_Textualizable$();
  var f = new $c_sjsr_AnonFunction1(((_id$2) => {
    var _id = $as_Lreactbuild_common_model_RefTo(_id$2);
    $m_Lreactbuild_package$();
    new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
    var this$4 = $n(proxy);
    var this$5 = $n(this$4.Ldiode_react_ModelProxy__f_modelReader);
    var m = $as_Lreactbuild_analyze_cost_services_Model(this$5.value__O());
    if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
      $n($m_s_package$().s_package$__f_List);
      var $$x1 = $m_sci_Nil$()
    } else {
      var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
      var x$9 = $as_Lreactbuild_model_CommonData(arg1);
      var $$x1 = $n(x$9).Lreactbuild_model_CommonData__f_persons
    };
    var this$7 = $n($as_sci_List($$x1));
    _return: {
      var these = this$7;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$1 = $n(these).head__O();
        var x$10 = $as_Lreactbuild_person_Person(arg1$1);
        var x = $n(x$10).Lreactbuild_person_Person__f__id;
        if (((x === null) ? (_id === null) : $n(x).equals__O__Z(_id))) {
          var this$8 = new $c_s_Some($n(these).head__O());
          break _return
        };
        these = $as_sci_List($n(these).tail__O())
      };
      var this$8 = $m_s_None$()
    };
    if (this$8.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$2 = this$8.get__O();
      var person = $as_Lreactbuild_person_Person(arg1$2);
      return new $c_s_Some($n(person).Lreactbuild_person_Person__f_name)
    }
  }));
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
  return new $c_Lcom_iz2use_common_Textualizable$$anon$1(ev$1, f)
}
function $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable($thiz, proxy) {
  $m_Lcom_iz2use_common_Textualizable$();
  var f = new $c_sjsr_AnonFunction1(((_id$2) => {
    var _id = $as_Lreactbuild_common_model_RefTo(_id$2);
    $m_Lreactbuild_package$();
    new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
    var this$4 = $n(proxy);
    var this$5 = $n(this$4.Ldiode_react_ModelProxy__f_modelReader);
    var m = $as_Lreactbuild_analyze_cost_services_Model(this$5.value__O());
    if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
      $n($m_s_package$().s_package$__f_List);
      var $$x1 = $m_sci_Nil$()
    } else {
      var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
      var x$11 = $as_Lreactbuild_model_CommonData(arg1);
      var $$x1 = $n(x$11).Lreactbuild_model_CommonData__f_buildingSites
    };
    var this$7 = $n($as_sci_List($$x1));
    _return: {
      var these = this$7;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$1 = $n(these).head__O();
        var x$12 = $as_Lreactbuild_common_model_Project(arg1$1);
        var x = $n(x$12).Lreactbuild_common_model_Project__f__id;
        if (((x === null) ? (_id === null) : $n(x).equals__O__Z(_id))) {
          var this$8 = new $c_s_Some($n(these).head__O());
          break _return
        };
        these = $as_sci_List($n(these).tail__O())
      };
      var this$8 = $m_s_None$()
    };
    if (this$8.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$2 = this$8.get__O();
      var buildingSite = $as_Lreactbuild_common_model_Project(arg1$2);
      return new $c_s_Some($n(buildingSite).Lreactbuild_common_model_Project__f_reference)
    }
  }));
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
  return new $c_Lcom_iz2use_common_Textualizable$$anon$1(ev$1, f)
}
function $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable($thiz, proxy) {
  $m_Lcom_iz2use_common_Textualizable$();
  var f = new $c_sjsr_AnonFunction1(((_id$2) => {
    var _id = $as_Lreactbuild_common_model_RefTo(_id$2);
    $m_Lreactbuild_package$();
    new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
    var this$4 = $n(proxy);
    var this$5 = $n(this$4.Ldiode_react_ModelProxy__f_modelReader);
    var m = $as_Lreactbuild_analyze_cost_services_Model(this$5.value__O());
    if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
      $n($m_s_package$().s_package$__f_List);
      var $$x1 = $m_sci_Nil$()
    } else {
      var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
      var x$13 = $as_Lreactbuild_model_CommonData(arg1);
      var $$x1 = $n(x$13).Lreactbuild_model_CommonData__f_buildingParts
    };
    var this$7 = $n($as_sci_List($$x1));
    _return: {
      var these = this$7;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$1 = $n(these).head__O();
        var x$14 = $as_Lreactbuild_model_BuildingPart(arg1$1);
        var x = $n(x$14).Lreactbuild_model_BuildingPart__f__id;
        if (((x === null) ? (_id === null) : $n(x).equals__O__Z(_id))) {
          var this$8 = new $c_s_Some($n(these).head__O());
          break _return
        };
        these = $as_sci_List($n(these).tail__O())
      };
      var this$8 = $m_s_None$()
    };
    if (this$8.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$2 = this$8.get__O();
      var buildingPart = $as_Lreactbuild_model_BuildingPart(arg1$2);
      return new $c_s_Some($n(buildingPart).Lreactbuild_model_BuildingPart__f_label)
    }
  }));
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
  return new $c_Lcom_iz2use_common_Textualizable$$anon$1(ev$1, f)
}
function $f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable($thiz, proxy) {
  $m_Lcom_iz2use_common_Textualizable$();
  var f = new $c_sjsr_AnonFunction1(((_id$2) => {
    var _id = $as_Lreactbuild_common_model_RefTo(_id$2);
    $m_Lreactbuild_package$();
    new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
    var this$4 = $n(proxy);
    var this$5 = $n(this$4.Ldiode_react_ModelProxy__f_modelReader);
    var m = $as_Lreactbuild_analyze_cost_services_Model(this$5.value__O());
    if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
      $n($m_s_package$().s_package$__f_List);
      var $$x1 = $m_sci_Nil$()
    } else {
      var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
      var x$15 = $as_Lreactbuild_model_CommonData(arg1);
      var $$x1 = $n(x$15).Lreactbuild_model_CommonData__f_buildingStages
    };
    var this$7 = $n($as_sci_List($$x1));
    _return: {
      var these = this$7;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$1 = $n(these).head__O();
        var x$16 = $as_Lreactbuild_model_BuildingStage(arg1$1);
        var x = $n(x$16).Lreactbuild_model_BuildingStage__f__id;
        if (((x === null) ? (_id === null) : $n(x).equals__O__Z(_id))) {
          var this$8 = new $c_s_Some($n(these).head__O());
          break _return
        };
        these = $as_sci_List($n(these).tail__O())
      };
      var this$8 = $m_s_None$()
    };
    if (this$8.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$2 = this$8.get__O();
      var buildingStage = $as_Lreactbuild_model_BuildingStage(arg1$2);
      return new $c_s_Some($n(buildingStage).Lreactbuild_model_BuildingStage__f_name)
    }
  }));
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
  return new $c_Lcom_iz2use_common_Textualizable$$anon$1(ev$1, f)
}
function $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable($thiz, proxy) {
  $m_Lcom_iz2use_common_Textualizable$();
  var f = new $c_sjsr_AnonFunction1(((_id$2) => {
    var _id = $as_Lreactbuild_common_model_RefTo(_id$2);
    $m_Lreactbuild_package$();
    new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
    var this$4 = $n(proxy);
    var this$5 = $n(this$4.Ldiode_react_ModelProxy__f_modelReader);
    var m = $as_Lreactbuild_analyze_cost_services_Model(this$5.value__O());
    if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
      $n($m_s_package$().s_package$__f_List);
      var $$x1 = $m_sci_Nil$()
    } else {
      var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
      var x$17 = $as_Lreactbuild_model_CommonData(arg1);
      var $$x1 = $n(x$17).Lreactbuild_model_CommonData__f_resources
    };
    var this$7 = $n($as_sci_List($$x1));
    _return: {
      var these = this$7;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$1 = $n(these).head__O();
        var x$18 = $as_Lreactbuild_model_Resource(arg1$1);
        var x = $n(x$18).Lreactbuild_model_Resource__f__id;
        if (((x === null) ? (_id === null) : $n(x).equals__O__Z(_id))) {
          var this$8 = new $c_s_Some($n(these).head__O());
          break _return
        };
        these = $as_sci_List($n(these).tail__O())
      };
      var this$8 = $m_s_None$()
    };
    if (this$8.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$2 = this$8.get__O();
      var resource = $as_Lreactbuild_model_Resource(arg1$2);
      return new $c_s_Some($n(resource).Lreactbuild_model_Resource__f_name)
    }
  }));
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
  return new $c_Lcom_iz2use_common_Textualizable$$anon$1(ev$1, f)
}
function $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable($thiz, proxy) {
  $m_Lcom_iz2use_common_Textualizable$();
  var f = new $c_sjsr_AnonFunction1(((ref$2) => {
    var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
    var this$2 = $n(proxy);
    var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
    var this$4 = $n($n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged);
    if (this$4.isEmpty__Z()) {
      var $$x1 = $m_s_None$()
    } else {
      var arg1 = this$4.get__O();
      var x$23 = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(arg1);
      var this$5 = $n($n(x$23).Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations);
      _return: {
        var these = this$5;
        while ((!$n(these).isEmpty__Z())) {
          var arg1$1 = $n(these).head__O();
          var x$24 = $as_Lreactbuild_common_model_LoggedUserOrganization(arg1$1);
          var x = $n(x$24).Lreactbuild_common_model_LoggedUserOrganization__f__id;
          if (((x === null) ? (ref === null) : $n(x).equals__O__Z(ref))) {
            var $$x1 = new $c_s_Some($n(these).head__O());
            break _return
          };
          these = $as_sci_List($n(these).tail__O())
        };
        var $$x1 = $m_s_None$()
      }
    };
    var this$6 = $n($$x1);
    if (this$6.isEmpty__Z()) {
      var $$x2 = "organisation non trouv\u00e9e"
    } else {
      var arg1$2 = this$6.get__O();
      var org = $as_Lreactbuild_common_model_LoggedUserOrganization(arg1$2);
      var this$7 = $n($n(org).Lreactbuild_common_model_LoggedUserOrganization__f_name);
      var $$x2 = $as_T((this$7.isEmpty__Z() ? $n(org).Lreactbuild_common_model_LoggedUserOrganization__f_path : this$7.get__O()))
    };
    return $as_T($$x2)
  }));
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var this$10 = $n(parsable);
  return new $c_Lcom_iz2use_common_Textualizable$$anon$1(this$10, f)
}
function $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering($thiz, ev) {
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((x$40$2) => {
    var x$40 = $as_Lreactbuild_common_model_RefTo(x$40$2);
    return $n(ev).stringify__O__T(x$40)
  }));
  var ord = $m_s_math_Ordering$String$();
  return new $c_s_math_Ordering$$anon$5(ord, f)
}
function $f_Lreactbuild_model_LowPriorityImplicits__$init$__V($thiz) {
  $thiz.Lreactbuild_model_Implicits$__f_dateTimePattern = "EEE d LLL yyyy HH:mm";
  var this$3 = $n($m_s_package$().s_package$__f_Ordering);
  var this$2 = $m_s_$less$colon$less$();
  var asComparable = this$2.s_$less$colon$less$__f_singleton;
  $thiz.Lreactbuild_model_Implicits$__f_localDateOrdering = new $c_s_math_LowPriorityOrderingImplicits$$anon$2(this$3, asComparable);
  $n($m_s_package$().s_package$__f_Ordering);
  var cmp = new $c_sjsr_AnonFunction2(((x$5$2, x$6$2) => {
    var x$5 = $as_Ljava_time_ZonedDateTime(x$5$2);
    var x$6 = $as_Ljava_time_ZonedDateTime(x$6$2);
    var this$5 = $n(x$5);
    return $f_Ljava_time_chrono_ChronoZonedDateTime__isBefore__Ljava_time_chrono_ChronoZonedDateTime__Z(this$5, x$6)
  }));
  new $c_s_math_Ordering$$anon$4(cmp);
  $n($m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_Format);
  var format = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
  var this$8 = $n(format);
  new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(this$8);
  var this$26 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lreactbuild_model_DocumentCategory$Invoice$();
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self, "Facture");
  var self$1 = $m_Lreactbuild_model_DocumentCategory$DeliveryForm$();
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$1, "Bon de livraison");
  var self$2 = $m_Lreactbuild_model_DocumentCategory$Quote$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$2, "Devis");
  var self$3 = $m_Lreactbuild_model_DocumentCategory$Order$();
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$3, "Commande");
  var self$4 = $m_Lreactbuild_model_DocumentCategory$PriceOffer$();
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$4, "Offre de prix");
  var self$5 = $m_Lreactbuild_model_DocumentCategory$Certificate$();
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$5, "Attestation");
  var self$6 = $m_Lreactbuild_model_DocumentCategory$Statement$();
  var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$6, "Relev\u00e9")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  $thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryMap = this$26.from__sc_IterableOnce__sci_Map(elems);
  $thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryFromName = $n($n($thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryMap).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = $as_Lreactbuild_model_DocumentCategory($n(x0$1)._1__O());
      var v = $as_T($n(x0$1)._2__O());
      var self$7 = $n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T(v);
      return $ct_T2__O__O__(new $c_T2(), self$7, k)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))).toSeq__sci_Seq();
  $thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryList = $n($n($thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryMap).keys__sc_Iterable()).toSeq__sci_Seq();
  var $$x7 = $as_sc_IterableOnceOps($n($thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryList).zipWithIndex__O());
  var this$29 = $m_s_$less$colon$less$();
  $thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryIndex = $n($$x7).toMap__s_$less$colon$less__sci_Map(this$29.s_$less$colon$less$__f_singleton);
  $n($m_s_package$().s_package$__f_Ordering);
  var f = $thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryIndex;
  var ord = $m_s_math_Ordering$Int$();
  $thiz.Lreactbuild_model_Implicits$__f_documentCategoryOrdering = new $c_s_math_Ordering$$anon$5(ord, f);
  $n($m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_Format);
  var format$1 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var this$32 = $n(format$1);
  $thiz.Lreactbuild_model_Implicits$__f_documentCategoryFormat = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(this$32);
  $thiz.Lreactbuild_model_Implicits$__f_parsableDocumentCategory = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$2($thiz);
  $thiz.Lreactbuild_model_Implicits$__f_documentCategoryResolver = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$3($thiz);
  $thiz.Lreactbuild_model_Implicits$__f_documentCategoryHelper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$4($thiz);
  var this$44 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$8 = $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$();
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$8, "date de livraison");
  var self$9 = $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$();
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$9, "r\u00e9f\u00e9rence produit");
  var self$10 = $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$();
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$10, "r\u00e9f\u00e9rence facture");
  var self$11 = $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$();
  var array$1 = [$$x10, $$x9, $$x8, $ct_T2__O__O__(new $c_T2(), self$11, "r\u00e9f\u00e9rence bon de livraison")];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  $thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderMap = this$44.from__sc_IterableOnce__sci_Map(elems$1);
  $thiz.Lreactbuild_model_Implicits$__f_reconciliationReportDefault = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$6($thiz);
  $thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportFromName = $n($n($thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderMap).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((x0$1$3$2) => {
    var x0$1$3 = $as_T2(x0$1$3$2);
    if ((x0$1$3 !== null)) {
      var k$1 = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder($n(x0$1$3)._1__O());
      var v$1 = $as_T($n(x0$1$3)._2__O());
      var self$12 = $n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T(v$1);
      return $ct_T2__O__O__(new $c_T2(), self$12, k$1)
    } else {
      throw new $c_s_MatchError(x0$1$3)
    }
  })))).toSeq__sci_Seq();
  $thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderList = $n($n($thiz.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderMap).keys__sc_Iterable()).toSeq__sci_Seq();
  new $c_Lreactbuild_model_LowPriorityImplicits$$anon$7($thiz);
  $thiz.Lreactbuild_model_Implicits$__f_reconciliationReportOrderResolver = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$8($thiz);
  $thiz.Lreactbuild_model_Implicits$__f_reconciliationReportOrderHelper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$9($thiz);
  $thiz.Lreactbuild_model_Implicits$__f_supplierGroupResolver = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$11($thiz);
  $n($m_s_package$().s_package$__f_Ordering);
  var f$1 = new $c_sjsr_AnonFunction1(((x$19$2) => {
    var x$19 = $as_Lreactbuild_person_SupplierGroup(x$19$2);
    return $n(x$19).Lreactbuild_person_SupplierGroup__f_title
  }));
  var ord$1 = $m_s_math_Ordering$String$();
  $thiz.Lreactbuild_model_Implicits$__f_supplierGroupOrdering = new $c_s_math_Ordering$$anon$5(ord$1, f$1);
  $thiz.Lreactbuild_model_Implicits$__f_supplierGroupHelper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$12($thiz);
  $n($m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_Format);
  var format$2 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var this$49 = $n(format$2);
  $thiz.Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsFormat = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(this$49);
  $n($m_s_package$().s_package$__f_Ordering);
  var f$2 = new $c_sjsr_AnonFunction1(((x$21$2) => {
    var x$21 = $as_sci_Seq(x$21$2);
    return $n(x$21).length__I()
  }));
  var ord$2 = $m_s_math_Ordering$Int$();
  $thiz.Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsSeqOrdering = new $c_s_math_Ordering$$anon$5(ord$2, f$2)
}
/** @constructor */
function $c_Lreactbuild_model_MapFeature$() {
  this.Lreactbuild_model_MapFeature$__f_config = null;
  $n_Lreactbuild_model_MapFeature$ = this;
  this.Lreactbuild_model_MapFeature$__f_config = $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config).withDiscriminator__T__Lio_circe_generic_extras_Configuration("type")
}
$c_Lreactbuild_model_MapFeature$.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$.prototype.constructor = $c_Lreactbuild_model_MapFeature$;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$.prototype = $c_Lreactbuild_model_MapFeature$.prototype;
var $d_Lreactbuild_model_MapFeature$ = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$: 0
}, false, "reactbuild.model.MapFeature$", {
  Lreactbuild_model_MapFeature$: 1,
  O: 1
});
$c_Lreactbuild_model_MapFeature$.prototype.$classData = $d_Lreactbuild_model_MapFeature$;
var $n_Lreactbuild_model_MapFeature$;
function $m_Lreactbuild_model_MapFeature$() {
  if ((!$n_Lreactbuild_model_MapFeature$)) {
    $n_Lreactbuild_model_MapFeature$ = new $c_Lreactbuild_model_MapFeature$()
  };
  return $n_Lreactbuild_model_MapFeature$
}
function $is_Lreactbuild_model_MapFeature$MapFeature(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_MapFeature$MapFeature)))
}
function $as_Lreactbuild_model_MapFeature$MapFeature(obj) {
  return (($is_Lreactbuild_model_MapFeature$MapFeature(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.MapFeature$MapFeature"))
}
function $isArrayOf_Lreactbuild_model_MapFeature$MapFeature(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_MapFeature$MapFeature)))
}
function $asArrayOf_Lreactbuild_model_MapFeature$MapFeature(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_MapFeature$MapFeature(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.MapFeature$MapFeature;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeature$() {
  this.Lreactbuild_model_MapFeature$MapFeature$__f_codecForMapFeature = null;
  $n_Lreactbuild_model_MapFeature$MapFeature$ = this;
  var inst$macro$224 = new $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$224));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_MapFeature$MapFeature$__f_codecForMapFeature = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_MapFeature$MapFeature$.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$MapFeature$.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeature$;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeature$() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeature$.prototype = $c_Lreactbuild_model_MapFeature$MapFeature$.prototype;
var $d_Lreactbuild_model_MapFeature$MapFeature$ = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeature$: 0
}, false, "reactbuild.model.MapFeature$MapFeature$", {
  Lreactbuild_model_MapFeature$MapFeature$: 1,
  O: 1
});
$c_Lreactbuild_model_MapFeature$MapFeature$.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeature$;
var $n_Lreactbuild_model_MapFeature$MapFeature$;
function $m_Lreactbuild_model_MapFeature$MapFeature$() {
  if ((!$n_Lreactbuild_model_MapFeature$MapFeature$)) {
    $n_Lreactbuild_model_MapFeature$MapFeature$ = new $c_Lreactbuild_model_MapFeature$MapFeature$()
  };
  return $n_Lreactbuild_model_MapFeature$MapFeature$
}
/** @constructor */
function $c_Lreactbuild_model_PasswordCrossImpl$() {
  /*<skip>*/
}
$c_Lreactbuild_model_PasswordCrossImpl$.prototype = new $h_O();
$c_Lreactbuild_model_PasswordCrossImpl$.prototype.constructor = $c_Lreactbuild_model_PasswordCrossImpl$;
/** @constructor */
function $h_Lreactbuild_model_PasswordCrossImpl$() {
  /*<skip>*/
}
$h_Lreactbuild_model_PasswordCrossImpl$.prototype = $c_Lreactbuild_model_PasswordCrossImpl$.prototype;
$c_Lreactbuild_model_PasswordCrossImpl$.prototype.encodePassword__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_model_Password(x$1$2);
    return $n(x$1).Lreactbuild_model_Password__f_value
  }));
  return new $c_Lio_circe_Encoder$$anon$1(this$3, f)
});
$c_Lreactbuild_model_PasswordCrossImpl$.prototype.decodePassword__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var instance = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_T(x$2$2);
    return new $c_Lreactbuild_model_Password(x$2)
  }));
  return new $c_Lio_circe_Decoder$$anon$1(this$3, f)
});
var $d_Lreactbuild_model_PasswordCrossImpl$ = new $TypeData().initClass({
  Lreactbuild_model_PasswordCrossImpl$: 0
}, false, "reactbuild.model.PasswordCrossImpl$", {
  Lreactbuild_model_PasswordCrossImpl$: 1,
  O: 1
});
$c_Lreactbuild_model_PasswordCrossImpl$.prototype.$classData = $d_Lreactbuild_model_PasswordCrossImpl$;
var $n_Lreactbuild_model_PasswordCrossImpl$;
function $m_Lreactbuild_model_PasswordCrossImpl$() {
  if ((!$n_Lreactbuild_model_PasswordCrossImpl$)) {
    $n_Lreactbuild_model_PasswordCrossImpl$ = new $c_Lreactbuild_model_PasswordCrossImpl$()
  };
  return $n_Lreactbuild_model_PasswordCrossImpl$
}
/** @constructor */
function $c_Lreactbuild_model_ReconciliationState() {
  /*<skip>*/
}
$c_Lreactbuild_model_ReconciliationState.prototype = new $h_O();
$c_Lreactbuild_model_ReconciliationState.prototype.constructor = $c_Lreactbuild_model_ReconciliationState;
/** @constructor */
function $h_Lreactbuild_model_ReconciliationState() {
  /*<skip>*/
}
$h_Lreactbuild_model_ReconciliationState.prototype = $c_Lreactbuild_model_ReconciliationState.prototype;
function $as_Lreactbuild_model_ReconciliationState(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ReconciliationState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ReconciliationState"))
}
function $isArrayOf_Lreactbuild_model_ReconciliationState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ReconciliationState)))
}
function $asArrayOf_Lreactbuild_model_ReconciliationState(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ReconciliationState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ReconciliationState;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_ReconciliationState$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ReconciliationState$.prototype = new $h_O();
$c_Lreactbuild_model_ReconciliationState$.prototype.constructor = $c_Lreactbuild_model_ReconciliationState$;
/** @constructor */
function $h_Lreactbuild_model_ReconciliationState$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ReconciliationState$.prototype = $c_Lreactbuild_model_ReconciliationState$.prototype;
$c_Lreactbuild_model_ReconciliationState$.prototype.decodeReconciliationState__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder = (function(decL, decR) {
  $m_Lio_circe_Decoder$();
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Lio_circe_HCursor(c$2);
    var lf = $n(c).downField__T__Lio_circe_ACursor("l");
    var rf = $n(c).downField__T__Lio_circe_ACursor("r");
    if ((lf instanceof $c_Lio_circe_HCursor)) {
      var x2 = $as_Lio_circe_HCursor(lf);
      if ((rf instanceof $c_Lio_circe_HCursor)) {
        var x2$2 = $as_Lio_circe_HCursor(rf);
        var this$2 = $n(x2);
        var this$3 = $n($n(decL).tryDecode__Lio_circe_ACursor__s_util_Either(this$2));
        if ((this$3 instanceof $c_s_util_Right)) {
          var x2$1 = $as_s_util_Right(this$3);
          var b = $n(x2$1).s_util_Right__f_value;
          var this$4 = $n(x2$2);
          var this$5 = $n($n(decR).tryDecode__Lio_circe_ACursor__s_util_Either(this$4));
          if ((this$5 instanceof $c_s_util_Right)) {
            var x2$3 = $as_s_util_Right(this$5);
            var b$1 = $n(x2$3).s_util_Right__f_value;
            return new $c_s_util_Right(new $c_Lreactbuild_model_Reconcilied(b, b$1))
          } else {
            return this$5
          }
        } else {
          return this$3
        }
      } else {
        var this$6 = $n(x2);
        var this$7 = $n($n(decL).tryDecode__Lio_circe_ACursor__s_util_Either(this$6));
        if ((this$7 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(this$7);
          var b$2 = $n(x2$4).s_util_Right__f_value;
          return new $c_s_util_Right(new $c_Lreactbuild_model_UnreconciliedLeft(b$2))
        } else {
          return this$7
        }
      }
    } else if ((rf instanceof $c_Lio_circe_HCursor)) {
      var x2$3$1 = $as_Lio_circe_HCursor(rf);
      var this$8 = $n(x2$3$1);
      var this$9 = $n($n(decR).tryDecode__Lio_circe_ACursor__s_util_Either(this$8));
      if ((this$9 instanceof $c_s_util_Right)) {
        var x2$5 = $as_s_util_Right(this$9);
        var b$3 = $n(x2$5).s_util_Right__f_value;
        return new $c_s_util_Right(new $c_Lreactbuild_model_UnreconciliedRight(b$3))
      } else {
        return this$9
      }
    } else {
      $m_Lio_circe_DecodingFailure$();
      var this$10 = $n(c);
      var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJsonObject;
      var message = ("[L, R]ReconciliationState[L, R] : \n" + $n($n(d).tryDecode__Lio_circe_ACursor__s_util_Either(this$10)).toString__T());
      var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
      return new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2(message, ops))
    }
  }));
  return new $c_Lio_circe_Decoder$$anon$16(f)
});
var $d_Lreactbuild_model_ReconciliationState$ = new $TypeData().initClass({
  Lreactbuild_model_ReconciliationState$: 0
}, false, "reactbuild.model.ReconciliationState$", {
  Lreactbuild_model_ReconciliationState$: 1,
  O: 1
});
$c_Lreactbuild_model_ReconciliationState$.prototype.$classData = $d_Lreactbuild_model_ReconciliationState$;
var $n_Lreactbuild_model_ReconciliationState$;
function $m_Lreactbuild_model_ReconciliationState$() {
  if ((!$n_Lreactbuild_model_ReconciliationState$)) {
    $n_Lreactbuild_model_ReconciliationState$ = new $c_Lreactbuild_model_ReconciliationState$()
  };
  return $n_Lreactbuild_model_ReconciliationState$
}
function $is_Lreactbuild_model_SearchResult(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_SearchResult)))
}
function $as_Lreactbuild_model_SearchResult(obj) {
  return (($is_Lreactbuild_model_SearchResult(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.SearchResult"))
}
function $isArrayOf_Lreactbuild_model_SearchResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_SearchResult)))
}
function $asArrayOf_Lreactbuild_model_SearchResult(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_SearchResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.SearchResult;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_SearchResult$() {
  this.Lreactbuild_model_SearchResult$__f_codecForSearchResult = null;
  $n_Lreactbuild_model_SearchResult$ = this;
  var inst$macro$84 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$84));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_SearchResult$__f_codecForSearchResult = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_SearchResult$.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$.prototype.constructor = $c_Lreactbuild_model_SearchResult$;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$.prototype = $c_Lreactbuild_model_SearchResult$.prototype;
var $d_Lreactbuild_model_SearchResult$ = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$: 0
}, false, "reactbuild.model.SearchResult$", {
  Lreactbuild_model_SearchResult$: 1,
  O: 1
});
$c_Lreactbuild_model_SearchResult$.prototype.$classData = $d_Lreactbuild_model_SearchResult$;
var $n_Lreactbuild_model_SearchResult$;
function $m_Lreactbuild_model_SearchResult$() {
  if ((!$n_Lreactbuild_model_SearchResult$)) {
    $n_Lreactbuild_model_SearchResult$ = new $c_Lreactbuild_model_SearchResult$()
  };
  return $n_Lreactbuild_model_SearchResult$
}
function $is_Lreactbuild_model_TaskAttachment(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_TaskAttachment)))
}
function $as_Lreactbuild_model_TaskAttachment(obj) {
  return (($is_Lreactbuild_model_TaskAttachment(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TaskAttachment"))
}
function $isArrayOf_Lreactbuild_model_TaskAttachment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TaskAttachment)))
}
function $asArrayOf_Lreactbuild_model_TaskAttachment(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TaskAttachment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TaskAttachment;", depth))
}
var $d_Lreactbuild_model_TaskAttachment = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment: 0
}, true, "reactbuild.model.TaskAttachment", {
  Lreactbuild_model_TaskAttachment: 1,
  O: 1
});
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$() {
  this.Lreactbuild_model_TaskAttachment$__f_codecForTaskAttachment = null;
  $n_Lreactbuild_model_TaskAttachment$ = this;
  var inst$macro$148 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$148));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_TaskAttachment$__f_codecForTaskAttachment = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_TaskAttachment$.prototype = new $h_O();
$c_Lreactbuild_model_TaskAttachment$.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$.prototype = $c_Lreactbuild_model_TaskAttachment$.prototype;
var $d_Lreactbuild_model_TaskAttachment$ = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$: 0
}, false, "reactbuild.model.TaskAttachment$", {
  Lreactbuild_model_TaskAttachment$: 1,
  O: 1
});
$c_Lreactbuild_model_TaskAttachment$.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$;
var $n_Lreactbuild_model_TaskAttachment$;
function $m_Lreactbuild_model_TaskAttachment$() {
  if ((!$n_Lreactbuild_model_TaskAttachment$)) {
    $n_Lreactbuild_model_TaskAttachment$ = new $c_Lreactbuild_model_TaskAttachment$()
  };
  return $n_Lreactbuild_model_TaskAttachment$
}
function $is_Lreactbuild_model_TaskRole(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_TaskRole)))
}
function $as_Lreactbuild_model_TaskRole(obj) {
  return (($is_Lreactbuild_model_TaskRole(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TaskRole"))
}
function $isArrayOf_Lreactbuild_model_TaskRole(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TaskRole)))
}
function $asArrayOf_Lreactbuild_model_TaskRole(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TaskRole(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TaskRole;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_TaskRole$() {
  this.Lreactbuild_model_TaskRole$__f_codecForTaskRole = null;
  $n_Lreactbuild_model_TaskRole$ = this;
  var inst$macro$10 = new $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$10));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_TaskRole$__f_codecForTaskRole = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_TaskRole$.prototype = new $h_O();
$c_Lreactbuild_model_TaskRole$.prototype.constructor = $c_Lreactbuild_model_TaskRole$;
/** @constructor */
function $h_Lreactbuild_model_TaskRole$() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskRole$.prototype = $c_Lreactbuild_model_TaskRole$.prototype;
var $d_Lreactbuild_model_TaskRole$ = new $TypeData().initClass({
  Lreactbuild_model_TaskRole$: 0
}, false, "reactbuild.model.TaskRole$", {
  Lreactbuild_model_TaskRole$: 1,
  O: 1
});
$c_Lreactbuild_model_TaskRole$.prototype.$classData = $d_Lreactbuild_model_TaskRole$;
var $n_Lreactbuild_model_TaskRole$;
function $m_Lreactbuild_model_TaskRole$() {
  if ((!$n_Lreactbuild_model_TaskRole$)) {
    $n_Lreactbuild_model_TaskRole$ = new $c_Lreactbuild_model_TaskRole$()
  };
  return $n_Lreactbuild_model_TaskRole$
}
function $p_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList__loop$1__sci_List__sci_List__sci_List__sci_List($thiz, dones, details, rest) {
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var x1$2 = details;
      if ((x1$2 !== null)) {
        var o8 = $n($m_s_package$().s_package$__f_$plus$colon).unapply__sc_SeqOps__s_Option(x1$2);
        if ((!$n(o8).isEmpty__Z())) {
          var head = $as_Lreactbuild_model_TimeReportEvent($n($as_T2($n(o8).get__O()))._1__O());
          if ($n(dones).isEmpty__Z()) {
            var rassoc$1 = new $c_Lreactbuild_model_TimeReportInterval($n(head).Lreactbuild_model_TimeReportEvent__f_date, $m_s_None$(), details);
            var this$1 = $n($m_s_package$().s_package$__f_Nil);
            return new $c_sci_$colon$colon(rassoc$1, this$1)
          }
        }
      };
      return dones
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head$2 = $as_Lreactbuild_model_TimeReportEvent($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      if ($n(head$2).Lreactbuild_model_TimeReportEvent__f_ignore) {
        var x1$3 = dones;
        if ((x1$3 !== null)) {
          var o7 = $n($m_s_package$().s_package$__f_$colon$plus).unapply__sc_SeqOps__s_Option(x1$3);
          if ((!$n(o7).isEmpty__Z())) {
            var init = $as_sci_List($n($as_T2($n(o7).get__O()))._1__O());
            var last = $as_Lreactbuild_model_TimeReportInterval($n($as_T2($n(o7).get__O()))._2__O());
            var this$6 = $n(init);
            var this$2 = $n($n(last).Lreactbuild_model_TimeReportInterval__f_details);
            var x$1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$2, head$2));
            var this$3 = $n(last);
            var x$2$2 = this$3.Lreactbuild_model_TimeReportInterval__f_start;
            var this$4 = $n(last);
            var x$3 = this$4.Lreactbuild_model_TimeReportInterval__f_end;
            $n(last);
            var elem = new $c_Lreactbuild_model_TimeReportInterval(x$2$2, x$3, x$1);
            var temp$dones = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$6, elem));
            var temp$details = $m_s_package$().s_package$__f_Nil;
            dones = temp$dones;
            details = temp$details;
            rest = tail;
            continue
          }
        };
        var this$7 = $n(details);
        var temp$details$2 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$7, head$2));
        details = temp$details$2;
        rest = tail
      } else {
        var x1$4 = dones;
        if ((x1$4 !== null)) {
          var o11 = $n($m_s_package$().s_package$__f_$colon$plus).unapply__sc_SeqOps__s_Option(x1$4);
          if ((!$n(o11).isEmpty__Z())) {
            var init$2 = $as_sci_List($n($as_T2($n(o11).get__O()))._1__O());
            var last$2 = $as_Lreactbuild_model_TimeReportInterval($n($as_T2($n(o11).get__O()))._2__O());
            if ((last$2 !== null)) {
              var p4 = $n(last$2).Lreactbuild_model_TimeReportInterval__f_end;
              var x$4 = $m_s_None$();
              if ((x$4 === p4)) {
                var this$11 = $n(init$2);
                var x$4$2 = new $c_s_Some($n(head$2).Lreactbuild_model_TimeReportEvent__f_date);
                var this$8 = $n($n(last$2).Lreactbuild_model_TimeReportInterval__f_details);
                var x$5$2 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$8, head$2));
                var this$9 = $n(last$2);
                var x$6 = this$9.Lreactbuild_model_TimeReportInterval__f_start;
                $n(last$2);
                var elem$1 = new $c_Lreactbuild_model_TimeReportInterval(x$6, x$4$2, x$5$2);
                var temp$dones$2 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$11, elem$1));
                var temp$details$3 = $m_s_package$().s_package$__f_Nil;
                dones = temp$dones$2;
                details = temp$details$3;
                rest = tail;
                continue
              }
            }
          }
        };
        var this$13 = $n(dones);
        var $$x2 = $n(head$2).Lreactbuild_model_TimeReportEvent__f_date;
        var $$x1 = $m_s_None$();
        var this$12 = $n(details);
        var elem$2 = new $c_Lreactbuild_model_TimeReportInterval($$x2, $$x1, $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$12, head$2)));
        var temp$dones$3 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$13, elem$2));
        var temp$details$4 = $m_s_package$().s_package$__f_Nil;
        dones = temp$dones$3;
        details = temp$details$4;
        rest = tail
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList(events) {
  this.Lreactbuild_model_TimeReportEvent$RichTimeReportEventList__f_events = null;
  this.Lreactbuild_model_TimeReportEvent$RichTimeReportEventList__f_events = events
}
$c_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList.prototype = new $h_O();
$c_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList.prototype.constructor = $c_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList;
/** @constructor */
function $h_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList.prototype = $c_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList.prototype;
$c_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList.prototype.intervals__sci_List = (function() {
  var $$x2 = $m_s_package$().s_package$__f_Nil;
  var $$x1 = $m_s_package$().s_package$__f_Nil;
  var this$5 = $n(this.Lreactbuild_model_TimeReportEvent$RichTimeReportEventList__f_events);
  var f = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Lreactbuild_model_TimeReportEvent(x$9$2);
    return $n(x$9).Lreactbuild_model_TimeReportEvent__f_date
  }));
  var this$4 = $m_s_math_Ordering$();
  var this$3 = $m_s_$less$colon$less$();
  var asComparable = this$3.s_$less$colon$less$__f_singleton;
  var ord = new $c_s_math_LowPriorityOrderingImplicits$$anon$2(this$4, asComparable);
  return $p_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList__loop$1__sci_List__sci_List__sci_List__sci_List(this, $$x2, $$x1, $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$5, f, ord)))
});
var $d_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList = new $TypeData().initClass({
  Lreactbuild_model_TimeReportEvent$RichTimeReportEventList: 0
}, false, "reactbuild.model.TimeReportEvent$RichTimeReportEventList", {
  Lreactbuild_model_TimeReportEvent$RichTimeReportEventList: 1,
  O: 1
});
$c_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList.prototype.$classData = $d_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList;
/** @constructor */
function $c_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval(intervals) {
  this.Lreactbuild_model_TimeReportInterval$RichTimeReportInterval__f_intervals = null;
  this.Lreactbuild_model_TimeReportInterval$RichTimeReportInterval__f_intervals = intervals
}
$c_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval.prototype = new $h_O();
$c_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval.prototype.constructor = $c_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval;
/** @constructor */
function $h_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval.prototype = $c_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval.prototype;
$c_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval.prototype.total__s_Option = (function() {
  var $$x1 = $m_s_Option$();
  var this$1 = $n(this.Lreactbuild_model_TimeReportInterval$RichTimeReportInterval__f_intervals);
  var acc = 0.0;
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = acc;
    var arg2 = $n(these).head__O();
    var x0$1 = $uD(arg1);
    var x1$1 = $as_Lreactbuild_model_TimeReportInterval(arg2);
    matchEnd8: {
      if ((x1$1 !== null)) {
        var a = $n(x1$1).Lreactbuild_model_TimeReportInterval__f_start;
        var p3 = $n(x1$1).Lreactbuild_model_TimeReportInterval__f_end;
        if ((p3 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p3);
          var b = $as_Ljava_time_LocalDateTime($n(x5).s_Some__f_value);
          var this$2 = $n($m_Ljava_time_Duration$().between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration(a, b)).toMinutes__J();
          acc = (x0$1 + ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$2.RTLong__f_lo, this$2.RTLong__f_hi) / 60.0));
          break matchEnd8
        }
      };
      acc = x0$1
    };
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  var this$3 = $n($n($$x1).apply__O__s_Option(new $c_Lreactbuild_model_Duration($uD(acc))));
  if (this$3.isEmpty__Z()) {
    var $$x2 = true
  } else {
    var arg1$1 = this$3.get__O();
    var x$8 = $as_Lreactbuild_model_Duration(arg1$1);
    var $$x2 = ($n(x$8).Lreactbuild_model_Duration__f_value > 0.0)
  };
  if ($$x2) {
    return this$3
  } else {
    return $m_s_None$()
  }
});
var $d_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval = new $TypeData().initClass({
  Lreactbuild_model_TimeReportInterval$RichTimeReportInterval: 0
}, false, "reactbuild.model.TimeReportInterval$RichTimeReportInterval", {
  Lreactbuild_model_TimeReportInterval$RichTimeReportInterval: 1,
  O: 1
});
$c_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval.prototype.$classData = $d_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval;
function $is_Lreactbuild_model_ToClient(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ToClient)))
}
function $as_Lreactbuild_model_ToClient(obj) {
  return (($is_Lreactbuild_model_ToClient(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ToClient"))
}
function $isArrayOf_Lreactbuild_model_ToClient(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ToClient)))
}
function $asArrayOf_Lreactbuild_model_ToClient(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ToClient(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ToClient;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_ToClient$() {
  this.Lreactbuild_model_ToClient$__f_codecForToClient = null;
  $n_Lreactbuild_model_ToClient$ = this;
  var inst$macro$60 = new $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1().inst$macro$1__Lio_circe_generic_codec_DerivedAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$60));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_ToClient$__f_codecForToClient = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_ToClient$.prototype = new $h_O();
$c_Lreactbuild_model_ToClient$.prototype.constructor = $c_Lreactbuild_model_ToClient$;
/** @constructor */
function $h_Lreactbuild_model_ToClient$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ToClient$.prototype = $c_Lreactbuild_model_ToClient$.prototype;
var $d_Lreactbuild_model_ToClient$ = new $TypeData().initClass({
  Lreactbuild_model_ToClient$: 0
}, false, "reactbuild.model.ToClient$", {
  Lreactbuild_model_ToClient$: 1,
  O: 1
});
$c_Lreactbuild_model_ToClient$.prototype.$classData = $d_Lreactbuild_model_ToClient$;
var $n_Lreactbuild_model_ToClient$;
function $m_Lreactbuild_model_ToClient$() {
  if ((!$n_Lreactbuild_model_ToClient$)) {
    $n_Lreactbuild_model_ToClient$ = new $c_Lreactbuild_model_ToClient$()
  };
  return $n_Lreactbuild_model_ToClient$
}
function $is_Lreactbuild_model_process_ProcessElement(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_process_ProcessElement)))
}
function $as_Lreactbuild_model_process_ProcessElement(obj) {
  return (($is_Lreactbuild_model_process_ProcessElement(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessElement"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessElement)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessElement(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessElement;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessElement$() {
  this.Lreactbuild_model_process_ProcessElement$__f_codecForProcessElement = null;
  $n_Lreactbuild_model_process_ProcessElement$ = this;
  var inst$macro$124 = new $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$124));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_process_ProcessElement$__f_codecForProcessElement = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_process_ProcessElement$.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessElement$.prototype.constructor = $c_Lreactbuild_model_process_ProcessElement$;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessElement$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessElement$.prototype = $c_Lreactbuild_model_process_ProcessElement$.prototype;
var $d_Lreactbuild_model_process_ProcessElement$ = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessElement$: 0
}, false, "reactbuild.model.process.ProcessElement$", {
  Lreactbuild_model_process_ProcessElement$: 1,
  O: 1
});
$c_Lreactbuild_model_process_ProcessElement$.prototype.$classData = $d_Lreactbuild_model_process_ProcessElement$;
var $n_Lreactbuild_model_process_ProcessElement$;
function $m_Lreactbuild_model_process_ProcessElement$() {
  if ((!$n_Lreactbuild_model_process_ProcessElement$)) {
    $n_Lreactbuild_model_process_ProcessElement$ = new $c_Lreactbuild_model_process_ProcessElement$()
  };
  return $n_Lreactbuild_model_process_ProcessElement$
}
function $is_Lreactbuild_model_process_ProcessInstanceEventDetails(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_process_ProcessInstanceEventDetails)))
}
function $as_Lreactbuild_model_process_ProcessInstanceEventDetails(obj) {
  return (($is_Lreactbuild_model_process_ProcessInstanceEventDetails(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessInstanceEventDetails"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessInstanceEventDetails)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessInstanceEventDetails;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$() {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$__f_codecForProcessInstanceEventDetails = null;
  $n_Lreactbuild_model_process_ProcessInstanceEventDetails$ = this;
  var inst$macro$136 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$136));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$__f_codecForProcessInstanceEventDetails = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$.prototype;
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$ = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$: 1,
  O: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$;
var $n_Lreactbuild_model_process_ProcessInstanceEventDetails$;
function $m_Lreactbuild_model_process_ProcessInstanceEventDetails$() {
  if ((!$n_Lreactbuild_model_process_ProcessInstanceEventDetails$)) {
    $n_Lreactbuild_model_process_ProcessInstanceEventDetails$ = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$()
  };
  return $n_Lreactbuild_model_process_ProcessInstanceEventDetails$
}
function $is_Lreactbuild_model_process_ProcessLinkClass(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_process_ProcessLinkClass)))
}
function $as_Lreactbuild_model_process_ProcessLinkClass(obj) {
  return (($is_Lreactbuild_model_process_ProcessLinkClass(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessLinkClass"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessLinkClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessLinkClass)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessLinkClass(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessLinkClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessLinkClass;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLinkClass$() {
  this.Lreactbuild_model_process_ProcessLinkClass$__f_codecForProcessLinkClass = null;
  $n_Lreactbuild_model_process_ProcessLinkClass$ = this;
  var inst$macro$10 = new $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$10));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_process_ProcessLinkClass$__f_codecForProcessLinkClass = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_process_ProcessLinkClass$.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessLinkClass$.prototype.constructor = $c_Lreactbuild_model_process_ProcessLinkClass$;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLinkClass$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLinkClass$.prototype = $c_Lreactbuild_model_process_ProcessLinkClass$.prototype;
var $d_Lreactbuild_model_process_ProcessLinkClass$ = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLinkClass$: 0
}, false, "reactbuild.model.process.ProcessLinkClass$", {
  Lreactbuild_model_process_ProcessLinkClass$: 1,
  O: 1
});
$c_Lreactbuild_model_process_ProcessLinkClass$.prototype.$classData = $d_Lreactbuild_model_process_ProcessLinkClass$;
var $n_Lreactbuild_model_process_ProcessLinkClass$;
function $m_Lreactbuild_model_process_ProcessLinkClass$() {
  if ((!$n_Lreactbuild_model_process_ProcessLinkClass$)) {
    $n_Lreactbuild_model_process_ProcessLinkClass$ = new $c_Lreactbuild_model_process_ProcessLinkClass$()
  };
  return $n_Lreactbuild_model_process_ProcessLinkClass$
}
function $is_Lreactbuild_model_process_ProcessNodeDetails(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_process_ProcessNodeDetails)))
}
function $as_Lreactbuild_model_process_ProcessNodeDetails(obj) {
  return (($is_Lreactbuild_model_process_ProcessNodeDetails(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails;", depth))
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$() {
  this.Lreactbuild_model_process_ProcessNodeDetails$__f_codecForProcessNodeDetails = null;
  $n_Lreactbuild_model_process_ProcessNodeDetails$ = this;
  var inst$macro$42 = new $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$42));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_process_ProcessNodeDetails$__f_codecForProcessNodeDetails = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_process_ProcessNodeDetails$.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$.prototype;
var $d_Lreactbuild_model_process_ProcessNodeDetails$ = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$", {
  Lreactbuild_model_process_ProcessNodeDetails$: 1,
  O: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$;
var $n_Lreactbuild_model_process_ProcessNodeDetails$;
function $m_Lreactbuild_model_process_ProcessNodeDetails$() {
  if ((!$n_Lreactbuild_model_process_ProcessNodeDetails$)) {
    $n_Lreactbuild_model_process_ProcessNodeDetails$ = new $c_Lreactbuild_model_process_ProcessNodeDetails$()
  };
  return $n_Lreactbuild_model_process_ProcessNodeDetails$
}
/** @constructor */
function $c_Lreactbuild_package$() {
  this.Lreactbuild_package$__f_scheme = null;
  this.Lreactbuild_package$__f_locale = null;
  this.Lreactbuild_package$__f_userPreferenceStore = null;
  $n_Lreactbuild_package$ = this;
  var t = $as_T(window.location.protocol);
  this.Lreactbuild_package$__f_scheme = t;
  this.Lreactbuild_package$__f_locale = $m_ju_Locale$().FRENCH__ju_Locale();
  this.Lreactbuild_package$__f_userPreferenceStore = new $c_Lreactbuild_package$$anon$3()
}
$c_Lreactbuild_package$.prototype = new $h_O();
$c_Lreactbuild_package$.prototype.constructor = $c_Lreactbuild_package$;
/** @constructor */
function $h_Lreactbuild_package$() {
  /*<skip>*/
}
$h_Lreactbuild_package$.prototype = $c_Lreactbuild_package$.prototype;
$c_Lreactbuild_package$.prototype.getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O = (function(proxy, f, ev) {
  var this$1 = $n(proxy);
  var this$2 = $n(this$1.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$2.value__O());
  return ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z() ? $n(ev).empty__O() : $n(f).apply__O__O($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O()))
});
var $d_Lreactbuild_package$ = new $TypeData().initClass({
  Lreactbuild_package$: 0
}, false, "reactbuild.package$", {
  Lreactbuild_package$: 1,
  O: 1
});
$c_Lreactbuild_package$.prototype.$classData = $d_Lreactbuild_package$;
var $n_Lreactbuild_package$;
function $m_Lreactbuild_package$() {
  if ((!$n_Lreactbuild_package$)) {
    $n_Lreactbuild_package$ = new $c_Lreactbuild_package$()
  };
  return $n_Lreactbuild_package$
}
function $p_Lreactbuild_person_AddPersonReference$__b$1$lzycompute$2__sr_LazyRef__F2($thiz, b$1$lzy$2) {
  $n(b$1$lzy$2);
  if ($n(b$1$lzy$2).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($thiz.Lreactbuild_person_AddPersonReference$__f_reusePersonReferenceModel);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$2).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_person_AddPersonReference$__b$1$2__sr_LazyRef__F2($thiz, b$1$lzy$2) {
  return ($n(b$1$lzy$2).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_person_AddPersonReference$__b$1$lzycompute$2__sr_LazyRef__F2($thiz, b$1$lzy$2))
}
function $p_Lreactbuild_person_AddPersonReference$__b$2$lzycompute$2__sr_LazyRef__F2($thiz, b$2$lzy$2) {
  $n(b$2$lzy$2);
  if ($n(b$2$lzy$2).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$2).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_person_AddPersonReference$__b$2$2__sr_LazyRef__F2($thiz, b$2$lzy$2) {
  return ($n(b$2$lzy$2).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_person_AddPersonReference$__b$2$lzycompute$2__sr_LazyRef__F2($thiz, b$2$lzy$2))
}
/** @constructor */
function $c_Lreactbuild_person_AddPersonReference$() {
  this.Lreactbuild_person_AddPersonReference$__f_reusePersonReferenceModel = null;
  this.Lreactbuild_person_AddPersonReference$__f_component = null;
  $n_Lreactbuild_person_AddPersonReference$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$26$2) => {
    var x$26 = $n($as_Lreactbuild_person_PersonReferenceModel(x$26$2)).Lreactbuild_person_PersonReferenceModel__f_id;
    return x$26
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  this.Lreactbuild_person_AddPersonReference$__f_reusePersonReferenceModel = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var a$1 = new $c_sr_ObjectRef(null);
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_person_PersonReferenceDetails(a$2);
    var b = $as_Lreactbuild_person_PersonReferenceDetails(b$2);
    return ($uZ($n($p_Lreactbuild_person_AddPersonReference$__b$1$2__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O(new $c_Lreactbuild_person_PersonReferenceModel($n(a).Lreactbuild_person_PersonReferenceDetails__f_model), new $c_Lreactbuild_person_PersonReferenceModel($n(b).Lreactbuild_person_PersonReferenceDetails__f_model))) && $uZ($n($p_Lreactbuild_person_AddPersonReference$__b$2$2__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lreactbuild_person_PersonReferenceDetails__f_value, $n(b).Lreactbuild_person_PersonReferenceDetails__f_value)))
  }));
  a$1.sr_ObjectRef__f_elem = f$1;
  $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(a$1.sr_ObjectRef__f_elem));
  var this$124 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).usePageProps__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x6 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x5 = new $c_sjsr_AnonFunction2(((props$2, x$27$2) => {
    var props = $as_Lreactbuild_person_AddPersonReference$Props(props$2);
    $as_Lreactbuild_package$PageProps(x$27$2);
    return $n($n(props).Lreactbuild_person_AddPersonReference$Props__f_targets).Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt
  }));
  var this$10 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$2 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x6.useStateSnapshotBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x5, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$10)));
  var $$x7 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$2);
  var $$x4 = new $c_sjsr_AnonFunction3(((props$3$2, x$28$2, x$29$2) => {
    var props$3 = $as_Lreactbuild_person_AddPersonReference$Props(props$3$2);
    $as_Lreactbuild_package$PageProps(x$28$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$29$2);
    var x1 = $n($n(props$3).Lreactbuild_person_AddPersonReference$Props__f_targets).Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      return $m_s_None$()
    };
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var one = $as_Lreactbuild_common_model_RefTo($n(x3).sci_$colon$colon__f_head);
      var p4 = $n(x3).sci_$colon$colon__f_next;
      var x$3 = $m_s_package$().s_package$__f_Nil;
      if (((x$3 === null) ? (p4 === null) : $n(x$3).equals__O__Z(p4))) {
        return $m_s_Option$().apply__O__s_Option(one)
      }
    };
    return $m_s_None$()
  }));
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$3 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x7.useStateSnapshotBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x4, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$12)));
  var $$x8 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$3);
  var $$x3 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_person_PersonReferenceDetails("", "")));
  var this$14 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$37 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x8.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x3, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$14))));
  var deps = new $c_sjsr_AnonFunction5(((props$4$2, x$30$2, x$31$2, x$32$2, x$33$2) => {
    var props$4 = $as_Lreactbuild_person_AddPersonReference$Props(props$4$2);
    $as_Lreactbuild_package$PageProps(x$30$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$31$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$32$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$33$2);
    return $n(props$4).Lreactbuild_person_AddPersonReference$Props__f_upsert
  }));
  var callback = new $c_sjsr_AnonFunction5(((props$5$2, x$34$2, x$35$2, x$36$2, x$37$2) => {
    var props$5 = $as_Lreactbuild_person_AddPersonReference$Props(props$5$2);
    $as_Lreactbuild_package$PageProps(x$34$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$35$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$36$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$37$2);
    return new $c_sjsr_AnonFunction1(((x$38$2) => {
      $as_Ljapgolly_scalajs_react_Reusable(x$38$2);
      return new $c_sjsr_AnonFunction3(((personRefOpt$2, targetRefList$2, detailList$2) => {
        var personRefOpt = $as_s_Option(personRefOpt$2);
        var targetRefList = $as_s_Option(targetRefList$2);
        var detailList = $as_Lreactbuild_person_PersonReferenceDetails(detailList$2);
        var cb = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => personRefOpt))), new $c_sjsr_AnonFunction1(((personRef$2) => {
          var personRef = $as_Lreactbuild_common_model_RefTo(personRef$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $n(targetRefList).isEmpty__Z()))), new $c_sjsr_AnonFunction1(((x$41$2) => {
            $as_jl_Void(x$41$2);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).require__F0__F0(new $c_sjsr_AnonFunction0((() => {
              $m_sc_StringOps$();
              var x$1 = $n(detailList).Lreactbuild_person_PersonReferenceDetails__f_value;
              var this$17 = $n(x$1);
              return (!(this$17 === ""))
            }))), new $c_sjsr_AnonFunction1(((x$40$2) => {
              $as_jl_Void(x$40$2);
              $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
              $m_Ljapgolly_scalajs_react_Reusable$();
              var r$1 = $n(props$5).Lreactbuild_person_AddPersonReference$Props__f_upsert;
              var $$x14 = $as_F1($n(r$1).value__O());
              $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
              var $$x13 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
              var $$x12 = $m_s_None$();
              var $$x11 = $n(targetRefList).toList__sci_List();
              $n($m_s_package$().s_package$__f_List);
              var array = [detailList];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              var $$x10 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
              $m_Lreactbuild_person_PersonReferenceEvent$();
              new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
              var $$x9 = $m_Ljava_time_Instant$();
              var this$29 = $m_RTLong$();
              var value = $uD(new Date().getTime());
              var lo = this$29.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
              var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x14).apply__O__O(new $c_Lreactbuild_person_PersonReferenceEvent($$x13, $$x12, personRef, $$x11, $$x10, $n($$x9).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, this$29.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
              var f$2 = new $c_sjsr_AnonFunction1(((x$39$2) => {
                $as_jl_Void(x$39$2)
              }));
              var this$31 = $n(this$);
              var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$31, f$2);
              return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
            }))))
          }))))
        })));
        var $$x15 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$33 = $m_s_$less$colon$less$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x15).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(cb, this$33.s_$less$colon$less$__f_singleton))
      }))
    }))
  }));
  var this$35 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var a$3 = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c3__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$35, Z);
  var r$2 = $m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2();
  var this$36 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$36);
  var this$47 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackWithDepsBy__O__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$37, deps, callback, a$3, r$2, step)));
  var deps$1 = new $c_sjsr_AnonFunction6(((x$42$2, x$43$2, x$44$2, targetRefList$2$1, x$45$2, x$46$2) => {
    $as_Lreactbuild_person_AddPersonReference$Props(x$42$2);
    $as_Lreactbuild_package$PageProps(x$43$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$44$2);
    var targetRefList$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(targetRefList$2$1);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$45$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$46$2);
    return $as_s_Option($n(targetRefList$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
  }));
  var create = new $c_sjsr_AnonFunction6(((props$6$2, pageProps$2, x$47$2, targetRefList$3$2, x$48$2, x$49$2) => {
    $as_Lreactbuild_person_AddPersonReference$Props(props$6$2);
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$47$2);
    var targetRefList$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(targetRefList$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$48$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$49$2);
    return new $c_sjsr_AnonFunction1(((x$50$2) => {
      $as_s_Option(x$50$2);
      var this$44 = $n($as_s_Option($n(targetRefList$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
      var f$6 = new $c_sjsr_AnonFunction1(((targetRef$2) => {
        var targetRef = $as_Lreactbuild_common_model_RefTo(targetRef$2);
        var this$38 = $n($n(pageProps).Lreactbuild_package$PageProps__f_proxy);
        var this$39 = $n(this$38.Ldiode_react_ModelProxy__f_modelReader);
        var this$40 = $n($n($as_Lreactbuild_analyze_cost_services_Model(this$39.value__O())).Lreactbuild_analyze_cost_services_Model__f_commonData);
        var this$43 = $n(((!this$40.isEmpty__Z()) ? new $c_s_Some(this$40.get__O()) : $m_s_None$()));
        var f$5 = new $c_sjsr_AnonFunction1(((commonData$2) => {
          var commonData = $as_Lreactbuild_model_CommonData(commonData$2);
          var this$42 = $n($n($n(commonData).Lreactbuild_model_CommonData__f_buildingSites).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$51$2) => {
            var x$51 = $as_Lreactbuild_common_model_Project(x$51$2);
            var x$2 = $n(x$51).Lreactbuild_common_model_Project__f__id;
            return ((x$2 === null) ? (targetRef === null) : $n(x$2).equals__O__Z(targetRef))
          }))));
          var f$4 = new $c_sjsr_AnonFunction1(((project$2) => {
            var project = $as_Lreactbuild_common_model_Project(project$2);
            var this$41 = $n($n($n(project).Lreactbuild_common_model_Project__f_organizations).headOption__s_Option());
            var f$3 = new $c_sjsr_AnonFunction1(((headOrg$2) => {
              var headOrg = $as_Lreactbuild_common_model_RefTo(headOrg$2);
              return headOrg
            }));
            return (this$41.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$3.apply__O__O(this$41.get__O())))
          }));
          return (this$42.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$4.apply__O__O(this$42.get__O())))
        }));
        return (this$43.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$5.apply__O__O(this$43.get__O())))
      }));
      return (this$44.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$6.apply__O__O(this$44.get__O())))
    }))
  }));
  var this$45 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  var r$3 = this$45.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3);
  var this$46 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(this$46);
  var this$123 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$47, deps$1, create, r$3, step$1)));
  var f$8 = new $c_sjsr_AnonFunction7(((props$7$2, pageProps$3$2, personRefOpt$2$1, targetRefList$4$2, detailList$2$1, submit$2, activeOrgOpt$2) => {
    $as_Lreactbuild_person_AddPersonReference$Props(props$7$2);
    var pageProps$3 = $as_Lreactbuild_package$PageProps(pageProps$3$2);
    var personRefOpt$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(personRefOpt$2$1);
    var targetRefList$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(targetRefList$4$2);
    var detailList$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(detailList$2$1);
    var submit = $as_Ljapgolly_scalajs_react_Reusable(submit$2);
    var activeOrgOpt = $as_Ljapgolly_scalajs_react_Reusable(activeOrgOpt$2);
    var _activeOrgOpt = $as_s_Option($n(activeOrgOpt).value__O());
    var $$x28 = $m_Lreactbuild_components_Form$();
    var $$x27 = $n($as_F3(($m_Ljapgolly_scalajs_react_Reusable$(), $n(submit).value__O())));
    var $$x26 = $n(personRefOpt$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var this$50 = $n($as_s_Option($n(targetRefList$4).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
    var f$7 = new $c_sjsr_AnonFunction1(((x$52$2) => {
      var x$52 = $as_Lreactbuild_common_model_RefTo(x$52$2);
      var this$49 = $n(x$52);
      return new $c_Lreactbuild_common_model_RefTo(this$49.Lreactbuild_common_model_RefTo__f_id)
    }));
    var $$x25 = $n($$x27).apply__O__O__O__O($$x26, (this$50.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$7.apply__O__O(this$50.get__O()))), $n(detailList$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var $$x24 = $m_Lreactbuild_components_Form$().Lreactbuild_components_Form$__f_row;
    var $$x23 = $n($m_Lreactbuild_components_Form$().Lreactbuild_components_Form$__f_col);
    var $$x22 = $n($m_Lreactbuild_components_Form$().Lreactbuild_components_Form$__f_row);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Tiers");
    var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var this$55 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy = $n(pageProps$3).Lreactbuild_package$PageProps__f_proxy;
    var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$55, proxy, _activeOrgOpt);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$57 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$1 = $n(pageProps$3).Lreactbuild_package$PageProps__f_proxy;
    var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$57, proxy$1, _activeOrgOpt);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$62 = $m_Lreactbuild_model_Implicits$();
    var this$61 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$2 = $n(pageProps$3).Lreactbuild_package$PageProps__f_proxy;
    var ev = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$61, proxy$2);
    var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$62, ev);
    var $$x21 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, personRefOpt$1, optioner, ev$1, explainError, equiv);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Projet");
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var this$68 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$3 = $n(pageProps$3).Lreactbuild_package$PageProps__f_proxy;
    var ev$3 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$68, proxy$3);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$70 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$4 = $n(pageProps$3).Lreactbuild_package$PageProps__f_proxy;
    var helper$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$70, proxy$4);
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$75 = $m_Lreactbuild_model_Implicits$();
    var this$74 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$5 = $n(pageProps$3).Lreactbuild_package$PageProps__f_proxy;
    var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$74, proxy$5);
    var equiv$1 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$75, ev$2);
    var array$1 = [$$x21, editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, targetRefList$4, optioner$1, ev$3, explainError$1, equiv$1)];
    var $$x20 = $n($$x22).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x19 = $m_Lreactbuild_components_Form$().Lreactbuild_components_Form$__f_row;
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Intitul\u00e9");
    var state = $n(detailList$1).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$53$2) => {
      var x$53 = $as_Lreactbuild_person_PersonReferenceDetails(x$53$2);
      return $n(x$53).Lreactbuild_person_PersonReferenceDetails__f_model
    })), new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_T(v$2);
      return new $c_sjsr_AnonFunction1(((x$54$2) => {
        var x$54 = $as_Lreactbuild_person_PersonReferenceDetails(x$54$2);
        $n(x$54);
        var this$82 = $n(x$54);
        var value$1 = this$82.Lreactbuild_person_PersonReferenceDetails__f_value;
        return new $c_Lreactbuild_person_PersonReferenceDetails(v, value$1)
      }))
    })));
    var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$86 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$86);
    var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
    var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$2 = $m_s_math_Equiv$String$();
    var $$x18 = editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state, optioner$2, ev$4, explainError$2, equiv$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence");
    var state$1 = $n(detailList$1).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$55$2) => {
      var x$55 = $as_Lreactbuild_person_PersonReferenceDetails(x$55$2);
      return $n(x$55).Lreactbuild_person_PersonReferenceDetails__f_value
    })), new $c_sjsr_AnonFunction1(((v$3$2) => {
      var v$3 = $as_T(v$3$2);
      return new $c_sjsr_AnonFunction1(((x$56$2) => {
        var x$56 = $as_Lreactbuild_person_PersonReferenceDetails(x$56$2);
        var this$92 = $n(x$56);
        var x$2$1 = this$92.Lreactbuild_person_PersonReferenceDetails__f_model;
        $n(x$56);
        return new $c_Lreactbuild_person_PersonReferenceDetails(x$2$1, v$3)
      }))
    })));
    var evDefault$1 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    var parser$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$96 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$96);
    var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
    var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$3 = $m_s_math_Equiv$String$();
    var array$2 = [$$x18, editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$1, optioner$3, ev$5, explainError$3, equiv$3)];
    var array$3 = [$$x20, $n($$x19).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
    var $$x17 = $n($$x23).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var $$x16 = $m_Lcom_iz2use_react_components_Button$().submit__Ljapgolly_scalajs_react_vdom_TagOf();
    var this$106 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
    var array$4 = [this$106.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ajouter"))];
    var array$5 = [$$x17, $n($$x16).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var array$6 = [$n($$x24).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var u = $n($$x28).apply__O__sci_Seq__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x25, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
    var this$120 = $n(u);
    var n = this$120.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$122 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6(this$122);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$6 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$123, f$8, step$2, s);
  this.Lreactbuild_person_AddPersonReference$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$124, ev$6).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.person.AddPersonReference.component"))
}
$c_Lreactbuild_person_AddPersonReference$.prototype = new $h_O();
$c_Lreactbuild_person_AddPersonReference$.prototype.constructor = $c_Lreactbuild_person_AddPersonReference$;
/** @constructor */
function $h_Lreactbuild_person_AddPersonReference$() {
  /*<skip>*/
}
$h_Lreactbuild_person_AddPersonReference$.prototype = $c_Lreactbuild_person_AddPersonReference$.prototype;
$c_Lreactbuild_person_AddPersonReference$.prototype.apply__Lreactbuild_person_PersonReferenceList$Targets__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(targets, upsert) {
  var c = this.Lreactbuild_person_AddPersonReference$__f_component;
  var $$x1 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
  var this$2 = $n(targets);
  var a = $m_sr_ScalaRunTime$()._toString__s_Product__T(this$2);
  var this$7 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x1).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
  var props = new $c_Lreactbuild_person_AddPersonReference$Props(targets, upsert);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$7.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$7.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_person_AddPersonReference$ = new $TypeData().initClass({
  Lreactbuild_person_AddPersonReference$: 0
}, false, "reactbuild.person.AddPersonReference$", {
  Lreactbuild_person_AddPersonReference$: 1,
  O: 1
});
$c_Lreactbuild_person_AddPersonReference$.prototype.$classData = $d_Lreactbuild_person_AddPersonReference$;
var $n_Lreactbuild_person_AddPersonReference$;
function $m_Lreactbuild_person_AddPersonReference$() {
  if ((!$n_Lreactbuild_person_AddPersonReference$)) {
    $n_Lreactbuild_person_AddPersonReference$ = new $c_Lreactbuild_person_AddPersonReference$()
  };
  return $n_Lreactbuild_person_AddPersonReference$
}
function $is_Lreactbuild_person_AddressDetails(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_person_AddressDetails)))
}
function $as_Lreactbuild_person_AddressDetails(obj) {
  return (($is_Lreactbuild_person_AddressDetails(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.AddressDetails"))
}
function $isArrayOf_Lreactbuild_person_AddressDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_AddressDetails)))
}
function $asArrayOf_Lreactbuild_person_AddressDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_AddressDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.AddressDetails;", depth))
}
/** @constructor */
function $c_Lreactbuild_person_AddressDetails$() {
  this.Lreactbuild_person_AddressDetails$__f_codecForAddressDetails = null;
  $n_Lreactbuild_person_AddressDetails$ = this;
  var inst$macro$92 = new $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$92));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_AddressDetails$__f_codecForAddressDetails = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_AddressDetails$.prototype = new $h_O();
$c_Lreactbuild_person_AddressDetails$.prototype.constructor = $c_Lreactbuild_person_AddressDetails$;
/** @constructor */
function $h_Lreactbuild_person_AddressDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_person_AddressDetails$.prototype = $c_Lreactbuild_person_AddressDetails$.prototype;
var $d_Lreactbuild_person_AddressDetails$ = new $TypeData().initClass({
  Lreactbuild_person_AddressDetails$: 0
}, false, "reactbuild.person.AddressDetails$", {
  Lreactbuild_person_AddressDetails$: 1,
  O: 1
});
$c_Lreactbuild_person_AddressDetails$.prototype.$classData = $d_Lreactbuild_person_AddressDetails$;
var $n_Lreactbuild_person_AddressDetails$;
function $m_Lreactbuild_person_AddressDetails$() {
  if ((!$n_Lreactbuild_person_AddressDetails$)) {
    $n_Lreactbuild_person_AddressDetails$ = new $c_Lreactbuild_person_AddressDetails$()
  };
  return $n_Lreactbuild_person_AddressDetails$
}
function $is_Lreactbuild_person_Bounds(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_person_Bounds)))
}
function $as_Lreactbuild_person_Bounds(obj) {
  return (($is_Lreactbuild_person_Bounds(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Bounds"))
}
function $isArrayOf_Lreactbuild_person_Bounds(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Bounds)))
}
function $asArrayOf_Lreactbuild_person_Bounds(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Bounds(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Bounds;", depth))
}
function $is_Lreactbuild_person_CredentialData(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_person_CredentialData)))
}
function $as_Lreactbuild_person_CredentialData(obj) {
  return (($is_Lreactbuild_person_CredentialData(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.CredentialData"))
}
function $isArrayOf_Lreactbuild_person_CredentialData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_CredentialData)))
}
function $asArrayOf_Lreactbuild_person_CredentialData(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_CredentialData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.CredentialData;", depth))
}
/** @constructor */
function $c_Lreactbuild_person_CredentialData$() {
  this.Lreactbuild_person_CredentialData$__f_codecForCredentialData = null;
  $n_Lreactbuild_person_CredentialData$ = this;
  var inst$macro$24 = new $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$24));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_CredentialData$__f_codecForCredentialData = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_CredentialData$.prototype = new $h_O();
$c_Lreactbuild_person_CredentialData$.prototype.constructor = $c_Lreactbuild_person_CredentialData$;
/** @constructor */
function $h_Lreactbuild_person_CredentialData$() {
  /*<skip>*/
}
$h_Lreactbuild_person_CredentialData$.prototype = $c_Lreactbuild_person_CredentialData$.prototype;
var $d_Lreactbuild_person_CredentialData$ = new $TypeData().initClass({
  Lreactbuild_person_CredentialData$: 0
}, false, "reactbuild.person.CredentialData$", {
  Lreactbuild_person_CredentialData$: 1,
  O: 1
});
$c_Lreactbuild_person_CredentialData$.prototype.$classData = $d_Lreactbuild_person_CredentialData$;
var $n_Lreactbuild_person_CredentialData$;
function $m_Lreactbuild_person_CredentialData$() {
  if ((!$n_Lreactbuild_person_CredentialData$)) {
    $n_Lreactbuild_person_CredentialData$ = new $c_Lreactbuild_person_CredentialData$()
  };
  return $n_Lreactbuild_person_CredentialData$
}
function $is_Lreactbuild_person_DocumentParserFormat(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_person_DocumentParserFormat)))
}
function $as_Lreactbuild_person_DocumentParserFormat(obj) {
  return (($is_Lreactbuild_person_DocumentParserFormat(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.DocumentParserFormat"))
}
function $isArrayOf_Lreactbuild_person_DocumentParserFormat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_DocumentParserFormat)))
}
function $asArrayOf_Lreactbuild_person_DocumentParserFormat(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_DocumentParserFormat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.DocumentParserFormat;", depth))
}
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$() {
  this.Lreactbuild_person_DocumentParserFormat$__f_codecForDocumentParserFormat = null;
  $n_Lreactbuild_person_DocumentParserFormat$ = this;
  var inst$macro$180 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$180));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_DocumentParserFormat$__f_codecForDocumentParserFormat = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_DocumentParserFormat$.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserFormat$.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$.prototype = $c_Lreactbuild_person_DocumentParserFormat$.prototype;
var $d_Lreactbuild_person_DocumentParserFormat$ = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$: 0
}, false, "reactbuild.person.DocumentParserFormat$", {
  Lreactbuild_person_DocumentParserFormat$: 1,
  O: 1
});
$c_Lreactbuild_person_DocumentParserFormat$.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$;
var $n_Lreactbuild_person_DocumentParserFormat$;
function $m_Lreactbuild_person_DocumentParserFormat$() {
  if ((!$n_Lreactbuild_person_DocumentParserFormat$)) {
    $n_Lreactbuild_person_DocumentParserFormat$ = new $c_Lreactbuild_person_DocumentParserFormat$()
  };
  return $n_Lreactbuild_person_DocumentParserFormat$
}
function $p_Lreactbuild_person_FacetRegistry$__register__Lreactbuild_person_IsFacet__V($thiz, ev) {
  var $$x1 = $thiz.Lreactbuild_person_FacetRegistry$__f_registryByName;
  var self = $n(ev).Lreactbuild_person_IsFacet__f_name;
  $thiz.Lreactbuild_person_FacetRegistry$__f_registryByName = $as_sci_Map($n($$x1).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self, ev)));
  var $$x2 = $thiz.Lreactbuild_person_FacetRegistry$__f_registryByClassTag;
  var self$1 = $n(ev).Lreactbuild_person_IsFacet__f_classTag;
  $thiz.Lreactbuild_person_FacetRegistry$__f_registryByClassTag = $as_sci_Map($n($$x2).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self$1, ev)))
}
/** @constructor */
function $c_Lreactbuild_person_FacetRegistry$() {
  this.Lreactbuild_person_FacetRegistry$__f_registryByName = null;
  this.Lreactbuild_person_FacetRegistry$__f_registryByClassTag = null;
  $n_Lreactbuild_person_FacetRegistry$ = this;
  this.Lreactbuild_person_FacetRegistry$__f_registryByName = ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$());
  this.Lreactbuild_person_FacetRegistry$__f_registryByClassTag = ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$());
  $p_Lreactbuild_person_FacetRegistry$__register__Lreactbuild_person_IsFacet__V(this, new $c_Lreactbuild_person_IsFacet($d_Lreactbuild_person_CustomerFacet.getClassOf(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_CustomerFacet.getClassOf()), $m_Lreactbuild_person_CustomerFacet$().Lreactbuild_person_CustomerFacet$__f_codecForCustomerFacet, $m_Lreactbuild_person_CustomerFacet$().Lreactbuild_person_CustomerFacet$__f_codecForCustomerFacet));
  $p_Lreactbuild_person_FacetRegistry$__register__Lreactbuild_person_IsFacet__V(this, new $c_Lreactbuild_person_IsFacet($d_Lreactbuild_person_SupplierFacet.getClassOf(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_SupplierFacet.getClassOf()), $m_Lreactbuild_person_SupplierFacet$().Lreactbuild_person_SupplierFacet$__f_codecForSupplierFacet, $m_Lreactbuild_person_SupplierFacet$().Lreactbuild_person_SupplierFacet$__f_codecForSupplierFacet));
  $p_Lreactbuild_person_FacetRegistry$__register__Lreactbuild_person_IsFacet__V(this, new $c_Lreactbuild_person_IsFacet($d_Lreactbuild_person_ResourceFacet.getClassOf(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_ResourceFacet.getClassOf()), $m_Lreactbuild_person_ResourceFacet$().Lreactbuild_person_ResourceFacet$__f_codecForResourceFacet, $m_Lreactbuild_person_ResourceFacet$().Lreactbuild_person_ResourceFacet$__f_codecForResourceFacet));
  $p_Lreactbuild_person_FacetRegistry$__register__Lreactbuild_person_IsFacet__V(this, new $c_Lreactbuild_person_IsFacet($d_Lreactbuild_person_EstateAgentFacet.getClassOf(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_EstateAgentFacet.getClassOf()), $m_Lreactbuild_person_EstateAgentFacet$().Lreactbuild_person_EstateAgentFacet$__f_codecForEstateAgentFacet, $m_Lreactbuild_person_EstateAgentFacet$().Lreactbuild_person_EstateAgentFacet$__f_codecForEstateAgentFacet));
  $p_Lreactbuild_person_FacetRegistry$__register__Lreactbuild_person_IsFacet__V(this, new $c_Lreactbuild_person_IsFacet($d_Lreactbuild_person_UserFacet.getClassOf(), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_UserFacet.getClassOf()), $m_Lreactbuild_person_UserFacet$().Lreactbuild_person_UserFacet$__f_codecForUserFacet, $m_Lreactbuild_person_UserFacet$().Lreactbuild_person_UserFacet$__f_codecForUserFacet))
}
$c_Lreactbuild_person_FacetRegistry$.prototype = new $h_O();
$c_Lreactbuild_person_FacetRegistry$.prototype.constructor = $c_Lreactbuild_person_FacetRegistry$;
/** @constructor */
function $h_Lreactbuild_person_FacetRegistry$() {
  /*<skip>*/
}
$h_Lreactbuild_person_FacetRegistry$.prototype = $c_Lreactbuild_person_FacetRegistry$.prototype;
$c_Lreactbuild_person_FacetRegistry$.prototype.nameOf__s_reflect_ClassTag__T = (function(ev) {
  return $n($as_Lreactbuild_person_IsFacet($n(this.Lreactbuild_person_FacetRegistry$__f_registryByClassTag).apply__O__O(ev))).Lreactbuild_person_IsFacet__f_name
});
var $d_Lreactbuild_person_FacetRegistry$ = new $TypeData().initClass({
  Lreactbuild_person_FacetRegistry$: 0
}, false, "reactbuild.person.FacetRegistry$", {
  Lreactbuild_person_FacetRegistry$: 1,
  O: 1
});
$c_Lreactbuild_person_FacetRegistry$.prototype.$classData = $d_Lreactbuild_person_FacetRegistry$;
var $n_Lreactbuild_person_FacetRegistry$;
function $m_Lreactbuild_person_FacetRegistry$() {
  if ((!$n_Lreactbuild_person_FacetRegistry$)) {
    $n_Lreactbuild_person_FacetRegistry$ = new $c_Lreactbuild_person_FacetRegistry$()
  };
  return $n_Lreactbuild_person_FacetRegistry$
}
function $is_Lreactbuild_person_PaymentMethod(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_person_PaymentMethod)))
}
function $as_Lreactbuild_person_PaymentMethod(obj) {
  return (($is_Lreactbuild_person_PaymentMethod(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PaymentMethod"))
}
function $isArrayOf_Lreactbuild_person_PaymentMethod(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PaymentMethod)))
}
function $asArrayOf_Lreactbuild_person_PaymentMethod(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PaymentMethod(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PaymentMethod;", depth))
}
/** @constructor */
function $c_Lreactbuild_person_PaymentMethod$() {
  this.Lreactbuild_person_PaymentMethod$__f_codecForPaymentMethod = null;
  $n_Lreactbuild_person_PaymentMethod$ = this;
  var inst$macro$12 = new $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_PaymentMethod$__f_codecForPaymentMethod = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_PaymentMethod$.prototype = new $h_O();
$c_Lreactbuild_person_PaymentMethod$.prototype.constructor = $c_Lreactbuild_person_PaymentMethod$;
/** @constructor */
function $h_Lreactbuild_person_PaymentMethod$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentMethod$.prototype = $c_Lreactbuild_person_PaymentMethod$.prototype;
var $d_Lreactbuild_person_PaymentMethod$ = new $TypeData().initClass({
  Lreactbuild_person_PaymentMethod$: 0
}, false, "reactbuild.person.PaymentMethod$", {
  Lreactbuild_person_PaymentMethod$: 1,
  O: 1
});
$c_Lreactbuild_person_PaymentMethod$.prototype.$classData = $d_Lreactbuild_person_PaymentMethod$;
var $n_Lreactbuild_person_PaymentMethod$;
function $m_Lreactbuild_person_PaymentMethod$() {
  if ((!$n_Lreactbuild_person_PaymentMethod$)) {
    $n_Lreactbuild_person_PaymentMethod$ = new $c_Lreactbuild_person_PaymentMethod$()
  };
  return $n_Lreactbuild_person_PaymentMethod$
}
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceList$() {
  this.Lreactbuild_person_PersonReferenceList$__f_personReferenceListSection = null;
  this.Lreactbuild_person_PersonReferenceList$__f_skeleton = null;
  this.Lreactbuild_person_PersonReferenceList$__f_reusePersonReferenceEvent = null;
  this.Lreactbuild_person_PersonReferenceList$__f_component = null;
  $n_Lreactbuild_person_PersonReferenceList$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_person_PersonReferenceList$__f_personReferenceListSection = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x11 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$alignItems$();
    var $$x10 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
    $n(dsl);
    var this$8 = $m_Lscalacss_internal_Attrs$display$();
    var $$x9 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$8.Lscalacss_internal_Attrs$display$__f_attr, "inline-grid")));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var $$x8 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1fr 1fr")));
    $n(dsl);
    var this$21 = $m_Lscalacss_internal_Attrs$margin$();
    $n(dsl);
    $n(dsl);
    var this$ = 0.25;
    var u = $m_Lscalacss_internal_LengthUnit$em$();
    var f$1 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var all = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$1 = $n(all).Lscalacss_internal_ValueT__f_value;
    var $$x7 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$21.Lscalacss_internal_Attrs$margin$__f_attr, v$1)));
    $n(dsl);
    var this$31 = $m_Lscalacss_internal_Attrs$marginLeft$();
    $n(dsl);
    $n(dsl);
    var this$$1 = 3;
    var u$1 = $m_Lscalacss_internal_LengthUnit$em$();
    var f$3 = new $c_Lscalacss_internal_Length(this$$1, u$1);
    $n(dsl);
    $n(dsl);
    var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      var x$3$1 = $as_Lscalacss_internal_Length(x$3$2$1);
      return $n(x$3$1).value__T()
    })));
    $n(dsl);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$1)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
    var r$1 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var v$2 = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$3);
    var v$3 = $n(v$2).Lscalacss_internal_ValueT__f_value;
    var array = [$$x10, $$x9, $$x8, $$x7, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$31.Lscalacss_internal_Attrs$marginLeft$__f_attr, v$3)))];
    var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(dsl).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("dl", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
    $n(dsl);
    $n(dsl);
    var a$1 = $m_Lscalacss_internal_Attrs$margin$();
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1.Lscalacss_internal_Attrs$margin$__f_attr, "0")));
    $n(dsl);
    var this$48 = $m_Lscalacss_internal_Attrs$fontSize$();
    $n(dsl);
    $n(dsl);
    var this$$2 = 125;
    var f$5 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$2);
    $n(dsl);
    $n(dsl);
    var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lscalacss_internal_Percentage(x$4$2);
      return $n(x$4).value__T()
    })));
    $n(dsl);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
      var x$1$3 = $as_Lscalacss_internal_ValueT(x$1$2$2);
      return $n(x$1$3)
    }));
    var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
    var r$2 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
    var v$4 = $n(r$2).apply__O__Lscalacss_internal_ValueT(f$5);
    var v$5 = $n(v$4).Lscalacss_internal_ValueT__f_value;
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$48.Lscalacss_internal_Attrs$fontSize$__f_attr, v$5)));
    $n(dsl);
    var this$58 = $m_Lscalacss_internal_Attrs$paddingLeft$();
    $n(dsl);
    $n(dsl);
    var this$$3 = 0.5;
    var u$2 = $m_Lscalacss_internal_LengthUnit$em$();
    var f$7 = new $c_Lscalacss_internal_Length(this$$3, u$2);
    $n(dsl);
    $n(dsl);
    var ab$3 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$2) => {
      var x$3$3 = $as_Lscalacss_internal_Length(x$3$2$2);
      return $n(x$3$3).value__T()
    })));
    $n(dsl);
    var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
      var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$3);
      return $n(x$1$4)
    }));
    var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
    var r$3 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
    var v$6 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$7);
    var v$7 = $n(v$6).Lscalacss_internal_ValueT__f_value;
    var array$1 = [$$x5, $$x4, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$58.Lscalacss_internal_Attrs$paddingLeft$__f_attr, v$7)))];
    var $$x3 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(dsl).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("dd", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
    $n(dsl);
    $n(dsl);
    var a$2 = $m_Lscalacss_internal_Attrs$margin$();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2.Lscalacss_internal_Attrs$margin$__f_attr, "0")));
    $n(dsl);
    var this$68 = $m_Lscalacss_internal_Attrs$fontWeight$();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$68.Lscalacss_internal_Attrs$fontWeight$__f_attr, "lighter")));
    $n(dsl);
    var this$78 = $m_Lscalacss_internal_Attrs$paddingRight$();
    $n(dsl);
    $n(dsl);
    var this$$4 = 0.5;
    var u$3 = $m_Lscalacss_internal_LengthUnit$em$();
    var f$9 = new $c_Lscalacss_internal_Length(this$$4, u$3);
    $n(dsl);
    $n(dsl);
    var ab$4 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$3) => {
      var x$3$4 = $as_Lscalacss_internal_Length(x$3$2$3);
      return $n(x$3$4).value__T()
    })));
    $n(dsl);
    var f$8 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
      var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$4);
      return $n(x$1$5)
    }));
    var bc$4 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$8);
    var r$4 = $n(ab$4).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$4);
    var v$8 = $n(r$4).apply__O__Lscalacss_internal_ValueT(f$9);
    var v$9 = $n(v$8).Lscalacss_internal_ValueT__f_value;
    var array$2 = [$$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$78.Lscalacss_internal_Attrs$paddingRight$__f_attr, v$9)))];
    var array$3 = [$$x6, $$x3, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(dsl).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("dt", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
    return $as_sci_Seq($n($$x11).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)))
  })), new $c_Lsourcecode_Name("personReferenceListSection"));
  var $$x18 = $m_Lcom_iz2use_react_components_Skeleton$();
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u$4 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(8);
  var this$89 = $n(u$4);
  var n = this$89.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x16 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  var $$x15 = $m_Lcom_iz2use_react_components_Skeleton$();
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x13 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("marginLeft")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("3em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var u$5 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(30);
  var this$95 = $n(u$5);
  var n$1 = this$95.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x12 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
  var u$6 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(16);
  var this$98 = $n(u$6);
  var n$2 = this$98.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$4 = [$$x13, $$x12, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
  var array$5 = [$n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var u$7 = $n($$x15).list__I__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var this$107 = $n(u$7);
  var n$3 = this$107.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$6 = [$$x16, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)];
  var array$7 = [$n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
  this.Lreactbuild_person_PersonReferenceList$__f_skeleton = $n($$x18).list__I__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var this$115 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_person_PersonReferenceList$__f_reusePersonReferenceEvent = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$115.byRef__F2(), this$115.by_$eq$eq__F2());
  new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onToggle");
  var this$220 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var this$121 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).usePageProps__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep())));
  var initialState = new $c_sjsr_AnonFunction0((() => false));
  var this$120 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$120);
  var this$125 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$121, initialState, step)));
  var effect = new $c_sjsr_AnonFunction3(((x$4$2$1, x$5$2, mounted$2) => {
    $as_Lreactbuild_person_PersonReferenceList$Props(x$4$2$1);
    $as_Lreactbuild_package$PageProps(x$5$2);
    var mounted = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(mounted$2);
    var this$122 = $n(mounted);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n($f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$122)).value__O())).apply__O__O(true))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var a$3 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$124 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$124);
  var this$128 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$125, effect, a$3, step$1)));
  var initialState$1 = new $c_sjsr_AnonFunction0((() => {
    $n($m_s_package$().s_package$__f_List);
    return $m_sci_Nil$()
  }));
  var this$127 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$127);
  var this$154 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$128, initialState$1, step$2)));
  var deps = new $c_sjsr_AnonFunction4(((props$2, x$6$2, x$7$2, personList$2) => {
    var props = $as_Lreactbuild_person_PersonReferenceList$Props(props$2);
    $as_Lreactbuild_package$PageProps(x$6$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$7$2);
    var personList = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(personList$2);
    var $$x19 = $n(props).Lreactbuild_person_PersonReferenceList$Props__f_events;
    var this$129 = $n(personList);
    return $ct_T2__O__O__(new $c_T2(), $$x19, this$129.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])
  }));
  var callback = new $c_sjsr_AnonFunction4(((props$3$2, x$8$2, x$9$2, personList$3$2) => {
    var props$3 = $as_Lreactbuild_person_PersonReferenceList$Props(props$3$2);
    $as_Lreactbuild_package$PageProps(x$8$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$9$2);
    var personList$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(personList$3$2);
    return new $c_sjsr_AnonFunction1(((x$10$2) => {
      $as_T2(x$10$2);
      return new $c_sjsr_AnonFunction1(((ev$2) => {
        var ev = $as_Lreactbuild_person_PersonReferenceEvent(ev$2);
        var cb = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
          var this$130 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var $$x22 = new $c_Lautowire_ClientProxy(this$130).Lautowire_ClientProxy__f_self;
          var $$x21 = $m_s_package$().s_package$__f_Seq;
          var array$8 = ["reactbuild", "person", "PersonApi", "persistReference"];
          var $$x20 = $as_sci_Seq($n($$x21).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8)));
          var this$141 = $n($m_s_Predef$().s_Predef$__f_Map);
          var this$135 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$136 = $n(new $c_Lautowire_ClientProxy(this$135).Lautowire_ClientProxy__f_self);
          var evidence$2 = $m_Lreactbuild_person_PersonReferenceEvent$().Lreactbuild_person_PersonReferenceEvent$__f_codecForPersonReferenceEvent;
          var y = this$136.write__O__Lio_circe_Encoder__Lio_circe_Json(ev, evidence$2);
          var array$9 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
          return $n($n($$x22).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x20, this$141.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2$5) => {
            var x$1$6 = $as_Lio_circe_Json(x$1$2$5);
            var this$142 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var this$143 = $n(new $c_Lautowire_ClientProxy(this$142).Lautowire_ClientProxy__f_self);
            var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
            this$143.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1$6, evidence$1)
          })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue), new $c_sjsr_AnonFunction1(((x$14$2) => {
          $as_jl_Void(x$14$2);
          var $$x23 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
          var this$144 = $n($n(props$3).Lreactbuild_person_PersonReferenceList$Props__f_events);
          var x = ((!this$144.isEmpty__Z()) ? new $c_s_Some(this$144.get__O()) : $m_s_None$());
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x23).flatMap$extension__F1__F1__F1(new $c_Lreactbuild_hooks_EnhancedOption(x).toAsyncCallback__F0__F1(new $c_sjsr_AnonFunction0((() => $ct_jl_Exception__T__(new $c_jl_Exception(), "not ready")))), new $c_sjsr_AnonFunction1(((ss$2) => {
            var ss = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(ss$2);
            var $$x25 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
            var $$x24 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var this$147 = $n(ss);
            var mod = new $c_sjsr_AnonFunction1(((x$11$2) => {
              var x$11 = $as_sci_List(x$11$2);
              var this$146 = $n(x$11);
              return new $c_sci_$colon$colon(ev, this$146)
            }));
            return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x25).flatMap$extension__F1__F1__F1($n($$x24).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$147, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$13$2) => {
              $as_jl_Void(x$13$2);
              var $$x27 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
              var $$x26 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
              var this$148 = $n(personList$3);
              return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x27).map$extension__F1__F1__F1($n($$x26).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n($f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$148)).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((lst$2) => {
                var lst = $as_sci_List(lst$2);
                if ($n(lst).contains__O__Z($n(ev).Lreactbuild_person_PersonReferenceEvent__f_person)) {
                  return lst
                } else {
                  var rassoc$2 = $n(ev).Lreactbuild_person_PersonReferenceEvent__f_person;
                  var this$149 = $n(lst);
                  return new $c_sci_$colon$colon(rassoc$2, this$149)
                }
              }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$12$2) => {
                $as_jl_Void(x$12$2)
              }))))
            }))))
          }))))
        })));
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(cb))
      }))
    }))
  }));
  var this$151 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var a$4 = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$151, Z);
  var $$x29 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x28 = $m_Lreactbuild_model_Implicits$();
  var this$152 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var r$5 = $n($$x29).tuple2__F2__F2__F2($n($$x28).reusabilityPotC__F2__F2(this$152.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3)), $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2()));
  var this$153 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$153);
  var this$165 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackWithDepsBy__O__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$154, deps, callback, a$4, r$5, step$3)));
  var deps$1 = new $c_sjsr_AnonFunction5(((x$15$2, x$16$2, mounted$3$2, opened$2, x$17$2) => {
    $as_Lreactbuild_person_PersonReferenceList$Props(x$15$2);
    $as_Lreactbuild_package$PageProps(x$16$2);
    var mounted$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(mounted$3$2);
    var opened = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(opened$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$17$2);
    var this$155 = $n(mounted$3);
    var $$x30 = this$155.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var this$156 = $n(opened);
    return $ct_T2__O__O__(new $c_T2(), $$x30, this$156.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])
  }));
  var callback$1 = new $c_sjsr_AnonFunction5(((x$18$2, x$19$2, mounted$4$2, opened$3$2, x$20$2) => {
    $as_Lreactbuild_person_PersonReferenceList$Props(x$18$2);
    $as_Lreactbuild_package$PageProps(x$19$2);
    var mounted$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(mounted$4$2);
    var opened$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(opened$3$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$20$2);
    return new $c_sjsr_AnonFunction1(((x$21$2) => {
      $as_T2(x$21$2);
      return new $c_sjsr_AnonFunction1(((personRef$2) => {
        var personRef = $as_Lreactbuild_common_model_RefTo(personRef$2);
        var $$x31 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
        var this$157 = $n(mounted$4);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x31).when__Z__F0__Ljapgolly_scalajs_react_callback_Trampoline($uZ(this$157.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]), new $c_sjsr_AnonFunction0((() => {
          var this$158 = $n(opened$3);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n($f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$158)).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((lst$2$1) => {
            var lst$1 = $as_sci_List(lst$2$1);
            if ($n(lst$1).contains__O__Z(personRef)) {
              var this$159 = $n(lst$1);
              var p = new $c_sjsr_AnonFunction1(((x$22$2) => {
                var x$22 = $as_Lreactbuild_common_model_RefTo(x$22$2);
                return (!((x$22 === null) ? (personRef === null) : $n(x$22).equals__O__Z(personRef)))
              }));
              return $p_sci_List__filterCommon__F1__Z__sci_List(this$159, p, false)
            } else {
              var this$160 = $n(lst$1);
              return new $c_sci_$colon$colon(personRef, this$160)
            }
          }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        }))))
      }))
    }))
  }));
  var this$162 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var a$5 = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$162, Z$1);
  var $$x32 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$163 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r$6 = $n($$x32).tuple2__F2__F2__F2(this$163.by_$eq$eq__F2(), $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2()));
  var this$164 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$164);
  var this$219 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackWithDepsBy__O__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$165, deps$1, callback$1, a$5, r$6, step$4)));
  var f$11 = new $c_sjsr_AnonFunction6(((props$4$2, pageProps$2, x$23$2, opened$4$2, upsert$2, toggle$2) => {
    var props$4 = $as_Lreactbuild_person_PersonReferenceList$Props(props$4$2);
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$23$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(opened$4$2);
    var upsert = $as_Ljapgolly_scalajs_react_Reusable(upsert$2);
    $as_Ljapgolly_scalajs_react_Reusable(toggle$2);
    var this$217 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x33 = $m_Lreactbuild_analyze_cost_components_RenderPot$().onlyReady__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode($n(props$4).Lreactbuild_person_PersonReferenceList$Props__f_events, new $c_sjsr_AnonFunction0((() => {
      var u$8 = $m_Lreactbuild_person_PersonReferenceList$().Lreactbuild_person_PersonReferenceList$__f_skeleton;
      var this$167 = $n(u$8);
      var n$4 = this$167.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4)
    })), new $c_sjsr_AnonFunction1(((references$2) => {
      var references = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(references$2);
      var grouped = $n($as_Lreactbuild_person_PersonReferenceListRender($n($n(props$4).Lreactbuild_person_PersonReferenceList$Props__f_targets).Lreactbuild_person_PersonReferenceList$Targets__f_render)).group__sci_List__Lreactbuild_package$PageProps__sci_List($as_sci_List($n(references).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), pageProps);
      var $$x42 = $n($m_Lreactbuild_person_PersonReferenceList$().Lreactbuild_person_PersonReferenceList$__f_personReferenceListSection);
      var array$16 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), grouped), new $c_sjsr_AnonFunction1(((x0$1$2) => {
        var x0$1 = $as_T2(x0$1$2);
        if ((x0$1 !== null)) {
          var header = $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(x0$1)._1__O());
          var referenceList = $as_sci_List($n(x0$1)._2__O());
          var this$170 = $n($n(referenceList).flatMap__F1__sci_List(new $c_sjsr_AnonFunction1(((x$24$2) => {
            var x$24 = $as_Lreactbuild_person_PersonReferenceEvent(x$24$2);
            return $n(x$24).Lreactbuild_person_PersonReferenceEvent__f_details
          }))));
          var f$10 = new $c_sjsr_AnonFunction1(((x$25$2) => {
            var x$25 = $as_Lreactbuild_person_PersonReferenceDetails(x$25$2);
            return $n(x$25).Lreactbuild_person_PersonReferenceDetails__f_model
          }));
          var ord = $m_s_math_Ordering$String$();
          var sortedList = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$170, f$10, ord));
          var $$x41 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$175 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "open");
          var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
          var $$x40 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$175.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, true);
          var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$10 = [header];
          var $$x38 = $n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("summary", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
          var $$x37 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$14 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), sortedList), new $c_sjsr_AnonFunction1(((d$2) => {
            var d = $as_Lreactbuild_person_PersonReferenceDetails(d$2);
            var this$201 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
            var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            var v$10 = $n(d).Lreactbuild_person_PersonReferenceDetails__f_model;
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            var array$11 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$10)];
            var $$x35 = $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("dt", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
            var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            var v$11 = $n(d).Lreactbuild_person_PersonReferenceDetails__f_value;
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            var array$12 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$11)];
            var array$13 = [$$x35, $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("dd", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
            var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
            return this$201.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
          })))];
          var array$15 = [$$x40, $$x38, $n($$x37).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("dl", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
          return $n($$x41).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("details", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))
        } else {
          throw new $c_s_MatchError(x0$1)
        }
      })))];
      return $n($$x42).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))
    })));
    var u$9 = $m_Lreactbuild_person_AddPersonReference$().apply__Lreactbuild_person_PersonReferenceList$Targets__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(props$4).Lreactbuild_person_PersonReferenceList$Props__f_targets, upsert);
    var this$212 = $n(u$9);
    var n$5 = this$212.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$17 = [$$x33, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$5)];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$217, null, ns)
  }));
  var this$218 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$5 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(this$218);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$219, f$11, step$5, s);
  this.Lreactbuild_person_PersonReferenceList$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$220, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.person.PersonReferenceList.component"))
}
$c_Lreactbuild_person_PersonReferenceList$.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceList$.prototype.constructor = $c_Lreactbuild_person_PersonReferenceList$;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceList$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceList$.prototype = $c_Lreactbuild_person_PersonReferenceList$.prototype;
$c_Lreactbuild_person_PersonReferenceList$.prototype.apply__s_Option__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(personRefOpt, otherRefList) {
  var targets = new $c_Lreactbuild_person_PersonReferenceList$Targets(personRefOpt, otherRefList);
  return $m_Lcom_iz2use_react_components_FetchCacheAndRender$().query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(targets, new $c_sjsr_AnonFunction1(((crit$2) => {
    var crit = $as_Lreactbuild_person_PersonReferenceList$Targets(crit$2);
    if (($n($n(crit).Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt).isEmpty__Z() && $n($n(crit).Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList).isEmpty__Z())) {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_s_package$().s_package$__f_Nil)
    } else {
      var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x4 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
      var $$x3 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "person", "PersonApi", "getLastReferences"];
      var $$x2 = $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$19 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$9 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
      var r = $n(crit).Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt;
      $m_Lio_circe_Encoder$();
      var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var evidence$2 = new $c_Lio_circe_Encoder$$anon$21(e);
      var y = this$9.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
      var $$x1 = $ct_T2__O__O__(new $c_T2(), "person", y);
      var this$12 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$14 = $n(new $c_Lautowire_ClientProxy(this$12).Lautowire_ClientProxy__f_self);
      var r$1 = $n(crit).Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList;
      $m_Lio_circe_Encoder$();
      var encodeA = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var evidence$2$1 = new $c_Lio_circe_Encoder$$anon$25(encodeA);
      var y$1 = this$14.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
      var array$1 = [$$x1, $ct_T2__O__O__(new $c_T2(), "target", y$1)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      return $n($n($$x4).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x2, this$19.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$20 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$22 = $n(new $c_Lautowire_ClientProxy(this$20).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lreactbuild_person_PersonReferenceEvent$().Lreactbuild_person_PersonReferenceEvent$__f_codecForPersonReferenceEvent;
        var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
        return $as_sci_List(this$22.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }
  })), new $c_sjsr_AnonFunction1(((events$2) => {
    var events = $as_Ldiode_data_Pot(events$2);
    var c = $m_Lreactbuild_person_PersonReferenceList$().Lreactbuild_person_PersonReferenceList$__f_component;
    var this$24 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_person_PersonReferenceList$Props(targets, events);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$24.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$24.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$26 = $n(u);
    var n = this$26.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })), $m_Lreactbuild_person_PersonReferenceList$Targets$().Lreactbuild_person_PersonReferenceList$Targets$__f_reuseProps, $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2(this.Lreactbuild_person_PersonReferenceList$__f_reusePersonReferenceEvent), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
});
var $d_Lreactbuild_person_PersonReferenceList$ = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceList$: 0
}, false, "reactbuild.person.PersonReferenceList$", {
  Lreactbuild_person_PersonReferenceList$: 1,
  O: 1
});
$c_Lreactbuild_person_PersonReferenceList$.prototype.$classData = $d_Lreactbuild_person_PersonReferenceList$;
var $n_Lreactbuild_person_PersonReferenceList$;
function $m_Lreactbuild_person_PersonReferenceList$() {
  if ((!$n_Lreactbuild_person_PersonReferenceList$)) {
    $n_Lreactbuild_person_PersonReferenceList$ = new $c_Lreactbuild_person_PersonReferenceList$()
  };
  return $n_Lreactbuild_person_PersonReferenceList$
}
function $is_Lreactbuild_person_PersonReferenceListRender(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_person_PersonReferenceListRender)))
}
function $as_Lreactbuild_person_PersonReferenceListRender(obj) {
  return (($is_Lreactbuild_person_PersonReferenceListRender(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PersonReferenceListRender"))
}
function $isArrayOf_Lreactbuild_person_PersonReferenceListRender(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PersonReferenceListRender)))
}
function $asArrayOf_Lreactbuild_person_PersonReferenceListRender(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PersonReferenceListRender(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PersonReferenceListRender;", depth))
}
function $is_Lreactbuild_person_Size(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_person_Size)))
}
function $as_Lreactbuild_person_Size(obj) {
  return (($is_Lreactbuild_person_Size(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Size"))
}
function $isArrayOf_Lreactbuild_person_Size(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Size)))
}
function $asArrayOf_Lreactbuild_person_Size(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Size(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Size;", depth))
}
/** @constructor */
function $c_Lreactbuild_person_Size$() {
  this.Lreactbuild_person_Size$__f_codecForSize = null;
  $n_Lreactbuild_person_Size$ = this;
  var inst$macro$8 = new $c_Lreactbuild_person_Size$anon$lazy$macro$7$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$8));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_Size$__f_codecForSize = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_Size$.prototype = new $h_O();
$c_Lreactbuild_person_Size$.prototype.constructor = $c_Lreactbuild_person_Size$;
/** @constructor */
function $h_Lreactbuild_person_Size$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Size$.prototype = $c_Lreactbuild_person_Size$.prototype;
var $d_Lreactbuild_person_Size$ = new $TypeData().initClass({
  Lreactbuild_person_Size$: 0
}, false, "reactbuild.person.Size$", {
  Lreactbuild_person_Size$: 1,
  O: 1
});
$c_Lreactbuild_person_Size$.prototype.$classData = $d_Lreactbuild_person_Size$;
var $n_Lreactbuild_person_Size$;
function $m_Lreactbuild_person_Size$() {
  if ((!$n_Lreactbuild_person_Size$)) {
    $n_Lreactbuild_person_Size$ = new $c_Lreactbuild_person_Size$()
  };
  return $n_Lreactbuild_person_Size$
}
function $ct_Lreactbuild_person_SupplierGroup__T__($thiz, title) {
  $thiz.Lreactbuild_person_SupplierGroup__f_title = title;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_person_SupplierGroup() {
  this.Lreactbuild_person_SupplierGroup__f_title = null
}
$c_Lreactbuild_person_SupplierGroup.prototype = new $h_O();
$c_Lreactbuild_person_SupplierGroup.prototype.constructor = $c_Lreactbuild_person_SupplierGroup;
/** @constructor */
function $h_Lreactbuild_person_SupplierGroup() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierGroup.prototype = $c_Lreactbuild_person_SupplierGroup.prototype;
function $as_Lreactbuild_person_SupplierGroup(obj) {
  return (((obj instanceof $c_Lreactbuild_person_SupplierGroup) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.SupplierGroup"))
}
function $isArrayOf_Lreactbuild_person_SupplierGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_SupplierGroup)))
}
function $asArrayOf_Lreactbuild_person_SupplierGroup(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_SupplierGroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.SupplierGroup;", depth))
}
/** @constructor */
function $c_Lreactbuild_person_SupplierGroup$() {
  this.Lreactbuild_person_SupplierGroup$__f_list = null;
  this.Lreactbuild_person_SupplierGroup$__f_codecForSupplierGroup = null;
  $n_Lreactbuild_person_SupplierGroup$ = this;
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array = [$m_Lreactbuild_person_SupplierGroup$VendeeMateriaux$()];
  this.Lreactbuild_person_SupplierGroup$__f_list = $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var $$x2 = $n($as_sc_IterableOnceOps($n(this.Lreactbuild_person_SupplierGroup$__f_list).map__F1__O(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Lreactbuild_person_SupplierGroup$VendeeMateriaux$(x$2);
    var y = $n(x).Lreactbuild_person_SupplierGroup__f_title;
    return $ct_T2__O__O__(new $c_T2(), x, y)
  })))));
  var this$7 = $m_s_$less$colon$less$();
  $n($$x2).toMap__s_$less$colon$less__sci_Map(this$7.s_$less$colon$less$__f_singleton);
  var inst$macro$8 = new $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$8));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_SupplierGroup$__f_codecForSupplierGroup = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_SupplierGroup$.prototype = new $h_O();
$c_Lreactbuild_person_SupplierGroup$.prototype.constructor = $c_Lreactbuild_person_SupplierGroup$;
/** @constructor */
function $h_Lreactbuild_person_SupplierGroup$() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierGroup$.prototype = $c_Lreactbuild_person_SupplierGroup$.prototype;
var $d_Lreactbuild_person_SupplierGroup$ = new $TypeData().initClass({
  Lreactbuild_person_SupplierGroup$: 0
}, false, "reactbuild.person.SupplierGroup$", {
  Lreactbuild_person_SupplierGroup$: 1,
  O: 1
});
$c_Lreactbuild_person_SupplierGroup$.prototype.$classData = $d_Lreactbuild_person_SupplierGroup$;
var $n_Lreactbuild_person_SupplierGroup$;
function $m_Lreactbuild_person_SupplierGroup$() {
  if ((!$n_Lreactbuild_person_SupplierGroup$)) {
    $n_Lreactbuild_person_SupplierGroup$ = new $c_Lreactbuild_person_SupplierGroup$()
  };
  return $n_Lreactbuild_person_SupplierGroup$
}
function $is_Lreactbuild_person_SupplyRowTarget(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_person_SupplyRowTarget)))
}
function $as_Lreactbuild_person_SupplyRowTarget(obj) {
  return (($is_Lreactbuild_person_SupplyRowTarget(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.SupplyRowTarget"))
}
function $isArrayOf_Lreactbuild_person_SupplyRowTarget(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_SupplyRowTarget)))
}
function $asArrayOf_Lreactbuild_person_SupplyRowTarget(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_SupplyRowTarget(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.SupplyRowTarget;", depth))
}
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$() {
  this.Lreactbuild_person_SupplyRowTarget$__f_codecForSupplyRowTarget = null;
  $n_Lreactbuild_person_SupplyRowTarget$ = this;
  var inst$macro$96 = new $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$96));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_SupplyRowTarget$__f_codecForSupplyRowTarget = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_SupplyRowTarget$.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRowTarget$.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$.prototype = $c_Lreactbuild_person_SupplyRowTarget$.prototype;
var $d_Lreactbuild_person_SupplyRowTarget$ = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$: 0
}, false, "reactbuild.person.SupplyRowTarget$", {
  Lreactbuild_person_SupplyRowTarget$: 1,
  O: 1
});
$c_Lreactbuild_person_SupplyRowTarget$.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$;
var $n_Lreactbuild_person_SupplyRowTarget$;
function $m_Lreactbuild_person_SupplyRowTarget$() {
  if ((!$n_Lreactbuild_person_SupplyRowTarget$)) {
    $n_Lreactbuild_person_SupplyRowTarget$ = new $c_Lreactbuild_person_SupplyRowTarget$()
  };
  return $n_Lreactbuild_person_SupplyRowTarget$
}
/** @constructor */
function $c_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent(event) {
  this.Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent__f_event = null;
  this.Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent__f_event = event
}
$c_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent.prototype.constructor = $c_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent;
/** @constructor */
function $h_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent.prototype = $c_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent.prototype;
$c_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent.prototype.typedTarget__O = (function() {
  return this.Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent__f_event.target
});
var $d_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent = new $TypeData().initClass({
  Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent: 0
}, false, "reactbuild.plugins.devices.BluetoothEvent$RichBluetoothEvent", {
  Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent: 1,
  O: 1
});
$c_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent.prototype.$classData = $d_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent;
function $is_Lreactbuild_plugins_devices_DeviceAction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_plugins_devices_DeviceAction)))
}
function $as_Lreactbuild_plugins_devices_DeviceAction(obj) {
  return (($is_Lreactbuild_plugins_devices_DeviceAction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.plugins.devices.DeviceAction"))
}
function $isArrayOf_Lreactbuild_plugins_devices_DeviceAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_plugins_devices_DeviceAction)))
}
function $asArrayOf_Lreactbuild_plugins_devices_DeviceAction(obj, depth) {
  return (($isArrayOf_Lreactbuild_plugins_devices_DeviceAction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.plugins.devices.DeviceAction;", depth))
}
/** @constructor */
function $c_Lreactbuild_plugins_devices_DeviceMeasure$() {
  this.Lreactbuild_plugins_devices_DeviceMeasure$__f_bleDevices = null;
  this.Lreactbuild_plugins_devices_DeviceMeasure$__f_useDeviceMeasure = null;
  $n_Lreactbuild_plugins_devices_DeviceMeasure$ = this;
  $n($m_s_package$().s_package$__f_List);
  var array = [$m_Lreactbuild_plugins_devices_MEAZOR$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_plugins_devices_DeviceMeasure$__f_bleDevices = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$9 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var reducer = new $c_sjsr_AnonFunction2(((s$2, action$2) => {
    var s = $as_Lreactbuild_plugins_devices_DeviceMeasure$State(s$2);
    var action = $as_Lreactbuild_plugins_devices_DeviceAction(action$2);
    return $m_Lreactbuild_plugins_devices_DeviceMeasure$().handleAction__Lreactbuild_plugins_devices_DeviceMeasure$State__Lreactbuild_plugins_devices_DeviceAction__Lreactbuild_plugins_devices_DeviceMeasure$State(s, action)
  }));
  var initialState = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_plugins_devices_DeviceMeasure$State(false, $m_s_package$().s_package$__f_Nil, $m_s_package$().s_package$__f_Nil)));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$20 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducer__F2__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$9, reducer, initialState, step)));
  var deps = new $c_sjsr_AnonFunction2(((x$9$2, state$2) => {
    $as_jl_Void(x$9$2);
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$2);
    var this$10 = $n(state);
    return $n($as_Lreactbuild_plugins_devices_DeviceMeasure$State(this$10.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_plugins_devices_DeviceMeasure$State__f_active
  }));
  var effect = new $c_sjsr_AnonFunction2(((x$10$2, state$3$2) => {
    $as_jl_Void(x$10$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$3$2);
    return new $c_sjsr_AnonFunction1(((x$11$2) => {
      $uZ(x$11$2);
      var this$11 = $n(state$3);
      if ($n($as_Lreactbuild_plugins_devices_DeviceMeasure$State(this$11.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_plugins_devices_DeviceMeasure$State__f_active) {
        var $$x3 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($m_Lreactbuild_plugins_devices_DeviceMeasure$().requestDevice__F1(), new $c_sjsr_AnonFunction1(((device$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(state$3).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice(device$2))).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$13$2) => {
          $as_jl_Void(x$13$2);
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($m_Lreactbuild_plugins_devices_DeviceMeasure$().connectDevice__Lreactbuild_plugins_devices_BluetoothDevice__F1__F1(device$2, new $c_sjsr_AnonFunction1(((v$2) => {
            var v = $as_Lreactbuild_plugins_devices_DeviceAction(v$2);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(state$3).dispatch__O__Ljapgolly_scalajs_react_Reusable(v)).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
          }))), new $c_sjsr_AnonFunction1(((x$12$2) => {
            $as_jl_Void(x$12$2)
          }))))
        })))))))
      } else {
        var $$x8 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
        var $$x7 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
        var $$x6 = new $c_sjsr_AnonFunction0((() => {
          var this$12 = $n(state$3);
          return $n($as_Lreactbuild_plugins_devices_DeviceMeasure$State(this$12.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices
        }));
        var $$x4 = new $c_sjsr_AnonFunction1(((dev$2) => {
          var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f = new $c_sjsr_AnonFunction0((() => {
            dev$2.gatt.disconnect()
          }));
          var f$1 = new $c_sjsr_AnonFunction0((() => {
            f.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x5).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)))
        }));
        var this$16 = $m_sc_BuildFrom$();
        var $$x3 = $n($$x8).map$extension__F1__F1__F1($n($$x7).traverse__F0__F1__sc_BuildFrom__F1($$x6, $$x4, new $c_sc_BuildFromLowPriority2$$anon$11(this$16)), new $c_sjsr_AnonFunction1(((x$14$2) => {
          $as_sci_List(x$14$2)
        })))
      };
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($$x3)
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$());
  var this$18 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$18.by_$eq$eq__F2();
  var this$19 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$19);
  var $$x2 = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$20, deps, effect, a, r, step$1));
  var $$x1 = new $c_sjsr_AnonFunction2(((x$15$2, reducer$2) => {
    $as_jl_Void(x$15$2);
    var reducer$1 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$2);
    return reducer$1
  }));
  var this$21 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  this.Lreactbuild_plugins_devices_DeviceMeasure$__f_useDeviceMeasure = $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$21))
}
$c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype.constructor = $c_Lreactbuild_plugins_devices_DeviceMeasure$;
/** @constructor */
function $h_Lreactbuild_plugins_devices_DeviceMeasure$() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_DeviceMeasure$.prototype = $c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype;
$c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype.requestDevice__F1 = (function() {
  return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
    var $$x4 = $m_sjs_js_Thenable$ThenableOps$();
    var $$x3 = window.navigator.bluetooth;
    var a$2 = (() => {
      var this$2 = {};
      var $$x1 = $m_sjs_js_JSConverters$JSRichIterableOnce$();
      var this$3 = $n($m_Lreactbuild_plugins_devices_DeviceMeasure$().Lreactbuild_plugins_devices_DeviceMeasure$__f_bleDevices);
      var rest = this$3;
      var h = null;
      var t = null;
      while ((rest !== $m_sci_Nil$())) {
        var arg1 = $n(rest).head__O();
        var x$2 = $as_Lreactbuild_plugins_devices_BLEDeviceMeasure(arg1);
        var it = $n($n(x$2).Lreactbuild_plugins_devices_MEAZOR$__f_filters).iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
          if ((t === null)) {
            h = nx
          } else {
            $n(t).sci_$colon$colon__f_next = nx
          };
          t = nx
        };
        rest = $as_sci_List($n(rest).tail__O())
      };
      var col = ((h === null) ? $m_sci_Nil$() : h);
      var a = $n($$x1).toJSArray$extension__sc_IterableOnce__sjs_js_Array(col);
      this$2.filters = a;
      var $$x2 = $m_sjs_js_JSConverters$JSRichIterableOnce$();
      var this$8 = $n($m_Lreactbuild_plugins_devices_DeviceMeasure$().Lreactbuild_plugins_devices_DeviceMeasure$__f_bleDevices);
      var rest$1 = this$8;
      var h$1 = null;
      var t$1 = null;
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest$1).head__O();
        var x$3 = $as_Lreactbuild_plugins_devices_BLEDeviceMeasure(arg1$1);
        var it$1 = $n($n(x$3).Lreactbuild_plugins_devices_MEAZOR$__f_services).iterator__sc_Iterator();
        while ($n(it$1).hasNext__Z()) {
          var nx$1 = new $c_sci_$colon$colon($n(it$1).next__O(), $m_sci_Nil$());
          if ((t$1 === null)) {
            h$1 = nx$1
          } else {
            $n(t$1).sci_$colon$colon__f_next = nx$1
          };
          t$1 = nx$1
        };
        rest$1 = $as_sci_List($n(rest$1).tail__O())
      };
      var col$1 = ((h$1 === null) ? $m_sci_Nil$() : h$1);
      var a$1 = $n($$x2).toJSArray$extension__sc_IterableOnce__sjs_js_Array(col$1);
      this$2.optionalServices = a$1;
      return this$2
    })();
    var p = $$x3.requestDevice(a$2);
    return $n($$x4).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype.handleEvent__Lreactbuild_plugins_devices_BluetoothEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev, dispatch) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).maybe__F0__Ljapgolly_scalajs_react_util_OptionLike__F0(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($m_Lreactbuild_plugins_devices_DeviceMeasure$().Lreactbuild_plugins_devices_DeviceMeasure$__f_bleDevices);
    var these = this$2;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x$4 = $as_Lreactbuild_plugins_devices_BLEDeviceMeasure(arg1);
      if ($n($n(x$4).Lreactbuild_plugins_devices_MEAZOR$__f_characteristics).contains__O__Z($as_T(new $c_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent(ev).typedTarget__O().uuid))) {
        return new $c_s_Some($n(these).head__O())
      };
      these = $as_sci_List($n(these).tail__O())
    };
    return $m_s_None$()
  })), $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance), new $c_sjsr_AnonFunction1(((dev$2) => {
    var dev = $as_Lreactbuild_plugins_devices_BLEDeviceMeasure(dev$2);
    var measure = $n(dev).handleEvent__Lreactbuild_plugins_devices_BluetoothEvent__Lreactbuild_plugins_devices_MeasureDetails(ev);
    return $ct_T2__O__O__(new $c_T2(), dev, measure)
  })), null), new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_T2(x$6$2);
    if ((x$6 !== null)) {
      var dev$1 = $as_Lreactbuild_plugins_devices_BLEDeviceMeasure($n(x$6)._1__O());
      var measure$1 = $as_Lreactbuild_plugins_devices_MeasureDetails($n(x$6)._2__O());
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(dispatch).apply__O__O(new $c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure(new $c_Lreactbuild_plugins_devices_MeasureEvent(dev$1, $uD(ev.timeStamp), measure$1))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
        $as_jl_Void(x$5$2)
      }));
      var this$5 = $n(this$);
      var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$5, f);
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c)
    } else {
      var $$x1;
      throw new $c_s_MatchError(x$6)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($$x1)
  })));
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$8 = $m_s_$less$colon$less$();
  return $n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$8.s_$less$colon$less$__f_singleton)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype.connectDevice__Lreactbuild_plugins_devices_BluetoothDevice__F1__F1 = (function(device, dispatch) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromJsPromise__F0__F1(new $c_sjsr_AnonFunction0((() => device.gatt.connect()))), new $c_sjsr_AnonFunction1(((gatt$2) => {
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
    gatt$2.ongattserverdisconnected = ((arg1$2) => {
      $m_Lreactbuild_plugins_devices_DeviceMeasure$().reactbuild$plugins$devices$DeviceMeasure$$$anonfun$connectDevice$3__Lreactbuild_plugins_devices_BluetoothEvent__Lreactbuild_plugins_devices_BluetoothDevice__F1__V(arg1$2, device, dispatch)
    });
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x1).flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromJsPromise__F0__F1(new $c_sjsr_AnonFunction0((() => gatt$2.getPrimaryServices()))), new $c_sjsr_AnonFunction1(((services$2) => {
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x4 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
      var $$x3 = new $c_sjsr_AnonFunction0((() => {
        var this$4 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), services$2);
        $m_sci_List$();
        return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4)
      }));
      var $$x2 = new $c_sjsr_AnonFunction1(((service$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromJsPromise__F0__F1(new $c_sjsr_AnonFunction0((() => service$2.getCharacteristics()))))));
      var this$6 = $m_sc_BuildFrom$();
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x5).flatMap$extension__F1__F1__F1($n($$x4).traverse__F0__F1__sc_BuildFrom__F1($$x3, $$x2, new $c_sc_BuildFromLowPriority2$$anon$11(this$6)), new $c_sjsr_AnonFunction1(((chars$2) => {
        var chars = $as_sci_List(chars$2);
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).traverse__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
          var this$8 = $n(chars);
          var toIterableOnce = new $c_sjsr_AnonFunction1(((array$2) => $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array$2)));
          return $as_sci_List($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$8, toIterableOnce))
        })), new $c_sjsr_AnonFunction1(((char$2) => {
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f = new $c_sjsr_AnonFunction0((() => {
            char$2.oncharacteristicvaluechanged = ((arg1$2$1) => {
              $m_Lreactbuild_plugins_devices_DeviceMeasure$().reactbuild$plugins$devices$DeviceMeasure$$$anonfun$connectDevice$14__Lreactbuild_plugins_devices_BluetoothEvent__F1__V(arg1$2$1, dispatch)
            });
            char$2.startNotifications()
          }));
          var f$1 = new $c_sjsr_AnonFunction0((() => {
            f.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
        })))), new $c_sjsr_AnonFunction1(((x$8$2) => {
          $as_jl_Void(x$8$2)
        }))))
      }))))
    }))))
  })))
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype.handleAction__Lreactbuild_plugins_devices_DeviceMeasure$State__Lreactbuild_plugins_devices_DeviceAction__Lreactbuild_plugins_devices_DeviceMeasure$State = (function(s, action) {
  if ((action instanceof $c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure)) {
    var x2 = $as_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure(action);
    var measure = $n(x2).Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure__f_measure;
    var this$1 = $n($n(s).Lreactbuild_plugins_devices_DeviceMeasure$State__f_events);
    var x$1 = new $c_sci_$colon$colon(measure, this$1);
    var this$2 = $n(s);
    var x$2 = this$2.Lreactbuild_plugins_devices_DeviceMeasure$State__f_active;
    var this$3 = $n(s);
    var x$3 = this$3.Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices;
    $n(s);
    return new $c_Lreactbuild_plugins_devices_DeviceMeasure$State(x$2, x$3, x$1)
  } else {
    var x = $m_Lreactbuild_plugins_devices_MeasureAction$Toggle$();
    if ((x === action)) {
      $n(s);
      var active = (!$n(s).Lreactbuild_plugins_devices_DeviceMeasure$State__f_active);
      var this$5 = $n(s);
      var bleDevices = this$5.Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices;
      var this$6 = $n(s);
      var events = this$6.Lreactbuild_plugins_devices_DeviceMeasure$State__f_events;
      return new $c_Lreactbuild_plugins_devices_DeviceMeasure$State(active, bleDevices, events)
    } else if ((action instanceof $c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice)) {
      var x4 = $as_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice(action);
      var device = $n(x4).Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice__f_device;
      var this$8 = $n($n(s).Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices);
      var x$4$2 = new $c_sci_$colon$colon(device, this$8);
      var this$9 = $n(s);
      var x$5 = this$9.Lreactbuild_plugins_devices_DeviceMeasure$State__f_active;
      var this$10 = $n(s);
      var x$6 = this$10.Lreactbuild_plugins_devices_DeviceMeasure$State__f_events;
      $n(s);
      return new $c_Lreactbuild_plugins_devices_DeviceMeasure$State(x$5, x$4$2, x$6)
    } else {
      throw new $c_s_MatchError(action)
    }
  }
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype.reactbuild$plugins$devices$DeviceMeasure$$$anonfun$connectDevice$3__Lreactbuild_plugins_devices_BluetoothEvent__Lreactbuild_plugins_devices_BluetoothDevice__F1__V = (function(x$7, device$1, dispatch$2) {
  $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().runNow$extension__F1__V($m_Lreactbuild_plugins_devices_DeviceMeasure$().connectDevice__Lreactbuild_plugins_devices_BluetoothDevice__F1__F1(device$1, dispatch$2))
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype.reactbuild$plugins$devices$DeviceMeasure$$$anonfun$connectDevice$14__Lreactbuild_plugins_devices_BluetoothEvent__F1__V = (function(ev, dispatch$2) {
  var this$ = $m_Lreactbuild_plugins_devices_DeviceMeasure$().handleEvent__Lreactbuild_plugins_devices_BluetoothEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline(ev, dispatch$2);
  var this$2 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)
});
var $d_Lreactbuild_plugins_devices_DeviceMeasure$ = new $TypeData().initClass({
  Lreactbuild_plugins_devices_DeviceMeasure$: 0
}, false, "reactbuild.plugins.devices.DeviceMeasure$", {
  Lreactbuild_plugins_devices_DeviceMeasure$: 1,
  O: 1
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$.prototype.$classData = $d_Lreactbuild_plugins_devices_DeviceMeasure$;
var $n_Lreactbuild_plugins_devices_DeviceMeasure$;
function $m_Lreactbuild_plugins_devices_DeviceMeasure$() {
  if ((!$n_Lreactbuild_plugins_devices_DeviceMeasure$)) {
    $n_Lreactbuild_plugins_devices_DeviceMeasure$ = new $c_Lreactbuild_plugins_devices_DeviceMeasure$()
  };
  return $n_Lreactbuild_plugins_devices_DeviceMeasure$
}
function $is_Lreactbuild_plugins_devices_MeasureDetails(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_plugins_devices_MeasureDetails)))
}
function $as_Lreactbuild_plugins_devices_MeasureDetails(obj) {
  return (($is_Lreactbuild_plugins_devices_MeasureDetails(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.plugins.devices.MeasureDetails"))
}
function $isArrayOf_Lreactbuild_plugins_devices_MeasureDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_plugins_devices_MeasureDetails)))
}
function $asArrayOf_Lreactbuild_plugins_devices_MeasureDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_plugins_devices_MeasureDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.plugins.devices.MeasureDetails;", depth))
}
function $p_Lreactbuild_process_AddProcess$__buildEvent$1__Lreactbuild_model_process_ProcessInstanceEventDetails__Z__Lreactbuild_common_model_RefTo__Lreactbuild_common_model_LoggedUserOrganization__Lreactbuild_process_AddProcess$Creation__Lreactbuild_model_process_ProcessInstanceEvent($thiz, details, master, mainRef$1, org$1, creation$1) {
  var $$x6 = (master ? mainRef$1 : ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())));
  if (master) {
    var $$x5 = $m_s_package$().s_package$__f_Nil
  } else {
    $n($m_s_package$().s_package$__f_List);
    var array = [mainRef$1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var $$x5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  };
  var $$x4 = $n(org$1).Lreactbuild_common_model_LoggedUserOrganization__f_organizationUser;
  var this$6 = $n($n(creation$1).Lreactbuild_process_AddProcess$Creation__f_dateOpt);
  if (this$6.isEmpty__Z()) {
    var this$7 = $m_Ljava_time_LocalDate$();
    var $$x3 = this$7.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
  } else {
    var $$x3 = this$6.get__O()
  };
  var $$x2 = $as_Ljava_time_LocalDate($$x3);
  $m_Lreactbuild_model_process_ProcessInstanceEvent$();
  new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
  var $$x1 = $m_Ljava_time_Instant$();
  var this$14 = $m_RTLong$();
  var value = $uD(new Date().getTime());
  var lo = this$14.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_Lreactbuild_model_process_ProcessInstanceEvent($$x6, $$x5, $$x4, $$x2, details, $n($$x1).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi)))
}
/** @constructor */
function $c_Lreactbuild_process_AddProcess$() {
  $n_Lreactbuild_process_AddProcess$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2()
}
$c_Lreactbuild_process_AddProcess$.prototype = new $h_O();
$c_Lreactbuild_process_AddProcess$.prototype.constructor = $c_Lreactbuild_process_AddProcess$;
/** @constructor */
function $h_Lreactbuild_process_AddProcess$() {
  /*<skip>*/
}
$h_Lreactbuild_process_AddProcess$.prototype = $c_Lreactbuild_process_AddProcess$.prototype;
$c_Lreactbuild_process_AddProcess$.prototype.apply__Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__Lreactbuild_model_process_ProcessLink__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(parentState, defaultLink) {
  var c = this.component__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot();
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType("add-process")));
  var props = new $c_Lreactbuild_process_AddProcess$Props(parentState, defaultLink);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_process_AddProcess$.prototype.component__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function() {
  var this$47 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var this$34 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).usePageProps__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep())));
  var deps = new $c_sjsr_AnonFunction2(((props$2, pageProps$2) => {
    $as_Lreactbuild_process_AddProcess$Props(props$2);
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    return pageProps
  }));
  var callback = new $c_sjsr_AnonFunction2(((props$3$2, pageProps$3$2) => {
    var props$3 = $as_Lreactbuild_process_AddProcess$Props(props$3$2);
    var pageProps$3 = $as_Lreactbuild_package$PageProps(pageProps$3$2);
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      $as_Lreactbuild_package$PageProps(x$1$2);
      return new $c_sjsr_AnonFunction1(((creation$2) => {
        var creation = $as_Lreactbuild_process_AddProcess$Creation(creation$2);
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
        var this$5 = $n($n(pageProps$3).Lreactbuild_package$PageProps__f_proxy);
        var this$6 = $n(this$5.Ldiode_react_ModelProxy__f_modelReader);
        var x = $n($as_Lreactbuild_analyze_cost_services_Model(this$6.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged;
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x1).flatMap$extension__F1__F1__F1(new $c_Lreactbuild_hooks_EnhancedOption(x).toAsyncCallback__F0__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_process_ProcessNotConnectedException$()))), new $c_sjsr_AnonFunction1(((logged$2) => {
          var logged = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(logged$2);
          var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
          var x$2 = $n(creation).Lreactbuild_process_AddProcess$Creation__f_orgOpt;
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x2).flatMap$extension__F1__F1__F1(new $c_Lreactbuild_hooks_EnhancedOption(x$2).toAsyncCallback__F0__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_process_ProcessOrganizationNotSelectedException$()))), new $c_sjsr_AnonFunction1(((selectedOrg$2) => {
            var selectedOrg = $as_Lreactbuild_common_model_RefTo(selectedOrg$2);
            var $$x4 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
            var $$x3 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
            var x$4 = $n($n(logged).Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$2$2) => {
              var x$2$1 = $as_Lreactbuild_common_model_LoggedUserOrganization(x$2$2);
              var x$3 = $n(x$2$1).Lreactbuild_common_model_LoggedUserOrganization__f__id;
              return ((x$3 === null) ? (selectedOrg === null) : $n(x$3).equals__O__Z(selectedOrg))
            })));
            return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x4).flatMap$extension__F1__F1__F1($n($$x3).map$extension__F1__F1__F1(new $c_Lreactbuild_hooks_EnhancedOption(x$4).toAsyncCallback__F0__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_process_ProcessOrganizationNotFoundException$()))), new $c_sjsr_AnonFunction1(((org$2) => {
              var org = $as_Lreactbuild_common_model_LoggedUserOrganization(org$2);
              $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
              var mainRef = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
              var rassoc$1 = $p_Lreactbuild_process_AddProcess$__buildEvent$1__Lreactbuild_model_process_ProcessInstanceEventDetails__Z__Lreactbuild_common_model_RefTo__Lreactbuild_common_model_LoggedUserOrganization__Lreactbuild_process_AddProcess$Creation__Lreactbuild_model_process_ProcessInstanceEvent(this, new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate($n(creation).Lreactbuild_process_AddProcess$Creation__f_processRef, $m_s_None$()), true, mainRef, org, creation);
              var this$12 = $n($n(creation).Lreactbuild_process_AddProcess$Creation__f_links);
              $m_sci_List$();
              var this$14 = $n($n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$12)).map__F1__sci_List(new $c_sjsr_AnonFunction1(((link$2) => {
                var link = $as_Lreactbuild_model_process_ProcessLink(link$2);
                return $p_Lreactbuild_process_AddProcess$__buildEvent$1__Lreactbuild_model_process_ProcessInstanceEventDetails__Z__Lreactbuild_common_model_RefTo__Lreactbuild_common_model_LoggedUserOrganization__Lreactbuild_process_AddProcess$Creation__Lreactbuild_model_process_ProcessInstanceEvent(this, new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(link), false, mainRef, org, creation)
              }))));
              var events = new $c_sci_$colon$colon(rassoc$1, this$14);
              return $ct_T2__O__O__(new $c_T2(), org, events)
            }))), new $c_sjsr_AnonFunction1(((x$5$2) => {
              var x$5 = $as_T2(x$5$2);
              if ((x$5 !== null)) {
                var events$1 = $as_sci_List($n(x$5)._2__O());
                var $$x5 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
                  var this$15 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                  var $$x8 = new $c_Lautowire_ClientProxy(this$15).Lautowire_ClientProxy__f_self;
                  var $$x7 = $m_s_package$().s_package$__f_Seq;
                  var array = ["reactbuild", "process", "ProcessApi", "persistEvents"];
                  var $$x6 = $as_sci_Seq($n($$x7).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
                  var this$27 = $n($m_s_Predef$().s_Predef$__f_Map);
                  var this$20 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                  var this$22 = $n(new $c_Lautowire_ClientProxy(this$20).Lautowire_ClientProxy__f_self);
                  $m_Lio_circe_Encoder$();
                  var encodeA = $m_Lreactbuild_model_process_ProcessInstanceEvent$().Lreactbuild_model_process_ProcessInstanceEvent$__f_codecForProcessInstanceEvent;
                  var evidence$2 = new $c_Lio_circe_Encoder$$anon$25(encodeA);
                  var y = this$22.write__O__Lio_circe_Encoder__Lio_circe_Json(events$1, evidence$2);
                  var array$1 = [$ct_T2__O__O__(new $c_T2(), "events", y)];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
                  return $n($n($$x8).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x6, this$27.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2$1) => {
                    var x$1$1 = $as_Lio_circe_Json(x$1$2$1);
                    var this$28 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                    var this$29 = $n(new $c_Lautowire_ClientProxy(this$28).Lautowire_ClientProxy__f_self);
                    var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
                    this$29.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1$1, evidence$1)
                  })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
                })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue), new $c_sjsr_AnonFunction1(((x$4$2) => {
                  $as_jl_Void(x$4$2);
                  var $$x10 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
                  var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
                  $m_Ljapgolly_scalajs_react_Reusable$();
                  var r = $n($n(props$3).Lreactbuild_process_AddProcess$Props__f_parentState).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_process_Processes$EventInsert(events$1));
                  return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x10).map$extension__F1__F1__F1($n($$x9).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$3$2) => {
                    $as_jl_Void(x$3$2)
                  }))))
                })))
              } else {
                var $$x5;
                throw new $c_s_MatchError(x$5)
              };
              return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($$x5)
            }))))
          }))))
        }))))
      }))
    }))
  }));
  var this$32 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z = $m_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$();
  var a = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$32, Z);
  var r$1 = $m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_reusePageProps;
  var this$33 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$33);
  var this$46 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackWithDepsBy__O__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$34, deps, callback, a, r$1, step)));
  var f = new $c_sjsr_AnonFunction3(((props$4$2, pageProps$4$2, creator$2) => {
    var props$4 = $as_Lreactbuild_process_AddProcess$Props(props$4$2);
    $as_Lreactbuild_package$PageProps(pageProps$4$2);
    var creator = $as_Ljapgolly_scalajs_react_Reusable(creator$2);
    var $$x11 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var u = $m_Lreactbuild_process_NewProcessInstanceEvent$().apply__Lreactbuild_model_process_ProcessLink__Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(props$4).Lreactbuild_process_AddProcess$Props__f_defaultLink, $n(props$4).Lreactbuild_process_AddProcess$Props__f_parentState, $as_F1(($m_Ljapgolly_scalajs_react_Reusable$(), $n(creator).value__O())));
    var this$40 = $n(u);
    var n = this$40.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    return $n($$x11).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("instantiate-procedure", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  }));
  var this$45 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$45);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$2 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$46, f, step$1, s);
  return new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$47, ev$2).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.process.AddProcess.component"))
});
var $d_Lreactbuild_process_AddProcess$ = new $TypeData().initClass({
  Lreactbuild_process_AddProcess$: 0
}, false, "reactbuild.process.AddProcess$", {
  Lreactbuild_process_AddProcess$: 1,
  O: 1
});
$c_Lreactbuild_process_AddProcess$.prototype.$classData = $d_Lreactbuild_process_AddProcess$;
var $n_Lreactbuild_process_AddProcess$;
function $m_Lreactbuild_process_AddProcess$() {
  if ((!$n_Lreactbuild_process_AddProcess$)) {
    $n_Lreactbuild_process_AddProcess$ = new $c_Lreactbuild_process_AddProcess$()
  };
  return $n_Lreactbuild_process_AddProcess$
}
/** @constructor */
function $c_Lreactbuild_process_ListProcessInstance$() {
  this.Lreactbuild_process_ListProcessInstance$__f_component = null;
  $n_Lreactbuild_process_ListProcessInstance$ = this;
  var this$27 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).useDerivedRefBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_process_ListProcessInstance$Props(props$2);
    return $n(props).Lreactbuild_process_ListProcessInstance$Props__f_process
  })), new $c_sjsr_AnonFunction1(((props$3$2) => {
    var props$3 = $as_Lreactbuild_process_ListProcessInstance$Props(props$3$2);
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      $as_sci_List(x$1$2);
      var this$7 = $n($n($n(props$3).Lreactbuild_process_ListProcessInstance$Props__f_process).map__F1__sci_List(new $c_sjsr_AnonFunction1(((p$2) => {
        var p = $as_Lreactbuild_model_process_Process(p$2);
        var self = $n(p).Lreactbuild_model_process_Process__f__id;
        return $ct_T2__O__O__(new $c_T2(), self, p)
      }))));
      var this$6 = $m_s_$less$colon$less$();
      return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$7)
    }))
  })), $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_process_ProcessImplicits$().Lreactbuild_process_ProcessImplicits$__f_reuseProcess), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x4 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var $$x3 = new $c_sjsr_AnonFunction2(((props$4$2, x$2$2) => {
    var props$4 = $as_Lreactbuild_process_ListProcessInstance$Props(props$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$2$2);
    return $n(props$4).Lreactbuild_process_ListProcessInstance$Props__f_events
  }));
  var $$x2 = new $c_sjsr_AnonFunction2(((props$5$2, processMap$2) => {
    $as_Lreactbuild_process_ListProcessInstance$Props(props$5$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(processMap$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      $as_sci_List(x$3$2);
      $n($m_s_package$().s_package$__f_List);
      return $m_sci_Nil$()
    }))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_process_ProcessImplicits$().Lreactbuild_process_ProcessImplicits$__f_reuseProcessInstanceEvent));
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$26 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($$x4.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$11))));
  var f$1 = new $c_sjsr_AnonFunction3(((props$6$2, procMap$2, sortedInstances$2) => {
    $as_Lreactbuild_process_ListProcessInstance$Props(props$6$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(procMap$2);
    var sortedInstances = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(sortedInstances$2);
    var this$24 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$12 = $n(sortedInstances);
    var ns = $n($as_sci_List(this$12.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).map__F1__sci_List(new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var process = $as_s_Option($n(x0$1)._2__O());
        var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ligne : ");
        var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var this$17 = $n(process);
        var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
          var x$4 = $as_Lreactbuild_model_process_Process(x$4$2);
          return $n(x$4).Lreactbuild_model_process_Process__f_name
        }));
        var as = (this$17.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$17.get__O())));
        var array = [$$x6, $n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((v$2) => {
          var v = $as_T(v$2);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
        })))];
        return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })));
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$24, null, ns)
  }));
  var this$25 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$25);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$26, f$1, step, s);
  this.Lreactbuild_process_ListProcessInstance$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$27, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.process.ListProcessInstance.component"))
}
$c_Lreactbuild_process_ListProcessInstance$.prototype = new $h_O();
$c_Lreactbuild_process_ListProcessInstance$.prototype.constructor = $c_Lreactbuild_process_ListProcessInstance$;
/** @constructor */
function $h_Lreactbuild_process_ListProcessInstance$() {
  /*<skip>*/
}
$h_Lreactbuild_process_ListProcessInstance$.prototype = $c_Lreactbuild_process_ListProcessInstance$.prototype;
$c_Lreactbuild_process_ListProcessInstance$.prototype.apply__sci_List__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(events, process) {
  var c = this.Lreactbuild_process_ListProcessInstance$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType("ListProcessInstance")));
  var props = new $c_Lreactbuild_process_ListProcessInstance$Props(events, process);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_process_ListProcessInstance$ = new $TypeData().initClass({
  Lreactbuild_process_ListProcessInstance$: 0
}, false, "reactbuild.process.ListProcessInstance$", {
  Lreactbuild_process_ListProcessInstance$: 1,
  O: 1
});
$c_Lreactbuild_process_ListProcessInstance$.prototype.$classData = $d_Lreactbuild_process_ListProcessInstance$;
var $n_Lreactbuild_process_ListProcessInstance$;
function $m_Lreactbuild_process_ListProcessInstance$() {
  if ((!$n_Lreactbuild_process_ListProcessInstance$)) {
    $n_Lreactbuild_process_ListProcessInstance$ = new $c_Lreactbuild_process_ListProcessInstance$()
  };
  return $n_Lreactbuild_process_ListProcessInstance$
}
/** @constructor */
function $c_Lreactbuild_process_NewProcessInstanceEvent$() {
  /*<skip>*/
}
$c_Lreactbuild_process_NewProcessInstanceEvent$.prototype = new $h_O();
$c_Lreactbuild_process_NewProcessInstanceEvent$.prototype.constructor = $c_Lreactbuild_process_NewProcessInstanceEvent$;
/** @constructor */
function $h_Lreactbuild_process_NewProcessInstanceEvent$() {
  /*<skip>*/
}
$h_Lreactbuild_process_NewProcessInstanceEvent$.prototype = $c_Lreactbuild_process_NewProcessInstanceEvent$.prototype;
$c_Lreactbuild_process_NewProcessInstanceEvent$.prototype.apply__Lreactbuild_model_process_ProcessLink__Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(defaultLink, parentState, f) {
  var c = this.component__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot();
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_process_NewProcessInstanceEvent$Props(defaultLink, parentState, f);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_process_NewProcessInstanceEvent$.prototype.component__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function() {
  var this$82 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction0((() => $m_s_None$())), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x10 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x9 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$2 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x10.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x9, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$8)));
  var $$x11 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$2);
  var $$x8 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$3 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x11.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x8, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$11)));
  var $$x12 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$3);
  var $$x7 = new $c_sjsr_AnonFunction4(((p$2, x$6$2, x$7$2, x$8$2) => {
    var p = $as_Lreactbuild_process_NewProcessInstanceEvent$Props(p$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$6$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$7$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$8$2);
    var this$16 = $n($m_s_Predef$().s_Predef$__f_Set);
    var array = [$n(p).Lreactbuild_process_NewProcessInstanceEvent$Props__f_defaultLink];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return this$16.from__sc_IterableOnce__sci_Set(elems)
  }));
  var this$17 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$4 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x12.useStateSnapshotBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x7, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$17)));
  var $$x13 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$4);
  var $$x6 = new $c_sjsr_AnonFunction5(((x$9$2, orgOpt$2, x$10$2, x$11$2, x$12$2) => {
    $as_Lreactbuild_process_NewProcessInstanceEvent$Props(x$9$2);
    var orgOpt = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(orgOpt$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$10$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$11$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$12$2);
    return orgOpt
  }));
  var $$x5 = new $c_sjsr_AnonFunction5(((x$13$2, orgOpt$3$2, x$14$2, x$15$2, x$16$2) => {
    $as_Lreactbuild_process_NewProcessInstanceEvent$Props(x$13$2);
    var orgOpt$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(orgOpt$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$14$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$15$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$16$2);
    return new $c_sjsr_AnonFunction1(((x$17$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$17$2);
      return $as_s_Option($n(orgOpt$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
    }))
  }));
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$19 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$5 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x13.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x6, $$x5, $$x4, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$19)));
  var $$x14 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$5);
  var $$x3 = new $c_sjsr_AnonFunction6(((props$2, x$18$2, x$19$2, x$20$2, x$21$2, x$22$2) => {
    var props = $as_Lreactbuild_process_NewProcessInstanceEvent$Props(props$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$18$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$19$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$20$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$21$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$22$2);
    return props
  }));
  var $$x2 = new $c_sjsr_AnonFunction6(((props$3$2, x$23$2, x$24$2, x$25$2, x$26$2, x$27$2) => {
    var props$3 = $as_Lreactbuild_process_NewProcessInstanceEvent$Props(props$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$23$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$24$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$25$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$26$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$27$2);
    return new $c_sjsr_AnonFunction1(((x$28$2) => {
      $as_Lreactbuild_process_NewProcessInstanceEvent$Props(x$28$2);
      return props$3
    }))
  }));
  var $$x1 = $m_Lreactbuild_process_NewProcessInstanceEvent$Props$().Lreactbuild_process_NewProcessInstanceEvent$Props$__f_reuseProps;
  var this$21 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$6 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x14.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(this$21)));
  var $$x15 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$6);
  var this$23 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$81 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($$x15.usePageProps__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6(this$23))));
  var f$1 = new $c_sjsr_AnonFunction8(((props$4$2, orgOpt$4$2, processOpt$2, dateOpt$2, links$2, orgOptRef$2, propsRef$2, pageProps$2) => {
    var props$4 = $as_Lreactbuild_process_NewProcessInstanceEvent$Props(props$4$2);
    var orgOpt$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(orgOpt$4$2);
    var processOpt = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(processOpt$2);
    var dateOpt = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(dateOpt$2);
    var links = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(links$2);
    var orgOptRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(orgOptRef$2);
    var propsRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(propsRef$2);
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var $$x16 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
    var x = $as_s_Option($n(processOpt).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var submit = $n($$x16).flatMap$extension__F1__F1__F1(new $c_Lreactbuild_hooks_EnhancedOption(x).toAsyncCallback__F0__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_process_ProcessNotSelectedException$()))), new $c_sjsr_AnonFunction1(((processRef$2) => {
      var processRef = $as_Lreactbuild_common_model_RefTo(processRef$2);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n($n(props$4).Lreactbuild_process_NewProcessInstanceEvent$Props__f_f).apply__O__O(new $c_Lreactbuild_process_AddProcess$Creation($as_s_Option($n(orgOpt$4).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $as_s_Option($n(dateOpt).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), processRef, $as_sci_Set($n(links).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, new $c_sjsr_AnonFunction1(((x$29$2) => {
        $as_jl_Void(x$29$2)
      }))))
    })));
    var f = new $c_sjsr_AnonFunction0((() => {
      var this$25 = $m_Ljava_time_LocalDate$();
      return this$25.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
    }));
    var dateReference = new $c_Lcom_iz2use_common_ParsingReference$Simple(f);
    var $$x26 = $m_Lreactbuild_components_Form$();
    var $$x25 = new $c_Ljapgolly_scalajs_react_callback_AsyncCallback(submit);
    var $$x24 = $n($m_Lreactbuild_components_Form$().Lreactbuild_components_Form$__f_title);
    var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9marrer une proc\u00e9dure"))];
    var $$x23 = $n($$x24).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x22 = $n($m_Lreactbuild_components_Form$().Lreactbuild_components_Form$__f_landscapeRow);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Organisation");
    var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var this$37 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$37, proxy);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$39 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$39, proxy$1);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$44 = $m_Lreactbuild_model_Implicits$();
    var this$43 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$43, proxy$2);
    var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$44, ev);
    var $$x21 = editorComponent.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement("org", label, orgOpt$4, optioner, ev$1, explainError, equiv);
    var key = ("" + $n(orgOpt$4).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Proc\u00e9dure");
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var ev$2 = new $c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1(orgOptRef, props$4, propsRef);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var helper$1 = new $c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1(orgOptRef, props$4, propsRef);
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$51 = $m_s_math_Equiv$();
    var equiv$1 = this$51.universal__s_math_Equiv();
    var $$x20 = editorComponent$1.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(key, label$1, processOpt, optioner$1, ev$2, explainError$1, equiv$1);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date de prise en compte");
    var optioner$2 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    $m_Lcom_iz2use_common_Parsable$();
    var parser = new $c_Lcom_iz2use_common_Parsable$$anon$4(dateReference);
    var ev$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$58 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$58);
    var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
    var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
    var $$x19 = editorComponent$2.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement("date", label$2, dateOpt, optioner$2, ev$3, explainError$2, equiv$2);
    var $$x18 = $m_Lcom_iz2use_react_components_Button$().submit__Ljapgolly_scalajs_react_vdom_TagOf();
    var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ajouter"))];
    var array$3 = [$$x21, $$x20, $$x19, $n($$x18).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
    var $$x17 = $n($$x22).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var u = $m_Lreactbuild_process_ProcessLinkList$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(links);
    var this$71 = $n(u);
    var n = this$71.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$4 = [$$x23, $$x17, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    var u$1 = $n($$x26).apply__O__sci_Seq__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x25, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), $m_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$());
    var this$78 = $n(u$1);
    var n$1 = this$78.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  }));
  var this$80 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7(this$80);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$4 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$81, f$1, step, s);
  return new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$82, ev$4).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.process.NewProcessInstanceEvent.component"))
});
var $d_Lreactbuild_process_NewProcessInstanceEvent$ = new $TypeData().initClass({
  Lreactbuild_process_NewProcessInstanceEvent$: 0
}, false, "reactbuild.process.NewProcessInstanceEvent$", {
  Lreactbuild_process_NewProcessInstanceEvent$: 1,
  O: 1
});
$c_Lreactbuild_process_NewProcessInstanceEvent$.prototype.$classData = $d_Lreactbuild_process_NewProcessInstanceEvent$;
var $n_Lreactbuild_process_NewProcessInstanceEvent$;
function $m_Lreactbuild_process_NewProcessInstanceEvent$() {
  if ((!$n_Lreactbuild_process_NewProcessInstanceEvent$)) {
    $n_Lreactbuild_process_NewProcessInstanceEvent$ = new $c_Lreactbuild_process_NewProcessInstanceEvent$()
  };
  return $n_Lreactbuild_process_NewProcessInstanceEvent$
}
/** @constructor */
function $c_Lreactbuild_process_ProcessImplicits$() {
  this.Lreactbuild_process_ProcessImplicits$__f_reuseProcess = null;
  this.Lreactbuild_process_ProcessImplicits$__f_reuseProcessInstanceEvent = null;
  $n_Lreactbuild_process_ProcessImplicits$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_model_process_Process(x$1$2);
    return $n(x$1).Lreactbuild_model_process_Process__f__id
  }));
  var r = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  this.Lreactbuild_process_ProcessImplicits$__f_reuseProcess = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_model_process_ProcessInstanceEvent(x$2$2);
    return $n(x$2).Lreactbuild_model_process_ProcessInstanceEvent__f__id
  }));
  var r$1 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  this.Lreactbuild_process_ProcessImplicits$__f_reuseProcessInstanceEvent = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r$1, f$1)
}
$c_Lreactbuild_process_ProcessImplicits$.prototype = new $h_O();
$c_Lreactbuild_process_ProcessImplicits$.prototype.constructor = $c_Lreactbuild_process_ProcessImplicits$;
/** @constructor */
function $h_Lreactbuild_process_ProcessImplicits$() {
  /*<skip>*/
}
$h_Lreactbuild_process_ProcessImplicits$.prototype = $c_Lreactbuild_process_ProcessImplicits$.prototype;
var $d_Lreactbuild_process_ProcessImplicits$ = new $TypeData().initClass({
  Lreactbuild_process_ProcessImplicits$: 0
}, false, "reactbuild.process.ProcessImplicits$", {
  Lreactbuild_process_ProcessImplicits$: 1,
  O: 1
});
$c_Lreactbuild_process_ProcessImplicits$.prototype.$classData = $d_Lreactbuild_process_ProcessImplicits$;
var $n_Lreactbuild_process_ProcessImplicits$;
function $m_Lreactbuild_process_ProcessImplicits$() {
  if ((!$n_Lreactbuild_process_ProcessImplicits$)) {
    $n_Lreactbuild_process_ProcessImplicits$ = new $c_Lreactbuild_process_ProcessImplicits$()
  };
  return $n_Lreactbuild_process_ProcessImplicits$
}
/** @constructor */
function $c_Lreactbuild_process_ProcessLinkList$() {
  this.Lreactbuild_process_ProcessLinkList$__f_component = null;
  $n_Lreactbuild_process_ProcessLinkList$ = this;
  var this$109 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).usePageProps__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x3 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x2 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$7 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$2 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x3.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x2, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$7)));
  var $$x4 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$2);
  var $$x1 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$10 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$20 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x4.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$10))));
  var deps = new $c_sjsr_AnonFunction4(((x$1$2, x$2$2, personRefOpt$2, x$3$2) => {
    $as_Lreactbuild_process_ProcessLinkList$Props(x$1$2);
    $as_Lreactbuild_package$PageProps(x$2$2);
    var personRefOpt = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(personRefOpt$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$3$2);
    return personRefOpt
  }));
  var effect = new $c_sjsr_AnonFunction4(((p$2, x$4$2, personRefOpt$3$2, x$5$2) => {
    var p = $as_Lreactbuild_process_ProcessLinkList$Props(p$2);
    $as_Lreactbuild_package$PageProps(x$4$2);
    var personRefOpt$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(personRefOpt$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$5$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$6$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => $as_s_Option($n(personRefOpt$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)))), new $c_sjsr_AnonFunction1(((personRef$2) => {
        var personRef = $as_Lreactbuild_common_model_RefTo(personRef$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$14 = $n($n(p).Lreactbuild_process_ProcessLinkList$Props__f_items);
        var mod = new $c_sjsr_AnonFunction1(((x$7$2) => {
          var x$7 = $as_sci_Set(x$7$2);
          var this$13 = $n(x$7);
          $m_Lreactbuild_model_process_ProcessLink$();
          var this$12 = $n(personRef);
          var elem = new $c_Lreactbuild_model_process_ProcessLink(new $c_Lreactbuild_common_model_RefTo(this$12.Lreactbuild_common_model_RefTo__f_id), $m_Lreactbuild_model_process_ProcessLinkClass$Person$());
          return $as_sci_Set(this$13.incl__O__sci_SetOps(elem))
        }));
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$14, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
          $as_jl_Void(x$8$2)
        }));
        var this$16 = $n(this$);
        var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$16, f);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
      }))))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$());
  var r = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$19 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$19);
  var this$30 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$20, deps, effect, a, r, step)));
  var deps$1 = new $c_sjsr_AnonFunction4(((x$9$2, x$10$2, x$11$2, projectRefOpt$2) => {
    $as_Lreactbuild_process_ProcessLinkList$Props(x$9$2);
    $as_Lreactbuild_package$PageProps(x$10$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$11$2);
    var projectRefOpt = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(projectRefOpt$2);
    return projectRefOpt
  }));
  var effect$1 = new $c_sjsr_AnonFunction4(((p$3$2, x$12$2, x$13$2, projectRefOpt$3$2) => {
    var p$3 = $as_Lreactbuild_process_ProcessLinkList$Props(p$3$2);
    $as_Lreactbuild_package$PageProps(x$12$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$13$2);
    var projectRefOpt$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(projectRefOpt$3$2);
    return new $c_sjsr_AnonFunction1(((x$14$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$14$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => $as_s_Option($n(projectRefOpt$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)))), new $c_sjsr_AnonFunction1(((projectRef$2) => {
        var projectRef = $as_Lreactbuild_common_model_RefTo(projectRef$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$24 = $n($n(p$3).Lreactbuild_process_ProcessLinkList$Props__f_items);
        var mod$1 = new $c_sjsr_AnonFunction1(((x$15$2) => {
          var x$15 = $as_sci_Set(x$15$2);
          var this$23 = $n(x$15);
          $m_Lreactbuild_model_process_ProcessLink$();
          var this$22 = $n(projectRef);
          var elem$1 = new $c_Lreactbuild_model_process_ProcessLink(new $c_Lreactbuild_common_model_RefTo(this$22.Lreactbuild_common_model_RefTo__f_id), $m_Lreactbuild_model_process_ProcessLinkClass$Project$());
          return $as_sci_Set(this$23.incl__O__sci_SetOps(elem$1))
        }));
        var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$24, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f$1 = new $c_sjsr_AnonFunction1(((x$16$2) => {
          $as_jl_Void(x$16$2)
        }));
        var this$26 = $n(this$$1);
        var c$1 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$26, f$1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1))
      }))))
    }))
  }));
  var a$1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$());
  var r$1 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$29 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$29);
  var this$108 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$30, deps$1, effect$1, a$1, r$1, step$1)));
  var f$2 = new $c_sjsr_AnonFunction4(((props$2, pageProps$2, personRefOpt$4$2, projectRefOpt$4$2) => {
    var props = $as_Lreactbuild_process_ProcessLinkList$Props(props$2);
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var personRefOpt$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(personRefOpt$4$2);
    var projectRefOpt$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(projectRefOpt$4$2);
    var selected = $as_sci_Set($n($n(props).Lreactbuild_process_ProcessLinkList$Props__f_items).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var projects = $as_sci_List($m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O($n(pageProps).Lreactbuild_package$PageProps__f_proxy, new $c_sjsr_AnonFunction1(((x$17$2) => {
      var x$17 = $as_Lreactbuild_model_CommonData(x$17$2);
      return $n(x$17).Lreactbuild_model_CommonData__f_buildingSites
    })), new $c_Lreactbuild_package$DefaultCommonData$$anon$1()));
    var persons = $as_sci_List($m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O($n(pageProps).Lreactbuild_package$PageProps__f_proxy, new $c_sjsr_AnonFunction1(((x$18$2) => {
      var x$18 = $as_Lreactbuild_model_CommonData(x$18$2);
      return $n(x$18).Lreactbuild_model_CommonData__f_persons
    })), new $c_Lreactbuild_package$DefaultCommonData$$anon$1()));
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x16 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("columnCount")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x14 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Projets li\u00e9s");
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $as_sc_IterableOnce($n($as_sc_IterableOps($n(selected).filter__F1__O(new $c_sjsr_AnonFunction1(((x$19$2) => {
      var x$19 = $as_Lreactbuild_model_process_ProcessLink(x$19$2);
      var x = $n(x$19).Lreactbuild_model_process_ProcessLink__f_cls;
      var x$2$1 = $m_Lreactbuild_model_process_ProcessLinkClass$Person$();
      if ((x !== null)) {
        var this$40 = $n(x);
        return (this$40 === x$2$1)
      } else {
        return false
      }
    }))))).flatMap__F1__O(new $c_sjsr_AnonFunction1(((e$2) => {
      var e = $as_Lreactbuild_model_process_ProcessLink(e$2);
      return $n(projects).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$20$2) => {
        var x$20 = $as_Lreactbuild_common_model_Project(x$20$2);
        var this$41 = $n($n(x$20).Lreactbuild_common_model_Project__f__id);
        var x$21 = new $c_Lreactbuild_common_model_RefTo(this$41.Lreactbuild_common_model_RefTo__f_id);
        var x$2$3 = $n(e).Lreactbuild_model_process_ProcessLink__f_ref;
        return x$21.equals__O__Z(x$2$3)
      })))
    }))));
    var $$x11 = $n($$x12).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((e$3$2) => {
      var e$3 = $as_Lreactbuild_common_model_Project(e$3$2);
      var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v = $n(e$3).Lreactbuild_common_model_Project__f__id;
      var this$46 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$46, proxy);
      var v$1 = $n(ev).stringify__O__T(v);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    })));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Rattacher un projet");
    var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var this$57 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$2 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$57, proxy$1);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$59 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$59, proxy$2);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$64 = $m_Lreactbuild_model_Implicits$();
    var this$63 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$3 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$1 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$63, proxy$3);
    var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$64, ev$1);
    var array$1 = [$$x14, $$x11, editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, projectRefOpt$4, optioner, ev$2, explainError, equiv)];
    var $$x10 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Personnes li\u00e9es");
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as$1 = $as_sc_IterableOnce($n($as_sc_IterableOps($n(selected).filter__F1__O(new $c_sjsr_AnonFunction1(((x$21$2) => {
      var x$21$1 = $as_Lreactbuild_model_process_ProcessLink(x$21$2);
      var x$22 = $n(x$21$1).Lreactbuild_model_process_ProcessLink__f_cls;
      var x$2$4 = $m_Lreactbuild_model_process_ProcessLinkClass$Person$();
      if ((x$22 !== null)) {
        var this$73 = $n(x$22);
        return (this$73 === x$2$4)
      } else {
        return false
      }
    }))))).flatMap__F1__O(new $c_sjsr_AnonFunction1(((e$4$2) => {
      var e$4 = $as_Lreactbuild_model_process_ProcessLink(e$4$2);
      return $n(persons).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$22$2) => {
        var x$22$1 = $as_Lreactbuild_person_Person(x$22$2);
        var this$74 = $n($n(x$22$1).Lreactbuild_person_Person__f__id);
        var x$23 = new $c_Lreactbuild_common_model_RefTo(this$74.Lreactbuild_common_model_RefTo__f_id);
        var x$2$5 = $n(e$4).Lreactbuild_model_process_ProcessLink__f_ref;
        return x$23.equals__O__Z(x$2$5)
      })))
    }))));
    var $$x5 = $n($$x6).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((e$5$2) => {
      var e$5 = $as_Lreactbuild_person_Person(e$5$2);
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$2 = $n(e$5).Lreactbuild_person_Person__f__id;
      var this$79 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$4 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$3 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$79, proxy$4);
      var v$3 = $n(ev$3).stringify__O__T(v$2);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
      return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    })));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Rattacher une personne");
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var this$91 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$5 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    $m_Lreactbuild_model_Implicits$();
    var organization = $m_s_None$();
    var ev$5 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$91, proxy$5, organization);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$94 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$6 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    $m_Lreactbuild_model_Implicits$();
    var organization$1 = $m_s_None$();
    var helper$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$94, proxy$6, organization$1);
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$99 = $m_Lreactbuild_model_Implicits$();
    var this$98 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy$7 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev$4 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$98, proxy$7);
    var equiv$1 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$99, ev$4);
    var array$3 = [$$x8, $$x5, editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, personRefOpt$4, optioner$1, ev$5, explainError$1, equiv$1)];
    var array$4 = [$$x16, $$x10, $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    return $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
  }));
  var this$107 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$107);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$6 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$108, f$2, step$2, s);
  this.Lreactbuild_process_ProcessLinkList$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$109, ev$6).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.process.ProcessLinkList.component"))
}
$c_Lreactbuild_process_ProcessLinkList$.prototype = new $h_O();
$c_Lreactbuild_process_ProcessLinkList$.prototype.constructor = $c_Lreactbuild_process_ProcessLinkList$;
/** @constructor */
function $h_Lreactbuild_process_ProcessLinkList$() {
  /*<skip>*/
}
$h_Lreactbuild_process_ProcessLinkList$.prototype = $c_Lreactbuild_process_ProcessLinkList$.prototype;
$c_Lreactbuild_process_ProcessLinkList$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(items) {
  var c = this.Lreactbuild_process_ProcessLinkList$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_process_ProcessLinkList$Props(items);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_process_ProcessLinkList$ = new $TypeData().initClass({
  Lreactbuild_process_ProcessLinkList$: 0
}, false, "reactbuild.process.ProcessLinkList$", {
  Lreactbuild_process_ProcessLinkList$: 1,
  O: 1
});
$c_Lreactbuild_process_ProcessLinkList$.prototype.$classData = $d_Lreactbuild_process_ProcessLinkList$;
var $n_Lreactbuild_process_ProcessLinkList$;
function $m_Lreactbuild_process_ProcessLinkList$() {
  if ((!$n_Lreactbuild_process_ProcessLinkList$)) {
    $n_Lreactbuild_process_ProcessLinkList$ = new $c_Lreactbuild_process_ProcessLinkList$()
  };
  return $n_Lreactbuild_process_ProcessLinkList$
}
/** @constructor */
function $c_Lreactbuild_process_Processes$() {
  this.Lreactbuild_process_Processes$__f_reducer = null;
  this.Lreactbuild_process_Processes$__f_component = null;
  $n_Lreactbuild_process_Processes$ = this;
  this.Lreactbuild_process_Processes$__f_reducer = new $c_sjsr_AnonFunction2(((s$2, a$2) => {
    var s = $as_Lreactbuild_process_Processes$State(s$2);
    var a = $as_Lreactbuild_process_Processes$Action(a$2);
    if ((a instanceof $c_Lreactbuild_process_Processes$Insert)) {
      var x2 = $as_Lreactbuild_process_Processes$Insert(a);
      var process = $n(x2).Lreactbuild_process_Processes$Insert__f_process;
      var this$2 = $n($n(s).Lreactbuild_process_Processes$State__f_process);
      var p = new $c_sjsr_AnonFunction1(((x$3$2) => {
        var x$3 = $as_Lreactbuild_model_process_Process(x$3$2);
        var x = $n(x$3).Lreactbuild_model_process_Process__f__id;
        var x$2 = $n(process).Lreactbuild_model_process_Process__f__id;
        return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      }));
      var x1$2 = $f_sc_LinearSeqOps__indexWhere__F1__I__I(this$2, p, 0);
      if ((x1$2 === (-1))) {
        var this$3 = $n($n(s).Lreactbuild_process_Processes$State__f_process);
        var updated = new $c_sci_$colon$colon(process, this$3)
      } else {
        var this$5 = $n($n(s).Lreactbuild_process_Processes$State__f_process);
        var this$4 = $n($m_s_package$().s_package$__f_Nil);
        var other = new $c_sci_$colon$colon(process, this$4);
        var updated = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$5, x1$2, other, 1))
      };
      $n(s);
      var this$6 = $n(s);
      var events = this$6.Lreactbuild_process_Processes$State__f_events;
      var this$7 = $n(s);
      var item = this$7.Lreactbuild_process_Processes$State__f_item;
      return new $c_Lreactbuild_process_Processes$State(updated, events, item)
    } else if ((a instanceof $c_Lreactbuild_process_Processes$EventInsert)) {
      var x3 = $as_Lreactbuild_process_Processes$EventInsert(a);
      var events$1 = $n(x3).Lreactbuild_process_Processes$EventInsert__f_events;
      var x$1 = $n($n(s).Lreactbuild_process_Processes$State__f_events).$colon$colon$colon__sci_List__sci_List(events$1);
      var this$9 = $n(s);
      var x$2$1 = this$9.Lreactbuild_process_Processes$State__f_process;
      var this$10 = $n(s);
      var x$3$3 = this$10.Lreactbuild_process_Processes$State__f_item;
      $n(s);
      return new $c_Lreactbuild_process_Processes$State(x$2$1, x$1, x$3$3)
    } else if ((a instanceof $c_Lreactbuild_process_Processes$LoadProcesses)) {
      var x4 = $as_Lreactbuild_process_Processes$LoadProcesses(a);
      var process$2 = $n(x4).Lreactbuild_process_Processes$LoadProcesses__f_processes;
      $n(s);
      var this$12 = $n(s);
      var events$2 = this$12.Lreactbuild_process_Processes$State__f_events;
      var this$13 = $n(s);
      var item$1 = this$13.Lreactbuild_process_Processes$State__f_item;
      return new $c_Lreactbuild_process_Processes$State(process$2, events$2, item$1)
    } else if ((a instanceof $c_Lreactbuild_process_Processes$ItemChanged)) {
      var x5 = $as_Lreactbuild_process_Processes$ItemChanged(a);
      var ref = $n(x5).Lreactbuild_process_Processes$ItemChanged__f_target;
      var this$15 = $n(s);
      var x$5 = this$15.Lreactbuild_process_Processes$State__f_process;
      var this$16 = $n(s);
      var x$6 = this$16.Lreactbuild_process_Processes$State__f_events;
      $n(s);
      return new $c_Lreactbuild_process_Processes$State(x$5, x$6, ref)
    } else {
      throw new $c_s_MatchError(a)
    }
  }));
  var this$123 = $m_Lcom_iz2use_react_hooks_package$();
  var this$20 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var reducer = new $c_sjsr_AnonFunction1(((x$4$2) => {
    $as_Lreactbuild_process_Processes$Props(x$4$2);
    return $m_Lreactbuild_process_Processes$().Lreactbuild_process_Processes$__f_reducer
  }));
  var initialState = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_process_Processes$Props(props$2);
    return new $c_Lreactbuild_process_Processes$State($as_sci_List($n($n(props).Lreactbuild_process_Processes$Props__f_process).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $m_s_package$().s_package$__f_Nil, $n(props).Lreactbuild_process_Processes$Props__f_target)
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$23 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducerBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$20, reducer, initialState, step)));
  var deps = new $c_sjsr_AnonFunction2(((props$3$2, x$5$2) => {
    var props$3 = $as_Lreactbuild_process_Processes$Props(props$3$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$5$2);
    return $as_sci_List($n($n(props$3).Lreactbuild_process_Processes$Props__f_process).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
  }));
  var effect = new $c_sjsr_AnonFunction2(((props$4$2, reducer$2) => {
    var props$4 = $as_Lreactbuild_process_Processes$Props(props$4$2);
    var reducer$1 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      $as_sci_List(x$6$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(reducer$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_process_Processes$LoadProcesses($as_sci_List($n($n(props$4).Lreactbuild_process_Processes$Props__f_process).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)))).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))
  }));
  var a$1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r = $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_process_ProcessImplicits$().Lreactbuild_process_ProcessImplicits$__f_reuseProcess);
  var this$22 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$22);
  var this$26 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$23, deps, effect, a$1, r, step$1)));
  var deps$1 = new $c_sjsr_AnonFunction2(((props$5$2, x$7$2) => {
    var props$5 = $as_Lreactbuild_process_Processes$Props(props$5$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$7$2);
    return $n(props$5).Lreactbuild_process_Processes$Props__f_target
  }));
  var effect$1 = new $c_sjsr_AnonFunction2(((props$6$2, reducer$3$2) => {
    var props$6 = $as_Lreactbuild_process_Processes$Props(props$6$2);
    var reducer$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$3$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      $as_Lreactbuild_common_model_RefTo(x$8$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(reducer$3).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_process_Processes$ItemChanged($n(props$6).Lreactbuild_process_Processes$Props__f_target))).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))
  }));
  var a$3 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r$1 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  var this$25 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$25);
  var this$30 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$26, deps$1, effect$1, a$3, r$1, step$2)));
  var initialState$1 = new $c_sjsr_AnonFunction0((() => {
    var this$27 = $m_Ljava_time_LocalTime$();
    return this$27.now__Ljava_time_Clock__Ljava_time_LocalTime(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
  }));
  var this$29 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$29);
  var this$56 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$30, initialState$1, step$3)));
  var deps$2 = new $c_sjsr_AnonFunction3(((props$7$2, reducer$4$2, time$2) => {
    var props$7 = $as_Lreactbuild_process_Processes$Props(props$7$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(time$2);
    return $n(props$7).Lreactbuild_process_Processes$Props__f_process
  }));
  var create = new $c_sjsr_AnonFunction3(((props$8$2, reducer$5$2, time$3$2) => {
    var props$8 = $as_Lreactbuild_process_Processes$Props(props$8$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$5$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(time$3$2);
    return new $c_sjsr_AnonFunction1(((x$9$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$9$2);
      $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
      var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
        var x0$1 = $as_s_Option(x0$1$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        matchEnd7: {
          var $$x1;
          var p2 = $as_s_Option(x1.T2__f__1);
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x$10 = $m_s_None$();
          if ((x$10 === p2)) {
            var $$x1 = cb;
            break matchEnd7
          };
          var p4 = $as_s_Option(x1.T2__f__1);
          var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          if ((p4 instanceof $c_s_Some)) {
            var x5$1 = $as_s_Some(p4);
            var v = $as_Lreactbuild_model_process_Process($n(x5$1).s_Some__f_value);
            var finalCb = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
              var this$31 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
              var $$x4 = new $c_Lautowire_ClientProxy(this$31).Lautowire_ClientProxy__f_self;
              var $$x3 = $m_s_package$().s_package$__f_Seq;
              var array = ["reactbuild", "process", "ProcessApi", "persistProcess"];
              var $$x2 = $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
              var this$42 = $n($m_s_Predef$().s_Predef$__f_Map);
              var this$36 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
              var this$37 = $n(new $c_Lautowire_ClientProxy(this$36).Lautowire_ClientProxy__f_self);
              var evidence$2 = $m_Lreactbuild_model_process_Process$().Lreactbuild_model_process_Process$__f_codecForProcess;
              var y = this$37.write__O__Lio_circe_Encoder__Lio_circe_Json(v, evidence$2);
              var array$1 = [$ct_T2__O__O__(new $c_T2(), "process", y)];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
              return $n($n($$x4).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x2, this$42.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$7$2$1) => {
                var x$7$1 = $as_Lio_circe_Json(x$7$2$1);
                var this$43 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                var this$44 = $n(new $c_Lautowire_ClientProxy(this$43).Lautowire_ClientProxy__f_self);
                var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
                this$44.read__Lio_circe_Json__Lio_circe_Decoder__O(x$7$1, evidence$1)
              })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
            })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue), new $c_sjsr_AnonFunction1(((x$12$2) => {
              $as_jl_Void(x$12$2);
              var $$x7 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
              var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
              var this$52 = $n($n(props$8).Lreactbuild_process_Processes$Props__f_process);
              var mod = new $c_sjsr_AnonFunction1(((lst$2) => {
                var lst = $as_sci_List(lst$2);
                var this$45 = $n(lst);
                var p$1 = new $c_sjsr_AnonFunction1(((x$10$2) => {
                  var x$10$1 = $as_Lreactbuild_model_process_Process(x$10$2);
                  var x$11 = $n(x$10$1).Lreactbuild_model_process_Process__f__id;
                  var x$2$2 = $n(v).Lreactbuild_model_process_Process__f__id;
                  return ((x$11 === null) ? (x$2$2 === null) : $n(x$11).equals__O__Z(x$2$2))
                }));
                var x1$3 = $f_sc_LinearSeqOps__indexWhere__F1__I__I(this$45, p$1, 0);
                if ((x1$3 === (-1))) {
                  var this$46 = $n(lst);
                  return $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$46, v))
                } else {
                  var this$50 = $n(lst);
                  var $$x5 = $n($m_s_package$().s_package$__f_Seq);
                  var array$2 = [v];
                  var other$1 = $n($$x5).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
                  return $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$50, x1$3, other$1, 1))
                }
              }));
              var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)));
              var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
              return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x7).map$extension__F1__F1__F1($n($$x6).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$52, mod, callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$11$2) => {
                $as_jl_Void(x$11$2)
              }))))
            })));
            var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(finalCb);
            break matchEnd7
          };
          throw new $c_s_MatchError(x1)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
      }));
      return new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn($m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f))
    }))
  }));
  var r$2 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$55 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$55);
  var this$122 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$56, deps$2, create, r$2, step$4)));
  var f$1 = new $c_sjsr_AnonFunction4(((props$9$2, reducer$6$2, time$4$2, reuseProcess$2) => {
    var props$9 = $as_Lreactbuild_process_Processes$Props(props$9$2);
    var reducer$6 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(reducer$6$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(time$4$2);
    $as_Ljapgolly_scalajs_react_Reusable(reuseProcess$2);
    var this$120 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x17 = $m_Lreactbuild_analyze_cost_components_Feature$();
    var u$4 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$().query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(props$9).Lreactbuild_process_Processes$Props__f_target, new $c_sjsr_AnonFunction1(((ref$2) => {
      var ref$1 = $as_Lreactbuild_common_model_RefTo(ref$2);
      var this$57 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x10 = new $c_Lautowire_ClientProxy(this$57).Lautowire_ClientProxy__f_self;
      var $$x9 = $m_s_package$().s_package$__f_Seq;
      var array$3 = ["reactbuild", "process", "ProcessApi", "getEventsLinkedTo"];
      var $$x8 = $as_sci_Seq($n($$x9).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)));
      var this$69 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$62 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$64 = $n(new $c_Lautowire_ClientProxy(this$62).Lautowire_ClientProxy__f_self);
      var this$63 = $n(ref$1);
      var r$3 = new $c_Lreactbuild_common_model_RefTo(this$63.Lreactbuild_common_model_RefTo__f_id);
      var evidence$2$1 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y$1 = this$64.write__O__Lio_circe_Encoder__Lio_circe_Json(r$3, evidence$2$1);
      var array$4 = [$ct_T2__O__O__(new $c_T2(), "item", y$1)];
      var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
      return $n($n($$x10).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x8, this$69.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$8$2$1) => {
        var x$8$1 = $as_Lio_circe_Json(x$8$2$1);
        var this$70 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$73 = $n(new $c_Lautowire_ClientProxy(this$70).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lreactbuild_model_process_ProcessInstanceEvent$().Lreactbuild_model_process_ProcessInstanceEvent$__f_codecForProcessInstanceEvent;
        var decodeA$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
        var evidence$1$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA$1);
        return $as_sci_List(this$73.read__Lio_circe_Json__Lio_circe_Decoder__O(x$8$1, evidence$1$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), new $c_sjsr_AnonFunction1(((instances$2) => {
      var instances = $as_Ldiode_data_Pot(instances$2);
      var this$107 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var $$x15 = $m_Ldiode_react_ReactPot$potWithReact$().renderPending$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(instances, new $c_sjsr_AnonFunction1(((x$13$2) => {
        $uI(x$13$2);
        var $$x16 = $m_Lcom_iz2use_react_components_Skeleton$();
        var u = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(20);
        var this$76 = $n(u);
        var n = this$76.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var array$5 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
        var u$1 = $n($$x16).list__I__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
        var this$82 = $n(u$1);
        var n$1 = this$82.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
      })));
      var $$x14 = $m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment;
      var array$7 = [$m_Ldiode_react_ReactPot$potWithReact$().render$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(instances, new $c_sjsr_AnonFunction1(((v$2) => {
        var v$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(v$2);
        var $$x13 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
        var u$2 = $m_Lreactbuild_process_ListProcessInstance$().apply__sci_List__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($as_sci_List($n(v$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $as_sci_List($n($n(props$9).Lreactbuild_process_Processes$Props__f_process).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
        var this$92 = $n(u$2);
        var n$2 = this$92.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var $$x12 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2);
        var $$x11 = $m_Lreactbuild_process_AddProcess$();
        $n($n(props$9).Lreactbuild_process_Processes$Props__f_useArg);
        var ref$3 = $n(props$9).Lreactbuild_process_Processes$Props__f_target;
        var u$3 = $n($$x11).apply__Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__Lreactbuild_model_process_ProcessLink__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(reducer$6, new $c_Lreactbuild_model_process_ProcessLink(ref$3, $m_Lreactbuild_model_process_ProcessLinkClass$Project$()));
        var this$96 = $n(u$3);
        var n$3 = this$96.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var array$6 = [$$x12, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)];
        return $n($$x13).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("render", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
      })))];
      var array$8 = [$$x15, $n($$x14).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("ready", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
      var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$107, null, ns)
    })), $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2(), $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_process_ProcessImplicits$().Lreactbuild_process_ProcessImplicits$__f_reuseProcessInstanceEvent)), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var this$109 = $n(u$4);
    var n$4 = this$109.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$9 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4)];
    var u$5 = $n($$x17).workInProgress__Z__sci_Seq__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(true, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9), new $c_Lsourcecode_Enclosing("reactbuild.process.Processes.component"));
    var this$115 = $n(u$5);
    var n$5 = this$115.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$10 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$5)];
    var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$120, null, ns$1)
  }));
  var this$121 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$5 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$121);
  var s$1 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$4 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$122, f$1, step$5, s$1);
  this.Lreactbuild_process_Processes$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$123, ev$4).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.process.Processes.component"))
}
$c_Lreactbuild_process_Processes$.prototype = new $h_O();
$c_Lreactbuild_process_Processes$.prototype.constructor = $c_Lreactbuild_process_Processes$;
/** @constructor */
function $h_Lreactbuild_process_Processes$() {
  /*<skip>*/
}
$h_Lreactbuild_process_Processes$.prototype = $c_Lreactbuild_process_Processes$.prototype;
$c_Lreactbuild_process_Processes$.prototype.apply__Ldiode_data_Pot__Lreactbuild_process_Processes$UseProcessArg__Ljapgolly_scalajs_react_vdom_TagOf = (function(target, useArg) {
  var $$x7 = $m_Lreactbuild_analyze_cost_components_ScrollBlockContainer$();
  var u$1 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$().apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x3 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "process", "ProcessApi", "getProcesses"];
    var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$6 = $n($m_s_Predef$().s_Predef$__f_Map);
    var elems = $m_sci_Nil$();
    return $n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$6.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$9 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_model_process_Process$().Lreactbuild_model_process_Process$__f_codecForProcess;
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$9.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), new $c_sjsr_AnonFunction1(((pot$2) => {
    var pot = $as_Ldiode_data_Pot(pot$2);
    var ready = $n(pot).flatMap__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(v$2);
      return $n(target).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((t$2) => {
        var t = $as_Lreactbuild_common_model_RefTo(t$2);
        return $ct_T2__O__O__(new $c_T2(), v, t)
      })))
    })));
    if ($n(ready).isFailed__Z()) {
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(ready).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$1 = [$$x4, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    } else {
      var this$22 = $n(ready);
      if ((!this$22.isEmpty__Z())) {
        var arg1 = $n(ready).get__O();
        var x0$1 = $as_T2(arg1);
        if ((x0$1 === null)) {
          throw new $c_s_MatchError(x0$1)
        };
        var processList = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n(x0$1)._1__O());
        var target$1 = $as_Lreactbuild_common_model_RefTo($n(x0$1)._2__O());
        var c = $m_Lreactbuild_process_Processes$().Lreactbuild_process_Processes$__f_component;
        var this$25 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
        var this$24 = $n(target$1);
        var props = new $c_Lreactbuild_process_Processes$Props(new $c_Lreactbuild_common_model_RefTo(this$24.Lreactbuild_common_model_RefTo__f_id), processList, useArg);
        var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$25.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$25.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
        var this$27 = $n(u);
        var n = this$27.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      } else if ($n(ready).isPending__Z()) {
        return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
      }
    }
  })), $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_process_ProcessImplicits$().Lreactbuild_process_ProcessImplicits$__f_reuseProcess), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
  var this$37 = $n(u$1);
  var n$1 = this$37.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  return $n($$x7).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
var $d_Lreactbuild_process_Processes$ = new $TypeData().initClass({
  Lreactbuild_process_Processes$: 0
}, false, "reactbuild.process.Processes$", {
  Lreactbuild_process_Processes$: 1,
  O: 1
});
$c_Lreactbuild_process_Processes$.prototype.$classData = $d_Lreactbuild_process_Processes$;
var $n_Lreactbuild_process_Processes$;
function $m_Lreactbuild_process_Processes$() {
  if ((!$n_Lreactbuild_process_Processes$)) {
    $n_Lreactbuild_process_Processes$ = new $c_Lreactbuild_process_Processes$()
  };
  return $n_Lreactbuild_process_Processes$
}
function $is_Lreactbuild_process_Processes$Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_process_Processes$Action)))
}
function $as_Lreactbuild_process_Processes$Action(obj) {
  return (($is_Lreactbuild_process_Processes$Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.Processes$Action"))
}
function $isArrayOf_Lreactbuild_process_Processes$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_Processes$Action)))
}
function $asArrayOf_Lreactbuild_process_Processes$Action(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_Processes$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.Processes$Action;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_Areas$() {
  this.Lreactbuild_project_Areas$__f_defaultNames = null;
  this.Lreactbuild_project_Areas$__f_skeleton = null;
  $n_Lreactbuild_project_Areas$ = this;
  var $$x2 = $m_s_package$().s_package$__f_Seq;
  var array = [new $c_Lreactbuild_project_Areas$Area("Land", "Terrain", 900), new $c_Lreactbuild_project_Areas$Area("Patio", "Terrasse", 800), new $c_Lreactbuild_project_Areas$Area("Livable", "Habitable", 300), new $c_Lreactbuild_project_Areas$Area("Liveable", "Habitable", 300), new $c_Lreactbuild_project_Areas$Area("Garage", "Garage", 890), new $c_Lreactbuild_project_Areas$Area("Room.Pantry", "Cellier", 895), new $c_Lreactbuild_project_Areas$Area("Room.Kitchen", "Cuisine", 430), new $c_Lreactbuild_project_Areas$Area("Room.Bed", "Chambre", 450), new $c_Lreactbuild_project_Areas$Area("Room.Shower", "Salle d'eau", 460), new $c_Lreactbuild_project_Areas$Area("Room.Bath", "Salle de bain", 460), new $c_Lreactbuild_project_Areas$Area("Room.Rest", "Toilettes", 490), new $c_Lreactbuild_project_Areas$Area("Room.Living", "S\u00e9jour", 410), new $c_Lreactbuild_project_Areas$Area("Room.Recess", "D\u00e9gagement", 410), new $c_Lreactbuild_project_Areas$Area("Room.Dining", "Salle \u00e0 manger", 420)];
  var $$x1 = $as_sc_IterableOnceOps($n($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))).map__F1__O(new $c_sjsr_AnonFunction1(((a$2) => {
    var a = $as_Lreactbuild_project_Areas$Area(a$2);
    var self = $n(a).Lreactbuild_project_Areas$Area__f_name;
    return $ct_T2__O__O__(new $c_T2(), self, a)
  }))));
  var this$7 = $m_s_$less$colon$less$();
  this.Lreactbuild_project_Areas$__f_defaultNames = $n($$x1).toMap__s_$less$colon$less__sci_Map(this$7.s_$less$colon$less$__f_singleton);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x7 = $m_Lcom_iz2use_react_components_Skeleton$();
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(10);
  var this$15 = $n(u);
  var n = this$15.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x4 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u$1 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(3);
  var this$20 = $n(u$1);
  var n$1 = this$20.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  var array$2 = [$$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var array$3 = [$n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var array$4 = [$n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var u$2 = $n($$x7).list__I__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var this$35 = $n(u$2);
  var n$2 = this$35.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$5 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
  this.Lreactbuild_project_Areas$__f_skeleton = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
}
$c_Lreactbuild_project_Areas$.prototype = new $h_O();
$c_Lreactbuild_project_Areas$.prototype.constructor = $c_Lreactbuild_project_Areas$;
/** @constructor */
function $h_Lreactbuild_project_Areas$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Areas$.prototype = $c_Lreactbuild_project_Areas$.prototype;
$c_Lreactbuild_project_Areas$.prototype.title__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf = (function(name, style) {
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaLabel;
  var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var $$x2 = this.Lreactbuild_project_Areas$__f_defaultNames;
  $m_sc_StringOps$();
  $m_sc_StringOps$();
  $m_sc_StringOps$();
  var from = 0;
  _return: {
    var this$7 = $n(name);
    var len = this$7.length;
    var i = from;
    while ((i < len)) {
      var this$8 = $n(name);
      var index = i;
      var arg1 = $charAt(this$8, index);
      if ((arg1 === 32)) {
        var x1 = i;
        break _return
      };
      i = ((1 + i) | 0)
    };
    var x1 = (-1)
  };
  if ((x1 === (-1))) {
    var $$x1 = name
  } else {
    var this$9 = $n(name);
    if ((x1 > this$9.length)) {
      $charAt(this$9, x1)
    };
    if ((x1 < 0)) {
      $charAt(this$9, (-1))
    };
    var $$x1 = $as_T(this$9.substring(0, x1))
  };
  var this$10 = $n($n($$x2).get__O__s_Option($$x1));
  if (this$10.isEmpty__Z()) {
    var $$x3 = $m_s_None$()
  } else {
    var arg1$1 = this$10.get__O();
    var x$2 = $as_Lreactbuild_project_Areas$Area(arg1$1);
    var $$x5 = $n(x$2).Lreactbuild_project_Areas$Area__f_label;
    $m_sc_StringOps$();
    $m_sc_StringOps$();
    $m_sc_StringOps$();
    var from$1 = 0;
    _return$1: {
      var this$14 = $n(name);
      var len$1 = this$14.length;
      var i$1 = from$1;
      while ((i$1 < len$1)) {
        var this$15 = $n(name);
        var index$1 = i$1;
        var arg1$2 = $charAt(this$15, index$1);
        if ((arg1$2 === 32)) {
          var x1$1 = i$1;
          break _return$1
        };
        i$1 = ((1 + i$1) | 0)
      };
      var x1$1 = (-1)
    };
    if ((x1$1 === (-1))) {
      var $$x4 = ""
    } else {
      var this$16 = $n(name);
      if (((x1$1 < 0) || (x1$1 > this$16.length))) {
        $charAt(this$16, x1$1)
      };
      var $$x4 = $as_T(this$16.substring(x1$1))
    };
    var $$x3 = new $c_s_Some((("" + $$x5) + $$x4))
  };
  var this$17 = $n($$x3);
  var v = $as_T((this$17.isEmpty__Z() ? name : this$17.get__O()));
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [$$x6, style, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_project_Areas$.prototype.value__D__Z__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf = (function(area, smaller, style) {
  var suffix = (smaller ? "" : " m\u00b2");
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaValue;
  var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  if ((area > 0.0)) {
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var $$x2 = $m_sc_StringOps$();
    var array = [area, suffix];
    var v = $n($$x2).format$extension__T__sci_Seq__T("%.2f%s", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
  } else {
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("")
  };
  var array$1 = [$$x3, style, $$x1];
  return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
$c_Lreactbuild_project_Areas$.prototype.apply__Ldiode_data_Pot__Z__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf = (function(areasOpt, smaller, fullWidth) {
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaTable;
  var $$x20 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  if (smaller) {
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Surface"))];
    var $$x11 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("m\u00b2"))];
    var array$2 = [$$x11, $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    var array$3 = [$n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
    var $$x9 = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  } else {
    var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Description"))];
    var $$x16 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Surface"))];
    var array$6 = [$$x16, $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var array$7 = [$n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
    var $$x9 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
  };
  if ($n(areasOpt).isFailed__Z()) {
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(areasOpt).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$8 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x1 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  } else {
    var this$62 = $n(areasOpt);
    if ((!this$62.isEmpty__Z())) {
      var arg1 = $n(areasOpt).get__O();
      var areas = $as_sci_Seq(arg1);
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as = $as_sc_IterableOnce($n(areas).zipWithIndex__O());
      var array$10 = [$n($$x4).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x0$1$2) => {
        var x0$1 = $as_T2(x0$1$2);
        if ((x0$1 !== null)) {
          var area = $as_Lreactbuild_common_model_Area($n(x0$1)._1__O());
          var idx = $n(x0$1)._2$mcI$sp__I();
          var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var $$x5 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key;
          var this$75 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var k = new $c_sjsr_AnonFunction1(((a$2) => {
            var a = $uI(a$2);
            return a
          }));
          var array$9 = [$n($$x5).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(idx, $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1__vdomAttrVtKey__F1__F2(this$75, k)), $m_Lreactbuild_project_Areas$().title__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf($n(area).Lreactbuild_common_model_Area__f_name, ($m_Lreactbuild_project_Areas$(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom)), $m_Lreactbuild_project_Areas$().value__D__Z__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf($n(area).Lreactbuild_common_model_Area__f_area, ($m_Lreactbuild_project_Areas$(), false), ($m_Lreactbuild_project_Areas$(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom))];
          return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
        } else {
          throw new $c_s_MatchError(x0$1)
        }
      })))];
      var $$x1 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))
    } else if ($n(areasOpt).isPending__Z()) {
      var $$x1 = $m_Lreactbuild_project_Areas$().Lreactbuild_project_Areas$__f_skeleton
    } else {
      var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$11 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x1 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
    }
  };
  var array$12 = [$$x20, fullWidth, $$x9, $$x1];
  return $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))
});
$c_Lreactbuild_project_Areas$.prototype.apply$default$3__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
});
var $d_Lreactbuild_project_Areas$ = new $TypeData().initClass({
  Lreactbuild_project_Areas$: 0
}, false, "reactbuild.project.Areas$", {
  Lreactbuild_project_Areas$: 1,
  O: 1
});
$c_Lreactbuild_project_Areas$.prototype.$classData = $d_Lreactbuild_project_Areas$;
var $n_Lreactbuild_project_Areas$;
function $m_Lreactbuild_project_Areas$() {
  if ((!$n_Lreactbuild_project_Areas$)) {
    $n_Lreactbuild_project_Areas$ = new $c_Lreactbuild_project_Areas$()
  };
  return $n_Lreactbuild_project_Areas$
}
/** @constructor */
function $c_Lreactbuild_project_Comparative$() {
  /*<skip>*/
}
$c_Lreactbuild_project_Comparative$.prototype = new $h_O();
$c_Lreactbuild_project_Comparative$.prototype.constructor = $c_Lreactbuild_project_Comparative$;
/** @constructor */
function $h_Lreactbuild_project_Comparative$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Comparative$.prototype = $c_Lreactbuild_project_Comparative$.prototype;
$c_Lreactbuild_project_Comparative$.prototype.apply__sci_List__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projects, settings) {
  var this$1 = $n($as_scm_Map($m_scm_Map$().apply__sci_Seq__O($m_sci_Nil$())));
  var d = $m_s_package$().s_package$__f_Nil;
  var areaWithSize = $f_scm_Map__withDefaultValue__O__scm_Map(this$1, d);
  var this$15 = $n(projects);
  var f$1 = ((prj$2) => {
    var prj = $as_Lreactbuild_common_model_Project(prj$2);
    var this$4 = $n($n($n(prj).Lreactbuild_common_model_Project__f_areas).toList__sci_List());
    var rest = this$4;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var areasOpt = $as_sci_Seq(arg1);
      var this$5 = $n(areasOpt);
      var m = $as_scm_Map($m_scm_Map$().empty__O());
      var it = this$5.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var elem = $n(it).next__O();
        var x$1 = $as_Lreactbuild_common_model_Area(elem);
        var key = $n(x$1).Lreactbuild_common_model_Area__f_name;
        var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$5) => (() => this$5.newSpecificBuilder__scm_Builder()))(this$5))));
        var this$6 = $n(bldr);
        this$6.addOne__O__scm_Growable(elem)
      };
      var this$7 = $m_sci_HashMap$();
      var result = this$7.sci_HashMap$__f_EmptyMap;
      var mapIt = $n(m).iterator__sc_Iterator();
      while ($n(mapIt).hasNext__Z()) {
        var x1 = $as_T2($n(mapIt).next__O());
        if ((x1 === null)) {
          throw new $c_s_MatchError(x1)
        };
        var k = $n(x1)._1__O();
        var v = $as_scm_Builder($n(x1)._2__O());
        result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
      };
      var this$8 = $n(result);
      var p = new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
        var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
        return (check$ifrefutable$1 !== null)
      }));
      var it$1 = $n($as_sci_Map($ct_sc_MapOps$WithFilter__sc_MapOps__F1__(new $c_sc_MapOps$WithFilter(), this$8, p).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((x$3$2) => {
        var x$3 = $as_T2(x$3$2);
        if ((x$3 !== null)) {
          var area = $as_T($n(x$3)._1__O());
          var areaList = $as_sci_Seq($n(x$3)._2__O());
          var this$10 = $n(areaList);
          var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
            var x$2 = $as_Lreactbuild_common_model_Area(x$2$2);
            return (-$n(x$2).Lreactbuild_common_model_Area__f_area)
          }));
          var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
          var y = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$10, f, ord);
          return $ct_T2__O__O__(new $c_T2(), area, y)
        } else {
          throw new $c_s_MatchError(x$3)
        }
      }))))).iterator__sc_Iterator();
      while ($n(it$1).hasNext__Z()) {
        var nx = new $c_sci_$colon$colon($n(it$1).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx
        } else {
          $n(t).sci_$colon$colon__f_next = nx
        };
        t = nx
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    var this$13 = $n(((h === null) ? $m_sci_Nil$() : h));
    var this$12 = $m_s_$less$colon$less$();
    var y$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$13);
    return $ct_T2__O__O__(new $c_T2(), prj, y$1)
  });
  if ((this$15 === $m_sci_Nil$())) {
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1$1 = this$15.head__O();
    var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = $as_sci_List(this$15.tail__O());
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest$1).head__O();
      var nx$1 = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
      $n(t$1).sci_$colon$colon__f_next = nx$1;
      t$1 = nx$1;
      rest$1 = $as_sci_List($n(rest$1).tail__O())
    };
    var $$x1 = h$1
  };
  var this$17 = $n($$x1);
  var this$16 = $m_s_$less$colon$less$();
  var projectWithAreas = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$17);
  var this$25 = $n(projectWithAreas);
  var this$18 = $n($m_s_Predef$().s_Predef$__f_Map);
  var elems = $m_sci_Nil$();
  var z = $n(this$18.from__sc_IterableOnce__sci_Map(elems)).withDefaultValue__O__sci_Map(0);
  var f$2 = ((acc$2, c$2) => {
    var acc = $as_sci_Map(acc$2);
    var c = $as_T2(c$2);
    return $as_sci_Map($n($as_sc_IterableOnceOps($n(c)._2__O())).foldLeft__O__F2__O(acc, new $c_sjsr_AnonFunction2(((acc$2$2, c$2$2) => {
      var acc$2$1 = $as_sci_Map(acc$2$2);
      var c$2$1 = $as_T2(c$2$2);
      var self = $n(c$2$1)._1__O();
      var x = $uI($n(acc$2$1).apply__O__O($n(c$2$1)._1__O()));
      var that = $n($as_sc_SeqOps($n(c$2$1)._2__O())).length__I();
      var y$2 = ((x > that) ? x : that);
      return $as_sci_Map($n(acc$2$1).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self, y$2)))
    }))))
  });
  if ($is_sc_IndexedSeq(this$25)) {
    var x2 = $as_sc_IndexedSeq(this$25);
    var at = 0;
    var end = $n(x2).length__I();
    var acc$1 = z;
    var $$x2;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1$3 = acc$1;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f$2(arg1$3, arg2);
        at = temp$at;
        acc$1 = temp$acc;
        continue
      };
      var $$x2 = acc$1;
      break
    }
  } else {
    var result$1 = z;
    var it$2 = this$25.iterator__sc_Iterator();
    while ($n(it$2).hasNext__Z()) {
      var arg1$4 = result$1;
      var arg2$1 = $n(it$2).next__O();
      result$1 = f$2(arg1$4, arg2$1)
    };
    var $$x2 = result$1
  };
  var sizedAreas = $as_sci_Map($$x2);
  var this$29 = $n(projects);
  var f$3 = ((prj$3$2) => {
    var prj$3 = $as_Lreactbuild_common_model_Project(prj$3$2);
    var this$28 = $n($as_sci_Map($n($n($as_sc_MapFactoryDefaults($n(projectWithAreas).apply__O__O(prj$3))).withFilter__F1__sc_MapOps$WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$2$2) => {
      var check$ifrefutable$2 = $as_T2(check$ifrefutable$2$2);
      return (check$ifrefutable$2 !== null)
    })))).flatMap__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_T2(x$5$2);
      if ((x$5 !== null)) {
        var areaName = $as_T($n(x$5)._1__O());
        var lst = $as_sci_Seq($n(x$5)._2__O());
        return $as_sci_Seq($n($n($as_sc_IterableOps($n(lst).zipWithIndex__O())).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$3$2) => {
          var check$ifrefutable$3 = $as_T2(check$ifrefutable$3$2);
          return (check$ifrefutable$3 !== null)
        })))).map__F1__O(new $c_sjsr_AnonFunction1(((x$4$2) => {
          var x$4 = $as_T2(x$4$2);
          if ((x$4 !== null)) {
            var area$1 = $as_Lreactbuild_common_model_Area($n(x$4)._1__O());
            var idx = $n(x$4)._2$mcI$sp__I();
            var name = (($uI($n(sizedAreas).apply__O__O(areaName)) === 1) ? areaName : (($n(area$1).Lreactbuild_common_model_Area__f_name + " ") + ((1 + idx) | 0)));
            var $$x3 = $n(areaWithSize);
            var this$26 = $n($as_sc_SeqOps($n(areaWithSize).apply__O__O(name)));
            var elem$1 = $n(area$1).Lreactbuild_common_model_Area__f_area;
            $n($$x3).update__O__O__V(name, this$26.appended__O__O(elem$1));
            return $ct_T2__O__O__(new $c_T2(), name, $n(area$1).Lreactbuild_common_model_Area__f_area)
          } else {
            throw new $c_s_MatchError(x$4)
          }
        }))))
      } else {
        throw new $c_s_MatchError(x$5)
      }
    })))));
    var this$27 = $m_s_$less$colon$less$();
    return $ct_T2__O__O__(new $c_T2(), prj$3, $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$28))
  });
  if ((this$29 === $m_sci_Nil$())) {
    var projectAreas = $m_sci_Nil$()
  } else {
    var arg1$5 = this$29.head__O();
    var h$2 = new $c_sci_$colon$colon(f$3(arg1$5), $m_sci_Nil$());
    var t$2 = h$2;
    var rest$2 = $as_sci_List(this$29.tail__O());
    while ((rest$2 !== $m_sci_Nil$())) {
      var arg1$6 = $n(rest$2).head__O();
      var nx$2 = new $c_sci_$colon$colon(f$3(arg1$6), $m_sci_Nil$());
      $n(t$2).sci_$colon$colon__f_next = nx$2;
      t$2 = nx$2;
      rest$2 = $as_sci_List($n(rest$2).tail__O())
    };
    var projectAreas = h$2
  };
  var this$32 = $n($n($n(areaWithSize).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k$1 = $as_T($n(x0$1)._1__O());
      var v$1 = $as_sci_Seq($n(x0$1)._2__O());
      var y$3 = $n(v$1).max__s_math_Ordering__O($m_s_math_Ordering$DeprecatedDoubleOrdering$());
      return $ct_T2__O__O__(new $c_T2(), k$1, y$3)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))).toSeq__sci_Seq());
  var f$4 = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_T2(x$6$2);
    return $n(x$6)._2$mcD$sp__D()
  }));
  var ord$1 = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var areaNames = $as_sci_Seq($n($as_sc_SeqOps($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$32, f$4, ord$1))).reverse__O());
  var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$35 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fullBorderTable;
  var $$x38 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$35, s);
  var this$36 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaTable;
  var $$x37 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$36, s$1);
  var $$x36 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x35 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontSize__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("80%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x34 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "transform")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("rotate(-90deg) translate(50%)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x31 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$46 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaLabel;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$46, s$2), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" "))];
  var $$x30 = $n($$x31).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x27 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), areaNames), new $c_sjsr_AnonFunction1(((a$2) => {
    var a = $as_T2(a$2);
    var $$x29 = $m_Lreactbuild_project_Areas$();
    var $$x28 = $as_T($n(a)._1__O());
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$54 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    return $n($$x29).title__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf($$x28, this$54.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString))
  })));
  if ($n(settings).Lreactbuild_project_RenderingSettings__f_withPrice) {
    var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$57 = $m_Lscalacss_ScalaCssReact$();
    var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaLabel;
    var $$x25 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$57, s$3);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$59 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var array$1 = [$$x25, this$59.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Tarif"))];
    var $$x24 = $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  } else {
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var array$2 = [$$x30, $$x27, $$x24];
  var $$x23 = $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$72 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaLabel;
  var array$3 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$72, s$4), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" "))];
  var $$x20 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), areaNames), new $c_sjsr_AnonFunction1(((x$7$2) => {
    $as_T2(x$7$2);
    var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$81 = $m_Lscalacss_ScalaCssReact$();
    var s$5 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaLabel;
    var $$x18 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$81, s$5);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$83 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var array$4 = [$$x18, this$83.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("m\u00b2"))];
    return $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
  })));
  if ($n(settings).Lreactbuild_project_RenderingSettings__f_withPrice) {
    var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$91 = $m_Lscalacss_ScalaCssReact$();
    var s$6 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaLabel;
    var $$x15 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$91, s$6);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$93 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var array$5 = [$$x15, this$93.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("\u20ac"))];
    var $$x14 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
  } else {
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var array$6 = [$$x20, $$x17, $$x14];
  var array$7 = [$$x23, $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
  var $$x13 = $n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$11 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), projectAreas), new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_T2(x0$2$2);
    if ((x0$2 !== null)) {
      var p$1 = $as_Lreactbuild_common_model_Project($n(x0$2)._1__O());
      var areas = $as_sci_Map($n(x0$2)._2__O());
      var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$112 = $m_Lscalacss_ScalaCssReact$();
      var s$7 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaValue;
      var $$x9 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$112, s$7);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var $$x8 = $m_sc_StringOps$();
      $m_sc_StringOps$();
      var x$8 = $n(p$1).Lreactbuild_common_model_Project__f_reference;
      $m_sc_StringOps$();
      $m_sc_StringOps$();
      var from = 0;
      _return: {
        var this$116 = $n(x$8);
        var len = this$116.length;
        var i = from;
        while ((i < len)) {
          var this$117 = $n(x$8);
          var index = i;
          var arg1$7 = $charAt(this$117, index);
          if ((arg1$7 === 46)) {
            var x1$1 = i;
            break _return
          };
          i = ((1 + i) | 0)
        };
        var x1$1 = (-1)
      };
      if ((x1$1 === (-1))) {
        var x$9 = ""
      } else {
        var this$118 = $n(x$8);
        if (((x1$1 < 0) || (x1$1 > this$118.length))) {
          $charAt(this$118, x1$1)
        };
        var x$9 = $as_T(this$118.substring(x1$1))
      };
      var v$2 = $n($$x8).drop$extension__T__I__T(x$9, 1);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$8 = [$$x9, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      var $$x7 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
      var $$x6 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), areaNames), new $c_sjsr_AnonFunction1(((n$2) => {
        var n = $as_T2(n$2);
        return $m_Lreactbuild_project_Areas$().value__D__Z__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf($uD($n(areas).getOrElse__O__F0__O($n(n)._1__O(), new $c_sjsr_AnonFunction0((() => 0.0)))), true, ($m_Lreactbuild_project_Areas$(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom))
      })));
      if ($n(settings).Lreactbuild_project_RenderingSettings__f_withPrice) {
        var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$129 = $m_Lscalacss_ScalaCssReact$();
        var s$8 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_areaValue;
        var array$9 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$129, s$8), $m_Lreactbuild_project_PriceMention$().apply__Lreactbuild_common_model_Project__Ljapgolly_scalajs_react_vdom_VdomNode(p$1)];
        var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
      } else {
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      };
      var array$10 = [$$x7, $$x6, $$x4];
      return $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))
    } else {
      throw new $c_s_MatchError(x0$2)
    }
  })))];
  var array$12 = [$$x38, $$x37, $$x36, $$x35, $$x34, $$x13, $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
  var table = $n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
  var $$x41 = $m_Lreactbuild_project_Page$();
  $m_Lreactbuild_project_Page$();
  var $$x40 = $m_Lreactbuild_project_PageSide$Any$();
  var this$143 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).justifyContent__Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$());
  var array$13 = [this$143.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex-end", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("")), table];
  return $n($$x41).apply__Lreactbuild_project_PageSide__sci_Seq__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode($$x40, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13), new $c_Lsourcecode_FullName("reactbuild.project.Comparative.apply"), settings)
});
var $d_Lreactbuild_project_Comparative$ = new $TypeData().initClass({
  Lreactbuild_project_Comparative$: 0
}, false, "reactbuild.project.Comparative$", {
  Lreactbuild_project_Comparative$: 1,
  O: 1
});
$c_Lreactbuild_project_Comparative$.prototype.$classData = $d_Lreactbuild_project_Comparative$;
var $n_Lreactbuild_project_Comparative$;
function $m_Lreactbuild_project_Comparative$() {
  if ((!$n_Lreactbuild_project_Comparative$)) {
    $n_Lreactbuild_project_Comparative$ = new $c_Lreactbuild_project_Comparative$()
  };
  return $n_Lreactbuild_project_Comparative$
}
/** @constructor */
function $c_Lreactbuild_project_CreateOrSelectLocalizedProject$() {
  this.Lreactbuild_project_CreateOrSelectLocalizedProject$__f_component = null;
  $n_Lreactbuild_project_CreateOrSelectLocalizedProject$ = this;
  var this$55 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction0((() => $m_s_None$())), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x3 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x2 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$2 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x3.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x2, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$8)));
  var $$x4 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$2);
  var $$x1 = new $c_sjsr_AnonFunction0((() => {
    $n($m_s_package$().s_package$__f_List);
    return $m_sci_Nil$()
  }));
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$54 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($$x4.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$11))));
  var f$1 = new $c_sjsr_AnonFunction4(((props$2, prjRef$2, address$2, parcels$2) => {
    var props = $as_Lreactbuild_project_CreateOrSelectLocalizedProject$Props(props$2);
    var prjRef = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(prjRef$2);
    var address = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(address$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(parcels$2);
    var this$52 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
    var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
      var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
      var $$x12 = $m_Lcom_iz2use_react_components_Card$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n($n(props).Lreactbuild_project_CreateOrSelectLocalizedProject$Props__f_target).title__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x11 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
      var $$x10 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
      var $$x9 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
      var $$x8 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Nom du projet");
      var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var this$23 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$23, proxy);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$25 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$25, proxy$1);
      var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
      var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var this$30 = $m_Lreactbuild_model_Implicits$();
      var this$29 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$29, proxy$2);
      var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$30, ev);
      var $$x6 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, prjRef, optioner, ev$1, explainError, equiv);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Adresse du projet");
      var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$2);
      var ev$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$38 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$38);
      var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
      var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var eqv = $m_s_math_Equiv$String$();
      var equiv$1 = new $c_s_math_Equiv$OptionEquiv(eqv);
      var $$x5 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, address, optioner$1, ev$3, explainError$1, equiv$1);
      var u = $m_Lreactbuild_project_TestBluetoothMeazor$().apply__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot();
      var this$44 = $n(u);
      var n = this$44.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array = [$$x6, $$x5, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
      var array$1 = [$n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
      return $n($$x12).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x11, $$x10, $$x9, $$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    }));
    return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$52, f)
  }));
  var this$53 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$53);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$4 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$54, f$1, step, s);
  this.Lreactbuild_project_CreateOrSelectLocalizedProject$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$55, ev$4).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.CreateOrSelectLocalizedProject.component"))
}
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$.prototype = new $h_O();
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$.prototype.constructor = $c_Lreactbuild_project_CreateOrSelectLocalizedProject$;
/** @constructor */
function $h_Lreactbuild_project_CreateOrSelectLocalizedProject$() {
  /*<skip>*/
}
$h_Lreactbuild_project_CreateOrSelectLocalizedProject$.prototype = $c_Lreactbuild_project_CreateOrSelectLocalizedProject$.prototype;
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$.prototype.apply__Lreactbuild_project_Activity__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(target) {
  var c = this.Lreactbuild_project_CreateOrSelectLocalizedProject$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props(target);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_CreateOrSelectLocalizedProject$ = new $TypeData().initClass({
  Lreactbuild_project_CreateOrSelectLocalizedProject$: 0
}, false, "reactbuild.project.CreateOrSelectLocalizedProject$", {
  Lreactbuild_project_CreateOrSelectLocalizedProject$: 1,
  O: 1
});
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$.prototype.$classData = $d_Lreactbuild_project_CreateOrSelectLocalizedProject$;
var $n_Lreactbuild_project_CreateOrSelectLocalizedProject$;
function $m_Lreactbuild_project_CreateOrSelectLocalizedProject$() {
  if ((!$n_Lreactbuild_project_CreateOrSelectLocalizedProject$)) {
    $n_Lreactbuild_project_CreateOrSelectLocalizedProject$ = new $c_Lreactbuild_project_CreateOrSelectLocalizedProject$()
  };
  return $n_Lreactbuild_project_CreateOrSelectLocalizedProject$
}
/** @constructor */
function $c_Lreactbuild_project_Description$() {
  /*<skip>*/
}
$c_Lreactbuild_project_Description$.prototype = new $h_O();
$c_Lreactbuild_project_Description$.prototype.constructor = $c_Lreactbuild_project_Description$;
/** @constructor */
function $h_Lreactbuild_project_Description$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Description$.prototype = $c_Lreactbuild_project_Description$.prototype;
$c_Lreactbuild_project_Description$.prototype.apply__Ldiode_data_Pot__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, settings) {
  var $$x17 = $m_Lreactbuild_project_Page$();
  $m_Lreactbuild_project_Page$();
  var $$x16 = $m_Lreactbuild_project_PageSide$Any$();
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperDescription;
  var $$x14 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x13 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence : ");
  if ($n(projectPot).isFailed__Z()) {
    var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x10 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x10, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x9 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$17 = $n(projectPot);
    if ((!this$17.isEmpty__Z())) {
      var arg1 = $n(projectPot).get__O();
      var x$1 = $as_Lreactbuild_common_model_Project(arg1);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(x$1).Lreactbuild_common_model_Project__f_reference;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)
    } else if ($n(projectPot).isPending__Z()) {
      var $$x9 = $m_Lreactbuild_project_ProjectSkeleton$().Lreactbuild_project_ProjectSkeleton$__f_reference
    } else {
      var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x9 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    }
  };
  var array$2 = [$$x14, $$x13, $$x9];
  var $$x8 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  var this$30 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_vdom_HtmlTags__hr__T(this$30), $m_sci_Nil$());
  if ($n(projectPot).isFailed__Z()) {
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$2 = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$3 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
    var $$x1 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  } else {
    var this$41 = $n(projectPot);
    if ((!this$41.isEmpty__Z())) {
      var arg1$1 = $n(projectPot).get__O();
      var project = $as_Lreactbuild_common_model_Project(arg1$1);
      var this$42 = $n($n(project).Lreactbuild_common_model_Project__f_description);
      if (this$42.isEmpty__Z()) {
        var $$x4 = $m_s_None$()
      } else {
        var arg1$2 = this$42.get__O();
        var d = $n($as_Lcom_iz2use_common_Multiline(arg1$2)).Lcom_iz2use_common_Multiline__f_underlying;
        var u = $m_Lreactbuild_project_RichContent$().apply__T__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(d);
        var this$44 = $n(u);
        var n = this$44.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var $$x4 = new $c_s_Some(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n))
      };
      var this$46 = $n($$x4);
      var $$x1 = $as_Ljapgolly_scalajs_react_vdom_VdomNode((this$46.isEmpty__Z() ? $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom : this$46.get__O()))
    } else if ($n(projectPot).isPending__Z()) {
      var u$1 = $m_Lreactbuild_project_ProjectSkeleton$().Lreactbuild_project_ProjectSkeleton$__f_description;
      var this$48 = $n(u$1);
      var n$1 = this$48.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    } else {
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x1 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
    }
  };
  var array$5 = [$$x8, $$x6, $$x1];
  return $n($$x17).apply__Lreactbuild_project_PageSide__sci_Seq__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode($$x16, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5), new $c_Lsourcecode_FullName("reactbuild.project.Description.apply"), settings)
});
var $d_Lreactbuild_project_Description$ = new $TypeData().initClass({
  Lreactbuild_project_Description$: 0
}, false, "reactbuild.project.Description$", {
  Lreactbuild_project_Description$: 1,
  O: 1
});
$c_Lreactbuild_project_Description$.prototype.$classData = $d_Lreactbuild_project_Description$;
var $n_Lreactbuild_project_Description$;
function $m_Lreactbuild_project_Description$() {
  if ((!$n_Lreactbuild_project_Description$)) {
    $n_Lreactbuild_project_Description$ = new $c_Lreactbuild_project_Description$()
  };
  return $n_Lreactbuild_project_Description$
}
/** @constructor */
function $c_Lreactbuild_project_Document$() {
  /*<skip>*/
}
$c_Lreactbuild_project_Document$.prototype = new $h_O();
$c_Lreactbuild_project_Document$.prototype.constructor = $c_Lreactbuild_project_Document$;
/** @constructor */
function $h_Lreactbuild_project_Document$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Document$.prototype = $c_Lreactbuild_project_Document$.prototype;
$c_Lreactbuild_project_Document$.prototype.apply__Ldiode_data_Pot__sci_List__Ljapgolly_scalajs_react_vdom_TagOf = (function(projectPot, subprojects) {
  var settings = new $c_Lreactbuild_project_RenderingSettings(false, $m_s_package$().s_package$__f_Nil, $m_Lreactbuild_project_RenderingPageFormat$A4$());
  var $$x2 = $m_Lreactbuild_project_generator_WithOutputMedia$();
  var $$x1 = new $c_Lreactbuild_project_generator_OutputMedia$StandardPaper($m_Lreactbuild_project_generator_MediaSize$().Lreactbuild_project_generator_MediaSize$__f_A4, $m_Lreactbuild_project_generator_Orientation$Portrait$());
  var x = $m_s_package$().s_package$__f_Nil;
  var array = [(((x === null) ? (subprojects === null) : $n(x).equals__O__Z(subprojects)) ? $m_Lreactbuild_project_ProjectDocument$().apply__Ldiode_data_Pot__Z__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomElement(projectPot, false, settings) : $m_Lreactbuild_project_GlobalDocument$().apply__Ldiode_data_Pot__sci_List__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomElement(projectPot, subprojects, settings))];
  return $n($$x2).apply__Lreactbuild_project_generator_OutputMedia__D__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x1, 0.3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lreactbuild_project_Document$ = new $TypeData().initClass({
  Lreactbuild_project_Document$: 0
}, false, "reactbuild.project.Document$", {
  Lreactbuild_project_Document$: 1,
  O: 1
});
$c_Lreactbuild_project_Document$.prototype.$classData = $d_Lreactbuild_project_Document$;
var $n_Lreactbuild_project_Document$;
function $m_Lreactbuild_project_Document$() {
  if ((!$n_Lreactbuild_project_Document$)) {
    $n_Lreactbuild_project_Document$ = new $c_Lreactbuild_project_Document$()
  };
  return $n_Lreactbuild_project_Document$
}
/** @constructor */
function $c_Lreactbuild_project_Facade$() {
  /*<skip>*/
}
$c_Lreactbuild_project_Facade$.prototype = new $h_O();
$c_Lreactbuild_project_Facade$.prototype.constructor = $c_Lreactbuild_project_Facade$;
/** @constructor */
function $h_Lreactbuild_project_Facade$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Facade$.prototype = $c_Lreactbuild_project_Facade$.prototype;
$c_Lreactbuild_project_Facade$.prototype.apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf = (function(project, settings) {
  return $m_Lreactbuild_project_Page$().notYetImplemented__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lsourcecode_FullName("reactbuild.project.Facade.apply"), settings)
});
var $d_Lreactbuild_project_Facade$ = new $TypeData().initClass({
  Lreactbuild_project_Facade$: 0
}, false, "reactbuild.project.Facade$", {
  Lreactbuild_project_Facade$: 1,
  O: 1
});
$c_Lreactbuild_project_Facade$.prototype.$classData = $d_Lreactbuild_project_Facade$;
var $n_Lreactbuild_project_Facade$;
function $m_Lreactbuild_project_Facade$() {
  if ((!$n_Lreactbuild_project_Facade$)) {
    $n_Lreactbuild_project_Facade$ = new $c_Lreactbuild_project_Facade$()
  };
  return $n_Lreactbuild_project_Facade$
}
/** @constructor */
function $c_Lreactbuild_project_GlobalDocument$() {
  /*<skip>*/
}
$c_Lreactbuild_project_GlobalDocument$.prototype = new $h_O();
$c_Lreactbuild_project_GlobalDocument$.prototype.constructor = $c_Lreactbuild_project_GlobalDocument$;
/** @constructor */
function $h_Lreactbuild_project_GlobalDocument$() {
  /*<skip>*/
}
$h_Lreactbuild_project_GlobalDocument$.prototype = $c_Lreactbuild_project_GlobalDocument$.prototype;
$c_Lreactbuild_project_GlobalDocument$.prototype.apply__Ldiode_data_Pot__sci_List__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomElement = (function(projectPot, subprojects, settings) {
  var this$43 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x10 = $m_Lreactbuild_project_GlobalOverview$().apply__Ldiode_data_Pot__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(projectPot, settings);
  var $$x9 = $m_Lreactbuild_project_Description$().apply__Ldiode_data_Pot__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(projectPot, settings);
  if ($n(projectPot).isFailed__Z()) {
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x5 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(projectPot);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(projectPot).get__O();
      var project = $as_Lreactbuild_common_model_Project(arg1);
      var $$x5 = $m_Lreactbuild_project_MapAndPOI$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf(project, settings)
    } else if ($n(projectPot).isPending__Z()) {
      var $$x5 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x5 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    }
  };
  if ($n(projectPot).isFailed__Z()) {
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$2 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    var $$x1 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  } else {
    var this$29 = $n(projectPot);
    if ((!this$29.isEmpty__Z())) {
      var arg1$1 = $n(projectPot).get__O();
      var project$3 = $as_Lreactbuild_common_model_Project(arg1$1);
      var $$x1 = $m_Lreactbuild_project_GlobalParcel$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf(project$3, settings)
    } else if ($n(projectPot).isPending__Z()) {
      var $$x1 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x1 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    }
  };
  var this$39 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var this$38 = $n(subprojects);
  var f = ((prj$2) => {
    var prj = $as_Lreactbuild_common_model_Project(prj$2);
    var node = $m_Lreactbuild_project_ProjectDocument$().apply__Ldiode_data_Pot__Z__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomElement(new $c_Ldiode_data_Ready(prj), true, settings);
    return node
  });
  if ((this$38 === $m_sci_Nil$())) {
    var ns = $m_sci_Nil$()
  } else {
    var arg1$2 = this$38.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$38.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$3 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var ns = h
  };
  var array$4 = [$$x10, $$x9, $$x5, $$x1, $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$39, null, ns), $m_Lreactbuild_project_Comparative$().apply__sci_List__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(subprojects, settings)];
  var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$43, null, ns$1)
});
var $d_Lreactbuild_project_GlobalDocument$ = new $TypeData().initClass({
  Lreactbuild_project_GlobalDocument$: 0
}, false, "reactbuild.project.GlobalDocument$", {
  Lreactbuild_project_GlobalDocument$: 1,
  O: 1
});
$c_Lreactbuild_project_GlobalDocument$.prototype.$classData = $d_Lreactbuild_project_GlobalDocument$;
var $n_Lreactbuild_project_GlobalDocument$;
function $m_Lreactbuild_project_GlobalDocument$() {
  if ((!$n_Lreactbuild_project_GlobalDocument$)) {
    $n_Lreactbuild_project_GlobalDocument$ = new $c_Lreactbuild_project_GlobalDocument$()
  };
  return $n_Lreactbuild_project_GlobalDocument$
}
/** @constructor */
function $c_Lreactbuild_project_GlobalOverview$() {
  /*<skip>*/
}
$c_Lreactbuild_project_GlobalOverview$.prototype = new $h_O();
$c_Lreactbuild_project_GlobalOverview$.prototype.constructor = $c_Lreactbuild_project_GlobalOverview$;
/** @constructor */
function $h_Lreactbuild_project_GlobalOverview$() {
  /*<skip>*/
}
$h_Lreactbuild_project_GlobalOverview$.prototype = $c_Lreactbuild_project_GlobalOverview$.prototype;
$c_Lreactbuild_project_GlobalOverview$.prototype.apply__Ldiode_data_Pot__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, settings) {
  var this$2 = $n($n(projectPot).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_common_model_Project(x$1$2);
    return $n(x$1).Lreactbuild_common_model_Project__f_images
  }))));
  var images = $n($as_s_PartialFunction((this$2.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$2.get__O()))).lift__F1();
  var $$x31 = $m_Lreactbuild_project_Page$();
  $m_Lreactbuild_project_Page$();
  var $$x30 = $m_Lreactbuild_project_PageSide$Any$();
  var this$13 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var this$4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x28 = this$4.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$9 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$5 = $n($as_s_Option($n(images).apply__O__O(0)));
  if (this$5.isEmpty__Z()) {
    var o = $m_s_None$()
  } else {
    var arg1 = this$5.get__O();
    var img = $as_Lreactbuild_common_model_Image(arg1);
    var o = new $c_s_Some($m_Lreactbuild_project_Image$().apply__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf(img, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom))
  };
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var this$8 = $m_s_$less$colon$less$();
  var f = this$8.s_$less$colon$less$__f_singleton;
  var array = [$$x28, $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$9, o, O, f)];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x29 = this$13.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms);
  var this$108 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var this$14 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x26 = this$14.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$15 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x25 = this$15.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x24 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$18 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).justifyContent__Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$());
  var $$x23 = this$18.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$19 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x22 = this$19.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$22 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperMainTitle1;
  var $$x20 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$22, s);
  if ($n(projectPot).isFailed__Z()) {
    var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x17 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$1 = [$$x17, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x16 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  } else {
    var this$33 = $n(projectPot);
    if ((!this$33.isEmpty__Z())) {
      var arg1$1 = $n(projectPot).get__O();
      var x$2 = $as_Lreactbuild_common_model_Project(arg1$1);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(x$2).Lreactbuild_common_model_Project__f_title;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x16 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)
    } else if ($n(projectPot).isPending__Z()) {
      var u = $m_Lreactbuild_project_ProjectSkeleton$().Lreactbuild_project_ProjectSkeleton$__f_title;
      var this$37 = $n(u);
      var n = this$37.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x16 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    } else {
      var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x16 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    }
  };
  var array$3 = [$$x20, $$x16];
  var $$x15 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("p", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$51 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperMainTitle2;
  var $$x13 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$51, s$1);
  if ($n(projectPot).isFailed__Z()) {
    var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x10 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$2 = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$4 = [$$x10, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
    var $$x9 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
  } else {
    var this$62 = $n(projectPot);
    if ((!this$62.isEmpty__Z())) {
      var arg1$2 = $n(projectPot).get__O();
      var project = $as_Lreactbuild_common_model_Project(arg1$2);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$63 = $n($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(project).Lreactbuild_common_model_Project__f_city)).toSeq__sci_Seq());
      var suffix = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(project).Lreactbuild_common_model_Project__f_district)).toSeq__sci_Seq();
      var this$64 = $n($as_sc_IterableOnceOps(this$63.appendedAll__sc_IterableOnce__O(suffix)));
      var v$3 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$64, "", " ", "");
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
    } else if ($n(projectPot).isPending__Z()) {
      var $$x9 = $m_Lreactbuild_project_ProjectSkeleton$().Lreactbuild_project_ProjectSkeleton$__f_city
    } else {
      var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x9 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
    }
  };
  var array$6 = [$$x13, $$x9];
  var $$x8 = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("p", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$79 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperMainTitle3;
  var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$79, s$2);
  if ($n(projectPot).isFailed__Z()) {
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$4 = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$7 = [$$x3, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
    var $$x2 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
  } else {
    var this$90 = $n(projectPot);
    if ((!this$90.isEmpty__Z())) {
      var arg1$3 = $n(projectPot).get__O();
      var x$3 = $as_Lreactbuild_common_model_Project(arg1$3);
      var this$94 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var o$1 = $n(x$3).Lreactbuild_common_model_Project__f_topic;
      var O$1 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var f$1 = new $c_sjsr_AnonFunction1(((v$2$1) => {
        var v$5 = $as_T(v$2$1);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)
      }));
      var $$x2 = $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$94, o$1, O$1, f$1)
    } else if ($n(projectPot).isPending__Z()) {
      var $$x2 = $m_Lreactbuild_project_ProjectSkeleton$().Lreactbuild_project_ProjectSkeleton$__f_topic
    } else {
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$8 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x2 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
    }
  };
  var array$9 = [$$x6, $$x2];
  var array$10 = [$$x26, $$x25, $$x24, $$x23, $$x22, $$x15, $$x8, $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("p", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))];
  var ms$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var $$x27 = this$108.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1);
  var this$118 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var this$109 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x1 = this$109.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$114 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$110 = $n($as_s_Option($n(images).apply__O__O(1)));
  if (this$110.isEmpty__Z()) {
    var o$2 = $m_s_None$()
  } else {
    var arg1$4 = this$110.get__O();
    var img$3 = $as_Lreactbuild_common_model_Image(arg1$4);
    var o$2 = new $c_s_Some($m_Lreactbuild_project_Image$().apply__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf(img$3, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom))
  };
  var O$2 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var this$113 = $m_s_$less$colon$less$();
  var f$2 = this$113.s_$less$colon$less$__f_singleton;
  var array$11 = [$$x1, $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$114, o$2, O$2, f$2)];
  var ms$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var array$12 = [$$x29, $$x27, this$118.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$2)];
  return $n($$x31).rows__Lreactbuild_project_PageSide__sci_Seq__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode($$x30, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12), new $c_Lsourcecode_FullName("reactbuild.project.GlobalOverview.apply"), settings)
});
var $d_Lreactbuild_project_GlobalOverview$ = new $TypeData().initClass({
  Lreactbuild_project_GlobalOverview$: 0
}, false, "reactbuild.project.GlobalOverview$", {
  Lreactbuild_project_GlobalOverview$: 1,
  O: 1
});
$c_Lreactbuild_project_GlobalOverview$.prototype.$classData = $d_Lreactbuild_project_GlobalOverview$;
var $n_Lreactbuild_project_GlobalOverview$;
function $m_Lreactbuild_project_GlobalOverview$() {
  if ((!$n_Lreactbuild_project_GlobalOverview$)) {
    $n_Lreactbuild_project_GlobalOverview$ = new $c_Lreactbuild_project_GlobalOverview$()
  };
  return $n_Lreactbuild_project_GlobalOverview$
}
/** @constructor */
function $c_Lreactbuild_project_GlobalParcel$() {
  /*<skip>*/
}
$c_Lreactbuild_project_GlobalParcel$.prototype = new $h_O();
$c_Lreactbuild_project_GlobalParcel$.prototype.constructor = $c_Lreactbuild_project_GlobalParcel$;
/** @constructor */
function $h_Lreactbuild_project_GlobalParcel$() {
  /*<skip>*/
}
$h_Lreactbuild_project_GlobalParcel$.prototype = $c_Lreactbuild_project_GlobalParcel$.prototype;
$c_Lreactbuild_project_GlobalParcel$.prototype.apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf = (function(project, settings) {
  return $m_Lreactbuild_project_Page$().notYetImplemented__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lsourcecode_FullName("reactbuild.project.GlobalParcel.apply"), settings)
});
var $d_Lreactbuild_project_GlobalParcel$ = new $TypeData().initClass({
  Lreactbuild_project_GlobalParcel$: 0
}, false, "reactbuild.project.GlobalParcel$", {
  Lreactbuild_project_GlobalParcel$: 1,
  O: 1
});
$c_Lreactbuild_project_GlobalParcel$.prototype.$classData = $d_Lreactbuild_project_GlobalParcel$;
var $n_Lreactbuild_project_GlobalParcel$;
function $m_Lreactbuild_project_GlobalParcel$() {
  if ((!$n_Lreactbuild_project_GlobalParcel$)) {
    $n_Lreactbuild_project_GlobalParcel$ = new $c_Lreactbuild_project_GlobalParcel$()
  };
  return $n_Lreactbuild_project_GlobalParcel$
}
/** @constructor */
function $c_Lreactbuild_project_Image$() {
  /*<skip>*/
}
$c_Lreactbuild_project_Image$.prototype = new $h_O();
$c_Lreactbuild_project_Image$.prototype.constructor = $c_Lreactbuild_project_Image$;
/** @constructor */
function $h_Lreactbuild_project_Image$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Image$.prototype = $c_Lreactbuild_project_Image$.prototype;
$c_Lreactbuild_project_Image$.prototype.apply__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf = (function(img, width, other) {
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperImageContainer;
  var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  var this$4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  var $$x1 = $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T(this$4);
  var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(img).fullPath__T__T($m_Lreactbuild_package$().Lreactbuild_package$__f_scheme), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$1 = [$$x3, width, other, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
$c_Lreactbuild_project_Image$.prototype.apply$default$2__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("75%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
});
$c_Lreactbuild_project_Image$.prototype.apply$default$3__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
});
var $d_Lreactbuild_project_Image$ = new $TypeData().initClass({
  Lreactbuild_project_Image$: 0
}, false, "reactbuild.project.Image$", {
  Lreactbuild_project_Image$: 1,
  O: 1
});
$c_Lreactbuild_project_Image$.prototype.$classData = $d_Lreactbuild_project_Image$;
var $n_Lreactbuild_project_Image$;
function $m_Lreactbuild_project_Image$() {
  if ((!$n_Lreactbuild_project_Image$)) {
    $n_Lreactbuild_project_Image$ = new $c_Lreactbuild_project_Image$()
  };
  return $n_Lreactbuild_project_Image$
}
/** @constructor */
function $c_Lreactbuild_project_MapAndPOI$() {
  /*<skip>*/
}
$c_Lreactbuild_project_MapAndPOI$.prototype = new $h_O();
$c_Lreactbuild_project_MapAndPOI$.prototype.constructor = $c_Lreactbuild_project_MapAndPOI$;
/** @constructor */
function $h_Lreactbuild_project_MapAndPOI$() {
  /*<skip>*/
}
$h_Lreactbuild_project_MapAndPOI$.prototype = $c_Lreactbuild_project_MapAndPOI$.prototype;
$c_Lreactbuild_project_MapAndPOI$.prototype.apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf = (function(project, settings) {
  return $m_Lreactbuild_project_Page$().notYetImplemented__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lsourcecode_FullName("reactbuild.project.MapAndPOI.apply"), settings)
});
var $d_Lreactbuild_project_MapAndPOI$ = new $TypeData().initClass({
  Lreactbuild_project_MapAndPOI$: 0
}, false, "reactbuild.project.MapAndPOI$", {
  Lreactbuild_project_MapAndPOI$: 1,
  O: 1
});
$c_Lreactbuild_project_MapAndPOI$.prototype.$classData = $d_Lreactbuild_project_MapAndPOI$;
var $n_Lreactbuild_project_MapAndPOI$;
function $m_Lreactbuild_project_MapAndPOI$() {
  if ((!$n_Lreactbuild_project_MapAndPOI$)) {
    $n_Lreactbuild_project_MapAndPOI$ = new $c_Lreactbuild_project_MapAndPOI$()
  };
  return $n_Lreactbuild_project_MapAndPOI$
}
/** @constructor */
function $c_Lreactbuild_project_Overview$() {
  /*<skip>*/
}
$c_Lreactbuild_project_Overview$.prototype = new $h_O();
$c_Lreactbuild_project_Overview$.prototype.constructor = $c_Lreactbuild_project_Overview$;
/** @constructor */
function $h_Lreactbuild_project_Overview$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Overview$.prototype = $c_Lreactbuild_project_Overview$.prototype;
$c_Lreactbuild_project_Overview$.prototype.apply__Ldiode_data_Pot__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, settings) {
  var this$2 = $n($n(projectPot).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_common_model_Project(x$1$2);
    return $as_sci_Seq($n($n(x$1).Lreactbuild_common_model_Project__f_images).filter__F1__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lreactbuild_common_model_Image(x$2$2);
      return ($n(x$2).Lreactbuild_common_model_Image__f_width < 2048)
    }))))
  }))));
  var images = $as_sci_Seq((this$2.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$2.get__O()));
  var this$3 = $n(images);
  var imageOptions = new $c_s_PartialFunction$Lifted(this$3);
  var $$x55 = $m_Lreactbuild_project_Page$();
  $m_Lreactbuild_project_Page$();
  var $$x54 = $m_Lreactbuild_project_PageSide$Any$();
  var this$129 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var this$5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x52 = this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$6 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x51 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x50 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x49 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x48 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$13 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperTitle;
  var $$x47 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$13, s);
  if ($n(projectPot).isFailed__Z()) {
    var $$x45 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x44 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x44, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x43 = $n($$x45).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$24 = $n(projectPot);
    if ((!this$24.isEmpty__Z())) {
      var arg1 = $n(projectPot).get__O();
      var x$3 = $as_Lreactbuild_common_model_Project(arg1);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(x$3).Lreactbuild_common_model_Project__f_title;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x43 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)
    } else if ($n(projectPot).isPending__Z()) {
      var u = $m_Lreactbuild_project_ProjectSkeleton$().Lreactbuild_project_ProjectSkeleton$__f_title;
      var this$28 = $n(u);
      var n = this$28.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x43 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    } else {
      var $$x46 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x43 = $n($$x46).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    }
  };
  var array$2 = [$$x47, $$x43];
  var $$x42 = $n($$x48).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x41 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  if ($n(settings).Lreactbuild_project_RenderingSettings__f_withPrice) {
    if ($n(projectPot).isFailed__Z()) {
      var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x38 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$2 = $n(projectPot).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$3 = [$$x38, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      var $$x37 = $n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    } else {
      var this$52 = $n(projectPot);
      if ((!this$52.isEmpty__Z())) {
        var arg1$1 = $n(projectPot).get__O();
        var p = $as_Lreactbuild_common_model_Project(arg1$1);
        var $$x37 = $m_Lreactbuild_project_PriceMention$().apply__Lreactbuild_common_model_Project__Ljapgolly_scalajs_react_vdom_VdomNode(p)
      } else if ($n(projectPot).isPending__Z()) {
        var $$x37 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x40 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        var $$x37 = $n($$x40).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
      }
    }
  } else {
    var $$x37 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var array$5 = [$$x37];
  var $$x36 = $n($$x41).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x35 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$65 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperDescription;
  var $$x34 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$65, s$1);
  if ($n(projectPot).isFailed__Z()) {
    var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x31 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$3 = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$6 = [$$x31, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
    var $$x30 = $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
  } else {
    var this$76 = $n(projectPot);
    if ((!this$76.isEmpty__Z())) {
      var arg1$2 = $n(projectPot).get__O();
      var x$4 = $as_Lreactbuild_common_model_Project(arg1$2);
      var this$80 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var o = $n(x$4).Lreactbuild_common_model_Project__f_topic;
      var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var f = new $c_sjsr_AnonFunction1(((v$2$1) => {
        var v$4 = $as_T(v$2$1);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)
      }));
      var $$x30 = $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$80, o, O, f)
    } else if ($n(projectPot).isPending__Z()) {
      var $$x30 = $m_Lreactbuild_project_ProjectSkeleton$().Lreactbuild_project_ProjectSkeleton$__f_topic
    } else {
      var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x30 = $n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
    }
  };
  var array$8 = [$$x34, $$x30];
  var $$x29 = $n($$x35).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
  var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$93 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperDescription;
  var $$x27 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$93, s$2);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x26 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence : ");
  if ($n(projectPot).isFailed__Z()) {
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x23 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$5 = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$9 = [$$x23, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
    var $$x22 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
  } else {
    var this$106 = $n(projectPot);
    if ((!this$106.isEmpty__Z())) {
      var arg1$3 = $n(projectPot).get__O();
      var x$5 = $as_Lreactbuild_common_model_Project(arg1$3);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$6 = $n(x$5).Lreactbuild_common_model_Project__f_reference;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x22 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$6)
    } else if ($n(projectPot).isPending__Z()) {
      var $$x22 = $m_Lreactbuild_project_ProjectSkeleton$().Lreactbuild_project_ProjectSkeleton$__f_reference
    } else {
      var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$10 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      var $$x22 = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))
    }
  };
  var array$11 = [$$x27, $$x26, $$x22];
  var array$12 = [$$x49, $$x42, $$x36, $$x29, $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11)), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom];
  var $$x21 = $n($$x50).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
  var $$x20 = $m_Lreactbuild_project_Page$().Lreactbuild_project_Page$__f_emptyCol;
  var this$125 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$122 = $n(imageOptions.apply__O__s_Option(0));
  if (this$122.isEmpty__Z()) {
    var o$1 = $m_s_None$()
  } else {
    var arg1$4 = this$122.get__O();
    var x$6 = $as_Lreactbuild_common_model_Image(arg1$4);
    var o$1 = new $c_s_Some($m_Lreactbuild_project_Image$().apply__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf(x$6, $m_Lreactbuild_project_Image$().apply$default$2__Ljapgolly_scalajs_react_vdom_TagMod(), $m_Lreactbuild_project_Image$().apply$default$3__Ljapgolly_scalajs_react_vdom_TagMod()))
  };
  var O$1 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var this$124 = $m_s_$less$colon$less$();
  var f$1 = this$124.s_$less$colon$less$__f_singleton;
  var array$13 = [$$x52, $$x51, $$x21, $$x20, $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$125, o$1, O$1, f$1)];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var $$x53 = this$129.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms);
  var this$151 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var this$130 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x18 = this$130.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$131 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x17 = this$131.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$132 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x16 = this$132.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$136 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$133 = $n(imageOptions.apply__O__s_Option(1));
  if (this$133.isEmpty__Z()) {
    var o$2 = $m_s_None$()
  } else {
    var arg1$5 = this$133.get__O();
    var x$7 = $as_Lreactbuild_common_model_Image(arg1$5);
    var o$2 = new $c_s_Some($m_Lreactbuild_project_Image$().apply__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf(x$7, $m_Lreactbuild_project_Image$().apply$default$2__Ljapgolly_scalajs_react_vdom_TagMod(), $m_Lreactbuild_project_Image$().apply$default$3__Ljapgolly_scalajs_react_vdom_TagMod()))
  };
  var O$2 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var this$135 = $m_s_$less$colon$less$();
  var f$2 = this$135.s_$less$colon$less$__f_singleton;
  var $$x15 = $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$136, o$2, O$2, f$2);
  var $$x14 = $m_Lreactbuild_project_Page$().Lreactbuild_project_Page$__f_emptyCol;
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x11 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$141 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).wordBreak__Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$());
  var array$14 = [$$x11, this$141.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("break-all", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $m_Lreactbuild_project_Areas$().apply__Ldiode_data_Pot__Z__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf($n(projectPot).flatMap__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((p$3$2) => {
    var p$3 = $as_Lreactbuild_common_model_Project(p$3$2);
    var $$x12 = $m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(p$3).Lreactbuild_common_model_Project__f_areas);
    var value = $m_s_package$().s_package$__f_Nil;
    return $as_Ldiode_data_Pot($n($$x12).foldLeft__O__F2__O(new $c_Ldiode_data_Ready(value), new $c_sjsr_AnonFunction2(((acc$2, c$2) => {
      var acc = $as_Ldiode_data_Pot(acc$2);
      var c = $as_sci_Seq(c$2);
      $n(acc);
      return new $c_Ldiode_data_Ready(c)
    }))))
  }))), ($m_Lreactbuild_project_Areas$(), false), $m_Lreactbuild_project_Areas$().apply$default$3__Ljapgolly_scalajs_react_vdom_TagMod())];
  var array$15 = [$$x18, $$x17, $$x16, $$x15, $$x14, $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  var ms$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var $$x19 = this$151.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1);
  var this$219 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var this$152 = $n($as_sci_Seq($n(images).drop__I__O(2)));
  matchEnd6: {
    var $$x1;
    $n($m_s_package$().s_package$__f_Seq);
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(this$152), true) && (this$152.lengthCompare__I__I(2) >= 0))) {
      var one = $as_Lreactbuild_common_model_Image(this$152.apply__I__O(0));
      var two = $as_Lreactbuild_common_model_Image(this$152.apply__I__O(1));
      var rest = $m_sc_SeqFactory$UnapplySeqWrapper$().drop$extension__sc_SeqOps__I__sci_Seq(this$152, 2);
      var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$164 = $m_Lscalacss_ScalaCssReact$();
      var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperRow;
      var $$x9 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$164, s$3);
      var $$x8 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("99%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$168 = $m_Lscalacss_ScalaCssReact$();
      var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperCol;
      var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$168, s$4);
      var this$169 = $n(rest);
      var lst = $as_sci_Seq($n($as_sc_IterableOps($n($as_sc_IterableOps(this$169.prepended__O__O(two))).take__I__O(3))).map__F1__O(new $c_sjsr_AnonFunction1(((x$8$2) => {
        var x$8 = $as_Lreactbuild_common_model_Image(x$8$2);
        return $m_Lreactbuild_project_Image$().apply__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf(x$8, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $m_Lreactbuild_project_Image$().apply$default$3__Ljapgolly_scalajs_react_vdom_TagMod())
      }))));
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      if (($n(lst).length__I() < 3)) {
        var this$190 = $n(lst);
        var x = $n(lst).length__I();
        var isEmpty = (x >= 3);
        if (isEmpty) {
          var scala$collection$immutable$Range$$numRangeElements = 0
        } else {
          var hi = (x >> 31);
          var lo = ((3 - x) | 0);
          var hi$1 = ((((-2147483648) ^ lo) > (-2147483645)) ? (((-1) - hi) | 0) : ((-hi) | 0));
          var hi$2 = (x >> 31);
          var lo$1 = ((3 - x) | 0);
          var this$179 = $L0;
          if ((!((this$179.RTLong__f_lo === 0) && (this$179.RTLong__f_hi === 0)))) {
            var value$1 = 1
          } else {
            var value$1 = 0
          };
          var hi$4 = (value$1 >> 31);
          var lo$2 = ((lo + value$1) | 0);
          var hi$5 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$4) | 0)) | 0) : ((hi$1 + hi$4) | 0));
          var scala$collection$immutable$Range$$numRangeElements = (((hi$5 === 0) ? (((-2147483648) ^ lo$2) > (-1)) : (hi$5 > 0)) ? (-1) : lo$2)
        };
        if ((scala$collection$immutable$Range$$numRangeElements < 0)) {
          $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(x, 3, 1, false)
        };
        var b = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
        var it = new $c_sci_RangeIterator(x, 1, 2, isEmpty);
        while (it.sci_RangeIterator__f__hasNext) {
          var this$189 = $n(b);
          it.next__I();
          var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$16 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
          var elem = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
          this$189.addOne__O__scm_Growable(elem)
        };
        var suffix = $as_sci_IndexedSeq($n(b).result__O());
        var $$x2 = this$190.appendedAll__sc_IterableOnce__O(suffix)
      } else {
        var $$x2 = lst
      };
      var as = $as_sc_IterableOnce($n($as_sc_IterableOps($n($as_sc_IterableOps($$x2)).flatMap__F1__O(new $c_sjsr_AnonFunction1(((c$2$1) => {
        var c$1 = $as_Ljapgolly_scalajs_react_vdom_TagOf(c$2$1);
        var $$x4 = $m_s_package$().s_package$__f_Seq;
        var array$17 = [$m_Lreactbuild_project_Page$().Lreactbuild_project_Page$__f_emptyRow, c$1];
        return $as_sci_Seq($n($$x4).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17)))
      }))))).drop__I__O(1));
      var this$196 = $m_s_$less$colon$less$();
      var array$18 = [$$x6, $n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$196.s_$less$colon$less$__f_singleton)];
      var array$19 = [$$x9, $$x8, $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18)), $m_Lreactbuild_project_Page$().Lreactbuild_project_Page$__f_emptyCol, $m_Lreactbuild_project_Image$().apply__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf(one, $m_Lreactbuild_project_Image$().apply$default$2__Ljapgolly_scalajs_react_vdom_TagMod(), $m_Lreactbuild_project_Image$().apply$default$3__Ljapgolly_scalajs_react_vdom_TagMod())];
      var $$x1 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19));
      break matchEnd6
    };
    $n($m_s_package$().s_package$__f_Seq);
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(this$152), true) && (this$152.lengthCompare__I__I(1) === 0))) {
      var one$2 = $as_Lreactbuild_common_model_Image(this$152.apply__I__O(0));
      var $$x1 = $m_Lreactbuild_project_Image$().apply__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf(one$2, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $m_Lreactbuild_project_Image$().apply$default$3__Ljapgolly_scalajs_react_vdom_TagMod());
      break matchEnd6
    };
    $n($m_s_package$().s_package$__f_Seq);
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(this$152), true) && (this$152.lengthCompare__I__I(0) === 0))) {
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("");
      break matchEnd6
    };
    throw new $c_s_MatchError(this$152)
  };
  var array$20 = [$$x1];
  var ms$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20);
  var array$21 = [$$x53, $$x19, this$219.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$2)];
  return $n($$x55).rows__Lreactbuild_project_PageSide__sci_Seq__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode($$x54, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21), new $c_Lsourcecode_FullName("reactbuild.project.Overview.apply"), settings)
});
var $d_Lreactbuild_project_Overview$ = new $TypeData().initClass({
  Lreactbuild_project_Overview$: 0
}, false, "reactbuild.project.Overview$", {
  Lreactbuild_project_Overview$: 1,
  O: 1
});
$c_Lreactbuild_project_Overview$.prototype.$classData = $d_Lreactbuild_project_Overview$;
var $n_Lreactbuild_project_Overview$;
function $m_Lreactbuild_project_Overview$() {
  if ((!$n_Lreactbuild_project_Overview$)) {
    $n_Lreactbuild_project_Overview$ = new $c_Lreactbuild_project_Overview$()
  };
  return $n_Lreactbuild_project_Overview$
}
/** @constructor */
function $c_Lreactbuild_project_Page$() {
  this.Lreactbuild_project_Page$__f_emptyRow = null;
  this.Lreactbuild_project_Page$__f_emptyCol = null;
  this.Lreactbuild_project_Page$__f_component = null;
  $n_Lreactbuild_project_Page$ = this;
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperEmptyRow;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("\u2000"))];
  this.Lreactbuild_project_Page$__f_emptyRow = $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$11 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperEmptyCol;
  var array$1 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$11, s$1), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("\u2000"))];
  this.Lreactbuild_project_Page$__f_emptyCol = $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var this$23 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Page", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_project_Page$Props(p$2);
    return new $c_Lreactbuild_project_Page$State(true)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_Page$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x4 = $n($as_Lreactbuild_project_Page$Backend($n(x$3).backend__O()));
    var this$18 = $n(x$3);
    var $$x3 = $as_Lreactbuild_project_Page$Props($n(this$18.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$19 = $n(x$3);
    return $n($$x4).render__Lreactbuild_project_Page$Props__Lreactbuild_project_Page$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x3, $as_Lreactbuild_project_Page$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$19)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(x$4$2);
    var this$21 = $n(x$4);
    var mod = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lreactbuild_project_Page$State(x$1$2);
      $n(x$1);
      return new $c_Lreactbuild_project_Page$State(true)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$21, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_project_Page$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$23, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_Page$.prototype = new $h_O();
$c_Lreactbuild_project_Page$.prototype.constructor = $c_Lreactbuild_project_Page$;
/** @constructor */
function $h_Lreactbuild_project_Page$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Page$.prototype = $c_Lreactbuild_project_Page$.prototype;
$c_Lreactbuild_project_Page$.prototype.apply__Lreactbuild_project_PageSide__sci_Seq__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode = (function(side, children, id, context) {
  var c = this.Lreactbuild_project_Page$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_Page$Props(children);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_project_Page$.prototype.rows__Lreactbuild_project_PageSide__sci_Seq__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode = (function(side, lines, id, context) {
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $as_sc_IterableOnce($n(lines).map__F1__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Ljapgolly_scalajs_react_vdom_TagMod(x$2$2);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$4 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_paperFullPart;
    var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s), x$2];
    return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }))));
  var sep = this.Lreactbuild_project_Page$__f_emptyRow;
  var this$10 = $m_s_$less$colon$less$();
  var f = this$10.s_$less$colon$less$__f_singleton;
  var array$1 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f)];
  return this.apply__Lreactbuild_project_PageSide__sci_Seq__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(side, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), id, context)
});
$c_Lreactbuild_project_Page$.prototype.notYetImplemented__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf = (function(id, context) {
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_documentPaperPage;
  var $$x9 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_skipPaperPage;
  var $$x8 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_documentPaperPageContent;
  var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$2);
  var this$8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x5 = this$8.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$9 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x4 = this$9.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Non impl\u00e9ment\u00e9 : "))];
  var $$x2 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = $n(id).Lsourcecode_FullName__f_value;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  var array$2 = [$$x6, $$x5, $$x4, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h1", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var array$3 = [$$x9, $$x8, $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
$c_Lreactbuild_project_Page$.prototype.empty__T__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf = (function(reason, id, context) {
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_documentPaperPage;
  var $$x9 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_skipPaperPage;
  var $$x8 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_documentPaperPageContent;
  var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$2);
  var this$8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x5 = this$8.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$9 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x4 = this$9.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Page vide"))];
  var $$x2 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(reason))];
  var array$2 = [$$x6, $$x5, $$x4, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h1", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var array$3 = [$$x9, $$x8, $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
var $d_Lreactbuild_project_Page$ = new $TypeData().initClass({
  Lreactbuild_project_Page$: 0
}, false, "reactbuild.project.Page$", {
  Lreactbuild_project_Page$: 1,
  O: 1
});
$c_Lreactbuild_project_Page$.prototype.$classData = $d_Lreactbuild_project_Page$;
var $n_Lreactbuild_project_Page$;
function $m_Lreactbuild_project_Page$() {
  if ((!$n_Lreactbuild_project_Page$)) {
    $n_Lreactbuild_project_Page$ = new $c_Lreactbuild_project_Page$()
  };
  return $n_Lreactbuild_project_Page$
}
/** @constructor */
function $c_Lreactbuild_project_Parcel$() {
  /*<skip>*/
}
$c_Lreactbuild_project_Parcel$.prototype = new $h_O();
$c_Lreactbuild_project_Parcel$.prototype.constructor = $c_Lreactbuild_project_Parcel$;
/** @constructor */
function $h_Lreactbuild_project_Parcel$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Parcel$.prototype = $c_Lreactbuild_project_Parcel$.prototype;
$c_Lreactbuild_project_Parcel$.prototype.apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode = (function(project, settings) {
  var x1 = $n(project).Lreactbuild_common_model_Project__f_modelSource;
  var x = $m_s_None$();
  if ((x === x1)) {
    return $m_Lreactbuild_project_Page$().empty__T__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf("Dessin non enregistr\u00e9", new $c_Lsourcecode_FullName("reactbuild.project.Parcel.apply"), settings)
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var modelSource = $n($as_Lcom_iz2use_common_Multiline($n(x3).s_Some__f_value)).Lcom_iz2use_common_Multiline__f_underlying;
    var $$x2 = $m_Lreactbuild_project_Page$();
    $m_Lreactbuild_project_Page$();
    var $$x1 = $m_Lreactbuild_project_PageSide$Any$();
    var u = $m_Lreactbuild_project_drawing_DrawingContext$().apply__Lreactbuild_common_model_Project__T__D__T2__s_Option__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(project, modelSource, 0.07559055118110236, new $c_T2$mcDD$sp(1000.0, 1000.0), ($m_Lreactbuild_project_drawing_DrawingContext$(), $m_s_None$()), new $c_sjsr_AnonFunction1(((ctx$2) => {
      var ctx = $as_Lreactbuild_project_drawing_BoxedDrawingContext(ctx$2);
      return $m_Lreactbuild_project_drawing_DrawBuilding$().apply__Lreactbuild_project_drawing_LOD__Lreactbuild_project_drawing_BoxedDrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode($m_Lreactbuild_project_drawing_LOD100$(), ctx)
    })));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    return $n($$x2).apply__Lreactbuild_project_PageSide__sci_Seq__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), new $c_Lsourcecode_FullName("reactbuild.project.Parcel.apply"), settings)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lreactbuild_project_Parcel$ = new $TypeData().initClass({
  Lreactbuild_project_Parcel$: 0
}, false, "reactbuild.project.Parcel$", {
  Lreactbuild_project_Parcel$: 1,
  O: 1
});
$c_Lreactbuild_project_Parcel$.prototype.$classData = $d_Lreactbuild_project_Parcel$;
var $n_Lreactbuild_project_Parcel$;
function $m_Lreactbuild_project_Parcel$() {
  if ((!$n_Lreactbuild_project_Parcel$)) {
    $n_Lreactbuild_project_Parcel$ = new $c_Lreactbuild_project_Parcel$()
  };
  return $n_Lreactbuild_project_Parcel$
}
/** @constructor */
function $c_Lreactbuild_project_PreviewDrawing$() {
  this.Lreactbuild_project_PreviewDrawing$__f_component = null;
  $n_Lreactbuild_project_PreviewDrawing$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$().double__D__F2(1.0E-4);
  this.Lreactbuild_project_PreviewDrawing$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("PreviewDrawing", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_project_PreviewDrawing$Props(p$2);
    return new $c_Lreactbuild_project_PreviewDrawing$State(0.02, false)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_PreviewDrawing$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_project_PreviewDrawing$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_project_PreviewDrawing$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_project_PreviewDrawing$Props__Lreactbuild_project_PreviewDrawing$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_project_PreviewDrawing$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_PreviewDrawing$.prototype = new $h_O();
$c_Lreactbuild_project_PreviewDrawing$.prototype.constructor = $c_Lreactbuild_project_PreviewDrawing$;
/** @constructor */
function $h_Lreactbuild_project_PreviewDrawing$() {
  /*<skip>*/
}
$h_Lreactbuild_project_PreviewDrawing$.prototype = $c_Lreactbuild_project_PreviewDrawing$.prototype;
$c_Lreactbuild_project_PreviewDrawing$.prototype.apply__Lreactbuild_common_model_Project__T__s_Option__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(project, modelSource, serverConnection) {
  var c = this.Lreactbuild_project_PreviewDrawing$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_PreviewDrawing$Props(project, modelSource, serverConnection);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_PreviewDrawing$ = new $TypeData().initClass({
  Lreactbuild_project_PreviewDrawing$: 0
}, false, "reactbuild.project.PreviewDrawing$", {
  Lreactbuild_project_PreviewDrawing$: 1,
  O: 1
});
$c_Lreactbuild_project_PreviewDrawing$.prototype.$classData = $d_Lreactbuild_project_PreviewDrawing$;
var $n_Lreactbuild_project_PreviewDrawing$;
function $m_Lreactbuild_project_PreviewDrawing$() {
  if ((!$n_Lreactbuild_project_PreviewDrawing$)) {
    $n_Lreactbuild_project_PreviewDrawing$ = new $c_Lreactbuild_project_PreviewDrawing$()
  };
  return $n_Lreactbuild_project_PreviewDrawing$
}
/** @constructor */
function $c_Lreactbuild_project_PriceMention$() {
  /*<skip>*/
}
$c_Lreactbuild_project_PriceMention$.prototype = new $h_O();
$c_Lreactbuild_project_PriceMention$.prototype.constructor = $c_Lreactbuild_project_PriceMention$;
/** @constructor */
function $h_Lreactbuild_project_PriceMention$() {
  /*<skip>*/
}
$h_Lreactbuild_project_PriceMention$.prototype = $c_Lreactbuild_project_PriceMention$.prototype;
$c_Lreactbuild_project_PriceMention$.prototype.apply__Lreactbuild_common_model_Project__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p) {
  var this$1 = $n(p);
  if ($n(this$1.Lreactbuild_common_model_Project__f_soldOut).contains__O__Z(true)) {
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$());
    var $$x2 = this$4.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("red", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x1 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 .5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$6 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontWeight__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$());
    var array = [$$x2, $$x1, this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("bold", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" D\u00e9j\u00e0 vendu "))];
    return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$12 = $n($n(p).Lreactbuild_common_model_Project__f_price);
    if (this$12.isEmpty__Z()) {
      var $$x4 = $m_s_None$()
    } else {
      var arg1 = this$12.get__O();
      var p$2 = $uD(arg1);
      var $$x5 = $m_sc_StringOps$();
      var array$1 = [p$2];
      var $$x4 = new $c_s_Some($n($$x5).format$extension__T__sci_Seq__T(" %.0f \u20ac ", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
    };
    var this$16 = $n($$x4);
    var v = $as_T((this$16.isEmpty__Z() ? " Contactez-nous " : this$16.get__O()));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
  }
});
var $d_Lreactbuild_project_PriceMention$ = new $TypeData().initClass({
  Lreactbuild_project_PriceMention$: 0
}, false, "reactbuild.project.PriceMention$", {
  Lreactbuild_project_PriceMention$: 1,
  O: 1
});
$c_Lreactbuild_project_PriceMention$.prototype.$classData = $d_Lreactbuild_project_PriceMention$;
var $n_Lreactbuild_project_PriceMention$;
function $m_Lreactbuild_project_PriceMention$() {
  if ((!$n_Lreactbuild_project_PriceMention$)) {
    $n_Lreactbuild_project_PriceMention$ = new $c_Lreactbuild_project_PriceMention$()
  };
  return $n_Lreactbuild_project_PriceMention$
}
/** @constructor */
function $c_Lreactbuild_project_ProjectDocument$() {
  /*<skip>*/
}
$c_Lreactbuild_project_ProjectDocument$.prototype = new $h_O();
$c_Lreactbuild_project_ProjectDocument$.prototype.constructor = $c_Lreactbuild_project_ProjectDocument$;
/** @constructor */
function $h_Lreactbuild_project_ProjectDocument$() {
  /*<skip>*/
}
$h_Lreactbuild_project_ProjectDocument$.prototype = $c_Lreactbuild_project_ProjectDocument$.prototype;
$c_Lreactbuild_project_ProjectDocument$.prototype.apply__Ldiode_data_Pot__Z__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomElement = (function(projectPot, includedInGlobal, settings) {
  if (includedInGlobal) {
    var this$58 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x14 = $m_Lreactbuild_project_Overview$().apply__Ldiode_data_Pot__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(projectPot, settings);
    var $$x13 = $m_Lreactbuild_project_Description$().apply__Ldiode_data_Pot__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(projectPot, settings);
    if ($n(projectPot).isFailed__Z()) {
      var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x10 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(projectPot).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [$$x10, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      var $$x9 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    } else {
      var this$11 = $n(projectPot);
      if ((!this$11.isEmpty__Z())) {
        var arg1 = $n(projectPot).get__O();
        var project = $as_Lreactbuild_common_model_Project(arg1);
        var $$x9 = $m_Lreactbuild_project_Parcel$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(project, settings)
      } else if ($n(projectPot).isPending__Z()) {
        var $$x9 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        var $$x9 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      }
    };
    if ($n(projectPot).isFailed__Z()) {
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(projectPot).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$2 = [$$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      var $$x5 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    } else {
      var this$29 = $n(projectPot);
      if ((!this$29.isEmpty__Z())) {
        var arg1$1 = $n(projectPot).get__O();
        var project$3 = $as_Lreactbuild_common_model_Project(arg1$1);
        var $$x5 = $m_Lreactbuild_project_TopView$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(project$3, settings)
      } else if ($n(projectPot).isPending__Z()) {
        var $$x5 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        var $$x5 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      }
    };
    if ($n(projectPot).isFailed__Z()) {
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$2 = $n(projectPot).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$4 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      var $$x1 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
    } else {
      var this$47 = $n(projectPot);
      if ((!this$47.isEmpty__Z())) {
        var arg1$2 = $n(projectPot).get__O();
        var project$4 = $as_Lreactbuild_common_model_Project(arg1$2);
        var $$x1 = $m_Lreactbuild_project_Facade$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf(project$4, settings)
      } else if ($n(projectPot).isPending__Z()) {
        var $$x1 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        var $$x1 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
      }
    };
    var array$6 = [$$x14, $$x13, $$x9, $$x5, $$x1];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$58, null, ns)
  } else {
    var this$152 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x36 = $m_Lreactbuild_project_Overview$().apply__Ldiode_data_Pot__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(projectPot, settings);
    if ($n(projectPot).isFailed__Z()) {
      var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x33 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$3 = $n(projectPot).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$7 = [$$x33, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
      var $$x32 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
    } else {
      var this$69 = $n(projectPot);
      if ((!this$69.isEmpty__Z())) {
        var arg1$3 = $n(projectPot).get__O();
        var project$5 = $as_Lreactbuild_common_model_Project(arg1$3);
        var $$x32 = $m_Lreactbuild_project_MapAndPOI$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf(project$5, settings)
      } else if ($n(projectPot).isPending__Z()) {
        var $$x32 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x35 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$8 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        var $$x32 = $n($$x35).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
      }
    };
    var $$x31 = $m_Lreactbuild_project_Description$().apply__Ldiode_data_Pot__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(projectPot, settings);
    if ($n(projectPot).isFailed__Z()) {
      var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x28 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$4 = $n(projectPot).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$9 = [$$x28, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
      var $$x27 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
    } else {
      var this$87 = $n(projectPot);
      if ((!this$87.isEmpty__Z())) {
        var arg1$4 = $n(projectPot).get__O();
        var project$6 = $as_Lreactbuild_common_model_Project(arg1$4);
        var $$x27 = $m_Lreactbuild_project_GlobalParcel$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf(project$6, settings)
      } else if ($n(projectPot).isPending__Z()) {
        var $$x27 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$10 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        var $$x27 = $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))
      }
    };
    if ($n(projectPot).isFailed__Z()) {
      var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x24 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$5 = $n(projectPot).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$11 = [$$x24, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
      var $$x23 = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
    } else {
      var this$105 = $n(projectPot);
      if ((!this$105.isEmpty__Z())) {
        var arg1$5 = $n(projectPot).get__O();
        var project$7 = $as_Lreactbuild_common_model_Project(arg1$5);
        var $$x23 = $m_Lreactbuild_project_Parcel$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(project$7, settings)
      } else if ($n(projectPot).isPending__Z()) {
        var $$x23 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$12 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        var $$x23 = $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))
      }
    };
    if ($n(projectPot).isFailed__Z()) {
      var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x20 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$6 = $n(projectPot).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$13 = [$$x20, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$6)];
      var $$x19 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))
    } else {
      var this$123 = $n(projectPot);
      if ((!this$123.isEmpty__Z())) {
        var arg1$6 = $n(projectPot).get__O();
        var project$8 = $as_Lreactbuild_common_model_Project(arg1$6);
        var $$x19 = $m_Lreactbuild_project_TopView$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode(project$8, settings)
      } else if ($n(projectPot).isPending__Z()) {
        var $$x19 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$14 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        var $$x19 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))
      }
    };
    if ($n(projectPot).isFailed__Z()) {
      var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x16 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$7 = $n(projectPot).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$15 = [$$x16, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)];
      var $$x15 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))
    } else {
      var this$141 = $n(projectPot);
      if ((!this$141.isEmpty__Z())) {
        var arg1$7 = $n(projectPot).get__O();
        var project$9 = $as_Lreactbuild_common_model_Project(arg1$7);
        var $$x15 = $m_Lreactbuild_project_Facade$().apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf(project$9, settings)
      } else if ($n(projectPot).isPending__Z()) {
        var $$x15 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$16 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        var $$x15 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))
      }
    };
    var array$17 = [$$x36, $$x32, $$x31, $$x27, $$x23, $$x19, $$x15];
    var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$152, null, ns$1)
  }
});
var $d_Lreactbuild_project_ProjectDocument$ = new $TypeData().initClass({
  Lreactbuild_project_ProjectDocument$: 0
}, false, "reactbuild.project.ProjectDocument$", {
  Lreactbuild_project_ProjectDocument$: 1,
  O: 1
});
$c_Lreactbuild_project_ProjectDocument$.prototype.$classData = $d_Lreactbuild_project_ProjectDocument$;
var $n_Lreactbuild_project_ProjectDocument$;
function $m_Lreactbuild_project_ProjectDocument$() {
  if ((!$n_Lreactbuild_project_ProjectDocument$)) {
    $n_Lreactbuild_project_ProjectDocument$ = new $c_Lreactbuild_project_ProjectDocument$()
  };
  return $n_Lreactbuild_project_ProjectDocument$
}
/** @constructor */
function $c_Lreactbuild_project_ProjectSkeleton$() {
  this.Lreactbuild_project_ProjectSkeleton$__f_title = null;
  this.Lreactbuild_project_ProjectSkeleton$__f_city = null;
  this.Lreactbuild_project_ProjectSkeleton$__f_topic = null;
  this.Lreactbuild_project_ProjectSkeleton$__f_reference = null;
  this.Lreactbuild_project_ProjectSkeleton$__f_description = null;
  $n_Lreactbuild_project_ProjectSkeleton$ = this;
  this.Lreactbuild_project_ProjectSkeleton$__f_title = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(40);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(30);
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
  var u$1 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(40);
  var this$9 = $n(u$1);
  var n$1 = this$9.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [$$x2, $$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  this.Lreactbuild_project_ProjectSkeleton$__f_city = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u$2 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(50);
  var this$17 = $n(u$2);
  var n$2 = this$17.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
  this.Lreactbuild_project_ProjectSkeleton$__f_topic = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u$3 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(12);
  var this$25 = $n(u$3);
  var n$3 = this$25.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)];
  this.Lreactbuild_project_ProjectSkeleton$__f_reference = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x6 = $m_Lcom_iz2use_react_components_Skeleton$();
  var u$4 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(80);
  var this$31 = $n(u$4);
  var n$4 = this$31.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4)];
  this.Lreactbuild_project_ProjectSkeleton$__f_description = $n($$x6).list__I__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(20, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
}
$c_Lreactbuild_project_ProjectSkeleton$.prototype = new $h_O();
$c_Lreactbuild_project_ProjectSkeleton$.prototype.constructor = $c_Lreactbuild_project_ProjectSkeleton$;
/** @constructor */
function $h_Lreactbuild_project_ProjectSkeleton$() {
  /*<skip>*/
}
$h_Lreactbuild_project_ProjectSkeleton$.prototype = $c_Lreactbuild_project_ProjectSkeleton$.prototype;
var $d_Lreactbuild_project_ProjectSkeleton$ = new $TypeData().initClass({
  Lreactbuild_project_ProjectSkeleton$: 0
}, false, "reactbuild.project.ProjectSkeleton$", {
  Lreactbuild_project_ProjectSkeleton$: 1,
  O: 1
});
$c_Lreactbuild_project_ProjectSkeleton$.prototype.$classData = $d_Lreactbuild_project_ProjectSkeleton$;
var $n_Lreactbuild_project_ProjectSkeleton$;
function $m_Lreactbuild_project_ProjectSkeleton$() {
  if ((!$n_Lreactbuild_project_ProjectSkeleton$)) {
    $n_Lreactbuild_project_ProjectSkeleton$ = new $c_Lreactbuild_project_ProjectSkeleton$()
  };
  return $n_Lreactbuild_project_ProjectSkeleton$
}
/** @constructor */
function $c_Lreactbuild_project_RenderProcedureState$() {
  this.Lreactbuild_project_RenderProcedureState$__f_component = null;
  $n_Lreactbuild_project_RenderProcedureState$ = this;
  var this$90 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f$4 = new $c_sjsr_AnonFunction1(((projects$2) => {
    var projects = $as_sci_List(projects$2);
    var this$3 = $n(projects);
    var rest = this$3;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var project = $as_Lreactbuild_common_model_Project(arg1);
      $n($m_s_package$().s_package$__f_List);
      var coll = $n(project).Lreactbuild_common_model_Project__f_procedureState;
      var this$5 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(coll));
      var rest$1 = this$5;
      var h$1 = null;
      var t$1 = null;
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest$1).head__O();
        var state = $n($as_Lcom_iz2use_common_Multiline(arg1$1)).Lcom_iz2use_common_Multiline__f_underlying;
        var $$x10 = $m_s_Predef$();
        $m_sc_ArrayOps$();
        var this$6 = $n(state);
        var xs = $f_T__split__T__I__AT(this$6, "\n", 0);
        var f = ((project) => ((line$2) => {
          var line = $as_T(line$2);
          $m_sc_ArrayOps$();
          var this$8 = $n(line);
          var xs$1 = $f_T__split__T__I__AT(this$8, "\\s*\\|\\s*", 0);
          var x = $n(project).Lreactbuild_common_model_Project__f_reference;
          var len = ((1 + $n(xs$1).u.length) | 0);
          var dest = new ($d_T.getArrayOf().constr)(len);
          dest.set(0, x);
          $m_s_Array$().copy__O__I__O__I__I__V(xs$1, 0, dest, 1, $n(xs$1).u.length);
          return dest
        }))(project);
        var len$1 = $n(xs).u.length;
        var ys = new ($d_T.getArrayOf().getArrayOf().constr)(len$1);
        if ((len$1 > 0)) {
          var i = 0;
          if ((xs !== null)) {
            while ((i < len$1)) {
              var $$x1 = i;
              var arg1$2 = $n(xs).get(i);
              ys.set($$x1, f(arg1$2));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_I)) {
            var x3 = $asArrayOf_I(xs, 1);
            while ((i < len$1)) {
              var $$x2 = i;
              var arg1$3 = $n(x3).get(i);
              ys.set($$x2, f(arg1$3));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_D)) {
            var x4 = $asArrayOf_D(xs, 1);
            while ((i < len$1)) {
              var $$x3 = i;
              var arg1$4 = $n(x4).get(i);
              ys.set($$x3, f(arg1$4));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_J)) {
            var x5 = $asArrayOf_J(xs, 1);
            while ((i < len$1)) {
              var $$x4 = i;
              var t$2 = $n(x5).get(i);
              var lo = t$2.RTLong__f_lo;
              var hi = t$2.RTLong__f_hi;
              ys.set($$x4, f(new $c_RTLong(lo, hi)));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_F)) {
            var x6 = $asArrayOf_F(xs, 1);
            while ((i < len$1)) {
              var $$x5 = i;
              var arg1$5 = $n(x6).get(i);
              ys.set($$x5, f(arg1$5));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_C)) {
            var x7 = $asArrayOf_C(xs, 1);
            while ((i < len$1)) {
              var $$x6 = i;
              var arg1$6 = $n(x7).get(i);
              ys.set($$x6, f($bC(arg1$6)));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_B)) {
            var x8 = $asArrayOf_B(xs, 1);
            while ((i < len$1)) {
              var $$x7 = i;
              var arg1$7 = $n(x8).get(i);
              ys.set($$x7, f(arg1$7));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_S)) {
            var x9 = $asArrayOf_S(xs, 1);
            while ((i < len$1)) {
              var $$x8 = i;
              var arg1$8 = $n(x9).get(i);
              ys.set($$x8, f(arg1$8));
              i = ((1 + i) | 0)
            }
          } else if ((xs instanceof $ac_Z)) {
            var x10 = $asArrayOf_Z(xs, 1);
            while ((i < len$1)) {
              var $$x9 = i;
              var arg1$9 = $n(x10).get(i);
              ys.set($$x9, f(arg1$9));
              i = ((1 + i) | 0)
            }
          } else {
            throw new $c_s_MatchError(xs)
          }
        };
        var this$16 = $n($n($$x10).wrapRefArray__AO__scm_ArraySeq$ofRef(ys));
        var it = $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this$16.scm_ArraySeq$ofRef__f_array);
        while (it.hasNext__Z()) {
          var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
          if ((t$1 === null)) {
            h$1 = nx
          } else {
            $n(t$1).sci_$colon$colon__f_next = nx
          };
          t$1 = nx
        };
        rest$1 = $as_sci_List($n(rest$1).tail__O())
      };
      var it$1 = $n(((h$1 === null) ? $m_sci_Nil$() : h$1)).iterator__sc_Iterator();
      while ($n(it$1).hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon($n(it$1).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx$1
        } else {
          $n(t).sci_$colon$colon__f_next = nx$1
        };
        t = nx$1
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    var splitted = ((h === null) ? $m_sci_Nil$() : h);
    var this$17 = $n(splitted);
    var m = $as_scm_Map($m_scm_Map$().empty__O());
    var it$2 = this$17.iterator__sc_Iterator();
    while ($n(it$2).hasNext__Z()) {
      var elem = $n(it$2).next__O();
      var x$6 = $asArrayOf_T(elem, 1);
      var key = $n(x$6).get(1);
      var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => {
        $m_sci_List$();
        return new $c_scm_ListBuffer()
      }))));
      var this$19 = $n(bldr);
      this$19.addOne__O__scm_Growable(elem)
    };
    var this$20 = $m_sci_HashMap$();
    var result = this$20.sci_HashMap$__f_EmptyMap;
    var mapIt = $n(m).iterator__sc_Iterator();
    while ($n(mapIt).hasNext__Z()) {
      var x1 = $as_T2($n(mapIt).next__O());
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1)
      };
      var k = $n(x1)._1__O();
      var v = $as_scm_Builder($n(x1)._2__O());
      result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
    };
    var this$21 = $n(result);
    $m_sci_List$();
    var this$24 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$21));
    var f$2 = ((v$2) => {
      var v$1 = $as_T2(v$2);
      var $$x11 = $n(v$1)._1__O();
      var this$23 = $n($as_sc_SeqOps($n(v$1)._2__O()));
      var f$1 = new $c_sjsr_AnonFunction1(((x$7$2) => {
        var x$7 = $asArrayOf_T(x$7$2, 1);
        return $n(x$7).get(0)
      }));
      var ord = $m_s_math_Ordering$String$();
      return $ct_T2__O__O__(new $c_T2(), $$x11, $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$23, f$1, ord))
    });
    if ((this$24 === $m_sci_Nil$())) {
      var $$x12 = $m_sci_Nil$()
    } else {
      var arg1$10 = this$24.head__O();
      var h$2 = new $c_sci_$colon$colon(f$2(arg1$10), $m_sci_Nil$());
      var t$3 = h$2;
      var rest$2 = $as_sci_List(this$24.tail__O());
      while ((rest$2 !== $m_sci_Nil$())) {
        var arg1$11 = $n(rest$2).head__O();
        var nx$2 = new $c_sci_$colon$colon(f$2(arg1$11), $m_sci_Nil$());
        $n(t$3).sci_$colon$colon__f_next = nx$2;
        t$3 = nx$2;
        rest$2 = $as_sci_List($n(rest$2).tail__O())
      };
      var $$x12 = h$2
    };
    var this$25 = $n($$x12);
    var f$3 = new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_T2(x$8$2);
      return $as_T($n(x$8)._1__O())
    }));
    var ord$1 = $m_s_math_Ordering$String$();
    var grouped = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$25, f$3, ord$1));
    var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$28 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reportTable;
    var array$8 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$28, s), $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), grouped), new $c_sjsr_AnonFunction1(((group$2) => {
      var group = $as_T2(group$2);
      var this$85 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$38 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
      var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
      var $$x21 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$38.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 4);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$3 = $as_T($n(group)._1__O());
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [$$x21, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
      var array$1 = [$n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
      var array$2 = [$n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
      var $$x20 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x13 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as = $as_sc_IterableOnce($n(group)._2__O());
      var array$6 = [$n($$x13).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((line$2$1) => {
        var line$1 = $asArrayOf_T(line$2$1, 1);
        var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$3 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
        var $$x15 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
        var $$x14 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_sc_ArrayOps$();
        var other = $m_s_package$().s_package$__f_Nil;
        var capacity = 0;
        var jsElems = null;
        capacity = 0;
        jsElems = [];
        $n(other);
        var k$1 = 0;
        if ((k$1 >= 0)) {
          $n(line$1)
        };
        var b = $n(line$1).u.length;
        var chunk1 = ((b > 1) ? 1 : b);
        if ((chunk1 > 0)) {
          var i$1 = 0;
          while ((i$1 < chunk1)) {
            var x1$1 = i$1;
            var elem$1 = $n(line$1).get(x1$1);
            var unboxedElem = ((elem$1 === null) ? null : elem$1);
            jsElems.push(unboxedElem);
            i$1 = ((1 + i$1) | 0)
          }
        };
        $n(other);
        var it$3 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
        while ($n(it$3).hasNext__Z()) {
          var elem$2 = $n(it$3).next__O();
          var unboxedElem$1 = ((elem$2 === null) ? null : elem$2);
          jsElems.push(unboxedElem$1)
        };
        var remaining = (((-1) + (($n(line$1).u.length - chunk1) | 0)) | 0);
        if ((remaining > 0)) {
          var offset = (($n(line$1).u.length - remaining) | 0);
          var end = ((offset + remaining) | 0);
          var i$2 = offset;
          while ((i$2 < end)) {
            var x1$2 = i$2;
            var elem$3 = $n(line$1).get(x1$2);
            var unboxedElem$2 = ((elem$3 === null) ? null : elem$3);
            jsElems.push(unboxedElem$2);
            i$2 = ((1 + i$2) | 0)
          }
        };
        var as$1 = new ($d_T.getArrayOf().constr)(jsElems);
        var array$5 = [$$x15, $n($$x14).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod($m_s_Predef$().genericWrapArray__O__scm_ArraySeq(as$1), new $c_sjsr_AnonFunction1(((v$2$1) => {
          var v$4 = $as_T(v$2$1);
          var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4))];
          return $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
        })))];
        return $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
      })))];
      var array$7 = [$$x20, $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
      var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
      return this$85.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
    })))];
    return $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  }));
  var s$1 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f$4, s$1);
  this.Lreactbuild_project_RenderProcedureState$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$90, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.RenderProcedureState.component"))
}
$c_Lreactbuild_project_RenderProcedureState$.prototype = new $h_O();
$c_Lreactbuild_project_RenderProcedureState$.prototype.constructor = $c_Lreactbuild_project_RenderProcedureState$;
/** @constructor */
function $h_Lreactbuild_project_RenderProcedureState$() {
  /*<skip>*/
}
$h_Lreactbuild_project_RenderProcedureState$.prototype = $c_Lreactbuild_project_RenderProcedureState$.prototype;
$c_Lreactbuild_project_RenderProcedureState$.prototype.apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(projects) {
  var c = this.Lreactbuild_project_RenderProcedureState$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(projects, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_RenderProcedureState$ = new $TypeData().initClass({
  Lreactbuild_project_RenderProcedureState$: 0
}, false, "reactbuild.project.RenderProcedureState$", {
  Lreactbuild_project_RenderProcedureState$: 1,
  O: 1
});
$c_Lreactbuild_project_RenderProcedureState$.prototype.$classData = $d_Lreactbuild_project_RenderProcedureState$;
var $n_Lreactbuild_project_RenderProcedureState$;
function $m_Lreactbuild_project_RenderProcedureState$() {
  if ((!$n_Lreactbuild_project_RenderProcedureState$)) {
    $n_Lreactbuild_project_RenderProcedureState$ = new $c_Lreactbuild_project_RenderProcedureState$()
  };
  return $n_Lreactbuild_project_RenderProcedureState$
}
function $is_Lreactbuild_project_ResourceUsage(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_ResourceUsage)))
}
function $as_Lreactbuild_project_ResourceUsage(obj) {
  return (($is_Lreactbuild_project_ResourceUsage(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.ResourceUsage"))
}
function $isArrayOf_Lreactbuild_project_ResourceUsage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_ResourceUsage)))
}
function $asArrayOf_Lreactbuild_project_ResourceUsage(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_ResourceUsage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.ResourceUsage;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_ResourceUsage$() {
  this.Lreactbuild_project_ResourceUsage$__f_codecForResourceUsage = null;
  $n_Lreactbuild_project_ResourceUsage$ = this;
  var inst$macro$268 = new $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$268));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_project_ResourceUsage$__f_codecForResourceUsage = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_project_ResourceUsage$.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsage$.prototype.constructor = $c_Lreactbuild_project_ResourceUsage$;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsage$() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsage$.prototype = $c_Lreactbuild_project_ResourceUsage$.prototype;
var $d_Lreactbuild_project_ResourceUsage$ = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsage$: 0
}, false, "reactbuild.project.ResourceUsage$", {
  Lreactbuild_project_ResourceUsage$: 1,
  O: 1
});
$c_Lreactbuild_project_ResourceUsage$.prototype.$classData = $d_Lreactbuild_project_ResourceUsage$;
var $n_Lreactbuild_project_ResourceUsage$;
function $m_Lreactbuild_project_ResourceUsage$() {
  if ((!$n_Lreactbuild_project_ResourceUsage$)) {
    $n_Lreactbuild_project_ResourceUsage$ = new $c_Lreactbuild_project_ResourceUsage$()
  };
  return $n_Lreactbuild_project_ResourceUsage$
}
function $is_Lreactbuild_project_ResourceUsageClause(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_ResourceUsageClause)))
}
function $as_Lreactbuild_project_ResourceUsageClause(obj) {
  return (($is_Lreactbuild_project_ResourceUsageClause(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.ResourceUsageClause"))
}
function $isArrayOf_Lreactbuild_project_ResourceUsageClause(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_ResourceUsageClause)))
}
function $asArrayOf_Lreactbuild_project_ResourceUsageClause(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_ResourceUsageClause(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.ResourceUsageClause;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_ResourceUsageClause$() {
  this.Lreactbuild_project_ResourceUsageClause$__f_codecForResourceUsageClause = null;
  $n_Lreactbuild_project_ResourceUsageClause$ = this;
  var inst$macro$44 = new $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_project_ResourceUsageClause$__f_codecForResourceUsageClause = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_project_ResourceUsageClause$.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsageClause$.prototype.constructor = $c_Lreactbuild_project_ResourceUsageClause$;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsageClause$() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsageClause$.prototype = $c_Lreactbuild_project_ResourceUsageClause$.prototype;
var $d_Lreactbuild_project_ResourceUsageClause$ = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsageClause$: 0
}, false, "reactbuild.project.ResourceUsageClause$", {
  Lreactbuild_project_ResourceUsageClause$: 1,
  O: 1
});
$c_Lreactbuild_project_ResourceUsageClause$.prototype.$classData = $d_Lreactbuild_project_ResourceUsageClause$;
var $n_Lreactbuild_project_ResourceUsageClause$;
function $m_Lreactbuild_project_ResourceUsageClause$() {
  if ((!$n_Lreactbuild_project_ResourceUsageClause$)) {
    $n_Lreactbuild_project_ResourceUsageClause$ = new $c_Lreactbuild_project_ResourceUsageClause$()
  };
  return $n_Lreactbuild_project_ResourceUsageClause$
}
function $p_Lreactbuild_project_RichContent$__loop$1__sci_List__Lreactbuild_project_RichContent$State__sci_List($thiz, lines, state) {
  while (true) {
    var rc11 = false;
    var x3 = null;
    var x1 = lines;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var this$1 = $n(state);
      return this$1.closeStack__sci_List()
    };
    if ((x1 instanceof $c_sci_$colon$colon)) {
      rc11 = true;
      x3 = $as_sci_$colon$colon(x1);
      var p4 = $as_T($n(x3).sci_$colon$colon__f_head);
      var rest = $n(x3).sci_$colon$colon__f_next;
      if ((p4 === "")) {
        var temp$state = $n(state).newStack__Lreactbuild_project_RichContent$Block__Lreactbuild_project_RichContent$State(new $c_Lreactbuild_project_RichContent$Paragraph($m_s_package$().s_package$__f_Nil));
        lines = rest;
        state = temp$state;
        continue
      }
    };
    if (rc11) {
      var p7 = $as_T($n(x3).sci_$colon$colon__f_head);
      var rest$2 = $n(x3).sci_$colon$colon__f_next;
      if ((p7 !== null)) {
        var o17 = $n($thiz.Lreactbuild_project_RichContent$__f_unorderedListPrefix).unapplySeq__jl_CharSequence__s_Option(p7);
        if (((!$n(o17).isEmpty__Z()) && (($n(o17).get__O() !== null) && ($n($as_sci_List($n(o17).get__O())).lengthCompare__I__I(1) === 0)))) {
          var content = $as_T($n($as_sc_LinearSeqOps($n(o17).get__O())).apply__I__O(0));
          var line = $m_Lreactbuild_project_RichContent$Line$().apply__T__Lreactbuild_project_RichContent$Line(content);
          var this$3 = $n(state);
          var this$5 = $n(this$3.Lreactbuild_project_RichContent$State__f_stack);
          var this$4 = $m_s_$less$colon$less$();
          var ev = this$4.s_$less$colon$less$__f_singleton;
          var arg1 = (this$5.isEmpty__Z() ? ($n(ev), null) : this$5.get__O());
          var x0$1 = $as_Lreactbuild_project_RichContent$Block(arg1);
          if ((x0$1 instanceof $c_Lreactbuild_project_RichContent$UnorderedList)) {
            var x2 = $as_Lreactbuild_project_RichContent$UnorderedList(x0$1);
            var x1$1 = new $c_s_util_Right($n(x2).push__Lreactbuild_project_RichContent$Line__Lreactbuild_project_RichContent$UnorderedList(line))
          } else {
            var this$7 = $n($m_s_package$().s_package$__f_Nil);
            var x1$1 = new $c_s_util_Left(new $c_Lreactbuild_project_RichContent$UnorderedList(new $c_sci_$colon$colon(line, this$7)))
          };
          if ((x1$1 instanceof $c_s_util_Left)) {
            var x2$1 = $as_s_util_Left(x1$1);
            var v = $as_Lreactbuild_project_RichContent$Block($n(x2$1).s_util_Left__f_value);
            var temp$state$2 = this$3.newStack__Lreactbuild_project_RichContent$Block__Lreactbuild_project_RichContent$State(v)
          } else {
            if ((!(x1$1 instanceof $c_s_util_Right))) {
              throw new $c_s_MatchError(x1$1)
            };
            var x3$1 = $as_s_util_Right(x1$1);
            var v$2 = $as_Lreactbuild_project_RichContent$Block($n(x3$1).s_util_Right__f_value);
            var temp$state$2 = this$3.updateStack__Lreactbuild_project_RichContent$Block__Lreactbuild_project_RichContent$State(v$2)
          };
          lines = rest$2;
          state = temp$state$2;
          continue
        }
      }
    };
    if (rc11) {
      var text = $as_T($n(x3).sci_$colon$colon__f_head);
      var rest$3 = $n(x3).sci_$colon$colon__f_next;
      var line$2 = $m_Lreactbuild_project_RichContent$Line$().apply__T__Lreactbuild_project_RichContent$Line(text);
      var this$8 = $n(state);
      var this$10 = $n(this$8.Lreactbuild_project_RichContent$State__f_stack);
      var this$9 = $m_s_$less$colon$less$();
      var ev$1 = this$9.s_$less$colon$less$__f_singleton;
      var arg1$1 = (this$10.isEmpty__Z() ? ($n(ev$1), null) : this$10.get__O());
      var x0$2 = $as_Lreactbuild_project_RichContent$Block(arg1$1);
      if ((x0$2 instanceof $c_Lreactbuild_project_RichContent$Paragraph)) {
        var x2$2 = $as_Lreactbuild_project_RichContent$Paragraph(x0$2);
        var x1$2 = new $c_s_util_Right($n(x2$2).push__Lreactbuild_project_RichContent$Line__Lreactbuild_project_RichContent$Paragraph(line$2))
      } else {
        var this$12 = $n($m_s_package$().s_package$__f_Nil);
        var x1$2 = new $c_s_util_Left(new $c_Lreactbuild_project_RichContent$Paragraph(new $c_sci_$colon$colon(line$2, this$12)))
      };
      if ((x1$2 instanceof $c_s_util_Left)) {
        var x2$3 = $as_s_util_Left(x1$2);
        var v$1 = $as_Lreactbuild_project_RichContent$Block($n(x2$3).s_util_Left__f_value);
        var temp$state$3 = this$8.newStack__Lreactbuild_project_RichContent$Block__Lreactbuild_project_RichContent$State(v$1)
      } else {
        if ((!(x1$2 instanceof $c_s_util_Right))) {
          throw new $c_s_MatchError(x1$2)
        };
        var x3$2 = $as_s_util_Right(x1$2);
        var v$2$1 = $as_Lreactbuild_project_RichContent$Block($n(x3$2).s_util_Right__f_value);
        var temp$state$3 = this$8.updateStack__Lreactbuild_project_RichContent$Block__Lreactbuild_project_RichContent$State(v$2$1)
      };
      lines = rest$3;
      state = temp$state$3;
      continue
    };
    throw new $c_s_MatchError(x1)
  }
}
/** @constructor */
function $c_Lreactbuild_project_RichContent$() {
  this.Lreactbuild_project_RichContent$__f_imagePrefix = null;
  this.Lreactbuild_project_RichContent$__f_unorderedListPrefix = null;
  this.Lreactbuild_project_RichContent$__f_component = null;
  $n_Lreactbuild_project_RichContent$ = this;
  this.Lreactbuild_project_RichContent$__f_imagePrefix = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^img(-[^:]+)?:(data:.*|[./].*)$", $m_sci_Nil$()));
  this.Lreactbuild_project_RichContent$__f_unorderedListPrefix = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^\\* (.*)$", $m_sci_Nil$()));
  this.Lreactbuild_project_RichContent$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var $$x1 = $m_Lreactbuild_project_RichContent$();
    var this$9 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($m_sc_StringOps$().split$extension__T__C__AT(s, 10)));
    $m_sci_List$();
    var as = $n($$x1).parseLines__sci_List__sci_List($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$9));
    var this$13 = $m_s_$less$colon$less$();
    var array = [$n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$13.s_$less$colon$less$__f_singleton)];
    return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_RichContent$.prototype = new $h_O();
$c_Lreactbuild_project_RichContent$.prototype.constructor = $c_Lreactbuild_project_RichContent$;
/** @constructor */
function $h_Lreactbuild_project_RichContent$() {
  /*<skip>*/
}
$h_Lreactbuild_project_RichContent$.prototype = $c_Lreactbuild_project_RichContent$.prototype;
$c_Lreactbuild_project_RichContent$.prototype.parseLines__sci_List__sci_List = (function(lines) {
  return $p_Lreactbuild_project_RichContent$__loop$1__sci_List__Lreactbuild_project_RichContent$State__sci_List(this, lines, new $c_Lreactbuild_project_RichContent$State($m_s_package$().s_package$__f_Nil, $m_s_None$()))
});
$c_Lreactbuild_project_RichContent$.prototype.apply__T__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(props) {
  var c = this.Lreactbuild_project_RichContent$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_RichContent$ = new $TypeData().initClass({
  Lreactbuild_project_RichContent$: 0
}, false, "reactbuild.project.RichContent$", {
  Lreactbuild_project_RichContent$: 1,
  O: 1
});
$c_Lreactbuild_project_RichContent$.prototype.$classData = $d_Lreactbuild_project_RichContent$;
var $n_Lreactbuild_project_RichContent$;
function $m_Lreactbuild_project_RichContent$() {
  if ((!$n_Lreactbuild_project_RichContent$)) {
    $n_Lreactbuild_project_RichContent$ = new $c_Lreactbuild_project_RichContent$()
  };
  return $n_Lreactbuild_project_RichContent$
}
function $is_Lreactbuild_project_Selection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_Selection)))
}
function $as_Lreactbuild_project_Selection(obj) {
  return (($is_Lreactbuild_project_Selection(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.Selection"))
}
function $isArrayOf_Lreactbuild_project_Selection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_Selection)))
}
function $asArrayOf_Lreactbuild_project_Selection(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_Selection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.Selection;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_Selection$() {
  /*<skip>*/
}
$c_Lreactbuild_project_Selection$.prototype = new $h_O();
$c_Lreactbuild_project_Selection$.prototype.constructor = $c_Lreactbuild_project_Selection$;
/** @constructor */
function $h_Lreactbuild_project_Selection$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$.prototype = $c_Lreactbuild_project_Selection$.prototype;
$c_Lreactbuild_project_Selection$.prototype.decodeSelection__Lio_circe_Decoder__Lio_circe_Decoder = (function(decode0) {
  var inst$macro$17 = new $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1(decode0).inst$macro$1__Lio_circe_generic_extras_decoding_ConfiguredDecoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$17));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t);
  return $as_Lio_circe_Decoder(decode.value__O())
});
$c_Lreactbuild_project_Selection$.prototype.encodeSelection__Lio_circe_Encoder__Lio_circe_Encoder$AsObject = (function(encode0) {
  var inst$macro$34 = new $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1(encode0).inst$macro$18__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$34));
  var encode = new $c_Lshapeless_Lazy$$anon$1(t);
  return $as_Lio_circe_Encoder$AsObject(encode.value__O())
});
var $d_Lreactbuild_project_Selection$ = new $TypeData().initClass({
  Lreactbuild_project_Selection$: 0
}, false, "reactbuild.project.Selection$", {
  Lreactbuild_project_Selection$: 1,
  O: 1
});
$c_Lreactbuild_project_Selection$.prototype.$classData = $d_Lreactbuild_project_Selection$;
var $n_Lreactbuild_project_Selection$;
function $m_Lreactbuild_project_Selection$() {
  if ((!$n_Lreactbuild_project_Selection$)) {
    $n_Lreactbuild_project_Selection$ = new $c_Lreactbuild_project_Selection$()
  };
  return $n_Lreactbuild_project_Selection$
}
/** @constructor */
function $c_Lreactbuild_project_ShowProjectAddress$() {
  this.Lreactbuild_project_ShowProjectAddress$__f_skeleton = null;
  this.Lreactbuild_project_ShowProjectAddress$__f_component = null;
  $n_Lreactbuild_project_ShowProjectAddress$ = this;
  this.Lreactbuild_project_ShowProjectAddress$__f_skeleton = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(40);
  var this$64 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f$1 = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_project_ShowProjectAddress$Props(x0$1$2);
    if ((x0$1 !== null)) {
      var project = $n(x0$1).Lreactbuild_project_ShowProjectAddress$Props__f_project;
      var f = $n(x0$1).Lreactbuild_project_ShowProjectAddress$Props__f_f;
      var x1$2 = $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_address;
      matchEnd13: {
        var more;
        if ((x1$2 !== null)) {
          var p5 = $n(x1$2).Lreactbuild_common_model_ProjectAddress__f_coordinates;
          if ((p5 instanceof $c_s_Some)) {
            var x6 = $as_s_Some(p5);
            var coordinates = $as_Lreactbuild_common_model_Coordinates($n(x6).s_Some__f_value);
            var more = $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f).apply__O__O__O($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().modelToCoordinates__Lreactbuild_common_model_Coordinates__sjs_js_Array(coordinates), "Afficher sur la carte"));
            break matchEnd13
          }
        };
        if ((x1$2 !== null)) {
          var p8 = $n(x1$2).Lreactbuild_common_model_ProjectAddress__f_raw;
          if ((p8 instanceof $c_s_Some)) {
            var x11 = $as_s_Some(p8);
            var rawAddress = $as_T($n(x11).s_Some__f_value);
            var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Afficher sur la carte"))];
            $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
            var x1$3 = $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().apply__T__Lfastparse_Parsed(rawAddress);
            if ((x1$3 instanceof $c_Lfastparse_Parsed$Success)) {
              var x2 = $as_Lfastparse_Parsed$Success(x1$3);
              var r = $as_s_Product($n(x2).Lfastparse_Parsed$Success__f_value);
              var result = r
            } else {
              if ((!(x1$3 instanceof $c_Lfastparse_Parsed$Failure))) {
                throw new $c_s_MatchError(x1$3)
              };
              var x4 = $as_Lfastparse_Parsed$Failure(x1$3);
              var result = new $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other(rawAddress, x4)
            };
            var u = $m_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$().apply__Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery__F2__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery(result), f);
            var this$11 = $n(u);
            var n = this$11.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
            var more = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
            break matchEnd13
          }
        };
        var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Renseigner d'abord une adresse avant de pouvoir afficher sur la carte"))];
        var more = $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      };
      var this$62 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Adresse");
      var this$48 = $n(project);
      var g = new $c_sjsr_AnonFunction1(((v$2) => {
        var v = $as_s_Option(v$2);
        return new $c_sjsr_AnonFunction1(((s$2) => {
          var s = $as_Lreactbuild_common_model_Project(s$2);
          var x$2 = $m_s_None$();
          var this$22 = $n($n(s).Lreactbuild_common_model_Project__f_address);
          var x$3 = this$22.Lreactbuild_common_model_ProjectAddress__f_country;
          var this$23 = $n($n(s).Lreactbuild_common_model_Project__f_address);
          var x$4 = this$23.Lreactbuild_common_model_ProjectAddress__f_parcels;
          $n($n(s).Lreactbuild_common_model_Project__f_address);
          var x$5 = new $c_Lreactbuild_common_model_ProjectAddress(x$3, v, x$4, x$2);
          var this$25 = $n(s);
          var x$6 = this$25.Lreactbuild_common_model_Project__f__id;
          var this$26 = $n(s);
          var x$7 = this$26.Lreactbuild_common_model_Project__f_organizations;
          var this$27 = $n(s);
          var x$8 = this$27.Lreactbuild_common_model_Project__f_name;
          var this$28 = $n(s);
          var x$9 = this$28.Lreactbuild_common_model_Project__f_title;
          var this$29 = $n(s);
          var x$10 = this$29.Lreactbuild_common_model_Project__f_description;
          var this$30 = $n(s);
          var x$11 = this$30.Lreactbuild_common_model_Project__f_images;
          var this$31 = $n(s);
          var x$12 = this$31.Lreactbuild_common_model_Project__f_location;
          var this$32 = $n(s);
          var x$13 = this$32.Lreactbuild_common_model_Project__f_areas;
          var this$33 = $n(s);
          var x$14 = this$33.Lreactbuild_common_model_Project__f_price;
          var this$34 = $n(s);
          var x$15 = this$34.Lreactbuild_common_model_Project__f_soldOut;
          var this$35 = $n(s);
          var x$16 = this$35.Lreactbuild_common_model_Project__f_privacy;
          var this$36 = $n(s);
          var x$17 = this$36.Lreactbuild_common_model_Project__f_scenes;
          var this$37 = $n(s);
          var x$18 = this$37.Lreactbuild_common_model_Project__f_renderSettings;
          var this$38 = $n(s);
          var x$19 = this$38.Lreactbuild_common_model_Project__f_city;
          var this$39 = $n(s);
          var x$20 = this$39.Lreactbuild_common_model_Project__f_district;
          var this$40 = $n(s);
          var x$21 = this$40.Lreactbuild_common_model_Project__f_topic;
          var this$41 = $n(s);
          var x$22 = this$41.Lreactbuild_common_model_Project__f_modelSource;
          var this$42 = $n(s);
          var x$23 = this$42.Lreactbuild_common_model_Project__f_procedureState;
          var this$43 = $n(s);
          var x$24 = this$43.Lreactbuild_common_model_Project__f_summary;
          var this$44 = $n(s);
          var x$25 = this$44.Lreactbuild_common_model_Project__f_archived;
          var this$45 = $n(s);
          var x$26 = this$45.Lreactbuild_common_model_Project__f_parent;
          var this$46 = $n(s);
          var x$27 = this$46.Lreactbuild_common_model_Project__f_reference;
          $n(s);
          return new $c_Lreactbuild_common_model_Project(x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$5, x$27)
        }))
      }));
      var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$48.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
      var arg1 = this$48.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var x$9$1 = $as_Lreactbuild_common_model_Project(arg1);
      var state = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$48, $n($n(x$9$1).Lreactbuild_common_model_Project__f_address).Lreactbuild_common_model_ProjectAddress__f_raw, new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
        var ot = $as_s_Option(ot$2);
        var $$x3 = $n($as_F2($n(this$48.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
        var this$49 = $n(ot);
        return $n($$x3).apply__O__O__O((this$49.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$49.get__O()))), cb$2)
      })));
      var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
      $m_Lcom_iz2use_common_Parsable$();
      var ev = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev);
      var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$54 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$54);
      var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
      var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var eqv = $m_s_math_Equiv$String$();
      var equiv = new $c_s_math_Equiv$OptionEquiv(eqv);
      var array$2 = [editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$1, explainError, equiv), more];
      var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$62, null, ns)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  var s$1 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$2 = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f$1, s$1);
  this.Lreactbuild_project_ShowProjectAddress$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$64, ev$2).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.ShowProjectAddress.component"))
}
$c_Lreactbuild_project_ShowProjectAddress$.prototype = new $h_O();
$c_Lreactbuild_project_ShowProjectAddress$.prototype.constructor = $c_Lreactbuild_project_ShowProjectAddress$;
/** @constructor */
function $h_Lreactbuild_project_ShowProjectAddress$() {
  /*<skip>*/
}
$h_Lreactbuild_project_ShowProjectAddress$.prototype = $c_Lreactbuild_project_ShowProjectAddress$.prototype;
$c_Lreactbuild_project_ShowProjectAddress$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(project, f) {
  var c = this.Lreactbuild_project_ShowProjectAddress$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_ShowProjectAddress$Props(project, f);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_ShowProjectAddress$ = new $TypeData().initClass({
  Lreactbuild_project_ShowProjectAddress$: 0
}, false, "reactbuild.project.ShowProjectAddress$", {
  Lreactbuild_project_ShowProjectAddress$: 1,
  O: 1
});
$c_Lreactbuild_project_ShowProjectAddress$.prototype.$classData = $d_Lreactbuild_project_ShowProjectAddress$;
var $n_Lreactbuild_project_ShowProjectAddress$;
function $m_Lreactbuild_project_ShowProjectAddress$() {
  if ((!$n_Lreactbuild_project_ShowProjectAddress$)) {
    $n_Lreactbuild_project_ShowProjectAddress$ = new $c_Lreactbuild_project_ShowProjectAddress$()
  };
  return $n_Lreactbuild_project_ShowProjectAddress$
}
/** @constructor */
function $c_Lreactbuild_project_Summary$() {
  this.Lreactbuild_project_Summary$__f_projectSummarylayoutContainer = null;
  this.Lreactbuild_project_Summary$__f_projectSummaryLayout = null;
  this.Lreactbuild_project_Summary$__f_projectSummaryImage = null;
  this.Lreactbuild_project_Summary$__f_projectPreviewImage = null;
  this.Lreactbuild_project_Summary$__f_component = null;
  $n_Lreactbuild_project_Summary$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_Summary$__f_projectSummarylayoutContainer = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x3 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    var this$8 = $m_Lscalacss_internal_Attrs$justifyContent$();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$8.Lscalacss_internal_Attrs$justifyContent$__f_attr, "space-around")));
    $n(dsl);
    var this$10 = $m_Lscalacss_internal_Attrs$backgroundColor$();
    var array = [$$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$10.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "transparent")))];
    return $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })), new $c_Lsourcecode_Name("projectSummarylayoutContainer"));
  var this$16 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$1 = "div";
  this.Lreactbuild_project_Summary$__f_projectSummaryLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$16, v$1)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x13 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    $n(dsl$3);
    var a = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var $$x12 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1")));
    $n(dsl$3);
    var this$21 = $m_Lscalacss_internal_Attrs$display$();
    var $$x11 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$21.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    $n(dsl$3);
    $n(dsl$3);
    var a$1 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var $$x10 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, "1fr")));
    $n(dsl$3);
    var a$2 = $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_gridGap;
    var $$x9 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2, "1em")));
    $n(dsl$3);
    $n(dsl$3);
    var this$28 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var $$x8 = $n($n(dsl$3).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__landscape__O(this$28), new $c_sjsr_AnonFunction1(((x$2) => {
      var x = $as_Lscalacss_internal_Media$Query(x$2);
      return $n(dsl$3).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x)
    }))));
    $n(dsl$3);
    var this$38 = $m_Lscalacss_internal_Attrs$maxWidth$();
    $n(dsl$3);
    $n(dsl$3);
    var this$ = 1280;
    var u = $m_Lscalacss_internal_LengthUnit$px$();
    var f$1 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl$3);
    $n(dsl$3);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl$3);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var v$2 = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$3 = $n(v$2).Lscalacss_internal_ValueT__f_value;
    var array$1 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$38.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$3)))];
    var x$4 = $n($$x8).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x7 = new $c_Lscalacss_internal_DslBase$ToStyle(x$4);
    $n(dsl$3);
    $n(dsl$3);
    var this$48 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    $n(dsl$3);
    var this$$1 = 40;
    var u$1 = $m_Lscalacss_internal_LengthUnit$em$();
    var v$4 = new $c_Lscalacss_internal_Length(this$$1, u$1);
    var $$x6 = $n($n(dsl$3).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__minWidth__Lscalacss_internal_Length__O(this$48, v$4), new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      var x$3$1 = $as_Lscalacss_internal_Media$Query(x$3$2$1);
      return $n(dsl$3).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$3$1)
    }))));
    $n(dsl$3);
    $n(dsl$3);
    var a$3 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var array$2 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$3, "1fr 1fr")))];
    var x$5 = $n($$x6).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle(x$5);
    $n(dsl$3);
    $n(dsl$3);
    var this$58 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var $$x4 = $n($n(dsl$3).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$58.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4$1 = $as_Lscalacss_internal_Media$Query(x$4$2);
      return $n(dsl$3).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$4$1)
    }))));
    $n(dsl$3);
    var this$60 = $m_Lscalacss_internal_Attrs$backgroundColor$();
    var array$3 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$60.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "transparent")))];
    var array$4 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(dsl$3).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(">*", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
    var x$6 = $n($$x4).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$5 = [$$x12, $$x11, $$x10, $$x9, $$x7, $$x5, new $c_Lscalacss_internal_DslBase$ToStyle(x$6)];
    return $as_sci_Seq($n($$x13).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
  })), new $c_Lsourcecode_Name("projectSummaryLayout"));
  var this$75 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$5 = "div";
  this.Lreactbuild_project_Summary$__f_projectSummaryImage = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$75, v$5)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$4$2) => {
    var dsl$4 = $as_Lscalacss_internal_DslBase(dsl$4$2);
    var $$x23 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$4);
    var this$77 = $m_Lscalacss_internal_Attrs$position$();
    var $$x22 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$77.Lscalacss_internal_Attrs$position$__f_attr, "fixed")));
    $n(dsl$4);
    var this$79 = $m_Lscalacss_internal_Attrs$left$();
    var $$x21 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$79.Lscalacss_internal_Attrs$left$__f_attr, "0")));
    $n(dsl$4);
    var this$81 = $m_Lscalacss_internal_Attrs$top$();
    var $$x20 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$81.Lscalacss_internal_Attrs$top$__f_attr, "0")));
    $n(dsl$4);
    var this$83 = $m_Lscalacss_internal_Attrs$right$();
    var $$x19 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$83.Lscalacss_internal_Attrs$right$__f_attr, "0")));
    $n(dsl$4);
    var this$85 = $m_Lscalacss_internal_Attrs$bottom$();
    var $$x18 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$85.Lscalacss_internal_Attrs$bottom$__f_attr, "0")));
    $n(dsl$4);
    var this$90 = $m_Lscalacss_internal_Attrs$opacity$();
    $n(dsl$4);
    $n(dsl$4);
    var r$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7 = $uD(x$7$2);
      return ("" + x$7)
    })));
    var v$6 = $n(r$1).apply__O__Lscalacss_internal_ValueT(0.3);
    var v$7 = $n(v$6).Lscalacss_internal_ValueT__f_value;
    var $$x17 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$90.Lscalacss_internal_Attrs$opacity$__f_attr, v$7)));
    $n(dsl$4);
    $n(dsl$4);
    var a$4 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-position");
    var $$x16 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$4, "50% 50%")));
    $n(dsl$4);
    $n(dsl$4);
    var a$5 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-size");
    var $$x15 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$5, "cover")));
    $n(dsl$4);
    var this$100 = $m_Lscalacss_internal_Attrs$backgroundRepeat$();
    var v$8 = $m_Lscalacss_internal_Literal$Typed$noRepeat$();
    var v$9 = v$8.Lscalacss_internal_Literal__f_value;
    var $$x14 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$100.Lscalacss_internal_Attrs$backgroundRepeat$__f_attr, v$9)));
    $n(dsl$4);
    var this$105 = $m_Lscalacss_internal_Attrs$zIndex$();
    $n(dsl$4);
    $n(dsl$4);
    var r$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5$1 = $uI(x$5$2);
      return ("" + x$5$1)
    })));
    var v$10 = $n(r$2).apply__O__Lscalacss_internal_ValueT((-1));
    var v$11 = $n(v$10).Lscalacss_internal_ValueT__f_value;
    var array$6 = [$$x22, $$x21, $$x20, $$x19, $$x18, $$x17, $$x16, $$x15, $$x14, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$105.Lscalacss_internal_Attrs$zIndex$__f_attr, v$11)))];
    return $as_sci_Seq($n($$x23).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6)))
  })), new $c_Lsourcecode_Name("projectSummaryImage"));
  var this$111 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$12 = "div";
  this.Lreactbuild_project_Summary$__f_projectPreviewImage = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$111, v$12)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$5$2) => {
    var dsl$5 = $as_Lscalacss_internal_DslBase(dsl$5$2);
    var $$x33 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$5);
    var this$120 = $m_Lscalacss_internal_Attrs$maxHeight$();
    $n(dsl$5);
    $n(dsl$5);
    var this$$2 = 100;
    var f$3 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$2);
    $n(dsl$5);
    $n(dsl$5);
    var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$1) => {
      var x$4$3 = $as_Lscalacss_internal_Percentage(x$4$2$1);
      return $n(x$4$3).value__T()
    })));
    $n(dsl$5);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$1)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
    var r$3 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var v$13 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$3);
    var v$14 = $n(v$13).Lscalacss_internal_ValueT__f_value;
    var $$x32 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$120.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$14)));
    $n(dsl$5);
    var this$122 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$15 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$16 = v$15.Lscalacss_internal_Literal__f_value;
    var $$x31 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$122.Lscalacss_internal_Attrs$overflow$__f_attr, v$16)));
    $n(dsl$5);
    var this$124 = $m_Lscalacss_internal_Attrs$display$();
    var $$x30 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$124.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$5);
    var this$126 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x29 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$126.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")));
    var $$x28 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
      var x$1$3 = $as_T(x$1$2$2);
      return (x$1$3 + ">svg")
    }));
    $n(dsl$5);
    var this$128 = $m_Lscalacss_internal_Attrs$display$();
    var $$x27 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$128.Lscalacss_internal_Attrs$display$__f_attr, "block")));
    $n(dsl$5);
    var this$130 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$17 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$18 = v$17.Lscalacss_internal_Literal__f_value;
    var $$x26 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$130.Lscalacss_internal_Attrs$overflow$__f_attr, v$18)));
    $n(dsl$5);
    $n(dsl$5);
    var a$6 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var $$x25 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$6, "1")));
    $n(dsl$5);
    var this$142 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl$5);
    $n(dsl$5);
    var this$$3 = 100;
    var f$5 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$3);
    $n(dsl$5);
    $n(dsl$5);
    var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$2) => {
      var x$4$4 = $as_Lscalacss_internal_Percentage(x$4$2$2);
      return $n(x$4$4).value__T()
    })));
    $n(dsl$5);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
      var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$3);
      return $n(x$1$4)
    }));
    var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
    var r$4 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
    var v$19 = $n(r$4).apply__O__Lscalacss_internal_ValueT(f$5);
    var v$20 = $n(v$19).Lscalacss_internal_ValueT__f_value;
    var $$x24 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$142.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$20)));
    $n(dsl$5);
    var this$151 = $m_Lscalacss_internal_Attrs$width$();
    $n(dsl$5);
    $n(dsl$5);
    var this$$4 = 100;
    var f$7 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$4);
    $n(dsl$5);
    $n(dsl$5);
    var ab$3 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$3) => {
      var x$4$5 = $as_Lscalacss_internal_Percentage(x$4$2$3);
      return $n(x$4$5).value__T()
    })));
    $n(dsl$5);
    var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
      var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$4);
      return $n(x$1$5)
    }));
    var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
    var r$5 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
    var v$21 = $n(r$5).apply__O__Lscalacss_internal_ValueT(f$7);
    var v$22 = $n(v$21).Lscalacss_internal_ValueT__f_value;
    var array$7 = [$$x27, $$x26, $$x25, $$x24, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$151.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$22)))];
    var array$8 = [$$x32, $$x31, $$x30, $$x29, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(dsl$5).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x28, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
    return $as_sci_Seq($n($$x33).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8)))
  })), new $c_Lsourcecode_Name("projectPreviewImage"));
  var this$246 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f$10 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_project_Summary$Props(p$2);
    var $$x65 = $m_Lreactbuild_analyze_cost_components_ScrollBlockContainer$();
    var $$x64 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x62 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode($n(p).Lreactbuild_project_Summary$Props__f_project, new $c_sjsr_AnonFunction0((() => $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom)), new $c_sjsr_AnonFunction1(((project$2) => {
      var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(project$2);
      var this$169 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$166 = $n($n($n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_images).headOption__s_Option());
      var f$8 = new $c_sjsr_AnonFunction1(((image$2) => {
        var image = $as_Lreactbuild_common_model_Image(image$2);
        var $$x63 = $n($m_Lreactbuild_project_Summary$().Lreactbuild_project_Summary$__f_projectSummaryImage);
        var array$9 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle("backgroundImage")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((("url(" + $n(image).fullPath__T__T($m_Lreactbuild_package$().Lreactbuild_package$__f_scheme)) + ")"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
        return $n($$x63).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
      }));
      var o = (this$166.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$8.apply__O__O(this$166.get__O())));
      var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var this$168 = $m_s_$less$colon$less$();
      var f$9 = this$168.s_$less$colon$less$__f_singleton;
      return $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$169, o, O, f$9)
    })));
    var $$x61 = $m_Lreactbuild_project_Summary$().Lreactbuild_project_Summary$__f_projectSummarylayoutContainer;
    var $$x60 = $m_Lreactbuild_project_Summary$().Lreactbuild_project_Summary$__f_projectSummaryLayout;
    var $$x59 = $m_Lcom_iz2use_react_components_Card$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x58 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Proc\u00e9dures en cours");
    var $$x57 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x56 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x55 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var array$10 = [$m_Lreactbuild_analyze_cost_components_RenderPot$().apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode($n($n($n(p).Lreactbuild_project_Summary$Props__f_project).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((mainProject$2) => {
      var mainProject = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(mainProject$2);
      var this$175 = $n($n(p).Lreactbuild_project_Summary$Props__f_allProjects);
      var p$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2$1 = $as_Lreactbuild_common_model_Project(x$2$2);
        return $n($n(x$2$1).Lreactbuild_common_model_Project__f_parent).contains__O__Z($n($as_Lreactbuild_common_model_Project($n(mainProject).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id)
      }));
      var subProjects = $p_sci_List__filterCommon__F1__Z__sci_List(this$175, p$1, false);
      return $ct_T2__O__O__(new $c_T2(), mainProject, subProjects)
    })))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$3$2$2) => {
      var x$3$3 = $as_T2(x$3$2$2);
      if ((x$3$3 !== null)) {
        var mainProject$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n(x$3$3)._1__O());
        var subProjects$1 = $as_sci_List($n(x$3$3)._2__O());
        var rassoc$1 = $as_Lreactbuild_common_model_Project($n(mainProject$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
        var this$176 = $n(subProjects$1);
        return this$176.prepended__O__sci_List(rassoc$1)
      } else {
        throw new $c_s_MatchError(x$3$3)
      }
    }))), new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode())), new $c_sjsr_AnonFunction1(((x$4$2$4) => {
      var x$4$6 = $as_sci_List(x$4$2$4);
      var u$2 = $m_Lreactbuild_project_RenderProcedureState$().apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(x$4$6);
      var this$178 = $n(u$2);
      var n = this$178.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    })))];
    var $$x54 = $n($$x59).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x58, $$x57, $$x56, $$x55, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
    var $$x53 = $m_Lcom_iz2use_react_components_Card$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x52 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aper\u00e7u du plan");
    var $$x51 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x50 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x49 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var array$12 = [$m_Lreactbuild_analyze_cost_components_RenderPot$().apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lreactbuild_project_Summary$Props__f_project).flatMap__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((project$3$2) => {
      var project$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(project$3$2);
      return $n($m_Ldiode_data_Pot$().fromOption__s_Option__Ldiode_data_Pot($n($as_Lreactbuild_common_model_Project($n(project$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_summary)).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((summary$2) => {
        var summary = $n($as_Lcom_iz2use_common_Multiline(summary$2)).Lcom_iz2use_common_Multiline__f_underlying;
        return new $c_Lcom_iz2use_common_Multiline(summary)
      })))
    }))), new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode())), new $c_sjsr_AnonFunction1(((svg$2) => {
      var svg = $n($as_Lcom_iz2use_common_Multiline(svg$2)).Lcom_iz2use_common_Multiline__f_underlying;
      var $$x48 = $n($m_Lreactbuild_project_Summary$().Lreactbuild_project_Summary$__f_projectPreviewImage);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$190 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "dangerouslySetInnerHTML");
      var a$7 = $f_T__replaceFirst__T__T__T($n(svg), "<svg", "<svg \n        preserveAspectRatio := \"xMidYMid meet\"");
      var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtInnerHtml__F2();
      var array$11 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$190.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$7)];
      return $n($$x48).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
    })))];
    var $$x47 = $n($$x53).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x52, $$x51, $$x50, $$x49, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
    var $$x46 = $m_Lcom_iz2use_react_components_Card$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x45 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Intervenants");
    var $$x44 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x43 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x42 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var u$3 = $m_Lreactbuild_person_PersonReferenceList$().apply__s_Option__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_s_None$(), $n($n($n(p).Lreactbuild_project_Summary$Props__f_project).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$5$2$1) => {
      var x$5$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$5$2$1);
      var this$202 = $n($n($as_Lreactbuild_common_model_Project($n(x$5$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id);
      return new $c_Lreactbuild_common_model_RefTo(this$202.Lreactbuild_common_model_RefTo__f_id)
    })))).toList__sci_List());
    var this$204 = $n(u$3);
    var n$1 = this$204.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$13 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
    var $$x41 = $n($$x46).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x45, $$x44, $$x43, $$x42, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
    var $$x40 = $m_Lcom_iz2use_react_components_Card$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x39 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Adresse");
    var $$x38 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x37 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x36 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x35 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$15 = [$m_Lreactbuild_analyze_cost_components_RenderPot$().apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode($n(p).Lreactbuild_project_Summary$Props__f_project, new $c_sjsr_AnonFunction0((() => {
      var u$4 = $m_Lreactbuild_project_ShowProjectAddress$().Lreactbuild_project_ShowProjectAddress$__f_skeleton;
      var this$217 = $n(u$4);
      var n$2 = this$217.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
    })), new $c_sjsr_AnonFunction1(((project$4$2) => {
      var project$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(project$4$2);
      var u$5 = $m_Lreactbuild_project_ShowProjectAddress$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(project$4, new $c_sjsr_AnonFunction2(((coords$2, text$2) => {
        var text = $as_T(text$2);
        var $$x34 = $n($n($n($n(p).Lreactbuild_project_Summary$Props__f_pageProps).Lreactbuild_package$PageProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$BusinessOpportunities(new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(coords$2, 20.0)))));
        var array$14 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(text))];
        return $n($$x34).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))
      })));
      var this$225 = $n(u$5);
      var n$3 = this$225.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)
    })))];
    var array$16 = [$n($$x35).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
    var array$17 = [$$x54, $$x47, $$x41, $n($$x40).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x39, $$x38, $$x37, $$x36, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
    var array$18 = [$n($$x60).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))];
    var array$19 = [$$x62, $n($$x61).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))];
    var array$20 = [$n($$x64).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19))];
    return $n($$x65).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20))
  }));
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f$10, s);
  this.Lreactbuild_project_Summary$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$246, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.Summary.component"))
}
$c_Lreactbuild_project_Summary$.prototype = new $h_O();
$c_Lreactbuild_project_Summary$.prototype.constructor = $c_Lreactbuild_project_Summary$;
/** @constructor */
function $h_Lreactbuild_project_Summary$() {
  /*<skip>*/
}
$h_Lreactbuild_project_Summary$.prototype = $c_Lreactbuild_project_Summary$.prototype;
$c_Lreactbuild_project_Summary$.prototype.apply__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(project, allProjects, pageProps) {
  var c = this.Lreactbuild_project_Summary$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_Summary$Props(project, allProjects, pageProps);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_Summary$ = new $TypeData().initClass({
  Lreactbuild_project_Summary$: 0
}, false, "reactbuild.project.Summary$", {
  Lreactbuild_project_Summary$: 1,
  O: 1
});
$c_Lreactbuild_project_Summary$.prototype.$classData = $d_Lreactbuild_project_Summary$;
var $n_Lreactbuild_project_Summary$;
function $m_Lreactbuild_project_Summary$() {
  if ((!$n_Lreactbuild_project_Summary$)) {
    $n_Lreactbuild_project_Summary$ = new $c_Lreactbuild_project_Summary$()
  };
  return $n_Lreactbuild_project_Summary$
}
/** @constructor */
function $c_Lreactbuild_project_TestBluetoothMeazor$() {
  this.Lreactbuild_project_TestBluetoothMeazor$__f_component = null;
  $n_Lreactbuild_project_TestBluetoothMeazor$ = this;
  var this$49 = $m_Lcom_iz2use_react_hooks_package$();
  var this$5 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = $m_Lreactbuild_plugins_devices_DeviceMeasure$().Lreactbuild_plugins_devices_DeviceMeasure$__f_useDeviceMeasure;
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$3 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$();
  var a = this$3.const__O__F1((void 0));
  var this$4 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$4);
  var this$48 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__custom__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__F1__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$5, hook, step, a, d)));
  var f$4 = new $c_sjsr_AnonFunction2(((props$2, measures$2) => {
    $as_Lreactbuild_project_TestBluetoothMeazor$Props(props$2);
    var measures = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(measures$2);
    var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x9 = $m_Lcom_iz2use_react_components_Button$();
    $m_Ljapgolly_scalajs_react_Reusable$();
    var r = $n(measures).dispatch__O__Ljapgolly_scalajs_react_Reusable($m_Lreactbuild_plugins_devices_MeasureAction$Toggle$());
    var $$x8 = $n($n($$x9).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Lancer/Arr\u00eater"))];
    var $$x7 = $n($$x8).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var this$15 = $n(measures);
    if ($n($as_Lreactbuild_plugins_devices_DeviceMeasure$State(this$15.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_plugins_devices_DeviceMeasure$State__f_active) {
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("actif")
    } else {
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("inactif")
    };
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$22 = $n(measures);
    var this$23 = $n($n($as_Lreactbuild_plugins_devices_DeviceMeasure$State(this$22.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices);
    var f = ((dev$2) => $as_T(dev$2.name));
    if ((this$23 === $m_sci_Nil$())) {
      var as = $m_sci_Nil$()
    } else {
      var arg1 = this$23.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$23.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var as = h
    };
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    var this$25 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    var sep = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_vdom_HtmlTags__br__T(this$25), $m_sci_Nil$());
    var f$1 = new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_T(v$2);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
    }));
    var array$1 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$1)];
    var $$x3 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("code", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$34 = $n(measures);
    var this$35 = $n($n($as_Lreactbuild_plugins_devices_DeviceMeasure$State(this$34.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_plugins_devices_DeviceMeasure$State__f_events);
    var f$2 = ((ev$2) => {
      var ev = $as_Lreactbuild_plugins_devices_MeasureEvent(ev$2);
      return ("" + $n(ev).Lreactbuild_plugins_devices_MeasureEvent__f_details)
    });
    if ((this$35 === $m_sci_Nil$())) {
      var as$1 = $m_sci_Nil$()
    } else {
      var arg1$2 = this$35.head__O();
      var h$1 = new $c_sci_$colon$colon(f$2(arg1$2), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(this$35.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$3 = $n(rest$1).head__O();
        var nx$1 = new $c_sci_$colon$colon(f$2(arg1$3), $m_sci_Nil$());
        $n(t$1).sci_$colon$colon__f_next = nx$1;
        t$1 = nx$1;
        rest$1 = $as_sci_List($n(rest$1).tail__O())
      };
      var as$1 = h$1
    };
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    var this$37 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    var sep$1 = $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_vdom_HtmlTags__br__T(this$37), $m_sci_Nil$());
    var f$3 = new $c_sjsr_AnonFunction1(((v$3$2) => {
      var v$3 = $as_T(v$3$2);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
    }));
    var array$2 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep$1, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$3)];
    var array$3 = [$$x7, $$x6, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("code", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
    return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  }));
  var this$47 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$47);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$48, f$4, step$1, s);
  this.Lreactbuild_project_TestBluetoothMeazor$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$49, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.TestBluetoothMeazor.component"))
}
$c_Lreactbuild_project_TestBluetoothMeazor$.prototype = new $h_O();
$c_Lreactbuild_project_TestBluetoothMeazor$.prototype.constructor = $c_Lreactbuild_project_TestBluetoothMeazor$;
/** @constructor */
function $h_Lreactbuild_project_TestBluetoothMeazor$() {
  /*<skip>*/
}
$h_Lreactbuild_project_TestBluetoothMeazor$.prototype = $c_Lreactbuild_project_TestBluetoothMeazor$.prototype;
$c_Lreactbuild_project_TestBluetoothMeazor$.prototype.apply__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function() {
  var c = this.Lreactbuild_project_TestBluetoothMeazor$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_TestBluetoothMeazor$Props();
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_TestBluetoothMeazor$ = new $TypeData().initClass({
  Lreactbuild_project_TestBluetoothMeazor$: 0
}, false, "reactbuild.project.TestBluetoothMeazor$", {
  Lreactbuild_project_TestBluetoothMeazor$: 1,
  O: 1
});
$c_Lreactbuild_project_TestBluetoothMeazor$.prototype.$classData = $d_Lreactbuild_project_TestBluetoothMeazor$;
var $n_Lreactbuild_project_TestBluetoothMeazor$;
function $m_Lreactbuild_project_TestBluetoothMeazor$() {
  if ((!$n_Lreactbuild_project_TestBluetoothMeazor$)) {
    $n_Lreactbuild_project_TestBluetoothMeazor$ = new $c_Lreactbuild_project_TestBluetoothMeazor$()
  };
  return $n_Lreactbuild_project_TestBluetoothMeazor$
}
/** @constructor */
function $c_Lreactbuild_project_TopView$() {
  /*<skip>*/
}
$c_Lreactbuild_project_TopView$.prototype = new $h_O();
$c_Lreactbuild_project_TopView$.prototype.constructor = $c_Lreactbuild_project_TopView$;
/** @constructor */
function $h_Lreactbuild_project_TopView$() {
  /*<skip>*/
}
$h_Lreactbuild_project_TopView$.prototype = $c_Lreactbuild_project_TopView$.prototype;
$c_Lreactbuild_project_TopView$.prototype.apply__Lreactbuild_common_model_Project__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode = (function(project, settings) {
  var x1 = $n(project).Lreactbuild_common_model_Project__f_modelSource;
  var x = $m_s_None$();
  if ((x === x1)) {
    return $m_Lreactbuild_project_Page$().empty__T__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_TagOf("Dessin non enregistr\u00e9", new $c_Lsourcecode_FullName("reactbuild.project.TopView.apply"), settings)
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var modelSource = $n($as_Lcom_iz2use_common_Multiline($n(x3).s_Some__f_value)).Lcom_iz2use_common_Multiline__f_underlying;
    var $$x2 = $m_Lreactbuild_project_Page$();
    $m_Lreactbuild_project_Page$();
    var $$x1 = $m_Lreactbuild_project_PageSide$Any$();
    var u = $m_Lreactbuild_project_drawing_DrawingContext$().apply__Lreactbuild_common_model_Project__T__D__T2__s_Option__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(project, modelSource, 0.07559055118110236, new $c_T2$mcDD$sp(1000.0, 1000.0), ($m_Lreactbuild_project_drawing_DrawingContext$(), $m_s_None$()), new $c_sjsr_AnonFunction1(((ctx$2) => {
      var ctx = $as_Lreactbuild_project_drawing_BoxedDrawingContext(ctx$2);
      var this$7 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var array = [$m_Lreactbuild_project_drawing_DrawBuilding$().apply__Lreactbuild_project_drawing_LOD__Lreactbuild_project_drawing_BoxedDrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode($m_Lreactbuild_project_drawing_LOD500$(), ctx)];
      var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, null, ns)
    })));
    var this$9 = $n(u);
    var n = this$9.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    return $n($$x2).apply__Lreactbuild_project_PageSide__sci_Seq__Lsourcecode_FullName__Lreactbuild_project_RenderingSettings__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), new $c_Lsourcecode_FullName("reactbuild.project.TopView.apply"), settings)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lreactbuild_project_TopView$ = new $TypeData().initClass({
  Lreactbuild_project_TopView$: 0
}, false, "reactbuild.project.TopView$", {
  Lreactbuild_project_TopView$: 1,
  O: 1
});
$c_Lreactbuild_project_TopView$.prototype.$classData = $d_Lreactbuild_project_TopView$;
var $n_Lreactbuild_project_TopView$;
function $m_Lreactbuild_project_TopView$() {
  if ((!$n_Lreactbuild_project_TopView$)) {
    $n_Lreactbuild_project_TopView$ = new $c_Lreactbuild_project_TopView$()
  };
  return $n_Lreactbuild_project_TopView$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$() {
  this.Lreactbuild_project_drawing_Area$__f_component = null;
  $n_Lreactbuild_project_drawing_Area$ = this;
  this.Lreactbuild_project_drawing_Area$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).withChildren__F2__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction2(((p$2, c$2) => {
    var p = $as_Lreactbuild_project_drawing_Area$Props(p$2);
    var c = $n($as_Ljapgolly_scalajs_react_PropsChildren(c$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$4 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingArea;
    var $$x4 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
    var this$5 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $as_Lscalacss_internal_StyleA($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaAxis).apply__O__O($n(p).Lreactbuild_project_drawing_Area$Props__f_axis));
    var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s$1);
    var this$6 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $as_Lscalacss_internal_StyleA($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaPosition).apply__O__O($ct_T2__O__O__(new $c_T2(), $n(p).Lreactbuild_project_drawing_Area$Props__f_axis, $n(p).Lreactbuild_project_drawing_Area$Props__f_position)));
    var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s$2);
    var this$7 = $m_Lscalacss_ScalaCssReact$();
    var s$3 = $as_Lscalacss_internal_StyleA($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaAlignment).apply__O__O($ct_T2__O__O__(new $c_T2(), $n(p).Lreactbuild_project_drawing_Area$Props__f_axis, $n(p).Lreactbuild_project_drawing_Area$Props__f_alignment)));
    var $$x1 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$3);
    var this$8 = $m_Lscalacss_ScalaCssReact$();
    var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaHidden;
    var this$9 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$8, s$4));
    var condition = $n(p).Lreactbuild_project_drawing_Area$Props__f_hide;
    var array = [$$x4, $$x3, $$x2, $$x1, $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$9, condition), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c))];
    return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_Area$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$.prototype = $c_Lreactbuild_project_drawing_Area$.prototype;
$c_Lreactbuild_project_drawing_Area$.prototype.apply__Lreactbuild_project_drawing_Area$Axis__Lreactbuild_project_drawing_Area$Position__Z__Lreactbuild_project_drawing_Area$Alignment__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(axis, position, hide, alignment, children) {
  var c = this.Lreactbuild_project_drawing_Area$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_drawing_Area$Props(axis, position, hide, alignment);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_project_drawing_Area$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$: 0
}, false, "reactbuild.project.drawing.Area$", {
  Lreactbuild_project_drawing_Area$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_Area$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$;
var $n_Lreactbuild_project_drawing_Area$;
function $m_Lreactbuild_project_drawing_Area$() {
  if ((!$n_Lreactbuild_project_drawing_Area$)) {
    $n_Lreactbuild_project_drawing_Area$ = new $c_Lreactbuild_project_drawing_Area$()
  };
  return $n_Lreactbuild_project_drawing_Area$
}
function $is_Lreactbuild_project_drawing_Area$Alignment(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_Area$Alignment)))
}
function $as_Lreactbuild_project_drawing_Area$Alignment(obj) {
  return (($is_Lreactbuild_project_drawing_Area$Alignment(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Area$Alignment"))
}
function $isArrayOf_Lreactbuild_project_drawing_Area$Alignment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Area$Alignment)))
}
function $asArrayOf_Lreactbuild_project_drawing_Area$Alignment(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Area$Alignment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Area$Alignment;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Alignment$() {
  this.Lreactbuild_project_drawing_Area$Alignment$__f_list = null;
  this.Lreactbuild_project_drawing_Area$Alignment$__f_domain = null;
  $n_Lreactbuild_project_drawing_Area$Alignment$ = this;
  var this$4 = $m_sci_ListSet$();
  var array = [$m_Lreactbuild_project_drawing_Area$Alignment$End$(), $m_Lreactbuild_project_drawing_Area$Alignment$Middle$(), $m_Lreactbuild_project_drawing_Area$Alignment$Start$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_project_drawing_Area$Alignment$__f_list = this$4.from__sc_IterableOnce__sci_ListSet(elems);
  $m_Lscalacss_internal_Domain$();
  var this$5 = $n(this.Lreactbuild_project_drawing_Area$Alignment$__f_list);
  var as = $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$5);
  this.Lreactbuild_project_drawing_Area$Alignment$__f_domain = new $c_Lscalacss_internal_Domain$OverSeq($n(as).toIndexedSeq__sci_IndexedSeq())
}
$c_Lreactbuild_project_drawing_Area$Alignment$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Alignment$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Alignment$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Alignment$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Alignment$.prototype = $c_Lreactbuild_project_drawing_Area$Alignment$.prototype;
var $d_Lreactbuild_project_drawing_Area$Alignment$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Alignment$: 0
}, false, "reactbuild.project.drawing.Area$Alignment$", {
  Lreactbuild_project_drawing_Area$Alignment$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_Area$Alignment$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Alignment$;
var $n_Lreactbuild_project_drawing_Area$Alignment$;
function $m_Lreactbuild_project_drawing_Area$Alignment$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Alignment$)) {
    $n_Lreactbuild_project_drawing_Area$Alignment$ = new $c_Lreactbuild_project_drawing_Area$Alignment$()
  };
  return $n_Lreactbuild_project_drawing_Area$Alignment$
}
function $is_Lreactbuild_project_drawing_Area$Axis(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_Area$Axis)))
}
function $as_Lreactbuild_project_drawing_Area$Axis(obj) {
  return (($is_Lreactbuild_project_drawing_Area$Axis(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Area$Axis"))
}
function $isArrayOf_Lreactbuild_project_drawing_Area$Axis(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Area$Axis)))
}
function $asArrayOf_Lreactbuild_project_drawing_Area$Axis(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Area$Axis(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Area$Axis;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Axis$() {
  this.Lreactbuild_project_drawing_Area$Axis$__f_list = null;
  this.Lreactbuild_project_drawing_Area$Axis$__f_domain = null;
  $n_Lreactbuild_project_drawing_Area$Axis$ = this;
  var this$4 = $m_sci_ListSet$();
  var array = [$m_Lreactbuild_project_drawing_Area$Axis$Vertical$(), $m_Lreactbuild_project_drawing_Area$Axis$Horizontal$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_project_drawing_Area$Axis$__f_list = this$4.from__sc_IterableOnce__sci_ListSet(elems);
  $m_Lscalacss_internal_Domain$();
  var this$5 = $n(this.Lreactbuild_project_drawing_Area$Axis$__f_list);
  var as = $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$5);
  this.Lreactbuild_project_drawing_Area$Axis$__f_domain = new $c_Lscalacss_internal_Domain$OverSeq($n(as).toIndexedSeq__sci_IndexedSeq())
}
$c_Lreactbuild_project_drawing_Area$Axis$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Axis$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Axis$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Axis$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Axis$.prototype = $c_Lreactbuild_project_drawing_Area$Axis$.prototype;
var $d_Lreactbuild_project_drawing_Area$Axis$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Axis$: 0
}, false, "reactbuild.project.drawing.Area$Axis$", {
  Lreactbuild_project_drawing_Area$Axis$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_Area$Axis$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Axis$;
var $n_Lreactbuild_project_drawing_Area$Axis$;
function $m_Lreactbuild_project_drawing_Area$Axis$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Axis$)) {
    $n_Lreactbuild_project_drawing_Area$Axis$ = new $c_Lreactbuild_project_drawing_Area$Axis$()
  };
  return $n_Lreactbuild_project_drawing_Area$Axis$
}
function $is_Lreactbuild_project_drawing_Area$Position(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_Area$Position)))
}
function $as_Lreactbuild_project_drawing_Area$Position(obj) {
  return (($is_Lreactbuild_project_drawing_Area$Position(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Area$Position"))
}
function $isArrayOf_Lreactbuild_project_drawing_Area$Position(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Area$Position)))
}
function $asArrayOf_Lreactbuild_project_drawing_Area$Position(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Area$Position(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Area$Position;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Position$() {
  this.Lreactbuild_project_drawing_Area$Position$__f_list = null;
  this.Lreactbuild_project_drawing_Area$Position$__f_domain = null;
  $n_Lreactbuild_project_drawing_Area$Position$ = this;
  var this$4 = $m_sci_ListSet$();
  var array = [$m_Lreactbuild_project_drawing_Area$Position$End$(), $m_Lreactbuild_project_drawing_Area$Position$Start$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_project_drawing_Area$Position$__f_list = this$4.from__sc_IterableOnce__sci_ListSet(elems);
  $m_Lscalacss_internal_Domain$();
  var this$5 = $n(this.Lreactbuild_project_drawing_Area$Position$__f_list);
  var as = $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$5);
  this.Lreactbuild_project_drawing_Area$Position$__f_domain = new $c_Lscalacss_internal_Domain$OverSeq($n(as).toIndexedSeq__sci_IndexedSeq())
}
$c_Lreactbuild_project_drawing_Area$Position$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Position$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Position$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Position$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Position$.prototype = $c_Lreactbuild_project_drawing_Area$Position$.prototype;
var $d_Lreactbuild_project_drawing_Area$Position$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Position$: 0
}, false, "reactbuild.project.drawing.Area$Position$", {
  Lreactbuild_project_drawing_Area$Position$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_Area$Position$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Position$;
var $n_Lreactbuild_project_drawing_Area$Position$;
function $m_Lreactbuild_project_drawing_Area$Position$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Position$)) {
    $n_Lreactbuild_project_drawing_Area$Position$ = new $c_Lreactbuild_project_drawing_Area$Position$()
  };
  return $n_Lreactbuild_project_drawing_Area$Position$
}
function $is_Lreactbuild_project_drawing_BuildingPart(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_BuildingPart)))
}
function $as_Lreactbuild_project_drawing_BuildingPart(obj) {
  return (($is_Lreactbuild_project_drawing_BuildingPart(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.BuildingPart"))
}
function $isArrayOf_Lreactbuild_project_drawing_BuildingPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_BuildingPart)))
}
function $asArrayOf_Lreactbuild_project_drawing_BuildingPart(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_BuildingPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.BuildingPart;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Button$() {
  this.Lreactbuild_project_drawing_Button$__f_defaultIcon = null;
  this.Lreactbuild_project_drawing_Button$__f_component = null;
  $n_Lreactbuild_project_drawing_Button$ = this;
  this.Lreactbuild_project_drawing_Button$__f_defaultIcon = ($m_sc_StringOps$(), $m_sc_StringOps$().stripMargin$extension__T__C__T("m 10.003157,15.825621 c -0.021107,-1.601666 0.264341,-3.323278 \n    | 1.439909,-4.507145 0.975643,-1.085112 2.459011,-1.9362815 2.684667,-3.498844 \n    | 0.140327,-0.976328 -0.172131,-2.2512513 -1.25352,-2.5321194 -1.045941,-0.3291887\n    | -2.399558,0.032243 -2.823527,1.1275992 -0.273015,0.4188892 0.03908,1.2665736 \n    | -0.6759078,1.0596439 -1.1424565,0 -2.2849132,0 -3.4273697,0 C 5.9072419,5.667589 \n    | 6.7584881,3.7994084 8.372611,2.8954468 10.19463,1.8546753 12.451776,1.8132673 \n    | 14.4467,2.3142946 c 1.718987,0.4403772 3.181647,1.8589143 3.476517,3.6371145 \n    | 0.351655,1.5824093 -0.0045,3.3172729 -1.087735,4.5475149 -0.797626,1.056872 \n    | -1.915711,1.815356 -2.724903,2.857237 -0.535165,0.711727 -0.64024,1.608464 \n    | -0.669436,2.46946 -1.145995,0 -2.291991,0 -3.437986,0 z m -0.3894592,4.12173 \n    | c -0.070804,-1.21591 1.1194182,-2.192024 2.2934242,-2.06527 1.180814,-0.02049 \n    | 2.225928,1.09752 2.048334,2.281971 -0.05807,1.13064 -1.198868,1.940454 \n    | -2.287234,1.82177 -1.113264,0.01731 -2.1082789,-0.899532 -2.0545242,-2.038471 z", 124));
  var b = new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("view", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$());
  var this$6 = $m_s_$less$colon$less$();
  var ev = this$6.s_$less$colon$less$__f_singleton;
  this.Lreactbuild_project_drawing_Button$__f_component = $n($n(($n(ev), b).noBackend__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3()).render_P__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_project_drawing_Button$Props(p$2);
    return $m_Lreactbuild_project_drawing_Button$().render__Lreactbuild_project_drawing_Button$Props__Ljapgolly_scalajs_react_vdom_VdomElement(p)
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_Button$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Button$.prototype.constructor = $c_Lreactbuild_project_drawing_Button$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Button$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Button$.prototype = $c_Lreactbuild_project_drawing_Button$.prototype;
$c_Lreactbuild_project_drawing_Button$.prototype.render__Lreactbuild_project_drawing_Button$Props__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p) {
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingButton;
  var $$x8 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var $$x7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(p).Lreactbuild_project_drawing_Button$Props__f_text, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$7 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "viewBox");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$7.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0 0 24 24");
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$14 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
  $m_sc_StringOps$();
  var x = $n(p).Lreactbuild_project_drawing_Button$Props__f_icon;
  var this$13 = $n(x);
  if ((!(this$13 === ""))) {
    var a = $n(p).Lreactbuild_project_drawing_Button$Props__f_icon
  } else {
    var a = this.Lreactbuild_project_drawing_Button$__f_defaultIcon
  };
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$14.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a)];
  var array$1 = [$$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var $$x3 = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("svg", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x2 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(p).Lreactbuild_project_drawing_Button$Props__f_action))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n(p).Lreactbuild_project_drawing_Button$Props__f_modifiers;
  var this$24 = $m_s_$less$colon$less$();
  var array$2 = [$$x8, $$x7, $$x3, $$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$24.s_$less$colon$less$__f_singleton)];
  return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
$c_Lreactbuild_project_drawing_Button$.prototype.apply__T__T__Ljapgolly_scalajs_react_callback_Trampoline__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(icon, text, action, modifiers) {
  var c = this.Lreactbuild_project_drawing_Button$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_drawing_Button$Props(icon, text, action, modifiers);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_drawing_Button$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Button$: 0
}, false, "reactbuild.project.drawing.Button$", {
  Lreactbuild_project_drawing_Button$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_Button$.prototype.$classData = $d_Lreactbuild_project_drawing_Button$;
var $n_Lreactbuild_project_drawing_Button$;
function $m_Lreactbuild_project_drawing_Button$() {
  if ((!$n_Lreactbuild_project_drawing_Button$)) {
    $n_Lreactbuild_project_drawing_Button$ = new $c_Lreactbuild_project_drawing_Button$()
  };
  return $n_Lreactbuild_project_drawing_Button$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawBuilding$() {
  this.Lreactbuild_project_drawing_DrawBuilding$__f_component = null;
  $n_Lreactbuild_project_drawing_DrawBuilding$ = this;
  this.Lreactbuild_project_drawing_DrawBuilding$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DrawBuilding", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_drawing_DrawBuilding$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_project_drawing_DrawBuilding$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_project_drawing_DrawBuilding$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_project_drawing_DrawBuilding$Props__jl_Void__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_jl_Void($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_DrawBuilding$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawBuilding$.prototype.constructor = $c_Lreactbuild_project_drawing_DrawBuilding$;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawBuilding$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawBuilding$.prototype = $c_Lreactbuild_project_drawing_DrawBuilding$.prototype;
$c_Lreactbuild_project_drawing_DrawBuilding$.prototype.apply__Lreactbuild_project_drawing_LOD__Lreactbuild_project_drawing_BoxedDrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(lod, context) {
  var c = this.Lreactbuild_project_drawing_DrawBuilding$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_drawing_DrawBuilding$Props(lod, context);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_project_drawing_DrawBuilding$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawBuilding$: 0
}, false, "reactbuild.project.drawing.DrawBuilding$", {
  Lreactbuild_project_drawing_DrawBuilding$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_DrawBuilding$.prototype.$classData = $d_Lreactbuild_project_drawing_DrawBuilding$;
var $n_Lreactbuild_project_drawing_DrawBuilding$;
function $m_Lreactbuild_project_drawing_DrawBuilding$() {
  if ((!$n_Lreactbuild_project_drawing_DrawBuilding$)) {
    $n_Lreactbuild_project_drawing_DrawBuilding$ = new $c_Lreactbuild_project_drawing_DrawBuilding$()
  };
  return $n_Lreactbuild_project_drawing_DrawBuilding$
}
function $p_Lreactbuild_project_drawing_DrawComponent$__default$1__s_Option__Lreactbuild_project_drawing_DrawingContext__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf($thiz, width$1, context$1, definition$1, clickHandler$1) {
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$5 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
  var this$4 = $n(width$1);
  var a = ("" + ($uD((this$4.isEmpty__Z() ? 600.0 : this$4.get__O())) * $n(context$1).Lreactbuild_project_drawing_DrawingContextImpl__f_scale));
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$5.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$8 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
  var a$1 = ("" + (100.0 * $n(context$1).Lreactbuild_project_drawing_DrawingContextImpl__f_scale));
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$8.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$11 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
  var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$11.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$15 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
  var this$14 = $n(context$1);
  var part = $m_Lreactbuild_project_drawing_Furniture$();
  var a$2 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$14, part);
  var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$15.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$2);
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$18 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
  var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$18.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "2");
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(definition$1))];
  var array$1 = [$$x6, $$x5, $$x4, $$x3, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("title", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), clickHandler$1];
  return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
}
function $p_Lreactbuild_project_drawing_DrawComponent$__flippedTransform$1__D__Z__Lreactbuild_project_drawing_DrawingContext__T($thiz, width, invertX$1, context$1) {
  return ((!invertX$1) ? "" : (("translate(" + $n(context$1).apply__D__T(width)) + ",0) scale(-1,1)"))
}
function $p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf($thiz, transform$1) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$4 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$4.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, transform$1)];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("g", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
}
function $p_Lreactbuild_project_drawing_DrawComponent$__halfCircle$1__D__Lreactbuild_project_drawing_DrawingContext__T($thiz, r, context$1) {
  return ((($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T((-r), 0.0, context$1) + " ") + $m_Lreactbuild_project_drawing_Path$().A__D__D__D__Z__Z__D__D__Lreactbuild_project_drawing_DrawingContext__T(r, r, 180.0, false, false, r, 0.0, context$1)) + " Z")
}
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawComponent$() {
  this.Lreactbuild_project_drawing_DrawComponent$__f_closet = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_door = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_bay = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_glassWall = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_window = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_kitchen = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_shower = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_lm = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_wc = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_te = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_bed = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_ceilLight = null;
  this.Lreactbuild_project_drawing_DrawComponent$__f_wallLight = null;
  $n_Lreactbuild_project_drawing_DrawComponent$ = this;
  this.Lreactbuild_project_drawing_DrawComponent$__f_closet = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "PP([0-9]*)", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_door = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?:P[EI]?[^0-9]|FC)*([0-9]+).*", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_bay = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "BV([0-9]+).*", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_glassWall = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "Verriere([0-9]+).*", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_window = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "F[^0-9]*([0-9]+).*", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_kitchen = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(TTT|PT|PS?|MS?|BB|WT)([HB])([0-9]+)", $m_sci_Nil$()));
  $m_sc_StringOps$();
  $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(?:BB|WT)[0-9]+|FRIGO|Rideau.*|(?:Lum).*", $m_sci_Nil$());
  this.Lreactbuild_project_drawing_DrawComponent$__f_shower = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "ReceveurDouche([0-9]+)(?:x([0-9]+))?", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_lm = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "LM([0-9]+)?", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_wc = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "WC", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_te = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "TE", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_bed = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "LIT([0-9]+).*", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_ceilLight = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "Lum.*", $m_sci_Nil$()));
  this.Lreactbuild_project_drawing_DrawComponent$__f_wallLight = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "Appliq.*", $m_sci_Nil$()))
}
$c_Lreactbuild_project_drawing_DrawComponent$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawComponent$.prototype.constructor = $c_Lreactbuild_project_drawing_DrawComponent$;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawComponent$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawComponent$.prototype = $c_Lreactbuild_project_drawing_DrawComponent$.prototype;
$c_Lreactbuild_project_drawing_DrawComponent$.prototype.apply__Lreactbuild_format_iz2use_package$GenerateGeometry__Ljapgolly_scalajs_react_extra_StateSnapshotF__T__Z__s_Option__T__T__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(geometry, componentGroup, definition, invertX, width, transform, textOrientation, context) {
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseUp");
  var $$x1 = new $c_sjsr_AnonFunction1(((e$2) => {
    var $$x3 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$();
    $m_Ljapgolly_scalajs_react_package$();
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$4 = $n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_tool);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$6 = $n(this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$6.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$7 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$7.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$4.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    $as_s_Option(arg1);
    var arg1$1 = new $c_s_Some(new $c_Lreactbuild_project_drawing_tool_EditingComponent(componentGroup, transform));
    var self = $n($$x2).toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x3).asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0(self, e$2))
  }));
  var this$10 = $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$();
  var F = $m_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$();
  var clickHandler = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod($$x1, $f_Ljapgolly_scalajs_react_vdom_Attr$EventCallback2__dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(this$10, F));
  if ((definition !== null)) {
    var o20 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_bed).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o20).isEmpty__Z()) && (($n(o20).get__O() !== null) && ($n($as_sci_List($n(o20).get__O())).lengthCompare__I__I(1) === 0)))) {
      var sizeCm = $as_T($n($as_sc_LinearSeqOps($n(o20).get__O())).apply__I__O(0));
      var this$11 = $n(context);
      var part = $m_Lreactbuild_project_drawing_Furniture$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$11.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var size = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(sizeCm)));
        var $$x15 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x14 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$17 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
        var a = ("" + $n(context).apply__D__T(((-size) / 2.0)));
        var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x13 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$17.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$20 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
        var a$1 = ("" + $n(context).apply__D__T(size));
        var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x12 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$20.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$23 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
        var a$2 = ("" + $n(context).apply__D__T(1900.0));
        var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x11 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$23.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$2);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$26 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x10 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$26.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$30 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$29 = $n(context);
        var part$1 = $m_Lreactbuild_project_drawing_Furniture$();
        var a$3 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$29, part$1);
        var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x9 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$30.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$3);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$33 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$5 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array = [$$x13, $$x12, $$x11, $$x10, $$x9, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$5, this$33.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1"), clickHandler];
        var $$x8 = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
        var $$x7 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = (sizeCm + "x190");
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$42 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
        var t$6 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$6, this$42.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "middle");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$46 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var this$45 = $n(context);
        var part$2 = $m_Lreactbuild_project_drawing_Furniture$();
        var a$4 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$45, part$2);
        var t$7 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$7, this$46.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$4);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$49 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$5 = (("translate(" + $n(context).apply__D__D__T(0.0, (-1900.0))) + ") translate(0,-2)");
        var t$8 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$1 = [$$x6, $$x5, $$x4, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$8, this$49.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$5)];
        var array$2 = [$$x8, $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
        return $n($$x15).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
      }
    }
  };
  if ((definition !== null)) {
    var o22 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_kitchen).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o22).isEmpty__Z()) && (($n(o22).get__O() !== null) && ($n($as_sci_List($n(o22).get__O())).lengthCompare__I__I(3) === 0)))) {
      var module = $as_T($n($as_sc_LinearSeqOps($n(o22).get__O())).apply__I__O(0));
      var level = $as_T($n($as_sc_LinearSeqOps($n(o22).get__O())).apply__I__O(1));
      var widthCm = $as_T($n($as_sc_LinearSeqOps($n(o22).get__O())).apply__I__O(2));
      var this$56 = $n(context);
      var part$3 = $m_Lreactbuild_project_drawing_KitchenFurniture$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$56.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$3)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var depth = ((level === "B") ? 600 : 420);
        var width$1 = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(widthCm)));
        var this$59 = $n(module);
        if (((this$59.length >= 0) && ($as_T(this$59.substring(0, 1)) === "M"))) {
          var translate2 = "2,-2"
        } else {
          var translate2 = "2,11"
        };
        var translate1 = ((level === "B") ? $n(context).apply__D__D__T(0.0, ((-depth) | 0)) : "0 11");
        var $$x32 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var this$60 = $n(module);
        if (($uI(this$60.indexOf("M")) !== (-1))) {
          var $$x24 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$64 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
          var a$6 = $n(context).apply__D__T(width$1);
          var t$9 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x23 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$9, this$64.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$6);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$67 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
          var a$7 = $n(context).apply__D__T(depth);
          var t$10 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x22 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$10, this$67.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$7);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$71 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
          var this$70 = $n(context);
          var part$4 = $m_Lreactbuild_project_drawing_KitchenFurniture$();
          var a$8 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$70, part$4);
          var t$11 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x21 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$11, this$71.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$8);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$74 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
          var t$12 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x20 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$12, this$74.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$77 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
          var a$9 = ("" + $p_Lreactbuild_project_drawing_DrawComponent$__flippedTransform$1__D__Z__Lreactbuild_project_drawing_DrawingContext__T(this, width$1, invertX, context));
          var t$13 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$3 = [$$x23, $$x22, $$x21, $$x20, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$13, this$77.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$9)];
          var $$x19 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
        } else {
          var $$x31 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$84 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
          var a$10 = $m_Lreactbuild_project_drawing_KitchenComponent$().apply__T__D__D__Lreactbuild_project_drawing_DrawingContext__T(module, depth, width$1, context);
          var t$14 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x30 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$14, this$84.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$10);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$87 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeDasharray");
          var t$15 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x29 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$15, this$87.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1 3 6 3");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$91 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
          var this$90 = $n(context);
          var part$5 = $m_Lreactbuild_project_drawing_KitchenFurniture$();
          var a$11 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$90, part$5);
          var t$16 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x28 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$16, this$91.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$11);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$94 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
          var t$17 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x27 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$17, this$94.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0.75");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$97 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
          var t$18 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x26 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$18, this$97.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$100 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeLinecap");
          var t$19 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x25 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$19, this$100.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "round");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$103 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
          var a$12 = ("" + $p_Lreactbuild_project_drawing_DrawComponent$__flippedTransform$1__D__Z__Lreactbuild_project_drawing_DrawingContext__T(this, width$1, invertX, context));
          var t$20 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$4 = [$$x30, $$x29, $$x28, $$x27, $$x26, $$x25, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$20, this$103.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$12), clickHandler];
          var $$x19 = $n($$x31).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
        };
        var $$x18 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x17 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(definition);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$112 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$13 = (((("translate(" + translate1) + ") translate(") + translate2) + ")");
        var t$21 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x16 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$21, this$112.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$13);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$116 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var this$115 = $n(context);
        var part$6 = $m_Lreactbuild_project_drawing_KitchenFurniture$();
        var a$14 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$115, part$6);
        var t$22 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$5 = [$$x17, $$x16, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$22, this$116.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$14)];
        var array$6 = [$$x19, $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
        return $n($$x32).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
      }
    }
  };
  if ((definition !== null)) {
    var o24 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_shower).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o24).isEmpty__Z()) && (($n(o24).get__O() !== null) && ($n($as_sci_List($n(o24).get__O())).lengthCompare__I__I(2) === 0)))) {
      var w = $as_T($n($as_sc_LinearSeqOps($n(o24).get__O())).apply__I__O(0));
      var d = $as_T($n($as_sc_LinearSeqOps($n(o24).get__O())).apply__I__O(1));
      var this$123 = $n(context);
      var part$7 = $m_Lreactbuild_project_drawing_Furniture$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$123.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$7)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var width$2 = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(w)));
        if ((d === null)) {
          var $$x33 = true
        } else {
          var this$126 = $n(d);
          var $$x33 = (this$126 === "")
        };
        if ($$x33) {
          var depth$1 = 900.0
        } else {
          var depth$1 = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(d)))
        };
        var $$x52 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x51 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$132 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
        var a$15 = $n(context).apply__D__T(width$2);
        var t$23 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x50 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$23, this$132.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$15);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$135 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
        var a$16 = $n(context).apply__D__T(depth$1);
        var t$24 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x49 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$24, this$135.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$16);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$138 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var t$25 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x48 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$25, this$138.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "none");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$141 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$26 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x47 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$26, this$141.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$145 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$144 = $n(context);
        var part$8 = $m_Lreactbuild_project_drawing_Furniture$();
        var a$17 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$144, part$8);
        var t$27 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$7 = [$$x50, $$x49, $$x48, $$x47, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$27, this$145.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$17), clickHandler];
        var $$x46 = $n($$x51).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
        var $$x45 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var $$x43 = $m_sc_StringOps$();
        var array$8 = [(width$2 / 10.0), (depth$1 / 10.0)];
        var v$1 = $n($$x43).format$extension__T__sci_Seq__T("%.0fx%.0f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x44 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$157 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
        var t$28 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x42 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$28, this$157.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "middle");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$160 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$18 = (((("translate(" + $n(context).apply__D__T((width$2 / 2.0))) + " ") + ((($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_scale * depth$1) / 2.0) + 5.5)) + ")");
        var t$29 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$9 = [$$x44, $$x42, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$29, this$160.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$18)];
        var $$x41 = $n($$x45).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
        var this$164 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var cond = $uZ($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
        if (cond) {
          var $$x40 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$168 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
          var t$30 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x39 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$30, this$168.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "url(#accessible-area)");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$171 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
          var t$31 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x38 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$31, this$171.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, ".4");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$174 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
          var a$19 = $n(context).apply__D__T(1300.0);
          var t$32 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x37 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$32, this$174.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$19);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$177 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
          var a$20 = $n(context).apply__D__T(800.0);
          var t$33 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x36 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$33, this$177.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$20);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$180 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y");
          var a$21 = $n(context).apply__D__T(depth$1);
          var t$34 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x35 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$34, this$180.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$21);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$183 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
          var t$35 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$10 = [$$x39, $$x38, $$x37, $$x36, $$x35, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$35, this$183.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#0000FF")];
          var $$x34 = $n($$x40).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))
        } else {
          var $$x34 = this$164.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
        };
        var array$11 = [$$x46, $$x41, $$x34];
        return $n($$x52).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
      }
    }
  };
  if ((definition !== null)) {
    var o26 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_closet).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o26).isEmpty__Z()) && (($n(o26).get__O() !== null) && ($n($as_sci_List($n(o26).get__O())).lengthCompare__I__I(1) === 0)))) {
      var this$190 = $n(context);
      var part$9 = $m_Lreactbuild_project_drawing_Joinery$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$190.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$9)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var this$191 = $n(width);
        var totalWidth = $uD((this$191.isEmpty__Z() ? 600.0 : this$191.get__O()));
        if ((totalWidth <= 800.0)) {
          var count = 1
        } else {
          var x = (totalWidth / 800.0);
          var count = $doubleToInt($uD(Math.ceil(x)))
        };
        var w$1 = (totalWidth / count);
        var isEmpty = (count <= 0);
        if (isEmpty) {
          var scala$collection$immutable$Range$$numRangeElements = 0
        } else {
          var hi = (count >> 31);
          var scala$collection$immutable$Range$$numRangeElements = (((hi === 0) ? (((-2147483648) ^ count) > (-1)) : (hi > 0)) ? (-1) : count)
        };
        var scala$collection$immutable$Range$$lastElement = (((-1) + count) | 0);
        if ((scala$collection$immutable$Range$$numRangeElements < 0)) {
          $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, count, 1, false)
        };
        var b = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
        var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
        while (it.sci_RangeIterator__f__hasNext) {
          var this$201 = $n(b);
          var arg1$2 = it.next__I();
          var offset = ((((arg1$2 % 2) | 0) === 0) ? 0.0 : (-40.0));
          var elem = new $c_T2$mcID$sp(arg1$2, offset);
          this$201.addOne__O__scm_Growable(elem)
        };
        var path = $as_sci_IndexedSeq($n($as_sci_IndexedSeq($n(b).result__O())).map__F1__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
          var x$2 = $as_T2(x$2$2);
          if ((x$2 !== null)) {
            var idx = $n(x$2)._1$mcI$sp__I();
            var offset$1 = $n(x$2)._2$mcD$sp__D();
            return ((((((($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T((w$1 * idx), (offset$1 - 40.0), context) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, 40.0, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(w$1, 0.0, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, (-40.0), context)) + " Z")
          } else {
            throw new $c_s_MatchError(x$2)
          }
        }))));
        var $$x58 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x57 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$206 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
        var this$205 = $n(path);
        var a$22 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$205, "", " ", "");
        var t$36 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x56 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$36, this$206.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$22);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$210 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$209 = $n(context);
        var part$10 = $m_Lreactbuild_project_drawing_Joinery$();
        var a$23 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$209, part$10);
        var t$37 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x55 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$37, this$210.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$23);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$213 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$38 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x54 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$38, this$213.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$216 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$39 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x53 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$39, this$216.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$219 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$24 = ("" + $p_Lreactbuild_project_drawing_DrawComponent$__flippedTransform$1__D__Z__Lreactbuild_project_drawing_DrawingContext__T(this, totalWidth, invertX, context));
        var t$40 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$12 = [$$x56, $$x55, $$x54, $$x53, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$40, this$219.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$24), clickHandler];
        var array$13 = [$n($$x57).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
        return $n($$x58).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))
      }
    }
  };
  if ((definition !== null)) {
    var o28 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_door).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o28).isEmpty__Z()) && (($n(o28).get__O() !== null) && ($n($as_sci_List($n(o28).get__O())).lengthCompare__I__I(1) === 0)))) {
      var widthCm$2 = $as_T($n($as_sc_LinearSeqOps($n(o28).get__O())).apply__I__O(0));
      var this$226 = $n(context);
      var part$11 = $m_Lreactbuild_project_drawing_Joinery$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$226.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$11)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var width$3 = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(widthCm$2)));
        var $$x61 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x60 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(definition);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$234 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var t$41 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x59 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$41, this$234.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "rotate(180) translate(-2, -2)");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$237 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
        var t$42 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$14 = [$$x60, $$x59, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$42, this$237.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "end")];
        var label = $n($$x61).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
        var $$x72 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x71 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$244 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
        var a$25 = (((($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T(width$3, 0.0, context) + " ") + $m_Lreactbuild_project_drawing_Path$().a__D__D__D__Z__Z__D__D__Lreactbuild_project_drawing_DrawingContext__T(width$3, width$3, 90.0, false, true, (-width$3), width$3, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().L__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, 0.0, context));
        var t$43 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x70 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$43, this$244.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$25);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$248 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$247 = $n(context);
        var part$12 = $m_Lreactbuild_project_drawing_Joinery$();
        var a$26 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$247, part$12);
        var t$44 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x69 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$44, this$248.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$26);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$251 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$45 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x68 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$45, this$251.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$254 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$46 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x67 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$46, this$254.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$257 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$27 = ("" + $p_Lreactbuild_project_drawing_DrawComponent$__flippedTransform$1__D__Z__Lreactbuild_project_drawing_DrawingContext__T(this, width$3, invertX, context));
        var t$47 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$15 = [$$x70, $$x69, $$x68, $$x67, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$47, this$257.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$27), clickHandler];
        var $$x66 = $n($$x71).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15));
        var $$x65 = $n(label);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$263 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$48 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x64 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$48, this$263.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$266 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var t$49 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x63 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$49, this$266.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#ffffff");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$269 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$50 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$16 = [$$x64, $$x63, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$50, this$269.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "2")];
        var $$x62 = $n($$x65).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$276 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var this$275 = $n(context);
        var part$13 = $m_Lreactbuild_project_drawing_Joinery$();
        var a$28 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$275, part$13);
        var t$51 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$17 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$51, this$276.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$28)];
        var array$18 = [$$x66, $$x62, $n(label).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))];
        return $n($$x72).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))
      }
    }
  };
  if ((definition !== null)) {
    var o30 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_bay).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o30).isEmpty__Z()) && (($n(o30).get__O() !== null) && ($n($as_sci_List($n(o30).get__O())).lengthCompare__I__I(1) === 0)))) {
      var widthCm$3 = $as_T($n($as_sc_LinearSeqOps($n(o30).get__O())).apply__I__O(0));
      var this$283 = $n(context);
      var part$14 = $m_Lreactbuild_project_drawing_Joinery$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$283.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$14)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var width$4 = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(widthCm$3)));
        var $$x75 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x74 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(definition);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$291 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var t$52 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x73 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$52, this$291.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "rotate(180) translate(-2, -2)");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$294 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
        var t$53 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$19 = [$$x74, $$x73, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$53, this$294.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "end")];
        var label$1 = $n($$x75).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19));
        var w$2 = (width$4 / 2.0);
        var b$1 = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
        var it$1 = new $c_sci_RangeIterator(0, 1, 1, false);
        while (it$1.sci_RangeIterator__f__hasNext) {
          var this$301 = $n(b$1);
          var arg1$3 = it$1.next__I();
          var offset$2 = ((((arg1$3 % 2) | 0) === 0) ? 0.0 : (-40.0));
          var elem$1 = new $c_T2$mcID$sp(arg1$3, offset$2);
          this$301.addOne__O__scm_Growable(elem$1)
        };
        var path$1 = $as_sci_IndexedSeq($n($as_sci_IndexedSeq($n(b$1).result__O())).map__F1__O(new $c_sjsr_AnonFunction1(((x$3$2) => {
          var x$3 = $as_T2(x$3$2);
          if ((x$3 !== null)) {
            var idx$1 = $n(x$3)._1$mcI$sp__I();
            var offset$3 = $n(x$3)._2$mcD$sp__D();
            return ((((((($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T((w$2 * idx$1), (offset$3 - 40.0), context) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, 40.0, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(w$2, 0.0, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, (-40.0), context)) + " Z")
          } else {
            throw new $c_s_MatchError(x$3)
          }
        }))));
        var $$x86 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x85 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$306 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
        var this$305 = $n(path$1);
        var a$29 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$305, "", " ", "");
        var t$54 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x84 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$54, this$306.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$29);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$310 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$309 = $n(context);
        var part$15 = $m_Lreactbuild_project_drawing_Joinery$();
        var a$30 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$309, part$15);
        var t$55 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x83 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$55, this$310.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$30);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$313 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$56 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x82 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$56, this$313.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$316 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$57 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x81 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$57, this$316.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$319 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$31 = ("" + $p_Lreactbuild_project_drawing_DrawComponent$__flippedTransform$1__D__Z__Lreactbuild_project_drawing_DrawingContext__T(this, width$4, invertX, context));
        var t$58 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$20 = [$$x84, $$x83, $$x82, $$x81, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$58, this$319.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$31), clickHandler];
        var $$x80 = $n($$x85).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20));
        var $$x79 = $n(label$1);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$325 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$59 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x78 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$59, this$325.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$328 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var t$60 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x77 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$60, this$328.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#ffffff");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$331 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$61 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$21 = [$$x78, $$x77, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$61, this$331.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "2")];
        var $$x76 = $n($$x79).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21));
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$338 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var this$337 = $n(context);
        var part$16 = $m_Lreactbuild_project_drawing_Joinery$();
        var a$32 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$337, part$16);
        var t$62 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$22 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$62, this$338.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$32)];
        var array$23 = [$$x80, $$x76, $n(label$1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22))];
        return $n($$x86).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23))
      }
    }
  };
  if ((definition !== null)) {
    var o32 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_glassWall).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o32).isEmpty__Z()) && (($n(o32).get__O() !== null) && ($n($as_sci_List($n(o32).get__O())).lengthCompare__I__I(1) === 0)))) {
      var widthCm$4 = $as_T($n($as_sc_LinearSeqOps($n(o32).get__O())).apply__I__O(0));
      var this$345 = $n(context);
      var part$17 = $m_Lreactbuild_project_drawing_Joinery$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$345.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$17)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var width$5 = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(widthCm$4)));
        var $$x89 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x88 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(definition);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$353 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var t$63 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x87 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$63, this$353.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "rotate(180) translate(-2, -2)");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$356 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
        var t$64 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$24 = [$$x88, $$x87, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$64, this$356.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "end")];
        var label$2 = $n($$x89).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24));
        var x$4 = ((width$5 - 360.0) / 320.0);
        var count$1 = ($uD(Math.ceil(x$4)) + 1.0);
        var w$3 = (width$5 / count$1);
        var end = $doubleToInt(count$1);
        var isEmpty$1 = (end <= 0);
        if (isEmpty$1) {
          var scala$collection$immutable$Range$$numRangeElements$1 = 0
        } else {
          var hi$2 = (end >> 31);
          var scala$collection$immutable$Range$$numRangeElements$1 = (((hi$2 === 0) ? (((-2147483648) ^ end) > (-1)) : (hi$2 > 0)) ? (-1) : end)
        };
        var scala$collection$immutable$Range$$lastElement$1 = (((-1) + end) | 0);
        if ((scala$collection$immutable$Range$$numRangeElements$1 < 0)) {
          $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, end, 1, false)
        };
        var b$2 = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
        var it$2 = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement$1, isEmpty$1);
        while (it$2.sci_RangeIterator__f__hasNext) {
          var this$369 = $n(b$2);
          var arg1$4 = it$2.next__I();
          var elem$2 = ((((((($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T((w$3 * arg1$4), 0.0, context) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, (-74.0), context)) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(w$3, 0.0, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, 74.0, context)) + " Z");
          this$369.addOne__O__scm_Growable(elem$2)
        };
        var path$2 = $as_sci_IndexedSeq($n(b$2).result__O());
        var $$x100 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x99 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$374 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
        var this$373 = $n(path$2);
        var a$33 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$373, "", " ", "");
        var t$65 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x98 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$65, this$374.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$33);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$378 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$377 = $n(context);
        var part$18 = $m_Lreactbuild_project_drawing_Joinery$();
        var a$34 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$377, part$18);
        var t$66 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x97 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$66, this$378.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$34);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$381 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$67 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x96 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$67, this$381.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$384 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$68 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x95 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$68, this$384.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$387 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$35 = ("" + $p_Lreactbuild_project_drawing_DrawComponent$__flippedTransform$1__D__Z__Lreactbuild_project_drawing_DrawingContext__T(this, width$5, invertX, context));
        var t$69 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$25 = [$$x98, $$x97, $$x96, $$x95, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$69, this$387.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$35), clickHandler];
        var $$x94 = $n($$x99).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25));
        var $$x93 = $n(label$2);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$393 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$70 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x92 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$70, this$393.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$396 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var t$71 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x91 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$71, this$396.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#ffffff");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$399 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$72 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$26 = [$$x92, $$x91, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$72, this$399.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "2")];
        var $$x90 = $n($$x93).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$26));
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$406 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var this$405 = $n(context);
        var part$19 = $m_Lreactbuild_project_drawing_Joinery$();
        var a$36 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$405, part$19);
        var t$73 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$27 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$73, this$406.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$36)];
        var array$28 = [$$x94, $$x90, $n(label$2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$27))];
        return $n($$x100).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$28))
      }
    }
  };
  if ((definition !== null)) {
    var o34 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_window).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o34).isEmpty__Z()) && (($n(o34).get__O() !== null) && ($n($as_sci_List($n(o34).get__O())).lengthCompare__I__I(1) === 0)))) {
      var widthCm$5 = $as_T($n($as_sc_LinearSeqOps($n(o34).get__O())).apply__I__O(0));
      var this$413 = $n(context);
      var part$20 = $m_Lreactbuild_project_drawing_Joinery$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$413.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$20)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var width$6 = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(widthCm$5)));
        var $$x103 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x102 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(definition);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$421 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
        var t$74 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x101 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$74, this$421.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "start");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$424 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$37 = (("translate(" + $n(context).apply__D__D__T(width$6, 0.0)) + ") rotate(180) translate(2,-2)");
        var t$75 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$29 = [$$x102, $$x101, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$75, this$424.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$37)];
        var label$3 = $n($$x103).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$29));
        var $$x114 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x113 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$431 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
        var a$38 = (((((((((($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, 0.0, context) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(width$6, 0.0, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, (width$6 / 2.0), context)) + " ") + $m_Lreactbuild_project_drawing_Path$().a__D__D__D__Z__Z__D__D__Lreactbuild_project_drawing_DrawingContext__T((width$6 / 2.0), (width$6 / 2.0), 90.0, false, true, ((-width$6) / 2.0), ((-width$6) / 2.0), context)) + " ") + $m_Lreactbuild_project_drawing_Path$().a__D__D__D__Z__Z__D__D__Lreactbuild_project_drawing_DrawingContext__T((width$6 / 2.0), (width$6 / 2.0), 90.0, false, true, ((-width$6) / 2.0), (width$6 / 2.0), context)) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, ((-width$6) / 2.0), context));
        var t$76 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x112 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$76, this$431.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$38);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$435 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$434 = $n(context);
        var part$21 = $m_Lreactbuild_project_drawing_Joinery$();
        var a$39 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$434, part$21);
        var t$77 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x111 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$77, this$435.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$39);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$438 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$78 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x110 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$78, this$438.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$441 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$79 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x109 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$79, this$441.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$444 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$40 = ("" + $p_Lreactbuild_project_drawing_DrawComponent$__flippedTransform$1__D__Z__Lreactbuild_project_drawing_DrawingContext__T(this, width$6, invertX, context));
        var t$80 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$30 = [$$x112, $$x111, $$x110, $$x109, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$80, this$444.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$40), clickHandler];
        var $$x108 = $n($$x113).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$30));
        var $$x107 = $n(label$3);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$450 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$81 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x106 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$81, this$450.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$453 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var t$82 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x105 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$82, this$453.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#ffffff");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$456 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$83 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$31 = [$$x106, $$x105, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$83, this$456.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "2")];
        var $$x104 = $n($$x107).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$31));
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$463 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var this$462 = $n(context);
        var part$22 = $m_Lreactbuild_project_drawing_Joinery$();
        var a$41 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$462, part$22);
        var t$84 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$32 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$84, this$463.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$41)];
        var array$33 = [$$x108, $$x104, $n(label$3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$32))];
        return $n($$x114).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$33))
      }
    }
  };
  if ((definition !== null)) {
    var o36 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_ceilLight).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o36).isEmpty__Z()) && (($n(o36).get__O() !== null) && ($n($as_sci_List($n(o36).get__O())).lengthCompare__I__I(0) === 0)))) {
      var this$470 = $n(context);
      var part$23 = $m_Lreactbuild_project_drawing_Furniture$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$470.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$23)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var this$517 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
        if ($uZ($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_lightArea).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)) {
          var $$x126 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$474 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "mask");
          var a$42 = (("url(#" + $n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_ids).apply__O__O(geometry)) + ")");
          var t$85 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x125 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$85, this$474.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$42);
          var $$x124 = $p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform);
          var $$x123 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$478 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "r");
          var a$43 = ("" + $n(context).apply__D__T(2500.0));
          var t$86 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x122 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$86, this$478.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$43);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$481 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
          var t$87 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
          var $$x121 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$87, this$481.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0.3);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$484 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
          var t$88 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x120 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$88, this$484.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "url(#lightCircleArea)");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$487 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "pointerEvents");
          var t$89 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$34 = [$$x122, $$x121, $$x120, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$89, this$487.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "none")];
          var array$35 = [$n($$x123).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("circle", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$34))];
          var array$36 = [$$x125, $n($$x124).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$35))];
          var $$x119 = $n($$x126).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("g", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$36))
        } else {
          var $$x119 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
        };
        var $$x118 = $p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform);
        var $$x117 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$500 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "r");
        var a$44 = ("" + $n(context).apply__D__T(100.0));
        var t$90 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x116 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$90, this$500.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$44);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$503 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$91 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
        var $$x115 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$91, this$503.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$507 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$506 = $n(context);
        var part$24 = $m_Lreactbuild_project_drawing_Furniture$();
        var a$45 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$506, part$24);
        var t$92 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$37 = [$$x116, $$x115, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$92, this$507.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$45), clickHandler];
        var array$38 = [$n($$x117).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("circle", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$37))];
        var array$39 = [$$x119, $n($$x118).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$38))];
        var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$39);
        return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$517, null, ns)
      }
    }
  };
  if ((definition !== null)) {
    var o38 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_wallLight).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o38).isEmpty__Z()) && (($n(o38).get__O() !== null) && ($n($as_sci_List($n(o38).get__O())).lengthCompare__I__I(0) === 0)))) {
      var this$518 = $n(context);
      var part$25 = $m_Lreactbuild_project_drawing_Furniture$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$518.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$25)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var $$x135 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        if ($uZ($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_lightArea).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)) {
          var $$x134 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$522 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
          var a$46 = $p_Lreactbuild_project_drawing_DrawComponent$__halfCircle$1__D__Lreactbuild_project_drawing_DrawingContext__T(this, 2500.0, context);
          var t$93 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x133 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$93, this$522.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$46);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$525 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
          var t$94 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
          var $$x132 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$94, this$525.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0.3);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$528 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
          var t$95 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x131 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$95, this$528.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "url(#lightHalfCircleArea)");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$531 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "pointerEvents");
          var t$96 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$40 = [$$x133, $$x132, $$x131, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$96, this$531.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "none")];
          var $$x130 = $n($$x134).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$40))
        } else {
          var $$x130 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
        };
        var $$x129 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$538 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
        var a$47 = $p_Lreactbuild_project_drawing_DrawComponent$__halfCircle$1__D__Lreactbuild_project_drawing_DrawingContext__T(this, 100.0, context);
        var t$97 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x128 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$97, this$538.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$47);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$541 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
        var t$98 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
        var $$x127 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$98, this$541.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$545 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$544 = $n(context);
        var part$26 = $m_Lreactbuild_project_drawing_Furniture$();
        var a$48 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$544, part$26);
        var t$99 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$41 = [$$x128, $$x127, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$99, this$545.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$48), clickHandler];
        var array$42 = [$$x130, $n($$x129).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$41))];
        return $n($$x135).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$42))
      }
    }
  };
  if ((definition !== null)) {
    var o40 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_te).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o40).isEmpty__Z()) && (($n(o40).get__O() !== null) && ($n($as_sci_List($n(o40).get__O())).lengthCompare__I__I(0) === 0)))) {
      var this$552 = $n(context);
      var part$27 = $m_Lreactbuild_project_drawing_Furniture$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$552.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$27)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var $$x136 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var array$43 = [$m_Ljapgolly_scalajs_react_vdom_SvgTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($m_Ljapgolly_scalajs_react_vdom_all$svg$(), "path"), $m_sci_Nil$())];
        return $n($$x136).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$43))
      }
    }
  };
  if ((definition !== null)) {
    var o42 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_shower).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o42).isEmpty__Z()) && (($n(o42).get__O() !== null) && ($n($as_sci_List($n(o42).get__O())).lengthCompare__I__I(2) === 0)))) {
      var w$2$1 = $as_T($n($as_sc_LinearSeqOps($n(o42).get__O())).apply__I__O(0));
      var d$2 = $as_T($n($as_sc_LinearSeqOps($n(o42).get__O())).apply__I__O(1));
      var width$2$1 = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(w$2$1)));
      var depth$2 = ((d$2 === null) ? 900.0 : (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(d$2))));
      var this$561 = $n(context);
      var part$28 = $m_Lreactbuild_project_drawing_Furniture$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$561.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$28)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var $$x148 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x147 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$565 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
        var a$49 = ((((((($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, 0.0, context) + " ") + $m_Lreactbuild_project_drawing_Path$().H__D__Lreactbuild_project_drawing_DrawingContext__T(width$2$1, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().V__D__Lreactbuild_project_drawing_DrawingContext__T(depth$2, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().H__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, context)) + " z");
        var t$100 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x146 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$100, this$565.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$49);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$568 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var t$101 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x145 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$101, this$568.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "none");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$572 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$571 = $n(context);
        var part$29 = $m_Lreactbuild_project_drawing_Furniture$();
        var a$50 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$571, part$29);
        var t$102 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$44 = [$$x146, $$x145, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$102, this$572.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$50), clickHandler];
        var $$x144 = $n($$x147).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$44));
        var this$576 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var cond$1 = $uZ($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
        if (cond$1) {
          var $$x143 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$580 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
          var t$103 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x142 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$103, this$580.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "url(#accessible-area)");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$583 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
          var a$51 = $n(context).apply__D__T(800.0);
          var t$104 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x141 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$104, this$583.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$51);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$586 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
          var a$52 = $n(context).apply__D__T(1300.0);
          var t$105 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x140 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$105, this$586.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$52);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$589 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y");
          var a$53 = $n(context).apply__D__T(depth$2);
          var t$106 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x139 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$106, this$589.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$53);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$592 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
          var t$107 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x138 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$107, this$592.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, ".4");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$595 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
          var t$108 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$45 = [$$x142, $$x141, $$x140, $$x139, $$x138, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$108, this$595.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#0000FF")];
          var $$x137 = $n($$x143).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$45))
        } else {
          var $$x137 = this$576.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
        };
        var array$46 = [$$x144, $$x137];
        return $n($$x148).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$46))
      }
    }
  };
  if ((definition !== null)) {
    var o44 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_lm).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o44).isEmpty__Z()) && (($n(o44).get__O() !== null) && ($n($as_sci_List($n(o44).get__O())).lengthCompare__I__I(1) === 0)))) {
      var w$3$1 = $as_T($n($as_sc_LinearSeqOps($n(o44).get__O())).apply__I__O(0));
      var width$3$1 = ((w$3$1 === null) ? 600.0 : (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(w$3$1))));
      var this$604 = $n(context);
      var part$30 = $m_Lreactbuild_project_drawing_Furniture$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$604.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$30)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var $$x160 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x159 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$608 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
        var a$54 = ((((((($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, 0.0, context) + " ") + $m_Lreactbuild_project_drawing_Path$().H__D__Lreactbuild_project_drawing_DrawingContext__T(width$3$1, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().V__D__Lreactbuild_project_drawing_DrawingContext__T(400.0, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().H__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, context)) + " z");
        var t$109 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x158 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$109, this$608.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$54);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$611 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var t$110 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x157 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$110, this$611.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "none");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$615 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$614 = $n(context);
        var part$31 = $m_Lreactbuild_project_drawing_Furniture$();
        var a$55 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$614, part$31);
        var t$111 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$47 = [$$x158, $$x157, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$111, this$615.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$55), clickHandler];
        var $$x156 = $n($$x159).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$47));
        var this$619 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var cond$2 = $uZ($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
        if (cond$2) {
          var $$x155 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$623 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
          var t$112 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x154 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$112, this$623.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "url(#accessible-area)");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$626 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
          var a$56 = $n(context).apply__D__T(1300.0);
          var t$113 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x153 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$113, this$626.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$56);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$629 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
          var a$57 = $n(context).apply__D__T(800.0);
          var t$114 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x152 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$114, this$629.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$57);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$632 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y");
          var a$58 = $n(context).apply__D__T(400.0);
          var t$115 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x151 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$115, this$632.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$58);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$635 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
          var t$116 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x150 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$116, this$635.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, ".4");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$638 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
          var t$117 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$48 = [$$x154, $$x153, $$x152, $$x151, $$x150, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$117, this$638.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#0000FF")];
          var $$x149 = $n($$x155).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$48))
        } else {
          var $$x149 = this$619.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
        };
        var array$49 = [$$x156, $$x149];
        return $n($$x160).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$49))
      }
    }
  };
  if ((definition !== null)) {
    var o46 = $n(this.Lreactbuild_project_drawing_DrawComponent$__f_wc).unapplySeq__jl_CharSequence__s_Option(definition);
    if (((!$n(o46).isEmpty__Z()) && (($n(o46).get__O() !== null) && ($n($as_sci_List($n(o46).get__O())).lengthCompare__I__I(0) === 0)))) {
      var this$645 = $n(context);
      var part$32 = $m_Lreactbuild_project_drawing_Furniture$();
      if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$645.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$32)) {
        return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      } else {
        var $$x186 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
        var $$x185 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$652 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
        var $$x183 = $m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, 66.0, context);
        var $$x182 = $m_Lreactbuild_project_drawing_Path$().H__D__Lreactbuild_project_drawing_DrawingContext__T(385.0, context);
        var $$x181 = $m_Lreactbuild_project_drawing_Path$().V__D__Lreactbuild_project_drawing_DrawingContext__T(226.0, context);
        var $$x180 = $m_Lreactbuild_project_drawing_Path$().H__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, context);
        var $$x179 = $m_Lreactbuild_project_drawing_Path$().m__D__D__Lreactbuild_project_drawing_DrawingContext__T(60.0, 160.0, context);
        var $$x178 = $m_Lreactbuild_project_drawing_Path$();
        var array$50 = [0.0, 0.0, (-45.0), 175.0, (-45.0), 255.0, 0.0, 245.0, 177.5, 245.0, 177.5, 245.0, 0.0, 0.0, 177.5, 0.0, 177.5, (-245.0), 0.0, (-80.0), (-45.0), (-255.0), (-45.0), (-255.0)];
        var a$59 = ((((((((((($$x183 + " ") + $$x182) + " ") + $$x181) + " ") + $$x180) + " Z ") + $$x179) + " ") + $n($$x178).c__sci_Seq__Lreactbuild_project_drawing_DrawingContext__T($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$50), context)) + " z");
        var t$118 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x184 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$118, this$652.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$59);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$655 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
        var t$119 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x177 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$119, this$655.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "none");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$658 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillRule");
        var t$120 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x176 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$120, this$658.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$662 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var this$661 = $n(context);
        var part$33 = $m_Lreactbuild_project_drawing_Furniture$();
        var a$60 = $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$661, part$33);
        var t$121 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$51 = [$$x184, $$x177, $$x176, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$121, this$662.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$60), clickHandler];
        var $$x175 = $n($$x185).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$51));
        var this$666 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var cond$3 = $uZ($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
        if (cond$3) {
          var this$714 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
          var $$x174 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$670 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
          var t$122 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x173 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$122, this$670.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "url(#accessible-area)");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$673 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
          var a$61 = $n(context).apply__D__T(1300.0);
          var t$123 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x172 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$123, this$673.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$61);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$676 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
          var a$62 = $n(context).apply__D__T(800.0);
          var t$124 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x171 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$124, this$676.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$62);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$679 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
          var a$63 = $n(context).apply__D__T(400.0);
          var t$125 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x170 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$125, this$679.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$63);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$682 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
          var t$126 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x169 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$126, this$682.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, ".4");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$685 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
          var t$127 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$52 = [$$x173, $$x172, $$x171, $$x170, $$x169, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$127, this$685.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#0000FF")];
          var $$x168 = $n($$x174).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$52));
          var $$x167 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$692 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
          var t$128 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x166 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$128, this$692.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "url(#accessible-area)");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$695 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
          var a$64 = $n(context).apply__D__T(1300.0);
          var t$129 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x165 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$129, this$695.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$64);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$698 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
          var a$65 = $n(context).apply__D__T(800.0);
          var t$130 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x164 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$130, this$698.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$65);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$701 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
          var a$66 = $n(context).apply__D__T((-800.0));
          var t$131 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x163 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$131, this$701.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$66);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$704 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
          var t$132 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var $$x162 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$132, this$704.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, ".4");
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$707 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
          var t$133 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$53 = [$$x166, $$x165, $$x164, $$x163, $$x162, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$133, this$707.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#0000FF")];
          var array$54 = [$$x168, $n($$x167).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$53))];
          var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$54);
          var $$x161 = this$714.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
        } else {
          var $$x161 = this$666.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
        };
        var array$55 = [$$x175, $$x161];
        return $n($$x186).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$55))
      }
    }
  };
  var this$718 = $n(context);
  var part$34 = $m_Lreactbuild_project_drawing_Furniture$();
  if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$718.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part$34)) {
    return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  } else {
    var $$x189 = $n($p_Lreactbuild_project_drawing_DrawComponent$__wrapComponent$1__T__Ljapgolly_scalajs_react_vdom_TagOf(this, transform));
    var $$x188 = $p_Lreactbuild_project_drawing_DrawComponent$__default$1__s_Option__Lreactbuild_project_drawing_DrawingContext__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagOf(this, width, context, definition, clickHandler);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$721 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
    var t$134 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x187 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$134, this$721.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0.3");
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$724 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeOpacity");
    var t$135 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array$56 = [$$x187, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$135, this$724.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0")];
    var array$57 = [$n($$x188).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$56))];
    return $n($$x189).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$57))
  }
});
var $d_Lreactbuild_project_drawing_DrawComponent$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawComponent$: 0
}, false, "reactbuild.project.drawing.DrawComponent$", {
  Lreactbuild_project_drawing_DrawComponent$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_DrawComponent$.prototype.$classData = $d_Lreactbuild_project_drawing_DrawComponent$;
var $n_Lreactbuild_project_drawing_DrawComponent$;
function $m_Lreactbuild_project_drawing_DrawComponent$() {
  if ((!$n_Lreactbuild_project_drawing_DrawComponent$)) {
    $n_Lreactbuild_project_drawing_DrawComponent$ = new $c_Lreactbuild_project_drawing_DrawComponent$()
  };
  return $n_Lreactbuild_project_drawing_DrawComponent$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawStorey$() {
  this.Lreactbuild_project_drawing_DrawStorey$__f_component = null;
  $n_Lreactbuild_project_drawing_DrawStorey$ = this;
  var this$9 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DrawStorey", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_project_drawing_DrawStorey$Props(p$2);
    return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_drawing_DrawStorey$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    $n($as_Lreactbuild_project_drawing_DrawStorey$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    $as_Lreactbuild_project_drawing_DrawStorey$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    var s = $as_Ljapgolly_scalajs_react_vdom_VdomNode($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5));
    return s
  }))));
  var f = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$2);
    var $$x1 = $as_Lreactbuild_project_drawing_DrawStorey$Backend($n(\u03b4).backend__O());
    var this$7 = $n(\u03b4);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).recomputeData__Lreactbuild_project_drawing_DrawStorey$Props__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_project_drawing_DrawStorey$Props($n(this$7.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$11 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$9, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f, G));
  var f$1 = new $c_sjsr_AnonFunction1(((\u03b4$3$2) => {
    var \u03b4$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(\u03b4$3$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_project_drawing_DrawStorey$Backend($n(\u03b4$3).backend__O())).recomputeData__Lreactbuild_project_drawing_DrawStorey$Props__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_project_drawing_DrawStorey$Props($n(\u03b4$3).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps)))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_project_drawing_DrawStorey$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$11, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_DrawStorey$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawStorey$.prototype.constructor = $c_Lreactbuild_project_drawing_DrawStorey$;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawStorey$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawStorey$.prototype = $c_Lreactbuild_project_drawing_DrawStorey$.prototype;
$c_Lreactbuild_project_drawing_DrawStorey$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_project_drawing_LOD__Lreactbuild_project_drawing_BoxedDrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(storeySS, lod, context) {
  var c = this.Lreactbuild_project_drawing_DrawStorey$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_drawing_DrawStorey$Props(storeySS, lod, context);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_project_drawing_DrawStorey$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawStorey$: 0
}, false, "reactbuild.project.drawing.DrawStorey$", {
  Lreactbuild_project_drawing_DrawStorey$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_DrawStorey$.prototype.$classData = $d_Lreactbuild_project_drawing_DrawStorey$;
var $n_Lreactbuild_project_drawing_DrawStorey$;
function $m_Lreactbuild_project_drawing_DrawStorey$() {
  if ((!$n_Lreactbuild_project_drawing_DrawStorey$)) {
    $n_Lreactbuild_project_drawing_DrawStorey$ = new $c_Lreactbuild_project_drawing_DrawStorey$()
  };
  return $n_Lreactbuild_project_drawing_DrawStorey$
}
function $p_Lreactbuild_project_drawing_DrawWallSides$__loop$1__I__Lreactbuild_geom_Vector2Based__sci_List__sci_List__sci_List__Lreactbuild_project_drawing_DrawingContext__T__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_format_iz2use_package$GenerateGeometry__T2($thiz, sideIndex, origin, sides, accVectors, accNodes, context$1, suffixTransform$1, geometry$1, geometryValue$1) {
  while (true) {
    var x1 = sides;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var $$x1 = accVectors;
      var this$1 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var ns = accNodes;
      return $ct_T2__O__O__(new $c_T2(), $$x1, $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$1, null, ns))
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $as_Lreactbuild_format_iz2use_package$Side($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      var wallVector = $n(head).Lreactbuild_format_iz2use_package$Side__f_edge;
      var this$2 = $n($m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2(wallVector));
      if ((this$2.Lreactbuild_geom_Vector2__f_x === 0.0)) {
        $m_Lreactbuild_math_package$SquareRoot$();
        var x$1 = this$2.Lreactbuild_geom_Vector2__f_y;
        var length = $uD(Math.abs(x$1));
        var sq = (length * length);
        var sqrt = $uD(Math.abs(length));
        var wallVectorMagnitude = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt)
      } else if ((this$2.Lreactbuild_geom_Vector2__f_y === 0.0)) {
        $m_Lreactbuild_math_package$SquareRoot$();
        var x$2 = this$2.Lreactbuild_geom_Vector2__f_x;
        var length$1 = $uD(Math.abs(x$2));
        var sq$1 = (length$1 * length$1);
        var sqrt$1 = $uD(Math.abs(length$1));
        var wallVectorMagnitude = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$1, sqrt$1)
      } else {
        $m_Lreactbuild_math_package$SquareRoot$();
        var v = this$2.Lreactbuild_geom_Vector2__f_x;
        var v$1 = this$2.Lreactbuild_geom_Vector2__f_y;
        var value = ((v * v) + (v$1 * v$1));
        var wallVectorMagnitude = new $c_Lreactbuild_math_package$LazySquareRoot(value)
      };
      var this$28 = $n($m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2(wallVector));
      var y = this$28.Lreactbuild_geom_Vector2__f_y;
      var x$3 = this$28.Lreactbuild_geom_Vector2__f_x;
      var x$4 = $uD(Math.atan2(y, x$3));
      var angle = (-((180.0 * x$4) / 3.141592653589793));
      var this$34 = $n(context$1);
      var v$2 = origin;
      var transformSideBase = ((((("translate(" + this$34.apply__D__D__T($n(v$2).x__D(), $n(v$2).y__D())) + ") rotate(") + angle) + ") ") + suffixTransform$1);
      var textTransform = (("rotate(" + (-angle)) + ")");
      var this$35 = $n($n(head).Lreactbuild_format_iz2use_package$Side__f_componentGroups);
      var $$x2 = $n($as_sc_IterableOps($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$35))).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
        var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
        return (check$ifrefutable$1 !== null)
      })));
      var sideIndex$2 = sideIndex;
      var components = $as_sci_List($n($$x2).flatMap__F1__O(new $c_sjsr_AnonFunction1(((wallVectorMagnitude, geometry$1, sideIndex$1, head, transformSideBase, context$1, geometryValue$1, textTransform) => ((x$1$2) => {
        var x$1$1 = $as_T2(x$1$2);
        if ((x$1$1 !== null)) {
          var componentGroup = $as_Lreactbuild_format_iz2use_package$ComponentGroup($n(x$1$1)._1__O());
          var idx = $n(x$1$1)._2$mcI$sp__I();
          var this$37 = $n(componentGroup);
          var this$52 = $n($p_Lreactbuild_format_iz2use_package$ComponentGroup__loop$2__D__sci_List__sci_List__sci_List(this$37, 0.0, this$37.Lreactbuild_format_iz2use_package$ComponentGroup__f_columns, $m_s_package$().s_package$__f_Nil));
          var f = ((cmp$2) => {
            var cmp = $as_Lreactbuild_format_iz2use_package$ExpandedComponent(cmp$2);
            var x1$1 = $n(cmp).Lreactbuild_format_iz2use_package$ExpandedComponent__f_definition;
            matchEnd4: {
              var width;
              if ((x1$1 !== null)) {
                var o7 = $n($m_Lreactbuild_format_iz2use_package$().Lreactbuild_format_iz2use_package$__f_componentLengthPattern).unapplySeq__jl_CharSequence__s_Option(x1$1);
                if (((!$n(o7).isEmpty__Z()) && (($n(o7).get__O() !== null) && ($n($as_sci_List($n(o7).get__O())).lengthCompare__I__I(1) === 0)))) {
                  var w = $as_T($n($as_sc_LinearSeqOps($n(o7).get__O())).apply__I__O(0));
                  var width = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(w)));
                  break matchEnd4
                }
              };
              var width = 600.0
            };
            var x0 = (($n(cmp).Lreactbuild_format_iz2use_package$ExpandedComponent__f_wallOffsetStart === 1.0) ? ((($m_Lreactbuild_math_package$SquareRoot$(), $n(wallVectorMagnitude).sqrt__D()) - $n(cmp).Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0) - width) : $n(cmp).Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0);
            var componentGroupStateSnapshot = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), componentGroup), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
              var x0$1 = $as_s_Option(x0$1$2);
              var x1$1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
              var x1$2 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$1));
              matchEnd7: {
                var $$x3;
                var p2 = $as_s_Option(x1$2.T2__f__1);
                var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
                var x$5 = $m_s_None$();
                if ((x$5 === p2)) {
                  var $$x3 = cb;
                  break matchEnd7
                };
                var p4 = $as_s_Option(x1$2.T2__f__1);
                var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
                if ((p4 instanceof $c_s_Some)) {
                  var x5 = $as_s_Some(p4);
                  var v$3 = $as_Lreactbuild_format_iz2use_package$ComponentGroup($n(x5).s_Some__f_value);
                  var this$43 = $n(geometry$1);
                  var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)));
                  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
                  var arg1 = this$43.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
                  var s = $as_Lreactbuild_format_iz2use_package$GenerateGeometry(arg1);
                  var $$x4 = $n(s);
                  var this$49 = $n($n(s).sides__sci_List());
                  var this$45 = $n($n(head).Lreactbuild_format_iz2use_package$Side__f_componentGroups);
                  var this$44 = $n($m_s_package$().s_package$__f_Nil);
                  var other = new $c_sci_$colon$colon(v$3, this$44);
                  var x$1$3 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$45, idx, other, 1));
                  var this$46 = $n(head);
                  var x$2$1 = this$46.Lreactbuild_format_iz2use_package$Side__f_edge;
                  $n(head);
                  var rassoc$2 = new $c_Lreactbuild_format_iz2use_package$Side(x$2$1, x$1$3);
                  var this$48 = $n($m_s_package$().s_package$__f_Nil);
                  var other$1 = new $c_sci_$colon$colon(rassoc$2, this$48);
                  var arg1$1 = $n($$x4).withSides__sci_List__Lreactbuild_format_iz2use_package$GenerateGeometry($as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$49, sideIndex$1, other$1, 1)));
                  var $$x3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$43.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
                  break matchEnd7
                };
                throw new $c_s_MatchError(x1$2)
              };
              return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x3)
            })));
            var this$50 = $n($n(cmp).Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset1);
            if (this$50.isEmpty__Z()) {
              var widthOpt = $m_s_None$()
            } else {
              var arg1$2 = this$50.get__O();
              var x1$2$1 = $uD(arg1$2);
              var widthOpt = new $c_s_Some(((($m_Lreactbuild_math_package$SquareRoot$(), $n(wallVectorMagnitude).sqrt__D()) - x1$2$1) - $n(cmp).Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0))
            };
            var transform = (((transformSideBase + " translate(") + $n(context$1).apply__D__D__T(x0, (-$n(cmp).Lreactbuild_format_iz2use_package$ExpandedComponent__f_distance))) + ") ");
            return $m_Lreactbuild_project_drawing_DrawComponent$().apply__Lreactbuild_format_iz2use_package$GenerateGeometry__Ljapgolly_scalajs_react_extra_StateSnapshotF__T__Z__s_Option__T__T__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode(geometryValue$1, componentGroupStateSnapshot, $n(cmp).Lreactbuild_format_iz2use_package$ExpandedComponent__f_definition, $n(cmp).Lreactbuild_format_iz2use_package$ExpandedComponent__f_invertY, widthOpt, transform, textTransform, context$1)
          });
          if ((this$52 === $m_sci_Nil$())) {
            return $m_sci_Nil$()
          } else {
            var arg1$3 = this$52.head__O();
            var h = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
            var t = h;
            var rest = $as_sci_List(this$52.tail__O());
            while ((rest !== $m_sci_Nil$())) {
              var arg1$4 = $n(rest).head__O();
              var nx = new $c_sci_$colon$colon(f(arg1$4), $m_sci_Nil$());
              $n(t).sci_$colon$colon__f_next = nx;
              t = nx;
              rest = $as_sci_List($n(rest).tail__O())
            };
            return h
          }
        } else {
          throw new $c_s_MatchError(x$1$1)
        }
      }))(wallVectorMagnitude, geometry$1, sideIndex$2, head, transformSideBase, context$1, geometryValue$1, textTransform))));
      var temp$sideIndex = ((1 + sideIndex) | 0);
      var this$53 = $n(origin);
      var other$2 = $m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2(wallVector);
      var temp$origin = new $c_Lreactbuild_geom_Vector2((this$53.x__D() + $n(other$2).Lreactbuild_geom_Vector2__f_x), (this$53.y__D() + $n(other$2).Lreactbuild_geom_Vector2__f_y));
      var this$54 = $n(accVectors);
      var elem = $m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2(wallVector);
      var temp$accVectors = new $c_sci_$colon$colon(elem, this$54);
      var this$55 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var rassoc$4 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$55, null, components);
      var this$56 = $n(accNodes);
      var temp$accNodes = new $c_sci_$colon$colon(rassoc$4, this$56);
      sideIndex = temp$sideIndex;
      origin = temp$origin;
      sides = tail;
      accVectors = temp$accVectors;
      accNodes = temp$accNodes
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawWallSides$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_DrawWallSides$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawWallSides$.prototype.constructor = $c_Lreactbuild_project_drawing_DrawWallSides$;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawWallSides$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawWallSides$.prototype = $c_Lreactbuild_project_drawing_DrawWallSides$.prototype;
$c_Lreactbuild_project_drawing_DrawWallSides$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__T__s_Option__sci_List__Z__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomElement = (function(geometry, stroke, fill, holes, outside, context) {
  var geometryValue = $as_Lreactbuild_format_iz2use_package$GenerateGeometry($n(geometry).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var suffixTransform = (outside ? "scale(1,-1) " : "");
  var $$x2 = $m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2($n(geometryValue).origin__Lreactbuild_format_iz2use_package$Vector2D());
  var $$x1 = $n(geometryValue).sides__sci_List();
  var rassoc$5 = $n($n(geometryValue).origin__Lreactbuild_format_iz2use_package$Vector2D()).toPoint__Lreactbuild_geom_Point2();
  var this$1 = $n($m_s_package$().s_package$__f_Nil);
  var x1 = $p_Lreactbuild_project_drawing_DrawWallSides$__loop$1__I__Lreactbuild_geom_Vector2Based__sci_List__sci_List__sci_List__Lreactbuild_project_drawing_DrawingContext__T__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_format_iz2use_package$GenerateGeometry__T2(this, 0, $$x2, $$x1, new $c_sci_$colon$colon(rassoc$5, this$1), $m_s_package$().s_package$__f_Nil, context, suffixTransform, geometry, geometryValue);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var vectors = $as_sci_List($n(x1)._1__O());
  var components = $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(x1)._2__O());
  $n($m_s_package$().s_package$__f_List);
  var array = [$n(vectors).reverse__sci_List()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$10 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var f$1 = ((pts$2) => {
    var pts = $as_sci_List(pts$2);
    var this$8 = $n(pts);
    var f = ((pt$2) => {
      var pt = $as_Lreactbuild_geom_Vector2Based(pt$2);
      var this$7 = $n(context);
      return this$7.apply__D__D__T($n(pt).x__D(), $n(pt).y__D())
    });
    if ((this$8 === $m_sci_Nil$())) {
      var $$x3 = $m_sci_Nil$()
    } else {
      var arg1 = this$8.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$8.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var $$x3 = h
    };
    var this$9 = $n($$x3);
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$9, "M ", " l ", " Z ")
  });
  if ((this$10 === $m_sci_Nil$())) {
    var paths = $m_sci_Nil$()
  } else {
    var arg1$2 = this$10.head__O();
    var h$1 = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = $as_sci_List(this$10.tail__O());
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$3 = $n(rest$1).head__O();
      var nx$1 = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
      $n(t$1).sci_$colon$colon__f_next = nx$1;
      t$1 = nx$1;
      rest$1 = $as_sci_List($n(rest$1).tail__O())
    };
    var paths = h$1
  };
  var this$11 = $n(vectors);
  var perimeter = $uD($n($as_sc_LinearSeqOps($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this$11, 1))).foldLeft__O__F2__O(0.0, new $c_sjsr_AnonFunction2(((acc$2, c$2) => {
    var acc = $uD(acc$2);
    var c = $as_Lreactbuild_geom_Vector2Based(c$2);
    $m_Lreactbuild_math_package$SquareRoot$();
    var this$12 = $n(c);
    if ((this$12.x__D() === 0.0)) {
      $m_Lreactbuild_math_package$SquareRoot$();
      var x = this$12.y__D();
      var length = $uD(Math.abs(x));
      var sq = (length * length);
      var sqrt = $uD(Math.abs(length));
      var sqrt$2 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt)
    } else if ((this$12.y__D() === 0.0)) {
      $m_Lreactbuild_math_package$SquareRoot$();
      var x$1 = this$12.x__D();
      var length$1 = $uD(Math.abs(x$1));
      var sq$1 = (length$1 * length$1);
      var sqrt$1 = $uD(Math.abs(length$1));
      var sqrt$2 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$1, sqrt$1)
    } else {
      $m_Lreactbuild_math_package$SquareRoot$();
      var v = this$12.x__D();
      var v$1 = this$12.y__D();
      var value = ((v * v) + (v$1 * v$1));
      var sqrt$2 = new $c_Lreactbuild_math_package$LazySquareRoot(value)
    };
    var x$2 = $n(sqrt$2).sqrt__D();
    return (acc + $uD(Math.abs(x$2)))
  }))));
  var this$41 = $m_Lreactbuild_geom_Polygon2$();
  var shape = $n(geometryValue).shape__sci_List();
  var x1$2 = $p_Lreactbuild_geom_Polygon2$__loop$1__sci_List__D__D__D__T2(this$41, shape, 0.0, 0.0, 0.0);
  if ((x1$2 === null)) {
    throw new $c_s_MatchError(x1$2)
  };
  var area = $n(x1$2)._1$mcD$sp__D();
  var centroid = $as_Lreactbuild_geom_Vector2Based($n(x1$2)._2__O());
  var this$42 = $n(paths);
  var genPath = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$42, "", "", "");
  var this$155 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x34 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$46 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "id");
  var a = ("" + $n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_ids).apply__O__O(geometryValue));
  var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x33 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$46.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
  var $$x32 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$50 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
  var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array$1 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$50.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, genPath)];
  var $$x31 = $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$56 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
  var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array$2 = [$$x33, $$x31, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$56.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#ffffff")];
  var $$x30 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("mask", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x29 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$64 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
  var this$63 = $n(context);
  var a$1 = (("translate(" + this$63.apply__D__D__T($n(centroid).x__D(), $n(centroid).y__D())) + ")");
  var t$5 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x28 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$5, this$64.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$67 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
  var t$6 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x27 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$6, this$67.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "middle");
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$70 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fontSize");
  var t$7 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x26 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$7, this$70.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "15");
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$73 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fontWeight");
  var t$8 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x25 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$8, this$73.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "bold");
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$76 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
  var t$9 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x24 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$9, this$76.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#b3bbe6");
  var $$x23 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$80 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
  var t$10 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$10, this$80.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$83 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y");
  var t$11 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$11, this$83.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-15");
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$2 = $as_T($n(geometryValue).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((x$4$2) => {
    $as_Lreactbuild_format_iz2use_package$Storey(x$4$2);
    return "Niveau"
  })), new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lreactbuild_format_iz2use_package$Room(x$5$2);
    return $n(x$5).Lreactbuild_format_iz2use_package$Room__f_name
  }))));
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$3 = [$$x22, $$x21, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
  var $$x20 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tspan", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$92 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
  var t$12 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x18 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$12, this$92.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$95 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "dy");
  var t$13 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$13, this$95.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "15");
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var $$x16 = $m_sc_StringOps$();
  var array$4 = [($uD(Math.abs(area)) / 1000000.0)];
  var v$3 = $n($$x16).format$extension__T__sci_Seq__T("S=%.1fm\u00b2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$5 = [$$x18, $$x17, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
  var $$x15 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tspan", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$111 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
  var t$14 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$14, this$111.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0");
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$114 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "dy");
  var t$15 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$15, this$114.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "15");
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var $$x11 = $m_sc_StringOps$();
  var array$6 = [(perimeter / 1000.0)];
  var v$4 = $n($$x11).format$extension__T__sci_Seq__T("P=%.1fml", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$7 = [$$x13, $$x12, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
  var array$8 = [$$x28, $$x27, $$x26, $$x25, $$x24, $$x20, $$x15, $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tspan", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  var $$x10 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
  var this$126 = $n(context);
  var part = $m_Lreactbuild_project_drawing_Wall$();
  if ($n($n($as_Lreactbuild_project_drawing_Layers($n(this$126.Lreactbuild_project_drawing_DrawingContextImpl__f_layers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part)) {
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  } else {
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$130 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
    var t$16 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$16, this$130.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, genPath);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$133 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
    var t$17 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$17, this$133.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, stroke);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$137 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
    var this$136 = $n(fill);
    if (this$136.isEmpty__Z()) {
      var a$2 = "0"
    } else {
      var arg1$4 = this$136.get__O();
      $as_T(arg1$4);
      var a$2 = "1"
    };
    var t$18 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$18, this$137.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
    var array$10 = [$$x7, $$x6, $$x5, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(fill, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((fill$2) => {
      var fill$1 = $as_T(fill$2);
      var this$148 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$141 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
      var t$19 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x8 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$19, this$141.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, fill$1);
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$144 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillRule");
      var t$20 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$9 = [$$x8, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$20, this$144.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "evenodd")];
      var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
      return this$148.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
    })))];
    var $$x4 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))
  };
  var array$11 = [$$x30, $$x10, $$x4, components];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$155, null, ns)
});
var $d_Lreactbuild_project_drawing_DrawWallSides$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawWallSides$: 0
}, false, "reactbuild.project.drawing.DrawWallSides$", {
  Lreactbuild_project_drawing_DrawWallSides$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_DrawWallSides$.prototype.$classData = $d_Lreactbuild_project_drawing_DrawWallSides$;
var $n_Lreactbuild_project_drawing_DrawWallSides$;
function $m_Lreactbuild_project_drawing_DrawWallSides$() {
  if ((!$n_Lreactbuild_project_drawing_DrawWallSides$)) {
    $n_Lreactbuild_project_drawing_DrawWallSides$ = new $c_Lreactbuild_project_drawing_DrawWallSides$()
  };
  return $n_Lreactbuild_project_drawing_DrawWallSides$
}
function $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T($thiz, part) {
  return $n($as_Lreactbuild_project_drawing_Theme($n($thiz.Lreactbuild_project_drawing_DrawingContextImpl__f_theme).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).apply__Lreactbuild_project_drawing_BuildingPart__T(part)
}
function $is_Lreactbuild_project_drawing_DrawingContext(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_DrawingContext)))
}
function $as_Lreactbuild_project_drawing_DrawingContext(obj) {
  return (($is_Lreactbuild_project_drawing_DrawingContext(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawingContext"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawingContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawingContext)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawingContext(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawingContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawingContext;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingContext$() {
  this.Lreactbuild_project_drawing_DrawingContext$__f_reactbuild$project$drawing$DrawingContext$$DebounceHidecontrols = null;
  this.Lreactbuild_project_drawing_DrawingContext$__f_reusabilityTool = null;
  this.Lreactbuild_project_drawing_DrawingContext$__f_reusabilityTheme = null;
  this.Lreactbuild_project_drawing_DrawingContext$__f_reusabilityLayers = null;
  this.Lreactbuild_project_drawing_DrawingContext$__f_reusabilityVector2Based = null;
  this.Lreactbuild_project_drawing_DrawingContext$__f_component = null;
  $n_Lreactbuild_project_drawing_DrawingContext$ = this;
  this.Lreactbuild_project_drawing_DrawingContext$__f_reactbuild$project$drawing$DrawingContext$$DebounceHidecontrols = "HIDE_CONTROLS";
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_project_drawing_DrawingContext$__f_reusabilityTool = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_project_drawing_DrawingContext$__f_reusabilityTheme = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$2.byRef__F2(), this$2.by_$eq$eq__F2());
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_project_drawing_DrawingContext$__f_reusabilityLayers = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$3.byRef__F2(), this$3.by_$eq$eq__F2());
  var this$4 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_project_drawing_DrawingContext$__f_reusabilityVector2Based = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$4.byRef__F2(), this$4.by_$eq$eq__F2());
  var this$20 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DrawingContext", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_project_drawing_DrawingContext$Props(p$2);
    return new $c_Lreactbuild_project_drawing_DrawingContext$State($m_Lreactbuild_project_drawing_Theme$().Lreactbuild_project_drawing_Theme$__f_defaultTheme, new $c_Lreactbuild_project_drawing_Layers(($n($m_s_Predef$().s_Predef$__f_Set), $m_sci_Set$EmptySet$())), $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero, 1.0, false, false, $m_s_None$(), $m_s_package$().s_package$__f_Nil, false, false, $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_drawing_DrawingContext$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_project_drawing_DrawingContext$Backend($n(x$3).backend__O()));
    var this$14 = $n(x$3);
    var $$x1 = $as_Lreactbuild_project_drawing_DrawingContext$Props($n(this$14.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$15 = $n(x$3);
    return $n($$x2).render__Lreactbuild_project_drawing_DrawingContext$Props__Lreactbuild_project_drawing_DrawingContext$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_project_drawing_DrawingContext$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$15)))
  }))));
  var this$18 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var evidence$1 = this$18.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var f = $m_Ljapgolly_scalajs_react_extra_OnUnmountF$().install__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(evidence$1);
  var this$23 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$20)));
  var f$1 = new $c_sjsr_AnonFunction1(((x$20$2) => {
    var x$20 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(x$20$2);
    var this$21 = $n($as_Lreactbuild_project_drawing_DrawingContext$Backend($n(x$20).backend__O()));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$21.hideControls__D__Ljapgolly_scalajs_react_callback_Trampoline(15000.0))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$28 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$23, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$1, G));
  var listenable = new $c_sjsr_AnonFunction1(((p$3$2) => {
    var p$3 = $as_Lreactbuild_project_drawing_DrawingContext$Props(p$3$2);
    var this$24 = $n($n(p$3).Lreactbuild_project_drawing_DrawingContext$Props__f_serverConnection);
    return $as_Ljapgolly_scalajs_react_extra_Broadcaster((this$24.isEmpty__Z() ? new $c_Lreactbuild_project_drawing_DrawingContext$$anon$1() : this$24.get__O()))
  }));
  var makeListener = new $c_sjsr_AnonFunction1(((x$21$2) => {
    var x$21 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(x$21$2);
    var eta$0$1 = $as_Lreactbuild_project_drawing_DrawingContext$Backend($n(x$21).backend__O());
    return new $c_sjsr_AnonFunction1(((e$2) => {
      var e = $as_Lreactbuild_model_ToClient(e$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(eta$0$1).message__Lreactbuild_model_ToClient__Ljapgolly_scalajs_react_callback_Trampoline(e))
    }))
  }));
  var evidence$3 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_ListenableF$();
  var this$27 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var f$2 = $n($$x3).listen__F1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(listenable, makeListener, this$27.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync, evidence$3);
  this.Lreactbuild_project_drawing_DrawingContext$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$2).apply__O__O(this$28))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_DrawingContext$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingContext$.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingContext$;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingContext$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingContext$.prototype = $c_Lreactbuild_project_drawing_DrawingContext$.prototype;
$c_Lreactbuild_project_drawing_DrawingContext$.prototype.apply__Lreactbuild_common_model_Project__T__D__T2__s_Option__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(project, modelSource, scale, space, serverConnection, render) {
  var c = this.Lreactbuild_project_drawing_DrawingContext$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_drawing_DrawingContext$Props(project, serverConnection, modelSource, scale, space, render);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_drawing_DrawingContext$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingContext$: 0
}, false, "reactbuild.project.drawing.DrawingContext$", {
  Lreactbuild_project_drawing_DrawingContext$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_DrawingContext$.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingContext$;
var $n_Lreactbuild_project_drawing_DrawingContext$;
function $m_Lreactbuild_project_drawing_DrawingContext$() {
  if ((!$n_Lreactbuild_project_drawing_DrawingContext$)) {
    $n_Lreactbuild_project_drawing_DrawingContext$ = new $c_Lreactbuild_project_drawing_DrawingContext$()
  };
  return $n_Lreactbuild_project_drawing_DrawingContext$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingParser$() {
  this.Lreactbuild_project_drawing_DrawingParser$__f_component = null;
  $n_Lreactbuild_project_drawing_DrawingParser$ = this;
  var this$12 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("DrawingParser", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_project_drawing_DrawingParser$Props(p$2);
    var this$5 = $ct_ju_Date__(new $c_ju_Date());
    var t = this$5.ju_Date__f_java$util$Date$$millis;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_Lreactbuild_project_drawing_DrawingParser$State(new $c_Ldiode_data_Pending(new $c_RTLong(lo, hi)))
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_drawing_DrawingParser$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_project_drawing_DrawingParser$Backend($n(x$3).backend__O()));
    var this$7 = $n(x$3);
    var $$x1 = $as_Lreactbuild_project_drawing_DrawingParser$Props($n(this$7.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$8 = $n(x$3);
    return $n($$x2).render__Lreactbuild_project_drawing_DrawingParser$Props__Lreactbuild_project_drawing_DrawingParser$State__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_project_drawing_DrawingParser$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$8)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((\u03b4$2) => {
    var \u03b4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(\u03b4$2);
    var qual$1 = $as_Lreactbuild_project_drawing_DrawingParser$Backend($n(\u03b4).backend__O());
    var this$9 = $n(\u03b4);
    var x$1 = $as_Lreactbuild_project_drawing_DrawingParser$Props($n(this$9.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    $n(qual$1);
    var x$2$1 = $m_s_None$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(qual$1).computeState__Lreactbuild_project_drawing_DrawingParser$Props__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(x$1, x$2$1))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$15 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$12, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f, G));
  var f$1 = new $c_sjsr_AnonFunction1(((\u03b4$3$2) => {
    var \u03b4$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(\u03b4$3$2);
    var $$x4 = $as_Lreactbuild_project_drawing_DrawingParser$Backend($n(\u03b4$3).backend__O());
    var $$x3 = $as_Lreactbuild_project_drawing_DrawingParser$Props($n(\u03b4$3).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps);
    var this$13 = $n(\u03b4$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x4).computeState__Lreactbuild_project_drawing_DrawingParser$Props__s_Option__Ljapgolly_scalajs_react_callback_Trampoline($$x3, new $c_s_Some($n(this$13.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O())))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_project_drawing_DrawingParser$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$15, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_DrawingParser$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingParser$.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingParser$;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingParser$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingParser$.prototype = $c_Lreactbuild_project_drawing_DrawingParser$.prototype;
$c_Lreactbuild_project_drawing_DrawingParser$.prototype.apply__T__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(modelSource, f) {
  var c = this.Lreactbuild_project_drawing_DrawingParser$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_drawing_DrawingParser$Props(modelSource, f);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_drawing_DrawingParser$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingParser$: 0
}, false, "reactbuild.project.drawing.DrawingParser$", {
  Lreactbuild_project_drawing_DrawingParser$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_DrawingParser$.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingParser$;
var $n_Lreactbuild_project_drawing_DrawingParser$;
function $m_Lreactbuild_project_drawing_DrawingParser$() {
  if ((!$n_Lreactbuild_project_drawing_DrawingParser$)) {
    $n_Lreactbuild_project_drawing_DrawingParser$ = new $c_Lreactbuild_project_drawing_DrawingParser$()
  };
  return $n_Lreactbuild_project_drawing_DrawingParser$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_KitchenComponent$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_KitchenComponent$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_KitchenComponent$.prototype.constructor = $c_Lreactbuild_project_drawing_KitchenComponent$;
/** @constructor */
function $h_Lreactbuild_project_drawing_KitchenComponent$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_KitchenComponent$.prototype = $c_Lreactbuild_project_drawing_KitchenComponent$.prototype;
$c_Lreactbuild_project_drawing_KitchenComponent$.prototype.door__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(width, enclosingDepth, context) {
  return (((($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T(width, enclosingDepth, context) + " ") + $m_Lreactbuild_project_drawing_Path$().a__D__D__D__Z__Z__D__D__Lreactbuild_project_drawing_DrawingContext__T(width, width, 90.0, false, true, (-width), width, context)) + " ") + $m_Lreactbuild_project_drawing_Path$().L__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, enclosingDepth, context))
});
$c_Lreactbuild_project_drawing_KitchenComponent$.prototype.drawer__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(width, offset, context) {
  return (($m_Lreactbuild_project_drawing_Path$().M__D__D__Lreactbuild_project_drawing_DrawingContext__T(0.0, offset, context) + " ") + $m_Lreactbuild_project_drawing_Path$().l__D__D__Lreactbuild_project_drawing_DrawingContext__T(width, 0.0, context))
});
$c_Lreactbuild_project_drawing_KitchenComponent$.prototype.tripleDrawer__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(width, depth, context) {
  var b = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
  var it = new $c_sci_RangeIterator(1, 1, 3, false);
  while (it.sci_RangeIterator__f__hasNext) {
    var this$4 = $n(b);
    var arg1 = it.next__I();
    var elem = $m_Lreactbuild_project_drawing_KitchenComponent$().drawer__D__D__Lreactbuild_project_drawing_DrawingContext__T(width, (depth + ((depth / 3.0) * arg1)), context);
    this$4.addOne__O__scm_Growable(elem)
  };
  var this$5 = $n($as_sci_IndexedSeq($n(b).result__O()));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", " ", "")
});
$c_Lreactbuild_project_drawing_KitchenComponent$.prototype.simpleDrawer__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(width, depth, context) {
  return this.drawer__D__D__Lreactbuild_project_drawing_DrawingContext__T(depth, (depth + depth), context)
});
$c_Lreactbuild_project_drawing_KitchenComponent$.prototype.apply__T__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(tpe, depth, width, context) {
  var this$1 = $n(tpe);
  if (($uI(this$1.indexOf("P")) !== (-1))) {
    var doorOpt = new $c_s_Some(this.door__D__D__Lreactbuild_project_drawing_DrawingContext__T(width, depth, context))
  } else {
    var doorOpt = $m_s_None$()
  };
  var this$2 = $n(tpe);
  if (($uI(this$2.indexOf("TTT")) !== (-1))) {
    var drawerOpt = new $c_s_Some(this.tripleDrawer__D__D__Lreactbuild_project_drawing_DrawingContext__T(width, depth, context))
  } else {
    var this$3 = $n(tpe);
    if (($uI(this$3.indexOf("T")) !== (-1))) {
      var drawerOpt = new $c_s_Some(this.simpleDrawer__D__D__Lreactbuild_project_drawing_DrawingContext__T(width, depth, context))
    } else {
      var drawerOpt = $m_s_None$()
    }
  };
  var this$4 = $n($m_s_package$().s_package$__f_Nil);
  var this$5 = $n(this$4.appendedAll__sc_IterableOnce__sci_List(doorOpt));
  var this$6 = $n(this$5.appendedAll__sc_IterableOnce__sci_List(drawerOpt));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$6, "", " ", "")
});
var $d_Lreactbuild_project_drawing_KitchenComponent$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_KitchenComponent$: 0
}, false, "reactbuild.project.drawing.KitchenComponent$", {
  Lreactbuild_project_drawing_KitchenComponent$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_KitchenComponent$.prototype.$classData = $d_Lreactbuild_project_drawing_KitchenComponent$;
var $n_Lreactbuild_project_drawing_KitchenComponent$;
function $m_Lreactbuild_project_drawing_KitchenComponent$() {
  if ((!$n_Lreactbuild_project_drawing_KitchenComponent$)) {
    $n_Lreactbuild_project_drawing_KitchenComponent$ = new $c_Lreactbuild_project_drawing_KitchenComponent$()
  };
  return $n_Lreactbuild_project_drawing_KitchenComponent$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Path$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Path$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Path$.prototype.constructor = $c_Lreactbuild_project_drawing_Path$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Path$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Path$.prototype = $c_Lreactbuild_project_drawing_Path$.prototype;
$c_Lreactbuild_project_drawing_Path$.prototype.m__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(x, y, context) {
  return ((("m " + $n(context).apply__D__T(x)) + " ") + $n(context).apply__D__T(y))
});
$c_Lreactbuild_project_drawing_Path$.prototype.M__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(x, y, context) {
  return ((("M " + $n(context).apply__D__T(x)) + " ") + $n(context).apply__D__T(y))
});
$c_Lreactbuild_project_drawing_Path$.prototype.H__D__Lreactbuild_project_drawing_DrawingContext__T = (function(x, context) {
  return ("H " + $n(context).apply__D__T(x))
});
$c_Lreactbuild_project_drawing_Path$.prototype.V__D__Lreactbuild_project_drawing_DrawingContext__T = (function(y, context) {
  return ("V " + $n(context).apply__D__T(y))
});
$c_Lreactbuild_project_drawing_Path$.prototype.l__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(x, y, context) {
  return ((("l " + $n(context).apply__D__T(x)) + " ") + $n(context).apply__D__T(y))
});
$c_Lreactbuild_project_drawing_Path$.prototype.L__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(x, y, context) {
  return ((("L " + $n(context).apply__D__T(x)) + " ") + $n(context).apply__D__T(y))
});
$c_Lreactbuild_project_drawing_Path$.prototype.c__sci_Seq__Lreactbuild_project_drawing_DrawingContext__T = (function(coords, context) {
  var this$2 = $n($as_sc_IterableOnceOps($n(coords).map__F1__O(new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $uD(x$4$2);
    return $n(context).apply__D__T(x$4)
  })))));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "c", ",", "")
});
$c_Lreactbuild_project_drawing_Path$.prototype.A__D__D__D__Z__Z__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(rx, ry, angle, largeArcFlag, sweepFlag, x, y, context) {
  return ((((((((((((("A " + $n(context).apply__D__T(rx)) + " ") + $n(context).apply__D__T(ry)) + " ") + angle) + " ") + (largeArcFlag ? 1 : 0)) + " ") + (sweepFlag ? 1 : 0)) + " ") + $n(context).apply__D__T(x)) + " ") + $n(context).apply__D__T(y))
});
$c_Lreactbuild_project_drawing_Path$.prototype.a__D__D__D__Z__Z__D__D__Lreactbuild_project_drawing_DrawingContext__T = (function(rx, ry, angle, largeArcFlag, sweepFlag, dx, dy, context) {
  return ((((((((((((("a " + $n(context).apply__D__T(rx)) + " ") + $n(context).apply__D__T(ry)) + " ") + angle) + " ") + (largeArcFlag ? 1 : 0)) + " ") + (sweepFlag ? 1 : 0)) + " ") + $n(context).apply__D__T(dx)) + " ") + $n(context).apply__D__T(dy))
});
var $d_Lreactbuild_project_drawing_Path$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Path$: 0
}, false, "reactbuild.project.drawing.Path$", {
  Lreactbuild_project_drawing_Path$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_Path$.prototype.$classData = $d_Lreactbuild_project_drawing_Path$;
var $n_Lreactbuild_project_drawing_Path$;
function $m_Lreactbuild_project_drawing_Path$() {
  if ((!$n_Lreactbuild_project_drawing_Path$)) {
    $n_Lreactbuild_project_drawing_Path$ = new $c_Lreactbuild_project_drawing_Path$()
  };
  return $n_Lreactbuild_project_drawing_Path$
}
function $p_Lreactbuild_project_drawing_ProjectSegmentOnRulers$__classifyOnRulers$1__sci_List__sci_List__sci_Map__sci_List__sci_Seq__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, shapes, pointList, classified, rest, rulers$1, context$1) {
  while (true) {
    var x1 = pointList;
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x2 = $as_sci_$colon$colon(x1);
      var a = $as_Lreactbuild_geom_Point2($n(x2).sci_$colon$colon__f_head);
      var tail = $n(x2).sci_$colon$colon__f_next;
      if ((tail instanceof $c_sci_$colon$colon)) {
        var x3 = $as_sci_$colon$colon(tail);
        var b = $as_Lreactbuild_geom_Point2($n(x3).sci_$colon$colon__f_head);
        var this$1 = $n(b);
        var vec = new $c_Lreactbuild_geom_Vector2((this$1.Lreactbuild_geom_Point2__f_x - $n(a).Lreactbuild_geom_Point2__f_x), (this$1.Lreactbuild_geom_Point2__f_y - $n(a).Lreactbuild_geom_Point2__f_y));
        var classified$2 = classified;
        var x1$2 = $n($as_sc_IterableOps($n(rulers$1).flatMap__F1__O(new $c_sjsr_AnonFunction1(((a, vec, classified$1) => ((ruler$2) => {
          var ruler = $as_Lreactbuild_project_drawing_OrientedRulers(ruler$2);
          var this$5 = $n($as_sc_IterableOnceOps($n($n(ruler).Lreactbuild_project_drawing_OrientedRulers__f_positionLines).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
            var x0$1 = $as_T2(x0$1$2);
            if ((x0$1 !== null)) {
              var pos = $as_Lreactbuild_geom_Point2($n(x0$1)._1__O());
              var line = $as_Lreactbuild_geom_Line2($n(x0$1)._2__O());
              var this$3 = $n(a);
              var this$4 = $n(line);
              return new $c_T3(pos, line, $m_Lreactbuild_geom_Line2$().distanceToPoint__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Point2Based__D(this$4.Lreactbuild_geom_Line2__f_origin, this$4.Lreactbuild_geom_Line2__f_vector, this$3))
            } else {
              throw new $c_s_MatchError(x0$1)
            }
          })))));
          var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
            var x$1 = $as_T3(x$1$2);
            return $uD($n(x$1).T3__f__3)
          }));
          var cmp = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
          var x1$1 = $as_T3($f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O(this$5, f, cmp));
          if ((x1$1 === null)) {
            throw new $c_s_MatchError(x1$1)
          };
          var pos$1 = $as_Lreactbuild_geom_Point2($n(x1$1).T3__f__1);
          var line$1 = $as_Lreactbuild_geom_Line2($n(x1$1).T3__f__2);
          $uD($n(x1$1).T3__f__3);
          var this$6 = $n(line$1);
          var this$7 = $n($m_Lreactbuild_geom_Line2$().intersectionWithSegment__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__s_Option(this$6.Lreactbuild_geom_Line2__f_origin, this$6.Lreactbuild_geom_Line2__f_vector, a, vec));
          if (this$7.isEmpty__Z()) {
            return $m_s_None$()
          } else {
            var arg1 = this$7.get__O();
            var inter = $as_Lreactbuild_geom_Point2Based(arg1);
            var key = $ct_T2__O__O__(new $c_T2(), ruler, pos$1);
            var this$9 = $n($as_sci_List($n(classified$1).getOrElse__O__F0__O(key, new $c_sjsr_AnonFunction0((() => $m_s_package$().s_package$__f_Nil)))));
            var y = new $c_sci_$colon$colon(inter, this$9);
            return new $c_s_Some($as_sci_Map($n(classified$1).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), key, y))))
          }
        }))(a, vec, classified$2))))).headOption__s_Option();
        var x = $m_s_None$();
        if ((x === x1$2)) {
          $n($m_s_package$().s_package$__f_List);
          var array = [a, b];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          var rassoc$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
          var this$15 = $n(rest);
          var temp$rest = new $c_sci_$colon$colon(rassoc$2, this$15);
          pointList = x3;
          rest = temp$rest;
          continue
        } else if ((x1$2 instanceof $c_s_Some)) {
          var x3$2 = $as_s_Some(x1$2);
          var updatedClassified = $as_sci_Map($n(x3$2).s_Some__f_value);
          pointList = x3;
          classified = updatedClassified;
          continue
        } else {
          throw new $c_s_MatchError(x1$2)
        }
      }
    };
    var x1$3 = shapes;
    if ((x1$3 instanceof $c_sci_$colon$colon)) {
      var x2$2 = $as_sci_$colon$colon(x1$3);
      var a$2 = $as_sci_List($n(x2$2).sci_$colon$colon__f_head);
      var tail$2 = $n(x2$2).sci_$colon$colon__f_next;
      shapes = tail$2;
      pointList = a$2
    } else {
      var x$3 = $m_s_package$().s_package$__f_Nil;
      if (((x$3 === null) ? (x1$3 === null) : $n(x$3).equals__O__Z(x1$3))) {
        var rulers = $n($n(classified).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((x0$2$2) => {
          var x0$2 = $as_T2(x0$2$2);
          if ((x0$2 !== null)) {
            var p2 = $as_T2($n(x0$2)._1__O());
            var pts = $as_sci_List($n(x0$2)._2__O());
            if ((p2 !== null)) {
              var ruler$1 = $as_Lreactbuild_project_drawing_OrientedRulers($n(p2)._1__O());
              var pt = $as_Lreactbuild_geom_Point2($n(p2)._2__O());
              var self = $ct_T2__O__O__(new $c_T2(), ruler$1, pt);
              var this$17 = $n(pts);
              var f$1 = new $c_sjsr_AnonFunction1(((p$2) => {
                var p = $as_Lreactbuild_geom_Point2Based(p$2);
                return ($n(p).x__D() + $n(p).y__D())
              }));
              var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
              var y$1 = $n($as_sc_SeqOps($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$17, f$1, ord))).distinct__O();
              return $ct_T2__O__O__(new $c_T2(), self, y$1)
            }
          };
          throw new $c_s_MatchError(x0$2)
        })))).toList__sci_List();
        var this$19 = $n(rulers);
        var f$2 = ((context$1) => ((x$3$2$2) => {
          var x$3$2 = $as_T2(x$3$2$2);
          return $m_Lreactbuild_project_drawing_ProjectSegmentOnRulers$().drawRuler__T2__Lreactbuild_project_drawing_DrawingContext__T2(x$3$2, context$1)
        }))(context$1);
        if ((this$19 === $m_sci_Nil$())) {
          var lst = $m_sci_Nil$()
        } else {
          var arg1$1 = this$19.head__O();
          var h = new $c_sci_$colon$colon(f$2(arg1$1), $m_sci_Nil$());
          var t = h;
          var rest$1 = $as_sci_List(this$19.tail__O());
          while ((rest$1 !== $m_sci_Nil$())) {
            var arg1$2 = $n(rest$1).head__O();
            var nx = new $c_sci_$colon$colon(f$2(arg1$2), $m_sci_Nil$());
            $n(t).sci_$colon$colon__f_next = nx;
            t = nx;
            rest$1 = $as_sci_List($n(rest$1).tail__O())
          };
          var lst = h
        };
        if ($n(lst).isEmpty__Z()) {
          return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
        } else {
          var this$20 = $n(lst);
          var f$3 = ((acc$2, c$2) => {
            var acc = $as_T2(acc$2);
            var c = $as_T2(c$2);
            var rassoc$3 = $as_sci_List($n(c)._1__O());
            var $$x1 = $n($as_sci_List($n(acc)._1__O())).$colon$colon$colon__sci_List__sci_List(rassoc$3);
            var rassoc$4 = $as_sci_List($n(c)._2__O());
            return $ct_T2__O__O__(new $c_T2(), $$x1, $n($as_sci_List($n(acc)._2__O())).$colon$colon$colon__sci_List__sci_List(rassoc$4))
          });
          matchEnd4$1: {
            var $$x2;
            if ($is_sc_IndexedSeq(this$20)) {
              var x2$1 = $as_sc_IndexedSeq(this$20);
              if (($n(x2$1).length__I() > 0)) {
                var z = $n(x2$1).apply__I__O(0);
                var at = 1;
                var end = $n(x2$1).length__I();
                var acc$1 = z;
                while (true) {
                  if ((at !== end)) {
                    var temp$at = ((1 + at) | 0);
                    var arg1$3 = acc$1;
                    var arg2 = $n(x2$1).apply__I__O(at);
                    var temp$acc = f$3(arg1$3, arg2);
                    at = temp$at;
                    acc$1 = temp$acc;
                    continue
                  };
                  var $$x2 = acc$1;
                  break matchEnd4$1
                }
              }
            };
            if ((this$20.knownSize__I() === 0)) {
              throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
            };
            var it = this$20.iterator__sc_Iterator();
            if ((!$n(it).hasNext__Z())) {
              throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
            };
            var acc$3 = $n(it).next__O();
            while ($n(it).hasNext__Z()) {
              var arg1$4 = acc$3;
              var arg2$1 = $n(it).next__O();
              acc$3 = f$3(arg1$4, arg2$1)
            };
            var $$x2 = acc$3
          };
          var x1$4 = $as_T2($$x2);
          if ((x1$4 === null)) {
            throw new $c_s_MatchError(x1$4)
          };
          var texts = $as_sci_List($n(x1$4)._1__O());
          var lines = $as_sci_List($n(x1$4)._2__O());
          var this$26 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
          var this$21 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
          var $$x3 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$21, null, texts);
          var this$22 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
          var array$1 = [$$x3, $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$22, null, lines)];
          var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
          return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$26, null, ns)
        }
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    }
  }
}
function $p_Lreactbuild_project_drawing_ProjectSegmentOnRulers$__loop$1__sci_List__sci_List__sci_List__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_geom_Vector2__Lreactbuild_geom_Vector2__Ljapgolly_scalajs_react_vdom_TagMod__T2($thiz, rest, lines, texts, context$2, offsetLine$1, offsetText$1, anchor$1) {
  while (true) {
    var x1 = rest;
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x2 = $as_sci_$colon$colon(x1);
      var a = $as_Lreactbuild_geom_Point2Based($n(x2).sci_$colon$colon__f_head);
      var tail = $n(x2).sci_$colon$colon__f_next;
      if ((tail instanceof $c_sci_$colon$colon)) {
        var x3 = $as_sci_$colon$colon(tail);
        var b = $as_Lreactbuild_geom_Point2Based($n(x3).sci_$colon$colon__f_head);
        var this$1 = $n(b);
        var vec = new $c_Lreactbuild_geom_Vector2((this$1.x__D() - $n(a).x__D()), (this$1.y__D() - $n(a).y__D()));
        if ((vec.Lreactbuild_geom_Vector2__f_x === 0.0)) {
          $m_Lreactbuild_math_package$SquareRoot$();
          var x = vec.Lreactbuild_geom_Vector2__f_y;
          var length = $uD(Math.abs(x));
          var sq = (length * length);
          var sqrt = $uD(Math.abs(length));
          var len = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt)
        } else if ((vec.Lreactbuild_geom_Vector2__f_y === 0.0)) {
          $m_Lreactbuild_math_package$SquareRoot$();
          var x$1 = vec.Lreactbuild_geom_Vector2__f_x;
          var length$1 = $uD(Math.abs(x$1));
          var sq$1 = (length$1 * length$1);
          var sqrt$1 = $uD(Math.abs(length$1));
          var len = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$1, sqrt$1)
        } else {
          $m_Lreactbuild_math_package$SquareRoot$();
          var v = vec.Lreactbuild_geom_Vector2__f_x;
          var v$1 = vec.Lreactbuild_geom_Vector2__f_y;
          var value = ((v * v) + (v$1 * v$1));
          var len = new $c_Lreactbuild_math_package$LazySquareRoot(value)
        };
        var this$27 = $n(context$2);
        var vecAtScale = this$27.atScale__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Vector2(vec);
        var this$28 = $n(context$2);
        var this$29 = $n(this$28.atScale__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Vector2(a));
        var linePos = new $c_Lreactbuild_geom_Vector2((this$29.Lreactbuild_geom_Vector2__f_x + $n(offsetLine$1).Lreactbuild_geom_Vector2__f_x), (this$29.Lreactbuild_geom_Vector2__f_y + $n(offsetLine$1).Lreactbuild_geom_Vector2__f_y));
        var $$x7 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$33 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x2");
        var a$1 = $n(vecAtScale).Lreactbuild_geom_Vector2__f_x;
        var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$33.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$36 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y2");
        var a$2 = $n(vecAtScale).Lreactbuild_geom_Vector2__f_y;
        var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
        var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$36.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$2);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$39 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$39.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#000000");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$42 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$42.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "2");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$45 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$3 = (((("translate(" + linePos.Lreactbuild_geom_Vector2__f_x) + " ") + linePos.Lreactbuild_geom_Vector2__f_y) + ")");
        var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x2 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$45.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$3);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$48 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "markerStart");
        var t$5 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x1 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$5, this$48.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "url(#dimension)");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$51 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "markerEnd");
        var t$6 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$6, this$51.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "url(#dimension)")];
        var line = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("line", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
        var this$56 = $n(context$2);
        var this$55 = $n(a);
        var other = new $c_Lreactbuild_geom_Vector2((vec.Lreactbuild_geom_Vector2__f_x / 2.0), (vec.Lreactbuild_geom_Vector2__f_y / 2.0));
        var v$2 = new $c_Lreactbuild_geom_Vector2((this$55.x__D() + other.Lreactbuild_geom_Vector2__f_x), (this$55.y__D() + other.Lreactbuild_geom_Vector2__f_y));
        var this$57 = $n(this$56.atScale__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Vector2(v$2));
        var textPos = new $c_Lreactbuild_geom_Vector2((this$57.Lreactbuild_geom_Vector2__f_x + $n(offsetText$1).Lreactbuild_geom_Vector2__f_x), (this$57.Lreactbuild_geom_Vector2__f_y + $n(offsetText$1).Lreactbuild_geom_Vector2__f_y));
        var $$x16 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$61 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$4 = (((("translate(" + textPos.Lreactbuild_geom_Vector2__f_x) + " ") + textPos.Lreactbuild_geom_Vector2__f_y) + ")");
        var t$7 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x15 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$7, this$61.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$4);
        var $$x14 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var $$x12 = $m_sc_StringOps$();
        var array$1 = [($m_Lreactbuild_math_package$SquareRoot$(), $n(len).sqrt__D())];
        var v$3 = $n($$x12).format$extension__T__sci_Seq__T("%.0f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x13 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$71 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
        var t$8 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x11 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$8, this$71.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#ffffff");
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$74 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
        var t$9 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$2 = [$$x13, $$x11, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$9, this$74.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "3"), anchor$1];
        var $$x10 = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
        var $$x9 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var $$x8 = $m_sc_StringOps$();
        var array$3 = [($m_Lreactbuild_math_package$SquareRoot$(), $n(len).sqrt__D())];
        var v$4 = $n($$x8).format$extension__T__sci_Seq__T("%.0f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4), anchor$1];
        var array$5 = [$$x15, $$x10, $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
        var text = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("g", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
        var this$91 = $n(lines);
        var temp$lines = new $c_sci_$colon$colon(line, this$91);
        var this$92 = $n(texts);
        var temp$texts = new $c_sci_$colon$colon(text, this$92);
        rest = x3;
        lines = temp$lines;
        texts = temp$texts;
        continue
      }
    };
    return $ct_T2__O__O__(new $c_T2(), lines, texts)
  }
}
/** @constructor */
function $c_Lreactbuild_project_drawing_ProjectSegmentOnRulers$() {
  this.Lreactbuild_project_drawing_ProjectSegmentOnRulers$__f_pathEndLen = 0;
  $n_Lreactbuild_project_drawing_ProjectSegmentOnRulers$ = this;
  $as_sci_SortedMap($m_sci_SortedMap$().apply__sci_Seq__s_math_Ordering__O($m_sci_Nil$(), $m_s_math_Ordering$DeprecatedDoubleOrdering$()));
  this.Lreactbuild_project_drawing_ProjectSegmentOnRulers$__f_pathEndLen = 2;
  var this$1 = $n($m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_unit);
  var factor = this.Lreactbuild_project_drawing_ProjectSegmentOnRulers$__f_pathEndLen;
  if ((factor !== 1.0)) {
    new $c_Lreactbuild_geom_Vector2((this$1.Lreactbuild_geom_Vector2__f_x * factor), (this$1.Lreactbuild_geom_Vector2__f_y * factor))
  }
}
$c_Lreactbuild_project_drawing_ProjectSegmentOnRulers$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_ProjectSegmentOnRulers$.prototype.constructor = $c_Lreactbuild_project_drawing_ProjectSegmentOnRulers$;
/** @constructor */
function $h_Lreactbuild_project_drawing_ProjectSegmentOnRulers$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_ProjectSegmentOnRulers$.prototype = $c_Lreactbuild_project_drawing_ProjectSegmentOnRulers$.prototype;
$c_Lreactbuild_project_drawing_ProjectSegmentOnRulers$.prototype.drawRuler__T2__Lreactbuild_project_drawing_DrawingContext__T2 = (function(p, context) {
  matchEnd4: {
    var x$5___1;
    var x$5___2;
    var x$5___3;
    if ((p !== null)) {
      var p2 = $as_T2($n(p)._1__O());
      var pts = $as_sci_List($n(p)._2__O());
      if ((p2 !== null)) {
        var ruler = $as_Lreactbuild_project_drawing_OrientedRulers($n(p2)._1__O());
        var cursor = $as_Lreactbuild_geom_Point2($n(p2)._2__O());
        var x$5___1 = ruler;
        var x$5___2 = cursor;
        var x$5___3 = pts;
        break matchEnd4
      }
    };
    throw new $c_s_MatchError(p)
  };
  var ruler$2 = $as_Lreactbuild_project_drawing_OrientedRulers(x$5___1);
  $as_Lreactbuild_geom_Point2(x$5___2);
  var pts$2 = $as_sci_List(x$5___3);
  var this$1 = $n($n(ruler$2).Lreactbuild_project_drawing_OrientedRulers__f_direction);
  var y = this$1.Lreactbuild_geom_Vector2__f_y;
  var x = this$1.Lreactbuild_geom_Vector2__f_x;
  var notHorizontal = ($uD(Math.atan2(y, x)) !== 0.0);
  var offsetText = (notHorizontal ? new $c_Lreactbuild_geom_Vector2(10.0, 0.0) : new $c_Lreactbuild_geom_Vector2(0.0, (-10.0)));
  var offsetLine = (notHorizontal ? new $c_Lreactbuild_geom_Vector2(5.0, 0.0) : new $c_Lreactbuild_geom_Vector2(0.0, (-5.0)));
  if (notHorizontal) {
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$5 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var anchor = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$5.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "start")
  } else {
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$8 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
    var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var anchor = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$8.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "middle")
  };
  return $p_Lreactbuild_project_drawing_ProjectSegmentOnRulers$__loop$1__sci_List__sci_List__sci_List__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_geom_Vector2__Lreactbuild_geom_Vector2__Ljapgolly_scalajs_react_vdom_TagMod__T2(this, pts$2, $m_s_package$().s_package$__f_Nil, $m_s_package$().s_package$__f_Nil, context, offsetLine, offsetText, anchor)
});
var $d_Lreactbuild_project_drawing_ProjectSegmentOnRulers$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_ProjectSegmentOnRulers$: 0
}, false, "reactbuild.project.drawing.ProjectSegmentOnRulers$", {
  Lreactbuild_project_drawing_ProjectSegmentOnRulers$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_ProjectSegmentOnRulers$.prototype.$classData = $d_Lreactbuild_project_drawing_ProjectSegmentOnRulers$;
var $n_Lreactbuild_project_drawing_ProjectSegmentOnRulers$;
function $m_Lreactbuild_project_drawing_ProjectSegmentOnRulers$() {
  if ((!$n_Lreactbuild_project_drawing_ProjectSegmentOnRulers$)) {
    $n_Lreactbuild_project_drawing_ProjectSegmentOnRulers$ = new $c_Lreactbuild_project_drawing_ProjectSegmentOnRulers$()
  };
  return $n_Lreactbuild_project_drawing_ProjectSegmentOnRulers$
}
function $is_Lreactbuild_project_drawing_Tool(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_Tool)))
}
function $as_Lreactbuild_project_drawing_Tool(obj) {
  return (($is_Lreactbuild_project_drawing_Tool(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Tool"))
}
function $isArrayOf_Lreactbuild_project_drawing_Tool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Tool)))
}
function $asArrayOf_Lreactbuild_project_drawing_Tool(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Tool(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Tool;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_drawing_ToolControls$() {
  this.Lreactbuild_project_drawing_ToolControls$__f_component = null;
  $n_Lreactbuild_project_drawing_ToolControls$ = this;
  this.Lreactbuild_project_drawing_ToolControls$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ToolControls", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_drawing_ToolControls$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x1 = $n($as_Lreactbuild_project_drawing_ToolControls$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var u = $n($$x1).render__Lreactbuild_project_drawing_ToolControls$Props__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($as_Lreactbuild_project_drawing_ToolControls$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()));
    var this$6 = $n(u);
    var n = this$6.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_ToolControls$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_ToolControls$.prototype.constructor = $c_Lreactbuild_project_drawing_ToolControls$;
/** @constructor */
function $h_Lreactbuild_project_drawing_ToolControls$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_ToolControls$.prototype = $c_Lreactbuild_project_drawing_ToolControls$.prototype;
$c_Lreactbuild_project_drawing_ToolControls$.prototype.apply__Lreactbuild_project_drawing_UITool__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(tool, context) {
  var c = this.Lreactbuild_project_drawing_ToolControls$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_drawing_ToolControls$Props(tool, context);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_drawing_ToolControls$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_ToolControls$: 0
}, false, "reactbuild.project.drawing.ToolControls$", {
  Lreactbuild_project_drawing_ToolControls$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_ToolControls$.prototype.$classData = $d_Lreactbuild_project_drawing_ToolControls$;
var $n_Lreactbuild_project_drawing_ToolControls$;
function $m_Lreactbuild_project_drawing_ToolControls$() {
  if ((!$n_Lreactbuild_project_drawing_ToolControls$)) {
    $n_Lreactbuild_project_drawing_ToolControls$ = new $c_Lreactbuild_project_drawing_ToolControls$()
  };
  return $n_Lreactbuild_project_drawing_ToolControls$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_ToolControls$Backend(\u03b4) {
  this.Lreactbuild_project_drawing_ToolControls$Backend__f_close = null;
  this.Lreactbuild_project_drawing_ToolControls$Backend__f_close = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(\u03b4).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_project_drawing_ToolControls$Props(x$1$2);
    var this$2 = $n($n($n(x$1).Lreactbuild_project_drawing_ToolControls$Props__f_context).Lreactbuild_project_drawing_DrawingContextImpl__f_tool);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    $as_s_Option(arg1);
    var arg1$1 = $m_s_None$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })))
}
$c_Lreactbuild_project_drawing_ToolControls$Backend.prototype = new $h_O();
$c_Lreactbuild_project_drawing_ToolControls$Backend.prototype.constructor = $c_Lreactbuild_project_drawing_ToolControls$Backend;
/** @constructor */
function $h_Lreactbuild_project_drawing_ToolControls$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_ToolControls$Backend.prototype = $c_Lreactbuild_project_drawing_ToolControls$Backend.prototype;
$c_Lreactbuild_project_drawing_ToolControls$Backend.prototype.render__Lreactbuild_project_drawing_ToolControls$Props__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(p) {
  var $$x6 = $m_Lreactbuild_project_drawing_Area$();
  var $$x5 = $m_Lreactbuild_project_drawing_Area$Axis$Vertical$();
  var $$x4 = $m_Lreactbuild_project_drawing_Area$Position$End$();
  $m_Lreactbuild_project_drawing_Area$();
  var $$x3 = $m_Lreactbuild_project_drawing_Area$Alignment$Middle$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = $n($n(p).Lreactbuild_project_drawing_ToolControls$Props__f_tool).name__T();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var x$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
  var $$x1 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.Lreactbuild_project_drawing_ToolControls$Backend__f_close));
  var array = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_close, "", "24px")];
  var x$2 = $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var x$3 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
  var x$4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
  var $$x2 = $m_sci_Seq$();
  var this$9 = $n($n(p).Lreactbuild_project_drawing_ToolControls$Props__f_tool);
  var context = $n(p).Lreactbuild_project_drawing_ToolControls$Props__f_context;
  var array$1 = [this$9.render__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_TagOf(context)];
  var x$5 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
  var array$2 = [$m_Lcom_iz2use_react_components_Card$().apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(x$1, x$3, x$2, x$4, x$5)];
  return $n($$x6).apply__Lreactbuild_project_drawing_Area$Axis__Lreactbuild_project_drawing_Area$Position__Z__Lreactbuild_project_drawing_Area$Alignment__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x5, $$x4, false, $$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
function $as_Lreactbuild_project_drawing_ToolControls$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_ToolControls$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.ToolControls$Backend"))
}
function $isArrayOf_Lreactbuild_project_drawing_ToolControls$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_ToolControls$Backend)))
}
function $asArrayOf_Lreactbuild_project_drawing_ToolControls$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_ToolControls$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.ToolControls$Backend;", depth))
}
var $d_Lreactbuild_project_drawing_ToolControls$Backend = new $TypeData().initClass({
  Lreactbuild_project_drawing_ToolControls$Backend: 0
}, false, "reactbuild.project.drawing.ToolControls$Backend", {
  Lreactbuild_project_drawing_ToolControls$Backend: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_ToolControls$Backend.prototype.$classData = $d_Lreactbuild_project_drawing_ToolControls$Backend;
/** @constructor */
function $c_Lreactbuild_project_drawing_ToolRegistry$() {
  this.Lreactbuild_project_drawing_ToolRegistry$__f_registered = null;
  $n_Lreactbuild_project_drawing_ToolRegistry$ = this;
  this.Lreactbuild_project_drawing_ToolRegistry$__f_registered = $m_sci_ListSet$EmptyListSet$();
  this.register__Lreactbuild_project_drawing_Tool__V(new $c_Lreactbuild_project_drawing_tool_Ruler($m_s_None$(), $m_s_None$()));
  this.register__Lreactbuild_project_drawing_Tool__V($m_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$());
  this.register__Lreactbuild_project_drawing_Tool__V($m_Lreactbuild_project_drawing_tool_LayerSelection$());
  this.register__Lreactbuild_project_drawing_Tool__V($m_Lreactbuild_project_drawing_tool_StyleSelection$());
  this.register__Lreactbuild_project_drawing_Tool__V($m_Lreactbuild_project_drawing_tool_SwitchLightArea$());
  this.register__Lreactbuild_project_drawing_Tool__V($m_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$());
  this.register__Lreactbuild_project_drawing_Tool__V($m_Lreactbuild_project_drawing_tool_DebugInfo$())
}
$c_Lreactbuild_project_drawing_ToolRegistry$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_ToolRegistry$.prototype.constructor = $c_Lreactbuild_project_drawing_ToolRegistry$;
/** @constructor */
function $h_Lreactbuild_project_drawing_ToolRegistry$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_ToolRegistry$.prototype = $c_Lreactbuild_project_drawing_ToolRegistry$.prototype;
$c_Lreactbuild_project_drawing_ToolRegistry$.prototype.register__Lreactbuild_project_drawing_Tool__V = (function(tool) {
  var this$1 = $n(this.Lreactbuild_project_drawing_ToolRegistry$__f_registered);
  this.Lreactbuild_project_drawing_ToolRegistry$__f_registered = this$1.incl__O__sci_ListSet(tool)
});
var $d_Lreactbuild_project_drawing_ToolRegistry$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_ToolRegistry$: 0
}, false, "reactbuild.project.drawing.ToolRegistry$", {
  Lreactbuild_project_drawing_ToolRegistry$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_ToolRegistry$.prototype.$classData = $d_Lreactbuild_project_drawing_ToolRegistry$;
var $n_Lreactbuild_project_drawing_ToolRegistry$;
function $m_Lreactbuild_project_drawing_ToolRegistry$() {
  if ((!$n_Lreactbuild_project_drawing_ToolRegistry$)) {
    $n_Lreactbuild_project_drawing_ToolRegistry$ = new $c_Lreactbuild_project_drawing_ToolRegistry$()
  };
  return $n_Lreactbuild_project_drawing_ToolRegistry$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_ToolSelector$() {
  this.Lreactbuild_project_drawing_ToolSelector$__f_switchToFullScreenIcon = null;
  this.Lreactbuild_project_drawing_ToolSelector$__f_exitFullScreenIcon = null;
  this.Lreactbuild_project_drawing_ToolSelector$__f_component = null;
  $n_Lreactbuild_project_drawing_ToolSelector$ = this;
  this.Lreactbuild_project_drawing_ToolSelector$__f_switchToFullScreenIcon = ($m_sc_StringOps$(), $m_sc_StringOps$().stripMargin$extension__T__C__T("M 9.4131418,8.002477 5.4144158,4.002618 h 2.589019 v -2 \n    | h -6.003082 l 0.0044,5.999859 h 2 l -0.0044,-2.585797 3.998727,3.999859 z \n    | m 6.5866462,1.413496 3.999859,-3.998726 v 2.589019 h 2 V 2.003184 l -5.999859,0.0044 \n    | v 2 l 2.585797,-0.0044 -3.999859,3.998727 z m -1.41293,6.580984 3.998726,3.999859 \n    | h -2.589019 v 2 h 6.003082 l -0.0044,-5.999859 h -2 l 0.0044,2.585797 -3.998727,-3.999859 \n    | z M 8.0001411,14.589019 4.0002822,18.587745 v -2.589019 h -2 v 6.003082 l 5.9998589,-0.0044 \n    | v -2 l -2.5857964,0.0044 3.9998588,-3.998727 z", 124));
  this.Lreactbuild_project_drawing_ToolSelector$__f_exitFullScreenIcon = ($m_sc_StringOps$(), $m_sc_StringOps$().stripMargin$extension__T__C__T("M 19.999788,2.587848 15.999929,6.586574 V 3.997555 h -2 v 6.003082 \n    | l 5.999859,-0.0044 v -2 L 17.413991,8.000637 21.41385,4.00191 Z M 2.5905752,4.001414 \n    | 6.5893012,8.001273 h -2.589019 v 2 h 6.0030818 l -0.0044,-5.999859 h -2 l 0.0044,2.585797 \n    | -3.998727,-3.999859 z m 1.4108391,17.410101 3.999859,-3.998726 v 2.589019 h 1.9999997 \n    | v -6.003082 l -5.9998587,0.0044 v 2 l 2.585797,-0.0044 -3.999859,3.998727 z \n    | M 21.404954,19.996816 17.406228,15.996957 h 2.589019 v -2 h -6.003082 l 0.0044,5.999859 \n    | h 2 l -0.0044,-2.585797 3.998727,3.999859 z", 124));
  this.Lreactbuild_project_drawing_ToolSelector$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialState$extension__T__F0__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ToolSelector", new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_project_drawing_ToolSelector$State())))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_drawing_ToolSelector$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_project_drawing_ToolSelector$Backend($n(x$3).backend__O()));
    var this$6 = $n(x$3);
    var $$x1 = $as_Lreactbuild_project_drawing_ToolSelector$Props($n(this$6.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$7 = $n(x$3);
    var u = $n($$x2).render__Lreactbuild_project_drawing_ToolSelector$Props__Lreactbuild_project_drawing_ToolSelector$State__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x1, $as_Lreactbuild_project_drawing_ToolSelector$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$7)));
    var this$9 = $n(u);
    var n = this$9.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_ToolSelector$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_ToolSelector$.prototype.constructor = $c_Lreactbuild_project_drawing_ToolSelector$;
/** @constructor */
function $h_Lreactbuild_project_drawing_ToolSelector$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_ToolSelector$.prototype = $c_Lreactbuild_project_drawing_ToolSelector$.prototype;
$c_Lreactbuild_project_drawing_ToolSelector$.prototype.apply__Lreactbuild_common_model_Project__Z__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(project, hidecontrols, fullScreen, context) {
  var c = this.Lreactbuild_project_drawing_ToolSelector$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_drawing_ToolSelector$Props(project, hidecontrols, fullScreen, context);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_drawing_ToolSelector$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_ToolSelector$: 0
}, false, "reactbuild.project.drawing.ToolSelector$", {
  Lreactbuild_project_drawing_ToolSelector$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_ToolSelector$.prototype.$classData = $d_Lreactbuild_project_drawing_ToolSelector$;
var $n_Lreactbuild_project_drawing_ToolSelector$;
function $m_Lreactbuild_project_drawing_ToolSelector$() {
  if ((!$n_Lreactbuild_project_drawing_ToolSelector$)) {
    $n_Lreactbuild_project_drawing_ToolSelector$ = new $c_Lreactbuild_project_drawing_ToolSelector$()
  };
  return $n_Lreactbuild_project_drawing_ToolSelector$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Toolbar$() {
  this.Lreactbuild_project_drawing_Toolbar$__f_component = null;
  $n_Lreactbuild_project_drawing_Toolbar$ = this;
  this.Lreactbuild_project_drawing_Toolbar$__f_component = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).justChildren__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $n($as_Ljapgolly_scalajs_react_PropsChildren(c$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$4 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingToolbar;
    var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c))];
    return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })))
}
$c_Lreactbuild_project_drawing_Toolbar$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Toolbar$.prototype.constructor = $c_Lreactbuild_project_drawing_Toolbar$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Toolbar$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Toolbar$.prototype = $c_Lreactbuild_project_drawing_Toolbar$.prototype;
$c_Lreactbuild_project_drawing_Toolbar$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_project_drawing_Toolbar$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children))
});
var $d_Lreactbuild_project_drawing_Toolbar$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Toolbar$: 0
}, false, "reactbuild.project.drawing.Toolbar$", {
  Lreactbuild_project_drawing_Toolbar$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_Toolbar$.prototype.$classData = $d_Lreactbuild_project_drawing_Toolbar$;
var $n_Lreactbuild_project_drawing_Toolbar$;
function $m_Lreactbuild_project_drawing_Toolbar$() {
  if ((!$n_Lreactbuild_project_drawing_Toolbar$)) {
    $n_Lreactbuild_project_drawing_Toolbar$ = new $c_Lreactbuild_project_drawing_Toolbar$()
  };
  return $n_Lreactbuild_project_drawing_Toolbar$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_View$() {
  this.Lreactbuild_project_drawing_View$__f_component = null;
  $n_Lreactbuild_project_drawing_View$ = this;
  var this$9 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("View", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_project_drawing_View$Props(p$2);
    return new $c_Lreactbuild_project_drawing_View$State($m_Lreactbuild_project_drawing_View$().checkFullscreenMode__Z())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_drawing_View$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_project_drawing_View$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_project_drawing_View$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_project_drawing_View$Props__Lreactbuild_project_drawing_View$State__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_project_drawing_View$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)), $n(x$3).propsChildren__sjs_js_Any())
  }))));
  var f = $m_Ljapgolly_scalajs_react_extra_package$EventListener$().install__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1("fullscreenchange", new $c_sjsr_AnonFunction1(((x$3$3$2) => {
    var x$3$3 = $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$3$3$2);
    var this$6 = $n(x$3$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_project_drawing_View$Backend($f_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot__backend__O(this$6))).updateFullScreenMode__Ljapgolly_scalajs_react_callback_Trampoline())
  })), new $c_sjsr_AnonFunction1(((x$4$2) => {
    $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$4$2);
    return window.document
  })), false, $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$13 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$9)));
  var f$1 = $m_Ljapgolly_scalajs_react_extra_package$EventListener$().install__T__F1__F1__Z__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1("resize", new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$5$2);
    var this$10 = $n(x$5);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_project_drawing_View$Backend($f_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot__backend__O(this$10))).updateFullScreenMode__Ljapgolly_scalajs_react_callback_Trampoline())
  })), new $c_sjsr_AnonFunction1(((x$6$2) => {
    $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(x$6$2);
    return window
  })), false, $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$15 = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$1).apply__O__O(this$13)));
  var f$2 = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(x$7$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_project_drawing_View$Backend($n(x$7).backend__O())).updateFullScreenMode__Ljapgolly_scalajs_react_callback_Trampoline())
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lreactbuild_project_drawing_View$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$15, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$2, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_View$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_View$.prototype.constructor = $c_Lreactbuild_project_drawing_View$;
/** @constructor */
function $h_Lreactbuild_project_drawing_View$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_View$.prototype = $c_Lreactbuild_project_drawing_View$.prototype;
$c_Lreactbuild_project_drawing_View$.prototype.checkFullscreenMode__Z = (function() {
  return (document.fullscreenElement !== null)
});
$c_Lreactbuild_project_drawing_View$.prototype.apply__Lreactbuild_common_model_Project__Z__s_Option__sci_Seq__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(project, hideControls, tool, children, context) {
  var c = this.Lreactbuild_project_drawing_View$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_drawing_View$Props(project, hideControls, tool, context);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_project_drawing_View$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_View$: 0
}, false, "reactbuild.project.drawing.View$", {
  Lreactbuild_project_drawing_View$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_View$.prototype.$classData = $d_Lreactbuild_project_drawing_View$;
var $n_Lreactbuild_project_drawing_View$;
function $m_Lreactbuild_project_drawing_View$() {
  if ((!$n_Lreactbuild_project_drawing_View$)) {
    $n_Lreactbuild_project_drawing_View$ = new $c_Lreactbuild_project_drawing_View$()
  };
  return $n_Lreactbuild_project_drawing_View$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Viewport$() {
  this.Lreactbuild_project_drawing_Viewport$__f_component = null;
  $n_Lreactbuild_project_drawing_Viewport$ = this;
  this.Lreactbuild_project_drawing_Viewport$__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Viewport", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_project_drawing_Viewport$Props(p$2);
    return new $c_Lreactbuild_project_drawing_Viewport$State()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_drawing_Viewport$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lreactbuild_project_drawing_Viewport$Backend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lreactbuild_project_drawing_Viewport$Props($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lreactbuild_project_drawing_Viewport$Props__Lreactbuild_project_drawing_Viewport$State__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode($$x1, $as_Lreactbuild_project_drawing_Viewport$State($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)), $n(x$3).propsChildren__sjs_js_Any())
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonPC__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_drawing_Viewport$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Viewport$.prototype.constructor = $c_Lreactbuild_project_drawing_Viewport$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Viewport$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Viewport$.prototype = $c_Lreactbuild_project_drawing_Viewport$.prototype;
$c_Lreactbuild_project_drawing_Viewport$.prototype.apply__sci_Seq__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(children, context) {
  var c = this.Lreactbuild_project_drawing_Viewport$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType("Viewport")));
  var props = new $c_Lreactbuild_project_drawing_Viewport$Props(context);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct).apply__O__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, children))
});
var $d_Lreactbuild_project_drawing_Viewport$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Viewport$: 0
}, false, "reactbuild.project.drawing.Viewport$", {
  Lreactbuild_project_drawing_Viewport$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_Viewport$.prototype.$classData = $d_Lreactbuild_project_drawing_Viewport$;
var $n_Lreactbuild_project_drawing_Viewport$;
function $m_Lreactbuild_project_drawing_Viewport$() {
  if ((!$n_Lreactbuild_project_drawing_Viewport$)) {
    $n_Lreactbuild_project_drawing_Viewport$ = new $c_Lreactbuild_project_drawing_Viewport$()
  };
  return $n_Lreactbuild_project_drawing_Viewport$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_package$() {
  this.Lreactbuild_project_drawing_interaction_package$__f_DrawingInteractions = null;
  $n_Lreactbuild_project_drawing_interaction_package$ = this;
  $n($m_s_package$().s_package$__f_List);
  var array = [$m_Lreactbuild_project_drawing_interaction_ActiveTool$(), new $c_Lreactbuild_project_drawing_interaction_DragRotate(), new $c_Lreactbuild_project_drawing_interaction_DoubleClickZoom(), $m_Lreactbuild_project_drawing_interaction_DragPan$Idle$(), new $c_Lreactbuild_project_drawing_interaction_PinchRotate(), new $c_Lreactbuild_project_drawing_interaction_PinchZoom(), new $c_Lreactbuild_project_drawing_interaction_KeyboardPan(), new $c_Lreactbuild_project_drawing_interaction_KeyboardZoom(), new $c_Lreactbuild_project_drawing_interaction_MouseWheelZoom(), new $c_Lreactbuild_project_drawing_interaction_DragZoom(), new $c_Lreactbuild_project_drawing_interaction_JustMoving($m_s_None$())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var orderedList = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  this.Lreactbuild_project_drawing_interaction_package$__f_DrawingInteractions = new $c_Lreactbuild_common_components_Interactions(orderedList)
}
$c_Lreactbuild_project_drawing_interaction_package$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_package$.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_package$;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_package$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_package$.prototype = $c_Lreactbuild_project_drawing_interaction_package$.prototype;
var $d_Lreactbuild_project_drawing_interaction_package$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_package$: 0
}, false, "reactbuild.project.drawing.interaction.package$", {
  Lreactbuild_project_drawing_interaction_package$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_interaction_package$.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_package$;
var $n_Lreactbuild_project_drawing_interaction_package$;
function $m_Lreactbuild_project_drawing_interaction_package$() {
  if ((!$n_Lreactbuild_project_drawing_interaction_package$)) {
    $n_Lreactbuild_project_drawing_interaction_package$ = new $c_Lreactbuild_project_drawing_interaction_package$()
  };
  return $n_Lreactbuild_project_drawing_interaction_package$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$.prototype.constructor = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$.prototype = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$.prototype;
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$.prototype.highlightWall__Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__Lreactbuild_geom_Point2Based__s_Option__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomElement = (function(wall, position, projectedPoint, context) {
  var this$1 = $n(context);
  var cursor = this$1.atScale__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Vector2(position);
  var this$2 = $n(context);
  var v = $n(wall).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallVector;
  var pt = this$2.atScale__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Vector2(v);
  var this$62 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var this$3 = $n(projectedPoint);
  if (this$3.isEmpty__Z()) {
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  } else {
    var arg1 = this$3.get__O();
    var projectedPoint$2 = $as_Lreactbuild_geom_Point2Based(arg1);
    var this$4 = $n(context);
    var target = this$4.atScale__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Vector2(projectedPoint$2);
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$8 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x1");
    var a = $n(cursor).Lreactbuild_geom_Vector2__f_x;
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
    var $$x16 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$8.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$11 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y1");
    var a$1 = $n(cursor).Lreactbuild_geom_Vector2__f_y;
    var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$11.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$14 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x2");
    var a$2 = $n(target).Lreactbuild_geom_Vector2__f_x;
    var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$14.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$2);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$17 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y2");
    var a$3 = $n(target).Lreactbuild_geom_Vector2__f_y;
    var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$17.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$3);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$20 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
    var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array = [$$x16, $$x15, $$x14, $$x13, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$20.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#ff0000")];
    var $$x12 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("line", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  };
  var $$x11 = $as_Ljapgolly_scalajs_react_vdom_VdomNode($$x12);
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$28 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
  var this$27 = $n(context);
  var v$1 = $n(wall).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallOrigin;
  var a$4 = (("translate(" + this$27.apply__D__D__T($n(v$1).x__D(), $n(v$1).y__D())) + ")");
  var t$5 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$5, this$28.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$4);
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$31 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x2");
  var a$5 = $n(pt).Lreactbuild_geom_Vector2__f_x;
  var t$6 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$6, this$31.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$5);
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$34 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y2");
  var a$6 = $n(pt).Lreactbuild_geom_Vector2__f_y;
  var t$7 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$7, this$34.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$6);
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$37 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
  var t$8 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$8, this$37.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "3");
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$40 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
  var t$9 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array$1 = [$$x9, $$x8, $$x7, $$x6, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$9, this$40.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#00FFFF")];
  var $$x5 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("line", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var this$44 = $n(projectedPoint);
  if (this$44.isEmpty__Z()) {
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  } else {
    var arg1$1 = this$44.get__O();
    var projectedPoint$3 = $as_Lreactbuild_geom_Point2Based(arg1$1);
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$49 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
    var this$48 = $n(context);
    var a$7 = (("translate(" + this$48.apply__D__D__T($n(projectedPoint$3).x__D(), $n(projectedPoint$3).y__D())) + ")");
    var t$10 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$10, this$49.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$7);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$52 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "r");
    var t$11 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$11, this$52.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "3");
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$55 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
    var t$12 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array$2 = [$$x3, $$x2, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$12, this$55.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#0000ff")];
    var $$x1 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("circle", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  };
  var array$3 = [$$x11, $$x5, $as_Ljapgolly_scalajs_react_vdom_VdomNode($$x1)];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$62, null, ns)
});
var $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$: 0
}, false, "reactbuild.project.drawing.tool.PlaceNetworkTerminal$", {
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$: 1,
  O: 1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$.prototype.$classData = $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$;
var $n_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$;
function $m_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$() {
  if ((!$n_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$)) {
    $n_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ = new $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$()
  };
  return $n_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$
}
/** @constructor */
function $c_Lreactbuild_project_generator_Document$() {
  this.Lreactbuild_project_generator_Document$__f_component = null;
  $n_Lreactbuild_project_generator_Document$ = this;
  var this$12 = $m_Lcom_iz2use_react_hooks_package$();
  var ev = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).justChildren__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((children$2) => {
    var children = $n($as_Ljapgolly_scalajs_react_PropsChildren(children$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
    var list = $m_Ljapgolly_scalajs_react_PropsChildren$().toList$extension__sjs_js_Any__sci_List(children);
    var this$2 = $n(list);
    var len = this$2.length__I();
    var this$11 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$3 = $n(list);
    var this$10 = $n($as_sci_List($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$3)));
    var f = ((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var node = $n(x0$1)._1__O();
        var i = $n(x0$1)._2$mcI$sp__I();
        var this$4 = $n($m_Lreactbuild_project_generator_Page$().Lreactbuild_project_generator_Page$__f_context);
        var value = new $c_Lreactbuild_project_generator_PageContext(i, len);
        var $$x1 = $n($f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$4, value));
        var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(node))];
        return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    });
    if ((this$10 === $m_sci_Nil$())) {
      var ns = $m_sci_Nil$()
    } else {
      var arg1 = this$10.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$10.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var ns = h
    };
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$11, null, ns)
  })));
  this.Lreactbuild_project_generator_Document$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$12, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.generator.Document.component"))
}
$c_Lreactbuild_project_generator_Document$.prototype = new $h_O();
$c_Lreactbuild_project_generator_Document$.prototype.constructor = $c_Lreactbuild_project_generator_Document$;
/** @constructor */
function $h_Lreactbuild_project_generator_Document$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_Document$.prototype = $c_Lreactbuild_project_generator_Document$.prototype;
$c_Lreactbuild_project_generator_Document$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(children) {
  var c = this.Lreactbuild_project_generator_Document$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$2.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children))
});
var $d_Lreactbuild_project_generator_Document$ = new $TypeData().initClass({
  Lreactbuild_project_generator_Document$: 0
}, false, "reactbuild.project.generator.Document$", {
  Lreactbuild_project_generator_Document$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_Document$.prototype.$classData = $d_Lreactbuild_project_generator_Document$;
var $n_Lreactbuild_project_generator_Document$;
function $m_Lreactbuild_project_generator_Document$() {
  if ((!$n_Lreactbuild_project_generator_Document$)) {
    $n_Lreactbuild_project_generator_Document$ = new $c_Lreactbuild_project_generator_Document$()
  };
  return $n_Lreactbuild_project_generator_Document$
}
function $ct_Lreactbuild_project_generator_DocumentType__T__T__D__($thiz, id, name, preferredScale) {
  $thiz.Lreactbuild_project_generator_DocumentType__f_id = id;
  $thiz.Lreactbuild_project_generator_DocumentType__f_name = name;
  $thiz.Lreactbuild_project_generator_DocumentType__f_preferredScale = preferredScale;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_project_generator_DocumentType() {
  this.Lreactbuild_project_generator_DocumentType__f_id = null;
  this.Lreactbuild_project_generator_DocumentType__f_name = null;
  this.Lreactbuild_project_generator_DocumentType__f_preferredScale = 0.0
}
$c_Lreactbuild_project_generator_DocumentType.prototype = new $h_O();
$c_Lreactbuild_project_generator_DocumentType.prototype.constructor = $c_Lreactbuild_project_generator_DocumentType;
/** @constructor */
function $h_Lreactbuild_project_generator_DocumentType() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_DocumentType.prototype = $c_Lreactbuild_project_generator_DocumentType.prototype;
function $as_Lreactbuild_project_generator_DocumentType(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_DocumentType) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.DocumentType"))
}
function $isArrayOf_Lreactbuild_project_generator_DocumentType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_DocumentType)))
}
function $asArrayOf_Lreactbuild_project_generator_DocumentType(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_DocumentType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.DocumentType;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_generator_DocumentType$() {
  this.Lreactbuild_project_generator_DocumentType$__f_list = null;
  $n_Lreactbuild_project_generator_DocumentType$ = this;
  var this$4 = $m_sci_ListSet$();
  var array = [$m_Lreactbuild_project_generator_DocumentType$Brochure$(), $m_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$(), $m_Lreactbuild_project_generator_DocumentType$PC$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$5 = $n(this$4.from__sc_IterableOnce__sci_ListSet(elems));
  $m_sci_List$();
  var this$8 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$5));
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_project_generator_DocumentType(x$1$2);
    return $n(x$1).Lreactbuild_project_generator_DocumentType__f_name
  }));
  var ord = $m_s_math_Ordering$String$();
  this.Lreactbuild_project_generator_DocumentType$__f_list = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$8, f, ord))
}
$c_Lreactbuild_project_generator_DocumentType$.prototype = new $h_O();
$c_Lreactbuild_project_generator_DocumentType$.prototype.constructor = $c_Lreactbuild_project_generator_DocumentType$;
/** @constructor */
function $h_Lreactbuild_project_generator_DocumentType$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_DocumentType$.prototype = $c_Lreactbuild_project_generator_DocumentType$.prototype;
var $d_Lreactbuild_project_generator_DocumentType$ = new $TypeData().initClass({
  Lreactbuild_project_generator_DocumentType$: 0
}, false, "reactbuild.project.generator.DocumentType$", {
  Lreactbuild_project_generator_DocumentType$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_DocumentType$.prototype.$classData = $d_Lreactbuild_project_generator_DocumentType$;
var $n_Lreactbuild_project_generator_DocumentType$;
function $m_Lreactbuild_project_generator_DocumentType$() {
  if ((!$n_Lreactbuild_project_generator_DocumentType$)) {
    $n_Lreactbuild_project_generator_DocumentType$ = new $c_Lreactbuild_project_generator_DocumentType$()
  };
  return $n_Lreactbuild_project_generator_DocumentType$
}
/** @constructor */
function $c_Lreactbuild_project_generator_Generator$() {
  this.Lreactbuild_project_generator_Generator$__f_generatorDocumentTypeListLayout = null;
  this.Lreactbuild_project_generator_Generator$__f_component = null;
  $n_Lreactbuild_project_generator_Generator$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_generator_Generator$__f_generatorDocumentTypeListLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x8 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x7 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1fr")));
    $n(dsl);
    $n(dsl);
    var a$1 = $m_Lscalacss_internal_Attrs$gap$();
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1.Lscalacss_internal_Attrs$gap$__f_attr, "1em")));
    $n(dsl);
    $n(dsl);
    var a$2 = $m_Lscalacss_internal_Attrs$padding$();
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2.Lscalacss_internal_Attrs$padding$__f_attr, "1em")));
    $n(dsl);
    $n(dsl);
    var a$3 = $m_Lscalacss_internal_Attrs$().gridAutoRows__Lscalacss_internal_Attr();
    var $$x3 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$3, "8em")));
    $n(dsl);
    $n(dsl);
    var this$25 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    $n(dsl);
    var this$ = 40;
    var u = $m_Lscalacss_internal_LengthUnit$em$();
    var v$1 = new $c_Lscalacss_internal_Length(this$, u);
    var $$x2 = $n($n(dsl).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__minWidth__Lscalacss_internal_Length__O(this$25, v$1), new $c_sjsr_AnonFunction1(((x$2) => {
      var x = $as_Lscalacss_internal_Media$Query(x$2);
      return $n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x)
    }))));
    $n(dsl);
    $n(dsl);
    var a$4 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$4, "1fr 1fr")));
    $n(dsl);
    var this$38 = $m_Lscalacss_internal_Attrs$maxWidth$();
    $n(dsl);
    $n(dsl);
    var this$$1 = 40;
    var u$1 = $m_Lscalacss_internal_LengthUnit$em$();
    var f$1 = new $c_Lscalacss_internal_Length(this$$1, u$1);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var v$2 = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$3 = $n(v$2).Lscalacss_internal_ValueT__f_value;
    var array = [$$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$38.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$3)))];
    var x$4 = $n($$x2).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$1 = [$$x7, $$x6, $$x5, $$x4, $$x3, new $c_Lscalacss_internal_DslBase$ToStyle(x$4)];
    return $as_sci_Seq($n($$x8).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })), new $c_Lsourcecode_Name("generatorDocumentTypeListLayout"));
  var this$85 = $m_Lcom_iz2use_react_hooks_package$();
  var this$53 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var deps = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_project_generator_Generator$Props(p$2);
    return $n($n(p).Lreactbuild_project_generator_Generator$Props__f_project).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((prj$2) => {
      var prj = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(prj$2);
      var this$48 = $n($n(p).Lreactbuild_project_generator_Generator$Props__f_allProjects);
      var p$1 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
        var x$1$1 = $as_Lreactbuild_common_model_Project(x$1$2$1);
        return $n($n(x$1$1).Lreactbuild_common_model_Project__f_parent).contains__O__Z($n($as_Lreactbuild_common_model_Project($n(prj).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id)
      }));
      return $ct_T2__O__O__(new $c_T2(), prj, $p_sci_List__filterCommon__F1__Z__sci_List(this$48, p$1, false))
    })))
  }));
  var create = new $c_sjsr_AnonFunction1(((x$2$2) => {
    $as_Lreactbuild_project_generator_Generator$Props(x$2$2);
    return new $c_sjsr_AnonFunction1(((v$2$1) => {
      var v$4 = $as_Ldiode_data_Pot(v$2$1);
      return v$4
    }))
  }));
  var $$x12 = $m_Lreactbuild_model_Implicits$();
  var this$51 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x11 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x10 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var $$x9 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Lreactbuild_model_Implicits$();
  var this$50 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $n($$x11).tuple2__F2__F2__F2($$x10, $n($$x9).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$50.byRef__F2(), this$50.by_$eq$eq__F2())));
  var r$1 = $n($$x12).reusabilityPotC__F2__F2(this$51.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$56 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useMemoBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$53, deps, create, r$1, step)));
  var initialState = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_project_generator_GeneratorPageContext(($m_Lreactbuild_project_generator_GeneratorPageContext$(), new $c_Lreactbuild_project_generator_OutputMedia$StandardPaper($m_Lreactbuild_project_generator_MediaSize$().Lreactbuild_project_generator_MediaSize$__f_A3, $m_Lreactbuild_project_generator_Orientation$Landscape$())))));
  var this$55 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$55);
  var this$84 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$56, initialState, step$1)));
  var f$3 = new $c_sjsr_AnonFunction3(((p$3$2, target$2, context$2) => {
    var p$3 = $as_Lreactbuild_project_generator_Generator$Props(p$3$2);
    var target = $as_Ljapgolly_scalajs_react_Reusable(target$2);
    var context = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(context$2);
    var $$x23 = $m_Lreactbuild_analyze_cost_components_ScrollBlockContainer$();
    var x1 = $n(p$3).Lreactbuild_project_generator_Generator$Props__f_documentType;
    var x$5 = $m_s_None$();
    if ((x$5 === x1)) {
      var $$x18 = $n($m_Lreactbuild_project_generator_Generator$().Lreactbuild_project_generator_Generator$__f_generatorDocumentTypeListLayout);
      var $$x14 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as = $m_Lreactbuild_project_generator_DocumentType$().Lreactbuild_project_generator_DocumentType$__f_list;
      var array$3 = [$n($$x14).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((dt$2) => {
        var dt = $as_Lreactbuild_project_generator_DocumentType(dt$2);
        var $$x17 = $n($n(p$3).Lreactbuild_project_generator_Generator$Props__f_pageProps).Lreactbuild_package$PageProps__f_router;
        var this$58 = $n($n(p$3).Lreactbuild_project_generator_Generator$Props__f_project);
        var this$59 = $n(((!this$58.isEmpty__Z()) ? new $c_s_Some(this$58.get__O()) : $m_s_None$()));
        var f$2 = new $c_sjsr_AnonFunction1(((x$3$2$1) => {
          var x$3$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$3$2$1);
          return $n($as_Lreactbuild_common_model_Project($n(x$3$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id
        }));
        var $$x16 = $n($n($$x17).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$Project(new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator((this$59.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$2.apply__O__O(this$59.get__O()))), $m_s_Option$().apply__O__s_Option(dt)))));
        var $$x15 = $m_Lcom_iz2use_react_components_Card$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v$5 = $n(dt).Lreactbuild_project_generator_DocumentType__f_name;
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$2 = [$n($$x15).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty, $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty, $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty, $m_sci_Nil$())];
        return $n($$x16).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
      })))];
      var $$x13 = $n($$x18).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    } else if ((x1 instanceof $c_s_Some)) {
      var x3 = $as_s_Some(x1);
      var documentType = $as_Lreactbuild_project_generator_DocumentType($n(x3).s_Some__f_value);
      var $$x13 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode($as_Ldiode_data_Pot($n(target).value__O()), new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode())), new $c_sjsr_AnonFunction1(((x0$1$2) => {
        var x0$1 = $as_T2(x0$1$2);
        if ((x0$1 !== null)) {
          var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n(x0$1)._1__O());
          var subprojects = $as_sci_List($n(x0$1)._2__O());
          var $$x22 = $m_Lreactbuild_project_generator_WithOutputMedia$();
          var this$71 = $n(context);
          var $$x21 = $n($as_Lreactbuild_project_generator_GeneratorPageContext(this$71.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])).Lreactbuild_project_generator_GeneratorPageContext__f_output;
          var $$x20 = $n(documentType).Lreactbuild_project_generator_DocumentType__f_preferredScale;
          var this$73 = $n($m_Lreactbuild_project_generator_GeneratorPageContext$().Lreactbuild_project_generator_GeneratorPageContext$__f_context);
          var this$72 = $n(context);
          var value = this$72.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
          var $$x19 = $f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$73, value);
          var array$4 = [$n(documentType).render__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode(project, subprojects)];
          var array$5 = [$n($$x19).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
          return $n($$x22).apply__Lreactbuild_project_generator_OutputMedia__D__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x21, $$x20, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
        } else {
          throw new $c_s_MatchError(x0$1)
        }
      })))
    } else {
      var $$x13;
      throw new $c_s_MatchError(x1)
    };
    var array$6 = [$$x13];
    return $n($$x23).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
  }));
  var this$83 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$83);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$84, f$3, step$2, s);
  this.Lreactbuild_project_generator_Generator$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$85, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.generator.Generator.component"))
}
$c_Lreactbuild_project_generator_Generator$.prototype = new $h_O();
$c_Lreactbuild_project_generator_Generator$.prototype.constructor = $c_Lreactbuild_project_generator_Generator$;
/** @constructor */
function $h_Lreactbuild_project_generator_Generator$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_Generator$.prototype = $c_Lreactbuild_project_generator_Generator$.prototype;
$c_Lreactbuild_project_generator_Generator$.prototype.apply__Ldiode_data_Pot__sci_List__s_Option__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(project, allProjects, documentType, pageProps) {
  var c = this.Lreactbuild_project_generator_Generator$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_generator_Generator$Props(project, allProjects, documentType, pageProps);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_generator_Generator$ = new $TypeData().initClass({
  Lreactbuild_project_generator_Generator$: 0
}, false, "reactbuild.project.generator.Generator$", {
  Lreactbuild_project_generator_Generator$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_Generator$.prototype.$classData = $d_Lreactbuild_project_generator_Generator$;
var $n_Lreactbuild_project_generator_Generator$;
function $m_Lreactbuild_project_generator_Generator$() {
  if ((!$n_Lreactbuild_project_generator_Generator$)) {
    $n_Lreactbuild_project_generator_Generator$ = new $c_Lreactbuild_project_generator_Generator$()
  };
  return $n_Lreactbuild_project_generator_Generator$
}
/** @constructor */
function $c_Lreactbuild_project_generator_GeneratorPart$() {
  this.Lreactbuild_project_generator_GeneratorPart$__f_pageLayout = null;
  this.Lreactbuild_project_generator_GeneratorPart$__f_bodyLayout = null;
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerLayout = null;
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerRightLayout = null;
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerCellHeader = null;
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerCellValue = null;
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerCell = null;
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerPageTitle = null;
  $n_Lreactbuild_project_generator_GeneratorPart$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_generator_GeneratorPart$__f_pageLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x7 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    var this$8 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$8.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")));
    $n(dsl);
    var this$10 = $m_Lscalacss_internal_Attrs$boxSizing$();
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$10.Lscalacss_internal_Attrs$boxSizing$__f_attr, "border-box")));
    $n(dsl);
    var this$13 = $n(dsl);
    $n(dsl);
    var this$12 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x = $n(this$12.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$());
    var x$1 = $as_Lscalacss_internal_Media$Query(x);
    var $$x3 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$1), this$13);
    $n(dsl);
    var this$23 = $m_Lscalacss_internal_Attrs$padding$();
    $n(dsl);
    $n(dsl);
    var this$ = 8;
    var u = $m_Lscalacss_internal_LengthUnit$mm$();
    var f$1 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var all = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$1 = $n(all).Lscalacss_internal_ValueT__f_value;
    var array = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$23.Lscalacss_internal_Attrs$padding$__f_attr, v$1)))];
    var x$2 = $$x3.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle(x$2);
    $n(dsl);
    var this$38 = $m_Lscalacss_internal_Attrs$gap$();
    $n(dsl);
    $n(dsl);
    var this$$1 = 1;
    var u$1 = $m_Lscalacss_internal_LengthUnit$em$();
    var f$3 = new $c_Lscalacss_internal_Length(this$$1, u$1);
    $n(dsl);
    $n(dsl);
    var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      var x$3$1 = $as_Lscalacss_internal_Length(x$3$2$1);
      return $n(x$3$1).value__T()
    })));
    $n(dsl);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$3 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$3)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
    var r$1 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var both = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$3);
    var v$2 = $n(both).Lscalacss_internal_ValueT__f_value;
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$38.Lscalacss_internal_Attrs$gap$__f_attr, v$2)));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var array$1 = [$$x6, $$x5, $$x4, $$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1")))];
    return $as_sci_Seq($n($$x7).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })), new $c_Lsourcecode_Name("pageLayout"));
  var this$47 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$3 = "div";
  this.Lreactbuild_project_generator_GeneratorPart$__f_bodyLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$47, v$3)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x14 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var this$49 = $m_Lscalacss_internal_Attrs$display$();
    var $$x13 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$49.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$3);
    $n(dsl$3);
    var a$1 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var $$x12 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, "1")));
    $n(dsl$3);
    var this$54 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x11 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$54.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")));
    $n(dsl$3);
    var $$x10 = $m_Lscalacss_internal_Attrs$border$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$2 = 1;
    var u$2 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$5 = new $c_Lscalacss_internal_Length(this$$2, u$2);
    $n(dsl$3);
    $n(dsl$3);
    var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$2) => {
      var x$3$3 = $as_Lscalacss_internal_Length(x$3$2$2);
      return $n(x$3$3).value__T()
    })));
    $n(dsl$3);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
      var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$2);
      return $n(x$1$4)
    }));
    var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
    var r$2 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
    var $$x9 = $n(r$2).apply__O__Lscalacss_internal_ValueT(f$5);
    $n(dsl$3);
    $n(dsl$3);
    var f$7 = $m_Lscalacss_internal_Literal$Typed$solid$();
    $n(dsl$3);
    $n(dsl$3);
    var this$66 = $m_Lscalacss_internal_ValueT$Rule$();
    var ab$3 = this$66.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2$1 = $as_Lscalacss_internal_Literal(x$2$2);
      return $n(x$2$1).Lscalacss_internal_Literal__f_value
    })));
    $n(dsl$3);
    var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
      var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$3);
      return $n(x$1$5)
    }));
    var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
    var r$3 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
    var $$x8 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$7);
    $n(dsl$3);
    $n(dsl$3);
    var f$9 = new $c_Lscalacss_internal_ValueT("black");
    $n(dsl$3);
    var f$8 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
      var x$1$6 = $as_Lscalacss_internal_ValueT(x$1$2$4);
      return $n(x$1$6)
    }));
    var r$4 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$8);
    var array$2 = [$$x13, $$x12, $$x11, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x10.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x9, $$x8, r$4.apply__O__Lscalacss_internal_ValueT(f$9))))];
    return $as_sci_Seq($n($$x14).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)))
  })), new $c_Lsourcecode_Name("bodyLayout"));
  var this$81 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$4 = "div";
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$81, v$4)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$4$2) => {
    var dsl$4 = $as_Lscalacss_internal_DslBase(dsl$4$2);
    var $$x17 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$4);
    var this$83 = $m_Lscalacss_internal_Attrs$display$();
    var $$x16 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$83.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    $n(dsl$4);
    $n(dsl$4);
    var a$2 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var $$x15 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2, "1fr 1fr 3fr auto")));
    $n(dsl$4);
    var this$88 = $m_Lscalacss_internal_Attrs$gap$();
    var v$5 = $m_Lscalacss_internal_Literal$Typed$inherit$();
    var v$6 = v$5.Lscalacss_internal_Literal__f_value;
    var array$3 = [$$x16, $$x15, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$88.Lscalacss_internal_Attrs$gap$__f_attr, v$6)))];
    return $as_sci_Seq($n($$x17).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)))
  })), new $c_Lsourcecode_Name("footerLayout"));
  var this$95 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$7 = "div";
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerRightLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$95, v$7)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$5$2) => {
    var dsl$5 = $as_Lscalacss_internal_DslBase(dsl$5$2);
    var $$x20 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$5);
    var this$97 = $m_Lscalacss_internal_Attrs$display$();
    var $$x19 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$97.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    $n(dsl$5);
    $n(dsl$5);
    var a$3 = $m_Lscalacss_internal_Attrs$().grid__Lscalacss_internal_Attr();
    var $$x18 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$3, "[row1-start] \"file file\" 1fr [row1-end] [row2-start] \"date page\" 1fr [row2-end] / 8em 4em")));
    $n(dsl$5);
    var this$102 = $m_Lscalacss_internal_Attrs$gap$();
    var v$8 = $m_Lscalacss_internal_Literal$Typed$inherit$();
    var v$9 = v$8.Lscalacss_internal_Literal__f_value;
    var array$4 = [$$x19, $$x18, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$102.Lscalacss_internal_Attrs$gap$__f_attr, v$9)))];
    return $as_sci_Seq($n($$x20).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)))
  })), new $c_Lsourcecode_Name("footerRightLayout"));
  var this$109 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$10 = "div";
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerCellHeader = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$109, v$10)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$6$2) => {
    var dsl$6 = $as_Lscalacss_internal_DslBase(dsl$6$2);
    var $$x22 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$6);
    var this$111 = $m_Lscalacss_internal_Attrs$color$();
    var $$x21 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$111.Lscalacss_internal_Attrs$color$__f_attr, "gray")));
    $n(dsl$6);
    var this$120 = $m_Lscalacss_internal_Attrs$fontSize$();
    $n(dsl$6);
    $n(dsl$6);
    var this$$3 = 80;
    var f$11 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$3);
    $n(dsl$6);
    $n(dsl$6);
    var ab$4 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lscalacss_internal_Percentage(x$4$2);
      return $n(x$4).value__T()
    })));
    $n(dsl$6);
    var f$10 = new $c_sjsr_AnonFunction1(((x$1$2$5) => {
      var x$1$7 = $as_Lscalacss_internal_ValueT(x$1$2$5);
      return $n(x$1$7)
    }));
    var bc$4 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$10);
    var r$5 = $n(ab$4).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$4);
    var v$11 = $n(r$5).apply__O__Lscalacss_internal_ValueT(f$11);
    var v$12 = $n(v$11).Lscalacss_internal_ValueT__f_value;
    var array$5 = [$$x21, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$120.Lscalacss_internal_Attrs$fontSize$__f_attr, v$12)))];
    return $as_sci_Seq($n($$x22).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
  })), new $c_Lsourcecode_Name("footerCellHeader"));
  var this$126 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$13 = "div";
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerCellValue = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$126, v$13)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$7$2) => {
    var dsl$7 = $as_Lscalacss_internal_DslBase(dsl$7$2);
    var $$x23 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$7);
    $n(dsl$7);
    var a$4 = $m_Lscalacss_internal_Attrs$paddingLeft$();
    var array$6 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$7).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$4.Lscalacss_internal_Attrs$paddingLeft$__f_attr, "1em")))];
    return $as_sci_Seq($n($$x23).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6)))
  })), new $c_Lsourcecode_Name("footerCellValue"));
  var this$136 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$14 = "div";
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerCell = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$136, v$14)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$8$2) => {
    $as_Lscalacss_internal_DslBase(dsl$8$2);
    return $as_sci_Seq($n($m_s_package$().s_package$__f_Seq).apply__sci_Seq__sc_SeqOps($m_sci_Nil$()))
  })), new $c_Lsourcecode_Name("footerCell"));
  var this$139 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$15 = "div";
  this.Lreactbuild_project_generator_GeneratorPart$__f_footerPageTitle = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$139, v$15)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$9$2) => {
    var dsl$9 = $as_Lscalacss_internal_DslBase(dsl$9$2);
    var $$x25 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$9);
    var this$148 = $m_Lscalacss_internal_Attrs$fontSize$();
    $n(dsl$9);
    $n(dsl$9);
    var this$$4 = 150;
    var f$13 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$4);
    $n(dsl$9);
    $n(dsl$9);
    var ab$5 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$1) => {
      var x$4$1 = $as_Lscalacss_internal_Percentage(x$4$2$1);
      return $n(x$4$1).value__T()
    })));
    $n(dsl$9);
    var f$12 = new $c_sjsr_AnonFunction1(((x$1$2$6) => {
      var x$1$8 = $as_Lscalacss_internal_ValueT(x$1$2$6);
      return $n(x$1$8)
    }));
    var bc$5 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$12);
    var r$6 = $n(ab$5).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$5);
    var v$16 = $n(r$6).apply__O__Lscalacss_internal_ValueT(f$13);
    var v$17 = $n(v$16).Lscalacss_internal_ValueT__f_value;
    var $$x24 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$9).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$148.Lscalacss_internal_Attrs$fontSize$__f_attr, v$17)));
    $n(dsl$9);
    var this$150 = $m_Lscalacss_internal_Attrs$fontWeight$();
    var array$7 = [$$x24, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$9).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$150.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")))];
    return $as_sci_Seq($n($$x25).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)))
  })), new $c_Lsourcecode_Name("footerPageTitle"))
}
$c_Lreactbuild_project_generator_GeneratorPart$.prototype = new $h_O();
$c_Lreactbuild_project_generator_GeneratorPart$.prototype.constructor = $c_Lreactbuild_project_generator_GeneratorPart$;
/** @constructor */
function $h_Lreactbuild_project_generator_GeneratorPart$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_GeneratorPart$.prototype = $c_Lreactbuild_project_generator_GeneratorPart$.prototype;
$c_Lreactbuild_project_generator_GeneratorPart$.prototype.footerBlock__T__Ljapgolly_scalajs_react_vdom_VdomNode__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(header, content, attrs) {
  var $$x6 = $n(this.Lreactbuild_project_generator_GeneratorPart$__f_footerCell);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$3 = $m_s_$less$colon$less$();
  var $$x4 = $n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(attrs, this$3.s_$less$colon$less$__f_singleton);
  var $$x3 = $n(this.Lreactbuild_project_generator_GeneratorPart$__f_footerCellHeader);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(header))];
  var $$x2 = $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x1 = this.Lreactbuild_project_generator_GeneratorPart$__f_footerCellValue;
  var array$1 = [content];
  var array$2 = [$$x4, $$x2, $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  return $n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
$c_Lreactbuild_project_generator_GeneratorPart$.prototype.apply__T__T__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement = (function(partNumber, partName, children, project) {
  var $$x21 = $m_Lreactbuild_project_generator_paper_Page$();
  var $$x20 = this.Lreactbuild_project_generator_GeneratorPart$__f_pageLayout;
  var $$x19 = $n(this.Lreactbuild_project_generator_GeneratorPart$__f_bodyLayout);
  var $$x18 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$3 = $m_s_$less$colon$less$();
  var array = [$n($$x18).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(children, this$3.s_$less$colon$less$__f_singleton)];
  var $$x17 = $n($$x19).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x16 = this.Lreactbuild_project_generator_GeneratorPart$__f_footerLayout;
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("???"))];
  var $$x14 = this.footerBlock__T__Ljapgolly_scalajs_react_vdom_VdomNode__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("Demandeur", $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)), $m_sci_Nil$());
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$16 = $n($n($n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_address).Lreactbuild_common_model_ProjectAddress__f_raw);
  var v = $as_T((this$16.isEmpty__Z() ? "(Non d\u00e9fini)" : this$16.get__O()));
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  var $$x12 = this.footerBlock__T__Ljapgolly_scalajs_react_vdom_VdomNode__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("Adresse du projet", $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)), $m_sci_Nil$());
  var $$x11 = this.Lreactbuild_project_generator_GeneratorPart$__f_footerPageTitle;
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$1 = ((("PCMI" + partNumber) + " - ") + partName);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
  var $$x10 = this.footerBlock__T__Ljapgolly_scalajs_react_vdom_VdomNode__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("Titre", $n($$x11).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)), $m_sci_Nil$());
  var $$x9 = this.Lreactbuild_project_generator_GeneratorPart$__f_footerRightLayout;
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$2 = $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_reference;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
  var $$x7 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var array$5 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "gridArea")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("file", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x6 = this.footerBlock__T__Ljapgolly_scalajs_react_vdom_VdomNode__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("Fichier", $$x7, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$41 = $m_Ljava_time_LocalDate$();
  var v$3 = this$41.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()));
  var ev = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var v$4 = $n(ev).stringify__O__T(v$3);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
  var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var array$7 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "gridArea")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("date", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x3 = this.footerBlock__T__Ljapgolly_scalajs_react_vdom_VdomNode__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("Date", $$x4, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var this$61 = $n($m_Lreactbuild_project_generator_Page$().Lreactbuild_project_generator_Page$__f_context);
  var f = new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Lreactbuild_project_generator_PageContext(ctx$2);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$5 = ((((1 + $n(ctx).Lreactbuild_project_generator_PageContext__f_index) | 0) + " / ") + $n(ctx).Lreactbuild_project_generator_PageContext__f_total);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$8 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
    return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  }));
  var $$x2 = $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$61, f);
  var array$9 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "gridArea")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("page", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$10 = [$$x6, $$x3, this.footerBlock__T__Ljapgolly_scalajs_react_vdom_VdomNode__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("Page n\u00b0", $$x2, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))];
  var array$11 = [$$x14, $$x12, $$x10, $n($$x9).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
  var array$12 = [$$x17, $n($$x16).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
  var array$13 = [$n($$x20).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  return $n($$x21).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))
});
var $d_Lreactbuild_project_generator_GeneratorPart$ = new $TypeData().initClass({
  Lreactbuild_project_generator_GeneratorPart$: 0
}, false, "reactbuild.project.generator.GeneratorPart$", {
  Lreactbuild_project_generator_GeneratorPart$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_GeneratorPart$.prototype.$classData = $d_Lreactbuild_project_generator_GeneratorPart$;
var $n_Lreactbuild_project_generator_GeneratorPart$;
function $m_Lreactbuild_project_generator_GeneratorPart$() {
  if ((!$n_Lreactbuild_project_generator_GeneratorPart$)) {
    $n_Lreactbuild_project_generator_GeneratorPart$ = new $c_Lreactbuild_project_generator_GeneratorPart$()
  };
  return $n_Lreactbuild_project_generator_GeneratorPart$
}
/** @constructor */
function $c_Lreactbuild_project_generator_GroundDrawing$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_GroundDrawing$.prototype = new $h_O();
$c_Lreactbuild_project_generator_GroundDrawing$.prototype.constructor = $c_Lreactbuild_project_generator_GroundDrawing$;
/** @constructor */
function $h_Lreactbuild_project_generator_GroundDrawing$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_GroundDrawing$.prototype = $c_Lreactbuild_project_generator_GroundDrawing$.prototype;
$c_Lreactbuild_project_generator_GroundDrawing$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement = (function(projectPot) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Plan de masse"))];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lreactbuild_project_generator_GroundDrawing$ = new $TypeData().initClass({
  Lreactbuild_project_generator_GroundDrawing$: 0
}, false, "reactbuild.project.generator.GroundDrawing$", {
  Lreactbuild_project_generator_GroundDrawing$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_GroundDrawing$.prototype.$classData = $d_Lreactbuild_project_generator_GroundDrawing$;
var $n_Lreactbuild_project_generator_GroundDrawing$;
function $m_Lreactbuild_project_generator_GroundDrawing$() {
  if ((!$n_Lreactbuild_project_generator_GroundDrawing$)) {
    $n_Lreactbuild_project_generator_GroundDrawing$ = new $c_Lreactbuild_project_generator_GroundDrawing$()
  };
  return $n_Lreactbuild_project_generator_GroundDrawing$
}
/** @constructor */
function $c_Lreactbuild_project_generator_Notice$() {
  this.Lreactbuild_project_generator_Notice$__f_noticeLayout = null;
  this.Lreactbuild_project_generator_Notice$__f_component = null;
  $n_Lreactbuild_project_generator_Notice$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_generator_Notice$__f_noticeLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().columns__Lscalacss_internal_Attr();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "2em 2")));
    $n(dsl);
    $n(dsl);
    var a$1 = $m_Lscalacss_internal_Attrs$padding$();
    var array = [$$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1.Lscalacss_internal_Attrs$padding$__f_attr, "2em")))];
    return $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })), new $c_Lsourcecode_Name("noticeLayout"));
  var this$68 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction0((() => $m_s_None$())), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x4 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x3 = new $c_sjsr_AnonFunction2(((p$2, text$2) => {
    $as_Lreactbuild_project_generator_Notice$Props(p$2);
    var text = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(text$2);
    return $n($as_s_Option($n(text).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).isEmpty__Z()
  }));
  var this$20 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$67 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($$x4.useStateSnapshotBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$20))));
  var f = new $c_sjsr_AnonFunction3(((props$2, text$3$2, editing$2) => {
    var props = $as_Lreactbuild_project_generator_Notice$Props(props$2);
    var text$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(text$3$2);
    var editing = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(editing$2);
    if ((props === null)) {
      throw new $c_s_MatchError(props)
    };
    $n(props);
    $n(props);
    if ($uZ($n(editing).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)) {
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Description du projet :");
      var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableMultiline;
      var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
      var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_multilineComponent;
      var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var this$26 = $m_s_math_Equiv$();
      var equiv = this$26.universal__s_math_Equiv();
      var this$28 = $n(editorComponent);
      var result = this$28.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, text$3, optioner, ev, explainError, equiv)
    } else {
      var $$x10 = $n($m_Lreactbuild_project_generator_Notice$().Lreactbuild_project_generator_Notice$__f_noticeLayout);
      var x1$2 = $as_s_Option($n(text$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
      if ((x1$2 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x1$2);
        var value = $n($as_Lcom_iz2use_common_Multiline($n(x2).s_Some__f_value)).Lcom_iz2use_common_Multiline__f_underlying;
        var $$x6 = $m_Lfastparse_package$();
        var conv = new $c_sjsr_AnonFunction1(((s$2) => {
          var s = $as_T(s$2);
          return new $c_Lfastparse_IndexedParserInput(s)
        }));
        var x1$3 = $n($$x6).parse__Lfastparse_ParserInputSource__F1__Z__I__Lfastparse_internal_Instrument__Lfastparse_Parsed(new $c_Lfastparse_ParserInputSource$fromParserInput(value, conv), new $c_sjsr_AnonFunction1(((x$2$2) => {
          var x$2 = $as_Lfastparse_ParsingRun(x$2$2);
          return $m_Lreactbuild_project_generator_markdown_MarkdownParser$().root__Lfastparse_ParsingRun__Lfastparse_ParsingRun(x$2)
        })), ($m_Lfastparse_package$(), false), ($m_Lfastparse_package$(), 0), ($m_Lfastparse_package$(), null));
        if ((x1$3 instanceof $c_Lfastparse_Parsed$Success)) {
          var x2$2 = $as_Lfastparse_Parsed$Success(x1$3);
          var results = $as_sci_Seq($n(x2$2).Lfastparse_Parsed$Success__f_value);
          var this$31 = $m_Lreactbuild_project_generator_markdown_MarkdownRender$();
          var blocks = $n(results).toList__sci_List();
          var $$x5 = $p_Lreactbuild_project_generator_markdown_MarkdownRender$__loop$1__sci_List__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode(this$31, $m_s_package$().s_package$__f_Nil, blocks)
        } else {
          if ((!(x1$3 instanceof $c_Lfastparse_Parsed$Failure))) {
            throw new $c_s_MatchError(x1$3)
          };
          var x3 = $as_Lfastparse_Parsed$Failure(x1$3);
          var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var v$1 = ("Erreur : " + x3);
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
          var $$x5 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("code", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
        }
      } else {
        var x = $m_s_None$();
        if ((!(x === x1$2))) {
          throw new $c_s_MatchError(x1$2)
        };
        var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun texte pour la notice pour le moment");
        var this$43 = $m_Lscalacss_ScalaCssReact$();
        var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
        var array$2 = [$$x8, $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$43, s$1)];
        var $$x5 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
      };
      var array$3 = [$$x5];
      var result = $n($$x10).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    };
    var this$65 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x13 = $m_Lcom_iz2use_react_components_Link$();
    var this$50 = $n(editing);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$51 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$52 = $n(this$51.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$52.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$53 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$53.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$50.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$3$2 = $uZ(arg1);
    var arg1$1 = (!x$3$2);
    var $$x12 = $n($$x13).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$50.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var $$x11 = ($uZ($n(editing).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value) ? ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Visualiser")) : ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Modifier")));
    var this$58 = $m_Lscalacss_ScalaCssReact$();
    var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
    var array$4 = [$$x11, $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$58, s$3)];
    var array$5 = [$n($$x12).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)), result];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$65, null, ns)
  }));
  var this$66 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$66);
  var s$4 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$67, f, step, s$4);
  this.Lreactbuild_project_generator_Notice$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$68, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.generator.Notice.component"))
}
$c_Lreactbuild_project_generator_Notice$.prototype = new $h_O();
$c_Lreactbuild_project_generator_Notice$.prototype.constructor = $c_Lreactbuild_project_generator_Notice$;
/** @constructor */
function $h_Lreactbuild_project_generator_Notice$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_Notice$.prototype = $c_Lreactbuild_project_generator_Notice$.prototype;
$c_Lreactbuild_project_generator_Notice$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomElement = (function(projectPot, subprojects) {
  var c = this.Lreactbuild_project_generator_Notice$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_generator_Notice$Props(projectPot, subprojects);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_project_generator_Notice$ = new $TypeData().initClass({
  Lreactbuild_project_generator_Notice$: 0
}, false, "reactbuild.project.generator.Notice$", {
  Lreactbuild_project_generator_Notice$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_Notice$.prototype.$classData = $d_Lreactbuild_project_generator_Notice$;
var $n_Lreactbuild_project_generator_Notice$;
function $m_Lreactbuild_project_generator_Notice$() {
  if ((!$n_Lreactbuild_project_generator_Notice$)) {
    $n_Lreactbuild_project_generator_Notice$ = new $c_Lreactbuild_project_generator_Notice$()
  };
  return $n_Lreactbuild_project_generator_Notice$
}
function $f_Lreactbuild_project_generator_OutputMedia__$init$__V($thiz) {
  var a = $n($n($thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_mediaSize).Lreactbuild_project_generator_MediaSize__f_size)._1$mcD$sp__D();
  var b = $n($n($thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_mediaSize).Lreactbuild_project_generator_MediaSize__f_size)._2$mcD$sp__D();
  $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_min = $uD(Math.min(a, b));
  var a$1 = $n($n($thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_mediaSize).Lreactbuild_project_generator_MediaSize__f_size)._1$mcD$sp__D();
  var b$1 = $n($n($thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_mediaSize).Lreactbuild_project_generator_MediaSize__f_size)._2$mcD$sp__D();
  $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_max = $uD(Math.max(a$1, b$1));
  var x1 = $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_orientation;
  var x = $m_Lreactbuild_project_generator_Orientation$Portrait$();
  if ((x === x1)) {
    var $$x1 = $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_min
  } else {
    var x$3 = $m_Lreactbuild_project_generator_Orientation$Landscape$();
    if ((!(x$3 === x1))) {
      throw new $c_s_MatchError(x1)
    };
    var $$x1 = $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_max
  };
  $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_width = $$x1;
  var x1$2 = $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_orientation;
  var x$5 = $m_Lreactbuild_project_generator_Orientation$Portrait$();
  if ((x$5 === x1$2)) {
    var $$x2 = $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_max
  } else {
    var x$7 = $m_Lreactbuild_project_generator_Orientation$Landscape$();
    if ((!(x$7 === x1$2))) {
      throw new $c_s_MatchError(x1$2)
    };
    var $$x2 = $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_min
  };
  $thiz.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_height = $$x2
}
/** @constructor */
function $c_Lreactbuild_project_generator_Page$() {
  this.Lreactbuild_project_generator_Page$__f_context = null;
  $n_Lreactbuild_project_generator_Page$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_React$();
  this.Lreactbuild_project_generator_Page$__f_context = $n(this$1.Ljapgolly_scalajs_react_React$__f_Context).apply__T__O__Ljapgolly_scalajs_react_feature_Context("PageContext", null)
}
$c_Lreactbuild_project_generator_Page$.prototype = new $h_O();
$c_Lreactbuild_project_generator_Page$.prototype.constructor = $c_Lreactbuild_project_generator_Page$;
/** @constructor */
function $h_Lreactbuild_project_generator_Page$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_Page$.prototype = $c_Lreactbuild_project_generator_Page$.prototype;
var $d_Lreactbuild_project_generator_Page$ = new $TypeData().initClass({
  Lreactbuild_project_generator_Page$: 0
}, false, "reactbuild.project.generator.Page$", {
  Lreactbuild_project_generator_Page$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_Page$.prototype.$classData = $d_Lreactbuild_project_generator_Page$;
var $n_Lreactbuild_project_generator_Page$;
function $m_Lreactbuild_project_generator_Page$() {
  if ((!$n_Lreactbuild_project_generator_Page$)) {
    $n_Lreactbuild_project_generator_Page$ = new $c_Lreactbuild_project_generator_Page$()
  };
  return $n_Lreactbuild_project_generator_Page$
}
/** @constructor */
function $c_Lreactbuild_project_generator_Place$() {
  this.Lreactbuild_project_generator_Place$__f_portraitLayout = null;
  this.Lreactbuild_project_generator_Place$__f_landscapeLayout = null;
  this.Lreactbuild_project_generator_Place$__f_component = null;
  $n_Lreactbuild_project_generator_Place$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_generator_Place$__f_portraitLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x5 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$width$();
    var $$x3 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "100%")));
    $n(dsl);
    $n(dsl);
    var a$1 = $m_Lscalacss_internal_Attrs$height$();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "100%")));
    $n(dsl);
    var this$16 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$1 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$2 = v$1.Lscalacss_internal_Literal__f_value;
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$16.Lscalacss_internal_Attrs$overflow$__f_attr, v$2)));
    $n(dsl);
    var this$18 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var array = [$$x4, $$x3, $$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$18.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")))];
    return $as_sci_Seq($n($$x5).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })), new $c_Lsourcecode_Name("portraitLayout"));
  var this$24 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$3 = "div";
  this.Lreactbuild_project_generator_Place$__f_landscapeLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$24, v$3)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x10 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var this$26 = $m_Lscalacss_internal_Attrs$display$();
    var $$x9 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$26.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$3);
    $n(dsl$3);
    var a$2 = $m_Lscalacss_internal_Attrs$width$();
    var $$x8 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "100%")));
    $n(dsl$3);
    $n(dsl$3);
    var a$3 = $m_Lscalacss_internal_Attrs$height$();
    var $$x7 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$3.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "100%")));
    $n(dsl$3);
    var this$36 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$4 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$5 = v$4.Lscalacss_internal_Literal__f_value;
    var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$36.Lscalacss_internal_Attrs$overflow$__f_attr, v$5)));
    $n(dsl$3);
    var this$38 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var array$1 = [$$x9, $$x8, $$x7, $$x6, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$38.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")))];
    return $as_sci_Seq($n($$x10).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })), new $c_Lsourcecode_Name("landscapeLayout"));
  var this$118 = $m_Lcom_iz2use_react_hooks_package$();
  var this$45 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var evidence$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_scalajs_dom_HTMLElement.getClassOf());
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$48 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefToVdom__s_reflect_ClassTag__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$45, evidence$1, step)));
  var hook = new $c_sjsr_AnonFunction2(((x$1$2, ref$2) => {
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$1$2);
    var ref = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$2);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Lreactbuild_hooks_ClientSize$().Lreactbuild_hooks_ClientSize$__f_hook, ref))
  }));
  var this$46 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$46);
  var this$47 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$47);
  var this$80 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__customBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$48, hook, step$1, d)));
  var deps = new $c_sjsr_AnonFunction3(((p$2, x$2$2, x$3$2) => {
    var p = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(p$2);
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$2$2);
    $as_s_Option(x$3$2);
    return $n(p).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((prj$2) => {
      var prj = $as_Lreactbuild_common_model_Project(prj$2);
      var this$49 = $n($n($n(prj).Lreactbuild_common_model_Project__f_address).Lreactbuild_common_model_ProjectAddress__f_coordinates);
      var f = new $c_sjsr_AnonFunction1(((coords$2) => {
        var coords = $as_Lreactbuild_common_model_Coordinates(coords$2);
        return $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().modelToCoordinates__Lreactbuild_common_model_Coordinates__sjs_js_Array(coords)
      }));
      return (this$49.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$49.get__O())))
    })), new $c_sjsr_AnonFunction1(((v$2$1) => {
      var v$6 = $as_s_Option(v$2$1);
      return new $c_sjsr_AnonFunction1(((prj$2$1) => {
        var prj$1 = $as_Lreactbuild_common_model_Project(prj$2$1);
        var this$50 = $n(v$6);
        var f$1 = new $c_sjsr_AnonFunction1(((coords$2$1) => $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().coordinatesToModel__sjs_js_Array__Lreactbuild_common_model_Coordinates(coords$2$1)));
        var x$1$1 = (this$50.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$1.apply__O__O(this$50.get__O())));
        var this$51 = $n($n(prj$1).Lreactbuild_common_model_Project__f_address);
        var x$2$1 = this$51.Lreactbuild_common_model_ProjectAddress__f_country;
        var this$52 = $n($n(prj$1).Lreactbuild_common_model_Project__f_address);
        var x$3$1 = this$52.Lreactbuild_common_model_ProjectAddress__f_raw;
        var this$53 = $n($n(prj$1).Lreactbuild_common_model_Project__f_address);
        var x$4 = this$53.Lreactbuild_common_model_ProjectAddress__f_parcels;
        $n($n(prj$1).Lreactbuild_common_model_Project__f_address);
        var x$5 = new $c_Lreactbuild_common_model_ProjectAddress(x$2$1, x$3$1, x$4, x$1$1);
        var this$55 = $n(prj$1);
        var x$6 = this$55.Lreactbuild_common_model_Project__f__id;
        var this$56 = $n(prj$1);
        var x$7 = this$56.Lreactbuild_common_model_Project__f_organizations;
        var this$57 = $n(prj$1);
        var x$8 = this$57.Lreactbuild_common_model_Project__f_name;
        var this$58 = $n(prj$1);
        var x$9 = this$58.Lreactbuild_common_model_Project__f_title;
        var this$59 = $n(prj$1);
        var x$10 = this$59.Lreactbuild_common_model_Project__f_description;
        var this$60 = $n(prj$1);
        var x$11 = this$60.Lreactbuild_common_model_Project__f_images;
        var this$61 = $n(prj$1);
        var x$12 = this$61.Lreactbuild_common_model_Project__f_location;
        var this$62 = $n(prj$1);
        var x$13 = this$62.Lreactbuild_common_model_Project__f_areas;
        var this$63 = $n(prj$1);
        var x$14 = this$63.Lreactbuild_common_model_Project__f_price;
        var this$64 = $n(prj$1);
        var x$15 = this$64.Lreactbuild_common_model_Project__f_soldOut;
        var this$65 = $n(prj$1);
        var x$16 = this$65.Lreactbuild_common_model_Project__f_privacy;
        var this$66 = $n(prj$1);
        var x$17 = this$66.Lreactbuild_common_model_Project__f_scenes;
        var this$67 = $n(prj$1);
        var x$18 = this$67.Lreactbuild_common_model_Project__f_renderSettings;
        var this$68 = $n(prj$1);
        var x$19 = this$68.Lreactbuild_common_model_Project__f_city;
        var this$69 = $n(prj$1);
        var x$20 = this$69.Lreactbuild_common_model_Project__f_district;
        var this$70 = $n(prj$1);
        var x$21 = this$70.Lreactbuild_common_model_Project__f_topic;
        var this$71 = $n(prj$1);
        var x$22 = this$71.Lreactbuild_common_model_Project__f_modelSource;
        var this$72 = $n(prj$1);
        var x$23 = this$72.Lreactbuild_common_model_Project__f_procedureState;
        var this$73 = $n(prj$1);
        var x$24 = this$73.Lreactbuild_common_model_Project__f_summary;
        var this$74 = $n(prj$1);
        var x$25 = this$74.Lreactbuild_common_model_Project__f_archived;
        var this$75 = $n(prj$1);
        var x$26 = this$75.Lreactbuild_common_model_Project__f_parent;
        var this$76 = $n(prj$1);
        var x$27 = this$76.Lreactbuild_common_model_Project__f_reference;
        $n(prj$1);
        return new $c_Lreactbuild_common_model_Project(x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$5, x$27)
      }))
    })))
  }));
  var create = new $c_sjsr_AnonFunction3(((x$4$2, x$5$2, x$6$2) => {
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$4$2);
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$5$2);
    $as_s_Option(x$6$2);
    return new $c_sjsr_AnonFunction1(((x$2$3) => {
      var x = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$2$3);
      return x
    }))
  }));
  var r = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$79 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$79);
  var this$117 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$80, deps, create, r, step$2)));
  var f$3 = new $c_sjsr_AnonFunction4(((p$3$2, ref$3$2, sizeOpt$2, positionOpt$2) => {
    var p$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(p$3$2);
    var ref$3 = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$3$2);
    var sizeOpt = $as_s_Option(sizeOpt$2);
    var positionOpt = $as_Ljapgolly_scalajs_react_Reusable(positionOpt$2);
    var x1 = $as_s_Option($n($as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n(positionOpt).value__O())).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    if ((x1 instanceof $c_s_Some)) {
      var position = $n($as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n(positionOpt).value__O())).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$7$2) => {
        var x$7$1 = $as_s_Option(x$7$2);
        return $n(x$7$1).get__O()
      })), new $c_sjsr_AnonFunction1(((v$2$2) => new $c_sjsr_AnonFunction1(((x$8$2) => {
        $as_s_Option(x$8$2);
        return $m_s_Option$().apply__O__s_Option(v$2$2)
      })))));
      var this$90 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var u = $m_Lreactbuild_project_generator_PlaceMapView$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__D__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(position, 18.0);
      var this$82 = $n(u);
      var n = this$82.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x11 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
      var u$1 = $m_Lreactbuild_project_generator_PlaceMapView$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__D__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(position, 15.0);
      var this$85 = $n(u$1);
      var n$1 = this$85.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$2 = [$$x11, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
      var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      var children = this$90.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms);
      var this$91 = $n(sizeOpt);
      var p$1 = new $c_sjsr_AnonFunction1(((size$2) => {
        var size = $as_Lreactbuild_hooks_ClientSize(size$2);
        return ($n(size).Lreactbuild_hooks_ClientSize__f_width < $n(size).Lreactbuild_hooks_ClientSize__f_height)
      }));
      if (((!this$91.isEmpty__Z()) && $uZ(p$1.apply__O__O(this$91.get__O())))) {
        var $$x12 = $n($n($m_Lreactbuild_project_generator_Place$().Lreactbuild_project_generator_Place$__f_portraitLayout).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(ref$3)));
        var array$3 = [children];
        return $n($$x12).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      } else {
        var $$x13 = $n($n($m_Lreactbuild_project_generator_Place$().Lreactbuild_project_generator_Place$__f_landscapeLayout).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(ref$3)));
        var array$4 = [children];
        return $n($$x13).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
      }
    } else {
      var x$28 = $m_s_None$();
      if ((x$28 === x1)) {
        var this$115 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
        var f$2 = new $c_sjsr_AnonFunction1(((pageProps$2) => {
          $as_Lreactbuild_package$PageProps(pageProps$2);
          var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var u$2 = $m_Lreactbuild_project_ShowProjectAddress$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(p$3, new $c_sjsr_AnonFunction2(((coords$2$2, text$2) => {
            var text = $as_T(text$2);
            var $$x15 = $m_Lcom_iz2use_react_components_Link$();
            var this$103 = $n($as_Ljapgolly_scalajs_react_StateAccess$ModState(($m_Ljapgolly_scalajs_react_Reusable$(), $n(positionOpt).value__O())));
            var mod = new $c_sjsr_AnonFunction1(((x$9$2) => {
              $as_s_Option(x$9$2);
              return $m_s_Option$().apply__O__s_Option(coords$2$2)
            }));
            var $$x14 = $n($n($$x15).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$103, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
            var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(text))];
            return $n($$x14).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
          })));
          var this$110 = $n(u$2);
          var n$2 = this$110.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
          var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
          return $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
        }));
        return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$115, f$2)
      } else {
        throw new $c_s_MatchError(x1)
      }
    }
  }));
  var this$116 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$116);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$117, f$3, step$3, s);
  this.Lreactbuild_project_generator_Place$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$118, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.generator.Place.component"))
}
$c_Lreactbuild_project_generator_Place$.prototype = new $h_O();
$c_Lreactbuild_project_generator_Place$.prototype.constructor = $c_Lreactbuild_project_generator_Place$;
/** @constructor */
function $h_Lreactbuild_project_generator_Place$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_Place$.prototype = $c_Lreactbuild_project_generator_Place$.prototype;
$c_Lreactbuild_project_generator_Place$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(projectPot) {
  var c = this.Lreactbuild_project_generator_Place$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(projectPot, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_generator_Place$ = new $TypeData().initClass({
  Lreactbuild_project_generator_Place$: 0
}, false, "reactbuild.project.generator.Place$", {
  Lreactbuild_project_generator_Place$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_Place$.prototype.$classData = $d_Lreactbuild_project_generator_Place$;
var $n_Lreactbuild_project_generator_Place$;
function $m_Lreactbuild_project_generator_Place$() {
  if ((!$n_Lreactbuild_project_generator_Place$)) {
    $n_Lreactbuild_project_generator_Place$ = new $c_Lreactbuild_project_generator_Place$()
  };
  return $n_Lreactbuild_project_generator_Place$
}
/** @constructor */
function $c_Lreactbuild_project_generator_PlaceMapView$() {
  this.Lreactbuild_project_generator_PlaceMapView$__f_component = null;
  $n_Lreactbuild_project_generator_PlaceMapView$ = this;
  var this$111 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary(), api).useStateSnapshotBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Lreactbuild_project_generator_PlaceMapView$Props(x$10$2);
    return $n(x$10).Lreactbuild_project_generator_PlaceMapView$Props__f_zoom
  })), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep()));
  var $$x6 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$1);
  var $$x1 = new $c_sjsr_AnonFunction0((() => {
    var $$x5 = $i_ol$002fstyle.Style;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var $$x4 = $moduleDefault($i_ol$002fstyle$002fCircle);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CircleStyleOptions);
    var array = [$ct_T2__O__O__(new $c_T2(), "radius", 15.0)];
    var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    var $$x2 = $moduleDefault($i_ol$002fstyle$002fStroke);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions);
    var fields$2 = $m_sci_Nil$();
    var _\uff3fobj$2 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
    _\uff3fobj$2.width = 3.0;
    _\uff3fobj$2.color = "#ffffffc0";
    var value = new $$x2(_\uff3fobj$2);
    _\uff3fobj$1.stroke = value;
    var $$x3 = $moduleDefault($i_ol$002fstyle$002fFill);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
    var fields$3 = $m_sci_Nil$();
    var _\uff3fobj$3 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3);
    _\uff3fobj$3.color = "#ff00ffc0";
    var value$1 = new $$x3(_\uff3fobj$3);
    _\uff3fobj$1.fill = value$1;
    var value$2 = new $$x4(_\uff3fobj$1);
    _\uff3fobj.image = value$2;
    var style = new $$x5(_\uff3fobj);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions);
    var fields$4 = $m_sci_Nil$();
    var _\uff3fobj$4 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$4);
    var value$3 = new ($moduleDefault($i_ol$002fsource$002fVector))();
    _\uff3fobj$4.source = value$3;
    _\uff3fobj$4.style = style;
    return new ($moduleDefault($i_ol$002flayer$002fVector))(_\uff3fobj$4)
  }));
  var this$57 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$64 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x6.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$57))));
  var deps = new $c_sjsr_AnonFunction3(((p$2, x$11$2, x$12$2) => {
    var p = $as_Lreactbuild_project_generator_PlaceMapView$Props(p$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$11$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$12$2);
    return $n($n(p).Lreactbuild_project_generator_PlaceMapView$Props__f_position).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value
  }));
  var effect = new $c_sjsr_AnonFunction3(((p$3$2, x$13$2, layer$2) => {
    $as_Lreactbuild_project_generator_PlaceMapView$Props(p$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$13$2);
    var layer = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(layer$2);
    return new $c_sjsr_AnonFunction1(((pos$2) => {
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f = new $c_sjsr_AnonFunction0((() => {
        var source = $n(layer).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value.getSource();
        source.clear();
        var point = new ($moduleDefault($i_ol$002fgeom$002fPoint))(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections), $i_ol$002fproj.fromLonLat(pos$2)));
        var feature = new ($moduleDefault($i_ol$002fFeature))(point);
        source.addFeature(feature)
      }));
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        f.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableCoordinate;
  var this$63 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$63);
  var this$81 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$64, deps, effect, a, r, step)));
  var initialState = new $c_sjsr_AnonFunction3(((x$14$2, x$15$2, layer$3$2) => {
    $as_Lreactbuild_project_generator_PlaceMapView$Props(x$14$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$15$2);
    var layer$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(layer$3$2);
    var $$x10 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$();
    var u = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$().apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$().render__Ltypings_ol_layerBaseMod$default(), true, $m_sci_Nil$());
    var this$66 = $n(u);
    var n = this$66.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var u$1 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$().apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Site).render__Ltypings_ol_layerBaseMod$default(), true, $m_sci_Nil$());
    var this$69 = $n(u$1);
    var n$1 = this$69.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
    var u$2 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$().apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Building).render__Ltypings_ol_layerBaseMod$default(), true, $m_sci_Nil$());
    var this$72 = $n(u$2);
    var n$2 = this$72.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x7 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2);
    var u$3 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$().apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(layer$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, true, $m_sci_Nil$());
    var this$75 = $n(u$3);
    var n$3 = this$75.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$1 = [$$x9, $$x8, $$x7, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)];
    return $n($$x10).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  }));
  var this$80 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$80);
  var this$110 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$81, initialState, step$1)));
  var f$4 = new $c_sjsr_AnonFunction4(((p$4$2, zoom$2, x$16$2, layers$2) => {
    var p$4 = $as_Lreactbuild_project_generator_PlaceMapView$Props(p$4$2);
    var zoom = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(zoom$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$16$2);
    var layers = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(layers$2);
    $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
    var f$3 = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x11;
        var p2 = $as_s_Option(x1.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x = $m_s_None$();
        if ((x === p2)) {
          var $$x11 = cb;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1.T2__f__1);
        var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var viewPoint = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint($n(x5).s_Some__f_value);
          var $$x12 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var this$83 = $n(zoom);
          var mod = new $c_sjsr_AnonFunction1(((v$2) => {
            var v = $uD(v$2);
            var this$82 = $m_s_Option$();
            var cond = (v === $n(viewPoint).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom);
            var a$1 = new $c_sjsr_AnonFunction0((() => $n(viewPoint).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom));
            return this$82.when__Z__F0__s_Option((!cond), a$1)
          }));
          var $$x11 = $n($$x12).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modStateOption__F1__O(this$83, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$19$2) => {
            $as_jl_Void(x$19$2);
            var $$x13 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var this$85 = $n($n(p$4).Lreactbuild_project_generator_PlaceMapView$Props__f_position);
            var mod$1 = new $c_sjsr_AnonFunction1(((v$2$1) => {
              var this$84 = $m_s_Option$();
              var y = $n(viewPoint).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords;
              var cond$1 = $m_sr_BoxesRunTime$().equals__O__O__Z(v$2$1, y);
              var a$2 = new $c_sjsr_AnonFunction0((() => $n(viewPoint).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords));
              return this$84.when__Z__F0__s_Option((!cond$1), a$2)
            }));
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x13).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modStateOption__F1__O(this$85, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$18$2) => {
              $as_jl_Void(x$18$2);
              var f$2 = new $c_sjsr_AnonFunction1(((x$17$2) => {
                $as_jl_Void(x$17$2)
              }));
              var this$87 = $n(cb$2);
              return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$87, f$2))
            }))))
          })));
          break matchEnd7
        };
        throw new $c_s_MatchError(x1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x11)
    }));
    var ssViewPoint = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$3);
    var $$x17 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$();
    var $$x16 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$().apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(ssViewPoint, new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint($n($n(p$4).Lreactbuild_project_generator_PlaceMapView$Props__f_position).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, $uD($n(zoom).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)), $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$().Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseViewPoint);
    var $$x15 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_MapProvider$();
    var this$90 = $n(layers);
    var u$4 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(this$90.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    var this$92 = $n(u$4);
    var n$4 = this$92.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x14 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4);
    var u$5 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_sci_Nil$());
    var this$95 = $n(u$5);
    var n$5 = this$95.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$2 = [$$x14, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$5)];
    var u$6 = $n($$x15).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var this$101 = $n(u$6);
    var n$6 = this$101.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$6)];
    var u$7 = $n($$x17).apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x16, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var this$107 = $n(u$7);
    var n$7 = this$107.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$7)
  }));
  var this$109 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$109);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$11 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$110, f$4, step$2, s);
  this.Lreactbuild_project_generator_PlaceMapView$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$111, ev$11).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.generator.PlaceMapView.component"))
}
$c_Lreactbuild_project_generator_PlaceMapView$.prototype = new $h_O();
$c_Lreactbuild_project_generator_PlaceMapView$.prototype.constructor = $c_Lreactbuild_project_generator_PlaceMapView$;
/** @constructor */
function $h_Lreactbuild_project_generator_PlaceMapView$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_PlaceMapView$.prototype = $c_Lreactbuild_project_generator_PlaceMapView$.prototype;
$c_Lreactbuild_project_generator_PlaceMapView$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__D__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(position, zoom) {
  var c = this.Lreactbuild_project_generator_PlaceMapView$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_generator_PlaceMapView$Props(position, zoom);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_generator_PlaceMapView$ = new $TypeData().initClass({
  Lreactbuild_project_generator_PlaceMapView$: 0
}, false, "reactbuild.project.generator.PlaceMapView$", {
  Lreactbuild_project_generator_PlaceMapView$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_PlaceMapView$.prototype.$classData = $d_Lreactbuild_project_generator_PlaceMapView$;
var $n_Lreactbuild_project_generator_PlaceMapView$;
function $m_Lreactbuild_project_generator_PlaceMapView$() {
  if ((!$n_Lreactbuild_project_generator_PlaceMapView$)) {
    $n_Lreactbuild_project_generator_PlaceMapView$ = new $c_Lreactbuild_project_generator_PlaceMapView$()
  };
  return $n_Lreactbuild_project_generator_PlaceMapView$
}
/** @constructor */
function $c_Lreactbuild_project_generator_SectionCutDrawing$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_SectionCutDrawing$.prototype = new $h_O();
$c_Lreactbuild_project_generator_SectionCutDrawing$.prototype.constructor = $c_Lreactbuild_project_generator_SectionCutDrawing$;
/** @constructor */
function $h_Lreactbuild_project_generator_SectionCutDrawing$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_SectionCutDrawing$.prototype = $c_Lreactbuild_project_generator_SectionCutDrawing$.prototype;
$c_Lreactbuild_project_generator_SectionCutDrawing$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement = (function(projectPot) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Plan en coupe"))];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lreactbuild_project_generator_SectionCutDrawing$ = new $TypeData().initClass({
  Lreactbuild_project_generator_SectionCutDrawing$: 0
}, false, "reactbuild.project.generator.SectionCutDrawing$", {
  Lreactbuild_project_generator_SectionCutDrawing$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_SectionCutDrawing$.prototype.$classData = $d_Lreactbuild_project_generator_SectionCutDrawing$;
var $n_Lreactbuild_project_generator_SectionCutDrawing$;
function $m_Lreactbuild_project_generator_SectionCutDrawing$() {
  if ((!$n_Lreactbuild_project_generator_SectionCutDrawing$)) {
    $n_Lreactbuild_project_generator_SectionCutDrawing$ = new $c_Lreactbuild_project_generator_SectionCutDrawing$()
  };
  return $n_Lreactbuild_project_generator_SectionCutDrawing$
}
/** @constructor */
function $c_Lreactbuild_project_generator_WithOutputMedia$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_WithOutputMedia$.prototype = new $h_O();
$c_Lreactbuild_project_generator_WithOutputMedia$.prototype.constructor = $c_Lreactbuild_project_generator_WithOutputMedia$;
/** @constructor */
function $h_Lreactbuild_project_generator_WithOutputMedia$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_WithOutputMedia$.prototype = $c_Lreactbuild_project_generator_WithOutputMedia$.prototype;
$c_Lreactbuild_project_generator_WithOutputMedia$.prototype.apply__Lreactbuild_project_generator_OutputMedia__D__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(media, zoom, children) {
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_Attr$Style$();
  var y = ($n(media).Lreactbuild_project_generator_OutputMedia$StandardPaper__f_width + "mm");
  var $$x5 = $ct_T2__O__O__(new $c_T2(), "--paper-width", y);
  var y$1 = ($n(media).Lreactbuild_project_generator_OutputMedia$StandardPaper__f_height + "mm");
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "--paper-height", y$1);
  var y$2 = ("" + zoom);
  var array = [$$x5, $$x4, $ct_T2__O__O__(new $c_T2(), "--paper-zoom", y$2)];
  var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x6 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$();
  var this$16 = $m_s_$less$colon$less$();
  var $$x2 = $$x7.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($$x6, $n($$x3).byImplicit__F1__F2(this$16.s_$less$colon$less$__f_singleton));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$19 = $m_s_$less$colon$less$();
  var array$1 = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(children, this$19.s_$less$colon$less$__f_singleton)];
  return $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lreactbuild_project_generator_WithOutputMedia$ = new $TypeData().initClass({
  Lreactbuild_project_generator_WithOutputMedia$: 0
}, false, "reactbuild.project.generator.WithOutputMedia$", {
  Lreactbuild_project_generator_WithOutputMedia$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_WithOutputMedia$.prototype.$classData = $d_Lreactbuild_project_generator_WithOutputMedia$;
var $n_Lreactbuild_project_generator_WithOutputMedia$;
function $m_Lreactbuild_project_generator_WithOutputMedia$() {
  if ((!$n_Lreactbuild_project_generator_WithOutputMedia$)) {
    $n_Lreactbuild_project_generator_WithOutputMedia$ = new $c_Lreactbuild_project_generator_WithOutputMedia$()
  };
  return $n_Lreactbuild_project_generator_WithOutputMedia$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Cell$() {
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardCellLayout = null;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardCellContentLayout = null;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardIcon = null;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardLabel = null;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_component = null;
  $n_Lreactbuild_project_generator_electricalboard_components_Cell$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardCellLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x6 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "0px 0px 1px gray")));
    $n(dsl);
    var this$9 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$1 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$2 = v$1.Lscalacss_internal_Literal__f_value;
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$9.Lscalacss_internal_Attrs$overflow$__f_attr, v$2)));
    $n(dsl);
    var this$12 = $n(dsl);
    $n(dsl);
    var this$11 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x = $n(this$11.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
    var x$1 = $as_Lscalacss_internal_Media$Query(x);
    var $$x3 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$1), this$12);
    $n(dsl);
    var this$14 = $m_Lscalacss_internal_Attrs$position$();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$14.Lscalacss_internal_Attrs$position$__f_attr, "relative")));
    $n(dsl);
    var this$16 = $m_Lscalacss_internal_Attrs$verticalAlign$();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$16.Lscalacss_internal_Attrs$verticalAlign$__f_attr, "top")));
    $n(dsl);
    var this$18 = $m_Lscalacss_internal_Attrs$textAlign$();
    var array = [$$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$18.Lscalacss_internal_Attrs$textAlign$__f_attr, "left")))];
    var x$2 = $$x3.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$1 = [$$x5, $$x4, new $c_Lscalacss_internal_DslBase$ToStyle(x$2)];
    return $as_sci_Seq($n($$x6).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })), new $c_Lsourcecode_Name("electricalBoardCellLayout"));
  var this$29 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$3 = "div";
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardCellContentLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$29, v$3)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x15 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var this$31 = $m_Lscalacss_internal_Attrs$display$();
    var $$x14 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$31.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$3);
    var this$33 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x13 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$33.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")));
    $n(dsl$3);
    var this$35 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$4 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$5 = v$4.Lscalacss_internal_Literal__f_value;
    var $$x12 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$35.Lscalacss_internal_Attrs$overflow$__f_attr, v$5)));
    $n(dsl$3);
    var this$38 = $n(dsl$3);
    $n(dsl$3);
    var this$37 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x$3 = $n(this$37.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
    var x$4 = $as_Lscalacss_internal_Media$Query(x$3);
    var $$x11 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl$3).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$4), this$38);
    $n(dsl$3);
    var this$40 = $m_Lscalacss_internal_Attrs$position$();
    var $$x10 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$40.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
    $n(dsl$3);
    var this$49 = $m_Lscalacss_internal_Attrs$width$();
    $n(dsl$3);
    $n(dsl$3);
    var this$ = 100;
    var f$1 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$);
    $n(dsl$3);
    $n(dsl$3);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4$1 = $as_Lscalacss_internal_Percentage(x$4$2);
      return $n(x$4$1).value__T()
    })));
    $n(dsl$3);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var v$6 = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$7 = $n(v$6).Lscalacss_internal_ValueT__f_value;
    var $$x9 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$49.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$7)));
    $n(dsl$3);
    var this$58 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$1 = 100;
    var f$3 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$1);
    $n(dsl$3);
    $n(dsl$3);
    var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$1) => {
      var x$4$3 = $as_Lscalacss_internal_Percentage(x$4$2$1);
      return $n(x$4$3).value__T()
    })));
    $n(dsl$3);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$3 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$3)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
    var r$1 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var v$8 = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$3);
    var v$9 = $n(v$8).Lscalacss_internal_ValueT__f_value;
    var $$x8 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$58.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$9)));
    $n(dsl$3);
    var this$68 = $m_Lscalacss_internal_Attrs$left$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$2 = 0;
    var u = $m_Lscalacss_internal_LengthUnit$px$();
    var f$5 = new $c_Lscalacss_internal_Length(this$$2, u);
    $n(dsl$3);
    $n(dsl$3);
    var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3$1 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3$1).value__T()
    })));
    $n(dsl$3);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
      var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$2);
      return $n(x$1$4)
    }));
    var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
    var r$2 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
    var v$10 = $n(r$2).apply__O__Lscalacss_internal_ValueT(f$5);
    var v$11 = $n(v$10).Lscalacss_internal_ValueT__f_value;
    var $$x7 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$68.Lscalacss_internal_Attrs$left$__f_attr, v$11)));
    $n(dsl$3);
    var this$78 = $m_Lscalacss_internal_Attrs$top$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$3 = 0;
    var u$1 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$7 = new $c_Lscalacss_internal_Length(this$$3, u$1);
    $n(dsl$3);
    $n(dsl$3);
    var ab$3 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      var x$3$3 = $as_Lscalacss_internal_Length(x$3$2$1);
      return $n(x$3$3).value__T()
    })));
    $n(dsl$3);
    var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
      var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$3);
      return $n(x$1$5)
    }));
    var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
    var r$3 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
    var v$12 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$7);
    var v$13 = $n(v$12).Lscalacss_internal_ValueT__f_value;
    var array$2 = [$$x10, $$x9, $$x8, $$x7, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$78.Lscalacss_internal_Attrs$top$__f_attr, v$13)))];
    var x$5 = $$x11.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$3 = [$$x14, $$x13, $$x12, new $c_Lscalacss_internal_DslBase$ToStyle(x$5)];
    return $as_sci_Seq($n($$x15).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)))
  })), new $c_Lsourcecode_Name("electricalBoardCellContentLayout"));
  var this$89 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$14 = "div";
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardIcon = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$89, v$14)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$4$2) => {
    var dsl$4 = $as_Lscalacss_internal_DslBase(dsl$4$2);
    var $$x21 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$4);
    var this$92 = $n(dsl$4);
    $n(dsl$4);
    var this$91 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x$6 = $n(this$91.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
    var x$7 = $as_Lscalacss_internal_Media$Query(x$6);
    var $$x20 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl$4).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$7), this$92);
    $n(dsl$4);
    $n(dsl$4);
    var a$1 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var array$4 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, "1")))];
    var x$8 = $$x20.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x19 = new $c_Lscalacss_internal_DslBase$ToStyle(x$8);
    $n(dsl$4);
    var this$102 = $m_Lscalacss_internal_Attrs$textAlign$();
    var $$x18 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$102.Lscalacss_internal_Attrs$textAlign$__f_attr, "center")));
    var $$x17 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
      var x$1$6 = $as_T(x$1$2$4);
      return (x$1$6 + ">*")
    }));
    $n(dsl$4);
    var this$112 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl$4);
    $n(dsl$4);
    var this$$4 = 28;
    var u$2 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$9 = new $c_Lscalacss_internal_Length(this$$4, u$2);
    $n(dsl$4);
    $n(dsl$4);
    var ab$4 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$2) => {
      var x$3$4 = $as_Lscalacss_internal_Length(x$3$2$2);
      return $n(x$3$4).value__T()
    })));
    $n(dsl$4);
    var f$8 = new $c_sjsr_AnonFunction1(((x$1$2$5) => {
      var x$1$7 = $as_Lscalacss_internal_ValueT(x$1$2$5);
      return $n(x$1$7)
    }));
    var bc$4 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$8);
    var r$4 = $n(ab$4).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$4);
    var v$15 = $n(r$4).apply__O__Lscalacss_internal_ValueT(f$9);
    var v$16 = $n(v$15).Lscalacss_internal_ValueT__f_value;
    var array$5 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$112.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$16)))];
    var $$x16 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(dsl$4).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x17, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
    $n(dsl$4);
    var this$126 = $m_Lscalacss_internal_Attrs$marginTop$();
    $n(dsl$4);
    $n(dsl$4);
    var this$$5 = 4;
    var u$3 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$11 = new $c_Lscalacss_internal_Length(this$$5, u$3);
    $n(dsl$4);
    $n(dsl$4);
    var ab$5 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$3) => {
      var x$3$5 = $as_Lscalacss_internal_Length(x$3$2$3);
      return $n(x$3$5).value__T()
    })));
    $n(dsl$4);
    var f$10 = new $c_sjsr_AnonFunction1(((x$1$2$6) => {
      var x$1$8 = $as_Lscalacss_internal_ValueT(x$1$2$6);
      return $n(x$1$8)
    }));
    var bc$5 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$10);
    var r$5 = $n(ab$5).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$5);
    var v$17 = $n(r$5).apply__O__Lscalacss_internal_ValueT(f$11);
    var v$18 = $n(v$17).Lscalacss_internal_ValueT__f_value;
    var array$6 = [$$x19, $$x18, $$x16, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$126.Lscalacss_internal_Attrs$marginTop$__f_attr, v$18)))];
    return $as_sci_Seq($n($$x21).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6)))
  })), new $c_Lsourcecode_Name("electricalBoardIcon"));
  var this$132 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$19 = "div";
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardLabel = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$132, v$19)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$5$2) => {
    var dsl$5 = $as_Lscalacss_internal_DslBase(dsl$5$2);
    var $$x28 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$5);
    var this$135 = $n(dsl$5);
    $n(dsl$5);
    var this$134 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x$9 = $n(this$134.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
    var x$10 = $as_Lscalacss_internal_Media$Query(x$9);
    var $$x27 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl$5).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$10), this$135);
    $n(dsl$5);
    $n(dsl$5);
    var a$2 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var array$7 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2, "2")))];
    var x$11 = $$x27.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x26 = new $c_Lscalacss_internal_DslBase$ToStyle(x$11);
    $n(dsl$5);
    var this$145 = $m_Lscalacss_internal_Attrs$textAlign$();
    var $$x25 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$145.Lscalacss_internal_Attrs$textAlign$__f_attr, "center")));
    $n(dsl$5);
    var this$149 = $n(dsl$5);
    $n(dsl$5);
    var this$148 = new $c_Lscalacss_internal_DslBase$MediaQueryNeedType($m_Lscalacss_internal_Media$Not$());
    var x$12 = $n(this$148.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
    var x$3$6 = $as_Lscalacss_internal_Media$Query(x$12);
    var $$x24 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl$5).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$3$6), this$149);
    $n(dsl$5);
    var this$151 = $m_Lscalacss_internal_Attrs$display$();
    var $$x23 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$151.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$5);
    var this$153 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x22 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$153.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")));
    $n(dsl$5);
    var this$155 = $m_Lscalacss_internal_Attrs$justifyContent$();
    var array$8 = [$$x23, $$x22, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$155.Lscalacss_internal_Attrs$justifyContent$__f_attr, "space-between")))];
    var x$13 = $$x24.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$9 = [$$x26, $$x25, new $c_Lscalacss_internal_DslBase$ToStyle(x$13)];
    return $as_sci_Seq($n($$x28).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9)))
  })), new $c_Lsourcecode_Name("electricalBoardLabel"));
  var this$166 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$20 = "div";
  $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$166, v$20)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$6$2) => {
    var dsl$6 = $as_Lscalacss_internal_DslBase(dsl$6$2);
    var $$x31 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$6);
    var this$168 = $m_Lscalacss_internal_Attrs$display$();
    var $$x30 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$168.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    $n(dsl$6);
    var this$170 = $m_Lscalacss_internal_Attrs$width$();
    var $$x29 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$170.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "available")));
    $n(dsl$6);
    $n(dsl$6);
    var a$3 = $m_Lscalacss_internal_Attrs$().gridAutoColumns__Lscalacss_internal_Attr();
    var array$10 = [$$x30, $$x29, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$3, "1fr")))];
    return $as_sci_Seq($n($$x31).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10)))
  })), new $c_Lsourcecode_Name("electricalBoardLineSources"));
  var this$185 = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Cell", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2$1) => {
    var x$14 = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2$1);
    return new $c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend(x$14)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2$4) => {
    var x$3$7 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2$4);
    var $$x33 = $n($as_Lreactbuild_project_generator_electricalboard_components_Cell$Backend($n(x$3$7).backend__O()));
    var this$180 = $n(x$3$7);
    var $$x32 = $as_Lreactbuild_project_generator_electricalboard_components_Cell$Props($n(this$180.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$181 = $n(x$3$7);
    return $n($$x33).render__Lreactbuild_project_generator_electricalboard_components_Cell$Props__jl_Void__Ljapgolly_scalajs_react_vdom_TagOf($$x32, $as_jl_Void($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$181)))
  }))));
  var this$183 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var evidence$1 = this$183.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var f$12 = $m_Ljapgolly_scalajs_react_extra_OnUnmountF$().install__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(evidence$1);
  this.Lreactbuild_project_generator_electricalboard_components_Cell$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$12).apply__O__O(this$185))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_generator_electricalboard_components_Cell$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Cell$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Cell$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Cell$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Cell$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Cell$.prototype;
var $d_Lreactbuild_project_generator_electricalboard_components_Cell$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Cell$: 0
}, false, "reactbuild.project.generator.electricalboard.components.Cell$", {
  Lreactbuild_project_generator_electricalboard_components_Cell$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Cell$;
var $n_Lreactbuild_project_generator_electricalboard_components_Cell$;
function $m_Lreactbuild_project_generator_electricalboard_components_Cell$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_Cell$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_Cell$ = new $c_Lreactbuild_project_generator_electricalboard_components_Cell$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_Cell$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Line$() {
  this.Lreactbuild_project_generator_electricalboard_components_Line$__f_component = null;
  $n_Lreactbuild_project_generator_electricalboard_components_Line$ = this;
  this.Lreactbuild_project_generator_electricalboard_components_Line$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("model.Line", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_generator_electricalboard_components_Line$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x1 = $n($as_Lreactbuild_project_generator_electricalboard_components_Line$Backend($n(x$3).backend__O()));
    var this$5 = $n(x$3);
    return $n($$x1).render__Lreactbuild_project_generator_electricalboard_components_Line$Props__Ljapgolly_scalajs_react_vdom_VdomElement($as_Lreactbuild_project_generator_electricalboard_components_Line$Props($n(this$5.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_generator_electricalboard_components_Line$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Line$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Line$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Line$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Line$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Line$.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_Line$.prototype.withKey__T__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__I__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, line, moveCell, index) {
  var c = this.Lreactbuild_project_generator_electricalboard_components_Line$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lreactbuild_project_generator_electricalboard_components_Line$Props(line, moveCell, index);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_generator_electricalboard_components_Line$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Line$: 0
}, false, "reactbuild.project.generator.electricalboard.components.Line$", {
  Lreactbuild_project_generator_electricalboard_components_Line$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Line$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Line$;
var $n_Lreactbuild_project_generator_electricalboard_components_Line$;
function $m_Lreactbuild_project_generator_electricalboard_components_Line$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_Line$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_Line$ = new $c_Lreactbuild_project_generator_electricalboard_components_Line$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_Line$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Line$Backend(\u03b4) {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_electricalboard_components_Line$Backend.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Line$Backend.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Line$Backend;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Line$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Line$Backend.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Line$Backend.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_Line$Backend.prototype.render__Lreactbuild_project_generator_electricalboard_components_Line$Props__Ljapgolly_scalajs_react_vdom_VdomElement = (function(props) {
  var this$22 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n($as_Lreactbuild_project_generator_electricalboard_model_Line($n($n(props).Lreactbuild_project_generator_electricalboard_components_Line$Props__f_line).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Line__f_cells;
  var this$3 = $n($m_Ljapgolly_scalajs_react_vdom_VdomArray$().empty__Ljapgolly_scalajs_react_vdom_VdomArray());
  var this$4 = $n($n(as).iterator__sc_Iterator());
  while (this$4.hasNext__Z()) {
    var arg1 = this$4.next__O();
    var $$x3 = this$3.Ljapgolly_scalajs_react_vdom_VdomArray__f_rawArray;
    var cell = $as_Lreactbuild_project_generator_electricalboard_model_Cell(arg1);
    var c = $m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_component;
    var $$x2 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
    var a = $n($n(cell).Lreactbuild_project_generator_electricalboard_model_Cell__f_id).toString__T();
    var this$14 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x2).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
    var props$1 = new $c_Lreactbuild_project_generator_electricalboard_components_Cell$Props($m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), cell), new $c_sjsr_AnonFunction2(((props) => ((ov$2, cb$2) => {
      var ov = $as_s_Option(ov$2);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$13 = $n($n(props).Lreactbuild_project_generator_electricalboard_components_Line$Props__f_line);
      var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
      var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
      var arg1$1 = this$13.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var t = $as_Lreactbuild_project_generator_electricalboard_model_Line(arg1$1);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$13.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some($n(t).update__Lreactbuild_project_generator_electricalboard_model_Cell__Lreactbuild_project_generator_electricalboard_model_Line($as_Lreactbuild_project_generator_electricalboard_model_Cell($n(ov).get__O()))), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }))(props))), $n(props).Lreactbuild_project_generator_electricalboard_components_Line$Props__f_moveCell, $n(props).Lreactbuild_project_generator_electricalboard_components_Line$Props__f_index);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$14.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props$1, this$14.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$16 = $n(u);
    var n = this$16.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var this$18 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var $$x1 = $$x3.push($f_Ljapgolly_scalajs_react_vdom_VdomElement__rawNode__sjs_js_$bar(this$18));
    $uI($$x1)
  };
  var array = [this$3];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$22, null, ns)
});
function $as_Lreactbuild_project_generator_electricalboard_components_Line$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_components_Line$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.components.Line$Backend"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_components_Line$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_components_Line$Backend)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_components_Line$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_components_Line$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.components.Line$Backend;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_components_Line$Backend = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Line$Backend: 0
}, false, "reactbuild.project.generator.electricalboard.components.Line$Backend", {
  Lreactbuild_project_generator_electricalboard_components_Line$Backend: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Line$Backend.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Line$Backend;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_LineSource$() {
  this.Lreactbuild_project_generator_electricalboard_components_LineSource$__f_component = null;
  $n_Lreactbuild_project_generator_electricalboard_components_LineSource$ = this;
  var this$49 = $m_Lcom_iz2use_react_hooks_package$();
  $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(p$2);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("ID");
    var this$11 = $n(p);
    var g = new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_T(v$2);
      return new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(x$2$2);
        var this$7 = $n(x$2);
        var x$2$2$1 = this$7.Lreactbuild_project_generator_electricalboard_model_LineSource__f_id;
        var this$8 = $n(x$2);
        var x$3 = this$8.Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter;
        var this$9 = $n(x$2);
        var x$4 = this$9.Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors;
        $n(x$2);
        return new $c_Lreactbuild_project_generator_electricalboard_model_LineSource(x$2$2$1, v, x$3, x$4)
      }))
    }));
    var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$11.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
    var arg1 = this$11.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$1 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(arg1);
    var state = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$11, $n(x$1).Lreactbuild_project_generator_electricalboard_model_LineSource__f_label, new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
      var ot = $as_s_Option(ot$2);
      var $$x5 = $n($as_F2($n(this$11.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
      var this$12 = $n(ot);
      return $n($$x5).apply__O__O__O((this$12.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$12.get__O()))), cb$2)
    })));
    var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$15 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$15);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv = $m_s_math_Equiv$String$();
    var $$x6 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Diam\u00e8tre");
    var this$25 = $n(p);
    var g$2 = new $c_sjsr_AnonFunction1(((v$3$2) => {
      var v$3 = $as_s_Option(v$3$2);
      return new $c_sjsr_AnonFunction1(((x$4$2) => {
        var x$4$1 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(x$4$2);
        var this$21 = $n(x$4$1);
        var x$6 = this$21.Lreactbuild_project_generator_electricalboard_model_LineSource__f_id;
        var this$22 = $n(x$4$1);
        var x$7 = this$22.Lreactbuild_project_generator_electricalboard_model_LineSource__f_label;
        var this$23 = $n(x$4$1);
        var x$8 = this$23.Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors;
        $n(x$4$1);
        return new $c_Lreactbuild_project_generator_electricalboard_model_LineSource(x$6, x$7, v$3, x$8)
      }))
    }));
    var g$3 = new $c_sjsr_AnonFunction1(((x$1$2$1) => $n($as_F1(g$2.apply__O__O(x$1$2$1))).apply__O__O(this$25.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
    var arg1$1 = this$25.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$3$1 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(arg1$1);
    var state$1 = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$25, $n(x$3$1).Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter, new $c_sjsr_AnonFunction2(((ot$2$1, cb$2$1) => {
      var ot$1 = $as_s_Option(ot$2$1);
      var $$x3 = $n($as_F2($n(this$25.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
      var this$26 = $n(ot$1);
      return $n($$x3).apply__O__O__O((this$26.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$3.apply__O__O(this$26.get__O()))), cb$2$1)
    })));
    var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$1);
    var ev$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$31 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$31);
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
    var equiv$1 = new $c_s_math_Equiv$OptionEquiv(eqv);
    var $$x4 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$2, explainError$1, equiv$1);
    var $$x1 = $m_Lreactbuild_project_generator_electricalboard_components_WireColors$();
    var this$40 = $n(p);
    var g$4 = new $c_sjsr_AnonFunction1(((v$4$2) => {
      var v$4 = $as_sci_Set(v$4$2);
      return new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(s$2);
        var this$36 = $n(s);
        var x$10 = this$36.Lreactbuild_project_generator_electricalboard_model_LineSource__f_id;
        var this$37 = $n(s);
        var x$11 = this$37.Lreactbuild_project_generator_electricalboard_model_LineSource__f_label;
        var this$38 = $n(s);
        var x$12 = this$38.Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter;
        $n(s);
        return new $c_Lreactbuild_project_generator_electricalboard_model_LineSource(x$10, x$11, x$12, v$4)
      }))
    }));
    var g$5 = new $c_sjsr_AnonFunction1(((x$1$2$2) => $n($as_F1(g$4.apply__O__O(x$1$2$2))).apply__O__O(this$40.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
    var arg1$2 = this$40.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$5 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(arg1$2);
    var u = $n($$x1).apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$40, $n(x$5).Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors, new $c_sjsr_AnonFunction2(((ot$2$2, cb$2$2) => {
      var ot$3 = $as_s_Option(ot$2$2);
      var $$x2 = $n($as_F2($n(this$40.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
      var this$41 = $n(ot$3);
      return $n($$x2).apply__O__O__O((this$41.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$5.apply__O__O(this$41.get__O()))), cb$2$2)
    }))));
    var this$43 = $n(u);
    var n = this$43.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array = [$$x6, $$x4, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  var s$1 = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$3 = $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(f, s$1);
  this.Lreactbuild_project_generator_electricalboard_components_LineSource$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$49, ev$3).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.generator.electricalboard.components.LineSource.component"))
}
$c_Lreactbuild_project_generator_electricalboard_components_LineSource$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_LineSource$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_LineSource$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_LineSource$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_LineSource$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_LineSource$.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_LineSource$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(state) {
  var c = this.Lreactbuild_project_generator_electricalboard_components_LineSource$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(state, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_generator_electricalboard_components_LineSource$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_LineSource$: 0
}, false, "reactbuild.project.generator.electricalboard.components.LineSource$", {
  Lreactbuild_project_generator_electricalboard_components_LineSource$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_LineSource$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_LineSource$;
var $n_Lreactbuild_project_generator_electricalboard_components_LineSource$;
function $m_Lreactbuild_project_generator_electricalboard_components_LineSource$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_LineSource$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_LineSource$ = new $c_Lreactbuild_project_generator_electricalboard_components_LineSource$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_LineSource$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Root$() {
  this.Lreactbuild_project_generator_electricalboard_components_Root$__f_key = null;
  this.Lreactbuild_project_generator_electricalboard_components_Root$__f_component = null;
  $n_Lreactbuild_project_generator_electricalboard_components_Root$ = this;
  this.Lreactbuild_project_generator_electricalboard_components_Root$__f_key = "electricalboard-last";
  var this$22 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialState$extension__T__F0__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Root", new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($m_s_Option$().apply__O__s_Option($as_T(window.localStorage.getItem($m_Lreactbuild_project_generator_electricalboard_components_Root$().Lreactbuild_project_generator_electricalboard_components_Root$__f_key))));
    if (this$2.isEmpty__Z()) {
      var $$x2 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var last = $as_T(arg1);
      var this$3 = $n($n($m_Lio_circe_parser_package$().parse__T__s_util_Either(last)).toOption__s_Option());
      if (this$3.isEmpty__Z()) {
        var $$x2 = $m_s_None$()
      } else {
        var arg1$1 = this$3.get__O();
        var json = $as_Lio_circe_Json(arg1$1);
        var this$4 = $n(json);
        var d = $m_Lreactbuild_project_generator_electricalboard_model_Table$().Lreactbuild_project_generator_electricalboard_model_Table$__f_codecForTable;
        var this$6 = $n($n($n(d).apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(this$4, null, null))).toOption__s_Option());
        if (this$6.isEmpty__Z()) {
          var $$x2 = $m_s_None$()
        } else {
          var arg1$2 = this$6.get__O();
          var r = $as_Lreactbuild_project_generator_electricalboard_model_Table(arg1$2);
          var $$x2 = new $c_s_Some(r)
        }
      }
    };
    var this$7 = $n($$x2);
    return $as_Lreactbuild_project_generator_electricalboard_model_Table((this$7.isEmpty__Z() ? new $c_Lreactbuild_project_generator_electricalboard_model_Table(($m_Lreactbuild_project_generator_electricalboard_model_Table$(), $m_s_package$().s_package$__f_Nil)) : this$7.get__O()))
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lreactbuild_project_generator_electricalboard_components_Root$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x1 = $n($as_Lreactbuild_project_generator_electricalboard_components_Root$Backend($n(x$3).backend__O()));
    var this$9 = $n(x$3);
    var u = $n($$x1).render__Lreactbuild_project_generator_electricalboard_model_Table__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_Lreactbuild_project_generator_electricalboard_model_Table($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$9)));
    var this$11 = $n(u);
    var n = this$11.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }))));
  var f$1 = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(c$2);
    var this$19 = $n($as_Ljapgolly_scalajs_react_extra_TimerSupportF($n(c).backend__O()));
    var f = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_project_generator_electricalboard_components_Root$Backend($n(c).backend__O())).save__Ljapgolly_scalajs_react_callback_Trampoline());
    var this$14 = new $c_s_concurrent_duration_package$DurationInt(5);
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
    var this$ = this$14.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    $m_s_concurrent_duration_Duration$();
    var hi = (this$ >> 31);
    var period = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit);
    var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
    var this$20 = $n(period.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(period.s_concurrent_duration_FiniteDuration__f_length);
    var periodInMilliseconds = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$20.RTLong__f_lo, this$20.RTLong__f_hi);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_extra_TimerSupportF__setIntervalMs__O__D__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$19, f, periodInMilliseconds, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$24 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$22, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentDidMount__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1));
  var f$2 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(c$3$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lreactbuild_project_generator_electricalboard_components_Root$Backend($n(c$3).backend__O())).save__Ljapgolly_scalajs_react_callback_Trampoline())
  }));
  var G$2 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$28 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$24, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillUnmount__Ljapgolly_scalajs_react_internal_Lens(), f$2, G$2));
  var this$26 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var evidence$1 = this$26.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var f$3 = $m_Ljapgolly_scalajs_react_extra_OnUnmountF$().install__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(evidence$1);
  this.Lreactbuild_project_generator_electricalboard_components_Root$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f$3).apply__O__O(this$28))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonN__Ljapgolly_scalajs_react_internal_Singleton__Ljapgolly_scalajs_react_CtorType$Summoner($m_Ljapgolly_scalajs_react_internal_Singleton$().Ljapgolly_scalajs_react_internal_Singleton$__f_BoxUnit))
}
$c_Lreactbuild_project_generator_electricalboard_components_Root$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Root$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Root$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Root$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Root$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Root$.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_Root$.prototype.apply__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function() {
  var c = this.Lreactbuild_project_generator_electricalboard_components_Root$__f_component;
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n($as_Ljapgolly_scalajs_react_CtorType$Nullary($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).apply__O())
});
var $d_Lreactbuild_project_generator_electricalboard_components_Root$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Root$: 0
}, false, "reactbuild.project.generator.electricalboard.components.Root$", {
  Lreactbuild_project_generator_electricalboard_components_Root$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Root$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Root$;
var $n_Lreactbuild_project_generator_electricalboard_components_Root$;
function $m_Lreactbuild_project_generator_electricalboard_components_Root$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_Root$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_Root$ = new $c_Lreactbuild_project_generator_electricalboard_components_Root$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_Root$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Table$() {
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardTableLayout = null;
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperTableLayout = null;
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardAddRow = null;
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperWire = null;
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperCell = null;
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperCellLabel = null;
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_component = null;
  $n_Lreactbuild_project_generator_electricalboard_components_Table$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardTableLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x29 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$borderCollapse$();
    var $$x28 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$borderCollapse$__f_attr, "collapse")));
    $n(dsl);
    var this$8 = $m_Lscalacss_internal_Attrs$display$();
    var $$x27 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$8.Lscalacss_internal_Attrs$display$__f_attr, "inline-grid")));
    $n(dsl);
    $n(dsl);
    var this$10 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var $$x26 = $n($n(dsl).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$10.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$2) => {
      var x = $as_Lscalacss_internal_Media$Query(x$2);
      return $n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x)
    }))));
    $n(dsl);
    var this$20 = $m_Lscalacss_internal_Attrs$rowGap$();
    $n(dsl);
    $n(dsl);
    var this$ = 1;
    var u = $m_Lscalacss_internal_LengthUnit$cm$();
    var f$1 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var v$1 = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$2 = $n(v$1).Lscalacss_internal_ValueT__f_value;
    var array = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$20.Lscalacss_internal_Attrs$rowGap$__f_attr, v$2)))];
    var x$4 = $n($$x26).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x25 = new $c_Lscalacss_internal_DslBase$ToStyle(x$4);
    $n(dsl);
    $n(dsl);
    var this$28 = new $c_Lscalacss_internal_DslBase$MediaQueryNeedType($m_Lscalacss_internal_Media$Not$());
    var $$x24 = $n($n(dsl).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$28.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      var x$3$1 = $as_Lscalacss_internal_Media$Query(x$3$2$1);
      return $n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$3$1)
    }))));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().gridAutoColumns__Lscalacss_internal_Attr();
    var $$x23 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1fr")));
    $n(dsl);
    var this$40 = $m_Lscalacss_internal_Attrs$maxWidth$();
    $n(dsl);
    $n(dsl);
    var this$$1 = 100;
    var f$3 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$1);
    $n(dsl);
    $n(dsl);
    var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4$1 = $as_Lscalacss_internal_Percentage(x$4$2);
      return $n(x$4$1).value__T()
    })));
    $n(dsl);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$1)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
    var r$1 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var v$3 = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$3);
    var v$4 = $n(v$3).Lscalacss_internal_ValueT__f_value;
    var array$1 = [$$x23, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$40.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$4)))];
    var x$5 = $n($$x24).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x22 = new $c_Lscalacss_internal_DslBase$ToStyle(x$5);
    $n(dsl);
    $n(dsl);
    var this$47 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var $$x21 = $n($n(dsl).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$47.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$4$2$1) => {
      var x$4$3 = $as_Lscalacss_internal_Media$Query(x$4$2$1);
      return $n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$4$3)
    }))));
    $n(dsl);
    $n(dsl);
    var a$1 = $m_Lscalacss_internal_Attrs$().gridAutoRows__Lscalacss_internal_Attr();
    var $$x20 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, "2cm")));
    $n(dsl);
    $n(dsl);
    var a$2 = $m_Lscalacss_internal_Attrs$().gridAutoColumns__Lscalacss_internal_Attr();
    var array$2 = [$$x20, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2, "1.76cm")))];
    var x$6 = $n($$x21).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x19 = new $c_Lscalacss_internal_DslBase$ToStyle(x$6);
    var $$x18 = $m_Lscalacss_internal_DslBase$DslAttrT$();
    $n(dsl);
    $n(dsl);
    var a$3 = $m_Lscalacss_internal_Attrs$fontFamily$();
    var $$x17 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x18).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$3, "'Gill Sans MT Condensed'")));
    $n(dsl);
    var this$70 = $m_Lscalacss_internal_Attrs$fontSize$();
    $n(dsl);
    $n(dsl);
    var this$$2 = 11;
    var u$1 = $m_Lscalacss_internal_LengthUnit$pt$();
    var f$5 = new $c_Lscalacss_internal_Length(this$$2, u$1);
    $n(dsl);
    $n(dsl);
    var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$2) => {
      var x$3$3 = $as_Lscalacss_internal_Length(x$3$2$2);
      return $n(x$3$3).value__T()
    })));
    $n(dsl);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
      var x$1$3 = $as_Lscalacss_internal_ValueT(x$1$2$2);
      return $n(x$1$3)
    }));
    var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
    var r$2 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
    var v$5 = $n(r$2).apply__O__Lscalacss_internal_ValueT(f$5);
    var v$6 = $n(v$5).Lscalacss_internal_ValueT__f_value;
    var $$x16 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$70.Lscalacss_internal_Attrs$fontSize$__f_attr, v$6)));
    var $$x15 = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_T(s$2);
      return (s + " BUTTON")
    }));
    $n(dsl);
    var x$7 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_withBackground;
    var array$3 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$7).Lscalacss_internal_StyleA__f_style)];
    var $$x14 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(dsl).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x15, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
    var $$x13 = new $c_sjsr_AnonFunction1(((s$3$2) => {
      var s$3 = $as_T(s$3$2);
      return (((s$3 + " INPUT, ") + s$3) + " SELECT")
    }));
    $n(dsl);
    var this$84 = $m_Lscalacss_internal_Attrs$width$();
    $n(dsl);
    $n(dsl);
    var this$$3 = 100;
    var f$7 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$3);
    $n(dsl);
    $n(dsl);
    var ab$3 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$2) => {
      var x$4$4 = $as_Lscalacss_internal_Percentage(x$4$2$2);
      return $n(x$4$4).value__T()
    })));
    $n(dsl);
    var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
      var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$3);
      return $n(x$1$4)
    }));
    var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
    var r$3 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
    var v$7 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$7);
    var v$8 = $n(v$7).Lscalacss_internal_ValueT__f_value;
    var $$x12 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$84.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$8)));
    $n(dsl);
    var this$86 = $m_Lscalacss_internal_Attrs$boxSizing$();
    var $$x11 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$86.Lscalacss_internal_Attrs$boxSizing$__f_attr, "border-box")));
    $n(dsl);
    var this$88 = $m_Lscalacss_internal_Attrs$fontFamily$();
    var v$9 = $m_Lscalacss_internal_Literal$Typed$inherit$();
    var v$10 = v$9.Lscalacss_internal_Literal__f_value;
    var $$x10 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$88.Lscalacss_internal_Attrs$fontFamily$__f_attr, v$10)));
    $n(dsl);
    var this$91 = $m_Lscalacss_internal_Attrs$fontSize$();
    var v$11 = $m_Lscalacss_internal_Literal$Typed$inherit$();
    var v$12 = v$11.Lscalacss_internal_Literal__f_value;
    var $$x9 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$91.Lscalacss_internal_Attrs$fontSize$__f_attr, v$12)));
    $n(dsl);
    var this$94 = $m_Lscalacss_internal_Attrs$border$();
    var $$x8 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$94.Lscalacss_internal_Attrs$border$__f_attr, "0")));
    $n(dsl);
    var $$x7 = $m_Lscalacss_internal_Attrs$borderBottom$();
    $n(dsl);
    $n(dsl);
    var this$$4 = 1;
    var u$2 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$9 = new $c_Lscalacss_internal_Length(this$$4, u$2);
    $n(dsl);
    $n(dsl);
    var ab$4 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$3) => {
      var x$3$4 = $as_Lscalacss_internal_Length(x$3$2$3);
      return $n(x$3$4).value__T()
    })));
    $n(dsl);
    var f$8 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
      var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$4);
      return $n(x$1$5)
    }));
    var bc$4 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$8);
    var r$4 = $n(ab$4).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$4);
    var $$x6 = $n(r$4).apply__O__Lscalacss_internal_ValueT(f$9);
    $n(dsl);
    $n(dsl);
    var f$11 = $m_Lscalacss_internal_Literal$Typed$dotted$();
    $n(dsl);
    $n(dsl);
    var this$106 = $m_Lscalacss_internal_ValueT$Rule$();
    var ab$5 = this$106.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2$1 = $as_Lscalacss_internal_Literal(x$2$2);
      return $n(x$2$1).Lscalacss_internal_Literal__f_value
    })));
    $n(dsl);
    var f$10 = new $c_sjsr_AnonFunction1(((x$1$2$5) => {
      var x$1$6 = $as_Lscalacss_internal_ValueT(x$1$2$5);
      return $n(x$1$6)
    }));
    var bc$5 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$10);
    var r$5 = $n(ab$5).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$5);
    var $$x5 = $n(r$5).apply__O__Lscalacss_internal_ValueT(f$11);
    $n(dsl);
    $n(dsl);
    var f$13 = new $c_Lscalacss_internal_ValueT("lightgray");
    $n(dsl);
    var f$12 = new $c_sjsr_AnonFunction1(((x$1$2$6) => {
      var x$1$7 = $as_Lscalacss_internal_ValueT(x$1$2$6);
      return $n(x$1$7)
    }));
    var r$6 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$12);
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x7.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x6, $$x5, r$6.apply__O__Lscalacss_internal_ValueT(f$13))));
    $n(dsl);
    var this$117 = $m_Lscalacss_internal_Attrs$backgroundColor$();
    var v$13 = $m_Lscalacss_internal_Literal$Typed$inherit$();
    var v$14 = v$13.Lscalacss_internal_Literal__f_value;
    var $$x3 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$117.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$14)));
    $n(dsl);
    var x$8 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_withBackground;
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$8).Lscalacss_internal_StyleA__f_style);
    $n(dsl);
    var this$121 = $m_Lscalacss_internal_Attrs$color$();
    var v$15 = $m_Lscalacss_internal_Literal$Typed$inherit$();
    var v$16 = v$15.Lscalacss_internal_Literal__f_value;
    var array$4 = [$$x12, $$x11, $$x10, $$x9, $$x8, $$x4, $$x3, $$x2, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$121.Lscalacss_internal_Attrs$color$__f_attr, v$16)))];
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(dsl).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x13, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
    $n(dsl);
    var this$136 = $m_Lscalacss_internal_Attrs$margin$();
    $n(dsl);
    $n(dsl);
    var this$$5 = 1;
    var u$3 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$15 = new $c_Lscalacss_internal_Length(this$$5, u$3);
    $n(dsl);
    $n(dsl);
    var ab$6 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$4) => {
      var x$3$5 = $as_Lscalacss_internal_Length(x$3$2$4);
      return $n(x$3$5).value__T()
    })));
    $n(dsl);
    var f$14 = new $c_sjsr_AnonFunction1(((x$1$2$7) => {
      var x$1$8 = $as_Lscalacss_internal_ValueT(x$1$2$7);
      return $n(x$1$8)
    }));
    var bc$6 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$14);
    var r$7 = $n(ab$6).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$6);
    var all = $n(r$7).apply__O__Lscalacss_internal_ValueT(f$15);
    var v$17 = $n(all).Lscalacss_internal_ValueT__f_value;
    var array$5 = [$$x28, $$x27, $$x25, $$x22, $$x19, $$x17, $$x16, $$x14, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$136.Lscalacss_internal_Attrs$margin$__f_attr, v$17)))];
    return $as_sci_Seq($n($$x29).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
  })), new $c_Lsourcecode_Name("electricalBoardTableLayout"));
  var this$142 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$18 = "div";
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperTableLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$142, v$18)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x38 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var this$144 = $m_Lscalacss_internal_Attrs$borderCollapse$();
    var $$x37 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$144.Lscalacss_internal_Attrs$borderCollapse$__f_attr, "collapse")));
    $n(dsl$3);
    var this$146 = $m_Lscalacss_internal_Attrs$display$();
    var $$x36 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$146.Lscalacss_internal_Attrs$display$__f_attr, "inline-grid")));
    var $$x35 = $m_Lscalacss_internal_DslBase$DslAttrT$();
    $n(dsl$3);
    $n(dsl$3);
    var a$4 = $m_Lscalacss_internal_Attrs$fontFamily$();
    var $$x34 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x35).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$4, "'Gill Sans MT Condensed'")));
    $n(dsl$3);
    var this$158 = $m_Lscalacss_internal_Attrs$fontSize$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$6 = 11;
    var u$4 = $m_Lscalacss_internal_LengthUnit$pt$();
    var f$17 = new $c_Lscalacss_internal_Length(this$$6, u$4);
    $n(dsl$3);
    $n(dsl$3);
    var ab$7 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$5) => {
      var x$3$6 = $as_Lscalacss_internal_Length(x$3$2$5);
      return $n(x$3$6).value__T()
    })));
    $n(dsl$3);
    var f$16 = new $c_sjsr_AnonFunction1(((x$1$2$8) => {
      var x$1$9 = $as_Lscalacss_internal_ValueT(x$1$2$8);
      return $n(x$1$9)
    }));
    var bc$7 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$16);
    var r$8 = $n(ab$7).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$7);
    var v$19 = $n(r$8).apply__O__Lscalacss_internal_ValueT(f$17);
    var v$20 = $n(v$19).Lscalacss_internal_ValueT__f_value;
    var $$x33 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$158.Lscalacss_internal_Attrs$fontSize$__f_attr, v$20)));
    $n(dsl$3);
    $n(dsl$3);
    var a$5 = $m_Lscalacss_internal_Attrs$().gridAutoRows__Lscalacss_internal_Attr();
    var $$x32 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$5, "2cm")));
    $n(dsl$3);
    $n(dsl$3);
    var a$6 = $m_Lscalacss_internal_Attrs$().gridAutoColumns__Lscalacss_internal_Attr();
    var $$x31 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$6, "1.77cm")));
    $n(dsl$3);
    var this$166 = $m_Lscalacss_internal_Attrs$alignItems$();
    var $$x30 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$166.Lscalacss_internal_Attrs$alignItems$__f_attr, "stretch")));
    $n(dsl$3);
    var this$176 = $m_Lscalacss_internal_Attrs$margin$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$7 = 1;
    var u$5 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$19 = new $c_Lscalacss_internal_Length(this$$7, u$5);
    $n(dsl$3);
    $n(dsl$3);
    var ab$8 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$6) => {
      var x$3$7 = $as_Lscalacss_internal_Length(x$3$2$6);
      return $n(x$3$7).value__T()
    })));
    $n(dsl$3);
    var f$18 = new $c_sjsr_AnonFunction1(((x$1$2$9) => {
      var x$1$10 = $as_Lscalacss_internal_ValueT(x$1$2$9);
      return $n(x$1$10)
    }));
    var bc$8 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$18);
    var r$9 = $n(ab$8).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$8);
    var all$1 = $n(r$9).apply__O__Lscalacss_internal_ValueT(f$19);
    var v$21 = $n(all$1).Lscalacss_internal_ValueT__f_value;
    var array$6 = [$$x37, $$x36, $$x34, $$x33, $$x32, $$x31, $$x30, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$176.Lscalacss_internal_Attrs$margin$__f_attr, v$21)))];
    return $as_sci_Seq($n($$x38).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6)))
  })), new $c_Lsourcecode_Name("electricalBoardHelperTableLayout"));
  var this$182 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$22 = "div";
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardAddRow = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$182, v$22)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$4$2) => {
    var dsl$4 = $as_Lscalacss_internal_DslBase(dsl$4$2);
    var $$x40 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$4);
    $n(dsl$4);
    var this$184 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var $$x39 = $n($n(dsl$4).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$184.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$2$3) => {
      var x$9 = $as_Lscalacss_internal_Media$Query(x$2$3);
      return $n(dsl$4).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$9)
    }))));
    $n(dsl$4);
    var this$186 = $m_Lscalacss_internal_Attrs$display$();
    var v$23 = $m_Lscalacss_internal_Literal$Typed$none$();
    var v$24 = v$23.Lscalacss_internal_Literal__f_value;
    var array$7 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$4).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$186.Lscalacss_internal_Attrs$display$__f_attr, v$24)))];
    var x$10 = $n($$x39).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$8 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$10)];
    return $as_sci_Seq($n($$x40).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8)))
  })), new $c_Lsourcecode_Name("electricalBoardAddRow"));
  var this$197 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$25 = "span";
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperWire = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$197, v$25)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$5$2) => {
    var dsl$5 = $as_Lscalacss_internal_DslBase(dsl$5$2);
    var $$x41 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$5);
    var this$207 = $m_Lscalacss_internal_Attrs$fontSize$();
    $n(dsl$5);
    $n(dsl$5);
    var this$$8 = 2;
    var u$6 = $m_Lscalacss_internal_LengthUnit$rem$();
    var f$21 = new $c_Lscalacss_internal_Length(this$$8, u$6);
    $n(dsl$5);
    $n(dsl$5);
    var ab$9 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$7) => {
      var x$3$8 = $as_Lscalacss_internal_Length(x$3$2$7);
      return $n(x$3$8).value__T()
    })));
    $n(dsl$5);
    var f$20 = new $c_sjsr_AnonFunction1(((x$1$2$10) => {
      var x$1$11 = $as_Lscalacss_internal_ValueT(x$1$2$10);
      return $n(x$1$11)
    }));
    var bc$9 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$20);
    var r$10 = $n(ab$9).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$9);
    var v$26 = $n(r$10).apply__O__Lscalacss_internal_ValueT(f$21);
    var v$27 = $n(v$26).Lscalacss_internal_ValueT__f_value;
    var array$9 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$207.Lscalacss_internal_Attrs$fontSize$__f_attr, v$27)))];
    return $as_sci_Seq($n($$x41).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9)))
  })), new $c_Lsourcecode_Name("electricalBoardHelperWire"));
  var this$213 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$28 = "div";
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperCell = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$213, v$28)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$6$2) => {
    var dsl$6 = $as_Lscalacss_internal_DslBase(dsl$6$2);
    var $$x43 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$6);
    var this$215 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$29 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$30 = v$29.Lscalacss_internal_Literal__f_value;
    var $$x42 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$215.Lscalacss_internal_Attrs$overflow$__f_attr, v$30)));
    $n(dsl$6);
    $n(dsl$6);
    var a$7 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
    var array$10 = [$$x42, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$7, "0px 0px 1px gray")))];
    return $as_sci_Seq($n($$x43).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10)))
  })), new $c_Lsourcecode_Name("electricalBoardHelperCell"));
  var this$224 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$31 = "div";
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperCellLabel = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$224, v$31)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$7$2) => {
    var dsl$7 = $as_Lscalacss_internal_DslBase(dsl$7$2);
    var $$x44 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$7);
    var this$226 = $m_Lscalacss_internal_Attrs$textAlign$();
    var array$11 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$7).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$226.Lscalacss_internal_Attrs$textAlign$__f_attr, "center")))];
    return $as_sci_Seq($n($$x44).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11)))
  })), new $c_Lsourcecode_Name("electricalBoardHelperCellLabel"));
  this.Lreactbuild_project_generator_electricalboard_components_Table$__f_component = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Table", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2$4) => {
    var x$11 = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2$4);
    return new $c_Lreactbuild_project_generator_electricalboard_components_Table$Backend(x$11)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2$8) => {
    var x$3$9 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2$8);
    var $$x45 = $n($as_Lreactbuild_project_generator_electricalboard_components_Table$Backend($n(x$3$9).backend__O()));
    var this$233 = $n(x$3$9);
    return $n($$x45).render__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement($as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n(this$233.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lreactbuild_project_generator_electricalboard_components_Table$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Table$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Table$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Table$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Table$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Table$.prototype;
var $d_Lreactbuild_project_generator_electricalboard_components_Table$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Table$: 0
}, false, "reactbuild.project.generator.electricalboard.components.Table$", {
  Lreactbuild_project_generator_electricalboard_components_Table$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Table$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Table$;
var $n_Lreactbuild_project_generator_electricalboard_components_Table$;
function $m_Lreactbuild_project_generator_electricalboard_components_Table$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_Table$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_Table$ = new $c_Lreactbuild_project_generator_electricalboard_components_Table$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_Table$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Table$Backend(\u03b4) {
  this.Lreactbuild_project_generator_electricalboard_components_Table$Backend__f_reactbuild$project$generator$electricalboard$components$Table$Backend$$$ = null;
  this.Lreactbuild_project_generator_electricalboard_components_Table$Backend__f_moveCell = null;
  this.Lreactbuild_project_generator_electricalboard_components_Table$Backend__f_reactbuild$project$generator$electricalboard$components$Table$Backend$$$ = \u03b4;
  this.Lreactbuild_project_generator_electricalboard_components_Table$Backend__f_moveCell = new $c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1(this)
}
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Table$Backend;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Table$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Table$Backend.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Table$Backend.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend.prototype.render__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement = (function(props) {
  var this$85 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x25 = $n($m_Lreactbuild_project_generator_electricalboard_components_Table$().Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardTableLayout);
  var $$x24 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $as_sc_IterableOnce($n($n($as_Lreactbuild_project_generator_electricalboard_model_Table($n(props).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Table__f_lines).zipWithIndex__O());
  var $$x23 = $n($$x24).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var line = $as_Lreactbuild_project_generator_electricalboard_model_Line($n(x0$1)._1__O());
      var idx = $n(x0$1)._2$mcI$sp__I();
      var u = $m_Lreactbuild_project_generator_electricalboard_components_Line$().withKey__T__Ljapgolly_scalajs_react_extra_StateSnapshotF__F2__I__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n($n(line).Lreactbuild_project_generator_electricalboard_model_Line__f_id).toString__T(), $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), line), new $c_sjsr_AnonFunction2(((ov$2, cb$2) => {
        var ov = $as_s_Option(ov$2);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$5 = $n(props);
        var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
        var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
        var arg1 = this$5.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
        var t = $as_Lreactbuild_project_generator_electricalboard_model_Table(arg1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$5.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some($n(t).update__Lreactbuild_project_generator_electricalboard_model_Line__Lreactbuild_project_generator_electricalboard_model_Table($as_Lreactbuild_project_generator_electricalboard_model_Line($n(ov).get__O()))), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      }))), this.Lreactbuild_project_generator_electricalboard_components_Table$Backend__f_moveCell, idx);
      var this$7 = $n(u);
      var n = this$7.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })));
  var $$x22 = $m_Lreactbuild_project_generator_electricalboard_components_Table$().Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardAddRow;
  var $$x21 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "gridRow")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + ((1 + $n($n($as_Lreactbuild_project_generator_electricalboard_model_Table($n(props).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Table__f_lines).length__I()) | 0)), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x20 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "gridColumn")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 / span 13", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("add", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Nouvelle ligne")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => {
    var this$17 = $n(props);
    var callback$1 = new $c_sjsr_AnonFunction0((() => {
      var this$18 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$19 = $n(this$18.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$19.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$20 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G$1 = this$20.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1$1 = this$17.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var t$1 = $as_Lreactbuild_project_generator_electricalboard_model_Table(arg1$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$17.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some($n(t$1).addNew__Lreactbuild_project_generator_electricalboard_model_Table()), callback$1, G$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var array$1 = [$$x21, $$x20, $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var array$2 = [$$x23, $n($$x22).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var $$x18 = $n($$x25).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x17 = $m_Lreactbuild_project_generator_electricalboard_components_Table$().Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperTableLayout;
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as$1 = $as_sc_IterableOnce($n($n($as_Lreactbuild_project_generator_electricalboard_model_Table($n(props).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Table__f_lines).zipWithIndex__O());
  var array$9 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_T2(x0$2$2);
    if ((x0$2 !== null)) {
      var line$1 = $as_Lreactbuild_project_generator_electricalboard_model_Line($n(x0$2)._1__O());
      var rowIdx = $n(x0$2)._2$mcI$sp__I();
      var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as$2 = $as_sc_IterableOnce($n($as_sc_IterableOps($n($n(line$1).Lreactbuild_project_generator_electricalboard_model_Line__f_cells).filter__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$1$2);
        var this$31 = $n($n(x$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets);
        var these = this$31;
        while ((!$n(these).isEmpty__Z())) {
          var arg1$2 = $n(these).head__O();
          var x$2 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(arg1$2);
          $m_sc_StringOps$();
          var x = $n(x$2).Lreactbuild_project_generator_electricalboard_model_LineSource__f_label;
          var this$34 = $n(x);
          if ((!(this$34 === ""))) {
            return true
          };
          these = $as_sci_List($n(these).tail__O())
        };
        return false
      }))))).zipWithIndex__O());
      return $n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$2, new $c_sjsr_AnonFunction1(((x0$3$2) => {
        var x0$3 = $as_T2(x0$3$2);
        if ((x0$3 !== null)) {
          var cell = $as_Lreactbuild_project_generator_electricalboard_model_Cell($n(x0$3)._1__O());
          var $$x16 = $n($m_Lreactbuild_project_generator_electricalboard_components_Table$().Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperCell);
          var $$x15 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "gridColumnEnd")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("span " + $n(cell).Lreactbuild_project_generator_electricalboard_model_Cell__f_span), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          var $$x14 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "gridRow")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + ((1 + rowIdx) | 0)), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          var $$x13 = $n($m_Lreactbuild_project_generator_electricalboard_components_Table$().Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperCellLabel);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var this$40 = $n($n(cell).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets);
          var f = ((x$3$2) => {
            var x$3 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(x$3$2);
            return $n(x$3).Lreactbuild_project_generator_electricalboard_model_LineSource__f_label
          });
          if ((this$40 === $m_sci_Nil$())) {
            var $$x12 = $m_sci_Nil$()
          } else {
            var arg1$3 = this$40.head__O();
            var h = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
            var t$2 = h;
            var rest = $as_sci_List(this$40.tail__O());
            while ((rest !== $m_sci_Nil$())) {
              var arg1$4 = $n(rest).head__O();
              var nx = new $c_sci_$colon$colon(f(arg1$4), $m_sci_Nil$());
              $n(t$2).sci_$colon$colon__f_next = nx;
              t$2 = nx;
              rest = $as_sci_List($n(rest).tail__O())
            };
            var $$x12 = h
          };
          var this$41 = $n($$x12);
          var v = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$41, "", ", ", "");
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
          var $$x11 = $n($$x13).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
          var $$x10 = $n($m_Lreactbuild_project_generator_electricalboard_components_Table$().Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperCellLabel);
          var this$51 = $n($n(cell).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets);
          var f$1 = ((x$4$2) => {
            var x$4 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(x$4$2);
            var this$47 = $n($n(x$4).Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter);
            if (this$47.isEmpty__Z()) {
              return $m_s_None$()
            } else {
              var arg1$5 = this$47.get__O();
              var v$1 = $uD(arg1$5);
              var $$x8 = $m_sc_StringOps$();
              var array$4 = [v$1];
              return new $c_s_Some($n($$x8).format$extension__T__sci_Seq__T("%.1f\u00b2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)))
            }
          });
          if ((this$51 === $m_sci_Nil$())) {
            var diameters = $m_sci_Nil$()
          } else {
            var arg1$6 = this$51.head__O();
            var h$1 = new $c_sci_$colon$colon(f$1(arg1$6), $m_sci_Nil$());
            var t$3 = h$1;
            var rest$1 = $as_sci_List(this$51.tail__O());
            while ((rest$1 !== $m_sci_Nil$())) {
              var arg1$7 = $n(rest$1).head__O();
              var nx$1 = new $c_sci_$colon$colon(f$1(arg1$7), $m_sci_Nil$());
              $n(t$3).sci_$colon$colon__f_next = nx$1;
              t$3 = nx$1;
              rest$1 = $as_sci_List($n(rest$1).tail__O())
            };
            var diameters = h$1
          };
          var this$52 = $n(diameters);
          var distincts = $as_sci_List($f_sc_SeqOps__distinct__O(this$52));
          matchEnd8: {
            var $$x9;
            if ((distincts instanceof $c_sci_$colon$colon)) {
              var x2 = $as_sci_$colon$colon(distincts);
              var p3 = $as_s_Option($n(x2).sci_$colon$colon__f_head);
              var p4 = $n(x2).sci_$colon$colon__f_next;
              if ((p3 instanceof $c_s_Some)) {
                var x5 = $as_s_Some(p3);
                var head = $as_T($n(x5).s_Some__f_value);
                var x$5 = $m_s_package$().s_package$__f_Nil;
                if (((x$5 === null) ? (p4 === null) : $n(x$5).equals__O__Z(p4))) {
                  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
                  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
                  var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(head);
                  break matchEnd8
                }
              }
            };
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            var this$56 = $n(diameters);
            var f$2 = ((x$5$2) => {
              var x$5$1 = $as_s_Option(x$5$2);
              var this$55 = $n(x$5$1);
              return $as_T((this$55.isEmpty__Z() ? "?" : this$55.get__O()))
            });
            if ((this$56 === $m_sci_Nil$())) {
              var as$3 = $m_sci_Nil$()
            } else {
              var arg1$8 = this$56.head__O();
              var h$2 = new $c_sci_$colon$colon(f$2(arg1$8), $m_sci_Nil$());
              var t$4 = h$2;
              var rest$2 = $as_sci_List(this$56.tail__O());
              while ((rest$2 !== $m_sci_Nil$())) {
                var arg1$9 = $n(rest$2).head__O();
                var nx$2 = new $c_sci_$colon$colon(f$2(arg1$9), $m_sci_Nil$());
                $n(t$4).sci_$colon$colon__f_next = nx$2;
                t$4 = nx$2;
                rest$2 = $as_sci_List($n(rest$2).tail__O())
              };
              var as$3 = h$2
            };
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            var sep = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("\u2022");
            var f$3 = new $c_sjsr_AnonFunction1(((v$2) => {
              var v$3 = $as_T(v$2);
              $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
              $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
              return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
            }));
            var $$x9 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$3, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$3)
          };
          var array$5 = [$$x9];
          var $$x7 = $n($$x10).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
          var $$x6 = $m_Lreactbuild_project_generator_electricalboard_components_Table$().Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperCellLabel;
          var $$x3 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var as$4 = $n(cell).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
          var array$7 = [$n($$x3).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$4, new $c_sjsr_AnonFunction1(((target$2) => {
            var target = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(target$2);
            var $$x4 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            var as$5 = $n(target).Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors;
            return $n($$x4).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$5, new $c_sjsr_AnonFunction1(((wireColor$2) => {
              var wireColor = $as_Lreactbuild_project_generator_electricalboard_model_WireColor(wireColor$2);
              var $$x5 = $n($m_Lreactbuild_project_generator_electricalboard_components_Table$().Lreactbuild_project_generator_electricalboard_components_Table$__f_electricalBoardHelperWire);
              var array$6 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n($n(wireColor).colors__sci_Seq()).head__O(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("\u2022"))];
              return $n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
            })))
          })))];
          var array$8 = [$$x15, $$x14, $$x11, $$x7, $n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
          return $n($$x16).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
        } else {
          throw new $c_s_MatchError(x0$3)
        }
      })))
    } else {
      throw new $c_s_MatchError(x0$2)
    }
  })))];
  var array$10 = [$$x18, $n($$x17).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$85, null, ns)
});
function $as_Lreactbuild_project_generator_electricalboard_components_Table$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_components_Table$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.components.Table$Backend"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_components_Table$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_components_Table$Backend)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_components_Table$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_components_Table$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.components.Table$Backend;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_components_Table$Backend = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Table$Backend: 0
}, false, "reactbuild.project.generator.electricalboard.components.Table$Backend", {
  Lreactbuild_project_generator_electricalboard_components_Table$Backend: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Table$Backend;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_WireColors$() {
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColors = null;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColorsKey = null;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColorsListLayout = null;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColor = null;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_component = null;
  $n_Lreactbuild_project_generator_electricalboard_components_WireColors$ = this;
  var this$4 = $m_sci_ListSet$();
  var array = [$m_Lreactbuild_project_generator_electricalboard_model_WireColor$White$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$5 = $n(this$4.from__sc_IterableOnce__sci_ListSet(elems));
  $m_sci_List$();
  var this$9 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$5));
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_project_generator_electricalboard_model_WireColor(v$2);
    return new $c_T2$mcII$sp($n(v).mainOrder__I(), $n(v).order__I())
  }));
  var ord1 = $m_s_math_Ordering$Int$();
  var ord2 = $m_s_math_Ordering$Int$();
  var ord = new $c_s_math_Ordering$Tuple2Ordering(ord1, ord2);
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColors = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$9, f, ord));
  var this$13 = $n($n(this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColors).map__F1__sci_List(new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor(v$3$2);
    var self = $n(v$3).keycode__I();
    return $ct_T2__O__O__(new $c_T2(), self, v$3)
  }))));
  var this$12 = $m_s_$less$colon$less$();
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColorsKey = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$13);
  var this$16 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$1 = "div";
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColorsListLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$16, v$1)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x9 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$18 = $m_Lscalacss_internal_Attrs$display$();
    var $$x8 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$18.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$gap$();
    var $$x7 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a.Lscalacss_internal_Attrs$gap$__f_attr, ".25em")));
    $n(dsl);
    var this$24 = $m_Lscalacss_internal_Attrs$flexWrap$();
    var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$24.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
    $n(dsl);
    var this$26 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$26.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")));
    var this$37 = $n(dsl);
    $n(dsl);
    $m_Lscalacss_internal_Attrs$borderRadius$();
    $n(dsl);
    $n(dsl);
    var this$ = 0.25;
    var u = $m_Lscalacss_internal_LengthUnit$em$();
    var f$2 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl);
    var f$1 = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$1);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var radius = $n(r).apply__O__Lscalacss_internal_ValueT(f$2);
    var v$4 = $n(radius).Lscalacss_internal_ValueT__f_value;
    var x = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$4);
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle(this$37.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x.av__Lscalacss_internal_AV()));
    $n(dsl);
    var this$39 = $m_Lscalacss_internal_Attrs$justifyContent$();
    var $$x3 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$39.Lscalacss_internal_Attrs$justifyContent$__f_attr, "space-evenly")));
    $n(dsl);
    var this$40 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
    var p = $m_Lscalacss_internal_Pseudo$Focus$();
    var $$x2 = this$40.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p);
    var this$42 = $m_s_$less$colon$less$();
    var $$x1 = $n($n(dsl).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x2, this$42.s_$less$colon$less$__f_singleton));
    $n(dsl);
    $n(dsl);
    var a$1 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
    var array$1 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, "0em 0em 0.25em orange")))];
    var x$2 = $n($$x1).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$2 = [$$x8, $$x7, $$x6, $$x5, $$x4, $$x3, new $c_Lscalacss_internal_DslBase$ToStyle(x$2)];
    return $as_sci_Seq($n($$x9).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)))
  })), new $c_Lsourcecode_Name("wireColorsListLayout"));
  var this$56 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$5 = "div";
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColor = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$56, v$5)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x10 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var this$65 = $m_Lscalacss_internal_Attrs$fontSize$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$1 = 200;
    var f$4 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$1);
    $n(dsl$3);
    $n(dsl$3);
    var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lscalacss_internal_Percentage(x$4$2);
      return $n(x$4).value__T()
    })));
    $n(dsl$3);
    var f$3 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$1)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$3);
    var r$1 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var v$6 = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$4);
    var v$7 = $n(v$6).Lscalacss_internal_ValueT__f_value;
    var array$3 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$65.Lscalacss_internal_Attrs$fontSize$__f_attr, v$7)))];
    return $as_sci_Seq($n($$x10).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)))
  })), new $c_Lsourcecode_Name("wireColor"));
  var this$138 = $m_Lcom_iz2use_react_hooks_package$();
  var this$72 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var evidence$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lorg_scalajs_dom_HTMLDivElement.getClassOf());
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$83 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefToVdom__s_reflect_ClassTag__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$72, evidence$1, step)));
  var deps = new $c_sjsr_AnonFunction2(((p$2, x$1$2$2) => {
    var p$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(p$2);
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$1$2$2);
    return p$1
  }));
  var callback = new $c_sjsr_AnonFunction2(((p$3$2, ref$2) => {
    var p$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(p$3$2);
    var ref = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$2$2);
      return new $c_sjsr_AnonFunction1(((color$2) => {
        var color = $as_Lreactbuild_project_generator_electricalboard_model_WireColor(color$2);
        var $$x12 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var this$75 = $n(p$3);
        var mod = new $c_sjsr_AnonFunction1(((prev$2) => {
          var prev = $as_sci_Set(prev$2);
          if ($n(prev).contains__O__Z(color)) {
            var this$73 = $n(prev);
            return $as_sci_Set(this$73.excl__O__sci_SetOps(color))
          } else {
            var this$74 = $n(prev);
            return $as_sci_Set(this$74.incl__O__sci_SetOps(color))
          }
        }));
        var $$x11 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$75, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$79 = $n(ref);
        var f$7 = new $c_sjsr_AnonFunction1(((e$2) => {
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f$5 = new $c_sjsr_AnonFunction0((() => {
            e$2.focus()
          }));
          var f$6 = new $c_sjsr_AnonFunction0((() => {
            f$5.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$6))
        }));
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x12).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x11, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_Ref$GetF__foreachCB__F1__O(this$79, f$7))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
      }))
    }))
  }));
  var this$81 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var a$2 = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$81, Z);
  var r$2 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$82 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$82);
  var this$85 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackWithDepsBy__O__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$83, deps, callback, a$2, r$2, step$1)));
  var reducer = $m_Lreactbuild_project_generator_electricalboard_components_WireColors$State$().reducer__F2();
  var initialState = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State(($m_Lreactbuild_project_generator_electricalboard_components_WireColors$State$(), false), ($m_Lreactbuild_project_generator_electricalboard_components_WireColors$State$(), false), ($m_Lreactbuild_project_generator_electricalboard_components_WireColors$State$(), 0))));
  var this$84 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$84);
  var this$101 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducer__F2__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$85, reducer, initialState, step$2)));
  var deps$1 = new $c_sjsr_AnonFunction4(((x$3$2$1, x$4$2$1, toggleColor$2, x$5$2) => {
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$3$2$1);
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$4$2$1);
    var toggleColor = $as_Ljapgolly_scalajs_react_Reusable(toggleColor$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$5$2);
    return toggleColor
  }));
  var callback$1 = new $c_sjsr_AnonFunction4(((x$6$2, x$7$2, toggleColor$3$2, focus$2) => {
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$6$2);
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$7$2);
    var toggleColor$3 = $as_Ljapgolly_scalajs_react_Reusable(toggleColor$3$2);
    var focus = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(focus$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      $as_Ljapgolly_scalajs_react_Reusable(x$8$2);
      return new $c_sjsr_AnonFunction1(((ev$2) => {
        $m_Ljapgolly_scalajs_react_package$();
        $m_Ljapgolly_scalajs_react_package$();
        var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
        var x$6$1 = new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1(focus);
        var handleMove = qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(ev$2, $uI(ev$2.keyCode), false, false, false, false, x$6$1);
        $m_Ljapgolly_scalajs_react_package$();
        $m_Ljapgolly_scalajs_react_package$();
        var qual$2 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
        var this$89 = $n($m_Lreactbuild_project_generator_electricalboard_components_WireColors$().Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColorsKey);
        var eta$0$1 = $as_F1(($m_Ljapgolly_scalajs_react_Reusable$(), $n(toggleColor$3).value__O()));
        var k = new $c_sjsr_AnonFunction1(((v1$2) => {
          var v1 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor(v1$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(eta$0$1).apply__O__O(v1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        }));
        var x$12 = $f_s_PartialFunction__andThen__F1__s_PartialFunction(this$89, k);
        var handleColor = qual$2.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(ev$2, $uI(ev$2.keyCode), false, false, false, false, x$12);
        var $$x17 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x14 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x13 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().orElse$extension__F0__F0__F0(handleMove, handleColor);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_package$();
        var this$91 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var c = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$91.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var co = $n($$x14).$greater$greater$extension__F0__F0__F0($$x13, $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c));
        var $$x16 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$94 = $m_s_$less$colon$less$();
        var $$x15 = $n($$x16).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$94.s_$less$colon$less$__f_singleton);
        var array$4 = [$uI(ev$2.keyCode), $dp_toString__T($n(ev$2))];
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x17).logAround$extension__Ljapgolly_scalajs_react_callback_Trampoline__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline($$x15, "keydown", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)))
      }))
    }))
  }));
  var this$99 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var a$3 = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$99, Z$1);
  var r$3 = $m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2();
  var this$100 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$100);
  var this$137 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackWithDepsBy__O__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$101, deps$1, callback$1, a$3, r$3, step$3)));
  var f$8 = new $c_sjsr_AnonFunction5(((p$4$2, ref$3$2, toggleColor$4$2, focus$3$2, handleKey$2) => {
    var p$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(p$4$2);
    var ref$3 = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$3$2);
    var toggleColor$4 = $as_Ljapgolly_scalajs_react_Reusable(toggleColor$4$2);
    var focus$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(focus$3$2);
    var handleKey = $as_Ljapgolly_scalajs_react_Reusable(handleKey$2);
    var active = $as_sci_Set($n(p$4).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var $$x32 = $n($n($m_Lreactbuild_project_generator_electricalboard_components_WireColors$().Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColorsListLayout).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(ref$3)));
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$105 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$105.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0);
    var $$x23 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onFocus")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => $n(focus$3).dispatch__O__Ljapgolly_scalajs_react_Reusable($m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().reusableDefaultSync__F1());
    var $$x22 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onBlur")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => $n(focus$3).dispatch__O__Ljapgolly_scalajs_react_Reusable($m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().reusableDefaultSync__F1());
    var $$x21 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseOver")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => $n(focus$3).dispatch__O__Ljapgolly_scalajs_react_Reusable($m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().reusableDefaultSync__F1());
    var $$x20 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseLeave")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => $n(focus$3).dispatch__O__Ljapgolly_scalajs_react_Reusable($m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().reusableDefaultSync__F1());
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onKeyDownCapture");
    var $$x19 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod($as_F1($n(handleKey).value__O()), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    var $$x18 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $m_Lreactbuild_project_generator_electricalboard_components_WireColors$().Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColors;
    var array$7 = [$$x24, $$x23, $$x22, $$x21, $$x20, $$x19, $n($$x18).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((color$2$1) => {
      var color$1 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor(color$2$1);
      var $$x31 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1(($m_Ljapgolly_scalajs_react_Reusable$(), $n(toggleColor$4).value__O()))).apply__O__O(color$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$120 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
      var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
      var $$x30 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$120.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, (-1));
      var $$x29 = $m_Lreactbuild_project_generator_electricalboard_components_WireColors$().Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColor;
      var $$x28 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n($n(color$1).colors__sci_Seq()).head__O(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x27 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("\u2022");
      var $$x26 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle("textShadow")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(active).contains__O__Z(color$1) ? "0 0 .25em #00FF00, 0 0 .25em #00FF00, 0 0 .25em #00FF00" : "0 0 .5em #888"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x25 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod;
      var this$124 = $n(focus$3);
      var array$5 = [$$x28, $$x27, $$x26, $n($$x25).when__Z__F0__Ljapgolly_scalajs_react_vdom_TagMod(((!$n($as_Lreactbuild_project_generator_electricalboard_components_WireColors$State(this$124.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_active) && (!$n(active).contains__O__Z(color$1))), new $c_sjsr_AnonFunction0((() => ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "opacity")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".5", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString))))];
      var array$6 = [$$x30, $n($$x29).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
      return $n($$x31).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
    })))];
    return $n($$x32).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
  }));
  var this$136 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$136);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$137, f$8, step$4, s);
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$138, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.generator.electricalboard.components.WireColors.component"))
}
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_WireColors$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_WireColors$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$.prototype.apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(state) {
  var c = this.Lreactbuild_project_generator_electricalboard_components_WireColors$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(state, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_generator_electricalboard_components_WireColors$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_WireColors$: 0
}, false, "reactbuild.project.generator.electricalboard.components.WireColors$", {
  Lreactbuild_project_generator_electricalboard_components_WireColors$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_WireColors$;
var $n_Lreactbuild_project_generator_electricalboard_components_WireColors$;
function $m_Lreactbuild_project_generator_electricalboard_components_WireColors$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_WireColors$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_WireColors$ = new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_WireColors$
}
function $is_Lreactbuild_project_generator_electricalboard_components_WireColors$Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_generator_electricalboard_components_WireColors$Action)))
}
function $as_Lreactbuild_project_generator_electricalboard_components_WireColors$Action(obj) {
  return (($is_Lreactbuild_project_generator_electricalboard_components_WireColors$Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.components.WireColors$Action"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_components_WireColors$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_components_WireColors$Action)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_components_WireColors$Action(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_components_WireColors$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.components.WireColors$Action;", depth))
}
function $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__($thiz, label, svg, mainColor) {
  $thiz.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = label;
  $thiz.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = svg;
  $thiz.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = mainColor;
  var this$1 = $n(svg);
  if ((this$1 === "")) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    var this$2 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    var $$x1 = $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T(this$2);
    var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
    var array = [this$3.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    var this$7 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    var $$x3 = $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T(this$7);
    var array$1 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("data:image/svg+xml;base64," + $as_T(window.btoa((("<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\">" + svg) + "</svg>")))), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  };
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Icon.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon.prototype;
function $as_Lreactbuild_project_generator_electricalboard_model_Icon(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_Icon) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.Icon"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_Icon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_Icon)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_Icon(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_Icon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.Icon;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon$__f_list = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon$__f_map = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon$__f_encoder = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon$__f_decoder = null;
  $n_Lreactbuild_project_generator_electricalboard_model_Icon$ = this;
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array = [$m_Lreactbuild_project_generator_electricalboard_model_Icon$heater$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$light$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$power$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$washer$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$oven$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$(), $m_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$()];
  this.Lreactbuild_project_generator_electricalboard_model_Icon$__f_list = $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var $$x2 = $as_sc_IterableOnceOps($n(this.Lreactbuild_project_generator_electricalboard_model_Icon$__f_list).map__F1__O(new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_project_generator_electricalboard_model_Icon(v$2);
    var self = $n(v).toString__T();
    return $ct_T2__O__O__(new $c_T2(), self, v)
  }))));
  var this$7 = $m_s_$less$colon$less$();
  this.Lreactbuild_project_generator_electricalboard_model_Icon$__f_map = $n($$x2).toMap__s_$less$colon$less__sci_Map(this$7.s_$less$colon$less$__f_singleton);
  var this$8 = $n($m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString);
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x = $m_s_None$();
    if ((x === x0$1)) {
      return ""
    } else if ((x0$1 instanceof $c_s_Some)) {
      var x3 = $as_s_Some(x0$1);
      var v$1 = $as_Lreactbuild_project_generator_electricalboard_model_Icon($n(x3).s_Some__f_value);
      return $n(v$1).toString__T()
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  this.Lreactbuild_project_generator_electricalboard_model_Icon$__f_encoder = new $c_Lio_circe_Encoder$$anon$1(this$8, f);
  var this$9 = $n($m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString);
  var f$1 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_T(v$3$2);
    return $n($m_Lreactbuild_project_generator_electricalboard_model_Icon$().Lreactbuild_project_generator_electricalboard_model_Icon$__f_map).get__O__s_Option(v$3)
  }));
  this.Lreactbuild_project_generator_electricalboard_model_Icon$__f_decoder = new $c_Lio_circe_Decoder$$anon$1(this$9, f$1)
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$.prototype;
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$
}
function $is_Lreactbuild_project_generator_electricalboard_model_WireColor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor)))
}
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor(obj) {
  return (($is_Lreactbuild_project_generator_electricalboard_model_WireColor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$() {
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$__f_codecForWireColor = null;
  $n_Lreactbuild_project_generator_electricalboard_model_WireColor$ = this;
  var inst$macro$26 = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$26));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$__f_codecForWireColor = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$.prototype;
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_package$() {
  this.Lreactbuild_project_generator_electricalboard_model_package$__f_config = null;
  $n_Lreactbuild_project_generator_electricalboard_model_package$ = this;
  this.Lreactbuild_project_generator_electricalboard_model_package$__f_config = $n($m_Lio_circe_generic_extras_Configuration$().Lio_circe_generic_extras_Configuration$__f_default).withDefaults__Lio_circe_generic_extras_Configuration()
}
$c_Lreactbuild_project_generator_electricalboard_model_package$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_package$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_package$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_package$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_package$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_package$.prototype;
var $d_Lreactbuild_project_generator_electricalboard_model_package$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_package$: 0
}, false, "reactbuild.project.generator.electricalboard.model.package$", {
  Lreactbuild_project_generator_electricalboard_model_package$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_package$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_package$;
var $n_Lreactbuild_project_generator_electricalboard_model_package$;
function $m_Lreactbuild_project_generator_electricalboard_model_package$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_package$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_package$ = new $c_Lreactbuild_project_generator_electricalboard_model_package$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_package$
}
function $is_Lreactbuild_project_generator_markdown_MarkdownBlock(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_generator_markdown_MarkdownBlock)))
}
function $as_Lreactbuild_project_generator_markdown_MarkdownBlock(obj) {
  return (($is_Lreactbuild_project_generator_markdown_MarkdownBlock(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.markdown.MarkdownBlock"))
}
function $isArrayOf_Lreactbuild_project_generator_markdown_MarkdownBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_markdown_MarkdownBlock)))
}
function $asArrayOf_Lreactbuild_project_generator_markdown_MarkdownBlock(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_markdown_MarkdownBlock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.markdown.MarkdownBlock;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_MarkdownLiterals$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype = new $h_O();
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.constructor = $c_Lreactbuild_project_generator_markdown_MarkdownLiterals$;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_MarkdownLiterals$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype = $c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype;
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.NL__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$14) {
  var startIndex = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$14).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$14).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("NL").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$14).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var startPos = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$14).Lfastparse_ParsingRun__f_cut;
  $n(evidence$14).Lfastparse_ParsingRun__f_cut = false;
  $m_Lfastparse_package$();
  var input = $n(evidence$14).Lfastparse_ParsingRun__f_input;
  var index = $n(evidence$14).Lfastparse_ParsingRun__f_index;
  if ($n(input).isReachable__I__Z(index)) {
    var this$2 = $n(input);
    var this$3 = $n(this$2.Lfastparse_IndexedParserInput__f_data);
    var $$x1 = ($charAt(this$3, index) === 13)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(evidence$14).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
  } else {
    $n(evidence$14).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$14).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"\\r\"")))
  };
  var postSuccess = $n(evidence$14).Lfastparse_ParsingRun__f_isSuccess;
  if (postSuccess) {
    var res$2 = $n(evidence$14).freshSuccess__O__Lfastparse_ParsingRun(($n(evidence$14), (void 0)));
    $n(res$2).Lfastparse_ParsingRun__f_cut = (!(!($n(res$2).Lfastparse_ParsingRun__f_cut | startCut)))
  } else if ($n(evidence$14).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var res$3 = $n(evidence$14).freshSuccess__O__I__Lfastparse_ParsingRun((void 0), startPos);
    $n(res$3).Lfastparse_ParsingRun__f_cut = (!(!($n(res$3).Lfastparse_ParsingRun__f_cut | startCut)))
  };
  if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
    var msg = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
    var agg = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
    if ((!postSuccess)) {
      $n(evidence$14).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startPos, new $c_sjsr_AnonFunction0((() => {
        var this$6 = $n(msg);
        return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".?")
      })), agg)
    }
  };
  if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$8 = evidence$14
  } else {
    var postLhsIndex$macro$3 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$14).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$14);
    if (((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$14).Lfastparse_ParsingRun__f_cut)) {
      var x1$8 = evidence$14
    } else {
      var preRhsIndex$macro$4 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
      var input$2 = $n(evidence$14).Lfastparse_ParsingRun__f_input;
      var index$2 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
      if ($n(input$2).isReachable__I__Z(index$2)) {
        var this$8 = $n(input$2);
        var this$9 = $n(this$8.Lfastparse_IndexedParserInput__f_data);
        var $$x2 = ($charAt(this$9, index$2) === 10)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        $n(evidence$14).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$2) | 0))
      } else {
        $n(evidence$14).freshFailure__Lfastparse_ParsingRun()
      };
      if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$14).aggregateTerminal__I__F0__V(index$2, new $c_sjsr_AnonFunction0((() => "\"\\n\"")))
      };
      var rhsAggregate$macro$7 = $n(evidence$14).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$14).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$14).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$14
      } else {
        var postRhsIndex$macro$5 = $n(evidence$14).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$14).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x3 = $n(evidence$14);
        $n(evidence$14);
        var v = (void 0);
        var res$macro$14 = $n($$x3).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
      };
      if ($n(evidence$14).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$14).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$14).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$8 = res$macro$14
    }
  };
  if (instrument) {
    $n($n(evidence$14).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("NL").Lsourcecode_Name__f_value, $n(x1$8).Lfastparse_ParsingRun__f_index, $n(x1$8).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$8).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x4 = $n(x1$8);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("NL").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$8).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$8).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$8).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x5 = $n(x1$8);
      var self = new $c_Lsourcecode_Name("NL").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$16 = $n($n(x1$8).Lfastparse_ParsingRun__f_failureStack);
      $$x5.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$16)
    }
  };
  return x1$8
});
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.EOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$15) {
  var startIndex = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$15).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$15).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("EOL").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$15).Lfastparse_ParsingRun__f_cut;
  $n(evidence$15).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$15).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  this.NL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$15);
  var lhsMsg = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$15).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$15).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$3 = evidence$15
  } else if ($n(evidence$15).Lfastparse_ParsingRun__f_cut) {
    var x1$3 = evidence$15
  } else {
    var verboseFailures = $n(evidence$15).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$15).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$2 = $n(evidence$15);
      this$2.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$15).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$15);
    var rhsMsg = $n(evidence$15).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$15).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$15).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$15).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$15).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$3 = $n(evidence$15);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$15).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$3.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$3 = evidence$15
  };
  if (instrument) {
    $n($n(evidence$15).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("EOL").Lsourcecode_Name__f_value, $n(x1$3).Lfastparse_ParsingRun__f_index, $n(x1$3).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$3).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(x1$3);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("EOL").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$3).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$3).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(x1$3);
      var self = new $c_Lsourcecode_Name("EOL").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$3).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$11)
    }
  };
  return x1$3
});
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.titleLevel__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$16) {
  var startIndex = $n(evidence$16).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$16).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$16).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("titleLevel").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$2 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$16).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var startPos = $n(evidence$16).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$16).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$16).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var repeater = $m_Lfastparse_Implicits$Repeater$UnitRepeater$();
  var whitespace = $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$();
  var this$3 = $m_Lfastparse_internal_RepImpls$();
  var startIndex$1 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$16).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  while (true) {
    $n(evidence$16).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
    var input = $n(evidence$16).Lfastparse_ParsingRun__f_input;
    var index = $n(evidence$16).Lfastparse_ParsingRun__f_index;
    if ($n(input).isReachable__I__Z(index)) {
      var this$4 = $n(input);
      var this$5 = $n(this$4.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$5, index) === 35)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(evidence$16).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
    } else {
      $n(evidence$16).freshFailure__Lfastparse_ParsingRun()
    };
    if ($n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$16).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"#\"")))
    };
    var parsedMsg = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$16).Lfastparse_ParsingRun__f_cut;
    var verboseFailures = $n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures;
    if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
      var res$1 = (postCut ? evidence$16 : $p_Lfastparse_internal_RepImpls$__end$3__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$16, repeater, (void 0)));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$16).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$8 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$8.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg)), $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x4 = $n(evidence$16);
          var $$x3 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$9 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$9.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x2 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x3, $$x2)
        }
      };
      break
    } else {
      var beforeSepIndex = $n(evidence$16).Lfastparse_ParsingRun__f_index;
      var t = $n(evidence$16).Lfastparse_ParsingRun__f_successValue;
      $as_jl_Void(t);
      var nextCount = ((1 + count) | 0);
      if ((nextCount === 6)) {
        var res$2 = $p_Lfastparse_internal_RepImpls$__end$3__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, beforeSepIndex, beforeSepIndex, nextCount, (!(!(outerCut | postCut))), 1, evidence$16, repeater, (void 0));
        if (verboseFailures) {
          $n(evidence$16).setMsg__I__F0__V(startIndex$1, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$10 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$10.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg)))
        };
        break
      } else {
        if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
          $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$16)
        };
        if ((!((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$16).Lfastparse_ParsingRun__f_cut))) {
          $n(evidence$16).Lfastparse_ParsingRun__f_cut = false;
          var sepCut = $n(evidence$16).Lfastparse_ParsingRun__f_cut;
          var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = false;
          outerCut = endCut;
          sepMsg = null;
          lastAgg = parsedAgg;
          continue
        };
        break
      }
    }
  };
  $n(evidence$16).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0$1 = ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) ? evidence$16 : $n(evidence$16).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$16).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$16).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var $$x5 = $n(parse0$1);
    var arg1 = $as_T($n(parse0$1).Lfastparse_ParsingRun__f_successValue);
    var this$13 = $n(arg1);
    $$x5.Lfastparse_ParsingRun__f_successValue = this$13.length
  };
  if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$7 = evidence$16
  } else {
    var postLhsIndex$macro$3 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$16).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$16).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$16).Lfastparse_ParsingRun__f_cut)) {
      var x1$7 = evidence$16
    } else {
      var preRhsIndex$macro$4 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
      var input$1 = $n(evidence$16).Lfastparse_ParsingRun__f_input;
      var index$1 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
      if ($n(input$1).isReachable__I__Z(index$1)) {
        var this$15 = $n(input$1);
        var this$16 = $n(this$15.Lfastparse_IndexedParserInput__f_data);
        var $$x6 = ($charAt(this$16, index$1) === 32)
      } else {
        var $$x6 = false
      };
      if ($$x6) {
        $n(evidence$16).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index$1) | 0))
      } else {
        $n(evidence$16).freshFailure__Lfastparse_ParsingRun()
      };
      if ($n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$16).aggregateTerminal__I__F0__V(index$1, new $c_sjsr_AnonFunction0((() => "\" \"")))
      };
      var rhsAggregate$macro$7 = $n(evidence$16).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$16).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$16).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$16
      } else {
        var postRhsIndex$macro$5 = $n(evidence$16).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$16).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x7 = $n(evidence$16);
        $n(x1$3);
        var t$1 = $uI(lhsValue$macro$12);
        $n(evidence$16);
        var res$macro$14 = $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$13)
      };
      if ($n(evidence$16).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$16).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$16).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$7 = res$macro$14
    }
  };
  if (instrument) {
    $n($n(evidence$16).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("titleLevel").Lsourcecode_Name__f_value, $n(x1$7).Lfastparse_ParsingRun__f_index, $n(x1$7).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$7).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x8 = $n(x1$7);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("titleLevel").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$7).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$7).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$7).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x9 = $n(x1$7);
      var self = new $c_Lsourcecode_Name("titleLevel").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$24 = $n($n(x1$7).Lfastparse_ParsingRun__f_failureStack);
      $$x9.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$24)
    }
  };
  return x1$7
});
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.indent__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$17) {
  var startIndex = $n(evidence$17).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$17).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$17).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("indent").Lsourcecode_Name__f_value, startIndex)
  };
  var index = $n(evidence$17).Lfastparse_ParsingRun__f_index;
  var end = ((2 + index) | 0);
  var input = $n(evidence$17).Lfastparse_ParsingRun__f_input;
  if ($n(input).isReachable__I__Z((((-1) + end) | 0))) {
    var this$1 = $n(input);
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    if (($charAt(this$2, index) === 32)) {
      var this$3 = $n(input);
      var index$1 = ((1 + index) | 0);
      var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$4, index$1) === 32)
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var res = $n(evidence$17).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
  } else {
    var res = $n(evidence$17).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$17).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$17).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"  \"")))
  };
  if (instrument) {
    $n($n(evidence$17).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("indent").Lsourcecode_Name__f_value, $n(res).Lfastparse_ParsingRun__f_index, $n(res).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(res).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(res);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("indent").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(res).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(res).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(res).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(res);
      var self = new $c_Lsourcecode_Name("indent").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(res).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$11)
    }
  };
  return res
});
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.ulh__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$18) {
  var startIndex = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$18).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$18).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("ulh").Lsourcecode_Name__f_value, startIndex)
  };
  var index = $n(evidence$18).Lfastparse_ParsingRun__f_index;
  var end = ((2 + index) | 0);
  var input = $n(evidence$18).Lfastparse_ParsingRun__f_input;
  if ($n(input).isReachable__I__Z((((-1) + end) | 0))) {
    var this$1 = $n(input);
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    if (($charAt(this$2, index) === 45)) {
      var this$3 = $n(input);
      var index$1 = ((1 + index) | 0);
      var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
      var $$x1 = ($charAt(this$4, index$1) === 32)
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var res = $n(evidence$18).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
  } else {
    var res = $n(evidence$18).freshFailure__Lfastparse_ParsingRun()
  };
  if ($n(evidence$18).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$18).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\"- \"")))
  };
  if (instrument) {
    $n($n(evidence$18).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("ulh").Lsourcecode_Name__f_value, $n(res).Lfastparse_ParsingRun__f_index, $n(res).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(res).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(res);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("ulh").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(res).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(res).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(res).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(res);
      var self = new $c_Lsourcecode_Name("ulh").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(res).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$11)
    }
  };
  return res
});
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$19) {
  var startIndex = $n(evidence$19).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$19).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$19).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value, startIndex)
  };
  var index = $n(evidence$19).Lfastparse_ParsingRun__f_index;
  if ((!$n($n(evidence$19).Lfastparse_ParsingRun__f_input).isReachable__I__Z(index))) {
    var res = $n(evidence$19).freshFailure__Lfastparse_ParsingRun()
  } else {
    var this$1 = $n($n(evidence$19).Lfastparse_ParsingRun__f_input);
    var index$1 = $n(evidence$19).Lfastparse_ParsingRun__f_index;
    var this$2 = $n(this$1.Lfastparse_IndexedParserInput__f_data);
    var x1$3 = $charAt(this$2, index$1);
    switch (x1$3) {
      case 48: {
        var x1$4 = true;
        break
      }
      case 49: {
        var x1$4 = true;
        break
      }
      case 50: {
        var x1$4 = true;
        break
      }
      case 51: {
        var x1$4 = true;
        break
      }
      case 52: {
        var x1$4 = true;
        break
      }
      case 53: {
        var x1$4 = true;
        break
      }
      case 54: {
        var x1$4 = true;
        break
      }
      case 55: {
        var x1$4 = true;
        break
      }
      case 56: {
        var x1$4 = true;
        break
      }
      case 57: {
        var x1$4 = true;
        break
      }
      default: {
        var x1$4 = false
      }
    };
    if ((x1$4 === true)) {
      var res = $n(evidence$19).freshSuccessUnit__I__Lfastparse_ParsingRun(((1 + index) | 0))
    } else {
      if ((x1$4 !== false)) {
        throw new $c_s_MatchError(x1$4)
      };
      var res = $n(evidence$19).freshFailure__Lfastparse_ParsingRun()
    }
  };
  if ($n(evidence$19).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$19).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "[0123456789]")))
  };
  if (instrument) {
    $n($n(evidence$19).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value, $n(res).Lfastparse_ParsingRun__f_index, $n(res).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(res).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(res);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(res).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(res).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(res).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(res);
      var self = new $c_Lsourcecode_Name("digit").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$10 = $n($n(res).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$10)
    }
  };
  return res
});
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.digits__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$20) {
  var startIndex = $n(evidence$20).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$20).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$20).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("digits").Lsourcecode_Name__f_value, startIndex)
  };
  var elem = $n(evidence$20).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  var startIndex$macro$4 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
  var count$macro$5 = 0;
  var lastAgg$macro$10 = null;
  var x1$4;
  while (true) {
    $n(evidence$20).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$5 < 1));
    $m_Lfastparse_package$();
    $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().digit__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$20);
    var parsedMsg$macro$9 = $n(evidence$20).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$11 = $n(evidence$20).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$20).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = ($n(evidence$20).Lfastparse_ParsingRun__f_cut ? evidence$20 : ((count$macro$5 < 1) ? $n(evidence$20).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$4, elem$1) : $n(evidence$20).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$4, elem$1)));
      if ($n(evidence$20).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x4 = $n(evidence$20);
        var $$x3 = startIndex$macro$4;
        var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$9) => (() => {
          var this$3 = $n(parsedMsg$macro$9);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$3.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
        }))(parsedMsg$macro$9));
        if ((lastAgg$macro$10 === null)) {
          var $$x1 = $n(evidence$20).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$1 = $n(evidence$20).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x1 = $n(lastAgg$macro$10).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1)
        };
        $n($$x4).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x3, $$x2, $$x1)
      };
      var x1$4 = res;
      break
    } else {
      var beforeSepIndex$macro$6 = $n(evidence$20).Lfastparse_ParsingRun__f_index;
      $n(evidence$20);
      $n(evidence$20).Lfastparse_ParsingRun__f_cut = false;
      if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$20)
      };
      if ((!((!$n(evidence$20).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$20).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$20).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$5 = ((1 + count$macro$5) | 0);
        startIndex$macro$4 = beforeSepIndex$macro$6;
        count$macro$5 = temp$count$macro$5;
        lastAgg$macro$10 = parsedAgg$macro$11;
        continue
      };
      var x1$4 = evidence$20;
      break
    }
  };
  if (instrument) {
    $n($n(evidence$20).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("digits").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("digits").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("digits").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$11)
    }
  };
  return x1$4
});
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.olh__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$21) {
  var startIndex = $n(evidence$21).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$21).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$21).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("olh").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$4 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
  var input$macro$13 = $n(evidence$21).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  this.digits__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$21);
  if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$5 = evidence$21
  } else {
    var postLhsIndex$macro$5 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$8 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$11 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$5 > preLhsIndex$macro$4) && $n(evidence$21).checkForDrop__Z())) {
      $n(input$macro$13)
    };
    $n(evidence$21);
    if (((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$21).Lfastparse_ParsingRun__f_cut)) {
      var x1$5 = evidence$21
    } else {
      var preRhsIndex$macro$6 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
      var index = $n(evidence$21).Lfastparse_ParsingRun__f_index;
      var end = ((2 + index) | 0);
      var input = $n(evidence$21).Lfastparse_ParsingRun__f_input;
      if ($n(input).isReachable__I__Z((((-1) + end) | 0))) {
        var this$3 = $n(input);
        var this$4 = $n(this$3.Lfastparse_IndexedParserInput__f_data);
        if (($charAt(this$4, index) === 46)) {
          var this$5 = $n(input);
          var index$1 = ((1 + index) | 0);
          var this$6 = $n(this$5.Lfastparse_IndexedParserInput__f_data);
          var $$x1 = ($charAt(this$6, index$1) === 32)
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        $n(evidence$21).freshSuccessUnit__I__Lfastparse_ParsingRun(end)
      } else {
        $n(evidence$21).freshFailure__Lfastparse_ParsingRun()
      };
      if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$21).aggregateTerminal__I__F0__V(index, new $c_sjsr_AnonFunction0((() => "\". \"")))
      };
      var rhsAggregate$macro$9 = $n(evidence$21).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$10 = $n(evidence$21).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$21).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$16 = evidence$21
      } else {
        var postRhsIndex$macro$7 = $n(evidence$21).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$12 = (postRhsIndex$macro$7 > preRhsIndex$macro$6);
        var nextIndex$macro$15 = (((!rhsMadeProgress$macro$12) && $n(input$macro$13).isReachable__I__Z(postRhsIndex$macro$7)) ? postLhsIndex$macro$5 : postRhsIndex$macro$7);
        if ((rhsMadeProgress$macro$12 && $n(evidence$21).checkForDrop__Z())) {
          $n(input$macro$13)
        };
        var $$x2 = $n(evidence$21);
        $n(evidence$21);
        var v = (void 0);
        var res$macro$16 = $n($$x2).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$15)
      };
      if ($n(evidence$21).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$21).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$4, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$11, rhsMsg$macro$10), $n(lhsAggregate$macro$8).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$9), (preRhsIndex$macro$6 === $n(evidence$21).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$5 = res$macro$16
    }
  };
  if (instrument) {
    $n($n(evidence$21).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("olh").Lsourcecode_Name__f_value, $n(x1$5).Lfastparse_ParsingRun__f_index, $n(x1$5).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x3 = $n(x1$5);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("olh").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x4 = $n(x1$5);
      var self = new $c_Lsourcecode_Name("olh").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$13 = $n($n(x1$5).Lfastparse_ParsingRun__f_failureStack);
      $$x4.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$13)
    }
  };
  return x1$5
});
var $d_Lreactbuild_project_generator_markdown_MarkdownLiterals$ = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_MarkdownLiterals$: 0
}, false, "reactbuild.project.generator.markdown.MarkdownLiterals$", {
  Lreactbuild_project_generator_markdown_MarkdownLiterals$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_markdown_MarkdownLiterals$.prototype.$classData = $d_Lreactbuild_project_generator_markdown_MarkdownLiterals$;
var $n_Lreactbuild_project_generator_markdown_MarkdownLiterals$;
function $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$() {
  if ((!$n_Lreactbuild_project_generator_markdown_MarkdownLiterals$)) {
    $n_Lreactbuild_project_generator_markdown_MarkdownLiterals$ = new $c_Lreactbuild_project_generator_markdown_MarkdownLiterals$()
  };
  return $n_Lreactbuild_project_generator_markdown_MarkdownLiterals$
}
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_MarkdownParser$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype = new $h_O();
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.constructor = $c_Lreactbuild_project_generator_markdown_MarkdownParser$;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_MarkdownParser$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype = $c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype;
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.header__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$1) {
  var startIndex = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$1).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("header").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$2 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$1).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().titleLevel__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$1);
  if ((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var parse0$1 = evidence$1
  } else {
    var postLhsIndex$macro$3 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$1).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$1).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$1).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$1).Lfastparse_ParsingRun__f_cut)) {
      var parse0$1 = evidence$1
    } else {
      var preRhsIndex$macro$4 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
      this.TOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$1);
      var rhsAggregate$macro$7 = $n(evidence$1).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$1).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$1).Lfastparse_ParsingRun__f_isSuccess)) {
        $n(evidence$1).Lfastparse_ParsingRun__f_cut = true;
        var res$macro$14 = evidence$1
      } else {
        var postRhsIndex$macro$5 = $n(evidence$1).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$1).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var res$macro$14 = $n(evidence$1).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($uI(lhsValue$macro$12), $as_Lreactbuild_project_generator_markdown_MarkdownText($n(evidence$1).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$13)
      };
      if ($n(evidence$1).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$1).Lfastparse_ParsingRun__f_traceIndex))
      };
      var parse0$1 = res$macro$14
    }
  };
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$5 = parse0$1
  } else {
    var $$x1 = $n(parse0$1);
    var this$4 = $m_Lreactbuild_project_generator_markdown_Header$();
    $$x1.Lfastparse_ParsingRun__f_successValue = $n($f_F2__tupled__F1(this$4)).apply__O__O($as_T2($n(parse0$1).Lfastparse_ParsingRun__f_successValue));
    var x1$5 = parse0$1
  };
  if (instrument) {
    $n($n(evidence$1).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("header").Lsourcecode_Name__f_value, $n(x1$5).Lfastparse_ParsingRun__f_index, $n(x1$5).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(x1$5);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("header").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(x1$5);
      var self = new $c_Lsourcecode_Name("header").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$12 = $n($n(x1$5).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$12)
    }
  };
  return x1$5
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.indentLevel__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$2) {
  var startIndex = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$2).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("indentLevel").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var startPos = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var repeater = $m_Lfastparse_Implicits$Repeater$UnitRepeater$();
  var whitespace = $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$();
  var this$3 = $m_Lfastparse_internal_RepImpls$();
  var startIndex$1 = $n(evidence$2).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  while (true) {
    $n(evidence$2).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 0) && outerCut))));
    $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().indent__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$2);
    var parsedMsg = $n(evidence$2).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
    var verboseFailures = $n(evidence$2).Lfastparse_ParsingRun__f_verboseFailures;
    if ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$2 : $p_Lfastparse_internal_RepImpls$__end$3__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 0, evidence$2, repeater, (void 0)));
      if (verboseFailures) {
        var startIndex$2 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$2).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$5 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$5.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
          }))(parsedMsg)), $n(evidence$2).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$2);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$6 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep(0)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
        }
      };
      break
    } else {
      var beforeSepIndex = $n(evidence$2).Lfastparse_ParsingRun__f_index;
      var t = $n(evidence$2).Lfastparse_ParsingRun__f_successValue;
      $as_jl_Void(t);
      var nextCount = ((1 + count) | 0);
      if ((nextCount === 2147483647)) {
        var res$2 = $p_Lfastparse_internal_RepImpls$__end$3__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, beforeSepIndex, beforeSepIndex, nextCount, (!(!(outerCut | postCut))), 0, evidence$2, repeater, (void 0));
        if (verboseFailures) {
          $n(evidence$2).setMsg__I__F0__V(startIndex$1, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$7 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".rep")
          }))(parsedMsg)))
        };
        break
      } else {
        if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
          $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$2)
        };
        if ((!((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$2).Lfastparse_ParsingRun__f_cut))) {
          $n(evidence$2).Lfastparse_ParsingRun__f_cut = false;
          var sepCut = $n(evidence$2).Lfastparse_ParsingRun__f_cut;
          var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = false;
          outerCut = endCut;
          sepMsg = null;
          lastAgg = parsedAgg;
          continue
        };
        break
      }
    }
  };
  $n(evidence$2).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0$1 = ((!$n(evidence$2).Lfastparse_ParsingRun__f_isSuccess) ? evidence$2 : $n(evidence$2).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$2).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$2).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$4 = parse0$1
  } else {
    var $$x4 = $n(parse0$1);
    var arg1 = $as_T($n(parse0$1).Lfastparse_ParsingRun__f_successValue);
    var this$10 = $n(arg1);
    $$x4.Lfastparse_ParsingRun__f_successValue = ((this$10.length / 2) | 0);
    var x1$4 = parse0$1
  };
  if (instrument) {
    $n($n(evidence$2).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("indentLevel").Lsourcecode_Name__f_value, $n(x1$4).Lfastparse_ParsingRun__f_index, $n(x1$4).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$4).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x5 = $n(x1$4);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("indentLevel").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$4).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$4).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$4).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x6 = $n(x1$4);
      var self = new $c_Lsourcecode_Name("indentLevel").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$17 = $n($n(x1$4).Lfastparse_ParsingRun__f_failureStack);
      $$x6.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$17)
    }
  };
  return x1$4
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.ul__I__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(level, evidence$3) {
  var startIndex = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$3).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("ul").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$17 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$3).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$2 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$3).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$().Pass__O__Lfastparse_ParsingRun__Lfastparse_ParsingRun(level, evidence$3);
  if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$3).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$3).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$3).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$4 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
      $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().ulh__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$3);
      var rhsAggregate$macro$7 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$3
      } else {
        var postRhsIndex$macro$5 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$3).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x1 = $n(evidence$3);
        $n(x1$5);
        var t = $uI(lhsValue$macro$12);
        $n(evidence$3);
        var res$macro$14 = $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$13)
      };
      if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$3).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
    var parse0$2 = evidence$3
  } else {
    var postLhsIndex$macro$18 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$3).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$3).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$3).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$3).Lfastparse_ParsingRun__f_cut)) {
      var parse0$2 = evidence$3
    } else {
      var preRhsIndex$macro$19 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
      this.TOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$3);
      var rhsAggregate$macro$22 = $n(evidence$3).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$23 = $n(evidence$3).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$3).Lfastparse_ParsingRun__f_isSuccess)) {
        $n(evidence$3).Lfastparse_ParsingRun__f_cut = true;
        var res$macro$29 = evidence$3
      } else {
        var postRhsIndex$macro$20 = $n(evidence$3).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
        var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
        if ((rhsMadeProgress$macro$25 && $n(evidence$3).checkForDrop__Z())) {
          $n(input$macro$26)
        };
        var res$macro$29 = $n(evidence$3).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($uI(lhsValue$macro$27), $as_Lreactbuild_project_generator_markdown_MarkdownText($n(evidence$3).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$28)
      };
      if ($n(evidence$3).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$3).Lfastparse_ParsingRun__f_traceIndex))
      };
      var parse0$2 = res$macro$29
    }
  };
  if ((!$n(parse0$2).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$7 = parse0$2
  } else {
    var $$x2 = $n(parse0$2);
    var this$7 = $m_Lreactbuild_project_generator_markdown_UL$();
    $$x2.Lfastparse_ParsingRun__f_successValue = $n($f_F2__tupled__F1(this$7)).apply__O__O($as_T2($n(parse0$2).Lfastparse_ParsingRun__f_successValue));
    var x1$7 = parse0$2
  };
  if (instrument) {
    $n($n(evidence$3).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("ul").Lsourcecode_Name__f_value, $n(x1$7).Lfastparse_ParsingRun__f_index, $n(x1$7).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$7).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x3 = $n(x1$7);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("ul").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$7).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$7).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$7).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x4 = $n(x1$7);
      var self = new $c_Lsourcecode_Name("ul").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$15 = $n($n(x1$7).Lfastparse_ParsingRun__f_failureStack);
      $$x4.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$15)
    }
  };
  return x1$7
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.ol__I__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(level, evidence$4) {
  var startIndex = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$4).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("ol").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = $as_Lfastparse_Implicits$Sequencer($f_Lfastparse_LowestPriSequencer__Sequencer1__O(this$1));
  var preLhsIndex$macro$17 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$5 = this$2.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$2 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$4).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$().Pass__O__Lfastparse_ParsingRun__Lfastparse_ParsingRun(level, evidence$4);
  if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$4).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    var lhsValue$macro$12 = $n(evidence$4).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$4).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$4 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().olh__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$4);
      var rhsAggregate$macro$7 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$4
      } else {
        var postRhsIndex$macro$5 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$4).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x1 = $n(evidence$4);
        $n(x1$5);
        var t = $uI(lhsValue$macro$12);
        $n(evidence$4);
        var res$macro$14 = $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$13)
      };
      if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$4).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
    var parse0$2 = evidence$4
  } else {
    var postLhsIndex$macro$18 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
    $n(evidence$4).Lfastparse_ParsingRun__f_cut = true;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$4).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$4).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$4).Lfastparse_ParsingRun__f_cut)) {
      var parse0$2 = evidence$4
    } else {
      var preRhsIndex$macro$19 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
      this.TOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$4);
      var rhsAggregate$macro$22 = $n(evidence$4).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$23 = $n(evidence$4).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$4).Lfastparse_ParsingRun__f_isSuccess)) {
        $n(evidence$4).Lfastparse_ParsingRun__f_cut = true;
        var res$macro$29 = evidence$4
      } else {
        var postRhsIndex$macro$20 = $n(evidence$4).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
        var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
        if ((rhsMadeProgress$macro$25 && $n(evidence$4).checkForDrop__Z())) {
          $n(input$macro$26)
        };
        var res$macro$29 = $n(evidence$4).freshSuccess__O__I__Lfastparse_ParsingRun($n(x1$3).apply__O__O__O($uI(lhsValue$macro$27), $as_Lreactbuild_project_generator_markdown_MarkdownText($n(evidence$4).Lfastparse_ParsingRun__f_successValue)), nextIndex$macro$28)
      };
      if ($n(evidence$4).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$4).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$4).Lfastparse_ParsingRun__f_traceIndex))
      };
      var parse0$2 = res$macro$29
    }
  };
  if ((!$n(parse0$2).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$7 = parse0$2
  } else {
    var $$x2 = $n(parse0$2);
    var this$7 = $m_Lreactbuild_project_generator_markdown_OL$();
    $$x2.Lfastparse_ParsingRun__f_successValue = $n($f_F2__tupled__F1(this$7)).apply__O__O($as_T2($n(parse0$2).Lfastparse_ParsingRun__f_successValue));
    var x1$7 = parse0$2
  };
  if (instrument) {
    $n($n(evidence$4).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("ol").Lsourcecode_Name__f_value, $n(x1$7).Lfastparse_ParsingRun__f_index, $n(x1$7).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$7).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x3 = $n(x1$7);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("ol").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x3).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$7).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$7).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$7).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x4 = $n(x1$7);
      var self = new $c_Lsourcecode_Name("ol").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$15 = $n($n(x1$7).Lfastparse_ParsingRun__f_failureStack);
      $$x4.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$15)
    }
  };
  return x1$7
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.TOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$5) {
  var startIndex = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$5).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$5).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("TOL").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$28 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var input$macro$37 = $n(evidence$5).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var startPos = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var oldCapturing = $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer = true;
  $m_Lfastparse_package$();
  var elem = $n(evidence$5).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  var startIndex$macro$19 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
  var count$macro$20 = 0;
  var lastAgg$macro$25 = null;
  while (true) {
    $n(evidence$5).Lfastparse_ParsingRun__f_cut = (elem$1 && (count$macro$20 < 0));
    $m_Lfastparse_package$();
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex$macro$2 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
    var input$macro$11 = $n(evidence$5).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    $m_Lfastparse_package$();
    var startPos$1 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
    var startCut = $n(evidence$5).Lfastparse_ParsingRun__f_cut;
    var oldNoCut = $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer;
    $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer = true;
    var startTerminals = $n(evidence$5).Lfastparse_ParsingRun__f_failureTerminalAggregate;
    $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().EOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$5);
    $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
    var msg = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
    var res = ($n(evidence$5).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$5).freshFailure__I__Lfastparse_ParsingRun(startPos$1) : $n(evidence$5).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$1));
    if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$5).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
      $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
      $n(evidence$5).setMsg__I__F0__V(startPos$1, new $c_sjsr_AnonFunction0(((msg) => (() => {
        var this$7 = $n(msg);
        return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value))
      }))(msg)))
    };
    $n(res).Lfastparse_ParsingRun__f_cut = startCut;
    if ($n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) {
      var postLhsIndex$macro$3 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$6 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$9 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
      if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$5).checkForDrop__Z())) {
        $n(input$macro$11)
      };
      $n(evidence$5);
      if ((!((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$5).Lfastparse_ParsingRun__f_cut))) {
        var preRhsIndex$macro$4 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$().AnyChar__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$5);
        var rhsAggregate$macro$7 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
          /*<skip>*/
        } else {
          var postRhsIndex$macro$5 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$5).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x1 = $n(evidence$5);
          $n(evidence$5);
          var v = (void 0);
          $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
        };
        if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$5).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    };
    var parsedMsg$macro$24 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$26 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$5).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var res$1 = ($n(evidence$5).Lfastparse_ParsingRun__f_cut ? evidence$5 : ((count$macro$20 < 0) ? $n(evidence$5).augmentFailure__I__Z__Lfastparse_ParsingRun(startIndex$macro$19, elem$1) : $n(evidence$5).freshSuccess__O__I__Z__Lfastparse_ParsingRun((void 0), startIndex$macro$19, elem$1)));
      if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x5 = $n(evidence$5);
        var $$x4 = startIndex$macro$19;
        var $$x3 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
          var this$9 = $n(parsedMsg$macro$24);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$9.Lfastparse_internal_Msgs__f_value) + ".rep")
        }))(parsedMsg$macro$24));
        if ((lastAgg$macro$25 === null)) {
          var $$x2 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$2 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x2 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
        };
        $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x4, $$x3, $$x2)
      };
      break
    } else {
      var beforeSepIndex$macro$21 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
      $n(evidence$5);
      $n(evidence$5).Lfastparse_ParsingRun__f_cut = false;
      if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$5)
      };
      if ((!((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$5).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$5).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$20 = ((1 + count$macro$20) | 0);
        startIndex$macro$19 = beforeSepIndex$macro$21;
        count$macro$20 = temp$count$macro$20;
        lastAgg$macro$25 = parsedAgg$macro$26;
        continue
      };
      break
    }
  };
  $n(evidence$5).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
  var parse0$1 = ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) ? evidence$5 : $n(evidence$5).freshSuccess__O__Lfastparse_ParsingRun($n($n(evidence$5).Lfastparse_ParsingRun__f_input).slice__I__I__T(startPos, $n(evidence$5).Lfastparse_ParsingRun__f_index)));
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var $$x6 = $n(parse0$1);
    var arg1 = $as_T($n(parse0$1).Lfastparse_ParsingRun__f_successValue);
    $$x6.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_project_generator_markdown_MarkdownText(arg1)
  };
  if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$9 = evidence$5
  } else {
    var postLhsIndex$macro$29 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$32 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$35 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$29 > preLhsIndex$macro$28) && $n(evidence$5).checkForDrop__Z())) {
      $n(input$macro$37)
    };
    var lhsValue$macro$38 = $n(evidence$5).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$5).Lfastparse_ParsingRun__f_cut)) {
      var x1$9 = evidence$5
    } else {
      var preRhsIndex$macro$30 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
      var startIndex$2 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var parse0$3 = $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().EOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$5);
      var index = $n(parse0$3).Lfastparse_ParsingRun__f_index;
      if ((!$n(parse0$3).Lfastparse_ParsingRun__f_isSuccess)) {
        $n(parse0$3).augmentFailure__I__Lfastparse_ParsingRun(index)
      } else {
        var progress = (index > startIndex$2);
        if ((progress && $n(parse0$3).checkForDrop__Z())) {
          $n($n(parse0$3).Lfastparse_ParsingRun__f_input)
        };
        $n(parse0$3).freshSuccess__O__Z__Lfastparse_ParsingRun($n(parse0$3).Lfastparse_ParsingRun__f_successValue, (!(!($n(parse0$3).Lfastparse_ParsingRun__f_cut | progress))))
      };
      var rhsAggregate$macro$33 = $n(evidence$5).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$34 = $n(evidence$5).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$5).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$40 = evidence$5
      } else {
        var postRhsIndex$macro$31 = $n(evidence$5).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$36 = (postRhsIndex$macro$31 > preRhsIndex$macro$30);
        var nextIndex$macro$39 = (((!rhsMadeProgress$macro$36) && $n(input$macro$37).isReachable__I__Z(postRhsIndex$macro$31)) ? postLhsIndex$macro$29 : postRhsIndex$macro$31);
        if ((rhsMadeProgress$macro$36 && $n(evidence$5).checkForDrop__Z())) {
          $n(input$macro$37)
        };
        var $$x7 = $n(evidence$5);
        $n(x1$3);
        var t = $as_Lreactbuild_project_generator_markdown_MarkdownText(lhsValue$macro$38);
        $n(evidence$5);
        var res$macro$40 = $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(t, nextIndex$macro$39)
      };
      if ($n(evidence$5).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$5).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$28, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$35, rhsMsg$macro$34), $n(lhsAggregate$macro$32).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$33), (preRhsIndex$macro$30 === $n(evidence$5).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$9 = res$macro$40
    }
  };
  if (instrument) {
    $n($n(evidence$5).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("TOL").Lsourcecode_Name__f_value, $n(x1$9).Lfastparse_ParsingRun__f_index, $n(x1$9).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$9).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x8 = $n(x1$9);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("TOL").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$9).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$9).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$9).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x9 = $n(x1$9);
      var self = new $c_Lsourcecode_Name("TOL").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$21 = $n($n(x1$9).Lfastparse_ParsingRun__f_failureStack);
      $$x9.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$21)
    }
  };
  return x1$9
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.maybeIndented__I__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(level, evidence$6) {
  var startIndex = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$6).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("maybeIndented").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
  $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$6).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  this.ol__I__Lfastparse_ParsingRun__Lfastparse_ParsingRun(level, evidence$6);
  var lhsMsg = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$6).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$3 = evidence$6
  } else if ($n(evidence$6).Lfastparse_ParsingRun__f_cut) {
    var x1$3 = evidence$6
  } else {
    var verboseFailures = $n(evidence$6).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$6).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$2 = $n(evidence$6);
      this$2.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = false;
    this.ul__I__Lfastparse_ParsingRun__Lfastparse_ParsingRun(level, evidence$6);
    var rhsMsg = $n(evidence$6).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$6).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$6).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$6).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$6).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$3 = $n(evidence$6);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$6).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$3.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$3 = evidence$6
  };
  if (instrument) {
    $n($n(evidence$6).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("maybeIndented").Lsourcecode_Name__f_value, $n(x1$3).Lfastparse_ParsingRun__f_index, $n(x1$3).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$3).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(x1$3);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("maybeIndented").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$3).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$3).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(x1$3);
      var self = new $c_Lsourcecode_Name("maybeIndented").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$3).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$11)
    }
  };
  return x1$3
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.text__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$7) {
  var startIndex = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$7).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("text").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$7).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var startPos = $n(evidence$7).Lfastparse_ParsingRun__f_index;
  var startCut = $n(evidence$7).Lfastparse_ParsingRun__f_cut;
  var oldNoCut = $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer;
  $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer = true;
  var startTerminals = $n(evidence$7).Lfastparse_ParsingRun__f_failureTerminalAggregate;
  $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().EOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
  $n(evidence$7).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
  var msg = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
  var res = ($n(evidence$7).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$7).freshFailure__I__Lfastparse_ParsingRun(startPos) : $n(evidence$7).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos));
  if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
    $n(evidence$7).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
    $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
    $n(evidence$7).setMsg__I__F0__V(startPos, new $c_sjsr_AnonFunction0((() => {
      var this$4 = $n(msg);
      return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$4.Lfastparse_internal_Msgs__f_value))
    })))
  };
  $n(res).Lfastparse_ParsingRun__f_cut = startCut;
  if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$5 = evidence$7
  } else {
    var postLhsIndex$macro$3 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$7).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$7);
    if (((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$7).Lfastparse_ParsingRun__f_cut)) {
      var x1$5 = evidence$7
    } else {
      var preRhsIndex$macro$4 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      var startIndex$2 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      var parse0 = this.TOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$7);
      var index = $n(parse0).Lfastparse_ParsingRun__f_index;
      if ((!$n(parse0).Lfastparse_ParsingRun__f_isSuccess)) {
        $n(parse0).augmentFailure__I__Lfastparse_ParsingRun(index)
      } else {
        var progress = (index > startIndex$2);
        if ((progress && $n(parse0).checkForDrop__Z())) {
          $n($n(parse0).Lfastparse_ParsingRun__f_input)
        };
        $n(parse0).freshSuccess__O__Z__Lfastparse_ParsingRun($n(parse0).Lfastparse_ParsingRun__f_successValue, (!(!($n(parse0).Lfastparse_ParsingRun__f_cut | progress))))
      };
      var rhsAggregate$macro$7 = $n(evidence$7).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$7).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$7).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$7
      } else {
        var postRhsIndex$macro$5 = $n(evidence$7).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$7).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x1 = $n(evidence$7);
        var v = $as_Lreactbuild_project_generator_markdown_MarkdownText($n(evidence$7).Lfastparse_ParsingRun__f_successValue);
        var res$macro$14 = $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
      };
      if ($n(evidence$7).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$7).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$7).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$5 = res$macro$14
    }
  };
  if (instrument) {
    $n($n(evidence$7).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("text").Lsourcecode_Name__f_value, $n(x1$5).Lfastparse_ParsingRun__f_index, $n(x1$5).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x2 = $n(x1$5);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("text").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x2).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x3 = $n(x1$5);
      var self = new $c_Lsourcecode_Name("text").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$13 = $n($n(x1$5).Lfastparse_ParsingRun__f_failureStack);
      $$x3.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$13)
    }
  };
  return x1$5
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.paragraphLines__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$8) {
  var startIndex = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$8).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$8).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("paragraphLines").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$17 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var input$macro$26 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_Implicits$Sequencer$();
  var preLhsIndex$macro$2 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
  var input$macro$11 = $n(evidence$8).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$().Pass__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
  if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
    /*<skip>*/
  } else {
    var postLhsIndex$macro$3 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$6 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$9 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$8).checkForDrop__Z())) {
      $n(input$macro$11)
    };
    $n(evidence$8);
    if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
      /*<skip>*/
    } else {
      var preRhsIndex$macro$4 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      $m_Lfastparse_package$();
      var this$5 = $m_Lfastparse_Implicits$Repeater$();
      var repeater = this$5.GenericRepeatedImplicit0__Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$();
      var whitespace = $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$();
      var this$7 = $m_Lfastparse_internal_RepImpls$();
      $n(repeater);
      var acc = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
      var startIndex$1 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var count = 0;
      var precut = false;
      var outerCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
      var sepMsg = null;
      var lastAgg = null;
      var parse0$2;
      while (true) {
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
        $m_Lreactbuild_project_generator_markdown_MarkdownParser$().text__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
        var parsedMsg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
        var parsedAgg = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var postCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
        var verboseFailures = $n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures;
        if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
          var res = (postCut ? evidence$8 : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$7, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$8, repeater, acc));
          if (verboseFailures) {
            var startIndex$2 = startIndex$1;
            var sepMsg$1 = sepMsg;
            var lastAgg$1 = lastAgg;
            var precut$1 = precut;
            if (((sepMsg$1 === null) || precut$1)) {
              $n(evidence$8).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$10 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$10.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg)), $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate)
            } else {
              var $$x3 = $n(evidence$8);
              var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$11 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$11.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg));
              if ((lastAgg$1 === null)) {
                var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
              } else {
                var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
                var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
              };
              $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$2, $$x2, $$x1)
            }
          };
          var parse0$2 = res;
          break
        } else {
          var beforeSepIndex = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          $n(repeater);
          var t = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
          var this$13 = $n(acc);
          this$13.addOne__O__scm_Growable(t);
          var nextCount = ((1 + count) | 0);
          if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$8)
          };
          if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
            var parse0$2 = evidence$8;
            break
          } else {
            $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
            $m_Lfastparse_package$();
            var startPos = $n(evidence$8).Lfastparse_ParsingRun__f_index;
            var startCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
            var oldNoCut = $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer;
            $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = true;
            var startTerminals = $n(evidence$8).Lfastparse_ParsingRun__f_failureTerminalAggregate;
            var oldCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
            $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
            var startPos$1 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
            $m_Lfastparse_package$();
            $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().EOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
            var lhsMsg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
            var lhsAggregate = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
            if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
              $n(evidence$8).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$8).Lfastparse_ParsingRun__f_cut | oldCut)))
            } else if ((!$n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
              var verboseFailures$1 = $n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures;
              $n(evidence$8).Lfastparse_ParsingRun__f_index = startPos$1;
              if (verboseFailures$1) {
                var this$17 = $n(evidence$8);
                this$17.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$1, lhsMsg, lhsAggregate, false)
              };
              $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
              $m_Lreactbuild_project_generator_markdown_MarkdownParser$().lineExceptParagraph__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
              var rhsMsg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
              var rhsCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
              var endCut = (!(!(rhsCut | oldCut)));
              if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
                $n(evidence$8).freshFailure__I__Lfastparse_ParsingRun(startPos$1)
              };
              $n(evidence$8).Lfastparse_ParsingRun__f_cut = endCut;
              if (verboseFailures$1) {
                var this$18 = $n(evidence$8);
                var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
                var rassoc$3 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
                var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
                this$18.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$1, msgToSet, msgToAggregate, false)
              }
            };
            $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
            var msg = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
            var res$1 = ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$8).freshFailure__I__Lfastparse_ParsingRun(startPos) : $n(evidence$8).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos));
            if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
              $n(evidence$8).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
              $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
              $n(evidence$8).setMsg__I__F0__V(startPos, new $c_sjsr_AnonFunction0(((msg) => (() => {
                var this$19 = $n(msg);
                return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$19.Lfastparse_internal_Msgs__f_value))
              }))(msg)))
            };
            $n(res$1).Lfastparse_ParsingRun__f_cut = startCut;
            var sepCut = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
            var endCut$1 = (!(!((!(!(outerCut | postCut))) | sepCut)));
            if ((res$1 === null)) {
              startIndex$1 = beforeSepIndex;
              count = nextCount;
              precut = false;
              outerCut = endCut$1;
              sepMsg = null;
              lastAgg = parsedAgg;
              continue
            };
            if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
              if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
                $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$8)
              };
              var temp$sepMsg$2 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
              startIndex$1 = beforeSepIndex;
              count = nextCount;
              precut = sepCut;
              outerCut = endCut$1;
              sepMsg = temp$sepMsg$2;
              lastAgg = parsedAgg;
              continue
            };
            var res$2 = (sepCut ? $n(evidence$8).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut$1) : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$7, beforeSepIndex, beforeSepIndex, nextCount, endCut$1, 1, evidence$8, repeater, acc));
            if (verboseFailures) {
              var startIndex$3 = startIndex$1;
              var $$x5 = $n(evidence$8);
              var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
                var this$21 = $n(parsedMsg);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$21.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg));
              var rassoc$1 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
              $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$3, $$x4, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1))
            };
            var parse0$2 = res$2;
            break
          }
        }
      };
      if ($n(parse0$2).Lfastparse_ParsingRun__f_isSuccess) {
        var $$x6 = $n(parse0$2);
        var arg1 = $as_sci_Seq($n(parse0$2).Lfastparse_ParsingRun__f_successValue);
        $$x6.Lfastparse_ParsingRun__f_successValue = new $c_Lreactbuild_project_generator_markdown_Paragraph(arg1)
      };
      var rhsAggregate$macro$7 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$8 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$14 = evidence$8
      } else {
        var postRhsIndex$macro$5 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
        var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
        if ((rhsMadeProgress$macro$10 && $n(evidence$8).checkForDrop__Z())) {
          $n(input$macro$11)
        };
        var $$x7 = $n(evidence$8);
        var v = $as_Lreactbuild_project_generator_markdown_Paragraph($n(evidence$8).Lfastparse_ParsingRun__f_successValue);
        var res$macro$14 = $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
      };
      if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$8).Lfastparse_ParsingRun__f_traceIndex))
      }
    }
  };
  if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$8 = evidence$8
  } else {
    var postLhsIndex$macro$18 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$21 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$24 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$18 > preLhsIndex$macro$17) && $n(evidence$8).checkForDrop__Z())) {
      $n(input$macro$26)
    };
    var lhsValue$macro$27 = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
      var x1$8 = evidence$8
    } else {
      var preRhsIndex$macro$19 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var oldCut$1 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
      $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
      var startPos$2 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$();
      $m_Lfastparse_package$();
      var repeater$1 = $m_Lfastparse_Implicits$Repeater$UnitRepeater$();
      var whitespace$1 = $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$();
      var this$26 = $m_Lfastparse_internal_RepImpls$();
      var startIndex$4 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
      var count$1 = 0;
      var precut$2 = false;
      var outerCut$1 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
      var sepMsg$2 = null;
      var lastAgg$2 = null;
      while (true) {
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = (!(!(precut$2 | ((count$1 < 1) && outerCut$1))));
        var startIndex$5 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
        $m_Lfastparse_package$();
        var parse0$4 = $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().EOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
        var index = $n(parse0$4).Lfastparse_ParsingRun__f_index;
        if ((!$n(parse0$4).Lfastparse_ParsingRun__f_isSuccess)) {
          $n(parse0$4).augmentFailure__I__Lfastparse_ParsingRun(index)
        } else {
          var progress = (index > startIndex$5);
          if ((progress && $n(parse0$4).checkForDrop__Z())) {
            $n($n(parse0$4).Lfastparse_ParsingRun__f_input)
          };
          $n(parse0$4).freshSuccess__O__Z__Lfastparse_ParsingRun($n(parse0$4).Lfastparse_ParsingRun__f_successValue, (!(!($n(parse0$4).Lfastparse_ParsingRun__f_cut | progress))))
        };
        var parsedMsg$1 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
        var parsedAgg$1 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var postCut$1 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
        var verboseFailures$2 = $n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures;
        if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
          var res$3 = (postCut$1 ? evidence$8 : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$26, startIndex$4, startIndex$4, count$1, (!(!(outerCut$1 | postCut$1))), 1, evidence$8, repeater$1, (void 0)));
          if (verboseFailures$2) {
            var startIndex$6 = startIndex$4;
            var sepMsg$3 = sepMsg$2;
            var lastAgg$3 = lastAgg$2;
            var precut$3 = precut$2;
            if (((sepMsg$3 === null) || precut$3)) {
              $n(evidence$8).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$6, new $c_sjsr_AnonFunction0(((parsedMsg$1) => (() => {
                var this$29 = $n(parsedMsg$1);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$29.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$1)), $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate)
            } else {
              var $$x10 = $n(evidence$8);
              var $$x9 = new $c_sjsr_AnonFunction0(((parsedMsg$1) => (() => {
                var this$30 = $n(parsedMsg$1);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$30.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$1));
              if ((lastAgg$3 === null)) {
                var $$x8 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$3, parsedMsg$1)
              } else {
                var rassoc$2$1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$3, parsedMsg$1);
                var $$x8 = $n(lastAgg$3).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2$1)
              };
              $n($$x10).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$6, $$x9, $$x8)
            }
          };
          break
        } else {
          var beforeSepIndex$1 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
          var t$1 = $n(evidence$8).Lfastparse_ParsingRun__f_successValue;
          $as_jl_Void(t$1);
          var nextCount$1 = ((1 + count$1) | 0);
          if ((whitespace$1 !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace$1, evidence$8)
          };
          if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
            break
          } else {
            $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
            $m_Lfastparse_package$();
            var startPos$3 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
            var startCut$1 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
            var oldNoCut$1 = $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer;
            $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = true;
            var startTerminals$1 = $n(evidence$8).Lfastparse_ParsingRun__f_failureTerminalAggregate;
            $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
            $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut$1;
            var msg$1 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
            var res$4 = ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$8).freshFailure__I__Lfastparse_ParsingRun(startPos$3) : $n(evidence$8).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$3));
            if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
              $n(evidence$8).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals$1;
              $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
              $n(evidence$8).setMsg__I__F0__V(startPos$3, new $c_sjsr_AnonFunction0(((msg$1) => (() => {
                var this$33 = $n(msg$1);
                return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$33.Lfastparse_internal_Msgs__f_value))
              }))(msg$1)))
            };
            $n(res$4).Lfastparse_ParsingRun__f_cut = startCut$1;
            var sepCut$1 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
            var endCut$2 = (!(!((!(!(outerCut$1 | postCut$1))) | sepCut$1)));
            if ((res$4 === null)) {
              startIndex$4 = beforeSepIndex$1;
              count$1 = nextCount$1;
              precut$2 = false;
              outerCut$1 = endCut$2;
              sepMsg$2 = null;
              lastAgg$2 = parsedAgg$1;
              continue
            };
            if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
              if ((whitespace$1 !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
                $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace$1, evidence$8)
              };
              var temp$sepMsg$2$1 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
              startIndex$4 = beforeSepIndex$1;
              count$1 = nextCount$1;
              precut$2 = sepCut$1;
              outerCut$1 = endCut$2;
              sepMsg$2 = temp$sepMsg$2$1;
              lastAgg$2 = parsedAgg$1;
              continue
            };
            var res$2$1 = (sepCut$1 ? $n(evidence$8).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex$1, endCut$2) : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$26, beforeSepIndex$1, beforeSepIndex$1, nextCount$1, endCut$2, 1, evidence$8, repeater$1, (void 0)));
            if (verboseFailures$2) {
              var startIndex$7 = startIndex$4;
              var $$x12 = $n(evidence$8);
              var $$x11 = new $c_sjsr_AnonFunction0(((parsedMsg$1) => (() => {
                var this$35 = $n(parsedMsg$1);
                return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$35.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
              }))(parsedMsg$1));
              var rassoc$1$1 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
              $n($$x12).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$7, $$x11, $n(parsedAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1$1))
            };
            break
          }
        }
      };
      var lhsMsg$1 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
      var lhsAggregate$1 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      if ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) {
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$8).Lfastparse_ParsingRun__f_cut | oldCut$1)))
      } else if ((!$n(evidence$8).Lfastparse_ParsingRun__f_cut)) {
        var verboseFailures$3 = $n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures;
        $n(evidence$8).Lfastparse_ParsingRun__f_index = startPos$2;
        if (verboseFailures$3) {
          var this$37 = $n(evidence$8);
          this$37.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg$1, lhsAggregate$1, false)
        };
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = false;
        $m_Lfastparse_package$();
        var startPos$4 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
        var startCut$2 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
        var oldNoCut$2 = $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = true;
        $m_Lreactbuild_project_generator_markdown_MarkdownParser$().lineExceptParagraph__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$8);
        $n(evidence$8).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut$2;
        var msg$2 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
        var res$5 = ($n(evidence$8).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$8).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos$4) : evidence$8);
        if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
          $n(evidence$8).setMsg__I__F0__V(startPos$4, new $c_sjsr_AnonFunction0((() => {
            if ($is_sci_Seq(msg$2)) {
              var x2 = $as_sci_Seq(msg$2);
              $m_sci_Seq$();
              if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x2), true) && ($n(x2).lengthCompare__I__I(1) === 0))) {
                var this$43 = $n(msg$2);
                return (("&(" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$43.Lfastparse_internal_Msgs__f_value)) + ")")
              }
            };
            var this$44 = $n(msg$2);
            return ("&" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$44.Lfastparse_internal_Msgs__f_value))
          })))
        };
        $n(res$5).Lfastparse_ParsingRun__f_cut = startCut$2;
        var rhsMsg$1 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
        var rhsCut$1 = $n(evidence$8).Lfastparse_ParsingRun__f_cut;
        var endCut$3 = (!(!(rhsCut$1 | oldCut$1)));
        if (((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$1))) {
          $n(evidence$8).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
        };
        $n(evidence$8).Lfastparse_ParsingRun__f_cut = endCut$3;
        if (verboseFailures$3) {
          var this$45 = $n(evidence$8);
          var msgToSet$1 = $n(lhsMsg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$1);
          var rassoc$3$1 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var msgToAggregate$1 = $n(lhsAggregate$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$1);
          this$45.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet$1, msgToAggregate$1, false)
        }
      };
      var rhsAggregate$macro$22 = $n(evidence$8).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$23 = $n(evidence$8).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$8).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$29 = evidence$8
      } else {
        var postRhsIndex$macro$20 = $n(evidence$8).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$25 = (postRhsIndex$macro$20 > preRhsIndex$macro$19);
        var nextIndex$macro$28 = (((!rhsMadeProgress$macro$25) && $n(input$macro$26).isReachable__I__Z(postRhsIndex$macro$20)) ? postLhsIndex$macro$18 : postRhsIndex$macro$20);
        if ((rhsMadeProgress$macro$25 && $n(evidence$8).checkForDrop__Z())) {
          $n(input$macro$26)
        };
        var $$x13 = $n(evidence$8);
        $n(x1$3);
        var t$2 = $as_Lreactbuild_project_generator_markdown_Paragraph(lhsValue$macro$27);
        $n(evidence$8);
        var res$macro$29 = $n($$x13).freshSuccess__O__I__Lfastparse_ParsingRun(t$2, nextIndex$macro$28)
      };
      if ($n(evidence$8).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$17, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$24, rhsMsg$macro$23), $n(lhsAggregate$macro$21).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$22), (preRhsIndex$macro$19 === $n(evidence$8).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$8 = res$macro$29
    }
  };
  if (instrument) {
    $n($n(evidence$8).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("paragraphLines").Lsourcecode_Name__f_value, $n(x1$8).Lfastparse_ParsingRun__f_index, $n(x1$8).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$8).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x14 = $n(x1$8);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("paragraphLines").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x14).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$8).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$8).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$8).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x15 = $n(x1$8);
      var self = new $c_Lsourcecode_Name("paragraphLines").Lsourcecode_Name__f_value;
      var rassoc$1$2 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$53 = $n($n(x1$8).Lfastparse_ParsingRun__f_failureStack);
      $$x15.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$2, this$53)
    }
  };
  return x1$8
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.emptyLines__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$9) {
  var startIndex = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$9).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$9).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("emptyLines").Lsourcecode_Name__f_value, startIndex)
  };
  $m_Lfastparse_package$();
  $m_Lfastparse_package$();
  var repeater = $m_Lfastparse_Implicits$Repeater$UnitRepeater$();
  var whitespace = $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$();
  var this$3 = $m_Lfastparse_internal_RepImpls$();
  var startIndex$1 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
  var count = 0;
  var precut = false;
  var outerCut = $n(evidence$9).Lfastparse_ParsingRun__f_cut;
  var sepMsg = null;
  var lastAgg = null;
  var parse0$1;
  while (true) {
    $n(evidence$9).Lfastparse_ParsingRun__f_cut = (!(!(precut | ((count < 1) && outerCut))));
    var startIndex$2 = $n(evidence$9).Lfastparse_ParsingRun__f_index;
    $m_Lfastparse_package$();
    var parse0 = $m_Lreactbuild_project_generator_markdown_MarkdownLiterals$().EOL__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$9);
    var index = $n(parse0).Lfastparse_ParsingRun__f_index;
    if ((!$n(parse0).Lfastparse_ParsingRun__f_isSuccess)) {
      $n(parse0).augmentFailure__I__Lfastparse_ParsingRun(index)
    } else {
      var progress = (index > startIndex$2);
      if ((progress && $n(parse0).checkForDrop__Z())) {
        $n($n(parse0).Lfastparse_ParsingRun__f_input)
      };
      $n(parse0).freshSuccess__O__Z__Lfastparse_ParsingRun($n(parse0).Lfastparse_ParsingRun__f_successValue, (!(!($n(parse0).Lfastparse_ParsingRun__f_cut | progress))))
    };
    var parsedMsg = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var postCut = $n(evidence$9).Lfastparse_ParsingRun__f_cut;
    var verboseFailures = $n(evidence$9).Lfastparse_ParsingRun__f_verboseFailures;
    if ((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess)) {
      var res = (postCut ? evidence$9 : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, startIndex$1, startIndex$1, count, (!(!(outerCut | postCut))), 1, evidence$9, repeater, (void 0)));
      if (verboseFailures) {
        var startIndex$3 = startIndex$1;
        var sepMsg$1 = sepMsg;
        var lastAgg$1 = lastAgg;
        var precut$1 = precut;
        if (((sepMsg$1 === null) || precut$1)) {
          $n(evidence$9).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$3, new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$6 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$6.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg)), $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate)
        } else {
          var $$x3 = $n(evidence$9);
          var $$x2 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$7 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$7.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          if ((lastAgg$1 === null)) {
            var $$x1 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg)
          } else {
            var rassoc$2 = $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(sepMsg$1, parsedMsg);
            var $$x1 = $n(lastAgg$1).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
          };
          $n($$x3).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$3, $$x2, $$x1)
        }
      };
      var parse0$1 = res;
      break
    } else {
      var beforeSepIndex = $n(evidence$9).Lfastparse_ParsingRun__f_index;
      var t = $n(evidence$9).Lfastparse_ParsingRun__f_successValue;
      $as_jl_Void(t);
      var nextCount = ((1 + count) | 0);
      if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$9)
      };
      if (((!$n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$9).Lfastparse_ParsingRun__f_cut)) {
        var parse0$1 = evidence$9;
        break
      } else {
        $n(evidence$9).Lfastparse_ParsingRun__f_cut = false;
        $m_Lfastparse_package$();
        var startPos = $n(evidence$9).Lfastparse_ParsingRun__f_index;
        var startCut = $n(evidence$9).Lfastparse_ParsingRun__f_cut;
        var oldNoCut = $n(evidence$9).Lfastparse_ParsingRun__f_noDropBuffer;
        $n(evidence$9).Lfastparse_ParsingRun__f_noDropBuffer = true;
        var startTerminals = $n(evidence$9).Lfastparse_ParsingRun__f_failureTerminalAggregate;
        $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$9);
        $n(evidence$9).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
        var msg = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
        var res$1 = ($n(evidence$9).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$9).freshFailure__I__Lfastparse_ParsingRun(startPos) : $n(evidence$9).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos));
        if ($n(evidence$9).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$9).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
          $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
          $n(evidence$9).setMsg__I__F0__V(startPos, new $c_sjsr_AnonFunction0(((msg) => (() => {
            var this$10 = $n(msg);
            return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$10.Lfastparse_internal_Msgs__f_value))
          }))(msg)))
        };
        $n(res$1).Lfastparse_ParsingRun__f_cut = startCut;
        var sepCut = $n(evidence$9).Lfastparse_ParsingRun__f_cut;
        var endCut = (!(!((!(!(outerCut | postCut))) | sepCut)));
        if ((res$1 === null)) {
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = false;
          outerCut = endCut;
          sepMsg = null;
          lastAgg = parsedAgg;
          continue
        };
        if ($n(evidence$9).Lfastparse_ParsingRun__f_isSuccess) {
          if ((whitespace !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
            $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V(whitespace, evidence$9)
          };
          var temp$sepMsg$2 = $n(evidence$9).Lfastparse_ParsingRun__f_shortParserMsg;
          startIndex$1 = beforeSepIndex;
          count = nextCount;
          precut = sepCut;
          outerCut = endCut;
          sepMsg = temp$sepMsg$2;
          lastAgg = parsedAgg;
          continue
        };
        var res$2 = (sepCut ? $n(evidence$9).augmentFailure__I__Z__Lfastparse_ParsingRun(beforeSepIndex, endCut) : $p_Lfastparse_internal_RepImpls$__end$4__I__I__I__Z__I__Lfastparse_ParsingRun__Lfastparse_Implicits$Repeater__O__Lfastparse_ParsingRun(this$3, beforeSepIndex, beforeSepIndex, nextCount, endCut, 1, evidence$9, repeater, (void 0)));
        if (verboseFailures) {
          var startIndex$4 = startIndex$1;
          var $$x5 = $n(evidence$9);
          var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg) => (() => {
            var this$12 = $n(parsedMsg);
            return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$12.Lfastparse_internal_Msgs__f_value) + ".rep(1)")
          }))(parsedMsg));
          var rassoc$1 = $n(evidence$9).Lfastparse_ParsingRun__f_failureGroupAggregate;
          $n($$x5).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V(startIndex$4, $$x4, $n(parsedAgg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1))
        };
        var parse0$1 = res$2;
        break
      }
    }
  };
  if ((!$n(parse0$1).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$3 = parse0$1
  } else {
    $n(parse0$1).Lfastparse_ParsingRun__f_successValue = ($n(parse0$1), new $c_Lreactbuild_project_generator_markdown_Paragraph($m_s_package$().s_package$__f_Nil));
    var x1$3 = parse0$1
  };
  if (instrument) {
    $n($n(evidence$9).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("emptyLines").Lsourcecode_Name__f_value, $n(x1$3).Lfastparse_ParsingRun__f_index, $n(x1$3).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$3).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x6 = $n(x1$3);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("emptyLines").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x6).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$3).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$3).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x7 = $n(x1$3);
      var self = new $c_Lsourcecode_Name("emptyLines").Lsourcecode_Name__f_value;
      var rassoc$1$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$20 = $n($n(x1$3).Lfastparse_ParsingRun__f_failureStack);
      $$x7.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1$1, this$20)
    }
  };
  return x1$3
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.paragraph__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$10) {
  var startIndex = $n(evidence$10).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$10).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$10).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("paragraph").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$10).Lfastparse_ParsingRun__f_cut;
  $n(evidence$10).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$10).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  this.paragraphLines__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$10);
  var lhsMsg = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$10).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$10).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$10).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$3 = evidence$10
  } else if ($n(evidence$10).Lfastparse_ParsingRun__f_cut) {
    var x1$3 = evidence$10
  } else {
    var verboseFailures = $n(evidence$10).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$10).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$2 = $n(evidence$10);
      this$2.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$10).Lfastparse_ParsingRun__f_cut = false;
    this.emptyLines__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$10);
    var rhsMsg = $n(evidence$10).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$10).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$10).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$10).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$10).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$3 = $n(evidence$10);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$10).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$3.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$3 = evidence$10
  };
  if (instrument) {
    $n($n(evidence$10).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("paragraph").Lsourcecode_Name__f_value, $n(x1$3).Lfastparse_ParsingRun__f_index, $n(x1$3).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$3).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(x1$3);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("paragraph").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$3).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$3).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(x1$3);
      var self = new $c_Lsourcecode_Name("paragraph").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$3).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$11)
    }
  };
  return x1$3
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.lineExceptParagraph__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$11) {
  var startIndex = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$11).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$11).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("lineExceptParagraph").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
  $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  var oldCut$2 = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
  $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
  var startPos$2 = $n(evidence$11).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  $m_Lfastparse_package$().Fail__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$11);
  var lhsMsg = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$11).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$11).Lfastparse_ParsingRun__f_cut | oldCut$2)))
  } else if ($n(evidence$11).Lfastparse_ParsingRun__f_cut) {
    /*<skip>*/
  } else {
    var verboseFailures = $n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$11).Lfastparse_ParsingRun__f_index = startPos$2;
    if (verboseFailures) {
      var this$2 = $n(evidence$11);
      this$2.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
    this.header__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$11);
    var rhsMsg = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut$2)));
    if (((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$11).freshFailure__I__Lfastparse_ParsingRun(startPos$2)
    };
    $n(evidence$11).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$3 = $n(evidence$11);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$3.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos$2, msgToSet, msgToAggregate, false)
    }
  };
  var lhsMsg$2 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate$2 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$11).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$11).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$5 = evidence$11
  } else if ($n(evidence$11).Lfastparse_ParsingRun__f_cut) {
    var x1$5 = evidence$11
  } else {
    var verboseFailures$2 = $n(evidence$11).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$11).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures$2) {
      var this$5 = $n(evidence$11);
      this$5.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg$2, lhsAggregate$2, false)
    };
    $n(evidence$11).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$();
    var parse0$2 = this.indentLevel__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$11);
    if ($n(parse0$2).Lfastparse_ParsingRun__f_isSuccess) {
      var oldCapturing = $n(parse0$2).Lfastparse_ParsingRun__f_noDropBuffer;
      var successValue = $n(parse0$2).Lfastparse_ParsingRun__f_successValue;
      $n(parse0$2).Lfastparse_ParsingRun__f_noDropBuffer = true;
      $n(parse0$2).freshSuccessUnit__Lfastparse_ParsingRun();
      $n(parse0$2).Lfastparse_ParsingRun__f_noDropBuffer = oldCapturing;
      if ((!((!$n(parse0$2).Lfastparse_ParsingRun__f_isSuccess) && $n(parse0$2).Lfastparse_ParsingRun__f_cut))) {
        var arg1 = $uI(successValue);
        $m_Lreactbuild_project_generator_markdown_MarkdownParser$().maybeIndented__I__Lfastparse_ParsingRun__Lfastparse_ParsingRun(arg1, evidence$11)
      }
    };
    var rhsMsg$2 = $n(evidence$11).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut$2 = $n(evidence$11).Lfastparse_ParsingRun__f_cut;
    var endCut$2 = (!(!(rhsCut$2 | oldCut)));
    if (((!$n(evidence$11).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut$2))) {
      $n(evidence$11).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$11).Lfastparse_ParsingRun__f_cut = endCut$2;
    if (verboseFailures$2) {
      var this$7 = $n(evidence$11);
      var msgToSet$1 = $n(lhsMsg$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg$2);
      var rassoc$3$2 = $n(evidence$11).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate$1 = $n(lhsAggregate$2).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3$2);
      this$7.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet$1, msgToAggregate$1, false)
    };
    var x1$5 = evidence$11
  };
  if (instrument) {
    $n($n(evidence$11).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("lineExceptParagraph").Lsourcecode_Name__f_value, $n(x1$5).Lfastparse_ParsingRun__f_index, $n(x1$5).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$5).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(x1$5);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("lineExceptParagraph").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$5).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$5).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$5).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(x1$5);
      var self = new $c_Lsourcecode_Name("lineExceptParagraph").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$14 = $n($n(x1$5).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$14)
    }
  };
  return x1$5
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.line__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$12) {
  var startIndex = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$12).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$12).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("line").Lsourcecode_Name__f_value, startIndex)
  };
  var oldCut = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
  $n(evidence$12).Lfastparse_ParsingRun__f_cut = false;
  var startPos = $n(evidence$12).Lfastparse_ParsingRun__f_index;
  $m_Lfastparse_package$();
  this.lineExceptParagraph__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$12);
  var lhsMsg = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
  var lhsAggregate = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
  if ($n(evidence$12).Lfastparse_ParsingRun__f_isSuccess) {
    $n(evidence$12).Lfastparse_ParsingRun__f_cut = (!(!($n(evidence$12).Lfastparse_ParsingRun__f_cut | oldCut)));
    var x1$3 = evidence$12
  } else if ($n(evidence$12).Lfastparse_ParsingRun__f_cut) {
    var x1$3 = evidence$12
  } else {
    var verboseFailures = $n(evidence$12).Lfastparse_ParsingRun__f_verboseFailures;
    $n(evidence$12).Lfastparse_ParsingRun__f_index = startPos;
    if (verboseFailures) {
      var this$2 = $n(evidence$12);
      this$2.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, lhsMsg, lhsAggregate, false)
    };
    $n(evidence$12).Lfastparse_ParsingRun__f_cut = false;
    this.paragraph__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$12);
    var rhsMsg = $n(evidence$12).Lfastparse_ParsingRun__f_shortParserMsg;
    var rhsCut = $n(evidence$12).Lfastparse_ParsingRun__f_cut;
    var endCut = (!(!(rhsCut | oldCut)));
    if (((!$n(evidence$12).Lfastparse_ParsingRun__f_isSuccess) && (!rhsCut))) {
      $n(evidence$12).freshFailure__I__Lfastparse_ParsingRun(startPos)
    };
    $n(evidence$12).Lfastparse_ParsingRun__f_cut = endCut;
    if (verboseFailures) {
      var this$3 = $n(evidence$12);
      var msgToSet = $n(lhsMsg).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsMsg);
      var rassoc$3 = $n(evidence$12).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var msgToAggregate = $n(lhsAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$3);
      this$3.aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startPos, msgToSet, msgToAggregate, false)
    };
    var x1$3 = evidence$12
  };
  if (instrument) {
    $n($n(evidence$12).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("line").Lsourcecode_Name__f_value, $n(x1$3).Lfastparse_ParsingRun__f_index, $n(x1$3).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$3).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x1 = $n(x1$3);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("line").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$3).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$3).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$3).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x2 = $n(x1$3);
      var self = new $c_Lsourcecode_Name("line").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$11 = $n($n(x1$3).Lfastparse_ParsingRun__f_failureStack);
      $$x2.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$11)
    }
  };
  return x1$3
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.root__Lfastparse_ParsingRun__Lfastparse_ParsingRun = (function(evidence$13) {
  var startIndex = $n(evidence$13).Lfastparse_ParsingRun__f_index;
  var instrument = ($n(evidence$13).Lfastparse_ParsingRun__f_instrument !== null);
  if (instrument) {
    $n($n(evidence$13).Lfastparse_ParsingRun__f_instrument).beforeParse__T__I__V(new $c_Lsourcecode_Name("root").Lsourcecode_Name__f_value, startIndex)
  };
  var this$1 = $m_Lfastparse_Implicits$Sequencer$();
  var x1$3 = this$1.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$();
  var preLhsIndex$macro$28 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
  var input$macro$37 = $n(evidence$13).Lfastparse_ParsingRun__f_input;
  $m_Lfastparse_package$();
  var this$2 = $m_Lfastparse_Implicits$Repeater$();
  var x1$5 = this$2.GenericRepeatedImplicit0__Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$();
  var elem = $n(evidence$13).Lfastparse_ParsingRun__f_cut;
  var elem$1 = false;
  elem$1 = elem;
  $n(x1$5);
  var acc$macro$18 = $as_scm_Buffer($m_scm_Buffer$().empty__sc_SeqOps());
  var startIndex$macro$19 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
  var count$macro$20 = 0;
  var lastAgg$macro$25 = null;
  while (true) {
    $n(evidence$13).Lfastparse_ParsingRun__f_cut = false;
    $m_Lfastparse_package$();
    $m_Lfastparse_Implicits$Sequencer$();
    var preLhsIndex$macro$2 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
    var input$macro$11 = $n(evidence$13).Lfastparse_ParsingRun__f_input;
    $m_Lfastparse_package$();
    $m_Lfastparse_package$();
    var startPos = $n(evidence$13).Lfastparse_ParsingRun__f_index;
    var startCut = $n(evidence$13).Lfastparse_ParsingRun__f_cut;
    var oldNoCut = $n(evidence$13).Lfastparse_ParsingRun__f_noDropBuffer;
    $n(evidence$13).Lfastparse_ParsingRun__f_noDropBuffer = true;
    var startTerminals = $n(evidence$13).Lfastparse_ParsingRun__f_failureTerminalAggregate;
    $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$13);
    $n(evidence$13).Lfastparse_ParsingRun__f_noDropBuffer = oldNoCut;
    var msg = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
    var res = ($n(evidence$13).Lfastparse_ParsingRun__f_isSuccess ? $n(evidence$13).freshFailure__I__Lfastparse_ParsingRun(startPos) : $n(evidence$13).freshSuccessUnit__I__Lfastparse_ParsingRun(startPos));
    if ($n(evidence$13).Lfastparse_ParsingRun__f_verboseFailures) {
      $n(evidence$13).Lfastparse_ParsingRun__f_failureTerminalAggregate = startTerminals;
      $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate = $m_Lfastparse_internal_Msgs$().Lfastparse_internal_Msgs$__f_empty;
      $n(evidence$13).setMsg__I__F0__V(startPos, new $c_sjsr_AnonFunction0(((msg) => (() => {
        var this$9 = $n(msg);
        return ("!" + $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$9.Lfastparse_internal_Msgs__f_value))
      }))(msg)))
    };
    $n(res).Lfastparse_ParsingRun__f_cut = startCut;
    if ($n(evidence$13).Lfastparse_ParsingRun__f_isSuccess) {
      var postLhsIndex$macro$3 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
      var lhsAggregate$macro$6 = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var lhsMsg$macro$9 = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
      if (((postLhsIndex$macro$3 > preLhsIndex$macro$2) && $n(evidence$13).checkForDrop__Z())) {
        $n(input$macro$11)
      };
      $n(evidence$13);
      if ((!((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$13).Lfastparse_ParsingRun__f_cut))) {
        var preRhsIndex$macro$4 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
        $m_Lreactbuild_project_generator_markdown_MarkdownParser$().line__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$13);
        var rhsAggregate$macro$7 = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
        var rhsMsg$macro$8 = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
        if ((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess)) {
          /*<skip>*/
        } else {
          var postRhsIndex$macro$5 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
          var rhsMadeProgress$macro$10 = (postRhsIndex$macro$5 > preRhsIndex$macro$4);
          var nextIndex$macro$13 = (((!rhsMadeProgress$macro$10) && $n(input$macro$11).isReachable__I__Z(postRhsIndex$macro$5)) ? postLhsIndex$macro$3 : postRhsIndex$macro$5);
          if ((rhsMadeProgress$macro$10 && $n(evidence$13).checkForDrop__Z())) {
            $n(input$macro$11)
          };
          var $$x1 = $n(evidence$13);
          var v = $as_s_Product($n(evidence$13).Lfastparse_ParsingRun__f_successValue);
          $n($$x1).freshSuccess__O__I__Lfastparse_ParsingRun(v, nextIndex$macro$13)
        };
        if ($n(evidence$13).Lfastparse_ParsingRun__f_verboseFailures) {
          $n(evidence$13).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$2, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$9, rhsMsg$macro$8), $n(lhsAggregate$macro$6).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$7), (preRhsIndex$macro$4 === $n(evidence$13).Lfastparse_ParsingRun__f_traceIndex))
        }
      }
    };
    var parsedMsg$macro$24 = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
    var parsedAgg$macro$26 = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
    elem$1 = (!(!(elem$1 | $n(evidence$13).Lfastparse_ParsingRun__f_cut)));
    if ((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess)) {
      if ($n(evidence$13).Lfastparse_ParsingRun__f_cut) {
        var res$1 = evidence$13
      } else {
        var $$x2 = $n(evidence$13);
        $n(x1$5);
        var this$12 = $n(acc$macro$18);
        var res$1 = $n($$x2).freshSuccess__O__I__Z__Lfastparse_ParsingRun($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$12), startIndex$macro$19, elem$1)
      };
      if ($n(evidence$13).Lfastparse_ParsingRun__f_verboseFailures) {
        var $$x6 = $n(evidence$13);
        var $$x5 = startIndex$macro$19;
        var $$x4 = new $c_sjsr_AnonFunction0(((parsedMsg$macro$24) => (() => {
          var this$13 = $n(parsedMsg$macro$24);
          return ($m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$13.Lfastparse_internal_Msgs__f_value) + ".rep")
        }))(parsedMsg$macro$24));
        if ((lastAgg$macro$25 === null)) {
          var $$x3 = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate
        } else {
          var rassoc$2 = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
          var $$x3 = $n(lastAgg$macro$25).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$2)
        };
        $n($$x6).aggregateMsg__I__F0__Lfastparse_internal_Msgs__V($$x5, $$x4, $$x3)
      };
      break
    } else {
      var beforeSepIndex$macro$21 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
      $n(x1$5);
      var t = $as_s_Product($n(evidence$13).Lfastparse_ParsingRun__f_successValue);
      var this$15 = $n(acc$macro$18);
      this$15.addOne__O__scm_Growable(t);
      $n(evidence$13).Lfastparse_ParsingRun__f_cut = false;
      if (($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() !== $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$())) {
        $m_Lfastparse_internal_Util$().consumeWhitespace__F1__Lfastparse_ParsingRun__V($m_Lfastparse_NoWhitespace$noWhitespaceImplicit$(), evidence$13)
      };
      if ((!((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$13).Lfastparse_ParsingRun__f_cut))) {
        $n(evidence$13).Lfastparse_ParsingRun__f_cut = false;
        var temp$count$macro$20 = ((1 + count$macro$20) | 0);
        startIndex$macro$19 = beforeSepIndex$macro$21;
        count$macro$20 = temp$count$macro$20;
        lastAgg$macro$25 = parsedAgg$macro$26;
        continue
      };
      break
    }
  };
  if ((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess)) {
    var x1$6 = evidence$13
  } else {
    var postLhsIndex$macro$29 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
    var lhsAggregate$macro$32 = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
    var lhsMsg$macro$35 = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
    if (((postLhsIndex$macro$29 > preLhsIndex$macro$28) && $n(evidence$13).checkForDrop__Z())) {
      $n(input$macro$37)
    };
    var lhsValue$macro$38 = $n(evidence$13).Lfastparse_ParsingRun__f_successValue;
    if (((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess) && $n(evidence$13).Lfastparse_ParsingRun__f_cut)) {
      var x1$6 = evidence$13
    } else {
      var preRhsIndex$macro$30 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
      $m_Lfastparse_package$().End__Lfastparse_ParsingRun__Lfastparse_ParsingRun(evidence$13);
      var rhsAggregate$macro$33 = $n(evidence$13).Lfastparse_ParsingRun__f_failureGroupAggregate;
      var rhsMsg$macro$34 = $n(evidence$13).Lfastparse_ParsingRun__f_shortParserMsg;
      if ((!$n(evidence$13).Lfastparse_ParsingRun__f_isSuccess)) {
        var res$macro$40 = evidence$13
      } else {
        var postRhsIndex$macro$31 = $n(evidence$13).Lfastparse_ParsingRun__f_index;
        var rhsMadeProgress$macro$36 = (postRhsIndex$macro$31 > preRhsIndex$macro$30);
        var nextIndex$macro$39 = (((!rhsMadeProgress$macro$36) && $n(input$macro$37).isReachable__I__Z(postRhsIndex$macro$31)) ? postLhsIndex$macro$29 : postRhsIndex$macro$31);
        if ((rhsMadeProgress$macro$36 && $n(evidence$13).checkForDrop__Z())) {
          $n(input$macro$37)
        };
        var $$x7 = $n(evidence$13);
        $n(x1$3);
        var t$1 = $as_sci_Seq(lhsValue$macro$38);
        $n(evidence$13);
        var res$macro$40 = $n($$x7).freshSuccess__O__I__Lfastparse_ParsingRun(t$1, nextIndex$macro$39)
      };
      if ($n(evidence$13).Lfastparse_ParsingRun__f_verboseFailures) {
        $n(evidence$13).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(preLhsIndex$macro$28, $m_Lfastparse_internal_Util$().joinBinOp__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(lhsMsg$macro$35, rhsMsg$macro$34), $n(lhsAggregate$macro$32).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rhsAggregate$macro$33), (preRhsIndex$macro$30 === $n(evidence$13).Lfastparse_ParsingRun__f_traceIndex))
      };
      var x1$6 = res$macro$40
    }
  };
  if (instrument) {
    $n($n(evidence$13).Lfastparse_ParsingRun__f_instrument).afterParse__T__I__Z__V(new $c_Lsourcecode_Name("root").Lsourcecode_Name__f_value, $n(x1$6).Lfastparse_ParsingRun__f_index, $n(x1$6).Lfastparse_ParsingRun__f_isSuccess)
  };
  if ($n(x1$6).Lfastparse_ParsingRun__f_verboseFailures) {
    var $$x8 = $n(x1$6);
    $m_sci_List$();
    var array = [new $c_Lfastparse_internal_Lazy(new $c_sjsr_AnonFunction0((() => new $c_Lsourcecode_Name("root").Lsourcecode_Name__f_value)))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x8).aggregateMsg__I__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs__Z__V(startIndex, new $c_Lfastparse_internal_Msgs($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)), $n(x1$6).Lfastparse_ParsingRun__f_failureGroupAggregate, (startIndex < $n(x1$6).Lfastparse_ParsingRun__f_traceIndex));
    if ((!$n(x1$6).Lfastparse_ParsingRun__f_isSuccess)) {
      var $$x9 = $n(x1$6);
      var self = new $c_Lsourcecode_Name("root").Lsourcecode_Name__f_value;
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, startIndex);
      var this$25 = $n($n(x1$6).Lfastparse_ParsingRun__f_failureStack);
      $$x9.Lfastparse_ParsingRun__f_failureStack = new $c_sci_$colon$colon(rassoc$1, this$25)
    }
  };
  return x1$6
});
var $d_Lreactbuild_project_generator_markdown_MarkdownParser$ = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_MarkdownParser$: 0
}, false, "reactbuild.project.generator.markdown.MarkdownParser$", {
  Lreactbuild_project_generator_markdown_MarkdownParser$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_markdown_MarkdownParser$.prototype.$classData = $d_Lreactbuild_project_generator_markdown_MarkdownParser$;
var $n_Lreactbuild_project_generator_markdown_MarkdownParser$;
function $m_Lreactbuild_project_generator_markdown_MarkdownParser$() {
  if ((!$n_Lreactbuild_project_generator_markdown_MarkdownParser$)) {
    $n_Lreactbuild_project_generator_markdown_MarkdownParser$ = new $c_Lreactbuild_project_generator_markdown_MarkdownParser$()
  };
  return $n_Lreactbuild_project_generator_markdown_MarkdownParser$
}
function $p_Lreactbuild_project_generator_markdown_MarkdownRender$__loop$1__sci_List__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, acc, input) {
  while (true) {
    var x1 = input;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var this$1 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var ns = acc;
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$1, null, ns)
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $as_Lreactbuild_project_generator_markdown_MarkdownBlock($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      if ((head instanceof $c_Lreactbuild_project_generator_markdown_Header)) {
        var x2 = $as_Lreactbuild_project_generator_markdown_Header(head);
        var level = $n(x2).Lreactbuild_project_generator_markdown_Header__f_level;
        var body = $n(x2).Lreactbuild_project_generator_markdown_Header__f_body;
        var this$8 = $n(acc);
        var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        var this$2 = $n($thiz.Lreactbuild_project_generator_markdown_MarkdownRender$__f_headerLevels);
        var $$x1 = $n($as_Ljapgolly_scalajs_react_vdom_HtmlTagOf($f_sc_LinearSeqOps__apply__I__O(this$2, level))).Ljapgolly_scalajs_react_vdom_HtmlTagOf__f_name;
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = $n(body).Lreactbuild_project_generator_markdown_MarkdownText__f_v;
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
        var elem = $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
        var temp$acc = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$8, elem));
        acc = temp$acc;
        input = tail
      } else if ((head instanceof $c_Lreactbuild_project_generator_markdown_OL)) {
        var x3$2 = $as_Lreactbuild_project_generator_markdown_OL(head);
        var level$2 = $n(x3$2).Lreactbuild_project_generator_markdown_OL__f_level;
        var body$2 = $n(x3$2).Lreactbuild_project_generator_markdown_OL__f_body;
        var this$9 = $n(tail);
        var b = new $c_scm_ListBuffer();
        var these = this$9;
        while (true) {
          if ((!$n(these).isEmpty__Z())) {
            var arg1 = $n(these).head__O();
            var x0$1 = $as_Lreactbuild_project_generator_markdown_MarkdownBlock(arg1);
            matchEnd7: {
              var $$x3;
              if ((x0$1 instanceof $c_Lreactbuild_project_generator_markdown_OL)) {
                var x2$1 = $as_Lreactbuild_project_generator_markdown_OL(x0$1);
                var p3 = $n(x2$1).Lreactbuild_project_generator_markdown_OL__f_level;
                if ((level$2 === p3)) {
                  var $$x3 = true;
                  break matchEnd7
                }
              };
              var $$x3 = false
            }
          } else {
            var $$x3 = false
          };
          if ($$x3) {
            var elem$1 = $n(these).head__O();
            b.addOne__O__scm_ListBuffer(elem$1);
            these = $as_sci_List($n(these).tail__O())
          } else {
            break
          }
        };
        var others = $n(b.toList__sci_List()).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1());
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var this$12 = $n(others);
        var as = this$12.prepended__O__sci_List(body$2);
        var array$2 = [$n($$x4).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((body$3$2) => {
          var body$3 = $as_Lreactbuild_project_generator_markdown_MarkdownText(body$3$2);
          var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Lreactbuild_project_generator_markdown_MarkdownRender$();
          var v$1 = $n(body$3).Lreactbuild_project_generator_markdown_MarkdownText__f_v;
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
          return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
        })))];
        var r = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ol", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
        var this$25 = $n(acc);
        var temp$acc$2 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$25, r));
        var this$27 = $n(tail);
        var this$26 = $n(others);
        var n = this$26.length__I();
        var temp$input$2 = $as_sci_List($p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$27, n, this$27));
        acc = temp$acc$2;
        input = temp$input$2
      } else if ((head instanceof $c_Lreactbuild_project_generator_markdown_UL)) {
        var x4 = $as_Lreactbuild_project_generator_markdown_UL(head);
        var level$3 = $n(x4).Lreactbuild_project_generator_markdown_UL__f_level;
        var body$4 = $n(x4).Lreactbuild_project_generator_markdown_UL__f_body;
        var this$28 = $n(tail);
        var b$1 = new $c_scm_ListBuffer();
        var these$1 = this$28;
        while (true) {
          if ((!$n(these$1).isEmpty__Z())) {
            var arg1$1 = $n(these$1).head__O();
            var x0$2 = $as_Lreactbuild_project_generator_markdown_MarkdownBlock(arg1$1);
            matchEnd7$1: {
              var $$x7;
              if ((x0$2 instanceof $c_Lreactbuild_project_generator_markdown_UL)) {
                var x2$2 = $as_Lreactbuild_project_generator_markdown_UL(x0$2);
                var p3$1 = $n(x2$2).Lreactbuild_project_generator_markdown_UL__f_level;
                if ((level$3 === p3$1)) {
                  var $$x7 = true;
                  break matchEnd7$1
                }
              };
              var $$x7 = false
            }
          } else {
            var $$x7 = false
          };
          if ($$x7) {
            var elem$2 = $n(these$1).head__O();
            b$1.addOne__O__scm_ListBuffer(elem$2);
            these$1 = $as_sci_List($n(these$1).tail__O())
          } else {
            break
          }
        };
        var others$2 = $n(b$1.toList__sci_List()).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2());
        var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x8 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var this$31 = $n(others$2);
        var as$1 = this$31.prepended__O__sci_List(body$4);
        var array$4 = [$n($$x8).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((body$5$2) => {
          var body$5 = $as_Lreactbuild_project_generator_markdown_MarkdownText(body$5$2);
          var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Lreactbuild_project_generator_markdown_MarkdownRender$();
          var v$2 = $n(body$5).Lreactbuild_project_generator_markdown_MarkdownText__f_v;
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
          return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
        })))];
        var r$2 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
        var this$44 = $n(acc);
        var temp$acc$3 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$44, r$2));
        var this$46 = $n(tail);
        var this$45 = $n(others$2);
        var n$1 = this$45.length__I();
        var temp$input$3 = $as_sci_List($p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$46, n$1, this$46));
        acc = temp$acc$3;
        input = temp$input$3
      } else if ((head instanceof $c_Lreactbuild_project_generator_markdown_Paragraph)) {
        var x5 = $as_Lreactbuild_project_generator_markdown_Paragraph(head);
        var lines = $n(x5).Lreactbuild_project_generator_markdown_Paragraph__f_lines;
        var this$58 = $n(acc);
        var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var as$2 = $as_sc_IterableOnce($n(lines).map__F1__O(new $c_sjsr_AnonFunction1(((text$2) => {
          var text = $as_Lreactbuild_project_generator_markdown_MarkdownText(text$2);
          $m_Lreactbuild_project_generator_markdown_MarkdownRender$();
          return $n(text).Lreactbuild_project_generator_markdown_MarkdownText__f_v
        }))));
        var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        var this$51 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        var sep = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_vdom_HtmlTags__br__T(this$51), $m_sci_Nil$());
        var f = new $c_sjsr_AnonFunction1(((v$2$1) => {
          var v$3 = $as_T(v$2$1);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
        }));
        var array$5 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$2, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f)];
        var elem$3 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("p", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
        var temp$acc$4 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$58, elem$3));
        acc = temp$acc$4;
        input = tail
      } else {
        throw new $c_s_MatchError(head)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_MarkdownRender$() {
  this.Lreactbuild_project_generator_markdown_MarkdownRender$__f_headerLevels = null;
  $n_Lreactbuild_project_generator_markdown_MarkdownRender$ = this;
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "h1")), new $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "h2")), new $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "h3")), new $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "h4")), new $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "h5")), new $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "h6"))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_project_generator_markdown_MarkdownRender$__f_headerLevels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
}
$c_Lreactbuild_project_generator_markdown_MarkdownRender$.prototype = new $h_O();
$c_Lreactbuild_project_generator_markdown_MarkdownRender$.prototype.constructor = $c_Lreactbuild_project_generator_markdown_MarkdownRender$;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_MarkdownRender$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_MarkdownRender$.prototype = $c_Lreactbuild_project_generator_markdown_MarkdownRender$.prototype;
var $d_Lreactbuild_project_generator_markdown_MarkdownRender$ = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_MarkdownRender$: 0
}, false, "reactbuild.project.generator.markdown.MarkdownRender$", {
  Lreactbuild_project_generator_markdown_MarkdownRender$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_markdown_MarkdownRender$.prototype.$classData = $d_Lreactbuild_project_generator_markdown_MarkdownRender$;
var $n_Lreactbuild_project_generator_markdown_MarkdownRender$;
function $m_Lreactbuild_project_generator_markdown_MarkdownRender$() {
  if ((!$n_Lreactbuild_project_generator_markdown_MarkdownRender$)) {
    $n_Lreactbuild_project_generator_markdown_MarkdownRender$ = new $c_Lreactbuild_project_generator_markdown_MarkdownRender$()
  };
  return $n_Lreactbuild_project_generator_markdown_MarkdownRender$
}
/** @constructor */
function $c_Lreactbuild_project_generator_paper_NotPrintable$() {
  this.Lreactbuild_project_generator_paper_NotPrintable$__f_notPrintable = null;
  $n_Lreactbuild_project_generator_paper_NotPrintable$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_generator_paper_NotPrintable$__f_notPrintable = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$7 = $n(dsl);
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x = $n(this$6.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
    var x$1 = $as_Lscalacss_internal_Media$Query(x);
    var $$x1 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$1), this$7);
    $n(dsl);
    var this$9 = $m_Lscalacss_internal_Attrs$display$();
    var v$1 = $m_Lscalacss_internal_Literal$Typed$none$();
    var v$2 = v$1.Lscalacss_internal_Literal__f_value;
    var array = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$9.Lscalacss_internal_Attrs$display$__f_attr, v$2)))];
    var x$2 = $$x1.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$1 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$2)];
    return $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })), new $c_Lsourcecode_Name("notPrintable"))
}
$c_Lreactbuild_project_generator_paper_NotPrintable$.prototype = new $h_O();
$c_Lreactbuild_project_generator_paper_NotPrintable$.prototype.constructor = $c_Lreactbuild_project_generator_paper_NotPrintable$;
/** @constructor */
function $h_Lreactbuild_project_generator_paper_NotPrintable$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_paper_NotPrintable$.prototype = $c_Lreactbuild_project_generator_paper_NotPrintable$.prototype;
var $d_Lreactbuild_project_generator_paper_NotPrintable$ = new $TypeData().initClass({
  Lreactbuild_project_generator_paper_NotPrintable$: 0
}, false, "reactbuild.project.generator.paper.NotPrintable$", {
  Lreactbuild_project_generator_paper_NotPrintable$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_paper_NotPrintable$.prototype.$classData = $d_Lreactbuild_project_generator_paper_NotPrintable$;
var $n_Lreactbuild_project_generator_paper_NotPrintable$;
function $m_Lreactbuild_project_generator_paper_NotPrintable$() {
  if ((!$n_Lreactbuild_project_generator_paper_NotPrintable$)) {
    $n_Lreactbuild_project_generator_paper_NotPrintable$ = new $c_Lreactbuild_project_generator_paper_NotPrintable$()
  };
  return $n_Lreactbuild_project_generator_paper_NotPrintable$
}
/** @constructor */
function $c_Lreactbuild_project_generator_paper_Page$() {
  this.Lreactbuild_project_generator_paper_Page$__f_documentPaperPage = null;
  this.Lreactbuild_project_generator_paper_Page$__f_documentPageLayout = null;
  $n_Lreactbuild_project_generator_paper_Page$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_generator_paper_Page$__f_documentPaperPage = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x17 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$7 = $n(dsl);
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x = $n(this$6.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$());
    var x$1 = $as_Lscalacss_internal_Media$Query(x);
    var $$x16 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$1), this$7);
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$width$();
    var $$x15 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "var(--paper-width)")));
    $n(dsl);
    $n(dsl);
    var a$1 = $m_Lscalacss_internal_Attrs$height$();
    var $$x14 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "var(--paper-height)")));
    $n(dsl);
    var a$2 = $m_Lcom_iz2use_react_style_package$().zoom__Lcom_iz2use_react_style_ExtendedStyles$zoom$();
    var $$x13 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV($n(a$2).Lcom_iz2use_react_style_ExtendedStyles$zoom$__f_attr, "var(--paper-zoom)")));
    $n(dsl);
    var this$20 = $m_Lscalacss_internal_Attrs$display$();
    var $$x12 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$20.Lscalacss_internal_Attrs$display$__f_attr, "inline-block")));
    $n(dsl);
    var this$30 = $m_Lscalacss_internal_Attrs$margin$();
    $n(dsl);
    $n(dsl);
    var this$ = 4;
    var u = $m_Lscalacss_internal_LengthUnit$em$();
    var f$1 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2);
      return $n(x$1$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var all = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$1 = $n(all).Lscalacss_internal_ValueT__f_value;
    var $$x11 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$30.Lscalacss_internal_Attrs$margin$__f_attr, v$1)));
    $n(dsl);
    $n(dsl);
    var a$3 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
    var $$x10 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$3, "1em 1em 2em #555")));
    $n(dsl);
    var this$35 = $m_Lscalacss_internal_Attrs$backgroundColor$();
    var $$x9 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$35.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "white")));
    $n(dsl);
    var this$37 = $m_Lscalacss_internal_Attrs$color$();
    var array = [$$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$37.Lscalacss_internal_Attrs$color$__f_attr, "black")))];
    var x$2 = $$x16.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x8 = new $c_Lscalacss_internal_DslBase$ToStyle(x$2);
    $n(dsl);
    var this$45 = $n(dsl);
    $n(dsl);
    var this$44 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x$4 = $n(this$44.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
    var x$3$1 = $as_Lscalacss_internal_Media$Query(x$4);
    var $$x7 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$3$1), this$45);
    $n(dsl);
    var this$54 = $m_Lscalacss_internal_Attrs$width$();
    $n(dsl);
    $n(dsl);
    var this$$1 = 100;
    var f$3 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$1);
    $n(dsl);
    $n(dsl);
    var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4$1 = $as_Lscalacss_internal_Percentage(x$4$2);
      return $n(x$4$1).value__T()
    })));
    $n(dsl);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$3 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$3)
    }));
    var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
    var r$1 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
    var v$2 = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$3);
    var v$3 = $n(v$2).Lscalacss_internal_ValueT__f_value;
    var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$54.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$3)));
    $n(dsl);
    var this$63 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl);
    $n(dsl);
    var this$$2 = 100;
    var f$5 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$2);
    $n(dsl);
    $n(dsl);
    var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$1) => {
      var x$4$3 = $as_Lscalacss_internal_Percentage(x$4$2$1);
      return $n(x$4$3).value__T()
    })));
    $n(dsl);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
      var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$2);
      return $n(x$1$4)
    }));
    var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
    var r$2 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
    var v$4 = $n(r$2).apply__O__Lscalacss_internal_ValueT(f$5);
    var v$5 = $n(v$4).Lscalacss_internal_ValueT__f_value;
    var array$1 = [$$x6, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$63.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$5)))];
    var x$5 = $$x7.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle(x$5);
    $n(dsl);
    var this$70 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$6 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$7 = v$6.Lscalacss_internal_Literal__f_value;
    var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$70.Lscalacss_internal_Attrs$overflow$__f_attr, v$7)));
    $n(dsl);
    var this$72 = $m_Lscalacss_internal_Attrs$pageBreakInside$();
    var $$x3 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$72.Lscalacss_internal_Attrs$pageBreakInside$__f_attr, "avoid")));
    $n(dsl);
    var this$73 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
    var p = $m_Lscalacss_internal_Pseudo$FirstChild$();
    var $$x2 = this$73.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p);
    var this$75 = $m_s_$less$colon$less$();
    var $$x1 = $n($n(dsl).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x2, this$75.s_$less$colon$less$__f_singleton));
    $n(dsl);
    var this$77 = $m_Lscalacss_internal_Attrs$pageBreakBefore$();
    var array$2 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$77.Lscalacss_internal_Attrs$pageBreakBefore$__f_attr, "avoid")))];
    var x$6 = $n($$x1).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$3 = [$$x8, $$x5, $$x4, $$x3, new $c_Lscalacss_internal_DslBase$ToStyle(x$6)];
    return $as_sci_Seq($n($$x17).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)))
  })), new $c_Lsourcecode_Name("documentPaperPage"));
  var this$88 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$8 = "div";
  this.Lreactbuild_project_generator_paper_Page$__f_documentPageLayout = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$88, v$8)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$3$2) => {
    var dsl$3 = $as_Lscalacss_internal_DslBase(dsl$3$2);
    var $$x29 = $m_s_package$().s_package$__f_Seq;
    $n(dsl$3);
    var this$98 = $m_Lscalacss_internal_Attrs$top$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$3 = 0;
    var u$1 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$7 = new $c_Lscalacss_internal_Length(this$$3, u$1);
    $n(dsl$3);
    $n(dsl$3);
    var ab$3 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
      var x$3$3 = $as_Lscalacss_internal_Length(x$3$2$1);
      return $n(x$3$3).value__T()
    })));
    $n(dsl$3);
    var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
      var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$3);
      return $n(x$1$5)
    }));
    var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
    var r$3 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
    var v$9 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$7);
    var v$10 = $n(v$9).Lscalacss_internal_ValueT__f_value;
    var $$x28 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$98.Lscalacss_internal_Attrs$top$__f_attr, v$10)));
    $n(dsl$3);
    var this$108 = $m_Lscalacss_internal_Attrs$left$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$4 = 0;
    var u$2 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$9 = new $c_Lscalacss_internal_Length(this$$4, u$2);
    $n(dsl$3);
    $n(dsl$3);
    var ab$4 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$2) => {
      var x$3$4 = $as_Lscalacss_internal_Length(x$3$2$2);
      return $n(x$3$4).value__T()
    })));
    $n(dsl$3);
    var f$8 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
      var x$1$6 = $as_Lscalacss_internal_ValueT(x$1$2$4);
      return $n(x$1$6)
    }));
    var bc$4 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$8);
    var r$4 = $n(ab$4).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$4);
    var v$11 = $n(r$4).apply__O__Lscalacss_internal_ValueT(f$9);
    var v$12 = $n(v$11).Lscalacss_internal_ValueT__f_value;
    var $$x27 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$108.Lscalacss_internal_Attrs$left$__f_attr, v$12)));
    $n(dsl$3);
    var this$111 = $n(dsl$3);
    $n(dsl$3);
    var this$110 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x$7 = $n(this$110.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$());
    var x$8 = $as_Lscalacss_internal_Media$Query(x$7);
    var $$x26 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl$3).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$8), this$111);
    $n(dsl$3);
    var this$120 = $m_Lscalacss_internal_Attrs$width$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$5 = 100;
    var f$11 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$5);
    $n(dsl$3);
    $n(dsl$3);
    var ab$5 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$2) => {
      var x$4$4 = $as_Lscalacss_internal_Percentage(x$4$2$2);
      return $n(x$4$4).value__T()
    })));
    $n(dsl$3);
    var f$10 = new $c_sjsr_AnonFunction1(((x$1$2$5) => {
      var x$1$7 = $as_Lscalacss_internal_ValueT(x$1$2$5);
      return $n(x$1$7)
    }));
    var bc$5 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$10);
    var r$5 = $n(ab$5).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$5);
    var v$13 = $n(r$5).apply__O__Lscalacss_internal_ValueT(f$11);
    var v$14 = $n(v$13).Lscalacss_internal_ValueT__f_value;
    var $$x25 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$120.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$14)));
    $n(dsl$3);
    var this$129 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$6 = 100;
    var f$13 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$6);
    $n(dsl$3);
    $n(dsl$3);
    var ab$6 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$3) => {
      var x$4$5 = $as_Lscalacss_internal_Percentage(x$4$2$3);
      return $n(x$4$5).value__T()
    })));
    $n(dsl$3);
    var f$12 = new $c_sjsr_AnonFunction1(((x$1$2$6) => {
      var x$1$8 = $as_Lscalacss_internal_ValueT(x$1$2$6);
      return $n(x$1$8)
    }));
    var bc$6 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$12);
    var r$6 = $n(ab$6).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$6);
    var v$15 = $n(r$6).apply__O__Lscalacss_internal_ValueT(f$13);
    var v$16 = $n(v$15).Lscalacss_internal_ValueT__f_value;
    var array$4 = [$$x25, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$129.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$16)))];
    var x$9 = $$x26.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x24 = new $c_Lscalacss_internal_DslBase$ToStyle(x$9);
    $n(dsl$3);
    var this$137 = $n(dsl$3);
    $n(dsl$3);
    var this$136 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var x$10 = $n(this$136.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
    var x$3$5 = $as_Lscalacss_internal_Media$Query(x$10);
    var $$x23 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl$3).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$3$5), this$137);
    $n(dsl$3);
    var this$147 = $m_Lscalacss_internal_Attrs$width$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$7 = 100;
    var u$3 = $m_Lscalacss_internal_LengthUnit$vw$();
    var f$15 = new $c_Lscalacss_internal_Length(this$$7, u$3);
    $n(dsl$3);
    $n(dsl$3);
    var ab$7 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$3) => {
      var x$3$6 = $as_Lscalacss_internal_Length(x$3$2$3);
      return $n(x$3$6).value__T()
    })));
    $n(dsl$3);
    var f$14 = new $c_sjsr_AnonFunction1(((x$1$2$7) => {
      var x$1$9 = $as_Lscalacss_internal_ValueT(x$1$2$7);
      return $n(x$1$9)
    }));
    var bc$7 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$14);
    var r$7 = $n(ab$7).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$7);
    var v$17 = $n(r$7).apply__O__Lscalacss_internal_ValueT(f$15);
    var v$18 = $n(v$17).Lscalacss_internal_ValueT__f_value;
    var $$x22 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$147.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$18)));
    $n(dsl$3);
    var this$157 = $m_Lscalacss_internal_Attrs$height$();
    $n(dsl$3);
    $n(dsl$3);
    var this$$8 = 100;
    var u$4 = $m_Lscalacss_internal_LengthUnit$vh$();
    var f$17 = new $c_Lscalacss_internal_Length(this$$8, u$4);
    $n(dsl$3);
    $n(dsl$3);
    var ab$8 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$4) => {
      var x$3$7 = $as_Lscalacss_internal_Length(x$3$2$4);
      return $n(x$3$7).value__T()
    })));
    $n(dsl$3);
    var f$16 = new $c_sjsr_AnonFunction1(((x$1$2$8) => {
      var x$1$10 = $as_Lscalacss_internal_ValueT(x$1$2$8);
      return $n(x$1$10)
    }));
    var bc$8 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$16);
    var r$8 = $n(ab$8).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$8);
    var v$19 = $n(r$8).apply__O__Lscalacss_internal_ValueT(f$17);
    var v$20 = $n(v$19).Lscalacss_internal_ValueT__f_value;
    var array$5 = [$$x22, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$157.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$20)))];
    var x$11 = $$x23.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x21 = new $c_Lscalacss_internal_DslBase$ToStyle(x$11);
    $n(dsl$3);
    var this$164 = $m_Lscalacss_internal_Attrs$overflow$();
    var v$21 = $m_Lscalacss_internal_Literal$Typed$hidden$();
    var v$22 = v$21.Lscalacss_internal_Literal__f_value;
    var $$x20 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$164.Lscalacss_internal_Attrs$overflow$__f_attr, v$22)));
    $n(dsl$3);
    var this$166 = $m_Lscalacss_internal_Attrs$display$();
    var $$x19 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$166.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl$3);
    var this$168 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x18 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$168.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")));
    $n(dsl$3);
    var this$170 = $m_Lscalacss_internal_Attrs$boxSizing$();
    var array$6 = [$$x28, $$x27, $$x24, $$x21, $$x20, $$x19, $$x18, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl$3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$170.Lscalacss_internal_Attrs$boxSizing$__f_attr, "border-box")))];
    return $as_sci_Seq($n($$x29).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6)))
  })), new $c_Lsourcecode_Name("documentPageLayout"))
}
$c_Lreactbuild_project_generator_paper_Page$.prototype = new $h_O();
$c_Lreactbuild_project_generator_paper_Page$.prototype.constructor = $c_Lreactbuild_project_generator_paper_Page$;
/** @constructor */
function $h_Lreactbuild_project_generator_paper_Page$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_paper_Page$.prototype = $c_Lreactbuild_project_generator_paper_Page$.prototype;
$c_Lreactbuild_project_generator_paper_Page$.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(xs) {
  var $$x1 = $n(this.Lreactbuild_project_generator_paper_Page$__f_documentPaperPage);
  var array = [$n(this.Lreactbuild_project_generator_paper_Page$__f_documentPageLayout).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(xs)];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lreactbuild_project_generator_paper_Page$ = new $TypeData().initClass({
  Lreactbuild_project_generator_paper_Page$: 0
}, false, "reactbuild.project.generator.paper.Page$", {
  Lreactbuild_project_generator_paper_Page$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_paper_Page$.prototype.$classData = $d_Lreactbuild_project_generator_paper_Page$;
var $n_Lreactbuild_project_generator_paper_Page$;
function $m_Lreactbuild_project_generator_paper_Page$() {
  if ((!$n_Lreactbuild_project_generator_paper_Page$)) {
    $n_Lreactbuild_project_generator_paper_Page$ = new $c_Lreactbuild_project_generator_paper_Page$()
  };
  return $n_Lreactbuild_project_generator_paper_Page$
}
/** @constructor */
function $c_Lreactbuild_project_generator_paper_PrintOnly$() {
  this.Lreactbuild_project_generator_paper_PrintOnly$__f_printOnly = null;
  $n_Lreactbuild_project_generator_paper_PrintOnly$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_generator_paper_PrintOnly$__f_printOnly = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$8 = $n(dsl);
    $n(dsl);
    var this$7 = new $c_Lscalacss_internal_DslBase$MediaQueryNeedType($m_Lscalacss_internal_Media$Not$());
    var x = $n(this$7.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
    var x$1 = $as_Lscalacss_internal_Media$Query(x);
    var $$x1 = new $c_Lscalacss_internal_DslBase$DslCond($n(dsl).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$1), this$8);
    $n(dsl);
    var this$10 = $m_Lscalacss_internal_Attrs$display$();
    var v$1 = $m_Lscalacss_internal_Literal$Typed$none$();
    var v$2 = v$1.Lscalacss_internal_Literal__f_value;
    var array = [new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$10.Lscalacss_internal_Attrs$display$__f_attr, v$2)))];
    var x$2 = $$x1.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$1 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$2)];
    return $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })), new $c_Lsourcecode_Name("printOnly"))
}
$c_Lreactbuild_project_generator_paper_PrintOnly$.prototype = new $h_O();
$c_Lreactbuild_project_generator_paper_PrintOnly$.prototype.constructor = $c_Lreactbuild_project_generator_paper_PrintOnly$;
/** @constructor */
function $h_Lreactbuild_project_generator_paper_PrintOnly$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_paper_PrintOnly$.prototype = $c_Lreactbuild_project_generator_paper_PrintOnly$.prototype;
var $d_Lreactbuild_project_generator_paper_PrintOnly$ = new $TypeData().initClass({
  Lreactbuild_project_generator_paper_PrintOnly$: 0
}, false, "reactbuild.project.generator.paper.PrintOnly$", {
  Lreactbuild_project_generator_paper_PrintOnly$: 1,
  O: 1
});
$c_Lreactbuild_project_generator_paper_PrintOnly$.prototype.$classData = $d_Lreactbuild_project_generator_paper_PrintOnly$;
var $n_Lreactbuild_project_generator_paper_PrintOnly$;
function $m_Lreactbuild_project_generator_paper_PrintOnly$() {
  if ((!$n_Lreactbuild_project_generator_paper_PrintOnly$)) {
    $n_Lreactbuild_project_generator_paper_PrintOnly$ = new $c_Lreactbuild_project_generator_paper_PrintOnly$()
  };
  return $n_Lreactbuild_project_generator_paper_PrintOnly$
}
function $is_Lreactbuild_project_notebook_Cell(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_notebook_Cell)))
}
function $as_Lreactbuild_project_notebook_Cell(obj) {
  return (($is_Lreactbuild_project_notebook_Cell(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.Cell"))
}
function $isArrayOf_Lreactbuild_project_notebook_Cell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_Cell)))
}
function $asArrayOf_Lreactbuild_project_notebook_Cell(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_Cell(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.Cell;", depth))
}
function $is_Lreactbuild_project_notebook_CellConfig(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_notebook_CellConfig)))
}
function $as_Lreactbuild_project_notebook_CellConfig(obj) {
  return (($is_Lreactbuild_project_notebook_CellConfig(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.CellConfig"))
}
function $isArrayOf_Lreactbuild_project_notebook_CellConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_CellConfig)))
}
function $asArrayOf_Lreactbuild_project_notebook_CellConfig(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_CellConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.CellConfig;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_notebook_Notebook$() {
  this.Lreactbuild_project_notebook_Notebook$__f_notebookContainer = null;
  this.Lreactbuild_project_notebook_Notebook$__f_notebookCell = null;
  this.Lreactbuild_project_notebook_Notebook$__f_context = null;
  this.Lreactbuild_project_notebook_Notebook$__f_component = null;
  $n_Lreactbuild_project_notebook_Notebook$ = this;
  var this$3 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v = "div";
  this.Lreactbuild_project_notebook_Notebook$__f_notebookContainer = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$3, v)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$6 = $m_Lscalacss_internal_Attrs$display$();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$6.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    $n(dsl);
    $n(dsl);
    var a = $m_Lscalacss_internal_Attrs$().gridTemplateRows__Lscalacss_internal_Attr();
    var array = [$$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "repeat(100%)")))];
    return $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })), new $c_Lsourcecode_Name("notebookContainer"));
  var this$15 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$1 = "div";
  this.Lreactbuild_project_notebook_Notebook$__f_notebookCell = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$15, v$1)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Lscalacss_internal_DslBase(x$1$2);
    return $m_s_package$().s_package$__f_Nil
  })), new $c_Lsourcecode_Name("notebookCell"));
  var this$16 = $m_Ljapgolly_scalajs_react_React$();
  this.Lreactbuild_project_notebook_Notebook$__f_context = $n(this$16.Ljapgolly_scalajs_react_React$__f_Context).apply__T__O__Ljapgolly_scalajs_react_feature_Context("Notebook", null);
  var this$79 = $m_Lcom_iz2use_react_hooks_package$();
  var this$19 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var initialState = new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_project_notebook_template_OpportunityStudy$().Lreactbuild_project_notebook_template_OpportunityStudy$__f_template));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$21 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$19, initialState, step)));
  var initialState$1 = new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_project_notebook_template_OpportunityStudy$().Lreactbuild_project_notebook_template_OpportunityStudy$__f_templateVersion));
  var this$20 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$20);
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$21, initialState$1, step$1));
  var $$x4 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api);
  var $$x3 = new $c_sjsr_AnonFunction0((() => {
    var this$23 = $n($m_s_Predef$().s_Predef$__f_Map);
    var elems = $m_sci_Nil$();
    return this$23.from__sc_IterableOnce__sci_Map(elems)
  }));
  var this$24 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$69 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x4.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x3, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$24))));
  var deps = new $c_sjsr_AnonFunction4(((x$2$2, template$2, version$2, x$3$2) => {
    $as_Lreactbuild_project_notebook_Notebook$Props(x$2$2);
    var template = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(template$2);
    var version = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(version$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$3$2);
    var this$25 = $n(template);
    var $$x5 = this$25.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var this$26 = $n(version);
    return $ct_T2__O__O__(new $c_T2(), $$x5, this$26.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])
  }));
  var create = new $c_sjsr_AnonFunction4(((props$2, template$3$2, version$3$2, data$2) => {
    var props = $as_Lreactbuild_project_notebook_Notebook$Props(props$2);
    var template$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(template$3$2);
    var version$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(version$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(data$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      $as_T2(x$4$2);
      var $$x18 = $m_Lreactbuild_analyze_cost_components_AutoScrollArea$();
      var $$x17 = $m_Lreactbuild_project_notebook_Notebook$().Lreactbuild_project_notebook_Notebook$__f_notebookContainer;
      var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var this$30 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
      var $$x15 = this$30.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$31 = $n(template$3);
      var v$2 = $n($as_Lreactbuild_project_notebook_NotebookTemplate(this$31.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])).Lreactbuild_project_notebook_NotebookTemplate__f_title;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$1 = [$$x15, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      var $$x14 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h1", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x11 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$41 = $n(version$3);
      var as = $n($n($as_Lreactbuild_project_notebook_NotebookTemplateVersion(this$41.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])).Lreactbuild_project_notebook_NotebookTemplateVersion__f_cells).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1());
      var this$44 = $m_s_$less$colon$less$();
      var array$2 = [$n($$x11).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$44.s_$less$colon$less$__f_singleton)];
      var array$3 = [$n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ol", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
      var $$x10 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
      var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x7 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("marginLeft")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x6 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$54 = $n(version$3);
      var as$1 = $n($as_Lreactbuild_project_notebook_NotebookTemplateVersion(this$54.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])).Lreactbuild_project_notebook_NotebookTemplateVersion__f_cells;
      var array$5 = [$$x7, $n($$x6).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((cellConfig$2) => {
        var cellConfig = $as_Lreactbuild_project_notebook_CellConfig(cellConfig$2);
        var $$x8 = $n($m_Lreactbuild_project_notebook_Notebook$().Lreactbuild_project_notebook_Notebook$__f_notebookCell);
        var array$4 = [$m_Lreactbuild_project_notebook_Notebook$().renderCell__Lreactbuild_project_notebook_CellConfig__Lreactbuild_project_notebook_Notebook$Props__Ljapgolly_scalajs_react_vdom_TagMod(cellConfig, props)];
        return $n($$x8).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
      })))];
      var array$6 = [$$x14, $$x10, $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
      var array$7 = [$n($$x17).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
      return $n($$x18).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
    }))
  }));
  var r = $m_Ljapgolly_scalajs_react_Reusability$().tuple2__F2__F2__F2($m_Lreactbuild_project_notebook_package$().Lreactbuild_project_notebook_package$__f_reuseNotebookTemplate, $m_Lreactbuild_project_notebook_package$().Lreactbuild_project_notebook_package$__f_reuseNotebookTemplateVersion);
  var this$68 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$68);
  var this$78 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$69, deps, create, r, step$2)));
  var f = new $c_sjsr_AnonFunction5(((props$3$2, template$4$2, version$4$2, data$3$2, memo$2) => {
    $as_Lreactbuild_project_notebook_Notebook$Props(props$3$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(template$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(version$4$2);
    var data$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(data$3$2);
    var memo = $as_Ljapgolly_scalajs_react_Reusable(memo$2);
    var this$70 = $n($m_Lreactbuild_project_notebook_Notebook$().Lreactbuild_project_notebook_Notebook$__f_context);
    var $$x19 = $n($f_Ljapgolly_scalajs_react_feature_Context__provide__O__Ljapgolly_scalajs_react_feature_Context$Provided(this$70, data$3));
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(memo).value__O());
    var this$72 = $n(u);
    var n = this$72.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$8 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    return $n($$x19).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  }));
  var this$77 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$77);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$78, f, step$3, s);
  this.Lreactbuild_project_notebook_Notebook$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$79, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.notebook.Notebook.component"))
}
$c_Lreactbuild_project_notebook_Notebook$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_Notebook$.prototype.constructor = $c_Lreactbuild_project_notebook_Notebook$;
/** @constructor */
function $h_Lreactbuild_project_notebook_Notebook$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_Notebook$.prototype = $c_Lreactbuild_project_notebook_Notebook$.prototype;
$c_Lreactbuild_project_notebook_Notebook$.prototype.apply__s_Option__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement = (function(template, instance) {
  var this$7 = $n($m_Lreactbuild_package$PageProps$().Lreactbuild_package$PageProps$__f_context);
  var f = new $c_sjsr_AnonFunction1(((pageProps$2) => {
    var pageProps = $as_Lreactbuild_package$PageProps(pageProps$2);
    var c = $m_Lreactbuild_project_notebook_Notebook$().Lreactbuild_project_notebook_Notebook$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lreactbuild_project_notebook_Notebook$Props(pageProps, template, instance);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
$c_Lreactbuild_project_notebook_Notebook$.prototype.renderCell__Lreactbuild_project_notebook_CellConfig__Lreactbuild_project_notebook_Notebook$Props__Ljapgolly_scalajs_react_vdom_TagMod = (function(cellConfig, props) {
  if ((cellConfig instanceof $c_Lreactbuild_project_notebook_Input)) {
    var x2 = $as_Lreactbuild_project_notebook_Input(cellConfig);
    var u = $m_Lreactbuild_project_notebook_renderer_InputRenderer$().apply__Lreactbuild_project_notebook_Input__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(x2);
    var this$2 = $n(u);
    var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  } else if ((cellConfig instanceof $c_Lreactbuild_project_notebook_Title)) {
    var x3 = $as_Lreactbuild_project_notebook_Title(cellConfig);
    var id = $n(x3).Lreactbuild_project_notebook_Title__f_id;
    var title = $n(x3).Lreactbuild_project_notebook_Title__f_title;
    var $$x3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$());
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$6 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "id");
    var a = $m_Lreactbuild_project_notebook_NotebookLink$().forId__ju_UUID__T(id);
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$6.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(title))];
    var array$1 = [$$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    return $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  } else if ((cellConfig instanceof $c_Lreactbuild_project_notebook_Text)) {
    var x4 = $as_Lreactbuild_project_notebook_Text(cellConfig);
    var u$1 = $m_Lreactbuild_project_notebook_renderer_TextAreaRenderer$().apply__Lreactbuild_project_notebook_Text__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(x4);
    var this$18 = $n(u$1);
    var n$1 = this$18.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  } else if ((cellConfig instanceof $c_Lreactbuild_project_notebook_FindAndSelectParcels)) {
    var $$x4 = $m_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesInitialStep$();
    var this$21 = $n($n($n(props).Lreactbuild_project_notebook_Notebook$Props__f_pageProps).Lreactbuild_package$PageProps__f_router);
    var f = new $c_sjsr_AnonFunction1(((step$2) => {
      var step = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(step$2);
      return new $c_Lreactbuild_Loc$BusinessOpportunities(step)
    }));
    var u$2 = $n($$x4).apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(this$21, f, this$21.F__Ljapgolly_scalajs_react_util_Effect$Sync()));
    var this$23 = $n(u$2);
    var n$2 = this$23.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
  } else if ((cellConfig instanceof $c_Lreactbuild_project_notebook_ChecklistOnMap)) {
    var x6 = $as_Lreactbuild_project_notebook_ChecklistOnMap(cellConfig);
    var layers = $n(x6).Lreactbuild_project_notebook_ChecklistOnMap__f_layers;
    var points = $n(x6).Lreactbuild_project_notebook_ChecklistOnMap__f_points;
    var this$48 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = (("Bient\u00f4t, " + ("ici appara\u00eetra une carte avec la possibilit\u00e9 de v\u00e9rifier sur " + layers)) + " les points suivants :");
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x7 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$4 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), points), new $c_sjsr_AnonFunction1(((pt$2) => {
      var pt = $as_Lreactbuild_project_notebook_Check(pt$2);
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(pt).Lreactbuild_project_notebook_Check__f_title;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    })))];
    var array$5 = [$$x7, $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
    return this$48.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
  } else {
    var $$x9 = $m_Lreactbuild_analyze_cost_components_Feature$();
    $m_Lreactbuild_analyze_cost_components_Feature$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$2 = ("" + cellConfig);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
    return $n($$x9).notImplemented__Z__sci_Seq__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_vdom_TagOf(false, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6), new $c_Lsourcecode_Enclosing("reactbuild.project.notebook.Notebook.renderCell"))
  }
});
var $d_Lreactbuild_project_notebook_Notebook$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_Notebook$: 0
}, false, "reactbuild.project.notebook.Notebook$", {
  Lreactbuild_project_notebook_Notebook$: 1,
  O: 1
});
$c_Lreactbuild_project_notebook_Notebook$.prototype.$classData = $d_Lreactbuild_project_notebook_Notebook$;
var $n_Lreactbuild_project_notebook_Notebook$;
function $m_Lreactbuild_project_notebook_Notebook$() {
  if ((!$n_Lreactbuild_project_notebook_Notebook$)) {
    $n_Lreactbuild_project_notebook_Notebook$ = new $c_Lreactbuild_project_notebook_Notebook$()
  };
  return $n_Lreactbuild_project_notebook_Notebook$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_NotebookLink$() {
  this.Lreactbuild_project_notebook_NotebookLink$__f_component = null;
  $n_Lreactbuild_project_notebook_NotebookLink$ = this;
  var this$35 = $m_Lcom_iz2use_react_hooks_package$();
  var this$4 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var reducer = new $c_sjsr_AnonFunction2(((v$2, x$5$2) => {
    var v = $uI(v$2);
    $as_jl_Void(x$5$2);
    return ((1 + v) | 0)
  }));
  var initialState = new $c_sjsr_AnonFunction0((() => 0));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$13 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducer__F2__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$4, reducer, initialState, step)));
  var deps = new $c_sjsr_AnonFunction2(((x$6$2, inc$2) => {
    $as_Lreactbuild_project_notebook_NotebookLink$Props(x$6$2);
    var inc = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(inc$2);
    var this$5 = $n(inc);
    return $uI(this$5.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])
  }));
  var effect = new $c_sjsr_AnonFunction2(((props$2, x$7$2) => {
    var props = $as_Lreactbuild_project_notebook_NotebookLink$Props(props$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$7$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      $uI(x$8$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        var this$6 = $n($m_s_Option$().apply__O__s_Option(document.getElementById($m_Lreactbuild_project_notebook_NotebookLink$().forId__ju_UUID__T($n(props).Lreactbuild_project_notebook_NotebookLink$Props__f_id))));
        var f = new $c_sjsr_AnonFunction1(((x$9$2) => {
          x$9$2.scrollIntoView(true)
        }));
        if ((!this$6.isEmpty__Z())) {
          f.apply__O__O(this$6.get__O())
        }
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$11 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$11.by_$eq$eq__F2();
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$12);
  var this$20 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$13, deps, effect, a, r, step$1)));
  var callback = new $c_sjsr_AnonFunction2(((props$3$2, state$2) => {
    $as_Lreactbuild_project_notebook_NotebookLink$Props(props$3$2);
    var state = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$2);
    return new $c_sjsr_AnonFunction1(((e$2) => {
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r$1 = $n(state).dispatch__O__Ljapgolly_scalajs_react_Reusable((void 0));
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$1).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      $m_Ljapgolly_scalajs_react_package$();
      var this$16 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e$2, this$16.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
    }))
  }));
  var this$18 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var a$1 = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$18, Z);
  var this$19 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$19);
  var this$34 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackBy__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$20, callback, a$1, step$2)));
  var f$3 = new $c_sjsr_AnonFunction3(((props$4$2, x$10$2, cb$2) => {
    var props$4 = $as_Lreactbuild_project_notebook_NotebookLink$Props(props$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$10$2);
    var cb = $as_Ljapgolly_scalajs_react_Reusable(cb$2);
    var $$x4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$23 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$23.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#"), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod($as_F1(($m_Ljapgolly_scalajs_react_Reusable$(), $n(cb).value__O())), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var $$x3 = $n($n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = $n(props$4).Lreactbuild_project_notebook_NotebookLink$Props__f_title;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    return $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  }));
  var this$33 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$33);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$34, f$3, step$3, s);
  this.Lreactbuild_project_notebook_NotebookLink$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$35, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.notebook.NotebookLink.component"))
}
$c_Lreactbuild_project_notebook_NotebookLink$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_NotebookLink$.prototype.constructor = $c_Lreactbuild_project_notebook_NotebookLink$;
/** @constructor */
function $h_Lreactbuild_project_notebook_NotebookLink$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_NotebookLink$.prototype = $c_Lreactbuild_project_notebook_NotebookLink$.prototype;
$c_Lreactbuild_project_notebook_NotebookLink$.prototype.apply__ju_UUID__T__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(id, title) {
  var c = this.Lreactbuild_project_notebook_NotebookLink$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_project_notebook_NotebookLink$Props(id, title);
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_project_notebook_NotebookLink$.prototype.forId__ju_UUID__T = (function(id) {
  return ("" + id)
});
var $d_Lreactbuild_project_notebook_NotebookLink$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_NotebookLink$: 0
}, false, "reactbuild.project.notebook.NotebookLink$", {
  Lreactbuild_project_notebook_NotebookLink$: 1,
  O: 1
});
$c_Lreactbuild_project_notebook_NotebookLink$.prototype.$classData = $d_Lreactbuild_project_notebook_NotebookLink$;
var $n_Lreactbuild_project_notebook_NotebookLink$;
function $m_Lreactbuild_project_notebook_NotebookLink$() {
  if ((!$n_Lreactbuild_project_notebook_NotebookLink$)) {
    $n_Lreactbuild_project_notebook_NotebookLink$ = new $c_Lreactbuild_project_notebook_NotebookLink$()
  };
  return $n_Lreactbuild_project_notebook_NotebookLink$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_package$() {
  this.Lreactbuild_project_notebook_package$__f_reuseNotebookTemplate = null;
  this.Lreactbuild_project_notebook_package$__f_reuseNotebookTemplateVersion = null;
  $n_Lreactbuild_project_notebook_package$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$2.byRef__F2(), this$2.by_$eq$eq__F2());
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_project_notebook_package$__f_reuseNotebookTemplate = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$3.byRef__F2(), this$3.by_$eq$eq__F2());
  var this$4 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_project_notebook_package$__f_reuseNotebookTemplateVersion = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$4.byRef__F2(), this$4.by_$eq$eq__F2());
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$5.byRef__F2(), this$5.by_$eq$eq__F2())
}
$c_Lreactbuild_project_notebook_package$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_package$.prototype.constructor = $c_Lreactbuild_project_notebook_package$;
/** @constructor */
function $h_Lreactbuild_project_notebook_package$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_package$.prototype = $c_Lreactbuild_project_notebook_package$.prototype;
var $d_Lreactbuild_project_notebook_package$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_package$: 0
}, false, "reactbuild.project.notebook.package$", {
  Lreactbuild_project_notebook_package$: 1,
  O: 1
});
$c_Lreactbuild_project_notebook_package$.prototype.$classData = $d_Lreactbuild_project_notebook_package$;
var $n_Lreactbuild_project_notebook_package$;
function $m_Lreactbuild_project_notebook_package$() {
  if ((!$n_Lreactbuild_project_notebook_package$)) {
    $n_Lreactbuild_project_notebook_package$ = new $c_Lreactbuild_project_notebook_package$()
  };
  return $n_Lreactbuild_project_notebook_package$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_renderer_InputRenderer$() {
  this.Lreactbuild_project_notebook_renderer_InputRenderer$__f_component = null;
  $n_Lreactbuild_project_notebook_renderer_InputRenderer$ = this;
  var this$21 = $m_Lcom_iz2use_react_hooks_package$();
  var this$6 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_project_notebook_Input(props$2);
    var $$x4 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$();
    var $$x3 = $m_Lreactbuild_project_notebook_renderer_WithValue$();
    var $$x2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
    var $$x1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
    var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($n($$x4).apply$extension__F1__O__F1($n($$x3).apply__Lio_circe_Encoder__Lio_circe_Decoder__F2__F1($$x2, $$x1, this$3.by_$eq$eq__F2()), $n(props).Lreactbuild_project_notebook_Input__f_source))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$5 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$5);
  var this$20 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$6, hook, step, d)));
  var f = new $c_sjsr_AnonFunction2(((props$3$2, withValue$2) => {
    var props$3 = $as_Lreactbuild_project_notebook_Input(props$3$2);
    var withValue = $as_Ljapgolly_scalajs_react_Reusable(withValue$2);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($as_F1(($m_Ljapgolly_scalajs_react_Reusable$(), $n(withValue).value__O()))).apply__O__O(new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(v$2);
      console.log(((("Input(" + $n(props$3).Lreactbuild_project_notebook_Input__f_id) + ") = ") + v));
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(props$3).Lreactbuild_project_notebook_Input__f_label;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
      var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
      $m_Lcom_iz2use_common_Parsable$();
      var ev = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev);
      var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$14 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$14);
      var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
      var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var eqv = $m_s_math_Equiv$String$();
      var equiv = new $c_s_math_Equiv$OptionEquiv(eqv);
      return editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, v, optioner, ev$1, explainError, equiv)
    }))))
  }));
  var this$19 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$19);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$2 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$20, f, step$1, s);
  this.Lreactbuild_project_notebook_renderer_InputRenderer$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$21, ev$2).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.notebook.renderer.InputRenderer.component"))
}
$c_Lreactbuild_project_notebook_renderer_InputRenderer$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_renderer_InputRenderer$.prototype.constructor = $c_Lreactbuild_project_notebook_renderer_InputRenderer$;
/** @constructor */
function $h_Lreactbuild_project_notebook_renderer_InputRenderer$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_renderer_InputRenderer$.prototype = $c_Lreactbuild_project_notebook_renderer_InputRenderer$.prototype;
$c_Lreactbuild_project_notebook_renderer_InputRenderer$.prototype.apply__Lreactbuild_project_notebook_Input__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(v) {
  var c = this.Lreactbuild_project_notebook_renderer_InputRenderer$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(v, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_notebook_renderer_InputRenderer$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_renderer_InputRenderer$: 0
}, false, "reactbuild.project.notebook.renderer.InputRenderer$", {
  Lreactbuild_project_notebook_renderer_InputRenderer$: 1,
  O: 1
});
$c_Lreactbuild_project_notebook_renderer_InputRenderer$.prototype.$classData = $d_Lreactbuild_project_notebook_renderer_InputRenderer$;
var $n_Lreactbuild_project_notebook_renderer_InputRenderer$;
function $m_Lreactbuild_project_notebook_renderer_InputRenderer$() {
  if ((!$n_Lreactbuild_project_notebook_renderer_InputRenderer$)) {
    $n_Lreactbuild_project_notebook_renderer_InputRenderer$ = new $c_Lreactbuild_project_notebook_renderer_InputRenderer$()
  };
  return $n_Lreactbuild_project_notebook_renderer_InputRenderer$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_renderer_TextAreaRenderer$() {
  this.Lreactbuild_project_notebook_renderer_TextAreaRenderer$__f_reuseMultiline = null;
  this.Lreactbuild_project_notebook_renderer_TextAreaRenderer$__f_component = null;
  $n_Lreactbuild_project_notebook_renderer_TextAreaRenderer$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $n($as_Lcom_iz2use_common_Multiline(x$1$2)).Lcom_iz2use_common_Multiline__f_underlying;
    return x$1
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  this.Lreactbuild_project_notebook_renderer_TextAreaRenderer$__f_reuseMultiline = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  var this$19 = $m_Lcom_iz2use_react_hooks_package$();
  var this$7 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_project_notebook_Text(props$2);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Ljapgolly_scalajs_react_hooks_CustomHook$().apply$extension__F1__O__F1($m_Lreactbuild_project_notebook_renderer_WithValue$().apply__Lio_circe_Encoder__Lio_circe_Decoder__F2__F1($m_Lcom_iz2use_common_Multiline$().encodeMultiline__Lio_circe_Encoder(), $m_Lcom_iz2use_common_Multiline$().decodeMultiline__Lio_circe_Decoder(), $m_Lreactbuild_project_notebook_renderer_TextAreaRenderer$().Lreactbuild_project_notebook_renderer_TextAreaRenderer$__f_reuseMultiline), $n(props).Lreactbuild_project_notebook_Text__f_source))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$6 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$6);
  var this$18 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$7, hook, step, d)));
  var f$1 = new $c_sjsr_AnonFunction2(((props$3$2, withValue$2) => {
    var props$3 = $as_Lreactbuild_project_notebook_Text(props$3$2);
    var withValue = $as_Ljapgolly_scalajs_react_Reusable(withValue$2);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($as_F1(($m_Ljapgolly_scalajs_react_Reusable$(), $n(withValue).value__O()))).apply__O__O(new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(v$2);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(props$3).Lreactbuild_project_notebook_Text__f_label;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
      var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableMultiline;
      var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
      var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_multilineComponent;
      var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var this$14 = $m_s_math_Equiv$();
      var equiv = this$14.universal__s_math_Equiv();
      var this$16 = $n(editorComponent);
      return this$16.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, v, optioner, ev, explainError, equiv)
    }))))
  }));
  var this$17 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$17);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$1 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$18, f$1, step$1, s);
  this.Lreactbuild_project_notebook_renderer_TextAreaRenderer$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$19, ev$1).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.project.notebook.renderer.TextAreaRenderer.component"))
}
$c_Lreactbuild_project_notebook_renderer_TextAreaRenderer$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_renderer_TextAreaRenderer$.prototype.constructor = $c_Lreactbuild_project_notebook_renderer_TextAreaRenderer$;
/** @constructor */
function $h_Lreactbuild_project_notebook_renderer_TextAreaRenderer$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_renderer_TextAreaRenderer$.prototype = $c_Lreactbuild_project_notebook_renderer_TextAreaRenderer$.prototype;
$c_Lreactbuild_project_notebook_renderer_TextAreaRenderer$.prototype.apply__Lreactbuild_project_notebook_Text__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(v) {
  var c = this.Lreactbuild_project_notebook_renderer_TextAreaRenderer$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(v, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_project_notebook_renderer_TextAreaRenderer$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_renderer_TextAreaRenderer$: 0
}, false, "reactbuild.project.notebook.renderer.TextAreaRenderer$", {
  Lreactbuild_project_notebook_renderer_TextAreaRenderer$: 1,
  O: 1
});
$c_Lreactbuild_project_notebook_renderer_TextAreaRenderer$.prototype.$classData = $d_Lreactbuild_project_notebook_renderer_TextAreaRenderer$;
var $n_Lreactbuild_project_notebook_renderer_TextAreaRenderer$;
function $m_Lreactbuild_project_notebook_renderer_TextAreaRenderer$() {
  if ((!$n_Lreactbuild_project_notebook_renderer_TextAreaRenderer$)) {
    $n_Lreactbuild_project_notebook_renderer_TextAreaRenderer$ = new $c_Lreactbuild_project_notebook_renderer_TextAreaRenderer$()
  };
  return $n_Lreactbuild_project_notebook_renderer_TextAreaRenderer$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_renderer_WithValue$() {
  /*<skip>*/
}
$c_Lreactbuild_project_notebook_renderer_WithValue$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_renderer_WithValue$.prototype.constructor = $c_Lreactbuild_project_notebook_renderer_WithValue$;
/** @constructor */
function $h_Lreactbuild_project_notebook_renderer_WithValue$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_renderer_WithValue$.prototype = $c_Lreactbuild_project_notebook_renderer_WithValue$.prototype;
$c_Lreactbuild_project_notebook_renderer_WithValue$.prototype.extract__T__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lio_circe_Decoder__s_util_Either = (function(props, ctx, decoder) {
  var x1 = $n($as_sc_MapOps($n(ctx).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).get__O__s_Option(props);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var value = $as_Lreactbuild_project_notebook_Cell($n(x2).s_Some__f_value);
    if ((value instanceof $c_Lreactbuild_project_notebook_Cell$JSON)) {
      var x2$2 = $as_Lreactbuild_project_notebook_Cell$JSON(value);
      var source = $n(x2$2).Lreactbuild_project_notebook_Cell$JSON__f_source;
      var this$1 = $n(source);
      var x1$3 = $n(decoder).apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(this$1, null, null));
      if ((x1$3 instanceof $c_s_util_Left)) {
        var x2$3 = $as_s_util_Left(x1$3);
        var v = $as_Lio_circe_DecodingFailure($n(x2$3).s_util_Left__f_value);
        return new $c_s_util_Left(((v + " in ") + source))
      } else if ((x1$3 instanceof $c_s_util_Right)) {
        var x3 = $as_s_util_Right(x1$3);
        var x = $n(x3).s_util_Right__f_value;
        return new $c_s_util_Right($m_s_Option$().apply__O__s_Option(x))
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    } else {
      return new $c_s_util_Left(("bad format : " + value))
    }
  } else {
    var x$2 = $m_s_None$();
    if ((x$2 === x1)) {
      return new $c_s_util_Right($m_s_None$())
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_project_notebook_renderer_WithValue$.prototype.apply__Lio_circe_Encoder__Lio_circe_Decoder__F2__F1 = (function(encoder, decoder, reusable) {
  var this$2 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var ctx = $m_Lreactbuild_project_notebook_Notebook$().Lreactbuild_project_notebook_Notebook$__f_context;
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var this$6 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$2, ctx, step)));
  var deps = new $c_sjsr_AnonFunction2(((props$2, ctx$2) => {
    var props = $as_T(props$2);
    var ctx$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(ctx$2);
    return $ct_T2__O__O__(new $c_T2(), props, ctx$1)
  }));
  var create = new $c_sjsr_AnonFunction2(((props$3$2, ctx$3$2) => {
    var props$3 = $as_T(props$3$2);
    var ctx$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(ctx$3$2);
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      $as_T2(x$1$2);
      var r = $m_Lreactbuild_project_notebook_renderer_WithValue$().extract__T__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lio_circe_Decoder__s_util_Either(props$3, ctx$3, decoder);
      console.log(((props$3 + " => ") + r));
      return r
    }))
  }));
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$4 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r$1 = $n($$x3).tuple2__F2__F2__F2(this$4.by_$eq$eq__F2(), $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2());
  var this$5 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$5);
  var this$14 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$6, deps, create, r$1, step$1)));
  var deps$1 = new $c_sjsr_AnonFunction3(((props$4$2, ctx$4$2, dataOpt$2) => {
    $as_T(props$4$2);
    var ctx$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(ctx$4$2);
    var dataOpt = $as_Ljapgolly_scalajs_react_Reusable(dataOpt$2);
    return $ct_T2__O__O__(new $c_T2(), dataOpt, ctx$4)
  }));
  var create$1 = new $c_sjsr_AnonFunction3(((props$5$2, ctx$5$2, dataOpt$3$2) => {
    var props$5 = $as_T(props$5$2);
    var ctx$5 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(ctx$5$2);
    var dataOpt$3 = $as_Ljapgolly_scalajs_react_Reusable(dataOpt$3$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      $as_T2(x$2$2);
      $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
      var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
        var x0$1 = $as_s_Option(x0$1$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        var nextDataOpt = $as_s_Option(x1.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1$2 = $as_s_util_Either($n(dataOpt$3).value__O());
        if ((x1$2 instanceof $c_s_util_Left)) {
          var $$x4 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).alert__T__Ljapgolly_scalajs_react_callback_Trampoline("Impossible d'enregistrer pour le moment car une autre valeur est pr\u00e9sente mais sous un mauvais format. Contacter reactbuild directement.")
        } else if ((x1$2 instanceof $c_s_util_Right)) {
          var x = $m_s_None$();
          if ((x === nextDataOpt)) {
            var $$x4 = cb
          } else if ((nextDataOpt instanceof $c_s_Some)) {
            var x3 = $as_s_Some(nextDataOpt);
            var data = $as_s_Option($n(x3).s_Some__f_value);
            var this$10 = $n(ctx$5);
            var mod = new $c_sjsr_AnonFunction1(((map$2) => {
              var map = $as_sci_Map(map$2);
              var x$3 = $m_s_None$();
              if ((x$3 === data)) {
                return $as_sci_Map($n(map).removed__O__sci_MapOps(props$5))
              } else if ((data instanceof $c_s_Some)) {
                var x3$1 = $as_s_Some(data);
                var value = $n(x3$1).s_Some__f_value;
                return $as_sci_Map($n(map).updated__O__O__sci_MapOps(props$5, new $c_Lreactbuild_project_notebook_Cell$JSON(props$5, $n(encoder).apply__O__Lio_circe_Json(value), (void 0))))
              } else {
                throw new $c_s_MatchError(data)
              }
            }));
            var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
            var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
            var $$x4 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$10, mod, callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
          } else {
            var $$x4;
            throw new $c_s_MatchError(nextDataOpt)
          }
        } else {
          var $$x4;
          throw new $c_s_MatchError(x1$2)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x4)
      }));
      return new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn($m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f))
    }))
  }));
  var r$2 = $m_Ljapgolly_scalajs_react_Reusability$().tuple2__F2__F2__F2($m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2(), $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2());
  var this$13 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$13);
  var this$26 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$14, deps$1, create$1, r$2, step$2)));
  var deps$2 = new $c_sjsr_AnonFunction4(((x$3$2, x$4$2, x$5$2, state$2) => {
    $as_T(x$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$4$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$5$2);
    var state = $as_Ljapgolly_scalajs_react_Reusable(state$2);
    return state
  }));
  var create$2 = new $c_sjsr_AnonFunction4(((x$6$2, x$7$2, dataOpt$4$2, state$3$2) => {
    $as_T(x$6$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$7$2);
    var dataOpt$4 = $as_Ljapgolly_scalajs_react_Reusable(dataOpt$4$2);
    var state$3 = $as_Ljapgolly_scalajs_react_Reusable(state$3$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      $as_Ljapgolly_scalajs_react_Reusable(x$8$2);
      var x1$3 = $as_s_util_Either($n(dataOpt$4).value__O());
      if ((x1$3 instanceof $c_s_util_Left)) {
        var x2 = $as_s_util_Left(x1$3);
        var v = $as_T($n(x2).s_util_Left__f_value);
        return new $c_sjsr_AnonFunction1(((x$9$2) => {
          $as_F1(x$9$2);
          var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var v$1 = ("Erreur " + v);
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
          return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
        }))
      } else if ((x1$3 instanceof $c_s_util_Right)) {
        return new $c_sjsr_AnonFunction1(((f$2) => {
          var f$1 = $as_F1(f$2);
          var $$x9 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
          var $$x8 = $n($as_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn(($m_Ljapgolly_scalajs_react_Reusable$(), $n(state$3).value__O()))).Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn__f_japgolly$scalajs$react$extra$internal$StateSnapshot$withReuse$FromSetStateFn$$set;
          var $$x7 = $n($n($as_s_util_Either($n(dataOpt$4).value__O())).toOption__s_Option());
          var this$23 = $m_s_$less$colon$less$();
          var $$x6 = $n($$x7).flatten__s_$less$colon$less__s_Option(this$23.s_$less$colon$less$__f_singleton);
          var this$24 = $m_Ljapgolly_scalajs_react_Reusability$();
          return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f$1).apply__O__O($n($$x9).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($$x8, $$x6, this$24.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, reusable))))
        }))
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    }))
  }));
  var r$3 = $m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2();
  var this$25 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44(this$25);
  var $$x2 = $n($as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$26, deps$2, create$2, r$3, step$3)));
  var $$x1 = new $c_sjsr_AnonFunction5(((x$10$2, x$11$2, x$12$2, x$13$2, render$2) => {
    $as_T(x$10$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$11$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$12$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$13$2);
    var render = $as_Ljapgolly_scalajs_react_Reusable(render$2);
    return render
  }));
  var this$27 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  return $n($$x2).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x1, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46(this$27))
});
var $d_Lreactbuild_project_notebook_renderer_WithValue$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_renderer_WithValue$: 0
}, false, "reactbuild.project.notebook.renderer.WithValue$", {
  Lreactbuild_project_notebook_renderer_WithValue$: 1,
  O: 1
});
$c_Lreactbuild_project_notebook_renderer_WithValue$.prototype.$classData = $d_Lreactbuild_project_notebook_renderer_WithValue$;
var $n_Lreactbuild_project_notebook_renderer_WithValue$;
function $m_Lreactbuild_project_notebook_renderer_WithValue$() {
  if ((!$n_Lreactbuild_project_notebook_renderer_WithValue$)) {
    $n_Lreactbuild_project_notebook_renderer_WithValue$ = new $c_Lreactbuild_project_notebook_renderer_WithValue$()
  };
  return $n_Lreactbuild_project_notebook_renderer_WithValue$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_template_OpportunityStudy$() {
  this.Lreactbuild_project_notebook_template_OpportunityStudy$__f_templateVersion = null;
  this.Lreactbuild_project_notebook_template_OpportunityStudy$__f_template = null;
  $n_Lreactbuild_project_notebook_template_OpportunityStudy$ = this;
  var $$x9 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
  $n($m_s_package$().s_package$__f_List);
  var $$x8 = new $c_Lreactbuild_project_notebook_Input($m_ju_UUID$().randomUUID__ju_UUID(), "project.address", $m_Lreactbuild_project_notebook_AddressType$(), "Emplacement");
  var $$x7 = new $c_Lreactbuild_project_notebook_Title($m_ju_UUID$().randomUUID__ju_UUID(), "Source de l'opportunit\u00e9");
  var $$x6 = new $c_Lreactbuild_project_notebook_Text($m_ju_UUID$().randomUUID__ju_UUID(), "source", "Origine de la source de l'opportunit\u00e9 (site internet avec lien, t\u00e9l\u00e9phone/email + nom agence)");
  var $$x5 = new $c_Lreactbuild_project_notebook_Input($m_ju_UUID$().randomUUID__ju_UUID(), "project.name", new $c_Lreactbuild_project_notebook_OptionType(new $c_Lreactbuild_project_notebook_RefToType($m_Lreactbuild_project_notebook_ProjectType$())), "Nom du projet \u00e0 cr\u00e9er");
  var $$x4 = new $c_Lreactbuild_project_notebook_FindAndSelectParcels($m_ju_UUID$().randomUUID__ju_UUID(), "project.parcels", "Chercher une adresse ou une parcelle", "S\u00e9lectionner les parcelles du projet");
  var $$x3 = new $c_Lreactbuild_project_notebook_Title($m_ju_UUID$().randomUUID__ju_UUID(), "Risques du projet");
  var $$x2 = $m_ju_UUID$().randomUUID__ju_UUID();
  $n($m_s_package$().s_package$__f_List);
  var array = [$m_Lreactbuild_project_notebook_MapLayer$Elevation$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $n($m_s_package$().s_package$__f_List);
  var array$1 = [new $c_Lreactbuild_project_notebook_Check($m_ju_UUID$().randomUUID__ju_UUID(), "V\u00e9rifier le niveau du terrain : besoin de travaux de terrassement"), new $c_Lreactbuild_project_notebook_Check($m_ju_UUID$().randomUUID__ju_UUID(), "Altitude minimale respect\u00e9e sur le terrain")];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var array$2 = [$$x8, $$x7, $$x6, $$x5, $$x4, $$x3, new $c_Lreactbuild_project_notebook_ChecklistOnMap($$x2, "hazards", $$x1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1))];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lreactbuild_project_notebook_template_OpportunityStudy$__f_templateVersion = new $c_Lreactbuild_project_notebook_NotebookTemplateVersion($$x9, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2), $m_s_None$());
  this.Lreactbuild_project_notebook_template_OpportunityStudy$__f_template = new $c_Lreactbuild_project_notebook_NotebookTemplate(new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().fromString__T__ju_UUID("68395ea8-eee0-4c78-9242-4c666a86404c")), "Etudier une opportunit\u00e9", $n(this.Lreactbuild_project_notebook_template_OpportunityStudy$__f_templateVersion).Lreactbuild_project_notebook_NotebookTemplateVersion__f_id)
}
$c_Lreactbuild_project_notebook_template_OpportunityStudy$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_template_OpportunityStudy$.prototype.constructor = $c_Lreactbuild_project_notebook_template_OpportunityStudy$;
/** @constructor */
function $h_Lreactbuild_project_notebook_template_OpportunityStudy$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_template_OpportunityStudy$.prototype = $c_Lreactbuild_project_notebook_template_OpportunityStudy$.prototype;
var $d_Lreactbuild_project_notebook_template_OpportunityStudy$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_template_OpportunityStudy$: 0
}, false, "reactbuild.project.notebook.template.OpportunityStudy$", {
  Lreactbuild_project_notebook_template_OpportunityStudy$: 1,
  O: 1
});
$c_Lreactbuild_project_notebook_template_OpportunityStudy$.prototype.$classData = $d_Lreactbuild_project_notebook_template_OpportunityStudy$;
var $n_Lreactbuild_project_notebook_template_OpportunityStudy$;
function $m_Lreactbuild_project_notebook_template_OpportunityStudy$() {
  if ((!$n_Lreactbuild_project_notebook_template_OpportunityStudy$)) {
    $n_Lreactbuild_project_notebook_template_OpportunityStudy$ = new $c_Lreactbuild_project_notebook_template_OpportunityStudy$()
  };
  return $n_Lreactbuild_project_notebook_template_OpportunityStudy$
}
function $p_Lreactbuild_task_TaskScheduler$__process$1__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__Ljapgolly_scalajs_react_callback_Trampoline($thiz, context$3, results$1) {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var x = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMapSync$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_task_TaskScheduler$Algorithm$().process__Lreactbuild_task_TaskScheduler$Context__sci_List($as_Lreactbuild_task_TaskScheduler$Context($n(context$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_sci_List(v$2);
    $m_Ljapgolly_scalajs_react_Reusable$();
    var this$4 = $n(results$1);
    var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$4);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_s_util_Success(v)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })));
  return $n($$x1).toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_hooks_EnhancedAsyncCallback(x).onError__F1__F1(new $c_sjsr_AnonFunction1(((e$2) => {
    var e = $as_jl_Throwable(e$2);
    $m_Ljapgolly_scalajs_react_Reusable$();
    var this$7 = $n(results$1);
    var r$1 = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__setState__Ljapgolly_scalajs_react_Reusable(this$7);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r$1).value__O())).apply__O__O(new $c_s_util_Failure(e)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }))))
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$() {
  this.Lreactbuild_task_TaskScheduler$__f_today = null;
  this.Lreactbuild_task_TaskScheduler$__f_dayTypes = null;
  this.Lreactbuild_task_TaskScheduler$__f_transitions = null;
  this.Lreactbuild_task_TaskScheduler$__f_tasks = null;
  this.Lreactbuild_task_TaskScheduler$__f_component = null;
  $n_Lreactbuild_task_TaskScheduler$ = this;
  var this$1 = $m_Ljava_time_LocalDate$();
  this.Lreactbuild_task_TaskScheduler$__f_today = this$1.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()));
  $n($m_s_package$().s_package$__f_LazyList).iterate__F0__F1__sci_LazyList(new $c_sjsr_AnonFunction0((() => {
    var $$x1 = $n($m_Lreactbuild_task_TaskScheduler$().Lreactbuild_task_TaskScheduler$__f_today);
    var value = ((8 - $n($n($m_Lreactbuild_task_TaskScheduler$().Lreactbuild_task_TaskScheduler$__f_today).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I()) | 0);
    return $n($$x1).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(value, (value >> 31)))
  })), new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljava_time_LocalDate(x$1$2);
    return $n(x$1).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0))
  })));
  $n($m_s_package$().s_package$__f_List);
  $n($m_s_package$().s_package$__f_List);
  var array = [1];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x8 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var array$1 = [new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$(), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(5, 0), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(7, 0)), new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(9, 0), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(16, 0))];
  var $$x7 = new $c_Lreactbuild_task_TaskScheduler$DayType($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  $n($m_s_package$().s_package$__f_List);
  var array$2 = [2];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var $$x6 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  var array$3 = [new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$(), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(5, 0), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(7, 0)), new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$(), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(9, 0), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(11, 0)), new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$(), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(14, 0), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(16, 0))];
  var $$x5 = new $c_Lreactbuild_task_TaskScheduler$DayType($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  $n($m_s_package$().s_package$__f_List);
  var array$4 = [3];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var $$x4 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  var array$5 = [new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$(), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(5, 0), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(7, 0)), new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(9, 0), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(15, 45))];
  var $$x3 = new $c_Lreactbuild_task_TaskScheduler$DayType($$x4, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  $n($m_s_package$().s_package$__f_List);
  var array$6 = [4, 5];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var $$x2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  var array$7 = [new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(9, 0), $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(15, 45))];
  var array$8 = [$$x7, $$x5, $$x3, new $c_Lreactbuild_task_TaskScheduler$DayType($$x2, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  this.Lreactbuild_task_TaskScheduler$__f_dayTypes = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  $n($m_s_package$().s_package$__f_List);
  var array$9 = [new $c_Lreactbuild_task_TaskScheduler$ActivityTransition($m_s_None$(), $m_s_Option$().apply__O__s_Option($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$()), $m_Ljava_time_Duration$().ofMinutes__J__Ljava_time_Duration(new $c_RTLong(10, 0))), new $c_Lreactbuild_task_TaskScheduler$ActivityTransition($m_s_None$(), $m_s_Option$().apply__O__s_Option($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$()), $m_Ljava_time_Duration$().ofMinutes__J__Ljava_time_Duration(new $c_RTLong(15, 0))), new $c_Lreactbuild_task_TaskScheduler$ActivityTransition($m_s_Option$().apply__O__s_Option($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$()), $m_s_Option$().apply__O__s_Option($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$()), $m_Ljava_time_Duration$().ofMinutes__J__Ljava_time_Duration(new $c_RTLong(5, 0))), new $c_Lreactbuild_task_TaskScheduler$ActivityTransition($m_s_Option$().apply__O__s_Option($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$()), $m_s_None$(), $m_Ljava_time_Duration$().ofMinutes__J__Ljava_time_Duration(new $c_RTLong(10, 0))), new $c_Lreactbuild_task_TaskScheduler$ActivityTransition($m_s_None$(), $m_s_Option$().apply__O__s_Option($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$()), $m_Ljava_time_Duration$().ofMinutes__J__Ljava_time_Duration(new $c_RTLong(5, 0)))];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  this.Lreactbuild_task_TaskScheduler$__f_transitions = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5);
  $n($m_s_package$().s_package$__f_List);
  var array$10 = [new $c_Lreactbuild_task_TaskScheduler$Activity($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$(), $m_Ljava_time_Duration$().ofHours__J__Ljava_time_Duration(new $c_RTLong(2, 0)), "JOC696.AB : Refaire demande assainissement individuelle sur rue de la Gare"), new $c_Lreactbuild_task_TaskScheduler$Activity($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$(), $m_Ljava_time_Duration$().ofHours__J__Ljava_time_Duration(new $c_RTLong(4, 0)), "JOC696.CD : Faire dossier PC pour maison pour demande assainissement"), new $c_Lreactbuild_task_TaskScheduler$Activity($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$(), $m_Ljava_time_Duration$().ofHours__J__Ljava_time_Duration(new $c_RTLong(2, 0)), "JOC696.CD : Refaire demande assainissement individuelle apr\u00e8s dossier PC"), new $c_Lreactbuild_task_TaskScheduler$Activity($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$(), $m_Ljava_time_Duration$().ofHours__J__Ljava_time_Duration(new $c_RTLong(8, 0)), "Dossier PC pour Zone Artisanale"), new $c_Lreactbuild_task_TaskScheduler$Activity($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(), $m_Ljava_time_Duration$().ofHours__J__Ljava_time_Duration(new $c_RTLong(12, 0)), "JOC696.A : Tableau \u00e9lectrique"), new $c_Lreactbuild_task_TaskScheduler$Activity($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(), $m_Ljava_time_Duration$().ofHours__J__Ljava_time_Duration(new $c_RTLong(3, 0)), "ANAM356.C : \u00e9lec ext\u00e9rieur apr\u00e8s enduits"), new $c_Lreactbuild_task_TaskScheduler$Activity($m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(), $m_Ljava_time_Duration$().ofHours__J__Ljava_time_Duration(new $c_RTLong(3, 0)), "ANAM356.B : \u00e9lec ext\u00e9rieur apr\u00e8s enduits")];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  this.Lreactbuild_task_TaskScheduler$__f_tasks = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$6);
  var this$159 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent);
  var api = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First();
  var this$50 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(new $c_Lreactbuild_hooks_HooksApiExt$Primary(), api).useLocalStorage__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Lio_circe_Encoder__Lio_circe_Decoder__F2__Lsourcecode_Pkg__Lsourcecode_FileName__O(new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_task_TaskScheduler$Context($m_Lreactbuild_task_TaskScheduler$().Lreactbuild_task_TaskScheduler$__f_dayTypes, $m_Lreactbuild_task_TaskScheduler$().Lreactbuild_task_TaskScheduler$__f_tasks, $m_Lreactbuild_task_TaskScheduler$().Lreactbuild_task_TaskScheduler$__f_transitions))), new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep(), $m_Lreactbuild_task_TaskScheduler$Context$().Lreactbuild_task_TaskScheduler$Context$__f_codecForContext, $m_Lreactbuild_task_TaskScheduler$Context$().Lreactbuild_task_TaskScheduler$Context$__f_codecForContext, $m_Lreactbuild_task_TaskScheduler$Context$().Lreactbuild_task_TaskScheduler$Context$__f_reuseContext, new $c_Lsourcecode_Pkg("reactbuild.task"), new $c_Lsourcecode_FileName("TaskScheduler.scala"))));
  var initialState = new $c_sjsr_AnonFunction0((() => $m_s_util_Try$().apply__F0__s_util_Try(new $c_sjsr_AnonFunction0((() => {
    $n($m_s_package$().s_package$__f_List);
    return $m_sci_Nil$()
  })))));
  var this$49 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$49);
  var this$158 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$50, initialState, step)));
  var f = new $c_sjsr_AnonFunction3(((props$2, context$2, results$2) => {
    $as_Lreactbuild_task_TaskScheduler$Props(props$2);
    var context = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(context$2);
    var results = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(results$2);
    var $$x39 = $m_Lcom_iz2use_react_components_Card$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x38 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Planif t\u00e2ches");
    var $$x37 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x36 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x35 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x26 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$60 = $n($n($as_Lreactbuild_task_TaskScheduler$Context($n(context).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_task_TaskScheduler$Context__f_dayTypes);
    var as = $as_sc_IterableOnce($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$60));
    var array$14 = [$n($$x26).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var day = $as_Lreactbuild_task_TaskScheduler$DayType($n(x0$1)._1__O());
        var idx = $n(x0$1)._2$mcI$sp__I();
        var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = ((idx + " - Dur\u00e9e dispo sur cette journ\u00e9e type : ") + $n($as_Ljava_time_Duration($n($n(day).Lreactbuild_task_TaskScheduler$DayType__f_periods).foldLeft__O__F2__O($m_Ljava_time_Duration$().ZERO__Ljava_time_Duration(), new $c_sjsr_AnonFunction2(((acc$2, c$2) => {
          var acc = $as_Ljava_time_Duration(acc$2);
          var c = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriod(c$2);
          var this$64 = $n(acc);
          var startInclusive = $n(c).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_start;
          var endExclusive = $n(c).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_end;
          var duration = $m_Ljava_time_Duration$().between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration(startInclusive, endExclusive);
          var this$65 = $n(duration);
          var $$x30 = this$65.Ljava_time_Duration__f_seconds;
          var this$66 = $n(duration);
          var value$1 = this$66.Ljava_time_Duration__f_nanos;
          return $p_Ljava_time_Duration__plus__J__J__Ljava_time_Duration(this$64, $$x30, new $c_RTLong(value$1, (value$1 >> 31)))
        }))))).toHours__J());
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x31 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
        var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x27 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var as$1 = $n(day).Lreactbuild_task_TaskScheduler$DayType__f_periods;
        var array$12 = [$n($$x27).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((period$2) => {
          var period = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriod(period$2);
          var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var v$1 = (((($n(period).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_start + " - ") + $n(period).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_end) + " : ") + $n(period).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_tpe);
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var array$11 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
          return $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
        })))];
        var array$13 = [$$x31, $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
        return $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })))];
    var array$15 = [$n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
    var $$x25 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15));
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as$2 = $n($as_Lreactbuild_task_TaskScheduler$Context($n(context).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_task_TaskScheduler$Context__f_tasks;
    var array$18 = [$n($$x17).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$2, new $c_sjsr_AnonFunction1(((task$2) => {
      var task = $as_Lreactbuild_task_TaskScheduler$Activity(task$2);
      var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x20 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var this$104 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
      var $$x19 = this$104.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$2 = (("[" + $n($n(task).Lreactbuild_task_TaskScheduler$Activity__f_estimatedDuration).toHours__J()) + "]");
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$16 = [$$x20, $$x19, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      var $$x18 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$3 = (" " + $n(task).Lreactbuild_task_TaskScheduler$Activity__f_name);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$17 = [$$x18, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
      return $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))
    })))];
    var array$19 = [$n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))];
    var $$x16 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19));
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$20 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lreactbuild_task_TaskScheduler$__process$1__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__Ljapgolly_scalajs_react_callback_Trampoline(this, context, results)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Calculer"))];
    var $$x14 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20));
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$132 = $n(results);
    var x1 = $as_s_util_Try(this$132.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    if ((x1 instanceof $c_s_util_Success)) {
      var x2 = $as_s_util_Success(x1);
      var lst = $as_sci_List($n(x2).s_util_Success__f_value);
      var $$x9 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), lst), new $c_sjsr_AnonFunction1(((r$2) => {
        var r = $as_Lreactbuild_task_TaskScheduler$Period(r$2);
        var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v$4 = ("" + r);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$21 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
        return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21))
      })))
    } else if ((x1 instanceof $c_s_util_Failure)) {
      var x3 = $as_s_util_Failure(x1);
      var e = $n(x3).s_util_Failure__f_exception;
      var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$5 = ("" + e);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$22 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
      var $$x9 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("code", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22))
    } else {
      var $$x9;
      throw new $c_s_MatchError(x1)
    };
    var array$23 = [$$x9];
    var array$24 = [$n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23))];
    var array$25 = [$$x25, $$x16, $$x14, $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24))];
    return $n($$x39).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x38, $$x37, $$x36, $$x35, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25))
  }));
  var this$157 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$157);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$158, f, step$1, s);
  this.Lreactbuild_task_TaskScheduler$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$159, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.task.TaskScheduler.component"))
}
$c_Lreactbuild_task_TaskScheduler$.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$.prototype = $c_Lreactbuild_task_TaskScheduler$.prototype;
$c_Lreactbuild_task_TaskScheduler$.prototype.apply__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function() {
  var c = this.Lreactbuild_task_TaskScheduler$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_task_TaskScheduler$Props();
  return $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lreactbuild_task_TaskScheduler$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$: 0
}, false, "reactbuild.task.TaskScheduler$", {
  Lreactbuild_task_TaskScheduler$: 1,
  O: 1
});
$c_Lreactbuild_task_TaskScheduler$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$;
var $n_Lreactbuild_task_TaskScheduler$;
function $m_Lreactbuild_task_TaskScheduler$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$)) {
    $n_Lreactbuild_task_TaskScheduler$ = new $c_Lreactbuild_task_TaskScheduler$()
  };
  return $n_Lreactbuild_task_TaskScheduler$
}
function $p_Lreactbuild_task_TaskScheduler$Algorithm$__loop$2__sci_List__sci_List__Lreactbuild_task_TaskScheduler$Context__sci_List($thiz, results, rest, context$2) {
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      return results
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $as_Lreactbuild_task_TaskScheduler$Activity($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      var underlying = results;
      var x1$2 = new $c_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList(underlying).nextFreePeriod__Lreactbuild_task_TaskScheduler$AllocatablePeriodType__Lreactbuild_task_TaskScheduler$Context__T2($n(head).Lreactbuild_task_TaskScheduler$Activity__f_tpe, context$2);
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var nextResults = $as_sci_List($n(x1$2)._1__O());
      $n(x1$2)._2$mcI$sp__I();
      results = nextResults;
      rest = tail
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Algorithm$() {
  /*<skip>*/
}
$c_Lreactbuild_task_TaskScheduler$Algorithm$.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Algorithm$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Algorithm$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Algorithm$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Algorithm$.prototype = $c_Lreactbuild_task_TaskScheduler$Algorithm$.prototype;
$c_Lreactbuild_task_TaskScheduler$Algorithm$.prototype.process__Lreactbuild_task_TaskScheduler$Context__sci_List = (function(context) {
  var this$2 = $n($n(context).Lreactbuild_task_TaskScheduler$Context__f_dayTypes);
  $n($m_s_Predef$().s_Predef$__f_Set);
  var z = $m_sci_Set$EmptySet$();
  var acc = z;
  var these = this$2;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = acc;
    var arg2 = $n(these).head__O();
    var acc$1 = $as_sci_Set(arg1);
    var c = $as_Lreactbuild_task_TaskScheduler$DayType(arg2);
    acc = $as_sci_Set($n($n(c).Lreactbuild_task_TaskScheduler$DayType__f_periods).foldLeft__O__F2__O(acc$1, new $c_sjsr_AnonFunction2(((acc$2$2, c$2$2) => {
      var acc$2 = $as_sci_Set(acc$2$2);
      var c$2 = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriod(c$2$2);
      var this$4 = $n(acc$2);
      var elem = $n(c$2).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_tpe;
      return $as_sci_Set(this$4.incl__O__sci_SetOps(elem))
    }))));
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  var dayTpe = $as_sci_Set(acc);
  var this$6 = $n($n(context).Lreactbuild_task_TaskScheduler$Context__f_tasks);
  $n($m_s_Predef$().s_Predef$__f_Set);
  var z$1 = $m_sci_Set$EmptySet$();
  var acc$3 = z$1;
  var these$1 = this$6;
  while ((!$n(these$1).isEmpty__Z())) {
    var arg1$1 = acc$3;
    var arg2$1 = $n(these$1).head__O();
    var acc$3$1 = $as_sci_Set(arg1$1);
    var c$3 = $as_Lreactbuild_task_TaskScheduler$Activity(arg2$1);
    var this$7 = $n(acc$3$1);
    var elem$1 = $n(c$3).Lreactbuild_task_TaskScheduler$Activity__f_tpe;
    acc$3 = $as_sci_Set(this$7.incl__O__sci_SetOps(elem$1));
    these$1 = $as_sc_LinearSeq($n(these$1).tail__O())
  };
  var taskTpe = $as_sci_Set(acc$3);
  var this$8 = $n(taskTpe);
  var this$9 = $n(this$8.removedAll__sc_IterableOnce__sci_SetOps(dayTpe));
  $m_sci_List$();
  var x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$9);
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
    return $p_Lreactbuild_task_TaskScheduler$Algorithm$__loop$2__sci_List__sci_List__Lreactbuild_task_TaskScheduler$Context__sci_List(this, $m_s_package$().s_package$__f_Nil, $n(context).Lreactbuild_task_TaskScheduler$Context__f_tasks, context)
  } else {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (x1 + " never handled in dayTypes"))
  }
});
var $d_Lreactbuild_task_TaskScheduler$Algorithm$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Algorithm$: 0
}, false, "reactbuild.task.TaskScheduler$Algorithm$", {
  Lreactbuild_task_TaskScheduler$Algorithm$: 1,
  O: 1
});
$c_Lreactbuild_task_TaskScheduler$Algorithm$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Algorithm$;
var $n_Lreactbuild_task_TaskScheduler$Algorithm$;
function $m_Lreactbuild_task_TaskScheduler$Algorithm$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$Algorithm$)) {
    $n_Lreactbuild_task_TaskScheduler$Algorithm$ = new $c_Lreactbuild_task_TaskScheduler$Algorithm$()
  };
  return $n_Lreactbuild_task_TaskScheduler$Algorithm$
}
function $p_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList__loop$1__sci_List__Lreactbuild_task_TaskScheduler$AllocatablePeriodType__Lreactbuild_task_TaskScheduler$Context__Ljava_time_LocalDateTime__T2($thiz, results, tpe$1, context$1, now$1) {
  while (true) {
    var this$1 = $n(results);
    _return: {
      var i = 0;
      var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$1, 0, this$1);
      while (true) {
        var this$4 = $n(these);
        if ((!this$4.isEmpty__Z())) {
          var arg1 = $n(these).head__O();
          var x$2 = $as_Lreactbuild_task_TaskScheduler$Period(arg1);
          if ($n($n(x$2).Lreactbuild_task_TaskScheduler$Period__f_details).isFree__Lreactbuild_task_TaskScheduler$AllocatablePeriodType__Z(tpe$1)) {
            var x1 = i;
            break _return
          };
          i = ((1 + i) | 0);
          these = $as_sc_LinearSeq($n(these).tail__O())
        } else {
          break
        }
      };
      var x1 = (-1)
    };
    if ((x1 === (-1))) {
      console.warn(((tpe$1 + " not found in ") + results));
      if ($n(results).isEmpty__Z()) {
        var this$5 = $m_Ljava_time_LocalDate$();
        var last = $n(this$5.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))).minusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0))
      } else {
        var this$7 = $n($n($as_Lreactbuild_task_TaskScheduler$Period($n(results).last__O())).Lreactbuild_task_TaskScheduler$Period__f_end);
        var last = this$7.Ljava_time_LocalDateTime__f_date
      };
      var this$8 = $n($m_s_package$().s_package$__f_LazyList);
      var stream = $n($n(this$8.from__I__I__sci_LazyList(1, 1)).flatMap__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((last, context$1, tpe$1) => ((i$2) => {
        var i$1 = $uI(i$2);
        var $$x1 = $n(last);
        var hi = (i$1 >> 31);
        var date = $n($$x1).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(i$1, hi));
        var this$10 = $n($n(context$1).Lreactbuild_task_TaskScheduler$Context__f_dayTypes);
        _return$1: {
          var these$1 = this$10;
          while ((!$n(these$1).isEmpty__Z())) {
            var arg1$1 = $n(these$1).head__O();
            var x$3 = $as_Lreactbuild_task_TaskScheduler$DayType(arg1$1);
            if ($n($n(x$3).Lreactbuild_task_TaskScheduler$DayType__f_dow).contains__O__Z($n($n(date).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I())) {
              var $$x2 = new $c_s_Some($n(these$1).head__O());
              break _return$1
            };
            these$1 = $as_sci_List($n(these$1).tail__O())
          };
          var $$x2 = $m_s_None$()
        };
        var this$11 = $n($$x2.toList__sci_List());
        var rest = this$11;
        var h = null;
        var t = null;
        while ((rest !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest).head__O();
          var dt = $as_Lreactbuild_task_TaskScheduler$DayType(arg1$2);
          var it = $n($as_sci_Seq($n($n(dt).Lreactbuild_task_TaskScheduler$DayType__f_periods).map__F1__O(new $c_sjsr_AnonFunction1(((date) => ((p$2) => {
            var p = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriod(p$2);
            var this$12 = $n(date);
            var time = $n(p).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_start;
            var $$x3 = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$12, time);
            var this$13 = $n(date);
            var time$1 = $n(p).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_end;
            return new $c_Lreactbuild_task_TaskScheduler$Period($$x3, $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$13, time$1), new $c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free($n(p).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_tpe))
          }))(date))))).iterator__sc_Iterator();
          while ($n(it).hasNext__Z()) {
            var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
            if ((t === null)) {
              h = nx
            } else {
              $n(t).sci_$colon$colon__f_next = nx
            };
            t = nx
          };
          rest = $as_sci_List($n(rest).tail__O())
        };
        var r = ((h === null) ? $m_sci_Nil$() : h);
        console.log(((tpe$1 + ": ") + r));
        return r
      }))(last, context$1, tpe$1)))).dropWhile__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((now$1) => ((x$4$2) => {
        var x$4 = $as_Lreactbuild_task_TaskScheduler$Period(x$4$2);
        return $n($n(x$4).Lreactbuild_task_TaskScheduler$Period__f_from).isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z(now$1)
      }))(now$1)));
      var this$14 = $n(stream);
      _return$2: {
        var i$3 = 0;
        var these$2 = this$14.drop__I__sci_LazyList(0);
        while (true) {
          var this$17 = $n(these$2);
          if ((!this$17.isEmpty__Z())) {
            var arg1$3 = $n(these$2).head__O();
            var x$5 = $as_Lreactbuild_task_TaskScheduler$Period(arg1$3);
            if ($n($n(x$5).Lreactbuild_task_TaskScheduler$Period__f_details).isFree__Lreactbuild_task_TaskScheduler$AllocatablePeriodType__Z(tpe$1)) {
              var idx = i$3;
              break _return$2
            };
            i$3 = ((1 + i$3) | 0);
            these$2 = $as_sc_LinearSeq($n(these$2).tail__O())
          } else {
            break
          }
        };
        var idx = (-1)
      };
      var r$1 = $n(stream).take__I__sci_LazyList(((1 + idx) | 0));
      var this$18 = $n(results);
      results = this$18.appendedAll__sc_IterableOnce__sci_List(r$1)
    } else {
      console.warn((tpe$1 + " found !"));
      return $ct_T2__O__O__(new $c_T2(), results, x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList(underlying) {
  this.Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList__f_underlying = null;
  this.Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList__f_underlying = underlying
}
$c_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList.prototype = $c_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList.prototype;
$c_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList.prototype.nextFreePeriod__Lreactbuild_task_TaskScheduler$AllocatablePeriodType__Lreactbuild_task_TaskScheduler$Context__T2 = (function(tpe, context) {
  var this$1 = $m_Ljava_time_LocalDateTime$();
  var now = this$1.now__Ljava_time_Clock__Ljava_time_LocalDateTime(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()));
  return $p_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList__loop$1__sci_List__Lreactbuild_task_TaskScheduler$AllocatablePeriodType__Lreactbuild_task_TaskScheduler$Context__Ljava_time_LocalDateTime__T2(this, this.Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList__f_underlying, tpe, context, now)
});
var $d_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList: 0
}, false, "reactbuild.task.TaskScheduler$Algorithm$RichPeriodList", {
  Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList: 1,
  O: 1
});
$c_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Algorithm$RichPeriodList;
function $ct_Lreactbuild_task_TaskScheduler$AllocatablePeriodType__D__($thiz, timeAllocation) {
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType() {
  /*<skip>*/
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType.prototype;
function $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$AllocatablePeriodType"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$AllocatablePeriodType)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$AllocatablePeriodType;", depth))
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$() {
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$__f_codecForAllocatablePeriodType = null;
  $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$ = this;
  var inst$macro$14 = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$14));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$__f_codecForAllocatablePeriodType = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$.prototype;
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriodType$", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$: 1,
  O: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$;
var $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$;
function $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$)) {
    $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$ = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$()
  };
  return $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$
}
/** @constructor */
function $c_s_Array$EmptyArrays$() {
  this.s_Array$EmptyArrays$__f_emptyIntArray = null;
  this.s_Array$EmptyArrays$__f_emptyObjectArray = null;
  $n_s_Array$EmptyArrays$ = this;
  this.s_Array$EmptyArrays$__f_emptyIntArray = new $ac_I(0);
  this.s_Array$EmptyArrays$__f_emptyObjectArray = new $ac_O(0)
}
$c_s_Array$EmptyArrays$.prototype = new $h_O();
$c_s_Array$EmptyArrays$.prototype.constructor = $c_s_Array$EmptyArrays$;
/** @constructor */
function $h_s_Array$EmptyArrays$() {
  /*<skip>*/
}
$h_s_Array$EmptyArrays$.prototype = $c_s_Array$EmptyArrays$.prototype;
var $d_s_Array$EmptyArrays$ = new $TypeData().initClass({
  s_Array$EmptyArrays$: 0
}, false, "scala.Array$EmptyArrays$", {
  s_Array$EmptyArrays$: 1,
  O: 1
});
$c_s_Array$EmptyArrays$.prototype.$classData = $d_s_Array$EmptyArrays$;
var $n_s_Array$EmptyArrays$;
function $m_s_Array$EmptyArrays$() {
  if ((!$n_s_Array$EmptyArrays$)) {
    $n_s_Array$EmptyArrays$ = new $c_s_Array$EmptyArrays$()
  };
  return $n_s_Array$EmptyArrays$
}
/** @constructor */
function $c_s_DummyImplicit() {
  /*<skip>*/
}
$c_s_DummyImplicit.prototype = new $h_O();
$c_s_DummyImplicit.prototype.constructor = $c_s_DummyImplicit;
/** @constructor */
function $h_s_DummyImplicit() {
  /*<skip>*/
}
$h_s_DummyImplicit.prototype = $c_s_DummyImplicit.prototype;
var $d_s_DummyImplicit = new $TypeData().initClass({
  s_DummyImplicit: 0
}, false, "scala.DummyImplicit", {
  s_DummyImplicit: 1,
  O: 1
});
$c_s_DummyImplicit.prototype.$classData = $d_s_DummyImplicit;
/** @constructor */
function $c_s_DummyImplicit$() {
  this.s_DummyImplicit$__f_dummyImplicit = null;
  $n_s_DummyImplicit$ = this;
  this.s_DummyImplicit$__f_dummyImplicit = new $c_s_DummyImplicit()
}
$c_s_DummyImplicit$.prototype = new $h_O();
$c_s_DummyImplicit$.prototype.constructor = $c_s_DummyImplicit$;
/** @constructor */
function $h_s_DummyImplicit$() {
  /*<skip>*/
}
$h_s_DummyImplicit$.prototype = $c_s_DummyImplicit$.prototype;
var $d_s_DummyImplicit$ = new $TypeData().initClass({
  s_DummyImplicit$: 0
}, false, "scala.DummyImplicit$", {
  s_DummyImplicit$: 1,
  O: 1
});
$c_s_DummyImplicit$.prototype.$classData = $d_s_DummyImplicit$;
var $n_s_DummyImplicit$;
function $m_s_DummyImplicit$() {
  if ((!$n_s_DummyImplicit$)) {
    $n_s_DummyImplicit$ = new $c_s_DummyImplicit$()
  };
  return $n_s_DummyImplicit$
}
function $is_F0(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F0)))
}
function $as_F0(obj) {
  return (($is_F0(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function0"))
}
function $isArrayOf_F0(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F0)))
}
function $asArrayOf_F0(obj, depth) {
  return (($isArrayOf_F0(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function0;", depth))
}
function $f_F1__compose__F1__F1($thiz, g) {
  return new $c_sjsr_AnonFunction1(((x$2) => $thiz.apply__O__O($n(g).apply__O__O(x$2))))
}
function $f_F1__andThen__F1__F1($thiz, g) {
  return new $c_sjsr_AnonFunction1(((x$2) => $n(g).apply__O__O($thiz.apply__O__O(x$2))))
}
function $is_F1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F1)))
}
function $as_F1(obj) {
  return (($is_F1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function1"))
}
function $isArrayOf_F1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F1)))
}
function $asArrayOf_F1(obj, depth) {
  return (($isArrayOf_F1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function1;", depth))
}
function $is_F10(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F10)))
}
function $as_F10(obj) {
  return (($is_F10(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function10"))
}
function $isArrayOf_F10(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F10)))
}
function $asArrayOf_F10(obj, depth) {
  return (($isArrayOf_F10(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function10;", depth))
}
function $is_F11(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F11)))
}
function $as_F11(obj) {
  return (($is_F11(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function11"))
}
function $isArrayOf_F11(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F11)))
}
function $asArrayOf_F11(obj, depth) {
  return (($isArrayOf_F11(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function11;", depth))
}
function $is_F12(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F12)))
}
function $as_F12(obj) {
  return (($is_F12(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function12"))
}
function $isArrayOf_F12(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F12)))
}
function $asArrayOf_F12(obj, depth) {
  return (($isArrayOf_F12(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function12;", depth))
}
function $is_F13(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F13)))
}
function $as_F13(obj) {
  return (($is_F13(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function13"))
}
function $isArrayOf_F13(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F13)))
}
function $asArrayOf_F13(obj, depth) {
  return (($isArrayOf_F13(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function13;", depth))
}
function $f_F2__tupled__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var x1$2 = $n(x0$1)._1__O();
      var x2 = $n(x0$1)._2__O();
      return $thiz.apply__O__O__O(x1$2, x2)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))
}
function $is_F2(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F2)))
}
function $as_F2(obj) {
  return (($is_F2(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function2"))
}
function $isArrayOf_F2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F2)))
}
function $asArrayOf_F2(obj, depth) {
  return (($isArrayOf_F2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function2;", depth))
}
function $f_F3__tupled__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T3(x0$1$2);
    if ((x0$1 !== null)) {
      var x1$2 = $n(x0$1).T3__f__1;
      var x2 = $n(x0$1).T3__f__2;
      var x3 = $n(x0$1).T3__f__3;
      return $thiz.apply__O__O__O__O(x1$2, x2, x3)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))
}
function $is_F3(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F3)))
}
function $as_F3(obj) {
  return (($is_F3(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function3"))
}
function $isArrayOf_F3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F3)))
}
function $asArrayOf_F3(obj, depth) {
  return (($isArrayOf_F3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function3;", depth))
}
function $f_F4__tupled__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T4(x0$1$2);
    if ((x0$1 !== null)) {
      var x1$2 = $n(x0$1).T4__f__1;
      var x2 = $n(x0$1).T4__f__2;
      var x3 = $n(x0$1).T4__f__3;
      var x4 = $n(x0$1).T4__f__4;
      return $thiz.apply__O__O__O__O__O(x1$2, x2, x3, x4)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))
}
function $is_F4(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F4)))
}
function $as_F4(obj) {
  return (($is_F4(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function4"))
}
function $isArrayOf_F4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F4)))
}
function $asArrayOf_F4(obj, depth) {
  return (($isArrayOf_F4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function4;", depth))
}
function $is_F5(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F5)))
}
function $as_F5(obj) {
  return (($is_F5(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function5"))
}
function $isArrayOf_F5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F5)))
}
function $asArrayOf_F5(obj, depth) {
  return (($isArrayOf_F5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function5;", depth))
}
function $is_F6(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F6)))
}
function $as_F6(obj) {
  return (($is_F6(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function6"))
}
function $isArrayOf_F6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F6)))
}
function $asArrayOf_F6(obj, depth) {
  return (($isArrayOf_F6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function6;", depth))
}
function $f_F7__tupled__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T7(x0$1$2);
    if ((x0$1 !== null)) {
      var x1$2 = $n(x0$1).T7__f__1;
      var x2 = $n(x0$1).T7__f__2;
      var x3 = $n(x0$1).T7__f__3;
      var x4 = $n(x0$1).T7__f__4;
      var x5 = $n(x0$1).T7__f__5;
      var x6 = $n(x0$1).T7__f__6;
      var x7 = $n(x0$1).T7__f__7;
      return $thiz.apply__O__O__O__O__O__O__O__O(x1$2, x2, x3, x4, x5, x6, x7)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))
}
function $is_F7(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F7)))
}
function $as_F7(obj) {
  return (($is_F7(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function7"))
}
function $isArrayOf_F7(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F7)))
}
function $asArrayOf_F7(obj, depth) {
  return (($isArrayOf_F7(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function7;", depth))
}
function $is_F8(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F8)))
}
function $as_F8(obj) {
  return (($is_F8(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function8"))
}
function $isArrayOf_F8(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F8)))
}
function $asArrayOf_F8(obj, depth) {
  return (($isArrayOf_F8(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function8;", depth))
}
function $is_F9(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F9)))
}
function $as_F9(obj) {
  return (($is_F9(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function9"))
}
function $isArrayOf_F9(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F9)))
}
function $asArrayOf_F9(obj, depth) {
  return (($isArrayOf_F9(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function9;", depth))
}
function $ct_s_JSUniquenessCache__($thiz) {
  $thiz.s_JSUniquenessCache__f_cache = {};
  return $thiz
}
/** @constructor */
function $c_s_JSUniquenessCache() {
  this.s_JSUniquenessCache__f_cache = null
}
$c_s_JSUniquenessCache.prototype = new $h_O();
$c_s_JSUniquenessCache.prototype.constructor = $c_s_JSUniquenessCache;
/** @constructor */
function $h_s_JSUniquenessCache() {
  /*<skip>*/
}
$h_s_JSUniquenessCache.prototype = $c_s_JSUniquenessCache.prototype;
$c_s_JSUniquenessCache.prototype.apply__T__O = (function(name) {
  var dict = this.s_JSUniquenessCache__f_cache;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, name))) {
    return dict[name]
  } else {
    var v = new $c_s_Symbol(name);
    dict[name] = v;
    return v
  }
});
/** @constructor */
function $c_s_LowPriorityImplicits2() {
  /*<skip>*/
}
$c_s_LowPriorityImplicits2.prototype = new $h_O();
$c_s_LowPriorityImplicits2.prototype.constructor = $c_s_LowPriorityImplicits2;
/** @constructor */
function $h_s_LowPriorityImplicits2() {
  /*<skip>*/
}
$h_s_LowPriorityImplicits2.prototype = $c_s_LowPriorityImplicits2.prototype;
$c_s_LowPriorityImplicits2.prototype.copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq = (function(xs) {
  return ((xs === null) ? null : $m_sc_ArrayOps$().toIndexedSeq$extension__O__sci_IndexedSeq(xs))
});
/** @constructor */
function $c_s_Option$WithFilter(outer, p) {
  this.s_Option$WithFilter__f_p = null;
  this.s_Option$WithFilter__f_$outer = null;
  this.s_Option$WithFilter__f_p = p;
  if ((outer === null)) {
    $n(null)
  } else {
    this.s_Option$WithFilter__f_$outer = outer
  }
}
$c_s_Option$WithFilter.prototype = new $h_O();
$c_s_Option$WithFilter.prototype.constructor = $c_s_Option$WithFilter;
/** @constructor */
function $h_s_Option$WithFilter() {
  /*<skip>*/
}
$h_s_Option$WithFilter.prototype = $c_s_Option$WithFilter.prototype;
$c_s_Option$WithFilter.prototype.flatMap__F1__s_Option = (function(f) {
  var this$1 = $n(this.s_Option$WithFilter__f_$outer);
  var p = this.s_Option$WithFilter__f_p;
  var this$2 = $n(((this$1.isEmpty__Z() || $uZ($n(p).apply__O__O(this$1.get__O()))) ? this$1 : $m_s_None$()));
  return (this$2.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(f).apply__O__O(this$2.get__O())))
});
$c_s_Option$WithFilter.prototype.withFilter__F1__s_Option$WithFilter = (function(q) {
  return new $c_s_Option$WithFilter(this.s_Option$WithFilter__f_$outer, new $c_sjsr_AnonFunction1(((x$2) => ($uZ($n(this.s_Option$WithFilter__f_p).apply__O__O(x$2)) && $uZ($n(q).apply__O__O(x$2))))))
});
var $d_s_Option$WithFilter = new $TypeData().initClass({
  s_Option$WithFilter: 0
}, false, "scala.Option$WithFilter", {
  s_Option$WithFilter: 1,
  O: 1
});
$c_s_Option$WithFilter.prototype.$classData = $d_s_Option$WithFilter;
/** @constructor */
function $c_s_PartialFunction$() {
  this.s_PartialFunction$__f_fallback_fn = null;
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = null;
  this.s_PartialFunction$__f_empty_pf = null;
  $n_s_PartialFunction$ = this;
  this.s_PartialFunction$__f_fallback_fn = new $c_sjsr_AnonFunction1(((x$2$2) => $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn));
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = new $c_sjsr_AnonFunction1(((x$3$2) => false));
  this.s_PartialFunction$__f_empty_pf = new $c_s_PartialFunction$$anon$1()
}
$c_s_PartialFunction$.prototype = new $h_O();
$c_s_PartialFunction$.prototype.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
  /*<skip>*/
}
$h_s_PartialFunction$.prototype = $c_s_PartialFunction$.prototype;
$c_s_PartialFunction$.prototype.scala$PartialFunction$$fallbackOccurred__O__Z = (function(x) {
  return (this.s_PartialFunction$__f_fallback_fn === x)
});
var $d_s_PartialFunction$ = new $TypeData().initClass({
  s_PartialFunction$: 0
}, false, "scala.PartialFunction$", {
  s_PartialFunction$: 1,
  O: 1
});
$c_s_PartialFunction$.prototype.$classData = $d_s_PartialFunction$;
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$()
  };
  return $n_s_PartialFunction$
}
function $f_s_Proxy__toString__T($thiz) {
  return ("" + $thiz.self__O())
}
/** @constructor */
function $c_s_annotation_Annotation() {
  /*<skip>*/
}
$c_s_annotation_Annotation.prototype = new $h_O();
$c_s_annotation_Annotation.prototype.constructor = $c_s_annotation_Annotation;
/** @constructor */
function $h_s_annotation_Annotation() {
  /*<skip>*/
}
$h_s_annotation_Annotation.prototype = $c_s_annotation_Annotation.prototype;
function $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O($thiz, len$1, \u03b4this$2, ord$1) {
  if ((len$1 < 300)) {
    var a = $m_sr_ScalaRunTime$().array_clone__O__O(\u03b4this$2);
    var this$1 = $m_s_util_Sorting$();
    this$1.stableSort__O__I__I__s_math_Ordering__V(a, 0, $m_jl_reflect_Array$().getLength__O__I(a), ord$1);
    return a
  } else {
    var this$5 = $m_s_Array$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    var this$6 = $n(\u03b4this$2);
    if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($n($objectGetClass(this$6)).getComponentType__jl_Class())) {
      if ($d_O.getClassOf().isPrimitive__Z()) {
        var $$x1 = this$5.copyOf__O__I__O(\u03b4this$2, len$1)
      } else {
        var original = $asArrayOf_O(\u03b4this$2, 1);
        var $$x1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, len$1, $d_O.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_O(len$1);
      $m_s_Array$().copy__O__I__O__I__I__V(\u03b4this$2, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(\u03b4this$2));
      var $$x1 = dest
    };
    var a$2 = $asArrayOf_O($$x1, 1);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a$2, ord$1);
    var $$x3 = $m_s_Array$();
    $m_sc_ArrayOps$();
    var $$x2 = $m_s_reflect_ClassTag$();
    var this$10 = $n(\u03b4this$2);
    return $n($$x3).copyAs__O__I__s_reflect_ClassTag__O(a$2, len$1, $n($$x2).apply__jl_Class__s_reflect_ClassTag($n($objectGetClass(this$10)).getComponentType__jl_Class()))
  }
}
/** @constructor */
function $c_sc_ArrayOps$() {
  this.sc_ArrayOps$__f_fallback = null;
  $n_sc_ArrayOps$ = this;
  this.sc_ArrayOps$__f_fallback = new $c_sjsr_AnonFunction1(((x$1$2) => $m_sc_ArrayOps$().sc_ArrayOps$__f_fallback))
}
$c_sc_ArrayOps$.prototype = new $h_O();
$c_sc_ArrayOps$.prototype.constructor = $c_sc_ArrayOps$;
/** @constructor */
function $h_sc_ArrayOps$() {
  /*<skip>*/
}
$h_sc_ArrayOps$.prototype = $c_sc_ArrayOps$.prototype;
$c_sc_ArrayOps$.prototype.slice$extension__O__I__I__O = (function(this$, from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = $m_jl_reflect_Array$().getLength__O__I(this$);
  var hi = ((until < b) ? until : b);
  if ((hi > lo)) {
    if ((this$ instanceof $ac_O)) {
      var x2 = $asArrayOf_O(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AO__I__I__AO(x2, lo, hi)
    } else if ((this$ instanceof $ac_I)) {
      var x3 = $asArrayOf_I(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AI__I__I__AI(x3, lo, hi)
    } else if ((this$ instanceof $ac_D)) {
      var x4 = $asArrayOf_D(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AD__I__I__AD(x4, lo, hi)
    } else if ((this$ instanceof $ac_J)) {
      var x5 = $asArrayOf_J(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AJ__I__I__AJ(x5, lo, hi)
    } else if ((this$ instanceof $ac_F)) {
      var x6 = $asArrayOf_F(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AF__I__I__AF(x6, lo, hi)
    } else if ((this$ instanceof $ac_C)) {
      var x7 = $asArrayOf_C(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AC__I__I__AC(x7, lo, hi)
    } else if ((this$ instanceof $ac_B)) {
      var x8 = $asArrayOf_B(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AB__I__I__AB(x8, lo, hi)
    } else if ((this$ instanceof $ac_S)) {
      var x9 = $asArrayOf_S(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AS__I__I__AS(x9, lo, hi)
    } else if ((this$ instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AZ__I__I__AZ(x10, lo, hi)
    } else {
      throw new $c_s_MatchError(this$)
    }
  } else {
    $m_sc_ArrayOps$();
    var $$x1 = $m_s_reflect_ClassTag$();
    var this$5 = $n(this$);
    return $n($n($$x1).apply__jl_Class__s_reflect_ClassTag($n($objectGetClass(this$5)).getComponentType__jl_Class())).newArray__I__O(0)
  }
});
$c_sc_ArrayOps$.prototype.tail$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty array")
  } else {
    return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 1, $m_jl_reflect_Array$().getLength__O__I(this$))
  }
});
$c_sc_ArrayOps$.prototype.init$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "init of empty array")
  } else {
    return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, (((-1) + $m_jl_reflect_Array$().getLength__O__I(this$)) | 0))
  }
});
$c_sc_ArrayOps$.prototype.drop$extension__O__I__O = (function(this$, n) {
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, n, $m_jl_reflect_Array$().getLength__O__I(this$))
});
$c_sc_ArrayOps$.prototype.dropRight$extension__O__I__O = (function(this$, n) {
  $m_sc_ArrayOps$();
  var n$1 = (($m_jl_reflect_Array$().getLength__O__I(this$) - ((n > 0) ? n : 0)) | 0);
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, n$1)
});
$c_sc_ArrayOps$.prototype.sorted$extension__O__s_math_Ordering__O = (function(this$, ord) {
  var len = $m_jl_reflect_Array$().getLength__O__I(this$);
  if ((len <= 1)) {
    return $m_sr_ScalaRunTime$().array_clone__O__O(this$)
  } else if ((this$ instanceof $ac_O)) {
    var x2 = $asArrayOf_O(this$, 1);
    var a = $m_ju_Arrays$().copyOf__AO__I__AO(x2, len);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return a
  } else if ((this$ instanceof $ac_I)) {
    var x3 = $asArrayOf_I(this$, 1);
    if ((ord === $m_s_math_Ordering$Int$())) {
      var a$2 = $m_ju_Arrays$().copyOf__AI__I__AI(x3, len);
      $m_ju_Arrays$().sort__AI__V(a$2);
      return a$2
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_J)) {
    var x4 = $asArrayOf_J(this$, 1);
    if ((ord === $m_s_math_Ordering$Long$())) {
      var a$3 = $m_ju_Arrays$().copyOf__AJ__I__AJ(x4, len);
      $m_ju_Arrays$().sort__AJ__V(a$3);
      return a$3
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_C)) {
    var x5 = $asArrayOf_C(this$, 1);
    if ((ord === $m_s_math_Ordering$Char$())) {
      var a$4 = $m_ju_Arrays$().copyOf__AC__I__AC(x5, len);
      $m_ju_Arrays$().sort__AC__V(a$4);
      return a$4
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_B)) {
    var x6 = $asArrayOf_B(this$, 1);
    if ((ord === $m_s_math_Ordering$Byte$())) {
      var a$5 = $m_ju_Arrays$().copyOf__AB__I__AB(x6, len);
      $m_ju_Arrays$().sort__AB__V(a$5);
      return a$5
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_S)) {
    var x7 = $asArrayOf_S(this$, 1);
    if ((ord === $m_s_math_Ordering$Short$())) {
      var a$6 = $m_ju_Arrays$().copyOf__AS__I__AS(x7, len);
      $m_ju_Arrays$().sort__AS__V(a$6);
      return a$6
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_Z)) {
    var x8 = $asArrayOf_Z(this$, 1);
    if ((ord === $m_s_math_Ordering$Boolean$())) {
      var a$7 = $m_ju_Arrays$().copyOf__AZ__I__AZ(x8, len);
      var this$2 = $m_s_util_Sorting$();
      var evidence$3 = $m_s_math_Ordering$Boolean$();
      this$2.stableSort__O__I__I__s_math_Ordering__V(a$7, 0, $n(a$7).u.length, evidence$3);
      return a$7
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else {
    return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
  }
});
$c_sc_ArrayOps$.prototype.zipWithIndex$extension__O__AT2 = (function(this$) {
  var b = new ($d_T2.getArrayOf().constr)($m_jl_reflect_Array$().getLength__O__I(this$));
  var i = 0;
  while ((i < $m_jl_reflect_Array$().getLength__O__I(this$))) {
    $n(b).set(i, $ct_T2__O__O__(new $c_T2(), $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, i), i));
    i = ((1 + i) | 0)
  };
  return b
});
$c_sc_ArrayOps$.prototype.toIndexedSeq$extension__O__sci_IndexedSeq = (function(this$) {
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_s_Array$().copyOf__O__I__O(this$, $m_jl_reflect_Array$().getLength__O__I(this$)))
});
$c_sc_ArrayOps$.prototype.copyToArray$extension__O__O__I__I__I = (function(this$, xs, start, len) {
  var srcLen = $m_jl_reflect_Array$().getLength__O__I(this$);
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this$, 0, xs, start, copied)
  };
  return copied
});
$c_sc_ArrayOps$.prototype.sliding$extension__O__I__I__sc_Iterator = (function(this$, size, step) {
  var this$1 = $n($m_scm_ArraySeq$().make__O__scm_ArraySeq(this$));
  var this$6 = $n($f_sc_IterableOps__sliding__I__I__sc_Iterator(this$1, size, step));
  var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_scm_ArraySeq(x$5$2);
    var this$5 = $n(x$5);
    $m_sc_ArrayOps$();
    var $$x1 = $m_s_reflect_ClassTag$();
    var this$4 = $n(this$);
    var evidence$2 = $n($$x1).apply__jl_Class__s_reflect_ClassTag($n($objectGetClass(this$4)).getComponentType__jl_Class());
    return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this$5, evidence$2)
  }));
  return new $c_sc_Iterator$$anon$9(this$6, f)
});
var $d_sc_ArrayOps$ = new $TypeData().initClass({
  sc_ArrayOps$: 0
}, false, "scala.collection.ArrayOps$", {
  sc_ArrayOps$: 1,
  O: 1
});
$c_sc_ArrayOps$.prototype.$classData = $d_sc_ArrayOps$;
var $n_sc_ArrayOps$;
function $m_sc_ArrayOps$() {
  if ((!$n_sc_ArrayOps$)) {
    $n_sc_ArrayOps$ = new $c_sc_ArrayOps$()
  };
  return $n_sc_ArrayOps$
}
/** @constructor */
function $c_sc_BitSetOps$() {
  /*<skip>*/
}
$c_sc_BitSetOps$.prototype = new $h_O();
$c_sc_BitSetOps$.prototype.constructor = $c_sc_BitSetOps$;
/** @constructor */
function $h_sc_BitSetOps$() {
  /*<skip>*/
}
$h_sc_BitSetOps$.prototype = $c_sc_BitSetOps$.prototype;
$c_sc_BitSetOps$.prototype.updateArray__AJ__I__J__AJ = (function(elems, idx, w) {
  var len = $n(elems).u.length;
  while (true) {
    if ((len > 0)) {
      var this$1 = $n(elems).get((((-1) + len) | 0));
      if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
        var $$x1 = true
      } else {
        var $$x1 = (((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)) && (idx === (((-1) + len) | 0)))
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      len = (((-1) + len) | 0)
    } else {
      break
    }
  };
  var newlen = len;
  if (((idx >= newlen) && (!((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0))))) {
    newlen = ((1 + idx) | 0)
  };
  var newelems = new $ac_J(newlen);
  $m_s_Array$().copy__O__I__O__I__I__V(elems, 0, newelems, 0, len);
  if ((idx < newlen)) {
    $n(newelems).set(idx, w)
  } else {
    $m_s_Predef$().assert__Z__V(((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)))
  };
  return newelems
});
$c_sc_BitSetOps$.prototype.computeWordForFilter__F1__Z__J__I__J = (function(pred, isFlipped, oldWord, wordIndex) {
  if (((oldWord.RTLong__f_lo === 0) && (oldWord.RTLong__f_hi === 0))) {
    return $L0
  } else {
    var lo = oldWord.RTLong__f_lo;
    var hi = oldWord.RTLong__f_hi;
    var w__lo = lo;
    var w__hi = hi;
    var l__lo = w__lo;
    var l__hi = w__hi;
    var lo$1 = l__lo;
    if ((lo$1 !== 0)) {
      if ((lo$1 === 0)) {
        var trailingZeroes = 32
      } else {
        var i = (lo$1 & ((-lo$1) | 0));
        var trailingZeroes = ((31 - $uI(Math.clz32(i))) | 0)
      }
    } else {
      var hi$1 = l__hi;
      if ((hi$1 === 0)) {
        var $$x1 = 32
      } else {
        var i$1 = (hi$1 & ((-hi$1) | 0));
        var $$x1 = ((31 - $uI(Math.clz32(i$1))) | 0)
      };
      var trailingZeroes = ((32 + $$x1) | 0)
    };
    var lo$2 = (((32 & trailingZeroes) === 0) ? (1 << trailingZeroes) : 0);
    var hi$2 = (((32 & trailingZeroes) === 0) ? 0 : (1 << trailingZeroes));
    var jmask__lo = lo$2;
    var jmask__hi = hi$2;
    var j = (((wordIndex << 6) + trailingZeroes) | 0);
    var l$1__lo = w__lo;
    var l$1__hi = w__hi;
    var hi$3 = l$1__hi;
    if ((hi$3 !== 0)) {
      var $$x2 = $uI(Math.clz32(hi$3))
    } else {
      var i$2 = l$1__lo;
      var $$x2 = ((32 + $uI(Math.clz32(i$2))) | 0)
    };
    var maxJ = (((((1 + wordIndex) | 0) << 6) - $$x2) | 0);
    while ((j !== maxJ)) {
      var this$7__lo = w__lo;
      var this$7__hi = w__hi;
      var b__lo = jmask__lo;
      var b__hi = jmask__hi;
      var lo$3 = (this$7__lo & b__lo);
      var hi$4 = (this$7__hi & b__hi);
      if ((!((lo$3 === 0) && (hi$4 === 0)))) {
        if (($n(pred).apply$mcZI$sp__I__Z(j) === isFlipped)) {
          var this$8__lo = w__lo;
          var this$8__hi = w__hi;
          var b$1__lo = jmask__lo;
          var b$1__hi = jmask__hi;
          var lo$4 = (~b$1__lo);
          var hi$5 = (~b$1__hi);
          var lo$5 = (this$8__lo & lo$4);
          var hi$6 = (this$8__hi & hi$5);
          var $$x3__lo = lo$5;
          var $$x3__hi = hi$6;
          w__lo = $$x3__lo;
          w__hi = $$x3__hi
        }
      };
      var this$9__lo = jmask__lo;
      var this$9__hi = jmask__hi;
      var lo$6 = this$9__lo;
      var lo$7 = (lo$6 << 1);
      var hi$7 = (((lo$6 >>> 31) | 0) | (this$9__hi << 1));
      var $$x4__lo = lo$7;
      var $$x4__hi = hi$7;
      jmask__lo = $$x4__lo;
      jmask__hi = $$x4__hi;
      j = ((1 + j) | 0)
    };
    return new $c_RTLong(w__lo, w__hi)
  }
});
var $d_sc_BitSetOps$ = new $TypeData().initClass({
  sc_BitSetOps$: 0
}, false, "scala.collection.BitSetOps$", {
  sc_BitSetOps$: 1,
  O: 1
});
$c_sc_BitSetOps$.prototype.$classData = $d_sc_BitSetOps$;
var $n_sc_BitSetOps$;
function $m_sc_BitSetOps$() {
  if ((!$n_sc_BitSetOps$)) {
    $n_sc_BitSetOps$ = new $c_sc_BitSetOps$()
  };
  return $n_sc_BitSetOps$
}
/** @constructor */
function $c_sc_Factory$() {
  this.sc_Factory$__f_stringFactory = null;
  $n_sc_Factory$ = this;
  this.sc_Factory$__f_stringFactory = new $c_sc_Factory$StringFactory()
}
$c_sc_Factory$.prototype = new $h_O();
$c_sc_Factory$.prototype.constructor = $c_sc_Factory$;
/** @constructor */
function $h_sc_Factory$() {
  /*<skip>*/
}
$h_sc_Factory$.prototype = $c_sc_Factory$.prototype;
var $d_sc_Factory$ = new $TypeData().initClass({
  sc_Factory$: 0
}, false, "scala.collection.Factory$", {
  sc_Factory$: 1,
  O: 1
});
$c_sc_Factory$.prototype.$classData = $d_sc_Factory$;
var $n_sc_Factory$;
function $m_sc_Factory$() {
  if ((!$n_sc_Factory$)) {
    $n_sc_Factory$ = new $c_sc_Factory$()
  };
  return $n_sc_Factory$
}
/** @constructor */
function $c_sc_Hashing$() {
  /*<skip>*/
}
$c_sc_Hashing$.prototype = new $h_O();
$c_sc_Hashing$.prototype.constructor = $c_sc_Hashing$;
/** @constructor */
function $h_sc_Hashing$() {
  /*<skip>*/
}
$h_sc_Hashing$.prototype = $c_sc_Hashing$.prototype;
$c_sc_Hashing$.prototype.improve__I__I = (function(hcode) {
  var h = ((hcode + (~(hcode << 9))) | 0);
  h = (h ^ ((h >>> 14) | 0));
  h = ((h + (h << 4)) | 0);
  return (h ^ ((h >>> 10) | 0))
});
var $d_sc_Hashing$ = new $TypeData().initClass({
  sc_Hashing$: 0
}, false, "scala.collection.Hashing$", {
  sc_Hashing$: 1,
  O: 1
});
$c_sc_Hashing$.prototype.$classData = $d_sc_Hashing$;
var $n_sc_Hashing$;
function $m_sc_Hashing$() {
  if ((!$n_sc_Hashing$)) {
    $n_sc_Hashing$ = new $c_sc_Hashing$()
  };
  return $n_sc_Hashing$
}
function $is_sc_IterableOnce(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnce)))
}
function $as_sc_IterableOnce(obj) {
  return (($is_sc_IterableOnce(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnce"))
}
function $isArrayOf_sc_IterableOnce(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnce)))
}
function $asArrayOf_sc_IterableOnce(obj, depth) {
  return (($isArrayOf_sc_IterableOnce(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnce;", depth))
}
/** @constructor */
function $c_sc_IterableOnceExtensionMethods$() {
  /*<skip>*/
}
$c_sc_IterableOnceExtensionMethods$.prototype = new $h_O();
$c_sc_IterableOnceExtensionMethods$.prototype.constructor = $c_sc_IterableOnceExtensionMethods$;
/** @constructor */
function $h_sc_IterableOnceExtensionMethods$() {
  /*<skip>*/
}
$h_sc_IterableOnceExtensionMethods$.prototype = $c_sc_IterableOnceExtensionMethods$.prototype;
$c_sc_IterableOnceExtensionMethods$.prototype.isEmpty$extension__sc_IterableOnce__Z = (function(this$) {
  if ($is_sc_Iterable(this$)) {
    var x2 = $as_sc_Iterable(this$);
    return $n(x2).isEmpty__Z()
  } else {
    var this$1 = $n($n(this$).iterator__sc_Iterator());
    return (!this$1.hasNext__Z())
  }
});
var $d_sc_IterableOnceExtensionMethods$ = new $TypeData().initClass({
  sc_IterableOnceExtensionMethods$: 0
}, false, "scala.collection.IterableOnceExtensionMethods$", {
  sc_IterableOnceExtensionMethods$: 1,
  O: 1
});
$c_sc_IterableOnceExtensionMethods$.prototype.$classData = $d_sc_IterableOnceExtensionMethods$;
var $n_sc_IterableOnceExtensionMethods$;
function $m_sc_IterableOnceExtensionMethods$() {
  if ((!$n_sc_IterableOnceExtensionMethods$)) {
    $n_sc_IterableOnceExtensionMethods$ = new $c_sc_IterableOnceExtensionMethods$()
  };
  return $n_sc_IterableOnceExtensionMethods$
}
function $f_sc_IterableOnceOps__foreach__F1__V($thiz, f) {
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    $n(f).apply__O__O($n(it).next__O())
  }
}
function $f_sc_IterableOnceOps__forall__F1__Z($thiz, p) {
  var res = true;
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ((res && $n(it).hasNext__Z())) {
    res = $uZ($n(p).apply__O__O($n(it).next__O()))
  };
  return res
}
function $f_sc_IterableOnceOps__exists__F1__Z($thiz, p) {
  var res = false;
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while (((!res) && $n(it).hasNext__Z())) {
    res = $uZ($n(p).apply__O__O($n(it).next__O()))
  };
  return res
}
function $f_sc_IterableOnceOps__find__F1__s_Option($thiz, p) {
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var a = $n(it).next__O();
    if ($uZ($n(p).apply__O__O(a))) {
      return new $c_s_Some(a)
    }
  };
  return $m_s_None$()
}
function $f_sc_IterableOnceOps__foldLeft__O__F2__O($thiz, z, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    var x2 = $as_sc_IndexedSeq($thiz);
    return $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, 0, $n(x2).length__I(), z, op, x2)
  } else {
    var result = z;
    var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      result = $n(op).apply__O__O__O(result, $n(it).next__O())
    };
    return result
  }
}
function $f_sc_IterableOnceOps__reduceLeft__F2__O($thiz, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    var x2 = $as_sc_IndexedSeq($thiz);
    if (($n(x2).length__I() > 0)) {
      var z = $n(x2).apply__I__O(0);
      return $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, 1, $n(x2).length__I(), z, op, x2)
    }
  };
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
  };
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var acc = $n(it).next__O();
    while ($n(it).hasNext__Z()) {
      acc = $n(op).apply__O__O__O(acc, $n(it).next__O())
    };
    return acc
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
  }
}
function $f_sc_IterableOnceOps__isEmpty__Z($thiz) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  switch (x1) {
    case (-1): {
      return (!$n($n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator()).hasNext__Z());
      break
    }
    case 0: {
      return true;
      break
    }
    default: {
      return false
    }
  }
}
function $f_sc_IterableOnceOps__size__I($thiz) {
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() >= 0)) {
    return $n($as_sc_IterableOnce($thiz)).knownSize__I()
  } else {
    var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
    var len = 0;
    while ($n(it).hasNext__Z()) {
      len = ((1 + len) | 0);
      $n(it).next__O()
    };
    return len
  }
}
function $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, xs, start, len) {
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  var i = start;
  var y = (($m_jl_reflect_Array$().getLength__O__I(xs) - start) | 0);
  var end = ((start + ((len < y) ? len : y)) | 0);
  while (((i < end) && $n(it).hasNext__Z())) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(xs, i, $n(it).next__O());
    i = ((1 + i) | 0)
  };
  return ((i - start) | 0)
}
function $f_sc_IterableOnceOps__sum__s_math_Numeric__O($thiz, num) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  switch (x1) {
    case (-1): {
      return $thiz.foldLeft__O__F2__O($n(num).zero__O(), new $c_sjsr_AnonFunction2(((x$2, y$2) => $n(num).plus__O__O__O(x$2, y$2))));
      break
    }
    case 0: {
      return $n(num).zero__O();
      break
    }
    default: {
      var op = new $c_sjsr_AnonFunction2(((x$3$2, y$3$2) => $n(num).plus__O__O__O(x$3$2, y$3$2)));
      return $thiz.reduceLeft__F2__O(op)
    }
  }
}
function $f_sc_IterableOnceOps__min__s_math_Ordering__O($thiz, ord) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  switch (x1) {
    case (-1): {
      var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
      if ($n(it).hasNext__Z()) {
        var acc = $n(it).next__O();
        while ($n(it).hasNext__Z()) {
          var arg1 = acc;
          var arg2 = $n(it).next__O();
          acc = $n(ord).min__O__O__O(arg1, arg2)
        };
        return acc
      } else {
        throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.min")
      };
      break
    }
    case 0: {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.min");
      break
    }
    default: {
      return $thiz.reduceLeft__F2__O(new $c_sjsr_AnonFunction2(((x$3$2, y$3$2) => $n(ord).min__O__O__O(x$3$2, y$3$2))))
    }
  }
}
function $f_sc_IterableOnceOps__max__s_math_Ordering__O($thiz, ord) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  switch (x1) {
    case (-1): {
      var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
      if ($n(it).hasNext__Z()) {
        var acc = $n(it).next__O();
        while ($n(it).hasNext__Z()) {
          var arg1 = acc;
          var arg2 = $n(it).next__O();
          acc = $n(ord).max__O__O__O(arg1, arg2)
        };
        return acc
      } else {
        throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max")
      };
      break
    }
    case 0: {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
      break
    }
    default: {
      return $thiz.reduceLeft__F2__O(new $c_sjsr_AnonFunction2(((x$3$2, y$3$2) => $n(ord).max__O__O__O(x$3$2, y$3$2))))
    }
  }
}
function $f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O($thiz, f, ord) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  if ((x1 === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.maxBy")
  } else {
    return $n($as_sc_IterableOnceOps$Maximized($thiz.foldLeft__O__F2__O(new $c_sc_IterableOnceOps$Maximized($thiz, "maxBy", f, new $c_sjsr_AnonFunction2(((x$2, y$2) => $n(ord).gt__O__O__Z(x$2, y$2)))), new $c_sjsr_AnonFunction2(((m$2, a$2) => {
      var m = $as_sc_IterableOnceOps$Maximized(m$2);
      return $n(m).apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized(m, a$2)
    }))))).result__O()
  }
}
function $f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O($thiz, f, ord) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  if ((x1 === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.minBy")
  } else {
    return $n($as_sc_IterableOnceOps$Maximized($thiz.foldLeft__O__F2__O(new $c_sc_IterableOnceOps$Maximized($thiz, "minBy", f, new $c_sjsr_AnonFunction2(((x$2, y$2) => $n(ord).lt__O__O__Z(x$2, y$2)))), new $c_sjsr_AnonFunction2(((m$2, a$2) => {
      var m = $as_sc_IterableOnceOps$Maximized(m$2);
      return $n(m).apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized(m, a$2)
    }))))).result__O()
  }
}
function $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option($thiz, pf) {
  var sentinel = new $c_sc_IterableOnceOps$$anon$1($thiz);
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var x = $n(pf).applyOrElse__O__F1__O($n(it).next__O(), sentinel);
    if ((x !== sentinel)) {
      return new $c_s_Some(x)
    }
  };
  return $m_s_None$()
}
function $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, sep, end) {
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() === 0)) {
    return (("" + start) + end)
  } else {
    var this$1 = $n($thiz.addString__scm_StringBuilder__T__T__T__scm_StringBuilder($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), start, sep, end));
    return $n(this$1.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
}
function $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, b, start, sep, end) {
  var jsb = $n(b).scm_StringBuilder__f_underlying;
  var this$1 = $n(start);
  if ((this$1.length !== 0)) {
    var this$2 = $n(jsb);
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start)
  };
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var this$3 = $n(jsb);
    var obj = $n(it).next__O();
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    while ($n(it).hasNext__Z()) {
      var this$4 = $n(jsb);
      this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      var this$5 = $n(jsb);
      var obj$1 = $n(it).next__O();
      this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1)
    }
  };
  var this$6 = $n(end);
  if ((this$6.length !== 0)) {
    var this$7 = $n(jsb);
    this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end)
  };
  return b
}
function $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($thiz, evidence$2) {
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() >= 0)) {
    var destination = $n(evidence$2).newArray__I__O($n($as_sc_IterableOnce($thiz)).knownSize__I());
    $thiz.copyToArray__O__I__I__I(destination, 0, 2147483647);
    return destination
  } else {
    var capacity = 0;
    var jsElems = null;
    var elementClass = $n(evidence$2).runtimeClass__jl_Class();
    capacity = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var xs = $as_sc_IterableOnce($thiz);
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(elementClass).jl_Class__f_data.zero : elem));
      jsElems.push(unboxedElem)
    };
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return $n(elemRuntimeClass).jl_Class__f_data.getArrayOf().wrapArray(jsElems)
  }
}
function $f_sc_IterableOnceOps__reversed__sc_Iterable($thiz) {
  var xs = $m_sci_Nil$();
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var rassoc$1 = $n(it).next__O();
    var this$1 = $n(xs);
    xs = new $c_sci_$colon$colon(rassoc$1, this$1)
  };
  return xs
}
function $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, at, end, acc, op$1, seq$1) {
  while (true) {
    if ((at === end)) {
      return acc
    } else {
      var temp$at = ((1 + at) | 0);
      var temp$acc = $n(op$1).apply__O__O__O(acc, $n(seq$1).apply__I__O(at));
      at = temp$at;
      acc = temp$acc
    }
  }
}
function $is_sc_IterableOnceOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnceOps)))
}
function $as_sc_IterableOnceOps(obj) {
  return (($is_sc_IterableOnceOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnceOps"))
}
function $isArrayOf_sc_IterableOnceOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnceOps)))
}
function $asArrayOf_sc_IterableOnceOps(obj, depth) {
  return (($isArrayOf_sc_IterableOnceOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnceOps;", depth))
}
/** @constructor */
function $c_sc_Iterator$ConcatIteratorCell(head, tail) {
  this.sc_Iterator$ConcatIteratorCell__f_head = null;
  this.sc_Iterator$ConcatIteratorCell__f_tail = null;
  this.sc_Iterator$ConcatIteratorCell__f_head = head;
  this.sc_Iterator$ConcatIteratorCell__f_tail = tail
}
$c_sc_Iterator$ConcatIteratorCell.prototype = new $h_O();
$c_sc_Iterator$ConcatIteratorCell.prototype.constructor = $c_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $h_sc_Iterator$ConcatIteratorCell() {
  /*<skip>*/
}
$h_sc_Iterator$ConcatIteratorCell.prototype = $c_sc_Iterator$ConcatIteratorCell.prototype;
$c_sc_Iterator$ConcatIteratorCell.prototype.headIterator__sc_Iterator = (function() {
  return $n($as_sc_IterableOnce($n(this.sc_Iterator$ConcatIteratorCell__f_head).apply__O())).iterator__sc_Iterator()
});
var $d_sc_Iterator$ConcatIteratorCell = new $TypeData().initClass({
  sc_Iterator$ConcatIteratorCell: 0
}, false, "scala.collection.Iterator$ConcatIteratorCell", {
  sc_Iterator$ConcatIteratorCell: 1,
  O: 1
});
$c_sc_Iterator$ConcatIteratorCell.prototype.$classData = $d_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $c_sc_JavaConverters$AsJava(op) {
  this.sc_JavaConverters$AsJava__f_op = null;
  this.sc_JavaConverters$AsJava__f_op = op
}
$c_sc_JavaConverters$AsJava.prototype = new $h_O();
$c_sc_JavaConverters$AsJava.prototype.constructor = $c_sc_JavaConverters$AsJava;
/** @constructor */
function $h_sc_JavaConverters$AsJava() {
  /*<skip>*/
}
$h_sc_JavaConverters$AsJava.prototype = $c_sc_JavaConverters$AsJava.prototype;
$c_sc_JavaConverters$AsJava.prototype.asJava__O = (function() {
  return $n(this.sc_JavaConverters$AsJava__f_op).apply__O()
});
var $d_sc_JavaConverters$AsJava = new $TypeData().initClass({
  sc_JavaConverters$AsJava: 0
}, false, "scala.collection.JavaConverters$AsJava", {
  sc_JavaConverters$AsJava: 1,
  O: 1
});
$c_sc_JavaConverters$AsJava.prototype.$classData = $d_sc_JavaConverters$AsJava;
/** @constructor */
function $c_sc_JavaConverters$AsScala(op) {
  this.sc_JavaConverters$AsScala__f_op = null;
  this.sc_JavaConverters$AsScala__f_op = op
}
$c_sc_JavaConverters$AsScala.prototype = new $h_O();
$c_sc_JavaConverters$AsScala.prototype.constructor = $c_sc_JavaConverters$AsScala;
/** @constructor */
function $h_sc_JavaConverters$AsScala() {
  /*<skip>*/
}
$h_sc_JavaConverters$AsScala.prototype = $c_sc_JavaConverters$AsScala.prototype;
$c_sc_JavaConverters$AsScala.prototype.asScala__O = (function() {
  return $n(this.sc_JavaConverters$AsScala__f_op).apply__O()
});
var $d_sc_JavaConverters$AsScala = new $TypeData().initClass({
  sc_JavaConverters$AsScala: 0
}, false, "scala.collection.JavaConverters$AsScala", {
  sc_JavaConverters$AsScala: 1,
  O: 1
});
$c_sc_JavaConverters$AsScala.prototype.$classData = $d_sc_JavaConverters$AsScala;
function $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps($thiz) {
  if ((!$thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0)) {
    $thiz.sc_LinearSeqIterator$LazyCell__f_v = $as_sc_LinearSeqOps($n($thiz.sc_LinearSeqIterator$LazyCell__f_st).apply__O());
    $thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = true
  };
  $thiz.sc_LinearSeqIterator$LazyCell__f_st = null;
  return $thiz.sc_LinearSeqIterator$LazyCell__f_v
}
/** @constructor */
function $c_sc_LinearSeqIterator$LazyCell(outer, st) {
  this.sc_LinearSeqIterator$LazyCell__f_v = null;
  this.sc_LinearSeqIterator$LazyCell__f_st = null;
  this.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = false;
  this.sc_LinearSeqIterator$LazyCell__f_st = st
}
$c_sc_LinearSeqIterator$LazyCell.prototype = new $h_O();
$c_sc_LinearSeqIterator$LazyCell.prototype.constructor = $c_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $h_sc_LinearSeqIterator$LazyCell() {
  /*<skip>*/
}
$h_sc_LinearSeqIterator$LazyCell.prototype = $c_sc_LinearSeqIterator$LazyCell.prototype;
$c_sc_LinearSeqIterator$LazyCell.prototype.v__sc_LinearSeqOps = (function() {
  return ((!this.sc_LinearSeqIterator$LazyCell__f_bitmap$0) ? $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps(this) : this.sc_LinearSeqIterator$LazyCell__f_v)
});
var $d_sc_LinearSeqIterator$LazyCell = new $TypeData().initClass({
  sc_LinearSeqIterator$LazyCell: 0
}, false, "scala.collection.LinearSeqIterator$LazyCell", {
  sc_LinearSeqIterator$LazyCell: 1,
  O: 1
});
$c_sc_LinearSeqIterator$LazyCell.prototype.$classData = $d_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $c_sc_SeqFactory$UnapplySeqWrapper(c) {
  this.sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c = null;
  this.sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c = c
}
$c_sc_SeqFactory$UnapplySeqWrapper.prototype = new $h_O();
$c_sc_SeqFactory$UnapplySeqWrapper.prototype.constructor = $c_sc_SeqFactory$UnapplySeqWrapper;
/** @constructor */
function $h_sc_SeqFactory$UnapplySeqWrapper() {
  /*<skip>*/
}
$h_sc_SeqFactory$UnapplySeqWrapper.prototype = $c_sc_SeqFactory$UnapplySeqWrapper.prototype;
$c_sc_SeqFactory$UnapplySeqWrapper.prototype.hashCode__I = (function() {
  var this$ = this.sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c;
  return $n(this$).hashCode__I()
});
$c_sc_SeqFactory$UnapplySeqWrapper.prototype.equals__O__Z = (function(x$1) {
  return $m_sc_SeqFactory$UnapplySeqWrapper$().equals$extension__sc_SeqOps__O__Z(this.sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c, x$1)
});
function $as_sc_SeqFactory$UnapplySeqWrapper(obj) {
  return (((obj instanceof $c_sc_SeqFactory$UnapplySeqWrapper) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SeqFactory$UnapplySeqWrapper"))
}
function $isArrayOf_sc_SeqFactory$UnapplySeqWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SeqFactory$UnapplySeqWrapper)))
}
function $asArrayOf_sc_SeqFactory$UnapplySeqWrapper(obj, depth) {
  return (($isArrayOf_sc_SeqFactory$UnapplySeqWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SeqFactory$UnapplySeqWrapper;", depth))
}
var $d_sc_SeqFactory$UnapplySeqWrapper = new $TypeData().initClass({
  sc_SeqFactory$UnapplySeqWrapper: 0
}, false, "scala.collection.SeqFactory$UnapplySeqWrapper", {
  sc_SeqFactory$UnapplySeqWrapper: 1,
  O: 1
});
$c_sc_SeqFactory$UnapplySeqWrapper.prototype.$classData = $d_sc_SeqFactory$UnapplySeqWrapper;
/** @constructor */
function $c_sc_SeqFactory$UnapplySeqWrapper$() {
  /*<skip>*/
}
$c_sc_SeqFactory$UnapplySeqWrapper$.prototype = new $h_O();
$c_sc_SeqFactory$UnapplySeqWrapper$.prototype.constructor = $c_sc_SeqFactory$UnapplySeqWrapper$;
/** @constructor */
function $h_sc_SeqFactory$UnapplySeqWrapper$() {
  /*<skip>*/
}
$h_sc_SeqFactory$UnapplySeqWrapper$.prototype = $c_sc_SeqFactory$UnapplySeqWrapper$.prototype;
$c_sc_SeqFactory$UnapplySeqWrapper$.prototype.drop$extension__sc_SeqOps__I__sci_Seq = (function(this$, n) {
  if ($is_sci_Seq(this$)) {
    var x2 = $as_sci_Seq(this$);
    return $as_sci_Seq($n(x2).drop__I__O(n))
  } else {
    var this$1 = $n($n($n(this$).view__sc_SeqView()).drop__I__sc_SeqView(n));
    return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$1)
  }
});
$c_sc_SeqFactory$UnapplySeqWrapper$.prototype.equals$extension__sc_SeqOps__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sc_SeqFactory$UnapplySeqWrapper)) {
    var UnapplySeqWrapper$1 = ((x$1 === null) ? null : $n($as_sc_SeqFactory$UnapplySeqWrapper(x$1)).sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c);
    return ((this$ === null) ? (UnapplySeqWrapper$1 === null) : $n(this$).equals__O__Z(UnapplySeqWrapper$1))
  } else {
    return false
  }
});
var $d_sc_SeqFactory$UnapplySeqWrapper$ = new $TypeData().initClass({
  sc_SeqFactory$UnapplySeqWrapper$: 0
}, false, "scala.collection.SeqFactory$UnapplySeqWrapper$", {
  sc_SeqFactory$UnapplySeqWrapper$: 1,
  O: 1
});
$c_sc_SeqFactory$UnapplySeqWrapper$.prototype.$classData = $d_sc_SeqFactory$UnapplySeqWrapper$;
var $n_sc_SeqFactory$UnapplySeqWrapper$;
function $m_sc_SeqFactory$UnapplySeqWrapper$() {
  if ((!$n_sc_SeqFactory$UnapplySeqWrapper$)) {
    $n_sc_SeqFactory$UnapplySeqWrapper$ = new $c_sc_SeqFactory$UnapplySeqWrapper$()
  };
  return $n_sc_SeqFactory$UnapplySeqWrapper$
}
/** @constructor */
function $c_sc_StringOps$() {
  this.sc_StringOps$__f_fallback = null;
  $n_sc_StringOps$ = this;
  this.sc_StringOps$__f_fallback = new $c_sjsr_AnonFunction1(((x$1$2) => $m_sc_StringOps$().sc_StringOps$__f_fallback))
}
$c_sc_StringOps$.prototype = new $h_O();
$c_sc_StringOps$.prototype.constructor = $c_sc_StringOps$;
/** @constructor */
function $h_sc_StringOps$() {
  /*<skip>*/
}
$h_sc_StringOps$.prototype = $c_sc_StringOps$.prototype;
$c_sc_StringOps$.prototype.contains$extension__T__C__Z = (function(this$, elem) {
  return ($f_T__indexOf__I__I($n(this$), elem) >= 0)
});
$c_sc_StringOps$.prototype.slice$extension__T__I__I__T = (function(this$, from, until) {
  var start = ((from > 0) ? from : 0);
  var this$6 = $n(this$);
  var that = this$6.length;
  var end = ((until < that) ? until : that);
  if ((start >= end)) {
    return ""
  } else {
    var this$10 = $n(this$);
    if ((start < 0)) {
      $charAt(this$10, start)
    };
    if ((end > this$10.length)) {
      $charAt(this$10, end)
    };
    if ((end < start)) {
      $charAt(this$10, (-1))
    };
    return $as_T(this$10.substring(start, end))
  }
});
$c_sc_StringOps$.prototype.$times$extension__T__I__T = (function(this$, n) {
  if ((n <= 0)) {
    return ""
  } else {
    var this$1 = $n(this$);
    var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), Math.imul(this$1.length, n));
    var i = 0;
    while ((i < n)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + this$);
      i = ((1 + i) | 0)
    };
    return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
});
$c_sc_StringOps$.prototype.stripPrefix$extension__T__T__T = (function(this$, prefix) {
  var this$1 = $n(this$);
  if ((this$1.length >= 0)) {
    var this$2 = $n(prefix);
    var $$x2 = this$1.substring(0, this$2.length);
    var $$x1 = ($as_T($$x2) === prefix)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var this$4 = $n(this$);
    var this$3 = $n(prefix);
    var beginIndex = this$3.length;
    if (((beginIndex < 0) || (beginIndex > this$4.length))) {
      $charAt(this$4, beginIndex)
    };
    return $as_T(this$4.substring(beginIndex))
  } else {
    return this$
  }
});
$c_sc_StringOps$.prototype.stripSuffix$extension__T__T__T = (function(this$, suffix) {
  if ($f_T__endsWith__T__Z($n(this$), suffix)) {
    var this$3 = $n(this$);
    var this$1 = $n(this$);
    var this$2 = $n(suffix);
    var endIndex = ((this$1.length - this$2.length) | 0);
    if ((endIndex > this$3.length)) {
      $charAt(this$3, endIndex)
    };
    if ((endIndex < 0)) {
      $charAt(this$3, (-1))
    };
    return $as_T(this$3.substring(0, endIndex))
  } else {
    return this$
  }
});
$c_sc_StringOps$.prototype.stripMargin$extension__T__C__T = (function(this$, marginChar) {
  var this$1 = $n(this$);
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), this$1.length);
  $m_sc_StringOps$();
  $m_sc_StringOps$();
  var this$4 = new $c_sc_StringOps$$anon$1(this$, false);
  while ((this$4.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this$4.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var arg1 = this$4.next__T();
    var this$5 = $n(arg1);
    var len = this$5.length;
    var index = 0;
    while (true) {
      if ((index < len)) {
        var this$6 = $n(arg1);
        var index$1 = index;
        var $$x1 = ($charAt(this$6, index$1) <= 32)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        index = ((1 + index) | 0)
      } else {
        break
      }
    };
    if ((index < len)) {
      var this$7 = $n(arg1);
      var index$2 = index;
      var $$x2 = ($charAt(this$7, index$2) === marginChar)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var this$8 = $n(arg1);
      var beginIndex = ((1 + index) | 0);
      if (((beginIndex < 0) || (beginIndex > this$8.length))) {
        $charAt(this$8, beginIndex)
      };
      var stripped = $as_T(this$8.substring(beginIndex))
    } else {
      var stripped = arg1
    };
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + stripped)
  };
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sc_StringOps$.prototype.escape$extension__T__C__T = (function(this$, ch) {
  return (((((ch >= 97) && (ch <= 122)) || ((ch >= 65) && (ch <= 90))) || ((ch >= 48) && (ch <= 57))) ? $as_T(String.fromCharCode(ch)) : ("\\" + $bC(ch)))
});
$c_sc_StringOps$.prototype.split$extension__T__C__AT = (function(this$, separator) {
  var this$1 = $n(this$);
  var regex = $m_sc_StringOps$().escape$extension__T__C__T(this$, separator);
  return $f_T__split__T__I__AT(this$1, regex, 0)
});
$c_sc_StringOps$.prototype.unwrapArg$extension__T__O__O = (function(this$, arg) {
  if ((arg instanceof $c_s_math_ScalaNumber)) {
    var x2 = $as_s_math_ScalaNumber(arg);
    return $n(x2).underlying__O()
  } else {
    return arg
  }
});
$c_sc_StringOps$.prototype.format$extension__T__sci_Seq__T = (function(this$, args) {
  var args$1 = $asArrayOf_O($n($as_sc_IterableOnceOps($n(args).map__F1__O(new $c_sjsr_AnonFunction1(((arg$2) => $m_sc_StringOps$().unwrapArg$extension__T__O__O(this$, arg$2)))))).toArray__s_reflect_ClassTag__O($m_s_reflect_ManifestFactory$ObjectManifest$()), 1);
  return $m_jl_String$().format__T__AO__T(this$, args$1)
});
$c_sc_StringOps$.prototype.headOption$extension__T__s_Option = (function(this$) {
  var this$1 = $n(this$);
  if ((this$1 === "")) {
    return $m_s_None$()
  } else {
    var this$2 = $n(this$);
    return new $c_s_Some($bC($charAt(this$2, 0)))
  }
});
$c_sc_StringOps$.prototype.reverse$extension__T__T = (function(this$) {
  return $n($ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), this$).reverse__jl_StringBuilder()).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sc_StringOps$.prototype.take$extension__T__I__T = (function(this$, n) {
  var $$x1 = $m_sc_StringOps$();
  var this$1 = $n(this$);
  var y = this$1.length;
  return $n($$x1).slice$extension__T__I__I__T(this$, 0, ((n < y) ? n : y))
});
$c_sc_StringOps$.prototype.drop$extension__T__I__T = (function(this$, n) {
  var $$x1 = $m_sc_StringOps$();
  var this$1 = $n(this$);
  var y = this$1.length;
  var this$4 = $n(this$);
  return $n($$x1).slice$extension__T__I__I__T(this$, ((n < y) ? n : y), this$4.length)
});
var $d_sc_StringOps$ = new $TypeData().initClass({
  sc_StringOps$: 0
}, false, "scala.collection.StringOps$", {
  sc_StringOps$: 1,
  O: 1
});
$c_sc_StringOps$.prototype.$classData = $d_sc_StringOps$;
var $n_sc_StringOps$;
function $m_sc_StringOps$() {
  if ((!$n_sc_StringOps$)) {
    $n_sc_StringOps$ = new $c_sc_StringOps$()
  };
  return $n_sc_StringOps$
}
function $p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, ch) {
  return ((((ch >= 48) && (ch <= 57)) || ((ch >= 97) && (ch <= 102))) || ((ch >= 65) && (ch <= 70)))
}
function $p_sc_StringParsers$__prefixOK$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  var len = ((endIndex - startIndex) | 0);
  if ((len > 0)) {
    var this$1 = $n(format$1);
    if (($charAt(this$1, startIndex) === 46)) {
      if ((len > 1)) {
        var start = ((1 + startIndex) | 0);
        var i = start;
        while (true) {
          if ((i >= endIndex)) {
            return true
          } else {
            var this$2 = $n(format$1);
            var index = i;
            var arg1 = $charAt(this$2, index);
            if ($p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, arg1)) {
              i = ((1 + i) | 0)
            } else {
              return false
            }
          }
        }
      } else {
        return false
      }
    } else {
      var i$1 = startIndex;
      while (true) {
        if ((i$1 < endIndex)) {
          var this$3 = $n(format$1);
          var index$1 = i$1;
          var arg1$1 = $charAt(this$3, index$1);
          var $$x1 = $p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, arg1$1)
        } else {
          var $$x1 = false
        };
        if ($$x1) {
          i$1 = ((1 + i$1) | 0)
        } else {
          break
        }
      };
      var noLeading = i$1;
      if ((noLeading >= endIndex)) {
        return true
      } else {
        var this$4 = $n(format$1);
        if (($charAt(this$4, noLeading) === 46)) {
          var start$1 = ((1 + noLeading) | 0);
          var i$2 = start$1;
          while (true) {
            if ((i$2 >= endIndex)) {
              return true
            } else {
              var this$5 = $n(format$1);
              var index$2 = i$2;
              var arg1$2 = $charAt(this$5, index$2);
              if ($p_sc_StringParsers$__isHexDigit$1__C__Z($thiz, arg1$2)) {
                i$2 = ((1 + i$2) | 0)
              } else {
                return false
              }
            }
          }
        } else {
          return false
        }
      }
    }
  } else {
    return false
  }
}
function $p_sc_StringParsers$__postfixOK$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  if ((startIndex < endIndex)) {
    var i = startIndex;
    var $$x1;
    while (true) {
      if ((i >= endIndex)) {
        var $$x1 = true;
        break
      } else {
        var this$1 = $n(format$1);
        var index = i;
        var arg1 = $charAt(this$1, index);
        if (((arg1 >= 48) && (arg1 <= 57))) {
          i = ((1 + i) | 0)
        } else {
          var $$x1 = false;
          break
        }
      }
    };
    if ($$x1) {
      return true
    } else {
      var this$3 = $n(format$1);
      var startchar = $charAt(this$3, startIndex);
      if ((((startchar === 43) || (startchar === 45)) && (((endIndex - startIndex) | 0) > 1))) {
        var start = ((1 + startIndex) | 0);
        var i$1 = start;
        while (true) {
          if ((i$1 >= endIndex)) {
            return true
          } else {
            var this$4 = $n(format$1);
            var index$1 = i$1;
            var arg1$1 = $charAt(this$4, index$1);
            if (((arg1$1 >= 48) && (arg1$1 <= 57))) {
              i$1 = ((1 + i$1) | 0)
            } else {
              return false
            }
          }
        }
      } else {
        return false
      }
    }
  } else {
    return false
  }
}
function $p_sc_StringParsers$__isHexFloatLiteral$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  $m_sc_StringOps$();
  _return: {
    var this$3 = $n(format$1);
    var len = this$3.length;
    var i = startIndex;
    while ((i < len)) {
      var this$4 = $n(format$1);
      var index = i;
      var arg1 = $charAt(this$4, index);
      if (((arg1 === 112) || (arg1 === 80))) {
        var pIndex = i;
        break _return
      };
      i = ((1 + i) | 0)
    };
    var pIndex = (-1)
  };
  return (((pIndex <= endIndex) && $p_sc_StringParsers$__prefixOK$1__I__I__T__Z($thiz, startIndex, pIndex, format$1)) && $p_sc_StringParsers$__postfixOK$1__I__I__T__Z($thiz, ((1 + pIndex) | 0), endIndex, format$1))
}
function $p_sc_StringParsers$__isExp$1__C__Z($thiz, c) {
  return ((c === 101) || (c === 69))
}
function $p_sc_StringParsers$__expOK$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  if ((startIndex < endIndex)) {
    var this$1 = $n(format$1);
    var startChar = $charAt(this$1, startIndex);
    if (((startChar === 43) || (startChar === 45))) {
      if ((endIndex > ((1 + startIndex) | 0))) {
        var from = ((1 + startIndex) | 0);
        var i = from;
        while (true) {
          if ((i < endIndex)) {
            var this$2 = $n(format$1);
            var index = i;
            var arg1 = $charAt(this$2, index);
            var $$x1 = ((arg1 >= 48) && (arg1 <= 57))
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            i = ((1 + i) | 0)
          } else {
            break
          }
        };
        return (i === endIndex)
      } else {
        return false
      }
    } else {
      var i$1 = startIndex;
      while (true) {
        if ((i$1 < endIndex)) {
          var this$4 = $n(format$1);
          var index$1 = i$1;
          var arg1$1 = $charAt(this$4, index$1);
          var $$x2 = ((arg1$1 >= 48) && (arg1$1 <= 57))
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          i$1 = ((1 + i$1) | 0)
        } else {
          break
        }
      };
      return (i$1 === endIndex)
    }
  } else {
    return false
  }
}
function $p_sc_StringParsers$__isDecFloatLiteral$1__I__I__T__Z($thiz, startIndex, endIndex, format$1) {
  var this$1 = $n(format$1);
  var startChar = $charAt(this$1, startIndex);
  if ((startChar === 46)) {
    var from = ((1 + startIndex) | 0);
    var i = from;
    while (true) {
      if ((i < endIndex)) {
        var this$2 = $n(format$1);
        var index = i;
        var arg1 = $charAt(this$2, index);
        var $$x1 = ((arg1 >= 48) && (arg1 <= 57))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        i = ((1 + i) | 0)
      } else {
        break
      }
    };
    var noSignificant = i;
    if ((noSignificant > ((1 + startIndex) | 0))) {
      if ((noSignificant >= endIndex)) {
        return true
      } else {
        var this$4 = $n(format$1);
        if ($p_sc_StringParsers$__isExp$1__C__Z($thiz, $charAt(this$4, noSignificant))) {
          return $p_sc_StringParsers$__expOK$1__I__I__T__Z($thiz, ((1 + noSignificant) | 0), endIndex, format$1)
        } else {
          return false
        }
      }
    } else {
      return false
    }
  } else if (((startChar >= 48) && (startChar <= 57))) {
    var i$1 = startIndex;
    while (true) {
      if ((i$1 < endIndex)) {
        var this$5 = $n(format$1);
        var index$1 = i$1;
        var arg1$1 = $charAt(this$5, index$1);
        var $$x2 = ((arg1$1 >= 48) && (arg1$1 <= 57))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        i$1 = ((1 + i$1) | 0)
      } else {
        break
      }
    };
    var noInt = i$1;
    if ((noInt === endIndex)) {
      return true
    } else {
      var this$7 = $n(format$1);
      if (($charAt(this$7, noInt) === 46)) {
        var from$1 = ((1 + noInt) | 0);
        var i$2 = from$1;
        while (true) {
          if ((i$2 < endIndex)) {
            var this$8 = $n(format$1);
            var index$2 = i$2;
            var arg1$2 = $charAt(this$8, index$2);
            var $$x3 = ((arg1$2 >= 48) && (arg1$2 <= 57))
          } else {
            var $$x3 = false
          };
          if ($$x3) {
            i$2 = ((1 + i$2) | 0)
          } else {
            break
          }
        };
        var noSignificant$2 = i$2;
        if ((noSignificant$2 >= endIndex)) {
          return true
        } else {
          var this$10 = $n(format$1);
          if ($p_sc_StringParsers$__isExp$1__C__Z($thiz, $charAt(this$10, noSignificant$2))) {
            return $p_sc_StringParsers$__expOK$1__I__I__T__Z($thiz, ((1 + noSignificant$2) | 0), endIndex, format$1)
          } else {
            return false
          }
        }
      } else {
        var this$11 = $n(format$1);
        if ($p_sc_StringParsers$__isExp$1__C__Z($thiz, $charAt(this$11, noInt))) {
          return $p_sc_StringParsers$__expOK$1__I__I__T__Z($thiz, ((1 + noInt) | 0), endIndex, format$1)
        } else {
          return false
        }
      }
    }
  } else {
    return false
  }
}
/** @constructor */
function $c_sc_StringParsers$() {
  /*<skip>*/
}
$c_sc_StringParsers$.prototype = new $h_O();
$c_sc_StringParsers$.prototype.constructor = $c_sc_StringParsers$;
/** @constructor */
function $h_sc_StringParsers$() {
  /*<skip>*/
}
$h_sc_StringParsers$.prototype = $c_sc_StringParsers$.prototype;
$c_sc_StringParsers$.prototype.checkFloatFormat__T__Z = (function(format) {
  $m_sc_StringOps$();
  var x$2 = 0;
  $m_sc_StringOps$();
  _return: {
    var this$3 = $n(format);
    var len = this$3.length;
    var i = x$2;
    while ((i < len)) {
      var this$4 = $n(format);
      var index = i;
      var arg1 = $charAt(this$4, index);
      if ((arg1 > 32)) {
        var unspacedStart = i;
        break _return
      };
      i = ((1 + i) | 0)
    };
    var unspacedStart = (-1)
  };
  $m_sc_StringOps$();
  var x$4 = 2147483647;
  $m_sc_StringOps$();
  _return$1: {
    var this$7 = $n(format);
    var len$1 = this$7.length;
    var y = (((-1) + len$1) | 0);
    var i$1 = ((x$4 < y) ? x$4 : y);
    while ((i$1 >= 0)) {
      var this$10 = $n(format);
      var index$1 = i$1;
      var arg1$1 = $charAt(this$10, index$1);
      if ((arg1$1 > 32)) {
        var $$x1 = i$1;
        break _return$1
      };
      i$1 = (((-1) + i$1) | 0)
    };
    var $$x1 = (-1)
  };
  var unspacedEnd = ((1 + $$x1) | 0);
  if ((!(((unspacedStart === (-1)) || (unspacedStart >= unspacedEnd)) || (unspacedEnd <= 0)))) {
    var this$11 = $n(format);
    var startchar = $charAt(this$11, unspacedStart);
    var unsigned = (((startchar === 45) || (startchar === 43)) ? ((1 + unspacedStart) | 0) : unspacedStart);
    if ((unsigned < unspacedEnd)) {
      var this$12 = $n(format);
      if (($charAt(this$12, unsigned) === 78)) {
        var this$13 = $n(format);
        if ((unsigned < 0)) {
          $charAt(this$13, unsigned)
        };
        if ((unspacedEnd > this$13.length)) {
          $charAt(this$13, unspacedEnd)
        };
        if ((unspacedEnd < unsigned)) {
          $charAt(this$13, (-1))
        };
        return ($as_T(this$13.substring(unsigned, unspacedEnd)) === "NaN")
      } else {
        var this$14 = $n(format);
        if (($charAt(this$14, unsigned) === 73)) {
          var this$15 = $n(format);
          if ((unsigned < 0)) {
            $charAt(this$15, unsigned)
          };
          if ((unspacedEnd > this$15.length)) {
            $charAt(this$15, unspacedEnd)
          };
          if ((unspacedEnd < unsigned)) {
            $charAt(this$15, (-1))
          };
          return ($as_T(this$15.substring(unsigned, unspacedEnd)) === "Infinity")
        } else {
          var this$16 = $n(format);
          var index$2 = (((-1) + unspacedEnd) | 0);
          var endchar = $charAt(this$16, index$2);
          var desuffixed = (((((endchar === 102) || (endchar === 70)) || (endchar === 100)) || (endchar === 68)) ? (((-1) + unspacedEnd) | 0) : unspacedEnd);
          var len$2 = ((desuffixed - unsigned) | 0);
          if ((len$2 > 0)) {
            if ((len$2 >= 2)) {
              var this$17 = $n(format);
              var index$3 = ((1 + unsigned) | 0);
              if (($charAt(this$17, index$3) === 120)) {
                var $$x2 = true
              } else {
                var this$18 = $n(format);
                var index$4 = ((1 + unsigned) | 0);
                var $$x2 = ($charAt(this$18, index$4) === 88)
              }
            } else {
              var $$x2 = false
            };
            if ($$x2) {
              var this$19 = $n(format);
              if (($charAt(this$19, unsigned) === 48)) {
                return $p_sc_StringParsers$__isHexFloatLiteral$1__I__I__T__Z(this, ((2 + unsigned) | 0), desuffixed, format)
              } else {
                return false
              }
            } else {
              return $p_sc_StringParsers$__isDecFloatLiteral$1__I__I__T__Z(this, unsigned, desuffixed, format)
            }
          } else {
            return false
          }
        }
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
var $d_sc_StringParsers$ = new $TypeData().initClass({
  sc_StringParsers$: 0
}, false, "scala.collection.StringParsers$", {
  sc_StringParsers$: 1,
  O: 1
});
$c_sc_StringParsers$.prototype.$classData = $d_sc_StringParsers$;
var $n_sc_StringParsers$;
function $m_sc_StringParsers$() {
  if ((!$n_sc_StringParsers$)) {
    $n_sc_StringParsers$ = new $c_sc_StringParsers$()
  };
  return $n_sc_StringParsers$
}
function $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set($thiz, s) {
  if ((s === null)) {
    return null
  } else if ((s instanceof $c_sc_convert_JavaCollectionWrappers$JSetWrapper)) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$JSetWrapper(s);
    return $n(x3).sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$SetWrapper(s)
  }
}
function $f_sc_convert_AsJavaConverters__asJava__sc_Map__ju_Map($thiz, m) {
  if ((m === null)) {
    return null
  } else if ((m instanceof $c_sc_convert_JavaCollectionWrappers$JMapWrapper)) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$JMapWrapper(m);
    return $n(x3).sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$MapWrapper(m)
  }
}
function $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator($thiz, i) {
  if ((i === null)) {
    return null
  } else if (false) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$IteratorWrapper(i);
    return $n(x3).underlying__sc_Iterator()
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(i)
  }
}
function $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set($thiz, s) {
  if ((s === null)) {
    return null
  } else if (false) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$MutableSetWrapper(s);
    return $n(x3).underlying__scm_Set()
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$JSetWrapper(s)
  }
}
function $f_sc_convert_AsScalaConverters__asScala__ju_Map__scm_Map($thiz, m) {
  if ((m === null)) {
    return null
  } else if (false) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$MutableMapWrapper(m);
    return $n(x3).underlying__scm_Map()
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$JMapWrapper(m)
  }
}
/** @constructor */
function $c_sc_convert_AsScalaExtensions$IteratorHasAsScala(outer, i) {
  this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i = null;
  this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i = i;
  if ((outer === null)) {
    $n(null)
  }
}
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = new $h_O();
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.constructor = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala;
/** @constructor */
function $h_sc_convert_AsScalaExtensions$IteratorHasAsScala() {
  /*<skip>*/
}
$h_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype;
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.asScala__sc_Iterator = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var i = this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i;
  return $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator(this$1, i)
});
var $d_sc_convert_AsScalaExtensions$IteratorHasAsScala = new $TypeData().initClass({
  sc_convert_AsScalaExtensions$IteratorHasAsScala: 0
}, false, "scala.collection.convert.AsScalaExtensions$IteratorHasAsScala", {
  sc_convert_AsScalaExtensions$IteratorHasAsScala: 1,
  O: 1
});
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.$classData = $d_sc_convert_AsScalaExtensions$IteratorHasAsScala;
function $p_sci_IndexedSeqDefaults$__liftedTree1$1__I($thiz) {
  try {
    $m_sc_StringOps$();
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.IndexedSeq.defaultApplyPreferredMaxLength", "64");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10)
  } catch (e) {
    if (false) {
      return 64
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_sci_IndexedSeqDefaults$() {
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = 0;
  $n_sci_IndexedSeqDefaults$ = this;
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = $p_sci_IndexedSeqDefaults$__liftedTree1$1__I(this)
}
$c_sci_IndexedSeqDefaults$.prototype = new $h_O();
$c_sci_IndexedSeqDefaults$.prototype.constructor = $c_sci_IndexedSeqDefaults$;
/** @constructor */
function $h_sci_IndexedSeqDefaults$() {
  /*<skip>*/
}
$h_sci_IndexedSeqDefaults$.prototype = $c_sci_IndexedSeqDefaults$.prototype;
var $d_sci_IndexedSeqDefaults$ = new $TypeData().initClass({
  sci_IndexedSeqDefaults$: 0
}, false, "scala.collection.immutable.IndexedSeqDefaults$", {
  sci_IndexedSeqDefaults$: 1,
  O: 1
});
$c_sci_IndexedSeqDefaults$.prototype.$classData = $d_sci_IndexedSeqDefaults$;
var $n_sci_IndexedSeqDefaults$;
function $m_sci_IndexedSeqDefaults$() {
  if ((!$n_sci_IndexedSeqDefaults$)) {
    $n_sci_IndexedSeqDefaults$ = new $c_sci_IndexedSeqDefaults$()
  };
  return $n_sci_IndexedSeqDefaults$
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder$DeferredState() {
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = null
}
$c_sci_LazyList$LazyBuilder$DeferredState.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.constructor = $c_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $h_sci_LazyList$LazyBuilder$DeferredState() {
  /*<skip>*/
}
$h_sci_LazyList$LazyBuilder$DeferredState.prototype = $c_sci_LazyList$LazyBuilder$DeferredState.prototype;
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.eval__sci_LazyList$State = (function() {
  var state = this.sci_LazyList$LazyBuilder$DeferredState__f__state;
  if ((state === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "uninitialized")
  };
  return $as_sci_LazyList$State($n(state).apply__O())
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.init__F0__V = (function(state) {
  if ((this.sci_LazyList$LazyBuilder$DeferredState__f__state !== null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "already initialized")
  };
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = state
});
var $d_sci_LazyList$LazyBuilder$DeferredState = new $TypeData().initClass({
  sci_LazyList$LazyBuilder$DeferredState: 0
}, false, "scala.collection.immutable.LazyList$LazyBuilder$DeferredState", {
  sci_LazyList$LazyBuilder$DeferredState: 1,
  O: 1
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.$classData = $d_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $c_sci_MapNode$() {
  this.sci_MapNode$__f_EmptyMapNode = null;
  $n_sci_MapNode$ = this;
  this.sci_MapNode$__f_EmptyMapNode = new $c_sci_BitmapIndexedMapNode(0, 0, ($m_s_reflect_ManifestFactory$AnyManifest$(), new $ac_O(0)), ($m_s_reflect_ManifestFactory$IntManifest$(), new $ac_I(0)), 0, 0)
}
$c_sci_MapNode$.prototype = new $h_O();
$c_sci_MapNode$.prototype.constructor = $c_sci_MapNode$;
/** @constructor */
function $h_sci_MapNode$() {
  /*<skip>*/
}
$h_sci_MapNode$.prototype = $c_sci_MapNode$.prototype;
var $d_sci_MapNode$ = new $TypeData().initClass({
  sci_MapNode$: 0
}, false, "scala.collection.immutable.MapNode$", {
  sci_MapNode$: 1,
  O: 1
});
$c_sci_MapNode$.prototype.$classData = $d_sci_MapNode$;
var $n_sci_MapNode$;
function $m_sci_MapNode$() {
  if ((!$n_sci_MapNode$)) {
    $n_sci_MapNode$ = new $c_sci_MapNode$()
  };
  return $n_sci_MapNode$
}
function $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException($thiz, as, ix) {
  return $ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((ix + " is out of bounds (min 0, max ") + (((-1) + $m_jl_reflect_Array$().getLength__O__I(as)) | 0)))
}
/** @constructor */
function $c_sci_Node() {
  /*<skip>*/
}
$c_sci_Node.prototype = new $h_O();
$c_sci_Node.prototype.constructor = $c_sci_Node;
/** @constructor */
function $h_sci_Node() {
  /*<skip>*/
}
$h_sci_Node.prototype = $c_sci_Node.prototype;
$c_sci_Node.prototype.removeElement__AI__I__AI = (function(as, ix) {
  if ((ix < 0)) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix))
  };
  if ((ix > (((-1) + $n(as).u.length) | 0))) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix))
  };
  var result = new $ac_I((((-1) + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  var srcPos = ((1 + ix) | 0);
  var length = (((-1) + (($n(as).u.length - ix) | 0)) | 0);
  $systemArraycopy($n(as), srcPos, result, ix, length);
  return result
});
$c_sci_Node.prototype.insertElement__AI__I__I__AI = (function(as, ix, elem) {
  if ((ix < 0)) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix))
  };
  if ((ix > $n(as).u.length)) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix))
  };
  var result = new $ac_I(((1 + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  $n(result).set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = (($n(as).u.length - ix) | 0);
  $systemArraycopy($n(as), ix, result, destPos, length);
  return result
});
var $d_sci_Node = new $TypeData().initClass({
  sci_Node: 0
}, false, "scala.collection.immutable.Node", {
  sci_Node: 1,
  O: 1
});
$c_sci_Node.prototype.$classData = $d_sci_Node;
/** @constructor */
function $c_sci_Node$() {
  this.sci_Node$__f_MaxDepth = 0;
  $n_sci_Node$ = this;
  this.sci_Node$__f_MaxDepth = $doubleToInt($uD(Math.ceil(6.4)))
}
$c_sci_Node$.prototype = new $h_O();
$c_sci_Node$.prototype.constructor = $c_sci_Node$;
/** @constructor */
function $h_sci_Node$() {
  /*<skip>*/
}
$h_sci_Node$.prototype = $c_sci_Node$.prototype;
$c_sci_Node$.prototype.maskFrom__I__I__I = (function(hash, shift) {
  return (31 & ((hash >>> shift) | 0))
});
$c_sci_Node$.prototype.bitposFrom__I__I = (function(mask) {
  return (1 << mask)
});
$c_sci_Node$.prototype.indexFrom__I__I__I = (function(bitmap, bitpos) {
  var i = (bitmap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_Node$.prototype.indexFrom__I__I__I__I = (function(bitmap, mask, bitpos) {
  return ((bitmap === (-1)) ? mask : this.indexFrom__I__I__I(bitmap, bitpos))
});
var $d_sci_Node$ = new $TypeData().initClass({
  sci_Node$: 0
}, false, "scala.collection.immutable.Node$", {
  sci_Node$: 1,
  O: 1
});
$c_sci_Node$.prototype.$classData = $d_sci_Node$;
var $n_sci_Node$;
function $m_sci_Node$() {
  if ((!$n_sci_Node$)) {
    $n_sci_Node$ = new $c_sci_Node$()
  };
  return $n_sci_Node$
}
function $p_sci_RedBlackTree$___foreach__sci_RedBlackTree$Tree__F1__V($thiz, tree, f) {
  while (true) {
    var this$1 = $n(tree);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = $n(tree);
      $p_sci_RedBlackTree$___foreach__sci_RedBlackTree$Tree__F1__V($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, f)
    };
    var $$x2 = $n(f);
    var this$3 = $n(tree);
    var $$x1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
    var this$4 = $n(tree);
    $n($$x2).apply__O__O($ct_T2__O__O__(new $c_T2(), $$x1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value));
    var this$5 = $n(tree);
    if ((this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$6 = $n(tree);
      tree = this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      continue
    };
    return (void 0)
  }
}
function $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, tree, f) {
  while (true) {
    var this$1 = $n(tree);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = $n(tree);
      $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, f)
    };
    var $$x1 = $n(f);
    var this$3 = $n(tree);
    $n($$x1).apply__O__O(this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    var this$4 = $n(tree);
    if ((this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$5 = $n(tree);
      tree = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      continue
    };
    return (void 0)
  }
}
function $p_sci_RedBlackTree$___foreachEntry__sci_RedBlackTree$Tree__F2__V($thiz, tree, f) {
  while (true) {
    var this$1 = $n(tree);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = $n(tree);
      $p_sci_RedBlackTree$___foreachEntry__sci_RedBlackTree$Tree__F2__V($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, f)
    };
    var $$x2 = $n(f);
    var this$3 = $n(tree);
    var $$x1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
    var this$4 = $n(tree);
    $n($$x2).apply__O__O__O($$x1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
    var this$5 = $n(tree);
    if ((this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$6 = $n(tree);
      tree = this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      continue
    };
    return (void 0)
  }
}
function $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, t) {
  return ((t === null) ? null : $n(t).black__sci_RedBlackTree$Tree())
}
function $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, t) {
  if ($thiz.isBlack__sci_RedBlackTree$Tree__Z(t)) {
    return t
  } else {
    var this$1 = $n(t);
    var tree = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tree !== null)) {
      var this$2 = $n(tree);
      var $$x2 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var $$x1 = true
    } else {
      var this$3 = $n(t);
      var tree$1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((tree$1 !== null)) {
        var this$4 = $n(tree$1);
        var $$x1 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x1 = false
      }
    };
    if ($$x1) {
      return $n(t).black__sci_RedBlackTree$Tree()
    } else {
      return t
    }
  }
}
function $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, isBlack, key, value, left, right) {
  if ((left === null)) {
    var $$x2 = 0
  } else {
    var this$1 = $n(left);
    var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
  };
  if ((right === null)) {
    var $$x1 = 0
  } else {
    var this$2 = $n(right);
    var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
  };
  var sizeAndColour = (((1 + (($$x2 + $$x1) | 0)) | 0) | (isBlack ? (-2147483648) : 0));
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, sizeAndColour)
}
function $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft) {
  var this$1 = $n(tree);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return tree
  } else {
    var this$2 = $n(newLeft);
    if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
      var this$3 = $n(newLeft);
      var newLeft_left = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$4 = $n(newLeft);
      var newLeft_right = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((newLeft_left !== null)) {
        var this$5 = $n(newLeft_left);
        var $$x1 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var resultLeft = $n(newLeft_left).black__sci_RedBlackTree$Tree();
        var resultRight = $n(tree).blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
        return $n(newLeft).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
      } else {
        if ((newLeft_right !== null)) {
          var this$6 = $n(newLeft_right);
          var $$x2 = (this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          var this$7 = $n(newLeft_right);
          var newLeft_right_right = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var $$x3 = $n(newLeft);
          var this$8 = $n(newLeft_right);
          var resultLeft$2 = $n($$x3).blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var resultRight$2 = $n(tree).blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
          return $n(newLeft_right).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
        } else {
          return $n(tree).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
        }
      }
    } else {
      return $n(tree).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
    }
  }
}
function $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newRight) {
  var this$1 = $n(tree);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return tree
  } else {
    var this$2 = $n(newRight);
    if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
      var this$3 = $n(newRight);
      var newRight_left = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if ((newRight_left !== null)) {
        var this$4 = $n(newRight_left);
        var $$x1 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var $$x2 = $n(tree);
        var this$5 = $n(newRight_left);
        var resultLeft = $n($$x2).blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var $$x3 = $n(newRight);
        var this$6 = $n(newRight_left);
        var resultRight = $n($$x3).blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        return $n(newRight_left).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
      } else {
        var this$7 = $n(newRight);
        var newRight_right = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if ((newRight_right !== null)) {
          var this$8 = $n(newRight_right);
          var $$x4 = (this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          var resultLeft$2 = $n(tree).blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
          var resultRight$2 = $n(newRight_right).black__sci_RedBlackTree$Tree();
          return $n(newRight).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
        } else {
          return $n(tree).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
        }
      }
    } else {
      return $n(tree).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
    }
  }
}
function $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, v, overwrite, ordering) {
  if ((tree === null)) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, null, null)
  } else {
    var this$1 = $n(tree);
    if (Object.is(k, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
      return (overwrite ? $n(tree).withV__O__sci_RedBlackTree$Tree(v) : tree)
    } else {
      var $$x1 = $n(ordering);
      var this$2 = $n(tree);
      var cmp = $n($$x1).compare__O__O__I(k, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$3 = $n(tree);
        return $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, v, overwrite, ordering))
      } else if ((cmp > 0)) {
        var this$4 = $n(tree);
        return $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, overwrite, ordering))
      } else {
        if (overwrite) {
          var this$5 = $n(tree);
          var $$x2 = (!Object.is(v, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value))
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          return $n(tree).withV__O__sci_RedBlackTree$Tree(v)
        } else {
          return tree
        }
      }
    }
  }
}
function $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, tree, idx, k, v) {
  if ((tree === null)) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, null, null)
  } else {
    var this$1 = $n(tree);
    var rank = ((1 + $thiz.count__sci_RedBlackTree$Tree__I(this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) | 0);
    if ((idx < rank)) {
      var this$2 = $n(tree);
      return $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, idx, k, v))
    } else if ((idx > rank)) {
      var this$3 = $n(tree);
      return $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((idx - rank) | 0), k, v))
    } else {
      return tree
    }
  }
}
function $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, tree, n) {
  while (true) {
    if (((tree === null) || (n <= 0))) {
      return tree
    } else {
      var $$x1 = n;
      var this$1 = $n(tree);
      if (($$x1 >= (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return null
      } else {
        var this$2 = $n(tree);
        var l = $thiz.count__sci_RedBlackTree$Tree__I(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((n > l)) {
          var this$3 = $n(tree);
          var temp$tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var temp$n = (((-1) + ((n - l) | 0)) | 0);
          tree = temp$tree;
          n = temp$n
        } else if ((n === l)) {
          var this$4 = $n(tree);
          var $$x3 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$5 = $n(tree);
          var $$x2 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$6 = $n(tree);
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(null, $$x3, $$x2, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
        } else {
          var this$7 = $n(tree);
          var $$x6 = $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, n);
          var this$8 = $n(tree);
          var $$x5 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$9 = $n(tree);
          var $$x4 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$10 = $n(tree);
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x6, $$x5, $$x4, this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
        }
      }
    }
  }
}
function $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, tree, n) {
  while (true) {
    if (((tree === null) || (n <= 0))) {
      return null
    } else {
      var this$1 = $n(tree);
      if ((n >= (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return tree
      } else {
        var this$2 = $n(tree);
        var l = $thiz.count__sci_RedBlackTree$Tree__I(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((n <= l)) {
          var this$3 = $n(tree);
          tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
        } else if ((n === ((1 + l) | 0))) {
          var this$4 = $n(tree);
          var $$x2 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
          var this$5 = $n(tree);
          var $$x1 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$6 = $n(tree);
          return $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, $$x2, n, $$x1, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value))
        } else {
          var this$7 = $n(tree);
          var $$x5 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
          var this$8 = $n(tree);
          var $$x4 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$9 = $n(tree);
          var $$x3 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$10 = $n(tree);
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x5, $$x4, $$x3, $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (((-1) + ((n - l) | 0)) | 0)))
        }
      }
    }
  }
}
function $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, ordering) {
  if ((tree === null)) {
    return null
  } else {
    var $$x1 = $n(ordering);
    var this$1 = $n(tree);
    var cmp = $n($$x1).compare__O__O__I(k, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp < 0)) {
      var this$2 = $n(tree);
      var newLeft = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, ordering);
      var this$3 = $n(tree);
      if ((newLeft === this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
        return tree
      } else {
        var this$4 = $n(tree);
        var tree$1 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        if ((tree$1 !== null)) {
          var this$5 = $n(tree$1);
          var $$x2 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          var this$6 = $n(tree);
          return $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
        } else {
          return $n(tree).redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
        }
      }
    } else if ((cmp > 0)) {
      var this$7 = $n(tree);
      var newRight = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, ordering);
      var this$8 = $n(tree);
      if ((newRight === this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
        return tree
      } else {
        var this$9 = $n(tree);
        var tree$2 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if ((tree$2 !== null)) {
          var this$10 = $n(tree$2);
          var $$x3 = (this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          var this$11 = $n(tree);
          return $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight)
        } else {
          return $n(tree).redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
        }
      }
    } else {
      var this$12 = $n(tree);
      var $$x4 = this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$13 = $n(tree);
      return $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $$x4, this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  }
}
function $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if ((tl !== null)) {
    var this$1 = $n(tl);
    var $$x1 = (this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    if ((tr !== null)) {
      var this$2 = $n(tr);
      var $$x2 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      return $n(tree).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($n(tl).black__sci_RedBlackTree$Tree(), $n(tr).black__sci_RedBlackTree$Tree())
    } else {
      var this$3 = $n(tl);
      var tree$1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if ((tree$1 !== null)) {
        var this$4 = $n(tree$1);
        var $$x3 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var $$x5 = $n(tl);
        var this$5 = $n(tl);
        var $$x4 = $n(this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left).black__sci_RedBlackTree$Tree();
        var this$6 = $n(tl);
        return $n($$x5).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x4, $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
      } else {
        var this$7 = $n(tl);
        var tree$2 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if ((tree$2 !== null)) {
          var this$8 = $n(tree$2);
          var $$x6 = (this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
        } else {
          var $$x6 = false
        };
        if ($$x6) {
          var this$9 = $n(tl);
          var $$x9 = $n(this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
          var $$x8 = $n(tl);
          var this$10 = $n(tl);
          var this$11 = $n(this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
          var $$x7 = $n($$x8).blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$12 = $n(tl);
          var this$13 = $n(this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
          return $n($$x9).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x7, $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
        } else {
          return $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
        }
      }
    }
  } else {
    if ((tr !== null)) {
      var this$14 = $n(tr);
      var $$x10 = (this$14.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
    } else {
      var $$x10 = false
    };
    if ($$x10) {
      var this$15 = $n(tr);
      var tree$3 = this$15.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((tree$3 !== null)) {
        var this$16 = $n(tree$3);
        var $$x11 = (this$16.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x11 = false
      };
      if ($$x11) {
        var $$x14 = $n(tr);
        var $$x13 = $n(tree);
        var this$17 = $n(tr);
        var $$x12 = $n($$x13).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$17.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var this$18 = $n(tr);
        return $n($$x14).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x12, $n(this$18.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right).black__sci_RedBlackTree$Tree())
      } else {
        var this$19 = $n(tr);
        var tree$4 = this$19.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        if ((tree$4 !== null)) {
          var this$20 = $n(tree$4);
          var $$x15 = (this$20.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
        } else {
          var $$x15 = false
        };
        if ($$x15) {
          var this$21 = $n(tr);
          var $$x19 = $n(this$21.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var $$x18 = $n(tree);
          var this$22 = $n(tr);
          var this$23 = $n(this$22.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var $$x17 = $n($$x18).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$23.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$24 = $n(tr);
          var this$25 = $n(this$24.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var $$x16 = this$25.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var this$26 = $n(tr);
          return $n($$x19).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x17, $n(tr).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x16, this$26.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))
        } else {
          return $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
        }
      }
    } else {
      return $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
    }
  }
}
function $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if ((tl !== null)) {
    var this$1 = $n(tl);
    var $$x1 = (this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $n(tree).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($n(tl).black__sci_RedBlackTree$Tree(), tr)
  } else {
    if ((tr !== null)) {
      var this$2 = $n(tr);
      var $$x2 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, $n(tr).red__sci_RedBlackTree$Tree())
    } else {
      if ((tr !== null)) {
        var this$3 = $n(tr);
        var $$x4 = (this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var this$4 = $n(tr);
        var tree$1 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        if ((tree$1 !== null)) {
          var this$5 = $n(tree$1);
          var $$x3 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)
        } else {
          var $$x3 = false
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var this$6 = $n(tr);
        var $$x8 = $n(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var $$x7 = $n(tree);
        var this$7 = $n(tr);
        var this$8 = $n(this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var $$x6 = $n($$x7).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var this$9 = $n(tr);
        var this$10 = $n(this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var $$x5 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        var this$11 = $n(tr);
        return $n($$x8).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x6, $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tr, $$x5, $n(this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right).red__sci_RedBlackTree$Tree()))
      } else {
        $m_s_sys_package$().error__T__E("Defect: invariance violation")
      }
    }
  }
}
function $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if ((tr !== null)) {
    var this$1 = $n(tr);
    var $$x1 = (this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $n(tree).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, $n(tr).black__sci_RedBlackTree$Tree())
  } else {
    if ((tl !== null)) {
      var this$2 = $n(tl);
      var $$x2 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $n(tl).red__sci_RedBlackTree$Tree(), tr)
    } else {
      if ((tl !== null)) {
        var this$3 = $n(tl);
        var $$x4 = (this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var this$4 = $n(tl);
        var tree$1 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if ((tree$1 !== null)) {
          var this$5 = $n(tree$1);
          var $$x3 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)
        } else {
          var $$x3 = false
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var this$6 = $n(tl);
        var $$x7 = $n(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        var this$7 = $n(tl);
        var $$x6 = $n(this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left).red__sci_RedBlackTree$Tree();
        var this$8 = $n(tl);
        var this$9 = $n(this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        var $$x5 = $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, $$x6, this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var this$10 = $n(tl);
        var this$11 = $n(this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        return $n($$x7).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x5, $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
      } else {
        $m_s_sys_package$().error__T__E("Defect: invariance violation")
      }
    }
  }
}
function $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tr) {
  if ((tl === null)) {
    return tr
  } else if ((tr === null)) {
    return tl
  } else {
    var this$1 = $n(tl);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
      var this$2 = $n(tr);
      if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
        var this$3 = $n(tl);
        var $$x1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        var this$4 = $n(tr);
        var bc = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $$x1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((bc !== null)) {
          var this$5 = $n(bc);
          var $$x2 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          var $$x5 = $n(bc);
          var $$x4 = $n(tl);
          var this$6 = $n(bc);
          var $$x3 = $n($$x4).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$7 = $n(bc);
          return $n($$x5).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x3, $n(tr).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))
        } else {
          return $n(tl).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($n(tr).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc))
        }
      } else {
        var $$x6 = $n(tl);
        var this$8 = $n(tl);
        return $n($$x6).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
      }
    } else {
      var this$9 = $n(tr);
      if ((this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var this$10 = $n(tl);
        var $$x7 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        var this$11 = $n(tr);
        var bc$2 = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $$x7, this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((bc$2 !== null)) {
          var this$12 = $n(bc$2);
          var $$x8 = (this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
        } else {
          var $$x8 = false
        };
        if ($$x8) {
          var $$x11 = $n(bc$2);
          var $$x10 = $n(tl);
          var this$13 = $n(bc$2);
          var $$x9 = $n($$x10).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$14 = $n(bc$2);
          return $n($$x11).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x9, $n(tr).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$14.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))
        } else {
          var this$15 = $n(tl);
          return $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, this$15.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, $n(tr).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2))
        }
      } else {
        var $$x12 = $n(tr);
        var this$16 = $n(tr);
        return $n($$x12).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, this$16.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left))
      }
    }
  }
}
function $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, bhtl, rtr) {
  if ((tl === null)) {
    var rtl = 0
  } else {
    var this$1 = $n(tl);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
      var rtl = ((((-1) + bhtl) | 0) << 1)
    } else {
      var rtl = (((-1) + (bhtl << 1)) | 0)
    }
  };
  if ((rtl === (((rtr / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr)
  } else {
    if ((tl !== null)) {
      var this$2 = $n(tl);
      var tlBlack = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)
    } else {
      var tlBlack = false
    };
    var bhtlr = (tlBlack ? (((-1) + bhtl) | 0) : bhtl);
    var this$3 = $n(tl);
    var ttr = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, tr, bhtlr, rtr);
    if (tlBlack) {
      if ((ttr !== null)) {
        var this$4 = $n(ttr);
        var $$x2 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var this$5 = $n(ttr);
      var tree = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((tree !== null)) {
        var this$6 = $n(tree);
        var $$x1 = (this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var this$7 = $n(ttr);
      var $$x8 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$8 = $n(ttr);
      var $$x7 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$9 = $n(tl);
      var $$x6 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$10 = $n(tl);
      var $$x5 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$11 = $n(tl);
      var $$x4 = this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$12 = $n(ttr);
      var $$x3 = $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x6, $$x5, $$x4, this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var this$13 = $n(ttr);
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x8, $$x7, $$x3, $n(this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right).black__sci_RedBlackTree$Tree())
    } else {
      var this$14 = $n(tl);
      var $$x10 = this$14.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$15 = $n(tl);
      var $$x9 = this$15.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$16 = $n(tl);
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tlBlack, $$x10, $$x9, this$16.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ttr)
    }
  }
}
function $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, rtl, bhtr) {
  if ((tr === null)) {
    var rtr = 0
  } else {
    var this$1 = $n(tr);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
      var rtr = ((((-1) + bhtr) | 0) << 1)
    } else {
      var rtr = (((-1) + (bhtr << 1)) | 0)
    }
  };
  if ((rtr === (((rtl / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr)
  } else {
    if ((tr !== null)) {
      var this$2 = $n(tr);
      var trBlack = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)
    } else {
      var trBlack = false
    };
    var bhtrl = (trBlack ? (((-1) + bhtr) | 0) : bhtr);
    var this$3 = $n(tr);
    var ttl = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, rtl, bhtrl);
    if (trBlack) {
      if ((ttl !== null)) {
        var this$4 = $n(ttl);
        var $$x2 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var this$5 = $n(ttl);
      var tree = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if ((tree !== null)) {
        var this$6 = $n(tree);
        var $$x1 = (this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var this$7 = $n(ttl);
      var $$x8 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$8 = $n(ttl);
      var $$x7 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$9 = $n(ttl);
      var $$x6 = $n(this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left).black__sci_RedBlackTree$Tree();
      var this$10 = $n(tr);
      var $$x5 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$11 = $n(tr);
      var $$x4 = this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$12 = $n(ttl);
      var $$x3 = this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var this$13 = $n(tr);
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x8, $$x7, $$x6, $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x5, $$x4, $$x3, this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))
    } else {
      var this$14 = $n(tr);
      var $$x10 = this$14.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$15 = $n(tr);
      var $$x9 = this$15.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$16 = $n(tr);
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, trBlack, $$x10, $$x9, ttl, this$16.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  }
}
function $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t, k2, ordering) {
  if ((t === null)) {
    return new $c_T4(null, null, null, k2)
  } else {
    var $$x1 = $n(ordering);
    var this$1 = $n(t);
    var cmp = $n($$x1).compare__O__O__I(k2, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp === 0)) {
      var this$2 = $n(t);
      var $$x3 = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$3 = $n(t);
      var $$x2 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var this$4 = $n(t);
      return new $c_T4($$x3, t, $$x2, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)
    } else if ((cmp < 0)) {
      var this$5 = $n(t);
      var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k2, ordering);
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1)
      };
      var ll = $as_sci_RedBlackTree$Tree($n(x1).T4__f__1);
      var b = $as_sci_RedBlackTree$Tree($n(x1).T4__f__2);
      var lr = $as_sci_RedBlackTree$Tree($n(x1).T4__f__3);
      var k1 = $n(x1).T4__f__4;
      var this$6 = $n(t);
      var $$x5 = this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$7 = $n(t);
      var $$x4 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$8 = $n(t);
      return new $c_T4(ll, b, $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(lr, $$x5, $$x4, this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right), k1)
    } else {
      var this$9 = $n(t);
      var x1$2 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k2, ordering);
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var rl = $as_sci_RedBlackTree$Tree($n(x1$2).T4__f__1);
      var b$3 = $as_sci_RedBlackTree$Tree($n(x1$2).T4__f__2);
      var rr = $as_sci_RedBlackTree$Tree($n(x1$2).T4__f__3);
      var k1$3 = $n(x1$2).T4__f__4;
      var this$10 = $n(t);
      var $$x7 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$11 = $n(t);
      var $$x6 = this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$12 = $n(t);
      return new $c_T4($thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x7, $$x6, this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, rl), b$3, rr, k1$3)
    }
  }
}
function $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3($thiz, t) {
  var this$1 = $n(t);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === null)) {
    var this$2 = $n(t);
    var $$x2 = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var this$3 = $n(t);
    var $$x1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
    var this$4 = $n(t);
    return new $c_T3($$x2, $$x1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value)
  } else {
    var this$5 = $n(t);
    var x1 = $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3($thiz, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var tt = $as_sci_RedBlackTree$Tree($n(x1).T3__f__1);
    var kk = $n(x1).T3__f__2;
    var vv = $n(x1).T3__f__3;
    var this$6 = $n(t);
    var $$x4 = this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var this$7 = $n(t);
    var $$x3 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
    var this$8 = $n(t);
    return new $c_T3($thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x4, $$x3, this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tt), kk, vv)
  }
}
function $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, t1, t2, ordering) {
  if (((t1 === null) || (t1 === t2))) {
    return t2
  } else if ((t2 === null)) {
    return t1
  } else {
    var this$1 = $n(t2);
    var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t1, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ordering);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var l1 = $as_sci_RedBlackTree$Tree($n(x1).T4__f__1);
    var r1 = $as_sci_RedBlackTree$Tree($n(x1).T4__f__3);
    var k1 = $n(x1).T4__f__4;
    var this$2 = $n(t2);
    var tl = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, l1, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ordering);
    var this$3 = $n(t2);
    var tr = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, r1, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ordering);
    var this$4 = $n(t2);
    return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, k1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tr)
  }
}
function $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, t1, t2, ordering) {
  if (((t1 === null) || (t2 === null))) {
    return t1
  } else if ((t1 === t2)) {
    return null
  } else {
    var this$1 = $n(t2);
    var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t1, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ordering);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var l1 = $as_sci_RedBlackTree$Tree($n(x1).T4__f__1);
    var r1 = $as_sci_RedBlackTree$Tree($n(x1).T4__f__3);
    $n(x1);
    var this$2 = $n(t2);
    var tl = $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, l1, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ordering);
    var this$3 = $n(t2);
    var tr = $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, r1, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ordering);
    return $thiz.scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
  }
}
function $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree")
  } else {
    var this$1 = $n(tree);
    var tl = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tl === null)) {
      var this$2 = $n(tree);
      return this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
    } else {
      var this$3 = $n(tl);
      if ((this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var $$x1 = $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl);
        var this$4 = $n(tree);
        return $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $$x1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
      } else {
        var $$x2 = $n(tree);
        var this$5 = $n(tree);
        return $n($$x2).redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left))
      }
    }
  }
}
function $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, level, size, maxUsedDepth$1, xs$1) {
  switch (size) {
    case 0: {
      return null;
      break
    }
    case 1: {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, ((level !== maxUsedDepth$1) || (level === 1)), $n(xs$1).next__O(), null, null, null);
      break
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), leftSize, maxUsedDepth$1, xs$1);
      var x = $n(xs$1).next__O();
      var right = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), maxUsedDepth$1, xs$1);
      return $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(x, null, left, right)
    }
  }
}
function $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree($thiz, level, size, xs$2, maxUsedDepth$2) {
  switch (size) {
    case 0: {
      return null;
      break
    }
    case 1: {
      var x1$2 = $as_T2($n(xs$2).next__O());
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var k = $n(x1$2)._1__O();
      var v = $n(x1$2)._2__O();
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, ((level !== maxUsedDepth$2) || (level === 1)), k, v, null, null);
      break
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), leftSize, xs$2, maxUsedDepth$2);
      var x1$3 = $as_T2($n(xs$2).next__O());
      if ((x1$3 === null)) {
        throw new $c_s_MatchError(x1$3)
      };
      var k$3 = $n(x1$3)._1__O();
      var v$3 = $n(x1$3)._2__O();
      var right = $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), xs$2, maxUsedDepth$2);
      return $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k$3, v$3, left, right)
    }
  }
}
function $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree($thiz, t, f$3) {
  var this$1 = $n(t);
  var k = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
  var this$2 = $n(t);
  var v = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
  var this$3 = $n(t);
  var l = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
  var this$4 = $n(t);
  var r = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
  var l2 = ((l === null) ? null : $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree($thiz, l, f$3));
  var keep = $uZ($n(f$3).apply__O__O__O(k, v));
  var r2 = ((r === null) ? null : $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree($thiz, r, f$3));
  return ((!keep) ? $thiz.scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2, r2) : (((l2 === l) && (r2 === r)) ? t : $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2, k, v, r2)))
}
function $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I($thiz, t, i) {
  while (true) {
    if ((t === null)) {
      return ((1 + i) | 0)
    } else {
      var this$1 = $n(t);
      var temp$t = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$2 = $n(t);
      if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var temp$i = ((1 + i) | 0)
      } else {
        var temp$i = i
      };
      t = temp$t;
      i = temp$i
    }
  }
}
/** @constructor */
function $c_sci_RedBlackTree$() {
  $n_sci_RedBlackTree$ = this;
  $ct_T2__O__O__(new $c_T2(), null, null)
}
$c_sci_RedBlackTree$.prototype = new $h_O();
$c_sci_RedBlackTree$.prototype.constructor = $c_sci_RedBlackTree$;
/** @constructor */
function $h_sci_RedBlackTree$() {
  /*<skip>*/
}
$h_sci_RedBlackTree$.prototype = $c_sci_RedBlackTree$.prototype;
$c_sci_RedBlackTree$.prototype.contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z = (function(tree, x, evidence$1) {
  return (this.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(tree, x, evidence$1) !== null)
});
$c_sci_RedBlackTree$.prototype.get__sci_RedBlackTree$Tree__O__s_math_Ordering__s_Option = (function(tree, x, evidence$2) {
  var x1 = this.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(tree, x, evidence$2);
  if ((x1 === null)) {
    return $m_s_None$()
  } else {
    var this$1 = $n(x1);
    return new $c_s_Some(this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value)
  }
});
$c_sci_RedBlackTree$.prototype.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, x, ordering) {
  while (true) {
    if ((tree === null)) {
      return null
    } else {
      var $$x1 = $n(ordering);
      var this$1 = $n(tree);
      var cmp = $n($$x1).compare__O__O__I(x, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$2 = $n(tree);
        tree = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
      } else if ((cmp > 0)) {
        var this$3 = $n(tree);
        tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
      } else {
        return tree
      }
    }
  }
});
$c_sci_RedBlackTree$.prototype.count__sci_RedBlackTree$Tree__I = (function(tree) {
  if ((tree === null)) {
    return 0
  } else {
    var this$1 = $n(tree);
    return (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
  }
});
$c_sci_RedBlackTree$.prototype.update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, v, overwrite, evidence$3) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, v, overwrite, evidence$3))
});
$c_sci_RedBlackTree$.prototype.delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, evidence$4) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, evidence$4))
});
$c_sci_RedBlackTree$.prototype.drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, n, evidence$10) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree(this, tree, n))
});
$c_sci_RedBlackTree$.prototype.take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, n, evidence$11) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree(this, tree, n))
});
$c_sci_RedBlackTree$.prototype.smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree")
  };
  var result = tree;
  while (true) {
    var this$1 = $n(result);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = $n(result);
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
    } else {
      break
    }
  };
  return result
});
$c_sci_RedBlackTree$.prototype.greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree")
  };
  var result = tree;
  while (true) {
    var this$1 = $n(result);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$2 = $n(result);
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
    } else {
      break
    }
  };
  return result
});
$c_sci_RedBlackTree$.prototype.tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, tree))
});
$c_sci_RedBlackTree$.prototype.foreach__sci_RedBlackTree$Tree__F1__V = (function(tree, f) {
  if ((tree !== null)) {
    $p_sci_RedBlackTree$___foreach__sci_RedBlackTree$Tree__F1__V(this, tree, f)
  }
});
$c_sci_RedBlackTree$.prototype.keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z = (function(a, b, evidence$13) {
  if ((a === b)) {
    return true
  } else if ((a !== null)) {
    if ((b !== null)) {
      var this$1 = $n(a);
      var $$x1 = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count;
      var this$2 = $n(b);
      if (((2147483647 & $$x1) === (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return new $c_sci_RedBlackTree$EqualsIterator(a, evidence$13).sameKeys__sci_RedBlackTree$EqualsIterator__Z(new $c_sci_RedBlackTree$EqualsIterator(b, evidence$13))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_sci_RedBlackTree$.prototype.entriesEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z = (function(a, b, evidence$15) {
  if ((a === b)) {
    return true
  } else if ((a !== null)) {
    if ((b !== null)) {
      var this$1 = $n(a);
      var $$x1 = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count;
      var this$2 = $n(b);
      if (((2147483647 & $$x1) === (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return new $c_sci_RedBlackTree$EqualsIterator(a, evidence$15).sameEntries__sci_RedBlackTree$EqualsIterator__Z(new $c_sci_RedBlackTree$EqualsIterator(b, evidence$15))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_sci_RedBlackTree$.prototype.foreachKey__sci_RedBlackTree$Tree__F1__V = (function(tree, f) {
  if ((tree !== null)) {
    $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V(this, tree, f)
  }
});
$c_sci_RedBlackTree$.prototype.foreachEntry__sci_RedBlackTree$Tree__F2__V = (function(tree, f) {
  if ((tree !== null)) {
    $p_sci_RedBlackTree$___foreachEntry__sci_RedBlackTree$Tree__F2__V(this, tree, f)
  }
});
$c_sci_RedBlackTree$.prototype.isBlack__sci_RedBlackTree$Tree__Z = (function(tree) {
  if ((tree === null)) {
    return true
  } else {
    var this$1 = $n(tree);
    return (this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)
  }
});
$c_sci_RedBlackTree$.prototype.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  if ((left === null)) {
    var $$x2 = 0
  } else {
    var this$1 = $n(left);
    var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
  };
  if ((right === null)) {
    var $$x1 = 0
  } else {
    var this$2 = $n(right);
    var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
  };
  var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, size)
});
$c_sci_RedBlackTree$.prototype.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  if ((left === null)) {
    var $$x2 = 0
  } else {
    var this$1 = $n(left);
    var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
  };
  if ((right === null)) {
    var $$x1 = 0
  } else {
    var this$2 = $n(right);
    var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
  };
  var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, ((-2147483648) | size))
});
$c_sci_RedBlackTree$.prototype.fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - $uI(Math.clz32(size))) | 0);
  return $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree(this, 1, size, maxUsedDepth, xs)
});
$c_sci_RedBlackTree$.prototype.fromOrderedEntries__sc_Iterator__I__sci_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - $uI(Math.clz32(size))) | 0);
  return $p_sci_RedBlackTree$__f$2__I__I__sc_Iterator__I__sci_RedBlackTree$Tree(this, 1, size, xs, maxUsedDepth)
});
$c_sci_RedBlackTree$.prototype.filterEntries__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree = (function(t, f) {
  return ((t === null) ? null : $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree(this, t, f)))
});
$c_sci_RedBlackTree$.prototype.union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree = (function(t1, t2, ordering) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this, t1, t2, ordering))
});
$c_sci_RedBlackTree$.prototype.difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree = (function(t1, t2, ordering) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this, t1, t2, ordering))
});
$c_sci_RedBlackTree$.prototype.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tl, k, v, tr) {
  var bhtl = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tl, 0);
  var bhtr = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tr, 0);
  if ((bhtl > bhtr)) {
    if ((tr === null)) {
      var $$x1 = 0
    } else {
      var this$1 = $n(tr);
      if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var $$x1 = ((((-1) + bhtr) | 0) << 1)
      } else {
        var $$x1 = (((-1) + (bhtr << 1)) | 0)
      }
    };
    var tt = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, bhtl, $$x1);
    if ((tt !== null)) {
      var this$2 = $n(tt);
      var $$x3 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var this$3 = $n(tt);
      var tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((tree !== null)) {
        var this$4 = $n(tree);
        var $$x2 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      return $n(tt).black__sci_RedBlackTree$Tree()
    } else {
      return tt
    }
  } else if ((bhtr > bhtl)) {
    if ((tl === null)) {
      var $$x4 = 0
    } else {
      var this$5 = $n(tl);
      if ((this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var $$x4 = ((((-1) + bhtl) | 0) << 1)
      } else {
        var $$x4 = (((-1) + (bhtl << 1)) | 0)
      }
    };
    var tt$2 = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, $$x4, bhtr);
    if ((tt$2 !== null)) {
      var this$6 = $n(tt$2);
      var $$x6 = (this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var this$7 = $n(tt$2);
      var tree$1 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if ((tree$1 !== null)) {
        var this$8 = $n(tree$1);
        var $$x5 = (this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x5 = false
      }
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      return $n(tt$2).black__sci_RedBlackTree$Tree()
    } else {
      return tt$2
    }
  } else {
    if ((tl !== null)) {
      var this$9 = $n(tl);
      var $$x8 = (this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
    } else {
      var $$x8 = false
    };
    if ($$x8) {
      var $$x7 = true
    } else if ((tr !== null)) {
      var this$10 = $n(tr);
      var $$x7 = (this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
    } else {
      var $$x7 = false
    };
    return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $$x7, k, v, tl, tr)
  }
});
$c_sci_RedBlackTree$.prototype.scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tl, tr) {
  if ((tl === null)) {
    return tr
  } else if ((tr === null)) {
    return tl
  } else {
    var x1 = $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3(this, tl);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var ttl = $as_sci_RedBlackTree$Tree($n(x1).T3__f__1);
    var k = $n(x1).T3__f__2;
    var v = $n(x1).T3__f__3;
    return this.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(ttl, k, v, tr)
  }
});
var $d_sci_RedBlackTree$ = new $TypeData().initClass({
  sci_RedBlackTree$: 0
}, false, "scala.collection.immutable.RedBlackTree$", {
  sci_RedBlackTree$: 1,
  O: 1
});
$c_sci_RedBlackTree$.prototype.$classData = $d_sci_RedBlackTree$;
var $n_sci_RedBlackTree$;
function $m_sci_RedBlackTree$() {
  if ((!$n_sci_RedBlackTree$)) {
    $n_sci_RedBlackTree$ = new $c_sci_RedBlackTree$()
  };
  return $n_sci_RedBlackTree$
}
function $ct_sci_RedBlackTree$Helper__s_math_Ordering__($thiz, ordering) {
  $thiz.sci_RedBlackTree$Helper__f_ordering = ordering;
  return $thiz
}
/** @constructor */
function $c_sci_RedBlackTree$Helper() {
  this.sci_RedBlackTree$Helper__f_ordering = null
}
$c_sci_RedBlackTree$Helper.prototype = new $h_O();
$c_sci_RedBlackTree$Helper.prototype.constructor = $c_sci_RedBlackTree$Helper;
/** @constructor */
function $h_sci_RedBlackTree$Helper() {
  /*<skip>*/
}
$h_sci_RedBlackTree$Helper.prototype = $c_sci_RedBlackTree$Helper.prototype;
$c_sci_RedBlackTree$Helper.prototype.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    return tree
  } else {
    var this$1 = $n(tree);
    if (((2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
      var res = $n($n(tree).mutableBlack__sci_RedBlackTree$Tree()).makeImmutable__sci_RedBlackTree$Tree();
      return res
    } else {
      return $n(tree).black__sci_RedBlackTree$Tree()
    }
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newLeft) {
  var this$1 = $n(newLeft);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var this$2 = $n(newLeft);
    var newLeft_left = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var this$3 = $n(newLeft);
    var newLeft_right = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    $m_sci_RedBlackTree$();
    if ((newLeft_left !== null)) {
      var this$5 = $n(newLeft_left);
      var $$x1 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var resultLeft = $n(newLeft_left).mutableBlack__sci_RedBlackTree$Tree();
      var resultRight = $n(tree).mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
      return $n(newLeft).mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else {
      $m_sci_RedBlackTree$();
      if ((newLeft_right !== null)) {
        var this$7 = $n(newLeft_right);
        var $$x2 = (this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var this$8 = $n(newLeft_right);
        var newLeft_right_right = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        var $$x3 = $n(newLeft);
        var this$9 = $n(newLeft_right);
        var resultLeft$2 = $n($$x3).mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var resultRight$2 = $n(tree).mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
        return $n(newLeft_right).mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
      } else {
        return $n(tree).mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
      }
    }
  } else {
    return $n(tree).mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newRight) {
  var this$1 = $n(newRight);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var this$2 = $n(newRight);
    var newRight_left = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    $m_sci_RedBlackTree$();
    if ((newRight_left !== null)) {
      var this$4 = $n(newRight_left);
      var $$x1 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var $$x2 = $n(tree);
      var this$5 = $n(newRight_left);
      var resultLeft = $n($$x2).mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var $$x3 = $n(newRight);
      var this$6 = $n(newRight_left);
      var resultRight = $n($$x3).mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      return $n(newRight_left).mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else {
      var this$7 = $n(newRight);
      var newRight_right = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      $m_sci_RedBlackTree$();
      if ((newRight_right !== null)) {
        var this$9 = $n(newRight_right);
        var $$x4 = (this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var resultLeft$2 = $n(tree).mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
        var resultRight$2 = $n(newRight_right).mutableBlack__sci_RedBlackTree$Tree();
        return $n(newRight).mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
      } else {
        return $n(tree).mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
      }
    }
  } else {
    return $n(tree).mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
  }
});
function $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__V($thiz) {
  if (((2147483647 & $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    var size = 1;
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      $n($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left).makeImmutable__sci_RedBlackTree$Tree();
      var $$x1 = size;
      var this$1 = $n($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      size = (($$x1 + (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0)
    };
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      $n($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right).makeImmutable__sci_RedBlackTree$Tree();
      var $$x2 = size;
      var this$2 = $n($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      size = (($$x2 + (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0)
    };
    $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = ($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count | size)
  }
}
/** @constructor */
function $c_sci_RedBlackTree$Tree(_key, _value, _left, _right, _count) {
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = 0;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = _key;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = _value;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = _left;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = _right;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = _count
}
$c_sci_RedBlackTree$Tree.prototype = new $h_O();
$c_sci_RedBlackTree$Tree.prototype.constructor = $c_sci_RedBlackTree$Tree;
/** @constructor */
function $h_sci_RedBlackTree$Tree() {
  /*<skip>*/
}
$h_sci_RedBlackTree$Tree.prototype = $c_sci_RedBlackTree$Tree.prototype;
$c_sci_RedBlackTree$Tree.prototype.toString__T = (function() {
  return (((((((((((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? "RedTree" : "BlackTree") + "(") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) + ")")
});
$c_sci_RedBlackTree$Tree.prototype.makeImmutable__sci_RedBlackTree$Tree = (function() {
  $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__V(this);
  return this
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlack__sci_RedBlackTree$Tree = (function() {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithV__O__sci_RedBlackTree$Tree = (function(newValue) {
  if (Object.is(newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = newValue;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight))) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (-2147483648))
  }
});
$c_sci_RedBlackTree$Tree.prototype.black__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)))
});
$c_sci_RedBlackTree$Tree.prototype.red__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)))
});
$c_sci_RedBlackTree$Tree.prototype.withV__O__sci_RedBlackTree$Tree = (function(newValue) {
  return (Object.is(newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
});
$c_sci_RedBlackTree$Tree.prototype.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
    return this
  } else {
    if ((newLeft === null)) {
      var $$x2 = 0
    } else {
      var this$1 = $n(newLeft);
      var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if ((tree === null)) {
      var $$x1 = 0
    } else {
      var this$2 = $n(tree);
      var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
    return this
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tree === null)) {
      var $$x2 = 0
    } else {
      var this$1 = $n(tree);
      var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    if ((newRight === null)) {
      var $$x1 = 0
    } else {
      var this$2 = $n(newRight);
      var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else {
    if ((newLeft === null)) {
      var $$x2 = 0
    } else {
      var this$1 = $n(newLeft);
      var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if ((tree === null)) {
      var $$x1 = 0
    } else {
      var this$2 = $n(tree);
      var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this
  } else {
    if ((newLeft === null)) {
      var $$x2 = 0
    } else {
      var this$1 = $n(newLeft);
      var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if ((tree === null)) {
      var $$x1 = 0
    } else {
      var this$2 = $n(tree);
      var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, size)
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tree === null)) {
      var $$x2 = 0
    } else {
      var this$1 = $n(tree);
      var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    if ((newRight === null)) {
      var $$x1 = 0
    } else {
      var this$2 = $n(newRight);
      var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tree === null)) {
      var $$x2 = 0
    } else {
      var this$1 = $n(tree);
      var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    if ((newRight === null)) {
      var $$x1 = 0
    } else {
      var this$2 = $n(newRight);
      var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, size)
  }
});
$c_sci_RedBlackTree$Tree.prototype.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))) {
    return this
  } else {
    if ((newLeft === null)) {
      var $$x2 = 0
    } else {
      var this$1 = $n(newLeft);
      var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    if ((newRight === null)) {
      var $$x1 = 0
    } else {
      var this$2 = $n(newRight);
      var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this
  } else {
    if ((newLeft === null)) {
      var $$x2 = 0
    } else {
      var this$1 = $n(newLeft);
      var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    if ((newRight === null)) {
      var $$x1 = 0
    } else {
      var this$2 = $n(newRight);
      var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, size)
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else {
    if ((newLeft === null)) {
      var $$x2 = 0
    } else {
      var this$1 = $n(newLeft);
      var $$x2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    if ((newRight === null)) {
      var $$x1 = 0
    } else {
      var this$2 = $n(newRight);
      var $$x1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)
    };
    var size = ((1 + (($$x2 + $$x1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) | size))
  }
});
function $as_sci_RedBlackTree$Tree(obj) {
  return (((obj instanceof $c_sci_RedBlackTree$Tree) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.RedBlackTree$Tree"))
}
function $isArrayOf_sci_RedBlackTree$Tree(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_RedBlackTree$Tree)))
}
function $asArrayOf_sci_RedBlackTree$Tree(obj, depth) {
  return (($isArrayOf_sci_RedBlackTree$Tree(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.RedBlackTree$Tree;", depth))
}
var $d_sci_RedBlackTree$Tree = new $TypeData().initClass({
  sci_RedBlackTree$Tree: 0
}, false, "scala.collection.immutable.RedBlackTree$Tree", {
  sci_RedBlackTree$Tree: 1,
  O: 1
});
$c_sci_RedBlackTree$Tree.prototype.$classData = $d_sci_RedBlackTree$Tree;
/** @constructor */
function $c_sci_SetNode$() {
  this.sci_SetNode$__f_EmptySetNode = null;
  $n_sci_SetNode$ = this;
  this.sci_SetNode$__f_EmptySetNode = new $c_sci_BitmapIndexedSetNode(0, 0, ($m_s_reflect_ManifestFactory$AnyManifest$(), new $ac_O(0)), ($m_s_reflect_ManifestFactory$IntManifest$(), new $ac_I(0)), 0, 0)
}
$c_sci_SetNode$.prototype = new $h_O();
$c_sci_SetNode$.prototype.constructor = $c_sci_SetNode$;
/** @constructor */
function $h_sci_SetNode$() {
  /*<skip>*/
}
$h_sci_SetNode$.prototype = $c_sci_SetNode$.prototype;
var $d_sci_SetNode$ = new $TypeData().initClass({
  sci_SetNode$: 0
}, false, "scala.collection.immutable.SetNode$", {
  sci_SetNode$: 1,
  O: 1
});
$c_sci_SetNode$.prototype.$classData = $d_sci_SetNode$;
var $n_sci_SetNode$;
function $m_sci_SetNode$() {
  if ((!$n_sci_SetNode$)) {
    $n_sci_SetNode$ = new $c_sci_SetNode$()
  };
  return $n_sci_SetNode$
}
function $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, n, a, lo, hi) {
  while (true) {
    if ((n === 1)) {
      var a$1 = a;
      var start = lo;
      var end = hi;
      $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, 1, (((start === 0) && (end === $n(a$1).u.length)) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, start, end)))
    } else {
      var bitsN = Math.imul(5, (((-1) + n) | 0));
      var widthN = (1 << bitsN);
      var loN = ((lo >>> bitsN) | 0);
      var hiN = ((hi >>> bitsN) | 0);
      var loRest = (lo & (((-1) + widthN) | 0));
      var hiRest = (hi & (((-1) + widthN) | 0));
      if ((loRest === 0)) {
        if ((hiRest === 0)) {
          var $$x1 = n;
          var a$2 = a;
          $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x1, (((loN === 0) && (hiN === $n(a$2).u.length)) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, loN, hiN)))
        } else {
          if ((hiN > loN)) {
            var $$x2 = n;
            var a$3 = a;
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x2, (((loN === 0) && (hiN === $n(a$3).u.length)) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, loN, hiN)))
          };
          var temp$n = (((-1) + n) | 0);
          var temp$a = $asArrayOf_O($n(a).get(hiN), 1);
          n = temp$n;
          a = temp$a;
          lo = 0;
          hi = hiRest;
          continue
        }
      } else if ((hiN === loN)) {
        var temp$n$2 = (((-1) + n) | 0);
        var temp$a$2 = $asArrayOf_O($n(a).get(loN), 1);
        n = temp$n$2;
        a = temp$a$2;
        lo = loRest;
        hi = hiRest;
        continue
      } else {
        $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, (((-1) + n) | 0), $asArrayOf_O($n(a).get(loN), 1), loRest, widthN);
        if ((hiRest === 0)) {
          if ((hiN > ((1 + loN) | 0))) {
            var $$x3 = n;
            var a$4 = a;
            var start$1 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x3, (((start$1 === 0) && (hiN === $n(a$4).u.length)) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, start$1, hiN)))
          }
        } else {
          if ((hiN > ((1 + loN) | 0))) {
            var $$x4 = n;
            var a$5 = a;
            var start$2 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x4, (((start$2 === 0) && (hiN === $n(a$5).u.length)) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, start$2, hiN)))
          };
          var temp$n$3 = (((-1) + n) | 0);
          var temp$a$3 = $asArrayOf_O($n(a).get(hiN), 1);
          n = temp$n$3;
          a = temp$a$3;
          lo = 0;
          hi = hiRest;
          continue
        }
      }
    };
    return (void 0)
  }
}
function $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, n, a) {
  if ((n <= $thiz.sci_VectorSliceBuilder__f_maxDim)) {
    var idx = ((11 - n) | 0)
  } else {
    $thiz.sci_VectorSliceBuilder__f_maxDim = n;
    var idx = (((-1) + n) | 0)
  };
  $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(idx, a)
}
function $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, n) {
  if (($n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get((((-1) + n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set((((-1) + n) | 0), $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(((11 - n) | 0)));
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((11 - n) | 0), null)
    } else {
      $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, ((1 + n) | 0));
      var $$x1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var preN1 = $asArrayOf_O($n($$x1).get((((-1) + n$1) | 0)), 2);
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set((((-1) + n) | 0), $n(preN1).get(0));
      if (($n(preN1).u.length === 1)) {
        var $$x2 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$2 = ((1 + n) | 0);
        $$x2.set((((-1) + n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $$x4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $$x3 = ($n($$x4).get(((11 - n$3) | 0)) === null)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n
        }
      } else {
        var $$x5 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$4 = ((1 + n) | 0);
        var to = $n(preN1).u.length;
        $$x5.set((((-1) + n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(preN1, 1, to))
      }
    }
  }
}
function $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, n) {
  if (($n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(((11 - n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((11 - n) | 0), $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get((((-1) + n) | 0)));
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set((((-1) + n) | 0), null)
    } else {
      $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, ((1 + n) | 0));
      var $$x1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var sufN1 = $asArrayOf_O($n($$x1).get(((11 - n$1) | 0)), 2);
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((11 - n) | 0), $n(sufN1).get((((-1) + $n(sufN1).u.length) | 0)));
      if (($n(sufN1).u.length === 1)) {
        var $$x2 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$2 = ((1 + n) | 0);
        $$x2.set(((11 - n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $$x4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $$x3 = ($n($$x4).get((((-1) + n$3) | 0)) === null)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n
        }
      } else {
        var $$x5 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$4 = ((1 + n) | 0);
        var to = (((-1) + $n(sufN1).u.length) | 0);
        $$x5.set(((11 - n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(sufN1, 0, to))
      }
    }
  }
}
/** @constructor */
function $c_sci_VectorSliceBuilder(lo, hi) {
  this.sci_VectorSliceBuilder__f_lo = 0;
  this.sci_VectorSliceBuilder__f_hi = 0;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = null;
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
  this.sci_VectorSliceBuilder__f_lo = lo;
  this.sci_VectorSliceBuilder__f_hi = hi;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = new ($d_O.getArrayOf().getArrayOf().constr)(11);
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0
}
$c_sci_VectorSliceBuilder.prototype = new $h_O();
$c_sci_VectorSliceBuilder.prototype.constructor = $c_sci_VectorSliceBuilder;
/** @constructor */
function $h_sci_VectorSliceBuilder() {
  /*<skip>*/
}
$h_sci_VectorSliceBuilder.prototype = $c_sci_VectorSliceBuilder.prototype;
$c_sci_VectorSliceBuilder.prototype.consider__I__AO__V = (function(n, a) {
  var count = Math.imul($n(a).u.length, (1 << Math.imul(5, (((-1) + n) | 0))));
  var a$1 = ((this.sci_VectorSliceBuilder__f_lo - this.sci_VectorSliceBuilder__f_pos) | 0);
  var lo0 = ((a$1 > 0) ? a$1 : 0);
  var a$2 = ((this.sci_VectorSliceBuilder__f_hi - this.sci_VectorSliceBuilder__f_pos) | 0);
  var hi0 = ((a$2 < count) ? a$2 : count);
  if ((hi0 > lo0)) {
    $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V(this, n, a, lo0, hi0);
    this.sci_VectorSliceBuilder__f_len = ((this.sci_VectorSliceBuilder__f_len + ((hi0 - lo0) | 0)) | 0)
  };
  this.sci_VectorSliceBuilder__f_pos = ((this.sci_VectorSliceBuilder__f_pos + count) | 0)
});
$c_sci_VectorSliceBuilder.prototype.result__sci_Vector = (function() {
  if ((this.sci_VectorSliceBuilder__f_len <= 32)) {
    if ((this.sci_VectorSliceBuilder__f_len === 0)) {
      return $m_sci_Vector0$()
    } else {
      var prefix1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(0);
      var suffix1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(10);
      if ((prefix1 !== null)) {
        if ((suffix1 !== null)) {
          var newLength = (($n(prefix1).u.length + $n(suffix1).u.length) | 0);
          var dest = $m_ju_Arrays$().copyOf__AO__I__AO(prefix1, newLength);
          var destPos = $n(prefix1).u.length;
          var length = $n(suffix1).u.length;
          $systemArraycopyRefs($n(suffix1), 0, $n(dest), destPos, length);
          var a = dest
        } else {
          var a = prefix1
        }
      } else if ((suffix1 !== null)) {
        var a = suffix1
      } else {
        var prefix2 = $asArrayOf_O($n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1), 2);
        if ((prefix2 !== null)) {
          var a = $n(prefix2).get(0)
        } else {
          var suffix2 = $asArrayOf_O($n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9), 2);
          var a = $n(suffix2).get(0)
        }
      };
      return new $c_sci_Vector1(a)
    }
  } else {
    $p_sci_VectorSliceBuilder__balancePrefix__I__V(this, 1);
    $p_sci_VectorSliceBuilder__balanceSuffix__I__V(this, 1);
    var resultDim = this.sci_VectorSliceBuilder__f_maxDim;
    if ((resultDim < 6)) {
      var $$x1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
      var n = this.sci_VectorSliceBuilder__f_maxDim;
      var pre = $n($$x1).get((((-1) + n) | 0));
      var $$x2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
      var n$1 = this.sci_VectorSliceBuilder__f_maxDim;
      var suf = $n($$x2).get(((11 - n$1) | 0));
      if (((pre !== null) && (suf !== null))) {
        if (((($n(pre).u.length + $n(suf).u.length) | 0) <= 30)) {
          var $$x3 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
          var n$2 = this.sci_VectorSliceBuilder__f_maxDim;
          var newLength$1 = (($n(pre).u.length + $n(suf).u.length) | 0);
          var dest$1 = $m_ju_Arrays$().copyOf__AO__I__AO(pre, newLength$1);
          var destPos$1 = $n(pre).u.length;
          var length$1 = $n(suf).u.length;
          $systemArraycopyRefs($n(suf), 0, $n(dest$1), destPos$1, length$1);
          $$x3.set((((-1) + n$2) | 0), dest$1);
          var $$x4 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
          var n$3 = this.sci_VectorSliceBuilder__f_maxDim;
          $$x4.set(((11 - n$3) | 0), null)
        } else {
          resultDim = ((1 + resultDim) | 0)
        }
      } else {
        var one = ((pre !== null) ? pre : suf);
        if (($n(one).u.length > 30)) {
          resultDim = ((1 + resultDim) | 0)
        }
      }
    };
    var prefix1$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(0);
    var suffix1$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(10);
    var len1 = $n(prefix1$2).u.length;
    var x1 = resultDim;
    switch (x1) {
      case 2: {
        var a$1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        if ((p !== null)) {
          var $$x5 = p
        } else {
          var s = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
          var $$x5 = ((s !== null) ? s : a$1)
        };
        var data2 = $asArrayOf_O($$x5, 2);
        var res = new $c_sci_Vector2(prefix1$2, len1, data2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 3: {
        var a$2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$2 = $asArrayOf_O(((p$1 !== null) ? p$1 : a$2), 2);
        var a$3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        if ((p$2 !== null)) {
          var $$x6 = p$2
        } else {
          var s$1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
          var $$x6 = ((s$1 !== null) ? s$1 : a$3)
        };
        var data3 = $asArrayOf_O($$x6, 3);
        var a$4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$2 = $asArrayOf_O(((s$2 !== null) ? s$2 : a$4), 2);
        var len12 = ((len1 + ($n(prefix2$2).u.length << 5)) | 0);
        var res = new $c_sci_Vector3(prefix1$2, len1, prefix2$2, len12, data3, suffix2$2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 4: {
        var a$5 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$3 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$3 = $asArrayOf_O(((p$3 !== null) ? p$3 : a$5), 2);
        var a$6 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$4 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        var prefix3 = $asArrayOf_O(((p$4 !== null) ? p$4 : a$6), 3);
        var a$7 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$5 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(3);
        if ((p$5 !== null)) {
          var $$x7 = p$5
        } else {
          var s$3 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(7);
          var $$x7 = ((s$3 !== null) ? s$3 : a$7)
        };
        var data4 = $asArrayOf_O($$x7, 4);
        var a$8 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$4 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
        var suffix3 = $asArrayOf_O(((s$4 !== null) ? s$4 : a$8), 3);
        var a$9 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$5 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$3 = $asArrayOf_O(((s$5 !== null) ? s$5 : a$9), 2);
        var len12$2 = ((len1 + ($n(prefix2$3).u.length << 5)) | 0);
        var len123 = ((len12$2 + ($n(prefix3).u.length << 10)) | 0);
        var res = new $c_sci_Vector4(prefix1$2, len1, prefix2$3, len12$2, prefix3, len123, data4, suffix3, suffix2$3, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 5: {
        var a$10 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$6 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$4 = $asArrayOf_O(((p$6 !== null) ? p$6 : a$10), 2);
        var a$11 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$7 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        var prefix3$2 = $asArrayOf_O(((p$7 !== null) ? p$7 : a$11), 3);
        var a$12 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$8 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(3);
        var prefix4 = $asArrayOf_O(((p$8 !== null) ? p$8 : a$12), 4);
        var a$13 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$9 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(4);
        if ((p$9 !== null)) {
          var $$x8 = p$9
        } else {
          var s$6 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(6);
          var $$x8 = ((s$6 !== null) ? s$6 : a$13)
        };
        var data5 = $asArrayOf_O($$x8, 5);
        var a$14 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$7 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(7);
        var suffix4 = $asArrayOf_O(((s$7 !== null) ? s$7 : a$14), 4);
        var a$15 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$8 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
        var suffix3$2 = $asArrayOf_O(((s$8 !== null) ? s$8 : a$15), 3);
        var a$16 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$9 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$4 = $asArrayOf_O(((s$9 !== null) ? s$9 : a$16), 2);
        var len12$3 = ((len1 + ($n(prefix2$4).u.length << 5)) | 0);
        var len123$2 = ((len12$3 + ($n(prefix3$2).u.length << 10)) | 0);
        var len1234 = ((len123$2 + ($n(prefix4).u.length << 15)) | 0);
        var res = new $c_sci_Vector5(prefix1$2, len1, prefix2$4, len12$3, prefix3$2, len123$2, prefix4, len1234, data5, suffix4, suffix3$2, suffix2$4, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 6: {
        var a$17 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$10 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$5 = $asArrayOf_O(((p$10 !== null) ? p$10 : a$17), 2);
        var a$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$11 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        var prefix3$3 = $asArrayOf_O(((p$11 !== null) ? p$11 : a$18), 3);
        var a$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$12 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(3);
        var prefix4$2 = $asArrayOf_O(((p$12 !== null) ? p$12 : a$19), 4);
        var a$20 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$13 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(4);
        var prefix5 = $asArrayOf_O(((p$13 !== null) ? p$13 : a$20), 5);
        var a$21 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
        var p$14 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(5);
        if ((p$14 !== null)) {
          var $$x9 = p$14
        } else {
          var s$10 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(5);
          var $$x9 = ((s$10 !== null) ? s$10 : a$21)
        };
        var data6 = $asArrayOf_O($$x9, 6);
        var a$22 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var s$11 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(6);
        var suffix5 = $asArrayOf_O(((s$11 !== null) ? s$11 : a$22), 5);
        var a$23 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$12 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(7);
        var suffix4$2 = $asArrayOf_O(((s$12 !== null) ? s$12 : a$23), 4);
        var a$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$13 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
        var suffix3$3 = $asArrayOf_O(((s$13 !== null) ? s$13 : a$24), 3);
        var a$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$14 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$5 = $asArrayOf_O(((s$14 !== null) ? s$14 : a$25), 2);
        var len12$4 = ((len1 + ($n(prefix2$5).u.length << 5)) | 0);
        var len123$3 = ((len12$4 + ($n(prefix3$3).u.length << 10)) | 0);
        var len1234$2 = ((len123$3 + ($n(prefix4$2).u.length << 15)) | 0);
        var len12345 = ((len1234$2 + ($n(prefix5).u.length << 20)) | 0);
        var res = new $c_sci_Vector6(prefix1$2, len1, prefix2$5, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data6, suffix5, suffix4$2, suffix3$3, suffix2$5, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      default: {
        var res;
        throw new $c_s_MatchError(x1)
      }
    };
    return res
  }
});
$c_sci_VectorSliceBuilder.prototype.toString__T = (function() {
  return (((((((((("VectorSliceBuilder(lo=" + this.sci_VectorSliceBuilder__f_lo) + ", hi=") + this.sci_VectorSliceBuilder__f_hi) + ", len=") + this.sci_VectorSliceBuilder__f_len) + ", pos=") + this.sci_VectorSliceBuilder__f_pos) + ", maxDim=") + this.sci_VectorSliceBuilder__f_maxDim) + ")")
});
var $d_sci_VectorSliceBuilder = new $TypeData().initClass({
  sci_VectorSliceBuilder: 0
}, false, "scala.collection.immutable.VectorSliceBuilder", {
  sci_VectorSliceBuilder: 1,
  O: 1
});
$c_sci_VectorSliceBuilder.prototype.$classData = $d_sci_VectorSliceBuilder;
/** @constructor */
function $c_sci_VectorStatics$() {
  this.sci_VectorStatics$__f_empty1 = null;
  this.sci_VectorStatics$__f_empty2 = null;
  this.sci_VectorStatics$__f_empty3 = null;
  this.sci_VectorStatics$__f_empty4 = null;
  this.sci_VectorStatics$__f_empty5 = null;
  this.sci_VectorStatics$__f_empty6 = null;
  $n_sci_VectorStatics$ = this;
  this.sci_VectorStatics$__f_empty1 = new $ac_O(0);
  this.sci_VectorStatics$__f_empty2 = new ($d_O.getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0)
}
$c_sci_VectorStatics$.prototype = new $h_O();
$c_sci_VectorStatics$.prototype.constructor = $c_sci_VectorStatics$;
/** @constructor */
function $h_sci_VectorStatics$() {
  /*<skip>*/
}
$h_sci_VectorStatics$.prototype = $c_sci_VectorStatics$.prototype;
$c_sci_VectorStatics$.prototype.copyAppend1__AO__O__AO = (function(a, elem) {
  var alen = $n(a).u.length;
  var ac = new $ac_O(((1 + alen) | 0));
  $systemArraycopyRefs($n(a), 0, ac, 0, alen);
  $n(ac).set(alen, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyAppend__AO__O__AO = (function(a, elem) {
  var newLength = ((1 + $n(a).u.length) | 0);
  var ac = $m_ju_Arrays$().copyOf__AO__I__AO(a, newLength);
  $n(ac).set((((-1) + $n(ac).u.length) | 0), elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyPrepend1__O__AO__AO = (function(elem, a) {
  var ac = new $ac_O(((1 + $n(a).u.length) | 0));
  var length = $n(a).u.length;
  $systemArraycopyRefs($n(a), 0, ac, 1, length);
  $n(ac).set(0, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyPrepend__O__AO__AO = (function(elem, a) {
  var this$1 = $n(a);
  var componentType = $objectGetClass(this$1).getComponentType__jl_Class();
  var length = ((1 + $n(a).u.length) | 0);
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  var length$1 = $n(a).u.length;
  $systemArraycopyRefs($n(a), 0, $n(ac), 1, length$1);
  $n(ac).set(0, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.foreachRec__I__AO__F1__V = (function(level, a, f) {
  var i = 0;
  var len = $n(a).u.length;
  if ((level === 0)) {
    while ((i < len)) {
      $n(f).apply__O__O($n(a).get(i));
      i = ((1 + i) | 0)
    }
  } else {
    var l = (((-1) + level) | 0);
    while ((i < len)) {
      this.foreachRec__I__AO__F1__V(l, $asArrayOf_O($n(a).get(i), 1), f);
      i = ((1 + i) | 0)
    }
  }
});
$c_sci_VectorStatics$.prototype.mapElems1__AO__F1__AO = (function(a, f) {
  var i = 0;
  while ((i < $n(a).u.length)) {
    var v1 = $n(a).get(i);
    var v2 = $n(f).apply__O__O(v1);
    if ((!Object.is(v1, v2))) {
      return this.mapElems1Rest__AO__F1__I__O__AO(a, f, i, v2)
    };
    i = ((1 + i) | 0)
  };
  return a
});
$c_sci_VectorStatics$.prototype.mapElems1Rest__AO__F1__I__O__AO = (function(a, f, at, v2) {
  var ac = new $ac_O($n(a).u.length);
  if ((at > 0)) {
    $systemArraycopyRefs($n(a), 0, ac, 0, at)
  };
  $n(ac).set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < $n(a).u.length)) {
    $n(ac).set(i, $n(f).apply__O__O($n(a).get(i)));
    i = ((1 + i) | 0)
  };
  return ac
});
$c_sci_VectorStatics$.prototype.mapElems__I__AO__F1__AO = (function(n, a, f) {
  if ((n === 1)) {
    return this.mapElems1__AO__F1__AO(a, f)
  } else {
    var i = 0;
    while ((i < $n(a).u.length)) {
      var v1 = $n(a).get(i);
      var v2 = this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O(v1, 1), f);
      if ((v1 !== v2)) {
        return this.mapElemsRest__I__AO__F1__I__O__AO(n, a, f, i, v2)
      };
      i = ((1 + i) | 0)
    };
    return a
  }
});
$c_sci_VectorStatics$.prototype.mapElemsRest__I__AO__F1__I__O__AO = (function(n, a, f, at, v2) {
  var this$1 = $n(a);
  var componentType = $objectGetClass(this$1).getComponentType__jl_Class();
  var length = $n(a).u.length;
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  if ((at > 0)) {
    $systemArraycopyRefs($n(a), 0, $n(ac), 0, at)
  };
  $n(ac).set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < $n(a).u.length)) {
    $n(ac).set(i, this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O($n(a).get(i), 1), f));
    i = ((1 + i) | 0)
  };
  return ac
});
$c_sci_VectorStatics$.prototype.append1IfSpace__AO__sc_IterableOnce__AO = (function(suffix1, xs) {
  if ($is_sci_Iterable(xs)) {
    var x2 = $as_sci_Iterable(xs);
    if (($n(x2).sizeCompare__I__I(((32 - $n(suffix1).u.length) | 0)) <= 0)) {
      var x1$2 = $n(x2).size__I();
      switch (x1$2) {
        case 0: {
          return null;
          break
        }
        case 1: {
          return this.copyAppend__AO__O__AO(suffix1, $n(x2).head__O());
          break
        }
        default: {
          var newLength = (($n(suffix1).u.length + x1$2) | 0);
          var suffix1b = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength);
          var this$1 = $n(x2);
          var start = $n(suffix1).u.length;
          this$1.copyToArray__O__I__I__I(suffix1b, start, 2147483647);
          return suffix1b
        }
      }
    } else {
      return null
    }
  } else {
    var s = $n(xs).knownSize__I();
    if (((s > 0) && (s <= ((32 - $n(suffix1).u.length) | 0)))) {
      var newLength$1 = (($n(suffix1).u.length + s) | 0);
      var suffix1b$2 = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength$1);
      var this$2 = $n($n(xs).iterator__sc_Iterator());
      var start$1 = $n(suffix1).u.length;
      this$2.copyToArray__O__I__I__I(suffix1b$2, start$1, 2147483647);
      return suffix1b$2
    } else {
      return null
    }
  }
});
var $d_sci_VectorStatics$ = new $TypeData().initClass({
  sci_VectorStatics$: 0
}, false, "scala.collection.immutable.VectorStatics$", {
  sci_VectorStatics$: 1,
  O: 1
});
$c_sci_VectorStatics$.prototype.$classData = $d_sci_VectorStatics$;
var $n_sci_VectorStatics$;
function $m_sci_VectorStatics$() {
  if ((!$n_sci_VectorStatics$)) {
    $n_sci_VectorStatics$ = new $c_sci_VectorStatics$()
  };
  return $n_sci_VectorStatics$
}
/** @constructor */
function $c_scm_HashMap$Node(_key, _hash, _value, _next) {
  this.scm_HashMap$Node__f__key = null;
  this.scm_HashMap$Node__f__hash = 0;
  this.scm_HashMap$Node__f__value = null;
  this.scm_HashMap$Node__f__next = null;
  this.scm_HashMap$Node__f__key = _key;
  this.scm_HashMap$Node__f__hash = _hash;
  this.scm_HashMap$Node__f__value = _value;
  this.scm_HashMap$Node__f__next = _next
}
$c_scm_HashMap$Node.prototype = new $h_O();
$c_scm_HashMap$Node.prototype.constructor = $c_scm_HashMap$Node;
/** @constructor */
function $h_scm_HashMap$Node() {
  /*<skip>*/
}
$h_scm_HashMap$Node.prototype = $c_scm_HashMap$Node.prototype;
$c_scm_HashMap$Node.prototype.findNode__O__I__scm_HashMap$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === $n(_$this).scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(_$this).scm_HashMap$Node__f__key))) {
      return _$this
    } else if ((($n(_$this).scm_HashMap$Node__f__next === null) || ($n(_$this).scm_HashMap$Node__f__hash > h))) {
      return null
    } else {
      _$this = $n(_$this).scm_HashMap$Node__f__next
    }
  }
});
$c_scm_HashMap$Node.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), $n(_$this).scm_HashMap$Node__f__key, $n(_$this).scm_HashMap$Node__f__value));
    if (($n(_$this).scm_HashMap$Node__f__next !== null)) {
      _$this = $n(_$this).scm_HashMap$Node__f__next;
      continue
    };
    break
  }
});
$c_scm_HashMap$Node.prototype.foreachEntry__F2__V = (function(f) {
  var _$this = this;
  while (true) {
    $n(f).apply__O__O__O($n(_$this).scm_HashMap$Node__f__key, $n(_$this).scm_HashMap$Node__f__value);
    if (($n(_$this).scm_HashMap$Node__f__next !== null)) {
      _$this = $n(_$this).scm_HashMap$Node__f__next;
      continue
    };
    break
  }
});
$c_scm_HashMap$Node.prototype.toString__T = (function() {
  return ((((((("Node(" + this.scm_HashMap$Node__f__key) + ", ") + this.scm_HashMap$Node__f__value) + ", ") + this.scm_HashMap$Node__f__hash) + ") -> ") + this.scm_HashMap$Node__f__next)
});
function $as_scm_HashMap$Node(obj) {
  return (((obj instanceof $c_scm_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap$Node"))
}
function $isArrayOf_scm_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap$Node)))
}
function $asArrayOf_scm_HashMap$Node(obj, depth) {
  return (($isArrayOf_scm_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap$Node;", depth))
}
var $d_scm_HashMap$Node = new $TypeData().initClass({
  scm_HashMap$Node: 0
}, false, "scala.collection.mutable.HashMap$Node", {
  scm_HashMap$Node: 1,
  O: 1
});
$c_scm_HashMap$Node.prototype.$classData = $d_scm_HashMap$Node;
/** @constructor */
function $c_scm_HashSet$Node(_key, _hash, _next) {
  this.scm_HashSet$Node__f__key = null;
  this.scm_HashSet$Node__f__hash = 0;
  this.scm_HashSet$Node__f__next = null;
  this.scm_HashSet$Node__f__key = _key;
  this.scm_HashSet$Node__f__hash = _hash;
  this.scm_HashSet$Node__f__next = _next
}
$c_scm_HashSet$Node.prototype = new $h_O();
$c_scm_HashSet$Node.prototype.constructor = $c_scm_HashSet$Node;
/** @constructor */
function $h_scm_HashSet$Node() {
  /*<skip>*/
}
$h_scm_HashSet$Node.prototype = $c_scm_HashSet$Node.prototype;
$c_scm_HashSet$Node.prototype.findNode__O__I__scm_HashSet$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === $n(_$this).scm_HashSet$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(_$this).scm_HashSet$Node__f__key))) {
      return _$this
    } else if ((($n(_$this).scm_HashSet$Node__f__next === null) || ($n(_$this).scm_HashSet$Node__f__hash > h))) {
      return null
    } else {
      _$this = $n(_$this).scm_HashSet$Node__f__next
    }
  }
});
$c_scm_HashSet$Node.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    $n(f).apply__O__O($n(_$this).scm_HashSet$Node__f__key);
    if (($n(_$this).scm_HashSet$Node__f__next !== null)) {
      _$this = $n(_$this).scm_HashSet$Node__f__next;
      continue
    };
    break
  }
});
$c_scm_HashSet$Node.prototype.toString__T = (function() {
  return ((((("Node(" + this.scm_HashSet$Node__f__key) + ", ") + this.scm_HashSet$Node__f__hash) + ") -> ") + this.scm_HashSet$Node__f__next)
});
function $as_scm_HashSet$Node(obj) {
  return (((obj instanceof $c_scm_HashSet$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet$Node"))
}
function $isArrayOf_scm_HashSet$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet$Node)))
}
function $asArrayOf_scm_HashSet$Node(obj, depth) {
  return (($isArrayOf_scm_HashSet$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet$Node;", depth))
}
var $d_scm_HashSet$Node = new $TypeData().initClass({
  scm_HashSet$Node: 0
}, false, "scala.collection.mutable.HashSet$Node", {
  scm_HashSet$Node: 1,
  O: 1
});
$c_scm_HashSet$Node.prototype.$classData = $d_scm_HashSet$Node;
function $as_scm_LinkedHashMap$LinkedEntry(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashMap$LinkedEntry"))
}
function $isArrayOf_scm_LinkedHashMap$LinkedEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashMap$LinkedEntry)))
}
function $asArrayOf_scm_LinkedHashMap$LinkedEntry(obj, depth) {
  return (($isArrayOf_scm_LinkedHashMap$LinkedEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashMap$LinkedEntry;", depth))
}
function $as_scm_LinkedHashSet$Entry(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashSet$Entry"))
}
function $isArrayOf_scm_LinkedHashSet$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashSet$Entry)))
}
function $asArrayOf_scm_LinkedHashSet$Entry(obj, depth) {
  return (($isArrayOf_scm_LinkedHashSet$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashSet$Entry;", depth))
}
/** @constructor */
function $c_scm_MutationTracker$() {
  /*<skip>*/
}
$c_scm_MutationTracker$.prototype = new $h_O();
$c_scm_MutationTracker$.prototype.constructor = $c_scm_MutationTracker$;
/** @constructor */
function $h_scm_MutationTracker$() {
  /*<skip>*/
}
$h_scm_MutationTracker$.prototype = $c_scm_MutationTracker$.prototype;
$c_scm_MutationTracker$.prototype.checkMutations__I__I__T__V = (function(expectedCount, actualCount, message) {
  if ((actualCount !== expectedCount)) {
    throw new $c_ju_ConcurrentModificationException(message)
  }
});
var $d_scm_MutationTracker$ = new $TypeData().initClass({
  scm_MutationTracker$: 0
}, false, "scala.collection.mutable.MutationTracker$", {
  scm_MutationTracker$: 1,
  O: 1
});
$c_scm_MutationTracker$.prototype.$classData = $d_scm_MutationTracker$;
var $n_scm_MutationTracker$;
function $m_scm_MutationTracker$() {
  if ((!$n_scm_MutationTracker$)) {
    $n_scm_MutationTracker$ = new $c_scm_MutationTracker$()
  };
  return $n_scm_MutationTracker$
}
function $p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node($thiz, node, key, ord) {
  while (true) {
    if ((node === null)) {
      return null
    } else {
      var cmp = $n(ord).compare__O__O__I(key, $n(node).scm_RedBlackTree$Node__f_key);
      if ((cmp < 0)) {
        node = $n(node).scm_RedBlackTree$Node__f_left
      } else if ((cmp > 0)) {
        node = $n(node).scm_RedBlackTree$Node__f_right
      } else {
        return node
      }
    }
  }
}
function $p_scm_RedBlackTree$__maxNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node($thiz, node) {
  return ((node === null) ? null : $thiz.maxNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node))
}
function $p_scm_RedBlackTree$__fixAfterInsert__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, node) {
  var z = node;
  while ($thiz.isRed__scm_RedBlackTree$Node__Z($n(z).scm_RedBlackTree$Node__f_parent)) {
    if (($n(z).scm_RedBlackTree$Node__f_parent === $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left)) {
      var y = $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right;
      if ($thiz.isRed__scm_RedBlackTree$Node__Z(y)) {
        $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = false;
        $n(y).scm_RedBlackTree$Node__f_red = false;
        $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = true;
        z = $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent
      } else {
        if ((z === $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right)) {
          z = $n(z).scm_RedBlackTree$Node__f_parent;
          $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z)
        };
        $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = false;
        $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent)
      }
    } else {
      var y$2 = $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left;
      if ($thiz.isRed__scm_RedBlackTree$Node__Z(y$2)) {
        $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = false;
        $n(y$2).scm_RedBlackTree$Node__f_red = false;
        $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = true;
        z = $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent
      } else {
        if ((z === $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left)) {
          z = $n(z).scm_RedBlackTree$Node__f_parent;
          $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z)
        };
        $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = false;
        $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent)
      }
    }
  };
  $n($n(tree).scm_RedBlackTree$Tree__f_root).scm_RedBlackTree$Node__f_red = false
}
function $p_scm_RedBlackTree$__fixAfterDelete__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V($thiz, tree, node, parent) {
  var x = node;
  var xParent = parent;
  while (((x !== $n(tree).scm_RedBlackTree$Tree__f_root) && $thiz.isBlack__scm_RedBlackTree$Node__Z(x))) {
    if ((x === $n(xParent).scm_RedBlackTree$Node__f_left)) {
      var w = $n(xParent).scm_RedBlackTree$Node__f_right;
      if ($n(w).scm_RedBlackTree$Node__f_red) {
        $n(w).scm_RedBlackTree$Node__f_red = false;
        $n(xParent).scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        w = $n(xParent).scm_RedBlackTree$Node__f_right
      };
      if (($thiz.isBlack__scm_RedBlackTree$Node__Z($n(w).scm_RedBlackTree$Node__f_left) && $thiz.isBlack__scm_RedBlackTree$Node__Z($n(w).scm_RedBlackTree$Node__f_right))) {
        $n(w).scm_RedBlackTree$Node__f_red = true;
        x = xParent
      } else {
        if ($thiz.isBlack__scm_RedBlackTree$Node__Z($n(w).scm_RedBlackTree$Node__f_right)) {
          $n($n(w).scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_red = false;
          $n(w).scm_RedBlackTree$Node__f_red = true;
          $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, w);
          w = $n(xParent).scm_RedBlackTree$Node__f_right
        };
        $n(w).scm_RedBlackTree$Node__f_red = $n(xParent).scm_RedBlackTree$Node__f_red;
        $n(xParent).scm_RedBlackTree$Node__f_red = false;
        $n($n(w).scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_red = false;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        x = $n(tree).scm_RedBlackTree$Tree__f_root
      }
    } else {
      var w$2 = $n(xParent).scm_RedBlackTree$Node__f_left;
      if ($n(w$2).scm_RedBlackTree$Node__f_red) {
        $n(w$2).scm_RedBlackTree$Node__f_red = false;
        $n(xParent).scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        w$2 = $n(xParent).scm_RedBlackTree$Node__f_left
      };
      if (($thiz.isBlack__scm_RedBlackTree$Node__Z($n(w$2).scm_RedBlackTree$Node__f_right) && $thiz.isBlack__scm_RedBlackTree$Node__Z($n(w$2).scm_RedBlackTree$Node__f_left))) {
        $n(w$2).scm_RedBlackTree$Node__f_red = true;
        x = xParent
      } else {
        if ($thiz.isBlack__scm_RedBlackTree$Node__Z($n(w$2).scm_RedBlackTree$Node__f_left)) {
          $n($n(w$2).scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_red = false;
          $n(w$2).scm_RedBlackTree$Node__f_red = true;
          $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, w$2);
          w$2 = $n(xParent).scm_RedBlackTree$Node__f_left
        };
        $n(w$2).scm_RedBlackTree$Node__f_red = $n(xParent).scm_RedBlackTree$Node__f_red;
        $n(xParent).scm_RedBlackTree$Node__f_red = false;
        $n($n(w$2).scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_red = false;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        x = $n(tree).scm_RedBlackTree$Tree__f_root
      }
    };
    xParent = $n(x).scm_RedBlackTree$Node__f_parent
  };
  if ((x !== null)) {
    $n(x).scm_RedBlackTree$Node__f_red = false
  }
}
function $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, x) {
  if ((x !== null)) {
    var y = $n(x).scm_RedBlackTree$Node__f_right;
    $n(x).scm_RedBlackTree$Node__f_right = $n(y).scm_RedBlackTree$Node__f_left;
    if (($n(y).scm_RedBlackTree$Node__f_left !== null)) {
      $n($n(y).scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_parent = x
    };
    $n(y).scm_RedBlackTree$Node__f_parent = $n(x).scm_RedBlackTree$Node__f_parent;
    if (($n(x).scm_RedBlackTree$Node__f_parent === null)) {
      $n(tree).scm_RedBlackTree$Tree__f_root = y
    } else if ((x === $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left)) {
      $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left = y
    } else {
      $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right = y
    };
    $n(y).scm_RedBlackTree$Node__f_left = x;
    $n(x).scm_RedBlackTree$Node__f_parent = y
  }
}
function $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, x) {
  if ((x !== null)) {
    var y = $n(x).scm_RedBlackTree$Node__f_left;
    $n(x).scm_RedBlackTree$Node__f_left = $n(y).scm_RedBlackTree$Node__f_right;
    if (($n(y).scm_RedBlackTree$Node__f_right !== null)) {
      $n($n(y).scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_parent = x
    };
    $n(y).scm_RedBlackTree$Node__f_parent = $n(x).scm_RedBlackTree$Node__f_parent;
    if (($n(x).scm_RedBlackTree$Node__f_parent === null)) {
      $n(tree).scm_RedBlackTree$Tree__f_root = y
    } else if ((x === $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right)) {
      $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right = y
    } else {
      $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left = y
    };
    $n(y).scm_RedBlackTree$Node__f_right = x;
    $n(x).scm_RedBlackTree$Node__f_parent = y
  }
}
function $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V($thiz, tree, to, from) {
  if (($n(to).scm_RedBlackTree$Node__f_parent === null)) {
    $n(tree).scm_RedBlackTree$Tree__f_root = from
  } else if ((to === $n($n(to).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left)) {
    $n($n(to).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left = from
  } else {
    $n($n(to).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right = from
  };
  if ((from !== null)) {
    $n(from).scm_RedBlackTree$Node__f_parent = $n(to).scm_RedBlackTree$Node__f_parent
  }
}
function $p_scm_RedBlackTree$__g$1__scm_RedBlackTree$Node__F1__V($thiz, node, f$1) {
  while (true) {
    var l = $n(node).scm_RedBlackTree$Node__f_left;
    if ((l !== null)) {
      $p_scm_RedBlackTree$__g$1__scm_RedBlackTree$Node__F1__V($thiz, l, f$1)
    };
    $n(f$1).apply__O__O($n(node).scm_RedBlackTree$Node__f_key);
    var r = $n(node).scm_RedBlackTree$Node__f_right;
    if ((r !== null)) {
      node = r;
      continue
    };
    return (void 0)
  }
}
function $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, level, size, xs$1, maxUsedDepth$1) {
  switch (size) {
    case 0: {
      return null;
      break
    }
    case 1: {
      return new $c_scm_RedBlackTree$Node($n(xs$1).next__O(), null, ((level === maxUsedDepth$1) && (level !== 1)), null, null, null);
      break
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, ((1 + level) | 0), leftSize, xs$1, maxUsedDepth$1);
      var x = $n(xs$1).next__O();
      var right = $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), xs$1, maxUsedDepth$1);
      var n = new $c_scm_RedBlackTree$Node(x, null, false, left, right, null);
      if ((left !== null)) {
        $n(left).scm_RedBlackTree$Node__f_parent = n
      };
      $n(right).scm_RedBlackTree$Node__f_parent = n;
      return n
    }
  }
}
/** @constructor */
function $c_scm_RedBlackTree$() {
  /*<skip>*/
}
$c_scm_RedBlackTree$.prototype = new $h_O();
$c_scm_RedBlackTree$.prototype.constructor = $c_scm_RedBlackTree$;
/** @constructor */
function $h_scm_RedBlackTree$() {
  /*<skip>*/
}
$h_scm_RedBlackTree$.prototype = $c_scm_RedBlackTree$.prototype;
$c_scm_RedBlackTree$.prototype.isRed__scm_RedBlackTree$Node__Z = (function(node) {
  return ((node !== null) && $n(node).scm_RedBlackTree$Node__f_red)
});
$c_scm_RedBlackTree$.prototype.isBlack__scm_RedBlackTree$Node__Z = (function(node) {
  return ((node === null) || (!$n(node).scm_RedBlackTree$Node__f_red))
});
$c_scm_RedBlackTree$.prototype.isEmpty__scm_RedBlackTree$Tree__Z = (function(tree) {
  return ($n(tree).scm_RedBlackTree$Tree__f_root === null)
});
$c_scm_RedBlackTree$.prototype.contains__scm_RedBlackTree$Tree__O__s_math_Ordering__Z = (function(tree, key, evidence$2) {
  return ($p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(this, $n(tree).scm_RedBlackTree$Tree__f_root, key, evidence$2) !== null)
});
$c_scm_RedBlackTree$.prototype.minKey__scm_RedBlackTree$Tree__s_Option = (function(tree) {
  var x1 = this.scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(tree).scm_RedBlackTree$Tree__f_root);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some($n(x1).scm_RedBlackTree$Node__f_key))
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  return ((node === null) ? null : this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node))
});
$c_scm_RedBlackTree$.prototype.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  while (true) {
    if (($n(node).scm_RedBlackTree$Node__f_left === null)) {
      return node
    } else {
      node = $n(node).scm_RedBlackTree$Node__f_left
    }
  }
});
$c_scm_RedBlackTree$.prototype.maxKey__scm_RedBlackTree$Tree__s_Option = (function(tree) {
  var x1 = $p_scm_RedBlackTree$__maxNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node(this, $n(tree).scm_RedBlackTree$Tree__f_root);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some($n(x1).scm_RedBlackTree$Node__f_key))
});
$c_scm_RedBlackTree$.prototype.maxNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  while (true) {
    if (($n(node).scm_RedBlackTree$Node__f_right === null)) {
      return node
    } else {
      node = $n(node).scm_RedBlackTree$Node__f_right
    }
  }
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$minNodeAfter__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node = (function(node, key, ord) {
  if ((node === null)) {
    return null
  } else {
    var y = null;
    var x = node;
    var cmp = 1;
    while (((x !== null) && (cmp !== 0))) {
      y = x;
      cmp = $n(ord).compare__O__O__I(key, $n(x).scm_RedBlackTree$Node__f_key);
      x = ((cmp < 0) ? $n(x).scm_RedBlackTree$Node__f_left : $n(x).scm_RedBlackTree$Node__f_right)
    };
    return ((cmp <= 0) ? y : this.scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node(y))
  }
});
$c_scm_RedBlackTree$.prototype.insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V = (function(tree, key, value, ord) {
  var y = null;
  var x = $n(tree).scm_RedBlackTree$Tree__f_root;
  var cmp = 1;
  while (((x !== null) && (cmp !== 0))) {
    y = x;
    cmp = $n(ord).compare__O__O__I(key, $n(x).scm_RedBlackTree$Node__f_key);
    x = ((cmp < 0) ? $n(x).scm_RedBlackTree$Node__f_left : $n(x).scm_RedBlackTree$Node__f_right)
  };
  if ((cmp === 0)) {
    $n(y).scm_RedBlackTree$Node__f_value = value
  } else {
    var parent = y;
    var z = new $c_scm_RedBlackTree$Node(key, value, true, null, null, parent);
    if ((y === null)) {
      $n(tree).scm_RedBlackTree$Tree__f_root = z
    } else if ((cmp < 0)) {
      $n(y).scm_RedBlackTree$Node__f_left = z
    } else {
      $n(y).scm_RedBlackTree$Node__f_right = z
    };
    $p_scm_RedBlackTree$__fixAfterInsert__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V(this, tree, z);
    $n(tree).scm_RedBlackTree$Tree__f_size = ((1 + $n(tree).scm_RedBlackTree$Tree__f_size) | 0)
  }
});
$c_scm_RedBlackTree$.prototype.delete__scm_RedBlackTree$Tree__O__s_math_Ordering__V = (function(tree, key, ord) {
  var z = $p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(this, $n(tree).scm_RedBlackTree$Tree__f_root, key, ord);
  if ((z !== null)) {
    var y = z;
    var yIsRed = $n(y).scm_RedBlackTree$Node__f_red;
    var x = null;
    var xParent = null;
    if (($n(z).scm_RedBlackTree$Node__f_left === null)) {
      x = $n(z).scm_RedBlackTree$Node__f_right;
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, $n(z).scm_RedBlackTree$Node__f_right);
      xParent = $n(z).scm_RedBlackTree$Node__f_parent
    } else if (($n(z).scm_RedBlackTree$Node__f_right === null)) {
      x = $n(z).scm_RedBlackTree$Node__f_left;
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, $n(z).scm_RedBlackTree$Node__f_left);
      xParent = $n(z).scm_RedBlackTree$Node__f_parent
    } else {
      y = this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(z).scm_RedBlackTree$Node__f_right);
      yIsRed = $n(y).scm_RedBlackTree$Node__f_red;
      x = $n(y).scm_RedBlackTree$Node__f_right;
      if (($n(y).scm_RedBlackTree$Node__f_parent === z)) {
        xParent = y
      } else {
        xParent = $n(y).scm_RedBlackTree$Node__f_parent;
        $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, y, $n(y).scm_RedBlackTree$Node__f_right);
        $n(y).scm_RedBlackTree$Node__f_right = $n(z).scm_RedBlackTree$Node__f_right;
        $n($n(y).scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_parent = y
      };
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, y);
      $n(y).scm_RedBlackTree$Node__f_left = $n(z).scm_RedBlackTree$Node__f_left;
      $n($n(y).scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_parent = y;
      $n(y).scm_RedBlackTree$Node__f_red = $n(z).scm_RedBlackTree$Node__f_red
    };
    if ((!yIsRed)) {
      $p_scm_RedBlackTree$__fixAfterDelete__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, x, xParent)
    };
    $n(tree).scm_RedBlackTree$Tree__f_size = (((-1) + $n(tree).scm_RedBlackTree$Tree__f_size) | 0)
  }
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  if (($n(node).scm_RedBlackTree$Node__f_right !== null)) {
    return this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(node).scm_RedBlackTree$Node__f_right)
  } else {
    var x = node;
    var y = $n(x).scm_RedBlackTree$Node__f_parent;
    while (((y !== null) && (x === $n(y).scm_RedBlackTree$Node__f_right))) {
      x = y;
      y = $n(y).scm_RedBlackTree$Node__f_parent
    };
    return y
  }
});
$c_scm_RedBlackTree$.prototype.foreachKey__scm_RedBlackTree$Tree__F1__V = (function(tree, f) {
  var r = $n(tree).scm_RedBlackTree$Tree__f_root;
  if ((r !== null)) {
    $p_scm_RedBlackTree$__g$1__scm_RedBlackTree$Node__F1__V(this, r, f)
  }
});
$c_scm_RedBlackTree$.prototype.fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - $uI(Math.clz32(size))) | 0);
  return new $c_scm_RedBlackTree$Tree($p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node(this, 1, size, xs, maxUsedDepth), size)
});
$c_scm_RedBlackTree$.prototype.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(n) {
  if ((n === null)) {
    return null
  } else {
    var c = new $c_scm_RedBlackTree$Node($n(n).scm_RedBlackTree$Node__f_key, $n(n).scm_RedBlackTree$Node__f_value, $n(n).scm_RedBlackTree$Node__f_red, this.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(n).scm_RedBlackTree$Node__f_left), this.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(n).scm_RedBlackTree$Node__f_right), null);
    if ((c.scm_RedBlackTree$Node__f_left !== null)) {
      $n(c.scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_parent = c
    };
    if ((c.scm_RedBlackTree$Node__f_right !== null)) {
      $n(c.scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_parent = c
    };
    return c
  }
});
var $d_scm_RedBlackTree$ = new $TypeData().initClass({
  scm_RedBlackTree$: 0
}, false, "scala.collection.mutable.RedBlackTree$", {
  scm_RedBlackTree$: 1,
  O: 1
});
$c_scm_RedBlackTree$.prototype.$classData = $d_scm_RedBlackTree$;
var $n_scm_RedBlackTree$;
function $m_scm_RedBlackTree$() {
  if ((!$n_scm_RedBlackTree$)) {
    $n_scm_RedBlackTree$ = new $c_scm_RedBlackTree$()
  };
  return $n_scm_RedBlackTree$
}
/** @constructor */
function $c_scm_RedBlackTree$Node(key, value, red, left, right, parent) {
  this.scm_RedBlackTree$Node__f_key = null;
  this.scm_RedBlackTree$Node__f_value = null;
  this.scm_RedBlackTree$Node__f_red = false;
  this.scm_RedBlackTree$Node__f_left = null;
  this.scm_RedBlackTree$Node__f_right = null;
  this.scm_RedBlackTree$Node__f_parent = null;
  this.scm_RedBlackTree$Node__f_key = key;
  this.scm_RedBlackTree$Node__f_value = value;
  this.scm_RedBlackTree$Node__f_red = red;
  this.scm_RedBlackTree$Node__f_left = left;
  this.scm_RedBlackTree$Node__f_right = right;
  this.scm_RedBlackTree$Node__f_parent = parent
}
$c_scm_RedBlackTree$Node.prototype = new $h_O();
$c_scm_RedBlackTree$Node.prototype.constructor = $c_scm_RedBlackTree$Node;
/** @constructor */
function $h_scm_RedBlackTree$Node() {
  /*<skip>*/
}
$h_scm_RedBlackTree$Node.prototype = $c_scm_RedBlackTree$Node.prototype;
$c_scm_RedBlackTree$Node.prototype.toString__T = (function() {
  return (((((((((("Node(" + this.scm_RedBlackTree$Node__f_key) + ", ") + this.scm_RedBlackTree$Node__f_value) + ", ") + this.scm_RedBlackTree$Node__f_red) + ", ") + this.scm_RedBlackTree$Node__f_left) + ", ") + this.scm_RedBlackTree$Node__f_right) + ")")
});
var $d_scm_RedBlackTree$Node = new $TypeData().initClass({
  scm_RedBlackTree$Node: 0
}, false, "scala.collection.mutable.RedBlackTree$Node", {
  scm_RedBlackTree$Node: 1,
  O: 1
});
$c_scm_RedBlackTree$Node.prototype.$classData = $d_scm_RedBlackTree$Node;
/** @constructor */
function $c_scm_RedBlackTree$Tree(root, size) {
  this.scm_RedBlackTree$Tree__f_root = null;
  this.scm_RedBlackTree$Tree__f_size = 0;
  this.scm_RedBlackTree$Tree__f_root = root;
  this.scm_RedBlackTree$Tree__f_size = size
}
$c_scm_RedBlackTree$Tree.prototype = new $h_O();
$c_scm_RedBlackTree$Tree.prototype.constructor = $c_scm_RedBlackTree$Tree;
/** @constructor */
function $h_scm_RedBlackTree$Tree() {
  /*<skip>*/
}
$h_scm_RedBlackTree$Tree.prototype = $c_scm_RedBlackTree$Tree.prototype;
$c_scm_RedBlackTree$Tree.prototype.treeCopy__scm_RedBlackTree$Tree = (function() {
  return new $c_scm_RedBlackTree$Tree($m_scm_RedBlackTree$().copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node(this.scm_RedBlackTree$Tree__f_root), this.scm_RedBlackTree$Tree__f_size)
});
var $d_scm_RedBlackTree$Tree = new $TypeData().initClass({
  scm_RedBlackTree$Tree: 0
}, false, "scala.collection.mutable.RedBlackTree$Tree", {
  scm_RedBlackTree$Tree: 1,
  O: 1
});
$c_scm_RedBlackTree$Tree.prototype.$classData = $d_scm_RedBlackTree$Tree;
function $is_scm_Shrinkable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Shrinkable)))
}
function $as_scm_Shrinkable(obj) {
  return (($is_scm_Shrinkable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Shrinkable"))
}
function $isArrayOf_scm_Shrinkable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Shrinkable)))
}
function $asArrayOf_scm_Shrinkable(obj, depth) {
  return (($isArrayOf_scm_Shrinkable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Shrinkable;", depth))
}
/** @constructor */
function $c_sc_package$$colon$plus$() {
  /*<skip>*/
}
$c_sc_package$$colon$plus$.prototype = new $h_O();
$c_sc_package$$colon$plus$.prototype.constructor = $c_sc_package$$colon$plus$;
/** @constructor */
function $h_sc_package$$colon$plus$() {
  /*<skip>*/
}
$h_sc_package$$colon$plus$.prototype = $c_sc_package$$colon$plus$.prototype;
$c_sc_package$$colon$plus$.prototype.unapply__sc_SeqOps__s_Option = (function(t) {
  if ($n(t).isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var self = $n(t).init__O();
    var y = $n(t).last__O();
    return new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, y))
  }
});
var $d_sc_package$$colon$plus$ = new $TypeData().initClass({
  sc_package$$colon$plus$: 0
}, false, "scala.collection.package$$colon$plus$", {
  sc_package$$colon$plus$: 1,
  O: 1
});
$c_sc_package$$colon$plus$.prototype.$classData = $d_sc_package$$colon$plus$;
var $n_sc_package$$colon$plus$;
function $m_sc_package$$colon$plus$() {
  if ((!$n_sc_package$$colon$plus$)) {
    $n_sc_package$$colon$plus$ = new $c_sc_package$$colon$plus$()
  };
  return $n_sc_package$$colon$plus$
}
/** @constructor */
function $c_sc_package$$plus$colon$() {
  /*<skip>*/
}
$c_sc_package$$plus$colon$.prototype = new $h_O();
$c_sc_package$$plus$colon$.prototype.constructor = $c_sc_package$$plus$colon$;
/** @constructor */
function $h_sc_package$$plus$colon$() {
  /*<skip>*/
}
$h_sc_package$$plus$colon$.prototype = $c_sc_package$$plus$colon$.prototype;
$c_sc_package$$plus$colon$.prototype.unapply__sc_SeqOps__s_Option = (function(t) {
  if ($n(t).isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var self = $n(t).head__O();
    var y = $n(t).tail__O();
    return new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, y))
  }
});
var $d_sc_package$$plus$colon$ = new $TypeData().initClass({
  sc_package$$plus$colon$: 0
}, false, "scala.collection.package$$plus$colon$", {
  sc_package$$plus$colon$: 1,
  O: 1
});
$c_sc_package$$plus$colon$.prototype.$classData = $d_sc_package$$plus$colon$;
var $n_sc_package$$plus$colon$;
function $m_sc_package$$plus$colon$() {
  if ((!$n_sc_package$$plus$colon$)) {
    $n_sc_package$$plus$colon$ = new $c_sc_package$$plus$colon$()
  };
  return $n_sc_package$$plus$colon$
}
function $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable($thiz, curSize) {
  var curOther = $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
  var curLen = $n(curOther).u.length;
  if ((curSize <= curLen)) {
    return curOther
  } else {
    var newLen = ((curLen === 0) ? 4 : (curLen << 1));
    if ((newLen <= curLen)) {
      throw new $c_jl_StackOverflowError(("Space limit of asynchronous stack reached: " + curLen))
    };
    var newOther = new ($d_jl_Runnable.getArrayOf().constr)(newLen);
    $systemArraycopyRefs($n(curOther), 0, newOther, 0, curLen);
    $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = newOther;
    return newOther
  }
}
function $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__($thiz, outer, first, other, size) {
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_first = first;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = other;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_size = size;
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = outer
  };
  return $thiz
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$AbstractBatch() {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null
}
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype = new $h_O();
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$AbstractBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$AbstractBatch() {
  /*<skip>*/
}
$h_s_concurrent_BatchingExecutor$AbstractBatch.prototype = $c_s_concurrent_BatchingExecutor$AbstractBatch.prototype;
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.push__jl_Runnable__V = (function(r) {
  var sz = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
  if ((sz === 0)) {
    this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = r
  } else {
    $n($p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable(this, sz)).set((((-1) + sz) | 0), r)
  };
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = ((1 + sz) | 0)
});
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.runN__I__V = (function(n) {
  while (true) {
    if ((n > 0)) {
      var x1 = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
      switch (x1) {
        case 0: {
          break
        }
        case 1: {
          var next = this.s_concurrent_BatchingExecutor$AbstractBatch__f_first;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
          $n(next).run__V();
          n = (((-1) + n) | 0);
          continue;
          break
        }
        default: {
          var o = this.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
          var next$2 = $n(o).get((((-2) + x1) | 0));
          $n(o).set((((-2) + x1) | 0), null);
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = (((-1) + x1) | 0);
          $n(next$2).run__V();
          n = (((-1) + n) | 0);
          continue
        }
      }
    };
    return (void 0)
  }
});
/** @constructor */
function $c_s_concurrent_BatchingExecutorStatics$() {
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = null;
  $n_s_concurrent_BatchingExecutorStatics$ = this;
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = new ($d_jl_Runnable.getArrayOf().constr)(0)
}
$c_s_concurrent_BatchingExecutorStatics$.prototype = new $h_O();
$c_s_concurrent_BatchingExecutorStatics$.prototype.constructor = $c_s_concurrent_BatchingExecutorStatics$;
/** @constructor */
function $h_s_concurrent_BatchingExecutorStatics$() {
  /*<skip>*/
}
$h_s_concurrent_BatchingExecutorStatics$.prototype = $c_s_concurrent_BatchingExecutorStatics$.prototype;
var $d_s_concurrent_BatchingExecutorStatics$ = new $TypeData().initClass({
  s_concurrent_BatchingExecutorStatics$: 0
}, false, "scala.concurrent.BatchingExecutorStatics$", {
  s_concurrent_BatchingExecutorStatics$: 1,
  O: 1
});
$c_s_concurrent_BatchingExecutorStatics$.prototype.$classData = $d_s_concurrent_BatchingExecutorStatics$;
var $n_s_concurrent_BatchingExecutorStatics$;
function $m_s_concurrent_BatchingExecutorStatics$() {
  if ((!$n_s_concurrent_BatchingExecutorStatics$)) {
    $n_s_concurrent_BatchingExecutorStatics$ = new $c_s_concurrent_BatchingExecutorStatics$()
  };
  return $n_s_concurrent_BatchingExecutorStatics$
}
function $p_s_concurrent_ExecutionContext$__global$lzycompute__s_concurrent_ExecutionContextExecutor($thiz) {
  if ((!$thiz.s_concurrent_ExecutionContext$__f_bitmap$0)) {
    $thiz.s_concurrent_ExecutionContext$__f_global = $m_sjs_concurrent_JSExecutionContext$().sjs_concurrent_JSExecutionContext$__f_queue;
    $thiz.s_concurrent_ExecutionContext$__f_bitmap$0 = true
  };
  return $thiz.s_concurrent_ExecutionContext$__f_global
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$() {
  this.s_concurrent_ExecutionContext$__f_global = null;
  this.s_concurrent_ExecutionContext$__f_defaultReporter = null;
  this.s_concurrent_ExecutionContext$__f_bitmap$0 = false;
  $n_s_concurrent_ExecutionContext$ = this;
  this.s_concurrent_ExecutionContext$__f_defaultReporter = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_jl_Throwable(x$1$2);
    var this$2 = $n(x$1);
    this$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
  }))
}
$c_s_concurrent_ExecutionContext$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$.prototype.constructor = $c_s_concurrent_ExecutionContext$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$() {
  /*<skip>*/
}
$h_s_concurrent_ExecutionContext$.prototype = $c_s_concurrent_ExecutionContext$.prototype;
$c_s_concurrent_ExecutionContext$.prototype.global__s_concurrent_ExecutionContextExecutor = (function() {
  return ((!this.s_concurrent_ExecutionContext$__f_bitmap$0) ? $p_s_concurrent_ExecutionContext$__global$lzycompute__s_concurrent_ExecutionContextExecutor(this) : this.s_concurrent_ExecutionContext$__f_global)
});
var $d_s_concurrent_ExecutionContext$ = new $TypeData().initClass({
  s_concurrent_ExecutionContext$: 0
}, false, "scala.concurrent.ExecutionContext$", {
  s_concurrent_ExecutionContext$: 1,
  O: 1
});
$c_s_concurrent_ExecutionContext$.prototype.$classData = $d_s_concurrent_ExecutionContext$;
var $n_s_concurrent_ExecutionContext$;
function $m_s_concurrent_ExecutionContext$() {
  if ((!$n_s_concurrent_ExecutionContext$)) {
    $n_s_concurrent_ExecutionContext$ = new $c_s_concurrent_ExecutionContext$()
  };
  return $n_s_concurrent_ExecutionContext$
}
/** @constructor */
function $c_s_concurrent_Future$() {
  this.s_concurrent_Future$__f_collectFailed = null;
  this.s_concurrent_Future$__f_filterFailure = null;
  this.s_concurrent_Future$__f_failedFailure = null;
  this.s_concurrent_Future$__f_recoverWithFailedMarker = null;
  this.s_concurrent_Future$__f_recoverWithFailed = null;
  this.s_concurrent_Future$__f__zipWithTuple2 = null;
  this.s_concurrent_Future$__f__addToBuilderFun = null;
  this.s_concurrent_Future$__f_unit = null;
  $n_s_concurrent_Future$ = this;
  var this$22 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array = [$ct_T2__O__O__(new $c_T2(), $d_Z.getClassOf(), $d_jl_Boolean.getClassOf()), $ct_T2__O__O__(new $c_T2(), $d_B.getClassOf(), $d_jl_Byte.getClassOf()), $ct_T2__O__O__(new $c_T2(), $d_C.getClassOf(), $d_jl_Character.getClassOf()), $ct_T2__O__O__(new $c_T2(), $d_S.getClassOf(), $d_jl_Short.getClassOf()), $ct_T2__O__O__(new $c_T2(), $d_I.getClassOf(), $d_jl_Integer.getClassOf()), $ct_T2__O__O__(new $c_T2(), $d_J.getClassOf(), $d_jl_Long.getClassOf()), $ct_T2__O__O__(new $c_T2(), $d_F.getClassOf(), $d_jl_Float.getClassOf()), $ct_T2__O__O__(new $c_T2(), $d_D.getClassOf(), $d_jl_Double.getClassOf()), $ct_T2__O__O__(new $c_T2(), $d_V.getClassOf(), $d_jl_Void.getClassOf())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this$22.from__sc_IterableOnce__sci_Map(elems);
  new $c_sjsr_AnonFunction1(((x$2) => x$2));
  this.s_concurrent_Future$__f_collectFailed = new $c_sjsr_AnonFunction1(((t$2) => {
    throw new $c_s_concurrent_Future$$anon$1(t$2)
  }));
  this.s_concurrent_Future$__f_filterFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$2());
  this.s_concurrent_Future$__f_failedFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$3());
  $m_s_concurrent_Future$().fromTry__s_util_Try__s_concurrent_Future(this.s_concurrent_Future$__f_failedFailure);
  new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_s_util_Try(v$2);
    return ((v instanceof $c_s_util_Failure) ? new $c_s_util_Success($n($as_s_util_Failure(v)).s_util_Failure__f_exception) : $m_s_concurrent_Future$().s_concurrent_Future$__f_failedFailure)
  }));
  this.s_concurrent_Future$__f_recoverWithFailedMarker = $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future(new $c_s_concurrent_Future$$anon$4());
  this.s_concurrent_Future$__f_recoverWithFailed = new $c_sjsr_AnonFunction1(((t$3$2) => {
    $as_jl_Throwable(t$3$2);
    return $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker
  }));
  this.s_concurrent_Future$__f__zipWithTuple2 = new $c_sjsr_AnonFunction2(((_1$2, _2$2) => $ct_T2__O__O__(new $c_T2(), _1$2, _2$2)));
  this.s_concurrent_Future$__f__addToBuilderFun = new $c_sjsr_AnonFunction2(((b$2, e$2) => {
    var b = $as_scm_Builder(b$2);
    var this$25 = $n(b);
    return $as_scm_Builder(this$25.addOne__O__scm_Growable(e$2))
  }));
  this.s_concurrent_Future$__f_unit = this.fromTry__s_util_Try__s_concurrent_Future(new $c_s_util_Success((void 0)))
}
$c_s_concurrent_Future$.prototype = new $h_O();
$c_s_concurrent_Future$.prototype.constructor = $c_s_concurrent_Future$;
/** @constructor */
function $h_s_concurrent_Future$() {
  /*<skip>*/
}
$h_s_concurrent_Future$.prototype = $c_s_concurrent_Future$.prototype;
$c_s_concurrent_Future$.prototype.failed__jl_Throwable__s_concurrent_Future = (function(exception) {
  return $n($m_s_concurrent_Promise$().failed__jl_Throwable__s_concurrent_Promise(exception))
});
$c_s_concurrent_Future$.prototype.successful__O__s_concurrent_Future = (function(result) {
  return $n($m_s_concurrent_Promise$().successful__O__s_concurrent_Promise(result))
});
$c_s_concurrent_Future$.prototype.fromTry__s_util_Try__s_concurrent_Future = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result)
});
$c_s_concurrent_Future$.prototype.apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future = (function(body, executor) {
  return $n(this.s_concurrent_Future$__f_unit).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$4$2) => {
    $as_jl_Void(x$4$2);
    return $n(body).apply__O()
  })), executor)
});
$c_s_concurrent_Future$.prototype.traverse__sc_IterableOnce__F1__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future = (function(in$1, fn, bf, executor) {
  var this$2 = $n($n(in$1).iterator__sc_Iterator());
  var z = this.successful__O__s_concurrent_Future($n(bf).newBuilder__O__scm_Builder(in$1));
  var f = ((fr$2, a$2) => {
    var fr = $as_s_concurrent_Future(fr$2);
    return $n(fr).zipWith__s_concurrent_Future__F2__s_concurrent_ExecutionContext__s_concurrent_Future($as_s_concurrent_Future($n(fn).apply__O__O(a$2)), $m_s_concurrent_Future$().s_concurrent_Future$__f__addToBuilderFun, executor)
  });
  if ($is_sc_IndexedSeq(this$2)) {
    var x2 = $as_sc_IndexedSeq(this$2);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = z;
    var $$x1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f(arg1, arg2);
        at = temp$at;
        acc = temp$acc;
        continue
      };
      var $$x1 = acc;
      break
    }
  } else {
    var result = z;
    while (this$2.hasNext__Z()) {
      var arg1$1 = result;
      var arg2$1 = this$2.next__O();
      result = f(arg1$1, arg2$1)
    };
    var $$x1 = result
  };
  return $n($as_s_concurrent_Future($$x1)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_scm_Builder(x$9$2);
    return $as_sc_IterableOnce($n(x$9).result__O())
  })), ($is_s_concurrent_BatchingExecutor(executor) ? executor : $m_s_concurrent_ExecutionContext$parasitic$()))
});
var $d_s_concurrent_Future$ = new $TypeData().initClass({
  s_concurrent_Future$: 0
}, false, "scala.concurrent.Future$", {
  s_concurrent_Future$: 1,
  O: 1
});
$c_s_concurrent_Future$.prototype.$classData = $d_s_concurrent_Future$;
var $n_s_concurrent_Future$;
function $m_s_concurrent_Future$() {
  if ((!$n_s_concurrent_Future$)) {
    $n_s_concurrent_Future$ = new $c_s_concurrent_Future$()
  };
  return $n_s_concurrent_Future$
}
function $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result) {
  if ($thiz.tryComplete__s_util_Try__Z(result)) {
    return $thiz
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Promise already completed.")
  }
}
function $f_s_concurrent_Promise__success__O__s_concurrent_Promise($thiz, value) {
  var result = new $c_s_util_Success(value);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result)
}
function $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise($thiz, cause) {
  var result = new $c_s_util_Failure(cause);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result)
}
/** @constructor */
function $c_s_concurrent_Promise$() {
  /*<skip>*/
}
$c_s_concurrent_Promise$.prototype = new $h_O();
$c_s_concurrent_Promise$.prototype.constructor = $c_s_concurrent_Promise$;
/** @constructor */
function $h_s_concurrent_Promise$() {
  /*<skip>*/
}
$h_s_concurrent_Promise$.prototype = $c_s_concurrent_Promise$.prototype;
$c_s_concurrent_Promise$.prototype.failed__jl_Throwable__s_concurrent_Promise = (function(exception) {
  var result = new $c_s_util_Failure(exception);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result)
});
$c_s_concurrent_Promise$.prototype.successful__O__s_concurrent_Promise = (function(result) {
  var result$1 = new $c_s_util_Success(result);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result$1)
});
var $d_s_concurrent_Promise$ = new $TypeData().initClass({
  s_concurrent_Promise$: 0
}, false, "scala.concurrent.Promise$", {
  s_concurrent_Promise$: 1,
  O: 1
});
$c_s_concurrent_Promise$.prototype.$classData = $d_s_concurrent_Promise$;
var $n_s_concurrent_Promise$;
function $m_s_concurrent_Promise$() {
  if ((!$n_s_concurrent_Promise$)) {
    $n_s_concurrent_Promise$ = new $c_s_concurrent_Promise$()
  };
  return $n_s_concurrent_Promise$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationDouble$() {
  /*<skip>*/
}
$c_s_concurrent_duration_package$DurationDouble$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationDouble$.prototype.constructor = $c_s_concurrent_duration_package$DurationDouble$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationDouble$() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationDouble$.prototype = $c_s_concurrent_duration_package$DurationDouble$.prototype;
$c_s_concurrent_duration_package$DurationDouble$.prototype.durationIn$extension__D__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration = (function(this$, unit) {
  var x1 = $m_s_concurrent_duration_Duration$().apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration(this$, unit);
  if ((x1 instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(x1);
    return x2
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Duration DSL not applicable to " + this$))
  }
});
$c_s_concurrent_duration_package$DurationDouble$.prototype.equals$extension__D__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationDouble)) {
    var DurationDouble$1 = $n($as_s_concurrent_duration_package$DurationDouble(x$1)).s_concurrent_duration_package$DurationDouble__f_scala$concurrent$duration$DurationDouble$$d;
    return (this$ === DurationDouble$1)
  } else {
    return false
  }
});
var $d_s_concurrent_duration_package$DurationDouble$ = new $TypeData().initClass({
  s_concurrent_duration_package$DurationDouble$: 0
}, false, "scala.concurrent.duration.package$DurationDouble$", {
  s_concurrent_duration_package$DurationDouble$: 1,
  O: 1
});
$c_s_concurrent_duration_package$DurationDouble$.prototype.$classData = $d_s_concurrent_duration_package$DurationDouble$;
var $n_s_concurrent_duration_package$DurationDouble$;
function $m_s_concurrent_duration_package$DurationDouble$() {
  if ((!$n_s_concurrent_duration_package$DurationDouble$)) {
    $n_s_concurrent_duration_package$DurationDouble$ = new $c_s_concurrent_duration_package$DurationDouble$()
  };
  return $n_s_concurrent_duration_package$DurationDouble$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt$() {
  /*<skip>*/
}
$c_s_concurrent_duration_package$DurationInt$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt$.prototype.constructor = $c_s_concurrent_duration_package$DurationInt$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt$() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationInt$.prototype = $c_s_concurrent_duration_package$DurationInt$.prototype;
$c_s_concurrent_duration_package$DurationInt$.prototype.equals$extension__I__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationInt)) {
    var DurationInt$1 = $n($as_s_concurrent_duration_package$DurationInt(x$1)).s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    return (this$ === DurationInt$1)
  } else {
    return false
  }
});
var $d_s_concurrent_duration_package$DurationInt$ = new $TypeData().initClass({
  s_concurrent_duration_package$DurationInt$: 0
}, false, "scala.concurrent.duration.package$DurationInt$", {
  s_concurrent_duration_package$DurationInt$: 1,
  O: 1
});
$c_s_concurrent_duration_package$DurationInt$.prototype.$classData = $d_s_concurrent_duration_package$DurationInt$;
var $n_s_concurrent_duration_package$DurationInt$;
function $m_s_concurrent_duration_package$DurationInt$() {
  if ((!$n_s_concurrent_duration_package$DurationInt$)) {
    $n_s_concurrent_duration_package$DurationInt$ = new $c_s_concurrent_duration_package$DurationInt$()
  };
  return $n_s_concurrent_duration_package$DurationInt$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong$() {
  /*<skip>*/
}
$c_s_concurrent_duration_package$DurationLong$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong$.prototype.constructor = $c_s_concurrent_duration_package$DurationLong$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong$() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationLong$.prototype = $c_s_concurrent_duration_package$DurationLong$.prototype;
$c_s_concurrent_duration_package$DurationLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationLong)) {
    var t = $n($as_s_concurrent_duration_package$DurationLong(x$1)).s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi))
  } else {
    return false
  }
});
var $d_s_concurrent_duration_package$DurationLong$ = new $TypeData().initClass({
  s_concurrent_duration_package$DurationLong$: 0
}, false, "scala.concurrent.duration.package$DurationLong$", {
  s_concurrent_duration_package$DurationLong$: 1,
  O: 1
});
$c_s_concurrent_duration_package$DurationLong$.prototype.$classData = $d_s_concurrent_duration_package$DurationLong$;
var $n_s_concurrent_duration_package$DurationLong$;
function $m_s_concurrent_duration_package$DurationLong$() {
  if ((!$n_s_concurrent_duration_package$DurationLong$)) {
    $n_s_concurrent_duration_package$DurationLong$ = new $c_s_concurrent_duration_package$DurationLong$()
  };
  return $n_s_concurrent_duration_package$DurationLong$
}
/** @constructor */
function $c_s_concurrent_impl_Promise$() {
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = null;
  $n_s_concurrent_impl_Promise$ = this;
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 0, null, $m_s_concurrent_ExecutionContext$parasitic$())
}
$c_s_concurrent_impl_Promise$.prototype = new $h_O();
$c_s_concurrent_impl_Promise$.prototype.constructor = $c_s_concurrent_impl_Promise$;
/** @constructor */
function $h_s_concurrent_impl_Promise$() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$.prototype = $c_s_concurrent_impl_Promise$.prototype;
$c_s_concurrent_impl_Promise$.prototype.scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try = (function(value) {
  if ((value === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ((value instanceof $c_s_util_Success)) {
    return value
  } else {
    var t = $n($as_s_util_Failure(value)).s_util_Failure__f_exception;
    return ((((t instanceof $c_s_util_control_ControlThrowable) || false) || (t instanceof $c_jl_Error)) ? ((t instanceof $c_sr_NonLocalReturnControl) ? new $c_s_util_Success($n($as_sr_NonLocalReturnControl(t)).value__O()) : new $c_s_util_Failure(new $c_ju_concurrent_ExecutionException("Boxed Exception", t))) : value)
  }
});
var $d_s_concurrent_impl_Promise$ = new $TypeData().initClass({
  s_concurrent_impl_Promise$: 0
}, false, "scala.concurrent.impl.Promise$", {
  s_concurrent_impl_Promise$: 1,
  O: 1
});
$c_s_concurrent_impl_Promise$.prototype.$classData = $d_s_concurrent_impl_Promise$;
var $n_s_concurrent_impl_Promise$;
function $m_s_concurrent_impl_Promise$() {
  if ((!$n_s_concurrent_impl_Promise$)) {
    $n_s_concurrent_impl_Promise$ = new $c_s_concurrent_impl_Promise$()
  };
  return $n_s_concurrent_impl_Promise$
}
function $is_s_concurrent_impl_Promise$Callbacks(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_impl_Promise$Callbacks)))
}
function $as_s_concurrent_impl_Promise$Callbacks(obj) {
  return (($is_s_concurrent_impl_Promise$Callbacks(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Callbacks"))
}
function $isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Callbacks)))
}
function $asArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Callbacks;", depth))
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var t = $thiz.longValue__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return ((((hi === (-1)) ? (((-2147483648) ^ lo) >= 0) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-1)) : (hi < 0))) ? lo : $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi)))
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return ($thiz.isValidChar__Z() && ($thiz.intValue__I() === x2))
  } else if ($isByte(x)) {
    var x3 = $uB(x);
    return ($thiz.isValidByte__Z() && ($thiz.byteValue__B() === x3))
  } else if ($isShort(x)) {
    var x4 = $uS(x);
    return ($thiz.isValidShort__Z() && ($thiz.shortValue__S() === x4))
  } else if ($isInt(x)) {
    var x5 = $uI(x);
    return ($thiz.isValidInt__Z() && ($thiz.intValue__I() === x5))
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$1 = $thiz.longValue__J();
    return ((this$1.RTLong__f_lo === lo) && (this$1.RTLong__f_hi === hi))
  } else if ($isFloat(x)) {
    var x7 = $uF(x);
    return ($thiz.floatValue__F() === x7)
  } else if (((typeof x) === "number")) {
    var x8 = $uD(x);
    return ($thiz.doubleValue__D() === x8)
  } else {
    return false
  }
}
function $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$($thiz) {
  if (((((1 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigDecimal = $m_s_math_BigDecimal$();
    $thiz.s_package$__f_bitmap$0 = (((1 | $thiz.s_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.s_package$__f_BigDecimal
}
function $p_s_package$__BigInt$lzycompute__s_math_BigInt$($thiz) {
  if (((((2 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigInt = $m_s_math_BigInt$();
    $thiz.s_package$__f_bitmap$0 = (((2 | $thiz.s_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.s_package$__f_BigInt
}
/** @constructor */
function $c_s_package$() {
  this.s_package$__f_BigDecimal = null;
  this.s_package$__f_BigInt = null;
  this.s_package$__f_Iterable = null;
  this.s_package$__f_Seq = null;
  this.s_package$__f_Iterator = null;
  this.s_package$__f_List = null;
  this.s_package$__f_Nil = null;
  this.s_package$__f_$plus$colon = null;
  this.s_package$__f_$colon$plus = null;
  this.s_package$__f_Stream = null;
  this.s_package$__f_LazyList = null;
  this.s_package$__f_Vector = null;
  this.s_package$__f_StringBuilder = null;
  this.s_package$__f_Range = null;
  this.s_package$__f_Equiv = null;
  this.s_package$__f_Ordering = null;
  this.s_package$__f_Left = null;
  this.s_package$__f_Right = null;
  this.s_package$__f_bitmap$0 = 0;
  $n_s_package$ = this;
  new $c_s_package$$anon$1();
  $m_sc_Iterable$();
  this.s_package$__f_Iterable = $m_sc_Iterable$();
  this.s_package$__f_Seq = $m_sci_Seq$();
  $m_sci_IndexedSeq$();
  this.s_package$__f_Iterator = $m_sc_Iterator$();
  this.s_package$__f_List = $m_sci_List$();
  this.s_package$__f_Nil = $m_sci_Nil$();
  this.s_package$__f_$plus$colon = $m_sc_package$$plus$colon$();
  this.s_package$__f_$colon$plus = $m_sc_package$$colon$plus$();
  this.s_package$__f_Stream = $m_sci_Stream$();
  this.s_package$__f_LazyList = $m_sci_LazyList$();
  this.s_package$__f_Vector = $m_sci_Vector$();
  this.s_package$__f_StringBuilder = $m_scm_StringBuilder$();
  this.s_package$__f_Range = $m_sci_Range$();
  this.s_package$__f_Equiv = $m_s_math_Equiv$();
  this.s_package$__f_Ordering = $m_s_math_Ordering$();
  this.s_package$__f_Left = $m_s_util_Left$();
  this.s_package$__f_Right = $m_s_util_Right$()
}
$c_s_package$.prototype = new $h_O();
$c_s_package$.prototype.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
  /*<skip>*/
}
$h_s_package$.prototype = $c_s_package$.prototype;
$c_s_package$.prototype.BigDecimal__s_math_BigDecimal$ = (function() {
  return (((((1 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$(this) : this.s_package$__f_BigDecimal)
});
$c_s_package$.prototype.BigInt__s_math_BigInt$ = (function() {
  return (((((2 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigInt$lzycompute__s_math_BigInt$(this) : this.s_package$__f_BigInt)
});
var $d_s_package$ = new $TypeData().initClass({
  s_package$: 0
}, false, "scala.package$", {
  s_package$: 1,
  O: 1
});
$c_s_package$.prototype.$classData = $d_s_package$;
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$()
  };
  return $n_s_package$
}
/** @constructor */
function $c_sr_BoxesRunTime$() {
  /*<skip>*/
}
$c_sr_BoxesRunTime$.prototype = new $h_O();
$c_sr_BoxesRunTime$.prototype.constructor = $c_sr_BoxesRunTime$;
/** @constructor */
function $h_sr_BoxesRunTime$() {
  /*<skip>*/
}
$h_sr_BoxesRunTime$.prototype = $c_sr_BoxesRunTime$.prototype;
$c_sr_BoxesRunTime$.prototype.equals__O__O__Z = (function(x, y) {
  if ((x === y)) {
    return true
  } else if ($is_jl_Number(x)) {
    var x2 = $as_jl_Number(x);
    return this.equalsNumObject__jl_Number__O__Z(x2, y)
  } else if ((x instanceof $Char)) {
    var x3 = $as_jl_Character(x);
    return this.equalsCharObject__jl_Character__O__Z(x3, y)
  } else {
    return ((x === null) ? (y === null) : $dp_equals__O__Z($n(x), y))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumObject__jl_Number__O__Z = (function(xn, y) {
  if ($is_jl_Number(y)) {
    var x2 = $as_jl_Number(y);
    return this.equalsNumNum__jl_Number__jl_Number__Z(xn, x2)
  } else if ((y instanceof $Char)) {
    var x3 = $as_jl_Character(y);
    if (((typeof xn) === "number")) {
      var x2$1 = $uD(xn);
      var this$1 = $uC($n(x3));
      return (x2$1 === this$1)
    } else if ((xn instanceof $c_RTLong)) {
      var t = $uJ(xn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$2 = $uC($n(x3));
      var value = this$2;
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1))
    } else {
      return ((xn === null) ? (x3 === null) : $dp_equals__O__Z($n(xn), x3))
    }
  } else {
    return ((xn === null) ? (y === null) : $dp_equals__O__Z($n(xn), y))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumNum__jl_Number__jl_Number__Z = (function(xn, yn) {
  if (((typeof xn) === "number")) {
    var x2 = $uD(xn);
    if (((typeof yn) === "number")) {
      var x2$2 = $uD(yn);
      return (x2 === x2$2)
    } else if ((yn instanceof $c_RTLong)) {
      var t = $uJ(yn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return (x2 === $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi))
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4 = $as_s_math_ScalaNumber(yn);
      return $n(x4).equals__O__Z(x2)
    } else {
      return false
    }
  } else if ((xn instanceof $c_RTLong)) {
    var t$1 = $uJ(xn);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((yn instanceof $c_RTLong)) {
      var t$2 = $uJ(yn);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      return ((lo$1 === lo$2) && (hi$1 === hi$2))
    } else if (((typeof yn) === "number")) {
      var x3$3 = $uD(yn);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo$1, hi$1) === x3$3)
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4$2 = $as_s_math_ScalaNumber(yn);
      return $n(x4$2).equals__O__Z(new $c_RTLong(lo$1, hi$1))
    } else {
      return false
    }
  } else {
    return ((xn === null) ? (yn === null) : $dp_equals__O__Z($n(xn), yn))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsCharObject__jl_Character__O__Z = (function(xc, y) {
  if ((y instanceof $Char)) {
    var x2 = $as_jl_Character(y);
    var this$1 = $uC($n(xc));
    var this$2 = $uC($n(x2));
    return (this$1 === this$2)
  } else if ($is_jl_Number(y)) {
    var x3 = $as_jl_Number(y);
    if (((typeof x3) === "number")) {
      var x2$1 = $uD(x3);
      var this$3 = $uC($n(xc));
      return (x2$1 === this$3)
    } else if ((x3 instanceof $c_RTLong)) {
      var t = $uJ(x3);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$4 = $uC($n(xc));
      var value = this$4;
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1))
    } else {
      return ((x3 === null) ? (xc === null) : $dp_equals__O__Z($n(x3), xc))
    }
  } else {
    return ((xc === null) && (y === null))
  }
});
var $d_sr_BoxesRunTime$ = new $TypeData().initClass({
  sr_BoxesRunTime$: 0
}, false, "scala.runtime.BoxesRunTime$", {
  sr_BoxesRunTime$: 1,
  O: 1
});
$c_sr_BoxesRunTime$.prototype.$classData = $d_sr_BoxesRunTime$;
var $n_sr_BoxesRunTime$;
function $m_sr_BoxesRunTime$() {
  if ((!$n_sr_BoxesRunTime$)) {
    $n_sr_BoxesRunTime$ = new $c_sr_BoxesRunTime$()
  };
  return $n_sr_BoxesRunTime$
}
var $d_sr_Null$ = new $TypeData().initClass({
  sr_Null$: 0
}, false, "scala.runtime.Null$", {
  sr_Null$: 1,
  O: 1
});
/** @constructor */
function $c_sr_RichDouble$() {
  /*<skip>*/
}
$c_sr_RichDouble$.prototype = new $h_O();
$c_sr_RichDouble$.prototype.constructor = $c_sr_RichDouble$;
/** @constructor */
function $h_sr_RichDouble$() {
  /*<skip>*/
}
$h_sr_RichDouble$.prototype = $c_sr_RichDouble$.prototype;
$c_sr_RichDouble$.prototype.isValidByte$extension__D__Z = (function(this$) {
  return ((($doubleToInt(this$) << 24) >> 24) === this$)
});
$c_sr_RichDouble$.prototype.isValidShort$extension__D__Z = (function(this$) {
  return ((($doubleToInt(this$) << 16) >> 16) === this$)
});
$c_sr_RichDouble$.prototype.isValidChar$extension__D__Z = (function(this$) {
  return ((65535 & $doubleToInt(this$)) === this$)
});
$c_sr_RichDouble$.prototype.isValidInt$extension__D__Z = (function(this$) {
  return ($doubleToInt(this$) === this$)
});
$c_sr_RichDouble$.prototype.equals$extension__D__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichDouble)) {
    var RichDouble$1 = $n($as_sr_RichDouble(x$1)).sr_RichDouble__f_self;
    return (this$ === RichDouble$1)
  } else {
    return false
  }
});
var $d_sr_RichDouble$ = new $TypeData().initClass({
  sr_RichDouble$: 0
}, false, "scala.runtime.RichDouble$", {
  sr_RichDouble$: 1,
  O: 1
});
$c_sr_RichDouble$.prototype.$classData = $d_sr_RichDouble$;
var $n_sr_RichDouble$;
function $m_sr_RichDouble$() {
  if ((!$n_sr_RichDouble$)) {
    $n_sr_RichDouble$ = new $c_sr_RichDouble$()
  };
  return $n_sr_RichDouble$
}
/** @constructor */
function $c_sr_RichLong$() {
  /*<skip>*/
}
$c_sr_RichLong$.prototype = new $h_O();
$c_sr_RichLong$.prototype.constructor = $c_sr_RichLong$;
/** @constructor */
function $h_sr_RichLong$() {
  /*<skip>*/
}
$h_sr_RichLong$.prototype = $c_sr_RichLong$.prototype;
$c_sr_RichLong$.prototype.isValidByte$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 24) >> 24);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidShort$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 16) >> 16);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidChar$extension__J__Z = (function(this$) {
  var value = (65535 & this$.RTLong__f_lo);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidInt$extension__J__Z = (function(this$) {
  var value = this$.RTLong__f_lo;
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichLong)) {
    var t = $n($as_sr_RichLong(x$1)).sr_RichLong__f_self;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi))
  } else {
    return false
  }
});
var $d_sr_RichLong$ = new $TypeData().initClass({
  sr_RichLong$: 0
}, false, "scala.runtime.RichLong$", {
  sr_RichLong$: 1,
  O: 1
});
$c_sr_RichLong$.prototype.$classData = $d_sr_RichLong$;
var $n_sr_RichLong$;
function $m_sr_RichLong$() {
  if ((!$n_sr_RichLong$)) {
    $n_sr_RichLong$ = new $c_sr_RichLong$()
  };
  return $n_sr_RichLong$
}
/** @constructor */
function $c_sr_ScalaRunTime$() {
  /*<skip>*/
}
$c_sr_ScalaRunTime$.prototype = new $h_O();
$c_sr_ScalaRunTime$.prototype.constructor = $c_sr_ScalaRunTime$;
/** @constructor */
function $h_sr_ScalaRunTime$() {
  /*<skip>*/
}
$h_sr_ScalaRunTime$.prototype = $c_sr_ScalaRunTime$.prototype;
$c_sr_ScalaRunTime$.prototype.array_apply__O__I__O = (function(xs, idx) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    return $n(x2).get(idx)
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    return $n(x3).get(idx)
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    return $n(x4).get(idx)
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    return $n(x5).get(idx)
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    return $n(x6).get(idx)
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    return $bC($n(x7).get(idx))
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    return $n(x8).get(idx)
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    return $n(x9).get(idx)
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    return $n(x10).get(idx)
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype.array_update__O__I__O__V = (function(xs, idx, value) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    $n(x2).set(idx, value)
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    $n(x3).set(idx, $uI(value))
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    $n(x4).set(idx, $uD(value))
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    $n(x5).set(idx, $uJ(value))
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    $n(x6).set(idx, $uF(value))
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    $n(x7).set(idx, $uC(value))
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    $n(x8).set(idx, $uB(value))
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    $n(x9).set(idx, $uS(value))
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    $n(x10).set(idx, $uZ(value))
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype.array_clone__O__O = (function(xs) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    var this$1 = $n(x2);
    return $n(this$1).clone__O()
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    var this$2 = $n(x3);
    return $n(this$2).clone__O()
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    var this$3 = $n(x4);
    return $n(this$3).clone__O()
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    var this$4 = $n(x5);
    return $n(this$4).clone__O()
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    var this$5 = $n(x6);
    return $n(this$5).clone__O()
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    var this$6 = $n(x7);
    return $n(this$6).clone__O()
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    var this$7 = $n(x8);
    return $n(this$7).clone__O()
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    var this$8 = $n(x9);
    return $n(this$8).clone__O()
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    var this$9 = $n(x10);
    return $n(this$9).clone__O()
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype._toString__s_Product__T = (function(x) {
  var this$1 = $n($n(x).productIterator__sc_Iterator());
  var start = ($n(x).productPrefix__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, start, ",", ")")
});
var $d_sr_ScalaRunTime$ = new $TypeData().initClass({
  sr_ScalaRunTime$: 0
}, false, "scala.runtime.ScalaRunTime$", {
  sr_ScalaRunTime$: 1,
  O: 1
});
$c_sr_ScalaRunTime$.prototype.$classData = $d_sr_ScalaRunTime$;
var $n_sr_ScalaRunTime$;
function $m_sr_ScalaRunTime$() {
  if ((!$n_sr_ScalaRunTime$)) {
    $n_sr_ScalaRunTime$ = new $c_sr_ScalaRunTime$()
  };
  return $n_sr_ScalaRunTime$
}
/** @constructor */
function $c_sr_Statics$() {
  /*<skip>*/
}
$c_sr_Statics$.prototype = new $h_O();
$c_sr_Statics$.prototype.constructor = $c_sr_Statics$;
/** @constructor */
function $h_sr_Statics$() {
  /*<skip>*/
}
$h_sr_Statics$.prototype = $c_sr_Statics$.prototype;
$c_sr_Statics$.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0)
});
$c_sr_Statics$.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k)
});
$c_sr_Statics$.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.avalanche__I__I((hash ^ length))
});
$c_sr_Statics$.prototype.avalanche__I__I = (function(h0) {
  var h = h0;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
$c_sr_Statics$.prototype.longHash__J__I = (function(lv) {
  var lo = lv.RTLong__f_lo;
  var hi = lv.RTLong__f_hi;
  return ((hi === (lo >> 31)) ? lo : (lo ^ hi))
});
$c_sr_Statics$.prototype.doubleHash__D__I = (function(dv) {
  var iv = $doubleToInt(dv);
  if ((iv === dv)) {
    return iv
  } else {
    var this$1 = $m_RTLong$();
    var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(dv);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return (($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi) === dv) ? (lo ^ hi) : $m_jl_FloatingPointBits$().numberHashCode__D__I(dv))
  }
});
$c_sr_Statics$.prototype.anyHash__O__I = (function(x) {
  if ((x === null)) {
    return 0
  } else if (((typeof x) === "number")) {
    var x3 = $uD(x);
    return this.doubleHash__D__I(x3)
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return this.longHash__J__I(new $c_RTLong(lo, hi))
  } else {
    return $dp_hashCode__I($n(x))
  }
});
$c_sr_Statics$.prototype.ioobe__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_sr_Statics$ = new $TypeData().initClass({
  sr_Statics$: 0
}, false, "scala.runtime.Statics$", {
  sr_Statics$: 1,
  O: 1
});
$c_sr_Statics$.prototype.$classData = $d_sr_Statics$;
var $n_sr_Statics$;
function $m_sr_Statics$() {
  if ((!$n_sr_Statics$)) {
    $n_sr_Statics$ = new $c_sr_Statics$()
  };
  return $n_sr_Statics$
}
/** @constructor */
function $c_sr_Statics$PFMarker$() {
  /*<skip>*/
}
$c_sr_Statics$PFMarker$.prototype = new $h_O();
$c_sr_Statics$PFMarker$.prototype.constructor = $c_sr_Statics$PFMarker$;
/** @constructor */
function $h_sr_Statics$PFMarker$() {
  /*<skip>*/
}
$h_sr_Statics$PFMarker$.prototype = $c_sr_Statics$PFMarker$.prototype;
var $d_sr_Statics$PFMarker$ = new $TypeData().initClass({
  sr_Statics$PFMarker$: 0
}, false, "scala.runtime.Statics$PFMarker$", {
  sr_Statics$PFMarker$: 1,
  O: 1
});
$c_sr_Statics$PFMarker$.prototype.$classData = $d_sr_Statics$PFMarker$;
var $n_sr_Statics$PFMarker$;
function $m_sr_Statics$PFMarker$() {
  if ((!$n_sr_Statics$PFMarker$)) {
    $n_sr_Statics$PFMarker$ = new $c_sr_Statics$PFMarker$()
  };
  return $n_sr_Statics$PFMarker$
}
/** @constructor */
function $c_sjs_concurrent_JSExecutionContext$() {
  this.sjs_concurrent_JSExecutionContext$__f_queue = null;
  $n_sjs_concurrent_JSExecutionContext$ = this;
  this.sjs_concurrent_JSExecutionContext$__f_queue = $m_sjs_concurrent_QueueExecutionContext$().apply__s_concurrent_ExecutionContextExecutor()
}
$c_sjs_concurrent_JSExecutionContext$.prototype = new $h_O();
$c_sjs_concurrent_JSExecutionContext$.prototype.constructor = $c_sjs_concurrent_JSExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_JSExecutionContext$() {
  /*<skip>*/
}
$h_sjs_concurrent_JSExecutionContext$.prototype = $c_sjs_concurrent_JSExecutionContext$.prototype;
var $d_sjs_concurrent_JSExecutionContext$ = new $TypeData().initClass({
  sjs_concurrent_JSExecutionContext$: 0
}, false, "scala.scalajs.concurrent.JSExecutionContext$", {
  sjs_concurrent_JSExecutionContext$: 1,
  O: 1
});
$c_sjs_concurrent_JSExecutionContext$.prototype.$classData = $d_sjs_concurrent_JSExecutionContext$;
var $n_sjs_concurrent_JSExecutionContext$;
function $m_sjs_concurrent_JSExecutionContext$() {
  if ((!$n_sjs_concurrent_JSExecutionContext$)) {
    $n_sjs_concurrent_JSExecutionContext$ = new $c_sjs_concurrent_JSExecutionContext$()
  };
  return $n_sjs_concurrent_JSExecutionContext$
}
/** @constructor */
function $c_sjs_concurrent_JSExecutionContext$Implicits$() {
  this.sjs_concurrent_JSExecutionContext$Implicits$__f_queue = null;
  $n_sjs_concurrent_JSExecutionContext$Implicits$ = this;
  this.sjs_concurrent_JSExecutionContext$Implicits$__f_queue = $m_sjs_concurrent_JSExecutionContext$().sjs_concurrent_JSExecutionContext$__f_queue
}
$c_sjs_concurrent_JSExecutionContext$Implicits$.prototype = new $h_O();
$c_sjs_concurrent_JSExecutionContext$Implicits$.prototype.constructor = $c_sjs_concurrent_JSExecutionContext$Implicits$;
/** @constructor */
function $h_sjs_concurrent_JSExecutionContext$Implicits$() {
  /*<skip>*/
}
$h_sjs_concurrent_JSExecutionContext$Implicits$.prototype = $c_sjs_concurrent_JSExecutionContext$Implicits$.prototype;
var $d_sjs_concurrent_JSExecutionContext$Implicits$ = new $TypeData().initClass({
  sjs_concurrent_JSExecutionContext$Implicits$: 0
}, false, "scala.scalajs.concurrent.JSExecutionContext$Implicits$", {
  sjs_concurrent_JSExecutionContext$Implicits$: 1,
  O: 1
});
$c_sjs_concurrent_JSExecutionContext$Implicits$.prototype.$classData = $d_sjs_concurrent_JSExecutionContext$Implicits$;
var $n_sjs_concurrent_JSExecutionContext$Implicits$;
function $m_sjs_concurrent_JSExecutionContext$Implicits$() {
  if ((!$n_sjs_concurrent_JSExecutionContext$Implicits$)) {
    $n_sjs_concurrent_JSExecutionContext$Implicits$ = new $c_sjs_concurrent_JSExecutionContext$Implicits$()
  };
  return $n_sjs_concurrent_JSExecutionContext$Implicits$
}
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$() {
  /*<skip>*/
}
$c_sjs_concurrent_QueueExecutionContext$.prototype = new $h_O();
$c_sjs_concurrent_QueueExecutionContext$.prototype.constructor = $c_sjs_concurrent_QueueExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$() {
  /*<skip>*/
}
$h_sjs_concurrent_QueueExecutionContext$.prototype = $c_sjs_concurrent_QueueExecutionContext$.prototype;
$c_sjs_concurrent_QueueExecutionContext$.prototype.apply__s_concurrent_ExecutionContextExecutor = (function() {
  return (($as_T((typeof Promise)) === "undefined") ? new $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() : new $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext())
});
var $d_sjs_concurrent_QueueExecutionContext$ = new $TypeData().initClass({
  sjs_concurrent_QueueExecutionContext$: 0
}, false, "scala.scalajs.concurrent.QueueExecutionContext$", {
  sjs_concurrent_QueueExecutionContext$: 1,
  O: 1
});
$c_sjs_concurrent_QueueExecutionContext$.prototype.$classData = $d_sjs_concurrent_QueueExecutionContext$;
var $n_sjs_concurrent_QueueExecutionContext$;
function $m_sjs_concurrent_QueueExecutionContext$() {
  if ((!$n_sjs_concurrent_QueueExecutionContext$)) {
    $n_sjs_concurrent_QueueExecutionContext$ = new $c_sjs_concurrent_QueueExecutionContext$()
  };
  return $n_sjs_concurrent_QueueExecutionContext$
}
/** @constructor */
function $c_sjs_js_$bar$() {
  /*<skip>*/
}
$c_sjs_js_$bar$.prototype = new $h_O();
$c_sjs_js_$bar$.prototype.constructor = $c_sjs_js_$bar$;
/** @constructor */
function $h_sjs_js_$bar$() {
  /*<skip>*/
}
$h_sjs_js_$bar$.prototype = $c_sjs_js_$bar$.prototype;
$c_sjs_js_$bar$.prototype.undefOr2jsAny__sjs_js_$bar__F1__sjs_js_Any = (function(value, ev) {
  if ((value === (void 0))) {
    return (void 0)
  } else {
    var a = $n(ev).apply__O__O(value);
    return a
  }
});
var $d_sjs_js_$bar$ = new $TypeData().initClass({
  sjs_js_$bar$: 0
}, false, "scala.scalajs.js.$bar$", {
  sjs_js_$bar$: 1,
  O: 1
});
$c_sjs_js_$bar$.prototype.$classData = $d_sjs_js_$bar$;
var $n_sjs_js_$bar$;
function $m_sjs_js_$bar$() {
  if ((!$n_sjs_js_$bar$)) {
    $n_sjs_js_$bar$ = new $c_sjs_js_$bar$()
  };
  return $n_sjs_js_$bar$
}
/** @constructor */
function $c_sjs_js_Any$ObjectCompanionOps$() {
  /*<skip>*/
}
$c_sjs_js_Any$ObjectCompanionOps$.prototype = new $h_O();
$c_sjs_js_Any$ObjectCompanionOps$.prototype.constructor = $c_sjs_js_Any$ObjectCompanionOps$;
/** @constructor */
function $h_sjs_js_Any$ObjectCompanionOps$() {
  /*<skip>*/
}
$h_sjs_js_Any$ObjectCompanionOps$.prototype = $c_sjs_js_Any$ObjectCompanionOps$.prototype;
$c_sjs_js_Any$ObjectCompanionOps$.prototype.hasProperty$extension__sjs_js_Object$__sjs_js_Object__T__Z = (function(this$, o, p) {
  return $uZ((p in o))
});
$c_sjs_js_Any$ObjectCompanionOps$.prototype.properties$extension__sjs_js_Object$__sjs_js_Any__sjs_js_Array = (function(this$, o) {
  var result = [];
  for (var key in o) {
    result.push(key)
  };
  return result
});
var $d_sjs_js_Any$ObjectCompanionOps$ = new $TypeData().initClass({
  sjs_js_Any$ObjectCompanionOps$: 0
}, false, "scala.scalajs.js.Any$ObjectCompanionOps$", {
  sjs_js_Any$ObjectCompanionOps$: 1,
  O: 1
});
$c_sjs_js_Any$ObjectCompanionOps$.prototype.$classData = $d_sjs_js_Any$ObjectCompanionOps$;
var $n_sjs_js_Any$ObjectCompanionOps$;
function $m_sjs_js_Any$ObjectCompanionOps$() {
  if ((!$n_sjs_js_Any$ObjectCompanionOps$)) {
    $n_sjs_js_Any$ObjectCompanionOps$ = new $c_sjs_js_Any$ObjectCompanionOps$()
  };
  return $n_sjs_js_Any$ObjectCompanionOps$
}
function $p_sjs_js_ArrayOps$__d$2__O__sr_BooleanRef__O($thiz, x, matched$2) {
  $n(matched$2).sr_BooleanRef__f_elem = false;
  return null
}
/** @constructor */
function $c_sjs_js_ArrayOps$() {
  /*<skip>*/
}
$c_sjs_js_ArrayOps$.prototype = new $h_O();
$c_sjs_js_ArrayOps$.prototype.constructor = $c_sjs_js_ArrayOps$;
/** @constructor */
function $h_sjs_js_ArrayOps$() {
  /*<skip>*/
}
$h_sjs_js_ArrayOps$.prototype = $c_sjs_js_ArrayOps$.prototype;
$c_sjs_js_ArrayOps$.prototype.head$extension__sjs_js_Array__O = (function(this$) {
  if (($uI(this$.length) === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty array")
  };
  return this$[0]
});
$c_sjs_js_ArrayOps$.prototype.headOption$extension__sjs_js_Array__s_Option = (function(this$) {
  return (($uI(this$.length) === 0) ? $m_s_None$() : new $c_s_Some(this$[0]))
});
$c_sjs_js_ArrayOps$.prototype.lastOption$extension__sjs_js_Array__s_Option = (function(this$) {
  return (($uI(this$.length) === 0) ? $m_s_None$() : new $c_s_Some(this$[(((-1) + $uI(this$.length)) | 0)]))
});
$c_sjs_js_ArrayOps$.prototype.filter$extension__sjs_js_Array__F1__sjs_js_Array = (function(this$, p) {
  var res = [];
  var len = $uI(this$.length);
  var i = 0;
  while ((i < len)) {
    var arg1 = this$[i];
    if ($uZ($n(p).apply__O__O(arg1))) {
      $uI(res.push(arg1))
    };
    i = ((1 + i) | 0)
  };
  return res
});
$c_sjs_js_ArrayOps$.prototype.indexOf$extension__sjs_js_Array__O__I__I = (function(this$, elem, from) {
  var len = $uI(this$.length);
  var i = from;
  while ((i < len)) {
    var arg1 = this$[i];
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, arg1)) {
      return i
    };
    i = ((1 + i) | 0)
  };
  return (-1)
});
$c_sjs_js_ArrayOps$.prototype.map$extension__sjs_js_Array__F1__sjs_js_Array = (function(this$, f) {
  var len = $uI(this$.length);
  var res = new Array(len);
  var i = 0;
  while ((i < len)) {
    res[i] = $n(f).apply__O__O(this$[i]);
    i = ((1 + i) | 0)
  };
  return res
});
$c_sjs_js_ArrayOps$.prototype.collectFirst$extension__sjs_js_Array__s_PartialFunction__s_Option = (function(this$, f) {
  var i = 0;
  var matched = new $c_sr_BooleanRef(true);
  var len = $uI(this$.length);
  while ((i < len)) {
    matched.sr_BooleanRef__f_elem = true;
    var v = $n(f).applyOrElse__O__F1__O(this$[i], new $c_sjsr_AnonFunction1(((matched) => ((x$2) => $p_sjs_js_ArrayOps$__d$2__O__sr_BooleanRef__O(this, x$2, matched)))(matched)));
    if (matched.sr_BooleanRef__f_elem) {
      return new $c_s_Some(v)
    };
    i = ((1 + i) | 0)
  };
  return $m_s_None$()
});
$c_sjs_js_ArrayOps$.prototype.contains$extension__sjs_js_Array__O__Z = (function(this$, elem) {
  return ($m_sjs_js_ArrayOps$().indexOf$extension__sjs_js_Array__O__I__I(this$, elem, 0) >= 0)
});
$c_sjs_js_ArrayOps$.prototype.foreach$extension__sjs_js_Array__F1__V = (function(this$, f) {
  var len = $uI(this$.length);
  var i = 0;
  while ((i < len)) {
    $n(f).apply__O__O(this$[i]);
    i = ((1 + i) | 0)
  }
});
$c_sjs_js_ArrayOps$.prototype.distinct$extension__sjs_js_Array__sjs_js_Array = (function(this$) {
  return $m_sjs_js_ArrayOps$().distinctBy$extension__sjs_js_Array__F1__sjs_js_Array(this$, new $c_sjsr_AnonFunction1(((x$2) => x$2)))
});
$c_sjs_js_ArrayOps$.prototype.distinctBy$extension__sjs_js_Array__F1__sjs_js_Array = (function(this$, f) {
  var result = [];
  var $$x1 = $m_sjs_js_ArrayOps$();
  var this$3 = new $c_sjs_js_ArrayOps$ArrayIterator(this$);
  $n($$x1).addAll$extension__sjs_js_Array__sc_IterableOnce__sjs_js_Array(result, new $c_sc_Iterator$$anon$8(this$3, f));
  return result
});
$c_sjs_js_ArrayOps$.prototype.diff$extension__sjs_js_Array__sci_Seq__sjs_js_Array = (function(this$, that) {
  var this$1 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), this$);
  var wrappedArray = $as_sjs_js_WrappedArray($f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this$1, that));
  return $n(wrappedArray).sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array
});
$c_sjs_js_ArrayOps$.prototype.addAll$extension__sjs_js_Array__sc_IterableOnce__sjs_js_Array = (function(this$, ys) {
  var this$1 = $n($n(ys).iterator__sc_Iterator());
  while (this$1.hasNext__Z()) {
    var arg1 = this$1.next__O();
    this$.push(arg1)
  };
  return this$
});
var $d_sjs_js_ArrayOps$ = new $TypeData().initClass({
  sjs_js_ArrayOps$: 0
}, false, "scala.scalajs.js.ArrayOps$", {
  sjs_js_ArrayOps$: 1,
  O: 1
});
$c_sjs_js_ArrayOps$.prototype.$classData = $d_sjs_js_ArrayOps$;
var $n_sjs_js_ArrayOps$;
function $m_sjs_js_ArrayOps$() {
  if ((!$n_sjs_js_ArrayOps$)) {
    $n_sjs_js_ArrayOps$ = new $c_sjs_js_ArrayOps$()
  };
  return $n_sjs_js_ArrayOps$
}
/** @constructor */
function $c_sjs_js_ArrayOps$WithFilter(p, xs) {
  this.sjs_js_ArrayOps$WithFilter__f_p = null;
  this.sjs_js_ArrayOps$WithFilter__f_xs = null;
  this.sjs_js_ArrayOps$WithFilter__f_p = p;
  this.sjs_js_ArrayOps$WithFilter__f_xs = xs
}
$c_sjs_js_ArrayOps$WithFilter.prototype = new $h_O();
$c_sjs_js_ArrayOps$WithFilter.prototype.constructor = $c_sjs_js_ArrayOps$WithFilter;
/** @constructor */
function $h_sjs_js_ArrayOps$WithFilter() {
  /*<skip>*/
}
$h_sjs_js_ArrayOps$WithFilter.prototype = $c_sjs_js_ArrayOps$WithFilter.prototype;
var $d_sjs_js_ArrayOps$WithFilter = new $TypeData().initClass({
  sjs_js_ArrayOps$WithFilter: 0
}, false, "scala.scalajs.js.ArrayOps$WithFilter", {
  sjs_js_ArrayOps$WithFilter: 1,
  O: 1
});
$c_sjs_js_ArrayOps$WithFilter.prototype.$classData = $d_sjs_js_ArrayOps$WithFilter;
/** @constructor */
function $c_sjs_js_JSConverters$JSRichIterableOnce$() {
  /*<skip>*/
}
$c_sjs_js_JSConverters$JSRichIterableOnce$.prototype = new $h_O();
$c_sjs_js_JSConverters$JSRichIterableOnce$.prototype.constructor = $c_sjs_js_JSConverters$JSRichIterableOnce$;
/** @constructor */
function $h_sjs_js_JSConverters$JSRichIterableOnce$() {
  /*<skip>*/
}
$h_sjs_js_JSConverters$JSRichIterableOnce$.prototype = $c_sjs_js_JSConverters$JSRichIterableOnce$.prototype;
$c_sjs_js_JSConverters$JSRichIterableOnce$.prototype.toJSArray$extension__sc_IterableOnce__sjs_js_Array = (function(this$) {
  if ((this$ instanceof $c_sjs_js_WrappedArray)) {
    var x2 = $as_sjs_js_WrappedArray(this$);
    return $n(x2).sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array
  } else {
    var result = [];
    var this$2 = $n($n(this$).iterator__sc_Iterator());
    while (this$2.hasNext__Z()) {
      var arg1 = this$2.next__O();
      $uI(result.push(arg1))
    };
    return result
  }
});
var $d_sjs_js_JSConverters$JSRichIterableOnce$ = new $TypeData().initClass({
  sjs_js_JSConverters$JSRichIterableOnce$: 0
}, false, "scala.scalajs.js.JSConverters$JSRichIterableOnce$", {
  sjs_js_JSConverters$JSRichIterableOnce$: 1,
  O: 1
});
$c_sjs_js_JSConverters$JSRichIterableOnce$.prototype.$classData = $d_sjs_js_JSConverters$JSRichIterableOnce$;
var $n_sjs_js_JSConverters$JSRichIterableOnce$;
function $m_sjs_js_JSConverters$JSRichIterableOnce$() {
  if ((!$n_sjs_js_JSConverters$JSRichIterableOnce$)) {
    $n_sjs_js_JSConverters$JSRichIterableOnce$ = new $c_sjs_js_JSConverters$JSRichIterableOnce$()
  };
  return $n_sjs_js_JSConverters$JSRichIterableOnce$
}
/** @constructor */
function $c_sjs_js_Thenable$ThenableOps$() {
  /*<skip>*/
}
$c_sjs_js_Thenable$ThenableOps$.prototype = new $h_O();
$c_sjs_js_Thenable$ThenableOps$.prototype.constructor = $c_sjs_js_Thenable$ThenableOps$;
/** @constructor */
function $h_sjs_js_Thenable$ThenableOps$() {
  /*<skip>*/
}
$h_sjs_js_Thenable$ThenableOps$.prototype = $c_sjs_js_Thenable$ThenableOps$.prototype;
$c_sjs_js_Thenable$ThenableOps$.prototype.toFuture$extension__sjs_js_Thenable__s_concurrent_Future = (function(this$) {
  var p2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  this$.then(((arg1$2) => $m_sjs_js_Thenable$ThenableOps$().scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$1__O__s_concurrent_Promise__sjs_js_$bar(arg1$2, p2)), $m_sjs_js_defined$().apply__O__sjs_js_$bar(((arg1$2$1) => $m_sjs_js_Thenable$ThenableOps$().scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$2__O__s_concurrent_Promise__sjs_js_$bar(arg1$2$1, p2))));
  return p2
});
$c_sjs_js_Thenable$ThenableOps$.prototype.scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$1__O__s_concurrent_Promise__sjs_js_$bar = (function(v, p2$1) {
  var this$1 = $n(p2$1);
  $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$1, v)
});
$c_sjs_js_Thenable$ThenableOps$.prototype.scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$2__O__s_concurrent_Promise__sjs_js_$bar = (function(e, p2$1) {
  var this$1 = $n(p2$1);
  var cause = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
  $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(this$1, cause)
});
var $d_sjs_js_Thenable$ThenableOps$ = new $TypeData().initClass({
  sjs_js_Thenable$ThenableOps$: 0
}, false, "scala.scalajs.js.Thenable$ThenableOps$", {
  sjs_js_Thenable$ThenableOps$: 1,
  O: 1
});
$c_sjs_js_Thenable$ThenableOps$.prototype.$classData = $d_sjs_js_Thenable$ThenableOps$;
var $n_sjs_js_Thenable$ThenableOps$;
function $m_sjs_js_Thenable$ThenableOps$() {
  if ((!$n_sjs_js_Thenable$ThenableOps$)) {
    $n_sjs_js_Thenable$ThenableOps$ = new $c_sjs_js_Thenable$ThenableOps$()
  };
  return $n_sjs_js_Thenable$ThenableOps$
}
/** @constructor */
function $c_sjs_js_ThisFunction$() {
  /*<skip>*/
}
$c_sjs_js_ThisFunction$.prototype = new $h_O();
$c_sjs_js_ThisFunction$.prototype.constructor = $c_sjs_js_ThisFunction$;
/** @constructor */
function $h_sjs_js_ThisFunction$() {
  /*<skip>*/
}
$h_sjs_js_ThisFunction$.prototype = $c_sjs_js_ThisFunction$.prototype;
$c_sjs_js_ThisFunction$.prototype.fromFunction1__F1__sjs_js_ThisFunction0 = (function(f) {
  return (function() {
    return $n(f).apply__O__O(this)
  })
});
$c_sjs_js_ThisFunction$.prototype.fromFunction2__F2__sjs_js_ThisFunction1 = (function(f) {
  return (function(arg1$2) {
    return $n(f).apply__O__O__O(this, arg1$2)
  })
});
$c_sjs_js_ThisFunction$.prototype.fromFunction3__F3__sjs_js_ThisFunction2 = (function(f) {
  return (function(arg1$2, arg2$2) {
    return $n(f).apply__O__O__O__O(this, arg1$2, arg2$2)
  })
});
$c_sjs_js_ThisFunction$.prototype.fromFunction4__F4__sjs_js_ThisFunction3 = (function(f) {
  return (function(arg1$2, arg2$2, arg3$2) {
    return $n(f).apply__O__O__O__O__O(this, arg1$2, arg2$2, arg3$2)
  })
});
var $d_sjs_js_ThisFunction$ = new $TypeData().initClass({
  sjs_js_ThisFunction$: 0
}, false, "scala.scalajs.js.ThisFunction$", {
  sjs_js_ThisFunction$: 1,
  O: 1
});
$c_sjs_js_ThisFunction$.prototype.$classData = $d_sjs_js_ThisFunction$;
var $n_sjs_js_ThisFunction$;
function $m_sjs_js_ThisFunction$() {
  if ((!$n_sjs_js_ThisFunction$)) {
    $n_sjs_js_ThisFunction$ = new $c_sjs_js_ThisFunction$()
  };
  return $n_sjs_js_ThisFunction$
}
/** @constructor */
function $c_sjs_js_UnicodeNormalizationForm$() {
  this.sjs_js_UnicodeNormalizationForm$__f_NFD = null;
  this.sjs_js_UnicodeNormalizationForm$__f_NFD = "NFD"
}
$c_sjs_js_UnicodeNormalizationForm$.prototype = new $h_O();
$c_sjs_js_UnicodeNormalizationForm$.prototype.constructor = $c_sjs_js_UnicodeNormalizationForm$;
/** @constructor */
function $h_sjs_js_UnicodeNormalizationForm$() {
  /*<skip>*/
}
$h_sjs_js_UnicodeNormalizationForm$.prototype = $c_sjs_js_UnicodeNormalizationForm$.prototype;
var $d_sjs_js_UnicodeNormalizationForm$ = new $TypeData().initClass({
  sjs_js_UnicodeNormalizationForm$: 0
}, false, "scala.scalajs.js.UnicodeNormalizationForm$", {
  sjs_js_UnicodeNormalizationForm$: 1,
  O: 1
});
$c_sjs_js_UnicodeNormalizationForm$.prototype.$classData = $d_sjs_js_UnicodeNormalizationForm$;
var $n_sjs_js_UnicodeNormalizationForm$;
function $m_sjs_js_UnicodeNormalizationForm$() {
  if ((!$n_sjs_js_UnicodeNormalizationForm$)) {
    $n_sjs_js_UnicodeNormalizationForm$ = new $c_sjs_js_UnicodeNormalizationForm$()
  };
  return $n_sjs_js_UnicodeNormalizationForm$
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty
}
$c_sjs_js_WrappedDictionary$Cache$.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$Cache$.prototype.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$Cache$.prototype = $c_sjs_js_WrappedDictionary$Cache$.prototype;
var $d_sjs_js_WrappedDictionary$Cache$ = new $TypeData().initClass({
  sjs_js_WrappedDictionary$Cache$: 0
}, false, "scala.scalajs.js.WrappedDictionary$Cache$", {
  sjs_js_WrappedDictionary$Cache$: 1,
  O: 1
});
$c_sjs_js_WrappedDictionary$Cache$.prototype.$classData = $d_sjs_js_WrappedDictionary$Cache$;
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$()
  };
  return $n_sjs_js_WrappedDictionary$Cache$
}
/** @constructor */
function $c_sjs_js_defined$() {
  /*<skip>*/
}
$c_sjs_js_defined$.prototype = new $h_O();
$c_sjs_js_defined$.prototype.constructor = $c_sjs_js_defined$;
/** @constructor */
function $h_sjs_js_defined$() {
  /*<skip>*/
}
$h_sjs_js_defined$.prototype = $c_sjs_js_defined$.prototype;
$c_sjs_js_defined$.prototype.apply__O__sjs_js_$bar = (function(a) {
  return a
});
var $d_sjs_js_defined$ = new $TypeData().initClass({
  sjs_js_defined$: 0
}, false, "scala.scalajs.js.defined$", {
  sjs_js_defined$: 1,
  O: 1
});
$c_sjs_js_defined$.prototype.$classData = $d_sjs_js_defined$;
var $n_sjs_js_defined$;
function $m_sjs_js_defined$() {
  if ((!$n_sjs_js_defined$)) {
    $n_sjs_js_defined$ = new $c_sjs_js_defined$()
  };
  return $n_sjs_js_defined$
}
/** @constructor */
function $c_sjs_js_special_package$() {
  /*<skip>*/
}
$c_sjs_js_special_package$.prototype = new $h_O();
$c_sjs_js_special_package$.prototype.constructor = $c_sjs_js_special_package$;
/** @constructor */
function $h_sjs_js_special_package$() {
  /*<skip>*/
}
$h_sjs_js_special_package$.prototype = $c_sjs_js_special_package$.prototype;
$c_sjs_js_special_package$.prototype.objectLiteral__sci_Seq__sjs_js_Object = (function(properties) {
  var result = {};
  $n(properties).foreach__F1__V(new $c_sjsr_AnonFunction1(((pair$2) => {
    var pair = $as_T2(pair$2);
    result[$n(pair)._1__O()] = $n(pair)._2__O()
  })));
  return result
});
var $d_sjs_js_special_package$ = new $TypeData().initClass({
  sjs_js_special_package$: 0
}, false, "scala.scalajs.js.special.package$", {
  sjs_js_special_package$: 1,
  O: 1
});
$c_sjs_js_special_package$.prototype.$classData = $d_sjs_js_special_package$;
var $n_sjs_js_special_package$;
function $m_sjs_js_special_package$() {
  if ((!$n_sjs_js_special_package$)) {
    $n_sjs_js_special_package$ = new $c_sjs_js_special_package$()
  };
  return $n_sjs_js_special_package$
}
/** @constructor */
function $c_sjs_js_timers_package$() {
  /*<skip>*/
}
$c_sjs_js_timers_package$.prototype = new $h_O();
$c_sjs_js_timers_package$.prototype.constructor = $c_sjs_js_timers_package$;
/** @constructor */
function $h_sjs_js_timers_package$() {
  /*<skip>*/
}
$h_sjs_js_timers_package$.prototype = $c_sjs_js_timers_package$.prototype;
$c_sjs_js_timers_package$.prototype.setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle = (function(interval, body) {
  return setTimeout((() => {
    var this$2 = $n(body);
    this$2.apply__O()
  }), interval)
});
$c_sjs_js_timers_package$.prototype.setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle = (function(interval, body) {
  var $$x1 = setTimeout;
  var this$3 = $n(interval);
  var this$4 = $n(this$3.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$3.s_concurrent_duration_FiniteDuration__f_length);
  return $$x1((() => {
    var this$2 = $n(body);
    this$2.apply__O()
  }), $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$4.RTLong__f_lo, this$4.RTLong__f_hi))
});
$c_sjs_js_timers_package$.prototype.clearTimeout__sjs_js_timers_SetTimeoutHandle__V = (function(handle) {
  clearTimeout(handle)
});
var $d_sjs_js_timers_package$ = new $TypeData().initClass({
  sjs_js_timers_package$: 0
}, false, "scala.scalajs.js.timers.package$", {
  sjs_js_timers_package$: 1,
  O: 1
});
$c_sjs_js_timers_package$.prototype.$classData = $d_sjs_js_timers_package$;
var $n_sjs_js_timers_package$;
function $m_sjs_js_timers_package$() {
  if ((!$n_sjs_js_timers_package$)) {
    $n_sjs_js_timers_package$ = new $c_sjs_js_timers_package$()
  };
  return $n_sjs_js_timers_package$
}
/** @constructor */
function $c_sjs_reflect_InstantiatableClass(runtimeClass, declaredConstructors) {
  this.sjs_reflect_InstantiatableClass__f_runtimeClass = null;
  this.sjs_reflect_InstantiatableClass__f_declaredConstructors = null;
  this.sjs_reflect_InstantiatableClass__f_runtimeClass = runtimeClass;
  this.sjs_reflect_InstantiatableClass__f_declaredConstructors = declaredConstructors
}
$c_sjs_reflect_InstantiatableClass.prototype = new $h_O();
$c_sjs_reflect_InstantiatableClass.prototype.constructor = $c_sjs_reflect_InstantiatableClass;
/** @constructor */
function $h_sjs_reflect_InstantiatableClass() {
  /*<skip>*/
}
$h_sjs_reflect_InstantiatableClass.prototype = $c_sjs_reflect_InstantiatableClass.prototype;
$c_sjs_reflect_InstantiatableClass.prototype.newInstance__O = (function() {
  var this$1 = $n(this.getConstructor__sci_Seq__s_Option($m_sci_Nil$()));
  if (this$1.isEmpty__Z()) {
    var $$x1 = new $c_jl_InstantiationException($n(this.sjs_reflect_InstantiatableClass__f_runtimeClass).getName__T()).initCause__jl_Throwable__jl_Throwable(new $c_jl_NoSuchMethodException(($n(this.sjs_reflect_InstantiatableClass__f_runtimeClass).getName__T() + ".<init>()")));
    throw (($$x1 instanceof $c_sjs_js_JavaScriptException) ? $$x1.sjs_js_JavaScriptException__f_exception : $n($$x1))
  } else {
    var arg1 = this$1.get__O();
    var ctor = $as_sjs_reflect_InvokableConstructor(arg1);
    return $n(ctor).newInstance__sci_Seq__O($m_sci_Nil$())
  }
});
$c_sjs_reflect_InstantiatableClass.prototype.getConstructor__sci_Seq__s_Option = (function(parameterTypes) {
  var this$1 = $n(this.sjs_reflect_InstantiatableClass__f_declaredConstructors);
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var x$1 = $as_sjs_reflect_InvokableConstructor(arg1);
    var this$2 = $n($n(x$1).sjs_reflect_InvokableConstructor__f_parameterTypes);
    if ($f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this$2, parameterTypes)) {
      return new $c_s_Some($n(these).head__O())
    };
    these = $as_sci_List($n(these).tail__O())
  };
  return $m_s_None$()
});
function $as_sjs_reflect_InstantiatableClass(obj) {
  return (((obj instanceof $c_sjs_reflect_InstantiatableClass) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.reflect.InstantiatableClass"))
}
function $isArrayOf_sjs_reflect_InstantiatableClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_reflect_InstantiatableClass)))
}
function $asArrayOf_sjs_reflect_InstantiatableClass(obj, depth) {
  return (($isArrayOf_sjs_reflect_InstantiatableClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.reflect.InstantiatableClass;", depth))
}
var $d_sjs_reflect_InstantiatableClass = new $TypeData().initClass({
  sjs_reflect_InstantiatableClass: 0
}, false, "scala.scalajs.reflect.InstantiatableClass", {
  sjs_reflect_InstantiatableClass: 1,
  O: 1
});
$c_sjs_reflect_InstantiatableClass.prototype.$classData = $d_sjs_reflect_InstantiatableClass;
/** @constructor */
function $c_sjs_reflect_InvokableConstructor(parameterTypes, newInstanceFun) {
  this.sjs_reflect_InvokableConstructor__f_parameterTypes = null;
  this.sjs_reflect_InvokableConstructor__f_newInstanceFun = null;
  this.sjs_reflect_InvokableConstructor__f_parameterTypes = parameterTypes;
  this.sjs_reflect_InvokableConstructor__f_newInstanceFun = newInstanceFun
}
$c_sjs_reflect_InvokableConstructor.prototype = new $h_O();
$c_sjs_reflect_InvokableConstructor.prototype.constructor = $c_sjs_reflect_InvokableConstructor;
/** @constructor */
function $h_sjs_reflect_InvokableConstructor() {
  /*<skip>*/
}
$h_sjs_reflect_InvokableConstructor.prototype = $c_sjs_reflect_InvokableConstructor.prototype;
$c_sjs_reflect_InvokableConstructor.prototype.newInstance__sci_Seq__O = (function(args) {
  var $$x2 = $m_s_Predef$();
  var this$1 = $n(args);
  var $$x1 = this$1.length__I();
  var this$2 = $n(this.sjs_reflect_InvokableConstructor__f_parameterTypes);
  $n($$x2).require__Z__V(($$x1 === this$2.length__I()));
  return (0, this.sjs_reflect_InvokableConstructor__f_newInstanceFun)(...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(args))
});
function $as_sjs_reflect_InvokableConstructor(obj) {
  return (((obj instanceof $c_sjs_reflect_InvokableConstructor) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.reflect.InvokableConstructor"))
}
function $isArrayOf_sjs_reflect_InvokableConstructor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_reflect_InvokableConstructor)))
}
function $asArrayOf_sjs_reflect_InvokableConstructor(obj, depth) {
  return (($isArrayOf_sjs_reflect_InvokableConstructor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.reflect.InvokableConstructor;", depth))
}
var $d_sjs_reflect_InvokableConstructor = new $TypeData().initClass({
  sjs_reflect_InvokableConstructor: 0
}, false, "scala.scalajs.reflect.InvokableConstructor", {
  sjs_reflect_InvokableConstructor: 1,
  O: 1
});
$c_sjs_reflect_InvokableConstructor.prototype.$classData = $d_sjs_reflect_InvokableConstructor;
/** @constructor */
function $c_sjs_reflect_LoadableModuleClass(runtimeClass, loadModuleFun) {
  this.sjs_reflect_LoadableModuleClass__f_loadModuleFun = null;
  this.sjs_reflect_LoadableModuleClass__f_loadModuleFun = loadModuleFun
}
$c_sjs_reflect_LoadableModuleClass.prototype = new $h_O();
$c_sjs_reflect_LoadableModuleClass.prototype.constructor = $c_sjs_reflect_LoadableModuleClass;
/** @constructor */
function $h_sjs_reflect_LoadableModuleClass() {
  /*<skip>*/
}
$h_sjs_reflect_LoadableModuleClass.prototype = $c_sjs_reflect_LoadableModuleClass.prototype;
$c_sjs_reflect_LoadableModuleClass.prototype.loadModule__O = (function() {
  return (0, this.sjs_reflect_LoadableModuleClass__f_loadModuleFun)()
});
function $as_sjs_reflect_LoadableModuleClass(obj) {
  return (((obj instanceof $c_sjs_reflect_LoadableModuleClass) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.reflect.LoadableModuleClass"))
}
function $isArrayOf_sjs_reflect_LoadableModuleClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_reflect_LoadableModuleClass)))
}
function $asArrayOf_sjs_reflect_LoadableModuleClass(obj, depth) {
  return (($isArrayOf_sjs_reflect_LoadableModuleClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.reflect.LoadableModuleClass;", depth))
}
var $d_sjs_reflect_LoadableModuleClass = new $TypeData().initClass({
  sjs_reflect_LoadableModuleClass: 0
}, false, "scala.scalajs.reflect.LoadableModuleClass", {
  sjs_reflect_LoadableModuleClass: 1,
  O: 1
});
$c_sjs_reflect_LoadableModuleClass.prototype.$classData = $d_sjs_reflect_LoadableModuleClass;
/** @constructor */
function $c_sjs_reflect_Reflect$() {
  this.sjs_reflect_Reflect$__f_loadableModuleClasses = null;
  this.sjs_reflect_Reflect$__f_instantiatableClasses = null;
  $n_sjs_reflect_Reflect$ = this;
  this.sjs_reflect_Reflect$__f_loadableModuleClasses = {};
  this.sjs_reflect_Reflect$__f_instantiatableClasses = {}
}
$c_sjs_reflect_Reflect$.prototype = new $h_O();
$c_sjs_reflect_Reflect$.prototype.constructor = $c_sjs_reflect_Reflect$;
/** @constructor */
function $h_sjs_reflect_Reflect$() {
  /*<skip>*/
}
$h_sjs_reflect_Reflect$.prototype = $c_sjs_reflect_Reflect$.prototype;
$c_sjs_reflect_Reflect$.prototype.registerLoadableModuleClass__T__jl_Class__sjs_js_Function0__V = (function(fqcn, runtimeClass, loadModuleFun) {
  var dict = this.sjs_reflect_Reflect$__f_loadableModuleClasses;
  var value = new $c_sjs_reflect_LoadableModuleClass(runtimeClass, loadModuleFun);
  dict[fqcn] = value
});
$c_sjs_reflect_Reflect$.prototype.registerInstantiatableClass__T__jl_Class__sjs_js_Array__V = (function(fqcn, runtimeClass, constructors) {
  var len = $uI(constructors.length);
  var res = new Array(len);
  var i = 0;
  while ((i < len)) {
    var $$x1 = i;
    var arg1 = constructors[i];
    var array = arg1[0];
    var this$4 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
    $m_sci_List$();
    res[$$x1] = new $c_sjs_reflect_InvokableConstructor($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4), arg1[1]);
    i = ((1 + i) | 0)
  };
  var dict = this.sjs_reflect_Reflect$__f_instantiatableClasses;
  var this$8 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res);
  $m_sci_List$();
  var value = new $c_sjs_reflect_InstantiatableClass(runtimeClass, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$8));
  dict[fqcn] = value
});
$c_sjs_reflect_Reflect$.prototype.lookupLoadableModuleClass__T__s_Option = (function(fqcn) {
  var dict = this.sjs_reflect_Reflect$__f_loadableModuleClasses;
  return ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, fqcn)) ? new $c_s_Some(dict[fqcn]) : $m_s_None$())
});
$c_sjs_reflect_Reflect$.prototype.lookupInstantiatableClass__T__s_Option = (function(fqcn) {
  var dict = this.sjs_reflect_Reflect$__f_instantiatableClasses;
  return ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, fqcn)) ? new $c_s_Some(dict[fqcn]) : $m_s_None$())
});
var $d_sjs_reflect_Reflect$ = new $TypeData().initClass({
  sjs_reflect_Reflect$: 0
}, false, "scala.scalajs.reflect.Reflect$", {
  sjs_reflect_Reflect$: 1,
  O: 1
});
$c_sjs_reflect_Reflect$.prototype.$classData = $d_sjs_reflect_Reflect$;
var $n_sjs_reflect_Reflect$;
function $m_sjs_reflect_Reflect$() {
  if ((!$n_sjs_reflect_Reflect$)) {
    $n_sjs_reflect_Reflect$ = new $c_sjs_reflect_Reflect$()
  };
  return $n_sjs_reflect_Reflect$
}
/** @constructor */
function $c_sjsr_Compat$() {
  /*<skip>*/
}
$c_sjsr_Compat$.prototype = new $h_O();
$c_sjsr_Compat$.prototype.constructor = $c_sjsr_Compat$;
/** @constructor */
function $h_sjsr_Compat$() {
  /*<skip>*/
}
$h_sjsr_Compat$.prototype = $c_sjsr_Compat$.prototype;
$c_sjsr_Compat$.prototype.toJSVarArgsImpl__sci_Seq__sjs_js_Array = (function(seq) {
  if ((seq instanceof $c_sjsr_WrappedVarArgs)) {
    var x2 = $as_sjsr_WrappedVarArgs(seq);
    return $n(x2).sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array
  } else {
    var result = [];
    $n(seq).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$2) => $uI(result.push(x$2)))));
    return result
  }
});
var $d_sjsr_Compat$ = new $TypeData().initClass({
  sjsr_Compat$: 0
}, false, "scala.scalajs.runtime.Compat$", {
  sjsr_Compat$: 1,
  O: 1
});
$c_sjsr_Compat$.prototype.$classData = $d_sjsr_Compat$;
var $n_sjsr_Compat$;
function $m_sjsr_Compat$() {
  if ((!$n_sjsr_Compat$)) {
    $n_sjsr_Compat$ = new $c_sjsr_Compat$()
  };
  return $n_sjsr_Compat$
}
/** @constructor */
function $c_s_sys_package$() {
  /*<skip>*/
}
$c_s_sys_package$.prototype = new $h_O();
$c_s_sys_package$.prototype.constructor = $c_s_sys_package$;
/** @constructor */
function $h_s_sys_package$() {
  /*<skip>*/
}
$h_s_sys_package$.prototype = $c_s_sys_package$.prototype;
$c_s_sys_package$.prototype.error__T__E = (function(message) {
  throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), message)
});
var $d_s_sys_package$ = new $TypeData().initClass({
  s_sys_package$: 0
}, false, "scala.sys.package$", {
  s_sys_package$: 1,
  O: 1
});
$c_s_sys_package$.prototype.$classData = $d_s_sys_package$;
var $n_s_sys_package$;
function $m_s_sys_package$() {
  if ((!$n_s_sys_package$)) {
    $n_s_sys_package$ = new $c_s_sys_package$()
  };
  return $n_s_sys_package$
}
/** @constructor */
function $c_s_util_DynamicVariable(init) {
  this.s_util_DynamicVariable__f_v = null;
  this.s_util_DynamicVariable__f_v = init
}
$c_s_util_DynamicVariable.prototype = new $h_O();
$c_s_util_DynamicVariable.prototype.constructor = $c_s_util_DynamicVariable;
/** @constructor */
function $h_s_util_DynamicVariable() {
  /*<skip>*/
}
$h_s_util_DynamicVariable.prototype = $c_s_util_DynamicVariable.prototype;
$c_s_util_DynamicVariable.prototype.toString__T = (function() {
  return (("DynamicVariable(" + this.s_util_DynamicVariable__f_v) + ")")
});
var $d_s_util_DynamicVariable = new $TypeData().initClass({
  s_util_DynamicVariable: 0
}, false, "scala.util.DynamicVariable", {
  s_util_DynamicVariable: 1,
  O: 1
});
$c_s_util_DynamicVariable.prototype.$classData = $d_s_util_DynamicVariable;
/** @constructor */
function $c_s_util_Either$MergeableEither$() {
  /*<skip>*/
}
$c_s_util_Either$MergeableEither$.prototype = new $h_O();
$c_s_util_Either$MergeableEither$.prototype.constructor = $c_s_util_Either$MergeableEither$;
/** @constructor */
function $h_s_util_Either$MergeableEither$() {
  /*<skip>*/
}
$h_s_util_Either$MergeableEither$.prototype = $c_s_util_Either$MergeableEither$.prototype;
$c_s_util_Either$MergeableEither$.prototype.merge$extension__s_util_Either__O = (function(this$) {
  if ((this$ instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$);
    var a = $n(x2).s_util_Right__f_value;
    return a
  } else if ((this$ instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(this$);
    var a$2 = $n(x3).s_util_Left__f_value;
    return a$2
  } else {
    throw new $c_s_MatchError(this$)
  }
});
var $d_s_util_Either$MergeableEither$ = new $TypeData().initClass({
  s_util_Either$MergeableEither$: 0
}, false, "scala.util.Either$MergeableEither$", {
  s_util_Either$MergeableEither$: 1,
  O: 1
});
$c_s_util_Either$MergeableEither$.prototype.$classData = $d_s_util_Either$MergeableEither$;
var $n_s_util_Either$MergeableEither$;
function $m_s_util_Either$MergeableEither$() {
  if ((!$n_s_util_Either$MergeableEither$)) {
    $n_s_util_Either$MergeableEither$ = new $c_s_util_Either$MergeableEither$()
  };
  return $n_s_util_Either$MergeableEither$
}
/** @constructor */
function $c_s_util_Sorting$() {
  /*<skip>*/
}
$c_s_util_Sorting$.prototype = new $h_O();
$c_s_util_Sorting$.prototype.constructor = $c_s_util_Sorting$;
/** @constructor */
function $h_s_util_Sorting$() {
  /*<skip>*/
}
$h_s_util_Sorting$.prototype = $c_s_util_Sorting$.prototype;
$c_s_util_Sorting$.prototype.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V = (function(a, i0, iN, ord) {
  var n = ((iN - i0) | 0);
  if ((n < 2)) {
    return (void 0)
  };
  if (($n(ord).compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0))) > 0)) {
    var temp = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0);
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i0, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0)));
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ((1 + i0) | 0), temp)
  };
  var m = 2;
  while ((m < n)) {
    var next = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((i0 + m) | 0));
    if (($n(ord).compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + ((i0 + m) | 0)) | 0))) < 0)) {
      var iA = i0;
      var iB = (((-1) + ((i0 + m) | 0)) | 0);
      while ((((iB - iA) | 0) > 1)) {
        var ix = ((((iA + iB) | 0) >>> 1) | 0);
        if (($n(ord).compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ix)) < 0)) {
          iB = ix
        } else {
          iA = ix
        }
      };
      var ix$2 = ((iA + (($n(ord).compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
      var i = ((i0 + m) | 0);
      while ((i > ix$2)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + i) | 0)));
        i = (((-1) + i) | 0)
      };
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ix$2, next)
    };
    m = ((1 + m) | 0)
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V = (function(a, i0, iN, ord, scratch, evidence$2) {
  if ((((iN - i0) | 0) < 32)) {
    this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, i0, iN, ord)
  } else {
    var iK = ((((i0 + iN) | 0) >>> 1) | 0);
    var sc = ((scratch === null) ? $n(evidence$2).newArray__I__O(((iK - i0) | 0)) : scratch);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, i0, iK, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK, iN, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, i0, iK, iN, ord, sc)
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V = (function(a, i0, iK, iN, ord, scratch) {
  if (($n(ord).compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + iK) | 0)), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iK)) > 0)) {
    var i = i0;
    var jN = ((iK - i0) | 0);
    var j = 0;
    while ((i < iK)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(scratch, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
      i = ((1 + i) | 0);
      j = ((1 + j) | 0)
    };
    var k = i0;
    j = 0;
    while (((i < iN) && (j < jN))) {
      if (($n(ord).compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i), $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j)) < 0)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
        i = ((1 + i) | 0)
      } else {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
        j = ((1 + j) | 0)
      };
      k = ((1 + k) | 0)
    };
    while ((j < jN)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
      j = ((1 + j) | 0);
      k = ((1 + k) | 0)
    }
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$booleanSort__AZ__I__I__V = (function(a, from, until) {
  var i = from;
  var n = 0;
  while ((i < until)) {
    if ((!$n(a).get(i))) {
      n = ((1 + n) | 0)
    };
    i = ((1 + i) | 0)
  };
  i = 0;
  while ((i < n)) {
    $n(a).set(((from + i) | 0), false);
    i = ((1 + i) | 0)
  };
  while ((((from + i) | 0) < until)) {
    $n(a).set(((from + i) | 0), true);
    i = ((1 + i) | 0)
  }
});
$c_s_util_Sorting$.prototype.stableSort__O__I__I__s_math_Ordering__V = (function(a, from, until, evidence$4) {
  if ((a instanceof $ac_O)) {
    if ((($m_jl_reflect_Array$().getLength__O__I(a) > 1) && (evidence$4 === null))) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Ordering")
    };
    var array = $asArrayOf_O(a, 1);
    $m_ju_Arrays$().sort__AO__I__I__ju_Comparator__V(array, from, until, evidence$4)
  } else if ((a instanceof $ac_I)) {
    var x3 = $asArrayOf_I(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Int$())) {
      $m_ju_Arrays$().sort__AI__I__I__V(x3, from, until)
    } else {
      var evidence$2 = $m_s_reflect_ManifestFactory$IntManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, until, evidence$4)
      } else {
        var iK = ((((from + until) | 0) >>> 1) | 0);
        var len = ((iK - from) | 0);
        var sc = new $ac_I(len);
        if ((((iK - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, iK, evidence$4)
        } else {
          var iK$1 = ((((from + iK) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, from, iK$1, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$1, iK, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK$1, iK, evidence$4, sc)
        };
        if ((((until - iK) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, iK, until, evidence$4)
        } else {
          var iK$2 = ((((iK + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK, iK$2, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$2, until, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, iK, iK$2, until, evidence$4, sc)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK, until, evidence$4, sc)
      }
    }
  } else if ((a instanceof $ac_D)) {
    var x4 = $asArrayOf_D(a, 1);
    var evidence$2$1 = $m_s_reflect_ManifestFactory$DoubleManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, until, evidence$4)
    } else {
      var iK$3 = ((((from + until) | 0) >>> 1) | 0);
      var len$1 = ((iK$3 - from) | 0);
      var sc$1 = new $ac_D(len$1);
      if ((((iK$3 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, iK$3, evidence$4)
      } else {
        var iK$4 = ((((from + iK$3) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, from, iK$4, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$4, iK$3, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$4, iK$3, evidence$4, sc$1)
      };
      if ((((until - iK$3) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, iK$3, until, evidence$4)
      } else {
        var iK$5 = ((((iK$3 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$3, iK$5, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$5, until, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, iK$3, iK$5, until, evidence$4, sc$1)
      };
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$3, until, evidence$4, sc$1)
    }
  } else if ((a instanceof $ac_J)) {
    var x5 = $asArrayOf_J(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Long$())) {
      $m_ju_Arrays$().sort__AJ__I__I__V(x5, from, until)
    } else {
      var evidence$2$2 = $m_s_reflect_ManifestFactory$LongManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, until, evidence$4)
      } else {
        var iK$6 = ((((from + until) | 0) >>> 1) | 0);
        var len$2 = ((iK$6 - from) | 0);
        var sc$2 = new $ac_J(len$2);
        if ((((iK$6 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, iK$6, evidence$4)
        } else {
          var iK$7 = ((((from + iK$6) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, from, iK$7, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$7, iK$6, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$7, iK$6, evidence$4, sc$2)
        };
        if ((((until - iK$6) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, iK$6, until, evidence$4)
        } else {
          var iK$8 = ((((iK$6 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$6, iK$8, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$8, until, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, iK$6, iK$8, until, evidence$4, sc$2)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$6, until, evidence$4, sc$2)
      }
    }
  } else if ((a instanceof $ac_F)) {
    var x6 = $asArrayOf_F(a, 1);
    var evidence$2$3 = $m_s_reflect_ManifestFactory$FloatManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, until, evidence$4)
    } else {
      var iK$9 = ((((from + until) | 0) >>> 1) | 0);
      var len$3 = ((iK$9 - from) | 0);
      var sc$3 = new $ac_F(len$3);
      if ((((iK$9 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, iK$9, evidence$4)
      } else {
        var iK$10 = ((((from + iK$9) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, from, iK$10, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$10, iK$9, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$10, iK$9, evidence$4, sc$3)
      };
      if ((((until - iK$9) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, iK$9, until, evidence$4)
      } else {
        var iK$11 = ((((iK$9 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$9, iK$11, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$11, until, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, iK$9, iK$11, until, evidence$4, sc$3)
      };
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$9, until, evidence$4, sc$3)
    }
  } else if ((a instanceof $ac_C)) {
    var x7 = $asArrayOf_C(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Char$())) {
      $m_ju_Arrays$().sort__AC__I__I__V(x7, from, until)
    } else {
      var evidence$2$4 = $m_s_reflect_ManifestFactory$CharManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, until, evidence$4)
      } else {
        var iK$12 = ((((from + until) | 0) >>> 1) | 0);
        var len$4 = ((iK$12 - from) | 0);
        var sc$4 = new $ac_C(len$4);
        if ((((iK$12 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, iK$12, evidence$4)
        } else {
          var iK$13 = ((((from + iK$12) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, from, iK$13, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$13, iK$12, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$13, iK$12, evidence$4, sc$4)
        };
        if ((((until - iK$12) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, iK$12, until, evidence$4)
        } else {
          var iK$14 = ((((iK$12 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$12, iK$14, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$14, until, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, iK$12, iK$14, until, evidence$4, sc$4)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$12, until, evidence$4, sc$4)
      }
    }
  } else if ((a instanceof $ac_B)) {
    var x8 = $asArrayOf_B(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Byte$())) {
      $m_ju_Arrays$().sort__AB__I__I__V(x8, from, until)
    } else {
      var evidence$2$5 = $m_s_reflect_ManifestFactory$ByteManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, until, evidence$4)
      } else {
        var iK$15 = ((((from + until) | 0) >>> 1) | 0);
        var len$5 = ((iK$15 - from) | 0);
        var sc$5 = new $ac_B(len$5);
        if ((((iK$15 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, iK$15, evidence$4)
        } else {
          var iK$16 = ((((from + iK$15) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, from, iK$16, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$16, iK$15, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$16, iK$15, evidence$4, sc$5)
        };
        if ((((until - iK$15) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, iK$15, until, evidence$4)
        } else {
          var iK$17 = ((((iK$15 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$15, iK$17, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$17, until, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, iK$15, iK$17, until, evidence$4, sc$5)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$15, until, evidence$4, sc$5)
      }
    }
  } else if ((a instanceof $ac_S)) {
    var x9 = $asArrayOf_S(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Short$())) {
      $m_ju_Arrays$().sort__AS__I__I__V(x9, from, until)
    } else {
      var evidence$2$6 = $m_s_reflect_ManifestFactory$ShortManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, until, evidence$4)
      } else {
        var iK$18 = ((((from + until) | 0) >>> 1) | 0);
        var len$6 = ((iK$18 - from) | 0);
        var sc$6 = new $ac_S(len$6);
        if ((((iK$18 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, iK$18, evidence$4)
        } else {
          var iK$19 = ((((from + iK$18) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, from, iK$19, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$19, iK$18, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$19, iK$18, evidence$4, sc$6)
        };
        if ((((until - iK$18) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, iK$18, until, evidence$4)
        } else {
          var iK$20 = ((((iK$18 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$18, iK$20, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$20, until, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, iK$18, iK$20, until, evidence$4, sc$6)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$18, until, evidence$4, sc$6)
      }
    }
  } else if ((a instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Boolean$())) {
      this.scala$util$Sorting$$booleanSort__AZ__I__I__V(x10, from, until)
    } else {
      var evidence$2$7 = $m_s_reflect_ManifestFactory$BooleanManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, until, evidence$4)
      } else {
        var iK$21 = ((((from + until) | 0) >>> 1) | 0);
        var len$7 = ((iK$21 - from) | 0);
        var sc$7 = new $ac_Z(len$7);
        if ((((iK$21 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, iK$21, evidence$4)
        } else {
          var iK$22 = ((((from + iK$21) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, from, iK$22, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$22, iK$21, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$22, iK$21, evidence$4, sc$7)
        };
        if ((((until - iK$21) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, iK$21, until, evidence$4)
        } else {
          var iK$23 = ((((iK$21 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$21, iK$23, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$23, until, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, iK$21, iK$23, until, evidence$4, sc$7)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$21, until, evidence$4, sc$7)
      }
    }
  } else if ((a === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(a)
  }
});
var $d_s_util_Sorting$ = new $TypeData().initClass({
  s_util_Sorting$: 0
}, false, "scala.util.Sorting$", {
  s_util_Sorting$: 1,
  O: 1
});
$c_s_util_Sorting$.prototype.$classData = $d_s_util_Sorting$;
var $n_s_util_Sorting$;
function $m_s_util_Sorting$() {
  if ((!$n_s_util_Sorting$)) {
    $n_s_util_Sorting$ = new $c_s_util_Sorting$()
  };
  return $n_s_util_Sorting$
}
function $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable($thiz) {
  var this$1 = $m_s_util_control_NoStackTrace$();
  if (this$1.s_util_control_NoStackTrace$__f__noSuppression) {
    return $c_jl_Throwable.prototype.fillInStackTrace__jl_Throwable.call($thiz)
  } else {
    return $as_jl_Throwable($thiz)
  }
}
/** @constructor */
function $c_s_util_control_NonFatal$() {
  /*<skip>*/
}
$c_s_util_control_NonFatal$.prototype = new $h_O();
$c_s_util_control_NonFatal$.prototype.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
  /*<skip>*/
}
$h_s_util_control_NonFatal$.prototype = $c_s_util_control_NonFatal$.prototype;
$c_s_util_control_NonFatal$.prototype.apply__jl_Throwable__Z = (function(t) {
  return (!((t instanceof $c_jl_VirtualMachineError) || (false || (false || (false || (t instanceof $c_s_util_control_ControlThrowable))))))
});
$c_s_util_control_NonFatal$.prototype.unapply__jl_Throwable__s_Option = (function(t) {
  return (this.apply__jl_Throwable__Z(t) ? new $c_s_Some(t) : $m_s_None$())
});
var $d_s_util_control_NonFatal$ = new $TypeData().initClass({
  s_util_control_NonFatal$: 0
}, false, "scala.util.control.NonFatal$", {
  s_util_control_NonFatal$: 1,
  O: 1
});
$c_s_util_control_NonFatal$.prototype.$classData = $d_s_util_control_NonFatal$;
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$()
  };
  return $n_s_util_control_NonFatal$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3() {
  /*<skip>*/
}
$c_s_util_hashing_MurmurHash3.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3.prototype.constructor = $c_s_util_hashing_MurmurHash3;
/** @constructor */
function $h_s_util_hashing_MurmurHash3() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3.prototype = $c_s_util_hashing_MurmurHash3.prototype;
$c_s_util_hashing_MurmurHash3.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0)
});
$c_s_util_hashing_MurmurHash3.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k)
});
$c_s_util_hashing_MurmurHash3.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I((hash ^ length))
});
$c_s_util_hashing_MurmurHash3.prototype.scala$util$hashing$MurmurHash3$$avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
$c_s_util_hashing_MurmurHash3.prototype.tuple2Hash__I__I__I__I = (function(x, y, seed) {
  var h = seed;
  h = this.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  h = this.mix__I__I__I(h, x);
  h = this.mix__I__I__I(h, y);
  return this.finalizeHash__I__I__I(h, 2)
});
$c_s_util_hashing_MurmurHash3.prototype.productHash__s_Product__I__Z__I = (function(x, seed, ignorePrefix) {
  var arr = $n(x).productArity__I();
  if ((arr === 0)) {
    return $f_T__hashCode__I($n($n(x).productPrefix__T()))
  } else {
    var h = seed;
    if ((!ignorePrefix)) {
      h = this.mix__I__I__I(h, $f_T__hashCode__I($n($n(x).productPrefix__T())))
    };
    var i = 0;
    while ((i < arr)) {
      var $$x1 = h;
      var x$1 = $n(x).productElement__I__O(i);
      h = this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x$1));
      i = ((1 + i) | 0)
    };
    return this.finalizeHash__I__I__I(h, arr)
  }
});
$c_s_util_hashing_MurmurHash3.prototype.unorderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var a = 0;
  var b = 0;
  var n = 0;
  var c = 1;
  var iterator = $n(xs).iterator__sc_Iterator();
  while ($n(iterator).hasNext__Z()) {
    var x = $n(iterator).next__O();
    var h = $m_sr_Statics$().anyHash__O__I(x);
    a = ((a + h) | 0);
    b = (b ^ h);
    c = Math.imul(c, (1 | h));
    n = ((1 + n) | 0)
  };
  var h$2 = seed;
  h$2 = this.mix__I__I__I(h$2, a);
  h$2 = this.mix__I__I__I(h$2, b);
  h$2 = this.mixLast__I__I__I(h$2, c);
  return this.finalizeHash__I__I__I(h$2, n)
});
$c_s_util_hashing_MurmurHash3.prototype.orderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var it = $n(xs).iterator__sc_Iterator();
  var h = seed;
  if ((!$n(it).hasNext__Z())) {
    return this.finalizeHash__I__I__I(h, 0)
  };
  var x0 = $n(it).next__O();
  if ((!$n(it).hasNext__Z())) {
    return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $m_sr_Statics$().anyHash__O__I(x0)), 1)
  };
  var x1 = $n(it).next__O();
  var initial = $m_sr_Statics$().anyHash__O__I(x0);
  h = this.mix__I__I__I(h, initial);
  var h0 = h;
  var prev = $m_sr_Statics$().anyHash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while ($n(it).hasNext__Z()) {
    h = this.mix__I__I__I(h, prev);
    var x = $n(it).next__O();
    var hash = $m_sr_Statics$().anyHash__O__I(x);
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = this.mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while ($n(it).hasNext__Z()) {
        var $$x1 = h;
        var x$1 = $n(it).next__O();
        h = this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x$1));
        i = ((1 + i) | 0)
      };
      return this.finalizeHash__I__I__I(h, i)
    };
    prev = hash;
    i = ((1 + i) | 0)
  };
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash__O__I__I = (function(a, seed) {
  var h = seed;
  var l = $m_jl_reflect_Array$().getLength__O__I(a);
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var x = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break
    }
    default: {
      var x$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var x$4 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.rangeHash__I__I__I__I__I = (function(start, step, last, seed) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(this.mix__I__I__I(seed, start), step), last))
});
$c_s_util_hashing_MurmurHash3.prototype.indexedSeqHash__sc_IndexedSeq__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).length__I();
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var x = $n(a).apply__I__O(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break
    }
    default: {
      var x$1 = $n(a).apply__I__O(0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $n(a).apply__I__O(1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $n(a).apply__I__O(i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var x$4 = $n(a).apply__I__O(i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.listHash__sci_List__I__I = (function(xs, seed) {
  var n = 0;
  var h = seed;
  var rangeState = 0;
  var rangeDiff = 0;
  var prev = 0;
  var initial = 0;
  var elems = xs;
  while ((!$n(elems).isEmpty__Z())) {
    var head = $n(elems).head__O();
    var tail = $as_sci_List($n(elems).tail__O());
    var hash = $m_sr_Statics$().anyHash__O__I(head);
    h = this.mix__I__I__I(h, hash);
    var x1 = rangeState;
    switch (x1) {
      case 0: {
        initial = hash;
        rangeState = 1;
        break
      }
      case 1: {
        rangeDiff = ((hash - prev) | 0);
        rangeState = 2;
        break
      }
      case 2: {
        if ((rangeDiff !== ((hash - prev) | 0))) {
          rangeState = 3
        };
        break
      }
    };
    prev = hash;
    n = ((1 + n) | 0);
    elems = tail
  };
  return ((rangeState === 2) ? this.rangeHash__I__I__I__I__I(initial, rangeDiff, prev, seed) : this.finalizeHash__I__I__I(h, n))
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mZc$sp__AZ__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, ($n(a).get(0) ? 1231 : 1237)), 1);
      break
    }
    default: {
      var initial = ($n(a).get(0) ? 1231 : 1237);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = ($n(a).get(1) ? 1231 : 1237);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = ($n(a).get(i) ? 1231 : 1237);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, ($n(a).get(i) ? 1231 : 1237));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mBc$sp__AB__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mCc$sp__AC__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mDc$sp__AD__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var dv = $n(a).get(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().doubleHash__D__I(dv)), 1);
      break
    }
    default: {
      var dv$1 = $n(a).get(0);
      var initial = $m_sr_Statics$().doubleHash__D__I(dv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var dv$2 = $n(a).get(1);
      var prev = $m_sr_Statics$().doubleHash__D__I(dv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var dv$3 = $n(a).get(i);
        var hash = $m_sr_Statics$().doubleHash__D__I(dv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var dv$4 = $n(a).get(i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().doubleHash__D__I(dv$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mFc$sp__AF__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var fv = $n(a).get(0);
      var this$1 = $m_sr_Statics$();
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, this$1.doubleHash__D__I(fv)), 1);
      break
    }
    default: {
      var fv$1 = $n(a).get(0);
      var this$2 = $m_sr_Statics$();
      var initial = this$2.doubleHash__D__I(fv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var fv$2 = $n(a).get(1);
      var this$3 = $m_sr_Statics$();
      var prev = this$3.doubleHash__D__I(fv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var fv$3 = $n(a).get(i);
        var this$4 = $m_sr_Statics$();
        var hash = this$4.doubleHash__D__I(fv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var fv$4 = $n(a).get(i);
            var this$5 = $m_sr_Statics$();
            h = this.mix__I__I__I($$x2, this$5.doubleHash__D__I(fv$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mIc$sp__AI__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mJc$sp__AJ__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var t = $n(a).get(0);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi))), 1);
      break
    }
    default: {
      var t$1 = $n(a).get(0);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var initial = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$1, hi$1));
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var t$2 = $n(a).get(1);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var prev = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$2, hi$2));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var t$3 = $n(a).get(i);
        var lo$3 = t$3.RTLong__f_lo;
        var hi$3 = t$3.RTLong__f_hi;
        var hash = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$3, hi$3));
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var t$4 = $n(a).get(i);
            var lo$4 = t$4.RTLong__f_lo;
            var hi$4 = t$4.RTLong__f_hi;
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$4, hi$4)));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mSc$sp__AS__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mVc$sp__Ajl_Void__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, 0), 1);
      break
    }
    default: {
      h = this.mix__I__I__I(h, 0);
      var h0 = h;
      var prev = 0;
      var rangeDiff = prev;
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        if ((rangeDiff !== ((-prev) | 0))) {
          h = this.mix__I__I__I(h, 0);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, 0);
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = 0;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
function $f_s_util_matching_Regex$MatchData__matched__T($thiz) {
  return (($thiz.start__I() >= 0) ? $dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n($thiz.source__jl_CharSequence()), $thiz.start__I(), $thiz.end__I()))) : null)
}
function $f_s_util_matching_Regex$MatchData__group__I__T($thiz, i) {
  return (($thiz.start__I__I(i) >= 0) ? $dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n($thiz.source__jl_CharSequence()), $thiz.start__I__I(i), $thiz.end__I__I(i)))) : null)
}
function $f_s_util_matching_Regex$Replacement__replaced__T($thiz) {
  var newsb = $ct_jl_StringBuffer__jl_CharSequence__(new $c_jl_StringBuffer(), $thiz.s_util_matching_Regex$MatchIterator$$anon$4__f_scala$util$matching$Regex$Replacement$$sb);
  $n($thiz.matcher__ju_regex_Matcher()).appendTail__jl_StringBuffer__jl_StringBuffer(newsb);
  return newsb.toString__T()
}
/** @constructor */
function $c_Lscalacss_internal_AVs(order, data) {
  this.Lscalacss_internal_AVs__f_order = null;
  this.Lscalacss_internal_AVs__f_data = null;
  this.Lscalacss_internal_AVs__f_order = order;
  this.Lscalacss_internal_AVs__f_data = data
}
$c_Lscalacss_internal_AVs.prototype = new $h_O();
$c_Lscalacss_internal_AVs.prototype.constructor = $c_Lscalacss_internal_AVs;
/** @constructor */
function $h_Lscalacss_internal_AVs() {
  /*<skip>*/
}
$h_Lscalacss_internal_AVs.prototype = $c_Lscalacss_internal_AVs.prototype;
$c_Lscalacss_internal_AVs.prototype.toString__T = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "AVs(", ", ", ")")
});
$c_Lscalacss_internal_AVs.prototype.$plus$plus__sc_Iterable__Lscalacss_internal_AVs = (function(avs) {
  return $as_Lscalacss_internal_AVs($n(avs).foldLeft__O__F2__O(this, new $c_sjsr_AnonFunction2(((x$1$2, x$2$2) => {
    var x$1 = $as_Lscalacss_internal_AVs(x$1$2);
    var x$2 = $as_Lscalacss_internal_AV(x$2$2);
    var this$2 = $n(x$1);
    return this$2.add__Lscalacss_internal_Attr__T__Lscalacss_internal_AVs($n(x$2).Lscalacss_internal_AV__f_attr, $n(x$2).Lscalacss_internal_AV__f_value)
  }))))
});
$c_Lscalacss_internal_AVs.prototype.$plus$plus__Lscalacss_internal_AVs__Lscalacss_internal_AVs = (function(avs) {
  var this$2 = $n($n(avs).iterator__sc_Iterator());
  var f = ((q$2, t$2) => {
    var q = $as_Lscalacss_internal_AVs(q$2);
    var t = $as_T2(t$2);
    return $n(q).addAll__Lscalacss_internal_Attr__Lscalacss_internal_NonEmptyVector__Lscalacss_internal_AVs($as_Lscalacss_internal_Attr($n(t)._1__O()), $as_Lscalacss_internal_NonEmptyVector($n(t)._2__O()))
  });
  if ($is_sc_IndexedSeq(this$2)) {
    var x2 = $as_sc_IndexedSeq(this$2);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = this;
    var $$x1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f(arg1, arg2);
        at = temp$at;
        acc = temp$acc;
        continue
      };
      var $$x1 = acc;
      break
    }
  } else {
    var result = this;
    while (this$2.hasNext__Z()) {
      var arg1$1 = result;
      var arg2$1 = this$2.next__O();
      result = f(arg1$1, arg2$1)
    };
    var $$x1 = result
  };
  return $as_Lscalacss_internal_AVs($$x1)
});
$c_Lscalacss_internal_AVs.prototype.add__Lscalacss_internal_Attr__T__Lscalacss_internal_AVs = (function(a, v) {
  var existing = this.getv__Lscalacss_internal_Attr__sci_Vector(a);
  var this$1 = $n(existing);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    var newOrder = $n(this.Lscalacss_internal_AVs__f_order).$colon$plus__O__Lscalacss_internal_NonEmptyVector(a)
  } else {
    var newOrder = this.Lscalacss_internal_AVs__f_order
  };
  var newData = $as_sci_Map($n(this.Lscalacss_internal_AVs__f_data).updated__O__O__sci_MapOps(a, $m_Lscalacss_internal_NonEmptyVector$().end__sci_Vector__O__Lscalacss_internal_NonEmptyVector(existing, v)));
  return new $c_Lscalacss_internal_AVs(newOrder, newData)
});
$c_Lscalacss_internal_AVs.prototype.addAll__Lscalacss_internal_Attr__Lscalacss_internal_NonEmptyVector__Lscalacss_internal_AVs = (function(a, vs) {
  var existing = this.getv__Lscalacss_internal_Attr__sci_Vector(a);
  var this$1 = $n(existing);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    var newOrder = $n(this.Lscalacss_internal_AVs__f_order).$colon$plus__O__Lscalacss_internal_NonEmptyVector(a)
  } else {
    var newOrder = this.Lscalacss_internal_AVs__f_order
  };
  var newData = $as_sci_Map($n(this.Lscalacss_internal_AVs__f_data).updated__O__O__sci_MapOps(a, $n(vs).$plus$plus$colon__sci_Vector__Lscalacss_internal_NonEmptyVector(existing)));
  return new $c_Lscalacss_internal_AVs(newOrder, newData)
});
$c_Lscalacss_internal_AVs.prototype.getv__Lscalacss_internal_Attr__sci_Vector = (function(a) {
  var this$1 = $n($n(this.Lscalacss_internal_AVs__f_data).get__O__s_Option(a));
  if (this$1.isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_Vector);
    var $$x1 = $m_sci_Vector0$()
  } else {
    var arg1 = this$1.get__O();
    var x$7 = $as_Lscalacss_internal_NonEmptyVector(arg1);
    var $$x1 = $n(x$7).whole__sci_Vector()
  };
  return $as_sci_Vector($$x1)
});
$c_Lscalacss_internal_AVs.prototype.filterKeys__F1__s_Option = (function(f) {
  var $$x1 = $m_Lscalacss_internal_NonEmptyVector$();
  var this$1 = $n($n(this.Lscalacss_internal_AVs__f_order).whole__sci_Vector());
  var this$2 = $n($n($$x1).option__sci_Vector__s_Option(this$1.filterImpl__F1__Z__sci_Vector(f, false)));
  if (this$2.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var o = $as_Lscalacss_internal_NonEmptyVector(arg1);
    var this$4 = $n($n(this.Lscalacss_internal_AVs__f_data).iterator__sc_Iterator());
    var p = new $c_sjsr_AnonFunction1(((kv$2) => {
      var kv = $as_T2(kv$2);
      return $uZ($n(f).apply__O__O($n(kv)._1__O()))
    }));
    var this$6 = new $c_sc_Iterator$$anon$6(this$4, p, false);
    var this$5 = $m_s_$less$colon$less$();
    return new $c_s_Some(new $c_Lscalacss_internal_AVs(o, $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$6)))
  }
});
$c_Lscalacss_internal_AVs.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n(this.Lscalacss_internal_AVs__f_order);
  var this$3 = $n($n(this$1.whole__sci_Vector()).iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((a$2) => {
    var a = $as_Lscalacss_internal_Attr(a$2);
    return $ct_T2__O__O__(new $c_T2(), a, $n(this.Lscalacss_internal_AVs__f_data).apply__O__O(a))
  }));
  return new $c_sc_Iterator$$anon$9(this$3, f)
});
$c_Lscalacss_internal_AVs.prototype.avIterator__sc_Iterator = (function() {
  var this$4 = $n(this.iterator__sc_Iterator());
  var f$1 = new $c_sjsr_AnonFunction1(((t$2) => {
    var t = $as_T2(t$2);
    var this$2 = $n($as_Lscalacss_internal_NonEmptyVector($n(t)._2__O()));
    var this$3 = $n($n(this$2.whole__sci_Vector()).iterator__sc_Iterator());
    var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_T(x$8$2);
      return new $c_Lscalacss_internal_AV($as_Lscalacss_internal_Attr($n(t)._1__O()), x$8)
    }));
    return new $c_sc_Iterator$$anon$9(this$3, f)
  }));
  return new $c_sc_Iterator$$anon$10(this$4, f$1)
});
function $as_Lscalacss_internal_AVs(obj) {
  return (((obj instanceof $c_Lscalacss_internal_AVs) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.AVs"))
}
function $isArrayOf_Lscalacss_internal_AVs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_AVs)))
}
function $asArrayOf_Lscalacss_internal_AVs(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_AVs(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.AVs;", depth))
}
var $d_Lscalacss_internal_AVs = new $TypeData().initClass({
  Lscalacss_internal_AVs: 0
}, false, "scalacss.internal.AVs", {
  Lscalacss_internal_AVs: 1,
  O: 1
});
$c_Lscalacss_internal_AVs.prototype.$classData = $d_Lscalacss_internal_AVs;
/** @constructor */
function $c_Lscalacss_internal_AVs$() {
  /*<skip>*/
}
$c_Lscalacss_internal_AVs$.prototype = new $h_O();
$c_Lscalacss_internal_AVs$.prototype.constructor = $c_Lscalacss_internal_AVs$;
/** @constructor */
function $h_Lscalacss_internal_AVs$() {
  /*<skip>*/
}
$h_Lscalacss_internal_AVs$.prototype = $c_Lscalacss_internal_AVs$.prototype;
$c_Lscalacss_internal_AVs$.prototype.apply__Lscalacss_internal_AV__sci_Seq__Lscalacss_internal_AVs = (function(av1, avn) {
  return $n(this.apply__Lscalacss_internal_Attr__T__Lscalacss_internal_AVs($n(av1).Lscalacss_internal_AV__f_attr, $n(av1).Lscalacss_internal_AV__f_value)).$plus$plus__sc_Iterable__Lscalacss_internal_AVs(avn)
});
$c_Lscalacss_internal_AVs$.prototype.apply__Lscalacss_internal_Attr__T__Lscalacss_internal_AVs = (function(a, v) {
  return this.apply__Lscalacss_internal_Attr__Lscalacss_internal_NonEmptyVector__Lscalacss_internal_AVs(a, $m_Lscalacss_internal_NonEmptyVector$().one__O__Lscalacss_internal_NonEmptyVector(v))
});
$c_Lscalacss_internal_AVs$.prototype.apply__Lscalacss_internal_Attr__Lscalacss_internal_NonEmptyVector__Lscalacss_internal_AVs = (function(a, vs) {
  return new $c_Lscalacss_internal_AVs($m_Lscalacss_internal_NonEmptyVector$().one__O__Lscalacss_internal_NonEmptyVector(a), ($n($m_s_Predef$().s_Predef$__f_Map), new $c_sci_Map$Map1(a, vs)))
});
var $d_Lscalacss_internal_AVs$ = new $TypeData().initClass({
  Lscalacss_internal_AVs$: 0
}, false, "scalacss.internal.AVs$", {
  Lscalacss_internal_AVs$: 1,
  O: 1
});
$c_Lscalacss_internal_AVs$.prototype.$classData = $d_Lscalacss_internal_AVs$;
var $n_Lscalacss_internal_AVs$;
function $m_Lscalacss_internal_AVs$() {
  if ((!$n_Lscalacss_internal_AVs$)) {
    $n_Lscalacss_internal_AVs$ = new $c_Lscalacss_internal_AVs$()
  };
  return $n_Lscalacss_internal_AVs$
}
function $ct_Lscalacss_internal_Attr__T__F1__($thiz, id, gen) {
  $thiz.Lscalacss_internal_Attr__f_id = id;
  $thiz.Lscalacss_internal_Attr__f_gen = gen;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_Attr() {
  this.Lscalacss_internal_Attr__f_id = null;
  this.Lscalacss_internal_Attr__f_gen = null
}
$c_Lscalacss_internal_Attr.prototype = new $h_O();
$c_Lscalacss_internal_Attr.prototype.constructor = $c_Lscalacss_internal_Attr;
/** @constructor */
function $h_Lscalacss_internal_Attr() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attr.prototype = $c_Lscalacss_internal_Attr.prototype;
$c_Lscalacss_internal_Attr.prototype.hashCode__I = (function() {
  var x = this.Lscalacss_internal_Attr__f_id;
  return $m_sr_Statics$().anyHash__O__I(x)
});
$c_Lscalacss_internal_Attr.prototype.equals__O__Z = (function(t) {
  if ((t instanceof $c_Lscalacss_internal_Attr)) {
    var x2 = $as_Lscalacss_internal_Attr(t);
    return ($n(x2).Lscalacss_internal_Attr__f_id === this.Lscalacss_internal_Attr__f_id)
  } else {
    return false
  }
});
$c_Lscalacss_internal_Attr.prototype.toString__T = (function() {
  return this.Lscalacss_internal_Attr__f_id
});
function $as_Lscalacss_internal_Attr(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Attr) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Attr"))
}
function $isArrayOf_Lscalacss_internal_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Attr)))
}
function $asArrayOf_Lscalacss_internal_Attr(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Attr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Attr;", depth))
}
function $p_Lscalacss_internal_Attr$___alias__T__F1__F1($thiz, id, g) {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    var a = new $c_sjsr_AnonFunction0((() => $as_Lscalacss_internal_NonEmptyVector($n(f).apply__O__O($m_Lscalacss_internal_Attr$AliasB$()))));
    return new $c_Lscalacss_internal_AliasAttr(id, g, new $c_Lscalacss_internal_Need(a))
  }))
}
/** @constructor */
function $c_Lscalacss_internal_Attr$() {
  /*<skip>*/
}
$c_Lscalacss_internal_Attr$.prototype = new $h_O();
$c_Lscalacss_internal_Attr$.prototype.constructor = $c_Lscalacss_internal_Attr$;
/** @constructor */
function $h_Lscalacss_internal_Attr$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attr$.prototype = $c_Lscalacss_internal_Attr$.prototype;
$c_Lscalacss_internal_Attr$.prototype.genSimple__T__F1 = (function(css) {
  return new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Lscalacss_internal_Env(x$1$2);
    return new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_T(v$2);
      return $m_Lscalacss_internal_package$().Vector1__O__sci_Vector(new $c_Lscalacss_internal_CssKV(css, v))
    }))
  }))
});
$c_Lscalacss_internal_Attr$.prototype.real__T__Lscalacss_internal_Attr = (function(css) {
  return new $c_Lscalacss_internal_RealAttr(css, this.genSimple__T__F1(css))
});
$c_Lscalacss_internal_Attr$.prototype.real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr = (function(css, t) {
  return new $c_Lscalacss_internal_RealAttr(css, $n(t).attrGen__T__F1(css))
});
$c_Lscalacss_internal_Attr$.prototype.alias__T__F1 = (function(css) {
  return $p_Lscalacss_internal_Attr$___alias__T__F1__F1(this, css, this.genSimple__T__F1(css))
});
$c_Lscalacss_internal_Attr$.prototype.alias__T__Lscalacss_internal_Transform__F1 = (function(css, t) {
  return $p_Lscalacss_internal_Attr$___alias__T__F1__F1(this, css, $n(t).attrGen__T__F1(css))
});
var $d_Lscalacss_internal_Attr$ = new $TypeData().initClass({
  Lscalacss_internal_Attr$: 0
}, false, "scalacss.internal.Attr$", {
  Lscalacss_internal_Attr$: 1,
  O: 1
});
$c_Lscalacss_internal_Attr$.prototype.$classData = $d_Lscalacss_internal_Attr$;
var $n_Lscalacss_internal_Attr$;
function $m_Lscalacss_internal_Attr$() {
  if ((!$n_Lscalacss_internal_Attr$)) {
    $n_Lscalacss_internal_Attr$ = new $c_Lscalacss_internal_Attr$()
  };
  return $n_Lscalacss_internal_Attr$
}
/** @constructor */
function $c_Lscalacss_internal_Attr$AliasB$() {
  /*<skip>*/
}
$c_Lscalacss_internal_Attr$AliasB$.prototype = new $h_O();
$c_Lscalacss_internal_Attr$AliasB$.prototype.constructor = $c_Lscalacss_internal_Attr$AliasB$;
/** @constructor */
function $h_Lscalacss_internal_Attr$AliasB$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attr$AliasB$.prototype = $c_Lscalacss_internal_Attr$AliasB$.prototype;
function $as_Lscalacss_internal_Attr$AliasB$(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Attr$AliasB$) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Attr$AliasB$"))
}
function $isArrayOf_Lscalacss_internal_Attr$AliasB$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Attr$AliasB$)))
}
function $asArrayOf_Lscalacss_internal_Attr$AliasB$(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Attr$AliasB$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Attr$AliasB$;", depth))
}
var $d_Lscalacss_internal_Attr$AliasB$ = new $TypeData().initClass({
  Lscalacss_internal_Attr$AliasB$: 0
}, false, "scalacss.internal.Attr$AliasB$", {
  Lscalacss_internal_Attr$AliasB$: 1,
  O: 1
});
$c_Lscalacss_internal_Attr$AliasB$.prototype.$classData = $d_Lscalacss_internal_Attr$AliasB$;
var $n_Lscalacss_internal_Attr$AliasB$;
function $m_Lscalacss_internal_Attr$AliasB$() {
  if ((!$n_Lscalacss_internal_Attr$AliasB$)) {
    $n_Lscalacss_internal_Attr$AliasB$ = new $c_Lscalacss_internal_Attr$AliasB$()
  };
  return $n_Lscalacss_internal_Attr$AliasB$
}
/** @constructor */
function $c_Lscalacss_internal_AttrCmp() {
  /*<skip>*/
}
$c_Lscalacss_internal_AttrCmp.prototype = new $h_O();
$c_Lscalacss_internal_AttrCmp.prototype.constructor = $c_Lscalacss_internal_AttrCmp;
/** @constructor */
function $h_Lscalacss_internal_AttrCmp() {
  /*<skip>*/
}
$h_Lscalacss_internal_AttrCmp.prototype = $c_Lscalacss_internal_AttrCmp.prototype;
function $as_Lscalacss_internal_AttrCmp(obj) {
  return (((obj instanceof $c_Lscalacss_internal_AttrCmp) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.AttrCmp"))
}
function $isArrayOf_Lscalacss_internal_AttrCmp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_AttrCmp)))
}
function $asArrayOf_Lscalacss_internal_AttrCmp(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_AttrCmp(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.AttrCmp;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_AttrCmp$() {
  this.Lscalacss_internal_AttrCmp$__f_byEquality = null;
  this.Lscalacss_internal_AttrCmp$__f_byRealAttrs = null;
  this.Lscalacss_internal_AttrCmp$__f_default = null;
  $n_Lscalacss_internal_AttrCmp$ = this;
  this.Lscalacss_internal_AttrCmp$__f_byEquality = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lscalacss_internal_Attr(a$2);
    var b = $as_Lscalacss_internal_Attr(b$2);
    return (((a === null) ? (b === null) : $n(a).equals__O__Z(b)) ? $m_Lscalacss_internal_AttrCmp$Same$() : $m_Lscalacss_internal_AttrCmp$Unrelated$())
  }));
  this.Lscalacss_internal_AttrCmp$__f_byRealAttrs = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $as_Lscalacss_internal_Attr(x$2);
    var y = $as_Lscalacss_internal_Attr(y$2);
    var a$1 = $n(x).real__sci_Set();
    var b$1 = $n(y).real__sci_Set();
    return ($n(a$1).exists__F1__Z(new $c_sjsr_AnonFunction1(((elem$2) => {
      var elem = $as_Lscalacss_internal_RealAttr(elem$2);
      return $n(b$1).contains__O__Z(elem)
    }))) ? $m_Lscalacss_internal_AttrCmp$Overlap$() : $m_Lscalacss_internal_AttrCmp$Unrelated$())
  }));
  this.Lscalacss_internal_AttrCmp$__f_default = this.compose__F2__F2__F2(this.Lscalacss_internal_AttrCmp$__f_byEquality, this.Lscalacss_internal_AttrCmp$__f_byRealAttrs)
}
$c_Lscalacss_internal_AttrCmp$.prototype = new $h_O();
$c_Lscalacss_internal_AttrCmp$.prototype.constructor = $c_Lscalacss_internal_AttrCmp$;
/** @constructor */
function $h_Lscalacss_internal_AttrCmp$() {
  /*<skip>*/
}
$h_Lscalacss_internal_AttrCmp$.prototype = $c_Lscalacss_internal_AttrCmp$.prototype;
$c_Lscalacss_internal_AttrCmp$.prototype.compose__F2__F2__F2 = (function(fst, snd) {
  return new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lscalacss_internal_Attr(a$2);
    var b = $as_Lscalacss_internal_Attr(b$2);
    return $n($as_Lscalacss_internal_AttrCmp($n(fst).apply__O__O__O(a, b))).$greater$greater__F0__Lscalacss_internal_AttrCmp(new $c_sjsr_AnonFunction0((() => $as_Lscalacss_internal_AttrCmp($n(snd).apply__O__O__O(a, b)))))
  }))
});
var $d_Lscalacss_internal_AttrCmp$ = new $TypeData().initClass({
  Lscalacss_internal_AttrCmp$: 0
}, false, "scalacss.internal.AttrCmp$", {
  Lscalacss_internal_AttrCmp$: 1,
  O: 1
});
$c_Lscalacss_internal_AttrCmp$.prototype.$classData = $d_Lscalacss_internal_AttrCmp$;
var $n_Lscalacss_internal_AttrCmp$;
function $m_Lscalacss_internal_AttrCmp$() {
  if ((!$n_Lscalacss_internal_AttrCmp$)) {
    $n_Lscalacss_internal_AttrCmp$ = new $c_Lscalacss_internal_AttrCmp$()
  };
  return $n_Lscalacss_internal_AttrCmp$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$() {
  /*<skip>*/
}
$c_Lscalacss_internal_Attrs$.prototype = new $h_O();
$c_Lscalacss_internal_Attrs$.prototype.constructor = $c_Lscalacss_internal_Attrs$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$.prototype = $c_Lscalacss_internal_Attrs$.prototype;
$c_Lscalacss_internal_Attrs$.prototype.backgroundAttachment__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().backgroundAttachment__sci_Map();
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("background-attachment", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.boxShadow__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().boxshadow__sci_Map();
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("box-shadow", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.flexBasis__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("flex-basis", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.gridAutoColumns__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_grid;
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("grid-auto-columns", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.gridAutoFlow__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_grid;
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("grid-auto-flow", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.gridAutoRows__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_grid;
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("grid-auto-rows", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.gridTemplateRows__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_grid;
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("grid-template-rows", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.gridTemplateColumns__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_grid;
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("grid-template-columns", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.textOverflow__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().textOverflow__sci_Map();
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("text-overflow", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.textShadow__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().textshadow__sci_Map();
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("text-shadow", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.touchAction__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().touchAction__sci_Map();
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("touch-action", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.transform__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().transforms__sci_Map();
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("transform", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.transformOrigin__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().transforms__sci_Map();
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("transform-origin", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.transitionProperty__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_transitions;
  return $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("transition-property", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
});
$c_Lscalacss_internal_Attrs$.prototype.background__Lscalacss_internal_Attr = (function() {
  return $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__Lscalacss_internal_Transform__F1("background", $m_Lscalacss_internal_CanIUse2$().backgroundImageTransforms__Lscalacss_internal_Transform())).apply__O__O(new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Lscalacss_internal_Attr$AliasB$(x$9$2);
    $n(x$9);
    var t = $m_Lscalacss_internal_Attrs$backgroundClip$();
    var h = t.Lscalacss_internal_Attrs$backgroundClip$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$backgroundColor$();
    var $$x4 = t$1.Lscalacss_internal_Attrs$backgroundColor$__f_attr;
    var $$x3 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("background-image", $m_Lscalacss_internal_CanIUse2$().backgroundImageTransforms__Lscalacss_internal_Transform());
    var $$x2 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-origin");
    var $$x1 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-position");
    var t$2 = $m_Lscalacss_internal_Attrs$backgroundRepeat$();
    var array = [$$x4, $$x3, $$x2, $$x1, t$2.Lscalacss_internal_Attrs$backgroundRepeat$__f_attr, $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-size"), $m_Lscalacss_internal_Attrs$().backgroundAttachment__Lscalacss_internal_Attr()];
    var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$4 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$3);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$4)
  }))))
});
$c_Lscalacss_internal_Attrs$.prototype.columns__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_multicolumn;
  return $as_Lscalacss_internal_Attr($n($n($$x1).alias__T__Lscalacss_internal_Transform__F1("columns", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))).apply__O__O(new $c_sjsr_AnonFunction1(((x$38$2) => {
    var x$38 = $as_Lscalacss_internal_Attr$AliasB$(x$38$2);
    $n(x$38);
    var t = $m_Lscalacss_internal_Attrs$columnWidth$();
    var h = t.Lscalacss_internal_Attrs$columnWidth$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$columnCount$();
    var array = [t$1.Lscalacss_internal_Attrs$columnCount$__f_attr];
    var t$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$3 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$2);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$3)
  }))))
});
$c_Lscalacss_internal_Attrs$.prototype.flex__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  return $as_Lscalacss_internal_Attr($n($n($$x1).alias__T__Lscalacss_internal_Transform__F1("flex", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))).apply__O__O(new $c_sjsr_AnonFunction1(((x$40$2) => {
    var x$40 = $as_Lscalacss_internal_Attr$AliasB$(x$40$2);
    $n(x$40);
    var t = $m_Lscalacss_internal_Attrs$flexGrow$();
    var h = t.Lscalacss_internal_Attrs$flexGrow$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$flexShrink$();
    var array = [t$1.Lscalacss_internal_Attrs$flexShrink$__f_attr, $m_Lscalacss_internal_Attrs$().flexBasis__Lscalacss_internal_Attr()];
    var t$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$3 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$2);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$3)
  }))))
});
$c_Lscalacss_internal_Attrs$.prototype.font__Lscalacss_internal_Attr = (function() {
  return $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("font")).apply__O__O(new $c_sjsr_AnonFunction1(((x$42$2) => {
    var x$42 = $as_Lscalacss_internal_Attr$AliasB$(x$42$2);
    $n(x$42);
    var t = $m_Lscalacss_internal_Attrs$fontStyle$();
    var h = t.Lscalacss_internal_Attrs$fontStyle$__f_attr;
    var $$x4 = $m_Lscalacss_internal_Attrs$().fontVariant__Lscalacss_internal_Attr();
    var t$1 = $m_Lscalacss_internal_Attrs$fontWeight$();
    var $$x3 = t$1.Lscalacss_internal_Attrs$fontWeight$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$fontSize$();
    var $$x2 = t$2.Lscalacss_internal_Attrs$fontSize$__f_attr;
    var t$3 = $m_Lscalacss_internal_Attrs$lineHeight$();
    var $$x1 = t$3.Lscalacss_internal_Attrs$lineHeight$__f_attr;
    var t$4 = $m_Lscalacss_internal_Attrs$fontFamily$();
    var array = [$$x4, $$x3, $$x2, $$x1, t$4.Lscalacss_internal_Attrs$fontFamily$__f_attr];
    var t$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$6 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$5);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$6)
  }))))
});
$c_Lscalacss_internal_Attrs$.prototype.fontVariant__Lscalacss_internal_Attr = (function() {
  return $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("font-variant")).apply__O__O(new $c_sjsr_AnonFunction1(((x$43$2) => {
    var x$43 = $as_Lscalacss_internal_Attr$AliasB$(x$43$2);
    $n(x$43);
    var h = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("font-variant-alternates");
    var t = $m_Lscalacss_internal_Attrs$fontVariantCaps$();
    var $$x4 = t.Lscalacss_internal_Attrs$fontVariantCaps$__f_attr;
    var $$x3 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("font-variant-east-asian");
    var $$x2 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("font-variant-ligatures");
    var $$x1 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("font-variant-numeric");
    var t$1 = $m_Lscalacss_internal_Attrs$fontVariantPosition$();
    var array = [$$x4, $$x3, $$x2, $$x1, t$1.Lscalacss_internal_Attrs$fontVariantPosition$__f_attr];
    var t$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$3 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$2);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$3)
  }))))
});
$c_Lscalacss_internal_Attrs$.prototype.grid__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_grid;
  return $as_Lscalacss_internal_Attr($n($n($$x1).alias__T__Lscalacss_internal_Transform__F1("grid", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))).apply__O__O(new $c_sjsr_AnonFunction1(((x$45$2) => {
    var x$45 = $as_Lscalacss_internal_Attr$AliasB$(x$45$2);
    $n(x$45);
    var h = $m_Lscalacss_internal_Attrs$().gridTemplate__Lscalacss_internal_Attr();
    var array = [$m_Lscalacss_internal_Attrs$().gridAutoFlow__Lscalacss_internal_Attr(), $m_Lscalacss_internal_Attrs$().gridAutoColumns__Lscalacss_internal_Attr(), $m_Lscalacss_internal_Attrs$().gridAutoRows__Lscalacss_internal_Attr()];
    var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$1 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$1)
  }))))
});
$c_Lscalacss_internal_Attrs$.prototype.gridTemplate__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_grid;
  return $as_Lscalacss_internal_Attr($n($n($$x1).alias__T__Lscalacss_internal_Transform__F1("grid-template", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))).apply__O__O(new $c_sjsr_AnonFunction1(((x$49$2) => {
    var x$49 = $as_Lscalacss_internal_Attr$AliasB$(x$49$2);
    $n(x$49);
    var t = $m_Lscalacss_internal_Attrs$gridTemplateAreas$();
    var h = t.Lscalacss_internal_Attrs$gridTemplateAreas$__f_attr;
    var array = [$m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr(), $m_Lscalacss_internal_Attrs$().gridTemplateRows__Lscalacss_internal_Attr()];
    var t$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$2 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$1);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$2)
  }))))
});
$c_Lscalacss_internal_Attrs$.prototype.textDecoration__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_textDecoration;
  return $as_Lscalacss_internal_Attr($n($n($$x1).alias__T__Lscalacss_internal_Transform__F1("text-decoration", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))).apply__O__O(new $c_sjsr_AnonFunction1(((x$77$2) => {
    var x$77 = $as_Lscalacss_internal_Attr$AliasB$(x$77$2);
    $n(x$77);
    var t = $m_Lscalacss_internal_Attrs$textDecorationColor$();
    var h = t.Lscalacss_internal_Attrs$textDecorationColor$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$textDecorationLine$();
    var $$x2 = t$1.Lscalacss_internal_Attrs$textDecorationLine$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$textDecorationStyle$();
    var array = [$$x2, t$2.Lscalacss_internal_Attrs$textDecorationStyle$__f_attr];
    var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$4 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$3);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$4)
  }))))
});
$c_Lscalacss_internal_Attrs$.prototype.transition__Lscalacss_internal_Attr = (function() {
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_transitions;
  return $as_Lscalacss_internal_Attr($n($n($$x1).alias__T__Lscalacss_internal_Transform__F1("transition", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))).apply__O__O(new $c_sjsr_AnonFunction1(((x$80$2) => {
    var x$80 = $as_Lscalacss_internal_Attr$AliasB$(x$80$2);
    $n(x$80);
    var h = $m_Lscalacss_internal_Attrs$().transitionProperty__Lscalacss_internal_Attr();
    var t = $m_Lscalacss_internal_Attrs$transitionDuration$();
    var $$x3 = t.Lscalacss_internal_Attrs$transitionDuration$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$transitionTimingFunction$();
    var $$x2 = t$1.Lscalacss_internal_Attrs$transitionTimingFunction$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$transitionDelay$();
    var array = [$$x3, $$x2, t$2.Lscalacss_internal_Attrs$transitionDelay$__f_attr];
    var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$4 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$3);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$4)
  }))))
});
var $d_Lscalacss_internal_Attrs$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$: 0
}, false, "scalacss.internal.Attrs$", {
  Lscalacss_internal_Attrs$: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$.prototype.$classData = $d_Lscalacss_internal_Attrs$;
var $n_Lscalacss_internal_Attrs$;
function $m_Lscalacss_internal_Attrs$() {
  if ((!$n_Lscalacss_internal_Attrs$)) {
    $n_Lscalacss_internal_Attrs$ = new $c_Lscalacss_internal_Attrs$()
  };
  return $n_Lscalacss_internal_Attrs$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$() {
  this.Lscalacss_internal_CanIUse$__f_animation = null;
  this.Lscalacss_internal_CanIUse$__f_borderRadius = null;
  this.Lscalacss_internal_CanIUse$__f_flexbox = null;
  this.Lscalacss_internal_CanIUse$__f_grid = null;
  this.Lscalacss_internal_CanIUse$__f_multicolumn = null;
  this.Lscalacss_internal_CanIUse$__f_outline = null;
  this.Lscalacss_internal_CanIUse$__f_textDecoration = null;
  this.Lscalacss_internal_CanIUse$__f_transitions = null;
  $n_Lscalacss_internal_CanIUse$ = this;
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  this.Lscalacss_internal_CanIUse$__f_animation = this$112.from__sc_IterableOnce__sci_Map(elems$18);
  var this$224 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$18 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$117 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$19 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$19 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19);
  var y$18 = this$117.from__sc_IterableOnce__sci_Set(elems$19);
  var $$x34 = $ct_T2__O__O__(new $c_T2(), self$18, y$18);
  var self$19 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$123 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$20 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$20 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20);
  var y$19 = this$123.from__sc_IterableOnce__sci_Set(elems$20);
  var $$x33 = $ct_T2__O__O__(new $c_T2(), self$19, y$19);
  var self$20 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$129 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$21 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$21 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21);
  var y$20 = this$129.from__sc_IterableOnce__sci_Set(elems$21);
  var $$x32 = $ct_T2__O__O__(new $c_T2(), self$20, y$20);
  var self$21 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$135 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$22 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$22 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22);
  var y$21 = this$135.from__sc_IterableOnce__sci_Set(elems$22);
  var $$x31 = $ct_T2__O__O__(new $c_T2(), self$21, y$21);
  var self$22 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$141 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$23 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$23 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23);
  var y$22 = this$141.from__sc_IterableOnce__sci_Set(elems$23);
  var $$x30 = $ct_T2__O__O__(new $c_T2(), self$22, y$22);
  var self$23 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$147 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$24 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$24 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24);
  var y$23 = this$147.from__sc_IterableOnce__sci_Set(elems$24);
  var $$x29 = $ct_T2__O__O__(new $c_T2(), self$23, y$23);
  var self$24 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$153 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$25 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$25 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25);
  var y$24 = this$153.from__sc_IterableOnce__sci_Set(elems$25);
  var $$x28 = $ct_T2__O__O__(new $c_T2(), self$24, y$24);
  var self$25 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$159 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$26 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$26 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$26);
  var y$25 = this$159.from__sc_IterableOnce__sci_Set(elems$26);
  var $$x27 = $ct_T2__O__O__(new $c_T2(), self$25, y$25);
  var self$26 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$165 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$27 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$27 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$27);
  var y$26 = this$165.from__sc_IterableOnce__sci_Set(elems$27);
  var $$x26 = $ct_T2__O__O__(new $c_T2(), self$26, y$26);
  var self$27 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$171 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$28 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$28 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$28);
  var y$27 = this$171.from__sc_IterableOnce__sci_Set(elems$28);
  var $$x25 = $ct_T2__O__O__(new $c_T2(), self$27, y$27);
  var self$28 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$177 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$29 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$29 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$29);
  var y$28 = this$177.from__sc_IterableOnce__sci_Set(elems$29);
  var $$x24 = $ct_T2__O__O__(new $c_T2(), self$28, y$28);
  var self$29 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$183 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$30 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$30 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$30);
  var y$29 = this$183.from__sc_IterableOnce__sci_Set(elems$30);
  var $$x23 = $ct_T2__O__O__(new $c_T2(), self$29, y$29);
  var self$30 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$189 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$31 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$31 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$31);
  var y$30 = this$189.from__sc_IterableOnce__sci_Set(elems$31);
  var $$x22 = $ct_T2__O__O__(new $c_T2(), self$30, y$30);
  var self$31 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$195 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$32 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$32 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$32);
  var y$31 = this$195.from__sc_IterableOnce__sci_Set(elems$32);
  var $$x21 = $ct_T2__O__O__(new $c_T2(), self$31, y$31);
  var self$32 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$201 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$33 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$33 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$33);
  var y$32 = this$201.from__sc_IterableOnce__sci_Set(elems$33);
  var $$x20 = $ct_T2__O__O__(new $c_T2(), self$32, y$32);
  var self$33 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$207 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$34 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$34 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$34);
  var y$33 = this$207.from__sc_IterableOnce__sci_Set(elems$34);
  var $$x19 = $ct_T2__O__O__(new $c_T2(), self$33, y$33);
  var self$34 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$213 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$35 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$35 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$35);
  var y$34 = this$213.from__sc_IterableOnce__sci_Set(elems$35);
  var $$x18 = $ct_T2__O__O__(new $c_T2(), self$34, y$34);
  var self$35 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$219 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$36 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$36 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$36);
  var y$35 = this$219.from__sc_IterableOnce__sci_Set(elems$36);
  var array$37 = [$$x34, $$x33, $$x32, $$x31, $$x30, $$x29, $$x28, $$x27, $$x26, $$x25, $$x24, $$x23, $$x22, $$x21, $$x20, $$x19, $$x18, $ct_T2__O__O__(new $c_T2(), self$35, y$35)];
  var elems$37 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$37);
  this$224.from__sc_IterableOnce__sci_Map(elems$37);
  var this$336 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$36 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$229 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$38 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$38 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$38);
  var y$36 = this$229.from__sc_IterableOnce__sci_Set(elems$38);
  var $$x51 = $ct_T2__O__O__(new $c_T2(), self$36, y$36);
  var self$37 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$235 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$39 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$39 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$39);
  var y$37 = this$235.from__sc_IterableOnce__sci_Set(elems$39);
  var $$x50 = $ct_T2__O__O__(new $c_T2(), self$37, y$37);
  var self$38 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$241 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$40 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$40 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$40);
  var y$38 = this$241.from__sc_IterableOnce__sci_Set(elems$40);
  var $$x49 = $ct_T2__O__O__(new $c_T2(), self$38, y$38);
  var self$39 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$247 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$41 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$41 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$41);
  var y$39 = this$247.from__sc_IterableOnce__sci_Set(elems$41);
  var $$x48 = $ct_T2__O__O__(new $c_T2(), self$39, y$39);
  var self$40 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$253 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$42 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$42 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$42);
  var y$40 = this$253.from__sc_IterableOnce__sci_Set(elems$42);
  var $$x47 = $ct_T2__O__O__(new $c_T2(), self$40, y$40);
  var self$41 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$259 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$43 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$43 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$43);
  var y$41 = this$259.from__sc_IterableOnce__sci_Set(elems$43);
  var $$x46 = $ct_T2__O__O__(new $c_T2(), self$41, y$41);
  var self$42 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$265 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$44 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$44 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$44);
  var y$42 = this$265.from__sc_IterableOnce__sci_Set(elems$44);
  var $$x45 = $ct_T2__O__O__(new $c_T2(), self$42, y$42);
  var self$43 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$271 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$45 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$45 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$45);
  var y$43 = this$271.from__sc_IterableOnce__sci_Set(elems$45);
  var $$x44 = $ct_T2__O__O__(new $c_T2(), self$43, y$43);
  var self$44 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$277 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$46 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$46 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$46);
  var y$44 = this$277.from__sc_IterableOnce__sci_Set(elems$46);
  var $$x43 = $ct_T2__O__O__(new $c_T2(), self$44, y$44);
  var self$45 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$283 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$47 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$47 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$47);
  var y$45 = this$283.from__sc_IterableOnce__sci_Set(elems$47);
  var $$x42 = $ct_T2__O__O__(new $c_T2(), self$45, y$45);
  var self$46 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$289 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$48 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$48 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$48);
  var y$46 = this$289.from__sc_IterableOnce__sci_Set(elems$48);
  var $$x41 = $ct_T2__O__O__(new $c_T2(), self$46, y$46);
  var self$47 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$295 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$49 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$49 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$49);
  var y$47 = this$295.from__sc_IterableOnce__sci_Set(elems$49);
  var $$x40 = $ct_T2__O__O__(new $c_T2(), self$47, y$47);
  var self$48 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$301 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$50 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$50 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$50);
  var y$48 = this$301.from__sc_IterableOnce__sci_Set(elems$50);
  var $$x39 = $ct_T2__O__O__(new $c_T2(), self$48, y$48);
  var self$49 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$307 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$51 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$51 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$51);
  var y$49 = this$307.from__sc_IterableOnce__sci_Set(elems$51);
  var $$x38 = $ct_T2__O__O__(new $c_T2(), self$49, y$49);
  var self$50 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$313 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$52 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$52 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$52);
  var y$50 = this$313.from__sc_IterableOnce__sci_Set(elems$52);
  var $$x37 = $ct_T2__O__O__(new $c_T2(), self$50, y$50);
  var self$51 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$319 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$53 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$53 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$53);
  var y$51 = this$319.from__sc_IterableOnce__sci_Set(elems$53);
  var $$x36 = $ct_T2__O__O__(new $c_T2(), self$51, y$51);
  var self$52 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$325 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$54 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$54 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$54);
  var y$52 = this$325.from__sc_IterableOnce__sci_Set(elems$54);
  var $$x35 = $ct_T2__O__O__(new $c_T2(), self$52, y$52);
  var self$53 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$331 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$55 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$55 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$55);
  var y$53 = this$331.from__sc_IterableOnce__sci_Set(elems$55);
  var array$56 = [$$x51, $$x50, $$x49, $$x48, $$x47, $$x46, $$x45, $$x44, $$x43, $$x42, $$x41, $$x40, $$x39, $$x38, $$x37, $$x36, $$x35, $ct_T2__O__O__(new $c_T2(), self$53, y$53)];
  var elems$56 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$56);
  this.Lscalacss_internal_CanIUse$__f_borderRadius = this$336.from__sc_IterableOnce__sci_Map(elems$56);
  var this$448 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$54 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$341 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$57 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$57 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$57);
  var y$54 = this$341.from__sc_IterableOnce__sci_Set(elems$57);
  var $$x68 = $ct_T2__O__O__(new $c_T2(), self$54, y$54);
  var self$55 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$347 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$58 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$58 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$58);
  var y$55 = this$347.from__sc_IterableOnce__sci_Set(elems$58);
  var $$x67 = $ct_T2__O__O__(new $c_T2(), self$55, y$55);
  var self$56 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$353 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$59 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$59 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$59);
  var y$56 = this$353.from__sc_IterableOnce__sci_Set(elems$59);
  var $$x66 = $ct_T2__O__O__(new $c_T2(), self$56, y$56);
  var self$57 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$359 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$60 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$60 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$60);
  var y$57 = this$359.from__sc_IterableOnce__sci_Set(elems$60);
  var $$x65 = $ct_T2__O__O__(new $c_T2(), self$57, y$57);
  var self$58 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$365 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$61 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$61 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$61);
  var y$58 = this$365.from__sc_IterableOnce__sci_Set(elems$61);
  var $$x64 = $ct_T2__O__O__(new $c_T2(), self$58, y$58);
  var self$59 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$371 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$62 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$62 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$62);
  var y$59 = this$371.from__sc_IterableOnce__sci_Set(elems$62);
  var $$x63 = $ct_T2__O__O__(new $c_T2(), self$59, y$59);
  var self$60 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$377 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$63 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$63 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$63);
  var y$60 = this$377.from__sc_IterableOnce__sci_Set(elems$63);
  var $$x62 = $ct_T2__O__O__(new $c_T2(), self$60, y$60);
  var self$61 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$383 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$64 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$64 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$64);
  var y$61 = this$383.from__sc_IterableOnce__sci_Set(elems$64);
  var $$x61 = $ct_T2__O__O__(new $c_T2(), self$61, y$61);
  var self$62 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$389 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$65 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$65 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$65);
  var y$62 = this$389.from__sc_IterableOnce__sci_Set(elems$65);
  var $$x60 = $ct_T2__O__O__(new $c_T2(), self$62, y$62);
  var self$63 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$395 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$66 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$66 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$66);
  var y$63 = this$395.from__sc_IterableOnce__sci_Set(elems$66);
  var $$x59 = $ct_T2__O__O__(new $c_T2(), self$63, y$63);
  var self$64 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$401 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$67 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$67 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$67);
  var y$64 = this$401.from__sc_IterableOnce__sci_Set(elems$67);
  var $$x58 = $ct_T2__O__O__(new $c_T2(), self$64, y$64);
  var self$65 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$407 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$68 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$68 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$68);
  var y$65 = this$407.from__sc_IterableOnce__sci_Set(elems$68);
  var $$x57 = $ct_T2__O__O__(new $c_T2(), self$65, y$65);
  var self$66 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$413 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$69 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$69 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$69);
  var y$66 = this$413.from__sc_IterableOnce__sci_Set(elems$69);
  var $$x56 = $ct_T2__O__O__(new $c_T2(), self$66, y$66);
  var self$67 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$419 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$70 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$70 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$70);
  var y$67 = this$419.from__sc_IterableOnce__sci_Set(elems$70);
  var $$x55 = $ct_T2__O__O__(new $c_T2(), self$67, y$67);
  var self$68 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$425 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$71 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$71 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$71);
  var y$68 = this$425.from__sc_IterableOnce__sci_Set(elems$71);
  var $$x54 = $ct_T2__O__O__(new $c_T2(), self$68, y$68);
  var self$69 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$431 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$72 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$72 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$72);
  var y$69 = this$431.from__sc_IterableOnce__sci_Set(elems$72);
  var $$x53 = $ct_T2__O__O__(new $c_T2(), self$69, y$69);
  var self$70 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$437 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$73 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$73 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$73);
  var y$70 = this$437.from__sc_IterableOnce__sci_Set(elems$73);
  var $$x52 = $ct_T2__O__O__(new $c_T2(), self$70, y$70);
  var self$71 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$443 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$74 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$74 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$74);
  var y$71 = this$443.from__sc_IterableOnce__sci_Set(elems$74);
  var array$75 = [$$x68, $$x67, $$x66, $$x65, $$x64, $$x63, $$x62, $$x61, $$x60, $$x59, $$x58, $$x57, $$x56, $$x55, $$x54, $$x53, $$x52, $ct_T2__O__O__(new $c_T2(), self$71, y$71)];
  var elems$75 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$75);
  this$448.from__sc_IterableOnce__sci_Map(elems$75);
  var this$560 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$72 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$453 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$76 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$76 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$76);
  var y$72 = this$453.from__sc_IterableOnce__sci_Set(elems$76);
  var $$x85 = $ct_T2__O__O__(new $c_T2(), self$72, y$72);
  var self$73 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$459 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$77 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$77 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$77);
  var y$73 = this$459.from__sc_IterableOnce__sci_Set(elems$77);
  var $$x84 = $ct_T2__O__O__(new $c_T2(), self$73, y$73);
  var self$74 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$465 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$78 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$78 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$78);
  var y$74 = this$465.from__sc_IterableOnce__sci_Set(elems$78);
  var $$x83 = $ct_T2__O__O__(new $c_T2(), self$74, y$74);
  var self$75 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$471 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$79 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$79 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$79);
  var y$75 = this$471.from__sc_IterableOnce__sci_Set(elems$79);
  var $$x82 = $ct_T2__O__O__(new $c_T2(), self$75, y$75);
  var self$76 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$477 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$80 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$80 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$80);
  var y$76 = this$477.from__sc_IterableOnce__sci_Set(elems$80);
  var $$x81 = $ct_T2__O__O__(new $c_T2(), self$76, y$76);
  var self$77 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$483 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$81 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$81 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$81);
  var y$77 = this$483.from__sc_IterableOnce__sci_Set(elems$81);
  var $$x80 = $ct_T2__O__O__(new $c_T2(), self$77, y$77);
  var self$78 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$489 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$82 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$82 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$82);
  var y$78 = this$489.from__sc_IterableOnce__sci_Set(elems$82);
  var $$x79 = $ct_T2__O__O__(new $c_T2(), self$78, y$78);
  var self$79 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$495 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$83 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$83 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$83);
  var y$79 = this$495.from__sc_IterableOnce__sci_Set(elems$83);
  var $$x78 = $ct_T2__O__O__(new $c_T2(), self$79, y$79);
  var self$80 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$501 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$84 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$84 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$84);
  var y$80 = this$501.from__sc_IterableOnce__sci_Set(elems$84);
  var $$x77 = $ct_T2__O__O__(new $c_T2(), self$80, y$80);
  var self$81 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$507 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$85 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$85 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$85);
  var y$81 = this$507.from__sc_IterableOnce__sci_Set(elems$85);
  var $$x76 = $ct_T2__O__O__(new $c_T2(), self$81, y$81);
  var self$82 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$513 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$86 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$86 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$86);
  var y$82 = this$513.from__sc_IterableOnce__sci_Set(elems$86);
  var $$x75 = $ct_T2__O__O__(new $c_T2(), self$82, y$82);
  var self$83 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$519 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$87 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$87 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$87);
  var y$83 = this$519.from__sc_IterableOnce__sci_Set(elems$87);
  var $$x74 = $ct_T2__O__O__(new $c_T2(), self$83, y$83);
  var self$84 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$525 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$88 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$88 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$88);
  var y$84 = this$525.from__sc_IterableOnce__sci_Set(elems$88);
  var $$x73 = $ct_T2__O__O__(new $c_T2(), self$84, y$84);
  var self$85 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$531 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$89 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$89 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$89);
  var y$85 = this$531.from__sc_IterableOnce__sci_Set(elems$89);
  var $$x72 = $ct_T2__O__O__(new $c_T2(), self$85, y$85);
  var self$86 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$537 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$90 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$90 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$90);
  var y$86 = this$537.from__sc_IterableOnce__sci_Set(elems$90);
  var $$x71 = $ct_T2__O__O__(new $c_T2(), self$86, y$86);
  var self$87 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$543 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$91 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$91 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$91);
  var y$87 = this$543.from__sc_IterableOnce__sci_Set(elems$91);
  var $$x70 = $ct_T2__O__O__(new $c_T2(), self$87, y$87);
  var self$88 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$549 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$92 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$92 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$92);
  var y$88 = this$549.from__sc_IterableOnce__sci_Set(elems$92);
  var $$x69 = $ct_T2__O__O__(new $c_T2(), self$88, y$88);
  var self$89 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$555 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$93 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$93 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$93);
  var y$89 = this$555.from__sc_IterableOnce__sci_Set(elems$93);
  var array$94 = [$$x85, $$x84, $$x83, $$x82, $$x81, $$x80, $$x79, $$x78, $$x77, $$x76, $$x75, $$x74, $$x73, $$x72, $$x71, $$x70, $$x69, $ct_T2__O__O__(new $c_T2(), self$89, y$89)];
  var elems$94 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$94);
  this.Lscalacss_internal_CanIUse$__f_flexbox = this$560.from__sc_IterableOnce__sci_Map(elems$94);
  var this$672 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$90 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$565 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$95 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$95 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$95);
  var y$90 = this$565.from__sc_IterableOnce__sci_Set(elems$95);
  var $$x102 = $ct_T2__O__O__(new $c_T2(), self$90, y$90);
  var self$91 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$571 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$96 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$96 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$96);
  var y$91 = this$571.from__sc_IterableOnce__sci_Set(elems$96);
  var $$x101 = $ct_T2__O__O__(new $c_T2(), self$91, y$91);
  var self$92 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$577 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$97 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$97 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$97);
  var y$92 = this$577.from__sc_IterableOnce__sci_Set(elems$97);
  var $$x100 = $ct_T2__O__O__(new $c_T2(), self$92, y$92);
  var self$93 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$583 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$98 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$98 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$98);
  var y$93 = this$583.from__sc_IterableOnce__sci_Set(elems$98);
  var $$x99 = $ct_T2__O__O__(new $c_T2(), self$93, y$93);
  var self$94 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$589 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$99 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$99 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$99);
  var y$94 = this$589.from__sc_IterableOnce__sci_Set(elems$99);
  var $$x98 = $ct_T2__O__O__(new $c_T2(), self$94, y$94);
  var self$95 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$595 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$100 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$100 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$100);
  var y$95 = this$595.from__sc_IterableOnce__sci_Set(elems$100);
  var $$x97 = $ct_T2__O__O__(new $c_T2(), self$95, y$95);
  var self$96 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$601 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$101 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$101 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$101);
  var y$96 = this$601.from__sc_IterableOnce__sci_Set(elems$101);
  var $$x96 = $ct_T2__O__O__(new $c_T2(), self$96, y$96);
  var self$97 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$607 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$102 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$102 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$102);
  var y$97 = this$607.from__sc_IterableOnce__sci_Set(elems$102);
  var $$x95 = $ct_T2__O__O__(new $c_T2(), self$97, y$97);
  var self$98 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$613 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$103 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$103 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$103);
  var y$98 = this$613.from__sc_IterableOnce__sci_Set(elems$103);
  var $$x94 = $ct_T2__O__O__(new $c_T2(), self$98, y$98);
  var self$99 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$619 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$104 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$104 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$104);
  var y$99 = this$619.from__sc_IterableOnce__sci_Set(elems$104);
  var $$x93 = $ct_T2__O__O__(new $c_T2(), self$99, y$99);
  var self$100 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$625 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$105 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$105 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$105);
  var y$100 = this$625.from__sc_IterableOnce__sci_Set(elems$105);
  var $$x92 = $ct_T2__O__O__(new $c_T2(), self$100, y$100);
  var self$101 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$631 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$106 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$106 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$106);
  var y$101 = this$631.from__sc_IterableOnce__sci_Set(elems$106);
  var $$x91 = $ct_T2__O__O__(new $c_T2(), self$101, y$101);
  var self$102 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$637 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$107 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$107 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$107);
  var y$102 = this$637.from__sc_IterableOnce__sci_Set(elems$107);
  var $$x90 = $ct_T2__O__O__(new $c_T2(), self$102, y$102);
  var self$103 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$643 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$108 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$108 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$108);
  var y$103 = this$643.from__sc_IterableOnce__sci_Set(elems$108);
  var $$x89 = $ct_T2__O__O__(new $c_T2(), self$103, y$103);
  var self$104 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$649 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$109 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$109 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$109);
  var y$104 = this$649.from__sc_IterableOnce__sci_Set(elems$109);
  var $$x88 = $ct_T2__O__O__(new $c_T2(), self$104, y$104);
  var self$105 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$655 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$110 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$110 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$110);
  var y$105 = this$655.from__sc_IterableOnce__sci_Set(elems$110);
  var $$x87 = $ct_T2__O__O__(new $c_T2(), self$105, y$105);
  var self$106 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$661 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$111 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$111 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$111);
  var y$106 = this$661.from__sc_IterableOnce__sci_Set(elems$111);
  var $$x86 = $ct_T2__O__O__(new $c_T2(), self$106, y$106);
  var self$107 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$667 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$112 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$112 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$112);
  var y$107 = this$667.from__sc_IterableOnce__sci_Set(elems$112);
  var array$113 = [$$x102, $$x101, $$x100, $$x99, $$x98, $$x97, $$x96, $$x95, $$x94, $$x93, $$x92, $$x91, $$x90, $$x89, $$x88, $$x87, $$x86, $ct_T2__O__O__(new $c_T2(), self$107, y$107)];
  var elems$113 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$113);
  this.Lscalacss_internal_CanIUse$__f_grid = this$672.from__sc_IterableOnce__sci_Map(elems$113);
  var this$784 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$108 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$677 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$114 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$114 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$114);
  var y$108 = this$677.from__sc_IterableOnce__sci_Set(elems$114);
  var $$x119 = $ct_T2__O__O__(new $c_T2(), self$108, y$108);
  var self$109 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$683 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$115 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$115 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$115);
  var y$109 = this$683.from__sc_IterableOnce__sci_Set(elems$115);
  var $$x118 = $ct_T2__O__O__(new $c_T2(), self$109, y$109);
  var self$110 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$689 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$116 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$116 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$116);
  var y$110 = this$689.from__sc_IterableOnce__sci_Set(elems$116);
  var $$x117 = $ct_T2__O__O__(new $c_T2(), self$110, y$110);
  var self$111 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$695 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$117 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$117 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$117);
  var y$111 = this$695.from__sc_IterableOnce__sci_Set(elems$117);
  var $$x116 = $ct_T2__O__O__(new $c_T2(), self$111, y$111);
  var self$112 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$701 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$118 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$118 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$118);
  var y$112 = this$701.from__sc_IterableOnce__sci_Set(elems$118);
  var $$x115 = $ct_T2__O__O__(new $c_T2(), self$112, y$112);
  var self$113 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$707 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$119 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$119 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$119);
  var y$113 = this$707.from__sc_IterableOnce__sci_Set(elems$119);
  var $$x114 = $ct_T2__O__O__(new $c_T2(), self$113, y$113);
  var self$114 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$713 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$120 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$120 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$120);
  var y$114 = this$713.from__sc_IterableOnce__sci_Set(elems$120);
  var $$x113 = $ct_T2__O__O__(new $c_T2(), self$114, y$114);
  var self$115 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$719 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$121 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$121 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$121);
  var y$115 = this$719.from__sc_IterableOnce__sci_Set(elems$121);
  var $$x112 = $ct_T2__O__O__(new $c_T2(), self$115, y$115);
  var self$116 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$725 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$122 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$122 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$122);
  var y$116 = this$725.from__sc_IterableOnce__sci_Set(elems$122);
  var $$x111 = $ct_T2__O__O__(new $c_T2(), self$116, y$116);
  var self$117 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$731 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$123 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$123 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$123);
  var y$117 = this$731.from__sc_IterableOnce__sci_Set(elems$123);
  var $$x110 = $ct_T2__O__O__(new $c_T2(), self$117, y$117);
  var self$118 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$737 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$124 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$124 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$124);
  var y$118 = this$737.from__sc_IterableOnce__sci_Set(elems$124);
  var $$x109 = $ct_T2__O__O__(new $c_T2(), self$118, y$118);
  var self$119 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$743 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$125 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$125 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$125);
  var y$119 = this$743.from__sc_IterableOnce__sci_Set(elems$125);
  var $$x108 = $ct_T2__O__O__(new $c_T2(), self$119, y$119);
  var self$120 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$749 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$126 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$126 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$126);
  var y$120 = this$749.from__sc_IterableOnce__sci_Set(elems$126);
  var $$x107 = $ct_T2__O__O__(new $c_T2(), self$120, y$120);
  var self$121 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$755 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$127 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$127 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$127);
  var y$121 = this$755.from__sc_IterableOnce__sci_Set(elems$127);
  var $$x106 = $ct_T2__O__O__(new $c_T2(), self$121, y$121);
  var self$122 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$761 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$128 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$128 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$128);
  var y$122 = this$761.from__sc_IterableOnce__sci_Set(elems$128);
  var $$x105 = $ct_T2__O__O__(new $c_T2(), self$122, y$122);
  var self$123 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$767 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$129 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$129 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$129);
  var y$123 = this$767.from__sc_IterableOnce__sci_Set(elems$129);
  var $$x104 = $ct_T2__O__O__(new $c_T2(), self$123, y$123);
  var self$124 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$773 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$130 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$130 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$130);
  var y$124 = this$773.from__sc_IterableOnce__sci_Set(elems$130);
  var $$x103 = $ct_T2__O__O__(new $c_T2(), self$124, y$124);
  var self$125 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$779 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$131 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$131 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$131);
  var y$125 = this$779.from__sc_IterableOnce__sci_Set(elems$131);
  var array$132 = [$$x119, $$x118, $$x117, $$x116, $$x115, $$x114, $$x113, $$x112, $$x111, $$x110, $$x109, $$x108, $$x107, $$x106, $$x105, $$x104, $$x103, $ct_T2__O__O__(new $c_T2(), self$125, y$125)];
  var elems$132 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$132);
  this$784.from__sc_IterableOnce__sci_Map(elems$132);
  var this$896 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$126 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$789 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$133 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$133 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$133);
  var y$126 = this$789.from__sc_IterableOnce__sci_Set(elems$133);
  var $$x136 = $ct_T2__O__O__(new $c_T2(), self$126, y$126);
  var self$127 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$795 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$134 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$134 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$134);
  var y$127 = this$795.from__sc_IterableOnce__sci_Set(elems$134);
  var $$x135 = $ct_T2__O__O__(new $c_T2(), self$127, y$127);
  var self$128 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$801 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$135 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$135 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$135);
  var y$128 = this$801.from__sc_IterableOnce__sci_Set(elems$135);
  var $$x134 = $ct_T2__O__O__(new $c_T2(), self$128, y$128);
  var self$129 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$807 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$136 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$136 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$136);
  var y$129 = this$807.from__sc_IterableOnce__sci_Set(elems$136);
  var $$x133 = $ct_T2__O__O__(new $c_T2(), self$129, y$129);
  var self$130 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$813 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$137 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$137 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$137);
  var y$130 = this$813.from__sc_IterableOnce__sci_Set(elems$137);
  var $$x132 = $ct_T2__O__O__(new $c_T2(), self$130, y$130);
  var self$131 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$819 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$138 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$138 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$138);
  var y$131 = this$819.from__sc_IterableOnce__sci_Set(elems$138);
  var $$x131 = $ct_T2__O__O__(new $c_T2(), self$131, y$131);
  var self$132 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$825 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$139 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$139 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$139);
  var y$132 = this$825.from__sc_IterableOnce__sci_Set(elems$139);
  var $$x130 = $ct_T2__O__O__(new $c_T2(), self$132, y$132);
  var self$133 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$831 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$140 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$140 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$140);
  var y$133 = this$831.from__sc_IterableOnce__sci_Set(elems$140);
  var $$x129 = $ct_T2__O__O__(new $c_T2(), self$133, y$133);
  var self$134 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$837 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$141 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$141 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$141);
  var y$134 = this$837.from__sc_IterableOnce__sci_Set(elems$141);
  var $$x128 = $ct_T2__O__O__(new $c_T2(), self$134, y$134);
  var self$135 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$843 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$142 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$142 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$142);
  var y$135 = this$843.from__sc_IterableOnce__sci_Set(elems$142);
  var $$x127 = $ct_T2__O__O__(new $c_T2(), self$135, y$135);
  var self$136 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$849 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$143 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$143 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$143);
  var y$136 = this$849.from__sc_IterableOnce__sci_Set(elems$143);
  var $$x126 = $ct_T2__O__O__(new $c_T2(), self$136, y$136);
  var self$137 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$855 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$144 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$144 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$144);
  var y$137 = this$855.from__sc_IterableOnce__sci_Set(elems$144);
  var $$x125 = $ct_T2__O__O__(new $c_T2(), self$137, y$137);
  var self$138 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$861 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$145 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$145 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$145);
  var y$138 = this$861.from__sc_IterableOnce__sci_Set(elems$145);
  var $$x124 = $ct_T2__O__O__(new $c_T2(), self$138, y$138);
  var self$139 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$867 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$146 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$146 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$146);
  var y$139 = this$867.from__sc_IterableOnce__sci_Set(elems$146);
  var $$x123 = $ct_T2__O__O__(new $c_T2(), self$139, y$139);
  var self$140 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$873 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$147 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$147 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$147);
  var y$140 = this$873.from__sc_IterableOnce__sci_Set(elems$147);
  var $$x122 = $ct_T2__O__O__(new $c_T2(), self$140, y$140);
  var self$141 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$879 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$148 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$148 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$148);
  var y$141 = this$879.from__sc_IterableOnce__sci_Set(elems$148);
  var $$x121 = $ct_T2__O__O__(new $c_T2(), self$141, y$141);
  var self$142 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$885 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$149 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$149 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$149);
  var y$142 = this$885.from__sc_IterableOnce__sci_Set(elems$149);
  var $$x120 = $ct_T2__O__O__(new $c_T2(), self$142, y$142);
  var self$143 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$891 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$150 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$150 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$150);
  var y$143 = this$891.from__sc_IterableOnce__sci_Set(elems$150);
  var array$151 = [$$x136, $$x135, $$x134, $$x133, $$x132, $$x131, $$x130, $$x129, $$x128, $$x127, $$x126, $$x125, $$x124, $$x123, $$x122, $$x121, $$x120, $ct_T2__O__O__(new $c_T2(), self$143, y$143)];
  var elems$151 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$151);
  this.Lscalacss_internal_CanIUse$__f_multicolumn = this$896.from__sc_IterableOnce__sci_Map(elems$151);
  var this$1008 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$144 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$901 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$152 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$152 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$152);
  var y$144 = this$901.from__sc_IterableOnce__sci_Set(elems$152);
  var $$x153 = $ct_T2__O__O__(new $c_T2(), self$144, y$144);
  var self$145 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$907 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$153 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$153 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$153);
  var y$145 = this$907.from__sc_IterableOnce__sci_Set(elems$153);
  var $$x152 = $ct_T2__O__O__(new $c_T2(), self$145, y$145);
  var self$146 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$913 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$154 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$154 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$154);
  var y$146 = this$913.from__sc_IterableOnce__sci_Set(elems$154);
  var $$x151 = $ct_T2__O__O__(new $c_T2(), self$146, y$146);
  var self$147 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$919 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$155 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$155 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$155);
  var y$147 = this$919.from__sc_IterableOnce__sci_Set(elems$155);
  var $$x150 = $ct_T2__O__O__(new $c_T2(), self$147, y$147);
  var self$148 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$925 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$156 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$156 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$156);
  var y$148 = this$925.from__sc_IterableOnce__sci_Set(elems$156);
  var $$x149 = $ct_T2__O__O__(new $c_T2(), self$148, y$148);
  var self$149 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$931 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$157 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$157 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$157);
  var y$149 = this$931.from__sc_IterableOnce__sci_Set(elems$157);
  var $$x148 = $ct_T2__O__O__(new $c_T2(), self$149, y$149);
  var self$150 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$937 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$158 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$158 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$158);
  var y$150 = this$937.from__sc_IterableOnce__sci_Set(elems$158);
  var $$x147 = $ct_T2__O__O__(new $c_T2(), self$150, y$150);
  var self$151 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$943 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$159 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$159 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$159);
  var y$151 = this$943.from__sc_IterableOnce__sci_Set(elems$159);
  var $$x146 = $ct_T2__O__O__(new $c_T2(), self$151, y$151);
  var self$152 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$949 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$160 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$160 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$160);
  var y$152 = this$949.from__sc_IterableOnce__sci_Set(elems$160);
  var $$x145 = $ct_T2__O__O__(new $c_T2(), self$152, y$152);
  var self$153 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$955 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$161 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$161 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$161);
  var y$153 = this$955.from__sc_IterableOnce__sci_Set(elems$161);
  var $$x144 = $ct_T2__O__O__(new $c_T2(), self$153, y$153);
  var self$154 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$961 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$162 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$162 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$162);
  var y$154 = this$961.from__sc_IterableOnce__sci_Set(elems$162);
  var $$x143 = $ct_T2__O__O__(new $c_T2(), self$154, y$154);
  var self$155 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$967 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$163 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$163 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$163);
  var y$155 = this$967.from__sc_IterableOnce__sci_Set(elems$163);
  var $$x142 = $ct_T2__O__O__(new $c_T2(), self$155, y$155);
  var self$156 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$973 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$164 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$164 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$164);
  var y$156 = this$973.from__sc_IterableOnce__sci_Set(elems$164);
  var $$x141 = $ct_T2__O__O__(new $c_T2(), self$156, y$156);
  var self$157 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$979 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$165 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$165 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$165);
  var y$157 = this$979.from__sc_IterableOnce__sci_Set(elems$165);
  var $$x140 = $ct_T2__O__O__(new $c_T2(), self$157, y$157);
  var self$158 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$985 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$166 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$166 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$166);
  var y$158 = this$985.from__sc_IterableOnce__sci_Set(elems$166);
  var $$x139 = $ct_T2__O__O__(new $c_T2(), self$158, y$158);
  var self$159 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$991 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$167 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$167 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$167);
  var y$159 = this$991.from__sc_IterableOnce__sci_Set(elems$167);
  var $$x138 = $ct_T2__O__O__(new $c_T2(), self$159, y$159);
  var self$160 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$997 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$168 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$168 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$168);
  var y$160 = this$997.from__sc_IterableOnce__sci_Set(elems$168);
  var $$x137 = $ct_T2__O__O__(new $c_T2(), self$160, y$160);
  var self$161 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$1003 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$169 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$169 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$169);
  var y$161 = this$1003.from__sc_IterableOnce__sci_Set(elems$169);
  var array$170 = [$$x153, $$x152, $$x151, $$x150, $$x149, $$x148, $$x147, $$x146, $$x145, $$x144, $$x143, $$x142, $$x141, $$x140, $$x139, $$x138, $$x137, $ct_T2__O__O__(new $c_T2(), self$161, y$161)];
  var elems$170 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$170);
  this.Lscalacss_internal_CanIUse$__f_outline = this$1008.from__sc_IterableOnce__sci_Map(elems$170);
  var this$1120 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$162 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$1013 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$171 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$171 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$171);
  var y$162 = this$1013.from__sc_IterableOnce__sci_Set(elems$171);
  var $$x170 = $ct_T2__O__O__(new $c_T2(), self$162, y$162);
  var self$163 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$1019 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$172 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$172 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$172);
  var y$163 = this$1019.from__sc_IterableOnce__sci_Set(elems$172);
  var $$x169 = $ct_T2__O__O__(new $c_T2(), self$163, y$163);
  var self$164 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$1025 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$173 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$173 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$173);
  var y$164 = this$1025.from__sc_IterableOnce__sci_Set(elems$173);
  var $$x168 = $ct_T2__O__O__(new $c_T2(), self$164, y$164);
  var self$165 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$1031 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$174 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$174 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$174);
  var y$165 = this$1031.from__sc_IterableOnce__sci_Set(elems$174);
  var $$x167 = $ct_T2__O__O__(new $c_T2(), self$165, y$165);
  var self$166 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$1037 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$175 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$175 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$175);
  var y$166 = this$1037.from__sc_IterableOnce__sci_Set(elems$175);
  var $$x166 = $ct_T2__O__O__(new $c_T2(), self$166, y$166);
  var self$167 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$1043 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$176 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$176 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$176);
  var y$167 = this$1043.from__sc_IterableOnce__sci_Set(elems$176);
  var $$x165 = $ct_T2__O__O__(new $c_T2(), self$167, y$167);
  var self$168 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$1049 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$177 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$177 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$177);
  var y$168 = this$1049.from__sc_IterableOnce__sci_Set(elems$177);
  var $$x164 = $ct_T2__O__O__(new $c_T2(), self$168, y$168);
  var self$169 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$1055 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$178 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$178 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$178);
  var y$169 = this$1055.from__sc_IterableOnce__sci_Set(elems$178);
  var $$x163 = $ct_T2__O__O__(new $c_T2(), self$169, y$169);
  var self$170 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$1061 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$179 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$179 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$179);
  var y$170 = this$1061.from__sc_IterableOnce__sci_Set(elems$179);
  var $$x162 = $ct_T2__O__O__(new $c_T2(), self$170, y$170);
  var self$171 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$1067 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$180 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$180 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$180);
  var y$171 = this$1067.from__sc_IterableOnce__sci_Set(elems$180);
  var $$x161 = $ct_T2__O__O__(new $c_T2(), self$171, y$171);
  var self$172 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$1073 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$181 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$181 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$181);
  var y$172 = this$1073.from__sc_IterableOnce__sci_Set(elems$181);
  var $$x160 = $ct_T2__O__O__(new $c_T2(), self$172, y$172);
  var self$173 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$1079 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$182 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$182 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$182);
  var y$173 = this$1079.from__sc_IterableOnce__sci_Set(elems$182);
  var $$x159 = $ct_T2__O__O__(new $c_T2(), self$173, y$173);
  var self$174 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$1085 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$183 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$183 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$183);
  var y$174 = this$1085.from__sc_IterableOnce__sci_Set(elems$183);
  var $$x158 = $ct_T2__O__O__(new $c_T2(), self$174, y$174);
  var self$175 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$1091 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$184 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$184 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$184);
  var y$175 = this$1091.from__sc_IterableOnce__sci_Set(elems$184);
  var $$x157 = $ct_T2__O__O__(new $c_T2(), self$175, y$175);
  var self$176 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$1097 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$185 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$185 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$185);
  var y$176 = this$1097.from__sc_IterableOnce__sci_Set(elems$185);
  var $$x156 = $ct_T2__O__O__(new $c_T2(), self$176, y$176);
  var self$177 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$1103 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$186 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$186 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$186);
  var y$177 = this$1103.from__sc_IterableOnce__sci_Set(elems$186);
  var $$x155 = $ct_T2__O__O__(new $c_T2(), self$177, y$177);
  var self$178 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$1109 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$187 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$187 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$187);
  var y$178 = this$1109.from__sc_IterableOnce__sci_Set(elems$187);
  var $$x154 = $ct_T2__O__O__(new $c_T2(), self$178, y$178);
  var self$179 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$1115 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$188 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$188 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$188);
  var y$179 = this$1115.from__sc_IterableOnce__sci_Set(elems$188);
  var array$189 = [$$x170, $$x169, $$x168, $$x167, $$x166, $$x165, $$x164, $$x163, $$x162, $$x161, $$x160, $$x159, $$x158, $$x157, $$x156, $$x155, $$x154, $ct_T2__O__O__(new $c_T2(), self$179, y$179)];
  var elems$189 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$189);
  this$1120.from__sc_IterableOnce__sci_Map(elems$189);
  var this$1232 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$180 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$1125 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$190 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$190 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$190);
  var y$180 = this$1125.from__sc_IterableOnce__sci_Set(elems$190);
  var $$x187 = $ct_T2__O__O__(new $c_T2(), self$180, y$180);
  var self$181 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$1131 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$191 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$191 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$191);
  var y$181 = this$1131.from__sc_IterableOnce__sci_Set(elems$191);
  var $$x186 = $ct_T2__O__O__(new $c_T2(), self$181, y$181);
  var self$182 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$1137 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$192 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$192 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$192);
  var y$182 = this$1137.from__sc_IterableOnce__sci_Set(elems$192);
  var $$x185 = $ct_T2__O__O__(new $c_T2(), self$182, y$182);
  var self$183 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$1143 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$193 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$193 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$193);
  var y$183 = this$1143.from__sc_IterableOnce__sci_Set(elems$193);
  var $$x184 = $ct_T2__O__O__(new $c_T2(), self$183, y$183);
  var self$184 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$1149 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$194 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$194 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$194);
  var y$184 = this$1149.from__sc_IterableOnce__sci_Set(elems$194);
  var $$x183 = $ct_T2__O__O__(new $c_T2(), self$184, y$184);
  var self$185 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$1155 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$195 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$195 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$195);
  var y$185 = this$1155.from__sc_IterableOnce__sci_Set(elems$195);
  var $$x182 = $ct_T2__O__O__(new $c_T2(), self$185, y$185);
  var self$186 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$1161 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$196 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$196 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$196);
  var y$186 = this$1161.from__sc_IterableOnce__sci_Set(elems$196);
  var $$x181 = $ct_T2__O__O__(new $c_T2(), self$186, y$186);
  var self$187 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$1167 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$197 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$197 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$197);
  var y$187 = this$1167.from__sc_IterableOnce__sci_Set(elems$197);
  var $$x180 = $ct_T2__O__O__(new $c_T2(), self$187, y$187);
  var self$188 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$1173 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$198 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$198 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$198);
  var y$188 = this$1173.from__sc_IterableOnce__sci_Set(elems$198);
  var $$x179 = $ct_T2__O__O__(new $c_T2(), self$188, y$188);
  var self$189 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$1179 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$199 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$199 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$199);
  var y$189 = this$1179.from__sc_IterableOnce__sci_Set(elems$199);
  var $$x178 = $ct_T2__O__O__(new $c_T2(), self$189, y$189);
  var self$190 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$1185 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$200 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$200 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$200);
  var y$190 = this$1185.from__sc_IterableOnce__sci_Set(elems$200);
  var $$x177 = $ct_T2__O__O__(new $c_T2(), self$190, y$190);
  var self$191 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$1191 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$201 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$201 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$201);
  var y$191 = this$1191.from__sc_IterableOnce__sci_Set(elems$201);
  var $$x176 = $ct_T2__O__O__(new $c_T2(), self$191, y$191);
  var self$192 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$1197 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$202 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$202 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$202);
  var y$192 = this$1197.from__sc_IterableOnce__sci_Set(elems$202);
  var $$x175 = $ct_T2__O__O__(new $c_T2(), self$192, y$192);
  var self$193 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$1203 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$203 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$203 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$203);
  var y$193 = this$1203.from__sc_IterableOnce__sci_Set(elems$203);
  var $$x174 = $ct_T2__O__O__(new $c_T2(), self$193, y$193);
  var self$194 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$1209 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$204 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$204 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$204);
  var y$194 = this$1209.from__sc_IterableOnce__sci_Set(elems$204);
  var $$x173 = $ct_T2__O__O__(new $c_T2(), self$194, y$194);
  var self$195 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$1215 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$205 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$205 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$205);
  var y$195 = this$1215.from__sc_IterableOnce__sci_Set(elems$205);
  var $$x172 = $ct_T2__O__O__(new $c_T2(), self$195, y$195);
  var self$196 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$1221 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$206 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$206 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$206);
  var y$196 = this$1221.from__sc_IterableOnce__sci_Set(elems$206);
  var $$x171 = $ct_T2__O__O__(new $c_T2(), self$196, y$196);
  var self$197 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$1227 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$207 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$207 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$207);
  var y$197 = this$1227.from__sc_IterableOnce__sci_Set(elems$207);
  var array$208 = [$$x187, $$x186, $$x185, $$x184, $$x183, $$x182, $$x181, $$x180, $$x179, $$x178, $$x177, $$x176, $$x175, $$x174, $$x173, $$x172, $$x171, $ct_T2__O__O__(new $c_T2(), self$197, y$197)];
  var elems$208 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$208);
  this.Lscalacss_internal_CanIUse$__f_textDecoration = this$1232.from__sc_IterableOnce__sci_Map(elems$208);
  var this$1344 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$198 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$1237 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$209 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$209 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$209);
  var y$198 = this$1237.from__sc_IterableOnce__sci_Set(elems$209);
  var $$x204 = $ct_T2__O__O__(new $c_T2(), self$198, y$198);
  var self$199 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$1243 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$210 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$210 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$210);
  var y$199 = this$1243.from__sc_IterableOnce__sci_Set(elems$210);
  var $$x203 = $ct_T2__O__O__(new $c_T2(), self$199, y$199);
  var self$200 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$1249 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$211 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$211 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$211);
  var y$200 = this$1249.from__sc_IterableOnce__sci_Set(elems$211);
  var $$x202 = $ct_T2__O__O__(new $c_T2(), self$200, y$200);
  var self$201 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$1255 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$212 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$212 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$212);
  var y$201 = this$1255.from__sc_IterableOnce__sci_Set(elems$212);
  var $$x201 = $ct_T2__O__O__(new $c_T2(), self$201, y$201);
  var self$202 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$1261 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$213 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$213 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$213);
  var y$202 = this$1261.from__sc_IterableOnce__sci_Set(elems$213);
  var $$x200 = $ct_T2__O__O__(new $c_T2(), self$202, y$202);
  var self$203 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$1267 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$214 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$214 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$214);
  var y$203 = this$1267.from__sc_IterableOnce__sci_Set(elems$214);
  var $$x199 = $ct_T2__O__O__(new $c_T2(), self$203, y$203);
  var self$204 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$1273 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$215 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$215 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$215);
  var y$204 = this$1273.from__sc_IterableOnce__sci_Set(elems$215);
  var $$x198 = $ct_T2__O__O__(new $c_T2(), self$204, y$204);
  var self$205 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$1279 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$216 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$216 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$216);
  var y$205 = this$1279.from__sc_IterableOnce__sci_Set(elems$216);
  var $$x197 = $ct_T2__O__O__(new $c_T2(), self$205, y$205);
  var self$206 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$1285 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$217 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$217 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$217);
  var y$206 = this$1285.from__sc_IterableOnce__sci_Set(elems$217);
  var $$x196 = $ct_T2__O__O__(new $c_T2(), self$206, y$206);
  var self$207 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$1291 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$218 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$218 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$218);
  var y$207 = this$1291.from__sc_IterableOnce__sci_Set(elems$218);
  var $$x195 = $ct_T2__O__O__(new $c_T2(), self$207, y$207);
  var self$208 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$1297 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$219 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$219 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$219);
  var y$208 = this$1297.from__sc_IterableOnce__sci_Set(elems$219);
  var $$x194 = $ct_T2__O__O__(new $c_T2(), self$208, y$208);
  var self$209 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$1303 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$220 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$220 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$220);
  var y$209 = this$1303.from__sc_IterableOnce__sci_Set(elems$220);
  var $$x193 = $ct_T2__O__O__(new $c_T2(), self$209, y$209);
  var self$210 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$1309 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$221 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$221 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$221);
  var y$210 = this$1309.from__sc_IterableOnce__sci_Set(elems$221);
  var $$x192 = $ct_T2__O__O__(new $c_T2(), self$210, y$210);
  var self$211 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$1315 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$222 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$222 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$222);
  var y$211 = this$1315.from__sc_IterableOnce__sci_Set(elems$222);
  var $$x191 = $ct_T2__O__O__(new $c_T2(), self$211, y$211);
  var self$212 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$1321 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$223 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$223 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$223);
  var y$212 = this$1321.from__sc_IterableOnce__sci_Set(elems$223);
  var $$x190 = $ct_T2__O__O__(new $c_T2(), self$212, y$212);
  var self$213 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$1327 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$224 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$224 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$224);
  var y$213 = this$1327.from__sc_IterableOnce__sci_Set(elems$224);
  var $$x189 = $ct_T2__O__O__(new $c_T2(), self$213, y$213);
  var self$214 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$1333 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$225 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$225 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$225);
  var y$214 = this$1333.from__sc_IterableOnce__sci_Set(elems$225);
  var $$x188 = $ct_T2__O__O__(new $c_T2(), self$214, y$214);
  var self$215 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$1339 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$226 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$226 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$226);
  var y$215 = this$1339.from__sc_IterableOnce__sci_Set(elems$226);
  var array$227 = [$$x204, $$x203, $$x202, $$x201, $$x200, $$x199, $$x198, $$x197, $$x196, $$x195, $$x194, $$x193, $$x192, $$x191, $$x190, $$x189, $$x188, $ct_T2__O__O__(new $c_T2(), self$215, y$215)];
  var elems$227 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$227);
  this.Lscalacss_internal_CanIUse$__f_transitions = this$1344.from__sc_IterableOnce__sci_Map(elems$227)
}
$c_Lscalacss_internal_CanIUse$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$.prototype.constructor = $c_Lscalacss_internal_CanIUse$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$.prototype = $c_Lscalacss_internal_CanIUse$.prototype;
$c_Lscalacss_internal_CanIUse$.prototype.backgroundAttachment__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.backgroundImgOpts__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.boxshadow__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.css3Boxsizing__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.css3CursorsNewer__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.displayContents__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.flowRoot__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.fontFamilySystemUi__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Unknown$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Unknown$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.gradients__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.intrinsicWidth__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.logicalProps__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$PartialX$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.objectFit__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.opacity__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.pageBreak__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unknown$(), $m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.repeatingGradients__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$PartialX$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.runIn__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unknown$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$Unknown$(), $m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.scrollBehavior__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.textJustify__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unknown$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.textOverflow__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.textshadow__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.touchAction__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.transforms__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Full$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.userSelectNone__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$FullX$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.wordBreak__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
$c_Lscalacss_internal_CanIUse$.prototype.wordwrap__sci_Map = (function() {
  var this$112 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var this$5 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var y = this$5.from__sc_IterableOnce__sci_Set(elems);
  var $$x17 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
  var this$11 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$1 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var y$1 = this$11.from__sc_IterableOnce__sci_Set(elems$1);
  var $$x16 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
  var this$17 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$2 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var y$2 = this$17.from__sc_IterableOnce__sci_Set(elems$2);
  var $$x15 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC;
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$3 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var y$3 = this$23.from__sc_IterableOnce__sci_Set(elems$3);
  var $$x14 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser;
  var this$29 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$4 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var y$4 = this$29.from__sc_IterableOnce__sci_Set(elems$4);
  var $$x13 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var self$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser;
  var this$35 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$5 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var y$5 = this$35.from__sc_IterableOnce__sci_Set(elems$5);
  var $$x12 = $ct_T2__O__O__(new $c_T2(), self$5, y$5);
  var self$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
  var this$41 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$6 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var y$6 = this$41.from__sc_IterableOnce__sci_Set(elems$6);
  var $$x11 = $ct_T2__O__O__(new $c_T2(), self$6, y$6);
  var self$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
  var this$47 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$7 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var y$7 = this$47.from__sc_IterableOnce__sci_Set(elems$7);
  var $$x10 = $ct_T2__O__O__(new $c_T2(), self$7, y$7);
  var self$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
  var this$53 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$8 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var y$8 = this$53.from__sc_IterableOnce__sci_Set(elems$8);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), self$8, y$8);
  var self$9 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
  var this$59 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$9 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var y$9 = this$59.from__sc_IterableOnce__sci_Set(elems$9);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), self$9, y$9);
  var self$10 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile;
  var this$65 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$10 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var y$10 = this$65.from__sc_IterableOnce__sci_Set(elems$10);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$10, y$10);
  var self$11 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
  var this$71 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$11 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  var y$11 = this$71.from__sc_IterableOnce__sci_Set(elems$11);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$11, y$11);
  var self$12 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
  var this$77 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$12 = [$m_Lscalacss_internal_CanIUse$Support$Unsupported$(), $m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var y$12 = this$77.from__sc_IterableOnce__sci_Set(elems$12);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$12, y$12);
  var self$13 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini;
  var this$83 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$13 = [$m_Lscalacss_internal_CanIUse$Support$Partial$()];
  var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var y$13 = this$83.from__sc_IterableOnce__sci_Set(elems$13);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$13, y$13);
  var self$14 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile;
  var this$89 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$14 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
  var y$14 = this$89.from__sc_IterableOnce__sci_Set(elems$14);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$14, y$14);
  var self$15 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_QQBrowser;
  var this$95 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$15 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  var y$15 = this$95.from__sc_IterableOnce__sci_Set(elems$15);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$15, y$15);
  var self$16 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari;
  var this$101 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$16 = [$m_Lscalacss_internal_CanIUse$Support$Partial$(), $m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  var y$16 = this$101.from__sc_IterableOnce__sci_Set(elems$16);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$16, y$16);
  var self$17 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Samsung;
  var this$107 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array$17 = [$m_Lscalacss_internal_CanIUse$Support$Full$()];
  var elems$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
  var y$17 = this$107.from__sc_IterableOnce__sci_Set(elems$17);
  var array$18 = [$$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$17, y$17)];
  var elems$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
  return this$112.from__sc_IterableOnce__sci_Map(elems$18)
});
var $d_Lscalacss_internal_CanIUse$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$: 0
}, false, "scalacss.internal.CanIUse$", {
  Lscalacss_internal_CanIUse$: 1,
  O: 1
});
$c_Lscalacss_internal_CanIUse$.prototype.$classData = $d_Lscalacss_internal_CanIUse$;
var $n_Lscalacss_internal_CanIUse$;
function $m_Lscalacss_internal_CanIUse$() {
  if ((!$n_Lscalacss_internal_CanIUse$)) {
    $n_Lscalacss_internal_CanIUse$ = new $c_Lscalacss_internal_CanIUse$()
  };
  return $n_Lscalacss_internal_CanIUse$
}
function $ct_Lscalacss_internal_CanIUse$Prefix__T__($thiz, name) {
  $thiz.Lscalacss_internal_CanIUse$Prefix__f_name = name;
  $thiz.Lscalacss_internal_CanIUse$Prefix__f_prefix = (("-" + name) + "-");
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Prefix() {
  this.Lscalacss_internal_CanIUse$Prefix__f_name = null;
  this.Lscalacss_internal_CanIUse$Prefix__f_prefix = null
}
$c_Lscalacss_internal_CanIUse$Prefix.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Prefix.prototype.constructor = $c_Lscalacss_internal_CanIUse$Prefix;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Prefix() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Prefix.prototype = $c_Lscalacss_internal_CanIUse$Prefix.prototype;
function $as_Lscalacss_internal_CanIUse$Prefix(obj) {
  return (((obj instanceof $c_Lscalacss_internal_CanIUse$Prefix) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.CanIUse$Prefix"))
}
function $isArrayOf_Lscalacss_internal_CanIUse$Prefix(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_CanIUse$Prefix)))
}
function $asArrayOf_Lscalacss_internal_CanIUse$Prefix(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_CanIUse$Prefix(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.CanIUse$Prefix;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Prefix$() {
  this.Lscalacss_internal_CanIUse$Prefix$__f_ordering = null;
  this.Lscalacss_internal_CanIUse$Prefix$__f_values = null;
  $n_Lscalacss_internal_CanIUse$Prefix$ = this;
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lscalacss_internal_CanIUse$Prefix(x$1$2);
    return $n(x$1).Lscalacss_internal_CanIUse$Prefix__f_name
  }));
  var ord = $m_s_math_Ordering$String$();
  this.Lscalacss_internal_CanIUse$Prefix$__f_ordering = new $c_s_math_Ordering$$anon$5(ord, f);
  var h = $m_Lscalacss_internal_CanIUse$Prefix$moz$();
  var array = [$m_Lscalacss_internal_CanIUse$Prefix$ms$(), $m_Lscalacss_internal_CanIUse$Prefix$o$(), $m_Lscalacss_internal_CanIUse$Prefix$webkit$()];
  var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var t$1 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t);
  this.Lscalacss_internal_CanIUse$Prefix$__f_values = new $c_Lscalacss_internal_NonEmptyVector(h, t$1)
}
$c_Lscalacss_internal_CanIUse$Prefix$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Prefix$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Prefix$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Prefix$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Prefix$.prototype = $c_Lscalacss_internal_CanIUse$Prefix$.prototype;
var $d_Lscalacss_internal_CanIUse$Prefix$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Prefix$: 0
}, false, "scalacss.internal.CanIUse$Prefix$", {
  Lscalacss_internal_CanIUse$Prefix$: 1,
  O: 1
});
$c_Lscalacss_internal_CanIUse$Prefix$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Prefix$;
var $n_Lscalacss_internal_CanIUse$Prefix$;
function $m_Lscalacss_internal_CanIUse$Prefix$() {
  if ((!$n_Lscalacss_internal_CanIUse$Prefix$)) {
    $n_Lscalacss_internal_CanIUse$Prefix$ = new $c_Lscalacss_internal_CanIUse$Prefix$()
  };
  return $n_Lscalacss_internal_CanIUse$Prefix$
}
function $is_Lscalacss_internal_CanIUse$Support(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalacss_internal_CanIUse$Support)))
}
function $as_Lscalacss_internal_CanIUse$Support(obj) {
  return (($is_Lscalacss_internal_CanIUse$Support(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.CanIUse$Support"))
}
function $isArrayOf_Lscalacss_internal_CanIUse$Support(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_CanIUse$Support)))
}
function $asArrayOf_Lscalacss_internal_CanIUse$Support(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_CanIUse$Support(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.CanIUse$Support;", depth))
}
function $p_Lscalacss_internal_CanIUse2$__intrinsicWidthTransforms$lzycompute__Lscalacss_internal_Transform($thiz) {
  if (((((1 & $thiz.Lscalacss_internal_CanIUse2$__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x2 = $m_Lscalacss_internal_Transform$();
    var $$x1 = $m_Lscalacss_internal_CanIUse$().intrinsicWidth__sci_Map();
    var array = ["max-content", "min-content", "fit-content", "contain-floats"];
    $thiz.Lscalacss_internal_CanIUse2$__f_intrinsicWidthTransforms = $n($$x2).values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($$x1, "fill-available", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    $thiz.Lscalacss_internal_CanIUse2$__f_bitmap$0 = (((1 | $thiz.Lscalacss_internal_CanIUse2$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscalacss_internal_CanIUse2$__f_intrinsicWidthTransforms
}
function $p_Lscalacss_internal_CanIUse2$__backgroundImageTransforms$lzycompute__Lscalacss_internal_Transform($thiz) {
  if (((((2 & $thiz.Lscalacss_internal_CanIUse2$__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x2 = $m_Lscalacss_internal_Transform$();
    var $$x1 = $m_Lscalacss_internal_CanIUse$().gradients__sci_Map();
    var array = ["radial-gradient"];
    var a = $n($$x2).valueKeywords__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($$x1, "linear-gradient", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x4 = $m_Lscalacss_internal_Transform$();
    var $$x3 = $m_Lscalacss_internal_CanIUse$().repeatingGradients__sci_Map();
    var array$1 = ["repeating-radial-gradient"];
    var b = $n($$x4).valueKeywords__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($$x3, "repeating-linear-gradient", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    $thiz.Lscalacss_internal_CanIUse2$__f_backgroundImageTransforms = $n(a).$times__Lscalacss_internal_Transform__Lscalacss_internal_Transform(b);
    $thiz.Lscalacss_internal_CanIUse2$__f_bitmap$0 = (((2 | $thiz.Lscalacss_internal_CanIUse2$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscalacss_internal_CanIUse2$__f_backgroundImageTransforms
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse2$() {
  this.Lscalacss_internal_CanIUse2$__f_intrinsicWidthTransforms = null;
  this.Lscalacss_internal_CanIUse2$__f_backgroundImageTransforms = null;
  this.Lscalacss_internal_CanIUse2$__f_needsPrefix = null;
  this.Lscalacss_internal_CanIUse2$__f_emptyPrefixSet = null;
  this.Lscalacss_internal_CanIUse2$__f_prefixPlan = null;
  this.Lscalacss_internal_CanIUse2$__f_prefixed = null;
  this.Lscalacss_internal_CanIUse2$__f_bitmap$0 = 0;
  $n_Lscalacss_internal_CanIUse2$ = this;
  this.Lscalacss_internal_CanIUse2$__f_needsPrefix = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lscalacss_internal_CanIUse$Support(x0$1$2);
    var x = $m_Lscalacss_internal_CanIUse$Support$Unsupported$();
    if ((x === x0$1)) {
      var $$x1 = true
    } else {
      var x$3 = $m_Lscalacss_internal_CanIUse$Support$Full$();
      if ((x$3 === x0$1)) {
        var $$x1 = true
      } else {
        var x$5 = $m_Lscalacss_internal_CanIUse$Support$Partial$();
        var $$x1 = (x$5 === x0$1)
      }
    };
    if ((!$$x1)) {
      var x$7 = $m_Lscalacss_internal_CanIUse$Support$FullX$();
      if ((x$7 === x0$1)) {
        var $$x2 = true
      } else {
        var x$9 = $m_Lscalacss_internal_CanIUse$Support$PartialX$();
        var $$x2 = (x$9 === x0$1)
      };
      if ($$x2) {
        return true
      } else {
        var x$11 = $m_Lscalacss_internal_CanIUse$Support$Unknown$();
        if ((x$11 === x0$1)) {
          return false
        } else {
          throw new $c_s_MatchError(x0$1)
        }
      }
    } else {
      return false
    }
  }));
  this.Lscalacss_internal_CanIUse2$__f_emptyPrefixSet = $as_sci_SortedSet($m_sci_SortedSet$().empty__O__O($m_Lscalacss_internal_CanIUse$Prefix$().Lscalacss_internal_CanIUse$Prefix$__f_ordering));
  var $$x4 = $m_Lscalacss_internal_package$();
  var $$x3 = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_sci_Map(s$2);
    var this$3 = $n($m_Lscalacss_internal_CanIUse2$().subjectPrefixes__sci_Map__sci_SortedSet(s));
    var ps = $as_sci_Vector($n($m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$3)).map__F1__O(new $c_sjsr_AnonFunction1(((value$2) => {
      var value = $as_Lscalacss_internal_CanIUse$Prefix(value$2);
      return new $c_s_Some(value)
    }))));
    var np = $n(s).exists__F1__Z(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_T2(x$4$2);
      return $n($as_sc_IterableOnceOps($n(x$4)._2__O())).exists__F1__Z(new $c_sjsr_AnonFunction1(((d$2) => {
        var d = $as_Lscalacss_internal_CanIUse$Support(d$2);
        return (!$uZ($n($m_Lscalacss_internal_CanIUse2$().Lscalacss_internal_CanIUse2$__f_needsPrefix).apply__O__O(d)))
      })))
    })));
    if (np) {
      var this$4 = $n(ps);
      var elem = $m_s_None$();
      return $as_sci_Vector(this$4.appended__O__O(elem))
    } else {
      return ps
    }
  }));
  $m_Ljapgolly_univeq_UnivEq$();
  $m_Lscalacss_internal_CanIUse$Agent$();
  var this$6 = $m_Ljapgolly_univeq_UnivEq$();
  $m_Ljapgolly_univeq_UnivEq$();
  var this$8 = $m_Ljapgolly_univeq_UnivEq$();
  var this$10 = $m_Ljapgolly_univeq_UnivEq$();
  var this$12 = $m_Ljapgolly_univeq_UnivEq$();
  this.Lscalacss_internal_CanIUse2$__f_prefixPlan = $n($$x4).memo__F1__Ljapgolly_univeq_UnivEq__F1($$x3, this$12.Ljapgolly_univeq_UnivEq$__f_UnivEqAnyRef);
  $m_sc_StringOps$();
  var this$13 = $n($m_Lscalacss_internal_CanIUse$Prefix$().Lscalacss_internal_CanIUse$Prefix$__f_values);
  var this$14 = $n($n(this$13.whole__sci_Vector()).iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5$1 = $as_Lscalacss_internal_CanIUse$Prefix(x$5$2);
    return $n(x$5$1).Lscalacss_internal_CanIUse$Prefix__f_prefix
  }));
  var this$15 = new $c_sc_Iterator$$anon$9(this$14, f);
  var x$1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$15, ".*(?:", "|", ").*");
  var p = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), x$1, $m_sci_Nil$()).s_util_matching_Regex__f_pattern;
  this.Lscalacss_internal_CanIUse2$__f_prefixed = new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_T(in$2);
    var this$18 = $n(p);
    var this$19 = $n(in$1);
    return new $c_ju_regex_Matcher(this$18, this$19).matches__Z()
  }))
}
$c_Lscalacss_internal_CanIUse2$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse2$.prototype.constructor = $c_Lscalacss_internal_CanIUse2$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse2$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse2$.prototype = $c_Lscalacss_internal_CanIUse2$.prototype;
$c_Lscalacss_internal_CanIUse2$.prototype.intrinsicWidthTransforms__Lscalacss_internal_Transform = (function() {
  return (((((1 & this.Lscalacss_internal_CanIUse2$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscalacss_internal_CanIUse2$__intrinsicWidthTransforms$lzycompute__Lscalacss_internal_Transform(this) : this.Lscalacss_internal_CanIUse2$__f_intrinsicWidthTransforms)
});
$c_Lscalacss_internal_CanIUse2$.prototype.backgroundImageTransforms__Lscalacss_internal_Transform = (function() {
  return (((((2 & this.Lscalacss_internal_CanIUse2$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscalacss_internal_CanIUse2$__backgroundImageTransforms$lzycompute__Lscalacss_internal_Transform(this) : this.Lscalacss_internal_CanIUse2$__f_backgroundImageTransforms)
});
$c_Lscalacss_internal_CanIUse2$.prototype.agentPrefixes__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((a$2) => {
    var a = $as_Lscalacss_internal_CanIUse$Agent(a$2);
    var this$2 = $n($m_Lscalacss_internal_CanIUse2$().Lscalacss_internal_CanIUse2$__f_emptyPrefixSet);
    var elem = $n(a).Lscalacss_internal_CanIUse$Agent__f_prefix;
    var this$4 = $n(this$2.incl__O__sci_SetOps(elem));
    var this$3 = $n($n(a).Lscalacss_internal_CanIUse$Agent__f_prefixExceptions);
    var that = new $c_sc_MapOps$$anon$1(this$3);
    return $as_sci_SortedSet(this$4.concat__sc_IterableOnce__sc_SetOps(that))
  }))
});
$c_Lscalacss_internal_CanIUse2$.prototype.subjectPrefixes__sci_Map__sci_SortedSet = (function(s) {
  var this$2 = $n($n(s).iterator__sc_Iterator());
  var p = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T2(x$1$2);
    return $n($as_sc_IterableOnceOps($n(x$1)._2__O())).exists__F1__Z($m_Lscalacss_internal_CanIUse2$().Lscalacss_internal_CanIUse2$__f_needsPrefix)
  }));
  var this$3 = new $c_sc_Iterator$$anon$6(this$2, p, false);
  var f = new $c_sjsr_AnonFunction1(((ad$2) => {
    var ad = $as_T2(ad$2);
    return $as_sci_SortedSet($n($m_Lscalacss_internal_CanIUse2$().agentPrefixes__F1()).apply__O__O($n(ad)._1__O()))
  }));
  var this$4 = new $c_sc_Iterator$$anon$9(this$3, f);
  var z = this.Lscalacss_internal_CanIUse2$__f_emptyPrefixSet;
  var result = z;
  while (this$4.hasNext__Z()) {
    var arg1 = result;
    var arg2 = this$4.next__O();
    var x$2 = $as_sci_SortedSet(arg1);
    var x$3 = $as_sci_SortedSet(arg2);
    var this$5 = $n(x$2);
    result = $as_sci_SortedSet(this$5.concat__sc_IterableOnce__sc_SetOps(x$3))
  };
  return $as_sci_SortedSet(result)
});
$c_Lscalacss_internal_CanIUse2$.prototype.runPlan__sci_Vector__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_CssKV__sci_Vector = (function(pp, pa, l, kv) {
  var tgt = $as_T($n($n(l).Lscalacss_internal_CssKV$Lens__f_get).apply__O__O(kv));
  if ($uZ($n(this.Lscalacss_internal_CanIUse2$__f_prefixed).apply__O__O(tgt))) {
    return $m_Lscalacss_internal_package$().Vector1__O__sci_Vector(kv)
  } else {
    var this$1 = $n($as_s_Option($n(pa).apply__O__O(tgt)));
    if (this$1.isEmpty__Z()) {
      return $m_Lscalacss_internal_package$().Vector1__O__sci_Vector(kv)
    } else {
      var arg1 = this$1.get__O();
      var apply = $as_F1(arg1);
      return $as_sci_Vector($n(pp).map__F1__O(new $c_sjsr_AnonFunction1(((op$2) => {
        var op = $as_s_Option(op$2);
        var this$3 = $n(op);
        if (this$3.isEmpty__Z()) {
          return kv
        } else {
          var arg1$1 = this$3.get__O();
          var p = $as_Lscalacss_internal_CanIUse$Prefix(arg1$1);
          return $as_Lscalacss_internal_CssKV($n($n(l).Lscalacss_internal_CssKV$Lens__f_set).apply__O__O__O(kv, $n(apply).apply__O__O(p)))
        }
      }))))
    }
  }
});
$c_Lscalacss_internal_CanIUse2$.prototype.prefixesForPlatform__Lscalacss_internal_Env$Platform__sci_SortedSet = (function(p) {
  var this$1 = $n(this.agentsForPlatform__Lscalacss_internal_Env$Platform__Lscalacss_internal_NonEmptyVector(p));
  var f = this.agentPrefixes__F1();
  var this$2 = $n(this$1.Lscalacss_internal_NonEmptyVector__f_tail);
  var z = $n(f).apply__O__O(this$1.Lscalacss_internal_NonEmptyVector__f_head);
  var at = 0;
  var end = this$2.length__I();
  var acc = z;
  var $$x1;
  while (true) {
    if ((at !== end)) {
      var temp$at = ((1 + at) | 0);
      var arg1 = acc;
      var arg2 = this$2.apply__I__O(at);
      var arg2$1 = $n(f).apply__O__O(arg2);
      var x$7 = $as_sci_SortedSet(arg1);
      var x$8 = $as_sci_SortedSet(arg2$1);
      var this$3 = $n(x$7);
      var temp$acc = $as_sci_SortedSet(this$3.concat__sc_IterableOnce__sc_SetOps(x$8));
      at = temp$at;
      acc = temp$acc;
      continue
    };
    var $$x1 = acc;
    break
  };
  return $as_sci_SortedSet($$x1)
});
$c_Lscalacss_internal_CanIUse2$.prototype.agentsForPlatform__Lscalacss_internal_Env$Platform__Lscalacss_internal_NonEmptyVector = (function(p) {
  var this$1 = $n(p);
  var this$2 = $n($m_sr_ScalaRunTime$()._toString__s_Product__T(this$1));
  var this$3 = $n($as_T(this$2.toLowerCase()));
  if (($uI(this$3.indexOf("android")) !== (-1))) {
    var this$4 = $n($as_s_Option($n(p).Lscalacss_internal_Env$Platform__f_name));
    if (this$4.isEmpty__Z()) {
      return $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_values
    } else {
      var arg1 = this$4.get__O();
      var x0$1 = $as_T(arg1);
      if ((x0$1 === "Chrome")) {
        var h = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome;
        var t = $m_sci_Nil$();
        var t$1 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t);
        return new $c_Lscalacss_internal_NonEmptyVector(h, t$1)
      } else if ((x0$1 === "Firefox")) {
        var h$1 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox;
        var t$2 = $m_sci_Nil$();
        var t$3 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$2);
        return new $c_Lscalacss_internal_NonEmptyVector(h$1, t$3)
      } else {
        var h$2 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
        var array = [$m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_AndroidUC];
        var t$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        var t$5 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$4);
        return new $c_Lscalacss_internal_NonEmptyVector(h$2, t$5)
      }
    }
  } else {
    var this$11 = $n($as_s_Option($n(p).Lscalacss_internal_Env$Platform__f_name));
    if (this$11.isEmpty__Z()) {
      return $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_values
    } else {
      var arg1$1 = this$11.get__O();
      var x0$2 = $as_T(arg1$1);
      if ((x0$2 === "Chrome")) {
        var h$3 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Chrome;
        var t$6 = $m_sci_Nil$();
        var t$7 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$6);
        return new $c_Lscalacss_internal_NonEmptyVector(h$3, t$7)
      } else if ((x0$2 === "Firefox")) {
        var h$4 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Firefox;
        var t$8 = $m_sci_Nil$();
        var t$9 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$8);
        return new $c_Lscalacss_internal_NonEmptyVector(h$4, t$9)
      } else if ((x0$2 === "IE")) {
        var h$5 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IE;
        var array$1 = [$m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IEMobile];
        var t$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        var t$11 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$10);
        return new $c_Lscalacss_internal_NonEmptyVector(h$5, t$11)
      } else if ((x0$2 === "Opera")) {
        var h$6 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Opera;
        var array$2 = [$m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMini, $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_OperaMobile];
        var t$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
        var t$13 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$12);
        return new $c_Lscalacss_internal_NonEmptyVector(h$6, t$13)
      } else if ((x0$2 === "Safari")) {
        var h$7 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_IOSSafari;
        var array$3 = [$m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Safari];
        var t$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        var t$15 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$14);
        return new $c_Lscalacss_internal_NonEmptyVector(h$7, t$15)
      } else if ($f_T__endsWith__T__Z($n(x0$2), "Edge")) {
        var h$8 = $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_Edge;
        var t$16 = $m_sci_Nil$();
        var t$17 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$16);
        return new $c_Lscalacss_internal_NonEmptyVector(h$8, t$17)
      } else {
        return $m_Lscalacss_internal_CanIUse$Agent$().Lscalacss_internal_CanIUse$Agent$__f_values
      }
    }
  }
});
$c_Lscalacss_internal_CanIUse2$.prototype.filteredPrefixPlan__sci_Set__sci_Vector__sci_Vector = (function(whitelist, pp) {
  var this$3 = $n(pp);
  var pred = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_s_Option(x$9$2);
    var this$2 = $n(x$9);
    if (this$2.isEmpty__Z()) {
      return true
    } else {
      var arg1 = this$2.get__O();
      var elem = $as_Lscalacss_internal_CanIUse$Prefix(arg1);
      return $n(whitelist).contains__O__Z(elem)
    }
  }));
  return this$3.filterImpl__F1__Z__sci_Vector(pred, false)
});
var $d_Lscalacss_internal_CanIUse2$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse2$: 0
}, false, "scalacss.internal.CanIUse2$", {
  Lscalacss_internal_CanIUse2$: 1,
  O: 1
});
$c_Lscalacss_internal_CanIUse2$.prototype.$classData = $d_Lscalacss_internal_CanIUse2$;
var $n_Lscalacss_internal_CanIUse2$;
function $m_Lscalacss_internal_CanIUse2$() {
  if ((!$n_Lscalacss_internal_CanIUse2$)) {
    $n_Lscalacss_internal_CanIUse2$ = new $c_Lscalacss_internal_CanIUse2$()
  };
  return $n_Lscalacss_internal_CanIUse2$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse2$PrefixApply$() {
  this.Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend = null;
  $n_Lscalacss_internal_CanIUse2$PrefixApply$ = this;
  this.Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend = new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_T(in$2);
    return new $c_s_Some(new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Lscalacss_internal_CanIUse$Prefix(x$6$2);
      return (("" + $n(x$6).Lscalacss_internal_CanIUse$Prefix__f_prefix) + in$1)
    })))
  }))
}
$c_Lscalacss_internal_CanIUse2$PrefixApply$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse2$PrefixApply$.prototype.constructor = $c_Lscalacss_internal_CanIUse2$PrefixApply$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse2$PrefixApply$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse2$PrefixApply$.prototype = $c_Lscalacss_internal_CanIUse2$PrefixApply$.prototype;
$c_Lscalacss_internal_CanIUse2$PrefixApply$.prototype.maybePrepend__F1__F1 = (function(f) {
  return new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_T(in$2);
    return ($uZ($n(f).apply__O__O(in$1)) ? $as_s_Option($n($m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend).apply__O__O(in$1)) : $m_s_None$())
  }))
});
$c_Lscalacss_internal_CanIUse2$PrefixApply$.prototype.keywords__T__sci_Seq__F1 = (function(w1, wn) {
  var this$1 = $n(wn);
  var ws = $as_sci_Seq(this$1.prepended__O__O(w1));
  $m_sc_StringOps$();
  var this$2 = $n(ws);
  var x = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "(?:^|.*[^a-zA-Z0-9_-])(?:", "|", ")(?![a-zA-Z0-9_-]).*");
  var r1 = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), x, $m_sci_Nil$()).s_util_matching_Regex__f_pattern;
  $m_sc_StringOps$();
  var this$5 = $n(ws);
  var x$1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "(^|[^a-zA-Z0-9_-])(", "|", ")(?![a-zA-Z0-9_-])");
  var r2 = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), x$1, $m_sci_Nil$());
  return new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_T(in$2);
    var this$9 = $n(r1);
    var this$10 = $n(in$1);
    if (new $c_ju_regex_Matcher(this$9, this$10).matches__Z()) {
      return new $c_s_Some(new $c_sjsr_AnonFunction1(((p$2) => {
        var p = $as_Lscalacss_internal_CanIUse$Prefix(p$2);
        var this$11 = new $c_s_util_matching_Regex$MatchIterator(in$1, r2, r2.s_util_matching_Regex__f_scala$util$matching$Regex$$groupNames);
        var it = new $c_s_util_matching_Regex$MatchIterator$$anon$4(this$11);
        while (it.hasNext__Z()) {
          var arg1 = it.next__s_util_matching_Regex$Match();
          var this$12 = $n(arg1);
          var $$x2 = $f_s_util_matching_Regex$MatchData__group__I__T(this$12, 1);
          var $$x1 = $n(p).Lscalacss_internal_CanIUse$Prefix__f_prefix;
          var this$13 = $n(arg1);
          var rs = ((("" + $$x2) + $$x1) + $f_s_util_matching_Regex$MatchData__group__I__T(this$13, 2));
          $n(it.matcher__ju_regex_Matcher()).appendReplacement__jl_StringBuffer__T__ju_regex_Matcher(it.s_util_matching_Regex$MatchIterator$$anon$4__f_scala$util$matching$Regex$Replacement$$sb, rs)
        };
        return $f_s_util_matching_Regex$Replacement__replaced__T(it)
      })))
    } else {
      return $m_s_None$()
    }
  }))
});
var $d_Lscalacss_internal_CanIUse2$PrefixApply$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse2$PrefixApply$: 0
}, false, "scalacss.internal.CanIUse2$PrefixApply$", {
  Lscalacss_internal_CanIUse2$PrefixApply$: 1,
  O: 1
});
$c_Lscalacss_internal_CanIUse2$PrefixApply$.prototype.$classData = $d_Lscalacss_internal_CanIUse2$PrefixApply$;
var $n_Lscalacss_internal_CanIUse2$PrefixApply$;
function $m_Lscalacss_internal_CanIUse2$PrefixApply$() {
  if ((!$n_Lscalacss_internal_CanIUse2$PrefixApply$)) {
    $n_Lscalacss_internal_CanIUse2$PrefixApply$ = new $c_Lscalacss_internal_CanIUse2$PrefixApply$()
  };
  return $n_Lscalacss_internal_CanIUse2$PrefixApply$
}
function $f_Lscalacss_internal_ColorOps__rgb__I__I__I__O($thiz, r, g, b) {
  return $thiz.mkColor__T__O((((((("rgb(" + r) + ",") + g) + ",") + b) + ")"))
}
function $f_Lscalacss_internal_ColorOps__hsl__I__Lscalacss_internal_Percentage__Lscalacss_internal_Percentage__O($thiz, h, s, l) {
  return $thiz.mkColor__T__O((((((("hsl(" + h) + ",") + $n(s).value__T()) + ",") + $n(l).value__T()) + ")"))
}
function $f_Lscalacss_internal_ColorOps__rgba__I__I__I__D__O($thiz, r, g, b, a) {
  return $thiz.mkColor__T__O((((((((("rgba(" + r) + ",") + g) + ",") + b) + ",") + a) + ")"))
}
function $f_Lscalacss_internal_ColorOps__hsla__I__Lscalacss_internal_Percentage__Lscalacss_internal_Percentage__D__O($thiz, h, s, l, a) {
  return $thiz.mkColor__T__O((((((((("hsla(" + h) + ",") + $n(s).value__T()) + ",") + $n(l).value__T()) + ",") + a) + ")"))
}
function $p_Lscalacss_internal_Compose$Rules$__showV$1__Lscalacss_internal_NonEmptyVector__T($thiz, vs) {
  var this$1 = $n($n(vs).Lscalacss_internal_NonEmptyVector__f_tail);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    return $as_T($n(vs).Lscalacss_internal_NonEmptyVector__f_head)
  } else {
    var this$2 = $n($n(vs).whole__sci_Vector());
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "[", "; ", "]")
  }
}
function $p_Lscalacss_internal_Compose$Rules$__showAV$1__Lscalacss_internal_Attr__Lscalacss_internal_NonEmptyVector__T($thiz, a, vs) {
  return (($n(a).Lscalacss_internal_Attr__f_id + ": ") + $p_Lscalacss_internal_Compose$Rules$__showV$1__Lscalacss_internal_NonEmptyVector__T($thiz, vs))
}
function $p_Lscalacss_internal_Compose$Rules$__showAVs$1__Lscalacss_internal_AVs__T($thiz, avs) {
  var this$2 = $n($n(avs).iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((t$2) => {
    var t = $as_T2(t$2);
    return $p_Lscalacss_internal_Compose$Rules$__showAV$1__Lscalacss_internal_Attr__Lscalacss_internal_NonEmptyVector__T($thiz, $as_Lscalacss_internal_Attr($n(t)._1__O()), $as_Lscalacss_internal_NonEmptyVector($n(t)._2__O()))
  }));
  var s = new $c_sc_Iterator$$anon$9(this$2, f);
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(s, "{", ", ", "}")
}
/** @constructor */
function $c_Lscalacss_internal_Compose$Rules$() {
  /*<skip>*/
}
$c_Lscalacss_internal_Compose$Rules$.prototype = new $h_O();
$c_Lscalacss_internal_Compose$Rules$.prototype.constructor = $c_Lscalacss_internal_Compose$Rules$;
/** @constructor */
function $h_Lscalacss_internal_Compose$Rules$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Compose$Rules$.prototype = $c_Lscalacss_internal_Compose$Rules$.prototype;
$c_Lscalacss_internal_Compose$Rules$.prototype.append__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((lo$2, hi$2) => {
    var lo = $as_Lscalacss_internal_AVs(lo$2);
    var hi = $as_Lscalacss_internal_AVs(hi$2);
    return $n(lo).$plus$plus__Lscalacss_internal_AVs__Lscalacss_internal_AVs(hi)
  }))
});
$c_Lscalacss_internal_Compose$Rules$.prototype.warn__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((lo$2, hi$2) => {
    var lo = $as_Lscalacss_internal_AVs(lo$2);
    var hi = $as_Lscalacss_internal_AVs(hi$2);
    var this$2 = $n($n(hi).iterator__sc_Iterator());
    var f = new $c_sjsr_AnonFunction1(((t$2) => {
      var t = $as_T2(t$2);
      return ((("{" + $p_Lscalacss_internal_Compose$Rules$__showAV$1__Lscalacss_internal_Attr__Lscalacss_internal_NonEmptyVector__T(this, $as_Lscalacss_internal_Attr($n(t)._1__O()), $as_Lscalacss_internal_NonEmptyVector($n(t)._2__O()))) + "} conflicts with ") + $p_Lscalacss_internal_Compose$Rules$__showAVs$1__Lscalacss_internal_AVs__T(this, lo))
    }));
    var this$3 = new $c_sc_Iterator$$anon$9(this$2, f);
    return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$3)
  }))
});
var $d_Lscalacss_internal_Compose$Rules$ = new $TypeData().initClass({
  Lscalacss_internal_Compose$Rules$: 0
}, false, "scalacss.internal.Compose$Rules$", {
  Lscalacss_internal_Compose$Rules$: 1,
  O: 1
});
$c_Lscalacss_internal_Compose$Rules$.prototype.$classData = $d_Lscalacss_internal_Compose$Rules$;
var $n_Lscalacss_internal_Compose$Rules$;
function $m_Lscalacss_internal_Compose$Rules$() {
  if ((!$n_Lscalacss_internal_Compose$Rules$)) {
    $n_Lscalacss_internal_Compose$Rules$ = new $c_Lscalacss_internal_Compose$Rules$()
  };
  return $n_Lscalacss_internal_Compose$Rules$
}
function $p_Lscalacss_internal_Css$__main$1__Lscalacss_internal_StyleS__Lscalacss_internal_Env__T__sc_Iterator($thiz, s$1, env$4, sel$1) {
  var this$11 = $n($n($n(s$1).Lscalacss_internal_StyleS__f_data).iterator__sc_Iterator());
  var f$1 = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var cond = $as_Lscalacss_internal_Cond($n(x0$1)._1__O());
      var avs = $as_Lscalacss_internal_AVs($n(x0$1)._2__O());
      var this$2 = $n($n(avs).avIterator__sc_Iterator());
      var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2 = $as_Lscalacss_internal_AV(x$2$2);
        return $n(x$2).apply__Lscalacss_internal_Env__sci_Vector(env$4)
      }));
      var this$4 = new $c_sc_Iterator$$anon$9(this$2, f);
      $n($m_s_package$().s_package$__f_Vector);
      var z = $m_sci_Vector0$();
      var result = z;
      while (this$4.hasNext__Z()) {
        var arg1 = result;
        var arg2 = this$4.next__O();
        var x$3 = $as_sci_Vector(arg1);
        var x$4 = $as_sci_Vector(arg2);
        var this$5 = $n(x$3);
        result = this$5.appendedAll__sc_IterableOnce__sci_Vector(x$4)
      };
      var kvs = $as_sci_Vector(result);
      var this$7 = $n(kvs);
      if ($f_sc_SeqOps__isEmpty__Z(this$7)) {
        $n($m_s_package$().s_package$__f_List);
        var $$x1 = $m_sci_Nil$()
      } else {
        var h = $n(kvs).head__O();
        var t = $n(kvs).tail__sci_Vector();
        var arg1$1 = new $c_Lscalacss_internal_NonEmptyVector(h, t);
        var mq = $m_Lscalacss_internal_Css$().mediaQuery__Lscalacss_internal_Cond__s_Option(cond);
        var s = $m_Lscalacss_internal_Css$().selector__T__Lscalacss_internal_Cond__T(sel$1, cond);
        var rassoc$1 = new $c_Lscalacss_internal_CssEntry$Style(mq, s, arg1$1);
        var this$10 = $n($m_s_package$().s_package$__f_Nil);
        var $$x1 = new $c_sci_$colon$colon(rassoc$1, this$10)
      };
      return $as_sc_IterableOnce($$x1)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  return new $c_sc_Iterator$$anon$10(this$11, f$1)
}
function $p_Lscalacss_internal_Css$__exts$1__Lscalacss_internal_StyleS__T__Lscalacss_internal_Env__sc_Iterator($thiz, s$1, sel$1, env$4) {
  var this$2 = $n($n($n(s$1).Lscalacss_internal_StyleS__f_unsafeExts).iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lscalacss_internal_Style$UnsafeExt(x$5$2);
    return $m_Lscalacss_internal_Css$().unsafeExt__T__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_Env__sci_Vector(sel$1, x$5, env$4)
  }));
  return new $c_sc_Iterator$$anon$10(this$2, f)
}
/** @constructor */
function $c_Lscalacss_internal_Css$() {
  /*<skip>*/
}
$c_Lscalacss_internal_Css$.prototype = new $h_O();
$c_Lscalacss_internal_Css$.prototype.constructor = $c_Lscalacss_internal_Css$;
/** @constructor */
function $h_Lscalacss_internal_Css$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Css$.prototype = $c_Lscalacss_internal_Css$.prototype;
$c_Lscalacss_internal_Css$.prototype.apply__sc_IterableOnce__sc_IterableOnce__sc_IterableOnce__Lscalacss_internal_Env__sci_Vector = (function(ss, kfs, ff, env) {
  $n($m_s_package$().s_package$__f_Vector);
  var b = new $c_sci_VectorBuilder();
  var xs = this.styles__sc_IterableOnce__Lscalacss_internal_Env__sci_Vector(ss, env);
  b.addAll__sc_IterableOnce__sci_VectorBuilder(xs);
  var xs$1 = this.keyframes__sc_IterableOnce__Lscalacss_internal_Env__sci_List(kfs, env);
  b.addAll__sc_IterableOnce__sci_VectorBuilder(xs$1);
  var xs$2 = this.fontFaces__sc_IterableOnce__sci_List(ff);
  b.addAll__sc_IterableOnce__sci_VectorBuilder(xs$2);
  return b.result__sci_Vector()
});
$c_Lscalacss_internal_Css$.prototype.styles__sc_IterableOnce__Lscalacss_internal_Env__sci_Vector = (function(ss, env) {
  var this$2 = $n($n(ss).iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lscalacss_internal_StyleA(s$2);
    return $m_Lscalacss_internal_Css$().styleA__Lscalacss_internal_StyleA__Lscalacss_internal_Env__sci_Vector(s, env)
  }));
  var this$3 = new $c_sc_Iterator$$anon$10(this$2, f);
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$3)
});
$c_Lscalacss_internal_Css$.prototype.keyframes__sc_IterableOnce__Lscalacss_internal_Env__sci_List = (function(kfs, env) {
  var this$2 = $n($n(kfs).iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((kfs$2$2) => {
    var kfs$2 = $as_Lscalacss_internal_Keyframes(kfs$2$2);
    return $m_Lscalacss_internal_Css$().keyframes__Lscalacss_internal_Keyframes__Lscalacss_internal_Env__Lscalacss_internal_CssEntry$Keyframes(kfs$2, env)
  }));
  var this$3 = new $c_sc_Iterator$$anon$9(this$2, f);
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$3)
});
$c_Lscalacss_internal_Css$.prototype.fontFaces__sc_IterableOnce__sci_List = (function(ff) {
  var this$3 = $n($n(ff).iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((ff$2$2) => {
    var ff$2 = $as_Lscalacss_internal_FontFace(ff$2$2);
    return new $c_Lscalacss_internal_CssEntry$FontFace($as_T($n(ff$2).fontFamily__O()), $n(ff$2).src__Lscalacss_internal_NonEmptyVector(), $n(ff$2).fontStretchValue__s_Option(), $n(ff$2).fontStyleValue__s_Option(), $n(ff$2).fontWeightValue__s_Option(), $n(ff$2).unicodeRangeValue__s_Option())
  }));
  var this$4 = new $c_sc_Iterator$$anon$9(this$3, f);
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4)
});
$c_Lscalacss_internal_Css$.prototype.className__Lscalacss_internal_ClassName__T = (function(cn) {
  return ("." + $n(cn).Lscalacss_internal_ClassName__f_value)
});
$c_Lscalacss_internal_Css$.prototype.selector__Lscalacss_internal_ClassName__Lscalacss_internal_Cond__T = (function(cn, c) {
  return this.selector__T__Lscalacss_internal_Cond__T(this.className__Lscalacss_internal_ClassName__T(cn), c)
});
$c_Lscalacss_internal_Css$.prototype.selector__T__Lscalacss_internal_Cond__T = (function(cs, c) {
  var this$1 = $n($n(c).Lscalacss_internal_Cond__f_pseudo);
  if (this$1.isEmpty__Z()) {
    return cs
  } else {
    var arg1 = this$1.get__O();
    var x$1 = $as_Lscalacss_internal_Pseudo(arg1);
    return $n(x$1).modSelector__T__T(cs)
  }
});
$c_Lscalacss_internal_Css$.prototype.mediaQuery__Lscalacss_internal_Cond__s_Option = (function(c) {
  var this$1 = $n($m_Lscalacss_internal_NonEmptyVector$().option__sci_Vector__s_Option($n(c).Lscalacss_internal_Cond__f_mediaQueries));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var qs = $as_Lscalacss_internal_NonEmptyVector(arg1);
    return new $c_s_Some($m_Lscalacss_internal_Media$().css__Lscalacss_internal_NonEmptyVector__T(qs))
  }
});
$c_Lscalacss_internal_Css$.prototype.keyframes__Lscalacss_internal_Keyframes__Lscalacss_internal_Env__Lscalacss_internal_CssEntry$Keyframes = (function(kfs, env) {
  var $$x1 = $n(kfs).Lscalacss_internal_Keyframes__f_name;
  var this$2 = $m_sci_ListMap$();
  var elems = $as_sci_Seq($n($n(kfs).Lscalacss_internal_Keyframes__f_frames).map__F1__O(new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T2(s$2);
    return $ct_T2__O__O__(new $c_T2(), $n(s)._1__O(), $m_Lscalacss_internal_Css$().styleA__Lscalacss_internal_StyleA__Lscalacss_internal_Env__sci_Vector($as_Lscalacss_internal_StyleA($n(s)._2__O()), env))
  }))));
  return new $c_Lscalacss_internal_CssEntry$Keyframes($$x1, this$2.from__sc_IterableOnce__sci_ListMap(elems))
});
$c_Lscalacss_internal_Css$.prototype.styleA__Lscalacss_internal_StyleA__Lscalacss_internal_Env__sci_Vector = (function(s, env) {
  return this.style__T__Lscalacss_internal_StyleS__Lscalacss_internal_Env__sci_Vector(this.className__Lscalacss_internal_ClassName__T($n(s).Lscalacss_internal_StyleA__f_className), $n(s).Lscalacss_internal_StyleA__f_style, env)
});
$c_Lscalacss_internal_Css$.prototype.style__T__Lscalacss_internal_StyleS__Lscalacss_internal_Env__sci_Vector = (function(sel, s, env) {
  var this$2 = $n($p_Lscalacss_internal_Css$__main$1__Lscalacss_internal_StyleS__Lscalacss_internal_Env__T__sc_Iterator(this, s, env, sel));
  var xs = new $c_sjsr_AnonFunction0((() => $p_Lscalacss_internal_Css$__exts$1__Lscalacss_internal_StyleS__T__Lscalacss_internal_Env__sc_Iterator(this, s, sel, env)));
  return $n(this$2.concat__F0__sc_Iterator(xs)).toVector__sci_Vector()
});
$c_Lscalacss_internal_Css$.prototype.unsafeExt__T__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_Env__sci_Vector = (function(root, u, env) {
  var sel = $as_T($n($n(u).Lscalacss_internal_Style$UnsafeExt__f_sel).apply__O__O((("" + root) + $n(u).Lscalacss_internal_Style$UnsafeExt__f_cond)));
  return this.style__T__Lscalacss_internal_StyleS__Lscalacss_internal_Env__sci_Vector(sel, $n(u).Lscalacss_internal_Style$UnsafeExt__f_style, env)
});
$c_Lscalacss_internal_Css$.prototype.separateStylesAndKeyframes__sci_Vector__T3 = (function(c) {
  $n($m_s_package$().s_package$__f_Vector);
  var styles = new $c_sci_VectorBuilder();
  $n($m_s_package$().s_package$__f_List);
  var animations = new $c_scm_ListBuffer();
  $n($m_s_package$().s_package$__f_List);
  var fontFaces = new $c_scm_ListBuffer();
  $n(c).foreach__F1__V(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lscalacss_internal_CssEntry(x0$1$2);
    if ((x0$1 instanceof $c_Lscalacss_internal_CssEntry$Style)) {
      var x2 = $as_Lscalacss_internal_CssEntry$Style(x0$1);
      return styles.addOne__O__sci_VectorBuilder(x2)
    } else if ((x0$1 instanceof $c_Lscalacss_internal_CssEntry$Keyframes)) {
      var x3 = $as_Lscalacss_internal_CssEntry$Keyframes(x0$1);
      return animations.addOne__O__scm_ListBuffer(x3)
    } else if ((x0$1 instanceof $c_Lscalacss_internal_CssEntry$FontFace)) {
      var x4 = $as_Lscalacss_internal_CssEntry$FontFace(x0$1);
      return fontFaces.addOne__O__scm_ListBuffer(x4)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })));
  return new $c_T3(styles.result__sci_Vector(), animations.toList__sci_List(), fontFaces.toList__sci_List())
});
$c_Lscalacss_internal_Css$.prototype.mapByMediaQuery__sci_Vector__sci_ListMap = (function(c) {
  var z = $m_sci_ListMap$EmptyListMap$();
  var this$2 = $n(c);
  var at = 0;
  var end = this$2.length__I();
  var acc = z;
  var $$x1;
  while (true) {
    if ((at !== end)) {
      var temp$at = ((1 + at) | 0);
      var arg1 = acc;
      var arg2 = this$2.apply__I__O(at);
      var q = $as_sci_ListMap(arg1);
      var e = $as_Lscalacss_internal_CssEntry$Style(arg2);
      var add = $ct_T2__O__O__(new $c_T2(), $n(e).Lscalacss_internal_CssEntry$Style__f_sel, $n(e).Lscalacss_internal_CssEntry$Style__f_content);
      var k = $n(e).Lscalacss_internal_CssEntry$Style__f_mq;
      var temp$acc = $n(q).updated__O__O__sci_ListMap(k, $m_Lscalacss_internal_NonEmptyVector$().endO__s_Option__O__Lscalacss_internal_NonEmptyVector($n(q).get__O__s_Option(k), add));
      at = temp$at;
      acc = temp$acc;
      continue
    };
    var $$x1 = acc;
    break
  };
  return $as_sci_ListMap($$x1)
});
var $d_Lscalacss_internal_Css$ = new $TypeData().initClass({
  Lscalacss_internal_Css$: 0
}, false, "scalacss.internal.Css$", {
  Lscalacss_internal_Css$: 1,
  O: 1
});
$c_Lscalacss_internal_Css$.prototype.$classData = $d_Lscalacss_internal_Css$;
var $n_Lscalacss_internal_Css$;
function $m_Lscalacss_internal_Css$() {
  if ((!$n_Lscalacss_internal_Css$)) {
    $n_Lscalacss_internal_Css$ = new $c_Lscalacss_internal_Css$()
  };
  return $n_Lscalacss_internal_Css$
}
function $is_Lscalacss_internal_CssEntry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalacss_internal_CssEntry)))
}
function $as_Lscalacss_internal_CssEntry(obj) {
  return (($is_Lscalacss_internal_CssEntry(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.CssEntry"))
}
function $isArrayOf_Lscalacss_internal_CssEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_CssEntry)))
}
function $asArrayOf_Lscalacss_internal_CssEntry(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_CssEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.CssEntry;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_CssKV$Lens(get, set) {
  this.Lscalacss_internal_CssKV$Lens__f_get = null;
  this.Lscalacss_internal_CssKV$Lens__f_set = null;
  this.Lscalacss_internal_CssKV$Lens__f_get = get;
  this.Lscalacss_internal_CssKV$Lens__f_set = set
}
$c_Lscalacss_internal_CssKV$Lens.prototype = new $h_O();
$c_Lscalacss_internal_CssKV$Lens.prototype.constructor = $c_Lscalacss_internal_CssKV$Lens;
/** @constructor */
function $h_Lscalacss_internal_CssKV$Lens() {
  /*<skip>*/
}
$h_Lscalacss_internal_CssKV$Lens.prototype = $c_Lscalacss_internal_CssKV$Lens.prototype;
var $d_Lscalacss_internal_CssKV$Lens = new $TypeData().initClass({
  Lscalacss_internal_CssKV$Lens: 0
}, false, "scalacss.internal.CssKV$Lens", {
  Lscalacss_internal_CssKV$Lens: 1,
  O: 1
});
$c_Lscalacss_internal_CssKV$Lens.prototype.$classData = $d_Lscalacss_internal_CssKV$Lens;
function $f_Lscalacss_internal_Domain__iterator__sc_Iterator($thiz) {
  var end = $thiz.size__I();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
  var this$7 = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  var f = new $c_sjsr_AnonFunction1(((i$2) => {
    var i = $uI(i$2);
    return $thiz.apply__I__O(i)
  }));
  return new $c_sc_Iterator$$anon$9(this$7, f)
}
function $is_Lscalacss_internal_Domain(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalacss_internal_Domain)))
}
function $as_Lscalacss_internal_Domain(obj) {
  return (($is_Lscalacss_internal_Domain(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Domain"))
}
function $isArrayOf_Lscalacss_internal_Domain(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Domain)))
}
function $asArrayOf_Lscalacss_internal_Domain(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Domain(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Domain;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_Domain$() {
  this.Lscalacss_internal_Domain$__f_boolean = null;
  $n_Lscalacss_internal_Domain$ = this;
  var array = [true, false];
  var as = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lscalacss_internal_Domain$__f_boolean = new $c_Lscalacss_internal_Domain$OverSeq(as)
}
$c_Lscalacss_internal_Domain$.prototype = new $h_O();
$c_Lscalacss_internal_Domain$.prototype.constructor = $c_Lscalacss_internal_Domain$;
/** @constructor */
function $h_Lscalacss_internal_Domain$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Domain$.prototype = $c_Lscalacss_internal_Domain$.prototype;
var $d_Lscalacss_internal_Domain$ = new $TypeData().initClass({
  Lscalacss_internal_Domain$: 0
}, false, "scalacss.internal.Domain$", {
  Lscalacss_internal_Domain$: 1,
  O: 1
});
$c_Lscalacss_internal_Domain$.prototype.$classData = $d_Lscalacss_internal_Domain$;
var $n_Lscalacss_internal_Domain$;
function $m_Lscalacss_internal_Domain$() {
  if ((!$n_Lscalacss_internal_Domain$)) {
    $n_Lscalacss_internal_Domain$ = new $c_Lscalacss_internal_Domain$()
  };
  return $n_Lscalacss_internal_Domain$
}
/** @constructor */
function $c_Lscalacss_internal_DslBase$DslAttrT$() {
  /*<skip>*/
}
$c_Lscalacss_internal_DslBase$DslAttrT$.prototype = new $h_O();
$c_Lscalacss_internal_DslBase$DslAttrT$.prototype.constructor = $c_Lscalacss_internal_DslBase$DslAttrT$;
/** @constructor */
function $h_Lscalacss_internal_DslBase$DslAttrT$() {
  /*<skip>*/
}
$h_Lscalacss_internal_DslBase$DslAttrT$.prototype = $c_Lscalacss_internal_DslBase$DslAttrT$.prototype;
$c_Lscalacss_internal_DslBase$DslAttrT$.prototype.$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV = (function(this$, value) {
  return new $c_Lscalacss_internal_AV($n(this$).attr__Lscalacss_internal_Attr(), value)
});
$c_Lscalacss_internal_DslBase$DslAttrT$.prototype.$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__Lscalacss_internal_ValueT__Lscalacss_internal_AV = (function(this$, value) {
  return new $c_Lscalacss_internal_AV($n(this$).attr__Lscalacss_internal_Attr(), $n(value).Lscalacss_internal_ValueT__f_value)
});
var $d_Lscalacss_internal_DslBase$DslAttrT$ = new $TypeData().initClass({
  Lscalacss_internal_DslBase$DslAttrT$: 0
}, false, "scalacss.internal.DslBase$DslAttrT$", {
  Lscalacss_internal_DslBase$DslAttrT$: 1,
  O: 1
});
$c_Lscalacss_internal_DslBase$DslAttrT$.prototype.$classData = $d_Lscalacss_internal_DslBase$DslAttrT$;
var $n_Lscalacss_internal_DslBase$DslAttrT$;
function $m_Lscalacss_internal_DslBase$DslAttrT$() {
  if ((!$n_Lscalacss_internal_DslBase$DslAttrT$)) {
    $n_Lscalacss_internal_DslBase$DslAttrT$ = new $c_Lscalacss_internal_DslBase$DslAttrT$()
  };
  return $n_Lscalacss_internal_DslBase$DslAttrT$
}
/** @constructor */
function $c_Lscalacss_internal_DslBase$DslCond(c, b) {
  this.Lscalacss_internal_DslBase$DslCond__f_c = null;
  this.Lscalacss_internal_DslBase$DslCond__f_b = null;
  this.Lscalacss_internal_DslBase$DslCond__f_c = c;
  this.Lscalacss_internal_DslBase$DslCond__f_b = b
}
$c_Lscalacss_internal_DslBase$DslCond.prototype = new $h_O();
$c_Lscalacss_internal_DslBase$DslCond.prototype.constructor = $c_Lscalacss_internal_DslBase$DslCond;
/** @constructor */
function $h_Lscalacss_internal_DslBase$DslCond() {
  /*<skip>*/
}
$h_Lscalacss_internal_DslBase$DslCond.prototype = $c_Lscalacss_internal_DslBase$DslCond.prototype;
$c_Lscalacss_internal_DslBase$DslCond.prototype.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS = (function(t, u) {
  var $$x1 = $n(this.Lscalacss_internal_DslBase$DslCond__f_c);
  var this$1 = $n(this.Lscalacss_internal_DslBase$DslCond__f_b);
  return $n($$x1).applyToStyle__Lscalacss_internal_StyleS__Lscalacss_internal_StyleS(this$1.styleS__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, u))
});
var $d_Lscalacss_internal_DslBase$DslCond = new $TypeData().initClass({
  Lscalacss_internal_DslBase$DslCond: 0
}, false, "scalacss.internal.DslBase$DslCond", {
  Lscalacss_internal_DslBase$DslCond: 1,
  O: 1
});
$c_Lscalacss_internal_DslBase$DslCond.prototype.$classData = $d_Lscalacss_internal_DslBase$DslCond;
/** @constructor */
function $c_Lscalacss_internal_DslBase$ToStyle(s) {
  this.Lscalacss_internal_DslBase$ToStyle__f_s = null;
  this.Lscalacss_internal_DslBase$ToStyle__f_s = s
}
$c_Lscalacss_internal_DslBase$ToStyle.prototype = new $h_O();
$c_Lscalacss_internal_DslBase$ToStyle.prototype.constructor = $c_Lscalacss_internal_DslBase$ToStyle;
/** @constructor */
function $h_Lscalacss_internal_DslBase$ToStyle() {
  /*<skip>*/
}
$h_Lscalacss_internal_DslBase$ToStyle.prototype = $c_Lscalacss_internal_DslBase$ToStyle.prototype;
$c_Lscalacss_internal_DslBase$ToStyle.prototype.hashCode__I = (function() {
  var this$ = this.Lscalacss_internal_DslBase$ToStyle__f_s;
  var this$2 = $n(this$);
  var this$4 = $m_s_util_hashing_MurmurHash3$();
  return this$4.productHash__s_Product__I__Z__I(this$2, (-889275714), false)
});
$c_Lscalacss_internal_DslBase$ToStyle.prototype.equals__O__Z = (function(x$1) {
  return $m_Lscalacss_internal_DslBase$ToStyle$().equals$extension__Lscalacss_internal_StyleS__O__Z(this.Lscalacss_internal_DslBase$ToStyle__f_s, x$1)
});
function $as_Lscalacss_internal_DslBase$ToStyle(obj) {
  return (((obj instanceof $c_Lscalacss_internal_DslBase$ToStyle) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.DslBase$ToStyle"))
}
function $isArrayOf_Lscalacss_internal_DslBase$ToStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_DslBase$ToStyle)))
}
function $asArrayOf_Lscalacss_internal_DslBase$ToStyle(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_DslBase$ToStyle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.DslBase$ToStyle;", depth))
}
var $d_Lscalacss_internal_DslBase$ToStyle = new $TypeData().initClass({
  Lscalacss_internal_DslBase$ToStyle: 0
}, false, "scalacss.internal.DslBase$ToStyle", {
  Lscalacss_internal_DslBase$ToStyle: 1,
  O: 1
});
$c_Lscalacss_internal_DslBase$ToStyle.prototype.$classData = $d_Lscalacss_internal_DslBase$ToStyle;
/** @constructor */
function $c_Lscalacss_internal_DslBase$ToStyle$() {
  /*<skip>*/
}
$c_Lscalacss_internal_DslBase$ToStyle$.prototype = new $h_O();
$c_Lscalacss_internal_DslBase$ToStyle$.prototype.constructor = $c_Lscalacss_internal_DslBase$ToStyle$;
/** @constructor */
function $h_Lscalacss_internal_DslBase$ToStyle$() {
  /*<skip>*/
}
$h_Lscalacss_internal_DslBase$ToStyle$.prototype = $c_Lscalacss_internal_DslBase$ToStyle$.prototype;
$c_Lscalacss_internal_DslBase$ToStyle$.prototype.equals$extension__Lscalacss_internal_StyleS__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Lscalacss_internal_DslBase$ToStyle)) {
    var ToStyle$1 = ((x$1 === null) ? null : $n($as_Lscalacss_internal_DslBase$ToStyle(x$1)).Lscalacss_internal_DslBase$ToStyle__f_s);
    return ((this$ === null) ? (ToStyle$1 === null) : $n(this$).equals__O__Z(ToStyle$1))
  } else {
    return false
  }
});
var $d_Lscalacss_internal_DslBase$ToStyle$ = new $TypeData().initClass({
  Lscalacss_internal_DslBase$ToStyle$: 0
}, false, "scalacss.internal.DslBase$ToStyle$", {
  Lscalacss_internal_DslBase$ToStyle$: 1,
  O: 1
});
$c_Lscalacss_internal_DslBase$ToStyle$.prototype.$classData = $d_Lscalacss_internal_DslBase$ToStyle$;
var $n_Lscalacss_internal_DslBase$ToStyle$;
function $m_Lscalacss_internal_DslBase$ToStyle$() {
  if ((!$n_Lscalacss_internal_DslBase$ToStyle$)) {
    $n_Lscalacss_internal_DslBase$ToStyle$ = new $c_Lscalacss_internal_DslBase$ToStyle$()
  };
  return $n_Lscalacss_internal_DslBase$ToStyle$
}
/** @constructor */
function $c_Lscalacss_internal_DslMacros$() {
  this.Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffix = null;
  this.Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffixB = null;
  this.Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffixI = null;
  $n_Lscalacss_internal_DslMacros$ = this;
  this.Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffix = new $c_sjsr_AnonFunction2(((x$5$2, index$2) => {
    var index = $uI(index$2);
    var this$2 = ((1 + index) | 0);
    return ("" + this$2)
  }));
  this.Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffixB = new $c_sjsr_AnonFunction2(((b$2, x$6$2) => {
    var b = $uZ(b$2);
    $uI(x$6$2);
    return (b ? "t" : "f")
  }));
  this.Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffixI = new $c_sjsr_AnonFunction2(((i$2, x$7$2) => {
    var i = $uI(i$2);
    $uI(x$7$2);
    return ("" + i)
  }))
}
$c_Lscalacss_internal_DslMacros$.prototype = new $h_O();
$c_Lscalacss_internal_DslMacros$.prototype.constructor = $c_Lscalacss_internal_DslMacros$;
/** @constructor */
function $h_Lscalacss_internal_DslMacros$() {
  /*<skip>*/
}
$h_Lscalacss_internal_DslMacros$.prototype = $c_Lscalacss_internal_DslMacros$.prototype;
var $d_Lscalacss_internal_DslMacros$ = new $TypeData().initClass({
  Lscalacss_internal_DslMacros$: 0
}, false, "scalacss.internal.DslMacros$", {
  Lscalacss_internal_DslMacros$: 1,
  O: 1
});
$c_Lscalacss_internal_DslMacros$.prototype.$classData = $d_Lscalacss_internal_DslMacros$;
var $n_Lscalacss_internal_DslMacros$;
function $m_Lscalacss_internal_DslMacros$() {
  if ((!$n_Lscalacss_internal_DslMacros$)) {
    $n_Lscalacss_internal_DslMacros$ = new $c_Lscalacss_internal_DslMacros$()
  };
  return $n_Lscalacss_internal_DslMacros$
}
function $f_Lscalacss_internal_DslMacros$MStyleF2__int__sci_Range__F1__F1($thiz, r, f) {
  return $thiz.create__s_Option__Lscalacss_internal_Domain__F1__F2__Lscalacss_internal_StyleLookup__F1($m_s_None$(), ($m_Lscalacss_internal_Domain$(), new $c_Lscalacss_internal_Domain$OverSeq(r)), f, $m_Lscalacss_internal_DslMacros$().Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffixI, $m_Lscalacss_internal_StyleLookup$().Lscalacss_internal_StyleLookup$__f_int)
}
function $ct_Lscalacss_internal_LengthUnit__T__($thiz, value) {
  $thiz.Lscalacss_internal_LengthUnit__f_value = value;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_LengthUnit() {
  this.Lscalacss_internal_LengthUnit__f_value = null
}
$c_Lscalacss_internal_LengthUnit.prototype = new $h_O();
$c_Lscalacss_internal_LengthUnit.prototype.constructor = $c_Lscalacss_internal_LengthUnit;
/** @constructor */
function $h_Lscalacss_internal_LengthUnit() {
  /*<skip>*/
}
$h_Lscalacss_internal_LengthUnit.prototype = $c_Lscalacss_internal_LengthUnit.prototype;
function $ct_Lscalacss_internal_Literal__T__($thiz, value) {
  $thiz.Lscalacss_internal_Literal__f_value = value;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_Literal() {
  this.Lscalacss_internal_Literal__f_value = null
}
$c_Lscalacss_internal_Literal.prototype = new $h_O();
$c_Lscalacss_internal_Literal.prototype.constructor = $c_Lscalacss_internal_Literal;
/** @constructor */
function $h_Lscalacss_internal_Literal() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal.prototype = $c_Lscalacss_internal_Literal.prototype;
$c_Lscalacss_internal_Literal.prototype.toString__T = (function() {
  return (("Literal(" + this.Lscalacss_internal_Literal__f_value) + ")")
});
function $as_Lscalacss_internal_Literal(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Literal) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Literal"))
}
function $isArrayOf_Lscalacss_internal_Literal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Literal)))
}
function $asArrayOf_Lscalacss_internal_Literal(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Literal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Literal;", depth))
}
function $p_Lscalacss_internal_Media$__paren__T__T($thiz, c) {
  var $$x1 = $m_Lscalacss_internal_Media$StringExt$();
  var _s = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("(", c);
  return $n($$x1).$tilde$extension__T__T__T(_s, ")")
}
/** @constructor */
function $c_Lscalacss_internal_Media$() {
  this.Lscalacss_internal_Media$__f_cssFeature = null;
  this.Lscalacss_internal_Media$__f_cssTypeExpr = null;
  $n_Lscalacss_internal_Media$ = this;
  var x = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lscalacss_internal_Media$Feature(x0$1$2);
    if (false) {
      var x2 = $as_Lscalacss_internal_Media$AspectRatio(x0$1);
      var v = $n(x2).ratio__Lscalacss_internal_Media$ValueExpr();
      $m_Lscalacss_internal_Media$();
      var f = ((r$2) => {
        var r = $as_Lscalacss_internal_Ratio(r$2);
        $m_Lscalacss_internal_Media$();
        return $n(r).value__T()
      });
      if (false) {
        var x2$1 = $as_Lscalacss_internal_Media$Eql(v);
        var t = $n(x2$1).eql__O();
        var $$x1 = $m_Lscalacss_internal_Media$StringExt$();
        var _s = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("aspect-ratio", ":");
        return $n($$x1).$tilde$extension__T__T__T(_s, $as_T(f(t)))
      } else if ((v instanceof $c_Lscalacss_internal_Media$Min)) {
        var x3 = $as_Lscalacss_internal_Media$Min(v);
        var t$2 = $n(x3).Lscalacss_internal_Media$Min__f_min;
        var $$x3 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x2 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$1 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "aspect-ratio");
        var _s$2 = $n($$x2).$tilde$extension__T__T__T(_s$1, ":");
        return $n($$x3).$tilde$extension__T__T__T(_s$2, $as_T(f(t$2)))
      } else if ((v instanceof $c_Lscalacss_internal_Media$Max)) {
        var x4 = $as_Lscalacss_internal_Media$Max(v);
        var t$3 = $n(x4).Lscalacss_internal_Media$Max__f_max;
        var $$x5 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x4 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$3 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "aspect-ratio");
        var _s$4 = $n($$x4).$tilde$extension__T__T__T(_s$3, ":");
        return $n($$x5).$tilde$extension__T__T__T(_s$4, $as_T(f(t$3)))
      } else {
        throw new $c_s_MatchError(v)
      }
    } else if (false) {
      var x3$1 = $as_Lscalacss_internal_Media$Height(x0$1);
      var v$2 = $n(x3$1).length__Lscalacss_internal_Media$ValueExpr();
      $m_Lscalacss_internal_Media$();
      var f$1 = ((l$2) => {
        var l = $as_Lscalacss_internal_Length(l$2);
        $m_Lscalacss_internal_Media$();
        return $n(l).value__T()
      });
      if (false) {
        var x2$2 = $as_Lscalacss_internal_Media$Eql(v$2);
        var t$1 = $n(x2$2).eql__O();
        var $$x6 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$5 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("height", ":");
        return $n($$x6).$tilde$extension__T__T__T(_s$5, $as_T(f$1(t$1)))
      } else if ((v$2 instanceof $c_Lscalacss_internal_Media$Min)) {
        var x3$2 = $as_Lscalacss_internal_Media$Min(v$2);
        var t$2$1 = $n(x3$2).Lscalacss_internal_Media$Min__f_min;
        var $$x8 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x7 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$6 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "height");
        var _s$7 = $n($$x7).$tilde$extension__T__T__T(_s$6, ":");
        return $n($$x8).$tilde$extension__T__T__T(_s$7, $as_T(f$1(t$2$1)))
      } else if ((v$2 instanceof $c_Lscalacss_internal_Media$Max)) {
        var x4$1 = $as_Lscalacss_internal_Media$Max(v$2);
        var t$3$1 = $n(x4$1).Lscalacss_internal_Media$Max__f_max;
        var $$x10 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x9 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$8 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "height");
        var _s$9 = $n($$x9).$tilde$extension__T__T__T(_s$8, ":");
        return $n($$x10).$tilde$extension__T__T__T(_s$9, $as_T(f$1(t$3$1)))
      } else {
        throw new $c_s_MatchError(v$2)
      }
    } else if ((x0$1 instanceof $c_Lscalacss_internal_Media$Width)) {
      var x4$2 = $as_Lscalacss_internal_Media$Width(x0$1);
      var v$3 = $n(x4$2).Lscalacss_internal_Media$Width__f_length;
      $m_Lscalacss_internal_Media$();
      var f$2 = ((l$3$2) => {
        var l$3 = $as_Lscalacss_internal_Length(l$3$2);
        $m_Lscalacss_internal_Media$();
        return $n(l$3).value__T()
      });
      if (false) {
        var x2$3 = $as_Lscalacss_internal_Media$Eql(v$3);
        var t$4 = $n(x2$3).eql__O();
        var $$x11 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$10 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("width", ":");
        return $n($$x11).$tilde$extension__T__T__T(_s$10, $as_T(f$2(t$4)))
      } else if ((v$3 instanceof $c_Lscalacss_internal_Media$Min)) {
        var x3$3 = $as_Lscalacss_internal_Media$Min(v$3);
        var t$2$2 = $n(x3$3).Lscalacss_internal_Media$Min__f_min;
        var $$x13 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x12 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$11 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "width");
        var _s$12 = $n($$x12).$tilde$extension__T__T__T(_s$11, ":");
        return $n($$x13).$tilde$extension__T__T__T(_s$12, $as_T(f$2(t$2$2)))
      } else if ((v$3 instanceof $c_Lscalacss_internal_Media$Max)) {
        var x4$3 = $as_Lscalacss_internal_Media$Max(v$3);
        var t$3$2 = $n(x4$3).Lscalacss_internal_Media$Max__f_max;
        var $$x15 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x14 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$13 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "width");
        var _s$14 = $n($$x14).$tilde$extension__T__T__T(_s$13, ":");
        return $n($$x15).$tilde$extension__T__T__T(_s$14, $as_T(f$2(t$3$2)))
      } else {
        throw new $c_s_MatchError(v$3)
      }
    } else if (false) {
      var x5 = $as_Lscalacss_internal_Media$DeviceAspectRatio(x0$1);
      var v$4 = $n(x5).ratio__Lscalacss_internal_Media$ValueExpr();
      $m_Lscalacss_internal_Media$();
      var f$3 = ((r$3$2) => {
        var r$3 = $as_Lscalacss_internal_Ratio(r$3$2);
        $m_Lscalacss_internal_Media$();
        return $n(r$3).value__T()
      });
      if (false) {
        var x2$4 = $as_Lscalacss_internal_Media$Eql(v$4);
        var t$5 = $n(x2$4).eql__O();
        var $$x16 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$15 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("device-aspect-ratio", ":");
        return $n($$x16).$tilde$extension__T__T__T(_s$15, $as_T(f$3(t$5)))
      } else if ((v$4 instanceof $c_Lscalacss_internal_Media$Min)) {
        var x3$4 = $as_Lscalacss_internal_Media$Min(v$4);
        var t$2$3 = $n(x3$4).Lscalacss_internal_Media$Min__f_min;
        var $$x18 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x17 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$16 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "device-aspect-ratio");
        var _s$17 = $n($$x17).$tilde$extension__T__T__T(_s$16, ":");
        return $n($$x18).$tilde$extension__T__T__T(_s$17, $as_T(f$3(t$2$3)))
      } else if ((v$4 instanceof $c_Lscalacss_internal_Media$Max)) {
        var x4$4 = $as_Lscalacss_internal_Media$Max(v$4);
        var t$3$3 = $n(x4$4).Lscalacss_internal_Media$Max__f_max;
        var $$x20 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x19 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$18 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "device-aspect-ratio");
        var _s$19 = $n($$x19).$tilde$extension__T__T__T(_s$18, ":");
        return $n($$x20).$tilde$extension__T__T__T(_s$19, $as_T(f$3(t$3$3)))
      } else {
        throw new $c_s_MatchError(v$4)
      }
    } else if (false) {
      var x6 = $as_Lscalacss_internal_Media$DeviceHeight(x0$1);
      var v$5 = $n(x6).length__Lscalacss_internal_Media$ValueExpr();
      $m_Lscalacss_internal_Media$();
      var f$4 = ((l$4$2) => {
        var l$4 = $as_Lscalacss_internal_Length(l$4$2);
        $m_Lscalacss_internal_Media$();
        return $n(l$4).value__T()
      });
      if (false) {
        var x2$5 = $as_Lscalacss_internal_Media$Eql(v$5);
        var t$6 = $n(x2$5).eql__O();
        var $$x21 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$20 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("device-height", ":");
        return $n($$x21).$tilde$extension__T__T__T(_s$20, $as_T(f$4(t$6)))
      } else if ((v$5 instanceof $c_Lscalacss_internal_Media$Min)) {
        var x3$5 = $as_Lscalacss_internal_Media$Min(v$5);
        var t$2$4 = $n(x3$5).Lscalacss_internal_Media$Min__f_min;
        var $$x23 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x22 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$21 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "device-height");
        var _s$22 = $n($$x22).$tilde$extension__T__T__T(_s$21, ":");
        return $n($$x23).$tilde$extension__T__T__T(_s$22, $as_T(f$4(t$2$4)))
      } else if ((v$5 instanceof $c_Lscalacss_internal_Media$Max)) {
        var x4$5 = $as_Lscalacss_internal_Media$Max(v$5);
        var t$3$4 = $n(x4$5).Lscalacss_internal_Media$Max__f_max;
        var $$x25 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x24 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$23 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "device-height");
        var _s$24 = $n($$x24).$tilde$extension__T__T__T(_s$23, ":");
        return $n($$x25).$tilde$extension__T__T__T(_s$24, $as_T(f$4(t$3$4)))
      } else {
        throw new $c_s_MatchError(v$5)
      }
    } else if (false) {
      var x7 = $as_Lscalacss_internal_Media$DeviceWidth(x0$1);
      var v$6 = $n(x7).length__Lscalacss_internal_Media$ValueExpr();
      $m_Lscalacss_internal_Media$();
      var f$5 = ((l$5$2) => {
        var l$5 = $as_Lscalacss_internal_Length(l$5$2);
        $m_Lscalacss_internal_Media$();
        return $n(l$5).value__T()
      });
      if (false) {
        var x2$6 = $as_Lscalacss_internal_Media$Eql(v$6);
        var t$7 = $n(x2$6).eql__O();
        var $$x26 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$25 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("device-width", ":");
        return $n($$x26).$tilde$extension__T__T__T(_s$25, $as_T(f$5(t$7)))
      } else if ((v$6 instanceof $c_Lscalacss_internal_Media$Min)) {
        var x3$6 = $as_Lscalacss_internal_Media$Min(v$6);
        var t$2$5 = $n(x3$6).Lscalacss_internal_Media$Min__f_min;
        var $$x28 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x27 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$26 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "device-width");
        var _s$27 = $n($$x27).$tilde$extension__T__T__T(_s$26, ":");
        return $n($$x28).$tilde$extension__T__T__T(_s$27, $as_T(f$5(t$2$5)))
      } else if ((v$6 instanceof $c_Lscalacss_internal_Media$Max)) {
        var x4$6 = $as_Lscalacss_internal_Media$Max(v$6);
        var t$3$5 = $n(x4$6).Lscalacss_internal_Media$Max__f_max;
        var $$x30 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x29 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$28 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "device-width");
        var _s$29 = $n($$x29).$tilde$extension__T__T__T(_s$28, ":");
        return $n($$x30).$tilde$extension__T__T__T(_s$29, $as_T(f$5(t$3$5)))
      } else {
        throw new $c_s_MatchError(v$6)
      }
    } else if (false) {
      var x8 = $as_Lscalacss_internal_Media$Color(x0$1);
      var v$7 = $n(x8).bits__s_Option();
      $m_Lscalacss_internal_Media$();
      var f$6 = ((i$2) => {
        var i = $uI(i$2);
        $m_Lscalacss_internal_Media$();
        return ("" + i)
      });
      var this$17 = $n(v$7);
      if (this$17.isEmpty__Z()) {
        var $$x31 = "color"
      } else {
        var arg1 = this$17.get__O();
        var x$5 = $as_Lscalacss_internal_Media$ValueExpr(arg1);
        $m_Lscalacss_internal_Media$();
        if (false) {
          var x2$7 = $as_Lscalacss_internal_Media$Eql(x$5);
          var t$8 = $n(x2$7).eql__O();
          var $$x32 = $m_Lscalacss_internal_Media$StringExt$();
          var _s$30 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("color", ":");
          var $$x31 = $n($$x32).$tilde$extension__T__T__T(_s$30, $as_T(f$6(t$8)))
        } else if ((x$5 instanceof $c_Lscalacss_internal_Media$Min)) {
          var x3$7 = $as_Lscalacss_internal_Media$Min(x$5);
          var t$2$6 = $n(x3$7).Lscalacss_internal_Media$Min__f_min;
          var $$x34 = $m_Lscalacss_internal_Media$StringExt$();
          var $$x33 = $m_Lscalacss_internal_Media$StringExt$();
          var _s$31 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "color");
          var _s$32 = $n($$x33).$tilde$extension__T__T__T(_s$31, ":");
          var $$x31 = $n($$x34).$tilde$extension__T__T__T(_s$32, $as_T(f$6(t$2$6)))
        } else {
          if ((!(x$5 instanceof $c_Lscalacss_internal_Media$Max))) {
            throw new $c_s_MatchError(x$5)
          };
          var x4$7 = $as_Lscalacss_internal_Media$Max(x$5);
          var t$3$6 = $n(x4$7).Lscalacss_internal_Media$Max__f_max;
          var $$x36 = $m_Lscalacss_internal_Media$StringExt$();
          var $$x35 = $m_Lscalacss_internal_Media$StringExt$();
          var _s$33 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "color");
          var _s$34 = $n($$x35).$tilde$extension__T__T__T(_s$33, ":");
          var $$x31 = $n($$x36).$tilde$extension__T__T__T(_s$34, $as_T(f$6(t$3$6)))
        }
      };
      return $as_T($$x31)
    } else if (false) {
      var x9 = $as_Lscalacss_internal_Media$ColorIndex(x0$1);
      var v$8 = $n(x9).index__s_Option();
      $m_Lscalacss_internal_Media$();
      var f$7 = ((i$3$2) => {
        var i$3 = $uI(i$3$2);
        $m_Lscalacss_internal_Media$();
        return ("" + i$3)
      });
      var this$22 = $n(v$8);
      if (this$22.isEmpty__Z()) {
        var $$x37 = "color-index"
      } else {
        var arg1$1 = this$22.get__O();
        var x$5$1 = $as_Lscalacss_internal_Media$ValueExpr(arg1$1);
        $m_Lscalacss_internal_Media$();
        if (false) {
          var x2$8 = $as_Lscalacss_internal_Media$Eql(x$5$1);
          var t$9 = $n(x2$8).eql__O();
          var $$x38 = $m_Lscalacss_internal_Media$StringExt$();
          var _s$35 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("color-index", ":");
          var $$x37 = $n($$x38).$tilde$extension__T__T__T(_s$35, $as_T(f$7(t$9)))
        } else if ((x$5$1 instanceof $c_Lscalacss_internal_Media$Min)) {
          var x3$8 = $as_Lscalacss_internal_Media$Min(x$5$1);
          var t$2$7 = $n(x3$8).Lscalacss_internal_Media$Min__f_min;
          var $$x40 = $m_Lscalacss_internal_Media$StringExt$();
          var $$x39 = $m_Lscalacss_internal_Media$StringExt$();
          var _s$36 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "color-index");
          var _s$37 = $n($$x39).$tilde$extension__T__T__T(_s$36, ":");
          var $$x37 = $n($$x40).$tilde$extension__T__T__T(_s$37, $as_T(f$7(t$2$7)))
        } else {
          if ((!(x$5$1 instanceof $c_Lscalacss_internal_Media$Max))) {
            throw new $c_s_MatchError(x$5$1)
          };
          var x4$8 = $as_Lscalacss_internal_Media$Max(x$5$1);
          var t$3$7 = $n(x4$8).Lscalacss_internal_Media$Max__f_max;
          var $$x42 = $m_Lscalacss_internal_Media$StringExt$();
          var $$x41 = $m_Lscalacss_internal_Media$StringExt$();
          var _s$38 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "color-index");
          var _s$39 = $n($$x41).$tilde$extension__T__T__T(_s$38, ":");
          var $$x37 = $n($$x42).$tilde$extension__T__T__T(_s$39, $as_T(f$7(t$3$7)))
        }
      };
      return $as_T($$x37)
    } else if (false) {
      var x10 = $as_Lscalacss_internal_Media$Resolution(x0$1);
      var v$9 = $n(x10).res__Lscalacss_internal_Media$ValueExpr();
      $m_Lscalacss_internal_Media$();
      var f$8 = ((r$4$2) => {
        var r$4 = $as_Lscalacss_internal_Resolution(r$4$2);
        $m_Lscalacss_internal_Media$();
        return $n(r$4).value__T()
      });
      if (false) {
        var x2$9 = $as_Lscalacss_internal_Media$Eql(v$9);
        var t$10 = $n(x2$9).eql__O();
        var $$x43 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$40 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("resolution", ":");
        return $n($$x43).$tilde$extension__T__T__T(_s$40, $as_T(f$8(t$10)))
      } else if ((v$9 instanceof $c_Lscalacss_internal_Media$Min)) {
        var x3$9 = $as_Lscalacss_internal_Media$Min(v$9);
        var t$2$8 = $n(x3$9).Lscalacss_internal_Media$Min__f_min;
        var $$x45 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x44 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$41 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "resolution");
        var _s$42 = $n($$x44).$tilde$extension__T__T__T(_s$41, ":");
        return $n($$x45).$tilde$extension__T__T__T(_s$42, $as_T(f$8(t$2$8)))
      } else if ((v$9 instanceof $c_Lscalacss_internal_Media$Max)) {
        var x4$9 = $as_Lscalacss_internal_Media$Max(v$9);
        var t$3$8 = $n(x4$9).Lscalacss_internal_Media$Max__f_max;
        var $$x47 = $m_Lscalacss_internal_Media$StringExt$();
        var $$x46 = $m_Lscalacss_internal_Media$StringExt$();
        var _s$43 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "resolution");
        var _s$44 = $n($$x46).$tilde$extension__T__T__T(_s$43, ":");
        return $n($$x47).$tilde$extension__T__T__T(_s$44, $as_T(f$8(t$3$8)))
      } else {
        throw new $c_s_MatchError(v$9)
      }
    } else if (false) {
      var x11 = $as_Lscalacss_internal_Media$Monochrome(x0$1);
      var v$10 = $n(x11).bitsPerPx__s_Option();
      $m_Lscalacss_internal_Media$();
      var f$9 = ((i$4$2) => {
        var i$4 = $uI(i$4$2);
        $m_Lscalacss_internal_Media$();
        return ("" + i$4)
      });
      var this$29 = $n(v$10);
      if (this$29.isEmpty__Z()) {
        var $$x48 = "monochrome"
      } else {
        var arg1$2 = this$29.get__O();
        var x$5$2 = $as_Lscalacss_internal_Media$ValueExpr(arg1$2);
        $m_Lscalacss_internal_Media$();
        if (false) {
          var x2$10 = $as_Lscalacss_internal_Media$Eql(x$5$2);
          var t$11 = $n(x2$10).eql__O();
          var $$x49 = $m_Lscalacss_internal_Media$StringExt$();
          var _s$45 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("monochrome", ":");
          var $$x48 = $n($$x49).$tilde$extension__T__T__T(_s$45, $as_T(f$9(t$11)))
        } else if ((x$5$2 instanceof $c_Lscalacss_internal_Media$Min)) {
          var x3$10 = $as_Lscalacss_internal_Media$Min(x$5$2);
          var t$2$9 = $n(x3$10).Lscalacss_internal_Media$Min__f_min;
          var $$x51 = $m_Lscalacss_internal_Media$StringExt$();
          var $$x50 = $m_Lscalacss_internal_Media$StringExt$();
          var _s$46 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("min-", "monochrome");
          var _s$47 = $n($$x50).$tilde$extension__T__T__T(_s$46, ":");
          var $$x48 = $n($$x51).$tilde$extension__T__T__T(_s$47, $as_T(f$9(t$2$9)))
        } else {
          if ((!(x$5$2 instanceof $c_Lscalacss_internal_Media$Max))) {
            throw new $c_s_MatchError(x$5$2)
          };
          var x4$10 = $as_Lscalacss_internal_Media$Max(x$5$2);
          var t$3$9 = $n(x4$10).Lscalacss_internal_Media$Max__f_max;
          var $$x53 = $m_Lscalacss_internal_Media$StringExt$();
          var $$x52 = $m_Lscalacss_internal_Media$StringExt$();
          var _s$48 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("max-", "monochrome");
          var _s$49 = $n($$x52).$tilde$extension__T__T__T(_s$48, ":");
          var $$x48 = $n($$x53).$tilde$extension__T__T__T(_s$49, $as_T(f$9(t$3$9)))
        }
      };
      return $as_T($$x48)
    } else if ((x0$1 instanceof $c_Lscalacss_internal_Media$Orientation)) {
      var x12 = $as_Lscalacss_internal_Media$Orientation(x0$1);
      var v$11 = $n(x12).Lscalacss_internal_Media$Orientation__f_value;
      return $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T(($m_Lscalacss_internal_Media$(), "orientation:"), $n(v$11).Lscalacss_internal_Media$OrientationValue__f_value)
    } else if (false) {
      var x13 = $as_Lscalacss_internal_Media$Scan(x0$1);
      var v$12 = $n(x13).value__Lscalacss_internal_Media$ScanValue();
      return $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T(($m_Lscalacss_internal_Media$(), "scan:"), $n(v$12).value__T())
    } else if ((x0$1 instanceof $c_Lscalacss_internal_Media$PrefersColorScheme)) {
      var x14 = $as_Lscalacss_internal_Media$PrefersColorScheme(x0$1);
      var v$13 = $n(x14).Lscalacss_internal_Media$PrefersColorScheme__f_value;
      return $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T(($m_Lscalacss_internal_Media$(), "prefers-color-scheme:"), $n(v$13).Lscalacss_internal_Media$PrefersColorSchemeValue__f_value)
    } else if (false) {
      var x15 = $as_Lscalacss_internal_Media$Grid(x0$1);
      var v$14 = $n(x15).value__s_Option();
      $m_Lscalacss_internal_Media$();
      var this$35 = $n(v$14);
      if (this$35.isEmpty__Z()) {
        var $$x54 = "grid"
      } else {
        var arg1$3 = this$35.get__O();
        var $$x55 = $m_Lscalacss_internal_Media$StringExt$();
        $m_Lscalacss_internal_Media$();
        var _s$50 = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T(($m_Lscalacss_internal_Media$(), "grid"), ($m_Lscalacss_internal_Media$(), ":"));
        var i$5 = $uI(arg1$3);
        $m_Lscalacss_internal_Media$();
        var $$x54 = $n($$x55).$tilde$extension__T__T__T(_s$50, ("" + i$5))
      };
      return $as_T($$x54)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  this.Lscalacss_internal_Media$__f_cssFeature = new $c_sjsr_AnonFunction1(((f$2$1) => {
    var f$10 = $as_Lscalacss_internal_Media$Feature(f$2$1);
    return $p_Lscalacss_internal_Media$__paren__T__T($m_Lscalacss_internal_Media$(), $as_T(x.apply__O__O(f$10)))
  }));
  this.Lscalacss_internal_Media$__f_cssTypeExpr = new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_Lscalacss_internal_Media$TypeExpr(x0$2$2);
    if ((x0$2 instanceof $c_Lscalacss_internal_Media$Just)) {
      var x2$11 = $as_Lscalacss_internal_Media$Just(x0$2);
      var t$12 = $n(x2$11).Lscalacss_internal_Media$Just__f_t;
      return $n(t$12).Lscalacss_internal_Media$TypeA__f_value
    } else if ((x0$2 instanceof $c_Lscalacss_internal_Media$Not)) {
      var x3$11 = $as_Lscalacss_internal_Media$Not(x0$2);
      var t$2$10 = $n(x3$11).Lscalacss_internal_Media$Not__f_t;
      return $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T(($m_Lscalacss_internal_Media$(), "not "), $n(t$2$10).Lscalacss_internal_Media$TypeA__f_value)
    } else if (false) {
      var x4$11 = $as_Lscalacss_internal_Media$Only(x0$2);
      var t$3$10 = $n(x4$11).t__Lscalacss_internal_Media$TypeA();
      return $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T(($m_Lscalacss_internal_Media$(), "only "), $n(t$3$10).Lscalacss_internal_Media$TypeA__f_value)
    } else {
      throw new $c_s_MatchError(x0$2)
    }
  }))
}
$c_Lscalacss_internal_Media$.prototype = new $h_O();
$c_Lscalacss_internal_Media$.prototype.constructor = $c_Lscalacss_internal_Media$;
/** @constructor */
function $h_Lscalacss_internal_Media$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$.prototype = $c_Lscalacss_internal_Media$.prototype;
$c_Lscalacss_internal_Media$.prototype.cssQueries__Lscalacss_internal_NonEmptyVector__T = (function(qs) {
  var this$2 = $n(qs);
  var f = ((x$6$2) => {
    var x$6 = $as_Lscalacss_internal_Media$Query(x$6$2);
    return $n(x$6).Lscalacss_internal_Media$Query__f_cssSuffix
  });
  var this$3 = $n(this$2.Lscalacss_internal_NonEmptyVector__f_tail);
  var arg1 = this$2.Lscalacss_internal_NonEmptyVector__f_head;
  var z = f(arg1);
  var at = 0;
  var end = this$3.length__I();
  var acc = z;
  var $$x1;
  while (true) {
    if ((at !== end)) {
      var temp$at = ((1 + at) | 0);
      var arg1$1 = acc;
      var arg2 = this$3.apply__I__O(at);
      var arg2$1 = f(arg2);
      var x$7 = $as_T(arg1$1);
      var x$8 = $as_T(arg2$1);
      var $$x2 = $m_Lscalacss_internal_Media$StringExt$();
      $m_Lscalacss_internal_Media$();
      var _s = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T(($m_Lscalacss_internal_Media$(), x$7), ($m_Lscalacss_internal_Media$(), ", "));
      var temp$acc = $n($$x2).$tilde$extension__T__T__T(_s, x$8);
      at = temp$at;
      acc = temp$acc;
      continue
    };
    var $$x1 = acc;
    break
  };
  return $as_T($$x1)
});
$c_Lscalacss_internal_Media$.prototype.css__Lscalacss_internal_NonEmptyVector__T = (function(qs) {
  return $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T("@media ", this.cssQueries__Lscalacss_internal_NonEmptyVector__T(qs))
});
var $d_Lscalacss_internal_Media$ = new $TypeData().initClass({
  Lscalacss_internal_Media$: 0
}, false, "scalacss.internal.Media$", {
  Lscalacss_internal_Media$: 1,
  O: 1
});
$c_Lscalacss_internal_Media$.prototype.$classData = $d_Lscalacss_internal_Media$;
var $n_Lscalacss_internal_Media$;
function $m_Lscalacss_internal_Media$() {
  if ((!$n_Lscalacss_internal_Media$)) {
    $n_Lscalacss_internal_Media$ = new $c_Lscalacss_internal_Media$()
  };
  return $n_Lscalacss_internal_Media$
}
function $is_Lscalacss_internal_Media$Feature(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalacss_internal_Media$Feature)))
}
function $as_Lscalacss_internal_Media$Feature(obj) {
  return (($is_Lscalacss_internal_Media$Feature(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Feature"))
}
function $isArrayOf_Lscalacss_internal_Media$Feature(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Feature)))
}
function $asArrayOf_Lscalacss_internal_Media$Feature(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Feature(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Feature;", depth))
}
function $f_Lscalacss_internal_Media$FeatureOps__minWidth__Lscalacss_internal_Length__O($thiz, v) {
  return $n($thiz.F__F1()).apply__O__O(new $c_Lscalacss_internal_Media$Width(new $c_Lscalacss_internal_Media$Min(v)))
}
function $f_Lscalacss_internal_Media$FeatureOps__maxWidth__Lscalacss_internal_Length__O($thiz, v) {
  return $n($thiz.F__F1()).apply__O__O(new $c_Lscalacss_internal_Media$Width(new $c_Lscalacss_internal_Media$Max(v)))
}
function $f_Lscalacss_internal_Media$FeatureOps__landscape__O($thiz) {
  return $n($thiz.F__F1()).apply__O__O(new $c_Lscalacss_internal_Media$Orientation($m_Lscalacss_internal_Media$Landscape$()))
}
function $f_Lscalacss_internal_Media$FeatureOps__portrait__O($thiz) {
  return $n($thiz.F__F1()).apply__O__O(new $c_Lscalacss_internal_Media$Orientation($m_Lscalacss_internal_Media$Portrait$()))
}
function $f_Lscalacss_internal_Media$FeatureOps__dark__O($thiz) {
  return $n($thiz.F__F1()).apply__O__O(new $c_Lscalacss_internal_Media$PrefersColorScheme($m_Lscalacss_internal_Media$Dark$()))
}
function $is_Lscalacss_internal_Media$FeatureOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalacss_internal_Media$FeatureOps)))
}
function $as_Lscalacss_internal_Media$FeatureOps(obj) {
  return (($is_Lscalacss_internal_Media$FeatureOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$FeatureOps"))
}
function $isArrayOf_Lscalacss_internal_Media$FeatureOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$FeatureOps)))
}
function $asArrayOf_Lscalacss_internal_Media$FeatureOps(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$FeatureOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$FeatureOps;", depth))
}
function $ct_Lscalacss_internal_Media$OrientationValue__T__($thiz, value) {
  $thiz.Lscalacss_internal_Media$OrientationValue__f_value = value;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_Media$OrientationValue() {
  this.Lscalacss_internal_Media$OrientationValue__f_value = null
}
$c_Lscalacss_internal_Media$OrientationValue.prototype = new $h_O();
$c_Lscalacss_internal_Media$OrientationValue.prototype.constructor = $c_Lscalacss_internal_Media$OrientationValue;
/** @constructor */
function $h_Lscalacss_internal_Media$OrientationValue() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$OrientationValue.prototype = $c_Lscalacss_internal_Media$OrientationValue.prototype;
function $ct_Lscalacss_internal_Media$PrefersColorSchemeValue__T__($thiz, value) {
  $thiz.Lscalacss_internal_Media$PrefersColorSchemeValue__f_value = value;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_Media$PrefersColorSchemeValue() {
  this.Lscalacss_internal_Media$PrefersColorSchemeValue__f_value = null
}
$c_Lscalacss_internal_Media$PrefersColorSchemeValue.prototype = new $h_O();
$c_Lscalacss_internal_Media$PrefersColorSchemeValue.prototype.constructor = $c_Lscalacss_internal_Media$PrefersColorSchemeValue;
/** @constructor */
function $h_Lscalacss_internal_Media$PrefersColorSchemeValue() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$PrefersColorSchemeValue.prototype = $c_Lscalacss_internal_Media$PrefersColorSchemeValue.prototype;
/** @constructor */
function $c_Lscalacss_internal_Media$StringExt$() {
  /*<skip>*/
}
$c_Lscalacss_internal_Media$StringExt$.prototype = new $h_O();
$c_Lscalacss_internal_Media$StringExt$.prototype.constructor = $c_Lscalacss_internal_Media$StringExt$;
/** @constructor */
function $h_Lscalacss_internal_Media$StringExt$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$StringExt$.prototype = $c_Lscalacss_internal_Media$StringExt$.prototype;
$c_Lscalacss_internal_Media$StringExt$.prototype.$tilde$extension__T__T__T = (function(this$, b) {
  return (("" + this$) + b)
});
var $d_Lscalacss_internal_Media$StringExt$ = new $TypeData().initClass({
  Lscalacss_internal_Media$StringExt$: 0
}, false, "scalacss.internal.Media$StringExt$", {
  Lscalacss_internal_Media$StringExt$: 1,
  O: 1
});
$c_Lscalacss_internal_Media$StringExt$.prototype.$classData = $d_Lscalacss_internal_Media$StringExt$;
var $n_Lscalacss_internal_Media$StringExt$;
function $m_Lscalacss_internal_Media$StringExt$() {
  if ((!$n_Lscalacss_internal_Media$StringExt$)) {
    $n_Lscalacss_internal_Media$StringExt$ = new $c_Lscalacss_internal_Media$StringExt$()
  };
  return $n_Lscalacss_internal_Media$StringExt$
}
function $ct_Lscalacss_internal_Media$TypeA__T__($thiz, value) {
  $thiz.Lscalacss_internal_Media$TypeA__f_value = value;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_Media$TypeA() {
  this.Lscalacss_internal_Media$TypeA__f_value = null
}
$c_Lscalacss_internal_Media$TypeA.prototype = new $h_O();
$c_Lscalacss_internal_Media$TypeA.prototype.constructor = $c_Lscalacss_internal_Media$TypeA;
/** @constructor */
function $h_Lscalacss_internal_Media$TypeA() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$TypeA.prototype = $c_Lscalacss_internal_Media$TypeA.prototype;
function $as_Lscalacss_internal_Media$TypeA(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Media$TypeA) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$TypeA"))
}
function $isArrayOf_Lscalacss_internal_Media$TypeA(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$TypeA)))
}
function $asArrayOf_Lscalacss_internal_Media$TypeA(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$TypeA(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$TypeA;", depth))
}
function $is_Lscalacss_internal_Media$TypeExpr(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalacss_internal_Media$TypeExpr)))
}
function $as_Lscalacss_internal_Media$TypeExpr(obj) {
  return (($is_Lscalacss_internal_Media$TypeExpr(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$TypeExpr"))
}
function $isArrayOf_Lscalacss_internal_Media$TypeExpr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$TypeExpr)))
}
function $asArrayOf_Lscalacss_internal_Media$TypeExpr(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$TypeExpr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$TypeExpr;", depth))
}
function $is_Lscalacss_internal_Media$ValueExpr(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalacss_internal_Media$ValueExpr)))
}
function $as_Lscalacss_internal_Media$ValueExpr(obj) {
  return (($is_Lscalacss_internal_Media$ValueExpr(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$ValueExpr"))
}
function $isArrayOf_Lscalacss_internal_Media$ValueExpr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$ValueExpr)))
}
function $asArrayOf_Lscalacss_internal_Media$ValueExpr(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$ValueExpr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$ValueExpr;", depth))
}
function $p_Lscalacss_internal_Need__value$lzycompute__O($thiz) {
  if ((!$thiz.Lscalacss_internal_Need__f_bitmap$0)) {
    var t = $thiz.Lscalacss_internal_Need__f__thunk;
    $thiz.Lscalacss_internal_Need__f__thunk = null;
    $thiz.Lscalacss_internal_Need__f_value = $n(t).apply__O();
    $thiz.Lscalacss_internal_Need__f_bitmap$0 = true
  };
  return $thiz.Lscalacss_internal_Need__f_value
}
/** @constructor */
function $c_Lscalacss_internal_Need(thunk) {
  this.Lscalacss_internal_Need__f_value = null;
  this.Lscalacss_internal_Need__f__thunk = null;
  this.Lscalacss_internal_Need__f_bitmap$0 = false;
  this.Lscalacss_internal_Need__f__thunk = thunk
}
$c_Lscalacss_internal_Need.prototype = new $h_O();
$c_Lscalacss_internal_Need.prototype.constructor = $c_Lscalacss_internal_Need;
/** @constructor */
function $h_Lscalacss_internal_Need() {
  /*<skip>*/
}
$h_Lscalacss_internal_Need.prototype = $c_Lscalacss_internal_Need.prototype;
$c_Lscalacss_internal_Need.prototype.value__O = (function() {
  return ((!this.Lscalacss_internal_Need__f_bitmap$0) ? $p_Lscalacss_internal_Need__value$lzycompute__O(this) : this.Lscalacss_internal_Need__f_value)
});
var $d_Lscalacss_internal_Need = new $TypeData().initClass({
  Lscalacss_internal_Need: 0
}, false, "scalacss.internal.Need", {
  Lscalacss_internal_Need: 1,
  O: 1
});
$c_Lscalacss_internal_Need.prototype.$classData = $d_Lscalacss_internal_Need;
/** @constructor */
function $c_Lscalacss_internal_NonEmptyVector(head, tail) {
  this.Lscalacss_internal_NonEmptyVector__f_head = null;
  this.Lscalacss_internal_NonEmptyVector__f_tail = null;
  this.Lscalacss_internal_NonEmptyVector__f_head = head;
  this.Lscalacss_internal_NonEmptyVector__f_tail = tail
}
$c_Lscalacss_internal_NonEmptyVector.prototype = new $h_O();
$c_Lscalacss_internal_NonEmptyVector.prototype.constructor = $c_Lscalacss_internal_NonEmptyVector;
/** @constructor */
function $h_Lscalacss_internal_NonEmptyVector() {
  /*<skip>*/
}
$h_Lscalacss_internal_NonEmptyVector.prototype = $c_Lscalacss_internal_NonEmptyVector.prototype;
$c_Lscalacss_internal_NonEmptyVector.prototype.toString__T = (function() {
  var this$1 = $n(this.whole__sci_Vector());
  return ("NonEmpty" + $f_sc_Iterable__toString__T(this$1))
});
$c_Lscalacss_internal_NonEmptyVector.prototype.hashCode__I = (function() {
  var x = this.Lscalacss_internal_NonEmptyVector__f_head;
  var $$x1 = $m_sr_Statics$().anyHash__O__I(x);
  var x$1 = this.Lscalacss_internal_NonEmptyVector__f_tail;
  return ((Math.imul(31, $$x1) + $m_sr_Statics$().anyHash__O__I(x$1)) | 0)
});
$c_Lscalacss_internal_NonEmptyVector.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_Lscalacss_internal_NonEmptyVector)) {
    var x2 = $as_Lscalacss_internal_NonEmptyVector(o);
    var x = this.Lscalacss_internal_NonEmptyVector__f_head;
    var y = $n(x2).Lscalacss_internal_NonEmptyVector__f_head;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lscalacss_internal_NonEmptyVector__f_tail;
      var x$2 = $n(x2).Lscalacss_internal_NonEmptyVector__f_tail;
      return ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lscalacss_internal_NonEmptyVector.prototype.$colon$plus__O__Lscalacss_internal_NonEmptyVector = (function(a) {
  var h = this.Lscalacss_internal_NonEmptyVector__f_head;
  var arg1 = this.Lscalacss_internal_NonEmptyVector__f_tail;
  var this$1 = $n(arg1);
  var t = $as_sci_Vector(this$1.appended__O__O(a));
  return new $c_Lscalacss_internal_NonEmptyVector(h, t)
});
$c_Lscalacss_internal_NonEmptyVector.prototype.$plus$plus$colon__sci_Vector__Lscalacss_internal_NonEmptyVector = (function(as) {
  var this$1 = $n(as);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    return this
  } else {
    var h = $n(as).head__O();
    var this$2 = $n($n(as).tail__sci_Vector());
    var suffix = this.whole__sci_Vector();
    var t = this$2.appendedAll__sc_IterableOnce__sci_Vector(suffix);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t)
  }
});
$c_Lscalacss_internal_NonEmptyVector.prototype.whole__sci_Vector = (function() {
  var rassoc$2 = this.Lscalacss_internal_NonEmptyVector__f_head;
  var this$1 = $n(this.Lscalacss_internal_NonEmptyVector__f_tail);
  return this$1.prepended__O__sci_Vector(rassoc$2)
});
function $as_Lscalacss_internal_NonEmptyVector(obj) {
  return (((obj instanceof $c_Lscalacss_internal_NonEmptyVector) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.NonEmptyVector"))
}
function $isArrayOf_Lscalacss_internal_NonEmptyVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_NonEmptyVector)))
}
function $asArrayOf_Lscalacss_internal_NonEmptyVector(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_NonEmptyVector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.NonEmptyVector;", depth))
}
var $d_Lscalacss_internal_NonEmptyVector = new $TypeData().initClass({
  Lscalacss_internal_NonEmptyVector: 0
}, false, "scalacss.internal.NonEmptyVector", {
  Lscalacss_internal_NonEmptyVector: 1,
  O: 1
});
$c_Lscalacss_internal_NonEmptyVector.prototype.$classData = $d_Lscalacss_internal_NonEmptyVector;
/** @constructor */
function $c_Lscalacss_internal_NonEmptyVector$() {
  /*<skip>*/
}
$c_Lscalacss_internal_NonEmptyVector$.prototype = new $h_O();
$c_Lscalacss_internal_NonEmptyVector$.prototype.constructor = $c_Lscalacss_internal_NonEmptyVector$;
/** @constructor */
function $h_Lscalacss_internal_NonEmptyVector$() {
  /*<skip>*/
}
$h_Lscalacss_internal_NonEmptyVector$.prototype = $c_Lscalacss_internal_NonEmptyVector$.prototype;
$c_Lscalacss_internal_NonEmptyVector$.prototype.one__O__Lscalacss_internal_NonEmptyVector = (function(h) {
  return new $c_Lscalacss_internal_NonEmptyVector(h, ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()))
});
$c_Lscalacss_internal_NonEmptyVector$.prototype.endO__s_Option__O__Lscalacss_internal_NonEmptyVector = (function(init, last) {
  var this$1 = $n(init);
  if (this$1.isEmpty__Z()) {
    return $m_Lscalacss_internal_NonEmptyVector$().one__O__Lscalacss_internal_NonEmptyVector(last)
  } else {
    var arg1 = this$1.get__O();
    var x$6 = $as_Lscalacss_internal_NonEmptyVector(arg1);
    return $n(x$6).$colon$plus__O__Lscalacss_internal_NonEmptyVector(last)
  }
});
$c_Lscalacss_internal_NonEmptyVector$.prototype.end__sci_Vector__O__Lscalacss_internal_NonEmptyVector = (function(init, last) {
  var this$1 = $n(init);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    return new $c_Lscalacss_internal_NonEmptyVector(last, ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()))
  } else {
    var $$x1 = $n(init).head__O();
    var this$3 = $n($n(init).tail__sci_Vector());
    return new $c_Lscalacss_internal_NonEmptyVector($$x1, $as_sci_Vector(this$3.appended__O__O(last)))
  }
});
$c_Lscalacss_internal_NonEmptyVector$.prototype.option__sci_Vector__s_Option = (function(v) {
  var this$1 = $n(v);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    var $$x1 = $m_s_None$()
  } else {
    var h = $n(v).head__O();
    var t = $n(v).tail__sci_Vector();
    var arg1 = new $c_Lscalacss_internal_NonEmptyVector(h, t);
    var $$x1 = new $c_s_Some(arg1)
  };
  return $as_s_Option($$x1)
});
var $d_Lscalacss_internal_NonEmptyVector$ = new $TypeData().initClass({
  Lscalacss_internal_NonEmptyVector$: 0
}, false, "scalacss.internal.NonEmptyVector$", {
  Lscalacss_internal_NonEmptyVector$: 1,
  O: 1
});
$c_Lscalacss_internal_NonEmptyVector$.prototype.$classData = $d_Lscalacss_internal_NonEmptyVector$;
var $n_Lscalacss_internal_NonEmptyVector$;
function $m_Lscalacss_internal_NonEmptyVector$() {
  if ((!$n_Lscalacss_internal_NonEmptyVector$)) {
    $n_Lscalacss_internal_NonEmptyVector$ = new $c_Lscalacss_internal_NonEmptyVector$()
  };
  return $n_Lscalacss_internal_NonEmptyVector$
}
/** @constructor */
function $c_Lscalacss_internal_Pseudo$() {
  this.Lscalacss_internal_Pseudo$__f_order = null;
  $n_Lscalacss_internal_Pseudo$ = this;
  this.Lscalacss_internal_Pseudo$__f_order = new $c_Lscalacss_internal_Pseudo$$anon$2()
}
$c_Lscalacss_internal_Pseudo$.prototype = new $h_O();
$c_Lscalacss_internal_Pseudo$.prototype.constructor = $c_Lscalacss_internal_Pseudo$;
/** @constructor */
function $h_Lscalacss_internal_Pseudo$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Pseudo$.prototype = $c_Lscalacss_internal_Pseudo$.prototype;
var $d_Lscalacss_internal_Pseudo$ = new $TypeData().initClass({
  Lscalacss_internal_Pseudo$: 0
}, false, "scalacss.internal.Pseudo$", {
  Lscalacss_internal_Pseudo$: 1,
  O: 1
});
$c_Lscalacss_internal_Pseudo$.prototype.$classData = $d_Lscalacss_internal_Pseudo$;
var $n_Lscalacss_internal_Pseudo$;
function $m_Lscalacss_internal_Pseudo$() {
  if ((!$n_Lscalacss_internal_Pseudo$)) {
    $n_Lscalacss_internal_Pseudo$ = new $c_Lscalacss_internal_Pseudo$()
  };
  return $n_Lscalacss_internal_Pseudo$
}
function $ct_Lscalacss_internal_PseudoType__S__($thiz, priority) {
  $thiz.Lscalacss_internal_PseudoType__f_priority = priority;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_PseudoType() {
  this.Lscalacss_internal_PseudoType__f_priority = 0
}
$c_Lscalacss_internal_PseudoType.prototype = new $h_O();
$c_Lscalacss_internal_PseudoType.prototype.constructor = $c_Lscalacss_internal_PseudoType;
/** @constructor */
function $h_Lscalacss_internal_PseudoType() {
  /*<skip>*/
}
$h_Lscalacss_internal_PseudoType.prototype = $c_Lscalacss_internal_PseudoType.prototype;
function $as_Lscalacss_internal_PseudoType(obj) {
  return (((obj instanceof $c_Lscalacss_internal_PseudoType) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.PseudoType"))
}
function $isArrayOf_Lscalacss_internal_PseudoType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_PseudoType)))
}
function $asArrayOf_Lscalacss_internal_PseudoType(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_PseudoType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.PseudoType;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_PseudoType$() {
  this.Lscalacss_internal_PseudoType$__f_ordering = null;
  $n_Lscalacss_internal_PseudoType$ = this;
  this.Lscalacss_internal_PseudoType$__f_ordering = new $c_Lscalacss_internal_PseudoType$$anon$1()
}
$c_Lscalacss_internal_PseudoType$.prototype = new $h_O();
$c_Lscalacss_internal_PseudoType$.prototype.constructor = $c_Lscalacss_internal_PseudoType$;
/** @constructor */
function $h_Lscalacss_internal_PseudoType$() {
  /*<skip>*/
}
$h_Lscalacss_internal_PseudoType$.prototype = $c_Lscalacss_internal_PseudoType$.prototype;
var $d_Lscalacss_internal_PseudoType$ = new $TypeData().initClass({
  Lscalacss_internal_PseudoType$: 0
}, false, "scalacss.internal.PseudoType$", {
  Lscalacss_internal_PseudoType$: 1,
  O: 1
});
$c_Lscalacss_internal_PseudoType$.prototype.$classData = $d_Lscalacss_internal_PseudoType$;
var $n_Lscalacss_internal_PseudoType$;
function $m_Lscalacss_internal_PseudoType$() {
  if ((!$n_Lscalacss_internal_PseudoType$)) {
    $n_Lscalacss_internal_PseudoType$ = new $c_Lscalacss_internal_PseudoType$()
  };
  return $n_Lscalacss_internal_PseudoType$
}
function $p_Lscalacss_internal_StringRenderer$__quoteIfNeeded__scm_StringBuilder__T__Z__V($thiz, sb, s, quote) {
  if (quote) {
    var this$1 = $n(s);
    var $$x1 = ($uI(this$1.indexOf(" ")) !== (-1))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $n(sb).append__C__scm_StringBuilder(34);
    $n(sb).append__T__scm_StringBuilder(s);
    $n(sb).append__C__scm_StringBuilder(34)
  } else {
    $n(sb).append__T__scm_StringBuilder(s)
  }
}
function $p_Lscalacss_internal_StringRenderer$__defaultPretty$lzycompute__Lscalacss_internal_Renderer($thiz) {
  if (((((2 & $thiz.Lscalacss_internal_StringRenderer$__f_bitmap$0) << 24) >> 24) === 0)) {
    var f = $thiz.formatPretty__T__T__F1("  ", " ");
    $thiz.Lscalacss_internal_StringRenderer$__f_defaultPretty = new $c_Lscalacss_internal_StringRenderer$Default(f);
    $thiz.Lscalacss_internal_StringRenderer$__f_bitmap$0 = (((2 | $thiz.Lscalacss_internal_StringRenderer$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscalacss_internal_StringRenderer$__f_defaultPretty
}
function $p_Lscalacss_internal_StringRenderer$__mqIndent$1__s_Option__scm_StringBuilder__T__V($thiz, mq, sb$2, indent$1) {
  var this$1 = $n(mq);
  if ((!this$1.isEmpty__Z())) {
    $n(sb$2).append__T__scm_StringBuilder(indent$1)
  }
}
function $p_Lscalacss_internal_StringRenderer$__kfIndent$1__s_Option__scm_StringBuilder__T__V($thiz, kf, sb$2, indent$1) {
  var this$1 = $n(kf);
  if ((!this$1.isEmpty__Z())) {
    $n(sb$2).append__T__scm_StringBuilder(indent$1)
  }
}
function $p_Lscalacss_internal_StringRenderer$__kv$2__s_Option__s_Option__Lscalacss_internal_CssKV__Z__scm_StringBuilder__T__T__scm_StringBuilder($thiz, kf, mq, c, quote, sb$2, indent$1, postColon$1) {
  $p_Lscalacss_internal_StringRenderer$__kfIndent$1__s_Option__scm_StringBuilder__T__V($thiz, kf, sb$2, indent$1);
  $p_Lscalacss_internal_StringRenderer$__mqIndent$1__s_Option__scm_StringBuilder__T__V($thiz, mq, sb$2, indent$1);
  $n(sb$2).append__T__scm_StringBuilder(indent$1);
  $n(sb$2).append__T__scm_StringBuilder($n(c).Lscalacss_internal_CssKV__f_key);
  $n(sb$2).append__C__scm_StringBuilder(58);
  $n(sb$2).append__T__scm_StringBuilder(postColon$1);
  $p_Lscalacss_internal_StringRenderer$__quoteIfNeeded__scm_StringBuilder__T__Z__V($m_Lscalacss_internal_StringRenderer$(), sb$2, $n(c).Lscalacss_internal_CssKV__f_value, quote);
  return $n(sb$2).append__T__scm_StringBuilder(";\n")
}
/** @constructor */
function $c_Lscalacss_internal_StringRenderer$() {
  this.Lscalacss_internal_StringRenderer$__f_defaultPretty = null;
  this.Lscalacss_internal_StringRenderer$__f_bitmap$0 = 0
}
$c_Lscalacss_internal_StringRenderer$.prototype = new $h_O();
$c_Lscalacss_internal_StringRenderer$.prototype.constructor = $c_Lscalacss_internal_StringRenderer$;
/** @constructor */
function $h_Lscalacss_internal_StringRenderer$() {
  /*<skip>*/
}
$h_Lscalacss_internal_StringRenderer$.prototype = $c_Lscalacss_internal_StringRenderer$.prototype;
$c_Lscalacss_internal_StringRenderer$.prototype.formatPretty__T__T__F1 = (function(indent, postColon) {
  return new $c_sjsr_AnonFunction1(((sb$2) => {
    var sb = $as_scm_StringBuilder(sb$2);
    return new $c_Lscalacss_internal_StringRenderer$FormatSB(new $c_sjsr_AnonFunction1(((n$2) => {
      var n = $as_T(n$2);
      $n(sb).append__T__scm_StringBuilder("@keyframes ");
      $n(sb).append__T__scm_StringBuilder(n);
      $n(sb).append__T__scm_StringBuilder(" {\n")
    })), new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_T(s$2);
      $n(sb).append__T__scm_StringBuilder(indent);
      $n(sb).append__T__scm_StringBuilder(s);
      $n(sb).append__T__scm_StringBuilder(" {\n")
    })), new $c_sjsr_AnonFunction1(((mq$2) => {
      var mq = $as_T(mq$2);
      $n(sb).append__T__scm_StringBuilder(mq);
      $n(sb).append__T__scm_StringBuilder(" {\n")
    })), new $c_sjsr_AnonFunction2(((mq$3$2, sel$2) => {
      var mq$3 = $as_s_Option(mq$3$2);
      var sel = $as_T(sel$2);
      $p_Lscalacss_internal_StringRenderer$__mqIndent$1__s_Option__scm_StringBuilder__T__V(this, mq$3, sb, indent);
      $n(sb).append__T__scm_StringBuilder(sel);
      $n(sb).append__T__scm_StringBuilder(" {\n")
    })), new $c_sjsr_AnonFunction3(((kf$2, mq$4$2, c$2) => {
      var kf = $as_s_Option(kf$2);
      var mq$4 = $as_s_Option(mq$4$2);
      var c = $as_Lscalacss_internal_CssKV(c$2);
      $p_Lscalacss_internal_StringRenderer$__kv$2__s_Option__s_Option__Lscalacss_internal_CssKV__Z__scm_StringBuilder__T__T__scm_StringBuilder(this, kf, mq$4, c, false, sb, indent, postColon)
    })), new $c_sjsr_AnonFunction3(((kf$3$2, mq$5$2, c$3$2) => {
      var kf$3 = $as_s_Option(kf$3$2);
      var mq$5 = $as_s_Option(mq$5$2);
      var c$3 = $as_Lscalacss_internal_CssKV(c$3$2);
      $p_Lscalacss_internal_StringRenderer$__kv$2__s_Option__s_Option__Lscalacss_internal_CssKV__Z__scm_StringBuilder__T__T__scm_StringBuilder(this, kf$3, mq$5, c$3, false, sb, indent, postColon)
    })), new $c_sjsr_AnonFunction2(((mq$6$2, x$18$2) => {
      var mq$6 = $as_s_Option(mq$6$2);
      $as_T(x$18$2);
      $p_Lscalacss_internal_StringRenderer$__mqIndent$1__s_Option__scm_StringBuilder__T__V(this, mq$6, sb, indent);
      $n(sb).append__T__scm_StringBuilder("}\n");
      if ($n(mq$6).isEmpty__Z()) {
        $n(sb).append__C__scm_StringBuilder(10)
      }
    })), new $c_sjsr_AnonFunction1(((x$19$2) => {
      $as_T(x$19$2);
      $n(sb).append__T__scm_StringBuilder("}\n\n")
    })), new $c_sjsr_AnonFunction1(((x$20$2) => {
      $as_Lscalacss_internal_Percentage(x$20$2);
      $n(sb).append__T__scm_StringBuilder(indent);
      $n(sb).append__T__scm_StringBuilder("}\n\n")
    })), new $c_sjsr_AnonFunction1(((x$21$2) => {
      $as_Lscalacss_internal_ClassName(x$21$2);
      $n(sb).append__T__scm_StringBuilder("}\n\n")
    })), new $c_sjsr_AnonFunction1(((fontface$2) => {
      var fontface = $as_Lscalacss_internal_CssEntry$FontFace(fontface$2);
      var f = ((key$3$2, value$3$2, quote$3$2) => {
        var key$3 = $as_T(key$3$2);
        var value$3 = $as_T(value$3$2);
        var quote$3 = $uZ(quote$3$2);
        $p_Lscalacss_internal_StringRenderer$__kv$2__s_Option__s_Option__Lscalacss_internal_CssKV__Z__scm_StringBuilder__T__T__scm_StringBuilder(this, $m_s_None$(), $m_s_None$(), new $c_Lscalacss_internal_CssKV(key$3, value$3), quote$3, sb, indent, postColon)
      });
      $n(sb).append__T__scm_StringBuilder("@font-face {\n");
      var arg2 = $n(fontface).Lscalacss_internal_CssEntry$FontFace__f_fontFamily;
      $p_Lscalacss_internal_StringRenderer$__kv$2__s_Option__s_Option__Lscalacss_internal_CssKV__Z__scm_StringBuilder__T__T__scm_StringBuilder(this, $m_s_None$(), $m_s_None$(), new $c_Lscalacss_internal_CssKV("font-family", arg2), true, sb, indent, postColon);
      var this$3 = $n($n($n(fontface).Lscalacss_internal_CssEntry$FontFace__f_src).whole__sci_Vector());
      var arg2$1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ",", "");
      f("src", arg2$1, false);
      var this$4 = $n($n(fontface).Lscalacss_internal_CssEntry$FontFace__f_fontStretch);
      if ((!this$4.isEmpty__Z())) {
        var arg1 = this$4.get__O();
        var v = $as_T(arg1);
        f("font-stretch", v, false)
      };
      var this$5 = $n($n(fontface).Lscalacss_internal_CssEntry$FontFace__f_fontStyle);
      if ((!this$5.isEmpty__Z())) {
        var arg1$1 = this$5.get__O();
        var v$3 = $as_T(arg1$1);
        f("font-style", v$3, false)
      };
      var this$6 = $n($n(fontface).Lscalacss_internal_CssEntry$FontFace__f_fontWeight);
      if ((!this$6.isEmpty__Z())) {
        var arg1$2 = this$6.get__O();
        var v$4 = $as_T(arg1$2);
        f("font-weight", v$4, false)
      };
      var this$7 = $n($n(fontface).Lscalacss_internal_CssEntry$FontFace__f_unicodeRange);
      if ((!this$7.isEmpty__Z())) {
        var arg1$3 = this$7.get__O();
        var v$5 = $as_Lscalacss_internal_UnicodeRange(arg1$3);
        var arg2$2 = $n(v$5).toString__T();
        f("unicode-range", arg2$2, false)
      };
      $n(sb).append__T__scm_StringBuilder("}\n\n")
    })), new $c_sjsr_AnonFunction0((() => (void 0))))
  }))
});
$c_Lscalacss_internal_StringRenderer$.prototype.defaultPretty__Lscalacss_internal_Renderer = (function() {
  return (((((2 & this.Lscalacss_internal_StringRenderer$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscalacss_internal_StringRenderer$__defaultPretty$lzycompute__Lscalacss_internal_Renderer(this) : this.Lscalacss_internal_StringRenderer$__f_defaultPretty)
});
var $d_Lscalacss_internal_StringRenderer$ = new $TypeData().initClass({
  Lscalacss_internal_StringRenderer$: 0
}, false, "scalacss.internal.StringRenderer$", {
  Lscalacss_internal_StringRenderer$: 1,
  O: 1
});
$c_Lscalacss_internal_StringRenderer$.prototype.$classData = $d_Lscalacss_internal_StringRenderer$;
var $n_Lscalacss_internal_StringRenderer$;
function $m_Lscalacss_internal_StringRenderer$() {
  if ((!$n_Lscalacss_internal_StringRenderer$)) {
    $n_Lscalacss_internal_StringRenderer$ = new $c_Lscalacss_internal_StringRenderer$()
  };
  return $n_Lscalacss_internal_StringRenderer$
}
/** @constructor */
function $c_Lscalacss_internal_StyleF$() {
  /*<skip>*/
}
$c_Lscalacss_internal_StyleF$.prototype = new $h_O();
$c_Lscalacss_internal_StyleF$.prototype.constructor = $c_Lscalacss_internal_StyleF$;
/** @constructor */
function $h_Lscalacss_internal_StyleF$() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleF$.prototype = $c_Lscalacss_internal_StyleF$.prototype;
$c_Lscalacss_internal_StyleF$.prototype.apply__F1__Lscalacss_internal_StyleF$P = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lscalacss_internal_Domain(x$1$2);
    return new $c_Lscalacss_internal_StyleF(f, x$1)
  }));
  return new $c_Lscalacss_internal_StyleF$$anon$1(f$1)
});
var $d_Lscalacss_internal_StyleF$ = new $TypeData().initClass({
  Lscalacss_internal_StyleF$: 0
}, false, "scalacss.internal.StyleF$", {
  Lscalacss_internal_StyleF$: 1,
  O: 1
});
$c_Lscalacss_internal_StyleF$.prototype.$classData = $d_Lscalacss_internal_StyleF$;
var $n_Lscalacss_internal_StyleF$;
function $m_Lscalacss_internal_StyleF$() {
  if ((!$n_Lscalacss_internal_StyleF$)) {
    $n_Lscalacss_internal_StyleF$ = new $c_Lscalacss_internal_StyleF$()
  };
  return $n_Lscalacss_internal_StyleF$
}
/** @constructor */
function $c_Lscalacss_internal_StyleLookup$() {
  this.Lscalacss_internal_StyleLookup$__f_boolean = null;
  this.Lscalacss_internal_StyleLookup$__f_int = null;
  $n_Lscalacss_internal_StyleLookup$ = this;
  this.Lscalacss_internal_StyleLookup$__f_boolean = new $c_Lscalacss_internal_StyleLookup$$anon$1();
  this.Lscalacss_internal_StyleLookup$__f_int = ($m_Ljapgolly_univeq_UnivEq$(), new $c_Lscalacss_internal_StyleLookup$$anon$2());
  $m_Ljapgolly_univeq_UnivEq$();
  new $c_Lscalacss_internal_StyleLookup$$anon$2();
  var this$1 = $m_Ljapgolly_univeq_UnivEq$();
  new $c_Lscalacss_internal_StyleLookup$$anon$2()
}
$c_Lscalacss_internal_StyleLookup$.prototype = new $h_O();
$c_Lscalacss_internal_StyleLookup$.prototype.constructor = $c_Lscalacss_internal_StyleLookup$;
/** @constructor */
function $h_Lscalacss_internal_StyleLookup$() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleLookup$.prototype = $c_Lscalacss_internal_StyleLookup$.prototype;
var $d_Lscalacss_internal_StyleLookup$ = new $TypeData().initClass({
  Lscalacss_internal_StyleLookup$: 0
}, false, "scalacss.internal.StyleLookup$", {
  Lscalacss_internal_StyleLookup$: 1,
  O: 1
});
$c_Lscalacss_internal_StyleLookup$.prototype.$classData = $d_Lscalacss_internal_StyleLookup$;
var $n_Lscalacss_internal_StyleLookup$;
function $m_Lscalacss_internal_StyleLookup$() {
  if ((!$n_Lscalacss_internal_StyleLookup$)) {
    $n_Lscalacss_internal_StyleLookup$ = new $c_Lscalacss_internal_StyleLookup$()
  };
  return $n_Lscalacss_internal_StyleLookup$
}
/** @constructor */
function $c_Lscalacss_internal_Transform(run) {
  this.Lscalacss_internal_Transform__f_run = null;
  this.Lscalacss_internal_Transform__f_run = run
}
$c_Lscalacss_internal_Transform.prototype = new $h_O();
$c_Lscalacss_internal_Transform.prototype.constructor = $c_Lscalacss_internal_Transform;
/** @constructor */
function $h_Lscalacss_internal_Transform() {
  /*<skip>*/
}
$h_Lscalacss_internal_Transform.prototype = $c_Lscalacss_internal_Transform.prototype;
$c_Lscalacss_internal_Transform.prototype.$times__Lscalacss_internal_Transform__Lscalacss_internal_Transform = (function(next) {
  return new $c_Lscalacss_internal_Transform(new $c_sjsr_AnonFunction1(((e$2) => {
    var e = $as_Lscalacss_internal_Env(e$2);
    var a = $as_F1($n(this.Lscalacss_internal_Transform__f_run).apply__O__O(e));
    var b = $as_F1($n($n(next).Lscalacss_internal_Transform__f_run).apply__O__O(e));
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lscalacss_internal_CssKV(x$2$2);
      return $as_sci_Vector($n($as_sc_StrictOptimizedIterableOps($n(a).apply__O__O(x$2))).flatMap__F1__O(b))
    }))
  })))
});
$c_Lscalacss_internal_Transform.prototype.attrGen__T__F1 = (function(key) {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    var e = $as_Lscalacss_internal_Env(e$2);
    var x = $as_F1($n(this.Lscalacss_internal_Transform__f_run).apply__O__O(e));
    return new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_T(v$2);
      return $as_sci_Vector($n(x).apply__O__O(new $c_Lscalacss_internal_CssKV(key, v)))
    }))
  }))
});
function $as_Lscalacss_internal_Transform(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Transform) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Transform"))
}
function $isArrayOf_Lscalacss_internal_Transform(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Transform)))
}
function $asArrayOf_Lscalacss_internal_Transform(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Transform(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Transform;", depth))
}
var $d_Lscalacss_internal_Transform = new $TypeData().initClass({
  Lscalacss_internal_Transform: 0
}, false, "scalacss.internal.Transform", {
  Lscalacss_internal_Transform: 1,
  O: 1
});
$c_Lscalacss_internal_Transform.prototype.$classData = $d_Lscalacss_internal_Transform;
function $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform($thiz, subject, pa, l) {
  var pp0 = $as_sci_Vector($n($m_Lscalacss_internal_CanIUse2$().Lscalacss_internal_CanIUse2$__f_prefixPlan).apply__O__O(subject));
  var run = new $c_sjsr_AnonFunction1(((e$2) => {
    var e = $as_Lscalacss_internal_Env(e$2);
    var pp = $m_Lscalacss_internal_CanIUse2$().filteredPrefixPlan__sci_Set__sci_Vector__sci_Vector($n(e).Lscalacss_internal_Env__f_prefixWhitelist, pp0);
    return new $c_sjsr_AnonFunction1(((kv$2) => {
      var kv = $as_Lscalacss_internal_CssKV(kv$2);
      return $m_Lscalacss_internal_CanIUse2$().runPlan__sci_Vector__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_CssKV__sci_Vector(pp, pa, l, kv)
    }))
  }));
  return new $c_Lscalacss_internal_Transform(run)
}
/** @constructor */
function $c_Lscalacss_internal_Transform$() {
  /*<skip>*/
}
$c_Lscalacss_internal_Transform$.prototype = new $h_O();
$c_Lscalacss_internal_Transform$.prototype.constructor = $c_Lscalacss_internal_Transform$;
/** @constructor */
function $h_Lscalacss_internal_Transform$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Transform$.prototype = $c_Lscalacss_internal_Transform$.prototype;
$c_Lscalacss_internal_Transform$.prototype.values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform = (function(subject, v1, vn) {
  var this$1 = $n(vn);
  var this$2 = $n($m_sci_Set$().from__sc_IterableOnce__sci_Set(this$1));
  var whitelist = $as_sci_Set(this$2.incl__O__sci_SetOps(v1));
  var pa = $m_Lscalacss_internal_CanIUse2$PrefixApply$().maybePrepend__F1__F1(new $c_sjsr_AnonFunction1(((elem$2) => {
    var elem = $as_T(elem$2);
    return $n(whitelist).contains__O__Z(elem)
  })));
  return $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this, subject, pa, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_value)
});
$c_Lscalacss_internal_Transform$.prototype.valueKeywords__sci_Map__T__sci_Seq__Lscalacss_internal_Transform = (function(subject, w1, wn) {
  var pa = $m_Lscalacss_internal_CanIUse2$PrefixApply$().keywords__T__sci_Seq__F1(w1, wn);
  return $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this, subject, pa, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_value)
});
var $d_Lscalacss_internal_Transform$ = new $TypeData().initClass({
  Lscalacss_internal_Transform$: 0
}, false, "scalacss.internal.Transform$", {
  Lscalacss_internal_Transform$: 1,
  O: 1
});
$c_Lscalacss_internal_Transform$.prototype.$classData = $d_Lscalacss_internal_Transform$;
var $n_Lscalacss_internal_Transform$;
function $m_Lscalacss_internal_Transform$() {
  if ((!$n_Lscalacss_internal_Transform$)) {
    $n_Lscalacss_internal_Transform$ = new $c_Lscalacss_internal_Transform$()
  };
  return $n_Lscalacss_internal_Transform$
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$Rule() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$Rule.prototype = new $h_O();
$c_Lscalacss_internal_ValueT$Rule.prototype.constructor = $c_Lscalacss_internal_ValueT$Rule;
/** @constructor */
function $h_Lscalacss_internal_ValueT$Rule() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$Rule.prototype = $c_Lscalacss_internal_ValueT$Rule.prototype;
$c_Lscalacss_internal_ValueT$Rule.prototype.$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1(((a$2) => $n(f).apply__O__Lscalacss_internal_ValueT(this.apply__O__Lscalacss_internal_ValueT(a$2))));
  return new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$1)
});
/** @constructor */
function $c_Lscalacss_internal_ValueT$Rule$() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$Rule$.prototype = new $h_O();
$c_Lscalacss_internal_ValueT$Rule$.prototype.constructor = $c_Lscalacss_internal_ValueT$Rule$;
/** @constructor */
function $h_Lscalacss_internal_ValueT$Rule$() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$Rule$.prototype = $c_Lscalacss_internal_ValueT$Rule$.prototype;
$c_Lscalacss_internal_ValueT$Rule$.prototype.apply__F1__Lscalacss_internal_ValueT$Rule = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1(((x$2) => new $c_Lscalacss_internal_ValueT($as_T($n(f).apply__O__O(x$2)))));
  return new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$1)
});
var $d_Lscalacss_internal_ValueT$Rule$ = new $TypeData().initClass({
  Lscalacss_internal_ValueT$Rule$: 0
}, false, "scalacss.internal.ValueT$Rule$", {
  Lscalacss_internal_ValueT$Rule$: 1,
  O: 1
});
$c_Lscalacss_internal_ValueT$Rule$.prototype.$classData = $d_Lscalacss_internal_ValueT$Rule$;
var $n_Lscalacss_internal_ValueT$Rule$;
function $m_Lscalacss_internal_ValueT$Rule$() {
  if ((!$n_Lscalacss_internal_ValueT$Rule$)) {
    $n_Lscalacss_internal_ValueT$Rule$ = new $c_Lscalacss_internal_ValueT$Rule$()
  };
  return $n_Lscalacss_internal_ValueT$Rule$
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$Rules() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$Rules.prototype = new $h_O();
$c_Lscalacss_internal_ValueT$Rules.prototype.constructor = $c_Lscalacss_internal_ValueT$Rules;
/** @constructor */
function $h_Lscalacss_internal_ValueT$Rules() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$Rules.prototype = $c_Lscalacss_internal_ValueT$Rules.prototype;
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttrBase() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$TypedAttrBase.prototype = new $h_O();
$c_Lscalacss_internal_ValueT$TypedAttrBase.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttrBase;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttrBase() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttrBase.prototype = $c_Lscalacss_internal_ValueT$TypedAttrBase.prototype;
$c_Lscalacss_internal_ValueT$TypedAttrBase.prototype.toString__T = (function() {
  var this$1 = $n(this.attr__Lscalacss_internal_Attr());
  return this$1.Lscalacss_internal_Attr__f_id
});
/** @constructor */
function $c_Lscalacss_internal_mutable_Mutex() {
  /*<skip>*/
}
$c_Lscalacss_internal_mutable_Mutex.prototype = new $h_O();
$c_Lscalacss_internal_mutable_Mutex.prototype.constructor = $c_Lscalacss_internal_mutable_Mutex;
/** @constructor */
function $h_Lscalacss_internal_mutable_Mutex() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_Mutex.prototype = $c_Lscalacss_internal_mutable_Mutex.prototype;
var $d_Lscalacss_internal_mutable_Mutex = new $TypeData().initClass({
  Lscalacss_internal_mutable_Mutex: 0
}, false, "scalacss.internal.mutable.Mutex", {
  Lscalacss_internal_mutable_Mutex: 1,
  O: 1
});
$c_Lscalacss_internal_mutable_Mutex.prototype.$classData = $d_Lscalacss_internal_mutable_Mutex;
/** @constructor */
function $c_Lscalacss_internal_mutable_Mutex$() {
  this.Lscalacss_internal_mutable_Mutex$__f_mutex = null;
  $n_Lscalacss_internal_mutable_Mutex$ = this;
  this.Lscalacss_internal_mutable_Mutex$__f_mutex = new $c_Lscalacss_internal_mutable_Mutex()
}
$c_Lscalacss_internal_mutable_Mutex$.prototype = new $h_O();
$c_Lscalacss_internal_mutable_Mutex$.prototype.constructor = $c_Lscalacss_internal_mutable_Mutex$;
/** @constructor */
function $h_Lscalacss_internal_mutable_Mutex$() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_Mutex$.prototype = $c_Lscalacss_internal_mutable_Mutex$.prototype;
var $d_Lscalacss_internal_mutable_Mutex$ = new $TypeData().initClass({
  Lscalacss_internal_mutable_Mutex$: 0
}, false, "scalacss.internal.mutable.Mutex$", {
  Lscalacss_internal_mutable_Mutex$: 1,
  O: 1
});
$c_Lscalacss_internal_mutable_Mutex$.prototype.$classData = $d_Lscalacss_internal_mutable_Mutex$;
var $n_Lscalacss_internal_mutable_Mutex$;
function $m_Lscalacss_internal_mutable_Mutex$() {
  if ((!$n_Lscalacss_internal_mutable_Mutex$)) {
    $n_Lscalacss_internal_mutable_Mutex$ = new $c_Lscalacss_internal_mutable_Mutex$()
  };
  return $n_Lscalacss_internal_mutable_Mutex$
}
function $p_Lscalacss_internal_mutable_Register__nextName__Lscalacss_internal_ClassNameHint__Lscalacss_internal_ClassName($thiz, cnh) {
  $n($thiz.Lscalacss_internal_mutable_Register__f_mutex);
  var x1 = $n($thiz.Lscalacss_internal_mutable_Register__f__nameGen).next__Lscalacss_internal_ClassNameHint__T2(cnh);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var cn = $as_Lscalacss_internal_ClassName($n(x1)._1__O());
  var ng = $as_Lscalacss_internal_mutable_Register$NameGen($n(x1)._2__O());
  $thiz.Lscalacss_internal_mutable_Register__f__nameGen = ng;
  return cn
}
function $p_Lscalacss_internal_mutable_Register__doesntNeedClassName__Lscalacss_internal_StyleS__Z($thiz, s0) {
  var this$1 = $n($n(s0).Lscalacss_internal_StyleS__f_addClassNames);
  if ((((!$f_sc_SeqOps__isEmpty__Z(this$1)) && $n($n(s0).Lscalacss_internal_StyleS__f_data).isEmpty__Z()) && $n($n(s0).Lscalacss_internal_StyleS__f_className).isEmpty__Z())) {
    var this$2 = $n($n(s0).Lscalacss_internal_StyleS__f_unsafeExts);
    return $f_sc_SeqOps__isEmpty__Z(this$2)
  } else {
    return false
  }
}
function $p_Lscalacss_internal_mutable_Register__isTaken__Lscalacss_internal_ClassName__Z($thiz, className) {
  $n($thiz.Lscalacss_internal_mutable_Register__f_mutex);
  var this$2 = $n($thiz.Lscalacss_internal_mutable_Register__f__styles);
  var res = false;
  var it = this$2.iterator__sc_Iterator();
  while (((!res) && $n(it).hasNext__Z())) {
    var arg1 = $n(it).next__O();
    var x$2 = $as_Lscalacss_internal_StyleA(arg1);
    var x = $n(x$2).Lscalacss_internal_StyleA__f_className;
    res = ((x === null) ? (className === null) : $n(x).equals__O__Z(className))
  };
  if (res) {
    return true
  } else {
    var this$3 = $n($thiz.Lscalacss_internal_mutable_Register__f__keyframes);
    var res$1 = false;
    var it$1 = this$3.iterator__sc_Iterator();
    while (((!res$1) && $n(it$1).hasNext__Z())) {
      var arg1$1 = $n(it$1).next__O();
      var x$3 = $as_Lscalacss_internal_Keyframes(arg1$1);
      var x$1 = $n(x$3).Lscalacss_internal_Keyframes__f_name;
      res$1 = ((x$1 === null) ? (className === null) : $n(x$1).equals__O__Z(className))
    };
    return res$1
  }
}
function $p_Lscalacss_internal_mutable_Register__ensureUnique__Lscalacss_internal_ClassName__Lscalacss_internal_ClassName($thiz, cn) {
  $n($thiz.Lscalacss_internal_mutable_Register__f_mutex);
  return ($p_Lscalacss_internal_mutable_Register__isTaken__Lscalacss_internal_ClassName__Z($thiz, cn) ? $p_Lscalacss_internal_mutable_Register__go$1__I__Lscalacss_internal_ClassName__Lscalacss_internal_ClassName($thiz, 2, cn) : cn)
}
function $p_Lscalacss_internal_mutable_Register__go$1__I__Lscalacss_internal_ClassName__Lscalacss_internal_ClassName($thiz, suf, cn$1) {
  while (true) {
    var n = new $c_Lscalacss_internal_ClassName((($n(cn$1).Lscalacss_internal_ClassName__f_value + "-") + suf));
    if ($p_Lscalacss_internal_mutable_Register__isTaken__Lscalacss_internal_ClassName__Z($thiz, n)) {
      suf = ((1 + suf) | 0)
    } else {
      return n
    }
  }
}
function $p_Lscalacss_internal_mutable_Register__warn$1__T__F2__Lscalacss_internal_ClassName__V($thiz, s, f$1, cn$2) {
  $n(f$1).apply__O__O__O(cn$2, new $c_Lscalacss_internal_package$Warning($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty, s))
}
/** @constructor */
function $c_Lscalacss_internal_mutable_Register(initNameGen, macroName, errHandler, mutex) {
  this.Lscalacss_internal_mutable_Register__f_macroName = null;
  this.Lscalacss_internal_mutable_Register__f_errHandler = null;
  this.Lscalacss_internal_mutable_Register__f_mutex = null;
  this.Lscalacss_internal_mutable_Register__f__nameGen = null;
  this.Lscalacss_internal_mutable_Register__f__styles = null;
  this.Lscalacss_internal_mutable_Register__f__keyframes = null;
  this.Lscalacss_internal_mutable_Register__f__fontFaces = null;
  this.Lscalacss_internal_mutable_Register__f__rendered = false;
  this.Lscalacss_internal_mutable_Register__f_macroName = macroName;
  this.Lscalacss_internal_mutable_Register__f_errHandler = errHandler;
  this.Lscalacss_internal_mutable_Register__f_mutex = mutex;
  this.Lscalacss_internal_mutable_Register__f__nameGen = initNameGen;
  this.Lscalacss_internal_mutable_Register__f__styles = ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$());
  this.Lscalacss_internal_mutable_Register__f__keyframes = ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$());
  this.Lscalacss_internal_mutable_Register__f__fontFaces = ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$());
  this.Lscalacss_internal_mutable_Register__f__rendered = false
}
$c_Lscalacss_internal_mutable_Register.prototype = new $h_O();
$c_Lscalacss_internal_mutable_Register.prototype.constructor = $c_Lscalacss_internal_mutable_Register;
/** @constructor */
function $h_Lscalacss_internal_mutable_Register() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_Register.prototype = $c_Lscalacss_internal_mutable_Register.prototype;
$c_Lscalacss_internal_mutable_Register.prototype.applyMacroName__T__Lscalacss_internal_StyleS__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleS = (function(name, style, cnh) {
  if ($n($n(style).Lscalacss_internal_StyleS__f_data).isEmpty__Z()) {
    var this$1 = $n($n(style).Lscalacss_internal_StyleS__f_unsafeExts);
    var $$x1 = $f_sc_SeqOps__isEmpty__Z(this$1)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return style
  } else {
    var this$2 = $n($n(this.Lscalacss_internal_mutable_Register__f_macroName).apply__Lscalacss_internal_ClassNameHint__T__s_Option(cnh, name));
    if (this$2.isEmpty__Z()) {
      var cn$3 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var cn = $as_Lscalacss_internal_ClassName(arg1);
      var cn$3 = new $c_s_Some($p_Lscalacss_internal_mutable_Register__ensureUnique__Lscalacss_internal_ClassName__Lscalacss_internal_ClassName(this, cn))
    };
    var this$3 = $n(style);
    var x$2 = this$3.Lscalacss_internal_StyleS__f_data;
    var this$4 = $n(style);
    var x$3 = this$4.Lscalacss_internal_StyleS__f_unsafeExts;
    var this$5 = $n(style);
    var x$4 = this$5.Lscalacss_internal_StyleS__f_addClassNames;
    var this$6 = $n(style);
    var x$5 = this$6.Lscalacss_internal_StyleS__f_warnings;
    $n(style);
    return new $c_Lscalacss_internal_StyleS(x$2, x$3, cn$3, x$4, x$5)
  }
});
$c_Lscalacss_internal_mutable_Register.prototype.registerS__Lscalacss_internal_StyleS__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleA = (function(s0, cnh) {
  $n(this.Lscalacss_internal_mutable_Register__f_mutex);
  if ($p_Lscalacss_internal_mutable_Register__doesntNeedClassName__Lscalacss_internal_StyleS__Z(this, s0)) {
    var h = $as_Lscalacss_internal_ClassName($n($n(s0).Lscalacss_internal_StyleS__f_addClassNames).head__O());
    var t = $n($n(s0).Lscalacss_internal_StyleS__f_addClassNames).tail__sci_Vector();
    var x$1 = new $c_s_Some(h);
    var this$2 = $n(s0);
    var x$3 = this$2.Lscalacss_internal_StyleS__f_data;
    var this$3 = $n(s0);
    var x$4 = this$3.Lscalacss_internal_StyleS__f_unsafeExts;
    var this$4 = $n(s0);
    var x$5 = this$4.Lscalacss_internal_StyleS__f_warnings;
    $n(s0);
    var s = new $c_Lscalacss_internal_StyleS(x$3, x$4, x$1, t, x$5)
  } else {
    var s = s0
  };
  var this$6 = $n($n(s).Lscalacss_internal_StyleS__f_className);
  var cn = $as_Lscalacss_internal_ClassName((this$6.isEmpty__Z() ? $p_Lscalacss_internal_mutable_Register__nextName__Lscalacss_internal_ClassNameHint__Lscalacss_internal_ClassName(this, cnh) : this$6.get__O()));
  var this$7 = $n(this.Lscalacss_internal_mutable_Register__f_errHandler);
  var this$8 = $n(this$7.warn__s_Some());
  if ((!this$8.isEmpty__Z())) {
    var arg1 = this$8.s_Some__f_value;
    var f = $as_F2(arg1);
    if (this.Lscalacss_internal_mutable_Register__f__rendered) {
      $p_Lscalacss_internal_mutable_Register__warn$1__T__F2__Lscalacss_internal_ClassName__V(this, "Style being registered after stylesheet has been rendered (via .render), or extracted (via .styles).", f, cn)
    };
    if ($p_Lscalacss_internal_mutable_Register__isTaken__Lscalacss_internal_ClassName__Z(this, cn)) {
      $p_Lscalacss_internal_mutable_Register__warn$1__T__F2__Lscalacss_internal_ClassName__V(this, "Another style in the register has the same classname.", f, cn)
    };
    $n($n(s).Lscalacss_internal_StyleS__f_warnings).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4$1 = $as_Lscalacss_internal_package$Warning(x$4$2);
      $n(f).apply__O__O__O(cn, x$4$1)
    })))
  };
  var a = new $c_Lscalacss_internal_StyleA(cn, $n(s).Lscalacss_internal_StyleS__f_addClassNames, s);
  var this$10 = $n(this.Lscalacss_internal_mutable_Register__f__styles);
  this.Lscalacss_internal_mutable_Register__f__styles = $as_sci_Vector(this$10.appended__O__O(a));
  return a
});
$c_Lscalacss_internal_mutable_Register.prototype.registerF2__Lscalacss_internal_StyleF__T__F2__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleLookup__F1 = (function(s, manualName, toCN, cnh, l) {
  var add = $n(l).add__F3();
  $n(this.Lscalacss_internal_mutable_Register__f_mutex);
  var arg2 = $n(s).Lscalacss_internal_StyleF__f_domain;
  var this$2 = $n(arg2);
  var this$3 = $n($f_Lscalacss_internal_Domain__iterator__sc_Iterator(this$2));
  var this$4 = new $c_sc_Iterator$$anon$16(this$3);
  var z = $n(l).empty__O();
  var result = z;
  while (this$4.hasNext__Z()) {
    var arg1 = result;
    var arg2$1 = this$4.next__T2();
    var x1 = $ct_T2__O__O__(new $c_T2(), arg1, arg2$1);
    matchEnd4: {
      var q = x1.T2__f__1;
      var p2 = $as_T2(x1.T2__f__2);
      if ((p2 !== null)) {
        var i = $n(p2)._1__O();
        var index = $n(p2)._2$mcI$sp__I();
        var cn = new $c_Lscalacss_internal_ClassName(((manualName + "-") + $n(toCN).apply__O__O__O(i, index)));
        var qual$1 = $as_Lscalacss_internal_StyleS($n($n(s).Lscalacss_internal_StyleF__f_f).apply__O__O(i));
        var x$1 = new $c_s_Some(cn);
        var this$5 = $n(qual$1);
        var x$2 = this$5.Lscalacss_internal_StyleS__f_data;
        var this$6 = $n(qual$1);
        var x$3 = this$6.Lscalacss_internal_StyleS__f_unsafeExts;
        var this$7 = $n(qual$1);
        var x$4 = this$7.Lscalacss_internal_StyleS__f_addClassNames;
        var this$8 = $n(qual$1);
        var x$5 = this$8.Lscalacss_internal_StyleS__f_warnings;
        $n(qual$1);
        var style = new $c_Lscalacss_internal_StyleS(x$2, x$3, x$1, x$4, x$5);
        result = $n(add).apply__O__O__O__O(q, i, this.registerS__Lscalacss_internal_StyleS__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleA(style, cnh));
        break matchEnd4
      };
      throw new $c_s_MatchError(x1)
    }
  };
  var lookup = result;
  var f = $as_F1($n($n(l).get__F1()).apply__O__O(lookup));
  return new $c_sjsr_AnonFunction1(((i$2) => {
    var this$10 = $n($as_s_Option($n(f).apply__O__O(i$2)));
    if (this$10.isEmpty__Z()) {
      var this$11 = $n(this.Lscalacss_internal_mutable_Register__f_errHandler);
      this$11.badInput__Lscalacss_internal_StyleF__O__E(s, i$2)
    };
    return $as_Lscalacss_internal_StyleA(this$10.get__O())
  }))
});
$c_Lscalacss_internal_mutable_Register.prototype.registerFM__Lscalacss_internal_StyleF__T__F2__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleLookup__F1 = (function(s, nameFromMacro, toCN, cnh, l) {
  var add = $n(l).add__F3();
  $n(this.Lscalacss_internal_mutable_Register__f_mutex);
  var arg2 = $n(s).Lscalacss_internal_StyleF__f_domain;
  var this$2 = $n(arg2);
  var this$3 = $n($f_Lscalacss_internal_Domain__iterator__sc_Iterator(this$2));
  var this$4 = new $c_sc_Iterator$$anon$16(this$3);
  var z = $n(l).empty__O();
  var result = z;
  while (this$4.hasNext__Z()) {
    var arg1 = result;
    var arg2$1 = this$4.next__T2();
    var x1 = $ct_T2__O__O__(new $c_T2(), arg1, arg2$1);
    matchEnd4: {
      var q = x1.T2__f__1;
      var p2 = $as_T2(x1.T2__f__2);
      if ((p2 !== null)) {
        var i = $n(p2)._1__O();
        var index = $n(p2)._2$mcI$sp__I();
        var elem = $as_Lscalacss_internal_StyleS($n($n(s).Lscalacss_internal_StyleF__f_f).apply__O__O(i));
        var elem$1 = null;
        elem$1 = elem;
        if (($n($n($as_Lscalacss_internal_StyleS(elem$1)).Lscalacss_internal_StyleS__f_className).isEmpty__Z() && (nameFromMacro !== null))) {
          var this$6 = $n(this.Lscalacss_internal_mutable_Register__f_macroName);
          var this$7 = $n(this$6.apply__Lscalacss_internal_ClassNameHint__T__s_Option(cnh, nameFromMacro));
          if (this$7.isEmpty__Z()) {
            var $$x1 = $m_s_None$()
          } else {
            var arg1$1 = this$7.get__O();
            var n = $as_Lscalacss_internal_ClassName(arg1$1);
            var $$x1 = new $c_s_Some(new $c_Lscalacss_internal_ClassName((($n(n).Lscalacss_internal_ClassName__f_value + "-") + $as_T($n(toCN).apply__O__O__O(i, index)))))
          };
          var this$8 = $n($$x1);
          if ((!this$8.isEmpty__Z())) {
            var arg1$2 = this$8.get__O();
            var cn = $as_Lscalacss_internal_ClassName(arg1$2);
            var qual$1 = $as_Lscalacss_internal_StyleS(elem$1);
            var x$1 = new $c_s_Some($p_Lscalacss_internal_mutable_Register__ensureUnique__Lscalacss_internal_ClassName__Lscalacss_internal_ClassName(this, cn));
            var this$9 = $n(qual$1);
            var x$2 = this$9.Lscalacss_internal_StyleS__f_data;
            var this$10 = $n(qual$1);
            var x$3 = this$10.Lscalacss_internal_StyleS__f_unsafeExts;
            var this$11 = $n(qual$1);
            var x$4 = this$11.Lscalacss_internal_StyleS__f_addClassNames;
            var this$12 = $n(qual$1);
            var x$5 = this$12.Lscalacss_internal_StyleS__f_warnings;
            $n(qual$1);
            elem$1 = new $c_Lscalacss_internal_StyleS(x$2, x$3, x$1, x$4, x$5)
          }
        };
        var arg3 = $as_Lscalacss_internal_StyleS(elem$1);
        result = $n(add).apply__O__O__O__O(q, i, this.registerS__Lscalacss_internal_StyleS__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleA(arg3, cnh));
        break matchEnd4
      };
      throw new $c_s_MatchError(x1)
    }
  };
  var lookup = result;
  var f = $as_F1($n($n(l).get__F1()).apply__O__O(lookup));
  return new $c_sjsr_AnonFunction1(((i$2) => {
    var this$14 = $n($as_s_Option($n(f).apply__O__O(i$2)));
    if (this$14.isEmpty__Z()) {
      var this$15 = $n(this.Lscalacss_internal_mutable_Register__f_errHandler);
      this$15.badInput__Lscalacss_internal_StyleF__O__E(s, i$2)
    };
    return $as_Lscalacss_internal_StyleA(this$14.get__O())
  }))
});
$c_Lscalacss_internal_mutable_Register.prototype.registerKeyframes__Lscalacss_internal_Keyframes__Lscalacss_internal_ClassNameHint__Lscalacss_internal_Keyframes = (function(keyframes, cnh) {
  $n(this.Lscalacss_internal_mutable_Register__f_mutex);
  var this$2 = $n($n(this.Lscalacss_internal_mutable_Register__f_macroName).apply__Lscalacss_internal_ClassNameHint__T__s_Option(cnh, $n($n(keyframes).Lscalacss_internal_Keyframes__f_name).Lscalacss_internal_ClassName__f_value));
  if (this$2.isEmpty__Z()) {
    var cn$3 = $p_Lscalacss_internal_mutable_Register__nextName__Lscalacss_internal_ClassNameHint__Lscalacss_internal_ClassName(this, cnh)
  } else {
    var arg1 = this$2.get__O();
    var cn = $as_Lscalacss_internal_ClassName(arg1);
    var cn$3 = $p_Lscalacss_internal_mutable_Register__ensureUnique__Lscalacss_internal_ClassName__Lscalacss_internal_ClassName(this, cn)
  };
  $n(keyframes);
  var this$3 = $n(keyframes);
  var frames = this$3.Lscalacss_internal_Keyframes__f_frames;
  var kf = new $c_Lscalacss_internal_Keyframes(cn$3, frames);
  var this$5 = $n(this.Lscalacss_internal_mutable_Register__f_errHandler);
  var this$6 = $n(this$5.warn__s_Some());
  if ((!this$6.isEmpty__Z())) {
    var arg1$1 = this$6.s_Some__f_value;
    var f = $as_F2(arg1$1);
    if (this.Lscalacss_internal_mutable_Register__f__rendered) {
      $p_Lscalacss_internal_mutable_Register__warn$1__T__F2__Lscalacss_internal_ClassName__V(this, "Style being registered after stylesheet has been rendered (via .render), or extracted (via .styles).", f, cn$3)
    };
    if ($p_Lscalacss_internal_mutable_Register__isTaken__Lscalacss_internal_ClassName__Z(this, cn$3)) {
      $p_Lscalacss_internal_mutable_Register__warn$1__T__F2__Lscalacss_internal_ClassName__V(this, "Another style in the register has the same classname.", f, cn$3)
    };
    ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lscalacss_internal_package$Warning(x$4$2);
      $n(f).apply__O__O__O(cn$3, x$4)
    })))
  };
  var this$9 = $n(this.Lscalacss_internal_mutable_Register__f__keyframes);
  this.Lscalacss_internal_mutable_Register__f__keyframes = $as_sci_Vector(this$9.appended__O__O(kf));
  return kf
});
$c_Lscalacss_internal_mutable_Register.prototype.styles__sci_Vector = (function() {
  $n(this.Lscalacss_internal_mutable_Register__f_mutex);
  this.Lscalacss_internal_mutable_Register__f__rendered = true;
  return this.Lscalacss_internal_mutable_Register__f__styles
});
$c_Lscalacss_internal_mutable_Register.prototype.keyframes__sci_Vector = (function() {
  $n(this.Lscalacss_internal_mutable_Register__f_mutex);
  this.Lscalacss_internal_mutable_Register__f__rendered = true;
  return this.Lscalacss_internal_mutable_Register__f__keyframes
});
$c_Lscalacss_internal_mutable_Register.prototype.fontFaces__sci_Vector = (function() {
  $n(this.Lscalacss_internal_mutable_Register__f_mutex);
  this.Lscalacss_internal_mutable_Register__f__rendered = true;
  return this.Lscalacss_internal_mutable_Register__f__fontFaces
});
$c_Lscalacss_internal_mutable_Register.prototype.render__Lscalacss_internal_Renderer__Lscalacss_internal_Env__O = (function(r, env) {
  return $n(r).apply__sci_Vector__O($m_Lscalacss_internal_Css$().apply__sc_IterableOnce__sc_IterableOnce__sc_IterableOnce__Lscalacss_internal_Env__sci_Vector(this.styles__sci_Vector(), this.keyframes__sci_Vector(), this.fontFaces__sci_Vector(), env))
});
var $d_Lscalacss_internal_mutable_Register = new $TypeData().initClass({
  Lscalacss_internal_mutable_Register: 0
}, false, "scalacss.internal.mutable.Register", {
  Lscalacss_internal_mutable_Register: 1,
  O: 1
});
$c_Lscalacss_internal_mutable_Register.prototype.$classData = $d_Lscalacss_internal_mutable_Register;
/** @constructor */
function $c_Lscalacss_internal_mutable_Register$ErrorHandler$() {
  /*<skip>*/
}
$c_Lscalacss_internal_mutable_Register$ErrorHandler$.prototype = new $h_O();
$c_Lscalacss_internal_mutable_Register$ErrorHandler$.prototype.constructor = $c_Lscalacss_internal_mutable_Register$ErrorHandler$;
/** @constructor */
function $h_Lscalacss_internal_mutable_Register$ErrorHandler$() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_Register$ErrorHandler$.prototype = $c_Lscalacss_internal_mutable_Register$ErrorHandler$.prototype;
$c_Lscalacss_internal_mutable_Register$ErrorHandler$.prototype.noisy__Lscalacss_internal_mutable_Register$ErrorHandler = (function() {
  var eta$0$1 = $m_s_Console$().err__Ljava_io_PrintStream();
  return new $c_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T(x$1$2);
    $n(eta$0$1).println__T__V(x$1)
  })))
});
var $d_Lscalacss_internal_mutable_Register$ErrorHandler$ = new $TypeData().initClass({
  Lscalacss_internal_mutable_Register$ErrorHandler$: 0
}, false, "scalacss.internal.mutable.Register$ErrorHandler$", {
  Lscalacss_internal_mutable_Register$ErrorHandler$: 1,
  O: 1
});
$c_Lscalacss_internal_mutable_Register$ErrorHandler$.prototype.$classData = $d_Lscalacss_internal_mutable_Register$ErrorHandler$;
var $n_Lscalacss_internal_mutable_Register$ErrorHandler$;
function $m_Lscalacss_internal_mutable_Register$ErrorHandler$() {
  if ((!$n_Lscalacss_internal_mutable_Register$ErrorHandler$)) {
    $n_Lscalacss_internal_mutable_Register$ErrorHandler$ = new $c_Lscalacss_internal_mutable_Register$ErrorHandler$()
  };
  return $n_Lscalacss_internal_mutable_Register$ErrorHandler$
}
function $is_Lscalacss_internal_mutable_Register$NameGen(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalacss_internal_mutable_Register$NameGen)))
}
function $as_Lscalacss_internal_mutable_Register$NameGen(obj) {
  return (($is_Lscalacss_internal_mutable_Register$NameGen(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.mutable.Register$NameGen"))
}
function $isArrayOf_Lscalacss_internal_mutable_Register$NameGen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_mutable_Register$NameGen)))
}
function $asArrayOf_Lscalacss_internal_mutable_Register$NameGen(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_mutable_Register$NameGen(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.mutable.Register$NameGen;", depth))
}
function $p_Lscalacss_internal_mutable_StyleSheet$Base__dsl$lzycompute$1__V($thiz) {
  if (($thiz.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module === null)) {
    $thiz.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module = new $c_Lscalacss_internal_mutable_StyleSheet$Base$dsl$($thiz)
  }
}
function $ct_Lscalacss_internal_mutable_StyleSheet$Base__($thiz) {
  var s = $objectClassName($thiz);
  $thiz.Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint = new $c_Lscalacss_internal_ClassNameHint($f_T__replaceAll__T__T__T($n($f_T__replaceFirst__T__T__T($n($f_T__replaceFirst__T__T__T($n($f_T__replaceFirst__T__T__T(s, "^\\$line.+[.$]\\$iw[.$]", "")), "\\$+$", "")), "^(?:.+\\.)(.+?)$", "$1")), "\\$+", "_"));
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_mutable_StyleSheet$Base() {
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module = null;
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint = null
}
$c_Lscalacss_internal_mutable_StyleSheet$Base.prototype = new $h_O();
$c_Lscalacss_internal_mutable_StyleSheet$Base.prototype.constructor = $c_Lscalacss_internal_mutable_StyleSheet$Base;
/** @constructor */
function $h_Lscalacss_internal_mutable_StyleSheet$Base() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_StyleSheet$Base.prototype = $c_Lscalacss_internal_mutable_StyleSheet$Base.prototype;
$c_Lscalacss_internal_mutable_StyleSheet$Base.prototype.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$ = (function() {
  if ((this.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module === null)) {
    $p_Lscalacss_internal_mutable_StyleSheet$Base__dsl$lzycompute$1__V(this)
  };
  return this.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module
});
/** @constructor */
function $c_Lscalacss_internal_package$() {
  this.Lscalacss_internal_package$__f__important = null;
  this.Lscalacss_internal_package$__f__important = " !important"
}
$c_Lscalacss_internal_package$.prototype = new $h_O();
$c_Lscalacss_internal_package$.prototype.constructor = $c_Lscalacss_internal_package$;
/** @constructor */
function $h_Lscalacss_internal_package$() {
  /*<skip>*/
}
$h_Lscalacss_internal_package$.prototype = $c_Lscalacss_internal_package$.prototype;
$c_Lscalacss_internal_package$.prototype.Vector1__O__sci_Vector = (function(a) {
  $n($m_s_package$().s_package$__f_Vector);
  var this$2 = $m_sci_Vector0$();
  return this$2.appended__O__sci_Vector(a)
});
$c_Lscalacss_internal_package$.prototype.memo__F1__Ljapgolly_univeq_UnivEq__F1 = (function(f, evidence$1) {
  var m = $ct_scm_HashMap__(new $c_scm_HashMap());
  return new $c_sjsr_AnonFunction1(((a$2) => {
    var originalHash = $m_sr_Statics$().anyHash__O__I(a$2);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = $n(m.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (((-1) + $n(m.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
    var nd = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(a$2, hash));
    if ((nd === null)) {
      var b = $n(f).apply__O__O(a$2);
      $p_scm_HashMap__put0__O__O__Z__s_Some(m, a$2, b, false);
      return b
    } else {
      return $n(nd).scm_HashMap$Node__f__value
    }
  }))
});
var $d_Lscalacss_internal_package$ = new $TypeData().initClass({
  Lscalacss_internal_package$: 0
}, false, "scalacss.internal.package$", {
  Lscalacss_internal_package$: 1,
  O: 1
});
$c_Lscalacss_internal_package$.prototype.$classData = $d_Lscalacss_internal_package$;
var $n_Lscalacss_internal_package$;
function $m_Lscalacss_internal_package$() {
  if ((!$n_Lscalacss_internal_package$)) {
    $n_Lscalacss_internal_package$ = new $c_Lscalacss_internal_package$()
  };
  return $n_Lscalacss_internal_package$
}
/** @constructor */
function $c_Lscalatags_Escaping$() {
  this.Lscalatags_Escaping$__f_tagRegex = null;
  $n_Lscalatags_Escaping$ = this;
  this.Lscalatags_Escaping$__f_tagRegex = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^[a-z][:\\w0-9-]*$", $m_sci_Nil$()))
}
$c_Lscalatags_Escaping$.prototype = new $h_O();
$c_Lscalatags_Escaping$.prototype.constructor = $c_Lscalatags_Escaping$;
/** @constructor */
function $h_Lscalatags_Escaping$() {
  /*<skip>*/
}
$h_Lscalatags_Escaping$.prototype = $c_Lscalatags_Escaping$.prototype;
$c_Lscalatags_Escaping$.prototype.validTag__T__Z = (function(s) {
  var this$1 = $n($n(this.Lscalatags_Escaping$__f_tagRegex).unapplySeq__jl_CharSequence__s_Option(s));
  return (!this$1.isEmpty__Z())
});
$c_Lscalatags_Escaping$.prototype.validAttrName__T__Z = (function(s) {
  var this$1 = $n(s);
  var len = this$1.length;
  if ((len === 0)) {
    return false
  };
  var this$2 = $n(s);
  var sc = $charAt(this$2, 0);
  var startCharValid = ((((sc >= 97) && (sc <= 122)) || ((sc >= 65) && (sc <= 90))) || (sc === 58));
  if ((!startCharValid)) {
    return false
  };
  var pos = 1;
  while ((pos < len)) {
    var this$3 = $n(s);
    var index = pos;
    var c = $charAt(this$3, index);
    var valid = ((((((((c >= 97) && (c <= 122)) || ((c >= 65) && (c <= 90))) || ((c >= 48) && (c <= 57))) || (c === 45)) || (c === 58)) || (c === 46)) || (c === 95));
    if ((!valid)) {
      return false
    };
    pos = ((1 + pos) | 0)
  };
  return true
});
var $d_Lscalatags_Escaping$ = new $TypeData().initClass({
  Lscalatags_Escaping$: 0
}, false, "scalatags.Escaping$", {
  Lscalatags_Escaping$: 1,
  O: 1
});
$c_Lscalatags_Escaping$.prototype.$classData = $d_Lscalatags_Escaping$;
var $n_Lscalatags_Escaping$;
function $m_Lscalatags_Escaping$() {
  if ((!$n_Lscalatags_Escaping$)) {
    $n_Lscalatags_Escaping$ = new $c_Lscalatags_Escaping$()
  };
  return $n_Lscalatags_Escaping$
}
function $is_Lscalatags_generic_Modifier(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalatags_generic_Modifier)))
}
function $as_Lscalatags_generic_Modifier(obj) {
  return (($is_Lscalatags_generic_Modifier(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalatags.generic.Modifier"))
}
function $isArrayOf_Lscalatags_generic_Modifier(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalatags_generic_Modifier)))
}
function $asArrayOf_Lscalatags_generic_Modifier(obj, depth) {
  return (($isArrayOf_Lscalatags_generic_Modifier(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalatags.generic.Modifier;", depth))
}
function $is_Lscalatags_generic_Namespace(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscalatags_generic_Namespace)))
}
function $as_Lscalatags_generic_Namespace(obj) {
  return (($is_Lscalatags_generic_Namespace(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scalatags.generic.Namespace"))
}
function $isArrayOf_Lscalatags_generic_Namespace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalatags_generic_Namespace)))
}
function $asArrayOf_Lscalatags_generic_Namespace(obj, depth) {
  return (($isArrayOf_Lscalatags_generic_Namespace(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalatags.generic.Namespace;", depth))
}
/** @constructor */
function $c_Lscalatags_generic_Namespace$() {
  this.Lscalatags_generic_Namespace$__f_htmlNamespaceConfig = null;
  $n_Lscalatags_generic_Namespace$ = this;
  this.Lscalatags_generic_Namespace$__f_htmlNamespaceConfig = new $c_Lscalatags_generic_Namespace$$anon$1();
  new $c_Lscalatags_generic_Namespace$$anon$2();
  new $c_Lscalatags_generic_Namespace$$anon$3()
}
$c_Lscalatags_generic_Namespace$.prototype = new $h_O();
$c_Lscalatags_generic_Namespace$.prototype.constructor = $c_Lscalatags_generic_Namespace$;
/** @constructor */
function $h_Lscalatags_generic_Namespace$() {
  /*<skip>*/
}
$h_Lscalatags_generic_Namespace$.prototype = $c_Lscalatags_generic_Namespace$.prototype;
var $d_Lscalatags_generic_Namespace$ = new $TypeData().initClass({
  Lscalatags_generic_Namespace$: 0
}, false, "scalatags.generic.Namespace$", {
  Lscalatags_generic_Namespace$: 1,
  O: 1
});
$c_Lscalatags_generic_Namespace$.prototype.$classData = $d_Lscalatags_generic_Namespace$;
var $n_Lscalatags_generic_Namespace$;
function $m_Lscalatags_generic_Namespace$() {
  if ((!$n_Lscalatags_generic_Namespace$)) {
    $n_Lscalatags_generic_Namespace$ = new $c_Lscalatags_generic_Namespace$()
  };
  return $n_Lscalatags_generic_Namespace$
}
function $f_Lshapeless_Nats__$init$__V($thiz) {
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ();
  new $c_Lshapeless_Succ()
}
function $f_Lshapeless_TupleTypeableInstances__tuple2Typeable__Lshapeless_Typeable__Lshapeless_Typeable__Lshapeless_Typeable($thiz, castA, castB) {
  $m_Lshapeless_Typeable$();
  var description = new $c_sjsr_AnonFunction0((() => (((("(" + $n(castA).describe__T()) + ", ") + $n(castB).describe__T()) + ")")));
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    if ((x0$1$2 instanceof $c_T2)) {
      var x2 = $as_T2(x0$1$2);
      var t = $n(x2)._1__O();
      var this$5 = $n($n(castA).cast__O__s_Option(t));
      if (this$5.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        this$5.get__O();
        var t$1 = $n(x2)._2__O();
        var this$8 = $n($n(castB).cast__O__s_Option(t$1));
        return (this$8.isEmpty__Z() ? $m_s_None$() : new $c_s_Some((this$8.get__O(), x2)))
      }
    } else {
      return $m_s_None$()
    }
  }));
  return new $c_Lshapeless_Typeable$$anon$1(description, f)
}
/** @constructor */
function $c_Lshapeless_labelled$FieldBuilder() {
  /*<skip>*/
}
$c_Lshapeless_labelled$FieldBuilder.prototype = new $h_O();
$c_Lshapeless_labelled$FieldBuilder.prototype.constructor = $c_Lshapeless_labelled$FieldBuilder;
/** @constructor */
function $h_Lshapeless_labelled$FieldBuilder() {
  /*<skip>*/
}
$h_Lshapeless_labelled$FieldBuilder.prototype = $c_Lshapeless_labelled$FieldBuilder.prototype;
var $d_Lshapeless_labelled$FieldBuilder = new $TypeData().initClass({
  Lshapeless_labelled$FieldBuilder: 0
}, false, "shapeless.labelled$FieldBuilder", {
  Lshapeless_labelled$FieldBuilder: 1,
  O: 1
});
$c_Lshapeless_labelled$FieldBuilder.prototype.$classData = $d_Lshapeless_labelled$FieldBuilder;
/** @constructor */
function $c_Lsourcecode_SourceValue() {
  /*<skip>*/
}
$c_Lsourcecode_SourceValue.prototype = new $h_O();
$c_Lsourcecode_SourceValue.prototype.constructor = $c_Lsourcecode_SourceValue;
/** @constructor */
function $h_Lsourcecode_SourceValue() {
  /*<skip>*/
}
$h_Lsourcecode_SourceValue.prototype = $c_Lsourcecode_SourceValue.prototype;
/** @constructor */
function $c_Ltypings_geojson_mod$Feature$() {
  /*<skip>*/
}
$c_Ltypings_geojson_mod$Feature$.prototype = new $h_O();
$c_Ltypings_geojson_mod$Feature$.prototype.constructor = $c_Ltypings_geojson_mod$Feature$;
/** @constructor */
function $h_Ltypings_geojson_mod$Feature$() {
  /*<skip>*/
}
$h_Ltypings_geojson_mod$Feature$.prototype = $c_Ltypings_geojson_mod$Feature$.prototype;
var $d_Ltypings_geojson_mod$Feature$ = new $TypeData().initClass({
  Ltypings_geojson_mod$Feature$: 0
}, false, "typings.geojson.mod$Feature$", {
  Ltypings_geojson_mod$Feature$: 1,
  O: 1
});
$c_Ltypings_geojson_mod$Feature$.prototype.$classData = $d_Ltypings_geojson_mod$Feature$;
var $n_Ltypings_geojson_mod$Feature$;
function $m_Ltypings_geojson_mod$Feature$() {
  if ((!$n_Ltypings_geojson_mod$Feature$)) {
    $n_Ltypings_geojson_mod$Feature$ = new $c_Ltypings_geojson_mod$Feature$()
  };
  return $n_Ltypings_geojson_mod$Feature$
}
/** @constructor */
function $c_Ltypings_geojson_mod$Point$() {
  /*<skip>*/
}
$c_Ltypings_geojson_mod$Point$.prototype = new $h_O();
$c_Ltypings_geojson_mod$Point$.prototype.constructor = $c_Ltypings_geojson_mod$Point$;
/** @constructor */
function $h_Ltypings_geojson_mod$Point$() {
  /*<skip>*/
}
$h_Ltypings_geojson_mod$Point$.prototype = $c_Ltypings_geojson_mod$Point$.prototype;
var $d_Ltypings_geojson_mod$Point$ = new $TypeData().initClass({
  Ltypings_geojson_mod$Point$: 0
}, false, "typings.geojson.mod$Point$", {
  Ltypings_geojson_mod$Point$: 1,
  O: 1
});
$c_Ltypings_geojson_mod$Point$.prototype.$classData = $d_Ltypings_geojson_mod$Point$;
var $n_Ltypings_geojson_mod$Point$;
function $m_Ltypings_geojson_mod$Point$() {
  if ((!$n_Ltypings_geojson_mod$Point$)) {
    $n_Ltypings_geojson_mod$Point$ = new $c_Ltypings_geojson_mod$Point$()
  };
  return $n_Ltypings_geojson_mod$Point$
}
/** @constructor */
function $c_Ltypings_ol_collectionMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_collectionMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_collectionMod$Options$.prototype.constructor = $c_Ltypings_ol_collectionMod$Options$;
/** @constructor */
function $h_Ltypings_ol_collectionMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_collectionMod$Options$.prototype = $c_Ltypings_ol_collectionMod$Options$.prototype;
var $d_Ltypings_ol_collectionMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_collectionMod$Options$: 0
}, false, "typings.ol.collectionMod$Options$", {
  Ltypings_ol_collectionMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_collectionMod$Options$.prototype.$classData = $d_Ltypings_ol_collectionMod$Options$;
var $n_Ltypings_ol_collectionMod$Options$;
function $m_Ltypings_ol_collectionMod$Options$() {
  if ((!$n_Ltypings_ol_collectionMod$Options$)) {
    $n_Ltypings_ol_collectionMod$Options$ = new $c_Ltypings_ol_collectionMod$Options$()
  };
  return $n_Ltypings_ol_collectionMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_controlControlMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_controlControlMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_controlControlMod$Options$.prototype.constructor = $c_Ltypings_ol_controlControlMod$Options$;
/** @constructor */
function $h_Ltypings_ol_controlControlMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_controlControlMod$Options$.prototype = $c_Ltypings_ol_controlControlMod$Options$.prototype;
var $d_Ltypings_ol_controlControlMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_controlControlMod$Options$: 0
}, false, "typings.ol.controlControlMod$Options$", {
  Ltypings_ol_controlControlMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_controlControlMod$Options$.prototype.$classData = $d_Ltypings_ol_controlControlMod$Options$;
var $n_Ltypings_ol_controlControlMod$Options$;
function $m_Ltypings_ol_controlControlMod$Options$() {
  if ((!$n_Ltypings_ol_controlControlMod$Options$)) {
    $n_Ltypings_ol_controlControlMod$Options$ = new $c_Ltypings_ol_controlControlMod$Options$()
  };
  return $n_Ltypings_ol_controlControlMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_controlOverviewMapMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_controlOverviewMapMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_controlOverviewMapMod$Options$.prototype.constructor = $c_Ltypings_ol_controlOverviewMapMod$Options$;
/** @constructor */
function $h_Ltypings_ol_controlOverviewMapMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_controlOverviewMapMod$Options$.prototype = $c_Ltypings_ol_controlOverviewMapMod$Options$.prototype;
var $d_Ltypings_ol_controlOverviewMapMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_controlOverviewMapMod$Options$: 0
}, false, "typings.ol.controlOverviewMapMod$Options$", {
  Ltypings_ol_controlOverviewMapMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_controlOverviewMapMod$Options$.prototype.$classData = $d_Ltypings_ol_controlOverviewMapMod$Options$;
var $n_Ltypings_ol_controlOverviewMapMod$Options$;
function $m_Ltypings_ol_controlOverviewMapMod$Options$() {
  if ((!$n_Ltypings_ol_controlOverviewMapMod$Options$)) {
    $n_Ltypings_ol_controlOverviewMapMod$Options$ = new $c_Ltypings_ol_controlOverviewMapMod$Options$()
  };
  return $n_Ltypings_ol_controlOverviewMapMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_controlScaleLineMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_controlScaleLineMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_controlScaleLineMod$Options$.prototype.constructor = $c_Ltypings_ol_controlScaleLineMod$Options$;
/** @constructor */
function $h_Ltypings_ol_controlScaleLineMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_controlScaleLineMod$Options$.prototype = $c_Ltypings_ol_controlScaleLineMod$Options$.prototype;
var $d_Ltypings_ol_controlScaleLineMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_controlScaleLineMod$Options$: 0
}, false, "typings.ol.controlScaleLineMod$Options$", {
  Ltypings_ol_controlScaleLineMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_controlScaleLineMod$Options$.prototype.$classData = $d_Ltypings_ol_controlScaleLineMod$Options$;
var $n_Ltypings_ol_controlScaleLineMod$Options$;
function $m_Ltypings_ol_controlScaleLineMod$Options$() {
  if ((!$n_Ltypings_ol_controlScaleLineMod$Options$)) {
    $n_Ltypings_ol_controlScaleLineMod$Options$ = new $c_Ltypings_ol_controlScaleLineMod$Options$()
  };
  return $n_Ltypings_ol_controlScaleLineMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_extentMod$() {
  /*<skip>*/
}
$c_Ltypings_ol_extentMod$.prototype = new $h_O();
$c_Ltypings_ol_extentMod$.prototype.constructor = $c_Ltypings_ol_extentMod$;
/** @constructor */
function $h_Ltypings_ol_extentMod$() {
  /*<skip>*/
}
$h_Ltypings_ol_extentMod$.prototype = $c_Ltypings_ol_extentMod$.prototype;
var $d_Ltypings_ol_extentMod$ = new $TypeData().initClass({
  Ltypings_ol_extentMod$: 0
}, false, "typings.ol.extentMod$", {
  Ltypings_ol_extentMod$: 1,
  O: 1
});
$c_Ltypings_ol_extentMod$.prototype.$classData = $d_Ltypings_ol_extentMod$;
var $n_Ltypings_ol_extentMod$;
function $m_Ltypings_ol_extentMod$() {
  if ((!$n_Ltypings_ol_extentMod$)) {
    $n_Ltypings_ol_extentMod$ = new $c_Ltypings_ol_extentMod$()
  };
  return $n_Ltypings_ol_extentMod$
}
/** @constructor */
function $c_Ltypings_ol_formatGeoJSONMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_formatGeoJSONMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_formatGeoJSONMod$Options$.prototype.constructor = $c_Ltypings_ol_formatGeoJSONMod$Options$;
/** @constructor */
function $h_Ltypings_ol_formatGeoJSONMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_formatGeoJSONMod$Options$.prototype = $c_Ltypings_ol_formatGeoJSONMod$Options$.prototype;
var $d_Ltypings_ol_formatGeoJSONMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_formatGeoJSONMod$Options$: 0
}, false, "typings.ol.formatGeoJSONMod$Options$", {
  Ltypings_ol_formatGeoJSONMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_formatGeoJSONMod$Options$.prototype.$classData = $d_Ltypings_ol_formatGeoJSONMod$Options$;
var $n_Ltypings_ol_formatGeoJSONMod$Options$;
function $m_Ltypings_ol_formatGeoJSONMod$Options$() {
  if ((!$n_Ltypings_ol_formatGeoJSONMod$Options$)) {
    $n_Ltypings_ol_formatGeoJSONMod$Options$ = new $c_Ltypings_ol_formatGeoJSONMod$Options$()
  };
  return $n_Ltypings_ol_formatGeoJSONMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_geolocationMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_geolocationMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_geolocationMod$Options$.prototype.constructor = $c_Ltypings_ol_geolocationMod$Options$;
/** @constructor */
function $h_Ltypings_ol_geolocationMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_geolocationMod$Options$.prototype = $c_Ltypings_ol_geolocationMod$Options$.prototype;
var $d_Ltypings_ol_geolocationMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_geolocationMod$Options$: 0
}, false, "typings.ol.geolocationMod$Options$", {
  Ltypings_ol_geolocationMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_geolocationMod$Options$.prototype.$classData = $d_Ltypings_ol_geolocationMod$Options$;
var $n_Ltypings_ol_geolocationMod$Options$;
function $m_Ltypings_ol_geolocationMod$Options$() {
  if ((!$n_Ltypings_ol_geolocationMod$Options$)) {
    $n_Ltypings_ol_geolocationMod$Options$ = new $c_Ltypings_ol_geolocationMod$Options$()
  };
  return $n_Ltypings_ol_geolocationMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_interactionDrawMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_interactionDrawMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_interactionDrawMod$Options$.prototype.constructor = $c_Ltypings_ol_interactionDrawMod$Options$;
/** @constructor */
function $h_Ltypings_ol_interactionDrawMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_interactionDrawMod$Options$.prototype = $c_Ltypings_ol_interactionDrawMod$Options$.prototype;
var $d_Ltypings_ol_interactionDrawMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_interactionDrawMod$Options$: 0
}, false, "typings.ol.interactionDrawMod$Options$", {
  Ltypings_ol_interactionDrawMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_interactionDrawMod$Options$.prototype.$classData = $d_Ltypings_ol_interactionDrawMod$Options$;
var $n_Ltypings_ol_interactionDrawMod$Options$;
function $m_Ltypings_ol_interactionDrawMod$Options$() {
  if ((!$n_Ltypings_ol_interactionDrawMod$Options$)) {
    $n_Ltypings_ol_interactionDrawMod$Options$ = new $c_Ltypings_ol_interactionDrawMod$Options$()
  };
  return $n_Ltypings_ol_interactionDrawMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_interactionInteractionMod$InteractionOptions$() {
  /*<skip>*/
}
$c_Ltypings_ol_interactionInteractionMod$InteractionOptions$.prototype = new $h_O();
$c_Ltypings_ol_interactionInteractionMod$InteractionOptions$.prototype.constructor = $c_Ltypings_ol_interactionInteractionMod$InteractionOptions$;
/** @constructor */
function $h_Ltypings_ol_interactionInteractionMod$InteractionOptions$() {
  /*<skip>*/
}
$h_Ltypings_ol_interactionInteractionMod$InteractionOptions$.prototype = $c_Ltypings_ol_interactionInteractionMod$InteractionOptions$.prototype;
var $d_Ltypings_ol_interactionInteractionMod$InteractionOptions$ = new $TypeData().initClass({
  Ltypings_ol_interactionInteractionMod$InteractionOptions$: 0
}, false, "typings.ol.interactionInteractionMod$InteractionOptions$", {
  Ltypings_ol_interactionInteractionMod$InteractionOptions$: 1,
  O: 1
});
$c_Ltypings_ol_interactionInteractionMod$InteractionOptions$.prototype.$classData = $d_Ltypings_ol_interactionInteractionMod$InteractionOptions$;
var $n_Ltypings_ol_interactionInteractionMod$InteractionOptions$;
function $m_Ltypings_ol_interactionInteractionMod$InteractionOptions$() {
  if ((!$n_Ltypings_ol_interactionInteractionMod$InteractionOptions$)) {
    $n_Ltypings_ol_interactionInteractionMod$InteractionOptions$ = new $c_Ltypings_ol_interactionInteractionMod$InteractionOptions$()
  };
  return $n_Ltypings_ol_interactionInteractionMod$InteractionOptions$
}
/** @constructor */
function $c_Ltypings_ol_interactionModifyMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_interactionModifyMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_interactionModifyMod$Options$.prototype.constructor = $c_Ltypings_ol_interactionModifyMod$Options$;
/** @constructor */
function $h_Ltypings_ol_interactionModifyMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_interactionModifyMod$Options$.prototype = $c_Ltypings_ol_interactionModifyMod$Options$.prototype;
var $d_Ltypings_ol_interactionModifyMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_interactionModifyMod$Options$: 0
}, false, "typings.ol.interactionModifyMod$Options$", {
  Ltypings_ol_interactionModifyMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_interactionModifyMod$Options$.prototype.$classData = $d_Ltypings_ol_interactionModifyMod$Options$;
var $n_Ltypings_ol_interactionModifyMod$Options$;
function $m_Ltypings_ol_interactionModifyMod$Options$() {
  if ((!$n_Ltypings_ol_interactionModifyMod$Options$)) {
    $n_Ltypings_ol_interactionModifyMod$Options$ = new $c_Ltypings_ol_interactionModifyMod$Options$()
  };
  return $n_Ltypings_ol_interactionModifyMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_interactionSnapMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_interactionSnapMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_interactionSnapMod$Options$.prototype.constructor = $c_Ltypings_ol_interactionSnapMod$Options$;
/** @constructor */
function $h_Ltypings_ol_interactionSnapMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_interactionSnapMod$Options$.prototype = $c_Ltypings_ol_interactionSnapMod$Options$.prototype;
var $d_Ltypings_ol_interactionSnapMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_interactionSnapMod$Options$: 0
}, false, "typings.ol.interactionSnapMod$Options$", {
  Ltypings_ol_interactionSnapMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_interactionSnapMod$Options$.prototype.$classData = $d_Ltypings_ol_interactionSnapMod$Options$;
var $n_Ltypings_ol_interactionSnapMod$Options$;
function $m_Ltypings_ol_interactionSnapMod$Options$() {
  if ((!$n_Ltypings_ol_interactionSnapMod$Options$)) {
    $n_Ltypings_ol_interactionSnapMod$Options$ = new $c_Ltypings_ol_interactionSnapMod$Options$()
  };
  return $n_Ltypings_ol_interactionSnapMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_interactionTranslateMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_interactionTranslateMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_interactionTranslateMod$Options$.prototype.constructor = $c_Ltypings_ol_interactionTranslateMod$Options$;
/** @constructor */
function $h_Ltypings_ol_interactionTranslateMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_interactionTranslateMod$Options$.prototype = $c_Ltypings_ol_interactionTranslateMod$Options$.prototype;
var $d_Ltypings_ol_interactionTranslateMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_interactionTranslateMod$Options$: 0
}, false, "typings.ol.interactionTranslateMod$Options$", {
  Ltypings_ol_interactionTranslateMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_interactionTranslateMod$Options$.prototype.$classData = $d_Ltypings_ol_interactionTranslateMod$Options$;
var $n_Ltypings_ol_interactionTranslateMod$Options$;
function $m_Ltypings_ol_interactionTranslateMod$Options$() {
  if ((!$n_Ltypings_ol_interactionTranslateMod$Options$)) {
    $n_Ltypings_ol_interactionTranslateMod$Options$ = new $c_Ltypings_ol_interactionTranslateMod$Options$()
  };
  return $n_Ltypings_ol_interactionTranslateMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_layerBaseImageMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_layerBaseImageMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_layerBaseImageMod$Options$.prototype.constructor = $c_Ltypings_ol_layerBaseImageMod$Options$;
/** @constructor */
function $h_Ltypings_ol_layerBaseImageMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_layerBaseImageMod$Options$.prototype = $c_Ltypings_ol_layerBaseImageMod$Options$.prototype;
var $d_Ltypings_ol_layerBaseImageMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_layerBaseImageMod$Options$: 0
}, false, "typings.ol.layerBaseImageMod$Options$", {
  Ltypings_ol_layerBaseImageMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_layerBaseImageMod$Options$.prototype.$classData = $d_Ltypings_ol_layerBaseImageMod$Options$;
var $n_Ltypings_ol_layerBaseImageMod$Options$;
function $m_Ltypings_ol_layerBaseImageMod$Options$() {
  if ((!$n_Ltypings_ol_layerBaseImageMod$Options$)) {
    $n_Ltypings_ol_layerBaseImageMod$Options$ = new $c_Ltypings_ol_layerBaseImageMod$Options$()
  };
  return $n_Ltypings_ol_layerBaseImageMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_layerBaseTileMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_layerBaseTileMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_layerBaseTileMod$Options$.prototype.constructor = $c_Ltypings_ol_layerBaseTileMod$Options$;
/** @constructor */
function $h_Ltypings_ol_layerBaseTileMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_layerBaseTileMod$Options$.prototype = $c_Ltypings_ol_layerBaseTileMod$Options$.prototype;
var $d_Ltypings_ol_layerBaseTileMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_layerBaseTileMod$Options$: 0
}, false, "typings.ol.layerBaseTileMod$Options$", {
  Ltypings_ol_layerBaseTileMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_layerBaseTileMod$Options$.prototype.$classData = $d_Ltypings_ol_layerBaseTileMod$Options$;
var $n_Ltypings_ol_layerBaseTileMod$Options$;
function $m_Ltypings_ol_layerBaseTileMod$Options$() {
  if ((!$n_Ltypings_ol_layerBaseTileMod$Options$)) {
    $n_Ltypings_ol_layerBaseTileMod$Options$ = new $c_Ltypings_ol_layerBaseTileMod$Options$()
  };
  return $n_Ltypings_ol_layerBaseTileMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_layerBaseVectorMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_layerBaseVectorMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_layerBaseVectorMod$Options$.prototype.constructor = $c_Ltypings_ol_layerBaseVectorMod$Options$;
/** @constructor */
function $h_Ltypings_ol_layerBaseVectorMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_layerBaseVectorMod$Options$.prototype = $c_Ltypings_ol_layerBaseVectorMod$Options$.prototype;
var $d_Ltypings_ol_layerBaseVectorMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_layerBaseVectorMod$Options$: 0
}, false, "typings.ol.layerBaseVectorMod$Options$", {
  Ltypings_ol_layerBaseVectorMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_layerBaseVectorMod$Options$.prototype.$classData = $d_Ltypings_ol_layerBaseVectorMod$Options$;
var $n_Ltypings_ol_layerBaseVectorMod$Options$;
function $m_Ltypings_ol_layerBaseVectorMod$Options$() {
  if ((!$n_Ltypings_ol_layerBaseVectorMod$Options$)) {
    $n_Ltypings_ol_layerBaseVectorMod$Options$ = new $c_Ltypings_ol_layerBaseVectorMod$Options$()
  };
  return $n_Ltypings_ol_layerBaseVectorMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_loadingstrategyMod$() {
  /*<skip>*/
}
$c_Ltypings_ol_loadingstrategyMod$.prototype = new $h_O();
$c_Ltypings_ol_loadingstrategyMod$.prototype.constructor = $c_Ltypings_ol_loadingstrategyMod$;
/** @constructor */
function $h_Ltypings_ol_loadingstrategyMod$() {
  /*<skip>*/
}
$h_Ltypings_ol_loadingstrategyMod$.prototype = $c_Ltypings_ol_loadingstrategyMod$.prototype;
var $d_Ltypings_ol_loadingstrategyMod$ = new $TypeData().initClass({
  Ltypings_ol_loadingstrategyMod$: 0
}, false, "typings.ol.loadingstrategyMod$", {
  Ltypings_ol_loadingstrategyMod$: 1,
  O: 1
});
$c_Ltypings_ol_loadingstrategyMod$.prototype.$classData = $d_Ltypings_ol_loadingstrategyMod$;
var $n_Ltypings_ol_loadingstrategyMod$;
function $m_Ltypings_ol_loadingstrategyMod$() {
  if ((!$n_Ltypings_ol_loadingstrategyMod$)) {
    $n_Ltypings_ol_loadingstrategyMod$ = new $c_Ltypings_ol_loadingstrategyMod$()
  };
  return $n_Ltypings_ol_loadingstrategyMod$
}
/** @constructor */
function $c_Ltypings_ol_olStrings$() {
  /*<skip>*/
}
$c_Ltypings_ol_olStrings$.prototype = new $h_O();
$c_Ltypings_ol_olStrings$.prototype.constructor = $c_Ltypings_ol_olStrings$;
/** @constructor */
function $h_Ltypings_ol_olStrings$() {
  /*<skip>*/
}
$h_Ltypings_ol_olStrings$.prototype = $c_Ltypings_ol_olStrings$.prototype;
var $d_Ltypings_ol_olStrings$ = new $TypeData().initClass({
  Ltypings_ol_olStrings$: 0
}, false, "typings.ol.olStrings$", {
  Ltypings_ol_olStrings$: 1,
  O: 1
});
$c_Ltypings_ol_olStrings$.prototype.$classData = $d_Ltypings_ol_olStrings$;
var $n_Ltypings_ol_olStrings$;
function $m_Ltypings_ol_olStrings$() {
  if ((!$n_Ltypings_ol_olStrings$)) {
    $n_Ltypings_ol_olStrings$ = new $c_Ltypings_ol_olStrings$()
  };
  return $n_Ltypings_ol_olStrings$
}
/** @constructor */
function $c_Ltypings_ol_pluggableMapMod$MapOptions$() {
  /*<skip>*/
}
$c_Ltypings_ol_pluggableMapMod$MapOptions$.prototype = new $h_O();
$c_Ltypings_ol_pluggableMapMod$MapOptions$.prototype.constructor = $c_Ltypings_ol_pluggableMapMod$MapOptions$;
/** @constructor */
function $h_Ltypings_ol_pluggableMapMod$MapOptions$() {
  /*<skip>*/
}
$h_Ltypings_ol_pluggableMapMod$MapOptions$.prototype = $c_Ltypings_ol_pluggableMapMod$MapOptions$.prototype;
var $d_Ltypings_ol_pluggableMapMod$MapOptions$ = new $TypeData().initClass({
  Ltypings_ol_pluggableMapMod$MapOptions$: 0
}, false, "typings.ol.pluggableMapMod$MapOptions$", {
  Ltypings_ol_pluggableMapMod$MapOptions$: 1,
  O: 1
});
$c_Ltypings_ol_pluggableMapMod$MapOptions$.prototype.$classData = $d_Ltypings_ol_pluggableMapMod$MapOptions$;
var $n_Ltypings_ol_pluggableMapMod$MapOptions$;
function $m_Ltypings_ol_pluggableMapMod$MapOptions$() {
  if ((!$n_Ltypings_ol_pluggableMapMod$MapOptions$)) {
    $n_Ltypings_ol_pluggableMapMod$MapOptions$ = new $c_Ltypings_ol_pluggableMapMod$MapOptions$()
  };
  return $n_Ltypings_ol_pluggableMapMod$MapOptions$
}
/** @constructor */
function $c_Ltypings_ol_projMod$() {
  /*<skip>*/
}
$c_Ltypings_ol_projMod$.prototype = new $h_O();
$c_Ltypings_ol_projMod$.prototype.constructor = $c_Ltypings_ol_projMod$;
/** @constructor */
function $h_Ltypings_ol_projMod$() {
  /*<skip>*/
}
$h_Ltypings_ol_projMod$.prototype = $c_Ltypings_ol_projMod$.prototype;
var $d_Ltypings_ol_projMod$ = new $TypeData().initClass({
  Ltypings_ol_projMod$: 0
}, false, "typings.ol.projMod$", {
  Ltypings_ol_projMod$: 1,
  O: 1
});
$c_Ltypings_ol_projMod$.prototype.$classData = $d_Ltypings_ol_projMod$;
var $n_Ltypings_ol_projMod$;
function $m_Ltypings_ol_projMod$() {
  if ((!$n_Ltypings_ol_projMod$)) {
    $n_Ltypings_ol_projMod$ = new $c_Ltypings_ol_projMod$()
  };
  return $n_Ltypings_ol_projMod$
}
/** @constructor */
function $c_Ltypings_ol_sourceImageWMSMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_sourceImageWMSMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_sourceImageWMSMod$Options$.prototype.constructor = $c_Ltypings_ol_sourceImageWMSMod$Options$;
/** @constructor */
function $h_Ltypings_ol_sourceImageWMSMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_sourceImageWMSMod$Options$.prototype = $c_Ltypings_ol_sourceImageWMSMod$Options$.prototype;
var $d_Ltypings_ol_sourceImageWMSMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_sourceImageWMSMod$Options$: 0
}, false, "typings.ol.sourceImageWMSMod$Options$", {
  Ltypings_ol_sourceImageWMSMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_sourceImageWMSMod$Options$.prototype.$classData = $d_Ltypings_ol_sourceImageWMSMod$Options$;
var $n_Ltypings_ol_sourceImageWMSMod$Options$;
function $m_Ltypings_ol_sourceImageWMSMod$Options$() {
  if ((!$n_Ltypings_ol_sourceImageWMSMod$Options$)) {
    $n_Ltypings_ol_sourceImageWMSMod$Options$ = new $c_Ltypings_ol_sourceImageWMSMod$Options$()
  };
  return $n_Ltypings_ol_sourceImageWMSMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_sourceOsmMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_sourceOsmMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_sourceOsmMod$Options$.prototype.constructor = $c_Ltypings_ol_sourceOsmMod$Options$;
/** @constructor */
function $h_Ltypings_ol_sourceOsmMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_sourceOsmMod$Options$.prototype = $c_Ltypings_ol_sourceOsmMod$Options$.prototype;
var $d_Ltypings_ol_sourceOsmMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_sourceOsmMod$Options$: 0
}, false, "typings.ol.sourceOsmMod$Options$", {
  Ltypings_ol_sourceOsmMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_sourceOsmMod$Options$.prototype.$classData = $d_Ltypings_ol_sourceOsmMod$Options$;
var $n_Ltypings_ol_sourceOsmMod$Options$;
function $m_Ltypings_ol_sourceOsmMod$Options$() {
  if ((!$n_Ltypings_ol_sourceOsmMod$Options$)) {
    $n_Ltypings_ol_sourceOsmMod$Options$ = new $c_Ltypings_ol_sourceOsmMod$Options$()
  };
  return $n_Ltypings_ol_sourceOsmMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_sourceTileDebugMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_sourceTileDebugMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_sourceTileDebugMod$Options$.prototype.constructor = $c_Ltypings_ol_sourceTileDebugMod$Options$;
/** @constructor */
function $h_Ltypings_ol_sourceTileDebugMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_sourceTileDebugMod$Options$.prototype = $c_Ltypings_ol_sourceTileDebugMod$Options$.prototype;
var $d_Ltypings_ol_sourceTileDebugMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_sourceTileDebugMod$Options$: 0
}, false, "typings.ol.sourceTileDebugMod$Options$", {
  Ltypings_ol_sourceTileDebugMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_sourceTileDebugMod$Options$.prototype.$classData = $d_Ltypings_ol_sourceTileDebugMod$Options$;
var $n_Ltypings_ol_sourceTileDebugMod$Options$;
function $m_Ltypings_ol_sourceTileDebugMod$Options$() {
  if ((!$n_Ltypings_ol_sourceTileDebugMod$Options$)) {
    $n_Ltypings_ol_sourceTileDebugMod$Options$ = new $c_Ltypings_ol_sourceTileDebugMod$Options$()
  };
  return $n_Ltypings_ol_sourceTileDebugMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_sourceVectorMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_sourceVectorMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_sourceVectorMod$Options$.prototype.constructor = $c_Ltypings_ol_sourceVectorMod$Options$;
/** @constructor */
function $h_Ltypings_ol_sourceVectorMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_sourceVectorMod$Options$.prototype = $c_Ltypings_ol_sourceVectorMod$Options$.prototype;
var $d_Ltypings_ol_sourceVectorMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_sourceVectorMod$Options$: 0
}, false, "typings.ol.sourceVectorMod$Options$", {
  Ltypings_ol_sourceVectorMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_sourceVectorMod$Options$.prototype.$classData = $d_Ltypings_ol_sourceVectorMod$Options$;
var $n_Ltypings_ol_sourceVectorMod$Options$;
function $m_Ltypings_ol_sourceVectorMod$Options$() {
  if ((!$n_Ltypings_ol_sourceVectorMod$Options$)) {
    $n_Ltypings_ol_sourceVectorMod$Options$ = new $c_Ltypings_ol_sourceVectorMod$Options$()
  };
  return $n_Ltypings_ol_sourceVectorMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_sourceWmtsMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_sourceWmtsMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_sourceWmtsMod$Options$.prototype.constructor = $c_Ltypings_ol_sourceWmtsMod$Options$;
/** @constructor */
function $h_Ltypings_ol_sourceWmtsMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_sourceWmtsMod$Options$.prototype = $c_Ltypings_ol_sourceWmtsMod$Options$.prototype;
var $d_Ltypings_ol_sourceWmtsMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_sourceWmtsMod$Options$: 0
}, false, "typings.ol.sourceWmtsMod$Options$", {
  Ltypings_ol_sourceWmtsMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_sourceWmtsMod$Options$.prototype.$classData = $d_Ltypings_ol_sourceWmtsMod$Options$;
var $n_Ltypings_ol_sourceWmtsMod$Options$;
function $m_Ltypings_ol_sourceWmtsMod$Options$() {
  if ((!$n_Ltypings_ol_sourceWmtsMod$Options$)) {
    $n_Ltypings_ol_sourceWmtsMod$Options$ = new $c_Ltypings_ol_sourceWmtsMod$Options$()
  };
  return $n_Ltypings_ol_sourceWmtsMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_sourceXyzMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_sourceXyzMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_sourceXyzMod$Options$.prototype.constructor = $c_Ltypings_ol_sourceXyzMod$Options$;
/** @constructor */
function $h_Ltypings_ol_sourceXyzMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_sourceXyzMod$Options$.prototype = $c_Ltypings_ol_sourceXyzMod$Options$.prototype;
var $d_Ltypings_ol_sourceXyzMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_sourceXyzMod$Options$: 0
}, false, "typings.ol.sourceXyzMod$Options$", {
  Ltypings_ol_sourceXyzMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_sourceXyzMod$Options$.prototype.$classData = $d_Ltypings_ol_sourceXyzMod$Options$;
var $n_Ltypings_ol_sourceXyzMod$Options$;
function $m_Ltypings_ol_sourceXyzMod$Options$() {
  if ((!$n_Ltypings_ol_sourceXyzMod$Options$)) {
    $n_Ltypings_ol_sourceXyzMod$Options$ = new $c_Ltypings_ol_sourceXyzMod$Options$()
  };
  return $n_Ltypings_ol_sourceXyzMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_styleCircleMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_styleCircleMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_styleCircleMod$Options$.prototype.constructor = $c_Ltypings_ol_styleCircleMod$Options$;
/** @constructor */
function $h_Ltypings_ol_styleCircleMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_styleCircleMod$Options$.prototype = $c_Ltypings_ol_styleCircleMod$Options$.prototype;
var $d_Ltypings_ol_styleCircleMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_styleCircleMod$Options$: 0
}, false, "typings.ol.styleCircleMod$Options$", {
  Ltypings_ol_styleCircleMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_styleCircleMod$Options$.prototype.$classData = $d_Ltypings_ol_styleCircleMod$Options$;
var $n_Ltypings_ol_styleCircleMod$Options$;
function $m_Ltypings_ol_styleCircleMod$Options$() {
  if ((!$n_Ltypings_ol_styleCircleMod$Options$)) {
    $n_Ltypings_ol_styleCircleMod$Options$ = new $c_Ltypings_ol_styleCircleMod$Options$()
  };
  return $n_Ltypings_ol_styleCircleMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_styleFillMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_styleFillMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_styleFillMod$Options$.prototype.constructor = $c_Ltypings_ol_styleFillMod$Options$;
/** @constructor */
function $h_Ltypings_ol_styleFillMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_styleFillMod$Options$.prototype = $c_Ltypings_ol_styleFillMod$Options$.prototype;
var $d_Ltypings_ol_styleFillMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_styleFillMod$Options$: 0
}, false, "typings.ol.styleFillMod$Options$", {
  Ltypings_ol_styleFillMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_styleFillMod$Options$.prototype.$classData = $d_Ltypings_ol_styleFillMod$Options$;
var $n_Ltypings_ol_styleFillMod$Options$;
function $m_Ltypings_ol_styleFillMod$Options$() {
  if ((!$n_Ltypings_ol_styleFillMod$Options$)) {
    $n_Ltypings_ol_styleFillMod$Options$ = new $c_Ltypings_ol_styleFillMod$Options$()
  };
  return $n_Ltypings_ol_styleFillMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_styleStrokeMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_styleStrokeMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_styleStrokeMod$Options$.prototype.constructor = $c_Ltypings_ol_styleStrokeMod$Options$;
/** @constructor */
function $h_Ltypings_ol_styleStrokeMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_styleStrokeMod$Options$.prototype = $c_Ltypings_ol_styleStrokeMod$Options$.prototype;
var $d_Ltypings_ol_styleStrokeMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_styleStrokeMod$Options$: 0
}, false, "typings.ol.styleStrokeMod$Options$", {
  Ltypings_ol_styleStrokeMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_styleStrokeMod$Options$.prototype.$classData = $d_Ltypings_ol_styleStrokeMod$Options$;
var $n_Ltypings_ol_styleStrokeMod$Options$;
function $m_Ltypings_ol_styleStrokeMod$Options$() {
  if ((!$n_Ltypings_ol_styleStrokeMod$Options$)) {
    $n_Ltypings_ol_styleStrokeMod$Options$ = new $c_Ltypings_ol_styleStrokeMod$Options$()
  };
  return $n_Ltypings_ol_styleStrokeMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_styleStyleMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_styleStyleMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_styleStyleMod$Options$.prototype.constructor = $c_Ltypings_ol_styleStyleMod$Options$;
/** @constructor */
function $h_Ltypings_ol_styleStyleMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_styleStyleMod$Options$.prototype = $c_Ltypings_ol_styleStyleMod$Options$.prototype;
var $d_Ltypings_ol_styleStyleMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_styleStyleMod$Options$: 0
}, false, "typings.ol.styleStyleMod$Options$", {
  Ltypings_ol_styleStyleMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_styleStyleMod$Options$.prototype.$classData = $d_Ltypings_ol_styleStyleMod$Options$;
var $n_Ltypings_ol_styleStyleMod$Options$;
function $m_Ltypings_ol_styleStyleMod$Options$() {
  if ((!$n_Ltypings_ol_styleStyleMod$Options$)) {
    $n_Ltypings_ol_styleStyleMod$Options$ = new $c_Ltypings_ol_styleStyleMod$Options$()
  };
  return $n_Ltypings_ol_styleStyleMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_styleTextMod$Options$() {
  /*<skip>*/
}
$c_Ltypings_ol_styleTextMod$Options$.prototype = new $h_O();
$c_Ltypings_ol_styleTextMod$Options$.prototype.constructor = $c_Ltypings_ol_styleTextMod$Options$;
/** @constructor */
function $h_Ltypings_ol_styleTextMod$Options$() {
  /*<skip>*/
}
$h_Ltypings_ol_styleTextMod$Options$.prototype = $c_Ltypings_ol_styleTextMod$Options$.prototype;
var $d_Ltypings_ol_styleTextMod$Options$ = new $TypeData().initClass({
  Ltypings_ol_styleTextMod$Options$: 0
}, false, "typings.ol.styleTextMod$Options$", {
  Ltypings_ol_styleTextMod$Options$: 1,
  O: 1
});
$c_Ltypings_ol_styleTextMod$Options$.prototype.$classData = $d_Ltypings_ol_styleTextMod$Options$;
var $n_Ltypings_ol_styleTextMod$Options$;
function $m_Ltypings_ol_styleTextMod$Options$() {
  if ((!$n_Ltypings_ol_styleTextMod$Options$)) {
    $n_Ltypings_ol_styleTextMod$Options$ = new $c_Ltypings_ol_styleTextMod$Options$()
  };
  return $n_Ltypings_ol_styleTextMod$Options$
}
/** @constructor */
function $c_Ltypings_ol_utilMod$() {
  /*<skip>*/
}
$c_Ltypings_ol_utilMod$.prototype = new $h_O();
$c_Ltypings_ol_utilMod$.prototype.constructor = $c_Ltypings_ol_utilMod$;
/** @constructor */
function $h_Ltypings_ol_utilMod$() {
  /*<skip>*/
}
$h_Ltypings_ol_utilMod$.prototype = $c_Ltypings_ol_utilMod$.prototype;
var $d_Ltypings_ol_utilMod$ = new $TypeData().initClass({
  Ltypings_ol_utilMod$: 0
}, false, "typings.ol.utilMod$", {
  Ltypings_ol_utilMod$: 1,
  O: 1
});
$c_Ltypings_ol_utilMod$.prototype.$classData = $d_Ltypings_ol_utilMod$;
var $n_Ltypings_ol_utilMod$;
function $m_Ltypings_ol_utilMod$() {
  if ((!$n_Ltypings_ol_utilMod$)) {
    $n_Ltypings_ol_utilMod$ = new $c_Ltypings_ol_utilMod$()
  };
  return $n_Ltypings_ol_utilMod$
}
/** @constructor */
function $c_Ltypings_ol_viewMod$AnimationOptions$() {
  /*<skip>*/
}
$c_Ltypings_ol_viewMod$AnimationOptions$.prototype = new $h_O();
$c_Ltypings_ol_viewMod$AnimationOptions$.prototype.constructor = $c_Ltypings_ol_viewMod$AnimationOptions$;
/** @constructor */
function $h_Ltypings_ol_viewMod$AnimationOptions$() {
  /*<skip>*/
}
$h_Ltypings_ol_viewMod$AnimationOptions$.prototype = $c_Ltypings_ol_viewMod$AnimationOptions$.prototype;
var $d_Ltypings_ol_viewMod$AnimationOptions$ = new $TypeData().initClass({
  Ltypings_ol_viewMod$AnimationOptions$: 0
}, false, "typings.ol.viewMod$AnimationOptions$", {
  Ltypings_ol_viewMod$AnimationOptions$: 1,
  O: 1
});
$c_Ltypings_ol_viewMod$AnimationOptions$.prototype.$classData = $d_Ltypings_ol_viewMod$AnimationOptions$;
var $n_Ltypings_ol_viewMod$AnimationOptions$;
function $m_Ltypings_ol_viewMod$AnimationOptions$() {
  if ((!$n_Ltypings_ol_viewMod$AnimationOptions$)) {
    $n_Ltypings_ol_viewMod$AnimationOptions$ = new $c_Ltypings_ol_viewMod$AnimationOptions$()
  };
  return $n_Ltypings_ol_viewMod$AnimationOptions$
}
/** @constructor */
function $c_Ltypings_ol_viewMod$ViewOptions$() {
  /*<skip>*/
}
$c_Ltypings_ol_viewMod$ViewOptions$.prototype = new $h_O();
$c_Ltypings_ol_viewMod$ViewOptions$.prototype.constructor = $c_Ltypings_ol_viewMod$ViewOptions$;
/** @constructor */
function $h_Ltypings_ol_viewMod$ViewOptions$() {
  /*<skip>*/
}
$h_Ltypings_ol_viewMod$ViewOptions$.prototype = $c_Ltypings_ol_viewMod$ViewOptions$.prototype;
var $d_Ltypings_ol_viewMod$ViewOptions$ = new $TypeData().initClass({
  Ltypings_ol_viewMod$ViewOptions$: 0
}, false, "typings.ol.viewMod$ViewOptions$", {
  Ltypings_ol_viewMod$ViewOptions$: 1,
  O: 1
});
$c_Ltypings_ol_viewMod$ViewOptions$.prototype.$classData = $d_Ltypings_ol_viewMod$ViewOptions$;
var $n_Ltypings_ol_viewMod$ViewOptions$;
function $m_Ltypings_ol_viewMod$ViewOptions$() {
  if ((!$n_Ltypings_ol_viewMod$ViewOptions$)) {
    $n_Ltypings_ol_viewMod$ViewOptions$ = new $c_Ltypings_ol_viewMod$ViewOptions$()
  };
  return $n_Ltypings_ol_viewMod$ViewOptions$
}
function $p_Lzonedb_java_tzdb$__fixedZones$lzycompute__sjs_js_Dynamic($thiz) {
  if (((((2 & $thiz.Lzonedb_java_tzdb$__f_bitmap$0) << 24) >> 24) === 0)) {
    var array = [$ct_T2__O__O__(new $c_T2(), "Etc/GMT-8", 28800), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+2", (-7200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+12", (-43200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+5", (-18000)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+1", (-3600)), $ct_T2__O__O__(new $c_T2(), "HST", (-36000)), $ct_T2__O__O__(new $c_T2(), "WET", 0), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-11", 39600), $ct_T2__O__O__(new $c_T2(), "EST", (-18000)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-12", 43200), $ct_T2__O__O__(new $c_T2(), "Etc/UTC", 0), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+11", (-39600)), $ct_T2__O__O__(new $c_T2(), "PST8PDT", (-28800)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-2", 7200), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+7", (-25200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-13", 46800), $ct_T2__O__O__(new $c_T2(), "Etc/GMT", 0), $ct_T2__O__O__(new $c_T2(), "CET", 3600), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+10", (-36000)), $ct_T2__O__O__(new $c_T2(), "CST6CDT", (-21600)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-1", 3600), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-4", 14400), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-10", 36000), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+4", (-14400)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+6", (-21600)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-5", 18000), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+8", (-28800)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-14", 50400), $ct_T2__O__O__(new $c_T2(), "MST", (-25200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-7", 25200), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-6", 21600), $ct_T2__O__O__(new $c_T2(), "MST7MDT", (-25200)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+3", (-10800)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-3", 10800), $ct_T2__O__O__(new $c_T2(), "MET", 3600), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+9", (-32400)), $ct_T2__O__O__(new $c_T2(), "EET", 7200), $ct_T2__O__O__(new $c_T2(), "EST5EDT", (-18000)), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-9", 32400)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Lzonedb_java_tzdb$__f_fixedZones = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    $thiz.Lzonedb_java_tzdb$__f_bitmap$0 = (((2 | $thiz.Lzonedb_java_tzdb$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lzonedb_java_tzdb$__f_fixedZones
}
function $p_Lzonedb_java_tzdb$__stdZones$lzycompute__sjs_js_Dynamic($thiz) {
  if (((((4 & $thiz.Lzonedb_java_tzdb$__f_bitmap$0) << 24) >> 24) === 0)) {
    var array = [$ct_T2__O__O__(new $c_T2(), "Asia/Hovd", $m_Lzonedb_java_tzdb$asiov$().Asia_Hovd__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Atyrau", $m_Lzonedb_java_tzdb$asira$().Asia_Atyrau__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Ust-Nera", $m_Lzonedb_java_tzdb$asier$().Asia_Ust_minus_Nera__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Efate", $m_Lzonedb_java_tzdb$pacat$().Pacific_Efate__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Lima", $m_Lzonedb_java_tzdb$ameim$().America_Lima__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Brussels", $m_Lzonedb_java_tzdb$eurel$().Europe_Brussels__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Yakutat", $m_Lzonedb_java_tzdb$ameta$().America_Yakutat__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Chita", $m_Lzonedb_java_tzdb$asiit$().Asia_Chita__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Minsk", $m_Lzonedb_java_tzdb$eurns$().Europe_Minsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Sao_Paulo", $m_Lzonedb_java_tzdb$ameul$().America_Sao_Paulo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Khandyga", $m_Lzonedb_java_tzdb$asiyg$().Asia_Khandyga__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Bucharest", $m_Lzonedb_java_tzdb$eures$().Europe_Bucharest__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Indian/Cocos", $m_Lzonedb_java_tzdb$indco$().Indian_Cocos__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Belize", $m_Lzonedb_java_tzdb$ameiz$().America_Belize__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Nipigon", $m_Lzonedb_java_tzdb$amego$().America_Nipigon__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/Ushuaia", $m_Lzonedb_java_tzdb$ameai$().America_Argentina_Ushuaia__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Colombo", $m_Lzonedb_java_tzdb$asimb$().Asia_Colombo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Vienna", $m_Lzonedb_java_tzdb$eurnn$().Europe_Vienna__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Khartoum", $m_Lzonedb_java_tzdb$afrou$().Africa_Khartoum__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Andorra", $m_Lzonedb_java_tzdb$eurrr$().Europe_Andorra__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Thimphu", $m_Lzonedb_java_tzdb$asiph$().Asia_Thimphu__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/La_Rioja", $m_Lzonedb_java_tzdb$ameoj$().America_Argentina_La_Rioja__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Atlantic/Reykjavik", $m_Lzonedb_java_tzdb$atlvi$().Atlantic_Reykjavik__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Indian/Mauritius", $m_Lzonedb_java_tzdb$indiu$().Indian_Mauritius__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Zaporozhye", $m_Lzonedb_java_tzdb$eurhy$().Europe_Zaporozhye__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Pago_Pago", $m_Lzonedb_java_tzdb$pacag$().Pacific_Pago_Pago__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Atlantic/Faroe", $m_Lzonedb_java_tzdb$atlro$().Atlantic_Faroe__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Saratov", $m_Lzonedb_java_tzdb$eurto$().Europe_Saratov__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Monaco", $m_Lzonedb_java_tzdb$eurac$().Europe_Monaco__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Adak", $m_Lzonedb_java_tzdb$ameda$().America_Adak__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Yerevan", $m_Lzonedb_java_tzdb$asiva$().Asia_Yerevan__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Indiana/Tell_City", $m_Lzonedb_java_tzdb$ameit$().America_Indiana_Tell_City__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Noronha", $m_Lzonedb_java_tzdb$amenh$().America_Noronha__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Dhaka", $m_Lzonedb_java_tzdb$asiak$().Asia_Dhaka__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Abidjan", $m_Lzonedb_java_tzdb$afrja$().Africa_Abidjan__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Manila", $m_Lzonedb_java_tzdb$asiil$().Asia_Manila__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Athens", $m_Lzonedb_java_tzdb$euren$().Europe_Athens__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Pyongyang", $m_Lzonedb_java_tzdb$asian$().Asia_Pyongyang__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Pangnirtung", $m_Lzonedb_java_tzdb$ameun$().America_Pangnirtung__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Toronto", $m_Lzonedb_java_tzdb$ament$().America_Toronto__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Indiana/Vincennes", $m_Lzonedb_java_tzdb$amene$().America_Indiana_Vincennes__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Recife", $m_Lzonedb_java_tzdb$ameif$().America_Recife__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Ulaanbaatar", $m_Lzonedb_java_tzdb$asita$().Asia_Ulaanbaatar__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Lindeman", $m_Lzonedb_java_tzdb$ausma$().Australia_Lindeman__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Creston", $m_Lzonedb_java_tzdb$ameto$().America_Creston__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Ho_Chi_Minh", $m_Lzonedb_java_tzdb$asiin$().Asia_Ho_Chi_Minh__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Merida", $m_Lzonedb_java_tzdb$ameid$().America_Merida__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Miquelon", $m_Lzonedb_java_tzdb$amelo$().America_Miquelon__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Almaty", $m_Lzonedb_java_tzdb$asiat$().Asia_Almaty__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Metlakatla", $m_Lzonedb_java_tzdb$ametl$().America_Metlakatla__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Pohnpei", $m_Lzonedb_java_tzdb$pacpe$().Pacific_Pohnpei__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Belgrade", $m_Lzonedb_java_tzdb$eurad$().Europe_Belgrade__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Perth", $m_Lzonedb_java_tzdb$ausrt$().Australia_Perth__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Rio_Branco", $m_Lzonedb_java_tzdb$amenc$().America_Rio_Branco__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Yekaterinburg", $m_Lzonedb_java_tzdb$asiur$().Asia_Yekaterinburg__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Atlantic/Stanley", $m_Lzonedb_java_tzdb$atlle$().Atlantic_Stanley__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Casablanca", $m_Lzonedb_java_tzdb$afrnc$().Africa_Casablanca__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Jakarta", $m_Lzonedb_java_tzdb$asirt$().Asia_Jakarta__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Kwajalein", $m_Lzonedb_java_tzdb$pacei$().Pacific_Kwajalein__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Caracas", $m_Lzonedb_java_tzdb$ameca$().America_Caracas__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Marquesas", $m_Lzonedb_java_tzdb$pacsa$().Pacific_Marquesas__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Gambier", $m_Lzonedb_java_tzdb$pacie$().Pacific_Gambier__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Algiers", $m_Lzonedb_java_tzdb$afrer$().Africa_Algiers__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Matamoros", $m_Lzonedb_java_tzdb$amero$().America_Matamoros__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Indiana/Knox", $m_Lzonedb_java_tzdb$ameno$().America_Indiana_Knox__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Samara", $m_Lzonedb_java_tzdb$eurar$().Europe_Samara__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/Tucuman", $m_Lzonedb_java_tzdb$amema$().America_Argentina_Tucuman__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Novosibirsk", $m_Lzonedb_java_tzdb$asirs$().Asia_Novosibirsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Tijuana", $m_Lzonedb_java_tzdb$amean$().America_Tijuana__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Gibraltar", $m_Lzonedb_java_tzdb$eurta$().Europe_Gibraltar__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Dawson", $m_Lzonedb_java_tzdb$ameso$().America_Dawson__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Qatar", $m_Lzonedb_java_tzdb$asita$().Asia_Qatar__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Port_of_Spain", $m_Lzonedb_java_tzdb$ameai$().America_Port_of_Spain__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/Jujuy", $m_Lzonedb_java_tzdb$ameju$().America_Argentina_Jujuy__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Campo_Grande", $m_Lzonedb_java_tzdb$amend$().America_Campo_Grande__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Tunis", $m_Lzonedb_java_tzdb$afrni$().Africa_Tunis__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Macau", $m_Lzonedb_java_tzdb$asica$().Asia_Macau__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Regina", $m_Lzonedb_java_tzdb$amein$().America_Regina__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Currie", $m_Lzonedb_java_tzdb$ausri$().Australia_Currie__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Winnipeg", $m_Lzonedb_java_tzdb$amepe$().America_Winnipeg__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Indian/Christmas", $m_Lzonedb_java_tzdb$indma$().Indian_Christmas__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Boise", $m_Lzonedb_java_tzdb$ameis$().America_Boise__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Copenhagen", $m_Lzonedb_java_tzdb$eurge$().Europe_Copenhagen__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Kamchatka", $m_Lzonedb_java_tzdb$asitk$().Asia_Kamchatka__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Havana", $m_Lzonedb_java_tzdb$amean$().America_Havana__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Menominee", $m_Lzonedb_java_tzdb$amene$().America_Menominee__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Chuuk", $m_Lzonedb_java_tzdb$pacuu$().Pacific_Chuuk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Novokuznetsk", $m_Lzonedb_java_tzdb$asits$().Asia_Novokuznetsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Kabul", $m_Lzonedb_java_tzdb$asibu$().Asia_Kabul__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Kolkata", $m_Lzonedb_java_tzdb$asiat$().Asia_Kolkata__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Baghdad", $m_Lzonedb_java_tzdb$asida$().Asia_Baghdad__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Easter", $m_Lzonedb_java_tzdb$pacte$().Pacific_Easter__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Omsk", $m_Lzonedb_java_tzdb$asims$().Asia_Omsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Riyadh", $m_Lzonedb_java_tzdb$asiad$().Asia_Riyadh__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Krasnoyarsk", $m_Lzonedb_java_tzdb$asirs$().Asia_Krasnoyarsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Apia", $m_Lzonedb_java_tzdb$pacpi$().Pacific_Apia__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Rarotonga", $m_Lzonedb_java_tzdb$pacng$().Pacific_Rarotonga__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Thunder_Bay", $m_Lzonedb_java_tzdb$ameba$().America_Thunder_Bay__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Chisinau", $m_Lzonedb_java_tzdb$eurna$().Europe_Chisinau__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Noumea", $m_Lzonedb_java_tzdb$pacme$().Pacific_Noumea__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Dushanbe", $m_Lzonedb_java_tzdb$asinb$().Asia_Dushanbe__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Dubai", $m_Lzonedb_java_tzdb$asiba$().Asia_Dubai__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/Davis", $m_Lzonedb_java_tzdb$antvi$().Antarctica_Davis__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Iqaluit", $m_Lzonedb_java_tzdb$ameui$().America_Iqaluit__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/Palmer", $m_Lzonedb_java_tzdb$antme$().Antarctica_Palmer__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Simferopol", $m_Lzonedb_java_tzdb$eurpo$().Europe_Simferopol__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/Rothera", $m_Lzonedb_java_tzdb$anter$().Antarctica_Rothera__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Nome", $m_Lzonedb_java_tzdb$ameom$().America_Nome__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Indiana/Vevay", $m_Lzonedb_java_tzdb$ameva$().America_Indiana_Vevay__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Rainy_River", $m_Lzonedb_java_tzdb$ameve$().America_Rainy_River__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Moncton", $m_Lzonedb_java_tzdb$ameto$().America_Moncton__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Nairobi", $m_Lzonedb_java_tzdb$afrob$().Africa_Nairobi__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/London", $m_Lzonedb_java_tzdb$eurdo$().Europe_London__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Yellowknife", $m_Lzonedb_java_tzdb$ameif$().America_Yellowknife__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Lord_Howe", $m_Lzonedb_java_tzdb$ausow$().Australia_Lord_Howe__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Nauru", $m_Lzonedb_java_tzdb$pacur$().Pacific_Nauru__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Darwin", $m_Lzonedb_java_tzdb$auswi$().Australia_Darwin__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/North_Dakota/Center", $m_Lzonedb_java_tzdb$amete$().America_North_Dakota_Center__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Jerusalem", $m_Lzonedb_java_tzdb$asile$().Asia_Jerusalem__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Dublin", $m_Lzonedb_java_tzdb$eurli$().Europe_Dublin__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Montevideo", $m_Lzonedb_java_tzdb$amede$().America_Montevideo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Zurich", $m_Lzonedb_java_tzdb$euric$().Europe_Zurich__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/North_Dakota/New_Salem", $m_Lzonedb_java_tzdb$amele$().America_North_Dakota_New_Salem__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Beirut", $m_Lzonedb_java_tzdb$asiru$().Asia_Beirut__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Makassar", $m_Lzonedb_java_tzdb$asisa$().Asia_Makassar__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Prague", $m_Lzonedb_java_tzdb$eurgu$().Europe_Prague__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Juneau", $m_Lzonedb_java_tzdb$ameea$().America_Juneau__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Amsterdam", $m_Lzonedb_java_tzdb$eurda$().Europe_Amsterdam__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Sitka", $m_Lzonedb_java_tzdb$ametk$().America_Sitka__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/New_York", $m_Lzonedb_java_tzdb$ameor$().America_New_York__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Juba", $m_Lzonedb_java_tzdb$afrub$().Africa_Juba__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Indiana/Indianapolis", $m_Lzonedb_java_tzdb$ameli$().America_Indiana_Indianapolis__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Niue", $m_Lzonedb_java_tzdb$paciu$().Pacific_Niue__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Kiritimati", $m_Lzonedb_java_tzdb$pacat$().Pacific_Kiritimati__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Malta", $m_Lzonedb_java_tzdb$eurlt$().Europe_Malta__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Singapore", $m_Lzonedb_java_tzdb$asior$().Asia_Singapore__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Goose_Bay", $m_Lzonedb_java_tzdb$ameba$().America_Goose_Bay__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Curacao", $m_Lzonedb_java_tzdb$ameca$().America_Curacao__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Scoresbysund", $m_Lzonedb_java_tzdb$ameun$().America_Scoresbysund__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Edmonton", $m_Lzonedb_java_tzdb$ameto$().America_Edmonton__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Guam", $m_Lzonedb_java_tzdb$pacua$().Pacific_Guam__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Indiana/Petersburg", $m_Lzonedb_java_tzdb$ameur$().America_Indiana_Petersburg__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Mazatlan", $m_Lzonedb_java_tzdb$amela$().America_Mazatlan__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Gaza", $m_Lzonedb_java_tzdb$asiaz$().Asia_Gaza__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Adelaide", $m_Lzonedb_java_tzdb$ausid$().Australia_Adelaide__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Guadalcanal", $m_Lzonedb_java_tzdb$pacna$().Pacific_Guadalcanal__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Srednekolymsk", $m_Lzonedb_java_tzdb$asims$().Asia_Srednekolymsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Urumqi", $m_Lzonedb_java_tzdb$asimq$().Asia_Urumqi__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Uzhgorod", $m_Lzonedb_java_tzdb$eurro$().Europe_Uzhgorod__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Lisbon", $m_Lzonedb_java_tzdb$eurbo$().Europe_Lisbon__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Barnaul", $m_Lzonedb_java_tzdb$asiau$().Asia_Barnaul__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Nicosia", $m_Lzonedb_java_tzdb$asisi$().Asia_Nicosia__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Madrid", $m_Lzonedb_java_tzdb$eurri$().Europe_Madrid__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/Mawson", $m_Lzonedb_java_tzdb$antso$().Antarctica_Mawson__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Inuvik", $m_Lzonedb_java_tzdb$amevi$().America_Inuvik__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Atlantic/Bermuda", $m_Lzonedb_java_tzdb$atlud$().Atlantic_Bermuda__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Windhoek", $m_Lzonedb_java_tzdb$afroe$().Africa_Windhoek__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/San_Juan", $m_Lzonedb_java_tzdb$ameua$().America_Argentina_San_Juan__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Palau", $m_Lzonedb_java_tzdb$pacla$().Pacific_Palau__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Godthab", $m_Lzonedb_java_tzdb$ameha$().America_Godthab__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Puerto_Rico", $m_Lzonedb_java_tzdb$ameic$().America_Puerto_Rico__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Majuro", $m_Lzonedb_java_tzdb$pacur$().Pacific_Majuro__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Tegucigalpa", $m_Lzonedb_java_tzdb$amelp$().America_Tegucigalpa__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Vladivostok", $m_Lzonedb_java_tzdb$asito$().Asia_Vladivostok__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Galapagos", $m_Lzonedb_java_tzdb$pacgo$().Pacific_Galapagos__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Sao_Tome", $m_Lzonedb_java_tzdb$afrom$().Africa_Sao_Tome__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Tahiti", $m_Lzonedb_java_tzdb$pacit$().Pacific_Tahiti__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Berlin", $m_Lzonedb_java_tzdb$eurli$().Europe_Berlin__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Bahia_Banderas", $m_Lzonedb_java_tzdb$amera$().America_Bahia_Banderas__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Kentucky/Louisville", $m_Lzonedb_java_tzdb$amell$().America_Kentucky_Louisville__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Qostanay", $m_Lzonedb_java_tzdb$asina$().Asia_Qostanay__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Boa_Vista", $m_Lzonedb_java_tzdb$amest$().America_Boa_Vista__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Istanbul", $m_Lzonedb_java_tzdb$eurbu$().Europe_Istanbul__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/Syowa", $m_Lzonedb_java_tzdb$antow$().Antarctica_Syowa__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Araguaina", $m_Lzonedb_java_tzdb$amein$().America_Araguaina__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/Vostok", $m_Lzonedb_java_tzdb$antto$().Antarctica_Vostok__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Guatemala", $m_Lzonedb_java_tzdb$ameal$().America_Guatemala__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Monterrey", $m_Lzonedb_java_tzdb$amere$().America_Monterrey__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Indiana/Winamac", $m_Lzonedb_java_tzdb$amema$().America_Indiana_Winamac__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Halifax", $m_Lzonedb_java_tzdb$amefa$().America_Halifax__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Kuala_Lumpur", $m_Lzonedb_java_tzdb$asipu$().Asia_Kuala_Lumpur__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Amman", $m_Lzonedb_java_tzdb$asima$().Asia_Amman__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Dawson_Creek", $m_Lzonedb_java_tzdb$ameee$().America_Dawson_Creek__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/Casey", $m_Lzonedb_java_tzdb$antse$().Antarctica_Casey__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Rankin_Inlet", $m_Lzonedb_java_tzdb$amele$().America_Rankin_Inlet__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Oral", $m_Lzonedb_java_tzdb$asira$().Asia_Oral__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Budapest", $m_Lzonedb_java_tzdb$eures$().Europe_Budapest__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Ashgabat", $m_Lzonedb_java_tzdb$asiba$().Asia_Ashgabat__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Irkutsk", $m_Lzonedb_java_tzdb$asits$().Asia_Irkutsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Helsinki", $m_Lzonedb_java_tzdb$eurnk$().Europe_Helsinki__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Indian/Chagos", $m_Lzonedb_java_tzdb$indgo$().Indian_Chagos__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Eucla", $m_Lzonedb_java_tzdb$auscl$().Australia_Eucla__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Kirov", $m_Lzonedb_java_tzdb$eurro$().Europe_Kirov__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Baku", $m_Lzonedb_java_tzdb$asiak$().Asia_Baku__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Samarkand", $m_Lzonedb_java_tzdb$asian$().Asia_Samarkand__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Pontianak", $m_Lzonedb_java_tzdb$asina$().Asia_Pontianak__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Dili", $m_Lzonedb_java_tzdb$asiil$().Asia_Dili__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Auckland", $m_Lzonedb_java_tzdb$pacan$().Pacific_Auckland__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Tirane", $m_Lzonedb_java_tzdb$euran$().Europe_Tirane__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Fiji", $m_Lzonedb_java_tzdb$pacij$().Pacific_Fiji__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Hong_Kong", $m_Lzonedb_java_tzdb$asion$().Asia_Hong_Kong__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Kathmandu", $m_Lzonedb_java_tzdb$asind$().Asia_Kathmandu__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Tbilisi", $m_Lzonedb_java_tzdb$asiis$().Asia_Tbilisi__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Sakhalin", $m_Lzonedb_java_tzdb$asili$().Asia_Sakhalin__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/Cordoba", $m_Lzonedb_java_tzdb$ameob$().America_Argentina_Cordoba__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Melbourne", $m_Lzonedb_java_tzdb$ausrn$().Australia_Melbourne__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Enderbury", $m_Lzonedb_java_tzdb$pacur$().Pacific_Enderbury__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/El_Salvador", $m_Lzonedb_java_tzdb$amedo$().America_El_Salvador__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Swift_Current", $m_Lzonedb_java_tzdb$ameen$().America_Swift_Current__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Bangkok", $m_Lzonedb_java_tzdb$asiko$().Asia_Bangkok__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Fakaofo", $m_Lzonedb_java_tzdb$pacof$().Pacific_Fakaofo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Asuncion", $m_Lzonedb_java_tzdb$ameio$().America_Asuncion__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Chatham", $m_Lzonedb_java_tzdb$pacha$().Pacific_Chatham__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/DumontDUrville", $m_Lzonedb_java_tzdb$antll$().Antarctica_DumontDUrville__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Atikokan", $m_Lzonedb_java_tzdb$ameka$().America_Atikokan__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Cuiaba", $m_Lzonedb_java_tzdb$ameab$().America_Cuiaba__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Pitcairn", $m_Lzonedb_java_tzdb$pacir$().Pacific_Pitcairn__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Chihuahua", $m_Lzonedb_java_tzdb$amehu$().America_Chihuahua__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Cairo", $m_Lzonedb_java_tzdb$afrir$().Africa_Cairo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Luxembourg", $m_Lzonedb_java_tzdb$eurur$().Europe_Luxembourg__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Norfolk", $m_Lzonedb_java_tzdb$pacol$().Pacific_Norfolk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Brunei", $m_Lzonedb_java_tzdb$asine$().Asia_Brunei__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Funafuti", $m_Lzonedb_java_tzdb$pacut$().Pacific_Funafuti__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Lagos", $m_Lzonedb_java_tzdb$afrgo$().Africa_Lagos__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Ceuta", $m_Lzonedb_java_tzdb$afrut$().Africa_Ceuta__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Cambridge_Bay", $m_Lzonedb_java_tzdb$ameba$().America_Cambridge_Bay__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/Catamarca", $m_Lzonedb_java_tzdb$amerc$().America_Argentina_Catamarca__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Riga", $m_Lzonedb_java_tzdb$eurig$().Europe_Riga__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Bahia", $m_Lzonedb_java_tzdb$amehi$().America_Bahia__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Resolute", $m_Lzonedb_java_tzdb$ameut$().America_Resolute__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Tripoli", $m_Lzonedb_java_tzdb$afrol$().Africa_Tripoli__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Thule", $m_Lzonedb_java_tzdb$ameul$().America_Thule__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Johannesburg", $m_Lzonedb_java_tzdb$afrur$().Africa_Johannesburg__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Whitehorse", $m_Lzonedb_java_tzdb$amers$().America_Whitehorse__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Oslo", $m_Lzonedb_java_tzdb$eursl$().Europe_Oslo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Maceio", $m_Lzonedb_java_tzdb$ameei$().America_Maceio__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Port_Moresby", $m_Lzonedb_java_tzdb$pacsb$().Pacific_Port_Moresby__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/El_Aaiun", $m_Lzonedb_java_tzdb$afriu$().Africa_El_Aaiun__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Jayapura", $m_Lzonedb_java_tzdb$asiur$().Asia_Jayapura__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Choibalsan", $m_Lzonedb_java_tzdb$asisa$().Asia_Choibalsan__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Tarawa", $m_Lzonedb_java_tzdb$pacaw$().Pacific_Tarawa__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Hermosillo", $m_Lzonedb_java_tzdb$amell$().America_Hermosillo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Indian/Kerguelen", $m_Lzonedb_java_tzdb$indle$().Indian_Kerguelen__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Taipei", $m_Lzonedb_java_tzdb$asipe$().Asia_Taipei__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Volgograd", $m_Lzonedb_java_tzdb$eurra$().Europe_Volgograd__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Kiev", $m_Lzonedb_java_tzdb$eurie$().Europe_Kiev__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Kuching", $m_Lzonedb_java_tzdb$asiin$().Asia_Kuching__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Phoenix", $m_Lzonedb_java_tzdb$ameni$().America_Phoenix__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Barbados", $m_Lzonedb_java_tzdb$amedo$().America_Barbados__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/Rio_Gallegos", $m_Lzonedb_java_tzdb$amego$().America_Argentina_Rio_Gallegos__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Magadan", $m_Lzonedb_java_tzdb$asida$().Asia_Magadan__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Atlantic/Madeira", $m_Lzonedb_java_tzdb$atlir$().Atlantic_Madeira__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Atlantic/South_Georgia", $m_Lzonedb_java_tzdb$atlgi$().Atlantic_South_Georgia__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/Troll", $m_Lzonedb_java_tzdb$antol$().Antarctica_Troll__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Antarctica/Macquarie", $m_Lzonedb_java_tzdb$antri$().Antarctica_Macquarie__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/Buenos_Aires", $m_Lzonedb_java_tzdb$amere$().America_Argentina_Buenos_Aires__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Belem", $m_Lzonedb_java_tzdb$amele$().America_Belem__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Indian/Reunion", $m_Lzonedb_java_tzdb$indio$().Indian_Reunion__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Anadyr", $m_Lzonedb_java_tzdb$asidy$().Asia_Anadyr__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Atlantic/Azores", $m_Lzonedb_java_tzdb$atlre$().Atlantic_Azores__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Vancouver", $m_Lzonedb_java_tzdb$ameve$().America_Vancouver__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Jamaica", $m_Lzonedb_java_tzdb$ameic$().America_Jamaica__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Manaus", $m_Lzonedb_java_tzdb$ameau$().America_Manaus__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Aqtobe", $m_Lzonedb_java_tzdb$asiob$().Asia_Aqtobe__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Indian/Mahe", $m_Lzonedb_java_tzdb$indah$().Indian_Mahe__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Ulyanovsk", $m_Lzonedb_java_tzdb$eurvs$().Europe_Ulyanovsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Tashkent", $m_Lzonedb_java_tzdb$asien$().Asia_Tashkent__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Martinique", $m_Lzonedb_java_tzdb$amequ$().America_Martinique__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Astrakhan", $m_Lzonedb_java_tzdb$eurha$().Europe_Astrakhan__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Paris", $m_Lzonedb_java_tzdb$eurri$().Europe_Paris__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Kentucky/Monticello", $m_Lzonedb_java_tzdb$amell$().America_Kentucky_Monticello__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/San_Luis", $m_Lzonedb_java_tzdb$ameui$().America_Argentina_San_Luis__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Shanghai", $m_Lzonedb_java_tzdb$asiha$().Asia_Shanghai__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Ojinaga", $m_Lzonedb_java_tzdb$ameag$().America_Ojinaga__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Santo_Domingo", $m_Lzonedb_java_tzdb$ameng$().America_Santo_Domingo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Managua", $m_Lzonedb_java_tzdb$amegu$().America_Managua__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Nassau", $m_Lzonedb_java_tzdb$amesa$().America_Nassau__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/Salta", $m_Lzonedb_java_tzdb$amelt$().America_Argentina_Salta__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Paramaribo", $m_Lzonedb_java_tzdb$ameib$().America_Paramaribo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Anchorage", $m_Lzonedb_java_tzdb$ameag$().America_Anchorage__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Argentina/Mendoza", $m_Lzonedb_java_tzdb$ameoz$().America_Argentina_Mendoza__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Ndjamena", $m_Lzonedb_java_tzdb$afren$().Africa_Ndjamena__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Tallinn", $m_Lzonedb_java_tzdb$eurin$().Europe_Tallinn__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Bogota", $m_Lzonedb_java_tzdb$ameot$().America_Bogota__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Famagusta", $m_Lzonedb_java_tzdb$asist$().Asia_Famagusta__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Indiana/Marengo", $m_Lzonedb_java_tzdb$ameng$().America_Indiana_Marengo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Fort_Nelson", $m_Lzonedb_java_tzdb$ameso$().America_Fort_Nelson__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/St_Johns", $m_Lzonedb_java_tzdb$amehn$().America_St_Johns__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Warsaw", $m_Lzonedb_java_tzdb$eursa$().Europe_Warsaw__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Guayaquil", $m_Lzonedb_java_tzdb$ameui$().America_Guayaquil__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Maputo", $m_Lzonedb_java_tzdb$afrut$().Africa_Maputo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Detroit", $m_Lzonedb_java_tzdb$ameoi$().America_Detroit__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Denver", $m_Lzonedb_java_tzdb$ameve$().America_Denver__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Danmarkshavn", $m_Lzonedb_java_tzdb$ameav$().America_Danmarkshavn__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Port-au-Prince", $m_Lzonedb_java_tzdb$amenc$().America_Port_minus_au_minus_Prince__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Mexico_City", $m_Lzonedb_java_tzdb$ameit$().America_Mexico_City__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Cayenne", $m_Lzonedb_java_tzdb$amenn$().America_Cayenne__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Seoul", $m_Lzonedb_java_tzdb$asiou$().Asia_Seoul__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Atlantic/Canary", $m_Lzonedb_java_tzdb$atlar$().Atlantic_Canary__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Hebron", $m_Lzonedb_java_tzdb$asiro$().Asia_Hebron__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Stockholm", $m_Lzonedb_java_tzdb$eurol$().Europe_Stockholm__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Sydney", $m_Lzonedb_java_tzdb$ausne$().Australia_Sydney__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Bougainville", $m_Lzonedb_java_tzdb$pacll$().Pacific_Bougainville__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Grand_Turk", $m_Lzonedb_java_tzdb$ameur$().America_Grand_Turk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Punta_Arenas", $m_Lzonedb_java_tzdb$amena$().America_Punta_Arenas__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/La_Paz", $m_Lzonedb_java_tzdb$amepa$().America_La_Paz__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Los_Angeles", $m_Lzonedb_java_tzdb$amele$().America_Los_Angeles__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Wake", $m_Lzonedb_java_tzdb$pacak$().Pacific_Wake__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Kaliningrad", $m_Lzonedb_java_tzdb$eurra$().Europe_Kaliningrad__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Broken_Hill", $m_Lzonedb_java_tzdb$ausil$().Australia_Broken_Hill__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Karachi", $m_Lzonedb_java_tzdb$asich$().Asia_Karachi__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Qyzylorda", $m_Lzonedb_java_tzdb$asird$().Asia_Qyzylorda__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Monrovia", $m_Lzonedb_java_tzdb$afrvi$().Africa_Monrovia__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Glace_Bay", $m_Lzonedb_java_tzdb$ameba$().America_Glace_Bay__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Kosrae", $m_Lzonedb_java_tzdb$pacra$().Pacific_Kosrae__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Tongatapu", $m_Lzonedb_java_tzdb$pacap$().Pacific_Tongatapu__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Yakutsk", $m_Lzonedb_java_tzdb$asits$().Asia_Yakutsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Aqtau", $m_Lzonedb_java_tzdb$asita$().Asia_Aqtau__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Wallis", $m_Lzonedb_java_tzdb$pacli$().Pacific_Wallis__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Guyana", $m_Lzonedb_java_tzdb$amean$().America_Guyana__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Rome", $m_Lzonedb_java_tzdb$eurom$().Europe_Rome__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Cancun", $m_Lzonedb_java_tzdb$amecu$().America_Cancun__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Tokyo", $m_Lzonedb_java_tzdb$asiky$().Asia_Tokyo__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Moscow", $m_Lzonedb_java_tzdb$eurco$().Europe_Moscow__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Damascus", $m_Lzonedb_java_tzdb$asicu$().Asia_Damascus__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Eirunepe", $m_Lzonedb_java_tzdb$ameep$().America_Eirunepe__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Atlantic/Cape_Verde", $m_Lzonedb_java_tzdb$atlrd$().Atlantic_Cape_Verde__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Tehran", $m_Lzonedb_java_tzdb$asira$().Asia_Tehran__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Pacific/Honolulu", $m_Lzonedb_java_tzdb$pacul$().Pacific_Honolulu__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Yangon", $m_Lzonedb_java_tzdb$asigo$().Asia_Yangon__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Fortaleza", $m_Lzonedb_java_tzdb$ameez$().America_Fortaleza__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Porto_Velho", $m_Lzonedb_java_tzdb$amelh$().America_Porto_Velho__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Santiago", $m_Lzonedb_java_tzdb$ameag$().America_Santiago__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Tomsk", $m_Lzonedb_java_tzdb$asims$().Asia_Tomsk__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Santarem", $m_Lzonedb_java_tzdb$amere$().America_Santarem__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Asia/Bishkek", $m_Lzonedb_java_tzdb$asike$().Asia_Bishkek__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Chicago", $m_Lzonedb_java_tzdb$ameag$().America_Chicago__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Panama", $m_Lzonedb_java_tzdb$ameam$().America_Panama__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/North_Dakota/Beulah", $m_Lzonedb_java_tzdb$amela$().America_North_Dakota_Beulah__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Accra", $m_Lzonedb_java_tzdb$afrcr$().Africa_Accra__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Sofia", $m_Lzonedb_java_tzdb$eurfi$().Europe_Sofia__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Hobart", $m_Lzonedb_java_tzdb$ausar$().Australia_Hobart__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Costa_Rica", $m_Lzonedb_java_tzdb$ameic$().America_Costa_Rica__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Australia/Brisbane", $m_Lzonedb_java_tzdb$ausan$().Australia_Brisbane__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Europe/Vilnius", $m_Lzonedb_java_tzdb$euriu$().Europe_Vilnius__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Africa/Bissau", $m_Lzonedb_java_tzdb$afrsa$().Africa_Bissau__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "America/Blanc-Sablon", $m_Lzonedb_java_tzdb$amelo$().America_Blanc_minus_Sablon__sjs_js_Dynamic()), $ct_T2__O__O__(new $c_T2(), "Indian/Maldives", $m_Lzonedb_java_tzdb$indve$().Indian_Maldives__sjs_js_Dynamic())];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Lzonedb_java_tzdb$__f_stdZones = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    $thiz.Lzonedb_java_tzdb$__f_bitmap$0 = (((4 | $thiz.Lzonedb_java_tzdb$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lzonedb_java_tzdb$__f_stdZones
}
function $p_Lzonedb_java_tzdb$__zoneLinks$lzycompute__sci_Map($thiz) {
  if (((((8 & $thiz.Lzonedb_java_tzdb$__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$4 = $n($m_s_Predef$().s_Predef$__f_Map);
    var array = [$ct_T2__O__O__(new $c_T2(), "US/Pacific-New", "America/Los_Angeles"), $ct_T2__O__O__(new $c_T2(), "Africa/Bamako", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Banjul", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Conakry", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Dakar", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Freetown", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Lome", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Nouakchott", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Ouagadougou", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Atlantic/St_Helena", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "Africa/Addis_Ababa", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Asmara", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Dar_es_Salaam", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Djibouti", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Kampala", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Mogadishu", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Indian/Antananarivo", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Indian/Comoro", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Indian/Mayotte", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Blantyre", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Bujumbura", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Gaborone", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Harare", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Kigali", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Lubumbashi", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Lusaka", "Africa/Maputo"), $ct_T2__O__O__(new $c_T2(), "Africa/Bangui", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Brazzaville", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Douala", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Kinshasa", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Libreville", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Luanda", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Malabo", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Niamey", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Porto-Novo", "Africa/Lagos"), $ct_T2__O__O__(new $c_T2(), "Africa/Maseru", "Africa/Johannesburg"), $ct_T2__O__O__(new $c_T2(), "Africa/Mbabane", "Africa/Johannesburg"), $ct_T2__O__O__(new $c_T2(), "America/Aruba", "America/Curacao"), $ct_T2__O__O__(new $c_T2(), "America/Lower_Princes", "America/Curacao"), $ct_T2__O__O__(new $c_T2(), "America/Kralendijk", "America/Curacao"), $ct_T2__O__O__(new $c_T2(), "America/Anguilla", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Antigua", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Dominica", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Grenada", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Guadeloupe", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Marigot", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Montserrat", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Barthelemy", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Kitts", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Lucia", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Thomas", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/St_Vincent", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "America/Tortola", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "GMT", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Etc/Universal", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "Etc/Zulu", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "Etc/Greenwich", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Etc/GMT-0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Etc/GMT+0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Etc/GMT0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Europe/Jersey", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "Europe/Guernsey", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "Europe/Isle_of_Man", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "Europe/Mariehamn", "Europe/Helsinki"), $ct_T2__O__O__(new $c_T2(), "Europe/Busingen", "Europe/Zurich"), $ct_T2__O__O__(new $c_T2(), "Europe/Vatican", "Europe/Rome"), $ct_T2__O__O__(new $c_T2(), "Europe/San_Marino", "Europe/Rome"), $ct_T2__O__O__(new $c_T2(), "Europe/Vaduz", "Europe/Zurich"), $ct_T2__O__O__(new $c_T2(), "Arctic/Longyearbyen", "Europe/Oslo"), $ct_T2__O__O__(new $c_T2(), "Europe/Ljubljana", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Podgorica", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Sarajevo", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Skopje", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Zagreb", "Europe/Belgrade"), $ct_T2__O__O__(new $c_T2(), "Europe/Bratislava", "Europe/Prague"), $ct_T2__O__O__(new $c_T2(), "Asia/Istanbul", "Europe/Istanbul"), $ct_T2__O__O__(new $c_T2(), "Pacific/Saipan", "Pacific/Guam"), $ct_T2__O__O__(new $c_T2(), "Antarctica/McMurdo", "Pacific/Auckland"), $ct_T2__O__O__(new $c_T2(), "Pacific/Midway", "Pacific/Pago_Pago"), $ct_T2__O__O__(new $c_T2(), "Europe/Nicosia", "Asia/Nicosia"), $ct_T2__O__O__(new $c_T2(), "Asia/Bahrain", "Asia/Qatar"), $ct_T2__O__O__(new $c_T2(), "Asia/Aden", "Asia/Riyadh"), $ct_T2__O__O__(new $c_T2(), "Asia/Kuwait", "Asia/Riyadh"), $ct_T2__O__O__(new $c_T2(), "Asia/Phnom_Penh", "Asia/Bangkok"), $ct_T2__O__O__(new $c_T2(), "Asia/Vientiane", "Asia/Bangkok"), $ct_T2__O__O__(new $c_T2(), "Asia/Muscat", "Asia/Dubai"), $ct_T2__O__O__(new $c_T2(), "Africa/Asmera", "Africa/Nairobi"), $ct_T2__O__O__(new $c_T2(), "Africa/Timbuktu", "Africa/Abidjan"), $ct_T2__O__O__(new $c_T2(), "America/Argentina/ComodRivadavia", "America/Argentina/Catamarca"), $ct_T2__O__O__(new $c_T2(), "America/Atka", "America/Adak"), $ct_T2__O__O__(new $c_T2(), "America/Buenos_Aires", "America/Argentina/Buenos_Aires"), $ct_T2__O__O__(new $c_T2(), "America/Catamarca", "America/Argentina/Catamarca"), $ct_T2__O__O__(new $c_T2(), "America/Coral_Harbour", "America/Atikokan"), $ct_T2__O__O__(new $c_T2(), "America/Cordoba", "America/Argentina/Cordoba"), $ct_T2__O__O__(new $c_T2(), "America/Ensenada", "America/Tijuana"), $ct_T2__O__O__(new $c_T2(), "America/Fort_Wayne", "America/Indiana/Indianapolis"), $ct_T2__O__O__(new $c_T2(), "America/Indianapolis", "America/Indiana/Indianapolis"), $ct_T2__O__O__(new $c_T2(), "America/Jujuy", "America/Argentina/Jujuy"), $ct_T2__O__O__(new $c_T2(), "America/Knox_IN", "America/Indiana/Knox"), $ct_T2__O__O__(new $c_T2(), "America/Louisville", "America/Kentucky/Louisville"), $ct_T2__O__O__(new $c_T2(), "America/Mendoza", "America/Argentina/Mendoza"), $ct_T2__O__O__(new $c_T2(), "America/Montreal", "America/Toronto"), $ct_T2__O__O__(new $c_T2(), "America/Porto_Acre", "America/Rio_Branco"), $ct_T2__O__O__(new $c_T2(), "America/Rosario", "America/Argentina/Cordoba"), $ct_T2__O__O__(new $c_T2(), "America/Santa_Isabel", "America/Tijuana"), $ct_T2__O__O__(new $c_T2(), "America/Shiprock", "America/Denver"), $ct_T2__O__O__(new $c_T2(), "America/Virgin", "America/Port_of_Spain"), $ct_T2__O__O__(new $c_T2(), "Antarctica/South_Pole", "Pacific/Auckland"), $ct_T2__O__O__(new $c_T2(), "Asia/Ashkhabad", "Asia/Ashgabat"), $ct_T2__O__O__(new $c_T2(), "Asia/Calcutta", "Asia/Kolkata"), $ct_T2__O__O__(new $c_T2(), "Asia/Chongqing", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "Asia/Chungking", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "Asia/Dacca", "Asia/Dhaka"), $ct_T2__O__O__(new $c_T2(), "Asia/Harbin", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "Asia/Kashgar", "Asia/Urumqi"), $ct_T2__O__O__(new $c_T2(), "Asia/Katmandu", "Asia/Kathmandu"), $ct_T2__O__O__(new $c_T2(), "Asia/Macao", "Asia/Macau"), $ct_T2__O__O__(new $c_T2(), "Asia/Rangoon", "Asia/Yangon"), $ct_T2__O__O__(new $c_T2(), "Asia/Saigon", "Asia/Ho_Chi_Minh"), $ct_T2__O__O__(new $c_T2(), "Asia/Tel_Aviv", "Asia/Jerusalem"), $ct_T2__O__O__(new $c_T2(), "Asia/Thimbu", "Asia/Thimphu"), $ct_T2__O__O__(new $c_T2(), "Asia/Ujung_Pandang", "Asia/Makassar"), $ct_T2__O__O__(new $c_T2(), "Asia/Ulan_Bator", "Asia/Ulaanbaatar"), $ct_T2__O__O__(new $c_T2(), "Atlantic/Faeroe", "Atlantic/Faroe"), $ct_T2__O__O__(new $c_T2(), "Atlantic/Jan_Mayen", "Europe/Oslo"), $ct_T2__O__O__(new $c_T2(), "Australia/ACT", "Australia/Sydney"), $ct_T2__O__O__(new $c_T2(), "Australia/Canberra", "Australia/Sydney"), $ct_T2__O__O__(new $c_T2(), "Australia/LHI", "Australia/Lord_Howe"), $ct_T2__O__O__(new $c_T2(), "Australia/NSW", "Australia/Sydney"), $ct_T2__O__O__(new $c_T2(), "Australia/North", "Australia/Darwin"), $ct_T2__O__O__(new $c_T2(), "Australia/Queensland", "Australia/Brisbane"), $ct_T2__O__O__(new $c_T2(), "Australia/South", "Australia/Adelaide"), $ct_T2__O__O__(new $c_T2(), "Australia/Tasmania", "Australia/Hobart"), $ct_T2__O__O__(new $c_T2(), "Australia/Victoria", "Australia/Melbourne"), $ct_T2__O__O__(new $c_T2(), "Australia/West", "Australia/Perth"), $ct_T2__O__O__(new $c_T2(), "Australia/Yancowinna", "Australia/Broken_Hill"), $ct_T2__O__O__(new $c_T2(), "Brazil/Acre", "America/Rio_Branco"), $ct_T2__O__O__(new $c_T2(), "Brazil/DeNoronha", "America/Noronha"), $ct_T2__O__O__(new $c_T2(), "Brazil/East", "America/Sao_Paulo"), $ct_T2__O__O__(new $c_T2(), "Brazil/West", "America/Manaus"), $ct_T2__O__O__(new $c_T2(), "Canada/Atlantic", "America/Halifax"), $ct_T2__O__O__(new $c_T2(), "Canada/Central", "America/Winnipeg"), $ct_T2__O__O__(new $c_T2(), "Canada/Eastern", "America/Toronto"), $ct_T2__O__O__(new $c_T2(), "Canada/Mountain", "America/Edmonton"), $ct_T2__O__O__(new $c_T2(), "Canada/Newfoundland", "America/St_Johns"), $ct_T2__O__O__(new $c_T2(), "Canada/Pacific", "America/Vancouver"), $ct_T2__O__O__(new $c_T2(), "Canada/Saskatchewan", "America/Regina"), $ct_T2__O__O__(new $c_T2(), "Canada/Yukon", "America/Whitehorse"), $ct_T2__O__O__(new $c_T2(), "Chile/Continental", "America/Santiago"), $ct_T2__O__O__(new $c_T2(), "Chile/EasterIsland", "Pacific/Easter"), $ct_T2__O__O__(new $c_T2(), "Cuba", "America/Havana"), $ct_T2__O__O__(new $c_T2(), "Egypt", "Africa/Cairo"), $ct_T2__O__O__(new $c_T2(), "Eire", "Europe/Dublin"), $ct_T2__O__O__(new $c_T2(), "Etc/UCT", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "Europe/Belfast", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "Europe/Tiraspol", "Europe/Chisinau"), $ct_T2__O__O__(new $c_T2(), "GB", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "GB-Eire", "Europe/London"), $ct_T2__O__O__(new $c_T2(), "GMT+0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "GMT-0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "GMT0", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Greenwich", "Etc/GMT"), $ct_T2__O__O__(new $c_T2(), "Hongkong", "Asia/Hong_Kong"), $ct_T2__O__O__(new $c_T2(), "Iceland", "Atlantic/Reykjavik"), $ct_T2__O__O__(new $c_T2(), "Iran", "Asia/Tehran"), $ct_T2__O__O__(new $c_T2(), "Israel", "Asia/Jerusalem"), $ct_T2__O__O__(new $c_T2(), "Jamaica", "America/Jamaica"), $ct_T2__O__O__(new $c_T2(), "Japan", "Asia/Tokyo"), $ct_T2__O__O__(new $c_T2(), "Kwajalein", "Pacific/Kwajalein"), $ct_T2__O__O__(new $c_T2(), "Libya", "Africa/Tripoli"), $ct_T2__O__O__(new $c_T2(), "Mexico/BajaNorte", "America/Tijuana"), $ct_T2__O__O__(new $c_T2(), "Mexico/BajaSur", "America/Mazatlan"), $ct_T2__O__O__(new $c_T2(), "Mexico/General", "America/Mexico_City"), $ct_T2__O__O__(new $c_T2(), "NZ", "Pacific/Auckland"), $ct_T2__O__O__(new $c_T2(), "NZ-CHAT", "Pacific/Chatham"), $ct_T2__O__O__(new $c_T2(), "Navajo", "America/Denver"), $ct_T2__O__O__(new $c_T2(), "PRC", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "Pacific/Johnston", "Pacific/Honolulu"), $ct_T2__O__O__(new $c_T2(), "Pacific/Ponape", "Pacific/Pohnpei"), $ct_T2__O__O__(new $c_T2(), "Pacific/Samoa", "Pacific/Pago_Pago"), $ct_T2__O__O__(new $c_T2(), "Pacific/Truk", "Pacific/Chuuk"), $ct_T2__O__O__(new $c_T2(), "Pacific/Yap", "Pacific/Chuuk"), $ct_T2__O__O__(new $c_T2(), "Poland", "Europe/Warsaw"), $ct_T2__O__O__(new $c_T2(), "Portugal", "Europe/Lisbon"), $ct_T2__O__O__(new $c_T2(), "ROC", "Asia/Taipei"), $ct_T2__O__O__(new $c_T2(), "ROK", "Asia/Seoul"), $ct_T2__O__O__(new $c_T2(), "Singapore", "Asia/Singapore"), $ct_T2__O__O__(new $c_T2(), "Turkey", "Europe/Istanbul"), $ct_T2__O__O__(new $c_T2(), "UCT", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "US/Alaska", "America/Anchorage"), $ct_T2__O__O__(new $c_T2(), "US/Aleutian", "America/Adak"), $ct_T2__O__O__(new $c_T2(), "US/Arizona", "America/Phoenix"), $ct_T2__O__O__(new $c_T2(), "US/Central", "America/Chicago"), $ct_T2__O__O__(new $c_T2(), "US/East-Indiana", "America/Indiana/Indianapolis"), $ct_T2__O__O__(new $c_T2(), "US/Eastern", "America/New_York"), $ct_T2__O__O__(new $c_T2(), "US/Hawaii", "Pacific/Honolulu"), $ct_T2__O__O__(new $c_T2(), "US/Indiana-Starke", "America/Indiana/Knox"), $ct_T2__O__O__(new $c_T2(), "US/Michigan", "America/Detroit"), $ct_T2__O__O__(new $c_T2(), "US/Mountain", "America/Denver"), $ct_T2__O__O__(new $c_T2(), "US/Pacific", "America/Los_Angeles"), $ct_T2__O__O__(new $c_T2(), "US/Samoa", "Pacific/Pago_Pago"), $ct_T2__O__O__(new $c_T2(), "UTC", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "Universal", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "W-SU", "Europe/Moscow"), $ct_T2__O__O__(new $c_T2(), "Zulu", "Etc/UTC"), $ct_T2__O__O__(new $c_T2(), "America/Cayman", "America/Panama")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Lzonedb_java_tzdb$__f_zoneLinks = this$4.from__sc_IterableOnce__sci_Map(elems);
    $thiz.Lzonedb_java_tzdb$__f_bitmap$0 = (((8 | $thiz.Lzonedb_java_tzdb$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lzonedb_java_tzdb$__f_zoneLinks
}
/** @constructor */
function $c_Lzonedb_java_tzdb$() {
  this.Lzonedb_java_tzdb$__f_fixedZones = null;
  this.Lzonedb_java_tzdb$__f_stdZones = null;
  this.Lzonedb_java_tzdb$__f_zoneLinks = null;
  this.Lzonedb_java_tzdb$__f_bitmap$0 = 0
}
$c_Lzonedb_java_tzdb$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$.prototype.constructor = $c_Lzonedb_java_tzdb$;
/** @constructor */
function $h_Lzonedb_java_tzdb$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$.prototype = $c_Lzonedb_java_tzdb$.prototype;
$c_Lzonedb_java_tzdb$.prototype.fixedZones__sjs_js_Dynamic = (function() {
  return (((((2 & this.Lzonedb_java_tzdb$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lzonedb_java_tzdb$__fixedZones$lzycompute__sjs_js_Dynamic(this) : this.Lzonedb_java_tzdb$__f_fixedZones)
});
$c_Lzonedb_java_tzdb$.prototype.stdZones__sjs_js_Dynamic = (function() {
  return (((((4 & this.Lzonedb_java_tzdb$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lzonedb_java_tzdb$__stdZones$lzycompute__sjs_js_Dynamic(this) : this.Lzonedb_java_tzdb$__f_stdZones)
});
$c_Lzonedb_java_tzdb$.prototype.zoneLinks__sci_Map = (function() {
  return (((((8 & this.Lzonedb_java_tzdb$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lzonedb_java_tzdb$__zoneLinks$lzycompute__sci_Map(this) : this.Lzonedb_java_tzdb$__f_zoneLinks)
});
var $d_Lzonedb_java_tzdb$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$: 0
}, false, "zonedb.java.tzdb$", {
  Lzonedb_java_tzdb$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$.prototype.$classData = $d_Lzonedb_java_tzdb$;
var $n_Lzonedb_java_tzdb$;
function $m_Lzonedb_java_tzdb$() {
  if ((!$n_Lzonedb_java_tzdb$)) {
    $n_Lzonedb_java_tzdb$ = new $c_Lzonedb_java_tzdb$()
  };
  return $n_Lzonedb_java_tzdb$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrcr$() {
  this.Lzonedb_java_tzdb$afrcr$__f_Africa_Accra = null;
  this.Lzonedb_java_tzdb$afrcr$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrcr$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-52)), $ct_T2__O__O__(new $c_T2(), "w", (-52)), $ct_T2__O__O__(new $c_T2(), "t", [[1918001, 0, (-52), 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1918001, 0, (-52), 0], [1920245, 0, 0, 1200], [1920366, 0, 1200, 0], [1921244, 0, 0, 1200], [1921365, 0, 1200, 0], [1922244, 0, 0, 1200], [1922365, 0, 1200, 0], [1923244, 0, 0, 1200], [1923365, 0, 1200, 0], [1924245, 0, 0, 1200], [1924366, 0, 1200, 0], [1925244, 0, 0, 1200], [1925365, 0, 1200, 0], [1926244, 0, 0, 1200], [1926365, 0, 1200, 0], [1927244, 0, 0, 1200], [1927365, 0, 1200, 0], [1928245, 0, 0, 1200], [1928366, 0, 1200, 0], [1929244, 0, 0, 1200], [1929365, 0, 1200, 0], [1930244, 0, 0, 1200], [1930365, 0, 1200, 0], [1931244, 0, 0, 1200], [1931365, 0, 1200, 0], [1932245, 0, 0, 1200], [1932366, 0, 1200, 0], [1933244, 0, 0, 1200], [1933365, 0, 1200, 0], [1934244, 0, 0, 1200], [1934365, 0, 1200, 0], [1935244, 0, 0, 1200], [1935365, 0, 1200, 0], [1936245, 0, 0, 1200], [1936366, 0, 1200, 0], [1937244, 0, 0, 1200], [1937365, 0, 1200, 0], [1938244, 0, 0, 1200], [1938365, 0, 1200, 0], [1939244, 0, 0, 1200], [1939365, 0, 1200, 0], [1940245, 0, 0, 1200], [1940366, 0, 1200, 0], [1941244, 0, 0, 1200], [1941365, 0, 1200, 0], [1942244, 0, 0, 1200], [1942365, 0, 1200, 0]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrcr$__f_Africa_Accra = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrcr$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrcr$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrcr$.prototype.constructor = $c_Lzonedb_java_tzdb$afrcr$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrcr$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrcr$.prototype = $c_Lzonedb_java_tzdb$afrcr$.prototype;
$c_Lzonedb_java_tzdb$afrcr$.prototype.Africa_Accra__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrcr$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 626")
  };
  return this.Lzonedb_java_tzdb$afrcr$__f_Africa_Accra
});
var $d_Lzonedb_java_tzdb$afrcr$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrcr$: 0
}, false, "zonedb.java.tzdb$afrcr$", {
  Lzonedb_java_tzdb$afrcr$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrcr$.prototype.$classData = $d_Lzonedb_java_tzdb$afrcr$;
var $n_Lzonedb_java_tzdb$afrcr$;
function $m_Lzonedb_java_tzdb$afrcr$() {
  if ((!$n_Lzonedb_java_tzdb$afrcr$)) {
    $n_Lzonedb_java_tzdb$afrcr$ = new $c_Lzonedb_java_tzdb$afrcr$()
  };
  return $n_Lzonedb_java_tzdb$afrcr$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afren$() {
  this.Lzonedb_java_tzdb$afren$__f_Africa_Ndjamena = null;
  this.Lzonedb_java_tzdb$afren$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afren$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 3612), $ct_T2__O__O__(new $c_T2(), "w", 3612), $ct_T2__O__O__(new $c_T2(), "t", [[1912001, 0, 3612, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912001, 0, 3612, 3600], [1979287, 0, 3600, 7200], [1980068, 0, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afren$__f_Africa_Ndjamena = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afren$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afren$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afren$.prototype.constructor = $c_Lzonedb_java_tzdb$afren$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afren$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afren$.prototype = $c_Lzonedb_java_tzdb$afren$.prototype;
$c_Lzonedb_java_tzdb$afren$.prototype.Africa_Ndjamena__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afren$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 241")
  };
  return this.Lzonedb_java_tzdb$afren$__f_Africa_Ndjamena
});
var $d_Lzonedb_java_tzdb$afren$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afren$: 0
}, false, "zonedb.java.tzdb$afren$", {
  Lzonedb_java_tzdb$afren$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afren$.prototype.$classData = $d_Lzonedb_java_tzdb$afren$;
var $n_Lzonedb_java_tzdb$afren$;
function $m_Lzonedb_java_tzdb$afren$() {
  if ((!$n_Lzonedb_java_tzdb$afren$)) {
    $n_Lzonedb_java_tzdb$afren$ = new $c_Lzonedb_java_tzdb$afren$()
  };
  return $n_Lzonedb_java_tzdb$afren$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrer$() {
  this.Lzonedb_java_tzdb$afrer$__f_Africa_Algiers = null;
  this.Lzonedb_java_tzdb$afrer$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrer$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 732), $ct_T2__O__O__(new $c_T2(), "w", 732), $ct_T2__O__O__(new $c_T2(), "t", [[1891074, 60, 732, 561], [1911070, 0, 561, 0], [1940056, 7200, 0, 3600], [1946280, 0, 3600, 0], [1956029, 0, 0, 3600], [1963104, 0, 3600, 0], [1977293, 82800, 0, 3600], [1979299, 0, 3600, 0], [1981121, 0, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1891074, 60, 732, 561], [1911070, 0, 561, 0], [1916166, 82800, 0, 3600], [1916276, 0, 3600, 0], [1917083, 82800, 0, 3600], [1917281, 0, 3600, 0], [1918068, 82800, 0, 3600], [1918280, 0, 3600, 0], [1919060, 82800, 0, 3600], [1919279, 0, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 0, 3600, 0], [1921073, 82800, 0, 3600], [1921173, 0, 3600, 0], [1939254, 82800, 0, 3600], [1939323, 3600, 3600, 0], [1940056, 7200, 0, 3600], [1944094, 7200, 3600, 7200], [1944282, 7200, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 3600, 7200, 3600], [1946280, 0, 3600, 0], [1956029, 0, 0, 3600], [1963104, 0, 3600, 0], [1971115, 82800, 0, 3600], [1971270, 0, 3600, 0], [1977126, 0, 0, 3600], [1978083, 3600, 3600, 7200], [1978265, 10800, 7200, 3600], [1979299, 0, 3600, 0], [1980116, 0, 0, 3600], [1980305, 7200, 3600, 0], [1981121, 0, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrer$__f_Africa_Algiers = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrer$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrer$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrer$.prototype.constructor = $c_Lzonedb_java_tzdb$afrer$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrer$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrer$.prototype = $c_Lzonedb_java_tzdb$afrer$.prototype;
$c_Lzonedb_java_tzdb$afrer$.prototype.Africa_Algiers__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrer$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 207")
  };
  return this.Lzonedb_java_tzdb$afrer$__f_Africa_Algiers
});
var $d_Lzonedb_java_tzdb$afrer$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrer$: 0
}, false, "zonedb.java.tzdb$afrer$", {
  Lzonedb_java_tzdb$afrer$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrer$.prototype.$classData = $d_Lzonedb_java_tzdb$afrer$;
var $n_Lzonedb_java_tzdb$afrer$;
function $m_Lzonedb_java_tzdb$afrer$() {
  if ((!$n_Lzonedb_java_tzdb$afrer$)) {
    $n_Lzonedb_java_tzdb$afrer$ = new $c_Lzonedb_java_tzdb$afrer$()
  };
  return $n_Lzonedb_java_tzdb$afrer$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrgo$() {
  this.Lzonedb_java_tzdb$afrgo$__f_Africa_Lagos = null;
  this.Lzonedb_java_tzdb$afrgo$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrgo$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 816), $ct_T2__O__O__(new $c_T2(), "w", 816), $ct_T2__O__O__(new $c_T2(), "t", [[1919244, 0, 816, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919244, 0, 816, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrgo$__f_Africa_Lagos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrgo$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrgo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrgo$.prototype.constructor = $c_Lzonedb_java_tzdb$afrgo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrgo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrgo$.prototype = $c_Lzonedb_java_tzdb$afrgo$.prototype;
$c_Lzonedb_java_tzdb$afrgo$.prototype.Africa_Lagos__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrgo$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 414")
  };
  return this.Lzonedb_java_tzdb$afrgo$__f_Africa_Lagos
});
var $d_Lzonedb_java_tzdb$afrgo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrgo$: 0
}, false, "zonedb.java.tzdb$afrgo$", {
  Lzonedb_java_tzdb$afrgo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrgo$.prototype.$classData = $d_Lzonedb_java_tzdb$afrgo$;
var $n_Lzonedb_java_tzdb$afrgo$;
function $m_Lzonedb_java_tzdb$afrgo$() {
  if ((!$n_Lzonedb_java_tzdb$afrgo$)) {
    $n_Lzonedb_java_tzdb$afrgo$ = new $c_Lzonedb_java_tzdb$afrgo$()
  };
  return $n_Lzonedb_java_tzdb$afrgo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrir$() {
  this.Lzonedb_java_tzdb$afrir$__f_Africa_Cairo = null;
  this.Lzonedb_java_tzdb$afrir$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrir$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 7509), $ct_T2__O__O__(new $c_T2(), "w", 7509), $ct_T2__O__O__(new $c_T2(), "t", [[1900274, 0, 7509, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1900274, 0, 7509, 7200], [1940197, 0, 7200, 10800], [1940275, 0, 10800, 7200], [1941105, 0, 7200, 10800], [1941259, 0, 10800, 7200], [1942091, 0, 7200, 10800], [1942300, 0, 10800, 7200], [1943091, 0, 7200, 10800], [1943305, 0, 10800, 7200], [1944092, 0, 7200, 10800], [1944306, 0, 10800, 7200], [1945106, 0, 7200, 10800], [1945305, 0, 10800, 7200], [1957130, 0, 7200, 10800], [1957274, 0, 10800, 7200], [1958121, 0, 7200, 10800], [1958274, 0, 10800, 7200], [1959121, 3600, 7200, 10800], [1959273, 10800, 10800, 7200], [1960122, 3600, 7200, 10800], [1960274, 10800, 10800, 7200], [1961121, 3600, 7200, 10800], [1961273, 10800, 10800, 7200], [1962121, 3600, 7200, 10800], [1962273, 10800, 10800, 7200], [1963121, 3600, 7200, 10800], [1963273, 10800, 10800, 7200], [1964122, 3600, 7200, 10800], [1964274, 10800, 10800, 7200], [1965121, 3600, 7200, 10800], [1965273, 10800, 10800, 7200], [1966121, 3600, 7200, 10800], [1966274, 10800, 10800, 7200], [1967121, 3600, 7200, 10800], [1967274, 10800, 10800, 7200], [1968122, 3600, 7200, 10800], [1968275, 10800, 10800, 7200], [1969121, 3600, 7200, 10800], [1969274, 10800, 10800, 7200], [1970121, 3600, 7200, 10800], [1970274, 10800, 10800, 7200], [1971121, 3600, 7200, 10800], [1971274, 10800, 10800, 7200], [1972122, 3600, 7200, 10800], [1972275, 10800, 10800, 7200], [1973121, 3600, 7200, 10800], [1973274, 10800, 10800, 7200], [1974121, 3600, 7200, 10800], [1974274, 10800, 10800, 7200], [1975121, 3600, 7200, 10800], [1975274, 10800, 10800, 7200], [1976122, 3600, 7200, 10800], [1976275, 10800, 10800, 7200], [1977121, 3600, 7200, 10800], [1977274, 10800, 10800, 7200], [1978121, 3600, 7200, 10800], [1978274, 10800, 10800, 7200], [1979121, 3600, 7200, 10800], [1979274, 10800, 10800, 7200], [1980122, 3600, 7200, 10800], [1980275, 10800, 10800, 7200], [1981121, 3600, 7200, 10800], [1981274, 10800, 10800, 7200], [1982206, 3600, 7200, 10800], [1982274, 10800, 10800, 7200], [1983193, 3600, 7200, 10800], [1983274, 10800, 10800, 7200], [1984122, 3600, 7200, 10800], [1984275, 10800, 10800, 7200], [1985121, 3600, 7200, 10800], [1985274, 10800, 10800, 7200], [1986121, 3600, 7200, 10800], [1986274, 10800, 10800, 7200], [1987121, 3600, 7200, 10800], [1987274, 10800, 10800, 7200], [1988122, 3600, 7200, 10800], [1988275, 10800, 10800, 7200], [1989126, 3600, 7200, 10800], [1989274, 10800, 10800, 7200], [1990121, 3600, 7200, 10800], [1990274, 10800, 10800, 7200], [1991121, 3600, 7200, 10800], [1991274, 10800, 10800, 7200], [1992122, 3600, 7200, 10800], [1992275, 10800, 10800, 7200], [1993121, 3600, 7200, 10800], [1993274, 10800, 10800, 7200], [1994121, 3600, 7200, 10800], [1994274, 10800, 10800, 7200], [1995118, 0, 7200, 10800], [1995272, 0, 10800, 7200], [1996117, 0, 7200, 10800], [1996271, 0, 10800, 7200], [1997115, 0, 7200, 10800], [1997269, 0, 10800, 7200], [1998114, 0, 7200, 10800], [1998268, 0, 10800, 7200], [1999120, 0, 7200, 10800], [1999274, 0, 10800, 7200], [2000119, 0, 7200, 10800], [2000273, 0, 10800, 7200], [2001117, 0, 7200, 10800], [2001271, 0, 10800, 7200], [2002116, 0, 7200, 10800], [2002270, 0, 10800, 7200], [2003115, 0, 7200, 10800], [2003269, 0, 10800, 7200], [2004121, 0, 7200, 10800], [2004275, 0, 10800, 7200], [2005119, 0, 7200, 10800], [2005273, 0, 10800, 7200], [2006118, 0, 7200, 10800], [2006265, 0, 10800, 7200], [2007117, 0, 7200, 10800], [2007250, 0, 10800, 7200], [2008116, 0, 7200, 10800], [2008242, 0, 10800, 7200], [2009114, 0, 7200, 10800], [2009233, 0, 10800, 7200], [2010120, 0, 7200, 10800], [2010223, 0, 10800, 7200], [2010253, 0, 7200, 10800], [2010274, 0, 10800, 7200], [2014136, 0, 7200, 10800], [2014178, 0, 10800, 7200], [2014213, 0, 7200, 10800], [2014269, 0, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrir$__f_Africa_Cairo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrir$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrir$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrir$.prototype.constructor = $c_Lzonedb_java_tzdb$afrir$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrir$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrir$.prototype = $c_Lzonedb_java_tzdb$afrir$.prototype;
$c_Lzonedb_java_tzdb$afrir$.prototype.Africa_Cairo__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrir$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 201")
  };
  return this.Lzonedb_java_tzdb$afrir$__f_Africa_Cairo
});
var $d_Lzonedb_java_tzdb$afrir$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrir$: 0
}, false, "zonedb.java.tzdb$afrir$", {
  Lzonedb_java_tzdb$afrir$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrir$.prototype.$classData = $d_Lzonedb_java_tzdb$afrir$;
var $n_Lzonedb_java_tzdb$afrir$;
function $m_Lzonedb_java_tzdb$afrir$() {
  if ((!$n_Lzonedb_java_tzdb$afrir$)) {
    $n_Lzonedb_java_tzdb$afrir$ = new $c_Lzonedb_java_tzdb$afrir$()
  };
  return $n_Lzonedb_java_tzdb$afrir$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afriu$() {
  this.Lzonedb_java_tzdb$afriu$__f_Africa_El_Aaiun = null;
  this.Lzonedb_java_tzdb$afriu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afriu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-3168)), $ct_T2__O__O__(new $c_T2(), "w", (-3168)), $ct_T2__O__O__(new $c_T2(), "t", [[1934001, 0, (-3168), (-3600)], [1976105, 0, (-3600), 0], [2018301, 7200, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1934001, 0, (-3168), (-3600)], [1976105, 0, (-3600), 0], [1976122, 0, 0, 3600], [1976214, 0, 3600, 0], [1977121, 0, 0, 3600], [1977271, 0, 3600, 0], [1978152, 0, 0, 3600], [1978216, 0, 3600, 0], [2008153, 0, 0, 3600], [2008245, 0, 3600, 0], [2009152, 0, 0, 3600], [2009233, 0, 3600, 0], [2010122, 0, 0, 3600], [2010220, 0, 3600, 0], [2011093, 0, 0, 3600], [2011212, 0, 3600, 0], [2012120, 7200, 0, 3600], [2012202, 10800, 3600, 0], [2012233, 7200, 0, 3600], [2012274, 10800, 3600, 0], [2013118, 7200, 0, 3600], [2013188, 10800, 3600, 0], [2013222, 7200, 0, 3600], [2013300, 10800, 3600, 0], [2014089, 7200, 0, 3600], [2014179, 10800, 3600, 0], [2014214, 7200, 0, 3600], [2014299, 10800, 3600, 0], [2015088, 7200, 0, 3600], [2015165, 10800, 3600, 0], [2015200, 7200, 0, 3600], [2015298, 10800, 3600, 0], [2016087, 7200, 0, 3600], [2016157, 10800, 3600, 0], [2016192, 7200, 0, 3600], [2016304, 10800, 3600, 0], [2017085, 7200, 0, 3600], [2017141, 10800, 3600, 0], [2017183, 7200, 0, 3600], [2017302, 10800, 3600, 0], [2018084, 7200, 0, 3600], [2018133, 10800, 3600, 0], [2018168, 7200, 0, 3600], [2019125, 10800, 3600, 0], [2019160, 7200, 0, 3600], [2020110, 10800, 3600, 0], [2020145, 7200, 0, 3600], [2021101, 10800, 3600, 0], [2021136, 7200, 0, 3600], [2022086, 10800, 3600, 0], [2022128, 7200, 0, 3600], [2023078, 10800, 3600, 0], [2023113, 7200, 0, 3600], [2024070, 10800, 3600, 0], [2024105, 7200, 0, 3600], [2025054, 10800, 3600, 0], [2025096, 7200, 0, 3600], [2026046, 10800, 3600, 0], [2026081, 7200, 0, 3600], [2027038, 10800, 3600, 0], [2027073, 7200, 0, 3600], [2028023, 10800, 3600, 0], [2028058, 7200, 0, 3600], [2029014, 10800, 3600, 0], [2029049, 7200, 0, 3600], [2029364, 10800, 3600, 0], [2030041, 7200, 0, 3600], [2030356, 10800, 3600, 0], [2031026, 7200, 0, 3600], [2031348, 10800, 3600, 0], [2032018, 7200, 0, 3600], [2032333, 10800, 3600, 0], [2033009, 7200, 0, 3600], [2033324, 10800, 3600, 0], [2033359, 7200, 0, 3600], [2034309, 10800, 3600, 0], [2034351, 7200, 0, 3600], [2035301, 10800, 3600, 0], [2035336, 7200, 0, 3600], [2036293, 10800, 3600, 0], [2036328, 7200, 0, 3600], [2037277, 10800, 3600, 0], [2037319, 7200, 0, 3600], [2038269, 10800, 3600, 0], [2038304, 7200, 0, 3600], [2039261, 10800, 3600, 0], [2039296, 7200, 0, 3600], [2040246, 10800, 3600, 0], [2040288, 7200, 0, 3600], [2041237, 10800, 3600, 0], [2041272, 7200, 0, 3600], [2042222, 10800, 3600, 0], [2042264, 7200, 0, 3600], [2043214, 10800, 3600, 0], [2043249, 7200, 0, 3600], [2044206, 10800, 3600, 0], [2044241, 7200, 0, 3600], [2045190, 10800, 3600, 0], [2045232, 7200, 0, 3600], [2046182, 10800, 3600, 0], [2046217, 7200, 0, 3600], [2047174, 10800, 3600, 0], [2047209, 7200, 0, 3600], [2048159, 10800, 3600, 0], [2048201, 7200, 0, 3600], [2049150, 10800, 3600, 0], [2049185, 7200, 0, 3600], [2050135, 10800, 3600, 0], [2050177, 7200, 0, 3600], [2051127, 10800, 3600, 0], [2051162, 7200, 0, 3600], [2052119, 10800, 3600, 0], [2052154, 7200, 0, 3600], [2053103, 10800, 3600, 0], [2053145, 7200, 0, 3600], [2054095, 10800, 3600, 0], [2054130, 7200, 0, 3600], [2055087, 10800, 3600, 0], [2055122, 7200, 0, 3600], [2056072, 10800, 3600, 0], [2056114, 7200, 0, 3600], [2057063, 10800, 3600, 0], [2057098, 7200, 0, 3600], [2058048, 10800, 3600, 0], [2058090, 7200, 0, 3600], [2059040, 10800, 3600, 0], [2059075, 7200, 0, 3600], [2060032, 10800, 3600, 0], [2060067, 7200, 0, 3600], [2061016, 10800, 3600, 0], [2061058, 7200, 0, 3600], [2062008, 10800, 3600, 0], [2062043, 7200, 0, 3600], [2062365, 10800, 3600, 0], [2063035, 7200, 0, 3600], [2063350, 10800, 3600, 0], [2064020, 7200, 0, 3600], [2064342, 10800, 3600, 0], [2065011, 7200, 0, 3600], [2065326, 10800, 3600, 0], [2066003, 7200, 0, 3600], [2066318, 10800, 3600, 0], [2066353, 7200, 0, 3600], [2067310, 10800, 3600, 0], [2067345, 7200, 0, 3600], [2068295, 10800, 3600, 0], [2068337, 7200, 0, 3600], [2069286, 10800, 3600, 0], [2069321, 7200, 0, 3600], [2070278, 10800, 3600, 0], [2070313, 7200, 0, 3600], [2071263, 10800, 3600, 0], [2071298, 7200, 0, 3600], [2072255, 10800, 3600, 0], [2072290, 7200, 0, 3600], [2073239, 10800, 3600, 0], [2073281, 7200, 0, 3600], [2074231, 10800, 3600, 0], [2074266, 7200, 0, 3600], [2075223, 10800, 3600, 0], [2075258, 7200, 0, 3600], [2076208, 10800, 3600, 0], [2076250, 7200, 0, 3600], [2077199, 10800, 3600, 0], [2077234, 7200, 0, 3600], [2078191, 10800, 3600, 0], [2078226, 7200, 0, 3600], [2079176, 10800, 3600, 0], [2079211, 7200, 0, 3600], [2080168, 10800, 3600, 0], [2080203, 7200, 0, 3600], [2081152, 10800, 3600, 0], [2081194, 7200, 0, 3600], [2082144, 10800, 3600, 0], [2082179, 7200, 0, 3600], [2083136, 10800, 3600, 0], [2083171, 7200, 0, 3600], [2084121, 10800, 3600, 0], [2084163, 7200, 0, 3600], [2085112, 10800, 3600, 0], [2085147, 7200, 0, 3600], [2086104, 10800, 3600, 0], [2086139, 7200, 0, 3600], [2087089, 10800, 3600, 0], [2087124, 7200, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afriu$__f_Africa_El_Aaiun = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afriu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afriu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afriu$.prototype.constructor = $c_Lzonedb_java_tzdb$afriu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afriu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afriu$.prototype = $c_Lzonedb_java_tzdb$afriu$.prototype;
$c_Lzonedb_java_tzdb$afriu$.prototype.Africa_El_Aaiun__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afriu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 836")
  };
  return this.Lzonedb_java_tzdb$afriu$__f_Africa_El_Aaiun
});
var $d_Lzonedb_java_tzdb$afriu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afriu$: 0
}, false, "zonedb.java.tzdb$afriu$", {
  Lzonedb_java_tzdb$afriu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afriu$.prototype.$classData = $d_Lzonedb_java_tzdb$afriu$;
var $n_Lzonedb_java_tzdb$afriu$;
function $m_Lzonedb_java_tzdb$afriu$() {
  if ((!$n_Lzonedb_java_tzdb$afriu$)) {
    $n_Lzonedb_java_tzdb$afriu$ = new $c_Lzonedb_java_tzdb$afriu$()
  };
  return $n_Lzonedb_java_tzdb$afriu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrja$() {
  this.Lzonedb_java_tzdb$afrja$__f_Africa_Abidjan = null;
  this.Lzonedb_java_tzdb$afrja$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrja$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-968)), $ct_T2__O__O__(new $c_T2(), "w", (-968)), $ct_T2__O__O__(new $c_T2(), "t", [[1912001, 0, (-968), 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912001, 0, (-968), 0]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrja$__f_Africa_Abidjan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrja$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrja$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrja$.prototype.constructor = $c_Lzonedb_java_tzdb$afrja$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrja$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrja$.prototype = $c_Lzonedb_java_tzdb$afrja$.prototype;
$c_Lzonedb_java_tzdb$afrja$.prototype.Africa_Abidjan__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrja$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 271")
  };
  return this.Lzonedb_java_tzdb$afrja$__f_Africa_Abidjan
});
var $d_Lzonedb_java_tzdb$afrja$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrja$: 0
}, false, "zonedb.java.tzdb$afrja$", {
  Lzonedb_java_tzdb$afrja$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrja$.prototype.$classData = $d_Lzonedb_java_tzdb$afrja$;
var $n_Lzonedb_java_tzdb$afrja$;
function $m_Lzonedb_java_tzdb$afrja$() {
  if ((!$n_Lzonedb_java_tzdb$afrja$)) {
    $n_Lzonedb_java_tzdb$afrja$ = new $c_Lzonedb_java_tzdb$afrja$()
  };
  return $n_Lzonedb_java_tzdb$afrja$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrnc$() {
  this.Lzonedb_java_tzdb$afrnc$__f_Africa_Casablanca = null;
  this.Lzonedb_java_tzdb$afrnc$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrnc$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-1820)), $ct_T2__O__O__(new $c_T2(), "w", (-1820)), $ct_T2__O__O__(new $c_T2(), "t", [[1913299, 0, (-1820), 0], [1984076, 0, 0, 3600], [1986001, 0, 3600, 0], [2018301, 7200, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1913299, 0, (-1820), 0], [1939255, 0, 0, 3600], [1939323, 0, 3600, 0], [1940056, 0, 0, 3600], [1945322, 0, 3600, 0], [1950162, 0, 0, 3600], [1950302, 0, 3600, 0], [1967154, 43200, 0, 3600], [1967274, 0, 3600, 0], [1974175, 0, 0, 3600], [1974244, 0, 3600, 0], [1976122, 0, 0, 3600], [1976214, 0, 3600, 0], [1977121, 0, 0, 3600], [1977271, 0, 3600, 0], [1978152, 0, 0, 3600], [1978216, 0, 3600, 0], [1984076, 0, 0, 3600], [1986001, 0, 3600, 0], [2008153, 0, 0, 3600], [2008245, 0, 3600, 0], [2009152, 0, 0, 3600], [2009233, 0, 3600, 0], [2010122, 0, 0, 3600], [2010220, 0, 3600, 0], [2011093, 0, 0, 3600], [2011212, 0, 3600, 0], [2012120, 7200, 0, 3600], [2012202, 10800, 3600, 0], [2012233, 7200, 0, 3600], [2012274, 10800, 3600, 0], [2013118, 7200, 0, 3600], [2013188, 10800, 3600, 0], [2013222, 7200, 0, 3600], [2013300, 10800, 3600, 0], [2014089, 7200, 0, 3600], [2014179, 10800, 3600, 0], [2014214, 7200, 0, 3600], [2014299, 10800, 3600, 0], [2015088, 7200, 0, 3600], [2015165, 10800, 3600, 0], [2015200, 7200, 0, 3600], [2015298, 10800, 3600, 0], [2016087, 7200, 0, 3600], [2016157, 10800, 3600, 0], [2016192, 7200, 0, 3600], [2016304, 10800, 3600, 0], [2017085, 7200, 0, 3600], [2017141, 10800, 3600, 0], [2017183, 7200, 0, 3600], [2017302, 10800, 3600, 0], [2018084, 7200, 0, 3600], [2018133, 10800, 3600, 0], [2018168, 7200, 0, 3600], [2019125, 10800, 3600, 0], [2019160, 7200, 0, 3600], [2020110, 10800, 3600, 0], [2020145, 7200, 0, 3600], [2021101, 10800, 3600, 0], [2021136, 7200, 0, 3600], [2022086, 10800, 3600, 0], [2022128, 7200, 0, 3600], [2023078, 10800, 3600, 0], [2023113, 7200, 0, 3600], [2024070, 10800, 3600, 0], [2024105, 7200, 0, 3600], [2025054, 10800, 3600, 0], [2025096, 7200, 0, 3600], [2026046, 10800, 3600, 0], [2026081, 7200, 0, 3600], [2027038, 10800, 3600, 0], [2027073, 7200, 0, 3600], [2028023, 10800, 3600, 0], [2028058, 7200, 0, 3600], [2029014, 10800, 3600, 0], [2029049, 7200, 0, 3600], [2029364, 10800, 3600, 0], [2030041, 7200, 0, 3600], [2030356, 10800, 3600, 0], [2031026, 7200, 0, 3600], [2031348, 10800, 3600, 0], [2032018, 7200, 0, 3600], [2032333, 10800, 3600, 0], [2033009, 7200, 0, 3600], [2033324, 10800, 3600, 0], [2033359, 7200, 0, 3600], [2034309, 10800, 3600, 0], [2034351, 7200, 0, 3600], [2035301, 10800, 3600, 0], [2035336, 7200, 0, 3600], [2036293, 10800, 3600, 0], [2036328, 7200, 0, 3600], [2037277, 10800, 3600, 0], [2037319, 7200, 0, 3600], [2038269, 10800, 3600, 0], [2038304, 7200, 0, 3600], [2039261, 10800, 3600, 0], [2039296, 7200, 0, 3600], [2040246, 10800, 3600, 0], [2040288, 7200, 0, 3600], [2041237, 10800, 3600, 0], [2041272, 7200, 0, 3600], [2042222, 10800, 3600, 0], [2042264, 7200, 0, 3600], [2043214, 10800, 3600, 0], [2043249, 7200, 0, 3600], [2044206, 10800, 3600, 0], [2044241, 7200, 0, 3600], [2045190, 10800, 3600, 0], [2045232, 7200, 0, 3600], [2046182, 10800, 3600, 0], [2046217, 7200, 0, 3600], [2047174, 10800, 3600, 0], [2047209, 7200, 0, 3600], [2048159, 10800, 3600, 0], [2048201, 7200, 0, 3600], [2049150, 10800, 3600, 0], [2049185, 7200, 0, 3600], [2050135, 10800, 3600, 0], [2050177, 7200, 0, 3600], [2051127, 10800, 3600, 0], [2051162, 7200, 0, 3600], [2052119, 10800, 3600, 0], [2052154, 7200, 0, 3600], [2053103, 10800, 3600, 0], [2053145, 7200, 0, 3600], [2054095, 10800, 3600, 0], [2054130, 7200, 0, 3600], [2055087, 10800, 3600, 0], [2055122, 7200, 0, 3600], [2056072, 10800, 3600, 0], [2056114, 7200, 0, 3600], [2057063, 10800, 3600, 0], [2057098, 7200, 0, 3600], [2058048, 10800, 3600, 0], [2058090, 7200, 0, 3600], [2059040, 10800, 3600, 0], [2059075, 7200, 0, 3600], [2060032, 10800, 3600, 0], [2060067, 7200, 0, 3600], [2061016, 10800, 3600, 0], [2061058, 7200, 0, 3600], [2062008, 10800, 3600, 0], [2062043, 7200, 0, 3600], [2062365, 10800, 3600, 0], [2063035, 7200, 0, 3600], [2063350, 10800, 3600, 0], [2064020, 7200, 0, 3600], [2064342, 10800, 3600, 0], [2065011, 7200, 0, 3600], [2065326, 10800, 3600, 0], [2066003, 7200, 0, 3600], [2066318, 10800, 3600, 0], [2066353, 7200, 0, 3600], [2067310, 10800, 3600, 0], [2067345, 7200, 0, 3600], [2068295, 10800, 3600, 0], [2068337, 7200, 0, 3600], [2069286, 10800, 3600, 0], [2069321, 7200, 0, 3600], [2070278, 10800, 3600, 0], [2070313, 7200, 0, 3600], [2071263, 10800, 3600, 0], [2071298, 7200, 0, 3600], [2072255, 10800, 3600, 0], [2072290, 7200, 0, 3600], [2073239, 10800, 3600, 0], [2073281, 7200, 0, 3600], [2074231, 10800, 3600, 0], [2074266, 7200, 0, 3600], [2075223, 10800, 3600, 0], [2075258, 7200, 0, 3600], [2076208, 10800, 3600, 0], [2076250, 7200, 0, 3600], [2077199, 10800, 3600, 0], [2077234, 7200, 0, 3600], [2078191, 10800, 3600, 0], [2078226, 7200, 0, 3600], [2079176, 10800, 3600, 0], [2079211, 7200, 0, 3600], [2080168, 10800, 3600, 0], [2080203, 7200, 0, 3600], [2081152, 10800, 3600, 0], [2081194, 7200, 0, 3600], [2082144, 10800, 3600, 0], [2082179, 7200, 0, 3600], [2083136, 10800, 3600, 0], [2083171, 7200, 0, 3600], [2084121, 10800, 3600, 0], [2084163, 7200, 0, 3600], [2085112, 10800, 3600, 0], [2085147, 7200, 0, 3600], [2086104, 10800, 3600, 0], [2086139, 7200, 0, 3600], [2087089, 10800, 3600, 0], [2087124, 7200, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrnc$__f_Africa_Casablanca = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrnc$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrnc$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrnc$.prototype.constructor = $c_Lzonedb_java_tzdb$afrnc$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrnc$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrnc$.prototype = $c_Lzonedb_java_tzdb$afrnc$.prototype;
$c_Lzonedb_java_tzdb$afrnc$.prototype.Africa_Casablanca__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrnc$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 914")
  };
  return this.Lzonedb_java_tzdb$afrnc$__f_Africa_Casablanca
});
var $d_Lzonedb_java_tzdb$afrnc$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrnc$: 0
}, false, "zonedb.java.tzdb$afrnc$", {
  Lzonedb_java_tzdb$afrnc$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrnc$.prototype.$classData = $d_Lzonedb_java_tzdb$afrnc$;
var $n_Lzonedb_java_tzdb$afrnc$;
function $m_Lzonedb_java_tzdb$afrnc$() {
  if ((!$n_Lzonedb_java_tzdb$afrnc$)) {
    $n_Lzonedb_java_tzdb$afrnc$ = new $c_Lzonedb_java_tzdb$afrnc$()
  };
  return $n_Lzonedb_java_tzdb$afrnc$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrni$() {
  this.Lzonedb_java_tzdb$afrni$__f_Africa_Tunis = null;
  this.Lzonedb_java_tzdb$afrni$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrni$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 2444), $ct_T2__O__O__(new $c_T2(), "w", 2444), $ct_T2__O__O__(new $c_T2(), "t", [[1881132, 0, 2444, 561], [1911070, 0, 561, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1881132, 0, 2444, 561], [1911070, 0, 561, 3600], [1939105, 82800, 3600, 7200], [1939323, 0, 7200, 3600], [1940056, 82800, 3600, 7200], [1941279, 0, 7200, 3600], [1942068, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943107, 7200, 7200, 3600], [1943115, 7200, 3600, 7200], [1943277, 7200, 7200, 3600], [1944094, 7200, 3600, 7200], [1944282, 0, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 0, 7200, 3600], [1977120, 0, 3600, 7200], [1977267, 3600, 7200, 3600], [1978121, 0, 3600, 7200], [1978274, 3600, 7200, 3600], [1988153, 0, 3600, 7200], [1988269, 3600, 7200, 3600], [1989085, 0, 3600, 7200], [1989267, 3600, 7200, 3600], [1990121, 0, 3600, 7200], [1990273, 3600, 7200, 3600], [2005121, 0, 3600, 7200], [2005273, 7200, 7200, 3600], [2006085, 7200, 3600, 7200], [2006302, 10800, 7200, 3600], [2007084, 7200, 3600, 7200], [2007301, 10800, 7200, 3600], [2008090, 7200, 3600, 7200], [2008300, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrni$__f_Africa_Tunis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrni$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrni$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrni$.prototype.constructor = $c_Lzonedb_java_tzdb$afrni$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrni$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrni$.prototype = $c_Lzonedb_java_tzdb$afrni$.prototype;
$c_Lzonedb_java_tzdb$afrni$.prototype.Africa_Tunis__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrni$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 638")
  };
  return this.Lzonedb_java_tzdb$afrni$__f_Africa_Tunis
});
var $d_Lzonedb_java_tzdb$afrni$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrni$: 0
}, false, "zonedb.java.tzdb$afrni$", {
  Lzonedb_java_tzdb$afrni$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrni$.prototype.$classData = $d_Lzonedb_java_tzdb$afrni$;
var $n_Lzonedb_java_tzdb$afrni$;
function $m_Lzonedb_java_tzdb$afrni$() {
  if ((!$n_Lzonedb_java_tzdb$afrni$)) {
    $n_Lzonedb_java_tzdb$afrni$ = new $c_Lzonedb_java_tzdb$afrni$()
  };
  return $n_Lzonedb_java_tzdb$afrni$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrob$() {
  this.Lzonedb_java_tzdb$afrob$__f_Africa_Nairobi = null;
  this.Lzonedb_java_tzdb$afrob$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrob$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8836), $ct_T2__O__O__(new $c_T2(), "w", 8836), $ct_T2__O__O__(new $c_T2(), "t", [[1928183, 0, 8836, 10800], [1930001, 0, 10800, 9000], [1940001, 0, 9000, 9900], [1960001, 0, 9900, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1928183, 0, 8836, 10800], [1930001, 0, 10800, 9000], [1940001, 0, 9000, 9900], [1960001, 0, 9900, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrob$__f_Africa_Nairobi = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrob$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrob$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrob$.prototype.constructor = $c_Lzonedb_java_tzdb$afrob$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrob$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrob$.prototype = $c_Lzonedb_java_tzdb$afrob$.prototype;
$c_Lzonedb_java_tzdb$afrob$.prototype.Africa_Nairobi__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrob$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 378")
  };
  return this.Lzonedb_java_tzdb$afrob$__f_Africa_Nairobi
});
var $d_Lzonedb_java_tzdb$afrob$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrob$: 0
}, false, "zonedb.java.tzdb$afrob$", {
  Lzonedb_java_tzdb$afrob$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrob$.prototype.$classData = $d_Lzonedb_java_tzdb$afrob$;
var $n_Lzonedb_java_tzdb$afrob$;
function $m_Lzonedb_java_tzdb$afrob$() {
  if ((!$n_Lzonedb_java_tzdb$afrob$)) {
    $n_Lzonedb_java_tzdb$afrob$ = new $c_Lzonedb_java_tzdb$afrob$()
  };
  return $n_Lzonedb_java_tzdb$afrob$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afroe$() {
  this.Lzonedb_java_tzdb$afroe$__f_Africa_Windhoek = null;
  this.Lzonedb_java_tzdb$afroe$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afroe$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 4104), $ct_T2__O__O__(new $c_T2(), "w", 4104), $ct_T2__O__O__(new $c_T2(), "t", [[1892039, 0, 4104, 5400], [1903060, 0, 5400, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1892039, 0, 4104, 5400], [1903060, 0, 5400, 7200], [1942263, 7200, 7200, 10800], [1943080, 7200, 10800, 7200], [1994080, 0, 7200, 3600], [1994247, 7200, 3600, 7200], [1995092, 7200, 7200, 3600], [1995246, 7200, 3600, 7200], [1996098, 7200, 7200, 3600], [1996245, 7200, 3600, 7200], [1997096, 7200, 7200, 3600], [1997250, 7200, 3600, 7200], [1998095, 7200, 7200, 3600], [1998249, 7200, 3600, 7200], [1999094, 7200, 7200, 3600], [1999248, 7200, 3600, 7200], [2000093, 7200, 7200, 3600], [2000247, 7200, 3600, 7200], [2001091, 7200, 7200, 3600], [2001245, 7200, 3600, 7200], [2002097, 7200, 7200, 3600], [2002244, 7200, 3600, 7200], [2003096, 7200, 7200, 3600], [2003250, 7200, 3600, 7200], [2004095, 7200, 7200, 3600], [2004249, 7200, 3600, 7200], [2005093, 7200, 7200, 3600], [2005247, 7200, 3600, 7200], [2006092, 7200, 7200, 3600], [2006246, 7200, 3600, 7200], [2007091, 7200, 7200, 3600], [2007245, 7200, 3600, 7200], [2008097, 7200, 7200, 3600], [2008251, 7200, 3600, 7200], [2009095, 7200, 7200, 3600], [2009249, 7200, 3600, 7200], [2010094, 7200, 7200, 3600], [2010248, 7200, 3600, 7200], [2011093, 7200, 7200, 3600], [2011247, 7200, 3600, 7200], [2012092, 7200, 7200, 3600], [2012246, 7200, 3600, 7200], [2013097, 7200, 7200, 3600], [2013244, 7200, 3600, 7200], [2014096, 7200, 7200, 3600], [2014250, 7200, 3600, 7200], [2015095, 7200, 7200, 3600], [2015249, 7200, 3600, 7200], [2016094, 7200, 7200, 3600], [2016248, 7200, 3600, 7200], [2017092, 7200, 7200, 3600], [2017246, 7200, 3600, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afroe$__f_Africa_Windhoek = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afroe$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afroe$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afroe$.prototype.constructor = $c_Lzonedb_java_tzdb$afroe$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afroe$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afroe$.prototype = $c_Lzonedb_java_tzdb$afroe$.prototype;
$c_Lzonedb_java_tzdb$afroe$.prototype.Africa_Windhoek__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afroe$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 113")
  };
  return this.Lzonedb_java_tzdb$afroe$__f_Africa_Windhoek
});
var $d_Lzonedb_java_tzdb$afroe$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afroe$: 0
}, false, "zonedb.java.tzdb$afroe$", {
  Lzonedb_java_tzdb$afroe$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afroe$.prototype.$classData = $d_Lzonedb_java_tzdb$afroe$;
var $n_Lzonedb_java_tzdb$afroe$;
function $m_Lzonedb_java_tzdb$afroe$() {
  if ((!$n_Lzonedb_java_tzdb$afroe$)) {
    $n_Lzonedb_java_tzdb$afroe$ = new $c_Lzonedb_java_tzdb$afroe$()
  };
  return $n_Lzonedb_java_tzdb$afroe$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrol$() {
  this.Lzonedb_java_tzdb$afrol$__f_Africa_Tripoli = null;
  this.Lzonedb_java_tzdb$afrol$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrol$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 3164), $ct_T2__O__O__(new $c_T2(), "w", 3164), $ct_T2__O__O__(new $c_T2(), "t", [[1920001, 0, 3164, 3600], [1959001, 0, 3600, 7200], [1982001, 0, 7200, 3600], [1990124, 0, 3600, 7200], [1996274, 0, 7200, 3600], [1997276, 82800, 3600, 7200], [2012315, 7200, 7200, 3600], [2013298, 3600, 3600, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920001, 0, 3164, 3600], [1951287, 7200, 3600, 7200], [1952001, 0, 7200, 3600], [1953282, 7200, 3600, 7200], [1954001, 0, 7200, 3600], [1955273, 0, 3600, 7200], [1956001, 0, 7200, 3600], [1959001, 0, 3600, 7200], [1982001, 0, 7200, 3600], [1982091, 0, 3600, 7200], [1982274, 0, 7200, 3600], [1983091, 0, 3600, 7200], [1983274, 0, 7200, 3600], [1984092, 0, 3600, 7200], [1984275, 0, 7200, 3600], [1985096, 0, 3600, 7200], [1985274, 0, 7200, 3600], [1986094, 0, 3600, 7200], [1986276, 0, 7200, 3600], [1987091, 0, 3600, 7200], [1987274, 0, 7200, 3600], [1988092, 0, 3600, 7200], [1988275, 0, 7200, 3600], [1989091, 0, 3600, 7200], [1989274, 0, 7200, 3600], [1990124, 0, 3600, 7200], [1996274, 0, 7200, 3600], [1997094, 0, 3600, 7200], [2012315, 7200, 7200, 3600], [2013088, 3600, 3600, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrol$__f_Africa_Tripoli = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrol$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrol$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrol$.prototype.constructor = $c_Lzonedb_java_tzdb$afrol$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrol$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrol$.prototype = $c_Lzonedb_java_tzdb$afrol$.prototype;
$c_Lzonedb_java_tzdb$afrol$.prototype.Africa_Tripoli__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrol$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 611")
  };
  return this.Lzonedb_java_tzdb$afrol$__f_Africa_Tripoli
});
var $d_Lzonedb_java_tzdb$afrol$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrol$: 0
}, false, "zonedb.java.tzdb$afrol$", {
  Lzonedb_java_tzdb$afrol$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrol$.prototype.$classData = $d_Lzonedb_java_tzdb$afrol$;
var $n_Lzonedb_java_tzdb$afrol$;
function $m_Lzonedb_java_tzdb$afrol$() {
  if ((!$n_Lzonedb_java_tzdb$afrol$)) {
    $n_Lzonedb_java_tzdb$afrol$ = new $c_Lzonedb_java_tzdb$afrol$()
  };
  return $n_Lzonedb_java_tzdb$afrol$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrom$() {
  this.Lzonedb_java_tzdb$afrom$__f_Africa_Sao_Tome = null;
  this.Lzonedb_java_tzdb$afrom$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrom$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 1616), $ct_T2__O__O__(new $c_T2(), "w", 1616), $ct_T2__O__O__(new $c_T2(), "t", [[1884001, 0, 1616, (-2205)], [1911365, 84195, (-2205), 0], [2018001, 3600, 0, 3600], [2019001, 7200, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1884001, 0, 1616, (-2205)], [1911365, 84195, (-2205), 0], [2018001, 3600, 0, 3600], [2019001, 7200, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrom$__f_Africa_Sao_Tome = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrom$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrom$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrom$.prototype.constructor = $c_Lzonedb_java_tzdb$afrom$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrom$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrom$.prototype = $c_Lzonedb_java_tzdb$afrom$.prototype;
$c_Lzonedb_java_tzdb$afrom$.prototype.Africa_Sao_Tome__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrom$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 247")
  };
  return this.Lzonedb_java_tzdb$afrom$__f_Africa_Sao_Tome
});
var $d_Lzonedb_java_tzdb$afrom$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrom$: 0
}, false, "zonedb.java.tzdb$afrom$", {
  Lzonedb_java_tzdb$afrom$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrom$.prototype.$classData = $d_Lzonedb_java_tzdb$afrom$;
var $n_Lzonedb_java_tzdb$afrom$;
function $m_Lzonedb_java_tzdb$afrom$() {
  if ((!$n_Lzonedb_java_tzdb$afrom$)) {
    $n_Lzonedb_java_tzdb$afrom$ = new $c_Lzonedb_java_tzdb$afrom$()
  };
  return $n_Lzonedb_java_tzdb$afrom$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrou$() {
  this.Lzonedb_java_tzdb$afrou$__f_Africa_Khartoum = null;
  this.Lzonedb_java_tzdb$afrou$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrou$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 7808), $ct_T2__O__O__(new $c_T2(), "w", 7808), $ct_T2__O__O__(new $c_T2(), "t", [[1931001, 0, 7808, 7200], [2000015, 43200, 7200, 10800], [2017305, 0, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1931001, 0, 7808, 7200], [1970121, 0, 7200, 10800], [1970288, 0, 10800, 7200], [1971120, 0, 7200, 10800], [1971288, 0, 10800, 7200], [1972121, 0, 7200, 10800], [1972289, 0, 10800, 7200], [1973119, 0, 7200, 10800], [1973288, 0, 10800, 7200], [1974118, 0, 7200, 10800], [1974288, 0, 10800, 7200], [1975117, 0, 7200, 10800], [1975288, 0, 10800, 7200], [1976116, 0, 7200, 10800], [1976289, 0, 10800, 7200], [1977114, 0, 7200, 10800], [1977288, 0, 10800, 7200], [1978120, 0, 7200, 10800], [1978288, 0, 10800, 7200], [1979119, 0, 7200, 10800], [1979288, 0, 10800, 7200], [1980118, 0, 7200, 10800], [1980289, 0, 10800, 7200], [1981116, 0, 7200, 10800], [1981288, 0, 10800, 7200], [1982115, 0, 7200, 10800], [1982288, 0, 10800, 7200], [1983114, 0, 7200, 10800], [1983288, 0, 10800, 7200], [1984120, 0, 7200, 10800], [1984289, 0, 10800, 7200], [1985118, 0, 7200, 10800], [1985288, 0, 10800, 7200], [2000015, 43200, 7200, 10800], [2017305, 0, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrou$__f_Africa_Khartoum = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrou$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrou$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrou$.prototype.constructor = $c_Lzonedb_java_tzdb$afrou$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrou$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrou$.prototype = $c_Lzonedb_java_tzdb$afrou$.prototype;
$c_Lzonedb_java_tzdb$afrou$.prototype.Africa_Khartoum__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrou$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 826")
  };
  return this.Lzonedb_java_tzdb$afrou$__f_Africa_Khartoum
});
var $d_Lzonedb_java_tzdb$afrou$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrou$: 0
}, false, "zonedb.java.tzdb$afrou$", {
  Lzonedb_java_tzdb$afrou$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrou$.prototype.$classData = $d_Lzonedb_java_tzdb$afrou$;
var $n_Lzonedb_java_tzdb$afrou$;
function $m_Lzonedb_java_tzdb$afrou$() {
  if ((!$n_Lzonedb_java_tzdb$afrou$)) {
    $n_Lzonedb_java_tzdb$afrou$ = new $c_Lzonedb_java_tzdb$afrou$()
  };
  return $n_Lzonedb_java_tzdb$afrou$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrsa$() {
  this.Lzonedb_java_tzdb$afrsa$__f_Africa_Bissau = null;
  this.Lzonedb_java_tzdb$afrsa$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrsa$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-3740)), $ct_T2__O__O__(new $c_T2(), "w", (-3740)), $ct_T2__O__O__(new $c_T2(), "t", [[1911365, 86260, (-3740), (-3600)], [1975001, 0, (-3600), 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1911365, 86260, (-3740), (-3600)], [1975001, 0, (-3600), 0]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrsa$__f_Africa_Bissau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrsa$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrsa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrsa$.prototype.constructor = $c_Lzonedb_java_tzdb$afrsa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrsa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrsa$.prototype = $c_Lzonedb_java_tzdb$afrsa$.prototype;
$c_Lzonedb_java_tzdb$afrsa$.prototype.Africa_Bissau__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrsa$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 524")
  };
  return this.Lzonedb_java_tzdb$afrsa$__f_Africa_Bissau
});
var $d_Lzonedb_java_tzdb$afrsa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrsa$: 0
}, false, "zonedb.java.tzdb$afrsa$", {
  Lzonedb_java_tzdb$afrsa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrsa$.prototype.$classData = $d_Lzonedb_java_tzdb$afrsa$;
var $n_Lzonedb_java_tzdb$afrsa$;
function $m_Lzonedb_java_tzdb$afrsa$() {
  if ((!$n_Lzonedb_java_tzdb$afrsa$)) {
    $n_Lzonedb_java_tzdb$afrsa$ = new $c_Lzonedb_java_tzdb$afrsa$()
  };
  return $n_Lzonedb_java_tzdb$afrsa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrub$() {
  this.Lzonedb_java_tzdb$afrub$__f_Africa_Juba = null;
  this.Lzonedb_java_tzdb$afrub$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrub$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 7588), $ct_T2__O__O__(new $c_T2(), "w", 7588), $ct_T2__O__O__(new $c_T2(), "t", [[1931001, 0, 7588, 7200], [2000015, 43200, 7200, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1931001, 0, 7588, 7200], [1970121, 0, 7200, 10800], [1970288, 0, 10800, 7200], [1971120, 0, 7200, 10800], [1971288, 0, 10800, 7200], [1972121, 0, 7200, 10800], [1972289, 0, 10800, 7200], [1973119, 0, 7200, 10800], [1973288, 0, 10800, 7200], [1974118, 0, 7200, 10800], [1974288, 0, 10800, 7200], [1975117, 0, 7200, 10800], [1975288, 0, 10800, 7200], [1976116, 0, 7200, 10800], [1976289, 0, 10800, 7200], [1977114, 0, 7200, 10800], [1977288, 0, 10800, 7200], [1978120, 0, 7200, 10800], [1978288, 0, 10800, 7200], [1979119, 0, 7200, 10800], [1979288, 0, 10800, 7200], [1980118, 0, 7200, 10800], [1980289, 0, 10800, 7200], [1981116, 0, 7200, 10800], [1981288, 0, 10800, 7200], [1982115, 0, 7200, 10800], [1982288, 0, 10800, 7200], [1983114, 0, 7200, 10800], [1983288, 0, 10800, 7200], [1984120, 0, 7200, 10800], [1984289, 0, 10800, 7200], [1985118, 0, 7200, 10800], [1985288, 0, 10800, 7200], [2000015, 43200, 7200, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrub$__f_Africa_Juba = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrub$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrub$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrub$.prototype.constructor = $c_Lzonedb_java_tzdb$afrub$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrub$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrub$.prototype = $c_Lzonedb_java_tzdb$afrub$.prototype;
$c_Lzonedb_java_tzdb$afrub$.prototype.Africa_Juba__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrub$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 407")
  };
  return this.Lzonedb_java_tzdb$afrub$__f_Africa_Juba
});
var $d_Lzonedb_java_tzdb$afrub$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrub$: 0
}, false, "zonedb.java.tzdb$afrub$", {
  Lzonedb_java_tzdb$afrub$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrub$.prototype.$classData = $d_Lzonedb_java_tzdb$afrub$;
var $n_Lzonedb_java_tzdb$afrub$;
function $m_Lzonedb_java_tzdb$afrub$() {
  if ((!$n_Lzonedb_java_tzdb$afrub$)) {
    $n_Lzonedb_java_tzdb$afrub$ = new $c_Lzonedb_java_tzdb$afrub$()
  };
  return $n_Lzonedb_java_tzdb$afrub$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrur$() {
  this.Lzonedb_java_tzdb$afrur$__f_Africa_Johannesburg = null;
  this.Lzonedb_java_tzdb$afrur$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrur$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 6720), $ct_T2__O__O__(new $c_T2(), "w", 6720), $ct_T2__O__O__(new $c_T2(), "t", [[1892039, 0, 6720, 5400], [1903060, 0, 5400, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1892039, 0, 6720, 5400], [1903060, 0, 5400, 7200], [1942263, 7200, 7200, 10800], [1943080, 7200, 10800, 7200], [1943262, 7200, 7200, 10800], [1944079, 7200, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrur$__f_Africa_Johannesburg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrur$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrur$.prototype.constructor = $c_Lzonedb_java_tzdb$afrur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrur$.prototype = $c_Lzonedb_java_tzdb$afrur$.prototype;
$c_Lzonedb_java_tzdb$afrur$.prototype.Africa_Johannesburg__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrur$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 140")
  };
  return this.Lzonedb_java_tzdb$afrur$__f_Africa_Johannesburg
});
var $d_Lzonedb_java_tzdb$afrur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrur$: 0
}, false, "zonedb.java.tzdb$afrur$", {
  Lzonedb_java_tzdb$afrur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrur$.prototype.$classData = $d_Lzonedb_java_tzdb$afrur$;
var $n_Lzonedb_java_tzdb$afrur$;
function $m_Lzonedb_java_tzdb$afrur$() {
  if ((!$n_Lzonedb_java_tzdb$afrur$)) {
    $n_Lzonedb_java_tzdb$afrur$ = new $c_Lzonedb_java_tzdb$afrur$()
  };
  return $n_Lzonedb_java_tzdb$afrur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrut$() {
  this.Lzonedb_java_tzdb$afrut$__f_Africa_Ceuta = null;
  this.Lzonedb_java_tzdb$afrut$__f_Africa_Maputo = null;
  this.Lzonedb_java_tzdb$afrut$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$afrut$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-1276)), $ct_T2__O__O__(new $c_T2(), "w", (-1276)), $ct_T2__O__O__(new $c_T2(), "t", [[1900365, 85124, (-1276), 0], [1984076, 0, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1900365, 85124, (-1276), 0], [1918126, 82800, 0, 3600], [1918280, 82800, 3600, 0], [1924107, 82800, 0, 3600], [1924279, 3600, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 3600, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 3600, 3600, 0], [1928106, 0, 0, 3600], [1928281, 3600, 3600, 0], [1967154, 43200, 0, 3600], [1967274, 0, 3600, 0], [1974175, 0, 0, 3600], [1974244, 0, 3600, 0], [1976122, 0, 0, 3600], [1976214, 0, 3600, 0], [1977121, 0, 0, 3600], [1977271, 0, 3600, 0], [1978152, 0, 0, 3600], [1978216, 0, 3600, 0], [1984076, 0, 0, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrut$__f_Africa_Ceuta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrut$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$afrut$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 7820), $ct_T2__O__O__(new $c_T2(), "w", 7820), $ct_T2__O__O__(new $c_T2(), "t", [[1903060, 0, 7820, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1903060, 0, 7820, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$afrut$__f_Africa_Maputo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$afrut$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$afrut$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$afrut$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrut$.prototype.constructor = $c_Lzonedb_java_tzdb$afrut$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrut$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrut$.prototype = $c_Lzonedb_java_tzdb$afrut$.prototype;
$c_Lzonedb_java_tzdb$afrut$.prototype.Africa_Ceuta__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$afrut$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 560")
  };
  return this.Lzonedb_java_tzdb$afrut$__f_Africa_Ceuta
});
$c_Lzonedb_java_tzdb$afrut$.prototype.Africa_Maputo__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$afrut$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 561")
  };
  return this.Lzonedb_java_tzdb$afrut$__f_Africa_Maputo
});
var $d_Lzonedb_java_tzdb$afrut$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrut$: 0
}, false, "zonedb.java.tzdb$afrut$", {
  Lzonedb_java_tzdb$afrut$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrut$.prototype.$classData = $d_Lzonedb_java_tzdb$afrut$;
var $n_Lzonedb_java_tzdb$afrut$;
function $m_Lzonedb_java_tzdb$afrut$() {
  if ((!$n_Lzonedb_java_tzdb$afrut$)) {
    $n_Lzonedb_java_tzdb$afrut$ = new $c_Lzonedb_java_tzdb$afrut$()
  };
  return $n_Lzonedb_java_tzdb$afrut$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$afrvi$() {
  this.Lzonedb_java_tzdb$afrvi$__f_Africa_Monrovia = null;
  this.Lzonedb_java_tzdb$afrvi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$afrvi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-2588)), $ct_T2__O__O__(new $c_T2(), "w", (-2588)), $ct_T2__O__O__(new $c_T2(), "t", [[1919060, 0, (-2588), (-2670)], [1972007, 0, (-2670), 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919060, 0, (-2588), (-2670)], [1972007, 0, (-2670), 0]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$afrvi$__f_Africa_Monrovia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$afrvi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$afrvi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$afrvi$.prototype.constructor = $c_Lzonedb_java_tzdb$afrvi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$afrvi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$afrvi$.prototype = $c_Lzonedb_java_tzdb$afrvi$.prototype;
$c_Lzonedb_java_tzdb$afrvi$.prototype.Africa_Monrovia__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$afrvi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 180")
  };
  return this.Lzonedb_java_tzdb$afrvi$__f_Africa_Monrovia
});
var $d_Lzonedb_java_tzdb$afrvi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$afrvi$: 0
}, false, "zonedb.java.tzdb$afrvi$", {
  Lzonedb_java_tzdb$afrvi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$afrvi$.prototype.$classData = $d_Lzonedb_java_tzdb$afrvi$;
var $n_Lzonedb_java_tzdb$afrvi$;
function $m_Lzonedb_java_tzdb$afrvi$() {
  if ((!$n_Lzonedb_java_tzdb$afrvi$)) {
    $n_Lzonedb_java_tzdb$afrvi$ = new $c_Lzonedb_java_tzdb$afrvi$()
  };
  return $n_Lzonedb_java_tzdb$afrvi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameab$() {
  this.Lzonedb_java_tzdb$ameab$__f_America_Cuiaba = null;
  this.Lzonedb_java_tzdb$ameab$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameab$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-13460)), $ct_T2__O__O__(new $c_T2(), "w", (-13460)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-13460), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-13460), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [1988290, 0, (-14400), (-10800)], [1989029, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990042, 0, (-10800), (-14400)], [1990294, 0, (-14400), (-10800)], [1991048, 0, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1992040, 0, (-10800), (-14400)], [1992299, 0, (-14400), (-10800)], [1993031, 0, (-10800), (-14400)], [1993290, 0, (-14400), (-10800)], [1994051, 0, (-10800), (-14400)], [1994289, 0, (-14400), (-10800)], [1995050, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996042, 0, (-10800), (-14400)], [1996280, 0, (-14400), (-10800)], [1997047, 0, (-10800), (-14400)], [1997279, 0, (-14400), (-10800)], [1998060, 0, (-10800), (-14400)], [1998284, 0, (-14400), (-10800)], [1999052, 0, (-10800), (-14400)], [1999276, 0, (-14400), (-10800)], [2000058, 0, (-10800), (-14400)], [2000282, 0, (-14400), (-10800)], [2001049, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002048, 0, (-10800), (-14400)], [2002307, 0, (-14400), (-10800)], [2003047, 0, (-10800), (-14400)], [2004307, 0, (-14400), (-10800)], [2005051, 0, (-10800), (-14400)], [2005289, 0, (-14400), (-10800)], [2006050, 0, (-10800), (-14400)], [2006309, 0, (-14400), (-10800)], [2007056, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008048, 0, (-10800), (-14400)], [2008293, 0, (-14400), (-10800)], [2009046, 0, (-10800), (-14400)], [2009291, 0, (-14400), (-10800)], [2010052, 0, (-10800), (-14400)], [2010290, 0, (-14400), (-10800)], [2011051, 0, (-10800), (-14400)], [2011289, 0, (-14400), (-10800)], [2012057, 0, (-10800), (-14400)], [2012295, 0, (-14400), (-10800)], [2013048, 0, (-10800), (-14400)], [2013293, 0, (-14400), (-10800)], [2014047, 0, (-10800), (-14400)], [2014292, 0, (-14400), (-10800)], [2015053, 0, (-10800), (-14400)], [2015291, 0, (-14400), (-10800)], [2016052, 0, (-10800), (-14400)], [2016290, 0, (-14400), (-10800)], [2017050, 0, (-10800), (-14400)], [2017288, 0, (-14400), (-10800)], [2018049, 0, (-10800), (-14400)], [2018308, 0, (-14400), (-10800)], [2019048, 0, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameab$__f_America_Cuiaba = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameab$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameab$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameab$.prototype.constructor = $c_Lzonedb_java_tzdb$ameab$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameab$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameab$.prototype = $c_Lzonedb_java_tzdb$ameab$.prototype;
$c_Lzonedb_java_tzdb$ameab$.prototype.America_Cuiaba__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameab$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 605")
  };
  return this.Lzonedb_java_tzdb$ameab$__f_America_Cuiaba
});
var $d_Lzonedb_java_tzdb$ameab$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameab$: 0
}, false, "zonedb.java.tzdb$ameab$", {
  Lzonedb_java_tzdb$ameab$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameab$.prototype.$classData = $d_Lzonedb_java_tzdb$ameab$;
var $n_Lzonedb_java_tzdb$ameab$;
function $m_Lzonedb_java_tzdb$ameab$() {
  if ((!$n_Lzonedb_java_tzdb$ameab$)) {
    $n_Lzonedb_java_tzdb$ameab$ = new $c_Lzonedb_java_tzdb$ameab$()
  };
  return $n_Lzonedb_java_tzdb$ameab$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameag$() {
  this.Lzonedb_java_tzdb$ameag$__f_America_Ojinaga = null;
  this.Lzonedb_java_tzdb$ameag$__f_America_Anchorage = null;
  this.Lzonedb_java_tzdb$ameag$__f_America_Santiago = null;
  this.Lzonedb_java_tzdb$ameag$__f_America_Chicago = null;
  this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameag$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-25060)), $ct_T2__O__O__(new $c_T2(), "w", (-25060)), $ct_T2__O__O__(new $c_T2(), "t", [[1922001, 140, (-25060), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1998095, 10800, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1922001, 140, (-25060), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001126, 7200, (-25200), (-21600)], [2001273, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007091, 7200, (-25200), (-21600)], [2007301, 7200, (-21600), (-25200)], [2008097, 7200, (-25200), (-21600)], [2008300, 7200, (-21600), (-25200)], [2009095, 7200, (-25200), (-21600)], [2009298, 7200, (-21600), (-25200)], [2010073, 7200, (-25200), (-21600)], [2010311, 7200, (-21600), (-25200)], [2011072, 7200, (-25200), (-21600)], [2011310, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameag$__f_America_Ojinaga = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 50424), $ct_T2__O__O__(new $c_T2(), "w", 50424), $ct_T2__O__O__(new $c_T2(), "t", [[1867292, 52297, 50424, (-35976)], [1900232, 43200, (-35976), (-36000)], [1983303, 3600, (-36000), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1867292, 52297, 50424, (-35976)], [1900232, 43200, (-35976), (-36000)], [1942040, 7200, (-36000), (-32400)], [1945273, 7200, (-32400), (-36000)], [1969117, 7200, (-36000), (-32400)], [1969299, 7200, (-32400), (-36000)], [1970116, 7200, (-36000), (-32400)], [1970298, 7200, (-32400), (-36000)], [1971115, 7200, (-36000), (-32400)], [1971304, 7200, (-32400), (-36000)], [1972121, 7200, (-36000), (-32400)], [1972303, 7200, (-32400), (-36000)], [1973119, 7200, (-36000), (-32400)], [1973301, 7200, (-32400), (-36000)], [1974006, 7200, (-36000), (-32400)], [1974300, 7200, (-32400), (-36000)], [1975054, 7200, (-36000), (-32400)], [1975299, 7200, (-32400), (-36000)], [1976116, 7200, (-36000), (-32400)], [1976305, 7200, (-32400), (-36000)], [1977114, 7200, (-36000), (-32400)], [1977303, 7200, (-32400), (-36000)], [1978120, 7200, (-36000), (-32400)], [1978302, 7200, (-32400), (-36000)], [1979119, 7200, (-36000), (-32400)], [1979301, 7200, (-32400), (-36000)], [1980118, 7200, (-36000), (-32400)], [1980300, 7200, (-32400), (-36000)], [1981116, 7200, (-36000), (-32400)], [1981298, 7200, (-32400), (-36000)], [1982115, 7200, (-36000), (-32400)], [1982304, 7200, (-32400), (-36000)], [1983114, 7200, (-36000), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameag$__f_America_Anchorage = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-16966)), $ct_T2__O__O__(new $c_T2(), "w", (-16966)), $ct_T2__O__O__(new $c_T2(), "t", [[1910010, 0, (-16966), (-18000)], [1916183, 0, (-18000), (-16966)], [1918253, 0, (-16966), (-14400)], [1919182, 0, (-14400), (-16966)], [1927244, 0, (-16966), (-18000)], [1932245, 0, (-18000), (-14400)], [1942152, 0, (-14400), (-18000)], [1942213, 0, (-18000), (-14400)], [1947091, 0, (-14400), (-18000)], [1947141, 82800, (-18000), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1910010, 0, (-16966), (-18000)], [1916183, 0, (-18000), (-16966)], [1918253, 0, (-16966), (-14400)], [1919182, 0, (-14400), (-16966)], [1927244, 0, (-16966), (-14400)], [1928092, 0, (-14400), (-18000)], [1928245, 0, (-18000), (-14400)], [1929091, 0, (-14400), (-18000)], [1929244, 0, (-18000), (-14400)], [1930091, 0, (-14400), (-18000)], [1930244, 0, (-18000), (-14400)], [1931091, 0, (-14400), (-18000)], [1931244, 0, (-18000), (-14400)], [1932092, 0, (-14400), (-18000)], [1932245, 0, (-18000), (-14400)], [1942152, 0, (-14400), (-18000)], [1942213, 0, (-18000), (-14400)], [1946196, 0, (-14400), (-10800)], [1946244, 0, (-10800), (-14400)], [1947091, 0, (-14400), (-18000)], [1947141, 82800, (-18000), (-14400)], [1968308, 0, (-14400), (-10800)], [1969089, 0, (-10800), (-14400)], [1969327, 0, (-14400), (-10800)], [1970088, 0, (-10800), (-14400)], [1970284, 0, (-14400), (-10800)], [1971073, 0, (-10800), (-14400)], [1971283, 0, (-14400), (-10800)], [1972072, 0, (-10800), (-14400)], [1972289, 0, (-14400), (-10800)], [1973070, 0, (-10800), (-14400)], [1973273, 0, (-14400), (-10800)], [1974069, 0, (-10800), (-14400)], [1974286, 0, (-14400), (-10800)], [1975068, 0, (-10800), (-14400)], [1975285, 0, (-14400), (-10800)], [1976074, 0, (-10800), (-14400)], [1976284, 0, (-14400), (-10800)], [1977072, 0, (-10800), (-14400)], [1977282, 0, (-14400), (-10800)], [1978071, 0, (-10800), (-14400)], [1978288, 0, (-14400), (-10800)], [1979070, 0, (-10800), (-14400)], [1979287, 0, (-14400), (-10800)], [1980069, 0, (-10800), (-14400)], [1980286, 0, (-14400), (-10800)], [1981074, 0, (-10800), (-14400)], [1981284, 0, (-14400), (-10800)], [1982073, 0, (-10800), (-14400)], [1982283, 0, (-14400), (-10800)], [1983072, 0, (-10800), (-14400)], [1983282, 0, (-14400), (-10800)], [1984071, 0, (-10800), (-14400)], [1984288, 0, (-14400), (-10800)], [1985069, 0, (-10800), (-14400)], [1985286, 0, (-14400), (-10800)], [1986068, 0, (-10800), (-14400)], [1986285, 0, (-14400), (-10800)], [1987102, 0, (-10800), (-14400)], [1987284, 0, (-14400), (-10800)], [1988073, 0, (-10800), (-14400)], [1988283, 0, (-14400), (-10800)], [1989071, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990070, 0, (-10800), (-14400)], [1990259, 0, (-14400), (-10800)], [1991069, 0, (-10800), (-14400)], [1991286, 0, (-14400), (-10800)], [1992075, 0, (-10800), (-14400)], [1992285, 0, (-14400), (-10800)], [1993073, 0, (-10800), (-14400)], [1993283, 0, (-14400), (-10800)], [1994072, 0, (-10800), (-14400)], [1994282, 0, (-14400), (-10800)], [1995071, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996070, 0, (-10800), (-14400)], [1996287, 0, (-14400), (-10800)], [1997089, 0, (-10800), (-14400)], [1997285, 0, (-14400), (-10800)], [1998074, 0, (-10800), (-14400)], [1998270, 0, (-14400), (-10800)], [1999094, 0, (-10800), (-14400)], [1999283, 0, (-14400), (-10800)], [2000072, 0, (-10800), (-14400)], [2000289, 0, (-14400), (-10800)], [2001070, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002069, 0, (-10800), (-14400)], [2002286, 0, (-14400), (-10800)], [2003068, 0, (-10800), (-14400)], [2003285, 0, (-14400), (-10800)], [2004074, 0, (-10800), (-14400)], [2004284, 0, (-14400), (-10800)], [2005072, 0, (-10800), (-14400)], [2005282, 0, (-14400), (-10800)], [2006071, 0, (-10800), (-14400)], [2006288, 0, (-14400), (-10800)], [2007070, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008090, 0, (-10800), (-14400)], [2008286, 0, (-14400), (-10800)], [2009074, 0, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)], [2010094, 0, (-10800), (-14400)], [2010283, 0, (-14400), (-10800)], [2011128, 0, (-10800), (-14400)], [2011233, 0, (-14400), (-10800)], [2012120, 0, (-10800), (-14400)], [2012246, 0, (-14400), (-10800)], [2013118, 0, (-10800), (-14400)], [2013251, 0, (-14400), (-10800)], [2014117, 0, (-10800), (-14400)], [2014250, 0, (-14400), (-10800)], [2016136, 0, (-10800), (-14400)], [2016227, 0, (-14400), (-10800)], [2017134, 0, (-10800), (-14400)], [2017225, 0, (-14400), (-10800)], [2018133, 0, (-10800), (-14400)], [2018224, 0, (-14400), (-10800)], [2019097, 0, (-10800), (-14400)], [2019251, 0, (-14400), (-10800)], [2020096, 0, (-10800), (-14400)], [2020250, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 2, 7, 10800, 0, 0, (-14400), (-10800), (-14400)], [9, 2, 7, 14400, 0, 0, (-14400), (-14400), (-10800)]])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$ameag$__f_America_Santiago = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0) << 24) >> 24);
  var array$3 = [$ct_T2__O__O__(new $c_T2(), "s", (-21036)), $ct_T2__O__O__(new $c_T2(), "w", (-21036)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 43764, (-21036), (-21600)], [1936061, 7200, (-21600), (-18000)], [1936320, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 43764, (-21036), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1920165, 7200, (-21600), (-18000)], [1920305, 7200, (-18000), (-21600)], [1921086, 7200, (-21600), (-18000)], [1921303, 7200, (-18000), (-21600)], [1922120, 7200, (-21600), (-18000)], [1922267, 7200, (-18000), (-21600)], [1923119, 7200, (-21600), (-18000)], [1923273, 7200, (-18000), (-21600)], [1924118, 7200, (-21600), (-18000)], [1924272, 7200, (-18000), (-21600)], [1925116, 7200, (-21600), (-18000)], [1925270, 7200, (-18000), (-21600)], [1926115, 7200, (-21600), (-18000)], [1926269, 7200, (-18000), (-21600)], [1927114, 7200, (-21600), (-18000)], [1927268, 7200, (-18000), (-21600)], [1928120, 7200, (-21600), (-18000)], [1928274, 7200, (-18000), (-21600)], [1929118, 7200, (-21600), (-18000)], [1929272, 7200, (-18000), (-21600)], [1930117, 7200, (-21600), (-18000)], [1930271, 7200, (-18000), (-21600)], [1931116, 7200, (-21600), (-18000)], [1931270, 7200, (-18000), (-21600)], [1932115, 7200, (-21600), (-18000)], [1932269, 7200, (-18000), (-21600)], [1933120, 7200, (-21600), (-18000)], [1933267, 7200, (-18000), (-21600)], [1934119, 7200, (-21600), (-18000)], [1934273, 7200, (-18000), (-21600)], [1935118, 7200, (-21600), (-18000)], [1935272, 7200, (-18000), (-21600)], [1936061, 7200, (-21600), (-18000)], [1936320, 7200, (-18000), (-21600)], [1937115, 7200, (-21600), (-18000)], [1937269, 7200, (-18000), (-21600)], [1938114, 7200, (-21600), (-18000)], [1938268, 7200, (-18000), (-21600)], [1939120, 7200, (-21600), (-18000)], [1939267, 7200, (-18000), (-21600)], [1940119, 7200, (-21600), (-18000)], [1940273, 7200, (-18000), (-21600)], [1941117, 7200, (-21600), (-18000)], [1941271, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955303, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956302, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957300, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958299, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959298, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960304, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961302, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1962301, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1964117, 7200, (-21600), (-18000)], [1964299, 7200, (-18000), (-21600)], [1965115, 7200, (-21600), (-18000)], [1965304, 7200, (-18000), (-21600)], [1966114, 7200, (-21600), (-18000)], [1966303, 7200, (-18000), (-21600)], [1967120, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 7200, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 7200, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 7200, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 7200, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  this.Lzonedb_java_tzdb$ameag$__f_America_Chicago = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3);
  this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0 = (((8 | this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameag$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameag$.prototype.constructor = $c_Lzonedb_java_tzdb$ameag$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameag$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameag$.prototype = $c_Lzonedb_java_tzdb$ameag$.prototype;
$c_Lzonedb_java_tzdb$ameag$.prototype.America_Ojinaga__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 738")
  };
  return this.Lzonedb_java_tzdb$ameag$__f_America_Ojinaga
});
$c_Lzonedb_java_tzdb$ameag$.prototype.America_Anchorage__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 739")
  };
  return this.Lzonedb_java_tzdb$ameag$__f_America_Anchorage
});
$c_Lzonedb_java_tzdb$ameag$.prototype.America_Santiago__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 740")
  };
  return this.Lzonedb_java_tzdb$ameag$__f_America_Santiago
});
$c_Lzonedb_java_tzdb$ameag$.prototype.America_Chicago__sjs_js_Dynamic = (function() {
  if (((((8 & this.Lzonedb_java_tzdb$ameag$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 741")
  };
  return this.Lzonedb_java_tzdb$ameag$__f_America_Chicago
});
var $d_Lzonedb_java_tzdb$ameag$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameag$: 0
}, false, "zonedb.java.tzdb$ameag$", {
  Lzonedb_java_tzdb$ameag$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameag$.prototype.$classData = $d_Lzonedb_java_tzdb$ameag$;
var $n_Lzonedb_java_tzdb$ameag$;
function $m_Lzonedb_java_tzdb$ameag$() {
  if ((!$n_Lzonedb_java_tzdb$ameag$)) {
    $n_Lzonedb_java_tzdb$ameag$ = new $c_Lzonedb_java_tzdb$ameag$()
  };
  return $n_Lzonedb_java_tzdb$ameag$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameai$() {
  this.Lzonedb_java_tzdb$ameai$__f_America_Argentina_Ushuaia = null;
  this.Lzonedb_java_tzdb$ameai$__f_America_Port_of_Spain = null;
  this.Lzonedb_java_tzdb$ameai$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameai$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-16392)), $ct_T2__O__O__(new $c_T2(), "w", (-16392)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-16392), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004151, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-16392), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004151, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameai$__f_America_Argentina_Ushuaia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameai$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameai$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-14764)), $ct_T2__O__O__(new $c_T2(), "w", (-14764)), $ct_T2__O__O__(new $c_T2(), "t", [[1912062, 0, (-14764), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912062, 0, (-14764), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameai$__f_America_Port_of_Spain = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameai$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameai$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameai$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameai$.prototype.constructor = $c_Lzonedb_java_tzdb$ameai$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameai$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameai$.prototype = $c_Lzonedb_java_tzdb$ameai$.prototype;
$c_Lzonedb_java_tzdb$ameai$.prototype.America_Argentina_Ushuaia__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameai$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 571")
  };
  return this.Lzonedb_java_tzdb$ameai$__f_America_Argentina_Ushuaia
});
$c_Lzonedb_java_tzdb$ameai$.prototype.America_Port_of_Spain__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameai$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 572")
  };
  return this.Lzonedb_java_tzdb$ameai$__f_America_Port_of_Spain
});
var $d_Lzonedb_java_tzdb$ameai$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameai$: 0
}, false, "zonedb.java.tzdb$ameai$", {
  Lzonedb_java_tzdb$ameai$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameai$.prototype.$classData = $d_Lzonedb_java_tzdb$ameai$;
var $n_Lzonedb_java_tzdb$ameai$;
function $m_Lzonedb_java_tzdb$ameai$() {
  if ((!$n_Lzonedb_java_tzdb$ameai$)) {
    $n_Lzonedb_java_tzdb$ameai$ = new $c_Lzonedb_java_tzdb$ameai$()
  };
  return $n_Lzonedb_java_tzdb$ameai$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameal$() {
  this.Lzonedb_java_tzdb$ameal$__f_America_Guatemala = null;
  this.Lzonedb_java_tzdb$ameal$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameal$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-21724)), $ct_T2__O__O__(new $c_T2(), "w", (-21724)), $ct_T2__O__O__(new $c_T2(), "t", [[1918278, 0, (-21724), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1918278, 0, (-21724), (-21600)], [1973329, 0, (-21600), (-18000)], [1974055, 0, (-18000), (-21600)], [1983141, 0, (-21600), (-18000)], [1983265, 0, (-18000), (-21600)], [1991082, 0, (-21600), (-18000)], [1991250, 0, (-18000), (-21600)], [2006120, 0, (-21600), (-18000)], [2006274, 0, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameal$__f_America_Guatemala = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameal$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameal$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameal$.prototype.constructor = $c_Lzonedb_java_tzdb$ameal$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameal$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameal$.prototype = $c_Lzonedb_java_tzdb$ameal$.prototype;
$c_Lzonedb_java_tzdb$ameal$.prototype.America_Guatemala__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameal$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 329")
  };
  return this.Lzonedb_java_tzdb$ameal$__f_America_Guatemala
});
var $d_Lzonedb_java_tzdb$ameal$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameal$: 0
}, false, "zonedb.java.tzdb$ameal$", {
  Lzonedb_java_tzdb$ameal$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameal$.prototype.$classData = $d_Lzonedb_java_tzdb$ameal$;
var $n_Lzonedb_java_tzdb$ameal$;
function $m_Lzonedb_java_tzdb$ameal$() {
  if ((!$n_Lzonedb_java_tzdb$ameal$)) {
    $n_Lzonedb_java_tzdb$ameal$ = new $c_Lzonedb_java_tzdb$ameal$()
  };
  return $n_Lzonedb_java_tzdb$ameal$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameam$() {
  this.Lzonedb_java_tzdb$ameam$__f_America_Panama = null;
  this.Lzonedb_java_tzdb$ameam$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameam$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-19088)), $ct_T2__O__O__(new $c_T2(), "w", (-19088)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-19088), (-19176)], [1908113, 0, (-19176), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-19088), (-19176)], [1908113, 0, (-19176), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameam$__f_America_Panama = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameam$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameam$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameam$.prototype.constructor = $c_Lzonedb_java_tzdb$ameam$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameam$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameam$.prototype = $c_Lzonedb_java_tzdb$ameam$.prototype;
$c_Lzonedb_java_tzdb$ameam$.prototype.America_Panama__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameam$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 506")
  };
  return this.Lzonedb_java_tzdb$ameam$__f_America_Panama
});
var $d_Lzonedb_java_tzdb$ameam$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameam$: 0
}, false, "zonedb.java.tzdb$ameam$", {
  Lzonedb_java_tzdb$ameam$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameam$.prototype.$classData = $d_Lzonedb_java_tzdb$ameam$;
var $n_Lzonedb_java_tzdb$ameam$;
function $m_Lzonedb_java_tzdb$ameam$() {
  if ((!$n_Lzonedb_java_tzdb$ameam$)) {
    $n_Lzonedb_java_tzdb$ameam$ = new $c_Lzonedb_java_tzdb$ameam$()
  };
  return $n_Lzonedb_java_tzdb$ameam$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amean$() {
  this.Lzonedb_java_tzdb$amean$__f_America_Tijuana = null;
  this.Lzonedb_java_tzdb$amean$__f_America_Havana = null;
  this.Lzonedb_java_tzdb$amean$__f_America_Guyana = null;
  this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amean$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-28084)), $ct_T2__O__O__(new $c_T2(), "w", (-28084)), $ct_T2__O__O__(new $c_T2(), "t", [[1922001, 716, (-28084), (-25200)], [1924001, 0, (-25200), (-28800)], [1927161, 82800, (-28800), (-25200)], [1930319, 0, (-25200), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1922001, 716, (-28084), (-25200)], [1924001, 0, (-25200), (-28800)], [1927161, 82800, (-28800), (-25200)], [1930319, 0, (-25200), (-28800)], [1931091, 0, (-28800), (-25200)], [1931273, 0, (-25200), (-28800)], [1942114, 0, (-28800), (-25200)], [1945316, 0, (-25200), (-28800)], [1948096, 0, (-28800), (-25200)], [1949014, 0, (-25200), (-28800)], [1954115, 3600, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 3600, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 3600, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 3600, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 3600, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 3600, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 3600, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007091, 7200, (-28800), (-25200)], [2007301, 7200, (-25200), (-28800)], [2008097, 7200, (-28800), (-25200)], [2008300, 7200, (-25200), (-28800)], [2009095, 7200, (-28800), (-25200)], [2009298, 7200, (-25200), (-28800)], [2010073, 7200, (-28800), (-25200)], [2010311, 7200, (-25200), (-28800)], [2011072, 7200, (-28800), (-25200)], [2011310, 7200, (-25200), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amean$__f_America_Tijuana = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-19768)), $ct_T2__O__O__(new $c_T2(), "w", (-19768)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-19768), (-19776)], [1925200, 43200, (-19776), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-19768), (-19776)], [1925200, 43200, (-19776), (-18000)], [1928162, 0, (-18000), (-14400)], [1928284, 0, (-14400), (-18000)], [1940154, 0, (-18000), (-14400)], [1940245, 0, (-14400), (-18000)], [1941152, 0, (-18000), (-14400)], [1941250, 0, (-14400), (-18000)], [1942158, 0, (-18000), (-14400)], [1942249, 0, (-14400), (-18000)], [1945154, 0, (-18000), (-14400)], [1945245, 0, (-14400), (-18000)], [1946153, 0, (-18000), (-14400)], [1946244, 0, (-14400), (-18000)], [1965152, 0, (-18000), (-14400)], [1965273, 0, (-14400), (-18000)], [1966149, 0, (-18000), (-14400)], [1966275, 0, (-14400), (-18000)], [1967098, 0, (-18000), (-14400)], [1967253, 0, (-14400), (-18000)], [1968105, 0, (-18000), (-14400)], [1968252, 0, (-14400), (-18000)], [1969117, 0, (-18000), (-14400)], [1969299, 0, (-14400), (-18000)], [1970116, 0, (-18000), (-14400)], [1970298, 0, (-14400), (-18000)], [1971115, 0, (-18000), (-14400)], [1971304, 0, (-14400), (-18000)], [1972121, 0, (-18000), (-14400)], [1972282, 0, (-14400), (-18000)], [1973119, 0, (-18000), (-14400)], [1973281, 0, (-14400), (-18000)], [1974118, 0, (-18000), (-14400)], [1974281, 0, (-14400), (-18000)], [1975117, 0, (-18000), (-14400)], [1975299, 0, (-14400), (-18000)], [1976116, 0, (-18000), (-14400)], [1976305, 0, (-14400), (-18000)], [1977114, 0, (-18000), (-14400)], [1977303, 0, (-14400), (-18000)], [1978127, 0, (-18000), (-14400)], [1978281, 0, (-14400), (-18000)], [1979077, 0, (-18000), (-14400)], [1979287, 0, (-14400), (-18000)], [1980076, 0, (-18000), (-14400)], [1980286, 0, (-14400), (-18000)], [1981130, 0, (-18000), (-14400)], [1981284, 0, (-14400), (-18000)], [1982129, 0, (-18000), (-14400)], [1982283, 0, (-14400), (-18000)], [1983128, 0, (-18000), (-14400)], [1983282, 0, (-14400), (-18000)], [1984127, 0, (-18000), (-14400)], [1984288, 0, (-14400), (-18000)], [1985125, 0, (-18000), (-14400)], [1985286, 0, (-14400), (-18000)], [1986075, 0, (-18000), (-14400)], [1986285, 0, (-14400), (-18000)], [1987074, 0, (-18000), (-14400)], [1987284, 0, (-14400), (-18000)], [1988080, 0, (-18000), (-14400)], [1988283, 0, (-14400), (-18000)], [1989078, 0, (-18000), (-14400)], [1989281, 0, (-14400), (-18000)], [1990091, 0, (-18000), (-14400)], [1990287, 0, (-14400), (-18000)], [1991097, 0, (-18000), (-14400)], [1991286, 3600, (-14400), (-18000)], [1992096, 0, (-18000), (-14400)], [1992285, 3600, (-14400), (-18000)], [1993094, 0, (-18000), (-14400)], [1993283, 3600, (-14400), (-18000)], [1994093, 0, (-18000), (-14400)], [1994282, 3600, (-14400), (-18000)], [1995092, 0, (-18000), (-14400)], [1995281, 3600, (-14400), (-18000)], [1996098, 0, (-18000), (-14400)], [1996280, 3600, (-14400), (-18000)], [1997096, 0, (-18000), (-14400)], [1997285, 3600, (-14400), (-18000)], [1998088, 0, (-18000), (-14400)], [1998298, 3600, (-14400), (-18000)], [1999087, 0, (-18000), (-14400)], [1999304, 3600, (-14400), (-18000)], [2000093, 0, (-18000), (-14400)], [2000303, 3600, (-14400), (-18000)], [2001091, 0, (-18000), (-14400)], [2001301, 3600, (-14400), (-18000)], [2002097, 0, (-18000), (-14400)], [2002300, 3600, (-14400), (-18000)], [2003096, 0, (-18000), (-14400)], [2003299, 3600, (-14400), (-18000)], [2004088, 0, (-18000), (-14400)], [2006302, 3600, (-14400), (-18000)], [2007070, 0, (-18000), (-14400)], [2007301, 3600, (-14400), (-18000)], [2008076, 0, (-18000), (-14400)], [2008300, 3600, (-14400), (-18000)], [2009067, 0, (-18000), (-14400)], [2009298, 3600, (-14400), (-18000)], [2010073, 0, (-18000), (-14400)], [2010304, 3600, (-14400), (-18000)], [2011079, 0, (-18000), (-14400)], [2011317, 3600, (-14400), (-18000)], [2012092, 0, (-18000), (-14400)], [2012309, 3600, (-14400), (-18000)], [2013069, 0, (-18000), (-14400)], [2013307, 3600, (-14400), (-18000)], [2014068, 0, (-18000), (-14400)], [2014306, 3600, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 0, 0, 2, (-18000), (-18000), (-14400)], [11, 1, 7, 0, 0, 2, (-18000), (-14400), (-18000)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amean$__f_America_Havana = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-13960)), $ct_T2__O__O__(new $c_T2(), "w", (-13960)), $ct_T2__O__O__(new $c_T2(), "t", [[1915060, 0, (-13960), (-13500)], [1975212, 0, (-13500), (-10800)], [1991001, 0, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1915060, 0, (-13960), (-13500)], [1975212, 0, (-13500), (-10800)], [1991001, 0, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$amean$__f_America_Guyana = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amean$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amean$.prototype.constructor = $c_Lzonedb_java_tzdb$amean$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amean$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amean$.prototype = $c_Lzonedb_java_tzdb$amean$.prototype;
$c_Lzonedb_java_tzdb$amean$.prototype.America_Tijuana__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 839")
  };
  return this.Lzonedb_java_tzdb$amean$__f_America_Tijuana
});
$c_Lzonedb_java_tzdb$amean$.prototype.America_Havana__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 840")
  };
  return this.Lzonedb_java_tzdb$amean$__f_America_Havana
});
$c_Lzonedb_java_tzdb$amean$.prototype.America_Guyana__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$amean$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 841")
  };
  return this.Lzonedb_java_tzdb$amean$__f_America_Guyana
});
var $d_Lzonedb_java_tzdb$amean$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amean$: 0
}, false, "zonedb.java.tzdb$amean$", {
  Lzonedb_java_tzdb$amean$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amean$.prototype.$classData = $d_Lzonedb_java_tzdb$amean$;
var $n_Lzonedb_java_tzdb$amean$;
function $m_Lzonedb_java_tzdb$amean$() {
  if ((!$n_Lzonedb_java_tzdb$amean$)) {
    $n_Lzonedb_java_tzdb$amean$ = new $c_Lzonedb_java_tzdb$amean$()
  };
  return $n_Lzonedb_java_tzdb$amean$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameau$() {
  this.Lzonedb_java_tzdb$ameau$__f_America_Manaus = null;
  this.Lzonedb_java_tzdb$ameau$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameau$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-14404)), $ct_T2__O__O__(new $c_T2(), "w", (-14404)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-14404), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-14404), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [1993290, 0, (-14400), (-10800)], [1994051, 0, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameau$__f_America_Manaus = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameau$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameau$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameau$.prototype.constructor = $c_Lzonedb_java_tzdb$ameau$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameau$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameau$.prototype = $c_Lzonedb_java_tzdb$ameau$.prototype;
$c_Lzonedb_java_tzdb$ameau$.prototype.America_Manaus__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameau$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 911")
  };
  return this.Lzonedb_java_tzdb$ameau$__f_America_Manaus
});
var $d_Lzonedb_java_tzdb$ameau$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameau$: 0
}, false, "zonedb.java.tzdb$ameau$", {
  Lzonedb_java_tzdb$ameau$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameau$.prototype.$classData = $d_Lzonedb_java_tzdb$ameau$;
var $n_Lzonedb_java_tzdb$ameau$;
function $m_Lzonedb_java_tzdb$ameau$() {
  if ((!$n_Lzonedb_java_tzdb$ameau$)) {
    $n_Lzonedb_java_tzdb$ameau$ = new $c_Lzonedb_java_tzdb$ameau$()
  };
  return $n_Lzonedb_java_tzdb$ameau$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameav$() {
  this.Lzonedb_java_tzdb$ameav$__f_America_Danmarkshavn = null;
  this.Lzonedb_java_tzdb$ameav$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameav$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-4480)), $ct_T2__O__O__(new $c_T2(), "w", (-4480)), $ct_T2__O__O__(new $c_T2(), "t", [[1916210, 0, (-4480), (-10800)], [1996001, 0, (-10800), 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1916210, 0, (-4480), (-10800)], [1980097, 7200, (-10800), (-7200)], [1980271, 82800, (-7200), (-10800)], [1981087, 79200, (-10800), (-7200)], [1981269, 82800, (-7200), (-10800)], [1982086, 79200, (-10800), (-7200)], [1982268, 82800, (-7200), (-10800)], [1983085, 79200, (-10800), (-7200)], [1983267, 82800, (-7200), (-10800)], [1984084, 79200, (-10800), (-7200)], [1984273, 82800, (-7200), (-10800)], [1985089, 79200, (-10800), (-7200)], [1985271, 82800, (-7200), (-10800)], [1986088, 79200, (-10800), (-7200)], [1986270, 82800, (-7200), (-10800)], [1987087, 79200, (-10800), (-7200)], [1987269, 82800, (-7200), (-10800)], [1988086, 79200, (-10800), (-7200)], [1988268, 82800, (-7200), (-10800)], [1989084, 79200, (-10800), (-7200)], [1989266, 82800, (-7200), (-10800)], [1990083, 79200, (-10800), (-7200)], [1990272, 82800, (-7200), (-10800)], [1991089, 79200, (-10800), (-7200)], [1991271, 82800, (-7200), (-10800)], [1992088, 79200, (-10800), (-7200)], [1992270, 82800, (-7200), (-10800)], [1993086, 79200, (-10800), (-7200)], [1993268, 82800, (-7200), (-10800)], [1994085, 79200, (-10800), (-7200)], [1994267, 82800, (-7200), (-10800)], [1995084, 79200, (-10800), (-7200)], [1995266, 82800, (-7200), (-10800)], [1996001, 0, (-10800), 0]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameav$__f_America_Danmarkshavn = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameav$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameav$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameav$.prototype.constructor = $c_Lzonedb_java_tzdb$ameav$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameav$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameav$.prototype = $c_Lzonedb_java_tzdb$ameav$.prototype;
$c_Lzonedb_java_tzdb$ameav$.prototype.America_Danmarkshavn__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameav$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 250")
  };
  return this.Lzonedb_java_tzdb$ameav$__f_America_Danmarkshavn
});
var $d_Lzonedb_java_tzdb$ameav$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameav$: 0
}, false, "zonedb.java.tzdb$ameav$", {
  Lzonedb_java_tzdb$ameav$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameav$.prototype.$classData = $d_Lzonedb_java_tzdb$ameav$;
var $n_Lzonedb_java_tzdb$ameav$;
function $m_Lzonedb_java_tzdb$ameav$() {
  if ((!$n_Lzonedb_java_tzdb$ameav$)) {
    $n_Lzonedb_java_tzdb$ameav$ = new $c_Lzonedb_java_tzdb$ameav$()
  };
  return $n_Lzonedb_java_tzdb$ameav$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameba$() {
  this.Lzonedb_java_tzdb$ameba$__f_America_Thunder_Bay = null;
  this.Lzonedb_java_tzdb$ameba$__f_America_Goose_Bay = null;
  this.Lzonedb_java_tzdb$ameba$__f_America_Cambridge_Bay = null;
  this.Lzonedb_java_tzdb$ameba$__f_America_Glace_Bay = null;
  this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameba$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-21420)), $ct_T2__O__O__(new $c_T2(), "w", (-21420)), $ct_T2__O__O__(new $c_T2(), "t", [[1895001, 0, (-21420), (-21600)], [1910001, 0, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895001, 0, (-21420), (-21600)], [1910001, 0, (-21600), (-18000)], [1942040, 7200, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1974118, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameba$__f_America_Thunder_Bay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-14500)), $ct_T2__O__O__(new $c_T2(), "w", (-14500)), $ct_T2__O__O__(new $c_T2(), "t", [[1884001, 0, (-14500), (-12652)], [1935089, 0, (-12652), (-12600)], [1966074, 7200, (-12600), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1884001, 0, (-14500), (-12652)], [1918104, 7200, (-12652), (-9052)], [1918300, 7200, (-9052), (-12652)], [1935089, 0, (-12652), (-12600)], [1936132, 0, (-12600), (-9000)], [1936279, 0, (-9000), (-12600)], [1937130, 0, (-12600), (-9000)], [1937277, 0, (-9000), (-12600)], [1938129, 0, (-12600), (-9000)], [1938276, 0, (-9000), (-12600)], [1939135, 0, (-12600), (-9000)], [1939275, 0, (-9000), (-12600)], [1940134, 0, (-12600), (-9000)], [1940281, 0, (-9000), (-12600)], [1941132, 0, (-12600), (-9000)], [1941279, 0, (-9000), (-12600)], [1942131, 0, (-12600), (-9000)], [1945273, 7200, (-9000), (-12600)], [1946132, 7200, (-12600), (-9000)], [1946279, 7200, (-9000), (-12600)], [1947131, 7200, (-12600), (-9000)], [1947278, 7200, (-9000), (-12600)], [1948130, 7200, (-12600), (-9000)], [1948277, 7200, (-9000), (-12600)], [1949128, 7200, (-12600), (-9000)], [1949275, 7200, (-9000), (-12600)], [1950134, 7200, (-12600), (-9000)], [1950281, 7200, (-9000), (-12600)], [1951119, 7200, (-12600), (-9000)], [1951273, 7200, (-9000), (-12600)], [1952118, 7200, (-12600), (-9000)], [1952272, 7200, (-9000), (-12600)], [1953116, 7200, (-12600), (-9000)], [1953270, 7200, (-9000), (-12600)], [1954115, 7200, (-12600), (-9000)], [1954269, 7200, (-9000), (-12600)], [1955114, 7200, (-12600), (-9000)], [1955268, 7200, (-9000), (-12600)], [1956120, 7200, (-12600), (-9000)], [1956274, 7200, (-9000), (-12600)], [1957118, 7200, (-12600), (-9000)], [1957272, 7200, (-9000), (-12600)], [1958117, 7200, (-12600), (-9000)], [1958271, 7200, (-9000), (-12600)], [1959116, 7200, (-12600), (-9000)], [1959270, 7200, (-9000), (-12600)], [1960115, 7200, (-12600), (-9000)], [1960304, 7200, (-9000), (-12600)], [1961120, 7200, (-12600), (-9000)], [1961302, 7200, (-9000), (-12600)], [1962119, 7200, (-12600), (-9000)], [1962301, 7200, (-9000), (-12600)], [1963118, 7200, (-12600), (-9000)], [1963300, 7200, (-9000), (-12600)], [1964117, 7200, (-12600), (-9000)], [1964299, 7200, (-9000), (-12600)], [1965115, 7200, (-12600), (-9000)], [1965304, 7200, (-9000), (-12600)], [1966074, 7200, (-12600), (-14400)], [1966114, 7200, (-14400), (-10800)], [1966303, 7200, (-10800), (-14400)], [1967120, 7200, (-14400), (-10800)], [1967302, 7200, (-10800), (-14400)], [1968119, 7200, (-14400), (-10800)], [1968301, 7200, (-10800), (-14400)], [1969117, 7200, (-14400), (-10800)], [1969299, 7200, (-10800), (-14400)], [1970116, 7200, (-14400), (-10800)], [1970298, 7200, (-10800), (-14400)], [1971115, 7200, (-14400), (-10800)], [1971304, 7200, (-10800), (-14400)], [1972121, 7200, (-14400), (-10800)], [1972303, 7200, (-10800), (-14400)], [1973119, 7200, (-14400), (-10800)], [1973301, 7200, (-10800), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 60, (-14400), (-10800)], [1987298, 60, (-10800), (-14400)], [1988094, 60, (-14400), (-7200)], [1988304, 60, (-7200), (-14400)], [1989092, 60, (-14400), (-10800)], [1989302, 60, (-10800), (-14400)], [1990091, 60, (-14400), (-10800)], [1990301, 60, (-10800), (-14400)], [1991097, 60, (-14400), (-10800)], [1991300, 60, (-10800), (-14400)], [1992096, 60, (-14400), (-10800)], [1992299, 60, (-10800), (-14400)], [1993094, 60, (-14400), (-10800)], [1993304, 60, (-10800), (-14400)], [1994093, 60, (-14400), (-10800)], [1994303, 60, (-10800), (-14400)], [1995092, 60, (-14400), (-10800)], [1995302, 60, (-10800), (-14400)], [1996098, 60, (-14400), (-10800)], [1996301, 60, (-10800), (-14400)], [1997096, 60, (-14400), (-10800)], [1997299, 60, (-10800), (-14400)], [1998095, 60, (-14400), (-10800)], [1998298, 60, (-10800), (-14400)], [1999094, 60, (-14400), (-10800)], [1999304, 60, (-10800), (-14400)], [2000093, 60, (-14400), (-10800)], [2000303, 60, (-10800), (-14400)], [2001091, 60, (-14400), (-10800)], [2001301, 60, (-10800), (-14400)], [2002097, 60, (-14400), (-10800)], [2002300, 60, (-10800), (-14400)], [2003096, 60, (-14400), (-10800)], [2003299, 60, (-10800), (-14400)], [2004095, 60, (-14400), (-10800)], [2004305, 60, (-10800), (-14400)], [2005093, 60, (-14400), (-10800)], [2005303, 60, (-10800), (-14400)], [2006092, 60, (-14400), (-10800)], [2006302, 60, (-10800), (-14400)], [2007070, 60, (-14400), (-10800)], [2007308, 60, (-10800), (-14400)], [2008069, 60, (-14400), (-10800)], [2008307, 60, (-10800), (-14400)], [2009067, 60, (-14400), (-10800)], [2009305, 60, (-10800), (-14400)], [2010073, 60, (-14400), (-10800)], [2010311, 60, (-10800), (-14400)], [2011072, 60, (-14400), (-10800)], [2011310, 7200, (-10800), (-14400)], [2012071, 7200, (-14400), (-10800)], [2012309, 7200, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameba$__f_America_Goose_Bay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1920001, 0, 0, (-25200)], [1999304, 3600, (-25200), (-21600)], [2000303, 3600, (-21600), (-18000)], [2000310, 0, (-18000), (-21600)], [2001091, 10800, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920001, 0, 0, (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1965115, 0, (-25200), (-18000)], [1965304, 7200, (-18000), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000310, 0, (-18000), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$ameba$__f_America_Cambridge_Bay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0) << 24) >> 24);
  var array$3 = [$ct_T2__O__O__(new $c_T2(), "s", (-14388)), $ct_T2__O__O__(new $c_T2(), "w", (-14388)), $ct_T2__O__O__(new $c_T2(), "t", [[1902166, 0, (-14388), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1902166, 0, (-14388), (-14400)], [1918104, 7200, (-14400), (-10800)], [1918300, 7200, (-10800), (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)], [1953116, 7200, (-14400), (-10800)], [1953270, 7200, (-10800), (-14400)], [1972121, 7200, (-14400), (-10800)], [1972303, 7200, (-10800), (-14400)], [1973119, 7200, (-14400), (-10800)], [1973301, 7200, (-10800), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995092, 7200, (-14400), (-10800)], [1995302, 7200, (-10800), (-14400)], [1996098, 7200, (-14400), (-10800)], [1996301, 7200, (-10800), (-14400)], [1997096, 7200, (-14400), (-10800)], [1997299, 7200, (-10800), (-14400)], [1998095, 7200, (-14400), (-10800)], [1998298, 7200, (-10800), (-14400)], [1999094, 7200, (-14400), (-10800)], [1999304, 7200, (-10800), (-14400)], [2000093, 7200, (-14400), (-10800)], [2000303, 7200, (-10800), (-14400)], [2001091, 7200, (-14400), (-10800)], [2001301, 7200, (-10800), (-14400)], [2002097, 7200, (-14400), (-10800)], [2002300, 7200, (-10800), (-14400)], [2003096, 7200, (-14400), (-10800)], [2003299, 7200, (-10800), (-14400)], [2004095, 7200, (-14400), (-10800)], [2004305, 7200, (-10800), (-14400)], [2005093, 7200, (-14400), (-10800)], [2005303, 7200, (-10800), (-14400)], [2006092, 7200, (-14400), (-10800)], [2006302, 7200, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]])];
  var fields$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  this.Lzonedb_java_tzdb$ameba$__f_America_Glace_Bay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3);
  this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0 = (((8 | this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameba$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameba$.prototype.constructor = $c_Lzonedb_java_tzdb$ameba$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameba$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameba$.prototype = $c_Lzonedb_java_tzdb$ameba$.prototype;
$c_Lzonedb_java_tzdb$ameba$.prototype.America_Thunder_Bay__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 157")
  };
  return this.Lzonedb_java_tzdb$ameba$__f_America_Thunder_Bay
});
$c_Lzonedb_java_tzdb$ameba$.prototype.America_Goose_Bay__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 158")
  };
  return this.Lzonedb_java_tzdb$ameba$__f_America_Goose_Bay
});
$c_Lzonedb_java_tzdb$ameba$.prototype.America_Cambridge_Bay__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 159")
  };
  return this.Lzonedb_java_tzdb$ameba$__f_America_Cambridge_Bay
});
$c_Lzonedb_java_tzdb$ameba$.prototype.America_Glace_Bay__sjs_js_Dynamic = (function() {
  if (((((8 & this.Lzonedb_java_tzdb$ameba$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 160")
  };
  return this.Lzonedb_java_tzdb$ameba$__f_America_Glace_Bay
});
var $d_Lzonedb_java_tzdb$ameba$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameba$: 0
}, false, "zonedb.java.tzdb$ameba$", {
  Lzonedb_java_tzdb$ameba$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameba$.prototype.$classData = $d_Lzonedb_java_tzdb$ameba$;
var $n_Lzonedb_java_tzdb$ameba$;
function $m_Lzonedb_java_tzdb$ameba$() {
  if ((!$n_Lzonedb_java_tzdb$ameba$)) {
    $n_Lzonedb_java_tzdb$ameba$ = new $c_Lzonedb_java_tzdb$ameba$()
  };
  return $n_Lzonedb_java_tzdb$ameba$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameca$() {
  this.Lzonedb_java_tzdb$ameca$__f_America_Caracas = null;
  this.Lzonedb_java_tzdb$ameca$__f_America_Curacao = null;
  this.Lzonedb_java_tzdb$ameca$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameca$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-16064)), $ct_T2__O__O__(new $c_T2(), "w", (-16064)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-16064), (-16060)], [1912043, 0, (-16060), (-16200)], [1965001, 0, (-16200), (-14400)], [2007343, 10800, (-14400), (-16200)], [2016122, 9000, (-16200), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-16064), (-16060)], [1912043, 0, (-16060), (-16200)], [1965001, 0, (-16200), (-14400)], [2007343, 10800, (-14400), (-16200)], [2016122, 9000, (-16200), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameca$__f_America_Caracas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameca$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameca$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-16547)), $ct_T2__O__O__(new $c_T2(), "w", (-16547)), $ct_T2__O__O__(new $c_T2(), "t", [[1912043, 0, (-16547), (-16200)], [1965001, 0, (-16200), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912043, 0, (-16547), (-16200)], [1965001, 0, (-16200), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameca$__f_America_Curacao = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameca$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameca$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameca$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameca$.prototype.constructor = $c_Lzonedb_java_tzdb$ameca$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameca$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameca$.prototype = $c_Lzonedb_java_tzdb$ameca$.prototype;
$c_Lzonedb_java_tzdb$ameca$.prototype.America_Caracas__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameca$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 875")
  };
  return this.Lzonedb_java_tzdb$ameca$__f_America_Caracas
});
$c_Lzonedb_java_tzdb$ameca$.prototype.America_Curacao__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameca$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 876")
  };
  return this.Lzonedb_java_tzdb$ameca$__f_America_Curacao
});
var $d_Lzonedb_java_tzdb$ameca$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameca$: 0
}, false, "zonedb.java.tzdb$ameca$", {
  Lzonedb_java_tzdb$ameca$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameca$.prototype.$classData = $d_Lzonedb_java_tzdb$ameca$;
var $n_Lzonedb_java_tzdb$ameca$;
function $m_Lzonedb_java_tzdb$ameca$() {
  if ((!$n_Lzonedb_java_tzdb$ameca$)) {
    $n_Lzonedb_java_tzdb$ameca$ = new $c_Lzonedb_java_tzdb$ameca$()
  };
  return $n_Lzonedb_java_tzdb$ameca$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amecu$() {
  this.Lzonedb_java_tzdb$amecu$__f_America_Cancun = null;
  this.Lzonedb_java_tzdb$amecu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amecu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-20824)), $ct_T2__O__O__(new $c_T2(), "w", (-20824)), $ct_T2__O__O__(new $c_T2(), "t", [[1922001, 776, (-20824), (-21600)], [1981357, 0, (-21600), (-18000)], [1998214, 3600, (-18000), (-21600)], [2015032, 7200, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1922001, 776, (-20824), (-21600)], [1981357, 0, (-21600), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998214, 7200, (-14400), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007091, 7200, (-21600), (-18000)], [2007301, 7200, (-18000), (-21600)], [2008097, 7200, (-21600), (-18000)], [2008300, 7200, (-18000), (-21600)], [2009095, 7200, (-21600), (-18000)], [2009298, 7200, (-18000), (-21600)], [2010094, 7200, (-21600), (-18000)], [2010304, 7200, (-18000), (-21600)], [2011093, 7200, (-21600), (-18000)], [2011303, 7200, (-18000), (-21600)], [2012092, 7200, (-21600), (-18000)], [2012302, 7200, (-18000), (-21600)], [2013097, 7200, (-21600), (-18000)], [2013300, 7200, (-18000), (-21600)], [2014096, 7200, (-21600), (-18000)], [2014299, 7200, (-18000), (-21600)], [2015032, 7200, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amecu$__f_America_Cancun = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amecu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amecu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amecu$.prototype.constructor = $c_Lzonedb_java_tzdb$amecu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amecu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amecu$.prototype = $c_Lzonedb_java_tzdb$amecu$.prototype;
$c_Lzonedb_java_tzdb$amecu$.prototype.America_Cancun__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amecu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 128")
  };
  return this.Lzonedb_java_tzdb$amecu$__f_America_Cancun
});
var $d_Lzonedb_java_tzdb$amecu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amecu$: 0
}, false, "zonedb.java.tzdb$amecu$", {
  Lzonedb_java_tzdb$amecu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amecu$.prototype.$classData = $d_Lzonedb_java_tzdb$amecu$;
var $n_Lzonedb_java_tzdb$amecu$;
function $m_Lzonedb_java_tzdb$amecu$() {
  if ((!$n_Lzonedb_java_tzdb$amecu$)) {
    $n_Lzonedb_java_tzdb$amecu$ = new $c_Lzonedb_java_tzdb$amecu$()
  };
  return $n_Lzonedb_java_tzdb$amecu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameda$() {
  this.Lzonedb_java_tzdb$ameda$__f_America_Adak = null;
  this.Lzonedb_java_tzdb$ameda$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameda$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 44002), $ct_T2__O__O__(new $c_T2(), "w", 44002), $ct_T2__O__O__(new $c_T2(), "t", [[1867292, 45875, 44002, (-42398)], [1900232, 43200, (-42398), (-39600)], [1983303, 3600, (-39600), (-36000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1867292, 45875, 44002, (-42398)], [1900232, 43200, (-42398), (-39600)], [1942040, 7200, (-39600), (-36000)], [1945273, 7200, (-36000), (-39600)], [1969117, 7200, (-39600), (-36000)], [1969299, 7200, (-36000), (-39600)], [1970116, 7200, (-39600), (-36000)], [1970298, 7200, (-36000), (-39600)], [1971115, 7200, (-39600), (-36000)], [1971304, 7200, (-36000), (-39600)], [1972121, 7200, (-39600), (-36000)], [1972303, 7200, (-36000), (-39600)], [1973119, 7200, (-39600), (-36000)], [1973301, 7200, (-36000), (-39600)], [1974006, 7200, (-39600), (-36000)], [1974300, 7200, (-36000), (-39600)], [1975054, 7200, (-39600), (-36000)], [1975299, 7200, (-36000), (-39600)], [1976116, 7200, (-39600), (-36000)], [1976305, 7200, (-36000), (-39600)], [1977114, 7200, (-39600), (-36000)], [1977303, 7200, (-36000), (-39600)], [1978120, 7200, (-39600), (-36000)], [1978302, 7200, (-36000), (-39600)], [1979119, 7200, (-39600), (-36000)], [1979301, 7200, (-36000), (-39600)], [1980118, 7200, (-39600), (-36000)], [1980300, 7200, (-36000), (-39600)], [1981116, 7200, (-39600), (-36000)], [1981298, 7200, (-36000), (-39600)], [1982115, 7200, (-39600), (-36000)], [1982304, 7200, (-36000), (-39600)], [1983114, 7200, (-39600), (-36000)], [1984120, 7200, (-36000), (-32400)], [1984302, 7200, (-32400), (-36000)], [1985118, 7200, (-36000), (-32400)], [1985300, 7200, (-32400), (-36000)], [1986117, 7200, (-36000), (-32400)], [1986299, 7200, (-32400), (-36000)], [1987095, 7200, (-36000), (-32400)], [1987298, 7200, (-32400), (-36000)], [1988094, 7200, (-36000), (-32400)], [1988304, 7200, (-32400), (-36000)], [1989092, 7200, (-36000), (-32400)], [1989302, 7200, (-32400), (-36000)], [1990091, 7200, (-36000), (-32400)], [1990301, 7200, (-32400), (-36000)], [1991097, 7200, (-36000), (-32400)], [1991300, 7200, (-32400), (-36000)], [1992096, 7200, (-36000), (-32400)], [1992299, 7200, (-32400), (-36000)], [1993094, 7200, (-36000), (-32400)], [1993304, 7200, (-32400), (-36000)], [1994093, 7200, (-36000), (-32400)], [1994303, 7200, (-32400), (-36000)], [1995092, 7200, (-36000), (-32400)], [1995302, 7200, (-32400), (-36000)], [1996098, 7200, (-36000), (-32400)], [1996301, 7200, (-32400), (-36000)], [1997096, 7200, (-36000), (-32400)], [1997299, 7200, (-32400), (-36000)], [1998095, 7200, (-36000), (-32400)], [1998298, 7200, (-32400), (-36000)], [1999094, 7200, (-36000), (-32400)], [1999304, 7200, (-32400), (-36000)], [2000093, 7200, (-36000), (-32400)], [2000303, 7200, (-32400), (-36000)], [2001091, 7200, (-36000), (-32400)], [2001301, 7200, (-32400), (-36000)], [2002097, 7200, (-36000), (-32400)], [2002300, 7200, (-32400), (-36000)], [2003096, 7200, (-36000), (-32400)], [2003299, 7200, (-32400), (-36000)], [2004095, 7200, (-36000), (-32400)], [2004305, 7200, (-32400), (-36000)], [2005093, 7200, (-36000), (-32400)], [2005303, 7200, (-32400), (-36000)], [2006092, 7200, (-36000), (-32400)], [2006302, 7200, (-32400), (-36000)], [2007070, 7200, (-36000), (-32400)], [2007308, 7200, (-32400), (-36000)], [2008069, 7200, (-36000), (-32400)], [2008307, 7200, (-32400), (-36000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-36000), (-36000), (-32400)], [11, 1, 7, 7200, 0, 1, (-36000), (-32400), (-36000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameda$__f_America_Adak = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameda$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameda$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameda$.prototype.constructor = $c_Lzonedb_java_tzdb$ameda$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameda$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameda$.prototype = $c_Lzonedb_java_tzdb$ameda$.prototype;
$c_Lzonedb_java_tzdb$ameda$.prototype.America_Adak__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameda$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 554")
  };
  return this.Lzonedb_java_tzdb$ameda$__f_America_Adak
});
var $d_Lzonedb_java_tzdb$ameda$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameda$: 0
}, false, "zonedb.java.tzdb$ameda$", {
  Lzonedb_java_tzdb$ameda$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameda$.prototype.$classData = $d_Lzonedb_java_tzdb$ameda$;
var $n_Lzonedb_java_tzdb$ameda$;
function $m_Lzonedb_java_tzdb$ameda$() {
  if ((!$n_Lzonedb_java_tzdb$ameda$)) {
    $n_Lzonedb_java_tzdb$ameda$ = new $c_Lzonedb_java_tzdb$ameda$()
  };
  return $n_Lzonedb_java_tzdb$ameda$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amede$() {
  this.Lzonedb_java_tzdb$amede$__f_America_Montevideo = null;
  this.Lzonedb_java_tzdb$amede$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amede$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-13491)), $ct_T2__O__O__(new $c_T2(), "w", (-13491)), $ct_T2__O__O__(new $c_T2(), "t", [[1920122, 0, (-13491), (-14400)], [1923274, 0, (-14400), (-12600)], [1942347, 84600, (-12600), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920122, 0, (-13491), (-14400)], [1923274, 0, (-14400), (-10800)], [1924092, 0, (-10800), (-12600)], [1924275, 0, (-12600), (-10800)], [1925091, 0, (-10800), (-12600)], [1925274, 0, (-12600), (-10800)], [1926091, 0, (-10800), (-12600)], [1933302, 0, (-12600), (-10800)], [1934091, 0, (-10800), (-12600)], [1934301, 0, (-12600), (-10800)], [1935090, 0, (-10800), (-12600)], [1935300, 0, (-12600), (-10800)], [1936089, 0, (-10800), (-12600)], [1936299, 0, (-12600), (-10800)], [1937087, 0, (-10800), (-12600)], [1937304, 0, (-12600), (-10800)], [1938086, 0, (-10800), (-12600)], [1938303, 0, (-12600), (-10800)], [1939085, 0, (-10800), (-12600)], [1939274, 0, (-12600), (-10800)], [1940091, 0, (-10800), (-12600)], [1940301, 0, (-12600), (-10800)], [1941089, 0, (-10800), (-12600)], [1941213, 0, (-12600), (-10800)], [1942348, 0, (-10800), (-9000)], [1943073, 0, (-9000), (-10800)], [1959144, 0, (-10800), (-9000)], [1959319, 0, (-9000), (-10800)], [1960017, 0, (-10800), (-7200)], [1960066, 0, (-7200), (-10800)], [1965094, 0, (-10800), (-7200)], [1965269, 0, (-7200), (-10800)], [1968148, 0, (-10800), (-9000)], [1968336, 0, (-9000), (-10800)], [1970115, 0, (-10800), (-7200)], [1970165, 0, (-7200), (-10800)], [1972114, 0, (-10800), (-7200)], [1972198, 0, (-7200), (-10800)], [1974013, 0, (-10800), (-5400)], [1974069, 0, (-5400), (-9000)], [1974244, 0, (-9000), (-10800)], [1974356, 0, (-10800), (-7200)], [1975089, 0, (-7200), (-10800)], [1976354, 0, (-10800), (-7200)], [1977065, 0, (-7200), (-10800)], [1977338, 0, (-10800), (-7200)], [1978064, 0, (-7200), (-10800)], [1978351, 0, (-10800), (-7200)], [1979063, 0, (-7200), (-10800)], [1979119, 0, (-10800), (-7200)], [1980076, 0, (-7200), (-10800)], [1987348, 0, (-10800), (-7200)], [1988059, 0, (-7200), (-10800)], [1988346, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989302, 0, (-10800), (-7200)], [1990056, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-10800)], [1991300, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993059, 0, (-7200), (-10800)], [2004263, 0, (-10800), (-7200)], [2005086, 7200, (-7200), (-10800)], [2005282, 7200, (-10800), (-7200)], [2006071, 7200, (-7200), (-10800)], [2006274, 7200, (-10800), (-7200)], [2007070, 7200, (-7200), (-10800)], [2007280, 7200, (-10800), (-7200)], [2008069, 7200, (-7200), (-10800)], [2008279, 7200, (-10800), (-7200)], [2009067, 7200, (-7200), (-10800)], [2009277, 7200, (-10800), (-7200)], [2010073, 7200, (-7200), (-10800)], [2010276, 7200, (-10800), (-7200)], [2011072, 7200, (-7200), (-10800)], [2011275, 7200, (-10800), (-7200)], [2012071, 7200, (-7200), (-10800)], [2012281, 7200, (-10800), (-7200)], [2013069, 7200, (-7200), (-10800)], [2013279, 7200, (-10800), (-7200)], [2014068, 7200, (-7200), (-10800)], [2014278, 7200, (-10800), (-7200)], [2015067, 7200, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amede$__f_America_Montevideo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amede$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amede$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amede$.prototype.constructor = $c_Lzonedb_java_tzdb$amede$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amede$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amede$.prototype = $c_Lzonedb_java_tzdb$amede$.prototype;
$c_Lzonedb_java_tzdb$amede$.prototype.America_Montevideo__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amede$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 641")
  };
  return this.Lzonedb_java_tzdb$amede$__f_America_Montevideo
});
var $d_Lzonedb_java_tzdb$amede$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amede$: 0
}, false, "zonedb.java.tzdb$amede$", {
  Lzonedb_java_tzdb$amede$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amede$.prototype.$classData = $d_Lzonedb_java_tzdb$amede$;
var $n_Lzonedb_java_tzdb$amede$;
function $m_Lzonedb_java_tzdb$amede$() {
  if ((!$n_Lzonedb_java_tzdb$amede$)) {
    $n_Lzonedb_java_tzdb$amede$ = new $c_Lzonedb_java_tzdb$amede$()
  };
  return $n_Lzonedb_java_tzdb$amede$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amedo$() {
  this.Lzonedb_java_tzdb$amedo$__f_America_El_Salvador = null;
  this.Lzonedb_java_tzdb$amedo$__f_America_Barbados = null;
  this.Lzonedb_java_tzdb$amedo$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amedo$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-21408)), $ct_T2__O__O__(new $c_T2(), "w", (-21408)), $ct_T2__O__O__(new $c_T2(), "t", [[1921001, 0, (-21408), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921001, 0, (-21408), (-21600)], [1987123, 0, (-21600), (-18000)], [1987270, 0, (-18000), (-21600)], [1988122, 0, (-21600), (-18000)], [1988269, 0, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amedo$__f_America_El_Salvador = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amedo$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amedo$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-14309)), $ct_T2__O__O__(new $c_T2(), "w", (-14309)), $ct_T2__O__O__(new $c_T2(), "t", [[1932001, 0, (-14309), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1932001, 0, (-14309), (-14400)], [1977163, 7200, (-14400), (-10800)], [1977275, 7200, (-10800), (-14400)], [1978106, 7200, (-14400), (-10800)], [1978274, 7200, (-10800), (-14400)], [1979105, 7200, (-14400), (-10800)], [1979273, 7200, (-10800), (-14400)], [1980111, 7200, (-14400), (-10800)], [1980269, 7200, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amedo$__f_America_Barbados = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amedo$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amedo$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amedo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amedo$.prototype.constructor = $c_Lzonedb_java_tzdb$amedo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amedo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amedo$.prototype = $c_Lzonedb_java_tzdb$amedo$.prototype;
$c_Lzonedb_java_tzdb$amedo$.prototype.America_El_Salvador__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amedo$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 490")
  };
  return this.Lzonedb_java_tzdb$amedo$__f_America_El_Salvador
});
$c_Lzonedb_java_tzdb$amedo$.prototype.America_Barbados__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amedo$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 491")
  };
  return this.Lzonedb_java_tzdb$amedo$__f_America_Barbados
});
var $d_Lzonedb_java_tzdb$amedo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amedo$: 0
}, false, "zonedb.java.tzdb$amedo$", {
  Lzonedb_java_tzdb$amedo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amedo$.prototype.$classData = $d_Lzonedb_java_tzdb$amedo$;
var $n_Lzonedb_java_tzdb$amedo$;
function $m_Lzonedb_java_tzdb$amedo$() {
  if ((!$n_Lzonedb_java_tzdb$amedo$)) {
    $n_Lzonedb_java_tzdb$amedo$ = new $c_Lzonedb_java_tzdb$amedo$()
  };
  return $n_Lzonedb_java_tzdb$amedo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameea$() {
  this.Lzonedb_java_tzdb$ameea$__f_America_Juneau = null;
  this.Lzonedb_java_tzdb$ameea$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameea$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 54139), $ct_T2__O__O__(new $c_T2(), "w", 54139), $ct_T2__O__O__(new $c_T2(), "t", [[1867292, 56012, 54139, (-32261)], [1900232, 43200, (-32261), (-28800)], [1980118, 7200, (-28800), (-32400)], [1980300, 3600, (-32400), (-28800)], [1983303, 3600, (-28800), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1867292, 56012, 54139, (-32261)], [1900232, 43200, (-32261), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974006, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975054, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameea$__f_America_Juneau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameea$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameea$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameea$.prototype.constructor = $c_Lzonedb_java_tzdb$ameea$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameea$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameea$.prototype = $c_Lzonedb_java_tzdb$ameea$.prototype;
$c_Lzonedb_java_tzdb$ameea$.prototype.America_Juneau__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameea$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 585")
  };
  return this.Lzonedb_java_tzdb$ameea$__f_America_Juneau
});
var $d_Lzonedb_java_tzdb$ameea$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameea$: 0
}, false, "zonedb.java.tzdb$ameea$", {
  Lzonedb_java_tzdb$ameea$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameea$.prototype.$classData = $d_Lzonedb_java_tzdb$ameea$;
var $n_Lzonedb_java_tzdb$ameea$;
function $m_Lzonedb_java_tzdb$ameea$() {
  if ((!$n_Lzonedb_java_tzdb$ameea$)) {
    $n_Lzonedb_java_tzdb$ameea$ = new $c_Lzonedb_java_tzdb$ameea$()
  };
  return $n_Lzonedb_java_tzdb$ameea$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameee$() {
  this.Lzonedb_java_tzdb$ameee$__f_America_Dawson_Creek = null;
  this.Lzonedb_java_tzdb$ameee$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameee$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-28856)), $ct_T2__O__O__(new $c_T2(), "w", (-28856)), $ct_T2__O__O__(new $c_T2(), "t", [[1884001, 0, (-28856), (-28800)], [1972243, 3600, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1884001, 0, (-28856), (-28800)], [1918104, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1947117, 7200, (-28800), (-25200)], [1947271, 7200, (-25200), (-28800)], [1948116, 7200, (-28800), (-25200)], [1948270, 7200, (-25200), (-28800)], [1949114, 7200, (-28800), (-25200)], [1949268, 7200, (-25200), (-28800)], [1950120, 7200, (-28800), (-25200)], [1950267, 7200, (-25200), (-28800)], [1951119, 7200, (-28800), (-25200)], [1951273, 7200, (-25200), (-28800)], [1952118, 7200, (-28800), (-25200)], [1952272, 7200, (-25200), (-28800)], [1953116, 7200, (-28800), (-25200)], [1953270, 7200, (-25200), (-28800)], [1954115, 7200, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 7200, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 7200, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 7200, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 7200, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 7200, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 7200, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1961120, 7200, (-28800), (-25200)], [1961267, 7200, (-25200), (-28800)], [1962119, 7200, (-28800), (-25200)], [1962301, 7200, (-25200), (-28800)], [1963118, 7200, (-28800), (-25200)], [1963300, 7200, (-25200), (-28800)], [1964117, 7200, (-28800), (-25200)], [1964299, 7200, (-25200), (-28800)], [1965115, 7200, (-28800), (-25200)], [1965304, 7200, (-25200), (-28800)], [1966114, 7200, (-28800), (-25200)], [1966303, 7200, (-25200), (-28800)], [1967120, 7200, (-28800), (-25200)], [1967302, 7200, (-25200), (-28800)], [1968119, 7200, (-28800), (-25200)], [1968301, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameee$__f_America_Dawson_Creek = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameee$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameee$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameee$.prototype.constructor = $c_Lzonedb_java_tzdb$ameee$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameee$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameee$.prototype = $c_Lzonedb_java_tzdb$ameee$.prototype;
$c_Lzonedb_java_tzdb$ameee$.prototype.America_Dawson_Creek__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameee$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 774")
  };
  return this.Lzonedb_java_tzdb$ameee$__f_America_Dawson_Creek
});
var $d_Lzonedb_java_tzdb$ameee$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameee$: 0
}, false, "zonedb.java.tzdb$ameee$", {
  Lzonedb_java_tzdb$ameee$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameee$.prototype.$classData = $d_Lzonedb_java_tzdb$ameee$;
var $n_Lzonedb_java_tzdb$ameee$;
function $m_Lzonedb_java_tzdb$ameee$() {
  if ((!$n_Lzonedb_java_tzdb$ameee$)) {
    $n_Lzonedb_java_tzdb$ameee$ = new $c_Lzonedb_java_tzdb$ameee$()
  };
  return $n_Lzonedb_java_tzdb$ameee$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameei$() {
  this.Lzonedb_java_tzdb$ameei$__f_America_Maceio = null;
  this.Lzonedb_java_tzdb$ameei$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameei$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-8572)), $ct_T2__O__O__(new $c_T2(), "w", (-8572)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-8572), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-8572), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1995288, 0, (-10800), (-7200)], [1996042, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2000296, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameei$__f_America_Maceio = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameei$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameei$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameei$.prototype.constructor = $c_Lzonedb_java_tzdb$ameei$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameei$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameei$.prototype = $c_Lzonedb_java_tzdb$ameei$.prototype;
$c_Lzonedb_java_tzdb$ameei$.prototype.America_Maceio__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameei$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 717")
  };
  return this.Lzonedb_java_tzdb$ameei$__f_America_Maceio
});
var $d_Lzonedb_java_tzdb$ameei$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameei$: 0
}, false, "zonedb.java.tzdb$ameei$", {
  Lzonedb_java_tzdb$ameei$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameei$.prototype.$classData = $d_Lzonedb_java_tzdb$ameei$;
var $n_Lzonedb_java_tzdb$ameei$;
function $m_Lzonedb_java_tzdb$ameei$() {
  if ((!$n_Lzonedb_java_tzdb$ameei$)) {
    $n_Lzonedb_java_tzdb$ameei$ = new $c_Lzonedb_java_tzdb$ameei$()
  };
  return $n_Lzonedb_java_tzdb$ameei$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameen$() {
  this.Lzonedb_java_tzdb$ameen$__f_America_Swift_Current = null;
  this.Lzonedb_java_tzdb$ameen$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameen$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-25880)), $ct_T2__O__O__(new $c_T2(), "w", (-25880)), $ct_T2__O__O__(new $c_T2(), "t", [[1905244, 0, (-25880), (-25200)], [1972121, 7200, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1905244, 0, (-25880), (-25200)], [1918104, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1946118, 7200, (-25200), (-21600)], [1946286, 7200, (-21600), (-25200)], [1947117, 7200, (-25200), (-21600)], [1947271, 7200, (-21600), (-25200)], [1948116, 7200, (-25200), (-21600)], [1948270, 7200, (-21600), (-25200)], [1949114, 7200, (-25200), (-21600)], [1949268, 7200, (-21600), (-25200)], [1957118, 7200, (-25200), (-21600)], [1957300, 7200, (-21600), (-25200)], [1959116, 7200, (-25200), (-21600)], [1959298, 7200, (-21600), (-25200)], [1960115, 7200, (-25200), (-21600)], [1960269, 7200, (-21600), (-25200)], [1961120, 7200, (-25200), (-21600)], [1961267, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameen$__f_America_Swift_Current = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameen$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameen$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameen$.prototype.constructor = $c_Lzonedb_java_tzdb$ameen$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameen$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameen$.prototype = $c_Lzonedb_java_tzdb$ameen$.prototype;
$c_Lzonedb_java_tzdb$ameen$.prototype.America_Swift_Current__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameen$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 401")
  };
  return this.Lzonedb_java_tzdb$ameen$__f_America_Swift_Current
});
var $d_Lzonedb_java_tzdb$ameen$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameen$: 0
}, false, "zonedb.java.tzdb$ameen$", {
  Lzonedb_java_tzdb$ameen$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameen$.prototype.$classData = $d_Lzonedb_java_tzdb$ameen$;
var $n_Lzonedb_java_tzdb$ameen$;
function $m_Lzonedb_java_tzdb$ameen$() {
  if ((!$n_Lzonedb_java_tzdb$ameen$)) {
    $n_Lzonedb_java_tzdb$ameen$ = new $c_Lzonedb_java_tzdb$ameen$()
  };
  return $n_Lzonedb_java_tzdb$ameen$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameep$() {
  this.Lzonedb_java_tzdb$ameep$__f_America_Eirunepe = null;
  this.Lzonedb_java_tzdb$ameep$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameep$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-16768)), $ct_T2__O__O__(new $c_T2(), "w", (-16768)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-16768), (-18000)], [2008176, 0, (-18000), (-14400)], [2013314, 0, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-16768), (-18000)], [1931276, 39600, (-18000), (-14400)], [1932092, 0, (-14400), (-18000)], [1932277, 0, (-18000), (-14400)], [1933091, 0, (-14400), (-18000)], [1949335, 0, (-18000), (-14400)], [1950106, 3600, (-14400), (-18000)], [1950335, 0, (-18000), (-14400)], [1951091, 0, (-14400), (-18000)], [1951335, 0, (-18000), (-14400)], [1952092, 0, (-14400), (-18000)], [1952336, 0, (-18000), (-14400)], [1953060, 0, (-14400), (-18000)], [1963343, 0, (-18000), (-14400)], [1964061, 0, (-14400), (-18000)], [1965031, 0, (-18000), (-14400)], [1965090, 0, (-14400), (-18000)], [1965335, 0, (-18000), (-14400)], [1966060, 0, (-14400), (-18000)], [1966305, 0, (-18000), (-14400)], [1967060, 0, (-14400), (-18000)], [1967305, 0, (-18000), (-14400)], [1968061, 0, (-14400), (-18000)], [1985306, 0, (-18000), (-14400)], [1986074, 0, (-14400), (-18000)], [1986298, 0, (-18000), (-14400)], [1987045, 0, (-14400), (-18000)], [1987298, 0, (-18000), (-14400)], [1988038, 0, (-14400), (-18000)], [1993290, 0, (-18000), (-14400)], [1994051, 0, (-14400), (-18000)], [2008176, 0, (-18000), (-14400)], [2013314, 0, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameep$__f_America_Eirunepe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameep$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameep$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameep$.prototype.constructor = $c_Lzonedb_java_tzdb$ameep$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameep$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameep$.prototype = $c_Lzonedb_java_tzdb$ameep$.prototype;
$c_Lzonedb_java_tzdb$ameep$.prototype.America_Eirunepe__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameep$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 527")
  };
  return this.Lzonedb_java_tzdb$ameep$__f_America_Eirunepe
});
var $d_Lzonedb_java_tzdb$ameep$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameep$: 0
}, false, "zonedb.java.tzdb$ameep$", {
  Lzonedb_java_tzdb$ameep$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameep$.prototype.$classData = $d_Lzonedb_java_tzdb$ameep$;
var $n_Lzonedb_java_tzdb$ameep$;
function $m_Lzonedb_java_tzdb$ameep$() {
  if ((!$n_Lzonedb_java_tzdb$ameep$)) {
    $n_Lzonedb_java_tzdb$ameep$ = new $c_Lzonedb_java_tzdb$ameep$()
  };
  return $n_Lzonedb_java_tzdb$ameep$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameez$() {
  this.Lzonedb_java_tzdb$ameez$__f_America_Fortaleza = null;
  this.Lzonedb_java_tzdb$ameez$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameez$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-9240)), $ct_T2__O__O__(new $c_T2(), "w", (-9240)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-9240), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-9240), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2000296, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameez$__f_America_Fortaleza = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameez$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameez$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameez$.prototype.constructor = $c_Lzonedb_java_tzdb$ameez$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameez$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameez$.prototype = $c_Lzonedb_java_tzdb$ameez$.prototype;
$c_Lzonedb_java_tzdb$ameez$.prototype.America_Fortaleza__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameez$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 228")
  };
  return this.Lzonedb_java_tzdb$ameez$__f_America_Fortaleza
});
var $d_Lzonedb_java_tzdb$ameez$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameez$: 0
}, false, "zonedb.java.tzdb$ameez$", {
  Lzonedb_java_tzdb$ameez$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameez$.prototype.$classData = $d_Lzonedb_java_tzdb$ameez$;
var $n_Lzonedb_java_tzdb$ameez$;
function $m_Lzonedb_java_tzdb$ameez$() {
  if ((!$n_Lzonedb_java_tzdb$ameez$)) {
    $n_Lzonedb_java_tzdb$ameez$ = new $c_Lzonedb_java_tzdb$ameez$()
  };
  return $n_Lzonedb_java_tzdb$ameez$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amefa$() {
  this.Lzonedb_java_tzdb$amefa$__f_America_Halifax = null;
  this.Lzonedb_java_tzdb$amefa$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amefa$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-15264)), $ct_T2__O__O__(new $c_T2(), "w", (-15264)), $ct_T2__O__O__(new $c_T2(), "t", [[1902166, 0, (-15264), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1902166, 0, (-15264), (-14400)], [1916092, 0, (-14400), (-10800)], [1916275, 0, (-10800), (-14400)], [1918104, 7200, (-14400), (-10800)], [1918300, 7200, (-10800), (-14400)], [1920130, 0, (-14400), (-10800)], [1920242, 0, (-10800), (-14400)], [1921126, 0, (-14400), (-10800)], [1921248, 0, (-10800), (-14400)], [1922120, 0, (-14400), (-10800)], [1922248, 0, (-10800), (-14400)], [1923126, 0, (-14400), (-10800)], [1923247, 0, (-10800), (-14400)], [1924125, 0, (-14400), (-10800)], [1924259, 0, (-10800), (-14400)], [1925123, 0, (-14400), (-10800)], [1925271, 0, (-10800), (-14400)], [1926136, 0, (-14400), (-10800)], [1926256, 0, (-10800), (-14400)], [1927121, 0, (-14400), (-10800)], [1927269, 0, (-10800), (-14400)], [1928134, 0, (-14400), (-10800)], [1928253, 0, (-10800), (-14400)], [1929132, 0, (-14400), (-10800)], [1929246, 0, (-10800), (-14400)], [1930131, 0, (-14400), (-10800)], [1930258, 0, (-10800), (-14400)], [1931130, 0, (-14400), (-10800)], [1931271, 0, (-10800), (-14400)], [1932122, 0, (-14400), (-10800)], [1932270, 0, (-10800), (-14400)], [1933120, 0, (-14400), (-10800)], [1933275, 0, (-10800), (-14400)], [1934140, 0, (-14400), (-10800)], [1934259, 0, (-10800), (-14400)], [1935153, 0, (-14400), (-10800)], [1935273, 0, (-10800), (-14400)], [1936153, 0, (-14400), (-10800)], [1936258, 0, (-10800), (-14400)], [1937122, 0, (-14400), (-10800)], [1937270, 0, (-10800), (-14400)], [1938121, 0, (-14400), (-10800)], [1938269, 0, (-10800), (-14400)], [1939148, 0, (-14400), (-10800)], [1939268, 0, (-10800), (-14400)], [1940126, 0, (-14400), (-10800)], [1940274, 0, (-10800), (-14400)], [1941124, 0, (-14400), (-10800)], [1941272, 0, (-10800), (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)], [1946118, 7200, (-14400), (-10800)], [1946272, 7200, (-10800), (-14400)], [1947117, 7200, (-14400), (-10800)], [1947271, 7200, (-10800), (-14400)], [1948116, 7200, (-14400), (-10800)], [1948270, 7200, (-10800), (-14400)], [1949114, 7200, (-14400), (-10800)], [1949268, 7200, (-10800), (-14400)], [1951119, 7200, (-14400), (-10800)], [1951273, 7200, (-10800), (-14400)], [1952118, 7200, (-14400), (-10800)], [1952272, 7200, (-10800), (-14400)], [1953116, 7200, (-14400), (-10800)], [1953270, 7200, (-10800), (-14400)], [1954115, 7200, (-14400), (-10800)], [1954269, 7200, (-10800), (-14400)], [1956120, 7200, (-14400), (-10800)], [1956274, 7200, (-10800), (-14400)], [1957118, 7200, (-14400), (-10800)], [1957272, 7200, (-10800), (-14400)], [1958117, 7200, (-14400), (-10800)], [1958271, 7200, (-10800), (-14400)], [1959116, 7200, (-14400), (-10800)], [1959270, 7200, (-10800), (-14400)], [1962119, 7200, (-14400), (-10800)], [1962301, 7200, (-10800), (-14400)], [1963118, 7200, (-14400), (-10800)], [1963300, 7200, (-10800), (-14400)], [1964117, 7200, (-14400), (-10800)], [1964299, 7200, (-10800), (-14400)], [1965115, 7200, (-14400), (-10800)], [1965304, 7200, (-10800), (-14400)], [1966114, 7200, (-14400), (-10800)], [1966303, 7200, (-10800), (-14400)], [1967120, 7200, (-14400), (-10800)], [1967302, 7200, (-10800), (-14400)], [1968119, 7200, (-14400), (-10800)], [1968301, 7200, (-10800), (-14400)], [1969117, 7200, (-14400), (-10800)], [1969299, 7200, (-10800), (-14400)], [1970116, 7200, (-14400), (-10800)], [1970298, 7200, (-10800), (-14400)], [1971115, 7200, (-14400), (-10800)], [1971304, 7200, (-10800), (-14400)], [1972121, 7200, (-14400), (-10800)], [1972303, 7200, (-10800), (-14400)], [1973119, 7200, (-14400), (-10800)], [1973301, 7200, (-10800), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995092, 7200, (-14400), (-10800)], [1995302, 7200, (-10800), (-14400)], [1996098, 7200, (-14400), (-10800)], [1996301, 7200, (-10800), (-14400)], [1997096, 7200, (-14400), (-10800)], [1997299, 7200, (-10800), (-14400)], [1998095, 7200, (-14400), (-10800)], [1998298, 7200, (-10800), (-14400)], [1999094, 7200, (-14400), (-10800)], [1999304, 7200, (-10800), (-14400)], [2000093, 7200, (-14400), (-10800)], [2000303, 7200, (-10800), (-14400)], [2001091, 7200, (-14400), (-10800)], [2001301, 7200, (-10800), (-14400)], [2002097, 7200, (-14400), (-10800)], [2002300, 7200, (-10800), (-14400)], [2003096, 7200, (-14400), (-10800)], [2003299, 7200, (-10800), (-14400)], [2004095, 7200, (-14400), (-10800)], [2004305, 7200, (-10800), (-14400)], [2005093, 7200, (-14400), (-10800)], [2005303, 7200, (-10800), (-14400)], [2006092, 7200, (-14400), (-10800)], [2006302, 7200, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amefa$__f_America_Halifax = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amefa$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amefa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amefa$.prototype.constructor = $c_Lzonedb_java_tzdb$amefa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amefa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amefa$.prototype = $c_Lzonedb_java_tzdb$amefa$.prototype;
$c_Lzonedb_java_tzdb$amefa$.prototype.America_Halifax__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amefa$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 750")
  };
  return this.Lzonedb_java_tzdb$amefa$__f_America_Halifax
});
var $d_Lzonedb_java_tzdb$amefa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amefa$: 0
}, false, "zonedb.java.tzdb$amefa$", {
  Lzonedb_java_tzdb$amefa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amefa$.prototype.$classData = $d_Lzonedb_java_tzdb$amefa$;
var $n_Lzonedb_java_tzdb$amefa$;
function $m_Lzonedb_java_tzdb$amefa$() {
  if ((!$n_Lzonedb_java_tzdb$amefa$)) {
    $n_Lzonedb_java_tzdb$amefa$ = new $c_Lzonedb_java_tzdb$amefa$()
  };
  return $n_Lzonedb_java_tzdb$amefa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amego$() {
  this.Lzonedb_java_tzdb$amego$__f_America_Nipigon = null;
  this.Lzonedb_java_tzdb$amego$__f_America_Argentina_Rio_Gallegos = null;
  this.Lzonedb_java_tzdb$amego$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amego$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-21184)), $ct_T2__O__O__(new $c_T2(), "w", (-21184)), $ct_T2__O__O__(new $c_T2(), "t", [[1895001, 0, (-21184), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895001, 0, (-21184), (-18000)], [1918104, 7200, (-18000), (-14400)], [1918300, 7200, (-14400), (-18000)], [1940273, 0, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1974118, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amego$__f_America_Nipigon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amego$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amego$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-16612)), $ct_T2__O__O__(new $c_T2(), "w", (-16612)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-16612), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-16612), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amego$__f_America_Argentina_Rio_Gallegos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amego$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amego$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amego$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amego$.prototype.constructor = $c_Lzonedb_java_tzdb$amego$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amego$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amego$.prototype = $c_Lzonedb_java_tzdb$amego$.prototype;
$c_Lzonedb_java_tzdb$amego$.prototype.America_Nipigon__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amego$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 310")
  };
  return this.Lzonedb_java_tzdb$amego$__f_America_Nipigon
});
$c_Lzonedb_java_tzdb$amego$.prototype.America_Argentina_Rio_Gallegos__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amego$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 311")
  };
  return this.Lzonedb_java_tzdb$amego$__f_America_Argentina_Rio_Gallegos
});
var $d_Lzonedb_java_tzdb$amego$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amego$: 0
}, false, "zonedb.java.tzdb$amego$", {
  Lzonedb_java_tzdb$amego$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amego$.prototype.$classData = $d_Lzonedb_java_tzdb$amego$;
var $n_Lzonedb_java_tzdb$amego$;
function $m_Lzonedb_java_tzdb$amego$() {
  if ((!$n_Lzonedb_java_tzdb$amego$)) {
    $n_Lzonedb_java_tzdb$amego$ = new $c_Lzonedb_java_tzdb$amego$()
  };
  return $n_Lzonedb_java_tzdb$amego$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amegu$() {
  this.Lzonedb_java_tzdb$amegu$__f_America_Managua = null;
  this.Lzonedb_java_tzdb$amegu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amegu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-20708)), $ct_T2__O__O__(new $c_T2(), "w", (-20708)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-20708), (-20712)], [1934174, 0, (-20712), (-21600)], [1973121, 0, (-21600), (-18000)], [1975047, 0, (-18000), (-21600)], [1992001, 14400, (-21600), (-18000)], [1992268, 0, (-18000), (-21600)], [1993001, 0, (-21600), (-18000)], [1997001, 0, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-20708), (-20712)], [1934174, 0, (-20712), (-21600)], [1973121, 0, (-21600), (-18000)], [1975047, 0, (-18000), (-21600)], [1979077, 0, (-21600), (-18000)], [1979176, 0, (-18000), (-21600)], [1980076, 0, (-21600), (-18000)], [1980175, 0, (-18000), (-21600)], [1992001, 14400, (-21600), (-18000)], [1992268, 0, (-18000), (-21600)], [1993001, 0, (-21600), (-18000)], [1997001, 0, (-18000), (-21600)], [2005100, 0, (-21600), (-18000)], [2005275, 0, (-18000), (-21600)], [2006120, 7200, (-21600), (-18000)], [2006274, 3600, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amegu$__f_America_Managua = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amegu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amegu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amegu$.prototype.constructor = $c_Lzonedb_java_tzdb$amegu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amegu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amegu$.prototype = $c_Lzonedb_java_tzdb$amegu$.prototype;
$c_Lzonedb_java_tzdb$amegu$.prototype.America_Managua__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amegu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 686")
  };
  return this.Lzonedb_java_tzdb$amegu$__f_America_Managua
});
var $d_Lzonedb_java_tzdb$amegu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amegu$: 0
}, false, "zonedb.java.tzdb$amegu$", {
  Lzonedb_java_tzdb$amegu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amegu$.prototype.$classData = $d_Lzonedb_java_tzdb$amegu$;
var $n_Lzonedb_java_tzdb$amegu$;
function $m_Lzonedb_java_tzdb$amegu$() {
  if ((!$n_Lzonedb_java_tzdb$amegu$)) {
    $n_Lzonedb_java_tzdb$amegu$ = new $c_Lzonedb_java_tzdb$amegu$()
  };
  return $n_Lzonedb_java_tzdb$amegu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameha$() {
  this.Lzonedb_java_tzdb$ameha$__f_America_Godthab = null;
  this.Lzonedb_java_tzdb$ameha$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameha$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-12416)), $ct_T2__O__O__(new $c_T2(), "w", (-12416)), $ct_T2__O__O__(new $c_T2(), "t", [[1916210, 0, (-12416), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1916210, 0, (-12416), (-10800)], [1980097, 7200, (-10800), (-7200)], [1980271, 82800, (-7200), (-10800)], [1981087, 79200, (-10800), (-7200)], [1981269, 82800, (-7200), (-10800)], [1982086, 79200, (-10800), (-7200)], [1982268, 82800, (-7200), (-10800)], [1983085, 79200, (-10800), (-7200)], [1983267, 82800, (-7200), (-10800)], [1984084, 79200, (-10800), (-7200)], [1984273, 82800, (-7200), (-10800)], [1985089, 79200, (-10800), (-7200)], [1985271, 82800, (-7200), (-10800)], [1986088, 79200, (-10800), (-7200)], [1986270, 82800, (-7200), (-10800)], [1987087, 79200, (-10800), (-7200)], [1987269, 82800, (-7200), (-10800)], [1988086, 79200, (-10800), (-7200)], [1988268, 82800, (-7200), (-10800)], [1989084, 79200, (-10800), (-7200)], [1989266, 82800, (-7200), (-10800)], [1990083, 79200, (-10800), (-7200)], [1990272, 82800, (-7200), (-10800)], [1991089, 79200, (-10800), (-7200)], [1991271, 82800, (-7200), (-10800)], [1992088, 79200, (-10800), (-7200)], [1992270, 82800, (-7200), (-10800)], [1993086, 79200, (-10800), (-7200)], [1993268, 82800, (-7200), (-10800)], [1994085, 79200, (-10800), (-7200)], [1994267, 82800, (-7200), (-10800)], [1995084, 79200, (-10800), (-7200)], [1995266, 82800, (-7200), (-10800)], [1996090, 79200, (-10800), (-7200)], [1996300, 82800, (-7200), (-10800)], [1997088, 79200, (-10800), (-7200)], [1997298, 82800, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, (-10800), (-10800), (-7200)], [10, 25, 7, 3600, 0, 0, (-10800), (-7200), (-10800)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameha$__f_America_Godthab = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameha$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameha$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameha$.prototype.constructor = $c_Lzonedb_java_tzdb$ameha$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameha$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameha$.prototype = $c_Lzonedb_java_tzdb$ameha$.prototype;
$c_Lzonedb_java_tzdb$ameha$.prototype.America_Godthab__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameha$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 596")
  };
  return this.Lzonedb_java_tzdb$ameha$__f_America_Godthab
});
var $d_Lzonedb_java_tzdb$ameha$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameha$: 0
}, false, "zonedb.java.tzdb$ameha$", {
  Lzonedb_java_tzdb$ameha$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameha$.prototype.$classData = $d_Lzonedb_java_tzdb$ameha$;
var $n_Lzonedb_java_tzdb$ameha$;
function $m_Lzonedb_java_tzdb$ameha$() {
  if ((!$n_Lzonedb_java_tzdb$ameha$)) {
    $n_Lzonedb_java_tzdb$ameha$ = new $c_Lzonedb_java_tzdb$ameha$()
  };
  return $n_Lzonedb_java_tzdb$ameha$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amehi$() {
  this.Lzonedb_java_tzdb$amehi$__f_America_Bahia = null;
  this.Lzonedb_java_tzdb$amehi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amehi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-9244)), $ct_T2__O__O__(new $c_T2(), "w", (-9244)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-9244), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-9244), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991048, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992040, 0, (-7200), (-10800)], [1992299, 0, (-10800), (-7200)], [1993031, 0, (-7200), (-10800)], [1993290, 0, (-10800), (-7200)], [1994051, 0, (-7200), (-10800)], [1994289, 0, (-10800), (-7200)], [1995050, 0, (-7200), (-10800)], [1995288, 0, (-10800), (-7200)], [1996042, 0, (-7200), (-10800)], [1996280, 0, (-10800), (-7200)], [1997047, 0, (-7200), (-10800)], [1997279, 0, (-10800), (-7200)], [1998060, 0, (-7200), (-10800)], [1998284, 0, (-10800), (-7200)], [1999052, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2001049, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)], [2002307, 0, (-10800), (-7200)], [2003047, 0, (-7200), (-10800)], [2011289, 0, (-10800), (-7200)], [2012057, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amehi$__f_America_Bahia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amehi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amehi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amehi$.prototype.constructor = $c_Lzonedb_java_tzdb$amehi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amehi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amehi$.prototype = $c_Lzonedb_java_tzdb$amehi$.prototype;
$c_Lzonedb_java_tzdb$amehi$.prototype.America_Bahia__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amehi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 41")
  };
  return this.Lzonedb_java_tzdb$amehi$__f_America_Bahia
});
var $d_Lzonedb_java_tzdb$amehi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amehi$: 0
}, false, "zonedb.java.tzdb$amehi$", {
  Lzonedb_java_tzdb$amehi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amehi$.prototype.$classData = $d_Lzonedb_java_tzdb$amehi$;
var $n_Lzonedb_java_tzdb$amehi$;
function $m_Lzonedb_java_tzdb$amehi$() {
  if ((!$n_Lzonedb_java_tzdb$amehi$)) {
    $n_Lzonedb_java_tzdb$amehi$ = new $c_Lzonedb_java_tzdb$amehi$()
  };
  return $n_Lzonedb_java_tzdb$amehi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amehn$() {
  this.Lzonedb_java_tzdb$amehn$__f_America_St_Johns = null;
  this.Lzonedb_java_tzdb$amehn$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amehn$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-12652)), $ct_T2__O__O__(new $c_T2(), "w", (-12652)), $ct_T2__O__O__(new $c_T2(), "t", [[1935089, 0, (-12652), (-12600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1917098, 7200, (-12652), (-9052)], [1917260, 7200, (-9052), (-12652)], [1918104, 7200, (-12652), (-9052)], [1918300, 7200, (-9052), (-12652)], [1919125, 82800, (-12652), (-9052)], [1919224, 82800, (-9052), (-12652)], [1920123, 82800, (-12652), (-9052)], [1920305, 82800, (-9052), (-12652)], [1921121, 82800, (-12652), (-9052)], [1921303, 82800, (-9052), (-12652)], [1922127, 82800, (-12652), (-9052)], [1922302, 82800, (-9052), (-12652)], [1923126, 82800, (-12652), (-9052)], [1923301, 82800, (-9052), (-12652)], [1924125, 82800, (-12652), (-9052)], [1924300, 82800, (-9052), (-12652)], [1925123, 82800, (-12652), (-9052)], [1925298, 82800, (-9052), (-12652)], [1926122, 82800, (-12652), (-9052)], [1926304, 82800, (-9052), (-12652)], [1927121, 82800, (-12652), (-9052)], [1927303, 82800, (-9052), (-12652)], [1928127, 82800, (-12652), (-9052)], [1928302, 82800, (-9052), (-12652)], [1929125, 82800, (-12652), (-9052)], [1929300, 82800, (-9052), (-12652)], [1930124, 82800, (-12652), (-9052)], [1930299, 82800, (-9052), (-12652)], [1931123, 82800, (-12652), (-9052)], [1931298, 82800, (-9052), (-12652)], [1932122, 82800, (-12652), (-9052)], [1932304, 82800, (-9052), (-12652)], [1933127, 82800, (-12652), (-9052)], [1933302, 82800, (-9052), (-12652)], [1934126, 82800, (-12652), (-9052)], [1934301, 82800, (-9052), (-12652)], [1935089, 0, (-12652), (-12600)], [1935125, 82800, (-12600), (-9000)], [1935300, 82800, (-9000), (-12600)], [1936132, 0, (-12600), (-9000)], [1936279, 0, (-9000), (-12600)], [1937130, 0, (-12600), (-9000)], [1937277, 0, (-9000), (-12600)], [1938129, 0, (-12600), (-9000)], [1938276, 0, (-9000), (-12600)], [1939135, 0, (-12600), (-9000)], [1939275, 0, (-9000), (-12600)], [1940134, 0, (-12600), (-9000)], [1940281, 0, (-9000), (-12600)], [1941132, 0, (-12600), (-9000)], [1941279, 0, (-9000), (-12600)], [1942131, 0, (-12600), (-9000)], [1945273, 7200, (-9000), (-12600)], [1946132, 7200, (-12600), (-9000)], [1946279, 7200, (-9000), (-12600)], [1947131, 7200, (-12600), (-9000)], [1947278, 7200, (-9000), (-12600)], [1948130, 7200, (-12600), (-9000)], [1948277, 7200, (-9000), (-12600)], [1949128, 7200, (-12600), (-9000)], [1949275, 7200, (-9000), (-12600)], [1950134, 7200, (-12600), (-9000)], [1950281, 7200, (-9000), (-12600)], [1951119, 7200, (-12600), (-9000)], [1951273, 7200, (-9000), (-12600)], [1952118, 7200, (-12600), (-9000)], [1952272, 7200, (-9000), (-12600)], [1953116, 7200, (-12600), (-9000)], [1953270, 7200, (-9000), (-12600)], [1954115, 7200, (-12600), (-9000)], [1954269, 7200, (-9000), (-12600)], [1955114, 7200, (-12600), (-9000)], [1955268, 7200, (-9000), (-12600)], [1956120, 7200, (-12600), (-9000)], [1956274, 7200, (-9000), (-12600)], [1957118, 7200, (-12600), (-9000)], [1957272, 7200, (-9000), (-12600)], [1958117, 7200, (-12600), (-9000)], [1958271, 7200, (-9000), (-12600)], [1959116, 7200, (-12600), (-9000)], [1959270, 7200, (-9000), (-12600)], [1960115, 7200, (-12600), (-9000)], [1960304, 7200, (-9000), (-12600)], [1961120, 7200, (-12600), (-9000)], [1961302, 7200, (-9000), (-12600)], [1962119, 7200, (-12600), (-9000)], [1962301, 7200, (-9000), (-12600)], [1963118, 7200, (-12600), (-9000)], [1963300, 7200, (-9000), (-12600)], [1964117, 7200, (-12600), (-9000)], [1964299, 7200, (-9000), (-12600)], [1965115, 7200, (-12600), (-9000)], [1965304, 7200, (-9000), (-12600)], [1966114, 7200, (-12600), (-9000)], [1966303, 7200, (-9000), (-12600)], [1967120, 7200, (-12600), (-9000)], [1967302, 7200, (-9000), (-12600)], [1968119, 7200, (-12600), (-9000)], [1968301, 7200, (-9000), (-12600)], [1969117, 7200, (-12600), (-9000)], [1969299, 7200, (-9000), (-12600)], [1970116, 7200, (-12600), (-9000)], [1970298, 7200, (-9000), (-12600)], [1971115, 7200, (-12600), (-9000)], [1971304, 7200, (-9000), (-12600)], [1972121, 7200, (-12600), (-9000)], [1972303, 7200, (-9000), (-12600)], [1973119, 7200, (-12600), (-9000)], [1973301, 7200, (-9000), (-12600)], [1974118, 7200, (-12600), (-9000)], [1974300, 7200, (-9000), (-12600)], [1975117, 7200, (-12600), (-9000)], [1975299, 7200, (-9000), (-12600)], [1976116, 7200, (-12600), (-9000)], [1976305, 7200, (-9000), (-12600)], [1977114, 7200, (-12600), (-9000)], [1977303, 7200, (-9000), (-12600)], [1978120, 7200, (-12600), (-9000)], [1978302, 7200, (-9000), (-12600)], [1979119, 7200, (-12600), (-9000)], [1979301, 7200, (-9000), (-12600)], [1980118, 7200, (-12600), (-9000)], [1980300, 7200, (-9000), (-12600)], [1981116, 7200, (-12600), (-9000)], [1981298, 7200, (-9000), (-12600)], [1982115, 7200, (-12600), (-9000)], [1982304, 7200, (-9000), (-12600)], [1983114, 7200, (-12600), (-9000)], [1983303, 7200, (-9000), (-12600)], [1984120, 7200, (-12600), (-9000)], [1984302, 7200, (-9000), (-12600)], [1985118, 7200, (-12600), (-9000)], [1985300, 7200, (-9000), (-12600)], [1986117, 7200, (-12600), (-9000)], [1986299, 7200, (-9000), (-12600)], [1987095, 60, (-12600), (-9000)], [1987298, 60, (-9000), (-12600)], [1988094, 60, (-12600), (-5400)], [1988304, 60, (-5400), (-12600)], [1989092, 60, (-12600), (-9000)], [1989302, 60, (-9000), (-12600)], [1990091, 60, (-12600), (-9000)], [1990301, 60, (-9000), (-12600)], [1991097, 60, (-12600), (-9000)], [1991300, 60, (-9000), (-12600)], [1992096, 60, (-12600), (-9000)], [1992299, 60, (-9000), (-12600)], [1993094, 60, (-12600), (-9000)], [1993304, 60, (-9000), (-12600)], [1994093, 60, (-12600), (-9000)], [1994303, 60, (-9000), (-12600)], [1995092, 60, (-12600), (-9000)], [1995302, 60, (-9000), (-12600)], [1996098, 60, (-12600), (-9000)], [1996301, 60, (-9000), (-12600)], [1997096, 60, (-12600), (-9000)], [1997299, 60, (-9000), (-12600)], [1998095, 60, (-12600), (-9000)], [1998298, 60, (-9000), (-12600)], [1999094, 60, (-12600), (-9000)], [1999304, 60, (-9000), (-12600)], [2000093, 60, (-12600), (-9000)], [2000303, 60, (-9000), (-12600)], [2001091, 60, (-12600), (-9000)], [2001301, 60, (-9000), (-12600)], [2002097, 60, (-12600), (-9000)], [2002300, 60, (-9000), (-12600)], [2003096, 60, (-12600), (-9000)], [2003299, 60, (-9000), (-12600)], [2004095, 60, (-12600), (-9000)], [2004305, 60, (-9000), (-12600)], [2005093, 60, (-12600), (-9000)], [2005303, 60, (-9000), (-12600)], [2006092, 60, (-12600), (-9000)], [2006302, 60, (-9000), (-12600)], [2007070, 60, (-12600), (-9000)], [2007308, 60, (-9000), (-12600)], [2008069, 60, (-12600), (-9000)], [2008307, 60, (-9000), (-12600)], [2009067, 60, (-12600), (-9000)], [2009305, 60, (-9000), (-12600)], [2010073, 60, (-12600), (-9000)], [2010311, 60, (-9000), (-12600)], [2011072, 60, (-12600), (-9000)], [2011310, 7200, (-9000), (-12600)], [2012071, 7200, (-12600), (-9000)], [2012309, 7200, (-9000), (-12600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-12600), (-12600), (-9000)], [11, 1, 7, 7200, 0, 1, (-12600), (-9000), (-12600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amehn$__f_America_St_Johns = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amehn$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amehn$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amehn$.prototype.constructor = $c_Lzonedb_java_tzdb$amehn$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amehn$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amehn$.prototype = $c_Lzonedb_java_tzdb$amehn$.prototype;
$c_Lzonedb_java_tzdb$amehn$.prototype.America_St_Johns__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amehn$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 79")
  };
  return this.Lzonedb_java_tzdb$amehn$__f_America_St_Johns
});
var $d_Lzonedb_java_tzdb$amehn$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amehn$: 0
}, false, "zonedb.java.tzdb$amehn$", {
  Lzonedb_java_tzdb$amehn$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amehn$.prototype.$classData = $d_Lzonedb_java_tzdb$amehn$;
var $n_Lzonedb_java_tzdb$amehn$;
function $m_Lzonedb_java_tzdb$amehn$() {
  if ((!$n_Lzonedb_java_tzdb$amehn$)) {
    $n_Lzonedb_java_tzdb$amehn$ = new $c_Lzonedb_java_tzdb$amehn$()
  };
  return $n_Lzonedb_java_tzdb$amehn$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amehu$() {
  this.Lzonedb_java_tzdb$amehu$__f_America_Chihuahua = null;
  this.Lzonedb_java_tzdb$amehu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amehu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-25460)), $ct_T2__O__O__(new $c_T2(), "w", (-25460)), $ct_T2__O__O__(new $c_T2(), "t", [[1921365, 86140, (-25460), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1998095, 10800, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921365, 86140, (-25460), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001126, 7200, (-25200), (-21600)], [2001273, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [10, 25, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amehu$__f_America_Chihuahua = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amehu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amehu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amehu$.prototype.constructor = $c_Lzonedb_java_tzdb$amehu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amehu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amehu$.prototype = $c_Lzonedb_java_tzdb$amehu$.prototype;
$c_Lzonedb_java_tzdb$amehu$.prototype.America_Chihuahua__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amehu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 404")
  };
  return this.Lzonedb_java_tzdb$amehu$__f_America_Chihuahua
});
var $d_Lzonedb_java_tzdb$amehu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amehu$: 0
}, false, "zonedb.java.tzdb$amehu$", {
  Lzonedb_java_tzdb$amehu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amehu$.prototype.$classData = $d_Lzonedb_java_tzdb$amehu$;
var $n_Lzonedb_java_tzdb$amehu$;
function $m_Lzonedb_java_tzdb$amehu$() {
  if ((!$n_Lzonedb_java_tzdb$amehu$)) {
    $n_Lzonedb_java_tzdb$amehu$ = new $c_Lzonedb_java_tzdb$amehu$()
  };
  return $n_Lzonedb_java_tzdb$amehu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameib$() {
  this.Lzonedb_java_tzdb$ameib$__f_America_Paramaribo = null;
  this.Lzonedb_java_tzdb$ameib$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameib$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-13240)), $ct_T2__O__O__(new $c_T2(), "w", (-13240)), $ct_T2__O__O__(new $c_T2(), "t", [[1911001, 0, (-13240), (-13252)], [1935001, 0, (-13252), (-13236)], [1945274, 0, (-13236), (-12600)], [1984275, 0, (-12600), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1911001, 0, (-13240), (-13252)], [1935001, 0, (-13252), (-13236)], [1945274, 0, (-13236), (-12600)], [1984275, 0, (-12600), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameib$__f_America_Paramaribo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameib$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameib$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameib$.prototype.constructor = $c_Lzonedb_java_tzdb$ameib$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameib$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameib$.prototype = $c_Lzonedb_java_tzdb$ameib$.prototype;
$c_Lzonedb_java_tzdb$ameib$.prototype.America_Paramaribo__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameib$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 454")
  };
  return this.Lzonedb_java_tzdb$ameib$__f_America_Paramaribo
});
var $d_Lzonedb_java_tzdb$ameib$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameib$: 0
}, false, "zonedb.java.tzdb$ameib$", {
  Lzonedb_java_tzdb$ameib$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameib$.prototype.$classData = $d_Lzonedb_java_tzdb$ameib$;
var $n_Lzonedb_java_tzdb$ameib$;
function $m_Lzonedb_java_tzdb$ameib$() {
  if ((!$n_Lzonedb_java_tzdb$ameib$)) {
    $n_Lzonedb_java_tzdb$ameib$ = new $c_Lzonedb_java_tzdb$ameib$()
  };
  return $n_Lzonedb_java_tzdb$ameib$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameic$() {
  this.Lzonedb_java_tzdb$ameic$__f_America_Puerto_Rico = null;
  this.Lzonedb_java_tzdb$ameic$__f_America_Jamaica = null;
  this.Lzonedb_java_tzdb$ameic$__f_America_Costa_Rica = null;
  this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameic$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-15865)), $ct_T2__O__O__(new $c_T2(), "w", (-15865)), $ct_T2__O__O__(new $c_T2(), "t", [[1899087, 43200, (-15865), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1899087, 43200, (-15865), (-14400)], [1942123, 0, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameic$__f_America_Puerto_Rico = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-18430)), $ct_T2__O__O__(new $c_T2(), "w", (-18430)), $ct_T2__O__O__(new $c_T2(), "t", [[1912032, 0, (-18430), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912032, 0, (-18430), (-18000)], [1974006, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975054, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameic$__f_America_Jamaica = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-20173)), $ct_T2__O__O__(new $c_T2(), "w", (-20173)), $ct_T2__O__O__(new $c_T2(), "t", [[1921015, 0, (-20173), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921015, 0, (-20173), (-21600)], [1979056, 0, (-21600), (-18000)], [1979154, 0, (-18000), (-21600)], [1980055, 0, (-21600), (-18000)], [1980153, 0, (-18000), (-21600)], [1991019, 0, (-21600), (-18000)], [1991182, 0, (-18000), (-21600)], [1992018, 0, (-21600), (-18000)], [1992075, 0, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$ameic$__f_America_Costa_Rica = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameic$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameic$.prototype.constructor = $c_Lzonedb_java_tzdb$ameic$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameic$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameic$.prototype = $c_Lzonedb_java_tzdb$ameic$.prototype;
$c_Lzonedb_java_tzdb$ameic$.prototype.America_Puerto_Rico__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 172")
  };
  return this.Lzonedb_java_tzdb$ameic$__f_America_Puerto_Rico
});
$c_Lzonedb_java_tzdb$ameic$.prototype.America_Jamaica__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 173")
  };
  return this.Lzonedb_java_tzdb$ameic$__f_America_Jamaica
});
$c_Lzonedb_java_tzdb$ameic$.prototype.America_Costa_Rica__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$ameic$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 174")
  };
  return this.Lzonedb_java_tzdb$ameic$__f_America_Costa_Rica
});
var $d_Lzonedb_java_tzdb$ameic$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameic$: 0
}, false, "zonedb.java.tzdb$ameic$", {
  Lzonedb_java_tzdb$ameic$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameic$.prototype.$classData = $d_Lzonedb_java_tzdb$ameic$;
var $n_Lzonedb_java_tzdb$ameic$;
function $m_Lzonedb_java_tzdb$ameic$() {
  if ((!$n_Lzonedb_java_tzdb$ameic$)) {
    $n_Lzonedb_java_tzdb$ameic$ = new $c_Lzonedb_java_tzdb$ameic$()
  };
  return $n_Lzonedb_java_tzdb$ameic$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameid$() {
  this.Lzonedb_java_tzdb$ameid$__f_America_Merida = null;
  this.Lzonedb_java_tzdb$ameid$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameid$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-21508)), $ct_T2__O__O__(new $c_T2(), "w", (-21508)), $ct_T2__O__O__(new $c_T2(), "t", [[1922001, 92, (-21508), (-21600)], [1981357, 0, (-21600), (-18000)], [1982336, 0, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1922001, 92, (-21508), (-21600)], [1981357, 0, (-21600), (-18000)], [1982336, 0, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [10, 25, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameid$__f_America_Merida = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameid$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameid$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameid$.prototype.constructor = $c_Lzonedb_java_tzdb$ameid$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameid$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameid$.prototype = $c_Lzonedb_java_tzdb$ameid$.prototype;
$c_Lzonedb_java_tzdb$ameid$.prototype.America_Merida__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameid$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 908")
  };
  return this.Lzonedb_java_tzdb$ameid$__f_America_Merida
});
var $d_Lzonedb_java_tzdb$ameid$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameid$: 0
}, false, "zonedb.java.tzdb$ameid$", {
  Lzonedb_java_tzdb$ameid$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameid$.prototype.$classData = $d_Lzonedb_java_tzdb$ameid$;
var $n_Lzonedb_java_tzdb$ameid$;
function $m_Lzonedb_java_tzdb$ameid$() {
  if ((!$n_Lzonedb_java_tzdb$ameid$)) {
    $n_Lzonedb_java_tzdb$ameid$ = new $c_Lzonedb_java_tzdb$ameid$()
  };
  return $n_Lzonedb_java_tzdb$ameid$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameif$() {
  this.Lzonedb_java_tzdb$ameif$__f_America_Recife = null;
  this.Lzonedb_java_tzdb$ameif$__f_America_Yellowknife = null;
  this.Lzonedb_java_tzdb$ameif$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameif$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-8376)), $ct_T2__O__O__(new $c_T2(), "w", (-8376)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-8376), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-8376), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2000289, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameif$__f_America_Recife = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameif$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameif$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1935001, 0, 0, (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1935001, 0, 0, (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1965115, 0, (-25200), (-18000)], [1965304, 7200, (-18000), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameif$__f_America_Yellowknife = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameif$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameif$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameif$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameif$.prototype.constructor = $c_Lzonedb_java_tzdb$ameif$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameif$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameif$.prototype = $c_Lzonedb_java_tzdb$ameif$.prototype;
$c_Lzonedb_java_tzdb$ameif$.prototype.America_Recife__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameif$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 644")
  };
  return this.Lzonedb_java_tzdb$ameif$__f_America_Recife
});
$c_Lzonedb_java_tzdb$ameif$.prototype.America_Yellowknife__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameif$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 645")
  };
  return this.Lzonedb_java_tzdb$ameif$__f_America_Yellowknife
});
var $d_Lzonedb_java_tzdb$ameif$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameif$: 0
}, false, "zonedb.java.tzdb$ameif$", {
  Lzonedb_java_tzdb$ameif$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameif$.prototype.$classData = $d_Lzonedb_java_tzdb$ameif$;
var $n_Lzonedb_java_tzdb$ameif$;
function $m_Lzonedb_java_tzdb$ameif$() {
  if ((!$n_Lzonedb_java_tzdb$ameif$)) {
    $n_Lzonedb_java_tzdb$ameif$ = new $c_Lzonedb_java_tzdb$ameif$()
  };
  return $n_Lzonedb_java_tzdb$ameif$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameim$() {
  this.Lzonedb_java_tzdb$ameim$__f_America_Lima = null;
  this.Lzonedb_java_tzdb$ameim$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameim$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-18492)), $ct_T2__O__O__(new $c_T2(), "w", (-18492)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-18492), (-18516)], [1908210, 0, (-18516), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-18492), (-18516)], [1908210, 0, (-18516), (-18000)], [1938001, 0, (-18000), (-14400)], [1938091, 0, (-14400), (-18000)], [1938268, 0, (-18000), (-14400)], [1939085, 0, (-14400), (-18000)], [1939267, 0, (-18000), (-14400)], [1940084, 0, (-14400), (-18000)], [1986001, 0, (-18000), (-14400)], [1986091, 0, (-14400), (-18000)], [1987001, 0, (-18000), (-14400)], [1987091, 0, (-14400), (-18000)], [1990001, 0, (-18000), (-14400)], [1990091, 0, (-14400), (-18000)], [1994001, 0, (-18000), (-14400)], [1994091, 0, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameim$__f_America_Lima = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameim$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameim$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameim$.prototype.constructor = $c_Lzonedb_java_tzdb$ameim$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameim$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameim$.prototype = $c_Lzonedb_java_tzdb$ameim$.prototype;
$c_Lzonedb_java_tzdb$ameim$.prototype.America_Lima__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameim$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 767")
  };
  return this.Lzonedb_java_tzdb$ameim$__f_America_Lima
});
var $d_Lzonedb_java_tzdb$ameim$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameim$: 0
}, false, "zonedb.java.tzdb$ameim$", {
  Lzonedb_java_tzdb$ameim$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameim$.prototype.$classData = $d_Lzonedb_java_tzdb$ameim$;
var $n_Lzonedb_java_tzdb$ameim$;
function $m_Lzonedb_java_tzdb$ameim$() {
  if ((!$n_Lzonedb_java_tzdb$ameim$)) {
    $n_Lzonedb_java_tzdb$ameim$ = new $c_Lzonedb_java_tzdb$ameim$()
  };
  return $n_Lzonedb_java_tzdb$ameim$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amein$() {
  this.Lzonedb_java_tzdb$amein$__f_America_Regina = null;
  this.Lzonedb_java_tzdb$amein$__f_America_Araguaina = null;
  this.Lzonedb_java_tzdb$amein$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amein$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-25116)), $ct_T2__O__O__(new $c_T2(), "w", (-25116)), $ct_T2__O__O__(new $c_T2(), "t", [[1905244, 0, (-25116), (-25200)], [1960115, 7200, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1905244, 0, (-25116), (-25200)], [1918104, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1930124, 0, (-25200), (-21600)], [1930278, 0, (-21600), (-25200)], [1931123, 0, (-25200), (-21600)], [1931277, 0, (-21600), (-25200)], [1932122, 0, (-25200), (-21600)], [1932276, 0, (-21600), (-25200)], [1933127, 0, (-25200), (-21600)], [1933274, 0, (-21600), (-25200)], [1934126, 0, (-25200), (-21600)], [1934280, 0, (-21600), (-25200)], [1937101, 0, (-25200), (-21600)], [1937283, 0, (-21600), (-25200)], [1938100, 0, (-25200), (-21600)], [1938275, 0, (-21600), (-25200)], [1939099, 0, (-25200), (-21600)], [1939281, 0, (-21600), (-25200)], [1940105, 0, (-25200), (-21600)], [1940287, 0, (-21600), (-25200)], [1941103, 0, (-25200), (-21600)], [1941285, 0, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1946104, 7200, (-25200), (-21600)], [1946286, 7200, (-21600), (-25200)], [1947117, 7200, (-25200), (-21600)], [1947271, 7200, (-21600), (-25200)], [1948116, 7200, (-25200), (-21600)], [1948270, 7200, (-21600), (-25200)], [1949114, 7200, (-25200), (-21600)], [1949268, 7200, (-21600), (-25200)], [1950120, 7200, (-25200), (-21600)], [1950267, 7200, (-21600), (-25200)], [1951119, 7200, (-25200), (-21600)], [1951273, 7200, (-21600), (-25200)], [1952118, 7200, (-25200), (-21600)], [1952272, 7200, (-21600), (-25200)], [1953116, 7200, (-25200), (-21600)], [1953270, 7200, (-21600), (-25200)], [1954115, 7200, (-25200), (-21600)], [1954269, 7200, (-21600), (-25200)], [1955114, 7200, (-25200), (-21600)], [1955268, 7200, (-21600), (-25200)], [1956120, 7200, (-25200), (-21600)], [1956274, 7200, (-21600), (-25200)], [1957118, 7200, (-25200), (-21600)], [1957272, 7200, (-21600), (-25200)], [1959116, 7200, (-25200), (-21600)], [1959298, 7200, (-21600), (-25200)], [1960115, 7200, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amein$__f_America_Regina = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amein$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amein$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-11568)), $ct_T2__O__O__(new $c_T2(), "w", (-11568)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-11568), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-11568), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1995288, 0, (-10800), (-7200)], [1996042, 0, (-7200), (-10800)], [1996280, 0, (-10800), (-7200)], [1997047, 0, (-7200), (-10800)], [1997279, 0, (-10800), (-7200)], [1998060, 0, (-7200), (-10800)], [1998284, 0, (-10800), (-7200)], [1999052, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2001049, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)], [2002307, 0, (-10800), (-7200)], [2003047, 0, (-7200), (-10800)], [2012295, 0, (-10800), (-7200)], [2013048, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amein$__f_America_Araguaina = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amein$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amein$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amein$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amein$.prototype.constructor = $c_Lzonedb_java_tzdb$amein$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amein$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amein$.prototype = $c_Lzonedb_java_tzdb$amein$.prototype;
$c_Lzonedb_java_tzdb$amein$.prototype.America_Regina__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amein$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 91")
  };
  return this.Lzonedb_java_tzdb$amein$__f_America_Regina
});
$c_Lzonedb_java_tzdb$amein$.prototype.America_Araguaina__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amein$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 92")
  };
  return this.Lzonedb_java_tzdb$amein$__f_America_Araguaina
});
var $d_Lzonedb_java_tzdb$amein$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amein$: 0
}, false, "zonedb.java.tzdb$amein$", {
  Lzonedb_java_tzdb$amein$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amein$.prototype.$classData = $d_Lzonedb_java_tzdb$amein$;
var $n_Lzonedb_java_tzdb$amein$;
function $m_Lzonedb_java_tzdb$amein$() {
  if ((!$n_Lzonedb_java_tzdb$amein$)) {
    $n_Lzonedb_java_tzdb$amein$ = new $c_Lzonedb_java_tzdb$amein$()
  };
  return $n_Lzonedb_java_tzdb$amein$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameio$() {
  this.Lzonedb_java_tzdb$ameio$__f_America_Asuncion = null;
  this.Lzonedb_java_tzdb$ameio$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameio$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-13840)), $ct_T2__O__O__(new $c_T2(), "w", (-13840)), $ct_T2__O__O__(new $c_T2(), "t", [[1931283, 0, (-13840), (-14400)], [1972275, 0, (-14400), (-10800)], [1974091, 0, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1931283, 0, (-13840), (-14400)], [1972275, 0, (-14400), (-10800)], [1974091, 0, (-10800), (-14400)], [1975274, 0, (-14400), (-10800)], [1976061, 0, (-10800), (-14400)], [1976275, 0, (-14400), (-10800)], [1977060, 0, (-10800), (-14400)], [1977274, 0, (-14400), (-10800)], [1978060, 0, (-10800), (-14400)], [1978274, 0, (-14400), (-10800)], [1979091, 0, (-10800), (-14400)], [1979274, 0, (-14400), (-10800)], [1980092, 0, (-10800), (-14400)], [1980275, 0, (-14400), (-10800)], [1981091, 0, (-10800), (-14400)], [1981274, 0, (-14400), (-10800)], [1982091, 0, (-10800), (-14400)], [1982274, 0, (-14400), (-10800)], [1983091, 0, (-10800), (-14400)], [1983274, 0, (-14400), (-10800)], [1984092, 0, (-10800), (-14400)], [1984275, 0, (-14400), (-10800)], [1985091, 0, (-10800), (-14400)], [1985274, 0, (-14400), (-10800)], [1986091, 0, (-10800), (-14400)], [1986274, 0, (-14400), (-10800)], [1987091, 0, (-10800), (-14400)], [1987274, 0, (-14400), (-10800)], [1988092, 0, (-10800), (-14400)], [1988275, 0, (-14400), (-10800)], [1989091, 0, (-10800), (-14400)], [1989295, 0, (-14400), (-10800)], [1990091, 0, (-10800), (-14400)], [1990274, 0, (-14400), (-10800)], [1991091, 0, (-10800), (-14400)], [1991279, 0, (-14400), (-10800)], [1992061, 0, (-10800), (-14400)], [1992279, 0, (-14400), (-10800)], [1993090, 0, (-10800), (-14400)], [1993274, 0, (-14400), (-10800)], [1994058, 0, (-10800), (-14400)], [1994274, 0, (-14400), (-10800)], [1995057, 0, (-10800), (-14400)], [1995274, 0, (-14400), (-10800)], [1996061, 0, (-10800), (-14400)], [1996280, 0, (-14400), (-10800)], [1997054, 0, (-10800), (-14400)], [1997278, 0, (-14400), (-10800)], [1998060, 0, (-10800), (-14400)], [1998277, 0, (-14400), (-10800)], [1999066, 0, (-10800), (-14400)], [1999276, 0, (-14400), (-10800)], [2000065, 0, (-10800), (-14400)], [2000275, 0, (-14400), (-10800)], [2001063, 0, (-10800), (-14400)], [2001280, 0, (-14400), (-10800)], [2002097, 0, (-10800), (-14400)], [2002244, 0, (-14400), (-10800)], [2003096, 0, (-10800), (-14400)], [2003250, 0, (-14400), (-10800)], [2004095, 0, (-10800), (-14400)], [2004291, 0, (-14400), (-10800)], [2005072, 0, (-10800), (-14400)], [2005289, 0, (-14400), (-10800)], [2006071, 0, (-10800), (-14400)], [2006288, 0, (-14400), (-10800)], [2007070, 0, (-10800), (-14400)], [2007294, 0, (-14400), (-10800)], [2008069, 0, (-10800), (-14400)], [2008293, 0, (-14400), (-10800)], [2009067, 0, (-10800), (-14400)], [2009291, 0, (-14400), (-10800)], [2010101, 0, (-10800), (-14400)], [2010276, 0, (-14400), (-10800)], [2011100, 0, (-10800), (-14400)], [2011275, 0, (-14400), (-10800)], [2012099, 0, (-10800), (-14400)], [2012281, 0, (-14400), (-10800)], [2013083, 0, (-10800), (-14400)], [2013279, 0, (-14400), (-10800)], [2014082, 0, (-10800), (-14400)], [2014278, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 22, 7, 0, 0, 1, (-14400), (-10800), (-14400)], [10, 1, 7, 0, 0, 1, (-14400), (-14400), (-10800)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameio$__f_America_Asuncion = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameio$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameio$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameio$.prototype.constructor = $c_Lzonedb_java_tzdb$ameio$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameio$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameio$.prototype = $c_Lzonedb_java_tzdb$ameio$.prototype;
$c_Lzonedb_java_tzdb$ameio$.prototype.America_Asuncion__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameio$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 817")
  };
  return this.Lzonedb_java_tzdb$ameio$__f_America_Asuncion
});
var $d_Lzonedb_java_tzdb$ameio$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameio$: 0
}, false, "zonedb.java.tzdb$ameio$", {
  Lzonedb_java_tzdb$ameio$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameio$.prototype.$classData = $d_Lzonedb_java_tzdb$ameio$;
var $n_Lzonedb_java_tzdb$ameio$;
function $m_Lzonedb_java_tzdb$ameio$() {
  if ((!$n_Lzonedb_java_tzdb$ameio$)) {
    $n_Lzonedb_java_tzdb$ameio$ = new $c_Lzonedb_java_tzdb$ameio$()
  };
  return $n_Lzonedb_java_tzdb$ameio$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameis$() {
  this.Lzonedb_java_tzdb$ameis$__f_America_Boise = null;
  this.Lzonedb_java_tzdb$ameis$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameis$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-27889)), $ct_T2__O__O__(new $c_T2(), "w", (-27889)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44111, (-27889), (-28800)], [1923133, 7200, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44111, (-27889), (-28800)], [1918090, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1919089, 7200, (-28800), (-25200)], [1919299, 7200, (-25200), (-28800)], [1923133, 7200, (-28800), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974034, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameis$__f_America_Boise = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameis$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameis$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameis$.prototype.constructor = $c_Lzonedb_java_tzdb$ameis$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameis$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameis$.prototype = $c_Lzonedb_java_tzdb$ameis$.prototype;
$c_Lzonedb_java_tzdb$ameis$.prototype.America_Boise__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameis$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 891")
  };
  return this.Lzonedb_java_tzdb$ameis$__f_America_Boise
});
var $d_Lzonedb_java_tzdb$ameis$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameis$: 0
}, false, "zonedb.java.tzdb$ameis$", {
  Lzonedb_java_tzdb$ameis$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameis$.prototype.$classData = $d_Lzonedb_java_tzdb$ameis$;
var $n_Lzonedb_java_tzdb$ameis$;
function $m_Lzonedb_java_tzdb$ameis$() {
  if ((!$n_Lzonedb_java_tzdb$ameis$)) {
    $n_Lzonedb_java_tzdb$ameis$ = new $c_Lzonedb_java_tzdb$ameis$()
  };
  return $n_Lzonedb_java_tzdb$ameis$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameit$() {
  this.Lzonedb_java_tzdb$ameit$__f_America_Indiana_Tell_City = null;
  this.Lzonedb_java_tzdb$ameit$__f_America_Mexico_City = null;
  this.Lzonedb_java_tzdb$ameit$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameit$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-20823)), $ct_T2__O__O__(new $c_T2(), "w", (-20823)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 43977, (-20823), (-21600)], [1964117, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 43977, (-20823), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1955121, 0, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961302, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1962301, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1964117, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameit$__f_America_Indiana_Tell_City = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameit$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameit$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-23796)), $ct_T2__O__O__(new $c_T2(), "w", (-23796)), $ct_T2__O__O__(new $c_T2(), "t", [[1922001, 1404, (-23796), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1922001, 1404, (-23796), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1939036, 0, (-21600), (-18000)], [1939176, 0, (-18000), (-21600)], [1940344, 0, (-21600), (-18000)], [1941091, 0, (-18000), (-21600)], [1943350, 0, (-21600), (-18000)], [1944122, 0, (-18000), (-21600)], [1950043, 0, (-21600), (-18000)], [1950211, 0, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [10, 25, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameit$__f_America_Mexico_City = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameit$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameit$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameit$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameit$.prototype.constructor = $c_Lzonedb_java_tzdb$ameit$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameit$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameit$.prototype = $c_Lzonedb_java_tzdb$ameit$.prototype;
$c_Lzonedb_java_tzdb$ameit$.prototype.America_Indiana_Tell_City__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameit$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 710")
  };
  return this.Lzonedb_java_tzdb$ameit$__f_America_Indiana_Tell_City
});
$c_Lzonedb_java_tzdb$ameit$.prototype.America_Mexico_City__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameit$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 711")
  };
  return this.Lzonedb_java_tzdb$ameit$__f_America_Mexico_City
});
var $d_Lzonedb_java_tzdb$ameit$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameit$: 0
}, false, "zonedb.java.tzdb$ameit$", {
  Lzonedb_java_tzdb$ameit$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameit$.prototype.$classData = $d_Lzonedb_java_tzdb$ameit$;
var $n_Lzonedb_java_tzdb$ameit$;
function $m_Lzonedb_java_tzdb$ameit$() {
  if ((!$n_Lzonedb_java_tzdb$ameit$)) {
    $n_Lzonedb_java_tzdb$ameit$ = new $c_Lzonedb_java_tzdb$ameit$()
  };
  return $n_Lzonedb_java_tzdb$ameit$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameiz$() {
  this.Lzonedb_java_tzdb$ameiz$__f_America_Belize = null;
  this.Lzonedb_java_tzdb$ameiz$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameiz$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-21168)), $ct_T2__O__O__(new $c_T2(), "w", (-21168)), $ct_T2__O__O__(new $c_T2(), "t", [[1912092, 0, (-21168), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912092, 0, (-21168), (-21600)], [1918279, 0, (-21600), (-19800)], [1919040, 0, (-19800), (-21600)], [1919278, 0, (-21600), (-19800)], [1920046, 0, (-19800), (-21600)], [1920277, 0, (-21600), (-19800)], [1921044, 0, (-19800), (-21600)], [1921275, 0, (-21600), (-19800)], [1922043, 0, (-19800), (-21600)], [1922281, 0, (-21600), (-19800)], [1923042, 0, (-19800), (-21600)], [1923280, 0, (-21600), (-19800)], [1924041, 0, (-19800), (-21600)], [1924279, 0, (-21600), (-19800)], [1925046, 0, (-19800), (-21600)], [1925277, 0, (-21600), (-19800)], [1926045, 0, (-19800), (-21600)], [1926276, 0, (-21600), (-19800)], [1927044, 0, (-19800), (-21600)], [1927275, 0, (-21600), (-19800)], [1928043, 0, (-19800), (-21600)], [1928281, 0, (-21600), (-19800)], [1929041, 0, (-19800), (-21600)], [1929279, 0, (-21600), (-19800)], [1930040, 0, (-19800), (-21600)], [1930278, 0, (-21600), (-19800)], [1931046, 0, (-19800), (-21600)], [1931277, 0, (-21600), (-19800)], [1932045, 0, (-19800), (-21600)], [1932276, 0, (-21600), (-19800)], [1933043, 0, (-19800), (-21600)], [1933281, 0, (-21600), (-19800)], [1934042, 0, (-19800), (-21600)], [1934280, 0, (-21600), (-19800)], [1935041, 0, (-19800), (-21600)], [1935279, 0, (-21600), (-19800)], [1936040, 0, (-19800), (-21600)], [1936278, 0, (-21600), (-19800)], [1937045, 0, (-19800), (-21600)], [1937276, 0, (-21600), (-19800)], [1938044, 0, (-19800), (-21600)], [1938275, 0, (-21600), (-19800)], [1939043, 0, (-19800), (-21600)], [1939281, 0, (-21600), (-19800)], [1940042, 0, (-19800), (-21600)], [1940280, 0, (-21600), (-19800)], [1941040, 0, (-19800), (-21600)], [1941278, 0, (-21600), (-19800)], [1942046, 0, (-19800), (-21600)], [1942277, 0, (-21600), (-19800)], [1943045, 0, (-19800), (-21600)], [1973339, 0, (-21600), (-18000)], [1974040, 0, (-18000), (-21600)], [1982352, 0, (-21600), (-18000)], [1983043, 0, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameiz$__f_America_Belize = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameiz$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameiz$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameiz$.prototype.constructor = $c_Lzonedb_java_tzdb$ameiz$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameiz$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameiz$.prototype = $c_Lzonedb_java_tzdb$ameiz$.prototype;
$c_Lzonedb_java_tzdb$ameiz$.prototype.America_Belize__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameiz$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 341")
  };
  return this.Lzonedb_java_tzdb$ameiz$__f_America_Belize
});
var $d_Lzonedb_java_tzdb$ameiz$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameiz$: 0
}, false, "zonedb.java.tzdb$ameiz$", {
  Lzonedb_java_tzdb$ameiz$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameiz$.prototype.$classData = $d_Lzonedb_java_tzdb$ameiz$;
var $n_Lzonedb_java_tzdb$ameiz$;
function $m_Lzonedb_java_tzdb$ameiz$() {
  if ((!$n_Lzonedb_java_tzdb$ameiz$)) {
    $n_Lzonedb_java_tzdb$ameiz$ = new $c_Lzonedb_java_tzdb$ameiz$()
  };
  return $n_Lzonedb_java_tzdb$ameiz$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameju$() {
  this.Lzonedb_java_tzdb$ameju$__f_America_Argentina_Jujuy = null;
  this.Lzonedb_java_tzdb$ameju$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameju$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-15672)), $ct_T2__O__O__(new $c_T2(), "w", (-15672)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-15672), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1990062, 82800, (-10800), (-14400)], [1991279, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-15672), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-14400)], [1990301, 0, (-14400), (-10800)], [1991076, 0, (-10800), (-14400)], [1991279, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameju$__f_America_Argentina_Jujuy = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameju$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameju$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameju$.prototype.constructor = $c_Lzonedb_java_tzdb$ameju$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameju$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameju$.prototype = $c_Lzonedb_java_tzdb$ameju$.prototype;
$c_Lzonedb_java_tzdb$ameju$.prototype.America_Argentina_Jujuy__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameju$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 545")
  };
  return this.Lzonedb_java_tzdb$ameju$__f_America_Argentina_Jujuy
});
var $d_Lzonedb_java_tzdb$ameju$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameju$: 0
}, false, "zonedb.java.tzdb$ameju$", {
  Lzonedb_java_tzdb$ameju$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameju$.prototype.$classData = $d_Lzonedb_java_tzdb$ameju$;
var $n_Lzonedb_java_tzdb$ameju$;
function $m_Lzonedb_java_tzdb$ameju$() {
  if ((!$n_Lzonedb_java_tzdb$ameju$)) {
    $n_Lzonedb_java_tzdb$ameju$ = new $c_Lzonedb_java_tzdb$ameju$()
  };
  return $n_Lzonedb_java_tzdb$ameju$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameka$() {
  this.Lzonedb_java_tzdb$ameka$__f_America_Atikokan = null;
  this.Lzonedb_java_tzdb$ameka$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameka$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-21988)), $ct_T2__O__O__(new $c_T2(), "w", (-21988)), $ct_T2__O__O__(new $c_T2(), "t", [[1895001, 0, (-21988), (-21600)], [1945273, 3600, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895001, 0, (-21988), (-21600)], [1918104, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1940273, 0, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameka$__f_America_Atikokan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameka$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameka$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameka$.prototype.constructor = $c_Lzonedb_java_tzdb$ameka$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameka$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameka$.prototype = $c_Lzonedb_java_tzdb$ameka$.prototype;
$c_Lzonedb_java_tzdb$ameka$.prototype.America_Atikokan__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameka$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 666")
  };
  return this.Lzonedb_java_tzdb$ameka$__f_America_Atikokan
});
var $d_Lzonedb_java_tzdb$ameka$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameka$: 0
}, false, "zonedb.java.tzdb$ameka$", {
  Lzonedb_java_tzdb$ameka$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameka$.prototype.$classData = $d_Lzonedb_java_tzdb$ameka$;
var $n_Lzonedb_java_tzdb$ameka$;
function $m_Lzonedb_java_tzdb$ameka$() {
  if ((!$n_Lzonedb_java_tzdb$ameka$)) {
    $n_Lzonedb_java_tzdb$ameka$ = new $c_Lzonedb_java_tzdb$ameka$()
  };
  return $n_Lzonedb_java_tzdb$ameka$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amela$() {
  this.Lzonedb_java_tzdb$amela$__f_America_Mazatlan = null;
  this.Lzonedb_java_tzdb$amela$__f_America_North_Dakota_Beulah = null;
  this.Lzonedb_java_tzdb$amela$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amela$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-25540)), $ct_T2__O__O__(new $c_T2(), "w", (-25540)), $ct_T2__O__O__(new $c_T2(), "t", [[1921365, 86060, (-25540), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921365, 86060, (-25540), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001126, 7200, (-25200), (-21600)], [2001273, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [10, 25, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amela$__f_America_Mazatlan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amela$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amela$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-24427)), $ct_T2__O__O__(new $c_T2(), "w", (-24427)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 43973, (-24427), (-25200)], [2010311, 3600, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 43973, (-24427), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974006, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)], [2009067, 7200, (-25200), (-21600)], [2009305, 7200, (-21600), (-25200)], [2010073, 7200, (-25200), (-21600)], [2011072, 7200, (-21600), (-18000)], [2011310, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amela$__f_America_North_Dakota_Beulah = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amela$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amela$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amela$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amela$.prototype.constructor = $c_Lzonedb_java_tzdb$amela$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amela$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amela$.prototype = $c_Lzonedb_java_tzdb$amela$.prototype;
$c_Lzonedb_java_tzdb$amela$.prototype.America_Mazatlan__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amela$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 253")
  };
  return this.Lzonedb_java_tzdb$amela$__f_America_Mazatlan
});
$c_Lzonedb_java_tzdb$amela$.prototype.America_North_Dakota_Beulah__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amela$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 254")
  };
  return this.Lzonedb_java_tzdb$amela$__f_America_North_Dakota_Beulah
});
var $d_Lzonedb_java_tzdb$amela$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amela$: 0
}, false, "zonedb.java.tzdb$amela$", {
  Lzonedb_java_tzdb$amela$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amela$.prototype.$classData = $d_Lzonedb_java_tzdb$amela$;
var $n_Lzonedb_java_tzdb$amela$;
function $m_Lzonedb_java_tzdb$amela$() {
  if ((!$n_Lzonedb_java_tzdb$amela$)) {
    $n_Lzonedb_java_tzdb$amela$ = new $c_Lzonedb_java_tzdb$amela$()
  };
  return $n_Lzonedb_java_tzdb$amela$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amele$() {
  this.Lzonedb_java_tzdb$amele$__f_America_North_Dakota_New_Salem = null;
  this.Lzonedb_java_tzdb$amele$__f_America_Rankin_Inlet = null;
  this.Lzonedb_java_tzdb$amele$__f_America_Belem = null;
  this.Lzonedb_java_tzdb$amele$__f_America_Los_Angeles = null;
  this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amele$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-24339)), $ct_T2__O__O__(new $c_T2(), "w", (-24339)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44061, (-24339), (-25200)], [2003299, 3600, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44061, (-24339), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974006, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amele$__f_America_North_Dakota_New_Salem = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1957001, 0, 0, (-21600)], [2000303, 3600, (-21600), (-18000)], [2001091, 10800, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1957001, 0, 0, (-21600)], [1965115, 0, (-21600), (-14400)], [1965304, 7200, (-14400), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amele$__f_America_Rankin_Inlet = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-11636)), $ct_T2__O__O__(new $c_T2(), "w", (-11636)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-11636), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-11636), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963343, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$amele$__f_America_Belem = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0) << 24) >> 24);
  var array$3 = [$ct_T2__O__O__(new $c_T2(), "s", (-28378)), $ct_T2__O__O__(new $c_T2(), "w", (-28378)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 43622, (-28378), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 43622, (-28378), (-28800)], [1918090, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1919089, 7200, (-28800), (-25200)], [1919299, 7200, (-25200), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1948074, 7260, (-28800), (-25200)], [1949001, 7200, (-25200), (-28800)], [1950120, 3600, (-28800), (-25200)], [1950267, 7200, (-25200), (-28800)], [1951119, 3600, (-28800), (-25200)], [1951273, 7200, (-25200), (-28800)], [1952118, 3600, (-28800), (-25200)], [1952272, 7200, (-25200), (-28800)], [1953116, 3600, (-28800), (-25200)], [1953270, 7200, (-25200), (-28800)], [1954115, 3600, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 3600, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 3600, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 3600, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 3600, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 3600, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 3600, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1961120, 3600, (-28800), (-25200)], [1961267, 7200, (-25200), (-28800)], [1962119, 3600, (-28800), (-25200)], [1962301, 7200, (-25200), (-28800)], [1963118, 3600, (-28800), (-25200)], [1963300, 7200, (-25200), (-28800)], [1964117, 3600, (-28800), (-25200)], [1964299, 7200, (-25200), (-28800)], [1965115, 3600, (-28800), (-25200)], [1965304, 7200, (-25200), (-28800)], [1966114, 3600, (-28800), (-25200)], [1966303, 7200, (-25200), (-28800)], [1967120, 7200, (-28800), (-25200)], [1967302, 7200, (-25200), (-28800)], [1968119, 7200, (-28800), (-25200)], [1968301, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974006, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975054, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]])];
  var fields$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  this.Lzonedb_java_tzdb$amele$__f_America_Los_Angeles = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3);
  this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0 = (((8 | this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amele$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amele$.prototype.constructor = $c_Lzonedb_java_tzdb$amele$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amele$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amele$.prototype = $c_Lzonedb_java_tzdb$amele$.prototype;
$c_Lzonedb_java_tzdb$amele$.prototype.America_North_Dakota_New_Salem__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 512")
  };
  return this.Lzonedb_java_tzdb$amele$__f_America_North_Dakota_New_Salem
});
$c_Lzonedb_java_tzdb$amele$.prototype.America_Rankin_Inlet__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 513")
  };
  return this.Lzonedb_java_tzdb$amele$__f_America_Rankin_Inlet
});
$c_Lzonedb_java_tzdb$amele$.prototype.America_Belem__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 514")
  };
  return this.Lzonedb_java_tzdb$amele$__f_America_Belem
});
$c_Lzonedb_java_tzdb$amele$.prototype.America_Los_Angeles__sjs_js_Dynamic = (function() {
  if (((((8 & this.Lzonedb_java_tzdb$amele$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 515")
  };
  return this.Lzonedb_java_tzdb$amele$__f_America_Los_Angeles
});
var $d_Lzonedb_java_tzdb$amele$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amele$: 0
}, false, "zonedb.java.tzdb$amele$", {
  Lzonedb_java_tzdb$amele$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amele$.prototype.$classData = $d_Lzonedb_java_tzdb$amele$;
var $n_Lzonedb_java_tzdb$amele$;
function $m_Lzonedb_java_tzdb$amele$() {
  if ((!$n_Lzonedb_java_tzdb$amele$)) {
    $n_Lzonedb_java_tzdb$amele$ = new $c_Lzonedb_java_tzdb$amele$()
  };
  return $n_Lzonedb_java_tzdb$amele$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amelh$() {
  this.Lzonedb_java_tzdb$amelh$__f_America_Porto_Velho = null;
  this.Lzonedb_java_tzdb$amelh$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amelh$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-15336)), $ct_T2__O__O__(new $c_T2(), "w", (-15336)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-15336), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-15336), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amelh$__f_America_Porto_Velho = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amelh$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amelh$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amelh$.prototype.constructor = $c_Lzonedb_java_tzdb$amelh$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amelh$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amelh$.prototype = $c_Lzonedb_java_tzdb$amelh$.prototype;
$c_Lzonedb_java_tzdb$amelh$.prototype.America_Porto_Velho__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amelh$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 530")
  };
  return this.Lzonedb_java_tzdb$amelh$__f_America_Porto_Velho
});
var $d_Lzonedb_java_tzdb$amelh$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amelh$: 0
}, false, "zonedb.java.tzdb$amelh$", {
  Lzonedb_java_tzdb$amelh$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amelh$.prototype.$classData = $d_Lzonedb_java_tzdb$amelh$;
var $n_Lzonedb_java_tzdb$amelh$;
function $m_Lzonedb_java_tzdb$amelh$() {
  if ((!$n_Lzonedb_java_tzdb$amelh$)) {
    $n_Lzonedb_java_tzdb$amelh$ = new $c_Lzonedb_java_tzdb$amelh$()
  };
  return $n_Lzonedb_java_tzdb$amelh$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameli$() {
  this.Lzonedb_java_tzdb$ameli$__f_America_Indiana_Indianapolis = null;
  this.Lzonedb_java_tzdb$ameli$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameli$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-20678)), $ct_T2__O__O__(new $c_T2(), "w", (-20678)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44122, (-20678), (-21600)], [1955114, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44122, (-20678), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1941173, 7200, (-21600), (-18000)], [1941271, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameli$__f_America_Indiana_Indianapolis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameli$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameli$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameli$.prototype.constructor = $c_Lzonedb_java_tzdb$ameli$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameli$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameli$.prototype = $c_Lzonedb_java_tzdb$ameli$.prototype;
$c_Lzonedb_java_tzdb$ameli$.prototype.America_Indiana_Indianapolis__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameli$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 599")
  };
  return this.Lzonedb_java_tzdb$ameli$__f_America_Indiana_Indianapolis
});
var $d_Lzonedb_java_tzdb$ameli$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameli$: 0
}, false, "zonedb.java.tzdb$ameli$", {
  Lzonedb_java_tzdb$ameli$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameli$.prototype.$classData = $d_Lzonedb_java_tzdb$ameli$;
var $n_Lzonedb_java_tzdb$ameli$;
function $m_Lzonedb_java_tzdb$ameli$() {
  if ((!$n_Lzonedb_java_tzdb$ameli$)) {
    $n_Lzonedb_java_tzdb$ameli$ = new $c_Lzonedb_java_tzdb$ameli$()
  };
  return $n_Lzonedb_java_tzdb$ameli$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amell$() {
  this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Louisville = null;
  this.Lzonedb_java_tzdb$amell$__f_America_Hermosillo = null;
  this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Monticello = null;
  this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amell$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-20582)), $ct_T2__O__O__(new $c_T2(), "w", (-20582)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44218, (-20582), (-21600)], [1961204, 3600, (-21600), (-18000)], [1974006, 7200, (-18000), (-21600)], [1974300, 3600, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44218, (-20582), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1921121, 7200, (-21600), (-18000)], [1921244, 7200, (-18000), (-21600)], [1941117, 7200, (-21600), (-18000)], [1941271, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 60, (-21600), (-18000)], [1946153, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956302, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957300, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958299, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959298, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960304, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1975054, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Louisville = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-26632)), $ct_T2__O__O__(new $c_T2(), "w", (-26632)), $ct_T2__O__O__(new $c_T2(), "t", [[1921365, 84968, (-26632), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921365, 84968, (-26632), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amell$__f_America_Hermosillo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-20364)), $ct_T2__O__O__(new $c_T2(), "w", (-20364)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44436, (-20364), (-21600)], [2000303, 3600, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44436, (-20364), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 7200, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 7200, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 7200, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 7200, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Monticello = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amell$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amell$.prototype.constructor = $c_Lzonedb_java_tzdb$amell$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amell$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amell$.prototype = $c_Lzonedb_java_tzdb$amell$.prototype;
$c_Lzonedb_java_tzdb$amell$.prototype.America_Kentucky_Louisville__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 863")
  };
  return this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Louisville
});
$c_Lzonedb_java_tzdb$amell$.prototype.America_Hermosillo__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 864")
  };
  return this.Lzonedb_java_tzdb$amell$__f_America_Hermosillo
});
$c_Lzonedb_java_tzdb$amell$.prototype.America_Kentucky_Monticello__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$amell$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 865")
  };
  return this.Lzonedb_java_tzdb$amell$__f_America_Kentucky_Monticello
});
var $d_Lzonedb_java_tzdb$amell$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amell$: 0
}, false, "zonedb.java.tzdb$amell$", {
  Lzonedb_java_tzdb$amell$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amell$.prototype.$classData = $d_Lzonedb_java_tzdb$amell$;
var $n_Lzonedb_java_tzdb$amell$;
function $m_Lzonedb_java_tzdb$amell$() {
  if ((!$n_Lzonedb_java_tzdb$amell$)) {
    $n_Lzonedb_java_tzdb$amell$ = new $c_Lzonedb_java_tzdb$amell$()
  };
  return $n_Lzonedb_java_tzdb$amell$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amelo$() {
  this.Lzonedb_java_tzdb$amelo$__f_America_Miquelon = null;
  this.Lzonedb_java_tzdb$amelo$__f_America_Blanc_minus_Sablon = null;
  this.Lzonedb_java_tzdb$amelo$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amelo$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-13480)), $ct_T2__O__O__(new $c_T2(), "w", (-13480)), $ct_T2__O__O__(new $c_T2(), "t", [[1911135, 0, (-13480), (-14400)], [1980122, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1911135, 0, (-13480), (-14400)], [1980122, 0, (-14400), (-10800)], [1987095, 7200, (-10800), (-7200)], [1987298, 7200, (-7200), (-10800)], [1988094, 7200, (-10800), (-7200)], [1988304, 7200, (-7200), (-10800)], [1989092, 7200, (-10800), (-7200)], [1989302, 7200, (-7200), (-10800)], [1990091, 7200, (-10800), (-7200)], [1990301, 7200, (-7200), (-10800)], [1991097, 7200, (-10800), (-7200)], [1991300, 7200, (-7200), (-10800)], [1992096, 7200, (-10800), (-7200)], [1992299, 7200, (-7200), (-10800)], [1993094, 7200, (-10800), (-7200)], [1993304, 7200, (-7200), (-10800)], [1994093, 7200, (-10800), (-7200)], [1994303, 7200, (-7200), (-10800)], [1995092, 7200, (-10800), (-7200)], [1995302, 7200, (-7200), (-10800)], [1996098, 7200, (-10800), (-7200)], [1996301, 7200, (-7200), (-10800)], [1997096, 7200, (-10800), (-7200)], [1997299, 7200, (-7200), (-10800)], [1998095, 7200, (-10800), (-7200)], [1998298, 7200, (-7200), (-10800)], [1999094, 7200, (-10800), (-7200)], [1999304, 7200, (-7200), (-10800)], [2000093, 7200, (-10800), (-7200)], [2000303, 7200, (-7200), (-10800)], [2001091, 7200, (-10800), (-7200)], [2001301, 7200, (-7200), (-10800)], [2002097, 7200, (-10800), (-7200)], [2002300, 7200, (-7200), (-10800)], [2003096, 7200, (-10800), (-7200)], [2003299, 7200, (-7200), (-10800)], [2004095, 7200, (-10800), (-7200)], [2004305, 7200, (-7200), (-10800)], [2005093, 7200, (-10800), (-7200)], [2005303, 7200, (-7200), (-10800)], [2006092, 7200, (-10800), (-7200)], [2006302, 7200, (-7200), (-10800)], [2007070, 7200, (-10800), (-7200)], [2007308, 7200, (-7200), (-10800)], [2008069, 7200, (-10800), (-7200)], [2008307, 7200, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-10800), (-10800), (-7200)], [11, 1, 7, 7200, 0, 1, (-10800), (-7200), (-10800)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amelo$__f_America_Miquelon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amelo$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amelo$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-13708)), $ct_T2__O__O__(new $c_T2(), "w", (-13708)), $ct_T2__O__O__(new $c_T2(), "t", [[1884001, 0, (-13708), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1884001, 0, (-13708), (-14400)], [1918104, 7200, (-14400), (-10800)], [1918300, 7200, (-10800), (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amelo$__f_America_Blanc_minus_Sablon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amelo$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amelo$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amelo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amelo$.prototype.constructor = $c_Lzonedb_java_tzdb$amelo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amelo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amelo$.prototype = $c_Lzonedb_java_tzdb$amelo$.prototype;
$c_Lzonedb_java_tzdb$amelo$.prototype.America_Miquelon__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amelo$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 441")
  };
  return this.Lzonedb_java_tzdb$amelo$__f_America_Miquelon
});
$c_Lzonedb_java_tzdb$amelo$.prototype.America_Blanc_minus_Sablon__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amelo$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 442")
  };
  return this.Lzonedb_java_tzdb$amelo$__f_America_Blanc_minus_Sablon
});
var $d_Lzonedb_java_tzdb$amelo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amelo$: 0
}, false, "zonedb.java.tzdb$amelo$", {
  Lzonedb_java_tzdb$amelo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amelo$.prototype.$classData = $d_Lzonedb_java_tzdb$amelo$;
var $n_Lzonedb_java_tzdb$amelo$;
function $m_Lzonedb_java_tzdb$amelo$() {
  if ((!$n_Lzonedb_java_tzdb$amelo$)) {
    $n_Lzonedb_java_tzdb$amelo$ = new $c_Lzonedb_java_tzdb$amelo$()
  };
  return $n_Lzonedb_java_tzdb$amelo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amelp$() {
  this.Lzonedb_java_tzdb$amelp$__f_America_Tegucigalpa = null;
  this.Lzonedb_java_tzdb$amelp$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amelp$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-20932)), $ct_T2__O__O__(new $c_T2(), "w", (-20932)), $ct_T2__O__O__(new $c_T2(), "t", [[1921091, 0, (-20932), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921091, 0, (-20932), (-21600)], [1987123, 0, (-21600), (-18000)], [1987270, 0, (-18000), (-21600)], [1988122, 0, (-21600), (-18000)], [1988269, 0, (-18000), (-21600)], [2006127, 0, (-21600), (-18000)], [2006219, 0, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amelp$__f_America_Tegucigalpa = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amelp$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amelp$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amelp$.prototype.constructor = $c_Lzonedb_java_tzdb$amelp$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amelp$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amelp$.prototype = $c_Lzonedb_java_tzdb$amelp$.prototype;
$c_Lzonedb_java_tzdb$amelp$.prototype.America_Tegucigalpa__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amelp$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 674")
  };
  return this.Lzonedb_java_tzdb$amelp$__f_America_Tegucigalpa
});
var $d_Lzonedb_java_tzdb$amelp$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amelp$: 0
}, false, "zonedb.java.tzdb$amelp$", {
  Lzonedb_java_tzdb$amelp$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amelp$.prototype.$classData = $d_Lzonedb_java_tzdb$amelp$;
var $n_Lzonedb_java_tzdb$amelp$;
function $m_Lzonedb_java_tzdb$amelp$() {
  if ((!$n_Lzonedb_java_tzdb$amelp$)) {
    $n_Lzonedb_java_tzdb$amelp$ = new $c_Lzonedb_java_tzdb$amelp$()
  };
  return $n_Lzonedb_java_tzdb$amelp$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amelt$() {
  this.Lzonedb_java_tzdb$amelt$__f_America_Argentina_Salta = null;
  this.Lzonedb_java_tzdb$amelt$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amelt$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-15700)), $ct_T2__O__O__(new $c_T2(), "w", (-15700)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-15700), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991061, 82800, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-15700), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-14400)], [1991293, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amelt$__f_America_Argentina_Salta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amelt$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amelt$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amelt$.prototype.constructor = $c_Lzonedb_java_tzdb$amelt$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amelt$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amelt$.prototype = $c_Lzonedb_java_tzdb$amelt$.prototype;
$c_Lzonedb_java_tzdb$amelt$.prototype.America_Argentina_Salta__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amelt$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 295")
  };
  return this.Lzonedb_java_tzdb$amelt$__f_America_Argentina_Salta
});
var $d_Lzonedb_java_tzdb$amelt$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amelt$: 0
}, false, "zonedb.java.tzdb$amelt$", {
  Lzonedb_java_tzdb$amelt$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amelt$.prototype.$classData = $d_Lzonedb_java_tzdb$amelt$;
var $n_Lzonedb_java_tzdb$amelt$;
function $m_Lzonedb_java_tzdb$amelt$() {
  if ((!$n_Lzonedb_java_tzdb$amelt$)) {
    $n_Lzonedb_java_tzdb$amelt$ = new $c_Lzonedb_java_tzdb$amelt$()
  };
  return $n_Lzonedb_java_tzdb$amelt$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amema$() {
  this.Lzonedb_java_tzdb$amema$__f_America_Argentina_Tucuman = null;
  this.Lzonedb_java_tzdb$amema$__f_America_Indiana_Winamac = null;
  this.Lzonedb_java_tzdb$amema$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amema$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-15652)), $ct_T2__O__O__(new $c_T2(), "w", (-15652)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-15652), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991061, 82800, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004153, 0, (-10800), (-14400)], [2004165, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-15652), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-14400)], [1991293, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004153, 0, (-10800), (-14400)], [2004165, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)], [2008293, 0, (-10800), (-7200)], [2009074, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amema$__f_America_Argentina_Tucuman = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amema$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amema$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-20785)), $ct_T2__O__O__(new $c_T2(), "w", (-20785)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44015, (-20785), (-21600)], [1961120, 7200, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44015, (-20785), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955303, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956302, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amema$__f_America_Indiana_Winamac = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amema$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amema$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amema$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amema$.prototype.constructor = $c_Lzonedb_java_tzdb$amema$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amema$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amema$.prototype = $c_Lzonedb_java_tzdb$amema$.prototype;
$c_Lzonedb_java_tzdb$amema$.prototype.America_Argentina_Tucuman__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amema$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 859")
  };
  return this.Lzonedb_java_tzdb$amema$__f_America_Argentina_Tucuman
});
$c_Lzonedb_java_tzdb$amema$.prototype.America_Indiana_Winamac__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amema$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 860")
  };
  return this.Lzonedb_java_tzdb$amema$__f_America_Indiana_Winamac
});
var $d_Lzonedb_java_tzdb$amema$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amema$: 0
}, false, "zonedb.java.tzdb$amema$", {
  Lzonedb_java_tzdb$amema$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amema$.prototype.$classData = $d_Lzonedb_java_tzdb$amema$;
var $n_Lzonedb_java_tzdb$amema$;
function $m_Lzonedb_java_tzdb$amema$() {
  if ((!$n_Lzonedb_java_tzdb$amema$)) {
    $n_Lzonedb_java_tzdb$amema$ = new $c_Lzonedb_java_tzdb$amema$()
  };
  return $n_Lzonedb_java_tzdb$amema$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amena$() {
  this.Lzonedb_java_tzdb$amena$__f_America_Punta_Arenas = null;
  this.Lzonedb_java_tzdb$amena$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amena$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-17020)), $ct_T2__O__O__(new $c_T2(), "w", (-17020)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-17020), (-16966)], [1910010, 0, (-16966), (-18000)], [1916183, 0, (-18000), (-16966)], [1918253, 0, (-16966), (-14400)], [1919182, 0, (-14400), (-16966)], [1927244, 0, (-16966), (-18000)], [1932245, 0, (-18000), (-14400)], [1942152, 0, (-14400), (-18000)], [1942213, 0, (-18000), (-14400)], [1947091, 0, (-14400), (-18000)], [1947141, 82800, (-18000), (-14400)], [2016338, 82800, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-17020), (-16966)], [1910010, 0, (-16966), (-18000)], [1916183, 0, (-18000), (-16966)], [1918253, 0, (-16966), (-14400)], [1919182, 0, (-14400), (-16966)], [1927244, 0, (-16966), (-14400)], [1928092, 0, (-14400), (-18000)], [1928245, 0, (-18000), (-14400)], [1929091, 0, (-14400), (-18000)], [1929244, 0, (-18000), (-14400)], [1930091, 0, (-14400), (-18000)], [1930244, 0, (-18000), (-14400)], [1931091, 0, (-14400), (-18000)], [1931244, 0, (-18000), (-14400)], [1932092, 0, (-14400), (-18000)], [1932245, 0, (-18000), (-14400)], [1942152, 0, (-14400), (-18000)], [1942213, 0, (-18000), (-14400)], [1947091, 0, (-14400), (-18000)], [1947141, 82800, (-18000), (-14400)], [1968308, 0, (-14400), (-10800)], [1969089, 0, (-10800), (-14400)], [1969327, 0, (-14400), (-10800)], [1970088, 0, (-10800), (-14400)], [1970284, 0, (-14400), (-10800)], [1971073, 0, (-10800), (-14400)], [1971283, 0, (-14400), (-10800)], [1972072, 0, (-10800), (-14400)], [1972289, 0, (-14400), (-10800)], [1973070, 0, (-10800), (-14400)], [1973273, 0, (-14400), (-10800)], [1974069, 0, (-10800), (-14400)], [1974286, 0, (-14400), (-10800)], [1975068, 0, (-10800), (-14400)], [1975285, 0, (-14400), (-10800)], [1976074, 0, (-10800), (-14400)], [1976284, 0, (-14400), (-10800)], [1977072, 0, (-10800), (-14400)], [1977282, 0, (-14400), (-10800)], [1978071, 0, (-10800), (-14400)], [1978288, 0, (-14400), (-10800)], [1979070, 0, (-10800), (-14400)], [1979287, 0, (-14400), (-10800)], [1980069, 0, (-10800), (-14400)], [1980286, 0, (-14400), (-10800)], [1981074, 0, (-10800), (-14400)], [1981284, 0, (-14400), (-10800)], [1982073, 0, (-10800), (-14400)], [1982283, 0, (-14400), (-10800)], [1983072, 0, (-10800), (-14400)], [1983282, 0, (-14400), (-10800)], [1984071, 0, (-10800), (-14400)], [1984288, 0, (-14400), (-10800)], [1985069, 0, (-10800), (-14400)], [1985286, 0, (-14400), (-10800)], [1986068, 0, (-10800), (-14400)], [1986285, 0, (-14400), (-10800)], [1987102, 0, (-10800), (-14400)], [1987284, 0, (-14400), (-10800)], [1988073, 0, (-10800), (-14400)], [1988283, 0, (-14400), (-10800)], [1989071, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990070, 0, (-10800), (-14400)], [1990259, 0, (-14400), (-10800)], [1991069, 0, (-10800), (-14400)], [1991286, 0, (-14400), (-10800)], [1992075, 0, (-10800), (-14400)], [1992285, 0, (-14400), (-10800)], [1993073, 0, (-10800), (-14400)], [1993283, 0, (-14400), (-10800)], [1994072, 0, (-10800), (-14400)], [1994282, 0, (-14400), (-10800)], [1995071, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996070, 0, (-10800), (-14400)], [1996287, 0, (-14400), (-10800)], [1997089, 0, (-10800), (-14400)], [1997285, 0, (-14400), (-10800)], [1998074, 0, (-10800), (-14400)], [1998270, 0, (-14400), (-10800)], [1999094, 0, (-10800), (-14400)], [1999283, 0, (-14400), (-10800)], [2000072, 0, (-10800), (-14400)], [2000289, 0, (-14400), (-10800)], [2001070, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002069, 0, (-10800), (-14400)], [2002286, 0, (-14400), (-10800)], [2003068, 0, (-10800), (-14400)], [2003285, 0, (-14400), (-10800)], [2004074, 0, (-10800), (-14400)], [2004284, 0, (-14400), (-10800)], [2005072, 0, (-10800), (-14400)], [2005282, 0, (-14400), (-10800)], [2006071, 0, (-10800), (-14400)], [2006288, 0, (-14400), (-10800)], [2007070, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008090, 0, (-10800), (-14400)], [2008286, 0, (-14400), (-10800)], [2009074, 0, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)], [2010094, 0, (-10800), (-14400)], [2010283, 0, (-14400), (-10800)], [2011128, 0, (-10800), (-14400)], [2011233, 0, (-14400), (-10800)], [2012120, 0, (-10800), (-14400)], [2012246, 0, (-14400), (-10800)], [2013118, 0, (-10800), (-14400)], [2013251, 0, (-14400), (-10800)], [2014117, 0, (-10800), (-14400)], [2014250, 0, (-14400), (-10800)], [2016136, 0, (-10800), (-14400)], [2016227, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amena$__f_America_Punta_Arenas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amena$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amena$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amena$.prototype.constructor = $c_Lzonedb_java_tzdb$amena$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amena$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amena$.prototype = $c_Lzonedb_java_tzdb$amena$.prototype;
$c_Lzonedb_java_tzdb$amena$.prototype.America_Punta_Arenas__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amena$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 15")
  };
  return this.Lzonedb_java_tzdb$amena$__f_America_Punta_Arenas
});
var $d_Lzonedb_java_tzdb$amena$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amena$: 0
}, false, "zonedb.java.tzdb$amena$", {
  Lzonedb_java_tzdb$amena$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amena$.prototype.$classData = $d_Lzonedb_java_tzdb$amena$;
var $n_Lzonedb_java_tzdb$amena$;
function $m_Lzonedb_java_tzdb$amena$() {
  if ((!$n_Lzonedb_java_tzdb$amena$)) {
    $n_Lzonedb_java_tzdb$amena$ = new $c_Lzonedb_java_tzdb$amena$()
  };
  return $n_Lzonedb_java_tzdb$amena$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amenc$() {
  this.Lzonedb_java_tzdb$amenc$__f_America_Rio_Branco = null;
  this.Lzonedb_java_tzdb$amenc$__f_America_Port_minus_au_minus_Prince = null;
  this.Lzonedb_java_tzdb$amenc$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amenc$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-16272)), $ct_T2__O__O__(new $c_T2(), "w", (-16272)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-16272), (-18000)], [2008176, 0, (-18000), (-14400)], [2013314, 0, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-16272), (-18000)], [1931276, 39600, (-18000), (-14400)], [1932092, 0, (-14400), (-18000)], [1932277, 0, (-18000), (-14400)], [1933091, 0, (-14400), (-18000)], [1949335, 0, (-18000), (-14400)], [1950106, 3600, (-14400), (-18000)], [1950335, 0, (-18000), (-14400)], [1951091, 0, (-14400), (-18000)], [1951335, 0, (-18000), (-14400)], [1952092, 0, (-14400), (-18000)], [1952336, 0, (-18000), (-14400)], [1953060, 0, (-14400), (-18000)], [1963343, 0, (-18000), (-14400)], [1964061, 0, (-14400), (-18000)], [1965031, 0, (-18000), (-14400)], [1965090, 0, (-14400), (-18000)], [1965335, 0, (-18000), (-14400)], [1966060, 0, (-14400), (-18000)], [1966305, 0, (-18000), (-14400)], [1967060, 0, (-14400), (-18000)], [1967305, 0, (-18000), (-14400)], [1968061, 0, (-14400), (-18000)], [1985306, 0, (-18000), (-14400)], [1986074, 0, (-14400), (-18000)], [1986298, 0, (-18000), (-14400)], [1987045, 0, (-14400), (-18000)], [1987298, 0, (-18000), (-14400)], [1988038, 0, (-14400), (-18000)], [2008176, 0, (-18000), (-14400)], [2013314, 0, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amenc$__f_America_Rio_Branco = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amenc$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amenc$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-17360)), $ct_T2__O__O__(new $c_T2(), "w", (-17360)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-17360), (-17340)], [1917024, 43200, (-17340), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-17360), (-17340)], [1917024, 43200, (-17340), (-18000)], [1983128, 0, (-18000), (-14400)], [1983303, 0, (-14400), (-18000)], [1984120, 0, (-18000), (-14400)], [1984302, 0, (-14400), (-18000)], [1985118, 0, (-18000), (-14400)], [1985300, 0, (-14400), (-18000)], [1986117, 0, (-18000), (-14400)], [1986299, 0, (-14400), (-18000)], [1987116, 0, (-18000), (-14400)], [1987298, 0, (-14400), (-18000)], [1988094, 3600, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 3600, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 3600, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 3600, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 3600, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 3600, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 3600, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 3600, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 3600, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 3600, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [2005093, 0, (-18000), (-14400)], [2005303, 0, (-14400), (-18000)], [2006092, 0, (-18000), (-14400)], [2006302, 0, (-14400), (-18000)], [2012071, 7200, (-18000), (-14400)], [2012309, 7200, (-14400), (-18000)], [2013069, 7200, (-18000), (-14400)], [2013307, 7200, (-14400), (-18000)], [2014068, 7200, (-18000), (-14400)], [2014306, 7200, (-14400), (-18000)], [2015067, 7200, (-18000), (-14400)], [2015305, 7200, (-14400), (-18000)], [2017071, 7200, (-18000), (-14400)], [2017309, 7200, (-14400), (-18000)], [2018070, 7200, (-18000), (-14400)], [2018308, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amenc$__f_America_Port_minus_au_minus_Prince = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amenc$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amenc$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amenc$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amenc$.prototype.constructor = $c_Lzonedb_java_tzdb$amenc$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amenc$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amenc$.prototype = $c_Lzonedb_java_tzdb$amenc$.prototype;
$c_Lzonedb_java_tzdb$amenc$.prototype.America_Rio_Branco__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amenc$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 575")
  };
  return this.Lzonedb_java_tzdb$amenc$__f_America_Rio_Branco
});
$c_Lzonedb_java_tzdb$amenc$.prototype.America_Port_minus_au_minus_Prince__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amenc$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 576")
  };
  return this.Lzonedb_java_tzdb$amenc$__f_America_Port_minus_au_minus_Prince
});
var $d_Lzonedb_java_tzdb$amenc$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amenc$: 0
}, false, "zonedb.java.tzdb$amenc$", {
  Lzonedb_java_tzdb$amenc$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amenc$.prototype.$classData = $d_Lzonedb_java_tzdb$amenc$;
var $n_Lzonedb_java_tzdb$amenc$;
function $m_Lzonedb_java_tzdb$amenc$() {
  if ((!$n_Lzonedb_java_tzdb$amenc$)) {
    $n_Lzonedb_java_tzdb$amenc$ = new $c_Lzonedb_java_tzdb$amenc$()
  };
  return $n_Lzonedb_java_tzdb$amenc$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amend$() {
  this.Lzonedb_java_tzdb$amend$__f_America_Campo_Grande = null;
  this.Lzonedb_java_tzdb$amend$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amend$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-13108)), $ct_T2__O__O__(new $c_T2(), "w", (-13108)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-13108), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-13108), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [1988290, 0, (-14400), (-10800)], [1989029, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990042, 0, (-10800), (-14400)], [1990294, 0, (-14400), (-10800)], [1991048, 0, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1992040, 0, (-10800), (-14400)], [1992299, 0, (-14400), (-10800)], [1993031, 0, (-10800), (-14400)], [1993290, 0, (-14400), (-10800)], [1994051, 0, (-10800), (-14400)], [1994289, 0, (-14400), (-10800)], [1995050, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996042, 0, (-10800), (-14400)], [1996280, 0, (-14400), (-10800)], [1997047, 0, (-10800), (-14400)], [1997279, 0, (-14400), (-10800)], [1998060, 0, (-10800), (-14400)], [1998284, 0, (-14400), (-10800)], [1999052, 0, (-10800), (-14400)], [1999276, 0, (-14400), (-10800)], [2000058, 0, (-10800), (-14400)], [2000282, 0, (-14400), (-10800)], [2001049, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002048, 0, (-10800), (-14400)], [2002307, 0, (-14400), (-10800)], [2003047, 0, (-10800), (-14400)], [2003292, 0, (-14400), (-10800)], [2004046, 0, (-10800), (-14400)], [2004307, 0, (-14400), (-10800)], [2005051, 0, (-10800), (-14400)], [2005289, 0, (-14400), (-10800)], [2006050, 0, (-10800), (-14400)], [2006309, 0, (-14400), (-10800)], [2007056, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008048, 0, (-10800), (-14400)], [2008293, 0, (-14400), (-10800)], [2009046, 0, (-10800), (-14400)], [2009291, 0, (-14400), (-10800)], [2010052, 0, (-10800), (-14400)], [2010290, 0, (-14400), (-10800)], [2011051, 0, (-10800), (-14400)], [2011289, 0, (-14400), (-10800)], [2012057, 0, (-10800), (-14400)], [2012295, 0, (-14400), (-10800)], [2013048, 0, (-10800), (-14400)], [2013293, 0, (-14400), (-10800)], [2014047, 0, (-10800), (-14400)], [2014292, 0, (-14400), (-10800)], [2015053, 0, (-10800), (-14400)], [2015291, 0, (-14400), (-10800)], [2016052, 0, (-10800), (-14400)], [2016290, 0, (-14400), (-10800)], [2017050, 0, (-10800), (-14400)], [2017288, 0, (-14400), (-10800)], [2018049, 0, (-10800), (-14400)], [2018308, 0, (-14400), (-10800)], [2019048, 0, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amend$__f_America_Campo_Grande = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amend$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amend$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amend$.prototype.constructor = $c_Lzonedb_java_tzdb$amend$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amend$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amend$.prototype = $c_Lzonedb_java_tzdb$amend$.prototype;
$c_Lzonedb_java_tzdb$amend$.prototype.America_Campo_Grande__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amend$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 268")
  };
  return this.Lzonedb_java_tzdb$amend$__f_America_Campo_Grande
});
var $d_Lzonedb_java_tzdb$amend$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amend$: 0
}, false, "zonedb.java.tzdb$amend$", {
  Lzonedb_java_tzdb$amend$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amend$.prototype.$classData = $d_Lzonedb_java_tzdb$amend$;
var $n_Lzonedb_java_tzdb$amend$;
function $m_Lzonedb_java_tzdb$amend$() {
  if ((!$n_Lzonedb_java_tzdb$amend$)) {
    $n_Lzonedb_java_tzdb$amend$ = new $c_Lzonedb_java_tzdb$amend$()
  };
  return $n_Lzonedb_java_tzdb$amend$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amene$() {
  this.Lzonedb_java_tzdb$amene$__f_America_Indiana_Vincennes = null;
  this.Lzonedb_java_tzdb$amene$__f_America_Menominee = null;
  this.Lzonedb_java_tzdb$amene$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amene$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-21007)), $ct_T2__O__O__(new $c_T2(), "w", (-21007)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 43793, (-21007), (-21600)], [1964117, 7200, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)], [2007308, 3600, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 43793, (-21007), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955121, 0, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960304, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961267, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1962301, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1964117, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amene$__f_America_Indiana_Vincennes = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amene$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amene$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-21027)), $ct_T2__O__O__(new $c_T2(), "w", (-21027)), $ct_T2__O__O__(new $c_T2(), "t", [[1885261, 43200, (-21027), (-21600)], [1969117, 7200, (-21600), (-18000)], [1973119, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1885261, 43200, (-21027), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946118, 7200, (-21600), (-18000)], [1946272, 7200, (-18000), (-21600)], [1966114, 7200, (-21600), (-18000)], [1966303, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amene$__f_America_Menominee = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amene$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amene$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amene$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amene$.prototype.constructor = $c_Lzonedb_java_tzdb$amene$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amene$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amene$.prototype = $c_Lzonedb_java_tzdb$amene$.prototype;
$c_Lzonedb_java_tzdb$amene$.prototype.America_Indiana_Vincennes__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amene$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 69")
  };
  return this.Lzonedb_java_tzdb$amene$__f_America_Indiana_Vincennes
});
$c_Lzonedb_java_tzdb$amene$.prototype.America_Menominee__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amene$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 70")
  };
  return this.Lzonedb_java_tzdb$amene$__f_America_Menominee
});
var $d_Lzonedb_java_tzdb$amene$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amene$: 0
}, false, "zonedb.java.tzdb$amene$", {
  Lzonedb_java_tzdb$amene$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amene$.prototype.$classData = $d_Lzonedb_java_tzdb$amene$;
var $n_Lzonedb_java_tzdb$amene$;
function $m_Lzonedb_java_tzdb$amene$() {
  if ((!$n_Lzonedb_java_tzdb$amene$)) {
    $n_Lzonedb_java_tzdb$amene$ = new $c_Lzonedb_java_tzdb$amene$()
  };
  return $n_Lzonedb_java_tzdb$amene$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameng$() {
  this.Lzonedb_java_tzdb$ameng$__f_America_Santo_Domingo = null;
  this.Lzonedb_java_tzdb$ameng$__f_America_Indiana_Marengo = null;
  this.Lzonedb_java_tzdb$ameng$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameng$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-16776)), $ct_T2__O__O__(new $c_T2(), "w", (-16776)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-16776), (-16800)], [1933091, 43200, (-16800), (-18000)], [1974300, 0, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2000338, 3600, (-18000), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-16776), (-16800)], [1933091, 43200, (-16800), (-18000)], [1966303, 0, (-18000), (-14400)], [1967059, 0, (-14400), (-18000)], [1969299, 0, (-18000), (-16200)], [1970052, 0, (-16200), (-18000)], [1970298, 0, (-18000), (-16200)], [1971020, 0, (-16200), (-18000)], [1971304, 0, (-18000), (-16200)], [1972021, 0, (-16200), (-18000)], [1972303, 0, (-18000), (-16200)], [1973021, 0, (-16200), (-18000)], [1973301, 0, (-18000), (-16200)], [1974021, 0, (-16200), (-18000)], [1974300, 0, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2000338, 3600, (-18000), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameng$__f_America_Santo_Domingo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameng$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameng$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-20723)), $ct_T2__O__O__(new $c_T2(), "w", (-20723)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44077, (-20723), (-21600)], [1961120, 7200, (-21600), (-18000)], [1974006, 7200, (-18000), (-21600)], [1974300, 3600, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44077, (-20723), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1975054, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameng$__f_America_Indiana_Marengo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameng$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameng$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameng$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameng$.prototype.constructor = $c_Lzonedb_java_tzdb$ameng$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameng$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameng$.prototype = $c_Lzonedb_java_tzdb$ameng$.prototype;
$c_Lzonedb_java_tzdb$ameng$.prototype.America_Santo_Domingo__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameng$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 347")
  };
  return this.Lzonedb_java_tzdb$ameng$__f_America_Santo_Domingo
});
$c_Lzonedb_java_tzdb$ameng$.prototype.America_Indiana_Marengo__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameng$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 348")
  };
  return this.Lzonedb_java_tzdb$ameng$__f_America_Indiana_Marengo
});
var $d_Lzonedb_java_tzdb$ameng$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameng$: 0
}, false, "zonedb.java.tzdb$ameng$", {
  Lzonedb_java_tzdb$ameng$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameng$.prototype.$classData = $d_Lzonedb_java_tzdb$ameng$;
var $n_Lzonedb_java_tzdb$ameng$;
function $m_Lzonedb_java_tzdb$ameng$() {
  if ((!$n_Lzonedb_java_tzdb$ameng$)) {
    $n_Lzonedb_java_tzdb$ameng$ = new $c_Lzonedb_java_tzdb$ameng$()
  };
  return $n_Lzonedb_java_tzdb$ameng$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amenh$() {
  this.Lzonedb_java_tzdb$amenh$__f_America_Noronha = null;
  this.Lzonedb_java_tzdb$amenh$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amenh$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-7780)), $ct_T2__O__O__(new $c_T2(), "w", (-7780)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-7780), (-7200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-7780), (-7200)], [1931276, 39600, (-7200), (-3600)], [1932092, 0, (-3600), (-7200)], [1932277, 0, (-7200), (-3600)], [1933091, 0, (-3600), (-7200)], [1949335, 0, (-7200), (-3600)], [1950106, 3600, (-3600), (-7200)], [1950335, 0, (-7200), (-3600)], [1951091, 0, (-3600), (-7200)], [1951335, 0, (-7200), (-3600)], [1952092, 0, (-3600), (-7200)], [1952336, 0, (-7200), (-3600)], [1953060, 0, (-3600), (-7200)], [1963343, 0, (-7200), (-3600)], [1964061, 0, (-3600), (-7200)], [1965031, 0, (-7200), (-3600)], [1965090, 0, (-3600), (-7200)], [1965335, 0, (-7200), (-3600)], [1966060, 0, (-3600), (-7200)], [1966305, 0, (-7200), (-3600)], [1967060, 0, (-3600), (-7200)], [1967305, 0, (-7200), (-3600)], [1968061, 0, (-3600), (-7200)], [1985306, 0, (-7200), (-3600)], [1986074, 0, (-3600), (-7200)], [1986298, 0, (-7200), (-3600)], [1987045, 0, (-3600), (-7200)], [1987298, 0, (-7200), (-3600)], [1988038, 0, (-3600), (-7200)], [1988290, 0, (-7200), (-3600)], [1989029, 0, (-3600), (-7200)], [1989288, 0, (-7200), (-3600)], [1990042, 0, (-3600), (-7200)], [1999276, 0, (-7200), (-3600)], [2000058, 0, (-3600), (-7200)], [2000282, 0, (-7200), (-3600)], [2000289, 0, (-3600), (-7200)], [2001287, 0, (-7200), (-3600)], [2002048, 0, (-3600), (-7200)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amenh$__f_America_Noronha = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amenh$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amenh$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amenh$.prototype.constructor = $c_Lzonedb_java_tzdb$amenh$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amenh$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amenh$.prototype = $c_Lzonedb_java_tzdb$amenh$.prototype;
$c_Lzonedb_java_tzdb$amenh$.prototype.America_Noronha__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amenh$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 548")
  };
  return this.Lzonedb_java_tzdb$amenh$__f_America_Noronha
});
var $d_Lzonedb_java_tzdb$amenh$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amenh$: 0
}, false, "zonedb.java.tzdb$amenh$", {
  Lzonedb_java_tzdb$amenh$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amenh$.prototype.$classData = $d_Lzonedb_java_tzdb$amenh$;
var $n_Lzonedb_java_tzdb$amenh$;
function $m_Lzonedb_java_tzdb$amenh$() {
  if ((!$n_Lzonedb_java_tzdb$amenh$)) {
    $n_Lzonedb_java_tzdb$amenh$ = new $c_Lzonedb_java_tzdb$amenh$()
  };
  return $n_Lzonedb_java_tzdb$amenh$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameni$() {
  this.Lzonedb_java_tzdb$ameni$__f_America_Phoenix = null;
  this.Lzonedb_java_tzdb$ameni$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameni$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-26898)), $ct_T2__O__O__(new $c_T2(), "w", (-26898)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 41502, (-26898), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 41502, (-26898), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1944001, 60, (-21600), (-25200)], [1944092, 60, (-25200), (-21600)], [1944275, 60, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameni$__f_America_Phoenix = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameni$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameni$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameni$.prototype.constructor = $c_Lzonedb_java_tzdb$ameni$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameni$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameni$.prototype = $c_Lzonedb_java_tzdb$ameni$.prototype;
$c_Lzonedb_java_tzdb$ameni$.prototype.America_Phoenix__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameni$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 847")
  };
  return this.Lzonedb_java_tzdb$ameni$__f_America_Phoenix
});
var $d_Lzonedb_java_tzdb$ameni$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameni$: 0
}, false, "zonedb.java.tzdb$ameni$", {
  Lzonedb_java_tzdb$ameni$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameni$.prototype.$classData = $d_Lzonedb_java_tzdb$ameni$;
var $n_Lzonedb_java_tzdb$ameni$;
function $m_Lzonedb_java_tzdb$ameni$() {
  if ((!$n_Lzonedb_java_tzdb$ameni$)) {
    $n_Lzonedb_java_tzdb$ameni$ = new $c_Lzonedb_java_tzdb$ameni$()
  };
  return $n_Lzonedb_java_tzdb$ameni$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amenn$() {
  this.Lzonedb_java_tzdb$amenn$__f_America_Cayenne = null;
  this.Lzonedb_java_tzdb$amenn$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amenn$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-12560)), $ct_T2__O__O__(new $c_T2(), "w", (-12560)), $ct_T2__O__O__(new $c_T2(), "t", [[1911182, 0, (-12560), (-14400)], [1967274, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1911182, 0, (-12560), (-14400)], [1967274, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amenn$__f_America_Cayenne = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amenn$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amenn$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amenn$.prototype.constructor = $c_Lzonedb_java_tzdb$amenn$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amenn$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amenn$.prototype = $c_Lzonedb_java_tzdb$amenn$.prototype;
$c_Lzonedb_java_tzdb$amenn$.prototype.America_Cayenne__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amenn$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 38")
  };
  return this.Lzonedb_java_tzdb$amenn$__f_America_Cayenne
});
var $d_Lzonedb_java_tzdb$amenn$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amenn$: 0
}, false, "zonedb.java.tzdb$amenn$", {
  Lzonedb_java_tzdb$amenn$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amenn$.prototype.$classData = $d_Lzonedb_java_tzdb$amenn$;
var $n_Lzonedb_java_tzdb$amenn$;
function $m_Lzonedb_java_tzdb$amenn$() {
  if ((!$n_Lzonedb_java_tzdb$amenn$)) {
    $n_Lzonedb_java_tzdb$amenn$ = new $c_Lzonedb_java_tzdb$amenn$()
  };
  return $n_Lzonedb_java_tzdb$amenn$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameno$() {
  this.Lzonedb_java_tzdb$ameno$__f_America_Indiana_Knox = null;
  this.Lzonedb_java_tzdb$ameno$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameno$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-20790)), $ct_T2__O__O__(new $c_T2(), "w", (-20790)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44010, (-20790), (-21600)], [1962119, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1991300, 3600, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44010, (-20790), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950120, 7200, (-21600), (-18000)], [1950267, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955303, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956302, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959298, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960304, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961302, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1967120, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 7200, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 7200, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 7200, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 7200, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameno$__f_America_Indiana_Knox = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameno$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameno$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameno$.prototype.constructor = $c_Lzonedb_java_tzdb$ameno$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameno$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameno$.prototype = $c_Lzonedb_java_tzdb$ameno$.prototype;
$c_Lzonedb_java_tzdb$ameno$.prototype.America_Indiana_Knox__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameno$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 692")
  };
  return this.Lzonedb_java_tzdb$ameno$__f_America_Indiana_Knox
});
var $d_Lzonedb_java_tzdb$ameno$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameno$: 0
}, false, "zonedb.java.tzdb$ameno$", {
  Lzonedb_java_tzdb$ameno$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameno$.prototype.$classData = $d_Lzonedb_java_tzdb$ameno$;
var $n_Lzonedb_java_tzdb$ameno$;
function $m_Lzonedb_java_tzdb$ameno$() {
  if ((!$n_Lzonedb_java_tzdb$ameno$)) {
    $n_Lzonedb_java_tzdb$ameno$ = new $c_Lzonedb_java_tzdb$ameno$()
  };
  return $n_Lzonedb_java_tzdb$ameno$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ament$() {
  this.Lzonedb_java_tzdb$ament$__f_America_Toronto = null;
  this.Lzonedb_java_tzdb$ament$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ament$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-19052)), $ct_T2__O__O__(new $c_T2(), "w", (-19052)), $ct_T2__O__O__(new $c_T2(), "t", [[1895001, 0, (-19052), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895001, 0, (-19052), (-18000)], [1918104, 7200, (-18000), (-14400)], [1918300, 7200, (-14400), (-18000)], [1919089, 84600, (-18000), (-14400)], [1919299, 0, (-14400), (-18000)], [1920123, 7200, (-18000), (-14400)], [1920270, 0, (-14400), (-18000)], [1921135, 7200, (-18000), (-14400)], [1921258, 7200, (-14400), (-18000)], [1922134, 7200, (-18000), (-14400)], [1922260, 7200, (-14400), (-18000)], [1923133, 7200, (-18000), (-14400)], [1923259, 7200, (-14400), (-18000)], [1924125, 7200, (-18000), (-14400)], [1924265, 7200, (-14400), (-18000)], [1925123, 7200, (-18000), (-14400)], [1925263, 7200, (-14400), (-18000)], [1926122, 7200, (-18000), (-14400)], [1926262, 7200, (-14400), (-18000)], [1927121, 7200, (-18000), (-14400)], [1927268, 7200, (-14400), (-18000)], [1928120, 7200, (-18000), (-14400)], [1928274, 7200, (-14400), (-18000)], [1929118, 7200, (-18000), (-14400)], [1929272, 7200, (-14400), (-18000)], [1930117, 7200, (-18000), (-14400)], [1930271, 7200, (-14400), (-18000)], [1931116, 7200, (-18000), (-14400)], [1931270, 7200, (-14400), (-18000)], [1932122, 7200, (-18000), (-14400)], [1932269, 7200, (-14400), (-18000)], [1933120, 7200, (-18000), (-14400)], [1933274, 7200, (-14400), (-18000)], [1934119, 7200, (-18000), (-14400)], [1934273, 7200, (-14400), (-18000)], [1935118, 7200, (-18000), (-14400)], [1935272, 7200, (-14400), (-18000)], [1936117, 7200, (-18000), (-14400)], [1936271, 7200, (-14400), (-18000)], [1937115, 7200, (-18000), (-14400)], [1937269, 7200, (-14400), (-18000)], [1938114, 7200, (-18000), (-14400)], [1938268, 7200, (-14400), (-18000)], [1939120, 7200, (-18000), (-14400)], [1939267, 7200, (-14400), (-18000)], [1940119, 7200, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1946118, 7200, (-18000), (-14400)], [1946272, 7200, (-14400), (-18000)], [1947117, 0, (-18000), (-14400)], [1947271, 0, (-14400), (-18000)], [1948116, 0, (-18000), (-14400)], [1948270, 0, (-14400), (-18000)], [1949114, 0, (-18000), (-14400)], [1949331, 0, (-14400), (-18000)], [1950120, 7200, (-18000), (-14400)], [1950330, 7200, (-14400), (-18000)], [1951119, 7200, (-18000), (-14400)], [1951273, 7200, (-14400), (-18000)], [1952118, 7200, (-18000), (-14400)], [1952272, 7200, (-14400), (-18000)], [1953116, 7200, (-18000), (-14400)], [1953270, 7200, (-14400), (-18000)], [1954115, 7200, (-18000), (-14400)], [1954269, 7200, (-14400), (-18000)], [1955114, 7200, (-18000), (-14400)], [1955268, 7200, (-14400), (-18000)], [1956120, 7200, (-18000), (-14400)], [1956274, 7200, (-14400), (-18000)], [1957118, 7200, (-18000), (-14400)], [1957300, 7200, (-14400), (-18000)], [1958117, 7200, (-18000), (-14400)], [1958299, 7200, (-14400), (-18000)], [1959116, 7200, (-18000), (-14400)], [1959298, 7200, (-14400), (-18000)], [1960115, 7200, (-18000), (-14400)], [1960304, 7200, (-14400), (-18000)], [1961120, 7200, (-18000), (-14400)], [1961302, 7200, (-14400), (-18000)], [1962119, 7200, (-18000), (-14400)], [1962301, 7200, (-14400), (-18000)], [1963118, 7200, (-18000), (-14400)], [1963300, 7200, (-14400), (-18000)], [1964117, 7200, (-18000), (-14400)], [1964299, 7200, (-14400), (-18000)], [1965115, 7200, (-18000), (-14400)], [1965304, 7200, (-14400), (-18000)], [1966114, 7200, (-18000), (-14400)], [1966303, 7200, (-14400), (-18000)], [1967120, 7200, (-18000), (-14400)], [1967302, 7200, (-14400), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1974118, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ament$__f_America_Toronto = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ament$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ament$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ament$.prototype.constructor = $c_Lzonedb_java_tzdb$ament$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ament$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ament$.prototype = $c_Lzonedb_java_tzdb$ament$.prototype;
$c_Lzonedb_java_tzdb$ament$.prototype.America_Toronto__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ament$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 53")
  };
  return this.Lzonedb_java_tzdb$ament$__f_America_Toronto
});
var $d_Lzonedb_java_tzdb$ament$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ament$: 0
}, false, "zonedb.java.tzdb$ament$", {
  Lzonedb_java_tzdb$ament$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ament$.prototype.$classData = $d_Lzonedb_java_tzdb$ament$;
var $n_Lzonedb_java_tzdb$ament$;
function $m_Lzonedb_java_tzdb$ament$() {
  if ((!$n_Lzonedb_java_tzdb$ament$)) {
    $n_Lzonedb_java_tzdb$ament$ = new $c_Lzonedb_java_tzdb$ament$()
  };
  return $n_Lzonedb_java_tzdb$ament$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameob$() {
  this.Lzonedb_java_tzdb$ameob$__f_America_Argentina_Cordoba = null;
  this.Lzonedb_java_tzdb$ameob$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameob$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-15408)), $ct_T2__O__O__(new $c_T2(), "w", (-15408)), $ct_T2__O__O__(new $c_T2(), "t", [[1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991061, 82800, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-14400)], [1991293, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)], [2008293, 0, (-10800), (-7200)], [2009074, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameob$__f_America_Argentina_Cordoba = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameob$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameob$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameob$.prototype.constructor = $c_Lzonedb_java_tzdb$ameob$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameob$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameob$.prototype = $c_Lzonedb_java_tzdb$ameob$.prototype;
$c_Lzonedb_java_tzdb$ameob$.prototype.America_Argentina_Cordoba__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameob$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 29")
  };
  return this.Lzonedb_java_tzdb$ameob$__f_America_Argentina_Cordoba
});
var $d_Lzonedb_java_tzdb$ameob$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameob$: 0
}, false, "zonedb.java.tzdb$ameob$", {
  Lzonedb_java_tzdb$ameob$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameob$.prototype.$classData = $d_Lzonedb_java_tzdb$ameob$;
var $n_Lzonedb_java_tzdb$ameob$;
function $m_Lzonedb_java_tzdb$ameob$() {
  if ((!$n_Lzonedb_java_tzdb$ameob$)) {
    $n_Lzonedb_java_tzdb$ameob$ = new $c_Lzonedb_java_tzdb$ameob$()
  };
  return $n_Lzonedb_java_tzdb$ameob$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameoi$() {
  this.Lzonedb_java_tzdb$ameoi$__f_America_Detroit = null;
  this.Lzonedb_java_tzdb$ameoi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameoi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-19931)), $ct_T2__O__O__(new $c_T2(), "w", (-19931)), $ct_T2__O__O__(new $c_T2(), "t", [[1905001, 0, (-19931), (-21600)], [1915135, 7200, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1905001, 0, (-19931), (-21600)], [1915135, 7200, (-21600), (-18000)], [1942040, 7200, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1948116, 7200, (-18000), (-14400)], [1948270, 7200, (-14400), (-18000)], [1967165, 60, (-18000), (-14400)], [1967302, 7200, (-14400), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1974006, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameoi$__f_America_Detroit = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameoi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameoi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameoi$.prototype.constructor = $c_Lzonedb_java_tzdb$ameoi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameoi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameoi$.prototype = $c_Lzonedb_java_tzdb$ameoi$.prototype;
$c_Lzonedb_java_tzdb$ameoi$.prototype.America_Detroit__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameoi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 582")
  };
  return this.Lzonedb_java_tzdb$ameoi$__f_America_Detroit
});
var $d_Lzonedb_java_tzdb$ameoi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameoi$: 0
}, false, "zonedb.java.tzdb$ameoi$", {
  Lzonedb_java_tzdb$ameoi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameoi$.prototype.$classData = $d_Lzonedb_java_tzdb$ameoi$;
var $n_Lzonedb_java_tzdb$ameoi$;
function $m_Lzonedb_java_tzdb$ameoi$() {
  if ((!$n_Lzonedb_java_tzdb$ameoi$)) {
    $n_Lzonedb_java_tzdb$ameoi$ = new $c_Lzonedb_java_tzdb$ameoi$()
  };
  return $n_Lzonedb_java_tzdb$ameoi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameoj$() {
  this.Lzonedb_java_tzdb$ameoj$__f_America_Argentina_La_Rioja = null;
  this.Lzonedb_java_tzdb$ameoj$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameoj$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-16044)), $ct_T2__O__O__(new $c_T2(), "w", (-16044)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-16044), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991059, 82800, (-10800), (-14400)], [1991127, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-16044), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991060, 0, (-7200), (-14400)], [1991127, 0, (-14400), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameoj$__f_America_Argentina_La_Rioja = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameoj$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameoj$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameoj$.prototype.constructor = $c_Lzonedb_java_tzdb$ameoj$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameoj$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameoj$.prototype = $c_Lzonedb_java_tzdb$ameoj$.prototype;
$c_Lzonedb_java_tzdb$ameoj$.prototype.America_Argentina_La_Rioja__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameoj$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 811")
  };
  return this.Lzonedb_java_tzdb$ameoj$__f_America_Argentina_La_Rioja
});
var $d_Lzonedb_java_tzdb$ameoj$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameoj$: 0
}, false, "zonedb.java.tzdb$ameoj$", {
  Lzonedb_java_tzdb$ameoj$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameoj$.prototype.$classData = $d_Lzonedb_java_tzdb$ameoj$;
var $n_Lzonedb_java_tzdb$ameoj$;
function $m_Lzonedb_java_tzdb$ameoj$() {
  if ((!$n_Lzonedb_java_tzdb$ameoj$)) {
    $n_Lzonedb_java_tzdb$ameoj$ = new $c_Lzonedb_java_tzdb$ameoj$()
  };
  return $n_Lzonedb_java_tzdb$ameoj$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameom$() {
  this.Lzonedb_java_tzdb$ameom$__f_America_Nome = null;
  this.Lzonedb_java_tzdb$ameom$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameom$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 46702), $ct_T2__O__O__(new $c_T2(), "w", 46702), $ct_T2__O__O__(new $c_T2(), "t", [[1867292, 48575, 46702, (-39698)], [1900232, 43200, (-39698), (-39600)], [1983303, 3600, (-39600), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1867292, 48575, 46702, (-39698)], [1900232, 43200, (-39698), (-39600)], [1942040, 7200, (-39600), (-36000)], [1945273, 7200, (-36000), (-39600)], [1969117, 7200, (-39600), (-36000)], [1969299, 7200, (-36000), (-39600)], [1970116, 7200, (-39600), (-36000)], [1970298, 7200, (-36000), (-39600)], [1971115, 7200, (-39600), (-36000)], [1971304, 7200, (-36000), (-39600)], [1972121, 7200, (-39600), (-36000)], [1972303, 7200, (-36000), (-39600)], [1973119, 7200, (-39600), (-36000)], [1973301, 7200, (-36000), (-39600)], [1974006, 7200, (-39600), (-36000)], [1974300, 7200, (-36000), (-39600)], [1975054, 7200, (-39600), (-36000)], [1975299, 7200, (-36000), (-39600)], [1976116, 7200, (-39600), (-36000)], [1976305, 7200, (-36000), (-39600)], [1977114, 7200, (-39600), (-36000)], [1977303, 7200, (-36000), (-39600)], [1978120, 7200, (-39600), (-36000)], [1978302, 7200, (-36000), (-39600)], [1979119, 7200, (-39600), (-36000)], [1979301, 7200, (-36000), (-39600)], [1980118, 7200, (-39600), (-36000)], [1980300, 7200, (-36000), (-39600)], [1981116, 7200, (-39600), (-36000)], [1981298, 7200, (-36000), (-39600)], [1982115, 7200, (-39600), (-36000)], [1982304, 7200, (-36000), (-39600)], [1983114, 7200, (-39600), (-36000)], [1983303, 7200, (-36000), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameom$__f_America_Nome = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameom$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameom$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameom$.prototype.constructor = $c_Lzonedb_java_tzdb$ameom$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameom$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameom$.prototype = $c_Lzonedb_java_tzdb$ameom$.prototype;
$c_Lzonedb_java_tzdb$ameom$.prototype.America_Nome__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameom$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 509")
  };
  return this.Lzonedb_java_tzdb$ameom$__f_America_Nome
});
var $d_Lzonedb_java_tzdb$ameom$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameom$: 0
}, false, "zonedb.java.tzdb$ameom$", {
  Lzonedb_java_tzdb$ameom$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameom$.prototype.$classData = $d_Lzonedb_java_tzdb$ameom$;
var $n_Lzonedb_java_tzdb$ameom$;
function $m_Lzonedb_java_tzdb$ameom$() {
  if ((!$n_Lzonedb_java_tzdb$ameom$)) {
    $n_Lzonedb_java_tzdb$ameom$ = new $c_Lzonedb_java_tzdb$ameom$()
  };
  return $n_Lzonedb_java_tzdb$ameom$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameor$() {
  this.Lzonedb_java_tzdb$ameor$__f_America_New_York = null;
  this.Lzonedb_java_tzdb$ameor$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameor$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-17762)), $ct_T2__O__O__(new $c_T2(), "w", (-17762)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 43438, (-17762), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 43438, (-17762), (-18000)], [1918090, 7200, (-18000), (-14400)], [1918300, 7200, (-14400), (-18000)], [1919089, 7200, (-18000), (-14400)], [1919299, 7200, (-14400), (-18000)], [1920088, 7200, (-18000), (-14400)], [1920305, 7200, (-14400), (-18000)], [1921114, 7200, (-18000), (-14400)], [1921268, 7200, (-14400), (-18000)], [1922120, 7200, (-18000), (-14400)], [1922267, 7200, (-14400), (-18000)], [1923119, 7200, (-18000), (-14400)], [1923273, 7200, (-14400), (-18000)], [1924118, 7200, (-18000), (-14400)], [1924272, 7200, (-14400), (-18000)], [1925116, 7200, (-18000), (-14400)], [1925270, 7200, (-14400), (-18000)], [1926115, 7200, (-18000), (-14400)], [1926269, 7200, (-14400), (-18000)], [1927114, 7200, (-18000), (-14400)], [1927268, 7200, (-14400), (-18000)], [1928120, 7200, (-18000), (-14400)], [1928274, 7200, (-14400), (-18000)], [1929118, 7200, (-18000), (-14400)], [1929272, 7200, (-14400), (-18000)], [1930117, 7200, (-18000), (-14400)], [1930271, 7200, (-14400), (-18000)], [1931116, 7200, (-18000), (-14400)], [1931270, 7200, (-14400), (-18000)], [1932115, 7200, (-18000), (-14400)], [1932269, 7200, (-14400), (-18000)], [1933120, 7200, (-18000), (-14400)], [1933267, 7200, (-14400), (-18000)], [1934119, 7200, (-18000), (-14400)], [1934273, 7200, (-14400), (-18000)], [1935118, 7200, (-18000), (-14400)], [1935272, 7200, (-14400), (-18000)], [1936117, 7200, (-18000), (-14400)], [1936271, 7200, (-14400), (-18000)], [1937115, 7200, (-18000), (-14400)], [1937269, 7200, (-14400), (-18000)], [1938114, 7200, (-18000), (-14400)], [1938268, 7200, (-14400), (-18000)], [1939120, 7200, (-18000), (-14400)], [1939267, 7200, (-14400), (-18000)], [1940119, 7200, (-18000), (-14400)], [1940273, 7200, (-14400), (-18000)], [1941117, 7200, (-18000), (-14400)], [1941271, 7200, (-14400), (-18000)], [1942040, 7200, (-18000), (-14400)], [1945273, 7200, (-14400), (-18000)], [1946118, 7200, (-18000), (-14400)], [1946272, 7200, (-14400), (-18000)], [1947117, 7200, (-18000), (-14400)], [1947271, 7200, (-14400), (-18000)], [1948116, 7200, (-18000), (-14400)], [1948270, 7200, (-14400), (-18000)], [1949114, 7200, (-18000), (-14400)], [1949268, 7200, (-14400), (-18000)], [1950120, 7200, (-18000), (-14400)], [1950267, 7200, (-14400), (-18000)], [1951119, 7200, (-18000), (-14400)], [1951273, 7200, (-14400), (-18000)], [1952118, 7200, (-18000), (-14400)], [1952272, 7200, (-14400), (-18000)], [1953116, 7200, (-18000), (-14400)], [1953270, 7200, (-14400), (-18000)], [1954115, 7200, (-18000), (-14400)], [1954269, 7200, (-14400), (-18000)], [1955114, 7200, (-18000), (-14400)], [1955303, 7200, (-14400), (-18000)], [1956120, 7200, (-18000), (-14400)], [1956302, 7200, (-14400), (-18000)], [1957118, 7200, (-18000), (-14400)], [1957300, 7200, (-14400), (-18000)], [1958117, 7200, (-18000), (-14400)], [1958299, 7200, (-14400), (-18000)], [1959116, 7200, (-18000), (-14400)], [1959298, 7200, (-14400), (-18000)], [1960115, 7200, (-18000), (-14400)], [1960304, 7200, (-14400), (-18000)], [1961120, 7200, (-18000), (-14400)], [1961302, 7200, (-14400), (-18000)], [1962119, 7200, (-18000), (-14400)], [1962301, 7200, (-14400), (-18000)], [1963118, 7200, (-18000), (-14400)], [1963300, 7200, (-14400), (-18000)], [1964117, 7200, (-18000), (-14400)], [1964299, 7200, (-14400), (-18000)], [1965115, 7200, (-18000), (-14400)], [1965304, 7200, (-14400), (-18000)], [1966114, 7200, (-18000), (-14400)], [1966303, 7200, (-14400), (-18000)], [1967120, 7200, (-18000), (-14400)], [1967302, 7200, (-14400), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1974006, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975054, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameor$__f_America_New_York = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameor$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameor$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameor$.prototype.constructor = $c_Lzonedb_java_tzdb$ameor$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameor$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameor$.prototype = $c_Lzonedb_java_tzdb$ameor$.prototype;
$c_Lzonedb_java_tzdb$ameor$.prototype.America_New_York__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameor$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 222")
  };
  return this.Lzonedb_java_tzdb$ameor$__f_America_New_York
});
var $d_Lzonedb_java_tzdb$ameor$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameor$: 0
}, false, "zonedb.java.tzdb$ameor$", {
  Lzonedb_java_tzdb$ameor$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameor$.prototype.$classData = $d_Lzonedb_java_tzdb$ameor$;
var $n_Lzonedb_java_tzdb$ameor$;
function $m_Lzonedb_java_tzdb$ameor$() {
  if ((!$n_Lzonedb_java_tzdb$ameor$)) {
    $n_Lzonedb_java_tzdb$ameor$ = new $c_Lzonedb_java_tzdb$ameor$()
  };
  return $n_Lzonedb_java_tzdb$ameor$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameot$() {
  this.Lzonedb_java_tzdb$ameot$__f_America_Bogota = null;
  this.Lzonedb_java_tzdb$ameot$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameot$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-17776)), $ct_T2__O__O__(new $c_T2(), "w", (-17776)), $ct_T2__O__O__(new $c_T2(), "t", [[1914327, 0, (-17776), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914327, 0, (-17776), (-18000)], [1992124, 0, (-18000), (-14400)], [1993094, 0, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameot$__f_America_Bogota = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameot$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameot$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameot$.prototype.constructor = $c_Lzonedb_java_tzdb$ameot$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameot$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameot$.prototype = $c_Lzonedb_java_tzdb$ameot$.prototype;
$c_Lzonedb_java_tzdb$ameot$.prototype.America_Bogota__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameot$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 888")
  };
  return this.Lzonedb_java_tzdb$ameot$__f_America_Bogota
});
var $d_Lzonedb_java_tzdb$ameot$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameot$: 0
}, false, "zonedb.java.tzdb$ameot$", {
  Lzonedb_java_tzdb$ameot$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameot$.prototype.$classData = $d_Lzonedb_java_tzdb$ameot$;
var $n_Lzonedb_java_tzdb$ameot$;
function $m_Lzonedb_java_tzdb$ameot$() {
  if ((!$n_Lzonedb_java_tzdb$ameot$)) {
    $n_Lzonedb_java_tzdb$ameot$ = new $c_Lzonedb_java_tzdb$ameot$()
  };
  return $n_Lzonedb_java_tzdb$ameot$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameoz$() {
  this.Lzonedb_java_tzdb$ameoz$__f_America_Argentina_Mendoza = null;
  this.Lzonedb_java_tzdb$ameoz$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameoz$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-16516)), $ct_T2__O__O__(new $c_T2(), "w", (-16516)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-16516), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1990062, 82800, (-10800), (-14400)], [1992292, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004144, 0, (-10800), (-14400)], [2004270, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-16516), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-14400)], [1990288, 0, (-14400), (-10800)], [1991060, 0, (-10800), (-14400)], [1991288, 0, (-14400), (-10800)], [1992061, 0, (-10800), (-14400)], [1992292, 0, (-14400), (-7200)], [1993066, 0, (-7200), (-10800)], [2004144, 0, (-10800), (-14400)], [2004270, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameoz$__f_America_Argentina_Mendoza = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameoz$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameoz$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameoz$.prototype.constructor = $c_Lzonedb_java_tzdb$ameoz$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameoz$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameoz$.prototype = $c_Lzonedb_java_tzdb$ameoz$.prototype;
$c_Lzonedb_java_tzdb$ameoz$.prototype.America_Argentina_Mendoza__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameoz$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 131")
  };
  return this.Lzonedb_java_tzdb$ameoz$__f_America_Argentina_Mendoza
});
var $d_Lzonedb_java_tzdb$ameoz$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameoz$: 0
}, false, "zonedb.java.tzdb$ameoz$", {
  Lzonedb_java_tzdb$ameoz$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameoz$.prototype.$classData = $d_Lzonedb_java_tzdb$ameoz$;
var $n_Lzonedb_java_tzdb$ameoz$;
function $m_Lzonedb_java_tzdb$ameoz$() {
  if ((!$n_Lzonedb_java_tzdb$ameoz$)) {
    $n_Lzonedb_java_tzdb$ameoz$ = new $c_Lzonedb_java_tzdb$ameoz$()
  };
  return $n_Lzonedb_java_tzdb$ameoz$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amepa$() {
  this.Lzonedb_java_tzdb$amepa$__f_America_La_Paz = null;
  this.Lzonedb_java_tzdb$amepa$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amepa$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-16356)), $ct_T2__O__O__(new $c_T2(), "w", (-16356)), $ct_T2__O__O__(new $c_T2(), "t", [[1932080, 82800, (-16356), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1931288, 0, (-16356), (-12756)], [1932081, 0, (-12756), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amepa$__f_America_La_Paz = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amepa$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amepa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amepa$.prototype.constructor = $c_Lzonedb_java_tzdb$amepa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amepa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amepa$.prototype = $c_Lzonedb_java_tzdb$amepa$.prototype;
$c_Lzonedb_java_tzdb$amepa$.prototype.America_La_Paz__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amepa$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 803")
  };
  return this.Lzonedb_java_tzdb$amepa$__f_America_La_Paz
});
var $d_Lzonedb_java_tzdb$amepa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amepa$: 0
}, false, "zonedb.java.tzdb$amepa$", {
  Lzonedb_java_tzdb$amepa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amepa$.prototype.$classData = $d_Lzonedb_java_tzdb$amepa$;
var $n_Lzonedb_java_tzdb$amepa$;
function $m_Lzonedb_java_tzdb$amepa$() {
  if ((!$n_Lzonedb_java_tzdb$amepa$)) {
    $n_Lzonedb_java_tzdb$amepa$ = new $c_Lzonedb_java_tzdb$amepa$()
  };
  return $n_Lzonedb_java_tzdb$amepa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amepe$() {
  this.Lzonedb_java_tzdb$amepe$__f_America_Winnipeg = null;
  this.Lzonedb_java_tzdb$amepe$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amepe$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-23316)), $ct_T2__O__O__(new $c_T2(), "w", (-23316)), $ct_T2__O__O__(new $c_T2(), "t", [[1887197, 0, (-23316), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1887197, 0, (-23316), (-21600)], [1916114, 0, (-21600), (-18000)], [1916261, 0, (-18000), (-21600)], [1918104, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1937136, 7200, (-21600), (-18000)], [1937269, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1946132, 7200, (-21600), (-18000)], [1946286, 7200, (-18000), (-21600)], [1947117, 7200, (-21600), (-18000)], [1947271, 7200, (-18000), (-21600)], [1948116, 7200, (-21600), (-18000)], [1948270, 7200, (-18000), (-21600)], [1949114, 7200, (-21600), (-18000)], [1949268, 7200, (-18000), (-21600)], [1950121, 7200, (-21600), (-18000)], [1950273, 7200, (-18000), (-21600)], [1951119, 7200, (-21600), (-18000)], [1951273, 7200, (-18000), (-21600)], [1952118, 7200, (-21600), (-18000)], [1952272, 7200, (-18000), (-21600)], [1953116, 7200, (-21600), (-18000)], [1953270, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1954269, 7200, (-18000), (-21600)], [1955114, 7200, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959298, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963265, 7200, (-18000), (-21600)], [1966114, 7200, (-21600), (-18000)], [1966303, 10800, (-18000), (-21600)], [1967120, 7200, (-21600), (-18000)], [1967302, 10800, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 10800, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 10800, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 10800, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 10800, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 10800, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 10800, (-18000), (-21600)], [1974118, 7200, (-21600), (-18000)], [1974300, 10800, (-18000), (-21600)], [1975117, 7200, (-21600), (-18000)], [1975299, 10800, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 10800, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 10800, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 10800, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 10800, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 10800, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 10800, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 10800, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 10800, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 10800, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 10800, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 10800, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 10800, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 10800, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 10800, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 10800, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 10800, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 10800, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 10800, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 10800, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 10800, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 10800, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 10800, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 10800, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 10800, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 10800, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 10800, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 10800, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 10800, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 10800, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 10800, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amepe$__f_America_Winnipeg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amepe$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amepe$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amepe$.prototype.constructor = $c_Lzonedb_java_tzdb$amepe$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amepe$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amepe$.prototype = $c_Lzonedb_java_tzdb$amepe$.prototype;
$c_Lzonedb_java_tzdb$amepe$.prototype.America_Winnipeg__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amepe$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 632")
  };
  return this.Lzonedb_java_tzdb$amepe$__f_America_Winnipeg
});
var $d_Lzonedb_java_tzdb$amepe$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amepe$: 0
}, false, "zonedb.java.tzdb$amepe$", {
  Lzonedb_java_tzdb$amepe$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amepe$.prototype.$classData = $d_Lzonedb_java_tzdb$amepe$;
var $n_Lzonedb_java_tzdb$amepe$;
function $m_Lzonedb_java_tzdb$amepe$() {
  if ((!$n_Lzonedb_java_tzdb$amepe$)) {
    $n_Lzonedb_java_tzdb$amepe$ = new $c_Lzonedb_java_tzdb$amepe$()
  };
  return $n_Lzonedb_java_tzdb$amepe$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amequ$() {
  this.Lzonedb_java_tzdb$amequ$__f_America_Martinique = null;
  this.Lzonedb_java_tzdb$amequ$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amequ$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-14660)), $ct_T2__O__O__(new $c_T2(), "w", (-14660)), $ct_T2__O__O__(new $c_T2(), "t", [[1911121, 0, (-14660), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1911121, 0, (-14660), (-14400)], [1980097, 0, (-14400), (-10800)], [1980272, 0, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amequ$__f_America_Martinique = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amequ$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amequ$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amequ$.prototype.constructor = $c_Lzonedb_java_tzdb$amequ$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amequ$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amequ$.prototype = $c_Lzonedb_java_tzdb$amequ$.prototype;
$c_Lzonedb_java_tzdb$amequ$.prototype.America_Martinique__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amequ$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 429")
  };
  return this.Lzonedb_java_tzdb$amequ$__f_America_Martinique
});
var $d_Lzonedb_java_tzdb$amequ$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amequ$: 0
}, false, "zonedb.java.tzdb$amequ$", {
  Lzonedb_java_tzdb$amequ$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amequ$.prototype.$classData = $d_Lzonedb_java_tzdb$amequ$;
var $n_Lzonedb_java_tzdb$amequ$;
function $m_Lzonedb_java_tzdb$amequ$() {
  if ((!$n_Lzonedb_java_tzdb$amequ$)) {
    $n_Lzonedb_java_tzdb$amequ$ = new $c_Lzonedb_java_tzdb$amequ$()
  };
  return $n_Lzonedb_java_tzdb$amequ$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amera$() {
  this.Lzonedb_java_tzdb$amera$__f_America_Bahia_Banderas = null;
  this.Lzonedb_java_tzdb$amera$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amera$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-25260)), $ct_T2__O__O__(new $c_T2(), "w", (-25260)), $ct_T2__O__O__(new $c_T2(), "t", [[1921365, 86340, (-25260), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)], [2010094, 7200, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921365, 86340, (-25260), (-25200)], [1927161, 82800, (-25200), (-21600)], [1930319, 0, (-21600), (-25200)], [1931121, 82800, (-25200), (-21600)], [1931274, 0, (-21600), (-25200)], [1932092, 0, (-25200), (-21600)], [1942114, 0, (-21600), (-25200)], [1949014, 0, (-25200), (-28800)], [1970001, 0, (-28800), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001126, 7200, (-25200), (-21600)], [2001273, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007091, 7200, (-25200), (-21600)], [2007301, 7200, (-21600), (-25200)], [2008097, 7200, (-25200), (-21600)], [2008300, 7200, (-21600), (-25200)], [2009095, 7200, (-25200), (-21600)], [2009298, 7200, (-21600), (-25200)], [2010094, 7200, (-25200), (-18000)], [2010304, 7200, (-18000), (-21600)], [2011093, 7200, (-21600), (-18000)], [2011303, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [10, 25, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amera$__f_America_Bahia_Banderas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amera$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amera$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amera$.prototype.constructor = $c_Lzonedb_java_tzdb$amera$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amera$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amera$.prototype = $c_Lzonedb_java_tzdb$amera$.prototype;
$c_Lzonedb_java_tzdb$amera$.prototype.America_Bahia_Banderas__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amera$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 104")
  };
  return this.Lzonedb_java_tzdb$amera$__f_America_Bahia_Banderas
});
var $d_Lzonedb_java_tzdb$amera$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amera$: 0
}, false, "zonedb.java.tzdb$amera$", {
  Lzonedb_java_tzdb$amera$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amera$.prototype.$classData = $d_Lzonedb_java_tzdb$amera$;
var $n_Lzonedb_java_tzdb$amera$;
function $m_Lzonedb_java_tzdb$amera$() {
  if ((!$n_Lzonedb_java_tzdb$amera$)) {
    $n_Lzonedb_java_tzdb$amera$ = new $c_Lzonedb_java_tzdb$amera$()
  };
  return $n_Lzonedb_java_tzdb$amera$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amerc$() {
  this.Lzonedb_java_tzdb$amerc$__f_America_Argentina_Catamarca = null;
  this.Lzonedb_java_tzdb$amerc$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amerc$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-15788)), $ct_T2__O__O__(new $c_T2(), "w", (-15788)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-15788), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991061, 82800, (-10800), (-14400)], [1991293, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-15788), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-14400)], [1991293, 0, (-14400), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004153, 0, (-10800), (-14400)], [2004172, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amerc$__f_America_Argentina_Catamarca = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amerc$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amerc$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amerc$.prototype.constructor = $c_Lzonedb_java_tzdb$amerc$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amerc$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amerc$.prototype = $c_Lzonedb_java_tzdb$amerc$.prototype;
$c_Lzonedb_java_tzdb$amerc$.prototype.America_Argentina_Catamarca__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amerc$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 704")
  };
  return this.Lzonedb_java_tzdb$amerc$__f_America_Argentina_Catamarca
});
var $d_Lzonedb_java_tzdb$amerc$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amerc$: 0
}, false, "zonedb.java.tzdb$amerc$", {
  Lzonedb_java_tzdb$amerc$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amerc$.prototype.$classData = $d_Lzonedb_java_tzdb$amerc$;
var $n_Lzonedb_java_tzdb$amerc$;
function $m_Lzonedb_java_tzdb$amerc$() {
  if ((!$n_Lzonedb_java_tzdb$amerc$)) {
    $n_Lzonedb_java_tzdb$amerc$ = new $c_Lzonedb_java_tzdb$amerc$()
  };
  return $n_Lzonedb_java_tzdb$amerc$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amere$() {
  this.Lzonedb_java_tzdb$amere$__f_America_Monterrey = null;
  this.Lzonedb_java_tzdb$amere$__f_America_Argentina_Buenos_Aires = null;
  this.Lzonedb_java_tzdb$amere$__f_America_Santarem = null;
  this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$amere$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-24076)), $ct_T2__O__O__(new $c_T2(), "w", (-24076)), $ct_T2__O__O__(new $c_T2(), "t", [[1921365, 83924, (-24076), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921365, 83924, (-24076), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [10, 25, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amere$__f_America_Monterrey = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-14028)), $ct_T2__O__O__(new $c_T2(), "w", (-14028)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-14028), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-14028), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991062, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)], [2008293, 0, (-10800), (-7200)], [2009074, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$amere$__f_America_Argentina_Buenos_Aires = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-13128)), $ct_T2__O__O__(new $c_T2(), "w", (-13128)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-13128), (-14400)], [2008176, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-13128), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [2008176, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$amere$__f_America_Santarem = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$amere$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amere$.prototype.constructor = $c_Lzonedb_java_tzdb$amere$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amere$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amere$.prototype = $c_Lzonedb_java_tzdb$amere$.prototype;
$c_Lzonedb_java_tzdb$amere$.prototype.America_Monterrey__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 152")
  };
  return this.Lzonedb_java_tzdb$amere$__f_America_Monterrey
});
$c_Lzonedb_java_tzdb$amere$.prototype.America_Argentina_Buenos_Aires__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 153")
  };
  return this.Lzonedb_java_tzdb$amere$__f_America_Argentina_Buenos_Aires
});
$c_Lzonedb_java_tzdb$amere$.prototype.America_Santarem__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$amere$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 154")
  };
  return this.Lzonedb_java_tzdb$amere$__f_America_Santarem
});
var $d_Lzonedb_java_tzdb$amere$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amere$: 0
}, false, "zonedb.java.tzdb$amere$", {
  Lzonedb_java_tzdb$amere$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amere$.prototype.$classData = $d_Lzonedb_java_tzdb$amere$;
var $n_Lzonedb_java_tzdb$amere$;
function $m_Lzonedb_java_tzdb$amere$() {
  if ((!$n_Lzonedb_java_tzdb$amere$)) {
    $n_Lzonedb_java_tzdb$amere$ = new $c_Lzonedb_java_tzdb$amere$()
  };
  return $n_Lzonedb_java_tzdb$amere$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amero$() {
  this.Lzonedb_java_tzdb$amero$__f_America_Matamoros = null;
  this.Lzonedb_java_tzdb$amero$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amero$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-24000)), $ct_T2__O__O__(new $c_T2(), "w", (-24000)), $ct_T2__O__O__(new $c_T2(), "t", [[1921365, 84000, (-24000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921365, 84000, (-24000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001126, 7200, (-21600), (-18000)], [2001273, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007091, 7200, (-21600), (-18000)], [2007301, 7200, (-18000), (-21600)], [2008097, 7200, (-21600), (-18000)], [2008300, 7200, (-18000), (-21600)], [2009095, 7200, (-21600), (-18000)], [2009298, 7200, (-18000), (-21600)], [2010073, 7200, (-21600), (-18000)], [2010311, 7200, (-18000), (-21600)], [2011072, 7200, (-21600), (-18000)], [2011310, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amero$__f_America_Matamoros = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amero$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amero$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amero$.prototype.constructor = $c_Lzonedb_java_tzdb$amero$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amero$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amero$.prototype = $c_Lzonedb_java_tzdb$amero$.prototype;
$c_Lzonedb_java_tzdb$amero$.prototype.America_Matamoros__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amero$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 289")
  };
  return this.Lzonedb_java_tzdb$amero$__f_America_Matamoros
});
var $d_Lzonedb_java_tzdb$amero$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amero$: 0
}, false, "zonedb.java.tzdb$amero$", {
  Lzonedb_java_tzdb$amero$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amero$.prototype.$classData = $d_Lzonedb_java_tzdb$amero$;
var $n_Lzonedb_java_tzdb$amero$;
function $m_Lzonedb_java_tzdb$amero$() {
  if ((!$n_Lzonedb_java_tzdb$amero$)) {
    $n_Lzonedb_java_tzdb$amero$ = new $c_Lzonedb_java_tzdb$amero$()
  };
  return $n_Lzonedb_java_tzdb$amero$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amers$() {
  this.Lzonedb_java_tzdb$amers$__f_America_Whitehorse = null;
  this.Lzonedb_java_tzdb$amers$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amers$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-32412)), $ct_T2__O__O__(new $c_T2(), "w", (-32412)), $ct_T2__O__O__(new $c_T2(), "t", [[1900232, 0, (-32412), (-32400)], [1967148, 0, (-32400), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1900232, 0, (-32412), (-32400)], [1918104, 7200, (-32400), (-28800)], [1918300, 7200, (-28800), (-32400)], [1919145, 7200, (-32400), (-28800)], [1919305, 0, (-28800), (-32400)], [1942040, 7200, (-32400), (-28800)], [1945273, 7200, (-28800), (-32400)], [1965115, 0, (-32400), (-25200)], [1965304, 7200, (-25200), (-32400)], [1967148, 0, (-32400), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amers$__f_America_Whitehorse = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amers$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amers$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amers$.prototype.constructor = $c_Lzonedb_java_tzdb$amers$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amers$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amers$.prototype = $c_Lzonedb_java_tzdb$amers$.prototype;
$c_Lzonedb_java_tzdb$amers$.prototype.America_Whitehorse__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amers$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 82")
  };
  return this.Lzonedb_java_tzdb$amers$__f_America_Whitehorse
});
var $d_Lzonedb_java_tzdb$amers$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amers$: 0
}, false, "zonedb.java.tzdb$amers$", {
  Lzonedb_java_tzdb$amers$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amers$.prototype.$classData = $d_Lzonedb_java_tzdb$amers$;
var $n_Lzonedb_java_tzdb$amers$;
function $m_Lzonedb_java_tzdb$amers$() {
  if ((!$n_Lzonedb_java_tzdb$amers$)) {
    $n_Lzonedb_java_tzdb$amers$ = new $c_Lzonedb_java_tzdb$amers$()
  };
  return $n_Lzonedb_java_tzdb$amers$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amesa$() {
  this.Lzonedb_java_tzdb$amesa$__f_America_Nassau = null;
  this.Lzonedb_java_tzdb$amesa$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amesa$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-18570)), $ct_T2__O__O__(new $c_T2(), "w", (-18570)), $ct_T2__O__O__(new $c_T2(), "t", [[1912062, 0, (-18570), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912062, 0, (-18570), (-18000)], [1964117, 7200, (-18000), (-14400)], [1964299, 7200, (-14400), (-18000)], [1965115, 7200, (-18000), (-14400)], [1965304, 7200, (-14400), (-18000)], [1966114, 7200, (-18000), (-14400)], [1966303, 7200, (-14400), (-18000)], [1967120, 7200, (-18000), (-14400)], [1967302, 7200, (-14400), (-18000)], [1968119, 7200, (-18000), (-14400)], [1968301, 7200, (-14400), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [1973119, 7200, (-18000), (-14400)], [1973301, 7200, (-14400), (-18000)], [1974118, 7200, (-18000), (-14400)], [1974300, 7200, (-14400), (-18000)], [1975117, 7200, (-18000), (-14400)], [1975299, 7200, (-14400), (-18000)], [1976116, 7200, (-18000), (-14400)], [1976305, 7200, (-14400), (-18000)], [1977114, 7200, (-18000), (-14400)], [1977303, 7200, (-14400), (-18000)], [1978120, 7200, (-18000), (-14400)], [1978302, 7200, (-14400), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amesa$__f_America_Nassau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amesa$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amesa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amesa$.prototype.constructor = $c_Lzonedb_java_tzdb$amesa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amesa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amesa$.prototype = $c_Lzonedb_java_tzdb$amesa$.prototype;
$c_Lzonedb_java_tzdb$amesa$.prototype.America_Nassau__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amesa$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 853")
  };
  return this.Lzonedb_java_tzdb$amesa$__f_America_Nassau
});
var $d_Lzonedb_java_tzdb$amesa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amesa$: 0
}, false, "zonedb.java.tzdb$amesa$", {
  Lzonedb_java_tzdb$amesa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amesa$.prototype.$classData = $d_Lzonedb_java_tzdb$amesa$;
var $n_Lzonedb_java_tzdb$amesa$;
function $m_Lzonedb_java_tzdb$amesa$() {
  if ((!$n_Lzonedb_java_tzdb$amesa$)) {
    $n_Lzonedb_java_tzdb$amesa$ = new $c_Lzonedb_java_tzdb$amesa$()
  };
  return $n_Lzonedb_java_tzdb$amesa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameso$() {
  this.Lzonedb_java_tzdb$ameso$__f_America_Dawson = null;
  this.Lzonedb_java_tzdb$ameso$__f_America_Fort_Nelson = null;
  this.Lzonedb_java_tzdb$ameso$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameso$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-33460)), $ct_T2__O__O__(new $c_T2(), "w", (-33460)), $ct_T2__O__O__(new $c_T2(), "t", [[1900232, 0, (-33460), (-32400)], [1973301, 0, (-32400), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1900232, 0, (-33460), (-32400)], [1918104, 7200, (-32400), (-28800)], [1918300, 7200, (-28800), (-32400)], [1919145, 7200, (-32400), (-28800)], [1919305, 0, (-28800), (-32400)], [1942040, 7200, (-32400), (-28800)], [1945273, 7200, (-28800), (-32400)], [1965115, 0, (-32400), (-25200)], [1965304, 7200, (-25200), (-32400)], [1973301, 0, (-32400), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameso$__f_America_Dawson = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameso$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameso$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-29447)), $ct_T2__O__O__(new $c_T2(), "w", (-29447)), $ct_T2__O__O__(new $c_T2(), "t", [[1884001, 0, (-29447), (-28800)], [2015067, 7200, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1884001, 0, (-29447), (-28800)], [1918104, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1947117, 7200, (-28800), (-25200)], [1947271, 7200, (-25200), (-28800)], [1948116, 7200, (-28800), (-25200)], [1948270, 7200, (-25200), (-28800)], [1949114, 7200, (-28800), (-25200)], [1949268, 7200, (-25200), (-28800)], [1950120, 7200, (-28800), (-25200)], [1950267, 7200, (-25200), (-28800)], [1951119, 7200, (-28800), (-25200)], [1951273, 7200, (-25200), (-28800)], [1952118, 7200, (-28800), (-25200)], [1952272, 7200, (-25200), (-28800)], [1953116, 7200, (-28800), (-25200)], [1953270, 7200, (-25200), (-28800)], [1954115, 7200, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 7200, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 7200, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 7200, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 7200, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 7200, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 7200, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1961120, 7200, (-28800), (-25200)], [1961267, 7200, (-25200), (-28800)], [1962119, 7200, (-28800), (-25200)], [1962301, 7200, (-25200), (-28800)], [1963118, 7200, (-28800), (-25200)], [1963300, 7200, (-25200), (-28800)], [1964117, 7200, (-28800), (-25200)], [1964299, 7200, (-25200), (-28800)], [1965115, 7200, (-28800), (-25200)], [1965304, 7200, (-25200), (-28800)], [1966114, 7200, (-28800), (-25200)], [1966303, 7200, (-25200), (-28800)], [1967120, 7200, (-28800), (-25200)], [1967302, 7200, (-25200), (-28800)], [1968119, 7200, (-28800), (-25200)], [1968301, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974118, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975117, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)], [2009067, 7200, (-28800), (-25200)], [2009305, 7200, (-25200), (-28800)], [2010073, 7200, (-28800), (-25200)], [2010311, 7200, (-25200), (-28800)], [2011072, 7200, (-28800), (-25200)], [2011310, 7200, (-25200), (-28800)], [2012071, 7200, (-28800), (-25200)], [2012309, 7200, (-25200), (-28800)], [2013069, 7200, (-28800), (-25200)], [2013307, 7200, (-25200), (-28800)], [2014068, 7200, (-28800), (-25200)], [2014306, 7200, (-25200), (-28800)], [2015067, 7200, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameso$__f_America_Fort_Nelson = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameso$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameso$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameso$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameso$.prototype.constructor = $c_Lzonedb_java_tzdb$ameso$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameso$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameso$.prototype = $c_Lzonedb_java_tzdb$ameso$.prototype;
$c_Lzonedb_java_tzdb$ameso$.prototype.America_Dawson__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameso$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 18")
  };
  return this.Lzonedb_java_tzdb$ameso$__f_America_Dawson
});
$c_Lzonedb_java_tzdb$ameso$.prototype.America_Fort_Nelson__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameso$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 19")
  };
  return this.Lzonedb_java_tzdb$ameso$__f_America_Fort_Nelson
});
var $d_Lzonedb_java_tzdb$ameso$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameso$: 0
}, false, "zonedb.java.tzdb$ameso$", {
  Lzonedb_java_tzdb$ameso$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameso$.prototype.$classData = $d_Lzonedb_java_tzdb$ameso$;
var $n_Lzonedb_java_tzdb$ameso$;
function $m_Lzonedb_java_tzdb$ameso$() {
  if ((!$n_Lzonedb_java_tzdb$ameso$)) {
    $n_Lzonedb_java_tzdb$ameso$ = new $c_Lzonedb_java_tzdb$ameso$()
  };
  return $n_Lzonedb_java_tzdb$ameso$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amest$() {
  this.Lzonedb_java_tzdb$amest$__f_America_Boa_Vista = null;
  this.Lzonedb_java_tzdb$amest$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amest$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-14560)), $ct_T2__O__O__(new $c_T2(), "w", (-14560)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-14560), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-14560), (-14400)], [1931276, 39600, (-14400), (-10800)], [1932092, 0, (-10800), (-14400)], [1932277, 0, (-14400), (-10800)], [1933091, 0, (-10800), (-14400)], [1949335, 0, (-14400), (-10800)], [1950106, 3600, (-10800), (-14400)], [1950335, 0, (-14400), (-10800)], [1951091, 0, (-10800), (-14400)], [1951335, 0, (-14400), (-10800)], [1952092, 0, (-10800), (-14400)], [1952336, 0, (-14400), (-10800)], [1953060, 0, (-10800), (-14400)], [1963343, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1965031, 0, (-14400), (-10800)], [1965090, 0, (-10800), (-14400)], [1965335, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966305, 0, (-14400), (-10800)], [1967060, 0, (-10800), (-14400)], [1967305, 0, (-14400), (-10800)], [1968061, 0, (-10800), (-14400)], [1985306, 0, (-14400), (-10800)], [1986074, 0, (-10800), (-14400)], [1986298, 0, (-14400), (-10800)], [1987045, 0, (-10800), (-14400)], [1987298, 0, (-14400), (-10800)], [1988038, 0, (-10800), (-14400)], [1999276, 0, (-14400), (-10800)], [2000058, 0, (-10800), (-14400)], [2000282, 0, (-14400), (-10800)], [2000289, 0, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amest$__f_America_Boa_Vista = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amest$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amest$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amest$.prototype.constructor = $c_Lzonedb_java_tzdb$amest$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amest$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amest$.prototype = $c_Lzonedb_java_tzdb$amest$.prototype;
$c_Lzonedb_java_tzdb$amest$.prototype.America_Boa_Vista__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amest$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 88")
  };
  return this.Lzonedb_java_tzdb$amest$__f_America_Boa_Vista
});
var $d_Lzonedb_java_tzdb$amest$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amest$: 0
}, false, "zonedb.java.tzdb$amest$", {
  Lzonedb_java_tzdb$amest$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amest$.prototype.$classData = $d_Lzonedb_java_tzdb$amest$;
var $n_Lzonedb_java_tzdb$amest$;
function $m_Lzonedb_java_tzdb$amest$() {
  if ((!$n_Lzonedb_java_tzdb$amest$)) {
    $n_Lzonedb_java_tzdb$amest$ = new $c_Lzonedb_java_tzdb$amest$()
  };
  return $n_Lzonedb_java_tzdb$amest$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameta$() {
  this.Lzonedb_java_tzdb$ameta$__f_America_Yakutat = null;
  this.Lzonedb_java_tzdb$ameta$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameta$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 52865), $ct_T2__O__O__(new $c_T2(), "w", 52865), $ct_T2__O__O__(new $c_T2(), "t", [[1867292, 54738, 52865, (-33535)], [1900232, 43200, (-33535), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1867292, 54738, 52865, (-33535)], [1900232, 43200, (-33535), (-32400)], [1942040, 7200, (-32400), (-28800)], [1945273, 7200, (-28800), (-32400)], [1969117, 7200, (-32400), (-28800)], [1969299, 7200, (-28800), (-32400)], [1970116, 7200, (-32400), (-28800)], [1970298, 7200, (-28800), (-32400)], [1971115, 7200, (-32400), (-28800)], [1971304, 7200, (-28800), (-32400)], [1972121, 7200, (-32400), (-28800)], [1972303, 7200, (-28800), (-32400)], [1973119, 7200, (-32400), (-28800)], [1973301, 7200, (-28800), (-32400)], [1974006, 7200, (-32400), (-28800)], [1974300, 7200, (-28800), (-32400)], [1975054, 7200, (-32400), (-28800)], [1975299, 7200, (-28800), (-32400)], [1976116, 7200, (-32400), (-28800)], [1976305, 7200, (-28800), (-32400)], [1977114, 7200, (-32400), (-28800)], [1977303, 7200, (-28800), (-32400)], [1978120, 7200, (-32400), (-28800)], [1978302, 7200, (-28800), (-32400)], [1979119, 7200, (-32400), (-28800)], [1979301, 7200, (-28800), (-32400)], [1980118, 7200, (-32400), (-28800)], [1980300, 7200, (-28800), (-32400)], [1981116, 7200, (-32400), (-28800)], [1981298, 7200, (-28800), (-32400)], [1982115, 7200, (-32400), (-28800)], [1982304, 7200, (-28800), (-32400)], [1983114, 7200, (-32400), (-28800)], [1983303, 7200, (-28800), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameta$__f_America_Yakutat = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameta$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameta$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameta$.prototype.constructor = $c_Lzonedb_java_tzdb$ameta$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameta$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameta$.prototype = $c_Lzonedb_java_tzdb$ameta$.prototype;
$c_Lzonedb_java_tzdb$ameta$.prototype.America_Yakutat__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameta$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 457")
  };
  return this.Lzonedb_java_tzdb$ameta$__f_America_Yakutat
});
var $d_Lzonedb_java_tzdb$ameta$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameta$: 0
}, false, "zonedb.java.tzdb$ameta$", {
  Lzonedb_java_tzdb$ameta$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameta$.prototype.$classData = $d_Lzonedb_java_tzdb$ameta$;
var $n_Lzonedb_java_tzdb$ameta$;
function $m_Lzonedb_java_tzdb$ameta$() {
  if ((!$n_Lzonedb_java_tzdb$ameta$)) {
    $n_Lzonedb_java_tzdb$ameta$ = new $c_Lzonedb_java_tzdb$ameta$()
  };
  return $n_Lzonedb_java_tzdb$ameta$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amete$() {
  this.Lzonedb_java_tzdb$amete$__f_America_North_Dakota_Center = null;
  this.Lzonedb_java_tzdb$amete$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amete$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-24312)), $ct_T2__O__O__(new $c_T2(), "w", (-24312)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44088, (-24312), (-25200)], [1992299, 3600, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44088, (-24312), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974006, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amete$__f_America_North_Dakota_Center = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amete$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amete$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amete$.prototype.constructor = $c_Lzonedb_java_tzdb$amete$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amete$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amete$.prototype = $c_Lzonedb_java_tzdb$amete$.prototype;
$c_Lzonedb_java_tzdb$amete$.prototype.America_North_Dakota_Center__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amete$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 747")
  };
  return this.Lzonedb_java_tzdb$amete$__f_America_North_Dakota_Center
});
var $d_Lzonedb_java_tzdb$amete$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amete$: 0
}, false, "zonedb.java.tzdb$amete$", {
  Lzonedb_java_tzdb$amete$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amete$.prototype.$classData = $d_Lzonedb_java_tzdb$amete$;
var $n_Lzonedb_java_tzdb$amete$;
function $m_Lzonedb_java_tzdb$amete$() {
  if ((!$n_Lzonedb_java_tzdb$amete$)) {
    $n_Lzonedb_java_tzdb$amete$ = new $c_Lzonedb_java_tzdb$amete$()
  };
  return $n_Lzonedb_java_tzdb$amete$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ametk$() {
  this.Lzonedb_java_tzdb$ametk$__f_America_Sitka = null;
  this.Lzonedb_java_tzdb$ametk$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ametk$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 53927), $ct_T2__O__O__(new $c_T2(), "w", 53927), $ct_T2__O__O__(new $c_T2(), "t", [[1867292, 55800, 53927, (-32473)], [1900232, 43200, (-32473), (-28800)], [1983303, 3600, (-28800), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1867292, 55800, 53927, (-32473)], [1900232, 43200, (-32473), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974006, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975054, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-32400)], [1984120, 7200, (-32400), (-28800)], [1984302, 7200, (-28800), (-32400)], [1985118, 7200, (-32400), (-28800)], [1985300, 7200, (-28800), (-32400)], [1986117, 7200, (-32400), (-28800)], [1986299, 7200, (-28800), (-32400)], [1987095, 7200, (-32400), (-28800)], [1987298, 7200, (-28800), (-32400)], [1988094, 7200, (-32400), (-28800)], [1988304, 7200, (-28800), (-32400)], [1989092, 7200, (-32400), (-28800)], [1989302, 7200, (-28800), (-32400)], [1990091, 7200, (-32400), (-28800)], [1990301, 7200, (-28800), (-32400)], [1991097, 7200, (-32400), (-28800)], [1991300, 7200, (-28800), (-32400)], [1992096, 7200, (-32400), (-28800)], [1992299, 7200, (-28800), (-32400)], [1993094, 7200, (-32400), (-28800)], [1993304, 7200, (-28800), (-32400)], [1994093, 7200, (-32400), (-28800)], [1994303, 7200, (-28800), (-32400)], [1995092, 7200, (-32400), (-28800)], [1995302, 7200, (-28800), (-32400)], [1996098, 7200, (-32400), (-28800)], [1996301, 7200, (-28800), (-32400)], [1997096, 7200, (-32400), (-28800)], [1997299, 7200, (-28800), (-32400)], [1998095, 7200, (-32400), (-28800)], [1998298, 7200, (-28800), (-32400)], [1999094, 7200, (-32400), (-28800)], [1999304, 7200, (-28800), (-32400)], [2000093, 7200, (-32400), (-28800)], [2000303, 7200, (-28800), (-32400)], [2001091, 7200, (-32400), (-28800)], [2001301, 7200, (-28800), (-32400)], [2002097, 7200, (-32400), (-28800)], [2002300, 7200, (-28800), (-32400)], [2003096, 7200, (-32400), (-28800)], [2003299, 7200, (-28800), (-32400)], [2004095, 7200, (-32400), (-28800)], [2004305, 7200, (-28800), (-32400)], [2005093, 7200, (-32400), (-28800)], [2005303, 7200, (-28800), (-32400)], [2006092, 7200, (-32400), (-28800)], [2006302, 7200, (-28800), (-32400)], [2007070, 7200, (-32400), (-28800)], [2007308, 7200, (-28800), (-32400)], [2008069, 7200, (-32400), (-28800)], [2008307, 7200, (-28800), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ametk$__f_America_Sitka = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ametk$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ametk$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ametk$.prototype.constructor = $c_Lzonedb_java_tzdb$ametk$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ametk$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ametk$.prototype = $c_Lzonedb_java_tzdb$ametk$.prototype;
$c_Lzonedb_java_tzdb$ametk$.prototype.America_Sitka__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ametk$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 59")
  };
  return this.Lzonedb_java_tzdb$ametk$__f_America_Sitka
});
var $d_Lzonedb_java_tzdb$ametk$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ametk$: 0
}, false, "zonedb.java.tzdb$ametk$", {
  Lzonedb_java_tzdb$ametk$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ametk$.prototype.$classData = $d_Lzonedb_java_tzdb$ametk$;
var $n_Lzonedb_java_tzdb$ametk$;
function $m_Lzonedb_java_tzdb$ametk$() {
  if ((!$n_Lzonedb_java_tzdb$ametk$)) {
    $n_Lzonedb_java_tzdb$ametk$ = new $c_Lzonedb_java_tzdb$ametk$()
  };
  return $n_Lzonedb_java_tzdb$ametk$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ametl$() {
  this.Lzonedb_java_tzdb$ametl$__f_America_Metlakatla = null;
  this.Lzonedb_java_tzdb$ametl$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ametl$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 54822), $ct_T2__O__O__(new $c_T2(), "w", 54822), $ct_T2__O__O__(new $c_T2(), "t", [[1867292, 56695, 54822, (-31578)], [1900232, 43200, (-31578), (-28800)], [2015305, 7200, (-28800), (-32400)], [2018308, 3600, (-32400), (-28800)], [2019020, 7200, (-28800), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1867292, 56695, 54822, (-31578)], [1900232, 43200, (-31578), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974006, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975054, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [2015305, 7200, (-28800), (-32400)], [2016073, 7200, (-32400), (-28800)], [2016311, 7200, (-28800), (-32400)], [2017071, 7200, (-32400), (-28800)], [2017309, 7200, (-28800), (-32400)], [2018070, 7200, (-32400), (-28800)], [2019020, 7200, (-28800), (-32400)], [2019069, 7200, (-32400), (-28800)], [2019307, 7200, (-28800), (-32400)], [2020068, 7200, (-32400), (-28800)], [2020306, 7200, (-28800), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-32400), (-32400), (-28800)], [11, 1, 7, 7200, 0, 1, (-32400), (-28800), (-32400)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ametl$__f_America_Metlakatla = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ametl$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ametl$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ametl$.prototype.constructor = $c_Lzonedb_java_tzdb$ametl$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ametl$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ametl$.prototype = $c_Lzonedb_java_tzdb$ametl$.prototype;
$c_Lzonedb_java_tzdb$ametl$.prototype.America_Metlakatla__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ametl$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 166")
  };
  return this.Lzonedb_java_tzdb$ametl$__f_America_Metlakatla
});
var $d_Lzonedb_java_tzdb$ametl$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ametl$: 0
}, false, "zonedb.java.tzdb$ametl$", {
  Lzonedb_java_tzdb$ametl$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ametl$.prototype.$classData = $d_Lzonedb_java_tzdb$ametl$;
var $n_Lzonedb_java_tzdb$ametl$;
function $m_Lzonedb_java_tzdb$ametl$() {
  if ((!$n_Lzonedb_java_tzdb$ametl$)) {
    $n_Lzonedb_java_tzdb$ametl$ = new $c_Lzonedb_java_tzdb$ametl$()
  };
  return $n_Lzonedb_java_tzdb$ametl$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameto$() {
  this.Lzonedb_java_tzdb$ameto$__f_America_Creston = null;
  this.Lzonedb_java_tzdb$ameto$__f_America_Moncton = null;
  this.Lzonedb_java_tzdb$ameto$__f_America_Edmonton = null;
  this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameto$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-27964)), $ct_T2__O__O__(new $c_T2(), "w", (-27964)), $ct_T2__O__O__(new $c_T2(), "t", [[1884001, 0, (-27964), (-25200)], [1916275, 0, (-25200), (-28800)], [1918153, 0, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1884001, 0, (-27964), (-25200)], [1916275, 0, (-25200), (-28800)], [1918153, 0, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameto$__f_America_Creston = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-15548)), $ct_T2__O__O__(new $c_T2(), "w", (-15548)), $ct_T2__O__O__(new $c_T2(), "t", [[1883343, 0, (-15548), (-18000)], [1902166, 0, (-18000), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883343, 0, (-15548), (-18000)], [1902166, 0, (-18000), (-14400)], [1918104, 7200, (-14400), (-10800)], [1918300, 7200, (-10800), (-14400)], [1933162, 3600, (-14400), (-10800)], [1933253, 3600, (-10800), (-14400)], [1934161, 3600, (-14400), (-10800)], [1934252, 3600, (-10800), (-14400)], [1935160, 3600, (-14400), (-10800)], [1935251, 3600, (-10800), (-14400)], [1936159, 3600, (-14400), (-10800)], [1936250, 3600, (-10800), (-14400)], [1937157, 3600, (-14400), (-10800)], [1937248, 3600, (-10800), (-14400)], [1938156, 3600, (-14400), (-10800)], [1938247, 3600, (-10800), (-14400)], [1939147, 3600, (-14400), (-10800)], [1939266, 3600, (-10800), (-14400)], [1940140, 3600, (-14400), (-10800)], [1940265, 3600, (-10800), (-14400)], [1941124, 3600, (-14400), (-10800)], [1941270, 3600, (-10800), (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)], [1946118, 7200, (-14400), (-10800)], [1946272, 7200, (-10800), (-14400)], [1947117, 7200, (-14400), (-10800)], [1947271, 7200, (-10800), (-14400)], [1948116, 7200, (-14400), (-10800)], [1948270, 7200, (-10800), (-14400)], [1949114, 7200, (-14400), (-10800)], [1949268, 7200, (-10800), (-14400)], [1950120, 7200, (-14400), (-10800)], [1950267, 7200, (-10800), (-14400)], [1951119, 7200, (-14400), (-10800)], [1951273, 7200, (-10800), (-14400)], [1952118, 7200, (-14400), (-10800)], [1952272, 7200, (-10800), (-14400)], [1953116, 7200, (-14400), (-10800)], [1953270, 7200, (-10800), (-14400)], [1954115, 7200, (-14400), (-10800)], [1954269, 7200, (-10800), (-14400)], [1955114, 7200, (-14400), (-10800)], [1955268, 7200, (-10800), (-14400)], [1956120, 7200, (-14400), (-10800)], [1956274, 7200, (-10800), (-14400)], [1957118, 7200, (-14400), (-10800)], [1957300, 7200, (-10800), (-14400)], [1958117, 7200, (-14400), (-10800)], [1958299, 7200, (-10800), (-14400)], [1959116, 7200, (-14400), (-10800)], [1959298, 7200, (-10800), (-14400)], [1960115, 7200, (-14400), (-10800)], [1960304, 7200, (-10800), (-14400)], [1961120, 7200, (-14400), (-10800)], [1961302, 7200, (-10800), (-14400)], [1962119, 7200, (-14400), (-10800)], [1962301, 7200, (-10800), (-14400)], [1963118, 7200, (-14400), (-10800)], [1963300, 7200, (-10800), (-14400)], [1964117, 7200, (-14400), (-10800)], [1964299, 7200, (-10800), (-14400)], [1965115, 7200, (-14400), (-10800)], [1965304, 7200, (-10800), (-14400)], [1966114, 7200, (-14400), (-10800)], [1966303, 7200, (-10800), (-14400)], [1967120, 7200, (-14400), (-10800)], [1967302, 7200, (-10800), (-14400)], [1968119, 7200, (-14400), (-10800)], [1968301, 7200, (-10800), (-14400)], [1969117, 7200, (-14400), (-10800)], [1969299, 7200, (-10800), (-14400)], [1970116, 7200, (-14400), (-10800)], [1970298, 7200, (-10800), (-14400)], [1971115, 7200, (-14400), (-10800)], [1971304, 7200, (-10800), (-14400)], [1972121, 7200, (-14400), (-10800)], [1972303, 7200, (-10800), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 60, (-14400), (-10800)], [1993304, 60, (-10800), (-14400)], [1994093, 60, (-14400), (-10800)], [1994303, 60, (-10800), (-14400)], [1995092, 60, (-14400), (-10800)], [1995302, 60, (-10800), (-14400)], [1996098, 60, (-14400), (-10800)], [1996301, 60, (-10800), (-14400)], [1997096, 60, (-14400), (-10800)], [1997299, 60, (-10800), (-14400)], [1998095, 60, (-14400), (-10800)], [1998298, 60, (-10800), (-14400)], [1999094, 60, (-14400), (-10800)], [1999304, 60, (-10800), (-14400)], [2000093, 60, (-14400), (-10800)], [2000303, 60, (-10800), (-14400)], [2001091, 60, (-14400), (-10800)], [2001301, 60, (-10800), (-14400)], [2002097, 60, (-14400), (-10800)], [2002300, 60, (-10800), (-14400)], [2003096, 60, (-14400), (-10800)], [2003299, 60, (-10800), (-14400)], [2004095, 60, (-14400), (-10800)], [2004305, 60, (-10800), (-14400)], [2005093, 60, (-14400), (-10800)], [2005303, 60, (-10800), (-14400)], [2006092, 60, (-14400), (-10800)], [2006302, 60, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameto$__f_America_Moncton = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-27232)), $ct_T2__O__O__(new $c_T2(), "w", (-27232)), $ct_T2__O__O__(new $c_T2(), "t", [[1906244, 0, (-27232), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1906244, 0, (-27232), (-25200)], [1918104, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919103, 7200, (-25200), (-21600)], [1919147, 7200, (-21600), (-25200)], [1920116, 7200, (-25200), (-21600)], [1920305, 7200, (-21600), (-25200)], [1921114, 7200, (-25200), (-21600)], [1921268, 7200, (-21600), (-25200)], [1922120, 7200, (-25200), (-21600)], [1922267, 7200, (-21600), (-25200)], [1923119, 7200, (-25200), (-21600)], [1923273, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1947117, 7200, (-25200), (-21600)], [1947271, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974118, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975117, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$ameto$__f_America_Edmonton = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameto$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameto$.prototype.constructor = $c_Lzonedb_java_tzdb$ameto$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameto$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameto$.prototype = $c_Lzonedb_java_tzdb$ameto$.prototype;
$c_Lzonedb_java_tzdb$ameto$.prototype.America_Creston__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 903")
  };
  return this.Lzonedb_java_tzdb$ameto$__f_America_Creston
});
$c_Lzonedb_java_tzdb$ameto$.prototype.America_Moncton__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 904")
  };
  return this.Lzonedb_java_tzdb$ameto$__f_America_Moncton
});
$c_Lzonedb_java_tzdb$ameto$.prototype.America_Edmonton__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$ameto$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 905")
  };
  return this.Lzonedb_java_tzdb$ameto$__f_America_Edmonton
});
var $d_Lzonedb_java_tzdb$ameto$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameto$: 0
}, false, "zonedb.java.tzdb$ameto$", {
  Lzonedb_java_tzdb$ameto$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameto$.prototype.$classData = $d_Lzonedb_java_tzdb$ameto$;
var $n_Lzonedb_java_tzdb$ameto$;
function $m_Lzonedb_java_tzdb$ameto$() {
  if ((!$n_Lzonedb_java_tzdb$ameto$)) {
    $n_Lzonedb_java_tzdb$ameto$ = new $c_Lzonedb_java_tzdb$ameto$()
  };
  return $n_Lzonedb_java_tzdb$ameto$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameua$() {
  this.Lzonedb_java_tzdb$ameua$__f_America_Argentina_San_Juan = null;
  this.Lzonedb_java_tzdb$ameua$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameua$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-16444)), $ct_T2__O__O__(new $c_T2(), "w", (-16444)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-16444), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1991059, 82800, (-10800), (-14400)], [1991127, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004152, 0, (-10800), (-14400)], [2004207, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-16444), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990063, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991060, 0, (-7200), (-14400)], [1991127, 0, (-14400), (-10800)], [1991293, 0, (-10800), (-7200)], [1992061, 0, (-7200), (-10800)], [1992292, 0, (-10800), (-7200)], [1993066, 0, (-7200), (-10800)], [2004152, 0, (-10800), (-14400)], [2004207, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008076, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameua$__f_America_Argentina_San_Juan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameua$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameua$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameua$.prototype.constructor = $c_Lzonedb_java_tzdb$ameua$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameua$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameua$.prototype = $c_Lzonedb_java_tzdb$ameua$.prototype;
$c_Lzonedb_java_tzdb$ameua$.prototype.America_Argentina_San_Juan__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameua$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 620")
  };
  return this.Lzonedb_java_tzdb$ameua$__f_America_Argentina_San_Juan
});
var $d_Lzonedb_java_tzdb$ameua$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameua$: 0
}, false, "zonedb.java.tzdb$ameua$", {
  Lzonedb_java_tzdb$ameua$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameua$.prototype.$classData = $d_Lzonedb_java_tzdb$ameua$;
var $n_Lzonedb_java_tzdb$ameua$;
function $m_Lzonedb_java_tzdb$ameua$() {
  if ((!$n_Lzonedb_java_tzdb$ameua$)) {
    $n_Lzonedb_java_tzdb$ameua$ = new $c_Lzonedb_java_tzdb$ameua$()
  };
  return $n_Lzonedb_java_tzdb$ameua$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameui$() {
  this.Lzonedb_java_tzdb$ameui$__f_America_Iqaluit = null;
  this.Lzonedb_java_tzdb$ameui$__f_America_Argentina_San_Luis = null;
  this.Lzonedb_java_tzdb$ameui$__f_America_Guayaquil = null;
  this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameui$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1942213, 0, 0, (-18000)], [1999304, 3600, (-18000), (-21600)], [2000303, 3600, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1942213, 0, 0, (-14400)], [1945273, 7200, (-14400), (-18000)], [1965115, 0, (-18000), (-10800)], [1965304, 7200, (-10800), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameui$__f_America_Iqaluit = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-15924)), $ct_T2__O__O__(new $c_T2(), "w", (-15924)), $ct_T2__O__O__(new $c_T2(), "t", [[1894304, 0, (-15924), (-15408)], [1920122, 0, (-15408), (-14400)], [1969278, 0, (-14400), (-10800)], [1990072, 82800, (-10800), (-14400)], [1991152, 0, (-14400), (-10800)], [1999276, 0, (-10800), (-14400)], [2000062, 82800, (-14400), (-10800)], [2004152, 0, (-10800), (-14400)], [2004207, 0, (-14400), (-10800)], [2008020, 82800, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894304, 0, (-15924), (-15408)], [1920122, 0, (-15408), (-14400)], [1930335, 0, (-14400), (-10800)], [1931091, 0, (-10800), (-14400)], [1931288, 0, (-14400), (-10800)], [1932061, 0, (-10800), (-14400)], [1932306, 0, (-14400), (-10800)], [1933060, 0, (-10800), (-14400)], [1933305, 0, (-14400), (-10800)], [1934060, 0, (-10800), (-14400)], [1934305, 0, (-14400), (-10800)], [1935060, 0, (-10800), (-14400)], [1935305, 0, (-14400), (-10800)], [1936061, 0, (-10800), (-14400)], [1936306, 0, (-14400), (-10800)], [1937060, 0, (-10800), (-14400)], [1937305, 0, (-14400), (-10800)], [1938060, 0, (-10800), (-14400)], [1938305, 0, (-14400), (-10800)], [1939060, 0, (-10800), (-14400)], [1939305, 0, (-14400), (-10800)], [1940061, 0, (-10800), (-14400)], [1940183, 0, (-14400), (-10800)], [1941166, 0, (-10800), (-14400)], [1941288, 0, (-14400), (-10800)], [1943213, 0, (-10800), (-14400)], [1943288, 0, (-14400), (-10800)], [1946060, 0, (-10800), (-14400)], [1946274, 0, (-14400), (-10800)], [1963274, 0, (-10800), (-14400)], [1963349, 0, (-14400), (-10800)], [1964061, 0, (-10800), (-14400)], [1964289, 0, (-14400), (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1988336, 0, (-10800), (-7200)], [1989064, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990073, 0, (-7200), (-14400)], [1990288, 0, (-14400), (-10800)], [1991060, 0, (-10800), (-14400)], [1991152, 0, (-14400), (-10800)], [2004152, 0, (-10800), (-14400)], [2004207, 0, (-14400), (-10800)], [2007364, 0, (-10800), (-7200)], [2008021, 0, (-7200), (-10800)], [2008069, 0, (-10800), (-14400)], [2008286, 0, (-14400), (-10800)], [2009067, 0, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameui$__f_America_Argentina_San_Luis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-19160)), $ct_T2__O__O__(new $c_T2(), "w", (-19160)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-19160), (-18840)], [1931001, 0, (-18840), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-19160), (-18840)], [1931001, 0, (-18840), (-18000)], [1992333, 0, (-18000), (-14400)], [1993036, 0, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$ameui$__f_America_Guayaquil = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameui$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameui$.prototype.constructor = $c_Lzonedb_java_tzdb$ameui$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameui$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameui$.prototype = $c_Lzonedb_java_tzdb$ameui$.prototype;
$c_Lzonedb_java_tzdb$ameui$.prototype.America_Iqaluit__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 730")
  };
  return this.Lzonedb_java_tzdb$ameui$__f_America_Iqaluit
});
$c_Lzonedb_java_tzdb$ameui$.prototype.America_Argentina_San_Luis__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 731")
  };
  return this.Lzonedb_java_tzdb$ameui$__f_America_Argentina_San_Luis
});
$c_Lzonedb_java_tzdb$ameui$.prototype.America_Guayaquil__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$ameui$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 732")
  };
  return this.Lzonedb_java_tzdb$ameui$__f_America_Guayaquil
});
var $d_Lzonedb_java_tzdb$ameui$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameui$: 0
}, false, "zonedb.java.tzdb$ameui$", {
  Lzonedb_java_tzdb$ameui$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameui$.prototype.$classData = $d_Lzonedb_java_tzdb$ameui$;
var $n_Lzonedb_java_tzdb$ameui$;
function $m_Lzonedb_java_tzdb$ameui$() {
  if ((!$n_Lzonedb_java_tzdb$ameui$)) {
    $n_Lzonedb_java_tzdb$ameui$ = new $c_Lzonedb_java_tzdb$ameui$()
  };
  return $n_Lzonedb_java_tzdb$ameui$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameul$() {
  this.Lzonedb_java_tzdb$ameul$__f_America_Sao_Paulo = null;
  this.Lzonedb_java_tzdb$ameul$__f_America_Thule = null;
  this.Lzonedb_java_tzdb$ameul$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameul$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-11188)), $ct_T2__O__O__(new $c_T2(), "w", (-11188)), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, (-11188), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, (-11188), (-10800)], [1931276, 39600, (-10800), (-7200)], [1932092, 0, (-7200), (-10800)], [1932277, 0, (-10800), (-7200)], [1933091, 0, (-7200), (-10800)], [1949335, 0, (-10800), (-7200)], [1950106, 3600, (-7200), (-10800)], [1950335, 0, (-10800), (-7200)], [1951091, 0, (-7200), (-10800)], [1951335, 0, (-10800), (-7200)], [1952092, 0, (-7200), (-10800)], [1952336, 0, (-10800), (-7200)], [1953060, 0, (-7200), (-10800)], [1963296, 0, (-10800), (-7200)], [1964061, 0, (-7200), (-10800)], [1965031, 0, (-10800), (-7200)], [1965090, 0, (-7200), (-10800)], [1965335, 0, (-10800), (-7200)], [1966060, 0, (-7200), (-10800)], [1966305, 0, (-10800), (-7200)], [1967060, 0, (-7200), (-10800)], [1967305, 0, (-10800), (-7200)], [1968061, 0, (-7200), (-10800)], [1985306, 0, (-10800), (-7200)], [1986074, 0, (-7200), (-10800)], [1986298, 0, (-10800), (-7200)], [1987045, 0, (-7200), (-10800)], [1987298, 0, (-10800), (-7200)], [1988038, 0, (-7200), (-10800)], [1988290, 0, (-10800), (-7200)], [1989029, 0, (-7200), (-10800)], [1989288, 0, (-10800), (-7200)], [1990042, 0, (-7200), (-10800)], [1990294, 0, (-10800), (-7200)], [1991048, 0, (-7200), (-10800)], [1991293, 0, (-10800), (-7200)], [1992040, 0, (-7200), (-10800)], [1992299, 0, (-10800), (-7200)], [1993031, 0, (-7200), (-10800)], [1993290, 0, (-10800), (-7200)], [1994051, 0, (-7200), (-10800)], [1994289, 0, (-10800), (-7200)], [1995050, 0, (-7200), (-10800)], [1995288, 0, (-10800), (-7200)], [1996042, 0, (-7200), (-10800)], [1996280, 0, (-10800), (-7200)], [1997047, 0, (-7200), (-10800)], [1997279, 0, (-10800), (-7200)], [1998060, 0, (-7200), (-10800)], [1998284, 0, (-10800), (-7200)], [1999052, 0, (-7200), (-10800)], [1999276, 0, (-10800), (-7200)], [2000058, 0, (-7200), (-10800)], [2000282, 0, (-10800), (-7200)], [2001049, 0, (-7200), (-10800)], [2001287, 0, (-10800), (-7200)], [2002048, 0, (-7200), (-10800)], [2002307, 0, (-10800), (-7200)], [2003047, 0, (-7200), (-10800)], [2003292, 0, (-10800), (-7200)], [2004046, 0, (-7200), (-10800)], [2004307, 0, (-10800), (-7200)], [2005051, 0, (-7200), (-10800)], [2005289, 0, (-10800), (-7200)], [2006050, 0, (-7200), (-10800)], [2006309, 0, (-10800), (-7200)], [2007056, 0, (-7200), (-10800)], [2007287, 0, (-10800), (-7200)], [2008048, 0, (-7200), (-10800)], [2008293, 0, (-10800), (-7200)], [2009046, 0, (-7200), (-10800)], [2009291, 0, (-10800), (-7200)], [2010052, 0, (-7200), (-10800)], [2010290, 0, (-10800), (-7200)], [2011051, 0, (-7200), (-10800)], [2011289, 0, (-10800), (-7200)], [2012057, 0, (-7200), (-10800)], [2012295, 0, (-10800), (-7200)], [2013048, 0, (-7200), (-10800)], [2013293, 0, (-10800), (-7200)], [2014047, 0, (-7200), (-10800)], [2014292, 0, (-10800), (-7200)], [2015053, 0, (-7200), (-10800)], [2015291, 0, (-10800), (-7200)], [2016052, 0, (-7200), (-10800)], [2016290, 0, (-10800), (-7200)], [2017050, 0, (-7200), (-10800)], [2017288, 0, (-10800), (-7200)], [2018049, 0, (-7200), (-10800)], [2018308, 0, (-10800), (-7200)], [2019048, 0, (-7200), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameul$__f_America_Sao_Paulo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameul$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameul$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-16508)), $ct_T2__O__O__(new $c_T2(), "w", (-16508)), $ct_T2__O__O__(new $c_T2(), "t", [[1916210, 0, (-16508), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1916210, 0, (-16508), (-14400)], [1991090, 7200, (-14400), (-10800)], [1991272, 7200, (-10800), (-14400)], [1992089, 7200, (-14400), (-10800)], [1992271, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995092, 7200, (-14400), (-10800)], [1995302, 7200, (-10800), (-14400)], [1996098, 7200, (-14400), (-10800)], [1996301, 7200, (-10800), (-14400)], [1997096, 7200, (-14400), (-10800)], [1997299, 7200, (-10800), (-14400)], [1998095, 7200, (-14400), (-10800)], [1998298, 7200, (-10800), (-14400)], [1999094, 7200, (-14400), (-10800)], [1999304, 7200, (-10800), (-14400)], [2000093, 7200, (-14400), (-10800)], [2000303, 7200, (-10800), (-14400)], [2001091, 7200, (-14400), (-10800)], [2001301, 7200, (-10800), (-14400)], [2002097, 7200, (-14400), (-10800)], [2002300, 7200, (-10800), (-14400)], [2003096, 7200, (-14400), (-10800)], [2003299, 7200, (-10800), (-14400)], [2004095, 7200, (-14400), (-10800)], [2004305, 7200, (-10800), (-14400)], [2005093, 7200, (-14400), (-10800)], [2005303, 7200, (-10800), (-14400)], [2006092, 7200, (-14400), (-10800)], [2006302, 7200, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameul$__f_America_Thule = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameul$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameul$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameul$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameul$.prototype.constructor = $c_Lzonedb_java_tzdb$ameul$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameul$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameul$.prototype = $c_Lzonedb_java_tzdb$ameul$.prototype;
$c_Lzonedb_java_tzdb$ameul$.prototype.America_Sao_Paulo__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameul$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 868")
  };
  return this.Lzonedb_java_tzdb$ameul$__f_America_Sao_Paulo
});
$c_Lzonedb_java_tzdb$ameul$.prototype.America_Thule__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameul$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 869")
  };
  return this.Lzonedb_java_tzdb$ameul$__f_America_Thule
});
var $d_Lzonedb_java_tzdb$ameul$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameul$: 0
}, false, "zonedb.java.tzdb$ameul$", {
  Lzonedb_java_tzdb$ameul$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameul$.prototype.$classData = $d_Lzonedb_java_tzdb$ameul$;
var $n_Lzonedb_java_tzdb$ameul$;
function $m_Lzonedb_java_tzdb$ameul$() {
  if ((!$n_Lzonedb_java_tzdb$ameul$)) {
    $n_Lzonedb_java_tzdb$ameul$ = new $c_Lzonedb_java_tzdb$ameul$()
  };
  return $n_Lzonedb_java_tzdb$ameul$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameun$() {
  this.Lzonedb_java_tzdb$ameun$__f_America_Pangnirtung = null;
  this.Lzonedb_java_tzdb$ameun$__f_America_Scoresbysund = null;
  this.Lzonedb_java_tzdb$ameun$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameun$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1921001, 0, 0, (-14400)], [1995092, 7200, (-14400), (-18000)], [1999304, 3600, (-18000), (-21600)], [2000303, 3600, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921001, 0, 0, (-14400)], [1942040, 7200, (-14400), (-10800)], [1945273, 7200, (-10800), (-14400)], [1965115, 0, (-14400), (-7200)], [1965304, 7200, (-7200), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameun$__f_America_Pangnirtung = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameun$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameun$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-5272)), $ct_T2__O__O__(new $c_T2(), "w", (-5272)), $ct_T2__O__O__(new $c_T2(), "t", [[1916210, 0, (-5272), (-7200)], [1981088, 0, (-7200), (-3600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1916210, 0, (-5272), (-7200)], [1980097, 7200, (-7200), (-3600)], [1980272, 10800, (-3600), (-7200)], [1981088, 0, (-7200), 0], [1981270, 3600, 0, (-3600)], [1982087, 0, (-3600), 0], [1982269, 3600, 0, (-3600)], [1983086, 0, (-3600), 0], [1983268, 3600, 0, (-3600)], [1984085, 0, (-3600), 0], [1984274, 3600, 0, (-3600)], [1985090, 0, (-3600), 0], [1985272, 3600, 0, (-3600)], [1986089, 0, (-3600), 0], [1986271, 3600, 0, (-3600)], [1987088, 0, (-3600), 0], [1987270, 3600, 0, (-3600)], [1988087, 0, (-3600), 0], [1988269, 3600, 0, (-3600)], [1989085, 0, (-3600), 0], [1989267, 3600, 0, (-3600)], [1990084, 0, (-3600), 0], [1990273, 3600, 0, (-3600)], [1991090, 0, (-3600), 0], [1991272, 3600, 0, (-3600)], [1992089, 0, (-3600), 0], [1992271, 3600, 0, (-3600)], [1993087, 0, (-3600), 0], [1993269, 3600, 0, (-3600)], [1994086, 0, (-3600), 0], [1994268, 3600, 0, (-3600)], [1995085, 0, (-3600), 0], [1995267, 3600, 0, (-3600)], [1996091, 0, (-3600), 0], [1996301, 3600, 0, (-3600)], [1997089, 0, (-3600), 0], [1997299, 3600, 0, (-3600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, (-3600), (-3600), 0], [10, 25, 7, 3600, 0, 0, (-3600), 0, (-3600)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameun$__f_America_Scoresbysund = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameun$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameun$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameun$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameun$.prototype.constructor = $c_Lzonedb_java_tzdb$ameun$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameun$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameun$.prototype = $c_Lzonedb_java_tzdb$ameun$.prototype;
$c_Lzonedb_java_tzdb$ameun$.prototype.America_Pangnirtung__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameun$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 476")
  };
  return this.Lzonedb_java_tzdb$ameun$__f_America_Pangnirtung
});
$c_Lzonedb_java_tzdb$ameun$.prototype.America_Scoresbysund__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameun$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 477")
  };
  return this.Lzonedb_java_tzdb$ameun$__f_America_Scoresbysund
});
var $d_Lzonedb_java_tzdb$ameun$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameun$: 0
}, false, "zonedb.java.tzdb$ameun$", {
  Lzonedb_java_tzdb$ameun$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameun$.prototype.$classData = $d_Lzonedb_java_tzdb$ameun$;
var $n_Lzonedb_java_tzdb$ameun$;
function $m_Lzonedb_java_tzdb$ameun$() {
  if ((!$n_Lzonedb_java_tzdb$ameun$)) {
    $n_Lzonedb_java_tzdb$ameun$ = new $c_Lzonedb_java_tzdb$ameun$()
  };
  return $n_Lzonedb_java_tzdb$ameun$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameur$() {
  this.Lzonedb_java_tzdb$ameur$__f_America_Indiana_Petersburg = null;
  this.Lzonedb_java_tzdb$ameur$__f_America_Grand_Turk = null;
  this.Lzonedb_java_tzdb$ameur$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameur$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-20947)), $ct_T2__O__O__(new $c_T2(), "w", (-20947)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 43853, (-20947), (-21600)], [1965115, 7200, (-21600), (-18000)], [1966303, 7200, (-18000), (-21600)], [1977303, 3600, (-21600), (-18000)], [2006092, 7200, (-18000), (-21600)], [2007308, 3600, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 43853, (-20947), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1955121, 0, (-21600), (-18000)], [1955268, 7200, (-18000), (-21600)], [1956120, 7200, (-21600), (-18000)], [1956274, 7200, (-18000), (-21600)], [1957118, 7200, (-21600), (-18000)], [1957272, 7200, (-18000), (-21600)], [1958117, 7200, (-21600), (-18000)], [1958271, 7200, (-18000), (-21600)], [1959116, 7200, (-21600), (-18000)], [1959270, 7200, (-18000), (-21600)], [1960115, 7200, (-21600), (-18000)], [1960269, 7200, (-18000), (-21600)], [1961120, 7200, (-21600), (-18000)], [1961302, 7200, (-18000), (-21600)], [1962119, 7200, (-21600), (-18000)], [1962301, 7200, (-18000), (-21600)], [1963118, 7200, (-21600), (-18000)], [1963300, 7200, (-18000), (-21600)], [1964117, 7200, (-21600), (-18000)], [1964299, 7200, (-18000), (-21600)], [1965115, 7200, (-21600), (-18000)], [1966303, 7200, (-18000), (-21600)], [1967120, 7200, (-21600), (-18000)], [1967302, 7200, (-18000), (-21600)], [1968119, 7200, (-21600), (-18000)], [1968301, 7200, (-18000), (-21600)], [1969117, 7200, (-21600), (-18000)], [1969299, 7200, (-18000), (-21600)], [1970116, 7200, (-21600), (-18000)], [1970298, 7200, (-18000), (-21600)], [1971115, 7200, (-21600), (-18000)], [1971304, 7200, (-18000), (-21600)], [1972121, 7200, (-21600), (-18000)], [1972303, 7200, (-18000), (-21600)], [1973119, 7200, (-21600), (-18000)], [1973301, 7200, (-18000), (-21600)], [1974006, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975054, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameur$__f_America_Indiana_Petersburg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameur$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameur$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-17072)), $ct_T2__O__O__(new $c_T2(), "w", (-17072)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-17072), (-18430)], [1912032, 0, (-18430), (-18000)], [2015305, 3600, (-18000), (-14400)], [2018070, 10800, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-17072), (-18430)], [1912032, 0, (-18430), (-18000)], [1979119, 7200, (-18000), (-14400)], [1979301, 7200, (-14400), (-18000)], [1980118, 7200, (-18000), (-14400)], [1980300, 7200, (-14400), (-18000)], [1981116, 7200, (-18000), (-14400)], [1981298, 7200, (-14400), (-18000)], [1982115, 7200, (-18000), (-14400)], [1982304, 7200, (-14400), (-18000)], [1983114, 7200, (-18000), (-14400)], [1983303, 7200, (-14400), (-18000)], [1984120, 7200, (-18000), (-14400)], [1984302, 7200, (-14400), (-18000)], [1985118, 7200, (-18000), (-14400)], [1985300, 7200, (-14400), (-18000)], [1986117, 7200, (-18000), (-14400)], [1986299, 7200, (-14400), (-18000)], [1987095, 7200, (-18000), (-14400)], [1987298, 7200, (-14400), (-18000)], [1988094, 7200, (-18000), (-14400)], [1988304, 7200, (-14400), (-18000)], [1989092, 7200, (-18000), (-14400)], [1989302, 7200, (-14400), (-18000)], [1990091, 7200, (-18000), (-14400)], [1990301, 7200, (-14400), (-18000)], [1991097, 7200, (-18000), (-14400)], [1991300, 7200, (-14400), (-18000)], [1992096, 7200, (-18000), (-14400)], [1992299, 7200, (-14400), (-18000)], [1993094, 7200, (-18000), (-14400)], [1993304, 7200, (-14400), (-18000)], [1994093, 7200, (-18000), (-14400)], [1994303, 7200, (-14400), (-18000)], [1995092, 7200, (-18000), (-14400)], [1995302, 7200, (-14400), (-18000)], [1996098, 7200, (-18000), (-14400)], [1996301, 7200, (-14400), (-18000)], [1997096, 7200, (-18000), (-14400)], [1997299, 7200, (-14400), (-18000)], [1998095, 7200, (-18000), (-14400)], [1998298, 7200, (-14400), (-18000)], [1999094, 7200, (-18000), (-14400)], [1999304, 7200, (-14400), (-18000)], [2000093, 7200, (-18000), (-14400)], [2000303, 7200, (-14400), (-18000)], [2001091, 7200, (-18000), (-14400)], [2001301, 7200, (-14400), (-18000)], [2002097, 7200, (-18000), (-14400)], [2002300, 7200, (-14400), (-18000)], [2003096, 7200, (-18000), (-14400)], [2003299, 7200, (-14400), (-18000)], [2004095, 7200, (-18000), (-14400)], [2004305, 7200, (-14400), (-18000)], [2005093, 7200, (-18000), (-14400)], [2005303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)], [2009067, 7200, (-18000), (-14400)], [2009305, 7200, (-14400), (-18000)], [2010073, 7200, (-18000), (-14400)], [2010311, 7200, (-14400), (-18000)], [2011072, 7200, (-18000), (-14400)], [2011310, 7200, (-14400), (-18000)], [2012071, 7200, (-18000), (-14400)], [2012309, 7200, (-14400), (-18000)], [2013069, 7200, (-18000), (-14400)], [2013307, 7200, (-14400), (-18000)], [2014068, 7200, (-18000), (-14400)], [2014306, 7200, (-14400), (-18000)], [2015067, 7200, (-18000), (-14400)], [2018308, 7200, (-14400), (-18000)], [2019069, 7200, (-18000), (-14400)], [2019307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameur$__f_America_Grand_Turk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameur$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameur$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameur$.prototype.constructor = $c_Lzonedb_java_tzdb$ameur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameur$.prototype = $c_Lzonedb_java_tzdb$ameur$.prototype;
$c_Lzonedb_java_tzdb$ameur$.prototype.America_Indiana_Petersburg__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameur$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 656")
  };
  return this.Lzonedb_java_tzdb$ameur$__f_America_Indiana_Petersburg
});
$c_Lzonedb_java_tzdb$ameur$.prototype.America_Grand_Turk__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameur$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 657")
  };
  return this.Lzonedb_java_tzdb$ameur$__f_America_Grand_Turk
});
var $d_Lzonedb_java_tzdb$ameur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameur$: 0
}, false, "zonedb.java.tzdb$ameur$", {
  Lzonedb_java_tzdb$ameur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameur$.prototype.$classData = $d_Lzonedb_java_tzdb$ameur$;
var $n_Lzonedb_java_tzdb$ameur$;
function $m_Lzonedb_java_tzdb$ameur$() {
  if ((!$n_Lzonedb_java_tzdb$ameur$)) {
    $n_Lzonedb_java_tzdb$ameur$ = new $c_Lzonedb_java_tzdb$ameur$()
  };
  return $n_Lzonedb_java_tzdb$ameur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameut$() {
  this.Lzonedb_java_tzdb$ameut$__f_America_Resolute = null;
  this.Lzonedb_java_tzdb$ameut$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameut$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1947243, 0, 0, (-21600)], [2000303, 3600, (-21600), (-18000)], [2001091, 10800, (-18000), (-21600)], [2006302, 3600, (-21600), (-18000)], [2007070, 10800, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1947243, 0, 0, (-21600)], [1965115, 0, (-21600), (-14400)], [1965304, 7200, (-14400), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameut$__f_America_Resolute = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameut$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameut$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameut$.prototype.constructor = $c_Lzonedb_java_tzdb$ameut$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameut$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameut$.prototype = $c_Lzonedb_java_tzdb$ameut$.prototype;
$c_Lzonedb_java_tzdb$ameut$.prototype.America_Resolute__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameut$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 76")
  };
  return this.Lzonedb_java_tzdb$ameut$__f_America_Resolute
});
var $d_Lzonedb_java_tzdb$ameut$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameut$: 0
}, false, "zonedb.java.tzdb$ameut$", {
  Lzonedb_java_tzdb$ameut$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameut$.prototype.$classData = $d_Lzonedb_java_tzdb$ameut$;
var $n_Lzonedb_java_tzdb$ameut$;
function $m_Lzonedb_java_tzdb$ameut$() {
  if ((!$n_Lzonedb_java_tzdb$ameut$)) {
    $n_Lzonedb_java_tzdb$ameut$ = new $c_Lzonedb_java_tzdb$ameut$()
  };
  return $n_Lzonedb_java_tzdb$ameut$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameva$() {
  this.Lzonedb_java_tzdb$ameva$__f_America_Indiana_Vevay = null;
  this.Lzonedb_java_tzdb$ameva$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ameva$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-20416)), $ct_T2__O__O__(new $c_T2(), "w", (-20416)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 44384, (-20416), (-21600)], [1954115, 7200, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 44384, (-20416), (-21600)], [1918090, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1919089, 7200, (-21600), (-18000)], [1919299, 7200, (-18000), (-21600)], [1942040, 7200, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1954115, 7200, (-21600), (-18000)], [1969117, 7200, (-18000), (-14400)], [1969299, 7200, (-14400), (-18000)], [1970116, 7200, (-18000), (-14400)], [1970298, 7200, (-14400), (-18000)], [1971115, 7200, (-18000), (-14400)], [1971304, 7200, (-14400), (-18000)], [1972121, 7200, (-18000), (-14400)], [1972303, 7200, (-14400), (-18000)], [2006092, 7200, (-18000), (-14400)], [2006302, 7200, (-14400), (-18000)], [2007070, 7200, (-18000), (-14400)], [2007308, 7200, (-14400), (-18000)], [2008069, 7200, (-18000), (-14400)], [2008307, 7200, (-14400), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-18000), (-18000), (-14400)], [11, 1, 7, 7200, 0, 1, (-18000), (-14400), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameva$__f_America_Indiana_Vevay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameva$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ameva$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameva$.prototype.constructor = $c_Lzonedb_java_tzdb$ameva$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameva$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameva$.prototype = $c_Lzonedb_java_tzdb$ameva$.prototype;
$c_Lzonedb_java_tzdb$ameva$.prototype.America_Indiana_Vevay__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ameva$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 698")
  };
  return this.Lzonedb_java_tzdb$ameva$__f_America_Indiana_Vevay
});
var $d_Lzonedb_java_tzdb$ameva$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameva$: 0
}, false, "zonedb.java.tzdb$ameva$", {
  Lzonedb_java_tzdb$ameva$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameva$.prototype.$classData = $d_Lzonedb_java_tzdb$ameva$;
var $n_Lzonedb_java_tzdb$ameva$;
function $m_Lzonedb_java_tzdb$ameva$() {
  if ((!$n_Lzonedb_java_tzdb$ameva$)) {
    $n_Lzonedb_java_tzdb$ameva$ = new $c_Lzonedb_java_tzdb$ameva$()
  };
  return $n_Lzonedb_java_tzdb$ameva$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ameve$() {
  this.Lzonedb_java_tzdb$ameve$__f_America_Rainy_River = null;
  this.Lzonedb_java_tzdb$ameve$__f_America_Vancouver = null;
  this.Lzonedb_java_tzdb$ameve$__f_America_Denver = null;
  this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$ameve$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-22696)), $ct_T2__O__O__(new $c_T2(), "w", (-22696)), $ct_T2__O__O__(new $c_T2(), "t", [[1895001, 0, (-22696), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895001, 0, (-22696), (-21600)], [1918104, 7200, (-21600), (-18000)], [1918300, 7200, (-18000), (-21600)], [1940273, 0, (-21600), (-18000)], [1945273, 7200, (-18000), (-21600)], [1974118, 7200, (-21600), (-18000)], [1974300, 7200, (-18000), (-21600)], [1975117, 7200, (-21600), (-18000)], [1975299, 7200, (-18000), (-21600)], [1976116, 7200, (-21600), (-18000)], [1976305, 7200, (-18000), (-21600)], [1977114, 7200, (-21600), (-18000)], [1977303, 7200, (-18000), (-21600)], [1978120, 7200, (-21600), (-18000)], [1978302, 7200, (-18000), (-21600)], [1979119, 7200, (-21600), (-18000)], [1979301, 7200, (-18000), (-21600)], [1980118, 7200, (-21600), (-18000)], [1980300, 7200, (-18000), (-21600)], [1981116, 7200, (-21600), (-18000)], [1981298, 7200, (-18000), (-21600)], [1982115, 7200, (-21600), (-18000)], [1982304, 7200, (-18000), (-21600)], [1983114, 7200, (-21600), (-18000)], [1983303, 7200, (-18000), (-21600)], [1984120, 7200, (-21600), (-18000)], [1984302, 7200, (-18000), (-21600)], [1985118, 7200, (-21600), (-18000)], [1985300, 7200, (-18000), (-21600)], [1986117, 7200, (-21600), (-18000)], [1986299, 7200, (-18000), (-21600)], [1987095, 7200, (-21600), (-18000)], [1987298, 7200, (-18000), (-21600)], [1988094, 7200, (-21600), (-18000)], [1988304, 7200, (-18000), (-21600)], [1989092, 7200, (-21600), (-18000)], [1989302, 7200, (-18000), (-21600)], [1990091, 7200, (-21600), (-18000)], [1990301, 7200, (-18000), (-21600)], [1991097, 7200, (-21600), (-18000)], [1991300, 7200, (-18000), (-21600)], [1992096, 7200, (-21600), (-18000)], [1992299, 7200, (-18000), (-21600)], [1993094, 7200, (-21600), (-18000)], [1993304, 7200, (-18000), (-21600)], [1994093, 7200, (-21600), (-18000)], [1994303, 7200, (-18000), (-21600)], [1995092, 7200, (-21600), (-18000)], [1995302, 7200, (-18000), (-21600)], [1996098, 7200, (-21600), (-18000)], [1996301, 7200, (-18000), (-21600)], [1997096, 7200, (-21600), (-18000)], [1997299, 7200, (-18000), (-21600)], [1998095, 7200, (-21600), (-18000)], [1998298, 7200, (-18000), (-21600)], [1999094, 7200, (-21600), (-18000)], [1999304, 7200, (-18000), (-21600)], [2000093, 7200, (-21600), (-18000)], [2000303, 7200, (-18000), (-21600)], [2001091, 7200, (-21600), (-18000)], [2001301, 7200, (-18000), (-21600)], [2002097, 7200, (-21600), (-18000)], [2002300, 7200, (-18000), (-21600)], [2003096, 7200, (-21600), (-18000)], [2003299, 7200, (-18000), (-21600)], [2004095, 7200, (-21600), (-18000)], [2004305, 7200, (-18000), (-21600)], [2005093, 7200, (-21600), (-18000)], [2005303, 7200, (-18000), (-21600)], [2006092, 7200, (-21600), (-18000)], [2006302, 7200, (-18000), (-21600)], [2007070, 7200, (-21600), (-18000)], [2007308, 7200, (-18000), (-21600)], [2008069, 7200, (-21600), (-18000)], [2008307, 7200, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-21600), (-21600), (-18000)], [11, 1, 7, 7200, 0, 1, (-21600), (-18000), (-21600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ameve$__f_America_Rainy_River = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-29548)), $ct_T2__O__O__(new $c_T2(), "w", (-29548)), $ct_T2__O__O__(new $c_T2(), "t", [[1884001, 0, (-29548), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1884001, 0, (-29548), (-28800)], [1918104, 7200, (-28800), (-25200)], [1918300, 7200, (-25200), (-28800)], [1942040, 7200, (-28800), (-25200)], [1945273, 7200, (-25200), (-28800)], [1946118, 7200, (-28800), (-25200)], [1946272, 7200, (-25200), (-28800)], [1947117, 7200, (-28800), (-25200)], [1947271, 7200, (-25200), (-28800)], [1948116, 7200, (-28800), (-25200)], [1948270, 7200, (-25200), (-28800)], [1949114, 7200, (-28800), (-25200)], [1949268, 7200, (-25200), (-28800)], [1950120, 7200, (-28800), (-25200)], [1950267, 7200, (-25200), (-28800)], [1951119, 7200, (-28800), (-25200)], [1951273, 7200, (-25200), (-28800)], [1952118, 7200, (-28800), (-25200)], [1952272, 7200, (-25200), (-28800)], [1953116, 7200, (-28800), (-25200)], [1953270, 7200, (-25200), (-28800)], [1954115, 7200, (-28800), (-25200)], [1954269, 7200, (-25200), (-28800)], [1955114, 7200, (-28800), (-25200)], [1955268, 7200, (-25200), (-28800)], [1956120, 7200, (-28800), (-25200)], [1956274, 7200, (-25200), (-28800)], [1957118, 7200, (-28800), (-25200)], [1957272, 7200, (-25200), (-28800)], [1958117, 7200, (-28800), (-25200)], [1958271, 7200, (-25200), (-28800)], [1959116, 7200, (-28800), (-25200)], [1959270, 7200, (-25200), (-28800)], [1960115, 7200, (-28800), (-25200)], [1960269, 7200, (-25200), (-28800)], [1961120, 7200, (-28800), (-25200)], [1961267, 7200, (-25200), (-28800)], [1962119, 7200, (-28800), (-25200)], [1962301, 7200, (-25200), (-28800)], [1963118, 7200, (-28800), (-25200)], [1963300, 7200, (-25200), (-28800)], [1964117, 7200, (-28800), (-25200)], [1964299, 7200, (-25200), (-28800)], [1965115, 7200, (-28800), (-25200)], [1965304, 7200, (-25200), (-28800)], [1966114, 7200, (-28800), (-25200)], [1966303, 7200, (-25200), (-28800)], [1967120, 7200, (-28800), (-25200)], [1967302, 7200, (-25200), (-28800)], [1968119, 7200, (-28800), (-25200)], [1968301, 7200, (-25200), (-28800)], [1969117, 7200, (-28800), (-25200)], [1969299, 7200, (-25200), (-28800)], [1970116, 7200, (-28800), (-25200)], [1970298, 7200, (-25200), (-28800)], [1971115, 7200, (-28800), (-25200)], [1971304, 7200, (-25200), (-28800)], [1972121, 7200, (-28800), (-25200)], [1972303, 7200, (-25200), (-28800)], [1973119, 7200, (-28800), (-25200)], [1973301, 7200, (-25200), (-28800)], [1974118, 7200, (-28800), (-25200)], [1974300, 7200, (-25200), (-28800)], [1975117, 7200, (-28800), (-25200)], [1975299, 7200, (-25200), (-28800)], [1976116, 7200, (-28800), (-25200)], [1976305, 7200, (-25200), (-28800)], [1977114, 7200, (-28800), (-25200)], [1977303, 7200, (-25200), (-28800)], [1978120, 7200, (-28800), (-25200)], [1978302, 7200, (-25200), (-28800)], [1979119, 7200, (-28800), (-25200)], [1979301, 7200, (-25200), (-28800)], [1980118, 7200, (-28800), (-25200)], [1980300, 7200, (-25200), (-28800)], [1981116, 7200, (-28800), (-25200)], [1981298, 7200, (-25200), (-28800)], [1982115, 7200, (-28800), (-25200)], [1982304, 7200, (-25200), (-28800)], [1983114, 7200, (-28800), (-25200)], [1983303, 7200, (-25200), (-28800)], [1984120, 7200, (-28800), (-25200)], [1984302, 7200, (-25200), (-28800)], [1985118, 7200, (-28800), (-25200)], [1985300, 7200, (-25200), (-28800)], [1986117, 7200, (-28800), (-25200)], [1986299, 7200, (-25200), (-28800)], [1987095, 7200, (-28800), (-25200)], [1987298, 7200, (-25200), (-28800)], [1988094, 7200, (-28800), (-25200)], [1988304, 7200, (-25200), (-28800)], [1989092, 7200, (-28800), (-25200)], [1989302, 7200, (-25200), (-28800)], [1990091, 7200, (-28800), (-25200)], [1990301, 7200, (-25200), (-28800)], [1991097, 7200, (-28800), (-25200)], [1991300, 7200, (-25200), (-28800)], [1992096, 7200, (-28800), (-25200)], [1992299, 7200, (-25200), (-28800)], [1993094, 7200, (-28800), (-25200)], [1993304, 7200, (-25200), (-28800)], [1994093, 7200, (-28800), (-25200)], [1994303, 7200, (-25200), (-28800)], [1995092, 7200, (-28800), (-25200)], [1995302, 7200, (-25200), (-28800)], [1996098, 7200, (-28800), (-25200)], [1996301, 7200, (-25200), (-28800)], [1997096, 7200, (-28800), (-25200)], [1997299, 7200, (-25200), (-28800)], [1998095, 7200, (-28800), (-25200)], [1998298, 7200, (-25200), (-28800)], [1999094, 7200, (-28800), (-25200)], [1999304, 7200, (-25200), (-28800)], [2000093, 7200, (-28800), (-25200)], [2000303, 7200, (-25200), (-28800)], [2001091, 7200, (-28800), (-25200)], [2001301, 7200, (-25200), (-28800)], [2002097, 7200, (-28800), (-25200)], [2002300, 7200, (-25200), (-28800)], [2003096, 7200, (-28800), (-25200)], [2003299, 7200, (-25200), (-28800)], [2004095, 7200, (-28800), (-25200)], [2004305, 7200, (-25200), (-28800)], [2005093, 7200, (-28800), (-25200)], [2005303, 7200, (-25200), (-28800)], [2006092, 7200, (-28800), (-25200)], [2006302, 7200, (-25200), (-28800)], [2007070, 7200, (-28800), (-25200)], [2007308, 7200, (-25200), (-28800)], [2008069, 7200, (-28800), (-25200)], [2008307, 7200, (-25200), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-28800), (-28800), (-25200)], [11, 1, 7, 7200, 0, 1, (-28800), (-25200), (-28800)]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$ameve$__f_America_Vancouver = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-25196)), $ct_T2__O__O__(new $c_T2(), "w", (-25196)), $ct_T2__O__O__(new $c_T2(), "t", [[1883322, 43204, (-25196), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1883322, 43204, (-25196), (-25200)], [1918090, 7200, (-25200), (-21600)], [1918300, 7200, (-21600), (-25200)], [1919089, 7200, (-25200), (-21600)], [1919299, 7200, (-21600), (-25200)], [1920088, 7200, (-25200), (-21600)], [1920305, 7200, (-21600), (-25200)], [1921086, 7200, (-25200), (-21600)], [1921142, 7200, (-21600), (-25200)], [1942040, 7200, (-25200), (-21600)], [1945273, 7200, (-21600), (-25200)], [1965115, 7200, (-25200), (-21600)], [1965304, 7200, (-21600), (-25200)], [1966114, 7200, (-25200), (-21600)], [1966303, 7200, (-21600), (-25200)], [1967120, 7200, (-25200), (-21600)], [1967302, 7200, (-21600), (-25200)], [1968119, 7200, (-25200), (-21600)], [1968301, 7200, (-21600), (-25200)], [1969117, 7200, (-25200), (-21600)], [1969299, 7200, (-21600), (-25200)], [1970116, 7200, (-25200), (-21600)], [1970298, 7200, (-21600), (-25200)], [1971115, 7200, (-25200), (-21600)], [1971304, 7200, (-21600), (-25200)], [1972121, 7200, (-25200), (-21600)], [1972303, 7200, (-21600), (-25200)], [1973119, 7200, (-25200), (-21600)], [1973301, 7200, (-21600), (-25200)], [1974006, 7200, (-25200), (-21600)], [1974300, 7200, (-21600), (-25200)], [1975054, 7200, (-25200), (-21600)], [1975299, 7200, (-21600), (-25200)], [1976116, 7200, (-25200), (-21600)], [1976305, 7200, (-21600), (-25200)], [1977114, 7200, (-25200), (-21600)], [1977303, 7200, (-21600), (-25200)], [1978120, 7200, (-25200), (-21600)], [1978302, 7200, (-21600), (-25200)], [1979119, 7200, (-25200), (-21600)], [1979301, 7200, (-21600), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$ameve$__f_America_Denver = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$ameve$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ameve$.prototype.constructor = $c_Lzonedb_java_tzdb$ameve$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ameve$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ameve$.prototype = $c_Lzonedb_java_tzdb$ameve$.prototype;
$c_Lzonedb_java_tzdb$ameve$.prototype.America_Rainy_River__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 753")
  };
  return this.Lzonedb_java_tzdb$ameve$__f_America_Rainy_River
});
$c_Lzonedb_java_tzdb$ameve$.prototype.America_Vancouver__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 754")
  };
  return this.Lzonedb_java_tzdb$ameve$__f_America_Vancouver
});
$c_Lzonedb_java_tzdb$ameve$.prototype.America_Denver__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$ameve$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 755")
  };
  return this.Lzonedb_java_tzdb$ameve$__f_America_Denver
});
var $d_Lzonedb_java_tzdb$ameve$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ameve$: 0
}, false, "zonedb.java.tzdb$ameve$", {
  Lzonedb_java_tzdb$ameve$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ameve$.prototype.$classData = $d_Lzonedb_java_tzdb$ameve$;
var $n_Lzonedb_java_tzdb$ameve$;
function $m_Lzonedb_java_tzdb$ameve$() {
  if ((!$n_Lzonedb_java_tzdb$ameve$)) {
    $n_Lzonedb_java_tzdb$ameve$ = new $c_Lzonedb_java_tzdb$ameve$()
  };
  return $n_Lzonedb_java_tzdb$ameve$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$amevi$() {
  this.Lzonedb_java_tzdb$amevi$__f_America_Inuvik = null;
  this.Lzonedb_java_tzdb$amevi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$amevi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1953001, 0, 0, (-28800)], [1979119, 7200, (-28800), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1953001, 0, 0, (-28800)], [1965115, 0, (-28800), (-21600)], [1965304, 7200, (-21600), (-28800)], [1979119, 7200, (-28800), (-25200)], [1980118, 7200, (-25200), (-21600)], [1980300, 7200, (-21600), (-25200)], [1981116, 7200, (-25200), (-21600)], [1981298, 7200, (-21600), (-25200)], [1982115, 7200, (-25200), (-21600)], [1982304, 7200, (-21600), (-25200)], [1983114, 7200, (-25200), (-21600)], [1983303, 7200, (-21600), (-25200)], [1984120, 7200, (-25200), (-21600)], [1984302, 7200, (-21600), (-25200)], [1985118, 7200, (-25200), (-21600)], [1985300, 7200, (-21600), (-25200)], [1986117, 7200, (-25200), (-21600)], [1986299, 7200, (-21600), (-25200)], [1987095, 7200, (-25200), (-21600)], [1987298, 7200, (-21600), (-25200)], [1988094, 7200, (-25200), (-21600)], [1988304, 7200, (-21600), (-25200)], [1989092, 7200, (-25200), (-21600)], [1989302, 7200, (-21600), (-25200)], [1990091, 7200, (-25200), (-21600)], [1990301, 7200, (-21600), (-25200)], [1991097, 7200, (-25200), (-21600)], [1991300, 7200, (-21600), (-25200)], [1992096, 7200, (-25200), (-21600)], [1992299, 7200, (-21600), (-25200)], [1993094, 7200, (-25200), (-21600)], [1993304, 7200, (-21600), (-25200)], [1994093, 7200, (-25200), (-21600)], [1994303, 7200, (-21600), (-25200)], [1995092, 7200, (-25200), (-21600)], [1995302, 7200, (-21600), (-25200)], [1996098, 7200, (-25200), (-21600)], [1996301, 7200, (-21600), (-25200)], [1997096, 7200, (-25200), (-21600)], [1997299, 7200, (-21600), (-25200)], [1998095, 7200, (-25200), (-21600)], [1998298, 7200, (-21600), (-25200)], [1999094, 7200, (-25200), (-21600)], [1999304, 7200, (-21600), (-25200)], [2000093, 7200, (-25200), (-21600)], [2000303, 7200, (-21600), (-25200)], [2001091, 7200, (-25200), (-21600)], [2001301, 7200, (-21600), (-25200)], [2002097, 7200, (-25200), (-21600)], [2002300, 7200, (-21600), (-25200)], [2003096, 7200, (-25200), (-21600)], [2003299, 7200, (-21600), (-25200)], [2004095, 7200, (-25200), (-21600)], [2004305, 7200, (-21600), (-25200)], [2005093, 7200, (-25200), (-21600)], [2005303, 7200, (-21600), (-25200)], [2006092, 7200, (-25200), (-21600)], [2006302, 7200, (-21600), (-25200)], [2007070, 7200, (-25200), (-21600)], [2007308, 7200, (-21600), (-25200)], [2008069, 7200, (-25200), (-21600)], [2008307, 7200, (-21600), (-25200)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-25200), (-25200), (-21600)], [11, 1, 7, 7200, 0, 1, (-25200), (-21600), (-25200)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$amevi$__f_America_Inuvik = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$amevi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$amevi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$amevi$.prototype.constructor = $c_Lzonedb_java_tzdb$amevi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$amevi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$amevi$.prototype = $c_Lzonedb_java_tzdb$amevi$.prototype;
$c_Lzonedb_java_tzdb$amevi$.prototype.America_Inuvik__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$amevi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 579")
  };
  return this.Lzonedb_java_tzdb$amevi$__f_America_Inuvik
});
var $d_Lzonedb_java_tzdb$amevi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$amevi$: 0
}, false, "zonedb.java.tzdb$amevi$", {
  Lzonedb_java_tzdb$amevi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$amevi$.prototype.$classData = $d_Lzonedb_java_tzdb$amevi$;
var $n_Lzonedb_java_tzdb$amevi$;
function $m_Lzonedb_java_tzdb$amevi$() {
  if ((!$n_Lzonedb_java_tzdb$amevi$)) {
    $n_Lzonedb_java_tzdb$amevi$ = new $c_Lzonedb_java_tzdb$amevi$()
  };
  return $n_Lzonedb_java_tzdb$amevi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$anter$() {
  this.Lzonedb_java_tzdb$anter$__f_Antarctica_Rothera = null;
  this.Lzonedb_java_tzdb$anter$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$anter$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1976336, 0, 0, (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1976336, 0, 0, (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$anter$__f_Antarctica_Rothera = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$anter$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$anter$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$anter$.prototype.constructor = $c_Lzonedb_java_tzdb$anter$;
/** @constructor */
function $h_Lzonedb_java_tzdb$anter$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$anter$.prototype = $c_Lzonedb_java_tzdb$anter$.prototype;
$c_Lzonedb_java_tzdb$anter$.prototype.Antarctica_Rothera__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$anter$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 663")
  };
  return this.Lzonedb_java_tzdb$anter$__f_Antarctica_Rothera
});
var $d_Lzonedb_java_tzdb$anter$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$anter$: 0
}, false, "zonedb.java.tzdb$anter$", {
  Lzonedb_java_tzdb$anter$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$anter$.prototype.$classData = $d_Lzonedb_java_tzdb$anter$;
var $n_Lzonedb_java_tzdb$anter$;
function $m_Lzonedb_java_tzdb$anter$() {
  if ((!$n_Lzonedb_java_tzdb$anter$)) {
    $n_Lzonedb_java_tzdb$anter$ = new $c_Lzonedb_java_tzdb$anter$()
  };
  return $n_Lzonedb_java_tzdb$anter$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antll$() {
  this.Lzonedb_java_tzdb$antll$__f_Antarctica_DumontDUrville = null;
  this.Lzonedb_java_tzdb$antll$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$antll$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1947001, 0, 0, 36000], [1952014, 0, 36000, 0], [1956306, 0, 0, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1947001, 0, 0, 36000], [1952014, 0, 36000, 0], [1956306, 0, 0, 36000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$antll$__f_Antarctica_DumontDUrville = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$antll$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$antll$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antll$.prototype.constructor = $c_Lzonedb_java_tzdb$antll$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antll$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antll$.prototype = $c_Lzonedb_java_tzdb$antll$.prototype;
$c_Lzonedb_java_tzdb$antll$.prototype.Antarctica_DumontDUrville__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$antll$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 894")
  };
  return this.Lzonedb_java_tzdb$antll$__f_Antarctica_DumontDUrville
});
var $d_Lzonedb_java_tzdb$antll$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antll$: 0
}, false, "zonedb.java.tzdb$antll$", {
  Lzonedb_java_tzdb$antll$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antll$.prototype.$classData = $d_Lzonedb_java_tzdb$antll$;
var $n_Lzonedb_java_tzdb$antll$;
function $m_Lzonedb_java_tzdb$antll$() {
  if ((!$n_Lzonedb_java_tzdb$antll$)) {
    $n_Lzonedb_java_tzdb$antll$ = new $c_Lzonedb_java_tzdb$antll$()
  };
  return $n_Lzonedb_java_tzdb$antll$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antme$() {
  this.Lzonedb_java_tzdb$antme$__f_Antarctica_Palmer = null;
  this.Lzonedb_java_tzdb$antme$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$antme$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1965001, 0, 0, (-14400)], [1969278, 0, (-14400), (-10800)], [1982121, 0, (-10800), (-14400)], [2016338, 82800, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1965001, 0, 0, (-10800)], [1965060, 0, (-10800), (-14400)], [1965288, 0, (-14400), (-10800)], [1966060, 0, (-10800), (-14400)], [1966288, 0, (-14400), (-10800)], [1967092, 0, (-10800), (-14400)], [1967274, 0, (-14400), (-10800)], [1968098, 0, (-10800), (-14400)], [1968280, 0, (-14400), (-10800)], [1969096, 0, (-10800), (-14400)], [1969278, 0, (-14400), (-10800)], [1974023, 0, (-10800), (-7200)], [1974121, 0, (-7200), (-10800)], [1982121, 0, (-10800), (-14400)], [1982283, 0, (-14400), (-10800)], [1983072, 0, (-10800), (-14400)], [1983282, 0, (-14400), (-10800)], [1984071, 0, (-10800), (-14400)], [1984288, 0, (-14400), (-10800)], [1985069, 0, (-10800), (-14400)], [1985286, 0, (-14400), (-10800)], [1986068, 0, (-10800), (-14400)], [1986285, 0, (-14400), (-10800)], [1987102, 0, (-10800), (-14400)], [1987284, 0, (-14400), (-10800)], [1988073, 0, (-10800), (-14400)], [1988283, 0, (-14400), (-10800)], [1989071, 0, (-10800), (-14400)], [1989288, 0, (-14400), (-10800)], [1990070, 0, (-10800), (-14400)], [1990259, 0, (-14400), (-10800)], [1991069, 0, (-10800), (-14400)], [1991286, 0, (-14400), (-10800)], [1992075, 0, (-10800), (-14400)], [1992285, 0, (-14400), (-10800)], [1993073, 0, (-10800), (-14400)], [1993283, 0, (-14400), (-10800)], [1994072, 0, (-10800), (-14400)], [1994282, 0, (-14400), (-10800)], [1995071, 0, (-10800), (-14400)], [1995288, 0, (-14400), (-10800)], [1996070, 0, (-10800), (-14400)], [1996287, 0, (-14400), (-10800)], [1997089, 0, (-10800), (-14400)], [1997285, 0, (-14400), (-10800)], [1998074, 0, (-10800), (-14400)], [1998270, 0, (-14400), (-10800)], [1999094, 0, (-10800), (-14400)], [1999283, 0, (-14400), (-10800)], [2000072, 0, (-10800), (-14400)], [2000289, 0, (-14400), (-10800)], [2001070, 0, (-10800), (-14400)], [2001287, 0, (-14400), (-10800)], [2002069, 0, (-10800), (-14400)], [2002286, 0, (-14400), (-10800)], [2003068, 0, (-10800), (-14400)], [2003285, 0, (-14400), (-10800)], [2004074, 0, (-10800), (-14400)], [2004284, 0, (-14400), (-10800)], [2005072, 0, (-10800), (-14400)], [2005282, 0, (-14400), (-10800)], [2006071, 0, (-10800), (-14400)], [2006288, 0, (-14400), (-10800)], [2007070, 0, (-10800), (-14400)], [2007287, 0, (-14400), (-10800)], [2008090, 0, (-10800), (-14400)], [2008286, 0, (-14400), (-10800)], [2009074, 0, (-10800), (-14400)], [2009284, 0, (-14400), (-10800)], [2010094, 0, (-10800), (-14400)], [2010283, 0, (-14400), (-10800)], [2011128, 0, (-10800), (-14400)], [2011233, 0, (-14400), (-10800)], [2012120, 0, (-10800), (-14400)], [2012246, 0, (-14400), (-10800)], [2013118, 0, (-10800), (-14400)], [2013251, 0, (-14400), (-10800)], [2014117, 0, (-10800), (-14400)], [2014250, 0, (-14400), (-10800)], [2016136, 0, (-10800), (-14400)], [2016227, 0, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$antme$__f_Antarctica_Palmer = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$antme$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$antme$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antme$.prototype.constructor = $c_Lzonedb_java_tzdb$antme$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antme$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antme$.prototype = $c_Lzonedb_java_tzdb$antme$.prototype;
$c_Lzonedb_java_tzdb$antme$.prototype.Antarctica_Palmer__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$antme$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 261")
  };
  return this.Lzonedb_java_tzdb$antme$__f_Antarctica_Palmer
});
var $d_Lzonedb_java_tzdb$antme$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antme$: 0
}, false, "zonedb.java.tzdb$antme$", {
  Lzonedb_java_tzdb$antme$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antme$.prototype.$classData = $d_Lzonedb_java_tzdb$antme$;
var $n_Lzonedb_java_tzdb$antme$;
function $m_Lzonedb_java_tzdb$antme$() {
  if ((!$n_Lzonedb_java_tzdb$antme$)) {
    $n_Lzonedb_java_tzdb$antme$ = new $c_Lzonedb_java_tzdb$antme$()
  };
  return $n_Lzonedb_java_tzdb$antme$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antol$() {
  this.Lzonedb_java_tzdb$antol$__f_Antarctica_Troll = null;
  this.Lzonedb_java_tzdb$antol$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$antol$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", []), $ct_T2__O__O__(new $c_T2(), "l", [[2005086, 3600, 0, 7200], [2005303, 10800, 7200, 0], [2006085, 3600, 0, 7200], [2006302, 10800, 7200, 0]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 0, 0, 7200], [10, 25, 7, 3600, 0, 0, 0, 7200, 0]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$antol$__f_Antarctica_Troll = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$antol$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$antol$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antol$.prototype.constructor = $c_Lzonedb_java_tzdb$antol$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antol$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antol$.prototype = $c_Lzonedb_java_tzdb$antol$.prototype;
$c_Lzonedb_java_tzdb$antol$.prototype.Antarctica_Troll__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$antol$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 375")
  };
  return this.Lzonedb_java_tzdb$antol$__f_Antarctica_Troll
});
var $d_Lzonedb_java_tzdb$antol$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antol$: 0
}, false, "zonedb.java.tzdb$antol$", {
  Lzonedb_java_tzdb$antol$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antol$.prototype.$classData = $d_Lzonedb_java_tzdb$antol$;
var $n_Lzonedb_java_tzdb$antol$;
function $m_Lzonedb_java_tzdb$antol$() {
  if ((!$n_Lzonedb_java_tzdb$antol$)) {
    $n_Lzonedb_java_tzdb$antol$ = new $c_Lzonedb_java_tzdb$antol$()
  };
  return $n_Lzonedb_java_tzdb$antol$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antow$() {
  this.Lzonedb_java_tzdb$antow$__f_Antarctica_Syowa = null;
  this.Lzonedb_java_tzdb$antow$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$antow$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1957029, 0, 0, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1957029, 0, 0, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$antow$__f_Antarctica_Syowa = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$antow$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$antow$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antow$.prototype.constructor = $c_Lzonedb_java_tzdb$antow$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antow$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antow$.prototype = $c_Lzonedb_java_tzdb$antow$.prototype;
$c_Lzonedb_java_tzdb$antow$.prototype.Antarctica_Syowa__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$antow$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 494")
  };
  return this.Lzonedb_java_tzdb$antow$__f_Antarctica_Syowa
});
var $d_Lzonedb_java_tzdb$antow$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antow$: 0
}, false, "zonedb.java.tzdb$antow$", {
  Lzonedb_java_tzdb$antow$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antow$.prototype.$classData = $d_Lzonedb_java_tzdb$antow$;
var $n_Lzonedb_java_tzdb$antow$;
function $m_Lzonedb_java_tzdb$antow$() {
  if ((!$n_Lzonedb_java_tzdb$antow$)) {
    $n_Lzonedb_java_tzdb$antow$ = new $c_Lzonedb_java_tzdb$antow$()
  };
  return $n_Lzonedb_java_tzdb$antow$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antri$() {
  this.Lzonedb_java_tzdb$antri$__f_Antarctica_Macquarie = null;
  this.Lzonedb_java_tzdb$antri$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$antri$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1899305, 0, 0, 36000], [1919091, 0, 36000, 0], [1948085, 0, 0, 36000], [2010094, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1899305, 0, 0, 36000], [1916275, 7200, 36000, 39600], [1917084, 7200, 39600, 36000], [1919091, 0, 36000, 0], [1948085, 0, 0, 36000], [1967274, 7200, 36000, 39600], [1968091, 10800, 39600, 36000], [1968301, 7200, 36000, 39600], [1969068, 10800, 39600, 36000], [1969299, 7200, 36000, 39600], [1970067, 10800, 39600, 36000], [1970298, 7200, 36000, 39600], [1971073, 10800, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982087, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983086, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986061, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987298, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990077, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991090, 10800, 39600, 36000], [1991279, 7200, 36000, 39600], [1992089, 10800, 39600, 36000], [1992278, 7200, 36000, 39600], [1993087, 10800, 39600, 36000], [1993276, 7200, 36000, 39600], [1994086, 10800, 39600, 36000], [1994275, 7200, 36000, 39600], [1995085, 10800, 39600, 36000], [1995274, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996280, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997278, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998277, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999276, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001280, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002279, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003278, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004277, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005275, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006274, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007280, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$antri$__f_Antarctica_Macquarie = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$antri$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$antri$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antri$.prototype.constructor = $c_Lzonedb_java_tzdb$antri$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antri$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antri$.prototype = $c_Lzonedb_java_tzdb$antri$.prototype;
$c_Lzonedb_java_tzdb$antri$.prototype.Antarctica_Macquarie__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$antri$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 426")
  };
  return this.Lzonedb_java_tzdb$antri$__f_Antarctica_Macquarie
});
var $d_Lzonedb_java_tzdb$antri$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antri$: 0
}, false, "zonedb.java.tzdb$antri$", {
  Lzonedb_java_tzdb$antri$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antri$.prototype.$classData = $d_Lzonedb_java_tzdb$antri$;
var $n_Lzonedb_java_tzdb$antri$;
function $m_Lzonedb_java_tzdb$antri$() {
  if ((!$n_Lzonedb_java_tzdb$antri$)) {
    $n_Lzonedb_java_tzdb$antri$ = new $c_Lzonedb_java_tzdb$antri$()
  };
  return $n_Lzonedb_java_tzdb$antri$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antse$() {
  this.Lzonedb_java_tzdb$antse$__f_Antarctica_Casey = null;
  this.Lzonedb_java_tzdb$antse$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$antse$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1969001, 0, 0, 28800], [2009291, 7200, 28800, 39600], [2010064, 7200, 39600, 28800], [2011301, 7200, 28800, 39600], [2012053, 14400, 39600, 28800], [2016296, 0, 28800, 39600], [2018070, 14400, 39600, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1969001, 0, 0, 28800], [2009291, 7200, 28800, 39600], [2010064, 7200, 39600, 28800], [2011301, 7200, 28800, 39600], [2012053, 14400, 39600, 28800], [2016296, 0, 28800, 39600], [2018070, 14400, 39600, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$antse$__f_Antarctica_Casey = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$antse$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$antse$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antse$.prototype.constructor = $c_Lzonedb_java_tzdb$antse$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antse$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antse$.prototype = $c_Lzonedb_java_tzdb$antse$.prototype;
$c_Lzonedb_java_tzdb$antse$.prototype.Antarctica_Casey__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$antse$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 381")
  };
  return this.Lzonedb_java_tzdb$antse$__f_Antarctica_Casey
});
var $d_Lzonedb_java_tzdb$antse$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antse$: 0
}, false, "zonedb.java.tzdb$antse$", {
  Lzonedb_java_tzdb$antse$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antse$.prototype.$classData = $d_Lzonedb_java_tzdb$antse$;
var $n_Lzonedb_java_tzdb$antse$;
function $m_Lzonedb_java_tzdb$antse$() {
  if ((!$n_Lzonedb_java_tzdb$antse$)) {
    $n_Lzonedb_java_tzdb$antse$ = new $c_Lzonedb_java_tzdb$antse$()
  };
  return $n_Lzonedb_java_tzdb$antse$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antso$() {
  this.Lzonedb_java_tzdb$antso$__f_Antarctica_Mawson = null;
  this.Lzonedb_java_tzdb$antso$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$antso$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1954044, 0, 0, 21600], [2009291, 7200, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1954044, 0, 0, 21600], [2009291, 7200, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$antso$__f_Antarctica_Mawson = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$antso$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$antso$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antso$.prototype.constructor = $c_Lzonedb_java_tzdb$antso$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antso$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antso$.prototype = $c_Lzonedb_java_tzdb$antso$.prototype;
$c_Lzonedb_java_tzdb$antso$.prototype.Antarctica_Mawson__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$antso$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 872")
  };
  return this.Lzonedb_java_tzdb$antso$__f_Antarctica_Mawson
});
var $d_Lzonedb_java_tzdb$antso$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antso$: 0
}, false, "zonedb.java.tzdb$antso$", {
  Lzonedb_java_tzdb$antso$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antso$.prototype.$classData = $d_Lzonedb_java_tzdb$antso$;
var $n_Lzonedb_java_tzdb$antso$;
function $m_Lzonedb_java_tzdb$antso$() {
  if ((!$n_Lzonedb_java_tzdb$antso$)) {
    $n_Lzonedb_java_tzdb$antso$ = new $c_Lzonedb_java_tzdb$antso$()
  };
  return $n_Lzonedb_java_tzdb$antso$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antto$() {
  this.Lzonedb_java_tzdb$antto$__f_Antarctica_Vostok = null;
  this.Lzonedb_java_tzdb$antto$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$antto$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1957350, 0, 0, 21600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1957350, 0, 0, 21600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$antto$__f_Antarctica_Vostok = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$antto$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$antto$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antto$.prototype.constructor = $c_Lzonedb_java_tzdb$antto$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antto$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antto$.prototype = $c_Lzonedb_java_tzdb$antto$.prototype;
$c_Lzonedb_java_tzdb$antto$.prototype.Antarctica_Vostok__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$antto$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 660")
  };
  return this.Lzonedb_java_tzdb$antto$__f_Antarctica_Vostok
});
var $d_Lzonedb_java_tzdb$antto$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antto$: 0
}, false, "zonedb.java.tzdb$antto$", {
  Lzonedb_java_tzdb$antto$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antto$.prototype.$classData = $d_Lzonedb_java_tzdb$antto$;
var $n_Lzonedb_java_tzdb$antto$;
function $m_Lzonedb_java_tzdb$antto$() {
  if ((!$n_Lzonedb_java_tzdb$antto$)) {
    $n_Lzonedb_java_tzdb$antto$ = new $c_Lzonedb_java_tzdb$antto$()
  };
  return $n_Lzonedb_java_tzdb$antto$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$antvi$() {
  this.Lzonedb_java_tzdb$antvi$__f_Antarctica_Davis = null;
  this.Lzonedb_java_tzdb$antvi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$antvi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1957013, 0, 0, 25200], [1964306, 0, 25200, 0], [1969032, 0, 0, 25200], [2009291, 7200, 25200, 18000], [2010070, 3600, 18000, 25200], [2011301, 7200, 25200, 18000], [2012053, 3600, 18000, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1957013, 0, 0, 25200], [1964306, 0, 25200, 0], [1969032, 0, 0, 25200], [2009291, 7200, 25200, 18000], [2010070, 3600, 18000, 25200], [2011301, 7200, 25200, 18000], [2012053, 3600, 18000, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$antvi$__f_Antarctica_Davis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$antvi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$antvi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$antvi$.prototype.constructor = $c_Lzonedb_java_tzdb$antvi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$antvi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$antvi$.prototype = $c_Lzonedb_java_tzdb$antvi$.prototype;
$c_Lzonedb_java_tzdb$antvi$.prototype.Antarctica_Davis__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$antvi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 423")
  };
  return this.Lzonedb_java_tzdb$antvi$__f_Antarctica_Davis
});
var $d_Lzonedb_java_tzdb$antvi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$antvi$: 0
}, false, "zonedb.java.tzdb$antvi$", {
  Lzonedb_java_tzdb$antvi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$antvi$.prototype.$classData = $d_Lzonedb_java_tzdb$antvi$;
var $n_Lzonedb_java_tzdb$antvi$;
function $m_Lzonedb_java_tzdb$antvi$() {
  if ((!$n_Lzonedb_java_tzdb$antvi$)) {
    $n_Lzonedb_java_tzdb$antvi$ = new $c_Lzonedb_java_tzdb$antvi$()
  };
  return $n_Lzonedb_java_tzdb$antvi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiad$() {
  this.Lzonedb_java_tzdb$asiad$__f_Asia_Riyadh = null;
  this.Lzonedb_java_tzdb$asiad$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiad$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 11212), $ct_T2__O__O__(new $c_T2(), "w", 11212), $ct_T2__O__O__(new $c_T2(), "t", [[1947073, 0, 11212, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1947073, 0, 11212, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiad$__f_Asia_Riyadh = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiad$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiad$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiad$.prototype.constructor = $c_Lzonedb_java_tzdb$asiad$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiad$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiad$.prototype = $c_Lzonedb_java_tzdb$asiad$.prototype;
$c_Lzonedb_java_tzdb$asiad$.prototype.Asia_Riyadh__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiad$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 384")
  };
  return this.Lzonedb_java_tzdb$asiad$__f_Asia_Riyadh
});
var $d_Lzonedb_java_tzdb$asiad$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiad$: 0
}, false, "zonedb.java.tzdb$asiad$", {
  Lzonedb_java_tzdb$asiad$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiad$.prototype.$classData = $d_Lzonedb_java_tzdb$asiad$;
var $n_Lzonedb_java_tzdb$asiad$;
function $m_Lzonedb_java_tzdb$asiad$() {
  if ((!$n_Lzonedb_java_tzdb$asiad$)) {
    $n_Lzonedb_java_tzdb$asiad$ = new $c_Lzonedb_java_tzdb$asiad$()
  };
  return $n_Lzonedb_java_tzdb$asiad$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiak$() {
  this.Lzonedb_java_tzdb$asiak$__f_Asia_Dhaka = null;
  this.Lzonedb_java_tzdb$asiak$__f_Asia_Baku = null;
  this.Lzonedb_java_tzdb$asiak$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asiak$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 21700), $ct_T2__O__O__(new $c_T2(), "w", 21700), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, 21700, 21200], [1941274, 0, 21200, 23400], [1942135, 0, 23400, 19800], [1942244, 0, 19800, 23400], [1951273, 0, 23400, 21600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, 21700, 21200], [1941274, 0, 21200, 23400], [1942135, 0, 23400, 19800], [1942244, 0, 19800, 23400], [1951273, 0, 23400, 21600], [2009170, 82800, 21600, 25200], [2010001, 0, 25200, 21600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiak$__f_Asia_Dhaka = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiak$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asiak$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 11964), $ct_T2__O__O__(new $c_T2(), "w", 11964), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 11964, 10800], [1957060, 0, 10800, 14400], [1991090, 7200, 14400, 10800], [1992271, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 11964, 10800], [1957060, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989085, 7200, 14400, 18000], [1989267, 10800, 18000, 14400], [1990084, 7200, 14400, 18000], [1990273, 10800, 18000, 14400], [1991272, 10800, 14400, 10800], [1992089, 7200, 10800, 14400], [1996091, 18000, 14400, 18000], [1996301, 21600, 18000, 14400], [1997089, 14400, 14400, 18000], [1997299, 18000, 18000, 14400], [1998088, 14400, 14400, 18000], [1998298, 18000, 18000, 14400], [1999087, 14400, 14400, 18000], [1999304, 18000, 18000, 14400], [2000086, 14400, 14400, 18000], [2000303, 18000, 18000, 14400], [2001084, 14400, 14400, 18000], [2001301, 18000, 18000, 14400], [2002090, 14400, 14400, 18000], [2002300, 18000, 18000, 14400], [2003089, 14400, 14400, 18000], [2003299, 18000, 18000, 14400], [2004088, 14400, 14400, 18000], [2004305, 18000, 18000, 14400], [2005086, 14400, 14400, 18000], [2005303, 18000, 18000, 14400], [2006085, 14400, 14400, 18000], [2006302, 18000, 18000, 14400], [2007084, 14400, 14400, 18000], [2007301, 18000, 18000, 14400], [2008090, 14400, 14400, 18000], [2008300, 18000, 18000, 14400], [2009088, 14400, 14400, 18000], [2009298, 18000, 18000, 14400], [2010087, 14400, 14400, 18000], [2010304, 18000, 18000, 14400], [2011086, 14400, 14400, 18000], [2011303, 18000, 18000, 14400], [2012085, 14400, 14400, 18000], [2012302, 18000, 18000, 14400], [2013090, 14400, 14400, 18000], [2013300, 18000, 18000, 14400], [2014089, 14400, 14400, 18000], [2014299, 18000, 18000, 14400], [2015088, 14400, 14400, 18000], [2015298, 18000, 18000, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asiak$__f_Asia_Baku = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asiak$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asiak$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asiak$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiak$.prototype.constructor = $c_Lzonedb_java_tzdb$asiak$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiak$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiak$.prototype = $c_Lzonedb_java_tzdb$asiak$.prototype;
$c_Lzonedb_java_tzdb$asiak$.prototype.Asia_Dhaka__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asiak$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 564")
  };
  return this.Lzonedb_java_tzdb$asiak$__f_Asia_Dhaka
});
$c_Lzonedb_java_tzdb$asiak$.prototype.Asia_Baku__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asiak$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 565")
  };
  return this.Lzonedb_java_tzdb$asiak$__f_Asia_Baku
});
var $d_Lzonedb_java_tzdb$asiak$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiak$: 0
}, false, "zonedb.java.tzdb$asiak$", {
  Lzonedb_java_tzdb$asiak$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiak$.prototype.$classData = $d_Lzonedb_java_tzdb$asiak$;
var $n_Lzonedb_java_tzdb$asiak$;
function $m_Lzonedb_java_tzdb$asiak$() {
  if ((!$n_Lzonedb_java_tzdb$asiak$)) {
    $n_Lzonedb_java_tzdb$asiak$ = new $c_Lzonedb_java_tzdb$asiak$()
  };
  return $n_Lzonedb_java_tzdb$asiak$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asian$() {
  this.Lzonedb_java_tzdb$asian$__f_Asia_Pyongyang = null;
  this.Lzonedb_java_tzdb$asian$__f_Asia_Samarkand = null;
  this.Lzonedb_java_tzdb$asian$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asian$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 30180), $ct_T2__O__O__(new $c_T2(), "w", 30180), $ct_T2__O__O__(new $c_T2(), "t", [[1908092, 0, 30180, 30600], [1912001, 0, 30600, 32400], [2015227, 0, 32400, 30600], [2018124, 84600, 30600, 32400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1908092, 0, 30180, 30600], [1912001, 0, 30600, 32400], [2015227, 0, 32400, 30600], [2018124, 84600, 30600, 32400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asian$__f_Asia_Pyongyang = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asian$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asian$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 16073), $ct_T2__O__O__(new $c_T2(), "w", 16073), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 16073, 14400], [1930172, 0, 14400, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 16073, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991090, 7200, 18000, 21600], [1991272, 10800, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asian$__f_Asia_Samarkand = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asian$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asian$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asian$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asian$.prototype.constructor = $c_Lzonedb_java_tzdb$asian$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asian$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asian$.prototype = $c_Lzonedb_java_tzdb$asian$.prototype;
$c_Lzonedb_java_tzdb$asian$.prototype.Asia_Pyongyang__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asian$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 410")
  };
  return this.Lzonedb_java_tzdb$asian$__f_Asia_Pyongyang
});
$c_Lzonedb_java_tzdb$asian$.prototype.Asia_Samarkand__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asian$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 411")
  };
  return this.Lzonedb_java_tzdb$asian$__f_Asia_Samarkand
});
var $d_Lzonedb_java_tzdb$asian$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asian$: 0
}, false, "zonedb.java.tzdb$asian$", {
  Lzonedb_java_tzdb$asian$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asian$.prototype.$classData = $d_Lzonedb_java_tzdb$asian$;
var $n_Lzonedb_java_tzdb$asian$;
function $m_Lzonedb_java_tzdb$asian$() {
  if ((!$n_Lzonedb_java_tzdb$asian$)) {
    $n_Lzonedb_java_tzdb$asian$ = new $c_Lzonedb_java_tzdb$asian$()
  };
  return $n_Lzonedb_java_tzdb$asian$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiat$() {
  this.Lzonedb_java_tzdb$asiat$__f_Asia_Almaty = null;
  this.Lzonedb_java_tzdb$asiat$__f_Asia_Kolkata = null;
  this.Lzonedb_java_tzdb$asiat$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asiat$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 18468), $ct_T2__O__O__(new $c_T2(), "w", 18468), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 18468, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000], [1992019, 7200, 18000, 21600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 18468, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991272, 10800, 21600, 18000], [1992019, 7200, 18000, 21600], [1992089, 7200, 21600, 25200], [1992271, 10800, 25200, 21600], [1993087, 7200, 21600, 25200], [1993269, 10800, 25200, 21600], [1994086, 7200, 21600, 25200], [1994268, 10800, 25200, 21600], [1995085, 7200, 21600, 25200], [1995267, 10800, 25200, 21600], [1996091, 7200, 21600, 25200], [1996301, 10800, 25200, 21600], [1997089, 7200, 21600, 25200], [1997299, 10800, 25200, 21600], [1998088, 7200, 21600, 25200], [1998298, 10800, 25200, 21600], [1999087, 7200, 21600, 25200], [1999304, 10800, 25200, 21600], [2000086, 7200, 21600, 25200], [2000303, 10800, 25200, 21600], [2001084, 7200, 21600, 25200], [2001301, 10800, 25200, 21600], [2002090, 7200, 21600, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiat$__f_Asia_Almaty = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiat$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asiat$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 21208), $ct_T2__O__O__(new $c_T2(), "w", 21208), $ct_T2__O__O__(new $c_T2(), "t", [[1854179, 0, 21208, 21200], [1870001, 0, 21200, 19270], [1906001, 0, 19270, 19800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1854179, 0, 21208, 21200], [1870001, 0, 21200, 19270], [1906001, 0, 19270, 19800], [1941274, 0, 19800, 23400], [1942135, 0, 23400, 19800], [1942244, 0, 19800, 23400], [1945288, 0, 23400, 19800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asiat$__f_Asia_Kolkata = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asiat$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asiat$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asiat$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiat$.prototype.constructor = $c_Lzonedb_java_tzdb$asiat$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiat$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiat$.prototype = $c_Lzonedb_java_tzdb$asiat$.prototype;
$c_Lzonedb_java_tzdb$asiat$.prototype.Asia_Almaty__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asiat$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 483")
  };
  return this.Lzonedb_java_tzdb$asiat$__f_Asia_Almaty
});
$c_Lzonedb_java_tzdb$asiat$.prototype.Asia_Kolkata__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asiat$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 484")
  };
  return this.Lzonedb_java_tzdb$asiat$__f_Asia_Kolkata
});
var $d_Lzonedb_java_tzdb$asiat$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiat$: 0
}, false, "zonedb.java.tzdb$asiat$", {
  Lzonedb_java_tzdb$asiat$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiat$.prototype.$classData = $d_Lzonedb_java_tzdb$asiat$;
var $n_Lzonedb_java_tzdb$asiat$;
function $m_Lzonedb_java_tzdb$asiat$() {
  if ((!$n_Lzonedb_java_tzdb$asiat$)) {
    $n_Lzonedb_java_tzdb$asiat$ = new $c_Lzonedb_java_tzdb$asiat$()
  };
  return $n_Lzonedb_java_tzdb$asiat$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiau$() {
  this.Lzonedb_java_tzdb$asiau$__f_Asia_Barnaul = null;
  this.Lzonedb_java_tzdb$asiau$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiau$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 20100), $ct_T2__O__O__(new $c_T2(), "w", 20100), $ct_T2__O__O__(new $c_T2(), "t", [[1919344, 0, 20100, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [1995147, 82800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016087, 7200, 21600, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919344, 0, 20100, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993269, 10800, 28800, 25200], [1994086, 7200, 25200, 28800], [1994268, 10800, 28800, 25200], [1995085, 7200, 25200, 28800], [1995148, 0, 28800, 25200], [1995267, 10800, 25200, 21600], [1996091, 7200, 21600, 25200], [1996301, 10800, 25200, 21600], [1997089, 7200, 21600, 25200], [1997299, 10800, 25200, 21600], [1998088, 7200, 21600, 25200], [1998298, 10800, 25200, 21600], [1999087, 7200, 21600, 25200], [1999304, 10800, 25200, 21600], [2000086, 7200, 21600, 25200], [2000303, 10800, 25200, 21600], [2001084, 7200, 21600, 25200], [2001301, 10800, 25200, 21600], [2002090, 7200, 21600, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600], [2005086, 7200, 21600, 25200], [2005303, 10800, 25200, 21600], [2006085, 7200, 21600, 25200], [2006302, 10800, 25200, 21600], [2007084, 7200, 21600, 25200], [2007301, 10800, 25200, 21600], [2008090, 7200, 21600, 25200], [2008300, 10800, 25200, 21600], [2009088, 7200, 21600, 25200], [2009298, 10800, 25200, 21600], [2010087, 7200, 21600, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016087, 7200, 21600, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiau$__f_Asia_Barnaul = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiau$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiau$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiau$.prototype.constructor = $c_Lzonedb_java_tzdb$asiau$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiau$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiau$.prototype = $c_Lzonedb_java_tzdb$asiau$.prototype;
$c_Lzonedb_java_tzdb$asiau$.prototype.Asia_Barnaul__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiau$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 73")
  };
  return this.Lzonedb_java_tzdb$asiau$__f_Asia_Barnaul
});
var $d_Lzonedb_java_tzdb$asiau$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiau$: 0
}, false, "zonedb.java.tzdb$asiau$", {
  Lzonedb_java_tzdb$asiau$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiau$.prototype.$classData = $d_Lzonedb_java_tzdb$asiau$;
var $n_Lzonedb_java_tzdb$asiau$;
function $m_Lzonedb_java_tzdb$asiau$() {
  if ((!$n_Lzonedb_java_tzdb$asiau$)) {
    $n_Lzonedb_java_tzdb$asiau$ = new $c_Lzonedb_java_tzdb$asiau$()
  };
  return $n_Lzonedb_java_tzdb$asiau$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiaz$() {
  this.Lzonedb_java_tzdb$asiaz$__f_Asia_Gaza = null;
  this.Lzonedb_java_tzdb$asiaz$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiaz$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8272), $ct_T2__O__O__(new $c_T2(), "w", 8272), $ct_T2__O__O__(new $c_T2(), "t", [[1900274, 0, 8272, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1900274, 0, 8272, 7200], [1940153, 0, 7200, 10800], [1942305, 0, 10800, 7200], [1943091, 7200, 7200, 10800], [1943305, 0, 10800, 7200], [1944092, 0, 7200, 10800], [1944306, 0, 10800, 7200], [1945106, 0, 7200, 10800], [1945305, 7200, 10800, 7200], [1946106, 7200, 7200, 10800], [1946305, 0, 10800, 7200], [1957130, 0, 7200, 10800], [1957274, 0, 10800, 7200], [1958121, 0, 7200, 10800], [1958274, 0, 10800, 7200], [1959121, 3600, 7200, 10800], [1959273, 10800, 10800, 7200], [1960122, 3600, 7200, 10800], [1960274, 10800, 10800, 7200], [1961121, 3600, 7200, 10800], [1961273, 10800, 10800, 7200], [1962121, 3600, 7200, 10800], [1962273, 10800, 10800, 7200], [1963121, 3600, 7200, 10800], [1963273, 10800, 10800, 7200], [1964122, 3600, 7200, 10800], [1964274, 10800, 10800, 7200], [1965121, 3600, 7200, 10800], [1965273, 10800, 10800, 7200], [1966121, 3600, 7200, 10800], [1966274, 10800, 10800, 7200], [1967121, 3600, 7200, 10800], [1967156, 0, 10800, 7200], [1974188, 0, 7200, 10800], [1974286, 0, 10800, 7200], [1975110, 0, 7200, 10800], [1975243, 0, 10800, 7200], [1980215, 0, 7200, 10800], [1980257, 3600, 10800, 7200], [1984126, 0, 7200, 10800], [1984238, 3600, 10800, 7200], [1985104, 0, 7200, 10800], [1985258, 0, 10800, 7200], [1986138, 0, 7200, 10800], [1986250, 0, 10800, 7200], [1987105, 0, 7200, 10800], [1987256, 0, 10800, 7200], [1988101, 0, 7200, 10800], [1988248, 0, 10800, 7200], [1989120, 0, 7200, 10800], [1989246, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990238, 0, 10800, 7200], [1991083, 0, 7200, 10800], [1991244, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992250, 0, 10800, 7200], [1993092, 0, 7200, 10800], [1993248, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994240, 0, 10800, 7200], [1995090, 0, 7200, 10800], [1995246, 0, 10800, 7200], [1996096, 0, 7200, 10800], [1996264, 3600, 10800, 7200], [1997094, 0, 7200, 10800], [1997262, 3600, 10800, 7200], [1998093, 0, 7200, 10800], [1998261, 3600, 10800, 7200], [1999106, 0, 7200, 10800], [1999288, 0, 10800, 7200], [2000112, 0, 7200, 10800], [2000294, 0, 10800, 7200], [2001110, 0, 7200, 10800], [2001292, 0, 10800, 7200], [2002109, 0, 7200, 10800], [2002291, 0, 10800, 7200], [2003108, 0, 7200, 10800], [2003290, 0, 10800, 7200], [2004107, 0, 7200, 10800], [2004275, 3600, 10800, 7200], [2005105, 0, 7200, 10800], [2005277, 7200, 10800, 7200], [2006091, 0, 7200, 10800], [2006265, 0, 10800, 7200], [2007091, 0, 7200, 10800], [2007256, 7200, 10800, 7200], [2008088, 0, 7200, 10800], [2008242, 0, 10800, 7200], [2009086, 0, 7200, 10800], [2009247, 3600, 10800, 7200], [2010086, 60, 7200, 10800], [2010223, 0, 10800, 7200], [2011091, 60, 7200, 10800], [2011213, 0, 10800, 7200], [2012090, 0, 7200, 10800], [2012265, 3600, 10800, 7200], [2013088, 0, 7200, 10800], [2013270, 0, 10800, 7200], [2014087, 0, 7200, 10800], [2014297, 0, 10800, 7200], [2015087, 0, 7200, 10800], [2015296, 0, 10800, 7200], [2016086, 3600, 7200, 10800], [2016303, 3600, 10800, 7200], [2017084, 3600, 7200, 10800], [2017301, 3600, 10800, 7200], [2018083, 3600, 7200, 10800], [2018300, 3600, 10800, 7200], [2019088, 0, 7200, 10800], [2019299, 3600, 10800, 7200], [2020087, 0, 7200, 10800], [2020305, 3600, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 5, 0, 0, 1, 7200, 7200, 10800], [10, 25, 6, 3600, 0, 1, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiaz$__f_Asia_Gaza = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiaz$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiaz$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiaz$.prototype.constructor = $c_Lzonedb_java_tzdb$asiaz$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiaz$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiaz$.prototype = $c_Lzonedb_java_tzdb$asiaz$.prototype;
$c_Lzonedb_java_tzdb$asiaz$.prototype.Asia_Gaza__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiaz$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 335")
  };
  return this.Lzonedb_java_tzdb$asiaz$__f_Asia_Gaza
});
var $d_Lzonedb_java_tzdb$asiaz$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiaz$: 0
}, false, "zonedb.java.tzdb$asiaz$", {
  Lzonedb_java_tzdb$asiaz$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiaz$.prototype.$classData = $d_Lzonedb_java_tzdb$asiaz$;
var $n_Lzonedb_java_tzdb$asiaz$;
function $m_Lzonedb_java_tzdb$asiaz$() {
  if ((!$n_Lzonedb_java_tzdb$asiaz$)) {
    $n_Lzonedb_java_tzdb$asiaz$ = new $c_Lzonedb_java_tzdb$asiaz$()
  };
  return $n_Lzonedb_java_tzdb$asiaz$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiba$() {
  this.Lzonedb_java_tzdb$asiba$__f_Asia_Dubai = null;
  this.Lzonedb_java_tzdb$asiba$__f_Asia_Ashgabat = null;
  this.Lzonedb_java_tzdb$asiba$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asiba$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 13272), $ct_T2__O__O__(new $c_T2(), "w", 13272), $ct_T2__O__O__(new $c_T2(), "t", [[1920001, 0, 13272, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920001, 0, 13272, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiba$__f_Asia_Dubai = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiba$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asiba$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 14012), $ct_T2__O__O__(new $c_T2(), "w", 14012), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 14012, 14400], [1930172, 0, 14400, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 14012, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1981274, 0, 21600, 18000], [1982091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asiba$__f_Asia_Ashgabat = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asiba$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asiba$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asiba$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiba$.prototype.constructor = $c_Lzonedb_java_tzdb$asiba$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiba$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiba$.prototype = $c_Lzonedb_java_tzdb$asiba$.prototype;
$c_Lzonedb_java_tzdb$asiba$.prototype.Asia_Dubai__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asiba$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 22")
  };
  return this.Lzonedb_java_tzdb$asiba$__f_Asia_Dubai
});
$c_Lzonedb_java_tzdb$asiba$.prototype.Asia_Ashgabat__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asiba$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 23")
  };
  return this.Lzonedb_java_tzdb$asiba$__f_Asia_Ashgabat
});
var $d_Lzonedb_java_tzdb$asiba$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiba$: 0
}, false, "zonedb.java.tzdb$asiba$", {
  Lzonedb_java_tzdb$asiba$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiba$.prototype.$classData = $d_Lzonedb_java_tzdb$asiba$;
var $n_Lzonedb_java_tzdb$asiba$;
function $m_Lzonedb_java_tzdb$asiba$() {
  if ((!$n_Lzonedb_java_tzdb$asiba$)) {
    $n_Lzonedb_java_tzdb$asiba$ = new $c_Lzonedb_java_tzdb$asiba$()
  };
  return $n_Lzonedb_java_tzdb$asiba$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asibu$() {
  this.Lzonedb_java_tzdb$asibu$__f_Asia_Kabul = null;
  this.Lzonedb_java_tzdb$asibu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asibu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 16608), $ct_T2__O__O__(new $c_T2(), "w", 16608), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, 16608, 14400], [1945001, 0, 14400, 16200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, 16608, 14400], [1945001, 0, 14400, 16200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asibu$__f_Asia_Kabul = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asibu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asibu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asibu$.prototype.constructor = $c_Lzonedb_java_tzdb$asibu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asibu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asibu$.prototype = $c_Lzonedb_java_tzdb$asibu$.prototype;
$c_Lzonedb_java_tzdb$asibu$.prototype.Asia_Kabul__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asibu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 653")
  };
  return this.Lzonedb_java_tzdb$asibu$__f_Asia_Kabul
});
var $d_Lzonedb_java_tzdb$asibu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asibu$: 0
}, false, "zonedb.java.tzdb$asibu$", {
  Lzonedb_java_tzdb$asibu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asibu$.prototype.$classData = $d_Lzonedb_java_tzdb$asibu$;
var $n_Lzonedb_java_tzdb$asibu$;
function $m_Lzonedb_java_tzdb$asibu$() {
  if ((!$n_Lzonedb_java_tzdb$asibu$)) {
    $n_Lzonedb_java_tzdb$asibu$ = new $c_Lzonedb_java_tzdb$asibu$()
  };
  return $n_Lzonedb_java_tzdb$asibu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asica$() {
  this.Lzonedb_java_tzdb$asica$__f_Asia_Macau = null;
  this.Lzonedb_java_tzdb$asica$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asica$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 27250), $ct_T2__O__O__(new $c_T2(), "w", 27250), $ct_T2__O__O__(new $c_T2(), "t", [[1904304, 0, 27250, 28800], [1941355, 82800, 28800, 32400], [1945274, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1904304, 0, 27250, 28800], [1941355, 82800, 28800, 32400], [1942120, 82800, 32400, 36000], [1942321, 82800, 36000, 32400], [1943120, 82800, 32400, 36000], [1943273, 82800, 36000, 32400], [1945274, 0, 32400, 28800], [1946120, 82800, 28800, 32400], [1946274, 0, 32400, 28800], [1947109, 82800, 28800, 32400], [1947335, 0, 32400, 28800], [1948123, 82800, 28800, 32400], [1948306, 0, 32400, 28800], [1949092, 82800, 28800, 32400], [1949303, 0, 32400, 28800], [1950091, 82800, 28800, 32400], [1950302, 0, 32400, 28800], [1951090, 82800, 28800, 32400], [1951302, 0, 32400, 28800], [1952096, 82800, 28800, 32400], [1952307, 0, 32400, 28800], [1953094, 82800, 28800, 32400], [1953305, 0, 32400, 28800], [1954079, 82800, 28800, 32400], [1954304, 0, 32400, 28800], [1955078, 82800, 28800, 32400], [1955310, 0, 32400, 28800], [1956077, 82800, 28800, 32400], [1956309, 12600, 32400, 28800], [1957083, 12600, 28800, 32400], [1957307, 12600, 32400, 28800], [1958082, 12600, 28800, 32400], [1958306, 12600, 32400, 28800], [1959081, 12600, 28800, 32400], [1959305, 12600, 32400, 28800], [1960080, 12600, 28800, 32400], [1960311, 12600, 32400, 28800], [1961078, 12600, 28800, 32400], [1961309, 12600, 32400, 28800], [1962077, 12600, 28800, 32400], [1962308, 12600, 32400, 28800], [1963083, 12600, 28800, 32400], [1963307, 12600, 32400, 28800], [1964082, 12600, 28800, 32400], [1964306, 12600, 32400, 28800], [1965108, 12600, 28800, 32400], [1965290, 9000, 32400, 28800], [1966107, 12600, 28800, 32400], [1966289, 9000, 32400, 28800], [1967106, 12600, 28800, 32400], [1967295, 12600, 32400, 28800], [1968112, 12600, 28800, 32400], [1968294, 12600, 32400, 28800], [1969110, 12600, 28800, 32400], [1969292, 12600, 32400, 28800], [1970109, 12600, 28800, 32400], [1970291, 12600, 32400, 28800], [1971108, 12600, 28800, 32400], [1971290, 12600, 32400, 28800], [1972107, 12600, 28800, 32400], [1972296, 12600, 32400, 28800], [1973112, 12600, 28800, 32400], [1973294, 12600, 32400, 28800], [1973364, 12600, 28800, 32400], [1974293, 12600, 32400, 28800], [1975110, 12600, 28800, 32400], [1975292, 12600, 32400, 28800], [1976109, 12600, 28800, 32400], [1976291, 12600, 32400, 28800], [1979133, 12600, 28800, 32400], [1979294, 12600, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asica$__f_Asia_Macau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asica$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asica$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asica$.prototype.constructor = $c_Lzonedb_java_tzdb$asica$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asica$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asica$.prototype = $c_Lzonedb_java_tzdb$asica$.prototype;
$c_Lzonedb_java_tzdb$asica$.prototype.Asia_Macau__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asica$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 234")
  };
  return this.Lzonedb_java_tzdb$asica$__f_Asia_Macau
});
var $d_Lzonedb_java_tzdb$asica$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asica$: 0
}, false, "zonedb.java.tzdb$asica$", {
  Lzonedb_java_tzdb$asica$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asica$.prototype.$classData = $d_Lzonedb_java_tzdb$asica$;
var $n_Lzonedb_java_tzdb$asica$;
function $m_Lzonedb_java_tzdb$asica$() {
  if ((!$n_Lzonedb_java_tzdb$asica$)) {
    $n_Lzonedb_java_tzdb$asica$ = new $c_Lzonedb_java_tzdb$asica$()
  };
  return $n_Lzonedb_java_tzdb$asica$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asich$() {
  this.Lzonedb_java_tzdb$asich$__f_Asia_Karachi = null;
  this.Lzonedb_java_tzdb$asich$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asich$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 16092), $ct_T2__O__O__(new $c_T2(), "w", 16092), $ct_T2__O__O__(new $c_T2(), "t", [[1907001, 0, 16092, 19800], [1951273, 0, 19800, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1907001, 0, 16092, 19800], [1942244, 0, 19800, 23400], [1945288, 0, 23400, 19800], [1951273, 0, 19800, 18000], [2002097, 0, 18000, 21600], [2002279, 0, 21600, 18000], [2008153, 0, 18000, 21600], [2008306, 0, 21600, 18000], [2009105, 0, 18000, 21600], [2009305, 0, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asich$__f_Asia_Karachi = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asich$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asich$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asich$.prototype.constructor = $c_Lzonedb_java_tzdb$asich$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asich$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asich$.prototype = $c_Lzonedb_java_tzdb$asich$.prototype;
$c_Lzonedb_java_tzdb$asich$.prototype.Asia_Karachi__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asich$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 85")
  };
  return this.Lzonedb_java_tzdb$asich$__f_Asia_Karachi
});
var $d_Lzonedb_java_tzdb$asich$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asich$: 0
}, false, "zonedb.java.tzdb$asich$", {
  Lzonedb_java_tzdb$asich$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asich$.prototype.$classData = $d_Lzonedb_java_tzdb$asich$;
var $n_Lzonedb_java_tzdb$asich$;
function $m_Lzonedb_java_tzdb$asich$() {
  if ((!$n_Lzonedb_java_tzdb$asich$)) {
    $n_Lzonedb_java_tzdb$asich$ = new $c_Lzonedb_java_tzdb$asich$()
  };
  return $n_Lzonedb_java_tzdb$asich$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asicu$() {
  this.Lzonedb_java_tzdb$asicu$__f_Asia_Damascus = null;
  this.Lzonedb_java_tzdb$asicu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asicu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8712), $ct_T2__O__O__(new $c_T2(), "w", 8712), $ct_T2__O__O__(new $c_T2(), "t", [[1920001, 0, 8712, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920001, 0, 8712, 7200], [1920109, 7200, 7200, 10800], [1920277, 7200, 10800, 7200], [1921107, 7200, 7200, 10800], [1921275, 7200, 10800, 7200], [1922106, 7200, 7200, 10800], [1922274, 7200, 10800, 7200], [1923105, 7200, 7200, 10800], [1923280, 7200, 10800, 7200], [1962119, 7200, 7200, 10800], [1962274, 7200, 10800, 7200], [1963121, 7200, 7200, 10800], [1963273, 7200, 10800, 7200], [1964122, 7200, 7200, 10800], [1964275, 7200, 10800, 7200], [1965121, 7200, 7200, 10800], [1965273, 7200, 10800, 7200], [1966114, 7200, 7200, 10800], [1966274, 7200, 10800, 7200], [1967121, 7200, 7200, 10800], [1967274, 7200, 10800, 7200], [1968122, 7200, 7200, 10800], [1968275, 7200, 10800, 7200], [1969121, 7200, 7200, 10800], [1969274, 7200, 10800, 7200], [1970121, 7200, 7200, 10800], [1970274, 7200, 10800, 7200], [1971121, 7200, 7200, 10800], [1971274, 7200, 10800, 7200], [1972122, 7200, 7200, 10800], [1972275, 7200, 10800, 7200], [1973121, 7200, 7200, 10800], [1973274, 7200, 10800, 7200], [1974121, 7200, 7200, 10800], [1974274, 7200, 10800, 7200], [1975121, 7200, 7200, 10800], [1975274, 7200, 10800, 7200], [1976122, 7200, 7200, 10800], [1976275, 7200, 10800, 7200], [1977121, 7200, 7200, 10800], [1977244, 7200, 10800, 7200], [1978121, 7200, 7200, 10800], [1978244, 7200, 10800, 7200], [1983099, 7200, 7200, 10800], [1983274, 7200, 10800, 7200], [1984100, 7200, 7200, 10800], [1984275, 7200, 10800, 7200], [1986047, 7200, 7200, 10800], [1986282, 7200, 10800, 7200], [1987060, 7200, 7200, 10800], [1987304, 7200, 10800, 7200], [1988075, 7200, 7200, 10800], [1988305, 7200, 10800, 7200], [1989090, 7200, 7200, 10800], [1989274, 7200, 10800, 7200], [1990091, 7200, 7200, 10800], [1990273, 7200, 10800, 7200], [1991091, 0, 7200, 10800], [1991274, 0, 10800, 7200], [1992099, 0, 7200, 10800], [1992275, 0, 10800, 7200], [1993085, 0, 7200, 10800], [1993268, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994274, 0, 10800, 7200], [1995091, 0, 7200, 10800], [1995274, 0, 10800, 7200], [1996092, 0, 7200, 10800], [1996275, 0, 10800, 7200], [1997090, 0, 7200, 10800], [1997274, 0, 10800, 7200], [1998089, 0, 7200, 10800], [1998274, 0, 10800, 7200], [1999091, 0, 7200, 10800], [1999274, 0, 10800, 7200], [2000092, 0, 7200, 10800], [2000275, 0, 10800, 7200], [2001091, 0, 7200, 10800], [2001274, 0, 10800, 7200], [2002091, 0, 7200, 10800], [2002274, 0, 10800, 7200], [2003091, 0, 7200, 10800], [2003274, 0, 10800, 7200], [2004092, 0, 7200, 10800], [2004275, 0, 10800, 7200], [2005091, 0, 7200, 10800], [2005274, 0, 10800, 7200], [2006091, 0, 7200, 10800], [2006265, 0, 10800, 7200], [2007089, 0, 7200, 10800], [2007306, 0, 10800, 7200], [2008095, 0, 7200, 10800], [2008306, 0, 10800, 7200], [2009086, 0, 7200, 10800], [2009303, 0, 10800, 7200], [2010092, 0, 7200, 10800], [2010302, 0, 10800, 7200], [2011091, 0, 7200, 10800], [2011301, 0, 10800, 7200], [2012090, 0, 7200, 10800], [2012300, 0, 10800, 7200], [2013088, 0, 7200, 10800], [2013298, 0, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 5, 0, 0, 1, 7200, 7200, 10800], [10, 25, 5, 0, 0, 1, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asicu$__f_Asia_Damascus = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asicu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asicu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asicu$.prototype.constructor = $c_Lzonedb_java_tzdb$asicu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asicu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asicu$.prototype = $c_Lzonedb_java_tzdb$asicu$.prototype;
$c_Lzonedb_java_tzdb$asicu$.prototype.Asia_Damascus__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asicu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 326")
  };
  return this.Lzonedb_java_tzdb$asicu$__f_Asia_Damascus
});
var $d_Lzonedb_java_tzdb$asicu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asicu$: 0
}, false, "zonedb.java.tzdb$asicu$", {
  Lzonedb_java_tzdb$asicu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asicu$.prototype.$classData = $d_Lzonedb_java_tzdb$asicu$;
var $n_Lzonedb_java_tzdb$asicu$;
function $m_Lzonedb_java_tzdb$asicu$() {
  if ((!$n_Lzonedb_java_tzdb$asicu$)) {
    $n_Lzonedb_java_tzdb$asicu$ = new $c_Lzonedb_java_tzdb$asicu$()
  };
  return $n_Lzonedb_java_tzdb$asicu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asida$() {
  this.Lzonedb_java_tzdb$asida$__f_Asia_Baghdad = null;
  this.Lzonedb_java_tzdb$asida$__f_Asia_Magadan = null;
  this.Lzonedb_java_tzdb$asida$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asida$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 10660), $ct_T2__O__O__(new $c_T2(), "w", 10660), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, 10660, 10656], [1918001, 0, 10656, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, 10660, 10656], [1918001, 0, 10656, 10800], [1982121, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983090, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984275, 0, 14400, 10800], [1985091, 0, 10800, 14400], [1985272, 7200, 14400, 10800], [1986089, 3600, 10800, 14400], [1986271, 7200, 14400, 10800], [1987088, 3600, 10800, 14400], [1987270, 7200, 14400, 10800], [1988087, 3600, 10800, 14400], [1988269, 7200, 14400, 10800], [1989085, 3600, 10800, 14400], [1989267, 7200, 14400, 10800], [1990084, 3600, 10800, 14400], [1990273, 7200, 14400, 10800], [1991091, 10800, 10800, 14400], [1991274, 14400, 14400, 10800], [1992092, 10800, 10800, 14400], [1992275, 14400, 14400, 10800], [1993091, 10800, 10800, 14400], [1993274, 14400, 14400, 10800], [1994091, 10800, 10800, 14400], [1994274, 14400, 14400, 10800], [1995091, 10800, 10800, 14400], [1995274, 14400, 14400, 10800], [1996092, 10800, 10800, 14400], [1996275, 14400, 14400, 10800], [1997091, 10800, 10800, 14400], [1997274, 14400, 14400, 10800], [1998091, 10800, 10800, 14400], [1998274, 14400, 14400, 10800], [1999091, 10800, 10800, 14400], [1999274, 14400, 14400, 10800], [2000092, 10800, 10800, 14400], [2000275, 14400, 14400, 10800], [2001091, 10800, 10800, 14400], [2001274, 14400, 14400, 10800], [2002091, 10800, 10800, 14400], [2002274, 14400, 14400, 10800], [2003091, 10800, 10800, 14400], [2003274, 14400, 14400, 10800], [2004092, 10800, 10800, 14400], [2004275, 14400, 14400, 10800], [2005091, 10800, 10800, 14400], [2005274, 14400, 14400, 10800], [2006091, 10800, 10800, 14400], [2006274, 14400, 14400, 10800], [2007091, 10800, 10800, 14400], [2007274, 14400, 14400, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asida$__f_Asia_Baghdad = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asida$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asida$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 36192), $ct_T2__O__O__(new $c_T2(), "w", 36192), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 36192, 36000], [1930172, 0, 36000, 39600], [1991090, 7200, 39600, 36000], [1992019, 7200, 36000, 39600], [2011086, 7200, 39600, 43200], [2014299, 7200, 43200, 36000], [2016115, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 36192, 36000], [1930172, 0, 36000, 39600], [1981091, 0, 39600, 43200], [1981274, 0, 43200, 39600], [1982091, 0, 39600, 43200], [1982274, 0, 43200, 39600], [1983091, 0, 39600, 43200], [1983274, 0, 43200, 39600], [1984092, 0, 39600, 43200], [1984274, 10800, 43200, 39600], [1985090, 7200, 39600, 43200], [1985272, 10800, 43200, 39600], [1986089, 7200, 39600, 43200], [1986271, 10800, 43200, 39600], [1987088, 7200, 39600, 43200], [1987270, 10800, 43200, 39600], [1988087, 7200, 39600, 43200], [1988269, 10800, 43200, 39600], [1989085, 7200, 39600, 43200], [1989267, 10800, 43200, 39600], [1990084, 7200, 39600, 43200], [1990273, 10800, 43200, 39600], [1991272, 10800, 39600, 36000], [1992019, 7200, 36000, 39600], [1992089, 7200, 39600, 43200], [1992271, 10800, 43200, 39600], [1993087, 7200, 39600, 43200], [1993269, 10800, 43200, 39600], [1994086, 7200, 39600, 43200], [1994268, 10800, 43200, 39600], [1995085, 7200, 39600, 43200], [1995267, 10800, 43200, 39600], [1996091, 7200, 39600, 43200], [1996301, 10800, 43200, 39600], [1997089, 7200, 39600, 43200], [1997299, 10800, 43200, 39600], [1998088, 7200, 39600, 43200], [1998298, 10800, 43200, 39600], [1999087, 7200, 39600, 43200], [1999304, 10800, 43200, 39600], [2000086, 7200, 39600, 43200], [2000303, 10800, 43200, 39600], [2001084, 7200, 39600, 43200], [2001301, 10800, 43200, 39600], [2002090, 7200, 39600, 43200], [2002300, 10800, 43200, 39600], [2003089, 7200, 39600, 43200], [2003299, 10800, 43200, 39600], [2004088, 7200, 39600, 43200], [2004305, 10800, 43200, 39600], [2005086, 7200, 39600, 43200], [2005303, 10800, 43200, 39600], [2006085, 7200, 39600, 43200], [2006302, 10800, 43200, 39600], [2007084, 7200, 39600, 43200], [2007301, 10800, 43200, 39600], [2008090, 7200, 39600, 43200], [2008300, 10800, 43200, 39600], [2009088, 7200, 39600, 43200], [2009298, 10800, 43200, 39600], [2010087, 7200, 39600, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200], [2014299, 7200, 43200, 36000], [2016115, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asida$__f_Asia_Magadan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asida$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asida$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asida$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asida$.prototype.constructor = $c_Lzonedb_java_tzdb$asida$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asida$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asida$.prototype = $c_Lzonedb_java_tzdb$asida$.prototype;
$c_Lzonedb_java_tzdb$asida$.prototype.Asia_Baghdad__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asida$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 257")
  };
  return this.Lzonedb_java_tzdb$asida$__f_Asia_Baghdad
});
$c_Lzonedb_java_tzdb$asida$.prototype.Asia_Magadan__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asida$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 258")
  };
  return this.Lzonedb_java_tzdb$asida$__f_Asia_Magadan
});
var $d_Lzonedb_java_tzdb$asida$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asida$: 0
}, false, "zonedb.java.tzdb$asida$", {
  Lzonedb_java_tzdb$asida$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asida$.prototype.$classData = $d_Lzonedb_java_tzdb$asida$;
var $n_Lzonedb_java_tzdb$asida$;
function $m_Lzonedb_java_tzdb$asida$() {
  if ((!$n_Lzonedb_java_tzdb$asida$)) {
    $n_Lzonedb_java_tzdb$asida$ = new $c_Lzonedb_java_tzdb$asida$()
  };
  return $n_Lzonedb_java_tzdb$asida$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asidy$() {
  this.Lzonedb_java_tzdb$asidy$__f_Asia_Anadyr = null;
  this.Lzonedb_java_tzdb$asidy$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asidy$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 42596), $ct_T2__O__O__(new $c_T2(), "w", 42596), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 42596, 43200], [1930172, 0, 43200, 46800], [1982091, 0, 46800, 43200], [1991090, 7200, 43200, 39600], [1992019, 7200, 39600, 43200], [2010087, 7200, 43200, 39600], [2011086, 7200, 39600, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 42596, 43200], [1930172, 0, 43200, 46800], [1981091, 0, 46800, 50400], [1981274, 0, 50400, 46800], [1982274, 0, 46800, 43200], [1983091, 0, 43200, 46800], [1983274, 0, 46800, 43200], [1984092, 0, 43200, 46800], [1984274, 10800, 46800, 43200], [1985090, 7200, 43200, 46800], [1985272, 10800, 46800, 43200], [1986089, 7200, 43200, 46800], [1986271, 10800, 46800, 43200], [1987088, 7200, 43200, 46800], [1987270, 10800, 46800, 43200], [1988087, 7200, 43200, 46800], [1988269, 10800, 46800, 43200], [1989085, 7200, 43200, 46800], [1989267, 10800, 46800, 43200], [1990084, 7200, 43200, 46800], [1990273, 10800, 46800, 43200], [1991272, 10800, 43200, 39600], [1992019, 7200, 39600, 43200], [1992089, 7200, 43200, 46800], [1992271, 10800, 46800, 43200], [1993087, 7200, 43200, 46800], [1993269, 10800, 46800, 43200], [1994086, 7200, 43200, 46800], [1994268, 10800, 46800, 43200], [1995085, 7200, 43200, 46800], [1995267, 10800, 46800, 43200], [1996091, 7200, 43200, 46800], [1996301, 10800, 46800, 43200], [1997089, 7200, 43200, 46800], [1997299, 10800, 46800, 43200], [1998088, 7200, 43200, 46800], [1998298, 10800, 46800, 43200], [1999087, 7200, 43200, 46800], [1999304, 10800, 46800, 43200], [2000086, 7200, 43200, 46800], [2000303, 10800, 46800, 43200], [2001084, 7200, 43200, 46800], [2001301, 10800, 46800, 43200], [2002090, 7200, 43200, 46800], [2002300, 10800, 46800, 43200], [2003089, 7200, 43200, 46800], [2003299, 10800, 46800, 43200], [2004088, 7200, 43200, 46800], [2004305, 10800, 46800, 43200], [2005086, 7200, 43200, 46800], [2005303, 10800, 46800, 43200], [2006085, 7200, 43200, 46800], [2006302, 10800, 46800, 43200], [2007084, 7200, 43200, 46800], [2007301, 10800, 46800, 43200], [2008090, 7200, 43200, 46800], [2008300, 10800, 46800, 43200], [2009088, 7200, 43200, 46800], [2009298, 10800, 46800, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asidy$__f_Asia_Anadyr = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asidy$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asidy$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asidy$.prototype.constructor = $c_Lzonedb_java_tzdb$asidy$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asidy$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asidy$.prototype = $c_Lzonedb_java_tzdb$asidy$.prototype;
$c_Lzonedb_java_tzdb$asidy$.prototype.Asia_Anadyr__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asidy$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 432")
  };
  return this.Lzonedb_java_tzdb$asidy$__f_Asia_Anadyr
});
var $d_Lzonedb_java_tzdb$asidy$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asidy$: 0
}, false, "zonedb.java.tzdb$asidy$", {
  Lzonedb_java_tzdb$asidy$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asidy$.prototype.$classData = $d_Lzonedb_java_tzdb$asidy$;
var $n_Lzonedb_java_tzdb$asidy$;
function $m_Lzonedb_java_tzdb$asidy$() {
  if ((!$n_Lzonedb_java_tzdb$asidy$)) {
    $n_Lzonedb_java_tzdb$asidy$ = new $c_Lzonedb_java_tzdb$asidy$()
  };
  return $n_Lzonedb_java_tzdb$asidy$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asien$() {
  this.Lzonedb_java_tzdb$asien$__f_Asia_Tashkent = null;
  this.Lzonedb_java_tzdb$asien$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asien$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 16631), $ct_T2__O__O__(new $c_T2(), "w", 16631), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 16631, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 16631, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991272, 10800, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asien$__f_Asia_Tashkent = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asien$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asien$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asien$.prototype.constructor = $c_Lzonedb_java_tzdb$asien$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asien$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asien$.prototype = $c_Lzonedb_java_tzdb$asien$.prototype;
$c_Lzonedb_java_tzdb$asien$.prototype.Asia_Tashkent__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asien$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 122")
  };
  return this.Lzonedb_java_tzdb$asien$__f_Asia_Tashkent
});
var $d_Lzonedb_java_tzdb$asien$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asien$: 0
}, false, "zonedb.java.tzdb$asien$", {
  Lzonedb_java_tzdb$asien$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asien$.prototype.$classData = $d_Lzonedb_java_tzdb$asien$;
var $n_Lzonedb_java_tzdb$asien$;
function $m_Lzonedb_java_tzdb$asien$() {
  if ((!$n_Lzonedb_java_tzdb$asien$)) {
    $n_Lzonedb_java_tzdb$asien$ = new $c_Lzonedb_java_tzdb$asien$()
  };
  return $n_Lzonedb_java_tzdb$asien$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asier$() {
  this.Lzonedb_java_tzdb$asier$__f_Asia_Ust_minus_Nera = null;
  this.Lzonedb_java_tzdb$asier$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asier$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 34374), $ct_T2__O__O__(new $c_T2(), "w", 34374), $ct_T2__O__O__(new $c_T2(), "t", [[1919349, 0, 34374, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 39600], [1991090, 7200, 39600, 36000], [1992019, 7200, 36000, 39600], [2011086, 7200, 39600, 43200], [2011256, 0, 43200, 39600], [2014299, 7200, 39600, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919349, 0, 34374, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 43200], [1981274, 0, 43200, 39600], [1982091, 0, 39600, 43200], [1982274, 0, 43200, 39600], [1983091, 0, 39600, 43200], [1983274, 0, 43200, 39600], [1984092, 0, 39600, 43200], [1984274, 10800, 43200, 39600], [1985090, 7200, 39600, 43200], [1985272, 10800, 43200, 39600], [1986089, 7200, 39600, 43200], [1986271, 10800, 43200, 39600], [1987088, 7200, 39600, 43200], [1987270, 10800, 43200, 39600], [1988087, 7200, 39600, 43200], [1988269, 10800, 43200, 39600], [1989085, 7200, 39600, 43200], [1989267, 10800, 43200, 39600], [1990084, 7200, 39600, 43200], [1990273, 10800, 43200, 39600], [1991272, 10800, 39600, 36000], [1992019, 7200, 36000, 39600], [1992089, 7200, 39600, 43200], [1992271, 10800, 43200, 39600], [1993087, 7200, 39600, 43200], [1993269, 10800, 43200, 39600], [1994086, 7200, 39600, 43200], [1994268, 10800, 43200, 39600], [1995085, 7200, 39600, 43200], [1995267, 10800, 43200, 39600], [1996091, 7200, 39600, 43200], [1996301, 10800, 43200, 39600], [1997089, 7200, 39600, 43200], [1997299, 10800, 43200, 39600], [1998088, 7200, 39600, 43200], [1998298, 10800, 43200, 39600], [1999087, 7200, 39600, 43200], [1999304, 10800, 43200, 39600], [2000086, 7200, 39600, 43200], [2000303, 10800, 43200, 39600], [2001084, 7200, 39600, 43200], [2001301, 10800, 43200, 39600], [2002090, 7200, 39600, 43200], [2002300, 10800, 43200, 39600], [2003089, 7200, 39600, 43200], [2003299, 10800, 43200, 39600], [2004088, 7200, 39600, 43200], [2004305, 10800, 43200, 39600], [2005086, 7200, 39600, 43200], [2005303, 10800, 43200, 39600], [2006085, 7200, 39600, 43200], [2006302, 10800, 43200, 39600], [2007084, 7200, 39600, 43200], [2007301, 10800, 43200, 39600], [2008090, 7200, 39600, 43200], [2008300, 10800, 43200, 39600], [2009088, 7200, 39600, 43200], [2009298, 10800, 43200, 39600], [2010087, 7200, 39600, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200], [2011256, 0, 43200, 39600], [2014299, 7200, 39600, 36000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asier$__f_Asia_Ust_minus_Nera = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asier$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asier$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asier$.prototype.constructor = $c_Lzonedb_java_tzdb$asier$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asier$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asier$.prototype = $c_Lzonedb_java_tzdb$asier$.prototype;
$c_Lzonedb_java_tzdb$asier$.prototype.Asia_Ust_minus_Nera__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asier$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 332")
  };
  return this.Lzonedb_java_tzdb$asier$__f_Asia_Ust_minus_Nera
});
var $d_Lzonedb_java_tzdb$asier$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asier$: 0
}, false, "zonedb.java.tzdb$asier$", {
  Lzonedb_java_tzdb$asier$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asier$.prototype.$classData = $d_Lzonedb_java_tzdb$asier$;
var $n_Lzonedb_java_tzdb$asier$;
function $m_Lzonedb_java_tzdb$asier$() {
  if ((!$n_Lzonedb_java_tzdb$asier$)) {
    $n_Lzonedb_java_tzdb$asier$ = new $c_Lzonedb_java_tzdb$asier$()
  };
  return $n_Lzonedb_java_tzdb$asier$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asigo$() {
  this.Lzonedb_java_tzdb$asigo$__f_Asia_Yangon = null;
  this.Lzonedb_java_tzdb$asigo$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asigo$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 23087), $ct_T2__O__O__(new $c_T2(), "w", 23087), $ct_T2__O__O__(new $c_T2(), "t", [[1920001, 0, 23087, 23400], [1942121, 0, 23400, 32400], [1945123, 0, 32400, 23400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920001, 0, 23087, 23400], [1942121, 0, 23400, 32400], [1945123, 0, 32400, 23400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asigo$__f_Asia_Yangon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asigo$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asigo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asigo$.prototype.constructor = $c_Lzonedb_java_tzdb$asigo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asigo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asigo$.prototype = $c_Lzonedb_java_tzdb$asigo$.prototype;
$c_Lzonedb_java_tzdb$asigo$.prototype.Asia_Yangon__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asigo$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 542")
  };
  return this.Lzonedb_java_tzdb$asigo$__f_Asia_Yangon
});
var $d_Lzonedb_java_tzdb$asigo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asigo$: 0
}, false, "zonedb.java.tzdb$asigo$", {
  Lzonedb_java_tzdb$asigo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asigo$.prototype.$classData = $d_Lzonedb_java_tzdb$asigo$;
var $n_Lzonedb_java_tzdb$asigo$;
function $m_Lzonedb_java_tzdb$asigo$() {
  if ((!$n_Lzonedb_java_tzdb$asigo$)) {
    $n_Lzonedb_java_tzdb$asigo$ = new $c_Lzonedb_java_tzdb$asigo$()
  };
  return $n_Lzonedb_java_tzdb$asigo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiha$() {
  this.Lzonedb_java_tzdb$asiha$__f_Asia_Shanghai = null;
  this.Lzonedb_java_tzdb$asiha$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiha$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 29143), $ct_T2__O__O__(new $c_T2(), "w", 29143), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 29143, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 29143, 28800], [1940153, 0, 28800, 32400], [1940287, 0, 32400, 28800], [1941074, 0, 28800, 32400], [1941306, 0, 32400, 28800], [1942031, 0, 28800, 32400], [1945245, 0, 32400, 28800], [1946135, 0, 28800, 32400], [1946274, 0, 32400, 28800], [1947105, 0, 28800, 32400], [1947305, 0, 32400, 28800], [1948122, 0, 28800, 32400], [1948275, 0, 32400, 28800], [1949121, 0, 28800, 32400], [1949148, 0, 32400, 28800], [1986124, 7200, 28800, 32400], [1986257, 7200, 32400, 28800], [1987102, 7200, 28800, 32400], [1987256, 7200, 32400, 28800], [1988108, 7200, 28800, 32400], [1988255, 7200, 32400, 28800], [1989106, 7200, 28800, 32400], [1989260, 7200, 32400, 28800], [1990105, 7200, 28800, 32400], [1990259, 7200, 32400, 28800], [1991104, 7200, 28800, 32400], [1991258, 7200, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiha$__f_Asia_Shanghai = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiha$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiha$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiha$.prototype.constructor = $c_Lzonedb_java_tzdb$asiha$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiha$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiha$.prototype = $c_Lzonedb_java_tzdb$asiha$.prototype;
$c_Lzonedb_java_tzdb$asiha$.prototype.Asia_Shanghai__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiha$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 163")
  };
  return this.Lzonedb_java_tzdb$asiha$__f_Asia_Shanghai
});
var $d_Lzonedb_java_tzdb$asiha$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiha$: 0
}, false, "zonedb.java.tzdb$asiha$", {
  Lzonedb_java_tzdb$asiha$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiha$.prototype.$classData = $d_Lzonedb_java_tzdb$asiha$;
var $n_Lzonedb_java_tzdb$asiha$;
function $m_Lzonedb_java_tzdb$asiha$() {
  if ((!$n_Lzonedb_java_tzdb$asiha$)) {
    $n_Lzonedb_java_tzdb$asiha$ = new $c_Lzonedb_java_tzdb$asiha$()
  };
  return $n_Lzonedb_java_tzdb$asiha$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiil$() {
  this.Lzonedb_java_tzdb$asiil$__f_Asia_Manila = null;
  this.Lzonedb_java_tzdb$asiil$__f_Asia_Dili = null;
  this.Lzonedb_java_tzdb$asiil$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asiil$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-57360)), $ct_T2__O__O__(new $c_T2(), "w", (-57360)), $ct_T2__O__O__(new $c_T2(), "t", [[1844366, 0, (-57360), 29040], [1899131, 0, 29040, 28800], [1942121, 0, 28800, 32400], [1944306, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1844366, 0, (-57360), 29040], [1899131, 0, 29040, 28800], [1936306, 0, 28800, 32400], [1937032, 0, 32400, 28800], [1942121, 0, 28800, 32400], [1944306, 0, 32400, 28800], [1954102, 0, 28800, 32400], [1954182, 0, 32400, 28800], [1978081, 0, 28800, 32400], [1978264, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiil$__f_Asia_Manila = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiil$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asiil$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 30140), $ct_T2__O__O__(new $c_T2(), "w", 30140), $ct_T2__O__O__(new $c_T2(), "t", [[1912001, 0, 30140, 28800], [1942052, 82800, 28800, 32400], [1976124, 0, 32400, 28800], [2000261, 0, 28800, 32400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912001, 0, 30140, 28800], [1942052, 82800, 28800, 32400], [1976124, 0, 32400, 28800], [2000261, 0, 28800, 32400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asiil$__f_Asia_Dili = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asiil$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asiil$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asiil$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiil$.prototype.constructor = $c_Lzonedb_java_tzdb$asiil$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiil$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiil$.prototype = $c_Lzonedb_java_tzdb$asiil$.prototype;
$c_Lzonedb_java_tzdb$asiil$.prototype.Asia_Manila__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asiil$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 65")
  };
  return this.Lzonedb_java_tzdb$asiil$__f_Asia_Manila
});
$c_Lzonedb_java_tzdb$asiil$.prototype.Asia_Dili__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asiil$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 66")
  };
  return this.Lzonedb_java_tzdb$asiil$__f_Asia_Dili
});
var $d_Lzonedb_java_tzdb$asiil$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiil$: 0
}, false, "zonedb.java.tzdb$asiil$", {
  Lzonedb_java_tzdb$asiil$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiil$.prototype.$classData = $d_Lzonedb_java_tzdb$asiil$;
var $n_Lzonedb_java_tzdb$asiil$;
function $m_Lzonedb_java_tzdb$asiil$() {
  if ((!$n_Lzonedb_java_tzdb$asiil$)) {
    $n_Lzonedb_java_tzdb$asiil$ = new $c_Lzonedb_java_tzdb$asiil$()
  };
  return $n_Lzonedb_java_tzdb$asiil$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiin$() {
  this.Lzonedb_java_tzdb$asiin$__f_Asia_Ho_Chi_Minh = null;
  this.Lzonedb_java_tzdb$asiin$__f_Asia_Kuching = null;
  this.Lzonedb_java_tzdb$asiin$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asiin$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 25600), $ct_T2__O__O__(new $c_T2(), "w", 25600), $ct_T2__O__O__(new $c_T2(), "t", [[1906182, 0, 25600, 25590], [1911121, 0, 25590, 25200], [1942365, 82800, 25200, 28800], [1945073, 82800, 28800, 32400], [1945245, 0, 32400, 25200], [1947091, 0, 25200, 28800], [1955182, 0, 28800, 25200], [1959365, 82800, 25200, 28800], [1975164, 0, 28800, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1906182, 0, 25600, 25590], [1911121, 0, 25590, 25200], [1942365, 82800, 25200, 28800], [1945073, 82800, 28800, 32400], [1945245, 0, 32400, 25200], [1947091, 0, 25200, 28800], [1955182, 0, 28800, 25200], [1959365, 82800, 25200, 28800], [1975164, 0, 28800, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiin$__f_Asia_Ho_Chi_Minh = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiin$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asiin$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 26480), $ct_T2__O__O__(new $c_T2(), "w", 26480), $ct_T2__O__O__(new $c_T2(), "t", [[1926060, 0, 26480, 27000], [1933001, 0, 27000, 28800], [1942047, 0, 28800, 32400], [1945255, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1926060, 0, 26480, 27000], [1933001, 0, 27000, 28800], [1935257, 0, 28800, 30000], [1935348, 0, 30000, 28800], [1936258, 0, 28800, 30000], [1936349, 0, 30000, 28800], [1937257, 0, 28800, 30000], [1937348, 0, 30000, 28800], [1938257, 0, 28800, 30000], [1938348, 0, 30000, 28800], [1939257, 0, 28800, 30000], [1939348, 0, 30000, 28800], [1940258, 0, 28800, 30000], [1940349, 0, 30000, 28800], [1941257, 0, 28800, 30000], [1941348, 0, 30000, 28800], [1942047, 0, 28800, 32400], [1945255, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asiin$__f_Asia_Kuching = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asiin$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asiin$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asiin$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiin$.prototype.constructor = $c_Lzonedb_java_tzdb$asiin$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiin$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiin$.prototype = $c_Lzonedb_java_tzdb$asiin$.prototype;
$c_Lzonedb_java_tzdb$asiin$.prototype.Asia_Ho_Chi_Minh__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asiin$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 237")
  };
  return this.Lzonedb_java_tzdb$asiin$__f_Asia_Ho_Chi_Minh
});
$c_Lzonedb_java_tzdb$asiin$.prototype.Asia_Kuching__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asiin$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 238")
  };
  return this.Lzonedb_java_tzdb$asiin$__f_Asia_Kuching
});
var $d_Lzonedb_java_tzdb$asiin$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiin$: 0
}, false, "zonedb.java.tzdb$asiin$", {
  Lzonedb_java_tzdb$asiin$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiin$.prototype.$classData = $d_Lzonedb_java_tzdb$asiin$;
var $n_Lzonedb_java_tzdb$asiin$;
function $m_Lzonedb_java_tzdb$asiin$() {
  if ((!$n_Lzonedb_java_tzdb$asiin$)) {
    $n_Lzonedb_java_tzdb$asiin$ = new $c_Lzonedb_java_tzdb$asiin$()
  };
  return $n_Lzonedb_java_tzdb$asiin$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiis$() {
  this.Lzonedb_java_tzdb$asiis$__f_Asia_Tbilisi = null;
  this.Lzonedb_java_tzdb$asiis$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiis$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 10751), $ct_T2__O__O__(new $c_T2(), "w", 10751), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 10751, 10800], [1957060, 0, 10800, 14400], [1991090, 7200, 14400, 10800], [1994267, 82800, 10800, 14400], [2004178, 82800, 14400, 10800], [2005086, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 10751, 10800], [1957060, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989085, 7200, 14400, 18000], [1989267, 10800, 18000, 14400], [1990084, 7200, 14400, 18000], [1990273, 10800, 18000, 14400], [1991272, 10800, 14400, 10800], [1992089, 0, 10800, 14400], [1992271, 0, 14400, 10800], [1993087, 0, 10800, 14400], [1993269, 0, 14400, 10800], [1994086, 0, 10800, 14400], [1995085, 0, 14400, 18000], [1995267, 0, 18000, 14400], [1996091, 0, 14400, 18000], [1997299, 0, 18000, 14400], [1998088, 0, 14400, 18000], [1998298, 0, 18000, 14400], [1999087, 0, 14400, 18000], [1999304, 0, 18000, 14400], [2000086, 0, 14400, 18000], [2000303, 0, 18000, 14400], [2001084, 0, 14400, 18000], [2001301, 0, 18000, 14400], [2002090, 0, 14400, 18000], [2002300, 0, 18000, 14400], [2003089, 0, 14400, 18000], [2003299, 0, 18000, 14400], [2004088, 0, 14400, 18000], [2004179, 0, 18000, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiis$__f_Asia_Tbilisi = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiis$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiis$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiis$.prototype.constructor = $c_Lzonedb_java_tzdb$asiis$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiis$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiis$.prototype = $c_Lzonedb_java_tzdb$asiis$.prototype;
$c_Lzonedb_java_tzdb$asiis$.prototype.Asia_Tbilisi__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiis$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 683")
  };
  return this.Lzonedb_java_tzdb$asiis$__f_Asia_Tbilisi
});
var $d_Lzonedb_java_tzdb$asiis$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiis$: 0
}, false, "zonedb.java.tzdb$asiis$", {
  Lzonedb_java_tzdb$asiis$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiis$.prototype.$classData = $d_Lzonedb_java_tzdb$asiis$;
var $n_Lzonedb_java_tzdb$asiis$;
function $m_Lzonedb_java_tzdb$asiis$() {
  if ((!$n_Lzonedb_java_tzdb$asiis$)) {
    $n_Lzonedb_java_tzdb$asiis$ = new $c_Lzonedb_java_tzdb$asiis$()
  };
  return $n_Lzonedb_java_tzdb$asiis$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiit$() {
  this.Lzonedb_java_tzdb$asiit$__f_Asia_Chita = null;
  this.Lzonedb_java_tzdb$asiit$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiit$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 27232), $ct_T2__O__O__(new $c_T2(), "w", 27232), $ct_T2__O__O__(new $c_T2(), "t", [[1919349, 0, 27232, 28800], [1930172, 0, 28800, 32400], [1991090, 7200, 32400, 28800], [1992019, 7200, 28800, 32400], [2011086, 7200, 32400, 36000], [2014299, 7200, 36000, 28800], [2016087, 7200, 28800, 32400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919349, 0, 27232, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 36000], [1981274, 0, 36000, 32400], [1982091, 0, 32400, 36000], [1982274, 0, 36000, 32400], [1983091, 0, 32400, 36000], [1983274, 0, 36000, 32400], [1984092, 0, 32400, 36000], [1984274, 10800, 36000, 32400], [1985090, 7200, 32400, 36000], [1985272, 10800, 36000, 32400], [1986089, 7200, 32400, 36000], [1986271, 10800, 36000, 32400], [1987088, 7200, 32400, 36000], [1987270, 10800, 36000, 32400], [1988087, 7200, 32400, 36000], [1988269, 10800, 36000, 32400], [1989085, 7200, 32400, 36000], [1989267, 10800, 36000, 32400], [1990084, 7200, 32400, 36000], [1990273, 10800, 36000, 32400], [1991272, 10800, 32400, 28800], [1992019, 7200, 28800, 32400], [1992089, 7200, 32400, 36000], [1992271, 10800, 36000, 32400], [1993087, 7200, 32400, 36000], [1993269, 10800, 36000, 32400], [1994086, 7200, 32400, 36000], [1994268, 10800, 36000, 32400], [1995085, 7200, 32400, 36000], [1995267, 10800, 36000, 32400], [1996091, 7200, 32400, 36000], [1996301, 10800, 36000, 32400], [1997089, 7200, 32400, 36000], [1997299, 10800, 36000, 32400], [1998088, 7200, 32400, 36000], [1998298, 10800, 36000, 32400], [1999087, 7200, 32400, 36000], [1999304, 10800, 36000, 32400], [2000086, 7200, 32400, 36000], [2000303, 10800, 36000, 32400], [2001084, 7200, 32400, 36000], [2001301, 10800, 36000, 32400], [2002090, 7200, 32400, 36000], [2002300, 10800, 36000, 32400], [2003089, 7200, 32400, 36000], [2003299, 10800, 36000, 32400], [2004088, 7200, 32400, 36000], [2004305, 10800, 36000, 32400], [2005086, 7200, 32400, 36000], [2005303, 10800, 36000, 32400], [2006085, 7200, 32400, 36000], [2006302, 10800, 36000, 32400], [2007084, 7200, 32400, 36000], [2007301, 10800, 36000, 32400], [2008090, 7200, 32400, 36000], [2008300, 10800, 36000, 32400], [2009088, 7200, 32400, 36000], [2009298, 10800, 36000, 32400], [2010087, 7200, 32400, 36000], [2010304, 10800, 36000, 32400], [2011086, 7200, 32400, 36000], [2014299, 7200, 36000, 28800], [2016087, 7200, 28800, 32400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiit$__f_Asia_Chita = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiit$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiit$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiit$.prototype.constructor = $c_Lzonedb_java_tzdb$asiit$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiit$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiit$.prototype = $c_Lzonedb_java_tzdb$asiit$.prototype;
$c_Lzonedb_java_tzdb$asiit$.prototype.Asia_Chita__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiit$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 56")
  };
  return this.Lzonedb_java_tzdb$asiit$__f_Asia_Chita
});
var $d_Lzonedb_java_tzdb$asiit$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiit$: 0
}, false, "zonedb.java.tzdb$asiit$", {
  Lzonedb_java_tzdb$asiit$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiit$.prototype.$classData = $d_Lzonedb_java_tzdb$asiit$;
var $n_Lzonedb_java_tzdb$asiit$;
function $m_Lzonedb_java_tzdb$asiit$() {
  if ((!$n_Lzonedb_java_tzdb$asiit$)) {
    $n_Lzonedb_java_tzdb$asiit$ = new $c_Lzonedb_java_tzdb$asiit$()
  };
  return $n_Lzonedb_java_tzdb$asiit$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asike$() {
  this.Lzonedb_java_tzdb$asike$__f_Asia_Bishkek = null;
  this.Lzonedb_java_tzdb$asike$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asike$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 17904), $ct_T2__O__O__(new $c_T2(), "w", 17904), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 17904, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000], [2005223, 82800, 18000, 21600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 17904, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991243, 7200, 21600, 18000], [1992103, 0, 18000, 21600], [1992271, 0, 21600, 18000], [1993101, 0, 18000, 21600], [1993269, 0, 21600, 18000], [1994100, 0, 18000, 21600], [1994268, 0, 21600, 18000], [1995099, 0, 18000, 21600], [1995267, 0, 21600, 18000], [1996098, 0, 18000, 21600], [1996273, 0, 21600, 18000], [1997089, 9000, 18000, 21600], [1997299, 9000, 21600, 18000], [1998088, 9000, 18000, 21600], [1998298, 9000, 21600, 18000], [1999087, 9000, 18000, 21600], [1999304, 9000, 21600, 18000], [2000086, 9000, 18000, 21600], [2000303, 9000, 21600, 18000], [2001084, 9000, 18000, 21600], [2001301, 9000, 21600, 18000], [2002090, 9000, 18000, 21600], [2002300, 9000, 21600, 18000], [2003089, 9000, 18000, 21600], [2003299, 9000, 21600, 18000], [2004088, 9000, 18000, 21600], [2004305, 9000, 21600, 18000], [2005086, 9000, 18000, 21600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asike$__f_Asia_Bishkek = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asike$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asike$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asike$.prototype.constructor = $c_Lzonedb_java_tzdb$asike$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asike$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asike$.prototype = $c_Lzonedb_java_tzdb$asike$.prototype;
$c_Lzonedb_java_tzdb$asike$.prototype.Asia_Bishkek__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asike$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 213")
  };
  return this.Lzonedb_java_tzdb$asike$__f_Asia_Bishkek
});
var $d_Lzonedb_java_tzdb$asike$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asike$: 0
}, false, "zonedb.java.tzdb$asike$", {
  Lzonedb_java_tzdb$asike$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asike$.prototype.$classData = $d_Lzonedb_java_tzdb$asike$;
var $n_Lzonedb_java_tzdb$asike$;
function $m_Lzonedb_java_tzdb$asike$() {
  if ((!$n_Lzonedb_java_tzdb$asike$)) {
    $n_Lzonedb_java_tzdb$asike$ = new $c_Lzonedb_java_tzdb$asike$()
  };
  return $n_Lzonedb_java_tzdb$asike$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiko$() {
  this.Lzonedb_java_tzdb$asiko$__f_Asia_Bangkok = null;
  this.Lzonedb_java_tzdb$asiko$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiko$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 24124), $ct_T2__O__O__(new $c_T2(), "w", 24124), $ct_T2__O__O__(new $c_T2(), "t", [[1920092, 0, 24124, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920092, 0, 24124, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiko$__f_Asia_Bangkok = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiko$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiko$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiko$.prototype.constructor = $c_Lzonedb_java_tzdb$asiko$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiko$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiko$.prototype = $c_Lzonedb_java_tzdb$asiko$.prototype;
$c_Lzonedb_java_tzdb$asiko$.prototype.Asia_Bangkok__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiko$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 438")
  };
  return this.Lzonedb_java_tzdb$asiko$__f_Asia_Bangkok
});
var $d_Lzonedb_java_tzdb$asiko$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiko$: 0
}, false, "zonedb.java.tzdb$asiko$", {
  Lzonedb_java_tzdb$asiko$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiko$.prototype.$classData = $d_Lzonedb_java_tzdb$asiko$;
var $n_Lzonedb_java_tzdb$asiko$;
function $m_Lzonedb_java_tzdb$asiko$() {
  if ((!$n_Lzonedb_java_tzdb$asiko$)) {
    $n_Lzonedb_java_tzdb$asiko$ = new $c_Lzonedb_java_tzdb$asiko$()
  };
  return $n_Lzonedb_java_tzdb$asiko$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiky$() {
  this.Lzonedb_java_tzdb$asiky$__f_Asia_Tokyo = null;
  this.Lzonedb_java_tzdb$asiky$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiky$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 33539), $ct_T2__O__O__(new $c_T2(), "w", 33539), $ct_T2__O__O__(new $c_T2(), "t", [[1888001, 1139, 33539, 32400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1888001, 1139, 33539, 32400], [1948123, 0, 32400, 36000], [1948256, 3600, 36000, 32400], [1949093, 0, 32400, 36000], [1949254, 3600, 36000, 32400], [1950127, 0, 32400, 36000], [1950253, 3600, 36000, 32400], [1951126, 0, 32400, 36000], [1951259, 3600, 36000, 32400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiky$__f_Asia_Tokyo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiky$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiky$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiky$.prototype.constructor = $c_Lzonedb_java_tzdb$asiky$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiky$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiky$.prototype = $c_Lzonedb_java_tzdb$asiky$.prototype;
$c_Lzonedb_java_tzdb$asiky$.prototype.Asia_Tokyo__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiky$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 629")
  };
  return this.Lzonedb_java_tzdb$asiky$__f_Asia_Tokyo
});
var $d_Lzonedb_java_tzdb$asiky$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiky$: 0
}, false, "zonedb.java.tzdb$asiky$", {
  Lzonedb_java_tzdb$asiky$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiky$.prototype.$classData = $d_Lzonedb_java_tzdb$asiky$;
var $n_Lzonedb_java_tzdb$asiky$;
function $m_Lzonedb_java_tzdb$asiky$() {
  if ((!$n_Lzonedb_java_tzdb$asiky$)) {
    $n_Lzonedb_java_tzdb$asiky$ = new $c_Lzonedb_java_tzdb$asiky$()
  };
  return $n_Lzonedb_java_tzdb$asiky$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asile$() {
  this.Lzonedb_java_tzdb$asile$__f_Asia_Jerusalem = null;
  this.Lzonedb_java_tzdb$asile$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asile$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8454), $ct_T2__O__O__(new $c_T2(), "w", 8454), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 8454, 8440], [1918001, 0, 8440, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 8454, 8440], [1918001, 0, 8440, 7200], [1940153, 0, 7200, 10800], [1942305, 0, 10800, 7200], [1943091, 7200, 7200, 10800], [1943305, 0, 10800, 7200], [1944092, 0, 7200, 10800], [1944306, 0, 10800, 7200], [1945106, 0, 7200, 10800], [1945305, 7200, 10800, 7200], [1946106, 7200, 7200, 10800], [1946305, 0, 10800, 7200], [1948144, 0, 7200, 14400], [1948245, 0, 14400, 10800], [1948306, 7200, 10800, 7200], [1949121, 0, 7200, 10800], [1949305, 7200, 10800, 7200], [1950106, 0, 7200, 10800], [1950258, 10800, 10800, 7200], [1951091, 0, 7200, 10800], [1951315, 10800, 10800, 7200], [1952111, 7200, 7200, 10800], [1952293, 10800, 10800, 7200], [1953102, 7200, 7200, 10800], [1953256, 10800, 10800, 7200], [1954164, 0, 7200, 10800], [1954255, 0, 10800, 7200], [1955162, 7200, 7200, 10800], [1955254, 0, 10800, 7200], [1956155, 0, 7200, 10800], [1956274, 10800, 10800, 7200], [1957119, 7200, 7200, 10800], [1957265, 0, 10800, 7200], [1974188, 0, 7200, 10800], [1974286, 0, 10800, 7200], [1975110, 0, 7200, 10800], [1975243, 0, 10800, 7200], [1980215, 0, 7200, 10800], [1980257, 3600, 10800, 7200], [1984126, 0, 7200, 10800], [1984238, 3600, 10800, 7200], [1985104, 0, 7200, 10800], [1985258, 0, 10800, 7200], [1986138, 0, 7200, 10800], [1986250, 0, 10800, 7200], [1987105, 0, 7200, 10800], [1987256, 0, 10800, 7200], [1988101, 0, 7200, 10800], [1988248, 0, 10800, 7200], [1989120, 0, 7200, 10800], [1989246, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990238, 0, 10800, 7200], [1991083, 0, 7200, 10800], [1991244, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992250, 0, 10800, 7200], [1993092, 0, 7200, 10800], [1993248, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994240, 0, 10800, 7200], [1995090, 0, 7200, 10800], [1995246, 0, 10800, 7200], [1996075, 0, 7200, 10800], [1996260, 0, 10800, 7200], [1997080, 0, 7200, 10800], [1997257, 0, 10800, 7200], [1998079, 0, 7200, 10800], [1998249, 0, 10800, 7200], [1999092, 7200, 7200, 10800], [1999246, 7200, 10800, 7200], [2000105, 7200, 7200, 10800], [2000280, 3600, 10800, 7200], [2001099, 3600, 7200, 10800], [2001267, 3600, 10800, 7200], [2002088, 3600, 7200, 10800], [2002280, 3600, 10800, 7200], [2003087, 3600, 7200, 10800], [2003276, 3600, 10800, 7200], [2004098, 3600, 7200, 10800], [2004266, 3600, 10800, 7200], [2005091, 7200, 7200, 10800], [2005282, 7200, 10800, 7200], [2006090, 7200, 7200, 10800], [2006274, 7200, 10800, 7200], [2007089, 7200, 7200, 10800], [2007259, 7200, 10800, 7200], [2008088, 7200, 7200, 10800], [2008279, 7200, 10800, 7200], [2009086, 7200, 7200, 10800], [2009270, 7200, 10800, 7200], [2010085, 7200, 7200, 10800], [2010255, 7200, 10800, 7200], [2011091, 7200, 7200, 10800], [2011275, 7200, 10800, 7200], [2012090, 7200, 7200, 10800], [2012267, 7200, 10800, 7200], [2013088, 7200, 7200, 10800], [2013300, 7200, 10800, 7200], [2014087, 7200, 7200, 10800], [2014299, 7200, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 23, 5, 7200, 0, 1, 7200, 7200, 10800], [10, 25, 7, 7200, 0, 1, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asile$__f_Asia_Jerusalem = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asile$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asile$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asile$.prototype.constructor = $c_Lzonedb_java_tzdb$asile$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asile$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asile$.prototype = $c_Lzonedb_java_tzdb$asile$.prototype;
$c_Lzonedb_java_tzdb$asile$.prototype.Asia_Jerusalem__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asile$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 26")
  };
  return this.Lzonedb_java_tzdb$asile$__f_Asia_Jerusalem
});
var $d_Lzonedb_java_tzdb$asile$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asile$: 0
}, false, "zonedb.java.tzdb$asile$", {
  Lzonedb_java_tzdb$asile$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asile$.prototype.$classData = $d_Lzonedb_java_tzdb$asile$;
var $n_Lzonedb_java_tzdb$asile$;
function $m_Lzonedb_java_tzdb$asile$() {
  if ((!$n_Lzonedb_java_tzdb$asile$)) {
    $n_Lzonedb_java_tzdb$asile$ = new $c_Lzonedb_java_tzdb$asile$()
  };
  return $n_Lzonedb_java_tzdb$asile$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asili$() {
  this.Lzonedb_java_tzdb$asili$__f_Asia_Sakhalin = null;
  this.Lzonedb_java_tzdb$asili$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asili$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 34248), $ct_T2__O__O__(new $c_T2(), "w", 34248), $ct_T2__O__O__(new $c_T2(), "t", [[1905235, 0, 34248, 32400], [1945237, 0, 32400, 39600], [1991090, 7200, 39600, 36000], [1992019, 7200, 36000, 39600], [1997089, 7200, 39600, 36000], [2011086, 7200, 36000, 39600], [2014299, 7200, 39600, 36000], [2016087, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1905235, 0, 34248, 32400], [1945237, 0, 32400, 39600], [1981091, 0, 39600, 43200], [1981274, 0, 43200, 39600], [1982091, 0, 39600, 43200], [1982274, 0, 43200, 39600], [1983091, 0, 39600, 43200], [1983274, 0, 43200, 39600], [1984092, 0, 39600, 43200], [1984274, 10800, 43200, 39600], [1985090, 7200, 39600, 43200], [1985272, 10800, 43200, 39600], [1986089, 7200, 39600, 43200], [1986271, 10800, 43200, 39600], [1987088, 7200, 39600, 43200], [1987270, 10800, 43200, 39600], [1988087, 7200, 39600, 43200], [1988269, 10800, 43200, 39600], [1989085, 7200, 39600, 43200], [1989267, 10800, 43200, 39600], [1990084, 7200, 39600, 43200], [1990273, 10800, 43200, 39600], [1991272, 10800, 39600, 36000], [1992019, 7200, 36000, 39600], [1992089, 7200, 39600, 43200], [1992271, 10800, 43200, 39600], [1993087, 7200, 39600, 43200], [1993269, 10800, 43200, 39600], [1994086, 7200, 39600, 43200], [1994268, 10800, 43200, 39600], [1995085, 7200, 39600, 43200], [1995267, 10800, 43200, 39600], [1996091, 7200, 39600, 43200], [1996301, 10800, 43200, 39600], [1997299, 10800, 39600, 36000], [1998088, 7200, 36000, 39600], [1998298, 10800, 39600, 36000], [1999087, 7200, 36000, 39600], [1999304, 10800, 39600, 36000], [2000086, 7200, 36000, 39600], [2000303, 10800, 39600, 36000], [2001084, 7200, 36000, 39600], [2001301, 10800, 39600, 36000], [2002090, 7200, 36000, 39600], [2002300, 10800, 39600, 36000], [2003089, 7200, 36000, 39600], [2003299, 10800, 39600, 36000], [2004088, 7200, 36000, 39600], [2004305, 10800, 39600, 36000], [2005086, 7200, 36000, 39600], [2005303, 10800, 39600, 36000], [2006085, 7200, 36000, 39600], [2006302, 10800, 39600, 36000], [2007084, 7200, 36000, 39600], [2007301, 10800, 39600, 36000], [2008090, 7200, 36000, 39600], [2008300, 10800, 39600, 36000], [2009088, 7200, 36000, 39600], [2009298, 10800, 39600, 36000], [2010087, 7200, 36000, 39600], [2010304, 10800, 39600, 36000], [2011086, 7200, 36000, 39600], [2014299, 7200, 39600, 36000], [2016087, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asili$__f_Asia_Sakhalin = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asili$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asili$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asili$.prototype.constructor = $c_Lzonedb_java_tzdb$asili$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asili$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asili$.prototype = $c_Lzonedb_java_tzdb$asili$.prototype;
$c_Lzonedb_java_tzdb$asili$.prototype.Asia_Sakhalin__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asili$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 186")
  };
  return this.Lzonedb_java_tzdb$asili$__f_Asia_Sakhalin
});
var $d_Lzonedb_java_tzdb$asili$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asili$: 0
}, false, "zonedb.java.tzdb$asili$", {
  Lzonedb_java_tzdb$asili$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asili$.prototype.$classData = $d_Lzonedb_java_tzdb$asili$;
var $n_Lzonedb_java_tzdb$asili$;
function $m_Lzonedb_java_tzdb$asili$() {
  if ((!$n_Lzonedb_java_tzdb$asili$)) {
    $n_Lzonedb_java_tzdb$asili$ = new $c_Lzonedb_java_tzdb$asili$()
  };
  return $n_Lzonedb_java_tzdb$asili$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asima$() {
  this.Lzonedb_java_tzdb$asima$__f_Asia_Amman = null;
  this.Lzonedb_java_tzdb$asima$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asima$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8624), $ct_T2__O__O__(new $c_T2(), "w", 8624), $ct_T2__O__O__(new $c_T2(), "t", [[1931001, 0, 8624, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1931001, 0, 8624, 7200], [1973157, 0, 7200, 10800], [1973274, 0, 10800, 7200], [1974121, 0, 7200, 10800], [1974274, 0, 10800, 7200], [1975121, 0, 7200, 10800], [1975274, 0, 10800, 7200], [1976122, 0, 7200, 10800], [1976306, 0, 10800, 7200], [1977121, 0, 7200, 10800], [1977274, 0, 10800, 7200], [1978120, 0, 7200, 10800], [1978273, 0, 10800, 7200], [1985091, 0, 7200, 10800], [1985274, 0, 10800, 7200], [1986094, 0, 7200, 10800], [1986276, 0, 10800, 7200], [1987093, 0, 7200, 10800], [1987275, 0, 10800, 7200], [1988092, 0, 7200, 10800], [1988281, 0, 10800, 7200], [1989128, 0, 7200, 10800], [1989279, 0, 10800, 7200], [1990117, 0, 7200, 10800], [1990278, 0, 10800, 7200], [1991107, 0, 7200, 10800], [1991270, 0, 10800, 7200], [1992101, 0, 7200, 10800], [1992276, 0, 10800, 7200], [1993092, 0, 7200, 10800], [1993274, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994259, 0, 10800, 7200], [1995097, 0, 7200, 10800], [1995258, 3600, 10800, 7200], [1996096, 0, 7200, 10800], [1996264, 3600, 10800, 7200], [1997094, 0, 7200, 10800], [1997262, 3600, 10800, 7200], [1998093, 0, 7200, 10800], [1998261, 3600, 10800, 7200], [1999182, 0, 7200, 10800], [1999267, 3600, 10800, 7200], [2000090, 0, 7200, 10800], [2000273, 3600, 10800, 7200], [2001088, 0, 7200, 10800], [2001271, 3600, 10800, 7200], [2002088, 0, 7200, 10800], [2002270, 3600, 10800, 7200], [2003087, 0, 7200, 10800], [2003297, 3600, 10800, 7200], [2004086, 0, 7200, 10800], [2004289, 3600, 10800, 7200], [2005091, 0, 7200, 10800], [2005273, 3600, 10800, 7200], [2006090, 0, 7200, 10800], [2006300, 3600, 10800, 7200], [2007089, 0, 7200, 10800], [2007299, 3600, 10800, 7200], [2008088, 0, 7200, 10800], [2008305, 3600, 10800, 7200], [2009086, 0, 7200, 10800], [2009303, 3600, 10800, 7200], [2010085, 0, 7200, 10800], [2010302, 3600, 10800, 7200], [2011091, 0, 7200, 10800], [2011301, 3600, 10800, 7200], [2012090, 0, 7200, 10800], [2013354, 0, 10800, 7200], [2014087, 0, 7200, 10800], [2014304, 3600, 10800, 7200], [2015086, 0, 7200, 10800], [2015303, 3600, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 26, 5, 0, 0, 1, 7200, 7200, 10800], [10, 25, 5, 0, 0, 2, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asima$__f_Asia_Amman = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asima$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asima$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asima$.prototype.constructor = $c_Lzonedb_java_tzdb$asima$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asima$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asima$.prototype = $c_Lzonedb_java_tzdb$asima$.prototype;
$c_Lzonedb_java_tzdb$asima$.prototype.Asia_Amman__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asima$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 304")
  };
  return this.Lzonedb_java_tzdb$asima$__f_Asia_Amman
});
var $d_Lzonedb_java_tzdb$asima$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asima$: 0
}, false, "zonedb.java.tzdb$asima$", {
  Lzonedb_java_tzdb$asima$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asima$.prototype.$classData = $d_Lzonedb_java_tzdb$asima$;
var $n_Lzonedb_java_tzdb$asima$;
function $m_Lzonedb_java_tzdb$asima$() {
  if ((!$n_Lzonedb_java_tzdb$asima$)) {
    $n_Lzonedb_java_tzdb$asima$ = new $c_Lzonedb_java_tzdb$asima$()
  };
  return $n_Lzonedb_java_tzdb$asima$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asimb$() {
  this.Lzonedb_java_tzdb$asimb$__f_Asia_Colombo = null;
  this.Lzonedb_java_tzdb$asimb$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asimb$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 19164), $ct_T2__O__O__(new $c_T2(), "w", 19164), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 19164, 19172], [1906001, 0, 19172, 19800], [1996146, 0, 19800, 23400], [1996300, 1800, 23400, 21600], [2006105, 1800, 21600, 19800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 19164, 19172], [1906001, 0, 19172, 19800], [1942005, 0, 19800, 21600], [1942244, 0, 21600, 23400], [1945289, 7200, 23400, 19800], [1996146, 0, 19800, 23400], [1996300, 1800, 23400, 21600], [2006105, 1800, 21600, 19800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asimb$__f_Asia_Colombo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asimb$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asimb$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asimb$.prototype.constructor = $c_Lzonedb_java_tzdb$asimb$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asimb$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asimb$.prototype = $c_Lzonedb_java_tzdb$asimb$.prototype;
$c_Lzonedb_java_tzdb$asimb$.prototype.Asia_Colombo__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asimb$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 758")
  };
  return this.Lzonedb_java_tzdb$asimb$__f_Asia_Colombo
});
var $d_Lzonedb_java_tzdb$asimb$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asimb$: 0
}, false, "zonedb.java.tzdb$asimb$", {
  Lzonedb_java_tzdb$asimb$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asimb$.prototype.$classData = $d_Lzonedb_java_tzdb$asimb$;
var $n_Lzonedb_java_tzdb$asimb$;
function $m_Lzonedb_java_tzdb$asimb$() {
  if ((!$n_Lzonedb_java_tzdb$asimb$)) {
    $n_Lzonedb_java_tzdb$asimb$ = new $c_Lzonedb_java_tzdb$asimb$()
  };
  return $n_Lzonedb_java_tzdb$asimb$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asimq$() {
  this.Lzonedb_java_tzdb$asimq$__f_Asia_Urumqi = null;
  this.Lzonedb_java_tzdb$asimq$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asimq$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 21020), $ct_T2__O__O__(new $c_T2(), "w", 21020), $ct_T2__O__O__(new $c_T2(), "t", [[1928001, 0, 21020, 21600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1928001, 0, 21020, 21600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asimq$__f_Asia_Urumqi = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asimq$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asimq$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asimq$.prototype.constructor = $c_Lzonedb_java_tzdb$asimq$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asimq$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asimq$.prototype = $c_Lzonedb_java_tzdb$asimq$.prototype;
$c_Lzonedb_java_tzdb$asimq$.prototype.Asia_Urumqi__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asimq$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 521")
  };
  return this.Lzonedb_java_tzdb$asimq$__f_Asia_Urumqi
});
var $d_Lzonedb_java_tzdb$asimq$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asimq$: 0
}, false, "zonedb.java.tzdb$asimq$", {
  Lzonedb_java_tzdb$asimq$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asimq$.prototype.$classData = $d_Lzonedb_java_tzdb$asimq$;
var $n_Lzonedb_java_tzdb$asimq$;
function $m_Lzonedb_java_tzdb$asimq$() {
  if ((!$n_Lzonedb_java_tzdb$asimq$)) {
    $n_Lzonedb_java_tzdb$asimq$ = new $c_Lzonedb_java_tzdb$asimq$()
  };
  return $n_Lzonedb_java_tzdb$asimq$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asims$() {
  this.Lzonedb_java_tzdb$asims$__f_Asia_Omsk = null;
  this.Lzonedb_java_tzdb$asims$__f_Asia_Srednekolymsk = null;
  this.Lzonedb_java_tzdb$asims$__f_Asia_Tomsk = null;
  this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asims$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 17610), $ct_T2__O__O__(new $c_T2(), "w", 17610), $ct_T2__O__O__(new $c_T2(), "t", [[1919318, 0, 17610, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000], [1992019, 7200, 18000, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919318, 0, 17610, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991272, 10800, 21600, 18000], [1992019, 7200, 18000, 21600], [1992089, 7200, 21600, 25200], [1992271, 10800, 25200, 21600], [1993087, 7200, 21600, 25200], [1993269, 10800, 25200, 21600], [1994086, 7200, 21600, 25200], [1994268, 10800, 25200, 21600], [1995085, 7200, 21600, 25200], [1995267, 10800, 25200, 21600], [1996091, 7200, 21600, 25200], [1996301, 10800, 25200, 21600], [1997089, 7200, 21600, 25200], [1997299, 10800, 25200, 21600], [1998088, 7200, 21600, 25200], [1998298, 10800, 25200, 21600], [1999087, 7200, 21600, 25200], [1999304, 10800, 25200, 21600], [2000086, 7200, 21600, 25200], [2000303, 10800, 25200, 21600], [2001084, 7200, 21600, 25200], [2001301, 10800, 25200, 21600], [2002090, 7200, 21600, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600], [2005086, 7200, 21600, 25200], [2005303, 10800, 25200, 21600], [2006085, 7200, 21600, 25200], [2006302, 10800, 25200, 21600], [2007084, 7200, 21600, 25200], [2007301, 10800, 25200, 21600], [2008090, 7200, 21600, 25200], [2008300, 10800, 25200, 21600], [2009088, 7200, 21600, 25200], [2009298, 10800, 25200, 21600], [2010087, 7200, 21600, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asims$__f_Asia_Omsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 36892), $ct_T2__O__O__(new $c_T2(), "w", 36892), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 36892, 36000], [1930172, 0, 36000, 39600], [1991090, 7200, 39600, 36000], [1992019, 7200, 36000, 39600], [2011086, 7200, 39600, 43200], [2014299, 7200, 43200, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 36892, 36000], [1930172, 0, 36000, 39600], [1981091, 0, 39600, 43200], [1981274, 0, 43200, 39600], [1982091, 0, 39600, 43200], [1982274, 0, 43200, 39600], [1983091, 0, 39600, 43200], [1983274, 0, 43200, 39600], [1984092, 0, 39600, 43200], [1984274, 10800, 43200, 39600], [1985090, 7200, 39600, 43200], [1985272, 10800, 43200, 39600], [1986089, 7200, 39600, 43200], [1986271, 10800, 43200, 39600], [1987088, 7200, 39600, 43200], [1987270, 10800, 43200, 39600], [1988087, 7200, 39600, 43200], [1988269, 10800, 43200, 39600], [1989085, 7200, 39600, 43200], [1989267, 10800, 43200, 39600], [1990084, 7200, 39600, 43200], [1990273, 10800, 43200, 39600], [1991272, 10800, 39600, 36000], [1992019, 7200, 36000, 39600], [1992089, 7200, 39600, 43200], [1992271, 10800, 43200, 39600], [1993087, 7200, 39600, 43200], [1993269, 10800, 43200, 39600], [1994086, 7200, 39600, 43200], [1994268, 10800, 43200, 39600], [1995085, 7200, 39600, 43200], [1995267, 10800, 43200, 39600], [1996091, 7200, 39600, 43200], [1996301, 10800, 43200, 39600], [1997089, 7200, 39600, 43200], [1997299, 10800, 43200, 39600], [1998088, 7200, 39600, 43200], [1998298, 10800, 43200, 39600], [1999087, 7200, 39600, 43200], [1999304, 10800, 43200, 39600], [2000086, 7200, 39600, 43200], [2000303, 10800, 43200, 39600], [2001084, 7200, 39600, 43200], [2001301, 10800, 43200, 39600], [2002090, 7200, 39600, 43200], [2002300, 10800, 43200, 39600], [2003089, 7200, 39600, 43200], [2003299, 10800, 43200, 39600], [2004088, 7200, 39600, 43200], [2004305, 10800, 43200, 39600], [2005086, 7200, 39600, 43200], [2005303, 10800, 43200, 39600], [2006085, 7200, 39600, 43200], [2006302, 10800, 43200, 39600], [2007084, 7200, 39600, 43200], [2007301, 10800, 43200, 39600], [2008090, 7200, 39600, 43200], [2008300, 10800, 43200, 39600], [2009088, 7200, 39600, 43200], [2009298, 10800, 43200, 39600], [2010087, 7200, 39600, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200], [2014299, 7200, 43200, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asims$__f_Asia_Srednekolymsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", 20391), $ct_T2__O__O__(new $c_T2(), "w", 20391), $ct_T2__O__O__(new $c_T2(), "t", [[1919356, 0, 20391, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [2002121, 7200, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016150, 7200, 21600, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919356, 0, 20391, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993269, 10800, 28800, 25200], [1994086, 7200, 25200, 28800], [1994268, 10800, 28800, 25200], [1995085, 7200, 25200, 28800], [1995267, 10800, 28800, 25200], [1996091, 7200, 25200, 28800], [1996301, 10800, 28800, 25200], [1997089, 7200, 25200, 28800], [1997299, 10800, 28800, 25200], [1998088, 7200, 25200, 28800], [1998298, 10800, 28800, 25200], [1999087, 7200, 25200, 28800], [1999304, 10800, 28800, 25200], [2000086, 7200, 25200, 28800], [2000303, 10800, 28800, 25200], [2001084, 7200, 25200, 28800], [2001301, 10800, 28800, 25200], [2002090, 7200, 25200, 28800], [2002121, 10800, 28800, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600], [2005086, 7200, 21600, 25200], [2005303, 10800, 25200, 21600], [2006085, 7200, 21600, 25200], [2006302, 10800, 25200, 21600], [2007084, 7200, 21600, 25200], [2007301, 10800, 25200, 21600], [2008090, 7200, 21600, 25200], [2008300, 10800, 25200, 21600], [2009088, 7200, 21600, 25200], [2009298, 10800, 25200, 21600], [2010087, 7200, 21600, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016150, 7200, 21600, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$asims$__f_Asia_Tomsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asims$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asims$.prototype.constructor = $c_Lzonedb_java_tzdb$asims$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asims$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asims$.prototype = $c_Lzonedb_java_tzdb$asims$.prototype;
$c_Lzonedb_java_tzdb$asims$.prototype.Asia_Omsk__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 798")
  };
  return this.Lzonedb_java_tzdb$asims$__f_Asia_Omsk
});
$c_Lzonedb_java_tzdb$asims$.prototype.Asia_Srednekolymsk__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 799")
  };
  return this.Lzonedb_java_tzdb$asims$__f_Asia_Srednekolymsk
});
$c_Lzonedb_java_tzdb$asims$.prototype.Asia_Tomsk__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$asims$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 800")
  };
  return this.Lzonedb_java_tzdb$asims$__f_Asia_Tomsk
});
var $d_Lzonedb_java_tzdb$asims$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asims$: 0
}, false, "zonedb.java.tzdb$asims$", {
  Lzonedb_java_tzdb$asims$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asims$.prototype.$classData = $d_Lzonedb_java_tzdb$asims$;
var $n_Lzonedb_java_tzdb$asims$;
function $m_Lzonedb_java_tzdb$asims$() {
  if ((!$n_Lzonedb_java_tzdb$asims$)) {
    $n_Lzonedb_java_tzdb$asims$ = new $c_Lzonedb_java_tzdb$asims$()
  };
  return $n_Lzonedb_java_tzdb$asims$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asina$() {
  this.Lzonedb_java_tzdb$asina$__f_Asia_Qostanay = null;
  this.Lzonedb_java_tzdb$asina$__f_Asia_Pontianak = null;
  this.Lzonedb_java_tzdb$asina$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asina$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 15268), $ct_T2__O__O__(new $c_T2(), "w", 15268), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 15268, 14400], [1930172, 0, 14400, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [2004305, 7200, 18000, 21600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 15268, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999087, 7200, 18000, 21600], [1999304, 10800, 21600, 18000], [2000086, 7200, 18000, 21600], [2000303, 10800, 21600, 18000], [2001084, 7200, 18000, 21600], [2001301, 10800, 21600, 18000], [2002090, 7200, 18000, 21600], [2002300, 10800, 21600, 18000], [2003089, 7200, 18000, 21600], [2003299, 10800, 21600, 18000], [2004088, 7200, 18000, 21600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asina$__f_Asia_Qostanay = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asina$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asina$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 26240), $ct_T2__O__O__(new $c_T2(), "w", 26240), $ct_T2__O__O__(new $c_T2(), "t", [[1932306, 0, 26240, 27000], [1942029, 0, 27000, 32400], [1945266, 0, 32400, 27000], [1948122, 0, 27000, 28800], [1950121, 0, 28800, 27000], [1964001, 0, 27000, 28800], [1988001, 0, 28800, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1932306, 0, 26240, 27000], [1942029, 0, 27000, 32400], [1945266, 0, 32400, 27000], [1948122, 0, 27000, 28800], [1950121, 0, 28800, 27000], [1964001, 0, 27000, 28800], [1988001, 0, 28800, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asina$__f_Asia_Pontianak = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asina$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asina$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asina$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asina$.prototype.constructor = $c_Lzonedb_java_tzdb$asina$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asina$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asina$.prototype = $c_Lzonedb_java_tzdb$asina$.prototype;
$c_Lzonedb_java_tzdb$asina$.prototype.Asia_Qostanay__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asina$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 770")
  };
  return this.Lzonedb_java_tzdb$asina$__f_Asia_Qostanay
});
$c_Lzonedb_java_tzdb$asina$.prototype.Asia_Pontianak__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asina$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 771")
  };
  return this.Lzonedb_java_tzdb$asina$__f_Asia_Pontianak
});
var $d_Lzonedb_java_tzdb$asina$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asina$: 0
}, false, "zonedb.java.tzdb$asina$", {
  Lzonedb_java_tzdb$asina$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asina$.prototype.$classData = $d_Lzonedb_java_tzdb$asina$;
var $n_Lzonedb_java_tzdb$asina$;
function $m_Lzonedb_java_tzdb$asina$() {
  if ((!$n_Lzonedb_java_tzdb$asina$)) {
    $n_Lzonedb_java_tzdb$asina$ = new $c_Lzonedb_java_tzdb$asina$()
  };
  return $n_Lzonedb_java_tzdb$asina$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asinb$() {
  this.Lzonedb_java_tzdb$asinb$__f_Asia_Dushanbe = null;
  this.Lzonedb_java_tzdb$asinb$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asinb$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 16512), $ct_T2__O__O__(new $c_T2(), "w", 16512), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 16512, 18000], [1930172, 0, 18000, 21600], [1991090, 7200, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 16512, 18000], [1930172, 0, 18000, 21600], [1981091, 0, 21600, 25200], [1981274, 0, 25200, 21600], [1982091, 0, 21600, 25200], [1982274, 0, 25200, 21600], [1983091, 0, 21600, 25200], [1983274, 0, 25200, 21600], [1984092, 0, 21600, 25200], [1984274, 10800, 25200, 21600], [1985090, 7200, 21600, 25200], [1985272, 10800, 25200, 21600], [1986089, 7200, 21600, 25200], [1986271, 10800, 25200, 21600], [1987088, 7200, 21600, 25200], [1987270, 10800, 25200, 21600], [1988087, 7200, 21600, 25200], [1988269, 10800, 25200, 21600], [1989085, 7200, 21600, 25200], [1989267, 10800, 25200, 21600], [1990084, 7200, 21600, 25200], [1990273, 10800, 25200, 21600], [1991252, 10800, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asinb$__f_Asia_Dushanbe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asinb$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asinb$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asinb$.prototype.constructor = $c_Lzonedb_java_tzdb$asinb$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asinb$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asinb$.prototype = $c_Lzonedb_java_tzdb$asinb$.prototype;
$c_Lzonedb_java_tzdb$asinb$.prototype.Asia_Dushanbe__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asinb$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 503")
  };
  return this.Lzonedb_java_tzdb$asinb$__f_Asia_Dushanbe
});
var $d_Lzonedb_java_tzdb$asinb$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asinb$: 0
}, false, "zonedb.java.tzdb$asinb$", {
  Lzonedb_java_tzdb$asinb$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asinb$.prototype.$classData = $d_Lzonedb_java_tzdb$asinb$;
var $n_Lzonedb_java_tzdb$asinb$;
function $m_Lzonedb_java_tzdb$asinb$() {
  if ((!$n_Lzonedb_java_tzdb$asinb$)) {
    $n_Lzonedb_java_tzdb$asinb$ = new $c_Lzonedb_java_tzdb$asinb$()
  };
  return $n_Lzonedb_java_tzdb$asinb$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asind$() {
  this.Lzonedb_java_tzdb$asind$__f_Asia_Kathmandu = null;
  this.Lzonedb_java_tzdb$asind$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asind$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 20476), $ct_T2__O__O__(new $c_T2(), "w", 20476), $ct_T2__O__O__(new $c_T2(), "t", [[1920001, 0, 20476, 19800], [1986001, 0, 19800, 20700]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920001, 0, 20476, 19800], [1986001, 0, 19800, 20700]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asind$__f_Asia_Kathmandu = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asind$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asind$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asind$.prototype.constructor = $c_Lzonedb_java_tzdb$asind$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asind$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asind$.prototype = $c_Lzonedb_java_tzdb$asind$.prototype;
$c_Lzonedb_java_tzdb$asind$.prototype.Asia_Kathmandu__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asind$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 789")
  };
  return this.Lzonedb_java_tzdb$asind$__f_Asia_Kathmandu
});
var $d_Lzonedb_java_tzdb$asind$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asind$: 0
}, false, "zonedb.java.tzdb$asind$", {
  Lzonedb_java_tzdb$asind$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asind$.prototype.$classData = $d_Lzonedb_java_tzdb$asind$;
var $n_Lzonedb_java_tzdb$asind$;
function $m_Lzonedb_java_tzdb$asind$() {
  if ((!$n_Lzonedb_java_tzdb$asind$)) {
    $n_Lzonedb_java_tzdb$asind$ = new $c_Lzonedb_java_tzdb$asind$()
  };
  return $n_Lzonedb_java_tzdb$asind$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asine$() {
  this.Lzonedb_java_tzdb$asine$__f_Asia_Brunei = null;
  this.Lzonedb_java_tzdb$asine$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asine$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 27580), $ct_T2__O__O__(new $c_T2(), "w", 27580), $ct_T2__O__O__(new $c_T2(), "t", [[1926060, 0, 27580, 27000], [1933001, 0, 27000, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1926060, 0, 27580, 27000], [1933001, 0, 27000, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asine$__f_Asia_Brunei = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asine$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asine$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asine$.prototype.constructor = $c_Lzonedb_java_tzdb$asine$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asine$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asine$.prototype = $c_Lzonedb_java_tzdb$asine$.prototype;
$c_Lzonedb_java_tzdb$asine$.prototype.Asia_Brunei__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asine$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 602")
  };
  return this.Lzonedb_java_tzdb$asine$__f_Asia_Brunei
});
var $d_Lzonedb_java_tzdb$asine$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asine$: 0
}, false, "zonedb.java.tzdb$asine$", {
  Lzonedb_java_tzdb$asine$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asine$.prototype.$classData = $d_Lzonedb_java_tzdb$asine$;
var $n_Lzonedb_java_tzdb$asine$;
function $m_Lzonedb_java_tzdb$asine$() {
  if ((!$n_Lzonedb_java_tzdb$asine$)) {
    $n_Lzonedb_java_tzdb$asine$ = new $c_Lzonedb_java_tzdb$asine$()
  };
  return $n_Lzonedb_java_tzdb$asine$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiob$() {
  this.Lzonedb_java_tzdb$asiob$__f_Asia_Aqtobe = null;
  this.Lzonedb_java_tzdb$asiob$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiob$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 13720), $ct_T2__O__O__(new $c_T2(), "w", 13720), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 13720, 14400], [1930172, 0, 14400, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 13720, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999087, 7200, 18000, 21600], [1999304, 10800, 21600, 18000], [2000086, 7200, 18000, 21600], [2000303, 10800, 21600, 18000], [2001084, 7200, 18000, 21600], [2001301, 10800, 21600, 18000], [2002090, 7200, 18000, 21600], [2002300, 10800, 21600, 18000], [2003089, 7200, 18000, 21600], [2003299, 10800, 21600, 18000], [2004088, 7200, 18000, 21600], [2004305, 10800, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiob$__f_Asia_Aqtobe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiob$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiob$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiob$.prototype.constructor = $c_Lzonedb_java_tzdb$asiob$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiob$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiob$.prototype = $c_Lzonedb_java_tzdb$asiob$.prototype;
$c_Lzonedb_java_tzdb$asiob$.prototype.Asia_Aqtobe__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiob$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 744")
  };
  return this.Lzonedb_java_tzdb$asiob$__f_Asia_Aqtobe
});
var $d_Lzonedb_java_tzdb$asiob$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiob$: 0
}, false, "zonedb.java.tzdb$asiob$", {
  Lzonedb_java_tzdb$asiob$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiob$.prototype.$classData = $d_Lzonedb_java_tzdb$asiob$;
var $n_Lzonedb_java_tzdb$asiob$;
function $m_Lzonedb_java_tzdb$asiob$() {
  if ((!$n_Lzonedb_java_tzdb$asiob$)) {
    $n_Lzonedb_java_tzdb$asiob$ = new $c_Lzonedb_java_tzdb$asiob$()
  };
  return $n_Lzonedb_java_tzdb$asiob$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asion$() {
  this.Lzonedb_java_tzdb$asion$__f_Asia_Hong_Kong = null;
  this.Lzonedb_java_tzdb$asion$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asion$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 27402), $ct_T2__O__O__(new $c_T2(), "w", 27402), $ct_T2__O__O__(new $c_T2(), "t", [[1904304, 2202, 27402, 28800], [1941358, 84600, 28800, 32400], [1945322, 7200, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1904304, 2202, 27402, 28800], [1941166, 10800, 28800, 32400], [1941274, 14400, 32400, 30600], [1941359, 0, 30600, 32400], [1945322, 7200, 32400, 28800], [1946111, 0, 28800, 32400], [1946335, 16200, 32400, 28800], [1947103, 12600, 28800, 32400], [1947334, 16200, 32400, 28800], [1948123, 12600, 28800, 32400], [1948305, 16200, 32400, 28800], [1949093, 12600, 28800, 32400], [1949303, 16200, 32400, 28800], [1950092, 12600, 28800, 32400], [1950302, 16200, 32400, 28800], [1951091, 12600, 28800, 32400], [1951301, 16200, 32400, 28800], [1952097, 12600, 28800, 32400], [1952307, 16200, 32400, 28800], [1953095, 12600, 28800, 32400], [1953305, 12600, 32400, 28800], [1954080, 12600, 28800, 32400], [1954304, 12600, 32400, 28800], [1955079, 12600, 28800, 32400], [1955310, 12600, 32400, 28800], [1956078, 12600, 28800, 32400], [1956309, 12600, 32400, 28800], [1957083, 12600, 28800, 32400], [1957307, 12600, 32400, 28800], [1958082, 12600, 28800, 32400], [1958306, 12600, 32400, 28800], [1959081, 12600, 28800, 32400], [1959305, 12600, 32400, 28800], [1960080, 12600, 28800, 32400], [1960311, 12600, 32400, 28800], [1961078, 12600, 28800, 32400], [1961309, 12600, 32400, 28800], [1962077, 12600, 28800, 32400], [1962308, 12600, 32400, 28800], [1963083, 12600, 28800, 32400], [1963307, 12600, 32400, 28800], [1964082, 12600, 28800, 32400], [1964306, 12600, 32400, 28800], [1965108, 12600, 28800, 32400], [1965290, 12600, 32400, 28800], [1966107, 12600, 28800, 32400], [1966289, 12600, 32400, 28800], [1967106, 12600, 28800, 32400], [1967295, 12600, 32400, 28800], [1968112, 12600, 28800, 32400], [1968294, 12600, 32400, 28800], [1969110, 12600, 28800, 32400], [1969292, 12600, 32400, 28800], [1970109, 12600, 28800, 32400], [1970291, 12600, 32400, 28800], [1971108, 12600, 28800, 32400], [1971290, 12600, 32400, 28800], [1972107, 12600, 28800, 32400], [1972296, 12600, 32400, 28800], [1973112, 12600, 28800, 32400], [1973294, 12600, 32400, 28800], [1973364, 12600, 28800, 32400], [1974293, 12600, 32400, 28800], [1975110, 12600, 28800, 32400], [1975292, 12600, 32400, 28800], [1976109, 12600, 28800, 32400], [1976291, 12600, 32400, 28800], [1979133, 12600, 28800, 32400], [1979294, 12600, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asion$__f_Asia_Hong_Kong = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asion$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asion$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asion$.prototype.constructor = $c_Lzonedb_java_tzdb$asion$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asion$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asion$.prototype = $c_Lzonedb_java_tzdb$asion$.prototype;
$c_Lzonedb_java_tzdb$asion$.prototype.Asia_Hong_Kong__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asion$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 695")
  };
  return this.Lzonedb_java_tzdb$asion$__f_Asia_Hong_Kong
});
var $d_Lzonedb_java_tzdb$asion$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asion$: 0
}, false, "zonedb.java.tzdb$asion$", {
  Lzonedb_java_tzdb$asion$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asion$.prototype.$classData = $d_Lzonedb_java_tzdb$asion$;
var $n_Lzonedb_java_tzdb$asion$;
function $m_Lzonedb_java_tzdb$asion$() {
  if ((!$n_Lzonedb_java_tzdb$asion$)) {
    $n_Lzonedb_java_tzdb$asion$ = new $c_Lzonedb_java_tzdb$asion$()
  };
  return $n_Lzonedb_java_tzdb$asion$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asior$() {
  this.Lzonedb_java_tzdb$asior$__f_Asia_Singapore = null;
  this.Lzonedb_java_tzdb$asior$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asior$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 24925), $ct_T2__O__O__(new $c_T2(), "w", 24925), $ct_T2__O__O__(new $c_T2(), "t", [[1905152, 0, 24925, 25200], [1935365, 85200, 25200, 26400], [1941244, 0, 26400, 27000], [1942047, 0, 27000, 32400], [1945255, 0, 32400, 27000], [1982001, 0, 27000, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1905152, 0, 24925, 25200], [1933001, 0, 25200, 26400], [1941244, 0, 26400, 27000], [1942047, 0, 27000, 32400], [1945255, 0, 32400, 27000], [1982001, 0, 27000, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asior$__f_Asia_Singapore = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asior$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asior$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asior$.prototype.constructor = $c_Lzonedb_java_tzdb$asior$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asior$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asior$.prototype = $c_Lzonedb_java_tzdb$asior$.prototype;
$c_Lzonedb_java_tzdb$asior$.prototype.Asia_Singapore__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asior$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 533")
  };
  return this.Lzonedb_java_tzdb$asior$__f_Asia_Singapore
});
var $d_Lzonedb_java_tzdb$asior$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asior$: 0
}, false, "zonedb.java.tzdb$asior$", {
  Lzonedb_java_tzdb$asior$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asior$.prototype.$classData = $d_Lzonedb_java_tzdb$asior$;
var $n_Lzonedb_java_tzdb$asior$;
function $m_Lzonedb_java_tzdb$asior$() {
  if ((!$n_Lzonedb_java_tzdb$asior$)) {
    $n_Lzonedb_java_tzdb$asior$ = new $c_Lzonedb_java_tzdb$asior$()
  };
  return $n_Lzonedb_java_tzdb$asior$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiou$() {
  this.Lzonedb_java_tzdb$asiou$__f_Asia_Seoul = null;
  this.Lzonedb_java_tzdb$asiou$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiou$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 30472), $ct_T2__O__O__(new $c_T2(), "w", 30472), $ct_T2__O__O__(new $c_T2(), "t", [[1908092, 0, 30472, 30600], [1912001, 0, 30600, 32400], [1954080, 0, 32400, 30600], [1961222, 0, 30600, 32400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1908092, 0, 30472, 30600], [1912001, 0, 30600, 32400], [1948153, 0, 32400, 36000], [1948257, 0, 36000, 32400], [1949093, 0, 32400, 36000], [1949254, 0, 36000, 32400], [1950091, 0, 32400, 36000], [1950253, 0, 36000, 32400], [1951126, 0, 32400, 36000], [1951252, 0, 36000, 32400], [1954080, 0, 32400, 30600], [1955125, 0, 30600, 34200], [1955252, 0, 34200, 30600], [1956141, 0, 30600, 34200], [1956274, 0, 34200, 30600], [1957125, 0, 30600, 34200], [1957265, 0, 34200, 30600], [1958124, 0, 30600, 34200], [1958264, 0, 34200, 30600], [1959123, 0, 30600, 34200], [1959263, 0, 34200, 30600], [1960122, 0, 30600, 34200], [1960262, 0, 34200, 30600], [1961222, 0, 30600, 32400], [1987130, 7200, 32400, 36000], [1987284, 10800, 36000, 32400], [1988129, 7200, 32400, 36000], [1988283, 10800, 36000, 32400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiou$__f_Asia_Seoul = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiou$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiou$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiou$.prototype.constructor = $c_Lzonedb_java_tzdb$asiou$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiou$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiou$.prototype = $c_Lzonedb_java_tzdb$asiou$.prototype;
$c_Lzonedb_java_tzdb$asiou$.prototype.Asia_Seoul__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiou$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 551")
  };
  return this.Lzonedb_java_tzdb$asiou$__f_Asia_Seoul
});
var $d_Lzonedb_java_tzdb$asiou$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiou$: 0
}, false, "zonedb.java.tzdb$asiou$", {
  Lzonedb_java_tzdb$asiou$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiou$.prototype.$classData = $d_Lzonedb_java_tzdb$asiou$;
var $n_Lzonedb_java_tzdb$asiou$;
function $m_Lzonedb_java_tzdb$asiou$() {
  if ((!$n_Lzonedb_java_tzdb$asiou$)) {
    $n_Lzonedb_java_tzdb$asiou$ = new $c_Lzonedb_java_tzdb$asiou$()
  };
  return $n_Lzonedb_java_tzdb$asiou$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiov$() {
  this.Lzonedb_java_tzdb$asiov$__f_Asia_Hovd = null;
  this.Lzonedb_java_tzdb$asiov$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiov$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 21996), $ct_T2__O__O__(new $c_T2(), "w", 21996), $ct_T2__O__O__(new $c_T2(), "t", [[1905213, 0, 21996, 21600], [1978001, 0, 21600, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1905213, 0, 21996, 21600], [1978001, 0, 21600, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 0, 28800, 25200], [1985090, 0, 25200, 28800], [1985272, 0, 28800, 25200], [1986089, 0, 25200, 28800], [1986271, 0, 28800, 25200], [1987088, 0, 25200, 28800], [1987270, 0, 28800, 25200], [1988087, 0, 25200, 28800], [1988269, 0, 28800, 25200], [1989085, 0, 25200, 28800], [1989267, 0, 28800, 25200], [1990084, 0, 25200, 28800], [1990273, 0, 28800, 25200], [1991090, 0, 25200, 28800], [1991272, 0, 28800, 25200], [1992089, 0, 25200, 28800], [1992271, 0, 28800, 25200], [1993087, 0, 25200, 28800], [1993269, 0, 28800, 25200], [1994086, 0, 25200, 28800], [1994268, 0, 28800, 25200], [1995085, 0, 25200, 28800], [1995267, 0, 28800, 25200], [1996091, 0, 25200, 28800], [1996273, 0, 28800, 25200], [1997089, 0, 25200, 28800], [1997271, 0, 28800, 25200], [1998088, 0, 25200, 28800], [1998270, 0, 28800, 25200], [2001118, 7200, 25200, 28800], [2001272, 7200, 28800, 25200], [2002089, 7200, 25200, 28800], [2002271, 7200, 28800, 25200], [2003088, 7200, 25200, 28800], [2003270, 7200, 28800, 25200], [2004087, 7200, 25200, 28800], [2004269, 7200, 28800, 25200], [2005085, 7200, 25200, 28800], [2005267, 7200, 28800, 25200], [2006084, 7200, 25200, 28800], [2006273, 7200, 28800, 25200], [2015087, 7200, 25200, 28800], [2015269, 0, 28800, 25200], [2016086, 7200, 25200, 28800], [2016268, 0, 28800, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiov$__f_Asia_Hovd = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiov$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiov$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiov$.prototype.constructor = $c_Lzonedb_java_tzdb$asiov$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiov$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiov$.prototype = $c_Lzonedb_java_tzdb$asiov$.prototype;
$c_Lzonedb_java_tzdb$asiov$.prototype.Asia_Hovd__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiov$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 354")
  };
  return this.Lzonedb_java_tzdb$asiov$__f_Asia_Hovd
});
var $d_Lzonedb_java_tzdb$asiov$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiov$: 0
}, false, "zonedb.java.tzdb$asiov$", {
  Lzonedb_java_tzdb$asiov$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiov$.prototype.$classData = $d_Lzonedb_java_tzdb$asiov$;
var $n_Lzonedb_java_tzdb$asiov$;
function $m_Lzonedb_java_tzdb$asiov$() {
  if ((!$n_Lzonedb_java_tzdb$asiov$)) {
    $n_Lzonedb_java_tzdb$asiov$ = new $c_Lzonedb_java_tzdb$asiov$()
  };
  return $n_Lzonedb_java_tzdb$asiov$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asipe$() {
  this.Lzonedb_java_tzdb$asipe$__f_Asia_Taipei = null;
  this.Lzonedb_java_tzdb$asipe$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asipe$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 29160), $ct_T2__O__O__(new $c_T2(), "w", 29160), $ct_T2__O__O__(new $c_T2(), "t", [[1896001, 0, 29160, 28800], [1937274, 0, 28800, 32400], [1945264, 3600, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1896001, 0, 29160, 28800], [1937274, 0, 28800, 32400], [1945264, 3600, 32400, 28800], [1946135, 0, 28800, 32400], [1946274, 0, 32400, 28800], [1947105, 0, 28800, 32400], [1947305, 0, 32400, 28800], [1948122, 0, 28800, 32400], [1948275, 0, 32400, 28800], [1949121, 0, 28800, 32400], [1949274, 0, 32400, 28800], [1950121, 0, 28800, 32400], [1950274, 0, 32400, 28800], [1951121, 0, 28800, 32400], [1951274, 0, 32400, 28800], [1952061, 0, 28800, 32400], [1952306, 0, 32400, 28800], [1953091, 0, 28800, 32400], [1953305, 0, 32400, 28800], [1954091, 0, 28800, 32400], [1954305, 0, 32400, 28800], [1955091, 0, 28800, 32400], [1955274, 0, 32400, 28800], [1956092, 0, 28800, 32400], [1956275, 0, 32400, 28800], [1957091, 0, 28800, 32400], [1957274, 0, 32400, 28800], [1958091, 0, 28800, 32400], [1958274, 0, 32400, 28800], [1959091, 0, 28800, 32400], [1959274, 0, 32400, 28800], [1960153, 0, 28800, 32400], [1960275, 0, 32400, 28800], [1961152, 0, 28800, 32400], [1961274, 0, 32400, 28800], [1974091, 0, 28800, 32400], [1974274, 0, 32400, 28800], [1975091, 0, 28800, 32400], [1975274, 0, 32400, 28800], [1979182, 0, 28800, 32400], [1979274, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asipe$__f_Asia_Taipei = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asipe$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asipe$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asipe$.prototype.constructor = $c_Lzonedb_java_tzdb$asipe$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asipe$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asipe$.prototype = $c_Lzonedb_java_tzdb$asipe$.prototype;
$c_Lzonedb_java_tzdb$asipe$.prototype.Asia_Taipei__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asipe$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 95")
  };
  return this.Lzonedb_java_tzdb$asipe$__f_Asia_Taipei
});
var $d_Lzonedb_java_tzdb$asipe$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asipe$: 0
}, false, "zonedb.java.tzdb$asipe$", {
  Lzonedb_java_tzdb$asipe$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asipe$.prototype.$classData = $d_Lzonedb_java_tzdb$asipe$;
var $n_Lzonedb_java_tzdb$asipe$;
function $m_Lzonedb_java_tzdb$asipe$() {
  if ((!$n_Lzonedb_java_tzdb$asipe$)) {
    $n_Lzonedb_java_tzdb$asipe$ = new $c_Lzonedb_java_tzdb$asipe$()
  };
  return $n_Lzonedb_java_tzdb$asipe$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiph$() {
  this.Lzonedb_java_tzdb$asiph$__f_Asia_Thimphu = null;
  this.Lzonedb_java_tzdb$asiph$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiph$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 21516), $ct_T2__O__O__(new $c_T2(), "w", 21516), $ct_T2__O__O__(new $c_T2(), "t", [[1947227, 0, 21516, 19800], [1987274, 0, 19800, 21600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1947227, 0, 21516, 19800], [1987274, 0, 19800, 21600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiph$__f_Asia_Thimphu = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiph$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiph$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiph$.prototype.constructor = $c_Lzonedb_java_tzdb$asiph$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiph$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiph$.prototype = $c_Lzonedb_java_tzdb$asiph$.prototype;
$c_Lzonedb_java_tzdb$asiph$.prototype.Asia_Thimphu__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiph$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 338")
  };
  return this.Lzonedb_java_tzdb$asiph$__f_Asia_Thimphu
});
var $d_Lzonedb_java_tzdb$asiph$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiph$: 0
}, false, "zonedb.java.tzdb$asiph$", {
  Lzonedb_java_tzdb$asiph$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiph$.prototype.$classData = $d_Lzonedb_java_tzdb$asiph$;
var $n_Lzonedb_java_tzdb$asiph$;
function $m_Lzonedb_java_tzdb$asiph$() {
  if ((!$n_Lzonedb_java_tzdb$asiph$)) {
    $n_Lzonedb_java_tzdb$asiph$ = new $c_Lzonedb_java_tzdb$asiph$()
  };
  return $n_Lzonedb_java_tzdb$asiph$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asipu$() {
  this.Lzonedb_java_tzdb$asipu$__f_Asia_Kuala_Lumpur = null;
  this.Lzonedb_java_tzdb$asipu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asipu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 24406), $ct_T2__O__O__(new $c_T2(), "w", 24406), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 24406, 24925], [1905152, 0, 24925, 25200], [1935365, 85200, 25200, 26400], [1941244, 0, 26400, 27000], [1942047, 0, 27000, 32400], [1945255, 0, 32400, 27000], [1982001, 0, 27000, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 24406, 24925], [1905152, 0, 24925, 25200], [1933001, 0, 25200, 26400], [1941244, 0, 26400, 27000], [1942047, 0, 27000, 32400], [1945255, 0, 32400, 27000], [1982001, 0, 27000, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asipu$__f_Asia_Kuala_Lumpur = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asipu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asipu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asipu$.prototype.constructor = $c_Lzonedb_java_tzdb$asipu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asipu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asipu$.prototype = $c_Lzonedb_java_tzdb$asipu$.prototype;
$c_Lzonedb_java_tzdb$asipu$.prototype.Asia_Kuala_Lumpur__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asipu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 777")
  };
  return this.Lzonedb_java_tzdb$asipu$__f_Asia_Kuala_Lumpur
});
var $d_Lzonedb_java_tzdb$asipu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asipu$: 0
}, false, "zonedb.java.tzdb$asipu$", {
  Lzonedb_java_tzdb$asipu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asipu$.prototype.$classData = $d_Lzonedb_java_tzdb$asipu$;
var $n_Lzonedb_java_tzdb$asipu$;
function $m_Lzonedb_java_tzdb$asipu$() {
  if ((!$n_Lzonedb_java_tzdb$asipu$)) {
    $n_Lzonedb_java_tzdb$asipu$ = new $c_Lzonedb_java_tzdb$asipu$()
  };
  return $n_Lzonedb_java_tzdb$asipu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asira$() {
  this.Lzonedb_java_tzdb$asira$__f_Asia_Atyrau = null;
  this.Lzonedb_java_tzdb$asira$__f_Asia_Oral = null;
  this.Lzonedb_java_tzdb$asira$__f_Asia_Tehran = null;
  this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asira$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 12464), $ct_T2__O__O__(new $c_T2(), "w", 12464), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 12464, 10800], [1930172, 0, 10800, 18000], [1981274, 0, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [1999087, 7200, 18000, 14400], [2004305, 7200, 14400, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 12464, 10800], [1930172, 0, 10800, 18000], [1981274, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asira$__f_Asia_Atyrau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 12324), $ct_T2__O__O__(new $c_T2(), "w", 12324), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 12324, 10800], [1930172, 0, 10800, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000], [1989085, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 14400], [2004305, 7200, 14400, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 12324, 10800], [1930172, 0, 10800, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989267, 10800, 18000, 14400], [1990084, 7200, 14400, 18000], [1990273, 10800, 18000, 14400], [1991090, 7200, 14400, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992271, 10800, 18000, 14400], [1993087, 7200, 14400, 18000], [1993269, 10800, 18000, 14400], [1994086, 7200, 14400, 18000], [1994268, 10800, 18000, 14400], [1995085, 7200, 14400, 18000], [1995267, 10800, 18000, 14400], [1996091, 7200, 14400, 18000], [1996301, 10800, 18000, 14400], [1997089, 7200, 14400, 18000], [1997299, 10800, 18000, 14400], [1998088, 7200, 14400, 18000], [1998298, 10800, 18000, 14400], [1999087, 7200, 14400, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asira$__f_Asia_Oral = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", 12344), $ct_T2__O__O__(new $c_T2(), "w", 12344), $ct_T2__O__O__(new $c_T2(), "t", [[1946001, 0, 12344, 12600], [1977305, 0, 12600, 14400], [1979001, 0, 14400, 12600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1946001, 0, 12344, 12600], [1977305, 0, 12600, 14400], [1978080, 0, 14400, 18000], [1978294, 0, 18000, 14400], [1979001, 0, 14400, 12600], [1979080, 0, 12600, 16200], [1979262, 0, 16200, 12600], [1980081, 0, 12600, 16200], [1980267, 0, 16200, 12600], [1991123, 0, 12600, 16200], [1991265, 0, 16200, 12600], [1992082, 0, 12600, 16200], [1992266, 0, 16200, 12600], [1993081, 0, 12600, 16200], [1993265, 0, 16200, 12600], [1994081, 0, 12600, 16200], [1994265, 0, 16200, 12600], [1995081, 0, 12600, 16200], [1995265, 0, 16200, 12600], [1996081, 0, 12600, 16200], [1996265, 0, 16200, 12600], [1997081, 0, 12600, 16200], [1997265, 0, 16200, 12600], [1998081, 0, 12600, 16200], [1998265, 0, 16200, 12600], [1999081, 0, 12600, 16200], [1999265, 0, 16200, 12600], [2000081, 0, 12600, 16200], [2000265, 0, 16200, 12600], [2001081, 0, 12600, 16200], [2001265, 0, 16200, 12600], [2002081, 0, 12600, 16200], [2002265, 0, 16200, 12600], [2003081, 0, 12600, 16200], [2003265, 0, 16200, 12600], [2004081, 0, 12600, 16200], [2004265, 0, 16200, 12600], [2005081, 0, 12600, 16200], [2005265, 0, 16200, 12600], [2008081, 0, 12600, 16200], [2008265, 0, 16200, 12600], [2009081, 0, 12600, 16200], [2009265, 0, 16200, 12600], [2010081, 0, 12600, 16200], [2010265, 0, 16200, 12600], [2011081, 0, 12600, 16200], [2011265, 0, 16200, 12600], [2012081, 0, 12600, 16200], [2012265, 0, 16200, 12600], [2013081, 0, 12600, 16200], [2013265, 0, 16200, 12600], [2014081, 0, 12600, 16200], [2014265, 0, 16200, 12600], [2015081, 0, 12600, 16200], [2015265, 0, 16200, 12600], [2016081, 0, 12600, 16200], [2016265, 0, 16200, 12600], [2017081, 0, 12600, 16200], [2017265, 0, 16200, 12600], [2018081, 0, 12600, 16200], [2018265, 0, 16200, 12600], [2019081, 0, 12600, 16200], [2019265, 0, 16200, 12600], [2020081, 0, 12600, 16200], [2020265, 0, 16200, 12600], [2021081, 0, 12600, 16200], [2021265, 0, 16200, 12600], [2022081, 0, 12600, 16200], [2022265, 0, 16200, 12600], [2023081, 0, 12600, 16200], [2023265, 0, 16200, 12600], [2024081, 0, 12600, 16200], [2024265, 0, 16200, 12600], [2025081, 0, 12600, 16200], [2025265, 0, 16200, 12600], [2026081, 0, 12600, 16200], [2026265, 0, 16200, 12600], [2027081, 0, 12600, 16200], [2027265, 0, 16200, 12600], [2028081, 0, 12600, 16200], [2028265, 0, 16200, 12600], [2029080, 0, 12600, 16200], [2029264, 0, 16200, 12600], [2030081, 0, 12600, 16200], [2030265, 0, 16200, 12600], [2031081, 0, 12600, 16200], [2031265, 0, 16200, 12600], [2032081, 0, 12600, 16200], [2032265, 0, 16200, 12600], [2033080, 0, 12600, 16200], [2033264, 0, 16200, 12600], [2034081, 0, 12600, 16200], [2034265, 0, 16200, 12600], [2035081, 0, 12600, 16200], [2035265, 0, 16200, 12600], [2036081, 0, 12600, 16200], [2036265, 0, 16200, 12600], [2037080, 0, 12600, 16200], [2037264, 0, 16200, 12600], [2038081, 0, 12600, 16200], [2038265, 0, 16200, 12600], [2039081, 0, 12600, 16200], [2039265, 0, 16200, 12600], [2040081, 0, 12600, 16200], [2040265, 0, 16200, 12600], [2041080, 0, 12600, 16200], [2041264, 0, 16200, 12600], [2042081, 0, 12600, 16200], [2042265, 0, 16200, 12600], [2043081, 0, 12600, 16200], [2043265, 0, 16200, 12600], [2044081, 0, 12600, 16200], [2044265, 0, 16200, 12600], [2045080, 0, 12600, 16200], [2045264, 0, 16200, 12600], [2046081, 0, 12600, 16200], [2046265, 0, 16200, 12600], [2047081, 0, 12600, 16200], [2047265, 0, 16200, 12600], [2048081, 0, 12600, 16200], [2048265, 0, 16200, 12600], [2049080, 0, 12600, 16200], [2049264, 0, 16200, 12600], [2050081, 0, 12600, 16200], [2050265, 0, 16200, 12600], [2051081, 0, 12600, 16200], [2051265, 0, 16200, 12600], [2052081, 0, 12600, 16200], [2052265, 0, 16200, 12600], [2053080, 0, 12600, 16200], [2053264, 0, 16200, 12600], [2054081, 0, 12600, 16200], [2054265, 0, 16200, 12600], [2055081, 0, 12600, 16200], [2055265, 0, 16200, 12600], [2056081, 0, 12600, 16200], [2056265, 0, 16200, 12600], [2057080, 0, 12600, 16200], [2057264, 0, 16200, 12600], [2058081, 0, 12600, 16200], [2058265, 0, 16200, 12600], [2059081, 0, 12600, 16200], [2059265, 0, 16200, 12600], [2060081, 0, 12600, 16200], [2060265, 0, 16200, 12600], [2061080, 0, 12600, 16200], [2061264, 0, 16200, 12600], [2062080, 0, 12600, 16200], [2062264, 0, 16200, 12600], [2063081, 0, 12600, 16200], [2063265, 0, 16200, 12600], [2064081, 0, 12600, 16200], [2064265, 0, 16200, 12600], [2065080, 0, 12600, 16200], [2065264, 0, 16200, 12600], [2066080, 0, 12600, 16200], [2066264, 0, 16200, 12600], [2067081, 0, 12600, 16200], [2067265, 0, 16200, 12600], [2068081, 0, 12600, 16200], [2068265, 0, 16200, 12600], [2069080, 0, 12600, 16200], [2069264, 0, 16200, 12600], [2070080, 0, 12600, 16200], [2070264, 0, 16200, 12600], [2071081, 0, 12600, 16200], [2071265, 0, 16200, 12600], [2072081, 0, 12600, 16200], [2072265, 0, 16200, 12600], [2073080, 0, 12600, 16200], [2073264, 0, 16200, 12600], [2074080, 0, 12600, 16200], [2074264, 0, 16200, 12600], [2075081, 0, 12600, 16200], [2075265, 0, 16200, 12600], [2076081, 0, 12600, 16200], [2076265, 0, 16200, 12600], [2077080, 0, 12600, 16200], [2077264, 0, 16200, 12600], [2078080, 0, 12600, 16200], [2078264, 0, 16200, 12600], [2079081, 0, 12600, 16200], [2079265, 0, 16200, 12600], [2080081, 0, 12600, 16200], [2080265, 0, 16200, 12600], [2081080, 0, 12600, 16200], [2081264, 0, 16200, 12600], [2082080, 0, 12600, 16200], [2082264, 0, 16200, 12600], [2083081, 0, 12600, 16200], [2083265, 0, 16200, 12600], [2084081, 0, 12600, 16200], [2084265, 0, 16200, 12600], [2085080, 0, 12600, 16200], [2085264, 0, 16200, 12600], [2086080, 0, 12600, 16200], [2086264, 0, 16200, 12600], [2087081, 0, 12600, 16200], [2087265, 0, 16200, 12600], [2088081, 0, 12600, 16200], [2088265, 0, 16200, 12600], [2089080, 0, 12600, 16200], [2089264, 0, 16200, 12600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 21, (-1), 0, 0, 1, 12600, 12600, 16200], [9, 21, (-1), 0, 0, 1, 12600, 16200, 12600]])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$asira$__f_Asia_Tehran = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asira$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asira$.prototype.constructor = $c_Lzonedb_java_tzdb$asira$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asira$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asira$.prototype = $c_Lzonedb_java_tzdb$asira$.prototype;
$c_Lzonedb_java_tzdb$asira$.prototype.Asia_Atyrau__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 669")
  };
  return this.Lzonedb_java_tzdb$asira$__f_Asia_Atyrau
});
$c_Lzonedb_java_tzdb$asira$.prototype.Asia_Oral__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 670")
  };
  return this.Lzonedb_java_tzdb$asira$__f_Asia_Oral
});
$c_Lzonedb_java_tzdb$asira$.prototype.Asia_Tehran__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$asira$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 671")
  };
  return this.Lzonedb_java_tzdb$asira$__f_Asia_Tehran
});
var $d_Lzonedb_java_tzdb$asira$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asira$: 0
}, false, "zonedb.java.tzdb$asira$", {
  Lzonedb_java_tzdb$asira$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asira$.prototype.$classData = $d_Lzonedb_java_tzdb$asira$;
var $n_Lzonedb_java_tzdb$asira$;
function $m_Lzonedb_java_tzdb$asira$() {
  if ((!$n_Lzonedb_java_tzdb$asira$)) {
    $n_Lzonedb_java_tzdb$asira$ = new $c_Lzonedb_java_tzdb$asira$()
  };
  return $n_Lzonedb_java_tzdb$asira$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asird$() {
  this.Lzonedb_java_tzdb$asird$__f_Asia_Qyzylorda = null;
  this.Lzonedb_java_tzdb$asird$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asird$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 15712), $ct_T2__O__O__(new $c_T2(), "w", 15712), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 15712, 14400], [1930172, 0, 14400, 18000], [1981273, 82800, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1991272, 7200, 14400, 18000], [1992019, 7200, 18000, 21600], [1992089, 7200, 21600, 18000], [2004305, 7200, 18000, 21600], [2018355, 0, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 15712, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1992019, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999087, 7200, 18000, 21600], [1999304, 10800, 21600, 18000], [2000086, 7200, 18000, 21600], [2000303, 10800, 21600, 18000], [2001084, 7200, 18000, 21600], [2001301, 10800, 21600, 18000], [2002090, 7200, 18000, 21600], [2002300, 10800, 21600, 18000], [2003089, 7200, 18000, 21600], [2003299, 10800, 21600, 18000], [2004088, 7200, 18000, 21600], [2018355, 0, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asird$__f_Asia_Qyzylorda = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asird$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asird$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asird$.prototype.constructor = $c_Lzonedb_java_tzdb$asird$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asird$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asird$.prototype = $c_Lzonedb_java_tzdb$asird$.prototype;
$c_Lzonedb_java_tzdb$asird$.prototype.Asia_Qyzylorda__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asird$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 12")
  };
  return this.Lzonedb_java_tzdb$asird$__f_Asia_Qyzylorda
});
var $d_Lzonedb_java_tzdb$asird$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asird$: 0
}, false, "zonedb.java.tzdb$asird$", {
  Lzonedb_java_tzdb$asird$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asird$.prototype.$classData = $d_Lzonedb_java_tzdb$asird$;
var $n_Lzonedb_java_tzdb$asird$;
function $m_Lzonedb_java_tzdb$asird$() {
  if ((!$n_Lzonedb_java_tzdb$asird$)) {
    $n_Lzonedb_java_tzdb$asird$ = new $c_Lzonedb_java_tzdb$asird$()
  };
  return $n_Lzonedb_java_tzdb$asird$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiro$() {
  this.Lzonedb_java_tzdb$asiro$__f_Asia_Hebron = null;
  this.Lzonedb_java_tzdb$asiro$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiro$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8423), $ct_T2__O__O__(new $c_T2(), "w", 8423), $ct_T2__O__O__(new $c_T2(), "t", [[1900274, 0, 8423, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1900274, 0, 8423, 7200], [1940153, 0, 7200, 10800], [1942305, 0, 10800, 7200], [1943091, 7200, 7200, 10800], [1943305, 0, 10800, 7200], [1944092, 0, 7200, 10800], [1944306, 0, 10800, 7200], [1945106, 0, 7200, 10800], [1945305, 7200, 10800, 7200], [1946106, 7200, 7200, 10800], [1946305, 0, 10800, 7200], [1957130, 0, 7200, 10800], [1957274, 0, 10800, 7200], [1958121, 0, 7200, 10800], [1958274, 0, 10800, 7200], [1959121, 3600, 7200, 10800], [1959273, 10800, 10800, 7200], [1960122, 3600, 7200, 10800], [1960274, 10800, 10800, 7200], [1961121, 3600, 7200, 10800], [1961273, 10800, 10800, 7200], [1962121, 3600, 7200, 10800], [1962273, 10800, 10800, 7200], [1963121, 3600, 7200, 10800], [1963273, 10800, 10800, 7200], [1964122, 3600, 7200, 10800], [1964274, 10800, 10800, 7200], [1965121, 3600, 7200, 10800], [1965273, 10800, 10800, 7200], [1966121, 3600, 7200, 10800], [1966274, 10800, 10800, 7200], [1967121, 3600, 7200, 10800], [1967156, 0, 10800, 7200], [1974188, 0, 7200, 10800], [1974286, 0, 10800, 7200], [1975110, 0, 7200, 10800], [1975243, 0, 10800, 7200], [1980215, 0, 7200, 10800], [1980257, 3600, 10800, 7200], [1984126, 0, 7200, 10800], [1984238, 3600, 10800, 7200], [1985104, 0, 7200, 10800], [1985258, 0, 10800, 7200], [1986138, 0, 7200, 10800], [1986250, 0, 10800, 7200], [1987105, 0, 7200, 10800], [1987256, 0, 10800, 7200], [1988101, 0, 7200, 10800], [1988248, 0, 10800, 7200], [1989120, 0, 7200, 10800], [1989246, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990238, 0, 10800, 7200], [1991083, 0, 7200, 10800], [1991244, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992250, 0, 10800, 7200], [1993092, 0, 7200, 10800], [1993248, 0, 10800, 7200], [1994091, 0, 7200, 10800], [1994240, 0, 10800, 7200], [1995090, 0, 7200, 10800], [1995246, 0, 10800, 7200], [1996096, 0, 7200, 10800], [1996264, 3600, 10800, 7200], [1997094, 0, 7200, 10800], [1997262, 3600, 10800, 7200], [1998093, 0, 7200, 10800], [1998261, 3600, 10800, 7200], [1999106, 0, 7200, 10800], [1999288, 0, 10800, 7200], [2000112, 0, 7200, 10800], [2000294, 0, 10800, 7200], [2001110, 0, 7200, 10800], [2001292, 0, 10800, 7200], [2002109, 0, 7200, 10800], [2002291, 0, 10800, 7200], [2003108, 0, 7200, 10800], [2003290, 0, 10800, 7200], [2004107, 0, 7200, 10800], [2004275, 3600, 10800, 7200], [2005105, 0, 7200, 10800], [2005277, 7200, 10800, 7200], [2006091, 0, 7200, 10800], [2006265, 0, 10800, 7200], [2007091, 0, 7200, 10800], [2007256, 7200, 10800, 7200], [2008088, 0, 7200, 10800], [2008245, 0, 10800, 7200], [2009086, 0, 7200, 10800], [2009247, 3600, 10800, 7200], [2010085, 0, 7200, 10800], [2010223, 0, 10800, 7200], [2011091, 60, 7200, 10800], [2011213, 0, 10800, 7200], [2011242, 0, 7200, 10800], [2011273, 0, 10800, 7200], [2012090, 0, 7200, 10800], [2012265, 3600, 10800, 7200], [2013088, 0, 7200, 10800], [2013270, 0, 10800, 7200], [2014087, 0, 7200, 10800], [2014297, 0, 10800, 7200], [2015087, 0, 7200, 10800], [2015296, 0, 10800, 7200], [2016086, 3600, 7200, 10800], [2016303, 3600, 10800, 7200], [2017084, 3600, 7200, 10800], [2017301, 3600, 10800, 7200], [2018083, 3600, 7200, 10800], [2018300, 3600, 10800, 7200], [2019088, 0, 7200, 10800], [2019299, 3600, 10800, 7200], [2020087, 0, 7200, 10800], [2020305, 3600, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 5, 0, 0, 1, 7200, 7200, 10800], [10, 25, 6, 3600, 0, 1, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiro$__f_Asia_Hebron = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiro$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiro$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiro$.prototype.constructor = $c_Lzonedb_java_tzdb$asiro$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiro$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiro$.prototype = $c_Lzonedb_java_tzdb$asiro$.prototype;
$c_Lzonedb_java_tzdb$asiro$.prototype.Asia_Hebron__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiro$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 219")
  };
  return this.Lzonedb_java_tzdb$asiro$__f_Asia_Hebron
});
var $d_Lzonedb_java_tzdb$asiro$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiro$: 0
}, false, "zonedb.java.tzdb$asiro$", {
  Lzonedb_java_tzdb$asiro$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiro$.prototype.$classData = $d_Lzonedb_java_tzdb$asiro$;
var $n_Lzonedb_java_tzdb$asiro$;
function $m_Lzonedb_java_tzdb$asiro$() {
  if ((!$n_Lzonedb_java_tzdb$asiro$)) {
    $n_Lzonedb_java_tzdb$asiro$ = new $c_Lzonedb_java_tzdb$asiro$()
  };
  return $n_Lzonedb_java_tzdb$asiro$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asirs$() {
  this.Lzonedb_java_tzdb$asirs$__f_Asia_Novosibirsk = null;
  this.Lzonedb_java_tzdb$asirs$__f_Asia_Krasnoyarsk = null;
  this.Lzonedb_java_tzdb$asirs$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asirs$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 19900), $ct_T2__O__O__(new $c_T2(), "w", 19900), $ct_T2__O__O__(new $c_T2(), "t", [[1919348, 21600, 19900, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [1993142, 82800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016206, 7200, 21600, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919348, 21600, 19900, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993143, 0, 28800, 25200], [1993269, 10800, 25200, 21600], [1994086, 7200, 21600, 25200], [1994268, 10800, 25200, 21600], [1995085, 7200, 21600, 25200], [1995267, 10800, 25200, 21600], [1996091, 7200, 21600, 25200], [1996301, 10800, 25200, 21600], [1997089, 7200, 21600, 25200], [1997299, 10800, 25200, 21600], [1998088, 7200, 21600, 25200], [1998298, 10800, 25200, 21600], [1999087, 7200, 21600, 25200], [1999304, 10800, 25200, 21600], [2000086, 7200, 21600, 25200], [2000303, 10800, 25200, 21600], [2001084, 7200, 21600, 25200], [2001301, 10800, 25200, 21600], [2002090, 7200, 21600, 25200], [2002300, 10800, 25200, 21600], [2003089, 7200, 21600, 25200], [2003299, 10800, 25200, 21600], [2004088, 7200, 21600, 25200], [2004305, 10800, 25200, 21600], [2005086, 7200, 21600, 25200], [2005303, 10800, 25200, 21600], [2006085, 7200, 21600, 25200], [2006302, 10800, 25200, 21600], [2007084, 7200, 21600, 25200], [2007301, 10800, 25200, 21600], [2008090, 7200, 21600, 25200], [2008300, 10800, 25200, 21600], [2009088, 7200, 21600, 25200], [2009298, 10800, 25200, 21600], [2010087, 7200, 21600, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200], [2014299, 7200, 25200, 21600], [2016206, 7200, 21600, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asirs$__f_Asia_Novosibirsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asirs$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asirs$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 22286), $ct_T2__O__O__(new $c_T2(), "w", 22286), $ct_T2__O__O__(new $c_T2(), "t", [[1920006, 0, 22286, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [2011086, 7200, 25200, 28800], [2014299, 7200, 28800, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920006, 0, 22286, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993269, 10800, 28800, 25200], [1994086, 7200, 25200, 28800], [1994268, 10800, 28800, 25200], [1995085, 7200, 25200, 28800], [1995267, 10800, 28800, 25200], [1996091, 7200, 25200, 28800], [1996301, 10800, 28800, 25200], [1997089, 7200, 25200, 28800], [1997299, 10800, 28800, 25200], [1998088, 7200, 25200, 28800], [1998298, 10800, 28800, 25200], [1999087, 7200, 25200, 28800], [1999304, 10800, 28800, 25200], [2000086, 7200, 25200, 28800], [2000303, 10800, 28800, 25200], [2001084, 7200, 25200, 28800], [2001301, 10800, 28800, 25200], [2002090, 7200, 25200, 28800], [2002300, 10800, 28800, 25200], [2003089, 7200, 25200, 28800], [2003299, 10800, 28800, 25200], [2004088, 7200, 25200, 28800], [2004305, 10800, 28800, 25200], [2005086, 7200, 25200, 28800], [2005303, 10800, 28800, 25200], [2006085, 7200, 25200, 28800], [2006302, 10800, 28800, 25200], [2007084, 7200, 25200, 28800], [2007301, 10800, 28800, 25200], [2008090, 7200, 25200, 28800], [2008300, 10800, 28800, 25200], [2009088, 7200, 25200, 28800], [2009298, 10800, 28800, 25200], [2010087, 7200, 25200, 28800], [2010304, 10800, 28800, 25200], [2011086, 7200, 25200, 28800], [2014299, 7200, 28800, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asirs$__f_Asia_Krasnoyarsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asirs$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asirs$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asirs$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asirs$.prototype.constructor = $c_Lzonedb_java_tzdb$asirs$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asirs$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asirs$.prototype = $c_Lzonedb_java_tzdb$asirs$.prototype;
$c_Lzonedb_java_tzdb$asirs$.prototype.Asia_Novosibirsk__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asirs$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 387")
  };
  return this.Lzonedb_java_tzdb$asirs$__f_Asia_Novosibirsk
});
$c_Lzonedb_java_tzdb$asirs$.prototype.Asia_Krasnoyarsk__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asirs$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 388")
  };
  return this.Lzonedb_java_tzdb$asirs$__f_Asia_Krasnoyarsk
});
var $d_Lzonedb_java_tzdb$asirs$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asirs$: 0
}, false, "zonedb.java.tzdb$asirs$", {
  Lzonedb_java_tzdb$asirs$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asirs$.prototype.$classData = $d_Lzonedb_java_tzdb$asirs$;
var $n_Lzonedb_java_tzdb$asirs$;
function $m_Lzonedb_java_tzdb$asirs$() {
  if ((!$n_Lzonedb_java_tzdb$asirs$)) {
    $n_Lzonedb_java_tzdb$asirs$ = new $c_Lzonedb_java_tzdb$asirs$()
  };
  return $n_Lzonedb_java_tzdb$asirs$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asirt$() {
  this.Lzonedb_java_tzdb$asirt$__f_Asia_Jakarta = null;
  this.Lzonedb_java_tzdb$asirt$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asirt$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 25632), $ct_T2__O__O__(new $c_T2(), "w", 25632), $ct_T2__O__O__(new $c_T2(), "t", [[1923365, 85632, 25632, 26400], [1932306, 0, 26400, 27000], [1942082, 0, 27000, 32400], [1945266, 0, 32400, 27000], [1948122, 0, 27000, 28800], [1950121, 0, 28800, 27000], [1964001, 0, 27000, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1923365, 85632, 25632, 26400], [1932306, 0, 26400, 27000], [1942082, 0, 27000, 32400], [1945266, 0, 32400, 27000], [1948122, 0, 27000, 28800], [1950121, 0, 28800, 27000], [1964001, 0, 27000, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asirt$__f_Asia_Jakarta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asirt$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asirt$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asirt$.prototype.constructor = $c_Lzonedb_java_tzdb$asirt$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asirt$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asirt$.prototype = $c_Lzonedb_java_tzdb$asirt$.prototype;
$c_Lzonedb_java_tzdb$asirt$.prototype.Asia_Jakarta__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asirt$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 714")
  };
  return this.Lzonedb_java_tzdb$asirt$__f_Asia_Jakarta
});
var $d_Lzonedb_java_tzdb$asirt$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asirt$: 0
}, false, "zonedb.java.tzdb$asirt$", {
  Lzonedb_java_tzdb$asirt$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asirt$.prototype.$classData = $d_Lzonedb_java_tzdb$asirt$;
var $n_Lzonedb_java_tzdb$asirt$;
function $m_Lzonedb_java_tzdb$asirt$() {
  if ((!$n_Lzonedb_java_tzdb$asirt$)) {
    $n_Lzonedb_java_tzdb$asirt$ = new $c_Lzonedb_java_tzdb$asirt$()
  };
  return $n_Lzonedb_java_tzdb$asirt$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiru$() {
  this.Lzonedb_java_tzdb$asiru$__f_Asia_Beirut = null;
  this.Lzonedb_java_tzdb$asiru$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiru$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8520), $ct_T2__O__O__(new $c_T2(), "w", 8520), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 8520, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 8520, 7200], [1920088, 0, 7200, 10800], [1920299, 0, 10800, 7200], [1921093, 0, 7200, 10800], [1921276, 0, 10800, 7200], [1922085, 0, 7200, 10800], [1922281, 0, 10800, 7200], [1923112, 0, 7200, 10800], [1923259, 0, 10800, 7200], [1957121, 0, 7200, 10800], [1957274, 0, 10800, 7200], [1958121, 0, 7200, 10800], [1958274, 0, 10800, 7200], [1959121, 0, 7200, 10800], [1959274, 0, 10800, 7200], [1960122, 0, 7200, 10800], [1960275, 0, 10800, 7200], [1961121, 0, 7200, 10800], [1961274, 0, 10800, 7200], [1972174, 0, 7200, 10800], [1972275, 0, 10800, 7200], [1973121, 0, 7200, 10800], [1973274, 0, 10800, 7200], [1974121, 0, 7200, 10800], [1974274, 0, 10800, 7200], [1975121, 0, 7200, 10800], [1975274, 0, 10800, 7200], [1976122, 0, 7200, 10800], [1976275, 0, 10800, 7200], [1977121, 0, 7200, 10800], [1977274, 0, 10800, 7200], [1978120, 0, 7200, 10800], [1978273, 0, 10800, 7200], [1984122, 0, 7200, 10800], [1984290, 0, 10800, 7200], [1985121, 0, 7200, 10800], [1985289, 0, 10800, 7200], [1986121, 0, 7200, 10800], [1986289, 0, 10800, 7200], [1987121, 0, 7200, 10800], [1987289, 0, 10800, 7200], [1988153, 0, 7200, 10800], [1988290, 0, 10800, 7200], [1989130, 0, 7200, 10800], [1989289, 0, 10800, 7200], [1990121, 0, 7200, 10800], [1990289, 0, 10800, 7200], [1991121, 0, 7200, 10800], [1991289, 0, 10800, 7200], [1992122, 0, 7200, 10800], [1992278, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996273, 0, 10800, 7200], [1997089, 0, 7200, 10800], [1997271, 0, 10800, 7200], [1998088, 0, 7200, 10800], [1998270, 0, 10800, 7200], [1999087, 0, 7200, 10800], [1999304, 0, 10800, 7200], [2000086, 0, 7200, 10800], [2000303, 0, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 0, 0, 1, 7200, 7200, 10800], [10, 25, 7, 0, 0, 1, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiru$__f_Asia_Beirut = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiru$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiru$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiru$.prototype.constructor = $c_Lzonedb_java_tzdb$asiru$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiru$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiru$.prototype = $c_Lzonedb_java_tzdb$asiru$.prototype;
$c_Lzonedb_java_tzdb$asiru$.prototype.Asia_Beirut__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiru$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 467")
  };
  return this.Lzonedb_java_tzdb$asiru$__f_Asia_Beirut
});
var $d_Lzonedb_java_tzdb$asiru$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiru$: 0
}, false, "zonedb.java.tzdb$asiru$", {
  Lzonedb_java_tzdb$asiru$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiru$.prototype.$classData = $d_Lzonedb_java_tzdb$asiru$;
var $n_Lzonedb_java_tzdb$asiru$;
function $m_Lzonedb_java_tzdb$asiru$() {
  if ((!$n_Lzonedb_java_tzdb$asiru$)) {
    $n_Lzonedb_java_tzdb$asiru$ = new $c_Lzonedb_java_tzdb$asiru$()
  };
  return $n_Lzonedb_java_tzdb$asiru$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asisa$() {
  this.Lzonedb_java_tzdb$asisa$__f_Asia_Makassar = null;
  this.Lzonedb_java_tzdb$asisa$__f_Asia_Choibalsan = null;
  this.Lzonedb_java_tzdb$asisa$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asisa$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 28656), $ct_T2__O__O__(new $c_T2(), "w", 28656), $ct_T2__O__O__(new $c_T2(), "t", [[1932306, 0, 28656, 28800], [1942040, 0, 28800, 32400], [1945266, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1932306, 0, 28656, 28800], [1942040, 0, 28800, 32400], [1945266, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asisa$__f_Asia_Makassar = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asisa$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asisa$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 27480), $ct_T2__O__O__(new $c_T2(), "w", 27480), $ct_T2__O__O__(new $c_T2(), "t", [[1905213, 0, 27480, 25200], [1978001, 0, 25200, 28800], [1983091, 0, 28800, 32400], [2008091, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1905213, 0, 27480, 25200], [1978001, 0, 25200, 28800], [1983091, 0, 28800, 36000], [1983274, 0, 36000, 32400], [1984092, 0, 32400, 36000], [1984274, 0, 36000, 32400], [1985090, 0, 32400, 36000], [1985272, 0, 36000, 32400], [1986089, 0, 32400, 36000], [1986271, 0, 36000, 32400], [1987088, 0, 32400, 36000], [1987270, 0, 36000, 32400], [1988087, 0, 32400, 36000], [1988269, 0, 36000, 32400], [1989085, 0, 32400, 36000], [1989267, 0, 36000, 32400], [1990084, 0, 32400, 36000], [1990273, 0, 36000, 32400], [1991090, 0, 32400, 36000], [1991272, 0, 36000, 32400], [1992089, 0, 32400, 36000], [1992271, 0, 36000, 32400], [1993087, 0, 32400, 36000], [1993269, 0, 36000, 32400], [1994086, 0, 32400, 36000], [1994268, 0, 36000, 32400], [1995085, 0, 32400, 36000], [1995267, 0, 36000, 32400], [1996091, 0, 32400, 36000], [1996273, 0, 36000, 32400], [1997089, 0, 32400, 36000], [1997271, 0, 36000, 32400], [1998088, 0, 32400, 36000], [1998270, 0, 36000, 32400], [2001118, 7200, 32400, 36000], [2001272, 7200, 36000, 32400], [2002089, 7200, 32400, 36000], [2002271, 7200, 36000, 32400], [2003088, 7200, 32400, 36000], [2003270, 7200, 36000, 32400], [2004087, 7200, 32400, 36000], [2004269, 7200, 36000, 32400], [2005085, 7200, 32400, 36000], [2005267, 7200, 36000, 32400], [2006084, 7200, 32400, 36000], [2006273, 7200, 36000, 32400], [2008091, 0, 32400, 28800], [2015087, 7200, 28800, 32400], [2015269, 0, 32400, 28800], [2016086, 7200, 28800, 32400], [2016268, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asisa$__f_Asia_Choibalsan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asisa$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asisa$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asisa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asisa$.prototype.constructor = $c_Lzonedb_java_tzdb$asisa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asisa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asisa$.prototype = $c_Lzonedb_java_tzdb$asisa$.prototype;
$c_Lzonedb_java_tzdb$asisa$.prototype.Asia_Makassar__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asisa$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 394")
  };
  return this.Lzonedb_java_tzdb$asisa$__f_Asia_Makassar
});
$c_Lzonedb_java_tzdb$asisa$.prototype.Asia_Choibalsan__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asisa$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 395")
  };
  return this.Lzonedb_java_tzdb$asisa$__f_Asia_Choibalsan
});
var $d_Lzonedb_java_tzdb$asisa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asisa$: 0
}, false, "zonedb.java.tzdb$asisa$", {
  Lzonedb_java_tzdb$asisa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asisa$.prototype.$classData = $d_Lzonedb_java_tzdb$asisa$;
var $n_Lzonedb_java_tzdb$asisa$;
function $m_Lzonedb_java_tzdb$asisa$() {
  if ((!$n_Lzonedb_java_tzdb$asisa$)) {
    $n_Lzonedb_java_tzdb$asisa$ = new $c_Lzonedb_java_tzdb$asisa$()
  };
  return $n_Lzonedb_java_tzdb$asisa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asisi$() {
  this.Lzonedb_java_tzdb$asisi$__f_Asia_Nicosia = null;
  this.Lzonedb_java_tzdb$asisi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asisi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8008), $ct_T2__O__O__(new $c_T2(), "w", 8008), $ct_T2__O__O__(new $c_T2(), "t", [[1921318, 0, 8008, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921318, 0, 8008, 7200], [1975103, 0, 7200, 10800], [1975285, 0, 10800, 7200], [1976136, 0, 7200, 10800], [1976285, 0, 10800, 7200], [1977093, 0, 7200, 10800], [1977268, 0, 10800, 7200], [1978092, 0, 7200, 10800], [1978275, 0, 10800, 7200], [1979091, 0, 7200, 10800], [1979273, 0, 10800, 7200], [1980097, 0, 7200, 10800], [1980272, 0, 10800, 7200], [1981088, 0, 7200, 10800], [1981270, 0, 10800, 7200], [1982087, 0, 7200, 10800], [1982269, 0, 10800, 7200], [1983086, 0, 7200, 10800], [1983268, 0, 10800, 7200], [1984085, 0, 7200, 10800], [1984274, 0, 10800, 7200], [1985090, 0, 7200, 10800], [1985272, 0, 10800, 7200], [1986089, 0, 7200, 10800], [1986271, 0, 10800, 7200], [1987088, 0, 7200, 10800], [1987270, 0, 10800, 7200], [1988087, 0, 7200, 10800], [1988269, 0, 10800, 7200], [1989085, 0, 7200, 10800], [1989267, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990273, 0, 10800, 7200], [1991090, 0, 7200, 10800], [1991272, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996273, 0, 10800, 7200], [1997089, 0, 7200, 10800], [1997271, 0, 10800, 7200], [1998088, 0, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asisi$__f_Asia_Nicosia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asisi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asisi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asisi$.prototype.constructor = $c_Lzonedb_java_tzdb$asisi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asisi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asisi$.prototype = $c_Lzonedb_java_tzdb$asisi$.prototype;
$c_Lzonedb_java_tzdb$asisi$.prototype.Asia_Nicosia__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asisi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 727")
  };
  return this.Lzonedb_java_tzdb$asisi$__f_Asia_Nicosia
});
var $d_Lzonedb_java_tzdb$asisi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asisi$: 0
}, false, "zonedb.java.tzdb$asisi$", {
  Lzonedb_java_tzdb$asisi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asisi$.prototype.$classData = $d_Lzonedb_java_tzdb$asisi$;
var $n_Lzonedb_java_tzdb$asisi$;
function $m_Lzonedb_java_tzdb$asisi$() {
  if ((!$n_Lzonedb_java_tzdb$asisi$)) {
    $n_Lzonedb_java_tzdb$asisi$ = new $c_Lzonedb_java_tzdb$asisi$()
  };
  return $n_Lzonedb_java_tzdb$asisi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asist$() {
  this.Lzonedb_java_tzdb$asist$__f_Asia_Famagusta = null;
  this.Lzonedb_java_tzdb$asist$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asist$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8148), $ct_T2__O__O__(new $c_T2(), "w", 8148), $ct_T2__O__O__(new $c_T2(), "t", [[1921318, 0, 8148, 7200], [2016251, 82800, 7200, 10800], [2017302, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921318, 0, 8148, 7200], [1975103, 0, 7200, 10800], [1975285, 0, 10800, 7200], [1976136, 0, 7200, 10800], [1976285, 0, 10800, 7200], [1977093, 0, 7200, 10800], [1977268, 0, 10800, 7200], [1978092, 0, 7200, 10800], [1978275, 0, 10800, 7200], [1979091, 0, 7200, 10800], [1979273, 0, 10800, 7200], [1980097, 0, 7200, 10800], [1980272, 0, 10800, 7200], [1981088, 0, 7200, 10800], [1981270, 0, 10800, 7200], [1982087, 0, 7200, 10800], [1982269, 0, 10800, 7200], [1983086, 0, 7200, 10800], [1983268, 0, 10800, 7200], [1984085, 0, 7200, 10800], [1984274, 0, 10800, 7200], [1985090, 0, 7200, 10800], [1985272, 0, 10800, 7200], [1986089, 0, 7200, 10800], [1986271, 0, 10800, 7200], [1987088, 0, 7200, 10800], [1987270, 0, 10800, 7200], [1988087, 0, 7200, 10800], [1988269, 0, 10800, 7200], [1989085, 0, 7200, 10800], [1989267, 0, 10800, 7200], [1990084, 0, 7200, 10800], [1990273, 0, 10800, 7200], [1991090, 0, 7200, 10800], [1991272, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996273, 0, 10800, 7200], [1997089, 0, 7200, 10800], [1997271, 0, 10800, 7200], [1998088, 0, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200], [2000086, 10800, 7200, 10800], [2000303, 14400, 10800, 7200], [2001084, 10800, 7200, 10800], [2001301, 14400, 10800, 7200], [2002090, 10800, 7200, 10800], [2002300, 14400, 10800, 7200], [2003089, 10800, 7200, 10800], [2003299, 14400, 10800, 7200], [2004088, 10800, 7200, 10800], [2004305, 14400, 10800, 7200], [2005086, 10800, 7200, 10800], [2005303, 14400, 10800, 7200], [2006085, 10800, 7200, 10800], [2006302, 14400, 10800, 7200], [2007084, 10800, 7200, 10800], [2007301, 14400, 10800, 7200], [2008090, 10800, 7200, 10800], [2008300, 14400, 10800, 7200], [2009088, 10800, 7200, 10800], [2009298, 14400, 10800, 7200], [2010087, 10800, 7200, 10800], [2010304, 14400, 10800, 7200], [2011086, 10800, 7200, 10800], [2011303, 14400, 10800, 7200], [2012085, 10800, 7200, 10800], [2012302, 14400, 10800, 7200], [2013090, 10800, 7200, 10800], [2013300, 14400, 10800, 7200], [2014089, 10800, 7200, 10800], [2014299, 14400, 10800, 7200], [2015088, 10800, 7200, 10800], [2015298, 14400, 10800, 7200], [2016087, 10800, 7200, 10800], [2017302, 14400, 10800, 7200], [2018084, 10800, 7200, 10800], [2018301, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asist$__f_Asia_Famagusta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asist$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asist$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asist$.prototype.constructor = $c_Lzonedb_java_tzdb$asist$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asist$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asist$.prototype = $c_Lzonedb_java_tzdb$asist$.prototype;
$c_Lzonedb_java_tzdb$asist$.prototype.Asia_Famagusta__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asist$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 351")
  };
  return this.Lzonedb_java_tzdb$asist$__f_Asia_Famagusta
});
var $d_Lzonedb_java_tzdb$asist$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asist$: 0
}, false, "zonedb.java.tzdb$asist$", {
  Lzonedb_java_tzdb$asist$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asist$.prototype.$classData = $d_Lzonedb_java_tzdb$asist$;
var $n_Lzonedb_java_tzdb$asist$;
function $m_Lzonedb_java_tzdb$asist$() {
  if ((!$n_Lzonedb_java_tzdb$asist$)) {
    $n_Lzonedb_java_tzdb$asist$ = new $c_Lzonedb_java_tzdb$asist$()
  };
  return $n_Lzonedb_java_tzdb$asist$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asita$() {
  this.Lzonedb_java_tzdb$asita$__f_Asia_Ulaanbaatar = null;
  this.Lzonedb_java_tzdb$asita$__f_Asia_Qatar = null;
  this.Lzonedb_java_tzdb$asita$__f_Asia_Aqtau = null;
  this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asita$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 25652), $ct_T2__O__O__(new $c_T2(), "w", 25652), $ct_T2__O__O__(new $c_T2(), "t", [[1905213, 0, 25652, 25200], [1978001, 0, 25200, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1905213, 0, 25652, 25200], [1978001, 0, 25200, 28800], [1983091, 0, 28800, 32400], [1983274, 0, 32400, 28800], [1984092, 0, 28800, 32400], [1984274, 0, 32400, 28800], [1985090, 0, 28800, 32400], [1985272, 0, 32400, 28800], [1986089, 0, 28800, 32400], [1986271, 0, 32400, 28800], [1987088, 0, 28800, 32400], [1987270, 0, 32400, 28800], [1988087, 0, 28800, 32400], [1988269, 0, 32400, 28800], [1989085, 0, 28800, 32400], [1989267, 0, 32400, 28800], [1990084, 0, 28800, 32400], [1990273, 0, 32400, 28800], [1991090, 0, 28800, 32400], [1991272, 0, 32400, 28800], [1992089, 0, 28800, 32400], [1992271, 0, 32400, 28800], [1993087, 0, 28800, 32400], [1993269, 0, 32400, 28800], [1994086, 0, 28800, 32400], [1994268, 0, 32400, 28800], [1995085, 0, 28800, 32400], [1995267, 0, 32400, 28800], [1996091, 0, 28800, 32400], [1996273, 0, 32400, 28800], [1997089, 0, 28800, 32400], [1997271, 0, 32400, 28800], [1998088, 0, 28800, 32400], [1998270, 0, 32400, 28800], [2001118, 7200, 28800, 32400], [2001272, 7200, 32400, 28800], [2002089, 7200, 28800, 32400], [2002271, 7200, 32400, 28800], [2003088, 7200, 28800, 32400], [2003270, 7200, 32400, 28800], [2004087, 7200, 28800, 32400], [2004269, 7200, 32400, 28800], [2005085, 7200, 28800, 32400], [2005267, 7200, 32400, 28800], [2006084, 7200, 28800, 32400], [2006273, 7200, 32400, 28800], [2015087, 7200, 28800, 32400], [2015269, 0, 32400, 28800], [2016086, 7200, 28800, 32400], [2016268, 0, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asita$__f_Asia_Ulaanbaatar = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 12368), $ct_T2__O__O__(new $c_T2(), "w", 12368), $ct_T2__O__O__(new $c_T2(), "t", [[1920001, 0, 12368, 14400], [1972153, 0, 14400, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920001, 0, 12368, 14400], [1972153, 0, 14400, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asita$__f_Asia_Qatar = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", 12064), $ct_T2__O__O__(new $c_T2(), "w", 12064), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 12064, 14400], [1930172, 0, 14400, 18000], [1981274, 0, 18000, 21600], [1982091, 0, 21600, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [1994268, 7200, 18000, 14400], [2004305, 7200, 14400, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 12064, 14400], [1930172, 0, 14400, 18000], [1981274, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 14400], [1995085, 7200, 14400, 18000], [1995267, 10800, 18000, 14400], [1996091, 7200, 14400, 18000], [1996301, 10800, 18000, 14400], [1997089, 7200, 14400, 18000], [1997299, 10800, 18000, 14400], [1998088, 7200, 14400, 18000], [1998298, 10800, 18000, 14400], [1999087, 7200, 14400, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$asita$__f_Asia_Aqtau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asita$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asita$.prototype.constructor = $c_Lzonedb_java_tzdb$asita$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asita$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asita$.prototype = $c_Lzonedb_java_tzdb$asita$.prototype;
$c_Lzonedb_java_tzdb$asita$.prototype.Asia_Ulaanbaatar__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 357")
  };
  return this.Lzonedb_java_tzdb$asita$__f_Asia_Ulaanbaatar
});
$c_Lzonedb_java_tzdb$asita$.prototype.Asia_Qatar__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 358")
  };
  return this.Lzonedb_java_tzdb$asita$__f_Asia_Qatar
});
$c_Lzonedb_java_tzdb$asita$.prototype.Asia_Aqtau__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$asita$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 359")
  };
  return this.Lzonedb_java_tzdb$asita$__f_Asia_Aqtau
});
var $d_Lzonedb_java_tzdb$asita$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asita$: 0
}, false, "zonedb.java.tzdb$asita$", {
  Lzonedb_java_tzdb$asita$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asita$.prototype.$classData = $d_Lzonedb_java_tzdb$asita$;
var $n_Lzonedb_java_tzdb$asita$;
function $m_Lzonedb_java_tzdb$asita$() {
  if ((!$n_Lzonedb_java_tzdb$asita$)) {
    $n_Lzonedb_java_tzdb$asita$ = new $c_Lzonedb_java_tzdb$asita$()
  };
  return $n_Lzonedb_java_tzdb$asita$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asitk$() {
  this.Lzonedb_java_tzdb$asitk$__f_Asia_Kamchatka = null;
  this.Lzonedb_java_tzdb$asitk$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asitk$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 38076), $ct_T2__O__O__(new $c_T2(), "w", 38076), $ct_T2__O__O__(new $c_T2(), "t", [[1922314, 0, 38076, 39600], [1930172, 0, 39600, 43200], [1991090, 7200, 43200, 39600], [1992019, 7200, 39600, 43200], [2010087, 7200, 43200, 39600], [2011086, 7200, 39600, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1922314, 0, 38076, 39600], [1930172, 0, 39600, 43200], [1981091, 0, 43200, 46800], [1981274, 0, 46800, 43200], [1982091, 0, 43200, 46800], [1982274, 0, 46800, 43200], [1983091, 0, 43200, 46800], [1983274, 0, 46800, 43200], [1984092, 0, 43200, 46800], [1984274, 10800, 46800, 43200], [1985090, 7200, 43200, 46800], [1985272, 10800, 46800, 43200], [1986089, 7200, 43200, 46800], [1986271, 10800, 46800, 43200], [1987088, 7200, 43200, 46800], [1987270, 10800, 46800, 43200], [1988087, 7200, 43200, 46800], [1988269, 10800, 46800, 43200], [1989085, 7200, 43200, 46800], [1989267, 10800, 46800, 43200], [1990084, 7200, 43200, 46800], [1990273, 10800, 46800, 43200], [1991272, 10800, 43200, 39600], [1992019, 7200, 39600, 43200], [1992089, 7200, 43200, 46800], [1992271, 10800, 46800, 43200], [1993087, 7200, 43200, 46800], [1993269, 10800, 46800, 43200], [1994086, 7200, 43200, 46800], [1994268, 10800, 46800, 43200], [1995085, 7200, 43200, 46800], [1995267, 10800, 46800, 43200], [1996091, 7200, 43200, 46800], [1996301, 10800, 46800, 43200], [1997089, 7200, 43200, 46800], [1997299, 10800, 46800, 43200], [1998088, 7200, 43200, 46800], [1998298, 10800, 46800, 43200], [1999087, 7200, 43200, 46800], [1999304, 10800, 46800, 43200], [2000086, 7200, 43200, 46800], [2000303, 10800, 46800, 43200], [2001084, 7200, 43200, 46800], [2001301, 10800, 46800, 43200], [2002090, 7200, 43200, 46800], [2002300, 10800, 46800, 43200], [2003089, 7200, 43200, 46800], [2003299, 10800, 46800, 43200], [2004088, 7200, 43200, 46800], [2004305, 10800, 46800, 43200], [2005086, 7200, 43200, 46800], [2005303, 10800, 46800, 43200], [2006085, 7200, 43200, 46800], [2006302, 10800, 46800, 43200], [2007084, 7200, 43200, 46800], [2007301, 10800, 46800, 43200], [2008090, 7200, 43200, 46800], [2008300, 10800, 46800, 43200], [2009088, 7200, 43200, 46800], [2009298, 10800, 46800, 43200], [2010304, 10800, 43200, 39600], [2011086, 7200, 39600, 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asitk$__f_Asia_Kamchatka = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asitk$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asitk$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asitk$.prototype.constructor = $c_Lzonedb_java_tzdb$asitk$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asitk$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asitk$.prototype = $c_Lzonedb_java_tzdb$asitk$.prototype;
$c_Lzonedb_java_tzdb$asitk$.prototype.Asia_Kamchatka__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asitk$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 435")
  };
  return this.Lzonedb_java_tzdb$asitk$__f_Asia_Kamchatka
});
var $d_Lzonedb_java_tzdb$asitk$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asitk$: 0
}, false, "zonedb.java.tzdb$asitk$", {
  Lzonedb_java_tzdb$asitk$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asitk$.prototype.$classData = $d_Lzonedb_java_tzdb$asitk$;
var $n_Lzonedb_java_tzdb$asitk$;
function $m_Lzonedb_java_tzdb$asitk$() {
  if ((!$n_Lzonedb_java_tzdb$asitk$)) {
    $n_Lzonedb_java_tzdb$asitk$ = new $c_Lzonedb_java_tzdb$asitk$()
  };
  return $n_Lzonedb_java_tzdb$asitk$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asito$() {
  this.Lzonedb_java_tzdb$asito$__f_Asia_Vladivostok = null;
  this.Lzonedb_java_tzdb$asito$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asito$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 31651), $ct_T2__O__O__(new $c_T2(), "w", 31651), $ct_T2__O__O__(new $c_T2(), "t", [[1922319, 0, 31651, 32400], [1930172, 0, 32400, 36000], [1991090, 7200, 36000, 32400], [1992019, 7200, 32400, 36000], [2011086, 7200, 36000, 39600], [2014299, 7200, 39600, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1922319, 0, 31651, 32400], [1930172, 0, 32400, 36000], [1981091, 0, 36000, 39600], [1981274, 0, 39600, 36000], [1982091, 0, 36000, 39600], [1982274, 0, 39600, 36000], [1983091, 0, 36000, 39600], [1983274, 0, 39600, 36000], [1984092, 0, 36000, 39600], [1984274, 10800, 39600, 36000], [1985090, 7200, 36000, 39600], [1985272, 10800, 39600, 36000], [1986089, 7200, 36000, 39600], [1986271, 10800, 39600, 36000], [1987088, 7200, 36000, 39600], [1987270, 10800, 39600, 36000], [1988087, 7200, 36000, 39600], [1988269, 10800, 39600, 36000], [1989085, 7200, 36000, 39600], [1989267, 10800, 39600, 36000], [1990084, 7200, 36000, 39600], [1990273, 10800, 39600, 36000], [1991272, 10800, 36000, 32400], [1992019, 7200, 32400, 36000], [1992089, 7200, 36000, 39600], [1992271, 10800, 39600, 36000], [1993087, 7200, 36000, 39600], [1993269, 10800, 39600, 36000], [1994086, 7200, 36000, 39600], [1994268, 10800, 39600, 36000], [1995085, 7200, 36000, 39600], [1995267, 10800, 39600, 36000], [1996091, 7200, 36000, 39600], [1996301, 10800, 39600, 36000], [1997089, 7200, 36000, 39600], [1997299, 10800, 39600, 36000], [1998088, 7200, 36000, 39600], [1998298, 10800, 39600, 36000], [1999087, 7200, 36000, 39600], [1999304, 10800, 39600, 36000], [2000086, 7200, 36000, 39600], [2000303, 10800, 39600, 36000], [2001084, 7200, 36000, 39600], [2001301, 10800, 39600, 36000], [2002090, 7200, 36000, 39600], [2002300, 10800, 39600, 36000], [2003089, 7200, 36000, 39600], [2003299, 10800, 39600, 36000], [2004088, 7200, 36000, 39600], [2004305, 10800, 39600, 36000], [2005086, 7200, 36000, 39600], [2005303, 10800, 39600, 36000], [2006085, 7200, 36000, 39600], [2006302, 10800, 39600, 36000], [2007084, 7200, 36000, 39600], [2007301, 10800, 39600, 36000], [2008090, 7200, 36000, 39600], [2008300, 10800, 39600, 36000], [2009088, 7200, 36000, 39600], [2009298, 10800, 39600, 36000], [2010087, 7200, 36000, 39600], [2010304, 10800, 39600, 36000], [2011086, 7200, 36000, 39600], [2014299, 7200, 39600, 36000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asito$__f_Asia_Vladivostok = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asito$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asito$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asito$.prototype.constructor = $c_Lzonedb_java_tzdb$asito$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asito$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asito$.prototype = $c_Lzonedb_java_tzdb$asito$.prototype;
$c_Lzonedb_java_tzdb$asito$.prototype.Asia_Vladivostok__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asito$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 420")
  };
  return this.Lzonedb_java_tzdb$asito$__f_Asia_Vladivostok
});
var $d_Lzonedb_java_tzdb$asito$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asito$: 0
}, false, "zonedb.java.tzdb$asito$", {
  Lzonedb_java_tzdb$asito$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asito$.prototype.$classData = $d_Lzonedb_java_tzdb$asito$;
var $n_Lzonedb_java_tzdb$asito$;
function $m_Lzonedb_java_tzdb$asito$() {
  if ((!$n_Lzonedb_java_tzdb$asito$)) {
    $n_Lzonedb_java_tzdb$asito$ = new $c_Lzonedb_java_tzdb$asito$()
  };
  return $n_Lzonedb_java_tzdb$asito$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asits$() {
  this.Lzonedb_java_tzdb$asits$__f_Asia_Novokuznetsk = null;
  this.Lzonedb_java_tzdb$asits$__f_Asia_Irkutsk = null;
  this.Lzonedb_java_tzdb$asits$__f_Asia_Yakutsk = null;
  this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asits$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 20928), $ct_T2__O__O__(new $c_T2(), "w", 20928), $ct_T2__O__O__(new $c_T2(), "t", [[1924122, 0, 20928, 21600], [1930172, 0, 21600, 25200], [1991090, 7200, 25200, 21600], [1992019, 7200, 21600, 25200], [2010087, 7200, 25200, 21600], [2011086, 7200, 21600, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924122, 0, 20928, 21600], [1930172, 0, 21600, 25200], [1981091, 0, 25200, 28800], [1981274, 0, 28800, 25200], [1982091, 0, 25200, 28800], [1982274, 0, 28800, 25200], [1983091, 0, 25200, 28800], [1983274, 0, 28800, 25200], [1984092, 0, 25200, 28800], [1984274, 10800, 28800, 25200], [1985090, 7200, 25200, 28800], [1985272, 10800, 28800, 25200], [1986089, 7200, 25200, 28800], [1986271, 10800, 28800, 25200], [1987088, 7200, 25200, 28800], [1987270, 10800, 28800, 25200], [1988087, 7200, 25200, 28800], [1988269, 10800, 28800, 25200], [1989085, 7200, 25200, 28800], [1989267, 10800, 28800, 25200], [1990084, 7200, 25200, 28800], [1990273, 10800, 28800, 25200], [1991272, 10800, 25200, 21600], [1992019, 7200, 21600, 25200], [1992089, 7200, 25200, 28800], [1992271, 10800, 28800, 25200], [1993087, 7200, 25200, 28800], [1993269, 10800, 28800, 25200], [1994086, 7200, 25200, 28800], [1994268, 10800, 28800, 25200], [1995085, 7200, 25200, 28800], [1995267, 10800, 28800, 25200], [1996091, 7200, 25200, 28800], [1996301, 10800, 28800, 25200], [1997089, 7200, 25200, 28800], [1997299, 10800, 28800, 25200], [1998088, 7200, 25200, 28800], [1998298, 10800, 28800, 25200], [1999087, 7200, 25200, 28800], [1999304, 10800, 28800, 25200], [2000086, 7200, 25200, 28800], [2000303, 10800, 28800, 25200], [2001084, 7200, 25200, 28800], [2001301, 10800, 28800, 25200], [2002090, 7200, 25200, 28800], [2002300, 10800, 28800, 25200], [2003089, 7200, 25200, 28800], [2003299, 10800, 28800, 25200], [2004088, 7200, 25200, 28800], [2004305, 10800, 28800, 25200], [2005086, 7200, 25200, 28800], [2005303, 10800, 28800, 25200], [2006085, 7200, 25200, 28800], [2006302, 10800, 28800, 25200], [2007084, 7200, 25200, 28800], [2007301, 10800, 28800, 25200], [2008090, 7200, 25200, 28800], [2008300, 10800, 28800, 25200], [2009088, 7200, 25200, 28800], [2009298, 10800, 28800, 25200], [2010304, 10800, 25200, 21600], [2011086, 7200, 21600, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asits$__f_Asia_Novokuznetsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 25025), $ct_T2__O__O__(new $c_T2(), "w", 25025), $ct_T2__O__O__(new $c_T2(), "t", [[1920025, 0, 25025, 25200], [1930172, 0, 25200, 28800], [1991090, 7200, 28800, 25200], [1992019, 7200, 25200, 28800], [2011086, 7200, 28800, 32400], [2014299, 7200, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920025, 0, 25025, 25200], [1930172, 0, 25200, 28800], [1981091, 0, 28800, 32400], [1981274, 0, 32400, 28800], [1982091, 0, 28800, 32400], [1982274, 0, 32400, 28800], [1983091, 0, 28800, 32400], [1983274, 0, 32400, 28800], [1984092, 0, 28800, 32400], [1984274, 10800, 32400, 28800], [1985090, 7200, 28800, 32400], [1985272, 10800, 32400, 28800], [1986089, 7200, 28800, 32400], [1986271, 10800, 32400, 28800], [1987088, 7200, 28800, 32400], [1987270, 10800, 32400, 28800], [1988087, 7200, 28800, 32400], [1988269, 10800, 32400, 28800], [1989085, 7200, 28800, 32400], [1989267, 10800, 32400, 28800], [1990084, 7200, 28800, 32400], [1990273, 10800, 32400, 28800], [1991272, 10800, 28800, 25200], [1992019, 7200, 25200, 28800], [1992089, 7200, 28800, 32400], [1992271, 10800, 32400, 28800], [1993087, 7200, 28800, 32400], [1993269, 10800, 32400, 28800], [1994086, 7200, 28800, 32400], [1994268, 10800, 32400, 28800], [1995085, 7200, 28800, 32400], [1995267, 10800, 32400, 28800], [1996091, 7200, 28800, 32400], [1996301, 10800, 32400, 28800], [1997089, 7200, 28800, 32400], [1997299, 10800, 32400, 28800], [1998088, 7200, 28800, 32400], [1998298, 10800, 32400, 28800], [1999087, 7200, 28800, 32400], [1999304, 10800, 32400, 28800], [2000086, 7200, 28800, 32400], [2000303, 10800, 32400, 28800], [2001084, 7200, 28800, 32400], [2001301, 10800, 32400, 28800], [2002090, 7200, 28800, 32400], [2002300, 10800, 32400, 28800], [2003089, 7200, 28800, 32400], [2003299, 10800, 32400, 28800], [2004088, 7200, 28800, 32400], [2004305, 10800, 32400, 28800], [2005086, 7200, 28800, 32400], [2005303, 10800, 32400, 28800], [2006085, 7200, 28800, 32400], [2006302, 10800, 32400, 28800], [2007084, 7200, 28800, 32400], [2007301, 10800, 32400, 28800], [2008090, 7200, 28800, 32400], [2008300, 10800, 32400, 28800], [2009088, 7200, 28800, 32400], [2009298, 10800, 32400, 28800], [2010087, 7200, 28800, 32400], [2010304, 10800, 32400, 28800], [2011086, 7200, 28800, 32400], [2014299, 7200, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asits$__f_Asia_Irkutsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", 31138), $ct_T2__O__O__(new $c_T2(), "w", 31138), $ct_T2__O__O__(new $c_T2(), "t", [[1919349, 0, 31138, 28800], [1930172, 0, 28800, 32400], [1991090, 7200, 32400, 28800], [1992019, 7200, 28800, 32400], [2011086, 7200, 32400, 36000], [2014299, 7200, 36000, 32400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919349, 0, 31138, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 36000], [1981274, 0, 36000, 32400], [1982091, 0, 32400, 36000], [1982274, 0, 36000, 32400], [1983091, 0, 32400, 36000], [1983274, 0, 36000, 32400], [1984092, 0, 32400, 36000], [1984274, 10800, 36000, 32400], [1985090, 7200, 32400, 36000], [1985272, 10800, 36000, 32400], [1986089, 7200, 32400, 36000], [1986271, 10800, 36000, 32400], [1987088, 7200, 32400, 36000], [1987270, 10800, 36000, 32400], [1988087, 7200, 32400, 36000], [1988269, 10800, 36000, 32400], [1989085, 7200, 32400, 36000], [1989267, 10800, 36000, 32400], [1990084, 7200, 32400, 36000], [1990273, 10800, 36000, 32400], [1991272, 10800, 32400, 28800], [1992019, 7200, 28800, 32400], [1992089, 7200, 32400, 36000], [1992271, 10800, 36000, 32400], [1993087, 7200, 32400, 36000], [1993269, 10800, 36000, 32400], [1994086, 7200, 32400, 36000], [1994268, 10800, 36000, 32400], [1995085, 7200, 32400, 36000], [1995267, 10800, 36000, 32400], [1996091, 7200, 32400, 36000], [1996301, 10800, 36000, 32400], [1997089, 7200, 32400, 36000], [1997299, 10800, 36000, 32400], [1998088, 7200, 32400, 36000], [1998298, 10800, 36000, 32400], [1999087, 7200, 32400, 36000], [1999304, 10800, 36000, 32400], [2000086, 7200, 32400, 36000], [2000303, 10800, 36000, 32400], [2001084, 7200, 32400, 36000], [2001301, 10800, 36000, 32400], [2002090, 7200, 32400, 36000], [2002300, 10800, 36000, 32400], [2003089, 7200, 32400, 36000], [2003299, 10800, 36000, 32400], [2004088, 7200, 32400, 36000], [2004305, 10800, 36000, 32400], [2005086, 7200, 32400, 36000], [2005303, 10800, 36000, 32400], [2006085, 7200, 32400, 36000], [2006302, 10800, 36000, 32400], [2007084, 7200, 32400, 36000], [2007301, 10800, 36000, 32400], [2008090, 7200, 32400, 36000], [2008300, 10800, 36000, 32400], [2009088, 7200, 32400, 36000], [2009298, 10800, 36000, 32400], [2010087, 7200, 32400, 36000], [2010304, 10800, 36000, 32400], [2011086, 7200, 32400, 36000], [2014299, 7200, 36000, 32400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$asits$__f_Asia_Yakutsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asits$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asits$.prototype.constructor = $c_Lzonedb_java_tzdb$asits$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asits$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asits$.prototype = $c_Lzonedb_java_tzdb$asits$.prototype;
$c_Lzonedb_java_tzdb$asits$.prototype.Asia_Novokuznetsk__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 806")
  };
  return this.Lzonedb_java_tzdb$asits$__f_Asia_Novokuznetsk
});
$c_Lzonedb_java_tzdb$asits$.prototype.Asia_Irkutsk__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 807")
  };
  return this.Lzonedb_java_tzdb$asits$__f_Asia_Irkutsk
});
$c_Lzonedb_java_tzdb$asits$.prototype.Asia_Yakutsk__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$asits$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 808")
  };
  return this.Lzonedb_java_tzdb$asits$__f_Asia_Yakutsk
});
var $d_Lzonedb_java_tzdb$asits$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asits$: 0
}, false, "zonedb.java.tzdb$asits$", {
  Lzonedb_java_tzdb$asits$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asits$.prototype.$classData = $d_Lzonedb_java_tzdb$asits$;
var $n_Lzonedb_java_tzdb$asits$;
function $m_Lzonedb_java_tzdb$asits$() {
  if ((!$n_Lzonedb_java_tzdb$asits$)) {
    $n_Lzonedb_java_tzdb$asits$ = new $c_Lzonedb_java_tzdb$asits$()
  };
  return $n_Lzonedb_java_tzdb$asits$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiur$() {
  this.Lzonedb_java_tzdb$asiur$__f_Asia_Yekaterinburg = null;
  this.Lzonedb_java_tzdb$asiur$__f_Asia_Jayapura = null;
  this.Lzonedb_java_tzdb$asiur$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$asiur$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 14553), $ct_T2__O__O__(new $c_T2(), "w", 14553), $ct_T2__O__O__(new $c_T2(), "t", [[1916185, 0, 14553, 13505], [1919196, 14400, 13505, 14400], [1930172, 0, 14400, 18000], [1991090, 7200, 18000, 14400], [1992019, 7200, 14400, 18000], [2011086, 7200, 18000, 21600], [2014299, 7200, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1916185, 0, 14553, 13505], [1919196, 14400, 13505, 14400], [1930172, 0, 14400, 18000], [1981091, 0, 18000, 21600], [1981274, 0, 21600, 18000], [1982091, 0, 18000, 21600], [1982274, 0, 21600, 18000], [1983091, 0, 18000, 21600], [1983274, 0, 21600, 18000], [1984092, 0, 18000, 21600], [1984274, 10800, 21600, 18000], [1985090, 7200, 18000, 21600], [1985272, 10800, 21600, 18000], [1986089, 7200, 18000, 21600], [1986271, 10800, 21600, 18000], [1987088, 7200, 18000, 21600], [1987270, 10800, 21600, 18000], [1988087, 7200, 18000, 21600], [1988269, 10800, 21600, 18000], [1989085, 7200, 18000, 21600], [1989267, 10800, 21600, 18000], [1990084, 7200, 18000, 21600], [1990273, 10800, 21600, 18000], [1991272, 10800, 18000, 14400], [1992019, 7200, 14400, 18000], [1992089, 7200, 18000, 21600], [1992271, 10800, 21600, 18000], [1993087, 7200, 18000, 21600], [1993269, 10800, 21600, 18000], [1994086, 7200, 18000, 21600], [1994268, 10800, 21600, 18000], [1995085, 7200, 18000, 21600], [1995267, 10800, 21600, 18000], [1996091, 7200, 18000, 21600], [1996301, 10800, 21600, 18000], [1997089, 7200, 18000, 21600], [1997299, 10800, 21600, 18000], [1998088, 7200, 18000, 21600], [1998298, 10800, 21600, 18000], [1999087, 7200, 18000, 21600], [1999304, 10800, 21600, 18000], [2000086, 7200, 18000, 21600], [2000303, 10800, 21600, 18000], [2001084, 7200, 18000, 21600], [2001301, 10800, 21600, 18000], [2002090, 7200, 18000, 21600], [2002300, 10800, 21600, 18000], [2003089, 7200, 18000, 21600], [2003299, 10800, 21600, 18000], [2004088, 7200, 18000, 21600], [2004305, 10800, 21600, 18000], [2005086, 7200, 18000, 21600], [2005303, 10800, 21600, 18000], [2006085, 7200, 18000, 21600], [2006302, 10800, 21600, 18000], [2007084, 7200, 18000, 21600], [2007301, 10800, 21600, 18000], [2008090, 7200, 18000, 21600], [2008300, 10800, 21600, 18000], [2009088, 7200, 18000, 21600], [2009298, 10800, 21600, 18000], [2010087, 7200, 18000, 21600], [2010304, 10800, 21600, 18000], [2011086, 7200, 18000, 21600], [2014299, 7200, 21600, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiur$__f_Asia_Yekaterinburg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiur$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$asiur$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 33768), $ct_T2__O__O__(new $c_T2(), "w", 33768), $ct_T2__O__O__(new $c_T2(), "t", [[1932306, 0, 33768, 32400], [1944245, 0, 32400, 34200], [1964001, 0, 34200, 32400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1932306, 0, 33768, 32400], [1944245, 0, 32400, 34200], [1964001, 0, 34200, 32400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$asiur$__f_Asia_Jayapura = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$asiur$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$asiur$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$asiur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiur$.prototype.constructor = $c_Lzonedb_java_tzdb$asiur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiur$.prototype = $c_Lzonedb_java_tzdb$asiur$.prototype;
$c_Lzonedb_java_tzdb$asiur$.prototype.Asia_Yekaterinburg__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$asiur$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 588")
  };
  return this.Lzonedb_java_tzdb$asiur$__f_Asia_Yekaterinburg
});
$c_Lzonedb_java_tzdb$asiur$.prototype.Asia_Jayapura__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$asiur$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 589")
  };
  return this.Lzonedb_java_tzdb$asiur$__f_Asia_Jayapura
});
var $d_Lzonedb_java_tzdb$asiur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiur$: 0
}, false, "zonedb.java.tzdb$asiur$", {
  Lzonedb_java_tzdb$asiur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiur$.prototype.$classData = $d_Lzonedb_java_tzdb$asiur$;
var $n_Lzonedb_java_tzdb$asiur$;
function $m_Lzonedb_java_tzdb$asiur$() {
  if ((!$n_Lzonedb_java_tzdb$asiur$)) {
    $n_Lzonedb_java_tzdb$asiur$ = new $c_Lzonedb_java_tzdb$asiur$()
  };
  return $n_Lzonedb_java_tzdb$asiur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiva$() {
  this.Lzonedb_java_tzdb$asiva$__f_Asia_Yerevan = null;
  this.Lzonedb_java_tzdb$asiva$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiva$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 10680), $ct_T2__O__O__(new $c_T2(), "w", 10680), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 10680, 10800], [1957060, 0, 10800, 14400], [1991090, 7200, 14400, 10800], [1995267, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 10680, 10800], [1957060, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989085, 7200, 14400, 18000], [1989267, 10800, 18000, 14400], [1990084, 7200, 14400, 18000], [1990273, 10800, 18000, 14400], [1991272, 10800, 14400, 10800], [1992089, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1997089, 7200, 14400, 18000], [1997299, 10800, 18000, 14400], [1998088, 7200, 14400, 18000], [1998298, 10800, 18000, 14400], [1999087, 7200, 14400, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000], [2004305, 10800, 18000, 14400], [2005086, 7200, 14400, 18000], [2005303, 10800, 18000, 14400], [2006085, 7200, 14400, 18000], [2006302, 10800, 18000, 14400], [2007084, 7200, 14400, 18000], [2007301, 10800, 18000, 14400], [2008090, 7200, 14400, 18000], [2008300, 10800, 18000, 14400], [2009088, 7200, 14400, 18000], [2009298, 10800, 18000, 14400], [2010087, 7200, 14400, 18000], [2010304, 10800, 18000, 14400], [2011086, 7200, 14400, 18000], [2011303, 10800, 18000, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiva$__f_Asia_Yerevan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiva$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiva$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiva$.prototype.constructor = $c_Lzonedb_java_tzdb$asiva$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiva$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiva$.prototype = $c_Lzonedb_java_tzdb$asiva$.prototype;
$c_Lzonedb_java_tzdb$asiva$.prototype.Asia_Yerevan__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiva$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 536")
  };
  return this.Lzonedb_java_tzdb$asiva$__f_Asia_Yerevan
});
var $d_Lzonedb_java_tzdb$asiva$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiva$: 0
}, false, "zonedb.java.tzdb$asiva$", {
  Lzonedb_java_tzdb$asiva$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiva$.prototype.$classData = $d_Lzonedb_java_tzdb$asiva$;
var $n_Lzonedb_java_tzdb$asiva$;
function $m_Lzonedb_java_tzdb$asiva$() {
  if ((!$n_Lzonedb_java_tzdb$asiva$)) {
    $n_Lzonedb_java_tzdb$asiva$ = new $c_Lzonedb_java_tzdb$asiva$()
  };
  return $n_Lzonedb_java_tzdb$asiva$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$asiyg$() {
  this.Lzonedb_java_tzdb$asiyg$__f_Asia_Khandyga = null;
  this.Lzonedb_java_tzdb$asiyg$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$asiyg$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 32533), $ct_T2__O__O__(new $c_T2(), "w", 32533), $ct_T2__O__O__(new $c_T2(), "t", [[1919349, 0, 32533, 28800], [1930172, 0, 28800, 32400], [1991090, 7200, 32400, 28800], [1992019, 7200, 28800, 32400], [2004001, 0, 32400, 36000], [2011086, 7200, 36000, 39600], [2011256, 0, 39600, 36000], [2014299, 7200, 36000, 32400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919349, 0, 32533, 28800], [1930172, 0, 28800, 32400], [1981091, 0, 32400, 36000], [1981274, 0, 36000, 32400], [1982091, 0, 32400, 36000], [1982274, 0, 36000, 32400], [1983091, 0, 32400, 36000], [1983274, 0, 36000, 32400], [1984092, 0, 32400, 36000], [1984274, 10800, 36000, 32400], [1985090, 7200, 32400, 36000], [1985272, 10800, 36000, 32400], [1986089, 7200, 32400, 36000], [1986271, 10800, 36000, 32400], [1987088, 7200, 32400, 36000], [1987270, 10800, 36000, 32400], [1988087, 7200, 32400, 36000], [1988269, 10800, 36000, 32400], [1989085, 7200, 32400, 36000], [1989267, 10800, 36000, 32400], [1990084, 7200, 32400, 36000], [1990273, 10800, 36000, 32400], [1991272, 10800, 32400, 28800], [1992019, 7200, 28800, 32400], [1992089, 7200, 32400, 36000], [1992271, 10800, 36000, 32400], [1993087, 7200, 32400, 36000], [1993269, 10800, 36000, 32400], [1994086, 7200, 32400, 36000], [1994268, 10800, 36000, 32400], [1995085, 7200, 32400, 36000], [1995267, 10800, 36000, 32400], [1996091, 7200, 32400, 36000], [1996301, 10800, 36000, 32400], [1997089, 7200, 32400, 36000], [1997299, 10800, 36000, 32400], [1998088, 7200, 32400, 36000], [1998298, 10800, 36000, 32400], [1999087, 7200, 32400, 36000], [1999304, 10800, 36000, 32400], [2000086, 7200, 32400, 36000], [2000303, 10800, 36000, 32400], [2001084, 7200, 32400, 36000], [2001301, 10800, 36000, 32400], [2002090, 7200, 32400, 36000], [2002300, 10800, 36000, 32400], [2003089, 7200, 32400, 36000], [2003299, 10800, 36000, 32400], [2004001, 0, 32400, 36000], [2004088, 7200, 36000, 39600], [2004305, 10800, 39600, 36000], [2005086, 7200, 36000, 39600], [2005303, 10800, 39600, 36000], [2006085, 7200, 36000, 39600], [2006302, 10800, 39600, 36000], [2007084, 7200, 36000, 39600], [2007301, 10800, 39600, 36000], [2008090, 7200, 36000, 39600], [2008300, 10800, 39600, 36000], [2009088, 7200, 36000, 39600], [2009298, 10800, 39600, 36000], [2010087, 7200, 36000, 39600], [2010304, 10800, 39600, 36000], [2011086, 7200, 36000, 39600], [2011256, 0, 39600, 36000], [2014299, 7200, 36000, 32400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$asiyg$__f_Asia_Khandyga = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$asiyg$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$asiyg$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$asiyg$.prototype.constructor = $c_Lzonedb_java_tzdb$asiyg$;
/** @constructor */
function $h_Lzonedb_java_tzdb$asiyg$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$asiyg$.prototype = $c_Lzonedb_java_tzdb$asiyg$.prototype;
$c_Lzonedb_java_tzdb$asiyg$.prototype.Asia_Khandyga__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$asiyg$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 820")
  };
  return this.Lzonedb_java_tzdb$asiyg$__f_Asia_Khandyga
});
var $d_Lzonedb_java_tzdb$asiyg$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$asiyg$: 0
}, false, "zonedb.java.tzdb$asiyg$", {
  Lzonedb_java_tzdb$asiyg$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$asiyg$.prototype.$classData = $d_Lzonedb_java_tzdb$asiyg$;
var $n_Lzonedb_java_tzdb$asiyg$;
function $m_Lzonedb_java_tzdb$asiyg$() {
  if ((!$n_Lzonedb_java_tzdb$asiyg$)) {
    $n_Lzonedb_java_tzdb$asiyg$ = new $c_Lzonedb_java_tzdb$asiyg$()
  };
  return $n_Lzonedb_java_tzdb$asiyg$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlar$() {
  this.Lzonedb_java_tzdb$atlar$__f_Atlantic_Canary = null;
  this.Lzonedb_java_tzdb$atlar$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$atlar$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-3696)), $ct_T2__O__O__(new $c_T2(), "w", (-3696)), $ct_T2__O__O__(new $c_T2(), "t", [[1922060, 0, (-3696), (-3600)], [1946273, 3600, (-3600), 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1922060, 0, (-3696), (-3600)], [1946273, 3600, (-3600), 0], [1980097, 0, 0, 3600], [1980272, 7200, 3600, 0], [1981088, 3600, 0, 3600], [1981270, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982269, 7200, 3600, 0], [1983086, 3600, 0, 3600], [1983268, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984274, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985272, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986271, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987270, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988269, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989267, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990273, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991272, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992271, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993269, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994268, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995267, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$atlar$__f_Atlantic_Canary = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$atlar$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$atlar$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlar$.prototype.constructor = $c_Lzonedb_java_tzdb$atlar$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlar$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlar$.prototype = $c_Lzonedb_java_tzdb$atlar$.prototype;
$c_Lzonedb_java_tzdb$atlar$.prototype.Atlantic_Canary__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$atlar$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 448")
  };
  return this.Lzonedb_java_tzdb$atlar$__f_Atlantic_Canary
});
var $d_Lzonedb_java_tzdb$atlar$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlar$: 0
}, false, "zonedb.java.tzdb$atlar$", {
  Lzonedb_java_tzdb$atlar$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlar$.prototype.$classData = $d_Lzonedb_java_tzdb$atlar$;
var $n_Lzonedb_java_tzdb$atlar$;
function $m_Lzonedb_java_tzdb$atlar$() {
  if ((!$n_Lzonedb_java_tzdb$atlar$)) {
    $n_Lzonedb_java_tzdb$atlar$ = new $c_Lzonedb_java_tzdb$atlar$()
  };
  return $n_Lzonedb_java_tzdb$atlar$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlgi$() {
  this.Lzonedb_java_tzdb$atlgi$__f_Atlantic_South_Georgia = null;
  this.Lzonedb_java_tzdb$atlgi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$atlgi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-8768)), $ct_T2__O__O__(new $c_T2(), "w", (-8768)), $ct_T2__O__O__(new $c_T2(), "t", [[1890001, 0, (-8768), (-7200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890001, 0, (-8768), (-7200)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$atlgi$__f_Atlantic_South_Georgia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$atlgi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$atlgi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlgi$.prototype.constructor = $c_Lzonedb_java_tzdb$atlgi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlgi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlgi$.prototype = $c_Lzonedb_java_tzdb$atlgi$.prototype;
$c_Lzonedb_java_tzdb$atlgi$.prototype.Atlantic_South_Georgia__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$atlgi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 107")
  };
  return this.Lzonedb_java_tzdb$atlgi$__f_Atlantic_South_Georgia
});
var $d_Lzonedb_java_tzdb$atlgi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlgi$: 0
}, false, "zonedb.java.tzdb$atlgi$", {
  Lzonedb_java_tzdb$atlgi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlgi$.prototype.$classData = $d_Lzonedb_java_tzdb$atlgi$;
var $n_Lzonedb_java_tzdb$atlgi$;
function $m_Lzonedb_java_tzdb$atlgi$() {
  if ((!$n_Lzonedb_java_tzdb$atlgi$)) {
    $n_Lzonedb_java_tzdb$atlgi$ = new $c_Lzonedb_java_tzdb$atlgi$()
  };
  return $n_Lzonedb_java_tzdb$atlgi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlir$() {
  this.Lzonedb_java_tzdb$atlir$__f_Atlantic_Madeira = null;
  this.Lzonedb_java_tzdb$atlir$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$atlir$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-4056)), $ct_T2__O__O__(new $c_T2(), "w", (-4056)), $ct_T2__O__O__(new $c_T2(), "t", [[1911365, 85944, (-4056), (-3600)], [1966093, 7200, (-3600), 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1911365, 85944, (-4056), (-3600)], [1916169, 82800, (-3600), 0], [1916306, 3600, 0, (-3600)], [1917059, 82800, (-3600), 0], [1917288, 0, 0, (-3600)], [1918060, 82800, (-3600), 0], [1918288, 0, 0, (-3600)], [1919059, 82800, (-3600), 0], [1919288, 0, 0, (-3600)], [1920060, 82800, (-3600), 0], [1920289, 0, 0, (-3600)], [1921059, 82800, (-3600), 0], [1921288, 0, 0, (-3600)], [1924107, 82800, (-3600), 0], [1924289, 0, 0, (-3600)], [1926107, 82800, (-3600), 0], [1926276, 0, 0, (-3600)], [1927099, 82800, (-3600), 0], [1927275, 0, 0, (-3600)], [1928105, 82800, (-3600), 0], [1928281, 0, 0, (-3600)], [1929110, 82800, (-3600), 0], [1929279, 0, 0, (-3600)], [1931108, 82800, (-3600), 0], [1931277, 0, 0, (-3600)], [1932093, 82800, (-3600), 0], [1932276, 0, 0, (-3600)], [1934097, 82800, (-3600), 0], [1934280, 0, 0, (-3600)], [1935089, 82800, (-3600), 0], [1935279, 0, 0, (-3600)], [1936109, 82800, (-3600), 0], [1936278, 0, 0, (-3600)], [1937093, 82800, (-3600), 0], [1937276, 0, 0, (-3600)], [1938085, 82800, (-3600), 0], [1938275, 0, 0, (-3600)], [1939105, 82800, (-3600), 0], [1939323, 0, 0, (-3600)], [1940055, 82800, (-3600), 0], [1940280, 0, 0, (-3600)], [1941095, 82800, (-3600), 0], [1941279, 0, 0, (-3600)], [1942073, 82800, (-3600), 0], [1942115, 82800, 0, 3600], [1942228, 0, 3600, 0], [1942298, 0, 0, (-3600)], [1943072, 82800, (-3600), 0], [1943107, 82800, 0, 3600], [1943241, 0, 3600, 0], [1943304, 0, 0, (-3600)], [1944071, 82800, (-3600), 0], [1944113, 82800, 0, 3600], [1944240, 0, 3600, 0], [1944303, 0, 0, (-3600)], [1945069, 82800, (-3600), 0], [1945111, 82800, 0, 3600], [1945238, 0, 3600, 0], [1945301, 0, 0, (-3600)], [1946096, 82800, (-3600), 0], [1946279, 0, 0, (-3600)], [1947096, 7200, (-3600), 0], [1947278, 10800, 0, (-3600)], [1948095, 7200, (-3600), 0], [1948277, 10800, 0, (-3600)], [1949093, 7200, (-3600), 0], [1949275, 10800, 0, (-3600)], [1951091, 7200, (-3600), 0], [1951280, 10800, 0, (-3600)], [1952097, 7200, (-3600), 0], [1952279, 10800, 0, (-3600)], [1953095, 7200, (-3600), 0], [1953277, 10800, 0, (-3600)], [1954094, 7200, (-3600), 0], [1954276, 10800, 0, (-3600)], [1955093, 7200, (-3600), 0], [1955275, 10800, 0, (-3600)], [1956092, 7200, (-3600), 0], [1956281, 10800, 0, (-3600)], [1957097, 7200, (-3600), 0], [1957279, 10800, 0, (-3600)], [1958096, 7200, (-3600), 0], [1958278, 10800, 0, (-3600)], [1959095, 7200, (-3600), 0], [1959277, 10800, 0, (-3600)], [1960094, 7200, (-3600), 0], [1960276, 10800, 0, (-3600)], [1961092, 7200, (-3600), 0], [1961274, 10800, 0, (-3600)], [1962091, 7200, (-3600), 0], [1962280, 10800, 0, (-3600)], [1963097, 7200, (-3600), 0], [1963279, 10800, 0, (-3600)], [1964096, 7200, (-3600), 0], [1964278, 10800, 0, (-3600)], [1965094, 7200, (-3600), 0], [1965276, 10800, 0, (-3600)], [1966093, 7200, (-3600), 0], [1977086, 0, 0, 3600], [1977268, 3600, 3600, 0], [1978092, 0, 0, 3600], [1978274, 3600, 3600, 0], [1979091, 0, 0, 3600], [1979273, 7200, 3600, 0], [1980090, 0, 0, 3600], [1980272, 7200, 3600, 0], [1981088, 3600, 0, 3600], [1981270, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982269, 7200, 3600, 0], [1983086, 7200, 0, 3600], [1983268, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984274, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985272, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986271, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987270, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988269, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989267, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990273, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991272, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992271, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993269, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994268, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995267, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$atlir$__f_Atlantic_Madeira = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$atlir$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$atlir$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlir$.prototype.constructor = $c_Lzonedb_java_tzdb$atlir$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlir$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlir$.prototype = $c_Lzonedb_java_tzdb$atlir$.prototype;
$c_Lzonedb_java_tzdb$atlir$.prototype.Atlantic_Madeira__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$atlir$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 707")
  };
  return this.Lzonedb_java_tzdb$atlir$__f_Atlantic_Madeira
});
var $d_Lzonedb_java_tzdb$atlir$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlir$: 0
}, false, "zonedb.java.tzdb$atlir$", {
  Lzonedb_java_tzdb$atlir$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlir$.prototype.$classData = $d_Lzonedb_java_tzdb$atlir$;
var $n_Lzonedb_java_tzdb$atlir$;
function $m_Lzonedb_java_tzdb$atlir$() {
  if ((!$n_Lzonedb_java_tzdb$atlir$)) {
    $n_Lzonedb_java_tzdb$atlir$ = new $c_Lzonedb_java_tzdb$atlir$()
  };
  return $n_Lzonedb_java_tzdb$atlir$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlle$() {
  this.Lzonedb_java_tzdb$atlle$__f_Atlantic_Stanley = null;
  this.Lzonedb_java_tzdb$atlle$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$atlle$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-13884)), $ct_T2__O__O__(new $c_T2(), "w", (-13884)), $ct_T2__O__O__(new $c_T2(), "t", [[1912072, 0, (-13884), (-14400)], [1983121, 0, (-14400), (-10800)], [1985258, 0, (-10800), (-14400)], [2010248, 7200, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912072, 0, (-13884), (-14400)], [1937269, 0, (-14400), (-10800)], [1938079, 0, (-10800), (-14400)], [1938268, 0, (-14400), (-10800)], [1939078, 0, (-10800), (-14400)], [1939274, 0, (-14400), (-10800)], [1940084, 0, (-10800), (-14400)], [1940273, 0, (-14400), (-10800)], [1941082, 0, (-10800), (-14400)], [1941271, 0, (-14400), (-10800)], [1942081, 0, (-10800), (-14400)], [1942270, 0, (-14400), (-10800)], [1943001, 0, (-10800), (-14400)], [1983121, 0, (-14400), (-10800)], [1983268, 0, (-10800), (-7200)], [1984120, 0, (-7200), (-10800)], [1984260, 0, (-10800), (-7200)], [1985118, 0, (-7200), (-10800)], [1986110, 0, (-10800), (-14400)], [1986257, 0, (-14400), (-10800)], [1987109, 0, (-10800), (-14400)], [1987256, 0, (-14400), (-10800)], [1988108, 0, (-10800), (-14400)], [1988255, 0, (-14400), (-10800)], [1989106, 0, (-10800), (-14400)], [1989253, 0, (-14400), (-10800)], [1990112, 0, (-10800), (-14400)], [1990252, 0, (-14400), (-10800)], [1991111, 0, (-10800), (-14400)], [1991258, 0, (-14400), (-10800)], [1992110, 0, (-10800), (-14400)], [1992257, 0, (-14400), (-10800)], [1993108, 0, (-10800), (-14400)], [1993255, 0, (-14400), (-10800)], [1994107, 0, (-10800), (-14400)], [1994254, 0, (-14400), (-10800)], [1995106, 0, (-10800), (-14400)], [1995253, 0, (-14400), (-10800)], [1996112, 0, (-10800), (-14400)], [1996259, 0, (-14400), (-10800)], [1997110, 0, (-10800), (-14400)], [1997257, 0, (-14400), (-10800)], [1998109, 0, (-10800), (-14400)], [1998256, 0, (-14400), (-10800)], [1999108, 0, (-10800), (-14400)], [1999255, 0, (-14400), (-10800)], [2000107, 0, (-10800), (-14400)], [2000254, 0, (-14400), (-10800)], [2001105, 7200, (-10800), (-14400)], [2001245, 7200, (-14400), (-10800)], [2002111, 7200, (-10800), (-14400)], [2002244, 7200, (-14400), (-10800)], [2003110, 7200, (-10800), (-14400)], [2003250, 7200, (-14400), (-10800)], [2004109, 7200, (-10800), (-14400)], [2004249, 7200, (-14400), (-10800)], [2005107, 7200, (-10800), (-14400)], [2005247, 7200, (-14400), (-10800)], [2006106, 7200, (-10800), (-14400)], [2006246, 7200, (-14400), (-10800)], [2007105, 7200, (-10800), (-14400)], [2007245, 7200, (-14400), (-10800)], [2008111, 7200, (-10800), (-14400)], [2008251, 7200, (-14400), (-10800)], [2009109, 7200, (-10800), (-14400)], [2009249, 7200, (-14400), (-10800)], [2010108, 7200, (-10800), (-14400)], [2010248, 7200, (-14400), (-10800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$atlle$__f_Atlantic_Stanley = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$atlle$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$atlle$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlle$.prototype.constructor = $c_Lzonedb_java_tzdb$atlle$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlle$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlle$.prototype = $c_Lzonedb_java_tzdb$atlle$.prototype;
$c_Lzonedb_java_tzdb$atlle$.prototype.Atlantic_Stanley__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$atlle$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 850")
  };
  return this.Lzonedb_java_tzdb$atlle$__f_Atlantic_Stanley
});
var $d_Lzonedb_java_tzdb$atlle$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlle$: 0
}, false, "zonedb.java.tzdb$atlle$", {
  Lzonedb_java_tzdb$atlle$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlle$.prototype.$classData = $d_Lzonedb_java_tzdb$atlle$;
var $n_Lzonedb_java_tzdb$atlle$;
function $m_Lzonedb_java_tzdb$atlle$() {
  if ((!$n_Lzonedb_java_tzdb$atlle$)) {
    $n_Lzonedb_java_tzdb$atlle$ = new $c_Lzonedb_java_tzdb$atlle$()
  };
  return $n_Lzonedb_java_tzdb$atlle$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlrd$() {
  this.Lzonedb_java_tzdb$atlrd$__f_Atlantic_Cape_Verde = null;
  this.Lzonedb_java_tzdb$atlrd$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$atlrd$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-5644)), $ct_T2__O__O__(new $c_T2(), "w", (-5644)), $ct_T2__O__O__(new $c_T2(), "t", [[1912001, 1556, (-5644), (-7200)], [1975329, 7200, (-7200), (-3600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912001, 1556, (-5644), (-7200)], [1942244, 0, (-7200), (-3600)], [1945288, 0, (-3600), (-7200)], [1975329, 7200, (-7200), (-3600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$atlrd$__f_Atlantic_Cape_Verde = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$atlrd$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$atlrd$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlrd$.prototype.constructor = $c_Lzonedb_java_tzdb$atlrd$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlrd$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlrd$.prototype = $c_Lzonedb_java_tzdb$atlrd$.prototype;
$c_Lzonedb_java_tzdb$atlrd$.prototype.Atlantic_Cape_Verde__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$atlrd$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 518")
  };
  return this.Lzonedb_java_tzdb$atlrd$__f_Atlantic_Cape_Verde
});
var $d_Lzonedb_java_tzdb$atlrd$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlrd$: 0
}, false, "zonedb.java.tzdb$atlrd$", {
  Lzonedb_java_tzdb$atlrd$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlrd$.prototype.$classData = $d_Lzonedb_java_tzdb$atlrd$;
var $n_Lzonedb_java_tzdb$atlrd$;
function $m_Lzonedb_java_tzdb$atlrd$() {
  if ((!$n_Lzonedb_java_tzdb$atlrd$)) {
    $n_Lzonedb_java_tzdb$atlrd$ = new $c_Lzonedb_java_tzdb$atlrd$()
  };
  return $n_Lzonedb_java_tzdb$atlrd$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlre$() {
  this.Lzonedb_java_tzdb$atlre$__f_Atlantic_Azores = null;
  this.Lzonedb_java_tzdb$atlre$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$atlre$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-6160)), $ct_T2__O__O__(new $c_T2(), "w", (-6160)), $ct_T2__O__O__(new $c_T2(), "t", [[1884001, 0, (-6160), (-6872)], [1912001, 328, (-6872), (-7200)], [1966093, 7200, (-7200), (-3600)], [1992271, 3600, (-3600), 0], [1993087, 3600, 0, (-3600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1884001, 0, (-6160), (-6872)], [1912001, 328, (-6872), (-7200)], [1916169, 82800, (-7200), (-3600)], [1916306, 3600, (-3600), (-7200)], [1917059, 82800, (-7200), (-3600)], [1917288, 0, (-3600), (-7200)], [1918060, 82800, (-7200), (-3600)], [1918288, 0, (-3600), (-7200)], [1919059, 82800, (-7200), (-3600)], [1919288, 0, (-3600), (-7200)], [1920060, 82800, (-7200), (-3600)], [1920289, 0, (-3600), (-7200)], [1921059, 82800, (-7200), (-3600)], [1921288, 0, (-3600), (-7200)], [1924107, 82800, (-7200), (-3600)], [1924289, 0, (-3600), (-7200)], [1926107, 82800, (-7200), (-3600)], [1926276, 0, (-3600), (-7200)], [1927099, 82800, (-7200), (-3600)], [1927275, 0, (-3600), (-7200)], [1928105, 82800, (-7200), (-3600)], [1928281, 0, (-3600), (-7200)], [1929110, 82800, (-7200), (-3600)], [1929279, 0, (-3600), (-7200)], [1931108, 82800, (-7200), (-3600)], [1931277, 0, (-3600), (-7200)], [1932093, 82800, (-7200), (-3600)], [1932276, 0, (-3600), (-7200)], [1934097, 82800, (-7200), (-3600)], [1934280, 0, (-3600), (-7200)], [1935089, 82800, (-7200), (-3600)], [1935279, 0, (-3600), (-7200)], [1936109, 82800, (-7200), (-3600)], [1936278, 0, (-3600), (-7200)], [1937093, 82800, (-7200), (-3600)], [1937276, 0, (-3600), (-7200)], [1938085, 82800, (-7200), (-3600)], [1938275, 0, (-3600), (-7200)], [1939105, 82800, (-7200), (-3600)], [1939323, 0, (-3600), (-7200)], [1940055, 82800, (-7200), (-3600)], [1940280, 0, (-3600), (-7200)], [1941095, 82800, (-7200), (-3600)], [1941279, 0, (-3600), (-7200)], [1942073, 82800, (-7200), (-3600)], [1942115, 82800, (-3600), 0], [1942228, 0, 0, (-3600)], [1942298, 0, (-3600), (-7200)], [1943072, 82800, (-7200), (-3600)], [1943107, 82800, (-3600), 0], [1943241, 0, 0, (-3600)], [1943304, 0, (-3600), (-7200)], [1944071, 82800, (-7200), (-3600)], [1944113, 82800, (-3600), 0], [1944240, 0, 0, (-3600)], [1944303, 0, (-3600), (-7200)], [1945069, 82800, (-7200), (-3600)], [1945111, 82800, (-3600), 0], [1945238, 0, 0, (-3600)], [1945301, 0, (-3600), (-7200)], [1946096, 82800, (-7200), (-3600)], [1946279, 0, (-3600), (-7200)], [1947096, 7200, (-7200), (-3600)], [1947278, 10800, (-3600), (-7200)], [1948095, 7200, (-7200), (-3600)], [1948277, 10800, (-3600), (-7200)], [1949093, 7200, (-7200), (-3600)], [1949275, 10800, (-3600), (-7200)], [1951091, 7200, (-7200), (-3600)], [1951280, 10800, (-3600), (-7200)], [1952097, 7200, (-7200), (-3600)], [1952279, 10800, (-3600), (-7200)], [1953095, 7200, (-7200), (-3600)], [1953277, 10800, (-3600), (-7200)], [1954094, 7200, (-7200), (-3600)], [1954276, 10800, (-3600), (-7200)], [1955093, 7200, (-7200), (-3600)], [1955275, 10800, (-3600), (-7200)], [1956092, 7200, (-7200), (-3600)], [1956281, 10800, (-3600), (-7200)], [1957097, 7200, (-7200), (-3600)], [1957279, 10800, (-3600), (-7200)], [1958096, 7200, (-7200), (-3600)], [1958278, 10800, (-3600), (-7200)], [1959095, 7200, (-7200), (-3600)], [1959277, 10800, (-3600), (-7200)], [1960094, 7200, (-7200), (-3600)], [1960276, 10800, (-3600), (-7200)], [1961092, 7200, (-7200), (-3600)], [1961274, 10800, (-3600), (-7200)], [1962091, 7200, (-7200), (-3600)], [1962280, 10800, (-3600), (-7200)], [1963097, 7200, (-7200), (-3600)], [1963279, 10800, (-3600), (-7200)], [1964096, 7200, (-7200), (-3600)], [1964278, 10800, (-3600), (-7200)], [1965094, 7200, (-7200), (-3600)], [1965276, 10800, (-3600), (-7200)], [1966093, 7200, (-7200), (-3600)], [1977086, 0, (-3600), 0], [1977268, 3600, 0, (-3600)], [1978092, 0, (-3600), 0], [1978274, 3600, 0, (-3600)], [1979091, 0, (-3600), 0], [1979273, 7200, 0, (-3600)], [1980090, 0, (-3600), 0], [1980272, 7200, 0, (-3600)], [1981088, 3600, (-3600), 0], [1981270, 7200, 0, (-3600)], [1982087, 3600, (-3600), 0], [1982269, 7200, 0, (-3600)], [1983086, 7200, (-3600), 0], [1983268, 7200, 0, (-3600)], [1984085, 3600, (-3600), 0], [1984274, 7200, 0, (-3600)], [1985090, 3600, (-3600), 0], [1985272, 7200, 0, (-3600)], [1986089, 3600, (-3600), 0], [1986271, 7200, 0, (-3600)], [1987088, 3600, (-3600), 0], [1987270, 7200, 0, (-3600)], [1988087, 3600, (-3600), 0], [1988269, 7200, 0, (-3600)], [1989085, 3600, (-3600), 0], [1989267, 7200, 0, (-3600)], [1990084, 3600, (-3600), 0], [1990273, 7200, 0, (-3600)], [1991090, 3600, (-3600), 0], [1991272, 7200, 0, (-3600)], [1992089, 3600, (-3600), 0], [1993269, 3600, 0, (-3600)], [1994086, 0, (-3600), 0], [1994268, 3600, 0, (-3600)], [1995085, 0, (-3600), 0], [1995267, 3600, 0, (-3600)], [1996091, 0, (-3600), 0], [1996301, 3600, 0, (-3600)], [1997089, 0, (-3600), 0], [1997299, 3600, 0, (-3600)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, (-3600), (-3600), 0], [10, 25, 7, 3600, 0, 0, (-3600), 0, (-3600)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$atlre$__f_Atlantic_Azores = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$atlre$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$atlre$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlre$.prototype.constructor = $c_Lzonedb_java_tzdb$atlre$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlre$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlre$.prototype = $c_Lzonedb_java_tzdb$atlre$.prototype;
$c_Lzonedb_java_tzdb$atlre$.prototype.Atlantic_Azores__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$atlre$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 480")
  };
  return this.Lzonedb_java_tzdb$atlre$__f_Atlantic_Azores
});
var $d_Lzonedb_java_tzdb$atlre$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlre$: 0
}, false, "zonedb.java.tzdb$atlre$", {
  Lzonedb_java_tzdb$atlre$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlre$.prototype.$classData = $d_Lzonedb_java_tzdb$atlre$;
var $n_Lzonedb_java_tzdb$atlre$;
function $m_Lzonedb_java_tzdb$atlre$() {
  if ((!$n_Lzonedb_java_tzdb$atlre$)) {
    $n_Lzonedb_java_tzdb$atlre$ = new $c_Lzonedb_java_tzdb$atlre$()
  };
  return $n_Lzonedb_java_tzdb$atlre$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlro$() {
  this.Lzonedb_java_tzdb$atlro$__f_Atlantic_Faroe = null;
  this.Lzonedb_java_tzdb$atlro$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$atlro$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-1624)), $ct_T2__O__O__(new $c_T2(), "w", (-1624)), $ct_T2__O__O__(new $c_T2(), "t", [[1908011, 0, (-1624), 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1908011, 0, (-1624), 0], [1981088, 3600, 0, 3600], [1981270, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982269, 7200, 3600, 0], [1983086, 3600, 0, 3600], [1983268, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984274, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985272, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986271, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987270, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988269, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989267, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990273, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991272, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992271, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993269, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994268, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995267, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$atlro$__f_Atlantic_Faroe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$atlro$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$atlro$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlro$.prototype.constructor = $c_Lzonedb_java_tzdb$atlro$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlro$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlro$.prototype = $c_Lzonedb_java_tzdb$atlro$.prototype;
$c_Lzonedb_java_tzdb$atlro$.prototype.Atlantic_Faroe__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$atlro$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 62")
  };
  return this.Lzonedb_java_tzdb$atlro$__f_Atlantic_Faroe
});
var $d_Lzonedb_java_tzdb$atlro$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlro$: 0
}, false, "zonedb.java.tzdb$atlro$", {
  Lzonedb_java_tzdb$atlro$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlro$.prototype.$classData = $d_Lzonedb_java_tzdb$atlro$;
var $n_Lzonedb_java_tzdb$atlro$;
function $m_Lzonedb_java_tzdb$atlro$() {
  if ((!$n_Lzonedb_java_tzdb$atlro$)) {
    $n_Lzonedb_java_tzdb$atlro$ = new $c_Lzonedb_java_tzdb$atlro$()
  };
  return $n_Lzonedb_java_tzdb$atlro$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlud$() {
  this.Lzonedb_java_tzdb$atlud$__f_Atlantic_Bermuda = null;
  this.Lzonedb_java_tzdb$atlud$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$atlud$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-15558)), $ct_T2__O__O__(new $c_T2(), "w", (-15558)), $ct_T2__O__O__(new $c_T2(), "t", [[1930001, 7200, (-15558), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1930001, 7200, (-15558), (-14400)], [1974118, 7200, (-14400), (-10800)], [1974300, 7200, (-10800), (-14400)], [1975117, 7200, (-14400), (-10800)], [1975299, 7200, (-10800), (-14400)], [1976116, 7200, (-14400), (-10800)], [1976305, 7200, (-10800), (-14400)], [1977114, 7200, (-14400), (-10800)], [1977303, 7200, (-10800), (-14400)], [1978120, 7200, (-14400), (-10800)], [1978302, 7200, (-10800), (-14400)], [1979119, 7200, (-14400), (-10800)], [1979301, 7200, (-10800), (-14400)], [1980118, 7200, (-14400), (-10800)], [1980300, 7200, (-10800), (-14400)], [1981116, 7200, (-14400), (-10800)], [1981298, 7200, (-10800), (-14400)], [1982115, 7200, (-14400), (-10800)], [1982304, 7200, (-10800), (-14400)], [1983114, 7200, (-14400), (-10800)], [1983303, 7200, (-10800), (-14400)], [1984120, 7200, (-14400), (-10800)], [1984302, 7200, (-10800), (-14400)], [1985118, 7200, (-14400), (-10800)], [1985300, 7200, (-10800), (-14400)], [1986117, 7200, (-14400), (-10800)], [1986299, 7200, (-10800), (-14400)], [1987095, 7200, (-14400), (-10800)], [1987298, 7200, (-10800), (-14400)], [1988094, 7200, (-14400), (-10800)], [1988304, 7200, (-10800), (-14400)], [1989092, 7200, (-14400), (-10800)], [1989302, 7200, (-10800), (-14400)], [1990091, 7200, (-14400), (-10800)], [1990301, 7200, (-10800), (-14400)], [1991097, 7200, (-14400), (-10800)], [1991300, 7200, (-10800), (-14400)], [1992096, 7200, (-14400), (-10800)], [1992299, 7200, (-10800), (-14400)], [1993094, 7200, (-14400), (-10800)], [1993304, 7200, (-10800), (-14400)], [1994093, 7200, (-14400), (-10800)], [1994303, 7200, (-10800), (-14400)], [1995092, 7200, (-14400), (-10800)], [1995302, 7200, (-10800), (-14400)], [1996098, 7200, (-14400), (-10800)], [1996301, 7200, (-10800), (-14400)], [1997096, 7200, (-14400), (-10800)], [1997299, 7200, (-10800), (-14400)], [1998095, 7200, (-14400), (-10800)], [1998298, 7200, (-10800), (-14400)], [1999094, 7200, (-14400), (-10800)], [1999304, 7200, (-10800), (-14400)], [2000093, 7200, (-14400), (-10800)], [2000303, 7200, (-10800), (-14400)], [2001091, 7200, (-14400), (-10800)], [2001301, 7200, (-10800), (-14400)], [2002097, 7200, (-14400), (-10800)], [2002300, 7200, (-10800), (-14400)], [2003096, 7200, (-14400), (-10800)], [2003299, 7200, (-10800), (-14400)], [2004095, 7200, (-14400), (-10800)], [2004305, 7200, (-10800), (-14400)], [2005093, 7200, (-14400), (-10800)], [2005303, 7200, (-10800), (-14400)], [2006092, 7200, (-14400), (-10800)], [2006302, 7200, (-10800), (-14400)], [2007070, 7200, (-14400), (-10800)], [2007308, 7200, (-10800), (-14400)], [2008069, 7200, (-14400), (-10800)], [2008307, 7200, (-10800), (-14400)]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 8, 7, 7200, 0, 1, (-14400), (-14400), (-10800)], [11, 1, 7, 7200, 0, 1, (-14400), (-10800), (-14400)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$atlud$__f_Atlantic_Bermuda = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$atlud$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$atlud$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlud$.prototype.constructor = $c_Lzonedb_java_tzdb$atlud$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlud$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlud$.prototype = $c_Lzonedb_java_tzdb$atlud$.prototype;
$c_Lzonedb_java_tzdb$atlud$.prototype.Atlantic_Bermuda__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$atlud$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 464")
  };
  return this.Lzonedb_java_tzdb$atlud$__f_Atlantic_Bermuda
});
var $d_Lzonedb_java_tzdb$atlud$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlud$: 0
}, false, "zonedb.java.tzdb$atlud$", {
  Lzonedb_java_tzdb$atlud$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlud$.prototype.$classData = $d_Lzonedb_java_tzdb$atlud$;
var $n_Lzonedb_java_tzdb$atlud$;
function $m_Lzonedb_java_tzdb$atlud$() {
  if ((!$n_Lzonedb_java_tzdb$atlud$)) {
    $n_Lzonedb_java_tzdb$atlud$ = new $c_Lzonedb_java_tzdb$atlud$()
  };
  return $n_Lzonedb_java_tzdb$atlud$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$atlvi$() {
  this.Lzonedb_java_tzdb$atlvi$__f_Atlantic_Reykjavik = null;
  this.Lzonedb_java_tzdb$atlvi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$atlvi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-5280)), $ct_T2__O__O__(new $c_T2(), "w", (-5280)), $ct_T2__O__O__(new $c_T2(), "t", [[1908001, 0, (-5280), (-3600)], [1968098, 3600, (-3600), 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1908001, 0, (-5280), (-3600)], [1917050, 82800, (-3600), 0], [1917294, 3600, 0, (-3600)], [1918050, 82800, (-3600), 0], [1918320, 3600, 0, (-3600)], [1919050, 82800, (-3600), 0], [1919320, 3600, 0, (-3600)], [1921078, 82800, (-3600), 0], [1921174, 3600, 0, (-3600)], [1939119, 82800, (-3600), 0], [1939302, 7200, 0, (-3600)], [1940056, 7200, (-3600), 0], [1940308, 7200, 0, (-3600)], [1941061, 3600, (-3600), 0], [1941306, 7200, 0, (-3600)], [1942067, 3600, (-3600), 0], [1942298, 7200, 0, (-3600)], [1943066, 3600, (-3600), 0], [1943297, 7200, 0, (-3600)], [1944065, 3600, (-3600), 0], [1944296, 7200, 0, (-3600)], [1945063, 3600, (-3600), 0], [1945301, 7200, 0, (-3600)], [1946062, 3600, (-3600), 0], [1946300, 7200, 0, (-3600)], [1947096, 3600, (-3600), 0], [1947299, 7200, 0, (-3600)], [1948095, 3600, (-3600), 0], [1948298, 7200, 0, (-3600)], [1949093, 3600, (-3600), 0], [1949303, 7200, 0, (-3600)], [1950092, 3600, (-3600), 0], [1950295, 7200, 0, (-3600)], [1951091, 3600, (-3600), 0], [1951301, 7200, 0, (-3600)], [1952097, 3600, (-3600), 0], [1952300, 7200, 0, (-3600)], [1953095, 3600, (-3600), 0], [1953298, 7200, 0, (-3600)], [1954094, 3600, (-3600), 0], [1954297, 7200, 0, (-3600)], [1955093, 3600, (-3600), 0], [1955296, 7200, 0, (-3600)], [1956092, 3600, (-3600), 0], [1956302, 7200, 0, (-3600)], [1957097, 3600, (-3600), 0], [1957300, 7200, 0, (-3600)], [1958096, 3600, (-3600), 0], [1958299, 7200, 0, (-3600)], [1959095, 3600, (-3600), 0], [1959298, 7200, 0, (-3600)], [1960094, 3600, (-3600), 0], [1960297, 7200, 0, (-3600)], [1961092, 3600, (-3600), 0], [1961295, 7200, 0, (-3600)], [1962091, 3600, (-3600), 0], [1962301, 7200, 0, (-3600)], [1963097, 3600, (-3600), 0], [1963300, 7200, 0, (-3600)], [1964096, 3600, (-3600), 0], [1964299, 7200, 0, (-3600)], [1965094, 3600, (-3600), 0], [1965297, 7200, 0, (-3600)], [1966093, 3600, (-3600), 0], [1966296, 7200, 0, (-3600)], [1967092, 3600, (-3600), 0], [1967302, 7200, 0, (-3600)], [1968098, 3600, (-3600), 0]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$atlvi$__f_Atlantic_Reykjavik = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$atlvi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$atlvi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$atlvi$.prototype.constructor = $c_Lzonedb_java_tzdb$atlvi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$atlvi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$atlvi$.prototype = $c_Lzonedb_java_tzdb$atlvi$.prototype;
$c_Lzonedb_java_tzdb$atlvi$.prototype.Atlantic_Reykjavik__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$atlvi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 497")
  };
  return this.Lzonedb_java_tzdb$atlvi$__f_Atlantic_Reykjavik
});
var $d_Lzonedb_java_tzdb$atlvi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$atlvi$: 0
}, false, "zonedb.java.tzdb$atlvi$", {
  Lzonedb_java_tzdb$atlvi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$atlvi$.prototype.$classData = $d_Lzonedb_java_tzdb$atlvi$;
var $n_Lzonedb_java_tzdb$atlvi$;
function $m_Lzonedb_java_tzdb$atlvi$() {
  if ((!$n_Lzonedb_java_tzdb$atlvi$)) {
    $n_Lzonedb_java_tzdb$atlvi$ = new $c_Lzonedb_java_tzdb$atlvi$()
  };
  return $n_Lzonedb_java_tzdb$atlvi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausan$() {
  this.Lzonedb_java_tzdb$ausan$__f_Australia_Brisbane = null;
  this.Lzonedb_java_tzdb$ausan$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausan$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 36728), $ct_T2__O__O__(new $c_T2(), "w", 36728), $ct_T2__O__O__(new $c_T2(), "t", [[1895001, 0, 36728, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895001, 0, 36728, 36000], [1917001, 60, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990063, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991062, 10800, 39600, 36000], [1991300, 7200, 36000, 39600], [1992061, 10800, 39600, 36000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausan$__f_Australia_Brisbane = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausan$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausan$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausan$.prototype.constructor = $c_Lzonedb_java_tzdb$ausan$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausan$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausan$.prototype = $c_Lzonedb_java_tzdb$ausan$.prototype;
$c_Lzonedb_java_tzdb$ausan$.prototype.Australia_Brisbane__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausan$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 786")
  };
  return this.Lzonedb_java_tzdb$ausan$__f_Australia_Brisbane
});
var $d_Lzonedb_java_tzdb$ausan$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausan$: 0
}, false, "zonedb.java.tzdb$ausan$", {
  Lzonedb_java_tzdb$ausan$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausan$.prototype.$classData = $d_Lzonedb_java_tzdb$ausan$;
var $n_Lzonedb_java_tzdb$ausan$;
function $m_Lzonedb_java_tzdb$ausan$() {
  if ((!$n_Lzonedb_java_tzdb$ausan$)) {
    $n_Lzonedb_java_tzdb$ausan$ = new $c_Lzonedb_java_tzdb$ausan$()
  };
  return $n_Lzonedb_java_tzdb$ausan$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausar$() {
  this.Lzonedb_java_tzdb$ausar$__f_Australia_Hobart = null;
  this.Lzonedb_java_tzdb$ausar$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausar$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 35356), $ct_T2__O__O__(new $c_T2(), "w", 35356), $ct_T2__O__O__(new $c_T2(), "t", [[1895244, 0, 35356, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895244, 0, 35356, 36000], [1916275, 7200, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1967274, 7200, 36000, 39600], [1968091, 10800, 39600, 36000], [1968301, 7200, 36000, 39600], [1969068, 10800, 39600, 36000], [1969299, 7200, 36000, 39600], [1970067, 10800, 39600, 36000], [1970298, 7200, 36000, 39600], [1971073, 10800, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982087, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983086, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986061, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987298, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990077, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991090, 10800, 39600, 36000], [1991279, 7200, 36000, 39600], [1992089, 10800, 39600, 36000], [1992278, 7200, 36000, 39600], [1993087, 10800, 39600, 36000], [1993276, 7200, 36000, 39600], [1994086, 10800, 39600, 36000], [1994275, 7200, 36000, 39600], [1995085, 10800, 39600, 36000], [1995274, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996280, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997278, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998277, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999276, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001280, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002279, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003278, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004277, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005275, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006274, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007280, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 2, 36000, 39600, 36000], [10, 1, 7, 7200, 0, 2, 36000, 36000, 39600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausar$__f_Australia_Hobart = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausar$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausar$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausar$.prototype.constructor = $c_Lzonedb_java_tzdb$ausar$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausar$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausar$.prototype = $c_Lzonedb_java_tzdb$ausar$.prototype;
$c_Lzonedb_java_tzdb$ausar$.prototype.Australia_Hobart__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausar$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 614")
  };
  return this.Lzonedb_java_tzdb$ausar$__f_Australia_Hobart
});
var $d_Lzonedb_java_tzdb$ausar$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausar$: 0
}, false, "zonedb.java.tzdb$ausar$", {
  Lzonedb_java_tzdb$ausar$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausar$.prototype.$classData = $d_Lzonedb_java_tzdb$ausar$;
var $n_Lzonedb_java_tzdb$ausar$;
function $m_Lzonedb_java_tzdb$ausar$() {
  if ((!$n_Lzonedb_java_tzdb$ausar$)) {
    $n_Lzonedb_java_tzdb$ausar$ = new $c_Lzonedb_java_tzdb$ausar$()
  };
  return $n_Lzonedb_java_tzdb$ausar$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$auscl$() {
  this.Lzonedb_java_tzdb$auscl$__f_Australia_Eucla = null;
  this.Lzonedb_java_tzdb$auscl$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$auscl$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 30928), $ct_T2__O__O__(new $c_T2(), "w", 30928), $ct_T2__O__O__(new $c_T2(), "t", [[1895335, 0, 30928, 31500]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895335, 0, 30928, 31500], [1917001, 60, 31500, 35100], [1917084, 7200, 35100, 31500], [1942001, 7200, 31500, 35100], [1942088, 7200, 35100, 31500], [1942270, 7200, 31500, 35100], [1943087, 7200, 35100, 31500], [1974300, 7200, 31500, 35100], [1975061, 10800, 35100, 31500], [1983303, 7200, 31500, 35100], [1984064, 10800, 35100, 31500], [1991321, 7200, 31500, 35100], [1992061, 10800, 35100, 31500], [2006337, 7200, 31500, 35100], [2007084, 10800, 35100, 31500], [2007301, 7200, 31500, 35100], [2008090, 10800, 35100, 31500], [2008300, 7200, 31500, 35100], [2009088, 10800, 35100, 31500]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$auscl$__f_Australia_Eucla = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$auscl$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$auscl$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$auscl$.prototype.constructor = $c_Lzonedb_java_tzdb$auscl$;
/** @constructor */
function $h_Lzonedb_java_tzdb$auscl$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$auscl$.prototype = $c_Lzonedb_java_tzdb$auscl$.prototype;
$c_Lzonedb_java_tzdb$auscl$.prototype.Australia_Eucla__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$auscl$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 635")
  };
  return this.Lzonedb_java_tzdb$auscl$__f_Australia_Eucla
});
var $d_Lzonedb_java_tzdb$auscl$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$auscl$: 0
}, false, "zonedb.java.tzdb$auscl$", {
  Lzonedb_java_tzdb$auscl$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$auscl$.prototype.$classData = $d_Lzonedb_java_tzdb$auscl$;
var $n_Lzonedb_java_tzdb$auscl$;
function $m_Lzonedb_java_tzdb$auscl$() {
  if ((!$n_Lzonedb_java_tzdb$auscl$)) {
    $n_Lzonedb_java_tzdb$auscl$ = new $c_Lzonedb_java_tzdb$auscl$()
  };
  return $n_Lzonedb_java_tzdb$auscl$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausid$() {
  this.Lzonedb_java_tzdb$ausid$__f_Australia_Adelaide = null;
  this.Lzonedb_java_tzdb$ausid$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausid$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 33260), $ct_T2__O__O__(new $c_T2(), "w", 33260), $ct_T2__O__O__(new $c_T2(), "t", [[1895032, 0, 33260, 32400], [1899121, 0, 32400, 34200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895032, 0, 33260, 32400], [1899121, 0, 32400, 34200], [1917001, 60, 34200, 37800], [1917084, 7200, 37800, 34200], [1942001, 7200, 34200, 37800], [1942088, 7200, 37800, 34200], [1942270, 7200, 34200, 37800], [1943087, 7200, 37800, 34200], [1943276, 7200, 34200, 37800], [1944086, 7200, 37800, 34200], [1971304, 7200, 34200, 37800], [1972058, 10800, 37800, 34200], [1972303, 7200, 34200, 37800], [1973063, 10800, 37800, 34200], [1973301, 7200, 34200, 37800], [1974062, 10800, 37800, 34200], [1974300, 7200, 34200, 37800], [1975061, 10800, 37800, 34200], [1975299, 7200, 34200, 37800], [1976067, 10800, 37800, 34200], [1976305, 7200, 34200, 37800], [1977065, 10800, 37800, 34200], [1977303, 7200, 34200, 37800], [1978064, 10800, 37800, 34200], [1978302, 7200, 34200, 37800], [1979063, 10800, 37800, 34200], [1979301, 7200, 34200, 37800], [1980062, 10800, 37800, 34200], [1980300, 7200, 34200, 37800], [1981060, 10800, 37800, 34200], [1981298, 7200, 34200, 37800], [1982066, 10800, 37800, 34200], [1982304, 7200, 34200, 37800], [1983065, 10800, 37800, 34200], [1983303, 7200, 34200, 37800], [1984064, 10800, 37800, 34200], [1984302, 7200, 34200, 37800], [1985062, 10800, 37800, 34200], [1985300, 7200, 34200, 37800], [1986075, 10800, 37800, 34200], [1986292, 7200, 34200, 37800], [1987074, 10800, 37800, 34200], [1987298, 7200, 34200, 37800], [1988080, 10800, 37800, 34200], [1988304, 7200, 34200, 37800], [1989078, 10800, 37800, 34200], [1989302, 7200, 34200, 37800], [1990077, 10800, 37800, 34200], [1990301, 7200, 34200, 37800], [1991062, 10800, 37800, 34200], [1991300, 7200, 34200, 37800], [1992082, 10800, 37800, 34200], [1992299, 7200, 34200, 37800], [1993066, 10800, 37800, 34200], [1993304, 7200, 34200, 37800], [1994079, 10800, 37800, 34200], [1994303, 7200, 34200, 37800], [1995085, 10800, 37800, 34200], [1995302, 7200, 34200, 37800], [1996091, 10800, 37800, 34200], [1996301, 7200, 34200, 37800], [1997089, 10800, 37800, 34200], [1997299, 7200, 34200, 37800], [1998088, 10800, 37800, 34200], [1998298, 7200, 34200, 37800], [1999087, 10800, 37800, 34200], [1999304, 7200, 34200, 37800], [2000086, 10800, 37800, 34200], [2000303, 7200, 34200, 37800], [2001084, 10800, 37800, 34200], [2001301, 7200, 34200, 37800], [2002090, 10800, 37800, 34200], [2002300, 7200, 34200, 37800], [2003089, 10800, 37800, 34200], [2003299, 7200, 34200, 37800], [2004088, 10800, 37800, 34200], [2004305, 7200, 34200, 37800], [2005086, 10800, 37800, 34200], [2005303, 7200, 34200, 37800], [2006092, 10800, 37800, 34200], [2006302, 7200, 34200, 37800], [2007084, 10800, 37800, 34200], [2007301, 7200, 34200, 37800], [2008097, 10800, 37800, 34200], [2008279, 7200, 34200, 37800], [2009095, 10800, 37800, 34200], [2009277, 7200, 34200, 37800]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 2, 34200, 37800, 34200], [10, 1, 7, 7200, 0, 2, 34200, 34200, 37800]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausid$__f_Australia_Adelaide = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausid$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausid$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausid$.prototype.constructor = $c_Lzonedb_java_tzdb$ausid$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausid$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausid$.prototype = $c_Lzonedb_java_tzdb$ausid$.prototype;
$c_Lzonedb_java_tzdb$ausid$.prototype.Australia_Adelaide__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausid$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 900")
  };
  return this.Lzonedb_java_tzdb$ausid$__f_Australia_Adelaide
});
var $d_Lzonedb_java_tzdb$ausid$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausid$: 0
}, false, "zonedb.java.tzdb$ausid$", {
  Lzonedb_java_tzdb$ausid$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausid$.prototype.$classData = $d_Lzonedb_java_tzdb$ausid$;
var $n_Lzonedb_java_tzdb$ausid$;
function $m_Lzonedb_java_tzdb$ausid$() {
  if ((!$n_Lzonedb_java_tzdb$ausid$)) {
    $n_Lzonedb_java_tzdb$ausid$ = new $c_Lzonedb_java_tzdb$ausid$()
  };
  return $n_Lzonedb_java_tzdb$ausid$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausil$() {
  this.Lzonedb_java_tzdb$ausil$__f_Australia_Broken_Hill = null;
  this.Lzonedb_java_tzdb$ausil$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausil$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 33948), $ct_T2__O__O__(new $c_T2(), "w", 33948), $ct_T2__O__O__(new $c_T2(), "t", [[1895032, 0, 33948, 36000], [1896236, 0, 36000, 32400], [1899121, 0, 32400, 34200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895032, 0, 33948, 36000], [1896236, 0, 36000, 32400], [1899121, 0, 32400, 34200], [1917001, 60, 34200, 37800], [1917084, 7200, 37800, 34200], [1942001, 7200, 34200, 37800], [1942088, 7200, 37800, 34200], [1942270, 7200, 34200, 37800], [1943087, 7200, 37800, 34200], [1943276, 7200, 34200, 37800], [1944086, 7200, 37800, 34200], [1971304, 7200, 34200, 37800], [1972058, 10800, 37800, 34200], [1972303, 7200, 34200, 37800], [1973063, 10800, 37800, 34200], [1973301, 7200, 34200, 37800], [1974062, 10800, 37800, 34200], [1974300, 7200, 34200, 37800], [1975061, 10800, 37800, 34200], [1975299, 7200, 34200, 37800], [1976067, 10800, 37800, 34200], [1976305, 7200, 34200, 37800], [1977065, 10800, 37800, 34200], [1977303, 7200, 34200, 37800], [1978064, 10800, 37800, 34200], [1978302, 7200, 34200, 37800], [1979063, 10800, 37800, 34200], [1979301, 7200, 34200, 37800], [1980062, 10800, 37800, 34200], [1980300, 7200, 34200, 37800], [1981060, 10800, 37800, 34200], [1981298, 7200, 34200, 37800], [1982094, 10800, 37800, 34200], [1982304, 7200, 34200, 37800], [1983065, 10800, 37800, 34200], [1983303, 7200, 34200, 37800], [1984064, 10800, 37800, 34200], [1984302, 7200, 34200, 37800], [1985062, 10800, 37800, 34200], [1985300, 7200, 34200, 37800], [1986075, 10800, 37800, 34200], [1986292, 7200, 34200, 37800], [1987074, 10800, 37800, 34200], [1987298, 7200, 34200, 37800], [1988080, 10800, 37800, 34200], [1988304, 7200, 34200, 37800], [1989078, 10800, 37800, 34200], [1989302, 7200, 34200, 37800], [1990063, 10800, 37800, 34200], [1990301, 7200, 34200, 37800], [1991062, 10800, 37800, 34200], [1991300, 7200, 34200, 37800], [1992061, 10800, 37800, 34200], [1992299, 7200, 34200, 37800], [1993066, 10800, 37800, 34200], [1993304, 7200, 34200, 37800], [1994065, 10800, 37800, 34200], [1994303, 7200, 34200, 37800], [1995064, 10800, 37800, 34200], [1995302, 7200, 34200, 37800], [1996091, 10800, 37800, 34200], [1996301, 7200, 34200, 37800], [1997089, 10800, 37800, 34200], [1997299, 7200, 34200, 37800], [1998088, 10800, 37800, 34200], [1998298, 7200, 34200, 37800], [1999087, 10800, 37800, 34200], [1999304, 7200, 34200, 37800], [2000086, 10800, 37800, 34200], [2000303, 7200, 34200, 37800], [2001084, 10800, 37800, 34200], [2001301, 7200, 34200, 37800], [2002090, 10800, 37800, 34200], [2002300, 7200, 34200, 37800], [2003089, 10800, 37800, 34200], [2003299, 7200, 34200, 37800], [2004088, 10800, 37800, 34200], [2004305, 7200, 34200, 37800], [2005086, 10800, 37800, 34200], [2005303, 7200, 34200, 37800], [2006092, 10800, 37800, 34200], [2006302, 7200, 34200, 37800], [2007084, 10800, 37800, 34200], [2007301, 7200, 34200, 37800], [2008097, 10800, 37800, 34200], [2008279, 7200, 34200, 37800], [2009095, 10800, 37800, 34200], [2009277, 7200, 34200, 37800]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 2, 34200, 37800, 34200], [10, 1, 7, 7200, 0, 2, 34200, 34200, 37800]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausil$__f_Australia_Broken_Hill = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausil$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausil$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausil$.prototype.constructor = $c_Lzonedb_java_tzdb$ausil$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausil$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausil$.prototype = $c_Lzonedb_java_tzdb$ausil$.prototype;
$c_Lzonedb_java_tzdb$ausil$.prototype.Australia_Broken_Hill__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausil$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 298")
  };
  return this.Lzonedb_java_tzdb$ausil$__f_Australia_Broken_Hill
});
var $d_Lzonedb_java_tzdb$ausil$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausil$: 0
}, false, "zonedb.java.tzdb$ausil$", {
  Lzonedb_java_tzdb$ausil$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausil$.prototype.$classData = $d_Lzonedb_java_tzdb$ausil$;
var $n_Lzonedb_java_tzdb$ausil$;
function $m_Lzonedb_java_tzdb$ausil$() {
  if ((!$n_Lzonedb_java_tzdb$ausil$)) {
    $n_Lzonedb_java_tzdb$ausil$ = new $c_Lzonedb_java_tzdb$ausil$()
  };
  return $n_Lzonedb_java_tzdb$ausil$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausma$() {
  this.Lzonedb_java_tzdb$ausma$__f_Australia_Lindeman = null;
  this.Lzonedb_java_tzdb$ausma$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausma$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 35756), $ct_T2__O__O__(new $c_T2(), "w", 35756), $ct_T2__O__O__(new $c_T2(), "t", [[1895001, 0, 35756, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895001, 0, 35756, 36000], [1917001, 60, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990063, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991062, 10800, 39600, 36000], [1991300, 7200, 36000, 39600], [1992061, 10800, 39600, 36000], [1992299, 7200, 36000, 39600], [1993066, 10800, 39600, 36000], [1993304, 7200, 36000, 39600], [1994065, 10800, 39600, 36000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausma$__f_Australia_Lindeman = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausma$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausma$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausma$.prototype.constructor = $c_Lzonedb_java_tzdb$ausma$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausma$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausma$.prototype = $c_Lzonedb_java_tzdb$ausma$.prototype;
$c_Lzonedb_java_tzdb$ausma$.prototype.Australia_Lindeman__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausma$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 169")
  };
  return this.Lzonedb_java_tzdb$ausma$__f_Australia_Lindeman
});
var $d_Lzonedb_java_tzdb$ausma$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausma$: 0
}, false, "zonedb.java.tzdb$ausma$", {
  Lzonedb_java_tzdb$ausma$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausma$.prototype.$classData = $d_Lzonedb_java_tzdb$ausma$;
var $n_Lzonedb_java_tzdb$ausma$;
function $m_Lzonedb_java_tzdb$ausma$() {
  if ((!$n_Lzonedb_java_tzdb$ausma$)) {
    $n_Lzonedb_java_tzdb$ausma$ = new $c_Lzonedb_java_tzdb$ausma$()
  };
  return $n_Lzonedb_java_tzdb$ausma$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausne$() {
  this.Lzonedb_java_tzdb$ausne$__f_Australia_Sydney = null;
  this.Lzonedb_java_tzdb$ausne$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausne$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 36292), $ct_T2__O__O__(new $c_T2(), "w", 36292), $ct_T2__O__O__(new $c_T2(), "t", [[1895032, 0, 36292, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895032, 0, 36292, 36000], [1917001, 60, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982094, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983065, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986075, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987298, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990063, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991062, 10800, 39600, 36000], [1991300, 7200, 36000, 39600], [1992061, 10800, 39600, 36000], [1992299, 7200, 36000, 39600], [1993066, 10800, 39600, 36000], [1993304, 7200, 36000, 39600], [1994065, 10800, 39600, 36000], [1994303, 7200, 36000, 39600], [1995064, 10800, 39600, 36000], [1995302, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996301, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997299, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998298, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999304, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001301, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002300, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003299, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004305, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005303, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006302, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007301, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 2, 36000, 39600, 36000], [10, 1, 7, 7200, 0, 2, 36000, 36000, 39600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausne$__f_Australia_Sydney = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausne$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausne$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausne$.prototype.constructor = $c_Lzonedb_java_tzdb$ausne$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausne$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausne$.prototype = $c_Lzonedb_java_tzdb$ausne$.prototype;
$c_Lzonedb_java_tzdb$ausne$.prototype.Australia_Sydney__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausne$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 539")
  };
  return this.Lzonedb_java_tzdb$ausne$__f_Australia_Sydney
});
var $d_Lzonedb_java_tzdb$ausne$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausne$: 0
}, false, "zonedb.java.tzdb$ausne$", {
  Lzonedb_java_tzdb$ausne$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausne$.prototype.$classData = $d_Lzonedb_java_tzdb$ausne$;
var $n_Lzonedb_java_tzdb$ausne$;
function $m_Lzonedb_java_tzdb$ausne$() {
  if ((!$n_Lzonedb_java_tzdb$ausne$)) {
    $n_Lzonedb_java_tzdb$ausne$ = new $c_Lzonedb_java_tzdb$ausne$()
  };
  return $n_Lzonedb_java_tzdb$ausne$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausow$() {
  this.Lzonedb_java_tzdb$ausow$__f_Australia_Lord_Howe = null;
  this.Lzonedb_java_tzdb$ausow$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausow$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 38180), $ct_T2__O__O__(new $c_T2(), "w", 38180), $ct_T2__O__O__(new $c_T2(), "t", [[1895032, 0, 38180, 36000], [1981060, 0, 36000, 37800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895032, 0, 38180, 36000], [1981060, 0, 36000, 37800], [1981298, 7200, 37800, 41400], [1982066, 7200, 41400, 37800], [1982304, 7200, 37800, 41400], [1983065, 7200, 41400, 37800], [1983303, 7200, 37800, 41400], [1984064, 7200, 41400, 37800], [1984302, 7200, 37800, 41400], [1985062, 7200, 41400, 37800], [1985300, 7200, 37800, 39600], [1986075, 7200, 39600, 37800], [1986292, 7200, 37800, 39600], [1987074, 7200, 39600, 37800], [1987298, 7200, 37800, 39600], [1988080, 7200, 39600, 37800], [1988304, 7200, 37800, 39600], [1989078, 7200, 39600, 37800], [1989302, 7200, 37800, 39600], [1990063, 7200, 39600, 37800], [1990301, 7200, 37800, 39600], [1991062, 7200, 39600, 37800], [1991300, 7200, 37800, 39600], [1992061, 7200, 39600, 37800], [1992299, 7200, 37800, 39600], [1993066, 7200, 39600, 37800], [1993304, 7200, 37800, 39600], [1994065, 7200, 39600, 37800], [1994303, 7200, 37800, 39600], [1995064, 7200, 39600, 37800], [1995302, 7200, 37800, 39600], [1996091, 7200, 39600, 37800], [1996301, 7200, 37800, 39600], [1997089, 7200, 39600, 37800], [1997299, 7200, 37800, 39600], [1998088, 7200, 39600, 37800], [1998298, 7200, 37800, 39600], [1999087, 7200, 39600, 37800], [1999304, 7200, 37800, 39600], [2000086, 7200, 39600, 37800], [2000240, 7200, 37800, 39600], [2001084, 7200, 39600, 37800], [2001301, 7200, 37800, 39600], [2002090, 7200, 39600, 37800], [2002300, 7200, 37800, 39600], [2003089, 7200, 39600, 37800], [2003299, 7200, 37800, 39600], [2004088, 7200, 39600, 37800], [2004305, 7200, 37800, 39600], [2005086, 7200, 39600, 37800], [2005303, 7200, 37800, 39600], [2006092, 7200, 39600, 37800], [2006302, 7200, 37800, 39600], [2007084, 7200, 39600, 37800], [2007301, 7200, 37800, 39600], [2008097, 7200, 39600, 37800], [2008279, 7200, 37800, 39600], [2009095, 7200, 39600, 37800], [2009277, 7200, 37800, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 1, 37800, 39600, 37800], [10, 1, 7, 7200, 0, 1, 37800, 37800, 39600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausow$__f_Australia_Lord_Howe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausow$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausow$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausow$.prototype.constructor = $c_Lzonedb_java_tzdb$ausow$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausow$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausow$.prototype = $c_Lzonedb_java_tzdb$ausow$.prototype;
$c_Lzonedb_java_tzdb$ausow$.prototype.Australia_Lord_Howe__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausow$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 677")
  };
  return this.Lzonedb_java_tzdb$ausow$__f_Australia_Lord_Howe
});
var $d_Lzonedb_java_tzdb$ausow$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausow$: 0
}, false, "zonedb.java.tzdb$ausow$", {
  Lzonedb_java_tzdb$ausow$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausow$.prototype.$classData = $d_Lzonedb_java_tzdb$ausow$;
var $n_Lzonedb_java_tzdb$ausow$;
function $m_Lzonedb_java_tzdb$ausow$() {
  if ((!$n_Lzonedb_java_tzdb$ausow$)) {
    $n_Lzonedb_java_tzdb$ausow$ = new $c_Lzonedb_java_tzdb$ausow$()
  };
  return $n_Lzonedb_java_tzdb$ausow$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausri$() {
  this.Lzonedb_java_tzdb$ausri$__f_Australia_Currie = null;
  this.Lzonedb_java_tzdb$ausri$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausri$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 34528), $ct_T2__O__O__(new $c_T2(), "w", 34528), $ct_T2__O__O__(new $c_T2(), "t", [[1895244, 0, 34528, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895244, 0, 34528, 36000], [1916275, 7200, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982087, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983086, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986061, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987298, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990077, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991090, 10800, 39600, 36000], [1991279, 7200, 36000, 39600], [1992089, 10800, 39600, 36000], [1992278, 7200, 36000, 39600], [1993087, 10800, 39600, 36000], [1993276, 7200, 36000, 39600], [1994086, 10800, 39600, 36000], [1994275, 7200, 36000, 39600], [1995085, 10800, 39600, 36000], [1995274, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996280, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997278, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998277, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999276, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001280, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002279, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003278, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004277, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005275, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006274, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007280, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 2, 36000, 39600, 36000], [10, 1, 7, 7200, 0, 2, 36000, 36000, 39600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausri$__f_Australia_Currie = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausri$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausri$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausri$.prototype.constructor = $c_Lzonedb_java_tzdb$ausri$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausri$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausri$.prototype = $c_Lzonedb_java_tzdb$ausri$.prototype;
$c_Lzonedb_java_tzdb$ausri$.prototype.Australia_Currie__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausri$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 623")
  };
  return this.Lzonedb_java_tzdb$ausri$__f_Australia_Currie
});
var $d_Lzonedb_java_tzdb$ausri$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausri$: 0
}, false, "zonedb.java.tzdb$ausri$", {
  Lzonedb_java_tzdb$ausri$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausri$.prototype.$classData = $d_Lzonedb_java_tzdb$ausri$;
var $n_Lzonedb_java_tzdb$ausri$;
function $m_Lzonedb_java_tzdb$ausri$() {
  if ((!$n_Lzonedb_java_tzdb$ausri$)) {
    $n_Lzonedb_java_tzdb$ausri$ = new $c_Lzonedb_java_tzdb$ausri$()
  };
  return $n_Lzonedb_java_tzdb$ausri$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausrn$() {
  this.Lzonedb_java_tzdb$ausrn$__f_Australia_Melbourne = null;
  this.Lzonedb_java_tzdb$ausrn$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausrn$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 34792), $ct_T2__O__O__(new $c_T2(), "w", 34792), $ct_T2__O__O__(new $c_T2(), "t", [[1895032, 0, 34792, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895032, 0, 34792, 36000], [1917001, 60, 36000, 39600], [1917084, 7200, 39600, 36000], [1942001, 7200, 36000, 39600], [1942088, 7200, 39600, 36000], [1942270, 7200, 36000, 39600], [1943087, 7200, 39600, 36000], [1943276, 7200, 36000, 39600], [1944086, 7200, 39600, 36000], [1971304, 7200, 36000, 39600], [1972058, 10800, 39600, 36000], [1972303, 7200, 36000, 39600], [1973063, 10800, 39600, 36000], [1973301, 7200, 36000, 39600], [1974062, 10800, 39600, 36000], [1974300, 7200, 36000, 39600], [1975061, 10800, 39600, 36000], [1975299, 7200, 36000, 39600], [1976067, 10800, 39600, 36000], [1976305, 7200, 36000, 39600], [1977065, 10800, 39600, 36000], [1977303, 7200, 36000, 39600], [1978064, 10800, 39600, 36000], [1978302, 7200, 36000, 39600], [1979063, 10800, 39600, 36000], [1979301, 7200, 36000, 39600], [1980062, 10800, 39600, 36000], [1980300, 7200, 36000, 39600], [1981060, 10800, 39600, 36000], [1981298, 7200, 36000, 39600], [1982066, 10800, 39600, 36000], [1982304, 7200, 36000, 39600], [1983065, 10800, 39600, 36000], [1983303, 7200, 36000, 39600], [1984064, 10800, 39600, 36000], [1984302, 7200, 36000, 39600], [1985062, 10800, 39600, 36000], [1985300, 7200, 36000, 39600], [1986075, 10800, 39600, 36000], [1986292, 7200, 36000, 39600], [1987074, 10800, 39600, 36000], [1987291, 7200, 36000, 39600], [1988080, 10800, 39600, 36000], [1988304, 7200, 36000, 39600], [1989078, 10800, 39600, 36000], [1989302, 7200, 36000, 39600], [1990077, 10800, 39600, 36000], [1990301, 7200, 36000, 39600], [1991062, 10800, 39600, 36000], [1991300, 7200, 36000, 39600], [1992061, 10800, 39600, 36000], [1992299, 7200, 36000, 39600], [1993066, 10800, 39600, 36000], [1993304, 7200, 36000, 39600], [1994065, 10800, 39600, 36000], [1994303, 7200, 36000, 39600], [1995085, 10800, 39600, 36000], [1995302, 7200, 36000, 39600], [1996091, 10800, 39600, 36000], [1996301, 7200, 36000, 39600], [1997089, 10800, 39600, 36000], [1997299, 7200, 36000, 39600], [1998088, 10800, 39600, 36000], [1998298, 7200, 36000, 39600], [1999087, 10800, 39600, 36000], [1999304, 7200, 36000, 39600], [2000086, 10800, 39600, 36000], [2000240, 7200, 36000, 39600], [2001084, 10800, 39600, 36000], [2001301, 7200, 36000, 39600], [2002090, 10800, 39600, 36000], [2002300, 7200, 36000, 39600], [2003089, 10800, 39600, 36000], [2003299, 7200, 36000, 39600], [2004088, 10800, 39600, 36000], [2004305, 7200, 36000, 39600], [2005086, 10800, 39600, 36000], [2005303, 7200, 36000, 39600], [2006092, 10800, 39600, 36000], [2006302, 7200, 36000, 39600], [2007084, 10800, 39600, 36000], [2007301, 7200, 36000, 39600], [2008097, 10800, 39600, 36000], [2008279, 7200, 36000, 39600], [2009095, 10800, 39600, 36000], [2009277, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 2, 36000, 39600, 36000], [10, 1, 7, 7200, 0, 2, 36000, 36000, 39600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausrn$__f_Australia_Melbourne = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausrn$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausrn$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausrn$.prototype.constructor = $c_Lzonedb_java_tzdb$ausrn$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausrn$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausrn$.prototype = $c_Lzonedb_java_tzdb$ausrn$.prototype;
$c_Lzonedb_java_tzdb$ausrn$.prototype.Australia_Melbourne__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausrn$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 149")
  };
  return this.Lzonedb_java_tzdb$ausrn$__f_Australia_Melbourne
});
var $d_Lzonedb_java_tzdb$ausrn$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausrn$: 0
}, false, "zonedb.java.tzdb$ausrn$", {
  Lzonedb_java_tzdb$ausrn$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausrn$.prototype.$classData = $d_Lzonedb_java_tzdb$ausrn$;
var $n_Lzonedb_java_tzdb$ausrn$;
function $m_Lzonedb_java_tzdb$ausrn$() {
  if ((!$n_Lzonedb_java_tzdb$ausrn$)) {
    $n_Lzonedb_java_tzdb$ausrn$ = new $c_Lzonedb_java_tzdb$ausrn$()
  };
  return $n_Lzonedb_java_tzdb$ausrn$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$ausrt$() {
  this.Lzonedb_java_tzdb$ausrt$__f_Australia_Perth = null;
  this.Lzonedb_java_tzdb$ausrt$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$ausrt$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 27804), $ct_T2__O__O__(new $c_T2(), "w", 27804), $ct_T2__O__O__(new $c_T2(), "t", [[1895335, 0, 27804, 28800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895335, 0, 27804, 28800], [1917001, 60, 28800, 32400], [1917084, 7200, 32400, 28800], [1942001, 7200, 28800, 32400], [1942088, 7200, 32400, 28800], [1942270, 7200, 28800, 32400], [1943087, 7200, 32400, 28800], [1974300, 7200, 28800, 32400], [1975061, 10800, 32400, 28800], [1983303, 7200, 28800, 32400], [1984064, 10800, 32400, 28800], [1991321, 7200, 28800, 32400], [1992061, 10800, 32400, 28800], [2006337, 7200, 28800, 32400], [2007084, 10800, 32400, 28800], [2007301, 7200, 28800, 32400], [2008090, 10800, 32400, 28800], [2008300, 7200, 28800, 32400], [2009088, 10800, 32400, 28800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$ausrt$__f_Australia_Perth = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$ausrt$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$ausrt$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$ausrt$.prototype.constructor = $c_Lzonedb_java_tzdb$ausrt$;
/** @constructor */
function $h_Lzonedb_java_tzdb$ausrt$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$ausrt$.prototype = $c_Lzonedb_java_tzdb$ausrt$.prototype;
$c_Lzonedb_java_tzdb$ausrt$.prototype.Australia_Perth__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$ausrt$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 369")
  };
  return this.Lzonedb_java_tzdb$ausrt$__f_Australia_Perth
});
var $d_Lzonedb_java_tzdb$ausrt$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$ausrt$: 0
}, false, "zonedb.java.tzdb$ausrt$", {
  Lzonedb_java_tzdb$ausrt$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$ausrt$.prototype.$classData = $d_Lzonedb_java_tzdb$ausrt$;
var $n_Lzonedb_java_tzdb$ausrt$;
function $m_Lzonedb_java_tzdb$ausrt$() {
  if ((!$n_Lzonedb_java_tzdb$ausrt$)) {
    $n_Lzonedb_java_tzdb$ausrt$ = new $c_Lzonedb_java_tzdb$ausrt$()
  };
  return $n_Lzonedb_java_tzdb$ausrt$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$auswi$() {
  this.Lzonedb_java_tzdb$auswi$__f_Australia_Darwin = null;
  this.Lzonedb_java_tzdb$auswi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$auswi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 31400), $ct_T2__O__O__(new $c_T2(), "w", 31400), $ct_T2__O__O__(new $c_T2(), "t", [[1895032, 0, 31400, 32400], [1899121, 0, 32400, 34200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895032, 0, 31400, 32400], [1899121, 0, 32400, 34200], [1917001, 60, 34200, 37800], [1917084, 7200, 37800, 34200], [1942001, 7200, 34200, 37800], [1942088, 7200, 37800, 34200], [1942270, 7200, 34200, 37800], [1943087, 7200, 37800, 34200], [1943276, 7200, 34200, 37800], [1944086, 7200, 37800, 34200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$auswi$__f_Australia_Darwin = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$auswi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$auswi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$auswi$.prototype.constructor = $c_Lzonedb_java_tzdb$auswi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$auswi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$auswi$.prototype = $c_Lzonedb_java_tzdb$auswi$.prototype;
$c_Lzonedb_java_tzdb$auswi$.prototype.Australia_Darwin__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$auswi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 417")
  };
  return this.Lzonedb_java_tzdb$auswi$__f_Australia_Darwin
});
var $d_Lzonedb_java_tzdb$auswi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$auswi$: 0
}, false, "zonedb.java.tzdb$auswi$", {
  Lzonedb_java_tzdb$auswi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$auswi$.prototype.$classData = $d_Lzonedb_java_tzdb$auswi$;
var $n_Lzonedb_java_tzdb$auswi$;
function $m_Lzonedb_java_tzdb$auswi$() {
  if ((!$n_Lzonedb_java_tzdb$auswi$)) {
    $n_Lzonedb_java_tzdb$auswi$ = new $c_Lzonedb_java_tzdb$auswi$()
  };
  return $n_Lzonedb_java_tzdb$auswi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurac$() {
  this.Lzonedb_java_tzdb$eurac$__f_Europe_Monaco = null;
  this.Lzonedb_java_tzdb$eurac$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurac$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 1772), $ct_T2__O__O__(new $c_T2(), "w", 1772), $ct_T2__O__O__(new $c_T2(), "t", [[1891074, 0, 1772, 561], [1911070, 0, 561, 0], [1945259, 3600, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1891074, 0, 1772, 561], [1911070, 0, 561, 0], [1916166, 82800, 0, 3600], [1916276, 0, 3600, 0], [1917083, 82800, 0, 3600], [1917281, 0, 3600, 0], [1918068, 82800, 0, 3600], [1918280, 0, 3600, 0], [1919060, 82800, 0, 3600], [1919279, 0, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 0, 3600, 0], [1921073, 82800, 0, 3600], [1921299, 0, 3600, 0], [1922084, 82800, 0, 3600], [1922281, 0, 3600, 0], [1923146, 82800, 0, 3600], [1923280, 0, 3600, 0], [1924089, 82800, 0, 3600], [1924279, 0, 3600, 0], [1925094, 82800, 0, 3600], [1925277, 0, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 0, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 0, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 0, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 0, 3600, 0], [1930102, 82800, 0, 3600], [1930278, 0, 3600, 0], [1931108, 82800, 0, 3600], [1931277, 0, 3600, 0], [1932093, 82800, 0, 3600], [1932276, 0, 3600, 0], [1933084, 82800, 0, 3600], [1933281, 0, 3600, 0], [1934097, 82800, 0, 3600], [1934280, 0, 3600, 0], [1935089, 82800, 0, 3600], [1935279, 0, 3600, 0], [1936109, 82800, 0, 3600], [1936278, 0, 3600, 0], [1937093, 82800, 0, 3600], [1937276, 0, 3600, 0], [1938085, 82800, 0, 3600], [1938275, 0, 3600, 0], [1939105, 82800, 0, 3600], [1939323, 0, 3600, 0], [1940056, 7200, 0, 3600], [1941125, 0, 3600, 7200], [1941279, 0, 7200, 3600], [1942068, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944282, 3600, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1976088, 3600, 3600, 7200], [1976270, 3600, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurac$__f_Europe_Monaco = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurac$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurac$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurac$.prototype.constructor = $c_Lzonedb_java_tzdb$eurac$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurac$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurac$.prototype = $c_Lzonedb_java_tzdb$eurac$.prototype;
$c_Lzonedb_java_tzdb$eurac$.prototype.Europe_Monaco__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurac$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 362")
  };
  return this.Lzonedb_java_tzdb$eurac$__f_Europe_Monaco
});
var $d_Lzonedb_java_tzdb$eurac$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurac$: 0
}, false, "zonedb.java.tzdb$eurac$", {
  Lzonedb_java_tzdb$eurac$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurac$.prototype.$classData = $d_Lzonedb_java_tzdb$eurac$;
var $n_Lzonedb_java_tzdb$eurac$;
function $m_Lzonedb_java_tzdb$eurac$() {
  if ((!$n_Lzonedb_java_tzdb$eurac$)) {
    $n_Lzonedb_java_tzdb$eurac$ = new $c_Lzonedb_java_tzdb$eurac$()
  };
  return $n_Lzonedb_java_tzdb$eurac$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurad$() {
  this.Lzonedb_java_tzdb$eurad$__f_Europe_Belgrade = null;
  this.Lzonedb_java_tzdb$eurad$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurad$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 4920), $ct_T2__O__O__(new $c_T2(), "w", 4920), $ct_T2__O__O__(new $c_T2(), "t", [[1884001, 0, 4920, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1884001, 0, 4920, 3600], [1941108, 82800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945128, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurad$__f_Europe_Belgrade = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurad$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurad$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurad$.prototype.constructor = $c_Lzonedb_java_tzdb$eurad$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurad$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurad$.prototype = $c_Lzonedb_java_tzdb$eurad$.prototype;
$c_Lzonedb_java_tzdb$eurad$.prototype.Europe_Belgrade__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurad$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 146")
  };
  return this.Lzonedb_java_tzdb$eurad$__f_Europe_Belgrade
});
var $d_Lzonedb_java_tzdb$eurad$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurad$: 0
}, false, "zonedb.java.tzdb$eurad$", {
  Lzonedb_java_tzdb$eurad$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurad$.prototype.$classData = $d_Lzonedb_java_tzdb$eurad$;
var $n_Lzonedb_java_tzdb$eurad$;
function $m_Lzonedb_java_tzdb$eurad$() {
  if ((!$n_Lzonedb_java_tzdb$eurad$)) {
    $n_Lzonedb_java_tzdb$eurad$ = new $c_Lzonedb_java_tzdb$eurad$()
  };
  return $n_Lzonedb_java_tzdb$eurad$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$euran$() {
  this.Lzonedb_java_tzdb$euran$__f_Europe_Tirane = null;
  this.Lzonedb_java_tzdb$euran$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$euran$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 4760), $ct_T2__O__O__(new $c_T2(), "w", 4760), $ct_T2__O__O__(new $c_T2(), "t", [[1914001, 0, 4760, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1914001, 0, 4760, 3600], [1940168, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943100, 10800, 7200, 3600], [1974124, 0, 3600, 7200], [1974275, 0, 7200, 3600], [1975121, 0, 3600, 7200], [1975275, 0, 7200, 3600], [1976123, 0, 3600, 7200], [1976277, 0, 7200, 3600], [1977128, 0, 3600, 7200], [1977275, 0, 7200, 3600], [1978126, 0, 3600, 7200], [1978274, 0, 7200, 3600], [1979125, 0, 3600, 7200], [1979273, 0, 7200, 3600], [1980124, 0, 3600, 7200], [1980278, 0, 7200, 3600], [1981116, 0, 3600, 7200], [1981270, 0, 7200, 3600], [1982122, 0, 3600, 7200], [1982276, 0, 7200, 3600], [1983108, 0, 3600, 7200], [1983274, 0, 7200, 3600], [1984092, 0, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$euran$__f_Europe_Tirane = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$euran$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$euran$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$euran$.prototype.constructor = $c_Lzonedb_java_tzdb$euran$;
/** @constructor */
function $h_Lzonedb_java_tzdb$euran$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$euran$.prototype = $c_Lzonedb_java_tzdb$euran$.prototype;
$c_Lzonedb_java_tzdb$euran$.prototype.Europe_Tirane__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$euran$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 204")
  };
  return this.Lzonedb_java_tzdb$euran$__f_Europe_Tirane
});
var $d_Lzonedb_java_tzdb$euran$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$euran$: 0
}, false, "zonedb.java.tzdb$euran$", {
  Lzonedb_java_tzdb$euran$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$euran$.prototype.$classData = $d_Lzonedb_java_tzdb$euran$;
var $n_Lzonedb_java_tzdb$euran$;
function $m_Lzonedb_java_tzdb$euran$() {
  if ((!$n_Lzonedb_java_tzdb$euran$)) {
    $n_Lzonedb_java_tzdb$euran$ = new $c_Lzonedb_java_tzdb$euran$()
  };
  return $n_Lzonedb_java_tzdb$euran$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurar$() {
  this.Lzonedb_java_tzdb$eurar$__f_Europe_Samara = null;
  this.Lzonedb_java_tzdb$eurar$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurar$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 12020), $ct_T2__O__O__(new $c_T2(), "w", 12020), $ct_T2__O__O__(new $c_T2(), "t", [[1919182, 12020, 12020, 10800], [1930172, 0, 10800, 14400], [1989085, 7200, 14400, 10800], [1991090, 7200, 10800, 7200], [1991272, 7200, 7200, 10800], [1991293, 10800, 10800, 14400], [2010087, 7200, 14400, 10800], [2011086, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919182, 12020, 12020, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991293, 10800, 10800, 14400], [1992089, 7200, 14400, 18000], [1992271, 10800, 18000, 14400], [1993087, 7200, 14400, 18000], [1993269, 10800, 18000, 14400], [1994086, 7200, 14400, 18000], [1994268, 10800, 18000, 14400], [1995085, 7200, 14400, 18000], [1995267, 10800, 18000, 14400], [1996091, 7200, 14400, 18000], [1996301, 10800, 18000, 14400], [1997089, 7200, 14400, 18000], [1997299, 10800, 18000, 14400], [1998088, 7200, 14400, 18000], [1998298, 10800, 18000, 14400], [1999087, 7200, 14400, 18000], [1999304, 10800, 18000, 14400], [2000086, 7200, 14400, 18000], [2000303, 10800, 18000, 14400], [2001084, 7200, 14400, 18000], [2001301, 10800, 18000, 14400], [2002090, 7200, 14400, 18000], [2002300, 10800, 18000, 14400], [2003089, 7200, 14400, 18000], [2003299, 10800, 18000, 14400], [2004088, 7200, 14400, 18000], [2004305, 10800, 18000, 14400], [2005086, 7200, 14400, 18000], [2005303, 10800, 18000, 14400], [2006085, 7200, 14400, 18000], [2006302, 10800, 18000, 14400], [2007084, 7200, 14400, 18000], [2007301, 10800, 18000, 14400], [2008090, 7200, 14400, 18000], [2008300, 10800, 18000, 14400], [2009088, 7200, 14400, 18000], [2009298, 10800, 18000, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurar$__f_Europe_Samara = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurar$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurar$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurar$.prototype.constructor = $c_Lzonedb_java_tzdb$eurar$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurar$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurar$.prototype = $c_Lzonedb_java_tzdb$eurar$.prototype;
$c_Lzonedb_java_tzdb$eurar$.prototype.Europe_Samara__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurar$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 764")
  };
  return this.Lzonedb_java_tzdb$eurar$__f_Europe_Samara
});
var $d_Lzonedb_java_tzdb$eurar$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurar$: 0
}, false, "zonedb.java.tzdb$eurar$", {
  Lzonedb_java_tzdb$eurar$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurar$.prototype.$classData = $d_Lzonedb_java_tzdb$eurar$;
var $n_Lzonedb_java_tzdb$eurar$;
function $m_Lzonedb_java_tzdb$eurar$() {
  if ((!$n_Lzonedb_java_tzdb$eurar$)) {
    $n_Lzonedb_java_tzdb$eurar$ = new $c_Lzonedb_java_tzdb$eurar$()
  };
  return $n_Lzonedb_java_tzdb$eurar$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurbo$() {
  this.Lzonedb_java_tzdb$eurbo$__f_Europe_Lisbon = null;
  this.Lzonedb_java_tzdb$eurbo$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurbo$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-2205)), $ct_T2__O__O__(new $c_T2(), "w", (-2205)), $ct_T2__O__O__(new $c_T2(), "t", [[1911365, 84195, (-2205), 0], [1966093, 7200, 0, 3600], [1976270, 3600, 3600, 0], [1992271, 3600, 0, 3600], [1996091, 7200, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1911365, 84195, (-2205), 0], [1916169, 82800, 0, 3600], [1916306, 3600, 3600, 0], [1917059, 82800, 0, 3600], [1917288, 0, 3600, 0], [1918060, 82800, 0, 3600], [1918288, 0, 3600, 0], [1919059, 82800, 0, 3600], [1919288, 0, 3600, 0], [1920060, 82800, 0, 3600], [1920289, 0, 3600, 0], [1921059, 82800, 0, 3600], [1921288, 0, 3600, 0], [1924107, 82800, 0, 3600], [1924289, 0, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 0, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 0, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 0, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 0, 3600, 0], [1931108, 82800, 0, 3600], [1931277, 0, 3600, 0], [1932093, 82800, 0, 3600], [1932276, 0, 3600, 0], [1934097, 82800, 0, 3600], [1934280, 0, 3600, 0], [1935089, 82800, 0, 3600], [1935279, 0, 3600, 0], [1936109, 82800, 0, 3600], [1936278, 0, 3600, 0], [1937093, 82800, 0, 3600], [1937276, 0, 3600, 0], [1938085, 82800, 0, 3600], [1938275, 0, 3600, 0], [1939105, 82800, 0, 3600], [1939323, 0, 3600, 0], [1940055, 82800, 0, 3600], [1940280, 0, 3600, 0], [1941095, 82800, 0, 3600], [1941279, 0, 3600, 0], [1942073, 82800, 0, 3600], [1942115, 82800, 3600, 7200], [1942228, 0, 7200, 3600], [1942298, 0, 3600, 0], [1943072, 82800, 0, 3600], [1943107, 82800, 3600, 7200], [1943241, 0, 7200, 3600], [1943304, 0, 3600, 0], [1944071, 82800, 0, 3600], [1944113, 82800, 3600, 7200], [1944240, 0, 7200, 3600], [1944303, 0, 3600, 0], [1945069, 82800, 0, 3600], [1945111, 82800, 3600, 7200], [1945238, 0, 7200, 3600], [1945301, 0, 3600, 0], [1946096, 82800, 0, 3600], [1946279, 0, 3600, 0], [1947096, 7200, 0, 3600], [1947278, 10800, 3600, 0], [1948095, 7200, 0, 3600], [1948277, 10800, 3600, 0], [1949093, 7200, 0, 3600], [1949275, 10800, 3600, 0], [1951091, 7200, 0, 3600], [1951280, 10800, 3600, 0], [1952097, 7200, 0, 3600], [1952279, 10800, 3600, 0], [1953095, 7200, 0, 3600], [1953277, 10800, 3600, 0], [1954094, 7200, 0, 3600], [1954276, 10800, 3600, 0], [1955093, 7200, 0, 3600], [1955275, 10800, 3600, 0], [1956092, 7200, 0, 3600], [1956281, 10800, 3600, 0], [1957097, 7200, 0, 3600], [1957279, 10800, 3600, 0], [1958096, 7200, 0, 3600], [1958278, 10800, 3600, 0], [1959095, 7200, 0, 3600], [1959277, 10800, 3600, 0], [1960094, 7200, 0, 3600], [1960276, 10800, 3600, 0], [1961092, 7200, 0, 3600], [1961274, 10800, 3600, 0], [1962091, 7200, 0, 3600], [1962280, 10800, 3600, 0], [1963097, 7200, 0, 3600], [1963279, 10800, 3600, 0], [1964096, 7200, 0, 3600], [1964278, 10800, 3600, 0], [1965094, 7200, 0, 3600], [1965276, 10800, 3600, 0], [1966093, 7200, 0, 3600], [1976270, 3600, 3600, 0], [1977086, 0, 0, 3600], [1977268, 3600, 3600, 0], [1978092, 0, 0, 3600], [1978274, 3600, 3600, 0], [1979091, 0, 0, 3600], [1979273, 7200, 3600, 0], [1980090, 0, 0, 3600], [1980272, 7200, 3600, 0], [1981088, 3600, 0, 3600], [1981270, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982269, 7200, 3600, 0], [1983086, 7200, 0, 3600], [1983268, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984274, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985272, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986271, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987270, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988269, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989267, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990273, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991272, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurbo$__f_Europe_Lisbon = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurbo$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurbo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurbo$.prototype.constructor = $c_Lzonedb_java_tzdb$eurbo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurbo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurbo$.prototype = $c_Lzonedb_java_tzdb$eurbo$.prototype;
$c_Lzonedb_java_tzdb$eurbo$.prototype.Europe_Lisbon__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurbo$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 44")
  };
  return this.Lzonedb_java_tzdb$eurbo$__f_Europe_Lisbon
});
var $d_Lzonedb_java_tzdb$eurbo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurbo$: 0
}, false, "zonedb.java.tzdb$eurbo$", {
  Lzonedb_java_tzdb$eurbo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurbo$.prototype.$classData = $d_Lzonedb_java_tzdb$eurbo$;
var $n_Lzonedb_java_tzdb$eurbo$;
function $m_Lzonedb_java_tzdb$eurbo$() {
  if ((!$n_Lzonedb_java_tzdb$eurbo$)) {
    $n_Lzonedb_java_tzdb$eurbo$ = new $c_Lzonedb_java_tzdb$eurbo$()
  };
  return $n_Lzonedb_java_tzdb$eurbo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurbu$() {
  this.Lzonedb_java_tzdb$eurbu$__f_Europe_Istanbul = null;
  this.Lzonedb_java_tzdb$eurbu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurbu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 6952), $ct_T2__O__O__(new $c_T2(), "w", 6952), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 6952, 7016], [1910274, 0, 7016, 7200], [1978179, 82800, 7200, 10800], [1984306, 7200, 10800, 7200], [2016250, 82800, 7200, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 6952, 7016], [1910274, 0, 7016, 7200], [1916122, 0, 7200, 10800], [1916275, 0, 10800, 7200], [1920088, 0, 7200, 10800], [1920299, 0, 10800, 7200], [1921093, 0, 7200, 10800], [1921276, 0, 10800, 7200], [1922085, 0, 7200, 10800], [1922281, 0, 10800, 7200], [1924134, 0, 7200, 10800], [1924275, 0, 10800, 7200], [1925121, 0, 7200, 10800], [1925274, 0, 10800, 7200], [1940183, 0, 7200, 10800], [1940280, 0, 10800, 7200], [1940336, 0, 7200, 10800], [1941264, 0, 10800, 7200], [1942091, 0, 7200, 10800], [1945281, 0, 10800, 7200], [1946152, 0, 7200, 10800], [1946274, 0, 10800, 7200], [1947110, 0, 7200, 10800], [1947278, 0, 10800, 7200], [1948109, 0, 7200, 10800], [1948277, 0, 10800, 7200], [1949100, 0, 7200, 10800], [1949275, 0, 10800, 7200], [1950106, 0, 7200, 10800], [1950281, 0, 10800, 7200], [1951112, 0, 7200, 10800], [1951280, 0, 10800, 7200], [1962196, 0, 7200, 10800], [1963303, 0, 10800, 7200], [1964136, 0, 7200, 10800], [1964275, 0, 10800, 7200], [1973154, 3600, 7200, 10800], [1973308, 7200, 10800, 7200], [1974090, 7200, 7200, 10800], [1974307, 7200, 10800, 7200], [1975081, 7200, 7200, 10800], [1975306, 7200, 10800, 7200], [1976081, 7200, 7200, 10800], [1976305, 7200, 10800, 7200], [1977093, 7200, 7200, 10800], [1977289, 7200, 10800, 7200], [1978092, 7200, 7200, 10800], [1983212, 7200, 10800, 14400], [1983275, 7200, 14400, 10800], [1984306, 7200, 10800, 7200], [1985110, 3600, 7200, 10800], [1985271, 7200, 10800, 7200], [1986089, 3600, 7200, 10800], [1986271, 7200, 10800, 7200], [1987088, 3600, 7200, 10800], [1987270, 7200, 10800, 7200], [1988087, 3600, 7200, 10800], [1988269, 7200, 10800, 7200], [1989085, 3600, 7200, 10800], [1989267, 7200, 10800, 7200], [1990084, 3600, 7200, 10800], [1990273, 7200, 10800, 7200], [1991090, 3600, 7200, 10800], [1991272, 7200, 10800, 7200], [1992089, 3600, 7200, 10800], [1992271, 7200, 10800, 7200], [1993087, 3600, 7200, 10800], [1993269, 7200, 10800, 7200], [1994079, 3600, 7200, 10800], [1994268, 7200, 10800, 7200], [1995085, 3600, 7200, 10800], [1995267, 7200, 10800, 7200], [1996091, 3600, 7200, 10800], [1996301, 7200, 10800, 7200], [1997089, 3600, 7200, 10800], [1997299, 7200, 10800, 7200], [1998088, 3600, 7200, 10800], [1998298, 7200, 10800, 7200], [1999087, 3600, 7200, 10800], [1999304, 7200, 10800, 7200], [2000086, 3600, 7200, 10800], [2000303, 7200, 10800, 7200], [2001084, 3600, 7200, 10800], [2001301, 7200, 10800, 7200], [2002090, 3600, 7200, 10800], [2002300, 7200, 10800, 7200], [2003089, 3600, 7200, 10800], [2003299, 7200, 10800, 7200], [2004088, 3600, 7200, 10800], [2004305, 7200, 10800, 7200], [2005086, 3600, 7200, 10800], [2005303, 7200, 10800, 7200], [2006085, 3600, 7200, 10800], [2006302, 7200, 10800, 7200], [2007084, 10800, 7200, 10800], [2007301, 14400, 10800, 7200], [2008090, 10800, 7200, 10800], [2008300, 14400, 10800, 7200], [2009088, 10800, 7200, 10800], [2009298, 14400, 10800, 7200], [2010087, 10800, 7200, 10800], [2010304, 14400, 10800, 7200], [2011087, 10800, 7200, 10800], [2011303, 14400, 10800, 7200], [2012085, 10800, 7200, 10800], [2012302, 14400, 10800, 7200], [2013090, 10800, 7200, 10800], [2013300, 14400, 10800, 7200], [2014090, 10800, 7200, 10800], [2014299, 14400, 10800, 7200], [2015088, 10800, 7200, 10800], [2015312, 14400, 10800, 7200], [2016087, 10800, 7200, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurbu$__f_Europe_Istanbul = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurbu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurbu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurbu$.prototype.constructor = $c_Lzonedb_java_tzdb$eurbu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurbu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurbu$.prototype = $c_Lzonedb_java_tzdb$eurbu$.prototype;
$c_Lzonedb_java_tzdb$eurbu$.prototype.Europe_Istanbul__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurbu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 277")
  };
  return this.Lzonedb_java_tzdb$eurbu$__f_Europe_Istanbul
});
var $d_Lzonedb_java_tzdb$eurbu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurbu$: 0
}, false, "zonedb.java.tzdb$eurbu$", {
  Lzonedb_java_tzdb$eurbu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurbu$.prototype.$classData = $d_Lzonedb_java_tzdb$eurbu$;
var $n_Lzonedb_java_tzdb$eurbu$;
function $m_Lzonedb_java_tzdb$eurbu$() {
  if ((!$n_Lzonedb_java_tzdb$eurbu$)) {
    $n_Lzonedb_java_tzdb$eurbu$ = new $c_Lzonedb_java_tzdb$eurbu$()
  };
  return $n_Lzonedb_java_tzdb$eurbu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurco$() {
  this.Lzonedb_java_tzdb$eurco$__f_Europe_Moscow = null;
  this.Lzonedb_java_tzdb$eurco$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurco$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 9017), $ct_T2__O__O__(new $c_T2(), "w", 9017), $ct_T2__O__O__(new $c_T2(), "t", [[1916185, 0, 9017, 9079], [1919182, 9079, 9079, 10800], [1922274, 0, 10800, 7200], [1930172, 0, 7200, 10800], [1991090, 7200, 10800, 7200], [1992019, 7200, 7200, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1916185, 0, 9017, 9079], [1917182, 82800, 9079, 12679], [1917362, 0, 12679, 9079], [1918151, 79200, 9079, 16279], [1918259, 3600, 16279, 12679], [1919151, 82800, 12679, 16279], [1919182, 16279, 16279, 14400], [1919228, 0, 14400, 10800], [1921045, 82800, 10800, 14400], [1921079, 82800, 14400, 18000], [1921244, 0, 18000, 14400], [1921274, 0, 14400, 10800], [1922274, 0, 10800, 7200], [1930172, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991272, 10800, 10800, 7200], [1992019, 7200, 7200, 10800], [1992089, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurco$__f_Europe_Moscow = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurco$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurco$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurco$.prototype.constructor = $c_Lzonedb_java_tzdb$eurco$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurco$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurco$.prototype = $c_Lzonedb_java_tzdb$eurco$.prototype;
$c_Lzonedb_java_tzdb$eurco$.prototype.Europe_Moscow__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurco$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 780")
  };
  return this.Lzonedb_java_tzdb$eurco$__f_Europe_Moscow
});
var $d_Lzonedb_java_tzdb$eurco$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurco$: 0
}, false, "zonedb.java.tzdb$eurco$", {
  Lzonedb_java_tzdb$eurco$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurco$.prototype.$classData = $d_Lzonedb_java_tzdb$eurco$;
var $n_Lzonedb_java_tzdb$eurco$;
function $m_Lzonedb_java_tzdb$eurco$() {
  if ((!$n_Lzonedb_java_tzdb$eurco$)) {
    $n_Lzonedb_java_tzdb$eurco$ = new $c_Lzonedb_java_tzdb$eurco$()
  };
  return $n_Lzonedb_java_tzdb$eurco$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurda$() {
  this.Lzonedb_java_tzdb$eurda$__f_Europe_Amsterdam = null;
  this.Lzonedb_java_tzdb$eurda$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurda$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 1172), $ct_T2__O__O__(new $c_T2(), "w", 1172), $ct_T2__O__O__(new $c_T2(), "t", [[1937181, 82800, 1172, 1200], [1940137, 0, 1200, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1916122, 0, 1172, 4772], [1916275, 0, 4772, 1172], [1917106, 7200, 1172, 4772], [1917260, 10800, 4772, 1172], [1918091, 7200, 1172, 4772], [1918273, 10800, 4772, 1172], [1919097, 7200, 1172, 4772], [1919272, 10800, 4772, 1172], [1920096, 7200, 1172, 4772], [1920271, 10800, 4772, 1172], [1921094, 7200, 1172, 4772], [1921269, 10800, 4772, 1172], [1922085, 7200, 1172, 4772], [1922281, 10800, 4772, 1172], [1923152, 7200, 1172, 4772], [1923280, 10800, 4772, 1172], [1924090, 7200, 1172, 4772], [1924279, 10800, 4772, 1172], [1925156, 7200, 1172, 4772], [1925277, 10800, 4772, 1172], [1926135, 7200, 1172, 4772], [1926276, 10800, 4772, 1172], [1927135, 7200, 1172, 4772], [1927275, 10800, 4772, 1172], [1928136, 7200, 1172, 4772], [1928281, 10800, 4772, 1172], [1929135, 7200, 1172, 4772], [1929279, 10800, 4772, 1172], [1930135, 7200, 1172, 4772], [1930278, 10800, 4772, 1172], [1931135, 7200, 1172, 4772], [1931277, 10800, 4772, 1172], [1932143, 7200, 1172, 4772], [1932276, 10800, 4772, 1172], [1933135, 7200, 1172, 4772], [1933281, 10800, 4772, 1172], [1934135, 7200, 1172, 4772], [1934280, 10800, 4772, 1172], [1935135, 7200, 1172, 4772], [1935279, 10800, 4772, 1172], [1936136, 7200, 1172, 4772], [1936278, 10800, 4772, 1172], [1937142, 7200, 1172, 4772], [1937182, 0, 4772, 4800], [1937276, 10800, 4800, 1200], [1938135, 7200, 1200, 4800], [1938275, 10800, 4800, 1200], [1939135, 7200, 1200, 4800], [1939281, 10800, 4800, 1200], [1940137, 0, 1200, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurda$__f_Europe_Amsterdam = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurda$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurda$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurda$.prototype.constructor = $c_Lzonedb_java_tzdb$eurda$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurda$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurda$.prototype = $c_Lzonedb_java_tzdb$eurda$.prototype;
$c_Lzonedb_java_tzdb$eurda$.prototype.Europe_Amsterdam__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurda$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 391")
  };
  return this.Lzonedb_java_tzdb$eurda$__f_Europe_Amsterdam
});
var $d_Lzonedb_java_tzdb$eurda$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurda$: 0
}, false, "zonedb.java.tzdb$eurda$", {
  Lzonedb_java_tzdb$eurda$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurda$.prototype.$classData = $d_Lzonedb_java_tzdb$eurda$;
var $n_Lzonedb_java_tzdb$eurda$;
function $m_Lzonedb_java_tzdb$eurda$() {
  if ((!$n_Lzonedb_java_tzdb$eurda$)) {
    $n_Lzonedb_java_tzdb$eurda$ = new $c_Lzonedb_java_tzdb$eurda$()
  };
  return $n_Lzonedb_java_tzdb$eurda$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurdo$() {
  this.Lzonedb_java_tzdb$eurdo$__f_Europe_London = null;
  this.Lzonedb_java_tzdb$eurdo$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurdo$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-75)), $ct_T2__O__O__(new $c_T2(), "w", (-75)), $ct_T2__O__O__(new $c_T2(), "t", [[1847335, 0, (-75), 0], [1968300, 82800, 0, 3600], [1971304, 10800, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "l", [[1847335, 0, (-75), 0], [1916142, 7200, 0, 3600], [1916275, 10800, 3600, 0], [1917098, 7200, 0, 3600], [1917260, 10800, 3600, 0], [1918083, 7200, 0, 3600], [1918273, 10800, 3600, 0], [1919089, 7200, 0, 3600], [1919272, 10800, 3600, 0], [1920088, 7200, 0, 3600], [1920299, 10800, 3600, 0], [1921093, 7200, 0, 3600], [1921276, 10800, 3600, 0], [1922085, 7200, 0, 3600], [1922281, 10800, 3600, 0], [1923112, 7200, 0, 3600], [1923259, 10800, 3600, 0], [1924104, 7200, 0, 3600], [1924265, 10800, 3600, 0], [1925109, 7200, 0, 3600], [1925277, 10800, 3600, 0], [1926108, 7200, 0, 3600], [1926276, 10800, 3600, 0], [1927100, 7200, 0, 3600], [1927275, 10800, 3600, 0], [1928113, 7200, 0, 3600], [1928281, 10800, 3600, 0], [1929111, 7200, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932108, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933099, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934112, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935104, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937108, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938100, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1941124, 7200, 3600, 7200], [1941222, 10800, 7200, 3600], [1942095, 7200, 3600, 7200], [1942221, 10800, 7200, 3600], [1943094, 7200, 3600, 7200], [1943227, 10800, 7200, 3600], [1944093, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945196, 10800, 7200, 3600], [1945280, 10800, 3600, 0], [1946104, 7200, 0, 3600], [1946279, 10800, 3600, 0], [1947075, 7200, 0, 3600], [1947103, 7200, 3600, 7200], [1947222, 10800, 7200, 3600], [1947306, 10800, 3600, 0], [1948074, 7200, 0, 3600], [1948305, 10800, 3600, 0], [1949093, 7200, 0, 3600], [1949303, 10800, 3600, 0], [1950106, 7200, 0, 3600], [1950295, 10800, 3600, 0], [1951105, 7200, 0, 3600], [1951294, 10800, 3600, 0], [1952111, 7200, 0, 3600], [1952300, 10800, 3600, 0], [1953109, 7200, 0, 3600], [1953277, 10800, 3600, 0], [1954101, 7200, 0, 3600], [1954276, 10800, 3600, 0], [1955107, 7200, 0, 3600], [1955275, 10800, 3600, 0], [1956113, 7200, 0, 3600], [1956281, 10800, 3600, 0], [1957104, 7200, 0, 3600], [1957279, 10800, 3600, 0], [1958110, 7200, 0, 3600], [1958278, 10800, 3600, 0], [1959109, 7200, 0, 3600], [1959277, 10800, 3600, 0], [1960101, 7200, 0, 3600], [1960276, 10800, 3600, 0], [1961085, 7200, 0, 3600], [1961302, 10800, 3600, 0], [1962084, 7200, 0, 3600], [1962301, 10800, 3600, 0], [1963090, 7200, 0, 3600], [1963300, 10800, 3600, 0], [1964082, 7200, 0, 3600], [1964299, 10800, 3600, 0], [1965080, 7200, 0, 3600], [1965297, 10800, 3600, 0], [1966079, 7200, 0, 3600], [1966296, 10800, 3600, 0], [1967078, 7200, 0, 3600], [1967302, 10800, 3600, 0], [1968049, 7200, 0, 3600], [1971304, 10800, 3600, 0], [1972079, 7200, 0, 3600], [1972303, 10800, 3600, 0], [1973077, 7200, 0, 3600], [1973301, 10800, 3600, 0], [1974076, 7200, 0, 3600], [1974300, 10800, 3600, 0], [1975075, 7200, 0, 3600], [1975299, 10800, 3600, 0], [1976081, 7200, 0, 3600], [1976298, 10800, 3600, 0], [1977079, 7200, 0, 3600], [1977296, 10800, 3600, 0], [1978078, 7200, 0, 3600], [1978302, 10800, 3600, 0], [1979077, 7200, 0, 3600], [1979301, 10800, 3600, 0], [1980076, 7200, 0, 3600], [1980300, 10800, 3600, 0], [1981088, 3600, 0, 3600], [1981298, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982297, 7200, 3600, 0], [1983086, 3600, 0, 3600], [1983296, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984302, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985300, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986299, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987298, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988297, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989302, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990301, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991300, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992299, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993297, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994296, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995295, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 0, 0, 3600], [10, 25, 7, 3600, 0, 0, 0, 3600, 0]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurdo$__f_Europe_London = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurdo$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurdo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurdo$.prototype.constructor = $c_Lzonedb_java_tzdb$eurdo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurdo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurdo$.prototype = $c_Lzonedb_java_tzdb$eurdo$.prototype;
$c_Lzonedb_java_tzdb$eurdo$.prototype.Europe_London__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurdo$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 470")
  };
  return this.Lzonedb_java_tzdb$eurdo$__f_Europe_London
});
var $d_Lzonedb_java_tzdb$eurdo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurdo$: 0
}, false, "zonedb.java.tzdb$eurdo$", {
  Lzonedb_java_tzdb$eurdo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurdo$.prototype.$classData = $d_Lzonedb_java_tzdb$eurdo$;
var $n_Lzonedb_java_tzdb$eurdo$;
function $m_Lzonedb_java_tzdb$eurdo$() {
  if ((!$n_Lzonedb_java_tzdb$eurdo$)) {
    $n_Lzonedb_java_tzdb$eurdo$ = new $c_Lzonedb_java_tzdb$eurdo$()
  };
  return $n_Lzonedb_java_tzdb$eurdo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurel$() {
  this.Lzonedb_java_tzdb$eurel$__f_Europe_Brussels = null;
  this.Lzonedb_java_tzdb$eurel$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurel$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 1050), $ct_T2__O__O__(new $c_T2(), "w", 1050), $ct_T2__O__O__(new $c_T2(), "t", [[1892122, 1050, 1050, 0], [1914312, 0, 0, 3600], [1918315, 43200, 3600, 0], [1940141, 7200, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1892122, 1050, 1050, 0], [1914312, 0, 0, 3600], [1916122, 0, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1918315, 43200, 3600, 0], [1919060, 82800, 0, 3600], [1919278, 0, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 0, 3600, 0], [1921073, 82800, 0, 3600], [1921299, 0, 3600, 0], [1922084, 82800, 0, 3600], [1922281, 0, 3600, 0], [1923111, 82800, 0, 3600], [1923280, 0, 3600, 0], [1924089, 82800, 0, 3600], [1924279, 0, 3600, 0], [1925094, 82800, 0, 3600], [1925277, 0, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 0, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 0, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 10800, 3600, 0], [1929111, 7200, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932094, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933085, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934098, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935090, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937094, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938086, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1940141, 10800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1946139, 7200, 3600, 7200], [1946280, 10800, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurel$__f_Europe_Brussels = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurel$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurel$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurel$.prototype.constructor = $c_Lzonedb_java_tzdb$eurel$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurel$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurel$.prototype = $c_Lzonedb_java_tzdb$eurel$.prototype;
$c_Lzonedb_java_tzdb$eurel$.prototype.Europe_Brussels__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurel$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 720")
  };
  return this.Lzonedb_java_tzdb$eurel$__f_Europe_Brussels
});
var $d_Lzonedb_java_tzdb$eurel$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurel$: 0
}, false, "zonedb.java.tzdb$eurel$", {
  Lzonedb_java_tzdb$eurel$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurel$.prototype.$classData = $d_Lzonedb_java_tzdb$eurel$;
var $n_Lzonedb_java_tzdb$eurel$;
function $m_Lzonedb_java_tzdb$eurel$() {
  if ((!$n_Lzonedb_java_tzdb$eurel$)) {
    $n_Lzonedb_java_tzdb$eurel$ = new $c_Lzonedb_java_tzdb$eurel$()
  };
  return $n_Lzonedb_java_tzdb$eurel$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$euren$() {
  this.Lzonedb_java_tzdb$euren$__f_Europe_Athens = null;
  this.Lzonedb_java_tzdb$euren$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$euren$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 5692), $ct_T2__O__O__(new $c_T2(), "w", 5692), $ct_T2__O__O__(new $c_T2(), "t", [[1916210, 60, 5692, 7200], [1941119, 82800, 7200, 3600], [1944095, 0, 3600, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1916210, 60, 5692, 7200], [1932189, 0, 7200, 10800], [1932245, 0, 10800, 7200], [1941097, 0, 7200, 10800], [1941120, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943089, 0, 3600, 7200], [1943277, 0, 7200, 3600], [1944095, 0, 3600, 7200], [1952183, 0, 7200, 10800], [1952307, 0, 10800, 7200], [1975102, 0, 7200, 10800], [1975330, 3600, 10800, 7200], [1976102, 7200, 7200, 10800], [1976284, 10800, 10800, 7200], [1977093, 7200, 7200, 10800], [1977269, 10800, 10800, 7200], [1978092, 7200, 7200, 10800], [1978267, 14400, 10800, 7200], [1979091, 32400, 7200, 10800], [1979272, 7200, 10800, 7200], [1980092, 0, 7200, 10800], [1980272, 0, 10800, 7200], [1981088, 10800, 7200, 10800], [1981270, 14400, 10800, 7200], [1982087, 10800, 7200, 10800], [1982269, 14400, 10800, 7200], [1983086, 10800, 7200, 10800], [1983268, 14400, 10800, 7200], [1984085, 10800, 7200, 10800], [1984274, 14400, 10800, 7200], [1985090, 10800, 7200, 10800], [1985272, 14400, 10800, 7200], [1986089, 10800, 7200, 10800], [1986271, 14400, 10800, 7200], [1987088, 10800, 7200, 10800], [1987270, 14400, 10800, 7200], [1988087, 10800, 7200, 10800], [1988269, 14400, 10800, 7200], [1989085, 10800, 7200, 10800], [1989267, 14400, 10800, 7200], [1990084, 10800, 7200, 10800], [1990273, 14400, 10800, 7200], [1991090, 10800, 7200, 10800], [1991272, 14400, 10800, 7200], [1992089, 10800, 7200, 10800], [1992271, 14400, 10800, 7200], [1993087, 10800, 7200, 10800], [1993269, 14400, 10800, 7200], [1994086, 10800, 7200, 10800], [1994268, 14400, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$euren$__f_Europe_Athens = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$euren$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$euren$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$euren$.prototype.constructor = $c_Lzonedb_java_tzdb$euren$;
/** @constructor */
function $h_Lzonedb_java_tzdb$euren$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$euren$.prototype = $c_Lzonedb_java_tzdb$euren$.prototype;
$c_Lzonedb_java_tzdb$euren$.prototype.Europe_Athens__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$euren$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 210")
  };
  return this.Lzonedb_java_tzdb$euren$__f_Europe_Athens
});
var $d_Lzonedb_java_tzdb$euren$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$euren$: 0
}, false, "zonedb.java.tzdb$euren$", {
  Lzonedb_java_tzdb$euren$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$euren$.prototype.$classData = $d_Lzonedb_java_tzdb$euren$;
var $n_Lzonedb_java_tzdb$euren$;
function $m_Lzonedb_java_tzdb$euren$() {
  if ((!$n_Lzonedb_java_tzdb$euren$)) {
    $n_Lzonedb_java_tzdb$euren$ = new $c_Lzonedb_java_tzdb$euren$()
  };
  return $n_Lzonedb_java_tzdb$euren$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eures$() {
  this.Lzonedb_java_tzdb$eures$__f_Europe_Bucharest = null;
  this.Lzonedb_java_tzdb$eures$__f_Europe_Budapest = null;
  this.Lzonedb_java_tzdb$eures$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$eures$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 6264), $ct_T2__O__O__(new $c_T2(), "w", 6264), $ct_T2__O__O__(new $c_T2(), "t", [[1931205, 0, 6264, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1931205, 0, 6264, 7200], [1932142, 0, 7200, 10800], [1932276, 3600, 10800, 7200], [1933092, 0, 7200, 10800], [1933274, 3600, 10800, 7200], [1934098, 0, 7200, 10800], [1934280, 3600, 10800, 7200], [1935097, 0, 7200, 10800], [1935279, 3600, 10800, 7200], [1936096, 0, 7200, 10800], [1936278, 3600, 10800, 7200], [1937094, 0, 7200, 10800], [1937276, 3600, 10800, 7200], [1938093, 0, 7200, 10800], [1938275, 3600, 10800, 7200], [1939092, 0, 7200, 10800], [1939274, 3600, 10800, 7200], [1979147, 0, 7200, 10800], [1979273, 0, 10800, 7200], [1980096, 82800, 7200, 10800], [1980272, 3600, 10800, 7200], [1981088, 7200, 7200, 10800], [1981270, 10800, 10800, 7200], [1982087, 7200, 7200, 10800], [1982269, 10800, 10800, 7200], [1983086, 7200, 7200, 10800], [1983268, 10800, 10800, 7200], [1984085, 7200, 7200, 10800], [1984274, 10800, 10800, 7200], [1985090, 7200, 7200, 10800], [1985272, 10800, 10800, 7200], [1986089, 7200, 7200, 10800], [1986271, 10800, 10800, 7200], [1987088, 7200, 7200, 10800], [1987270, 10800, 10800, 7200], [1988087, 7200, 7200, 10800], [1988269, 10800, 10800, 7200], [1989085, 7200, 7200, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 0, 7200, 10800], [1991272, 3600, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 3600, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 3600, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996301, 0, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200], [1998088, 10800, 7200, 10800], [1998298, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eures$__f_Europe_Bucharest = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eures$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$eures$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 4580), $ct_T2__O__O__(new $c_T2(), "w", 4580), $ct_T2__O__O__(new $c_T2(), "t", [[1890274, 0, 4580, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890274, 0, 4580, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918091, 10800, 3600, 7200], [1918259, 10800, 7200, 3600], [1919105, 10800, 3600, 7200], [1919328, 10800, 7200, 3600], [1941098, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945121, 82800, 3600, 7200], [1945305, 0, 7200, 3600], [1946090, 7200, 3600, 7200], [1946279, 10800, 7200, 3600], [1947096, 7200, 3600, 7200], [1947278, 10800, 7200, 3600], [1948095, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1949100, 7200, 3600, 7200], [1949275, 10800, 7200, 3600], [1950107, 7200, 3600, 7200], [1950296, 10800, 7200, 3600], [1954143, 0, 3600, 7200], [1954276, 0, 7200, 3600], [1955143, 0, 3600, 7200], [1955276, 0, 7200, 3600], [1956155, 0, 3600, 7200], [1956274, 0, 7200, 3600], [1957153, 3600, 3600, 7200], [1957272, 10800, 7200, 3600], [1980097, 3600, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$eures$__f_Europe_Budapest = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$eures$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$eures$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$eures$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eures$.prototype.constructor = $c_Lzonedb_java_tzdb$eures$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eures$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eures$.prototype = $c_Lzonedb_java_tzdb$eures$.prototype;
$c_Lzonedb_java_tzdb$eures$.prototype.Europe_Bucharest__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$eures$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 365")
  };
  return this.Lzonedb_java_tzdb$eures$__f_Europe_Bucharest
});
$c_Lzonedb_java_tzdb$eures$.prototype.Europe_Budapest__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$eures$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 366")
  };
  return this.Lzonedb_java_tzdb$eures$__f_Europe_Budapest
});
var $d_Lzonedb_java_tzdb$eures$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eures$: 0
}, false, "zonedb.java.tzdb$eures$", {
  Lzonedb_java_tzdb$eures$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eures$.prototype.$classData = $d_Lzonedb_java_tzdb$eures$;
var $n_Lzonedb_java_tzdb$eures$;
function $m_Lzonedb_java_tzdb$eures$() {
  if ((!$n_Lzonedb_java_tzdb$eures$)) {
    $n_Lzonedb_java_tzdb$eures$ = new $c_Lzonedb_java_tzdb$eures$()
  };
  return $n_Lzonedb_java_tzdb$eures$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurfi$() {
  this.Lzonedb_java_tzdb$eurfi$__f_Europe_Sofia = null;
  this.Lzonedb_java_tzdb$eurfi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurfi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 5596), $ct_T2__O__O__(new $c_T2(), "w", 5596), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 5596, 7016], [1894334, 0, 7016, 7200], [1942306, 10800, 7200, 3600], [1945092, 10800, 3600, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 5596, 7016], [1894334, 0, 7016, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 10800, 3600, 7200], [1979090, 82800, 7200, 10800], [1979274, 3600, 10800, 7200], [1980096, 82800, 7200, 10800], [1980273, 3600, 10800, 7200], [1981094, 82800, 7200, 10800], [1981270, 7200, 10800, 7200], [1982093, 82800, 7200, 10800], [1982269, 10800, 10800, 7200], [1983086, 7200, 7200, 10800], [1983268, 10800, 10800, 7200], [1984085, 7200, 7200, 10800], [1984274, 10800, 10800, 7200], [1985090, 7200, 7200, 10800], [1985272, 10800, 10800, 7200], [1986089, 7200, 7200, 10800], [1986271, 10800, 10800, 7200], [1987088, 7200, 7200, 10800], [1987270, 10800, 10800, 7200], [1988087, 7200, 7200, 10800], [1988269, 10800, 10800, 7200], [1989085, 7200, 7200, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 0, 7200, 10800], [1991272, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996301, 0, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200], [1998088, 10800, 7200, 10800], [1998298, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurfi$__f_Europe_Sofia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurfi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurfi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurfi$.prototype.constructor = $c_Lzonedb_java_tzdb$eurfi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurfi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurfi$.prototype = $c_Lzonedb_java_tzdb$eurfi$.prototype;
$c_Lzonedb_java_tzdb$eurfi$.prototype.Europe_Sofia__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurfi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 761")
  };
  return this.Lzonedb_java_tzdb$eurfi$__f_Europe_Sofia
});
var $d_Lzonedb_java_tzdb$eurfi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurfi$: 0
}, false, "zonedb.java.tzdb$eurfi$", {
  Lzonedb_java_tzdb$eurfi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurfi$.prototype.$classData = $d_Lzonedb_java_tzdb$eurfi$;
var $n_Lzonedb_java_tzdb$eurfi$;
function $m_Lzonedb_java_tzdb$eurfi$() {
  if ((!$n_Lzonedb_java_tzdb$eurfi$)) {
    $n_Lzonedb_java_tzdb$eurfi$ = new $c_Lzonedb_java_tzdb$eurfi$()
  };
  return $n_Lzonedb_java_tzdb$eurfi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurge$() {
  this.Lzonedb_java_tzdb$eurge$__f_Europe_Copenhagen = null;
  this.Lzonedb_java_tzdb$eurge$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurge$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 3020), $ct_T2__O__O__(new $c_T2(), "w", 3020), $ct_T2__O__O__(new $c_T2(), "t", [[1894001, 0, 3020, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1894001, 0, 3020, 3600], [1916135, 82800, 3600, 7200], [1916274, 82800, 7200, 3600], [1940136, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945227, 10800, 7200, 3600], [1946121, 7200, 3600, 7200], [1946244, 10800, 7200, 3600], [1947124, 7200, 3600, 7200], [1947222, 10800, 7200, 3600], [1948130, 7200, 3600, 7200], [1948221, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurge$__f_Europe_Copenhagen = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurge$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurge$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurge$.prototype.constructor = $c_Lzonedb_java_tzdb$eurge$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurge$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurge$.prototype = $c_Lzonedb_java_tzdb$eurge$.prototype;
$c_Lzonedb_java_tzdb$eurge$.prototype.Europe_Copenhagen__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurge$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 244")
  };
  return this.Lzonedb_java_tzdb$eurge$__f_Europe_Copenhagen
});
var $d_Lzonedb_java_tzdb$eurge$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurge$: 0
}, false, "zonedb.java.tzdb$eurge$", {
  Lzonedb_java_tzdb$eurge$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurge$.prototype.$classData = $d_Lzonedb_java_tzdb$eurge$;
var $n_Lzonedb_java_tzdb$eurge$;
function $m_Lzonedb_java_tzdb$eurge$() {
  if ((!$n_Lzonedb_java_tzdb$eurge$)) {
    $n_Lzonedb_java_tzdb$eurge$ = new $c_Lzonedb_java_tzdb$eurge$()
  };
  return $n_Lzonedb_java_tzdb$eurge$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurgu$() {
  this.Lzonedb_java_tzdb$eurgu$__f_Europe_Prague = null;
  this.Lzonedb_java_tzdb$eurgu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurgu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 3464), $ct_T2__O__O__(new $c_T2(), "w", 3464), $ct_T2__O__O__(new $c_T2(), "t", [[1891274, 0, 3464, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1891274, 0, 3464, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945274, 10800, 7200, 3600], [1946126, 7200, 3600, 7200], [1946279, 10800, 7200, 3600], [1946335, 10800, 3600, 0], [1947054, 7200, 0, 3600], [1947110, 7200, 3600, 7200], [1947278, 10800, 7200, 3600], [1948109, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1949099, 7200, 3600, 7200], [1949275, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurgu$__f_Europe_Prague = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurgu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurgu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurgu$.prototype.constructor = $c_Lzonedb_java_tzdb$eurgu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurgu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurgu$.prototype = $c_Lzonedb_java_tzdb$eurgu$.prototype;
$c_Lzonedb_java_tzdb$eurgu$.prototype.Europe_Prague__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurgu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 487")
  };
  return this.Lzonedb_java_tzdb$eurgu$__f_Europe_Prague
});
var $d_Lzonedb_java_tzdb$eurgu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurgu$: 0
}, false, "zonedb.java.tzdb$eurgu$", {
  Lzonedb_java_tzdb$eurgu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurgu$.prototype.$classData = $d_Lzonedb_java_tzdb$eurgu$;
var $n_Lzonedb_java_tzdb$eurgu$;
function $m_Lzonedb_java_tzdb$eurgu$() {
  if ((!$n_Lzonedb_java_tzdb$eurgu$)) {
    $n_Lzonedb_java_tzdb$eurgu$ = new $c_Lzonedb_java_tzdb$eurgu$()
  };
  return $n_Lzonedb_java_tzdb$eurgu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurha$() {
  this.Lzonedb_java_tzdb$eurha$__f_Europe_Astrakhan = null;
  this.Lzonedb_java_tzdb$eurha$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurha$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 11532), $ct_T2__O__O__(new $c_T2(), "w", 11532), $ct_T2__O__O__(new $c_T2(), "t", [[1924122, 0, 11532, 10800], [1930172, 0, 10800, 14400], [1989085, 7200, 14400, 10800], [1991090, 7200, 10800, 14400], [1992089, 7200, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016087, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924122, 0, 11532, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991090, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016087, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurha$__f_Europe_Astrakhan = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurha$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurha$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurha$.prototype.constructor = $c_Lzonedb_java_tzdb$eurha$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurha$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurha$.prototype = $c_Lzonedb_java_tzdb$eurha$.prototype;
$c_Lzonedb_java_tzdb$eurha$.prototype.Europe_Astrakhan__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurha$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 473")
  };
  return this.Lzonedb_java_tzdb$eurha$__f_Europe_Astrakhan
});
var $d_Lzonedb_java_tzdb$eurha$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurha$: 0
}, false, "zonedb.java.tzdb$eurha$", {
  Lzonedb_java_tzdb$eurha$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurha$.prototype.$classData = $d_Lzonedb_java_tzdb$eurha$;
var $n_Lzonedb_java_tzdb$eurha$;
function $m_Lzonedb_java_tzdb$eurha$() {
  if ((!$n_Lzonedb_java_tzdb$eurha$)) {
    $n_Lzonedb_java_tzdb$eurha$ = new $c_Lzonedb_java_tzdb$eurha$()
  };
  return $n_Lzonedb_java_tzdb$eurha$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurhy$() {
  this.Lzonedb_java_tzdb$eurhy$__f_Europe_Zaporozhye = null;
  this.Lzonedb_java_tzdb$eurhy$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurhy$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8440), $ct_T2__O__O__(new $c_T2(), "w", 8440), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 8440, 8400], [1924123, 0, 8400, 7200], [1930172, 0, 7200, 10800], [1941237, 0, 10800, 3600], [1943298, 0, 3600, 10800], [1991090, 7200, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 8440, 8400], [1924123, 0, 8400, 7200], [1930172, 0, 7200, 10800], [1941237, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1943298, 0, 3600, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991272, 0, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurhy$__f_Europe_Zaporozhye = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurhy$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurhy$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurhy$.prototype.constructor = $c_Lzonedb_java_tzdb$eurhy$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurhy$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurhy$.prototype = $c_Lzonedb_java_tzdb$eurhy$.prototype;
$c_Lzonedb_java_tzdb$eurhy$.prototype.Europe_Zaporozhye__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurhy$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 216")
  };
  return this.Lzonedb_java_tzdb$eurhy$__f_Europe_Zaporozhye
});
var $d_Lzonedb_java_tzdb$eurhy$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurhy$: 0
}, false, "zonedb.java.tzdb$eurhy$", {
  Lzonedb_java_tzdb$eurhy$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurhy$.prototype.$classData = $d_Lzonedb_java_tzdb$eurhy$;
var $n_Lzonedb_java_tzdb$eurhy$;
function $m_Lzonedb_java_tzdb$eurhy$() {
  if ((!$n_Lzonedb_java_tzdb$eurhy$)) {
    $n_Lzonedb_java_tzdb$eurhy$ = new $c_Lzonedb_java_tzdb$eurhy$()
  };
  return $n_Lzonedb_java_tzdb$eurhy$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$euric$() {
  this.Lzonedb_java_tzdb$euric$__f_Europe_Zurich = null;
  this.Lzonedb_java_tzdb$euric$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$euric$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 2048), $ct_T2__O__O__(new $c_T2(), "w", 2048), $ct_T2__O__O__(new $c_T2(), "t", [[1853197, 0, 2048, 1786], [1894152, 0, 1786, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1853197, 0, 2048, 1786], [1894152, 0, 1786, 3600], [1941125, 3600, 3600, 7200], [1941279, 7200, 7200, 3600], [1942124, 3600, 3600, 7200], [1942278, 7200, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$euric$__f_Europe_Zurich = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$euric$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$euric$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$euric$.prototype.constructor = $c_Lzonedb_java_tzdb$euric$;
/** @constructor */
function $h_Lzonedb_java_tzdb$euric$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$euric$.prototype = $c_Lzonedb_java_tzdb$euric$.prototype;
$c_Lzonedb_java_tzdb$euric$.prototype.Europe_Zurich__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$euric$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 274")
  };
  return this.Lzonedb_java_tzdb$euric$__f_Europe_Zurich
});
var $d_Lzonedb_java_tzdb$euric$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$euric$: 0
}, false, "zonedb.java.tzdb$euric$", {
  Lzonedb_java_tzdb$euric$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$euric$.prototype.$classData = $d_Lzonedb_java_tzdb$euric$;
var $n_Lzonedb_java_tzdb$euric$;
function $m_Lzonedb_java_tzdb$euric$() {
  if ((!$n_Lzonedb_java_tzdb$euric$)) {
    $n_Lzonedb_java_tzdb$euric$ = new $c_Lzonedb_java_tzdb$euric$()
  };
  return $n_Lzonedb_java_tzdb$euric$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurie$() {
  this.Lzonedb_java_tzdb$eurie$__f_Europe_Kiev = null;
  this.Lzonedb_java_tzdb$eurie$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurie$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 7324), $ct_T2__O__O__(new $c_T2(), "w", 7324), $ct_T2__O__O__(new $c_T2(), "t", [[1924123, 0, 7324, 7200], [1930172, 0, 7200, 10800], [1941263, 0, 10800, 3600], [1943310, 0, 3600, 10800], [1990182, 3600, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1924123, 0, 7324, 7200], [1930172, 0, 7200, 10800], [1941263, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1943310, 0, 3600, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990182, 7200, 14400, 10800], [1991272, 10800, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurie$__f_Europe_Kiev = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurie$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurie$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurie$.prototype.constructor = $c_Lzonedb_java_tzdb$eurie$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurie$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurie$.prototype = $c_Lzonedb_java_tzdb$eurie$.prototype;
$c_Lzonedb_java_tzdb$eurie$.prototype.Europe_Kiev__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurie$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 856")
  };
  return this.Lzonedb_java_tzdb$eurie$__f_Europe_Kiev
});
var $d_Lzonedb_java_tzdb$eurie$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurie$: 0
}, false, "zonedb.java.tzdb$eurie$", {
  Lzonedb_java_tzdb$eurie$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurie$.prototype.$classData = $d_Lzonedb_java_tzdb$eurie$;
var $n_Lzonedb_java_tzdb$eurie$;
function $m_Lzonedb_java_tzdb$eurie$() {
  if ((!$n_Lzonedb_java_tzdb$eurie$)) {
    $n_Lzonedb_java_tzdb$eurie$ = new $c_Lzonedb_java_tzdb$eurie$()
  };
  return $n_Lzonedb_java_tzdb$eurie$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurig$() {
  this.Lzonedb_java_tzdb$eurig$__f_Europe_Riga = null;
  this.Lzonedb_java_tzdb$eurig$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurig$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 5794), $ct_T2__O__O__(new $c_T2(), "w", 5794), $ct_T2__O__O__(new $c_T2(), "t", [[1926131, 0, 5794, 7200], [1940218, 0, 7200, 10800], [1941182, 0, 10800, 3600], [1944287, 0, 3600, 10800], [1989085, 7200, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1918105, 7200, 5794, 9394], [1918259, 10800, 9394, 5794], [1919091, 7200, 5794, 9394], [1919142, 10800, 9394, 5794], [1926131, 0, 5794, 7200], [1940218, 0, 7200, 10800], [1941182, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1944287, 0, 3600, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996273, 10800, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200], [1998088, 10800, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200], [2001084, 10800, 7200, 10800], [2001301, 14400, 10800, 7200], [2002090, 10800, 7200, 10800], [2002300, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurig$__f_Europe_Riga = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurig$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurig$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurig$.prototype.constructor = $c_Lzonedb_java_tzdb$eurig$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurig$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurig$.prototype = $c_Lzonedb_java_tzdb$eurig$.prototype;
$c_Lzonedb_java_tzdb$eurig$.prototype.Europe_Riga__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurig$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 231")
  };
  return this.Lzonedb_java_tzdb$eurig$__f_Europe_Riga
});
var $d_Lzonedb_java_tzdb$eurig$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurig$: 0
}, false, "zonedb.java.tzdb$eurig$", {
  Lzonedb_java_tzdb$eurig$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurig$.prototype.$classData = $d_Lzonedb_java_tzdb$eurig$;
var $n_Lzonedb_java_tzdb$eurig$;
function $m_Lzonedb_java_tzdb$eurig$() {
  if ((!$n_Lzonedb_java_tzdb$eurig$)) {
    $n_Lzonedb_java_tzdb$eurig$ = new $c_Lzonedb_java_tzdb$eurig$()
  };
  return $n_Lzonedb_java_tzdb$eurig$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurin$() {
  this.Lzonedb_java_tzdb$eurin$__f_Europe_Tallinn = null;
  this.Lzonedb_java_tzdb$eurin$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurin$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 5940), $ct_T2__O__O__(new $c_T2(), "w", 5940), $ct_T2__O__O__(new $c_T2(), "t", [[1918032, 0, 5940, 3600], [1919182, 0, 3600, 5940], [1921121, 0, 5940, 7200], [1940219, 0, 7200, 10800], [1941258, 0, 10800, 3600], [1944265, 82800, 3600, 10800], [1989085, 7200, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1918032, 0, 5940, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1919182, 0, 3600, 5940], [1921121, 0, 5940, 7200], [1940219, 0, 7200, 10800], [1941258, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944266, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996301, 10800, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998088, 7200, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200], [2002090, 10800, 7200, 10800], [2002300, 14400, 10800, 7200], [2003089, 10800, 7200, 10800], [2003299, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurin$__f_Europe_Tallinn = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurin$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurin$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurin$.prototype.constructor = $c_Lzonedb_java_tzdb$eurin$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurin$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurin$.prototype = $c_Lzonedb_java_tzdb$eurin$.prototype;
$c_Lzonedb_java_tzdb$eurin$.prototype.Europe_Tallinn__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurin$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 301")
  };
  return this.Lzonedb_java_tzdb$eurin$__f_Europe_Tallinn
});
var $d_Lzonedb_java_tzdb$eurin$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurin$: 0
}, false, "zonedb.java.tzdb$eurin$", {
  Lzonedb_java_tzdb$eurin$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurin$.prototype.$classData = $d_Lzonedb_java_tzdb$eurin$;
var $n_Lzonedb_java_tzdb$eurin$;
function $m_Lzonedb_java_tzdb$eurin$() {
  if ((!$n_Lzonedb_java_tzdb$eurin$)) {
    $n_Lzonedb_java_tzdb$eurin$ = new $c_Lzonedb_java_tzdb$eurin$()
  };
  return $n_Lzonedb_java_tzdb$eurin$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$euriu$() {
  this.Lzonedb_java_tzdb$euriu$__f_Europe_Vilnius = null;
  this.Lzonedb_java_tzdb$euriu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$euriu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 6076), $ct_T2__O__O__(new $c_T2(), "w", 6076), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 6076, 5040], [1917001, 0, 5040, 5736], [1919283, 0, 5736, 3600], [1920194, 0, 3600, 7200], [1920283, 0, 7200, 3600], [1940216, 0, 3600, 10800], [1941175, 0, 10800, 3600], [1944213, 82800, 3600, 10800], [1989085, 7200, 10800, 7200], [1998088, 10800, 7200, 3600], [1999304, 7200, 3600, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 6076, 5040], [1917001, 0, 5040, 5736], [1919283, 0, 5736, 3600], [1920194, 0, 3600, 7200], [1920283, 0, 7200, 3600], [1940216, 0, 3600, 10800], [1941175, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944214, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996301, 10800, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998298, 10800, 7200, 3600], [1999087, 7200, 3600, 7200], [2003089, 10800, 7200, 10800], [2003299, 14400, 10800, 7200], [2004088, 10800, 7200, 10800], [2004305, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$euriu$__f_Europe_Vilnius = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$euriu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$euriu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$euriu$.prototype.constructor = $c_Lzonedb_java_tzdb$euriu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$euriu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$euriu$.prototype = $c_Lzonedb_java_tzdb$euriu$.prototype;
$c_Lzonedb_java_tzdb$euriu$.prototype.Europe_Vilnius__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$euriu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 119")
  };
  return this.Lzonedb_java_tzdb$euriu$__f_Europe_Vilnius
});
var $d_Lzonedb_java_tzdb$euriu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$euriu$: 0
}, false, "zonedb.java.tzdb$euriu$", {
  Lzonedb_java_tzdb$euriu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$euriu$.prototype.$classData = $d_Lzonedb_java_tzdb$euriu$;
var $n_Lzonedb_java_tzdb$euriu$;
function $m_Lzonedb_java_tzdb$euriu$() {
  if ((!$n_Lzonedb_java_tzdb$euriu$)) {
    $n_Lzonedb_java_tzdb$euriu$ = new $c_Lzonedb_java_tzdb$euriu$()
  };
  return $n_Lzonedb_java_tzdb$euriu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurli$() {
  this.Lzonedb_java_tzdb$eurli$__f_Europe_Dublin = null;
  this.Lzonedb_java_tzdb$eurli$__f_Europe_Berlin = null;
  this.Lzonedb_java_tzdb$eurli$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$eurli$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-1500)), $ct_T2__O__O__(new $c_T2(), "w", (-1500)), $ct_T2__O__O__(new $c_T2(), "t", [[1880215, 0, (-1500), (-1521)], [1916275, 7200, (-1521), 0], [1968300, 82800, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880215, 0, (-1500), (-1521)], [1916142, 7200, (-1521), 2079], [1916275, 10800, 2079, 0], [1917098, 7200, 0, 3600], [1917260, 10800, 3600, 0], [1918083, 7200, 0, 3600], [1918273, 10800, 3600, 0], [1919089, 7200, 0, 3600], [1919272, 10800, 3600, 0], [1920088, 7200, 0, 3600], [1920299, 10800, 3600, 0], [1921093, 7200, 0, 3600], [1921276, 10800, 3600, 0], [1922085, 7200, 0, 3600], [1922281, 10800, 3600, 0], [1923112, 7200, 0, 3600], [1923259, 10800, 3600, 0], [1924104, 7200, 0, 3600], [1924265, 10800, 3600, 0], [1925109, 7200, 0, 3600], [1925277, 10800, 3600, 0], [1926108, 7200, 0, 3600], [1926276, 10800, 3600, 0], [1927100, 7200, 0, 3600], [1927275, 10800, 3600, 0], [1928113, 7200, 0, 3600], [1928281, 10800, 3600, 0], [1929111, 7200, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932108, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933099, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934112, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935104, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937108, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938100, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1946279, 10800, 3600, 0], [1947075, 7200, 0, 3600], [1947306, 10800, 3600, 0], [1948109, 7200, 0, 3600], [1948305, 10800, 3600, 0], [1949093, 7200, 0, 3600], [1949303, 10800, 3600, 0], [1950106, 7200, 0, 3600], [1950295, 10800, 3600, 0], [1951105, 7200, 0, 3600], [1951294, 10800, 3600, 0], [1952111, 7200, 0, 3600], [1952300, 10800, 3600, 0], [1953109, 7200, 0, 3600], [1953277, 10800, 3600, 0], [1954101, 7200, 0, 3600], [1954276, 10800, 3600, 0], [1955107, 7200, 0, 3600], [1955275, 10800, 3600, 0], [1956113, 7200, 0, 3600], [1956281, 10800, 3600, 0], [1957104, 7200, 0, 3600], [1957279, 10800, 3600, 0], [1958110, 7200, 0, 3600], [1958278, 10800, 3600, 0], [1959109, 7200, 0, 3600], [1959277, 10800, 3600, 0], [1960101, 7200, 0, 3600], [1960276, 10800, 3600, 0], [1961085, 7200, 0, 3600], [1961302, 10800, 3600, 0], [1962084, 7200, 0, 3600], [1962301, 10800, 3600, 0], [1963090, 7200, 0, 3600], [1963300, 10800, 3600, 0], [1964082, 7200, 0, 3600], [1964299, 10800, 3600, 0], [1965080, 7200, 0, 3600], [1965297, 10800, 3600, 0], [1966079, 7200, 0, 3600], [1966296, 10800, 3600, 0], [1967078, 7200, 0, 3600], [1967302, 10800, 3600, 0], [1968049, 7200, 0, 3600], [1971304, 10800, 3600, 0], [1972079, 7200, 0, 3600], [1972303, 10800, 3600, 0], [1973077, 7200, 0, 3600], [1973301, 10800, 3600, 0], [1974076, 7200, 0, 3600], [1974300, 10800, 3600, 0], [1975075, 7200, 0, 3600], [1975299, 10800, 3600, 0], [1976081, 7200, 0, 3600], [1976298, 10800, 3600, 0], [1977079, 7200, 0, 3600], [1977296, 10800, 3600, 0], [1978078, 7200, 0, 3600], [1978302, 10800, 3600, 0], [1979077, 7200, 0, 3600], [1979301, 10800, 3600, 0], [1980076, 7200, 0, 3600], [1980300, 10800, 3600, 0], [1981088, 3600, 0, 3600], [1981298, 7200, 3600, 0], [1982087, 3600, 0, 3600], [1982297, 7200, 3600, 0], [1983086, 3600, 0, 3600], [1983296, 7200, 3600, 0], [1984085, 3600, 0, 3600], [1984302, 7200, 3600, 0], [1985090, 3600, 0, 3600], [1985300, 7200, 3600, 0], [1986089, 3600, 0, 3600], [1986299, 7200, 3600, 0], [1987088, 3600, 0, 3600], [1987298, 7200, 3600, 0], [1988087, 3600, 0, 3600], [1988297, 7200, 3600, 0], [1989085, 3600, 0, 3600], [1989302, 7200, 3600, 0], [1990084, 3600, 0, 3600], [1990301, 7200, 3600, 0], [1991090, 3600, 0, 3600], [1991300, 7200, 3600, 0], [1992089, 3600, 0, 3600], [1992299, 7200, 3600, 0], [1993087, 3600, 0, 3600], [1993297, 7200, 3600, 0], [1994086, 3600, 0, 3600], [1994296, 7200, 3600, 0], [1995085, 3600, 0, 3600], [1995295, 7200, 3600, 0], [1996091, 3600, 0, 3600], [1996301, 7200, 3600, 0], [1997089, 3600, 0, 3600], [1997299, 7200, 3600, 0]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 0, 3600], [10, 25, 7, 3600, 0, 0, 3600, 3600, 0]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurli$__f_Europe_Dublin = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurli$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$eurli$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 3208), $ct_T2__O__O__(new $c_T2(), "w", 3208), $ct_T2__O__O__(new $c_T2(), "t", [[1893091, 0, 3208, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1893091, 0, 3208, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945144, 7200, 7200, 10800], [1945267, 10800, 10800, 7200], [1945322, 10800, 7200, 3600], [1946104, 7200, 3600, 7200], [1946280, 10800, 7200, 3600], [1947096, 10800, 3600, 7200], [1947131, 10800, 7200, 10800], [1947180, 10800, 10800, 7200], [1947278, 10800, 7200, 3600], [1948109, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1949100, 7200, 3600, 7200], [1949275, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$eurli$__f_Europe_Berlin = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$eurli$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$eurli$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$eurli$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurli$.prototype.constructor = $c_Lzonedb_java_tzdb$eurli$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurli$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurli$.prototype = $c_Lzonedb_java_tzdb$eurli$.prototype;
$c_Lzonedb_java_tzdb$eurli$.prototype.Europe_Dublin__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$eurli$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 592")
  };
  return this.Lzonedb_java_tzdb$eurli$__f_Europe_Dublin
});
$c_Lzonedb_java_tzdb$eurli$.prototype.Europe_Berlin__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$eurli$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 593")
  };
  return this.Lzonedb_java_tzdb$eurli$__f_Europe_Berlin
});
var $d_Lzonedb_java_tzdb$eurli$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurli$: 0
}, false, "zonedb.java.tzdb$eurli$", {
  Lzonedb_java_tzdb$eurli$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurli$.prototype.$classData = $d_Lzonedb_java_tzdb$eurli$;
var $n_Lzonedb_java_tzdb$eurli$;
function $m_Lzonedb_java_tzdb$eurli$() {
  if ((!$n_Lzonedb_java_tzdb$eurli$)) {
    $n_Lzonedb_java_tzdb$eurli$ = new $c_Lzonedb_java_tzdb$eurli$()
  };
  return $n_Lzonedb_java_tzdb$eurli$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurlt$() {
  this.Lzonedb_java_tzdb$eurlt$__f_Europe_Malta = null;
  this.Lzonedb_java_tzdb$eurlt$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurlt$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 3484), $ct_T2__O__O__(new $c_T2(), "w", 3484), $ct_T2__O__O__(new $c_T2(), "t", [[1893306, 0, 3484, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1893306, 0, 3484, 3600], [1916156, 0, 3600, 7200], [1916275, 0, 7200, 3600], [1917091, 0, 3600, 7200], [1917274, 0, 7200, 3600], [1918069, 0, 3600, 7200], [1918280, 0, 7200, 3600], [1919061, 0, 3600, 7200], [1919278, 0, 7200, 3600], [1920081, 0, 3600, 7200], [1920263, 0, 7200, 3600], [1940167, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944093, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945258, 3600, 7200, 3600], [1946076, 7200, 3600, 7200], [1946279, 10800, 7200, 3600], [1947075, 0, 3600, 7200], [1947278, 3600, 7200, 3600], [1948060, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1966142, 0, 3600, 7200], [1966268, 0, 7200, 3600], [1967148, 0, 3600, 7200], [1967267, 3600, 7200, 3600], [1968147, 0, 3600, 7200], [1968266, 3600, 7200, 3600], [1969152, 0, 3600, 7200], [1969271, 3600, 7200, 3600], [1970151, 0, 3600, 7200], [1970270, 3600, 7200, 3600], [1971143, 0, 3600, 7200], [1971269, 3600, 7200, 3600], [1972149, 0, 3600, 7200], [1972275, 3600, 7200, 3600], [1973090, 0, 3600, 7200], [1973272, 3600, 7200, 3600], [1974111, 0, 3600, 7200], [1974259, 3600, 7200, 3600], [1975110, 7200, 3600, 7200], [1975264, 7200, 7200, 3600], [1976109, 7200, 3600, 7200], [1976263, 7200, 7200, 3600], [1977107, 7200, 3600, 7200], [1977261, 7200, 7200, 3600], [1978106, 7200, 3600, 7200], [1978260, 7200, 7200, 3600], [1979105, 7200, 3600, 7200], [1979259, 7200, 7200, 3600], [1980091, 7200, 3600, 7200], [1980265, 7200, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurlt$__f_Europe_Malta = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurlt$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurlt$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurlt$.prototype.constructor = $c_Lzonedb_java_tzdb$eurlt$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurlt$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurlt$.prototype = $c_Lzonedb_java_tzdb$eurlt$.prototype;
$c_Lzonedb_java_tzdb$eurlt$.prototype.Europe_Malta__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurlt$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 195")
  };
  return this.Lzonedb_java_tzdb$eurlt$__f_Europe_Malta
});
var $d_Lzonedb_java_tzdb$eurlt$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurlt$: 0
}, false, "zonedb.java.tzdb$eurlt$", {
  Lzonedb_java_tzdb$eurlt$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurlt$.prototype.$classData = $d_Lzonedb_java_tzdb$eurlt$;
var $n_Lzonedb_java_tzdb$eurlt$;
function $m_Lzonedb_java_tzdb$eurlt$() {
  if ((!$n_Lzonedb_java_tzdb$eurlt$)) {
    $n_Lzonedb_java_tzdb$eurlt$ = new $c_Lzonedb_java_tzdb$eurlt$()
  };
  return $n_Lzonedb_java_tzdb$eurlt$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurna$() {
  this.Lzonedb_java_tzdb$eurna$__f_Europe_Chisinau = null;
  this.Lzonedb_java_tzdb$eurna$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurna$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 6920), $ct_T2__O__O__(new $c_T2(), "w", 6920), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 6920, 6900], [1918046, 0, 6900, 6264], [1931205, 0, 6264, 7200], [1941197, 82800, 7200, 3600], [1944236, 82800, 3600, 10800], [1990126, 3600, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 6920, 6900], [1918046, 0, 6900, 6264], [1931205, 0, 6264, 7200], [1932142, 0, 7200, 10800], [1932276, 3600, 10800, 7200], [1933092, 0, 7200, 10800], [1933274, 3600, 10800, 7200], [1934098, 0, 7200, 10800], [1934280, 3600, 10800, 7200], [1935097, 0, 7200, 10800], [1935279, 3600, 10800, 7200], [1936096, 0, 7200, 10800], [1936278, 3600, 10800, 7200], [1937094, 0, 7200, 10800], [1937276, 3600, 10800, 7200], [1938093, 0, 7200, 10800], [1938275, 3600, 10800, 7200], [1939092, 0, 7200, 10800], [1939274, 3600, 10800, 7200], [1940228, 0, 7200, 10800], [1941198, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944237, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990126, 7200, 14400, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 0, 7200, 10800], [1995267, 0, 10800, 7200], [1996091, 0, 7200, 10800], [1996301, 0, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998088, 7200, 7200, 10800], [1998298, 10800, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 7200, 0, 1, 7200, 7200, 10800], [10, 25, 7, 10800, 0, 1, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurna$__f_Europe_Chisinau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurna$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurna$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurna$.prototype.constructor = $c_Lzonedb_java_tzdb$eurna$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurna$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurna$.prototype = $c_Lzonedb_java_tzdb$eurna$.prototype;
$c_Lzonedb_java_tzdb$eurna$.prototype.Europe_Chisinau__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurna$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 225")
  };
  return this.Lzonedb_java_tzdb$eurna$__f_Europe_Chisinau
});
var $d_Lzonedb_java_tzdb$eurna$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurna$: 0
}, false, "zonedb.java.tzdb$eurna$", {
  Lzonedb_java_tzdb$eurna$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurna$.prototype.$classData = $d_Lzonedb_java_tzdb$eurna$;
var $n_Lzonedb_java_tzdb$eurna$;
function $m_Lzonedb_java_tzdb$eurna$() {
  if ((!$n_Lzonedb_java_tzdb$eurna$)) {
    $n_Lzonedb_java_tzdb$eurna$ = new $c_Lzonedb_java_tzdb$eurna$()
  };
  return $n_Lzonedb_java_tzdb$eurna$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurnk$() {
  this.Lzonedb_java_tzdb$eurnk$__f_Europe_Helsinki = null;
  this.Lzonedb_java_tzdb$eurnk$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurnk$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 5989), $ct_T2__O__O__(new $c_T2(), "w", 5989), $ct_T2__O__O__(new $c_T2(), "t", [[1921121, 0, 5989, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921121, 0, 5989, 7200], [1942093, 0, 7200, 10800], [1942277, 3600, 10800, 7200], [1981088, 7200, 7200, 10800], [1981270, 10800, 10800, 7200], [1982087, 7200, 7200, 10800], [1982269, 10800, 10800, 7200], [1983086, 10800, 7200, 10800], [1983268, 14400, 10800, 7200], [1984085, 10800, 7200, 10800], [1984274, 14400, 10800, 7200], [1985090, 10800, 7200, 10800], [1985272, 14400, 10800, 7200], [1986089, 10800, 7200, 10800], [1986271, 14400, 10800, 7200], [1987088, 10800, 7200, 10800], [1987270, 14400, 10800, 7200], [1988087, 10800, 7200, 10800], [1988269, 14400, 10800, 7200], [1989085, 10800, 7200, 10800], [1989267, 14400, 10800, 7200], [1990084, 10800, 7200, 10800], [1990273, 14400, 10800, 7200], [1991090, 10800, 7200, 10800], [1991272, 14400, 10800, 7200], [1992089, 10800, 7200, 10800], [1992271, 14400, 10800, 7200], [1993087, 10800, 7200, 10800], [1993269, 14400, 10800, 7200], [1994086, 10800, 7200, 10800], [1994268, 14400, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurnk$__f_Europe_Helsinki = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurnk$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurnk$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurnk$.prototype.constructor = $c_Lzonedb_java_tzdb$eurnk$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurnk$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurnk$.prototype = $c_Lzonedb_java_tzdb$eurnk$.prototype;
$c_Lzonedb_java_tzdb$eurnk$.prototype.Europe_Helsinki__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurnk$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 557")
  };
  return this.Lzonedb_java_tzdb$eurnk$__f_Europe_Helsinki
});
var $d_Lzonedb_java_tzdb$eurnk$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurnk$: 0
}, false, "zonedb.java.tzdb$eurnk$", {
  Lzonedb_java_tzdb$eurnk$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurnk$.prototype.$classData = $d_Lzonedb_java_tzdb$eurnk$;
var $n_Lzonedb_java_tzdb$eurnk$;
function $m_Lzonedb_java_tzdb$eurnk$() {
  if ((!$n_Lzonedb_java_tzdb$eurnk$)) {
    $n_Lzonedb_java_tzdb$eurnk$ = new $c_Lzonedb_java_tzdb$eurnk$()
  };
  return $n_Lzonedb_java_tzdb$eurnk$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurnn$() {
  this.Lzonedb_java_tzdb$eurnn$__f_Europe_Vienna = null;
  this.Lzonedb_java_tzdb$eurnn$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurnn$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 3921), $ct_T2__O__O__(new $c_T2(), "w", 3921), $ct_T2__O__O__(new $c_T2(), "t", [[1893091, 0, 3921, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1893091, 0, 3921, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1920096, 7200, 3600, 7200], [1920257, 10800, 7200, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945102, 10800, 7200, 3600], [1946104, 7200, 3600, 7200], [1946280, 10800, 7200, 3600], [1947096, 7200, 3600, 7200], [1947278, 10800, 7200, 3600], [1948109, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1980097, 0, 3600, 7200], [1980272, 0, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurnn$__f_Europe_Vienna = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurnn$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurnn$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurnn$.prototype.constructor = $c_Lzonedb_java_tzdb$eurnn$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurnn$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurnn$.prototype = $c_Lzonedb_java_tzdb$eurnn$.prototype;
$c_Lzonedb_java_tzdb$eurnn$.prototype.Europe_Vienna__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurnn$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 897")
  };
  return this.Lzonedb_java_tzdb$eurnn$__f_Europe_Vienna
});
var $d_Lzonedb_java_tzdb$eurnn$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurnn$: 0
}, false, "zonedb.java.tzdb$eurnn$", {
  Lzonedb_java_tzdb$eurnn$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurnn$.prototype.$classData = $d_Lzonedb_java_tzdb$eurnn$;
var $n_Lzonedb_java_tzdb$eurnn$;
function $m_Lzonedb_java_tzdb$eurnn$() {
  if ((!$n_Lzonedb_java_tzdb$eurnn$)) {
    $n_Lzonedb_java_tzdb$eurnn$ = new $c_Lzonedb_java_tzdb$eurnn$()
  };
  return $n_Lzonedb_java_tzdb$eurnn$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurns$() {
  this.Lzonedb_java_tzdb$eurns$__f_Europe_Minsk = null;
  this.Lzonedb_java_tzdb$eurns$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurns$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 6616), $ct_T2__O__O__(new $c_T2(), "w", 6616), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 6616, 6600], [1924123, 0, 6600, 7200], [1930172, 0, 7200, 10800], [1941179, 0, 10800, 3600], [1944184, 82800, 3600, 10800], [1991090, 7200, 10800, 7200], [2011086, 7200, 7200, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 6616, 6600], [1924123, 0, 6600, 7200], [1930172, 0, 7200, 10800], [1941179, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944185, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996301, 10800, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998088, 7200, 7200, 10800], [1998298, 10800, 10800, 7200], [1999087, 7200, 7200, 10800], [1999304, 10800, 10800, 7200], [2000086, 7200, 7200, 10800], [2000303, 10800, 10800, 7200], [2001084, 7200, 7200, 10800], [2001301, 10800, 10800, 7200], [2002090, 7200, 7200, 10800], [2002300, 10800, 10800, 7200], [2003089, 7200, 7200, 10800], [2003299, 10800, 10800, 7200], [2004088, 7200, 7200, 10800], [2004305, 10800, 10800, 7200], [2005086, 7200, 7200, 10800], [2005303, 10800, 10800, 7200], [2006085, 7200, 7200, 10800], [2006302, 10800, 10800, 7200], [2007084, 7200, 7200, 10800], [2007301, 10800, 10800, 7200], [2008090, 7200, 7200, 10800], [2008300, 10800, 10800, 7200], [2009088, 7200, 7200, 10800], [2009298, 10800, 10800, 7200], [2010087, 7200, 7200, 10800], [2010304, 10800, 10800, 7200], [2011086, 7200, 7200, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurns$__f_Europe_Minsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurns$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurns$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurns$.prototype.constructor = $c_Lzonedb_java_tzdb$eurns$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurns$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurns$.prototype = $c_Lzonedb_java_tzdb$eurns$.prototype;
$c_Lzonedb_java_tzdb$eurns$.prototype.Europe_Minsk__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurns$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 134")
  };
  return this.Lzonedb_java_tzdb$eurns$__f_Europe_Minsk
});
var $d_Lzonedb_java_tzdb$eurns$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurns$: 0
}, false, "zonedb.java.tzdb$eurns$", {
  Lzonedb_java_tzdb$eurns$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurns$.prototype.$classData = $d_Lzonedb_java_tzdb$eurns$;
var $n_Lzonedb_java_tzdb$eurns$;
function $m_Lzonedb_java_tzdb$eurns$() {
  if ((!$n_Lzonedb_java_tzdb$eurns$)) {
    $n_Lzonedb_java_tzdb$eurns$ = new $c_Lzonedb_java_tzdb$eurns$()
  };
  return $n_Lzonedb_java_tzdb$eurns$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurol$() {
  this.Lzonedb_java_tzdb$eurol$__f_Europe_Stockholm = null;
  this.Lzonedb_java_tzdb$eurol$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurol$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 4332), $ct_T2__O__O__(new $c_T2(), "w", 4332), $ct_T2__O__O__(new $c_T2(), "t", [[1879001, 0, 4332, 3614], [1900001, 0, 3614, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1879001, 0, 4332, 3614], [1900001, 0, 3614, 3600], [1916135, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurol$__f_Europe_Stockholm = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurol$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurol$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurol$.prototype.constructor = $c_Lzonedb_java_tzdb$eurol$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurol$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurol$.prototype = $c_Lzonedb_java_tzdb$eurol$.prototype;
$c_Lzonedb_java_tzdb$eurol$.prototype.Europe_Stockholm__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurol$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 177")
  };
  return this.Lzonedb_java_tzdb$eurol$__f_Europe_Stockholm
});
var $d_Lzonedb_java_tzdb$eurol$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurol$: 0
}, false, "zonedb.java.tzdb$eurol$", {
  Lzonedb_java_tzdb$eurol$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurol$.prototype.$classData = $d_Lzonedb_java_tzdb$eurol$;
var $n_Lzonedb_java_tzdb$eurol$;
function $m_Lzonedb_java_tzdb$eurol$() {
  if ((!$n_Lzonedb_java_tzdb$eurol$)) {
    $n_Lzonedb_java_tzdb$eurol$ = new $c_Lzonedb_java_tzdb$eurol$()
  };
  return $n_Lzonedb_java_tzdb$eurol$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurom$() {
  this.Lzonedb_java_tzdb$eurom$__f_Europe_Rome = null;
  this.Lzonedb_java_tzdb$eurom$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurom$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 2996), $ct_T2__O__O__(new $c_T2(), "w", 2996), $ct_T2__O__O__(new $c_T2(), "t", [[1893304, 85796, 2996, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1893304, 85796, 2996, 3600], [1916156, 0, 3600, 7200], [1916275, 0, 7200, 3600], [1917091, 0, 3600, 7200], [1917274, 0, 7200, 3600], [1918069, 0, 3600, 7200], [1918280, 0, 7200, 3600], [1919061, 0, 3600, 7200], [1919278, 0, 7200, 3600], [1920081, 0, 3600, 7200], [1920263, 0, 7200, 3600], [1940167, 0, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945258, 3600, 7200, 3600], [1946076, 7200, 3600, 7200], [1946279, 10800, 7200, 3600], [1947075, 0, 3600, 7200], [1947278, 3600, 7200, 3600], [1948060, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1966142, 0, 3600, 7200], [1966268, 0, 7200, 3600], [1967148, 0, 3600, 7200], [1967267, 3600, 7200, 3600], [1968147, 0, 3600, 7200], [1968266, 3600, 7200, 3600], [1969152, 0, 3600, 7200], [1969271, 3600, 7200, 3600], [1970151, 0, 3600, 7200], [1970270, 3600, 7200, 3600], [1971143, 0, 3600, 7200], [1971269, 3600, 7200, 3600], [1972149, 0, 3600, 7200], [1972275, 3600, 7200, 3600], [1973154, 0, 3600, 7200], [1973273, 3600, 7200, 3600], [1974146, 0, 3600, 7200], [1974272, 3600, 7200, 3600], [1975152, 0, 3600, 7200], [1975271, 3600, 7200, 3600], [1976151, 0, 3600, 7200], [1976270, 3600, 7200, 3600], [1977142, 0, 3600, 7200], [1977268, 3600, 7200, 3600], [1978148, 0, 3600, 7200], [1978274, 3600, 7200, 3600], [1979147, 0, 3600, 7200], [1979273, 3600, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurom$__f_Europe_Rome = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurom$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurom$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurom$.prototype.constructor = $c_Lzonedb_java_tzdb$eurom$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurom$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurom$.prototype = $c_Lzonedb_java_tzdb$eurom$.prototype;
$c_Lzonedb_java_tzdb$eurom$.prototype.Europe_Rome__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurom$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 344")
  };
  return this.Lzonedb_java_tzdb$eurom$__f_Europe_Rome
});
var $d_Lzonedb_java_tzdb$eurom$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurom$: 0
}, false, "zonedb.java.tzdb$eurom$", {
  Lzonedb_java_tzdb$eurom$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurom$.prototype.$classData = $d_Lzonedb_java_tzdb$eurom$;
var $n_Lzonedb_java_tzdb$eurom$;
function $m_Lzonedb_java_tzdb$eurom$() {
  if ((!$n_Lzonedb_java_tzdb$eurom$)) {
    $n_Lzonedb_java_tzdb$eurom$ = new $c_Lzonedb_java_tzdb$eurom$()
  };
  return $n_Lzonedb_java_tzdb$eurom$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurpo$() {
  this.Lzonedb_java_tzdb$eurpo$__f_Europe_Simferopol = null;
  this.Lzonedb_java_tzdb$eurpo$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurpo$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 8184), $ct_T2__O__O__(new $c_T2(), "w", 8184), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 8184, 8160], [1924123, 0, 8160, 7200], [1930172, 0, 7200, 10800], [1941305, 0, 10800, 3600], [1944103, 82800, 3600, 10800], [1990182, 7200, 10800, 7200], [1994120, 82800, 7200, 10800], [1997089, 14400, 10800, 7200], [2014089, 7200, 7200, 14400], [2014299, 7200, 14400, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 8184, 8160], [1924123, 0, 8160, 7200], [1930172, 0, 7200, 10800], [1941305, 0, 10800, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944104, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990182, 7200, 10800, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994121, 0, 10800, 14400], [1994268, 0, 14400, 10800], [1995085, 0, 10800, 14400], [1995267, 0, 14400, 10800], [1996091, 0, 10800, 14400], [1996301, 14400, 14400, 10800], [1997299, 14400, 10800, 7200], [1998088, 10800, 7200, 10800], [1998298, 14400, 10800, 7200], [1999087, 10800, 7200, 10800], [1999304, 14400, 10800, 7200], [2000086, 10800, 7200, 10800], [2000303, 14400, 10800, 7200], [2001084, 10800, 7200, 10800], [2001301, 14400, 10800, 7200], [2002090, 10800, 7200, 10800], [2002300, 14400, 10800, 7200], [2003089, 10800, 7200, 10800], [2003299, 14400, 10800, 7200], [2004088, 10800, 7200, 10800], [2004305, 14400, 10800, 7200], [2005086, 10800, 7200, 10800], [2005303, 14400, 10800, 7200], [2006085, 10800, 7200, 10800], [2006302, 14400, 10800, 7200], [2007084, 10800, 7200, 10800], [2007301, 14400, 10800, 7200], [2008090, 10800, 7200, 10800], [2008300, 14400, 10800, 7200], [2009088, 10800, 7200, 10800], [2009298, 14400, 10800, 7200], [2010087, 10800, 7200, 10800], [2010304, 14400, 10800, 7200], [2011086, 10800, 7200, 10800], [2011303, 14400, 10800, 7200], [2012085, 10800, 7200, 10800], [2012302, 14400, 10800, 7200], [2013090, 10800, 7200, 10800], [2013300, 14400, 10800, 7200], [2014089, 7200, 7200, 14400], [2014299, 7200, 14400, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurpo$__f_Europe_Simferopol = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurpo$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurpo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurpo$.prototype.constructor = $c_Lzonedb_java_tzdb$eurpo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurpo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurpo$.prototype = $c_Lzonedb_java_tzdb$eurpo$.prototype;
$c_Lzonedb_java_tzdb$eurpo$.prototype.Europe_Simferopol__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurpo$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 280")
  };
  return this.Lzonedb_java_tzdb$eurpo$__f_Europe_Simferopol
});
var $d_Lzonedb_java_tzdb$eurpo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurpo$: 0
}, false, "zonedb.java.tzdb$eurpo$", {
  Lzonedb_java_tzdb$eurpo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurpo$.prototype.$classData = $d_Lzonedb_java_tzdb$eurpo$;
var $n_Lzonedb_java_tzdb$eurpo$;
function $m_Lzonedb_java_tzdb$eurpo$() {
  if ((!$n_Lzonedb_java_tzdb$eurpo$)) {
    $n_Lzonedb_java_tzdb$eurpo$ = new $c_Lzonedb_java_tzdb$eurpo$()
  };
  return $n_Lzonedb_java_tzdb$eurpo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurra$() {
  this.Lzonedb_java_tzdb$eurra$__f_Europe_Volgograd = null;
  this.Lzonedb_java_tzdb$eurra$__f_Europe_Kaliningrad = null;
  this.Lzonedb_java_tzdb$eurra$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$eurra$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 10660), $ct_T2__O__O__(new $c_T2(), "w", 10660), $ct_T2__O__O__(new $c_T2(), "t", [[1920003, 0, 10660, 10800], [1930172, 0, 10800, 14400], [1988087, 7200, 14400, 10800], [1991090, 7200, 10800, 14400], [1992089, 7200, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2018301, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1920003, 0, 10660, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991090, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2018301, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurra$__f_Europe_Volgograd = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurra$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$eurra$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 4920), $ct_T2__O__O__(new $c_T2(), "w", 4920), $ct_T2__O__O__(new $c_T2(), "t", [[1893091, 0, 4920, 3600], [1945099, 82800, 3600, 7200], [1946097, 0, 7200, 10800], [1989085, 7200, 10800, 7200], [2011086, 7200, 7200, 10800], [2014299, 7200, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1893091, 0, 4920, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945119, 0, 7200, 10800], [1945305, 0, 10800, 7200], [1946097, 0, 7200, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989267, 10800, 10800, 7200], [1990084, 7200, 7200, 10800], [1990273, 10800, 10800, 7200], [1991090, 7200, 7200, 10800], [1991272, 10800, 10800, 7200], [1992089, 7200, 7200, 10800], [1992271, 10800, 10800, 7200], [1993087, 7200, 7200, 10800], [1993269, 10800, 10800, 7200], [1994086, 7200, 7200, 10800], [1994268, 10800, 10800, 7200], [1995085, 7200, 7200, 10800], [1995267, 10800, 10800, 7200], [1996091, 7200, 7200, 10800], [1996301, 10800, 10800, 7200], [1997089, 7200, 7200, 10800], [1997299, 10800, 10800, 7200], [1998088, 7200, 7200, 10800], [1998298, 10800, 10800, 7200], [1999087, 7200, 7200, 10800], [1999304, 10800, 10800, 7200], [2000086, 7200, 7200, 10800], [2000303, 10800, 10800, 7200], [2001084, 7200, 7200, 10800], [2001301, 10800, 10800, 7200], [2002090, 7200, 7200, 10800], [2002300, 10800, 10800, 7200], [2003089, 7200, 7200, 10800], [2003299, 10800, 10800, 7200], [2004088, 7200, 7200, 10800], [2004305, 10800, 10800, 7200], [2005086, 7200, 7200, 10800], [2005303, 10800, 10800, 7200], [2006085, 7200, 7200, 10800], [2006302, 10800, 10800, 7200], [2007084, 7200, 7200, 10800], [2007301, 10800, 10800, 7200], [2008090, 7200, 7200, 10800], [2008300, 10800, 10800, 7200], [2009088, 7200, 7200, 10800], [2009298, 10800, 10800, 7200], [2010087, 7200, 7200, 10800], [2010304, 10800, 10800, 7200], [2011086, 7200, 7200, 10800], [2014299, 7200, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$eurra$__f_Europe_Kaliningrad = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$eurra$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$eurra$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$eurra$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurra$.prototype.constructor = $c_Lzonedb_java_tzdb$eurra$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurra$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurra$.prototype = $c_Lzonedb_java_tzdb$eurra$.prototype;
$c_Lzonedb_java_tzdb$eurra$.prototype.Europe_Volgograd__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$eurra$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 460")
  };
  return this.Lzonedb_java_tzdb$eurra$__f_Europe_Volgograd
});
$c_Lzonedb_java_tzdb$eurra$.prototype.Europe_Kaliningrad__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$eurra$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 461")
  };
  return this.Lzonedb_java_tzdb$eurra$__f_Europe_Kaliningrad
});
var $d_Lzonedb_java_tzdb$eurra$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurra$: 0
}, false, "zonedb.java.tzdb$eurra$", {
  Lzonedb_java_tzdb$eurra$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurra$.prototype.$classData = $d_Lzonedb_java_tzdb$eurra$;
var $n_Lzonedb_java_tzdb$eurra$;
function $m_Lzonedb_java_tzdb$eurra$() {
  if ((!$n_Lzonedb_java_tzdb$eurra$)) {
    $n_Lzonedb_java_tzdb$eurra$ = new $c_Lzonedb_java_tzdb$eurra$()
  };
  return $n_Lzonedb_java_tzdb$eurra$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurri$() {
  this.Lzonedb_java_tzdb$eurri$__f_Europe_Madrid = null;
  this.Lzonedb_java_tzdb$eurri$__f_Europe_Paris = null;
  this.Lzonedb_java_tzdb$eurri$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$eurri$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-884)), $ct_T2__O__O__(new $c_T2(), "w", (-884)), $ct_T2__O__O__(new $c_T2(), "t", [[1900365, 85516, (-884), 0], [1940076, 82800, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1900365, 85516, (-884), 0], [1918105, 82800, 0, 3600], [1918280, 3600, 3600, 0], [1919096, 82800, 0, 3600], [1919280, 3600, 3600, 0], [1924107, 82800, 0, 3600], [1924279, 3600, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 3600, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 3600, 3600, 0], [1928106, 0, 0, 3600], [1928281, 3600, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 3600, 3600, 0], [1937167, 82800, 0, 3600], [1937276, 3600, 3600, 0], [1938092, 82800, 0, 3600], [1938120, 82800, 3600, 7200], [1938276, 0, 7200, 3600], [1939281, 3600, 3600, 0], [1940076, 82800, 0, 3600], [1942122, 82800, 3600, 7200], [1942244, 3600, 7200, 3600], [1943107, 82800, 3600, 7200], [1943276, 3600, 7200, 3600], [1944106, 82800, 3600, 7200], [1944275, 3600, 7200, 3600], [1945104, 82800, 3600, 7200], [1945273, 3600, 7200, 3600], [1946103, 82800, 3600, 7200], [1946272, 3600, 7200, 3600], [1949120, 82800, 3600, 7200], [1949275, 3600, 7200, 3600], [1974103, 82800, 3600, 7200], [1974279, 3600, 7200, 3600], [1975102, 82800, 3600, 7200], [1975278, 3600, 7200, 3600], [1976087, 82800, 3600, 7200], [1976270, 3600, 7200, 3600], [1977092, 82800, 3600, 7200], [1977268, 3600, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurri$__f_Europe_Madrid = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurri$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$eurri$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 561), $ct_T2__O__O__(new $c_T2(), "w", 561), $ct_T2__O__O__(new $c_T2(), "t", [[1911070, 60, 561, 0], [1940166, 79200, 0, 3600], [1944237, 82800, 3600, 0], [1945259, 3600, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1911070, 60, 561, 0], [1916166, 82800, 0, 3600], [1916276, 0, 3600, 0], [1917083, 82800, 0, 3600], [1917281, 0, 3600, 0], [1918068, 82800, 0, 3600], [1918280, 0, 3600, 0], [1919060, 82800, 0, 3600], [1919279, 0, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 0, 3600, 0], [1921073, 82800, 0, 3600], [1921299, 0, 3600, 0], [1922084, 82800, 0, 3600], [1922281, 0, 3600, 0], [1923146, 82800, 0, 3600], [1923280, 0, 3600, 0], [1924089, 82800, 0, 3600], [1924279, 0, 3600, 0], [1925094, 82800, 0, 3600], [1925277, 0, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 0, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 0, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 0, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 0, 3600, 0], [1930102, 82800, 0, 3600], [1930278, 0, 3600, 0], [1931108, 82800, 0, 3600], [1931277, 0, 3600, 0], [1932093, 82800, 0, 3600], [1932276, 0, 3600, 0], [1933084, 82800, 0, 3600], [1933281, 0, 3600, 0], [1934097, 82800, 0, 3600], [1934280, 0, 3600, 0], [1935089, 82800, 0, 3600], [1935279, 0, 3600, 0], [1936109, 82800, 0, 3600], [1936278, 0, 3600, 0], [1937093, 82800, 0, 3600], [1937276, 0, 3600, 0], [1938085, 82800, 0, 3600], [1938275, 0, 3600, 0], [1939105, 82800, 0, 3600], [1939323, 0, 3600, 0], [1940056, 7200, 0, 3600], [1940166, 82800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944282, 3600, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1976088, 3600, 3600, 7200], [1976270, 3600, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$eurri$__f_Europe_Paris = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$eurri$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$eurri$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$eurri$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurri$.prototype.constructor = $c_Lzonedb_java_tzdb$eurri$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurri$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurri$.prototype = $c_Lzonedb_java_tzdb$eurri$.prototype;
$c_Lzonedb_java_tzdb$eurri$.prototype.Europe_Madrid__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$eurri$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 832")
  };
  return this.Lzonedb_java_tzdb$eurri$__f_Europe_Madrid
});
$c_Lzonedb_java_tzdb$eurri$.prototype.Europe_Paris__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$eurri$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 833")
  };
  return this.Lzonedb_java_tzdb$eurri$__f_Europe_Paris
});
var $d_Lzonedb_java_tzdb$eurri$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurri$: 0
}, false, "zonedb.java.tzdb$eurri$", {
  Lzonedb_java_tzdb$eurri$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurri$.prototype.$classData = $d_Lzonedb_java_tzdb$eurri$;
var $n_Lzonedb_java_tzdb$eurri$;
function $m_Lzonedb_java_tzdb$eurri$() {
  if ((!$n_Lzonedb_java_tzdb$eurri$)) {
    $n_Lzonedb_java_tzdb$eurri$ = new $c_Lzonedb_java_tzdb$eurri$()
  };
  return $n_Lzonedb_java_tzdb$eurri$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurro$() {
  this.Lzonedb_java_tzdb$eurro$__f_Europe_Uzhgorod = null;
  this.Lzonedb_java_tzdb$eurro$__f_Europe_Kirov = null;
  this.Lzonedb_java_tzdb$eurro$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$eurro$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 5352), $ct_T2__O__O__(new $c_T2(), "w", 5352), $ct_T2__O__O__(new $c_T2(), "t", [[1890274, 0, 5352, 3600], [1945180, 0, 3600, 10800], [1990182, 7200, 10800, 3600], [1991090, 10800, 3600, 7200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1890274, 0, 5352, 3600], [1940092, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944300, 0, 7200, 3600], [1945180, 0, 3600, 10800], [1981091, 0, 10800, 14400], [1981274, 0, 14400, 10800], [1982091, 0, 10800, 14400], [1982274, 0, 14400, 10800], [1983091, 0, 10800, 14400], [1983274, 0, 14400, 10800], [1984092, 0, 10800, 14400], [1984274, 10800, 14400, 10800], [1985090, 7200, 10800, 14400], [1985272, 10800, 14400, 10800], [1986089, 7200, 10800, 14400], [1986271, 10800, 14400, 10800], [1987088, 7200, 10800, 14400], [1987270, 10800, 14400, 10800], [1988087, 7200, 10800, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990182, 7200, 10800, 3600], [1991090, 10800, 3600, 7200], [1992089, 0, 7200, 10800], [1992271, 0, 10800, 7200], [1993087, 0, 7200, 10800], [1993269, 0, 10800, 7200], [1994086, 0, 7200, 10800], [1994268, 0, 10800, 7200], [1995085, 10800, 7200, 10800], [1995267, 14400, 10800, 7200], [1996091, 10800, 7200, 10800], [1996301, 14400, 10800, 7200], [1997089, 10800, 7200, 10800], [1997299, 14400, 10800, 7200]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 7200, 7200, 10800], [10, 25, 7, 3600, 0, 0, 7200, 10800, 7200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurro$__f_Europe_Uzhgorod = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurro$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$eurro$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 11928), $ct_T2__O__O__(new $c_T2(), "w", 11928), $ct_T2__O__O__(new $c_T2(), "t", [[1919182, 11928, 11928, 10800], [1930172, 0, 10800, 14400], [1989085, 7200, 14400, 10800], [1991090, 7200, 10800, 14400], [1992089, 7200, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919182, 11928, 11928, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991090, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$eurro$__f_Europe_Kirov = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$eurro$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$eurro$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$eurro$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurro$.prototype.constructor = $c_Lzonedb_java_tzdb$eurro$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurro$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurro$.prototype = $c_Lzonedb_java_tzdb$eurro$.prototype;
$c_Lzonedb_java_tzdb$eurro$.prototype.Europe_Uzhgorod__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$eurro$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 264")
  };
  return this.Lzonedb_java_tzdb$eurro$__f_Europe_Uzhgorod
});
$c_Lzonedb_java_tzdb$eurro$.prototype.Europe_Kirov__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$eurro$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 265")
  };
  return this.Lzonedb_java_tzdb$eurro$__f_Europe_Kirov
});
var $d_Lzonedb_java_tzdb$eurro$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurro$: 0
}, false, "zonedb.java.tzdb$eurro$", {
  Lzonedb_java_tzdb$eurro$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurro$.prototype.$classData = $d_Lzonedb_java_tzdb$eurro$;
var $n_Lzonedb_java_tzdb$eurro$;
function $m_Lzonedb_java_tzdb$eurro$() {
  if ((!$n_Lzonedb_java_tzdb$eurro$)) {
    $n_Lzonedb_java_tzdb$eurro$ = new $c_Lzonedb_java_tzdb$eurro$()
  };
  return $n_Lzonedb_java_tzdb$eurro$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurrr$() {
  this.Lzonedb_java_tzdb$eurrr$__f_Europe_Andorra = null;
  this.Lzonedb_java_tzdb$eurrr$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurrr$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 364), $ct_T2__O__O__(new $c_T2(), "w", 364), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 364, 0], [1946273, 0, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 364, 0], [1946273, 0, 0, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurrr$__f_Europe_Andorra = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurrr$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurrr$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurrr$.prototype.constructor = $c_Lzonedb_java_tzdb$eurrr$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurrr$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurrr$.prototype = $c_Lzonedb_java_tzdb$eurrr$.prototype;
$c_Lzonedb_java_tzdb$eurrr$.prototype.Europe_Andorra__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurrr$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 198")
  };
  return this.Lzonedb_java_tzdb$eurrr$__f_Europe_Andorra
});
var $d_Lzonedb_java_tzdb$eurrr$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurrr$: 0
}, false, "zonedb.java.tzdb$eurrr$", {
  Lzonedb_java_tzdb$eurrr$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurrr$.prototype.$classData = $d_Lzonedb_java_tzdb$eurrr$;
var $n_Lzonedb_java_tzdb$eurrr$;
function $m_Lzonedb_java_tzdb$eurrr$() {
  if ((!$n_Lzonedb_java_tzdb$eurrr$)) {
    $n_Lzonedb_java_tzdb$eurrr$ = new $c_Lzonedb_java_tzdb$eurrr$()
  };
  return $n_Lzonedb_java_tzdb$eurrr$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eursa$() {
  this.Lzonedb_java_tzdb$eursa$__f_Europe_Warsaw = null;
  this.Lzonedb_java_tzdb$eursa$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eursa$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 5040), $ct_T2__O__O__(new $c_T2(), "w", 5040), $ct_T2__O__O__(new $c_T2(), "t", [[1915217, 0, 5040, 3600], [1918259, 7200, 3600, 7200], [1922152, 0, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1915217, 0, 5040, 3600], [1916121, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917106, 7200, 3600, 7200], [1917260, 10800, 7200, 3600], [1918105, 7200, 3600, 7200], [1919105, 7200, 7200, 10800], [1919259, 10800, 10800, 7200], [1922152, 0, 7200, 3600], [1940175, 7200, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944278, 7200, 7200, 3600], [1945119, 0, 3600, 7200], [1945305, 0, 7200, 3600], [1946104, 0, 3600, 7200], [1946280, 10800, 7200, 3600], [1947124, 7200, 3600, 7200], [1947278, 10800, 7200, 3600], [1948109, 7200, 3600, 7200], [1948277, 10800, 7200, 3600], [1949100, 7200, 3600, 7200], [1949275, 10800, 7200, 3600], [1957153, 3600, 3600, 7200], [1957272, 7200, 7200, 3600], [1958089, 3600, 3600, 7200], [1958271, 7200, 7200, 3600], [1959151, 3600, 3600, 7200], [1959277, 7200, 7200, 3600], [1960094, 3600, 3600, 7200], [1960276, 7200, 7200, 3600], [1961148, 3600, 3600, 7200], [1961274, 7200, 7200, 3600], [1962147, 3600, 3600, 7200], [1962273, 7200, 7200, 3600], [1963146, 3600, 3600, 7200], [1963272, 7200, 7200, 3600], [1964152, 3600, 3600, 7200], [1964271, 7200, 7200, 3600], [1977093, 3600, 3600, 7200], [1977268, 7200, 7200, 3600], [1978092, 3600, 3600, 7200], [1978274, 7200, 7200, 3600], [1979091, 3600, 3600, 7200], [1979273, 7200, 7200, 3600], [1980097, 3600, 3600, 7200], [1980272, 7200, 7200, 3600], [1981088, 3600, 3600, 7200], [1981270, 7200, 7200, 3600], [1982087, 3600, 3600, 7200], [1982269, 7200, 7200, 3600], [1983086, 3600, 3600, 7200], [1983268, 7200, 7200, 3600], [1984085, 3600, 3600, 7200], [1984274, 7200, 7200, 3600], [1985090, 3600, 3600, 7200], [1985272, 7200, 7200, 3600], [1986089, 3600, 3600, 7200], [1986271, 7200, 7200, 3600], [1987088, 3600, 3600, 7200], [1987270, 7200, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eursa$__f_Europe_Warsaw = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eursa$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eursa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eursa$.prototype.constructor = $c_Lzonedb_java_tzdb$eursa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eursa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eursa$.prototype = $c_Lzonedb_java_tzdb$eursa$.prototype;
$c_Lzonedb_java_tzdb$eursa$.prototype.Europe_Warsaw__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eursa$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 47")
  };
  return this.Lzonedb_java_tzdb$eursa$__f_Europe_Warsaw
});
var $d_Lzonedb_java_tzdb$eursa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eursa$: 0
}, false, "zonedb.java.tzdb$eursa$", {
  Lzonedb_java_tzdb$eursa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eursa$.prototype.$classData = $d_Lzonedb_java_tzdb$eursa$;
var $n_Lzonedb_java_tzdb$eursa$;
function $m_Lzonedb_java_tzdb$eursa$() {
  if ((!$n_Lzonedb_java_tzdb$eursa$)) {
    $n_Lzonedb_java_tzdb$eursa$ = new $c_Lzonedb_java_tzdb$eursa$()
  };
  return $n_Lzonedb_java_tzdb$eursa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eursl$() {
  this.Lzonedb_java_tzdb$eursl$__f_Europe_Oslo = null;
  this.Lzonedb_java_tzdb$eursl$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eursl$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 2580), $ct_T2__O__O__(new $c_T2(), "w", 2580), $ct_T2__O__O__(new $c_T2(), "t", [[1895001, 0, 2580, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895001, 0, 2580, 3600], [1916143, 3600, 3600, 7200], [1916274, 0, 7200, 3600], [1940223, 82800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944276, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945274, 10800, 7200, 3600], [1959074, 7200, 3600, 7200], [1959263, 10800, 7200, 3600], [1960080, 7200, 3600, 7200], [1960262, 10800, 7200, 3600], [1961078, 7200, 3600, 7200], [1961260, 10800, 7200, 3600], [1962077, 7200, 3600, 7200], [1962259, 10800, 7200, 3600], [1963076, 7200, 3600, 7200], [1963258, 10800, 7200, 3600], [1964075, 7200, 3600, 7200], [1964264, 10800, 7200, 3600], [1965115, 7200, 3600, 7200], [1965262, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eursl$__f_Europe_Oslo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eursl$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eursl$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eursl$.prototype.constructor = $c_Lzonedb_java_tzdb$eursl$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eursl$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eursl$.prototype = $c_Lzonedb_java_tzdb$eursl$.prototype;
$c_Lzonedb_java_tzdb$eursl$.prototype.Europe_Oslo__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eursl$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 189")
  };
  return this.Lzonedb_java_tzdb$eursl$__f_Europe_Oslo
});
var $d_Lzonedb_java_tzdb$eursl$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eursl$: 0
}, false, "zonedb.java.tzdb$eursl$", {
  Lzonedb_java_tzdb$eursl$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eursl$.prototype.$classData = $d_Lzonedb_java_tzdb$eursl$;
var $n_Lzonedb_java_tzdb$eursl$;
function $m_Lzonedb_java_tzdb$eursl$() {
  if ((!$n_Lzonedb_java_tzdb$eursl$)) {
    $n_Lzonedb_java_tzdb$eursl$ = new $c_Lzonedb_java_tzdb$eursl$()
  };
  return $n_Lzonedb_java_tzdb$eursl$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurta$() {
  this.Lzonedb_java_tzdb$eurta$__f_Europe_Gibraltar = null;
  this.Lzonedb_java_tzdb$eurta$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurta$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-1284)), $ct_T2__O__O__(new $c_T2(), "w", (-1284)), $ct_T2__O__O__(new $c_T2(), "t", [[1880215, 0, (-1284), 0], [1957104, 7200, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880215, 0, (-1284), 0], [1916142, 7200, 0, 3600], [1916275, 10800, 3600, 0], [1917098, 7200, 0, 3600], [1917260, 10800, 3600, 0], [1918083, 7200, 0, 3600], [1918273, 10800, 3600, 0], [1919089, 7200, 0, 3600], [1919272, 10800, 3600, 0], [1920088, 7200, 0, 3600], [1920299, 10800, 3600, 0], [1921093, 7200, 0, 3600], [1921276, 10800, 3600, 0], [1922085, 7200, 0, 3600], [1922281, 10800, 3600, 0], [1923112, 7200, 0, 3600], [1923259, 10800, 3600, 0], [1924104, 7200, 0, 3600], [1924265, 10800, 3600, 0], [1925109, 7200, 0, 3600], [1925277, 10800, 3600, 0], [1926108, 7200, 0, 3600], [1926276, 10800, 3600, 0], [1927100, 7200, 0, 3600], [1927275, 10800, 3600, 0], [1928113, 7200, 0, 3600], [1928281, 10800, 3600, 0], [1929111, 7200, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932108, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933099, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934112, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935104, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937108, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938100, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1941124, 7200, 3600, 7200], [1941222, 10800, 7200, 3600], [1942095, 7200, 3600, 7200], [1942221, 10800, 7200, 3600], [1943094, 7200, 3600, 7200], [1943227, 10800, 7200, 3600], [1944093, 7200, 3600, 7200], [1944261, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945196, 10800, 7200, 3600], [1945280, 10800, 3600, 0], [1946104, 7200, 0, 3600], [1946279, 10800, 3600, 0], [1947075, 7200, 0, 3600], [1947103, 7200, 3600, 7200], [1947222, 10800, 7200, 3600], [1947306, 10800, 3600, 0], [1948074, 7200, 0, 3600], [1948305, 10800, 3600, 0], [1949093, 7200, 0, 3600], [1949303, 10800, 3600, 0], [1950106, 7200, 0, 3600], [1950295, 10800, 3600, 0], [1951105, 7200, 0, 3600], [1951294, 10800, 3600, 0], [1952111, 7200, 0, 3600], [1952300, 10800, 3600, 0], [1953109, 7200, 0, 3600], [1953277, 10800, 3600, 0], [1954101, 7200, 0, 3600], [1954276, 10800, 3600, 0], [1955107, 7200, 0, 3600], [1955275, 10800, 3600, 0], [1956113, 7200, 0, 3600], [1956281, 10800, 3600, 0], [1957104, 7200, 0, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurta$__f_Europe_Gibraltar = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurta$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurta$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurta$.prototype.constructor = $c_Lzonedb_java_tzdb$eurta$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurta$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurta$.prototype = $c_Lzonedb_java_tzdb$eurta$.prototype;
$c_Lzonedb_java_tzdb$eurta$.prototype.Europe_Gibraltar__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurta$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 680")
  };
  return this.Lzonedb_java_tzdb$eurta$__f_Europe_Gibraltar
});
var $d_Lzonedb_java_tzdb$eurta$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurta$: 0
}, false, "zonedb.java.tzdb$eurta$", {
  Lzonedb_java_tzdb$eurta$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurta$.prototype.$classData = $d_Lzonedb_java_tzdb$eurta$;
var $n_Lzonedb_java_tzdb$eurta$;
function $m_Lzonedb_java_tzdb$eurta$() {
  if ((!$n_Lzonedb_java_tzdb$eurta$)) {
    $n_Lzonedb_java_tzdb$eurta$ = new $c_Lzonedb_java_tzdb$eurta$()
  };
  return $n_Lzonedb_java_tzdb$eurta$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurto$() {
  this.Lzonedb_java_tzdb$eurto$__f_Europe_Saratov = null;
  this.Lzonedb_java_tzdb$eurto$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurto$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 11058), $ct_T2__O__O__(new $c_T2(), "w", 11058), $ct_T2__O__O__(new $c_T2(), "t", [[1919182, 11058, 11058, 10800], [1930172, 0, 10800, 14400], [1988087, 7200, 14400, 10800], [1991090, 7200, 10800, 14400], [1992089, 7200, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016339, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919182, 11058, 11058, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988269, 10800, 14400, 10800], [1989085, 7200, 10800, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991090, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016339, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurto$__f_Europe_Saratov = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurto$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurto$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurto$.prototype.constructor = $c_Lzonedb_java_tzdb$eurto$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurto$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurto$.prototype = $c_Lzonedb_java_tzdb$eurto$.prototype;
$c_Lzonedb_java_tzdb$eurto$.prototype.Europe_Saratov__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurto$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 500")
  };
  return this.Lzonedb_java_tzdb$eurto$__f_Europe_Saratov
});
var $d_Lzonedb_java_tzdb$eurto$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurto$: 0
}, false, "zonedb.java.tzdb$eurto$", {
  Lzonedb_java_tzdb$eurto$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurto$.prototype.$classData = $d_Lzonedb_java_tzdb$eurto$;
var $n_Lzonedb_java_tzdb$eurto$;
function $m_Lzonedb_java_tzdb$eurto$() {
  if ((!$n_Lzonedb_java_tzdb$eurto$)) {
    $n_Lzonedb_java_tzdb$eurto$ = new $c_Lzonedb_java_tzdb$eurto$()
  };
  return $n_Lzonedb_java_tzdb$eurto$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurur$() {
  this.Lzonedb_java_tzdb$eurur$__f_Europe_Luxembourg = null;
  this.Lzonedb_java_tzdb$eurur$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurur$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 1476), $ct_T2__O__O__(new $c_T2(), "w", 1476), $ct_T2__O__O__(new $c_T2(), "t", [[1904153, 0, 1476, 3600], [1918329, 0, 3600, 0], [1940135, 7200, 0, 3600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1904153, 0, 1476, 3600], [1916135, 82800, 3600, 7200], [1916275, 3600, 7200, 3600], [1917118, 82800, 3600, 7200], [1917260, 3600, 7200, 3600], [1918105, 7200, 3600, 7200], [1918259, 10800, 7200, 3600], [1918329, 0, 3600, 0], [1919060, 82800, 0, 3600], [1919278, 10800, 3600, 0], [1920045, 82800, 0, 3600], [1920298, 7200, 3600, 0], [1921073, 82800, 0, 3600], [1921299, 7200, 3600, 0], [1922084, 82800, 0, 3600], [1922281, 3600, 3600, 0], [1923111, 82800, 0, 3600], [1923280, 7200, 3600, 0], [1924089, 82800, 0, 3600], [1924279, 3600, 3600, 0], [1925095, 82800, 0, 3600], [1925277, 3600, 3600, 0], [1926107, 82800, 0, 3600], [1926276, 3600, 3600, 0], [1927099, 82800, 0, 3600], [1927275, 3600, 3600, 0], [1928105, 82800, 0, 3600], [1928281, 3600, 3600, 0], [1929110, 82800, 0, 3600], [1929279, 10800, 3600, 0], [1930103, 7200, 0, 3600], [1930278, 10800, 3600, 0], [1931109, 7200, 0, 3600], [1931277, 10800, 3600, 0], [1932094, 7200, 0, 3600], [1932276, 10800, 3600, 0], [1933085, 7200, 0, 3600], [1933281, 10800, 3600, 0], [1934098, 7200, 0, 3600], [1934280, 10800, 3600, 0], [1935090, 7200, 0, 3600], [1935279, 10800, 3600, 0], [1936110, 7200, 0, 3600], [1936278, 10800, 3600, 0], [1937094, 7200, 0, 3600], [1937276, 10800, 3600, 0], [1938086, 7200, 0, 3600], [1938275, 10800, 3600, 0], [1939106, 7200, 0, 3600], [1939323, 10800, 3600, 0], [1940056, 7200, 0, 3600], [1940135, 10800, 3600, 7200], [1942306, 10800, 7200, 3600], [1943088, 7200, 3600, 7200], [1943277, 10800, 7200, 3600], [1944094, 7200, 3600, 7200], [1944262, 10800, 7200, 3600], [1945092, 7200, 3600, 7200], [1945259, 10800, 7200, 3600], [1946139, 7200, 3600, 7200], [1946280, 10800, 7200, 3600], [1977093, 7200, 3600, 7200], [1977268, 10800, 7200, 3600], [1978092, 7200, 3600, 7200], [1978274, 10800, 7200, 3600], [1979091, 7200, 3600, 7200], [1979273, 10800, 7200, 3600], [1980097, 7200, 3600, 7200], [1980272, 10800, 7200, 3600], [1981088, 7200, 3600, 7200], [1981270, 10800, 7200, 3600], [1982087, 7200, 3600, 7200], [1982269, 10800, 7200, 3600], [1983086, 7200, 3600, 7200], [1983268, 10800, 7200, 3600], [1984085, 7200, 3600, 7200], [1984274, 10800, 7200, 3600], [1985090, 7200, 3600, 7200], [1985272, 10800, 7200, 3600], [1986089, 7200, 3600, 7200], [1986271, 10800, 7200, 3600], [1987088, 7200, 3600, 7200], [1987270, 10800, 7200, 3600], [1988087, 7200, 3600, 7200], [1988269, 10800, 7200, 3600], [1989085, 7200, 3600, 7200], [1989267, 10800, 7200, 3600], [1990084, 7200, 3600, 7200], [1990273, 10800, 7200, 3600], [1991090, 7200, 3600, 7200], [1991272, 10800, 7200, 3600], [1992089, 7200, 3600, 7200], [1992271, 10800, 7200, 3600], [1993087, 7200, 3600, 7200], [1993269, 10800, 7200, 3600], [1994086, 7200, 3600, 7200], [1994268, 10800, 7200, 3600], [1995085, 7200, 3600, 7200], [1995267, 10800, 7200, 3600], [1996091, 7200, 3600, 7200], [1996301, 10800, 7200, 3600], [1997089, 7200, 3600, 7200], [1997299, 10800, 7200, 3600]]), $ct_T2__O__O__(new $c_T2(), "r", [[3, 25, 7, 3600, 0, 0, 3600, 3600, 7200], [10, 25, 7, 3600, 0, 0, 3600, 7200, 3600]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurur$__f_Europe_Luxembourg = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurur$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurur$.prototype.constructor = $c_Lzonedb_java_tzdb$eurur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurur$.prototype = $c_Lzonedb_java_tzdb$eurur$.prototype;
$c_Lzonedb_java_tzdb$eurur$.prototype.Europe_Luxembourg__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurur$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 35")
  };
  return this.Lzonedb_java_tzdb$eurur$__f_Europe_Luxembourg
});
var $d_Lzonedb_java_tzdb$eurur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurur$: 0
}, false, "zonedb.java.tzdb$eurur$", {
  Lzonedb_java_tzdb$eurur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurur$.prototype.$classData = $d_Lzonedb_java_tzdb$eurur$;
var $n_Lzonedb_java_tzdb$eurur$;
function $m_Lzonedb_java_tzdb$eurur$() {
  if ((!$n_Lzonedb_java_tzdb$eurur$)) {
    $n_Lzonedb_java_tzdb$eurur$ = new $c_Lzonedb_java_tzdb$eurur$()
  };
  return $n_Lzonedb_java_tzdb$eurur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$eurvs$() {
  this.Lzonedb_java_tzdb$eurvs$__f_Europe_Ulyanovsk = null;
  this.Lzonedb_java_tzdb$eurvs$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$eurvs$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 11616), $ct_T2__O__O__(new $c_T2(), "w", 11616), $ct_T2__O__O__(new $c_T2(), "t", [[1919182, 11616, 11616, 10800], [1930172, 0, 10800, 14400], [1989085, 7200, 14400, 10800], [1991090, 7200, 10800, 7200], [1992019, 7200, 7200, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016087, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1919182, 11616, 11616, 10800], [1930172, 0, 10800, 14400], [1981091, 0, 14400, 18000], [1981274, 0, 18000, 14400], [1982091, 0, 14400, 18000], [1982274, 0, 18000, 14400], [1983091, 0, 14400, 18000], [1983274, 0, 18000, 14400], [1984092, 0, 14400, 18000], [1984274, 10800, 18000, 14400], [1985090, 7200, 14400, 18000], [1985272, 10800, 18000, 14400], [1986089, 7200, 14400, 18000], [1986271, 10800, 18000, 14400], [1987088, 7200, 14400, 18000], [1987270, 10800, 18000, 14400], [1988087, 7200, 14400, 18000], [1988269, 10800, 18000, 14400], [1989267, 10800, 14400, 10800], [1990084, 7200, 10800, 14400], [1990273, 10800, 14400, 10800], [1991272, 10800, 10800, 7200], [1992019, 7200, 7200, 10800], [1992089, 7200, 10800, 14400], [1992271, 10800, 14400, 10800], [1993087, 7200, 10800, 14400], [1993269, 10800, 14400, 10800], [1994086, 7200, 10800, 14400], [1994268, 10800, 14400, 10800], [1995085, 7200, 10800, 14400], [1995267, 10800, 14400, 10800], [1996091, 7200, 10800, 14400], [1996301, 10800, 14400, 10800], [1997089, 7200, 10800, 14400], [1997299, 10800, 14400, 10800], [1998088, 7200, 10800, 14400], [1998298, 10800, 14400, 10800], [1999087, 7200, 10800, 14400], [1999304, 10800, 14400, 10800], [2000086, 7200, 10800, 14400], [2000303, 10800, 14400, 10800], [2001084, 7200, 10800, 14400], [2001301, 10800, 14400, 10800], [2002090, 7200, 10800, 14400], [2002300, 10800, 14400, 10800], [2003089, 7200, 10800, 14400], [2003299, 10800, 14400, 10800], [2004088, 7200, 10800, 14400], [2004305, 10800, 14400, 10800], [2005086, 7200, 10800, 14400], [2005303, 10800, 14400, 10800], [2006085, 7200, 10800, 14400], [2006302, 10800, 14400, 10800], [2007084, 7200, 10800, 14400], [2007301, 10800, 14400, 10800], [2008090, 7200, 10800, 14400], [2008300, 10800, 14400, 10800], [2009088, 7200, 10800, 14400], [2009298, 10800, 14400, 10800], [2010087, 7200, 10800, 14400], [2010304, 10800, 14400, 10800], [2011086, 7200, 10800, 14400], [2014299, 7200, 14400, 10800], [2016087, 7200, 10800, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$eurvs$__f_Europe_Ulyanovsk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$eurvs$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$eurvs$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$eurvs$.prototype.constructor = $c_Lzonedb_java_tzdb$eurvs$;
/** @constructor */
function $h_Lzonedb_java_tzdb$eurvs$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$eurvs$.prototype = $c_Lzonedb_java_tzdb$eurvs$.prototype;
$c_Lzonedb_java_tzdb$eurvs$.prototype.Europe_Ulyanovsk__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$eurvs$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 32")
  };
  return this.Lzonedb_java_tzdb$eurvs$__f_Europe_Ulyanovsk
});
var $d_Lzonedb_java_tzdb$eurvs$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$eurvs$: 0
}, false, "zonedb.java.tzdb$eurvs$", {
  Lzonedb_java_tzdb$eurvs$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$eurvs$.prototype.$classData = $d_Lzonedb_java_tzdb$eurvs$;
var $n_Lzonedb_java_tzdb$eurvs$;
function $m_Lzonedb_java_tzdb$eurvs$() {
  if ((!$n_Lzonedb_java_tzdb$eurvs$)) {
    $n_Lzonedb_java_tzdb$eurvs$ = new $c_Lzonedb_java_tzdb$eurvs$()
  };
  return $n_Lzonedb_java_tzdb$eurvs$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indah$() {
  this.Lzonedb_java_tzdb$indah$__f_Indian_Mahe = null;
  this.Lzonedb_java_tzdb$indah$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$indah$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 13308), $ct_T2__O__O__(new $c_T2(), "w", 13308), $ct_T2__O__O__(new $c_T2(), "t", [[1906152, 0, 13308, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1906152, 0, 13308, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$indah$__f_Indian_Mahe = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$indah$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$indah$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indah$.prototype.constructor = $c_Lzonedb_java_tzdb$indah$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indah$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indah$.prototype = $c_Lzonedb_java_tzdb$indah$.prototype;
$c_Lzonedb_java_tzdb$indah$.prototype.Indian_Mahe__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$indah$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 292")
  };
  return this.Lzonedb_java_tzdb$indah$__f_Indian_Mahe
});
var $d_Lzonedb_java_tzdb$indah$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indah$: 0
}, false, "zonedb.java.tzdb$indah$", {
  Lzonedb_java_tzdb$indah$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indah$.prototype.$classData = $d_Lzonedb_java_tzdb$indah$;
var $n_Lzonedb_java_tzdb$indah$;
function $m_Lzonedb_java_tzdb$indah$() {
  if ((!$n_Lzonedb_java_tzdb$indah$)) {
    $n_Lzonedb_java_tzdb$indah$ = new $c_Lzonedb_java_tzdb$indah$()
  };
  return $n_Lzonedb_java_tzdb$indah$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indco$() {
  this.Lzonedb_java_tzdb$indco$__f_Indian_Cocos = null;
  this.Lzonedb_java_tzdb$indco$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$indco$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 23260), $ct_T2__O__O__(new $c_T2(), "w", 23260), $ct_T2__O__O__(new $c_T2(), "t", [[1900001, 0, 23260, 23400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1900001, 0, 23260, 23400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$indco$__f_Indian_Cocos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$indco$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$indco$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indco$.prototype.constructor = $c_Lzonedb_java_tzdb$indco$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indco$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indco$.prototype = $c_Lzonedb_java_tzdb$indco$.prototype;
$c_Lzonedb_java_tzdb$indco$.prototype.Indian_Cocos__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$indco$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 701")
  };
  return this.Lzonedb_java_tzdb$indco$__f_Indian_Cocos
});
var $d_Lzonedb_java_tzdb$indco$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indco$: 0
}, false, "zonedb.java.tzdb$indco$", {
  Lzonedb_java_tzdb$indco$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indco$.prototype.$classData = $d_Lzonedb_java_tzdb$indco$;
var $n_Lzonedb_java_tzdb$indco$;
function $m_Lzonedb_java_tzdb$indco$() {
  if ((!$n_Lzonedb_java_tzdb$indco$)) {
    $n_Lzonedb_java_tzdb$indco$ = new $c_Lzonedb_java_tzdb$indco$()
  };
  return $n_Lzonedb_java_tzdb$indco$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indgo$() {
  this.Lzonedb_java_tzdb$indgo$__f_Indian_Chagos = null;
  this.Lzonedb_java_tzdb$indgo$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$indgo$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 17380), $ct_T2__O__O__(new $c_T2(), "w", 17380), $ct_T2__O__O__(new $c_T2(), "t", [[1907001, 0, 17380, 18000], [1996001, 0, 18000, 21600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1907001, 0, 17380, 18000], [1996001, 0, 18000, 21600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$indgo$__f_Indian_Chagos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$indgo$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$indgo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indgo$.prototype.constructor = $c_Lzonedb_java_tzdb$indgo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indgo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indgo$.prototype = $c_Lzonedb_java_tzdb$indgo$.prototype;
$c_Lzonedb_java_tzdb$indgo$.prototype.Indian_Chagos__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$indgo$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 823")
  };
  return this.Lzonedb_java_tzdb$indgo$__f_Indian_Chagos
});
var $d_Lzonedb_java_tzdb$indgo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indgo$: 0
}, false, "zonedb.java.tzdb$indgo$", {
  Lzonedb_java_tzdb$indgo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indgo$.prototype.$classData = $d_Lzonedb_java_tzdb$indgo$;
var $n_Lzonedb_java_tzdb$indgo$;
function $m_Lzonedb_java_tzdb$indgo$() {
  if ((!$n_Lzonedb_java_tzdb$indgo$)) {
    $n_Lzonedb_java_tzdb$indgo$ = new $c_Lzonedb_java_tzdb$indgo$()
  };
  return $n_Lzonedb_java_tzdb$indgo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indio$() {
  this.Lzonedb_java_tzdb$indio$__f_Indian_Reunion = null;
  this.Lzonedb_java_tzdb$indio$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$indio$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 13312), $ct_T2__O__O__(new $c_T2(), "w", 13312), $ct_T2__O__O__(new $c_T2(), "t", [[1911152, 0, 13312, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1911152, 0, 13312, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$indio$__f_Indian_Reunion = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$indio$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$indio$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indio$.prototype.constructor = $c_Lzonedb_java_tzdb$indio$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indio$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indio$.prototype = $c_Lzonedb_java_tzdb$indio$.prototype;
$c_Lzonedb_java_tzdb$indio$.prototype.Indian_Reunion__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$indio$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 617")
  };
  return this.Lzonedb_java_tzdb$indio$__f_Indian_Reunion
});
var $d_Lzonedb_java_tzdb$indio$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indio$: 0
}, false, "zonedb.java.tzdb$indio$", {
  Lzonedb_java_tzdb$indio$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indio$.prototype.$classData = $d_Lzonedb_java_tzdb$indio$;
var $n_Lzonedb_java_tzdb$indio$;
function $m_Lzonedb_java_tzdb$indio$() {
  if ((!$n_Lzonedb_java_tzdb$indio$)) {
    $n_Lzonedb_java_tzdb$indio$ = new $c_Lzonedb_java_tzdb$indio$()
  };
  return $n_Lzonedb_java_tzdb$indio$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indiu$() {
  this.Lzonedb_java_tzdb$indiu$__f_Indian_Mauritius = null;
  this.Lzonedb_java_tzdb$indiu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$indiu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 13800), $ct_T2__O__O__(new $c_T2(), "w", 13800), $ct_T2__O__O__(new $c_T2(), "t", [[1907001, 0, 13800, 14400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1907001, 0, 13800, 14400], [1982283, 0, 14400, 18000], [1983080, 0, 18000, 14400], [2008300, 7200, 14400, 18000], [2009088, 7200, 18000, 14400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$indiu$__f_Indian_Mauritius = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$indiu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$indiu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indiu$.prototype.constructor = $c_Lzonedb_java_tzdb$indiu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indiu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indiu$.prototype = $c_Lzonedb_java_tzdb$indiu$.prototype;
$c_Lzonedb_java_tzdb$indiu$.prototype.Indian_Mauritius__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$indiu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 286")
  };
  return this.Lzonedb_java_tzdb$indiu$__f_Indian_Mauritius
});
var $d_Lzonedb_java_tzdb$indiu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indiu$: 0
}, false, "zonedb.java.tzdb$indiu$", {
  Lzonedb_java_tzdb$indiu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indiu$.prototype.$classData = $d_Lzonedb_java_tzdb$indiu$;
var $n_Lzonedb_java_tzdb$indiu$;
function $m_Lzonedb_java_tzdb$indiu$() {
  if ((!$n_Lzonedb_java_tzdb$indiu$)) {
    $n_Lzonedb_java_tzdb$indiu$ = new $c_Lzonedb_java_tzdb$indiu$()
  };
  return $n_Lzonedb_java_tzdb$indiu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indle$() {
  this.Lzonedb_java_tzdb$indle$__f_Indian_Kerguelen = null;
  this.Lzonedb_java_tzdb$indle$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$indle$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 0), $ct_T2__O__O__(new $c_T2(), "w", 0), $ct_T2__O__O__(new $c_T2(), "t", [[1950001, 0, 0, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1950001, 0, 0, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$indle$__f_Indian_Kerguelen = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$indle$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$indle$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indle$.prototype.constructor = $c_Lzonedb_java_tzdb$indle$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indle$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indle$.prototype = $c_Lzonedb_java_tzdb$indle$.prototype;
$c_Lzonedb_java_tzdb$indle$.prototype.Indian_Kerguelen__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$indle$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 137")
  };
  return this.Lzonedb_java_tzdb$indle$__f_Indian_Kerguelen
});
var $d_Lzonedb_java_tzdb$indle$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indle$: 0
}, false, "zonedb.java.tzdb$indle$", {
  Lzonedb_java_tzdb$indle$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indle$.prototype.$classData = $d_Lzonedb_java_tzdb$indle$;
var $n_Lzonedb_java_tzdb$indle$;
function $m_Lzonedb_java_tzdb$indle$() {
  if ((!$n_Lzonedb_java_tzdb$indle$)) {
    $n_Lzonedb_java_tzdb$indle$ = new $c_Lzonedb_java_tzdb$indle$()
  };
  return $n_Lzonedb_java_tzdb$indle$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indma$() {
  this.Lzonedb_java_tzdb$indma$__f_Indian_Christmas = null;
  this.Lzonedb_java_tzdb$indma$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$indma$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 25372), $ct_T2__O__O__(new $c_T2(), "w", 25372), $ct_T2__O__O__(new $c_T2(), "t", [[1895032, 0, 25372, 25200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1895032, 0, 25372, 25200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$indma$__f_Indian_Christmas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$indma$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$indma$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indma$.prototype.constructor = $c_Lzonedb_java_tzdb$indma$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indma$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indma$.prototype = $c_Lzonedb_java_tzdb$indma$.prototype;
$c_Lzonedb_java_tzdb$indma$.prototype.Indian_Christmas__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$indma$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 398")
  };
  return this.Lzonedb_java_tzdb$indma$__f_Indian_Christmas
});
var $d_Lzonedb_java_tzdb$indma$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indma$: 0
}, false, "zonedb.java.tzdb$indma$", {
  Lzonedb_java_tzdb$indma$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indma$.prototype.$classData = $d_Lzonedb_java_tzdb$indma$;
var $n_Lzonedb_java_tzdb$indma$;
function $m_Lzonedb_java_tzdb$indma$() {
  if ((!$n_Lzonedb_java_tzdb$indma$)) {
    $n_Lzonedb_java_tzdb$indma$ = new $c_Lzonedb_java_tzdb$indma$()
  };
  return $n_Lzonedb_java_tzdb$indma$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$indve$() {
  this.Lzonedb_java_tzdb$indve$__f_Indian_Maldives = null;
  this.Lzonedb_java_tzdb$indve$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$indve$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 17640), $ct_T2__O__O__(new $c_T2(), "w", 17640), $ct_T2__O__O__(new $c_T2(), "t", [[1960001, 0, 17640, 18000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1960001, 0, 17640, 18000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$indve$__f_Indian_Maldives = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$indve$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$indve$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$indve$.prototype.constructor = $c_Lzonedb_java_tzdb$indve$;
/** @constructor */
function $h_Lzonedb_java_tzdb$indve$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$indve$.prototype = $c_Lzonedb_java_tzdb$indve$.prototype;
$c_Lzonedb_java_tzdb$indve$.prototype.Indian_Maldives__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$indve$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 192")
  };
  return this.Lzonedb_java_tzdb$indve$__f_Indian_Maldives
});
var $d_Lzonedb_java_tzdb$indve$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$indve$: 0
}, false, "zonedb.java.tzdb$indve$", {
  Lzonedb_java_tzdb$indve$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$indve$.prototype.$classData = $d_Lzonedb_java_tzdb$indve$;
var $n_Lzonedb_java_tzdb$indve$;
function $m_Lzonedb_java_tzdb$indve$() {
  if ((!$n_Lzonedb_java_tzdb$indve$)) {
    $n_Lzonedb_java_tzdb$indve$ = new $c_Lzonedb_java_tzdb$indve$()
  };
  return $n_Lzonedb_java_tzdb$indve$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacag$() {
  this.Lzonedb_java_tzdb$pacag$__f_Pacific_Pago_Pago = null;
  this.Lzonedb_java_tzdb$pacag$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacag$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 45432), $ct_T2__O__O__(new $c_T2(), "w", 45432), $ct_T2__O__O__(new $c_T2(), "t", [[1892187, 0, 45432, (-40968)], [1911001, 0, (-40968), (-39600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1892187, 0, 45432, (-40968)], [1911001, 0, (-40968), (-39600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacag$__f_Pacific_Pago_Pago = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacag$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacag$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacag$.prototype.constructor = $c_Lzonedb_java_tzdb$pacag$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacag$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacag$.prototype = $c_Lzonedb_java_tzdb$pacag$.prototype;
$c_Lzonedb_java_tzdb$pacag$.prototype.Pacific_Pago_Pago__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacag$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 879")
  };
  return this.Lzonedb_java_tzdb$pacag$__f_Pacific_Pago_Pago
});
var $d_Lzonedb_java_tzdb$pacag$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacag$: 0
}, false, "zonedb.java.tzdb$pacag$", {
  Lzonedb_java_tzdb$pacag$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacag$.prototype.$classData = $d_Lzonedb_java_tzdb$pacag$;
var $n_Lzonedb_java_tzdb$pacag$;
function $m_Lzonedb_java_tzdb$pacag$() {
  if ((!$n_Lzonedb_java_tzdb$pacag$)) {
    $n_Lzonedb_java_tzdb$pacag$ = new $c_Lzonedb_java_tzdb$pacag$()
  };
  return $n_Lzonedb_java_tzdb$pacag$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacak$() {
  this.Lzonedb_java_tzdb$pacak$__f_Pacific_Wake = null;
  this.Lzonedb_java_tzdb$pacak$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacak$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 39988), $ct_T2__O__O__(new $c_T2(), "w", 39988), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 39988, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 39988, 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacak$__f_Pacific_Wake = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacak$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacak$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacak$.prototype.constructor = $c_Lzonedb_java_tzdb$pacak$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacak$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacak$.prototype = $c_Lzonedb_java_tzdb$pacak$.prototype;
$c_Lzonedb_java_tzdb$pacak$.prototype.Pacific_Wake__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacak$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 451")
  };
  return this.Lzonedb_java_tzdb$pacak$__f_Pacific_Wake
});
var $d_Lzonedb_java_tzdb$pacak$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacak$: 0
}, false, "zonedb.java.tzdb$pacak$", {
  Lzonedb_java_tzdb$pacak$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacak$.prototype.$classData = $d_Lzonedb_java_tzdb$pacak$;
var $n_Lzonedb_java_tzdb$pacak$;
function $m_Lzonedb_java_tzdb$pacak$() {
  if ((!$n_Lzonedb_java_tzdb$pacak$)) {
    $n_Lzonedb_java_tzdb$pacak$ = new $c_Lzonedb_java_tzdb$pacak$()
  };
  return $n_Lzonedb_java_tzdb$pacak$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacan$() {
  this.Lzonedb_java_tzdb$pacan$__f_Pacific_Auckland = null;
  this.Lzonedb_java_tzdb$pacan$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacan$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 41944), $ct_T2__O__O__(new $c_T2(), "w", 41944), $ct_T2__O__O__(new $c_T2(), "t", [[1868307, 0, 41944, 41400], [1945365, 84600, 41400, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1868307, 0, 41944, 41400], [1927310, 7200, 41400, 45000], [1928064, 7200, 45000, 41400], [1928288, 7200, 41400, 43200], [1929076, 7200, 43200, 41400], [1929286, 7200, 41400, 43200], [1930075, 7200, 43200, 41400], [1930285, 7200, 41400, 43200], [1931074, 7200, 43200, 41400], [1931284, 7200, 41400, 43200], [1932080, 7200, 43200, 41400], [1932283, 7200, 41400, 43200], [1933078, 7200, 43200, 41400], [1933281, 7200, 41400, 43200], [1934119, 7200, 43200, 41400], [1934273, 7200, 41400, 43200], [1935118, 7200, 43200, 41400], [1935272, 7200, 41400, 43200], [1936117, 7200, 43200, 41400], [1936271, 7200, 41400, 43200], [1937115, 7200, 43200, 41400], [1937269, 7200, 41400, 43200], [1938114, 7200, 43200, 41400], [1938268, 7200, 41400, 43200], [1939120, 7200, 43200, 41400], [1939267, 7200, 41400, 43200], [1940119, 7200, 43200, 41400], [1940273, 7200, 41400, 43200], [1974307, 7200, 43200, 46800], [1975054, 10800, 46800, 43200], [1975299, 7200, 43200, 46800], [1976067, 10800, 46800, 43200], [1976305, 7200, 43200, 46800], [1977065, 10800, 46800, 43200], [1977303, 7200, 43200, 46800], [1978064, 10800, 46800, 43200], [1978302, 7200, 43200, 46800], [1979063, 10800, 46800, 43200], [1979301, 7200, 43200, 46800], [1980062, 10800, 46800, 43200], [1980300, 7200, 43200, 46800], [1981060, 10800, 46800, 43200], [1981298, 7200, 43200, 46800], [1982066, 10800, 46800, 43200], [1982304, 7200, 43200, 46800], [1983065, 10800, 46800, 43200], [1983303, 7200, 43200, 46800], [1984064, 10800, 46800, 43200], [1984302, 7200, 43200, 46800], [1985062, 10800, 46800, 43200], [1985300, 7200, 43200, 46800], [1986061, 10800, 46800, 43200], [1986299, 7200, 43200, 46800], [1987060, 10800, 46800, 43200], [1987298, 7200, 43200, 46800], [1988066, 10800, 46800, 43200], [1988304, 7200, 43200, 46800], [1989064, 10800, 46800, 43200], [1989281, 7200, 43200, 46800], [1990077, 10800, 46800, 43200], [1990280, 7200, 43200, 46800], [1991076, 10800, 46800, 43200], [1991279, 7200, 43200, 46800], [1992075, 10800, 46800, 43200], [1992278, 7200, 43200, 46800], [1993080, 10800, 46800, 43200], [1993276, 7200, 43200, 46800], [1994079, 10800, 46800, 43200], [1994275, 7200, 43200, 46800], [1995078, 10800, 46800, 43200], [1995274, 7200, 43200, 46800], [1996077, 10800, 46800, 43200], [1996280, 7200, 43200, 46800], [1997075, 10800, 46800, 43200], [1997278, 7200, 43200, 46800], [1998074, 10800, 46800, 43200], [1998277, 7200, 43200, 46800], [1999080, 10800, 46800, 43200], [1999276, 7200, 43200, 46800], [2000079, 10800, 46800, 43200], [2000275, 7200, 43200, 46800], [2001077, 10800, 46800, 43200], [2001280, 7200, 43200, 46800], [2002076, 10800, 46800, 43200], [2002279, 7200, 43200, 46800], [2003075, 10800, 46800, 43200], [2003278, 7200, 43200, 46800], [2004081, 10800, 46800, 43200], [2004277, 7200, 43200, 46800], [2005079, 10800, 46800, 43200], [2005275, 7200, 43200, 46800], [2006078, 10800, 46800, 43200], [2006274, 7200, 43200, 46800], [2007077, 10800, 46800, 43200], [2007273, 7200, 43200, 46800], [2008097, 10800, 46800, 43200], [2008272, 7200, 43200, 46800], [2009095, 10800, 46800, 43200], [2009270, 7200, 43200, 46800]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 2, 43200, 46800, 43200], [9, 24, 7, 7200, 0, 2, 43200, 43200, 46800]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacan$__f_Pacific_Auckland = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacan$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacan$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacan$.prototype.constructor = $c_Lzonedb_java_tzdb$pacan$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacan$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacan$.prototype = $c_Lzonedb_java_tzdb$pacan$.prototype;
$c_Lzonedb_java_tzdb$pacan$.prototype.Pacific_Auckland__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacan$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 792")
  };
  return this.Lzonedb_java_tzdb$pacan$__f_Pacific_Auckland
});
var $d_Lzonedb_java_tzdb$pacan$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacan$: 0
}, false, "zonedb.java.tzdb$pacan$", {
  Lzonedb_java_tzdb$pacan$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacan$.prototype.$classData = $d_Lzonedb_java_tzdb$pacan$;
var $n_Lzonedb_java_tzdb$pacan$;
function $m_Lzonedb_java_tzdb$pacan$() {
  if ((!$n_Lzonedb_java_tzdb$pacan$)) {
    $n_Lzonedb_java_tzdb$pacan$ = new $c_Lzonedb_java_tzdb$pacan$()
  };
  return $n_Lzonedb_java_tzdb$pacan$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacap$() {
  this.Lzonedb_java_tzdb$pacap$__f_Pacific_Tongatapu = null;
  this.Lzonedb_java_tzdb$pacap$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacap$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 44360), $ct_T2__O__O__(new $c_T2(), "w", 44360), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 44360, 44400], [1941001, 0, 44400, 46800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 44360, 44400], [1941001, 0, 44400, 46800], [1999280, 7200, 46800, 50400], [2000079, 10800, 50400, 46800], [2000310, 7200, 46800, 50400], [2001028, 7200, 50400, 46800], [2001308, 7200, 46800, 50400], [2002027, 7200, 50400, 46800], [2016311, 7200, 46800, 50400], [2017015, 10800, 50400, 46800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacap$__f_Pacific_Tongatapu = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacap$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacap$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacap$.prototype.constructor = $c_Lzonedb_java_tzdb$pacap$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacap$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacap$.prototype = $c_Lzonedb_java_tzdb$pacap$.prototype;
$c_Lzonedb_java_tzdb$pacap$.prototype.Pacific_Tongatapu__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacap$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 783")
  };
  return this.Lzonedb_java_tzdb$pacap$__f_Pacific_Tongatapu
});
var $d_Lzonedb_java_tzdb$pacap$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacap$: 0
}, false, "zonedb.java.tzdb$pacap$", {
  Lzonedb_java_tzdb$pacap$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacap$.prototype.$classData = $d_Lzonedb_java_tzdb$pacap$;
var $n_Lzonedb_java_tzdb$pacap$;
function $m_Lzonedb_java_tzdb$pacap$() {
  if ((!$n_Lzonedb_java_tzdb$pacap$)) {
    $n_Lzonedb_java_tzdb$pacap$ = new $c_Lzonedb_java_tzdb$pacap$()
  };
  return $n_Lzonedb_java_tzdb$pacap$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacat$() {
  this.Lzonedb_java_tzdb$pacat$__f_Pacific_Efate = null;
  this.Lzonedb_java_tzdb$pacat$__f_Pacific_Kiritimati = null;
  this.Lzonedb_java_tzdb$pacat$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$pacat$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 40396), $ct_T2__O__O__(new $c_T2(), "w", 40396), $ct_T2__O__O__(new $c_T2(), "t", [[1912013, 0, 40396, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912013, 0, 40396, 39600], [1983268, 0, 39600, 43200], [1984085, 0, 43200, 39600], [1984297, 0, 39600, 43200], [1985083, 0, 43200, 39600], [1985272, 0, 39600, 43200], [1986082, 0, 43200, 39600], [1986271, 0, 39600, 43200], [1987088, 0, 43200, 39600], [1987270, 0, 39600, 43200], [1988087, 0, 43200, 39600], [1988269, 0, 39600, 43200], [1989085, 0, 43200, 39600], [1989267, 0, 39600, 43200], [1990084, 0, 43200, 39600], [1990266, 0, 39600, 43200], [1991083, 0, 43200, 39600], [1991272, 0, 39600, 43200], [1992026, 0, 43200, 39600], [1992299, 0, 39600, 43200], [1993024, 0, 43200, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacat$__f_Pacific_Efate = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacat$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$pacat$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", (-37760)), $ct_T2__O__O__(new $c_T2(), "w", (-37760)), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, (-37760), (-38400)], [1979274, 0, (-38400), (-36000)], [1994365, 0, (-36000), 50400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, (-37760), (-38400)], [1979274, 0, (-38400), (-36000)], [1994365, 0, (-36000), 50400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$pacat$__f_Pacific_Kiritimati = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$pacat$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$pacat$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$pacat$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacat$.prototype.constructor = $c_Lzonedb_java_tzdb$pacat$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacat$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacat$.prototype = $c_Lzonedb_java_tzdb$pacat$.prototype;
$c_Lzonedb_java_tzdb$pacat$.prototype.Pacific_Efate__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$pacat$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 723")
  };
  return this.Lzonedb_java_tzdb$pacat$__f_Pacific_Efate
});
$c_Lzonedb_java_tzdb$pacat$.prototype.Pacific_Kiritimati__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$pacat$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 724")
  };
  return this.Lzonedb_java_tzdb$pacat$__f_Pacific_Kiritimati
});
var $d_Lzonedb_java_tzdb$pacat$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacat$: 0
}, false, "zonedb.java.tzdb$pacat$", {
  Lzonedb_java_tzdb$pacat$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacat$.prototype.$classData = $d_Lzonedb_java_tzdb$pacat$;
var $n_Lzonedb_java_tzdb$pacat$;
function $m_Lzonedb_java_tzdb$pacat$() {
  if ((!$n_Lzonedb_java_tzdb$pacat$)) {
    $n_Lzonedb_java_tzdb$pacat$ = new $c_Lzonedb_java_tzdb$pacat$()
  };
  return $n_Lzonedb_java_tzdb$pacat$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacaw$() {
  this.Lzonedb_java_tzdb$pacaw$__f_Pacific_Tarawa = null;
  this.Lzonedb_java_tzdb$pacaw$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacaw$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 41524), $ct_T2__O__O__(new $c_T2(), "w", 41524), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 41524, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 41524, 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacaw$__f_Pacific_Tarawa = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacaw$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacaw$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacaw$.prototype.constructor = $c_Lzonedb_java_tzdb$pacaw$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacaw$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacaw$.prototype = $c_Lzonedb_java_tzdb$pacaw$.prototype;
$c_Lzonedb_java_tzdb$pacaw$.prototype.Pacific_Tarawa__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacaw$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 445")
  };
  return this.Lzonedb_java_tzdb$pacaw$__f_Pacific_Tarawa
});
var $d_Lzonedb_java_tzdb$pacaw$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacaw$: 0
}, false, "zonedb.java.tzdb$pacaw$", {
  Lzonedb_java_tzdb$pacaw$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacaw$.prototype.$classData = $d_Lzonedb_java_tzdb$pacaw$;
var $n_Lzonedb_java_tzdb$pacaw$;
function $m_Lzonedb_java_tzdb$pacaw$() {
  if ((!$n_Lzonedb_java_tzdb$pacaw$)) {
    $n_Lzonedb_java_tzdb$pacaw$ = new $c_Lzonedb_java_tzdb$pacaw$()
  };
  return $n_Lzonedb_java_tzdb$pacaw$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacei$() {
  this.Lzonedb_java_tzdb$pacei$__f_Pacific_Kwajalein = null;
  this.Lzonedb_java_tzdb$pacei$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacei$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 40160), $ct_T2__O__O__(new $c_T2(), "w", 40160), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 40160, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1944037, 0, 32400, 39600], [1969274, 0, 39600, (-43200)], [1993233, 0, (-43200), 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 40160, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1944037, 0, 32400, 39600], [1969274, 0, 39600, (-43200)], [1993233, 0, (-43200), 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacei$__f_Pacific_Kwajalein = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacei$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacei$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacei$.prototype.constructor = $c_Lzonedb_java_tzdb$pacei$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacei$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacei$.prototype = $c_Lzonedb_java_tzdb$pacei$.prototype;
$c_Lzonedb_java_tzdb$pacei$.prototype.Pacific_Kwajalein__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacei$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 317")
  };
  return this.Lzonedb_java_tzdb$pacei$__f_Pacific_Kwajalein
});
var $d_Lzonedb_java_tzdb$pacei$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacei$: 0
}, false, "zonedb.java.tzdb$pacei$", {
  Lzonedb_java_tzdb$pacei$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacei$.prototype.$classData = $d_Lzonedb_java_tzdb$pacei$;
var $n_Lzonedb_java_tzdb$pacei$;
function $m_Lzonedb_java_tzdb$pacei$() {
  if ((!$n_Lzonedb_java_tzdb$pacei$)) {
    $n_Lzonedb_java_tzdb$pacei$ = new $c_Lzonedb_java_tzdb$pacei$()
  };
  return $n_Lzonedb_java_tzdb$pacei$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacgo$() {
  this.Lzonedb_java_tzdb$pacgo$__f_Pacific_Galapagos = null;
  this.Lzonedb_java_tzdb$pacgo$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacgo$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-21504)), $ct_T2__O__O__(new $c_T2(), "w", (-21504)), $ct_T2__O__O__(new $c_T2(), "t", [[1931001, 0, (-21504), (-18000)], [1986001, 0, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1931001, 0, (-21504), (-18000)], [1986001, 0, (-18000), (-21600)], [1992333, 0, (-21600), (-18000)], [1993036, 0, (-18000), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacgo$__f_Pacific_Galapagos = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacgo$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacgo$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacgo$.prototype.constructor = $c_Lzonedb_java_tzdb$pacgo$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacgo$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacgo$.prototype = $c_Lzonedb_java_tzdb$pacgo$.prototype;
$c_Lzonedb_java_tzdb$pacgo$.prototype.Pacific_Galapagos__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacgo$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 183")
  };
  return this.Lzonedb_java_tzdb$pacgo$__f_Pacific_Galapagos
});
var $d_Lzonedb_java_tzdb$pacgo$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacgo$: 0
}, false, "zonedb.java.tzdb$pacgo$", {
  Lzonedb_java_tzdb$pacgo$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacgo$.prototype.$classData = $d_Lzonedb_java_tzdb$pacgo$;
var $n_Lzonedb_java_tzdb$pacgo$;
function $m_Lzonedb_java_tzdb$pacgo$() {
  if ((!$n_Lzonedb_java_tzdb$pacgo$)) {
    $n_Lzonedb_java_tzdb$pacgo$ = new $c_Lzonedb_java_tzdb$pacgo$()
  };
  return $n_Lzonedb_java_tzdb$pacgo$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacha$() {
  this.Lzonedb_java_tzdb$pacha$__f_Pacific_Chatham = null;
  this.Lzonedb_java_tzdb$pacha$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacha$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 44028), $ct_T2__O__O__(new $c_T2(), "w", 44028), $ct_T2__O__O__(new $c_T2(), "t", [[1868307, 0, 44028, 44100], [1946001, 0, 44100, 45900]]), $ct_T2__O__O__(new $c_T2(), "l", [[1868307, 0, 44028, 44100], [1946001, 0, 44100, 45900], [1974307, 9900, 45900, 49500], [1975054, 13500, 49500, 45900], [1975299, 9900, 45900, 49500], [1976067, 13500, 49500, 45900], [1976305, 9900, 45900, 49500], [1977065, 13500, 49500, 45900], [1977303, 9900, 45900, 49500], [1978064, 13500, 49500, 45900], [1978302, 9900, 45900, 49500], [1979063, 13500, 49500, 45900], [1979301, 9900, 45900, 49500], [1980062, 13500, 49500, 45900], [1980300, 9900, 45900, 49500], [1981060, 13500, 49500, 45900], [1981298, 9900, 45900, 49500], [1982066, 13500, 49500, 45900], [1982304, 9900, 45900, 49500], [1983065, 13500, 49500, 45900], [1983303, 9900, 45900, 49500], [1984064, 13500, 49500, 45900], [1984302, 9900, 45900, 49500], [1985062, 13500, 49500, 45900], [1985300, 9900, 45900, 49500], [1986061, 13500, 49500, 45900], [1986299, 9900, 45900, 49500], [1987060, 13500, 49500, 45900], [1987298, 9900, 45900, 49500], [1988066, 13500, 49500, 45900], [1988304, 9900, 45900, 49500], [1989064, 13500, 49500, 45900], [1989281, 9900, 45900, 49500], [1990077, 13500, 49500, 45900], [1990280, 9900, 45900, 49500], [1991076, 13500, 49500, 45900], [1991279, 9900, 45900, 49500], [1992075, 13500, 49500, 45900], [1992278, 9900, 45900, 49500], [1993080, 13500, 49500, 45900], [1993276, 9900, 45900, 49500], [1994079, 13500, 49500, 45900], [1994275, 9900, 45900, 49500], [1995078, 13500, 49500, 45900], [1995274, 9900, 45900, 49500], [1996077, 13500, 49500, 45900], [1996280, 9900, 45900, 49500], [1997075, 13500, 49500, 45900], [1997278, 9900, 45900, 49500], [1998074, 13500, 49500, 45900], [1998277, 9900, 45900, 49500], [1999080, 13500, 49500, 45900], [1999276, 9900, 45900, 49500], [2000079, 13500, 49500, 45900], [2000275, 9900, 45900, 49500], [2001077, 13500, 49500, 45900], [2001280, 9900, 45900, 49500], [2002076, 13500, 49500, 45900], [2002279, 9900, 45900, 49500], [2003075, 13500, 49500, 45900], [2003278, 9900, 45900, 49500], [2004081, 13500, 49500, 45900], [2004277, 9900, 45900, 49500], [2005079, 13500, 49500, 45900], [2005275, 9900, 45900, 49500], [2006078, 13500, 49500, 45900], [2006274, 9900, 45900, 49500], [2007077, 13500, 49500, 45900], [2007273, 9900, 45900, 49500], [2008097, 13500, 49500, 45900], [2008272, 9900, 45900, 49500], [2009095, 13500, 49500, 45900], [2009270, 9900, 45900, 49500]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 9900, 0, 2, 45900, 49500, 45900], [9, 24, 7, 9900, 0, 2, 45900, 45900, 49500]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacha$__f_Pacific_Chatham = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacha$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacha$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacha$.prototype.constructor = $c_Lzonedb_java_tzdb$pacha$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacha$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacha$.prototype = $c_Lzonedb_java_tzdb$pacha$.prototype;
$c_Lzonedb_java_tzdb$pacha$.prototype.Pacific_Chatham__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacha$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 101")
  };
  return this.Lzonedb_java_tzdb$pacha$__f_Pacific_Chatham
});
var $d_Lzonedb_java_tzdb$pacha$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacha$: 0
}, false, "zonedb.java.tzdb$pacha$", {
  Lzonedb_java_tzdb$pacha$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacha$.prototype.$classData = $d_Lzonedb_java_tzdb$pacha$;
var $n_Lzonedb_java_tzdb$pacha$;
function $m_Lzonedb_java_tzdb$pacha$() {
  if ((!$n_Lzonedb_java_tzdb$pacha$)) {
    $n_Lzonedb_java_tzdb$pacha$ = new $c_Lzonedb_java_tzdb$pacha$()
  };
  return $n_Lzonedb_java_tzdb$pacha$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacie$() {
  this.Lzonedb_java_tzdb$pacie$__f_Pacific_Gambier = null;
  this.Lzonedb_java_tzdb$pacie$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacie$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-32388)), $ct_T2__O__O__(new $c_T2(), "w", (-32388)), $ct_T2__O__O__(new $c_T2(), "t", [[1912275, 0, (-32388), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912275, 0, (-32388), (-32400)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacie$__f_Pacific_Gambier = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacie$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacie$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacie$.prototype.constructor = $c_Lzonedb_java_tzdb$pacie$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacie$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacie$.prototype = $c_Lzonedb_java_tzdb$pacie$.prototype;
$c_Lzonedb_java_tzdb$pacie$.prototype.Pacific_Gambier__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacie$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 885")
  };
  return this.Lzonedb_java_tzdb$pacie$__f_Pacific_Gambier
});
var $d_Lzonedb_java_tzdb$pacie$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacie$: 0
}, false, "zonedb.java.tzdb$pacie$", {
  Lzonedb_java_tzdb$pacie$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacie$.prototype.$classData = $d_Lzonedb_java_tzdb$pacie$;
var $n_Lzonedb_java_tzdb$pacie$;
function $m_Lzonedb_java_tzdb$pacie$() {
  if ((!$n_Lzonedb_java_tzdb$pacie$)) {
    $n_Lzonedb_java_tzdb$pacie$ = new $c_Lzonedb_java_tzdb$pacie$()
  };
  return $n_Lzonedb_java_tzdb$pacie$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacij$() {
  this.Lzonedb_java_tzdb$pacij$__f_Pacific_Fiji = null;
  this.Lzonedb_java_tzdb$pacij$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacij$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 42944), $ct_T2__O__O__(new $c_T2(), "w", 42944), $ct_T2__O__O__(new $c_T2(), "t", [[1915299, 0, 42944, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1915299, 0, 42944, 43200], [1998305, 7200, 43200, 46800], [1999059, 10800, 46800, 43200], [1999311, 7200, 43200, 46800], [2000058, 10800, 46800, 43200], [2009333, 7200, 43200, 46800], [2010087, 10800, 46800, 43200], [2010297, 7200, 43200, 46800], [2011065, 10800, 46800, 43200], [2011296, 7200, 43200, 46800], [2012022, 10800, 46800, 43200], [2012295, 7200, 43200, 46800], [2013020, 10800, 46800, 43200], [2013300, 7200, 43200, 46800], [2014019, 7200, 46800, 43200], [2014306, 7200, 43200, 46800], [2015018, 10800, 46800, 43200], [2015305, 7200, 43200, 46800], [2016017, 10800, 46800, 43200], [2016311, 7200, 43200, 46800], [2017015, 10800, 46800, 43200], [2017309, 7200, 43200, 46800], [2018014, 10800, 46800, 43200], [2018308, 7200, 43200, 46800], [2019013, 10800, 46800, 43200], [2019314, 7200, 43200, 46800], [2020012, 10800, 46800, 43200], [2020313, 7200, 43200, 46800]]), $ct_T2__O__O__(new $c_T2(), "r", [[1, 12, 7, 10800, 0, 1, 43200, 46800, 43200], [11, 8, 7, 7200, 0, 1, 43200, 43200, 46800]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacij$__f_Pacific_Fiji = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacij$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacij$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacij$.prototype.constructor = $c_Lzonedb_java_tzdb$pacij$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacij$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacij$.prototype = $c_Lzonedb_java_tzdb$pacij$.prototype;
$c_Lzonedb_java_tzdb$pacij$.prototype.Pacific_Fiji__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacij$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 735")
  };
  return this.Lzonedb_java_tzdb$pacij$__f_Pacific_Fiji
});
var $d_Lzonedb_java_tzdb$pacij$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacij$: 0
}, false, "zonedb.java.tzdb$pacij$", {
  Lzonedb_java_tzdb$pacij$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacij$.prototype.$classData = $d_Lzonedb_java_tzdb$pacij$;
var $n_Lzonedb_java_tzdb$pacij$;
function $m_Lzonedb_java_tzdb$pacij$() {
  if ((!$n_Lzonedb_java_tzdb$pacij$)) {
    $n_Lzonedb_java_tzdb$pacij$ = new $c_Lzonedb_java_tzdb$pacij$()
  };
  return $n_Lzonedb_java_tzdb$pacij$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacir$() {
  this.Lzonedb_java_tzdb$pacir$__f_Pacific_Pitcairn = null;
  this.Lzonedb_java_tzdb$pacir$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacir$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-31220)), $ct_T2__O__O__(new $c_T2(), "w", (-31220)), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, (-31220), (-30600)], [1998117, 0, (-30600), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, (-31220), (-30600)], [1998117, 0, (-30600), (-28800)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacir$__f_Pacific_Pitcairn = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacir$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacir$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacir$.prototype.constructor = $c_Lzonedb_java_tzdb$pacir$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacir$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacir$.prototype = $c_Lzonedb_java_tzdb$pacir$.prototype;
$c_Lzonedb_java_tzdb$pacir$.prototype.Pacific_Pitcairn__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacir$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 372")
  };
  return this.Lzonedb_java_tzdb$pacir$__f_Pacific_Pitcairn
});
var $d_Lzonedb_java_tzdb$pacir$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacir$: 0
}, false, "zonedb.java.tzdb$pacir$", {
  Lzonedb_java_tzdb$pacir$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacir$.prototype.$classData = $d_Lzonedb_java_tzdb$pacir$;
var $n_Lzonedb_java_tzdb$pacir$;
function $m_Lzonedb_java_tzdb$pacir$() {
  if ((!$n_Lzonedb_java_tzdb$pacir$)) {
    $n_Lzonedb_java_tzdb$pacir$ = new $c_Lzonedb_java_tzdb$pacir$()
  };
  return $n_Lzonedb_java_tzdb$pacir$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacit$() {
  this.Lzonedb_java_tzdb$pacit$__f_Pacific_Tahiti = null;
  this.Lzonedb_java_tzdb$pacit$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacit$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-35896)), $ct_T2__O__O__(new $c_T2(), "w", (-35896)), $ct_T2__O__O__(new $c_T2(), "t", [[1912275, 0, (-35896), (-36000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912275, 0, (-35896), (-36000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacit$__f_Pacific_Tahiti = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacit$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacit$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacit$.prototype.constructor = $c_Lzonedb_java_tzdb$pacit$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacit$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacit$.prototype = $c_Lzonedb_java_tzdb$pacit$.prototype;
$c_Lzonedb_java_tzdb$pacit$.prototype.Pacific_Tahiti__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacit$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 829")
  };
  return this.Lzonedb_java_tzdb$pacit$__f_Pacific_Tahiti
});
var $d_Lzonedb_java_tzdb$pacit$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacit$: 0
}, false, "zonedb.java.tzdb$pacit$", {
  Lzonedb_java_tzdb$pacit$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacit$.prototype.$classData = $d_Lzonedb_java_tzdb$pacit$;
var $n_Lzonedb_java_tzdb$pacit$;
function $m_Lzonedb_java_tzdb$pacit$() {
  if ((!$n_Lzonedb_java_tzdb$pacit$)) {
    $n_Lzonedb_java_tzdb$pacit$ = new $c_Lzonedb_java_tzdb$pacit$()
  };
  return $n_Lzonedb_java_tzdb$pacit$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$paciu$() {
  this.Lzonedb_java_tzdb$paciu$__f_Pacific_Niue = null;
  this.Lzonedb_java_tzdb$paciu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$paciu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-40780)), $ct_T2__O__O__(new $c_T2(), "w", (-40780)), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, (-40780), (-40800)], [1951001, 0, (-40800), (-41400)], [1978274, 0, (-41400), (-39600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, (-40780), (-40800)], [1951001, 0, (-40800), (-41400)], [1978274, 0, (-41400), (-39600)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$paciu$__f_Pacific_Niue = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$paciu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$paciu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$paciu$.prototype.constructor = $c_Lzonedb_java_tzdb$paciu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$paciu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$paciu$.prototype = $c_Lzonedb_java_tzdb$paciu$.prototype;
$c_Lzonedb_java_tzdb$paciu$.prototype.Pacific_Niue__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$paciu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 143")
  };
  return this.Lzonedb_java_tzdb$paciu$__f_Pacific_Niue
});
var $d_Lzonedb_java_tzdb$paciu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$paciu$: 0
}, false, "zonedb.java.tzdb$paciu$", {
  Lzonedb_java_tzdb$paciu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$paciu$.prototype.$classData = $d_Lzonedb_java_tzdb$paciu$;
var $n_Lzonedb_java_tzdb$paciu$;
function $m_Lzonedb_java_tzdb$paciu$() {
  if ((!$n_Lzonedb_java_tzdb$paciu$)) {
    $n_Lzonedb_java_tzdb$paciu$ = new $c_Lzonedb_java_tzdb$paciu$()
  };
  return $n_Lzonedb_java_tzdb$paciu$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacla$() {
  this.Lzonedb_java_tzdb$pacla$__f_Pacific_Palau = null;
  this.Lzonedb_java_tzdb$pacla$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacla$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-54124)), $ct_T2__O__O__(new $c_T2(), "w", (-54124)), $ct_T2__O__O__(new $c_T2(), "t", [[1844366, 0, (-54124), 32276], [1901001, 0, 32276, 32400]]), $ct_T2__O__O__(new $c_T2(), "l", [[1844366, 0, (-54124), 32276], [1901001, 0, 32276, 32400]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacla$__f_Pacific_Palau = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacla$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacla$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacla$.prototype.constructor = $c_Lzonedb_java_tzdb$pacla$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacla$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacla$.prototype = $c_Lzonedb_java_tzdb$pacla$.prototype;
$c_Lzonedb_java_tzdb$pacla$.prototype.Pacific_Palau__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacla$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 323")
  };
  return this.Lzonedb_java_tzdb$pacla$__f_Pacific_Palau
});
var $d_Lzonedb_java_tzdb$pacla$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacla$: 0
}, false, "zonedb.java.tzdb$pacla$", {
  Lzonedb_java_tzdb$pacla$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacla$.prototype.$classData = $d_Lzonedb_java_tzdb$pacla$;
var $n_Lzonedb_java_tzdb$pacla$;
function $m_Lzonedb_java_tzdb$pacla$() {
  if ((!$n_Lzonedb_java_tzdb$pacla$)) {
    $n_Lzonedb_java_tzdb$pacla$ = new $c_Lzonedb_java_tzdb$pacla$()
  };
  return $n_Lzonedb_java_tzdb$pacla$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacli$() {
  this.Lzonedb_java_tzdb$pacli$__f_Pacific_Wallis = null;
  this.Lzonedb_java_tzdb$pacli$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacli$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 44120), $ct_T2__O__O__(new $c_T2(), "w", 44120), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 44120, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 44120, 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacli$__f_Pacific_Wallis = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacli$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacli$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacli$.prototype.constructor = $c_Lzonedb_java_tzdb$pacli$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacli$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacli$.prototype = $c_Lzonedb_java_tzdb$pacli$.prototype;
$c_Lzonedb_java_tzdb$pacli$.prototype.Pacific_Wallis__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacli$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 9")
  };
  return this.Lzonedb_java_tzdb$pacli$__f_Pacific_Wallis
});
var $d_Lzonedb_java_tzdb$pacli$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacli$: 0
}, false, "zonedb.java.tzdb$pacli$", {
  Lzonedb_java_tzdb$pacli$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacli$.prototype.$classData = $d_Lzonedb_java_tzdb$pacli$;
var $n_Lzonedb_java_tzdb$pacli$;
function $m_Lzonedb_java_tzdb$pacli$() {
  if ((!$n_Lzonedb_java_tzdb$pacli$)) {
    $n_Lzonedb_java_tzdb$pacli$ = new $c_Lzonedb_java_tzdb$pacli$()
  };
  return $n_Lzonedb_java_tzdb$pacli$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacll$() {
  this.Lzonedb_java_tzdb$pacll$__f_Pacific_Bougainville = null;
  this.Lzonedb_java_tzdb$pacll$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacll$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 37336), $ct_T2__O__O__(new $c_T2(), "w", 37336), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 37336, 35312], [1895001, 0, 35312, 36000], [1942182, 0, 36000, 32400], [1945233, 0, 32400, 36000], [2014362, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 37336, 35312], [1895001, 0, 35312, 36000], [1942182, 0, 36000, 32400], [1945233, 0, 32400, 36000], [2014362, 7200, 36000, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacll$__f_Pacific_Bougainville = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacll$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacll$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacll$.prototype.constructor = $c_Lzonedb_java_tzdb$pacll$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacll$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacll$.prototype = $c_Lzonedb_java_tzdb$pacll$.prototype;
$c_Lzonedb_java_tzdb$pacll$.prototype.Pacific_Bougainville__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacll$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 314")
  };
  return this.Lzonedb_java_tzdb$pacll$__f_Pacific_Bougainville
});
var $d_Lzonedb_java_tzdb$pacll$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacll$: 0
}, false, "zonedb.java.tzdb$pacll$", {
  Lzonedb_java_tzdb$pacll$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacll$.prototype.$classData = $d_Lzonedb_java_tzdb$pacll$;
var $n_Lzonedb_java_tzdb$pacll$;
function $m_Lzonedb_java_tzdb$pacll$() {
  if ((!$n_Lzonedb_java_tzdb$pacll$)) {
    $n_Lzonedb_java_tzdb$pacll$ = new $c_Lzonedb_java_tzdb$pacll$()
  };
  return $n_Lzonedb_java_tzdb$pacll$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacme$() {
  this.Lzonedb_java_tzdb$pacme$__f_Pacific_Noumea = null;
  this.Lzonedb_java_tzdb$pacme$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacme$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 39948), $ct_T2__O__O__(new $c_T2(), "w", 39948), $ct_T2__O__O__(new $c_T2(), "t", [[1912013, 0, 39948, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912013, 0, 39948, 39600], [1977338, 0, 39600, 43200], [1978058, 0, 43200, 39600], [1978337, 0, 39600, 43200], [1979058, 0, 43200, 39600], [1996336, 7200, 39600, 43200], [1997061, 10800, 43200, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacme$__f_Pacific_Noumea = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacme$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacme$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacme$.prototype.constructor = $c_Lzonedb_java_tzdb$pacme$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacme$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacme$.prototype = $c_Lzonedb_java_tzdb$pacme$.prototype;
$c_Lzonedb_java_tzdb$pacme$.prototype.Pacific_Noumea__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacme$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 882")
  };
  return this.Lzonedb_java_tzdb$pacme$__f_Pacific_Noumea
});
var $d_Lzonedb_java_tzdb$pacme$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacme$: 0
}, false, "zonedb.java.tzdb$pacme$", {
  Lzonedb_java_tzdb$pacme$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacme$.prototype.$classData = $d_Lzonedb_java_tzdb$pacme$;
var $n_Lzonedb_java_tzdb$pacme$;
function $m_Lzonedb_java_tzdb$pacme$() {
  if ((!$n_Lzonedb_java_tzdb$pacme$)) {
    $n_Lzonedb_java_tzdb$pacme$ = new $c_Lzonedb_java_tzdb$pacme$()
  };
  return $n_Lzonedb_java_tzdb$pacme$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacna$() {
  this.Lzonedb_java_tzdb$pacna$__f_Pacific_Guadalcanal = null;
  this.Lzonedb_java_tzdb$pacna$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacna$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 38388), $ct_T2__O__O__(new $c_T2(), "w", 38388), $ct_T2__O__O__(new $c_T2(), "t", [[1912275, 0, 38388, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912275, 0, 38388, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacna$__f_Pacific_Guadalcanal = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacna$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacna$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacna$.prototype.constructor = $c_Lzonedb_java_tzdb$pacna$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacna$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacna$.prototype = $c_Lzonedb_java_tzdb$pacna$.prototype;
$c_Lzonedb_java_tzdb$pacna$.prototype.Pacific_Guadalcanal__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacna$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 814")
  };
  return this.Lzonedb_java_tzdb$pacna$__f_Pacific_Guadalcanal
});
var $d_Lzonedb_java_tzdb$pacna$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacna$: 0
}, false, "zonedb.java.tzdb$pacna$", {
  Lzonedb_java_tzdb$pacna$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacna$.prototype.$classData = $d_Lzonedb_java_tzdb$pacna$;
var $n_Lzonedb_java_tzdb$pacna$;
function $m_Lzonedb_java_tzdb$pacna$() {
  if ((!$n_Lzonedb_java_tzdb$pacna$)) {
    $n_Lzonedb_java_tzdb$pacna$ = new $c_Lzonedb_java_tzdb$pacna$()
  };
  return $n_Lzonedb_java_tzdb$pacna$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacng$() {
  this.Lzonedb_java_tzdb$pacng$__f_Pacific_Rarotonga = null;
  this.Lzonedb_java_tzdb$pacng$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacng$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-38344)), $ct_T2__O__O__(new $c_T2(), "w", (-38344)), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, (-38344), (-37800)], [1978316, 0, (-37800), (-36000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, (-38344), (-37800)], [1978316, 0, (-37800), (-34200)], [1979063, 0, (-34200), (-36000)], [1979301, 0, (-36000), (-34200)], [1980062, 0, (-34200), (-36000)], [1980300, 0, (-36000), (-34200)], [1981060, 0, (-34200), (-36000)], [1981298, 0, (-36000), (-34200)], [1982066, 0, (-34200), (-36000)], [1982304, 0, (-36000), (-34200)], [1983065, 0, (-34200), (-36000)], [1983303, 0, (-36000), (-34200)], [1984064, 0, (-34200), (-36000)], [1984302, 0, (-36000), (-34200)], [1985062, 0, (-34200), (-36000)], [1985300, 0, (-36000), (-34200)], [1986061, 0, (-34200), (-36000)], [1986299, 0, (-36000), (-34200)], [1987060, 0, (-34200), (-36000)], [1987298, 0, (-36000), (-34200)], [1988066, 0, (-34200), (-36000)], [1988304, 0, (-36000), (-34200)], [1989064, 0, (-34200), (-36000)], [1989302, 0, (-36000), (-34200)], [1990063, 0, (-34200), (-36000)], [1990301, 0, (-36000), (-34200)], [1991062, 0, (-34200), (-36000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacng$__f_Pacific_Rarotonga = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacng$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacng$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacng$.prototype.constructor = $c_Lzonedb_java_tzdb$pacng$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacng$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacng$.prototype = $c_Lzonedb_java_tzdb$pacng$.prototype;
$c_Lzonedb_java_tzdb$pacng$.prototype.Pacific_Rarotonga__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacng$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 50")
  };
  return this.Lzonedb_java_tzdb$pacng$__f_Pacific_Rarotonga
});
var $d_Lzonedb_java_tzdb$pacng$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacng$: 0
}, false, "zonedb.java.tzdb$pacng$", {
  Lzonedb_java_tzdb$pacng$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacng$.prototype.$classData = $d_Lzonedb_java_tzdb$pacng$;
var $n_Lzonedb_java_tzdb$pacng$;
function $m_Lzonedb_java_tzdb$pacng$() {
  if ((!$n_Lzonedb_java_tzdb$pacng$)) {
    $n_Lzonedb_java_tzdb$pacng$ = new $c_Lzonedb_java_tzdb$pacng$()
  };
  return $n_Lzonedb_java_tzdb$pacng$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacof$() {
  this.Lzonedb_java_tzdb$pacof$__f_Pacific_Fakaofo = null;
  this.Lzonedb_java_tzdb$pacof$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacof$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-41096)), $ct_T2__O__O__(new $c_T2(), "w", (-41096)), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, (-41096), (-39600)], [2011364, 0, (-39600), 46800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, (-41096), (-39600)], [2011364, 0, (-39600), 46800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacof$__f_Pacific_Fakaofo = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacof$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacof$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacof$.prototype.constructor = $c_Lzonedb_java_tzdb$pacof$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacof$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacof$.prototype = $c_Lzonedb_java_tzdb$pacof$.prototype;
$c_Lzonedb_java_tzdb$pacof$.prototype.Pacific_Fakaofo__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacof$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 568")
  };
  return this.Lzonedb_java_tzdb$pacof$__f_Pacific_Fakaofo
});
var $d_Lzonedb_java_tzdb$pacof$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacof$: 0
}, false, "zonedb.java.tzdb$pacof$", {
  Lzonedb_java_tzdb$pacof$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacof$.prototype.$classData = $d_Lzonedb_java_tzdb$pacof$;
var $n_Lzonedb_java_tzdb$pacof$;
function $m_Lzonedb_java_tzdb$pacof$() {
  if ((!$n_Lzonedb_java_tzdb$pacof$)) {
    $n_Lzonedb_java_tzdb$pacof$ = new $c_Lzonedb_java_tzdb$pacof$()
  };
  return $n_Lzonedb_java_tzdb$pacof$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacol$() {
  this.Lzonedb_java_tzdb$pacol$__f_Pacific_Norfolk = null;
  this.Lzonedb_java_tzdb$pacol$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacol$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 40312), $ct_T2__O__O__(new $c_T2(), "w", 40312), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 40312, 40320], [1951001, 0, 40320, 41400], [2015277, 7200, 41400, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 40312, 40320], [1951001, 0, 40320, 41400], [1974300, 7200, 41400, 45000], [1975061, 10800, 45000, 41400], [2015277, 7200, 41400, 39600], [2019279, 7200, 39600, 43200], [2020096, 10800, 43200, 39600], [2020278, 7200, 39600, 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 7200, 0, 2, 39600, 43200, 39600], [10, 1, 7, 7200, 0, 2, 39600, 39600, 43200]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacol$__f_Pacific_Norfolk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacol$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacol$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacol$.prototype.constructor = $c_Lzonedb_java_tzdb$pacol$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacol$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacol$.prototype = $c_Lzonedb_java_tzdb$pacol$.prototype;
$c_Lzonedb_java_tzdb$pacol$.prototype.Pacific_Norfolk__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacol$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 98")
  };
  return this.Lzonedb_java_tzdb$pacol$__f_Pacific_Norfolk
});
var $d_Lzonedb_java_tzdb$pacol$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacol$: 0
}, false, "zonedb.java.tzdb$pacol$", {
  Lzonedb_java_tzdb$pacol$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacol$.prototype.$classData = $d_Lzonedb_java_tzdb$pacol$;
var $n_Lzonedb_java_tzdb$pacol$;
function $m_Lzonedb_java_tzdb$pacol$() {
  if ((!$n_Lzonedb_java_tzdb$pacol$)) {
    $n_Lzonedb_java_tzdb$pacol$ = new $c_Lzonedb_java_tzdb$pacol$()
  };
  return $n_Lzonedb_java_tzdb$pacol$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacpe$() {
  this.Lzonedb_java_tzdb$pacpe$__f_Pacific_Pohnpei = null;
  this.Lzonedb_java_tzdb$pacpe$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacpe$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-48428)), $ct_T2__O__O__(new $c_T2(), "w", (-48428)), $ct_T2__O__O__(new $c_T2(), "t", [[1844366, 0, (-48428), 37972], [1901001, 0, 37972, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1844366, 0, (-48428), 37972], [1901001, 0, 37972, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacpe$__f_Pacific_Pohnpei = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacpe$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacpe$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacpe$.prototype.constructor = $c_Lzonedb_java_tzdb$pacpe$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacpe$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacpe$.prototype = $c_Lzonedb_java_tzdb$pacpe$.prototype;
$c_Lzonedb_java_tzdb$pacpe$.prototype.Pacific_Pohnpei__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacpe$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 110")
  };
  return this.Lzonedb_java_tzdb$pacpe$__f_Pacific_Pohnpei
});
var $d_Lzonedb_java_tzdb$pacpe$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacpe$: 0
}, false, "zonedb.java.tzdb$pacpe$", {
  Lzonedb_java_tzdb$pacpe$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacpe$.prototype.$classData = $d_Lzonedb_java_tzdb$pacpe$;
var $n_Lzonedb_java_tzdb$pacpe$;
function $m_Lzonedb_java_tzdb$pacpe$() {
  if ((!$n_Lzonedb_java_tzdb$pacpe$)) {
    $n_Lzonedb_java_tzdb$pacpe$ = new $c_Lzonedb_java_tzdb$pacpe$()
  };
  return $n_Lzonedb_java_tzdb$pacpe$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacpi$() {
  this.Lzonedb_java_tzdb$pacpi$__f_Pacific_Apia = null;
  this.Lzonedb_java_tzdb$pacpi$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacpi$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 45184), $ct_T2__O__O__(new $c_T2(), "w", 45184), $ct_T2__O__O__(new $c_T2(), "t", [[1892187, 0, 45184, (-41216)], [1911001, 0, (-41216), (-41400)], [1950001, 0, (-41400), (-39600)], [2011363, 82800, (-39600), 46800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1892187, 0, 45184, (-41216)], [1911001, 0, (-41216), (-41400)], [1950001, 0, (-41400), (-39600)], [2010269, 0, (-39600), (-36000)], [2011092, 14400, (-36000), (-39600)], [2011267, 10800, (-39600), (-36000)], [2011364, 0, (-36000), 50400], [2012092, 14400, 50400, 46800], [2012274, 10800, 46800, 50400], [2013097, 14400, 50400, 46800], [2013272, 10800, 46800, 50400]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 1, 7, 14400, 0, 1, 46800, 50400, 46800], [9, 24, 7, 10800, 0, 1, 46800, 46800, 50400]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacpi$__f_Pacific_Apia = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacpi$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacpi$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacpi$.prototype.constructor = $c_Lzonedb_java_tzdb$pacpi$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacpi$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacpi$.prototype = $c_Lzonedb_java_tzdb$pacpi$.prototype;
$c_Lzonedb_java_tzdb$pacpi$.prototype.Pacific_Apia__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacpi$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 283")
  };
  return this.Lzonedb_java_tzdb$pacpi$__f_Pacific_Apia
});
var $d_Lzonedb_java_tzdb$pacpi$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacpi$: 0
}, false, "zonedb.java.tzdb$pacpi$", {
  Lzonedb_java_tzdb$pacpi$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacpi$.prototype.$classData = $d_Lzonedb_java_tzdb$pacpi$;
var $n_Lzonedb_java_tzdb$pacpi$;
function $m_Lzonedb_java_tzdb$pacpi$() {
  if ((!$n_Lzonedb_java_tzdb$pacpi$)) {
    $n_Lzonedb_java_tzdb$pacpi$ = new $c_Lzonedb_java_tzdb$pacpi$()
  };
  return $n_Lzonedb_java_tzdb$pacpi$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacra$() {
  this.Lzonedb_java_tzdb$pacra$__f_Pacific_Kosrae = null;
  this.Lzonedb_java_tzdb$pacra$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacra$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-47284)), $ct_T2__O__O__(new $c_T2(), "w", (-47284)), $ct_T2__O__O__(new $c_T2(), "t", [[1844366, 0, (-47284), 39116], [1901001, 0, 39116, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 39600], [1969274, 0, 39600, 43200], [1999001, 0, 43200, 39600]]), $ct_T2__O__O__(new $c_T2(), "l", [[1844366, 0, (-47284), 39116], [1901001, 0, 39116, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 39600], [1969274, 0, 39600, 43200], [1999001, 0, 43200, 39600]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacra$__f_Pacific_Kosrae = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacra$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacra$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacra$.prototype.constructor = $c_Lzonedb_java_tzdb$pacra$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacra$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacra$.prototype = $c_Lzonedb_java_tzdb$pacra$.prototype;
$c_Lzonedb_java_tzdb$pacra$.prototype.Pacific_Kosrae__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacra$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 320")
  };
  return this.Lzonedb_java_tzdb$pacra$__f_Pacific_Kosrae
});
var $d_Lzonedb_java_tzdb$pacra$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacra$: 0
}, false, "zonedb.java.tzdb$pacra$", {
  Lzonedb_java_tzdb$pacra$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacra$.prototype.$classData = $d_Lzonedb_java_tzdb$pacra$;
var $n_Lzonedb_java_tzdb$pacra$;
function $m_Lzonedb_java_tzdb$pacra$() {
  if ((!$n_Lzonedb_java_tzdb$pacra$)) {
    $n_Lzonedb_java_tzdb$pacra$ = new $c_Lzonedb_java_tzdb$pacra$()
  };
  return $n_Lzonedb_java_tzdb$pacra$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacsa$() {
  this.Lzonedb_java_tzdb$pacsa$__f_Pacific_Marquesas = null;
  this.Lzonedb_java_tzdb$pacsa$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacsa$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-33480)), $ct_T2__O__O__(new $c_T2(), "w", (-33480)), $ct_T2__O__O__(new $c_T2(), "t", [[1912275, 0, (-33480), (-34200)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1912275, 0, (-33480), (-34200)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacsa$__f_Pacific_Marquesas = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacsa$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacsa$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacsa$.prototype.constructor = $c_Lzonedb_java_tzdb$pacsa$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacsa$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacsa$.prototype = $c_Lzonedb_java_tzdb$pacsa$.prototype;
$c_Lzonedb_java_tzdb$pacsa$.prototype.Pacific_Marquesas__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacsa$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 844")
  };
  return this.Lzonedb_java_tzdb$pacsa$__f_Pacific_Marquesas
});
var $d_Lzonedb_java_tzdb$pacsa$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacsa$: 0
}, false, "zonedb.java.tzdb$pacsa$", {
  Lzonedb_java_tzdb$pacsa$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacsa$.prototype.$classData = $d_Lzonedb_java_tzdb$pacsa$;
var $n_Lzonedb_java_tzdb$pacsa$;
function $m_Lzonedb_java_tzdb$pacsa$() {
  if ((!$n_Lzonedb_java_tzdb$pacsa$)) {
    $n_Lzonedb_java_tzdb$pacsa$ = new $c_Lzonedb_java_tzdb$pacsa$()
  };
  return $n_Lzonedb_java_tzdb$pacsa$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacsb$() {
  this.Lzonedb_java_tzdb$pacsb$__f_Pacific_Port_Moresby = null;
  this.Lzonedb_java_tzdb$pacsb$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacsb$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 35320), $ct_T2__O__O__(new $c_T2(), "w", 35320), $ct_T2__O__O__(new $c_T2(), "t", [[1880001, 0, 35320, 35312], [1895001, 0, 35312, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1880001, 0, 35320, 35312], [1895001, 0, 35312, 36000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacsb$__f_Pacific_Port_Moresby = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacsb$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacsb$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacsb$.prototype.constructor = $c_Lzonedb_java_tzdb$pacsb$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacsb$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacsb$.prototype = $c_Lzonedb_java_tzdb$pacsb$.prototype;
$c_Lzonedb_java_tzdb$pacsb$.prototype.Pacific_Port_Moresby__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacsb$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 307")
  };
  return this.Lzonedb_java_tzdb$pacsb$__f_Pacific_Port_Moresby
});
var $d_Lzonedb_java_tzdb$pacsb$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacsb$: 0
}, false, "zonedb.java.tzdb$pacsb$", {
  Lzonedb_java_tzdb$pacsb$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacsb$.prototype.$classData = $d_Lzonedb_java_tzdb$pacsb$;
var $n_Lzonedb_java_tzdb$pacsb$;
function $m_Lzonedb_java_tzdb$pacsb$() {
  if ((!$n_Lzonedb_java_tzdb$pacsb$)) {
    $n_Lzonedb_java_tzdb$pacsb$ = new $c_Lzonedb_java_tzdb$pacsb$()
  };
  return $n_Lzonedb_java_tzdb$pacsb$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacte$() {
  this.Lzonedb_java_tzdb$pacte$__f_Pacific_Easter = null;
  this.Lzonedb_java_tzdb$pacte$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacte$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-26248)), $ct_T2__O__O__(new $c_T2(), "w", (-26248)), $ct_T2__O__O__(new $c_T2(), "t", [[1932245, 0, (-26248), (-25200)], [1982072, 72000, (-25200), (-21600)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1932245, 0, (-26248), (-25200)], [1968307, 75600, (-25200), (-21600)], [1969088, 75600, (-21600), (-25200)], [1969326, 75600, (-25200), (-21600)], [1970087, 75600, (-21600), (-25200)], [1970283, 75600, (-25200), (-21600)], [1971072, 75600, (-21600), (-25200)], [1971282, 75600, (-25200), (-21600)], [1972071, 75600, (-21600), (-25200)], [1972288, 75600, (-25200), (-21600)], [1973069, 75600, (-21600), (-25200)], [1973272, 75600, (-25200), (-21600)], [1974068, 75600, (-21600), (-25200)], [1974285, 75600, (-25200), (-21600)], [1975067, 75600, (-21600), (-25200)], [1975284, 75600, (-25200), (-21600)], [1976073, 75600, (-21600), (-25200)], [1976283, 75600, (-25200), (-21600)], [1977071, 75600, (-21600), (-25200)], [1977281, 75600, (-25200), (-21600)], [1978070, 75600, (-21600), (-25200)], [1978287, 75600, (-25200), (-21600)], [1979069, 75600, (-21600), (-25200)], [1979286, 75600, (-25200), (-21600)], [1980068, 75600, (-21600), (-25200)], [1980285, 75600, (-25200), (-21600)], [1981073, 75600, (-21600), (-25200)], [1981283, 75600, (-25200), (-21600)], [1982282, 79200, (-21600), (-18000)], [1983071, 79200, (-18000), (-21600)], [1983281, 79200, (-21600), (-18000)], [1984070, 79200, (-18000), (-21600)], [1984287, 79200, (-21600), (-18000)], [1985068, 79200, (-18000), (-21600)], [1985285, 79200, (-21600), (-18000)], [1986067, 79200, (-18000), (-21600)], [1986284, 79200, (-21600), (-18000)], [1987101, 79200, (-18000), (-21600)], [1987283, 79200, (-21600), (-18000)], [1988072, 79200, (-18000), (-21600)], [1988282, 79200, (-21600), (-18000)], [1989070, 79200, (-18000), (-21600)], [1989287, 79200, (-21600), (-18000)], [1990069, 79200, (-18000), (-21600)], [1990258, 79200, (-21600), (-18000)], [1991068, 79200, (-18000), (-21600)], [1991285, 79200, (-21600), (-18000)], [1992074, 79200, (-18000), (-21600)], [1992284, 79200, (-21600), (-18000)], [1993072, 79200, (-18000), (-21600)], [1993282, 79200, (-21600), (-18000)], [1994071, 79200, (-18000), (-21600)], [1994281, 79200, (-21600), (-18000)], [1995070, 79200, (-18000), (-21600)], [1995287, 79200, (-21600), (-18000)], [1996069, 79200, (-18000), (-21600)], [1996286, 79200, (-21600), (-18000)], [1997088, 79200, (-18000), (-21600)], [1997284, 79200, (-21600), (-18000)], [1998073, 79200, (-18000), (-21600)], [1998269, 79200, (-21600), (-18000)], [1999093, 79200, (-18000), (-21600)], [1999282, 79200, (-21600), (-18000)], [2000071, 79200, (-18000), (-21600)], [2000288, 79200, (-21600), (-18000)], [2001069, 79200, (-18000), (-21600)], [2001286, 79200, (-21600), (-18000)], [2002068, 79200, (-18000), (-21600)], [2002285, 79200, (-21600), (-18000)], [2003067, 79200, (-18000), (-21600)], [2003284, 79200, (-21600), (-18000)], [2004073, 79200, (-18000), (-21600)], [2004283, 79200, (-21600), (-18000)], [2005071, 79200, (-18000), (-21600)], [2005281, 79200, (-21600), (-18000)], [2006070, 79200, (-18000), (-21600)], [2006287, 79200, (-21600), (-18000)], [2007069, 79200, (-18000), (-21600)], [2007286, 79200, (-21600), (-18000)], [2008089, 79200, (-18000), (-21600)], [2008285, 79200, (-21600), (-18000)], [2009073, 79200, (-18000), (-21600)], [2009283, 79200, (-21600), (-18000)], [2010093, 79200, (-18000), (-21600)], [2010282, 79200, (-21600), (-18000)], [2011127, 79200, (-18000), (-21600)], [2011232, 79200, (-21600), (-18000)], [2012119, 79200, (-18000), (-21600)], [2012245, 79200, (-21600), (-18000)], [2013117, 79200, (-18000), (-21600)], [2013250, 79200, (-21600), (-18000)], [2014116, 79200, (-18000), (-21600)], [2014249, 79200, (-21600), (-18000)], [2016135, 79200, (-18000), (-21600)], [2016226, 79200, (-21600), (-18000)], [2017133, 79200, (-18000), (-21600)], [2017224, 79200, (-21600), (-18000)], [2018132, 79200, (-18000), (-21600)], [2018223, 79200, (-21600), (-18000)], [2019096, 79200, (-18000), (-21600)], [2019250, 79200, (-21600), (-18000)], [2020095, 79200, (-18000), (-21600)], [2020249, 79200, (-21600), (-18000)]]), $ct_T2__O__O__(new $c_T2(), "r", [[4, 2, 7, 10800, 0, 0, (-21600), (-18000), (-21600)], [9, 2, 7, 14400, 0, 0, (-21600), (-21600), (-18000)]])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacte$__f_Pacific_Easter = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacte$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacte$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacte$.prototype.constructor = $c_Lzonedb_java_tzdb$pacte$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacte$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacte$.prototype = $c_Lzonedb_java_tzdb$pacte$.prototype;
$c_Lzonedb_java_tzdb$pacte$.prototype.Pacific_Easter__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacte$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 125")
  };
  return this.Lzonedb_java_tzdb$pacte$__f_Pacific_Easter
});
var $d_Lzonedb_java_tzdb$pacte$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacte$: 0
}, false, "zonedb.java.tzdb$pacte$", {
  Lzonedb_java_tzdb$pacte$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacte$.prototype.$classData = $d_Lzonedb_java_tzdb$pacte$;
var $n_Lzonedb_java_tzdb$pacte$;
function $m_Lzonedb_java_tzdb$pacte$() {
  if ((!$n_Lzonedb_java_tzdb$pacte$)) {
    $n_Lzonedb_java_tzdb$pacte$ = new $c_Lzonedb_java_tzdb$pacte$()
  };
  return $n_Lzonedb_java_tzdb$pacte$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacua$() {
  this.Lzonedb_java_tzdb$pacua$__f_Pacific_Guam = null;
  this.Lzonedb_java_tzdb$pacua$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacua$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-51660)), $ct_T2__O__O__(new $c_T2(), "w", (-51660)), $ct_T2__O__O__(new $c_T2(), "t", [[1844366, 0, (-51660), 34740], [1901001, 0, 34740, 36000], [1941344, 0, 36000, 32400], [1944213, 0, 32400, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1844366, 0, (-51660), 34740], [1901001, 0, 34740, 36000], [1941344, 0, 36000, 32400], [1944213, 0, 32400, 36000], [1959178, 7200, 36000, 39600], [1961029, 7200, 39600, 36000], [1967244, 7200, 36000, 39600], [1969026, 60, 39600, 36000], [1969173, 7200, 36000, 39600], [1969243, 7200, 39600, 36000], [1970116, 7200, 36000, 39600], [1970249, 7200, 39600, 36000], [1971115, 7200, 36000, 39600], [1971248, 7200, 39600, 36000], [1973350, 7200, 36000, 39600], [1974055, 7200, 39600, 36000], [1976147, 7200, 36000, 39600], [1976235, 7260, 39600, 36000], [1977114, 7200, 36000, 39600], [1977240, 7200, 39600, 36000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacua$__f_Pacific_Guam = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacua$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacua$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacua$.prototype.constructor = $c_Lzonedb_java_tzdb$pacua$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacua$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacua$.prototype = $c_Lzonedb_java_tzdb$pacua$.prototype;
$c_Lzonedb_java_tzdb$pacua$.prototype.Pacific_Guam__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacua$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 608")
  };
  return this.Lzonedb_java_tzdb$pacua$__f_Pacific_Guam
});
var $d_Lzonedb_java_tzdb$pacua$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacua$: 0
}, false, "zonedb.java.tzdb$pacua$", {
  Lzonedb_java_tzdb$pacua$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacua$.prototype.$classData = $d_Lzonedb_java_tzdb$pacua$;
var $n_Lzonedb_java_tzdb$pacua$;
function $m_Lzonedb_java_tzdb$pacua$() {
  if ((!$n_Lzonedb_java_tzdb$pacua$)) {
    $n_Lzonedb_java_tzdb$pacua$ = new $c_Lzonedb_java_tzdb$pacua$()
  };
  return $n_Lzonedb_java_tzdb$pacua$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacul$() {
  this.Lzonedb_java_tzdb$pacul$__f_Pacific_Honolulu = null;
  this.Lzonedb_java_tzdb$pacul$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacul$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-37886)), $ct_T2__O__O__(new $c_T2(), "w", (-37886)), $ct_T2__O__O__(new $c_T2(), "t", [[1896013, 43200, (-37886), (-37800)], [1947159, 7200, (-37800), (-36000)]]), $ct_T2__O__O__(new $c_T2(), "l", [[1896013, 43200, (-37886), (-37800)], [1933120, 7200, (-37800), (-34200)], [1933141, 43200, (-34200), (-37800)], [1942040, 7200, (-37800), (-34200)], [1945273, 7200, (-34200), (-37800)], [1947159, 7200, (-37800), (-36000)]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacul$__f_Pacific_Honolulu = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacul$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacul$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacul$.prototype.constructor = $c_Lzonedb_java_tzdb$pacul$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacul$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacul$.prototype = $c_Lzonedb_java_tzdb$pacul$.prototype;
$c_Lzonedb_java_tzdb$pacul$.prototype.Pacific_Honolulu__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacul$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 795")
  };
  return this.Lzonedb_java_tzdb$pacul$__f_Pacific_Honolulu
});
var $d_Lzonedb_java_tzdb$pacul$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacul$: 0
}, false, "zonedb.java.tzdb$pacul$", {
  Lzonedb_java_tzdb$pacul$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacul$.prototype.$classData = $d_Lzonedb_java_tzdb$pacul$;
var $n_Lzonedb_java_tzdb$pacul$;
function $m_Lzonedb_java_tzdb$pacul$() {
  if ((!$n_Lzonedb_java_tzdb$pacul$)) {
    $n_Lzonedb_java_tzdb$pacul$ = new $c_Lzonedb_java_tzdb$pacul$()
  };
  return $n_Lzonedb_java_tzdb$pacul$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacur$() {
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Nauru = null;
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Majuro = null;
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Enderbury = null;
  this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0 = 0;
  $n_Lzonedb_java_tzdb$pacur$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 40060), $ct_T2__O__O__(new $c_T2(), "w", 40060), $ct_T2__O__O__(new $c_T2(), "t", [[1921015, 0, 40060, 41400], [1942241, 0, 41400, 32400], [1945251, 0, 32400, 41400], [1979041, 7200, 41400, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1921015, 0, 40060, 41400], [1942241, 0, 41400, 32400], [1945251, 0, 32400, 41400], [1979041, 7200, 41400, 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Nauru = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0 = (((1 | this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0) << 24) >> 24);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "s", 41088), $ct_T2__O__O__(new $c_T2(), "w", 41088), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 41088, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1944030, 0, 32400, 39600], [1969274, 0, 39600, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 41088, 39600], [1914274, 0, 39600, 32400], [1919032, 0, 32400, 39600], [1937001, 0, 39600, 36000], [1941091, 0, 36000, 32400], [1944030, 0, 32400, 39600], [1969274, 0, 39600, 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Majuro = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0 = (((2 | this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0) << 24) >> 24);
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "s", (-41060)), $ct_T2__O__O__(new $c_T2(), "w", (-41060)), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, (-41060), (-43200)], [1979274, 0, (-43200), (-39600)], [1994365, 0, (-39600), 46800]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, (-41060), (-43200)], [1979274, 0, (-43200), (-39600)], [1994365, 0, (-39600), 46800]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lzonedb_java_tzdb$pacur$__f_Pacific_Enderbury = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0 = (((4 | this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lzonedb_java_tzdb$pacur$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacur$.prototype.constructor = $c_Lzonedb_java_tzdb$pacur$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacur$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacur$.prototype = $c_Lzonedb_java_tzdb$pacur$.prototype;
$c_Lzonedb_java_tzdb$pacur$.prototype.Pacific_Nauru__sjs_js_Dynamic = (function() {
  if (((((1 & this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 648")
  };
  return this.Lzonedb_java_tzdb$pacur$__f_Pacific_Nauru
});
$c_Lzonedb_java_tzdb$pacur$.prototype.Pacific_Majuro__sjs_js_Dynamic = (function() {
  if (((((2 & this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 649")
  };
  return this.Lzonedb_java_tzdb$pacur$__f_Pacific_Majuro
});
$c_Lzonedb_java_tzdb$pacur$.prototype.Pacific_Enderbury__sjs_js_Dynamic = (function() {
  if (((((4 & this.Lzonedb_java_tzdb$pacur$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 650")
  };
  return this.Lzonedb_java_tzdb$pacur$__f_Pacific_Enderbury
});
var $d_Lzonedb_java_tzdb$pacur$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacur$: 0
}, false, "zonedb.java.tzdb$pacur$", {
  Lzonedb_java_tzdb$pacur$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacur$.prototype.$classData = $d_Lzonedb_java_tzdb$pacur$;
var $n_Lzonedb_java_tzdb$pacur$;
function $m_Lzonedb_java_tzdb$pacur$() {
  if ((!$n_Lzonedb_java_tzdb$pacur$)) {
    $n_Lzonedb_java_tzdb$pacur$ = new $c_Lzonedb_java_tzdb$pacur$()
  };
  return $n_Lzonedb_java_tzdb$pacur$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacut$() {
  this.Lzonedb_java_tzdb$pacut$__f_Pacific_Funafuti = null;
  this.Lzonedb_java_tzdb$pacut$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacut$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", 43012), $ct_T2__O__O__(new $c_T2(), "w", 43012), $ct_T2__O__O__(new $c_T2(), "t", [[1901001, 0, 43012, 43200]]), $ct_T2__O__O__(new $c_T2(), "l", [[1901001, 0, 43012, 43200]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacut$__f_Pacific_Funafuti = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacut$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacut$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacut$.prototype.constructor = $c_Lzonedb_java_tzdb$pacut$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacut$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacut$.prototype = $c_Lzonedb_java_tzdb$pacut$.prototype;
$c_Lzonedb_java_tzdb$pacut$.prototype.Pacific_Funafuti__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacut$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 689")
  };
  return this.Lzonedb_java_tzdb$pacut$__f_Pacific_Funafuti
});
var $d_Lzonedb_java_tzdb$pacut$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacut$: 0
}, false, "zonedb.java.tzdb$pacut$", {
  Lzonedb_java_tzdb$pacut$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacut$.prototype.$classData = $d_Lzonedb_java_tzdb$pacut$;
var $n_Lzonedb_java_tzdb$pacut$;
function $m_Lzonedb_java_tzdb$pacut$() {
  if ((!$n_Lzonedb_java_tzdb$pacut$)) {
    $n_Lzonedb_java_tzdb$pacut$ = new $c_Lzonedb_java_tzdb$pacut$()
  };
  return $n_Lzonedb_java_tzdb$pacut$
}
/** @constructor */
function $c_Lzonedb_java_tzdb$pacuu$() {
  this.Lzonedb_java_tzdb$pacuu$__f_Pacific_Chuuk = null;
  this.Lzonedb_java_tzdb$pacuu$__f_bitmap$init$0 = false;
  $n_Lzonedb_java_tzdb$pacuu$ = this;
  var array = [$ct_T2__O__O__(new $c_T2(), "s", (-49972)), $ct_T2__O__O__(new $c_T2(), "w", (-49972)), $ct_T2__O__O__(new $c_T2(), "t", [[1844366, 0, (-49972), 36428], [1901001, 0, 36428, 36000], [1914274, 0, 36000, 32400], [1919032, 0, 32400, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 36000]]), $ct_T2__O__O__(new $c_T2(), "l", [[1844366, 0, (-49972), 36428], [1901001, 0, 36428, 36000], [1914274, 0, 36000, 32400], [1919032, 0, 32400, 36000], [1941091, 0, 36000, 32400], [1945213, 0, 32400, 36000]]), $ct_T2__O__O__(new $c_T2(), "r", [])];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lzonedb_java_tzdb$pacuu$__f_Pacific_Chuuk = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  this.Lzonedb_java_tzdb$pacuu$__f_bitmap$init$0 = true
}
$c_Lzonedb_java_tzdb$pacuu$.prototype = new $h_O();
$c_Lzonedb_java_tzdb$pacuu$.prototype.constructor = $c_Lzonedb_java_tzdb$pacuu$;
/** @constructor */
function $h_Lzonedb_java_tzdb$pacuu$() {
  /*<skip>*/
}
$h_Lzonedb_java_tzdb$pacuu$.prototype = $c_Lzonedb_java_tzdb$pacuu$.prototype;
$c_Lzonedb_java_tzdb$pacuu$.prototype.Pacific_Chuuk__sjs_js_Dynamic = (function() {
  if ((!this.Lzonedb_java_tzdb$pacuu$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/tzdb/tzdb_java.scala: 116")
  };
  return this.Lzonedb_java_tzdb$pacuu$__f_Pacific_Chuuk
});
var $d_Lzonedb_java_tzdb$pacuu$ = new $TypeData().initClass({
  Lzonedb_java_tzdb$pacuu$: 0
}, false, "zonedb.java.tzdb$pacuu$", {
  Lzonedb_java_tzdb$pacuu$: 1,
  O: 1
});
$c_Lzonedb_java_tzdb$pacuu$.prototype.$classData = $d_Lzonedb_java_tzdb$pacuu$;
var $n_Lzonedb_java_tzdb$pacuu$;
function $m_Lzonedb_java_tzdb$pacuu$() {
  if ((!$n_Lzonedb_java_tzdb$pacuu$)) {
    $n_Lzonedb_java_tzdb$pacuu$ = new $c_Lzonedb_java_tzdb$pacuu$()
  };
  return $n_Lzonedb_java_tzdb$pacuu$
}
/** @constructor */
function $c_Lcats_Eval() {
  /*<skip>*/
}
$c_Lcats_Eval.prototype = new $h_O();
$c_Lcats_Eval.prototype.constructor = $c_Lcats_Eval;
/** @constructor */
function $h_Lcats_Eval() {
  /*<skip>*/
}
$h_Lcats_Eval.prototype = $c_Lcats_Eval.prototype;
$c_Lcats_Eval.prototype.map__F1__Lcats_Eval = (function(f) {
  return this.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((a$2) => new $c_Lcats_Now($n(f).apply__O__O(a$2)))))
});
$c_Lcats_Eval.prototype.flatMap__F1__Lcats_Eval = (function(f) {
  if ((this instanceof $c_Lcats_Eval$FlatMap)) {
    var x2 = $as_Lcats_Eval$FlatMap(this);
    return new $c_Lcats_Eval$$anon$1(this, x2, f)
  } else if (false) {
    var x3 = $as_Lcats_Eval$Defer(this);
    return new $c_Lcats_Eval$$anon$3(this, x3, f)
  } else {
    return new $c_Lcats_Eval$$anon$4(this, f)
  }
});
function $as_Lcats_Eval(obj) {
  return (((obj instanceof $c_Lcats_Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval"))
}
function $isArrayOf_Lcats_Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval)))
}
function $asArrayOf_Lcats_Eval(obj, depth) {
  return (($isArrayOf_Lcats_Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval;", depth))
}
/** @constructor */
function $c_Lcats_EvalInstances0() {
  /*<skip>*/
}
$c_Lcats_EvalInstances0.prototype = new $h_Lcats_EvalInstances1();
$c_Lcats_EvalInstances0.prototype.constructor = $c_Lcats_EvalInstances0;
/** @constructor */
function $h_Lcats_EvalInstances0() {
  /*<skip>*/
}
$h_Lcats_EvalInstances0.prototype = $c_Lcats_EvalInstances0.prototype;
function $ct_Lcats_data_AndThenInstances0__($thiz) {
  new $c_Lcats_data_AndThenInstances0$$anon$3($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcats_data_AndThenInstances0() {
  /*<skip>*/
}
$c_Lcats_data_AndThenInstances0.prototype = new $h_Lcats_data_AndThenInstances1();
$c_Lcats_data_AndThenInstances0.prototype.constructor = $c_Lcats_data_AndThenInstances0;
/** @constructor */
function $h_Lcats_data_AndThenInstances0() {
  /*<skip>*/
}
$h_Lcats_data_AndThenInstances0.prototype = $c_Lcats_data_AndThenInstances0.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances0() {
  /*<skip>*/
}
$c_Lcats_data_NonEmptyListInstances0.prototype = new $h_Lcats_data_NonEmptyListInstances1();
$c_Lcats_data_NonEmptyListInstances0.prototype.constructor = $c_Lcats_data_NonEmptyListInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances0() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances0.prototype = $c_Lcats_data_NonEmptyListInstances0.prototype;
/** @constructor */
function $c_Lcats_data_ValidatedInstances1() {
  /*<skip>*/
}
$c_Lcats_data_ValidatedInstances1.prototype = new $h_Lcats_data_ValidatedInstances2();
$c_Lcats_data_ValidatedInstances1.prototype.constructor = $c_Lcats_data_ValidatedInstances1;
/** @constructor */
function $h_Lcats_data_ValidatedInstances1() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances1.prototype = $c_Lcats_data_ValidatedInstances1.prototype;
function $f_Lcats_instances_Function0Instances__$init$__V($thiz) {
  $thiz.cats$instances$Function0Instances$_setter_$catsStdBimonadForFunction0_$eq__Lcats_Bimonad__V(new $c_Lcats_instances_Function0Instances$$anon$4($thiz))
}
function $f_Lcats_instances_Function1Instances__$init$__V($thiz) {
  $thiz.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V(new $c_Lcats_instances_Function1Instances$$anon$8($thiz));
  $thiz.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V(new $c_Lcats_instances_Function1Instances$$anon$9($thiz))
}
function $f_Lcats_instances_SortedSetInstances__$init$__V($thiz) {
  $thiz.cats$instances$SortedSetInstances$_setter_$catsStdInstancesForSortedSet_$eq__Lcats_Foldable__V(new $c_Lcats_instances_SortedSetInstances$$anon$1($thiz))
}
/** @constructor */
function $c_Lcats_instances_package$equiv$() {
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = null;
  $n_Lcats_instances_package$equiv$ = this;
  $f_Lcats_instances_EquivInstances__$init$__V(this)
}
$c_Lcats_instances_package$equiv$.prototype = new $h_O();
$c_Lcats_instances_package$equiv$.prototype.constructor = $c_Lcats_instances_package$equiv$;
/** @constructor */
function $h_Lcats_instances_package$equiv$() {
  /*<skip>*/
}
$h_Lcats_instances_package$equiv$.prototype = $c_Lcats_instances_package$equiv$.prototype;
$c_Lcats_instances_package$equiv$.prototype.cats$instances$EquivInstances$_setter_$catsContravariantMonoidalForEquiv_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = x$1
});
var $d_Lcats_instances_package$equiv$ = new $TypeData().initClass({
  Lcats_instances_package$equiv$: 0
}, false, "cats.instances.package$equiv$", {
  Lcats_instances_package$equiv$: 1,
  O: 1,
  Lcats_instances_EquivInstances: 1
});
$c_Lcats_instances_package$equiv$.prototype.$classData = $d_Lcats_instances_package$equiv$;
var $n_Lcats_instances_package$equiv$;
function $m_Lcats_instances_package$equiv$() {
  if ((!$n_Lcats_instances_package$equiv$)) {
    $n_Lcats_instances_package$equiv$ = new $c_Lcats_instances_package$equiv$()
  };
  return $n_Lcats_instances_package$equiv$
}
/** @constructor */
function $c_Lcats_instances_package$invariant$() {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = null;
  $n_Lcats_instances_package$invariant$ = this;
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this)
}
$c_Lcats_instances_package$invariant$.prototype = new $h_O();
$c_Lcats_instances_package$invariant$.prototype.constructor = $c_Lcats_instances_package$invariant$;
/** @constructor */
function $h_Lcats_instances_package$invariant$() {
  /*<skip>*/
}
$h_Lcats_instances_package$invariant$.prototype = $c_Lcats_instances_package$invariant$.prototype;
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$1) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = x$1
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$1) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = x$1
});
var $d_Lcats_instances_package$invariant$ = new $TypeData().initClass({
  Lcats_instances_package$invariant$: 0
}, false, "cats.instances.package$invariant$", {
  Lcats_instances_package$invariant$: 1,
  O: 1,
  Lcats_instances_InvariantMonoidalInstances: 1
});
$c_Lcats_instances_package$invariant$.prototype.$classData = $d_Lcats_instances_package$invariant$;
var $n_Lcats_instances_package$invariant$;
function $m_Lcats_instances_package$invariant$() {
  if ((!$n_Lcats_instances_package$invariant$)) {
    $n_Lcats_instances_package$invariant$ = new $c_Lcats_instances_package$invariant$()
  };
  return $n_Lcats_instances_package$invariant$
}
/** @constructor */
function $c_Lcats_instances_package$ordering$() {
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = null;
  $n_Lcats_instances_package$ordering$ = this;
  $f_Lcats_instances_OrderingInstances__$init$__V(this)
}
$c_Lcats_instances_package$ordering$.prototype = new $h_O();
$c_Lcats_instances_package$ordering$.prototype.constructor = $c_Lcats_instances_package$ordering$;
/** @constructor */
function $h_Lcats_instances_package$ordering$() {
  /*<skip>*/
}
$h_Lcats_instances_package$ordering$.prototype = $c_Lcats_instances_package$ordering$.prototype;
$c_Lcats_instances_package$ordering$.prototype.cats$instances$OrderingInstances$_setter_$catsContravariantMonoidalForOrdering_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = x$1
});
var $d_Lcats_instances_package$ordering$ = new $TypeData().initClass({
  Lcats_instances_package$ordering$: 0
}, false, "cats.instances.package$ordering$", {
  Lcats_instances_package$ordering$: 1,
  O: 1,
  Lcats_instances_OrderingInstances: 1
});
$c_Lcats_instances_package$ordering$.prototype.$classData = $d_Lcats_instances_package$ordering$;
var $n_Lcats_instances_package$ordering$;
function $m_Lcats_instances_package$ordering$() {
  if ((!$n_Lcats_instances_package$ordering$)) {
    $n_Lcats_instances_package$ordering$ = new $c_Lcats_instances_package$ordering$()
  };
  return $n_Lcats_instances_package$ordering$
}
/** @constructor */
function $c_Lcats_instances_package$partialOrdering$() {
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = null;
  $n_Lcats_instances_package$partialOrdering$ = this;
  $f_Lcats_instances_PartialOrderingInstances__$init$__V(this)
}
$c_Lcats_instances_package$partialOrdering$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrdering$.prototype.constructor = $c_Lcats_instances_package$partialOrdering$;
/** @constructor */
function $h_Lcats_instances_package$partialOrdering$() {
  /*<skip>*/
}
$h_Lcats_instances_package$partialOrdering$.prototype = $c_Lcats_instances_package$partialOrdering$.prototype;
$c_Lcats_instances_package$partialOrdering$.prototype.cats$instances$PartialOrderingInstances$_setter_$catsContravariantMonoidalForPartialOrdering_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = x$1
});
var $d_Lcats_instances_package$partialOrdering$ = new $TypeData().initClass({
  Lcats_instances_package$partialOrdering$: 0
}, false, "cats.instances.package$partialOrdering$", {
  Lcats_instances_package$partialOrdering$: 1,
  O: 1,
  Lcats_instances_PartialOrderingInstances: 1
});
$c_Lcats_instances_package$partialOrdering$.prototype.$classData = $d_Lcats_instances_package$partialOrdering$;
var $n_Lcats_instances_package$partialOrdering$;
function $m_Lcats_instances_package$partialOrdering$() {
  if ((!$n_Lcats_instances_package$partialOrdering$)) {
    $n_Lcats_instances_package$partialOrdering$ = new $c_Lcats_instances_package$partialOrdering$()
  };
  return $n_Lcats_instances_package$partialOrdering$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$() {
  $n_Lcats_kernel_Comparison$ = this;
  new $c_s_Some($m_Lcats_kernel_Comparison$GreaterThan$());
  new $c_s_Some($m_Lcats_kernel_Comparison$EqualTo$());
  new $c_s_Some($m_Lcats_kernel_Comparison$LessThan$());
  new $c_Lcats_kernel_Eq$$anon$6()
}
$c_Lcats_kernel_Comparison$.prototype = new $h_O();
$c_Lcats_kernel_Comparison$.prototype.constructor = $c_Lcats_kernel_Comparison$;
/** @constructor */
function $h_Lcats_kernel_Comparison$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$.prototype = $c_Lcats_kernel_Comparison$.prototype;
var $d_Lcats_kernel_Comparison$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$: 0
}, false, "cats.kernel.Comparison$", {
  Lcats_kernel_Comparison$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Comparison$.prototype.$classData = $d_Lcats_kernel_Comparison$;
var $n_Lcats_kernel_Comparison$;
function $m_Lcats_kernel_Comparison$() {
  if ((!$n_Lcats_kernel_Comparison$)) {
    $n_Lcats_kernel_Comparison$ = new $c_Lcats_kernel_Comparison$()
  };
  return $n_Lcats_kernel_Comparison$
}
function $f_Lcats_kernel_Eq__neqv__O__O__Z($thiz, x, y) {
  return (!$thiz.eqv__O__O__Z(x, y))
}
function $is_Lcats_kernel_Eq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Eq)))
}
function $as_Lcats_kernel_Eq(obj) {
  return (($is_Lcats_kernel_Eq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Eq"))
}
function $isArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Eq)))
}
function $asArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Eq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Eq;", depth))
}
/** @constructor */
function $c_Lcats_kernel_HashFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_HashFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_HashFunctions.prototype.constructor = $c_Lcats_kernel_HashFunctions;
/** @constructor */
function $h_Lcats_kernel_HashFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_HashFunctions.prototype = $c_Lcats_kernel_HashFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_PartialOrderFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_PartialOrderFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_PartialOrderFunctions.prototype.constructor = $c_Lcats_kernel_PartialOrderFunctions;
/** @constructor */
function $h_Lcats_kernel_PartialOrderFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_PartialOrderFunctions.prototype = $c_Lcats_kernel_PartialOrderFunctions.prototype;
function $is_Lcats_kernel_Semigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Semigroup)))
}
function $as_Lcats_kernel_Semigroup(obj) {
  return (($is_Lcats_kernel_Semigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Semigroup"))
}
function $isArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Semigroup)))
}
function $asArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Semigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Semigroup;", depth))
}
function $p_Lcom_iz2use_common_Filter$DefaultFilter__pushValue$1__T__I__I__scm_Builder__O($thiz, v, start, end, acc$1) {
  $m_sc_StringOps$();
  var this$3 = $n(v);
  if ((!(this$3 === ""))) {
    var this$4 = $n(acc$1);
    var elem = new $c_Lcom_iz2use_common_internal_tokenizer_Token(v, start, end);
    return this$4.addOne__O__scm_Growable(elem)
  } else {
    return (void 0)
  }
}
/** @constructor */
function $c_Lcom_iz2use_common_Filter$DefaultFilter(separators) {
  this.Lcom_iz2use_common_Filter$DefaultFilter__f_separators = null;
  this.Lcom_iz2use_common_Filter$DefaultFilter__f_separators = separators
}
$c_Lcom_iz2use_common_Filter$DefaultFilter.prototype = new $h_O();
$c_Lcom_iz2use_common_Filter$DefaultFilter.prototype.constructor = $c_Lcom_iz2use_common_Filter$DefaultFilter;
/** @constructor */
function $h_Lcom_iz2use_common_Filter$DefaultFilter() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Filter$DefaultFilter.prototype = $c_Lcom_iz2use_common_Filter$DefaultFilter.prototype;
$c_Lcom_iz2use_common_Filter$DefaultFilter.prototype.prepare__T__T = (function(raw) {
  var this$1 = $n($f_T__replaceAll__T__T__T($n($n($m_Lcom_iz2use_common_package$().Normalizer__Lcom_iz2use_common_PlatformSpecifics$Normalizer$()).normalize__T__Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form__T(raw, $n($n($m_Lcom_iz2use_common_package$().Normalizer__Lcom_iz2use_common_PlatformSpecifics$Normalizer$()).Form__Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$()).NFD__Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$())), "[\u0300-\u036f]", ""));
  return $as_T(this$1.toLowerCase())
});
$c_Lcom_iz2use_common_Filter$DefaultFilter.prototype.split__T__sci_Seq = (function(raw) {
  var prepared = this.prepare__T__T(raw);
  var acc = $n($m_s_package$().s_package$__f_Seq).newBuilder__scm_Builder();
  var last = 0;
  var i = 0;
  var this$1 = $n(prepared);
  var len = this$1.length;
  while ((i < len)) {
    var this$2 = $n(prepared);
    var index = i;
    var c = $charAt(this$2, index);
    var $$x1 = $m_sc_StringOps$();
    var x = this.Lcom_iz2use_common_Filter$DefaultFilter__f_separators;
    if ($n($$x1).contains$extension__T__C__Z(x, c)) {
      var this$4 = $n(prepared);
      var beginIndex = last;
      var endIndex = i;
      if ((beginIndex < 0)) {
        $charAt(this$4, beginIndex)
      };
      if ((endIndex > this$4.length)) {
        $charAt(this$4, endIndex)
      };
      if ((endIndex < beginIndex)) {
        $charAt(this$4, (-1))
      };
      var v = $as_T(this$4.substring(beginIndex, endIndex));
      $p_Lcom_iz2use_common_Filter$DefaultFilter__pushValue$1__T__I__I__scm_Builder__O(this, v, last, i, acc);
      last = ((1 + i) | 0)
    };
    i = ((1 + i) | 0)
  };
  if ((last !== i)) {
    var this$5 = $n(prepared);
    var beginIndex$1 = last;
    if ((beginIndex$1 < 0)) {
      $charAt(this$5, beginIndex$1)
    };
    if ((len > this$5.length)) {
      $charAt(this$5, len)
    };
    if ((len < beginIndex$1)) {
      $charAt(this$5, (-1))
    };
    $p_Lcom_iz2use_common_Filter$DefaultFilter__pushValue$1__T__I__I__scm_Builder__O(this, $as_T(this$5.substring(beginIndex$1, len)), last, len, acc)
  };
  return $as_sci_Seq($n(acc).result__O())
});
var $d_Lcom_iz2use_common_Filter$DefaultFilter = new $TypeData().initClass({
  Lcom_iz2use_common_Filter$DefaultFilter: 0
}, false, "com.iz2use.common.Filter$DefaultFilter", {
  Lcom_iz2use_common_Filter$DefaultFilter: 1,
  O: 1,
  Lcom_iz2use_common_Filter: 1
});
$c_Lcom_iz2use_common_Filter$DefaultFilter.prototype.$classData = $d_Lcom_iz2use_common_Filter$DefaultFilter;
function $f_Lcom_iz2use_common_ForeachQueryTokenMatcher__matches__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__Lcom_iz2use_common_internal_tokenizer_Tokenized__Lcom_iz2use_common_TokenMatches($thiz, search, item) {
  if ($n($n(search).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens).isEmpty__Z()) {
    return new $c_Lcom_iz2use_common_TokenMatches($m_s_package$().s_package$__f_Nil, item, 0.0)
  } else {
    var builder = $n($m_s_package$().s_package$__f_Seq).newBuilder__scm_Builder();
    $n($n(search).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens).length__I();
    $n($n(search).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens).foreach__F1__V(new $c_sjsr_AnonFunction1(((searchToken$2) => {
      var searchToken = $as_Lcom_iz2use_common_internal_tokenizer_Token(searchToken$2);
      $thiz.processQueryToken__Lcom_iz2use_common_internal_tokenizer_Token__Lcom_iz2use_common_internal_tokenizer_Tokenized__scm_Builder__V(searchToken, item, builder)
    })));
    var matches = $as_sci_Seq($n(builder).result__O());
    var r = $p_Lcom_iz2use_common_ForeachQueryTokenMatcher__loop$1__I__D__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__sci_Seq__D($thiz, 0, 1.0, search, matches);
    return new $c_Lcom_iz2use_common_TokenMatches(matches, item, r)
  }
}
function $p_Lcom_iz2use_common_ForeachQueryTokenMatcher__loop$1__I__D__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__sci_Seq__D($thiz, searchTokenIndex, acc, search$1, matches$1) {
  while (true) {
    if ((searchTokenIndex < $n($n(search$1).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens).length__I())) {
      var searchToken = $as_Lcom_iz2use_common_internal_tokenizer_Token($n($n(search$1).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens).apply__I__O(searchTokenIndex));
      var x1 = $n(matches$1).find__F1__s_Option(new $c_sjsr_AnonFunction1(((searchToken) => ((x$1$2) => {
        var x$1 = $as_Lcom_iz2use_common_TokenMatch(x$1$2);
        var x = $n(x$1).Lcom_iz2use_common_TokenMatch__f_searchToken;
        return ((x === null) ? (searchToken === null) : $n(x).equals__O__Z(searchToken))
      }))(searchToken)));
      var x$2 = $m_s_None$();
      if ((x$2 === x1)) {
        var temp$searchTokenIndex = ((1 + searchTokenIndex) | 0);
        var temp$acc = (0.5 * acc);
        searchTokenIndex = temp$searchTokenIndex;
        acc = temp$acc
      } else if ((x1 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x1);
        var matching = $as_Lcom_iz2use_common_TokenMatch($n(x3).s_Some__f_value);
        var temp$searchTokenIndex$2 = ((1 + searchTokenIndex) | 0);
        var $$x2 = acc;
        var a = $n($n(matching).Lcom_iz2use_common_TokenMatch__f_itemToken).Lcom_iz2use_common_internal_tokenizer_Token__f_start;
        var $$x1 = $uD(Math.min(a, 80.0));
        var a$1 = $n(matching).Lcom_iz2use_common_TokenMatch__f_index;
        var temp$acc$2 = (($$x2 * (1.0 - ($$x1 / 80.0))) * (1.0 - ($uD(Math.min(a$1, 4.0)) / 4.0)));
        searchTokenIndex = temp$searchTokenIndex$2;
        acc = temp$acc$2
      } else {
        throw new $c_s_MatchError(x1)
      }
    } else {
      return acc
    }
  }
}
/** @constructor */
function $c_Lcom_iz2use_common_Multiline$() {
  /*<skip>*/
}
$c_Lcom_iz2use_common_Multiline$.prototype = new $h_O();
$c_Lcom_iz2use_common_Multiline$.prototype.constructor = $c_Lcom_iz2use_common_Multiline$;
/** @constructor */
function $h_Lcom_iz2use_common_Multiline$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Multiline$.prototype = $c_Lcom_iz2use_common_Multiline$.prototype;
$c_Lcom_iz2use_common_Multiline$.prototype.encodeMultiline__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $n($as_Lcom_iz2use_common_Multiline(x$1$2)).Lcom_iz2use_common_Multiline__f_underlying;
    return x$1
  }));
  return new $c_Lio_circe_Encoder$$anon$1(this$3, f)
});
$c_Lcom_iz2use_common_Multiline$.prototype.decodeMultiline__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var instance = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_T(x$2$2);
    return new $c_Lcom_iz2use_common_Multiline(x$2)
  }));
  return new $c_Lio_circe_Decoder$$anon$1(this$3, f)
});
$c_Lcom_iz2use_common_Multiline$.prototype.productElement$extension__T__I__O = (function(this$, x$1) {
  return ((x$1 === 0) ? this$ : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_common_Multiline$.prototype.productIterator$extension__T__sc_Iterator = (function(this$) {
  var x = new $c_Lcom_iz2use_common_Multiline(this$);
  return new $c_sr_ScalaRunTime$$anon$1(x)
});
$c_Lcom_iz2use_common_Multiline$.prototype.equals$extension__T__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Lcom_iz2use_common_Multiline)) {
    var Multiline$1 = ((x$1 === null) ? null : $n($as_Lcom_iz2use_common_Multiline(x$1)).Lcom_iz2use_common_Multiline__f_underlying);
    return (this$ === Multiline$1)
  } else {
    return false
  }
});
$c_Lcom_iz2use_common_Multiline$.prototype.toString$extension__T__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lcom_iz2use_common_Multiline(this$))
});
var $d_Lcom_iz2use_common_Multiline$ = new $TypeData().initClass({
  Lcom_iz2use_common_Multiline$: 0
}, false, "com.iz2use.common.Multiline$", {
  Lcom_iz2use_common_Multiline$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Multiline$.prototype.$classData = $d_Lcom_iz2use_common_Multiline$;
var $n_Lcom_iz2use_common_Multiline$;
function $m_Lcom_iz2use_common_Multiline$() {
  if ((!$n_Lcom_iz2use_common_Multiline$)) {
    $n_Lcom_iz2use_common_Multiline$ = new $c_Lcom_iz2use_common_Multiline$()
  };
  return $n_Lcom_iz2use_common_Multiline$
}
/** @constructor */
function $c_Lcom_iz2use_common_Parsable$() {
  this.Lcom_iz2use_common_Parsable$__f_parsableString = null;
  this.Lcom_iz2use_common_Parsable$__f_parsableInt = null;
  this.Lcom_iz2use_common_Parsable$__f_parsableDouble = null;
  this.Lcom_iz2use_common_Parsable$__f_parsableBoolean = null;
  this.Lcom_iz2use_common_Parsable$__f_parsableMultiline = null;
  $n_Lcom_iz2use_common_Parsable$ = this;
  var parser = new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_T(in$2);
    return new $c_s_util_Success(in$1)
  }));
  var stringifier = new $c_sjsr_AnonFunction1(((value$2) => {
    var value = $as_T(value$2);
    return value
  }));
  this.Lcom_iz2use_common_Parsable$__f_parsableString = new $c_Lcom_iz2use_common_Parsable$$anon$2(parser, stringifier);
  var parser$1 = new $c_sjsr_AnonFunction1(((in$3$2) => {
    var in$3 = $as_T(in$3$2);
    try {
      $m_sc_StringOps$();
      var this$7 = $m_jl_Integer$();
      return new $c_s_util_Success(this$7.parseInt__T__I__I(in$3, 10))
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(o11).isEmpty__Z())) {
        var e$3 = $as_jl_Throwable($n(o11).get__O());
        return new $c_s_util_Failure(e$3)
      };
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
    }
  }));
  var stringifier$1 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $uI(x$4$2);
    return ("" + x$4)
  }));
  this.Lcom_iz2use_common_Parsable$__f_parsableInt = new $c_Lcom_iz2use_common_Parsable$$anon$2(parser$1, stringifier$1);
  var parser$2 = new $c_sjsr_AnonFunction1(((in$4$2) => {
    var in$4 = $as_T(in$4$2);
    try {
      var $$x1 = $m_Lfastparse_package$();
      var conv = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_T(s$2);
        return new $c_Lfastparse_IndexedParserInput(s)
      }));
      var x1 = $n($$x1).parse__Lfastparse_ParserInputSource__F1__Z__I__Lfastparse_internal_Instrument__Lfastparse_Parsed(new $c_Lfastparse_ParserInputSource$fromParserInput(in$4, conv), new $c_sjsr_AnonFunction1(((x$5$2) => {
        var x$5 = $as_Lfastparse_ParsingRun(x$5$2);
        return $m_Lcom_iz2use_common_MathParser$().expr__Lfastparse_ParsingRun__Lfastparse_ParsingRun(x$5)
      })), ($m_Lfastparse_package$(), false), ($m_Lfastparse_package$(), 0), ($m_Lfastparse_package$(), null));
      matchEnd7: {
        var $$x2;
        if ((x1 instanceof $c_Lfastparse_Parsed$Success)) {
          var x2 = $as_Lfastparse_Parsed$Success(x1);
          var v = $uD($n(x2).Lfastparse_Parsed$Success__f_value);
          var $$x2 = v;
          break matchEnd7
        };
        if ((x1 instanceof $c_Lfastparse_Parsed$Failure)) {
          var x4 = $as_Lfastparse_Parsed$Failure(x1);
          var o11$1 = $m_Lfastparse_Parsed$Failure$().unapply__Lfastparse_Parsed$Failure__s_Option(x4);
          if ((!$n(o11$1).isEmpty__Z())) {
            throw $ct_jl_Exception__T__(new $c_jl_Exception(), $n(x4).toString__T())
          }
        };
        throw new $c_s_MatchError(x1)
      };
      return new $c_s_util_Success($$x2)
    } catch (e$1) {
      var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      var o11$2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2$1);
      if ((!$n(o11$2).isEmpty__Z())) {
        var e$3$1 = $as_jl_Throwable($n(o11$2).get__O());
        return new $c_s_util_Failure(e$3$1)
      };
      throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : $n(e$2$1))
    }
  }));
  var stringifier$2 = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $uD(x$6$2);
    return ("" + x$6)
  }));
  this.Lcom_iz2use_common_Parsable$__f_parsableDouble = new $c_Lcom_iz2use_common_Parsable$$anon$2(parser$2, stringifier$2);
  var parser$3 = new $c_sjsr_AnonFunction1(((in$5$2) => {
    var in$5 = $as_T(in$5$2);
    var $$x3 = $m_sc_StringOps$();
    var this$13 = $n($f_T__trim__T($n(in$5)));
    var x = $as_T(this$13.toLowerCase());
    var this$15 = $n($n($$x3).headOption$extension__T__s_Option(x));
    if ((!this$15.isEmpty__Z())) {
      var arg1 = this$15.get__O();
      var x$7 = $uC(arg1);
      var $$x4 = $m_sc_StringOps$().contains$extension__T__C__Z("yot", x$7)
    } else {
      var $$x4 = false
    };
    return new $c_s_util_Success($$x4)
  }));
  var stringifier$3 = new $c_sjsr_AnonFunction1(((in$6$2) => {
    var in$6 = $uZ(in$6$2);
    return (in$6 ? "Oui" : "Non")
  }));
  this.Lcom_iz2use_common_Parsable$__f_parsableBoolean = new $c_Lcom_iz2use_common_Parsable$$anon$2(parser$3, stringifier$3);
  var parser$4 = new $c_sjsr_AnonFunction1(((in$7$2) => {
    var in$7 = $as_T(in$7$2);
    return new $c_s_util_Success(new $c_Lcom_iz2use_common_Multiline(in$7))
  }));
  var stringifier$4 = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $n($as_Lcom_iz2use_common_Multiline(x$8$2)).Lcom_iz2use_common_Multiline__f_underlying;
    return x$8
  }));
  this.Lcom_iz2use_common_Parsable$__f_parsableMultiline = new $c_Lcom_iz2use_common_Parsable$$anon$2(parser$4, stringifier$4)
}
$c_Lcom_iz2use_common_Parsable$.prototype = new $h_O();
$c_Lcom_iz2use_common_Parsable$.prototype.constructor = $c_Lcom_iz2use_common_Parsable$;
/** @constructor */
function $h_Lcom_iz2use_common_Parsable$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Parsable$.prototype = $c_Lcom_iz2use_common_Parsable$.prototype;
var $d_Lcom_iz2use_common_Parsable$ = new $TypeData().initClass({
  Lcom_iz2use_common_Parsable$: 0
}, false, "com.iz2use.common.Parsable$", {
  Lcom_iz2use_common_Parsable$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Parsable$.prototype.$classData = $d_Lcom_iz2use_common_Parsable$;
var $n_Lcom_iz2use_common_Parsable$;
function $m_Lcom_iz2use_common_Parsable$() {
  if ((!$n_Lcom_iz2use_common_Parsable$)) {
    $n_Lcom_iz2use_common_Parsable$ = new $c_Lcom_iz2use_common_Parsable$()
  };
  return $n_Lcom_iz2use_common_Parsable$
}
/** @constructor */
function $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1) {
  this.Lcom_iz2use_common_Resolver$$anon$1__f_parser$1 = null;
  this.Lcom_iz2use_common_Resolver$$anon$1__f_parser$1 = parser$1
}
$c_Lcom_iz2use_common_Resolver$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_common_Resolver$$anon$1.prototype.constructor = $c_Lcom_iz2use_common_Resolver$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_common_Resolver$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Resolver$$anon$1.prototype = $c_Lcom_iz2use_common_Resolver$$anon$1.prototype;
$c_Lcom_iz2use_common_Resolver$$anon$1.prototype.parse__T__s_concurrent_Future = (function(value) {
  return $m_s_concurrent_Future$().fromTry__s_util_Try__s_concurrent_Future($n(this.Lcom_iz2use_common_Resolver$$anon$1__f_parser$1).parse__T__s_util_Try(value))
});
$c_Lcom_iz2use_common_Resolver$$anon$1.prototype.stringify__O__s_concurrent_Future = (function(in$1) {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n(this.Lcom_iz2use_common_Resolver$$anon$1__f_parser$1).stringify__O__T(in$1))
});
var $d_Lcom_iz2use_common_Resolver$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_common_Resolver$$anon$1: 0
}, false, "com.iz2use.common.Resolver$$anon$1", {
  Lcom_iz2use_common_Resolver$$anon$1: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1
});
$c_Lcom_iz2use_common_Resolver$$anon$1.prototype.$classData = $d_Lcom_iz2use_common_Resolver$$anon$1;
function $is_Lcom_iz2use_common_Textualizable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_common_Textualizable)))
}
function $as_Lcom_iz2use_common_Textualizable(obj) {
  return (($is_Lcom_iz2use_common_Textualizable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.Textualizable"))
}
function $isArrayOf_Lcom_iz2use_common_Textualizable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_Textualizable)))
}
function $asArrayOf_Lcom_iz2use_common_Textualizable(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_Textualizable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.Textualizable;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_common_Textualizable$() {
  this.Lcom_iz2use_common_Textualizable$__f_fromLocalDate = null;
  $n_Lcom_iz2use_common_Textualizable$ = this;
  this.Lcom_iz2use_common_Textualizable$__f_fromLocalDate = new $c_Lcom_iz2use_common_Textualizable$$anon$4()
}
$c_Lcom_iz2use_common_Textualizable$.prototype = new $h_O();
$c_Lcom_iz2use_common_Textualizable$.prototype.constructor = $c_Lcom_iz2use_common_Textualizable$;
/** @constructor */
function $h_Lcom_iz2use_common_Textualizable$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Textualizable$.prototype = $c_Lcom_iz2use_common_Textualizable$.prototype;
var $d_Lcom_iz2use_common_Textualizable$ = new $TypeData().initClass({
  Lcom_iz2use_common_Textualizable$: 0
}, false, "com.iz2use.common.Textualizable$", {
  Lcom_iz2use_common_Textualizable$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Textualizable$.prototype.$classData = $d_Lcom_iz2use_common_Textualizable$;
var $n_Lcom_iz2use_common_Textualizable$;
function $m_Lcom_iz2use_common_Textualizable$() {
  if ((!$n_Lcom_iz2use_common_Textualizable$)) {
    $n_Lcom_iz2use_common_Textualizable$ = new $c_Lcom_iz2use_common_Textualizable$()
  };
  return $n_Lcom_iz2use_common_Textualizable$
}
function $p_Lcom_iz2use_common_TimeParser$__PossibleDays$lzycompute$1__V($thiz) {
  if (($m_Lcom_iz2use_common_TimeParser$().Lcom_iz2use_common_TimeParser$__f_PossibleDays$module === null)) {
    $m_Lcom_iz2use_common_TimeParser$().Lcom_iz2use_common_TimeParser$__f_PossibleDays$module = new $c_Lcom_iz2use_common_TimeParser$PossibleDays$($thiz)
  }
}
/** @constructor */
function $c_Lcom_iz2use_common_TimeParser$() {
  this.Lcom_iz2use_common_TimeParser$__f_ddmmyy = null;
  this.Lcom_iz2use_common_TimeParser$__f_dmy = null;
  this.Lcom_iz2use_common_TimeParser$__f_my = null;
  this.Lcom_iz2use_common_TimeParser$__f_d = null;
  this.Lcom_iz2use_common_TimeParser$__f_relative = null;
  this.Lcom_iz2use_common_TimeParser$__f_namedDayValues = null;
  this.Lcom_iz2use_common_TimeParser$__f_PossibleDays$module = null;
  $n_Lcom_iz2use_common_TimeParser$ = this;
  $f_Lcom_iz2use_common_TimeParser__$init$__V(this)
}
$c_Lcom_iz2use_common_TimeParser$.prototype = new $h_O();
$c_Lcom_iz2use_common_TimeParser$.prototype.constructor = $c_Lcom_iz2use_common_TimeParser$;
/** @constructor */
function $h_Lcom_iz2use_common_TimeParser$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TimeParser$.prototype = $c_Lcom_iz2use_common_TimeParser$.prototype;
$c_Lcom_iz2use_common_TimeParser$.prototype.PossibleDays__Lcom_iz2use_common_TimeParser$PossibleDays$ = (function() {
  if (($m_Lcom_iz2use_common_TimeParser$().Lcom_iz2use_common_TimeParser$__f_PossibleDays$module === null)) {
    $p_Lcom_iz2use_common_TimeParser$__PossibleDays$lzycompute$1__V(this)
  };
  return $m_Lcom_iz2use_common_TimeParser$().Lcom_iz2use_common_TimeParser$__f_PossibleDays$module
});
var $d_Lcom_iz2use_common_TimeParser$ = new $TypeData().initClass({
  Lcom_iz2use_common_TimeParser$: 0
}, false, "com.iz2use.common.TimeParser$", {
  Lcom_iz2use_common_TimeParser$: 1,
  O: 1,
  Lcom_iz2use_common_TimeParser: 1
});
$c_Lcom_iz2use_common_TimeParser$.prototype.$classData = $d_Lcom_iz2use_common_TimeParser$;
var $n_Lcom_iz2use_common_TimeParser$;
function $m_Lcom_iz2use_common_TimeParser$() {
  if ((!$n_Lcom_iz2use_common_TimeParser$)) {
    $n_Lcom_iz2use_common_TimeParser$ = new $c_Lcom_iz2use_common_TimeParser$()
  };
  return $n_Lcom_iz2use_common_TimeParser$
}
/** @constructor */
function $c_Lcom_iz2use_common_TokenMatches$() {
  /*<skip>*/
}
$c_Lcom_iz2use_common_TokenMatches$.prototype = new $h_O();
$c_Lcom_iz2use_common_TokenMatches$.prototype.constructor = $c_Lcom_iz2use_common_TokenMatches$;
/** @constructor */
function $h_Lcom_iz2use_common_TokenMatches$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TokenMatches$.prototype = $c_Lcom_iz2use_common_TokenMatches$.prototype;
$c_Lcom_iz2use_common_TokenMatches$.prototype.tokenMatchesOrdering__s_math_Ordering = (function() {
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_Lcom_iz2use_common_TokenMatches(in$2);
    return $n(in$1).Lcom_iz2use_common_TokenMatches__f_score
  }));
  var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var this$3 = new $c_s_math_Ordering$$anon$5(ord, f);
  return new $c_s_math_Ordering$Reverse(this$3)
});
var $d_Lcom_iz2use_common_TokenMatches$ = new $TypeData().initClass({
  Lcom_iz2use_common_TokenMatches$: 0
}, false, "com.iz2use.common.TokenMatches$", {
  Lcom_iz2use_common_TokenMatches$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_TokenMatches$.prototype.$classData = $d_Lcom_iz2use_common_TokenMatches$;
var $n_Lcom_iz2use_common_TokenMatches$;
function $m_Lcom_iz2use_common_TokenMatches$() {
  if ((!$n_Lcom_iz2use_common_TokenMatches$)) {
    $n_Lcom_iz2use_common_TokenMatches$ = new $c_Lcom_iz2use_common_TokenMatches$()
  };
  return $n_Lcom_iz2use_common_TokenMatches$
}
/** @constructor */
function $c_Lcom_iz2use_common_TypedRange$() {
  /*<skip>*/
}
$c_Lcom_iz2use_common_TypedRange$.prototype = new $h_O();
$c_Lcom_iz2use_common_TypedRange$.prototype.constructor = $c_Lcom_iz2use_common_TypedRange$;
/** @constructor */
function $h_Lcom_iz2use_common_TypedRange$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TypedRange$.prototype = $c_Lcom_iz2use_common_TypedRange$.prototype;
$c_Lcom_iz2use_common_TypedRange$.prototype.fromStart__O__F1__s_math_Ordering__Lcom_iz2use_common_TypedRange = (function(start, endFromStart, orderingT) {
  return new $c_Lcom_iz2use_common_TypedRange(start, $n(endFromStart).apply__O__O(start), orderingT)
});
var $d_Lcom_iz2use_common_TypedRange$ = new $TypeData().initClass({
  Lcom_iz2use_common_TypedRange$: 0
}, false, "com.iz2use.common.TypedRange$", {
  Lcom_iz2use_common_TypedRange$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_TypedRange$.prototype.$classData = $d_Lcom_iz2use_common_TypedRange$;
var $n_Lcom_iz2use_common_TypedRange$;
function $m_Lcom_iz2use_common_TypedRange$() {
  if ((!$n_Lcom_iz2use_common_TypedRange$)) {
    $n_Lcom_iz2use_common_TypedRange$ = new $c_Lcom_iz2use_common_TypedRange$()
  };
  return $n_Lcom_iz2use_common_TypedRange$
}
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1(underlying$1, f$1) {
  this.Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1__f_underlying$1 = null;
  this.Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1__f_f$1 = null;
  this.Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1__f_underlying$1 = underlying$1;
  this.Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1__f_f$1 = f$1
}
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1.prototype = $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1.prototype;
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1.prototype.tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_MappedTokenized = (function(in$1, filter) {
  return new $c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized($n(this.Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1__f_underlying$1).tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_Tokenized($n(this.Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1__f_f$1).apply__O__O(in$1), filter), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_F1(x0$1$2);
    var x1$1 = $as_Lcom_iz2use_common_internal_tokenizer_Tokenized(x1$1$2);
    return $n(x1$1).process__F1__Z(x0$1)
  })))
});
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1.prototype.tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_Tokenized = (function(in$1, filter) {
  return this.tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_MappedTokenized(in$1, filter)
});
var $d_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1: 0
}, false, "com.iz2use.common.internal.tokenizer.Tokenizer$$anon$1", {
  Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1: 1,
  O: 1,
  Lcom_iz2use_common_internal_tokenizer_Tokenizer: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$() {
  /*<skip>*/
}
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$.prototype = $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$.prototype;
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$.prototype.tokenize__T__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_SeqTokenized = (function(in$1, filter) {
  return new $c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(in$1, $n(filter).split__T__sci_Seq(in$1))
});
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$.prototype.tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_Tokenized = (function(in$1, filter) {
  return this.tokenize__T__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_SeqTokenized($as_T(in$1), filter)
});
var $d_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$ = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$: 0
}, false, "com.iz2use.common.internal.tokenizer.Tokenizer$tokenizeString$", {
  Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$: 1,
  O: 1,
  Lcom_iz2use_common_internal_tokenizer_Tokenizer: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$;
var $n_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$;
function $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$() {
  if ((!$n_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$)) {
    $n_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$ = new $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$()
  };
  return $n_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$
}
function $f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer($thiz, textualizable, ev) {
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => $n(textualizable).stringify__O__T(x$1$2)));
  return new $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1(ev, f)
}
/** @constructor */
function $c_Lcom_iz2use_react_components_ConcreteEditorComponent$() {
  this.Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent = null;
  this.Lcom_iz2use_react_components_ConcreteEditorComponent$__f_multilineComponent = null;
  $n_Lcom_iz2use_react_components_ConcreteEditorComponent$ = this;
  this.Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent = new $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent();
  this.Lcom_iz2use_react_components_ConcreteEditorComponent$__f_multilineComponent = new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent()
}
$c_Lcom_iz2use_react_components_ConcreteEditorComponent$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_ConcreteEditorComponent$.prototype.constructor = $c_Lcom_iz2use_react_components_ConcreteEditorComponent$;
/** @constructor */
function $h_Lcom_iz2use_react_components_ConcreteEditorComponent$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_ConcreteEditorComponent$.prototype = $c_Lcom_iz2use_react_components_ConcreteEditorComponent$.prototype;
var $d_Lcom_iz2use_react_components_ConcreteEditorComponent$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_ConcreteEditorComponent$: 0
}, false, "com.iz2use.react.components.ConcreteEditorComponent$", {
  Lcom_iz2use_react_components_ConcreteEditorComponent$: 1,
  O: 1,
  Lcom_iz2use_react_components_ConcreteEditorComponentLowPriorityImplicits: 1
});
$c_Lcom_iz2use_react_components_ConcreteEditorComponent$.prototype.$classData = $d_Lcom_iz2use_react_components_ConcreteEditorComponent$;
var $n_Lcom_iz2use_react_components_ConcreteEditorComponent$;
function $m_Lcom_iz2use_react_components_ConcreteEditorComponent$() {
  if ((!$n_Lcom_iz2use_react_components_ConcreteEditorComponent$)) {
    $n_Lcom_iz2use_react_components_ConcreteEditorComponent$ = new $c_Lcom_iz2use_react_components_ConcreteEditorComponent$()
  };
  return $n_Lcom_iz2use_react_components_ConcreteEditorComponent$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$1, resolver$1) {
  this.Lcom_iz2use_react_components_Editable$$anon$1__f_optioner$1 = null;
  this.Lcom_iz2use_react_components_Editable$$anon$1__f_resolver$1 = null;
  this.Lcom_iz2use_react_components_Editable$$anon$1__f_optioner$1 = optioner$1;
  this.Lcom_iz2use_react_components_Editable$$anon$1__f_resolver$1 = resolver$1
}
$c_Lcom_iz2use_react_components_Editable$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Editable$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_Editable$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_Editable$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Editable$$anon$1.prototype = $c_Lcom_iz2use_react_components_Editable$$anon$1.prototype;
$c_Lcom_iz2use_react_components_Editable$$anon$1.prototype.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod = (function(label, state) {
  var optioner = this.Lcom_iz2use_react_components_Editable$$anon$1__f_optioner$1;
  var ev = this.Lcom_iz2use_react_components_Editable$$anon$1__f_resolver$1;
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$1 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$1);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var this$3 = $m_Lcom_iz2use_react_components_ExplainError$();
  var explainError = new $c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1(this$3);
  var this$4 = $m_s_math_Equiv$();
  var equiv = this$4.universal__s_math_Equiv();
  return editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv)
});
var $d_Lcom_iz2use_react_components_Editable$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Editable$$anon$1: 0
}, false, "com.iz2use.react.components.Editable$$anon$1", {
  Lcom_iz2use_react_components_Editable$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_Editable: 1
});
$c_Lcom_iz2use_react_components_Editable$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_Editable$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_ExplainError$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_ExplainError$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_ExplainError$.prototype.constructor = $c_Lcom_iz2use_react_components_ExplainError$;
/** @constructor */
function $h_Lcom_iz2use_react_components_ExplainError$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_ExplainError$.prototype = $c_Lcom_iz2use_react_components_ExplainError$.prototype;
var $d_Lcom_iz2use_react_components_ExplainError$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_ExplainError$: 0
}, false, "com.iz2use.react.components.ExplainError$", {
  Lcom_iz2use_react_components_ExplainError$: 1,
  O: 1,
  Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits: 1
});
$c_Lcom_iz2use_react_components_ExplainError$.prototype.$classData = $d_Lcom_iz2use_react_components_ExplainError$;
var $n_Lcom_iz2use_react_components_ExplainError$;
function $m_Lcom_iz2use_react_components_ExplainError$() {
  if ((!$n_Lcom_iz2use_react_components_ExplainError$)) {
    $n_Lcom_iz2use_react_components_ExplainError$ = new $c_Lcom_iz2use_react_components_ExplainError$()
  };
  return $n_Lcom_iz2use_react_components_ExplainError$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_ExplainError$$anon$2() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_ExplainError$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_ExplainError$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_ExplainError$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_ExplainError$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_ExplainError$$anon$2.prototype = $c_Lcom_iz2use_react_components_ExplainError$$anon$2.prototype;
var $d_Lcom_iz2use_react_components_ExplainError$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_ExplainError$$anon$2: 0
}, false, "com.iz2use.react.components.ExplainError$$anon$2", {
  Lcom_iz2use_react_components_ExplainError$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_ExplainError: 1
});
$c_Lcom_iz2use_react_components_ExplainError$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_ExplainError$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1.prototype = $c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1.prototype;
var $d_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1: 0
}, false, "com.iz2use.react.components.ExplainErrorLowPriorityImplicits$$anon$1", {
  Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_ExplainError: 1
});
$c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1(reducer$1) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1__f_reducer$1 = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1__f_reducer$1 = reducer$1
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype.newCriterion__O__Ljapgolly_scalajs_react_callback_Trampoline = (function(criterion) {
  $m_Ljapgolly_scalajs_react_Reusable$();
  var r = $n(this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1__f_reducer$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion(criterion));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype.pending__O__Ljapgolly_scalajs_react_callback_Trampoline = (function(criterion) {
  $m_Ljapgolly_scalajs_react_Reusable$();
  var r = $n(this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1__f_reducer$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending(criterion));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype.failed__O__jl_Throwable__Ljapgolly_scalajs_react_callback_Trampoline = (function(criterion, throwable) {
  $m_Ljapgolly_scalajs_react_Reusable$();
  var r = $n(this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1__f_reducer$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed(criterion, throwable));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype.success__O__O__Ljapgolly_scalajs_react_callback_Trampoline = (function(criterion, data) {
  $m_Ljapgolly_scalajs_react_Reusable$();
  var r = $n(this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1__f_reducer$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lcom_iz2use_react_components_FetchCacheAndRender$Success(criterion, data));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype.update__O__Ljapgolly_scalajs_react_callback_Trampoline = (function(value) {
  $m_Ljapgolly_scalajs_react_Reusable$();
  var r = $n(this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1__f_reducer$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache(value));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$QueryDispatcher$$anon$1", {
  Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher$$anon$1;
function $p_Lcom_iz2use_react_components_FormContext$Simple__loop$1__sci_Set__Z($thiz, rest) {
  while (true) {
    if ($n(rest).isEmpty__Z()) {
      return true
    } else {
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(rest).head__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$2 = $n(this$);
      if ($uZ($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2))) {
        rest = $as_sci_Set($n(rest).tail__O())
      } else {
        return false
      }
    }
  }
}
/** @constructor */
function $c_Lcom_iz2use_react_components_FormContext$Simple() {
  this.Lcom_iz2use_react_components_FormContext$Simple__f_handlers = null;
  this.Lcom_iz2use_react_components_FormContext$Simple__f_handlers = ($n($m_s_Predef$().s_Predef$__f_Set), $m_sci_Set$EmptySet$())
}
$c_Lcom_iz2use_react_components_FormContext$Simple.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FormContext$Simple.prototype.constructor = $c_Lcom_iz2use_react_components_FormContext$Simple;
/** @constructor */
function $h_Lcom_iz2use_react_components_FormContext$Simple() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FormContext$Simple.prototype = $c_Lcom_iz2use_react_components_FormContext$Simple.prototype;
$c_Lcom_iz2use_react_components_FormContext$Simple.prototype.check__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
  var f = new $c_sjsr_AnonFunction0((() => $p_Lcom_iz2use_react_components_FormContext$Simple__loop$1__sci_Set__Z(this, this.Lcom_iz2use_react_components_FormContext$Simple__f_handlers)));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Lcom_iz2use_react_components_FormContext$Simple.prototype.registerOnSubmit__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(this.Lcom_iz2use_react_components_FormContext$Simple__f_handlers);
    var elem = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(f);
    this.Lcom_iz2use_react_components_FormContext$Simple__f_handlers = $as_sci_Set(this$2.incl__O__sci_SetOps(elem))
  }));
  var f$2 = new $c_sjsr_AnonFunction0((() => {
    f$1.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2)
});
$c_Lcom_iz2use_react_components_FormContext$Simple.prototype.unregisterOnSubmit__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(this.Lcom_iz2use_react_components_FormContext$Simple__f_handlers);
    var elem = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(f);
    this.Lcom_iz2use_react_components_FormContext$Simple__f_handlers = $as_sci_Set(this$2.excl__O__sci_SetOps(elem))
  }));
  var f$2 = new $c_sjsr_AnonFunction0((() => {
    f$1.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2)
});
var $d_Lcom_iz2use_react_components_FormContext$Simple = new $TypeData().initClass({
  Lcom_iz2use_react_components_FormContext$Simple: 0
}, false, "com.iz2use.react.components.FormContext$Simple", {
  Lcom_iz2use_react_components_FormContext$Simple: 1,
  O: 1,
  Lcom_iz2use_react_components_FormContext: 1
});
$c_Lcom_iz2use_react_components_FormContext$Simple.prototype.$classData = $d_Lcom_iz2use_react_components_FormContext$Simple;
function $f_Lcom_iz2use_react_components_Gesture$Left__direction__I($thiz) {
  return $uI($moduleDefault($i_hammerjs$002fhammer).DIRECTION_LEFT)
}
function $f_Lcom_iz2use_react_components_Gesture$Right__direction__I($thiz) {
  return $uI($moduleDefault($i_hammerjs$002fhammer).DIRECTION_RIGHT)
}
/** @constructor */
function $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1.prototype = $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1.prototype;
$c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1.prototype.renderContainer__T__Z__Lcom_iz2use_react_components_internal_TextEditorContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(text, open, context) {
  return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
});
var $d_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1: 0
}, false, "com.iz2use.react.components.LowestPriorityTextEditorHelperImplicits$$anon$1", {
  Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_Multiview$() {
  this.Lcom_iz2use_react_components_Multiview$__f_component = null;
  this.Lcom_iz2use_react_components_Multiview$__f_Format = null;
  $n_Lcom_iz2use_react_components_Multiview$ = this;
  $f_Lcom_iz2use_react_components_internal_multiview_MultiviewApi__$init$__V(this);
  var this$16 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("Multiview", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_Multiview$TypedProps(p$2);
    var this$2 = $n($n($as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view);
    if (this$2.isEmpty__Z()) {
      var startingView = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var expectedView = $as_T(arg1);
      var this$3 = $n($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_views).Lcom_iz2use_react_components_internal_multiview_HasViews__f_views);
      _return: {
        var these = this$3;
        while ((!$n(these).isEmpty__Z())) {
          var arg1$1 = $n(these).head__O();
          var x$17 = $as_Lcom_iz2use_react_components_internal_multiview_View(arg1$1);
          if (($n(x$17).name__T() === expectedView)) {
            var this$4 = new $c_s_Some($n(these).head__O());
            break _return
          };
          these = $as_sci_List($n(these).tail__O())
        };
        var this$4 = $m_s_None$()
      };
      if (this$4.isEmpty__Z()) {
        var startingView = $m_s_None$()
      } else {
        var arg1$2 = this$4.get__O();
        var foundView = $as_Lcom_iz2use_react_components_internal_multiview_View(arg1$2);
        var startingView = new $c_s_Some(foundView)
      }
    };
    var this$5 = $n(startingView);
    if (this$5.isEmpty__Z()) {
      var this$6 = $n($as_s_Option($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
      if (this$6.isEmpty__Z()) {
        var $$x3 = $m_s_None$()
      } else {
        var arg1$3 = this$6.get__O();
        $as_T(arg1$3);
        var this$7 = $n($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_views).Lcom_iz2use_react_components_internal_multiview_HasViews__f_views);
        _return$1: {
          var these$1 = this$7;
          while ((!$n(these$1).isEmpty__Z())) {
            var arg1$4 = $n(these$1).head__O();
            var x$18 = $as_Lcom_iz2use_react_components_internal_multiview_View(arg1$4);
            if ($is_Lcom_iz2use_react_components_internal_multiview_Slideshow(x$18)) {
              var this$8 = new $c_s_Some($n(these$1).head__O());
              break _return$1
            };
            these$1 = $as_sci_List($n(these$1).tail__O())
          };
          var this$8 = $m_s_None$()
        };
        if (this$8.isEmpty__Z()) {
          var $$x3 = $m_s_None$()
        } else {
          var arg1$5 = this$8.get__O();
          var foundView$1 = $as_Lcom_iz2use_react_components_internal_multiview_View(arg1$5);
          var $$x3 = new $c_s_Some(foundView$1)
        }
      }
    } else {
      var $$x3 = this$5
    };
    var this$9 = $n($$x3);
    var selectedView = $as_Lcom_iz2use_react_components_internal_multiview_View((this$9.isEmpty__Z() ? $as_Lcom_iz2use_react_components_internal_multiview_View($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_defaultView).apply__O__O($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_views).Lcom_iz2use_react_components_internal_multiview_HasViews__f_views)) : this$9.get__O()));
    var x$2 = $m_Ldiode_data_Empty$();
    return new $c_Lcom_iz2use_react_components_Multiview$TypedState(x$2, selectedView)
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2$1) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2$1);
    return new $c_Lcom_iz2use_react_components_Multiview$ZBackend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_Multiview$ZTypedBackend($n(x$3).backend__O()));
    var this$11 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_Multiview$TypedProps($n(this$11.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$12 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_Multiview$TypedProps__Lcom_iz2use_react_components_Multiview$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lcom_iz2use_react_components_Multiview$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$12)))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(c$2);
    var this$14 = $n($as_Lcom_iz2use_react_components_Multiview$ZTypedBackend($n(c).backend__O()));
    var this$13 = $n(c);
    var p$1 = $as_Lcom_iz2use_react_components_Multiview$TypedProps($n(this$13.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_sourceHandler).onMount__O__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline($n(p$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_source, this$14.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_sourceChange))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var this$21 = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$16, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillMount__Ljapgolly_scalajs_react_internal_Lens(), f, G));
  var f$1 = new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$3$2);
    var this$19 = $n($as_Lcom_iz2use_react_components_Multiview$ZTypedBackend($n(c$3).backend__O()));
    var this$17 = $n(c$3);
    var prev = $as_Lcom_iz2use_react_components_Multiview$TypedProps($n(this$17.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var next = $as_Lcom_iz2use_react_components_Multiview$TypedProps($n(c$3).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps);
    var this$18 = $n(c$3);
    $as_Lcom_iz2use_react_components_Multiview$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$18));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(next).Lcom_iz2use_react_components_Multiview$TypedProps__f_sourceHandler).onPropsChange__O__O__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline($n(prev).Lcom_iz2use_react_components_Multiview$TypedProps__f_source, $n(next).Lcom_iz2use_react_components_Multiview$TypedProps__f_source, this$19.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_sourceChange))
  }));
  var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lcom_iz2use_react_components_Multiview$__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$21, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f$1, G$1)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)));
  this.Lcom_iz2use_react_components_Multiview$__f_Format = $m_Lcom_iz2use_react_components_internal_multiview_Format$()
}
$c_Lcom_iz2use_react_components_Multiview$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Multiview$.prototype.constructor = $c_Lcom_iz2use_react_components_Multiview$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Multiview$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Multiview$.prototype = $c_Lcom_iz2use_react_components_Multiview$.prototype;
$c_Lcom_iz2use_react_components_Multiview$.prototype.noExternalState__O__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(source, active, sourceHandler, asMap, views, hasIterator, fieldsRenderer, keyMapper, filter, tokenMatcher, tokenizer, proposedSorts, proposedSearches, itemSimpleActions, updater, decorator, reusabilityT, reusabilityC, orderViews) {
  var $$x1 = $m_Lcom_iz2use_react_components_StateProvider$();
  var this$5 = $m_Ljapgolly_scalajs_react_Reusable$();
  var a = new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState($m_s_None$(), $m_s_package$().s_package$__f_Nil, $m_s_None$(), $m_s_package$().s_package$__f_Nil);
  return $n($$x1).apply__Ljapgolly_scalajs_react_Reusable__F1__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(this$5.const__O__Z__Ljapgolly_scalajs_react_Reusable(a, true), new $c_sjsr_AnonFunction1(((state$2) => {
    var state = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(state$2);
    return $m_Lcom_iz2use_react_components_Multiview$().apply__O__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_vdom_VdomNode(source, active, state, sourceHandler, asMap, views, hasIterator, fieldsRenderer, keyMapper, filter, tokenMatcher, tokenizer, proposedSorts, proposedSearches, itemSimpleActions, updater, decorator, reusabilityT, reusabilityC, orderViews)
  })), $m_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$().reuseMultiviewCurrentState__F2__F2(reusabilityT))
});
$c_Lcom_iz2use_react_components_Multiview$.prototype.noExternalStateNorActive__O__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(source, sourceHandler, asMap, views, hasIterator, fieldsRenderer, keyMapper, filter, tokenMatcher, tokenizer, proposedSorts, proposedSearches, itemSimpleActions, updater, decorator, reusabilityT, reusabilityC, orderViews) {
  var $$x3 = $m_Lcom_iz2use_react_components_StateProvider$();
  var this$1 = $m_Ljapgolly_scalajs_react_Reusable$();
  var a = $m_s_None$();
  var $$x2 = this$1.const__O__Z__Ljapgolly_scalajs_react_Reusable(a, true);
  var $$x1 = new $c_sjsr_AnonFunction1(((state$2) => {
    var state = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(state$2);
    var u = $m_Lcom_iz2use_react_components_Multiview$().noExternalState__O__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(source, state, sourceHandler, asMap, views, hasIterator, fieldsRenderer, keyMapper, filter, tokenMatcher, tokenizer, proposedSorts, proposedSearches, itemSimpleActions, updater, decorator, reusabilityT, reusabilityC, orderViews);
    var this$4 = $n(u);
    var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$6 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_reuseKey;
  return $n($$x3).apply__Ljapgolly_scalajs_react_Reusable__F1__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x2, $$x1, this$6.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3))
});
$c_Lcom_iz2use_react_components_Multiview$.prototype.apply__O__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_vdom_VdomNode = (function(source, active, state, sourceHandler, asMap, views, hasIterator, fieldsRenderer, keyMapper, filter, tokenMatcher, tokenizer, proposedSorts, proposedSearches, itemSimpleActions, updater, decorator, reusabilityT, reusabilityC, orderViews) {
  var this$4 = $n($n(fieldsRenderer).Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1__f_fields);
  var f = ((i$2) => {
    var i = $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(i$2);
    var self = $n(filter).prepare__T__T($n($n(i).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key).s_Symbol__f_name);
    return $ct_T2__O__O__(new $c_T2(), self, i)
  });
  if ((this$4 === $m_sci_Nil$())) {
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = this$4.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$4.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x1 = h
  };
  var this$7 = $n($$x1);
  var f$1 = new $c_sjsr_AnonFunction1(((i$3$2) => {
    var i$3 = $as_T2(i$3$2);
    var this$5 = $n($n($n($as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer($n(i$3)._2__O())).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_parser);
    return $ct_T2__O__O__(new $c_T2(), (!this$5.isEmpty__Z()), $n(i$3)._1__O())
  }));
  var ord1 = $m_s_math_Ordering$Boolean$();
  var ord2 = $m_s_math_Ordering$String$();
  var ord = new $c_s_math_Ordering$Tuple2Ordering(ord1, ord2);
  var fieldMap = $as_sci_Seq($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$7, f$1, ord));
  var this$8 = $n($n(decorator).Lcom_iz2use_common_MaybeImplicit__f_value);
  if (this$8.isEmpty__Z()) {
    var this$9 = $m_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$();
    var $$x2 = this$9.Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$__f_emptySingleton
  } else {
    var $$x2 = this$8.get__O()
  };
  var decoratorOpt = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator($$x2);
  var proposedSearchesOpt = $n(proposedSearches).Lcom_iz2use_common_MaybeImplicit__f_value;
  var proposedSortsOpt = $n(proposedSorts).Lcom_iz2use_common_MaybeImplicit__f_value;
  var isItemCollection = new $c_Lcom_iz2use_react_components_ConcreteIsItemCollection();
  var c = $m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_component;
  var this$12 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_Multiview$TypedProps(isItemCollection, source, views, new $c_sjsr_AnonFunction1(((x$20$2) => {
    var x$20 = $as_sci_Seq(x$20$2);
    return $as_Lcom_iz2use_react_components_internal_multiview_View($n(x$20).min__s_math_Ordering__O(orderViews))
  })), $n(updater).Lcom_iz2use_common_MaybeImplicit__f_value, filter, tokenMatcher, null, active, state, sourceHandler, hasIterator, keyMapper, asMap, fieldMap, tokenizer, decoratorOpt, proposedSortsOpt, proposedSearchesOpt, itemSimpleActions, reusabilityT, reusabilityC, orderViews);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$12.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$12.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$14 = $n(u);
  var n = this$14.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lcom_iz2use_react_components_Multiview$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Multiview$: 0
}, false, "com.iz2use.react.components.Multiview$", {
  Lcom_iz2use_react_components_Multiview$: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_MultiviewApi: 1
});
$c_Lcom_iz2use_react_components_Multiview$.prototype.$classData = $d_Lcom_iz2use_react_components_Multiview$;
var $n_Lcom_iz2use_react_components_Multiview$;
function $m_Lcom_iz2use_react_components_Multiview$() {
  if ((!$n_Lcom_iz2use_react_components_Multiview$)) {
    $n_Lcom_iz2use_react_components_Multiview$ = new $c_Lcom_iz2use_react_components_Multiview$()
  };
  return $n_Lcom_iz2use_react_components_Multiview$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1(outer) {
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_createNew = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_$outer = outer
  };
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_Multiview$TypedProps(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_updater))), new $c_sjsr_AnonFunction1(((updater$2) => {
      var updater = $as_Lcom_iz2use_react_components_internal_multiview_Updateable(updater$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(updater).createNew__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction1(((v$2) => {
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
        var this$2 = $n(updater);
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x1).flatMap$extension__F1__F1__F1(this$2.update__Lreactbuild_common_model_Project__F1($as_Lreactbuild_common_model_Project(v$2)), new $c_sjsr_AnonFunction1(((x$2$2) => {
          $as_jl_Void(x$2$2);
          var $$x8 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
          var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var $$x6 = $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_sourceHandler;
          var $$x5 = $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_source;
          var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var $$x3 = this.setActive__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(new $c_s_Some(v$2));
          $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var co = this.selectView__s_reflect_ClassTag__F0(new $c_s_reflect_ClassTag$GenericClassTag($d_Lcom_iz2use_react_components_internal_multiview_Slideshow.getClassOf()));
          var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var this$5 = $m_s_$less$colon$less$();
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x8).map$extension__F1__F1__F1($n($$x7).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($$x6).append__O__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline($$x5, v$2, $n($$x4).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x3, $n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$5.s_$less$colon$less$__f_singleton)), $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_hasIterator, $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_keyMapper)), new $c_sjsr_AnonFunction1(((x$1$2) => {
            $as_jl_Void(x$1$2)
          }))))
        }))))
      }))))
    })), null))
  })));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var this$$1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(this$);
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_createNew = $as_s_Option($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$$1))
}
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1.prototype = $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1.prototype;
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1.prototype.modSort__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$1 = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lcom_iz2use_react_components_Multiview$TypedProps(x$5$2);
    var this$2 = $n($n(x$5).Lcom_iz2use_react_components_Multiview$TypedProps__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var s = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(arg1);
    var x$1 = $as_sci_List($n(f).apply__O__O($n(s).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders));
    var this$6 = $n(s);
    var x$2 = this$6.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view;
    var this$7 = $n(s);
    var x$3 = this$7.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected;
    var this$8 = $n(s);
    var x$4 = this$8.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query;
    $n(s);
    var arg1$1 = new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(x$2, x$3, x$4, x$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$1)
});
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1.prototype.active__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_Multiview$TypedProps(p$2);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lcom_iz2use_react_components_Multiview$TypedState(s$2);
      var this$2 = $n($as_s_Option($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
      if (this$2.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1 = this$2.get__O();
        var key = $as_T(arg1);
        var this$3 = $n($n(s).Lcom_iz2use_react_components_Multiview$TypedState__f_content);
        var this$4 = $n(((!this$3.isEmpty__Z()) ? new $c_s_Some(this$3.get__O()) : $m_s_None$()));
        if (this$4.isEmpty__Z()) {
          return $m_s_None$()
        } else {
          var arg1$1 = this$4.get__O();
          var this$5 = $n($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_hasIterator).find__O__F1__s_Option(arg1$1, new $c_sjsr_AnonFunction1(((v$2) => {
            var v = $as_T2(v$2);
            var x = $n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_keyMapper).apply__O__O($n(v)._1__O());
            return ((x === null) ? (key === null) : $dp_equals__O__Z($n(x), key))
          }))));
          if (this$5.isEmpty__Z()) {
            return $m_s_None$()
          } else {
            var arg1$2 = this$5.get__O();
            var item = $as_T2(arg1$2);
            return new $c_s_Some($m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$().apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_updateFn, $n(item)._1__O(), $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_reusabilityT))
          }
        }
      }
    }));
    var this$7 = $n(this$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$7, f))
  })))
});
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1.prototype.setActive__s_Option__Ljapgolly_scalajs_react_callback_Trampoline = (function(newActive) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$1 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_Multiview$TypedProps(p$2);
    var this$2 = $n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_active);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    $as_s_Option(arg1);
    var this$6 = $n(newActive);
    var f = $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_keyMapper;
    var arg1$1 = (this$6.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$6.get__O())));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$1)
});
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1.prototype.selectView__s_reflect_ClassTag__F0 = (function(ev) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_Multiview$TypedProps(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
      var cls = $n(ev).runtimeClass__jl_Class();
      var this$2 = $n($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_views).Lcom_iz2use_react_components_internal_multiview_HasViews__f_views);
      var these = this$2;
      while ((!$n(these).isEmpty__Z())) {
        var arg1 = $n(these).head__O();
        if ($n(cls).isInstance__O__Z(arg1)) {
          return new $c_s_Some($n(these).head__O())
        };
        these = $as_sci_List($n(these).tail__O())
      };
      return $m_s_None$()
    }))), new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_Lcom_iz2use_react_components_internal_multiview_View(v$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$5 = $n($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$7$2) => {
        var x$7 = $as_Lcom_iz2use_react_components_Multiview$TypedState(x$7$2);
        var this$3 = $n(x$7);
        var x$2 = this$3.Lcom_iz2use_react_components_Multiview$TypedState__f_content;
        $n(x$7);
        return new $c_Lcom_iz2use_react_components_Multiview$TypedState(x$2, v)
      }));
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$5, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
        $as_jl_Void(x$8$2)
      }));
      var this$7 = $n(this$);
      var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$7, f);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    }))))
  })))
});
var $d_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1: 0
}, false, "com.iz2use.react.components.Multiview$ZTypedBackend$$anon$1", {
  Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_MultiviewContext: 1
});
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2(outer, hasIterator$1) {
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2__f_$outer = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2__f_hasIterator$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2__f_$outer = outer
  };
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2__f_hasIterator$1 = hasIterator$1
}
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2.prototype = $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2.prototype;
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2.prototype.apply__Lcom_iz2use_react_components_internal_multiview_MultiviewState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p) {
  var _context = $n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2__f_$outer).Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_context;
  return $n($n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_view).render__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_vdom_VdomElement($n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source, this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2__f_hasIterator$1, $n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_keyMapper, _context, $n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_itemSimpleActions, $n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_decorator)
});
var $d_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2: 0
}, false, "com.iz2use.react.components.Multiview$ZTypedBackend$$anon$2", {
  Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_NextRefinerRenderer: 1
});
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3(outer) {
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3.prototype.constructor = $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3.prototype = $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3.prototype;
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3.prototype.pure__Ldiode_data_Pot__Ljapgolly_scalajs_react_callback_Trampoline = (function(source) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3__f_$outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_Multiview$TypedProps(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3__f_$outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lcom_iz2use_react_components_Multiview$TypedState(s$2);
      $n(s);
      var content = $n($n(s).Lcom_iz2use_react_components_Multiview$TypedState__f_content).pending__J__Ldiode_data_Pot($n($n(s).Lcom_iz2use_react_components_Multiview$TypedState__f_content).pending$default$1__J());
      var this$2 = $n(s);
      var view = this$2.Lcom_iz2use_react_components_Multiview$TypedState__f_view;
      return new $c_Lcom_iz2use_react_components_Multiview$TypedState(content, view)
    })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => $n($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => $n(source).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((coll$2) => {
      var coll = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(coll$2);
      window.performance.mark("Multiview.pure/mapping.start");
      var r = $n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_hasIterator).map__O__F1__O($n(coll).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, new $c_sjsr_AnonFunction1(((i$2) => {
        var y = $n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_asMap).apply__O__sci_Map(i$2);
        return $ct_T2__O__O__(new $c_T2(), i$2, y)
      })));
      window.performance.mark("Multiview.pure/mapping.end");
      window.performance.measure("Multiview.pure/mapping", "Multiview.pure/mapping.start", "Multiview.pure/mapping.end");
      return r
    }))))), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((r$2) => {
      var r$1 = $as_Ldiode_data_Pot(r$2);
      var this$10 = $n($n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3__f_$outer).Lcom_iz2use_react_components_Multiview$ZBackend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2$1) => {
        var s$1 = $as_Lcom_iz2use_react_components_Multiview$TypedState(s$2$1);
        $n(s$1);
        var this$8 = $n(s$1);
        var view$1 = this$8.Lcom_iz2use_react_components_Multiview$TypedState__f_view;
        return new $c_Lcom_iz2use_react_components_Multiview$TypedState(r$1, view$1)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$10, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    })), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor()))), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
var $d_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3: 0
}, false, "com.iz2use.react.components.Multiview$ZTypedBackend$$anon$3", {
  Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_SourceChange: 1
});
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3.prototype.$classData = $d_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3;
/** @constructor */
function $c_Lcom_iz2use_react_components_NotEditable() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_NotEditable.prototype = new $h_O();
$c_Lcom_iz2use_react_components_NotEditable.prototype.constructor = $c_Lcom_iz2use_react_components_NotEditable;
/** @constructor */
function $h_Lcom_iz2use_react_components_NotEditable() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_NotEditable.prototype = $c_Lcom_iz2use_react_components_NotEditable.prototype;
$c_Lcom_iz2use_react_components_NotEditable.prototype.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod = (function(label, state) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("not editable"))];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Lcom_iz2use_react_components_NotEditable = new $TypeData().initClass({
  Lcom_iz2use_react_components_NotEditable: 0
}, false, "com.iz2use.react.components.NotEditable", {
  Lcom_iz2use_react_components_NotEditable: 1,
  O: 1,
  Lcom_iz2use_react_components_Editable: 1
});
$c_Lcom_iz2use_react_components_NotEditable.prototype.$classData = $d_Lcom_iz2use_react_components_NotEditable;
function $p_Lcom_iz2use_react_components_Selector$$anon$1__dropEffect__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    ev.dataTransfer.dropEffect = "move"
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
}
function $p_Lcom_iz2use_react_components_Selector$$anon$1__noneEffect__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    ev.dataTransfer.dropEffect = "none"
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
}
function $p_Lcom_iz2use_react_components_Selector$$anon$1__log$1__T__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline($thiz, msg, ev) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
  var f = new $c_sjsr_AnonFunction0((() => ((((((((msg + " dropEffect=") + $as_T(ev.dataTransfer.dropEffect)) + " types=") + ev.dataTransfer.types) + " getData(tpe)=") + $as_T(ev.dataTransfer.getData($thiz.Lcom_iz2use_react_components_Selector$$anon$1__f_tpe))) + " defaultPrevented=") + $uZ(ev.defaultPrevented))));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var this$ = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
  var f$1 = new $c_sjsr_AnonFunction1(((msg$2$2) => {
    var msg$2 = $as_T(msg$2$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).warn__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline(msg$2, $m_sci_Nil$()))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$1)
}
function $p_Lcom_iz2use_react_components_Selector$$anon$1__data$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__T__Lcom_iz2use_react_components_Selector$TypedProps__F0($thiz, ev, key$3, p$2) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption);
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($m_s_Option$().apply__O__s_Option($as_T(ev.dataTransfer.getData($thiz.Lcom_iz2use_react_components_Selector$$anon$1__f_tpe))));
    if (this$2.isEmpty__Z()) {
      var $$x1 = true
    } else {
      var arg1 = this$2.get__O();
      var x$4 = $as_T(arg1);
      $m_sc_StringOps$();
      var this$5 = $n(x$4);
      var $$x1 = (!(this$5 === ""))
    };
    var this$9 = $n(($$x1 ? this$2 : $m_s_None$()));
    var p = new $c_sjsr_AnonFunction1(((data$2) => {
      var data = $as_T(data$2);
      $m_sc_StringOps$();
      var this$8 = $n(data);
      return (!(this$8 === ""))
    }));
    var this$17 = $n(new $c_s_Option$WithFilter(this$9, p).withFilter__F1__s_Option$WithFilter(new $c_sjsr_AnonFunction1(((data$3$2) => {
      var data$3 = $as_T(data$3$2);
      $m_sc_StringOps$();
      $m_sc_StringOps$();
      $m_sc_StringOps$();
      var from = 0;
      _return: {
        var this$13 = $n(data$3);
        var len = this$13.length;
        var i = from;
        while ((i < len)) {
          var this$14 = $n(data$3);
          var index = i;
          var arg1$1 = $charAt(this$14, index);
          var this$15 = $m_Lcom_iz2use_common_package$();
          var x$2 = new $c_Lcom_iz2use_common_KeyImports$RichKey(this$15, key$3).Lcom_iz2use_common_KeyImports$RichKey__f_key;
          if ((x$2 instanceof $Char)) {
            var this$16 = $uC($n($as_jl_Character(x$2)));
            var $$x3 = (arg1$1 === this$16)
          } else {
            var $$x3 = false
          };
          if ($$x3) {
            var $$x2 = i;
            break _return
          };
          i = ((1 + i) | 0)
        };
        var $$x2 = (-1)
      };
      return (!($$x2 !== (-1)))
    }))));
    var this$18 = $n(this$17.s_Option$WithFilter__f_$outer);
    var p$1 = this$17.s_Option$WithFilter__f_p;
    var this$19 = $n(((this$18.isEmpty__Z() || $uZ($n(p$1).apply__O__O(this$18.get__O()))) ? this$18 : $m_s_None$()));
    if (this$19.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$2 = this$19.get__O();
      var data$4 = $as_T(arg1$2);
      var this$21 = $n($n($n(p$2).Lcom_iz2use_react_components_Selector$TypedProps__f_items).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$6$2) => {
        var this$20 = $m_Lcom_iz2use_common_package$();
        var key = $as_T($n($n(p$2).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(x$6$2));
        return (new $c_Lcom_iz2use_common_KeyImports$RichKey(this$20, key).Lcom_iz2use_common_KeyImports$RichKey__f_key === data$4)
      }))));
      if (this$21.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1$3 = this$21.get__O();
        return new $c_s_Some(arg1$3)
      }
    }
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var callback = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$25 = $m_s_$less$colon$less$();
  return $n($$x4).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0(callback, this$25.s_$less$colon$less$__f_singleton)
}
function $p_Lcom_iz2use_react_components_Selector$$anon$1__onDragStart$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__T__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev, key$3) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    var $$x2 = ev.dataTransfer;
    var $$x1 = $thiz.Lcom_iz2use_react_components_Selector$$anon$1__f_tpe;
    var this$2 = $m_Lcom_iz2use_common_package$();
    $$x2.setData($$x1, new $c_Lcom_iz2use_common_KeyImports$RichKey(this$2, key$3).Lcom_iz2use_common_KeyImports$RichKey__f_key)
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
}
function $p_Lcom_iz2use_react_components_Selector$$anon$1__onDragEnter$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__T__Lcom_iz2use_react_components_Selector$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev, key$3, p$2) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$();
  $m_Ljapgolly_scalajs_react_package$();
  var self = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().void$extension__F0__F0($p_Lcom_iz2use_react_components_Selector$$anon$1__data$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__T__Lcom_iz2use_react_components_Selector$TypedProps__F0($thiz, ev, key$3, p$2));
  var this$ = $n($$x1).asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0(self, ev);
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var c = $p_Lcom_iz2use_react_components_Selector$$anon$1__noneEffect__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev);
  var tryNext = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c);
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().orElse$extension__F0__F0__F0(this$, tryNext);
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$5 = $m_s_$less$colon$less$();
  return $n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$5.s_$less$colon$less$__f_singleton)
}
function $p_Lcom_iz2use_react_components_Selector$$anon$1__onDragOver$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev) {
  var $$x1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
  $m_Ljapgolly_scalajs_react_package$();
  var self = $p_Lcom_iz2use_react_components_Selector$$anon$1__dropEffect__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev);
  var this$ = $n($$x1).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev);
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
}
function $p_Lcom_iz2use_react_components_Selector$$anon$1__move$1__sci_List__Lcom_iz2use_common_KeyMapper__O__T__F0($thiz, items, keyMapper, source, key$3) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption);
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
  var f = new $c_sjsr_AnonFunction0((() => {
    var sourceKey = $as_T($n(keyMapper).apply__O__O(source));
    var this$2 = $m_Lcom_iz2use_common_package$();
    var $$x3 = new $c_Lcom_iz2use_common_TraversableImplicits$RichCollection(this$2, items);
    var $$x2 = new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x = $n(keyMapper).apply__O__O(x$7$2);
      return ((x === null) ? (sourceKey === null) : $dp_equals__O__Z($n(x), sourceKey))
    }));
    var $$x1 = new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$1 = $n(keyMapper).apply__O__O(x$8$2);
      return ((x$1 === null) ? (key$3 === null) : $dp_equals__O__Z($n(x$1), key$3))
    }));
    var this$3 = $m_sci_List$();
    var updatedItems = $as_sci_List($$x3.moveWhere__F1__F1__sc_Factory__sci_Seq($$x2, $$x1, new $c_sc_IterableFactory$ToFactory(this$3)));
    return ((updatedItems === items) ? $m_s_None$() : new $c_s_Some(updatedItems))
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var callback = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$8 = $m_s_$less$colon$less$();
  return $n($$x4).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0(callback, this$8.s_$less$colon$less$__f_singleton)
}
function $p_Lcom_iz2use_react_components_Selector$$anon$1__onDrop$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Lcom_iz2use_react_components_Selector$TypedProps__T__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev, p$2, key$3) {
  var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x5 = $p_Lcom_iz2use_react_components_Selector$$anon$1__log$1__T__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline($thiz, "drop>", ev);
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x3 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$();
  $m_Ljapgolly_scalajs_react_package$();
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$ = $p_Lcom_iz2use_react_components_Selector$$anon$1__data$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__T__Lcom_iz2use_react_components_Selector$TypedProps__F0($thiz, ev, key$3, p$2);
  var f = new $c_sjsr_AnonFunction1(((source$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption($p_Lcom_iz2use_react_components_Selector$$anon$1__move$1__sci_List__Lcom_iz2use_common_KeyMapper__O__T__F0($thiz, $as_sci_List($n($n(p$2).Lcom_iz2use_react_components_Selector$TypedProps__f_active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $n(p$2).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper, source$2, key$3))));
  var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, f);
  var f$1 = new $c_sjsr_AnonFunction1(((items$2) => {
    var items = $as_sci_List(items$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$3 = $n($n(p$2).Lcom_iz2use_react_components_Selector$TypedProps__f_active);
    var c = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$3, items))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$$1, f$1);
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var c$1 = $p_Lcom_iz2use_react_components_Selector$$anon$1__log$1__T__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline($thiz, "drop!", ev);
  var self = $n($$x2).$greater$greater$extension__F0__F0__F0($$x1, $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1));
  var co = $n($$x3).asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0(self, ev);
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$9 = $m_s_$less$colon$less$();
  return $n($$x7).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($$x6).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x5, $n($$x4).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$9.s_$less$colon$less$__f_singleton)), $p_Lcom_iz2use_react_components_Selector$$anon$1__log$1__T__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline($thiz, "drop<", ev))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$$anon$1() {
  this.Lcom_iz2use_react_components_Selector$$anon$1__f_tpe = null;
  this.Lcom_iz2use_react_components_Selector$$anon$1__f_tpe = "text/plain"
}
$c_Lcom_iz2use_react_components_Selector$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$$anon$1.prototype = $c_Lcom_iz2use_react_components_Selector$$anon$1.prototype;
$c_Lcom_iz2use_react_components_Selector$$anon$1.prototype.containerClass__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagMod = (function(style) {
  var this$1 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(style).Lcom_iz2use_react_style_Style__f_reorderableSelector;
  return $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$1, s)
});
$c_Lcom_iz2use_react_components_Selector$$anon$1.prototype.handleKeys__Lcom_iz2use_react_components_Selector$TypedProps__s_Option__F1__F0__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s, modState, reset, e) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x2 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$();
  $m_Ljapgolly_scalajs_react_package$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption);
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
  var f = new $c_sjsr_AnonFunction0((() => s));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var callback = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$5 = $m_s_$less$colon$less$();
  var this$ = $n($$x1).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0(callback, this$5.s_$less$colon$less$__f_singleton);
  var f$1 = new $c_sjsr_AnonFunction1(((key$2) => {
    var key = $as_T(key$2);
    $m_Ljapgolly_scalajs_react_package$();
    $m_Ljapgolly_scalajs_react_package$();
    var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
    var x$6 = new $c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1(this, key, p);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption(qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e, $uI(e.keyCode), false, false, false, false, x$6))
  }));
  var self$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, f$1);
  var co = $n($$x2).asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0(self$1, e);
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$10 = $m_s_$less$colon$less$();
  return $n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$10.s_$less$colon$less$__f_singleton)
});
$c_Lcom_iz2use_react_components_Selector$$anon$1.prototype.wrapItem__Lcom_iz2use_react_components_Selector$TypedProps__F1__F0__T__O__Ljapgolly_scalajs_react_vdom_TagOf__Ljapgolly_scalajs_react_vdom_TagMod = (function(p, modState, reset, key, item, element) {
  var $$x6 = $n(element);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$3 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "draggable");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$3.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, true);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDragStart");
  var $$x4 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lcom_iz2use_react_components_Selector$$anon$1__onDragStart$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__T__Ljapgolly_scalajs_react_callback_Trampoline(this, ev$2, key)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$2 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDragEnter");
  var $$x3 = stabilizer$2.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$3$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lcom_iz2use_react_components_Selector$$anon$1__onDragEnter$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__T__Lcom_iz2use_react_components_Selector$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline(this, ev$3$2, key, p)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$3 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDragOver");
  var $$x2 = stabilizer$3.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$4$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lcom_iz2use_react_components_Selector$$anon$1__onDragOver$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline(this, ev$4$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$4 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDrop");
  var $$x1 = stabilizer$4.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$5$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lcom_iz2use_react_components_Selector$$anon$1__onDrop$1__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Lcom_iz2use_react_components_Selector$TypedProps__T__Ljapgolly_scalajs_react_callback_Trampoline(this, ev$5$2, p, key)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$15 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var array = [$$x5, $$x4, $$x3, $$x2, $$x1, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$15.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onFocus")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(modState).apply__O__O(new $c_sjsr_AnonFunction1(((x$9$2) => {
    $as_s_Option(x$9$2);
    return new $c_s_Some(key)
  }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onBlur")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(reset, $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  return $n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_Selector$$anon$1.prototype.wrapList__sci_Seq__sci_Seq = (function(items) {
  return ($n(items).isEmpty__Z() ? $f_Lcom_iz2use_react_components_Selector__wrapList__sci_Seq__sci_Seq(this, $m_s_package$().s_package$__f_Nil) : $as_sci_Seq($n(items).flatMap__F1__O(new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_Ljapgolly_scalajs_react_vdom_TagMod(in$2);
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" > "))];
    var array$1 = [$n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), in$1];
    return $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  })))))
});
$c_Lcom_iz2use_react_components_Selector$$anon$1.prototype.isActive__Lcom_iz2use_react_components_Selector$TypedProps__T__O__Z = (function(p, key, out) {
  $as_sci_List(out);
  return true
});
$c_Lcom_iz2use_react_components_Selector$$anon$1.prototype.com$iz2use$react$components$Selector$$nestedInanon$1$$moveItem$1__T__I__Lcom_iz2use_react_components_Selector$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(key, count, p$1) {
  var this$2 = $n($n(p$1).Lcom_iz2use_react_components_Selector$TypedProps__f_items);
  var p = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x = $n($n(p$1).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(x$1$2);
    return ((x === null) ? (key === null) : $dp_equals__O__Z($n(x), key))
  }));
  var idx = this$2.indexWhere__F1__I__I(p, 0);
  var this$6 = $n($n(p$1).Lcom_iz2use_react_components_Selector$TypedProps__f_active);
  var this$3 = $m_Lcom_iz2use_common_package$();
  var in$1 = $n(p$1).Lcom_iz2use_react_components_Selector$TypedProps__f_items;
  var $$x1 = new $c_Lcom_iz2use_common_TraversableImplicits$RichCollection(this$3, in$1);
  var this$4 = $m_sci_Seq$();
  var newState = $n($$x1.moveOffset__I__I__sc_Factory__sci_Seq(idx, count, new $c_sc_IterableFactory$ToFactory(this$4))).toList__sci_List();
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$6, newState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
var $d_Lcom_iz2use_react_components_Selector$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$$anon$1: 0
}, false, "com.iz2use.react.components.Selector$$anon$1", {
  Lcom_iz2use_react_components_Selector$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_Selector: 1
});
$c_Lcom_iz2use_react_components_Selector$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$$anon$1;
function $p_Lcom_iz2use_react_components_Selector$$anon$2__onClick$1__Ljapgolly_scalajs_react_facade_SyntheticEvent__Lcom_iz2use_react_components_Selector$TypedProps__O__Ljapgolly_scalajs_react_callback_Trampoline($thiz, ev, p$3, item$1) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$1 = $n($n(p$3).Lcom_iz2use_react_components_Selector$TypedProps__f_active);
  var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$1, item$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  $m_Ljapgolly_scalajs_react_package$();
  var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return $n($$x2).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev, this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$$anon$2() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Selector$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$$anon$2.prototype = $c_Lcom_iz2use_react_components_Selector$$anon$2.prototype;
$c_Lcom_iz2use_react_components_Selector$$anon$2.prototype.containerClass__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagMod = (function(style) {
  var this$1 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(style).Lcom_iz2use_react_style_Style__f_selector;
  return $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$1, s)
});
$c_Lcom_iz2use_react_components_Selector$$anon$2.prototype.wrapList__sci_Seq__sci_Seq = (function(items) {
  return $f_Lcom_iz2use_react_components_Selector__wrapList__sci_Seq__sci_Seq(this, items)
});
$c_Lcom_iz2use_react_components_Selector$$anon$2.prototype.wrapItem__Lcom_iz2use_react_components_Selector$TypedProps__F1__F0__T__O__Ljapgolly_scalajs_react_vdom_TagOf__Ljapgolly_scalajs_react_vdom_TagMod = (function(p, modState, reset, key, item, element) {
  var $$x1 = $n(element);
  var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($p_Lcom_iz2use_react_components_Selector$$anon$2__onClick$1__Ljapgolly_scalajs_react_facade_SyntheticEvent__Lcom_iz2use_react_components_Selector$TypedProps__O__Ljapgolly_scalajs_react_callback_Trampoline(this, ev$2, p, item)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_Selector$$anon$2.prototype.isActive__Lcom_iz2use_react_components_Selector$TypedProps__T__O__Z = (function(p, key, out) {
  return (key === $n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(out))
});
$c_Lcom_iz2use_react_components_Selector$$anon$2.prototype.handleKeys__Lcom_iz2use_react_components_Selector$TypedProps__s_Option__F1__F0__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s, modState, reset, e) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$();
  $m_Ljapgolly_scalajs_react_package$();
  $m_Ljapgolly_scalajs_react_package$();
  $m_Ljapgolly_scalajs_react_package$();
  var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
  var x$6 = new $c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2(this, p, s, reset, modState);
  var self$1 = qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e, $uI(e.keyCode), false, false, false, false, x$6);
  var co = $n($$x1).asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0(self$1, e);
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$4 = $m_s_$less$colon$less$();
  return $n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$4.s_$less$colon$less$__f_singleton)
});
var $d_Lcom_iz2use_react_components_Selector$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$$anon$2: 0
}, false, "com.iz2use.react.components.Selector$$anon$2", {
  Lcom_iz2use_react_components_Selector$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_Selector: 1
});
$c_Lcom_iz2use_react_components_Selector$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$Focusable$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Selector$Focusable$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$Focusable$.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$Focusable$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$Focusable$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$Focusable$.prototype = $c_Lcom_iz2use_react_components_Selector$Focusable$.prototype;
var $d_Lcom_iz2use_react_components_Selector$Focusable$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$Focusable$: 0
}, false, "com.iz2use.react.components.Selector$Focusable$", {
  Lcom_iz2use_react_components_Selector$Focusable$: 1,
  O: 1,
  Lcom_iz2use_react_components_Selector$LowPriorityFocusable: 1
});
$c_Lcom_iz2use_react_components_Selector$Focusable$.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$Focusable$;
var $n_Lcom_iz2use_react_components_Selector$Focusable$;
function $m_Lcom_iz2use_react_components_Selector$Focusable$() {
  if ((!$n_Lcom_iz2use_react_components_Selector$Focusable$)) {
    $n_Lcom_iz2use_react_components_Selector$Focusable$ = new $c_Lcom_iz2use_react_components_Selector$Focusable$()
  };
  return $n_Lcom_iz2use_react_components_Selector$Focusable$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3(outer) {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3.prototype = $c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3.prototype;
var $d_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3: 0
}, false, "com.iz2use.react.components.Selector$LowPriorityFocusable$$anon$3", {
  Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_Selector$Focusable: 1
});
$c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3;
/** @constructor */
function $c_Lcom_iz2use_react_components_StateProvider$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_StateProvider$TypedBackend__f_stateUpdater = null;
  this.Lcom_iz2use_react_components_StateProvider$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_StateProvider$Backend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_StateProvider$TypedBackend__(this)
}
$c_Lcom_iz2use_react_components_StateProvider$Backend.prototype = new $h_Lcom_iz2use_react_components_StateProvider$TypedBackend();
$c_Lcom_iz2use_react_components_StateProvider$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_StateProvider$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_StateProvider$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_StateProvider$Backend.prototype = $c_Lcom_iz2use_react_components_StateProvider$Backend.prototype;
var $d_Lcom_iz2use_react_components_StateProvider$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_StateProvider$Backend: 0
}, false, "com.iz2use.react.components.StateProvider$Backend", {
  Lcom_iz2use_react_components_StateProvider$Backend: 1,
  Lcom_iz2use_react_components_StateProvider$TypedBackend: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_StateProvider$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_StateProvider$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$1) {
  this.Lcom_iz2use_react_components_Viewable$$anon$1__f_textualizable$1 = null;
  this.Lcom_iz2use_react_components_Viewable$$anon$1__f_textualizable$1 = textualizable$1
}
$c_Lcom_iz2use_react_components_Viewable$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Viewable$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_Viewable$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_Viewable$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Viewable$$anon$1.prototype = $c_Lcom_iz2use_react_components_Viewable$$anon$1.prototype;
$c_Lcom_iz2use_react_components_Viewable$$anon$1.prototype.apply__O__Ljapgolly_scalajs_react_vdom_VdomNode = (function(value) {
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = $n(this.Lcom_iz2use_react_components_Viewable$$anon$1__f_textualizable$1).stringify__O__T(value);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
});
$c_Lcom_iz2use_react_components_Viewable$$anon$1.prototype.apply__O__Ljapgolly_scalajs_react_vdom_TagMod = (function(value) {
  return this.apply__O__Ljapgolly_scalajs_react_vdom_VdomNode(value)
});
var $d_Lcom_iz2use_react_components_Viewable$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Viewable$$anon$1: 0
}, false, "com.iz2use.react.components.Viewable$$anon$1", {
  Lcom_iz2use_react_components_Viewable$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_Viewable: 1
});
$c_Lcom_iz2use_react_components_Viewable$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_Viewable$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_Viewable$$anon$2(viewable$1, f$1) {
  this.Lcom_iz2use_react_components_Viewable$$anon$2__f_viewable$1 = null;
  this.Lcom_iz2use_react_components_Viewable$$anon$2__f_f$1 = null;
  this.Lcom_iz2use_react_components_Viewable$$anon$2__f_viewable$1 = viewable$1;
  this.Lcom_iz2use_react_components_Viewable$$anon$2__f_f$1 = f$1
}
$c_Lcom_iz2use_react_components_Viewable$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Viewable$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_Viewable$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_Viewable$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Viewable$$anon$2.prototype = $c_Lcom_iz2use_react_components_Viewable$$anon$2.prototype;
$c_Lcom_iz2use_react_components_Viewable$$anon$2.prototype.apply__O__Ljapgolly_scalajs_react_vdom_TagMod = (function(value) {
  return $n(this.Lcom_iz2use_react_components_Viewable$$anon$2__f_viewable$1).apply__O__Ljapgolly_scalajs_react_vdom_TagMod($n(this.Lcom_iz2use_react_components_Viewable$$anon$2__f_f$1).apply__O__O(value))
});
var $d_Lcom_iz2use_react_components_Viewable$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Viewable$$anon$2: 0
}, false, "com.iz2use.react.components.Viewable$$anon$2", {
  Lcom_iz2use_react_components_Viewable$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_Viewable: 1
});
$c_Lcom_iz2use_react_components_Viewable$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_Viewable$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_Default$$anon$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_Default$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_Default$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_Default$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_Default$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_Default$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_Default$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_Default$$anon$1.prototype.empty__O = (function() {
  return $m_s_None$()
});
var $d_Lcom_iz2use_react_components_internal_Default$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_Default$$anon$1: 0
}, false, "com.iz2use.react.components.internal.Default$$anon$1", {
  Lcom_iz2use_react_components_internal_Default$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_Default: 1
});
$c_Lcom_iz2use_react_components_internal_Default$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_Default$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_Default$BooleanDefault$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_Default$BooleanDefault$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_Default$BooleanDefault$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_Default$BooleanDefault$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_Default$BooleanDefault$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_Default$BooleanDefault$.prototype = $c_Lcom_iz2use_react_components_internal_Default$BooleanDefault$.prototype;
$c_Lcom_iz2use_react_components_internal_Default$BooleanDefault$.prototype.empty__O = (function() {
  return false
});
var $d_Lcom_iz2use_react_components_internal_Default$BooleanDefault$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_Default$BooleanDefault$: 0
}, false, "com.iz2use.react.components.internal.Default$BooleanDefault$", {
  Lcom_iz2use_react_components_internal_Default$BooleanDefault$: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_Default: 1
});
$c_Lcom_iz2use_react_components_internal_Default$BooleanDefault$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_Default$BooleanDefault$;
var $n_Lcom_iz2use_react_components_internal_Default$BooleanDefault$;
function $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$() {
  if ((!$n_Lcom_iz2use_react_components_internal_Default$BooleanDefault$)) {
    $n_Lcom_iz2use_react_components_internal_Default$BooleanDefault$ = new $c_Lcom_iz2use_react_components_internal_Default$BooleanDefault$()
  };
  return $n_Lcom_iz2use_react_components_internal_Default$BooleanDefault$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_Default$StringDefault$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_Default$StringDefault$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_Default$StringDefault$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_Default$StringDefault$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_Default$StringDefault$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_Default$StringDefault$.prototype = $c_Lcom_iz2use_react_components_internal_Default$StringDefault$.prototype;
$c_Lcom_iz2use_react_components_internal_Default$StringDefault$.prototype.empty__O = (function() {
  return ""
});
var $d_Lcom_iz2use_react_components_internal_Default$StringDefault$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_Default$StringDefault$: 0
}, false, "com.iz2use.react.components.internal.Default$StringDefault$", {
  Lcom_iz2use_react_components_internal_Default$StringDefault$: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_Default: 1
});
$c_Lcom_iz2use_react_components_internal_Default$StringDefault$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_Default$StringDefault$;
var $n_Lcom_iz2use_react_components_internal_Default$StringDefault$;
function $m_Lcom_iz2use_react_components_internal_Default$StringDefault$() {
  if ((!$n_Lcom_iz2use_react_components_internal_Default$StringDefault$)) {
    $n_Lcom_iz2use_react_components_internal_Default$StringDefault$ = new $c_Lcom_iz2use_react_components_internal_Default$StringDefault$()
  };
  return $n_Lcom_iz2use_react_components_internal_Default$StringDefault$
}
function $p_Lcom_iz2use_react_components_internal_Highlighter$$anon$1__loop$1__sci_Seq__sci_Seq__sci_Seq($thiz, in$1, result) {
  while (true) {
    var x1 = in$1;
    if ((x1 !== null)) {
      var o7 = $n($m_s_package$().s_package$__f_$plus$colon).unapply__sc_SeqOps__s_Option(x1);
      if ((!$n(o7).isEmpty__Z())) {
        var head = $as_Lcom_iz2use_common_TokenMatch($n($as_T2($n(o7).get__O()))._1__O());
        var tail = $as_sci_Seq($n($as_T2($n(o7).get__O()))._2__O());
        var i = (($n($n(head).Lcom_iz2use_common_TokenMatch__f_itemToken).Lcom_iz2use_common_internal_tokenizer_Token__f_start + $n(head).Lcom_iz2use_common_TokenMatch__f_index) | 0);
        var end = ((((i + $n($n(head).Lcom_iz2use_common_TokenMatch__f_searchToken).Lcom_iz2use_common_internal_tokenizer_Token__f_end) | 0) - $n($n(head).Lcom_iz2use_common_TokenMatch__f_searchToken).Lcom_iz2use_common_internal_tokenizer_Token__f_start) | 0);
        var this$2 = $n(result);
        var p = new $c_sjsr_AnonFunction1(((i) => ((x$1$2) => {
          var x$1 = $as_T2(x$1$2);
          return ($n(x$1)._1$mcI$sp__I() < i)
        }))(i));
        var from = ((1 + this$2.lastIndexWhere__F1__I__I(p, 2147483647)) | 0);
        var this$3 = $n(result);
        var p$1 = new $c_sjsr_AnonFunction1(((end) => ((x$2$2) => {
          var x$2 = $as_T2(x$2$2);
          return ($n(x$2)._1$mcI$sp__I() < end)
        }))(end));
        var to = ((1 + this$3.lastIndexWhere__F1__I__I(p$1, 2147483647)) | 0);
        var replacement = $as_sci_Seq($n(result).slice__I__I__O(from, to));
        var lastBefore = ($n(result).isDefinedAt__I__Z((((-1) + from) | 0)) ? $as_sci_Seq($n($as_T2($n(result).apply__I__O((((-1) + from) | 0))))._2__O()) : $m_s_package$().s_package$__f_Nil);
        var this$4 = $n($n(replacement).headOption__s_Option());
        if ((!this$4.isEmpty__Z())) {
          var arg1 = this$4.get__O();
          var x$3 = $as_T2(arg1);
          var $$x1 = ($n(x$3)._1$mcI$sp__I() === i)
        } else {
          var $$x1 = false
        };
        if ((!$$x1)) {
          var rassoc$1 = $ct_T2__O__O__(new $c_T2(), i, lastBefore);
          var this$7 = $n(replacement);
          var withStart = $as_sci_Seq(this$7.prepended__O__O(rassoc$1))
        } else {
          var withStart = replacement
        };
        var updated = $as_sci_Seq($n(withStart).map__F1__O(new $c_sjsr_AnonFunction1(((head) => ((x0$1$2) => {
          var x0$1 = $as_T2(x0$1$2);
          if ((x0$1 !== null)) {
            var idx = $n(x0$1)._1$mcI$sp__I();
            var tokens = $as_sci_Seq($n(x0$1)._2__O());
            var this$8 = $n(tokens);
            var elem = $n(head).Lcom_iz2use_common_TokenMatch__f_searchToken;
            return $ct_T2__O__O__(new $c_T2(), idx, this$8.appended__O__O(elem))
          } else {
            throw new $c_s_MatchError(x0$1)
          }
        }))(head))));
        if (($n(result).isDefinedAt__I__Z(to) && ($n($as_T2($n(result).apply__I__O(to)))._1$mcI$sp__I() === end))) {
          var headAfter = $as_sci_Seq($n($as_T2($n(result).apply__I__O(to)))._2__O())
        } else {
          matchEnd5: {
            var headAfter;
            if ((replacement !== null)) {
              var o8 = $n($m_s_package$().s_package$__f_$colon$plus).unapply__sc_SeqOps__s_Option(replacement);
              if ((!$n(o8).isEmpty__Z())) {
                var last = $as_T2($n($as_T2($n(o8).get__O()))._2__O());
                var headAfter = $as_sci_Seq($n(last)._2__O());
                break matchEnd5
              }
            };
            var headAfter = $m_s_package$().s_package$__f_Nil
          }
        };
        if (((!$n(result).isDefinedAt__I__Z(to)) || ($n($as_T2($n(result).apply__I__O(to)))._1$mcI$sp__I() !== end))) {
          var this$11 = $n(updated);
          var elem$1 = $ct_T2__O__O__(new $c_T2(), end, headAfter);
          var withEnd = $as_sci_Seq(this$11.appended__O__O(elem$1))
        } else {
          var withEnd = updated
        };
        var newResult = $as_sci_Seq($n(result).patch__I__sc_IterableOnce__I__O(from, withEnd, $n(replacement).length__I()));
        in$1 = tail;
        result = newResult;
        continue
      }
    };
    return result
  }
}
function $p_Lcom_iz2use_react_components_internal_Highlighter$$anon$1__wrap$1__T__sci_Seq__I__sci_Seq__sci_Seq__sci_Seq($thiz, text, parts, lastIndex, lastToken, result) {
  while (true) {
    var x1 = parts;
    if ((x1 !== null)) {
      var o8 = $n($m_s_package$().s_package$__f_$plus$colon).unapply__sc_SeqOps__s_Option(x1);
      if ((!$n(o8).isEmpty__Z())) {
        var p3 = $as_T2($n($as_T2($n(o8).get__O()))._1__O());
        var tail = $as_sci_Seq($n($as_T2($n(o8).get__O()))._2__O());
        if ((p3 !== null)) {
          var nextIndex = $n(p3)._1$mcI$sp__I();
          var nextToken = $as_sci_Seq($n(p3)._2__O());
          var this$1 = $n(text);
          var beginIndex = lastIndex;
          if ((beginIndex < 0)) {
            $charAt(this$1, beginIndex)
          };
          if ((nextIndex > this$1.length)) {
            $charAt(this$1, nextIndex)
          };
          if ((nextIndex < beginIndex)) {
            $charAt(this$1, (-1))
          };
          var content = $as_T(this$1.substring(beginIndex, nextIndex));
          if ($n(lastToken).isEmpty__Z()) {
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            var wrapped = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(content)
          } else {
            var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(content)), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontWeight__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("bolder", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "boxShadow")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((("0px " + ((1 + ($n(lastToken).length__I() << 1)) | 0)) + "px 1px -1px orange"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
            var wrapped = $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
          };
          var this$13 = $n(result);
          var temp$result = $as_sci_Seq(this$13.appended__O__O(wrapped));
          parts = tail;
          lastIndex = nextIndex;
          lastToken = nextToken;
          result = temp$result;
          continue
        }
      }
    };
    var this$18 = $n(result);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$15 = $n(text);
    var beginIndex$1 = lastIndex;
    var this$14 = $n(text);
    var endIndex = this$14.length;
    if ((beginIndex$1 < 0)) {
      $charAt(this$15, beginIndex$1)
    };
    if ((endIndex > this$15.length)) {
      $charAt(this$15, endIndex)
    };
    if ((endIndex < beginIndex$1)) {
      $charAt(this$15, (-1))
    };
    var v = $as_T(this$15.substring(beginIndex$1, endIndex));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var elem = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
    return $as_sci_Seq(this$18.appended__O__O(elem))
  }
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_Highlighter$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_Highlighter$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1.prototype.highlight__sci_Seq__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__sci_Seq = (function(matches, tokenized) {
  var $$x2 = $as_sci_Seq($n(matches).filter__F1__O(new $c_sjsr_AnonFunction1(((t$2) => {
    var t = $as_Lcom_iz2use_common_TokenMatch(t$2);
    return $n($n(tokenized).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens).contains__O__Z($n(t).Lcom_iz2use_common_TokenMatch__f_itemToken)
  }))));
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var y = $m_s_package$().s_package$__f_Nil;
  var array = [$ct_T2__O__O__(new $c_T2(), 0, y)];
  var r = $p_Lcom_iz2use_react_components_internal_Highlighter$$anon$1__loop$1__sci_Seq__sci_Seq__sci_Seq(this, $$x2, $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))));
  var res = $p_Lcom_iz2use_react_components_internal_Highlighter$$anon$1__wrap$1__T__sci_Seq__I__sci_Seq__sci_Seq__sci_Seq(this, $as_T($n(tokenized).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_source), r, 0, $m_s_package$().s_package$__f_Nil, $m_s_package$().s_package$__f_Nil);
  return res
});
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1.prototype.highlight__sci_Seq__Lcom_iz2use_common_internal_tokenizer_Tokenized__O = (function(matches, tokenized) {
  return this.highlight__sci_Seq__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__sci_Seq(matches, $as_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(tokenized))
});
var $d_Lcom_iz2use_react_components_internal_Highlighter$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_Highlighter$$anon$1: 0
}, false, "com.iz2use.react.components.internal.Highlighter$$anon$1", {
  Lcom_iz2use_react_components_internal_Highlighter$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_Highlighter: 1
});
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_Highlighter$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3(h$1) {
  this.Lcom_iz2use_react_components_internal_Highlighter$$anon$3__f_h$1 = null;
  this.Lcom_iz2use_react_components_internal_Highlighter$$anon$3__f_h$1 = h$1
}
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3.prototype.constructor = $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_Highlighter$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_Highlighter$$anon$3.prototype = $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3.prototype;
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3.prototype.highlight__sci_Seq__Lcom_iz2use_common_internal_tokenizer_MappedTokenized__O = (function(matches, tokenized) {
  return $n(this.Lcom_iz2use_react_components_internal_Highlighter$$anon$3__f_h$1).highlight__sci_Seq__Lcom_iz2use_common_internal_tokenizer_Tokenized__O(matches, $as_Lcom_iz2use_common_internal_tokenizer_Tokenized($n(tokenized).Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_result))
});
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3.prototype.highlight__sci_Seq__Lcom_iz2use_common_internal_tokenizer_Tokenized__O = (function(matches, tokenized) {
  return this.highlight__sci_Seq__Lcom_iz2use_common_internal_tokenizer_MappedTokenized__O(matches, $as_Lcom_iz2use_common_internal_tokenizer_MappedTokenized(tokenized))
});
var $d_Lcom_iz2use_react_components_internal_Highlighter$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_Highlighter$$anon$3: 0
}, false, "com.iz2use.react.components.internal.Highlighter$$anon$3", {
  Lcom_iz2use_react_components_internal_Highlighter$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_Highlighter: 1
});
$c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3.prototype.$classData = $d_Lcom_iz2use_react_components_internal_Highlighter$$anon$3;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_OptionOptioner() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_OptionOptioner.prototype = new $h_Lcom_iz2use_react_components_internal_Optioner();
$c_Lcom_iz2use_react_components_internal_OptionOptioner.prototype.constructor = $c_Lcom_iz2use_react_components_internal_OptionOptioner;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_OptionOptioner() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_OptionOptioner.prototype = $c_Lcom_iz2use_react_components_internal_OptionOptioner.prototype;
$c_Lcom_iz2use_react_components_internal_OptionOptioner.prototype.transformOption__O__F1__O = (function(value, f) {
  var value$1 = $as_s_Option(value);
  return $n(f).apply__O__O(value$1)
});
$c_Lcom_iz2use_react_components_internal_OptionOptioner.prototype.some__O__O = (function(value) {
  return new $c_s_Some(value)
});
$c_Lcom_iz2use_react_components_internal_OptionOptioner.prototype.none__O = (function() {
  return $m_s_None$()
});
var $d_Lcom_iz2use_react_components_internal_OptionOptioner = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_OptionOptioner: 0
}, false, "com.iz2use.react.components.internal.OptionOptioner", {
  Lcom_iz2use_react_components_internal_OptionOptioner: 1,
  Lcom_iz2use_react_components_internal_Optioner: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_OptionOptioner.prototype.$classData = $d_Lcom_iz2use_react_components_internal_OptionOptioner;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault) {
  this.Lcom_iz2use_react_components_internal_SomeOptioner__f_evDefault = null;
  this.Lcom_iz2use_react_components_internal_SomeOptioner__f_evDefault = evDefault
}
$c_Lcom_iz2use_react_components_internal_SomeOptioner.prototype = new $h_Lcom_iz2use_react_components_internal_Optioner();
$c_Lcom_iz2use_react_components_internal_SomeOptioner.prototype.constructor = $c_Lcom_iz2use_react_components_internal_SomeOptioner;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_SomeOptioner() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_SomeOptioner.prototype = $c_Lcom_iz2use_react_components_internal_SomeOptioner.prototype;
$c_Lcom_iz2use_react_components_internal_SomeOptioner.prototype.none__O = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_SomeOptioner__f_evDefault).empty__O()
});
$c_Lcom_iz2use_react_components_internal_SomeOptioner.prototype.some__O__O = (function(value) {
  return value
});
$c_Lcom_iz2use_react_components_internal_SomeOptioner.prototype.transformOption__O__F1__O = (function(value, f) {
  return $n(f).apply__O__O(new $c_s_Some(value))
});
var $d_Lcom_iz2use_react_components_internal_SomeOptioner = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_SomeOptioner: 0
}, false, "com.iz2use.react.components.internal.SomeOptioner", {
  Lcom_iz2use_react_components_internal_SomeOptioner: 1,
  Lcom_iz2use_react_components_internal_Optioner: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_SomeOptioner.prototype.$classData = $d_Lcom_iz2use_react_components_internal_SomeOptioner;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent.prototype = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent.prototype;
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent.prototype.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement = (function(label, state, optioner, ev, explainError, equiv) {
  var c = $m_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$().Lcom_iz2use_react_components_internal_editor_CheckboxComponent$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps(label, state, explainError, equiv, optioner);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent.prototype.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement = (function(key, label, state, optioner, ev, explainError, equiv) {
  var c = $m_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$().Lcom_iz2use_react_components_internal_editor_CheckboxComponent$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps(label, state, explainError, equiv, optioner);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$8 = $n(u);
  var n = this$8.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent: 0
}, false, "com.iz2use.react.components.internal.editor.CheckboxComponent", {
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent: 1,
  O: 1,
  Lcom_iz2use_react_components_ConcreteEditorComponent: 1
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_MultilineComponent() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_MultilineComponent.prototype = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent.prototype;
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent.prototype.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement = (function(label, state, optioner, ev, explainError, equiv) {
  var c = $m_Lcom_iz2use_react_components_internal_editor_MultilineComponent$().Lcom_iz2use_react_components_internal_editor_MultilineComponent$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps(label, state, ev, explainError, equiv, optioner);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_MultilineComponent: 0
}, false, "com.iz2use.react.components.internal.editor.MultilineComponent", {
  Lcom_iz2use_react_components_internal_editor_MultilineComponent: 1,
  O: 1,
  Lcom_iz2use_react_components_ConcreteEditorComponent: 1
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper) {
  this.Lcom_iz2use_react_components_internal_editor_TextComponent__f_helper = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent__f_helper = helper
}
$c_Lcom_iz2use_react_components_internal_editor_TextComponent.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_TextComponent.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_TextComponent;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_TextComponent() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_TextComponent.prototype = $c_Lcom_iz2use_react_components_internal_editor_TextComponent.prototype;
$c_Lcom_iz2use_react_components_internal_editor_TextComponent.prototype.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement = (function(label, state, optioner, ev, explainError, equiv) {
  var this$7 = $n($m_Lcom_iz2use_react_components_FormContext$().Lcom_iz2use_react_components_FormContext$__f_context);
  var f = new $c_sjsr_AnonFunction1(((formContext$2) => {
    var formContext = $as_Lcom_iz2use_react_components_FormContext(formContext$2);
    var c = $m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_component;
    var this$3 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    var props = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(formContext, label, state, ev, explainError, this.Lcom_iz2use_react_components_internal_editor_TextComponent__f_helper, equiv, optioner);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$3.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$3.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, f)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent.prototype.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement = (function(key, label, state, optioner, ev, explainError, equiv) {
  var this$11 = $n($m_Lcom_iz2use_react_components_FormContext$().Lcom_iz2use_react_components_FormContext$__f_context);
  var f = new $c_sjsr_AnonFunction1(((formContext$2) => {
    var formContext = $as_Lcom_iz2use_react_components_FormContext(formContext$2);
    var c = $m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_component;
    var this$7 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
    var props = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(formContext, label, state, ev, explainError, this.Lcom_iz2use_react_components_internal_editor_TextComponent__f_helper, equiv, optioner);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$7.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$7.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
    var this$9 = $n(u);
    var n = this$9.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  return $f_Ljapgolly_scalajs_react_feature_Context__consume__F1__Ljapgolly_scalajs_react_vdom_VdomElement(this$11, f)
});
var $d_Lcom_iz2use_react_components_internal_editor_TextComponent = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_TextComponent: 0
}, false, "com.iz2use.react.components.internal.editor.TextComponent", {
  Lcom_iz2use_react_components_internal_editor_TextComponent: 1,
  O: 1,
  Lcom_iz2use_react_components_ConcreteEditorComponent: 1
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_TextComponent;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingFieldsRenderer$", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$;
var $n_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$;
function $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$ = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3.prototype.fields__sci_List = (function() {
  return $m_s_package$().s_package$__f_Nil
});
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingFieldsRenderer$$anon$3", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$1, witness$1, tail$2) {
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_fieldRenderable$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_witness$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_tail$2 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_fieldRenderable$1 = fieldRenderable$1;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_witness$1 = witness$1;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_tail$2 = tail$2
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4.prototype.fields__sci_List = (function() {
  var this$1 = $n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_fieldRenderable$1);
  var title = $n($as_s_Symbol($n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_witness$1).value__O())).s_Symbol__f_name;
  var key = $as_s_Symbol($n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_witness$1).value__O());
  var rassoc$1 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(title, key, this$1);
  var this$2 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4__f_tail$2).fields__sci_List());
  return new $c_sci_$colon$colon(rassoc$1, this$2)
});
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingFieldsRenderer$$anon$4", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(outer, tail$1) {
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2__f_tail$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2__f_tail$1 = tail$1
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2.prototype.fields__sci_List = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2__f_tail$1).fields__sci_List()
});
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingFieldsRendererLowPriorityImplicits$$anon$2", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4.prototype.fields__sci_List = (function() {
  return $m_s_package$().s_package$__f_Nil
});
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingListRenderer$$anon$4", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(outer, tail$1) {
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2__f_tail$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2__f_tail$1 = tail$1
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2.prototype.fields__sci_List = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2__f_tail$1).fields__sci_List()
});
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingListRendererLowPriorityImplicits$$anon$2", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(outer, fieldRenderable$1, witness$1, tail$2) {
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_fieldRenderable$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_witness$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_tail$2 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_fieldRenderable$1 = fieldRenderable$1;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_witness$1 = witness$1;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_tail$2 = tail$2
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3.prototype.fields__sci_List = (function() {
  var this$1 = $n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_fieldRenderable$1);
  var title = $n($as_s_Symbol($n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_witness$1).value__O())).s_Symbol__f_name;
  var key = $as_s_Symbol($n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_witness$1).value__O());
  var rassoc$1 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(title, key, this$1);
  var this$2 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3__f_tail$2).fields__sci_List());
  return new $c_sci_$colon$colon(rassoc$1, this$2)
});
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingListRendererMidPriorityImplicits$$anon$3", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8.prototype.columns__sci_List = (function() {
  return $m_s_package$().s_package$__f_Nil
});
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingTableRenderer$$anon$8", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(outer, tail$1) {
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6__f_tail$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6__f_tail$1 = tail$1
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6.prototype.columns__sci_List = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6__f_tail$1).columns__sci_List()
});
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingTableRendererLowPriorityImplicits$$anon$6", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(outer, columnRenderable$1, witness$1, tail$2) {
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_columnRenderable$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_witness$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_tail$2 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_columnRenderable$1 = columnRenderable$1;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_witness$1 = witness$1;
  this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_tail$2 = tail$2
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7.prototype.columns__sci_List = (function() {
  var this$2 = $n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_columnRenderable$1);
  var title = $n($as_s_Symbol($n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_witness$1).value__O())).s_Symbol__f_name;
  var f = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_sci_Map(x$7$2);
    return $n(x$7).get__O__s_Option($n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_witness$1).value__O())
  }));
  var rassoc$1 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer(title, f, this$2);
  var this$3 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7__f_tail$2).columns__sci_List());
  return new $c_sci_$colon$colon(rassoc$1, this$3)
});
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingTableRendererMidPriorityImplicits$$anon$7", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.Actions$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Actions: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap$1, gen$1, fromMap$1) {
  this.Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1__f_toMap$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1__f_gen$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1__f_toMap$1 = toMap$1;
  this.Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1__f_gen$1 = gen$1
}
$c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1.prototype.apply__O__sci_Map = (function(in$1) {
  var this$1 = $n(this.Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1__f_toMap$1);
  var t = $n(this.Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1__f_gen$1).to__O__O(in$1);
  return this$1.apply__Lshapeless_$colon$colon__sci_Map($as_Lshapeless_$colon$colon(t))
});
var $d_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.AsMap$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AsMap: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1;
function $p_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__childrenCount$lzycompute__I($thiz) {
  if ((!$thiz.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_bitmap$0)) {
    $thiz.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_childrenCount = $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__childrenCount__I($thiz);
    $thiz.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_bitmap$0 = true
  };
  return $thiz.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_childrenCount
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$2) {
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_children = null;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_childrenCount = 0;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_bitmap$0 = false;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_children = $n(renderer$2).columns__sci_List()
}
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype = $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype.newLevel__Z = (function() {
  return false
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype.maxLevel__I = (function() {
  return $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__maxLevel__I(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype.renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List = (function(level, context) {
  return $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List(this, level, context)
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype.renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode = (function(map, editing) {
  return $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode(this, map, editing)
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype.childrenCount__I = (function() {
  return ((!this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_bitmap$0) ? $p_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__childrenCount$lzycompute__I(this) : this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_childrenCount)
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype.children__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3__f_children
});
var $d_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3: 0
}, false, "com.iz2use.react.components.internal.multiview.ColumnFragment$$anon$3", {
  Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_ColumnFragment: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3;
function $p_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__childrenCount$lzycompute__I($thiz) {
  if ((!$thiz.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_bitmap$0)) {
    $thiz.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_childrenCount = $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__childrenCount__I($thiz);
    $thiz.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_bitmap$0 = true
  };
  return $thiz.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_childrenCount
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5(outer, columnGroupTitle$2, f$2) {
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_title = null;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_newLevel = false;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_childrenCount = 0;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_bitmap$0 = false;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_$outer = null;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_f$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_$outer = outer
  };
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_f$2 = f$2;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_title = columnGroupTitle$2;
  this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_newLevel = true
}
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype = $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype.maxLevel__I = (function() {
  return $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__maxLevel__I(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype.childrenCount__I = (function() {
  return ((!this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_bitmap$0) ? $p_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__childrenCount$lzycompute__I(this) : this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_childrenCount)
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype.children__sci_List = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_$outer).children__sci_List()
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype.newLevel__Z = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_newLevel
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype.renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List = (function(level, context) {
  if ((level === 0)) {
    $n($m_s_package$().s_package$__f_List);
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$5 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
    var a = this.childrenCount__I();
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$5.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_title;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var array$1 = [$n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  } else {
    return $n(this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_$outer).renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List((((-1) + level) | 0), context)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype.renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode = (function(in$1, editing) {
  var nextMap = $as_sci_Map($n(this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_f$2).apply__O__O(in$1));
  return $n(this.Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5__f_$outer).renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode(nextMap, $m_s_None$())
});
var $d_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5: 0
}, false, "com.iz2use.react.components.internal.multiview.ColumnFragment$$anon$5", {
  Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_ColumnFragment: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5;
function $f_Lcom_iz2use_react_components_internal_multiview_CompareRenderer__$init$__V($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1__f_name = "Comparer";
  $thiz.Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1__f_icon = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$() {
  $n_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$ = this;
  new $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer($m_Ljapgolly_scalajs_react_vdom_TagMod$().Ljapgolly_scalajs_react_vdom_TagMod$__f_empty, new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_s_Symbol(x$1$2);
    return $m_Ljapgolly_scalajs_react_vdom_TagMod$().Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  })))
}
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$: 0
}, false, "com.iz2use.react.components.internal.multiview.DecoratorRenderer$", {
  Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$;
var $n_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$;
function $m_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$ = new $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews$() {
  this.Lcom_iz2use_react_components_internal_multiview_DefinedViews$__f_defaultViews = null;
  $n_Lcom_iz2use_react_components_internal_multiview_DefinedViews$ = this;
  this.Lcom_iz2use_react_components_internal_multiview_DefinedViews$__f_defaultViews = new $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews()
}
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_DefinedViews$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_DefinedViews$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_DefinedViews$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_DefinedViews$: 0
}, false, "com.iz2use.react.components.internal.multiview.DefinedViews$", {
  Lcom_iz2use_react_components_internal_multiview_DefinedViews$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_DefinedViews$;
var $n_Lcom_iz2use_react_components_internal_multiview_DefinedViews$;
function $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_DefinedViews$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_DefinedViews$ = new $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_DefinedViews$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$.prototype.of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable = (function(format, ordering, editor, viewer, parser) {
  var orderingOpt = $n(ordering).Lcom_iz2use_common_FailableImplicit__f_value;
  var parserOpt = $n(parser).Lcom_iz2use_common_FailableImplicit__f_value;
  return new $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable(format, orderingOpt, editor, viewer, parserOpt)
});
var $d_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_FieldRenderable$: 0
}, false, "com.iz2use.react.components.internal.multiview.FieldRenderable$", {
  Lcom_iz2use_react_components_internal_multiview_FieldRenderable$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$;
var $n_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$;
function $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$ = new $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$1) {
  this.Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1__f_fields = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1__f_fields = $n(renderer$1).fields__sci_List()
}
$c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.FieldsRenderer$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_FieldsRenderer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner.prototype = new $h_Lcom_iz2use_react_components_MultiviewRefiner();
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_FilterRefiner() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_FilterRefiner.prototype = $c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner.prototype.handleNext__Lcom_iz2use_react_components_internal_multiview_MultiviewState__s_Option__s_Option__Lcom_iz2use_react_components_internal_multiview_HasIterator__s_Option = (function(next, prev, lastState, iterable) {
  var this$1 = $n(prev);
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var p = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState(arg1);
    var x = $n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
    var x$2 = $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query;
      var x$4 = $n($n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $m_s_None$()
  } else {
    var rc6 = false;
    var x3 = null;
    var x1 = $n($n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query;
    matchEnd7: {
      var $$x2;
      var x$1 = $m_s_None$();
      if ((x$1 === x1)) {
        var $$x2 = $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
        break matchEnd7
      };
      if ((x1 instanceof $c_s_Some)) {
        rc6 = true;
        x3 = $as_s_Some(x1);
        var query = $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery($n(x3).s_Some__f_value);
        if ($n($n(query).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_matchingFields).isEmpty__Z()) {
          var $$x2 = $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
          break matchEnd7
        }
      };
      if (rc6) {
        var query$2 = $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery($n(x3).s_Some__f_value);
        var eval$1 = $as_sci_Seq($n($n(query$2).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_matchingFields).collect__s_PartialFunction__O(new $c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1(this)));
        window.performance.mark("FilterResults.eval.start");
        var r = $n($n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((source$2) => $n(iterable).filter__O__F1__O(source$2, new $c_sjsr_AnonFunction1(((x0$1$2) => {
          var x0$1 = $as_T2(x0$1$2);
          if ((x0$1 !== null)) {
            var in$1 = $as_sci_Map($n(x0$1)._2__O());
            return (!$n(eval$1).exists__F1__Z(new $c_sjsr_AnonFunction1(((f$2) => {
              var f = $as_F1(f$2);
              return (!$uZ($n(f).apply__O__O(in$1)))
            }))))
          } else {
            throw new $c_s_MatchError(x0$1)
          }
        }))))));
        window.performance.mark("FilterResults.eval.end");
        window.performance.measure("FilterResults.eval", "FilterResults.eval.start", "FilterResults.eval.end");
        var $$x2 = r;
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_s_Some($$x2)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner.prototype.reusabilityState__F2__F1__F2 = (function(evT, evC) {
  return $n($as_Ljapgolly_scalajs_react_Reusability($n(evC).apply__O__O(new $c_Ljapgolly_scalajs_react_Reusability(evT)))).Ljapgolly_scalajs_react_Reusability__f_test
});
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner.prototype.apply__O__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ldiode_data_Pot = (function(state, results, iterable) {
  var state$1 = $as_Ldiode_data_Pot(state);
  return state$1
});
var $d_Lcom_iz2use_react_components_internal_multiview_FilterRefiner = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_FilterRefiner: 0
}, false, "com.iz2use.react.components.internal.multiview.FilterRefiner", {
  Lcom_iz2use_react_components_internal_multiview_FilterRefiner: 1,
  Lcom_iz2use_react_components_MultiviewRefiner: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_FilterRefiner;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(outer) {
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$1__f_sizing = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$1__f_alignment = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$1__f_sizing = $n(outer).sizing__Lcom_iz2use_react_components_internal_multiview_Sizing();
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$1__f_alignment = $n(outer).alignment__Ljapgolly_scalajs_react_vdom_TagMod()
}
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$1__f_sizing
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$1__f_alignment
});
var $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.Format$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Format: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2() {
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$2__f_sizing = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$2__f_sizing = new $c_Lcom_iz2use_react_components_internal_multiview_Sizing($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("7 0 10em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString))
}
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$2__f_sizing
});
var $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$2: 0
}, false, "com.iz2use.react.components.internal.multiview.Format$$anon$2", {
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Format: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3() {
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$3__f_sizing = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$3__f_alignment = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$3__f_sizing = new $c_Lcom_iz2use_react_components_internal_multiview_Sizing($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 0 6em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$4 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$3__f_alignment = this$4.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
}
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$3__f_sizing
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$3__f_alignment
});
var $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$3: 0
}, false, "com.iz2use.react.components.internal.multiview.Format$$anon$3", {
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Format: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$3;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4() {
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$4__f_sizing = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$4__f_alignment = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$4__f_sizing = new $c_Lcom_iz2use_react_components_internal_multiview_Sizing($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 0 5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$4 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$4__f_alignment = this$4.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
}
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$4__f_sizing
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$4__f_alignment
});
var $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$4: 0
}, false, "com.iz2use.react.components.internal.multiview.Format$$anon$4", {
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$4: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Format: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$4;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5() {
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$5__f_sizing = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$5__f_alignment = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$5__f_sizing = new $c_Lcom_iz2use_react_components_internal_multiview_Sizing($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 0 4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$4 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$5__f_alignment = this$4.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
}
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$5__f_sizing
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$5__f_alignment
});
var $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$5: 0
}, false, "com.iz2use.react.components.internal.multiview.Format$$anon$5", {
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$5: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Format: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$5;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6() {
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$6__f_sizing = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$6__f_alignment = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$6__f_sizing = new $c_Lcom_iz2use_react_components_internal_multiview_Sizing($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 0 1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$4 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$6__f_alignment = this$4.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
}
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$6__f_sizing
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$6__f_alignment
});
var $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$6: 0
}, false, "com.iz2use.react.components.internal.multiview.Format$$anon$6", {
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$6: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Format: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$6;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7() {
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$7__f_sizing = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$7__f_alignment = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$7__f_sizing = new $c_Lcom_iz2use_react_components_internal_multiview_Sizing($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 0 6em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$4 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$7__f_alignment = this$4.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("left", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
}
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$7__f_sizing
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$7__f_alignment
});
var $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$7: 0
}, false, "com.iz2use.react.components.internal.multiview.Format$$anon$7", {
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$7: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Format: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$7;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$1) {
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$8__f_sizing = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$8__f_alignment = null;
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$8__f_sizing = $n(format$1).sizing__Lcom_iz2use_react_components_internal_multiview_Sizing();
  this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$8__f_alignment = $n(format$1).alignment__Ljapgolly_scalajs_react_vdom_TagMod()
}
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$8__f_sizing
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Format$$anon$8__f_alignment
});
var $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$8: 0
}, false, "com.iz2use.react.components.internal.multiview.Format$$anon$8", {
  Lcom_iz2use_react_components_internal_multiview_Format$$anon$8: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Format: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8;
function $f_Lcom_iz2use_react_components_internal_multiview_GanttRenderer__$init$__V($thiz) {
  $thiz.Lreactbuild_analyze_cost_modules_Projects$$anon$4__f_name = "Gantt";
  $thiz.Lreactbuild_analyze_cost_modules_Projects$$anon$4__f_icon = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M 0 0 L 0 24 L 2 24 L 24 24 L 24 22 L 2 22 L 2 0 L 0 0 z M 4 2 L 4 5 L 5 5 L 5 4 L 21 4 L 21 5 L 22 5 L 22 2 L 4 2 z M 4 7 L 4 10 L 10 10 L 10 7 L 4 7 z M 10 12 L 10 15 L 15 15 L 15 12 L 10 12 z M 15 17 L 15 20 L 22 20 L 22 17 L 15 17 z "))
}
function $f_Lcom_iz2use_react_components_internal_multiview_GridRenderer__$init$__V($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_name = "Grille";
  $thiz.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_icon = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z"))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$: 0
}, false, "com.iz2use.react.components.internal.multiview.HasViewMaterializer$", {
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$;
var $n_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$;
function $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$ = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2.prototype = $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2.prototype.apply__sci_List = (function() {
  return $m_s_package$().s_package$__f_Nil
});
var $d_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2: 0
}, false, "com.iz2use.react.components.internal.multiview.HasViewMaterializer$$anon$2", {
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$1, tail$2) {
  this.Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3__f_view$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3__f_tail$2 = null;
  this.Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3__f_view$1 = view$1;
  this.Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3__f_tail$2 = tail$2
}
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3.prototype = $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3.prototype.apply__sci_List = (function() {
  var rassoc$1 = this.Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3__f_view$1;
  var this$1 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3__f_tail$2).apply__sci_List());
  return new $c_sci_$colon$colon(rassoc$1, this$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3: 0
}, false, "com.iz2use.react.components.internal.multiview.HasViewMaterializer$$anon$3", {
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(outer, tail$1) {
  this.Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1__f_tail$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1__f_tail$1 = tail$1
}
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1.prototype.apply__sci_List = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1__f_tail$1).apply__sci_List()
});
var $d_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.HasViewMaterializerLowPriorityImplicits$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_IterableIsIterator() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_IterableIsIterator.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_IterableIsIterator.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_IterableIsIterator;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_IterableIsIterator() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_IterableIsIterator.prototype = $c_Lcom_iz2use_react_components_internal_multiview_IterableIsIterator.prototype;
function $f_Lcom_iz2use_react_components_internal_multiview_ListRenderer__$init$__V($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_name = "Liste";
  $thiz.Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_icon = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"))
}
function $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  if ((b$1$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = this$1.by_$eq$eq__F2();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$2.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$2$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$2$lzy$1, reusabilityT$1) {
  if ((b$2$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2(reusabilityT$1));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$2$1__sr_LazyRef__F2__F2($thiz, b$2$lzy$1, reusabilityT$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$2$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$2$lzy$1, reusabilityT$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  if ((b$3$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$3$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = $m_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$().reuseParsedQuery__F2();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$3$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  return ($n(b$3$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  if ((b$4$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$4$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lcom_iz2use_react_components_internal_multiview_Order$().Lcom_iz2use_react_components_internal_multiview_Order$__f_reusabilityOrder));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$4$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  return ($n(b$4$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$.prototype.reuseMultiviewCurrentState__F2__F2 = (function(reusabilityT) {
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  var b$3$lzy = new $c_sr_LazyRef();
  var b$4$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(a$2);
    var b = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(b$2);
    return ((($uZ($n($p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view, $n(b).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view)) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$2$1__sr_LazyRef__F2__F2(this, b$2$lzy, reusabilityT)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected, $n(b).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$3$1__sr_LazyRef__F2(this, b$3$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query, $n(b).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$__b$4$1__sr_LazyRef__F2(this, b$4$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders, $n(b).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders)))
  }));
  elem = f;
  return $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
});
var $d_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$: 0
}, false, "com.iz2use.react.components.internal.multiview.MultiviewCurrentState$", {
  Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$;
var $n_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$;
function $m_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$ = new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator();
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.MultiviewDecorator$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1: 1,
  Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator$$anon$1;
function $p_Lcom_iz2use_react_components_internal_multiview_Order$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  if ((b$1$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_Order$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_Order$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_Order$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  if ((b$2$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_Order$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_Order$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Order$() {
  this.Lcom_iz2use_react_components_internal_multiview_Order$__f_keyMapper = null;
  this.Lcom_iz2use_react_components_internal_multiview_Order$__f_reusabilityOrder = null;
  $n_Lcom_iz2use_react_components_internal_multiview_Order$ = this;
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lcom_iz2use_react_components_internal_multiview_Order(x$1$2);
    return $n(x$1).Lcom_iz2use_react_components_internal_multiview_Order__f_field
  }));
  var ev = $m_Lcom_iz2use_common_KeyMapper$().Lcom_iz2use_common_KeyMapper$__f_fromString;
  this.Lcom_iz2use_react_components_internal_multiview_Order$__f_keyMapper = new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f);
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lcom_iz2use_react_components_internal_multiview_Order(a$2);
    var b = $as_Lcom_iz2use_react_components_internal_multiview_Order(b$2);
    return ($uZ($n($p_Lcom_iz2use_react_components_internal_multiview_Order$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_Order__f_field, $n(b).Lcom_iz2use_react_components_internal_multiview_Order__f_field)) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_Order$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_Order__f_ascending, $n(b).Lcom_iz2use_react_components_internal_multiview_Order__f_ascending)))
  }));
  elem = f$1;
  this.Lcom_iz2use_react_components_internal_multiview_Order$__f_reusabilityOrder = $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
}
$c_Lcom_iz2use_react_components_internal_multiview_Order$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Order$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Order$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Order$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Order$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Order$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_Order$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Order$: 0
}, false, "com.iz2use.react.components.internal.multiview.Order$", {
  Lcom_iz2use_react_components_internal_multiview_Order$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Order$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Order$;
var $n_Lcom_iz2use_react_components_internal_multiview_Order$;
function $m_Lcom_iz2use_react_components_internal_multiview_Order$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_Order$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_Order$ = new $c_Lcom_iz2use_react_components_internal_multiview_Order$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_Order$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$.prototype.equiv__s_math_Equiv = (function() {
  var $$x2 = $n($m_s_package$().s_package$__f_Equiv);
  var $$x1 = new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(in$2);
    return $n(in$1).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_input
  }));
  $m_Lcats_implicits$();
  var ev = $m_Lcats_implicits$().Lcats_implicits$__f_catsKernelStdOrderForString;
  var this$3 = $n(ev);
  return $n($$x2).by__F1__s_math_Equiv__s_math_Equiv($$x1, new $c_Lcats_kernel_Order$$anon$1(this$3))
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$.prototype.reuseParsedQuery__F2 = (function() {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(x$4$2);
    return $n(x$4).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_input
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
});
var $d_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_ParsedQuery$: 0
}, false, "com.iz2use.react.components.internal.multiview.ParsedQuery$", {
  Lcom_iz2use_react_components_internal_multiview_ParsedQuery$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$;
var $n_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$;
function $m_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$ = new $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format) {
  this.Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat__f_format = null;
  this.Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat__f_format = format
}
$c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat.prototype = $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat__f_format).sizing__Lcom_iz2use_react_components_internal_multiview_Sizing()
});
$c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat__f_format).alignment__Ljapgolly_scalajs_react_vdom_TagMod()
});
var $d_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat: 0
}, false, "com.iz2use.react.components.internal.multiview.ProxyFieldFormat", {
  Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_FieldFormat: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat;
function $p_Lcom_iz2use_react_components_internal_multiview_SearchRefiner__MatchedTypedState$lzycompute$1__V($thiz) {
  if (($thiz.Lcom_iz2use_react_components_internal_multiview_SearchRefiner__f_MatchedTypedState$module === null)) {
    $thiz.Lcom_iz2use_react_components_internal_multiview_SearchRefiner__f_MatchedTypedState$module = new $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$($thiz)
  }
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner() {
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner__f_MatchedTypedState$module = null
}
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype = new $h_Lcom_iz2use_react_components_MultiviewRefiner();
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype.MatchedTypedState__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$ = (function() {
  if ((this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner__f_MatchedTypedState$module === null)) {
    $p_Lcom_iz2use_react_components_internal_multiview_SearchRefiner__MatchedTypedState$lzycompute$1__V(this)
  };
  return this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner__f_MatchedTypedState$module
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype.reusabilityState__F2__F1__F2 = (function(evT, evC) {
  return $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2()
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype.handleNext__Lcom_iz2use_react_components_internal_multiview_MultiviewState__s_Option__s_Option__Lcom_iz2use_react_components_internal_multiview_HasIterator__s_Option = (function(next, prev, lastState, iterable) {
  var this$1 = $n(prev);
  if (this$1.isEmpty__Z()) {
    var prevTokenized = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x$4 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState(arg1);
    var this$2 = $n($n($n(x$4).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query);
    if (this$2.isEmpty__Z()) {
      var prevTokenized = $m_s_None$()
    } else {
      var arg1$1 = this$2.get__O();
      var x$5 = $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(arg1$1);
      var prevTokenized = new $c_s_Some($n(x$5).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_tokenized)
    }
  };
  var this$3 = $n($n($n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query);
  if (this$3.isEmpty__Z()) {
    var nextTokenizedQuery = $m_s_None$()
  } else {
    var arg1$2 = this$3.get__O();
    var x$6 = $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(arg1$2);
    var nextTokenizedQuery = new $c_s_Some($n(x$6).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_tokenized)
  };
  var this$4 = $n(prev);
  if ((!this$4.isEmpty__Z())) {
    var arg1$3 = this$4.get__O();
    var p = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState(arg1$3);
    var x = $n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
    var x$2 = $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var this$5 = $n(prevTokenized);
      if (this$5.isEmpty__Z()) {
        var x$3 = $m_s_None$()
      } else {
        var arg1$4 = this$5.get__O();
        var x$7 = $as_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(arg1$4);
        var x$3 = new $c_s_Some($n(x$7).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens)
      };
      var this$6 = $n(nextTokenizedQuery);
      if (this$6.isEmpty__Z()) {
        var x$4$1 = $m_s_None$()
      } else {
        var arg1$5 = this$6.get__O();
        var x$8 = $as_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(arg1$5);
        var x$4$1 = new $c_s_Some($n(x$8).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens)
      };
      var $$x1 = ((x$3 === null) ? (x$4$1 === null) : $n(x$3).equals__O__Z(x$4$1))
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $m_s_None$()
  } else {
    var this$7 = $n(lastState);
    if (this$7.isEmpty__Z()) {
      var $$x2 = true
    } else {
      var arg1$6 = this$7.get__O();
      $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState(arg1$6);
      var this$8 = $n(prev);
      if ((!this$8.isEmpty__Z())) {
        var arg1$7 = this$8.get__O();
        var x$10 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState(arg1$7);
        var x$1 = $n(x$10).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
        var x$2$1 = $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
        var $$x2 = ((x$1 === null) ? (x$2$1 === null) : $n(x$1).equals__O__Z(x$2$1))
      } else {
        var $$x2 = false
      }
    };
    var this$9 = $n(($$x2 ? this$7 : $m_s_None$()));
    var currentState = $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState((this$9.isEmpty__Z() ? new $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState(this, $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source) : this$9.get__O()));
    matchEnd4: {
      var $$x3;
      if ((nextTokenizedQuery instanceof $c_s_Some)) {
        var x2 = $as_s_Some(nextTokenizedQuery);
        var tokenizedQuery = $as_Lcom_iz2use_common_internal_tokenizer_SeqTokenized($n(x2).s_Some__f_value);
        var this$10 = $n($n(tokenizedQuery).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens);
        if ((!this$10.isEmpty__Z())) {
          window.performance.mark("SearchResults.eval.start");
          var r = $n(currentState).matched__s_Option__F1__F1__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState(lastState, new $c_sjsr_AnonFunction1(((item$2) => {
            var tokenizer = $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_tokenizer;
            var filter = $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_filter;
            var this$13 = $n(tokenizer);
            return this$13.tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_MappedTokenized(item$2, filter)
          })), new $c_sjsr_AnonFunction1(((tokenized$2) => {
            var tokenized = $as_Lcom_iz2use_common_internal_tokenizer_MappedTokenized(tokenized$2);
            var tokenMatcher = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
            var this$14 = $n(tokenMatcher);
            return $f_Lcom_iz2use_common_ForeachQueryTokenMatcher__matches__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__Lcom_iz2use_common_internal_tokenizer_Tokenized__Lcom_iz2use_common_TokenMatches(this$14, tokenizedQuery, tokenized)
          })), iterable, $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_keyMapper);
          window.performance.mark("SearchResults.eval.end");
          window.performance.measure("SearchResults.eval", "SearchResults.eval.start", "SearchResults.eval.end");
          var $$x3 = r;
          break matchEnd4
        }
      };
      var $$x3 = $n(currentState).noMatched__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$NotMatchedTypedState(iterable)
    };
    return new $c_s_Some($$x3)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype.apply__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ldiode_data_Pot = (function(state, results, iterable) {
  if ((state instanceof $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState)) {
    var x2 = $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState(state);
    var filters = $n(x2).Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_filtered;
    return filters
  } else {
    return results
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype.apply__O__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ldiode_data_Pot = (function(state, results, iterable) {
  return this.apply__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ldiode_data_Pot($as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState(state), results, iterable)
});
var $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner: 0
}, false, "com.iz2use.react.components.internal.multiview.SearchRefiner", {
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner: 1,
  Lcom_iz2use_react_components_MultiviewRefiner: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$(outer) {
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$.prototype.from__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState = (function(results, iterable) {
  return new $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState(this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$__f_$outer, results, $n(results).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((results$2$2) => $n(iterable).collect__O__s_PartialFunction__O(results$2$2, new $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1(this))))))
});
var $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$: 0
}, false, "com.iz2use.react.components.internal.multiview.SearchRefiner$MatchedTypedState$", {
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$;
function $f_Lcom_iz2use_react_components_internal_multiview_Slideshow__$init$__V($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1__f_name = "Diaporama";
  $thiz.Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1__f_icon = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z"))
}
function $is_Lcom_iz2use_react_components_internal_multiview_Slideshow(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_internal_multiview_Slideshow)))
}
function $as_Lcom_iz2use_react_components_internal_multiview_Slideshow(obj) {
  return (($is_Lcom_iz2use_react_components_internal_multiview_Slideshow(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.Slideshow"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_Slideshow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_Slideshow)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_Slideshow(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_Slideshow(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.Slideshow;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_Slideshow = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Slideshow: 0
}, true, "com.iz2use.react.components.internal.multiview.Slideshow", {
  Lcom_iz2use_react_components_internal_multiview_Slideshow: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_View: 1
});
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner.prototype = new $h_Lcom_iz2use_react_components_MultiviewRefiner();
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SortRefiner() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SortRefiner.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner.prototype.generateOrdering__Lcom_iz2use_react_components_internal_multiview_MultiviewState__s_math_Ordering = (function(props) {
  var this$1 = $n($n($n(props).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders);
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = $n(rest).head__O();
    var order = $as_Lcom_iz2use_react_components_internal_multiview_Order(arg1);
    var this$2 = $n($n($n(props).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_fields).collectFirst__s_PartialFunction__s_Option(new $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1(this, order)));
    if (this$2.isEmpty__Z()) {
      var $$x1 = $m_s_None$()
    } else {
      var arg1$1 = this$2.get__O();
      var f = $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(arg1$1);
      var this$3 = $n($n($n(f).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_ordering);
      if (this$3.isEmpty__Z()) {
        var $$x1 = $m_s_None$()
      } else {
        var arg1$2 = this$3.get__O();
        var ordering = $as_s_math_Ordering(arg1$2);
        var $$x1 = new $c_s_Some(new $c_T3($n(f).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key, ordering, $n(order).Lcom_iz2use_react_components_internal_multiview_Order__f_ascending))
      }
    };
    var it = $n($$x1).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        $n(t).sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest = $as_sci_List($n(rest).tail__O())
  };
  var fieldOrderings = ((h === null) ? $m_sci_Nil$() : h);
  return new $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1(this, fieldOrderings)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner.prototype.handleNext__Lcom_iz2use_react_components_internal_multiview_MultiviewState__s_Option__s_Option__Lcom_iz2use_react_components_internal_multiview_HasIterator__s_Option = (function(next, prev, lastState, iterable) {
  var this$1 = $n(prev);
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var p = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState(arg1);
    var x = $n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
    var x$2 = $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders;
      var x$4 = $n($n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $m_s_None$()
  } else {
    var x1 = $n($n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders;
    matchEnd4: {
      var $$x2;
      if ((x1 !== null)) {
        $n($m_s_package$().s_package$__f_Seq);
        if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x1), true) && ($n(x1).lengthCompare__I__I(0) === 0))) {
          var $$x2 = $n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
          break matchEnd4
        }
      };
      var ord = this.generateOrdering__Lcom_iz2use_react_components_internal_multiview_MultiviewState__s_math_Ordering(next);
      window.performance.mark("SortResults.eval.start");
      var r = $n($n(next).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((source$2) => $n(iterable).sortBy__O__F1__s_math_Ordering__O(source$2, new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_T2(x$1$2);
        return $as_sci_Map($n(x$1)._2__O())
      })), ord))));
      window.performance.mark("SortResults.eval.end");
      window.performance.measure("SortResults.eval", "SortResults.eval.start", "SortResults.eval.end");
      var $$x2 = r
    };
    return new $c_s_Some($$x2)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner.prototype.reusabilityState__F2__F1__F2 = (function(evT, evC) {
  return $n($as_Ljapgolly_scalajs_react_Reusability($n(evC).apply__O__O(new $c_Ljapgolly_scalajs_react_Reusability(evT)))).Ljapgolly_scalajs_react_Reusability__f_test
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner.prototype.apply__O__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ldiode_data_Pot = (function(state, results, iterable) {
  var state$1 = $as_Ldiode_data_Pot(state);
  return state$1
});
var $d_Lcom_iz2use_react_components_internal_multiview_SortRefiner = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SortRefiner: 0
}, false, "com.iz2use.react.components.internal.multiview.SortRefiner", {
  Lcom_iz2use_react_components_internal_multiview_SortRefiner: 1,
  Lcom_iz2use_react_components_MultiviewRefiner: 1,
  O: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SortRefiner;
function $f_Lcom_iz2use_react_components_internal_multiview_TableRenderer__renderSkeleton__Ljapgolly_scalajs_react_vdom_VdomNode($thiz) {
  var this$16 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [$m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "progress"), $m_sci_Nil$())];
  var array$1 = [$n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var array$2 = [$n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$16, null, ns)
}
function $f_Lcom_iz2use_react_components_internal_multiview_TableRenderer__$init$__V($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_name = "Tableau";
  $thiz.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_icon = ($m_Lcom_iz2use_react_components_IconSource$(), new $c_Lcom_iz2use_react_components_IconSourceShape("M10 10.02h5V21h-5zM17 21h3c1.1 0 2-.9 2-2v-9h-5v11zm3-18H5c-1.1 0-2 .9-2 2v3h19V5c0-1.1-.9-2-2-2zM3 19c0 1.1.9 2 2 2h3V10H3v9z"))
}
function $is_Lcom_iz2use_react_components_internal_multiview_TableRenderer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_react_components_internal_multiview_TableRenderer)))
}
function $as_Lcom_iz2use_react_components_internal_multiview_TableRenderer(obj) {
  return (($is_Lcom_iz2use_react_components_internal_multiview_TableRenderer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.TableRenderer"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_TableRenderer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_TableRenderer)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_TableRenderer(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_TableRenderer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.TableRenderer;", depth))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  if ((b$1$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  if ((b$2$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  if ((b$3$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$3$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$3$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  return ($n(b$3$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  if ((b$4$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$4$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$4$1__sr_LazyRef__F2($thiz, b$4$lzy$1) {
  return ($n(b$4$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$4$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$4$lzycompute$1__sr_LazyRef__F2($thiz, b$4$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$5$lzycompute$1__sr_LazyRef__F2($thiz, b$5$lzy$1) {
  if ((b$5$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$5$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$5$1__sr_LazyRef__F2($thiz, b$5$lzy$1) {
  return ($n(b$5$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$5$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$5$lzycompute$1__sr_LazyRef__F2($thiz, b$5$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$6$lzycompute$1__sr_LazyRef__F2($thiz, b$6$lzy$1) {
  if ((b$6$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$6$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$6$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$6$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$6$1__sr_LazyRef__F2($thiz, b$6$lzy$1) {
  return ($n(b$6$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$6$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$6$lzycompute$1__sr_LazyRef__F2($thiz, b$6$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$7$lzycompute$1__sr_LazyRef__F2($thiz, b$7$lzy$1) {
  if ((b$7$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$7$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$7$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$2.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$7$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$7$1__sr_LazyRef__F2($thiz, b$7$lzy$1) {
  return ($n(b$7$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$7$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$7$lzycompute$1__sr_LazyRef__F2($thiz, b$7$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$8$lzycompute$1__sr_LazyRef__F2($thiz, b$8$lzy$1) {
  if ((b$8$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$8$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$8$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$8$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$8$1__sr_LazyRef__F2($thiz, b$8$lzy$1) {
  return ($n(b$8$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$8$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$8$lzycompute$1__sr_LazyRef__F2($thiz, b$8$lzy$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$9$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$9$lzy$1, reuseDecorator$1) {
  if ((b$9$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$9$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$9$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability(reuseDecorator$1);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$9$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$9$1__sr_LazyRef__F2__F2($thiz, b$9$lzy$1, reuseDecorator$1) {
  return ($n(b$9$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$9$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$9$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$9$lzy$1, reuseDecorator$1))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$10$lzycompute$1__sr_LazyRef__F2($thiz, b$10$lzy$1) {
  if ((b$10$lzy$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ($n(b$10$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$10$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$10$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$10$1__sr_LazyRef__F2($thiz, b$10$lzy$1) {
  return ($n(b$10$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$10$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$10$lzycompute$1__sr_LazyRef__F2($thiz, b$10$lzy$1))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$() {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__f_component = null;
  $n_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$ = this;
  var this$10 = $n($n(new $c_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("GridItem", $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend(x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x1 = $n($as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    return $n($$x1).render__Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__Ljapgolly_scalajs_react_vdom_VdomNode($as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()))
  }))));
  $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$1 = this.reusableProps__F2();
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$2 = this$5.always__F2();
  var this$8 = $m_Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$();
  var f = $n(this$8.Ljapgolly_scalajs_react_ScalaJsReactConfig$Defaults$__f_reusabilityOverrideInDev).apply__F2__F2__F1(evidence$1, evidence$2);
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__f_component = $n($as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep($n(f).apply__O__O(this$10))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$.prototype.renderItem__Z__Z__s_Option__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagOf = (function(selected, focused, image, imageOverlay, title, click, style) {
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(style).Lcom_iz2use_react_style_Style__f_gridItem;
  var $$x9 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(style).Lcom_iz2use_react_style_Style__f_multiviewSelected;
  var this$5 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1));
  var $$x8 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$5, selected);
  var this$6 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n(style).Lcom_iz2use_react_style_Style__f_multiviewFocused;
  var this$7 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s$2));
  var $$x7 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$7, focused);
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$10 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $n(style).Lcom_iz2use_react_style_Style__f_gridItemContent;
  var $$x5 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s$3);
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$13 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $n(style).Lcom_iz2use_react_style_Style__f_gridItemImage;
  var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$13, s$4);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var array = [$$x3, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(image, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((url$2) => {
    var url = $as_T(url$2);
    return ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle("backgroundImage")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((("url(" + url) + ")"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
  }))), imageOverlay];
  var $$x2 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$22 = $m_Lscalacss_ScalaCssReact$();
  var s$5 = $n(style).Lcom_iz2use_react_style_Style__f_gridItemTitle;
  var array$1 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$22, s$5), title];
  var array$2 = [$$x5, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var array$3 = [$$x9, $$x8, $$x7, $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(click, $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$.prototype.reusableProps__F2 = (function() {
  var reuseDecorator = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  var b$3$lzy = new $c_sr_LazyRef();
  var b$4$lzy = new $c_sr_LazyRef();
  var b$5$lzy = new $c_sr_LazyRef();
  var b$6$lzy = new $c_sr_LazyRef();
  var b$7$lzy = new $c_sr_LazyRef();
  var b$8$lzy = new $c_sr_LazyRef();
  var b$9$lzy = new $c_sr_LazyRef();
  var b$10$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(a$2);
    var b = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(b$2);
    return ((((((((((($uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_key, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_key)) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$3$1__sr_LazyRef__F2(this, b$3$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_map, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_map))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$4$1__sr_LazyRef__F2(this, b$4$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderer, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderer))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$5$1__sr_LazyRef__F2(this, b$5$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_itemSimpleActions, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_itemSimpleActions))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$6$1__sr_LazyRef__F2(this, b$6$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_selected, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_selected))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$6$1__sr_LazyRef__F2(this, b$6$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_focused, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_focused))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$7$1__sr_LazyRef__F2(this, b$7$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_ref, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_ref))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$8$1__sr_LazyRef__F2(this, b$8$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActive, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActive))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$8$1__sr_LazyRef__F2(this, b$8$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActiveAndSelectView, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActiveAndSelectView))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$9$1__sr_LazyRef__F2__F2(this, b$9$lzy, reuseDecorator)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_decorator, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_decorator))) && $uZ($n($p_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__b$10$1__sr_LazyRef__F2(this, b$10$lzy)).apply__O__O__O($n(a).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderable, $n(b).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderable)))
  }));
  elem = f;
  return $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$.prototype.withKey__T__O__sci_Map__Lcom_iz2use_react_components_internal_multiview_GridRenderer__Lcom_iz2use_react_components_internal_multiview_Actions__Z__Z__s_Option__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_Reusable__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Lcom_iz2use_react_components_internal_multiview_grid_GridRenderable__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(key, model, map, renderer, itemSimpleActions, selected, focused, ref, setActive, setActiveAndSelectView, decorator, renderable) {
  var c = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(key)));
  var props = new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(key, model, map, renderer, itemSimpleActions, selected, focused, ref, setActive, setActiveAndSelectView, decorator, renderable);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridItem$: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridItem$", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridItem$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$;
var $n_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$;
function $m_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$ = new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1(outer) {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.activateFocused__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.gotoBoundItem__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.changePrimarySelection__s_PartialFunction = (function() {
  return new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.changeSecondarySelection__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.extendPrimarySelection__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.extendSecondarySelection__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.toggleSelectionState__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.movePrimaryFocus__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.moveSecondaryFocus__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridView$TypedBackend$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AxesContext: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$.prototype.of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable = (function(format, ordering, editable, viewable) {
  var orderingOpt = $n(ordering).Lcom_iz2use_common_FailableImplicit__f_value;
  return new $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable(format, orderingOpt, editable, viewable)
});
var $d_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$: 0
}, false, "com.iz2use.react.components.internal.multiview.table.ColumnRenderable$", {
  Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$;
var $n_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$;
function $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$ = new $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format) {
  this.Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat__f_format = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat__f_format = format
}
$c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat.prototype.sizing__Lcom_iz2use_react_components_internal_multiview_Sizing = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat__f_format).sizing__Lcom_iz2use_react_components_internal_multiview_Sizing()
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat.prototype.alignment__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat__f_format).alignment__Ljapgolly_scalajs_react_vdom_TagMod()
});
var $d_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat: 0
}, false, "com.iz2use.react.components.internal.multiview.table.ProxyColumnFormat", {
  Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1(outer) {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.activateFocused__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.gotoBoundItem__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.changePrimarySelection__s_PartialFunction = (function() {
  return new $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.changeSecondarySelection__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.extendPrimarySelection__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.extendSecondarySelection__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.toggleSelectionState__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.movePrimaryFocus__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.moveSecondaryFocus__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
var $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.table.TabularView$TypedBackend$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AxesContext: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$.prototype.onPropsChange__Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__s_concurrent_Future = (function(fetcher, props, state) {
  if ($n($n(state).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems).isEmpty__Z()) {
    return $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_Exception__T__(new $c_jl_Exception(), "No loaded items"))
  } else {
    var $$x1 = $m_s_concurrent_Future$();
    var this$5 = $n($as_sc_SeqOps($n($as_sc_IterableOps($n($n(state).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems).get__O())).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var i = $n(x0$1)._1__O();
        var r = $as_Lcom_iz2use_common_internal_tokenizer_Tokenized($n(x0$1)._2__O());
        var this$3 = $n($n(props).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenMatcher);
        var search = $n(props).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizedSearch;
        var y = $f_Lcom_iz2use_common_ForeachQueryTokenMatcher__matches__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__Lcom_iz2use_common_internal_tokenizer_Tokenized__Lcom_iz2use_common_TokenMatches(this$3, search, r);
        return $ct_T2__O__O__(new $c_T2(), i, y)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })))));
    var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_T2(x$1$2);
      return $as_Lcom_iz2use_common_TokenMatches($n(x$1)._2__O())
    }));
    var ord = $m_Lcom_iz2use_common_TokenMatches$().tokenMatchesOrdering__s_math_Ordering();
    return $n($$x1).successful__O__s_concurrent_Future($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$5, f, ord))
  }
});
var $d_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$: 0
}, false, "com.iz2use.react.components.internal.suggestion.FetcherBackend$OnMountFetcherBackend$", {
  Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_suggestion_FetcherBackend: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$;
var $n_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$;
function $m_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$() {
  if ((!$n_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$)) {
    $n_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$ = new $c_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$()
  };
  return $n_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2.prototype;
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionFocusHandler$$anon$2", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_package$() {
  this.Lcom_iz2use_react_components_package$__f_instantOrdering = null;
  $n_Lcom_iz2use_react_components_package$ = this;
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljava_time_Instant(x$1$2);
    return $n(x$1).toEpochMilli__J()
  }));
  var ord = $m_s_math_Ordering$Long$();
  this.Lcom_iz2use_react_components_package$__f_instantOrdering = new $c_s_math_Ordering$$anon$5(ord, f)
}
$c_Lcom_iz2use_react_components_package$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_package$.prototype.constructor = $c_Lcom_iz2use_react_components_package$;
/** @constructor */
function $h_Lcom_iz2use_react_components_package$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_package$.prototype = $c_Lcom_iz2use_react_components_package$.prototype;
$c_Lcom_iz2use_react_components_package$.prototype.toTagMod__T__Ljapgolly_scalajs_react_vdom_TagMod = (function(key) {
  var $$x1 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key);
  var this$1 = $m_Lcom_iz2use_common_package$();
  return $n($$x1).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(new $c_Lcom_iz2use_common_KeyImports$RichKey(this$1, key).Lcom_iz2use_common_KeyImports$RichKey__f_key, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS)
});
var $d_Lcom_iz2use_react_components_package$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_package$: 0
}, false, "com.iz2use.react.components.package$", {
  Lcom_iz2use_react_components_package$: 1,
  O: 1,
  Lcom_iz2use_react_components_feature_Features: 1
});
$c_Lcom_iz2use_react_components_package$.prototype.$classData = $d_Lcom_iz2use_react_components_package$;
var $n_Lcom_iz2use_react_components_package$;
function $m_Lcom_iz2use_react_components_package$() {
  if ((!$n_Lcom_iz2use_react_components_package$)) {
    $n_Lcom_iz2use_react_components_package$ = new $c_Lcom_iz2use_react_components_package$()
  };
  return $n_Lcom_iz2use_react_components_package$
}
/** @constructor */
function $c_Lcom_iz2use_react_hooks_package$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_hooks_package$.prototype = new $h_O();
$c_Lcom_iz2use_react_hooks_package$.prototype.constructor = $c_Lcom_iz2use_react_hooks_package$;
/** @constructor */
function $h_Lcom_iz2use_react_hooks_package$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_hooks_package$.prototype = $c_Lcom_iz2use_react_hooks_package$.prototype;
var $d_Lcom_iz2use_react_hooks_package$ = new $TypeData().initClass({
  Lcom_iz2use_react_hooks_package$: 0
}, false, "com.iz2use.react.hooks.package$", {
  Lcom_iz2use_react_hooks_package$: 1,
  O: 1,
  Lcom_iz2use_react_hooks_HooksApiExt: 1
});
$c_Lcom_iz2use_react_hooks_package$.prototype.$classData = $d_Lcom_iz2use_react_hooks_package$;
var $n_Lcom_iz2use_react_hooks_package$;
function $m_Lcom_iz2use_react_hooks_package$() {
  if ((!$n_Lcom_iz2use_react_hooks_package$)) {
    $n_Lcom_iz2use_react_hooks_package$ = new $c_Lcom_iz2use_react_hooks_package$()
  };
  return $n_Lcom_iz2use_react_hooks_package$
}
function $ct_Lcom_iz2use_react_style_MaterialDesign$PressableElevation__Lcom_iz2use_react_style_MaterialDesign__J__J__($thiz, outer, dpi, pressedDpi) {
  $thiz.Lcom_iz2use_react_style_MaterialDesign$PressableElevation__f_pressedDpi = pressedDpi;
  $ct_Lcom_iz2use_react_style_MaterialDesign$Elevation__Lcom_iz2use_react_style_MaterialDesign__J__($thiz, outer, dpi);
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_style_MaterialDesign$PressableElevation() {
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_dpi = $L0;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_$outer = null;
  this.Lcom_iz2use_react_style_MaterialDesign$PressableElevation__f_pressedDpi = $L0
}
$c_Lcom_iz2use_react_style_MaterialDesign$PressableElevation.prototype = new $h_Lcom_iz2use_react_style_MaterialDesign$Elevation();
$c_Lcom_iz2use_react_style_MaterialDesign$PressableElevation.prototype.constructor = $c_Lcom_iz2use_react_style_MaterialDesign$PressableElevation;
/** @constructor */
function $h_Lcom_iz2use_react_style_MaterialDesign$PressableElevation() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_MaterialDesign$PressableElevation.prototype = $c_Lcom_iz2use_react_style_MaterialDesign$PressableElevation.prototype;
$c_Lcom_iz2use_react_style_MaterialDesign$PressableElevation.prototype.pressedStyle__Lscalacss_internal_StyleS = (function() {
  return $n(this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_$outer).pureWhiteframe__J__Lscalacss_internal_StyleS(this.Lcom_iz2use_react_style_MaterialDesign$PressableElevation__f_pressedDpi)
});
function $p_Lcom_iz2use_react_style_package$__featureStateColor$lzycompute$1__V($thiz) {
  if (($m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_featureStateColor$module === null)) {
    $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_featureStateColor$module = new $c_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$($thiz)
  }
}
function $p_Lcom_iz2use_react_style_package$__zoom$lzycompute$1__V($thiz) {
  if (($m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_zoom$module === null)) {
    $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_zoom$module = new $c_Lcom_iz2use_react_style_ExtendedStyles$zoom$($thiz)
  }
}
function $p_Lcom_iz2use_react_style_package$__svgR$lzycompute$1__V($thiz) {
  if (($m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_svgR$module === null)) {
    $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_svgR$module = new $c_Lcom_iz2use_react_style_ExtendedStyles$svgR$($thiz)
  }
}
function $p_Lcom_iz2use_react_style_package$__svgFillColor$lzycompute$1__V($thiz) {
  if (($m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_svgFillColor$module === null)) {
    $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_svgFillColor$module = new $c_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$($thiz)
  }
}
/** @constructor */
function $c_Lcom_iz2use_react_style_package$() {
  this.Lcom_iz2use_react_style_package$__f_gridGap = null;
  this.Lcom_iz2use_react_style_package$__f_featureStateColor$module = null;
  this.Lcom_iz2use_react_style_package$__f_zoom$module = null;
  this.Lcom_iz2use_react_style_package$__f_svgR$module = null;
  this.Lcom_iz2use_react_style_package$__f_svgFillColor$module = null;
  $n_Lcom_iz2use_react_style_package$ = this;
  $f_Lcom_iz2use_react_style_ExtendedStyles__$init$__V(this)
}
$c_Lcom_iz2use_react_style_package$.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$.prototype.constructor = $c_Lcom_iz2use_react_style_package$;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$.prototype = $c_Lcom_iz2use_react_style_package$.prototype;
$c_Lcom_iz2use_react_style_package$.prototype.featureStateColor__Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$ = (function() {
  if (($m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_featureStateColor$module === null)) {
    $p_Lcom_iz2use_react_style_package$__featureStateColor$lzycompute$1__V(this)
  };
  return $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_featureStateColor$module
});
$c_Lcom_iz2use_react_style_package$.prototype.zoom__Lcom_iz2use_react_style_ExtendedStyles$zoom$ = (function() {
  if (($m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_zoom$module === null)) {
    $p_Lcom_iz2use_react_style_package$__zoom$lzycompute$1__V(this)
  };
  return $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_zoom$module
});
$c_Lcom_iz2use_react_style_package$.prototype.svgR__Lcom_iz2use_react_style_ExtendedStyles$svgR$ = (function() {
  if (($m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_svgR$module === null)) {
    $p_Lcom_iz2use_react_style_package$__svgR$lzycompute$1__V(this)
  };
  return $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_svgR$module
});
$c_Lcom_iz2use_react_style_package$.prototype.svgFillColor__Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$ = (function() {
  if (($m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_svgFillColor$module === null)) {
    $p_Lcom_iz2use_react_style_package$__svgFillColor$lzycompute$1__V(this)
  };
  return $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_svgFillColor$module
});
var $d_Lcom_iz2use_react_style_package$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$: 0
}, false, "com.iz2use.react.style.package$", {
  Lcom_iz2use_react_style_package$: 1,
  O: 1,
  Lcom_iz2use_react_style_ExtendedStyles: 1
});
$c_Lcom_iz2use_react_style_package$.prototype.$classData = $d_Lcom_iz2use_react_style_package$;
var $n_Lcom_iz2use_react_style_package$;
function $m_Lcom_iz2use_react_style_package$() {
  if ((!$n_Lcom_iz2use_react_style_package$)) {
    $n_Lcom_iz2use_react_style_package$ = new $c_Lcom_iz2use_react_style_package$()
  };
  return $n_Lcom_iz2use_react_style_package$
}
/** @constructor */
function $c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1(outer) {
  this.Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1.prototype = $c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1.prototype;
$c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1.prototype.dark__Lscalacss_internal_AV = (function() {
  return $n($n($n(this.Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1__f_$outer).Lcom_iz2use_react_style_package$RichToThemedStyle__f_com$iz2use$react$style$RichToThemedStyle$$v).dark__Lscalacss_internal_AV()).important__Lscalacss_internal_AV()
});
$c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1.prototype.light__Lscalacss_internal_AV = (function() {
  return $n($n($n(this.Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1__f_$outer).Lcom_iz2use_react_style_package$RichToThemedStyle__f_com$iz2use$react$style$RichToThemedStyle$$v).light__Lscalacss_internal_AV()).important__Lscalacss_internal_AV()
});
var $d_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1: 0
}, false, "com.iz2use.react.style.package$RichToThemedStyle$$anon$1", {
  Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_style_package$ToThemedStyle: 1
});
$c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4(outer, f$1, darkVersion$2, lightVersion$2) {
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_$outer = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_f$1 = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_darkVersion$2 = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_lightVersion$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_$outer = outer
  };
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_f$1 = f$1;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_darkVersion$2 = darkVersion$2;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_lightVersion$2 = lightVersion$2
}
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4.prototype.constructor = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4.prototype = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4.prototype;
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4.prototype.dark__Lscalacss_internal_AV = (function() {
  return $as_Lscalacss_internal_AV($n($as_F1($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_f$1).apply__O__O(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_darkVersion$2))).apply__O__O($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_com$iz2use$react$style$WithThemedSupport$RichAttr$$v))
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4.prototype.light__Lscalacss_internal_AV = (function() {
  return $as_Lscalacss_internal_AV($n($as_F1($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_f$1).apply__O__O(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_lightVersion$2))).apply__O__O($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_com$iz2use$react$style$WithThemedSupport$RichAttr$$v))
});
var $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4 = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4: 0
}, false, "com.iz2use.react.style.package$WithThemedSupport$RichAttr$$anon$4", {
  Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4: 1,
  O: 1,
  Lcom_iz2use_react_style_package$ToThemedStyle: 1
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4.prototype.$classData = $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4;
/** @constructor */
function $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6(outer, colors$2, opacity$2) {
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_$outer = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_colors$2 = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_opacity$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_$outer = outer
  };
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_colors$2 = colors$2;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_opacity$2 = opacity$2
}
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6.prototype.constructor = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6.prototype = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6.prototype;
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6.prototype.light__Lscalacss_internal_AV = (function() {
  $n($n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_com$iz2use$react$style$WithThemedSupport$RichAttr$$v;
  var value = $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_colors$2).Lcom_iz2use_react_style_ThemeColor__f_default).apply__Lcom_iz2use_react_style_OpacityLevel__Lscalacss_internal_DslBase__Lscalacss_internal_ValueT(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_opacity$2, $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  return new $c_Lscalacss_internal_AV(a, $n(value).Lscalacss_internal_ValueT__f_value)
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6.prototype.dark__Lscalacss_internal_AV = (function() {
  $n($n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_com$iz2use$react$style$WithThemedSupport$RichAttr$$v;
  var value = $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_colors$2).Lcom_iz2use_react_style_ThemeColor__f_inverse).apply__Lcom_iz2use_react_style_OpacityLevel__Lscalacss_internal_DslBase__Lscalacss_internal_ValueT(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_opacity$2, $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  return new $c_Lscalacss_internal_AV(a, $n(value).Lscalacss_internal_ValueT__f_value)
});
var $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6 = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6: 0
}, false, "com.iz2use.react.style.package$WithThemedSupport$RichAttr$$anon$6", {
  Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6: 1,
  O: 1,
  Lcom_iz2use_react_style_package$ToThemedStyle: 1
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6.prototype.$classData = $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6;
/** @constructor */
function $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(outer, f$2, colors$3, opacity$3) {
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_$outer = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_f$2 = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_colors$3 = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_opacity$3 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_$outer = outer
  };
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_f$2 = f$2;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_colors$3 = colors$3;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_opacity$3 = opacity$3
}
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7.prototype.constructor = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7.prototype = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7.prototype;
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7.prototype.light__Lscalacss_internal_AV = (function() {
  return $as_Lscalacss_internal_AV($n($as_F1($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_f$2).apply__O__O($n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_colors$3).Lcom_iz2use_react_style_ThemeColor__f_default).apply__Lcom_iz2use_react_style_OpacityLevel__Lscalacss_internal_DslBase__Lscalacss_internal_ValueT(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_opacity$3, $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$())))).apply__O__O($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_com$iz2use$react$style$WithThemedSupport$RichAttr$$v))
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7.prototype.dark__Lscalacss_internal_AV = (function() {
  return $as_Lscalacss_internal_AV($n($as_F1($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_f$2).apply__O__O($n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_colors$3).Lcom_iz2use_react_style_ThemeColor__f_inverse).apply__Lcom_iz2use_react_style_OpacityLevel__Lscalacss_internal_DslBase__Lscalacss_internal_ValueT(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_opacity$3, $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$())))).apply__O__O($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr__f_com$iz2use$react$style$WithThemedSupport$RichAttr$$v))
});
var $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7 = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7: 0
}, false, "com.iz2use.react.style.package$WithThemedSupport$RichAttr$$anon$7", {
  Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7: 1,
  O: 1,
  Lcom_iz2use_react_style_package$ToThemedStyle: 1
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7.prototype.$classData = $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7;
/** @constructor */
function $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2(outer, darkVersion$1, lightVersion$1) {
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_$outer = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_darkVersion$1 = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_lightVersion$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_$outer = outer
  };
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_darkVersion$1 = darkVersion$1;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_lightVersion$1 = lightVersion$1
}
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2.prototype = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2.prototype;
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2.prototype.dark__Lscalacss_internal_AV = (function() {
  var $$x1 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n($n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_com$iz2use$react$style$WithThemedSupport$RichTypedAttrBase$$v;
  return $n($$x1).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__Lscalacss_internal_ValueT__Lscalacss_internal_AV(a, this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_darkVersion$1)
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2.prototype.light__Lscalacss_internal_AV = (function() {
  var $$x1 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n($n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_com$iz2use$react$style$WithThemedSupport$RichTypedAttrBase$$v;
  return $n($$x1).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__Lscalacss_internal_ValueT__Lscalacss_internal_AV(a, this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2__f_lightVersion$1)
});
var $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2: 0
}, false, "com.iz2use.react.style.package$WithThemedSupport$RichTypedAttrBase$$anon$2", {
  Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_style_package$ToThemedStyle: 1
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(outer, colors$1, opacity$1) {
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_$outer = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_colors$1 = null;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_opacity$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_$outer = outer
  };
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_colors$1 = colors$1;
  this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_opacity$1 = opacity$1
}
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3.prototype.constructor = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3.prototype = $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3.prototype;
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3.prototype.light__Lscalacss_internal_AV = (function() {
  var $$x1 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n($n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_com$iz2use$react$style$WithThemedSupport$RichTypedAttrBase$$v;
  return $n($$x1).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__Lscalacss_internal_ValueT__Lscalacss_internal_AV(a, $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_colors$1).Lcom_iz2use_react_style_ThemeColor__f_default).apply__Lcom_iz2use_react_style_OpacityLevel__Lscalacss_internal_DslBase__Lscalacss_internal_ValueT(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_opacity$1, $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()))
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3.prototype.dark__Lscalacss_internal_AV = (function() {
  var $$x1 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n($n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_com$iz2use$react$style$WithThemedSupport$RichTypedAttrBase$$v;
  return $n($$x1).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__Lscalacss_internal_ValueT__Lscalacss_internal_AV(a, $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_colors$1).Lcom_iz2use_react_style_ThemeColor__f_inverse).apply__Lcom_iz2use_react_style_OpacityLevel__Lscalacss_internal_DslBase__Lscalacss_internal_ValueT(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_opacity$1, $n($n(this.Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3__f_$outer).Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase__f_$outer).dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()))
});
var $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3: 0
}, false, "com.iz2use.react.style.package$WithThemedSupport$RichTypedAttrBase$$anon$3", {
  Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_style_package$ToThemedStyle: 1
});
$c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3.prototype.$classData = $d_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3;
/** @constructor */
function $c_Ldiode_Action$aType$() {
  /*<skip>*/
}
$c_Ldiode_Action$aType$.prototype = new $h_O();
$c_Ldiode_Action$aType$.prototype.constructor = $c_Ldiode_Action$aType$;
/** @constructor */
function $h_Ldiode_Action$aType$() {
  /*<skip>*/
}
$h_Ldiode_Action$aType$.prototype = $c_Ldiode_Action$aType$.prototype;
var $d_Ldiode_Action$aType$ = new $TypeData().initClass({
  Ldiode_Action$aType$: 0
}, false, "diode.Action$aType$", {
  Ldiode_Action$aType$: 1,
  O: 1,
  Ldiode_ActionType: 1
});
$c_Ldiode_Action$aType$.prototype.$classData = $d_Ldiode_Action$aType$;
var $n_Ldiode_Action$aType$;
function $m_Ldiode_Action$aType$() {
  if ((!$n_Ldiode_Action$aType$)) {
    $n_Ldiode_Action$aType$ = new $c_Ldiode_Action$aType$()
  };
  return $n_Ldiode_Action$aType$
}
function $as_Ldiode_ActionBatch(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ActionBatch"))
}
function $isArrayOf_Ldiode_ActionBatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ActionBatch)))
}
function $asArrayOf_Ldiode_ActionBatch(obj, depth) {
  return (($isArrayOf_Ldiode_ActionBatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ActionBatch;", depth))
}
function $ct_Ldiode_EffectBase__s_concurrent_ExecutionContext__($thiz, ec) {
  $thiz.Ldiode_EffectBase__f_ec = ec;
  return $thiz
}
/** @constructor */
function $c_Ldiode_EffectBase() {
  this.Ldiode_EffectBase__f_ec = null
}
$c_Ldiode_EffectBase.prototype = new $h_O();
$c_Ldiode_EffectBase.prototype.constructor = $c_Ldiode_EffectBase;
/** @constructor */
function $h_Ldiode_EffectBase() {
  /*<skip>*/
}
$h_Ldiode_EffectBase.prototype = $c_Ldiode_EffectBase.prototype;
$c_Ldiode_EffectBase.prototype.$plus__Ldiode_Effect__Ldiode_EffectSet = (function(that) {
  var this$4 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [that];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return new $c_Ldiode_EffectSet(this, this$4.from__sc_IterableOnce__sci_Set(elems), this.Ldiode_EffectBase__f_ec)
});
function $as_Ldiode_EffectBase(obj) {
  return (((obj instanceof $c_Ldiode_EffectBase) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.EffectBase"))
}
function $isArrayOf_Ldiode_EffectBase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_EffectBase)))
}
function $asArrayOf_Ldiode_EffectBase(obj, depth) {
  return (($isArrayOf_Ldiode_EffectBase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.EffectBase;", depth))
}
function $p_Ldiode_FastEq$__AnyRefEq$lzycompute$1__V($thiz) {
  if (($m_Ldiode_FastEq$().Ldiode_FastEq$__f_AnyRefEq$module === null)) {
    $m_Ldiode_FastEq$().Ldiode_FastEq$__f_AnyRefEq$module = new $c_Ldiode_FastEqLowPri$AnyRefEq$($thiz)
  }
}
/** @constructor */
function $c_Ldiode_FastEq$() {
  this.Ldiode_FastEq$__f_AnyRefEq$module = null
}
$c_Ldiode_FastEq$.prototype = new $h_O();
$c_Ldiode_FastEq$.prototype.constructor = $c_Ldiode_FastEq$;
/** @constructor */
function $h_Ldiode_FastEq$() {
  /*<skip>*/
}
$h_Ldiode_FastEq$.prototype = $c_Ldiode_FastEq$.prototype;
$c_Ldiode_FastEq$.prototype.AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$ = (function() {
  if (($m_Ldiode_FastEq$().Ldiode_FastEq$__f_AnyRefEq$module === null)) {
    $p_Ldiode_FastEq$__AnyRefEq$lzycompute$1__V(this)
  };
  return $m_Ldiode_FastEq$().Ldiode_FastEq$__f_AnyRefEq$module
});
var $d_Ldiode_FastEq$ = new $TypeData().initClass({
  Ldiode_FastEq$: 0
}, false, "diode.FastEq$", {
  Ldiode_FastEq$: 1,
  O: 1,
  Ldiode_FastEqLowPri: 1
});
$c_Ldiode_FastEq$.prototype.$classData = $d_Ldiode_FastEq$;
var $n_Ldiode_FastEq$;
function $m_Ldiode_FastEq$() {
  if ((!$n_Ldiode_FastEq$)) {
    $n_Ldiode_FastEq$ = new $c_Ldiode_FastEq$()
  };
  return $n_Ldiode_FastEq$
}
/** @constructor */
function $c_Ldiode_FastEqLowPri$AnyRefEq$(outer) {
  /*<skip>*/
}
$c_Ldiode_FastEqLowPri$AnyRefEq$.prototype = new $h_O();
$c_Ldiode_FastEqLowPri$AnyRefEq$.prototype.constructor = $c_Ldiode_FastEqLowPri$AnyRefEq$;
/** @constructor */
function $h_Ldiode_FastEqLowPri$AnyRefEq$() {
  /*<skip>*/
}
$h_Ldiode_FastEqLowPri$AnyRefEq$.prototype = $c_Ldiode_FastEqLowPri$AnyRefEq$.prototype;
$c_Ldiode_FastEqLowPri$AnyRefEq$.prototype.eqv__O__O__Z = (function(a, b) {
  return Object.is(a, b)
});
var $d_Ldiode_FastEqLowPri$AnyRefEq$ = new $TypeData().initClass({
  Ldiode_FastEqLowPri$AnyRefEq$: 0
}, false, "diode.FastEqLowPri$AnyRefEq$", {
  Ldiode_FastEqLowPri$AnyRefEq$: 1,
  O: 1,
  Ldiode_FastEq: 1
});
$c_Ldiode_FastEqLowPri$AnyRefEq$.prototype.$classData = $d_Ldiode_FastEqLowPri$AnyRefEq$;
function $is_Ldiode_ModelR(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ldiode_ModelR)))
}
function $as_Ldiode_ModelR(obj) {
  return (($is_Ldiode_ModelR(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ModelR"))
}
function $isArrayOf_Ldiode_ModelR(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ModelR)))
}
function $asArrayOf_Ldiode_ModelR(obj, depth) {
  return (($isArrayOf_Ldiode_ModelR(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ModelR;", depth))
}
/** @constructor */
function $c_Ldiode_data_Pot$() {
  /*<skip>*/
}
$c_Ldiode_data_Pot$.prototype = new $h_O();
$c_Ldiode_data_Pot$.prototype.constructor = $c_Ldiode_data_Pot$;
/** @constructor */
function $h_Ldiode_data_Pot$() {
  /*<skip>*/
}
$h_Ldiode_data_Pot$.prototype = $c_Ldiode_data_Pot$.prototype;
$c_Ldiode_data_Pot$.prototype.fromOption__s_Option__Ldiode_data_Pot = (function(a) {
  if ((a instanceof $c_s_Some)) {
    var x2 = $as_s_Some(a);
    var x = $n(x2).s_Some__f_value;
    return new $c_Ldiode_data_Ready(x)
  } else {
    var x$2 = $m_s_None$();
    if ((x$2 === a)) {
      return $m_Ldiode_data_Empty$()
    } else {
      throw new $c_s_MatchError(a)
    }
  }
});
var $d_Ldiode_data_Pot$ = new $TypeData().initClass({
  Ldiode_data_Pot$: 0
}, false, "diode.data.Pot$", {
  Ldiode_data_Pot$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_data_Pot$.prototype.$classData = $d_Ldiode_data_Pot$;
var $n_Ldiode_data_Pot$;
function $m_Ldiode_data_Pot$() {
  if ((!$n_Ldiode_data_Pot$)) {
    $n_Ldiode_data_Pot$ = new $c_Ldiode_data_Pot$()
  };
  return $n_Ldiode_data_Pot$
}
/** @constructor */
function $c_Ldiode_package$AnyAction$aType$() {
  /*<skip>*/
}
$c_Ldiode_package$AnyAction$aType$.prototype = new $h_O();
$c_Ldiode_package$AnyAction$aType$.prototype.constructor = $c_Ldiode_package$AnyAction$aType$;
/** @constructor */
function $h_Ldiode_package$AnyAction$aType$() {
  /*<skip>*/
}
$h_Ldiode_package$AnyAction$aType$.prototype = $c_Ldiode_package$AnyAction$aType$.prototype;
var $d_Ldiode_package$AnyAction$aType$ = new $TypeData().initClass({
  Ldiode_package$AnyAction$aType$: 0
}, false, "diode.package$AnyAction$aType$", {
  Ldiode_package$AnyAction$aType$: 1,
  O: 1,
  Ldiode_ActionType: 1
});
$c_Ldiode_package$AnyAction$aType$.prototype.$classData = $d_Ldiode_package$AnyAction$aType$;
var $n_Ldiode_package$AnyAction$aType$;
function $m_Ldiode_package$AnyAction$aType$() {
  if ((!$n_Ldiode_package$AnyAction$aType$)) {
    $n_Ldiode_package$AnyAction$aType$ = new $c_Ldiode_package$AnyAction$aType$()
  };
  return $n_Ldiode_package$AnyAction$aType$
}
/** @constructor */
function $c_Ldiode_react_ReactConnector$aType$1$(outer) {
  /*<skip>*/
}
$c_Ldiode_react_ReactConnector$aType$1$.prototype = new $h_O();
$c_Ldiode_react_ReactConnector$aType$1$.prototype.constructor = $c_Ldiode_react_ReactConnector$aType$1$;
/** @constructor */
function $h_Ldiode_react_ReactConnector$aType$1$() {
  /*<skip>*/
}
$h_Ldiode_react_ReactConnector$aType$1$.prototype = $c_Ldiode_react_ReactConnector$aType$1$.prototype;
function $as_Ldiode_react_ReactConnector$aType$1$(obj) {
  return (((obj instanceof $c_Ldiode_react_ReactConnector$aType$1$) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.react.ReactConnector$aType$1$"))
}
function $isArrayOf_Ldiode_react_ReactConnector$aType$1$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_react_ReactConnector$aType$1$)))
}
function $asArrayOf_Ldiode_react_ReactConnector$aType$1$(obj, depth) {
  return (($isArrayOf_Ldiode_react_ReactConnector$aType$1$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.react.ReactConnector$aType$1$;", depth))
}
var $d_Ldiode_react_ReactConnector$aType$1$ = new $TypeData().initClass({
  Ldiode_react_ReactConnector$aType$1$: 0
}, false, "diode.react.ReactConnector$aType$1$", {
  Ldiode_react_ReactConnector$aType$1$: 1,
  O: 1,
  Ldiode_ActionType: 1
});
$c_Ldiode_react_ReactConnector$aType$1$.prototype.$classData = $d_Ldiode_react_ReactConnector$aType$1$;
/** @constructor */
function $c_Ldiode_util_RunAfterJS() {
  /*<skip>*/
}
$c_Ldiode_util_RunAfterJS.prototype = new $h_O();
$c_Ldiode_util_RunAfterJS.prototype.constructor = $c_Ldiode_util_RunAfterJS;
/** @constructor */
function $h_Ldiode_util_RunAfterJS() {
  /*<skip>*/
}
$h_Ldiode_util_RunAfterJS.prototype = $c_Ldiode_util_RunAfterJS.prototype;
$c_Ldiode_util_RunAfterJS.prototype.runAfter__s_concurrent_duration_FiniteDuration__F0__s_concurrent_Future = (function(delay, f) {
  var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  $m_sjs_js_timers_package$().setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle(delay, new $c_sjsr_AnonFunction0((() => {
    var value = $n(f).apply__O();
    $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p, value)
  })));
  return p
});
/** @constructor */
function $c_Leu_timepit_refined_api_RefType$() {
  this.Leu_timepit_refined_api_RefType$__f_refinedRefType = null;
  $n_Leu_timepit_refined_api_RefType$ = this;
  this.Leu_timepit_refined_api_RefType$__f_refinedRefType = new $c_Leu_timepit_refined_api_RefType$$anon$1();
  new $c_Leu_timepit_refined_api_RefType$$anon$2()
}
$c_Leu_timepit_refined_api_RefType$.prototype = new $h_O();
$c_Leu_timepit_refined_api_RefType$.prototype.constructor = $c_Leu_timepit_refined_api_RefType$;
/** @constructor */
function $h_Leu_timepit_refined_api_RefType$() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_RefType$.prototype = $c_Leu_timepit_refined_api_RefType$.prototype;
var $d_Leu_timepit_refined_api_RefType$ = new $TypeData().initClass({
  Leu_timepit_refined_api_RefType$: 0
}, false, "eu.timepit.refined.api.RefType$", {
  Leu_timepit_refined_api_RefType$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_RefType$.prototype.$classData = $d_Leu_timepit_refined_api_RefType$;
var $n_Leu_timepit_refined_api_RefType$;
function $m_Leu_timepit_refined_api_RefType$() {
  if ((!$n_Leu_timepit_refined_api_RefType$)) {
    $n_Leu_timepit_refined_api_RefType$ = new $c_Leu_timepit_refined_api_RefType$()
  };
  return $n_Leu_timepit_refined_api_RefType$
}
/** @constructor */
function $c_Leu_timepit_refined_api_Refined(value) {
  this.Leu_timepit_refined_api_Refined__f_value = null;
  this.Leu_timepit_refined_api_Refined__f_value = value
}
$c_Leu_timepit_refined_api_Refined.prototype = new $h_O();
$c_Leu_timepit_refined_api_Refined.prototype.constructor = $c_Leu_timepit_refined_api_Refined;
/** @constructor */
function $h_Leu_timepit_refined_api_Refined() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_Refined.prototype = $c_Leu_timepit_refined_api_Refined.prototype;
$c_Leu_timepit_refined_api_Refined.prototype.toString__T = (function() {
  var this$ = this.Leu_timepit_refined_api_Refined__f_value;
  return $dp_toString__T($n(this$))
});
$c_Leu_timepit_refined_api_Refined.prototype.hashCode__I = (function() {
  var this$ = this.Leu_timepit_refined_api_Refined__f_value;
  return $dp_hashCode__I($n(this$))
});
$c_Leu_timepit_refined_api_Refined.prototype.equals__O__Z = (function(x$1) {
  return $m_Leu_timepit_refined_api_Refined$().equals$extension__O__O__Z(this.Leu_timepit_refined_api_Refined__f_value, x$1)
});
function $as_Leu_timepit_refined_api_Refined(obj) {
  return (((obj instanceof $c_Leu_timepit_refined_api_Refined) || (obj === null)) ? obj : $throwClassCastException(obj, "eu.timepit.refined.api.Refined"))
}
function $isArrayOf_Leu_timepit_refined_api_Refined(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Leu_timepit_refined_api_Refined)))
}
function $asArrayOf_Leu_timepit_refined_api_Refined(obj, depth) {
  return (($isArrayOf_Leu_timepit_refined_api_Refined(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Leu.timepit.refined.api.Refined;", depth))
}
var $d_Leu_timepit_refined_api_Refined = new $TypeData().initClass({
  Leu_timepit_refined_api_Refined: 0
}, false, "eu.timepit.refined.api.Refined", {
  Leu_timepit_refined_api_Refined: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_Refined.prototype.$classData = $d_Leu_timepit_refined_api_Refined;
/** @constructor */
function $c_Leu_timepit_refined_api_Refined$() {
  /*<skip>*/
}
$c_Leu_timepit_refined_api_Refined$.prototype = new $h_O();
$c_Leu_timepit_refined_api_Refined$.prototype.constructor = $c_Leu_timepit_refined_api_Refined$;
/** @constructor */
function $h_Leu_timepit_refined_api_Refined$() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_Refined$.prototype = $c_Leu_timepit_refined_api_Refined$.prototype;
$c_Leu_timepit_refined_api_Refined$.prototype.equals$extension__O__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Leu_timepit_refined_api_Refined)) {
    var Refined$1 = ((x$1 === null) ? null : $n($as_Leu_timepit_refined_api_Refined(x$1)).Leu_timepit_refined_api_Refined__f_value);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this$, Refined$1)
  } else {
    return false
  }
});
var $d_Leu_timepit_refined_api_Refined$ = new $TypeData().initClass({
  Leu_timepit_refined_api_Refined$: 0
}, false, "eu.timepit.refined.api.Refined$", {
  Leu_timepit_refined_api_Refined$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_Refined$.prototype.$classData = $d_Leu_timepit_refined_api_Refined$;
var $n_Leu_timepit_refined_api_Refined$;
function $m_Leu_timepit_refined_api_Refined$() {
  if ((!$n_Leu_timepit_refined_api_Refined$)) {
    $n_Leu_timepit_refined_api_Refined$ = new $c_Leu_timepit_refined_api_Refined$()
  };
  return $n_Leu_timepit_refined_api_Refined$
}
/** @constructor */
function $c_Leu_timepit_refined_api_Result$() {
  /*<skip>*/
}
$c_Leu_timepit_refined_api_Result$.prototype = new $h_O();
$c_Leu_timepit_refined_api_Result$.prototype.constructor = $c_Leu_timepit_refined_api_Result$;
/** @constructor */
function $h_Leu_timepit_refined_api_Result$() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_Result$.prototype = $c_Leu_timepit_refined_api_Result$.prototype;
$c_Leu_timepit_refined_api_Result$.prototype.fromBoolean__Z__O__Leu_timepit_refined_api_Result = (function(b, detail) {
  return (b ? new $c_Leu_timepit_refined_api_Passed(detail) : new $c_Leu_timepit_refined_api_Failed(detail))
});
var $d_Leu_timepit_refined_api_Result$ = new $TypeData().initClass({
  Leu_timepit_refined_api_Result$: 0
}, false, "eu.timepit.refined.api.Result$", {
  Leu_timepit_refined_api_Result$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_Result$.prototype.$classData = $d_Leu_timepit_refined_api_Result$;
var $n_Leu_timepit_refined_api_Result$;
function $m_Leu_timepit_refined_api_Result$() {
  if ((!$n_Leu_timepit_refined_api_Result$)) {
    $n_Leu_timepit_refined_api_Result$ = new $c_Leu_timepit_refined_api_Result$()
  };
  return $n_Leu_timepit_refined_api_Result$
}
function $f_Leu_timepit_refined_api_Validate__showResult__O__Leu_timepit_refined_api_Result__T($thiz, t, r) {
  return $m_Leu_timepit_refined_internal_Resources$().predicateResultDetailDot__Leu_timepit_refined_api_Result__T__T(r, $thiz.showExpr__O__T(t))
}
/** @constructor */
function $c_Leu_timepit_refined_api_Validate$() {
  /*<skip>*/
}
$c_Leu_timepit_refined_api_Validate$.prototype = new $h_O();
$c_Leu_timepit_refined_api_Validate$.prototype.constructor = $c_Leu_timepit_refined_api_Validate$;
/** @constructor */
function $h_Leu_timepit_refined_api_Validate$() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_Validate$.prototype = $c_Leu_timepit_refined_api_Validate$.prototype;
$c_Leu_timepit_refined_api_Validate$.prototype.fromPredicate__F1__F1__O__Leu_timepit_refined_api_Validate = (function(f, showExpr, p) {
  return new $c_Leu_timepit_refined_api_Validate$$anon$3(f, p, showExpr)
});
var $d_Leu_timepit_refined_api_Validate$ = new $TypeData().initClass({
  Leu_timepit_refined_api_Validate$: 0
}, false, "eu.timepit.refined.api.Validate$", {
  Leu_timepit_refined_api_Validate$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_Validate$.prototype.$classData = $d_Leu_timepit_refined_api_Validate$;
var $n_Leu_timepit_refined_api_Validate$;
function $m_Leu_timepit_refined_api_Validate$() {
  if ((!$n_Leu_timepit_refined_api_Validate$)) {
    $n_Leu_timepit_refined_api_Validate$ = new $c_Leu_timepit_refined_api_Validate$()
  };
  return $n_Leu_timepit_refined_api_Validate$
}
/** @constructor */
function $c_Leu_timepit_refined_numeric$Less$() {
  /*<skip>*/
}
$c_Leu_timepit_refined_numeric$Less$.prototype = new $h_O();
$c_Leu_timepit_refined_numeric$Less$.prototype.constructor = $c_Leu_timepit_refined_numeric$Less$;
/** @constructor */
function $h_Leu_timepit_refined_numeric$Less$() {
  /*<skip>*/
}
$h_Leu_timepit_refined_numeric$Less$.prototype = $c_Leu_timepit_refined_numeric$Less$.prototype;
$c_Leu_timepit_refined_numeric$Less$.prototype.lessValidate__Leu_timepit_refined_internal_WitnessAs__s_math_Numeric__Leu_timepit_refined_api_Validate = (function(wn, nt) {
  return $m_Leu_timepit_refined_api_Validate$().fromPredicate__F1__F1__O__Leu_timepit_refined_api_Validate(new $c_sjsr_AnonFunction1(((t$2) => $n(nt).lt__O__O__Z(t$2, $n(wn).Leu_timepit_refined_internal_WitnessAs__f_snd))), new $c_sjsr_AnonFunction1(((t$3$2) => (((("(" + t$3$2) + " < ") + $n(wn).Leu_timepit_refined_internal_WitnessAs__f_snd) + ")"))), new $c_Leu_timepit_refined_numeric$Less($n(wn).Leu_timepit_refined_internal_WitnessAs__f_fst))
});
var $d_Leu_timepit_refined_numeric$Less$ = new $TypeData().initClass({
  Leu_timepit_refined_numeric$Less$: 0
}, false, "eu.timepit.refined.numeric$Less$", {
  Leu_timepit_refined_numeric$Less$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_numeric$Less$.prototype.$classData = $d_Leu_timepit_refined_numeric$Less$;
var $n_Leu_timepit_refined_numeric$Less$;
function $m_Leu_timepit_refined_numeric$Less$() {
  if ((!$n_Leu_timepit_refined_numeric$Less$)) {
    $n_Leu_timepit_refined_numeric$Less$ = new $c_Leu_timepit_refined_numeric$Less$()
  };
  return $n_Leu_timepit_refined_numeric$Less$
}
/** @constructor */
function $c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$(outer) {
  /*<skip>*/
}
$c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$.prototype = new $h_O();
$c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$.prototype.constructor = $c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$;
/** @constructor */
function $h_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$() {
  /*<skip>*/
}
$h_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$.prototype = $c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$.prototype;
var $d_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$ = new $TypeData().initClass({
  Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$: 0
}, false, "fastparse.Implicits$LowPriOptioner$GenericOptionerImplicit0$", {
  Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$: 1,
  O: 1,
  Lfastparse_Implicits$Optioner: 1
});
$c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$.prototype.$classData = $d_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$;
/** @constructor */
function $c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$(outer) {
  /*<skip>*/
}
$c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$.prototype = new $h_O();
$c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$.prototype.constructor = $c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$;
/** @constructor */
function $h_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$() {
  /*<skip>*/
}
$h_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$.prototype = $c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$.prototype;
$c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$.prototype.result__O__O = (function(acc) {
  var acc$1 = $as_scm_Buffer(acc);
  var this$1 = $n(acc$1);
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$1)
});
var $d_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$ = new $TypeData().initClass({
  Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$: 0
}, false, "fastparse.Implicits$LowPriRepeater$GenericRepeatedImplicit0$", {
  Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$: 1,
  O: 1,
  Lfastparse_Implicits$Repeater: 1
});
$c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$.prototype.$classData = $d_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$;
/** @constructor */
function $c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$(outer) {
  /*<skip>*/
}
$c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$.prototype = new $h_O();
$c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$.prototype.constructor = $c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$;
/** @constructor */
function $h_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$() {
  /*<skip>*/
}
$h_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$.prototype = $c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$.prototype;
$c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$.prototype.apply__O__O__O = (function(t, v) {
  $as_jl_Void(v);
  return t
});
var $d_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$ = new $TypeData().initClass({
  Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$: 0
}, false, "fastparse.Implicits$LowPriSequencer$UnitSequencer0$", {
  Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$: 1,
  O: 1,
  Lfastparse_Implicits$Sequencer: 1
});
$c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$.prototype.$classData = $d_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$;
function $p_Lfastparse_Implicits$Optioner$__GenericOptionerImplicit0$lzycompute$1__V($thiz) {
  if (($m_Lfastparse_Implicits$Optioner$().Lfastparse_Implicits$Optioner$__f_GenericOptionerImplicit0$module === null)) {
    $m_Lfastparse_Implicits$Optioner$().Lfastparse_Implicits$Optioner$__f_GenericOptionerImplicit0$module = new $c_Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$($thiz)
  }
}
/** @constructor */
function $c_Lfastparse_Implicits$Optioner$() {
  this.Lfastparse_Implicits$Optioner$__f_GenericOptionerImplicit0$module = null
}
$c_Lfastparse_Implicits$Optioner$.prototype = new $h_O();
$c_Lfastparse_Implicits$Optioner$.prototype.constructor = $c_Lfastparse_Implicits$Optioner$;
/** @constructor */
function $h_Lfastparse_Implicits$Optioner$() {
  /*<skip>*/
}
$h_Lfastparse_Implicits$Optioner$.prototype = $c_Lfastparse_Implicits$Optioner$.prototype;
$c_Lfastparse_Implicits$Optioner$.prototype.GenericOptionerImplicit0__Lfastparse_Implicits$LowPriOptioner$GenericOptionerImplicit0$ = (function() {
  if (($m_Lfastparse_Implicits$Optioner$().Lfastparse_Implicits$Optioner$__f_GenericOptionerImplicit0$module === null)) {
    $p_Lfastparse_Implicits$Optioner$__GenericOptionerImplicit0$lzycompute$1__V(this)
  };
  return $m_Lfastparse_Implicits$Optioner$().Lfastparse_Implicits$Optioner$__f_GenericOptionerImplicit0$module
});
var $d_Lfastparse_Implicits$Optioner$ = new $TypeData().initClass({
  Lfastparse_Implicits$Optioner$: 0
}, false, "fastparse.Implicits$Optioner$", {
  Lfastparse_Implicits$Optioner$: 1,
  O: 1,
  Lfastparse_Implicits$LowPriOptioner: 1
});
$c_Lfastparse_Implicits$Optioner$.prototype.$classData = $d_Lfastparse_Implicits$Optioner$;
var $n_Lfastparse_Implicits$Optioner$;
function $m_Lfastparse_Implicits$Optioner$() {
  if ((!$n_Lfastparse_Implicits$Optioner$)) {
    $n_Lfastparse_Implicits$Optioner$ = new $c_Lfastparse_Implicits$Optioner$()
  };
  return $n_Lfastparse_Implicits$Optioner$
}
function $p_Lfastparse_Implicits$Repeater$__GenericRepeatedImplicit0$lzycompute$1__V($thiz) {
  if (($m_Lfastparse_Implicits$Repeater$().Lfastparse_Implicits$Repeater$__f_GenericRepeatedImplicit0$module === null)) {
    $m_Lfastparse_Implicits$Repeater$().Lfastparse_Implicits$Repeater$__f_GenericRepeatedImplicit0$module = new $c_Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$($thiz)
  }
}
/** @constructor */
function $c_Lfastparse_Implicits$Repeater$() {
  this.Lfastparse_Implicits$Repeater$__f_GenericRepeatedImplicit0$module = null
}
$c_Lfastparse_Implicits$Repeater$.prototype = new $h_O();
$c_Lfastparse_Implicits$Repeater$.prototype.constructor = $c_Lfastparse_Implicits$Repeater$;
/** @constructor */
function $h_Lfastparse_Implicits$Repeater$() {
  /*<skip>*/
}
$h_Lfastparse_Implicits$Repeater$.prototype = $c_Lfastparse_Implicits$Repeater$.prototype;
$c_Lfastparse_Implicits$Repeater$.prototype.GenericRepeatedImplicit0__Lfastparse_Implicits$LowPriRepeater$GenericRepeatedImplicit0$ = (function() {
  if (($m_Lfastparse_Implicits$Repeater$().Lfastparse_Implicits$Repeater$__f_GenericRepeatedImplicit0$module === null)) {
    $p_Lfastparse_Implicits$Repeater$__GenericRepeatedImplicit0$lzycompute$1__V(this)
  };
  return $m_Lfastparse_Implicits$Repeater$().Lfastparse_Implicits$Repeater$__f_GenericRepeatedImplicit0$module
});
var $d_Lfastparse_Implicits$Repeater$ = new $TypeData().initClass({
  Lfastparse_Implicits$Repeater$: 0
}, false, "fastparse.Implicits$Repeater$", {
  Lfastparse_Implicits$Repeater$: 1,
  O: 1,
  Lfastparse_Implicits$LowPriRepeater: 1
});
$c_Lfastparse_Implicits$Repeater$.prototype.$classData = $d_Lfastparse_Implicits$Repeater$;
var $n_Lfastparse_Implicits$Repeater$;
function $m_Lfastparse_Implicits$Repeater$() {
  if ((!$n_Lfastparse_Implicits$Repeater$)) {
    $n_Lfastparse_Implicits$Repeater$ = new $c_Lfastparse_Implicits$Repeater$()
  };
  return $n_Lfastparse_Implicits$Repeater$
}
/** @constructor */
function $c_Lfastparse_Implicits$Repeater$UnitRepeater$() {
  /*<skip>*/
}
$c_Lfastparse_Implicits$Repeater$UnitRepeater$.prototype = new $h_O();
$c_Lfastparse_Implicits$Repeater$UnitRepeater$.prototype.constructor = $c_Lfastparse_Implicits$Repeater$UnitRepeater$;
/** @constructor */
function $h_Lfastparse_Implicits$Repeater$UnitRepeater$() {
  /*<skip>*/
}
$h_Lfastparse_Implicits$Repeater$UnitRepeater$.prototype = $c_Lfastparse_Implicits$Repeater$UnitRepeater$.prototype;
$c_Lfastparse_Implicits$Repeater$UnitRepeater$.prototype.result__O__O = (function(acc) {
  $as_jl_Void(acc)
});
var $d_Lfastparse_Implicits$Repeater$UnitRepeater$ = new $TypeData().initClass({
  Lfastparse_Implicits$Repeater$UnitRepeater$: 0
}, false, "fastparse.Implicits$Repeater$UnitRepeater$", {
  Lfastparse_Implicits$Repeater$UnitRepeater$: 1,
  O: 1,
  Lfastparse_Implicits$Repeater: 1
});
$c_Lfastparse_Implicits$Repeater$UnitRepeater$.prototype.$classData = $d_Lfastparse_Implicits$Repeater$UnitRepeater$;
var $n_Lfastparse_Implicits$Repeater$UnitRepeater$;
function $m_Lfastparse_Implicits$Repeater$UnitRepeater$() {
  if ((!$n_Lfastparse_Implicits$Repeater$UnitRepeater$)) {
    $n_Lfastparse_Implicits$Repeater$UnitRepeater$ = new $c_Lfastparse_Implicits$Repeater$UnitRepeater$()
  };
  return $n_Lfastparse_Implicits$Repeater$UnitRepeater$
}
/** @constructor */
function $c_Lfastparse_Implicits$Sequencer$NarySequencer(f) {
  this.Lfastparse_Implicits$Sequencer$NarySequencer__f_f = null;
  this.Lfastparse_Implicits$Sequencer$NarySequencer__f_f = f
}
$c_Lfastparse_Implicits$Sequencer$NarySequencer.prototype = new $h_O();
$c_Lfastparse_Implicits$Sequencer$NarySequencer.prototype.constructor = $c_Lfastparse_Implicits$Sequencer$NarySequencer;
/** @constructor */
function $h_Lfastparse_Implicits$Sequencer$NarySequencer() {
  /*<skip>*/
}
$h_Lfastparse_Implicits$Sequencer$NarySequencer.prototype = $c_Lfastparse_Implicits$Sequencer$NarySequencer.prototype;
$c_Lfastparse_Implicits$Sequencer$NarySequencer.prototype.apply__O__O__O = (function(t, v) {
  return $n(this.Lfastparse_Implicits$Sequencer$NarySequencer__f_f).apply__O__O__O(t, v)
});
var $d_Lfastparse_Implicits$Sequencer$NarySequencer = new $TypeData().initClass({
  Lfastparse_Implicits$Sequencer$NarySequencer: 0
}, false, "fastparse.Implicits$Sequencer$NarySequencer", {
  Lfastparse_Implicits$Sequencer$NarySequencer: 1,
  O: 1,
  Lfastparse_Implicits$Sequencer: 1
});
$c_Lfastparse_Implicits$Sequencer$NarySequencer.prototype.$classData = $d_Lfastparse_Implicits$Sequencer$NarySequencer;
/** @constructor */
function $c_Lfastparse_NoWhitespace$noWhitespaceImplicit$() {
  /*<skip>*/
}
$c_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype = new $h_O();
$c_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype.constructor = $c_Lfastparse_NoWhitespace$noWhitespaceImplicit$;
/** @constructor */
function $h_Lfastparse_NoWhitespace$noWhitespaceImplicit$() {
  /*<skip>*/
}
$h_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype = $c_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype;
$c_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  var ctx = $as_Lfastparse_ParsingRun(v1);
  return $uZ($n(ctx).freshSuccessUnit__Lfastparse_ParsingRun())
});
$c_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype.toString__T = (function() {
  return "<function1>"
});
$c_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype.apply__O__O = (function(v1) {
  var ctx = $as_Lfastparse_ParsingRun(v1);
  return $n(ctx).freshSuccessUnit__Lfastparse_ParsingRun()
});
var $d_Lfastparse_NoWhitespace$noWhitespaceImplicit$ = new $TypeData().initClass({
  Lfastparse_NoWhitespace$noWhitespaceImplicit$: 0
}, false, "fastparse.NoWhitespace$noWhitespaceImplicit$", {
  Lfastparse_NoWhitespace$noWhitespaceImplicit$: 1,
  O: 1,
  F1: 1
});
$c_Lfastparse_NoWhitespace$noWhitespaceImplicit$.prototype.$classData = $d_Lfastparse_NoWhitespace$noWhitespaceImplicit$;
var $n_Lfastparse_NoWhitespace$noWhitespaceImplicit$;
function $m_Lfastparse_NoWhitespace$noWhitespaceImplicit$() {
  if ((!$n_Lfastparse_NoWhitespace$noWhitespaceImplicit$)) {
    $n_Lfastparse_NoWhitespace$noWhitespaceImplicit$ = new $c_Lfastparse_NoWhitespace$noWhitespaceImplicit$()
  };
  return $n_Lfastparse_NoWhitespace$noWhitespaceImplicit$
}
/** @constructor */
function $c_Lfastparse_Parsed$Failure(label, index, extra) {
  this.Lfastparse_Parsed$Failure__f_label = null;
  this.Lfastparse_Parsed$Failure__f_index = 0;
  this.Lfastparse_Parsed$Failure__f_extra = null;
  this.Lfastparse_Parsed$Failure__f_label = label;
  this.Lfastparse_Parsed$Failure__f_index = index;
  this.Lfastparse_Parsed$Failure__f_extra = extra;
  $ct_Lfastparse_Parsed__Z__(this, false)
}
$c_Lfastparse_Parsed$Failure.prototype = new $h_Lfastparse_Parsed();
$c_Lfastparse_Parsed$Failure.prototype.constructor = $c_Lfastparse_Parsed$Failure;
/** @constructor */
function $h_Lfastparse_Parsed$Failure() {
  /*<skip>*/
}
$h_Lfastparse_Parsed$Failure.prototype = $c_Lfastparse_Parsed$Failure.prototype;
$c_Lfastparse_Parsed$Failure.prototype.toString__T = (function() {
  return (("Parsed.Failure(" + this.msg__T()) + ")")
});
$c_Lfastparse_Parsed$Failure.prototype.msg__T = (function() {
  var x1 = this.Lfastparse_Parsed$Failure__f_label;
  if ((x1 === "")) {
    return ((("Position " + $n($n(this.Lfastparse_Parsed$Failure__f_extra).Lfastparse_Parsed$Extra__f_input).prettyIndex__I__T(this.Lfastparse_Parsed$Failure__f_index)) + ", found ") + $m_Lfastparse_Parsed$Failure$().formatTrailing__Lfastparse_ParserInput__I__T($n(this.Lfastparse_Parsed$Failure__f_extra).Lfastparse_Parsed$Extra__f_input, this.Lfastparse_Parsed$Failure__f_index))
  } else {
    var $$x2 = $m_Lfastparse_Parsed$Failure$();
    var $$x1 = $n(this.Lfastparse_Parsed$Failure__f_extra).Lfastparse_Parsed$Extra__f_input;
    $m_sci_List$();
    var y = this.Lfastparse_Parsed$Failure__f_index;
    var array = [$ct_T2__O__O__(new $c_T2(), x1, y)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $n($$x2).formatMsg__Lfastparse_ParserInput__sci_List__I__T($$x1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), this.Lfastparse_Parsed$Failure__f_index)
  }
});
function $as_Lfastparse_Parsed$Failure(obj) {
  return (((obj instanceof $c_Lfastparse_Parsed$Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.Parsed$Failure"))
}
function $isArrayOf_Lfastparse_Parsed$Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_Parsed$Failure)))
}
function $asArrayOf_Lfastparse_Parsed$Failure(obj, depth) {
  return (($isArrayOf_Lfastparse_Parsed$Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.Parsed$Failure;", depth))
}
var $d_Lfastparse_Parsed$Failure = new $TypeData().initClass({
  Lfastparse_Parsed$Failure: 0
}, false, "fastparse.Parsed$Failure", {
  Lfastparse_Parsed$Failure: 1,
  Lfastparse_Parsed: 1,
  O: 1
});
$c_Lfastparse_Parsed$Failure.prototype.$classData = $d_Lfastparse_Parsed$Failure;
/** @constructor */
function $c_Lfastparse_Parsed$TracedFailure$() {
  /*<skip>*/
}
$c_Lfastparse_Parsed$TracedFailure$.prototype = new $h_O();
$c_Lfastparse_Parsed$TracedFailure$.prototype.constructor = $c_Lfastparse_Parsed$TracedFailure$;
/** @constructor */
function $h_Lfastparse_Parsed$TracedFailure$() {
  /*<skip>*/
}
$h_Lfastparse_Parsed$TracedFailure$.prototype = $c_Lfastparse_Parsed$TracedFailure$.prototype;
$c_Lfastparse_Parsed$TracedFailure$.prototype.fromParsingRun__Lfastparse_ParsingRun__Lfastparse_Parsed$TracedFailure = (function(p) {
  $m_s_Predef$().assert__Z__V((!$n(p).Lfastparse_ParsingRun__f_isSuccess));
  var $$x1 = $n(p).Lfastparse_ParsingRun__f_failureTerminalAggregate;
  var rassoc$1 = $n(p).Lfastparse_ParsingRun__f_lastFailureMsg;
  return new $c_Lfastparse_Parsed$TracedFailure($$x1, $n($n(p).Lfastparse_ParsingRun__f_failureGroupAggregate).$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs(rassoc$1), $as_Lfastparse_Parsed$Failure($m_Lfastparse_Parsed$().fromParsingRun__Lfastparse_ParsingRun__Lfastparse_Parsed(p)))
});
var $d_Lfastparse_Parsed$TracedFailure$ = new $TypeData().initClass({
  Lfastparse_Parsed$TracedFailure$: 0
}, false, "fastparse.Parsed$TracedFailure$", {
  Lfastparse_Parsed$TracedFailure$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lfastparse_Parsed$TracedFailure$.prototype.$classData = $d_Lfastparse_Parsed$TracedFailure$;
var $n_Lfastparse_Parsed$TracedFailure$;
function $m_Lfastparse_Parsed$TracedFailure$() {
  if ((!$n_Lfastparse_Parsed$TracedFailure$)) {
    $n_Lfastparse_Parsed$TracedFailure$ = new $c_Lfastparse_Parsed$TracedFailure$()
  };
  return $n_Lfastparse_Parsed$TracedFailure$
}
/** @constructor */
function $c_Lfastparse_ParserInput() {
  /*<skip>*/
}
$c_Lfastparse_ParserInput.prototype = new $h_O();
$c_Lfastparse_ParserInput.prototype.constructor = $c_Lfastparse_ParserInput;
/** @constructor */
function $h_Lfastparse_ParserInput() {
  /*<skip>*/
}
$h_Lfastparse_ParserInput.prototype = $c_Lfastparse_ParserInput.prototype;
function $as_Lfastparse_ParserInput(obj) {
  return (((obj instanceof $c_Lfastparse_ParserInput) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.ParserInput"))
}
function $isArrayOf_Lfastparse_ParserInput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_ParserInput)))
}
function $asArrayOf_Lfastparse_ParserInput(obj, depth) {
  return (($isArrayOf_Lfastparse_ParserInput(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.ParserInput;", depth))
}
/** @constructor */
function $c_Lfastparse_ParserInputSource$fromParserInput(t, conv) {
  this.Lfastparse_ParserInputSource$fromParserInput__f_t = null;
  this.Lfastparse_ParserInputSource$fromParserInput__f_conv = null;
  this.Lfastparse_ParserInputSource$fromParserInput__f_t = t;
  this.Lfastparse_ParserInputSource$fromParserInput__f_conv = conv
}
$c_Lfastparse_ParserInputSource$fromParserInput.prototype = new $h_O();
$c_Lfastparse_ParserInputSource$fromParserInput.prototype.constructor = $c_Lfastparse_ParserInputSource$fromParserInput;
/** @constructor */
function $h_Lfastparse_ParserInputSource$fromParserInput() {
  /*<skip>*/
}
$h_Lfastparse_ParserInputSource$fromParserInput.prototype = $c_Lfastparse_ParserInputSource$fromParserInput.prototype;
var $d_Lfastparse_ParserInputSource$fromParserInput = new $TypeData().initClass({
  Lfastparse_ParserInputSource$fromParserInput: 0
}, false, "fastparse.ParserInputSource$fromParserInput", {
  Lfastparse_ParserInputSource$fromParserInput: 1,
  O: 1,
  Lfastparse_ParserInputSource: 1
});
$c_Lfastparse_ParserInputSource$fromParserInput.prototype.$classData = $d_Lfastparse_ParserInputSource$fromParserInput;
function $f_Lfastparse_SequencerGen__$init$__V($thiz) {
  var f = new $c_sjsr_AnonFunction2(((t$2, d$2) => {
    var t = $as_T2(t$2);
    return new $c_T3($n(t)._1__O(), $n(t)._2__O(), d$2)
  }));
  var x$1 = new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f);
  $thiz.Lfastparse_Implicits$Sequencer$__f_BaseSequencer2 = x$1;
  var f$1 = new $c_sjsr_AnonFunction2(((t$3$2, d$3$2) => {
    var t$3 = $as_T3(t$3$2);
    return new $c_T4($n(t$3).T3__f__1, $n(t$3).T3__f__2, $n(t$3).T3__f__3, d$3$2)
  }));
  var x$1$1 = new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$1);
  $thiz.Lfastparse_Implicits$Sequencer$__f_BaseSequencer3 = x$1$1;
  var f$2 = new $c_sjsr_AnonFunction2(((t$4$2, d$4$2) => {
    var t$4 = $as_T4(t$4$2);
    return new $c_T5($n(t$4).T4__f__1, $n(t$4).T4__f__2, $n(t$4).T4__f__3, $n(t$4).T4__f__4, d$4$2)
  }));
  var x$1$2 = new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$2);
  $thiz.Lfastparse_Implicits$Sequencer$__f_BaseSequencer4 = x$1$2;
  var f$3 = new $c_sjsr_AnonFunction2(((t$5$2, d$5$2) => {
    var t$5 = $as_T5(t$5$2);
    return new $c_T6($n(t$5).T5__f__1, $n(t$5).T5__f__2, $n(t$5).T5__f__3, $n(t$5).T5__f__4, $n(t$5).T5__f__5, d$5$2)
  }));
  var x$1$3 = new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$3);
  $thiz.Lfastparse_Implicits$Sequencer$__f_BaseSequencer5 = x$1$3;
  var f$4 = new $c_sjsr_AnonFunction2(((t$6$2, d$6$2) => {
    var t$6 = $as_T6(t$6$2);
    return new $c_T7($n(t$6).T6__f__1, $n(t$6).T6__f__2, $n(t$6).T6__f__3, $n(t$6).T6__f__4, $n(t$6).T6__f__5, $n(t$6).T6__f__6, d$6$2)
  }));
  var x$1$4 = new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$4);
  $thiz.Lfastparse_Implicits$Sequencer$__f_BaseSequencer6 = x$1$4;
  var f$5 = new $c_sjsr_AnonFunction2(((t$7$2, d$7$2) => {
    var t$7 = $as_T7(t$7$2);
    return new $c_T8($n(t$7).T7__f__1, $n(t$7).T7__f__2, $n(t$7).T7__f__3, $n(t$7).T7__f__4, $n(t$7).T7__f__5, $n(t$7).T7__f__6, $n(t$7).T7__f__7, d$7$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$5);
  var f$6 = new $c_sjsr_AnonFunction2(((t$8$2, d$8$2) => {
    var t$8 = $as_T8(t$8$2);
    return new $c_T9($n(t$8).T8__f__1, $n(t$8).T8__f__2, $n(t$8).T8__f__3, $n(t$8).T8__f__4, $n(t$8).T8__f__5, $n(t$8).T8__f__6, $n(t$8).T8__f__7, $n(t$8).T8__f__8, d$8$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$6);
  var f$7 = new $c_sjsr_AnonFunction2(((t$9$2, d$9$2) => {
    var t$9 = $as_T9(t$9$2);
    return new $c_T10($n(t$9).T9__f__1, $n(t$9).T9__f__2, $n(t$9).T9__f__3, $n(t$9).T9__f__4, $n(t$9).T9__f__5, $n(t$9).T9__f__6, $n(t$9).T9__f__7, $n(t$9).T9__f__8, $n(t$9).T9__f__9, d$9$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$7);
  var f$8 = new $c_sjsr_AnonFunction2(((t$10$2, d$10$2) => {
    var t$10 = $as_T10(t$10$2);
    return new $c_T11($n(t$10).T10__f__1, $n(t$10).T10__f__2, $n(t$10).T10__f__3, $n(t$10).T10__f__4, $n(t$10).T10__f__5, $n(t$10).T10__f__6, $n(t$10).T10__f__7, $n(t$10).T10__f__8, $n(t$10).T10__f__9, $n(t$10).T10__f__10, d$10$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$8);
  var f$9 = new $c_sjsr_AnonFunction2(((t$11$2, d$11$2) => {
    var t$11 = $as_T11(t$11$2);
    return new $c_T12($n(t$11).T11__f__1, $n(t$11).T11__f__2, $n(t$11).T11__f__3, $n(t$11).T11__f__4, $n(t$11).T11__f__5, $n(t$11).T11__f__6, $n(t$11).T11__f__7, $n(t$11).T11__f__8, $n(t$11).T11__f__9, $n(t$11).T11__f__10, $n(t$11).T11__f__11, d$11$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$9);
  var f$10 = new $c_sjsr_AnonFunction2(((t$12$2, d$12$2) => {
    var t$12 = $as_T12(t$12$2);
    return new $c_T13($n(t$12).T12__f__1, $n(t$12).T12__f__2, $n(t$12).T12__f__3, $n(t$12).T12__f__4, $n(t$12).T12__f__5, $n(t$12).T12__f__6, $n(t$12).T12__f__7, $n(t$12).T12__f__8, $n(t$12).T12__f__9, $n(t$12).T12__f__10, $n(t$12).T12__f__11, $n(t$12).T12__f__12, d$12$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$10);
  var f$11 = new $c_sjsr_AnonFunction2(((t$13$2, d$13$2) => {
    var t$13 = $as_T13(t$13$2);
    return new $c_T14($n(t$13).T13__f__1, $n(t$13).T13__f__2, $n(t$13).T13__f__3, $n(t$13).T13__f__4, $n(t$13).T13__f__5, $n(t$13).T13__f__6, $n(t$13).T13__f__7, $n(t$13).T13__f__8, $n(t$13).T13__f__9, $n(t$13).T13__f__10, $n(t$13).T13__f__11, $n(t$13).T13__f__12, $n(t$13).T13__f__13, d$13$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$11);
  var f$12 = new $c_sjsr_AnonFunction2(((t$14$2, d$14$2) => {
    var t$14 = $as_T14(t$14$2);
    return new $c_T15($n(t$14).T14__f__1, $n(t$14).T14__f__2, $n(t$14).T14__f__3, $n(t$14).T14__f__4, $n(t$14).T14__f__5, $n(t$14).T14__f__6, $n(t$14).T14__f__7, $n(t$14).T14__f__8, $n(t$14).T14__f__9, $n(t$14).T14__f__10, $n(t$14).T14__f__11, $n(t$14).T14__f__12, $n(t$14).T14__f__13, $n(t$14).T14__f__14, d$14$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$12);
  var f$13 = new $c_sjsr_AnonFunction2(((t$15$2, d$15$2) => {
    var t$15 = $as_T15(t$15$2);
    return new $c_T16($n(t$15).T15__f__1, $n(t$15).T15__f__2, $n(t$15).T15__f__3, $n(t$15).T15__f__4, $n(t$15).T15__f__5, $n(t$15).T15__f__6, $n(t$15).T15__f__7, $n(t$15).T15__f__8, $n(t$15).T15__f__9, $n(t$15).T15__f__10, $n(t$15).T15__f__11, $n(t$15).T15__f__12, $n(t$15).T15__f__13, $n(t$15).T15__f__14, $n(t$15).T15__f__15, d$15$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$13);
  var f$14 = new $c_sjsr_AnonFunction2(((t$16$2, d$16$2) => {
    var t$16 = $as_T16(t$16$2);
    return new $c_T17($n(t$16).T16__f__1, $n(t$16).T16__f__2, $n(t$16).T16__f__3, $n(t$16).T16__f__4, $n(t$16).T16__f__5, $n(t$16).T16__f__6, $n(t$16).T16__f__7, $n(t$16).T16__f__8, $n(t$16).T16__f__9, $n(t$16).T16__f__10, $n(t$16).T16__f__11, $n(t$16).T16__f__12, $n(t$16).T16__f__13, $n(t$16).T16__f__14, $n(t$16).T16__f__15, $n(t$16).T16__f__16, d$16$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$14);
  var f$15 = new $c_sjsr_AnonFunction2(((t$17$2, d$17$2) => {
    var t$17 = $as_T17(t$17$2);
    return new $c_T18($n(t$17).T17__f__1, $n(t$17).T17__f__2, $n(t$17).T17__f__3, $n(t$17).T17__f__4, $n(t$17).T17__f__5, $n(t$17).T17__f__6, $n(t$17).T17__f__7, $n(t$17).T17__f__8, $n(t$17).T17__f__9, $n(t$17).T17__f__10, $n(t$17).T17__f__11, $n(t$17).T17__f__12, $n(t$17).T17__f__13, $n(t$17).T17__f__14, $n(t$17).T17__f__15, $n(t$17).T17__f__16, $n(t$17).T17__f__17, d$17$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$15);
  var f$16 = new $c_sjsr_AnonFunction2(((t$18$2, d$18$2) => {
    var t$18 = $as_T18(t$18$2);
    return new $c_T19($n(t$18).T18__f__1, $n(t$18).T18__f__2, $n(t$18).T18__f__3, $n(t$18).T18__f__4, $n(t$18).T18__f__5, $n(t$18).T18__f__6, $n(t$18).T18__f__7, $n(t$18).T18__f__8, $n(t$18).T18__f__9, $n(t$18).T18__f__10, $n(t$18).T18__f__11, $n(t$18).T18__f__12, $n(t$18).T18__f__13, $n(t$18).T18__f__14, $n(t$18).T18__f__15, $n(t$18).T18__f__16, $n(t$18).T18__f__17, $n(t$18).T18__f__18, d$18$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$16);
  var f$17 = new $c_sjsr_AnonFunction2(((t$19$2, d$19$2) => {
    var t$19 = $as_T19(t$19$2);
    return new $c_T20($n(t$19).T19__f__1, $n(t$19).T19__f__2, $n(t$19).T19__f__3, $n(t$19).T19__f__4, $n(t$19).T19__f__5, $n(t$19).T19__f__6, $n(t$19).T19__f__7, $n(t$19).T19__f__8, $n(t$19).T19__f__9, $n(t$19).T19__f__10, $n(t$19).T19__f__11, $n(t$19).T19__f__12, $n(t$19).T19__f__13, $n(t$19).T19__f__14, $n(t$19).T19__f__15, $n(t$19).T19__f__16, $n(t$19).T19__f__17, $n(t$19).T19__f__18, $n(t$19).T19__f__19, d$19$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$17);
  var f$18 = new $c_sjsr_AnonFunction2(((t$20$2, d$20$2) => {
    var t$20 = $as_T20(t$20$2);
    return new $c_T21($n(t$20).T20__f__1, $n(t$20).T20__f__2, $n(t$20).T20__f__3, $n(t$20).T20__f__4, $n(t$20).T20__f__5, $n(t$20).T20__f__6, $n(t$20).T20__f__7, $n(t$20).T20__f__8, $n(t$20).T20__f__9, $n(t$20).T20__f__10, $n(t$20).T20__f__11, $n(t$20).T20__f__12, $n(t$20).T20__f__13, $n(t$20).T20__f__14, $n(t$20).T20__f__15, $n(t$20).T20__f__16, $n(t$20).T20__f__17, $n(t$20).T20__f__18, $n(t$20).T20__f__19, $n(t$20).T20__f__20, d$20$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$18);
  var f$19 = new $c_sjsr_AnonFunction2(((t$21$2, d$21$2) => {
    var t$21 = $as_T21(t$21$2);
    return new $c_T22($n(t$21).T21__f__1, $n(t$21).T21__f__2, $n(t$21).T21__f__3, $n(t$21).T21__f__4, $n(t$21).T21__f__5, $n(t$21).T21__f__6, $n(t$21).T21__f__7, $n(t$21).T21__f__8, $n(t$21).T21__f__9, $n(t$21).T21__f__10, $n(t$21).T21__f__11, $n(t$21).T21__f__12, $n(t$21).T21__f__13, $n(t$21).T21__f__14, $n(t$21).T21__f__15, $n(t$21).T21__f__16, $n(t$21).T21__f__17, $n(t$21).T21__f__18, $n(t$21).T21__f__19, $n(t$21).T21__f__20, $n(t$21).T21__f__21, d$21$2)
  }));
  new $c_Lfastparse_Implicits$Sequencer$NarySequencer(f$19)
}
/** @constructor */
function $c_Lfastparse_internal_Msgs$() {
  this.Lfastparse_internal_Msgs$__f_empty = null;
  $n_Lfastparse_internal_Msgs$ = this;
  this.Lfastparse_internal_Msgs$__f_empty = new $c_Lfastparse_internal_Msgs($m_sci_Nil$())
}
$c_Lfastparse_internal_Msgs$.prototype = new $h_O();
$c_Lfastparse_internal_Msgs$.prototype.constructor = $c_Lfastparse_internal_Msgs$;
/** @constructor */
function $h_Lfastparse_internal_Msgs$() {
  /*<skip>*/
}
$h_Lfastparse_internal_Msgs$.prototype = $c_Lfastparse_internal_Msgs$.prototype;
var $d_Lfastparse_internal_Msgs$ = new $TypeData().initClass({
  Lfastparse_internal_Msgs$: 0
}, false, "fastparse.internal.Msgs$", {
  Lfastparse_internal_Msgs$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lfastparse_internal_Msgs$.prototype.$classData = $d_Lfastparse_internal_Msgs$;
var $n_Lfastparse_internal_Msgs$;
function $m_Lfastparse_internal_Msgs$() {
  if ((!$n_Lfastparse_internal_Msgs$)) {
    $n_Lfastparse_internal_Msgs$ = new $c_Lfastparse_internal_Msgs$()
  };
  return $n_Lfastparse_internal_Msgs$
}
function $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__($thiz, lastCursor, lastOp) {
  $thiz.Lio_circe_ACursor__f_lastCursor = lastCursor;
  $thiz.Lio_circe_ACursor__f_lastOp = lastOp;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_ACursor() {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null
}
$c_Lio_circe_ACursor.prototype = new $h_O();
$c_Lio_circe_ACursor.prototype.constructor = $c_Lio_circe_ACursor;
/** @constructor */
function $h_Lio_circe_ACursor() {
  /*<skip>*/
}
$h_Lio_circe_ACursor.prototype = $c_Lio_circe_ACursor.prototype;
$c_Lio_circe_ACursor.prototype.history__sci_List = (function() {
  var next = this;
  $m_sci_List$();
  var builder = new $c_scm_ListBuffer();
  while ((next !== null)) {
    if (($n(next).Lio_circe_ACursor__f_lastOp !== null)) {
      var elem = $n(next).Lio_circe_ACursor__f_lastOp;
      builder.addOne__O__scm_ListBuffer(elem)
    };
    next = $n(next).Lio_circe_ACursor__f_lastCursor
  };
  return builder.toList__sci_List()
});
$c_Lio_circe_ACursor.prototype.get__T__Lio_circe_Decoder__s_util_Either = (function(k, d) {
  var this$1 = $n(this.downField__T__Lio_circe_ACursor(k));
  return $n(d).tryDecode__Lio_circe_ACursor__s_util_Either(this$1)
});
/** @constructor */
function $c_Lio_circe_CursorOp$() {
  this.Lio_circe_CursorOp$__f_showCursorOp = null;
  this.Lio_circe_CursorOp$__f_eqCursorOp = null;
  this.Lio_circe_CursorOp$__f_eqCursorOpList = null;
  $n_Lio_circe_CursorOp$ = this;
  $m_Lcats_Show$();
  var f$1 = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lio_circe_CursorOp(x0$1$2);
    var x = $m_Lio_circe_CursorOp$MoveLeft$();
    if ((x === x0$1)) {
      return "<-"
    } else {
      var x$3 = $m_Lio_circe_CursorOp$MoveRight$();
      if ((x$3 === x0$1)) {
        return "->"
      } else {
        var x$5 = $m_Lio_circe_CursorOp$MoveFirst$();
        if ((x$5 === x0$1)) {
          return "|<-"
        } else {
          var x$7 = $m_Lio_circe_CursorOp$MoveUp$();
          if ((x$7 === x0$1)) {
            return "_/"
          } else if (false) {
            var x2 = $as_Lio_circe_CursorOp$LeftN(x0$1);
            var n = $n(x2).n__I();
            return (("-<-:(" + n) + ")")
          } else if (false) {
            var x3 = $as_Lio_circe_CursorOp$RightN(x0$1);
            var n$2 = $n(x3).n__I();
            return ((":->-(" + n$2) + ")")
          } else if (false) {
            var x4 = $as_Lio_circe_CursorOp$Field(x0$1);
            var f = $n(x4).k__T();
            return (("--(" + f) + ")")
          } else if ((x0$1 instanceof $c_Lio_circe_CursorOp$DownField)) {
            var x5 = $as_Lio_circe_CursorOp$DownField(x0$1);
            var f$2 = $n(x5).Lio_circe_CursorOp$DownField__f_k;
            return (("--\\(" + f$2) + ")")
          } else {
            var x$9 = $m_Lio_circe_CursorOp$DownArray$();
            if ((x$9 === x0$1)) {
              return "\\\\"
            } else if ((x0$1 instanceof $c_Lio_circe_CursorOp$DownN)) {
              var x6 = $as_Lio_circe_CursorOp$DownN(x0$1);
              var n$3 = $n(x6).Lio_circe_CursorOp$DownN__f_n;
              return (("=\\(" + n$3) + ")")
            } else {
              var x$11 = $m_Lio_circe_CursorOp$DeleteGoParent$();
              if ((x$11 === x0$1)) {
                return "!_/"
              } else {
                throw new $c_s_MatchError(x0$1)
              }
            }
          }
        }
      }
    }
  }));
  this.Lio_circe_CursorOp$__f_showCursorOp = new $c_Lcats_Show$$anon$2(f$1);
  this.Lio_circe_CursorOp$__f_eqCursorOp = ($n($m_Lcats_package$().Lcats_package$__f_Eq), new $c_Lcats_kernel_Eq$$anon$6());
  $m_Lcats_instances_package$list$();
  var evidence$4 = this.Lio_circe_CursorOp$__f_eqCursorOp;
  this.Lio_circe_CursorOp$__f_eqCursorOpList = new $c_Lcats_kernel_instances_ListEq(evidence$4)
}
$c_Lio_circe_CursorOp$.prototype = new $h_O();
$c_Lio_circe_CursorOp$.prototype.constructor = $c_Lio_circe_CursorOp$;
/** @constructor */
function $h_Lio_circe_CursorOp$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$.prototype = $c_Lio_circe_CursorOp$.prototype;
$c_Lio_circe_CursorOp$.prototype.opsToPath__sci_List__T = (function(history) {
  var this$2 = $n(history);
  $m_sci_List$();
  var z = $m_sci_Nil$();
  var acc = z;
  var these = this$2.reverse__sci_List();
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var arg2 = acc;
    var x0$1 = $as_Lio_circe_CursorOp(arg1);
    var x1$1 = $as_sci_List(arg2);
    matchEnd36: {
      if ((x0$1 instanceof $c_Lio_circe_CursorOp$DownField)) {
        var x3 = $as_Lio_circe_CursorOp$DownField(x0$1);
        var k = $n(x3).Lio_circe_CursorOp$DownField__f_k;
        var rassoc$1 = new $c_Lio_circe_CursorOp$SelectField(k);
        var this$3 = $n(x1$1);
        acc = new $c_sci_$colon$colon(rassoc$1, this$3);
        break matchEnd36
      };
      var x = $m_Lio_circe_CursorOp$DownArray$();
      if ((x === x0$1)) {
        var rassoc$2 = new $c_Lio_circe_CursorOp$SelectIndex(0);
        var this$4 = $n(x1$1);
        acc = new $c_sci_$colon$colon(rassoc$2, this$4);
        break matchEnd36
      };
      var x$3 = $m_Lio_circe_CursorOp$MoveUp$();
      if (((x$3 === x0$1) && (x1$1 instanceof $c_sci_$colon$colon))) {
        var x7 = $as_sci_$colon$colon(x1$1);
        var tail = $n(x7).sci_$colon$colon__f_next;
        acc = tail;
        break matchEnd36
      };
      var x$5 = $m_Lio_circe_CursorOp$MoveRight$();
      if (((x$5 === x0$1) && (x1$1 instanceof $c_sci_$colon$colon))) {
        var x11 = $as_sci_$colon$colon(x1$1);
        var p12 = $as_Lio_circe_CursorOp$Selection($n(x11).sci_$colon$colon__f_head);
        var tail$2 = $n(x11).sci_$colon$colon__f_next;
        if ((p12 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
          var x13 = $as_Lio_circe_CursorOp$SelectIndex(p12);
          var i = $n(x13).Lio_circe_CursorOp$SelectIndex__f_index;
          var rassoc$3 = new $c_Lio_circe_CursorOp$SelectIndex(((1 + i) | 0));
          var this$5 = $n(tail$2);
          acc = new $c_sci_$colon$colon(rassoc$3, this$5);
          break matchEnd36
        }
      };
      var x$7 = $m_Lio_circe_CursorOp$MoveLeft$();
      if (((x$7 === x0$1) && (x1$1 instanceof $c_sci_$colon$colon))) {
        var x16 = $as_sci_$colon$colon(x1$1);
        var p17 = $as_Lio_circe_CursorOp$Selection($n(x16).sci_$colon$colon__f_head);
        var tail$3 = $n(x16).sci_$colon$colon__f_next;
        if ((p17 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
          var x18 = $as_Lio_circe_CursorOp$SelectIndex(p17);
          var i$2 = $n(x18).Lio_circe_CursorOp$SelectIndex__f_index;
          var rassoc$4 = new $c_Lio_circe_CursorOp$SelectIndex((((-1) + i$2) | 0));
          var this$6 = $n(tail$3);
          acc = new $c_sci_$colon$colon(rassoc$4, this$6);
          break matchEnd36
        }
      };
      if (false) {
        var x21 = $as_Lio_circe_CursorOp$RightN(x0$1);
        var n = $n(x21).n__I();
        if ((x1$1 instanceof $c_sci_$colon$colon)) {
          var x22 = $as_sci_$colon$colon(x1$1);
          var p23 = $as_Lio_circe_CursorOp$Selection($n(x22).sci_$colon$colon__f_head);
          var tail$4 = $n(x22).sci_$colon$colon__f_next;
          if ((p23 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
            var x24 = $as_Lio_circe_CursorOp$SelectIndex(p23);
            var i$3 = $n(x24).Lio_circe_CursorOp$SelectIndex__f_index;
            var rassoc$5 = new $c_Lio_circe_CursorOp$SelectIndex(((i$3 + n) | 0));
            var this$7 = $n(tail$4);
            acc = new $c_sci_$colon$colon(rassoc$5, this$7);
            break matchEnd36
          }
        }
      };
      if (false) {
        var x27 = $as_Lio_circe_CursorOp$LeftN(x0$1);
        var n$2 = $n(x27).n__I();
        if ((x1$1 instanceof $c_sci_$colon$colon)) {
          var x28 = $as_sci_$colon$colon(x1$1);
          var p29 = $as_Lio_circe_CursorOp$Selection($n(x28).sci_$colon$colon__f_head);
          var tail$5 = $n(x28).sci_$colon$colon__f_next;
          if ((p29 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
            var x30 = $as_Lio_circe_CursorOp$SelectIndex(p29);
            var i$4 = $n(x30).Lio_circe_CursorOp$SelectIndex__f_index;
            var rassoc$6 = new $c_Lio_circe_CursorOp$SelectIndex(((i$4 - n$2) | 0));
            var this$8 = $n(tail$5);
            acc = new $c_sci_$colon$colon(rassoc$6, this$8);
            break matchEnd36
          }
        }
      };
      var rassoc$7 = new $c_Lio_circe_CursorOp$Op(x0$1);
      var this$9 = $n(x1$1);
      acc = new $c_sci_$colon$colon(rassoc$7, this$9)
    };
    these = $as_sci_List($n(these).tail__O())
  };
  var selections = $as_sci_List(acc);
  var this$10 = $n(selections);
  var acc$1 = "";
  var these$1 = this$10;
  while ((!$n(these$1).isEmpty__Z())) {
    var arg1$1 = acc$1;
    var arg2$1 = $n(these$1).head__O();
    var x0$2 = $as_T(arg1$1);
    var x1$2 = $as_Lio_circe_CursorOp$Selection(arg2$1);
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$2, x1$2);
    matchEnd9: {
      var str = $as_T(x1.T2__f__1);
      var p2 = $as_Lio_circe_CursorOp$Selection(x1.T2__f__2);
      if ((p2 instanceof $c_Lio_circe_CursorOp$SelectField)) {
        var x3$1 = $as_Lio_circe_CursorOp$SelectField(p2);
        var f = $n(x3$1).Lio_circe_CursorOp$SelectField__f_field;
        acc$1 = (("." + f) + str);
        break matchEnd9
      };
      var str$2 = $as_T(x1.T2__f__1);
      var p4 = $as_Lio_circe_CursorOp$Selection(x1.T2__f__2);
      if ((p4 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
        var x5 = $as_Lio_circe_CursorOp$SelectIndex(p4);
        var i$1 = $n(x5).Lio_circe_CursorOp$SelectIndex__f_index;
        acc$1 = ((("[" + i$1) + "]") + str$2);
        break matchEnd9
      };
      var str$3 = $as_T(x1.T2__f__1);
      var p6 = $as_Lio_circe_CursorOp$Selection(x1.T2__f__2);
      if ((p6 instanceof $c_Lio_circe_CursorOp$Op)) {
        var x7$1 = $as_Lio_circe_CursorOp$Op(p6);
        var op = $n(x7$1).Lio_circe_CursorOp$Op__f_op;
        $m_Lcats_Show$();
        var instance = $m_Lio_circe_CursorOp$().Lio_circe_CursorOp$__f_showCursorOp;
        acc$1 = ((("{" + $n(instance).show__O__T(op)) + "}") + str$3);
        break matchEnd9
      };
      throw new $c_s_MatchError(x1)
    };
    these$1 = $as_sc_LinearSeq($n(these$1).tail__O())
  };
  return $as_T(acc$1)
});
var $d_Lio_circe_CursorOp$ = new $TypeData().initClass({
  Lio_circe_CursorOp$: 0
}, false, "io.circe.CursorOp$", {
  Lio_circe_CursorOp$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$.prototype.$classData = $d_Lio_circe_CursorOp$;
var $n_Lio_circe_CursorOp$;
function $m_Lio_circe_CursorOp$() {
  if ((!$n_Lio_circe_CursorOp$)) {
    $n_Lio_circe_CursorOp$ = new $c_Lio_circe_CursorOp$()
  };
  return $n_Lio_circe_CursorOp$
}
function $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either($thiz, c) {
  if ((c instanceof $c_Lio_circe_HCursor)) {
    var x2 = $as_Lio_circe_HCursor(c);
    return $thiz.apply__Lio_circe_HCursor__s_util_Either(x2)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value = new $c_Lio_circe_DecodingFailure$$anon$2("Attempt to decode value on failed cursor", ops);
    return new $c_s_util_Left(value)
  }
}
function $f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either($thiz, j) {
  return $thiz.apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(j, null, null))
}
function $is_Lio_circe_Decoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_Decoder)))
}
function $as_Lio_circe_Decoder(obj) {
  return (($is_Lio_circe_Decoder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Decoder"))
}
function $isArrayOf_Lio_circe_Decoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Decoder)))
}
function $asArrayOf_Lio_circe_Decoder(obj, depth) {
  return (($isArrayOf_Lio_circe_Decoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Decoder;", depth))
}
/** @constructor */
function $c_Lio_circe_DecodingFailure$() {
  this.Lio_circe_DecodingFailure$__f_eqDecodingFailure = null;
  $n_Lio_circe_DecodingFailure$ = this;
  $n($m_Lcats_package$().Lcats_package$__f_Eq);
  var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_Lio_circe_DecodingFailure(x0$1$2);
    var x1$1 = $as_Lio_circe_DecodingFailure(x1$1$2);
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
    var p2 = $as_Lio_circe_DecodingFailure(x1.T2__f__1);
    var p3 = $as_Lio_circe_DecodingFailure(x1.T2__f__2);
    if ((p2 !== null)) {
      var o11 = $m_Lio_circe_DecodingFailure$().unapply__Lio_circe_Error__s_Option(p2);
      if ((!$n(o11).isEmpty__Z())) {
        var m1 = $as_T($n($as_T2($n(o11).get__O()))._1__O());
        var h1 = $as_sci_List($n($as_T2($n(o11).get__O()))._2__O());
        if ((p3 !== null)) {
          var o10 = $m_Lio_circe_DecodingFailure$().unapply__Lio_circe_Error__s_Option(p3);
          if ((!$n(o10).isEmpty__Z())) {
            var m2 = $as_T($n($as_T2($n(o10).get__O()))._1__O());
            var h2 = $as_sci_List($n($as_T2($n(o10).get__O()))._2__O());
            return ((m1 === m2) && $n($m_Lio_circe_CursorOp$().Lio_circe_CursorOp$__f_eqCursorOpList).eqv__O__O__Z(h1, h2))
          }
        }
      }
    };
    throw new $c_s_MatchError(x1)
  }));
  this.Lio_circe_DecodingFailure$__f_eqDecodingFailure = new $c_Lcats_kernel_Eq$$anon$5(f);
  $m_Lcats_Show$();
  var f$1 = new $c_sjsr_AnonFunction1(((failure$2) => {
    var failure = $as_Lio_circe_DecodingFailure(failure$2);
    var path = $m_Lio_circe_CursorOp$().opsToPath__sci_List__T($n(failure).history__sci_List());
    return ((("DecodingFailure at " + path) + ": ") + $n(failure).Lio_circe_DecodingFailure__f_message)
  }));
  new $c_Lcats_Show$$anon$2(f$1)
}
$c_Lio_circe_DecodingFailure$.prototype = new $h_O();
$c_Lio_circe_DecodingFailure$.prototype.constructor = $c_Lio_circe_DecodingFailure$;
/** @constructor */
function $h_Lio_circe_DecodingFailure$() {
  /*<skip>*/
}
$h_Lio_circe_DecodingFailure$.prototype = $c_Lio_circe_DecodingFailure$.prototype;
$c_Lio_circe_DecodingFailure$.prototype.unapply__Lio_circe_Error__s_Option = (function(error) {
  if ((error instanceof $c_Lio_circe_ParsingFailure)) {
    return $m_s_None$()
  } else if ((error instanceof $c_Lio_circe_DecodingFailure)) {
    var x5 = $as_Lio_circe_DecodingFailure(error);
    return new $c_s_Some($ct_T2__O__O__(new $c_T2(), $n(x5).Lio_circe_DecodingFailure__f_message, $n(x5).history__sci_List()))
  } else {
    throw new $c_s_MatchError(error)
  }
});
var $d_Lio_circe_DecodingFailure$ = new $TypeData().initClass({
  Lio_circe_DecodingFailure$: 0
}, false, "io.circe.DecodingFailure$", {
  Lio_circe_DecodingFailure$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_DecodingFailure$.prototype.$classData = $d_Lio_circe_DecodingFailure$;
var $n_Lio_circe_DecodingFailure$;
function $m_Lio_circe_DecodingFailure$() {
  if ((!$n_Lio_circe_DecodingFailure$)) {
    $n_Lio_circe_DecodingFailure$ = new $c_Lio_circe_DecodingFailure$()
  };
  return $n_Lio_circe_DecodingFailure$
}
function $is_Lio_circe_Encoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_Encoder)))
}
function $as_Lio_circe_Encoder(obj) {
  return (($is_Lio_circe_Encoder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Encoder"))
}
function $isArrayOf_Lio_circe_Encoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Encoder)))
}
function $asArrayOf_Lio_circe_Encoder(obj, depth) {
  return (($isArrayOf_Lio_circe_Encoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Encoder;", depth))
}
function $p_Lio_circe_Json$__arrayEq__sci_Seq__sci_Seq__Z($thiz, x, y) {
  var it0 = $n(x).iterator__sc_Iterator();
  var it1 = $n(y).iterator__sc_Iterator();
  while (($n(it0).hasNext__Z() && $n(it1).hasNext__Z())) {
    if ($n($m_Lio_circe_Json$().Lio_circe_Json$__f_eqJson).neqv__O__O__Z($n(it0).next__O(), $n(it1).next__O())) {
      return false
    }
  };
  return ($n(it0).hasNext__Z() === $n(it1).hasNext__Z())
}
/** @constructor */
function $c_Lio_circe_Json$() {
  this.Lio_circe_Json$__f_Null = null;
  this.Lio_circe_Json$__f_True = null;
  this.Lio_circe_Json$__f_False = null;
  this.Lio_circe_Json$__f_eqJson = null;
  this.Lio_circe_Json$__f_showJson = null;
  $n_Lio_circe_Json$ = this;
  this.Lio_circe_Json$__f_Null = $m_Lio_circe_Json$JNull$();
  this.Lio_circe_Json$__f_True = new $c_Lio_circe_Json$JBoolean(true);
  this.Lio_circe_Json$__f_False = new $c_Lio_circe_Json$JBoolean(false);
  $n($m_Lcats_package$().Lcats_package$__f_Eq);
  var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_Lio_circe_Json(x0$1$2);
    var x1$1 = $as_Lio_circe_Json(x1$1$2);
    if ((x0$1 instanceof $c_Lio_circe_Json$JObject)) {
      var x4 = $as_Lio_circe_Json$JObject(x0$1);
      var a = $n(x4).Lio_circe_Json$JObject__f_value;
      if ((x1$1 instanceof $c_Lio_circe_Json$JObject)) {
        var x5 = $as_Lio_circe_Json$JObject(x1$1);
        var b = $n(x5).Lio_circe_Json$JObject__f_value;
        return $n($m_Lio_circe_JsonObject$().Lio_circe_JsonObject$__f_eqJsonObject).eqv__O__O__Z(a, b)
      }
    };
    if ((x0$1 instanceof $c_Lio_circe_Json$JString)) {
      var x8 = $as_Lio_circe_Json$JString(x0$1);
      var a$2 = $n(x8).Lio_circe_Json$JString__f_value;
      if ((x1$1 instanceof $c_Lio_circe_Json$JString)) {
        var x9 = $as_Lio_circe_Json$JString(x1$1);
        var b$2 = $n(x9).Lio_circe_Json$JString__f_value;
        return (a$2 === b$2)
      }
    };
    if ((x0$1 instanceof $c_Lio_circe_Json$JNumber)) {
      var x12 = $as_Lio_circe_Json$JNumber(x0$1);
      var a$3 = $n(x12).Lio_circe_Json$JNumber__f_value;
      if ((x1$1 instanceof $c_Lio_circe_Json$JNumber)) {
        var x13 = $as_Lio_circe_Json$JNumber(x1$1);
        var b$3 = $n(x13).Lio_circe_Json$JNumber__f_value;
        return $n($m_Lio_circe_JsonNumber$().Lio_circe_JsonNumber$__f_eqJsonNumber).eqv__O__O__Z(a$3, b$3)
      }
    };
    if ((x0$1 instanceof $c_Lio_circe_Json$JBoolean)) {
      var x16 = $as_Lio_circe_Json$JBoolean(x0$1);
      var a$4 = $n(x16).Lio_circe_Json$JBoolean__f_value;
      if ((x1$1 instanceof $c_Lio_circe_Json$JBoolean)) {
        var x17 = $as_Lio_circe_Json$JBoolean(x1$1);
        var b$4 = $n(x17).Lio_circe_Json$JBoolean__f_value;
        return (a$4 === b$4)
      }
    };
    if ((x0$1 instanceof $c_Lio_circe_Json$JArray)) {
      var x20 = $as_Lio_circe_Json$JArray(x0$1);
      var a$5 = $n(x20).Lio_circe_Json$JArray__f_value;
      if ((x1$1 instanceof $c_Lio_circe_Json$JArray)) {
        var x21 = $as_Lio_circe_Json$JArray(x1$1);
        var b$5 = $n(x21).Lio_circe_Json$JArray__f_value;
        return $p_Lio_circe_Json$__arrayEq__sci_Seq__sci_Seq__Z($m_Lio_circe_Json$(), a$5, b$5)
      }
    };
    return ($n(x0$1).isNull__Z() && $n(x1$1).isNull__Z())
  }));
  this.Lio_circe_Json$__f_eqJson = new $c_Lcats_kernel_Eq$$anon$5(f);
  this.Lio_circe_Json$__f_showJson = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$3())
}
$c_Lio_circe_Json$.prototype = new $h_O();
$c_Lio_circe_Json$.prototype.constructor = $c_Lio_circe_Json$;
/** @constructor */
function $h_Lio_circe_Json$() {
  /*<skip>*/
}
$h_Lio_circe_Json$.prototype = $c_Lio_circe_Json$.prototype;
$c_Lio_circe_Json$.prototype.fromFields__sc_Iterable__Lio_circe_Json = (function(fields) {
  return new $c_Lio_circe_Json$JObject($m_Lio_circe_JsonObject$().fromIterable__sc_Iterable__Lio_circe_JsonObject(fields))
});
$c_Lio_circe_Json$.prototype.fromBoolean__Z__Lio_circe_Json = (function(value) {
  return (value ? this.Lio_circe_Json$__f_True : this.Lio_circe_Json$__f_False)
});
$c_Lio_circe_Json$.prototype.fromInt__I__Lio_circe_Json = (function(value) {
  var hi = (value >> 31);
  return new $c_Lio_circe_Json$JNumber(new $c_Lio_circe_JsonLong(new $c_RTLong(value, hi)))
});
$c_Lio_circe_Json$.prototype.fromLong__J__Lio_circe_Json = (function(value) {
  return new $c_Lio_circe_Json$JNumber(new $c_Lio_circe_JsonLong(value))
});
$c_Lio_circe_Json$.prototype.fromDoubleOrNull__D__Lio_circe_Json = (function(value) {
  return (((value === value) && (!((value === Infinity) || (value === (-Infinity))))) ? new $c_Lio_circe_Json$JNumber(new $c_Lio_circe_JsonDouble(value)) : this.Lio_circe_Json$__f_Null)
});
$c_Lio_circe_Json$.prototype.fromFloatOrNull__F__Lio_circe_Json = (function(value) {
  return (((value === value) && (!((value === Infinity) || (value === (-Infinity))))) ? new $c_Lio_circe_Json$JNumber(new $c_Lio_circe_JsonFloat(value)) : this.Lio_circe_Json$__f_Null)
});
$c_Lio_circe_Json$.prototype.fromBigInt__s_math_BigInt__Lio_circe_Json = (function(value) {
  var this$2 = $m_Lio_circe_numbers_BiggerDecimal$();
  var this$1 = $n(value);
  var i = this$1.bigInteger__Ljava_math_BigInteger();
  return new $c_Lio_circe_Json$JNumber(new $c_Lio_circe_JsonBiggerDecimal($p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this$2, i, $L0), $n(value).toString__T()))
});
$c_Lio_circe_Json$.prototype.fromBigDecimal__s_math_BigDecimal__Lio_circe_Json = (function(value) {
  var this$1 = $n(value);
  return new $c_Lio_circe_Json$JNumber(new $c_Lio_circe_JsonBigDecimal(this$1.s_math_BigDecimal__f_bigDecimal))
});
var $d_Lio_circe_Json$ = new $TypeData().initClass({
  Lio_circe_Json$: 0
}, false, "io.circe.Json$", {
  Lio_circe_Json$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$.prototype.$classData = $d_Lio_circe_Json$;
var $n_Lio_circe_Json$;
function $m_Lio_circe_Json$() {
  if ((!$n_Lio_circe_Json$)) {
    $n_Lio_circe_Json$ = new $c_Lio_circe_Json$()
  };
  return $n_Lio_circe_Json$
}
/** @constructor */
function $c_Lio_circe_JsonNumber() {
  /*<skip>*/
}
$c_Lio_circe_JsonNumber.prototype = new $h_O();
$c_Lio_circe_JsonNumber.prototype.constructor = $c_Lio_circe_JsonNumber;
/** @constructor */
function $h_Lio_circe_JsonNumber() {
  /*<skip>*/
}
$h_Lio_circe_JsonNumber.prototype = $c_Lio_circe_JsonNumber.prototype;
$c_Lio_circe_JsonNumber.prototype.toByte__s_Option = (function() {
  var x1 = this.toLong__s_Option();
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var t = $uJ($n(x2).s_Some__f_value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var asByte = ((lo << 24) >> 24);
    var value = asByte;
    var hi$1 = (value >> 31);
    if (((lo === value) && (hi === hi$1))) {
      return new $c_s_Some(asByte)
    } else {
      return $m_s_None$()
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return $m_s_None$()
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lio_circe_JsonNumber.prototype.toShort__s_Option = (function() {
  var x1 = this.toLong__s_Option();
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var t = $uJ($n(x2).s_Some__f_value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var asShort = ((lo << 16) >> 16);
    var value = asShort;
    var hi$1 = (value >> 31);
    if (((lo === value) && (hi === hi$1))) {
      return new $c_s_Some(asShort)
    } else {
      return $m_s_None$()
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return $m_s_None$()
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lio_circe_JsonNumber.prototype.toInt__s_Option = (function() {
  var x1 = this.toLong__s_Option();
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var t = $uJ($n(x2).s_Some__f_value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var hi$1 = (lo >> 31);
    if (((lo === lo) && (hi === hi$1))) {
      return new $c_s_Some(lo)
    } else {
      return $m_s_None$()
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return $m_s_None$()
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lio_circe_JsonNumber.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_JsonNumber)) {
    var x2 = $as_Lio_circe_JsonNumber(that);
    return $n($m_Lio_circe_JsonNumber$().Lio_circe_JsonNumber$__f_eqJsonNumber).eqv__O__O__Z(this, x2)
  } else {
    return false
  }
});
$c_Lio_circe_JsonNumber.prototype.hashCode__I = (function() {
  return $n(this.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal()).hashCode__I()
});
function $as_Lio_circe_JsonNumber(obj) {
  return (((obj instanceof $c_Lio_circe_JsonNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonNumber"))
}
function $isArrayOf_Lio_circe_JsonNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonNumber)))
}
function $asArrayOf_Lio_circe_JsonNumber(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonNumber;", depth))
}
/** @constructor */
function $c_Lio_circe_JsonNumber$() {
  this.Lio_circe_JsonNumber$__f_bigDecimalMinLong = null;
  this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong = null;
  this.Lio_circe_JsonNumber$__f_eqJsonNumber = null;
  $n_Lio_circe_JsonNumber$ = this;
  this.Lio_circe_JsonNumber$__f_bigDecimalMinLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong(0, (-2147483648)));
  this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong((-1), 2147483647));
  var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_Lio_circe_JsonNumber(x0$1$2);
    var x1$1 = $as_Lio_circe_JsonNumber(x1$1$2);
    if ((x0$1 instanceof $c_Lio_circe_JsonLong)) {
      var x4 = $as_Lio_circe_JsonLong(x0$1);
      var t = $n(x4).Lio_circe_JsonLong__f_value;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      if ((x1$1 instanceof $c_Lio_circe_JsonLong)) {
        var x5 = $as_Lio_circe_JsonLong(x1$1);
        var t$1 = $n(x5).Lio_circe_JsonLong__f_value;
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        return ((lo === lo$1) && (hi === hi$1))
      }
    };
    if ((x0$1 instanceof $c_Lio_circe_JsonDouble)) {
      var x8 = $as_Lio_circe_JsonDouble(x0$1);
      var x$2 = $n(x8).Lio_circe_JsonDouble__f_value;
      if ((x1$1 instanceof $c_Lio_circe_JsonDouble)) {
        var x9 = $as_Lio_circe_JsonDouble(x1$1);
        var y$2 = $n(x9).Lio_circe_JsonDouble__f_value;
        return ($m_jl_Double$().compare__D__D__I(x$2, y$2) === 0)
      }
    };
    if ((x0$1 instanceof $c_Lio_circe_JsonFloat)) {
      var x12 = $as_Lio_circe_JsonFloat(x0$1);
      var x$3 = $n(x12).Lio_circe_JsonFloat__f_value;
      if ((x1$1 instanceof $c_Lio_circe_JsonFloat)) {
        var x13 = $as_Lio_circe_JsonFloat(x1$1);
        var y$3 = $n(x13).Lio_circe_JsonFloat__f_value;
        return ($m_jl_Double$().compare__D__D__I(x$3, y$3) === 0)
      }
    };
    if ((x0$1 instanceof $c_Lio_circe_JsonBigDecimal)) {
      var x16 = $as_Lio_circe_JsonBigDecimal(x0$1);
      var x$4 = $n(x16).Lio_circe_JsonBigDecimal__f_value;
      if ((x1$1 instanceof $c_Lio_circe_JsonBigDecimal)) {
        var x17 = $as_Lio_circe_JsonBigDecimal(x1$1);
        var y$4 = $n(x17).Lio_circe_JsonBigDecimal__f_value;
        return ($n(x$4).compareTo__Ljava_math_BigDecimal__I(y$4) === 0)
      }
    };
    var x$5 = $n(x0$1).toBiggerDecimal__Lio_circe_numbers_BiggerDecimal();
    var x$6 = $n(x1$1).toBiggerDecimal__Lio_circe_numbers_BiggerDecimal();
    return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
  }));
  this.Lio_circe_JsonNumber$__f_eqJsonNumber = new $c_Lcats_kernel_Eq$$anon$5(f)
}
$c_Lio_circe_JsonNumber$.prototype = new $h_O();
$c_Lio_circe_JsonNumber$.prototype.constructor = $c_Lio_circe_JsonNumber$;
/** @constructor */
function $h_Lio_circe_JsonNumber$() {
  /*<skip>*/
}
$h_Lio_circe_JsonNumber$.prototype = $c_Lio_circe_JsonNumber$.prototype;
$c_Lio_circe_JsonNumber$.prototype.fromString__T__s_Option = (function(value) {
  var result = $m_Lio_circe_numbers_BiggerDecimal$().parseBiggerDecimalUnsafe__T__Lio_circe_numbers_BiggerDecimal(value);
  return ((result === null) ? $m_s_None$() : new $c_s_Some(new $c_Lio_circe_JsonBiggerDecimal(result, value)))
});
$c_Lio_circe_JsonNumber$.prototype.bigDecimalIsWhole__Ljava_math_BigDecimal__Z = (function(value) {
  if (($n(value).signum__I() === 0)) {
    var $$x1 = true
  } else {
    var this$1 = $n(value);
    var $$x1 = (this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)
  };
  if ($$x1) {
    return true
  } else {
    var this$2 = $n($n(value).stripTrailingZeros__Ljava_math_BigDecimal());
    return (this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)
  }
});
$c_Lio_circe_JsonNumber$.prototype.bigDecimalIsValidLong__Ljava_math_BigDecimal__Z = (function(value) {
  return ((this.bigDecimalIsWhole__Ljava_math_BigDecimal__Z(value) && ($n(value).compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsonNumber$__f_bigDecimalMinLong) >= 0)) && ($n(value).compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong) <= 0))
});
var $d_Lio_circe_JsonNumber$ = new $TypeData().initClass({
  Lio_circe_JsonNumber$: 0
}, false, "io.circe.JsonNumber$", {
  Lio_circe_JsonNumber$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_JsonNumber$.prototype.$classData = $d_Lio_circe_JsonNumber$;
var $n_Lio_circe_JsonNumber$;
function $m_Lio_circe_JsonNumber$() {
  if ((!$n_Lio_circe_JsonNumber$)) {
    $n_Lio_circe_JsonNumber$ = new $c_Lio_circe_JsonNumber$()
  };
  return $n_Lio_circe_JsonNumber$
}
/** @constructor */
function $c_Lio_circe_JsonObject() {
  /*<skip>*/
}
$c_Lio_circe_JsonObject.prototype = new $h_O();
$c_Lio_circe_JsonObject.prototype.constructor = $c_Lio_circe_JsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject.prototype = $c_Lio_circe_JsonObject.prototype;
$c_Lio_circe_JsonObject.prototype.toString__T = (function() {
  var this$2 = $n($as_sc_IterableOnceOps($n(this.toIterable__sc_Iterable()).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = $as_T($n(x0$1)._1__O());
      var v = $as_Lio_circe_Json($n(x0$1)._2__O());
      return ((k + " -> ") + $n($m_Lio_circe_Json$().Lio_circe_Json$__f_showJson).show__O__T(v))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "object[", ",", "]")
});
$c_Lio_circe_JsonObject.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_JsonObject)) {
    var x2 = $as_Lio_circe_JsonObject(that);
    var x = this.toMap__sci_Map();
    var x$2 = $n(x2).toMap__sci_Map();
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lio_circe_JsonObject.prototype.hashCode__I = (function() {
  return $n(this.toMap__sci_Map()).hashCode__I()
});
function $as_Lio_circe_JsonObject(obj) {
  return (((obj instanceof $c_Lio_circe_JsonObject) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonObject"))
}
function $isArrayOf_Lio_circe_JsonObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonObject)))
}
function $asArrayOf_Lio_circe_JsonObject(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonObject;", depth))
}
/** @constructor */
function $c_Lio_circe_JsonObject$() {
  this.Lio_circe_JsonObject$__f_empty = null;
  this.Lio_circe_JsonObject$__f_eqJsonObject = null;
  $n_Lio_circe_JsonObject$ = this;
  this.Lio_circe_JsonObject$__f_empty = new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($m_sci_Map$EmptyMap$(), ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()));
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  this.Lio_circe_JsonObject$__f_eqJsonObject = ($n($m_Lcats_package$().Lcats_package$__f_Eq), new $c_Lcats_kernel_Eq$$anon$6())
}
$c_Lio_circe_JsonObject$.prototype = new $h_O();
$c_Lio_circe_JsonObject$.prototype.constructor = $c_Lio_circe_JsonObject$;
/** @constructor */
function $h_Lio_circe_JsonObject$() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$.prototype = $c_Lio_circe_JsonObject$.prototype;
$c_Lio_circe_JsonObject$.prototype.fromIterable__sc_Iterable__Lio_circe_JsonObject = (function(fields) {
  var map = $ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap());
  var iterator = $n(fields).iterator__sc_Iterator();
  while ($n(iterator).hasNext__Z()) {
    var x1 = $as_T2($n(iterator).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var key = $as_T($n(x1)._1__O());
    var value = $as_Lio_circe_Json($n(x1)._2__O());
    if ((key === null)) {
      var $$x1 = 0
    } else {
      var originalHash = $f_T__hashCode__I($n(key));
      var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    map.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $$x1, false)
  };
  return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject(map)
});
$c_Lio_circe_JsonObject$.prototype.singleton__T__Lio_circe_Json__Lio_circe_JsonObject = (function(key, value) {
  var this$4 = $m_sci_Map$();
  var array = [$ct_T2__O__O__(new $c_T2(), key, value)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x1 = this$4.from__sc_IterableOnce__sci_Map(elems);
  var this$8 = $n($m_s_package$().s_package$__f_Vector);
  var array$1 = [key];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($$x1, this$8.from__sc_IterableOnce__sci_Vector(elems$1))
});
var $d_Lio_circe_JsonObject$ = new $TypeData().initClass({
  Lio_circe_JsonObject$: 0
}, false, "io.circe.JsonObject$", {
  Lio_circe_JsonObject$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_JsonObject$.prototype.$classData = $d_Lio_circe_JsonObject$;
var $n_Lio_circe_JsonObject$;
function $m_Lio_circe_JsonObject$() {
  if ((!$n_Lio_circe_JsonObject$)) {
    $n_Lio_circe_JsonObject$ = new $c_Lio_circe_JsonObject$()
  };
  return $n_Lio_circe_JsonObject$
}
function $is_Lio_circe_KeyDecoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_KeyDecoder)))
}
function $as_Lio_circe_KeyDecoder(obj) {
  return (($is_Lio_circe_KeyDecoder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.KeyDecoder"))
}
function $isArrayOf_Lio_circe_KeyDecoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_KeyDecoder)))
}
function $asArrayOf_Lio_circe_KeyDecoder(obj, depth) {
  return (($isArrayOf_Lio_circe_KeyDecoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.KeyDecoder;", depth))
}
/** @constructor */
function $c_Lio_circe_KeyDecoder$() {
  this.Lio_circe_KeyDecoder$__f_decodeKeyString = null;
  this.Lio_circe_KeyDecoder$__f_decodeKeyUUID = null;
  $n_Lio_circe_KeyDecoder$ = this;
  this.Lio_circe_KeyDecoder$__f_decodeKeyString = new $c_Lio_circe_KeyDecoder$$anon$5();
  new $c_Lio_circe_KeyDecoder$$anon$6();
  this.Lio_circe_KeyDecoder$__f_decodeKeyUUID = new $c_Lio_circe_KeyDecoder$$anon$7();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T(x$1$2);
    var this$2 = $m_jl_Byte$();
    return this$2.parseByte__T__I__B(x$1, 10)
  }));
  new $c_Lio_circe_KeyDecoder$$anon$4(f);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1$3$2) => {
    var x$1$3 = $as_T(x$1$3$2);
    var this$3 = $m_jl_Short$();
    return this$3.parseShort__T__I__S(x$1$3, 10)
  }));
  new $c_Lio_circe_KeyDecoder$$anon$4(f$1);
  var f$2 = new $c_sjsr_AnonFunction1(((x$1$4$2) => {
    var x$1$4 = $as_T(x$1$4$2);
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x$1$4, 10)
  }));
  new $c_Lio_circe_KeyDecoder$$anon$4(f$2);
  var f$3 = new $c_sjsr_AnonFunction1(((x$1$5$2) => {
    var x$1$5 = $as_T(x$1$5$2);
    var this$5 = $m_jl_Long$();
    return this$5.parseLong__T__I__J(x$1$5, 10)
  }));
  new $c_Lio_circe_KeyDecoder$$anon$4(f$3);
  new $c_Lio_circe_KeyDecoder$$anon$8()
}
$c_Lio_circe_KeyDecoder$.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$.prototype.constructor = $c_Lio_circe_KeyDecoder$;
/** @constructor */
function $h_Lio_circe_KeyDecoder$() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$.prototype = $c_Lio_circe_KeyDecoder$.prototype;
var $d_Lio_circe_KeyDecoder$ = new $TypeData().initClass({
  Lio_circe_KeyDecoder$: 0
}, false, "io.circe.KeyDecoder$", {
  Lio_circe_KeyDecoder$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyDecoder$.prototype.$classData = $d_Lio_circe_KeyDecoder$;
var $n_Lio_circe_KeyDecoder$;
function $m_Lio_circe_KeyDecoder$() {
  if ((!$n_Lio_circe_KeyDecoder$)) {
    $n_Lio_circe_KeyDecoder$ = new $c_Lio_circe_KeyDecoder$()
  };
  return $n_Lio_circe_KeyDecoder$
}
function $is_Lio_circe_KeyEncoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_KeyEncoder)))
}
function $as_Lio_circe_KeyEncoder(obj) {
  return (($is_Lio_circe_KeyEncoder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.KeyEncoder"))
}
function $isArrayOf_Lio_circe_KeyEncoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_KeyEncoder)))
}
function $asArrayOf_Lio_circe_KeyEncoder(obj, depth) {
  return (($isArrayOf_Lio_circe_KeyEncoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.KeyEncoder;", depth))
}
/** @constructor */
function $c_Lio_circe_KeyEncoder$() {
  this.Lio_circe_KeyEncoder$__f_encodeKeyString = null;
  this.Lio_circe_KeyEncoder$__f_encodeKeyUUID = null;
  $n_Lio_circe_KeyEncoder$ = this;
  this.Lio_circe_KeyEncoder$__f_encodeKeyString = new $c_Lio_circe_KeyEncoder$$anon$3();
  new $c_Lio_circe_KeyEncoder$$anon$4();
  this.Lio_circe_KeyEncoder$__f_encodeKeyUUID = new $c_Lio_circe_KeyEncoder$$anon$5();
  new $c_Lio_circe_KeyEncoder$$anon$6();
  new $c_Lio_circe_KeyEncoder$$anon$7();
  new $c_Lio_circe_KeyEncoder$$anon$8();
  new $c_Lio_circe_KeyEncoder$$anon$9();
  new $c_Lio_circe_KeyEncoder$$anon$10()
}
$c_Lio_circe_KeyEncoder$.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$.prototype.constructor = $c_Lio_circe_KeyEncoder$;
/** @constructor */
function $h_Lio_circe_KeyEncoder$() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$.prototype = $c_Lio_circe_KeyEncoder$.prototype;
var $d_Lio_circe_KeyEncoder$ = new $TypeData().initClass({
  Lio_circe_KeyEncoder$: 0
}, false, "io.circe.KeyEncoder$", {
  Lio_circe_KeyEncoder$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$.prototype.$classData = $d_Lio_circe_KeyEncoder$;
var $n_Lio_circe_KeyEncoder$;
function $m_Lio_circe_KeyEncoder$() {
  if ((!$n_Lio_circe_KeyEncoder$)) {
    $n_Lio_circe_KeyEncoder$ = new $c_Lio_circe_KeyEncoder$()
  };
  return $n_Lio_circe_KeyEncoder$
}
/** @constructor */
function $c_Lio_circe_MapDecoder$() {
  /*<skip>*/
}
$c_Lio_circe_MapDecoder$.prototype = new $h_O();
$c_Lio_circe_MapDecoder$.prototype.constructor = $c_Lio_circe_MapDecoder$;
/** @constructor */
function $h_Lio_circe_MapDecoder$() {
  /*<skip>*/
}
$h_Lio_circe_MapDecoder$.prototype = $c_Lio_circe_MapDecoder$.prototype;
$c_Lio_circe_MapDecoder$.prototype.failure__Lio_circe_HCursor__Lio_circe_DecodingFailure = (function(c) {
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
  return new $c_Lio_circe_DecodingFailure$$anon$2("[K, V]Map[K, V]", ops)
});
$c_Lio_circe_MapDecoder$.prototype.failureResult__Lio_circe_HCursor__s_util_Either = (function(c) {
  $n($m_s_package$().s_package$__f_Left);
  var value = this.failure__Lio_circe_HCursor__Lio_circe_DecodingFailure(c);
  return new $c_s_util_Left(value)
});
var $d_Lio_circe_MapDecoder$ = new $TypeData().initClass({
  Lio_circe_MapDecoder$: 0
}, false, "io.circe.MapDecoder$", {
  Lio_circe_MapDecoder$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_MapDecoder$.prototype.$classData = $d_Lio_circe_MapDecoder$;
var $n_Lio_circe_MapDecoder$;
function $m_Lio_circe_MapDecoder$() {
  if ((!$n_Lio_circe_MapDecoder$)) {
    $n_Lio_circe_MapDecoder$ = new $c_Lio_circe_MapDecoder$()
  };
  return $n_Lio_circe_MapDecoder$
}
function $f_Lio_circe_Parser__finishDecode__s_util_Either__Lio_circe_Decoder__s_util_Either($thiz, input, decoder) {
  if ((input instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(input);
    var json = $as_Lio_circe_Json($n(x2).s_util_Right__f_value);
    var this$1 = $n(decoder);
    return $f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either(this$1, json)
  } else if ((input instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(input);
    return x3
  } else {
    throw new $c_s_MatchError(input)
  }
}
function $f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either($thiz, input, evidence$1) {
  var input$1 = $thiz.parse__T__s_util_Either(input);
  return $f_Lio_circe_Parser__finishDecode__s_util_Either__Lio_circe_Decoder__s_util_Either($thiz, input$1, evidence$1)
}
function $p_Lio_circe_Printer$__toHex__I__C($thiz, nibble) {
  return (65535 & ((nibble + ((nibble >= 10) ? 87 : 48)) | 0))
}
/** @constructor */
function $c_Lio_circe_Printer$() {
  this.Lio_circe_Printer$__f_noSpaces = null;
  this.Lio_circe_Printer$__f_spaces2 = null;
  $n_Lio_circe_Printer$ = this;
  this.Lio_circe_Printer$__f_noSpaces = new $c_Lio_circe_Printer(false, "", ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), ""), ($m_Lio_circe_Printer$(), false), ($m_Lio_circe_Printer$(), false), ($m_Lio_circe_Printer$(), false), ($m_Lio_circe_Printer$(), false));
  $m_Lio_circe_Printer$();
  var x$4 = "";
  $m_Lio_circe_Printer$();
  var x$5 = "";
  $m_Lio_circe_Printer$();
  var x$6 = "";
  $m_Lio_circe_Printer$();
  var x$7 = "";
  $m_Lio_circe_Printer$();
  var x$8 = "";
  $m_Lio_circe_Printer$();
  var x$9 = "";
  $m_Lio_circe_Printer$();
  var x$10 = "";
  $m_Lio_circe_Printer$();
  var x$11 = "";
  $m_Lio_circe_Printer$();
  var x$12 = "";
  $m_Lio_circe_Printer$();
  var x$13 = "";
  $m_Lio_circe_Printer$();
  var x$14 = "";
  $m_Lio_circe_Printer$();
  var x$15 = "";
  $m_Lio_circe_Printer$();
  var x$16 = "";
  $m_Lio_circe_Printer$();
  var x$17 = "";
  $m_Lio_circe_Printer$();
  var x$18 = "";
  $m_Lio_circe_Printer$();
  var x$19 = false;
  $m_Lio_circe_Printer$();
  var x$20 = false;
  $m_Lio_circe_Printer$();
  var x$21 = false;
  new $c_Lio_circe_Printer(false, "", x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$18, x$19, x$20, x$21, true);
  this.Lio_circe_Printer$__f_spaces2 = this.indented__T__Z__Lio_circe_Printer("  ", false);
  this.indented__T__Z__Lio_circe_Printer("  ", true);
  this.indented__T__Z__Lio_circe_Printer("    ", false);
  this.indented__T__Z__Lio_circe_Printer("    ", true)
}
$c_Lio_circe_Printer$.prototype = new $h_O();
$c_Lio_circe_Printer$.prototype.constructor = $c_Lio_circe_Printer$;
/** @constructor */
function $h_Lio_circe_Printer$() {
  /*<skip>*/
}
$h_Lio_circe_Printer$.prototype = $c_Lio_circe_Printer$.prototype;
$c_Lio_circe_Printer$.prototype.indented__T__Z__Lio_circe_Printer = (function(indent, sortKeys) {
  $m_Lio_circe_Printer$();
  var x$13 = "";
  $m_Lio_circe_Printer$();
  var x$14 = "";
  $m_Lio_circe_Printer$();
  var x$15 = "";
  $m_Lio_circe_Printer$();
  var x$16 = "";
  $m_Lio_circe_Printer$();
  var x$17 = "";
  $m_Lio_circe_Printer$();
  var x$18 = "";
  $m_Lio_circe_Printer$();
  var x$19 = false;
  $m_Lio_circe_Printer$();
  var x$20 = false;
  $m_Lio_circe_Printer$();
  var x$21 = false;
  return new $c_Lio_circe_Printer(false, indent, x$13, "\n", "\n", x$14, x$15, "\n", "\n", x$16, "\n", x$17, "\n", x$18, "\n", " ", " ", x$19, x$20, x$21, sortKeys)
});
$c_Lio_circe_Printer$.prototype.io$circe$Printer$$writeEscapedChar__jl_Appendable__C__V = (function(writer, c) {
  $n($n($n($n($n(writer).append__C__jl_Appendable(117)).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 12))))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 8))))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 4))))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & c)))
});
var $d_Lio_circe_Printer$ = new $TypeData().initClass({
  Lio_circe_Printer$: 0
}, false, "io.circe.Printer$", {
  Lio_circe_Printer$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Printer$.prototype.$classData = $d_Lio_circe_Printer$;
var $n_Lio_circe_Printer$;
function $m_Lio_circe_Printer$() {
  if ((!$n_Lio_circe_Printer$)) {
    $n_Lio_circe_Printer$ = new $c_Lio_circe_Printer$()
  };
  return $n_Lio_circe_Printer$
}
/** @constructor */
function $c_Lio_circe_Printer$$anon$2(outer) {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  $ct_jl_ThreadLocal__(this)
}
$c_Lio_circe_Printer$$anon$2.prototype = new $h_jl_ThreadLocal();
$c_Lio_circe_Printer$$anon$2.prototype.constructor = $c_Lio_circe_Printer$$anon$2;
/** @constructor */
function $h_Lio_circe_Printer$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_Printer$$anon$2.prototype = $c_Lio_circe_Printer$$anon$2.prototype;
$c_Lio_circe_Printer$$anon$2.prototype.initialValue__O = (function() {
  return $ct_jl_StringBuilder__(new $c_jl_StringBuilder())
});
var $d_Lio_circe_Printer$$anon$2 = new $TypeData().initClass({
  Lio_circe_Printer$$anon$2: 0
}, false, "io.circe.Printer$$anon$2", {
  Lio_circe_Printer$$anon$2: 1,
  jl_ThreadLocal: 1,
  O: 1
});
$c_Lio_circe_Printer$$anon$2.prototype.$classData = $d_Lio_circe_Printer$$anon$2;
/** @constructor */
function $c_Lio_circe_Printer$$anon$3(outer) {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  $ct_jl_ThreadLocal__(this)
}
$c_Lio_circe_Printer$$anon$3.prototype = new $h_jl_ThreadLocal();
$c_Lio_circe_Printer$$anon$3.prototype.constructor = $c_Lio_circe_Printer$$anon$3;
/** @constructor */
function $h_Lio_circe_Printer$$anon$3() {
  /*<skip>*/
}
$h_Lio_circe_Printer$$anon$3.prototype = $c_Lio_circe_Printer$$anon$3.prototype;
$c_Lio_circe_Printer$$anon$3.prototype.initialValue__O = (function() {
  return new $c_Lio_circe_Printer$AdaptiveSizePredictor()
});
var $d_Lio_circe_Printer$$anon$3 = new $TypeData().initClass({
  Lio_circe_Printer$$anon$3: 0
}, false, "io.circe.Printer$$anon$3", {
  Lio_circe_Printer$$anon$3: 1,
  jl_ThreadLocal: 1,
  O: 1
});
$c_Lio_circe_Printer$$anon$3.prototype.$classData = $d_Lio_circe_Printer$$anon$3;
/** @constructor */
function $c_Lio_circe_Printer$AdaptiveSizePredictor() {
  /*<skip>*/
}
$c_Lio_circe_Printer$AdaptiveSizePredictor.prototype = new $h_Lio_circe_Printer$SizePredictor();
$c_Lio_circe_Printer$AdaptiveSizePredictor.prototype.constructor = $c_Lio_circe_Printer$AdaptiveSizePredictor;
/** @constructor */
function $h_Lio_circe_Printer$AdaptiveSizePredictor() {
  /*<skip>*/
}
$h_Lio_circe_Printer$AdaptiveSizePredictor.prototype = $c_Lio_circe_Printer$AdaptiveSizePredictor.prototype;
var $d_Lio_circe_Printer$AdaptiveSizePredictor = new $TypeData().initClass({
  Lio_circe_Printer$AdaptiveSizePredictor: 0
}, false, "io.circe.Printer$AdaptiveSizePredictor", {
  Lio_circe_Printer$AdaptiveSizePredictor: 1,
  Lio_circe_Printer$SizePredictor: 1,
  O: 1
});
$c_Lio_circe_Printer$AdaptiveSizePredictor.prototype.$classData = $d_Lio_circe_Printer$AdaptiveSizePredictor;
/** @constructor */
function $c_Lio_circe_Printer$PiecesAtDepth() {
  /*<skip>*/
}
$c_Lio_circe_Printer$PiecesAtDepth.prototype = new $h_O();
$c_Lio_circe_Printer$PiecesAtDepth.prototype.constructor = $c_Lio_circe_Printer$PiecesAtDepth;
/** @constructor */
function $h_Lio_circe_Printer$PiecesAtDepth() {
  /*<skip>*/
}
$h_Lio_circe_Printer$PiecesAtDepth.prototype = $c_Lio_circe_Printer$PiecesAtDepth.prototype;
/** @constructor */
function $c_Lio_circe_generic_decoding_ReprDecoder$() {
  this.Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult = null;
  $n_Lio_circe_generic_decoding_ReprDecoder$ = this;
  new $c_Lio_circe_generic_decoding_ReprDecoder$$anon$1();
  $n($m_s_package$().s_package$__f_Right);
  var value = $m_Lshapeless_HNil$();
  this.Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult = new $c_s_util_Right(value);
  $m_Lcats_data_Validated$();
  var a = $m_Lshapeless_HNil$();
  new $c_Lcats_data_Validated$Valid(a)
}
$c_Lio_circe_generic_decoding_ReprDecoder$.prototype = new $h_O();
$c_Lio_circe_generic_decoding_ReprDecoder$.prototype.constructor = $c_Lio_circe_generic_decoding_ReprDecoder$;
/** @constructor */
function $h_Lio_circe_generic_decoding_ReprDecoder$() {
  /*<skip>*/
}
$h_Lio_circe_generic_decoding_ReprDecoder$.prototype = $c_Lio_circe_generic_decoding_ReprDecoder$.prototype;
$c_Lio_circe_generic_decoding_ReprDecoder$.prototype.consResults__O__O__Lcats_Apply__O = (function(hv, tr, F) {
  return $n(F).map2__O__O__F2__O(hv, tr, new $c_sjsr_AnonFunction2(((v$2, t$2) => {
    var t = $as_Lshapeless_HList(t$2);
    new $c_Lshapeless_labelled$FieldBuilder();
    return new $c_Lshapeless_syntax_HListOps(t).$colon$colon__O__Lshapeless_$colon$colon(v$2)
  })))
});
$c_Lio_circe_generic_decoding_ReprDecoder$.prototype.injectLeftValue__O__Lshapeless_$colon$plus$colon = (function(v) {
  return new $c_Lshapeless_Inl((new $c_Lshapeless_labelled$FieldBuilder(), v))
});
var $d_Lio_circe_generic_decoding_ReprDecoder$ = new $TypeData().initClass({
  Lio_circe_generic_decoding_ReprDecoder$: 0
}, false, "io.circe.generic.decoding.ReprDecoder$", {
  Lio_circe_generic_decoding_ReprDecoder$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_decoding_ReprDecoder$.prototype.$classData = $d_Lio_circe_generic_decoding_ReprDecoder$;
var $n_Lio_circe_generic_decoding_ReprDecoder$;
function $m_Lio_circe_generic_decoding_ReprDecoder$() {
  if ((!$n_Lio_circe_generic_decoding_ReprDecoder$)) {
    $n_Lio_circe_generic_decoding_ReprDecoder$ = new $c_Lio_circe_generic_decoding_ReprDecoder$()
  };
  return $n_Lio_circe_generic_decoding_ReprDecoder$
}
/** @constructor */
function $c_Lio_circe_generic_extras_Configuration$() {
  this.Lio_circe_generic_extras_Configuration$__f_default = null;
  this.Lio_circe_generic_extras_Configuration$__f_basePattern = null;
  this.Lio_circe_generic_extras_Configuration$__f_swapPattern = null;
  $n_Lio_circe_generic_extras_Configuration$ = this;
  this.Lio_circe_generic_extras_Configuration$__f_default = new $c_Lio_circe_generic_extras_Configuration(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return x
  })), new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_T(x$3$2);
    return x$3
  })), false, $m_s_None$(), ($m_Lio_circe_generic_extras_Configuration$(), false));
  this.Lio_circe_generic_extras_Configuration$__f_basePattern = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("([A-Z]+)([A-Z][a-z])", 0);
  this.Lio_circe_generic_extras_Configuration$__f_swapPattern = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("([a-z\\d])([A-Z])", 0);
  new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    var this$6 = $n($m_Lio_circe_generic_extras_Configuration$().Lio_circe_generic_extras_Configuration$__f_basePattern);
    var this$7 = $n(s);
    var partial = new $c_ju_regex_Matcher(this$6, this$7).replaceAll__T__T("$1_$2");
    var this$8 = $n($m_Lio_circe_generic_extras_Configuration$().Lio_circe_generic_extras_Configuration$__f_swapPattern);
    var this$9 = $n(partial);
    var this$10 = $n(new $c_ju_regex_Matcher(this$8, this$9).replaceAll__T__T("$1_$2"));
    return $as_T(this$10.toLowerCase())
  }));
  new $c_sjsr_AnonFunction1(((s$3$2) => {
    var s$3 = $as_T(s$3$2);
    var this$11 = $n($m_Lio_circe_generic_extras_Configuration$().Lio_circe_generic_extras_Configuration$__f_basePattern);
    var this$12 = $n(s$3);
    var partial$1 = new $c_ju_regex_Matcher(this$11, this$12).replaceAll__T__T("$1-$2");
    var this$13 = $n($m_Lio_circe_generic_extras_Configuration$().Lio_circe_generic_extras_Configuration$__f_swapPattern);
    var this$14 = $n(partial$1);
    var this$15 = $n(new $c_ju_regex_Matcher(this$13, this$14).replaceAll__T__T("$1-$2"));
    return $as_T(this$15.toLowerCase())
  }))
}
$c_Lio_circe_generic_extras_Configuration$.prototype = new $h_O();
$c_Lio_circe_generic_extras_Configuration$.prototype.constructor = $c_Lio_circe_generic_extras_Configuration$;
/** @constructor */
function $h_Lio_circe_generic_extras_Configuration$() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_Configuration$.prototype = $c_Lio_circe_generic_extras_Configuration$.prototype;
var $d_Lio_circe_generic_extras_Configuration$ = new $TypeData().initClass({
  Lio_circe_generic_extras_Configuration$: 0
}, false, "io.circe.generic.extras.Configuration$", {
  Lio_circe_generic_extras_Configuration$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_Configuration$.prototype.$classData = $d_Lio_circe_generic_extras_Configuration$;
var $n_Lio_circe_generic_extras_Configuration$;
function $m_Lio_circe_generic_extras_Configuration$() {
  if ((!$n_Lio_circe_generic_extras_Configuration$)) {
    $n_Lio_circe_generic_extras_Configuration$ = new $c_Lio_circe_generic_extras_Configuration$()
  };
  return $n_Lio_circe_generic_extras_Configuration$
}
/** @constructor */
function $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$() {
  this.Lio_circe_generic_extras_codec_ReprAsObjectCodec$__f_hnilReprCodec = null;
  $n_Lio_circe_generic_extras_codec_ReprAsObjectCodec$ = this;
  this.Lio_circe_generic_extras_codec_ReprAsObjectCodec$__f_hnilReprCodec = new $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1()
}
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$.prototype = new $h_O();
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$.prototype.constructor = $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$;
/** @constructor */
function $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec$() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_codec_ReprAsObjectCodec$.prototype = $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$.prototype;
var $d_Lio_circe_generic_extras_codec_ReprAsObjectCodec$ = new $TypeData().initClass({
  Lio_circe_generic_extras_codec_ReprAsObjectCodec$: 0
}, false, "io.circe.generic.extras.codec.ReprAsObjectCodec$", {
  Lio_circe_generic_extras_codec_ReprAsObjectCodec$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$.prototype.$classData = $d_Lio_circe_generic_extras_codec_ReprAsObjectCodec$;
var $n_Lio_circe_generic_extras_codec_ReprAsObjectCodec$;
function $m_Lio_circe_generic_extras_codec_ReprAsObjectCodec$() {
  if ((!$n_Lio_circe_generic_extras_codec_ReprAsObjectCodec$)) {
    $n_Lio_circe_generic_extras_codec_ReprAsObjectCodec$ = new $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$()
  };
  return $n_Lio_circe_generic_extras_codec_ReprAsObjectCodec$
}
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ReprDecoder$() {
  this.Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder = null;
  $n_Lio_circe_generic_extras_decoding_ReprDecoder$ = this;
  this.Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder = new $c_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1()
}
$c_Lio_circe_generic_extras_decoding_ReprDecoder$.prototype = new $h_O();
$c_Lio_circe_generic_extras_decoding_ReprDecoder$.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ReprDecoder$;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ReprDecoder$() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ReprDecoder$.prototype = $c_Lio_circe_generic_extras_decoding_ReprDecoder$.prototype;
var $d_Lio_circe_generic_extras_decoding_ReprDecoder$ = new $TypeData().initClass({
  Lio_circe_generic_extras_decoding_ReprDecoder$: 0
}, false, "io.circe.generic.extras.decoding.ReprDecoder$", {
  Lio_circe_generic_extras_decoding_ReprDecoder$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_decoding_ReprDecoder$.prototype.$classData = $d_Lio_circe_generic_extras_decoding_ReprDecoder$;
var $n_Lio_circe_generic_extras_decoding_ReprDecoder$;
function $m_Lio_circe_generic_extras_decoding_ReprDecoder$() {
  if ((!$n_Lio_circe_generic_extras_decoding_ReprDecoder$)) {
    $n_Lio_circe_generic_extras_decoding_ReprDecoder$ = new $c_Lio_circe_generic_extras_decoding_ReprDecoder$()
  };
  return $n_Lio_circe_generic_extras_decoding_ReprDecoder$
}
/** @constructor */
function $c_Lio_circe_generic_extras_util_RecordToMap$$anon$1() {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_util_RecordToMap$$anon$1.prototype = new $h_Lio_circe_generic_extras_util_RecordToMap();
$c_Lio_circe_generic_extras_util_RecordToMap$$anon$1.prototype.constructor = $c_Lio_circe_generic_extras_util_RecordToMap$$anon$1;
/** @constructor */
function $h_Lio_circe_generic_extras_util_RecordToMap$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_util_RecordToMap$$anon$1.prototype = $c_Lio_circe_generic_extras_util_RecordToMap$$anon$1.prototype;
$c_Lio_circe_generic_extras_util_RecordToMap$$anon$1.prototype.apply__Lshapeless_HList__sci_Map = (function(r) {
  $as_Lshapeless_HNil(r);
  return $m_sci_Map$EmptyMap$()
});
var $d_Lio_circe_generic_extras_util_RecordToMap$$anon$1 = new $TypeData().initClass({
  Lio_circe_generic_extras_util_RecordToMap$$anon$1: 0
}, false, "io.circe.generic.extras.util.RecordToMap$$anon$1", {
  Lio_circe_generic_extras_util_RecordToMap$$anon$1: 1,
  Lio_circe_generic_extras_util_RecordToMap: 1,
  O: 1
});
$c_Lio_circe_generic_extras_util_RecordToMap$$anon$1.prototype.$classData = $d_Lio_circe_generic_extras_util_RecordToMap$$anon$1;
/** @constructor */
function $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1) {
  this.Lio_circe_generic_extras_util_RecordToMap$$anon$2__f_rtmT$1 = null;
  this.Lio_circe_generic_extras_util_RecordToMap$$anon$2__f_wit$1 = null;
  this.Lio_circe_generic_extras_util_RecordToMap$$anon$2__f_rtmT$1 = rtmT$1;
  this.Lio_circe_generic_extras_util_RecordToMap$$anon$2__f_wit$1 = wit$1
}
$c_Lio_circe_generic_extras_util_RecordToMap$$anon$2.prototype = new $h_Lio_circe_generic_extras_util_RecordToMap();
$c_Lio_circe_generic_extras_util_RecordToMap$$anon$2.prototype.constructor = $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2;
/** @constructor */
function $h_Lio_circe_generic_extras_util_RecordToMap$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_util_RecordToMap$$anon$2.prototype = $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2.prototype;
$c_Lio_circe_generic_extras_util_RecordToMap$$anon$2.prototype.apply__Lshapeless_$colon$colon__sci_Map = (function(r) {
  return $as_sci_Map($n($n(this.Lio_circe_generic_extras_util_RecordToMap$$anon$2__f_rtmT$1).apply__Lshapeless_HList__sci_Map($n(r).Lshapeless_$colon$colon__f_tail)).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), $n($as_s_Symbol($n(this.Lio_circe_generic_extras_util_RecordToMap$$anon$2__f_wit$1).value__O())).s_Symbol__f_name, $n(r).Lshapeless_$colon$colon__f_head)))
});
$c_Lio_circe_generic_extras_util_RecordToMap$$anon$2.prototype.apply__Lshapeless_HList__sci_Map = (function(r) {
  return this.apply__Lshapeless_$colon$colon__sci_Map($as_Lshapeless_$colon$colon(r))
});
var $d_Lio_circe_generic_extras_util_RecordToMap$$anon$2 = new $TypeData().initClass({
  Lio_circe_generic_extras_util_RecordToMap$$anon$2: 0
}, false, "io.circe.generic.extras.util.RecordToMap$$anon$2", {
  Lio_circe_generic_extras_util_RecordToMap$$anon$2: 1,
  Lio_circe_generic_extras_util_RecordToMap: 1,
  O: 1
});
$c_Lio_circe_generic_extras_util_RecordToMap$$anon$2.prototype.$classData = $d_Lio_circe_generic_extras_util_RecordToMap$$anon$2;
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal() {
  /*<skip>*/
}
$c_Lio_circe_numbers_BiggerDecimal.prototype = new $h_O();
$c_Lio_circe_numbers_BiggerDecimal.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal.prototype = $c_Lio_circe_numbers_BiggerDecimal.prototype;
function $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal($thiz, unscaled, scale) {
  var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(unscaled, yn)) {
    return $thiz.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero
  } else {
    var current = unscaled;
    var lo = scale.RTLong__f_lo;
    var hi = scale.RTLong__f_hi;
    var depth__lo = lo;
    var depth__hi = hi;
    var divAndRem = $n(current).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
    while (true) {
      var xn = $n(divAndRem).get(1);
      var yn$1 = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn$1)) {
        current = $n(divAndRem).get(0);
        var b__lo = depth__lo;
        var b__hi = depth__hi;
        var bhi = b__hi;
        var lo$1 = (((-1) + b__lo) | 0);
        var hi$1 = ((lo$1 !== (-1)) ? bhi : (((-1) + bhi) | 0));
        var $$x1__lo = lo$1;
        var $$x1__hi = hi$1;
        depth__lo = $$x1__lo;
        depth__hi = $$x1__hi;
        divAndRem = $n(current).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN)
      } else {
        break
      }
    };
    var $$x2 = current;
    var lVal__lo = depth__lo;
    var lVal__hi = depth__hi;
    return new $c_Lio_circe_numbers_SigAndExp($$x2, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lVal__lo, lVal__hi)))
  }
}
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$() {
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxInt = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MinInt = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero = null;
  $n_Lio_circe_numbers_BiggerDecimal$ = this;
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(262144, 0));
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxInt = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(2147483647, 0));
  this.Lio_circe_numbers_BiggerDecimal$__f_MinInt = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-2147483648), (-1)));
  $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong((-1), 2147483647));
  $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong(0, (-2147483648)));
  this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero = new $c_Lio_circe_numbers_BiggerDecimal$$anon$1();
  this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero = new $c_Lio_circe_numbers_BiggerDecimal$$anon$2()
}
$c_Lio_circe_numbers_BiggerDecimal$.prototype = new $h_O();
$c_Lio_circe_numbers_BiggerDecimal$.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal$.prototype = $c_Lio_circe_numbers_BiggerDecimal$.prototype;
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromLong__J__Lio_circe_numbers_BiggerDecimal = (function(d) {
  return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(d), $L0)
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromDoubleUnsafe__D__Lio_circe_numbers_BiggerDecimal = (function(d) {
  if (($m_jl_Double$().compare__D__D__I(d, (-0)) === 0)) {
    return this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero
  } else {
    var d$1 = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
    var this$1 = $n(d$1);
    var $$x1 = this$1.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var this$2 = $n(d$1);
    var value = this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $$x1, new $c_RTLong(value, hi))
  }
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromFloat__F__Lio_circe_numbers_BiggerDecimal = (function(f) {
  if (($m_jl_Double$().compare__D__D__I(f, (-0)) === 0)) {
    return this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero
  } else {
    var d = $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), ("" + f));
    var $$x1 = d.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = d.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $$x1, new $c_RTLong(value, hi))
  }
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.parseBiggerDecimalUnsafe__T__Lio_circe_numbers_BiggerDecimal = (function(input) {
  var this$1 = $n(input);
  var len = this$1.length;
  if ((len === 0)) {
    return null
  } else {
    var zeros = 0;
    var decIndex = (-1);
    var expIndex = (-1);
    var this$2 = $n(input);
    if (($charAt(this$2, 0) === 45)) {
      var i = 1
    } else {
      var i = 0
    };
    if ((i >= len)) {
      var state = 0
    } else {
      var this$3 = $n(input);
      var index = i;
      if (($charAt(this$3, index) !== 48)) {
        var state = 1
      } else {
        i = ((1 + i) | 0);
        var state = 2
      }
    };
    while (((i < len) && (state !== 0))) {
      var this$4 = $n(input);
      var index$1 = i;
      var c = $charAt(this$4, index$1);
      var x1 = state;
      switch (x1) {
        case 1: {
          if (((c >= 49) && (c <= 57))) {
            state = 8
          } else {
            state = 0
          };
          break
        }
        case 2: {
          if ((c === 46)) {
            state = 3
          } else if (((c === 101) || (c === 69))) {
            state = 5
          } else {
            state = 0
          };
          break
        }
        case 8: {
          if ((c === 48)) {
            zeros = ((1 + zeros) | 0);
            state = 8
          } else if (((c >= 49) && (c <= 57))) {
            zeros = 0;
            state = 8
          } else if ((c === 46)) {
            state = 3
          } else if (((c === 101) || (c === 69))) {
            state = 5
          } else {
            state = 0
          };
          break
        }
        case 3: {
          decIndex = (((-1) + i) | 0);
          if ((c === 48)) {
            zeros = ((1 + zeros) | 0);
            state = 4
          } else if (((c >= 49) && (c <= 57))) {
            zeros = 0;
            state = 4
          } else {
            state = 0
          };
          break
        }
        case 5: {
          expIndex = (((-1) + i) | 0);
          if (((c >= 48) && (c <= 57))) {
            state = 7
          } else if (((c === 43) || (c === 45))) {
            state = 6
          } else {
            state = 0
          };
          break
        }
        case 4: {
          if ((c === 48)) {
            zeros = ((1 + zeros) | 0);
            state = 4
          } else if (((c >= 49) && (c <= 57))) {
            zeros = 0;
            state = 4
          } else if (((c === 101) || (c === 69))) {
            state = 5
          } else {
            state = 0
          };
          break
        }
        case 6: {
          if (((c >= 48) && (c <= 57))) {
            state = 7
          } else {
            state = 0
          };
          break
        }
        case 7: {
          if (((c >= 48) && (c <= 57))) {
            state = 7
          } else {
            state = 0
          };
          break
        }
        default: {
          throw new $c_s_MatchError(x1)
        }
      };
      i = ((1 + i) | 0)
    };
    if (((((state === 0) || (state === 3)) || (state === 5)) || (state === 6))) {
      return null
    } else {
      if ((decIndex >= 0)) {
        var this$5 = $n(input);
        var endIndex = decIndex;
        if ((endIndex > this$5.length)) {
          $charAt(this$5, endIndex)
        };
        if ((endIndex < 0)) {
          $charAt(this$5, (-1))
        };
        var integral = $as_T(this$5.substring(0, endIndex))
      } else if ((expIndex === (-1))) {
        var integral = input
      } else {
        var this$6 = $n(input);
        var endIndex$1 = expIndex;
        if ((endIndex$1 > this$6.length)) {
          $charAt(this$6, endIndex$1)
        };
        if ((endIndex$1 < 0)) {
          $charAt(this$6, (-1))
        };
        var integral = $as_T(this$6.substring(0, endIndex$1))
      };
      if ((decIndex === (-1))) {
        var fractional = ""
      } else if ((expIndex === (-1))) {
        var this$7 = $n(input);
        var beginIndex = ((1 + decIndex) | 0);
        if (((beginIndex < 0) || (beginIndex > this$7.length))) {
          $charAt(this$7, beginIndex)
        };
        var fractional = $as_T(this$7.substring(beginIndex))
      } else {
        var this$8 = $n(input);
        var beginIndex$1 = ((1 + decIndex) | 0);
        var endIndex$2 = expIndex;
        if ((beginIndex$1 < 0)) {
          $charAt(this$8, beginIndex$1)
        };
        if ((endIndex$2 > this$8.length)) {
          $charAt(this$8, endIndex$2)
        };
        if ((endIndex$2 < beginIndex$1)) {
          $charAt(this$8, (-1))
        };
        var fractional = $as_T(this$8.substring(beginIndex$1, endIndex$2))
      };
      var unscaledString = (("" + integral) + fractional);
      var endIndex$3 = ((unscaledString.length - zeros) | 0);
      if ((endIndex$3 > unscaledString.length)) {
        $charAt(unscaledString, endIndex$3)
      };
      if ((endIndex$3 < 0)) {
        $charAt(unscaledString, (-1))
      };
      var unscaled = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), $as_T(unscaledString.substring(0, endIndex$3)));
      var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(unscaled, yn)) {
        var this$9 = $n(input);
        if (($charAt(this$9, 0) === 45)) {
          return this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero
        } else {
          return this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero
        }
      } else {
        var this$10 = $n(fractional);
        var value = ((this$10.length - zeros) | 0);
        var hi = (value >> 31);
        var rescale = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(value, hi));
        if ((expIndex === (-1))) {
          var scale = rescale
        } else {
          var this$13 = $n(rescale);
          var this$12 = $n(input);
          var beginIndex$2 = ((1 + expIndex) | 0);
          if (((beginIndex$2 < 0) || (beginIndex$2 > this$12.length))) {
            $charAt(this$12, beginIndex$2)
          };
          var bi = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), $as_T(this$12.substring(beginIndex$2)));
          var scale = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$13, bi)
        };
        return new $c_Lio_circe_numbers_SigAndExp(unscaled, scale)
      }
    }
  }
});
var $d_Lio_circe_numbers_BiggerDecimal$ = new $TypeData().initClass({
  Lio_circe_numbers_BiggerDecimal$: 0
}, false, "io.circe.numbers.BiggerDecimal$", {
  Lio_circe_numbers_BiggerDecimal$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.$classData = $d_Lio_circe_numbers_BiggerDecimal$;
var $n_Lio_circe_numbers_BiggerDecimal$;
function $m_Lio_circe_numbers_BiggerDecimal$() {
  if ((!$n_Lio_circe_numbers_BiggerDecimal$)) {
    $n_Lio_circe_numbers_BiggerDecimal$ = new $c_Lio_circe_numbers_BiggerDecimal$()
  };
  return $n_Lio_circe_numbers_BiggerDecimal$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$Children(construct, mods) {
  this.Ljapgolly_scalajs_react_CtorType$Children__f_construct = null;
  this.Ljapgolly_scalajs_react_CtorType$Children__f_mods = null;
  this.Ljapgolly_scalajs_react_CtorType$Children__f_construct = construct;
  this.Ljapgolly_scalajs_react_CtorType$Children__f_mods = mods
}
$c_Ljapgolly_scalajs_react_CtorType$Children.prototype = new $h_Ljapgolly_scalajs_react_CtorType();
$c_Ljapgolly_scalajs_react_CtorType$Children.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$Children;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$Children() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$Children.prototype = $c_Ljapgolly_scalajs_react_CtorType$Children.prototype;
$c_Ljapgolly_scalajs_react_CtorType$Children.prototype.addMod__F1__Ljapgolly_scalajs_react_CtorType$Children = (function(f) {
  return new $c_Ljapgolly_scalajs_react_CtorType$Children(this.Ljapgolly_scalajs_react_CtorType$Children__f_construct, $m_Ljapgolly_scalajs_react_CtorType$().japgolly$scalajs$react$CtorType$$modAppend__sjs_js_$bar__F1__sjs_js_$bar(this.Ljapgolly_scalajs_react_CtorType$Children__f_mods, f))
});
$c_Ljapgolly_scalajs_react_CtorType$Children.prototype.addMod__F1__Ljapgolly_scalajs_react_CtorType = (function(f) {
  return this.addMod__F1__Ljapgolly_scalajs_react_CtorType$Children(f)
});
function $as_Ljapgolly_scalajs_react_CtorType$Children(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_CtorType$Children) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.CtorType$Children"))
}
function $isArrayOf_Ljapgolly_scalajs_react_CtorType$Children(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_CtorType$Children)))
}
function $asArrayOf_Ljapgolly_scalajs_react_CtorType$Children(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_CtorType$Children(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.CtorType$Children;", depth))
}
var $d_Ljapgolly_scalajs_react_CtorType$Children = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$Children: 0
}, false, "japgolly.scalajs.react.CtorType$Children", {
  Ljapgolly_scalajs_react_CtorType$Children: 1,
  Ljapgolly_scalajs_react_CtorType: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_CtorType$Children.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$Children;
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$Nullary(unmodified, construct, mods) {
  this.Ljapgolly_scalajs_react_CtorType$Nullary__f_unmodified = null;
  this.Ljapgolly_scalajs_react_CtorType$Nullary__f_construct = null;
  this.Ljapgolly_scalajs_react_CtorType$Nullary__f_mods = null;
  this.Ljapgolly_scalajs_react_CtorType$Nullary__f_unmodified = unmodified;
  this.Ljapgolly_scalajs_react_CtorType$Nullary__f_construct = construct;
  this.Ljapgolly_scalajs_react_CtorType$Nullary__f_mods = mods
}
$c_Ljapgolly_scalajs_react_CtorType$Nullary.prototype = new $h_Ljapgolly_scalajs_react_CtorType();
$c_Ljapgolly_scalajs_react_CtorType$Nullary.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$Nullary;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$Nullary() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$Nullary.prototype = $c_Ljapgolly_scalajs_react_CtorType$Nullary.prototype;
$c_Ljapgolly_scalajs_react_CtorType$Nullary.prototype.apply__O = (function() {
  var value = this.Ljapgolly_scalajs_react_CtorType$Nullary__f_mods;
  var f = this.Ljapgolly_scalajs_react_CtorType$Nullary__f_construct;
  return ((value === (void 0)) ? this.Ljapgolly_scalajs_react_CtorType$Nullary__f_unmodified : $n(f).apply__O__O(value))
});
$c_Ljapgolly_scalajs_react_CtorType$Nullary.prototype.addMod__F1__Ljapgolly_scalajs_react_CtorType$Nullary = (function(f) {
  return new $c_Ljapgolly_scalajs_react_CtorType$Nullary(this.Ljapgolly_scalajs_react_CtorType$Nullary__f_unmodified, this.Ljapgolly_scalajs_react_CtorType$Nullary__f_construct, $m_Ljapgolly_scalajs_react_CtorType$().japgolly$scalajs$react$CtorType$$modAppend__sjs_js_$bar__F1__sjs_js_$bar(this.Ljapgolly_scalajs_react_CtorType$Nullary__f_mods, f))
});
$c_Ljapgolly_scalajs_react_CtorType$Nullary.prototype.addMod__F1__Ljapgolly_scalajs_react_CtorType = (function(f) {
  return this.addMod__F1__Ljapgolly_scalajs_react_CtorType$Nullary(f)
});
function $as_Ljapgolly_scalajs_react_CtorType$Nullary(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_CtorType$Nullary) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.CtorType$Nullary"))
}
function $isArrayOf_Ljapgolly_scalajs_react_CtorType$Nullary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_CtorType$Nullary)))
}
function $asArrayOf_Ljapgolly_scalajs_react_CtorType$Nullary(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_CtorType$Nullary(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.CtorType$Nullary;", depth))
}
var $d_Ljapgolly_scalajs_react_CtorType$Nullary = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$Nullary: 0
}, false, "japgolly.scalajs.react.CtorType$Nullary", {
  Ljapgolly_scalajs_react_CtorType$Nullary: 1,
  Ljapgolly_scalajs_react_CtorType: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_CtorType$Nullary.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$Nullary;
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$ProfunctorC$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$ProfunctorC$.prototype = $c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$.prototype;
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$.prototype.rmap__Ljapgolly_scalajs_react_CtorType$Children__F1__Ljapgolly_scalajs_react_CtorType$Children = (function(ct, g) {
  var fn = $n(ct).Ljapgolly_scalajs_react_CtorType$Children__f_construct;
  return new $c_Ljapgolly_scalajs_react_CtorType$Children(new $c_sjsr_AnonFunction2(((m$2, c$2) => {
    var c = $as_sci_Seq(c$2);
    return $n(g).apply__O__O($n(fn).apply__O__O__O(m$2, c))
  })), $n(ct).Ljapgolly_scalajs_react_CtorType$Children__f_mods)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$.prototype.dimap__Ljapgolly_scalajs_react_CtorType$Children__F1__F1__Ljapgolly_scalajs_react_CtorType$Children = (function(ct, f, g) {
  var fn = $n(ct).Ljapgolly_scalajs_react_CtorType$Children__f_construct;
  return new $c_Ljapgolly_scalajs_react_CtorType$Children(new $c_sjsr_AnonFunction2(((m$2, c$2) => {
    var c = $as_sci_Seq(c$2);
    return $n(g).apply__O__O($n(fn).apply__O__O__O(m$2, c))
  })), $n(ct).Ljapgolly_scalajs_react_CtorType$Children__f_mods)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$.prototype.dimap__O__F1__F1__O = (function(f, l, r) {
  return this.dimap__Ljapgolly_scalajs_react_CtorType$Children__F1__F1__Ljapgolly_scalajs_react_CtorType$Children($as_Ljapgolly_scalajs_react_CtorType$Children(f), l, r)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$.prototype.rmap__O__F1__O = (function(f, m) {
  return this.rmap__Ljapgolly_scalajs_react_CtorType$Children__F1__Ljapgolly_scalajs_react_CtorType$Children($as_Ljapgolly_scalajs_react_CtorType$Children(f), m)
});
var $d_Ljapgolly_scalajs_react_CtorType$ProfunctorC$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$ProfunctorC$: 0
}, false, "japgolly.scalajs.react.CtorType$ProfunctorC$", {
  Ljapgolly_scalajs_react_CtorType$ProfunctorC$: 1,
  O: 1,
  Ljapgolly_scalajs_react_internal_Profunctor: 1
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$ProfunctorC$;
var $n_Ljapgolly_scalajs_react_CtorType$ProfunctorC$;
function $m_Ljapgolly_scalajs_react_CtorType$ProfunctorC$() {
  if ((!$n_Ljapgolly_scalajs_react_CtorType$ProfunctorC$)) {
    $n_Ljapgolly_scalajs_react_CtorType$ProfunctorC$ = new $c_Ljapgolly_scalajs_react_CtorType$ProfunctorC$()
  };
  return $n_Ljapgolly_scalajs_react_CtorType$ProfunctorC$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$ProfunctorF$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$ProfunctorF$.prototype = $c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$.prototype;
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$.prototype.rmap__Ljapgolly_scalajs_react_CtorType$PropsAndChildren__F1__Ljapgolly_scalajs_react_CtorType$PropsAndChildren = (function(ct, g) {
  var fn = $n(ct).Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct;
  return new $c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(new $c_sjsr_AnonFunction3(((p$2, m$2, c$2) => {
    var c = $as_sci_Seq(c$2);
    return $n(g).apply__O__O($n(fn).apply__O__O__O__O(p$2, m$2, c))
  })), $n(ct).Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$.prototype.dimap__Ljapgolly_scalajs_react_CtorType$PropsAndChildren__F1__F1__Ljapgolly_scalajs_react_CtorType$PropsAndChildren = (function(ct, f, g) {
  var fn = $n(ct).Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct;
  return new $c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(new $c_sjsr_AnonFunction3(((p$2, m$2, c$2) => {
    var c = $as_sci_Seq(c$2);
    return $n(g).apply__O__O($n(fn).apply__O__O__O__O($n(f).apply__O__O(p$2), m$2, c))
  })), $n(ct).Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$.prototype.dimap__O__F1__F1__O = (function(f, l, r) {
  return this.dimap__Ljapgolly_scalajs_react_CtorType$PropsAndChildren__F1__F1__Ljapgolly_scalajs_react_CtorType$PropsAndChildren($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(f), l, r)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$.prototype.rmap__O__F1__O = (function(f, m) {
  return this.rmap__Ljapgolly_scalajs_react_CtorType$PropsAndChildren__F1__Ljapgolly_scalajs_react_CtorType$PropsAndChildren($as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(f), m)
});
var $d_Ljapgolly_scalajs_react_CtorType$ProfunctorF$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$ProfunctorF$: 0
}, false, "japgolly.scalajs.react.CtorType$ProfunctorF$", {
  Ljapgolly_scalajs_react_CtorType$ProfunctorF$: 1,
  O: 1,
  Ljapgolly_scalajs_react_internal_Profunctor: 1
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$ProfunctorF$;
var $n_Ljapgolly_scalajs_react_CtorType$ProfunctorF$;
function $m_Ljapgolly_scalajs_react_CtorType$ProfunctorF$() {
  if ((!$n_Ljapgolly_scalajs_react_CtorType$ProfunctorF$)) {
    $n_Ljapgolly_scalajs_react_CtorType$ProfunctorF$ = new $c_Ljapgolly_scalajs_react_CtorType$ProfunctorF$()
  };
  return $n_Ljapgolly_scalajs_react_CtorType$ProfunctorF$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$ProfunctorN$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$ProfunctorN$.prototype = $c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$.prototype;
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$.prototype.rmap__Ljapgolly_scalajs_react_CtorType$Nullary__F1__Ljapgolly_scalajs_react_CtorType$Nullary = (function(x, g) {
  return new $c_Ljapgolly_scalajs_react_CtorType$Nullary($n(g).apply__O__O($n(x).Ljapgolly_scalajs_react_CtorType$Nullary__f_unmodified), $n(g).compose__F1__F1($n(x).Ljapgolly_scalajs_react_CtorType$Nullary__f_construct), $n(x).Ljapgolly_scalajs_react_CtorType$Nullary__f_mods)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$.prototype.dimap__Ljapgolly_scalajs_react_CtorType$Nullary__F1__F1__Ljapgolly_scalajs_react_CtorType$Nullary = (function(x, f, g) {
  return new $c_Ljapgolly_scalajs_react_CtorType$Nullary($n(g).apply__O__O($n(x).Ljapgolly_scalajs_react_CtorType$Nullary__f_unmodified), $n(g).compose__F1__F1($n(x).Ljapgolly_scalajs_react_CtorType$Nullary__f_construct), $n(x).Ljapgolly_scalajs_react_CtorType$Nullary__f_mods)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$.prototype.dimap__O__F1__F1__O = (function(f, l, r) {
  return this.dimap__Ljapgolly_scalajs_react_CtorType$Nullary__F1__F1__Ljapgolly_scalajs_react_CtorType$Nullary($as_Ljapgolly_scalajs_react_CtorType$Nullary(f), l, r)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$.prototype.rmap__O__F1__O = (function(f, m) {
  return this.rmap__Ljapgolly_scalajs_react_CtorType$Nullary__F1__Ljapgolly_scalajs_react_CtorType$Nullary($as_Ljapgolly_scalajs_react_CtorType$Nullary(f), m)
});
var $d_Ljapgolly_scalajs_react_CtorType$ProfunctorN$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$ProfunctorN$: 0
}, false, "japgolly.scalajs.react.CtorType$ProfunctorN$", {
  Ljapgolly_scalajs_react_CtorType$ProfunctorN$: 1,
  O: 1,
  Ljapgolly_scalajs_react_internal_Profunctor: 1
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$ProfunctorN$;
var $n_Ljapgolly_scalajs_react_CtorType$ProfunctorN$;
function $m_Ljapgolly_scalajs_react_CtorType$ProfunctorN$() {
  if ((!$n_Ljapgolly_scalajs_react_CtorType$ProfunctorN$)) {
    $n_Ljapgolly_scalajs_react_CtorType$ProfunctorN$ = new $c_Ljapgolly_scalajs_react_CtorType$ProfunctorN$()
  };
  return $n_Ljapgolly_scalajs_react_CtorType$ProfunctorN$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$ProfunctorP$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$ProfunctorP$.prototype = $c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$.prototype;
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$.prototype.rmap__Ljapgolly_scalajs_react_CtorType$Props__F1__Ljapgolly_scalajs_react_CtorType$Props = (function(ct, g) {
  var fn = $n(ct).Ljapgolly_scalajs_react_CtorType$Props__f_construct;
  return new $c_Ljapgolly_scalajs_react_CtorType$Props(new $c_sjsr_AnonFunction2(((p$2, m$2) => $n(g).apply__O__O($n(fn).apply__O__O__O(p$2, m$2)))), $n(ct).Ljapgolly_scalajs_react_CtorType$Props__f_mods)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$.prototype.dimap__Ljapgolly_scalajs_react_CtorType$Props__F1__F1__Ljapgolly_scalajs_react_CtorType$Props = (function(ct, f, g) {
  var fn = $n(ct).Ljapgolly_scalajs_react_CtorType$Props__f_construct;
  return new $c_Ljapgolly_scalajs_react_CtorType$Props(new $c_sjsr_AnonFunction2(((p$2, m$2) => $n(g).apply__O__O($n(fn).apply__O__O__O($n(f).apply__O__O(p$2), m$2)))), $n(ct).Ljapgolly_scalajs_react_CtorType$Props__f_mods)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$.prototype.dimap__O__F1__F1__O = (function(f, l, r) {
  return this.dimap__Ljapgolly_scalajs_react_CtorType$Props__F1__F1__Ljapgolly_scalajs_react_CtorType$Props($as_Ljapgolly_scalajs_react_CtorType$Props(f), l, r)
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$.prototype.rmap__O__F1__O = (function(f, m) {
  return this.rmap__Ljapgolly_scalajs_react_CtorType$Props__F1__Ljapgolly_scalajs_react_CtorType$Props($as_Ljapgolly_scalajs_react_CtorType$Props(f), m)
});
var $d_Ljapgolly_scalajs_react_CtorType$ProfunctorP$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$ProfunctorP$: 0
}, false, "japgolly.scalajs.react.CtorType$ProfunctorP$", {
  Ljapgolly_scalajs_react_CtorType$ProfunctorP$: 1,
  O: 1,
  Ljapgolly_scalajs_react_internal_Profunctor: 1
});
$c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$ProfunctorP$;
var $n_Ljapgolly_scalajs_react_CtorType$ProfunctorP$;
function $m_Ljapgolly_scalajs_react_CtorType$ProfunctorP$() {
  if ((!$n_Ljapgolly_scalajs_react_CtorType$ProfunctorP$)) {
    $n_Ljapgolly_scalajs_react_CtorType$ProfunctorP$ = new $c_Ljapgolly_scalajs_react_CtorType$ProfunctorP$()
  };
  return $n_Ljapgolly_scalajs_react_CtorType$ProfunctorP$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$Props(construct, mods) {
  this.Ljapgolly_scalajs_react_CtorType$Props__f_construct = null;
  this.Ljapgolly_scalajs_react_CtorType$Props__f_mods = null;
  this.Ljapgolly_scalajs_react_CtorType$Props__f_construct = construct;
  this.Ljapgolly_scalajs_react_CtorType$Props__f_mods = mods
}
$c_Ljapgolly_scalajs_react_CtorType$Props.prototype = new $h_Ljapgolly_scalajs_react_CtorType();
$c_Ljapgolly_scalajs_react_CtorType$Props.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$Props;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$Props() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$Props.prototype = $c_Ljapgolly_scalajs_react_CtorType$Props.prototype;
$c_Ljapgolly_scalajs_react_CtorType$Props.prototype.addMod__F1__Ljapgolly_scalajs_react_CtorType$Props = (function(f) {
  return new $c_Ljapgolly_scalajs_react_CtorType$Props(this.Ljapgolly_scalajs_react_CtorType$Props__f_construct, $m_Ljapgolly_scalajs_react_CtorType$().japgolly$scalajs$react$CtorType$$modAppend__sjs_js_$bar__F1__sjs_js_$bar(this.Ljapgolly_scalajs_react_CtorType$Props__f_mods, f))
});
$c_Ljapgolly_scalajs_react_CtorType$Props.prototype.addMod__F1__Ljapgolly_scalajs_react_CtorType = (function(f) {
  return this.addMod__F1__Ljapgolly_scalajs_react_CtorType$Props(f)
});
function $as_Ljapgolly_scalajs_react_CtorType$Props(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_CtorType$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.CtorType$Props"))
}
function $isArrayOf_Ljapgolly_scalajs_react_CtorType$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_CtorType$Props)))
}
function $asArrayOf_Ljapgolly_scalajs_react_CtorType$Props(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_CtorType$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.CtorType$Props;", depth))
}
var $d_Ljapgolly_scalajs_react_CtorType$Props = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$Props: 0
}, false, "japgolly.scalajs.react.CtorType$Props", {
  Ljapgolly_scalajs_react_CtorType$Props: 1,
  Ljapgolly_scalajs_react_CtorType: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_CtorType$Props.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$Props;
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(construct, mods) {
  this.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct = null;
  this.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods = null;
  this.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct = construct;
  this.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods = mods
}
$c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren.prototype = new $h_Ljapgolly_scalajs_react_CtorType();
$c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$PropsAndChildren() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$PropsAndChildren.prototype = $c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren.prototype;
$c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren.prototype.addMod__F1__Ljapgolly_scalajs_react_CtorType$PropsAndChildren = (function(f) {
  return new $c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(this.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_construct, $m_Ljapgolly_scalajs_react_CtorType$().japgolly$scalajs$react$CtorType$$modAppend__sjs_js_$bar__F1__sjs_js_$bar(this.Ljapgolly_scalajs_react_CtorType$PropsAndChildren__f_mods, f))
});
$c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren.prototype.addMod__F1__Ljapgolly_scalajs_react_CtorType = (function(f) {
  return this.addMod__F1__Ljapgolly_scalajs_react_CtorType$PropsAndChildren(f)
});
function $as_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.CtorType$PropsAndChildren"))
}
function $isArrayOf_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_CtorType$PropsAndChildren)))
}
function $asArrayOf_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_CtorType$PropsAndChildren(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.CtorType$PropsAndChildren;", depth))
}
var $d_Ljapgolly_scalajs_react_CtorType$PropsAndChildren = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$PropsAndChildren: 0
}, false, "japgolly.scalajs.react.CtorType$PropsAndChildren", {
  Ljapgolly_scalajs_react_CtorType$PropsAndChildren: 1,
  Ljapgolly_scalajs_react_CtorType: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_CtorType$PropsAndChildren.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$PropsAndChildren;
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1(f$7, p$3) {
  this.Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_summon = null;
  this.Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_pf = null;
  this.Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_summon = f$7;
  this.Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_pf = p$3
}
$c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1.prototype = $c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1.prototype;
var $d_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1: 0
}, false, "japgolly.scalajs.react.CtorType$Summoner$$anon$1", {
  Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_CtorType$Summoner: 1
});
$c_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1.prototype = $c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1.prototype.apply__F2__F2__F1 = (function(P, S) {
  return new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(x$1$2);
    return $n(x$1).shouldComponentUpdatePure__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((i$2) => {
      var i = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(i$2);
      $m_Ljapgolly_scalajs_react_Reusability$();
      var this$2 = $n(i);
      var x = $n(this$2.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O();
      var y = $n(i).Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextProps;
      if ((!$uZ($n(P).apply__O__O__O(x, y)))) {
        return true
      } else {
        $m_Ljapgolly_scalajs_react_Reusability$();
        var this$4 = $n(i);
        var x$2 = $n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O();
        var y$1 = $n(i).Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextState;
        return (!$uZ($n(S).apply__O__O__O(x$2, y$1)))
      }
    })))
  }))
});
var $d_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1: 0
}, false, "japgolly.scalajs.react.ScalaJsReactConfig$ReusabilityOverride$$anon$1", {
  Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride: 1
});
$c_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_ScalaJsReactConfig$ReusabilityOverride$$anon$1;
function $f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O($thiz, mod) {
  var $$x1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return $thiz.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(mod, $$x1, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
}
function $f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, mod, callback, G) {
  return $thiz.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($n(mod).andThen__F1__F1(new $c_sjsr_AnonFunction1(((x$3$2) => new $c_s_Some(x$3$2)))), callback, G)
}
function $f_Ljapgolly_scalajs_react_StateAccess$ModState__modStateOption__F1__O($thiz, mod) {
  var $$x1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return $thiz.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(mod, $$x1, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
}
function $f_Ljapgolly_scalajs_react_StateAccess$ModState__modStateAsync__F1__O($thiz, mod) {
  var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var $$x1 = new $c_sjsr_AnonFunction0((() => x$4$2));
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return $thiz.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(mod, $$x1, this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
  }));
  return $f_Ljapgolly_scalajs_react_StateAccess$Base__async__F1__O($thiz, f)
}
function $is_Ljapgolly_scalajs_react_StateAccess$ModState(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_StateAccess$ModState)))
}
function $as_Ljapgolly_scalajs_react_StateAccess$ModState(obj) {
  return (($is_Ljapgolly_scalajs_react_StateAccess$ModState(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.StateAccess$ModState"))
}
function $isArrayOf_Ljapgolly_scalajs_react_StateAccess$ModState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_StateAccess$ModState)))
}
function $asArrayOf_Ljapgolly_scalajs_react_StateAccess$ModState(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_StateAccess$ModState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.StateAccess$ModState;", depth))
}
function $f_Ljapgolly_scalajs_react_StateAccess$ModStateWithProps__modState__F2__O($thiz, mod) {
  var $$x1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return $thiz.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(mod, $$x1, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
}
function $f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O($thiz, newState) {
  var $$x1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return $thiz.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(newState, $$x1, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync)
}
function $f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, newState, callback, G) {
  return $thiz.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(newState), callback, G)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(value) {
  this.Ljapgolly_scalajs_react_callback_Trampoline$Delay__f_value = null;
  this.Ljapgolly_scalajs_react_callback_Trampoline$Delay__f_value = value
}
$c_Ljapgolly_scalajs_react_callback_Trampoline$Delay.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_Trampoline$Delay.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_Trampoline$Delay() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_Trampoline$Delay.prototype = $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay.prototype;
function $as_Ljapgolly_scalajs_react_callback_Trampoline$Delay(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.Trampoline$Delay"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$Delay(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_Trampoline$Delay)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$Delay(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$Delay(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.Trampoline$Delay;", depth))
}
var $d_Ljapgolly_scalajs_react_callback_Trampoline$Delay = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_Trampoline$Delay: 0
}, false, "japgolly.scalajs.react.callback.Trampoline$Delay", {
  Ljapgolly_scalajs_react_callback_Trampoline$Delay: 1,
  O: 1,
  Ljapgolly_scalajs_react_callback_Trampoline: 1
});
$c_Ljapgolly_scalajs_react_callback_Trampoline$Delay.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_Trampoline$Delay;
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap(from, f) {
  this.Ljapgolly_scalajs_react_callback_Trampoline$FlatMap__f_from = null;
  this.Ljapgolly_scalajs_react_callback_Trampoline$FlatMap__f_f = null;
  this.Ljapgolly_scalajs_react_callback_Trampoline$FlatMap__f_from = from;
  this.Ljapgolly_scalajs_react_callback_Trampoline$FlatMap__f_f = f
}
$c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap.prototype = $c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap.prototype;
function $as_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.Trampoline$FlatMap"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_Trampoline$FlatMap)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.Trampoline$FlatMap;", depth))
}
var $d_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_Trampoline$FlatMap: 0
}, false, "japgolly.scalajs.react.callback.Trampoline$FlatMap", {
  Ljapgolly_scalajs_react_callback_Trampoline$FlatMap: 1,
  O: 1,
  Ljapgolly_scalajs_react_callback_Trampoline: 1
});
$c_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_Trampoline$FlatMap;
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(value) {
  this.Ljapgolly_scalajs_react_callback_Trampoline$Pure__f_value = null;
  this.Ljapgolly_scalajs_react_callback_Trampoline$Pure__f_value = value
}
$c_Ljapgolly_scalajs_react_callback_Trampoline$Pure.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_Trampoline$Pure.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_Trampoline$Pure() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_Trampoline$Pure.prototype = $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure.prototype;
function $as_Ljapgolly_scalajs_react_callback_Trampoline$Pure(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.Trampoline$Pure"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_Trampoline$Pure)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$Pure(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.Trampoline$Pure;", depth))
}
var $d_Ljapgolly_scalajs_react_callback_Trampoline$Pure = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_Trampoline$Pure: 0
}, false, "japgolly.scalajs.react.callback.Trampoline$Pure", {
  Ljapgolly_scalajs_react_callback_Trampoline$Pure: 1,
  O: 1,
  Ljapgolly_scalajs_react_callback_Trampoline: 1
});
$c_Ljapgolly_scalajs_react_callback_Trampoline$Pure.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_Trampoline$Pure;
/** @constructor */
function $c_Ljapgolly_scalajs_react_callback_Trampoline$Suspend(suspension) {
  this.Ljapgolly_scalajs_react_callback_Trampoline$Suspend__f_suspension = null;
  this.Ljapgolly_scalajs_react_callback_Trampoline$Suspend__f_suspension = suspension
}
$c_Ljapgolly_scalajs_react_callback_Trampoline$Suspend.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_callback_Trampoline$Suspend.prototype.constructor = $c_Ljapgolly_scalajs_react_callback_Trampoline$Suspend;
/** @constructor */
function $h_Ljapgolly_scalajs_react_callback_Trampoline$Suspend() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_callback_Trampoline$Suspend.prototype = $c_Ljapgolly_scalajs_react_callback_Trampoline$Suspend.prototype;
function $as_Ljapgolly_scalajs_react_callback_Trampoline$Suspend(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_callback_Trampoline$Suspend) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.callback.Trampoline$Suspend"))
}
function $isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$Suspend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_callback_Trampoline$Suspend)))
}
function $asArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$Suspend(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_callback_Trampoline$Suspend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.callback.Trampoline$Suspend;", depth))
}
var $d_Ljapgolly_scalajs_react_callback_Trampoline$Suspend = new $TypeData().initClass({
  Ljapgolly_scalajs_react_callback_Trampoline$Suspend: 0
}, false, "japgolly.scalajs.react.callback.Trampoline$Suspend", {
  Ljapgolly_scalajs_react_callback_Trampoline$Suspend: 1,
  O: 1,
  Ljapgolly_scalajs_react_callback_Trampoline: 1
});
$c_Ljapgolly_scalajs_react_callback_Trampoline$Suspend.prototype.$classData = $d_Ljapgolly_scalajs_react_callback_Trampoline$Suspend;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Js$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_Js$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_Js$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Js$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Js$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Js$.prototype = $c_Ljapgolly_scalajs_react_component_Js$.prototype;
$c_Ljapgolly_scalajs_react_component_Js$.prototype.force__O__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(raw, s) {
  return this.component__sjs_js_Function1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(raw, s)
});
$c_Ljapgolly_scalajs_react_component_Js$.prototype.component__sjs_js_Function1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(rc, s) {
  var c = $as_Ljapgolly_scalajs_react_CtorType($n($n(s).Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_pf).rmap__O__F1__O($n($n(s).Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_summon).apply__O__O(rc), new $c_sjsr_AnonFunction1(((r$2) => $m_Ljapgolly_scalajs_react_component_Js$().unmounted__Ljapgolly_scalajs_react_facade_React$ComponentElement__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(r$2)))));
  var pf = $n(s).Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_pf;
  return new $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1(this, rc, c, pf)
});
$c_Ljapgolly_scalajs_react_component_Js$.prototype.unmounted__Ljapgolly_scalajs_react_facade_React$ComponentElement__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(r) {
  var m = new $c_sjsr_AnonFunction1(((r$2$2) => new $c_Ljapgolly_scalajs_react_component_Js$$anon$3(r$2$2)));
  return new $c_Ljapgolly_scalajs_react_component_Js$$anon$1(r, m)
});
var $d_Ljapgolly_scalajs_react_component_Js$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_Js$: 0
}, false, "japgolly.scalajs.react.component.Js$", {
  Ljapgolly_scalajs_react_component_Js$: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate: 1
});
$c_Ljapgolly_scalajs_react_component_Js$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_Js$;
var $n_Ljapgolly_scalajs_react_component_Js$;
function $m_Ljapgolly_scalajs_react_component_Js$() {
  if ((!$n_Ljapgolly_scalajs_react_component_Js$)) {
    $n_Ljapgolly_scalajs_react_component_Js$ = new $c_Ljapgolly_scalajs_react_component_Js$()
  };
  return $n_Ljapgolly_scalajs_react_component_Js$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_JsFn$() {
  this.Ljapgolly_scalajs_react_component_JsFn$__f_japgolly$scalajs$react$component$JsFn$$constUnit = null;
  $n_Ljapgolly_scalajs_react_component_JsFn$ = this;
  this.Ljapgolly_scalajs_react_component_JsFn$__f_japgolly$scalajs$react$component$JsFn$$constUnit = new $c_sjsr_AnonFunction1(((x$5$2) => (void 0)))
}
$c_Ljapgolly_scalajs_react_component_JsFn$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_JsFn$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_JsFn$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_JsFn$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_JsFn$.prototype = $c_Ljapgolly_scalajs_react_component_JsFn$.prototype;
$c_Ljapgolly_scalajs_react_component_JsFn$.prototype.force__O__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(raw, s) {
  var c = $as_Ljapgolly_scalajs_react_CtorType($n($n(s).Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_pf).rmap__O__F1__O($n($n(s).Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_summon).apply__O__O(raw), new $c_sjsr_AnonFunction1(((r$2) => {
    $m_Ljapgolly_scalajs_react_component_JsFn$();
    return new $c_Ljapgolly_scalajs_react_component_JsFn$$anon$3(r$2)
  }))));
  var pf = $n(s).Ljapgolly_scalajs_react_CtorType$Summoner$$anon$1__f_pf;
  return new $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1(this, raw, c, pf)
});
var $d_Ljapgolly_scalajs_react_component_JsFn$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_JsFn$: 0
}, false, "japgolly.scalajs.react.component.JsFn$", {
  Ljapgolly_scalajs_react_component_JsFn$: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate: 1
});
$c_Ljapgolly_scalajs_react_component_JsFn$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_JsFn$;
var $n_Ljapgolly_scalajs_react_component_JsFn$;
function $m_Ljapgolly_scalajs_react_component_JsFn$() {
  if ((!$n_Ljapgolly_scalajs_react_component_JsFn$)) {
    $n_Ljapgolly_scalajs_react_component_JsFn$ = new $c_Ljapgolly_scalajs_react_component_JsFn$()
  };
  return $n_Ljapgolly_scalajs_react_component_JsFn$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype.japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T = (function(toString) {
  var this$2 = $n($f_T__replaceAll__T__T__T($n(toString), "undefined \u2192 undefined", "undefined"));
  var this$3 = $n($as_T(this$2.split("props: undefined, ").join("")));
  var this$4 = $n($as_T(this$3.split("state: undefined)").join(")")));
  return $as_T(this$4.split(", )").join(")"))
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype.componentDidMount__Ljapgolly_scalajs_react_internal_Lens = (function() {
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var get = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$3$2);
    return $n(x$3).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount
  }));
  var set = new $c_sjsr_AnonFunction1(((n$2) => {
    var n = $as_s_Option(n$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$4$2);
      var this$3 = $n(x$4);
      var x$2 = this$3.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
      var this$4 = $n(x$4);
      var x$3$1 = this$4.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
      var this$5 = $n(x$4);
      var x$4$2$1 = this$5.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
      var this$6 = $n(x$4);
      var x$5 = this$6.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
      var this$7 = $n(x$4);
      var x$6 = this$7.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
      var this$8 = $n(x$4);
      var x$7 = this$8.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
      var this$9 = $n(x$4);
      var x$8 = this$9.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps;
      var this$10 = $n(x$4);
      var x$9 = this$10.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
      var this$11 = $n(x$4);
      var x$10 = this$11.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
      $n(x$4);
      return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$2, n, x$3$1, x$4$2$1, x$5, x$6, x$7, x$8, x$9, x$10)
    }))
  }));
  return new $c_Ljapgolly_scalajs_react_internal_Lens(get, set)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype.componentDidUpdate__Ljapgolly_scalajs_react_internal_Lens = (function() {
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var get = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$5$2);
    return $n(x$5).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate
  }));
  var set = new $c_sjsr_AnonFunction1(((n$2) => {
    var n = $as_s_Option(n$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$6$2);
      var this$3 = $n(x$6);
      var x$2 = this$3.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
      var this$4 = $n(x$6);
      var x$3 = this$4.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
      var this$5 = $n(x$6);
      var x$4 = this$5.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
      var this$6 = $n(x$6);
      var x$5$1 = this$6.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
      var this$7 = $n(x$6);
      var x$6$2$1 = this$7.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
      var this$8 = $n(x$6);
      var x$7 = this$8.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
      var this$9 = $n(x$6);
      var x$8 = this$9.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps;
      var this$10 = $n(x$6);
      var x$9 = this$10.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
      var this$11 = $n(x$6);
      var x$10 = this$11.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
      $n(x$6);
      return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$2, x$3, n, x$4, x$5$1, x$6$2$1, x$7, x$8, x$9, x$10)
    }))
  }));
  return new $c_Ljapgolly_scalajs_react_internal_Lens(get, set)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype.componentWillMount__Ljapgolly_scalajs_react_internal_Lens = (function() {
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var get = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$7$2);
    return $n(x$7).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount
  }));
  var set = new $c_sjsr_AnonFunction1(((n$2) => {
    var n = $as_s_Option(n$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$8$2);
      var this$3 = $n(x$8);
      var x$2 = this$3.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
      var this$4 = $n(x$8);
      var x$3 = this$4.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
      var this$5 = $n(x$8);
      var x$4 = this$5.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
      var this$6 = $n(x$8);
      var x$5 = this$6.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
      var this$7 = $n(x$8);
      var x$6 = this$7.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
      var this$8 = $n(x$8);
      var x$7$1 = this$8.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
      var this$9 = $n(x$8);
      var x$8$2$1 = this$9.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps;
      var this$10 = $n(x$8);
      var x$9 = this$10.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
      var this$11 = $n(x$8);
      var x$10 = this$11.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
      $n(x$8);
      return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$2, x$3, x$4, n, x$5, x$6, x$7$1, x$8$2$1, x$9, x$10)
    }))
  }));
  return new $c_Ljapgolly_scalajs_react_internal_Lens(get, set)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype.componentWillUnmount__Ljapgolly_scalajs_react_internal_Lens = (function() {
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var get = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$9$2);
    return $n(x$9).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount
  }));
  var set = new $c_sjsr_AnonFunction1(((n$2) => {
    var n = $as_s_Option(n$2);
    return new $c_sjsr_AnonFunction1(((x$10$2) => {
      var x$10 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$10$2);
      var this$3 = $n(x$10);
      var x$2 = this$3.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
      var this$4 = $n(x$10);
      var x$3 = this$4.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
      var this$5 = $n(x$10);
      var x$4 = this$5.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
      var this$6 = $n(x$10);
      var x$5 = this$6.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
      var this$7 = $n(x$10);
      var x$6 = this$7.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
      var this$8 = $n(x$10);
      var x$7 = this$8.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
      var this$9 = $n(x$10);
      var x$8 = this$9.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps;
      var this$10 = $n(x$10);
      var x$9$1 = this$10.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
      var this$11 = $n(x$10);
      var x$10$2$1 = this$11.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
      $n(x$10);
      return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$2, x$3, x$4, x$5, x$6, n, x$7, x$8, x$9$1, x$10$2$1)
    }))
  }));
  return new $c_Ljapgolly_scalajs_react_internal_Lens(get, set)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype.componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens = (function() {
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var get = new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$11$2);
    return $n(x$11).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps
  }));
  var set = new $c_sjsr_AnonFunction1(((n$2) => {
    var n = $as_s_Option(n$2);
    return new $c_sjsr_AnonFunction1(((x$12$2) => {
      var x$12 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$12$2);
      var this$3 = $n(x$12);
      var x$2 = this$3.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
      var this$4 = $n(x$12);
      var x$3 = this$4.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
      var this$5 = $n(x$12);
      var x$4 = this$5.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
      var this$6 = $n(x$12);
      var x$5 = this$6.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
      var this$7 = $n(x$12);
      var x$6 = this$7.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
      var this$8 = $n(x$12);
      var x$7 = this$8.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
      var this$9 = $n(x$12);
      var x$8 = this$9.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps;
      var this$10 = $n(x$12);
      var x$9 = this$10.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
      var this$11 = $n(x$12);
      var x$10 = this$11.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
      $n(x$12);
      return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$2, x$3, x$4, x$5, n, x$6, x$7, x$8, x$9, x$10)
    }))
  }));
  return new $c_Ljapgolly_scalajs_react_internal_Lens(get, set)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype.shouldComponentUpdate__Ljapgolly_scalajs_react_internal_Lens = (function() {
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var get = new $c_sjsr_AnonFunction1(((x$19$2) => {
    var x$19 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$19$2);
    return $n(x$19).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate
  }));
  var set = new $c_sjsr_AnonFunction1(((n$2) => {
    var n = $as_s_Option(n$2);
    return new $c_sjsr_AnonFunction1(((x$20$2) => {
      var x$20 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$20$2);
      var this$3 = $n(x$20);
      var x$2 = this$3.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
      var this$4 = $n(x$20);
      var x$3 = this$4.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
      var this$5 = $n(x$20);
      var x$4 = this$5.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
      var this$6 = $n(x$20);
      var x$5 = this$6.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
      var this$7 = $n(x$20);
      var x$6 = this$7.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
      var this$8 = $n(x$20);
      var x$7 = this$8.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
      var this$9 = $n(x$20);
      var x$8 = this$9.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
      var this$10 = $n(x$20);
      var x$9 = this$10.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps;
      var this$11 = $n(x$20);
      var x$10 = this$11.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
      $n(x$20);
      return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, n)
    }))
  }));
  return new $c_Ljapgolly_scalajs_react_internal_Lens(get, set)
});
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$;
var $n_Ljapgolly_scalajs_react_component_builder_LifecycleF$;
function $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$() {
  if ((!$n_Ljapgolly_scalajs_react_component_builder_LifecycleF$)) {
    $n_Ljapgolly_scalajs_react_component_builder_LifecycleF$ = new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$()
  };
  return $n_Ljapgolly_scalajs_react_component_builder_LifecycleF$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(raw, evidence$9, evidence$10) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$9, evidence$10)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((((("ComponentWillUnmount(props: " + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()) + ", state: ") + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O()) + ")"))
});
function $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentWillUnmount"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.LifecycleF$ComponentWillUnmount;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentWillUnmount", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUnmount;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate(raw, nextProps, nextState, evidence$13, evidence$14) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate__f_nextProps = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate__f_nextState = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate__f_nextProps = nextProps;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate__f_nextState = nextState;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$13, evidence$14)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((((((((("ComponentWillUpdate(props: " + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()) + " \u2192 ") + this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate__f_nextProps) + ", state: ") + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O()) + " \u2192 ") + this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate__f_nextState) + ")"))
});
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentWillUpdate", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillUpdate;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate(raw, prevProps, prevState, evidence$15, evidence$16) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate__f_prevProps = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate__f_prevState = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate__f_prevProps = prevProps;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate__f_prevState = prevState;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$15, evidence$16)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((((((((("GetSnapshotBeforeUpdate(props: " + this.Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate__f_prevProps) + " \u2192 ") + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()) + ", state: ") + this.Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate__f_prevState) + " \u2192 ") + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O()) + ")"))
});
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$GetSnapshotBeforeUpdate", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$GetSnapshotBeforeUpdate;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(raw, nextProps, nextState, evidence$17, evidence$18) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextProps = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextState = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextProps = nextProps;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextState = nextState;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$17, evidence$18)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((((((((("ShouldComponentUpdate(props: " + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()) + " \u2192 ") + this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextProps) + ", state: ") + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O()) + " \u2192 ") + this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextState) + ")"))
});
function $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.LifecycleF$ShouldComponentUpdate"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.LifecycleF$ShouldComponentUpdate;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$ShouldComponentUpdate", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate;
function $f_Ljapgolly_scalajs_react_extra_BroadcasterF__register__F1__O($thiz, listener) {
  $n($thiz.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync());
  var a$1 = new $c_sjsr_AnonFunction0((() => {
    var record = $ct_T2__O__O__(new $c_T2(), listener, (void 0));
    var this$2 = $n($thiz.japgolly$scalajs$react$extra$BroadcasterF$$_listeners__sci_List());
    $thiz.japgolly$scalajs$react$extra$BroadcasterF$$_listeners_$eq__sci_List__V(new $c_sci_$colon$colon(record, this$2));
    $n($thiz.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync());
    var a = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $n($thiz.japgolly$scalajs$react$extra$BroadcasterF$$_listeners__sci_List());
      var f = ((x$2$2) => {
        var x$2 = $as_T2(x$2$2);
        return (x$2 !== record)
      });
      var l = this$3;
      block: {
        var result;
        while (true) {
          if ($n(l).isEmpty__Z()) {
            var result = $m_sci_Nil$();
            break
          } else {
            var h = $n(l).head__O();
            var t = $as_sci_List($n(l).tail__O());
            if (($uZ(f(h)) === false)) {
              l = t;
              continue
            };
            var start = l;
            var remaining = t;
            while (true) {
              if ($n(remaining).isEmpty__Z()) {
                var result = start;
                break block
              } else {
                var x = $n(remaining).head__O();
                if (($uZ(f(x)) !== false)) {
                  remaining = $as_sci_List($n(remaining).tail__O());
                  continue
                };
                var firstMiss = remaining;
                var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                var toProcess = $as_sci_List($n(start).tail__O());
                var currentLast = newHead;
                while ((toProcess !== firstMiss)) {
                  var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem;
                  currentLast = newElem;
                  toProcess = $as_sci_List($n(toProcess).tail__O())
                };
                var next = $as_sci_List($n(firstMiss).tail__O());
                var nextToCopy = next;
                while ((!$n(next).isEmpty__Z())) {
                  var head = $n(next).head__O();
                  if (($uZ(f(head)) !== false)) {
                    next = $as_sci_List($n(next).tail__O())
                  } else {
                    while ((nextToCopy !== next)) {
                      var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                      $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                      currentLast = newElem$2;
                      nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                    };
                    nextToCopy = $as_sci_List($n(next).tail__O());
                    next = $as_sci_List($n(next).tail__O())
                  }
                };
                if ((!$n(nextToCopy).isEmpty__Z())) {
                  $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                };
                var result = newHead;
                break block
              }
            }
          }
        }
      };
      $thiz.japgolly$scalajs$react$extra$BroadcasterF$$_listeners_$eq__sci_List__V(result)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$1)))
}
function $f_Ljapgolly_scalajs_react_extra_BroadcasterF__broadcast__O__O($thiz, a) {
  $n($thiz.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync());
  var as = new $c_sjsr_AnonFunction0((() => $thiz.japgolly$scalajs$react$extra$BroadcasterF$$_listeners__sci_List()));
  var f = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_T2(x$3$2);
    return $n($as_F1($n(x$3)._1__O())).apply__O__O(a)
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_Callback$().traverse__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(as, new $c_sjsr_AnonFunction1(((x$5$2) => {
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(f.apply__O__O(x$5$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty))
  }))))
}
function $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V($thiz) {
  $thiz.japgolly$scalajs$react$extra$BroadcasterF$$_listeners_$eq__sci_List__V(($n($m_s_package$().s_package$__f_List), $m_sci_Nil$()))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1(F$1) {
  this.Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1__f_F$1 = null;
  this.Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1__f_F$1 = F$1;
  this.Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1.prototype = $c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  return this.Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1__f_F$1
});
var $d_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1: 0
}, false, "japgolly.scalajs.react.extra.OnUnmountF$$anon$1", {
  Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_OnUnmountF$$anon$1;
function $f_Ljapgolly_scalajs_react_extra_TimerSupportF__setTimeoutMs__F0__D__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, f, timeoutInMilliseconds, G) {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  $n(this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
  var a$3 = new $c_sjsr_AnonFunction0((() => {
    var handle = new $c_sr_ObjectRef((void 0));
    var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    $n(this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    $n(this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    var a = new $c_sjsr_AnonFunction0((() => {
      handle.sr_ObjectRef__f_elem = (void 0)
    }));
    var fa = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)));
    var this$9 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$10 = $n(this$9.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    var fb = $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatch__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$10, f, G);
    var fa$1 = fa.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var fb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fb)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var proc = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, fb$1));
    var $$x1 = setTimeout;
    var this$12 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    $n(this$12.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    var a$1 = $$x1($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toJsFn$extension__Ljapgolly_scalajs_react_callback_Trampoline__sjs_js_Function0(proc.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), timeoutInMilliseconds);
    handle.sr_ObjectRef__f_elem = a$1;
    var this$17 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    $n(this$17.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    var a$2 = new $c_sjsr_AnonFunction0((() => {
      var value = handle.sr_ObjectRef__f_elem;
      if ((value !== (void 0))) {
        clearTimeout(value)
      }
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$2)))
  }));
  var first = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$3)));
  var this$29 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  $n(this$29.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
  var f$2 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var f$1 = new $c_sjsr_AnonFunction0((() => x$1$2));
    var this$30 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G$1 = this$30.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    return $f_Ljapgolly_scalajs_react_extra_OnUnmountF__onUnmount__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, f$1, G$1)
  }));
  var fa$2 = first.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$2, f$2))
}
function $f_Ljapgolly_scalajs_react_extra_TimerSupportF__setIntervalMs__O__D__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, f, periodInMilliseconds, G) {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  $n(this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
  var a$1 = new $c_sjsr_AnonFunction0((() => {
    var $$x2 = setInterval;
    var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$6 = $n(this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    var f$1 = new $c_sjsr_AnonFunction0((() => f));
    var i = $$x2($n($$x1).toJsFn$extension__Ljapgolly_scalajs_react_callback_Trampoline__sjs_js_Function0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatch__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$6, f$1, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), periodInMilliseconds);
    var this$7 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    $n(this$7.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    var a = new $c_sjsr_AnonFunction0((() => {
      clearInterval(i)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
  }));
  var first = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$1)));
  var this$14 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  $n(this$14.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
  var f$3 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var f$2 = new $c_sjsr_AnonFunction0((() => x$2$2));
    var this$15 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G$1 = this$15.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    return $f_Ljapgolly_scalajs_react_extra_OnUnmountF__onUnmount__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, f$2, G$1)
  }));
  var fa = first.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa, f$3))
}
function $is_Ljapgolly_scalajs_react_extra_TimerSupportF(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_extra_TimerSupportF)))
}
function $as_Ljapgolly_scalajs_react_extra_TimerSupportF(obj) {
  return (($is_Ljapgolly_scalajs_react_extra_TimerSupportF(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.TimerSupportF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_TimerSupportF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_TimerSupportF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_TimerSupportF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_TimerSupportF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.TimerSupportF;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api) {
  this.Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__f_api = null;
  $ct_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(this, api)
}
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary.prototype = new $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary();
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary.prototype = $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary.prototype;
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary.prototype.useStateSnapshotBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O = (function(initialState, step) {
  return this.useStateSnapshotBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((x$16$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(initialState))).apply__O__O(x$16$2))), step)
});
var $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary: 0
}, false, "japgolly.scalajs.react.extra.internal.StateSnapshot$HooksApiExt$Secondary", {
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary: 1,
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Primary: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary;
function $p_Ljapgolly_scalajs_react_extra_package$__StateSnapshot$lzycompute__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$($thiz) {
  if ((!$thiz.Ljapgolly_scalajs_react_extra_package$__f_bitmap$0)) {
    $thiz.Ljapgolly_scalajs_react_extra_package$__f_StateSnapshot = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
    $thiz.Ljapgolly_scalajs_react_extra_package$__f_bitmap$0 = true
  };
  return $thiz.Ljapgolly_scalajs_react_extra_package$__f_StateSnapshot
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_package$() {
  this.Ljapgolly_scalajs_react_extra_package$__f_StateSnapshot = null;
  this.Ljapgolly_scalajs_react_extra_package$__f_bitmap$0 = false
}
$c_Ljapgolly_scalajs_react_extra_package$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_package$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_package$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_package$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_package$.prototype = $c_Ljapgolly_scalajs_react_extra_package$.prototype;
$c_Ljapgolly_scalajs_react_extra_package$.prototype.StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$ = (function() {
  return ((!this.Ljapgolly_scalajs_react_extra_package$__f_bitmap$0) ? $p_Ljapgolly_scalajs_react_extra_package$__StateSnapshot$lzycompute__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$(this) : this.Ljapgolly_scalajs_react_extra_package$__f_StateSnapshot)
});
var $d_Ljapgolly_scalajs_react_extra_package$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_package$: 0
}, false, "japgolly.scalajs.react.extra.package$", {
  Ljapgolly_scalajs_react_extra_package$: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt: 1
});
$c_Ljapgolly_scalajs_react_extra_package$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_package$;
var $n_Ljapgolly_scalajs_react_extra_package$;
function $m_Ljapgolly_scalajs_react_extra_package$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_package$)) {
    $n_Ljapgolly_scalajs_react_extra_package$ = new $c_Ljapgolly_scalajs_react_extra_package$()
  };
  return $n_Ljapgolly_scalajs_react_extra_package$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_package$EventListener$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_package$EventListener$.prototype = new $h_Ljapgolly_scalajs_react_extra_EventListenerF();
$c_Ljapgolly_scalajs_react_extra_package$EventListener$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_package$EventListener$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_package$EventListener$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_package$EventListener$.prototype = $c_Ljapgolly_scalajs_react_extra_package$EventListener$.prototype;
var $d_Ljapgolly_scalajs_react_extra_package$EventListener$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_package$EventListener$: 0
}, false, "japgolly.scalajs.react.extra.package$EventListener$", {
  Ljapgolly_scalajs_react_extra_package$EventListener$: 1,
  Ljapgolly_scalajs_react_extra_EventListenerF: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_package$EventListener$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_package$EventListener$;
var $n_Ljapgolly_scalajs_react_extra_package$EventListener$;
function $m_Ljapgolly_scalajs_react_extra_package$EventListener$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_package$EventListener$)) {
    $n_Ljapgolly_scalajs_react_extra_package$EventListener$ = new $c_Ljapgolly_scalajs_react_extra_package$EventListener$()
  };
  return $n_Ljapgolly_scalajs_react_extra_package$EventListener$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_AbsUrl$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_AbsUrl$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_AbsUrl$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_AbsUrl$.prototype = $c_Ljapgolly_scalajs_react_extra_router_AbsUrl$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl$.prototype.fromWindow__Ljapgolly_scalajs_react_extra_router_AbsUrl = (function() {
  return new $c_Ljapgolly_scalajs_react_extra_router_AbsUrl($as_T(window.location.href))
});
var $d_Ljapgolly_scalajs_react_extra_router_AbsUrl$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_AbsUrl$: 0
}, false, "japgolly.scalajs.react.extra.router.AbsUrl$", {
  Ljapgolly_scalajs_react_extra_router_AbsUrl$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_AbsUrl$;
var $n_Ljapgolly_scalajs_react_extra_router_AbsUrl$;
function $m_Ljapgolly_scalajs_react_extra_router_AbsUrl$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_AbsUrl$)) {
    $n_Ljapgolly_scalajs_react_extra_router_AbsUrl$ = new $c_Ljapgolly_scalajs_react_extra_router_AbsUrl$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_AbsUrl$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_BaseUrl$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_BaseUrl$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_BaseUrl$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_BaseUrl$.prototype = $c_Ljapgolly_scalajs_react_extra_router_BaseUrl$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl$.prototype.fromWindowOrigin__Ljapgolly_scalajs_react_extra_router_BaseUrl = (function() {
  var l = window.location;
  var url = (($as_T(l.protocol) + "//") + $as_T(l.hostname));
  var this$1 = $n($as_T(l.port));
  var this$2 = $m_ju_regex_Pattern$();
  if ((!this$2.java$util$regex$Pattern$$matches__T__T__Z("^(?:80)?$", this$1))) {
    url = ((url + ":") + $as_T(l.port))
  };
  return new $c_Ljapgolly_scalajs_react_extra_router_BaseUrl(url)
});
var $d_Ljapgolly_scalajs_react_extra_router_BaseUrl$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_BaseUrl$: 0
}, false, "japgolly.scalajs.react.extra.router.BaseUrl$", {
  Ljapgolly_scalajs_react_extra_router_BaseUrl$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_BaseUrl$;
var $n_Ljapgolly_scalajs_react_extra_router_BaseUrl$;
function $m_Ljapgolly_scalajs_react_extra_router_BaseUrl$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_BaseUrl$)) {
    $n_Ljapgolly_scalajs_react_extra_router_BaseUrl$ = new $c_Ljapgolly_scalajs_react_extra_router_BaseUrl$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_BaseUrl$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1(outer) {
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1__f_refresh = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1__f_$outer = outer
  };
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1__f_refresh = $n(outer).interpret__Ljapgolly_scalajs_react_extra_router_RouteCmd__O($m_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$())
}
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouterCtlF();
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype.F__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  return $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1__f_$outer).Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype.baseUrl__Ljapgolly_scalajs_react_extra_router_BaseUrl = (function() {
  var this$1 = $n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1__f_$outer);
  return this$1.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype.refresh__O = (function() {
  return this.Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1__f_refresh
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype.set__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O = (function(p, v) {
  return $n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1__f_$outer).interpret__Ljapgolly_scalajs_react_extra_router_RouteCmd__O($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1__f_$outer).setPath__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_SetRouteVia__Ljapgolly_scalajs_react_extra_router_RouteCmd(p, v))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O = (function(route, via) {
  return this.set__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O($as_Ljapgolly_scalajs_react_extra_router_Path(route), via)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype.pathFor__O__Ljapgolly_scalajs_react_extra_router_Path = (function(route) {
  var path = $as_Ljapgolly_scalajs_react_extra_router_Path(route);
  return path
});
var $d_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1: 0
}, false, "japgolly.scalajs.react.extra.router.RouterLogicF$$anon$1", {
  Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1: 1,
  Ljapgolly_scalajs_react_extra_router_RouterCtlF: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1;
function $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__optionTransAction$1__s_Option__Ljapgolly_scalajs_react_util_Effect$Sync__s_Option($thiz, o, F$2) {
  var this$1 = $n(o);
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x$10 = $as_Ljapgolly_scalajs_react_extra_router_ActionF(arg1);
    return new $c_s_Some($n(x$10).withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_ActionF(F$2))
  }
}
function $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareParseFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1($thiz, rule) {
  while (true) {
    var x1 = rule;
    if ((x1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom)) {
      var x2 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(x1);
      return new $c_sjsr_AnonFunction1(((x2) => ((p$2) => {
        var p = $as_Ljapgolly_scalajs_react_extra_router_Path(p$2);
        var a = $n($n(x2).Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_parse).apply__O__O(p);
        var rassoc$1 = new $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(($n($m_s_package$().s_package$__f_Right), new $c_s_util_Right(a)));
        var this$4 = $n($m_s_package$().s_package$__f_Nil);
        return new $c_sci_$colon$colon(rassoc$1, this$4)
      }))(x2))
    } else if (false) {
      var x3 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$AutoCorrect(x1);
      rule = $n(x3).underlying__Ljapgolly_scalajs_react_extra_router_RoutingRule()
    } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or)) {
      var x4 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(x1);
      var x = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareParseFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1($thiz, $n(x4).Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs);
      var y = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareParseFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1($thiz, $n(x4).Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs);
      return new $c_sjsr_AnonFunction1(((y, x) => ((p$3$2) => {
        var p$3 = $as_Ljapgolly_scalajs_react_extra_router_Path(p$3$2);
        return $n($as_sci_List($n(y).apply__O__O(p$3))).reverse_$colon$colon$colon__sci_List__sci_List($as_sci_List($n(x).apply__O__O(p$3)))
      }))(y, x))
    } else if (false) {
      var x5 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Conditional(x1);
      rule = $n(x5).underlying__Ljapgolly_scalajs_react_extra_router_RoutingRule()
    } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP)) {
      var x6 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(x1);
      rule = $n(x6).Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
function $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__preparePathFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1($thiz, rule) {
  while (true) {
    var x1 = rule;
    if ((x1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom)) {
      var x2 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(x1);
      return $n(x2).Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_path
    } else if (false) {
      var x3 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Conditional(x1);
      rule = $n(x3).underlying__Ljapgolly_scalajs_react_extra_router_RoutingRule()
    } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP)) {
      var x4 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(x1);
      rule = $n(x4).Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying
    } else if (false) {
      var x5 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$AutoCorrect(x1);
      rule = $n(x5).underlying__Ljapgolly_scalajs_react_extra_router_RoutingRule()
    } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or)) {
      var x6 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(x1);
      var $$x1 = $m_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$();
      var f = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__preparePathFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1($thiz, $n(x6).Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs);
      return $n($$x1).$bar$bar$extension__F1__F1__F1(f, $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__preparePathFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1($thiz, $n(x6).Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs))
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
function $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareActionFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__Ljapgolly_scalajs_react_util_Effect$Sync__F2($thiz, rule, F$2) {
  while (true) {
    var x1 = rule;
    if ((x1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom)) {
      var x2 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(x1);
      return new $c_sjsr_AnonFunction2(((x2, F$2) => ((path$2, page$2) => {
        var path = $as_Ljapgolly_scalajs_react_extra_router_Path(path$2);
        var action = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__optionTransAction$1__s_Option__Ljapgolly_scalajs_react_util_Effect$Sync__s_Option($thiz, $as_s_Option($n($n(x2).Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_action).apply__O__O__O(path, page$2)), F$2);
        var rassoc$2 = new $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(($n($m_s_package$().s_package$__f_Right), new $c_s_util_Right(action)));
        var this$4 = $n($m_s_package$().s_package$__f_Nil);
        return new $c_sci_$colon$colon(rassoc$2, this$4)
      }))(x2, F$2))
    } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or)) {
      var x3 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(x1);
      var x = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareActionFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__Ljapgolly_scalajs_react_util_Effect$Sync__F2($thiz, $n(x3).Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs, F$2);
      var y = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareActionFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__Ljapgolly_scalajs_react_util_Effect$Sync__F2($thiz, $n(x3).Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs, F$2);
      return new $c_sjsr_AnonFunction2(((y, x) => ((path$3$2, page$3$2) => {
        var path$3 = $as_Ljapgolly_scalajs_react_extra_router_Path(path$3$2);
        return $n($as_sci_List($n(y).apply__O__O__O(path$3, page$3$2))).reverse_$colon$colon$colon__sci_List__sci_List($as_sci_List($n(x).apply__O__O__O(path$3, page$3$2)))
      }))(y, x))
    } else if (false) {
      var x4 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$AutoCorrect(x1);
      var path$4 = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__preparePathFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1($thiz, $n(x4).underlying__Ljapgolly_scalajs_react_extra_router_RoutingRule());
      var action$1 = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareActionFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__Ljapgolly_scalajs_react_util_Effect$Sync__F2($thiz, $n(x4).underlying__Ljapgolly_scalajs_react_extra_router_RoutingRule(), F$2);
      return new $c_sjsr_AnonFunction2(((path$4, action$1, x4) => ((actualPath$2, page$4$2) => {
        var actualPath = $as_Ljapgolly_scalajs_react_extra_router_Path(actualPath$2);
        var x1$1 = $as_s_Option($n(path$4).apply__O__O(page$4$2));
        if ((x1$1 instanceof $c_s_Some)) {
          var x2$1 = $as_s_Some(x1$1);
          var expectedPath = $as_Ljapgolly_scalajs_react_extra_router_Path($n(x2$1).s_Some__f_value);
          if (((expectedPath === null) ? (actualPath === null) : $n(expectedPath).equals__O__Z(actualPath))) {
            return $as_sci_List($n(action$1).apply__O__O__O(actualPath, page$4$2))
          } else {
            var a = new $c_s_Some(new $c_Ljapgolly_scalajs_react_extra_router_RedirectToPath(expectedPath, $n(x4).redirectVia__Ljapgolly_scalajs_react_extra_router_SetRouteVia()));
            var rassoc$3 = new $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(($n($m_s_package$().s_package$__f_Right), new $c_s_util_Right(a)));
            var this$7 = $n($m_s_package$().s_package$__f_Nil);
            return new $c_sci_$colon$colon(rassoc$3, this$7)
          }
        } else {
          var x$3 = $m_s_None$();
          if ((x$3 === x1$1)) {
            return $m_s_package$().s_package$__f_Nil
          } else {
            throw new $c_s_MatchError(x1$1)
          }
        }
      }))(path$4, action$1, x4))
    } else if (false) {
      var x5 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Conditional(x1);
      rule = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(new $c_sjsr_AnonFunction1(((x5) => ((x$11$2) => $n(x5).condition__sjs_js_Function0()))(x5)), $n(x5).underlying__Ljapgolly_scalajs_react_extra_router_RoutingRule(), $n(x5).otherwise__F1())
    } else if ((x1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP)) {
      var x6 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(x1);
      var underlying = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareActionFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__Ljapgolly_scalajs_react_util_Effect$Sync__F2($thiz, $n(x6).Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying, F$2);
      return new $c_sjsr_AnonFunction2(((underlying, F$2, x6) => ((path$5$2, page$5$2) => {
        var path$5 = $as_Ljapgolly_scalajs_react_extra_router_Path(path$5$2);
        var step1 = $m_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$().selectAction__Ljapgolly_scalajs_react_extra_router_Path__O__F2__Ljapgolly_scalajs_react_util_Effect$Sync__O(path$5, page$5$2, underlying, F$2);
        $n(F$2);
        var f$2 = new $c_sjsr_AnonFunction1(((x0$1$2) => {
          var x0$1 = $as_s_Option(x0$1$2);
          if ((x0$1 instanceof $c_s_Some)) {
            var x2$2 = $as_s_Some(x0$1);
            $n(F$2);
            $n(F$2);
            var f = $n($n(x6).Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_condition).apply__O__O(page$5$2);
            var fa = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().fromJsFn__sjs_js_Function0__Ljapgolly_scalajs_react_callback_Trampoline(f));
            var f$1 = new $c_sjsr_AnonFunction1(((x0$2$2) => {
              var x0$2 = $uZ(x0$2$2);
              if ((x0$2 === true)) {
                return x2$2
              } else if ((x0$2 === false)) {
                return $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__optionTransAction$1__s_Option__Ljapgolly_scalajs_react_util_Effect$Sync__s_Option($thiz, $as_s_Option($n($n(x6).Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_otherwise).apply__O__O(page$5$2)), F$2)
              } else {
                throw new $c_s_MatchError(x0$2)
              }
            }));
            var fa$1 = fa.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var this$11 = $n(fa$1);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$11, f$1))
          } else {
            var x$1 = $m_s_None$();
            if ((x$1 === x0$1)) {
              $n(F$2);
              var a$1 = $m_s_None$();
              return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a$1)))
            } else {
              throw new $c_s_MatchError(x0$1)
            }
          }
        }));
        var fa$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(step1)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var fa$3 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$2, f$2));
        $n($m_s_package$().s_package$__f_Left);
        $n(F$2);
        var value = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toJsFn$extension__Ljapgolly_scalajs_react_callback_Trampoline__sjs_js_Function0(fa$3.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
        var rassoc$4 = new $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(new $c_s_util_Left(value));
        var this$19 = $n($m_s_package$().s_package$__f_Nil);
        return new $c_sci_$colon$colon(rassoc$4, this$19)
      }))(underlying, F$2, x6))
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$.prototype = $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$.prototype.fromRule__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1__F2__F1__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RoutingRulesF = (function(rule, fallbackPath, fallbackAction, whenNotFound, F) {
  var $$x2 = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareParseFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1(this, rule);
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_router_package$OptionFnExt$();
  var f = $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__preparePathFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1(this, rule);
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF($$x2, $n($$x1).$bar$extension__F1__F1__F1(f, fallbackPath), $p_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$__prepareActionFn$1__Ljapgolly_scalajs_react_extra_router_RoutingRule__Ljapgolly_scalajs_react_util_Effect$Sync__F2(this, rule, F), fallbackAction, whenNotFound, F)
});
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF$: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRulesF$", {
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$;
var $n_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$;
function $m_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$)) {
    $n_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$ = new $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1(a$2, b$1, c$1) {
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1__f_ga = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1__f_gb = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1__f_gc = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1__f_ga = a$2;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1__f_gb = b$1;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1__f_gc = c$1
}
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1.prototype = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1.prototype;
var $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1: 0
}, false, "japgolly.scalajs.react.extra.router.StaticDsl$RouteB$Composition$$anon$1", {
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition: 1
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1;
function $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLow__T3__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition($thiz) {
  var a = new $c_sjsr_AnonFunction1(((r$2) => {
    var r = $as_T3(r$2);
    return $ct_T2__O__O__(new $c_T2(), $n(r).T3__f__1, $n(r).T3__f__2)
  }));
  var b = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_T3(x$5$2);
    return $n(x$5).T3__f__3
  }));
  var c = new $c_sjsr_AnonFunction2(((l$2, r$3$2) => {
    var l = $as_T2(l$2);
    return new $c_T3($n(l)._1__O(), $n(l)._2__O(), r$3$2)
  }));
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1(a, b, c)
}
function $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLow__T4__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition($thiz) {
  var a = new $c_sjsr_AnonFunction1(((r$2) => {
    var r = $as_T4(r$2);
    return new $c_T3($n(r).T4__f__1, $n(r).T4__f__2, $n(r).T4__f__3)
  }));
  var b = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_T4(x$6$2);
    return $n(x$6).T4__f__4
  }));
  var c = new $c_sjsr_AnonFunction2(((l$2, r$3$2) => {
    var l = $as_T3(l$2);
    return new $c_T4($n(l).T3__f__1, $n(l).T3__f__2, $n(l).T3__f__3, r$3$2)
  }));
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1(a, b, c)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$.prototype = $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$.prototype.partition__sci_List__Ljapgolly_scalajs_react_util_Effect$Sync__T2 = (function(xs, F) {
  $n($m_s_package$().s_package$__f_List);
  var elem = $m_sci_Nil$();
  var elem$1 = null;
  elem$1 = elem;
  $n($m_s_package$().s_package$__f_List);
  var elem$2 = $m_sci_Nil$();
  var elem$3 = null;
  elem$3 = elem$2;
  var this$5 = $n(xs);
  var these = this$5;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var x = $as_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(arg1);
    var x1 = $n(x).Ljapgolly_scalajs_react_extra_router_StaticOrDynamic__f_value;
    if ((x1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(x1);
      var a = $n(x2).s_util_Right__f_value;
      var this$6 = $n($as_sci_List(elem$1));
      elem$1 = new $c_sci_$colon$colon(a, this$6)
    } else if ((x1 instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(x1);
      var ca = $n(x3).s_util_Left__f_value;
      var this$8 = $n($as_sci_List(elem$3));
      $n(F);
      var elem$4 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().fromJsFn__sjs_js_Function0__Ljapgolly_scalajs_react_callback_Trampoline(ca));
      elem$3 = new $c_sci_$colon$colon(elem$4, this$8)
    } else {
      throw new $c_s_MatchError(x1)
    };
    these = $as_sci_List($n(these).tail__O())
  };
  return $ct_T2__O__O__(new $c_T2(), $as_sci_List(elem$1), $as_sci_List(elem$3))
});
var $d_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$: 0
}, false, "japgolly.scalajs.react.extra.router.StaticOrDynamic$", {
  Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$;
var $n_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$;
function $m_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$)) {
    $n_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$ = new $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_feature_Context$$anon$1(outer, a$1) {
  this.Ljapgolly_scalajs_react_feature_Context$$anon$1__f_props = null;
  this.Ljapgolly_scalajs_react_feature_Context$$anon$1__f_$outer = null;
  this.Ljapgolly_scalajs_react_feature_Context$$anon$1__f_a$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ljapgolly_scalajs_react_feature_Context$$anon$1__f_$outer = outer
  };
  this.Ljapgolly_scalajs_react_feature_Context$$anon$1__f_a$1 = a$1;
  this.Ljapgolly_scalajs_react_feature_Context$$anon$1__f_props = (() => {
    var outer$1 = null;
    outer$1 = this;
    var this$2 = {};
    this$2.value = null;
    this$2.value = $n(outer$1).Ljapgolly_scalajs_react_feature_Context$$anon$1__f_a$1;
    return this$2
  })()
}
$c_Ljapgolly_scalajs_react_feature_Context$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_feature_Context$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_feature_Context$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_feature_Context$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_feature_Context$$anon$1.prototype = $c_Ljapgolly_scalajs_react_feature_Context$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_feature_Context$$anon$1.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement = (function(children) {
  var $$x2 = $i_react;
  var a = $n(this.Ljapgolly_scalajs_react_feature_Context$$anon$1__f_$outer).Ljapgolly_scalajs_react_feature_Context$$anon$3__f_raw.Provider;
  var $$x1 = this.Ljapgolly_scalajs_react_feature_Context$$anon$1__f_props;
  var seq = $as_sci_Seq($n(children).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(x$1$2);
    return $n(x$1).rawNode__sjs_js_$bar()
  }))));
  var e = $$x2.createElement(a, $$x1, ...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(seq));
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(e)
});
var $d_Ljapgolly_scalajs_react_feature_Context$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_feature_Context$$anon$1: 0
}, false, "japgolly.scalajs.react.feature.Context$$anon$1", {
  Ljapgolly_scalajs_react_feature_Context$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_feature_Context$Provided: 1
});
$c_Ljapgolly_scalajs_react_feature_Context$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_feature_Context$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_feature_Context$$anon$3(defaultValue$1) {
  this.Ljapgolly_scalajs_react_feature_Context$$anon$3__f_raw = null;
  this.Ljapgolly_scalajs_react_feature_Context$$anon$3__f_defaultValue$1 = null;
  this.Ljapgolly_scalajs_react_feature_Context$$anon$3__f_defaultValue$1 = defaultValue$1;
  this.Ljapgolly_scalajs_react_feature_Context$$anon$3__f_raw = $i_react.createContext(defaultValue$1)
}
$c_Ljapgolly_scalajs_react_feature_Context$$anon$3.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_feature_Context$$anon$3.prototype.constructor = $c_Ljapgolly_scalajs_react_feature_Context$$anon$3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_feature_Context$$anon$3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_feature_Context$$anon$3.prototype = $c_Ljapgolly_scalajs_react_feature_Context$$anon$3.prototype;
$c_Ljapgolly_scalajs_react_feature_Context$$anon$3.prototype.toString__T = (function() {
  return (("Context(" + this.Ljapgolly_scalajs_react_feature_Context$$anon$3__f_defaultValue$1) + ")")
});
$c_Ljapgolly_scalajs_react_feature_Context$$anon$3.prototype.hashCode__I = (function() {
  var x = this.Ljapgolly_scalajs_react_feature_Context$$anon$3__f_defaultValue$1;
  return $m_sr_Statics$().anyHash__O__I(x)
});
var $d_Ljapgolly_scalajs_react_feature_Context$$anon$3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_feature_Context$$anon$3: 0
}, false, "japgolly.scalajs.react.feature.Context$$anon$3", {
  Ljapgolly_scalajs_react_feature_Context$$anon$3: 1,
  O: 1,
  Ljapgolly_scalajs_react_feature_Context: 1
});
$c_Ljapgolly_scalajs_react_feature_Context$$anon$3.prototype.$classData = $d_Ljapgolly_scalajs_react_feature_Context$$anon$3;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$.prototype = $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$.prototype;
var $d_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$: 0
}, false, "japgolly.scalajs.react.hooks.Api$DynamicNextStep$", {
  Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri: 1
});
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$;
var $n_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$;
function $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$)) {
    $n_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$ = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2.prototype = $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2.prototype;
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2.prototype.apply__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O__F1__F1__O = (function(s, i, self, next) {
  return $n(self).apply__O__O(i)
});
var $d_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2: 0
}, false, "japgolly.scalajs.react.hooks.Api$DynamicNextStep$$anon$2", {
  Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$$anon$2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1.prototype = $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1.prototype.apply__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O__F1__F1__O = (function(s, i, self, next) {
  return $n(next).apply__O__O(i)
});
var $d_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1: 0
}, false, "japgolly.scalajs.react.hooks.Api$DynamicNextStepLowPri$$anon$1", {
  Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1;
function $f_Ljapgolly_scalajs_react_hooks_Api$Secondary__customBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O($thiz, hook, step, d) {
  var hook$1 = new $c_sjsr_AnonFunction1(((x$34$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($n($as_Ljapgolly_scalajs_react_hooks_CustomHook($n($as_F1($n($n(step).squash__F1()).apply__O__O(hook))).apply__O__O(x$34$2))).Ljapgolly_scalajs_react_hooks_CustomHook__f_unsafeInit)));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O($thiz, hook$1, step, d)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackBy__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($thiz, callback, a, step) {
  var callback$1 = new $c_sjsr_AnonFunction1(((x$39$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(callback))).apply__O__O(x$39$2)));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useCallbackBy__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, callback$1, a, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackWithDepsBy__O__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($thiz, deps, callback, a, r, step) {
  var deps$1 = new $c_sjsr_AnonFunction1(((x$40$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(deps))).apply__O__O(x$40$2)));
  var callback$1 = new $c_sjsr_AnonFunction1(((x$41$2) => $as_F1($n($as_F1($n($n(step).squash__F1()).apply__O__O(callback))).apply__O__O(x$41$2))));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useCallbackWithDepsBy__F1__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, deps$1, callback$1, a, r, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($thiz, init, a, step) {
  var init$1 = new $c_sjsr_AnonFunction1(((x$44$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(init))).apply__O__O(x$44$2)));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useEffectBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, init$1, a, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($thiz, deps, effect, a, r, step) {
  var deps$1 = new $c_sjsr_AnonFunction1(((x$45$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(deps))).apply__O__O(x$45$2)));
  var effect$1 = new $c_sjsr_AnonFunction1(((x$46$2) => $as_F1($n($as_F1($n($n(step).squash__F1()).apply__O__O(effect))).apply__O__O(x$46$2))));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useEffectWithDepsBy__F1__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, deps$1, effect$1, a, r, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($thiz, effect, a, step) {
  var effect$1 = new $c_sjsr_AnonFunction1(((x$47$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(effect))).apply__O__O(x$47$2)));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useEffectOnMountBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, effect$1, a, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useMemoBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($thiz, deps, create, r, step) {
  var deps$1 = new $c_sjsr_AnonFunction1(((x$52$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(deps))).apply__O__O(x$52$2)));
  var create$1 = new $c_sjsr_AnonFunction1(((x$53$2) => $as_F1($n($as_F1($n($n(step).squash__F1()).apply__O__O(create))).apply__O__O(x$53$2))));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useMemoBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, deps$1, create$1, r, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useRefBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($thiz, f, step) {
  var initialValue = new $c_sjsr_AnonFunction1(((x$56$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(f))).apply__O__O(x$56$2)));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useRefBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, initialValue, step)
}
function $f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($thiz, initialState, step) {
  var initialState$1 = new $c_sjsr_AnonFunction1(((x$57$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(initialState))).apply__O__O(x$57$2)));
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__useStateBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($thiz, initialState$1, step)
}
function $is_Ljapgolly_scalajs_react_hooks_Api$Secondary(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_hooks_Api$Secondary)))
}
function $as_Ljapgolly_scalajs_react_hooks_Api$Secondary(obj) {
  return (($is_Ljapgolly_scalajs_react_hooks_Api$Secondary(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.Api$Secondary"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_Api$Secondary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_Api$Secondary)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_Api$Secondary(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_Api$Secondary(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.Api$Secondary;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First(init) {
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First__f_init = null;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First__f_init = init
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First.prototype;
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First.prototype.self__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First = (function(f, step) {
  return $n(step).self__F1__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First(this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First__f_init, f)
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First.prototype.next__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent = (function(f, step) {
  return $n(step).next__F1__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First__f_init, f)
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First.prototype.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.next__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(f, $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep(step))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First.prototype.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.self__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First(f, $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep(step))
});
var $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook$Builder$First", {
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$Primary: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep.prototype;
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep.prototype.self__F1__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First = (function(initFirst, f) {
  return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First(new $c_sjsr_AnonFunction1(((i$2) => {
    $n(initFirst).apply__O__O(i$2);
    $n(f).apply__O__O(i$2)
  })))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep.prototype.next__F1__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent = (function(initFirst, hook1) {
  var build = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1(this, initFirst, hook1);
  return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(build)
});
function $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.CustomHook$Builder$FirstStep"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.CustomHook$Builder$FirstStep;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook$Builder$FirstStep", {
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1(outer, initFirst$2, hook1$1) {
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1__f_initFirst$2 = null;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1__f_hook1$1 = null;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1__f_initFirst$2 = initFirst$2;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1__f_hook1$1 = hook1$1
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1.prototype.apply__F1__F1 = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1(((i$2) => {
    $n(this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1__f_initFirst$2).apply__O__O(i$2);
    var h1 = $n(this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1__f_hook1$1).apply__O__O(i$2);
    var ctx = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I1__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$I1(), i$2, h1);
    return $n(f).apply__O__O(ctx)
  }));
  return f$1
});
var $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook$Builder$FirstStep$$anon$1", {
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$.prototype;
var $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook$Builder$SubsequentStep$", {
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$;
var $n_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$;
function $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$)) {
    $n_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$ = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2(outer, buildPrev$1, initNextHook$1) {
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2__f_buildPrev$1 = null;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2__f_initNextHook$1 = null;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2__f_buildPrev$1 = buildPrev$1;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2__f_initNextHook$1 = initNextHook$1
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2.prototype;
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2.prototype.apply__F1__F1 = (function(f) {
  return $n(this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2__f_buildPrev$1).apply__F1__F1(new $c_sjsr_AnonFunction1(((ctx$2) => {
    $n(this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2__f_initNextHook$1).apply__O__O(ctx$2);
    return $n(f).apply__O__O(ctx$2)
  })))
});
var $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook$Builder$SubsequentStep$$anon$2", {
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41(outer, buildPrev$1, initNextHook$40) {
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41__f_buildPrev$1 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41__f_initNextHook$40 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41__f_buildPrev$1 = buildPrev$1;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41__f_initNextHook$40 = initNextHook$40
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41.prototype.apply__F1__F1 = (function(f) {
  return $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41__f_buildPrev$1).apply__F1__F1(new $c_sjsr_AnonFunction1(((ctx1$2) => {
    var ctx1 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I1(ctx1$2);
    var h2 = $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41__f_initNextHook$40).apply__O__O(ctx1);
    var input = $n(ctx1).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input;
    var hook1 = $n(ctx1).Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1;
    var ctx2 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I2__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$I2(), input, hook1, h2);
    return $n(f).apply__O__O(ctx2)
  })))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$40$$anon$41", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43(outer, buildPrev$2, initNextHook$41) {
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43__f_buildPrev$2 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43__f_initNextHook$41 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43__f_buildPrev$2 = buildPrev$2;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43__f_initNextHook$41 = initNextHook$41
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43.prototype.apply__F1__F1 = (function(f) {
  return $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43__f_buildPrev$2).apply__F1__F1(new $c_sjsr_AnonFunction1(((ctx2$2) => {
    var ctx2 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I2(ctx2$2);
    var h3 = $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43__f_initNextHook$41).apply__O__O(ctx2);
    var input = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input;
    var hook1 = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1;
    var hook2 = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2;
    var ctx3 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I3__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$I3(), input, hook1, hook2, h3);
    return $n(f).apply__O__O(ctx3)
  })))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$42$$anon$43", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45(outer, buildPrev$3, initNextHook$42) {
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45__f_buildPrev$3 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45__f_initNextHook$42 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45__f_buildPrev$3 = buildPrev$3;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45__f_initNextHook$42 = initNextHook$42
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45.prototype.apply__F1__F1 = (function(f) {
  return $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45__f_buildPrev$3).apply__F1__F1(new $c_sjsr_AnonFunction1(((ctx3$2) => {
    var ctx3 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I3(ctx3$2);
    var h4 = $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45__f_initNextHook$42).apply__O__O(ctx3);
    var input = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input;
    var hook1 = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1;
    var hook2 = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2;
    var hook3 = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3;
    var ctx4 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I4__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$I4(), input, hook1, hook2, hook3, h4);
    return $n(f).apply__O__O(ctx4)
  })))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$44$$anon$45", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47(outer, buildPrev$4, initNextHook$43) {
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47__f_buildPrev$4 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47__f_initNextHook$43 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47__f_buildPrev$4 = buildPrev$4;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47__f_initNextHook$43 = initNextHook$43
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47.prototype.apply__F1__F1 = (function(f) {
  return $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47__f_buildPrev$4).apply__F1__F1(new $c_sjsr_AnonFunction1(((ctx4$2) => {
    var ctx4 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I4(ctx4$2);
    var h5 = $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47__f_initNextHook$43).apply__O__O(ctx4);
    var input = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input;
    var hook1 = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1;
    var hook2 = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2;
    var hook3 = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3;
    var hook4 = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4;
    var ctx5 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I5__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$I5(), input, hook1, hook2, hook3, hook4, h5);
    return $n(f).apply__O__O(ctx5)
  })))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$46$$anon$47", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49(outer, buildPrev$5, initNextHook$44) {
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49__f_buildPrev$5 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49__f_initNextHook$44 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49__f_buildPrev$5 = buildPrev$5;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49__f_initNextHook$44 = initNextHook$44
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49.prototype.apply__F1__F1 = (function(f) {
  return $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49__f_buildPrev$5).apply__F1__F1(new $c_sjsr_AnonFunction1(((ctx5$2) => {
    var ctx5 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I5(ctx5$2);
    var h6 = $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49__f_initNextHook$44).apply__O__O(ctx5);
    var input = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input;
    var hook1 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1;
    var hook2 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2;
    var hook3 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3;
    var hook4 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4;
    var hook5 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5;
    var ctx6 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I6__O__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$I6(), input, hook1, hook2, hook3, hook4, hook5, h6);
    return $n(f).apply__O__O(ctx6)
  })))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$48$$anon$49", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51(outer, buildPrev$6, initNextHook$45) {
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51__f_buildPrev$6 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51__f_initNextHook$45 = null;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51__f_buildPrev$6 = buildPrev$6;
  this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51__f_initNextHook$45 = initNextHook$45
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51.prototype.apply__F1__F1 = (function(f) {
  return $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51__f_buildPrev$6).apply__F1__F1(new $c_sjsr_AnonFunction1(((ctx6$2) => {
    var ctx6 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I6(ctx6$2);
    var h7 = $n(this.Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51__f_initNextHook$45).apply__O__O(ctx6);
    var input = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input;
    var hook1 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1;
    var hook2 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2;
    var hook3 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3;
    var hook4 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4;
    var hook5 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5;
    var hook6 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$I6__f_hook6;
    var ctx7 = new $c_Ljapgolly_scalajs_react_hooks_HookCtx$I7(input, hook1, hook2, hook3, hook4, hook5, hook6, h7);
    return $n(f).apply__O__O(ctx7)
  })))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$50$$anon$51", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep.prototype = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep.prototype.self__F1__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First = (function(initFirst, f) {
  return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First(new $c_sjsr_AnonFunction1(((p$2) => {
    $n(initFirst).apply__O__O(p$2);
    $n(f).apply__O__O(p$2)
  })))
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep.prototype.next__F1__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent = (function(initFirst, hook1) {
  var render = new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    return new $c_sjsr_AnonFunction1(((p$2) => {
      $n(initFirst).apply__O__O(p$2);
      var h1 = $n(hook1).apply__O__O(p$2);
      return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f).apply__O__O($ct_Ljapgolly_scalajs_react_hooks_HookCtx$P1__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P1(), p$2, h1)))
    }))
  }));
  return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(render)
});
function $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$FirstStep"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$FirstStep;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep: 0
}, false, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$FirstStep", {
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$.prototype = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$.prototype;
var $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$: 0
}, false, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$SubsequentStep$", {
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$;
var $n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$;
function $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$)) {
    $n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$ = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep.prototype = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep.prototype.self__F1__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First = (function(initFirst, f) {
  return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First(new $c_sjsr_AnonFunction1(((ctx0$2) => {
    var ctx0 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(ctx0$2);
    $n(initFirst).apply__O__O(ctx0);
    $n(f).apply__O__O(ctx0)
  })))
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep.prototype.next__F1__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent = (function(initFirst, hook1) {
  var render = new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F1(f$2);
    return new $c_sjsr_AnonFunction2(((p$2, pc$2) => {
      var pc = $n($as_Ljapgolly_scalajs_react_PropsChildren(pc$2)).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self;
      var ctx0 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC0__O__sjs_js_Any__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(), p$2, pc);
      $n(initFirst).apply__O__O(ctx0);
      var h1 = $n(hook1).apply__O__O(ctx0);
      return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(f).apply__O__O($ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC1__O__sjs_js_Any__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(), p$2, pc, h1)))
    }))
  }));
  return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(render)
});
function $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$FirstStep"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$FirstStep;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep: 0
}, false, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$FirstStep", {
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$.prototype = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$.prototype;
var $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$: 0
}, false, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$SubsequentStep$", {
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$;
var $n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$;
function $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$)) {
    $n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$ = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep$
}
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I1__O__O__($thiz, input, hook1) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1 = hook1;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I0__O__($thiz, input);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$I1() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I1.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$I0();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I1.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$I1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$I1.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I1.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I1.prototype.toString__T = (function() {
  return (((("HookCtx.withInput(\n  input = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$I1(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$I1) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$I1"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$I1)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I1(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$I1;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$I1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$I1: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$I1", {
  Ljapgolly_scalajs_react_hooks_HookCtx$I1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I1.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$I1;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P1__O__O__($thiz, props, hook1) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = hook1;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P0__O__($thiz, props);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P1() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P1.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P0();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P1.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P1.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P1.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P1.prototype.toString__T = (function() {
  return (((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P1(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P1) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P1"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P1)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P1(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P1;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P1", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P1.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P1;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC0__O__sjs_js_Any__($thiz, props, propsChildren) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren = propsChildren;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P0__O__($thiz, props);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC0() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC0.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P0();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC0.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC0;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$PC0() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$PC0.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC0.prototype;
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC0) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$PC0"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$PC0)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$PC0;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC0 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$PC0: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$PC0", {
  Ljapgolly_scalajs_react_hooks_HookCtx$PC0: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC0.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC0;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$.prototype;
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseCallbackArg$", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1(f$1, g$1) {
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1__f_f$1 = null;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1__f_g$1 = null;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1__f_f$1 = f$1;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1__f_g$1 = g$1
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1.prototype;
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseCallbackArg$$anon$1", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$.prototype.unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1 = (function(F) {
  return new $c_sjsr_AnonFunction1(((x$3$2) => {
    var a = $n(F).dispatchFn__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => x$3$2)));
    return a
  }))
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$.prototype.maybeCleanupF__F1__Ljapgolly_scalajs_react_util_Effect$Sync__F1 = (function(f, F) {
  return new $c_sjsr_AnonFunction1(((fa$2) => {
    $n(F);
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $n(F);
    var fa = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$5 = $n(fa);
    return $n($$x1).toJsFn$extension__Ljapgolly_scalajs_react_callback_Trampoline__sjs_js_Function0(new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$5, f)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$.prototype.cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1 = (function(F, G) {
  return this.maybeCleanupF__F1__Ljapgolly_scalajs_react_util_Effect$Sync__F1(new $c_sjsr_AnonFunction1(((x$4$2) => {
    var a = $n(G).dispatchFn__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => x$4$2)));
    return a
  })), F)
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$.prototype.optionalCallback__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_OptionLike__F1 = (function(F, G, O) {
  return this.maybeCleanupF__F1__Ljapgolly_scalajs_react_util_Effect$Sync__F1(new $c_sjsr_AnonFunction1(((x$5$2) => {
    var value = $n(O).unsafeToJs__O__sjs_js_$bar(x$5$2);
    if ((value === (void 0))) {
      return (void 0)
    } else {
      var a = $n(G).dispatchFn__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => value)));
      return a
    }
  })), F)
});
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseEffectArg$", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$
}
function $p_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$___unsafeCreate__sjs_js_Tuple2__Ljapgolly_scalajs_react_hooks_Hooks$UseReducer($thiz, originalResult) {
  var originalDispatch = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(originalResult[1]);
  return new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(originalResult, originalDispatch)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$.prototype.unsafeCreate__F2__O__F1__Ljapgolly_scalajs_react_hooks_Hooks$UseReducer = (function(reducer, initialArg, init) {
  return $p_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$___unsafeCreate__sjs_js_Tuple2__Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(this, $i_react.useReducer($m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(reducer), initialArg, $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(init)))
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$.prototype.reusability__F2__F2 = (function(S) {
  var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2());
  var r = e.Ljapgolly_scalajs_react_Reusability__f_test;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$2);
    var y = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(y$2);
    var this$3 = $n(x);
    var $$x1 = this$3.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0];
    var this$4 = $n(y);
    if ($uZ($n(S).apply__O__O__O($$x1, this$4.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0]))) {
      return $uZ($n(r).apply__O__O__O($n(x).Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_originalDispatch, $n(y).Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_originalDispatch))
    } else {
      return false
    }
  }));
  return f
});
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseReducer$", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$;
var $n_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$;
function $m_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$)) {
    $n_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$ = new $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2(f$5, r$2, oss$1) {
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw = null;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_originalSetState = null;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_f$5 = null;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_f$5 = f$5;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw = r$2;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_originalSetState = oss$1
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2.prototype;
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseStateF$$anon$2", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Hooks$UseStateF: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_EffectFallbacks5() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_EffectFallbacks5.prototype = new $h_Ljapgolly_scalajs_react_userdefined_Effects();
$c_Ljapgolly_scalajs_react_util_EffectFallbacks5.prototype.constructor = $c_Ljapgolly_scalajs_react_util_EffectFallbacks5;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_EffectFallbacks5() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_EffectFallbacks5.prototype = $c_Ljapgolly_scalajs_react_util_EffectFallbacks5.prototype;
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_OptionLike$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype = $c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype.unsafeToJs__s_Option__sjs_js_$bar = (function(o) {
  if ($n(o).isEmpty__Z()) {
    return (void 0)
  } else {
    var a = $n(o).get__O();
    return a
  }
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype.unsafeToJs__O__sjs_js_$bar = (function(o) {
  return this.unsafeToJs__s_Option__sjs_js_$bar($as_s_Option(o))
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype.toOption__O__s_Option = (function(o) {
  var o$1 = $as_s_Option(o);
  return o$1
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype.isEmpty__O__Z = (function(o) {
  var o$1 = $as_s_Option(o);
  return $n(o$1).isEmpty__Z()
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype.fold__O__F0__F1__O = (function(o, b, f) {
  var o$1 = $as_s_Option(o);
  var this$1 = $n(o$1);
  return (this$1.isEmpty__Z() ? $n(b).apply__O() : $n(f).apply__O__O(this$1.get__O()))
});
var $d_Ljapgolly_scalajs_react_util_OptionLike$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_OptionLike$$anon$1: 0
}, false, "japgolly.scalajs.react.util.OptionLike$$anon$1", {
  Ljapgolly_scalajs_react_util_OptionLike$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_util_OptionLike: 1
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_util_OptionLike$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype.constructor = $c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_OptionLike$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype = $c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype;
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype.fold__sjs_js_$bar__F0__F1__O = (function(o, b, f) {
  return ((o === (void 0)) ? $n(b).apply__O() : $n(f).apply__O__O(o))
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype.isEmpty__sjs_js_$bar__Z = (function(o) {
  return (o === (void 0))
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype.toOption__sjs_js_$bar__s_Option = (function(o) {
  return ((o === (void 0)) ? $m_s_None$() : new $c_s_Some(o))
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype.unsafeToJs__O__sjs_js_$bar = (function(o) {
  return o
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype.toOption__O__s_Option = (function(o) {
  return this.toOption__sjs_js_$bar__s_Option(o)
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype.isEmpty__O__Z = (function(o) {
  return this.isEmpty__sjs_js_$bar__Z(o)
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype.fold__O__F0__F1__O = (function(o, b, f) {
  return this.fold__sjs_js_$bar__F0__F1__O(o, b, f)
});
var $d_Ljapgolly_scalajs_react_util_OptionLike$$anon$2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_OptionLike$$anon$2: 0
}, false, "japgolly.scalajs.react.util.OptionLike$$anon$2", {
  Ljapgolly_scalajs_react_util_OptionLike$$anon$2: 1,
  O: 1,
  Ljapgolly_scalajs_react_util_OptionLike: 1
});
$c_Ljapgolly_scalajs_react_util_OptionLike$$anon$2.prototype.$classData = $d_Ljapgolly_scalajs_react_util_OptionLike$$anon$2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Attr$ClassName$() {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  $ct_Ljapgolly_scalajs_react_vdom_Attr__T__(this, "class")
}
$c_Ljapgolly_scalajs_react_vdom_Attr$ClassName$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Attr();
$c_Ljapgolly_scalajs_react_vdom_Attr$ClassName$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Attr$ClassName$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Attr$ClassName$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Attr$ClassName$.prototype = $c_Ljapgolly_scalajs_react_vdom_Attr$ClassName$.prototype;
$c_Ljapgolly_scalajs_react_vdom_Attr$ClassName$.prototype.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod = (function(a, t) {
  $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  var f = new $c_sjsr_AnonFunction1(((b$2) => {
    var b = $as_Ljapgolly_scalajs_react_vdom_VdomBuilder(b$2);
    $n(t).apply__O__O__O($n(b).Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addClassName, a)
  }));
  return new $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3(f)
});
var $d_Ljapgolly_scalajs_react_vdom_Attr$ClassName$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Attr$ClassName$: 0
}, false, "japgolly.scalajs.react.vdom.Attr$ClassName$", {
  Ljapgolly_scalajs_react_vdom_Attr$ClassName$: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Attr$ClassName$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Attr$ClassName$;
var $n_Ljapgolly_scalajs_react_vdom_Attr$ClassName$;
function $m_Ljapgolly_scalajs_react_vdom_Attr$ClassName$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_Attr$ClassName$)) {
    $n_Ljapgolly_scalajs_react_vdom_Attr$ClassName$ = new $c_Ljapgolly_scalajs_react_vdom_Attr$ClassName$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_Attr$ClassName$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Attr$Event(name) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  $ct_Ljapgolly_scalajs_react_vdom_Attr__T__(this, name)
}
$c_Ljapgolly_scalajs_react_vdom_Attr$Event.prototype = new $h_Ljapgolly_scalajs_react_vdom_Attr();
$c_Ljapgolly_scalajs_react_vdom_Attr$Event.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Attr$Event;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Attr$Event() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Attr$Event.prototype = $c_Ljapgolly_scalajs_react_vdom_Attr$Event.prototype;
$c_Ljapgolly_scalajs_react_vdom_Attr$Event.prototype.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod = (function(a, t) {
  $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  var f = new $c_sjsr_AnonFunction1(((b$2) => {
    var b = $as_Ljapgolly_scalajs_react_vdom_VdomBuilder(b$2);
    $n(t).apply__O__O__O(new $c_sjsr_AnonFunction1(((f$2) => {
      $n($n(b).Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addEventHandler).apply__O__O__O(this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, f$2)
    })), a)
  }));
  return new $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3(f)
});
$c_Ljapgolly_scalajs_react_vdom_Attr$Event.prototype.$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod = (function(callback, F) {
  return this.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(F).apply__O__O(callback), $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_direct)
});
$c_Ljapgolly_scalajs_react_vdom_Attr$Event.prototype.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod = (function(eventHandler, F) {
  var f = ((arg1$2) => {
    this.japgolly$scalajs$react$vdom$Attr$Event$$$anonfun$$eq$eq$greater$1__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__F1__V(arg1$2, F, eventHandler)
  });
  return this.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(f, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_direct)
});
$c_Ljapgolly_scalajs_react_vdom_Attr$Event.prototype.japgolly$scalajs$react$vdom$Attr$Event$$$anonfun$$eq$eq$greater$1__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__F1__V = (function(e, F$3, eventHandler$1) {
  $n(F$3).apply__O__O(new $c_sjsr_AnonFunction0((() => $n(eventHandler$1).apply__O__O(e))))()
});
var $d_Ljapgolly_scalajs_react_vdom_Attr$Event = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Attr$Event: 0
}, false, "japgolly.scalajs.react.vdom.Attr$Event", {
  Ljapgolly_scalajs_react_vdom_Attr$Event: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Attr$Event.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Attr$Event;
function $f_Ljapgolly_scalajs_react_vdom_Attr$EventCallback2__dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($thiz, F) {
  return new $c_sjsr_AnonFunction1(((fa$2) => {
    var fa = $as_F0(fa$2);
    return $n(F).dispatchFn__F0__sjs_js_Function0(fa)
  }))
}
function $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__($thiz, attrName) {
  $ct_Ljapgolly_scalajs_react_vdom_Attr__T__($thiz, attrName);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Attr$Generic() {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null
}
$c_Ljapgolly_scalajs_react_vdom_Attr$Generic.prototype = new $h_Ljapgolly_scalajs_react_vdom_Attr();
$c_Ljapgolly_scalajs_react_vdom_Attr$Generic.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Attr$Generic;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Attr$Generic() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Attr$Generic.prototype = $c_Ljapgolly_scalajs_react_vdom_Attr$Generic.prototype;
$c_Ljapgolly_scalajs_react_vdom_Attr$Generic.prototype.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod = (function(a, t) {
  return $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a)
});
var $d_Ljapgolly_scalajs_react_vdom_Attr$Generic = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Attr$Generic: 0
}, false, "japgolly.scalajs.react.vdom.Attr$Generic", {
  Ljapgolly_scalajs_react_vdom_Attr$Generic: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Attr$Generic.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Attr$Generic;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Attr$Key$() {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  $ct_Ljapgolly_scalajs_react_vdom_Attr__T__(this, "key")
}
$c_Ljapgolly_scalajs_react_vdom_Attr$Key$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Attr();
$c_Ljapgolly_scalajs_react_vdom_Attr$Key$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Attr$Key$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Attr$Key$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Attr$Key$.prototype = $c_Ljapgolly_scalajs_react_vdom_Attr$Key$.prototype;
$c_Ljapgolly_scalajs_react_vdom_Attr$Key$.prototype.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod = (function(a, t) {
  $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  var f = new $c_sjsr_AnonFunction1(((b$2) => {
    var b = $as_Ljapgolly_scalajs_react_vdom_VdomBuilder(b$2);
    $n(t).apply__O__O__O($n(b).Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_setKey, a)
  }));
  return new $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3(f)
});
var $d_Ljapgolly_scalajs_react_vdom_Attr$Key$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Attr$Key$: 0
}, false, "japgolly.scalajs.react.vdom.Attr$Key$", {
  Ljapgolly_scalajs_react_vdom_Attr$Key$: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Attr$Key$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Attr$Key$;
var $n_Ljapgolly_scalajs_react_vdom_Attr$Key$;
function $m_Ljapgolly_scalajs_react_vdom_Attr$Key$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_Attr$Key$)) {
    $n_Ljapgolly_scalajs_react_vdom_Attr$Key$ = new $c_Ljapgolly_scalajs_react_vdom_Attr$Key$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_Attr$Key$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Attr$Style$() {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  $ct_Ljapgolly_scalajs_react_vdom_Attr__T__(this, "style")
}
$c_Ljapgolly_scalajs_react_vdom_Attr$Style$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Attr();
$c_Ljapgolly_scalajs_react_vdom_Attr$Style$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Attr$Style$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Attr$Style$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Attr$Style$.prototype = $c_Ljapgolly_scalajs_react_vdom_Attr$Style$.prototype;
$c_Ljapgolly_scalajs_react_vdom_Attr$Style$.prototype.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod = (function(a, t) {
  $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  var f = new $c_sjsr_AnonFunction1(((b$2) => {
    var b = $as_Ljapgolly_scalajs_react_vdom_VdomBuilder(b$2);
    $n(t).apply__O__O__O(new $c_sjsr_AnonFunction1(((j$2) => {
      var this$2 = $n(b);
      $f_Ljapgolly_scalajs_react_vdom_VdomBuilder__addStyles__sjs_js_Any__V(this$2, j$2)
    })), a)
  }));
  return new $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3(f)
});
var $d_Ljapgolly_scalajs_react_vdom_Attr$Style$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Attr$Style$: 0
}, false, "japgolly.scalajs.react.vdom.Attr$Style$", {
  Ljapgolly_scalajs_react_vdom_Attr$Style$: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Attr$Style$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Attr$Style$;
var $n_Ljapgolly_scalajs_react_vdom_Attr$Style$;
function $m_Ljapgolly_scalajs_react_vdom_Attr$Style$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_Attr$Style$)) {
    $n_Ljapgolly_scalajs_react_vdom_Attr$Style$ = new $c_Ljapgolly_scalajs_react_vdom_Attr$Style$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_Attr$Style$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Exports$() {
  this.Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_TagMod = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomStyle = null;
  $ct_Ljapgolly_scalajs_react_vdom_Exports__(this)
}
$c_Ljapgolly_scalajs_react_vdom_Exports$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Exports();
$c_Ljapgolly_scalajs_react_vdom_Exports$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Exports$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Exports$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Exports$.prototype = $c_Ljapgolly_scalajs_react_vdom_Exports$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_Exports$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Exports$: 0
}, false, "japgolly.scalajs.react.vdom.Exports$", {
  Ljapgolly_scalajs_react_vdom_Exports$: 1,
  Ljapgolly_scalajs_react_vdom_Exports: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Exports$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Exports$;
var $n_Ljapgolly_scalajs_react_vdom_Exports$;
function $m_Ljapgolly_scalajs_react_vdom_Exports$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_Exports$)) {
    $n_Ljapgolly_scalajs_react_vdom_Exports$ = new $c_Ljapgolly_scalajs_react_vdom_Exports$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_Exports$
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrs$__target$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$().Ljapgolly_scalajs_react_vdom_HtmlAttrs$__f_target$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$().Ljapgolly_scalajs_react_vdom_HtmlAttrs$__f_target$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$($thiz)
  }
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$() {
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrs$__f_target$module = null;
  $n_Ljapgolly_scalajs_react_vdom_HtmlAttrs$ = this;
  $f_Ljapgolly_scalajs_react_vdom_HtmlAttrs__$init$__V(this)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlAttrs$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype;
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.target__Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$().Ljapgolly_scalajs_react_vdom_HtmlAttrs$__f_target$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrs$__target$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$().Ljapgolly_scalajs_react_vdom_HtmlAttrs$__f_target$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$key_$eq__Ljapgolly_scalajs_react_vdom_Attr$Key$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$onChange_$eq__Ljapgolly_scalajs_react_vdom_Attr$Event__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$onClick_$eq__Ljapgolly_scalajs_react_vdom_Attr$Event__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$onClickCapture_$eq__Ljapgolly_scalajs_react_vdom_Attr$Event__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$src_$eq__Ljapgolly_scalajs_react_vdom_Attr__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$title_$eq__Ljapgolly_scalajs_react_vdom_Attr__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$type_$eq__Ljapgolly_scalajs_react_vdom_Attr__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$value_$eq__Ljapgolly_scalajs_react_vdom_Attr__V = (function(x$1) {
  /*<skip>*/
});
var $d_Ljapgolly_scalajs_react_vdom_HtmlAttrs$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlAttrs$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlAttrs$", {
  Ljapgolly_scalajs_react_vdom_HtmlAttrs$: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_HtmlAttrs: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlAttrs$;
var $n_Ljapgolly_scalajs_react_vdom_HtmlAttrs$;
function $m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_HtmlAttrs$)) {
    $n_Ljapgolly_scalajs_react_vdom_HtmlAttrs$ = new $c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_HtmlAttrs$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlTagOf$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype;
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype.apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(this$, xs) {
  var this$1 = $n($m_s_package$().s_package$__f_Nil);
  return $ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(new $c_Ljapgolly_scalajs_react_vdom_TagOf(), this$, new $c_sci_$colon$colon(xs, this$1))
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype.productElement$extension__T__I__O = (function(this$, x$1) {
  return ((x$1 === 0) ? this$ : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype.productIterator$extension__T__sc_Iterator = (function(this$) {
  var x = new $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf(this$);
  return new $c_sr_ScalaRunTime$$anon$1(x)
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype.equals$extension__T__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf)) {
    var HtmlTagOf$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_vdom_HtmlTagOf(x$1)).Ljapgolly_scalajs_react_vdom_HtmlTagOf__f_name);
    return (this$ === HtmlTagOf$1)
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype.toString$extension__T__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf(this$))
});
var $d_Ljapgolly_scalajs_react_vdom_HtmlTagOf$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlTagOf$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlTagOf$", {
  Ljapgolly_scalajs_react_vdom_HtmlTagOf$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlTagOf$;
var $n_Ljapgolly_scalajs_react_vdom_HtmlTagOf$;
function $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_HtmlTagOf$)) {
    $n_Ljapgolly_scalajs_react_vdom_HtmlTagOf$ = new $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_HtmlTagOf$
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlTags$__a$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlTags$().Ljapgolly_scalajs_react_vdom_HtmlTags$__f_a$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlTags$().Ljapgolly_scalajs_react_vdom_HtmlTags$__f_a$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlTags$a$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlTags$__input$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlTags$().Ljapgolly_scalajs_react_vdom_HtmlTags$__f_input$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlTags$().Ljapgolly_scalajs_react_vdom_HtmlTags$__f_input$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlTags$input$($thiz)
  }
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlTags$() {
  this.Ljapgolly_scalajs_react_vdom_HtmlTags$__f_a$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlTags$__f_input$module = null
}
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlTags$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlTags$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlTags$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlTags$.prototype;
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$.prototype.a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlTags$().Ljapgolly_scalajs_react_vdom_HtmlTags$__f_a$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlTags$__a$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlTags$().Ljapgolly_scalajs_react_vdom_HtmlTags$__f_a$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$.prototype.input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlTags$().Ljapgolly_scalajs_react_vdom_HtmlTags$__f_input$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlTags$__input$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlTags$().Ljapgolly_scalajs_react_vdom_HtmlTags$__f_input$module
});
var $d_Ljapgolly_scalajs_react_vdom_HtmlTags$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlTags$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlTags$", {
  Ljapgolly_scalajs_react_vdom_HtmlTags$: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_HtmlTags: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlTags$;
var $n_Ljapgolly_scalajs_react_vdom_HtmlTags$;
function $m_Ljapgolly_scalajs_react_vdom_HtmlTags$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_HtmlTags$)) {
    $n_Ljapgolly_scalajs_react_vdom_HtmlTags$ = new $c_Ljapgolly_scalajs_react_vdom_HtmlTags$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_HtmlTags$
}
function $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1__vdomAttrVtInnerHtml__F2($thiz) {
  $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$();
  var fn = new $c_sjsr_AnonFunction2(((b$2, html$2) => {
    var b = $as_F1(b$2);
    var html = $as_T(html$2);
    var $$x1 = $n(b);
    var array = [$ct_T2__O__O__(new $c_T2(), "__html", html)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $n($$x1).apply__O__O($m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields))
  }));
  return fn
}
function $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1__vdomAttrVtKey__F1__F2($thiz, k) {
  $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$();
  var fn = new $c_sjsr_AnonFunction2(((b$2, a$2) => {
    var b = $as_F1(b$2);
    $n(b).apply__O__O($n(k).apply__O__O(a$2))
  }));
  return fn
}
function $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1__$init$__V($thiz) {
  $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$();
  var k = new $c_sjsr_AnonFunction1(((a$3$2) => {
    var a$3 = $as_T(a$3$2);
    return a$3
  }));
  $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS = $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1__vdomAttrVtKey__F1__F2($thiz, k)
}
function $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, o, O, f) {
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(O).fold__O__F0__F1__O(o, new $c_sjsr_AnonFunction0((() => $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty)), f))
}
function $ct_Ljapgolly_scalajs_react_vdom_Style__T__($thiz, name) {
  $thiz.Ljapgolly_scalajs_react_vdom_Style__f_name = name;
  $ct_Ljapgolly_scalajs_react_vdom_Attr__T__($thiz, ("style." + name));
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Style() {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null
}
$c_Ljapgolly_scalajs_react_vdom_Style.prototype = new $h_Ljapgolly_scalajs_react_vdom_Attr();
$c_Ljapgolly_scalajs_react_vdom_Style.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Style;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Style() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Style.prototype = $c_Ljapgolly_scalajs_react_vdom_Style.prototype;
$c_Ljapgolly_scalajs_react_vdom_Style.prototype.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod = (function(a, t) {
  $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  var f = new $c_sjsr_AnonFunction1(((b$2) => {
    var b = $as_Ljapgolly_scalajs_react_vdom_VdomBuilder(b$2);
    $n(t).apply__O__O__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
      $n($n(b).Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addStyle).apply__O__O__O(this.Ljapgolly_scalajs_react_vdom_Style__f_name, x$1$2)
    })), a)
  }));
  return new $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3(f)
});
var $d_Ljapgolly_scalajs_react_vdom_Style = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Style: 0
}, false, "japgolly.scalajs.react.vdom.Style", {
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_Style.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Style;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_SvgTagOf$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_SvgTagOf$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_SvgTagOf$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_SvgTagOf$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_SvgTagOf$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_SvgTagOf$.prototype = $c_Ljapgolly_scalajs_react_vdom_SvgTagOf$.prototype;
$c_Ljapgolly_scalajs_react_vdom_SvgTagOf$.prototype.apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(this$, xs) {
  var this$1 = $n($m_s_package$().s_package$__f_Nil);
  return $ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(new $c_Ljapgolly_scalajs_react_vdom_TagOf(), this$, new $c_sci_$colon$colon(xs, this$1))
});
var $d_Ljapgolly_scalajs_react_vdom_SvgTagOf$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_SvgTagOf$: 0
}, false, "japgolly.scalajs.react.vdom.SvgTagOf$", {
  Ljapgolly_scalajs_react_vdom_SvgTagOf$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_vdom_SvgTagOf$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_SvgTagOf$;
var $n_Ljapgolly_scalajs_react_vdom_SvgTagOf$;
function $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_SvgTagOf$)) {
    $n_Ljapgolly_scalajs_react_vdom_SvgTagOf$ = new $c_Ljapgolly_scalajs_react_vdom_SvgTagOf$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_SvgTagOf$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_SvgTags$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_SvgTags$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_SvgTags$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_SvgTags$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_SvgTags$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_SvgTags$.prototype = $c_Ljapgolly_scalajs_react_vdom_SvgTags$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_SvgTags$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_SvgTags$: 0
}, false, "japgolly.scalajs.react.vdom.SvgTags$", {
  Ljapgolly_scalajs_react_vdom_SvgTags$: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_SvgTags: 1
});
$c_Ljapgolly_scalajs_react_vdom_SvgTags$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_SvgTags$;
var $n_Ljapgolly_scalajs_react_vdom_SvgTags$;
function $m_Ljapgolly_scalajs_react_vdom_SvgTags$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_SvgTags$)) {
    $n_Ljapgolly_scalajs_react_vdom_SvgTags$ = new $c_Ljapgolly_scalajs_react_vdom_SvgTags$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_SvgTags$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2.prototype = $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2.prototype;
$c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2.prototype.applyTo__Ljapgolly_scalajs_react_vdom_VdomBuilder__V = (function(b) {
  /*<skip>*/
});
var $d_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_TagMod$$anon$2: 0
}, false, "japgolly.scalajs.react.vdom.TagMod$$anon$2", {
  Ljapgolly_scalajs_react_vdom_TagMod$$anon$2: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_TagMod: 1
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_TagMod$$anon$2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3(f$1) {
  this.Ljapgolly_scalajs_react_vdom_TagMod$$anon$3__f_f$1 = null;
  this.Ljapgolly_scalajs_react_vdom_TagMod$$anon$3__f_f$1 = f$1
}
$c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3.prototype = $c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3.prototype;
$c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3.prototype.applyTo__Ljapgolly_scalajs_react_vdom_VdomBuilder__V = (function(b) {
  $n(this.Ljapgolly_scalajs_react_vdom_TagMod$$anon$3__f_f$1).apply__O__O(b)
});
var $d_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_TagMod$$anon$3: 0
}, false, "japgolly.scalajs.react.vdom.TagMod$$anon$3", {
  Ljapgolly_scalajs_react_vdom_TagMod$$anon$3: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_TagMod: 1
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_TagMod$$anon$3;
function $f_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToJs__addClassNameToProps__V($thiz) {
  var value = $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_nonEmptyClassName;
  if ((value !== (void 0))) {
    var o = $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_props;
    o.className = value
  }
}
function $f_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToJs__addStyleToProps__V($thiz) {
  var o = $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_styles;
  var value = (($uI(Object.keys(o).length) === 0) ? (void 0) : o);
  if ((value !== (void 0))) {
    var o$1 = $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_props;
    o$1.style = value
  }
}
function $f_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToJs__japgolly$scalajs$react$vdom$VdomBuilder$ToJs$$$anonfun$addEventHandler$3__sjs_js_Any__sjs_js_Function1__sjs_js_Function1__O($thiz, e, f$1, g$1) {
  f$1(e);
  return g$1(e)
}
function $f_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToJs__$init$__V($thiz) {
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_props = {};
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_styles = {};
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_children = [];
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_key = (void 0);
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_nonEmptyClassName = (void 0);
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addAttr = new $c_sjsr_AnonFunction2(((x$4$2, x$5$2) => {
    var x$4 = $as_T(x$4$2);
    var o = $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_props;
    o[x$4] = x$5$2
  }));
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addClassName = new $c_sjsr_AnonFunction1(((n$2) => {
    var value = $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_nonEmptyClassName;
    if ((value === (void 0))) {
      var a = n$2
    } else {
      var s = (($dp_toString__T($n(value)) + " ") + n$2);
      var a = s
    };
    $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_nonEmptyClassName = a
  }));
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addEventHandler = new $c_sjsr_AnonFunction2(((k$2, g$2) => {
    var k = $as_T(k$2);
    var o$1 = $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_props;
    var cur = o$1[k];
    if ((cur === (void 0))) {
      var $$x1 = g$2
    } else {
      if ((cur === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
      };
      var $$x1 = ((arg1$2) => $f_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToJs__japgolly$scalajs$react$vdom$VdomBuilder$ToJs$$$anonfun$addEventHandler$3__sjs_js_Any__sjs_js_Function1__sjs_js_Function1__O($thiz, arg1$2, cur, g$2))
    };
    o$1[k] = $$x1
  }));
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addStyle = new $c_sjsr_AnonFunction2(((x$7$2, x$8$2) => {
    var x$7 = $as_T(x$7$2);
    var o$2 = $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_styles;
    o$2[x$7] = x$8$2
  }));
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addStylesObject = new $c_sjsr_AnonFunction1(((o$2$1) => {
    var this$21 = $n($m_Ljapgolly_scalajs_react_util_JsUtil$().objectIterator__sjs_js_Object__sc_Iterator(o$2$1));
    while (this$21.hasNext__Z()) {
      var arg1 = this$21.next__O();
      var x$9 = $as_T2(arg1);
      if ((x$9 !== null)) {
        var k$1 = $as_T($n(x$9)._1__O());
        var v = $n(x$9)._2__O();
        $as_jl_Void($n($thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addStyle).apply__O__O__O(k$1, v))
      } else {
        throw new $c_s_MatchError(x$9)
      }
    }
  }));
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_appendChild = new $c_sjsr_AnonFunction1(((x$10$2) => {
    $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_children.push(x$10$2)
  }));
  $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_setKey = new $c_sjsr_AnonFunction1(((k$3$2) => {
    $thiz.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_key = k$3$2
  }))
}
function $is_Ljapgolly_scalajs_react_vdom_VdomNode(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_vdom_VdomNode)))
}
function $as_Ljapgolly_scalajs_react_vdom_VdomNode(obj) {
  return (($is_Ljapgolly_scalajs_react_vdom_VdomNode(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.vdom.VdomNode"))
}
function $isArrayOf_Ljapgolly_scalajs_react_vdom_VdomNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_vdom_VdomNode)))
}
function $asArrayOf_Ljapgolly_scalajs_react_vdom_VdomNode(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_vdom_VdomNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.vdom.VdomNode;", depth))
}
/** @constructor */
function $c_Ljapgolly_univeq_UnivEq$$anon$1() {
  /*<skip>*/
}
$c_Ljapgolly_univeq_UnivEq$$anon$1.prototype = new $h_O();
$c_Ljapgolly_univeq_UnivEq$$anon$1.prototype.constructor = $c_Ljapgolly_univeq_UnivEq$$anon$1;
/** @constructor */
function $h_Ljapgolly_univeq_UnivEq$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_univeq_UnivEq$$anon$1.prototype = $c_Ljapgolly_univeq_UnivEq$$anon$1.prototype;
var $d_Ljapgolly_univeq_UnivEq$$anon$1 = new $TypeData().initClass({
  Ljapgolly_univeq_UnivEq$$anon$1: 0
}, false, "japgolly.univeq.UnivEq$$anon$1", {
  Ljapgolly_univeq_UnivEq$$anon$1: 1,
  O: 1,
  Ljapgolly_univeq_UnivEq: 1
});
$c_Ljapgolly_univeq_UnivEq$$anon$1.prototype.$classData = $d_Ljapgolly_univeq_UnivEq$$anon$1;
/** @constructor */
function $c_jl_Byte$() {
  /*<skip>*/
}
$c_jl_Byte$.prototype = new $h_O();
$c_jl_Byte$.prototype.constructor = $c_jl_Byte$;
/** @constructor */
function $h_jl_Byte$() {
  /*<skip>*/
}
$h_jl_Byte$.prototype = $c_jl_Byte$.prototype;
$c_jl_Byte$.prototype.parseByte__T__I__B = (function(s, radix) {
  var r = $m_jl_Integer$().parseInt__T__I__I(s, radix);
  if (((r < (-128)) || (r > 127))) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
  } else {
    return ((r << 24) >> 24)
  }
});
var $d_jl_Byte$ = new $TypeData().initClass({
  jl_Byte$: 0
}, false, "java.lang.Byte$", {
  jl_Byte$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Byte$.prototype.$classData = $d_jl_Byte$;
var $n_jl_Byte$;
function $m_jl_Byte$() {
  if ((!$n_jl_Byte$)) {
    $n_jl_Byte$ = new $c_jl_Byte$()
  };
  return $n_jl_Byte$
}
function $p_jl_Character$__getTypeGE256__I__I($thiz, codePoint) {
  return $n($p_jl_Character$__charTypes__AI($thiz)).get($p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, $p_jl_Character$__charTypeIndices__AI($thiz), codePoint, false))
}
function $p_jl_Character$__isLowerCaseGE256__I__Z($thiz, c) {
  return ((((((((((((((((((c >= 688) && (c <= 696)) || ((c >= 704) && (c <= 705))) || ((c >= 736) && (c <= 740))) || (c === 837)) || (c === 890)) || ((c >= 7468) && (c <= 7530))) || (c === 7544)) || ((c >= 7579) && (c <= 7615))) || (c === 8305)) || (c === 8319)) || ((c >= 8336) && (c <= 8348))) || ((c >= 8560) && (c <= 8575))) || ((c >= 9424) && (c <= 9449))) || ((c >= 11388) && (c <= 11389))) || (c === 42864)) || ((c >= 43000) && (c <= 43001))) || ($p_jl_Character$__getTypeGE256__I__I($thiz, c) === 2))
}
function $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI($thiz) {
  if (((((1 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_java$lang$Character$$charTypesFirst256 = new $ac_I(new Int32Array([15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 24, 24, 26, 24, 24, 24, 21, 22, 24, 25, 24, 20, 24, 24, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 24, 24, 25, 25, 25, 24, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 21, 24, 22, 27, 23, 27, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 21, 25, 22, 25, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 26, 26, 26, 26, 28, 24, 27, 28, 5, 29, 25, 16, 28, 27, 28, 25, 11, 11, 27, 2, 24, 24, 27, 11, 5, 30, 11, 11, 11, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 25, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 25, 2, 2, 2, 2, 2, 2, 2, 2]));
    $thiz.jl_Character$__f_bitmap$0 = (((1 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_java$lang$Character$$charTypesFirst256
}
function $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) {
  if (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    var deltas = new $ac_I(new Int32Array([257, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 3, 2, 1, 1, 1, 2, 1, 3, 2, 4, 1, 2, 1, 3, 3, 2, 1, 2, 1, 1, 1, 1, 1, 2, 1, 1, 2, 1, 1, 2, 1, 3, 1, 1, 1, 2, 2, 1, 1, 3, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 2, 1, 2, 2, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 69, 1, 27, 18, 4, 12, 14, 5, 7, 1, 1, 1, 17, 112, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 3, 1, 5, 2, 1, 1, 3, 1, 1, 1, 2, 1, 17, 1, 9, 35, 1, 2, 3, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 2, 2, 51, 48, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 38, 2, 1, 6, 1, 39, 1, 1, 1, 4, 1, 1, 45, 1, 1, 1, 2, 1, 2, 1, 1, 8, 27, 5, 3, 2, 11, 5, 1, 3, 2, 1, 2, 2, 11, 1, 2, 2, 32, 1, 10, 21, 10, 4, 2, 1, 99, 1, 1, 7, 1, 1, 6, 2, 2, 1, 4, 2, 10, 3, 2, 1, 14, 1, 1, 1, 1, 30, 27, 2, 89, 11, 1, 14, 10, 33, 9, 2, 1, 3, 1, 5, 22, 4, 1, 9, 1, 3, 1, 5, 2, 15, 1, 25, 3, 2, 1, 65, 1, 1, 11, 55, 27, 1, 3, 1, 54, 1, 1, 1, 1, 3, 8, 4, 1, 2, 1, 7, 10, 2, 2, 10, 1, 1, 6, 1, 7, 1, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 1, 3, 4, 2, 1, 1, 3, 4, 2, 2, 2, 2, 1, 1, 8, 1, 4, 2, 1, 3, 2, 2, 10, 2, 2, 6, 1, 1, 5, 2, 1, 1, 6, 4, 2, 2, 22, 1, 7, 1, 2, 1, 2, 1, 2, 2, 1, 1, 3, 2, 4, 2, 2, 3, 3, 1, 7, 4, 1, 1, 7, 10, 2, 3, 1, 11, 2, 1, 1, 9, 1, 3, 1, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 3, 5, 1, 2, 1, 1, 2, 1, 2, 1, 15, 2, 2, 2, 10, 1, 1, 15, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 1, 1, 1, 4, 2, 2, 2, 2, 1, 8, 1, 1, 4, 2, 1, 3, 2, 2, 10, 1, 1, 6, 10, 1, 1, 1, 6, 3, 3, 1, 4, 3, 2, 1, 1, 1, 2, 3, 2, 3, 3, 3, 12, 4, 2, 1, 2, 3, 3, 1, 3, 1, 2, 1, 6, 1, 14, 10, 3, 6, 1, 1, 6, 3, 1, 8, 1, 3, 1, 23, 1, 10, 1, 5, 3, 1, 3, 4, 1, 3, 1, 4, 7, 2, 1, 2, 6, 2, 2, 2, 10, 8, 7, 1, 2, 2, 1, 8, 1, 3, 1, 23, 1, 10, 1, 5, 2, 1, 1, 1, 1, 5, 1, 1, 2, 1, 2, 2, 7, 2, 7, 1, 1, 2, 2, 2, 10, 1, 2, 15, 2, 1, 8, 1, 3, 1, 41, 2, 1, 3, 4, 1, 3, 1, 3, 1, 1, 8, 1, 8, 2, 2, 2, 10, 6, 3, 1, 6, 2, 2, 1, 18, 3, 24, 1, 9, 1, 1, 2, 7, 3, 1, 4, 3, 3, 1, 1, 1, 8, 18, 2, 1, 12, 48, 1, 2, 7, 4, 1, 6, 1, 8, 1, 10, 2, 37, 2, 1, 1, 2, 2, 1, 1, 2, 1, 6, 4, 1, 7, 1, 3, 1, 1, 1, 1, 2, 2, 1, 4, 1, 2, 6, 1, 2, 1, 2, 5, 1, 1, 1, 6, 2, 10, 2, 4, 32, 1, 3, 15, 1, 1, 3, 2, 6, 10, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 8, 1, 36, 4, 14, 1, 5, 1, 2, 5, 11, 1, 36, 1, 8, 1, 6, 1, 2, 5, 4, 2, 37, 43, 2, 4, 1, 6, 1, 2, 2, 2, 1, 10, 6, 6, 2, 2, 4, 3, 1, 3, 2, 7, 3, 4, 13, 1, 2, 2, 6, 1, 1, 1, 10, 3, 1, 2, 38, 1, 1, 5, 1, 2, 43, 1, 1, 332, 1, 4, 2, 7, 1, 1, 1, 4, 2, 41, 1, 4, 2, 33, 1, 4, 2, 7, 1, 1, 1, 4, 2, 15, 1, 57, 1, 4, 2, 67, 2, 3, 9, 20, 3, 16, 10, 6, 85, 11, 1, 620, 2, 17, 1, 26, 1, 1, 3, 75, 3, 3, 15, 13, 1, 4, 3, 11, 18, 3, 2, 9, 18, 2, 12, 13, 1, 3, 1, 2, 12, 52, 2, 1, 7, 8, 1, 2, 11, 3, 1, 3, 1, 1, 1, 2, 10, 6, 10, 6, 6, 1, 4, 3, 1, 1, 10, 6, 35, 1, 52, 8, 41, 1, 1, 5, 70, 10, 29, 3, 3, 4, 2, 3, 4, 2, 1, 6, 3, 4, 1, 3, 2, 10, 30, 2, 5, 11, 44, 4, 17, 7, 2, 6, 10, 1, 3, 34, 23, 2, 3, 2, 2, 53, 1, 1, 1, 7, 1, 1, 1, 1, 2, 8, 6, 10, 2, 1, 10, 6, 10, 6, 7, 1, 6, 82, 4, 1, 47, 1, 1, 5, 1, 1, 5, 1, 2, 7, 4, 10, 7, 10, 9, 9, 3, 2, 1, 30, 1, 4, 2, 2, 1, 1, 2, 2, 10, 44, 1, 1, 2, 3, 1, 1, 3, 2, 8, 4, 36, 8, 8, 2, 2, 3, 5, 10, 3, 3, 10, 30, 6, 2, 64, 8, 8, 3, 1, 13, 1, 7, 4, 1, 4, 2, 1, 2, 9, 44, 63, 13, 1, 34, 37, 39, 21, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 8, 6, 2, 6, 2, 8, 8, 8, 8, 6, 2, 6, 2, 8, 1, 1, 1, 1, 1, 1, 1, 1, 8, 8, 14, 2, 8, 8, 8, 8, 8, 8, 5, 1, 2, 4, 1, 1, 1, 3, 3, 1, 2, 4, 1, 3, 4, 2, 2, 4, 1, 3, 8, 5, 3, 2, 3, 1, 2, 4, 1, 2, 1, 11, 5, 6, 2, 1, 1, 1, 2, 1, 1, 1, 8, 1, 1, 5, 1, 9, 1, 1, 4, 2, 3, 1, 1, 1, 11, 1, 1, 1, 10, 1, 5, 5, 6, 1, 1, 2, 6, 3, 1, 1, 1, 10, 3, 1, 1, 1, 13, 3, 32, 16, 13, 4, 1, 3, 12, 15, 2, 1, 4, 1, 2, 1, 3, 2, 3, 1, 1, 1, 2, 1, 5, 6, 1, 1, 1, 1, 1, 1, 4, 1, 1, 4, 1, 4, 1, 2, 2, 2, 5, 1, 4, 1, 1, 2, 1, 1, 16, 35, 1, 1, 4, 1, 6, 5, 5, 2, 4, 1, 2, 1, 2, 1, 7, 1, 31, 2, 2, 1, 1, 1, 31, 268, 8, 4, 20, 2, 7, 1, 1, 81, 1, 30, 25, 40, 6, 18, 12, 39, 25, 11, 21, 60, 78, 22, 183, 1, 9, 1, 54, 8, 111, 1, 144, 1, 103, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 30, 44, 5, 1, 1, 31, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 16, 256, 131, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 63, 1, 1, 1, 1, 32, 1, 1, 258, 48, 21, 2, 6, 3, 10, 166, 47, 1, 47, 1, 1, 1, 3, 2, 1, 1, 1, 1, 1, 1, 4, 1, 1, 2, 1, 6, 2, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 6, 1, 1, 1, 1, 3, 1, 1, 5, 4, 1, 2, 38, 1, 1, 5, 1, 2, 56, 7, 1, 1, 14, 1, 23, 9, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 32, 2, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 9, 1, 2, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 10, 2, 68, 26, 1, 89, 12, 214, 26, 12, 4, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 9, 4, 2, 1, 5, 2, 3, 1, 1, 1, 2, 1, 86, 2, 2, 2, 2, 1, 1, 90, 1, 3, 1, 5, 41, 3, 94, 1, 2, 4, 10, 27, 5, 36, 12, 16, 31, 1, 10, 30, 8, 1, 15, 32, 10, 39, 15, 320, 6582, 10, 64, 20941, 51, 21, 1, 1143, 3, 55, 9, 40, 6, 2, 268, 1, 3, 16, 10, 2, 20, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 1, 70, 10, 2, 6, 8, 23, 9, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 12, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 77, 2, 1, 7, 1, 3, 1, 4, 1, 23, 2, 2, 1, 4, 4, 6, 2, 1, 1, 6, 52, 4, 8, 2, 50, 16, 1, 9, 2, 10, 6, 18, 6, 3, 1, 4, 10, 28, 8, 2, 23, 11, 2, 11, 1, 29, 3, 3, 1, 47, 1, 2, 4, 2, 1, 4, 13, 1, 1, 10, 4, 2, 32, 41, 6, 2, 2, 2, 2, 9, 3, 1, 8, 1, 1, 2, 10, 2, 4, 16, 1, 6, 3, 1, 1, 4, 48, 1, 1, 3, 2, 2, 5, 2, 1, 1, 1, 24, 2, 1, 2, 11, 1, 2, 2, 2, 1, 2, 1, 1, 10, 6, 2, 6, 2, 6, 9, 7, 1, 7, 145, 35, 2, 1, 2, 1, 2, 1, 1, 1, 2, 10, 6, 11172, 12, 23, 4, 49, 4, 2048, 6400, 366, 2, 106, 38, 7, 12, 5, 5, 1, 1, 10, 1, 13, 1, 5, 1, 1, 1, 2, 1, 2, 1, 108, 16, 17, 363, 1, 1, 16, 64, 2, 54, 40, 12, 1, 1, 2, 16, 7, 1, 1, 1, 6, 7, 9, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 4, 3, 3, 1, 4, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 3, 1, 1, 1, 2, 4, 5, 1, 135, 2, 1, 1, 3, 1, 3, 1, 1, 1, 1, 1, 1, 2, 10, 2, 3, 2, 26, 1, 1, 1, 1, 1, 1, 26, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 10, 1, 45, 2, 31, 3, 6, 2, 6, 2, 6, 2, 3, 3, 2, 1, 1, 1, 2, 1, 1, 4, 2, 10, 3, 2, 2, 12, 1, 26, 1, 19, 1, 2, 1, 15, 2, 14, 34, 123, 5, 3, 4, 45, 3, 9, 53, 4, 17, 1, 5, 12, 52, 45, 1, 130, 29, 3, 49, 47, 31, 1, 4, 12, 17, 1, 8, 1, 53, 30, 1, 1, 36, 4, 8, 1, 5, 42, 40, 40, 78, 2, 10, 854, 6, 2, 1, 1, 44, 1, 2, 3, 1, 2, 23, 1, 1, 8, 160, 22, 6, 3, 1, 26, 5, 1, 64, 56, 6, 2, 64, 1, 3, 1, 2, 5, 4, 4, 1, 3, 1, 27, 4, 3, 4, 1, 8, 8, 9, 7, 29, 2, 1, 128, 54, 3, 7, 22, 2, 8, 19, 5, 8, 128, 73, 535, 31, 385, 1, 1, 1, 53, 15, 7, 4, 20, 10, 16, 2, 1, 45, 3, 4, 2, 2, 2, 1, 4, 14, 25, 7, 10, 6, 3, 36, 5, 1, 8, 1, 10, 4, 60, 2, 1, 48, 3, 9, 2, 4, 4, 7, 10, 1190, 43, 1, 1, 1, 2, 6, 1, 1, 8, 10, 2358, 879, 145, 99, 13, 4, 2956, 1071, 13265, 569, 1223, 69, 11, 1, 46, 16, 4, 13, 16480, 2, 8190, 246, 10, 39, 2, 60, 2, 3, 3, 6, 8, 8, 2, 7, 30, 4, 48, 34, 66, 3, 1, 186, 87, 9, 18, 142, 26, 26, 26, 7, 1, 18, 26, 26, 1, 1, 2, 2, 1, 2, 2, 2, 4, 1, 8, 4, 1, 1, 1, 7, 1, 11, 26, 26, 2, 1, 4, 2, 8, 1, 7, 1, 26, 2, 1, 4, 1, 5, 1, 1, 3, 7, 1, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 28, 2, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 1, 1, 2, 50, 5632, 4, 1, 27, 1, 2, 1, 1, 2, 1, 1, 10, 1, 4, 1, 1, 1, 1, 6, 1, 4, 1, 1, 1, 1, 1, 1, 3, 1, 2, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 2, 4, 1, 7, 1, 4, 1, 4, 1, 1, 1, 10, 1, 17, 5, 3, 1, 5, 1, 17, 52, 2, 270, 44, 4, 100, 12, 15, 2, 14, 2, 15, 1, 15, 32, 11, 5, 31, 1, 60, 4, 43, 75, 29, 13, 43, 5, 9, 7, 2, 174, 33, 15, 6, 1, 70, 3, 20, 12, 37, 1, 5, 21, 17, 15, 63, 1, 1, 1, 182, 1, 4, 3, 62, 2, 4, 12, 24, 147, 70, 4, 11, 48, 70, 58, 116, 2188, 42711, 41, 4149, 11, 222, 16354, 542, 722403, 1, 30, 96, 128, 240, 65040, 65534, 2, 65534]));
    $thiz.jl_Character$__f_charTypeIndices = $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas);
    $thiz.jl_Character$__f_bitmap$0 = (((2 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_charTypeIndices
}
function $p_jl_Character$__charTypeIndices__AI($thiz) {
  return (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypeIndices)
}
function $p_jl_Character$__charTypes$lzycompute__AI($thiz) {
  if (((((4 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_charTypes = new $ac_I(new Int32Array([1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 1, 2, 5, 1, 3, 2, 1, 3, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 2, 4, 27, 4, 27, 4, 27, 4, 27, 4, 27, 6, 1, 2, 1, 2, 4, 27, 1, 2, 0, 4, 2, 24, 0, 27, 1, 24, 1, 0, 1, 0, 1, 2, 1, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 25, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 6, 7, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 4, 24, 0, 2, 0, 24, 20, 0, 26, 0, 6, 20, 6, 24, 6, 24, 6, 24, 6, 0, 5, 0, 5, 24, 0, 16, 0, 25, 24, 26, 24, 28, 6, 24, 0, 24, 5, 4, 5, 6, 9, 24, 5, 6, 5, 24, 5, 6, 16, 28, 6, 4, 6, 28, 6, 5, 9, 5, 28, 5, 24, 0, 16, 5, 6, 5, 6, 0, 5, 6, 5, 0, 9, 5, 6, 4, 28, 24, 4, 0, 5, 6, 4, 6, 4, 6, 4, 6, 0, 24, 0, 5, 6, 0, 24, 0, 5, 0, 5, 0, 6, 0, 6, 8, 5, 6, 8, 6, 5, 8, 6, 8, 6, 8, 5, 6, 5, 6, 24, 9, 24, 4, 5, 0, 5, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 8, 0, 8, 6, 5, 0, 8, 0, 5, 0, 5, 6, 0, 9, 5, 26, 11, 28, 26, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 0, 9, 6, 5, 6, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 6, 8, 0, 8, 6, 0, 5, 0, 5, 6, 0, 9, 24, 26, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 6, 0, 8, 0, 8, 6, 0, 6, 8, 0, 5, 0, 5, 6, 0, 9, 28, 5, 11, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 8, 6, 8, 0, 8, 0, 8, 6, 0, 5, 0, 8, 0, 9, 11, 28, 26, 28, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 6, 8, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 6, 0, 9, 0, 11, 28, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 0, 6, 8, 0, 8, 6, 0, 8, 0, 5, 0, 5, 6, 0, 9, 0, 5, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 8, 6, 0, 8, 0, 8, 6, 5, 0, 8, 0, 5, 6, 0, 9, 11, 0, 28, 5, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 8, 0, 8, 24, 0, 5, 6, 5, 6, 0, 26, 5, 4, 6, 24, 9, 24, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 6, 5, 6, 0, 6, 5, 0, 5, 0, 4, 0, 6, 0, 9, 0, 5, 0, 5, 28, 24, 28, 24, 28, 6, 28, 9, 11, 28, 6, 28, 6, 28, 6, 21, 22, 21, 22, 8, 5, 0, 5, 0, 6, 8, 6, 24, 6, 5, 6, 0, 6, 0, 28, 6, 28, 0, 28, 24, 28, 24, 0, 5, 8, 6, 8, 6, 8, 6, 8, 6, 5, 9, 24, 5, 8, 6, 5, 6, 5, 8, 5, 8, 5, 6, 5, 6, 8, 6, 8, 6, 5, 8, 9, 8, 6, 28, 1, 0, 1, 0, 1, 0, 5, 24, 4, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 11, 0, 5, 28, 0, 5, 0, 20, 5, 24, 5, 12, 5, 21, 22, 0, 5, 24, 10, 0, 5, 0, 5, 6, 0, 5, 6, 24, 0, 5, 6, 0, 5, 0, 5, 0, 6, 0, 5, 6, 8, 6, 8, 6, 8, 6, 24, 4, 24, 26, 5, 6, 0, 9, 0, 11, 0, 24, 20, 24, 6, 12, 0, 9, 0, 5, 4, 5, 0, 5, 6, 5, 0, 5, 0, 5, 0, 6, 8, 6, 8, 0, 8, 6, 8, 6, 0, 28, 0, 24, 9, 5, 0, 5, 0, 5, 0, 8, 5, 8, 0, 9, 11, 0, 28, 5, 6, 8, 0, 24, 5, 8, 6, 8, 6, 0, 6, 8, 6, 8, 6, 8, 6, 0, 6, 9, 0, 9, 0, 24, 4, 24, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 6, 8, 5, 0, 9, 24, 28, 6, 28, 0, 6, 8, 5, 8, 6, 8, 6, 8, 6, 8, 5, 9, 5, 6, 8, 6, 8, 6, 8, 6, 8, 0, 24, 5, 8, 6, 8, 6, 0, 24, 9, 0, 5, 9, 5, 4, 24, 0, 24, 0, 6, 24, 6, 8, 6, 5, 6, 5, 8, 6, 5, 0, 2, 4, 2, 4, 2, 4, 6, 0, 6, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 2, 1, 2, 1, 2, 0, 1, 0, 2, 0, 1, 0, 1, 0, 1, 0, 1, 2, 1, 2, 0, 2, 3, 2, 3, 2, 3, 2, 0, 2, 1, 3, 27, 2, 27, 2, 0, 2, 1, 3, 27, 2, 0, 2, 1, 0, 27, 2, 1, 27, 0, 2, 0, 2, 1, 3, 27, 0, 12, 16, 20, 24, 29, 30, 21, 29, 30, 21, 29, 24, 13, 14, 16, 12, 24, 29, 30, 24, 23, 24, 25, 21, 22, 24, 25, 24, 23, 24, 12, 16, 0, 16, 11, 4, 0, 11, 25, 21, 22, 4, 11, 25, 21, 22, 0, 4, 0, 26, 0, 6, 7, 6, 7, 6, 0, 28, 1, 28, 1, 28, 2, 1, 2, 1, 2, 28, 1, 28, 25, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 2, 1, 2, 5, 2, 28, 2, 1, 25, 1, 2, 28, 25, 28, 2, 28, 11, 10, 1, 2, 10, 11, 0, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 21, 22, 28, 25, 28, 25, 28, 25, 28, 0, 28, 0, 28, 0, 11, 28, 11, 28, 25, 28, 25, 28, 25, 28, 25, 28, 0, 28, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 11, 28, 25, 21, 22, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 28, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 21, 22, 21, 22, 25, 21, 22, 25, 28, 25, 28, 25, 0, 28, 0, 1, 0, 2, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 1, 2, 1, 2, 6, 1, 2, 0, 24, 11, 24, 2, 0, 2, 0, 2, 0, 5, 0, 4, 24, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 29, 30, 29, 30, 24, 29, 30, 24, 29, 30, 24, 20, 24, 20, 24, 29, 30, 24, 29, 30, 21, 22, 21, 22, 21, 22, 21, 22, 24, 4, 24, 20, 0, 28, 0, 28, 0, 28, 0, 28, 0, 12, 24, 28, 4, 5, 10, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 28, 21, 22, 21, 22, 21, 22, 21, 22, 20, 21, 22, 28, 10, 6, 8, 20, 4, 28, 10, 4, 5, 24, 28, 0, 5, 0, 6, 27, 4, 5, 20, 5, 24, 4, 5, 0, 5, 0, 5, 0, 28, 11, 28, 5, 0, 28, 0, 5, 28, 0, 11, 28, 11, 28, 11, 28, 11, 28, 11, 28, 5, 0, 28, 5, 0, 5, 4, 5, 0, 28, 0, 5, 4, 24, 5, 4, 24, 5, 9, 5, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 6, 7, 24, 6, 24, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 6, 5, 10, 6, 24, 0, 27, 4, 27, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 27, 1, 2, 1, 2, 0, 1, 2, 1, 2, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 0, 4, 2, 5, 6, 5, 6, 5, 6, 5, 8, 6, 8, 28, 0, 11, 28, 26, 28, 0, 5, 24, 0, 8, 5, 8, 6, 0, 24, 9, 0, 6, 5, 24, 5, 0, 9, 5, 6, 24, 5, 6, 8, 0, 24, 5, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 24, 0, 4, 9, 0, 24, 0, 5, 6, 8, 6, 8, 6, 0, 5, 6, 5, 6, 8, 0, 9, 0, 24, 5, 4, 5, 28, 5, 8, 0, 5, 6, 5, 6, 5, 6, 5, 6, 5, 6, 5, 0, 5, 4, 24, 5, 8, 6, 8, 24, 5, 4, 8, 6, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 8, 6, 8, 6, 8, 24, 8, 6, 0, 9, 0, 5, 0, 5, 0, 5, 0, 19, 18, 5, 0, 5, 0, 2, 0, 2, 0, 5, 6, 5, 25, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 27, 0, 5, 21, 22, 0, 5, 0, 5, 0, 5, 26, 28, 0, 6, 24, 21, 22, 24, 0, 6, 0, 24, 20, 23, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 24, 21, 22, 24, 23, 24, 0, 24, 20, 21, 22, 21, 22, 21, 22, 24, 25, 20, 25, 0, 24, 26, 24, 0, 5, 0, 5, 0, 16, 0, 24, 26, 24, 21, 22, 24, 25, 24, 20, 24, 9, 24, 25, 24, 1, 21, 24, 22, 27, 23, 27, 2, 21, 25, 22, 25, 21, 22, 24, 21, 22, 24, 5, 4, 5, 4, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 26, 25, 27, 28, 26, 0, 28, 25, 28, 0, 16, 28, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 0, 11, 0, 28, 10, 11, 28, 11, 0, 28, 0, 28, 6, 0, 5, 0, 5, 0, 5, 0, 11, 0, 5, 10, 5, 10, 0, 5, 0, 24, 5, 0, 5, 24, 10, 0, 1, 2, 5, 0, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 11, 0, 5, 11, 0, 24, 5, 0, 24, 0, 5, 0, 5, 0, 5, 6, 0, 6, 0, 6, 5, 0, 5, 0, 5, 0, 6, 0, 6, 11, 0, 24, 0, 5, 11, 24, 0, 5, 0, 24, 5, 0, 11, 5, 0, 11, 0, 5, 0, 11, 0, 8, 6, 8, 5, 6, 24, 0, 11, 9, 0, 6, 8, 5, 8, 6, 8, 6, 24, 16, 24, 0, 5, 0, 9, 0, 6, 5, 6, 8, 6, 0, 9, 24, 0, 6, 8, 5, 8, 6, 8, 5, 24, 0, 9, 0, 5, 6, 8, 6, 8, 6, 8, 6, 0, 9, 0, 5, 0, 10, 0, 24, 0, 5, 0, 5, 0, 5, 0, 5, 8, 0, 6, 4, 0, 5, 0, 28, 0, 28, 0, 28, 8, 6, 28, 8, 16, 6, 28, 6, 28, 6, 28, 0, 28, 6, 28, 0, 28, 0, 11, 0, 1, 2, 1, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 2, 0, 2, 0, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 2, 0, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 25, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 11, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 5, 0, 5, 0, 5, 0, 5, 0, 16, 0, 16, 0, 6, 0, 18, 0, 18, 0]));
    $thiz.jl_Character$__f_bitmap$0 = (((4 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_charTypes
}
function $p_jl_Character$__charTypes__AI($thiz) {
  return (((((4 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypes$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypes)
}
function $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas) {
  var acc = $n(deltas).get(0);
  var i = 1;
  var len = $n(deltas).u.length;
  while ((i !== len)) {
    acc = ((acc + $n(deltas).get(i)) | 0);
    $n(deltas).set(i, acc);
    i = ((1 + i) | 0)
  };
  return deltas
}
function $p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, startOfRangesArray, value, hasEmptyRanges) {
  var i = $m_ju_Arrays$().binarySearch__AI__I__I(startOfRangesArray, value);
  if ((i >= 0)) {
    if (hasEmptyRanges) {
      var j = ((1 + i) | 0);
      while (((j < $n(startOfRangesArray).u.length) && ($n(startOfRangesArray).get(j) === value))) {
        j = ((1 + j) | 0)
      };
      return j
    } else {
      return ((1 + i) | 0)
    }
  } else {
    return (((-1) - i) | 0)
  }
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) {
  if (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints = new $ac_I(new Int32Array([1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43600, 44016, 65296, 66720, 69734, 69872, 69942, 70096, 71360, 120782, 120792, 120802, 120812, 120822]));
    $thiz.jl_Character$__f_bitmap$0 = (((32 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI($thiz) {
  return (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) : $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints)
}
/** @constructor */
function $c_jl_Character$() {
  this.jl_Character$__f_java$lang$Character$$charTypesFirst256 = null;
  this.jl_Character$__f_charTypeIndices = null;
  this.jl_Character$__f_charTypes = null;
  this.jl_Character$__f_nonASCIIZeroDigitCodePoints = null;
  this.jl_Character$__f_bitmap$0 = 0
}
$c_jl_Character$.prototype = new $h_O();
$c_jl_Character$.prototype.constructor = $c_jl_Character$;
/** @constructor */
function $h_jl_Character$() {
  /*<skip>*/
}
$h_jl_Character$.prototype = $c_jl_Character$.prototype;
$c_jl_Character$.prototype.toString__I__T = (function(codePoint) {
  if (((codePoint >= 0) && (codePoint < 65536))) {
    return $as_T(String.fromCharCode(codePoint))
  } else if (((codePoint >= 0) && (codePoint <= 1114111))) {
    return $as_T(String.fromCharCode((65535 & (55296 | (((-64) + (codePoint >> 10)) | 0))), (65535 & (56320 | (1023 & codePoint)))))
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_jl_Character$.prototype.getType__I__I = (function(codePoint) {
  return ((codePoint < 0) ? 0 : ((codePoint < 256) ? $n(this.java$lang$Character$$charTypesFirst256__AI()).get(codePoint) : $p_jl_Character$__getTypeGE256__I__I(this, codePoint)))
});
$c_jl_Character$.prototype.digitWithValidRadix__I__I__I = (function(codePoint, radix) {
  if ((codePoint < 256)) {
    var value = (((codePoint >= 48) && (codePoint <= 57)) ? (((-48) + codePoint) | 0) : (((codePoint >= 65) && (codePoint <= 90)) ? (((-55) + codePoint) | 0) : (((codePoint >= 97) && (codePoint <= 122)) ? (((-87) + codePoint) | 0) : (-1))))
  } else if (((codePoint >= 65313) && (codePoint <= 65338))) {
    var value = (((-65303) + codePoint) | 0)
  } else if (((codePoint >= 65345) && (codePoint <= 65370))) {
    var value = (((-65335) + codePoint) | 0)
  } else {
    var p = $m_ju_Arrays$().binarySearch__AI__I__I($p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this), codePoint);
    var zeroCodePointIndex = ((p < 0) ? (((-2) - p) | 0) : p);
    if ((zeroCodePointIndex < 0)) {
      var value = (-1)
    } else {
      var v = ((codePoint - $n($p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this)).get(zeroCodePointIndex)) | 0);
      var value = ((v > 9) ? (-1) : v)
    }
  };
  return ((value < radix) ? value : (-1))
});
$c_jl_Character$.prototype.isZeroDigit__C__Z = (function(ch) {
  return ((ch < 256) ? (ch === 48) : ($m_ju_Arrays$().binarySearch__AI__I__I($p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this), ch) >= 0))
});
$c_jl_Character$.prototype.forDigit__I__I__C = (function(digit, radix) {
  if (((((radix < 2) || (radix > 36)) || (digit < 0)) || (digit >= radix))) {
    return 0
  } else {
    var overBaseTen = (((-10) + digit) | 0);
    var result = ((overBaseTen < 0) ? ((48 + digit) | 0) : ((97 + overBaseTen) | 0));
    return (65535 & result)
  }
});
$c_jl_Character$.prototype.isISOControl__I__Z = (function(codePoint) {
  return (((codePoint >= 0) && (codePoint <= 31)) || ((codePoint >= 127) && (codePoint <= 159)))
});
$c_jl_Character$.prototype.isSpaceChar__I__Z = (function(codePoint) {
  var tpe = this.getType__I__I(codePoint);
  return (((tpe === 12) || (tpe === 13)) || (tpe === 14))
});
$c_jl_Character$.prototype.isLowerCase__I__Z = (function(c) {
  return ((c < 256) ? (((c === 170) || (c === 186)) || ($n(this.java$lang$Character$$charTypesFirst256__AI()).get(c) === 2)) : $p_jl_Character$__isLowerCaseGE256__I__Z(this, c))
});
$c_jl_Character$.prototype.isDigit__I__Z = (function(cp) {
  if ((cp < 256)) {
    return ((cp >= 48) && (cp <= 57))
  } else {
    var tpe = $p_jl_Character$__getTypeGE256__I__I(this, cp);
    return (tpe === 9)
  }
});
$c_jl_Character$.prototype.isLetter__I__Z = (function(cp) {
  var tpe = this.getType__I__I(cp);
  return (((((tpe === 1) || (tpe === 2)) || (tpe === 3)) || (tpe === 4)) || (tpe === 5))
});
$c_jl_Character$.prototype.toUpperCase__C__C = (function(ch) {
  return (65535 & this.toUpperCase__I__I(ch))
});
$c_jl_Character$.prototype.toUpperCase__I__I = (function(codePoint) {
  switch (codePoint) {
    case 8115:
    case 8131:
    case 8179: {
      return ((9 + codePoint) | 0);
      break
    }
    default: {
      if (((codePoint >= 8064) && (codePoint <= 8111))) {
        return (8 | codePoint)
      } else {
        var this$1 = $n(this.toString__I__T(codePoint));
        var upperChars = $as_T(this$1.toUpperCase());
        var this$2 = $n(upperChars);
        var x1$2 = this$2.length;
        switch (x1$2) {
          case 1: {
            var this$3 = $n(upperChars);
            return $charAt(this$3, 0);
            break
          }
          case 2: {
            var this$4 = $n(upperChars);
            var high = $charAt(this$4, 0);
            var this$5 = $n(upperChars);
            var low = $charAt(this$5, 1);
            return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
            break
          }
          default: {
            return codePoint
          }
        }
      }
    }
  }
});
$c_jl_Character$.prototype.toLowerCase__C__C = (function(ch) {
  return (65535 & this.toLowerCase__I__I(ch))
});
$c_jl_Character$.prototype.toLowerCase__I__I = (function(codePoint) {
  if ((codePoint === 304)) {
    return 105
  } else {
    var this$1 = $n(this.toString__I__T(codePoint));
    var lowerChars = $as_T(this$1.toLowerCase());
    var this$2 = $n(lowerChars);
    var x1$2 = this$2.length;
    switch (x1$2) {
      case 1: {
        var this$3 = $n(lowerChars);
        return $charAt(this$3, 0);
        break
      }
      case 2: {
        var this$4 = $n(lowerChars);
        var high = $charAt(this$4, 0);
        var this$5 = $n(lowerChars);
        var low = $charAt(this$5, 1);
        return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
        break
      }
      default: {
        return codePoint
      }
    }
  }
});
$c_jl_Character$.prototype.java$lang$Character$$charTypesFirst256__AI = (function() {
  return (((((1 & this.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI(this) : this.jl_Character$__f_java$lang$Character$$charTypesFirst256)
});
var $d_jl_Character$ = new $TypeData().initClass({
  jl_Character$: 0
}, false, "java.lang.Character$", {
  jl_Character$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Character$.prototype.$classData = $d_jl_Character$;
var $n_jl_Character$;
function $m_jl_Character$() {
  if ((!$n_jl_Character$)) {
    $n_jl_Character$ = new $c_jl_Character$()
  };
  return $n_jl_Character$
}
function $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrPat = new RegExp("^[\\x00-\\x20]*([+-]?(?:NaN|Infinity|(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((1 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Double$__f_doubleStrPat
}
function $p_jl_Double$__doubleStrPat__O($thiz) {
  return (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrPat)
}
function $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrHexPat = new RegExp("^[\\x00-\\x20]*([+-]?)0[xX]([0-9A-Fa-f]*)\\.?([0-9A-Fa-f]*)[pP]([+-]?\\d+)[fFdD]?[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((2 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Double$__f_doubleStrHexPat
}
function $p_jl_Double$__doubleStrHexPat__O($thiz) {
  return (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrHexPat)
}
function $p_jl_Double$__parseDoubleSlowPath__T__D($thiz, s) {
  var groups = $p_jl_Double$__doubleStrHexPat__O($thiz).exec(s);
  if ((groups === null)) {
    $p_jl_Double$__fail$1__T__E($thiz, s)
  };
  var x = groups[1];
  var signStr = $as_T(x);
  var x$1 = groups[2];
  var integralPartStr = $as_T(x$1);
  var x$2 = groups[3];
  var fractionalPartStr = $as_T(x$2);
  var x$3 = groups[4];
  var binaryExpStr = $as_T(x$3);
  if (((integralPartStr === "") && (fractionalPartStr === ""))) {
    $p_jl_Double$__fail$1__T__E($thiz, s)
  };
  var absResult = $thiz.parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 15);
  return ((signStr === "-") ? (-absResult) : absResult)
}
function $p_jl_Double$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""))
}
/** @constructor */
function $c_jl_Double$() {
  this.jl_Double$__f_doubleStrPat = null;
  this.jl_Double$__f_doubleStrHexPat = null;
  this.jl_Double$__f_bitmap$0 = 0
}
$c_jl_Double$.prototype = new $h_O();
$c_jl_Double$.prototype.constructor = $c_jl_Double$;
/** @constructor */
function $h_jl_Double$() {
  /*<skip>*/
}
$h_jl_Double$.prototype = $c_jl_Double$.prototype;
$c_jl_Double$.prototype.parseDouble__T__D = (function(s) {
  var groups = $p_jl_Double$__doubleStrPat__O(this).exec(s);
  if ((groups !== null)) {
    var $$x2 = parseFloat;
    var x = groups[1];
    var $$x1 = $$x2($as_T(x));
    return $uD($$x1)
  } else {
    return $p_jl_Double$__parseDoubleSlowPath__T__D(this, s)
  }
});
$c_jl_Double$.prototype.parseHexDoubleImpl__T__T__T__I__D = (function(integralPartStr, fractionalPartStr, binaryExpStr, maxPrecisionChars) {
  var mantissaStr0 = (("" + integralPartStr) + fractionalPartStr);
  var this$1 = $n(fractionalPartStr);
  var correction1 = ((-(this$1.length << 2)) | 0);
  var i = 0;
  while (true) {
    if ((i !== mantissaStr0.length)) {
      var index = i;
      var $$x1 = ($charAt(mantissaStr0, index) === 48)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      i = ((1 + i) | 0)
    } else {
      break
    }
  };
  var beginIndex = i;
  if (((beginIndex < 0) || (beginIndex > mantissaStr0.length))) {
    $charAt(mantissaStr0, beginIndex)
  };
  var mantissaStr = $as_T(mantissaStr0.substring(beginIndex));
  if ((mantissaStr === "")) {
    return 0.0
  };
  var this$2 = $n(mantissaStr);
  var mantissaStrLen = this$2.length;
  var needsCorrection2 = (mantissaStrLen > maxPrecisionChars);
  if (needsCorrection2) {
    var hasNonZeroChar = false;
    var j = maxPrecisionChars;
    while (((!hasNonZeroChar) && (j !== mantissaStrLen))) {
      var this$3 = $n(mantissaStr);
      var index$1 = j;
      if (($charAt(this$3, index$1) !== 48)) {
        hasNonZeroChar = true
      };
      j = ((1 + j) | 0)
    };
    var compressedTail = (hasNonZeroChar ? "1" : "0");
    var this$4 = $n(mantissaStr);
    if ((maxPrecisionChars > this$4.length)) {
      $charAt(this$4, maxPrecisionChars)
    };
    if ((maxPrecisionChars < 0)) {
      $charAt(this$4, (-1))
    };
    var truncatedMantissaStr = ($as_T(this$4.substring(0, maxPrecisionChars)) + compressedTail)
  } else {
    var truncatedMantissaStr = mantissaStr
  };
  if (needsCorrection2) {
    var this$5 = $n(mantissaStr);
    var correction2 = (((this$5.length - ((1 + maxPrecisionChars) | 0)) | 0) << 2)
  } else {
    var correction2 = 0
  };
  var fullCorrection = ((correction1 + correction2) | 0);
  var mantissa = $uD(parseInt(truncatedMantissaStr, 16));
  var binaryExpDouble = $uD(parseInt(binaryExpStr, 10));
  var binaryExp = $doubleToInt(binaryExpDouble);
  var binExpAndCorrection = ((binaryExp + fullCorrection) | 0);
  var binExpAndCorrection_div_3 = ((binExpAndCorrection / 3) | 0);
  var b = binExpAndCorrection_div_3;
  var correctingPow = $uD(Math.pow(2.0, b));
  var b$1 = ((binExpAndCorrection - (binExpAndCorrection_div_3 << 1)) | 0);
  var correctingPow3 = $uD(Math.pow(2.0, b$1));
  return (((mantissa * correctingPow) * correctingPow) * correctingPow3)
});
$c_jl_Double$.prototype.compare__D__D__I = (function(a, b) {
  if ((a !== a)) {
    return ((b !== b) ? 0 : 1)
  } else if ((b !== b)) {
    return (-1)
  } else if ((a === b)) {
    if ((a === 0.0)) {
      var ainf = (1.0 / a);
      return ((ainf === (1.0 / b)) ? 0 : ((ainf < 0.0) ? (-1) : 1))
    } else {
      return 0
    }
  } else {
    return ((a < b) ? (-1) : 1)
  }
});
var $d_jl_Double$ = new $TypeData().initClass({
  jl_Double$: 0
}, false, "java.lang.Double$", {
  jl_Double$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Double$.prototype.$classData = $d_jl_Double$;
var $n_jl_Double$;
function $m_jl_Double$() {
  if ((!$n_jl_Double$)) {
    $n_jl_Double$ = new $c_jl_Double$()
  };
  return $n_jl_Double$
}
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.jl_Float$__f_bitmap$0)) {
    $thiz.jl_Float$__f_parseFloatRegExp = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Float$__f_bitmap$0 = true
  };
  return $thiz.jl_Float$__f_parseFloatRegExp
}
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.jl_Float$__f_bitmap$0) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.jl_Float$__f_parseFloatRegExp)
}
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = $uD(parseFloat(fullNumberStr));
  var z = Math.fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z)
  } else if ((zDouble < z0)) {
    var zUp = $m_jl_Math$().nextUp__F__F(z);
    var mid$2 = ((zDouble + zUp) / 2.0);
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z)
  } else {
    var zDown = $m_jl_Math$().nextDown__F__F(z);
    var mid$3 = ((zDouble + zDown) / 2.0);
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z)
  }
}
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var f = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), (("" + integralPartStr) + fractionalPartStr));
  var this$1 = $m_jl_Integer$();
  var $$x1 = this$1.parseInt__T__I__I(exponentStr, 10);
  var this$2 = $n(fractionalPartStr);
  var e = (($$x1 - this$2.length) | 0);
  var t = $m_jl_FloatingPointBits$().doubleToLongBits__D__J(mid);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw new $c_jl_AssertionError(("parseFloatCorrection was given a subnormal mid: " + mid))
  };
  var hi$2 = (1048575 & hi);
  var $$x2 = $m_Ljava_math_BigInteger$();
  var hi$3 = (1048576 | hi$2);
  var m = $n($$x2).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$3));
  var k = (((-1075) + lo$1) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e));
      var y = $n(m).shiftLeft__I__Ljava_math_BigInteger(k);
      var cmp = $n(x).compareTo__Ljava_math_BigInteger__I(y)
    } else {
      var v = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e));
      var e$1 = ((-k) | 0);
      var x$1 = $n(v).shiftLeft__I__Ljava_math_BigInteger(e$1);
      var cmp = $n(x$1).compareTo__Ljava_math_BigInteger__I(m)
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var v$1 = $n(m).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e$2));
    var y$1 = $n(v$1).shiftLeft__I__Ljava_math_BigInteger(k);
    var cmp = f.compareTo__Ljava_math_BigInteger__I(y$1)
  } else {
    var e$3 = ((-k) | 0);
    var x$2 = f.shiftLeft__I__Ljava_math_BigInteger(e$3);
    var e$4 = ((-e) | 0);
    var y$2 = $n(m).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e$4));
    var cmp = $n(x$2).compareTo__Ljava_math_BigInteger__I(y$2)
  };
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $m_jl_FloatingPointBits$().floatToIntBits__F__I(zDown)) === 0) ? zDown : zUp)))
}
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  var doubleValue = $m_jl_Double$().parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 7);
  return Math.fround(doubleValue)
}
/** @constructor */
function $c_jl_Float$() {
  this.jl_Float$__f_parseFloatRegExp = null;
  this.jl_Float$__f_bitmap$0 = false
}
$c_jl_Float$.prototype = new $h_O();
$c_jl_Float$.prototype.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
  /*<skip>*/
}
$h_jl_Float$.prototype = $c_jl_Float$.prototype;
$c_jl_Float$.prototype.parseFloat__T__F = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
  };
  var x = groups[2];
  if ((x !== (void 0))) {
    var absResult = (NaN)
  } else {
    var x$1 = groups[3];
    if ((x$1 !== (void 0))) {
      var absResult = Infinity
    } else {
      var x$2 = groups[4];
      if ((x$2 !== (void 0))) {
        var x$3 = groups[4];
        var fullNumberStr = $as_T(x$3);
        var x$4 = groups[5];
        var integralPartStr = $as_T(((x$4 !== (void 0)) ? x$4 : ""));
        var x$5 = groups[6];
        var $$x1 = $as_T(((x$5 !== (void 0)) ? x$5 : ""));
        var x$6 = groups[7];
        var fractionalPartStr = (("" + $$x1) + ((x$6 !== (void 0)) ? x$6 : ""));
        var x$7 = groups[8];
        var exponentStr = $as_T(((x$7 !== (void 0)) ? x$7 : "0"));
        var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr)
      } else {
        var x$8 = groups[10];
        var integralPartStr$2 = $as_T(((x$8 !== (void 0)) ? x$8 : ""));
        var x$9 = groups[11];
        var $$x2 = $as_T(((x$9 !== (void 0)) ? x$9 : ""));
        var x$10 = groups[12];
        var fractionalPartStr$2 = (("" + $$x2) + ((x$10 !== (void 0)) ? x$10 : ""));
        var x$11 = groups[13];
        var binaryExpStr = $as_T(x$11);
        var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, integralPartStr$2, fractionalPartStr$2, binaryExpStr)
      }
    }
  };
  var x$12 = groups[1];
  var signStr = $as_T(x$12);
  return ((signStr === "-") ? Math.fround((-absResult)) : absResult)
});
var $d_jl_Float$ = new $TypeData().initClass({
  jl_Float$: 0
}, false, "java.lang.Float$", {
  jl_Float$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Float$.prototype.$classData = $d_jl_Float$;
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$()
  };
  return $n_jl_Float$
}
function $p_jl_Integer$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""))
}
/** @constructor */
function $c_jl_Integer$() {
  /*<skip>*/
}
$c_jl_Integer$.prototype = new $h_O();
$c_jl_Integer$.prototype.constructor = $c_jl_Integer$;
/** @constructor */
function $h_jl_Integer$() {
  /*<skip>*/
}
$h_jl_Integer$.prototype = $c_jl_Integer$.prototype;
$c_jl_Integer$.prototype.parseInt__T__I__I = (function(s, radix) {
  if ((s === null)) {
    var len = 0
  } else {
    var this$1 = $n(s);
    var len = this$1.length
  };
  if ((((len === 0) || (radix < 2)) || (radix > 36))) {
    $p_jl_Integer$__fail$1__T__E(this, s)
  };
  var this$2 = $n(s);
  var firstChar = $charAt(this$2, 0);
  var negative = (firstChar === 45);
  var maxAbsValue = (negative ? 2.147483648E9 : 2.147483647E9);
  var i = ((negative || (firstChar === 43)) ? 1 : 0);
  var $$x1 = i;
  var this$3 = $n(s);
  if (($$x1 >= this$3.length)) {
    $p_jl_Integer$__fail$1__T__E(this, s)
  };
  var result = 0.0;
  while ((i !== len)) {
    var $$x2 = $m_jl_Character$();
    var this$4 = $n(s);
    var index = i;
    var digit = $n($$x2).digitWithValidRadix__I__I__I($charAt(this$4, index), radix);
    result = ((result * radix) + digit);
    if (((digit === (-1)) || (result > maxAbsValue))) {
      $p_jl_Integer$__fail$1__T__E(this, s)
    };
    i = ((1 + i) | 0)
  };
  if (negative) {
    var n = (-result);
    return $uI((n | 0.0))
  } else {
    var n$1 = result;
    return $uI((n$1 | 0.0))
  }
});
$c_jl_Integer$.prototype.bitCount__I__I = (function(i) {
  var t1 = ((i - (1431655765 & (i >> 1))) | 0);
  var t2 = (((858993459 & t1) + (858993459 & (t1 >> 2))) | 0);
  return (Math.imul(16843009, (252645135 & ((t2 + (t2 >> 4)) | 0))) >> 24)
});
var $d_jl_Integer$ = new $TypeData().initClass({
  jl_Integer$: 0
}, false, "java.lang.Integer$", {
  jl_Integer$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Integer$.prototype.$classData = $d_jl_Integer$;
var $n_jl_Integer$;
function $m_jl_Integer$() {
  if ((!$n_jl_Integer$)) {
    $n_jl_Integer$ = new $c_jl_Integer$()
  };
  return $n_jl_Integer$
}
function $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) {
  if ((!$thiz.jl_Long$__f_bitmap$0)) {
    var r = [];
    var radix = 0;
    while ((radix < 2)) {
      r.push(null);
      radix = ((1 + radix) | 0)
    };
    while ((radix <= 36)) {
      var barrier = $intDiv(2147483647, radix);
      var radixPowLength = radix;
      var chunkLength = 1;
      var paddingZeros = "0";
      while ((radixPowLength <= barrier)) {
        radixPowLength = Math.imul(radixPowLength, radix);
        chunkLength = ((1 + chunkLength) | 0);
        paddingZeros = (paddingZeros + "0")
      };
      var value = radixPowLength;
      var hi = (value >> 31);
      var this$2 = $m_RTLong$();
      var lo = this$2.divideUnsignedImpl__I__I__I__I__I((-1), (-1), value, hi);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      r.push(new $c_jl_Long$StringRadixInfo(chunkLength, new $c_RTLong(value, hi), paddingZeros, new $c_RTLong(lo, hi$1)));
      radix = ((1 + radix) | 0)
    };
    $thiz.jl_Long$__f_StringRadixInfos = r;
    $thiz.jl_Long$__f_bitmap$0 = true
  };
  return $thiz.jl_Long$__f_StringRadixInfos
}
function $p_jl_Long$__StringRadixInfos__O($thiz) {
  return ((!$thiz.jl_Long$__f_bitmap$0) ? $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) : $thiz.jl_Long$__f_StringRadixInfos)
}
function $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T($thiz, i, radix) {
  var radixInfo = $as_jl_Long$StringRadixInfo($p_jl_Long$__StringRadixInfos__O($thiz)[radix]);
  var t = $n(radixInfo).jl_Long$StringRadixInfo__f_radixPowLength;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var paddingZeros = $n(radixInfo).jl_Long$StringRadixInfo__f_paddingZeros;
  var hi$1 = ((-2147483648) ^ hi);
  var res = "";
  var lo$1 = i.RTLong__f_lo;
  var hi$2 = i.RTLong__f_hi;
  var value__lo = lo$1;
  var value__hi = hi$2;
  while (true) {
    var b__lo = value__lo;
    var b__hi = value__hi;
    var lo$2 = b__lo;
    var hi$3 = ((-2147483648) ^ b__hi);
    if (((hi$3 === hi$1) ? (((-2147483648) ^ lo$2) >= ((-2147483648) ^ lo)) : (hi$3 > hi$1))) {
      var this$1__lo = value__lo;
      var this$1__hi = value__hi;
      var this$2 = $m_RTLong$();
      var lo$3 = this$2.divideUnsignedImpl__I__I__I__I__I(this$1__lo, this$1__hi, lo, hi);
      var hi$4 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var this$3__lo = value__lo;
      var this$3__hi = value__hi;
      var a0 = (65535 & lo$3);
      var a1 = ((lo$3 >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$5 = ((((((((Math.imul(lo$3, hi) + Math.imul(hi$4, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var alo = this$3__lo;
      var ahi = this$3__hi;
      var lo$5 = ((alo - lo$4) | 0);
      var remStr = $as_T(lo$5.toString(radix));
      var this$5 = $n(remStr);
      var $$x1 = paddingZeros.substring(this$5.length);
      res = ((("" + $as_T($$x1)) + remStr) + res);
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$4;
      value__lo = $$x2__lo;
      value__hi = $$x2__hi
    } else {
      break
    }
  };
  var this$6__lo = value__lo;
  var this$6__hi = value__hi;
  var $$x3 = this$6__lo.toString(radix);
  return (("" + $as_T($$x3)) + res)
}
function $p_jl_Long$__parseLongError__T__E($thiz, s) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
}
function $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I($thiz, chunkStart, chunkEnd, s$1, radix$1) {
  var result = 0;
  var i = chunkStart;
  while ((i !== chunkEnd)) {
    var $$x1 = $m_jl_Character$();
    var this$1 = $n(s$1);
    var index = i;
    var digit = $n($$x1).digitWithValidRadix__I__I__I($charAt(this$1, index), radix$1);
    if ((digit === (-1))) {
      $p_jl_Long$__parseLongError__T__E($thiz, s$1)
    };
    result = ((Math.imul(result, radix$1) + digit) | 0);
    i = ((1 + i) | 0)
  };
  return result
}
/** @constructor */
function $c_jl_Long$() {
  this.jl_Long$__f_StringRadixInfos = null;
  this.jl_Long$__f_bitmap$0 = false
}
$c_jl_Long$.prototype = new $h_O();
$c_jl_Long$.prototype.constructor = $c_jl_Long$;
/** @constructor */
function $h_jl_Long$() {
  /*<skip>*/
}
$h_jl_Long$.prototype = $c_jl_Long$.prototype;
$c_jl_Long$.prototype.java$lang$Long$$toStringImpl__J__I__T = (function(i, radix) {
  var lo = i.RTLong__f_lo;
  var hi = i.RTLong__f_hi;
  if (((lo >> 31) === hi)) {
    return $as_T(lo.toString(radix))
  } else if ((hi < 0)) {
    var lo$1 = i.RTLong__f_lo;
    var hi$1 = i.RTLong__f_hi;
    var lo$2 = ((-lo$1) | 0);
    var hi$2 = ((lo$1 !== 0) ? (~hi$1) : ((-hi$1) | 0));
    return ("-" + $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T(this, new $c_RTLong(lo$2, hi$2), radix))
  } else {
    return $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T(this, i, radix)
  }
});
$c_jl_Long$.prototype.parseLong__T__I__J = (function(s, radix) {
  if ((s === "")) {
    $p_jl_Long$__parseLongError__T__E(this, s)
  };
  var start = 0;
  var neg = false;
  var this$1 = $n(s);
  var x1 = $charAt(this$1, 0);
  switch (x1) {
    case 43: {
      start = 1;
      break
    }
    case 45: {
      start = 1;
      neg = true;
      break
    }
  };
  var t = this.parseUnsignedLongInternal__T__I__I__J(s, radix, start);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (neg) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    if (((hi$1 === 0) ? (lo$1 !== 0) : (hi$1 > 0))) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    return new $c_RTLong(lo$1, hi$1)
  } else {
    if ((hi < 0)) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    return new $c_RTLong(lo, hi)
  }
});
$c_jl_Long$.prototype.parseUnsignedLongInternal__T__I__I__J = (function(s, radix, start) {
  var this$1 = $n(s);
  var length = this$1.length;
  if ((((start >= length) || (radix < 2)) || (radix > 36))) {
    $p_jl_Long$__parseLongError__T__E(this, s)
  } else {
    var radixInfo = $as_jl_Long$StringRadixInfo($p_jl_Long$__StringRadixInfos__O(this)[radix]);
    var chunkLen = $n(radixInfo).jl_Long$StringRadixInfo__f_chunkLength;
    var firstChunkStart = start;
    while (true) {
      if ((firstChunkStart < length)) {
        var $$x2 = $m_jl_Character$();
        var this$2 = $n(s);
        var index = firstChunkStart;
        var $$x1 = $n($$x2).isZeroDigit__C__Z($charAt(this$2, index))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        firstChunkStart = ((1 + firstChunkStart) | 0)
      } else {
        break
      }
    };
    if ((((length - firstChunkStart) | 0) > Math.imul(3, chunkLen))) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    var firstChunkLength = ((1 + $intMod((((-1) + ((length - firstChunkStart) | 0)) | 0), chunkLen)) | 0);
    var firstChunkEnd = ((firstChunkStart + firstChunkLength) | 0);
    var chunkStart = firstChunkStart;
    var x = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, chunkStart, firstChunkEnd, s, radix);
    if ((firstChunkEnd === length)) {
      return new $c_RTLong(x, 0)
    } else {
      var t = $n(radixInfo).jl_Long$StringRadixInfo__f_radixPowLength;
      var lo = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      var secondChunkEnd = ((firstChunkEnd + chunkLen) | 0);
      var a0 = (65535 & x);
      var a1 = ((x >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((Math.imul(x, hi$1) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var x$1 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, firstChunkEnd, secondChunkEnd, s, radix);
      var lo$2 = ((lo$1 + x$1) | 0);
      var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$2) | 0) : hi$2);
      if ((secondChunkEnd === length)) {
        return new $c_RTLong(lo$2, hi$4)
      } else {
        var t$1 = $n(radixInfo).jl_Long$StringRadixInfo__f_overflowBarrier;
        var lo$3 = t$1.RTLong__f_lo;
        var hi$5 = t$1.RTLong__f_hi;
        var x$2 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, secondChunkEnd, length, s, radix);
        if (((hi$4 === hi$5) ? (((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$3)) : (hi$4 > hi$5))) {
          $p_jl_Long$__parseLongError__T__E(this, s)
        };
        var a0$1 = (65535 & lo$2);
        var a1$1 = ((lo$2 >>> 16) | 0);
        var b0$1 = (65535 & lo);
        var b1$1 = ((lo >>> 16) | 0);
        var a0b0$1 = Math.imul(a0$1, b0$1);
        var a1b0$1 = Math.imul(a1$1, b0$1);
        var a0b1$1 = Math.imul(a0$1, b1$1);
        var lo$4 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$7 = ((((((((Math.imul(lo$2, hi$1) + Math.imul(hi$4, lo)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$5 = ((lo$4 + x$2) | 0);
        var hi$8 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$7) | 0) : hi$7);
        var hi$9 = ((-2147483648) ^ hi$8);
        if (((hi$9 === (-2147483648)) && (((-2147483648) ^ lo$5) < ((-2147483648) ^ x$2)))) {
          $p_jl_Long$__parseLongError__T__E(this, s)
        };
        return new $c_RTLong(lo$5, hi$8)
      }
    }
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toHexString__I__I__T = (function(lo, hi) {
  if ((hi !== 0)) {
    var $$x1 = $as_T($uD((hi >>> 0.0)).toString(16));
    var s = $as_T($uD((lo >>> 0.0)).toString(16));
    var this$3 = $n(s);
    var beginIndex = this$3.length;
    if (((beginIndex < 0) || (beginIndex > 8))) {
      $charAt("00000000", beginIndex)
    };
    return ($$x1 + (("" + $as_T("00000000".substring(beginIndex))) + s))
  } else {
    return $as_T($uD((lo >>> 0.0)).toString(16))
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toOctalString__I__I__T = (function(lo, hi) {
  var lp = (1073741823 & lo);
  var mp = (1073741823 & ((((lo >>> 30) | 0) + (hi << 2)) | 0));
  var hp = ((hi >>> 28) | 0);
  if ((hp !== 0)) {
    var $$x2 = $as_T($uD((hp >>> 0.0)).toString(8));
    var s = $as_T($uD((mp >>> 0.0)).toString(8));
    var this$3 = $n(s);
    var beginIndex = this$3.length;
    if (((beginIndex < 0) || (beginIndex > 10))) {
      $charAt("0000000000", beginIndex)
    };
    var $$x1 = $as_T("0000000000".substring(beginIndex));
    var s$1 = $as_T($uD((lp >>> 0.0)).toString(8));
    var this$5 = $n(s$1);
    var beginIndex$1 = this$5.length;
    if (((beginIndex$1 < 0) || (beginIndex$1 > 10))) {
      $charAt("0000000000", beginIndex$1)
    };
    return (($$x2 + (("" + $$x1) + s)) + (("" + $as_T("0000000000".substring(beginIndex$1))) + s$1))
  } else if ((mp !== 0)) {
    var $$x3 = $as_T($uD((mp >>> 0.0)).toString(8));
    var s$2 = $as_T($uD((lp >>> 0.0)).toString(8));
    var this$8 = $n(s$2);
    var beginIndex$2 = this$8.length;
    if (((beginIndex$2 < 0) || (beginIndex$2 > 10))) {
      $charAt("0000000000", beginIndex$2)
    };
    return ($$x3 + (("" + $as_T("0000000000".substring(beginIndex$2))) + s$2))
  } else {
    return $as_T($uD((lp >>> 0.0)).toString(8))
  }
});
var $d_jl_Long$ = new $TypeData().initClass({
  jl_Long$: 0
}, false, "java.lang.Long$", {
  jl_Long$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Long$.prototype.$classData = $d_jl_Long$;
var $n_jl_Long$;
function $m_jl_Long$() {
  if ((!$n_jl_Long$)) {
    $n_jl_Long$ = new $c_jl_Long$()
  };
  return $n_jl_Long$
}
/** @constructor */
function $c_jl_Number() {
  /*<skip>*/
}
$c_jl_Number.prototype = new $h_O();
$c_jl_Number.prototype.constructor = $c_jl_Number;
/** @constructor */
function $h_jl_Number() {
  /*<skip>*/
}
$h_jl_Number.prototype = $c_jl_Number.prototype;
function $is_jl_Number(obj) {
  return (((obj instanceof $c_jl_Number) || ((typeof obj) === "number")) || (obj instanceof $c_RTLong))
}
function $as_jl_Number(obj) {
  return (($is_jl_Number(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Number"))
}
function $isArrayOf_jl_Number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Number)))
}
function $asArrayOf_jl_Number(obj, depth) {
  return (($isArrayOf_jl_Number(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Number;", depth))
}
/** @constructor */
function $c_jl_Short$() {
  /*<skip>*/
}
$c_jl_Short$.prototype = new $h_O();
$c_jl_Short$.prototype.constructor = $c_jl_Short$;
/** @constructor */
function $h_jl_Short$() {
  /*<skip>*/
}
$h_jl_Short$.prototype = $c_jl_Short$.prototype;
$c_jl_Short$.prototype.parseShort__T__I__S = (function(s, radix) {
  var r = $m_jl_Integer$().parseInt__T__I__I(s, radix);
  if (((r < (-32768)) || (r > 32767))) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
  } else {
    return ((r << 16) >> 16)
  }
});
var $d_jl_Short$ = new $TypeData().initClass({
  jl_Short$: 0
}, false, "java.lang.Short$", {
  jl_Short$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Short$.prototype.$classData = $d_jl_Short$;
var $n_jl_Short$;
function $m_jl_Short$() {
  if ((!$n_jl_Short$)) {
    $n_jl_Short$ = new $c_jl_Short$()
  };
  return $n_jl_Short$
}
/** @constructor */
function $c_jl_StackTraceElement(declaringClass, methodName, fileName, lineNumber, columnNumber) {
  this.jl_StackTraceElement__f_declaringClass = null;
  this.jl_StackTraceElement__f_methodName = null;
  this.jl_StackTraceElement__f_fileName = null;
  this.jl_StackTraceElement__f_lineNumber = 0;
  this.jl_StackTraceElement__f_columnNumber = 0;
  this.jl_StackTraceElement__f_declaringClass = declaringClass;
  this.jl_StackTraceElement__f_methodName = methodName;
  this.jl_StackTraceElement__f_fileName = fileName;
  this.jl_StackTraceElement__f_lineNumber = lineNumber;
  this.jl_StackTraceElement__f_columnNumber = columnNumber
}
$c_jl_StackTraceElement.prototype = new $h_O();
$c_jl_StackTraceElement.prototype.constructor = $c_jl_StackTraceElement;
/** @constructor */
function $h_jl_StackTraceElement() {
  /*<skip>*/
}
$h_jl_StackTraceElement.prototype = $c_jl_StackTraceElement.prototype;
$c_jl_StackTraceElement.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_jl_StackTraceElement)) {
    var x2 = $as_jl_StackTraceElement(that);
    return (((((this.jl_StackTraceElement__f_fileName === $n(x2).jl_StackTraceElement__f_fileName) && (this.jl_StackTraceElement__f_lineNumber === $n(x2).jl_StackTraceElement__f_lineNumber)) && (this.jl_StackTraceElement__f_columnNumber === $n(x2).jl_StackTraceElement__f_columnNumber)) && (this.jl_StackTraceElement__f_declaringClass === $n(x2).jl_StackTraceElement__f_declaringClass)) && (this.jl_StackTraceElement__f_methodName === $n(x2).jl_StackTraceElement__f_methodName))
  } else {
    return false
  }
});
$c_jl_StackTraceElement.prototype.toString__T = (function() {
  var result = "";
  if ((this.jl_StackTraceElement__f_declaringClass !== "<jscode>")) {
    result = ((("" + result) + this.jl_StackTraceElement__f_declaringClass) + ".")
  };
  result = (("" + result) + this.jl_StackTraceElement__f_methodName);
  if ((this.jl_StackTraceElement__f_fileName === null)) {
    result = (result + "(Unknown Source)")
  } else {
    result = ((result + "(") + this.jl_StackTraceElement__f_fileName);
    if ((this.jl_StackTraceElement__f_lineNumber >= 0)) {
      result = ((result + ":") + this.jl_StackTraceElement__f_lineNumber);
      if ((this.jl_StackTraceElement__f_columnNumber >= 0)) {
        result = ((result + ":") + this.jl_StackTraceElement__f_columnNumber)
      }
    };
    result = (result + ")")
  };
  return result
});
$c_jl_StackTraceElement.prototype.hashCode__I = (function() {
  return (((($f_T__hashCode__I($n(this.jl_StackTraceElement__f_declaringClass)) ^ $f_T__hashCode__I($n(this.jl_StackTraceElement__f_methodName))) ^ $f_T__hashCode__I($n(this.jl_StackTraceElement__f_fileName))) ^ this.jl_StackTraceElement__f_lineNumber) ^ this.jl_StackTraceElement__f_columnNumber)
});
function $as_jl_StackTraceElement(obj) {
  return (((obj instanceof $c_jl_StackTraceElement) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.StackTraceElement"))
}
function $isArrayOf_jl_StackTraceElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StackTraceElement)))
}
function $asArrayOf_jl_StackTraceElement(obj, depth) {
  return (($isArrayOf_jl_StackTraceElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.StackTraceElement;", depth))
}
var $d_jl_StackTraceElement = new $TypeData().initClass({
  jl_StackTraceElement: 0
}, false, "java.lang.StackTraceElement", {
  jl_StackTraceElement: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StackTraceElement.prototype.$classData = $d_jl_StackTraceElement;
/** @constructor */
function $c_jl_String$() {
  /*<skip>*/
}
$c_jl_String$.prototype = new $h_O();
$c_jl_String$.prototype.constructor = $c_jl_String$;
/** @constructor */
function $h_jl_String$() {
  /*<skip>*/
}
$h_jl_String$.prototype = $c_jl_String$.prototype;
$c_jl_String$.prototype.new__AC__I__I__T = (function(value, offset, count) {
  var end = ((offset + count) | 0);
  if ((((offset < 0) || (end < offset)) || (end > $n(value).u.length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException())
  };
  var result = "";
  var i = offset;
  while ((i !== end)) {
    var $$x1 = result;
    var this$1 = $n(value).get(i);
    result = (("" + $$x1) + $as_T(String.fromCharCode(this$1)));
    i = ((1 + i) | 0)
  };
  return result
});
$c_jl_String$.prototype.format__T__AO__T = (function(format, args) {
  return $n($ct_ju_Formatter__(new $c_ju_Formatter()).format__T__AO__ju_Formatter(format, args)).toString__T()
});
var $d_jl_String$ = new $TypeData().initClass({
  jl_String$: 0
}, false, "java.lang.String$", {
  jl_String$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_String$.prototype.$classData = $d_jl_String$;
var $n_jl_String$;
function $m_jl_String$() {
  if ((!$n_jl_String$)) {
    $n_jl_String$ = new $c_jl_String$()
  };
  return $n_jl_String$
}
/** @constructor */
function $c_jl_Thread(dummy) {
  /*<skip>*/
}
$c_jl_Thread.prototype = new $h_O();
$c_jl_Thread.prototype.constructor = $c_jl_Thread;
/** @constructor */
function $h_jl_Thread() {
  /*<skip>*/
}
$h_jl_Thread.prototype = $c_jl_Thread.prototype;
$c_jl_Thread.prototype.run__V = (function() {
  /*<skip>*/
});
var $d_jl_Thread = new $TypeData().initClass({
  jl_Thread: 0
}, false, "java.lang.Thread", {
  jl_Thread: 1,
  O: 1,
  jl_Runnable: 1
});
$c_jl_Thread.prototype.$classData = $d_jl_Thread;
function $p_jl_Throwable__printStackTraceImpl__O__V($thiz, sprintln) {
  $thiz.getStackTrace__Ajl_StackTraceElement();
  sprintln($thiz.toString__T());
  if (($n($thiz.jl_Throwable__f_stackTrace).u.length !== 0)) {
    var i = 0;
    while ((i < $n($thiz.jl_Throwable__f_stackTrace).u.length)) {
      sprintln(("  at " + $n($thiz.jl_Throwable__f_stackTrace).get(i)));
      i = ((1 + i) | 0)
    }
  } else {
    sprintln("  <no stack trace available>")
  };
  var wCause = $thiz;
  while (true) {
    var $$x3 = wCause;
    var this$1 = $n(wCause);
    if (($$x3 !== this$1.jl_Throwable__f_e)) {
      var this$2 = $n(wCause);
      var $$x2 = (this$2.jl_Throwable__f_e !== null)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var parentTrace = $n(wCause).getStackTrace__Ajl_StackTraceElement();
      var this$3 = $n(wCause);
      wCause = this$3.jl_Throwable__f_e;
      var thisTrace = $n(wCause).getStackTrace__Ajl_StackTraceElement();
      var thisLength = $n(thisTrace).u.length;
      var parentLength = $n(parentTrace).u.length;
      sprintln(("Caused by: " + wCause));
      if ((thisLength !== 0)) {
        var sameFrameCount = 0;
        while (true) {
          if (((sameFrameCount < thisLength) && (sameFrameCount < parentLength))) {
            var x = $n(thisTrace).get((((-1) + ((thisLength - sameFrameCount) | 0)) | 0));
            var x$2 = $n(parentTrace).get((((-1) + ((parentLength - sameFrameCount) | 0)) | 0));
            var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            sameFrameCount = ((1 + sameFrameCount) | 0)
          } else {
            break
          }
        };
        if ((sameFrameCount > 0)) {
          sameFrameCount = (((-1) + sameFrameCount) | 0)
        };
        var lengthToPrint = ((thisLength - sameFrameCount) | 0);
        var i$2 = 0;
        while ((i$2 < lengthToPrint)) {
          sprintln(("  at " + $n(thisTrace).get(i$2)));
          i$2 = ((1 + i$2) | 0)
        };
        if ((sameFrameCount > 0)) {
          sprintln((("  ... " + sameFrameCount) + " more"))
        }
      } else {
        sprintln("  <no stack trace available>")
      }
    } else {
      break
    }
  }
}
function $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, enableSuppression, writableStackTrace) {
  $thiz.jl_Throwable__f_s = s;
  $thiz.jl_Throwable__f_e = e;
  $thiz.jl_Throwable__f_writableStackTrace = writableStackTrace;
  if (writableStackTrace) {
    $thiz.fillInStackTrace__jl_Throwable()
  };
  return $thiz
}
class $c_jl_Throwable extends Error {
  constructor() {
    super();
    this.jl_Throwable__f_s = null;
    this.jl_Throwable__f_e = null;
    this.jl_Throwable__f_writableStackTrace = false;
    this.jl_Throwable__f_jsErrorForStackTrace = null;
    this.jl_Throwable__f_stackTrace = null
  };
  initCause__jl_Throwable__jl_Throwable(cause) {
    this.jl_Throwable__f_e = cause;
    return this
  };
  getMessage__T() {
    return this.jl_Throwable__f_s
  };
  fillInStackTrace__jl_Throwable() {
    var $$x1 = this;
    var reference = (($$x1 instanceof $c_sjs_js_JavaScriptException) ? $$x1.sjs_js_JavaScriptException__f_exception : $n($$x1));
    var identifyingString = Object.prototype.toString.call(reference);
    this.jl_Throwable__f_jsErrorForStackTrace = ((identifyingString === "[object Error]") ? reference : ((Error.captureStackTrace === (void 0)) ? new Error() : (Error.captureStackTrace(this), this)));
    return this
  };
  getStackTrace__Ajl_StackTraceElement() {
    if ((this.jl_Throwable__f_stackTrace === null)) {
      if (this.jl_Throwable__f_writableStackTrace) {
        this.jl_Throwable__f_stackTrace = $m_jl_StackTrace$().extract__O__Ajl_StackTraceElement(this.jl_Throwable__f_jsErrorForStackTrace)
      } else {
        this.jl_Throwable__f_stackTrace = new ($d_jl_StackTraceElement.getArrayOf().constr)(0)
      }
    };
    return this.jl_Throwable__f_stackTrace
  };
  printStackTrace__Ljava_io_PrintStream__V(s) {
    $p_jl_Throwable__printStackTraceImpl__O__V(this, ((x$1$2) => {
      var x$1 = $as_T(x$1$2);
      $n(s).println__T__V(x$1)
    }))
  };
  toString__T() {
    var className = $objectClassName(this);
    var message = this.getMessage__T();
    return ((message === null) ? className : ((className + ": ") + message))
  };
  hashCode__I() {
    return $c_O.prototype.hashCode__I.call(this)
  };
  equals__O__Z(that) {
    return $c_O.prototype.equals__O__Z.call(this, that)
  };
  get "message"() {
    var m = this.getMessage__T();
    return ((m === null) ? "" : m)
  };
  get "name"() {
    return $objectClassName(this)
  };
  "toString"() {
    return this.toString__T()
  };
}
function $as_jl_Throwable(obj) {
  return (((obj instanceof $c_jl_Throwable) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Throwable"))
}
function $isArrayOf_jl_Throwable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Throwable)))
}
function $asArrayOf_jl_Throwable(obj, depth) {
  return (($isArrayOf_jl_Throwable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Throwable;", depth))
}
function $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1) {
  return $n($thiz.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength).get(diffScale$1)
}
function $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1) {
  return (($n(augend$1).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1)) | 0)
}
function $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I($thiz, thisValue$1, augend$1, diffScale$1) {
  var a = $n(thisValue$1).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var b = $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1);
  return ((1 + ((a > b) ? a : b)) | 0)
}
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.Ljava_math_BigDecimal$__f_ZERO = null;
  this.Ljava_math_BigDecimal$__f_ONE = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = null;
  this.Ljava_math_BigDecimal$__f_LongTenPows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = null;
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = null;
  $n_Ljava_math_BigDecimal$ = this;
  this.Ljava_math_BigDecimal$__f_ZERO = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  this.Ljava_math_BigDecimal$__f_ONE = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = this.newArrayOfPows__I__I__AJ(28, 5);
  var len = $n(this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows).u.length;
  var result = new $ac_I(len);
  var i = 0;
  while ((i < len)) {
    var i$2 = i;
    $n(result).set(i$2, $m_Ljava_math_BigDecimal$().bitLength__J__I($n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows).get(i$2)));
    i = ((1 + i) | 0)
  };
  this.Ljava_math_BigDecimal$__f_LongTenPows = this.newArrayOfPows__I__I__AJ(19, 10);
  var len$2 = $n(this.Ljava_math_BigDecimal$__f_LongTenPows).u.length;
  var result$2 = new $ac_I(len$2);
  var i$1 = 0;
  while ((i$1 < len$2)) {
    var i$3$2 = i$1;
    $n(result$2).set(i$3$2, $m_Ljava_math_BigDecimal$().bitLength__J__I($n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(i$3$2)));
    i$1 = ((1 + i$1) | 0)
  };
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = result$2;
  var result$3 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var i$4$2 = i$3;
    $n(result$3).set(i$4$2, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), i$4$2, 0));
    i$3 = ((1 + i$3) | 0)
  };
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = result$3;
  var result$4 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$4 = 0;
  while ((i$4 < 11)) {
    var i$5$2 = i$4;
    $n(result$4).set(i$5$2, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, i$5$2));
    i$4 = ((1 + i$4) | 0)
  };
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = result$4;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
}
$c_Ljava_math_BigDecimal$.prototype = new $h_O();
$c_Ljava_math_BigDecimal$.prototype.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
  /*<skip>*/
}
$h_Ljava_math_BigDecimal$.prototype = $c_Ljava_math_BigDecimal$.prototype;
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__I__Ljava_math_BigDecimal = (function(unscaledVal, scale) {
  return ((scale === 0) ? this.valueOf__J__Ljava_math_BigDecimal(unscaledVal) : (((((unscaledVal.RTLong__f_lo === 0) && (unscaledVal.RTLong__f_hi === 0)) && (scale >= 0)) && (scale < $n(this.Ljava_math_BigDecimal$__f_ZeroScaledBy).u.length)) ? $n(this.Ljava_math_BigDecimal$__f_ZeroScaledBy).get(scale) : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, scale)))
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__Ljava_math_BigDecimal = (function(unscaledVal) {
  var ahi = unscaledVal.RTLong__f_hi;
  if ((ahi >= 0)) {
    var ahi$1 = unscaledVal.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ unscaledVal.RTLong__f_lo) < (-2147483637)) : (ahi$1 < 0))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $n(this.Ljava_math_BigDecimal$__f_BigIntScaledByZero).get(unscaledVal.RTLong__f_lo)
  } else {
    return $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, 0)
  }
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__D__Ljava_math_BigDecimal = (function(d) {
  if ((((d === Infinity) || (d === (-Infinity))) || (d !== d))) {
    throw new $c_jl_NumberFormatException(("Infinity or NaN: " + d))
  };
  return $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), ("" + d))
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal = (function(thisValue, augend, diffScale) {
  if (((diffScale < $n(this.Ljava_math_BigDecimal$__f_LongTenPows).u.length) && ($p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I(this, thisValue, augend, diffScale) < 64))) {
    var this$1 = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var b = $n(this.Ljava_math_BigDecimal$__f_LongTenPows).get(diffScale);
    var alo = this$1.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$1.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var this$2 = $n(thisValue).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var alo$1 = this$2.RTLong__f_lo;
    var ahi = this$2.RTLong__f_hi;
    var lo$1 = ((alo$1 + lo) | 0);
    var hi$1 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi + hi) | 0)) | 0) : ((ahi + hi) | 0));
    return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1), $n(thisValue).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  } else {
    var $$x2 = $m_Ljava_math_Multiplication$();
    var $$x1 = $n(augend).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var hi$2 = (diffScale >> 31);
    var bi = $n($$x2).multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x1, new $c_RTLong(diffScale, hi$2));
    var this$5 = $n($n(thisValue).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $$x3 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$5, bi);
    var this$6 = $n(thisValue);
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $$x3, this$6.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$divideBigIntegers__Ljava_math_BigInteger__Ljava_math_BigInteger__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(scaledDividend, scaledDivisor, scale, roundingMode) {
  var qr = $n(scaledDividend).divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(scaledDivisor);
  var this$1 = $n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_rem);
  if ((this$1.Ljava_math_BigInteger__f_sign === 0)) {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $n(qr).Ljava_math_BigInteger$QuotAndRem__f_quot, scale)
  } else {
    var this$2 = $n(scaledDividend);
    var $$x1 = this$2.Ljava_math_BigInteger__f_sign;
    var this$3 = $n(scaledDivisor);
    var sign = Math.imul($$x1, this$3.Ljava_math_BigInteger__f_sign);
    var parityBit = ($n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_quot).testBit__I__Z(0) ? 1 : 0);
    var this$4 = $n(scaledDivisor);
    if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$4) < 63)) {
      var t = $n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_rem).longValue__J();
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $n(scaledDivisor).longValue__J();
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      if ((hi < 0)) {
        var lo$2 = ((-lo) | 0);
        var hi$2 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
        var this$8__lo = lo$2;
        var this$8__hi = hi$2
      } else {
        var this$8__lo = lo;
        var this$8__hi = hi
      };
      var lo$3 = this$8__lo;
      var lo$4 = (lo$3 << 1);
      var hi$3 = (((lo$3 >>> 31) | 0) | (this$8__hi << 1));
      var $$x2 = new $c_RTLong(lo$4, hi$3);
      if ((hi$1 < 0)) {
        var lo$5 = ((-lo$1) | 0);
        var hi$4 = ((lo$1 !== 0) ? (~hi$1) : ((-hi$1) | 0));
        var x__lo = lo$5;
        var x__hi = hi$4
      } else {
        var x__lo = lo$1;
        var x__hi = hi$1
      };
      var compRem = this.java$math$BigDecimal$$longCompareTo__J__J__I($$x2, new $c_RTLong(x__lo, x__hi));
      var compRem$3 = this.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, Math.imul(sign, ((5 + compRem) | 0)), roundingMode)
    } else {
      var compRem$2 = $n($n($n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_rem).abs__Ljava_math_BigInteger()).shiftLeftOneBit__Ljava_math_BigInteger()).compareTo__Ljava_math_BigInteger__I($n(scaledDivisor).abs__Ljava_math_BigInteger());
      var compRem$3 = this.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, Math.imul(sign, ((5 + compRem$2) | 0)), roundingMode)
    };
    if ((compRem$3 !== 0)) {
      var this$12 = $n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_quot);
      if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$12) < 63)) {
        var this$14 = $n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_quot).longValue__J();
        var hi$5 = (compRem$3 >> 31);
        var alo = this$14.RTLong__f_lo;
        var ahi = this$14.RTLong__f_hi;
        var lo$6 = ((alo + compRem$3) | 0);
        var hi$6 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$5) | 0)) | 0) : ((ahi + hi$5) | 0));
        return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$6, hi$6), scale)
      } else {
        var this$17 = $n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_quot);
        var $$x3 = $m_Ljava_math_BigInteger$();
        var hi$7 = (compRem$3 >> 31);
        var bi = $n($$x3).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(compRem$3, hi$7));
        var quotient2 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$17, bi);
        return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), quotient2, scale)
      }
    } else {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $n(qr).Ljava_math_BigInteger$QuotAndRem__f_quot, scale)
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(scaledDividend, scaledDivisor, scale, roundingMode) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(scaledDividend.RTLong__f_lo, scaledDividend.RTLong__f_hi, scaledDivisor.RTLong__f_lo, scaledDivisor.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$1 = scaledDividend.RTLong__f_hi;
  var $$x1 = ((hi$1 < 0) ? (-1) : (((hi$1 === 0) && (scaledDividend.RTLong__f_lo === 0)) ? 0 : 1));
  var hi$2 = scaledDivisor.RTLong__f_hi;
  var sign = Math.imul($$x1, ((hi$2 < 0) ? (-1) : (((hi$2 === 0) && (scaledDivisor.RTLong__f_lo === 0)) ? 0 : 1)));
  var this$4 = $m_RTLong$();
  var lo$1 = this$4.divideImpl__I__I__I__I__I(scaledDividend.RTLong__f_lo, scaledDividend.RTLong__f_hi, scaledDivisor.RTLong__f_lo, scaledDivisor.RTLong__f_hi);
  var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((!((lo === 0) && (hi === 0)))) {
    if ((hi < 0)) {
      var lo$2 = ((-lo) | 0);
      var hi$4 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var this$8__lo = lo$2;
      var this$8__hi = hi$4
    } else {
      var this$8__lo = lo;
      var this$8__hi = hi
    };
    var lo$3 = this$8__lo;
    var lo$4 = (lo$3 << 1);
    var hi$5 = (((lo$3 >>> 31) | 0) | (this$8__hi << 1));
    var $$x3 = new $c_RTLong(lo$4, hi$5);
    var ahi = scaledDivisor.RTLong__f_hi;
    if ((ahi < 0)) {
      var lo$5 = scaledDivisor.RTLong__f_lo;
      var hi$6 = scaledDivisor.RTLong__f_hi;
      var lo$6 = ((-lo$5) | 0);
      var hi$7 = ((lo$5 !== 0) ? (~hi$6) : ((-hi$6) | 0));
      var x__lo = lo$6;
      var x__hi = hi$7;
      var $$x2 = new $c_RTLong(x__lo, x__hi)
    } else {
      var $$x2 = scaledDivisor
    };
    var compRem = this.java$math$BigDecimal$$longCompareTo__J__J__I($$x3, $$x2);
    var value = this.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & lo$1), Math.imul(sign, ((5 + compRem) | 0)), roundingMode);
    var hi$8 = (value >> 31);
    var lo$7 = ((lo$1 + value) | 0);
    var hi$9 = ((((-2147483648) ^ lo$7) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$3 + hi$8) | 0)) | 0) : ((hi$3 + hi$8) | 0));
    var quotient__lo = lo$7;
    var quotient__hi = hi$9
  } else {
    var quotient__lo = lo$1;
    var quotient__hi = hi$3
  };
  return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(quotient__lo, quotient__hi), scale)
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$longCompareTo__J__J__I = (function(value1, value2) {
  var ahi = value1.RTLong__f_hi;
  var bhi = value2.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ value1.RTLong__f_lo) > ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi > bhi))) {
    return 1
  } else {
    var ahi$1 = value1.RTLong__f_hi;
    var bhi$1 = value2.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ value1.RTLong__f_lo) < ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi$1 < bhi$1))) {
      return (-1)
    } else {
      return 0
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.newArrayOfPows__I__I__AJ = (function(len, pow) {
  var result = new $ac_J(len);
  $n(result).set(0, new $c_RTLong(1, 0));
  var i = 1;
  while ((i < len)) {
    var i$2 = i;
    var $$x1 = $n(result);
    var this$4 = $n(result).get((((-1) + i$2) | 0));
    var hi = (pow >> 31);
    var alo = this$4.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & pow);
    var b1 = ((pow >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(alo, hi) + Math.imul(this$4.RTLong__f_hi, pow)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    $$x1.set(i$2, new $c_RTLong(lo, hi$1));
    i = ((1 + i) | 0)
  };
  return result
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I = (function(parityBit, fraction, roundingMode) {
  var absFraction = ((fraction < 0) ? ((-fraction) | 0) : fraction);
  var sigFraction = ((fraction === 0) ? 0 : ((fraction < 0) ? (-1) : 1));
  var x = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UP;
  if ((x === null)) {
    var $$x1 = (roundingMode === null)
  } else {
    var this$3 = $n(x);
    var $$x1 = (this$3 === roundingMode)
  };
  if ($$x1) {
    return sigFraction
  } else {
    var x$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_DOWN;
    if ((x$3 === null)) {
      var $$x2 = (roundingMode === null)
    } else {
      var this$4 = $n(x$3);
      var $$x2 = (this$4 === roundingMode)
    };
    if ($$x2) {
      return 0
    } else {
      var x$5 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_CEILING;
      if ((x$5 === null)) {
        var $$x3 = (roundingMode === null)
      } else {
        var this$5 = $n(x$5);
        var $$x3 = (this$5 === roundingMode)
      };
      if ($$x3) {
        return ((sigFraction > 0) ? sigFraction : 0)
      } else {
        var x$7 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR;
        if ((x$7 === null)) {
          var $$x4 = (roundingMode === null)
        } else {
          var this$7 = $n(x$7);
          var $$x4 = (this$7 === roundingMode)
        };
        if ($$x4) {
          return ((sigFraction < 0) ? sigFraction : 0)
        } else {
          var x$9 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
          if ((x$9 === null)) {
            var $$x5 = (roundingMode === null)
          } else {
            var this$9 = $n(x$9);
            var $$x5 = (this$9 === roundingMode)
          };
          if ($$x5) {
            return ((absFraction >= 5) ? sigFraction : 0)
          } else {
            var x$11 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_DOWN;
            if ((x$11 === null)) {
              var $$x6 = (roundingMode === null)
            } else {
              var this$10 = $n(x$11);
              var $$x6 = (this$10 === roundingMode)
            };
            if ($$x6) {
              return ((absFraction > 5) ? sigFraction : 0)
            } else {
              var x$13 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
              if ((x$13 === null)) {
                var $$x7 = (roundingMode === null)
              } else {
                var this$11 = $n(x$13);
                var $$x7 = (this$11 === roundingMode)
              };
              if ($$x7) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0)
              } else {
                var x$15 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UNNECESSARY;
                if ((x$15 === null)) {
                  var $$x8 = (roundingMode === null)
                } else {
                  var this$12 = $n(x$15);
                  var $$x8 = (this$12 === roundingMode)
                };
                if ($$x8) {
                  if ((fraction === 0)) {
                    return 0
                  } else {
                    throw new $c_jl_ArithmeticException("Rounding necessary")
                  }
                } else {
                  throw new $c_jl_AssertionError(roundingMode)
                }
              }
            }
          }
        }
      }
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$safeLongToInt__J__I = (function(longValue) {
  var ahi = longValue.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ longValue.RTLong__f_lo) < 0) : (ahi < (-1)))) {
    var $$x1 = true
  } else {
    var ahi$1 = longValue.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ longValue.RTLong__f_lo) > (-1)) : (ahi$1 > 0))
  };
  if ($$x1) {
    throw new $c_jl_ArithmeticException(("Out of int range: " + longValue))
  };
  return longValue.RTLong__f_lo
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal = (function(longScale) {
  var value = longScale.RTLong__f_lo;
  var hi = (value >> 31);
  if (((longScale.RTLong__f_lo === value) && (longScale.RTLong__f_hi === hi))) {
    return this.valueOf__J__I__Ljava_math_BigDecimal($L0, longScale.RTLong__f_lo)
  } else {
    var ahi = longScale.RTLong__f_hi;
    if ((ahi >= 0)) {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647)
    } else {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648))
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.bitLength__J__I = (function(sValue) {
  var ahi = sValue.RTLong__f_hi;
  if ((ahi < 0)) {
    var lo = (~sValue.RTLong__f_lo);
    var hi = (~sValue.RTLong__f_hi);
    var x__lo = lo;
    var x__hi = hi;
    var t = new $c_RTLong(x__lo, x__hi)
  } else {
    var t = sValue
  };
  var lo$1 = t.RTLong__f_lo;
  var hi$1 = t.RTLong__f_hi;
  return ((64 - ((hi$1 !== 0) ? $uI(Math.clz32(hi$1)) : ((32 + $uI(Math.clz32(lo$1))) | 0))) | 0)
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$bitLength__I__I = (function(sValue) {
  var smallValue = ((sValue < 0) ? (~sValue) : sValue);
  return ((32 - $uI(Math.clz32(smallValue))) | 0)
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$charNotEqualTo__C__AC__Z = (function(c, cs) {
  return (!this.java$math$BigDecimal$$charEqualTo__C__AC__Z(c, cs))
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$charEqualTo__C__AC__Z = (function(c, cs) {
  var len = $n(cs).u.length;
  var i = 0;
  while ((i !== len)) {
    if (($n(cs).get(i) === c)) {
      return true
    };
    i = ((1 + i) | 0)
  };
  return false
});
var $d_Ljava_math_BigDecimal$ = new $TypeData().initClass({
  Ljava_math_BigDecimal$: 0
}, false, "java.math.BigDecimal$", {
  Ljava_math_BigDecimal$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_BigDecimal$.prototype.$classData = $d_Ljava_math_BigDecimal$;
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$()
  };
  return $n_Ljava_math_BigDecimal$
}
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.Ljava_math_BigInteger$__f_ONE = null;
  this.Ljava_math_BigInteger$__f_TEN = null;
  this.Ljava_math_BigInteger$__f_ZERO = null;
  this.Ljava_math_BigInteger$__f_MINUS_ONE = null;
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = null;
  this.Ljava_math_BigInteger$__f_TWO_POWS = null;
  $n_Ljava_math_BigInteger$ = this;
  this.Ljava_math_BigInteger$__f_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.Ljava_math_BigInteger$__f_TEN = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.Ljava_math_BigInteger$__f_ZERO = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.Ljava_math_BigInteger$__f_MINUS_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$__f_ZERO, this.Ljava_math_BigInteger$__f_ONE, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.Ljava_math_BigInteger$__f_TEN]);
  var result = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  var i = 0;
  while ((i < 32)) {
    var i$2 = i;
    var $$x2 = $n(result);
    var $$x1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & i$2) === 0) ? (1 << i$2) : 0);
    var hi = (((32 & i$2) === 0) ? 0 : (1 << i$2));
    $$x2.set(i$2, $n($$x1).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi)));
    i = ((1 + i) | 0)
  };
  this.Ljava_math_BigInteger$__f_TWO_POWS = result
}
$c_Ljava_math_BigInteger$.prototype = new $h_O();
$c_Ljava_math_BigInteger$.prototype.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger$.prototype = $c_Ljava_math_BigInteger$.prototype;
$c_Ljava_math_BigInteger$.prototype.valueOf__J__Ljava_math_BigInteger = (function(lVal) {
  var ahi = lVal.RTLong__f_hi;
  if ((ahi < 0)) {
    if ((!((lVal.RTLong__f_lo === (-1)) && (lVal.RTLong__f_hi === (-1))))) {
      var lo = lVal.RTLong__f_lo;
      var hi = lVal.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), new $c_RTLong(lo$1, hi$1))
    } else {
      return this.Ljava_math_BigInteger$__f_MINUS_ONE
    }
  } else {
    var ahi$1 = lVal.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ lVal.RTLong__f_lo) <= (-2147483638)) : (ahi$1 < 0))) {
      return $n(this.Ljava_math_BigInteger$__f_SMALL_VALUES).get(lVal.RTLong__f_lo)
    } else {
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal)
    }
  }
});
$c_Ljava_math_BigInteger$.prototype.getPowerOfTwo__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < $n(this.Ljava_math_BigInteger$__f_TWO_POWS).u.length)) {
    return $n(this.Ljava_math_BigInteger$__f_TWO_POWS).get(exp)
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $ac_I(((1 + intCount) | 0));
    $n(resDigits).set(intCount, (1 << bitN));
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits)
  }
});
$c_Ljava_math_BigInteger$.prototype.checkRangeBasedOnIntArrayLength__I__V = (function(byteLength) {
  if (((byteLength < 0) || (byteLength >= 67108864))) {
    throw new $c_jl_ArithmeticException("BigInteger would overflow supported range")
  }
});
var $d_Ljava_math_BigInteger$ = new $TypeData().initClass({
  Ljava_math_BigInteger$: 0
}, false, "java.math.BigInteger$", {
  Ljava_math_BigInteger$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_BigInteger$.prototype.$classData = $d_Ljava_math_BigInteger$;
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$()
  };
  return $n_Ljava_math_BigInteger$
}
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.Ljava_math_RoundingMode$__f_UP = null;
  this.Ljava_math_RoundingMode$__f_DOWN = null;
  this.Ljava_math_RoundingMode$__f_CEILING = null;
  this.Ljava_math_RoundingMode$__f_FLOOR = null;
  this.Ljava_math_RoundingMode$__f_HALF_UP = null;
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = null;
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = null;
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.Ljava_math_RoundingMode$__f_UP = new $c_Ljava_math_RoundingMode("UP", 0);
  this.Ljava_math_RoundingMode$__f_DOWN = new $c_Ljava_math_RoundingMode("DOWN", 1);
  this.Ljava_math_RoundingMode$__f_CEILING = new $c_Ljava_math_RoundingMode("CEILING", 2);
  this.Ljava_math_RoundingMode$__f_FLOOR = new $c_Ljava_math_RoundingMode("FLOOR", 3);
  this.Ljava_math_RoundingMode$__f_HALF_UP = new $c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = new $c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = new $c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = new $c_Ljava_math_RoundingMode("UNNECESSARY", 7)
}
$c_Ljava_math_RoundingMode$.prototype = new $h_O();
$c_Ljava_math_RoundingMode$.prototype.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
  /*<skip>*/
}
$h_Ljava_math_RoundingMode$.prototype = $c_Ljava_math_RoundingMode$.prototype;
var $d_Ljava_math_RoundingMode$ = new $TypeData().initClass({
  Ljava_math_RoundingMode$: 0
}, false, "java.math.RoundingMode$", {
  Ljava_math_RoundingMode$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_RoundingMode$.prototype.$classData = $d_Ljava_math_RoundingMode$;
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$()
  };
  return $n_Ljava_math_RoundingMode$
}
function $p_Ljava_security_SecureRandom$__getRandomValuesFun$lzycompute__sjs_js_Function1($thiz) {
  if ((!$thiz.Ljava_security_SecureRandom$__f_bitmap$0)) {
    if ((($as_T((typeof crypto)) !== "undefined") && ($as_T((typeof crypto.getRandomValues)) === "function"))) {
      var $$x1 = ((arg1$2) => {
        $m_Ljava_security_SecureRandom$().java$security$SecureRandom$$$anonfun$getRandomValuesFun$1__sjs_js_typedarray_ArrayBufferView__V(arg1$2)
      })
    } else {
      if (($as_T((typeof require)) !== "function")) {
        $p_Ljava_security_SecureRandom$__notSupported__E($thiz)
      };
      var $$x1 = $p_Ljava_security_SecureRandom$__liftedTree1$1__sjs_js_Function1($thiz)
    };
    $thiz.Ljava_security_SecureRandom$__f_java$security$SecureRandom$$getRandomValuesFun = $$x1;
    $thiz.Ljava_security_SecureRandom$__f_bitmap$0 = true
  };
  return $thiz.Ljava_security_SecureRandom$__f_java$security$SecureRandom$$getRandomValuesFun
}
function $p_Ljava_security_SecureRandom$__notSupported__E($thiz) {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "java.security.SecureRandom is not supported on this platform because it provides neither `crypto.getRandomValues` nor Node.js' \"crypto\" module.")
}
function $p_Ljava_security_SecureRandom$__liftedTree1$1__sjs_js_Function1($thiz) {
  try {
    var crypto = require("crypto");
    return (($as_T((typeof crypto.randomFillSync)) === "function") ? ((arg1$2) => {
      $m_Ljava_security_SecureRandom$().java$security$SecureRandom$$$anonfun$getRandomValuesFun$2__sjs_js_typedarray_ArrayBufferView__sjs_js_Dynamic__V(arg1$2, crypto)
    }) : $p_Ljava_security_SecureRandom$__notSupported__E($thiz))
  } catch (e) {
    $p_Ljava_security_SecureRandom$__notSupported__E($thiz)
  }
}
/** @constructor */
function $c_Ljava_security_SecureRandom$() {
  this.Ljava_security_SecureRandom$__f_java$security$SecureRandom$$getRandomValuesFun = null;
  this.Ljava_security_SecureRandom$__f_bitmap$0 = false
}
$c_Ljava_security_SecureRandom$.prototype = new $h_O();
$c_Ljava_security_SecureRandom$.prototype.constructor = $c_Ljava_security_SecureRandom$;
/** @constructor */
function $h_Ljava_security_SecureRandom$() {
  /*<skip>*/
}
$h_Ljava_security_SecureRandom$.prototype = $c_Ljava_security_SecureRandom$.prototype;
$c_Ljava_security_SecureRandom$.prototype.java$security$SecureRandom$$getRandomValuesFun__sjs_js_Function1 = (function() {
  return ((!this.Ljava_security_SecureRandom$__f_bitmap$0) ? $p_Ljava_security_SecureRandom$__getRandomValuesFun$lzycompute__sjs_js_Function1(this) : this.Ljava_security_SecureRandom$__f_java$security$SecureRandom$$getRandomValuesFun)
});
$c_Ljava_security_SecureRandom$.prototype.java$security$SecureRandom$$$anonfun$getRandomValuesFun$1__sjs_js_typedarray_ArrayBufferView__V = (function(buffer) {
  crypto.getRandomValues(buffer)
});
$c_Ljava_security_SecureRandom$.prototype.java$security$SecureRandom$$$anonfun$getRandomValuesFun$2__sjs_js_typedarray_ArrayBufferView__sjs_js_Dynamic__V = (function(buffer, crypto$1) {
  crypto$1.randomFillSync(buffer)
});
var $d_Ljava_security_SecureRandom$ = new $TypeData().initClass({
  Ljava_security_SecureRandom$: 0
}, false, "java.security.SecureRandom$", {
  Ljava_security_SecureRandom$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_security_SecureRandom$.prototype.$classData = $d_Ljava_security_SecureRandom$;
var $n_Ljava_security_SecureRandom$;
function $m_Ljava_security_SecureRandom$() {
  if ((!$n_Ljava_security_SecureRandom$)) {
    $n_Ljava_security_SecureRandom$ = new $c_Ljava_security_SecureRandom$()
  };
  return $n_Ljava_security_SecureRandom$
}
/** @constructor */
function $c_Ljava_text_DateFormatSymbols(locale) {
  this.Ljava_text_DateFormatSymbols__f_eras = null;
  this.Ljava_text_DateFormatSymbols__f_months = null;
  this.Ljava_text_DateFormatSymbols__f_shortMonths = null;
  this.Ljava_text_DateFormatSymbols__f_weekdays = null;
  this.Ljava_text_DateFormatSymbols__f_shortWeekdays = null;
  this.Ljava_text_DateFormatSymbols__f_amPmStrings = null;
  this.Ljava_text_DateFormatSymbols__f_zoneStrings = null;
  this.Ljava_text_DateFormatSymbols__f_localPatternChars = null;
  this.Ljava_text_DateFormatSymbols__f_bitmap$init$0 = 0;
  var xs = $m_sci_Nil$();
  var len = xs.length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i = 0;
  while ($n(iterator).hasNext__Z()) {
    array.set(i, $n(iterator).next__O());
    i = ((1 + i) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_eras = array;
  this.Ljava_text_DateFormatSymbols__f_bitmap$init$0 = (((1 | this.Ljava_text_DateFormatSymbols__f_bitmap$init$0) << 24) >> 24);
  var xs$1 = $m_sci_Nil$();
  var len$1 = xs$1.length__I();
  var array$1 = new ($d_T.getArrayOf().constr)(len$1);
  var iterator$1 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$1 = 0;
  while ($n(iterator$1).hasNext__Z()) {
    array$1.set(i$1, $n(iterator$1).next__O());
    i$1 = ((1 + i$1) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_months = array$1;
  this.Ljava_text_DateFormatSymbols__f_bitmap$init$0 = (((2 | this.Ljava_text_DateFormatSymbols__f_bitmap$init$0) << 24) >> 24);
  var xs$2 = $m_sci_Nil$();
  var len$2 = xs$2.length__I();
  var array$2 = new ($d_T.getArrayOf().constr)(len$2);
  var iterator$2 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$2 = 0;
  while ($n(iterator$2).hasNext__Z()) {
    array$2.set(i$2, $n(iterator$2).next__O());
    i$2 = ((1 + i$2) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_shortMonths = array$2;
  this.Ljava_text_DateFormatSymbols__f_bitmap$init$0 = (((4 | this.Ljava_text_DateFormatSymbols__f_bitmap$init$0) << 24) >> 24);
  var xs$3 = $m_sci_Nil$();
  var len$3 = xs$3.length__I();
  var array$3 = new ($d_T.getArrayOf().constr)(len$3);
  var iterator$3 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$3 = 0;
  while ($n(iterator$3).hasNext__Z()) {
    array$3.set(i$3, $n(iterator$3).next__O());
    i$3 = ((1 + i$3) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_weekdays = array$3;
  this.Ljava_text_DateFormatSymbols__f_bitmap$init$0 = (((8 | this.Ljava_text_DateFormatSymbols__f_bitmap$init$0) << 24) >> 24);
  var xs$4 = $m_sci_Nil$();
  var len$4 = xs$4.length__I();
  var array$4 = new ($d_T.getArrayOf().constr)(len$4);
  var iterator$4 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$4 = 0;
  while ($n(iterator$4).hasNext__Z()) {
    array$4.set(i$4, $n(iterator$4).next__O());
    i$4 = ((1 + i$4) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_shortWeekdays = array$4;
  this.Ljava_text_DateFormatSymbols__f_bitmap$init$0 = (((16 | this.Ljava_text_DateFormatSymbols__f_bitmap$init$0) << 24) >> 24);
  var xs$5 = $m_sci_Nil$();
  var len$5 = xs$5.length__I();
  var array$5 = new ($d_T.getArrayOf().constr)(len$5);
  var iterator$5 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$5 = 0;
  while ($n(iterator$5).hasNext__Z()) {
    array$5.set(i$5, $n(iterator$5).next__O());
    i$5 = ((1 + i$5) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_amPmStrings = array$5;
  this.Ljava_text_DateFormatSymbols__f_bitmap$init$0 = (((32 | this.Ljava_text_DateFormatSymbols__f_bitmap$init$0) << 24) >> 24);
  var xs$6 = $m_sci_Nil$();
  var len$6 = xs$6.length__I();
  var array$6 = new ($d_T.getArrayOf().getArrayOf().constr)(len$6);
  var iterator$6 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$6 = 0;
  while ($n(iterator$6).hasNext__Z()) {
    array$6.set(i$6, $n(iterator$6).next__O());
    i$6 = ((1 + i$6) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_zoneStrings = array$6;
  this.Ljava_text_DateFormatSymbols__f_bitmap$init$0 = (((64 | this.Ljava_text_DateFormatSymbols__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_text_DateFormatSymbols__f_localPatternChars = "";
  this.Ljava_text_DateFormatSymbols__f_bitmap$init$0 = (((128 | this.Ljava_text_DateFormatSymbols__f_bitmap$init$0) << 24) >> 24);
  $m_Ljava_text_DateFormatSymbols$().java$text$DateFormatSymbols$$initialize__ju_Locale__Ljava_text_DateFormatSymbols__Ljava_text_DateFormatSymbols(locale, this)
}
$c_Ljava_text_DateFormatSymbols.prototype = new $h_O();
$c_Ljava_text_DateFormatSymbols.prototype.constructor = $c_Ljava_text_DateFormatSymbols;
/** @constructor */
function $h_Ljava_text_DateFormatSymbols() {
  /*<skip>*/
}
$h_Ljava_text_DateFormatSymbols.prototype = $c_Ljava_text_DateFormatSymbols.prototype;
$c_Ljava_text_DateFormatSymbols.prototype.setEras__AT__V = (function(eras) {
  if ((eras === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var xs = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(eras);
  var len = $n(xs).length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = $n(xs).iterator__sc_Iterator();
  var i = 0;
  while ($n(iterator).hasNext__Z()) {
    array.set(i, $n(iterator).next__O());
    i = ((1 + i) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_eras = array
});
$c_Ljava_text_DateFormatSymbols.prototype.setMonths__AT__V = (function(months) {
  if ((months === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var xs = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(months);
  var len = $n(xs).length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = $n(xs).iterator__sc_Iterator();
  var i = 0;
  while ($n(iterator).hasNext__Z()) {
    array.set(i, $n(iterator).next__O());
    i = ((1 + i) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_months = array
});
$c_Ljava_text_DateFormatSymbols.prototype.setShortMonths__AT__V = (function(shortMonths) {
  if ((shortMonths === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var xs = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(shortMonths);
  var len = $n(xs).length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = $n(xs).iterator__sc_Iterator();
  var i = 0;
  while ($n(iterator).hasNext__Z()) {
    array.set(i, $n(iterator).next__O());
    i = ((1 + i) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_shortMonths = array
});
$c_Ljava_text_DateFormatSymbols.prototype.setWeekdays__AT__V = (function(weekdays) {
  if ((weekdays === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var xs = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(weekdays);
  var len = $n(xs).length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = $n(xs).iterator__sc_Iterator();
  var i = 0;
  while ($n(iterator).hasNext__Z()) {
    array.set(i, $n(iterator).next__O());
    i = ((1 + i) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_weekdays = array
});
$c_Ljava_text_DateFormatSymbols.prototype.setShortWeekdays__AT__V = (function(shortWeekdays) {
  if ((shortWeekdays === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var xs = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(shortWeekdays);
  var len = $n(xs).length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = $n(xs).iterator__sc_Iterator();
  var i = 0;
  while ($n(iterator).hasNext__Z()) {
    array.set(i, $n(iterator).next__O());
    i = ((1 + i) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_shortWeekdays = array
});
$c_Ljava_text_DateFormatSymbols.prototype.setAmPmStrings__AT__V = (function(amPmStrings) {
  if ((amPmStrings === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var xs = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(amPmStrings);
  var len = $n(xs).length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = $n(xs).iterator__sc_Iterator();
  var i = 0;
  while ($n(iterator).hasNext__Z()) {
    array.set(i, $n(iterator).next__O());
    i = ((1 + i) | 0)
  };
  this.Ljava_text_DateFormatSymbols__f_amPmStrings = array
});
$c_Ljava_text_DateFormatSymbols.prototype.hashCode__I = (function() {
  var $$x1 = $m_sci_Seq$();
  var xs = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(this.Ljava_text_DateFormatSymbols__f_eras);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var len = $n(xs).length__I();
  var array = new $ac_O(len);
  var iterator = $n(xs).iterator__sc_Iterator();
  var i = 0;
  while ($n(iterator).hasNext__Z()) {
    array.set(i, $n(iterator).next__O());
    i = ((1 + i) | 0)
  };
  var xs$1 = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(this.Ljava_text_DateFormatSymbols__f_months);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var len$1 = $n(xs$1).length__I();
  var array$1 = new $ac_O(len$1);
  var iterator$1 = $n(xs$1).iterator__sc_Iterator();
  var i$1 = 0;
  while ($n(iterator$1).hasNext__Z()) {
    array$1.set(i$1, $n(iterator$1).next__O());
    i$1 = ((1 + i$1) | 0)
  };
  var xs$2 = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(this.Ljava_text_DateFormatSymbols__f_shortMonths);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var len$2 = $n(xs$2).length__I();
  var array$2 = new $ac_O(len$2);
  var iterator$2 = $n(xs$2).iterator__sc_Iterator();
  var i$2 = 0;
  while ($n(iterator$2).hasNext__Z()) {
    array$2.set(i$2, $n(iterator$2).next__O());
    i$2 = ((1 + i$2) | 0)
  };
  var xs$3 = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(this.Ljava_text_DateFormatSymbols__f_weekdays);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var len$3 = $n(xs$3).length__I();
  var array$3 = new $ac_O(len$3);
  var iterator$3 = $n(xs$3).iterator__sc_Iterator();
  var i$3 = 0;
  while ($n(iterator$3).hasNext__Z()) {
    array$3.set(i$3, $n(iterator$3).next__O());
    i$3 = ((1 + i$3) | 0)
  };
  var xs$4 = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(this.Ljava_text_DateFormatSymbols__f_shortWeekdays);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var len$4 = $n(xs$4).length__I();
  var array$4 = new $ac_O(len$4);
  var iterator$4 = $n(xs$4).iterator__sc_Iterator();
  var i$4 = 0;
  while ($n(iterator$4).hasNext__Z()) {
    array$4.set(i$4, $n(iterator$4).next__O());
    i$4 = ((1 + i$4) | 0)
  };
  var xs$5 = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(this.Ljava_text_DateFormatSymbols__f_amPmStrings);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var len$5 = $n(xs$5).length__I();
  var array$5 = new $ac_O(len$5);
  var iterator$5 = $n(xs$5).iterator__sc_Iterator();
  var i$5 = 0;
  while ($n(iterator$5).hasNext__Z()) {
    array$5.set(i$5, $n(iterator$5).next__O());
    i$5 = ((1 + i$5) | 0)
  };
  var array$6 = [array, array$1, array$2, array$3, array$4, array$5];
  var state = $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6)));
  var s = $uI($n($as_sc_IterableOnceOps($n(state).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $asArrayOf_O(x$1$2, 1);
    return $m_ju_Arrays$().hashCode__AO__I(x$1)
  }))))).foldLeft__O__F2__O(0, new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $uI(a$2);
    var b = $uI(b$2);
    return ((Math.imul(31, a) + b) | 0)
  }))));
  $m_sc_ArrayOps$();
  var xs$6 = this.Ljava_text_DateFormatSymbols__f_zoneStrings;
  var f = ((x$11$2) => {
    var x$11 = $asArrayOf_T(x$11$2, 1);
    var xs$7 = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(x$11);
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    var len$6 = $n(xs$7).length__I();
    var array$7 = new $ac_O(len$6);
    var iterator$6 = $n(xs$7).iterator__sc_Iterator();
    var i$6 = 0;
    while ($n(iterator$6).hasNext__Z()) {
      array$7.set(i$6, $n(iterator$6).next__O());
      i$6 = ((1 + i$6) | 0)
    };
    return array$7
  });
  var len$7 = $n(xs$6).u.length;
  var ys = new ($d_O.getArrayOf().getArrayOf().constr)(len$7);
  if ((len$7 > 0)) {
    var i$7 = 0;
    if ((xs$6 !== null)) {
      while ((i$7 < len$7)) {
        var $$x2 = i$7;
        var arg1 = $n(xs$6).get(i$7);
        ys.set($$x2, f(arg1));
        i$7 = ((1 + i$7) | 0)
      }
    } else if ((xs$6 instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs$6, 1);
      while ((i$7 < len$7)) {
        var $$x3 = i$7;
        var arg1$1 = $n(x3).get(i$7);
        ys.set($$x3, f(arg1$1));
        i$7 = ((1 + i$7) | 0)
      }
    } else if ((xs$6 instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs$6, 1);
      while ((i$7 < len$7)) {
        var $$x4 = i$7;
        var arg1$2 = $n(x4).get(i$7);
        ys.set($$x4, f(arg1$2));
        i$7 = ((1 + i$7) | 0)
      }
    } else if ((xs$6 instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs$6, 1);
      while ((i$7 < len$7)) {
        var $$x5 = i$7;
        var t = $n(x5).get(i$7);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($$x5, f(new $c_RTLong(lo, hi)));
        i$7 = ((1 + i$7) | 0)
      }
    } else if ((xs$6 instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs$6, 1);
      while ((i$7 < len$7)) {
        var $$x6 = i$7;
        var arg1$3 = $n(x6).get(i$7);
        ys.set($$x6, f(arg1$3));
        i$7 = ((1 + i$7) | 0)
      }
    } else if ((xs$6 instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs$6, 1);
      while ((i$7 < len$7)) {
        var $$x7 = i$7;
        var arg1$4 = $n(x7).get(i$7);
        ys.set($$x7, f($bC(arg1$4)));
        i$7 = ((1 + i$7) | 0)
      }
    } else if ((xs$6 instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs$6, 1);
      while ((i$7 < len$7)) {
        var $$x8 = i$7;
        var arg1$5 = $n(x8).get(i$7);
        ys.set($$x8, f(arg1$5));
        i$7 = ((1 + i$7) | 0)
      }
    } else if ((xs$6 instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs$6, 1);
      while ((i$7 < len$7)) {
        var $$x9 = i$7;
        var arg1$6 = $n(x9).get(i$7);
        ys.set($$x9, f(arg1$6));
        i$7 = ((1 + i$7) | 0)
      }
    } else if ((xs$6 instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs$6, 1);
      while ((i$7 < len$7)) {
        var $$x10 = i$7;
        var arg1$7 = $n(x10).get(i$7);
        ys.set($$x10, f(arg1$7));
        i$7 = ((1 + i$7) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs$6)
    }
  };
  var xs$8 = $m_s_Predef$().copyArrayToImmutableIndexedSeq__O__sci_IndexedSeq(ys);
  $m_s_reflect_ManifestFactory$ObjectManifest$();
  var len$8 = $n(xs$8).length__I();
  var array$8 = new $ac_O(len$8);
  var iterator$7 = $n(xs$8).iterator__sc_Iterator();
  var i$8 = 0;
  while ($n(iterator$7).hasNext__Z()) {
    array$8.set(i$8, $n(iterator$7).next__O());
    i$8 = ((1 + i$8) | 0)
  };
  return ((Math.imul(31, ((Math.imul(31, s) + $m_ju_Arrays$().hashCode__AO__I(array$8)) | 0)) + $f_T__hashCode__I($n(this.Ljava_text_DateFormatSymbols__f_localPatternChars))) | 0)
});
$c_Ljava_text_DateFormatSymbols.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_text_DateFormatSymbols)) {
    var x2 = $as_Ljava_text_DateFormatSymbols(other);
    var this$1 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_eras));
    var that = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($n(x2).Ljava_text_DateFormatSymbols__f_eras);
    if ($f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$1, that)) {
      var this$2 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_months));
      var that$1 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($n(x2).Ljava_text_DateFormatSymbols__f_months);
      var $$x6 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$2, that$1)
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var this$3 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_shortMonths));
      var that$2 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($n(x2).Ljava_text_DateFormatSymbols__f_shortMonths);
      var $$x5 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$3, that$2)
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var this$4 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_weekdays));
      var that$3 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($n(x2).Ljava_text_DateFormatSymbols__f_weekdays);
      var $$x4 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$4, that$3)
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var this$5 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_shortWeekdays));
      var that$4 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($n(x2).Ljava_text_DateFormatSymbols__f_shortWeekdays);
      var $$x3 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$5, that$4)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var this$6 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_amPmStrings));
      var that$5 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($n(x2).Ljava_text_DateFormatSymbols__f_amPmStrings);
      var $$x2 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$6, that$5)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var this$7 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_zoneStrings));
      var that$6 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($n(x2).Ljava_text_DateFormatSymbols__f_zoneStrings);
      var $$x1 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$7, that$6)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return (this.Ljava_text_DateFormatSymbols__f_localPatternChars === $n(x2).Ljava_text_DateFormatSymbols__f_localPatternChars)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljava_text_DateFormatSymbols(obj) {
  return (((obj instanceof $c_Ljava_text_DateFormatSymbols) || (obj === null)) ? obj : $throwClassCastException(obj, "java.text.DateFormatSymbols"))
}
function $isArrayOf_Ljava_text_DateFormatSymbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_text_DateFormatSymbols)))
}
function $asArrayOf_Ljava_text_DateFormatSymbols(obj, depth) {
  return (($isArrayOf_Ljava_text_DateFormatSymbols(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.text.DateFormatSymbols;", depth))
}
var $d_Ljava_text_DateFormatSymbols = new $TypeData().initClass({
  Ljava_text_DateFormatSymbols: 0
}, false, "java.text.DateFormatSymbols", {
  Ljava_text_DateFormatSymbols: 1,
  O: 1,
  jl_Cloneable: 1
});
$c_Ljava_text_DateFormatSymbols.prototype.$classData = $d_Ljava_text_DateFormatSymbols;
function $p_Ljava_time_DayOfWeek$__MONDAY$lzycompute__Ljava_time_DayOfWeek($thiz) {
  if (((1 & $thiz.Ljava_time_DayOfWeek$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_DayOfWeek$__f_MONDAY = new $c_Ljava_time_DayOfWeek("MONDAY", 0);
    $thiz.Ljava_time_DayOfWeek$__f_bitmap$0 = (1 | $thiz.Ljava_time_DayOfWeek$__f_bitmap$0)
  };
  return $thiz.Ljava_time_DayOfWeek$__f_MONDAY
}
function $p_Ljava_time_DayOfWeek$__TUESDAY$lzycompute__Ljava_time_DayOfWeek($thiz) {
  if (((2 & $thiz.Ljava_time_DayOfWeek$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_DayOfWeek$__f_TUESDAY = new $c_Ljava_time_DayOfWeek("TUESDAY", 1);
    $thiz.Ljava_time_DayOfWeek$__f_bitmap$0 = (2 | $thiz.Ljava_time_DayOfWeek$__f_bitmap$0)
  };
  return $thiz.Ljava_time_DayOfWeek$__f_TUESDAY
}
function $p_Ljava_time_DayOfWeek$__WEDNESDAY$lzycompute__Ljava_time_DayOfWeek($thiz) {
  if (((4 & $thiz.Ljava_time_DayOfWeek$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_DayOfWeek$__f_WEDNESDAY = new $c_Ljava_time_DayOfWeek("WEDNESDAY", 2);
    $thiz.Ljava_time_DayOfWeek$__f_bitmap$0 = (4 | $thiz.Ljava_time_DayOfWeek$__f_bitmap$0)
  };
  return $thiz.Ljava_time_DayOfWeek$__f_WEDNESDAY
}
function $p_Ljava_time_DayOfWeek$__THURSDAY$lzycompute__Ljava_time_DayOfWeek($thiz) {
  if (((8 & $thiz.Ljava_time_DayOfWeek$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_DayOfWeek$__f_THURSDAY = new $c_Ljava_time_DayOfWeek("THURSDAY", 3);
    $thiz.Ljava_time_DayOfWeek$__f_bitmap$0 = (8 | $thiz.Ljava_time_DayOfWeek$__f_bitmap$0)
  };
  return $thiz.Ljava_time_DayOfWeek$__f_THURSDAY
}
function $p_Ljava_time_DayOfWeek$__FRIDAY$lzycompute__Ljava_time_DayOfWeek($thiz) {
  if (((16 & $thiz.Ljava_time_DayOfWeek$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_DayOfWeek$__f_FRIDAY = new $c_Ljava_time_DayOfWeek("FRIDAY", 4);
    $thiz.Ljava_time_DayOfWeek$__f_bitmap$0 = (16 | $thiz.Ljava_time_DayOfWeek$__f_bitmap$0)
  };
  return $thiz.Ljava_time_DayOfWeek$__f_FRIDAY
}
function $p_Ljava_time_DayOfWeek$__SATURDAY$lzycompute__Ljava_time_DayOfWeek($thiz) {
  if (((32 & $thiz.Ljava_time_DayOfWeek$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_DayOfWeek$__f_SATURDAY = new $c_Ljava_time_DayOfWeek("SATURDAY", 5);
    $thiz.Ljava_time_DayOfWeek$__f_bitmap$0 = (32 | $thiz.Ljava_time_DayOfWeek$__f_bitmap$0)
  };
  return $thiz.Ljava_time_DayOfWeek$__f_SATURDAY
}
function $p_Ljava_time_DayOfWeek$__SUNDAY$lzycompute__Ljava_time_DayOfWeek($thiz) {
  if (((64 & $thiz.Ljava_time_DayOfWeek$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_DayOfWeek$__f_SUNDAY = new $c_Ljava_time_DayOfWeek("SUNDAY", 6);
    $thiz.Ljava_time_DayOfWeek$__f_bitmap$0 = (64 | $thiz.Ljava_time_DayOfWeek$__f_bitmap$0)
  };
  return $thiz.Ljava_time_DayOfWeek$__f_SUNDAY
}
function $p_Ljava_time_DayOfWeek$__values$lzycompute__ALjava_time_DayOfWeek($thiz) {
  if (((128 & $thiz.Ljava_time_DayOfWeek$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_DayOfWeek$__f_values = new ($d_Ljava_time_DayOfWeek.getArrayOf().constr)([$thiz.MONDAY__Ljava_time_DayOfWeek(), $thiz.TUESDAY__Ljava_time_DayOfWeek(), $thiz.WEDNESDAY__Ljava_time_DayOfWeek(), $thiz.THURSDAY__Ljava_time_DayOfWeek(), $thiz.FRIDAY__Ljava_time_DayOfWeek(), $thiz.SATURDAY__Ljava_time_DayOfWeek(), $thiz.SUNDAY__Ljava_time_DayOfWeek()]);
    $thiz.Ljava_time_DayOfWeek$__f_bitmap$0 = (128 | $thiz.Ljava_time_DayOfWeek$__f_bitmap$0)
  };
  return $thiz.Ljava_time_DayOfWeek$__f_values
}
function $p_Ljava_time_DayOfWeek$__ENUMS$lzycompute__ALjava_time_DayOfWeek($thiz) {
  if (((256 & $thiz.Ljava_time_DayOfWeek$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_DayOfWeek$__f_java$time$DayOfWeek$$ENUMS = $m_Ljava_time_DayOfWeek$().values__ALjava_time_DayOfWeek();
    $thiz.Ljava_time_DayOfWeek$__f_bitmap$0 = (256 | $thiz.Ljava_time_DayOfWeek$__f_bitmap$0)
  };
  return $thiz.Ljava_time_DayOfWeek$__f_java$time$DayOfWeek$$ENUMS
}
/** @constructor */
function $c_Ljava_time_DayOfWeek$() {
  this.Ljava_time_DayOfWeek$__f_MONDAY = null;
  this.Ljava_time_DayOfWeek$__f_TUESDAY = null;
  this.Ljava_time_DayOfWeek$__f_WEDNESDAY = null;
  this.Ljava_time_DayOfWeek$__f_THURSDAY = null;
  this.Ljava_time_DayOfWeek$__f_FRIDAY = null;
  this.Ljava_time_DayOfWeek$__f_SATURDAY = null;
  this.Ljava_time_DayOfWeek$__f_SUNDAY = null;
  this.Ljava_time_DayOfWeek$__f_values = null;
  this.Ljava_time_DayOfWeek$__f_java$time$DayOfWeek$$ENUMS = null;
  this.Ljava_time_DayOfWeek$__f_bitmap$0 = 0
}
$c_Ljava_time_DayOfWeek$.prototype = new $h_O();
$c_Ljava_time_DayOfWeek$.prototype.constructor = $c_Ljava_time_DayOfWeek$;
/** @constructor */
function $h_Ljava_time_DayOfWeek$() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek$.prototype = $c_Ljava_time_DayOfWeek$.prototype;
$c_Ljava_time_DayOfWeek$.prototype.MONDAY__Ljava_time_DayOfWeek = (function() {
  return (((1 & this.Ljava_time_DayOfWeek$__f_bitmap$0) === 0) ? $p_Ljava_time_DayOfWeek$__MONDAY$lzycompute__Ljava_time_DayOfWeek(this) : this.Ljava_time_DayOfWeek$__f_MONDAY)
});
$c_Ljava_time_DayOfWeek$.prototype.TUESDAY__Ljava_time_DayOfWeek = (function() {
  return (((2 & this.Ljava_time_DayOfWeek$__f_bitmap$0) === 0) ? $p_Ljava_time_DayOfWeek$__TUESDAY$lzycompute__Ljava_time_DayOfWeek(this) : this.Ljava_time_DayOfWeek$__f_TUESDAY)
});
$c_Ljava_time_DayOfWeek$.prototype.WEDNESDAY__Ljava_time_DayOfWeek = (function() {
  return (((4 & this.Ljava_time_DayOfWeek$__f_bitmap$0) === 0) ? $p_Ljava_time_DayOfWeek$__WEDNESDAY$lzycompute__Ljava_time_DayOfWeek(this) : this.Ljava_time_DayOfWeek$__f_WEDNESDAY)
});
$c_Ljava_time_DayOfWeek$.prototype.THURSDAY__Ljava_time_DayOfWeek = (function() {
  return (((8 & this.Ljava_time_DayOfWeek$__f_bitmap$0) === 0) ? $p_Ljava_time_DayOfWeek$__THURSDAY$lzycompute__Ljava_time_DayOfWeek(this) : this.Ljava_time_DayOfWeek$__f_THURSDAY)
});
$c_Ljava_time_DayOfWeek$.prototype.FRIDAY__Ljava_time_DayOfWeek = (function() {
  return (((16 & this.Ljava_time_DayOfWeek$__f_bitmap$0) === 0) ? $p_Ljava_time_DayOfWeek$__FRIDAY$lzycompute__Ljava_time_DayOfWeek(this) : this.Ljava_time_DayOfWeek$__f_FRIDAY)
});
$c_Ljava_time_DayOfWeek$.prototype.SATURDAY__Ljava_time_DayOfWeek = (function() {
  return (((32 & this.Ljava_time_DayOfWeek$__f_bitmap$0) === 0) ? $p_Ljava_time_DayOfWeek$__SATURDAY$lzycompute__Ljava_time_DayOfWeek(this) : this.Ljava_time_DayOfWeek$__f_SATURDAY)
});
$c_Ljava_time_DayOfWeek$.prototype.SUNDAY__Ljava_time_DayOfWeek = (function() {
  return (((64 & this.Ljava_time_DayOfWeek$__f_bitmap$0) === 0) ? $p_Ljava_time_DayOfWeek$__SUNDAY$lzycompute__Ljava_time_DayOfWeek(this) : this.Ljava_time_DayOfWeek$__f_SUNDAY)
});
$c_Ljava_time_DayOfWeek$.prototype.values__ALjava_time_DayOfWeek = (function() {
  return (((128 & this.Ljava_time_DayOfWeek$__f_bitmap$0) === 0) ? $p_Ljava_time_DayOfWeek$__values$lzycompute__ALjava_time_DayOfWeek(this) : this.Ljava_time_DayOfWeek$__f_values)
});
$c_Ljava_time_DayOfWeek$.prototype.java$time$DayOfWeek$$ENUMS__ALjava_time_DayOfWeek = (function() {
  return (((256 & this.Ljava_time_DayOfWeek$__f_bitmap$0) === 0) ? $p_Ljava_time_DayOfWeek$__ENUMS$lzycompute__ALjava_time_DayOfWeek(this) : this.Ljava_time_DayOfWeek$__f_java$time$DayOfWeek$$ENUMS)
});
$c_Ljava_time_DayOfWeek$.prototype.of__I__Ljava_time_DayOfWeek = (function(dayOfWeek) {
  if (((dayOfWeek < 1) || (dayOfWeek > 7))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for DayOfWeek: " + dayOfWeek))
  } else {
    return $n(this.java$time$DayOfWeek$$ENUMS__ALjava_time_DayOfWeek()).get((((-1) + dayOfWeek) | 0))
  }
});
var $d_Ljava_time_DayOfWeek$ = new $TypeData().initClass({
  Ljava_time_DayOfWeek$: 0
}, false, "java.time.DayOfWeek$", {
  Ljava_time_DayOfWeek$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_DayOfWeek$.prototype.$classData = $d_Ljava_time_DayOfWeek$;
var $n_Ljava_time_DayOfWeek$;
function $m_Ljava_time_DayOfWeek$() {
  if ((!$n_Ljava_time_DayOfWeek$)) {
    $n_Ljava_time_DayOfWeek$ = new $c_Ljava_time_DayOfWeek$()
  };
  return $n_Ljava_time_DayOfWeek$
}
function $p_Ljava_time_Duration$__ZERO$lzycompute__Ljava_time_Duration($thiz) {
  if ((!$thiz.Ljava_time_Duration$__f_bitmap$0)) {
    $thiz.Ljava_time_Duration$__f_ZERO = new $c_Ljava_time_Duration($L0, 0);
    $thiz.Ljava_time_Duration$__f_bitmap$0 = true
  };
  return $thiz.Ljava_time_Duration$__f_ZERO
}
function $p_Ljava_time_Duration$__parseNumber__jl_CharSequence__T__I__T__J($thiz, text, parsed, multiplier, errorText) {
  var _parsed = parsed;
  if ((_parsed === null)) {
    return $L0
  };
  try {
    var this$1 = $n(_parsed);
    if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 1)) === "+"))) {
      var this$2 = $n(_parsed);
      if ((this$2.length < 1)) {
        $charAt(this$2, 1)
      };
      _parsed = $as_T(this$2.substring(1))
    };
    var s = _parsed;
    var this$3 = $m_jl_Long$();
    var t = this$3.parseLong__T__I__J(s, 10);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var hi$1 = (multiplier >> 31);
    return $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo, hi), new $c_RTLong(multiplier, hi$1))
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      var ex$2 = $as_jl_NumberFormatException(e);
      throw new $c_Ljava_time_format_DateTimeParseException(("Text cannot be parsed to a Duration: " + errorText), text, 0, ex$2)
    } else if ((e instanceof $c_jl_ArithmeticException)) {
      var ex = $as_jl_ArithmeticException(e);
      throw new $c_Ljava_time_format_DateTimeParseException(("Text cannot be parsed to a Duration: " + errorText), text, 0, ex)
    } else {
      throw e
    }
  }
}
function $p_Ljava_time_Duration$__parseFraction__jl_CharSequence__T__I__I($thiz, text, parsed, negate) {
  var _parsed = parsed;
  if ((_parsed === null)) {
    var $$x1 = true
  } else {
    var this$1 = $n(_parsed);
    var $$x1 = (this$1.length === 0)
  };
  if ($$x1) {
    return 0
  };
  try {
    var this$2 = (_parsed + "000000000");
    if ((this$2.length < 9)) {
      $charAt(this$2, 9)
    };
    _parsed = $as_T(this$2.substring(0, 9));
    $m_sc_StringOps$();
    var x = _parsed;
    var this$5 = $m_jl_Integer$();
    return Math.imul(this$5.parseInt__T__I__I(x, 10), negate)
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      var ex$2 = $as_jl_NumberFormatException(e);
      throw new $c_Ljava_time_format_DateTimeParseException("Text cannot be parsed to a Duration: fraction", text, 0, ex$2)
    } else if ((e instanceof $c_jl_ArithmeticException)) {
      var ex = $as_jl_ArithmeticException(e);
      throw new $c_Ljava_time_format_DateTimeParseException("Text cannot be parsed to a Duration: fraction", text, 0, ex)
    } else {
      throw e
    }
  }
}
function $p_Ljava_time_Duration$__create__Z__J__J__J__J__I__Ljava_time_Duration($thiz, negate, daysAsSecs, hoursAsSecs, minsAsSecs, secs, nanos) {
  var t = $m_jl_Math$().addExact__J__J__J(minsAsSecs, secs);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $m_jl_Math$().addExact__J__J__J(hoursAsSecs, new $c_RTLong(lo, hi));
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $m_jl_Math$().addExact__J__J__J(daysAsSecs, new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  if (negate) {
    var $$x1 = new $c_RTLong(lo$2, hi$2);
    var hi$3 = (nanos >> 31);
    var this$2 = $n($thiz.ofSeconds__J__J__Ljava_time_Duration($$x1, new $c_RTLong(nanos, hi$3)));
    return this$2.multipliedBy__J__Ljava_time_Duration(new $c_RTLong((-1), (-1)))
  } else {
    var $$x2 = new $c_RTLong(lo$2, hi$2);
    var hi$4 = (nanos >> 31);
    return $thiz.ofSeconds__J__J__Ljava_time_Duration($$x2, new $c_RTLong(nanos, hi$4))
  }
}
/** @constructor */
function $c_Ljava_time_Duration$() {
  this.Ljava_time_Duration$__f_ZERO = null;
  this.Ljava_time_Duration$__f_bitmap$0 = false
}
$c_Ljava_time_Duration$.prototype = new $h_O();
$c_Ljava_time_Duration$.prototype.constructor = $c_Ljava_time_Duration$;
/** @constructor */
function $h_Ljava_time_Duration$() {
  /*<skip>*/
}
$h_Ljava_time_Duration$.prototype = $c_Ljava_time_Duration$.prototype;
$c_Ljava_time_Duration$.prototype.ZERO__Ljava_time_Duration = (function() {
  return ((!this.Ljava_time_Duration$__f_bitmap$0) ? $p_Ljava_time_Duration$__ZERO$lzycompute__Ljava_time_Duration(this) : this.Ljava_time_Duration$__f_ZERO)
});
$c_Ljava_time_Duration$.prototype.ofHours__J__Ljava_time_Duration = (function(hours) {
  return this.java$time$Duration$$create__J__I__Ljava_time_Duration($m_jl_Math$().multiplyExact__J__J__J(hours, new $c_RTLong(3600, 0)), 0)
});
$c_Ljava_time_Duration$.prototype.ofMinutes__J__Ljava_time_Duration = (function(minutes) {
  return this.java$time$Duration$$create__J__I__Ljava_time_Duration($m_jl_Math$().multiplyExact__J__J__J(minutes, new $c_RTLong(60, 0)), 0)
});
$c_Ljava_time_Duration$.prototype.ofSeconds__J__J__Ljava_time_Duration = (function(seconds, nanoAdjustment) {
  var t = $m_jl_Math$().floorDiv__J__J__J(nanoAdjustment, new $c_RTLong(1000000000, 0));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $m_jl_Math$().addExact__J__J__J(seconds, new $c_RTLong(lo, hi));
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var this$1 = $m_jl_Math$().floorMod__J__J__J(nanoAdjustment, new $c_RTLong(1000000000, 0));
  var nos = this$1.RTLong__f_lo;
  return this.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(lo$1, hi$1), nos)
});
$c_Ljava_time_Duration$.prototype.ofNanos__J__Ljava_time_Duration = (function(nanos) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var secs__lo = lo;
  var secs__hi = hi;
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
  var nos = lo$1;
  if ((nos < 0)) {
    nos = ((1000000000 + nos) | 0);
    var b__lo = secs__lo;
    var b__hi = secs__hi;
    var bhi = b__hi;
    var lo$2 = (((-1) + b__lo) | 0);
    var hi$2 = ((lo$2 !== (-1)) ? bhi : (((-1) + bhi) | 0));
    var $$x1__lo = lo$2;
    var $$x1__hi = hi$2;
    secs__lo = $$x1__lo;
    secs__hi = $$x1__hi
  };
  return this.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(secs__lo, secs__hi), nos)
});
$c_Ljava_time_Duration$.prototype.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration = (function(startInclusive, endExclusive) {
  var t = $n(startInclusive).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(endExclusive, $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit());
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var secs__lo = lo;
  var secs__hi = hi;
  var nanos__lo = 0;
  var nanos__hi = 0;
  if (($n(startInclusive).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField()) && $n(endExclusive).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    try {
      var t$1 = $n(startInclusive).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var this$1 = $n(endExclusive).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
      var alo = this$1.RTLong__f_lo;
      var ahi = this$1.RTLong__f_hi;
      var lo$2 = ((alo - lo$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$1) | 0)) | 0) : ((ahi - hi$1) | 0));
      var $$x1__lo = lo$2;
      var $$x1__hi = hi$2;
      nanos__lo = $$x1__lo;
      nanos__hi = $$x1__hi;
      var this$3__lo = secs__lo;
      var this$3__hi = secs__hi;
      var ahi$1 = this$3__hi;
      if (((ahi$1 === 0) ? (this$3__lo !== 0) : (ahi$1 > 0))) {
        var this$4__lo = nanos__lo;
        var this$4__hi = nanos__hi;
        var ahi$2 = this$4__hi;
        var $$x2 = (ahi$2 < 0)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var b__lo = nanos__lo;
        var b__hi = nanos__hi;
        var bhi = b__hi;
        var lo$3 = ((1000000000 + b__lo) | 0);
        var hi$3 = ((((-2147483648) ^ lo$3) < (-1147483648)) ? ((1 + bhi) | 0) : bhi);
        var $$x3__lo = lo$3;
        var $$x3__hi = hi$3;
        nanos__lo = $$x3__lo;
        nanos__hi = $$x3__hi
      } else {
        var this$6__lo = secs__lo;
        var this$6__hi = secs__hi;
        var ahi$3 = this$6__hi;
        if ((ahi$3 < 0)) {
          var this$7__lo = nanos__lo;
          var this$7__hi = nanos__hi;
          var ahi$4 = this$7__hi;
          var $$x4 = ((ahi$4 === 0) ? (this$7__lo !== 0) : (ahi$4 > 0))
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          var b$1__lo = nanos__lo;
          var b$1__hi = nanos__hi;
          var bhi$1 = b$1__hi;
          var lo$4 = (((-1000000000) + b$1__lo) | 0);
          var hi$4 = ((((-2147483648) ^ lo$4) < 1147483648) ? bhi$1 : (((-1) + bhi$1) | 0));
          var $$x5__lo = lo$4;
          var $$x5__hi = hi$4;
          nanos__lo = $$x5__lo;
          nanos__hi = $$x5__hi
        } else {
          var this$9__lo = secs__lo;
          var this$9__hi = secs__hi;
          if (((this$9__lo === 0) && (this$9__hi === 0))) {
            var this$10__lo = nanos__lo;
            var this$10__hi = nanos__hi;
            var $$x6 = (!((this$10__lo === 0) && (this$10__hi === 0)))
          } else {
            var $$x6 = false
          };
          if ($$x6) {
            var adjustedEnd = $n(endExclusive).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo$1, hi$1));
            var t$2 = $n(startInclusive).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(adjustedEnd, $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit());
            var lo$5 = t$2.RTLong__f_lo;
            var hi$5 = t$2.RTLong__f_hi;
            var $$x7__lo = lo$5;
            var $$x7__hi = hi$5;
            secs__lo = $$x7__lo;
            secs__hi = $$x7__hi
          }
        }
      }
    } catch (e) {
      if ((!(e instanceof $c_Ljava_time_DateTimeException))) {
        if ((!(e instanceof $c_jl_ArithmeticException))) {
          throw e
        }
      }
    }
  };
  return this.ofSeconds__J__J__Ljava_time_Duration(new $c_RTLong(secs__lo, secs__hi), new $c_RTLong(nanos__lo, nanos__hi))
});
$c_Ljava_time_Duration$.prototype.parse__jl_CharSequence__Ljava_time_Duration = (function(text) {
  if ((text === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "text")
  };
  var this$3 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("([-+]?)P(?:([-+]?[0-9]+)D)?(T(?:([-+]?[0-9]+)H)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)(?:[.,]([0-9]{0,9}))?S)?)?", 2));
  var matcher = new $c_ju_regex_Matcher(this$3, $dp_toString__T($n(text)));
  if (matcher.matches__Z()) {
    if ((matcher.group__I__T(3) !== "T")) {
      var negate = (matcher.group__I__T(1) === "-");
      var dayMatch = matcher.group__I__T(2);
      var hourMatch = matcher.group__I__T(4);
      var minuteMatch = matcher.group__I__T(5);
      var secondMatch = matcher.group__I__T(6);
      var fractionMatch = matcher.group__I__T(7);
      if (((((dayMatch !== null) || (hourMatch !== null)) || (minuteMatch !== null)) || (secondMatch !== null))) {
        var t = $p_Ljava_time_Duration$__parseNumber__jl_CharSequence__T__I__T__J(this, text, dayMatch, $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I(), "days");
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var t$1 = $p_Ljava_time_Duration$__parseNumber__jl_CharSequence__T__I__T__J(this, text, hourMatch, $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I(), "hours");
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var t$2 = $p_Ljava_time_Duration$__parseNumber__jl_CharSequence__T__I__T__J(this, text, minuteMatch, $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I(), "minutes");
        var lo$2 = t$2.RTLong__f_lo;
        var hi$2 = t$2.RTLong__f_hi;
        var t$3 = $p_Ljava_time_Duration$__parseNumber__jl_CharSequence__T__I__T__J(this, text, secondMatch, 1, "seconds");
        var lo$3 = t$3.RTLong__f_lo;
        var hi$3 = t$3.RTLong__f_hi;
        if ((secondMatch !== null)) {
          var this$4 = $n(secondMatch);
          var negativeSecs = ($charAt(this$4, 0) === 45)
        } else {
          var negativeSecs = false
        };
        var nanos = $p_Ljava_time_Duration$__parseFraction__jl_CharSequence__T__I__I(this, text, fractionMatch, (negativeSecs ? (-1) : 1));
        try {
          return $p_Ljava_time_Duration$__create__Z__J__J__J__J__I__Ljava_time_Duration(this, negate, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1), new $c_RTLong(lo$2, hi$2), new $c_RTLong(lo$3, hi$3), nanos)
        } catch (e) {
          if ((e instanceof $c_jl_ArithmeticException)) {
            var ex = $as_jl_ArithmeticException(e);
            throw new $c_Ljava_time_format_DateTimeParseException("Text cannot be parsed to a Duration: overflow", text, 0, ex)
          } else {
            throw e
          }
        }
      }
    }
  };
  throw new $c_Ljava_time_format_DateTimeParseException("Text cannot be parsed to a Duration", text, 0, null)
});
$c_Ljava_time_Duration$.prototype.java$time$Duration$$create__J__I__Ljava_time_Duration = (function(seconds, nanoAdjustment) {
  var hi = (nanoAdjustment >> 31);
  var lo = (seconds.RTLong__f_lo | nanoAdjustment);
  var hi$1 = (seconds.RTLong__f_hi | hi);
  if (((lo === 0) && (hi$1 === 0))) {
    return this.ZERO__Ljava_time_Duration()
  } else {
    return new $c_Ljava_time_Duration(seconds, nanoAdjustment)
  }
});
$c_Ljava_time_Duration$.prototype.java$time$Duration$$create__Ljava_math_BigDecimal__Ljava_time_Duration = (function(seconds) {
  var nanos = $n($n(seconds).movePointRight__I__Ljava_math_BigDecimal(9)).toBigIntegerExact__Ljava_math_BigInteger();
  var divRem = $n(nanos).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(1000000000, 0)));
  var this$1 = $n($n(divRem).get(0));
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1) > 63)) {
    throw new $c_jl_ArithmeticException(("Exceeds capacity of Duration: " + nanos))
  };
  return this.ofSeconds__J__J__Ljava_time_Duration($n($n(divRem).get(0)).longValue__J(), $n($n(divRem).get(1)).longValue__J())
});
var $d_Ljava_time_Duration$ = new $TypeData().initClass({
  Ljava_time_Duration$: 0
}, false, "java.time.Duration$", {
  Ljava_time_Duration$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Duration$.prototype.$classData = $d_Ljava_time_Duration$;
var $n_Ljava_time_Duration$;
function $m_Ljava_time_Duration$() {
  if ((!$n_Ljava_time_Duration$)) {
    $n_Ljava_time_Duration$ = new $c_Ljava_time_Duration$()
  };
  return $n_Ljava_time_Duration$
}
function $p_Ljava_time_Instant$__EPOCH$lzycompute__Ljava_time_Instant($thiz) {
  if (((((1 & $thiz.Ljava_time_Instant$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_Instant$__f_EPOCH = new $c_Ljava_time_Instant($L0, 0);
    $thiz.Ljava_time_Instant$__f_bitmap$0 = (((1 | $thiz.Ljava_time_Instant$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_Instant$__f_EPOCH
}
/** @constructor */
function $c_Ljava_time_Instant$() {
  this.Ljava_time_Instant$__f_EPOCH = null;
  this.Ljava_time_Instant$__f_bitmap$0 = 0
}
$c_Ljava_time_Instant$.prototype = new $h_O();
$c_Ljava_time_Instant$.prototype.constructor = $c_Ljava_time_Instant$;
/** @constructor */
function $h_Ljava_time_Instant$() {
  /*<skip>*/
}
$h_Ljava_time_Instant$.prototype = $c_Ljava_time_Instant$.prototype;
$c_Ljava_time_Instant$.prototype.EPOCH__Ljava_time_Instant = (function() {
  return (((((1 & this.Ljava_time_Instant$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_Instant$__EPOCH$lzycompute__Ljava_time_Instant(this) : this.Ljava_time_Instant$__f_EPOCH)
});
$c_Ljava_time_Instant$.prototype.ofEpochSecond__J__J__Ljava_time_Instant = (function(epochSecond, nanoAdjustment) {
  var t = $m_jl_Math$().floorDiv__J__J__J(nanoAdjustment, new $c_RTLong(1000000000, 0));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $m_jl_Math$().addExact__J__J__J(epochSecond, new $c_RTLong(lo, hi));
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var this$1 = $m_jl_Math$().floorMod__J__J__J(nanoAdjustment, new $c_RTLong(1000000000, 0));
  var nos = this$1.RTLong__f_lo;
  return this.java$time$Instant$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo$1, hi$1), nos)
});
$c_Ljava_time_Instant$.prototype.ofEpochMilli__J__Ljava_time_Instant = (function(epochMilli) {
  var t = $m_jl_Math$().floorDiv__J__J__J(epochMilli, new $c_RTLong(1000, 0));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$1 = $m_jl_Math$().floorMod__J__J__J(epochMilli, new $c_RTLong(1000, 0));
  var mos = this$1.RTLong__f_lo;
  return this.java$time$Instant$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo, hi), Math.imul(1000000, mos))
});
$c_Ljava_time_Instant$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant = (function(temporal) {
  try {
    var t = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var nanoOfSecond = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var $$x2 = $m_Ljava_time_Instant$();
    var $$x1 = new $c_RTLong(lo, hi);
    var hi$1 = (nanoOfSecond >> 31);
    return $n($$x2).ofEpochSecond__J__J__Ljava_time_Instant($$x1, new $c_RTLong(nanoOfSecond, hi$1))
  } catch (e) {
    if ((e instanceof $c_Ljava_time_DateTimeException)) {
      var ex = $as_Ljava_time_DateTimeException(e);
      var this$2 = $n(temporal);
      throw $ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain Instant from TemporalAccessor: " + temporal) + ", type ") + $objectGetClass(this$2).getName__T()), ex)
    } else {
      throw e
    }
  }
});
$c_Ljava_time_Instant$.prototype.java$time$Instant$$create__J__I__Ljava_time_Instant = (function(seconds, nanoOfSecond) {
  var hi = (nanoOfSecond >> 31);
  var lo = (seconds.RTLong__f_lo | nanoOfSecond);
  var hi$1 = (seconds.RTLong__f_hi | hi);
  if (((lo === 0) && (hi$1 === 0))) {
    return this.EPOCH__Ljava_time_Instant()
  } else {
    var ahi = seconds.RTLong__f_hi;
    if (((ahi === (-7347440)) ? (((-2147483648) ^ seconds.RTLong__f_lo) < (-1805380608)) : (ahi < (-7347440)))) {
      var $$x1 = true
    } else {
      var ahi$1 = seconds.RTLong__f_hi;
      var $$x1 = ((ahi$1 === 7347410) ? (((-2147483648) ^ seconds.RTLong__f_lo) > 2056616191) : (ahi$1 > 7347410))
    };
    if ($$x1) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Instant exceeds minimum or maximum instant")
    } else {
      return new $c_Ljava_time_Instant(seconds, nanoOfSecond)
    }
  }
});
var $d_Ljava_time_Instant$ = new $TypeData().initClass({
  Ljava_time_Instant$: 0
}, false, "java.time.Instant$", {
  Ljava_time_Instant$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Instant$.prototype.$classData = $d_Ljava_time_Instant$;
var $n_Ljava_time_Instant$;
function $m_Ljava_time_Instant$() {
  if ((!$n_Ljava_time_Instant$)) {
    $n_Ljava_time_Instant$ = new $c_Ljava_time_Instant$()
  };
  return $n_Ljava_time_Instant$
}
/** @constructor */
function $c_Ljava_time_Instant$$anon$1() {
  /*<skip>*/
}
$c_Ljava_time_Instant$$anon$1.prototype = new $h_O();
$c_Ljava_time_Instant$$anon$1.prototype.constructor = $c_Ljava_time_Instant$$anon$1;
/** @constructor */
function $h_Ljava_time_Instant$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_Instant$$anon$1.prototype = $c_Ljava_time_Instant$$anon$1.prototype;
$c_Ljava_time_Instant$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(temporal)
});
var $d_Ljava_time_Instant$$anon$1 = new $TypeData().initClass({
  Ljava_time_Instant$$anon$1: 0
}, false, "java.time.Instant$$anon$1", {
  Ljava_time_Instant$$anon$1: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_Instant$$anon$1.prototype.$classData = $d_Ljava_time_Instant$$anon$1;
function $p_Ljava_time_LocalDate$__DAYS_PER_CYCLE__I($thiz) {
  if (((((1 & $thiz.Ljava_time_LocalDate$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalDate.scala: 82")
  };
  return $thiz.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE
}
function $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate($thiz, year, month, dayOfMonth) {
  if ((dayOfMonth > 28)) {
    var $$x2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var hi = (year >> 31);
    var $$x1 = (dayOfMonth > $n(month).length__Z__I($n($$x2).isLeapYear__J__Z(new $c_RTLong(year, hi))))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    if ((dayOfMonth === 29)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Invalid date 'February 29' as '" + year) + "' is not a leap year"))
    } else {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (((("Invalid date '" + $n(month).jl_Enum__f__name) + " ") + dayOfMonth) + "'"))
    }
  } else {
    return new $c_Ljava_time_LocalDate(year, $n(month).getValue__I(), dayOfMonth)
  }
}
/** @constructor */
function $c_Ljava_time_LocalDate$() {
  this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE = 0;
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970 = $L0;
  this.Ljava_time_LocalDate$__f_bitmap$init$0 = 0;
  $n_Ljava_time_LocalDate$ = this;
  this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE = 146097;
  this.Ljava_time_LocalDate$__f_bitmap$init$0 = (((1 | this.Ljava_time_LocalDate$__f_bitmap$init$0) << 24) >> 24);
  var value = $p_Ljava_time_LocalDate$__DAYS_PER_CYCLE__I(this);
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(5, b0);
  var a0b1 = Math.imul(5, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(5, hi) + ((c1part >>> 16) | 0)) | 0);
  var lo$1 = (((-10957) + lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$1) < 2147472691) ? hi$1 : (((-1) + hi$1) | 0));
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970 = new $c_RTLong(lo$1, hi$2);
  this.Ljava_time_LocalDate$__f_bitmap$init$0 = (((2 | this.Ljava_time_LocalDate$__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_LocalDate$.prototype = new $h_O();
$c_Ljava_time_LocalDate$.prototype.constructor = $c_Ljava_time_LocalDate$;
/** @constructor */
function $h_Ljava_time_LocalDate$() {
  /*<skip>*/
}
$h_Ljava_time_LocalDate$.prototype = $c_Ljava_time_LocalDate$.prototype;
$c_Ljava_time_LocalDate$.prototype.DAYS_0000_TO_1970__J = (function() {
  if (((((2 & this.Ljava_time_LocalDate$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalDate.scala: 88")
  };
  return this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970
});
$c_Ljava_time_LocalDate$.prototype.now__Ljava_time_Clock__Ljava_time_LocalDate = (function(clock) {
  if ((clock === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "clock")
  };
  $n(clock);
  var $$x1 = $m_Ljava_time_Instant$();
  var this$4 = $m_RTLong$();
  var value = $uD(new Date().getTime());
  var lo = this$4.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var now = $n($$x1).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
  var this$5 = $n(clock);
  var offset = $n($n(this$5.Ljava_time_Clock$SystemClock__f_zone).getRules__Ljava_time_zone_ZoneRules()).getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(now);
  var this$6 = $n(now);
  var this$9 = this$6.Ljava_time_Instant__f_seconds;
  var this$7 = $n(offset);
  var value$1 = this$7.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$1 = (value$1 >> 31);
  var alo = this$9.RTLong__f_lo;
  var ahi = this$9.RTLong__f_hi;
  var lo$1 = ((alo + value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$1) | 0)) | 0) : ((ahi + hi$1) | 0));
  var value$2 = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
  var hi$3 = (value$2 >> 31);
  var t = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo$1, hi$2), new $c_RTLong(value$2, hi$3));
  var lo$2 = t.RTLong__f_lo;
  var hi$4 = t.RTLong__f_hi;
  return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo$2, hi$4))
});
$c_Ljava_time_LocalDate$.prototype.of__I__Ljava_time_Month__I__Ljava_time_LocalDate = (function(year, month, dayOfMonth) {
  var this$2 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  var hi = (year >> 31);
  $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
  if ((month === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "month")
  };
  var this$5 = $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
  var hi$1 = (dayOfMonth >> 31);
  $n(this$5.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(dayOfMonth, hi$1), this$5);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, month, dayOfMonth)
});
$c_Ljava_time_LocalDate$.prototype.of__I__I__I__Ljava_time_LocalDate = (function(year, month, dayOfMonth) {
  var this$2 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  var hi = (year >> 31);
  $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
  var this$4 = $n($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
  var hi$1 = (month >> 31);
  $n(this$4.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(month, hi$1), this$4);
  var this$6 = $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
  var hi$2 = (dayOfMonth >> 31);
  $n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(dayOfMonth, hi$2), this$6);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, $m_Ljava_time_Month$().of__I__Ljava_time_Month(month), dayOfMonth)
});
$c_Ljava_time_LocalDate$.prototype.ofYearDay__I__I__Ljava_time_LocalDate = (function(year, dayOfYear) {
  var this$2 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  var hi = (year >> 31);
  $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
  var this$4 = $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
  var hi$1 = (dayOfYear >> 31);
  $n(this$4.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(dayOfYear, hi$1), this$4);
  var $$x1 = $n($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
  var hi$2 = (year >> 31);
  var leap = $n($$x1).isLeapYear__J__Z(new $c_RTLong(year, hi$2));
  if (((dayOfYear === 366) && (!leap))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Invalid date 'DayOfYear 366' as '" + year) + "' is not a leap year"))
  };
  var moy = $m_Ljava_time_Month$().of__I__Ljava_time_Month(((1 + (((((-1) + dayOfYear) | 0) / 31) | 0)) | 0));
  var monthEnd = (((-1) + (($n(moy).firstDayOfYear__Z__I(leap) + $n(moy).length__Z__I(leap)) | 0)) | 0);
  if ((dayOfYear > monthEnd)) {
    moy = $n(moy).plus__J__Ljava_time_Month(new $c_RTLong(1, 0))
  };
  var dom = ((1 + ((dayOfYear - $n(moy).firstDayOfYear__Z__I(leap)) | 0)) | 0);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, moy, dom)
});
$c_Ljava_time_LocalDate$.prototype.ofEpochDay__J__Ljava_time_LocalDate = (function(epochDay) {
  var this$1 = $n($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField());
  $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(epochDay, this$1);
  var b = this.DAYS_0000_TO_1970__J();
  var alo = epochDay.RTLong__f_lo;
  var ahi = epochDay.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo + b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  var zeroDay__lo = lo;
  var zeroDay__hi = hi;
  var b$1__lo = zeroDay__lo;
  var b$1__hi = zeroDay__hi;
  var bhi$1 = b$1__hi;
  var lo$1 = (((-60) + b$1__lo) | 0);
  var hi$1 = ((((-2147483648) ^ lo$1) < 2147483588) ? bhi$1 : (((-1) + bhi$1) | 0));
  var $$x1__lo = lo$1;
  var $$x1__hi = hi$1;
  zeroDay__lo = $$x1__lo;
  zeroDay__hi = $$x1__hi;
  var adjust__lo = 0;
  var adjust__hi = 0;
  var this$4__lo = zeroDay__lo;
  var this$4__hi = zeroDay__hi;
  var ahi$1 = this$4__hi;
  if ((ahi$1 < 0)) {
    var b$2__lo = zeroDay__lo;
    var b$2__hi = zeroDay__hi;
    var bhi$2 = b$2__hi;
    var lo$2 = ((1 + b$2__lo) | 0);
    var hi$2 = ((lo$2 === 0) ? ((1 + bhi$2) | 0) : bhi$2);
    var value = $p_Ljava_time_LocalDate$__DAYS_PER_CYCLE__I(this);
    var hi$3 = (value >> 31);
    var this$7 = $m_RTLong$();
    var lo$3 = this$7.divideImpl__I__I__I__I__I(lo$2, hi$2, value, hi$3);
    var hi$4 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$4 = (((-1) + lo$3) | 0);
    var hi$5 = ((lo$4 !== (-1)) ? hi$4 : (((-1) + hi$4) | 0));
    var b0 = (65535 & lo$4);
    var b1 = ((lo$4 >>> 16) | 0);
    var a0b0 = Math.imul(400, b0);
    var a0b1 = Math.imul(400, b1);
    var lo$5 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$6 = ((Math.imul(400, hi$5) + ((c1part >>> 16) | 0)) | 0);
    var $$x2__lo = lo$5;
    var $$x2__hi = hi$6;
    adjust__lo = $$x2__lo;
    adjust__hi = $$x2__hi;
    var this$12__lo = zeroDay__lo;
    var this$12__hi = zeroDay__hi;
    var lo$6 = ((-lo$4) | 0);
    var hi$7 = ((lo$4 !== 0) ? (~hi$5) : ((-hi$5) | 0));
    var value$1 = $p_Ljava_time_LocalDate$__DAYS_PER_CYCLE__I(this);
    var hi$8 = (value$1 >> 31);
    var a0 = (65535 & lo$6);
    var a1 = ((lo$6 >>> 16) | 0);
    var b0$1 = (65535 & value$1);
    var b1$1 = ((value$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0, b0$1);
    var a1b0 = Math.imul(a1, b0$1);
    var a0b1$1 = Math.imul(a0, b1$1);
    var lo$7 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((((((Math.imul(lo$6, hi$8) + Math.imul(hi$7, value$1)) | 0) + Math.imul(a1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
    var alo$1 = this$12__lo;
    var ahi$2 = this$12__hi;
    var lo$8 = ((alo$1 + lo$7) | 0);
    var hi$10 = ((((-2147483648) ^ lo$8) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$2 + hi$9) | 0)) | 0) : ((ahi$2 + hi$9) | 0));
    var $$x3__lo = lo$8;
    var $$x3__hi = hi$10;
    zeroDay__lo = $$x3__lo;
    zeroDay__hi = $$x3__hi
  };
  var b$3__lo = zeroDay__lo;
  var b$3__hi = zeroDay__hi;
  var blo = b$3__lo;
  var b0$2 = (65535 & blo);
  var b1$2 = ((blo >>> 16) | 0);
  var a0b0$2 = Math.imul(400, b0$2);
  var a0b1$2 = Math.imul(400, b1$2);
  var lo$9 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$11 = ((Math.imul(400, b$3__hi) + ((c1part$2 >>> 16) | 0)) | 0);
  var lo$10 = ((591 + lo$9) | 0);
  var hi$12 = ((((-2147483648) ^ lo$10) < (-2147483057)) ? ((1 + hi$11) | 0) : hi$11);
  var value$2 = $p_Ljava_time_LocalDate$__DAYS_PER_CYCLE__I(this);
  var hi$13 = (value$2 >> 31);
  var this$16 = $m_RTLong$();
  var lo$11 = this$16.divideImpl__I__I__I__I__I(lo$10, hi$12, value$2, hi$13);
  var hi$14 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var yearEst__lo = lo$11;
  var yearEst__hi = hi$14;
  var this$26__lo = zeroDay__lo;
  var this$26__hi = zeroDay__hi;
  var b$4__lo = yearEst__lo;
  var b$4__hi = yearEst__hi;
  var blo$1 = b$4__lo;
  var b0$3 = (65535 & blo$1);
  var b1$3 = ((blo$1 >>> 16) | 0);
  var a0b0$3 = Math.imul(365, b0$3);
  var a0b1$3 = Math.imul(365, b1$3);
  var lo$12 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$15 = ((Math.imul(365, b$4__hi) + ((c1part$3 >>> 16) | 0)) | 0);
  var this$17__lo = yearEst__lo;
  var this$17__hi = yearEst__hi;
  var this$18 = $m_RTLong$();
  var lo$13 = this$18.divideImpl__I__I__I__I__I(this$17__lo, this$17__hi, 4, 0);
  var hi$16 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$14 = ((lo$12 + lo$13) | 0);
  var hi$17 = ((((-2147483648) ^ lo$14) < ((-2147483648) ^ lo$12)) ? ((1 + ((hi$15 + hi$16) | 0)) | 0) : ((hi$15 + hi$16) | 0));
  var this$20__lo = yearEst__lo;
  var this$20__hi = yearEst__hi;
  var this$21 = $m_RTLong$();
  var lo$15 = this$21.divideImpl__I__I__I__I__I(this$20__lo, this$20__hi, 100, 0);
  var hi$18 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$16 = ((lo$14 - lo$15) | 0);
  var hi$19 = ((((-2147483648) ^ lo$16) > ((-2147483648) ^ lo$14)) ? (((-1) + ((hi$17 - hi$18) | 0)) | 0) : ((hi$17 - hi$18) | 0));
  var this$23__lo = yearEst__lo;
  var this$23__hi = yearEst__hi;
  var this$24 = $m_RTLong$();
  var lo$17 = this$24.divideImpl__I__I__I__I__I(this$23__lo, this$23__hi, 400, 0);
  var hi$20 = this$24.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$18 = ((lo$16 + lo$17) | 0);
  var hi$21 = ((((-2147483648) ^ lo$18) < ((-2147483648) ^ lo$16)) ? ((1 + ((hi$19 + hi$20) | 0)) | 0) : ((hi$19 + hi$20) | 0));
  var alo$2 = this$26__lo;
  var ahi$3 = this$26__hi;
  var lo$19 = ((alo$2 - lo$18) | 0);
  var hi$22 = ((((-2147483648) ^ lo$19) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$3 - hi$21) | 0)) | 0) : ((ahi$3 - hi$21) | 0));
  var doyEst__lo = lo$19;
  var doyEst__hi = hi$22;
  var this$28__lo = doyEst__lo;
  var this$28__hi = doyEst__hi;
  var ahi$4 = this$28__hi;
  if ((ahi$4 < 0)) {
    var b$5__lo = yearEst__lo;
    var b$5__hi = yearEst__hi;
    var bhi$3 = b$5__hi;
    var lo$20 = (((-1) + b$5__lo) | 0);
    var hi$23 = ((lo$20 !== (-1)) ? bhi$3 : (((-1) + bhi$3) | 0));
    var $$x4__lo = lo$20;
    var $$x4__hi = hi$23;
    yearEst__lo = $$x4__lo;
    yearEst__hi = $$x4__hi;
    var this$39__lo = zeroDay__lo;
    var this$39__hi = zeroDay__hi;
    var b$6__lo = yearEst__lo;
    var b$6__hi = yearEst__hi;
    var blo$2 = b$6__lo;
    var b0$4 = (65535 & blo$2);
    var b1$4 = ((blo$2 >>> 16) | 0);
    var a0b0$4 = Math.imul(365, b0$4);
    var a0b1$4 = Math.imul(365, b1$4);
    var lo$21 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$24 = ((Math.imul(365, b$6__hi) + ((c1part$4 >>> 16) | 0)) | 0);
    var this$30__lo = yearEst__lo;
    var this$30__hi = yearEst__hi;
    var this$31 = $m_RTLong$();
    var lo$22 = this$31.divideImpl__I__I__I__I__I(this$30__lo, this$30__hi, 4, 0);
    var hi$25 = this$31.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$23 = ((lo$21 + lo$22) | 0);
    var hi$26 = ((((-2147483648) ^ lo$23) < ((-2147483648) ^ lo$21)) ? ((1 + ((hi$24 + hi$25) | 0)) | 0) : ((hi$24 + hi$25) | 0));
    var this$33__lo = yearEst__lo;
    var this$33__hi = yearEst__hi;
    var this$34 = $m_RTLong$();
    var lo$24 = this$34.divideImpl__I__I__I__I__I(this$33__lo, this$33__hi, 100, 0);
    var hi$27 = this$34.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$25 = ((lo$23 - lo$24) | 0);
    var hi$28 = ((((-2147483648) ^ lo$25) > ((-2147483648) ^ lo$23)) ? (((-1) + ((hi$26 - hi$27) | 0)) | 0) : ((hi$26 - hi$27) | 0));
    var this$36__lo = yearEst__lo;
    var this$36__hi = yearEst__hi;
    var this$37 = $m_RTLong$();
    var lo$26 = this$37.divideImpl__I__I__I__I__I(this$36__lo, this$36__hi, 400, 0);
    var hi$29 = this$37.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$27 = ((lo$25 + lo$26) | 0);
    var hi$30 = ((((-2147483648) ^ lo$27) < ((-2147483648) ^ lo$25)) ? ((1 + ((hi$28 + hi$29) | 0)) | 0) : ((hi$28 + hi$29) | 0));
    var alo$3 = this$39__lo;
    var ahi$5 = this$39__hi;
    var lo$28 = ((alo$3 - lo$27) | 0);
    var hi$31 = ((((-2147483648) ^ lo$28) > ((-2147483648) ^ alo$3)) ? (((-1) + ((ahi$5 - hi$30) | 0)) | 0) : ((ahi$5 - hi$30) | 0));
    var $$x5__lo = lo$28;
    var $$x5__hi = hi$31;
    doyEst__lo = $$x5__lo;
    doyEst__hi = $$x5__hi
  };
  var this$41__lo = yearEst__lo;
  var this$41__hi = yearEst__hi;
  var b$7__lo = adjust__lo;
  var b$7__hi = adjust__hi;
  var alo$4 = this$41__lo;
  var ahi$6 = this$41__hi;
  var bhi$4 = b$7__hi;
  var lo$29 = ((alo$4 + b$7__lo) | 0);
  var hi$32 = ((((-2147483648) ^ lo$29) < ((-2147483648) ^ alo$4)) ? ((1 + ((ahi$6 + bhi$4) | 0)) | 0) : ((ahi$6 + bhi$4) | 0));
  var $$x6__lo = lo$29;
  var $$x6__hi = hi$32;
  yearEst__lo = $$x6__lo;
  yearEst__hi = $$x6__hi;
  var this$43__lo = doyEst__lo;
  var this$43__hi = doyEst__hi;
  var marchDoy0 = this$43__lo;
  var marchMonth0 = ((((2 + Math.imul(5, marchDoy0)) | 0) / 153) | 0);
  var month = ((1 + ((((2 + marchMonth0) | 0) % 12) | 0)) | 0);
  var dom = ((1 + ((marchDoy0 - ((((5 + Math.imul(306, marchMonth0)) | 0) / 10) | 0)) | 0)) | 0);
  var this$45__lo = yearEst__lo;
  var this$45__hi = yearEst__hi;
  var value$3 = ((marchMonth0 / 10) | 0);
  var hi$33 = (value$3 >> 31);
  var alo$5 = this$45__lo;
  var ahi$7 = this$45__hi;
  var lo$30 = ((alo$5 + value$3) | 0);
  var hi$34 = ((((-2147483648) ^ lo$30) < ((-2147483648) ^ alo$5)) ? ((1 + ((ahi$7 + hi$33) | 0)) | 0) : ((ahi$7 + hi$33) | 0));
  var $$x7__lo = lo$30;
  var $$x7__hi = hi$34;
  yearEst__lo = $$x7__lo;
  yearEst__hi = $$x7__hi;
  var this$47 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  var value$4__lo = yearEst__lo;
  var value$4__hi = yearEst__hi;
  var year = $n(this$47.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(value$4__lo, value$4__hi), this$47);
  return new $c_Ljava_time_LocalDate(year, month, dom)
});
$c_Ljava_time_LocalDate$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate = (function(temporal) {
  var date = $as_Ljava_time_LocalDate($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()));
  if ((date === null)) {
    var this$1 = $n(temporal);
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalDate from TemporalAccessor: " + temporal) + ", type ") + $objectGetClass(this$1).getName__T()))
  };
  return date
});
$c_Ljava_time_LocalDate$.prototype.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_LocalDate = (function(text, formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter")
  };
  return $as_Ljava_time_LocalDate($n(formatter).parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O(text, new $c_Ljava_time_LocalDate$$anon$1()))
});
$c_Ljava_time_LocalDate$.prototype.java$time$LocalDate$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate = (function(year, month, day) {
  switch (month) {
    case 2: {
      var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      var hi = (year >> 31);
      if ($n($$x1).isLeapYear__J__Z(new $c_RTLong(year, hi))) {
        var b = 29
      } else {
        var b = 28
      };
      var _day = ((day < b) ? day : b);
      break
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      var _day = ((day < 30) ? day : 30);
      break
    }
    default: {
      var _day = day
    }
  };
  return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, month, _day)
});
var $d_Ljava_time_LocalDate$ = new $TypeData().initClass({
  Ljava_time_LocalDate$: 0
}, false, "java.time.LocalDate$", {
  Ljava_time_LocalDate$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_LocalDate$.prototype.$classData = $d_Ljava_time_LocalDate$;
var $n_Ljava_time_LocalDate$;
function $m_Ljava_time_LocalDate$() {
  if ((!$n_Ljava_time_LocalDate$)) {
    $n_Ljava_time_LocalDate$ = new $c_Ljava_time_LocalDate$()
  };
  return $n_Ljava_time_LocalDate$
}
/** @constructor */
function $c_Ljava_time_LocalDate$$anon$1() {
  /*<skip>*/
}
$c_Ljava_time_LocalDate$$anon$1.prototype = new $h_O();
$c_Ljava_time_LocalDate$$anon$1.prototype.constructor = $c_Ljava_time_LocalDate$$anon$1;
/** @constructor */
function $h_Ljava_time_LocalDate$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_LocalDate$$anon$1.prototype = $c_Ljava_time_LocalDate$$anon$1.prototype;
$c_Ljava_time_LocalDate$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)
});
var $d_Ljava_time_LocalDate$$anon$1 = new $TypeData().initClass({
  Ljava_time_LocalDate$$anon$1: 0
}, false, "java.time.LocalDate$$anon$1", {
  Ljava_time_LocalDate$$anon$1: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_LocalDate$$anon$1.prototype.$classData = $d_Ljava_time_LocalDate$$anon$1;
/** @constructor */
function $c_Ljava_time_LocalDateTime$() {
  /*<skip>*/
}
$c_Ljava_time_LocalDateTime$.prototype = new $h_O();
$c_Ljava_time_LocalDateTime$.prototype.constructor = $c_Ljava_time_LocalDateTime$;
/** @constructor */
function $h_Ljava_time_LocalDateTime$() {
  /*<skip>*/
}
$h_Ljava_time_LocalDateTime$.prototype = $c_Ljava_time_LocalDateTime$.prototype;
$c_Ljava_time_LocalDateTime$.prototype.now__Ljava_time_ZoneId__Ljava_time_LocalDateTime = (function(zone) {
  return this.now__Ljava_time_Clock__Ljava_time_LocalDateTime($m_Ljava_time_Clock$().system__Ljava_time_ZoneId__Ljava_time_Clock(zone))
});
$c_Ljava_time_LocalDateTime$.prototype.now__Ljava_time_Clock__Ljava_time_LocalDateTime = (function(clock) {
  if ((clock === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "clock")
  };
  $n(clock);
  var $$x1 = $m_Ljava_time_Instant$();
  var this$4 = $m_RTLong$();
  var value = $uD(new Date().getTime());
  var lo = this$4.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var now = $n($$x1).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
  var this$5 = $n(clock);
  var offset = $n($n(this$5.Ljava_time_Clock$SystemClock__f_zone).getRules__Ljava_time_zone_ZoneRules()).getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(now);
  var this$6 = $n(now);
  var $$x2 = this$6.Ljava_time_Instant__f_seconds;
  var this$7 = $n(now);
  return this.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime($$x2, this$7.Ljava_time_Instant__f_nanos, offset)
});
$c_Ljava_time_LocalDateTime$.prototype.of__I__I__I__I__I__I__I__Ljava_time_LocalDateTime = (function(year, month, dayOfMonth, hour, minute, second, nanoOfSecond) {
  var date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, month, dayOfMonth);
  var time = $m_Ljava_time_LocalTime$().of__I__I__I__I__Ljava_time_LocalTime(hour, minute, second, nanoOfSecond);
  return new $c_Ljava_time_LocalDateTime(date, time)
});
$c_Ljava_time_LocalDateTime$.prototype.of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime = (function(date, time) {
  if ((date === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "date")
  };
  if ((time === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "time")
  };
  return new $c_Ljava_time_LocalDateTime(date, time)
});
$c_Ljava_time_LocalDateTime$.prototype.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime = (function(epochSecond, nanoOfSecond, offset) {
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  var this$2 = $n(offset);
  var value = this$2.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  var alo = epochSecond.RTLong__f_lo;
  var ahi = epochSecond.RTLong__f_hi;
  var lo = ((alo + value) | 0);
  var hi$1 = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi) | 0)) | 0) : ((ahi + hi) | 0));
  var value$1 = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
  var hi$2 = (value$1 >> 31);
  var t = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo, hi$1), new $c_RTLong(value$1, hi$2));
  var lo$1 = t.RTLong__f_lo;
  var hi$3 = t.RTLong__f_hi;
  var value$2 = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
  var hi$4 = (value$2 >> 31);
  var this$7 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo, hi$1), new $c_RTLong(value$2, hi$4));
  var secsOfDay = this$7.RTLong__f_lo;
  var date = $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$3));
  var $$x1 = $m_Ljava_time_LocalTime$();
  var hi$5 = (secsOfDay >> 31);
  var time = $n($$x1).ofSecondOfDay__J__I__Ljava_time_LocalTime(new $c_RTLong(secsOfDay, hi$5), nanoOfSecond);
  return new $c_Ljava_time_LocalDateTime(date, time)
});
$c_Ljava_time_LocalDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_LocalDateTime)) {
    var x2 = $as_Ljava_time_LocalDateTime(temporal);
    return x2
  } else if ((temporal instanceof $c_Ljava_time_ZonedDateTime)) {
    var x3 = $as_Ljava_time_ZonedDateTime(temporal);
    var this$1 = $n(x3);
    return this$1.Ljava_time_ZonedDateTime__f_dateTime
  } else {
    try {
      var date = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
      var time = $m_Ljava_time_LocalTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(temporal);
      return new $c_Ljava_time_LocalDateTime(date, time)
    } catch (e) {
      if ((e instanceof $c_Ljava_time_DateTimeException)) {
        var this$2 = $n(temporal);
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalDateTime from TemporalAccessor: " + temporal) + ", type ") + $objectGetClass(this$2).getName__T()))
      } else {
        throw e
      }
    }
  }
});
$c_Ljava_time_LocalDateTime$.prototype.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_LocalDateTime = (function(text, formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter")
  };
  return $as_Ljava_time_LocalDateTime($n(formatter).parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O(text, new $c_Ljava_time_LocalDateTime$$anon$1()))
});
var $d_Ljava_time_LocalDateTime$ = new $TypeData().initClass({
  Ljava_time_LocalDateTime$: 0
}, false, "java.time.LocalDateTime$", {
  Ljava_time_LocalDateTime$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_LocalDateTime$.prototype.$classData = $d_Ljava_time_LocalDateTime$;
var $n_Ljava_time_LocalDateTime$;
function $m_Ljava_time_LocalDateTime$() {
  if ((!$n_Ljava_time_LocalDateTime$)) {
    $n_Ljava_time_LocalDateTime$ = new $c_Ljava_time_LocalDateTime$()
  };
  return $n_Ljava_time_LocalDateTime$
}
/** @constructor */
function $c_Ljava_time_LocalDateTime$$anon$1() {
  /*<skip>*/
}
$c_Ljava_time_LocalDateTime$$anon$1.prototype = new $h_O();
$c_Ljava_time_LocalDateTime$$anon$1.prototype.constructor = $c_Ljava_time_LocalDateTime$$anon$1;
/** @constructor */
function $h_Ljava_time_LocalDateTime$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_LocalDateTime$$anon$1.prototype = $c_Ljava_time_LocalDateTime$$anon$1.prototype;
$c_Ljava_time_LocalDateTime$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal)
});
var $d_Ljava_time_LocalDateTime$$anon$1 = new $TypeData().initClass({
  Ljava_time_LocalDateTime$$anon$1: 0
}, false, "java.time.LocalDateTime$$anon$1", {
  Ljava_time_LocalDateTime$$anon$1: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_LocalDateTime$$anon$1.prototype.$classData = $d_Ljava_time_LocalDateTime$$anon$1;
function $p_Ljava_time_LocalTime$__HOURS$lzycompute__ALjava_time_LocalTime($thiz) {
  if (((((1 & $thiz.Ljava_time_LocalTime$__f_bitmap$0) << 24) >> 24) === 0)) {
    var hours = new ($d_Ljava_time_LocalTime.getArrayOf().constr)(24);
    var i = 0;
    while ((i < $n(hours).u.length)) {
      $n(hours).set(i, new $c_Ljava_time_LocalTime(i, 0, 0, 0));
      i = ((1 + i) | 0)
    };
    $thiz.Ljava_time_LocalTime$__f_HOURS = hours;
    $thiz.Ljava_time_LocalTime$__f_bitmap$0 = (((1 | $thiz.Ljava_time_LocalTime$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_LocalTime$__f_HOURS
}
function $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime($thiz) {
  return (((((1 & $thiz.Ljava_time_LocalTime$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_LocalTime$__HOURS$lzycompute__ALjava_time_LocalTime($thiz) : $thiz.Ljava_time_LocalTime$__f_HOURS)
}
function $p_Ljava_time_LocalTime$__MIDNIGHT$lzycompute__Ljava_time_LocalTime($thiz) {
  if (((((8 & $thiz.Ljava_time_LocalTime$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_LocalTime$__f_MIDNIGHT = $n($p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime($thiz)).get(0);
    $thiz.Ljava_time_LocalTime$__f_bitmap$0 = (((8 | $thiz.Ljava_time_LocalTime$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_LocalTime$__f_MIDNIGHT
}
/** @constructor */
function $c_Ljava_time_LocalTime$() {
  this.Ljava_time_LocalTime$__f_HOURS = null;
  this.Ljava_time_LocalTime$__f_MIDNIGHT = null;
  this.Ljava_time_LocalTime$__f_HOURS_PER_DAY = 0;
  this.Ljava_time_LocalTime$__f_MINUTES_PER_HOUR = 0;
  this.Ljava_time_LocalTime$__f_MINUTES_PER_DAY = 0;
  this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE = 0;
  this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR = 0;
  this.Ljava_time_LocalTime$__f_SECONDS_PER_DAY = 0;
  this.Ljava_time_LocalTime$__f_MILLIS_PER_DAY = $L0;
  this.Ljava_time_LocalTime$__f_MICROS_PER_DAY = $L0;
  this.Ljava_time_LocalTime$__f_NANOS_PER_SECOND = $L0;
  this.Ljava_time_LocalTime$__f_NANOS_PER_MINUTE = $L0;
  this.Ljava_time_LocalTime$__f_NANOS_PER_HOUR = $L0;
  this.Ljava_time_LocalTime$__f_NANOS_PER_DAY = $L0;
  this.Ljava_time_LocalTime$__f_bitmap$0 = 0;
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = 0;
  $n_Ljava_time_LocalTime$ = this;
  this.Ljava_time_LocalTime$__f_HOURS_PER_DAY = 24;
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (1 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  this.Ljava_time_LocalTime$__f_MINUTES_PER_HOUR = 60;
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (2 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  this.Ljava_time_LocalTime$__f_MINUTES_PER_DAY = Math.imul(this.MINUTES_PER_HOUR__I(), this.HOURS_PER_DAY__I());
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (4 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE = 60;
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (8 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR = Math.imul(this.SECONDS_PER_MINUTE__I(), this.MINUTES_PER_HOUR__I());
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (16 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  this.Ljava_time_LocalTime$__f_SECONDS_PER_DAY = Math.imul(this.SECONDS_PER_HOUR__I(), this.HOURS_PER_DAY__I());
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (32 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  var value = this.SECONDS_PER_DAY__I();
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(1000, b0);
  var a0b1 = Math.imul(1000, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(1000, hi) + ((c1part >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_MILLIS_PER_DAY = new $c_RTLong(lo, hi$1);
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (64 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  var value$1 = this.SECONDS_PER_DAY__I();
  var hi$2 = (value$1 >> 31);
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(16960, b0$1);
  var a1b0 = Math.imul(15, b0$1);
  var a0b1$1 = Math.imul(16960, b1$1);
  var lo$1 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((((Math.imul(1000000, hi$2) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_MICROS_PER_DAY = new $c_RTLong(lo$1, hi$3);
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (128 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  this.Ljava_time_LocalTime$__f_NANOS_PER_SECOND = new $c_RTLong(1000000000, 0);
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (256 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  var this$4 = this.NANOS_PER_SECOND__J();
  var value$2 = this.SECONDS_PER_MINUTE__I();
  var hi$4 = (value$2 >> 31);
  var alo = this$4.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0$2 = (65535 & value$2);
  var b1$2 = ((value$2 >>> 16) | 0);
  var a0b0$2 = Math.imul(a0, b0$2);
  var a1b0$1 = Math.imul(a1, b0$2);
  var a0b1$2 = Math.imul(a0, b1$2);
  var lo$2 = ((a0b0$2 + (((a1b0$1 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$5 = ((((((((Math.imul(alo, hi$4) + Math.imul(this$4.RTLong__f_hi, value$2)) | 0) + Math.imul(a1, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_NANOS_PER_MINUTE = new $c_RTLong(lo$2, hi$5);
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (512 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  var this$6 = this.NANOS_PER_MINUTE__J();
  var value$3 = this.MINUTES_PER_HOUR__I();
  var hi$6 = (value$3 >> 31);
  var alo$1 = this$6.RTLong__f_lo;
  var a0$1 = (65535 & alo$1);
  var a1$1 = ((alo$1 >>> 16) | 0);
  var b0$3 = (65535 & value$3);
  var b1$3 = ((value$3 >>> 16) | 0);
  var a0b0$3 = Math.imul(a0$1, b0$3);
  var a1b0$2 = Math.imul(a1$1, b0$3);
  var a0b1$3 = Math.imul(a0$1, b1$3);
  var lo$3 = ((a0b0$3 + (((a1b0$2 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((((Math.imul(alo$1, hi$6) + Math.imul(this$6.RTLong__f_hi, value$3)) | 0) + Math.imul(a1$1, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_NANOS_PER_HOUR = new $c_RTLong(lo$3, hi$7);
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (1024 | this.Ljava_time_LocalTime$__f_bitmap$init$0);
  var this$8 = this.NANOS_PER_HOUR__J();
  var value$4 = this.HOURS_PER_DAY__I();
  var hi$8 = (value$4 >> 31);
  var alo$2 = this$8.RTLong__f_lo;
  var a0$2 = (65535 & alo$2);
  var a1$2 = ((alo$2 >>> 16) | 0);
  var b0$4 = (65535 & value$4);
  var b1$4 = ((value$4 >>> 16) | 0);
  var a0b0$4 = Math.imul(a0$2, b0$4);
  var a1b0$3 = Math.imul(a1$2, b0$4);
  var a0b1$4 = Math.imul(a0$2, b1$4);
  var lo$4 = ((a0b0$4 + (((a1b0$3 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$9 = ((((((((Math.imul(alo$2, hi$8) + Math.imul(this$8.RTLong__f_hi, value$4)) | 0) + Math.imul(a1$2, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  this.Ljava_time_LocalTime$__f_NANOS_PER_DAY = new $c_RTLong(lo$4, hi$9);
  this.Ljava_time_LocalTime$__f_bitmap$init$0 = (2048 | this.Ljava_time_LocalTime$__f_bitmap$init$0)
}
$c_Ljava_time_LocalTime$.prototype = new $h_O();
$c_Ljava_time_LocalTime$.prototype.constructor = $c_Ljava_time_LocalTime$;
/** @constructor */
function $h_Ljava_time_LocalTime$() {
  /*<skip>*/
}
$h_Ljava_time_LocalTime$.prototype = $c_Ljava_time_LocalTime$.prototype;
$c_Ljava_time_LocalTime$.prototype.MIDNIGHT__Ljava_time_LocalTime = (function() {
  return (((((8 & this.Ljava_time_LocalTime$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_LocalTime$__MIDNIGHT$lzycompute__Ljava_time_LocalTime(this) : this.Ljava_time_LocalTime$__f_MIDNIGHT)
});
$c_Ljava_time_LocalTime$.prototype.HOURS_PER_DAY__I = (function() {
  if (((1 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 88")
  };
  return this.Ljava_time_LocalTime$__f_HOURS_PER_DAY
});
$c_Ljava_time_LocalTime$.prototype.MINUTES_PER_HOUR__I = (function() {
  if (((2 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 91")
  };
  return this.Ljava_time_LocalTime$__f_MINUTES_PER_HOUR
});
$c_Ljava_time_LocalTime$.prototype.MINUTES_PER_DAY__I = (function() {
  if (((4 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 94")
  };
  return this.Ljava_time_LocalTime$__f_MINUTES_PER_DAY
});
$c_Ljava_time_LocalTime$.prototype.SECONDS_PER_MINUTE__I = (function() {
  if (((8 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 97")
  };
  return this.Ljava_time_LocalTime$__f_SECONDS_PER_MINUTE
});
$c_Ljava_time_LocalTime$.prototype.SECONDS_PER_HOUR__I = (function() {
  if (((16 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 100")
  };
  return this.Ljava_time_LocalTime$__f_SECONDS_PER_HOUR
});
$c_Ljava_time_LocalTime$.prototype.SECONDS_PER_DAY__I = (function() {
  if (((32 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 103")
  };
  return this.Ljava_time_LocalTime$__f_SECONDS_PER_DAY
});
$c_Ljava_time_LocalTime$.prototype.MILLIS_PER_DAY__J = (function() {
  if (((64 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 106")
  };
  return this.Ljava_time_LocalTime$__f_MILLIS_PER_DAY
});
$c_Ljava_time_LocalTime$.prototype.MICROS_PER_DAY__J = (function() {
  if (((128 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 109")
  };
  return this.Ljava_time_LocalTime$__f_MICROS_PER_DAY
});
$c_Ljava_time_LocalTime$.prototype.NANOS_PER_SECOND__J = (function() {
  if (((256 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 112")
  };
  return this.Ljava_time_LocalTime$__f_NANOS_PER_SECOND
});
$c_Ljava_time_LocalTime$.prototype.NANOS_PER_MINUTE__J = (function() {
  if (((512 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 115")
  };
  return this.Ljava_time_LocalTime$__f_NANOS_PER_MINUTE
});
$c_Ljava_time_LocalTime$.prototype.NANOS_PER_HOUR__J = (function() {
  if (((1024 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 118")
  };
  return this.Ljava_time_LocalTime$__f_NANOS_PER_HOUR
});
$c_Ljava_time_LocalTime$.prototype.NANOS_PER_DAY__J = (function() {
  if (((2048 & this.Ljava_time_LocalTime$__f_bitmap$init$0) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 121")
  };
  return this.Ljava_time_LocalTime$__f_NANOS_PER_DAY
});
$c_Ljava_time_LocalTime$.prototype.now__Ljava_time_Clock__Ljava_time_LocalTime = (function(clock) {
  if ((clock === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "clock")
  };
  $n(clock);
  var $$x1 = $m_Ljava_time_Instant$();
  var this$4 = $m_RTLong$();
  var value = $uD(new Date().getTime());
  var lo = this$4.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var now = $n($$x1).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
  var this$5 = $n(clock);
  var offset = $n($n(this$5.Ljava_time_Clock$SystemClock__f_zone).getRules__Ljava_time_zone_ZoneRules()).getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(now);
  var this$6 = $n(now);
  var this$8 = this$6.Ljava_time_Instant__f_seconds;
  var value$1 = this.SECONDS_PER_DAY__I();
  var hi$1 = (value$1 >> 31);
  var this$9 = $m_RTLong$();
  var lo$1 = this$9.remainderImpl__I__I__I__I__I(this$8.RTLong__f_lo, this$8.RTLong__f_hi, value$1, hi$1);
  var hi$2 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var secsOfDay__lo = lo$1;
  var secsOfDay__hi = hi$2;
  var this$12__lo = secsOfDay__lo;
  var this$12__hi = secsOfDay__hi;
  var this$10 = $n(offset);
  var value$2 = this$10.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$3 = (value$2 >> 31);
  var alo = this$12__lo;
  var ahi = this$12__hi;
  var lo$2 = ((alo + value$2) | 0);
  var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$3) | 0)) | 0) : ((ahi + hi$3) | 0));
  var value$3 = this.SECONDS_PER_DAY__I();
  var hi$5 = (value$3 >> 31);
  var this$15 = $m_RTLong$();
  var lo$3 = this$15.remainderImpl__I__I__I__I__I(lo$2, hi$4, value$3, hi$5);
  var hi$6 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var $$x2__lo = lo$3;
  var $$x2__hi = hi$6;
  secsOfDay__lo = $$x2__lo;
  secsOfDay__hi = $$x2__hi;
  var this$16__lo = secsOfDay__lo;
  var this$16__hi = secsOfDay__hi;
  var ahi$1 = this$16__hi;
  if ((ahi$1 < 0)) {
    var this$18__lo = secsOfDay__lo;
    var this$18__hi = secsOfDay__hi;
    var value$4 = this.SECONDS_PER_DAY__I();
    var hi$7 = (value$4 >> 31);
    var alo$1 = this$18__lo;
    var ahi$2 = this$18__hi;
    var lo$4 = ((alo$1 + value$4) | 0);
    var hi$8 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$2 + hi$7) | 0)) | 0) : ((ahi$2 + hi$7) | 0));
    var $$x3__lo = lo$4;
    var $$x3__hi = hi$8;
    secsOfDay__lo = $$x3__lo;
    secsOfDay__hi = $$x3__hi
  };
  var $$x5 = $m_Ljava_time_LocalTime$();
  var $$x4 = new $c_RTLong(secsOfDay__lo, secsOfDay__hi);
  var this$20 = $n(now);
  return $n($$x5).ofSecondOfDay__J__I__Ljava_time_LocalTime($$x4, this$20.Ljava_time_Instant__f_nanos)
});
$c_Ljava_time_LocalTime$.prototype.of__I__I__Ljava_time_LocalTime = (function(hour, minute) {
  var this$2 = $n($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  var hi = (hour >> 31);
  $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
  if ((minute === 0)) {
    return $n($p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this)).get(hour)
  } else {
    var this$4 = $n($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
    var hi$1 = (minute >> 31);
    $n(this$4.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi$1), this$4);
    return new $c_Ljava_time_LocalTime(hour, minute, 0, 0)
  }
});
$c_Ljava_time_LocalTime$.prototype.of__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second) {
  var this$2 = $n($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  var hi = (hour >> 31);
  $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
  if (((minute | second) === 0)) {
    return $n($p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this)).get(hour)
  };
  var this$4 = $n($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  var hi$1 = (minute >> 31);
  $n(this$4.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi$1), this$4);
  var this$6 = $n($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  var hi$2 = (second >> 31);
  $n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(second, hi$2), this$6);
  return new $c_Ljava_time_LocalTime(hour, minute, second, 0)
});
$c_Ljava_time_LocalTime$.prototype.of__I__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second, nanoOfSecond) {
  var this$2 = $n($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  var hi = (hour >> 31);
  $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
  var this$4 = $n($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  var hi$1 = (minute >> 31);
  $n(this$4.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi$1), this$4);
  var this$6 = $n($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  var hi$2 = (second >> 31);
  $n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(second, hi$2), this$6);
  var this$8 = $n($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  var hi$3 = (nanoOfSecond >> 31);
  $n(this$8.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(nanoOfSecond, hi$3), this$8);
  return this.java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime(hour, minute, second, nanoOfSecond)
});
$c_Ljava_time_LocalTime$.prototype.ofSecondOfDay__J__Ljava_time_LocalTime = (function(secondOfDay) {
  var lo = secondOfDay.RTLong__f_lo;
  var hi = secondOfDay.RTLong__f_hi;
  var _secondOfDay__lo = lo;
  var _secondOfDay__hi = hi;
  var this$1 = $n($m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField());
  var value__lo = _secondOfDay__lo;
  var value__hi = _secondOfDay__hi;
  $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value__lo, value__hi), this$1);
  var this$3__lo = _secondOfDay__lo;
  var this$3__hi = _secondOfDay__hi;
  var value$1 = this.SECONDS_PER_HOUR__I();
  var hi$1 = (value$1 >> 31);
  var this$4 = $m_RTLong$();
  var lo$1 = this$4.divideImpl__I__I__I__I__I(this$3__lo, this$3__hi, value$1, hi$1);
  var this$6__lo = _secondOfDay__lo;
  var this$6__hi = _secondOfDay__hi;
  var value$2 = Math.imul(lo$1, this.SECONDS_PER_HOUR__I());
  var hi$3 = (value$2 >> 31);
  var alo = this$6__lo;
  var ahi = this$6__hi;
  var lo$2 = ((alo - value$2) | 0);
  var hi$4 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$3) | 0)) | 0) : ((ahi - hi$3) | 0));
  var $$x1__lo = lo$2;
  var $$x1__hi = hi$4;
  _secondOfDay__lo = $$x1__lo;
  _secondOfDay__hi = $$x1__hi;
  var this$9__lo = _secondOfDay__lo;
  var this$9__hi = _secondOfDay__hi;
  var value$3 = this.SECONDS_PER_MINUTE__I();
  var hi$5 = (value$3 >> 31);
  var this$10 = $m_RTLong$();
  var lo$3 = this$10.divideImpl__I__I__I__I__I(this$9__lo, this$9__hi, value$3, hi$5);
  var this$12__lo = _secondOfDay__lo;
  var this$12__hi = _secondOfDay__hi;
  var value$4 = Math.imul(lo$3, this.SECONDS_PER_MINUTE__I());
  var hi$7 = (value$4 >> 31);
  var alo$1 = this$12__lo;
  var ahi$1 = this$12__hi;
  var lo$4 = ((alo$1 - value$4) | 0);
  var hi$8 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - hi$7) | 0)) | 0) : ((ahi$1 - hi$7) | 0));
  var $$x2__lo = lo$4;
  var $$x2__hi = hi$8;
  _secondOfDay__lo = $$x2__lo;
  _secondOfDay__hi = $$x2__hi;
  var this$14__lo = _secondOfDay__lo;
  var this$14__hi = _secondOfDay__hi;
  return this.java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime(lo$1, lo$3, this$14__lo, 0)
});
$c_Ljava_time_LocalTime$.prototype.ofSecondOfDay__J__I__Ljava_time_LocalTime = (function(secondOfDay, nanoOfSecond) {
  var lo = secondOfDay.RTLong__f_lo;
  var hi = secondOfDay.RTLong__f_hi;
  var _secondOfDay__lo = lo;
  var _secondOfDay__hi = hi;
  var this$1 = $n($m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField());
  var value__lo = _secondOfDay__lo;
  var value__hi = _secondOfDay__hi;
  $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value__lo, value__hi), this$1);
  var this$3 = $n($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  var hi$1 = (nanoOfSecond >> 31);
  $n(this$3.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(nanoOfSecond, hi$1), this$3);
  var this$5__lo = _secondOfDay__lo;
  var this$5__hi = _secondOfDay__hi;
  var value$1 = this.SECONDS_PER_HOUR__I();
  var hi$2 = (value$1 >> 31);
  var this$6 = $m_RTLong$();
  var lo$1 = this$6.divideImpl__I__I__I__I__I(this$5__lo, this$5__hi, value$1, hi$2);
  var this$8__lo = _secondOfDay__lo;
  var this$8__hi = _secondOfDay__hi;
  var value$2 = Math.imul(lo$1, this.SECONDS_PER_HOUR__I());
  var hi$4 = (value$2 >> 31);
  var alo = this$8__lo;
  var ahi = this$8__hi;
  var lo$2 = ((alo - value$2) | 0);
  var hi$5 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$4) | 0)) | 0) : ((ahi - hi$4) | 0));
  var $$x1__lo = lo$2;
  var $$x1__hi = hi$5;
  _secondOfDay__lo = $$x1__lo;
  _secondOfDay__hi = $$x1__hi;
  var this$11__lo = _secondOfDay__lo;
  var this$11__hi = _secondOfDay__hi;
  var value$3 = this.SECONDS_PER_MINUTE__I();
  var hi$6 = (value$3 >> 31);
  var this$12 = $m_RTLong$();
  var lo$3 = this$12.divideImpl__I__I__I__I__I(this$11__lo, this$11__hi, value$3, hi$6);
  var this$14__lo = _secondOfDay__lo;
  var this$14__hi = _secondOfDay__hi;
  var value$4 = Math.imul(lo$3, this.SECONDS_PER_MINUTE__I());
  var hi$8 = (value$4 >> 31);
  var alo$1 = this$14__lo;
  var ahi$1 = this$14__hi;
  var lo$4 = ((alo$1 - value$4) | 0);
  var hi$9 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - hi$8) | 0)) | 0) : ((ahi$1 - hi$8) | 0));
  var $$x2__lo = lo$4;
  var $$x2__hi = hi$9;
  _secondOfDay__lo = $$x2__lo;
  _secondOfDay__hi = $$x2__hi;
  var this$16__lo = _secondOfDay__lo;
  var this$16__hi = _secondOfDay__hi;
  return this.java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime(lo$1, lo$3, this$16__lo, nanoOfSecond)
});
$c_Ljava_time_LocalTime$.prototype.ofNanoOfDay__J__Ljava_time_LocalTime = (function(nanoOfDay) {
  var lo = nanoOfDay.RTLong__f_lo;
  var hi = nanoOfDay.RTLong__f_hi;
  var _nanoOfDay__lo = lo;
  var _nanoOfDay__hi = hi;
  var this$1 = $n($m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField());
  var value__lo = _nanoOfDay__lo;
  var value__hi = _nanoOfDay__hi;
  $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value__lo, value__hi), this$1);
  var this$2__lo = _nanoOfDay__lo;
  var this$2__hi = _nanoOfDay__hi;
  var b = this.NANOS_PER_HOUR__J();
  var this$3 = $m_RTLong$();
  var lo$1 = this$3.divideImpl__I__I__I__I__I(this$2__lo, this$2__hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var this$5__lo = _nanoOfDay__lo;
  var this$5__hi = _nanoOfDay__hi;
  var hi$2 = (lo$1 >> 31);
  var b$1 = this.NANOS_PER_HOUR__J();
  var blo = b$1.RTLong__f_lo;
  var a0 = (65535 & lo$1);
  var a1 = ((lo$1 >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$3 = ((((((((Math.imul(lo$1, b$1.RTLong__f_hi) + Math.imul(hi$2, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var alo = this$5__lo;
  var ahi = this$5__hi;
  var lo$3 = ((alo - lo$2) | 0);
  var hi$4 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$3) | 0)) | 0) : ((ahi - hi$3) | 0));
  var $$x1__lo = lo$3;
  var $$x1__hi = hi$4;
  _nanoOfDay__lo = $$x1__lo;
  _nanoOfDay__hi = $$x1__hi;
  var this$7__lo = _nanoOfDay__lo;
  var this$7__hi = _nanoOfDay__hi;
  var b$2 = this.NANOS_PER_MINUTE__J();
  var this$8 = $m_RTLong$();
  var lo$4 = this$8.divideImpl__I__I__I__I__I(this$7__lo, this$7__hi, b$2.RTLong__f_lo, b$2.RTLong__f_hi);
  var this$10__lo = _nanoOfDay__lo;
  var this$10__hi = _nanoOfDay__hi;
  var hi$6 = (lo$4 >> 31);
  var b$3 = this.NANOS_PER_MINUTE__J();
  var blo$1 = b$3.RTLong__f_lo;
  var a0$1 = (65535 & lo$4);
  var a1$1 = ((lo$4 >>> 16) | 0);
  var b0$1 = (65535 & blo$1);
  var b1$1 = ((blo$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(a0$1, b0$1);
  var a1b0$1 = Math.imul(a1$1, b0$1);
  var a0b1$1 = Math.imul(a0$1, b1$1);
  var lo$5 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$7 = ((((((((Math.imul(lo$4, b$3.RTLong__f_hi) + Math.imul(hi$6, blo$1)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var alo$1 = this$10__lo;
  var ahi$1 = this$10__hi;
  var lo$6 = ((alo$1 - lo$5) | 0);
  var hi$8 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - hi$7) | 0)) | 0) : ((ahi$1 - hi$7) | 0));
  var $$x2__lo = lo$6;
  var $$x2__hi = hi$8;
  _nanoOfDay__lo = $$x2__lo;
  _nanoOfDay__hi = $$x2__hi;
  var this$12__lo = _nanoOfDay__lo;
  var this$12__hi = _nanoOfDay__hi;
  var b$4 = this.NANOS_PER_SECOND__J();
  var this$13 = $m_RTLong$();
  var lo$7 = this$13.divideImpl__I__I__I__I__I(this$12__lo, this$12__hi, b$4.RTLong__f_lo, b$4.RTLong__f_hi);
  var this$15__lo = _nanoOfDay__lo;
  var this$15__hi = _nanoOfDay__hi;
  var hi$10 = (lo$7 >> 31);
  var b$5 = this.NANOS_PER_SECOND__J();
  var blo$2 = b$5.RTLong__f_lo;
  var a0$2 = (65535 & lo$7);
  var a1$2 = ((lo$7 >>> 16) | 0);
  var b0$2 = (65535 & blo$2);
  var b1$2 = ((blo$2 >>> 16) | 0);
  var a0b0$2 = Math.imul(a0$2, b0$2);
  var a1b0$2 = Math.imul(a1$2, b0$2);
  var a0b1$2 = Math.imul(a0$2, b1$2);
  var lo$8 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$11 = ((((((((Math.imul(lo$7, b$5.RTLong__f_hi) + Math.imul(hi$10, blo$2)) | 0) + Math.imul(a1$2, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var alo$2 = this$15__lo;
  var ahi$2 = this$15__hi;
  var lo$9 = ((alo$2 - lo$8) | 0);
  var hi$12 = ((((-2147483648) ^ lo$9) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$2 - hi$11) | 0)) | 0) : ((ahi$2 - hi$11) | 0));
  var $$x3__lo = lo$9;
  var $$x3__hi = hi$12;
  _nanoOfDay__lo = $$x3__lo;
  _nanoOfDay__hi = $$x3__hi;
  var this$17__lo = _nanoOfDay__lo;
  var this$17__hi = _nanoOfDay__hi;
  return this.java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime(lo$1, lo$4, lo$7, this$17__lo)
});
$c_Ljava_time_LocalTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime = (function(temporal) {
  var time = $as_Ljava_time_LocalTime($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery()));
  if ((time === null)) {
    var this$1 = $n(temporal);
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalTime from TemporalAccessor: " + temporal) + ", type ") + $objectGetClass(this$1).getName__T()))
  } else {
    return time
  }
});
$c_Ljava_time_LocalTime$.prototype.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_LocalTime = (function(text, formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter")
  };
  return $as_Ljava_time_LocalTime($n(formatter).parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O(text, new $c_Ljava_time_LocalTime$$anon$1()))
});
$c_Ljava_time_LocalTime$.prototype.java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second, nanoOfSecond) {
  return ((((minute | second) | nanoOfSecond) === 0) ? $n($p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this)).get(hour) : new $c_Ljava_time_LocalTime(hour, minute, second, nanoOfSecond))
});
var $d_Ljava_time_LocalTime$ = new $TypeData().initClass({
  Ljava_time_LocalTime$: 0
}, false, "java.time.LocalTime$", {
  Ljava_time_LocalTime$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_LocalTime$.prototype.$classData = $d_Ljava_time_LocalTime$;
var $n_Ljava_time_LocalTime$;
function $m_Ljava_time_LocalTime$() {
  if ((!$n_Ljava_time_LocalTime$)) {
    $n_Ljava_time_LocalTime$ = new $c_Ljava_time_LocalTime$()
  };
  return $n_Ljava_time_LocalTime$
}
/** @constructor */
function $c_Ljava_time_LocalTime$$anon$1() {
  /*<skip>*/
}
$c_Ljava_time_LocalTime$$anon$1.prototype = new $h_O();
$c_Ljava_time_LocalTime$$anon$1.prototype.constructor = $c_Ljava_time_LocalTime$$anon$1;
/** @constructor */
function $h_Ljava_time_LocalTime$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_LocalTime$$anon$1.prototype = $c_Ljava_time_LocalTime$$anon$1.prototype;
$c_Ljava_time_LocalTime$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $m_Ljava_time_LocalTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(temporal)
});
var $d_Ljava_time_LocalTime$$anon$1 = new $TypeData().initClass({
  Ljava_time_LocalTime$$anon$1: 0
}, false, "java.time.LocalTime$$anon$1", {
  Ljava_time_LocalTime$$anon$1: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_LocalTime$$anon$1.prototype.$classData = $d_Ljava_time_LocalTime$$anon$1;
function $p_Ljava_time_Month$__JANUARY$lzycompute__Ljava_time_Month($thiz) {
  if (((1 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_JANUARY = new $c_Ljava_time_Month("JANUARY", 0);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (1 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_JANUARY
}
function $p_Ljava_time_Month$__FEBRUARY$lzycompute__Ljava_time_Month($thiz) {
  if (((2 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_FEBRUARY = new $c_Ljava_time_Month("FEBRUARY", 1);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (2 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_FEBRUARY
}
function $p_Ljava_time_Month$__MARCH$lzycompute__Ljava_time_Month($thiz) {
  if (((4 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_MARCH = new $c_Ljava_time_Month("MARCH", 2);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (4 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_MARCH
}
function $p_Ljava_time_Month$__APRIL$lzycompute__Ljava_time_Month($thiz) {
  if (((8 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_APRIL = new $c_Ljava_time_Month("APRIL", 3);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (8 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_APRIL
}
function $p_Ljava_time_Month$__MAY$lzycompute__Ljava_time_Month($thiz) {
  if (((16 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_MAY = new $c_Ljava_time_Month("MAY", 4);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (16 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_MAY
}
function $p_Ljava_time_Month$__JUNE$lzycompute__Ljava_time_Month($thiz) {
  if (((32 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_JUNE = new $c_Ljava_time_Month("JUNE", 5);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (32 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_JUNE
}
function $p_Ljava_time_Month$__JULY$lzycompute__Ljava_time_Month($thiz) {
  if (((64 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_JULY = new $c_Ljava_time_Month("JULY", 6);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (64 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_JULY
}
function $p_Ljava_time_Month$__AUGUST$lzycompute__Ljava_time_Month($thiz) {
  if (((128 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_AUGUST = new $c_Ljava_time_Month("AUGUST", 7);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (128 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_AUGUST
}
function $p_Ljava_time_Month$__SEPTEMBER$lzycompute__Ljava_time_Month($thiz) {
  if (((256 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_SEPTEMBER = new $c_Ljava_time_Month("SEPTEMBER", 8);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (256 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_SEPTEMBER
}
function $p_Ljava_time_Month$__OCTOBER$lzycompute__Ljava_time_Month($thiz) {
  if (((512 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_OCTOBER = new $c_Ljava_time_Month("OCTOBER", 9);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (512 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_OCTOBER
}
function $p_Ljava_time_Month$__DECEMBER$lzycompute__Ljava_time_Month($thiz) {
  if (((1024 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_DECEMBER = new $c_Ljava_time_Month("DECEMBER", 11);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (1024 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_DECEMBER
}
function $p_Ljava_time_Month$__values$lzycompute__ALjava_time_Month($thiz) {
  if (((2048 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_values = new ($d_Ljava_time_Month.getArrayOf().constr)([$thiz.JANUARY__Ljava_time_Month(), $thiz.FEBRUARY__Ljava_time_Month(), $thiz.MARCH__Ljava_time_Month(), $thiz.APRIL__Ljava_time_Month(), $thiz.MAY__Ljava_time_Month(), $thiz.JUNE__Ljava_time_Month(), $thiz.JULY__Ljava_time_Month(), $thiz.AUGUST__Ljava_time_Month(), $thiz.SEPTEMBER__Ljava_time_Month(), $thiz.OCTOBER__Ljava_time_Month(), $thiz.NOVEMBER__Ljava_time_Month(), $thiz.DECEMBER__Ljava_time_Month()]);
    $thiz.Ljava_time_Month$__f_bitmap$0 = (2048 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_values
}
function $p_Ljava_time_Month$__ENUMS$lzycompute__ALjava_time_Month($thiz) {
  if (((4096 & $thiz.Ljava_time_Month$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_Month$__f_java$time$Month$$ENUMS = $m_Ljava_time_Month$().values__ALjava_time_Month();
    $thiz.Ljava_time_Month$__f_bitmap$0 = (4096 | $thiz.Ljava_time_Month$__f_bitmap$0)
  };
  return $thiz.Ljava_time_Month$__f_java$time$Month$$ENUMS
}
/** @constructor */
function $c_Ljava_time_Month$() {
  this.Ljava_time_Month$__f_JANUARY = null;
  this.Ljava_time_Month$__f_FEBRUARY = null;
  this.Ljava_time_Month$__f_MARCH = null;
  this.Ljava_time_Month$__f_APRIL = null;
  this.Ljava_time_Month$__f_MAY = null;
  this.Ljava_time_Month$__f_JUNE = null;
  this.Ljava_time_Month$__f_JULY = null;
  this.Ljava_time_Month$__f_AUGUST = null;
  this.Ljava_time_Month$__f_SEPTEMBER = null;
  this.Ljava_time_Month$__f_OCTOBER = null;
  this.Ljava_time_Month$__f_DECEMBER = null;
  this.Ljava_time_Month$__f_values = null;
  this.Ljava_time_Month$__f_java$time$Month$$ENUMS = null;
  this.Ljava_time_Month$__f_NOVEMBER = null;
  this.Ljava_time_Month$__f_bitmap$0 = 0;
  this.Ljava_time_Month$__f_bitmap$init$0 = false;
  $n_Ljava_time_Month$ = this;
  this.Ljava_time_Month$__f_NOVEMBER = new $c_Ljava_time_Month("NOVEMBER", 10);
  this.Ljava_time_Month$__f_bitmap$init$0 = true
}
$c_Ljava_time_Month$.prototype = new $h_O();
$c_Ljava_time_Month$.prototype.constructor = $c_Ljava_time_Month$;
/** @constructor */
function $h_Ljava_time_Month$() {
  /*<skip>*/
}
$h_Ljava_time_Month$.prototype = $c_Ljava_time_Month$.prototype;
$c_Ljava_time_Month$.prototype.JANUARY__Ljava_time_Month = (function() {
  return (((1 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__JANUARY$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_JANUARY)
});
$c_Ljava_time_Month$.prototype.FEBRUARY__Ljava_time_Month = (function() {
  return (((2 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__FEBRUARY$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_FEBRUARY)
});
$c_Ljava_time_Month$.prototype.MARCH__Ljava_time_Month = (function() {
  return (((4 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__MARCH$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_MARCH)
});
$c_Ljava_time_Month$.prototype.APRIL__Ljava_time_Month = (function() {
  return (((8 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__APRIL$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_APRIL)
});
$c_Ljava_time_Month$.prototype.MAY__Ljava_time_Month = (function() {
  return (((16 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__MAY$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_MAY)
});
$c_Ljava_time_Month$.prototype.JUNE__Ljava_time_Month = (function() {
  return (((32 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__JUNE$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_JUNE)
});
$c_Ljava_time_Month$.prototype.JULY__Ljava_time_Month = (function() {
  return (((64 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__JULY$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_JULY)
});
$c_Ljava_time_Month$.prototype.AUGUST__Ljava_time_Month = (function() {
  return (((128 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__AUGUST$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_AUGUST)
});
$c_Ljava_time_Month$.prototype.SEPTEMBER__Ljava_time_Month = (function() {
  return (((256 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__SEPTEMBER$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_SEPTEMBER)
});
$c_Ljava_time_Month$.prototype.OCTOBER__Ljava_time_Month = (function() {
  return (((512 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__OCTOBER$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_OCTOBER)
});
$c_Ljava_time_Month$.prototype.NOVEMBER__Ljava_time_Month = (function() {
  if ((!this.Ljava_time_Month$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/Month.scala: 128")
  };
  return this.Ljava_time_Month$__f_NOVEMBER
});
$c_Ljava_time_Month$.prototype.DECEMBER__Ljava_time_Month = (function() {
  return (((1024 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__DECEMBER$lzycompute__Ljava_time_Month(this) : this.Ljava_time_Month$__f_DECEMBER)
});
$c_Ljava_time_Month$.prototype.values__ALjava_time_Month = (function() {
  return (((2048 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__values$lzycompute__ALjava_time_Month(this) : this.Ljava_time_Month$__f_values)
});
$c_Ljava_time_Month$.prototype.java$time$Month$$ENUMS__ALjava_time_Month = (function() {
  return (((4096 & this.Ljava_time_Month$__f_bitmap$0) === 0) ? $p_Ljava_time_Month$__ENUMS$lzycompute__ALjava_time_Month(this) : this.Ljava_time_Month$__f_java$time$Month$$ENUMS)
});
$c_Ljava_time_Month$.prototype.of__I__Ljava_time_Month = (function(month) {
  if (((month < 1) || (month > 12))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for MonthOfYear: " + month))
  } else {
    return $n(this.java$time$Month$$ENUMS__ALjava_time_Month()).get((((-1) + month) | 0))
  }
});
var $d_Ljava_time_Month$ = new $TypeData().initClass({
  Ljava_time_Month$: 0
}, false, "java.time.Month$", {
  Ljava_time_Month$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Month$.prototype.$classData = $d_Ljava_time_Month$;
var $n_Ljava_time_Month$;
function $m_Ljava_time_Month$() {
  if ((!$n_Ljava_time_Month$)) {
    $n_Ljava_time_Month$ = new $c_Ljava_time_Month$()
  };
  return $n_Ljava_time_Month$
}
/** @constructor */
function $c_Ljava_time_OffsetDateTime$() {
  /*<skip>*/
}
$c_Ljava_time_OffsetDateTime$.prototype = new $h_O();
$c_Ljava_time_OffsetDateTime$.prototype.constructor = $c_Ljava_time_OffsetDateTime$;
/** @constructor */
function $h_Ljava_time_OffsetDateTime$() {
  /*<skip>*/
}
$h_Ljava_time_OffsetDateTime$.prototype = $c_Ljava_time_OffsetDateTime$.prototype;
$c_Ljava_time_OffsetDateTime$.prototype.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime = (function(instant, zone) {
  if ((instant === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "instant")
  };
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  var rules = $n(zone).getRules__Ljava_time_zone_ZoneRules();
  var offset = $n(rules).getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  var $$x2 = $m_Ljava_time_LocalDateTime$();
  var this$3 = $n(instant);
  var $$x1 = this$3.Ljava_time_Instant__f_seconds;
  var this$4 = $n(instant);
  var ldt = $n($$x2).ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime($$x1, this$4.Ljava_time_Instant__f_nanos, offset);
  return new $c_Ljava_time_OffsetDateTime(ldt, offset)
});
$c_Ljava_time_OffsetDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_OffsetDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_OffsetDateTime)) {
    var x2 = $as_Ljava_time_OffsetDateTime(temporal);
    return x2
  } else {
    try {
      var offset = $m_Ljava_time_ZoneOffset$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset(temporal);
      try {
        var ldt = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal);
        return new $c_Ljava_time_OffsetDateTime(ldt, offset)
      } catch (e) {
        if ((e instanceof $c_Ljava_time_DateTimeException)) {
          var instant = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(temporal);
          return $m_Ljava_time_OffsetDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime(instant, offset)
        } else {
          throw e
        }
      }
    } catch (e$2) {
      if ((e$2 instanceof $c_Ljava_time_DateTimeException)) {
        var this$2 = $n(temporal);
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain OffsetDateTime from TemporalAccessor: " + temporal) + ", type ") + $objectGetClass(this$2).getName__T()))
      } else {
        throw e$2
      }
    }
  }
});
var $d_Ljava_time_OffsetDateTime$ = new $TypeData().initClass({
  Ljava_time_OffsetDateTime$: 0
}, false, "java.time.OffsetDateTime$", {
  Ljava_time_OffsetDateTime$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_OffsetDateTime$.prototype.$classData = $d_Ljava_time_OffsetDateTime$;
var $n_Ljava_time_OffsetDateTime$;
function $m_Ljava_time_OffsetDateTime$() {
  if ((!$n_Ljava_time_OffsetDateTime$)) {
    $n_Ljava_time_OffsetDateTime$ = new $c_Ljava_time_OffsetDateTime$()
  };
  return $n_Ljava_time_OffsetDateTime$
}
function $p_Ljava_time_Period$__ZERO$lzycompute__Ljava_time_Period($thiz) {
  if (((((1 & $thiz.Ljava_time_Period$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_Period$__f_ZERO = new $c_Ljava_time_Period(0, 0, 0);
    $thiz.Ljava_time_Period$__f_bitmap$0 = (((1 | $thiz.Ljava_time_Period$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_Period$__f_ZERO
}
function $p_Ljava_time_Period$__PATTERN$lzycompute__ju_regex_Pattern($thiz) {
  if (((((2 & $thiz.Ljava_time_Period$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_Period$__f_PATTERN = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("([-+]?)P(?:([-+]?[0-9]+)Y)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)W)?(?:([-+]?[0-9]+)D)?", 2);
    $thiz.Ljava_time_Period$__f_bitmap$0 = (((2 | $thiz.Ljava_time_Period$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_Period$__f_PATTERN
}
function $p_Ljava_time_Period$__PATTERN__ju_regex_Pattern($thiz) {
  return (((((2 & $thiz.Ljava_time_Period$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_Period$__PATTERN$lzycompute__ju_regex_Pattern($thiz) : $thiz.Ljava_time_Period$__f_PATTERN)
}
function $p_Ljava_time_Period$__parseNumber__jl_CharSequence__T__I__I($thiz, text, str, negate) {
  if ((str === null)) {
    return 0
  };
  $m_sc_StringOps$();
  var this$3 = $m_jl_Integer$();
  var val = this$3.parseInt__T__I__I(str, 10);
  try {
    return $m_jl_Math$().multiplyExact__I__I__I(val, negate)
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      var ex = $as_jl_ArithmeticException(e);
      throw new $c_Ljava_time_format_DateTimeParseException("Text cannot be parsed to a Period", text, 0, ex)
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_Ljava_time_Period$() {
  this.Ljava_time_Period$__f_ZERO = null;
  this.Ljava_time_Period$__f_PATTERN = null;
  this.Ljava_time_Period$__f_bitmap$0 = 0
}
$c_Ljava_time_Period$.prototype = new $h_O();
$c_Ljava_time_Period$.prototype.constructor = $c_Ljava_time_Period$;
/** @constructor */
function $h_Ljava_time_Period$() {
  /*<skip>*/
}
$h_Ljava_time_Period$.prototype = $c_Ljava_time_Period$.prototype;
$c_Ljava_time_Period$.prototype.ZERO__Ljava_time_Period = (function() {
  return (((((1 & this.Ljava_time_Period$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_Period$__ZERO$lzycompute__Ljava_time_Period(this) : this.Ljava_time_Period$__f_ZERO)
});
$c_Ljava_time_Period$.prototype.parse__jl_CharSequence__Ljava_time_Period = (function(text) {
  if ((text === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "text")
  };
  var this$2 = $n($p_Ljava_time_Period$__PATTERN__ju_regex_Pattern(this));
  var matcher = new $c_ju_regex_Matcher(this$2, $dp_toString__T($n(text)));
  if (matcher.matches__Z()) {
    var negate = ((matcher.group__I__T(1) === "-") ? (-1) : 1);
    var yearMatch = matcher.group__I__T(2);
    var monthMatch = matcher.group__I__T(3);
    var weekMatch = matcher.group__I__T(4);
    var dayMatch = matcher.group__I__T(5);
    if (((((yearMatch !== null) || (monthMatch !== null)) || (weekMatch !== null)) || (dayMatch !== null))) {
      try {
        var years = $p_Ljava_time_Period$__parseNumber__jl_CharSequence__T__I__I(this, text, yearMatch, negate);
        var months = $p_Ljava_time_Period$__parseNumber__jl_CharSequence__T__I__I(this, text, monthMatch, negate);
        var weeks = $p_Ljava_time_Period$__parseNumber__jl_CharSequence__T__I__I(this, text, weekMatch, negate);
        var days = $p_Ljava_time_Period$__parseNumber__jl_CharSequence__T__I__I(this, text, dayMatch, negate);
        var a = days;
        var b = $m_jl_Math$().multiplyExact__I__I__I(weeks, 7);
        days = $m_jl_Math$().addExact__I__I__I(a, b);
        return this.java$time$Period$$create__I__I__I__Ljava_time_Period(years, months, days)
      } catch (e) {
        if ((e instanceof $c_jl_NumberFormatException)) {
          var ex = $as_jl_NumberFormatException(e);
          throw new $c_Ljava_time_format_DateTimeParseException("Text cannot be parsed to a Period", text, 0, ex)
        } else {
          throw e
        }
      }
    }
  };
  throw new $c_Ljava_time_format_DateTimeParseException("Text cannot be parsed to a Period", text, 0, null)
});
$c_Ljava_time_Period$.prototype.java$time$Period$$create__I__I__I__Ljava_time_Period = (function(years, months, days) {
  return ((((years | months) | days) === 0) ? this.ZERO__Ljava_time_Period() : new $c_Ljava_time_Period(years, months, days))
});
var $d_Ljava_time_Period$ = new $TypeData().initClass({
  Ljava_time_Period$: 0
}, false, "java.time.Period$", {
  Ljava_time_Period$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Period$.prototype.$classData = $d_Ljava_time_Period$;
var $n_Ljava_time_Period$;
function $m_Ljava_time_Period$() {
  if ((!$n_Ljava_time_Period$)) {
    $n_Ljava_time_Period$ = new $c_Ljava_time_Period$()
  };
  return $n_Ljava_time_Period$
}
function $p_Ljava_time_Year$__MIN_VALUE$lzycompute__I($thiz) {
  if (((((1 & $thiz.Ljava_time_Year$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_Year$__f_MIN_VALUE = (-999999999);
    $thiz.Ljava_time_Year$__f_bitmap$0 = (((1 | $thiz.Ljava_time_Year$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_Year$__f_MIN_VALUE
}
function $p_Ljava_time_Year$__MAX_VALUE$lzycompute__I($thiz) {
  if (((((2 & $thiz.Ljava_time_Year$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_Year$__f_MAX_VALUE = 999999999;
    $thiz.Ljava_time_Year$__f_bitmap$0 = (((2 | $thiz.Ljava_time_Year$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_Year$__f_MAX_VALUE
}
/** @constructor */
function $c_Ljava_time_Year$() {
  this.Ljava_time_Year$__f_MIN_VALUE = 0;
  this.Ljava_time_Year$__f_MAX_VALUE = 0;
  this.Ljava_time_Year$__f_bitmap$0 = 0
}
$c_Ljava_time_Year$.prototype = new $h_O();
$c_Ljava_time_Year$.prototype.constructor = $c_Ljava_time_Year$;
/** @constructor */
function $h_Ljava_time_Year$() {
  /*<skip>*/
}
$h_Ljava_time_Year$.prototype = $c_Ljava_time_Year$.prototype;
$c_Ljava_time_Year$.prototype.MIN_VALUE__I = (function() {
  return (((((1 & this.Ljava_time_Year$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_Year$__MIN_VALUE$lzycompute__I(this) : this.Ljava_time_Year$__f_MIN_VALUE)
});
$c_Ljava_time_Year$.prototype.MAX_VALUE__I = (function() {
  return (((((2 & this.Ljava_time_Year$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_Year$__MAX_VALUE$lzycompute__I(this) : this.Ljava_time_Year$__f_MAX_VALUE)
});
$c_Ljava_time_Year$.prototype.isLeap__J__Z = (function(year) {
  var lo = (3 & year.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_RTLong$();
    var lo$1 = this$1.remainderImpl__I__I__I__I__I(year.RTLong__f_lo, year.RTLong__f_hi, 100, 0);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if ((!((lo$1 === 0) && (hi === 0)))) {
      return true
    } else {
      var this$2 = $m_RTLong$();
      var lo$2 = this$2.remainderImpl__I__I__I__I__I(year.RTLong__f_lo, year.RTLong__f_hi, 400, 0);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return ((lo$2 === 0) && (hi$1 === 0))
    }
  } else {
    return false
  }
});
var $d_Ljava_time_Year$ = new $TypeData().initClass({
  Ljava_time_Year$: 0
}, false, "java.time.Year$", {
  Ljava_time_Year$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Year$.prototype.$classData = $d_Ljava_time_Year$;
var $n_Ljava_time_Year$;
function $m_Ljava_time_Year$() {
  if ((!$n_Ljava_time_Year$)) {
    $n_Ljava_time_Year$ = new $c_Ljava_time_Year$()
  };
  return $n_Ljava_time_Year$
}
function $ct_Ljava_time_ZoneId__($thiz) {
  if ((($objectGetClass($thiz) !== $d_Ljava_time_ZoneOffset.getClassOf()) && ($objectGetClass($thiz) !== $d_Ljava_time_ZoneRegion.getClassOf()))) {
    throw new $c_jl_AssertionError("Invalid subclass")
  };
  return $thiz
}
/** @constructor */
function $c_Ljava_time_ZoneId() {
  /*<skip>*/
}
$c_Ljava_time_ZoneId.prototype = new $h_O();
$c_Ljava_time_ZoneId.prototype.constructor = $c_Ljava_time_ZoneId;
/** @constructor */
function $h_Ljava_time_ZoneId() {
  /*<skip>*/
}
$h_Ljava_time_ZoneId.prototype = $c_Ljava_time_ZoneId.prototype;
$c_Ljava_time_ZoneId.prototype.normalized__Ljava_time_ZoneId = (function() {
  try {
    var rules = this.getRules__Ljava_time_zone_ZoneRules();
    if ($n(rules).isFixedOffset__Z()) {
      return $n(rules).getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant())
    }
  } catch (e) {
    if ((!(e instanceof $c_Ljava_time_zone_ZoneRulesException))) {
      throw e
    }
  };
  return this
});
$c_Ljava_time_ZoneId.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZoneId)) {
    var x2 = $as_Ljava_time_ZoneId(obj);
    return ((this === x2) || (this.getId__T() === $n(x2).getId__T()))
  } else {
    return false
  }
});
$c_Ljava_time_ZoneId.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I($n(this.getId__T()))
});
$c_Ljava_time_ZoneId.prototype.toString__T = (function() {
  return this.getId__T()
});
function $as_Ljava_time_ZoneId(obj) {
  return (((obj instanceof $c_Ljava_time_ZoneId) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.ZoneId"))
}
function $isArrayOf_Ljava_time_ZoneId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZoneId)))
}
function $asArrayOf_Ljava_time_ZoneId(obj, depth) {
  return (($isArrayOf_Ljava_time_ZoneId(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.ZoneId;", depth))
}
function $p_Ljava_time_ZoneId$__SHORT_IDS$lzycompute__ju_Map($thiz) {
  if (((((1 & $thiz.Ljava_time_ZoneId$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_ZoneId$__f_SHORT_IDS = $as_ju_Map($n($m_sc_JavaConverters$().mapAsJavaMapConverter__sc_Map__sc_JavaConverters$AsJava($p_Ljava_time_ZoneId$__ShortIds__sci_Map($thiz))).asJava__O());
    $thiz.Ljava_time_ZoneId$__f_bitmap$0 = (((1 | $thiz.Ljava_time_ZoneId$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_ZoneId$__f_SHORT_IDS
}
function $p_Ljava_time_ZoneId$__ShortIds$lzycompute__sci_Map($thiz) {
  if (((((2 & $thiz.Ljava_time_ZoneId$__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$60 = $n($m_s_Predef$().s_Predef$__f_Map);
    var array = [$ct_T2__O__O__(new $c_T2(), "ACT", "Australia/Darwin"), $ct_T2__O__O__(new $c_T2(), "AET", "Australia/Sydney"), $ct_T2__O__O__(new $c_T2(), "AGT", "America/Argentina/Buenos_Aires"), $ct_T2__O__O__(new $c_T2(), "ART", "Africa/Cairo"), $ct_T2__O__O__(new $c_T2(), "AST", "America/Anchorage"), $ct_T2__O__O__(new $c_T2(), "BET", "America/Sao_Paulo"), $ct_T2__O__O__(new $c_T2(), "BST", "Asia/Dhaka"), $ct_T2__O__O__(new $c_T2(), "CAT", "Africa/Harare"), $ct_T2__O__O__(new $c_T2(), "CNT", "America/St_Johns"), $ct_T2__O__O__(new $c_T2(), "CST", "America/Chicago"), $ct_T2__O__O__(new $c_T2(), "CTT", "Asia/Shanghai"), $ct_T2__O__O__(new $c_T2(), "EAT", "Africa/Addis_Ababa"), $ct_T2__O__O__(new $c_T2(), "ECT", "Europe/Paris"), $ct_T2__O__O__(new $c_T2(), "IET", "America/Indiana/Indianapolis"), $ct_T2__O__O__(new $c_T2(), "IST", "Asia/Kolkata"), $ct_T2__O__O__(new $c_T2(), "JST", "Asia/Tokyo"), $ct_T2__O__O__(new $c_T2(), "MIT", "Pacific/Apia"), $ct_T2__O__O__(new $c_T2(), "NET", "Asia/Yerevan"), $ct_T2__O__O__(new $c_T2(), "NST", "Pacific/Auckland"), $ct_T2__O__O__(new $c_T2(), "PLT", "Asia/Karachi"), $ct_T2__O__O__(new $c_T2(), "PNT", "America/Phoenix"), $ct_T2__O__O__(new $c_T2(), "PRT", "America/Puerto_Rico"), $ct_T2__O__O__(new $c_T2(), "PST", "America/Los_Angeles"), $ct_T2__O__O__(new $c_T2(), "SST", "Pacific/Guadalcanal"), $ct_T2__O__O__(new $c_T2(), "VST", "Asia/Ho_Chi_Minh"), $ct_T2__O__O__(new $c_T2(), "EST", "-05:00"), $ct_T2__O__O__(new $c_T2(), "MST", "-07:00"), $ct_T2__O__O__(new $c_T2(), "HST", "-10:00")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Ljava_time_ZoneId$__f_ShortIds = this$60.from__sc_IterableOnce__sci_Map(elems);
    $thiz.Ljava_time_ZoneId$__f_bitmap$0 = (((2 | $thiz.Ljava_time_ZoneId$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_ZoneId$__f_ShortIds
}
function $p_Ljava_time_ZoneId$__ShortIds__sci_Map($thiz) {
  return (((((2 & $thiz.Ljava_time_ZoneId$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_ZoneId$__ShortIds$lzycompute__sci_Map($thiz) : $thiz.Ljava_time_ZoneId$__f_ShortIds)
}
function $p_Ljava_time_ZoneId$__of2__T__sci_Map__Ljava_time_ZoneId($thiz, zoneId, aliasMap) {
  var this$1 = $n($n(aliasMap).get__O__s_Option(zoneId));
  return $thiz.of__T__Ljava_time_ZoneId($as_T((this$1.isEmpty__Z() ? zoneId : this$1.get__O())))
}
/** @constructor */
function $c_Ljava_time_ZoneId$() {
  this.Ljava_time_ZoneId$__f_SHORT_IDS = null;
  this.Ljava_time_ZoneId$__f_ShortIds = null;
  this.Ljava_time_ZoneId$__f_bitmap$0 = 0
}
$c_Ljava_time_ZoneId$.prototype = new $h_O();
$c_Ljava_time_ZoneId$.prototype.constructor = $c_Ljava_time_ZoneId$;
/** @constructor */
function $h_Ljava_time_ZoneId$() {
  /*<skip>*/
}
$h_Ljava_time_ZoneId$.prototype = $c_Ljava_time_ZoneId$.prototype;
$c_Ljava_time_ZoneId$.prototype.SHORT_IDS__ju_Map = (function() {
  return (((((1 & this.Ljava_time_ZoneId$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_ZoneId$__SHORT_IDS$lzycompute__ju_Map(this) : this.Ljava_time_ZoneId$__f_SHORT_IDS)
});
$c_Ljava_time_ZoneId$.prototype.systemDefault__Ljava_time_ZoneId = (function() {
  var this$1 = $m_ju_TimeZone$();
  var this$2 = $n($p_ju_TimeZone$__default__ju_TimeZone(this$1));
  return $p_Ljava_time_ZoneId$__of2__T__sci_Map__Ljava_time_ZoneId(this, this$2.ju_SimpleTimeZone__f_ID, $p_Ljava_time_ZoneId$__ShortIds__sci_Map(this))
});
$c_Ljava_time_ZoneId$.prototype.of__T__ju_Map__Ljava_time_ZoneId = (function(zoneId, aliasMap) {
  var $$x1 = $as_sc_IterableOnceOps($n($m_sc_JavaConverters$().mapAsScalaMapConverter__ju_Map__sc_JavaConverters$AsScala(aliasMap)).asScala__O());
  var this$1 = $m_s_$less$colon$less$();
  return $p_Ljava_time_ZoneId$__of2__T__sci_Map__Ljava_time_ZoneId(this, zoneId, $n($$x1).toMap__s_$less$colon$less__sci_Map(this$1.s_$less$colon$less$__f_singleton))
});
$c_Ljava_time_ZoneId$.prototype.of__T__Ljava_time_ZoneId = (function(zoneId) {
  if ((zoneId === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId")
  };
  if ((zoneId === "Z")) {
    return $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset()
  } else {
    var this$2 = $n(zoneId);
    if ((this$2.length === 1)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, invalid format: " + zoneId))
    } else {
      var this$3 = $n(zoneId);
      if (((this$3.length >= 0) && ($as_T(this$3.substring(0, 1)) === "+"))) {
        var $$x1 = true
      } else {
        var this$4 = $n(zoneId);
        var $$x1 = ((this$4.length >= 0) && ($as_T(this$4.substring(0, 1)) === "-"))
      };
      if ($$x1) {
        return $m_Ljava_time_ZoneOffset$().of__T__Ljava_time_ZoneOffset(zoneId)
      } else if ((((zoneId === "UTC") || (zoneId === "GMT")) || (zoneId === "UT"))) {
        var this$5 = $n($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        return new $c_Ljava_time_ZoneRegion(zoneId, $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$5))
      } else {
        var this$6 = $n(zoneId);
        if (((this$6.length >= 0) && ($as_T(this$6.substring(0, 4)) === "UTC+"))) {
          var $$x4 = true
        } else {
          var this$7 = $n(zoneId);
          var $$x4 = ((this$7.length >= 0) && ($as_T(this$7.substring(0, 4)) === "GMT+"))
        };
        if ($$x4) {
          var $$x3 = true
        } else {
          var this$8 = $n(zoneId);
          var $$x3 = ((this$8.length >= 0) && ($as_T(this$8.substring(0, 4)) === "UTC-"))
        };
        if ($$x3) {
          var $$x2 = true
        } else {
          var this$9 = $n(zoneId);
          var $$x2 = ((this$9.length >= 0) && ($as_T(this$9.substring(0, 4)) === "GMT-"))
        };
        if ($$x2) {
          var $$x5 = $m_Ljava_time_ZoneOffset$();
          var this$10 = $n(zoneId);
          if ((this$10.length < 3)) {
            $charAt(this$10, 3)
          };
          var offset = $n($$x5).of__T__Ljava_time_ZoneOffset($as_T(this$10.substring(3)));
          var this$11 = $n(offset);
          if ((this$11.Ljava_time_ZoneOffset__f_totalSeconds === 0)) {
            var this$12 = $n(zoneId);
            if ((this$12.length < 3)) {
              $charAt(this$12, 3)
            };
            var $$x6 = $as_T(this$12.substring(0, 3));
            var this$13 = $n(offset);
            return new $c_Ljava_time_ZoneRegion($$x6, $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$13))
          } else {
            var this$14 = $n(zoneId);
            if ((this$14.length < 3)) {
              $charAt(this$14, 3)
            };
            var $$x8 = $as_T(this$14.substring(0, 3));
            var this$15 = $n(offset);
            var $$x7 = $p_Ljava_time_ZoneOffset__id__T(this$15);
            var this$16 = $n(offset);
            return new $c_Ljava_time_ZoneRegion((("" + $$x8) + $$x7), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$16))
          }
        } else {
          var this$17 = $n(zoneId);
          if (((this$17.length >= 0) && ($as_T(this$17.substring(0, 3)) === "UT+"))) {
            var $$x9 = true
          } else {
            var this$18 = $n(zoneId);
            var $$x9 = ((this$18.length >= 0) && ($as_T(this$18.substring(0, 3)) === "UT-"))
          };
          if ($$x9) {
            var $$x10 = $m_Ljava_time_ZoneOffset$();
            var this$19 = $n(zoneId);
            if ((this$19.length < 2)) {
              $charAt(this$19, 2)
            };
            var offset$2 = $n($$x10).of__T__Ljava_time_ZoneOffset($as_T(this$19.substring(2)));
            var this$20 = $n(offset$2);
            if ((this$20.Ljava_time_ZoneOffset__f_totalSeconds === 0)) {
              var this$21 = $n(offset$2);
              return new $c_Ljava_time_ZoneRegion("UT", $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$21))
            } else {
              var this$22 = $n(offset$2);
              var $$x11 = $p_Ljava_time_ZoneOffset__id__T(this$22);
              var this$23 = $n(offset$2);
              return new $c_Ljava_time_ZoneRegion(("UT" + $$x11), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$23))
            }
          } else {
            return $m_Ljava_time_ZoneRegion$().ofId__T__Z__Ljava_time_ZoneRegion(zoneId, true)
          }
        }
      }
    }
  }
});
$c_Ljava_time_ZoneId$.prototype.ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId = (function(prefix, offset) {
  if ((prefix === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "prefix")
  };
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  var this$3 = $n(prefix);
  if ((this$3.length === 0)) {
    return offset
  };
  if ((((prefix === "GMT") || (prefix === "UTC")) || (prefix === "UT"))) {
    var this$4 = $n(offset);
    if ((this$4.Ljava_time_ZoneOffset__f_totalSeconds === 0)) {
      var this$5 = $n(offset);
      return new $c_Ljava_time_ZoneRegion(prefix, $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$5))
    };
    var this$6 = $n(offset);
    var $$x1 = $p_Ljava_time_ZoneOffset__id__T(this$6);
    var this$7 = $n(offset);
    return new $c_Ljava_time_ZoneRegion((("" + prefix) + $$x1), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$7))
  };
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid prefix, must be GMT, UTC or UT: " + prefix))
});
$c_Ljava_time_ZoneId$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId = (function(temporal) {
  var obj = $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery()));
  if ((obj === null)) {
    var this$1 = $n(temporal);
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZoneId from TemporalAccessor: " + temporal) + ", type ") + $objectGetClass(this$1).getName__T()))
  } else {
    return obj
  }
});
var $d_Ljava_time_ZoneId$ = new $TypeData().initClass({
  Ljava_time_ZoneId$: 0
}, false, "java.time.ZoneId$", {
  Ljava_time_ZoneId$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_ZoneId$.prototype.$classData = $d_Ljava_time_ZoneId$;
var $n_Ljava_time_ZoneId$;
function $m_Ljava_time_ZoneId$() {
  if ((!$n_Ljava_time_ZoneId$)) {
    $n_Ljava_time_ZoneId$ = new $c_Ljava_time_ZoneId$()
  };
  return $n_Ljava_time_ZoneId$
}
function $p_Ljava_time_ZoneOffset$__SECONDS_CACHE$lzycompute__ju_Map($thiz) {
  if (((((1 & $thiz.Ljava_time_ZoneOffset$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHE = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_ZoneOffset$__f_bitmap$0 = (((1 | $thiz.Ljava_time_ZoneOffset$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHE
}
function $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map($thiz) {
  return (((((1 & $thiz.Ljava_time_ZoneOffset$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_ZoneOffset$__SECONDS_CACHE$lzycompute__ju_Map($thiz) : $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHE)
}
function $p_Ljava_time_ZoneOffset$__ID_CACHE$lzycompute__ju_Map($thiz) {
  if (((((2 & $thiz.Ljava_time_ZoneOffset$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_ZoneOffset$__f_ID_CACHE = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_ZoneOffset$__f_bitmap$0 = (((2 | $thiz.Ljava_time_ZoneOffset$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_ZoneOffset$__f_ID_CACHE
}
function $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map($thiz) {
  return (((((2 & $thiz.Ljava_time_ZoneOffset$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_ZoneOffset$__ID_CACHE$lzycompute__ju_Map($thiz) : $thiz.Ljava_time_ZoneOffset$__f_ID_CACHE)
}
function $p_Ljava_time_ZoneOffset$__SECONDS_PER_HOUR__I($thiz) {
  if (((((1 & $thiz.Ljava_time_ZoneOffset$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/ZoneOffset.scala: 61")
  };
  return $thiz.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR
}
function $p_Ljava_time_ZoneOffset$__SECONDS_PER_MINUTE__I($thiz) {
  if (((((2 & $thiz.Ljava_time_ZoneOffset$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/ZoneOffset.scala: 64")
  };
  return $thiz.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE
}
function $p_Ljava_time_ZoneOffset$__MINUTES_PER_HOUR__I($thiz) {
  if (((((4 & $thiz.Ljava_time_ZoneOffset$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/ZoneOffset.scala: 67")
  };
  return $thiz.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR
}
function $p_Ljava_time_ZoneOffset$__MAX_SECONDS__I($thiz) {
  if (((((8 & $thiz.Ljava_time_ZoneOffset$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/ZoneOffset.scala: 70")
  };
  return $thiz.Ljava_time_ZoneOffset$__f_MAX_SECONDS
}
function $p_Ljava_time_ZoneOffset$__UTC$lzycompute__Ljava_time_ZoneOffset($thiz) {
  if (((((4 & $thiz.Ljava_time_ZoneOffset$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_ZoneOffset$__f_UTC = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(0);
    $thiz.Ljava_time_ZoneOffset$__f_bitmap$0 = (((4 | $thiz.Ljava_time_ZoneOffset$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_ZoneOffset$__f_UTC
}
function $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I($thiz, offsetId, pos, precededByColon) {
  if ((precededByColon && ($dp_charAt__I__C($n(offsetId), (((-1) + pos) | 0)) !== 58))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, colon not found when expected: " + offsetId))
  };
  var ch1 = $dp_charAt__I__C($n(offsetId), pos);
  var ch2 = $dp_charAt__I__C($n(offsetId), ((1 + pos) | 0));
  if (((((ch1 < 48) || (ch1 > 57)) || (ch2 < 48)) || (ch2 > 57))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, non numeric characters found: " + offsetId))
  };
  return ((Math.imul(10, (((-48) + ch1) | 0)) + (((-48) + ch2) | 0)) | 0)
}
function $p_Ljava_time_ZoneOffset$__validate__I__I__I__V($thiz, hours, minutes, seconds) {
  if (((hours < (-18)) || (hours > 18))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Zone offset hours not in valid range: value " + hours) + " is not in the range -18 to 18"))
  };
  if ((hours > 0)) {
    if (((minutes < 0) || (seconds < 0))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg2$1__T__T($thiz, "positive"))
    }
  } else if ((hours < 0)) {
    if (((minutes > 0) || (seconds > 0))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg2$1__T__T($thiz, "negative"))
    }
  } else if ((((minutes > 0) && (seconds < 0)) || ((minutes < 0) && (seconds > 0)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset minutes and seconds must have the same sign")
  };
  if ((((minutes < 0) ? ((-minutes) | 0) : minutes) > 59)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg$1__T__I__T($thiz, "minutes", minutes))
  };
  if ((((seconds < 0) ? ((-seconds) | 0) : seconds) > 59)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg$1__T__I__T($thiz, "seconds", minutes))
  };
  if (((((hours < 0) ? ((-hours) | 0) : hours) === 18) && ((((minutes < 0) ? ((-minutes) | 0) : minutes) > 0) || (((seconds < 0) ? ((-seconds) | 0) : seconds) > 0)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset not in valid range: -18:00 to +18:00")
  }
}
function $p_Ljava_time_ZoneOffset$__totalSeconds__I__I__I__I($thiz, hours, minutes, seconds) {
  return ((((Math.imul(hours, $p_Ljava_time_ZoneOffset$__SECONDS_PER_HOUR__I($thiz)) + Math.imul(minutes, $p_Ljava_time_ZoneOffset$__SECONDS_PER_MINUTE__I($thiz))) | 0) + seconds) | 0)
}
function $p_Ljava_time_ZoneOffset$__msg$1__T__I__T($thiz, v, minutes$1) {
  return (((("Zone offset " + v) + " not in valid range: abs(value) ") + ((minutes$1 < 0) ? ((-minutes$1) | 0) : minutes$1)) + " is not in the range 0 to 59")
}
function $p_Ljava_time_ZoneOffset$__msg2$1__T__T($thiz, v) {
  return ((("Zone offset minutes and seconds must be " + v) + " because hours is ") + v)
}
/** @constructor */
function $c_Ljava_time_ZoneOffset$() {
  this.Ljava_time_ZoneOffset$__f_SECONDS_CACHE = null;
  this.Ljava_time_ZoneOffset$__f_ID_CACHE = null;
  this.Ljava_time_ZoneOffset$__f_UTC = null;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR = 0;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE = 0;
  this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR = 0;
  this.Ljava_time_ZoneOffset$__f_MAX_SECONDS = 0;
  this.Ljava_time_ZoneOffset$__f_bitmap$0 = 0;
  this.Ljava_time_ZoneOffset$__f_bitmap$init$0 = 0;
  $n_Ljava_time_ZoneOffset$ = this;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR = 3600;
  this.Ljava_time_ZoneOffset$__f_bitmap$init$0 = (((1 | this.Ljava_time_ZoneOffset$__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE = 60;
  this.Ljava_time_ZoneOffset$__f_bitmap$init$0 = (((2 | this.Ljava_time_ZoneOffset$__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR = 60;
  this.Ljava_time_ZoneOffset$__f_bitmap$init$0 = (((4 | this.Ljava_time_ZoneOffset$__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_ZoneOffset$__f_MAX_SECONDS = Math.imul(18, $p_Ljava_time_ZoneOffset$__SECONDS_PER_HOUR__I(this));
  this.Ljava_time_ZoneOffset$__f_bitmap$init$0 = (((8 | this.Ljava_time_ZoneOffset$__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_ZoneOffset$.prototype = new $h_O();
$c_Ljava_time_ZoneOffset$.prototype.constructor = $c_Ljava_time_ZoneOffset$;
/** @constructor */
function $h_Ljava_time_ZoneOffset$() {
  /*<skip>*/
}
$h_Ljava_time_ZoneOffset$.prototype = $c_Ljava_time_ZoneOffset$.prototype;
$c_Ljava_time_ZoneOffset$.prototype.UTC__Ljava_time_ZoneOffset = (function() {
  return (((((4 & this.Ljava_time_ZoneOffset$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_ZoneOffset$__UTC$lzycompute__Ljava_time_ZoneOffset(this) : this.Ljava_time_ZoneOffset$__f_UTC)
});
$c_Ljava_time_ZoneOffset$.prototype.of__T__Ljava_time_ZoneOffset = (function(offsetId) {
  var _offsetId = offsetId;
  var obj = _offsetId;
  if ((obj === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetId")
  };
  var offset = $as_Ljava_time_ZoneOffset($n($p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map(this)).get__O__O(_offsetId));
  if ((offset !== null)) {
    return offset
  };
  var hours = 0;
  var minutes = 0;
  var seconds = 0;
  var this$2 = $n(_offsetId);
  if ((this$2.length === 2)) {
    var this$3 = $n(_offsetId);
    var this$4 = $n(_offsetId);
    _offsetId = (($bC($charAt(this$3, 0)) + "0") + $bC($charAt(this$4, 1)))
  };
  var this$5 = $n(_offsetId);
  var x1 = this$5.length;
  switch (x1) {
    case 3: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = 0;
      seconds = 0;
      break
    }
    case 5: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 3, false);
      seconds = 0;
      break
    }
    case 6: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 4, true);
      seconds = 0;
      break
    }
    case 7: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 3, false);
      seconds = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 5, false);
      break
    }
    case 9: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 4, true);
      seconds = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 7, true);
      break
    }
    default: {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, invalid format: " + _offsetId))
    }
  };
  var this$6 = $n(_offsetId);
  var first = $charAt(this$6, 0);
  if (((first !== 43) && (first !== 45))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, plus/minus not found when expected: " + _offsetId))
  };
  return ((first === 45) ? this.ofHoursMinutesSeconds__I__I__I__Ljava_time_ZoneOffset(((-hours) | 0), ((-minutes) | 0), ((-seconds) | 0)) : this.ofHoursMinutesSeconds__I__I__I__Ljava_time_ZoneOffset(hours, minutes, seconds))
});
$c_Ljava_time_ZoneOffset$.prototype.ofHoursMinutesSeconds__I__I__I__Ljava_time_ZoneOffset = (function(hours, minutes, seconds) {
  $p_Ljava_time_ZoneOffset$__validate__I__I__I__V(this, hours, minutes, seconds);
  var totalSecs = $p_Ljava_time_ZoneOffset$__totalSeconds__I__I__I__I(this, hours, minutes, seconds);
  return this.ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSecs)
});
$c_Ljava_time_ZoneOffset$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset = (function(temporal) {
  var offset = $as_Ljava_time_ZoneOffset($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()));
  if ((offset === null)) {
    var this$1 = $n(temporal);
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZoneOffset from TemporalAccessor: " + temporal) + ", type ") + $objectGetClass(this$1).getName__T()))
  };
  return offset
});
$c_Ljava_time_ZoneOffset$.prototype.ofTotalSeconds__I__Ljava_time_ZoneOffset = (function(totalSeconds) {
  if ((((totalSeconds < 0) ? ((-totalSeconds) | 0) : totalSeconds) > $p_Ljava_time_ZoneOffset$__MAX_SECONDS__I(this))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset not in valid range: -18:00 to +18:00")
  } else if (($intMod(totalSeconds, Math.imul(15, $p_Ljava_time_ZoneOffset$__SECONDS_PER_MINUTE__I(this))) === 0)) {
    var result = $as_Ljava_time_ZoneOffset($n($p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this)).get__O__O(totalSeconds));
    if ((result === null)) {
      result = new $c_Ljava_time_ZoneOffset(totalSeconds);
      $n($p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this)).put__O__O__O(totalSeconds, result);
      result = $as_Ljava_time_ZoneOffset($n($p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this)).get__O__O(totalSeconds));
      var $$x1 = $n($p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map(this));
      var this$3 = $n(result);
      $n($$x1).put__O__O__O($p_Ljava_time_ZoneOffset__id__T(this$3), result)
    };
    return result
  } else {
    return new $c_Ljava_time_ZoneOffset(totalSeconds)
  }
});
$c_Ljava_time_ZoneOffset$.prototype.java$time$ZoneOffset$$buildId__I__T = (function(totalSeconds) {
  if ((totalSeconds === 0)) {
    return "Z"
  } else {
    var absTotalSeconds = ((totalSeconds < 0) ? ((-totalSeconds) | 0) : totalSeconds);
    var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
    var absHours = $intDiv(absTotalSeconds, $p_Ljava_time_ZoneOffset$__SECONDS_PER_HOUR__I(this));
    var absMinutes = $intMod($intDiv(absTotalSeconds, $p_Ljava_time_ZoneOffset$__SECONDS_PER_MINUTE__I(this)), $p_Ljava_time_ZoneOffset$__MINUTES_PER_HOUR__I(this));
    $n($n($n($n(buf.append__T__scm_StringBuilder(((totalSeconds < 0) ? "-" : "+"))).append__T__scm_StringBuilder(((absHours < 10) ? "0" : ""))).append__I__scm_StringBuilder(absHours)).append__T__scm_StringBuilder(((absMinutes < 10) ? ":0" : ":"))).append__I__scm_StringBuilder(absMinutes);
    var absSeconds = $intMod(absTotalSeconds, $p_Ljava_time_ZoneOffset$__SECONDS_PER_MINUTE__I(this));
    if ((absSeconds !== 0)) {
      $n(buf.append__T__scm_StringBuilder(((absSeconds < 10) ? ":0" : ":"))).append__I__scm_StringBuilder(absSeconds)
    };
    return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
});
var $d_Ljava_time_ZoneOffset$ = new $TypeData().initClass({
  Ljava_time_ZoneOffset$: 0
}, false, "java.time.ZoneOffset$", {
  Ljava_time_ZoneOffset$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_ZoneOffset$.prototype.$classData = $d_Ljava_time_ZoneOffset$;
var $n_Ljava_time_ZoneOffset$;
function $m_Ljava_time_ZoneOffset$() {
  if ((!$n_Ljava_time_ZoneOffset$)) {
    $n_Ljava_time_ZoneOffset$ = new $c_Ljava_time_ZoneOffset$()
  };
  return $n_Ljava_time_ZoneOffset$
}
function $p_Ljava_time_ZoneRegion$__PATTERN$lzycompute__ju_regex_Pattern($thiz) {
  if ((!$thiz.Ljava_time_ZoneRegion$__f_bitmap$0)) {
    $thiz.Ljava_time_ZoneRegion$__f_PATTERN = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("[A-Za-z][A-Za-z0-9~/._+-]+", 0);
    $thiz.Ljava_time_ZoneRegion$__f_bitmap$0 = true
  };
  return $thiz.Ljava_time_ZoneRegion$__f_PATTERN
}
function $p_Ljava_time_ZoneRegion$__PATTERN__ju_regex_Pattern($thiz) {
  return ((!$thiz.Ljava_time_ZoneRegion$__f_bitmap$0) ? $p_Ljava_time_ZoneRegion$__PATTERN$lzycompute__ju_regex_Pattern($thiz) : $thiz.Ljava_time_ZoneRegion$__f_PATTERN)
}
/** @constructor */
function $c_Ljava_time_ZoneRegion$() {
  this.Ljava_time_ZoneRegion$__f_PATTERN = null;
  this.Ljava_time_ZoneRegion$__f_bitmap$0 = false
}
$c_Ljava_time_ZoneRegion$.prototype = new $h_O();
$c_Ljava_time_ZoneRegion$.prototype.constructor = $c_Ljava_time_ZoneRegion$;
/** @constructor */
function $h_Ljava_time_ZoneRegion$() {
  /*<skip>*/
}
$h_Ljava_time_ZoneRegion$.prototype = $c_Ljava_time_ZoneRegion$.prototype;
$c_Ljava_time_ZoneRegion$.prototype.ofId__T__Z__Ljava_time_ZoneRegion = (function(zoneId, checkAvailable) {
  if ((zoneId === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId")
  };
  var this$2 = $n(zoneId);
  if ((this$2.length < 2)) {
    var $$x1 = true
  } else {
    var this$3 = $n($p_Ljava_time_ZoneRegion$__PATTERN__ju_regex_Pattern(this));
    var this$4 = $n(zoneId);
    var $$x1 = (!new $c_ju_regex_Matcher(this$3, this$4).matches__Z())
  };
  if ($$x1) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for region-based ZoneId, invalid format: " + zoneId))
  };
  var rules = null;
  try {
    rules = $m_Ljava_time_zone_ZoneRulesProvider$().getRules__T__Z__Ljava_time_zone_ZoneRules(zoneId, true)
  } catch (e) {
    if ((e instanceof $c_Ljava_time_zone_ZoneRulesException)) {
      var ex = $as_Ljava_time_zone_ZoneRulesException(e);
      if ((zoneId === "GMT0")) {
        var this$5 = $n($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        rules = $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$5)
      } else if (checkAvailable) {
        throw ((ex === null) ? $n(null) : ex)
      }
    } else {
      throw e
    }
  };
  return new $c_Ljava_time_ZoneRegion(zoneId, rules)
});
var $d_Ljava_time_ZoneRegion$ = new $TypeData().initClass({
  Ljava_time_ZoneRegion$: 0
}, false, "java.time.ZoneRegion$", {
  Ljava_time_ZoneRegion$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_ZoneRegion$.prototype.$classData = $d_Ljava_time_ZoneRegion$;
var $n_Ljava_time_ZoneRegion$;
function $m_Ljava_time_ZoneRegion$() {
  if ((!$n_Ljava_time_ZoneRegion$)) {
    $n_Ljava_time_ZoneRegion$ = new $c_Ljava_time_ZoneRegion$()
  };
  return $n_Ljava_time_ZoneRegion$
}
/** @constructor */
function $c_Ljava_time_ZonedDateTime$() {
  /*<skip>*/
}
$c_Ljava_time_ZonedDateTime$.prototype = new $h_O();
$c_Ljava_time_ZonedDateTime$.prototype.constructor = $c_Ljava_time_ZonedDateTime$;
/** @constructor */
function $h_Ljava_time_ZonedDateTime$() {
  /*<skip>*/
}
$h_Ljava_time_ZonedDateTime$.prototype = $c_Ljava_time_ZonedDateTime$.prototype;
$c_Ljava_time_ZonedDateTime$.prototype.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime = (function(localDateTime, zone, preferredOffset) {
  if ((localDateTime === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "localDateTime")
  };
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  var _localDateTime = localDateTime;
  if ((zone instanceof $c_Ljava_time_ZoneOffset)) {
    var x2 = $as_Ljava_time_ZoneOffset(zone);
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, x2, zone)
  } else {
    var rules = $n(zone).getRules__Ljava_time_zone_ZoneRules();
    var validOffsets = $n(rules).getValidOffsets__Ljava_time_LocalDateTime__ju_List(_localDateTime);
    var offset = null;
    if (($n(validOffsets).size__I() === 1)) {
      offset = $as_Ljava_time_ZoneOffset($n(validOffsets).get__I__O(0))
    } else if (($n(validOffsets).size__I() === 0)) {
      var trans = $n(rules).getTransition__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition(_localDateTime);
      var this$7 = $n(_localDateTime);
      var this$3 = $n(trans);
      var this$5 = $m_Ljava_time_Duration$();
      var value = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(this$3);
      var hi = (value >> 31);
      var this$6 = $n(this$5.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(value, hi), 0));
      var t = this$6.Ljava_time_Duration__f_seconds;
      var lo = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      _localDateTime = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$7, this$7.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(lo, hi$1), $L0, 1);
      var this$8 = $n(trans);
      offset = this$8.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter
    } else if (((preferredOffset !== null) && $n(validOffsets).contains__O__Z(preferredOffset))) {
      offset = preferredOffset
    } else {
      var obj = $n(validOffsets).get__I__O(0);
      if ((obj === null)) {
        throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
      };
      offset = $as_Ljava_time_ZoneOffset(obj)
    };
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, offset, zone)
  }
});
$c_Ljava_time_ZonedDateTime$.prototype.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(instant, zone) {
  if ((instant === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "instant")
  };
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  var this$3 = $n(instant);
  var $$x1 = this$3.Ljava_time_Instant__f_seconds;
  var this$4 = $n(instant);
  return this.java$time$ZonedDateTime$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($$x1, this$4.Ljava_time_Instant__f_nanos, zone)
});
$c_Ljava_time_ZonedDateTime$.prototype.ofInstant__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(localDateTime, offset, zone) {
  if ((localDateTime === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "localDateTime")
  };
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  var $$x1 = $n(localDateTime).toEpochSecond__Ljava_time_ZoneOffset__J(offset);
  var this$4 = $n(localDateTime);
  var this$5 = $n(this$4.Ljava_time_LocalDateTime__f_time);
  return this.java$time$ZonedDateTime$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($$x1, this$5.Ljava_time_LocalTime__f_nano, zone)
});
$c_Ljava_time_ZonedDateTime$.prototype.java$time$ZonedDateTime$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(epochSecond, nanoOfSecond, zone) {
  var rules = $n(zone).getRules__Ljava_time_zone_ZoneRules();
  var $$x1 = $m_Ljava_time_Instant$();
  var hi = (nanoOfSecond >> 31);
  var instant = $n($$x1).ofEpochSecond__J__J__Ljava_time_Instant(epochSecond, new $c_RTLong(nanoOfSecond, hi));
  var offset = $n(rules).getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  return new $c_Ljava_time_ZonedDateTime($m_Ljava_time_LocalDateTime$().ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(epochSecond, nanoOfSecond, offset), offset, zone)
});
$c_Ljava_time_ZonedDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZonedDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_ZonedDateTime)) {
    var x2 = $as_Ljava_time_ZonedDateTime(temporal);
    return x2
  } else {
    try {
      var zone = $m_Ljava_time_ZoneId$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId(temporal);
      if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
        try {
          var t = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var nanoOfSecond = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
          return this.java$time$ZonedDateTime$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(new $c_RTLong(lo, hi), nanoOfSecond, zone)
        } catch (e) {
          if ((!(e instanceof $c_Ljava_time_DateTimeException))) {
            throw e
          }
        }
      };
      var ldt = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal);
      return this.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(ldt, zone, null)
    } catch (e$2) {
      if ((e$2 instanceof $c_Ljava_time_DateTimeException)) {
        var this$1 = $n(temporal);
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZonedDateTime from TemporalAccessor: " + temporal) + ", type ") + $objectGetClass(this$1).getName__T()))
      } else {
        throw e$2
      }
    }
  }
});
var $d_Ljava_time_ZonedDateTime$ = new $TypeData().initClass({
  Ljava_time_ZonedDateTime$: 0
}, false, "java.time.ZonedDateTime$", {
  Ljava_time_ZonedDateTime$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_ZonedDateTime$.prototype.$classData = $d_Ljava_time_ZonedDateTime$;
var $n_Ljava_time_ZonedDateTime$;
function $m_Ljava_time_ZonedDateTime$() {
  if ((!$n_Ljava_time_ZonedDateTime$)) {
    $n_Ljava_time_ZonedDateTime$ = new $c_Ljava_time_ZonedDateTime$()
  };
  return $n_Ljava_time_ZonedDateTime$
}
function $p_Ljava_time_chrono_IsoChronology$__INSTANCE$lzycompute__Ljava_time_chrono_IsoChronology($thiz) {
  if ((!$thiz.Ljava_time_chrono_IsoChronology$__f_bitmap$0)) {
    $thiz.Ljava_time_chrono_IsoChronology$__f_INSTANCE = new $c_Ljava_time_chrono_IsoChronology();
    $thiz.Ljava_time_chrono_IsoChronology$__f_bitmap$0 = true
  };
  return $thiz.Ljava_time_chrono_IsoChronology$__f_INSTANCE
}
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology$() {
  this.Ljava_time_chrono_IsoChronology$__f_INSTANCE = null;
  this.Ljava_time_chrono_IsoChronology$__f_bitmap$0 = false
}
$c_Ljava_time_chrono_IsoChronology$.prototype = new $h_O();
$c_Ljava_time_chrono_IsoChronology$.prototype.constructor = $c_Ljava_time_chrono_IsoChronology$;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology$() {
  /*<skip>*/
}
$h_Ljava_time_chrono_IsoChronology$.prototype = $c_Ljava_time_chrono_IsoChronology$.prototype;
$c_Ljava_time_chrono_IsoChronology$.prototype.INSTANCE__Ljava_time_chrono_IsoChronology = (function() {
  return ((!this.Ljava_time_chrono_IsoChronology$__f_bitmap$0) ? $p_Ljava_time_chrono_IsoChronology$__INSTANCE$lzycompute__Ljava_time_chrono_IsoChronology(this) : this.Ljava_time_chrono_IsoChronology$__f_INSTANCE)
});
var $d_Ljava_time_chrono_IsoChronology$ = new $TypeData().initClass({
  Ljava_time_chrono_IsoChronology$: 0
}, false, "java.time.chrono.IsoChronology$", {
  Ljava_time_chrono_IsoChronology$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_chrono_IsoChronology$.prototype.$classData = $d_Ljava_time_chrono_IsoChronology$;
var $n_Ljava_time_chrono_IsoChronology$;
function $m_Ljava_time_chrono_IsoChronology$() {
  if ((!$n_Ljava_time_chrono_IsoChronology$)) {
    $n_Ljava_time_chrono_IsoChronology$ = new $c_Ljava_time_chrono_IsoChronology$()
  };
  return $n_Ljava_time_chrono_IsoChronology$
}
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2() {
  /*<skip>*/
}
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype.compare__T__T__I = (function(str1, str2) {
  var this$1 = $n(str1);
  var this$2 = $n(str2);
  if ((this$1.length === this$2.length)) {
    return $f_T__compareTo__T__I($n(str1), str2)
  } else {
    var this$3 = $n(str1);
    var this$4 = $n(str2);
    return ((this$3.length - this$4.length) | 0)
  }
});
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype.compare__O__O__I = (function(x$1, x$2) {
  return this.compare__T__T__I($as_T(x$1), $as_T(x$2))
});
var $d_Ljava_time_format_DateTimeFormatterBuilder$$anon$2 = new $TypeData().initClass({
  Ljava_time_format_DateTimeFormatterBuilder$$anon$2: 0
}, false, "java.time.format.DateTimeFormatterBuilder$$anon$2", {
  Ljava_time_format_DateTimeFormatterBuilder$$anon$2: 1,
  O: 1,
  ju_Comparator: 1
});
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$2.prototype.$classData = $d_Ljava_time_format_DateTimeFormatterBuilder$$anon$2;
function $p_Ljava_time_format_ResolverStyle$__STRICT$lzycompute__Ljava_time_format_ResolverStyle($thiz) {
  if (((((1 & $thiz.Ljava_time_format_ResolverStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_ResolverStyle$__f_STRICT = new $c_Ljava_time_format_ResolverStyle("STRICT", 0);
    $thiz.Ljava_time_format_ResolverStyle$__f_bitmap$0 = (((1 | $thiz.Ljava_time_format_ResolverStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_ResolverStyle$__f_STRICT
}
function $p_Ljava_time_format_ResolverStyle$__SMART$lzycompute__Ljava_time_format_ResolverStyle($thiz) {
  if (((((2 & $thiz.Ljava_time_format_ResolverStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_ResolverStyle$__f_SMART = new $c_Ljava_time_format_ResolverStyle("SMART", 1);
    $thiz.Ljava_time_format_ResolverStyle$__f_bitmap$0 = (((2 | $thiz.Ljava_time_format_ResolverStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_ResolverStyle$__f_SMART
}
function $p_Ljava_time_format_ResolverStyle$__LENIENT$lzycompute__Ljava_time_format_ResolverStyle($thiz) {
  if (((((4 & $thiz.Ljava_time_format_ResolverStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_ResolverStyle$__f_LENIENT = new $c_Ljava_time_format_ResolverStyle("LENIENT", 2);
    $thiz.Ljava_time_format_ResolverStyle$__f_bitmap$0 = (((4 | $thiz.Ljava_time_format_ResolverStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_ResolverStyle$__f_LENIENT
}
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$() {
  this.Ljava_time_format_ResolverStyle$__f_STRICT = null;
  this.Ljava_time_format_ResolverStyle$__f_SMART = null;
  this.Ljava_time_format_ResolverStyle$__f_LENIENT = null;
  this.Ljava_time_format_ResolverStyle$__f_bitmap$0 = 0
}
$c_Ljava_time_format_ResolverStyle$.prototype = new $h_O();
$c_Ljava_time_format_ResolverStyle$.prototype.constructor = $c_Ljava_time_format_ResolverStyle$;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$() {
  /*<skip>*/
}
$h_Ljava_time_format_ResolverStyle$.prototype = $c_Ljava_time_format_ResolverStyle$.prototype;
$c_Ljava_time_format_ResolverStyle$.prototype.STRICT__Ljava_time_format_ResolverStyle = (function() {
  return (((((1 & this.Ljava_time_format_ResolverStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_ResolverStyle$__STRICT$lzycompute__Ljava_time_format_ResolverStyle(this) : this.Ljava_time_format_ResolverStyle$__f_STRICT)
});
$c_Ljava_time_format_ResolverStyle$.prototype.SMART__Ljava_time_format_ResolverStyle = (function() {
  return (((((2 & this.Ljava_time_format_ResolverStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_ResolverStyle$__SMART$lzycompute__Ljava_time_format_ResolverStyle(this) : this.Ljava_time_format_ResolverStyle$__f_SMART)
});
$c_Ljava_time_format_ResolverStyle$.prototype.LENIENT__Ljava_time_format_ResolverStyle = (function() {
  return (((((4 & this.Ljava_time_format_ResolverStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_ResolverStyle$__LENIENT$lzycompute__Ljava_time_format_ResolverStyle(this) : this.Ljava_time_format_ResolverStyle$__f_LENIENT)
});
var $d_Ljava_time_format_ResolverStyle$ = new $TypeData().initClass({
  Ljava_time_format_ResolverStyle$: 0
}, false, "java.time.format.ResolverStyle$", {
  Ljava_time_format_ResolverStyle$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_ResolverStyle$.prototype.$classData = $d_Ljava_time_format_ResolverStyle$;
var $n_Ljava_time_format_ResolverStyle$;
function $m_Ljava_time_format_ResolverStyle$() {
  if ((!$n_Ljava_time_format_ResolverStyle$)) {
    $n_Ljava_time_format_ResolverStyle$ = new $c_Ljava_time_format_ResolverStyle$()
  };
  return $n_Ljava_time_format_ResolverStyle$
}
function $p_Ljava_time_format_SignStyle$__NORMAL$lzycompute__Ljava_time_format_SignStyle($thiz) {
  if (((((1 & $thiz.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_SignStyle$__f_NORMAL = new $c_Ljava_time_format_SignStyle("NORMAL", 0);
    $thiz.Ljava_time_format_SignStyle$__f_bitmap$0 = (((1 | $thiz.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_SignStyle$__f_NORMAL
}
function $p_Ljava_time_format_SignStyle$__ALWAYS$lzycompute__Ljava_time_format_SignStyle($thiz) {
  if (((((2 & $thiz.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_SignStyle$__f_ALWAYS = new $c_Ljava_time_format_SignStyle("ALWAYS", 1);
    $thiz.Ljava_time_format_SignStyle$__f_bitmap$0 = (((2 | $thiz.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_SignStyle$__f_ALWAYS
}
function $p_Ljava_time_format_SignStyle$__NOT_NEGATIVE$lzycompute__Ljava_time_format_SignStyle($thiz) {
  if (((((8 & $thiz.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_SignStyle$__f_NOT_NEGATIVE = new $c_Ljava_time_format_SignStyle("NOT_NEGATIVE", 3);
    $thiz.Ljava_time_format_SignStyle$__f_bitmap$0 = (((8 | $thiz.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_SignStyle$__f_NOT_NEGATIVE
}
function $p_Ljava_time_format_SignStyle$__EXCEEDS_PAD$lzycompute__Ljava_time_format_SignStyle($thiz) {
  if (((((16 & $thiz.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_SignStyle$__f_EXCEEDS_PAD = new $c_Ljava_time_format_SignStyle("EXCEEDS_PAD", 4);
    $thiz.Ljava_time_format_SignStyle$__f_bitmap$0 = (((16 | $thiz.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_SignStyle$__f_EXCEEDS_PAD
}
/** @constructor */
function $c_Ljava_time_format_SignStyle$() {
  this.Ljava_time_format_SignStyle$__f_NORMAL = null;
  this.Ljava_time_format_SignStyle$__f_ALWAYS = null;
  this.Ljava_time_format_SignStyle$__f_NOT_NEGATIVE = null;
  this.Ljava_time_format_SignStyle$__f_EXCEEDS_PAD = null;
  this.Ljava_time_format_SignStyle$__f_bitmap$0 = 0
}
$c_Ljava_time_format_SignStyle$.prototype = new $h_O();
$c_Ljava_time_format_SignStyle$.prototype.constructor = $c_Ljava_time_format_SignStyle$;
/** @constructor */
function $h_Ljava_time_format_SignStyle$() {
  /*<skip>*/
}
$h_Ljava_time_format_SignStyle$.prototype = $c_Ljava_time_format_SignStyle$.prototype;
$c_Ljava_time_format_SignStyle$.prototype.NORMAL__Ljava_time_format_SignStyle = (function() {
  return (((((1 & this.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_SignStyle$__NORMAL$lzycompute__Ljava_time_format_SignStyle(this) : this.Ljava_time_format_SignStyle$__f_NORMAL)
});
$c_Ljava_time_format_SignStyle$.prototype.ALWAYS__Ljava_time_format_SignStyle = (function() {
  return (((((2 & this.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_SignStyle$__ALWAYS$lzycompute__Ljava_time_format_SignStyle(this) : this.Ljava_time_format_SignStyle$__f_ALWAYS)
});
$c_Ljava_time_format_SignStyle$.prototype.NOT_NEGATIVE__Ljava_time_format_SignStyle = (function() {
  return (((((8 & this.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_SignStyle$__NOT_NEGATIVE$lzycompute__Ljava_time_format_SignStyle(this) : this.Ljava_time_format_SignStyle$__f_NOT_NEGATIVE)
});
$c_Ljava_time_format_SignStyle$.prototype.EXCEEDS_PAD__Ljava_time_format_SignStyle = (function() {
  return (((((16 & this.Ljava_time_format_SignStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_SignStyle$__EXCEEDS_PAD$lzycompute__Ljava_time_format_SignStyle(this) : this.Ljava_time_format_SignStyle$__f_EXCEEDS_PAD)
});
var $d_Ljava_time_format_SignStyle$ = new $TypeData().initClass({
  Ljava_time_format_SignStyle$: 0
}, false, "java.time.format.SignStyle$", {
  Ljava_time_format_SignStyle$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_SignStyle$.prototype.$classData = $d_Ljava_time_format_SignStyle$;
var $n_Ljava_time_format_SignStyle$;
function $m_Ljava_time_format_SignStyle$() {
  if ((!$n_Ljava_time_format_SignStyle$)) {
    $n_Ljava_time_format_SignStyle$ = new $c_Ljava_time_format_SignStyle$()
  };
  return $n_Ljava_time_format_SignStyle$
}
function $p_Ljava_time_format_TextStyle$__FULL$lzycompute__Ljava_time_format_TextStyle($thiz) {
  if (((((1 & $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_TextStyle$__f_FULL = new $c_Ljava_time_format_TextStyle("FULL", 0);
    $thiz.Ljava_time_format_TextStyle$__f_bitmap$0 = (((1 | $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_TextStyle$__f_FULL
}
function $p_Ljava_time_format_TextStyle$__FULL_STANDALONE$lzycompute__Ljava_time_format_TextStyle($thiz) {
  if (((((2 & $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_TextStyle$__f_FULL_STANDALONE = new $c_Ljava_time_format_TextStyle("FULL_STANDALONE", 1);
    $thiz.Ljava_time_format_TextStyle$__f_bitmap$0 = (((2 | $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_TextStyle$__f_FULL_STANDALONE
}
function $p_Ljava_time_format_TextStyle$__SHORT$lzycompute__Ljava_time_format_TextStyle($thiz) {
  if (((((4 & $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_TextStyle$__f_SHORT = new $c_Ljava_time_format_TextStyle("SHORT", 2);
    $thiz.Ljava_time_format_TextStyle$__f_bitmap$0 = (((4 | $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_TextStyle$__f_SHORT
}
function $p_Ljava_time_format_TextStyle$__SHORT_STANDALONE$lzycompute__Ljava_time_format_TextStyle($thiz) {
  if (((((8 & $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_TextStyle$__f_SHORT_STANDALONE = new $c_Ljava_time_format_TextStyle("SHORT_STANDALONE", 3);
    $thiz.Ljava_time_format_TextStyle$__f_bitmap$0 = (((8 | $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_TextStyle$__f_SHORT_STANDALONE
}
function $p_Ljava_time_format_TextStyle$__NARROW$lzycompute__Ljava_time_format_TextStyle($thiz) {
  if (((((16 & $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_TextStyle$__f_NARROW = new $c_Ljava_time_format_TextStyle("NARROW", 4);
    $thiz.Ljava_time_format_TextStyle$__f_bitmap$0 = (((16 | $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_TextStyle$__f_NARROW
}
function $p_Ljava_time_format_TextStyle$__NARROW_STANDALONE$lzycompute__Ljava_time_format_TextStyle($thiz) {
  if (((((32 & $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_TextStyle$__f_NARROW_STANDALONE = new $c_Ljava_time_format_TextStyle("NARROW_STANDALONE", 5);
    $thiz.Ljava_time_format_TextStyle$__f_bitmap$0 = (((32 | $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_TextStyle$__f_NARROW_STANDALONE
}
function $p_Ljava_time_format_TextStyle$__values$lzycompute__ALjava_time_format_TextStyle($thiz) {
  if (((((64 & $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_TextStyle$__f_values = new ($d_Ljava_time_format_TextStyle.getArrayOf().constr)([$thiz.FULL__Ljava_time_format_TextStyle(), $thiz.FULL_STANDALONE__Ljava_time_format_TextStyle(), $thiz.SHORT__Ljava_time_format_TextStyle(), $thiz.SHORT_STANDALONE__Ljava_time_format_TextStyle(), $thiz.NARROW__Ljava_time_format_TextStyle(), $thiz.NARROW_STANDALONE__Ljava_time_format_TextStyle()]);
    $thiz.Ljava_time_format_TextStyle$__f_bitmap$0 = (((64 | $thiz.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_TextStyle$__f_values
}
/** @constructor */
function $c_Ljava_time_format_TextStyle$() {
  this.Ljava_time_format_TextStyle$__f_FULL = null;
  this.Ljava_time_format_TextStyle$__f_FULL_STANDALONE = null;
  this.Ljava_time_format_TextStyle$__f_SHORT = null;
  this.Ljava_time_format_TextStyle$__f_SHORT_STANDALONE = null;
  this.Ljava_time_format_TextStyle$__f_NARROW = null;
  this.Ljava_time_format_TextStyle$__f_NARROW_STANDALONE = null;
  this.Ljava_time_format_TextStyle$__f_values = null;
  this.Ljava_time_format_TextStyle$__f_bitmap$0 = 0
}
$c_Ljava_time_format_TextStyle$.prototype = new $h_O();
$c_Ljava_time_format_TextStyle$.prototype.constructor = $c_Ljava_time_format_TextStyle$;
/** @constructor */
function $h_Ljava_time_format_TextStyle$() {
  /*<skip>*/
}
$h_Ljava_time_format_TextStyle$.prototype = $c_Ljava_time_format_TextStyle$.prototype;
$c_Ljava_time_format_TextStyle$.prototype.FULL__Ljava_time_format_TextStyle = (function() {
  return (((((1 & this.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_TextStyle$__FULL$lzycompute__Ljava_time_format_TextStyle(this) : this.Ljava_time_format_TextStyle$__f_FULL)
});
$c_Ljava_time_format_TextStyle$.prototype.FULL_STANDALONE__Ljava_time_format_TextStyle = (function() {
  return (((((2 & this.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_TextStyle$__FULL_STANDALONE$lzycompute__Ljava_time_format_TextStyle(this) : this.Ljava_time_format_TextStyle$__f_FULL_STANDALONE)
});
$c_Ljava_time_format_TextStyle$.prototype.SHORT__Ljava_time_format_TextStyle = (function() {
  return (((((4 & this.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_TextStyle$__SHORT$lzycompute__Ljava_time_format_TextStyle(this) : this.Ljava_time_format_TextStyle$__f_SHORT)
});
$c_Ljava_time_format_TextStyle$.prototype.SHORT_STANDALONE__Ljava_time_format_TextStyle = (function() {
  return (((((8 & this.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_TextStyle$__SHORT_STANDALONE$lzycompute__Ljava_time_format_TextStyle(this) : this.Ljava_time_format_TextStyle$__f_SHORT_STANDALONE)
});
$c_Ljava_time_format_TextStyle$.prototype.NARROW__Ljava_time_format_TextStyle = (function() {
  return (((((16 & this.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_TextStyle$__NARROW$lzycompute__Ljava_time_format_TextStyle(this) : this.Ljava_time_format_TextStyle$__f_NARROW)
});
$c_Ljava_time_format_TextStyle$.prototype.NARROW_STANDALONE__Ljava_time_format_TextStyle = (function() {
  return (((((32 & this.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_TextStyle$__NARROW_STANDALONE$lzycompute__Ljava_time_format_TextStyle(this) : this.Ljava_time_format_TextStyle$__f_NARROW_STANDALONE)
});
$c_Ljava_time_format_TextStyle$.prototype.values__ALjava_time_format_TextStyle = (function() {
  return (((((64 & this.Ljava_time_format_TextStyle$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_TextStyle$__values$lzycompute__ALjava_time_format_TextStyle(this) : this.Ljava_time_format_TextStyle$__f_values)
});
var $d_Ljava_time_format_TextStyle$ = new $TypeData().initClass({
  Ljava_time_format_TextStyle$: 0
}, false, "java.time.format.TextStyle$", {
  Ljava_time_format_TextStyle$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_TextStyle$.prototype.$classData = $d_Ljava_time_format_TextStyle$;
var $n_Ljava_time_format_TextStyle$;
function $m_Ljava_time_format_TextStyle$() {
  if ((!$n_Ljava_time_format_TextStyle$)) {
    $n_Ljava_time_format_TextStyle$ = new $c_Ljava_time_format_TextStyle$()
  };
  return $n_Ljava_time_format_TextStyle$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser(literal) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal = literal
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var this$1 = $n(buf);
  var c = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal;
  var str = $as_T(String.fromCharCode(c));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I($n(text));
  if ((position === length)) {
    return (~position)
  };
  if (((position < 0) || (position > length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException())
  };
  var ch = $dp_charAt__I__C($n(text), position);
  if ((!$n(context).charEquals__C__C__Z(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal, ch))) {
    return (~position)
  };
  return ((1 + position) | 0)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.toString__T = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal === 39) ? "''" : (("'" + $bC(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal)) + "'"))
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser;
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__Z__($thiz, printerParsers, optional) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers = printerParsers;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional = optional;
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__($thiz, printerParsers, optional) {
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__Z__($thiz, $asArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser($n(printerParsers).toArray__AO__AO(new ($d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser.getArrayOf().constr)($n(printerParsers).size__I())), 1), optional);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional = false
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.withOptional__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser = (function(optional) {
  return ((optional === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers, optional))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var nonLocalReturnKey1 = $ct_O__(new $c_O());
  try {
    var length = $n(buf).length__I();
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
      $n(context).startOptional__V()
    };
    try {
      $m_sc_ArrayOps$();
      var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f = ((pp$2) => {
        var pp = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(pp$2);
        if ((!$n(pp).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf))) {
          $n(buf).setLength__I__V(length);
          throw new $c_sr_NonLocalReturnControl$mcZ$sp(nonLocalReturnKey1, true)
        }
      });
      var len = $n(xs).u.length;
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var arg1 = $n(xs).get(i);
          f(arg1);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_I)) {
        var x3 = $asArrayOf_I(xs, 1);
        while ((i < len)) {
          var arg1$1 = $n(x3).get(i);
          f(arg1$1);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_D)) {
        var x4 = $asArrayOf_D(xs, 1);
        while ((i < len)) {
          var arg1$2 = $n(x4).get(i);
          f(arg1$2);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_J)) {
        var x5 = $asArrayOf_J(xs, 1);
        while ((i < len)) {
          var t = $n(x5).get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_F)) {
        var x6 = $asArrayOf_F(xs, 1);
        while ((i < len)) {
          var arg1$3 = $n(x6).get(i);
          f(arg1$3);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_C)) {
        var x7 = $asArrayOf_C(xs, 1);
        while ((i < len)) {
          var arg1$4 = $n(x7).get(i);
          f($bC(arg1$4));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_B)) {
        var x8 = $asArrayOf_B(xs, 1);
        while ((i < len)) {
          var arg1$5 = $n(x8).get(i);
          f(arg1$5);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_S)) {
        var x9 = $asArrayOf_S(xs, 1);
        while ((i < len)) {
          var arg1$6 = $n(x9).get(i);
          f(arg1$6);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(xs, 1);
        while ((i < len)) {
          var arg1$7 = $n(x10).get(i);
          f(arg1$7);
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(xs)
      }
    } finally {
      if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
        $n(context).endOptional__V()
      }
    };
    return true
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = $as_sr_NonLocalReturnControl(e);
      if (($n(ex).sr_NonLocalReturnControl__f_key === nonLocalReturnKey1)) {
        return $n(ex).value$mcZ$sp__Z()
      } else {
        throw ((ex === null) ? $n(null) : ex)
      }
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var nonLocalReturnKey2 = $ct_O__(new $c_O());
  try {
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
      $n(context).startOptional__V();
      var pos = new $c_sr_IntRef(position);
      $m_sc_ArrayOps$();
      var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f = ((pp$2) => {
        var pp = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(pp$2);
        pos.sr_IntRef__f_elem = $n(pp).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, pos.sr_IntRef__f_elem);
        if ((pos.sr_IntRef__f_elem < 0)) {
          $n(context).endOptional__Z__V(false);
          throw new $c_sr_NonLocalReturnControl$mcI$sp(nonLocalReturnKey2, position)
        }
      });
      var len = $n(xs).u.length;
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var arg1 = $n(xs).get(i);
          f(arg1);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_I)) {
        var x3 = $asArrayOf_I(xs, 1);
        while ((i < len)) {
          var arg1$1 = $n(x3).get(i);
          f(arg1$1);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_D)) {
        var x4 = $asArrayOf_D(xs, 1);
        while ((i < len)) {
          var arg1$2 = $n(x4).get(i);
          f(arg1$2);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_J)) {
        var x5 = $asArrayOf_J(xs, 1);
        while ((i < len)) {
          var t = $n(x5).get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_F)) {
        var x6 = $asArrayOf_F(xs, 1);
        while ((i < len)) {
          var arg1$3 = $n(x6).get(i);
          f(arg1$3);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_C)) {
        var x7 = $asArrayOf_C(xs, 1);
        while ((i < len)) {
          var arg1$4 = $n(x7).get(i);
          f($bC(arg1$4));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_B)) {
        var x8 = $asArrayOf_B(xs, 1);
        while ((i < len)) {
          var arg1$5 = $n(x8).get(i);
          f(arg1$5);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_S)) {
        var x9 = $asArrayOf_S(xs, 1);
        while ((i < len)) {
          var arg1$6 = $n(x9).get(i);
          f(arg1$6);
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(xs, 1);
        while ((i < len)) {
          var arg1$7 = $n(x10).get(i);
          f(arg1$7);
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(xs)
      };
      $n(context).endOptional__Z__V(true);
      return pos.sr_IntRef__f_elem
    } else {
      $m_sc_ArrayOps$();
      var xs$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f$1 = ((x0$1$2, x1$1$2) => {
        var x0$1 = $uI(x0$1$2);
        var x1$1 = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(x1$1$2);
        return ((x0$1 < 0) ? x0$1 : $n(x1$1).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, x0$1))
      });
      if ((xs$1 === null)) {
        throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
      };
      if ((xs$1 !== null)) {
        var length = $n(xs$1).u.length;
        var v = position;
        var i$1 = 0;
        while ((i$1 < length)) {
          var arg1$8 = v;
          var x1 = i$1;
          var arg2 = $n(xs$1).get(x1);
          v = f$1(arg1$8, arg2);
          i$1 = ((1 + i$1) | 0)
        };
        var $$x1 = v
      } else if ((xs$1 instanceof $ac_I)) {
        var x4$1 = $asArrayOf_I(xs$1, 1);
        var length$1 = $n(x4$1).u.length;
        var v$1 = position;
        var i$2 = 0;
        while ((i$2 < length$1)) {
          var arg1$9 = v$1;
          var arg2$1 = $n(x4$1).get(i$2);
          v$1 = f$1(arg1$9, arg2$1);
          i$2 = ((1 + i$2) | 0)
        };
        var $$x1 = v$1
      } else if ((xs$1 instanceof $ac_D)) {
        var x5$1 = $asArrayOf_D(xs$1, 1);
        var length$2 = $n(x5$1).u.length;
        var v$2 = position;
        var i$3 = 0;
        while ((i$3 < length$2)) {
          var arg1$10 = v$2;
          var arg2$2 = $n(x5$1).get(i$3);
          v$2 = f$1(arg1$10, arg2$2);
          i$3 = ((1 + i$3) | 0)
        };
        var $$x1 = v$2
      } else if ((xs$1 instanceof $ac_J)) {
        var x6$1 = $asArrayOf_J(xs$1, 1);
        var length$3 = $n(x6$1).u.length;
        var v$3 = position;
        var i$4 = 0;
        while ((i$4 < length$3)) {
          var arg1$11 = v$3;
          var t$1 = $n(x6$1).get(i$4);
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          v$3 = f$1(arg1$11, new $c_RTLong(lo$1, hi$1));
          i$4 = ((1 + i$4) | 0)
        };
        var $$x1 = v$3
      } else if ((xs$1 instanceof $ac_F)) {
        var x7$1 = $asArrayOf_F(xs$1, 1);
        var length$4 = $n(x7$1).u.length;
        var v$4 = position;
        var i$5 = 0;
        while ((i$5 < length$4)) {
          var arg1$12 = v$4;
          var arg2$3 = $n(x7$1).get(i$5);
          v$4 = f$1(arg1$12, arg2$3);
          i$5 = ((1 + i$5) | 0)
        };
        var $$x1 = v$4
      } else if ((xs$1 instanceof $ac_C)) {
        var x8$1 = $asArrayOf_C(xs$1, 1);
        var length$5 = $n(x8$1).u.length;
        var v$5 = position;
        var i$6 = 0;
        while ((i$6 < length$5)) {
          var arg1$13 = v$5;
          var arg2$4 = $n(x8$1).get(i$6);
          v$5 = f$1(arg1$13, $bC(arg2$4));
          i$6 = ((1 + i$6) | 0)
        };
        var $$x1 = v$5
      } else if ((xs$1 instanceof $ac_B)) {
        var x9$1 = $asArrayOf_B(xs$1, 1);
        var length$6 = $n(x9$1).u.length;
        var v$6 = position;
        var i$7 = 0;
        while ((i$7 < length$6)) {
          var arg1$14 = v$6;
          var arg2$5 = $n(x9$1).get(i$7);
          v$6 = f$1(arg1$14, arg2$5);
          i$7 = ((1 + i$7) | 0)
        };
        var $$x1 = v$6
      } else if ((xs$1 instanceof $ac_S)) {
        var x10$1 = $asArrayOf_S(xs$1, 1);
        var length$7 = $n(x10$1).u.length;
        var v$7 = position;
        var i$8 = 0;
        while ((i$8 < length$7)) {
          var arg1$15 = v$7;
          var arg2$6 = $n(x10$1).get(i$8);
          v$7 = f$1(arg1$15, arg2$6);
          i$8 = ((1 + i$8) | 0)
        };
        var $$x1 = v$7
      } else if ((xs$1 instanceof $ac_Z)) {
        var x11 = $asArrayOf_Z(xs$1, 1);
        var length$8 = $n(x11).u.length;
        var v$8 = position;
        var i$9 = 0;
        while ((i$9 < length$8)) {
          var arg1$16 = v$8;
          var arg2$7 = $n(x11).get(i$9);
          v$8 = f$1(arg1$16, arg2$7);
          i$9 = ((1 + i$9) | 0)
        };
        var $$x1 = v$8
      } else {
        if ((!$isArrayOf_jl_Void(xs$1, 1))) {
          throw new $c_s_MatchError(xs$1)
        };
        var x12 = $asArrayOf_jl_Void(xs$1, 1);
        var length$9 = $n(x12).u.length;
        var v$9 = position;
        var i$10 = 0;
        while ((i$10 < length$9)) {
          var arg1$17 = v$9;
          var arg2$8 = $n(x12).get(i$10);
          v$9 = f$1(arg1$17, arg2$8);
          i$10 = ((1 + i$10) | 0)
        };
        var $$x1 = v$9
      };
      return $uI($$x1)
    }
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = $as_sr_NonLocalReturnControl(e);
      if (($n(ex).sr_NonLocalReturnControl__f_key === nonLocalReturnKey2)) {
        return $n(ex).value$mcI$sp__I()
      } else {
        throw ((ex === null) ? $n(null) : ex)
      }
    } else {
      throw e
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.toString__T = (function() {
  var buf = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers !== null)) {
    var str = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional ? "[" : "(");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    $m_sc_ArrayOps$();
    var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
    var f = ((pp$2) => {
      var pp = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(pp$2);
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + pp);
      return buf
    });
    var len = $n(xs).u.length;
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var arg1 = $n(xs).get(i);
        f(arg1);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var arg1$1 = $n(x3).get(i);
        f(arg1$1);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var arg1$2 = $n(x4).get(i);
        f(arg1$2);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var t = $n(x5).get(i);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        f(new $c_RTLong(lo, hi));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var arg1$3 = $n(x6).get(i);
        f(arg1$3);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var arg1$4 = $n(x7).get(i);
        f($bC(arg1$4));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var arg1$5 = $n(x8).get(i);
        f(arg1$5);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var arg1$6 = $n(x9).get(i);
        f(arg1$6);
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var arg1$7 = $n(x10).get(i);
        f(arg1$7);
        i = ((1 + i) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs)
    };
    var str$1 = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional ? "]" : ")");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1)
  };
  return buf.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$CompositePrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal($thiz, value) {
  var range = $n($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field).range__Ljava_time_temporal_ValueRange();
  $n(range).checkValidValue__J__Ljava_time_temporal_TemporalField__J($uJ(value), $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field);
  var this$2 = $n(range);
  var t = this$2.Ljava_time_temporal_ValueRange__f_minSmallest;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var minBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi));
  var this$3 = $n(range);
  var t$1 = this$3.Ljava_time_temporal_ValueRange__f_maxLargest;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var rangeBD = $n($n($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1))).subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD)).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ONE);
  var t$2 = $uJ(value);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var valueBD = $n($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo$2, hi$2))).subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD);
  var fraction = $n(valueBD).divide__Ljava_math_BigDecimal__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(rangeBD, 9, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR);
  return (($n(fraction).compareTo__Ljava_math_BigDecimal__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO) === 0) ? $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO : $n(fraction).stripTrailingZeros__Ljava_math_BigDecimal())
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long($thiz, fraction) {
  var range = $n($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field).range__Ljava_time_temporal_ValueRange();
  var this$1 = $n(range);
  var t = this$1.Ljava_time_temporal_ValueRange__f_minSmallest;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var minBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi));
  var this$2 = $n(range);
  var t$1 = this$2.Ljava_time_temporal_ValueRange__f_maxLargest;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var rangeBD = $n($n($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1))).subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD)).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ONE);
  var this$3 = $n($n($n($n(fraction).multiply__Ljava_math_BigDecimal__Ljava_math_BigDecimal(rangeBD)).setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(0, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR)).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD));
  var t$2 = $p_Ljava_math_BigDecimal__valueExact__I__J(this$3, 64);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  return new $c_RTLong(lo$2, hi$2)
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint = false;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field = field;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth = minWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth = maxWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint = decimalPoint;
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  if ((!$n($n(field).range__Ljava_time_temporal_ValueRange()).isFixed__Z())) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Field must have a fixed set of values: " + field))
  };
  if (((minWidth < 0) || (minWidth > 9))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Minimum width must be from 0 to 9 inclusive but was " + minWidth))
  };
  if (((maxWidth < 1) || (maxWidth > 9))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Maximum width must be from 1 to 9 inclusive but was " + maxWidth))
  };
  if ((maxWidth < minWidth)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("Maximum width must exceed or equal the minimum width but " + maxWidth) + " < ") + minWidth))
  }
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var value = $n(context).getValue__Ljava_time_temporal_TemporalField__jl_Long(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field);
  if ((value === null)) {
    return false
  };
  var this$1 = $n(context);
  var symbols = this$1.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols;
  var fraction = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal(this, value);
  var this$2 = $n(fraction);
  if ((this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
    if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth > 0)) {
      if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint) {
        var this$4 = $n(buf);
        var this$3 = $n(symbols);
        var c = this$3.Ljava_time_format_DecimalStyle__f_decimalSeparator;
        var str = $as_T(String.fromCharCode(c));
        this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
      };
      var i = 0;
      while ((i < this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth)) {
        var this$7 = $n(buf);
        var this$6 = $n(symbols);
        var c$1 = this$6.Ljava_time_format_DecimalStyle__f_zeroDigit;
        var str$1 = $as_T(String.fromCharCode(c$1));
        this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
        i = ((1 + i) | 0)
      }
    }
  } else {
    var this$9 = $n(fraction);
    var a = this$9.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var b = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth;
    var a$1 = ((a > b) ? a : b);
    var b$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth;
    var outputScale = ((a$1 < b$1) ? a$1 : b$1);
    fraction = $n(fraction).setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(outputScale, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR);
    var this$12 = $n($n(fraction).toPlainString__T());
    if ((this$12.length < 2)) {
      $charAt(this$12, 2)
    };
    var str$2 = $as_T(this$12.substring(2));
    str$2 = $n(symbols).convertNumberToI18N__T__T(str$2);
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint) {
      var this$14 = $n(buf);
      var this$13 = $n(symbols);
      var c$2 = this$13.Ljava_time_format_DecimalStyle__f_decimalSeparator;
      var str$3 = $as_T(String.fromCharCode(c$2));
      this$14.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$14.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3)
    };
    var this$16 = $n(buf);
    var str$4 = str$2;
    this$16.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$16.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$4)
  };
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _position = position;
  var this$1 = $n(context);
  if (this$1.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict) {
    var effectiveMin = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth
  } else {
    var effectiveMin = 0
  };
  var this$2 = $n(context);
  if (this$2.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict) {
    var effectiveMax = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth
  } else {
    var effectiveMax = 9
  };
  var length = $dp_length__I($n(text));
  if ((_position === length)) {
    return ((effectiveMin > 0) ? (~_position) : _position)
  };
  if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint) {
    var $$x1 = $dp_charAt__I__C($n(text), _position);
    var this$3 = $n(context);
    var this$4 = $n(this$3.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols);
    if (($$x1 !== this$4.Ljava_time_format_DecimalStyle__f_decimalSeparator)) {
      return ((effectiveMin > 0) ? (~_position) : _position)
    };
    _position = ((1 + _position) | 0)
  };
  var minEndPos = ((_position + effectiveMin) | 0);
  if ((minEndPos > length)) {
    return (~_position)
  };
  var a = ((_position + effectiveMax) | 0);
  var maxEndPos = ((a < length) ? a : length);
  var total = 0;
  var pos = _position;
  var break$1 = false;
  while (((!break$1) && (pos < maxEndPos))) {
    var ch = $dp_charAt__I__C($n(text), pos);
    pos = ((1 + pos) | 0);
    var this$6 = $n(context);
    var digit = $n(this$6.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols).convertToDigit__C__I(ch);
    if ((digit < 0)) {
      if ((pos < minEndPos)) {
        return (~_position)
      };
      pos = (((-1) + pos) | 0);
      break$1 = true
    };
    if ((!break$1)) {
      total = ((Math.imul(10, total) + digit) | 0)
    }
  };
  var fraction = $ct_Ljava_math_BigDecimal__I__(new $c_Ljava_math_BigDecimal(), total).movePointLeft__I__Ljava_math_BigDecimal(((pos - _position) | 0));
  var value = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long(this, fraction);
  return $n(context).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field, $uJ(value), _position, pos)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.toString__T = (function() {
  var decimal = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint ? ",DecimalPoint" : "");
  return ((((((("Fraction(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth) + decimal) + ")")
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$FractionPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser(fractionalDigits) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits = fractionalDigits
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var inSecs = $n(context).getValue__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
  var inNanos = $L0;
  var this$2 = $n(context);
  if ($n(this$2.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var this$3 = $n(context);
    var t = $n(this$3.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    inNanos = new $c_RTLong(lo, hi)
  };
  if ((inSecs === null)) {
    return false
  };
  var this$6 = $n($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  var x = inNanos;
  var t$1 = $uJ(x);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var inNano = $n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$1, hi$1), this$6);
  var this$12 = $uJ(inSecs);
  var x$1 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_0000_TO_1970__jl_Long();
  var this$9 = $uJ(x$1);
  var lo$2 = this$9.RTLong__f_lo;
  var hi$2 = this$9.RTLong__f_hi;
  var lo$3 = ((-lo$2) | 0);
  var hi$3 = ((lo$2 !== 0) ? (~hi$2) : ((-hi$2) | 0));
  var ahi = this$12.RTLong__f_hi;
  if (((ahi === hi$3) ? (((-2147483648) ^ this$12.RTLong__f_lo) >= ((-2147483648) ^ lo$3)) : (ahi > hi$3))) {
    var this$15 = $uJ(inSecs);
    var x$2 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS__jl_Long();
    var b = $uJ(x$2);
    var alo = this$15.RTLong__f_lo;
    var ahi$1 = this$15.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    var lo$4 = ((alo - b.RTLong__f_lo) | 0);
    var hi$4 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi$1 - bhi) | 0)) | 0) : ((ahi$1 - bhi) | 0));
    var x$3 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_0000_TO_1970__jl_Long();
    var b$1 = $uJ(x$3);
    var bhi$1 = b$1.RTLong__f_hi;
    var lo$5 = ((lo$4 + b$1.RTLong__f_lo) | 0);
    var hi$5 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$4 + bhi$1) | 0)) | 0) : ((hi$4 + bhi$1) | 0));
    var t$2 = $uJ(new $c_RTLong(lo$5, hi$5));
    var lo$6 = t$2.RTLong__f_lo;
    var hi$6 = t$2.RTLong__f_hi;
    var x$4 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS__jl_Long();
    var t$3 = $uJ(x$4);
    var lo$7 = t$3.RTLong__f_lo;
    var hi$7 = t$3.RTLong__f_hi;
    var b$2 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo$6, hi$6), new $c_RTLong(lo$7, hi$7));
    var bhi$2 = b$2.RTLong__f_hi;
    var lo$8 = ((1 + b$2.RTLong__f_lo) | 0);
    var hi$8 = ((lo$8 === 0) ? ((1 + bhi$2) | 0) : bhi$2);
    var t$4 = $uJ(new $c_RTLong(lo$5, hi$5));
    var lo$9 = t$4.RTLong__f_lo;
    var hi$9 = t$4.RTLong__f_hi;
    var x$5 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS__jl_Long();
    var t$5 = $uJ(x$5);
    var lo$10 = t$5.RTLong__f_lo;
    var hi$10 = t$5.RTLong__f_hi;
    var t$6 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo$9, hi$9), new $c_RTLong(lo$10, hi$10));
    var lo$11 = t$6.RTLong__f_lo;
    var hi$11 = t$6.RTLong__f_hi;
    var $$x1 = $m_Ljava_time_LocalDateTime$();
    var this$29 = $uJ(new $c_RTLong(lo$11, hi$11));
    var x$6 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_0000_TO_1970__jl_Long();
    var b$3 = $uJ(x$6);
    var alo$1 = this$29.RTLong__f_lo;
    var ahi$2 = this$29.RTLong__f_hi;
    var bhi$3 = b$3.RTLong__f_hi;
    var lo$12 = ((alo$1 - b$3.RTLong__f_lo) | 0);
    var hi$12 = ((((-2147483648) ^ lo$12) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$2 - bhi$3) | 0)) | 0) : ((ahi$2 - bhi$3) | 0));
    var ldt = $n($$x1).ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(new $c_RTLong(lo$12, hi$12), 0, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var this$32 = $uJ(new $c_RTLong(lo$8, hi$8));
    var ahi$3 = this$32.RTLong__f_hi;
    if (((ahi$3 === 0) ? (this$32.RTLong__f_lo !== 0) : (ahi$3 > 0))) {
      var this$33 = $n(buf);
      var str = $as_T(String.fromCharCode(43));
      this$33.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$33.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      this$33.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$33.jl_StringBuilder__f_java$lang$StringBuilder$$content) + new $c_RTLong(lo$8, hi$8))
    };
    var this$35 = $n(buf);
    this$35.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$35.jl_StringBuilder__f_java$lang$StringBuilder$$content) + ldt);
    var this$36 = $n(ldt);
    var this$37 = $n(this$36.Ljava_time_LocalDateTime__f_time);
    if (($p_Ljava_time_LocalTime__second__B(this$37) === 0)) {
      var this$38 = $n(buf);
      this$38.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$38.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":00")
    }
  } else {
    var this$41 = $uJ(inSecs);
    var x$7 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_0000_TO_1970__jl_Long();
    var b$4 = $uJ(x$7);
    var alo$2 = this$41.RTLong__f_lo;
    var ahi$4 = this$41.RTLong__f_hi;
    var bhi$4 = b$4.RTLong__f_hi;
    var lo$13 = ((alo$2 + b$4.RTLong__f_lo) | 0);
    var hi$13 = ((((-2147483648) ^ lo$13) < ((-2147483648) ^ alo$2)) ? ((1 + ((ahi$4 + bhi$4) | 0)) | 0) : ((ahi$4 + bhi$4) | 0));
    var this$46 = $uJ(new $c_RTLong(lo$13, hi$13));
    var x$8 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS__jl_Long();
    var b$5 = $uJ(x$8);
    var this$47 = $m_RTLong$();
    var lo$14 = this$47.divideImpl__I__I__I__I__I(this$46.RTLong__f_lo, this$46.RTLong__f_hi, b$5.RTLong__f_lo, b$5.RTLong__f_hi);
    var hi$14 = this$47.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$51 = $uJ(new $c_RTLong(lo$13, hi$13));
    var x$9 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS__jl_Long();
    var b$6 = $uJ(x$9);
    var this$52 = $m_RTLong$();
    var lo$15 = this$52.remainderImpl__I__I__I__I__I(this$51.RTLong__f_lo, this$51.RTLong__f_hi, b$6.RTLong__f_lo, b$6.RTLong__f_hi);
    var hi$15 = this$52.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $$x2 = $m_Ljava_time_LocalDateTime$();
    var this$56 = $uJ(new $c_RTLong(lo$15, hi$15));
    var x$10 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_0000_TO_1970__jl_Long();
    var b$7 = $uJ(x$10);
    var alo$3 = this$56.RTLong__f_lo;
    var ahi$5 = this$56.RTLong__f_hi;
    var bhi$5 = b$7.RTLong__f_hi;
    var lo$16 = ((alo$3 - b$7.RTLong__f_lo) | 0);
    var hi$16 = ((((-2147483648) ^ lo$16) > ((-2147483648) ^ alo$3)) ? (((-1) + ((ahi$5 - bhi$5) | 0)) | 0) : ((ahi$5 - bhi$5) | 0));
    var ldt$2 = $n($$x2).ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(new $c_RTLong(lo$16, hi$16), 0, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var pos = $n(buf).length__I();
    var this$58 = $n(buf);
    this$58.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$58.jl_StringBuilder__f_java$lang$StringBuilder$$content) + ldt$2);
    var this$59 = $n(ldt$2);
    var this$60 = $n(this$59.Ljava_time_LocalDateTime__f_time);
    if (($p_Ljava_time_LocalTime__second__B(this$60) === 0)) {
      var this$61 = $n(buf);
      this$61.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$61.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":00")
    };
    var this$63 = $uJ(new $c_RTLong(lo$14, hi$14));
    var ahi$6 = this$63.RTLong__f_hi;
    if ((ahi$6 < 0)) {
      var this$64 = $n(ldt$2);
      var this$65 = $n(this$64.Ljava_time_LocalDateTime__f_date);
      if ((this$65.Ljava_time_LocalDate__f_year === (-10000))) {
        var $$x3 = $n(buf);
        var b$8 = $uJ(new $c_RTLong(lo$14, hi$14));
        var bhi$6 = b$8.RTLong__f_hi;
        var lo$17 = (((-1) + b$8.RTLong__f_lo) | 0);
        var hi$17 = ((lo$17 !== (-1)) ? bhi$6 : (((-1) + bhi$6) | 0));
        $n($$x3).replace__I__I__T__jl_StringBuilder(pos, ((2 + pos) | 0), $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$17, hi$17))
      } else if ($m_sr_BoxesRunTime$().equalsNumObject__jl_Number__O__Z(new $c_RTLong(lo$15, hi$15), 0)) {
        var this$68 = $n(buf);
        this$68.insert__I__T__jl_StringBuilder(pos, ("" + new $c_RTLong(lo$14, hi$14)))
      } else {
        var this$74 = $n(buf);
        var offset = ((1 + pos) | 0);
        var t$7 = $uJ(new $c_RTLong(lo$14, hi$14));
        var lo$18 = t$7.RTLong__f_lo;
        var hi$18 = t$7.RTLong__f_hi;
        if ((hi$18 < 0)) {
          var lo$19 = ((-lo$18) | 0);
          var hi$19 = ((lo$18 !== 0) ? (~hi$18) : ((-hi$18) | 0));
          var l__lo = lo$19;
          var l__hi = hi$19
        } else {
          var l__lo = lo$18;
          var l__hi = hi$18
        };
        this$74.insert__I__T__jl_StringBuilder(offset, $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(l__lo, l__hi))
      }
    }
  };
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-2))) {
    if ((inNano !== 0)) {
      var this$75 = $n(buf);
      var str$1 = $as_T(String.fromCharCode(46));
      this$75.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$75.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
      if ((((inNano % 1000000) | 0) === 0)) {
        var this$79 = $n(buf);
        var i = ((1000 + ((inNano / 1000000) | 0)) | 0);
        var this$78 = ("" + i);
        if ((this$78.length < 1)) {
          $charAt(this$78, 1)
        };
        var str$2 = $as_T(this$78.substring(1));
        this$79.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$79.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2)
      } else if ((((inNano % 1000) | 0) === 0)) {
        var this$82 = $n(buf);
        var i$1 = ((1000000 + ((inNano / 1000) | 0)) | 0);
        var this$81 = ("" + i$1);
        if ((this$81.length < 1)) {
          $charAt(this$81, 1)
        };
        var str$3 = $as_T(this$81.substring(1));
        this$82.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$82.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3)
      } else {
        var this$85 = $n(buf);
        var i$2 = ((1000000000 + inNano) | 0);
        var this$84 = ("" + i$2);
        if ((this$84.length < 1)) {
          $charAt(this$84, 1)
        };
        var str$4 = $as_T(this$84.substring(1));
        this$85.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$85.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$4)
      }
    }
  } else if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits > 0) || ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-1)) && (inNano > 0)))) {
    var this$86 = $n(buf);
    var str$5 = $as_T(String.fromCharCode(46));
    this$86.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$86.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$5);
    var div = 100000000;
    var i$3 = 0;
    while ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-1)) && (inNano > 0)) || (i$3 < this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits))) {
      var digit = $intDiv(inNano, div);
      var this$88 = $n(buf);
      var c = (65535 & ((48 + digit) | 0));
      var str$6 = $as_T(String.fromCharCode(c));
      this$88.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$88.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$6);
      inNano = ((inNano - Math.imul(digit, div)) | 0);
      div = ((div / 10) | 0);
      i$3 = ((1 + i$3) | 0)
    }
  };
  var this$90 = $n(buf);
  var str$7 = $as_T(String.fromCharCode(90));
  this$90.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$90.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$7);
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var this$1 = $n(context);
  var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), this$1);
  var minDigits = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits < 0) ? 0 : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits);
  var maxDigits = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits < 0) ? 9 : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits);
  var this$2 = $n($n($n($n($n($n($n($n($n($ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_DateTimeFormatter$().ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter())).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(84)).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), 2)).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58)).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), 2)).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58)).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), 2)).appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), minDigits, maxDigits, true)).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(90));
  var this$3 = $m_ju_Locale$();
  var this$4 = $n(this$2.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter($p_ju_Locale$__defaultLocale__ju_Locale(this$3)));
  var parser = $n(this$4.Ljava_time_format_DateTimeFormatter__f_printerParser).withOptional__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(false);
  var pos = $n(parser).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(newContext, text, position);
  if ((pos < 0)) {
    return pos
  };
  var yearParsed = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  var this$5 = $n(newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
  var month = this$5.RTLong__f_lo;
  var this$6 = $n(newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField()));
  var day = this$6.RTLong__f_lo;
  var this$7 = $n(newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField()));
  var hour = this$7.RTLong__f_lo;
  var this$8 = $n(newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField()));
  var min = this$8.RTLong__f_lo;
  var secVal = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  var nanoVal = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  if ((secVal !== null)) {
    var this$9 = $n(secVal);
    var sec = this$9.RTLong__f_lo
  } else {
    var sec = 0
  };
  if ((nanoVal !== null)) {
    var this$10 = $n(nanoVal);
    var nano = this$10.RTLong__f_lo
  } else {
    var nano = 0
  };
  var this$12 = $uJ(yearParsed);
  var year = ((this$12.RTLong__f_lo % 10000) | 0);
  var days = 0;
  if (((((hour === 24) && (min === 0)) && (sec === 0)) && (nano === 0))) {
    hour = 0;
    days = 1
  } else if ((((hour === 23) && (min === 59)) && (sec === 60))) {
    var this$13 = $n(context);
    $n($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this$13)).leapSecond_$eq__Z__V(true);
    sec = 59
  };
  var instantSecs = $L0;
  try {
    var $$x1 = $n($m_Ljava_time_LocalDateTime$().of__I__I__I__I__I__I__I__Ljava_time_LocalDateTime(year, month, day, hour, min, sec, 0));
    var value = days;
    var hi = (value >> 31);
    var ldt = $n($$x1).plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(value, hi));
    var t = $n(ldt).toEpochSecond__Ljava_time_ZoneOffset__J($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var lo = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    instantSecs = new $c_RTLong(lo, hi$1);
    var x = instantSecs;
    var this$22 = $uJ(x);
    var this$19 = $uJ(yearParsed);
    var this$20 = $m_RTLong$();
    var lo$1 = this$20.divideImpl__I__I__I__I__I(this$19.RTLong__f_lo, this$19.RTLong__f_hi, 10000, 0);
    var hi$2 = this$20.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var x$1 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$SECONDS_PER_10000_YEARS__jl_Long();
    var t$1 = $uJ(x$1);
    var lo$2 = t$1.RTLong__f_lo;
    var hi$3 = t$1.RTLong__f_hi;
    var b = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$1, hi$2), new $c_RTLong(lo$2, hi$3));
    var alo = this$22.RTLong__f_lo;
    var ahi = this$22.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    var lo$3 = ((alo + b.RTLong__f_lo) | 0);
    var hi$4 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
    instantSecs = new $c_RTLong(lo$3, hi$4)
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    if ((e$2 instanceof $c_jl_RuntimeException)) {
      return (~position)
    } else {
      throw e
    }
  };
  var successPos = pos;
  var $$x3 = $n(context);
  var $$x2 = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
  var x$2 = instantSecs;
  successPos = $n($$x3).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($$x2, $uJ(x$2), position, successPos);
  var $$x5 = $n(context);
  var $$x4 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi$5 = (nano >> 31);
  return $n($$x5).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($$x4, new $c_RTLong(nano, hi$5), position, successPos)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.toString__T = (function() {
  return "Instant()"
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser(style) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser__f_style = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser__f_style = style
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var offsetSecs = $n(context).getValue__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
  if ((offsetSecs === null)) {
    return false
  };
  var this$1 = $n(buf);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + "GMT");
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser__f_style === $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle())) {
    return new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser("", "+HH:MM:ss").print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf)
  };
  var t = $uJ(offsetSecs);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var totalSecs = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo, hi));
  if ((totalSecs !== 0)) {
    var a = ((((totalSecs / 3600) | 0) % 100) | 0);
    var absHours = ((a < 0) ? ((-a) | 0) : a);
    var a$1 = ((((totalSecs / 60) | 0) % 60) | 0);
    var absMinutes = ((a$1 < 0) ? ((-a$1) | 0) : a$1);
    var a$2 = ((totalSecs % 60) | 0);
    var absSeconds = ((a$2 < 0) ? ((-a$2) | 0) : a$2);
    var this$6 = $n(buf);
    var str = ((totalSecs < 0) ? "-" : "+");
    this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    var str$1 = ("" + absHours);
    this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
    if (((absMinutes > 0) || (absSeconds > 0))) {
      var this$8 = $n(buf);
      this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":");
      var c = (65535 & ((48 + ((absMinutes / 10) | 0)) | 0));
      var str$2 = $as_T(String.fromCharCode(c));
      this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
      var c$1 = (65535 & ((48 + ((absMinutes % 10) | 0)) | 0));
      var str$3 = $as_T(String.fromCharCode(c$1));
      this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3);
      if ((absSeconds > 0)) {
        var this$11 = $n(buf);
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":");
        var c$2 = (65535 & ((48 + ((absSeconds / 10) | 0)) | 0));
        var str$4 = $as_T(String.fromCharCode(c$2));
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$4);
        var c$3 = (65535 & ((48 + ((absSeconds % 10) | 0)) | 0));
        var str$5 = $as_T(String.fromCharCode(c$3));
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$5)
      }
    }
  };
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _position = position;
  if ((!$n(context).subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(text, _position, "GMT", 0, 3))) {
    return (~_position)
  };
  _position = ((3 + _position) | 0);
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser__f_style === $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle())) {
    return new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser("", "+HH:MM:ss").parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, _position)
  };
  var end = $dp_length__I($n(text));
  if ((_position === end)) {
    return $n(context).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, _position, _position)
  };
  var sign = $dp_charAt__I__C($n(text), _position);
  if (((sign !== 43) && (sign !== 45))) {
    return $n(context).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, _position, _position)
  };
  var negative = ((sign === 45) ? (-1) : 1);
  if ((_position === end)) {
    return (~_position)
  };
  _position = ((1 + _position) | 0);
  var ch = $dp_charAt__I__C($n(text), _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position)
  };
  _position = ((1 + _position) | 0);
  var hour = (((-48) + ch) | 0);
  if ((_position !== end)) {
    ch = $dp_charAt__I__C($n(text), _position);
    if (((ch >= 48) && (ch <= 57))) {
      hour = ((Math.imul(10, hour) + (((-48) + ch) | 0)) | 0);
      if ((hour > 23)) {
        return (~_position)
      };
      _position = ((1 + _position) | 0)
    }
  };
  if (((_position === end) || ($dp_charAt__I__C($n(text), _position) !== 58))) {
    var offset = Math.imul(Math.imul(3600, negative), hour);
    var $$x2 = $n(context);
    var $$x1 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    var hi = (offset >> 31);
    return $n($$x2).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($$x1, new $c_RTLong(offset, hi), _position, _position)
  };
  _position = ((1 + _position) | 0);
  if ((_position > (((-2) + end) | 0))) {
    return (~_position)
  };
  ch = $dp_charAt__I__C($n(text), _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position)
  };
  _position = ((1 + _position) | 0);
  var min = (((-48) + ch) | 0);
  ch = $dp_charAt__I__C($n(text), _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position)
  };
  _position = ((1 + _position) | 0);
  min = ((Math.imul(10, min) + (((-48) + ch) | 0)) | 0);
  if ((min > 59)) {
    return (~_position)
  };
  if (((_position === end) || ($dp_charAt__I__C($n(text), _position) !== 58))) {
    var offset$2 = Math.imul(negative, ((Math.imul(3600, hour) + Math.imul(60, min)) | 0));
    var $$x4 = $n(context);
    var $$x3 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    var hi$1 = (offset$2 >> 31);
    return $n($$x4).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($$x3, new $c_RTLong(offset$2, hi$1), _position, _position)
  };
  _position = ((1 + _position) | 0);
  if ((_position > (((-2) + end) | 0))) {
    return (~_position)
  };
  ch = $dp_charAt__I__C($n(text), _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position)
  };
  _position = ((1 + _position) | 0);
  var sec = (((-48) + ch) | 0);
  ch = $dp_charAt__I__C($n(text), _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position)
  };
  _position = ((1 + _position) | 0);
  sec = ((Math.imul(10, sec) + (((-48) + ch) | 0)) | 0);
  if ((sec > 59)) {
    return (~_position)
  };
  var offset$3 = Math.imul(negative, ((((Math.imul(3600, hour) + Math.imul(60, min)) | 0) + sec) | 0));
  var $$x6 = $n(context);
  var $$x5 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  var hi$2 = (offset$3 >> 31);
  return $n($$x6).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($$x5, new $c_RTLong(offset$3, hi$2), _position, _position)
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser;
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, signStyle, subsequentWidth) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field = field;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth = minWidth;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth = maxWidth;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle = signStyle;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth = subsequentWidth;
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__($thiz, field, minWidth, maxWidth, signStyle) {
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, signStyle, 0);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth = 0
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle, (-1)))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function(subsequentWidth) {
  return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle, ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth + subsequentWidth) | 0))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var valueLong = $n(context).getValue__Ljava_time_temporal_TemporalField__jl_Long(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field);
  if ((valueLong === null)) {
    return false
  };
  var value = this.getValue__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_Long__jl_Long(context, valueLong);
  var this$1 = $n(context);
  var symbols = this$1.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols;
  if ($m_sr_BoxesRunTime$().equalsNumObject__jl_Number__O__Z(value, new $c_RTLong(0, (-2147483648)))) {
    var str = "9223372036854775808"
  } else {
    var t = $uJ(value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((hi < 0)) {
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var this$6__lo = lo$1;
      var this$6__hi = hi$1
    } else {
      var this$6__lo = lo;
      var this$6__hi = hi
    };
    var str = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$6__lo, this$6__hi)
  };
  var this$7 = $n(str);
  if ((this$7.length > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Field " + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + " cannot be printed as the value ") + value) + " exceeds the maximum print width of ") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth))
  };
  str = $n(symbols).convertNumberToI18N__T__T(str);
  var this$9 = $uJ(value);
  var ahi = this$9.RTLong__f_hi;
  if ((ahi >= 0)) {
    var x1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle;
    var x = $m_Ljava_time_format_SignStyle$().EXCEEDS_PAD__Ljava_time_format_SignStyle();
    if ((x === null)) {
      var $$x1 = (x1 === null)
    } else {
      var this$10 = $n(x);
      var $$x1 = (this$10 === x1)
    };
    if ($$x1) {
      if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth < 19)) {
        var this$13 = $uJ(value);
        var value$1 = $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().EXCEED_POINTS__AI()).get(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth);
        var hi$2 = (value$1 >> 31);
        var ahi$1 = this$13.RTLong__f_hi;
        var $$x2 = ((ahi$1 === hi$2) ? (((-2147483648) ^ this$13.RTLong__f_lo) >= ((-2147483648) ^ value$1)) : (ahi$1 > hi$2))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var this$15 = $n(buf);
        var this$14 = $n(symbols);
        var c = this$14.Ljava_time_format_DecimalStyle__f_positiveSign;
        var str$1 = $as_T(String.fromCharCode(c));
        this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1)
      }
    } else {
      var x$3 = $m_Ljava_time_format_SignStyle$().ALWAYS__Ljava_time_format_SignStyle();
      if ((x$3 === null)) {
        var $$x3 = (x1 === null)
      } else {
        var this$17 = $n(x$3);
        var $$x3 = (this$17 === x1)
      };
      if ($$x3) {
        var this$19 = $n(buf);
        var this$18 = $n(symbols);
        var c$1 = this$18.Ljava_time_format_DecimalStyle__f_positiveSign;
        var str$2 = $as_T(String.fromCharCode(c$1));
        this$19.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$19.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2)
      }
    }
  } else {
    var x1$2 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle;
    var x$5 = $m_Ljava_time_format_SignStyle$().NORMAL__Ljava_time_format_SignStyle();
    if ((x$5 === null)) {
      var $$x5 = (x1$2 === null)
    } else {
      var this$21 = $n(x$5);
      var $$x5 = (this$21 === x1$2)
    };
    if ($$x5) {
      var $$x4 = true
    } else {
      var x$7 = $m_Ljava_time_format_SignStyle$().EXCEEDS_PAD__Ljava_time_format_SignStyle();
      if ((x$7 === null)) {
        var $$x6 = (x1$2 === null)
      } else {
        var this$22 = $n(x$7);
        var $$x6 = (this$22 === x1$2)
      };
      if ($$x6) {
        var $$x4 = true
      } else {
        var x$9 = $m_Ljava_time_format_SignStyle$().ALWAYS__Ljava_time_format_SignStyle();
        if ((x$9 === null)) {
          var $$x4 = (x1$2 === null)
        } else {
          var this$23 = $n(x$9);
          var $$x4 = (this$23 === x1$2)
        }
      }
    };
    if ($$x4) {
      var this$25 = $n(buf);
      var this$24 = $n(symbols);
      var c$2 = this$24.Ljava_time_format_DecimalStyle__f_negativeSign;
      var str$3 = $as_T(String.fromCharCode(c$2));
      this$25.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$25.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3)
    } else {
      var x$11 = $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle();
      if ((x$11 === null)) {
        var $$x7 = (x1$2 === null)
      } else {
        var this$27 = $n(x$11);
        var $$x7 = (this$27 === x1$2)
      };
      if ($$x7) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (((("Field " + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + " cannot be printed as the value ") + value) + " cannot be negative according to the SignStyle"))
      }
    }
  };
  var i = 0;
  while (true) {
    var $$x9 = i;
    var $$x8 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth;
    var this$28 = $n(str);
    if (($$x9 < (($$x8 - this$28.length) | 0))) {
      var this$30 = $n(buf);
      var this$29 = $n(symbols);
      var c$3 = this$29.Ljava_time_format_DecimalStyle__f_zeroDigit;
      var str$4 = $as_T(String.fromCharCode(c$3));
      this$30.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$30.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$4);
      i = ((1 + i) | 0)
    } else {
      break
    }
  };
  var this$32 = $n(buf);
  var str$5 = str;
  this$32.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$32.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$5);
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.getValue__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_Long__jl_Long = (function(context, value) {
  return ((context !== null) ? value : value)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z = (function(context) {
  return ((context !== null) ? ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) || (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth > 0) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle()))) : ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) || (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth > 0) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle()))))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _position = position;
  var length = $dp_length__I($n(text));
  if ((_position === length)) {
    return (~_position)
  };
  if (((_position < 0) || (position > length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException())
  };
  var sign = $dp_charAt__I__C($n(text), _position);
  var negative = false;
  var positive = false;
  var this$1 = $n(context);
  var this$2 = $n(this$1.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols);
  if ((sign === this$2.Ljava_time_format_DecimalStyle__f_positiveSign)) {
    var $$x1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle;
    var this$3 = $n(context);
    if ((!$n($$x1).parse__Z__Z__Z__Z(true, this$3.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict, (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)))) {
      return (~_position)
    };
    positive = true;
    _position = ((1 + _position) | 0)
  } else {
    var this$4 = $n(context);
    var this$5 = $n(this$4.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols);
    if ((sign === this$5.Ljava_time_format_DecimalStyle__f_negativeSign)) {
      var $$x2 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle;
      var this$6 = $n(context);
      if ((!$n($$x2).parse__Z__Z__Z__Z(false, this$6.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict, (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)))) {
        return (~_position)
      };
      negative = true;
      _position = ((1 + _position) | 0)
    } else {
      if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $m_Ljava_time_format_SignStyle$().ALWAYS__Ljava_time_format_SignStyle())) {
        var this$7 = $n(context);
        var $$x3 = this$7.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        return (~_position)
      }
    }
  };
  var this$8 = $n(context);
  if ((this$8.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict || this.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z(context))) {
    var effMinWidth = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth
  } else {
    var effMinWidth = 1
  };
  var minEndPos = ((_position + effMinWidth) | 0);
  if ((minEndPos > length)) {
    return (~_position)
  };
  var this$9 = $n(context);
  if ((this$9.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict || this.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z(context))) {
    var $$x4 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth
  } else {
    var $$x4 = 9
  };
  var a = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth;
  var effMaxWidth = (($$x4 + ((a > 0) ? a : 0)) | 0);
  var total = $L0;
  var totalBig = null;
  var pos = _position;
  var pass = 0;
  var outerBreak = false;
  while (((!outerBreak) && (pass < 2))) {
    var a$1 = ((pos + effMaxWidth) | 0);
    var maxEndPos = ((a$1 < length) ? a$1 : length);
    var break$1 = false;
    while (((!break$1) && (pos < maxEndPos))) {
      var ch = $dp_charAt__I__C($n(text), pos);
      pos = ((1 + pos) | 0);
      var this$13 = $n(context);
      var digit = $n(this$13.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols).convertToDigit__C__I(ch);
      if ((digit < 0)) {
        pos = (((-1) + pos) | 0);
        if ((pos < minEndPos)) {
          return (~_position)
        };
        break$1 = true
      };
      if ((!break$1)) {
        if ((((pos - _position) | 0) > 18)) {
          if ((totalBig === null)) {
            var x = total;
            var t = $uJ(x);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            totalBig = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi))
          };
          var this$16 = $n($n(totalBig).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN));
          var hi$1 = (digit >> 31);
          var bi = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(digit, hi$1));
          totalBig = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$16, bi)
        } else {
          var x$1 = total;
          var b = $uJ(x$1);
          var blo = b.RTLong__f_lo;
          var b0 = (65535 & blo);
          var b1 = ((blo >>> 16) | 0);
          var a0b0 = Math.imul(10, b0);
          var a0b1 = Math.imul(10, b1);
          var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$2 = ((Math.imul(10, b.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
          var hi$3 = (digit >> 31);
          var lo$2 = ((lo$1 + digit) | 0);
          var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$2 + hi$3) | 0)) | 0) : ((hi$2 + hi$3) | 0));
          total = new $c_RTLong(lo$2, hi$4)
        }
      }
    };
    if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth > 0) && (pass === 0))) {
      var parseLen = ((pos - _position) | 0);
      var b$1 = ((parseLen - this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth) | 0);
      effMaxWidth = ((effMinWidth > b$1) ? effMinWidth : b$1);
      pos = _position;
      total = $L0;
      totalBig = null;
      pass = ((1 + pass) | 0)
    } else {
      outerBreak = true
    }
  };
  if (negative) {
    if ((totalBig !== null)) {
      var xn = totalBig;
      var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)) {
        var this$23 = $n(context);
        var $$x5 = this$23.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict
      } else {
        var $$x5 = false
      };
      if ($$x5) {
        return (~(((-1) + _position) | 0))
      };
      totalBig = $n(totalBig).negate__Ljava_math_BigInteger()
    } else {
      var xn$1 = total;
      if ($m_sr_BoxesRunTime$().equalsNumObject__jl_Number__O__Z(xn$1, 0)) {
        var this$24 = $n(context);
        var $$x6 = this$24.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict
      } else {
        var $$x6 = false
      };
      if ($$x6) {
        return (~(((-1) + _position) | 0))
      };
      var x$2 = total;
      var this$26 = $uJ(x$2);
      var lo$3 = this$26.RTLong__f_lo;
      var hi$5 = this$26.RTLong__f_hi;
      var lo$4 = ((-lo$3) | 0);
      var hi$6 = ((lo$3 !== 0) ? (~hi$5) : ((-hi$5) | 0));
      total = new $c_RTLong(lo$4, hi$6)
    }
  } else {
    if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $m_Ljava_time_format_SignStyle$().EXCEEDS_PAD__Ljava_time_format_SignStyle())) {
      var this$30 = $n(context);
      var $$x7 = this$30.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict
    } else {
      var $$x7 = false
    };
    if ($$x7) {
      var parseLen$2 = ((pos - _position) | 0);
      if (positive) {
        if ((parseLen$2 <= this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) {
          return (~(((-1) + _position) | 0))
        }
      } else if ((parseLen$2 > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) {
        return (~_position)
      }
    }
  };
  if ((totalBig !== null)) {
    var this$31 = $n(totalBig);
    if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$31) > 63)) {
      totalBig = $n(totalBig).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
      pos = (((-1) + pos) | 0)
    };
    var t$1 = $n(totalBig).longValue__J();
    var lo$5 = t$1.RTLong__f_lo;
    var hi$7 = t$1.RTLong__f_hi;
    return this.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I(context, new $c_RTLong(lo$5, hi$7), _position, pos)
  };
  return this.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I(context, total, _position, pos)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I = (function(context, value, errorPos, successPos) {
  return $n(context).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, $uJ(value), errorPos, successPos)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.toString__T = (function() {
  return ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === 1) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth === 19)) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $m_Ljava_time_format_SignStyle$().NORMAL__Ljava_time_format_SignStyle())) ? (("Value(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ")") : (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle())) ? (((("Value(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth) + ")") : (((((((("Value(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle) + ")")))
});
function $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj) {
  return (((obj instanceof $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser"))
}
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser)))
}
function $asArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser;", depth))
}
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I($thiz) {
  if ((!$thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 1101")
  };
  return $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__checkPattern__T__I($thiz, pattern) {
  var i = 0;
  while ((i < $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().PATTERNS__AT()).u.length)) {
    if (($n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().PATTERNS__AT()).get(i) === pattern)) {
      return i
    };
    i = ((1 + i) | 0)
  };
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid zone offset pattern: " + pattern))
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z($thiz, array, arrayIndex, parseText, required) {
  if ((((((3 + $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I($thiz)) | 0) / 2) | 0) < arrayIndex)) {
    return false
  };
  var pos = $n(array).get(0);
  if ((((($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I($thiz) % 2) | 0) === 0) && (arrayIndex > 1))) {
    if (((((1 + pos) | 0) > $dp_length__I($n(parseText))) || ($dp_charAt__I__C($n(parseText), pos) !== 58))) {
      return required
    };
    pos = ((1 + pos) | 0)
  };
  if ((((2 + pos) | 0) > $dp_length__I($n(parseText)))) {
    return required
  };
  var ch1 = $dp_charAt__I__C($n(parseText), pos);
  pos = ((1 + pos) | 0);
  var ch2 = $dp_charAt__I__C($n(parseText), pos);
  pos = ((1 + pos) | 0);
  if (((((ch1 < 48) || (ch1 > 57)) || (ch2 < 48)) || (ch2 > 57))) {
    return required
  };
  var value = ((Math.imul(10, (((-48) + ch1) | 0)) + (((-48) + ch2) | 0)) | 0);
  if (((value < 0) || (value > 59))) {
    return required
  };
  $n(array).set(arrayIndex, value);
  $n(array).set(0, pos);
  return false
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser(noOffsetText, pattern) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_bitmap$init$0 = false;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText = noOffsetText;
  if ((noOffsetText === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "noOffsetText")
  };
  if ((pattern === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "pattern")
  };
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__checkPattern__T__I(this, pattern);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_bitmap$init$0 = true
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var offsetSecs = $n(context).getValue__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
  if ((offsetSecs === null)) {
    return false
  };
  var t = $uJ(offsetSecs);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var totalSecs = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo, hi));
  if ((totalSecs === 0)) {
    var this$2 = $n(buf);
    var str = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
  } else {
    var a = ((((totalSecs / 3600) | 0) % 100) | 0);
    var absHours = ((a < 0) ? ((-a) | 0) : a);
    var a$1 = ((((totalSecs / 60) | 0) % 60) | 0);
    var absMinutes = ((a$1 < 0) ? ((-a$1) | 0) : a$1);
    var a$2 = ((totalSecs % 60) | 0);
    var absSeconds = ((a$2 < 0) ? ((-a$2) | 0) : a$2);
    var bufPos = $n(buf).length__I();
    var output = absHours;
    var this$6 = $n(buf);
    var str$1 = ((totalSecs < 0) ? "-" : "+");
    this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
    var c = (65535 & ((48 + ((absHours / 10) | 0)) | 0));
    var str$2 = $as_T(String.fromCharCode(c));
    this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
    var c$1 = (65535 & ((48 + ((absHours % 10) | 0)) | 0));
    var str$3 = $as_T(String.fromCharCode(c$1));
    this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3);
    if ((($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I(this) >= 3) || (($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I(this) >= 1) && (absMinutes > 0)))) {
      var this$9 = $n(buf);
      var str$4 = (((($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I(this) % 2) | 0) === 0) ? ":" : "");
      this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$4);
      var c$2 = (65535 & ((48 + ((absMinutes / 10) | 0)) | 0));
      var str$5 = $as_T(String.fromCharCode(c$2));
      this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$5);
      var c$3 = (65535 & ((48 + ((absMinutes % 10) | 0)) | 0));
      var str$6 = $as_T(String.fromCharCode(c$3));
      this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$6);
      output = ((output + absMinutes) | 0);
      if ((($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I(this) >= 7) || (($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I(this) >= 5) && (absSeconds > 0)))) {
        var this$12 = $n(buf);
        var str$7 = (((($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I(this) % 2) | 0) === 0) ? ":" : "");
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$7);
        var c$4 = (65535 & ((48 + ((absSeconds / 10) | 0)) | 0));
        var str$8 = $as_T(String.fromCharCode(c$4));
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$8);
        var c$5 = (65535 & ((48 + ((absSeconds % 10) | 0)) | 0));
        var str$9 = $as_T(String.fromCharCode(c$5));
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$9);
        output = ((output + absSeconds) | 0)
      }
    };
    if ((output === 0)) {
      $n(buf).setLength__I__V(bufPos);
      var this$15 = $n(buf);
      var str$10 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
      this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$10)
    }
  };
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I($n(text));
  var this$1 = $n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText);
  var noOffsetLen = this$1.length;
  if ((noOffsetLen === 0)) {
    if ((position === length)) {
      return $n(context).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, position, position)
    }
  } else {
    if ((position === length)) {
      return (~position)
    };
    if ($n(context).subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(text, position, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText, 0, noOffsetLen)) {
      return $n(context).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, position, ((position + noOffsetLen) | 0))
    }
  };
  var sign = $dp_charAt__I__C($n(text), position);
  if (((sign === 43) || (sign === 45))) {
    var negative = ((sign === 45) ? (-1) : 1);
    var array = new $ac_I(4);
    $n(array).set(0, ((1 + position) | 0));
    if ((!(($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z(this, array, 1, text, true) || $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z(this, array, 2, text, ($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I(this) >= 3))) || $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z(this, array, 3, text, false)))) {
      var hi = (negative >> 31);
      var value = $n(array).get(1);
      var hi$1 = (value >> 31);
      var b0 = (65535 & value);
      var b1 = ((value >>> 16) | 0);
      var a0b0 = Math.imul(3600, b0);
      var a0b1 = Math.imul(3600, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((Math.imul(3600, hi$1) + ((c1part >>> 16) | 0)) | 0);
      var value$1 = $n(array).get(2);
      var hi$3 = (value$1 >> 31);
      var b0$1 = (65535 & value$1);
      var b1$1 = ((value$1 >>> 16) | 0);
      var a0b0$1 = Math.imul(60, b0$1);
      var a0b1$1 = Math.imul(60, b1$1);
      var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$4 = ((Math.imul(60, hi$3) + ((c1part$1 >>> 16) | 0)) | 0);
      var lo$2 = ((lo + lo$1) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo)) ? ((1 + ((hi$2 + hi$4) | 0)) | 0) : ((hi$2 + hi$4) | 0));
      var value$2 = $n(array).get(3);
      var hi$6 = (value$2 >> 31);
      var lo$3 = ((lo$2 + value$2) | 0);
      var hi$7 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$2)) ? ((1 + ((hi$5 + hi$6) | 0)) | 0) : ((hi$5 + hi$6) | 0));
      var a0 = (65535 & negative);
      var a1 = ((negative >>> 16) | 0);
      var b0$2 = (65535 & lo$3);
      var b1$2 = ((lo$3 >>> 16) | 0);
      var a0b0$2 = Math.imul(a0, b0$2);
      var a1b0 = Math.imul(a1, b0$2);
      var a0b1$2 = Math.imul(a0, b1$2);
      var lo$4 = ((a0b0$2 + (((a1b0 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$8 = ((((((((Math.imul(negative, hi$7) + Math.imul(hi, lo$3)) | 0) + Math.imul(a1, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $n(context).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $uJ(new $c_RTLong(lo$4, hi$8)), position, $n(array).get(0))
    }
  };
  if ((noOffsetLen === 0)) {
    return $n(context).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, position, ((position + noOffsetLen) | 0))
  };
  return (~position)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.toString__T = (function() {
  var this$1 = $n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText);
  var converted = $as_T(this$1.split("'").join("''"));
  return (((("Offset(" + $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().PATTERNS__AT()).get($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__type__I(this))) + ",'") + converted) + "')")
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(printerParser, padWidth, padChar) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser = printerParser;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth = padWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar = padChar
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var preLen = $n(buf).length__I();
  if ((!$n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf))) {
    return false
  };
  var len = (($n(buf).length__I() - preLen) | 0);
  if ((len > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Cannot print as output of " + len) + " characters exceeds pad width of ") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth))
  };
  var i = 0;
  while ((i < ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth - len) | 0))) {
    var this$1 = $n(buf);
    var c = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar;
    this$1.insert__I__T__jl_StringBuilder(preLen, $as_T(String.fromCharCode(c)));
    i = ((1 + i) | 0)
  };
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _text = text;
  var this$1 = $n(context);
  var strict = this$1.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict;
  var this$2 = $n(context);
  var caseSensitive = this$2.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive;
  if ((position > $dp_length__I($n(_text)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  if ((position === $dp_length__I($n(_text)))) {
    return (~position)
  };
  var endPos = ((position + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth) | 0);
  if ((endPos > $dp_length__I($n(_text)))) {
    if (strict) {
      return (~position)
    };
    endPos = $dp_length__I($n(_text))
  };
  var pos = position;
  while (((pos < endPos) && (caseSensitive ? ($dp_charAt__I__C($n(_text), pos) === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar) : $n(context).charEquals__C__C__Z($dp_charAt__I__C($n(_text), pos), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar)))) {
    pos = ((1 + pos) | 0)
  };
  _text = $dp_subSequence__I__I__jl_CharSequence($n(_text), 0, endPos);
  var resultPos = $n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, _text, pos);
  if (((resultPos !== endPos) && strict)) {
    return (~((position + pos) | 0))
  };
  return resultPos
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.toString__T = (function() {
  return (((("Pad(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth) + ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar === 32) ? ")" : ((",'" + $bC(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar)) + "')")))
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE$lzycompute__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser($thiz) {
  if (((((2 & $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_INSENSITIVE = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser("INSENSITIVE", 1);
    $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_bitmap$0 = (((2 | $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_INSENSITIVE
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_INSENSITIVE = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_bitmap$0 = 0
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype.INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser = (function() {
  return (((((2 & this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE$lzycompute__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(this) : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__f_INSENSITIVE)
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$()
  };
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser(literal) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal = literal
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var this$1 = $n(buf);
  var str = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I($n(text));
  if (((position > length) || (position < 0))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  } else {
    var $$x1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal;
    var this$1 = $n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal);
    if ((!$n(context).subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(text, position, $$x1, 0, this$1.length))) {
      return (~position)
    } else {
      var this$2 = $n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal);
      return ((position + this$2.length) | 0)
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype.toString__T = (function() {
  var this$1 = $n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal);
  var converted = $as_T(this$1.split("'").join("''"));
  return (("'" + converted) + "'")
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser___numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser($thiz) {
  if ((!$thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeFormatterBuilder.scala: 882")
  };
  return $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f__numberPrinterParser
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser___numberPrinterParser_$eq__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__V($thiz, x$1) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f__numberPrinterParser = x$1;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_bitmap$init$0 = true
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser($thiz) {
  if (($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser___numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser($thiz) === null)) {
    $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser___numberPrinterParser_$eq__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__V($thiz, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field, 1, 19, $m_Ljava_time_format_SignStyle$().NORMAL__Ljava_time_format_SignStyle()))
  };
  return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser___numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser($thiz)
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser(field, textStyle, provider) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_provider = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f__numberPrinterParser = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_bitmap$init$0 = false;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field = field;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle = textStyle;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_provider = provider;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f__numberPrinterParser = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_bitmap$init$0 = true
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var value = $n(context).getValue__Ljava_time_temporal_TemporalField__jl_Long(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field);
  if ((value === null)) {
    return false
  };
  var $$x4 = $n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_provider);
  var $$x3 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field;
  var $$x2 = $uJ(value);
  var $$x1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle;
  var this$2 = $n(context);
  var text = $n($$x4).getText__Ljava_time_temporal_TemporalField__J__Ljava_time_format_TextStyle__ju_Locale__T($$x3, $$x2, $$x1, this$2.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale);
  if ((text === null)) {
    return $n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(this)).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf)
  };
  var this$3 = $n(buf);
  this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + text);
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, parseText, position) {
  var length = $dp_length__I($n(parseText));
  if (((position < 0) || (position > length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  var this$1 = $n(context);
  if (this$1.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict) {
    var style = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle
  } else {
    var style = null
  };
  var $$x2 = $n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_provider);
  var $$x1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field;
  var this$2 = $n(context);
  var it = $n($$x2).getTextIterator__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__ju_Locale__sc_Iterator($$x1, style, this$2.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
  if ((it !== null)) {
    while ($n(it).hasNext__Z()) {
      var entry = $as_T2($n(it).next__O());
      var itText = $as_T($n(entry)._1__O());
      var this$3 = $n(itText);
      if ($n(context).subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(itText, 0, parseText, position, this$3.length)) {
        var $$x5 = $n(context);
        var $$x4 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field;
        var this$4 = $n(entry);
        var $$x3 = $uJ(this$4._2__O());
        var this$5 = $n(itText);
        return $n($$x5).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($$x4, $$x3, position, ((position + this$5.length) | 0))
      }
    };
    var this$6 = $n(context);
    if (this$6.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict) {
      return (~position)
    }
  };
  return $n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(this)).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, parseText, position)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype.toString__T = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle === $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle()) ? (("Text(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field) + ")") : (((("Text(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle) + ")"))
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$TextPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__evaluate__Ljava_time_temporal_WeekFields__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser($thiz, weekFields) {
  var x1 = $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter;
  switch (x1) {
    case 101: {
      return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), $n(weekFields).dayOfWeek__Ljava_time_temporal_TemporalField(), $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count, 2, $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle());
      break
    }
    case 99: {
      return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), $n(weekFields).dayOfWeek__Ljava_time_temporal_TemporalField(), $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count, 2, $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle());
      break
    }
    case 119: {
      return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), $n(weekFields).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField(), $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count, 2, $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle());
      break
    }
    case 87: {
      return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), $n(weekFields).weekOfMonth__Ljava_time_temporal_TemporalField(), 1, 2, $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle());
      break
    }
    case 89: {
      return (($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count === 2) ? $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(), $n(weekFields).weekBasedYear__Ljava_time_temporal_TemporalField(), 2, 2, 0, $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$().BASE_DATE__Ljava_time_LocalDate()) : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), $n(weekFields).weekBasedYear__Ljava_time_temporal_TemporalField(), $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count, 19, (($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count < 4) ? $m_Ljava_time_format_SignStyle$().NORMAL__Ljava_time_format_SignStyle() : $m_Ljava_time_format_SignStyle$().EXCEEDS_PAD__Ljava_time_format_SignStyle()), (-1)));
      break
    }
    default: {
      throw new $c_s_MatchError($bC(x1))
    }
  }
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(letter, count) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter = letter;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count = count
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var $$x1 = $m_Ljava_time_temporal_WeekFields$();
  var this$1 = $n(context);
  return $n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__evaluate__Ljava_time_temporal_WeekFields__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(this, $n($$x1).of__ju_Locale__Ljava_time_temporal_WeekFields(this$1.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale))).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var $$x1 = $m_Ljava_time_temporal_WeekFields$();
  var this$1 = $n(context);
  return $n($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__evaluate__Ljava_time_temporal_WeekFields__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser(this, $n($$x1).of__ju_Locale__Ljava_time_temporal_WeekFields(this$1.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale))).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, position)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype.toString__T = (function() {
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 30);
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "Localized(");
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 89)) {
    if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count === 1)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "WeekBasedYear")
    } else if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count === 2)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "ReducedValue(WeekBasedYear,2,2,2000-01-01)")
    } else {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "WeekBasedYear,");
      var i = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count;
      var str = ("" + i);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "19");
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
      var obj = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count < 4) ? $m_Ljava_time_format_SignStyle$().NORMAL__Ljava_time_format_SignStyle() : $m_Ljava_time_format_SignStyle$().EXCEEDS_PAD__Ljava_time_format_SignStyle());
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj)
    }
  } else {
    if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 99) || (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 101))) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "DayOfWeek")
    } else if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 119)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "WeekOfWeekBasedYear")
    } else if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 87)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "WeekOfMonth")
    };
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
    var i$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count;
    var str$1 = ("" + i$1);
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1)
  };
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + ")");
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser;
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId($thiz, regionIds, parsedZoneId, caseSensitive) {
  if ((parsedZoneId === null)) {
    return null
  } else if (caseSensitive) {
    return ($n(regionIds).contains__O__Z(parsedZoneId) ? $m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId(parsedZoneId) : null)
  } else {
    var regionIdsIterator = $n(regionIds).iterator__ju_Iterator();
    while ($n(regionIdsIterator).hasNext__Z()) {
      var regionId = $as_T($n(regionIdsIterator).next__O());
      var this$1 = $n(regionId);
      _return$1: {
        var len = this$1.length;
        if ((parsedZoneId === null)) {
          var $$x2 = true
        } else {
          var this$2 = $n(parsedZoneId);
          var $$x2 = (this$2.length !== len)
        };
        if ((!$$x2)) {
          var i = 0;
          while ((i !== len)) {
            var index = i;
            var c = $charAt(this$1, index);
            var $$x3 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
            var this$3 = $n(parsedZoneId);
            var index$1 = i;
            var c$1 = $charAt(this$3, index$1);
            if (($$x3 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
              var $$x1 = false;
              break _return$1
            };
            i = ((1 + i) | 0)
          };
          var $$x1 = true
        } else {
          var $$x1 = false
        }
      };
      if ($$x1) {
        return $m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId(regionId)
      }
    };
    return null
  }
}
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I($thiz, context, text, prefixPos, position) {
  var this$1 = $n($dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n(text), prefixPos, position))));
  var prefix = $as_T(this$1.toUpperCase());
  var this$2 = $n(context);
  var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), this$2);
  if (((position < $dp_length__I($n(text))) && $n(context).charEquals__C__C__Z($dp_charAt__I__C($n(text), position), 90))) {
    $n(context).setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId(prefix, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset()));
    return position
  };
  var endPos = $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().INSTANCE_ID__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser()).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(newContext, text, position);
  if ((endPos < 0)) {
    $n(context).setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId(prefix, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset()));
    return position
  };
  var this$3 = $n(newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField()));
  var this$4 = $uJ(this$3);
  var offsetSecs = this$4.RTLong__f_lo;
  var offset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offsetSecs);
  $n(context).setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId(prefix, offset));
  return endPos
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser(query, description) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_query = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_description = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_query = query;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_description = description
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var zone = $as_Ljava_time_ZoneId($n(context).getValue__Ljava_time_temporal_TemporalQuery__O(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_query));
  if ((zone !== null)) {
    var this$1 = $n(buf);
    var str = $n(zone).getId__T();
    this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    return true
  } else {
    return false
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I($n(text));
  if ((position > length)) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  if ((position === length)) {
    return (~position)
  };
  var nextChar = $dp_charAt__I__C($n(text), position);
  if (((nextChar === 43) || (nextChar === 45))) {
    var this$1 = $n(context);
    var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), this$1);
    var endPos = $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().INSTANCE_ID__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser()).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(newContext, text, position);
    if ((endPos < 0)) {
      return endPos
    };
    var this$2 = $n(newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField()));
    var this$3 = $uJ(this$2);
    var offset = this$3.RTLong__f_lo;
    $n(context).setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offset));
    return endPos
  } else if ((length >= ((2 + position) | 0))) {
    var nextNextChar = $dp_charAt__I__C($n(text), ((1 + position) | 0));
    if (($n(context).charEquals__C__C__Z(nextChar, 85) && $n(context).charEquals__C__C__Z(nextNextChar, 84))) {
      if (((length >= ((3 + position) | 0)) && $n(context).charEquals__C__C__Z($dp_charAt__I__C($n(text), ((2 + position) | 0)), 67))) {
        return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I(this, context, text, position, ((3 + position) | 0))
      };
      return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I(this, context, text, position, ((2 + position) | 0))
    } else if (((($n(context).charEquals__C__C__Z(nextChar, 71) && (length >= ((3 + position) | 0))) && $n(context).charEquals__C__C__Z(nextNextChar, 77)) && $n(context).charEquals__C__C__Z($dp_charAt__I__C($n(text), ((2 + position) | 0)), 84))) {
      return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I(this, context, text, position, ((3 + position) | 0))
    }
  };
  var regionIds = $m_Ljava_time_zone_ZoneRulesProvider$().getAvailableZoneIds__ju_Set();
  var regionIdsSize = $n(regionIds).size__I();
  var cached = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$cachedSubstringTree__ju_Map$Entry();
  if ((cached === null)) {
    var $$x1 = true
  } else {
    var x = $n(cached).getKey__O();
    var $$x1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x, regionIdsSize))
  };
  if ($$x1) {
    cached = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$cachedSubstringTree__ju_Map$Entry();
    if ((cached === null)) {
      var $$x2 = true
    } else {
      var x$1 = $n(cached).getKey__O();
      var $$x2 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, regionIdsSize))
    };
    if ($$x2) {
      var $$x3 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$();
      cached = new $c_ju_AbstractMap$SimpleImmutableEntry(regionIdsSize, $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$prepareParser__ju_Set__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(regionIds));
      $n($$x3).java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$cachedSubstringTree_$eq__ju_Map$Entry__V(cached)
    }
  };
  var tree = $as_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree($n(cached).getValue__O());
  var parsedZoneId = null;
  var lastZoneId = null;
  var break$1 = false;
  while (((!break$1) && (tree !== null))) {
    var nodeLength = $n(tree).Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length;
    if ((((position + nodeLength) | 0) > length)) {
      break$1 = true
    } else {
      lastZoneId = parsedZoneId;
      parsedZoneId = $dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n(text), position, ((position + nodeLength) | 0))));
      var $$x5 = $n(tree);
      var $$x4 = parsedZoneId;
      var this$5 = $n(context);
      tree = $n($$x5).get__jl_CharSequence__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree($$x4, this$5.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive)
    }
  };
  var $$x6 = parsedZoneId;
  var this$6 = $n(context);
  var zone = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId(this, regionIds, $$x6, this$6.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive);
  if ((zone === null)) {
    var $$x7 = lastZoneId;
    var this$7 = $n(context);
    zone = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId(this, regionIds, $$x7, this$7.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive);
    if ((zone === null)) {
      if ($n(context).charEquals__C__C__Z(nextChar, 90)) {
        $n(context).setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        return ((1 + position) | 0)
      };
      return (~position)
    };
    parsedZoneId = lastZoneId
  };
  $n(context).setParsed__Ljava_time_ZoneId__V(zone);
  var this$8 = $n(parsedZoneId);
  return ((position + this$8.length) | 0)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.toString__T = (function() {
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_description
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser(textStyle) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle = textStyle;
  if ((textStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "textStyle")
  }
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var zone = $as_Ljava_time_ZoneId($n(context).getValue__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()));
  if ((zone === null)) {
    return false
  };
  if (($n(zone).normalized__Ljava_time_ZoneId() instanceof $c_Ljava_time_ZoneOffset)) {
    var this$1 = $n(buf);
    var str = $n(zone).getId__T();
    this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    return true
  };
  var this$2 = $n(context);
  var temporal = this$2.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal;
  var daylight = false;
  if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
    var this$3 = $m_Ljava_time_Instant$();
    var t = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var instant = this$3.java$time$Instant$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo, hi), 0);
    daylight = $n($n(zone).getRules__Ljava_time_zone_ZoneRules()).isDaylightSavings__Ljava_time_Instant__Z(instant)
  };
  var tz = $m_ju_TimeZone$().getTimeZone__T__ju_TimeZone($n(zone).getId__T());
  var tzstyle = (($n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle).asNormal__Ljava_time_format_TextStyle() === $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle()) ? 1 : 0);
  var $$x2 = $n(tz);
  var $$x1 = daylight;
  var this$4 = $n(context);
  var text = $n($$x2).getDisplayName__Z__I__ju_Locale__T($$x1, tzstyle, this$4.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale);
  var this$5 = $n(buf);
  this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + text);
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var ids = $ct_ju_HashMap__(new $c_ju_HashMap());
  var this$2 = $ct_ju_HashSet__ju_Collection__(new $c_ju_HashSet(), $m_Ljava_time_zone_ZoneRulesProvider$().getAvailableZoneIds__ju_Set());
  var idIterator = $n(this$2.ju_HashSet__f_innerKeySet).iterator__ju_Iterator();
  while ($n(idIterator).hasNext__Z()) {
    var id = $as_T($n(idIterator).next__O());
    if ((id === null)) {
      var $$x1 = 0
    } else {
      var originalHash = $f_T__hashCode__I($n(id));
      var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    ids.java$util$HashMap$$put0__O__O__I__Z__O(id, id, $$x1, false);
    var tz = $m_ju_TimeZone$().getTimeZone__T__ju_TimeZone(id);
    var tzstyle = (($n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle).asNormal__Ljava_time_format_TextStyle() === $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle()) ? 1 : 0);
    var $$x2 = $n(tz);
    var this$4 = $n(context);
    var textWinter = $n($$x2).getDisplayName__Z__I__ju_Locale__T(false, tzstyle, this$4.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
    if ((textWinter !== null)) {
      var this$5 = $n(id);
      var $$x4 = ((this$5.length >= 0) && ($as_T(this$5.substring(0, 4)) === "Etc/"))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var $$x3 = true
    } else {
      var this$6 = $n(textWinter);
      if ((!((this$6.length >= 0) && ($as_T(this$6.substring(0, 4)) === "GMT+")))) {
        var this$7 = $n(textWinter);
        var $$x3 = (!((this$7.length >= 0) && ($as_T(this$7.substring(0, 4)) === "GMT+")))
      } else {
        var $$x3 = false
      }
    };
    if ($$x3) {
      if ((textWinter === null)) {
        var $$x5 = 0
      } else {
        var originalHash$1 = $f_T__hashCode__I($n(textWinter));
        var $$x5 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0))
      };
      ids.java$util$HashMap$$put0__O__O__I__Z__O(textWinter, id, $$x5, false)
    } else if ((textWinter === null)) {
      var $$x6 = $n(tz);
      var this$9 = $n(context);
      var key = $n($$x6).getDisplayName__Z__I__ju_Locale__T(false, tzstyle, this$9.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
      if ((key === null)) {
        var $$x7 = 0
      } else {
        var originalHash$2 = $f_T__hashCode__I($n(key));
        var $$x7 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0))
      };
      ids.java$util$HashMap$$put0__O__O__I__Z__O(key, id, $$x7, false)
    };
    var $$x8 = $n(tz);
    var this$11 = $n(context);
    var textSummer = $n($$x8).getDisplayName__Z__I__ju_Locale__T(true, tzstyle, this$11.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
    if ((textSummer !== null)) {
      var this$12 = $n(id);
      var $$x10 = ((this$12.length >= 0) && ($as_T(this$12.substring(0, 4)) === "Etc/"))
    } else {
      var $$x10 = false
    };
    if ($$x10) {
      var $$x9 = true
    } else {
      var this$13 = $n(textSummer);
      if ((!((this$13.length >= 0) && ($as_T(this$13.substring(0, 4)) === "GMT+")))) {
        var this$14 = $n(textSummer);
        var $$x9 = (!((this$14.length >= 0) && ($as_T(this$14.substring(0, 4)) === "GMT+")))
      } else {
        var $$x9 = false
      }
    };
    if ($$x9) {
      if ((textSummer === null)) {
        var $$x11 = 0
      } else {
        var originalHash$3 = $f_T__hashCode__I($n(textSummer));
        var $$x11 = (originalHash$3 ^ ((originalHash$3 >>> 16) | 0))
      };
      ids.java$util$HashMap$$put0__O__O__I__Z__O(textSummer, id, $$x11, false)
    } else if ((textSummer === null)) {
      var $$x12 = $n(tz);
      var this$16 = $n(context);
      var key$1 = $n($$x12).getDisplayName__Z__I__ju_Locale__T(true, tzstyle, this$16.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
      if ((key$1 === null)) {
        var $$x13 = 0
      } else {
        var originalHash$4 = $f_T__hashCode__I($n(key$1));
        var $$x13 = (originalHash$4 ^ ((originalHash$4 >>> 16) | 0))
      };
      ids.java$util$HashMap$$put0__O__O__I__Z__O(key$1, id, $$x13, false)
    }
  };
  var tmpIds = $ct_ju_ArrayList__ju_Collection__(new $c_ju_ArrayList(), new $c_ju_HashMap$EntrySet(ids));
  var c = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$LENGTH_COMPARATOR__s_math_Ordering();
  $f_ju_List__sort__ju_Comparator__V(tmpIds, c);
  var i = tmpIds.listIterator__I__ju_ListIterator(0);
  while ($n(i).hasNext__Z()) {
    var v = $as_ju_Map$Entry($n(i).next__O());
    var name = $as_T($n(v).getKey__O());
    var this$19 = $n(name);
    if ($n(context).subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(text, position, name, 0, this$19.length)) {
      $n(context).setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId($as_T($n(v).getValue__O())));
      var this$20 = $n(name);
      return ((position + this$20.length) | 0)
    }
  };
  return (~position)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype.toString__T = (function() {
  return (("ZoneText(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle) + ")")
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(outer) {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_excessDays = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = 0;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer = outer
  };
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((1 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((2 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((4 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((8 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_excessDays = $m_Ljava_time_Period$().ZERO__Ljava_time_Period();
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((16 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((32 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.chrono__Ljava_time_chrono_Chronology = (function() {
  if (((((1 & this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeParseContext.scala: 371")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.chrono_$eq__Ljava_time_chrono_Chronology__V = (function(x$1) {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono = x$1;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((1 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.zone__Ljava_time_ZoneId = (function() {
  if (((((2 & this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeParseContext.scala: 372")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.zone_$eq__Ljava_time_ZoneId__V = (function(x$1) {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = x$1;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((2 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.fieldValues__ju_Map = (function() {
  if (((((4 & this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeParseContext.scala: 373")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.leapSecond__Z = (function() {
  if (((((8 & this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeParseContext.scala: 375")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.leapSecond_$eq__Z__V = (function(x$1) {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = x$1;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((8 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.excessDays__Ljava_time_Period = (function() {
  if (((((16 & this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeParseContext.scala: 376")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_excessDays
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.callbacks__ju_List = (function() {
  if (((((32 & this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPDateTimeParseContext.scala: 377")
  };
  return this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.callbacks_$eq__ju_List__V = (function(x$1) {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks = x$1;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0 = (((32 | this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.copy__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = (function() {
  var cloned = new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer);
  cloned.chrono_$eq__Ljava_time_chrono_Chronology__V(this.chrono__Ljava_time_chrono_Chronology());
  cloned.zone_$eq__Ljava_time_ZoneId__V(this.zone__Ljava_time_ZoneId());
  $n(cloned.fieldValues__ju_Map()).putAll__ju_Map__V(this.fieldValues__ju_Map());
  cloned.leapSecond_$eq__Z__V(this.leapSecond__Z());
  return cloned
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.toString__T = (function() {
  return (((($n(this.fieldValues__ju_Map()).toString__T() + ",") + this.chrono__Ljava_time_chrono_Chronology()) + ",") + this.zone__Ljava_time_ZoneId())
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return $n(this.fieldValues__ju_Map()).containsKey__O__Z(field)
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((!$n(this.fieldValues__ju_Map()).containsKey__O__Z(field))) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  };
  var x = $as_jl_Long($n(this.fieldValues__ju_Map()).get__O__O(field));
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo, hi))
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((!$n(this.fieldValues__ju_Map()).containsKey__O__Z(field))) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    var x = $as_jl_Long($n(this.fieldValues__ju_Map()).get__O__O(field));
    return $uJ(x)
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.chrono__Ljava_time_chrono_Chronology() : (((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) ? this.zone__Ljava_time_ZoneId() : $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query)))
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.toBuilder__Ljava_time_format_DateTimeBuilder = (function() {
  var builder = new $c_Ljava_time_format_DateTimeBuilder();
  $n(builder.fieldValues__ju_Map()).putAll__ju_Map__V(this.fieldValues__ju_Map());
  builder.chrono_$eq__Ljava_time_chrono_Chronology__V($n(this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer).getEffectiveChronology__Ljava_time_chrono_Chronology());
  if ((this.zone__Ljava_time_ZoneId() !== null)) {
    builder.zone_$eq__Ljava_time_ZoneId__V(this.zone__Ljava_time_ZoneId())
  } else {
    builder.zone_$eq__Ljava_time_ZoneId__V($n(this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer).Ljava_time_format_internal_TTBPDateTimeParseContext__f_java$time$format$internal$TTBPDateTimeParseContext$$overrideZone)
  };
  builder.leapSecond_$eq__Z__V(this.leapSecond__Z());
  builder.excessDays_$eq__Ljava_time_Period__V(this.excessDays__Ljava_time_Period());
  return builder
});
function $as_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(obj) {
  return (((obj instanceof $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.TTBPDateTimeParseContext$Parsed"))
}
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed)))
}
function $asArrayOf_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.TTBPDateTimeParseContext$Parsed;", depth))
}
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed: 0
}, false, "java.time.format.internal.TTBPDateTimeParseContext$Parsed", {
  Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1(effectiveDate$1, temporal$1, effectiveChrono$1, effectiveZone$1) {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 = effectiveDate$1;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$1 = temporal$1;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 = effectiveChrono$1;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 = effectiveZone$1
}
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && $n(field).isDateBased__Z())) {
    var this$1 = $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1);
    return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$1, field)
  } else {
    return $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$1).isSupported__Ljava_time_temporal_TemporalField__Z(field)
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && $n(field).isDateBased__Z()) ? $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field) : $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$1).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field))
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  return (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && $n(field).isDateBased__Z()) ? $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1).getLong__Ljava_time_temporal_TemporalField__J(field) : $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$1).getLong__Ljava_time_temporal_TemporalField__J(field))
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 : ((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$1).query__Ljava_time_temporal_TemporalQuery__O(query) : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this))))
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1: 0
}, false, "java.time.format.internal.TTBPDateTimePrintContext$$anon$1", {
  Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1;
function $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__cache__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPSimpleDateTimeTextProvider.scala: 136")
  };
  return $thiz.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_cache
}
function $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__findStore__Ljava_time_temporal_TemporalField__ju_Locale__O($thiz, field, locale) {
  var key = $ct_T2__O__O__(new $c_T2(), field, locale);
  var store = $n($p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__cache__ju_Map($thiz)).get__O__O(key);
  if ((store === null)) {
    store = $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__createStore__Ljava_time_temporal_TemporalField__ju_Locale__O($thiz, field, locale);
    $n($p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__cache__ju_Map($thiz)).put__O__O__O(key, store);
    store = $n($p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__cache__ju_Map($thiz)).get__O__O(key)
  };
  return store
}
function $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__createStore__Ljava_time_temporal_TemporalField__ju_Locale__O($thiz, field, locale) {
  if ((field === $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    var oldSymbols = $m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale);
    var array = $n(oldSymbols).Ljava_text_DateFormatSymbols__f_months;
    var this$28 = $n($m_s_Predef$().s_Predef$__f_Map);
    var y = $n(array).get(0);
    var $$x11 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y);
    var y$1 = $n(array).get(1);
    var $$x10 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$1);
    var y$2 = $n(array).get(2);
    var $$x9 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$2);
    var y$3 = $n(array).get(3);
    var $$x8 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$3);
    var y$4 = $n(array).get(4);
    var $$x7 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$4);
    var y$5 = $n(array).get(5);
    var $$x6 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$5);
    var y$6 = $n(array).get(6);
    var $$x5 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$6);
    var y$7 = $n(array).get(7);
    var $$x4 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(8, 0), y$7);
    var y$8 = $n(array).get(8);
    var $$x3 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(9, 0), y$8);
    var y$9 = $n(array).get(9);
    var $$x2 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(10, 0), y$9);
    var y$10 = $n(array).get(10);
    var $$x1 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(11, 0), y$10);
    var y$11 = $n(array).get(11);
    var array$1 = [$$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(12, 0), y$11)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var mapF = this$28.from__sc_IterableOnce__sci_Map(elems);
    var this$68 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$30 = $n($n(array).get(0));
    if ((this$30.length < 1)) {
      $charAt(this$30, 1)
    };
    var y$12 = $as_T(this$30.substring(0, 1));
    var $$x22 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$12);
    var this$33 = $n($n(array).get(1));
    if ((this$33.length < 1)) {
      $charAt(this$33, 1)
    };
    var y$13 = $as_T(this$33.substring(0, 1));
    var $$x21 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$13);
    var this$36 = $n($n(array).get(2));
    if ((this$36.length < 1)) {
      $charAt(this$36, 1)
    };
    var y$14 = $as_T(this$36.substring(0, 1));
    var $$x20 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$14);
    var this$39 = $n($n(array).get(3));
    if ((this$39.length < 1)) {
      $charAt(this$39, 1)
    };
    var y$15 = $as_T(this$39.substring(0, 1));
    var $$x19 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$15);
    var this$42 = $n($n(array).get(4));
    if ((this$42.length < 1)) {
      $charAt(this$42, 1)
    };
    var y$16 = $as_T(this$42.substring(0, 1));
    var $$x18 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$16);
    var this$45 = $n($n(array).get(5));
    if ((this$45.length < 1)) {
      $charAt(this$45, 1)
    };
    var y$17 = $as_T(this$45.substring(0, 1));
    var $$x17 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$17);
    var this$48 = $n($n(array).get(6));
    if ((this$48.length < 1)) {
      $charAt(this$48, 1)
    };
    var y$18 = $as_T(this$48.substring(0, 1));
    var $$x16 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$18);
    var this$51 = $n($n(array).get(7));
    if ((this$51.length < 1)) {
      $charAt(this$51, 1)
    };
    var y$19 = $as_T(this$51.substring(0, 1));
    var $$x15 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(8, 0), y$19);
    var this$54 = $n($n(array).get(8));
    if ((this$54.length < 1)) {
      $charAt(this$54, 1)
    };
    var y$20 = $as_T(this$54.substring(0, 1));
    var $$x14 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(9, 0), y$20);
    var this$57 = $n($n(array).get(9));
    if ((this$57.length < 1)) {
      $charAt(this$57, 1)
    };
    var y$21 = $as_T(this$57.substring(0, 1));
    var $$x13 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(10, 0), y$21);
    var this$60 = $n($n(array).get(10));
    if ((this$60.length < 1)) {
      $charAt(this$60, 1)
    };
    var y$22 = $as_T(this$60.substring(0, 1));
    var $$x12 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(11, 0), y$22);
    var this$63 = $n($n(array).get(11));
    if ((this$63.length < 1)) {
      $charAt(this$63, 1)
    };
    var y$23 = $as_T(this$63.substring(0, 1));
    var array$2 = [$$x22, $$x21, $$x20, $$x19, $$x18, $$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(12, 0), y$23)];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    var mapN = this$68.from__sc_IterableOnce__sci_Map(elems$1);
    array = $n(oldSymbols).Ljava_text_DateFormatSymbols__f_shortMonths;
    var this$96 = $n($m_s_Predef$().s_Predef$__f_Map);
    var y$24 = $n(array).get(0);
    var $$x33 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$24);
    var y$25 = $n(array).get(1);
    var $$x32 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$25);
    var y$26 = $n(array).get(2);
    var $$x31 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$26);
    var y$27 = $n(array).get(3);
    var $$x30 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$27);
    var y$28 = $n(array).get(4);
    var $$x29 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$28);
    var y$29 = $n(array).get(5);
    var $$x28 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$29);
    var y$30 = $n(array).get(6);
    var $$x27 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$30);
    var y$31 = $n(array).get(7);
    var $$x26 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(8, 0), y$31);
    var y$32 = $n(array).get(8);
    var $$x25 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(9, 0), y$32);
    var y$33 = $n(array).get(9);
    var $$x24 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(10, 0), y$33);
    var y$34 = $n(array).get(10);
    var $$x23 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(11, 0), y$34);
    var y$35 = $n(array).get(11);
    var array$3 = [$$x33, $$x32, $$x31, $$x30, $$x29, $$x28, $$x27, $$x26, $$x25, $$x24, $$x23, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(12, 0), y$35)];
    var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    var mapS = this$96.from__sc_IterableOnce__sci_Map(elems$2);
    var this$106 = $n($m_s_Predef$().s_Predef$__f_Map);
    var self = $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle();
    var $$x35 = $ct_T2__O__O__(new $c_T2(), self, mapF);
    var self$1 = $m_Ljava_time_format_TextStyle$().NARROW__Ljava_time_format_TextStyle();
    var $$x34 = $ct_T2__O__O__(new $c_T2(), self$1, mapN);
    var self$2 = $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle();
    var array$4 = [$$x35, $$x34, $ct_T2__O__O__(new $c_T2(), self$2, mapS)];
    var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
    var styleMap = this$106.from__sc_IterableOnce__sci_Map(elems$3);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap)
  };
  if ((field === $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    var oldSymbols$2 = $m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale);
    var array$2$1 = $n(oldSymbols$2).Ljava_text_DateFormatSymbols__f_weekdays;
    var this$124 = $n($m_s_Predef$().s_Predef$__f_Map);
    var y$36 = $n(array$2$1).get(2);
    var $$x41 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$36);
    var y$37 = $n(array$2$1).get(3);
    var $$x40 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$37);
    var y$38 = $n(array$2$1).get(4);
    var $$x39 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$38);
    var y$39 = $n(array$2$1).get(5);
    var $$x38 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$39);
    var y$40 = $n(array$2$1).get(6);
    var $$x37 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$40);
    var y$41 = $n(array$2$1).get(7);
    var $$x36 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$41);
    var y$42 = $n(array$2$1).get(1);
    var array$5 = [$$x41, $$x40, $$x39, $$x38, $$x37, $$x36, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$42)];
    var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
    var mapF$2 = this$124.from__sc_IterableOnce__sci_Map(elems$4);
    var this$149 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$126 = $n($n(array$2$1).get(2));
    if ((this$126.length < 1)) {
      $charAt(this$126, 1)
    };
    var y$43 = $as_T(this$126.substring(0, 1));
    var $$x47 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$43);
    var this$129 = $n($n(array$2$1).get(3));
    if ((this$129.length < 1)) {
      $charAt(this$129, 1)
    };
    var y$44 = $as_T(this$129.substring(0, 1));
    var $$x46 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$44);
    var this$132 = $n($n(array$2$1).get(4));
    if ((this$132.length < 1)) {
      $charAt(this$132, 1)
    };
    var y$45 = $as_T(this$132.substring(0, 1));
    var $$x45 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$45);
    var this$135 = $n($n(array$2$1).get(5));
    if ((this$135.length < 1)) {
      $charAt(this$135, 1)
    };
    var y$46 = $as_T(this$135.substring(0, 1));
    var $$x44 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$46);
    var this$138 = $n($n(array$2$1).get(6));
    if ((this$138.length < 1)) {
      $charAt(this$138, 1)
    };
    var y$47 = $as_T(this$138.substring(0, 1));
    var $$x43 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$47);
    var this$141 = $n($n(array$2$1).get(7));
    if ((this$141.length < 1)) {
      $charAt(this$141, 1)
    };
    var y$48 = $as_T(this$141.substring(0, 1));
    var $$x42 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$48);
    var this$144 = $n($n(array$2$1).get(1));
    if ((this$144.length < 1)) {
      $charAt(this$144, 1)
    };
    var y$49 = $as_T(this$144.substring(0, 1));
    var array$6 = [$$x47, $$x46, $$x45, $$x44, $$x43, $$x42, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$49)];
    var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
    var mapN$2 = this$149.from__sc_IterableOnce__sci_Map(elems$5);
    array$2$1 = $n(oldSymbols$2).Ljava_text_DateFormatSymbols__f_shortWeekdays;
    var this$167 = $n($m_s_Predef$().s_Predef$__f_Map);
    var y$50 = $n(array$2$1).get(2);
    var $$x53 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$50);
    var y$51 = $n(array$2$1).get(3);
    var $$x52 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$51);
    var y$52 = $n(array$2$1).get(4);
    var $$x51 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$52);
    var y$53 = $n(array$2$1).get(5);
    var $$x50 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$53);
    var y$54 = $n(array$2$1).get(6);
    var $$x49 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$54);
    var y$55 = $n(array$2$1).get(7);
    var $$x48 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$55);
    var y$56 = $n(array$2$1).get(1);
    var array$7 = [$$x53, $$x52, $$x51, $$x50, $$x49, $$x48, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$56)];
    var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
    var mapS$2 = this$167.from__sc_IterableOnce__sci_Map(elems$6);
    var this$177 = $n($m_s_Predef$().s_Predef$__f_Map);
    var self$3 = $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle();
    var $$x55 = $ct_T2__O__O__(new $c_T2(), self$3, mapF$2);
    var self$4 = $m_Ljava_time_format_TextStyle$().NARROW__Ljava_time_format_TextStyle();
    var $$x54 = $ct_T2__O__O__(new $c_T2(), self$4, mapN$2);
    var self$5 = $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle();
    var array$8 = [$$x55, $$x54, $ct_T2__O__O__(new $c_T2(), self$5, mapS$2)];
    var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
    var styleMap$2 = this$177.from__sc_IterableOnce__sci_Map(elems$7);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap$2)
  };
  if ((field === $m_Ljava_time_temporal_ChronoField$().AMPM_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var oldSymbols$3 = $m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale);
    var array$3$1 = $n(oldSymbols$3).Ljava_text_DateFormatSymbols__f_amPmStrings;
    var this$185 = $n($m_s_Predef$().s_Predef$__f_Map);
    var y$57 = $n(array$3$1).get(0);
    var $$x56 = $ct_T2__O__O__(new $c_T2(), $L0, y$57);
    var y$58 = $n(array$3$1).get(1);
    var array$9 = [$$x56, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$58)];
    var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
    var map = this$185.from__sc_IterableOnce__sci_Map(elems$8);
    var this$193 = $n($m_s_Predef$().s_Predef$__f_Map);
    var self$6 = $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle();
    var $$x57 = $ct_T2__O__O__(new $c_T2(), self$6, map);
    var self$7 = $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle();
    var array$10 = [$$x57, $ct_T2__O__O__(new $c_T2(), self$7, map)];
    var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
    var styleMap$3 = this$193.from__sc_IterableOnce__sci_Map(elems$9);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap$3)
  };
  if ((field === $m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField())) {
    var oldSymbols$4 = $m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale);
    var array$4$1 = $n(oldSymbols$4).Ljava_text_DateFormatSymbols__f_eras;
    var this$201 = $n($m_s_Predef$().s_Predef$__f_Map);
    var y$59 = $n(array$4$1).get(0);
    var $$x58 = $ct_T2__O__O__(new $c_T2(), $L0, y$59);
    var y$60 = $n(array$4$1).get(1);
    var array$11 = [$$x58, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$60)];
    var elems$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
    var mapS$3 = this$201.from__sc_IterableOnce__sci_Map(elems$10);
    if (($n(locale).getLanguage__T() === $n($m_ju_Locale$().ENGLISH__ju_Locale()).getLanguage__T())) {
      var this$209 = $n($m_s_Predef$().s_Predef$__f_Map);
      var array$12 = [$ct_T2__O__O__(new $c_T2(), $L0, "Before Christ"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), "Anno Domini")];
      var elems$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
      var mapF$3 = this$209.from__sc_IterableOnce__sci_Map(elems$11)
    } else {
      var mapF$3 = mapS$3
    };
    var this$219 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$211 = $n($n(array$4$1).get(0));
    if ((this$211.length < 1)) {
      $charAt(this$211, 1)
    };
    var y$61 = $as_T(this$211.substring(0, 1));
    var $$x59 = $ct_T2__O__O__(new $c_T2(), $L0, y$61);
    var this$214 = $n($n(array$4$1).get(1));
    if ((this$214.length < 1)) {
      $charAt(this$214, 1)
    };
    var y$62 = $as_T(this$214.substring(0, 1));
    var array$13 = [$$x59, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$62)];
    var elems$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
    var mapN$3 = this$219.from__sc_IterableOnce__sci_Map(elems$12);
    var this$229 = $n($m_s_Predef$().s_Predef$__f_Map);
    var self$8 = $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle();
    var $$x61 = $ct_T2__O__O__(new $c_T2(), self$8, mapS$3);
    var self$9 = $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle();
    var $$x60 = $ct_T2__O__O__(new $c_T2(), self$9, mapF$3);
    var self$10 = $m_Ljava_time_format_TextStyle$().NARROW__Ljava_time_format_TextStyle();
    var array$14 = [$$x61, $$x60, $ct_T2__O__O__(new $c_T2(), self$10, mapN$3)];
    var elems$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
    var styleMap$4 = this$229.from__sc_IterableOnce__sci_Map(elems$13);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap$4)
  };
  if ((field === $m_Ljava_time_temporal_IsoFields$().QUARTER_OF_YEAR__Ljava_time_temporal_TemporalField())) {
    var this$241 = $n($m_s_Predef$().s_Predef$__f_Map);
    var array$15 = [$ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), "Q1"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), "Q2"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), "Q3"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), "Q4")];
    var elems$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
    var mapS$4 = this$241.from__sc_IterableOnce__sci_Map(elems$14);
    var this$253 = $n($m_s_Predef$().s_Predef$__f_Map);
    var array$16 = [$ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), "1st quarter"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), "2nd quarter"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), "3rd quarter"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), "4th quarter")];
    var elems$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
    var mapF$4 = this$253.from__sc_IterableOnce__sci_Map(elems$15);
    var this$261 = $n($m_s_Predef$().s_Predef$__f_Map);
    var self$11 = $m_Ljava_time_format_TextStyle$().SHORT__Ljava_time_format_TextStyle();
    var $$x62 = $ct_T2__O__O__(new $c_T2(), self$11, mapS$4);
    var self$12 = $m_Ljava_time_format_TextStyle$().FULL__Ljava_time_format_TextStyle();
    var array$17 = [$$x62, $ct_T2__O__O__(new $c_T2(), self$12, mapF$4)];
    var elems$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
    var styleMap$5 = this$261.from__sc_IterableOnce__sci_Map(elems$16);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap$5)
  };
  return ""
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider() {
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_cache = null;
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_bitmap$init$0 = false;
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_cache = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_bitmap$init$0 = true
}
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeTextProvider();
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype.constructor = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype;
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype.getText__Ljava_time_temporal_TemporalField__J__Ljava_time_format_TextStyle__ju_Locale__T = (function(field, value, style, locale) {
  var x1 = $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__findStore__Ljava_time_temporal_TemporalField__ju_Locale__O(this, field, locale);
  if ((x1 instanceof $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore)) {
    var x2 = $as_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(x1);
    return $n(x2).getText__J__Ljava_time_format_TextStyle__T(value, style)
  } else {
    return null
  }
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype.getTextIterator__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__ju_Locale__sc_Iterator = (function(field, style, locale) {
  var x1 = $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__findStore__Ljava_time_temporal_TemporalField__ju_Locale__O(this, field, locale);
  if ((x1 instanceof $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore)) {
    var x2 = $as_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(x1);
    return $n(x2).getTextIterator__Ljava_time_format_TextStyle__sc_Iterator(style)
  } else {
    return null
  }
});
var $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider: 0
}, false, "java.time.format.internal.TTBPSimpleDateTimeTextProvider", {
  Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider: 1,
  Ljava_time_format_internal_TTBPDateTimeTextProvider: 1,
  O: 1
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype.$classData = $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider;
function $p_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((1 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_NANO_OF_SECOND = new $c_Ljava_time_temporal_ChronoField("NanoOfSecond", 0, $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(999999999, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (1 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_NANO_OF_SECOND
}
function $p_Ljava_time_temporal_ChronoField$__NANO_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((2 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_NANO_OF_DAY = new $c_Ljava_time_temporal_ChronoField("NanoOfDay", 1, $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong((-1857093633), 20116)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (2 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_NANO_OF_DAY
}
function $p_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((4 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_MICRO_OF_SECOND = new $c_Ljava_time_temporal_ChronoField("MicroOfSecond", 2, $m_Ljava_time_temporal_ChronoUnit$().MICROS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(999999, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (4 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_MICRO_OF_SECOND
}
function $p_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((8 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_MICRO_OF_DAY = new $c_Ljava_time_temporal_ChronoField("MicroOfDay", 3, $m_Ljava_time_temporal_ChronoUnit$().MICROS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(500654079, 20)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (8 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_MICRO_OF_DAY
}
function $p_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((16 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_MILLI_OF_SECOND = new $c_Ljava_time_temporal_ChronoField("MilliOfSecond", 4, $m_Ljava_time_temporal_ChronoUnit$().MILLIS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(999, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (16 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_MILLI_OF_SECOND
}
function $p_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((32 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_MILLI_OF_DAY = new $c_Ljava_time_temporal_ChronoField("MilliOfDay", 5, $m_Ljava_time_temporal_ChronoUnit$().MILLIS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(86399999, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (32 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_MILLI_OF_DAY
}
function $p_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((64 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_SECOND_OF_MINUTE = new $c_Ljava_time_temporal_ChronoField("SecondOfMinute", 6, $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(59, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (64 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_SECOND_OF_MINUTE
}
function $p_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((128 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_SECOND_OF_DAY = new $c_Ljava_time_temporal_ChronoField("SecondOfDay", 7, $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(86399, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (128 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_SECOND_OF_DAY
}
function $p_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((256 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_MINUTE_OF_HOUR = new $c_Ljava_time_temporal_ChronoField("MinuteOfHour", 8, $m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(59, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (256 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_MINUTE_OF_HOUR
}
function $p_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((512 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_MINUTE_OF_DAY = new $c_Ljava_time_temporal_ChronoField("MinuteOfDay", 9, $m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1439, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (512 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_MINUTE_OF_DAY
}
function $p_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((1024 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_HOUR_OF_AMPM = new $c_Ljava_time_temporal_ChronoField("HourOfAmPm", 10, $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(11, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (1024 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_HOUR_OF_AMPM
}
function $p_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((2048 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_CLOCK_HOUR_OF_AMPM = new $c_Ljava_time_temporal_ChronoField("ClockHourOfAmPm", 11, $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(12, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (2048 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_CLOCK_HOUR_OF_AMPM
}
function $p_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((4096 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_HOUR_OF_DAY = new $c_Ljava_time_temporal_ChronoField("HourOfDay", 12, $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(23, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (4096 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_HOUR_OF_DAY
}
function $p_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((8192 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_CLOCK_HOUR_OF_DAY = new $c_Ljava_time_temporal_ChronoField("ClockHourOfDay", 13, $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(24, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (8192 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_CLOCK_HOUR_OF_DAY
}
function $p_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((16384 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_AMPM_OF_DAY = new $c_Ljava_time_temporal_ChronoField("AmPmOfDay", 14, $m_Ljava_time_temporal_ChronoUnit$().HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (16384 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_AMPM_OF_DAY
}
function $p_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((32768 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_DAY_OF_WEEK = new $c_Ljava_time_temporal_ChronoField("DayOfWeek", 15, $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (32768 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_DAY_OF_WEEK
}
function $p_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((65536 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_ALIGNED_DAY_OF_WEEK_IN_MONTH = new $c_Ljava_time_temporal_ChronoField("AlignedDayOfWeekInMonth", 16, $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (65536 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_ALIGNED_DAY_OF_WEEK_IN_MONTH
}
function $p_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((131072 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_ALIGNED_DAY_OF_WEEK_IN_YEAR = new $c_Ljava_time_temporal_ChronoField("AlignedDayOfWeekInYear", 17, $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (131072 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_ALIGNED_DAY_OF_WEEK_IN_YEAR
}
function $p_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((262144 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    var $$x2 = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
    var $$x1 = $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit();
    var this$1 = $m_Ljava_time_temporal_ValueRange$();
    $thiz.Ljava_time_temporal_ChronoField$__f_DAY_OF_MONTH = new $c_Ljava_time_temporal_ChronoField("DayOfMonth", 18, $$x2, $$x1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(28, 0), new $c_RTLong(31, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (262144 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_DAY_OF_MONTH
}
function $p_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((524288 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    var $$x2 = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
    var $$x1 = $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit();
    var this$1 = $m_Ljava_time_temporal_ValueRange$();
    $thiz.Ljava_time_temporal_ChronoField$__f_DAY_OF_YEAR = new $c_Ljava_time_temporal_ChronoField("DayOfYear", 19, $$x2, $$x1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(365, 0), new $c_RTLong(366, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (524288 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_DAY_OF_YEAR
}
function $p_Ljava_time_temporal_ChronoField$__EPOCH_DAY$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((1048576 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_EPOCH_DAY = new $c_Ljava_time_temporal_ChronoField("EpochDay", 20, $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong((-170999002), (-86)), new $c_RTLong(169560311, 85)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (1048576 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_EPOCH_DAY
}
function $p_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((2097152 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    var $$x2 = $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit();
    var $$x1 = $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit();
    var this$1 = $m_Ljava_time_temporal_ValueRange$();
    $thiz.Ljava_time_temporal_ChronoField$__f_ALIGNED_WEEK_OF_MONTH = new $c_Ljava_time_temporal_ChronoField("AlignedWeekOfMonth", 21, $$x2, $$x1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(4, 0), new $c_RTLong(5, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (2097152 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_ALIGNED_WEEK_OF_MONTH
}
function $p_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((4194304 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_ALIGNED_WEEK_OF_YEAR = new $c_Ljava_time_temporal_ChronoField("AlignedWeekOfYear", 22, $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(53, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (4194304 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_ALIGNED_WEEK_OF_YEAR
}
function $p_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((8388608 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_MONTH_OF_YEAR = new $c_Ljava_time_temporal_ChronoField("MonthOfYear", 23, $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(12, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (8388608 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_MONTH_OF_YEAR
}
function $p_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((16777216 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    var $$x4 = $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit();
    var $$x3 = $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit();
    var $$x2 = $m_Ljava_time_temporal_ValueRange$();
    var value = $m_Ljava_time_Year$().MIN_VALUE__I();
    var hi = (value >> 31);
    var b0 = (65535 & value);
    var b1 = ((value >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
    var $$x1 = new $c_RTLong(lo, hi$1);
    var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
    var hi$2 = (value$1 >> 31);
    var b0$1 = (65535 & value$1);
    var b1$1 = ((value$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(12, b0$1);
    var a0b1$1 = Math.imul(12, b1$1);
    var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$3 = ((Math.imul(12, hi$2) + ((c1part$1 >>> 16) | 0)) | 0);
    var lo$2 = ((11 + lo$1) | 0);
    var hi$4 = ((((-2147483648) ^ lo$2) < (-2147483637)) ? ((1 + hi$3) | 0) : hi$3);
    $thiz.Ljava_time_temporal_ChronoField$__f_PROLEPTIC_MONTH = new $c_Ljava_time_temporal_ChronoField("ProlepticMonth", 24, $$x4, $$x3, $n($$x2).of__J__J__Ljava_time_temporal_ValueRange($$x1, new $c_RTLong(lo$2, hi$4)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (16777216 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_PROLEPTIC_MONTH
}
function $p_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((33554432 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    var $$x2 = $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit();
    var $$x1 = $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit();
    var this$4 = $m_Ljava_time_temporal_ValueRange$();
    var value = $m_Ljava_time_Year$().MAX_VALUE__I();
    var hi = (value >> 31);
    var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
    var hi$1 = (value$1 >> 31);
    var lo = ((1 + value$1) | 0);
    var hi$2 = ((lo === 0) ? ((1 + hi$1) | 0) : hi$1);
    $thiz.Ljava_time_temporal_ChronoField$__f_YEAR_OF_ERA = new $c_Ljava_time_temporal_ChronoField("YearOfEra", 25, $$x2, $$x1, this$4.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(value, hi), new $c_RTLong(lo, hi$2)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (33554432 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_YEAR_OF_ERA
}
function $p_Ljava_time_temporal_ChronoField$__YEAR$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((67108864 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    var $$x4 = $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit();
    var $$x3 = $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit();
    var $$x2 = $m_Ljava_time_temporal_ValueRange$();
    var value = $m_Ljava_time_Year$().MIN_VALUE__I();
    var hi = (value >> 31);
    var $$x1 = new $c_RTLong(value, hi);
    var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
    var hi$1 = (value$1 >> 31);
    $thiz.Ljava_time_temporal_ChronoField$__f_YEAR = new $c_Ljava_time_temporal_ChronoField("Year", 26, $$x4, $$x3, $n($$x2).of__J__J__Ljava_time_temporal_ValueRange($$x1, new $c_RTLong(value$1, hi$1)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (67108864 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_YEAR
}
function $p_Ljava_time_temporal_ChronoField$__ERA$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((134217728 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_ERA = new $c_Ljava_time_temporal_ChronoField("Era", 27, $m_Ljava_time_temporal_ChronoUnit$().ERAS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (134217728 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_ERA
}
function $p_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((268435456 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_INSTANT_SECONDS = new $c_Ljava_time_temporal_ChronoField("InstantSeconds", 28, $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(0, (-2147483648)), new $c_RTLong((-1), 2147483647)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (268435456 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_INSTANT_SECONDS
}
function $p_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS$lzycompute__Ljava_time_temporal_ChronoField($thiz) {
  if (((536870912 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_OFFSET_SECONDS = new $c_Ljava_time_temporal_ChronoField("OffsetSeconds", 29, $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong((-64800), (-1)), new $c_RTLong(64800, 0)));
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (536870912 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_OFFSET_SECONDS
}
function $p_Ljava_time_temporal_ChronoField$__values$lzycompute__ALjava_time_temporal_ChronoField($thiz) {
  if (((1073741824 & $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoField$__f_values = new ($d_Ljava_time_temporal_ChronoField.getArrayOf().constr)([$thiz.NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), $thiz.NANO_OF_DAY__Ljava_time_temporal_ChronoField(), $thiz.MICRO_OF_SECOND__Ljava_time_temporal_ChronoField(), $thiz.MICRO_OF_DAY__Ljava_time_temporal_ChronoField(), $thiz.MILLI_OF_SECOND__Ljava_time_temporal_ChronoField(), $thiz.MILLI_OF_DAY__Ljava_time_temporal_ChronoField(), $thiz.SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), $thiz.SECOND_OF_DAY__Ljava_time_temporal_ChronoField(), $thiz.MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), $thiz.MINUTE_OF_DAY__Ljava_time_temporal_ChronoField(), $thiz.HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), $thiz.CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), $thiz.HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), $thiz.CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), $thiz.AMPM_OF_DAY__Ljava_time_temporal_ChronoField(), $thiz.DAY_OF_WEEK__Ljava_time_temporal_ChronoField(), $thiz.ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField(), $thiz.ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField(), $thiz.DAY_OF_MONTH__Ljava_time_temporal_ChronoField(), $thiz.DAY_OF_YEAR__Ljava_time_temporal_ChronoField(), $thiz.EPOCH_DAY__Ljava_time_temporal_ChronoField(), $thiz.ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField(), $thiz.ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField(), $thiz.MONTH_OF_YEAR__Ljava_time_temporal_ChronoField(), $thiz.PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField(), $thiz.YEAR_OF_ERA__Ljava_time_temporal_ChronoField(), $thiz.YEAR__Ljava_time_temporal_ChronoField(), $thiz.ERA__Ljava_time_temporal_ChronoField(), $thiz.INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), $thiz.OFFSET_SECONDS__Ljava_time_temporal_ChronoField()]);
    $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0 = (1073741824 | $thiz.Ljava_time_temporal_ChronoField$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoField$__f_values
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$() {
  this.Ljava_time_temporal_ChronoField$__f_NANO_OF_SECOND = null;
  this.Ljava_time_temporal_ChronoField$__f_NANO_OF_DAY = null;
  this.Ljava_time_temporal_ChronoField$__f_MICRO_OF_SECOND = null;
  this.Ljava_time_temporal_ChronoField$__f_MICRO_OF_DAY = null;
  this.Ljava_time_temporal_ChronoField$__f_MILLI_OF_SECOND = null;
  this.Ljava_time_temporal_ChronoField$__f_MILLI_OF_DAY = null;
  this.Ljava_time_temporal_ChronoField$__f_SECOND_OF_MINUTE = null;
  this.Ljava_time_temporal_ChronoField$__f_SECOND_OF_DAY = null;
  this.Ljava_time_temporal_ChronoField$__f_MINUTE_OF_HOUR = null;
  this.Ljava_time_temporal_ChronoField$__f_MINUTE_OF_DAY = null;
  this.Ljava_time_temporal_ChronoField$__f_HOUR_OF_AMPM = null;
  this.Ljava_time_temporal_ChronoField$__f_CLOCK_HOUR_OF_AMPM = null;
  this.Ljava_time_temporal_ChronoField$__f_HOUR_OF_DAY = null;
  this.Ljava_time_temporal_ChronoField$__f_CLOCK_HOUR_OF_DAY = null;
  this.Ljava_time_temporal_ChronoField$__f_AMPM_OF_DAY = null;
  this.Ljava_time_temporal_ChronoField$__f_DAY_OF_WEEK = null;
  this.Ljava_time_temporal_ChronoField$__f_ALIGNED_DAY_OF_WEEK_IN_MONTH = null;
  this.Ljava_time_temporal_ChronoField$__f_ALIGNED_DAY_OF_WEEK_IN_YEAR = null;
  this.Ljava_time_temporal_ChronoField$__f_DAY_OF_MONTH = null;
  this.Ljava_time_temporal_ChronoField$__f_DAY_OF_YEAR = null;
  this.Ljava_time_temporal_ChronoField$__f_EPOCH_DAY = null;
  this.Ljava_time_temporal_ChronoField$__f_ALIGNED_WEEK_OF_MONTH = null;
  this.Ljava_time_temporal_ChronoField$__f_ALIGNED_WEEK_OF_YEAR = null;
  this.Ljava_time_temporal_ChronoField$__f_MONTH_OF_YEAR = null;
  this.Ljava_time_temporal_ChronoField$__f_PROLEPTIC_MONTH = null;
  this.Ljava_time_temporal_ChronoField$__f_YEAR_OF_ERA = null;
  this.Ljava_time_temporal_ChronoField$__f_YEAR = null;
  this.Ljava_time_temporal_ChronoField$__f_ERA = null;
  this.Ljava_time_temporal_ChronoField$__f_INSTANT_SECONDS = null;
  this.Ljava_time_temporal_ChronoField$__f_OFFSET_SECONDS = null;
  this.Ljava_time_temporal_ChronoField$__f_values = null;
  this.Ljava_time_temporal_ChronoField$__f_bitmap$0 = 0
}
$c_Ljava_time_temporal_ChronoField$.prototype = new $h_O();
$c_Ljava_time_temporal_ChronoField$.prototype.constructor = $c_Ljava_time_temporal_ChronoField$;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField$.prototype = $c_Ljava_time_temporal_ChronoField$.prototype;
$c_Ljava_time_temporal_ChronoField$.prototype.NANO_OF_SECOND__Ljava_time_temporal_ChronoField = (function() {
  return (((1 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_NANO_OF_SECOND)
});
$c_Ljava_time_temporal_ChronoField$.prototype.NANO_OF_DAY__Ljava_time_temporal_ChronoField = (function() {
  return (((2 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__NANO_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_NANO_OF_DAY)
});
$c_Ljava_time_temporal_ChronoField$.prototype.MICRO_OF_SECOND__Ljava_time_temporal_ChronoField = (function() {
  return (((4 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_MICRO_OF_SECOND)
});
$c_Ljava_time_temporal_ChronoField$.prototype.MICRO_OF_DAY__Ljava_time_temporal_ChronoField = (function() {
  return (((8 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_MICRO_OF_DAY)
});
$c_Ljava_time_temporal_ChronoField$.prototype.MILLI_OF_SECOND__Ljava_time_temporal_ChronoField = (function() {
  return (((16 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_MILLI_OF_SECOND)
});
$c_Ljava_time_temporal_ChronoField$.prototype.MILLI_OF_DAY__Ljava_time_temporal_ChronoField = (function() {
  return (((32 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_MILLI_OF_DAY)
});
$c_Ljava_time_temporal_ChronoField$.prototype.SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField = (function() {
  return (((64 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_SECOND_OF_MINUTE)
});
$c_Ljava_time_temporal_ChronoField$.prototype.SECOND_OF_DAY__Ljava_time_temporal_ChronoField = (function() {
  return (((128 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_SECOND_OF_DAY)
});
$c_Ljava_time_temporal_ChronoField$.prototype.MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField = (function() {
  return (((256 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_MINUTE_OF_HOUR)
});
$c_Ljava_time_temporal_ChronoField$.prototype.MINUTE_OF_DAY__Ljava_time_temporal_ChronoField = (function() {
  return (((512 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_MINUTE_OF_DAY)
});
$c_Ljava_time_temporal_ChronoField$.prototype.HOUR_OF_AMPM__Ljava_time_temporal_ChronoField = (function() {
  return (((1024 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_HOUR_OF_AMPM)
});
$c_Ljava_time_temporal_ChronoField$.prototype.CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField = (function() {
  return (((2048 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_CLOCK_HOUR_OF_AMPM)
});
$c_Ljava_time_temporal_ChronoField$.prototype.HOUR_OF_DAY__Ljava_time_temporal_ChronoField = (function() {
  return (((4096 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_HOUR_OF_DAY)
});
$c_Ljava_time_temporal_ChronoField$.prototype.CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField = (function() {
  return (((8192 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_CLOCK_HOUR_OF_DAY)
});
$c_Ljava_time_temporal_ChronoField$.prototype.AMPM_OF_DAY__Ljava_time_temporal_ChronoField = (function() {
  return (((16384 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_AMPM_OF_DAY)
});
$c_Ljava_time_temporal_ChronoField$.prototype.DAY_OF_WEEK__Ljava_time_temporal_ChronoField = (function() {
  return (((32768 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_DAY_OF_WEEK)
});
$c_Ljava_time_temporal_ChronoField$.prototype.ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField = (function() {
  return (((65536 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_ALIGNED_DAY_OF_WEEK_IN_MONTH)
});
$c_Ljava_time_temporal_ChronoField$.prototype.ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField = (function() {
  return (((131072 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_ALIGNED_DAY_OF_WEEK_IN_YEAR)
});
$c_Ljava_time_temporal_ChronoField$.prototype.DAY_OF_MONTH__Ljava_time_temporal_ChronoField = (function() {
  return (((262144 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_DAY_OF_MONTH)
});
$c_Ljava_time_temporal_ChronoField$.prototype.DAY_OF_YEAR__Ljava_time_temporal_ChronoField = (function() {
  return (((524288 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_DAY_OF_YEAR)
});
$c_Ljava_time_temporal_ChronoField$.prototype.EPOCH_DAY__Ljava_time_temporal_ChronoField = (function() {
  return (((1048576 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__EPOCH_DAY$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_EPOCH_DAY)
});
$c_Ljava_time_temporal_ChronoField$.prototype.ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField = (function() {
  return (((2097152 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_ALIGNED_WEEK_OF_MONTH)
});
$c_Ljava_time_temporal_ChronoField$.prototype.ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField = (function() {
  return (((4194304 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_ALIGNED_WEEK_OF_YEAR)
});
$c_Ljava_time_temporal_ChronoField$.prototype.MONTH_OF_YEAR__Ljava_time_temporal_ChronoField = (function() {
  return (((8388608 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_MONTH_OF_YEAR)
});
$c_Ljava_time_temporal_ChronoField$.prototype.PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField = (function() {
  return (((16777216 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_PROLEPTIC_MONTH)
});
$c_Ljava_time_temporal_ChronoField$.prototype.YEAR_OF_ERA__Ljava_time_temporal_ChronoField = (function() {
  return (((33554432 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_YEAR_OF_ERA)
});
$c_Ljava_time_temporal_ChronoField$.prototype.YEAR__Ljava_time_temporal_ChronoField = (function() {
  return (((67108864 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__YEAR$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_YEAR)
});
$c_Ljava_time_temporal_ChronoField$.prototype.ERA__Ljava_time_temporal_ChronoField = (function() {
  return (((134217728 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__ERA$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_ERA)
});
$c_Ljava_time_temporal_ChronoField$.prototype.INSTANT_SECONDS__Ljava_time_temporal_ChronoField = (function() {
  return (((268435456 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_INSTANT_SECONDS)
});
$c_Ljava_time_temporal_ChronoField$.prototype.OFFSET_SECONDS__Ljava_time_temporal_ChronoField = (function() {
  return (((536870912 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS$lzycompute__Ljava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_OFFSET_SECONDS)
});
$c_Ljava_time_temporal_ChronoField$.prototype.values__ALjava_time_temporal_ChronoField = (function() {
  return (((1073741824 & this.Ljava_time_temporal_ChronoField$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoField$__values$lzycompute__ALjava_time_temporal_ChronoField(this) : this.Ljava_time_temporal_ChronoField$__f_values)
});
var $d_Ljava_time_temporal_ChronoField$ = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField$: 0
}, false, "java.time.temporal.ChronoField$", {
  Ljava_time_temporal_ChronoField$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_ChronoField$.prototype.$classData = $d_Ljava_time_temporal_ChronoField$;
var $n_Ljava_time_temporal_ChronoField$;
function $m_Ljava_time_temporal_ChronoField$() {
  if ((!$n_Ljava_time_temporal_ChronoField$)) {
    $n_Ljava_time_temporal_ChronoField$ = new $c_Ljava_time_temporal_ChronoField$()
  };
  return $n_Ljava_time_temporal_ChronoField$
}
function $p_Ljava_time_temporal_ChronoUnit$__NANOS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((1 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoUnit$__f_NANOS = new $c_Ljava_time_temporal_ChronoUnit("Nanos", 0, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(new $c_RTLong(1, 0)));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (1 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_NANOS
}
function $p_Ljava_time_temporal_ChronoUnit$__MICROS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((2 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoUnit$__f_MICROS = new $c_Ljava_time_temporal_ChronoUnit("Micros", 1, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(new $c_RTLong(1000, 0)));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (2 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_MICROS
}
function $p_Ljava_time_temporal_ChronoUnit$__MILLIS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((4 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoUnit$__f_MILLIS = new $c_Ljava_time_temporal_ChronoUnit("Millis", 2, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(new $c_RTLong(1000000, 0)));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (4 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_MILLIS
}
function $p_Ljava_time_temporal_ChronoUnit$__SECONDS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((8 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_SECONDS = new $c_Ljava_time_temporal_ChronoUnit("Seconds", 3, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(1, 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (8 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_SECONDS
}
function $p_Ljava_time_temporal_ChronoUnit$__MINUTES$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((16 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_MINUTES = new $c_Ljava_time_temporal_ChronoUnit("Minutes", 4, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(60, 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (16 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_MINUTES
}
function $p_Ljava_time_temporal_ChronoUnit$__HOURS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((32 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_HOURS = new $c_Ljava_time_temporal_ChronoUnit("Hours", 5, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(3600, 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (32 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_HOURS
}
function $p_Ljava_time_temporal_ChronoUnit$__HALF_DAYS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((64 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_HALF_DAYS = new $c_Ljava_time_temporal_ChronoUnit("HalfDays", 6, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(43200, 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (64 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_HALF_DAYS
}
function $p_Ljava_time_temporal_ChronoUnit$__DAYS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((128 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_DAYS = new $c_Ljava_time_temporal_ChronoUnit("Days", 7, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(86400, 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (128 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_DAYS
}
function $p_Ljava_time_temporal_ChronoUnit$__WEEKS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((256 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_WEEKS = new $c_Ljava_time_temporal_ChronoUnit("Weeks", 8, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(604800, 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (256 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_WEEKS
}
function $p_Ljava_time_temporal_ChronoUnit$__MONTHS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((512 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_MONTHS = new $c_Ljava_time_temporal_ChronoUnit("Months", 9, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(2629746, 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (512 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_MONTHS
}
function $p_Ljava_time_temporal_ChronoUnit$__YEARS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((1024 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_YEARS = new $c_Ljava_time_temporal_ChronoUnit("Years", 10, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(31556952, 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (1024 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_YEARS
}
function $p_Ljava_time_temporal_ChronoUnit$__DECADES$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((2048 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_DECADES = new $c_Ljava_time_temporal_ChronoUnit("Decades", 11, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(315569520, 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (2048 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_DECADES
}
function $p_Ljava_time_temporal_ChronoUnit$__CENTURIES$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((4096 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_CENTURIES = new $c_Ljava_time_temporal_ChronoUnit("Centuries", 12, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong((-1139272096), 0), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (4096 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_CENTURIES
}
function $p_Ljava_time_temporal_ChronoUnit$__MILLENNIA$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((8192 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_MILLENNIA = new $c_Ljava_time_temporal_ChronoUnit("Millenia", 13, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(1492180928, 7), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (8192 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_MILLENNIA
}
function $p_Ljava_time_temporal_ChronoUnit$__ERAS$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((16384 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_ChronoUnit$__f_ERAS = new $c_Ljava_time_temporal_ChronoUnit("Eras", 14, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(1915187200, 7347425), 0));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (16384 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_ERAS
}
function $p_Ljava_time_temporal_ChronoUnit$__FOREVER$lzycompute__Ljava_time_temporal_ChronoUnit($thiz) {
  if (((32768 & $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0)) {
    $thiz.Ljava_time_temporal_ChronoUnit$__f_FOREVER = new $c_Ljava_time_temporal_ChronoUnit("Forever", 15, $m_Ljava_time_Duration$().ofSeconds__J__J__Ljava_time_Duration(new $c_RTLong((-1), 2147483647), new $c_RTLong(999999999, 0)));
    $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = (32768 | $thiz.Ljava_time_temporal_ChronoUnit$__f_bitmap$0)
  };
  return $thiz.Ljava_time_temporal_ChronoUnit$__f_FOREVER
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$() {
  this.Ljava_time_temporal_ChronoUnit$__f_NANOS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_MICROS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_MILLIS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_SECONDS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_MINUTES = null;
  this.Ljava_time_temporal_ChronoUnit$__f_HOURS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_HALF_DAYS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_DAYS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_WEEKS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_MONTHS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_YEARS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_DECADES = null;
  this.Ljava_time_temporal_ChronoUnit$__f_CENTURIES = null;
  this.Ljava_time_temporal_ChronoUnit$__f_MILLENNIA = null;
  this.Ljava_time_temporal_ChronoUnit$__f_ERAS = null;
  this.Ljava_time_temporal_ChronoUnit$__f_FOREVER = null;
  this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0 = 0
}
$c_Ljava_time_temporal_ChronoUnit$.prototype = new $h_O();
$c_Ljava_time_temporal_ChronoUnit$.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit$.prototype = $c_Ljava_time_temporal_ChronoUnit$.prototype;
$c_Ljava_time_temporal_ChronoUnit$.prototype.NANOS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((1 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__NANOS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_NANOS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.MICROS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((2 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__MICROS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_MICROS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.MILLIS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((4 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__MILLIS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_MILLIS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.SECONDS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((8 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__SECONDS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_SECONDS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.MINUTES__Ljava_time_temporal_ChronoUnit = (function() {
  return (((16 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__MINUTES$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_MINUTES)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.HOURS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((32 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__HOURS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_HOURS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.HALF_DAYS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((64 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__HALF_DAYS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_HALF_DAYS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.DAYS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((128 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__DAYS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_DAYS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.WEEKS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((256 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__WEEKS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_WEEKS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.MONTHS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((512 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__MONTHS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_MONTHS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.YEARS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((1024 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__YEARS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_YEARS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.DECADES__Ljava_time_temporal_ChronoUnit = (function() {
  return (((2048 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__DECADES$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_DECADES)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.CENTURIES__Ljava_time_temporal_ChronoUnit = (function() {
  return (((4096 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__CENTURIES$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_CENTURIES)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.MILLENNIA__Ljava_time_temporal_ChronoUnit = (function() {
  return (((8192 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__MILLENNIA$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_MILLENNIA)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.ERAS__Ljava_time_temporal_ChronoUnit = (function() {
  return (((16384 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__ERAS$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_ERAS)
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.FOREVER__Ljava_time_temporal_ChronoUnit = (function() {
  return (((32768 & this.Ljava_time_temporal_ChronoUnit$__f_bitmap$0) === 0) ? $p_Ljava_time_temporal_ChronoUnit$__FOREVER$lzycompute__Ljava_time_temporal_ChronoUnit(this) : this.Ljava_time_temporal_ChronoUnit$__f_FOREVER)
});
var $d_Ljava_time_temporal_ChronoUnit$ = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit$: 0
}, false, "java.time.temporal.ChronoUnit$", {
  Ljava_time_temporal_ChronoUnit$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_ChronoUnit$.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit$;
var $n_Ljava_time_temporal_ChronoUnit$;
function $m_Ljava_time_temporal_ChronoUnit$() {
  if ((!$n_Ljava_time_temporal_ChronoUnit$)) {
    $n_Ljava_time_temporal_ChronoUnit$ = new $c_Ljava_time_temporal_ChronoUnit$()
  };
  return $n_Ljava_time_temporal_ChronoUnit$
}
function $p_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR$lzycompute__Ljava_time_temporal_IsoFields$Field($thiz) {
  if (((((2 & $thiz.Ljava_time_temporal_IsoFields$Field$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_IsoFields$Field$__f_QUARTER_OF_YEAR = new $c_Ljava_time_temporal_IsoFields$Field$$anon$2();
    $thiz.Ljava_time_temporal_IsoFields$Field$__f_bitmap$0 = (((2 | $thiz.Ljava_time_temporal_IsoFields$Field$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_IsoFields$Field$__f_QUARTER_OF_YEAR
}
function $p_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR$lzycompute__Ljava_time_temporal_IsoFields$Field($thiz) {
  if (((((8 & $thiz.Ljava_time_temporal_IsoFields$Field$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_IsoFields$Field$__f_WEEK_BASED_YEAR = new $c_Ljava_time_temporal_IsoFields$Field$$anon$4();
    $thiz.Ljava_time_temporal_IsoFields$Field$__f_bitmap$0 = (((8 | $thiz.Ljava_time_temporal_IsoFields$Field$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_IsoFields$Field$__f_WEEK_BASED_YEAR
}
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field$() {
  this.Ljava_time_temporal_IsoFields$Field$__f_QUARTER_OF_YEAR = null;
  this.Ljava_time_temporal_IsoFields$Field$__f_WEEK_BASED_YEAR = null;
  this.Ljava_time_temporal_IsoFields$Field$__f_bitmap$0 = 0
}
$c_Ljava_time_temporal_IsoFields$Field$.prototype = new $h_O();
$c_Ljava_time_temporal_IsoFields$Field$.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field$;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_IsoFields$Field$.prototype = $c_Ljava_time_temporal_IsoFields$Field$.prototype;
$c_Ljava_time_temporal_IsoFields$Field$.prototype.QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field = (function() {
  return (((((2 & this.Ljava_time_temporal_IsoFields$Field$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR$lzycompute__Ljava_time_temporal_IsoFields$Field(this) : this.Ljava_time_temporal_IsoFields$Field$__f_QUARTER_OF_YEAR)
});
$c_Ljava_time_temporal_IsoFields$Field$.prototype.java$time$temporal$IsoFields$Field$$unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException = (function(f) {
  return new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + f))
});
$c_Ljava_time_temporal_IsoFields$Field$.prototype.WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field = (function() {
  return (((((8 & this.Ljava_time_temporal_IsoFields$Field$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR$lzycompute__Ljava_time_temporal_IsoFields$Field(this) : this.Ljava_time_temporal_IsoFields$Field$__f_WEEK_BASED_YEAR)
});
$c_Ljava_time_temporal_IsoFields$Field$.prototype.java$time$temporal$IsoFields$Field$$isIso__Ljava_time_temporal_TemporalAccessor__Z = (function(temporal) {
  var x = $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal);
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  if ((x === null)) {
    return (x$2 === null)
  } else {
    var this$1 = $n(x);
    return $f_Ljava_time_chrono_Chronology__equals__O__Z(this$1, x$2)
  }
});
$c_Ljava_time_temporal_IsoFields$Field$.prototype.java$time$temporal$IsoFields$Field$$getWeekRange__Ljava_time_LocalDate__Ljava_time_temporal_ValueRange = (function(date) {
  var wby = this.java$time$temporal$IsoFields$Field$$getWeekBasedYear__Ljava_time_LocalDate__I(date);
  var $$x1 = $m_Ljava_time_temporal_ValueRange$();
  var value = this.java$time$temporal$IsoFields$Field$$getWeekRange__I__I(wby);
  var hi = (value >> 31);
  return $n($$x1).of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value, hi))
});
$c_Ljava_time_temporal_IsoFields$Field$.prototype.java$time$temporal$IsoFields$Field$$getWeekRange__I__I = (function(wby) {
  var date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(wby, 1, 1);
  if (($n(date).getDayOfWeek__Ljava_time_DayOfWeek() === $m_Ljava_time_DayOfWeek$().THURSDAY__Ljava_time_DayOfWeek())) {
    var $$x1 = true
  } else if (($n(date).getDayOfWeek__Ljava_time_DayOfWeek() === $m_Ljava_time_DayOfWeek$().WEDNESDAY__Ljava_time_DayOfWeek())) {
    var this$1 = $n(date);
    var $$x2 = $n($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    var value = this$1.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    var $$x1 = $n($$x2).isLeapYear__J__Z(new $c_RTLong(value, hi))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return 53
  } else {
    return 52
  }
});
$c_Ljava_time_temporal_IsoFields$Field$.prototype.java$time$temporal$IsoFields$Field$$getWeek__Ljava_time_LocalDate__I = (function(date) {
  var dow0 = $n($n(date).getDayOfWeek__Ljava_time_DayOfWeek()).jl_Enum__f__ordinal;
  var doy0 = (((-1) + $n(date).getDayOfYear__I()) | 0);
  var doyThu0 = ((doy0 + ((3 - dow0) | 0)) | 0);
  var alignedWeek = ((doyThu0 / 7) | 0);
  var firstThuDoy0 = ((doyThu0 - Math.imul(7, alignedWeek)) | 0);
  var firstMonDoy0 = (((-3) + firstThuDoy0) | 0);
  if ((firstMonDoy0 < (-3))) {
    firstMonDoy0 = ((7 + firstMonDoy0) | 0)
  };
  if ((doy0 < firstMonDoy0)) {
    var this$1 = $n(this.java$time$temporal$IsoFields$Field$$getWeekRange__Ljava_time_LocalDate__Ljava_time_temporal_ValueRange($n($n(date).withDayOfYear__I__Ljava_time_LocalDate(180)).minusYears__J__Ljava_time_LocalDate(new $c_RTLong(1, 0))));
    var this$2 = this$1.Ljava_time_temporal_ValueRange__f_maxLargest;
    return this$2.RTLong__f_lo
  };
  var week = ((1 + ((((doy0 - firstMonDoy0) | 0) / 7) | 0)) | 0);
  if ((week === 53)) {
    if ((firstMonDoy0 === (-3))) {
      var $$x1 = true
    } else if ((firstMonDoy0 === (-2))) {
      var this$3 = $n(date);
      var $$x2 = $n($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
      var value = this$3.Ljava_time_LocalDate__f_year;
      var hi = (value >> 31);
      var $$x1 = $n($$x2).isLeapYear__J__Z(new $c_RTLong(value, hi))
    } else {
      var $$x1 = false
    };
    if ((!$$x1)) {
      week = 1
    }
  };
  return week
});
$c_Ljava_time_temporal_IsoFields$Field$.prototype.java$time$temporal$IsoFields$Field$$getWeekBasedYear__Ljava_time_LocalDate__I = (function(date) {
  var this$1 = $n(date);
  var year = this$1.Ljava_time_LocalDate__f_year;
  var doy = $n(date).getDayOfYear__I();
  if ((doy <= 3)) {
    var dow = $n($n(date).getDayOfWeek__Ljava_time_DayOfWeek()).jl_Enum__f__ordinal;
    if ((((doy - dow) | 0) < (-2))) {
      year = (((-1) + year) | 0)
    }
  } else if ((doy >= 363)) {
    var dow$2 = $n($n(date).getDayOfWeek__Ljava_time_DayOfWeek()).jl_Enum__f__ordinal;
    var $$x2 = doy;
    var this$2 = $n(date);
    var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var value = this$2.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    doy = (((((-363) + $$x2) | 0) - ($n($$x1).isLeapYear__J__Z(new $c_RTLong(value, hi)) ? 1 : 0)) | 0);
    if ((((doy - dow$2) | 0) >= 0)) {
      year = ((1 + year) | 0)
    }
  };
  return year
});
var $d_Ljava_time_temporal_IsoFields$Field$ = new $TypeData().initClass({
  Ljava_time_temporal_IsoFields$Field$: 0
}, false, "java.time.temporal.IsoFields$Field$", {
  Ljava_time_temporal_IsoFields$Field$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_IsoFields$Field$.prototype.$classData = $d_Ljava_time_temporal_IsoFields$Field$;
var $n_Ljava_time_temporal_IsoFields$Field$;
function $m_Ljava_time_temporal_IsoFields$Field$() {
  if ((!$n_Ljava_time_temporal_IsoFields$Field$)) {
    $n_Ljava_time_temporal_IsoFields$Field$ = new $c_Ljava_time_temporal_IsoFields$Field$()
  };
  return $n_Ljava_time_temporal_IsoFields$Field$
}
function $p_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS$lzycompute__Ljava_time_temporal_IsoFields$Unit($thiz) {
  if (((((1 & $thiz.Ljava_time_temporal_IsoFields$Unit$__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_IsoFields$Unit$__f_WEEK_BASED_YEARS = new $c_Ljava_time_temporal_IsoFields$Unit("WeekBasedYear", 0, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(31556952, 0), 0));
    $thiz.Ljava_time_temporal_IsoFields$Unit$__f_bitmap$0 = (((1 | $thiz.Ljava_time_temporal_IsoFields$Unit$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_IsoFields$Unit$__f_WEEK_BASED_YEARS
}
function $p_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS$lzycompute__Ljava_time_temporal_IsoFields$Unit($thiz) {
  if (((((2 & $thiz.Ljava_time_temporal_IsoFields$Unit$__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Ljava_time_Duration$();
    $thiz.Ljava_time_temporal_IsoFields$Unit$__f_QUARTER_YEARS = new $c_Ljava_time_temporal_IsoFields$Unit("QuarterYears", 1, this$1.java$time$Duration$$create__J__I__Ljava_time_Duration(new $c_RTLong(7889238, 0), 0));
    $thiz.Ljava_time_temporal_IsoFields$Unit$__f_bitmap$0 = (((2 | $thiz.Ljava_time_temporal_IsoFields$Unit$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_IsoFields$Unit$__f_QUARTER_YEARS
}
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Unit$() {
  this.Ljava_time_temporal_IsoFields$Unit$__f_WEEK_BASED_YEARS = null;
  this.Ljava_time_temporal_IsoFields$Unit$__f_QUARTER_YEARS = null;
  this.Ljava_time_temporal_IsoFields$Unit$__f_bitmap$0 = 0
}
$c_Ljava_time_temporal_IsoFields$Unit$.prototype = new $h_O();
$c_Ljava_time_temporal_IsoFields$Unit$.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Unit$;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Unit$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_IsoFields$Unit$.prototype = $c_Ljava_time_temporal_IsoFields$Unit$.prototype;
$c_Ljava_time_temporal_IsoFields$Unit$.prototype.WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit = (function() {
  return (((((1 & this.Ljava_time_temporal_IsoFields$Unit$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS$lzycompute__Ljava_time_temporal_IsoFields$Unit(this) : this.Ljava_time_temporal_IsoFields$Unit$__f_WEEK_BASED_YEARS)
});
$c_Ljava_time_temporal_IsoFields$Unit$.prototype.QUARTER_YEARS__Ljava_time_temporal_IsoFields$Unit = (function() {
  return (((((2 & this.Ljava_time_temporal_IsoFields$Unit$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS$lzycompute__Ljava_time_temporal_IsoFields$Unit(this) : this.Ljava_time_temporal_IsoFields$Unit$__f_QUARTER_YEARS)
});
var $d_Ljava_time_temporal_IsoFields$Unit$ = new $TypeData().initClass({
  Ljava_time_temporal_IsoFields$Unit$: 0
}, false, "java.time.temporal.IsoFields$Unit$", {
  Ljava_time_temporal_IsoFields$Unit$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_IsoFields$Unit$.prototype.$classData = $d_Ljava_time_temporal_IsoFields$Unit$;
var $n_Ljava_time_temporal_IsoFields$Unit$;
function $m_Ljava_time_temporal_IsoFields$Unit$() {
  if ((!$n_Ljava_time_temporal_IsoFields$Unit$)) {
    $n_Ljava_time_temporal_IsoFields$Unit$ = new $c_Ljava_time_temporal_IsoFields$Unit$()
  };
  return $n_Ljava_time_temporal_IsoFields$Unit$
}
function $is_Ljava_time_temporal_Temporal(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_temporal_Temporal)))
}
function $as_Ljava_time_temporal_Temporal(obj) {
  return (($is_Ljava_time_temporal_Temporal(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.Temporal"))
}
function $isArrayOf_Ljava_time_temporal_Temporal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_Temporal)))
}
function $asArrayOf_Ljava_time_temporal_Temporal(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_Temporal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.Temporal;", depth))
}
function $p_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__dowValue__I($thiz) {
  if ((!$thiz.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/temporal/TemporalAdjusters.scala: 411")
  };
  return $thiz.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue
}
/** @constructor */
function $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(relative, dayOfWeek) {
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative = 0;
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue = 0;
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_bitmap$init$0 = false;
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative = relative;
  if ((dayOfWeek === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "dayOfWeek")
  };
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue = $n(dayOfWeek).getValue__I();
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_bitmap$init$0 = true
}
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype.constructor = $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek;
/** @constructor */
function $h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype = $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype;
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var calDow = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  if (((this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative < 2) && (calDow === $p_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__dowValue__I(this)))) {
    return temporal
  } else if (((1 & this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative) === 0)) {
    var daysDiff = ((calDow - $p_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__dowValue__I(this)) | 0);
    var $$x1 = $n(temporal);
    if ((daysDiff >= 0)) {
      var hi = (daysDiff >> 31);
      var lo = ((7 - daysDiff) | 0);
      var hi$1 = ((((-2147483648) ^ lo) > (-2147483641)) ? (((-1) - hi) | 0) : ((-hi) | 0));
      var x__lo = lo;
      var x__hi = hi$1
    } else {
      var hi$2 = (daysDiff >> 31);
      var lo$1 = ((-daysDiff) | 0);
      var hi$3 = ((daysDiff !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var x__lo = lo$1;
      var x__hi = hi$3
    };
    return $n($$x1).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(x__lo, x__hi), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit())
  } else {
    var daysDiff$2 = (($p_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__dowValue__I(this) - calDow) | 0);
    var $$x2 = $n(temporal);
    if ((daysDiff$2 >= 0)) {
      var hi$4 = (daysDiff$2 >> 31);
      var lo$2 = ((7 - daysDiff$2) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) > (-2147483641)) ? (((-1) - hi$4) | 0) : ((-hi$4) | 0));
      var x$1__lo = lo$2;
      var x$1__hi = hi$5
    } else {
      var hi$6 = (daysDiff$2 >> 31);
      var lo$3 = ((-daysDiff$2) | 0);
      var hi$7 = ((daysDiff$2 !== 0) ? (~hi$6) : ((-hi$6) | 0));
      var x$1__lo = lo$3;
      var x$1__hi = hi$7
    };
    return $n($$x2).minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(x$1__lo, x$1__hi), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit())
  }
});
var $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek = new $TypeData().initClass({
  Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek: 0
}, false, "java.time.temporal.TemporalAdjusters$RelativeDayOfWeek", {
  Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek: 1,
  O: 1,
  Ljava_time_temporal_TemporalAdjuster: 1
});
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype.$classData = $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$1() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$1.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O(this))
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$1 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$1: 0
}, false, "java.time.temporal.TemporalQueries$$anon$1", {
  Ljava_time_temporal_TemporalQueries$$anon$1: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$1;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$2() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$2.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $as_Ljava_time_chrono_Chronology($n(temporal).query__Ljava_time_temporal_TemporalQuery__O(this))
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$2 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$2: 0
}, false, "java.time.temporal.TemporalQueries$$anon$2", {
  Ljava_time_temporal_TemporalQueries$$anon$2: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$2;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$3() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$3() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $as_Ljava_time_temporal_TemporalUnit($n(temporal).query__Ljava_time_temporal_TemporalQuery__O(this))
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$3 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$3: 0
}, false, "java.time.temporal.TemporalQueries$$anon$3", {
  Ljava_time_temporal_TemporalQueries$$anon$3: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$3;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$4() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$4() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset = (function(temporal) {
  return ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset($n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) : null)
});
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset(temporal)
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$4 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$4: 0
}, false, "java.time.temporal.TemporalQueries$$anon$4", {
  Ljava_time_temporal_TemporalQueries$$anon$4: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$4;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$5() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$5() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId = (function(temporal) {
  var zone = $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()));
  return ((zone !== null) ? zone : $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())))
});
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId(temporal)
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$5 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$5: 0
}, false, "java.time.temporal.TemporalQueries$$anon$5", {
  Ljava_time_temporal_TemporalQueries$$anon$5: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$5;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$6() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$6() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate = (function(temporal) {
  return ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate($n(temporal).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField())) : null)
});
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$6 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$6: 0
}, false, "java.time.temporal.TemporalQueries$$anon$6", {
  Ljava_time_temporal_TemporalQueries$$anon$6: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$6;
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$7() {
  /*<skip>*/
}
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$7() {
  /*<skip>*/
}
$h_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime = (function(temporal) {
  return ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime($n(temporal).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField())) : null)
});
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(temporal)
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$7 = new $TypeData().initClass({
  Ljava_time_temporal_TemporalQueries$$anon$7: 0
}, false, "java.time.temporal.TemporalQueries$$anon$7", {
  Ljava_time_temporal_TemporalQueries$$anon$7: 1,
  O: 1,
  Ljava_time_temporal_TemporalQuery: 1
});
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.$classData = $d_Ljava_time_temporal_TemporalQueries$$anon$7;
/** @constructor */
function $c_Ljava_time_temporal_ValueRange(minSmallest, minLargest, maxSmallest, maxLargest) {
  this.Ljava_time_temporal_ValueRange__f_minSmallest = $L0;
  this.Ljava_time_temporal_ValueRange__f_minLargest = $L0;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest = $L0;
  this.Ljava_time_temporal_ValueRange__f_maxLargest = $L0;
  this.Ljava_time_temporal_ValueRange__f_minSmallest = minSmallest;
  this.Ljava_time_temporal_ValueRange__f_minLargest = minLargest;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest = maxSmallest;
  this.Ljava_time_temporal_ValueRange__f_maxLargest = maxLargest
}
$c_Ljava_time_temporal_ValueRange.prototype = new $h_O();
$c_Ljava_time_temporal_ValueRange.prototype.constructor = $c_Ljava_time_temporal_ValueRange;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ValueRange.prototype = $c_Ljava_time_temporal_ValueRange.prototype;
$c_Ljava_time_temporal_ValueRange.prototype.isFixed__Z = (function() {
  var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var b = this.Ljava_time_temporal_ValueRange__f_minLargest;
  if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
    var this$2 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
    var b$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
    return ((this$2.RTLong__f_lo === b$1.RTLong__f_lo) && (this$2.RTLong__f_hi === b$1.RTLong__f_hi))
  } else {
    return false
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isIntValue__Z = (function() {
  var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 0) : (ahi > (-1)))) {
    var this$2 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-1)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isValidValue__J__Z = (function(value) {
  var b = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var ahi = value.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ value.RTLong__f_lo) >= ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))) {
    var b$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
    var ahi$1 = value.RTLong__f_hi;
    var bhi$1 = b$1.RTLong__f_hi;
    return ((ahi$1 === bhi$1) ? (((-2147483648) ^ value.RTLong__f_lo) <= ((-2147483648) ^ b$1.RTLong__f_lo)) : (ahi$1 < bhi$1))
  } else {
    return false
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isValidIntValue__J__Z = (function(value) {
  return (this.isIntValue__Z() && this.isValidValue__J__Z(value))
});
$c_Ljava_time_temporal_ValueRange.prototype.checkValidValue__J__Ljava_time_temporal_TemporalField__J = (function(value, field) {
  if ((!this.isValidValue__J__Z(value))) {
    if ((field !== null)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Invalid value for " + field) + " (valid values ") + this) + "): ") + value))
    } else {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid value (valid values " + this) + "): ") + value))
    }
  } else {
    return value
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I = (function(value, field) {
  if ((!this.isValidIntValue__J__Z(value))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid int value for " + field) + ": ") + value))
  } else {
    return value.RTLong__f_lo
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_temporal_ValueRange)) {
    var x2 = $as_Ljava_time_temporal_ValueRange(obj);
    if ((this === x2)) {
      return true
    } else {
      var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
      var b = $n(x2).Ljava_time_temporal_ValueRange__f_minSmallest;
      if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
        var this$2 = this.Ljava_time_temporal_ValueRange__f_minLargest;
        var b$1 = $n(x2).Ljava_time_temporal_ValueRange__f_minLargest;
        var $$x2 = ((this$2.RTLong__f_lo === b$1.RTLong__f_lo) && (this$2.RTLong__f_hi === b$1.RTLong__f_hi))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var this$3 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
        var b$2 = $n(x2).Ljava_time_temporal_ValueRange__f_maxSmallest;
        var $$x1 = ((this$3.RTLong__f_lo === b$2.RTLong__f_lo) && (this$3.RTLong__f_hi === b$2.RTLong__f_hi))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var this$4 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
        var b$3 = $n(x2).Ljava_time_temporal_ValueRange__f_maxLargest;
        return ((this$4.RTLong__f_lo === b$3.RTLong__f_lo) && (this$4.RTLong__f_hi === b$3.RTLong__f_hi))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.hashCode__I = (function() {
  var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var b = this.Ljava_time_temporal_ValueRange__f_minLargest;
  var alo = this$1.RTLong__f_lo;
  var ahi = this$1.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo + b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  var b$1 = this.Ljava_time_temporal_ValueRange__f_minLargest;
  var bhi$1 = b$1.RTLong__f_hi;
  var lo$1 = ((16 + b$1.RTLong__f_lo) | 0);
  var lo$2 = (((32 & lo$1) === 0) ? (lo << lo$1) : 0);
  var hi$2 = (((32 & lo$1) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - lo$1) | 0)) | 0) | (hi << lo$1)) : (lo << lo$1));
  var b$2 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
  var bhi$2 = b$2.RTLong__f_hi;
  var lo$3 = ((48 + b$2.RTLong__f_lo) | 0);
  var lo$4 = (((32 & lo$3) === 0) ? (((lo$2 >>> lo$3) | 0) | ((hi$2 << 1) << ((31 - lo$3) | 0))) : (hi$2 >> lo$3));
  var hi$4 = (((32 & lo$3) === 0) ? (hi$2 >> lo$3) : (hi$2 >> 31));
  var b$3 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
  var bhi$3 = b$3.RTLong__f_hi;
  var lo$5 = ((32 + b$3.RTLong__f_lo) | 0);
  var lo$6 = (((32 & lo$5) === 0) ? (lo$4 << lo$5) : 0);
  var hi$6 = (((32 & lo$5) === 0) ? (((((lo$4 >>> 1) | 0) >>> ((31 - lo$5) | 0)) | 0) | (hi$4 << lo$5)) : (lo$4 << lo$5));
  var b$4 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
  var bhi$4 = b$4.RTLong__f_hi;
  var lo$7 = ((32 + b$4.RTLong__f_lo) | 0);
  var lo$8 = (((32 & lo$7) === 0) ? (((lo$6 >>> lo$7) | 0) | ((hi$6 << 1) << ((31 - lo$7) | 0))) : (hi$6 >> lo$7));
  var hi$8 = (((32 & lo$7) === 0) ? (hi$6 >> lo$7) : (hi$6 >> 31));
  var b$5 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
  var bhi$5 = b$5.RTLong__f_hi;
  var lo$9 = ((48 + b$5.RTLong__f_lo) | 0);
  var lo$10 = (((32 & lo$9) === 0) ? (lo$8 << lo$9) : 0);
  var hi$10 = (((32 & lo$9) === 0) ? (((((lo$8 >>> 1) | 0) >>> ((31 - lo$9) | 0)) | 0) | (hi$8 << lo$9)) : (lo$8 << lo$9));
  var lo$11 = (((lo$10 >>> 16) | 0) | (hi$10 << 16));
  var hi$11 = (hi$10 >> 16);
  var lo$12 = (lo$11 ^ hi$11);
  return lo$12
});
$c_Ljava_time_temporal_ValueRange.prototype.toString__T = (function() {
  var this$1 = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var b = this.Ljava_time_temporal_ValueRange__f_minLargest;
  if ((!((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi)))) {
    var ss = ("/" + this.Ljava_time_temporal_ValueRange__f_minLargest)
  } else {
    var ss = ""
  };
  var this$2 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
  var b$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
  if ((!((this$2.RTLong__f_lo === b$1.RTLong__f_lo) && (this$2.RTLong__f_hi === b$1.RTLong__f_hi)))) {
    var sl = ("/" + this.Ljava_time_temporal_ValueRange__f_maxLargest)
  } else {
    var sl = ""
  };
  return ((((this.Ljava_time_temporal_ValueRange__f_minSmallest + ss) + " - ") + this.Ljava_time_temporal_ValueRange__f_maxSmallest) + sl)
});
function $as_Ljava_time_temporal_ValueRange(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_ValueRange) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.ValueRange"))
}
function $isArrayOf_Ljava_time_temporal_ValueRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ValueRange)))
}
function $asArrayOf_Ljava_time_temporal_ValueRange(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_ValueRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.ValueRange;", depth))
}
var $d_Ljava_time_temporal_ValueRange = new $TypeData().initClass({
  Ljava_time_temporal_ValueRange: 0
}, false, "java.time.temporal.ValueRange", {
  Ljava_time_temporal_ValueRange: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_ValueRange.prototype.$classData = $d_Ljava_time_temporal_ValueRange;
/** @constructor */
function $c_Ljava_time_temporal_ValueRange$() {
  /*<skip>*/
}
$c_Ljava_time_temporal_ValueRange$.prototype = new $h_O();
$c_Ljava_time_temporal_ValueRange$.prototype.constructor = $c_Ljava_time_temporal_ValueRange$;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ValueRange$.prototype = $c_Ljava_time_temporal_ValueRange$.prototype;
$c_Ljava_time_temporal_ValueRange$.prototype.of__J__J__Ljava_time_temporal_ValueRange = (function(min, max) {
  var ahi = min.RTLong__f_hi;
  var bhi = max.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ min.RTLong__f_lo) > ((-2147483648) ^ max.RTLong__f_lo)) : (ahi > bhi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value")
  } else {
    return new $c_Ljava_time_temporal_ValueRange(min, min, max, max)
  }
});
$c_Ljava_time_temporal_ValueRange$.prototype.of__J__J__J__J__Ljava_time_temporal_ValueRange = (function(minSmallest, minLargest, maxSmallest, maxLargest) {
  var ahi = minSmallest.RTLong__f_hi;
  var bhi = minLargest.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ minSmallest.RTLong__f_lo) > ((-2147483648) ^ minLargest.RTLong__f_lo)) : (ahi > bhi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Smallest minimum value must be less than largest minimum value")
  };
  var ahi$1 = maxSmallest.RTLong__f_hi;
  var bhi$1 = maxLargest.RTLong__f_hi;
  if (((ahi$1 === bhi$1) ? (((-2147483648) ^ maxSmallest.RTLong__f_lo) > ((-2147483648) ^ maxLargest.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Smallest maximum value must be less than largest maximum value")
  };
  var ahi$2 = minLargest.RTLong__f_hi;
  var bhi$2 = maxLargest.RTLong__f_hi;
  if (((ahi$2 === bhi$2) ? (((-2147483648) ^ minLargest.RTLong__f_lo) > ((-2147483648) ^ maxLargest.RTLong__f_lo)) : (ahi$2 > bhi$2))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value")
  };
  return new $c_Ljava_time_temporal_ValueRange(minSmallest, minLargest, maxSmallest, maxLargest)
});
var $d_Ljava_time_temporal_ValueRange$ = new $TypeData().initClass({
  Ljava_time_temporal_ValueRange$: 0
}, false, "java.time.temporal.ValueRange$", {
  Ljava_time_temporal_ValueRange$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_ValueRange$.prototype.$classData = $d_Ljava_time_temporal_ValueRange$;
var $n_Ljava_time_temporal_ValueRange$;
function $m_Ljava_time_temporal_ValueRange$() {
  if ((!$n_Ljava_time_temporal_ValueRange$)) {
    $n_Ljava_time_temporal_ValueRange$ = new $c_Ljava_time_temporal_ValueRange$()
  };
  return $n_Ljava_time_temporal_ValueRange$
}
/** @constructor */
function $c_Ljava_time_temporal_WeekFields(firstDayOfWeek, minimalDays) {
  this.Ljava_time_temporal_WeekFields__f_firstDayOfWeek = null;
  this.Ljava_time_temporal_WeekFields__f_minimalDays = 0;
  this.Ljava_time_temporal_WeekFields__f_dayOfWeek = null;
  this.Ljava_time_temporal_WeekFields__f_weekOfMonth = null;
  this.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear = null;
  this.Ljava_time_temporal_WeekFields__f_weekBasedYear = null;
  this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0 = 0;
  this.Ljava_time_temporal_WeekFields__f_firstDayOfWeek = firstDayOfWeek;
  this.Ljava_time_temporal_WeekFields__f_minimalDays = minimalDays;
  if ((firstDayOfWeek === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "firstDayOfWeek")
  };
  if (((minimalDays < 1) || (minimalDays > 7))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimal number of days is invalid")
  };
  this.Ljava_time_temporal_WeekFields__f_dayOfWeek = new $c_Ljava_time_temporal_WeekFields$ComputedDayOfField("DayOfWeek", this, $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)));
  this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0 = (((1 | this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0) << 24) >> 24);
  this.Ljava_time_temporal_WeekFields__f_weekOfMonth = new $c_Ljava_time_temporal_WeekFields$ComputedDayOfField("WeekOfMonth", this, $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0), new $c_RTLong(4, 0), new $c_RTLong(6, 0)));
  this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0 = (((2 | this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0) << 24) >> 24);
  new $c_Ljava_time_temporal_WeekFields$ComputedDayOfField("WeekOfYear", this, $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0), new $c_RTLong(52, 0), new $c_RTLong(54, 0)));
  this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0 = (((4 | this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0) << 24) >> 24);
  var $$x2 = $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit();
  var $$x1 = $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit();
  var this$6 = $m_Ljava_time_temporal_ValueRange$();
  this.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear = new $c_Ljava_time_temporal_WeekFields$ComputedDayOfField("WeekOfYWeekBasedYear", this, $$x2, $$x1, this$6.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(52, 0), new $c_RTLong(53, 0)));
  this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0 = (((8 | this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0) << 24) >> 24);
  var $$x4 = $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit();
  var $$x3 = $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit();
  var this$8 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  this.Ljava_time_temporal_WeekFields__f_weekBasedYear = new $c_Ljava_time_temporal_WeekFields$ComputedDayOfField("WeekBasedYear", this, $$x4, $$x3, this$8.Ljava_time_temporal_ChronoField__f__range);
  this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0 = (((16 | this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0) << 24) >> 24)
}
$c_Ljava_time_temporal_WeekFields.prototype = new $h_O();
$c_Ljava_time_temporal_WeekFields.prototype.constructor = $c_Ljava_time_temporal_WeekFields;
/** @constructor */
function $h_Ljava_time_temporal_WeekFields() {
  /*<skip>*/
}
$h_Ljava_time_temporal_WeekFields.prototype = $c_Ljava_time_temporal_WeekFields.prototype;
$c_Ljava_time_temporal_WeekFields.prototype.dayOfWeek__Ljava_time_temporal_TemporalField = (function() {
  if (((((1 & this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/temporal/WeekFields.scala: 622")
  };
  return this.Ljava_time_temporal_WeekFields__f_dayOfWeek
});
$c_Ljava_time_temporal_WeekFields.prototype.weekOfMonth__Ljava_time_temporal_TemporalField = (function() {
  if (((((2 & this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/temporal/WeekFields.scala: 666")
  };
  return this.Ljava_time_temporal_WeekFields__f_weekOfMonth
});
$c_Ljava_time_temporal_WeekFields.prototype.weekOfWeekBasedYear__Ljava_time_temporal_TemporalField = (function() {
  if (((((8 & this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/temporal/WeekFields.scala: 757")
  };
  return this.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear
});
$c_Ljava_time_temporal_WeekFields.prototype.weekBasedYear__Ljava_time_temporal_TemporalField = (function() {
  if (((((16 & this.Ljava_time_temporal_WeekFields__f_bitmap$inittrans$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/temporal/WeekFields.scala: 798")
  };
  return this.Ljava_time_temporal_WeekFields__f_weekBasedYear
});
$c_Ljava_time_temporal_WeekFields.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_time_temporal_WeekFields)) {
    var x2 = $as_Ljava_time_temporal_WeekFields(that);
    return ((this === x2) || (this.hashCode__I() === $n(x2).hashCode__I()))
  } else {
    return false
  }
});
$c_Ljava_time_temporal_WeekFields.prototype.hashCode__I = (function() {
  return ((Math.imul(7, $n(this.Ljava_time_temporal_WeekFields__f_firstDayOfWeek).jl_Enum__f__ordinal) + this.Ljava_time_temporal_WeekFields__f_minimalDays) | 0)
});
$c_Ljava_time_temporal_WeekFields.prototype.toString__T = (function() {
  return (((("WeekFields[" + this.Ljava_time_temporal_WeekFields__f_firstDayOfWeek) + ",") + this.Ljava_time_temporal_WeekFields__f_minimalDays) + "]")
});
function $as_Ljava_time_temporal_WeekFields(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_WeekFields) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.WeekFields"))
}
function $isArrayOf_Ljava_time_temporal_WeekFields(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_WeekFields)))
}
function $asArrayOf_Ljava_time_temporal_WeekFields(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_WeekFields(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.WeekFields;", depth))
}
var $d_Ljava_time_temporal_WeekFields = new $TypeData().initClass({
  Ljava_time_temporal_WeekFields: 0
}, false, "java.time.temporal.WeekFields", {
  Ljava_time_temporal_WeekFields: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_WeekFields.prototype.$classData = $d_Ljava_time_temporal_WeekFields;
function $p_Ljava_time_temporal_WeekFields$__CACHE$lzycompute__ju_Map($thiz) {
  if (((((1 & $thiz.Ljava_time_temporal_WeekFields$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_WeekFields$__f_CACHE = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_temporal_WeekFields$__f_bitmap$0 = (((1 | $thiz.Ljava_time_temporal_WeekFields$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_WeekFields$__f_CACHE
}
function $p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map($thiz) {
  return (((((1 & $thiz.Ljava_time_temporal_WeekFields$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_WeekFields$__CACHE$lzycompute__ju_Map($thiz) : $thiz.Ljava_time_temporal_WeekFields$__f_CACHE)
}
function $p_Ljava_time_temporal_WeekFields$__ISO$lzycompute__Ljava_time_temporal_WeekFields($thiz) {
  if (((((2 & $thiz.Ljava_time_temporal_WeekFields$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_temporal_WeekFields$__f_ISO = new $c_Ljava_time_temporal_WeekFields($m_Ljava_time_DayOfWeek$().MONDAY__Ljava_time_DayOfWeek(), 4);
    $thiz.Ljava_time_temporal_WeekFields$__f_bitmap$0 = (((2 | $thiz.Ljava_time_temporal_WeekFields$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_temporal_WeekFields$__f_ISO
}
/** @constructor */
function $c_Ljava_time_temporal_WeekFields$() {
  this.Ljava_time_temporal_WeekFields$__f_CACHE = null;
  this.Ljava_time_temporal_WeekFields$__f_ISO = null;
  this.Ljava_time_temporal_WeekFields$__f_bitmap$0 = 0
}
$c_Ljava_time_temporal_WeekFields$.prototype = new $h_O();
$c_Ljava_time_temporal_WeekFields$.prototype.constructor = $c_Ljava_time_temporal_WeekFields$;
/** @constructor */
function $h_Ljava_time_temporal_WeekFields$() {
  /*<skip>*/
}
$h_Ljava_time_temporal_WeekFields$.prototype = $c_Ljava_time_temporal_WeekFields$.prototype;
$c_Ljava_time_temporal_WeekFields$.prototype.ISO__Ljava_time_temporal_WeekFields = (function() {
  return (((((2 & this.Ljava_time_temporal_WeekFields$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_temporal_WeekFields$__ISO$lzycompute__Ljava_time_temporal_WeekFields(this) : this.Ljava_time_temporal_WeekFields$__f_ISO)
});
$c_Ljava_time_temporal_WeekFields$.prototype.of__ju_Locale__Ljava_time_temporal_WeekFields = (function(locale) {
  if ((locale === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "locale")
  };
  var dow = $m_Ljava_time_DayOfWeek$().SUNDAY__Ljava_time_DayOfWeek();
  return $m_Ljava_time_temporal_WeekFields$().of__Ljava_time_DayOfWeek__I__Ljava_time_temporal_WeekFields(dow, 1)
});
$c_Ljava_time_temporal_WeekFields$.prototype.of__Ljava_time_DayOfWeek__I__Ljava_time_temporal_WeekFields = (function(firstDayOfWeek, minimalDaysInFirstWeek) {
  var key = (("" + $n(firstDayOfWeek).jl_Enum__f__name) + minimalDaysInFirstWeek);
  var rules = $as_Ljava_time_temporal_WeekFields($n($p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map(this)).get__O__O(key));
  if ((rules === null)) {
    rules = new $c_Ljava_time_temporal_WeekFields(firstDayOfWeek, minimalDaysInFirstWeek);
    $n($p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map(this)).put__O__O__O(key, rules);
    rules = $as_Ljava_time_temporal_WeekFields($n($p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map(this)).get__O__O(key))
  };
  return rules
});
var $d_Ljava_time_temporal_WeekFields$ = new $TypeData().initClass({
  Ljava_time_temporal_WeekFields$: 0
}, false, "java.time.temporal.WeekFields$", {
  Ljava_time_temporal_WeekFields$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_WeekFields$.prototype.$classData = $d_Ljava_time_temporal_WeekFields$;
var $n_Ljava_time_temporal_WeekFields$;
function $m_Ljava_time_temporal_WeekFields$() {
  if ((!$n_Ljava_time_temporal_WeekFields$)) {
    $n_Ljava_time_temporal_WeekFields$ = new $c_Ljava_time_temporal_WeekFields$()
  };
  return $n_Ljava_time_temporal_WeekFields$
}
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I($thiz, temporal, sow) {
  var isoDow = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  return ((1 + $m_jl_Math$().floorMod__I__I__I(a, 7)) | 0)
}
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfMonth__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal, dow) {
  var dom = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
  var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, dom, dow);
  var value = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, dom);
  var hi = (value >> 31);
  return new $c_RTLong(value, hi)
}
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal, dow) {
  var doy = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
  var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, doy, dow);
  var value = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, doy);
  var hi = (value >> 31);
  return new $c_RTLong(value, hi)
}
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWOWBY__Ljava_time_temporal_TemporalAccessor__I($thiz, temporal) {
  var this$1 = $n($thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
  var sow = $n(this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek).getValue__I();
  var isoDow = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var dow = ((1 + $m_jl_Math$().floorMod__I__I__I(a, 7)) | 0);
  var t = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal, dow);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (((lo === 0) && (hi === 0))) {
    var this$3 = $n(($n($m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal)), $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)));
    var unit = $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit();
    var previous = this$3.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(1, 0), unit);
    var this$4 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, previous, dow);
    return ((1 + this$4.RTLong__f_lo) | 0)
  } else if (((hi === 0) ? (((-2147483648) ^ lo) >= (-2147483595)) : (hi > 0))) {
    var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField()), dow);
    var year = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
    var $$x1 = $m_Ljava_time_Year$();
    var hi$1 = (year >> 31);
    if ($n($$x1).isLeap__J__Z(new $c_RTLong(year, hi$1))) {
      var yearLen = 366
    } else {
      var yearLen = 365
    };
    var this$6 = $n($thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
    var weekIndexOfFirstWeekNextYear = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, ((yearLen + this$6.Ljava_time_temporal_WeekFields__f_minimalDays) | 0));
    var hi$2 = (weekIndexOfFirstWeekNextYear >> 31);
    if (((hi === hi$2) ? (((-2147483648) ^ lo) >= ((-2147483648) ^ weekIndexOfFirstWeekNextYear)) : (hi > hi$2))) {
      var value = (((-1) + weekIndexOfFirstWeekNextYear) | 0);
      var hi$3 = (value >> 31);
      var lo$1 = ((lo - value) | 0);
      return lo$1
    }
  };
  return lo
}
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWBY__Ljava_time_temporal_TemporalAccessor__I($thiz, temporal) {
  var this$1 = $n($thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
  var sow = $n(this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek).getValue__I();
  var isoDow = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var dow = ((1 + $m_jl_Math$().floorMod__I__I__I(a, 7)) | 0);
  var year = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  var t = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal, dow);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (((lo === 0) && (hi === 0))) {
    return (((-1) + year) | 0)
  } else if (((hi === 0) ? (((-2147483648) ^ lo) < (-2147483595)) : (hi < 0))) {
    return year
  };
  var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField()), dow);
  var $$x1 = $m_Ljava_time_Year$();
  var hi$1 = (year >> 31);
  if ($n($$x1).isLeap__J__Z(new $c_RTLong(year, hi$1))) {
    var yearLen = 366
  } else {
    var yearLen = 365
  };
  var this$3 = $n($thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
  var weekIndexOfFirstWeekNextYear = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, ((yearLen + this$3.Ljava_time_temporal_WeekFields__f_minimalDays) | 0));
  var hi$2 = (weekIndexOfFirstWeekNextYear >> 31);
  if (((hi === hi$2) ? (((-2147483648) ^ lo) >= ((-2147483648) ^ weekIndexOfFirstWeekNextYear)) : (hi > hi$2))) {
    return ((1 + year) | 0)
  };
  return year
}
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, day, dow) {
  var a = ((day - dow) | 0);
  var weekStart = $m_jl_Math$().floorMod__I__I__I(a, 7);
  var offset = ((-weekStart) | 0);
  var this$1 = $n($thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
  if ((((1 + weekStart) | 0) > this$1.Ljava_time_temporal_WeekFields__f_minimalDays)) {
    offset = ((7 - weekStart) | 0)
  };
  return offset
}
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, day) {
  return ((((((7 + offset) | 0) + (((-1) + day) | 0)) | 0) / 7) | 0)
}
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__rangeWOWBY__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange($thiz, temporal) {
  var this$1 = $n($thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
  var sow = $n(this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek).getValue__I();
  var isoDow = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var dow = ((1 + $m_jl_Math$().floorMod__I__I__I(a, 7)) | 0);
  var t = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal, dow);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (((lo === 0) && (hi === 0))) {
    var this$3 = $n(($n($m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal)), $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)));
    var unit = $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit();
    return $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__rangeWOWBY__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange($thiz, this$3.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(2, 0), unit))
  };
  var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField()), dow);
  var year = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  var $$x1 = $m_Ljava_time_Year$();
  var hi$1 = (year >> 31);
  if ($n($$x1).isLeap__J__Z(new $c_RTLong(year, hi$1))) {
    var yearLen = 366
  } else {
    var yearLen = 365
  };
  var this$5 = $n($thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
  var weekIndexOfFirstWeekNextYear = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, ((yearLen + this$5.Ljava_time_temporal_WeekFields__f_minimalDays) | 0));
  var hi$2 = (weekIndexOfFirstWeekNextYear >> 31);
  if (((hi === hi$2) ? (((-2147483648) ^ lo) >= ((-2147483648) ^ weekIndexOfFirstWeekNextYear)) : (hi > hi$2))) {
    var this$8 = $n(($n($m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal)), $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)));
    var unit$1 = $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit();
    return $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__rangeWOWBY__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange($thiz, this$8.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(2, 0), unit$1))
  };
  var $$x2 = $m_Ljava_time_temporal_ValueRange$();
  var hi$3 = (weekIndexOfFirstWeekNextYear >> 31);
  var lo$1 = (((-1) + weekIndexOfFirstWeekNextYear) | 0);
  var hi$4 = ((lo$1 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
  return $n($$x2).of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(lo$1, hi$4))
}
/** @constructor */
function $c_Ljava_time_temporal_WeekFields$ComputedDayOfField(name, weekDef, baseUnit, rangeUnit, range) {
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_name = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_baseUnit = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_name = name;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef = weekDef;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_baseUnit = baseUnit;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit = rangeUnit;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range = range
}
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype = new $h_O();
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.constructor = $c_Ljava_time_temporal_WeekFields$ComputedDayOfField;
/** @constructor */
function $h_Ljava_time_temporal_WeekFields$ComputedDayOfField() {
  /*<skip>*/
}
$h_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype = $c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype;
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.range__Ljava_time_temporal_ValueRange = (function() {
  return this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.getFrom__Ljava_time_temporal_TemporalAccessor__J = (function(temporal) {
  var this$1 = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
  var sow = $n(this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek).getValue__I();
  var isoDow = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var dow = ((1 + $m_jl_Math$().floorMod__I__I__I(a, 7)) | 0);
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit())) {
    var hi = (dow >> 31);
    return new $c_RTLong(dow, hi)
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit())) {
    var dom = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
    var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I(this, dom, dow);
    var value = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I(this, offset, dom);
    var hi$1 = (value >> 31);
    return new $c_RTLong(value, hi$1)
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit())) {
    var doy = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
    var offset$2 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I(this, doy, dow);
    var value$1 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I(this, offset$2, doy);
    var hi$2 = (value$1 >> 31);
    return new $c_RTLong(value$1, hi$2)
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit())) {
    var value$2 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWOWBY__Ljava_time_temporal_TemporalAccessor__I(this, temporal);
    var hi$3 = (value$2 >> 31);
    return new $c_RTLong(value$2, hi$3)
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit())) {
    var value$3 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWBY__Ljava_time_temporal_TemporalAccessor__I(this, temporal);
    var hi$4 = (value$3 >> 31);
    return new $c_RTLong(value$3, hi$4)
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "unreachable")
  }
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(temporal, newValue) {
  var newVal = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, this);
  var currentVal = $n(temporal).get__Ljava_time_temporal_TemporalField__I(this);
  if ((newVal === currentVal)) {
    return temporal
  };
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit())) {
    var baseWowby = $n(temporal).get__Ljava_time_temporal_TemporalField__I($n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField());
    var this$3 = $m_RTLong$();
    var hi = (currentVal >> 31);
    var alo = newValue.RTLong__f_lo;
    var ahi = newValue.RTLong__f_hi;
    var lo = ((alo - currentVal) | 0);
    var hi$1 = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi) | 0)) | 0) : ((ahi - hi) | 0));
    var value = (52.1775 * $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi$1));
    var lo$1 = this$3.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var result = $n(temporal).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(lo$1, hi$2), $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit());
    if (($n(result).get__Ljava_time_temporal_TemporalField__I(this) > newVal)) {
      var newWowby = $n(result).get__Ljava_time_temporal_TemporalField__I($n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField());
      var $$x1 = $n(result);
      var hi$3 = (newWowby >> 31);
      result = $n($$x1).minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(newWowby, hi$3), $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit())
    } else {
      if (($n(result).get__Ljava_time_temporal_TemporalField__I(this) < newVal)) {
        result = $n(result).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(2, 0), $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit())
      };
      var newWowby$2 = $n(result).get__Ljava_time_temporal_TemporalField__I($n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField());
      var $$x2 = $n(result);
      var hi$4 = (baseWowby >> 31);
      var hi$5 = (newWowby$2 >> 31);
      var lo$2 = ((baseWowby - newWowby$2) | 0);
      var hi$6 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ baseWowby)) ? (((-1) + ((hi$4 - hi$5) | 0)) | 0) : ((hi$4 - hi$5) | 0));
      result = $n($$x2).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(lo$2, hi$6), $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit());
      if (($n(result).get__Ljava_time_temporal_TemporalField__I(this) > newVal)) {
        result = $n(result).minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(1, 0), $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit())
      }
    };
    return result
  };
  var delta = ((newVal - currentVal) | 0);
  var $$x3 = $n(temporal);
  var hi$7 = (delta >> 31);
  return $n($$x3).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(delta, hi$7), this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_baseUnit)
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.resolve__ju_Map__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_ResolverStyle__Ljava_time_temporal_TemporalAccessor = (function(fieldValues, partialTemporal, resolverStyle) {
  var this$1 = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
  var sow = $n(this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek).getValue__I();
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit())) {
    var x = $as_jl_Long($n(fieldValues).remove__O__O(this));
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var localDow = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo, hi), this);
    var a = (((((-1) + sow) | 0) + (((-1) + localDow) | 0)) | 0);
    var isoDow = ((1 + $m_jl_Math$().floorMod__I__I__I(a, 7)) | 0);
    var $$x2 = $n(fieldValues);
    var $$x1 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    var hi$1 = (isoDow >> 31);
    $n($$x2).put__O__O__O($$x1, new $c_RTLong(isoDow, hi$1));
    return null
  };
  if ((!$n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()))) {
    return null
  };
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit())) {
    if ((!$n(fieldValues).containsKey__O__Z($n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField()))) {
      return null
    };
    var chrono = $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(partialTemporal);
    var this$6 = $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    var x$1 = $as_jl_Long($n(fieldValues).get__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
    var t$1 = $uJ(x$1);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$2 = t$1.RTLong__f_hi;
    var isoDow$2 = $n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$1, hi$2), this$6);
    var a$1 = ((isoDow$2 - sow) | 0);
    var dow = ((1 + $m_jl_Math$().floorMod__I__I__I(a$1, 7)) | 0);
    var $$x3 = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range);
    var x$2 = $as_jl_Long($n(fieldValues).get__O__O(this));
    var wby = $n($$x3).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($uJ(x$2), this);
    var date = null;
    var days__lo = 0;
    var days__hi = 0;
    if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      $n(chrono);
      var this$8 = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
      var dayOfMonth = this$8.Ljava_time_temporal_WeekFields__f_minimalDays;
      date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(wby, 1, dayOfMonth);
      var x$3 = $as_jl_Long($n(fieldValues).get__O__O($n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField()));
      var t$2 = $uJ(x$3);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$3 = t$2.RTLong__f_hi;
      var dateDow = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date, sow);
      var b = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J(this, date, dateDow);
      var bhi = b.RTLong__f_hi;
      var lo$3 = ((lo$2 - b.RTLong__f_lo) | 0);
      var hi$4 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ lo$2)) ? (((-1) + ((hi$3 - bhi) | 0)) | 0) : ((hi$3 - bhi) | 0));
      var b0 = (65535 & lo$3);
      var b1 = ((lo$3 >>> 16) | 0);
      var a0b0 = Math.imul(7, b0);
      var a0b1 = Math.imul(7, b1);
      var lo$4 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$5 = ((Math.imul(7, hi$4) + ((c1part >>> 16) | 0)) | 0);
      var value = ((dow - dateDow) | 0);
      var hi$6 = (value >> 31);
      var lo$5 = ((lo$4 + value) | 0);
      var hi$7 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$5 + hi$6) | 0)) | 0) : ((hi$5 + hi$6) | 0));
      var $$x4__lo = lo$5;
      var $$x4__hi = hi$7;
      days__lo = $$x4__lo;
      days__hi = $$x4__hi
    } else {
      $n(chrono);
      var this$14 = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
      var dayOfMonth$1 = this$14.Ljava_time_temporal_WeekFields__f_minimalDays;
      date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(wby, 1, dayOfMonth$1);
      var $$x5 = $n($n($n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField()).range__Ljava_time_temporal_ValueRange());
      var x$4 = $as_jl_Long($n(fieldValues).get__O__O($n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField()));
      var value$1 = $n($$x5).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($uJ(x$4), $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField());
      var hi$8 = (value$1 >> 31);
      var dateDow$2 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date, sow);
      var b$1 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J(this, date, dateDow$2);
      var bhi$1 = b$1.RTLong__f_hi;
      var lo$6 = ((value$1 - b$1.RTLong__f_lo) | 0);
      var hi$9 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ value$1)) ? (((-1) + ((hi$8 - bhi$1) | 0)) | 0) : ((hi$8 - bhi$1) | 0));
      var b0$1 = (65535 & lo$6);
      var b1$1 = ((lo$6 >>> 16) | 0);
      var a0b0$1 = Math.imul(7, b0$1);
      var a0b1$1 = Math.imul(7, b1$1);
      var lo$7 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$10 = ((Math.imul(7, hi$9) + ((c1part$1 >>> 16) | 0)) | 0);
      var value$2 = ((dow - dateDow$2) | 0);
      var hi$11 = (value$2 >> 31);
      var lo$8 = ((lo$7 + value$2) | 0);
      var hi$12 = ((((-2147483648) ^ lo$8) < ((-2147483648) ^ lo$7)) ? ((1 + ((hi$10 + hi$11) | 0)) | 0) : ((hi$10 + hi$11) | 0));
      var $$x6__lo = lo$8;
      var $$x6__hi = hi$12;
      days__lo = $$x6__lo;
      days__hi = $$x6__hi
    };
    var this$21 = $n(date);
    var amountToAdd__lo = days__lo;
    var amountToAdd__hi = days__hi;
    var unit = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
    date = this$21.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(amountToAdd__lo, amountToAdd__hi), unit);
    if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle())) {
      var t$3 = $n(date).getLong__Ljava_time_temporal_TemporalField__J(this);
      var lo$9 = t$3.RTLong__f_lo;
      var hi$13 = t$3.RTLong__f_hi;
      var y = $n(fieldValues).get__O__O(this);
      if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(new $c_RTLong(lo$9, hi$13), y))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different year")
      }
    };
    $n(fieldValues).remove__O__O(this);
    $n(fieldValues).remove__O__O($n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField());
    $n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    return date
  };
  if ((!$n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()))) {
    return null
  };
  var this$23 = $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var x$5 = $as_jl_Long($n(fieldValues).get__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
  var t$4 = $uJ(x$5);
  var lo$10 = t$4.RTLong__f_lo;
  var hi$14 = t$4.RTLong__f_hi;
  var isoDow$3 = $n(this$23.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$10, hi$14), this$23);
  var a$2 = ((isoDow$3 - sow) | 0);
  var dow$2 = ((1 + $m_jl_Math$().floorMod__I__I__I(a$2, 7)) | 0);
  var this$25 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  var x$6 = $as_jl_Long($n(fieldValues).get__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()));
  var t$5 = $uJ(x$6);
  var lo$11 = t$5.RTLong__f_lo;
  var hi$15 = t$5.RTLong__f_hi;
  var year = $n(this$25.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$11, hi$15), this$25);
  var chrono$2 = $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(partialTemporal);
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit())) {
    if ((!$n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()))) {
      return null
    };
    var x$7 = $as_jl_Long($n(fieldValues).remove__O__O(this));
    var t$6 = $uJ(x$7);
    var lo$12 = t$6.RTLong__f_lo;
    var hi$16 = t$6.RTLong__f_hi;
    var date$2 = null;
    var days$2__lo = 0;
    var days$2__hi = 0;
    if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      var x$8 = $as_jl_Long($n(fieldValues).get__O__O($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
      var t$7 = $uJ(x$8);
      var lo$13 = t$7.RTLong__f_lo;
      var hi$17 = t$7.RTLong__f_hi;
      $n(chrono$2);
      date$2 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, 1, 1);
      var this$30 = $n(date$2);
      var lo$14 = (((-1) + lo$13) | 0);
      var hi$18 = ((lo$14 !== (-1)) ? hi$17 : (((-1) + hi$17) | 0));
      var unit$1 = $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit();
      date$2 = this$30.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(lo$14, hi$18), unit$1);
      var dateDow$3 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date$2, sow);
      var b$2 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfMonth__Ljava_time_temporal_TemporalAccessor__I__J(this, date$2, dateDow$3);
      var bhi$2 = b$2.RTLong__f_hi;
      var lo$15 = ((lo$12 - b$2.RTLong__f_lo) | 0);
      var hi$19 = ((((-2147483648) ^ lo$15) > ((-2147483648) ^ lo$12)) ? (((-1) + ((hi$16 - bhi$2) | 0)) | 0) : ((hi$16 - bhi$2) | 0));
      var b0$2 = (65535 & lo$15);
      var b1$2 = ((lo$15 >>> 16) | 0);
      var a0b0$2 = Math.imul(7, b0$2);
      var a0b1$2 = Math.imul(7, b1$2);
      var lo$16 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$20 = ((Math.imul(7, hi$19) + ((c1part$2 >>> 16) | 0)) | 0);
      var value$3 = ((dow$2 - dateDow$3) | 0);
      var hi$21 = (value$3 >> 31);
      var lo$17 = ((lo$16 + value$3) | 0);
      var hi$22 = ((((-2147483648) ^ lo$17) < ((-2147483648) ^ lo$16)) ? ((1 + ((hi$20 + hi$21) | 0)) | 0) : ((hi$20 + hi$21) | 0));
      var $$x7__lo = lo$17;
      var $$x7__hi = hi$22;
      days$2__lo = $$x7__lo;
      days$2__hi = $$x7__hi
    } else {
      var this$35 = $n($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
      var x$9 = $as_jl_Long($n(fieldValues).get__O__O($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
      var t$8 = $uJ(x$9);
      var lo$18 = t$8.RTLong__f_lo;
      var hi$23 = t$8.RTLong__f_hi;
      var month$2 = $n(this$35.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$18, hi$23), this$35);
      $n(chrono$2);
      date$2 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, month$2, 8);
      var dateDow$4 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date$2, sow);
      var wom = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$12, hi$16), this);
      var hi$24 = (wom >> 31);
      var b$3 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfMonth__Ljava_time_temporal_TemporalAccessor__I__J(this, date$2, dateDow$4);
      var bhi$3 = b$3.RTLong__f_hi;
      var lo$19 = ((wom - b$3.RTLong__f_lo) | 0);
      var hi$25 = ((((-2147483648) ^ lo$19) > ((-2147483648) ^ wom)) ? (((-1) + ((hi$24 - bhi$3) | 0)) | 0) : ((hi$24 - bhi$3) | 0));
      var b0$3 = (65535 & lo$19);
      var b1$3 = ((lo$19 >>> 16) | 0);
      var a0b0$3 = Math.imul(7, b0$3);
      var a0b1$3 = Math.imul(7, b1$3);
      var lo$20 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$26 = ((Math.imul(7, hi$25) + ((c1part$3 >>> 16) | 0)) | 0);
      var value$4 = ((dow$2 - dateDow$4) | 0);
      var hi$27 = (value$4 >> 31);
      var lo$21 = ((lo$20 + value$4) | 0);
      var hi$28 = ((((-2147483648) ^ lo$21) < ((-2147483648) ^ lo$20)) ? ((1 + ((hi$26 + hi$27) | 0)) | 0) : ((hi$26 + hi$27) | 0));
      var $$x8__lo = lo$21;
      var $$x8__hi = hi$28;
      days$2__lo = $$x8__lo;
      days$2__hi = $$x8__hi
    };
    var this$41 = $n(date$2);
    var amountToAdd$1__lo = days$2__lo;
    var amountToAdd$1__hi = days$2__hi;
    var unit$2 = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
    date$2 = this$41.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(amountToAdd$1__lo, amountToAdd$1__hi), unit$2);
    if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle())) {
      var t$9 = $n(date$2).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
      var lo$22 = t$9.RTLong__f_lo;
      var hi$29 = t$9.RTLong__f_hi;
      var y$1 = $n(fieldValues).get__O__O($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
      if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(new $c_RTLong(lo$22, hi$29), y$1))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month")
      }
    };
    $n(fieldValues).remove__O__O(this);
    $n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
    $n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
    $n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    return date$2
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit())) {
    var x$10 = $as_jl_Long($n(fieldValues).remove__O__O(this));
    var t$10 = $uJ(x$10);
    var lo$23 = t$10.RTLong__f_lo;
    var hi$30 = t$10.RTLong__f_hi;
    $n(chrono$2);
    var date$3 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, 1, 1);
    var days$3__lo = 0;
    var days$3__hi = 0;
    if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      var dateDow$5 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date$3, sow);
      var b$4 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J(this, date$3, dateDow$5);
      var bhi$4 = b$4.RTLong__f_hi;
      var lo$24 = ((lo$23 - b$4.RTLong__f_lo) | 0);
      var hi$31 = ((((-2147483648) ^ lo$24) > ((-2147483648) ^ lo$23)) ? (((-1) + ((hi$30 - bhi$4) | 0)) | 0) : ((hi$30 - bhi$4) | 0));
      var b0$4 = (65535 & lo$24);
      var b1$4 = ((lo$24 >>> 16) | 0);
      var a0b0$4 = Math.imul(7, b0$4);
      var a0b1$4 = Math.imul(7, b1$4);
      var lo$25 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$32 = ((Math.imul(7, hi$31) + ((c1part$4 >>> 16) | 0)) | 0);
      var value$5 = ((dow$2 - dateDow$5) | 0);
      var hi$33 = (value$5 >> 31);
      var lo$26 = ((lo$25 + value$5) | 0);
      var hi$34 = ((((-2147483648) ^ lo$26) < ((-2147483648) ^ lo$25)) ? ((1 + ((hi$32 + hi$33) | 0)) | 0) : ((hi$32 + hi$33) | 0));
      var $$x9__lo = lo$26;
      var $$x9__hi = hi$34;
      days$3__lo = $$x9__lo;
      days$3__hi = $$x9__hi
    } else {
      var dateDow$6 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date$3, sow);
      var woy = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$23, hi$30), this);
      var hi$35 = (woy >> 31);
      var b$5 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J(this, date$3, dateDow$6);
      var bhi$5 = b$5.RTLong__f_hi;
      var lo$27 = ((woy - b$5.RTLong__f_lo) | 0);
      var hi$36 = ((((-2147483648) ^ lo$27) > ((-2147483648) ^ woy)) ? (((-1) + ((hi$35 - bhi$5) | 0)) | 0) : ((hi$35 - bhi$5) | 0));
      var b0$5 = (65535 & lo$27);
      var b1$5 = ((lo$27 >>> 16) | 0);
      var a0b0$5 = Math.imul(7, b0$5);
      var a0b1$5 = Math.imul(7, b1$5);
      var lo$28 = ((a0b0$5 + (a0b1$5 << 16)) | 0);
      var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
      var hi$37 = ((Math.imul(7, hi$36) + ((c1part$5 >>> 16) | 0)) | 0);
      var value$6 = ((dow$2 - dateDow$6) | 0);
      var hi$38 = (value$6 >> 31);
      var lo$29 = ((lo$28 + value$6) | 0);
      var hi$39 = ((((-2147483648) ^ lo$29) < ((-2147483648) ^ lo$28)) ? ((1 + ((hi$37 + hi$38) | 0)) | 0) : ((hi$37 + hi$38) | 0));
      var $$x10__lo = lo$29;
      var $$x10__hi = hi$39;
      days$3__lo = $$x10__lo;
      days$3__hi = $$x10__hi
    };
    var this$51 = $n(date$3);
    var amountToAdd$2__lo = days$3__lo;
    var amountToAdd$2__hi = days$3__hi;
    var unit$3 = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
    date$3 = this$51.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(amountToAdd$2__lo, amountToAdd$2__hi), unit$3);
    if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle())) {
      var t$11 = $n(date$3).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
      var lo$30 = t$11.RTLong__f_lo;
      var hi$40 = t$11.RTLong__f_hi;
      var y$2 = $n(fieldValues).get__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
      if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(new $c_RTLong(lo$30, hi$40), y$2))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different year")
      }
    };
    $n(fieldValues).remove__O__O(this);
    $n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
    $n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    return date$3
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "unreachable")
  }
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.isDateBased__Z = (function() {
  return true
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.isTimeBased__Z = (function() {
  return false
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z = (function(temporal) {
  return ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()) && ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit()) || ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit()) ? $n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField()) : ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit()) ? $n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField()) : ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit()) ? $n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField()) : ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit()) && $n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField())))))))
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange = (function(temporal) {
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit())) {
    return this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range
  };
  var field = null;
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit())) {
    field = $m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField()
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit())) {
    field = $m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField()
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit())) {
    return $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__rangeWOWBY__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this, temporal)
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit())) {
    return $n(temporal).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField())
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "unreachable")
  };
  var this$1 = $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef);
  var sow = $n(this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek).getValue__I();
  var isoDow = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var dow = ((1 + $m_jl_Math$().floorMod__I__I__I(a, 7)) | 0);
  var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I(this, $n(temporal).get__Ljava_time_temporal_TemporalField__I(field), dow);
  var fieldRange = $n(temporal).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field);
  var $$x2 = $m_Ljava_time_temporal_ValueRange$();
  var this$2 = $n(fieldRange);
  var this$3 = this$2.Ljava_time_temporal_ValueRange__f_minSmallest;
  var value = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I(this, offset, this$3.RTLong__f_lo);
  var hi = (value >> 31);
  var $$x1 = new $c_RTLong(value, hi);
  var this$5 = $n(fieldRange);
  var this$6 = this$5.Ljava_time_temporal_ValueRange__f_maxLargest;
  var value$1 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I(this, offset, this$6.RTLong__f_lo);
  var hi$1 = (value$1 >> 31);
  return $n($$x2).of__J__J__Ljava_time_temporal_ValueRange($$x1, new $c_RTLong(value$1, hi$1))
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.toString__T = (function() {
  return (((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_name + "[") + $n(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef).toString__T()) + "]")
});
var $d_Ljava_time_temporal_WeekFields$ComputedDayOfField = new $TypeData().initClass({
  Ljava_time_temporal_WeekFields$ComputedDayOfField: 0
}, false, "java.time.temporal.WeekFields$ComputedDayOfField", {
  Ljava_time_temporal_WeekFields$ComputedDayOfField: 1,
  O: 1,
  Ljava_time_temporal_TemporalField: 1
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.$classData = $d_Ljava_time_temporal_WeekFields$ComputedDayOfField;
/** @constructor */
function $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider() {
  /*<skip>*/
}
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype = new $h_Ljava_time_zone_ZoneRulesProvider();
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.constructor = $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider;
/** @constructor */
function $h_Ljava_time_zone_DefaultTzdbZoneRulesProvider() {
  /*<skip>*/
}
$h_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype = $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype;
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.provideZoneIds__ju_Set = (function() {
  var zones = $ct_ju_HashSet__(new $c_ju_HashSet());
  zones.add__O__Z("UTC");
  zones.add__O__Z("GMT");
  return zones
});
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.provideRules__T__Z__Ljava_time_zone_ZoneRules = (function(regionId, forCaching) {
  return $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_ZoneRules($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset(), $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset(), $ct_ju_ArrayList__(new $c_ju_ArrayList()), $ct_ju_ArrayList__(new $c_ju_ArrayList()), $ct_ju_ArrayList__(new $c_ju_ArrayList()))
});
var $d_Ljava_time_zone_DefaultTzdbZoneRulesProvider = new $TypeData().initClass({
  Ljava_time_zone_DefaultTzdbZoneRulesProvider: 0
}, false, "java.time.zone.DefaultTzdbZoneRulesProvider", {
  Ljava_time_zone_DefaultTzdbZoneRulesProvider: 1,
  Ljava_time_zone_ZoneRulesProvider: 1,
  O: 1
});
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.$classData = $d_Ljava_time_zone_DefaultTzdbZoneRulesProvider;
/** @constructor */
function $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer() {
  /*<skip>*/
}
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype = new $h_Ljava_time_zone_ZoneRulesInitializer();
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype.constructor = $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer;
/** @constructor */
function $h_Ljava_time_zone_ServiceLoaderZoneRulesInitializer() {
  /*<skip>*/
}
$h_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype = $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype;
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype.initializeProviders__V = (function() {
  var $$x2 = $m_s_Predef$();
  var $$x1 = $m_sc_ArrayOps$();
  var this$1 = $objectClassName(this);
  var xs = $f_T__split__T__I__AT(this$1, "\\.", 0);
  var this$3 = $n($n($$x2).wrapRefArray__AO__scm_ArraySeq$ofRef($asArrayOf_O($n($$x1).init$extension__O__O(xs), 1)));
  var packageName = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ".", "");
  var optClassData = $m_sjs_reflect_Reflect$().lookupInstantiatableClass__T__s_Option((packageName + ".TzdbZoneRulesProvider"));
  var this$4 = $n(optClassData);
  if (this$4.isEmpty__Z()) {
    $m_sci_List$();
    var array = [new $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider()];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var $$x3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  } else {
    var arg1 = this$4.get__O();
    var c = $as_sjs_reflect_InstantiatableClass(arg1);
    var instance = $as_Ljava_time_zone_ZoneRulesProvider($n(c).newInstance__O());
    $m_sci_List$();
    var array$1 = [instance];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var $$x3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)
  };
  var this$13 = $n($$x3);
  var these = this$13;
  while ((!$n(these).isEmpty__Z())) {
    var arg1$1 = $n(these).head__O();
    var provider = $as_Ljava_time_zone_ZoneRulesProvider(arg1$1);
    $m_Ljava_time_zone_ZoneRulesProvider$().registerProvider__Ljava_time_zone_ZoneRulesProvider__V(provider);
    these = $as_sci_List($n(these).tail__O())
  }
});
var $d_Ljava_time_zone_ServiceLoaderZoneRulesInitializer = new $TypeData().initClass({
  Ljava_time_zone_ServiceLoaderZoneRulesInitializer: 0
}, false, "java.time.zone.ServiceLoaderZoneRulesInitializer", {
  Ljava_time_zone_ServiceLoaderZoneRulesInitializer: 1,
  Ljava_time_zone_ZoneRulesInitializer: 1,
  O: 1
});
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype.$classData = $d_Ljava_time_zone_ServiceLoaderZoneRulesInitializer;
/** @constructor */
function $c_Ljava_time_zone_StandardZoneRules$() {
  this.Ljava_time_zone_StandardZoneRules$__f_java$time$zone$StandardZoneRules$$LAST_CACHED_YEAR = 0;
  this.Ljava_time_zone_StandardZoneRules$__f_bitmap$init$0 = false;
  this.Ljava_time_zone_StandardZoneRules$__f_java$time$zone$StandardZoneRules$$LAST_CACHED_YEAR = 2100;
  this.Ljava_time_zone_StandardZoneRules$__f_bitmap$init$0 = true
}
$c_Ljava_time_zone_StandardZoneRules$.prototype = new $h_O();
$c_Ljava_time_zone_StandardZoneRules$.prototype.constructor = $c_Ljava_time_zone_StandardZoneRules$;
/** @constructor */
function $h_Ljava_time_zone_StandardZoneRules$() {
  /*<skip>*/
}
$h_Ljava_time_zone_StandardZoneRules$.prototype = $c_Ljava_time_zone_StandardZoneRules$.prototype;
$c_Ljava_time_zone_StandardZoneRules$.prototype.java$time$zone$StandardZoneRules$$LAST_CACHED_YEAR__I = (function() {
  if ((!this.Ljava_time_zone_StandardZoneRules$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/zone/StandardZoneRules.scala: 50")
  };
  return this.Ljava_time_zone_StandardZoneRules$__f_java$time$zone$StandardZoneRules$$LAST_CACHED_YEAR
});
$c_Ljava_time_zone_StandardZoneRules$.prototype.apply__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_StandardZoneRules = (function(baseStandardOffset, baseWallOffset, standardOffsetTransitionList, transitionList, lastRules) {
  var standardTransitions = new $ac_J($n(standardOffsetTransitionList).size__I());
  var standardOffsets = new ($d_Ljava_time_ZoneOffset.getArrayOf().constr)(((1 + $n(standardOffsetTransitionList).size__I()) | 0));
  $n(standardOffsets).set(0, baseStandardOffset);
  var i = 0;
  while ((i < $n(standardOffsetTransitionList).size__I())) {
    var $$x2 = $n(standardTransitions);
    var $$x1 = i;
    var this$1 = $n($as_Ljava_time_zone_ZoneOffsetTransition($n(standardOffsetTransitionList).get__I__O(i)));
    $$x2.set($$x1, $n(this$1.Ljava_time_zone_ZoneOffsetTransition__f_transition).toEpochSecond__Ljava_time_ZoneOffset__J(this$1.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore));
    var $$x4 = $n(standardOffsets);
    var $$x3 = i;
    var this$2 = $n($as_Ljava_time_zone_ZoneOffsetTransition($n(standardOffsetTransitionList).get__I__O(i)));
    $$x4.set(((1 + $$x3) | 0), this$2.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter);
    i = ((1 + i) | 0)
  };
  var localTransitionList = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  var localTransitionOffsetList = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  localTransitionOffsetList.add__O__Z(baseWallOffset);
  var transitions = $n(transitionList).iterator__ju_Iterator();
  while ($n(transitions).hasNext__Z()) {
    var trans = $as_Ljava_time_zone_ZoneOffsetTransition($n(transitions).next__O());
    if ($n(trans).isGap__Z()) {
      var this$3 = $n(trans);
      localTransitionList.add__O__Z(this$3.Ljava_time_zone_ZoneOffsetTransition__f_transition);
      var this$4 = $n(trans);
      var this$6 = $n(this$4.Ljava_time_zone_ZoneOffsetTransition__f_transition);
      var value = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(this$4);
      var hi = (value >> 31);
      localTransitionList.add__O__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$6, this$6.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value, hi), $L0, 1))
    } else {
      var this$7 = $n(trans);
      var this$9 = $n(this$7.Ljava_time_zone_ZoneOffsetTransition__f_transition);
      var value$1 = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(this$7);
      var hi$1 = (value$1 >> 31);
      localTransitionList.add__O__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$9, this$9.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value$1, hi$1), $L0, 1));
      var this$10 = $n(trans);
      localTransitionList.add__O__Z(this$10.Ljava_time_zone_ZoneOffsetTransition__f_transition)
    };
    var this$11 = $n(trans);
    localTransitionOffsetList.add__O__Z(this$11.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter)
  };
  var savingsLocalTransitions = $asArrayOf_Ljava_time_LocalDateTime(localTransitionList.toArray__AO__AO(new ($d_Ljava_time_LocalDateTime.getArrayOf().constr)(localTransitionList.size__I())), 1);
  var wallOffsets = $asArrayOf_Ljava_time_ZoneOffset(localTransitionOffsetList.toArray__AO__AO(new ($d_Ljava_time_ZoneOffset.getArrayOf().constr)(localTransitionOffsetList.size__I())), 1);
  var savingsInstantTransitions = new $ac_J($n(transitionList).size__I());
  var i$2 = 0;
  while ((i$2 < $n(transitionList).size__I())) {
    var $$x6 = $n(savingsInstantTransitions);
    var $$x5 = i$2;
    var this$12 = $n($as_Ljava_time_zone_ZoneOffsetTransition($n(transitionList).get__I__O(i$2)));
    var this$13 = $n($n(this$12.Ljava_time_zone_ZoneOffsetTransition__f_transition).toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(this$12.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore));
    $$x6.set($$x5, this$13.Ljava_time_Instant__f_seconds);
    i$2 = ((1 + i$2) | 0)
  };
  if (($n(lastRules).size__I() > 15)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Too many transition rules")
  };
  var resultLastRules = $asArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule($n(lastRules).toArray__AO__AO(new ($d_Ljava_time_zone_ZoneOffsetTransitionRule.getArrayOf().constr)($n(lastRules).size__I())), 1);
  return new $c_Ljava_time_zone_StandardZoneRules(standardTransitions, standardOffsets, savingsInstantTransitions, wallOffsets, resultLastRules, savingsLocalTransitions)
});
var $d_Ljava_time_zone_StandardZoneRules$ = new $TypeData().initClass({
  Ljava_time_zone_StandardZoneRules$: 0
}, false, "java.time.zone.StandardZoneRules$", {
  Ljava_time_zone_StandardZoneRules$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_StandardZoneRules$.prototype.$classData = $d_Ljava_time_zone_StandardZoneRules$;
var $n_Ljava_time_zone_StandardZoneRules$;
function $m_Ljava_time_zone_StandardZoneRules$() {
  if ((!$n_Ljava_time_zone_StandardZoneRules$)) {
    $n_Ljava_time_zone_StandardZoneRules$ = new $c_Ljava_time_zone_StandardZoneRules$()
  };
  return $n_Ljava_time_zone_StandardZoneRules$
}
function $p_Ljava_time_zone_TzdbZoneRulesProvider__stdZonesMap__sci_Map($thiz) {
  if (((((1 & $thiz.Ljava_time_zone_TzdbZoneRulesProvider__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/java/time/zone/TzdbZoneRulesProvider.scala: 18")
  };
  return $thiz.Ljava_time_zone_TzdbZoneRulesProvider__f_stdZonesMap
}
function $p_Ljava_time_zone_TzdbZoneRulesProvider__fixedZonesMap__sci_Map($thiz) {
  if (((((2 & $thiz.Ljava_time_zone_TzdbZoneRulesProvider__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/tzdb/js/target/scala-2.13/src_managed/main/java/time/zone/TzdbZoneRulesProvider.scala: 20")
  };
  return $thiz.Ljava_time_zone_TzdbZoneRulesProvider__f_fixedZonesMap
}
function $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransition__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransition($thiz, zr) {
  var jointDate = $uI(zr[0]);
  $m_sc_StringOps$();
  var this$2 = ("" + jointDate);
  if ((this$2.length < 4)) {
    $charAt(this$2, 4)
  };
  var x = $as_T(this$2.substring(0, 4));
  var this$5 = $m_jl_Integer$();
  var year = this$5.parseInt__T__I__I(x, 10);
  $m_sc_StringOps$();
  var this$7 = ("" + jointDate);
  if ((this$7.length < 7)) {
    $charAt(this$7, 7)
  };
  var x$1 = $as_T(this$7.substring(4, 7));
  var this$10 = $m_jl_Integer$();
  var dayOfYear = this$10.parseInt__T__I__I(x$1, 10);
  var date = $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(year, dayOfYear);
  var lt = $uI(zr[1]);
  var hi = (lt >> 31);
  var time = $m_Ljava_time_LocalTime$().ofSecondOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lt, hi));
  var transition = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(date, time);
  var totalSeconds = $uI(zr[2]);
  var offsetBefore = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds);
  var totalSeconds$1 = $uI(zr[3]);
  var offsetAfter = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds$1);
  return $m_Ljava_time_zone_ZoneOffsetTransition$().of__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneOffsetTransition(transition, offsetBefore, offsetAfter)
}
function $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransitionRule__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransitionRule($thiz, zor) {
  var lt = $uI(zor[3]);
  var hi = (lt >> 31);
  var time = $m_Ljava_time_LocalTime$().ofSecondOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lt, hi));
  if (($uI(zor[2]) >= 0)) {
    var dayOfWeek = $uI(zor[2]);
    var dayOfWeek$1 = $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(dayOfWeek)
  } else {
    var dayOfWeek$1 = null
  };
  var month = $uI(zor[0]);
  var month$1 = $m_Ljava_time_Month$().of__I__Ljava_time_Month(month);
  var dayOfMonthIndicator = $uI(zor[1]);
  var timeEndOfDay = ($uI(zor[4]) === 1);
  var timeDefnition = $n($m_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$().values__ALjava_time_zone_ZoneOffsetTransitionRule$TimeDefinition()).get($uI(zor[5]));
  var totalSeconds = $uI(zor[6]);
  var standardOffset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds);
  var totalSeconds$1 = $uI(zor[7]);
  var offsetBefore = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds$1);
  var totalSeconds$2 = $uI(zor[8]);
  var offsetAfter = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds$2);
  return $m_Ljava_time_zone_ZoneOffsetTransitionRule$().of__Ljava_time_Month__I__Ljava_time_DayOfWeek__Ljava_time_LocalTime__Z__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneOffsetTransitionRule(month$1, dayOfMonthIndicator, dayOfWeek$1, time, timeEndOfDay, timeDefnition, standardOffset, offsetBefore, offsetAfter)
}
function $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneRules__sjs_js_Dynamic__Ljava_time_zone_ZoneRules($thiz, zr) {
  var totalSeconds = $uI(zr.s);
  var bso = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds);
  var totalSeconds$1 = $uI(zr.w);
  var bwo = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSeconds$1);
  var array = zr.t;
  var len = $uI(array.length);
  var res = new Array(len);
  var i = 0;
  while ((i < len)) {
    var $$x1 = i;
    var arg1 = array[i];
    res[$$x1] = $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransition__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransition($thiz, arg1);
    i = ((1 + i) | 0)
  };
  var array$1 = zr.l;
  var len$1 = $uI(array$1.length);
  var res$1 = new Array(len$1);
  var i$1 = 0;
  while ((i$1 < len$1)) {
    var $$x2 = i$1;
    var arg1$1 = array$1[i$1];
    res$1[$$x2] = $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransition__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransition($thiz, arg1$1);
    i$1 = ((1 + i$1) | 0)
  };
  var array$2 = zr.r;
  var len$2 = $uI(array$2.length);
  var res$2 = new Array(len$2);
  var i$2 = 0;
  while ((i$2 < len$2)) {
    var $$x3 = i$2;
    var arg1$2 = array$2[i$2];
    res$2[$$x3] = $p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneOffsetTransitionRule__sjs_js_Array__Ljava_time_zone_ZoneOffsetTransitionRule($thiz, arg1$2);
    i$2 = ((1 + i$2) | 0)
  };
  var standardTransitionsJ = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  var this$8 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res);
  $m_sci_List$();
  var this$10 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$8));
  var these = this$10;
  while ((!$n(these).isEmpty__Z())) {
    var arg1$3 = $n(these).head__O();
    var x$2 = $as_Ljava_time_zone_ZoneOffsetTransition(arg1$3);
    standardTransitionsJ.add__O__Z(x$2);
    these = $as_sci_List($n(these).tail__O())
  };
  var transitionListJ = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  var this$12 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res$1);
  $m_sci_List$();
  var this$14 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$12));
  var these$1 = this$14;
  while ((!$n(these$1).isEmpty__Z())) {
    var arg1$4 = $n(these$1).head__O();
    var x$3 = $as_Ljava_time_zone_ZoneOffsetTransition(arg1$4);
    transitionListJ.add__O__Z(x$3);
    these$1 = $as_sci_List($n(these$1).tail__O())
  };
  var lastRulesJ = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  var this$16 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res$2);
  $m_sci_List$();
  var this$18 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$16));
  var these$2 = this$18;
  while ((!$n(these$2).isEmpty__Z())) {
    var arg1$5 = $n(these$2).head__O();
    var x$4 = $as_Ljava_time_zone_ZoneOffsetTransitionRule(arg1$5);
    lastRulesJ.add__O__Z(x$4);
    these$2 = $as_sci_List($n(these$2).tail__O())
  };
  return $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_ZoneRules(bso, bwo, standardTransitionsJ, transitionListJ, lastRulesJ)
}
function $sct_Ljava_time_zone_TzdbZoneRulesProvider__stinit__() {
  $m_sjs_reflect_Reflect$().registerInstantiatableClass__T__jl_Class__sjs_js_Array__V("java.time.zone.TzdbZoneRulesProvider", $d_Ljava_time_zone_TzdbZoneRulesProvider.getClassOf(), [[[], (() => new $c_Ljava_time_zone_TzdbZoneRulesProvider())]])
}
/** @constructor */
function $c_Ljava_time_zone_TzdbZoneRulesProvider() {
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_stdZonesMap = null;
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_fixedZonesMap = null;
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_bitmap$init$0 = 0;
  var dict = $m_Lzonedb_java_tzdb$().stdZones__sjs_js_Dynamic();
  var this$3 = new $c_sjs_js_WrappedDictionary(dict);
  var this$2 = $m_s_$less$colon$less$();
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_stdZonesMap = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3);
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_bitmap$init$0 = (((1 | this.Ljava_time_zone_TzdbZoneRulesProvider__f_bitmap$init$0) << 24) >> 24);
  var dict$1 = $m_Lzonedb_java_tzdb$().fixedZones__sjs_js_Dynamic();
  var this$6 = new $c_sjs_js_WrappedDictionary(dict$1);
  var this$5 = $m_s_$less$colon$less$();
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_fixedZonesMap = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$6);
  this.Ljava_time_zone_TzdbZoneRulesProvider__f_bitmap$init$0 = (((2 | this.Ljava_time_zone_TzdbZoneRulesProvider__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype = new $h_Ljava_time_zone_ZoneRulesProvider();
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype.constructor = $c_Ljava_time_zone_TzdbZoneRulesProvider;
/** @constructor */
function $h_Ljava_time_zone_TzdbZoneRulesProvider() {
  /*<skip>*/
}
$h_Ljava_time_zone_TzdbZoneRulesProvider.prototype = $c_Ljava_time_zone_TzdbZoneRulesProvider.prototype;
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype.provideZoneIds__ju_Set = (function() {
  var zones = $ct_ju_HashSet__(new $c_ju_HashSet());
  var this$1 = $n($n($p_Ljava_time_zone_TzdbZoneRulesProvider__stdZonesMap__sci_Map(this)).keySet__sci_Set());
  var that = $n($p_Ljava_time_zone_TzdbZoneRulesProvider__fixedZonesMap__sci_Map(this)).keySet__sci_Set();
  var this$2 = $n(this$1.concat__sc_IterableOnce__sc_SetOps(that));
  var that$1 = $n($m_Lzonedb_java_tzdb$().zoneLinks__sci_Map()).keySet__sci_Set();
  var zonesSet = $as_sci_Set(this$2.concat__sc_IterableOnce__sc_SetOps(that$1));
  $n(zonesSet).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T(x$1$2);
    return zones.add__O__Z(x$1)
  })));
  zones.remove__O__Z("GMT0");
  zones.remove__O__Z("GMT+0");
  zones.remove__O__Z("GMT-0");
  return zones
});
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype.provideRules__T__Z__Ljava_time_zone_ZoneRules = (function(regionId, forCaching) {
  var actualRegion = $as_T($n($m_Lzonedb_java_tzdb$().zoneLinks__sci_Map()).getOrElse__O__F0__O(regionId, new $c_sjsr_AnonFunction0((() => regionId))));
  var this$2 = $n($n($p_Ljava_time_zone_TzdbZoneRulesProvider__stdZonesMap__sci_Map(this)).get__O__s_Option(actualRegion));
  if (this$2.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var $$x1 = new $c_s_Some($p_Ljava_time_zone_TzdbZoneRulesProvider__toZoneRules__sjs_js_Dynamic__Ljava_time_zone_ZoneRules(this, arg1))
  };
  var this$3 = $n($$x1);
  if (this$3.isEmpty__Z()) {
    var this$4 = $n($n($p_Ljava_time_zone_TzdbZoneRulesProvider__fixedZonesMap__sci_Map(this)).get__O__s_Option(actualRegion));
    if (this$4.isEmpty__Z()) {
      var $$x2 = $m_s_None$()
    } else {
      var arg1$1 = this$4.get__O();
      var i = $uI(arg1$1);
      var offset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(i);
      var $$x2 = new $c_s_Some($m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset))
    }
  } else {
    var $$x2 = this$3
  };
  var this$5 = $n($$x2);
  if (this$5.isEmpty__Z()) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("TimeZone Region " + actualRegion) + " unknown"))
  };
  return $as_Ljava_time_zone_ZoneRules(this$5.get__O())
});
var $d_Ljava_time_zone_TzdbZoneRulesProvider = new $TypeData().initClass({
  Ljava_time_zone_TzdbZoneRulesProvider: 0
}, false, "java.time.zone.TzdbZoneRulesProvider", {
  Ljava_time_zone_TzdbZoneRulesProvider: 1,
  Ljava_time_zone_ZoneRulesProvider: 1,
  O: 1
});
$c_Ljava_time_zone_TzdbZoneRulesProvider.prototype.$classData = $d_Ljava_time_zone_TzdbZoneRulesProvider;
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransition$() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneOffsetTransition$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransition$.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransition$;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransition$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransition$.prototype = $c_Ljava_time_zone_ZoneOffsetTransition$.prototype;
$c_Ljava_time_zone_ZoneOffsetTransition$.prototype.of__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneOffsetTransition = (function(transition, offsetBefore, offsetAfter) {
  if ((transition === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "transition")
  };
  if ((offsetBefore === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetBefore")
  };
  if ((offsetAfter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetAfter")
  };
  if (((offsetBefore === null) ? (offsetAfter === null) : $n(offsetBefore).equals__O__Z(offsetAfter))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Offsets must not be equal")
  };
  var this$4 = $n(transition);
  var this$5 = $n(this$4.Ljava_time_LocalDateTime__f_time);
  if ((this$5.Ljava_time_LocalTime__f_nano !== 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Nano-of-second must be zero")
  };
  return new $c_Ljava_time_zone_ZoneOffsetTransition(transition, offsetBefore, offsetAfter)
});
var $d_Ljava_time_zone_ZoneOffsetTransition$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransition$: 0
}, false, "java.time.zone.ZoneOffsetTransition$", {
  Ljava_time_zone_ZoneOffsetTransition$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneOffsetTransition$.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransition$;
var $n_Ljava_time_zone_ZoneOffsetTransition$;
function $m_Ljava_time_zone_ZoneOffsetTransition$() {
  if ((!$n_Ljava_time_zone_ZoneOffsetTransition$)) {
    $n_Ljava_time_zone_ZoneOffsetTransition$ = new $c_Ljava_time_zone_ZoneOffsetTransition$()
  };
  return $n_Ljava_time_zone_ZoneOffsetTransition$
}
function $p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B($thiz) {
  if ((!$thiz.Ljava_time_zone_ZoneOffsetTransitionRule__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/zone/ZoneOffsetTransitionRule.scala: 251")
  };
  return $thiz.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom
}
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule(month, dayOfMonthIndicator, dayOfWeek, time, timeEndOfDay, timeDefinition, standardOffset, offsetBefore, offsetAfter) {
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay = false;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom = 0;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_bitmap$init$0 = false;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month = month;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek = dayOfWeek;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time = time;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay = timeEndOfDay;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition = timeDefinition;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset = standardOffset;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore = offsetBefore;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter = offsetAfter;
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dom = ((dayOfMonthIndicator << 24) >> 24);
  this.Ljava_time_zone_ZoneOffsetTransitionRule__f_bitmap$init$0 = true
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.createTransition__I__Ljava_time_zone_ZoneOffsetTransition = (function(year) {
  var date = null;
  if (($p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this) < 0)) {
    var $$x4 = $m_Ljava_time_LocalDate$();
    var $$x3 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month;
    var $$x2 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month;
    var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var hi = (year >> 31);
    date = $n($$x4).of__I__Ljava_time_Month__I__Ljava_time_LocalDate(year, $$x3, ((((1 + $n($$x2).length__Z__I($n($$x1).isLeapYear__J__Z(new $c_RTLong(year, hi)))) | 0) + $p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this)) | 0));
    if ((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek !== null)) {
      var $$x5 = $n(date);
      var dayOfWeek = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek;
      date = $n($$x5).with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(1, dayOfWeek))
    }
  } else {
    date = $m_Ljava_time_LocalDate$().of__I__Ljava_time_Month__I__Ljava_time_LocalDate(year, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month, $p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this));
    if ((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek !== null)) {
      var $$x6 = $n(date);
      var dayOfWeek$1 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek;
      date = $n($$x6).with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, dayOfWeek$1))
    }
  };
  if (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay) {
    date = $n(date).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0))
  };
  var localDT = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(date, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time);
  var transition = $n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition).createDateTime__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(localDT, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore);
  return new $c_Ljava_time_zone_ZoneOffsetTransition(transition, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore, this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.equals__O__Z = (function(otherRule) {
  if ((otherRule instanceof $c_Ljava_time_zone_ZoneOffsetTransitionRule)) {
    var x2 = $as_Ljava_time_zone_ZoneOffsetTransitionRule(otherRule);
    if ((this === x2)) {
      return true
    } else {
      if (((((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month === $n(x2).Ljava_time_zone_ZoneOffsetTransitionRule__f_month) && ($p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this) === $p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B($n(x2)))) && (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek === $n(x2).Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek)) && (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition === $n(x2).Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition))) {
        var x = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time;
        var x$2 = $n(x2).Ljava_time_zone_ZoneOffsetTransitionRule__f_time;
        var $$x3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        var $$x3 = false
      };
      if (($$x3 && (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay === $n(x2).Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay))) {
        var x$3 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset;
        var x$4 = $n(x2).Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset;
        var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$5 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore;
        var x$6 = $n(x2).Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$7 = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter;
        var x$8 = $n(x2).Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.hashCode__I = (function() {
  var hash = ((((((((((($n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time).toSecondOfDay__I() + (this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay ? 1 : 0)) | 0) << 15) + ($n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month).jl_Enum__f__ordinal << 11)) | 0) + (((32 + $p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this)) | 0) << 5)) | 0) + (((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek === null) ? 7 : $n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek).jl_Enum__f__ordinal) << 2)) | 0) + $n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition).jl_Enum__f__ordinal) | 0);
  var this$1 = $n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset);
  var $$x2 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore);
  var $$x1 = this$2.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$3 = $n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter);
  return (((hash ^ $$x2) ^ $$x1) ^ this$3.Ljava_time_ZoneOffset__f_totalSeconds)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.toString__T = (function() {
  var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var $$x1 = buf.append__T__scm_StringBuilder("TransitionRule[");
  var this$1 = $n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore);
  var other = this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter;
  $n($n($n($n($n($$x1).append__T__scm_StringBuilder(((this$1.compare__Ljava_time_ZoneOffset__I(other) > 0) ? "Gap " : "Overlap "))).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetBefore)).append__T__scm_StringBuilder(" to ")).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_offsetAfter)).append__T__scm_StringBuilder(", ");
  if ((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek !== null)) {
    if (($p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this) === (-1))) {
      $n($n(buf.append__T__scm_StringBuilder($n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek).jl_Enum__f__name)).append__T__scm_StringBuilder(" on or before last day of ")).append__T__scm_StringBuilder($n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month).jl_Enum__f__name)
    } else if (($p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this) < 0)) {
      $n($n($n($n(buf.append__T__scm_StringBuilder($n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek).jl_Enum__f__name)).append__T__scm_StringBuilder(" on or before last day minus ")).append__I__scm_StringBuilder((((-1) - $p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this)) | 0))).append__T__scm_StringBuilder(" of ")).append__T__scm_StringBuilder($n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month).jl_Enum__f__name)
    } else {
      var this$2 = $n($n($n($n(buf.append__T__scm_StringBuilder($n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_dayOfWeek).jl_Enum__f__name)).append__T__scm_StringBuilder(" on or after ")).append__T__scm_StringBuilder($n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month).jl_Enum__f__name)).append__C__scm_StringBuilder(32));
      var x = $p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this);
      this$2.append__I__scm_StringBuilder(x)
    }
  } else {
    var this$3 = $n($n(buf.append__T__scm_StringBuilder($n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_month).jl_Enum__f__name)).append__C__scm_StringBuilder(32));
    var x$1 = $p_Ljava_time_zone_ZoneOffsetTransitionRule__dom__B(this);
    this$3.append__I__scm_StringBuilder(x$1)
  };
  $n($n($n($n($n($n(buf.append__T__scm_StringBuilder(" at ")).append__T__scm_StringBuilder((this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeEndOfDay ? "24:00" : $n(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_time).toString__T()))).append__T__scm_StringBuilder(" ")).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_timeDefinition)).append__T__scm_StringBuilder(", standard offset ")).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransitionRule__f_standardOffset)).append__C__scm_StringBuilder(93);
  return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
function $as_Ljava_time_zone_ZoneOffsetTransitionRule(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneOffsetTransitionRule) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneOffsetTransitionRule"))
}
function $isArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneOffsetTransitionRule)))
}
function $asArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneOffsetTransitionRule(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneOffsetTransitionRule;", depth))
}
var $d_Ljava_time_zone_ZoneOffsetTransitionRule = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule", {
  Ljava_time_zone_ZoneOffsetTransitionRule: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule;
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule$() {
  /*<skip>*/
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule$;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype.of__Ljava_time_Month__I__Ljava_time_DayOfWeek__Ljava_time_LocalTime__Z__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneOffsetTransitionRule = (function(month, dayOfMonthIndicator, dayOfWeek, time, timeEndOfDay, timeDefnition, standardOffset, offsetBefore, offsetAfter) {
  if ((month === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "month")
  };
  if ((time === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "time")
  };
  if ((timeDefnition === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "timeDefnition")
  };
  if ((standardOffset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "standardOffset")
  };
  if ((offsetBefore === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetBefore")
  };
  if ((offsetAfter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetAfter")
  };
  if ((((dayOfMonthIndicator < (-28)) || (dayOfMonthIndicator > 31)) || (dayOfMonthIndicator === 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Day of month indicator must be between -28 and 31 inclusive excluding zero")
  };
  if (timeEndOfDay) {
    var x$2 = $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime();
    var $$x1 = (!((time === null) ? (x$2 === null) : $n(time).equals__O__Z(x$2)))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Time must be midnight when end of day flag is true")
  };
  return new $c_Ljava_time_zone_ZoneOffsetTransitionRule(month, dayOfMonthIndicator, dayOfWeek, time, timeEndOfDay, timeDefnition, standardOffset, offsetBefore, offsetAfter)
});
var $d_Ljava_time_zone_ZoneOffsetTransitionRule$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule$: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule$", {
  Ljava_time_zone_ZoneOffsetTransitionRule$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule$;
var $n_Ljava_time_zone_ZoneOffsetTransitionRule$;
function $m_Ljava_time_zone_ZoneOffsetTransitionRule$() {
  if ((!$n_Ljava_time_zone_ZoneOffsetTransitionRule$)) {
    $n_Ljava_time_zone_ZoneOffsetTransitionRule$ = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$()
  };
  return $n_Ljava_time_zone_ZoneOffsetTransitionRule$
}
function $p_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__UTC$lzycompute__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition($thiz) {
  if (((((1 & $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_UTC = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition("UTC", 0);
    $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0 = (((1 | $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_UTC
}
function $p_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__WALL$lzycompute__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition($thiz) {
  if (((((2 & $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_WALL = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition("WALL", 1);
    $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0 = (((2 | $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_WALL
}
function $p_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__STANDARD$lzycompute__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition($thiz) {
  if (((((4 & $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_STANDARD = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition("STANDARD", 2);
    $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0 = (((4 | $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_STANDARD
}
function $p_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__values$lzycompute__ALjava_time_zone_ZoneOffsetTransitionRule$TimeDefinition($thiz) {
  if (((((8 & $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_values = new ($d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.getArrayOf().constr)([$thiz.UTC__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(), $thiz.WALL__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(), $thiz.STANDARD__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition()]);
    $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0 = (((8 | $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_values
}
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$() {
  this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_UTC = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_WALL = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_STANDARD = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_values = null;
  this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0 = 0
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.UTC__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition = (function() {
  return (((((1 & this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__UTC$lzycompute__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(this) : this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_UTC)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.WALL__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition = (function() {
  return (((((2 & this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__WALL$lzycompute__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(this) : this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_WALL)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.STANDARD__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition = (function() {
  return (((((4 & this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__STANDARD$lzycompute__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(this) : this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_STANDARD)
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.values__ALjava_time_zone_ZoneOffsetTransitionRule$TimeDefinition = (function() {
  return (((((8 & this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__values$lzycompute__ALjava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(this) : this.Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$__f_values)
});
var $d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$ = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule$TimeDefinition$", {
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$;
var $n_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$;
function $m_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$() {
  if ((!$n_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$)) {
    $n_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$ = new $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$()
  };
  return $n_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$
}
function $p_ju_AbstractMap__findAndRemove$1__ju_Iterator__O__O($thiz, iter, key$3) {
  while (true) {
    if ($n(iter).hasNext__Z()) {
      var item = $as_ju_Map$Entry($n(iter).next__O());
      var b = $n(item).getKey__O();
      if (((key$3 === null) ? (b === null) : $dp_equals__O__Z($n(key$3), b))) {
        $n(iter).remove__V();
        return $n(item).getValue__O()
      }
    } else {
      return null
    }
  }
}
/** @constructor */
function $c_ju_AbstractMap() {
  /*<skip>*/
}
$c_ju_AbstractMap.prototype = new $h_O();
$c_ju_AbstractMap.prototype.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
  /*<skip>*/
}
$h_ju_AbstractMap.prototype = $c_ju_AbstractMap.prototype;
$c_ju_AbstractMap.prototype.computeIfAbsent__O__ju_function_Function__O = (function(key, mappingFunction) {
  return $f_ju_Map__computeIfAbsent__O__ju_function_Function__O(this, key, mappingFunction)
});
$c_ju_AbstractMap.prototype.compute__O__ju_function_BiFunction__O = (function(key, remappingFunction) {
  return $f_ju_Map__compute__O__ju_function_BiFunction__O(this, key, remappingFunction)
});
$c_ju_AbstractMap.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0)
});
$c_ju_AbstractMap.prototype.put__O__O__O = (function(key, value) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_AbstractMap.prototype.remove__O__O = (function(key) {
  return $p_ju_AbstractMap__findAndRemove$1__ju_Iterator__O__O(this, $n(this.entrySet__ju_Set()).iterator__ju_Iterator(), key)
});
$c_ju_AbstractMap.prototype.putAll__ju_Map__V = (function(m) {
  var _\uff3fself = $n(m).entrySet__ju_Set();
  var _\uff3fself$1 = $n(_\uff3fself).iterator__ju_Iterator();
  while ($n(_\uff3fself$1).hasNext__Z()) {
    var e$2 = $n(_\uff3fself$1).next__O();
    var e = $as_ju_Map$Entry(e$2);
    this.put__O__O__O($n(e).getKey__O(), $n(e).getValue__O())
  }
});
$c_ju_AbstractMap.prototype.keySet__ju_Set = (function() {
  return new $c_ju_AbstractMap$$anon$1(this)
});
$c_ju_AbstractMap.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true
  } else if ($is_ju_Map(o)) {
    var x2 = $as_ju_Map(o);
    if ((this.size__I() === $n(x2).size__I())) {
      var _\uff3fself = this.entrySet__ju_Set();
      var _\uff3fself$1 = $n(_\uff3fself).iterator__ju_Iterator();
      _return: {
        while ($n(_\uff3fself$1).hasNext__Z()) {
          var x$2 = $n(_\uff3fself$1).next__O();
          var item = $as_ju_Map$Entry(x$2);
          var a = $n(x2).get__O__O($n(item).getKey__O());
          var b = $n(item).getValue__O();
          if ((!((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b)))) {
            var $$x1 = true;
            break _return
          }
        };
        var $$x1 = false
      };
      return (!$$x1)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_AbstractMap.prototype.hashCode__I = (function() {
  var _\uff3fself = this.entrySet__ju_Set();
  var _\uff3fself$1 = $n(_\uff3fself).iterator__ju_Iterator();
  var result = 0;
  while ($n(_\uff3fself$1).hasNext__Z()) {
    var prev$2 = result;
    var item$2 = $n(_\uff3fself$1).next__O();
    var prev = $uI(prev$2);
    var item = $as_ju_Map$Entry(item$2);
    result = (($n(item).hashCode__I() + prev) | 0)
  };
  return $uI(result)
});
$c_ju_AbstractMap.prototype.toString__T = (function() {
  var result = "{";
  var first = true;
  var iter = $n(this.entrySet__ju_Set()).iterator__ju_Iterator();
  while ($n(iter).hasNext__Z()) {
    var entry = $as_ju_Map$Entry($n(iter).next__O());
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (((("" + result) + $n(entry).getKey__O()) + "=") + $n(entry).getValue__O())
  };
  return (result + "}")
});
/** @constructor */
function $c_ju_AbstractMap$$anon$1$$anon$2(outer) {
  this.ju_AbstractMap$$anon$1$$anon$2__f_iter = null;
  this.ju_AbstractMap$$anon$1$$anon$2__f_iter = $n($n($n(outer).ju_AbstractMap$$anon$1__f_$outer).entrySet__ju_Set()).iterator__ju_Iterator()
}
$c_ju_AbstractMap$$anon$1$$anon$2.prototype = new $h_O();
$c_ju_AbstractMap$$anon$1$$anon$2.prototype.constructor = $c_ju_AbstractMap$$anon$1$$anon$2;
/** @constructor */
function $h_ju_AbstractMap$$anon$1$$anon$2() {
  /*<skip>*/
}
$h_ju_AbstractMap$$anon$1$$anon$2.prototype = $c_ju_AbstractMap$$anon$1$$anon$2.prototype;
$c_ju_AbstractMap$$anon$1$$anon$2.prototype.hasNext__Z = (function() {
  return $n(this.ju_AbstractMap$$anon$1$$anon$2__f_iter).hasNext__Z()
});
$c_ju_AbstractMap$$anon$1$$anon$2.prototype.next__O = (function() {
  return $n($as_ju_Map$Entry($n(this.ju_AbstractMap$$anon$1$$anon$2__f_iter).next__O())).getKey__O()
});
$c_ju_AbstractMap$$anon$1$$anon$2.prototype.remove__V = (function() {
  $n(this.ju_AbstractMap$$anon$1$$anon$2__f_iter).remove__V()
});
var $d_ju_AbstractMap$$anon$1$$anon$2 = new $TypeData().initClass({
  ju_AbstractMap$$anon$1$$anon$2: 0
}, false, "java.util.AbstractMap$$anon$1$$anon$2", {
  ju_AbstractMap$$anon$1$$anon$2: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_AbstractMap$$anon$1$$anon$2.prototype.$classData = $d_ju_AbstractMap$$anon$1$$anon$2;
/** @constructor */
function $c_ju_Arrays$NaturalComparator$() {
  /*<skip>*/
}
$c_ju_Arrays$NaturalComparator$.prototype = new $h_O();
$c_ju_Arrays$NaturalComparator$.prototype.constructor = $c_ju_Arrays$NaturalComparator$;
/** @constructor */
function $h_ju_Arrays$NaturalComparator$() {
  /*<skip>*/
}
$h_ju_Arrays$NaturalComparator$.prototype = $c_ju_Arrays$NaturalComparator$.prototype;
$c_ju_Arrays$NaturalComparator$.prototype.compare__O__O__I = (function(o1, o2) {
  return $dp_compareTo__O__I($n($as_jl_Comparable(o1)), o2)
});
var $d_ju_Arrays$NaturalComparator$ = new $TypeData().initClass({
  ju_Arrays$NaturalComparator$: 0
}, false, "java.util.Arrays$NaturalComparator$", {
  ju_Arrays$NaturalComparator$: 1,
  O: 1,
  ju_Comparator: 1
});
$c_ju_Arrays$NaturalComparator$.prototype.$classData = $d_ju_Arrays$NaturalComparator$;
var $n_ju_Arrays$NaturalComparator$;
function $m_ju_Arrays$NaturalComparator$() {
  if ((!$n_ju_Arrays$NaturalComparator$)) {
    $n_ju_Arrays$NaturalComparator$ = new $c_ju_Arrays$NaturalComparator$()
  };
  return $n_ju_Arrays$NaturalComparator$
}
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Collection)))
}
function $as_ju_Collection(obj) {
  return (($is_ju_Collection(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Collection"))
}
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Collection)))
}
function $asArrayOf_ju_Collection(obj, depth) {
  return (($isArrayOf_ju_Collection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Collection;", depth))
}
/** @constructor */
function $c_ju_Date$() {
  this.ju_Date$__f_java$util$Date$$Days = null;
  this.ju_Date$__f_java$util$Date$$Months = null;
  $n_ju_Date$ = this;
  this.ju_Date$__f_java$util$Date$$Days = new ($d_T.getArrayOf().constr)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]);
  this.ju_Date$__f_java$util$Date$$Months = new ($d_T.getArrayOf().constr)(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"])
}
$c_ju_Date$.prototype = new $h_O();
$c_ju_Date$.prototype.constructor = $c_ju_Date$;
/** @constructor */
function $h_ju_Date$() {
  /*<skip>*/
}
$h_ju_Date$.prototype = $c_ju_Date$.prototype;
$c_ju_Date$.prototype.java$util$Date$$pad0__I__T = (function(i) {
  var str = ("" + i);
  return ((str.length < 2) ? ("0" + str) : str)
});
var $d_ju_Date$ = new $TypeData().initClass({
  ju_Date$: 0
}, false, "java.util.Date$", {
  ju_Date$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Date$.prototype.$classData = $d_ju_Date$;
var $n_ju_Date$;
function $m_ju_Date$() {
  if ((!$n_ju_Date$)) {
    $n_ju_Date$ = new $c_ju_Date$()
  };
  return $n_ju_Date$
}
/** @constructor */
function $c_ju_Formatter$RootLocaleInfo$() {
  /*<skip>*/
}
$c_ju_Formatter$RootLocaleInfo$.prototype = new $h_ju_Formatter$LocaleInfo();
$c_ju_Formatter$RootLocaleInfo$.prototype.constructor = $c_ju_Formatter$RootLocaleInfo$;
/** @constructor */
function $h_ju_Formatter$RootLocaleInfo$() {
  /*<skip>*/
}
$h_ju_Formatter$RootLocaleInfo$.prototype = $c_ju_Formatter$RootLocaleInfo$.prototype;
var $d_ju_Formatter$RootLocaleInfo$ = new $TypeData().initClass({
  ju_Formatter$RootLocaleInfo$: 0
}, false, "java.util.Formatter$RootLocaleInfo$", {
  ju_Formatter$RootLocaleInfo$: 1,
  ju_Formatter$LocaleInfo: 1,
  O: 1
});
$c_ju_Formatter$RootLocaleInfo$.prototype.$classData = $d_ju_Formatter$RootLocaleInfo$;
var $n_ju_Formatter$RootLocaleInfo$;
function $m_ju_Formatter$RootLocaleInfo$() {
  if ((!$n_ju_Formatter$RootLocaleInfo$)) {
    $n_ju_Formatter$RootLocaleInfo$ = new $c_ju_Formatter$RootLocaleInfo$()
  };
  return $n_ju_Formatter$RootLocaleInfo$
}
function $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.ju_HashMap$AbstractHashMapIterator__f_$outer = outer
  };
  $thiz.ju_HashMap$AbstractHashMapIterator__f_len = $n($n(outer).ju_HashMap__f_java$util$HashMap$$table).u.length;
  return $thiz
}
/** @constructor */
function $c_ju_HashMap$AbstractHashMapIterator() {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null
}
$c_ju_HashMap$AbstractHashMapIterator.prototype = new $h_O();
$c_ju_HashMap$AbstractHashMapIterator.prototype.constructor = $c_ju_HashMap$AbstractHashMapIterator;
/** @constructor */
function $h_ju_HashMap$AbstractHashMapIterator() {
  /*<skip>*/
}
$h_ju_HashMap$AbstractHashMapIterator.prototype = $c_ju_HashMap$AbstractHashMapIterator.prototype;
$c_ju_HashMap$AbstractHashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.ju_HashMap$AbstractHashMapIterator__f_nextNode !== null)) {
    return true
  } else {
    while ((this.ju_HashMap$AbstractHashMapIterator__f_nextIdx < this.ju_HashMap$AbstractHashMapIterator__f_len)) {
      var node = $n($n(this.ju_HashMap$AbstractHashMapIterator__f_$outer).ju_HashMap__f_java$util$HashMap$$table).get(this.ju_HashMap$AbstractHashMapIterator__f_nextIdx);
      this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = ((1 + this.ju_HashMap$AbstractHashMapIterator__f_nextIdx) | 0);
      if ((node !== null)) {
        this.ju_HashMap$AbstractHashMapIterator__f_nextNode = node;
        return true
      }
    };
    return false
  }
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
  };
  var node = this.ju_HashMap$AbstractHashMapIterator__f_nextNode;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = node;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = $n(node).ju_HashMap$Node__f_next;
  return this.extract__ju_HashMap$Node__O(node)
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.remove__V = (function() {
  var last = this.ju_HashMap$AbstractHashMapIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove")
  };
  $n(this.ju_HashMap$AbstractHashMapIterator__f_$outer).removeNode__ju_HashMap$Node__V(last);
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null
});
function $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__($thiz, key, hash, value, previous, next) {
  $thiz.ju_HashMap$Node__f_key = key;
  $thiz.ju_HashMap$Node__f_hash = hash;
  $thiz.ju_HashMap$Node__f_value = value;
  $thiz.ju_HashMap$Node__f_previous = previous;
  $thiz.ju_HashMap$Node__f_next = next;
  return $thiz
}
/** @constructor */
function $c_ju_HashMap$Node() {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null
}
$c_ju_HashMap$Node.prototype = new $h_O();
$c_ju_HashMap$Node.prototype.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
  /*<skip>*/
}
$h_ju_HashMap$Node.prototype = $c_ju_HashMap$Node.prototype;
$c_ju_HashMap$Node.prototype.getKey__O = (function() {
  return this.ju_HashMap$Node__f_key
});
$c_ju_HashMap$Node.prototype.getValue__O = (function() {
  return this.ju_HashMap$Node__f_value
});
$c_ju_HashMap$Node.prototype.equals__O__Z = (function(that) {
  if ($is_ju_Map$Entry(that)) {
    var x2 = $as_ju_Map$Entry(that);
    var a = this.ju_HashMap$Node__f_key;
    var b = $n(x2).getKey__O();
    if (((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b))) {
      var a$1 = this.ju_HashMap$Node__f_value;
      var b$1 = $n(x2).getValue__O();
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z($n(a$1), b$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_HashMap$Node.prototype.hashCode__I = (function() {
  var improvedHash = this.ju_HashMap$Node__f_hash;
  var o = this.ju_HashMap$Node__f_value;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $dp_hashCode__I($n(o))))
});
$c_ju_HashMap$Node.prototype.toString__T = (function() {
  return ((this.ju_HashMap$Node__f_key + "=") + this.ju_HashMap$Node__f_value)
});
function $as_ju_HashMap$Node(obj) {
  return (((obj instanceof $c_ju_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.HashMap$Node"))
}
function $isArrayOf_ju_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_HashMap$Node)))
}
function $asArrayOf_ju_HashMap$Node(obj, depth) {
  return (($isArrayOf_ju_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.HashMap$Node;", depth))
}
var $d_ju_HashMap$Node = new $TypeData().initClass({
  ju_HashMap$Node: 0
}, false, "java.util.HashMap$Node", {
  ju_HashMap$Node: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_ju_HashMap$Node.prototype.$classData = $d_ju_HashMap$Node;
function $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = outer
  };
  $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = $n(outer).ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest;
  return $thiz
}
/** @constructor */
function $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null
}
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = new $h_O();
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.constructor = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator;
/** @constructor */
function $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype;
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.hasNext__Z = (function() {
  return (this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode !== null)
});
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
  };
  var node = this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = node;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = $n(node).ju_LinkedHashMap$Node__f_younger;
  return this.extract__ju_LinkedHashMap$Node__O(node)
});
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.remove__V = (function() {
  var last = this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove")
  };
  $n(this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer).removeNode__ju_HashMap$Node__V(last);
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null
});
function $p_ju_Locale$Category$__categories$lzycompute__Aju_Locale$Category($thiz) {
  if ((!$thiz.ju_Locale$Category$__f_bitmap$0)) {
    $thiz.ju_Locale$Category$__f_categories = new ($d_ju_Locale$Category.getArrayOf().constr)([$thiz.DISPLAY__ju_Locale$Category(), $thiz.FORMAT__ju_Locale$Category()]);
    $thiz.ju_Locale$Category$__f_bitmap$0 = true
  };
  return $thiz.ju_Locale$Category$__f_categories
}
function $p_ju_Locale$Category$__categories__Aju_Locale$Category($thiz) {
  return ((!$thiz.ju_Locale$Category$__f_bitmap$0) ? $p_ju_Locale$Category$__categories$lzycompute__Aju_Locale$Category($thiz) : $thiz.ju_Locale$Category$__f_categories)
}
/** @constructor */
function $c_ju_Locale$Category$() {
  this.ju_Locale$Category$__f_categories = null;
  this.ju_Locale$Category$__f_DISPLAY = null;
  this.ju_Locale$Category$__f_FORMAT = null;
  this.ju_Locale$Category$__f_bitmap$0 = false;
  this.ju_Locale$Category$__f_bitmap$init$0 = 0;
  $n_ju_Locale$Category$ = this;
  this.ju_Locale$Category$__f_DISPLAY = new $c_ju_Locale$Category("DISPLAY", 0);
  this.ju_Locale$Category$__f_bitmap$init$0 = (((1 | this.ju_Locale$Category$__f_bitmap$init$0) << 24) >> 24);
  this.ju_Locale$Category$__f_FORMAT = new $c_ju_Locale$Category("FORMAT", 1);
  this.ju_Locale$Category$__f_bitmap$init$0 = (((2 | this.ju_Locale$Category$__f_bitmap$init$0) << 24) >> 24)
}
$c_ju_Locale$Category$.prototype = new $h_O();
$c_ju_Locale$Category$.prototype.constructor = $c_ju_Locale$Category$;
/** @constructor */
function $h_ju_Locale$Category$() {
  /*<skip>*/
}
$h_ju_Locale$Category$.prototype = $c_ju_Locale$Category$.prototype;
$c_ju_Locale$Category$.prototype.DISPLAY__ju_Locale$Category = (function() {
  if (((((1 & this.ju_Locale$Category$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-locales/scala-java-locales/core/shared/src/main/scala/java/util/Locale.scala: 50")
  };
  return this.ju_Locale$Category$__f_DISPLAY
});
$c_ju_Locale$Category$.prototype.FORMAT__ju_Locale$Category = (function() {
  if (((((2 & this.ju_Locale$Category$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-locales/scala-java-locales/core/shared/src/main/scala/java/util/Locale.scala: 51")
  };
  return this.ju_Locale$Category$__f_FORMAT
});
var $d_ju_Locale$Category$ = new $TypeData().initClass({
  ju_Locale$Category$: 0
}, false, "java.util.Locale$Category$", {
  ju_Locale$Category$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Locale$Category$.prototype.$classData = $d_ju_Locale$Category$;
var $n_ju_Locale$Category$;
function $m_ju_Locale$Category$() {
  if ((!$n_ju_Locale$Category$)) {
    $n_ju_Locale$Category$ = new $c_ju_Locale$Category$()
  };
  return $n_ju_Locale$Category$
}
function $ct_ju_Random__J__($thiz, seed_in) {
  $thiz.setSeed__J__V(seed_in);
  return $thiz
}
function $ct_ju_Random__($thiz) {
  $ct_ju_Random__J__($thiz, $m_ju_Random$().java$util$Random$$randomSeed__J());
  return $thiz
}
/** @constructor */
function $c_ju_Random() {
  this.ju_Random__f_seedHi = 0;
  this.ju_Random__f_seedLo = 0
}
$c_ju_Random.prototype = new $h_O();
$c_ju_Random.prototype.constructor = $c_ju_Random;
/** @constructor */
function $h_ju_Random() {
  /*<skip>*/
}
$h_ju_Random.prototype = $c_ju_Random.prototype;
$c_ju_Random.prototype.setSeed__J__V = (function(seed_in) {
  var lo = ((-554899859) ^ seed_in.RTLong__f_lo);
  var hi = (5 ^ seed_in.RTLong__f_hi);
  var hi$1 = (65535 & hi);
  var lo$1 = (((lo >>> 24) | 0) | (hi$1 << 8));
  this.ju_Random__f_seedHi = lo$1;
  this.ju_Random__f_seedLo = (16777215 & lo)
});
$c_ju_Random.prototype.next__I__I = (function(bits) {
  var oldSeedHi = this.ju_Random__f_seedHi;
  var oldSeedLo = this.ju_Random__f_seedLo;
  var loProd = ((1.5525485E7 * oldSeedLo) + 11.0);
  var hiProd = ((1502.0 * oldSeedLo) + (1.5525485E7 * oldSeedHi));
  var x = (loProd / 1.6777216E7);
  var newSeedHi = (16777215 & (($uI((x | 0)) + (16777215 & $uI((hiProd | 0)))) | 0));
  var newSeedLo = (16777215 & $uI((loProd | 0)));
  this.ju_Random__f_seedHi = newSeedHi;
  this.ju_Random__f_seedLo = newSeedLo;
  var result32 = ((newSeedHi << 8) | (newSeedLo >> 16));
  return ((result32 >>> ((32 - bits) | 0)) | 0)
});
$c_ju_Random.prototype.nextBytes__AB__V = (function(bytes) {
  var i = 0;
  while ((i < $n(bytes).u.length)) {
    var rnd = this.next__I__I(32);
    var a = (($n(bytes).u.length - i) | 0);
    var n = ((a < 4) ? a : 4);
    while ((n > 0)) {
      $n(bytes).set(i, ((rnd << 24) >> 24));
      rnd = (rnd >> 8);
      n = (((-1) + n) | 0);
      i = ((1 + i) | 0)
    }
  }
});
var $d_ju_Random = new $TypeData().initClass({
  ju_Random: 0
}, false, "java.util.Random", {
  ju_Random: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Random.prototype.$classData = $d_ju_Random;
function $p_ju_Random$__randomInt__I($thiz) {
  var a = (4.294967296E9 * $uD(Math.random()));
  return $doubleToInt(($uD(Math.floor(a)) - 2.147483648E9))
}
/** @constructor */
function $c_ju_Random$() {
  /*<skip>*/
}
$c_ju_Random$.prototype = new $h_O();
$c_ju_Random$.prototype.constructor = $c_ju_Random$;
/** @constructor */
function $h_ju_Random$() {
  /*<skip>*/
}
$h_ju_Random$.prototype = $c_ju_Random$.prototype;
$c_ju_Random$.prototype.java$util$Random$$randomSeed__J = (function() {
  var value = $p_ju_Random$__randomInt__I(this);
  var value$1 = $p_ju_Random$__randomInt__I(this);
  return new $c_RTLong(value$1, value)
});
var $d_ju_Random$ = new $TypeData().initClass({
  ju_Random$: 0
}, false, "java.util.Random$", {
  ju_Random$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Random$.prototype.$classData = $d_ju_Random$;
var $n_ju_Random$;
function $m_ju_Random$() {
  if ((!$n_ju_Random$)) {
    $n_ju_Random$ = new $c_ju_Random$()
  };
  return $n_ju_Random$
}
function $p_ju_TimeZone$__default__ju_TimeZone($thiz) {
  if ((!$thiz.ju_TimeZone$__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/src/main/scala/java/util/TimeZone.scala: 28")
  };
  return $thiz.ju_TimeZone$__f_default
}
function $p_ju_TimeZone$__offsetInMillis$1__I($thiz) {
  var browserDate = new Date();
  return Math.imul(1000, Math.imul(60, $doubleToInt($uD(browserDate.getTimezoneOffset()))))
}
function $p_ju_TimeZone$__browserTZ$1__s_util_Try($thiz) {
  try {
    var browserDate = new Date();
    $m_sc_StringOps$();
    var $$x1 = $m_sc_StringOps$();
    var x = $as_T(browserDate.toTimeString());
    var x$1 = $n($n($$x1).split$extension__T__C__AT(x, 32)).get(1);
    $m_sc_StringOps$();
    $m_sc_StringOps$();
    var from = 0;
    _return: {
      var this$6 = $n(x$1);
      var len = this$6.length;
      var i = from;
      while ((i < len)) {
        var this$7 = $n(x$1);
        var index = i;
        var arg1 = $charAt(this$7, index);
        if ((arg1 === 32)) {
          var x1 = i;
          break _return
        };
        i = ((1 + i) | 0)
      };
      var x1 = (-1)
    };
    if ((x1 === (-1))) {
      var $$x2 = x$1
    } else {
      var this$8 = $n(x$1);
      if ((x1 > this$8.length)) {
        $charAt(this$8, x1)
      };
      if ((x1 < 0)) {
        $charAt(this$8, (-1))
      };
      var $$x2 = $as_T(this$8.substring(0, x1))
    };
    return new $c_s_util_Success($$x2)
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(o11).isEmpty__Z())) {
      var e$3 = $as_jl_Throwable($n(o11).get__O());
      return new $c_s_util_Failure(e$3)
    };
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
  }
}
function $p_ju_TimeZone$__timeZone$1__T($thiz) {
  try {
    var value = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    var $$x1 = new $c_s_util_Success($as_T(((value === (void 0)) ? $as_T($n($p_ju_TimeZone$__browserTZ$1__s_util_Try($thiz)).getOrElse__F0__O(new $c_sjsr_AnonFunction0((() => "UTC")))) : value)))
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $$x1;
      var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(o11).isEmpty__Z())) {
        var e$3 = $as_jl_Throwable($n(o11).get__O());
        var $$x1 = new $c_s_util_Failure(e$3);
        break matchEnd8
      };
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
    }
  };
  return $as_T($n($n($$x1).orElse__F0__s_util_Try(new $c_sjsr_AnonFunction0((() => $p_ju_TimeZone$__browserTZ$1__s_util_Try($thiz))))).getOrElse__F0__O(new $c_sjsr_AnonFunction0((() => "UTC"))))
}
/** @constructor */
function $c_ju_TimeZone$() {
  this.ju_TimeZone$__f_default = null;
  this.ju_TimeZone$__f_bitmap$init$0 = false;
  $n_ju_TimeZone$ = this;
  this.ju_TimeZone$__f_default = new $c_ju_SimpleTimeZone($p_ju_TimeZone$__offsetInMillis$1__I(this), $p_ju_TimeZone$__timeZone$1__T(this));
  this.ju_TimeZone$__f_bitmap$init$0 = true
}
$c_ju_TimeZone$.prototype = new $h_O();
$c_ju_TimeZone$.prototype.constructor = $c_ju_TimeZone$;
/** @constructor */
function $h_ju_TimeZone$() {
  /*<skip>*/
}
$h_ju_TimeZone$.prototype = $c_ju_TimeZone$.prototype;
$c_ju_TimeZone$.prototype.getTimeZone__T__ju_TimeZone = (function(timeZone) {
  return this.getTimeZone__Ljava_time_ZoneId__ju_TimeZone($m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId(timeZone))
});
$c_ju_TimeZone$.prototype.getTimeZone__Ljava_time_ZoneId__ju_TimeZone = (function(zoneId) {
  var rules = $n(zoneId).getRules__Ljava_time_zone_ZoneRules();
  new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
  var $$x1 = $m_Ljava_time_Instant$();
  var this$5 = $m_RTLong$();
  var value = $uD(new Date().getTime());
  var lo = this$5.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$6 = $n($n(rules).getStandardOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($n($$x1).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))));
  var offsetInMillis = Math.imul(1000, this$6.Ljava_time_ZoneOffset__f_totalSeconds);
  return new $c_ju_SimpleTimeZone(offsetInMillis, $n(zoneId).getId__T())
});
var $d_ju_TimeZone$ = new $TypeData().initClass({
  ju_TimeZone$: 0
}, false, "java.util.TimeZone$", {
  ju_TimeZone$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_TimeZone$.prototype.$classData = $d_ju_TimeZone$;
var $n_ju_TimeZone$;
function $m_ju_TimeZone$() {
  if ((!$n_ju_TimeZone$)) {
    $n_ju_TimeZone$ = new $c_ju_TimeZone$()
  };
  return $n_ju_TimeZone$
}
function $p_ju_UUID$__csprng$lzycompute__ju_Random($thiz) {
  if (((((1 & $thiz.ju_UUID$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.ju_UUID$__f_csprng = new $c_Ljava_security_SecureRandom();
    $thiz.ju_UUID$__f_bitmap$0 = (((1 | $thiz.ju_UUID$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.ju_UUID$__f_csprng
}
function $p_ju_UUID$__csprng__ju_Random($thiz) {
  return (((((1 & $thiz.ju_UUID$__f_bitmap$0) << 24) >> 24) === 0) ? $p_ju_UUID$__csprng$lzycompute__ju_Random($thiz) : $thiz.ju_UUID$__f_csprng)
}
function $p_ju_UUID$__randomUUIDBuffer$lzycompute__AB($thiz) {
  if (((((2 & $thiz.ju_UUID$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.ju_UUID$__f_randomUUIDBuffer = new $ac_B(16);
    $thiz.ju_UUID$__f_bitmap$0 = (((2 | $thiz.ju_UUID$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.ju_UUID$__f_randomUUIDBuffer
}
function $p_ju_UUID$__randomUUIDBuffer__AB($thiz) {
  return (((((2 & $thiz.ju_UUID$__f_bitmap$0) << 24) >> 24) === 0) ? $p_ju_UUID$__randomUUIDBuffer$lzycompute__AB($thiz) : $thiz.ju_UUID$__f_randomUUIDBuffer)
}
function $p_ju_UUID$__fail$1__T__E($thiz, name$1) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid UUID string: " + name$1))
}
/** @constructor */
function $c_ju_UUID$() {
  this.ju_UUID$__f_csprng = null;
  this.ju_UUID$__f_randomUUIDBuffer = null;
  this.ju_UUID$__f_bitmap$0 = 0
}
$c_ju_UUID$.prototype = new $h_O();
$c_ju_UUID$.prototype.constructor = $c_ju_UUID$;
/** @constructor */
function $h_ju_UUID$() {
  /*<skip>*/
}
$h_ju_UUID$.prototype = $c_ju_UUID$.prototype;
$c_ju_UUID$.prototype.randomUUID__ju_UUID = (function() {
  var buffer = $p_ju_UUID$__randomUUIDBuffer__AB(this);
  $n($p_ju_UUID$__csprng__ju_Random(this)).nextBytes__AB__V($p_ju_UUID$__randomUUIDBuffer__AB(this));
  var i1 = (((($n(buffer).get(0) << 24) | ((255 & $n(buffer).get(1)) << 16)) | ((255 & $n(buffer).get(2)) << 8)) | (255 & $n(buffer).get(3)));
  var i2 = (16384 | ((-61441) & (((($n(buffer).get(4) << 24) | ((255 & $n(buffer).get(5)) << 16)) | ((255 & $n(buffer).get(6)) << 8)) | (255 & $n(buffer).get(7)))));
  var i3 = ((-2147483648) | (1073741823 & (((($n(buffer).get(8) << 24) | ((255 & $n(buffer).get(9)) << 16)) | ((255 & $n(buffer).get(10)) << 8)) | (255 & $n(buffer).get(11)))));
  var i4 = (((($n(buffer).get(12) << 24) | ((255 & $n(buffer).get(13)) << 16)) | ((255 & $n(buffer).get(14)) << 8)) | (255 & $n(buffer).get(15)));
  return new $c_ju_UUID(i1, i2, i3, i4)
});
$c_ju_UUID$.prototype.fromString__T__ju_UUID = (function(name) {
  var this$1 = $n(name);
  if ((this$1.length !== 36)) {
    var $$x4 = true
  } else {
    var this$2 = $n(name);
    var $$x4 = ($charAt(this$2, 8) !== 45)
  };
  if ($$x4) {
    var $$x3 = true
  } else {
    var this$3 = $n(name);
    var $$x3 = ($charAt(this$3, 13) !== 45)
  };
  if ($$x3) {
    var $$x2 = true
  } else {
    var this$4 = $n(name);
    var $$x2 = ($charAt(this$4, 18) !== 45)
  };
  if ($$x2) {
    var $$x1 = true
  } else {
    var this$5 = $n(name);
    var $$x1 = ($charAt(this$5, 23) !== 45)
  };
  if ($$x1) {
    $p_ju_UUID$__fail$1__T__E(this, name)
  };
  try {
    var this$6 = $n(name);
    if ((this$6.length < 4)) {
      $charAt(this$6, 4)
    };
    var his = $as_T(this$6.substring(0, 4));
    var this$7 = $n(name);
    if ((this$7.length < 8)) {
      $charAt(this$7, 8)
    };
    var los = $as_T(this$7.substring(4, 8));
    var i1 = (($m_jl_Integer$().parseInt__T__I__I(his, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los, 16));
    var this$8 = $n(name);
    if ((this$8.length < 13)) {
      $charAt(this$8, 13)
    };
    var his$1 = $as_T(this$8.substring(9, 13));
    var this$9 = $n(name);
    if ((this$9.length < 18)) {
      $charAt(this$9, 18)
    };
    var los$1 = $as_T(this$9.substring(14, 18));
    var i2 = (($m_jl_Integer$().parseInt__T__I__I(his$1, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los$1, 16));
    var this$10 = $n(name);
    if ((this$10.length < 23)) {
      $charAt(this$10, 23)
    };
    var his$2 = $as_T(this$10.substring(19, 23));
    var this$11 = $n(name);
    if ((this$11.length < 28)) {
      $charAt(this$11, 28)
    };
    var los$2 = $as_T(this$11.substring(24, 28));
    var i3 = (($m_jl_Integer$().parseInt__T__I__I(his$2, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los$2, 16));
    var this$12 = $n(name);
    if ((this$12.length < 32)) {
      $charAt(this$12, 32)
    };
    var his$3 = $as_T(this$12.substring(28, 32));
    var this$13 = $n(name);
    if ((this$13.length < 36)) {
      $charAt(this$13, 36)
    };
    var los$3 = $as_T(this$13.substring(32, 36));
    var i4 = (($m_jl_Integer$().parseInt__T__I__I(his$3, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los$3, 16));
    return new $c_ju_UUID(i1, i2, i3, i4)
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      $p_ju_UUID$__fail$1__T__E(this, name)
    } else {
      throw e
    }
  }
});
var $d_ju_UUID$ = new $TypeData().initClass({
  ju_UUID$: 0
}, false, "java.util.UUID$", {
  ju_UUID$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_UUID$.prototype.$classData = $d_ju_UUID$;
var $n_ju_UUID$;
function $m_ju_UUID$() {
  if ((!$n_ju_UUID$)) {
    $n_ju_UUID$ = new $c_ju_UUID$()
  };
  return $n_ju_UUID$
}
function $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = outer
  };
  var this$1 = $n($n(outer).java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList());
  $thiz.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = this$1.listIterator__I__ju_ListIterator(0);
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = new $h_O();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.hasNext__Z = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter).hasNext__Z()
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.next__O = (function() {
  var node = $as_ju_HashMap$Node($n(this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter).next__O());
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = node;
  return this.extract__ju_HashMap$Node__O(node)
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.remove__V = (function() {
  var last = this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove")
  };
  $n(this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer).removeNode__ju_HashMap$Node__V(last);
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null
});
/** @constructor */
function $c_ju_concurrent_TimeUnit$() {
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = null;
  this.ju_concurrent_TimeUnit$__f_SECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MINUTES = null;
  this.ju_concurrent_TimeUnit$__f_HOURS = null;
  this.ju_concurrent_TimeUnit$__f_DAYS = null;
  $n_ju_concurrent_TimeUnit$ = this;
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = new $c_ju_concurrent_TimeUnit$$anon$1();
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = new $c_ju_concurrent_TimeUnit$$anon$2();
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = new $c_ju_concurrent_TimeUnit$$anon$3();
  this.ju_concurrent_TimeUnit$__f_SECONDS = new $c_ju_concurrent_TimeUnit$$anon$4();
  this.ju_concurrent_TimeUnit$__f_MINUTES = new $c_ju_concurrent_TimeUnit$$anon$5();
  this.ju_concurrent_TimeUnit$__f_HOURS = new $c_ju_concurrent_TimeUnit$$anon$6();
  this.ju_concurrent_TimeUnit$__f_DAYS = new $c_ju_concurrent_TimeUnit$$anon$7()
}
$c_ju_concurrent_TimeUnit$.prototype = new $h_O();
$c_ju_concurrent_TimeUnit$.prototype.constructor = $c_ju_concurrent_TimeUnit$;
/** @constructor */
function $h_ju_concurrent_TimeUnit$() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$.prototype = $c_ju_concurrent_TimeUnit$.prototype;
$c_ju_concurrent_TimeUnit$.prototype.java$util$concurrent$TimeUnit$$x__J__J__J__J = (function(a, b, max) {
  var ahi = a.RTLong__f_hi;
  var bhi = max.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ max.RTLong__f_lo)) : (ahi > bhi))) {
    return new $c_RTLong((-1), 2147483647)
  } else {
    var lo = max.RTLong__f_lo;
    var hi = max.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var ahi$1 = a.RTLong__f_hi;
    if (((ahi$1 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$1 < hi$1))) {
      return new $c_RTLong(1, (-2147483648))
    } else {
      var alo = a.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var a0 = (65535 & alo);
      var a1 = ((alo >>> 16) | 0);
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return new $c_RTLong(lo$2, hi$2)
    }
  }
});
var $d_ju_concurrent_TimeUnit$ = new $TypeData().initClass({
  ju_concurrent_TimeUnit$: 0
}, false, "java.util.concurrent.TimeUnit$", {
  ju_concurrent_TimeUnit$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$.prototype.$classData = $d_ju_concurrent_TimeUnit$;
var $n_ju_concurrent_TimeUnit$;
function $m_ju_concurrent_TimeUnit$() {
  if ((!$n_ju_concurrent_TimeUnit$)) {
    $n_ju_concurrent_TimeUnit$ = new $c_ju_concurrent_TimeUnit$()
  };
  return $n_ju_concurrent_TimeUnit$
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicBoolean(value) {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  this.ju_concurrent_atomic_AtomicBoolean__f_value = value
}
$c_ju_concurrent_atomic_AtomicBoolean.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicBoolean.prototype.constructor = $c_ju_concurrent_atomic_AtomicBoolean;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicBoolean() {
  /*<skip>*/
}
$h_ju_concurrent_atomic_AtomicBoolean.prototype = $c_ju_concurrent_atomic_AtomicBoolean.prototype;
$c_ju_concurrent_atomic_AtomicBoolean.prototype.getAndSet__Z__Z = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  this.ju_concurrent_atomic_AtomicBoolean__f_value = newValue;
  return old
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  return ("" + this$1)
});
var $d_ju_concurrent_atomic_AtomicBoolean = new $TypeData().initClass({
  ju_concurrent_atomic_AtomicBoolean: 0
}, false, "java.util.concurrent.atomic.AtomicBoolean", {
  ju_concurrent_atomic_AtomicBoolean: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.$classData = $d_ju_concurrent_atomic_AtomicBoolean;
function $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicReference__f_value = value;
  return $thiz
}
function $ct_ju_concurrent_atomic_AtomicReference__($thiz) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, null);
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicReference() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null
}
$c_ju_concurrent_atomic_AtomicReference.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicReference.prototype.constructor = $c_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicReference() {
  /*<skip>*/
}
$h_ju_concurrent_atomic_AtomicReference.prototype = $c_ju_concurrent_atomic_AtomicReference.prototype;
$c_ju_concurrent_atomic_AtomicReference.prototype.compareAndSet__O__O__Z = (function(expect, update) {
  if (Object.is(expect, this.ju_concurrent_atomic_AtomicReference__f_value)) {
    this.ju_concurrent_atomic_AtomicReference__f_value = update;
    return true
  } else {
    return false
  }
});
$c_ju_concurrent_atomic_AtomicReference.prototype.getAndSet__O__O = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicReference__f_value;
  this.ju_concurrent_atomic_AtomicReference__f_value = newValue;
  return old
});
$c_ju_concurrent_atomic_AtomicReference.prototype.toString__T = (function() {
  var obj = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ("" + obj)
});
var $d_ju_concurrent_atomic_AtomicReference = new $TypeData().initClass({
  ju_concurrent_atomic_AtomicReference: 0
}, false, "java.util.concurrent.atomic.AtomicReference", {
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_atomic_AtomicReference.prototype.$classData = $d_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
  /*<skip>*/
}
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
  /*<skip>*/
}
$h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_O(a, 1);
  $n(a$1).set(i, v)
});
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_O(a, 1);
  return $n(a$1).get(i)
});
var $d_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $TypeData().initClass({
  ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$: 0
}, false, "java.util.internal.GenericArrayOps$ReusableAnyRefArrayOps$", {
  ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$: 1,
  O: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1
});
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.$classData = $d_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
var $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
function $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$()
  };
  return $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$
}
/** @constructor */
function $c_ju_regex_IndicesBuilder$AlternativesNode(alternatives) {
  this.ju_regex_IndicesBuilder$Node__f_newGroup = 0;
  this.ju_regex_IndicesBuilder$AlternativesNode__f_alternatives = null;
  this.ju_regex_IndicesBuilder$AlternativesNode__f_alternatives = alternatives
}
$c_ju_regex_IndicesBuilder$AlternativesNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$c_ju_regex_IndicesBuilder$AlternativesNode.prototype.constructor = $c_ju_regex_IndicesBuilder$AlternativesNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$AlternativesNode() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$AlternativesNode.prototype = $c_ju_regex_IndicesBuilder$AlternativesNode.prototype;
$c_ju_regex_IndicesBuilder$AlternativesNode.prototype.setNewGroup__I__I = (function(newGroupIndex) {
  var nextIndex = $c_ju_regex_IndicesBuilder$Node.prototype.setNewGroup__I__I.call(this, newGroupIndex);
  var len = $uI(this.ju_regex_IndicesBuilder$AlternativesNode__f_alternatives.length);
  var i = 0;
  while ((i !== len)) {
    nextIndex = $n($as_ju_regex_IndicesBuilder$Node(this.ju_regex_IndicesBuilder$AlternativesNode__f_alternatives[i])).setNewGroup__I__I(nextIndex);
    i = ((1 + i) | 0)
  };
  return nextIndex
});
$c_ju_regex_IndicesBuilder$AlternativesNode.prototype.buildRegex__O__T = (function(groupNodeMap) {
  var result = "(";
  var len = $uI(this.ju_regex_IndicesBuilder$AlternativesNode__f_alternatives.length);
  var i = 0;
  while ((i !== len)) {
    if ((i !== 0)) {
      result = (result + "|")
    };
    result = (("" + result) + $n($as_ju_regex_IndicesBuilder$Node(this.ju_regex_IndicesBuilder$AlternativesNode__f_alternatives[i])).buildRegex__O__T(groupNodeMap));
    i = ((1 + i) | 0)
  };
  return (result + ")")
});
$c_ju_regex_IndicesBuilder$AlternativesNode.prototype.propagate__O__O__I__I__V = (function(matchResult, indices, start, end) {
  var len = $uI(this.ju_regex_IndicesBuilder$AlternativesNode__f_alternatives.length);
  var i = 0;
  while ((i !== len)) {
    $n($as_ju_regex_IndicesBuilder$Node(this.ju_regex_IndicesBuilder$AlternativesNode__f_alternatives[i])).propagate__O__O__I__I__V(matchResult, indices, start, end);
    i = ((1 + i) | 0)
  }
});
var $d_ju_regex_IndicesBuilder$AlternativesNode = new $TypeData().initClass({
  ju_regex_IndicesBuilder$AlternativesNode: 0
}, false, "java.util.regex.IndicesBuilder$AlternativesNode", {
  ju_regex_IndicesBuilder$AlternativesNode: 1,
  ju_regex_IndicesBuilder$Node: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder$AlternativesNode.prototype.$classData = $d_ju_regex_IndicesBuilder$AlternativesNode;
/** @constructor */
function $c_ju_regex_IndicesBuilder$BackReferenceNode(groupNumber) {
  this.ju_regex_IndicesBuilder$Node__f_newGroup = 0;
  this.ju_regex_IndicesBuilder$BackReferenceNode__f_groupNumber = 0;
  this.ju_regex_IndicesBuilder$BackReferenceNode__f_groupNumber = groupNumber
}
$c_ju_regex_IndicesBuilder$BackReferenceNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$c_ju_regex_IndicesBuilder$BackReferenceNode.prototype.constructor = $c_ju_regex_IndicesBuilder$BackReferenceNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$BackReferenceNode() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$BackReferenceNode.prototype = $c_ju_regex_IndicesBuilder$BackReferenceNode.prototype;
$c_ju_regex_IndicesBuilder$BackReferenceNode.prototype.buildRegex__O__T = (function(groupNodeMap) {
  var newGroupNumber = ((this.ju_regex_IndicesBuilder$BackReferenceNode__f_groupNumber >= $uI(groupNodeMap.length)) ? 0 : $n($as_ju_regex_IndicesBuilder$Node(groupNodeMap[this.ju_regex_IndicesBuilder$BackReferenceNode__f_groupNumber])).ju_regex_IndicesBuilder$Node__f_newGroup);
  return (("(\\" + newGroupNumber) + ")")
});
$c_ju_regex_IndicesBuilder$BackReferenceNode.prototype.propagate__O__O__I__I__V = (function(matchResult, indices, start, end) {
  /*<skip>*/
});
var $d_ju_regex_IndicesBuilder$BackReferenceNode = new $TypeData().initClass({
  ju_regex_IndicesBuilder$BackReferenceNode: 0
}, false, "java.util.regex.IndicesBuilder$BackReferenceNode", {
  ju_regex_IndicesBuilder$BackReferenceNode: 1,
  ju_regex_IndicesBuilder$Node: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder$BackReferenceNode.prototype.$classData = $d_ju_regex_IndicesBuilder$BackReferenceNode;
/** @constructor */
function $c_ju_regex_IndicesBuilder$GroupNode(number, inner) {
  this.ju_regex_IndicesBuilder$Node__f_newGroup = 0;
  this.ju_regex_IndicesBuilder$GroupNode__f_number = 0;
  this.ju_regex_IndicesBuilder$GroupNode__f_inner = null;
  this.ju_regex_IndicesBuilder$GroupNode__f_number = number;
  this.ju_regex_IndicesBuilder$GroupNode__f_inner = inner
}
$c_ju_regex_IndicesBuilder$GroupNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$c_ju_regex_IndicesBuilder$GroupNode.prototype.constructor = $c_ju_regex_IndicesBuilder$GroupNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$GroupNode() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$GroupNode.prototype = $c_ju_regex_IndicesBuilder$GroupNode.prototype;
$c_ju_regex_IndicesBuilder$GroupNode.prototype.setNewGroup__I__I = (function(newGroupIndex) {
  return $n(this.ju_regex_IndicesBuilder$GroupNode__f_inner).setNewGroup__I__I($c_ju_regex_IndicesBuilder$Node.prototype.setNewGroup__I__I.call(this, newGroupIndex))
});
$c_ju_regex_IndicesBuilder$GroupNode.prototype.buildRegex__O__T = (function(groupNodeMap) {
  return (("(" + $n(this.ju_regex_IndicesBuilder$GroupNode__f_inner).buildRegex__O__T(groupNodeMap)) + ")")
});
$c_ju_regex_IndicesBuilder$GroupNode.prototype.propagate__O__O__I__I__V = (function(matchResult, indices, start, end) {
  var x = matchResult[this.ju_regex_IndicesBuilder$Node__f_newGroup];
  if ((x !== (void 0))) {
    indices[this.ju_regex_IndicesBuilder$GroupNode__f_number] = [start, end]
  };
  $n(this.ju_regex_IndicesBuilder$GroupNode__f_inner).propagate__O__O__I__I__V(matchResult, indices, start, end)
});
var $d_ju_regex_IndicesBuilder$GroupNode = new $TypeData().initClass({
  ju_regex_IndicesBuilder$GroupNode: 0
}, false, "java.util.regex.IndicesBuilder$GroupNode", {
  ju_regex_IndicesBuilder$GroupNode: 1,
  ju_regex_IndicesBuilder$Node: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder$GroupNode.prototype.$classData = $d_ju_regex_IndicesBuilder$GroupNode;
/** @constructor */
function $c_ju_regex_IndicesBuilder$LeafRegexNode(regex) {
  this.ju_regex_IndicesBuilder$Node__f_newGroup = 0;
  this.ju_regex_IndicesBuilder$LeafRegexNode__f_regex = null;
  this.ju_regex_IndicesBuilder$LeafRegexNode__f_regex = regex
}
$c_ju_regex_IndicesBuilder$LeafRegexNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$c_ju_regex_IndicesBuilder$LeafRegexNode.prototype.constructor = $c_ju_regex_IndicesBuilder$LeafRegexNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$LeafRegexNode() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$LeafRegexNode.prototype = $c_ju_regex_IndicesBuilder$LeafRegexNode.prototype;
$c_ju_regex_IndicesBuilder$LeafRegexNode.prototype.buildRegex__O__T = (function(groupNodeMap) {
  return (("(" + this.ju_regex_IndicesBuilder$LeafRegexNode__f_regex) + ")")
});
$c_ju_regex_IndicesBuilder$LeafRegexNode.prototype.propagate__O__O__I__I__V = (function(matchResult, indices, start, end) {
  /*<skip>*/
});
function $as_ju_regex_IndicesBuilder$LeafRegexNode(obj) {
  return (((obj instanceof $c_ju_regex_IndicesBuilder$LeafRegexNode) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.regex.IndicesBuilder$LeafRegexNode"))
}
function $isArrayOf_ju_regex_IndicesBuilder$LeafRegexNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_regex_IndicesBuilder$LeafRegexNode)))
}
function $asArrayOf_ju_regex_IndicesBuilder$LeafRegexNode(obj, depth) {
  return (($isArrayOf_ju_regex_IndicesBuilder$LeafRegexNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.regex.IndicesBuilder$LeafRegexNode;", depth))
}
var $d_ju_regex_IndicesBuilder$LeafRegexNode = new $TypeData().initClass({
  ju_regex_IndicesBuilder$LeafRegexNode: 0
}, false, "java.util.regex.IndicesBuilder$LeafRegexNode", {
  ju_regex_IndicesBuilder$LeafRegexNode: 1,
  ju_regex_IndicesBuilder$Node: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder$LeafRegexNode.prototype.$classData = $d_ju_regex_IndicesBuilder$LeafRegexNode;
/** @constructor */
function $c_ju_regex_IndicesBuilder$LookAroundNode(isLookBehind, indicator, inner) {
  this.ju_regex_IndicesBuilder$Node__f_newGroup = 0;
  this.ju_regex_IndicesBuilder$LookAroundNode__f_isLookBehind = false;
  this.ju_regex_IndicesBuilder$LookAroundNode__f_indicator = null;
  this.ju_regex_IndicesBuilder$LookAroundNode__f_inner = null;
  this.ju_regex_IndicesBuilder$LookAroundNode__f_isLookBehind = isLookBehind;
  this.ju_regex_IndicesBuilder$LookAroundNode__f_indicator = indicator;
  this.ju_regex_IndicesBuilder$LookAroundNode__f_inner = inner
}
$c_ju_regex_IndicesBuilder$LookAroundNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$c_ju_regex_IndicesBuilder$LookAroundNode.prototype.constructor = $c_ju_regex_IndicesBuilder$LookAroundNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$LookAroundNode() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$LookAroundNode.prototype = $c_ju_regex_IndicesBuilder$LookAroundNode.prototype;
$c_ju_regex_IndicesBuilder$LookAroundNode.prototype.setNewGroup__I__I = (function(newGroupIndex) {
  return $n(this.ju_regex_IndicesBuilder$LookAroundNode__f_inner).setNewGroup__I__I($c_ju_regex_IndicesBuilder$Node.prototype.setNewGroup__I__I.call(this, newGroupIndex))
});
$c_ju_regex_IndicesBuilder$LookAroundNode.prototype.buildRegex__O__T = (function(groupNodeMap) {
  return ((("((" + this.ju_regex_IndicesBuilder$LookAroundNode__f_indicator) + $n(this.ju_regex_IndicesBuilder$LookAroundNode__f_inner).buildRegex__O__T(groupNodeMap)) + "))")
});
$c_ju_regex_IndicesBuilder$LookAroundNode.prototype.propagate__O__O__I__I__V = (function(matchResult, indices, start, end) {
  if (this.ju_regex_IndicesBuilder$LookAroundNode__f_isLookBehind) {
    $n(this.ju_regex_IndicesBuilder$LookAroundNode__f_inner).propagateFromEnd__O__O__I__V(matchResult, indices, end)
  } else {
    $n(this.ju_regex_IndicesBuilder$LookAroundNode__f_inner).propagateFromStart__O__O__I__I(matchResult, indices, start)
  }
});
var $d_ju_regex_IndicesBuilder$LookAroundNode = new $TypeData().initClass({
  ju_regex_IndicesBuilder$LookAroundNode: 0
}, false, "java.util.regex.IndicesBuilder$LookAroundNode", {
  ju_regex_IndicesBuilder$LookAroundNode: 1,
  ju_regex_IndicesBuilder$Node: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder$LookAroundNode.prototype.$classData = $d_ju_regex_IndicesBuilder$LookAroundNode;
/** @constructor */
function $c_ju_regex_IndicesBuilder$RepeatedNode(inner, repeater) {
  this.ju_regex_IndicesBuilder$Node__f_newGroup = 0;
  this.ju_regex_IndicesBuilder$RepeatedNode__f_inner = null;
  this.ju_regex_IndicesBuilder$RepeatedNode__f_repeater = null;
  this.ju_regex_IndicesBuilder$RepeatedNode__f_inner = inner;
  this.ju_regex_IndicesBuilder$RepeatedNode__f_repeater = repeater
}
$c_ju_regex_IndicesBuilder$RepeatedNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$c_ju_regex_IndicesBuilder$RepeatedNode.prototype.constructor = $c_ju_regex_IndicesBuilder$RepeatedNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$RepeatedNode() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$RepeatedNode.prototype = $c_ju_regex_IndicesBuilder$RepeatedNode.prototype;
$c_ju_regex_IndicesBuilder$RepeatedNode.prototype.setNewGroup__I__I = (function(newGroupIndex) {
  return $n(this.ju_regex_IndicesBuilder$RepeatedNode__f_inner).setNewGroup__I__I($c_ju_regex_IndicesBuilder$Node.prototype.setNewGroup__I__I.call(this, newGroupIndex))
});
$c_ju_regex_IndicesBuilder$RepeatedNode.prototype.buildRegex__O__T = (function(groupNodeMap) {
  return ((("(" + $n(this.ju_regex_IndicesBuilder$RepeatedNode__f_inner).buildRegex__O__T(groupNodeMap)) + this.ju_regex_IndicesBuilder$RepeatedNode__f_repeater) + ")")
});
$c_ju_regex_IndicesBuilder$RepeatedNode.prototype.propagate__O__O__I__I__V = (function(matchResult, indices, start, end) {
  $n(this.ju_regex_IndicesBuilder$RepeatedNode__f_inner).propagateFromEnd__O__O__I__V(matchResult, indices, end)
});
var $d_ju_regex_IndicesBuilder$RepeatedNode = new $TypeData().initClass({
  ju_regex_IndicesBuilder$RepeatedNode: 0
}, false, "java.util.regex.IndicesBuilder$RepeatedNode", {
  ju_regex_IndicesBuilder$RepeatedNode: 1,
  ju_regex_IndicesBuilder$Node: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder$RepeatedNode.prototype.$classData = $d_ju_regex_IndicesBuilder$RepeatedNode;
/** @constructor */
function $c_ju_regex_IndicesBuilder$SequenceNode(sequence) {
  this.ju_regex_IndicesBuilder$Node__f_newGroup = 0;
  this.ju_regex_IndicesBuilder$SequenceNode__f_sequence = null;
  this.ju_regex_IndicesBuilder$SequenceNode__f_sequence = sequence
}
$c_ju_regex_IndicesBuilder$SequenceNode.prototype = new $h_ju_regex_IndicesBuilder$Node();
$c_ju_regex_IndicesBuilder$SequenceNode.prototype.constructor = $c_ju_regex_IndicesBuilder$SequenceNode;
/** @constructor */
function $h_ju_regex_IndicesBuilder$SequenceNode() {
  /*<skip>*/
}
$h_ju_regex_IndicesBuilder$SequenceNode.prototype = $c_ju_regex_IndicesBuilder$SequenceNode.prototype;
$c_ju_regex_IndicesBuilder$SequenceNode.prototype.setNewGroup__I__I = (function(newGroupIndex) {
  var nextIndex = $c_ju_regex_IndicesBuilder$Node.prototype.setNewGroup__I__I.call(this, newGroupIndex);
  var len = $uI(this.ju_regex_IndicesBuilder$SequenceNode__f_sequence.length);
  var i = 0;
  while ((i !== len)) {
    nextIndex = $n($as_ju_regex_IndicesBuilder$Node(this.ju_regex_IndicesBuilder$SequenceNode__f_sequence[i])).setNewGroup__I__I(nextIndex);
    i = ((1 + i) | 0)
  };
  return nextIndex
});
$c_ju_regex_IndicesBuilder$SequenceNode.prototype.buildRegex__O__T = (function(groupNodeMap) {
  var result = "(";
  var len = $uI(this.ju_regex_IndicesBuilder$SequenceNode__f_sequence.length);
  var i = 0;
  while ((i !== len)) {
    result = (("" + result) + $n($as_ju_regex_IndicesBuilder$Node(this.ju_regex_IndicesBuilder$SequenceNode__f_sequence[i])).buildRegex__O__T(groupNodeMap));
    i = ((1 + i) | 0)
  };
  return (result + ")")
});
$c_ju_regex_IndicesBuilder$SequenceNode.prototype.propagate__O__O__I__I__V = (function(matchResult, indices, start, end) {
  var len = $uI(this.ju_regex_IndicesBuilder$SequenceNode__f_sequence.length);
  var i = 0;
  var nextStart = start;
  while ((i !== len)) {
    nextStart = $n($as_ju_regex_IndicesBuilder$Node(this.ju_regex_IndicesBuilder$SequenceNode__f_sequence[i])).propagateFromStart__O__O__I__I(matchResult, indices, nextStart);
    i = ((1 + i) | 0)
  }
});
var $d_ju_regex_IndicesBuilder$SequenceNode = new $TypeData().initClass({
  ju_regex_IndicesBuilder$SequenceNode: 0
}, false, "java.util.regex.IndicesBuilder$SequenceNode", {
  ju_regex_IndicesBuilder$SequenceNode: 1,
  ju_regex_IndicesBuilder$Node: 1,
  O: 1
});
$c_ju_regex_IndicesBuilder$SequenceNode.prototype.$classData = $d_ju_regex_IndicesBuilder$SequenceNode;
function $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher($thiz) {
  $thiz.ju_regex_Matcher__f_position = 0;
  $thiz.ju_regex_Matcher__f_lastMatch = null;
  $thiz.ju_regex_Matcher__f_appendPos = 0;
  return $thiz
}
function $p_ju_regex_Matcher__ensureLastMatch__O($thiz) {
  if (($thiz.ju_regex_Matcher__f_lastMatch === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "No match available")
  };
  return $thiz.ju_regex_Matcher__f_lastMatch
}
function $p_ju_regex_Matcher__startInternal__I__I($thiz, compiledGroup) {
  var x = $n($thiz.ju_regex_Matcher__f_pattern0).getIndices__O__Z__O($p_ju_regex_Matcher__ensureLastMatch__O($thiz), $thiz.ju_regex_Matcher__f_lastMatchIsForMatches)[compiledGroup];
  return ((x !== (void 0)) ? (($uI(x[0]) + $thiz.ju_regex_Matcher__f_regionStart0) | 0) : (-1))
}
function $p_ju_regex_Matcher__endInternal__I__I($thiz, compiledGroup) {
  var x = $n($thiz.ju_regex_Matcher__f_pattern0).getIndices__O__Z__O($p_ju_regex_Matcher__ensureLastMatch__O($thiz), $thiz.ju_regex_Matcher__f_lastMatchIsForMatches)[compiledGroup];
  return ((x !== (void 0)) ? (($uI(x[1]) + $thiz.ju_regex_Matcher__f_regionStart0) | 0) : (-1))
}
/** @constructor */
function $c_ju_regex_Matcher(pattern0, input0) {
  this.ju_regex_Matcher__f_pattern0 = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = null;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_inputstr = null;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_lastMatchIsForMatches = false;
  this.ju_regex_Matcher__f_appendPos = 0;
  this.ju_regex_Matcher__f_pattern0 = pattern0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = input0;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0);
  this.ju_regex_Matcher__f_inputstr = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_lastMatchIsForMatches = false;
  this.ju_regex_Matcher__f_appendPos = 0
}
$c_ju_regex_Matcher.prototype = new $h_O();
$c_ju_regex_Matcher.prototype.constructor = $c_ju_regex_Matcher;
/** @constructor */
function $h_ju_regex_Matcher() {
  /*<skip>*/
}
$h_ju_regex_Matcher.prototype = $c_ju_regex_Matcher.prototype;
$c_ju_regex_Matcher.prototype.matches__Z = (function() {
  $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  this.ju_regex_Matcher__f_lastMatch = $n(this.ju_regex_Matcher__f_pattern0).execMatches__T__O(this.ju_regex_Matcher__f_inputstr);
  this.ju_regex_Matcher__f_lastMatchIsForMatches = true;
  return (this.ju_regex_Matcher__f_lastMatch !== null)
});
$c_ju_regex_Matcher.prototype.find__Z = (function() {
  var this$1 = $n(this.ju_regex_Matcher__f_pattern0);
  var input = this.ju_regex_Matcher__f_inputstr;
  var start = this.ju_regex_Matcher__f_position;
  var mtch = this$1.java$util$regex$Pattern$$execFindInternal__T__I__O(input, start);
  var end = $uI(this$1.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind.lastIndex);
  if ((mtch !== null)) {
    var $$x1 = ((end === $uI(mtch.index)) ? ((1 + end) | 0) : end)
  } else {
    var this$2 = $n(this.ju_regex_Matcher__f_inputstr);
    var $$x1 = ((1 + this$2.length) | 0)
  };
  this.ju_regex_Matcher__f_position = $$x1;
  this.ju_regex_Matcher__f_lastMatch = mtch;
  this.ju_regex_Matcher__f_lastMatchIsForMatches = false;
  return (mtch !== null)
});
$c_ju_regex_Matcher.prototype.appendReplacement__jl_StringBuffer__T__ju_regex_Matcher = (function(sb, replacement) {
  var $$x1 = $n(sb);
  var this$1 = $n(this.ju_regex_Matcher__f_inputstr);
  var beginIndex = this.ju_regex_Matcher__f_appendPos;
  var endIndex = this.start__I();
  if ((beginIndex < 0)) {
    $charAt(this$1, beginIndex)
  };
  if ((endIndex > this$1.length)) {
    $charAt(this$1, endIndex)
  };
  if ((endIndex < beginIndex)) {
    $charAt(this$1, (-1))
  };
  $n($$x1).append__T__jl_StringBuffer($as_T(this$1.substring(beginIndex, endIndex)));
  var this$2 = $n(replacement);
  var len = this$2.length;
  var i = 0;
  while ((i < len)) {
    var this$3 = $n(replacement);
    var index = i;
    var x1 = $charAt(this$3, index);
    switch (x1) {
      case 36: {
        i = ((1 + i) | 0);
        var j = i;
        while (true) {
          if ((i < len)) {
            var this$4 = $n(replacement);
            var index$1 = i;
            var c = $charAt(this$4, index$1);
            var $$x2 = ((c >= 48) && (c <= 57))
          } else {
            var $$x2 = false
          };
          if ($$x2) {
            i = ((1 + i) | 0)
          } else {
            break
          }
        };
        var this$6 = $m_jl_Integer$();
        var this$5 = $n(replacement);
        var endIndex$1 = i;
        if ((j < 0)) {
          $charAt(this$5, j)
        };
        if ((endIndex$1 > this$5.length)) {
          $charAt(this$5, endIndex$1)
        };
        if ((endIndex$1 < j)) {
          $charAt(this$5, (-1))
        };
        var s = $as_T(this$5.substring(j, endIndex$1));
        var group = this$6.parseInt__T__I__I(s, 10);
        var replaced = this.group__I__T(group);
        if ((replaced !== null)) {
          $n(sb).append__T__jl_StringBuffer(replaced)
        };
        break
      }
      case 92: {
        i = ((1 + i) | 0);
        if ((i < len)) {
          var $$x3 = $n(sb);
          var this$7 = $n(replacement);
          var index$2 = i;
          $n($$x3).append__C__jl_StringBuffer($charAt(this$7, index$2))
        };
        i = ((1 + i) | 0);
        break
      }
      default: {
        $n(sb).append__C__jl_StringBuffer(x1);
        i = ((1 + i) | 0)
      }
    }
  };
  this.ju_regex_Matcher__f_appendPos = this.end__I();
  return this
});
$c_ju_regex_Matcher.prototype.appendTail__jl_StringBuffer__jl_StringBuffer = (function(sb) {
  var $$x1 = $n(sb);
  var this$1 = $n(this.ju_regex_Matcher__f_inputstr);
  var beginIndex = this.ju_regex_Matcher__f_appendPos;
  if (((beginIndex < 0) || (beginIndex > this$1.length))) {
    $charAt(this$1, beginIndex)
  };
  $n($$x1).append__T__jl_StringBuffer($as_T(this$1.substring(beginIndex)));
  var this$2 = $n(this.ju_regex_Matcher__f_inputstr);
  this.ju_regex_Matcher__f_appendPos = this$2.length;
  return sb
});
$c_ju_regex_Matcher.prototype.replaceFirst__T__T = (function(replacement) {
  this.reset__ju_regex_Matcher();
  if (this.find__Z()) {
    var sb = $ct_jl_StringBuffer__(new $c_jl_StringBuffer());
    this.appendReplacement__jl_StringBuffer__T__ju_regex_Matcher(sb, replacement);
    this.appendTail__jl_StringBuffer__jl_StringBuffer(sb);
    return sb.toString__T()
  } else {
    return this.ju_regex_Matcher__f_inputstr
  }
});
$c_ju_regex_Matcher.prototype.replaceAll__T__T = (function(replacement) {
  this.reset__ju_regex_Matcher();
  var sb = $ct_jl_StringBuffer__(new $c_jl_StringBuffer());
  while (this.find__Z()) {
    this.appendReplacement__jl_StringBuffer__T__ju_regex_Matcher(sb, replacement)
  };
  this.appendTail__jl_StringBuffer__jl_StringBuffer(sb);
  return sb.toString__T()
});
$c_ju_regex_Matcher.prototype.reset__ju_regex_Matcher = (function() {
  this.ju_regex_Matcher__f_regionStart0 = 0;
  $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0);
  this.ju_regex_Matcher__f_inputstr = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  return $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this)
});
$c_ju_regex_Matcher.prototype.start__I = (function() {
  return (($uI($p_ju_regex_Matcher__ensureLastMatch__O(this).index) + this.ju_regex_Matcher__f_regionStart0) | 0)
});
$c_ju_regex_Matcher.prototype.end__I = (function() {
  var $$x1 = this.start__I();
  var this$1 = $n(this.group__T());
  return (($$x1 + this$1.length) | 0)
});
$c_ju_regex_Matcher.prototype.group__T = (function() {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[0];
  return $as_T(x)
});
$c_ju_regex_Matcher.prototype.start__I__I = (function(group) {
  return $p_ju_regex_Matcher__startInternal__I__I(this, $n(this.ju_regex_Matcher__f_pattern0).numberedGroup__I__I(group))
});
$c_ju_regex_Matcher.prototype.end__I__I = (function(group) {
  return $p_ju_regex_Matcher__endInternal__I__I(this, $n(this.ju_regex_Matcher__f_pattern0).numberedGroup__I__I(group))
});
$c_ju_regex_Matcher.prototype.group__I__T = (function(group) {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[$n(this.ju_regex_Matcher__f_pattern0).numberedGroup__I__I(group)];
  return $as_T(((x !== (void 0)) ? x : null))
});
function $as_ju_regex_Matcher(obj) {
  return (((obj instanceof $c_ju_regex_Matcher) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.regex.Matcher"))
}
function $isArrayOf_ju_regex_Matcher(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_regex_Matcher)))
}
function $asArrayOf_ju_regex_Matcher(obj, depth) {
  return (($isArrayOf_ju_regex_Matcher(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.regex.Matcher;", depth))
}
var $d_ju_regex_Matcher = new $TypeData().initClass({
  ju_regex_Matcher: 0
}, false, "java.util.regex.Matcher", {
  ju_regex_Matcher: 1,
  O: 1,
  ju_regex_MatchResult: 1
});
$c_ju_regex_Matcher.prototype.$classData = $d_ju_regex_Matcher;
function $p_ju_regex_Pattern__indicesBuilder$lzycompute__ju_regex_IndicesBuilder($thiz) {
  if ((!$thiz.ju_regex_Pattern__f_bitmap$0)) {
    $thiz.ju_regex_Pattern__f_indicesBuilder = $m_ju_regex_IndicesBuilder$().apply__T__T__ju_regex_IndicesBuilder($thiz.ju_regex_Pattern__f_jsPattern, $thiz.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags);
    $thiz.ju_regex_Pattern__f_bitmap$0 = true
  };
  return $thiz.ju_regex_Pattern__f_indicesBuilder
}
function $p_ju_regex_Pattern__indicesBuilder__ju_regex_IndicesBuilder($thiz) {
  return ((!$thiz.ju_regex_Pattern__f_bitmap$0) ? $p_ju_regex_Pattern__indicesBuilder$lzycompute__ju_regex_IndicesBuilder($thiz) : $thiz.ju_regex_Pattern__f_indicesBuilder)
}
/** @constructor */
function $c_ju_regex_Pattern(_pattern, _flags, jsPattern, jsFlags, sticky, groupCount, groupNumberMap, namedGroups) {
  this.ju_regex_Pattern__f_indicesBuilder = null;
  this.ju_regex_Pattern__f__pattern = null;
  this.ju_regex_Pattern__f_jsPattern = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = false;
  this.ju_regex_Pattern__f_groupCount = 0;
  this.ju_regex_Pattern__f_groupNumberMap = null;
  this.ju_regex_Pattern__f_enabledNativeIndices = false;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = null;
  this.ju_regex_Pattern__f_jsRegExpForMatches = null;
  this.ju_regex_Pattern__f_bitmap$0 = false;
  this.ju_regex_Pattern__f__pattern = _pattern;
  this.ju_regex_Pattern__f_jsPattern = jsPattern;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = jsFlags;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = sticky;
  this.ju_regex_Pattern__f_groupCount = groupCount;
  this.ju_regex_Pattern__f_groupNumberMap = groupNumberMap;
  this.ju_regex_Pattern__f_enabledNativeIndices = false;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = new RegExp(jsPattern, (this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags + (this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky ? "gy" : "g")));
  this.ju_regex_Pattern__f_jsRegExpForMatches = new RegExp((("^(?:" + jsPattern) + ")$"), jsFlags)
}
$c_ju_regex_Pattern.prototype = new $h_O();
$c_ju_regex_Pattern.prototype.constructor = $c_ju_regex_Pattern;
/** @constructor */
function $h_ju_regex_Pattern() {
  /*<skip>*/
}
$h_ju_regex_Pattern.prototype = $c_ju_regex_Pattern.prototype;
$c_ju_regex_Pattern.prototype.execMatches__T__O = (function(input) {
  return this.ju_regex_Pattern__f_jsRegExpForMatches.exec(input)
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$execFindInternal__T__I__O = (function(input, start) {
  var regexp = this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind;
  regexp.lastIndex = start;
  return regexp.exec(input)
});
$c_ju_regex_Pattern.prototype.numberedGroup__I__I = (function(group) {
  if (((group < 0) || (group > this.ju_regex_Pattern__f_groupCount))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + group))
  };
  return $uI(this.ju_regex_Pattern__f_groupNumberMap[group])
});
$c_ju_regex_Pattern.prototype.getIndices__O__Z__O = (function(lastMatch, forMatches) {
  var x = lastMatch.indices;
  if ((x === (void 0))) {
    if ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsIndices) {
      if ((!this.ju_regex_Pattern__f_enabledNativeIndices)) {
        this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = new RegExp(this.ju_regex_Pattern__f_jsPattern, ((this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags + (this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky ? "gy" : "g")) + "d"));
        var $$x2 = RegExp;
        var jsPattern = this.ju_regex_Pattern__f_jsPattern;
        var $$x1 = new $$x2((("^(?:" + jsPattern) + ")$"), (this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags + "d"));
        this.ju_regex_Pattern__f_jsRegExpForMatches = $$x1;
        this.ju_regex_Pattern__f_enabledNativeIndices = true
      };
      var regexp = (forMatches ? this.ju_regex_Pattern__f_jsRegExpForMatches : this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind);
      regexp.lastIndex = $uI(lastMatch.index);
      lastMatch.indices = regexp.exec($as_T(lastMatch.input)).indices
    } else {
      lastMatch.indices = $n($p_ju_regex_Pattern__indicesBuilder__ju_regex_IndicesBuilder(this)).apply__Z__T__I__O(forMatches, $as_T(lastMatch.input), $uI(lastMatch.index))
    }
  };
  return lastMatch.indices
});
$c_ju_regex_Pattern.prototype.toString__T = (function() {
  return this.ju_regex_Pattern__f__pattern
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$split__T__I__AT = (function(inputStr, limit) {
  if ((inputStr === "")) {
    return new ($d_T.getArrayOf().constr)([""])
  } else {
    var lim = ((limit > 0) ? limit : 2147483647);
    var this$1 = $n(inputStr);
    var matcher = new $c_ju_regex_Matcher(this, this$1);
    var result = [];
    var prevEnd = 0;
    while ((($uI(result.length) < (((-1) + lim) | 0)) && matcher.find__Z())) {
      if ((matcher.end__I() !== 0)) {
        var this$2 = $n(inputStr);
        var beginIndex = prevEnd;
        var endIndex = matcher.start__I();
        if ((beginIndex < 0)) {
          $charAt(this$2, beginIndex)
        };
        if ((endIndex > this$2.length)) {
          $charAt(this$2, endIndex)
        };
        if ((endIndex < beginIndex)) {
          $charAt(this$2, (-1))
        };
        var $$x1 = result.push($as_T(this$2.substring(beginIndex, endIndex)));
        $uI($$x1)
      };
      prevEnd = matcher.end__I()
    };
    var this$3 = $n(inputStr);
    var beginIndex$1 = prevEnd;
    if (((beginIndex$1 < 0) || (beginIndex$1 > this$3.length))) {
      $charAt(this$3, beginIndex$1)
    };
    result.push($as_T(this$3.substring(beginIndex$1)));
    var actualLength = $uI(result.length);
    if ((limit === 0)) {
      while (true) {
        if ((actualLength !== 0)) {
          var x = result[(((-1) + actualLength) | 0)];
          var $$x2 = ((x !== null) && $dp_equals__O__Z($n(x), ""))
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          actualLength = (((-1) + actualLength) | 0)
        } else {
          break
        }
      }
    };
    var r = new ($d_T.getArrayOf().constr)(actualLength);
    var end = actualLength;
    var i = 0;
    while ((i < end)) {
      var i$2 = i;
      $n(r).set(i$2, $as_T(result[i$2]));
      i = ((1 + i) | 0)
    };
    return r
  }
});
var $d_ju_regex_Pattern = new $TypeData().initClass({
  ju_regex_Pattern: 0
}, false, "java.util.regex.Pattern", {
  ju_regex_Pattern: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_Pattern.prototype.$classData = $d_ju_regex_Pattern;
/** @constructor */
function $c_ju_regex_Pattern$() {
  /*<skip>*/
}
$c_ju_regex_Pattern$.prototype = new $h_O();
$c_ju_regex_Pattern$.prototype.constructor = $c_ju_regex_Pattern$;
/** @constructor */
function $h_ju_regex_Pattern$() {
  /*<skip>*/
}
$h_ju_regex_Pattern$.prototype = $c_ju_regex_Pattern$.prototype;
$c_ju_regex_Pattern$.prototype.java$util$regex$Pattern$$matches__T__T__Z = (function(regex, input) {
  var this$1 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  var this$2 = $n(input);
  return new $c_ju_regex_Matcher(this$1, this$2).matches__Z()
});
$c_ju_regex_Pattern$.prototype.quote__T__T = (function(s) {
  var result = "\\Q";
  var start = 0;
  var this$1 = $n(s);
  var fromIndex = start;
  var end = $uI(this$1.indexOf("\\E", fromIndex));
  while ((end >= 0)) {
    var $$x1 = result;
    var this$2 = $n(s);
    var beginIndex = start;
    var endIndex = end;
    if ((beginIndex < 0)) {
      $charAt(this$2, beginIndex)
    };
    if ((endIndex > this$2.length)) {
      $charAt(this$2, endIndex)
    };
    if ((endIndex < beginIndex)) {
      $charAt(this$2, (-1))
    };
    result = ((("" + $$x1) + $as_T(this$2.substring(beginIndex, endIndex))) + "\\E\\\\E\\Q");
    start = ((2 + end) | 0);
    var this$3 = $n(s);
    var fromIndex$1 = start;
    end = $uI(this$3.indexOf("\\E", fromIndex$1))
  };
  var $$x2 = result;
  var this$4 = $n(s);
  var beginIndex$1 = start;
  if (((beginIndex$1 < 0) || (beginIndex$1 > this$4.length))) {
    $charAt(this$4, beginIndex$1)
  };
  return ((("" + $$x2) + $as_T(this$4.substring(beginIndex$1))) + "\\E")
});
var $d_ju_regex_Pattern$ = new $TypeData().initClass({
  ju_regex_Pattern$: 0
}, false, "java.util.regex.Pattern$", {
  ju_regex_Pattern$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_Pattern$.prototype.$classData = $d_ju_regex_Pattern$;
var $n_ju_regex_Pattern$;
function $m_ju_regex_Pattern$() {
  if ((!$n_ju_regex_Pattern$)) {
    $n_ju_regex_Pattern$ = new $c_ju_regex_Pattern$()
  };
  return $n_ju_regex_Pattern$
}
function $sct_Llocales_cldr_data_LocalesProvider$__stinit__() {
  $m_sjs_reflect_Reflect$().registerLoadableModuleClass__T__jl_Class__sjs_js_Function0__V("locales.cldr.data.LocalesProvider$", $d_Llocales_cldr_data_LocalesProvider$.getClassOf(), (() => $m_Llocales_cldr_data_LocalesProvider$()))
}
/** @constructor */
function $c_Llocales_cldr_data_LocalesProvider$() {
  /*<skip>*/
}
$c_Llocales_cldr_data_LocalesProvider$.prototype = new $h_O();
$c_Llocales_cldr_data_LocalesProvider$.prototype.constructor = $c_Llocales_cldr_data_LocalesProvider$;
/** @constructor */
function $h_Llocales_cldr_data_LocalesProvider$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_LocalesProvider$.prototype = $c_Llocales_cldr_data_LocalesProvider$.prototype;
$c_Llocales_cldr_data_LocalesProvider$.prototype.root__Llocales_cldr_LDML = (function() {
  return $m_Llocales_cldr_data_\uff3froot$()
});
$c_Llocales_cldr_data_LocalesProvider$.prototype.ldmls__sci_Map = (function() {
  var $$x10 = $m_s_Predef$();
  $m_sc_ArrayOps$();
  var xs = $m_Llocales_cldr_data_\uff3fall\uff3f$().all__ALlocales_cldr_LDML();
  var f = ((x0$1$2) => {
    var x0$1 = $as_Llocales_cldr_LDML(x0$1$2);
    var this$3 = $n(x0$1);
    return $ct_T2__O__O__(new $c_T2(), $n(this$3.toLocale__ju_Locale()).toLanguageTag__T(), x0$1)
  });
  var len = $n(xs).u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $$x1 = i;
        var arg1 = $n(xs).get(i);
        ys.set($$x1, f(arg1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var $$x2 = i;
        var arg1$1 = $n(x3).get(i);
        ys.set($$x2, f(arg1$1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var $$x3 = i;
        var arg1$2 = $n(x4).get(i);
        ys.set($$x3, f(arg1$2));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var $$x4 = i;
        var t = $n(x5).get(i);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($$x4, f(new $c_RTLong(lo, hi)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var $$x5 = i;
        var arg1$3 = $n(x6).get(i);
        ys.set($$x5, f(arg1$3));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var $$x6 = i;
        var arg1$4 = $n(x7).get(i);
        ys.set($$x6, f($bC(arg1$4)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var $$x7 = i;
        var arg1$5 = $n(x8).get(i);
        ys.set($$x7, f(arg1$5));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var $$x8 = i;
        var arg1$6 = $n(x9).get(i);
        ys.set($$x8, f(arg1$6));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var $$x9 = i;
        var arg1$7 = $n(x10).get(i);
        ys.set($$x9, f(arg1$7));
        i = ((1 + i) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs)
    }
  };
  var this$7 = $n($n($$x10).wrapRefArray__AO__scm_ArraySeq$ofRef(ys));
  var this$6 = $m_s_$less$colon$less$();
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$7)
});
$c_Llocales_cldr_data_LocalesProvider$.prototype.latn__Llocales_cldr_NumberingSystem = (function() {
  return $m_Llocales_cldr_data_numericsystems$().latn__Llocales_cldr_NumberingSystem()
});
$c_Llocales_cldr_data_LocalesProvider$.prototype.currencyData__Llocales_cldr_CurrencyData = (function() {
  return new $c_Llocales_cldr_CurrencyData($m_Llocales_cldr_data_currencydata$().Llocales_cldr_data_currencydata$__f_currencyTypes, $m_Llocales_cldr_data_currencydata$().Llocales_cldr_data_currencydata$__f_fractions, $m_Llocales_cldr_data_currencydata$().Llocales_cldr_data_currencydata$__f_regions, $m_Llocales_cldr_data_currencydata$().Llocales_cldr_data_currencydata$__f_numericCodes)
});
$c_Llocales_cldr_data_LocalesProvider$.prototype.metadata__Llocales_cldr_CLDRMetadata = (function() {
  return new $c_Llocales_cldr_CLDRMetadata($m_Llocales_cldr_data_metadata$().isoCountries__AT(), $m_Llocales_cldr_data_metadata$().iso3Countries__sci_Map(), $m_Llocales_cldr_data_metadata$().isoLanguages__AT(), $m_Llocales_cldr_data_metadata$().iso3Languages__sci_Map(), $m_Llocales_cldr_data_metadata$().scripts__AT())
});
var $d_Llocales_cldr_data_LocalesProvider$ = new $TypeData().initClass({
  Llocales_cldr_data_LocalesProvider$: 0
}, false, "locales.cldr.data.LocalesProvider$", {
  Llocales_cldr_data_LocalesProvider$: 1,
  O: 1,
  Llocales_cldr_LocalesProvider: 1
});
$c_Llocales_cldr_data_LocalesProvider$.prototype.$classData = $d_Llocales_cldr_data_LocalesProvider$;
var $n_Llocales_cldr_data_LocalesProvider$;
function $m_Llocales_cldr_data_LocalesProvider$() {
  if ((!$n_Llocales_cldr_data_LocalesProvider$)) {
    $n_Llocales_cldr_data_LocalesProvider$ = new $c_Llocales_cldr_data_LocalesProvider$()
  };
  return $n_Llocales_cldr_data_LocalesProvider$
}
/** @constructor */
function $c_Llocales_cldr_fallback_LocalesProvider$() {
  /*<skip>*/
}
$c_Llocales_cldr_fallback_LocalesProvider$.prototype = new $h_O();
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.constructor = $c_Llocales_cldr_fallback_LocalesProvider$;
/** @constructor */
function $h_Llocales_cldr_fallback_LocalesProvider$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_LocalesProvider$.prototype = $c_Llocales_cldr_fallback_LocalesProvider$.prototype;
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.root__Llocales_cldr_LDML = (function() {
  return $m_Llocales_cldr_fallback_data_\uff3froot$()
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.ldmls__sci_Map = (function() {
  var $$x10 = $m_s_Predef$();
  $m_sc_ArrayOps$();
  var xs = $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$().all__ALlocales_cldr_LDML();
  var f = ((x0$1$2) => {
    var x0$1 = $as_Llocales_cldr_LDML(x0$1$2);
    var this$3 = $n(x0$1);
    return $ct_T2__O__O__(new $c_T2(), $n(this$3.toLocale__ju_Locale()).toLanguageTag__T(), x0$1)
  });
  var len = $n(xs).u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $$x1 = i;
        var arg1 = $n(xs).get(i);
        ys.set($$x1, f(arg1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var $$x2 = i;
        var arg1$1 = $n(x3).get(i);
        ys.set($$x2, f(arg1$1));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var $$x3 = i;
        var arg1$2 = $n(x4).get(i);
        ys.set($$x3, f(arg1$2));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var $$x4 = i;
        var t = $n(x5).get(i);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($$x4, f(new $c_RTLong(lo, hi)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var $$x5 = i;
        var arg1$3 = $n(x6).get(i);
        ys.set($$x5, f(arg1$3));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var $$x6 = i;
        var arg1$4 = $n(x7).get(i);
        ys.set($$x6, f($bC(arg1$4)));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var $$x7 = i;
        var arg1$5 = $n(x8).get(i);
        ys.set($$x7, f(arg1$5));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var $$x8 = i;
        var arg1$6 = $n(x9).get(i);
        ys.set($$x8, f(arg1$6));
        i = ((1 + i) | 0)
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var $$x9 = i;
        var arg1$7 = $n(x10).get(i);
        ys.set($$x9, f(arg1$7));
        i = ((1 + i) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs)
    }
  };
  var this$7 = $n($n($$x10).wrapRefArray__AO__scm_ArraySeq$ofRef(ys));
  var this$6 = $m_s_$less$colon$less$();
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$7)
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.latn__Llocales_cldr_NumberingSystem = (function() {
  return $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem()
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.currencyData__Llocales_cldr_CurrencyData = (function() {
  return new $c_Llocales_cldr_CurrencyData($as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()), $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()), $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()), $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()))
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.metadata__Llocales_cldr_CLDRMetadata = (function() {
  return new $c_Llocales_cldr_CLDRMetadata(new ($d_T.getArrayOf().constr)(0), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()), new ($d_T.getArrayOf().constr)(0), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()), new ($d_T.getArrayOf().constr)(0))
});
var $d_Llocales_cldr_fallback_LocalesProvider$ = new $TypeData().initClass({
  Llocales_cldr_fallback_LocalesProvider$: 0
}, false, "locales.cldr.fallback.LocalesProvider$", {
  Llocales_cldr_fallback_LocalesProvider$: 1,
  O: 1,
  Llocales_cldr_LocalesProvider: 1
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.$classData = $d_Llocales_cldr_fallback_LocalesProvider$;
var $n_Llocales_cldr_fallback_LocalesProvider$;
function $m_Llocales_cldr_fallback_LocalesProvider$() {
  if ((!$n_Llocales_cldr_fallback_LocalesProvider$)) {
    $n_Llocales_cldr_fallback_LocalesProvider$ = new $c_Llocales_cldr_fallback_LocalesProvider$()
  };
  return $n_Llocales_cldr_fallback_LocalesProvider$
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "DeliveryDate"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "DeliveryFormReference"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "InvoiceReference"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "ProductReference")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$())) {
        var $$x4 = 0
      } else if ((p === $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$())) {
        var $$x4 = 1
      } else if ((p === $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$())) {
        var $$x4 = 2
      } else {
        if ((p !== $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$())) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_analyze_cost_ReconciliationReportOrder($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "ProductReference"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "InvoiceReference"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "DeliveryFormReference"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "DeliveryDate"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$1
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$2 = new $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1($thiz);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$2
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$3
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$4
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$5
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$6 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$6
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$7 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$7
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$(x0$39$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      $as_Lshapeless_HNil(x0$40$2);
      return $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$8 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$8
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$9 = new $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2($thiz);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$9
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$(x0$47$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      $as_Lshapeless_HNil(x0$48$2);
      return $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$10 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$10
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$11$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$(x0$55$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      $as_Lshapeless_HNil(x0$56$2);
      return $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$11 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$11
}
function $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$(x0$63$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      $as_Lshapeless_HNil(x0$64$2);
      return $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$12 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$12
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1() {
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$1 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$2 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$3 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$4 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$5 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$6 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$7 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$8 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$9 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$10 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$11 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$12 = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0 = 0
}
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.constructor = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype;
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$1)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$2)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$3)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$4)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$5)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((32 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$6)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$7)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$8)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$9)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$10__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$10)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$11__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$11$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$11)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.inst$macro$12__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1__f_inst$macro$12)
});
var $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1: 0
}, false, "reactbuild.analyze.cost.ReconciliationReportOrder$anon$lazy$macro$13$1", {
  Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1.prototype.$classData = $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossSpec$() {
  this.Lreactbuild_analyze_cost_modules_CrossSpec$__f_buildingSiteName = null;
  this.Lreactbuild_analyze_cost_modules_CrossSpec$__f_buildingPart = null;
  this.Lreactbuild_analyze_cost_modules_CrossSpec$__f_supplier = null;
  $n_Lreactbuild_analyze_cost_modules_CrossSpec$ = this;
  this.Lreactbuild_analyze_cost_modules_CrossSpec$__f_buildingSiteName = new $c_Lreactbuild_analyze_cost_modules_CrossSpec("Chantier", new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_model_CommonData(x$1$2);
    var this$2 = $n($n(x$1).Lreactbuild_model_CommonData__f_buildingSites);
    var f = ((x$2$2) => {
      var x$2 = $as_Lreactbuild_common_model_Project(x$2$2);
      return $n($n(x$2).Lreactbuild_common_model_Project__f_archived).isEmpty__Z()
    });
    var l = this$2;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break
        } else {
          var h = $n(l).head__O();
          var t = $as_sci_List($n(l).tail__O());
          if (($uZ(f(h)) === false)) {
            l = t;
            continue
          };
          var start = l;
          var remaining = t;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block
            } else {
              var x = $n(remaining).head__O();
              if (($uZ(f(x)) !== false)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue
              };
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O())
              };
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f(head)) !== false)) {
                  next = $as_sci_List($n(next).tail__O())
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                  };
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O())
                }
              };
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy
              };
              var result = newHead;
              break block
            }
          }
        }
      }
    };
    return result
  })), new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_common_model_Project(x$3$2);
    return $n(x$3).Lreactbuild_common_model_Project__f_reference
  })), new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Lreactbuild_common_model_Project(x$4$2);
    return $n(x$4).Lreactbuild_common_model_Project__f__id
  })), new $c_sjsr_AnonFunction2(((page$2, detail$2) => {
    $as_Lreactbuild_model_InvoicePage(page$2);
    var detail = $as_Lreactbuild_model_InvoiceDetail(detail$2);
    return $n(detail).Lreactbuild_model_InvoiceDetail__f_buildingSite
  })), new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Ldiode_react_ModelProxy(x$5$2);
    var this$6 = $m_Lreactbuild_model_Implicits$();
    return $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$6, x$5)
  })), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_common_model_Project.getClassOf()));
  this.Lreactbuild_analyze_cost_modules_CrossSpec$__f_buildingPart = new $c_Lreactbuild_analyze_cost_modules_CrossSpec("Corps d'\u00e9tat", new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Lreactbuild_model_CommonData(x$6$2);
    return $n(x$6).Lreactbuild_model_CommonData__f_buildingParts
  })), new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Lreactbuild_model_BuildingPart(x$7$2);
    return $n(x$7).Lreactbuild_model_BuildingPart__f_label
  })), new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_Lreactbuild_model_BuildingPart(x$8$2);
    return $n(x$8).Lreactbuild_model_BuildingPart__f__id
  })), new $c_sjsr_AnonFunction2(((page$3$2, detail$3$2) => {
    $as_Lreactbuild_model_InvoicePage(page$3$2);
    var detail$3 = $as_Lreactbuild_model_InvoiceDetail(detail$3$2);
    return $n(detail$3).Lreactbuild_model_InvoiceDetail__f_tradeBody
  })), new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Ldiode_react_ModelProxy(x$9$2);
    var this$11 = $m_Lreactbuild_model_Implicits$();
    return $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$11, x$9)
  })), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_model_BuildingPart.getClassOf()));
  this.Lreactbuild_analyze_cost_modules_CrossSpec$__f_supplier = new $c_Lreactbuild_analyze_cost_modules_CrossSpec("Fournisseur", new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Lreactbuild_model_CommonData(x$10$2);
    return $n(x$10).Lreactbuild_model_CommonData__f_persons
  })), new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_Lreactbuild_person_Person(x$11$2);
    return $n(x$11).Lreactbuild_person_Person__f_name
  })), new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12 = $as_Lreactbuild_person_Person(x$12$2);
    return $n(x$12).Lreactbuild_person_Person__f__id
  })), new $c_sjsr_AnonFunction2(((page$4$2, detail$4$2) => {
    var page$4 = $as_Lreactbuild_model_InvoicePage(page$4$2);
    $as_Lreactbuild_model_InvoiceDetail(detail$4$2);
    return $n(page$4).Lreactbuild_model_InvoicePage__f_supplier
  })), new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13 = $as_Ldiode_react_ModelProxy(x$13$2);
    var this$16 = $m_Lreactbuild_model_Implicits$();
    return $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$16, x$13)
  })), new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_person_Person.getClassOf()))
}
$c_Lreactbuild_analyze_cost_modules_CrossSpec$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossSpec$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossSpec$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossSpec$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossSpec$.prototype = $c_Lreactbuild_analyze_cost_modules_CrossSpec$.prototype;
var $d_Lreactbuild_analyze_cost_modules_CrossSpec$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossSpec$: 0
}, false, "reactbuild.analyze.cost.modules.CrossSpec$", {
  Lreactbuild_analyze_cost_modules_CrossSpec$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossSpec$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossSpec$;
var $n_Lreactbuild_analyze_cost_modules_CrossSpec$;
function $m_Lreactbuild_analyze_cost_modules_CrossSpec$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_CrossSpec$)) {
    $n_Lreactbuild_analyze_cost_modules_CrossSpec$ = new $c_Lreactbuild_analyze_cost_modules_CrossSpec$()
  };
  return $n_Lreactbuild_analyze_cost_modules_CrossSpec$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6.prototype.empty__O = (function() {
  return $m_Lreactbuild_model_ListEntryType$Issue$()
});
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$$anon$6", {
  Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_Default: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$6;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7.prototype.parse__T__s_concurrent_Future = (function(value) {
  return $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_Exception__T__(new $c_jl_Exception(), "Pas de raccourcis pr\u00e9vu"))
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7.prototype.stringify__Lreactbuild_model_ListEntryType__s_concurrent_Future = (function(in$1) {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n($as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader($n($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_headers).apply__O__O(in$1))).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_title)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7.prototype.stringify__O__s_concurrent_Future = (function(in$1) {
  return this.stringify__Lreactbuild_model_ListEntryType__s_concurrent_Future($as_Lreactbuild_model_ListEntryType(in$1))
});
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$$anon$7", {
  Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$7;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8() {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8__f_itemTokenizer = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8__f_itemFetcher = null;
  $n($m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_Tokenizer);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_model_ListEntryType(v$2);
    return $n($as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader($n($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_headers).apply__O__O(v))).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_title
  }));
  var underlying = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8__f_itemTokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1(underlying, f);
  this.Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8__f_itemFetcher = new $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9(this)
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8.prototype.keyOf__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$36$2) => {
    var x$36 = $as_Lreactbuild_model_ListEntryType(x$36$2);
    return $n(x$36).toString__T()
  }))
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8.prototype.handleNonexistent__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((in$2) => {
    $as_T(in$2);
    return $m_s_None$()
  }))
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8.prototype.renderContainer__T__Z__Lcom_iz2use_react_components_internal_TextEditorContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(text, open, context) {
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  var focusHandler = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2();
  var fetcher = this.Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8__f_itemFetcher;
  var fetcherBackend = $m_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$();
  var filter = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
  var keyOf = this.keyOf__F1();
  var this$3 = $m_s_math_Equiv$();
  var equiv = this$3.universal__s_math_Equiv();
  var handleNonexistent = this.handleNonexistent__F1();
  var tokenMatcher = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
  var tokenizer = this.Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8__f_itemTokenizer;
  var h = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1();
  var highlighter = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3(h);
  var u = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder(text, open, context, focusHandler, fetcher, fetcherBackend, filter, keyOf, equiv, handleNonexistent, tokenMatcher, tokenizer, highlighter).apply__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction2(((i$2, v$2) => {
    $as_Lreactbuild_model_ListEntryType(i$2);
    var v = $as_sci_Seq(v$2);
    return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), v)
  })));
  var this$11 = $n(u);
  var n = this$11.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$$anon$8", {
  Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8: 1,
  O: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8;
function $f_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps__createEvent__Lreactbuild_model_ListEntry__Lreactbuild_model_ListEntryEventBody__Lreactbuild_model_ListEntryEvent($thiz, entry, body) {
  var x$1 = $n(entry)._id__Lreactbuild_common_model_RefTo();
  var x$2 = $n($thiz.context__Lreactbuild_analyze_cost_modules_EditListEntry$Context()).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_user;
  $m_Lreactbuild_model_ListEntryEvent$();
  $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
  var x$4 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
  $m_Lreactbuild_model_ListEntryEvent$();
  new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
  var $$x1 = $m_Ljava_time_Instant$();
  var this$8 = $m_RTLong$();
  var value = $uD(new Date().getTime());
  var lo = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var x$5 = $n($$x1).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
  return new $c_Lreactbuild_model_ListEntryEvent(x$4, x$1, x$5, x$2, body)
}
function $f_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps__saveNewEvent__Lreactbuild_model_ListEntryEventBody__F1($thiz, body) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($thiz.entryOpt__s_Option());
    var f = new $c_sjsr_AnonFunction1(((result$2) => {
      var result = $as_Lreactbuild_model_ListEntry(result$2);
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future(result)
    }));
    var this$19 = $n((this$2.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$2.get__O()))));
    var default$1 = new $c_sjsr_AnonFunction0((() => {
      var entry = $thiz.createEntry__Lreactbuild_model_ListEntry();
      var this$3 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x3 = new $c_Lautowire_ClientProxy(this$3).Lautowire_ClientProxy__f_self;
      var $$x2 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistListEntries"];
      var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$16 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$8 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$11 = $n(new $c_Lautowire_ClientProxy(this$8).Lautowire_ClientProxy__f_self);
      var this$9 = $m_sci_Nil$();
      var r = new $c_sci_$colon$colon(entry, this$9);
      $m_Lio_circe_Encoder$();
      var encodeA = $m_Lreactbuild_model_ListEntry$().Lreactbuild_model_ListEntry$__f_encodeListEntry;
      var evidence$2 = new $c_Lio_circe_Encoder$$anon$25(encodeA);
      var y = this$11.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
      var array$1 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      return $n($n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$16.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$17 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$18 = $n(new $c_Lautowire_ClientProxy(this$17).Lautowire_ClientProxy__f_self);
        var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$18.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$28$2) => {
        $as_jl_Void(x$28$2);
        return entry
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    return $as_s_concurrent_Future((this$19.isEmpty__Z() ? default$1.apply__O() : this$19.get__O()))
  })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue), new $c_sjsr_AnonFunction1(((entry$2) => {
    var entry$1 = $as_Lreactbuild_model_ListEntry(entry$2);
    var ev = $f_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps__createEvent__Lreactbuild_model_ListEntry__Lreactbuild_model_ListEntryEventBody__Lreactbuild_model_ListEntryEvent($thiz, entry$1, body);
    return $ct_T2__O__O__(new $c_T2(), entry$1, ev)
  }))), new $c_sjsr_AnonFunction1(((x$30$2) => {
    var x$30 = $as_T2(x$30$2);
    if ((x$30 !== null)) {
      var entry$3 = $as_Lreactbuild_model_ListEntry($n(x$30)._1__O());
      var ev$1 = $as_Lreactbuild_model_ListEntryEvent($n(x$30)._2__O());
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
        var this$20 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x7 = new $c_Lautowire_ClientProxy(this$20).Lautowire_ClientProxy__f_self;
        var $$x6 = $m_s_package$().s_package$__f_Seq;
        var array$2 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistListEntryEvents"];
        var $$x5 = $as_sci_Seq($n($$x6).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
        var this$33 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$25 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$28 = $n(new $c_Lautowire_ClientProxy(this$25).Lautowire_ClientProxy__f_self);
        var this$26 = $m_sci_Nil$();
        var r$1 = new $c_sci_$colon$colon(ev$1, this$26);
        $m_Lio_circe_Encoder$();
        var encodeA$1 = $m_Lreactbuild_model_ListEntryEvent$().Lreactbuild_model_ListEntryEvent$__f_codecForListEntryEvent;
        var evidence$2$1 = new $c_Lio_circe_Encoder$$anon$25(encodeA$1);
        var y$1 = this$28.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
        var array$3 = [$ct_T2__O__O__(new $c_T2(), "x", y$1)];
        var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        return $n($n($$x7).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x5, this$33.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
          var x$2 = $as_Lio_circe_Json(x$2$2);
          var this$34 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$35 = $n(new $c_Lautowire_ClientProxy(this$34).Lautowire_ClientProxy__f_self);
          var evidence$1$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
          this$35.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2, evidence$1$1)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue), new $c_sjsr_AnonFunction1(((x$29$2) => {
        $as_jl_Void(x$29$2);
        var this$36 = $n($thiz.history__sci_List());
        return new $c_Lreactbuild_model_WithChildren(entry$3, $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$36, ev$1)))
      })))
    } else {
      var $$x4;
      throw new $c_s_MatchError(x$30)
    };
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($$x4)
  })))
}
function $is_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps)))
}
function $as_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditListEntry$ExistingProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditListEntry$ExistingProps;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1(outer) {
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1.prototype = $c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1.prototype.apply__sci_List__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(updates, cb) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1__f_$outer).Lreactbuild_analyze_cost_modules_EntryList$Backend__f_reactbuild$analyze$cost$modules$EntryList$Backend$$$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_EntryList$Props(p$2);
    var this$3 = $n($n(p).Lreactbuild_analyze_cost_modules_EntryList$Props__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
    var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
    var arg1 = this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var lst = $as_sci_List(arg1);
    var this$4 = $n(updates);
    var acc = lst;
    var these = this$4;
    while ((!$n(these).isEmpty__Z())) {
      var arg1$1 = acc;
      var arg2 = $n(these).head__O();
      var lst$2 = $as_sci_List(arg1$1);
      var v = $as_Lreactbuild_model_WithChildren(arg2);
      var this$5 = $n(lst$2);
      _return: {
        var i = 0;
        var these$1 = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$5, 0, this$5);
        while (true) {
          var this$8 = $n(these$1);
          if ((!this$8.isEmpty__Z())) {
            var arg1$2 = $n(these$1).head__O();
            var x$3 = $as_Lreactbuild_model_WithChildren(arg1$2);
            var x = $n($as_Lreactbuild_model_ListEntry($n(x$3).Lreactbuild_model_WithChildren__f_item))._id__Lreactbuild_common_model_RefTo();
            var x$2 = $n($as_Lreactbuild_model_ListEntry($n(v).Lreactbuild_model_WithChildren__f_item))._id__Lreactbuild_common_model_RefTo();
            if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
              var x1 = i;
              break _return
            };
            i = ((1 + i) | 0);
            these$1 = $as_sc_LinearSeq($n(these$1).tail__O())
          } else {
            break
          }
        };
        var x1 = (-1)
      };
      if ((x1 === (-1))) {
        var this$9 = $n(lst$2);
        acc = new $c_sci_$colon$colon(v, this$9)
      } else {
        var this$11 = $n(lst$2);
        var this$10 = $m_sci_Nil$();
        var other = new $c_sci_$colon$colon(v, this$10);
        acc = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$11, x1, other, 1))
      };
      these = $as_sc_LinearSeq($n(these).tail__O())
    };
    var arg1$3 = $as_sci_List(acc);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$3), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
      $as_jl_Void(x$4$2)
    }));
    var this$13 = $n(this$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$13, f))
  })))
});
var $d_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1: 0
}, false, "reactbuild.analyze.cost.modules.EntryList$Backend$$anon$1", {
  Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_EntryList$Updater: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_FlatListItem$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_FlatListItem$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_FlatListItem$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_FlatListItem$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_FlatListItem$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_FlatListItem$.prototype = $c_Lreactbuild_analyze_cost_modules_FlatListItem$.prototype;
var $d_Lreactbuild_analyze_cost_modules_FlatListItem$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_FlatListItem$: 0
}, false, "reactbuild.analyze.cost.modules.FlatListItem$", {
  Lreactbuild_analyze_cost_modules_FlatListItem$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits: 1
});
$c_Lreactbuild_analyze_cost_modules_FlatListItem$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_FlatListItem$;
var $n_Lreactbuild_analyze_cost_modules_FlatListItem$;
function $m_Lreactbuild_analyze_cost_modules_FlatListItem$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_FlatListItem$)) {
    $n_Lreactbuild_analyze_cost_modules_FlatListItem$ = new $c_Lreactbuild_analyze_cost_modules_FlatListItem$()
  };
  return $n_Lreactbuild_analyze_cost_modules_FlatListItem$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3(value$2) {
  this.Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3__f_value$2 = null;
  this.Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3__f_value$2 = value$2
}
$c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3.prototype = $c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3.prototype;
$c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3.prototype.values__sci_Seq = (function() {
  var rassoc$5 = this.Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3__f_value$2;
  var this$1 = $m_sci_Nil$();
  return new $c_sci_$colon$colon(rassoc$5, this$1)
});
var $d_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3: 0
}, false, "reactbuild.analyze.cost.modules.FlatListItem$$anon$3", {
  Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_FlatListItem: 1
});
$c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4(optional$1, f$2) {
  this.Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4__f_optional$1 = null;
  this.Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4__f_f$2 = null;
  this.Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4__f_optional$1 = optional$1;
  this.Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4__f_f$2 = f$2
}
$c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4.prototype = $c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4.prototype;
$c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4.prototype.values__sci_Seq = (function() {
  var this$1 = $n($n(this.Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4__f_optional$1).toList__sci_List());
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = $n(rest).head__O();
    var it = $n($n($as_Lreactbuild_analyze_cost_modules_FlatListItem($n(this.Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4__f_f$2).apply__O__O(arg1))).values__sci_Seq()).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        $n(t).sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest = $as_sci_List($n(rest).tail__O())
  };
  return ((h === null) ? $m_sci_Nil$() : h)
});
var $d_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4: 0
}, false, "reactbuild.analyze.cost.modules.FlatListItem$$anon$4", {
  Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_FlatListItem: 1
});
$c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2(outer, f$1, value$1) {
  this.Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2__f_f$1 = null;
  this.Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2__f_value$1 = null;
  this.Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2__f_f$1 = f$1;
  this.Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2__f_value$1 = value$1
}
$c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2.prototype = $c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2.prototype;
$c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2.prototype.values__sci_Seq = (function() {
  var rassoc$4 = $n(this.Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2__f_f$1).apply__O__O(this.Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2__f_value$1);
  var this$1 = $m_sci_Nil$();
  return new $c_sci_$colon$colon(rassoc$4, this$1)
});
var $d_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2: 0
}, false, "reactbuild.analyze.cost.modules.FlatListItemLowPriorityImplicits$$anon$2", {
  Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_FlatListItem: 1
});
$c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$() {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$__f_unknown = null;
  $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$ = this;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$__f_unknown = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_unknown, $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$(), "en attente d'action", ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty), ($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$(), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0()))
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$.prototype.fromSingleton__Lreactbuild_model_ListEntryEventBody__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__T2 = (function(body, iconSource, color, name, lineDecoration) {
  var this$1 = $n(body);
  var self = $objectGetClass(this$1);
  var y = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(iconSource, color, name, lineDecoration, $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).pure__O__F0(body));
  return $ct_T2__O__O__(new $c_T2(), self, y)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$.prototype.fromPrompt__T__F1__Lcom_iz2use_react_components_IconSource__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__Ljapgolly_scalajs_react_vdom_TagMod__Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType = (function(prompt, body, iconSource, color, name, lineDecoration) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).prompt__T__Ljapgolly_scalajs_react_callback_Trampoline(prompt);
  var this$1 = $m_s_$less$colon$less$();
  var this$ = $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$1.s_$less$colon$less$__f_singleton);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_T(v$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).pure__O__F0($n(body).apply__O__O(v)))
  }));
  return new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(iconSource, color, name, lineDecoration, $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, f))
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$EventType$", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$;
var $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$;
function $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$)) {
    $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$ = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$.prototype.fromEvents__s_PartialFunction__F2 = (function(pf) {
  return new $c_sjsr_AnonFunction2(((events$2, user$2) => {
    var events = $as_sci_List(events$2);
    $as_Lreactbuild_common_model_RefTo(user$2);
    var reversed = $n(events).reverse__sci_List();
    var this$2 = $n(reversed);
    var pf$1 = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1(pf);
    var $$x2 = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this$2, pf$1);
    var $$x1 = $m_s_None$();
    var this$3 = $n(reversed);
    var pf$2 = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2(pf);
    return new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary($$x2, $$x1, $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this$3, pf$2))
  }))
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$HistorySummary$", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$;
var $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$;
function $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$)) {
    $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$ = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$() {
  this.Lreactbuild_analyze_cost_modules_MapLogic$Init$__f_reuseInit = null;
  $n_Lreactbuild_analyze_cost_modules_MapLogic$Init$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_MapLogic$Init$__f_reuseInit = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2())
}
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_MapLogic$Init$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_MapLogic$Init$.prototype = $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$.prototype;
var $d_Lreactbuild_analyze_cost_modules_MapLogic$Init$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_MapLogic$Init$: 0
}, false, "reactbuild.analyze.cost.modules.MapLogic$Init$", {
  Lreactbuild_analyze_cost_modules_MapLogic$Init$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_MapLogic$Init$;
var $n_Lreactbuild_analyze_cost_modules_MapLogic$Init$;
function $m_Lreactbuild_analyze_cost_modules_MapLogic$Init$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_MapLogic$Init$)) {
    $n_Lreactbuild_analyze_cost_modules_MapLogic$Init$ = new $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$()
  };
  return $n_Lreactbuild_analyze_cost_modules_MapLogic$Init$
}
function $is_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState)))
}
function $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$DetailState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.PersonDetailViewHandler$DetailState;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1(outer, router$1) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1__f_router$1 = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1__f_router$1 = router$1
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1.prototype.apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_vdom_TagOf = (function(invoicePageRef) {
  var $$x1 = $n($n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$()).toNewWindow__T__Z__Z__Ljapgolly_scalajs_react_vdom_TagOf($n($n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1__f_router$1).urlFor__O__Ljapgolly_scalajs_react_extra_router_AbsUrl(new $c_Lreactbuild_Loc$Processing(new $c_s_Some(invoicePageRef)))).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value, ($n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$()), true), ($n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$()), false)));
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("afficher"))];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1.prototype.apply__O__Ljapgolly_scalajs_react_vdom_TagMod = (function(value) {
  return this.apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_vdom_TagOf($as_Lreactbuild_common_model_RefTo(value))
});
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$DocumentLineList$$anon$1", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_Viewable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Projects$$anon$1(pageProps$1, viewState$1) {
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$1__f_pageProps$1 = null;
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$1__f_viewState$1 = null;
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$1__f_pageProps$1 = pageProps$1;
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$1__f_viewState$1 = viewState$1
}
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Projects$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Projects$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Projects$$anon$1.prototype = $c_Lreactbuild_analyze_cost_modules_Projects$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$1.prototype.render__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(item, moveAction) {
  var u = $m_Lreactbuild_analyze_cost_modules_RenderProject$().apply__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_callback_Trampoline__Ldiode_data_Pot__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(this.Lreactbuild_analyze_cost_modules_Projects$$anon$1__f_pageProps$1, this.Lreactbuild_analyze_cost_modules_Projects$$anon$1__f_viewState$1, item);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_analyze_cost_modules_Projects$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Projects$$anon$1: 0
}, false, "reactbuild.analyze.cost.modules.Projects$$anon$1", {
  Lreactbuild_analyze_cost_modules_Projects$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_RenderItem: 1
});
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Projects$$anon$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Projects$$anon$2() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$2.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$2.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Projects$$anon$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Projects$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Projects$$anon$2.prototype = $c_Lreactbuild_analyze_cost_modules_Projects$$anon$2.prototype;
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$2.prototype.render__Lreactbuild_common_model_Project__Lcom_iz2use_react_components_internal_multiview_grid_GridItem = (function(project) {
  var this$1 = $n($n(project).Lreactbuild_common_model_Project__f__id);
  var $$x27 = $m_sr_ScalaRunTime$()._toString__s_Product__T(this$1);
  var this$2 = $n($n($n(project).Lreactbuild_common_model_Project__f_images).headOption__s_Option());
  if (this$2.isEmpty__Z()) {
    var $$x26 = $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var x$10 = $as_Lreactbuild_common_model_Image(arg1);
    var $$x26 = new $c_s_Some($n(x$10).fullPath__T__T($m_Lreactbuild_package$().Lreactbuild_package$__f_scheme))
  };
  var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$5 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_ribbonWrapper;
  var $$x23 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s);
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$8 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_ribbon;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$8, s$1), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" D\u00e9j\u00e0 vendu ! "))];
  var array$1 = [$$x23, $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var this$18 = $n($n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
  var this$17 = $n(project);
  var condition = $n(this$17.Lreactbuild_common_model_Project__f_soldOut).contains__O__Z(true);
  var $$x25 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$18, condition);
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$21 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x20 = this$21.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$22 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x19 = this$22.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$23 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).justifyContent__Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$());
  var $$x18 = this$23.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("space-between", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$26 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_dontOverflow;
  var $$x16 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$26, s$2);
  var this$29 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var o = $n(project).Lreactbuild_common_model_Project__f_city;
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_T(v$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
  }));
  var array$2 = [$$x16, $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$29, o, O, f)];
  var $$x15 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x14 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$37 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_dontOverflow;
  var $$x12 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$37, s$3);
  var this$40 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var o$1 = $n(project).Lreactbuild_common_model_Project__f_district;
  var O$1 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var f$1 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_T(v$3$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
  }));
  var array$3 = [$$x12, $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$40, o$1, O$1, f$1)];
  var array$4 = [$$x20, $$x19, $$x18, $$x15, $$x14, $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var $$x11 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$49 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x9 = this$49.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$50 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x8 = this$50.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$51 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).justifyContent__Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$());
  var $$x7 = this$51.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("space-between", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$54 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_dontOverflow;
  var $$x5 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$54, s$4);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$1 = $n(project).Lreactbuild_common_model_Project__f_title;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$5 = [$$x5, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
  var $$x4 = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$64 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
  var $$x1 = this$64.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$4 = $n(project).Lreactbuild_common_model_Project__f_reference;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$6 = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
  var array$7 = [$$x9, $$x8, $$x7, $$x4, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
  var array$8 = [$$x11, $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  return new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem($$x27, $$x26, $$x25, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
});
var $d_Lreactbuild_analyze_cost_modules_Projects$$anon$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Projects$$anon$2: 0
}, false, "reactbuild.analyze.cost.modules.Projects$$anon$2", {
  Lreactbuild_analyze_cost_modules_Projects$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_grid_GridRenderable: 1
});
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$2.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Projects$$anon$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Projects$$anon$3(pageProps$2) {
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$3__f_pageProps$2 = null;
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$3__f_pageProps$2 = pageProps$2
}
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$3.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$3.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Projects$$anon$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Projects$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Projects$$anon$3.prototype = $c_Lreactbuild_analyze_cost_modules_Projects$$anon$3.prototype;
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$3.prototype.render__Ldiode_data_Pot__Ljapgolly_scalajs_react_vdom_VdomElement = (function(items) {
  var u = $m_Lreactbuild_analyze_cost_modules_project_CompareProjects$().apply__Ldiode_data_Pot__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(items, this.Lreactbuild_analyze_cost_modules_Projects$$anon$3__f_pageProps$2);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_analyze_cost_modules_Projects$$anon$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Projects$$anon$3: 0
}, false, "reactbuild.analyze.cost.modules.Projects$$anon$3", {
  Lreactbuild_analyze_cost_modules_Projects$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_RenderCompare: 1
});
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$3.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Projects$$anon$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1() {
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_id = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_name = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_havingChoice = false;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_id = "buildingSite";
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_name = "Chantier";
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_havingChoice = true
}
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.id__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_id
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.symbol__s_Symbol = (function() {
  var this$1 = $m_s_Symbol$();
  return $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "buildingSite"))
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.name__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_name
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.havingChoice__Z = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_havingChoice
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.label__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable = (function(proxy) {
  var this$1 = $m_Lreactbuild_model_Implicits$();
  return $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$1, proxy)
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.actives__Lreactbuild_analyze_cost_modules_ReportContext__sci_Seq = (function(ctx) {
  var this$1 = $n(ctx);
  var arg1 = this$1.proxy__Ldiode_react_ModelProxy();
  var $$x2 = $m_sci_SortedSet$();
  var $$x1 = $as_sci_Seq($n($n(ctx).timeReports__sci_Seq()).map__F1__O(new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13 = $as_Lreactbuild_model_TimeReport(x$13$2);
    return $n(x$13).Lreactbuild_model_TimeReport__f_buildingSite
  }))));
  var this$4 = $m_Lreactbuild_model_Implicits$();
  var this$3 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$3, arg1);
  return $n($as_sc_IterableOnceOps($n($$x2).apply__sci_Seq__O__O($$x1, $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$4, ev)))).toSeq__sci_Seq()
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.editor__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_VdomNode = (function(done, proxy) {
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1__f_name;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value = $m_s_None$();
  var state = $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var _2 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1);
    matchEnd8: {
      var $$x2;
      var cb = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((x0$1 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x0$1);
        var p4 = $as_s_Option($n(x3).s_Some__f_value);
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v$1 = $as_Lreactbuild_common_model_RefTo($n(x5).s_Some__f_value);
          var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(done).apply__O__O(v$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb);
          break matchEnd8
        }
      };
      var cb$2 = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x2 = cb$2
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  })));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$6 = $m_Lreactbuild_model_Implicits$();
  var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$6, proxy);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$7 = $m_Lreactbuild_model_Implicits$();
  var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$7, proxy);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$11 = $m_Lreactbuild_model_Implicits$();
  var this$10 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$10, proxy);
  var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$11, ev);
  return editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$1, explainError, equiv)
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.extract__Lreactbuild_model_TimeReport__O = (function(timeReport) {
  return $n(timeReport).Lreactbuild_model_TimeReport__f_buildingSite
});
var $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1: 0
}, false, "reactbuild.analyze.cost.modules.ReportFieldSpec$$anon$1", {
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ReportFieldSpec: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2() {
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_id = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_name = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_havingChoice = false;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_id = "buildingStage";
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_name = "Stade construction";
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_havingChoice = true
}
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.id__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_id
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.symbol__s_Symbol = (function() {
  var this$1 = $m_s_Symbol$();
  return $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "buildingStage"))
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.name__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_name
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.havingChoice__Z = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_havingChoice
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.label__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable = (function(proxy) {
  $m_Lcom_iz2use_common_Textualizable$();
  var this$1 = $m_Lreactbuild_model_Implicits$();
  var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$1, proxy);
  return new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable)
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.actives__Lreactbuild_analyze_cost_modules_ReportContext__sci_Seq = (function(ctx) {
  var this$1 = $n(ctx);
  var arg1 = this$1.proxy__Ldiode_react_ModelProxy();
  var $$x3 = $m_sci_SortedSet$();
  var $$x2 = $as_sci_Seq($n($n(ctx).timeReports__sci_Seq()).map__F1__O(new $c_sjsr_AnonFunction1(((x$17$2) => {
    var x$17 = $as_Lreactbuild_model_TimeReport(x$17$2);
    return $n(x$17).Lreactbuild_model_TimeReport__f_buildingStage
  }))));
  var $$x1 = $m_Lreactbuild_model_Implicits$();
  var this$3 = $m_Lreactbuild_model_Implicits$();
  var ord = $n($$x1).buildingStageRefOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering($f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$3, arg1));
  return $n($as_sc_IterableOnceOps($n($$x3).apply__sci_Seq__O__O($$x2, new $c_s_math_Ordering$O$1(ord)))).toSeq__sci_Seq()
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.editor__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_VdomNode = (function(done, proxy) {
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2__f_name;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value = $m_s_None$();
  var state = $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var _2 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1);
    matchEnd6: {
      var $$x2;
      var cb = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((x0$1 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x0$1);
        var v$1 = $as_s_Option($n(x3).s_Some__f_value);
        var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(done).apply__O__O(v$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb);
        break matchEnd6
      };
      var cb$2 = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x2 = cb$2
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  })));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$7 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization = $m_s_None$();
  var ev = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$17(this$7, proxy, organization);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$9 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization$1 = $m_s_None$();
  var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$17(this$9, proxy, organization$1);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var $$x3 = $m_Lreactbuild_model_Implicits$();
  var this$12 = $m_Lreactbuild_model_Implicits$();
  var equiv = $n($$x3).buildingStageRefOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering($f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$12, proxy));
  return editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv)
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.extract__Lreactbuild_model_TimeReport__O = (function(timeReport) {
  return $n(timeReport).Lreactbuild_model_TimeReport__f_buildingStage
});
var $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2: 0
}, false, "reactbuild.analyze.cost.modules.ReportFieldSpec$$anon$2", {
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ReportFieldSpec: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3() {
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_id = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_name = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_havingChoice = false;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_id = "resource";
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_name = "Ressource";
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_havingChoice = true
}
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.id__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_id
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.symbol__s_Symbol = (function() {
  var this$1 = $m_s_Symbol$();
  return $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "resource"))
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.name__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_name
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.havingChoice__Z = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_havingChoice
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.label__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable = (function(proxy) {
  var this$1 = $m_Lreactbuild_model_Implicits$();
  return $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$1, proxy)
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.actives__Lreactbuild_analyze_cost_modules_ReportContext__sci_Seq = (function(ctx) {
  var this$1 = $n(ctx);
  var arg1 = this$1.proxy__Ldiode_react_ModelProxy();
  var $$x2 = $m_sci_SortedSet$();
  var $$x1 = $as_sci_Seq($n($n(ctx).timeReports__sci_Seq()).map__F1__O(new $c_sjsr_AnonFunction1(((x$19$2) => {
    var x$19 = $as_Lreactbuild_model_TimeReport(x$19$2);
    return $n(x$19).Lreactbuild_model_TimeReport__f_resource
  }))));
  var this$4 = $m_Lreactbuild_model_Implicits$();
  var this$3 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$3, arg1);
  return $n($as_sc_IterableOnceOps($n($$x2).apply__sci_Seq__O__O($$x1, $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$4, ev)))).toSeq__sci_Seq()
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.editor__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_VdomNode = (function(done, proxy) {
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3__f_name;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value = $m_s_None$();
  var state = $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var _2 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1);
    matchEnd8: {
      var $$x2;
      var cb = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((x0$1 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x0$1);
        var p4 = $as_s_Option($n(x3).s_Some__f_value);
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v$1 = $as_Lreactbuild_common_model_RefTo($n(x5).s_Some__f_value);
          var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(done).apply__O__O(v$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb);
          break matchEnd8
        }
      };
      var cb$2 = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x2 = cb$2
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  })));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$7 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization = $m_s_None$();
  var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$21(this$7, proxy, organization);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$9 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization$1 = $m_s_None$();
  var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$21(this$9, proxy, organization$1);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$13 = $m_Lreactbuild_model_Implicits$();
  var this$12 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$12, proxy);
  var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$13, ev);
  return editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$1, explainError, equiv)
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.extract__Lreactbuild_model_TimeReport__O = (function(timeReport) {
  return $n(timeReport).Lreactbuild_model_TimeReport__f_resource
});
var $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3: 0
}, false, "reactbuild.analyze.cost.modules.ReportFieldSpec$$anon$3", {
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ReportFieldSpec: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4() {
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_dateRef = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_id = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_name = null;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_havingChoice = false;
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_id = "date";
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_name = "Date";
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_havingChoice = false;
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljava_time_LocalDate$();
    return this$2.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
  }));
  this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_dateRef = new $c_Lcom_iz2use_common_ParsingReference$Simple(f)
}
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.id__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_id
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.symbol__s_Symbol = (function() {
  var this$1 = $m_s_Symbol$();
  return $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "date"))
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.name__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_name
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.havingChoice__Z = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_havingChoice
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.label__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable = (function(proxy) {
  return $m_Lreactbuild_analyze_cost_modules_ReportFieldSpec$().Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_localDateTextualizable
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.actives__Lreactbuild_analyze_cost_modules_ReportContext__sci_IndexedSeq = (function(ctx) {
  var this$1 = $n($n($n(ctx).periodRange__Lreactbuild_analyze_cost_modules_PeriodRange()).Lreactbuild_analyze_cost_modules_PeriodRange__f_days);
  return this$1
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.editor__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_VdomNode = (function(done, proxy) {
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_name;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value = $m_s_None$();
  var state = $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var _2 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1);
    matchEnd8: {
      var $$x2;
      var cb = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((x0$1 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x0$1);
        var p4 = $as_s_Option($n(x3).s_Some__f_value);
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v$1 = $as_Ljava_time_LocalDate($n(x5).s_Some__f_value);
          var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(done).apply__O__O(v$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb);
          break matchEnd8
        }
      };
      var cb$2 = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x2 = cb$2
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  })));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  $m_Lcom_iz2use_common_Parsable$();
  var reference = this.Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4__f_dateRef;
  var parser = new $c_Lcom_iz2use_common_Parsable$$anon$4(reference);
  var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$8 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$8);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  return editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv)
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.actives__Lreactbuild_analyze_cost_modules_ReportContext__sci_Seq = (function(reportContext) {
  return this.actives__Lreactbuild_analyze_cost_modules_ReportContext__sci_IndexedSeq(reportContext)
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.extract__Lreactbuild_model_TimeReport__O = (function(timeReport) {
  return $n(timeReport).Lreactbuild_model_TimeReport__f_date
});
var $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4: 0
}, false, "reactbuild.analyze.cost.modules.ReportFieldSpec$$anon$4", {
  Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ReportFieldSpec: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFieldSpec$$anon$4;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5(outer) {
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5.prototype.timeReports__sci_Seq = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5__f_$outer).Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  var this$3 = $n($n($as_Lreactbuild_analyze_cost_modules_ReportFragment$State($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2))).Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports);
  return $as_sci_Seq((this$3.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$3.get__O()))
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5.prototype.proxy__Ldiode_react_ModelProxy = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5__f_$outer).Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  return $n($as_Lreactbuild_analyze_cost_modules_ReportFragment$Props($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2))).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_proxy
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5.prototype.periodRange__Lreactbuild_analyze_cost_modules_PeriodRange = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5__f_$outer).Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  return $n($as_Lreactbuild_analyze_cost_modules_ReportFragment$Props($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2))).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange
});
var $d_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragment$Backend$$anon$5", {
  Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ReportContext: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6(outer) {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6.prototype.timeReports__sci_Seq = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6__f_$outer).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  return $n($as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2))).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState__f_selectedTimeReports
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6.prototype.proxy__Ldiode_react_ModelProxy = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6__f_$outer).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  return $n($as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2))).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_proxy
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6.prototype.periodRange__Lreactbuild_analyze_cost_modules_PeriodRange = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6__f_$outer).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  return $n($as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2))).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_periodRange
});
var $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragmentGroup$TypedBackend$$anon$6", {
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ReportContext: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6;
function $is_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState)))
}
function $as_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ResourceDetailViewHandler$DetailState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ResourceDetailViewHandler$DetailState;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$() {
  this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$__f_reusableMonthRange = null;
  $n_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start
  }));
  var r = $m_Lreactbuild_model_Implicits$().reusabilityLocalDate__F2();
  this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$__f_reusableMonthRange = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$.prototype.fromDate__Ljava_time_LocalDate__I__Lreactbuild_analyze_cost_modules_hometimereport_MonthRange = (function(date, monthCount) {
  var hi = (monthCount >> 31);
  var d = $n($n(date).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(monthCount, hi))).withDayOfMonth__I__Ljava_time_LocalDate(1);
  return new $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(d, $n($n(d).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(1, 0))).minusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)))
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.MonthRange$", {
  Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$.prototype.cellToTagMod__Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell__Ljapgolly_scalajs_react_vdom_TagMod = (function(v) {
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$1 = $n($n(v).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell__f_date);
  var v$1 = ("" + $p_Ljava_time_LocalDate__day__S(this$1));
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$Cell$", {
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$__f_decodeDocumentResponse = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$ = this;
  var inst$macro$12 = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1().inst$macro$1__Lio_circe_generic_decoding_DerivedDecoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$__f_decodeDocumentResponse = $as_Lio_circe_Decoder(decode.value__O())
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$DocumentResponse$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_decoding_DerivedDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "writingMaterials"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "archiveUrl")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse(x0$3$2);
      if ((x0$3 !== null)) {
        var writingMaterials$macro$8 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_writingMaterials;
        var archiveUrl$macro$9 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_archiveUrl;
        return new $c_Lshapeless_$colon$colon(writingMaterials$macro$8, new $c_Lshapeless_$colon$colon(archiveUrl$macro$9, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var writingMaterials$macro$6 = $as_sci_Map($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var archiveUrl$macro$7 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse(writingMaterials$macro$6, archiveUrl$macro$7)
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "archiveUrl"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "writingMaterials"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_decoding_ReprDecoder()));
    var decode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_inst$macro$1 = new $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1(decode, gen$1);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_inst$macro$1
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_inst$macro$10 = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6($thiz);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_inst$macro$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_inst$macro$10 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_bitmap$0 = 0
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1.prototype.inst$macro$1__Lio_circe_generic_decoding_DerivedDecoder = (function() {
  return (((((1 & this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_decoding_DerivedDecoder(this) : this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_inst$macro$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1.prototype.inst$macro$10__Lio_circe_generic_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_decoding_ReprDecoder(this) : this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1__f_inst$macro$10)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$DocumentResponse$anon$lazy$macro$11$1", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$__f_decodeFeatureRequest = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$ = this;
  var inst$macro$8 = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1().inst$macro$1__Lio_circe_generic_decoding_DerivedDecoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$8));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$__f_decodeFeatureRequest = $as_Lio_circe_Decoder(decode.value__O())
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequest$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__inst$macro$1$lzycompute__Lio_circe_generic_decoding_DerivedDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "features")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest(x0$3$2);
      if ((x0$3 !== null)) {
        var features$macro$5 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest__f_features;
        return new $c_Lshapeless_$colon$colon(features$macro$5, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var features$macro$4 = $as_sci_List($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest(features$macro$4)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "features"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lio_circe_generic_decoding_ReprDecoder()));
    var decode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_inst$macro$1 = new $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1(decode, gen$1);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_inst$macro$1
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__inst$macro$6$lzycompute__Lio_circe_generic_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_inst$macro$6 = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3($thiz);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_inst$macro$6
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_inst$macro$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_inst$macro$6 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_bitmap$0 = 0
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1.prototype.inst$macro$1__Lio_circe_generic_decoding_DerivedDecoder = (function() {
  return (((((1 & this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__inst$macro$1$lzycompute__Lio_circe_generic_decoding_DerivedDecoder(this) : this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_inst$macro$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1.prototype.inst$macro$6__Lio_circe_generic_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__inst$macro$6$lzycompute__Lio_circe_generic_decoding_ReprDecoder(this) : this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1__f_inst$macro$6)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequest$anon$lazy$macro$7$1", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$__f_decodeFeatureRequestEntry = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$ = this;
  var inst$macro$8 = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2().inst$macro$1__Lio_circe_generic_decoding_DerivedDecoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$8));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$__f_decodeFeatureRequestEntry = $as_Lio_circe_Decoder(decode.value__O())
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntry$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__inst$macro$1$lzycompute__Lio_circe_generic_decoding_DerivedDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "properties")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry(x0$3$2);
      if ((x0$3 !== null)) {
        var properties$macro$5 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry__f_properties;
        return new $c_Lshapeless_$colon$colon(properties$macro$5, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var properties$macro$4 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry(properties$macro$4)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "properties"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lio_circe_generic_decoding_ReprDecoder()));
    var decode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_inst$macro$1 = new $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1(decode, gen$1);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_inst$macro$1
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__inst$macro$6$lzycompute__Lio_circe_generic_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_inst$macro$6 = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4($thiz);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_inst$macro$6
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_inst$macro$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_inst$macro$6 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_bitmap$0 = 0
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2.prototype.inst$macro$1__Lio_circe_generic_decoding_DerivedDecoder = (function() {
  return (((((1 & this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__inst$macro$1$lzycompute__Lio_circe_generic_decoding_DerivedDecoder(this) : this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_inst$macro$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2.prototype.inst$macro$6__Lio_circe_generic_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__inst$macro$6$lzycompute__Lio_circe_generic_decoding_ReprDecoder(this) : this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2__f_inst$macro$6)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntry$anon$lazy$macro$7$2", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$__f_decodeFeatureRequestEntryProperties = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$ = this;
  var inst$macro$8 = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3().inst$macro$1__Lio_circe_generic_decoding_DerivedDecoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$8));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$__f_decodeFeatureRequestEntryProperties = $as_Lio_circe_Decoder(decode.value__O())
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntryProperties$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__inst$macro$1$lzycompute__Lio_circe_generic_decoding_DerivedDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties(x0$3$2);
      if ((x0$3 !== null)) {
        var id$macro$5 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties__f_id;
        return new $c_Lshapeless_$colon$colon(id$macro$5, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var id$macro$4 = $as_T($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties(id$macro$4)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lio_circe_generic_decoding_ReprDecoder()));
    var decode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_inst$macro$1 = new $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1(decode, gen$1);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_inst$macro$1
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__inst$macro$6$lzycompute__Lio_circe_generic_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_inst$macro$6 = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5($thiz);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_inst$macro$6
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3() {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_inst$macro$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_inst$macro$6 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_bitmap$0 = 0
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3.prototype.inst$macro$1__Lio_circe_generic_decoding_DerivedDecoder = (function() {
  return (((((1 & this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__inst$macro$1$lzycompute__Lio_circe_generic_decoding_DerivedDecoder(this) : this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_inst$macro$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3.prototype.inst$macro$6__Lio_circe_generic_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__inst$macro$6$lzycompute__Lio_circe_generic_decoding_ReprDecoder(this) : this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3__f_inst$macro$6)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntryProperties$anon$lazy$macro$7$3", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3;
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__source$lzycompute__Ltypings_ol_sourceVectorMod$default($thiz) {
  if ((!$thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_bitmap$0)) {
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorSourceOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var value = new $c_sjsr_AnonFunction2(((extent$2, resolution$2) => {
      var resolution = $uD(resolution$2);
      $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_LoadingStrategy);
      return $i_ol$002floadingstrategy.bbox(extent$2, resolution)
    }));
    var value$1 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value);
    _\uff3fobj.strategy = value$1;
    var value$2 = (function(arg1$2, arg2$2, arg3$2, arg4$2, arg5$2) {
      var arg2 = $uD(arg2$2);
      $thiz.reactbuild$analyze$cost$modules$mapview$LayerLibrary$ReactbuildLayer$$$anonfun$source$2__sjs_js_$bar__sjs_js_Tuple4__D__Ltypings_ol_projProjectionMod$default__sjs_js_Function1__sjs_js_Function0__V(this, arg1$2, arg2, arg3$2, arg4$2, arg5$2)
    });
    _\uff3fobj.loader = value$2;
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_source = new ($moduleDefault($i_ol$002fsource$002fVector))(_\uff3fobj);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_bitmap$0 = true
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_source
}
function $ct_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__Lio_circe_Decoder__($thiz, evidence$1) {
  $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_evidence$1 = evidence$1;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__($thiz);
  var $$x2 = $i_ol$002fformat.GeoJSON;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeoJSONOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var a = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj;
  _\uff3fobj.dataProjection = a;
  var a$1 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_MercatorProj;
  _\uff3fobj.featureProjection = a$1;
  var $$x1 = new $$x2(_\uff3fobj);
  $thiz.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_format = $$x1;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_source = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_evidence$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_format = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_bitmap$0 = false
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype.buildUrl__T__sjs_js_Tuple4__Lorg_scalajs_dom_URL = (function(projection, extent) {
  var url = new URL(this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_baseUrl, $as_T(window.location.href));
  $n($m_s_package$().s_package$__f_List);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "srsname", projection);
  var this$5 = new $c_T4(extent[0], extent[1], extent[2], extent[3]);
  var this$7 = new $c_sr_ScalaRunTime$$anon$1(this$5);
  var y = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$7, "", ",", "");
  var array = [$$x1, $ct_T2__O__O__(new $c_T2(), "bbox", y)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$14 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var p = new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
    var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
    return (check$ifrefutable$1 !== null)
  }));
  var this$15 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this$14, p);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T2(x$1$2);
    if ((x$1 !== null)) {
      var k = $as_T($n(x$1)._1__O());
      var v = $as_T($n(x$1)._2__O());
      url.searchParams.append(k, v)
    } else {
      throw new $c_s_MatchError(x$1)
    }
  }));
  $n(this$15.filtered__sc_Iterable()).foreach__F1__V(f);
  return url
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype.convertFeature__sjs_js_$bar__Ltypings_ol_featureMod$default = (function(featureLike) {
  $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$();
  $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$();
  var value = featureLike.get("data");
  if ((value !== (void 0))) {
    var obj = $m_Lio_circe_scalajs_package$().decodeJs__sjs_js_Any__Lio_circe_Decoder__s_util_Either(value, this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_evidence$1);
    var this$8 = $n(obj);
    var data = new $c_s_util_Either$RightProjection(this$8).get__O();
    featureLike.set("data", data);
    featureLike.setId(("" + $n($as_Lreactbuild_common_model_RefTo($n(this.idOf__F1()).apply__O__O(data))).Lreactbuild_common_model_RefTo__f_id))
  };
  return featureLike
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype.getData__sjs_js_$bar__O = (function(feature) {
  return feature.get("data")
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype.setData__sjs_js_$bar__O__V = (function(feature, value) {
  feature.set("data", value)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype.source__Ltypings_ol_sourceVectorMod$default = (function() {
  return ((!this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_bitmap$0) ? $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__source$lzycompute__Ltypings_ol_sourceVectorMod$default(this) : this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_source)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer.prototype.reactbuild$analyze$cost$modules$mapview$LayerLibrary$ReactbuildLayer$$$anonfun$source$2__sjs_js_$bar__sjs_js_Tuple4__D__Ltypings_ol_projProjectionMod$default__sjs_js_Function1__sjs_js_Function0__V = (function(self, extent, resolution, projection, success, failure) {
  var $$x1 = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj.getCode());
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections);
  var a = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj;
  var url = $dp_toString__T($n(this.buildUrl__T__sjs_js_Tuple4__Lorg_scalajs_dom_URL($$x1, $i_ol$002fproj.transformExtent(extent, projection, a))));
  var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
  var p = fetch(url, (() => {
    var outer = null;
    outer = this;
    var this$11 = {};
    var a$1 = $m_Lorg_scalajs_dom_RequestCredentials$().Lorg_scalajs_dom_RequestCredentials$__f_include;
    this$11.credentials = a$1;
    return this$11
  })());
  var future = $n($n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((res$2) => {
    var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
    var p$1 = res$2.json();
    return $n($n($$x3).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((json$2) => {
      var array = this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_format.readFeatures(json$2);
      var len = $uI(array.length);
      var res = new Array(len);
      var i = 0;
      while ((i < len)) {
        var $$x4 = i;
        var arg1 = array[i];
        res[$$x4] = this.convertFeature__sjs_js_$bar__Ltypings_ol_featureMod$default(arg1);
        i = ((1 + i) | 0)
      };
      return res
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
  $n(future).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_util_Try(x0$1$2);
    if ((x0$1 instanceof $c_s_util_Success)) {
      var x2 = $as_s_util_Success(x0$1);
      var results = $n(x2).s_util_Success__f_value;
      this.source__Ltypings_ol_sourceVectorMod$default().addFeatures(($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$(), results));
      $as_jl_Void(success(($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$(), results)))
    } else if ((x0$1 instanceof $c_s_util_Failure)) {
      var x3 = $as_s_util_Failure(x0$1);
      var exception = $n(x3).s_util_Failure__f_exception;
      failure();
      throw ((exception instanceof $c_sjs_js_JavaScriptException) ? exception.sjs_js_JavaScriptException__f_exception : $n(exception))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory$() {
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_reusabilityMapCategory = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_list = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_MapCategory$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_reusabilityMapCategory = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard = new $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory("Risques & al\u00e9as");
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological = new $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory("G\u00e9ologiques");
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision = new $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory("Limites administratives");
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap = new $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory("Fond de carte");
  $n($m_s_package$().s_package$__f_List);
  var array = [this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap, this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision, this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_Geological, this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_list = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapCategory$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapCategory$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_MapCategory$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapCategory$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapCategory$", {
  Lreactbuild_analyze_cost_modules_mapview_MapCategory$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapCategory$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapCategory$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapCategory$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapCategory$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapCategory$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapImports$() {
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ControlOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CollectionOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CircleStyleOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_DrawOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TranslateOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ModifyOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Extent = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_MapBrowserEventType = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_SnapOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_InteractionOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeoJSONOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeolocationOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageLayerOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageWMSOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_LoadingStrategy = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_MapOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OSMOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OverviewMapOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ScaleLineOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ScaleLineUnits = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileDebugOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileLayerOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_WMTSOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorSourceOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ViewOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_AnimationOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_WMSServerType = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TextOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Util = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_XYZOptions = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_MapImports$ = this;
  $moduleDefault($i_ol$002fproj$002fUnits);
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ControlOptions = $m_Ltypings_ol_controlControlMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CollectionOptions = $m_Ltypings_ol_collectionMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_CircleStyleOptions = $m_Ltypings_ol_styleCircleMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_DrawOptions = $m_Ltypings_ol_interactionDrawMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TranslateOptions = $m_Ltypings_ol_interactionTranslateMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ModifyOptions = $m_Ltypings_ol_interactionModifyMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Extent = $m_Ltypings_ol_extentMod$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_MapBrowserEventType = $moduleDefault($i_ol$002fMapBrowserEventType);
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions = $m_Ltypings_ol_styleFillMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_SnapOptions = $m_Ltypings_ol_interactionSnapMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_InteractionOptions = $m_Ltypings_ol_interactionInteractionMod$InteractionOptions$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType = $moduleDefault($i_ol$002fgeom$002fGeometryType);
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeoJSONOptions = $m_Ltypings_ol_formatGeoJSONMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeolocationOptions = $m_Ltypings_ol_geolocationMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageLayerOptions = $m_Ltypings_ol_layerBaseImageMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageWMSOptions = $m_Ltypings_ol_sourceImageWMSMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_LoadingStrategy = $m_Ltypings_ol_loadingstrategyMod$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_MapOptions = $m_Ltypings_ol_pluggableMapMod$MapOptions$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings = $m_Ltypings_ol_olStrings$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OSMOptions = $m_Ltypings_ol_sourceOsmMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OverviewMapOptions = $m_Ltypings_ol_controlOverviewMapMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections = $m_Ltypings_ol_projMod$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ScaleLineOptions = $m_Ltypings_ol_controlScaleLineMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ScaleLineUnits = $i_ol$002fcontrol$002fScaleLine.Units;
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions = $m_Ltypings_ol_styleStrokeMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions = $m_Ltypings_ol_styleStyleMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileDebugOptions = $m_Ltypings_ol_sourceTileDebugMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileLayerOptions = $m_Ltypings_ol_layerBaseTileMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_WMTSOptions = $m_Ltypings_ol_sourceWmtsMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions = $m_Ltypings_ol_layerBaseVectorMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorSourceOptions = $m_Ltypings_ol_sourceVectorMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ViewOptions = $m_Ltypings_ol_viewMod$ViewOptions$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_AnimationOptions = $m_Ltypings_ol_viewMod$AnimationOptions$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_WMSServerType = $moduleDefault($i_ol$002fsource$002fWMSServerType);
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TextOptions = $m_Ltypings_ol_styleTextMod$Options$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Util = $m_Ltypings_ol_utilMod$();
  this.Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_XYZOptions = $m_Ltypings_ol_sourceXyzMod$Options$()
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapImports$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapImports$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapImports$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapImports$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$.prototype.updateFeatureList__Ltypings_ol_sourceVectorMod$default__sci_Seq__V = (function(source, features) {
  var lastFeatures = source.getFeatures();
  var toRemove = $m_sjs_js_ArrayOps$().diff$extension__sjs_js_Array__sci_Seq__sjs_js_Array(lastFeatures, features);
  var toAdd = $as_sci_Seq($n(features).diff__sc_Seq__O($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), lastFeatures)));
  if ((!$uZ(source.isEmpty()))) {
    var len = $uI(toRemove.length);
    var res = new Array(len);
    var i = 0;
    while ((i < len)) {
      var $$x1 = i;
      var arg1 = toRemove[i];
      res[$$x1] = $ct_T2__O__O__(new $c_T2(), arg1, arg1);
      i = ((1 + i) | 0)
    };
    var p = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_T2(x$1$2);
      if ((x$1 !== null)) {
        var f = $n(x$1)._2__O();
        return $uZ(source.hasFeature(f))
      } else {
        throw new $c_s_MatchError(x$1)
      }
    }));
    var this$7 = new $c_sjs_js_ArrayOps$WithFilter(p, res);
    var len$1 = $uI(this$7.sjs_js_ArrayOps$WithFilter__f_xs.length);
    var i$1 = 0;
    while ((i$1 < len$1)) {
      var x = this$7.sjs_js_ArrayOps$WithFilter__f_xs[i$1];
      if ($uZ($n(this$7.sjs_js_ArrayOps$WithFilter__f_p).apply__O__O(x))) {
        var x$2 = $as_T2(x);
        if ((x$2 !== null)) {
          var f$1 = $n(x$2)._2__O();
          source.removeFeature(f$1)
        } else {
          throw new $c_s_MatchError(x$2)
        }
      };
      i$1 = ((1 + i$1) | 0)
    }
  };
  $n(toAdd).foreach__F1__V(new $c_sjsr_AnonFunction1(((feature$3$2) => {
    source.addFeature(feature$3$2)
  })))
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$.prototype.cloneObject__O__O = (function(v) {
  return v.clone()
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapImports$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapImports$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapImports$", {
  Lreactbuild_analyze_cost_modules_mapview_MapImports$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_MapImports: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapImports$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapImports$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapImports$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapImports$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapImports$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapImports$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapImports$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$() {
  $n_Lreactbuild_analyze_cost_modules_mapview_MapSearch$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_mapview_MapSearch(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_input
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapSearch$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapSearch$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$.prototype.equivMapSearch__s_math_Equiv = (function() {
  return $n($m_s_package$().s_package$__f_Equiv).by__F1__s_math_Equiv__s_math_Equiv(new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_analyze_cost_modules_mapview_MapSearch(x$2$2);
    return $n(x$2).Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_input
  })), $m_s_math_Equiv$String$())
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapSearch$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapSearch$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapSearch$", {
  Lreactbuild_analyze_cost_modules_mapview_MapSearch$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapSearch$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapSearch$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapSearch$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapSearch$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapSearch$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapSearch$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$.prototype.parse__T__s_concurrent_Future = (function(in$1) {
  var x1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapSearchParser$().apply__T__Lfastparse_Parsed(in$1);
  if ((x1 instanceof $c_Lfastparse_Parsed$Success)) {
    var x2 = $as_Lfastparse_Parsed$Success(x1);
    var r = $as_s_Product($n(x2).Lfastparse_Parsed$Success__f_value);
    return $m_s_concurrent_Future$().successful__O__s_concurrent_Future(new $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch(in$1, $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery(r)))
  };
  if ((x1 instanceof $c_Lfastparse_Parsed$Failure)) {
    var x4 = $as_Lfastparse_Parsed$Failure(x1);
    var o11 = $m_Lfastparse_Parsed$Failure$().unapply__Lfastparse_Parsed$Failure__s_Option(x4);
    if ((!$n(o11).isEmpty__Z())) {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future(new $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch(in$1, new $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other(in$1, x4)))
    }
  };
  throw new $c_s_MatchError(x1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$.prototype.stringify__O__s_concurrent_Future = (function(in$1) {
  var in$2 = $as_Lreactbuild_analyze_cost_modules_mapview_MapSearch(in$1);
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n(in$2).Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_input)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapSearch$parsableMapSearch$", {
  Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$;
var $n_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$;
function $m_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$ = new $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_MapSearch$parsableMapSearch$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null
}
$c_Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo.prototype;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_Parcel$() {
  this.Lreactbuild_analyze_cost_modules_mapview_Parcel$__f_reusabilityParcel = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_Parcel$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_mapview_Parcel(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  this.Lreactbuild_analyze_cost_modules_mapview_Parcel$__f_reusabilityParcel = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
}
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_Parcel$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_Parcel$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_Parcel$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_Parcel$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_Parcel$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_Parcel$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.Parcel$", {
  Lreactbuild_analyze_cost_modules_mapview_Parcel$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_Parcel$;
var $n_Lreactbuild_analyze_cost_modules_mapview_Parcel$;
function $m_Lreactbuild_analyze_cost_modules_mapview_Parcel$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_Parcel$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_Parcel$ = new $c_Lreactbuild_analyze_cost_modules_mapview_Parcel$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_Parcel$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField$1, witnessK$1, convertRest$1) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_convertField$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_witnessK$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_convertRest$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_convertField$1 = convertField$1;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_witnessK$1 = witnessK$1;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_convertRest$1 = convertRest$1
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10.prototype.fromDatabase__sjs_js_Any__Lshapeless_$colon$colon = (function(item) {
  new $c_Lshapeless_labelled$FieldBuilder();
  var $$x1 = $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_convertField$1);
  var key = $n($as_s_Symbol($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_witnessK$1).value__O())).s_Symbol__f_name;
  if ((!$uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(item, key)))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  };
  var v = $n($$x1).from__sjs_js_Any__O(item[key]);
  var l = $as_Lshapeless_HList($n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_convertRest$1).value__O())).fromDatabase__sjs_js_Any__O(item));
  return new $c_Lshapeless_syntax_HListOps(l).$colon$colon__O__Lshapeless_$colon$colon(v)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10.prototype.toDatabase__Lshapeless_$colon$colon__sjs_js_Dictionary = (function(item) {
  var obj = $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_convertRest$1).value__O())).toDatabase__O__sjs_js_Dictionary($n(item).Lshapeless_$colon$colon__f_tail);
  var fieldValue = $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_convertField$1).to__O__sjs_js_Any($n(item).Lshapeless_$colon$colon__f_head);
  var key = $n($as_s_Symbol($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10__f_witnessK$1).value__O())).s_Symbol__f_name;
  obj[key] = fieldValue;
  return obj
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10.prototype.toDatabase__O__sjs_js_Dictionary = (function(item) {
  return this.toDatabase__Lshapeless_$colon$colon__sjs_js_Dictionary($as_Lshapeless_$colon$colon(item))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10.prototype.fromDatabase__sjs_js_Any__O = (function(item) {
  return this.fromDatabase__sjs_js_Any__Lshapeless_$colon$colon(item)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.AccumulatingStoreConverter$$anon$10", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9.prototype.toDatabase__O__sjs_js_Dictionary = (function(item) {
  $as_Lshapeless_HNil(item);
  return {}
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9.prototype.fromDatabase__sjs_js_Any__O = (function(item) {
  return $m_Lshapeless_HNil$()
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.AccumulatingStoreConverter$$anon$9", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12.prototype.upgrade__Lorg_scalajs_dom_IDBDatabase__V = (function(db) {
  /*<skip>*/
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12.prototype.put__O__s_reflect_ClassTag__Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction__s_concurrent_Future = (function(item, ct, transaction) {
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12.prototype.getAll__s_reflect_ClassTag__Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction__s_concurrent_Future = (function(ct, transaction) {
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.CoproductSchemaBuilder$$anon$12", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13(witK$1, builderR$1, ctV$1, converterV$2) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_witK$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_builderR$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_ctV$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_converterV$2 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_witK$1 = witK$1;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_builderR$1 = builderR$1;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_ctV$1 = ctV$1;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_converterV$2 = converterV$2
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13.prototype.name__T = (function() {
  return $n($as_s_Symbol($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_witK$1).value__O())).s_Symbol__f_name
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13.prototype.upgrade__Lorg_scalajs_dom_IDBDatabase__V = (function(db) {
  var $$x1 = this.name__T();
  var a = (() => {
    var outer = null;
    outer = this;
    var this$1 = {};
    this$1.keyPath = null;
    this$1.keyPath = "_id";
    return this$1
  })();
  db.createObjectStore($$x1, a);
  $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_builderR$1).upgrade__Lorg_scalajs_dom_IDBDatabase__V(db)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13.prototype.getAll__s_reflect_ClassTag__Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction__s_concurrent_Future = (function(ct, transaction) {
  var x$2 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_ctV$1;
  if (((ct === null) ? (x$2 === null) : $n(ct).equals__O__Z(x$2))) {
    var $$x1 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$();
    var qual$1 = $n(transaction).objectStore__T__Lorg_scalajs_dom_IDBObjectStore(this.name__T());
    return $n($n($$x1).promiseIDBRequest__Lorg_scalajs_dom_IDBRequest__s_concurrent_Future(qual$1.getAll())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((arr$2) => {
      var len = $uI(arr$2.length);
      var res = new Array(len);
      var i = 0;
      while ((i < len)) {
        var $$x2 = i;
        var arg1 = arr$2[i];
        res[$$x2] = $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_converterV$2).fromDatabase__sjs_js_Any__O(arg1);
        i = ((1 + i) | 0)
      };
      return res
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
  } else {
    return $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_builderR$1).getAll__s_reflect_ClassTag__Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction__s_concurrent_Future(ct, transaction)
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13.prototype.put__O__s_reflect_ClassTag__Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction__s_concurrent_Future = (function(item, ct, transaction) {
  var x$2 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_ctV$1;
  if (((ct === null) ? (x$2 === null) : $n(ct).equals__O__Z(x$2))) {
    var $$x1 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$();
    var qual$1 = $n(transaction).objectStore__T__Lorg_scalajs_dom_IDBObjectStore(this.name__T());
    var x$1 = $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_converterV$2).toDatabase__O__sjs_js_Any(item);
    return $n($n($$x1).promiseIDBRequest__Lorg_scalajs_dom_IDBRequest__s_concurrent_Future(qual$1.put(x$1))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$3$2) => (void 0))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
  } else {
    return $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13__f_builderR$1).put__O__s_reflect_ClassTag__Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction__s_concurrent_Future(item, ct, transaction)
  }
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.CoproductSchemaBuilder$$anon$13", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1.prototype.from__sjs_js_Any__Ltypings_ol_geomPointMod$default = (function(item) {
  return new ($moduleDefault($i_ol$002fgeom$002fPoint))(item)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1.prototype.to__Ltypings_ol_geomPointMod$default__sjs_js_Any = (function(item) {
  return item.getCoordinates()
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1.prototype.to__O__sjs_js_Any = (function(item) {
  return this.to__Ltypings_ol_geomPointMod$default__sjs_js_Any(item)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1.prototype.from__sjs_js_Any__O = (function(item) {
  return this.from__sjs_js_Any__Ltypings_ol_geomPointMod$default(item)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.FieldConverter$$anon$1", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2.prototype.from__sjs_js_Any__Lreactbuild_common_model_RefTo = (function(item) {
  var name = $as_T(item);
  return new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().fromString__T__ju_UUID(name))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2.prototype.to__Lreactbuild_common_model_RefTo__sjs_js_Any = (function(item) {
  var s = $n($n(item).Lreactbuild_common_model_RefTo__f_id).toString__T();
  return s
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2.prototype.to__O__sjs_js_Any = (function(item) {
  return this.to__Lreactbuild_common_model_RefTo__sjs_js_Any($as_Lreactbuild_common_model_RefTo(item))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2.prototype.from__sjs_js_Any__O = (function(item) {
  return this.from__sjs_js_Any__Lreactbuild_common_model_RefTo(item)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.FieldConverter$$anon$2", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3.prototype.to__O__sjs_js_Any = (function(item) {
  var item$1 = $as_T(item);
  return item$1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3.prototype.from__sjs_js_Any__O = (function(item) {
  return $as_T(item)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.FieldConverter$$anon$3", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4.prototype.to__O__sjs_js_Any = (function(item) {
  return item
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4.prototype.from__sjs_js_Any__O = (function(item) {
  return item
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.FieldConverter$$anon$4", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$4;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5.prototype.to__O__sjs_js_Any = (function(item) {
  var item$1 = $uD(item);
  return item$1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5.prototype.from__sjs_js_Any__O = (function(item) {
  return $uD(item)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.FieldConverter$$anon$5", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$5;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6.prototype.to__O__sjs_js_Any = (function(item) {
  var item$1 = $as_Ljava_time_Instant(item);
  var t = $n(item$1).toEpochMilli__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6.prototype.from__sjs_js_Any__O = (function(item) {
  var this$1 = $m_RTLong$();
  var value = $uD(item);
  var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return $m_Ljava_time_Instant$().ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.FieldConverter$$anon$6", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$6;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7(convertA$1) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7__f_convertA$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7__f_convertA$1 = convertA$1
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7.prototype.from__sjs_js_Any__s_Option = (function(item) {
  if ((item === (void 0))) {
    var value = (void 0)
  } else {
    var a = $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7__f_convertA$1).from__sjs_js_Any__O(item);
    var value = a
  };
  return ((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7.prototype.to__s_Option__sjs_js_Any = (function(item) {
  var this$1 = $n(item);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var $$x1 = new $c_s_Some($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7__f_convertA$1).to__O__sjs_js_Any(arg1))
  };
  var this$2 = $n($$x1);
  if (this$2.isEmpty__Z()) {
    var $$x2 = $m_sjs_js_Any$();
    var this$4 = $m_s_$less$colon$less$();
    return $n($$x2).undefOr2jsAny__sjs_js_$bar__F1__sjs_js_Any((void 0), this$4.s_$less$colon$less$__f_singleton)
  } else {
    return this$2.get__O()
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7.prototype.to__O__sjs_js_Any = (function(item) {
  return this.to__s_Option__sjs_js_Any($as_s_Option(item))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7.prototype.from__sjs_js_Any__O = (function(item) {
  return this.from__sjs_js_Any__s_Option(item)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.FieldConverter$$anon$7", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8(convertA$2) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8__f_convertA$2 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8__f_convertA$2 = convertA$2
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8.prototype.from__sjs_js_Any__O = (function(item) {
  return $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8__f_convertA$2).value__O())).fromDatabase__sjs_js_Any__O(item)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8.prototype.to__O__sjs_js_Any = (function(item) {
  return $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8__f_convertA$2).value__O())).toDatabase__O__sjs_js_Any(item)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.FieldConverter$$anon$8", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$__f_converterFeature = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$ = this;
  var this$1 = $m_s_Symbol$();
  var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
  var this$2 = $m_s_Symbol$();
  var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "file"));
  var this$3 = $m_s_Symbol$();
  var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "position"));
  var this$4 = $m_s_Symbol$();
  var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "geolocation"));
  var this$5 = $m_s_Symbol$();
  var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "orientation"));
  var this$6 = $m_s_Symbol$();
  var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "instant")), $m_Lshapeless_HNil$()))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
  var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
    var x0$3 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(x0$3$2);
    if ((x0$3 !== null)) {
      var _id$macro$19 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f__id;
      var file$macro$20 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_file;
      var position$macro$21 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_position;
      var geolocation$macro$22 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_geolocation;
      var orientation$macro$23 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_orientation;
      var instant$macro$24 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_instant;
      return new $c_Lshapeless_$colon$colon(_id$macro$19, new $c_Lshapeless_$colon$colon(file$macro$20, new $c_Lshapeless_$colon$colon(position$macro$21, new $c_Lshapeless_$colon$colon(geolocation$macro$22, new $c_Lshapeless_$colon$colon(orientation$macro$23, new $c_Lshapeless_$colon$colon(instant$macro$24, $m_Lshapeless_HNil$()))))))
    } else {
      throw new $c_s_MatchError(x0$3)
    }
  }));
  var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
    var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
    if ((x0$4 !== null)) {
      var _id$macro$13 = $as_Lreactbuild_common_model_RefTo($n(x0$4).Lshapeless_$colon$colon__f_head);
      var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
      if ((p2 !== null)) {
        var file$macro$14 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
        var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
        if ((p3 !== null)) {
          var position$macro$15 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
          var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
          if ((p4 !== null)) {
            var geolocation$macro$16 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
            var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
            if ((p5 !== null)) {
              var orientation$macro$17 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
              var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
              if ((p6 !== null)) {
                var instant$macro$18 = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
                var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p7)) {
                  return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(_id$macro$13, file$macro$14, position$macro$15, geolocation$macro$16, orientation$macro$17, instant$macro$18)
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$4)
  }));
  var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$10 = $m_s_Symbol$();
  var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "instant"));
  new $c_Lshapeless_Witness$$anon$1(value0);
  var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
  $m_Lshapeless_Witness$();
  var this$13 = $m_s_Symbol$();
  var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "orientation"));
  new $c_Lshapeless_Witness$$anon$1(value0$1);
  var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
  $m_Lshapeless_Witness$();
  var this$16 = $m_s_Symbol$();
  var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "geolocation"));
  new $c_Lshapeless_Witness$$anon$1(value0$2);
  var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
  $m_Lshapeless_Witness$();
  var this$19 = $m_s_Symbol$();
  var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "position"));
  new $c_Lshapeless_Witness$$anon$1(value0$3);
  var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
  $m_Lshapeless_Witness$();
  var this$22 = $m_s_Symbol$();
  var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "file"));
  new $c_Lshapeless_Witness$$anon$1(value0$4);
  var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
  $m_Lshapeless_Witness$();
  var this$25 = $m_s_Symbol$();
  var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$5);
  var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
  var this$28 = $m_s_$less$colon$less$();
  var ev = this$28.s_$less$colon$less$__f_singleton;
  var genericV = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
  var inst$macro$141 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1().inst$macro$25__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$141));
  var converterV = new $c_Lshapeless_Lazy$$anon$1(t);
  var ev$1 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11(genericV, converterV);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$__f_converterFeature = ev$1
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.LocalData$Feature$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$25$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((1 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    var convertField = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$33__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$25 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$25
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$33$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((2 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "file"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    var convertA = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2();
    var convertField = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7(convertA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$33 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$33
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$42$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((4 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "position"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    var convertA = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$1();
    var convertField = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7(convertA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$45__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$42 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$42
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$45$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((8 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "geolocation"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$47__Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter()));
    var convertA = new $c_Lshapeless_Lazy$$anon$1(t);
    var convertA$1 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8(convertA);
    var convertField = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7(convertA$1);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$97__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$45 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$45
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$47$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter($thiz) {
  if (((16 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "latitude"));
    var this$2 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "longitude"));
    var this$3 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "accuracy"));
    var this$4 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "altitude"));
    var this$5 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "altitudeAccuracy"));
    var this$6 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "heading"));
    var this$7 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "speed"));
    var this$8 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "timestamp")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(x0$15$2);
      if ((x0$15 !== null)) {
        var latitude$macro$72 = $n(x0$15).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_latitude;
        var longitude$macro$73 = $n(x0$15).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_longitude;
        var accuracy$macro$74 = $n(x0$15).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_accuracy;
        var altitude$macro$75 = $n(x0$15).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitude;
        var altitudeAccuracy$macro$76 = $n(x0$15).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitudeAccuracy;
        var heading$macro$77 = $n(x0$15).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_heading;
        var speed$macro$78 = $n(x0$15).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_speed;
        var timestamp$macro$79 = $n(x0$15).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_timestamp;
        return new $c_Lshapeless_$colon$colon(latitude$macro$72, new $c_Lshapeless_$colon$colon(longitude$macro$73, new $c_Lshapeless_$colon$colon(accuracy$macro$74, new $c_Lshapeless_$colon$colon(altitude$macro$75, new $c_Lshapeless_$colon$colon(altitudeAccuracy$macro$76, new $c_Lshapeless_$colon$colon(heading$macro$77, new $c_Lshapeless_$colon$colon(speed$macro$78, new $c_Lshapeless_$colon$colon(timestamp$macro$79, $m_Lshapeless_HNil$()))))))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var latitude$macro$64 = $uD($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var longitude$macro$65 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var accuracy$macro$66 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var altitude$macro$67 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var altitudeAccuracy$macro$68 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var heading$macro$69 = $uD($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var speed$macro$70 = $uD($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var timestamp$macro$71 = $uD($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p9)) {
                        return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(latitude$macro$64, longitude$macro$65, accuracy$macro$66, altitude$macro$67, altitudeAccuracy$macro$68, heading$macro$69, speed$macro$70, timestamp$macro$71)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "timestamp"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "speed"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "heading"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "altitudeAccuracy"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "altitude"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "accuracy"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "longitude"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "latitude"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    var this$36 = $m_s_$less$colon$less$();
    var ev = this$36.s_$less$colon$less$__f_singleton;
    var genericV = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$80__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var converterV = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$47 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11(genericV, converterV);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$47
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$80$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((32 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "latitude"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$82__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$80 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$80
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$82$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((64 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "longitude"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$84__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$82 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$82
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$84$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((128 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "accuracy"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$86__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$84 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$84
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$86$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((256 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "altitude"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$88__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$86 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$86
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$88$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((512 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "altitudeAccuracy"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$90__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$88 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$88
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$90$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((1024 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "heading"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$92__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$90 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$90
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$92$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((2048 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "speed"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$94__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$92 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$92
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$94$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((4096 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "timestamp"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$96__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$94 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$94
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$96$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((8192 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$96 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9();
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$96
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$97$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((16384 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "orientation"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$99__Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter()));
    var convertA = new $c_Lshapeless_Lazy$$anon$1(t);
    var convertA$1 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$8(convertA);
    var convertField = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$7(convertA$1);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$137__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$97 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$97
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$99$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter($thiz) {
  if (((32768 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "pitch"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "roll"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "yaw"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "alpha"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "beta"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "gamma")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$19$2) => {
      var x0$19 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(x0$19$2);
      if ((x0$19 !== null)) {
        var pitch$macro$118 = $n(x0$19).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_pitch;
        var roll$macro$119 = $n(x0$19).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_roll;
        var yaw$macro$120 = $n(x0$19).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_yaw;
        var alpha$macro$121 = $n(x0$19).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_alpha;
        var beta$macro$122 = $n(x0$19).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_beta;
        var gamma$macro$123 = $n(x0$19).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_gamma;
        return new $c_Lshapeless_$colon$colon(pitch$macro$118, new $c_Lshapeless_$colon$colon(roll$macro$119, new $c_Lshapeless_$colon$colon(yaw$macro$120, new $c_Lshapeless_$colon$colon(alpha$macro$121, new $c_Lshapeless_$colon$colon(beta$macro$122, new $c_Lshapeless_$colon$colon(gamma$macro$123, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$19)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$20$2) => {
      var x0$20 = $as_Lshapeless_$colon$colon(x0$20$2);
      if ((x0$20 !== null)) {
        var pitch$macro$112 = $uD($n(x0$20).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$20).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var roll$macro$113 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var yaw$macro$114 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var alpha$macro$115 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var beta$macro$116 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var gamma$macro$117 = $uD($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(pitch$macro$112, roll$macro$113, yaw$macro$114, alpha$macro$115, beta$macro$116, gamma$macro$117)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$20)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "gamma"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "beta"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "alpha"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "yaw"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "roll"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "pitch"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var genericV = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$124__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var converterV = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$99 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11(genericV, converterV);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (32768 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$99
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$124$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((65536 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "pitch"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$126__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$124 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (65536 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$124
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$126$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((131072 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "roll"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$128__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$126 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (131072 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$126
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$128$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((262144 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "yaw"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$130__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$128 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (262144 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$128
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$130$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((524288 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "alpha"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$132__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$130 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (524288 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$130
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$132$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((1048576 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "beta"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$134__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$132 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (1048576 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$132
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$134$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((2097152 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "gamma"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeDouble;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$136__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$134 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (2097152 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$134
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$136$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((4194304 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$136 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9();
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (4194304 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$136
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$137$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((8388608 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "instant"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeInstant;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$139__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$137 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (8388608 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$137
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$139$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((16777216 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$139 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9();
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = (16777216 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$139
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$25 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$33 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$42 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$45 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$47 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$80 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$82 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$84 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$86 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$88 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$90 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$92 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$94 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$96 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$97 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$99 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$124 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$126 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$128 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$130 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$132 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$134 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$136 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$137 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$139 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0 = 0
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$25__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((1 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$25$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$25)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$33__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((2 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$33$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$33)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$42__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((4 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$42$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$42)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$45__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((8 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$45$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$45)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$47__Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter = (function() {
  return (((16 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$47$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$47)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$80__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((32 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$80$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$80)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$82__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((64 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$82$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$82)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$84__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((128 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$84$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$84)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$86__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((256 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$86$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$86)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$88__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((512 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$88$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$88)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$90__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((1024 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$90$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$90)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$92__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((2048 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$92$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$92)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$94__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((4096 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$94$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$94)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$96__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((8192 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$96$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$96)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$97__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((16384 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$97$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$97)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$99__Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter = (function() {
  return (((32768 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$99$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$99)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$124__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((65536 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$124$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$124)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$126__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((131072 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$126$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$126)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$128__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((262144 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$128$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$128)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$130__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((524288 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$130$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$130)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$132__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((1048576 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$132$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$132)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$134__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((2097152 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$134$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$134)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$136__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((4194304 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$136$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$136)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$137__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((8388608 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$137$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$137)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.inst$macro$139__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((16777216 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__inst$macro$139$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1__f_inst$macro$139)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.LocalData$Feature$anon$storeConverter$macro$140$1", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$anon$storeConverter$macro$140$1;
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$1$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder($thiz) {
  if (((1 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Feature"));
    var witK$1 = new $c_Lshapeless_Witness$$anon$1(value0);
    var ctV$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.getClassOf());
    var converterV$2 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$().Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature$__f_converterFeature;
    $m_Lshapeless_Witness$();
    var this$4 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "File"));
    var witK = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var ctV = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.getClassOf());
    var this$7 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "_id"));
    var this$8 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "type"));
    var this$9 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "buffer")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File(x0$23$2);
      if ((x0$23 !== null)) {
        var _id$macro$150 = $n(x0$23).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f__id;
        var type$macro$151 = $n(x0$23).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_type;
        var buffer$macro$152 = $n(x0$23).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_buffer;
        return new $c_Lshapeless_$colon$colon(_id$macro$150, new $c_Lshapeless_$colon$colon(type$macro$151, new $c_Lshapeless_$colon$colon(buffer$macro$152, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var _id$macro$147 = $as_Lreactbuild_common_model_RefTo($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var type$macro$148 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var buffer$macro$149 = $n(p3).Lshapeless_$colon$colon__f_head;
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File(_id$macro$147, type$macro$148, buffer$macro$149)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "buffer"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "type"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$22 = $m_s_$less$colon$less$();
    var ev = this$22.s_$less$colon$less$__f_singleton;
    var genericV = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$153__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var converterV = new $c_Lshapeless_Lazy$$anon$1(t);
    var converterV$1 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11(genericV, converterV);
    var builderR = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$12();
    var builderR$1 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13(witK, builderR, ctV, converterV$1);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$1 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder$$anon$13(witK$1, builderR$1, ctV$1, converterV$2);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$1
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$153$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((67108864 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$();
    var convertField = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$$anon$2();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$161__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$153 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0 = (67108864 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$153
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$161$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((134217728 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "type"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeString;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$163__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$161 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0 = (134217728 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$161
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$163$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((268435456 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0)) {
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "buffer"));
    var witnessK = new $c_Lshapeless_Witness$$anon$1(value0);
    var convertField = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$().Lreactbuild_analyze_cost_modules_mapview_interactions_FieldConverter$__f_encodeBlob;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$165__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter()));
    var convertRest = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$163 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$10(convertField, witnessK, convertRest);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0 = (268435456 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$163
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$165$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($thiz) {
  if (((536870912 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$165 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter$$anon$9();
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0 = (536870912 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$165
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$153 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$161 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$163 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$165 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0 = 0
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype.inst$macro$1__Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder = (function() {
  return (((1 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$1$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype.inst$macro$153__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((67108864 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$153$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$153)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype.inst$macro$161__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((134217728 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$161$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$161)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype.inst$macro$163__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((268435456 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$163$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$163)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype.inst$macro$165__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter = (function() {
  return (((536870912 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_bitmap$0) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__inst$macro$165$lzycompute__Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1__f_inst$macro$165)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.LocalData$anon$build$macro$166$1", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$anon$build$macro$166$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15(decoder$1) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15__f_decoder$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15__f_decoder$1 = decoder$1
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15.prototype.withTransaction__Lorg_scalajs_dom_IDBTransactionMode__F1__Lorg_scalajs_dom_IDBDatabase__O = (function(mode, f, idb) {
  var $$x1 = $m_sjs_js_JSConverters$JSRichIterableOnce$();
  var coll = idb.objectStoreNames;
  var a = $n($$x1).toJSArray$extension__sc_IterableOnce__sjs_js_Array(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(coll));
  var transaction = idb.transaction(a, mode);
  var map = $as_scm_Map($m_scm_Map$().empty__O());
  var tx = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16(this, map, transaction);
  return $n(f).apply__O__O(tx)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15.prototype.upgrade__Lorg_scalajs_dom_IDBDatabase__V = (function(db) {
  $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15__f_decoder$1).value__O())).upgrade__Lorg_scalajs_dom_IDBDatabase__V(db)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.SchemaBuilder$$anon$15", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16(outer, map$1, transaction$1) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_$outer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_map$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_transaction$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_$outer = outer
  };
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_map$1 = map$1;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_transaction$1 = transaction$1
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16.prototype.objectStore__T__Lorg_scalajs_dom_IDBObjectStore = (function(name) {
  return $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_map$1).getOrElseUpdate__O__F0__O(name, new $c_sjsr_AnonFunction0((() => this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_transaction$1.objectStore(name))))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16.prototype.getAll__s_reflect_ClassTag__s_concurrent_Future = (function(ct) {
  return $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder($n($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_$outer).Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15__f_decoder$1).value__O())).getAll__s_reflect_ClassTag__Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction__s_concurrent_Future(ct, this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16.prototype.put__O__s_reflect_ClassTag__s_concurrent_Future = (function(item, ct) {
  return $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_CoproductSchemaBuilder($n($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16__f_$outer).Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15__f_decoder$1).value__O())).put__O__s_reflect_ClassTag__Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction__s_concurrent_Future(item, ct, this)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.SchemaBuilder$$anon$15$$anon$16", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11(genericV$1, converterV$1) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11__f_genericV$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11__f_converterV$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11__f_genericV$1 = genericV$1;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11__f_converterV$1 = converterV$1
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11.prototype.fromDatabase__sjs_js_Any__O = (function(item) {
  return $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11__f_genericV$1).from__O__O($n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11__f_converterV$1).value__O())).fromDatabase__sjs_js_Any__O(item))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11.prototype.toDatabase__O__sjs_js_Any = (function(item) {
  return $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_AccumulatingStoreConverter($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11__f_converterV$1).value__O())).toDatabase__O__sjs_js_Dictionary($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11__f_genericV$1).to__O__O(item))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.StoreConverter$$anon$11", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_StoreConverter$$anon$11;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$__f_reuseProps = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$__f_reuseProps = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2())
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$ChildProps$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$__f_reuseDeviceOrientationData = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$__f_reuseDeviceOrientationData = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var inst$macro$28 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1().inst$macro$1__Lio_circe_generic_codec_DerivedAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.DeviceOrientationData$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_codec_DerivedAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "pitch"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "roll"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "yaw"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "alpha"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "beta"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "gamma")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(x0$3$2);
      if ((x0$3 !== null)) {
        var pitch$macro$20 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_pitch;
        var roll$macro$21 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_roll;
        var yaw$macro$22 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_yaw;
        var alpha$macro$23 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_alpha;
        var beta$macro$24 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_beta;
        var gamma$macro$25 = $n(x0$3).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_gamma;
        return new $c_Lshapeless_$colon$colon(pitch$macro$20, new $c_Lshapeless_$colon$colon(roll$macro$21, new $c_Lshapeless_$colon$colon(yaw$macro$22, new $c_Lshapeless_$colon$colon(alpha$macro$23, new $c_Lshapeless_$colon$colon(beta$macro$24, new $c_Lshapeless_$colon$colon(gamma$macro$25, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var pitch$macro$14 = $uD($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var roll$macro$15 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var yaw$macro$16 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var alpha$macro$17 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var beta$macro$18 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var gamma$macro$19 = $uD($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(pitch$macro$14, roll$macro$15, yaw$macro$16, alpha$macro$17, beta$macro$18, gamma$macro$19)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "gamma"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "beta"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "alpha"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "yaw"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "roll"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "pitch"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_inst$macro$1 = new $c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1(codec, gen$1);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_inst$macro$1
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_inst$macro$26 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1($thiz);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_inst$macro$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_inst$macro$26 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_bitmap$0 = 0
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1.prototype.inst$macro$1__Lio_circe_generic_codec_DerivedAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_codec_DerivedAsObjectCodec(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_inst$macro$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1.prototype.inst$macro$26__Lio_circe_generic_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_codec_ReprAsObjectCodec(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1__f_inst$macro$26)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.DeviceOrientationData$anon$lazy$macro$27$1", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$() {
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var inst$macro$68 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$68));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$.prototype.from__Lorg_scalajs_dom_Position__Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition = (function(e) {
  return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition($uD(e.coords.latitude), $uD(e.coords.longitude), $uD(e.coords.accuracy), $uD(e.coords.altitude), $uD(e.coords.altitudeAccuracy), $uD(e.coords.heading), $uD(e.coords.speed), $uD(e.timestamp))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.GeolocationPosition$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "latitude"));
    var this$2 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "longitude"));
    var this$3 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "accuracy"));
    var this$4 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "altitude"));
    var this$5 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "altitudeAccuracy"));
    var this$6 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "heading"));
    var this$7 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "speed"));
    var this$8 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "timestamp")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(x0$7$2);
      if ((x0$7 !== null)) {
        var latitude$macro$58 = $n(x0$7).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_latitude;
        var longitude$macro$59 = $n(x0$7).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_longitude;
        var accuracy$macro$60 = $n(x0$7).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_accuracy;
        var altitude$macro$61 = $n(x0$7).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitude;
        var altitudeAccuracy$macro$62 = $n(x0$7).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitudeAccuracy;
        var heading$macro$63 = $n(x0$7).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_heading;
        var speed$macro$64 = $n(x0$7).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_speed;
        var timestamp$macro$65 = $n(x0$7).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_timestamp;
        return new $c_Lshapeless_$colon$colon(latitude$macro$58, new $c_Lshapeless_$colon$colon(longitude$macro$59, new $c_Lshapeless_$colon$colon(accuracy$macro$60, new $c_Lshapeless_$colon$colon(altitude$macro$61, new $c_Lshapeless_$colon$colon(altitudeAccuracy$macro$62, new $c_Lshapeless_$colon$colon(heading$macro$63, new $c_Lshapeless_$colon$colon(speed$macro$64, new $c_Lshapeless_$colon$colon(timestamp$macro$65, $m_Lshapeless_HNil$()))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var latitude$macro$50 = $uD($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var longitude$macro$51 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var accuracy$macro$52 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var altitude$macro$53 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var altitudeAccuracy$macro$54 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var heading$macro$55 = $uD($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var speed$macro$56 = $uD($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var timestamp$macro$57 = $uD($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p9)) {
                        return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(latitude$macro$50, longitude$macro$51, accuracy$macro$52, altitude$macro$53, altitudeAccuracy$macro$54, heading$macro$55, speed$macro$56, timestamp$macro$57)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "timestamp"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "speed"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "heading"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "altitudeAccuracy"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "altitude"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "accuracy"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "longitude"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "latitude"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    var this$36 = $m_s_$less$colon$less$();
    var ev = this$36.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$66__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$40 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "latitude"));
    var this$41 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "longitude"));
    var this$42 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "accuracy"));
    var this$43 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "altitude"));
    var this$44 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "altitudeAccuracy"));
    var this$45 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "heading"));
    var this$46 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "speed"));
    var this$47 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "timestamp")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$7);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "latitude"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "longitude"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "accuracy"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "altitude"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$67 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "altitudeAccuracy"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$69 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$69, "heading"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$71 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$71, "speed"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$73 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "timestamp"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$15);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var this$84 = $m_s_$less$colon$less$();
    var ev$1 = this$84.s_$less$colon$less$__f_singleton;
    var this$85 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$85);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$89 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$89);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$93 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$93);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$97 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$97);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$101 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$113);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$117 = $m_s_$less$colon$less$();
    var ev$2 = this$117.s_$less$colon$less$__f_singleton;
    var this$118 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$118);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$8, ev$2);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$122 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$122);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$126 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$126);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$130 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$130);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$134 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$134);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$138 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$138);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$142 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$142);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$146 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$146);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_inst$macro$1
}
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__inst$macro$66$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_inst$macro$66 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1($thiz);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_inst$macro$66
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_inst$macro$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_inst$macro$66 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_bitmap$0 = 0
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_inst$macro$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1.prototype.inst$macro$66__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__inst$macro$66$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1__f_inst$macro$66)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.GeolocationPosition$anon$lazy$macro$67$1", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1;
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableInteraction);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  $n(b$2$lzy$1);
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__f_reuseChildProps = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$ = this;
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(a$2);
    var b = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(b$2);
    return ($uZ($n($p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction, $n(b).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction)) && $uZ($n($p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active, $n(b).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active)))
  }));
  elem = f;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$__f_reuseChildProps = $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Interactions$ChildProps$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseLayer);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  $n(b$2$lzy$1);
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__f_reuseProps = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$ = this;
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(a$2);
    var b = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(b$2);
    return ($uZ($n($p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer, $n(b).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer)) && $uZ($n($p_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_visible, $n(b).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_visible)))
  }));
  elem = f;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$__f_reuseProps = $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Layer$Props$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$__f_reuseIndex = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$ = this;
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index__f_index
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$__f_reuseIndex = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Layers$Index$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableCoordinate);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  $n(b$2$lzy$1);
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($thiz.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseZoom);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$() {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseZoom = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseViewPoint = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseZoom = $m_Ljapgolly_scalajs_react_Reusability$().double__D__F2(0.1);
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(a$2);
    var b = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(b$2);
    if ($uZ($n($p_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords, $n(b).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords))) {
      var this$3 = $n($p_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__b$2$1__sr_LazyRef__F2(this, b$2$lzy));
      var v1 = $n(a).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom;
      var v2 = $n(b).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom;
      return $uZ(this$3.apply__O__O__O(v1, v2))
    } else {
      return false
    }
  }));
  elem = f;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$__f_reuseViewPoint = $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$.prototype;
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewPoint$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$.prototype.reducer__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((state$2, action$2) => {
    var state = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(state$2);
    var action = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction(action$2);
    var this$2 = $n($n(state).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_history);
    var nextHistory = new $c_sci_$colon$colon(action, this$2).take__I__sci_List(5);
    var this$15 = $n(nextHistory);
    var f = ((e$2) => {
      var e = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction(e$2);
      var $$x5 = $m_sc_StringOps$();
      var $$x4 = $n(e).origin__T();
      var $$x3 = $n(e).when__D();
      var array = $n($n(e).viewPoint__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint()).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords;
      var len = $uI(array.length);
      var res = new Array(len);
      var i = 0;
      while ((i < len)) {
        var $$x2 = i;
        var arg1 = array[i];
        var v = $uD(arg1);
        var $$x1 = $m_sc_StringOps$();
        var array$1 = [((1000000.0 * $uD(Math.abs(v))) % 1000.0)];
        res[$$x2] = $n($$x1).format$extension__T__sci_Seq__T("%.0f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
        i = ((1 + i) | 0)
      };
      var array$2 = [$$x4, $$x3, res, $n($n(e).viewPoint__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint()).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom];
      return $n($$x5).format$extension__T__sci_Seq__T("%s(%.0f, %s, %.1f)", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    });
    if ((this$15 === $m_sci_Nil$())) {
      var $$x6 = $m_sci_Nil$()
    } else {
      var arg1$1 = this$15.head__O();
      var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$15.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$2 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var $$x6 = h
    };
    var this$16 = $n($$x6);
    var lastActions = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$16, "", " : ", "");
    if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView)) {
      var x2 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView(action);
      var viewPoint = $n(x2).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_viewPoint;
      var this$17 = $n(state);
      var x$5 = this$17.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToView;
      $n(state);
      return new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(action, viewPoint, x$5, nextHistory, lastActions)
    } else if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps)) {
      var x3 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps(action);
      var viewPoint$2 = $n(x3).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_viewPoint;
      var x = $n($n(state).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastAction).viewPoint__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint();
      if (((x === null) ? (viewPoint$2 === null) : $n(x).equals__O__Z(viewPoint$2))) {
        var this$19 = $n(state);
        var x$9 = this$19.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToProps;
        var this$20 = $n(state);
        var x$10 = this$20.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToView;
        $n(state);
        return new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(action, x$9, x$10, nextHistory, lastActions)
      } else {
        var this$22 = $n(state);
        var x$15 = this$22.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToProps;
        $n(state);
        return new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(action, x$15, viewPoint$2, nextHistory, lastActions)
      }
    } else {
      throw new $c_s_MatchError(action)
    }
  }))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewState$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1.prototype = $c_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1.prototype;
var $d_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1: 0
}, false, "reactbuild.analyze.cost.modules.planner.LineRuler$$anon$1", {
  Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_planner_IsRange: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_LineRuler$$anon$1;
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$1$lzycompute$2__sr_LazyRef__F2($thiz, b$1$lzy$2) {
  $n(b$1$lzy$2);
  if ($n(b$1$lzy$2).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_analyze_cost_modules_planner_Planner$().Lreactbuild_analyze_cost_modules_planner_Planner$__f_reusabilityPeriod);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$2).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$1$2__sr_LazyRef__F2($thiz, b$1$lzy$2) {
  return ($n(b$1$lzy$2).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$2).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$1$lzycompute$2__sr_LazyRef__F2($thiz, b$1$lzy$2))
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$2$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$2$lzy$1, reuseDouble$1) {
  $n(b$2$lzy$1);
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability(reuseDouble$1);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$2$1__sr_LazyRef__F2__F2($thiz, b$2$lzy$1, reuseDouble$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$2$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$2$lzy$1, reuseDouble$1))
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  $n(b$3$lzy$1);
  if ($n(b$3$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$3$1__sr_LazyRef__F2($thiz, b$3$lzy$1) {
  return ($n(b$3$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$3$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$3$lzycompute$1__sr_LazyRef__F2($thiz, b$3$lzy$1))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_Planner$State$() {
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State$__f_reuseState = null;
  $n_Lreactbuild_analyze_cost_modules_planner_Planner$State$ = this;
  var reuseDouble = $m_Ljapgolly_scalajs_react_Reusability$().double__D__F2(1.0);
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  var b$3$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_analyze_cost_modules_planner_Planner$State(a$2);
    var b = $as_Lreactbuild_analyze_cost_modules_planner_Planner$State(b$2);
    if ($uZ($n($p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$1$2__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period, $n(b).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period))) {
      var this$3 = $n($p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$2$1__sr_LazyRef__F2__F2(this, b$2$lzy, reuseDouble));
      var v1 = $n(a).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth;
      var v2 = $n(b).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth;
      var $$x1 = $uZ(this$3.apply__O__O__O(v1, v2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $uZ($n($p_Lreactbuild_analyze_cost_modules_planner_Planner$State$__b$3$1__sr_LazyRef__F2(this, b$3$lzy)).apply__O__O__O($n(a).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_printMode, $n(b).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_printMode))
    } else {
      return false
    }
  }));
  elem = f;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State$__f_reuseState = $n($$x3).$bar$bar$extension__F2__F2__F2($$x2, $as_F2(elem))
}
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_Planner$State$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_Planner$State$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_Planner$State$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_Planner$State$.prototype;
var $d_Lreactbuild_analyze_cost_modules_planner_Planner$State$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_Planner$State$: 0
}, false, "reactbuild.analyze.cost.modules.planner.Planner$State$", {
  Lreactbuild_analyze_cost_modules_planner_Planner$State$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_Planner$State$;
var $n_Lreactbuild_analyze_cost_modules_planner_Planner$State$;
function $m_Lreactbuild_analyze_cost_modules_planner_Planner$State$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_Planner$State$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_Planner$State$ = new $c_Lreactbuild_analyze_cost_modules_planner_Planner$State$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_Planner$State$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1() {
  this.Ldiode_ActionHandler__f_liftedHandler = null;
  this.Ldiode_ActionHandler__f_modelRW = null;
  this.Ldiode_ActionHandler__f_currentModel = null;
  this.Ldiode_ActionHandler__f_bitmap$0 = false;
  var this$2 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var get = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_services_RootModel(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_services_RootModel__f_model
  }));
  var set = new $c_sjsr_AnonFunction2(((m$2, t$2) => {
    var m = $as_Lreactbuild_analyze_cost_services_RootModel(m$2);
    var t = $as_Lreactbuild_analyze_cost_services_Model(t$2);
    $n(m);
    return new $c_Lreactbuild_analyze_cost_services_RootModel(t)
  }));
  var feq = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  var this$3 = $n(this$2.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$modelRW);
  var this$12 = new $c_Ldiode_ZoomModelRW(this$3, get, set, feq);
  var get$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_analyze_cost_services_Model(x$2$2);
    return $n(x$2).Lreactbuild_analyze_cost_services_Model__f_serverConnectionState
  }));
  var set$1 = new $c_sjsr_AnonFunction2(((m$2$1, t$2$1) => {
    var m$1 = $as_Lreactbuild_analyze_cost_services_Model(m$2$1);
    var t$1 = $as_Ldiode_data_Pot(t$2$1);
    var this$4 = $n(m$1);
    var x$4 = this$4.Lreactbuild_analyze_cost_services_Model__f_logged;
    var this$5 = $n(m$1);
    var x$5 = this$5.Lreactbuild_analyze_cost_services_Model__f_activeOrganization;
    var this$6 = $n(m$1);
    var x$6 = this$6.Lreactbuild_analyze_cost_services_Model__f_commonData;
    var this$7 = $n(m$1);
    var x$7 = this$7.Lreactbuild_analyze_cost_services_Model__f_period;
    var this$8 = $n(m$1);
    var x$8 = this$8.Lreactbuild_analyze_cost_services_Model__f_library;
    var this$9 = $n(m$1);
    var x$9 = this$9.Lreactbuild_analyze_cost_services_Model__f_serverConnection;
    var this$10 = $n(m$1);
    var x$10 = this$10.Lreactbuild_analyze_cost_services_Model__f_permissionRequested;
    $n(m$1);
    return new $c_Lreactbuild_analyze_cost_services_Model(x$4, x$5, x$6, x$7, x$8, x$9, t$1, x$10)
  }));
  var feq$1 = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  $ct_Ldiode_ActionHandler__Ldiode_ModelRW__(this, $f_Ldiode_BaseModelRW__zoomRW__F1__F2__Ldiode_FastEq__Ldiode_ZoomModelRW(this$12, get$1, set$1, feq$1))
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1.prototype = new $h_Ldiode_ActionHandler();
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1.prototype.handle__s_PartialFunction = (function() {
  return new $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1(this)
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$1: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$$anon$1", {
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$1: 1,
  Ldiode_ActionHandler: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1;
function $p_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2__onopen$1__Lorg_scalajs_dom_Event__Lorg_scalajs_dom_WebSocket__V($thiz, e, ws$1) {
  var this$1 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var action = new $c_Lreactbuild_analyze_cost_actions_ConnectedToServer(ws$1);
  var evidence$6 = $m_Ldiode_Action$aType$();
  $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V(this$1, action, evidence$6)
}
function $p_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2__onmessage$1__Lorg_scalajs_dom_MessageEvent__V($thiz, e) {
  var this$1 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var action = new $c_Lreactbuild_analyze_cost_actions_ServerRawMessage(e.data);
  var evidence$6 = $m_Ldiode_Action$aType$();
  $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V(this$1, action, evidence$6)
}
function $p_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2__onerror$1__Lorg_scalajs_dom_Event__V($thiz, e) {
  var this$7 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var value = e.message;
  if ((value === (void 0))) {
    var $$x1 = "Error occured"
  } else {
    var x = $as_T(value);
    var $$x1 = x
  };
  var action = new $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed($ct_jl_Exception__T__(new $c_jl_Exception(), $as_T($$x1)));
  var evidence$6 = $m_Ldiode_Action$aType$();
  $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V(this$7, action, evidence$6)
}
function $p_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2__onclose$1__Lorg_scalajs_dom_CloseEvent__V($thiz, e) {
  var this$1 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var action = new $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost($uI(e.code), $as_T(e.reason), $uZ(e.wasClean));
  var evidence$6 = $m_Ldiode_Action$aType$();
  $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V(this$1, action, evidence$6)
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2() {
  this.Ldiode_ActionHandler__f_liftedHandler = null;
  this.Ldiode_ActionHandler__f_modelRW = null;
  this.Ldiode_ActionHandler__f_currentModel = null;
  this.Ldiode_ActionHandler__f_bitmap$0 = false;
  var this$2 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var get = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_services_RootModel(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_services_RootModel__f_model
  }));
  var set = new $c_sjsr_AnonFunction2(((m$2, t$2) => {
    var m = $as_Lreactbuild_analyze_cost_services_RootModel(m$2);
    var t = $as_Lreactbuild_analyze_cost_services_Model(t$2);
    $n(m);
    return new $c_Lreactbuild_analyze_cost_services_RootModel(t)
  }));
  var feq = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  var this$3 = $n(this$2.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$modelRW);
  var this$12 = new $c_Ldiode_ZoomModelRW(this$3, get, set, feq);
  var get$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_analyze_cost_services_Model(x$2$2);
    return $n(x$2).Lreactbuild_analyze_cost_services_Model__f_serverConnection
  }));
  var set$1 = new $c_sjsr_AnonFunction2(((m$2$1, t$2$1) => {
    var m$1 = $as_Lreactbuild_analyze_cost_services_Model(m$2$1);
    var t$1 = $as_Lreactbuild_analyze_cost_services_ServerConnection(t$2$1);
    var this$4 = $n(m$1);
    var x$4 = this$4.Lreactbuild_analyze_cost_services_Model__f_logged;
    var this$5 = $n(m$1);
    var x$5 = this$5.Lreactbuild_analyze_cost_services_Model__f_activeOrganization;
    var this$6 = $n(m$1);
    var x$6 = this$6.Lreactbuild_analyze_cost_services_Model__f_commonData;
    var this$7 = $n(m$1);
    var x$7 = this$7.Lreactbuild_analyze_cost_services_Model__f_period;
    var this$8 = $n(m$1);
    var x$8 = this$8.Lreactbuild_analyze_cost_services_Model__f_library;
    var this$9 = $n(m$1);
    var x$9 = this$9.Lreactbuild_analyze_cost_services_Model__f_serverConnectionState;
    var this$10 = $n(m$1);
    var x$10 = this$10.Lreactbuild_analyze_cost_services_Model__f_permissionRequested;
    $n(m$1);
    return new $c_Lreactbuild_analyze_cost_services_Model(x$4, x$5, x$6, x$7, x$8, t$1, x$9, x$10)
  }));
  var feq$1 = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  $ct_Ldiode_ActionHandler__Ldiode_ModelRW__(this, $f_Ldiode_BaseModelRW__zoomRW__F1__F2__Ldiode_FastEq__Ldiode_ZoomModelRW(this$12, get$1, set$1, feq$1))
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2.prototype = new $h_Ldiode_ActionHandler();
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2.prototype.reactbuild$analyze$cost$services$AppCircuit$$anon$$connectToServer__Ldiode_NoAction$ = (function() {
  $m_sc_StringOps$();
  var x = $as_T(window.location.protocol);
  var this$3 = $n(x);
  var len = this$3.length;
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
  var i = 0;
  while ((i < len)) {
    var this$4 = $n(x);
    var index = i;
    var x$1 = $charAt(this$4, index);
    if ((x$1 === 115)) {
      var str = $as_T(String.fromCharCode(x$1));
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
    };
    i = ((1 + i) | 0)
  };
  var url = ((((("ws" + ((len === sb.length__I()) ? x : sb.jl_StringBuilder__f_java$lang$StringBuilder$$content)) + "://") + $as_T(window.location.host)) + "/api/client-stream/") + $m_Lreactbuild_analyze_cost_services_AppCircuit$().Lreactbuild_analyze_cost_services_AppCircuit$__f_reactbuild$analyze$cost$services$AppCircuit$$id);
  var ws = new WebSocket(url);
  ws.onopen = ((arg1$2) => {
    $p_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2__onopen$1__Lorg_scalajs_dom_Event__Lorg_scalajs_dom_WebSocket__V(this, arg1$2, ws)
  });
  ws.onclose = ((arg1$2$1) => {
    $p_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2__onclose$1__Lorg_scalajs_dom_CloseEvent__V(this, arg1$2$1)
  });
  ws.onmessage = ((arg1$2$2) => {
    $p_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2__onmessage$1__Lorg_scalajs_dom_MessageEvent__V(this, arg1$2$2)
  });
  ws.onerror = ((arg1$2$3) => {
    $p_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2__onerror$1__Lorg_scalajs_dom_Event__V(this, arg1$2$3)
  });
  return $m_Ldiode_NoAction$()
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2.prototype.handle__s_PartialFunction = (function() {
  return new $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2(this)
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$2: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$$anon$2", {
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$2: 1,
  Ldiode_ActionHandler: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3() {
  this.Ldiode_ActionHandler__f_liftedHandler = null;
  this.Ldiode_ActionHandler__f_modelRW = null;
  this.Ldiode_ActionHandler__f_currentModel = null;
  this.Ldiode_ActionHandler__f_bitmap$0 = false;
  var this$2 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var get = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_services_RootModel(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_services_RootModel__f_model
  }));
  var set = new $c_sjsr_AnonFunction2(((m$2, t$2) => {
    var m = $as_Lreactbuild_analyze_cost_services_RootModel(m$2);
    var t = $as_Lreactbuild_analyze_cost_services_Model(t$2);
    $n(m);
    return new $c_Lreactbuild_analyze_cost_services_RootModel(t)
  }));
  var feq = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  var this$3 = $n(this$2.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$modelRW);
  var this$12 = new $c_Ldiode_ZoomModelRW(this$3, get, set, feq);
  var get$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_analyze_cost_services_Model(x$2$2);
    return $n(x$2).Lreactbuild_analyze_cost_services_Model__f_commonData
  }));
  var set$1 = new $c_sjsr_AnonFunction2(((m$2$1, t$2$1) => {
    var m$1 = $as_Lreactbuild_analyze_cost_services_Model(m$2$1);
    var t$1 = $as_Ldiode_data_Pot(t$2$1);
    var this$4 = $n(m$1);
    var x$4 = this$4.Lreactbuild_analyze_cost_services_Model__f_logged;
    var this$5 = $n(m$1);
    var x$5 = this$5.Lreactbuild_analyze_cost_services_Model__f_activeOrganization;
    var this$6 = $n(m$1);
    var x$6 = this$6.Lreactbuild_analyze_cost_services_Model__f_period;
    var this$7 = $n(m$1);
    var x$7 = this$7.Lreactbuild_analyze_cost_services_Model__f_library;
    var this$8 = $n(m$1);
    var x$8 = this$8.Lreactbuild_analyze_cost_services_Model__f_serverConnection;
    var this$9 = $n(m$1);
    var x$9 = this$9.Lreactbuild_analyze_cost_services_Model__f_serverConnectionState;
    var this$10 = $n(m$1);
    var x$10 = this$10.Lreactbuild_analyze_cost_services_Model__f_permissionRequested;
    $n(m$1);
    return new $c_Lreactbuild_analyze_cost_services_Model(x$4, x$5, t$1, x$6, x$7, x$8, x$9, x$10)
  }));
  var feq$1 = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  $ct_Ldiode_ActionHandler__Ldiode_ModelRW__(this, $f_Ldiode_BaseModelRW__zoomRW__F1__F2__Ldiode_FastEq__Ldiode_ZoomModelRW(this$12, get$1, set$1, feq$1))
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3.prototype = new $h_Ldiode_ActionHandler();
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3.prototype.handle__s_PartialFunction = (function() {
  return new $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3(this)
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$3: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$$anon$3", {
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$3: 1,
  Ldiode_ActionHandler: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4() {
  this.Ldiode_ActionHandler__f_liftedHandler = null;
  this.Ldiode_ActionHandler__f_modelRW = null;
  this.Ldiode_ActionHandler__f_currentModel = null;
  this.Ldiode_ActionHandler__f_bitmap$0 = false;
  var this$2 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
  var get = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_services_RootModel(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_services_RootModel__f_model
  }));
  var set = new $c_sjsr_AnonFunction2(((m$2, t$2) => {
    var m = $as_Lreactbuild_analyze_cost_services_RootModel(m$2);
    var t = $as_Lreactbuild_analyze_cost_services_Model(t$2);
    $n(m);
    return new $c_Lreactbuild_analyze_cost_services_RootModel(t)
  }));
  var feq = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  var this$3 = $n(this$2.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$modelRW);
  $ct_Ldiode_ActionHandler__Ldiode_ModelRW__(this, new $c_Ldiode_ZoomModelRW(this$3, get, set, feq))
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4.prototype = new $h_Ldiode_ActionHandler();
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4.prototype.handle__s_PartialFunction = (function() {
  return new $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4(this)
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$4: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$$anon$4", {
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$4: 1,
  Ldiode_ActionHandler: 1,
  O: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1(outer, context$1, state$1, textualizable$1) {
  this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_$outer = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_context$1 = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_state$1 = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_textualizable$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_$outer = outer
  };
  this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_context$1 = context$1;
  this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_state$1 = state$1;
  this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_textualizable$1 = textualizable$1
}
$c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1.prototype = $c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1.prototype.apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_vdom_TagOf = (function(ref) {
  var $$x1 = $n($n(this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_$outer).openItem__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagOf(ref, this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_context$1, this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_state$1));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = $n(this.Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1__f_textualizable$1).stringify__O__T(ref);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1.prototype.apply__O__Ljapgolly_scalajs_react_vdom_TagMod = (function(value) {
  return this.apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_vdom_TagOf($as_Lreactbuild_common_model_RefTo(value))
});
var $d_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1: 0
}, false, "reactbuild.analyze.cost.ui.ItemDetailViewHandler$$anon$1", {
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_Viewable: 1
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_Inbox$$anon$1(router$1, proxy$1) {
  this.Lreactbuild_analyze_cost_views_Inbox$$anon$1__f_router$1 = null;
  this.Lreactbuild_analyze_cost_views_Inbox$$anon$1__f_proxy$1 = null;
  this.Lreactbuild_analyze_cost_views_Inbox$$anon$1__f_router$1 = router$1;
  this.Lreactbuild_analyze_cost_views_Inbox$$anon$1__f_proxy$1 = proxy$1
}
$c_Lreactbuild_analyze_cost_views_Inbox$$anon$1.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_Inbox$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_views_Inbox$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_Inbox$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_Inbox$$anon$1.prototype = $c_Lreactbuild_analyze_cost_views_Inbox$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_views_Inbox$$anon$1.prototype.render__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(item, moveActive) {
  var u = $m_Lreactbuild_analyze_cost_views_ProcessTask$().apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Ldiode_data_Pot__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(this.Lreactbuild_analyze_cost_views_Inbox$$anon$1__f_router$1, this.Lreactbuild_analyze_cost_views_Inbox$$anon$1__f_proxy$1, item, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(moveActive).apply__O__O(1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_analyze_cost_views_Inbox$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_Inbox$$anon$1: 0
}, false, "reactbuild.analyze.cost.views.Inbox$$anon$1", {
  Lreactbuild_analyze_cost_views_Inbox$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_RenderItem: 1
});
$c_Lreactbuild_analyze_cost_views_Inbox$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_views_Inbox$$anon$1;
function $is_Lreactbuild_common_components_ProcessedInteractionResult(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_common_components_ProcessedInteractionResult)))
}
function $as_Lreactbuild_common_components_ProcessedInteractionResult(obj) {
  return (($is_Lreactbuild_common_components_ProcessedInteractionResult(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.ProcessedInteractionResult"))
}
function $isArrayOf_Lreactbuild_common_components_ProcessedInteractionResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_ProcessedInteractionResult)))
}
function $asArrayOf_Lreactbuild_common_components_ProcessedInteractionResult(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_ProcessedInteractionResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.ProcessedInteractionResult;", depth))
}
/** @constructor */
function $c_Lreactbuild_common_handlers_LibraryHandler(modelRW, ajaxClient) {
  this.Ldiode_ActionHandler__f_liftedHandler = null;
  this.Ldiode_ActionHandler__f_modelRW = null;
  this.Ldiode_ActionHandler__f_currentModel = null;
  this.Ldiode_ActionHandler__f_bitmap$0 = false;
  this.Lreactbuild_common_handlers_LibraryHandler__f_reactbuild$common$handlers$LibraryHandler$$ajaxClient = null;
  this.Lreactbuild_common_handlers_LibraryHandler__f_reactbuild$common$handlers$LibraryHandler$$ajaxClient = ajaxClient;
  $ct_Ldiode_ActionHandler__Ldiode_ModelRW__(this, modelRW)
}
$c_Lreactbuild_common_handlers_LibraryHandler.prototype = new $h_Ldiode_ActionHandler();
$c_Lreactbuild_common_handlers_LibraryHandler.prototype.constructor = $c_Lreactbuild_common_handlers_LibraryHandler;
/** @constructor */
function $h_Lreactbuild_common_handlers_LibraryHandler() {
  /*<skip>*/
}
$h_Lreactbuild_common_handlers_LibraryHandler.prototype = $c_Lreactbuild_common_handlers_LibraryHandler.prototype;
$c_Lreactbuild_common_handlers_LibraryHandler.prototype.handle__s_PartialFunction = (function() {
  return new $c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1(this)
});
var $d_Lreactbuild_common_handlers_LibraryHandler = new $TypeData().initClass({
  Lreactbuild_common_handlers_LibraryHandler: 0
}, false, "reactbuild.common.handlers.LibraryHandler", {
  Lreactbuild_common_handlers_LibraryHandler: 1,
  Ldiode_ActionHandler: 1,
  O: 1
});
$c_Lreactbuild_common_handlers_LibraryHandler.prototype.$classData = $d_Lreactbuild_common_handlers_LibraryHandler;
/** @constructor */
function $c_Lreactbuild_common_handlers_UserHandler(modelRW) {
  this.Ldiode_ActionHandler__f_liftedHandler = null;
  this.Ldiode_ActionHandler__f_modelRW = null;
  this.Ldiode_ActionHandler__f_currentModel = null;
  this.Ldiode_ActionHandler__f_bitmap$0 = false;
  $ct_Ldiode_ActionHandler__Ldiode_ModelRW__(this, modelRW)
}
$c_Lreactbuild_common_handlers_UserHandler.prototype = new $h_Ldiode_ActionHandler();
$c_Lreactbuild_common_handlers_UserHandler.prototype.constructor = $c_Lreactbuild_common_handlers_UserHandler;
/** @constructor */
function $h_Lreactbuild_common_handlers_UserHandler() {
  /*<skip>*/
}
$h_Lreactbuild_common_handlers_UserHandler.prototype = $c_Lreactbuild_common_handlers_UserHandler.prototype;
$c_Lreactbuild_common_handlers_UserHandler.prototype.handle__s_PartialFunction = (function() {
  return new $c_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1(this)
});
var $d_Lreactbuild_common_handlers_UserHandler = new $TypeData().initClass({
  Lreactbuild_common_handlers_UserHandler: 0
}, false, "reactbuild.common.handlers.UserHandler", {
  Lreactbuild_common_handlers_UserHandler: 1,
  Ldiode_ActionHandler: 1,
  O: 1
});
$c_Lreactbuild_common_handlers_UserHandler.prototype.$classData = $d_Lreactbuild_common_handlers_UserHandler;
/** @constructor */
function $c_Lreactbuild_common_model_Area$() {
  this.Lreactbuild_common_model_Area$__f_codecForArea = null;
  $n_Lreactbuild_common_model_Area$ = this;
  var inst$macro$20 = new $c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_Area$__f_codecForArea = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_Area$.prototype = new $h_O();
$c_Lreactbuild_common_model_Area$.prototype.constructor = $c_Lreactbuild_common_model_Area$;
/** @constructor */
function $h_Lreactbuild_common_model_Area$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Area$.prototype = $c_Lreactbuild_common_model_Area$.prototype;
var $d_Lreactbuild_common_model_Area$ = new $TypeData().initClass({
  Lreactbuild_common_model_Area$: 0
}, false, "reactbuild.common.model.Area$", {
  Lreactbuild_common_model_Area$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Area$.prototype.$classData = $d_Lreactbuild_common_model_Area$;
var $n_Lreactbuild_common_model_Area$;
function $m_Lreactbuild_common_model_Area$() {
  if ((!$n_Lreactbuild_common_model_Area$)) {
    $n_Lreactbuild_common_model_Area$ = new $c_Lreactbuild_common_model_Area$()
  };
  return $n_Lreactbuild_common_model_Area$
}
function $p_Lreactbuild_common_model_Area$anon$lazy$macro$19$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "area")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_Area(x0$7$2);
      if ((x0$7 !== null)) {
        var name$macro$16 = $n(x0$7).Lreactbuild_common_model_Area__f_name;
        var area$macro$17 = $n(x0$7).Lreactbuild_common_model_Area__f_area;
        return new $c_Lshapeless_$colon$colon(name$macro$16, new $c_Lshapeless_$colon$colon(area$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var name$macro$14 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var area$macro$15 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_common_model_Area(name$macro$14, area$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "area"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "name"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "area")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "area"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_inst$macro$1
}
function $p_Lreactbuild_common_model_Area$anon$lazy$macro$19$4__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_inst$macro$18 = new $c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16($thiz);
    $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4() {
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_inst$macro$18 = null;
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4.prototype = new $h_O();
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4.prototype.constructor = $c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4;
/** @constructor */
function $h_Lreactbuild_common_model_Area$anon$lazy$macro$19$4() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Area$anon$lazy$macro$19$4.prototype = $c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4.prototype;
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Area$anon$lazy$macro$19$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_inst$macro$1)
});
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Area$anon$lazy$macro$19$4__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4__f_inst$macro$18)
});
var $d_Lreactbuild_common_model_Area$anon$lazy$macro$19$4 = new $TypeData().initClass({
  Lreactbuild_common_model_Area$anon$lazy$macro$19$4: 0
}, false, "reactbuild.common.model.Area$anon$lazy$macro$19$4", {
  Lreactbuild_common_model_Area$anon$lazy$macro$19$4: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4.prototype.$classData = $d_Lreactbuild_common_model_Area$anon$lazy$macro$19$4;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDefinition$() {
  this.Lreactbuild_common_model_AssetDefinition$__f_codecForAssetDefinition = null;
  $n_Lreactbuild_common_model_AssetDefinition$ = this;
  var inst$macro$36 = new $c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_AssetDefinition$__f_codecForAssetDefinition = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_AssetDefinition$.prototype = new $h_O();
$c_Lreactbuild_common_model_AssetDefinition$.prototype.constructor = $c_Lreactbuild_common_model_AssetDefinition$;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDefinition$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDefinition$.prototype = $c_Lreactbuild_common_model_AssetDefinition$.prototype;
var $d_Lreactbuild_common_model_AssetDefinition$ = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDefinition$: 0
}, false, "reactbuild.common.model.AssetDefinition$", {
  Lreactbuild_common_model_AssetDefinition$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDefinition$.prototype.$classData = $d_Lreactbuild_common_model_AssetDefinition$;
var $n_Lreactbuild_common_model_AssetDefinition$;
function $m_Lreactbuild_common_model_AssetDefinition$() {
  if ((!$n_Lreactbuild_common_model_AssetDefinition$)) {
    $n_Lreactbuild_common_model_AssetDefinition$ = new $c_Lreactbuild_common_model_AssetDefinition$()
  };
  return $n_Lreactbuild_common_model_AssetDefinition$
}
function $p_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "name"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "category"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "details")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_AssetDefinition(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$30 = $n(x0$7).Lreactbuild_common_model_AssetDefinition__f__id;
        var name$macro$31 = $n(x0$7).Lreactbuild_common_model_AssetDefinition__f_name;
        var category$macro$32 = $n(x0$7).Lreactbuild_common_model_AssetDefinition__f_category;
        var details$macro$33 = $n(x0$7).Lreactbuild_common_model_AssetDefinition__f_details;
        return new $c_Lshapeless_$colon$colon(_id$macro$30, new $c_Lshapeless_$colon$colon(name$macro$31, new $c_Lshapeless_$colon$colon(category$macro$32, new $c_Lshapeless_$colon$colon(details$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$26 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var name$macro$27 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var category$macro$28 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var details$macro$29 = $as_Lreactbuild_common_model_AssetDetails($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_common_model_AssetDefinition(_id$macro$26, name$macro$27, category$macro$28, details$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_AssetDefinition$(), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$26 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "_id"));
    var this$27 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "name"));
    var this$28 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "category"));
    var this$29 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "details")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "_id"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "name"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$44 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "category"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "details"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$53 = $m_s_$less$colon$less$();
    var ev$1 = this$53.s_$less$colon$less$__f_singleton;
    var this$54 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$54);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$58 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$66);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$70 = $m_s_$less$colon$less$();
    var ev$2 = this$70.s_$less$colon$less$__f_singleton;
    var this$71 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$71);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$75 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$75);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$79 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$83);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_inst$macro$1
}
function $p_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_inst$macro$34 = new $c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34($thiz);
    $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6() {
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_inst$macro$34 = null;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6.prototype = new $h_O();
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6.prototype.constructor = $c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6.prototype = $c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6.prototype;
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_inst$macro$1)
});
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6__f_inst$macro$34)
});
var $d_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6: 0
}, false, "reactbuild.common.model.AssetDefinition$anon$lazy$macro$35$6", {
  Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6.prototype.$classData = $d_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6;
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ComponentDetails"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "MaterialDetails"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "TextureDetails")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_common_model_AssetDetails(p$2);
      var $$x4 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_common_model_ComponentDetails)) {
        var $$x3 = 0
      } else if ((p instanceof $c_Lreactbuild_common_model_MaterialDetails)) {
        var $$x3 = 1
      } else {
        if ((!(p instanceof $c_Lreactbuild_common_model_TextureDetails))) {
          throw new $c_s_MatchError(p)
        };
        var $$x3 = 2
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x4).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x3, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_common_model_AssetDetails($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "TextureDetails"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "MaterialDetails"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "ComponentDetails"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$1
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$2 = new $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27($thiz);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$2
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "file")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_TextureDetails(x0$7$2);
      if ((x0$7 !== null)) {
        var file$macro$11 = $n(x0$7).Lreactbuild_common_model_TextureDetails__f_file;
        return new $c_Lshapeless_$colon$colon(file$macro$11, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var file$macro$10 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_common_model_TextureDetails(file$macro$10)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "file"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "file")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "file"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$3
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$12 = new $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28($thiz);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$12
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    var $$x17 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "baseColor"));
    var this$2 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "roughness"));
    var this$3 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "bumpMap"));
    var this$4 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "bumpScale"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "map")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_common_model_MaterialDetails(x0$15$2);
      if ((x0$15 !== null)) {
        var baseColor$macro$49 = $n(x0$15).Lreactbuild_common_model_MaterialDetails__f_baseColor;
        var roughness$macro$50 = $n(x0$15).Lreactbuild_common_model_MaterialDetails__f_roughness;
        var bumpMap$macro$51 = $n(x0$15).Lreactbuild_common_model_MaterialDetails__f_bumpMap;
        var bumpScale$macro$52 = $n(x0$15).Lreactbuild_common_model_MaterialDetails__f_bumpScale;
        var map$macro$53 = $n(x0$15).Lreactbuild_common_model_MaterialDetails__f_map;
        return new $c_Lshapeless_$colon$colon(new $c_Lreactbuild_common_model_Color(baseColor$macro$49), new $c_Lshapeless_$colon$colon(roughness$macro$50, new $c_Lshapeless_$colon$colon(bumpMap$macro$51, new $c_Lshapeless_$colon$colon(bumpScale$macro$52, new $c_Lshapeless_$colon$colon(map$macro$53, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var baseColor$macro$44 = $n($as_Lreactbuild_common_model_Color($n(x0$16).Lshapeless_$colon$colon__f_head)).Lreactbuild_common_model_Color__f_color;
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var roughness$macro$45 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var bumpMap$macro$46 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var bumpScale$macro$47 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var map$macro$48 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_common_model_MaterialDetails(baseColor$macro$44, roughness$macro$45, bumpMap$macro$46, bumpScale$macro$47, map$macro$48)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "map"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "bumpScale"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "bumpMap"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "roughness"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "baseColor"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var $$x16 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$54__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x11 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some(1.0), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$30 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "baseColor"));
    var this$31 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "roughness"));
    var this$32 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "bumpMap"));
    var this$33 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "bumpScale"));
    var this$34 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "map")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var $$x10 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "bumpMap"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "bumpScale"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "map"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var $$x4 = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$52 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "baseColor"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$54 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "roughness"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$56 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "bumpMap"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$58 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "bumpScale"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$60 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "map"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$12);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$68 = $m_s_$less$colon$less$();
    var ev$1 = this$68.s_$less$colon$less$__f_singleton;
    var this$69 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$73);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$77 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$77);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$81 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$81);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$85 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$85);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$89 = $m_s_$less$colon$less$();
    var ev$2 = this$89.s_$less$colon$less$__f_singleton;
    var this$90 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$90);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$94 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$94);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$98 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$98);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$102 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$102);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$106 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$106);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$13 = $n($$x17).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x16, $$x11, $$x10, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7));
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$13
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$54$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$54 = new $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29($thiz);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$54
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$55$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    var $$x13 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "files3d"));
    var this$2 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "files2d"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "loader")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_common_model_ComponentDetails(x0$23$2);
      if ((x0$23 !== null)) {
        var files3d$macro$77 = $n(x0$23).Lreactbuild_common_model_ComponentDetails__f_files3d;
        var files2d$macro$78 = $n(x0$23).Lreactbuild_common_model_ComponentDetails__f_files2d;
        var loader$macro$79 = $n(x0$23).Lreactbuild_common_model_ComponentDetails__f_loader;
        return new $c_Lshapeless_$colon$colon(files3d$macro$77, new $c_Lshapeless_$colon$colon(files2d$macro$78, new $c_Lshapeless_$colon$colon(loader$macro$79, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var files3d$macro$74 = $as_sci_List($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var files2d$macro$75 = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var loader$macro$76 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_common_model_ComponentDetails(files3d$macro$74, files2d$macro$75, loader$macro$76)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "loader"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "files2d"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "files3d"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var $$x12 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$80__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x9 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_package$().s_package$__f_Nil), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_package$().s_package$__f_Nil), new $c_Lshapeless_$colon$colon(new $c_s_Some("OBJ"), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$22 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "files3d"));
    var this$23 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "files2d"));
    var this$24 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "loader")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var $$x8 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "files3d"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "files2d"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "loader"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var $$x4 = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "files3d"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "files2d"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$44 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "loader"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$50 = $m_s_$less$colon$less$();
    var ev$1 = this$50.s_$less$colon$less$__f_singleton;
    var this$51 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$51);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$55 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$55);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$59 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$59);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$63 = $m_s_$less$colon$less$();
    var ev$2 = this$63.s_$less$colon$less$__f_singleton;
    var this$64 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$64);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$68 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$68);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$72 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$72);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$55 = $n($$x13).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x12, $$x9, $$x8, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3));
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$55
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$80$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$80 = new $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30($thiz);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$80
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$81$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "file")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_common_model_TextureDetails(x0$31$2);
      if ((x0$31 !== null)) {
        var file$macro$89 = $n(x0$31).Lreactbuild_common_model_TextureDetails__f_file;
        return new $c_Lshapeless_$colon$colon(file$macro$89, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var file$macro$88 = $as_Lreactbuild_common_model_RefTo($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$32).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_common_model_TextureDetails(file$macro$88)
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "file"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$90__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "file"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$81 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$81
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$90$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$90 = new $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31($thiz);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$90
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$91$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "baseColor"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "roughness"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "bumpMap"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "bumpScale"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "map")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_common_model_MaterialDetails(x0$39$2);
      if ((x0$39 !== null)) {
        var baseColor$macro$127 = $n(x0$39).Lreactbuild_common_model_MaterialDetails__f_baseColor;
        var roughness$macro$128 = $n(x0$39).Lreactbuild_common_model_MaterialDetails__f_roughness;
        var bumpMap$macro$129 = $n(x0$39).Lreactbuild_common_model_MaterialDetails__f_bumpMap;
        var bumpScale$macro$130 = $n(x0$39).Lreactbuild_common_model_MaterialDetails__f_bumpScale;
        var map$macro$131 = $n(x0$39).Lreactbuild_common_model_MaterialDetails__f_map;
        return new $c_Lshapeless_$colon$colon(new $c_Lreactbuild_common_model_Color(baseColor$macro$127), new $c_Lshapeless_$colon$colon(roughness$macro$128, new $c_Lshapeless_$colon$colon(bumpMap$macro$129, new $c_Lshapeless_$colon$colon(bumpScale$macro$130, new $c_Lshapeless_$colon$colon(map$macro$131, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var baseColor$macro$122 = $n($as_Lreactbuild_common_model_Color($n(x0$40).Lshapeless_$colon$colon__f_head)).Lreactbuild_common_model_Color__f_color;
        var p2 = $as_Lshapeless_$colon$colon($n(x0$40).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var roughness$macro$123 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var bumpMap$macro$124 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var bumpScale$macro$125 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var map$macro$126 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_common_model_MaterialDetails(baseColor$macro$122, roughness$macro$123, bumpMap$macro$124, bumpScale$macro$125, map$macro$126)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "map"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "bumpScale"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "bumpMap"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "roughness"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "baseColor"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$132__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "baseColor"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "roughness"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "bumpMap"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "bumpScale"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "map"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$43 = $m_s_$less$colon$less$();
    var ev$1 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$48);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$52 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$52);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$56 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$56);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$60 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$60);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$64 = $m_s_$less$colon$less$();
    var ev$2 = this$64.s_$less$colon$less$__f_singleton;
    var this$65 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$73);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$77 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$77);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$81 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$81);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$91 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$91
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$132$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$132 = new $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32($thiz);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$132
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$133$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "files3d"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "files2d"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "loader")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_common_model_ComponentDetails(x0$47$2);
      if ((x0$47 !== null)) {
        var files3d$macro$155 = $n(x0$47).Lreactbuild_common_model_ComponentDetails__f_files3d;
        var files2d$macro$156 = $n(x0$47).Lreactbuild_common_model_ComponentDetails__f_files2d;
        var loader$macro$157 = $n(x0$47).Lreactbuild_common_model_ComponentDetails__f_loader;
        return new $c_Lshapeless_$colon$colon(files3d$macro$155, new $c_Lshapeless_$colon$colon(files2d$macro$156, new $c_Lshapeless_$colon$colon(loader$macro$157, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_$colon$colon(x0$48$2);
      if ((x0$48 !== null)) {
        var files3d$macro$152 = $as_sci_List($n(x0$48).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$48).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var files2d$macro$153 = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var loader$macro$154 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_common_model_ComponentDetails(files3d$macro$152, files2d$macro$153, loader$macro$154)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$48)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "loader"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "files2d"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "files3d"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$158__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "files3d"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "files2d"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "loader"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$29 = $m_s_$less$colon$less$();
    var ev$1 = this$29.s_$less$colon$less$__f_singleton;
    var this$30 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$30);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$34 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$34);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$38 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$38);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$42 = $m_s_$less$colon$less$();
    var ev$2 = this$42.s_$less$colon$less$__f_singleton;
    var this$43 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$43);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$47 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$47);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$51 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$51);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$133 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$133
}
function $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$158$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$158 = new $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33($thiz);
    $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$158
}
/** @constructor */
function $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1() {
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$2 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$3 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$12 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$13 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$54 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$55 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$80 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$81 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$90 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$91 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$132 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$133 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$158 = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype = new $h_O();
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.constructor = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype;
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$1)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$2)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$3)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$12)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$13)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$54__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$54$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$54)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$55__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$55$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$55)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$80__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((128 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$80$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$80)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$81__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$81$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$81)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$90__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$90$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$90)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$91__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$91$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$91)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$132__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$132$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$132)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$133__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4096 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$133$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$133)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.inst$macro$158__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_bitmap$0) === 0) ? $p_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__inst$macro$158$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1__f_inst$macro$158)
});
var $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1: 0
}, false, "reactbuild.common.model.AssetDetails$anon$lazy$macro$159$1", {
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1.prototype.$classData = $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1;
/** @constructor */
function $c_Lreactbuild_common_model_CityCode$() {
  $n_Lreactbuild_common_model_CityCode$ = this;
  var inst$macro$20 = new $c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_CityCode$.prototype = new $h_O();
$c_Lreactbuild_common_model_CityCode$.prototype.constructor = $c_Lreactbuild_common_model_CityCode$;
/** @constructor */
function $h_Lreactbuild_common_model_CityCode$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_CityCode$.prototype = $c_Lreactbuild_common_model_CityCode$.prototype;
var $d_Lreactbuild_common_model_CityCode$ = new $TypeData().initClass({
  Lreactbuild_common_model_CityCode$: 0
}, false, "reactbuild.common.model.CityCode$", {
  Lreactbuild_common_model_CityCode$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_CityCode$.prototype.$classData = $d_Lreactbuild_common_model_CityCode$;
var $n_Lreactbuild_common_model_CityCode$;
function $m_Lreactbuild_common_model_CityCode$() {
  if ((!$n_Lreactbuild_common_model_CityCode$)) {
    $n_Lreactbuild_common_model_CityCode$ = new $c_Lreactbuild_common_model_CityCode$()
  };
  return $n_Lreactbuild_common_model_CityCode$
}
function $p_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "country"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "code")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_CityCode(x0$7$2);
      if ((x0$7 !== null)) {
        var country$macro$16 = $n(x0$7).Lreactbuild_common_model_CityCode__f_country;
        var code$macro$17 = $n(x0$7).Lreactbuild_common_model_CityCode__f_code;
        return new $c_Lshapeless_$colon$colon(country$macro$16, new $c_Lshapeless_$colon$colon(code$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var country$macro$14 = $as_Lreactbuild_common_model_Country($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var code$macro$15 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_common_model_CityCode(country$macro$14, code$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "code"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "country"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "country"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "code")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "country"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "code"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_inst$macro$1
}
function $p_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_inst$macro$18 = new $c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37($thiz);
    $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6() {
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_inst$macro$18 = null;
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6.prototype = new $h_O();
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6.prototype.constructor = $c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6;
/** @constructor */
function $h_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6.prototype = $c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6.prototype;
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_inst$macro$1)
});
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6__f_inst$macro$18)
});
var $d_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6 = new $TypeData().initClass({
  Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6: 0
}, false, "reactbuild.common.model.CityCode$anon$lazy$macro$19$6", {
  Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6.prototype.$classData = $d_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6;
/** @constructor */
function $c_Lreactbuild_common_model_Color$() {
  this.Lreactbuild_common_model_Color$__f_encodeColor = null;
  this.Lreactbuild_common_model_Color$__f_decodeColor = null;
  $n_Lreactbuild_common_model_Color$ = this;
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $n($as_Lreactbuild_common_model_Color(x$9$2)).Lreactbuild_common_model_Color__f_color;
    return x$9
  }));
  this.Lreactbuild_common_model_Color$__f_encodeColor = new $c_Lio_circe_Encoder$$anon$1(this$3, f);
  $m_Lio_circe_Decoder$();
  var instance$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  var this$5 = $n(instance$1);
  var f$1 = new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $uD(x$10$2);
    return new $c_Lreactbuild_common_model_Color(x$10)
  }));
  this.Lreactbuild_common_model_Color$__f_decodeColor = new $c_Lio_circe_Decoder$$anon$1(this$5, f$1)
}
$c_Lreactbuild_common_model_Color$.prototype = new $h_O();
$c_Lreactbuild_common_model_Color$.prototype.constructor = $c_Lreactbuild_common_model_Color$;
/** @constructor */
function $h_Lreactbuild_common_model_Color$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Color$.prototype = $c_Lreactbuild_common_model_Color$.prototype;
$c_Lreactbuild_common_model_Color$.prototype.productElement$extension__D__I__O = (function(this$, x$1) {
  return ((x$1 === 0) ? this$ : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_model_Color$.prototype.productIterator$extension__D__sc_Iterator = (function(this$) {
  var x = new $c_Lreactbuild_common_model_Color(this$);
  return new $c_sr_ScalaRunTime$$anon$1(x)
});
$c_Lreactbuild_common_model_Color$.prototype.equals$extension__D__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Lreactbuild_common_model_Color)) {
    var Color$1 = $n($as_Lreactbuild_common_model_Color(x$1)).Lreactbuild_common_model_Color__f_color;
    return (this$ === Color$1)
  } else {
    return false
  }
});
$c_Lreactbuild_common_model_Color$.prototype.toString$extension__D__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lreactbuild_common_model_Color(this$))
});
var $d_Lreactbuild_common_model_Color$ = new $TypeData().initClass({
  Lreactbuild_common_model_Color$: 0
}, false, "reactbuild.common.model.Color$", {
  Lreactbuild_common_model_Color$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Color$.prototype.$classData = $d_Lreactbuild_common_model_Color$;
var $n_Lreactbuild_common_model_Color$;
function $m_Lreactbuild_common_model_Color$() {
  if ((!$n_Lreactbuild_common_model_Color$)) {
    $n_Lreactbuild_common_model_Color$ = new $c_Lreactbuild_common_model_Color$()
  };
  return $n_Lreactbuild_common_model_Color$
}
/** @constructor */
function $c_Lreactbuild_common_model_Coordinates$() {
  /*<skip>*/
}
$c_Lreactbuild_common_model_Coordinates$.prototype = new $h_O();
$c_Lreactbuild_common_model_Coordinates$.prototype.constructor = $c_Lreactbuild_common_model_Coordinates$;
/** @constructor */
function $h_Lreactbuild_common_model_Coordinates$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Coordinates$.prototype = $c_Lreactbuild_common_model_Coordinates$.prototype;
$c_Lreactbuild_common_model_Coordinates$.prototype.encodeCoordinates__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var this$1 = $m_Lio_circe_Encoder$();
  var encodeA0 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  var encodeA1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  var instance = new $c_Lio_circe_TupleEncoders$$anon$2(this$1, encodeA0, encodeA1);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_common_model_Coordinates(v$2);
    return new $c_T2$mcDD$sp($n(v).Lreactbuild_common_model_Coordinates__f_lon, $n(v).Lreactbuild_common_model_Coordinates__f_lat)
  }));
  return new $c_Lio_circe_Encoder$$anon$1(instance, f)
});
$c_Lreactbuild_common_model_Coordinates$.prototype.decodeCoordinates__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var this$1 = $m_Lio_circe_Decoder$();
  var decodeA0 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  var decodeA1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  var instance = new $c_Lio_circe_TupleDecoders$$anon$2(this$1, decodeA0, decodeA1);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_T2(v$2);
    return new $c_Lreactbuild_common_model_Coordinates($n(v)._1$mcD$sp__D(), $n(v)._2$mcD$sp__D())
  }));
  return new $c_Lio_circe_Decoder$$anon$1(instance, f)
});
var $d_Lreactbuild_common_model_Coordinates$ = new $TypeData().initClass({
  Lreactbuild_common_model_Coordinates$: 0
}, false, "reactbuild.common.model.Coordinates$", {
  Lreactbuild_common_model_Coordinates$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Coordinates$.prototype.$classData = $d_Lreactbuild_common_model_Coordinates$;
var $n_Lreactbuild_common_model_Coordinates$;
function $m_Lreactbuild_common_model_Coordinates$() {
  if ((!$n_Lreactbuild_common_model_Coordinates$)) {
    $n_Lreactbuild_common_model_Coordinates$ = new $c_Lreactbuild_common_model_Coordinates$()
  };
  return $n_Lreactbuild_common_model_Coordinates$
}
function $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "France")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_common_model_Country(p$2);
      var $$x1 = $m_Lshapeless_Coproduct$();
      if ((p !== $m_Lreactbuild_common_model_Country$France$())) {
        throw new $c_s_MatchError(p)
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x1).unsafeMkCoproduct__I__O__Lshapeless_Coproduct(0, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_common_model_Country($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "France"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$1
}
function $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$2 = new $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35($thiz);
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$2
}
function $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_common_model_Country$France$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_common_model_Country$France$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0 = (((4 | $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$3
}
function $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0 = (((8 | $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$4
}
function $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$5$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_common_model_Country$France$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_common_model_Country$France$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$5 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0 = (((16 | $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$5
}
function $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$6 = new $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36($thiz);
    $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0 = (((32 | $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$6
}
/** @constructor */
function $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2() {
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$2 = null;
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$3 = null;
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$4 = null;
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$5 = null;
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$6 = null;
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype = new $h_O();
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype.constructor = $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2;
/** @constructor */
function $h_Lreactbuild_common_model_Country$anon$lazy$macro$7$2() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype = $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype;
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$1)
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$2)
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((4 & this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$3)
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((8 & this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$4)
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype.inst$macro$5__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((16 & this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$5$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$5)
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype.inst$macro$6__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((32 & this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Country$anon$lazy$macro$7$2__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2__f_inst$macro$6)
});
var $d_Lreactbuild_common_model_Country$anon$lazy$macro$7$2 = new $TypeData().initClass({
  Lreactbuild_common_model_Country$anon$lazy$macro$7$2: 0
}, false, "reactbuild.common.model.Country$anon$lazy$macro$7$2", {
  Lreactbuild_common_model_Country$anon$lazy$macro$7$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2.prototype.$classData = $d_Lreactbuild_common_model_Country$anon$lazy$macro$7$2;
/** @constructor */
function $c_Lreactbuild_common_model_Date$() {
  this.Lreactbuild_common_model_Date$__f_reactbuild$common$model$Date$$dateDayConstant = 0;
  this.Lreactbuild_common_model_Date$__f_codecForDate = null;
  $n_Lreactbuild_common_model_Date$ = this;
  this.Lreactbuild_common_model_Date$__f_reactbuild$common$model$Date$$dateDayConstant = 86400000;
  var inst$macro$12 = new $c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_Date$__f_codecForDate = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_Date$.prototype = new $h_O();
$c_Lreactbuild_common_model_Date$.prototype.constructor = $c_Lreactbuild_common_model_Date$;
/** @constructor */
function $h_Lreactbuild_common_model_Date$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Date$.prototype = $c_Lreactbuild_common_model_Date$.prototype;
$c_Lreactbuild_common_model_Date$.prototype.fromLocalDate__Ljava_time_LocalDate__Lreactbuild_common_model_Date = (function(date) {
  var this$2 = $n(date).toEpochDay__J();
  var value = this.Lreactbuild_common_model_Date$__f_reactbuild$common$model$Date$$dateDayConstant;
  var hi = (value >> 31);
  var alo = this$2.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(alo, hi) + Math.imul(this$2.RTLong__f_hi, value)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_Lreactbuild_common_model_Date(new $c_RTLong(lo, hi$1))
});
var $d_Lreactbuild_common_model_Date$ = new $TypeData().initClass({
  Lreactbuild_common_model_Date$: 0
}, false, "reactbuild.common.model.Date$", {
  Lreactbuild_common_model_Date$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Date$.prototype.$classData = $d_Lreactbuild_common_model_Date$;
var $n_Lreactbuild_common_model_Date$;
function $m_Lreactbuild_common_model_Date$() {
  if ((!$n_Lreactbuild_common_model_Date$)) {
    $n_Lreactbuild_common_model_Date$ = new $c_Lreactbuild_common_model_Date$()
  };
  return $n_Lreactbuild_common_model_Date$
}
function $p_Lreactbuild_common_model_Date$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "value")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_Date(x0$7$2);
      if ((x0$7 !== null)) {
        var t = $n(x0$7).Lreactbuild_common_model_Date__f_value;
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        return new $c_Lshapeless_$colon$colon(new $c_RTLong(lo, hi), $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var t$1 = $uJ($n(x0$8).Lshapeless_$colon$colon__f_head);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_common_model_Date(new $c_RTLong(lo$1, hi$1))
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "value"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t$2 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t$2);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "value")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "value"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_inst$macro$1
}
function $p_Lreactbuild_common_model_Date$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_inst$macro$10 = new $c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5($thiz);
    $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1() {
  this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_inst$macro$10 = null;
  this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1.prototype = new $h_O();
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1.prototype.constructor = $c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1;
/** @constructor */
function $h_Lreactbuild_common_model_Date$anon$lazy$macro$11$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Date$anon$lazy$macro$11$1.prototype = $c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1.prototype;
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Date$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_inst$macro$1)
});
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Date$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1__f_inst$macro$10)
});
var $d_Lreactbuild_common_model_Date$anon$lazy$macro$11$1 = new $TypeData().initClass({
  Lreactbuild_common_model_Date$anon$lazy$macro$11$1: 0
}, false, "reactbuild.common.model.Date$anon$lazy$macro$11$1", {
  Lreactbuild_common_model_Date$anon$lazy$macro$11$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1.prototype.$classData = $d_Lreactbuild_common_model_Date$anon$lazy$macro$11$1;
/** @constructor */
function $c_Lreactbuild_common_model_DeployableWebsite$() {
  this.Lreactbuild_common_model_DeployableWebsite$__f_codecForDeployableWebsite = null;
  $n_Lreactbuild_common_model_DeployableWebsite$ = this;
  var inst$macro$60 = new $c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$60));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_DeployableWebsite$__f_codecForDeployableWebsite = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_DeployableWebsite$.prototype = new $h_O();
$c_Lreactbuild_common_model_DeployableWebsite$.prototype.constructor = $c_Lreactbuild_common_model_DeployableWebsite$;
/** @constructor */
function $h_Lreactbuild_common_model_DeployableWebsite$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_DeployableWebsite$.prototype = $c_Lreactbuild_common_model_DeployableWebsite$.prototype;
var $d_Lreactbuild_common_model_DeployableWebsite$ = new $TypeData().initClass({
  Lreactbuild_common_model_DeployableWebsite$: 0
}, false, "reactbuild.common.model.DeployableWebsite$", {
  Lreactbuild_common_model_DeployableWebsite$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_DeployableWebsite$.prototype.$classData = $d_Lreactbuild_common_model_DeployableWebsite$;
var $n_Lreactbuild_common_model_DeployableWebsite$;
function $m_Lreactbuild_common_model_DeployableWebsite$() {
  if ((!$n_Lreactbuild_common_model_DeployableWebsite$)) {
    $n_Lreactbuild_common_model_DeployableWebsite$ = new $c_Lreactbuild_common_model_DeployableWebsite$()
  };
  return $n_Lreactbuild_common_model_DeployableWebsite$
}
function $p_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "home"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "contact"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "username"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "password"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "url"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "head")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_DeployableWebsite(x0$7$2);
      if ((x0$7 !== null)) {
        var name$macro$51 = $n(x0$7).Lreactbuild_common_model_DeployableWebsite__f_name;
        var home$macro$52 = $n(x0$7).Lreactbuild_common_model_DeployableWebsite__f_home;
        var contact$macro$53 = $n(x0$7).Lreactbuild_common_model_DeployableWebsite__f_contact;
        var username$macro$54 = $n(x0$7).Lreactbuild_common_model_DeployableWebsite__f_username;
        var password$macro$55 = $n(x0$7).Lreactbuild_common_model_DeployableWebsite__f_password;
        var url$macro$56 = $n(x0$7).Lreactbuild_common_model_DeployableWebsite__f_url;
        var head$macro$57 = $n(x0$7).Lreactbuild_common_model_DeployableWebsite__f_head;
        return new $c_Lshapeless_$colon$colon(name$macro$51, new $c_Lshapeless_$colon$colon(home$macro$52, new $c_Lshapeless_$colon$colon(contact$macro$53, new $c_Lshapeless_$colon$colon(username$macro$54, new $c_Lshapeless_$colon$colon(password$macro$55, new $c_Lshapeless_$colon$colon(url$macro$56, new $c_Lshapeless_$colon$colon(head$macro$57, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var name$macro$44 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var home$macro$45 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var contact$macro$46 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var username$macro$47 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var password$macro$48 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var url$macro$49 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var head$macro$50 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_common_model_DeployableWebsite(name$macro$44, home$macro$45, contact$macro$46, username$macro$47, password$macro$48, url$macro$49, head$macro$50)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "head"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "url"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "password"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "username"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "contact"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "home"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$36 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "name"));
    var this$37 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "home"));
    var this$38 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "contact"));
    var this$39 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "username"));
    var this$40 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "password"));
    var this$41 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "url"));
    var this$42 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "head")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "name"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "home"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "contact"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "username"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "password"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "url"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "head"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$75 = $m_s_$less$colon$less$();
    var ev$1 = this$75.s_$less$colon$less$__f_singleton;
    var this$76 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$76);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$80 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$88);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$92 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$92);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$96 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$96);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$100 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$100);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$104 = $m_s_$less$colon$less$();
    var ev$2 = this$104.s_$less$colon$less$__f_singleton;
    var this$105 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$113);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$117 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$117);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$121 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$121);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$125 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$125);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$129 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$129);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_inst$macro$1
}
function $p_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_inst$macro$58 = new $c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20($thiz);
    $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1() {
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_inst$macro$58 = null;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1.prototype = new $h_O();
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1.prototype.constructor = $c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1;
/** @constructor */
function $h_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1.prototype = $c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1.prototype;
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_inst$macro$1)
});
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1.prototype.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1__f_inst$macro$58)
});
var $d_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1 = new $TypeData().initClass({
  Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1: 0
}, false, "reactbuild.common.model.DeployableWebsite$anon$lazy$macro$59$1", {
  Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1.prototype.$classData = $d_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1;
/** @constructor */
function $c_Lreactbuild_common_model_Edge$() {
  $n_Lreactbuild_common_model_Edge$ = this;
  var inst$macro$52 = new $c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$52));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_Edge$.prototype = new $h_O();
$c_Lreactbuild_common_model_Edge$.prototype.constructor = $c_Lreactbuild_common_model_Edge$;
/** @constructor */
function $h_Lreactbuild_common_model_Edge$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Edge$.prototype = $c_Lreactbuild_common_model_Edge$.prototype;
var $d_Lreactbuild_common_model_Edge$ = new $TypeData().initClass({
  Lreactbuild_common_model_Edge$: 0
}, false, "reactbuild.common.model.Edge$", {
  Lreactbuild_common_model_Edge$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Edge$.prototype.$classData = $d_Lreactbuild_common_model_Edge$;
var $n_Lreactbuild_common_model_Edge$;
function $m_Lreactbuild_common_model_Edge$() {
  if ((!$n_Lreactbuild_common_model_Edge$)) {
    $n_Lreactbuild_common_model_Edge$ = new $c_Lreactbuild_common_model_Edge$()
  };
  return $n_Lreactbuild_common_model_Edge$
}
function $p_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "created"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "from"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "to"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "label"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "attributes")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_Edge(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$44 = $n(x0$7).Lreactbuild_common_model_Edge__f__id;
        var created$macro$45 = $n(x0$7).Lreactbuild_common_model_Edge__f_created;
        var from$macro$46 = $n(x0$7).Lreactbuild_common_model_Edge__f_from;
        var to$macro$47 = $n(x0$7).Lreactbuild_common_model_Edge__f_to;
        var label$macro$48 = $n(x0$7).Lreactbuild_common_model_Edge__f_label;
        var attributes$macro$49 = $n(x0$7).Lreactbuild_common_model_Edge__f_attributes;
        return new $c_Lshapeless_$colon$colon(_id$macro$44, new $c_Lshapeless_$colon$colon(created$macro$45, new $c_Lshapeless_$colon$colon(from$macro$46, new $c_Lshapeless_$colon$colon(to$macro$47, new $c_Lshapeless_$colon$colon(label$macro$48, new $c_Lshapeless_$colon$colon(attributes$macro$49, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$38 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var created$macro$39 = $as_Ljava_time_Instant($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var from$macro$40 = $as_Lreactbuild_common_model_TypedRefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var to$macro$41 = $as_Lreactbuild_common_model_TypedRefTo($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var label$macro$42 = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var attributes$macro$43 = $as_Lio_circe_JsonObject($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_common_model_Edge(_id$macro$38, created$macro$39, from$macro$40, to$macro$41, label$macro$42, attributes$macro$43)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "attributes"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "label"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "to"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "from"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x11 = new $c_s_Some(($m_Lreactbuild_common_model_Edge$(), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())));
    $m_Lreactbuild_common_model_Edge$();
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x10 = $m_Ljava_time_Instant$();
    var this$38 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$38.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$38.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $$x9 = new $c_s_Some($n($$x10).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi)));
    var $$x8 = $m_s_None$();
    var $$x7 = $m_s_None$();
    var $$x6 = $m_s_None$();
    $m_Lreactbuild_common_model_Edge$();
    var this$40 = $m_Lio_circe_JsonObject$();
    var fields = $m_sci_Nil$();
    var defaults = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon(new $c_s_Some(this$40.fromIterable__sc_Iterable__Lio_circe_JsonObject(fields)), $m_Lshapeless_HNil$()))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$42 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "_id"));
    var this$43 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "created"));
    var this$44 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "from"));
    var this$45 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "to"));
    var this$46 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "label"));
    var this$47 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "attributes")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$5);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "_id"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "created"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "attributes"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$66 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "_id"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$68 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "created"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$70 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$70, "from"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$72 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$72, "to"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$74 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "label"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$76 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "attributes"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$14);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var fields$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var this$85 = $m_s_$less$colon$less$();
    var ev$1 = this$85.s_$less$colon$less$__f_singleton;
    var this$86 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$86);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$90 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$90);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$94 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$94);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$98 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$98);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$102 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$102);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$106 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$106);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$110 = $m_s_$less$colon$less$();
    var ev$2 = this$110.s_$less$colon$less$__f_singleton;
    var this$111 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$111);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$6, ev$2);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$115 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$115);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$119 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$119);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$123 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$123);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$127 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$127);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$131 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$131);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields$1, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_inst$macro$1
}
function $p_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_inst$macro$50 = new $c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2($thiz);
    $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_inst$macro$50
}
/** @constructor */
function $c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1() {
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_inst$macro$50 = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1.prototype = new $h_O();
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1.prototype.constructor = $c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1;
/** @constructor */
function $h_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1.prototype = $c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1.prototype;
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_inst$macro$1)
});
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1.prototype.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1__f_inst$macro$50)
});
var $d_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1 = new $TypeData().initClass({
  Lreactbuild_common_model_Edge$anon$lazy$macro$51$1: 0
}, false, "reactbuild.common.model.Edge$anon$lazy$macro$51$1", {
  Lreactbuild_common_model_Edge$anon$lazy$macro$51$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1.prototype.$classData = $d_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1;
/** @constructor */
function $c_Lreactbuild_common_model_File$() {
  $n_Lreactbuild_common_model_File$ = this;
  var inst$macro$44 = new $c_Lreactbuild_common_model_File$anon$lazy$macro$43$3().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_File$.prototype = new $h_O();
$c_Lreactbuild_common_model_File$.prototype.constructor = $c_Lreactbuild_common_model_File$;
/** @constructor */
function $h_Lreactbuild_common_model_File$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_File$.prototype = $c_Lreactbuild_common_model_File$.prototype;
var $d_Lreactbuild_common_model_File$ = new $TypeData().initClass({
  Lreactbuild_common_model_File$: 0
}, false, "reactbuild.common.model.File$", {
  Lreactbuild_common_model_File$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_File$.prototype.$classData = $d_Lreactbuild_common_model_File$;
var $n_Lreactbuild_common_model_File$;
function $m_Lreactbuild_common_model_File$() {
  if ((!$n_Lreactbuild_common_model_File$)) {
    $n_Lreactbuild_common_model_File$ = new $c_Lreactbuild_common_model_File$()
  };
  return $n_Lreactbuild_common_model_File$
}
function $p_Lreactbuild_common_model_File$anon$lazy$macro$43$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "contentType"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "savedAt")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_File(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$37 = $n(x0$7).Lreactbuild_common_model_File__f__id;
        var organization$macro$38 = $n(x0$7).Lreactbuild_common_model_File__f_organization;
        var name$macro$39 = $n(x0$7).Lreactbuild_common_model_File__f_name;
        var contentType$macro$40 = $n(x0$7).Lreactbuild_common_model_File__f_contentType;
        var savedAt$macro$41 = $n(x0$7).Lreactbuild_common_model_File__f_savedAt;
        return new $c_Lshapeless_$colon$colon(_id$macro$37, new $c_Lshapeless_$colon$colon(organization$macro$38, new $c_Lshapeless_$colon$colon(name$macro$39, new $c_Lshapeless_$colon$colon(contentType$macro$40, new $c_Lshapeless_$colon$colon(savedAt$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$32 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$33 = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$34 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var contentType$macro$35 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var savedAt$macro$36 = $as_Ljava_time_Instant($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_common_model_File(_id$macro$32, organization$macro$33, name$macro$34, contentType$macro$35, savedAt$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "savedAt"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "contentType"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x9 = new $c_s_Some(($m_Lreactbuild_common_model_File$(), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())));
    var $$x8 = $m_s_None$();
    var $$x7 = $m_s_None$();
    var $$x6 = $m_s_None$();
    $m_Lreactbuild_common_model_File$();
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x5 = $m_Ljava_time_Instant$();
    var this$34 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$34.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$34.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var defaults = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon(new $c_s_Some($n($$x5).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$36 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "_id"));
    var this$37 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "organization"));
    var this$38 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "name"));
    var this$39 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "contentType"));
    var this$40 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "savedAt")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "_id"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "savedAt"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "_id"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "organization"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "name"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "contentType"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "savedAt"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$71 = $m_s_$less$colon$less$();
    var ev$1 = this$71.s_$less$colon$less$__f_singleton;
    var this$72 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$72);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$76 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$76);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$80 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$88);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$92 = $m_s_$less$colon$less$();
    var ev$2 = this$92.s_$less$colon$less$__f_singleton;
    var this$93 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$93);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$97 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$97);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$101 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$109);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_inst$macro$1
}
function $p_Lreactbuild_common_model_File$anon$lazy$macro$43$3__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_inst$macro$42 = new $c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26($thiz);
    $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_common_model_File$anon$lazy$macro$43$3() {
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_inst$macro$42 = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3.prototype = new $h_O();
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3.prototype.constructor = $c_Lreactbuild_common_model_File$anon$lazy$macro$43$3;
/** @constructor */
function $h_Lreactbuild_common_model_File$anon$lazy$macro$43$3() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_File$anon$lazy$macro$43$3.prototype = $c_Lreactbuild_common_model_File$anon$lazy$macro$43$3.prototype;
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_File$anon$lazy$macro$43$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_inst$macro$1)
});
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_File$anon$lazy$macro$43$3__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_File$anon$lazy$macro$43$3__f_inst$macro$42)
});
var $d_Lreactbuild_common_model_File$anon$lazy$macro$43$3 = new $TypeData().initClass({
  Lreactbuild_common_model_File$anon$lazy$macro$43$3: 0
}, false, "reactbuild.common.model.File$anon$lazy$macro$43$3", {
  Lreactbuild_common_model_File$anon$lazy$macro$43$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3.prototype.$classData = $d_Lreactbuild_common_model_File$anon$lazy$macro$43$3;
/** @constructor */
function $c_Lreactbuild_common_model_Image$() {
  this.Lreactbuild_common_model_Image$__f_codecForImage = null;
  $n_Lreactbuild_common_model_Image$ = this;
  var inst$macro$44 = new $c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_Image$__f_codecForImage = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_Image$.prototype = new $h_O();
$c_Lreactbuild_common_model_Image$.prototype.constructor = $c_Lreactbuild_common_model_Image$;
/** @constructor */
function $h_Lreactbuild_common_model_Image$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Image$.prototype = $c_Lreactbuild_common_model_Image$.prototype;
var $d_Lreactbuild_common_model_Image$ = new $TypeData().initClass({
  Lreactbuild_common_model_Image$: 0
}, false, "reactbuild.common.model.Image$", {
  Lreactbuild_common_model_Image$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Image$.prototype.$classData = $d_Lreactbuild_common_model_Image$;
var $n_Lreactbuild_common_model_Image$;
function $m_Lreactbuild_common_model_Image$() {
  if ((!$n_Lreactbuild_common_model_Image$)) {
    $n_Lreactbuild_common_model_Image$ = new $c_Lreactbuild_common_model_Image$()
  };
  return $n_Lreactbuild_common_model_Image$
}
function $p_Lreactbuild_common_model_Image$anon$lazy$macro$43$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "url"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "width"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "height"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "title"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "markers")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_Image(x0$7$2);
      if ((x0$7 !== null)) {
        var url$macro$37 = $n(x0$7).Lreactbuild_common_model_Image__f_url;
        var width$macro$38 = $n(x0$7).Lreactbuild_common_model_Image__f_width;
        var height$macro$39 = $n(x0$7).Lreactbuild_common_model_Image__f_height;
        var title$macro$40 = $n(x0$7).Lreactbuild_common_model_Image__f_title;
        var markers$macro$41 = $n(x0$7).Lreactbuild_common_model_Image__f_markers;
        return new $c_Lshapeless_$colon$colon(url$macro$37, new $c_Lshapeless_$colon$colon(width$macro$38, new $c_Lshapeless_$colon$colon(height$macro$39, new $c_Lshapeless_$colon$colon(title$macro$40, new $c_Lshapeless_$colon$colon(markers$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var url$macro$32 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var width$macro$33 = $uI($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var height$macro$34 = $uI($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var title$macro$35 = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var markers$macro$36 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_common_model_Image(url$macro$32, width$macro$33, height$macro$34, title$macro$35, markers$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "markers"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "height"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "width"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "url"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$28 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "url"));
    var this$29 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "width"));
    var this$30 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "height"));
    var this$31 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "title"));
    var this$32 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "markers")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "url"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "width"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "height"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "title"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "markers"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$57 = $m_s_$less$colon$less$();
    var ev$1 = this$57.s_$less$colon$less$__f_singleton;
    var this$58 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$74);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$78 = $m_s_$less$colon$less$();
    var ev$2 = this$78.s_$less$colon$less$__f_singleton;
    var this$79 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$83);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$87 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$91);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$95 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$95);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_inst$macro$1
}
function $p_Lreactbuild_common_model_Image$anon$lazy$macro$43$2__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_inst$macro$42 = new $c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15($thiz);
    $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2() {
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_inst$macro$42 = null;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2.prototype = new $h_O();
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2.prototype.constructor = $c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2;
/** @constructor */
function $h_Lreactbuild_common_model_Image$anon$lazy$macro$43$2() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Image$anon$lazy$macro$43$2.prototype = $c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2.prototype;
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Image$anon$lazy$macro$43$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_inst$macro$1)
});
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Image$anon$lazy$macro$43$2__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2__f_inst$macro$42)
});
var $d_Lreactbuild_common_model_Image$anon$lazy$macro$43$2 = new $TypeData().initClass({
  Lreactbuild_common_model_Image$anon$lazy$macro$43$2: 0
}, false, "reactbuild.common.model.Image$anon$lazy$macro$43$2", {
  Lreactbuild_common_model_Image$anon$lazy$macro$43$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2.prototype.$classData = $d_Lreactbuild_common_model_Image$anon$lazy$macro$43$2;
/** @constructor */
function $c_Lreactbuild_common_model_ImageCoordinates$() {
  $n_Lreactbuild_common_model_ImageCoordinates$ = this;
  var inst$macro$20 = new $c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_ImageCoordinates$.prototype = new $h_O();
$c_Lreactbuild_common_model_ImageCoordinates$.prototype.constructor = $c_Lreactbuild_common_model_ImageCoordinates$;
/** @constructor */
function $h_Lreactbuild_common_model_ImageCoordinates$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ImageCoordinates$.prototype = $c_Lreactbuild_common_model_ImageCoordinates$.prototype;
var $d_Lreactbuild_common_model_ImageCoordinates$ = new $TypeData().initClass({
  Lreactbuild_common_model_ImageCoordinates$: 0
}, false, "reactbuild.common.model.ImageCoordinates$", {
  Lreactbuild_common_model_ImageCoordinates$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ImageCoordinates$.prototype.$classData = $d_Lreactbuild_common_model_ImageCoordinates$;
var $n_Lreactbuild_common_model_ImageCoordinates$;
function $m_Lreactbuild_common_model_ImageCoordinates$() {
  if ((!$n_Lreactbuild_common_model_ImageCoordinates$)) {
    $n_Lreactbuild_common_model_ImageCoordinates$ = new $c_Lreactbuild_common_model_ImageCoordinates$()
  };
  return $n_Lreactbuild_common_model_ImageCoordinates$
}
function $p_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_ImageCoordinates(x0$7$2);
      if ((x0$7 !== null)) {
        var x$macro$16 = $n(x0$7).Lreactbuild_common_model_ImageCoordinates__f_x;
        var y$macro$17 = $n(x0$7).Lreactbuild_common_model_ImageCoordinates__f_y;
        return new $c_Lshapeless_$colon$colon(x$macro$16, new $c_Lshapeless_$colon$colon(y$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var x$macro$14 = $uD($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$15 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_common_model_ImageCoordinates(x$macro$14, y$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "x"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "y")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "x"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "y"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_inst$macro$1
}
function $p_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_inst$macro$18 = new $c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14($thiz);
    $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3() {
  this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_inst$macro$18 = null;
  this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3.prototype = new $h_O();
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3.prototype.constructor = $c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3;
/** @constructor */
function $h_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3.prototype = $c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3.prototype;
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_inst$macro$1)
});
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3__f_inst$macro$18)
});
var $d_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3 = new $TypeData().initClass({
  Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3: 0
}, false, "reactbuild.common.model.ImageCoordinates$anon$lazy$macro$19$3", {
  Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3.prototype.$classData = $d_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3;
/** @constructor */
function $c_Lreactbuild_common_model_ListProjects$() {
  $n_Lreactbuild_common_model_ListProjects$ = this;
  var inst$macro$20 = new $c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_ListProjects$.prototype = new $h_O();
$c_Lreactbuild_common_model_ListProjects$.prototype.constructor = $c_Lreactbuild_common_model_ListProjects$;
/** @constructor */
function $h_Lreactbuild_common_model_ListProjects$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ListProjects$.prototype = $c_Lreactbuild_common_model_ListProjects$.prototype;
var $d_Lreactbuild_common_model_ListProjects$ = new $TypeData().initClass({
  Lreactbuild_common_model_ListProjects$: 0
}, false, "reactbuild.common.model.ListProjects$", {
  Lreactbuild_common_model_ListProjects$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ListProjects$.prototype.$classData = $d_Lreactbuild_common_model_ListProjects$;
var $n_Lreactbuild_common_model_ListProjects$;
function $m_Lreactbuild_common_model_ListProjects$() {
  if ((!$n_Lreactbuild_common_model_ListProjects$)) {
    $n_Lreactbuild_common_model_ListProjects$ = new $c_Lreactbuild_common_model_ListProjects$()
  };
  return $n_Lreactbuild_common_model_ListProjects$
}
function $p_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "logged"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "projects")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_ListProjects(x0$7$2);
      if ((x0$7 !== null)) {
        var logged$macro$16 = $n(x0$7).Lreactbuild_common_model_ListProjects__f_logged;
        var projects$macro$17 = $n(x0$7).Lreactbuild_common_model_ListProjects__f_projects;
        return new $c_Lshapeless_$colon$colon(logged$macro$16, new $c_Lshapeless_$colon$colon(projects$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var logged$macro$14 = $as_s_Option($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var projects$macro$15 = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_common_model_ListProjects(logged$macro$14, projects$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "projects"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "logged"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "logged"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "projects")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "logged"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "projects"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_inst$macro$1
}
function $p_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_inst$macro$18 = new $c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17($thiz);
    $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5() {
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_inst$macro$18 = null;
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5.prototype = new $h_O();
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5.prototype.constructor = $c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5;
/** @constructor */
function $h_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5.prototype = $c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5.prototype;
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_inst$macro$1)
});
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5__f_inst$macro$18)
});
var $d_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5 = new $TypeData().initClass({
  Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5: 0
}, false, "reactbuild.common.model.ListProjects$anon$lazy$macro$19$5", {
  Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5.prototype.$classData = $d_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5;
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUser$() {
  this.Lreactbuild_common_model_LoggedUser$__f_codecForLoggedUser = null;
  $n_Lreactbuild_common_model_LoggedUser$ = this;
  var inst$macro$36 = new $c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_LoggedUser$__f_codecForLoggedUser = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_LoggedUser$.prototype = new $h_O();
$c_Lreactbuild_common_model_LoggedUser$.prototype.constructor = $c_Lreactbuild_common_model_LoggedUser$;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUser$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUser$.prototype = $c_Lreactbuild_common_model_LoggedUser$.prototype;
var $d_Lreactbuild_common_model_LoggedUser$ = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUser$: 0
}, false, "reactbuild.common.model.LoggedUser$", {
  Lreactbuild_common_model_LoggedUser$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_LoggedUser$.prototype.$classData = $d_Lreactbuild_common_model_LoggedUser$;
var $n_Lreactbuild_common_model_LoggedUser$;
function $m_Lreactbuild_common_model_LoggedUser$() {
  if ((!$n_Lreactbuild_common_model_LoggedUser$)) {
    $n_Lreactbuild_common_model_LoggedUser$ = new $c_Lreactbuild_common_model_LoggedUser$()
  };
  return $n_Lreactbuild_common_model_LoggedUser$
}
function $p_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "email"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "avatar")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_LoggedUser(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$30 = $n(x0$7).Lreactbuild_common_model_LoggedUser__f__id;
        var email$macro$31 = $n(x0$7).Lreactbuild_common_model_LoggedUser__f_email;
        var name$macro$32 = $n(x0$7).Lreactbuild_common_model_LoggedUser__f_name;
        var avatar$macro$33 = $n(x0$7).Lreactbuild_common_model_LoggedUser__f_avatar;
        return new $c_Lshapeless_$colon$colon(_id$macro$30, new $c_Lshapeless_$colon$colon(email$macro$31, new $c_Lshapeless_$colon$colon(name$macro$32, new $c_Lshapeless_$colon$colon(avatar$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$26 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var email$macro$27 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$28 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var avatar$macro$29 = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_common_model_LoggedUser(_id$macro$26, email$macro$27, name$macro$28, avatar$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "avatar"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "email"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$24 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "_id"));
    var this$25 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "email"));
    var this$26 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "name"));
    var this$27 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "avatar")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "email"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "avatar"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$48 = $m_s_$less$colon$less$();
    var ev$1 = this$48.s_$less$colon$less$__f_singleton;
    var this$49 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$49);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$53 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$61);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$65 = $m_s_$less$colon$less$();
    var ev$2 = this$65.s_$less$colon$less$__f_singleton;
    var this$66 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$78);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_inst$macro$1
}
function $p_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_inst$macro$34 = new $c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10($thiz);
    $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4() {
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_inst$macro$34 = null;
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4.prototype = new $h_O();
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4.prototype.constructor = $c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4.prototype = $c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4.prototype;
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_inst$macro$1)
});
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4__f_inst$macro$34)
});
var $d_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4 = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4: 0
}, false, "reactbuild.common.model.LoggedUser$anon$lazy$macro$35$4", {
  Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4.prototype.$classData = $d_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4;
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUserOrganization$() {
  this.Lreactbuild_common_model_LoggedUserOrganization$__f_codecForLoggedUserOrganization = null;
  $n_Lreactbuild_common_model_LoggedUserOrganization$ = this;
  var inst$macro$36 = new $c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_LoggedUserOrganization$__f_codecForLoggedUserOrganization = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_LoggedUserOrganization$.prototype = new $h_O();
$c_Lreactbuild_common_model_LoggedUserOrganization$.prototype.constructor = $c_Lreactbuild_common_model_LoggedUserOrganization$;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUserOrganization$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUserOrganization$.prototype = $c_Lreactbuild_common_model_LoggedUserOrganization$.prototype;
var $d_Lreactbuild_common_model_LoggedUserOrganization$ = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUserOrganization$: 0
}, false, "reactbuild.common.model.LoggedUserOrganization$", {
  Lreactbuild_common_model_LoggedUserOrganization$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_LoggedUserOrganization$.prototype.$classData = $d_Lreactbuild_common_model_LoggedUserOrganization$;
var $n_Lreactbuild_common_model_LoggedUserOrganization$;
function $m_Lreactbuild_common_model_LoggedUserOrganization$() {
  if ((!$n_Lreactbuild_common_model_LoggedUserOrganization$)) {
    $n_Lreactbuild_common_model_LoggedUserOrganization$ = new $c_Lreactbuild_common_model_LoggedUserOrganization$()
  };
  return $n_Lreactbuild_common_model_LoggedUserOrganization$
}
function $p_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "path"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "organizationUser")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_LoggedUserOrganization(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$30 = $n(x0$7).Lreactbuild_common_model_LoggedUserOrganization__f__id;
        var path$macro$31 = $n(x0$7).Lreactbuild_common_model_LoggedUserOrganization__f_path;
        var name$macro$32 = $n(x0$7).Lreactbuild_common_model_LoggedUserOrganization__f_name;
        var organizationUser$macro$33 = $n(x0$7).Lreactbuild_common_model_LoggedUserOrganization__f_organizationUser;
        return new $c_Lshapeless_$colon$colon(_id$macro$30, new $c_Lshapeless_$colon$colon(path$macro$31, new $c_Lshapeless_$colon$colon(name$macro$32, new $c_Lshapeless_$colon$colon(organizationUser$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$26 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var path$macro$27 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$28 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var organizationUser$macro$29 = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_common_model_LoggedUserOrganization(_id$macro$26, path$macro$27, name$macro$28, organizationUser$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "organizationUser"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "path"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_LoggedUserOrganization$(), $m_s_None$())), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$25 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "_id"));
    var this$26 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "path"));
    var this$27 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "name"));
    var this$28 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "organizationUser")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "name"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "path"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "organizationUser"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$52 = $m_s_$less$colon$less$();
    var ev$1 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$61);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$65 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$65);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$69 = $m_s_$less$colon$less$();
    var ev$2 = this$69.s_$less$colon$less$__f_singleton;
    var this$70 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$82);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_inst$macro$1
}
function $p_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_inst$macro$34 = new $c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9($thiz);
    $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3() {
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_inst$macro$34 = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3.prototype = new $h_O();
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3.prototype.constructor = $c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3.prototype = $c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3.prototype;
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_inst$macro$1)
});
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3__f_inst$macro$34)
});
var $d_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3 = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3: 0
}, false, "reactbuild.common.model.LoggedUserOrganization$anon$lazy$macro$35$3", {
  Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3.prototype.$classData = $d_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3;
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUserWithOrganizations$() {
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$__f_codecForLoggedUserWithOrganizations = null;
  $n_Lreactbuild_common_model_LoggedUserWithOrganizations$ = this;
  var inst$macro$20 = new $c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$__f_codecForLoggedUserWithOrganizations = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$.prototype = new $h_O();
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$.prototype.constructor = $c_Lreactbuild_common_model_LoggedUserWithOrganizations$;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUserWithOrganizations$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUserWithOrganizations$.prototype = $c_Lreactbuild_common_model_LoggedUserWithOrganizations$.prototype;
var $d_Lreactbuild_common_model_LoggedUserWithOrganizations$ = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUserWithOrganizations$: 0
}, false, "reactbuild.common.model.LoggedUserWithOrganizations$", {
  Lreactbuild_common_model_LoggedUserWithOrganizations$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$.prototype.$classData = $d_Lreactbuild_common_model_LoggedUserWithOrganizations$;
var $n_Lreactbuild_common_model_LoggedUserWithOrganizations$;
function $m_Lreactbuild_common_model_LoggedUserWithOrganizations$() {
  if ((!$n_Lreactbuild_common_model_LoggedUserWithOrganizations$)) {
    $n_Lreactbuild_common_model_LoggedUserWithOrganizations$ = new $c_Lreactbuild_common_model_LoggedUserWithOrganizations$()
  };
  return $n_Lreactbuild_common_model_LoggedUserWithOrganizations$
}
function $p_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "user"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organizations")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(x0$7$2);
      if ((x0$7 !== null)) {
        var user$macro$16 = $n(x0$7).Lreactbuild_common_model_LoggedUserWithOrganizations__f_user;
        var organizations$macro$17 = $n(x0$7).Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations;
        return new $c_Lshapeless_$colon$colon(user$macro$16, new $c_Lshapeless_$colon$colon(organizations$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var user$macro$14 = $as_Lreactbuild_common_model_LoggedUser($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organizations$macro$15 = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_common_model_LoggedUserWithOrganizations(user$macro$14, organizations$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "organizations"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "user"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "user"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "organizations")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "user"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "organizations"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_inst$macro$1
}
function $p_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_inst$macro$18 = new $c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11($thiz);
    $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2() {
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_inst$macro$18 = null;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2.prototype = new $h_O();
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2.prototype.constructor = $c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2.prototype = $c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2.prototype;
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_inst$macro$1)
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2__f_inst$macro$18)
});
var $d_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2 = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2: 0
}, false, "reactbuild.common.model.LoggedUserWithOrganizations$anon$lazy$macro$19$2", {
  Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2.prototype.$classData = $d_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2;
/** @constructor */
function $c_Lreactbuild_common_model_Marker$() {
  this.Lreactbuild_common_model_Marker$__f_codecForMarker = null;
  $n_Lreactbuild_common_model_Marker$ = this;
  var inst$macro$28 = new $c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_Marker$__f_codecForMarker = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_Marker$.prototype = new $h_O();
$c_Lreactbuild_common_model_Marker$.prototype.constructor = $c_Lreactbuild_common_model_Marker$;
/** @constructor */
function $h_Lreactbuild_common_model_Marker$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Marker$.prototype = $c_Lreactbuild_common_model_Marker$.prototype;
var $d_Lreactbuild_common_model_Marker$ = new $TypeData().initClass({
  Lreactbuild_common_model_Marker$: 0
}, false, "reactbuild.common.model.Marker$", {
  Lreactbuild_common_model_Marker$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Marker$.prototype.$classData = $d_Lreactbuild_common_model_Marker$;
var $n_Lreactbuild_common_model_Marker$;
function $m_Lreactbuild_common_model_Marker$() {
  if ((!$n_Lreactbuild_common_model_Marker$)) {
    $n_Lreactbuild_common_model_Marker$ = new $c_Lreactbuild_common_model_Marker$()
  };
  return $n_Lreactbuild_common_model_Marker$
}
function $p_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "label"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "x"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "y")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_Marker(x0$7$2);
      if ((x0$7 !== null)) {
        var label$macro$23 = $n(x0$7).Lreactbuild_common_model_Marker__f_label;
        var x$macro$24 = $n(x0$7).Lreactbuild_common_model_Marker__f_x;
        var y$macro$25 = $n(x0$7).Lreactbuild_common_model_Marker__f_y;
        return new $c_Lshapeless_$colon$colon(label$macro$23, new $c_Lshapeless_$colon$colon(x$macro$24, new $c_Lshapeless_$colon$colon(y$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var label$macro$20 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var x$macro$21 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var y$macro$22 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_common_model_Marker(label$macro$20, x$macro$21, y$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "label"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "label"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "x"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "y")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "label"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "x"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "y"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_inst$macro$1
}
function $p_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_inst$macro$26 = new $c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13($thiz);
    $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1() {
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_inst$macro$26 = null;
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1.prototype = new $h_O();
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1.prototype.constructor = $c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1;
/** @constructor */
function $h_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1.prototype = $c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1.prototype;
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_inst$macro$1)
});
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1__f_inst$macro$26)
});
var $d_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1 = new $TypeData().initClass({
  Lreactbuild_common_model_Marker$anon$lazy$macro$27$1: 0
}, false, "reactbuild.common.model.Marker$anon$lazy$macro$27$1", {
  Lreactbuild_common_model_Marker$anon$lazy$macro$27$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1.prototype.$classData = $d_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1;
/** @constructor */
function $c_Lreactbuild_common_model_Organization$() {
  $n_Lreactbuild_common_model_Organization$ = this;
  var inst$macro$36 = new $c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_Organization$.prototype = new $h_O();
$c_Lreactbuild_common_model_Organization$.prototype.constructor = $c_Lreactbuild_common_model_Organization$;
/** @constructor */
function $h_Lreactbuild_common_model_Organization$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Organization$.prototype = $c_Lreactbuild_common_model_Organization$.prototype;
var $d_Lreactbuild_common_model_Organization$ = new $TypeData().initClass({
  Lreactbuild_common_model_Organization$: 0
}, false, "reactbuild.common.model.Organization$", {
  Lreactbuild_common_model_Organization$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Organization$.prototype.$classData = $d_Lreactbuild_common_model_Organization$;
var $n_Lreactbuild_common_model_Organization$;
function $m_Lreactbuild_common_model_Organization$() {
  if ((!$n_Lreactbuild_common_model_Organization$)) {
    $n_Lreactbuild_common_model_Organization$ = new $c_Lreactbuild_common_model_Organization$()
  };
  return $n_Lreactbuild_common_model_Organization$
}
function $p_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "path"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "settings")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_Organization(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$30 = $n(x0$7).Lreactbuild_common_model_Organization__f__id;
        var path$macro$31 = $n(x0$7).Lreactbuild_common_model_Organization__f_path;
        var name$macro$32 = $n(x0$7).Lreactbuild_common_model_Organization__f_name;
        var settings$macro$33 = $n(x0$7).Lreactbuild_common_model_Organization__f_settings;
        return new $c_Lshapeless_$colon$colon(_id$macro$30, new $c_Lshapeless_$colon$colon(path$macro$31, new $c_Lshapeless_$colon$colon(name$macro$32, new $c_Lshapeless_$colon$colon(settings$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$26 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var path$macro$27 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$28 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var settings$macro$29 = $as_Lreactbuild_common_model_OrganizationSettings($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_common_model_Organization(_id$macro$26, path$macro$27, name$macro$28, settings$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "settings"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "path"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Organization$(), $m_s_None$())), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$25 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "_id"));
    var this$26 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "path"));
    var this$27 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "name"));
    var this$28 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "settings")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "name"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "path"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "settings"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$52 = $m_s_$less$colon$less$();
    var ev$1 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$61);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$65 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$65);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$69 = $m_s_$less$colon$less$();
    var ev$2 = this$69.s_$less$colon$less$__f_singleton;
    var this$70 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$82);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_inst$macro$1
}
function $p_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_inst$macro$34 = new $c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8($thiz);
    $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2() {
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_inst$macro$34 = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2.prototype = new $h_O();
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2.prototype.constructor = $c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2;
/** @constructor */
function $h_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2.prototype = $c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2.prototype;
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_inst$macro$1)
});
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2__f_inst$macro$34)
});
var $d_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2 = new $TypeData().initClass({
  Lreactbuild_common_model_Organization$anon$lazy$macro$35$2: 0
}, false, "reactbuild.common.model.Organization$anon$lazy$macro$35$2", {
  Lreactbuild_common_model_Organization$anon$lazy$macro$35$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2.prototype.$classData = $d_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2;
/** @constructor */
function $c_Lreactbuild_common_model_OrganizationSettings$() {
  this.Lreactbuild_common_model_OrganizationSettings$__f_codecForOrganizationSettings = null;
  $n_Lreactbuild_common_model_OrganizationSettings$ = this;
  var inst$macro$12 = new $c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_OrganizationSettings$__f_codecForOrganizationSettings = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_OrganizationSettings$.prototype = new $h_O();
$c_Lreactbuild_common_model_OrganizationSettings$.prototype.constructor = $c_Lreactbuild_common_model_OrganizationSettings$;
/** @constructor */
function $h_Lreactbuild_common_model_OrganizationSettings$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_OrganizationSettings$.prototype = $c_Lreactbuild_common_model_OrganizationSettings$.prototype;
var $d_Lreactbuild_common_model_OrganizationSettings$ = new $TypeData().initClass({
  Lreactbuild_common_model_OrganizationSettings$: 0
}, false, "reactbuild.common.model.OrganizationSettings$", {
  Lreactbuild_common_model_OrganizationSettings$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_OrganizationSettings$.prototype.$classData = $d_Lreactbuild_common_model_OrganizationSettings$;
var $n_Lreactbuild_common_model_OrganizationSettings$;
function $m_Lreactbuild_common_model_OrganizationSettings$() {
  if ((!$n_Lreactbuild_common_model_OrganizationSettings$)) {
    $n_Lreactbuild_common_model_OrganizationSettings$ = new $c_Lreactbuild_common_model_OrganizationSettings$()
  };
  return $n_Lreactbuild_common_model_OrganizationSettings$
}
function $p_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "usersNotifiedByIncomingCommunication")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_OrganizationSettings(x0$7$2);
      if ((x0$7 !== null)) {
        var usersNotifiedByIncomingCommunication$macro$9 = $n(x0$7).Lreactbuild_common_model_OrganizationSettings__f_usersNotifiedByIncomingCommunication;
        return new $c_Lshapeless_$colon$colon(usersNotifiedByIncomingCommunication$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var usersNotifiedByIncomingCommunication$macro$8 = $as_sci_Seq($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_common_model_OrganizationSettings(usersNotifiedByIncomingCommunication$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "usersNotifiedByIncomingCommunication"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "usersNotifiedByIncomingCommunication")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "usersNotifiedByIncomingCommunication"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_inst$macro$1
}
function $p_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_inst$macro$10 = new $c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7($thiz);
    $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2() {
  this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_inst$macro$10 = null;
  this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2.prototype = new $h_O();
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2.prototype.constructor = $c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2;
/** @constructor */
function $h_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2.prototype = $c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2.prototype;
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_inst$macro$1)
});
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2__f_inst$macro$10)
});
var $d_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2 = new $TypeData().initClass({
  Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2: 0
}, false, "reactbuild.common.model.OrganizationSettings$anon$lazy$macro$11$2", {
  Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2.prototype.$classData = $d_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2;
/** @constructor */
function $c_Lreactbuild_common_model_OrganizationUser$() {
  this.Lreactbuild_common_model_OrganizationUser$__f_codecForOrganizationUser = null;
  $n_Lreactbuild_common_model_OrganizationUser$ = this;
  var inst$macro$36 = new $c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_OrganizationUser$__f_codecForOrganizationUser = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_OrganizationUser$.prototype = new $h_O();
$c_Lreactbuild_common_model_OrganizationUser$.prototype.constructor = $c_Lreactbuild_common_model_OrganizationUser$;
/** @constructor */
function $h_Lreactbuild_common_model_OrganizationUser$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_OrganizationUser$.prototype = $c_Lreactbuild_common_model_OrganizationUser$.prototype;
var $d_Lreactbuild_common_model_OrganizationUser$ = new $TypeData().initClass({
  Lreactbuild_common_model_OrganizationUser$: 0
}, false, "reactbuild.common.model.OrganizationUser$", {
  Lreactbuild_common_model_OrganizationUser$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_OrganizationUser$.prototype.$classData = $d_Lreactbuild_common_model_OrganizationUser$;
var $n_Lreactbuild_common_model_OrganizationUser$;
function $m_Lreactbuild_common_model_OrganizationUser$() {
  if ((!$n_Lreactbuild_common_model_OrganizationUser$)) {
    $n_Lreactbuild_common_model_OrganizationUser$ = new $c_Lreactbuild_common_model_OrganizationUser$()
  };
  return $n_Lreactbuild_common_model_OrganizationUser$
}
function $p_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "email"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "name")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_OrganizationUser(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$30 = $n(x0$7).Lreactbuild_common_model_OrganizationUser__f__id;
        var organization$macro$31 = $n(x0$7).Lreactbuild_common_model_OrganizationUser__f_organization;
        var email$macro$32 = $n(x0$7).Lreactbuild_common_model_OrganizationUser__f_email;
        var name$macro$33 = $n(x0$7).Lreactbuild_common_model_OrganizationUser__f_name;
        return new $c_Lshapeless_$colon$colon(_id$macro$30, new $c_Lshapeless_$colon$colon(organization$macro$31, new $c_Lshapeless_$colon$colon(email$macro$32, new $c_Lshapeless_$colon$colon(name$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$26 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$27 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var email$macro$28 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var name$macro$29 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_common_model_OrganizationUser(_id$macro$26, organization$macro$27, email$macro$28, name$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "email"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_OrganizationUser$(), $m_s_None$())), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$25 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "_id"));
    var this$26 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "organization"));
    var this$27 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "email"));
    var this$28 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "name")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "name"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "organization"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "email"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "name"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$52 = $m_s_$less$colon$less$();
    var ev$1 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$61);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$65 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$65);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$69 = $m_s_$less$colon$less$();
    var ev$2 = this$69.s_$less$colon$less$__f_singleton;
    var this$70 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$82);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_inst$macro$1
}
function $p_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_inst$macro$34 = new $c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6($thiz);
    $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1() {
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_inst$macro$34 = null;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1.prototype = new $h_O();
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1.prototype.constructor = $c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1;
/** @constructor */
function $h_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1.prototype = $c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1.prototype;
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_inst$macro$1)
});
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1__f_inst$macro$34)
});
var $d_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1 = new $TypeData().initClass({
  Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1: 0
}, false, "reactbuild.common.model.OrganizationUser$anon$lazy$macro$35$1", {
  Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1.prototype.$classData = $d_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1;
/** @constructor */
function $c_Lreactbuild_common_model_Project$() {
  this.Lreactbuild_common_model_Project$__f_codecForProject = null;
  $n_Lreactbuild_common_model_Project$ = this;
  var inst$macro$100 = new $c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$100));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_Project$__f_codecForProject = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_Project$.prototype = new $h_O();
$c_Lreactbuild_common_model_Project$.prototype.constructor = $c_Lreactbuild_common_model_Project$;
/** @constructor */
function $h_Lreactbuild_common_model_Project$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Project$.prototype = $c_Lreactbuild_common_model_Project$.prototype;
$c_Lreactbuild_common_model_Project$.prototype.keyMapper__Lcom_iz2use_common_KeyMapper = (function() {
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_Lreactbuild_common_model_Project(x$8$2);
    return $n(x$8).Lreactbuild_common_model_Project__f__id
  }));
  var ev = $m_Lreactbuild_common_model_RefTo$().keyMapper__Lcom_iz2use_common_KeyMapper();
  return new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f)
});
var $d_Lreactbuild_common_model_Project$ = new $TypeData().initClass({
  Lreactbuild_common_model_Project$: 0
}, false, "reactbuild.common.model.Project$", {
  Lreactbuild_common_model_Project$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Project$.prototype.$classData = $d_Lreactbuild_common_model_Project$;
var $n_Lreactbuild_common_model_Project$;
function $m_Lreactbuild_common_model_Project$() {
  if ((!$n_Lreactbuild_common_model_Project$)) {
    $n_Lreactbuild_common_model_Project$ = new $c_Lreactbuild_common_model_Project$()
  };
  return $n_Lreactbuild_common_model_Project$
}
function $p_Lreactbuild_common_model_Project$anon$lazy$macro$99$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organizations"));
    var this$3 = $m_s_Symbol$();
    var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name"));
    var this$4 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "title"));
    var this$5 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "description"));
    var this$6 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "images"));
    var this$7 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "location"));
    var this$8 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "areas"));
    var this$9 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "price"));
    var this$10 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "soldOut"));
    var this$11 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "privacy"));
    var this$12 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "scenes"));
    var this$13 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "renderSettings"));
    var this$14 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "city"));
    var this$15 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "district"));
    var this$16 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "topic"));
    var this$17 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "modelSource"));
    var this$18 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "procedureState"));
    var this$19 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "summary"));
    var this$20 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "archived"));
    var this$21 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "parent"));
    var this$22 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "address"));
    var this$23 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "reference")), $m_Lshapeless_HNil$())))))))))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_Project(x0$7$2);
      return new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f__id, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_organizations, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_name, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_title, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_description, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_images, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_location, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_areas, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_price, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_soldOut, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_privacy, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_scenes, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_renderSettings, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_city, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_district, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_topic, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_modelSource, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_procedureState, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_summary, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_archived, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_parent, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_address, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_common_model_Project__f_reference, $m_Lshapeless_HNil$())))))))))))))))))))))))
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$74 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organizations$macro$75 = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$76 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var title$macro$77 = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var description$macro$78 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var images$macro$79 = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var location$macro$80 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var areas$macro$81 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var price$macro$82 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var soldOut$macro$83 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                          if ((p11 !== null)) {
                            var privacy$macro$84 = $as_s_Option($n(p11).Lshapeless_$colon$colon__f_head);
                            var p12 = $as_Lshapeless_$colon$colon($n(p11).Lshapeless_$colon$colon__f_tail);
                            if ((p12 !== null)) {
                              var scenes$macro$85 = $as_s_Option($n(p12).Lshapeless_$colon$colon__f_head);
                              var p13 = $as_Lshapeless_$colon$colon($n(p12).Lshapeless_$colon$colon__f_tail);
                              if ((p13 !== null)) {
                                var renderSettings$macro$86 = $as_s_Option($n(p13).Lshapeless_$colon$colon__f_head);
                                var p14 = $as_Lshapeless_$colon$colon($n(p13).Lshapeless_$colon$colon__f_tail);
                                if ((p14 !== null)) {
                                  var city$macro$87 = $as_s_Option($n(p14).Lshapeless_$colon$colon__f_head);
                                  var p15 = $as_Lshapeless_$colon$colon($n(p14).Lshapeless_$colon$colon__f_tail);
                                  if ((p15 !== null)) {
                                    var district$macro$88 = $as_s_Option($n(p15).Lshapeless_$colon$colon__f_head);
                                    var p16 = $as_Lshapeless_$colon$colon($n(p15).Lshapeless_$colon$colon__f_tail);
                                    if ((p16 !== null)) {
                                      var topic$macro$89 = $as_s_Option($n(p16).Lshapeless_$colon$colon__f_head);
                                      var p17 = $as_Lshapeless_$colon$colon($n(p16).Lshapeless_$colon$colon__f_tail);
                                      if ((p17 !== null)) {
                                        var modelSource$macro$90 = $as_s_Option($n(p17).Lshapeless_$colon$colon__f_head);
                                        var p18 = $as_Lshapeless_$colon$colon($n(p17).Lshapeless_$colon$colon__f_tail);
                                        if ((p18 !== null)) {
                                          var procedureState$macro$91 = $as_s_Option($n(p18).Lshapeless_$colon$colon__f_head);
                                          var p19 = $as_Lshapeless_$colon$colon($n(p18).Lshapeless_$colon$colon__f_tail);
                                          if ((p19 !== null)) {
                                            var summary$macro$92 = $as_s_Option($n(p19).Lshapeless_$colon$colon__f_head);
                                            var p20 = $as_Lshapeless_$colon$colon($n(p19).Lshapeless_$colon$colon__f_tail);
                                            if ((p20 !== null)) {
                                              var archived$macro$93 = $as_s_Option($n(p20).Lshapeless_$colon$colon__f_head);
                                              var p21 = $as_Lshapeless_$colon$colon($n(p20).Lshapeless_$colon$colon__f_tail);
                                              if ((p21 !== null)) {
                                                var parent$macro$94 = $as_s_Option($n(p21).Lshapeless_$colon$colon__f_head);
                                                var p22 = $as_Lshapeless_$colon$colon($n(p21).Lshapeless_$colon$colon__f_tail);
                                                if ((p22 !== null)) {
                                                  var address$macro$95 = $as_Lreactbuild_common_model_ProjectAddress($n(p22).Lshapeless_$colon$colon__f_head);
                                                  var p23 = $as_Lshapeless_$colon$colon($n(p22).Lshapeless_$colon$colon__f_tail);
                                                  if ((p23 !== null)) {
                                                    var reference$macro$96 = $as_T($n(p23).Lshapeless_$colon$colon__f_head);
                                                    var p24 = $as_Lshapeless_HNil($n(p23).Lshapeless_$colon$colon__f_tail);
                                                    var x = $m_Lshapeless_HNil$();
                                                    if ((x === p24)) {
                                                      return new $c_Lreactbuild_common_model_Project(_id$macro$74, organizations$macro$75, name$macro$76, title$macro$77, description$macro$78, images$macro$79, location$macro$80, areas$macro$81, price$macro$82, soldOut$macro$83, privacy$macro$84, scenes$macro$85, renderSettings$macro$86, city$macro$87, district$macro$88, topic$macro$89, modelSource$macro$90, procedureState$macro$91, summary$macro$92, archived$macro$93, parent$macro$94, address$macro$95, reference$macro$96)
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "address"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "archived"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "summary"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "procedureState"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "modelSource"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$48 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "topic"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "district"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$54 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "city"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "renderSettings"));
    new $c_Lshapeless_Witness$$anon$1(value0$10);
    var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    $m_Lshapeless_Witness$();
    var this$60 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "scenes"));
    new $c_Lshapeless_Witness$$anon$1(value0$11);
    var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "privacy"));
    new $c_Lshapeless_Witness$$anon$1(value0$12);
    var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
    $m_Lshapeless_Witness$();
    var this$66 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "soldOut"));
    new $c_Lshapeless_Witness$$anon$1(value0$13);
    var zipWithKeys$14 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
    $m_Lshapeless_Witness$();
    var this$69 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$69, "price"));
    new $c_Lshapeless_Witness$$anon$1(value0$14);
    var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
    $m_Lshapeless_Witness$();
    var this$72 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$72, "areas"));
    new $c_Lshapeless_Witness$$anon$1(value0$15);
    var zipWithKeys$16 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
    $m_Lshapeless_Witness$();
    var this$75 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$75, "location"));
    new $c_Lshapeless_Witness$$anon$1(value0$16);
    var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
    $m_Lshapeless_Witness$();
    var this$78 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "images"));
    new $c_Lshapeless_Witness$$anon$1(value0$17);
    var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
    $m_Lshapeless_Witness$();
    var this$81 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$81, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$18);
    var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
    $m_Lshapeless_Witness$();
    var this$84 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$84, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$19);
    var zipWithKeys$20 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
    $m_Lshapeless_Witness$();
    var this$87 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$87, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$20);
    var zipWithKeys$21 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
    $m_Lshapeless_Witness$();
    var this$90 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "organizations"));
    new $c_Lshapeless_Witness$$anon$1(value0$21);
    var zipWithKeys$22 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
    $m_Lshapeless_Witness$();
    var this$93 = $m_s_Symbol$();
    var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$22);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
    var this$96 = $m_s_$less$colon$less$();
    var ev = this$96.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$98__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), "")), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), "")), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), new $c_Lreactbuild_common_model_ProjectAddress(($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$()), ($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$()), ($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_package$().s_package$__f_Nil), ($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$())))), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_Project$(), "")), $m_Lshapeless_HNil$())))))))))))))))))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$125 = $m_s_Symbol$();
    var $$x44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$125, "_id"));
    var this$126 = $m_s_Symbol$();
    var $$x43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$126, "organizations"));
    var this$127 = $m_s_Symbol$();
    var $$x42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$127, "name"));
    var this$128 = $m_s_Symbol$();
    var $$x41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$128, "title"));
    var this$129 = $m_s_Symbol$();
    var $$x40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$129, "description"));
    var this$130 = $m_s_Symbol$();
    var $$x39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$130, "images"));
    var this$131 = $m_s_Symbol$();
    var $$x38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$131, "location"));
    var this$132 = $m_s_Symbol$();
    var $$x37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$132, "areas"));
    var this$133 = $m_s_Symbol$();
    var $$x36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$133, "price"));
    var this$134 = $m_s_Symbol$();
    var $$x35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$134, "soldOut"));
    var this$135 = $m_s_Symbol$();
    var $$x34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$135, "privacy"));
    var this$136 = $m_s_Symbol$();
    var $$x33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$136, "scenes"));
    var this$137 = $m_s_Symbol$();
    var $$x32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$137, "renderSettings"));
    var this$138 = $m_s_Symbol$();
    var $$x31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$138, "city"));
    var this$139 = $m_s_Symbol$();
    var $$x30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$139, "district"));
    var this$140 = $m_s_Symbol$();
    var $$x29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$140, "topic"));
    var this$141 = $m_s_Symbol$();
    var $$x28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$141, "modelSource"));
    var this$142 = $m_s_Symbol$();
    var $$x27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$142, "procedureState"));
    var this$143 = $m_s_Symbol$();
    var $$x26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$143, "summary"));
    var this$144 = $m_s_Symbol$();
    var $$x25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$144, "archived"));
    var this$145 = $m_s_Symbol$();
    var $$x24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$145, "parent"));
    var this$146 = $m_s_Symbol$();
    var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$146, "address"));
    var this$147 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x44, new $c_Lshapeless_$colon$colon($$x43, new $c_Lshapeless_$colon$colon($$x42, new $c_Lshapeless_$colon$colon($$x41, new $c_Lshapeless_$colon$colon($$x40, new $c_Lshapeless_$colon$colon($$x39, new $c_Lshapeless_$colon$colon($$x38, new $c_Lshapeless_$colon$colon($$x37, new $c_Lshapeless_$colon$colon($$x36, new $c_Lshapeless_$colon$colon($$x35, new $c_Lshapeless_$colon$colon($$x34, new $c_Lshapeless_$colon$colon($$x33, new $c_Lshapeless_$colon$colon($$x32, new $c_Lshapeless_$colon$colon($$x31, new $c_Lshapeless_$colon$colon($$x30, new $c_Lshapeless_$colon$colon($$x29, new $c_Lshapeless_$colon$colon($$x28, new $c_Lshapeless_$colon$colon($$x27, new $c_Lshapeless_$colon$colon($$x26, new $c_Lshapeless_$colon$colon($$x25, new $c_Lshapeless_$colon$colon($$x24, new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$147, "reference")), $m_Lshapeless_HNil$())))))))))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$6);
    var tailHelper$8 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var tailHelper$9 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$8);
    var tailHelper$10 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$9);
    var tailHelper$11 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$10);
    var tailHelper$12 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$11);
    var tailHelper$13 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$12);
    var tailHelper$14 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$13);
    var tailHelper$15 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$14);
    var tailHelper$16 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$15);
    var tailHelper$17 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$16);
    var tailHelper$18 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$17);
    var tailHelper$19 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$18);
    var tailHelper$20 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$19);
    var tailHelper$21 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$20);
    var tailHelper$22 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$21);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$22);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$174 = $m_s_Symbol$();
    var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$174, "_id"));
    var wit$22 = new $c_Lshapeless_Witness$$anon$1(value0$23);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$176 = $m_s_Symbol$();
    var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$176, "organizations"));
    var wit$21 = new $c_Lshapeless_Witness$$anon$1(value0$24);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$178 = $m_s_Symbol$();
    var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$178, "name"));
    var wit$20 = new $c_Lshapeless_Witness$$anon$1(value0$25);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$180 = $m_s_Symbol$();
    var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$180, "title"));
    var wit$19 = new $c_Lshapeless_Witness$$anon$1(value0$26);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$182 = $m_s_Symbol$();
    var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$182, "description"));
    var wit$18 = new $c_Lshapeless_Witness$$anon$1(value0$27);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$184 = $m_s_Symbol$();
    var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$184, "images"));
    var wit$17 = new $c_Lshapeless_Witness$$anon$1(value0$28);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$186 = $m_s_Symbol$();
    var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$186, "location"));
    var wit$16 = new $c_Lshapeless_Witness$$anon$1(value0$29);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$188 = $m_s_Symbol$();
    var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$188, "areas"));
    var wit$15 = new $c_Lshapeless_Witness$$anon$1(value0$30);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$190 = $m_s_Symbol$();
    var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$190, "price"));
    var wit$14 = new $c_Lshapeless_Witness$$anon$1(value0$31);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$192 = $m_s_Symbol$();
    var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$192, "soldOut"));
    var wit$13 = new $c_Lshapeless_Witness$$anon$1(value0$32);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$194 = $m_s_Symbol$();
    var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$194, "privacy"));
    var wit$12 = new $c_Lshapeless_Witness$$anon$1(value0$33);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$196 = $m_s_Symbol$();
    var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$196, "scenes"));
    var wit$11 = new $c_Lshapeless_Witness$$anon$1(value0$34);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$198 = $m_s_Symbol$();
    var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$198, "renderSettings"));
    var wit$10 = new $c_Lshapeless_Witness$$anon$1(value0$35);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$200 = $m_s_Symbol$();
    var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$200, "city"));
    var wit$9 = new $c_Lshapeless_Witness$$anon$1(value0$36);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$202 = $m_s_Symbol$();
    var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$202, "district"));
    var wit$8 = new $c_Lshapeless_Witness$$anon$1(value0$37);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$204 = $m_s_Symbol$();
    var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$204, "topic"));
    var wit$7 = new $c_Lshapeless_Witness$$anon$1(value0$38);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$206 = $m_s_Symbol$();
    var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$206, "modelSource"));
    var wit$6 = new $c_Lshapeless_Witness$$anon$1(value0$39);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$208 = $m_s_Symbol$();
    var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$208, "procedureState"));
    var wit$5 = new $c_Lshapeless_Witness$$anon$1(value0$40);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$210 = $m_s_Symbol$();
    var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$210, "summary"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$41);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$212 = $m_s_Symbol$();
    var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$212, "archived"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$42);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$214 = $m_s_Symbol$();
    var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$214, "parent"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$43);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$216 = $m_s_Symbol$();
    var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$216, "address"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$44);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$218 = $m_s_Symbol$();
    var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$218, "reference"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$45);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var rtmT$5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var rtmT$6 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$5, wit$5);
    var rtmT$7 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$6, wit$6);
    var rtmT$8 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$7, wit$7);
    var rtmT$9 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$8, wit$8);
    var rtmT$10 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$9, wit$9);
    var rtmT$11 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$10, wit$10);
    var rtmT$12 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$11, wit$11);
    var rtmT$13 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$12, wit$12);
    var rtmT$14 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$13, wit$13);
    var rtmT$15 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$14, wit$14);
    var rtmT$16 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$15, wit$15);
    var rtmT$17 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$16, wit$16);
    var rtmT$18 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$17, wit$17);
    var rtmT$19 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$18, wit$18);
    var rtmT$20 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$19, wit$19);
    var rtmT$21 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$20, wit$20);
    var rtmT$22 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$21, wit$21);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$22, wit$22);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$243 = $m_s_Symbol$();
    var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$243, "_id"));
    var wk$22 = new $c_Lshapeless_Witness$$anon$1(value0$46);
    $m_Lshapeless_Witness$();
    var this$245 = $m_s_Symbol$();
    var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$245, "organizations"));
    var wk$21 = new $c_Lshapeless_Witness$$anon$1(value0$47);
    $m_Lshapeless_Witness$();
    var this$247 = $m_s_Symbol$();
    var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$247, "name"));
    var wk$20 = new $c_Lshapeless_Witness$$anon$1(value0$48);
    $m_Lshapeless_Witness$();
    var this$249 = $m_s_Symbol$();
    var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$249, "title"));
    var wk$19 = new $c_Lshapeless_Witness$$anon$1(value0$49);
    $m_Lshapeless_Witness$();
    var this$251 = $m_s_Symbol$();
    var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$251, "description"));
    var wk$18 = new $c_Lshapeless_Witness$$anon$1(value0$50);
    $m_Lshapeless_Witness$();
    var this$253 = $m_s_Symbol$();
    var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$253, "images"));
    var wk$17 = new $c_Lshapeless_Witness$$anon$1(value0$51);
    $m_Lshapeless_Witness$();
    var this$255 = $m_s_Symbol$();
    var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$255, "location"));
    var wk$16 = new $c_Lshapeless_Witness$$anon$1(value0$52);
    $m_Lshapeless_Witness$();
    var this$257 = $m_s_Symbol$();
    var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$257, "areas"));
    var wk$15 = new $c_Lshapeless_Witness$$anon$1(value0$53);
    $m_Lshapeless_Witness$();
    var this$259 = $m_s_Symbol$();
    var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$259, "price"));
    var wk$14 = new $c_Lshapeless_Witness$$anon$1(value0$54);
    $m_Lshapeless_Witness$();
    var this$261 = $m_s_Symbol$();
    var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$261, "soldOut"));
    var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$55);
    $m_Lshapeless_Witness$();
    var this$263 = $m_s_Symbol$();
    var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$263, "privacy"));
    var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$56);
    $m_Lshapeless_Witness$();
    var this$265 = $m_s_Symbol$();
    var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$265, "scenes"));
    var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$57);
    $m_Lshapeless_Witness$();
    var this$267 = $m_s_Symbol$();
    var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$267, "renderSettings"));
    var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$58);
    $m_Lshapeless_Witness$();
    var this$269 = $m_s_Symbol$();
    var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$269, "city"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$59);
    $m_Lshapeless_Witness$();
    var this$271 = $m_s_Symbol$();
    var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$271, "district"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$60);
    $m_Lshapeless_Witness$();
    var this$273 = $m_s_Symbol$();
    var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$273, "topic"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$61);
    $m_Lshapeless_Witness$();
    var this$275 = $m_s_Symbol$();
    var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$275, "modelSource"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$62);
    $m_Lshapeless_Witness$();
    var this$277 = $m_s_Symbol$();
    var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$277, "procedureState"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$63);
    $m_Lshapeless_Witness$();
    var this$279 = $m_s_Symbol$();
    var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$279, "summary"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$64);
    $m_Lshapeless_Witness$();
    var this$281 = $m_s_Symbol$();
    var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$281, "archived"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$65);
    $m_Lshapeless_Witness$();
    var this$283 = $m_s_Symbol$();
    var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$283, "parent"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$66);
    $m_Lshapeless_Witness$();
    var this$285 = $m_s_Symbol$();
    var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$285, "address"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$67);
    $m_Lshapeless_Witness$();
    var this$287 = $m_s_Symbol$();
    var value0$68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$287, "reference"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$68);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var kt$9 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var kt$10 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$9, kt$9);
    var kt$11 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$10, kt$10);
    var kt$12 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$11, kt$11);
    var kt$13 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$12, kt$12);
    var kt$14 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$13, kt$13);
    var kt$15 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$14, kt$14);
    var kt$16 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$15, kt$15);
    var kt$17 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$16, kt$16);
    var kt$18 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$17, kt$17);
    var kt$19 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$18, kt$18);
    var kt$20 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$19, kt$19);
    var kt$21 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$20, kt$20);
    var kt$22 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$21, kt$21);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$22, kt$22);
    var this$313 = $m_s_$less$colon$less$();
    var ev$1 = this$313.s_$less$colon$less$__f_singleton;
    var this$314 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$314);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$318 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$318);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$322 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$322);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$326 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$326);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$330 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$330);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$334 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$334);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$338 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$338);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$342 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$342);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$346 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$346);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$350 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$350);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$354 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$354);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$358 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$358);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$362 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$362);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$366 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$366);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$370 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$370);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$374 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$374);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$14, tttvs$14);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$378 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$378);
    var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$15, tttvs$15);
    var u$16 = new $c_Lshapeless_Lub$$anon$4();
    var this$382 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$382);
    var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$16, tttvs$16);
    var u$17 = new $c_Lshapeless_Lub$$anon$4();
    var this$386 = $m_sci_List$();
    var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$386);
    var tttvs$18 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$17, tttvs$17);
    var u$18 = new $c_Lshapeless_Lub$$anon$4();
    var this$390 = $m_sci_List$();
    var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$390);
    var tttvs$19 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$18, tttvs$18);
    var u$19 = new $c_Lshapeless_Lub$$anon$4();
    var this$394 = $m_sci_List$();
    var cbf$20 = new $c_sc_IterableFactory$ToFactory(this$394);
    var tttvs$20 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$20, u$19, tttvs$19);
    var u$20 = new $c_Lshapeless_Lub$$anon$4();
    var this$398 = $m_sci_List$();
    var cbf$21 = new $c_sc_IterableFactory$ToFactory(this$398);
    var tttvs$21 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$21, u$20, tttvs$20);
    var u$21 = new $c_Lshapeless_Lub$$anon$4();
    var this$402 = $m_sci_List$();
    var cbf$22 = new $c_sc_IterableFactory$ToFactory(this$402);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$22, u$21, tttvs$21);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))))))))))))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$406 = $m_s_$less$colon$less$();
    var ev$2 = this$406.s_$less$colon$less$__f_singleton;
    var this$407 = $m_sci_List$();
    var cbf$23 = new $c_sc_IterableFactory$ToFactory(this$407);
    var tttvs$22 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$23, ev$2);
    var u$22 = new $c_Lshapeless_Lub$$anon$4();
    var this$411 = $m_sci_List$();
    var cbf$24 = new $c_sc_IterableFactory$ToFactory(this$411);
    var tttvs$23 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$24, u$22, tttvs$22);
    var u$23 = new $c_Lshapeless_Lub$$anon$4();
    var this$415 = $m_sci_List$();
    var cbf$25 = new $c_sc_IterableFactory$ToFactory(this$415);
    var tttvs$24 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$25, u$23, tttvs$23);
    var u$24 = new $c_Lshapeless_Lub$$anon$4();
    var this$419 = $m_sci_List$();
    var cbf$26 = new $c_sc_IterableFactory$ToFactory(this$419);
    var tttvs$25 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$26, u$24, tttvs$24);
    var u$25 = new $c_Lshapeless_Lub$$anon$4();
    var this$423 = $m_sci_List$();
    var cbf$27 = new $c_sc_IterableFactory$ToFactory(this$423);
    var tttvs$26 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$27, u$25, tttvs$25);
    var u$26 = new $c_Lshapeless_Lub$$anon$4();
    var this$427 = $m_sci_List$();
    var cbf$28 = new $c_sc_IterableFactory$ToFactory(this$427);
    var tttvs$27 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$28, u$26, tttvs$26);
    var u$27 = new $c_Lshapeless_Lub$$anon$4();
    var this$431 = $m_sci_List$();
    var cbf$29 = new $c_sc_IterableFactory$ToFactory(this$431);
    var tttvs$28 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$29, u$27, tttvs$27);
    var u$28 = new $c_Lshapeless_Lub$$anon$4();
    var this$435 = $m_sci_List$();
    var cbf$30 = new $c_sc_IterableFactory$ToFactory(this$435);
    var tttvs$29 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$30, u$28, tttvs$28);
    var u$29 = new $c_Lshapeless_Lub$$anon$4();
    var this$439 = $m_sci_List$();
    var cbf$31 = new $c_sc_IterableFactory$ToFactory(this$439);
    var tttvs$30 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$31, u$29, tttvs$29);
    var u$30 = new $c_Lshapeless_Lub$$anon$4();
    var this$443 = $m_sci_List$();
    var cbf$32 = new $c_sc_IterableFactory$ToFactory(this$443);
    var tttvs$31 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$32, u$30, tttvs$30);
    var u$31 = new $c_Lshapeless_Lub$$anon$4();
    var this$447 = $m_sci_List$();
    var cbf$33 = new $c_sc_IterableFactory$ToFactory(this$447);
    var tttvs$32 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$33, u$31, tttvs$31);
    var u$32 = new $c_Lshapeless_Lub$$anon$4();
    var this$451 = $m_sci_List$();
    var cbf$34 = new $c_sc_IterableFactory$ToFactory(this$451);
    var tttvs$33 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$34, u$32, tttvs$32);
    var u$33 = new $c_Lshapeless_Lub$$anon$4();
    var this$455 = $m_sci_List$();
    var cbf$35 = new $c_sc_IterableFactory$ToFactory(this$455);
    var tttvs$34 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$35, u$33, tttvs$33);
    var u$34 = new $c_Lshapeless_Lub$$anon$4();
    var this$459 = $m_sci_List$();
    var cbf$36 = new $c_sc_IterableFactory$ToFactory(this$459);
    var tttvs$35 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$36, u$34, tttvs$34);
    var u$35 = new $c_Lshapeless_Lub$$anon$4();
    var this$463 = $m_sci_List$();
    var cbf$37 = new $c_sc_IterableFactory$ToFactory(this$463);
    var tttvs$36 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$37, u$35, tttvs$35);
    var u$36 = new $c_Lshapeless_Lub$$anon$4();
    var this$467 = $m_sci_List$();
    var cbf$38 = new $c_sc_IterableFactory$ToFactory(this$467);
    var tttvs$37 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$38, u$36, tttvs$36);
    var u$37 = new $c_Lshapeless_Lub$$anon$4();
    var this$471 = $m_sci_List$();
    var cbf$39 = new $c_sc_IterableFactory$ToFactory(this$471);
    var tttvs$38 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$39, u$37, tttvs$37);
    var u$38 = new $c_Lshapeless_Lub$$anon$4();
    var this$475 = $m_sci_List$();
    var cbf$40 = new $c_sc_IterableFactory$ToFactory(this$475);
    var tttvs$39 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$40, u$38, tttvs$38);
    var u$39 = new $c_Lshapeless_Lub$$anon$4();
    var this$479 = $m_sci_List$();
    var cbf$41 = new $c_sc_IterableFactory$ToFactory(this$479);
    var tttvs$40 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$41, u$39, tttvs$39);
    var u$40 = new $c_Lshapeless_Lub$$anon$4();
    var this$483 = $m_sci_List$();
    var cbf$42 = new $c_sc_IterableFactory$ToFactory(this$483);
    var tttvs$41 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$42, u$40, tttvs$40);
    var u$41 = new $c_Lshapeless_Lub$$anon$4();
    var this$487 = $m_sci_List$();
    var cbf$43 = new $c_sc_IterableFactory$ToFactory(this$487);
    var tttvs$42 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$43, u$41, tttvs$41);
    var u$42 = new $c_Lshapeless_Lub$$anon$4();
    var this$491 = $m_sci_List$();
    var cbf$44 = new $c_sc_IterableFactory$ToFactory(this$491);
    var tttvs$43 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$44, u$42, tttvs$42);
    var u$43 = new $c_Lshapeless_Lub$$anon$4();
    var this$495 = $m_sci_List$();
    var cbf$45 = new $c_sc_IterableFactory$ToFactory(this$495);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$45, u$43, tttvs$43);
    $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_inst$macro$1
}
function $p_Lreactbuild_common_model_Project$anon$lazy$macro$99$1__inst$macro$98$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_inst$macro$98 = new $c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25($thiz);
    $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_inst$macro$98
}
/** @constructor */
function $c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1() {
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_inst$macro$98 = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1.prototype = new $h_O();
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1.prototype.constructor = $c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1;
/** @constructor */
function $h_Lreactbuild_common_model_Project$anon$lazy$macro$99$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Project$anon$lazy$macro$99$1.prototype = $c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1.prototype;
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Project$anon$lazy$macro$99$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_inst$macro$1)
});
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1.prototype.inst$macro$98__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_Project$anon$lazy$macro$99$1__inst$macro$98$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1__f_inst$macro$98)
});
var $d_Lreactbuild_common_model_Project$anon$lazy$macro$99$1 = new $TypeData().initClass({
  Lreactbuild_common_model_Project$anon$lazy$macro$99$1: 0
}, false, "reactbuild.common.model.Project$anon$lazy$macro$99$1", {
  Lreactbuild_common_model_Project$anon$lazy$macro$99$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1.prototype.$classData = $d_Lreactbuild_common_model_Project$anon$lazy$macro$99$1;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectAddress$() {
  this.Lreactbuild_common_model_ProjectAddress$__f_encodeProjectAddress = null;
  this.Lreactbuild_common_model_ProjectAddress$__f_decodeProjectAddress = null;
  $n_Lreactbuild_common_model_ProjectAddress$ = this;
  var inst$macro$36 = new $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5().inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var encode = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_ProjectAddress$__f_encodeProjectAddress = $as_Lio_circe_Encoder$AsObject(encode.value__O());
  var inst$macro$72 = new $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1().inst$macro$37__Lio_circe_generic_extras_decoding_ConfiguredDecoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$72));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t$1);
  var defaultDecoder = $as_Lio_circe_Decoder(decode.value__O());
  $m_Lio_circe_Decoder$();
  var instance = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$14 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((raw$2) => {
    var raw = $as_T(raw$2);
    var this$7 = $n($m_s_Option$().apply__O__s_Option(raw));
    if (this$7.isEmpty__Z()) {
      var $$x1 = true
    } else {
      var arg1 = this$7.get__O();
      var x$7 = $as_T(arg1);
      $m_sc_StringOps$();
      var this$10 = $n(x$7);
      var $$x1 = (!(this$10 === ""))
    };
    if ($$x1) {
      var x$1 = this$7
    } else {
      var x$1 = $m_s_None$()
    };
    $m_Lreactbuild_common_model_ProjectAddress$();
    var x$2 = $m_s_None$();
    $m_Lreactbuild_common_model_ProjectAddress$();
    var x$3 = $m_s_package$().s_package$__f_Nil;
    $m_Lreactbuild_common_model_ProjectAddress$();
    var x$4 = $m_s_None$();
    return new $c_Lreactbuild_common_model_ProjectAddress(x$2, x$1, x$3, x$4)
  }));
  var this$15 = new $c_Lio_circe_Decoder$$anon$1(this$14, f);
  var d = new $c_sjsr_AnonFunction0((() => defaultDecoder));
  this.Lreactbuild_common_model_ProjectAddress$__f_decodeProjectAddress = new $c_Lio_circe_Decoder$$anon$9(this$15, d)
}
$c_Lreactbuild_common_model_ProjectAddress$.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectAddress$.prototype.constructor = $c_Lreactbuild_common_model_ProjectAddress$;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectAddress$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectAddress$.prototype = $c_Lreactbuild_common_model_ProjectAddress$.prototype;
var $d_Lreactbuild_common_model_ProjectAddress$ = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectAddress$: 0
}, false, "reactbuild.common.model.ProjectAddress$", {
  Lreactbuild_common_model_ProjectAddress$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectAddress$.prototype.$classData = $d_Lreactbuild_common_model_ProjectAddress$;
var $n_Lreactbuild_common_model_ProjectAddress$;
function $m_Lreactbuild_common_model_ProjectAddress$() {
  if ((!$n_Lreactbuild_common_model_ProjectAddress$)) {
    $n_Lreactbuild_common_model_ProjectAddress$ = new $c_Lreactbuild_common_model_ProjectAddress$()
  };
  return $n_Lreactbuild_common_model_ProjectAddress$
}
function $p_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "country"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "raw"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "parcels"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "coordinates")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_ProjectAddress(x0$7$2);
      if ((x0$7 !== null)) {
        var country$macro$30 = $n(x0$7).Lreactbuild_common_model_ProjectAddress__f_country;
        var raw$macro$31 = $n(x0$7).Lreactbuild_common_model_ProjectAddress__f_raw;
        var parcels$macro$32 = $n(x0$7).Lreactbuild_common_model_ProjectAddress__f_parcels;
        var coordinates$macro$33 = $n(x0$7).Lreactbuild_common_model_ProjectAddress__f_coordinates;
        return new $c_Lshapeless_$colon$colon(country$macro$30, new $c_Lshapeless_$colon$colon(raw$macro$31, new $c_Lshapeless_$colon$colon(parcels$macro$32, new $c_Lshapeless_$colon$colon(coordinates$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var country$macro$26 = $as_s_Option($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var raw$macro$27 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var parcels$macro$28 = $as_sci_List($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var coordinates$macro$29 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_common_model_ProjectAddress(country$macro$26, raw$macro$27, parcels$macro$28, coordinates$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "coordinates"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "parcels"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "raw"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "country"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "country"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "raw"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "parcels"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "coordinates"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$36 = $m_s_$less$colon$less$();
    var ev$1 = this$36.s_$less$colon$less$__f_singleton;
    var this$37 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$37);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$41 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$41);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$45 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$45);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$49 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$49);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$53 = $m_s_$less$colon$less$();
    var ev$2 = this$53.s_$less$colon$less$__f_singleton;
    var this$54 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$54);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$58 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$66);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_inst$macro$1 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_inst$macro$1
}
function $p_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__inst$macro$34$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_inst$macro$34 = new $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23($thiz);
    $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5() {
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_inst$macro$34 = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5.prototype.constructor = $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5.prototype = $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5.prototype;
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5.prototype.inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((1 & this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_inst$macro$1)
});
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5.prototype.inst$macro$34__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((2 & this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__inst$macro$34$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5__f_inst$macro$34)
});
var $d_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5: 0
}, false, "reactbuild.common.model.ProjectAddress$anon$lazy$macro$35$5", {
  Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5.prototype.$classData = $d_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5;
function $p_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x15 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "country"));
    var this$2 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "raw"));
    var this$3 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "parcels"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "coordinates")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_common_model_ProjectAddress(x0$15$2);
      if ((x0$15 !== null)) {
        var country$macro$66 = $n(x0$15).Lreactbuild_common_model_ProjectAddress__f_country;
        var raw$macro$67 = $n(x0$15).Lreactbuild_common_model_ProjectAddress__f_raw;
        var parcels$macro$68 = $n(x0$15).Lreactbuild_common_model_ProjectAddress__f_parcels;
        var coordinates$macro$69 = $n(x0$15).Lreactbuild_common_model_ProjectAddress__f_coordinates;
        return new $c_Lshapeless_$colon$colon(country$macro$66, new $c_Lshapeless_$colon$colon(raw$macro$67, new $c_Lshapeless_$colon$colon(parcels$macro$68, new $c_Lshapeless_$colon$colon(coordinates$macro$69, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var country$macro$62 = $as_s_Option($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var raw$macro$63 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var parcels$macro$64 = $as_sci_List($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var coordinates$macro$65 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_common_model_ProjectAddress(country$macro$62, raw$macro$63, parcels$macro$64, coordinates$macro$65)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "coordinates"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "parcels"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "raw"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "country"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var $$x14 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$70__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x10 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$())), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$28 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "country"));
    var this$29 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "raw"));
    var this$30 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "parcels"));
    var this$31 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "coordinates")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var $$x9 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "country"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "raw"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "parcels"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "coordinates"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var $$x4 = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "country"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "raw"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "parcels"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "coordinates"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$64 = $m_s_$less$colon$less$();
    var ev$1 = this$64.s_$less$colon$less$__f_singleton;
    var this$65 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$73);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$77 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$77);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$81 = $m_s_$less$colon$less$();
    var ev$2 = this$81.s_$less$colon$less$__f_singleton;
    var this$82 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$82);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$86 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$86);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$90 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$90);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$94 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$94);
    $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_inst$macro$37 = $n($$x15).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x14, $$x10, $$x9, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5));
    $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_inst$macro$37
}
function $p_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__inst$macro$70$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_inst$macro$70 = new $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24($thiz);
    $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_inst$macro$70
}
/** @constructor */
function $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1() {
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_inst$macro$37 = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_inst$macro$70 = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1.prototype.constructor = $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1.prototype = $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1.prototype;
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1.prototype.inst$macro$37__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((1 & this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_inst$macro$37)
});
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1.prototype.inst$macro$70__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__inst$macro$70$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1__f_inst$macro$70)
});
var $d_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1: 0
}, false, "reactbuild.common.model.ProjectAddress$anon$lazy$macro$71$1", {
  Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1.prototype.$classData = $d_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectRelease$() {
  $n_Lreactbuild_common_model_ProjectRelease$ = this;
  var inst$macro$44 = new $c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_ProjectRelease$.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectRelease$.prototype.constructor = $c_Lreactbuild_common_model_ProjectRelease$;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectRelease$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectRelease$.prototype = $c_Lreactbuild_common_model_ProjectRelease$.prototype;
var $d_Lreactbuild_common_model_ProjectRelease$ = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectRelease$: 0
}, false, "reactbuild.common.model.ProjectRelease$", {
  Lreactbuild_common_model_ProjectRelease$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectRelease$.prototype.$classData = $d_Lreactbuild_common_model_ProjectRelease$;
var $n_Lreactbuild_common_model_ProjectRelease$;
function $m_Lreactbuild_common_model_ProjectRelease$() {
  if ((!$n_Lreactbuild_common_model_ProjectRelease$)) {
    $n_Lreactbuild_common_model_ProjectRelease$ = new $c_Lreactbuild_common_model_ProjectRelease$()
  };
  return $n_Lreactbuild_common_model_ProjectRelease$
}
function $p_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "organization"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "name"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "version"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "date"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "assets")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_ProjectRelease(x0$7$2);
      if ((x0$7 !== null)) {
        var organization$macro$37 = $n(x0$7).Lreactbuild_common_model_ProjectRelease__f_organization;
        var name$macro$38 = $n(x0$7).Lreactbuild_common_model_ProjectRelease__f_name;
        var version$macro$39 = $n(x0$7).Lreactbuild_common_model_ProjectRelease__f_version;
        var date$macro$40 = $n(x0$7).Lreactbuild_common_model_ProjectRelease__f_date;
        var assets$macro$41 = $n(x0$7).Lreactbuild_common_model_ProjectRelease__f_assets;
        return new $c_Lshapeless_$colon$colon(organization$macro$37, new $c_Lshapeless_$colon$colon(name$macro$38, new $c_Lshapeless_$colon$colon(version$macro$39, new $c_Lshapeless_$colon$colon(date$macro$40, new $c_Lshapeless_$colon$colon(assets$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var organization$macro$32 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var name$macro$33 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var version$macro$34 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var date$macro$35 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var assets$macro$36 = $as_sci_Seq($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_common_model_ProjectRelease(organization$macro$32, name$macro$33, version$macro$34, date$macro$35, assets$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "assets"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "version"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectRelease$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectRelease$(), $m_s_package$().s_package$__f_Nil)), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$30 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "organization"));
    var this$31 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "name"));
    var this$32 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "version"));
    var this$33 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "date"));
    var this$34 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "assets")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "date"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "assets"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "organization"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "name"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "version"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "date"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "assets"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$65 = $m_s_$less$colon$less$();
    var ev$1 = this$65.s_$less$colon$less$__f_singleton;
    var this$66 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$82);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$86 = $m_s_$less$colon$less$();
    var ev$2 = this$86.s_$less$colon$less$__f_singleton;
    var this$87 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$91);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$95 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$95);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$99 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$99);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$103 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$103);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_inst$macro$1
}
function $p_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_inst$macro$42 = new $c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12($thiz);
    $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1() {
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_inst$macro$42 = null;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1.prototype.constructor = $c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1.prototype = $c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1.prototype;
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_inst$macro$1)
});
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1__f_inst$macro$42)
});
var $d_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1: 0
}, false, "reactbuild.common.model.ProjectRelease$anon$lazy$macro$43$1", {
  Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1.prototype.$classData = $d_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectSpecific$() {
  this.Lreactbuild_common_model_ProjectSpecific$__f_codecForProjectSpecific = null;
  $n_Lreactbuild_common_model_ProjectSpecific$ = this;
  var inst$macro$60 = new $c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$60));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_ProjectSpecific$__f_codecForProjectSpecific = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_ProjectSpecific$.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectSpecific$.prototype.constructor = $c_Lreactbuild_common_model_ProjectSpecific$;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectSpecific$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectSpecific$.prototype = $c_Lreactbuild_common_model_ProjectSpecific$.prototype;
var $d_Lreactbuild_common_model_ProjectSpecific$ = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectSpecific$: 0
}, false, "reactbuild.common.model.ProjectSpecific$", {
  Lreactbuild_common_model_ProjectSpecific$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectSpecific$.prototype.$classData = $d_Lreactbuild_common_model_ProjectSpecific$;
var $n_Lreactbuild_common_model_ProjectSpecific$;
function $m_Lreactbuild_common_model_ProjectSpecific$() {
  if ((!$n_Lreactbuild_common_model_ProjectSpecific$)) {
    $n_Lreactbuild_common_model_ProjectSpecific$ = new $c_Lreactbuild_common_model_ProjectSpecific$()
  };
  return $n_Lreactbuild_common_model_ProjectSpecific$
}
function $p_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "project"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "title"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "description"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "price"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "publish"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "soldOut")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_ProjectSpecific(x0$7$2);
      if ((x0$7 !== null)) {
        var project$macro$51 = $n(x0$7).Lreactbuild_common_model_ProjectSpecific__f_project;
        var organization$macro$52 = $n(x0$7).Lreactbuild_common_model_ProjectSpecific__f_organization;
        var title$macro$53 = $n(x0$7).Lreactbuild_common_model_ProjectSpecific__f_title;
        var description$macro$54 = $n(x0$7).Lreactbuild_common_model_ProjectSpecific__f_description;
        var price$macro$55 = $n(x0$7).Lreactbuild_common_model_ProjectSpecific__f_price;
        var publish$macro$56 = $n(x0$7).Lreactbuild_common_model_ProjectSpecific__f_publish;
        var soldOut$macro$57 = $n(x0$7).Lreactbuild_common_model_ProjectSpecific__f_soldOut;
        return new $c_Lshapeless_$colon$colon(project$macro$51, new $c_Lshapeless_$colon$colon(organization$macro$52, new $c_Lshapeless_$colon$colon(title$macro$53, new $c_Lshapeless_$colon$colon(description$macro$54, new $c_Lshapeless_$colon$colon(price$macro$55, new $c_Lshapeless_$colon$colon(publish$macro$56, new $c_Lshapeless_$colon$colon(soldOut$macro$57, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var project$macro$44 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$45 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var title$macro$46 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var description$macro$47 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var price$macro$48 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var publish$macro$49 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var soldOut$macro$50 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_common_model_ProjectSpecific(project$macro$44, organization$macro$45, title$macro$46, description$macro$47, price$macro$48, publish$macro$49, soldOut$macro$50)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "soldOut"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "publish"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "price"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectSpecific$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectSpecific$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectSpecific$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectSpecific$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_common_model_ProjectSpecific$(), $m_s_None$())), $m_Lshapeless_HNil$())))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$41 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "project"));
    var this$42 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "organization"));
    var this$43 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "title"));
    var this$44 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "description"));
    var this$45 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "price"));
    var this$46 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "publish"));
    var this$47 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "soldOut")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$58 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "title"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$60 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "description"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$62 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "price"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$64 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "publish"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$66 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "soldOut"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$73 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "project"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$75 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$75, "organization"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$77 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$77, "title"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$79 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$79, "description"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$81 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$81, "price"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$83 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "publish"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$85 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "soldOut"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$18);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$95 = $m_s_$less$colon$less$();
    var ev$1 = this$95.s_$less$colon$less$__f_singleton;
    var this$96 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$96);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$100 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$100);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$104 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$104);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$108 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$108);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$112 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$112);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$116 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$116);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$120 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$120);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$124 = $m_s_$less$colon$less$();
    var ev$2 = this$124.s_$less$colon$less$__f_singleton;
    var this$125 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$125);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$129 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$129);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$133 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$133);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$137 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$137);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$141 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$141);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$145 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$145);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$149 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$149);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_inst$macro$1
}
function $p_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_inst$macro$58 = new $c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21($thiz);
    $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2() {
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_inst$macro$58 = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2.prototype.constructor = $c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2.prototype = $c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2.prototype;
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_inst$macro$1)
});
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2.prototype.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2__f_inst$macro$58)
});
var $d_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2: 0
}, false, "reactbuild.common.model.ProjectSpecific$anon$lazy$macro$59$2", {
  Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2.prototype.$classData = $d_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectSpecifics$() {
  $n_Lreactbuild_common_model_ProjectSpecifics$ = this;
  var inst$macro$28 = new $c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_ProjectSpecifics$.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectSpecifics$.prototype.constructor = $c_Lreactbuild_common_model_ProjectSpecifics$;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectSpecifics$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectSpecifics$.prototype = $c_Lreactbuild_common_model_ProjectSpecifics$.prototype;
var $d_Lreactbuild_common_model_ProjectSpecifics$ = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectSpecifics$: 0
}, false, "reactbuild.common.model.ProjectSpecifics$", {
  Lreactbuild_common_model_ProjectSpecifics$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectSpecifics$.prototype.$classData = $d_Lreactbuild_common_model_ProjectSpecifics$;
var $n_Lreactbuild_common_model_ProjectSpecifics$;
function $m_Lreactbuild_common_model_ProjectSpecifics$() {
  if ((!$n_Lreactbuild_common_model_ProjectSpecifics$)) {
    $n_Lreactbuild_common_model_ProjectSpecifics$ = new $c_Lreactbuild_common_model_ProjectSpecifics$()
  };
  return $n_Lreactbuild_common_model_ProjectSpecifics$
}
function $p_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "websites"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organizations"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "projectsSpecific")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_ProjectSpecifics(x0$7$2);
      if ((x0$7 !== null)) {
        var websites$macro$23 = $n(x0$7).Lreactbuild_common_model_ProjectSpecifics__f_websites;
        var organizations$macro$24 = $n(x0$7).Lreactbuild_common_model_ProjectSpecifics__f_organizations;
        var projectsSpecific$macro$25 = $n(x0$7).Lreactbuild_common_model_ProjectSpecifics__f_projectsSpecific;
        return new $c_Lshapeless_$colon$colon(websites$macro$23, new $c_Lshapeless_$colon$colon(organizations$macro$24, new $c_Lshapeless_$colon$colon(projectsSpecific$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var websites$macro$20 = $as_sci_Seq($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organizations$macro$21 = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var projectsSpecific$macro$22 = $as_sci_Seq($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_common_model_ProjectSpecifics(websites$macro$20, organizations$macro$21, projectsSpecific$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "projectsSpecific"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "organizations"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "websites"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "websites"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "organizations"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "projectsSpecific")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "websites"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "organizations"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "projectsSpecific"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_inst$macro$1
}
function $p_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_inst$macro$26 = new $c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22($thiz);
    $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2() {
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_inst$macro$26 = null;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2.prototype.constructor = $c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2.prototype = $c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2.prototype;
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_inst$macro$1)
});
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2__f_inst$macro$26)
});
var $d_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2: 0
}, false, "reactbuild.common.model.ProjectSpecifics$anon$lazy$macro$27$2", {
  Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2.prototype.$classData = $d_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2;
/** @constructor */
function $c_Lreactbuild_common_model_RefTo$() {
  /*<skip>*/
}
$c_Lreactbuild_common_model_RefTo$.prototype = new $h_O();
$c_Lreactbuild_common_model_RefTo$.prototype.constructor = $c_Lreactbuild_common_model_RefTo$;
/** @constructor */
function $h_Lreactbuild_common_model_RefTo$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_RefTo$.prototype = $c_Lreactbuild_common_model_RefTo$.prototype;
$c_Lreactbuild_common_model_RefTo$.prototype.encodeRefTo__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_common_model_RefTo(x$1$2);
    return $n(x$1).Lreactbuild_common_model_RefTo__f_id
  }));
  return new $c_Lio_circe_Encoder$$anon$1(this$3, f)
});
$c_Lreactbuild_common_model_RefTo$.prototype.decodeRefTo__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var instance = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_ju_UUID(x$2$2);
    return new $c_Lreactbuild_common_model_RefTo(x$2)
  }));
  return new $c_Lio_circe_Decoder$$anon$1(this$3, f)
});
$c_Lreactbuild_common_model_RefTo$.prototype.encodeKeyRefTo__Lio_circe_KeyEncoder = (function() {
  $m_Lio_circe_KeyEncoder$();
  var A = $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyUUID;
  var this$3 = $n(A);
  var f = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_common_model_RefTo(x$3$2);
    return $n(x$3).Lreactbuild_common_model_RefTo__f_id
  }));
  return new $c_Lio_circe_KeyEncoder$$anon$1(this$3, f)
});
$c_Lreactbuild_common_model_RefTo$.prototype.decodeKeyRefTo__Lio_circe_KeyDecoder = (function() {
  $m_Lio_circe_KeyDecoder$();
  var A = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyUUID;
  var this$3 = $n(A);
  var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_ju_UUID(x$4$2);
    return new $c_Lreactbuild_common_model_RefTo(x$4)
  }));
  return new $c_Lio_circe_KeyDecoder$$anon$1(this$3, f)
});
$c_Lreactbuild_common_model_RefTo$.prototype.keyMapper__Lcom_iz2use_common_KeyMapper = (function() {
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lreactbuild_common_model_RefTo(x$5$2);
    return $n(x$5).Lreactbuild_common_model_RefTo__f_id
  }));
  var ev = $m_Lcom_iz2use_common_KeyMapper$().Lcom_iz2use_common_KeyMapper$__f_fromUUID;
  return new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f)
});
var $d_Lreactbuild_common_model_RefTo$ = new $TypeData().initClass({
  Lreactbuild_common_model_RefTo$: 0
}, false, "reactbuild.common.model.RefTo$", {
  Lreactbuild_common_model_RefTo$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_RefTo$.prototype.$classData = $d_Lreactbuild_common_model_RefTo$;
var $n_Lreactbuild_common_model_RefTo$;
function $m_Lreactbuild_common_model_RefTo$() {
  if ((!$n_Lreactbuild_common_model_RefTo$)) {
    $n_Lreactbuild_common_model_RefTo$ = new $c_Lreactbuild_common_model_RefTo$()
  };
  return $n_Lreactbuild_common_model_RefTo$
}
/** @constructor */
function $c_Lreactbuild_common_model_RenderSettings$() {
  this.Lreactbuild_common_model_RenderSettings$__f_codecForRenderSettings = null;
  $n_Lreactbuild_common_model_RenderSettings$ = this;
  var inst$macro$12 = new $c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_RenderSettings$__f_codecForRenderSettings = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_RenderSettings$.prototype = new $h_O();
$c_Lreactbuild_common_model_RenderSettings$.prototype.constructor = $c_Lreactbuild_common_model_RenderSettings$;
/** @constructor */
function $h_Lreactbuild_common_model_RenderSettings$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_RenderSettings$.prototype = $c_Lreactbuild_common_model_RenderSettings$.prototype;
var $d_Lreactbuild_common_model_RenderSettings$ = new $TypeData().initClass({
  Lreactbuild_common_model_RenderSettings$: 0
}, false, "reactbuild.common.model.RenderSettings$", {
  Lreactbuild_common_model_RenderSettings$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_RenderSettings$.prototype.$classData = $d_Lreactbuild_common_model_RenderSettings$;
var $n_Lreactbuild_common_model_RenderSettings$;
function $m_Lreactbuild_common_model_RenderSettings$() {
  if ((!$n_Lreactbuild_common_model_RenderSettings$)) {
    $n_Lreactbuild_common_model_RenderSettings$ = new $c_Lreactbuild_common_model_RenderSettings$()
  };
  return $n_Lreactbuild_common_model_RenderSettings$
}
function $p_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "settings")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_RenderSettings(x0$7$2);
      if ((x0$7 !== null)) {
        var settings$macro$9 = $n(x0$7).Lreactbuild_common_model_RenderSettings__f_settings;
        return new $c_Lshapeless_$colon$colon(settings$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var settings$macro$8 = $as_sci_Map($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_common_model_RenderSettings(settings$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "settings"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "settings")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "settings"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_inst$macro$1
}
function $p_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_inst$macro$10 = new $c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19($thiz);
    $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3() {
  this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_inst$macro$10 = null;
  this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3.prototype = new $h_O();
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3.prototype.constructor = $c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3;
/** @constructor */
function $h_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3.prototype = $c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3.prototype;
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_inst$macro$1)
});
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3__f_inst$macro$10)
});
var $d_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3 = new $TypeData().initClass({
  Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3: 0
}, false, "reactbuild.common.model.RenderSettings$anon$lazy$macro$11$3", {
  Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3.prototype.$classData = $d_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3;
/** @constructor */
function $c_Lreactbuild_common_model_TypedRefTo$() {
  this.Lreactbuild_common_model_TypedRefTo$__f_codecForTypedRefTo = null;
  $n_Lreactbuild_common_model_TypedRefTo$ = this;
  var inst$macro$20 = new $c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_common_model_TypedRefTo$__f_codecForTypedRefTo = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_common_model_TypedRefTo$.prototype = new $h_O();
$c_Lreactbuild_common_model_TypedRefTo$.prototype.constructor = $c_Lreactbuild_common_model_TypedRefTo$;
/** @constructor */
function $h_Lreactbuild_common_model_TypedRefTo$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_TypedRefTo$.prototype = $c_Lreactbuild_common_model_TypedRefTo$.prototype;
var $d_Lreactbuild_common_model_TypedRefTo$ = new $TypeData().initClass({
  Lreactbuild_common_model_TypedRefTo$: 0
}, false, "reactbuild.common.model.TypedRefTo$", {
  Lreactbuild_common_model_TypedRefTo$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_TypedRefTo$.prototype.$classData = $d_Lreactbuild_common_model_TypedRefTo$;
var $n_Lreactbuild_common_model_TypedRefTo$;
function $m_Lreactbuild_common_model_TypedRefTo$() {
  if ((!$n_Lreactbuild_common_model_TypedRefTo$)) {
    $n_Lreactbuild_common_model_TypedRefTo$ = new $c_Lreactbuild_common_model_TypedRefTo$()
  };
  return $n_Lreactbuild_common_model_TypedRefTo$
}
function $p_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "tpe"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "ref")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_common_model_TypedRefTo(x0$7$2);
      if ((x0$7 !== null)) {
        var tpe$macro$16 = $n(x0$7).Lreactbuild_common_model_TypedRefTo__f_tpe;
        var ref$macro$17 = $n(x0$7).Lreactbuild_common_model_TypedRefTo__f_ref;
        return new $c_Lshapeless_$colon$colon(tpe$macro$16, new $c_Lshapeless_$colon$colon(ref$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var tpe$macro$14 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var ref$macro$15 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_common_model_TypedRefTo(tpe$macro$14, ref$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "tpe"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "tpe"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "ref")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_common_model_package$().Lreactbuild_common_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "tpe"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "ref"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_inst$macro$1
}
function $p_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_inst$macro$18 = new $c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1($thiz);
    $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1() {
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_inst$macro$1 = null;
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_inst$macro$18 = null;
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_bitmap$0 = 0
}
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1.prototype = new $h_O();
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1.prototype.constructor = $c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1;
/** @constructor */
function $h_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1.prototype = $c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1.prototype;
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_inst$macro$1)
});
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1__f_inst$macro$18)
});
var $d_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1 = new $TypeData().initClass({
  Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1: 0
}, false, "reactbuild.common.model.TypedRefTo$anon$lazy$macro$19$1", {
  Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1.prototype.$classData = $d_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1;
/** @constructor */
function $c_Lreactbuild_common_model_package$() {
  this.Lreactbuild_common_model_package$__f_config = null;
  $n_Lreactbuild_common_model_package$ = this;
  $f_Lreactbuild_common_CirceExtendedImplicits__$init$__V(this)
}
$c_Lreactbuild_common_model_package$.prototype = new $h_O();
$c_Lreactbuild_common_model_package$.prototype.constructor = $c_Lreactbuild_common_model_package$;
/** @constructor */
function $h_Lreactbuild_common_model_package$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_package$.prototype = $c_Lreactbuild_common_model_package$.prototype;
$c_Lreactbuild_common_model_package$.prototype.reactbuild$common$CirceExtendedImplicits$_setter_$config_$eq__Lio_circe_generic_extras_Configuration__V = (function(x$1) {
  this.Lreactbuild_common_model_package$__f_config = x$1
});
var $d_Lreactbuild_common_model_package$ = new $TypeData().initClass({
  Lreactbuild_common_model_package$: 0
}, false, "reactbuild.common.model.package$", {
  Lreactbuild_common_model_package$: 1,
  O: 1,
  Lreactbuild_common_CirceExtendedImplicits: 1
});
$c_Lreactbuild_common_model_package$.prototype.$classData = $d_Lreactbuild_common_model_package$;
var $n_Lreactbuild_common_model_package$;
function $m_Lreactbuild_common_model_package$() {
  if ((!$n_Lreactbuild_common_model_package$)) {
    $n_Lreactbuild_common_model_package$ = new $c_Lreactbuild_common_model_package$()
  };
  return $n_Lreactbuild_common_model_package$
}
/** @constructor */
function $c_Lreactbuild_components_Form$Props$$anon$1(_submit$1, _dispatcher$1) {
  this.Lreactbuild_components_Form$Props$$anon$1__f_submit = null;
  this.Lreactbuild_components_Form$Props$$anon$1__f_dispatcher = null;
  this.Lreactbuild_components_Form$Props$$anon$1__f_submit = _submit$1;
  this.Lreactbuild_components_Form$Props$$anon$1__f_dispatcher = _dispatcher$1
}
$c_Lreactbuild_components_Form$Props$$anon$1.prototype = new $h_O();
$c_Lreactbuild_components_Form$Props$$anon$1.prototype.constructor = $c_Lreactbuild_components_Form$Props$$anon$1;
/** @constructor */
function $h_Lreactbuild_components_Form$Props$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_components_Form$Props$$anon$1.prototype = $c_Lreactbuild_components_Form$Props$$anon$1.prototype;
var $d_Lreactbuild_components_Form$Props$$anon$1 = new $TypeData().initClass({
  Lreactbuild_components_Form$Props$$anon$1: 0
}, false, "reactbuild.components.Form$Props$$anon$1", {
  Lreactbuild_components_Form$Props$$anon$1: 1,
  O: 1,
  Lreactbuild_components_Form$Props: 1
});
$c_Lreactbuild_components_Form$Props$$anon$1.prototype.$classData = $d_Lreactbuild_components_Form$Props$$anon$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10.prototype = new $h_O();
$c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10.prototype.constructor = $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10;
/** @constructor */
function $h_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10.prototype = $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10.prototype;
var $d_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10 = new $TypeData().initClass({
  Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10: 0
}, false, "reactbuild.format.dxf.AccumulatingDecoder$$anon$10", {
  Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10: 1,
  O: 1,
  Lreactbuild_format_dxf_AccumulatingDecoder: 1
});
$c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10.prototype.$classData = $d_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10;
/** @constructor */
function $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$2, decodeT$1) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11.prototype = new $h_O();
$c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11.prototype.constructor = $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11;
/** @constructor */
function $h_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11.prototype = $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11.prototype;
var $d_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11 = new $TypeData().initClass({
  Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11: 0
}, false, "reactbuild.format.dxf.AccumulatingDecoder$$anon$11", {
  Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11: 1,
  O: 1,
  Lreactbuild_format_dxf_AccumulatingDecoder: 1
});
$c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11.prototype.$classData = $d_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11;
/** @constructor */
function $c_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8(outer) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8.prototype = new $h_O();
$c_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8.prototype.constructor = $c_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8;
/** @constructor */
function $h_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8.prototype = $c_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8.prototype;
var $d_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8 = new $TypeData().initClass({
  Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8: 0
}, false, "reactbuild.format.dxf.AccumulatingEncoderInstances$$anon$8", {
  Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8: 1,
  O: 1,
  Lreactbuild_format_dxf_AccumulatingEncoder: 1
});
$c_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8.prototype.$classData = $d_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8;
/** @constructor */
function $c_Lreactbuild_format_dxf_Block$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Block$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Block$.prototype.constructor = $c_Lreactbuild_format_dxf_Block$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Block$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Block$.prototype = $c_Lreactbuild_format_dxf_Block$.prototype;
$c_Lreactbuild_format_dxf_Block$.prototype.encodeBlock__Lreactbuild_format_dxf_Encoder = (function() {
  var inst$macro$512 = new $c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$512));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  var this$10 = $n($as_Lreactbuild_format_dxf_Encoder(encoder.value__O()));
  var f = new $c_sjsr_AnonFunction1(((block$2) => {
    var block = $as_Lreactbuild_format_dxf_Block(block$2);
    if ($n($n(block).Lreactbuild_format_dxf_Block__f_name2).isEmpty__Z()) {
      var x$5 = new $c_s_Some($n(block).Lreactbuild_format_dxf_Block__f_name);
      var this$4 = $n(block);
      var x$6 = this$4.Lreactbuild_format_dxf_Block__f_layer;
      var this$5 = $n(block);
      var x$7 = this$5.Lreactbuild_format_dxf_Block__f_name;
      var this$6 = $n(block);
      var x$8 = this$6.Lreactbuild_format_dxf_Block__f_flags;
      var this$7 = $n(block);
      var x$9 = this$7.Lreactbuild_format_dxf_Block__f_base;
      var this$8 = $n(block);
      var x$10 = this$8.Lreactbuild_format_dxf_Block__f_entries;
      $n(block);
      return new $c_Lreactbuild_format_dxf_Block(x$6, x$7, x$8, x$9, x$5, x$10)
    } else {
      return block
    }
  }));
  var qual$1 = new $c_Lreactbuild_format_dxf_Encoder$$anon$4(this$10, f);
  var x$11 = new $c_sjsr_AnonFunction1(((in$2) => {
    $as_Lreactbuild_format_dxf_Block(in$2);
    $n($m_s_package$().s_package$__f_List);
    var array = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "BLOCK")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  }));
  $n($m_s_package$().s_package$__f_List);
  var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDBLK")];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var x$12 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  return new $c_Lreactbuild_format_dxf_Encoder$$anon$1(qual$1, false, x$11, x$12)
});
$c_Lreactbuild_format_dxf_Block$.prototype.decodeBlock__Lreactbuild_format_dxf_Decoder = (function() {
  var inst$macro$685 = new $c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1().inst$macro$1__Lreactbuild_format_dxf_Decoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$685));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t);
  var this$7 = $n($as_Lreactbuild_format_dxf_Decoder(decoder.value__O()));
  var array = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "BLOCK")];
  var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$11 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$7, prefix);
  var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDBLK")];
  var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  return new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$11, suffix)
});
var $d_Lreactbuild_format_dxf_Block$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Block$: 0
}, false, "reactbuild.format.dxf.Block$", {
  Lreactbuild_format_dxf_Block$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Block$.prototype.$classData = $d_Lreactbuild_format_dxf_Block$;
var $n_Lreactbuild_format_dxf_Block$;
function $m_Lreactbuild_format_dxf_Block$() {
  if ((!$n_Lreactbuild_format_dxf_Block$)) {
    $n_Lreactbuild_format_dxf_Block$ = new $c_Lreactbuild_format_dxf_Block$()
  };
  return $n_Lreactbuild_format_dxf_Block$
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$32 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "layer"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "name"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "flags"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "base"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "name2"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "entries")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Block(x0$3$2);
      if ((x0$3 !== null)) {
        var layer$macro$20 = $n(x0$3).Lreactbuild_format_dxf_Block__f_layer;
        var name$macro$21 = $n(x0$3).Lreactbuild_format_dxf_Block__f_name;
        var flags$macro$22 = $n(x0$3).Lreactbuild_format_dxf_Block__f_flags;
        var base$macro$23 = $n(x0$3).Lreactbuild_format_dxf_Block__f_base;
        var name2$macro$24 = $n(x0$3).Lreactbuild_format_dxf_Block__f_name2;
        var entries$macro$25 = $n(x0$3).Lreactbuild_format_dxf_Block__f_entries;
        return new $c_Lshapeless_$colon$colon(layer$macro$20, new $c_Lshapeless_$colon$colon(name$macro$21, new $c_Lshapeless_$colon$colon(flags$macro$22, new $c_Lshapeless_$colon$colon(base$macro$23, new $c_Lshapeless_$colon$colon(name2$macro$24, new $c_Lshapeless_$colon$colon(entries$macro$25, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var layer$macro$14 = $as_Lreactbuild_format_dxf_NameOf($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var name$macro$15 = $as_Lreactbuild_format_dxf_NameOf($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var flags$macro$16 = $as_Lreactbuild_format_dxf_BlockFlags($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var base$macro$17 = $as_Lreactbuild_format_dxf_Point3D($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var name2$macro$18 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var entries$macro$19 = $as_sci_List($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_format_dxf_Block(layer$macro$14, name$macro$15, flags$macro$16, base$macro$17, name2$macro$18, entries$macro$19)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "entries"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "name2"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "base"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(3)), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$32, encoder, gen$1, annots);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$29__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$26 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$26
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$32__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$29 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (4 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$29
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$32$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (8 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_BlockFlags$().Lreactbuild_format_dxf_BlockFlags$__f_serializeBlockFlags;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$47__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$32 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (8 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$32
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$47$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (16 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$22 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var this$20 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "z")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$13$2) => {
      var x0$13 = $as_Lreactbuild_format_dxf_Point3D(x0$13$2);
      if ((x0$13 !== null)) {
        var x$macro$57 = $n(x0$13).Lreactbuild_format_dxf_Point3D__f_x;
        var y$macro$58 = $n(x0$13).Lreactbuild_format_dxf_Point3D__f_y;
        var z$macro$59 = $n(x0$13).Lreactbuild_format_dxf_Point3D__f_z;
        return new $c_Lshapeless_$colon$colon(x$macro$57, new $c_Lshapeless_$colon$colon(y$macro$58, new $c_Lshapeless_$colon$colon(z$macro$59, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$13)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$14$2) => {
      var x0$14 = $as_Lshapeless_$colon$colon(x0$14$2);
      if ((x0$14 !== null)) {
        var x$macro$54 = $uD($n(x0$14).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$14).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$55 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var z$macro$56 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_format_dxf_Point3D(x$macro$54, y$macro$55, z$macro$56)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$14)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "z"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(10)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(20)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(30)), $m_Lshapeless_HNil$())))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$60__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var encodeV = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$20, encoder, gen$1, annots);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$76__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$47 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$22, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (16 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$47
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$60$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (32 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$61__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$60 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (32 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$60
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$61$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$62__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$61 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (64 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$61
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$62$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (128 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$63__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$62 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (128 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$62
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$63$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (256 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$63 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (256 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$63
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$76$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (512 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$79__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$76 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (512 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$76
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$79$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encoderA = $m_Lreactbuild_format_dxf_Entity$().Lreactbuild_format_dxf_Entity$__f_encodeEntity;
    var encodeV = new $c_Lreactbuild_format_dxf_Encoder$$anon$14(encoderA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$63__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$79 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
    var lo$1 = (1024 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$79
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1() {
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$26 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$29 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$32 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$47 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$60 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$61 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$62 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$63 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$76 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$79 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0 = $L0
}
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.constructor = $c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype = $c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype;
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$1
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$26__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$26
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$29__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$29
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$32__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (8 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$32$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$32
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$47__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (16 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$47$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$47
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$60__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (32 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$60$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$60
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$61__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$61$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$61
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$62__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (128 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$62$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$62
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$63__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (256 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$63$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$63
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$76__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (512 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$76$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$76
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.inst$macro$79__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_bitmap$0;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__inst$macro$79$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1__f_inst$macro$79
  }
});
var $d_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1: 0
}, false, "reactbuild.format.dxf.Block$anon$lazy$macro$511$1", {
  Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1.prototype.$classData = $d_Lreactbuild_format_dxf_Block$anon$lazy$macro$511$1;
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$32 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "layer"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "name"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "flags"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "base"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "name2"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "entries")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Block(x0$3$2);
      if ((x0$3 !== null)) {
        var layer$macro$20 = $n(x0$3).Lreactbuild_format_dxf_Block__f_layer;
        var name$macro$21 = $n(x0$3).Lreactbuild_format_dxf_Block__f_name;
        var flags$macro$22 = $n(x0$3).Lreactbuild_format_dxf_Block__f_flags;
        var base$macro$23 = $n(x0$3).Lreactbuild_format_dxf_Block__f_base;
        var name2$macro$24 = $n(x0$3).Lreactbuild_format_dxf_Block__f_name2;
        var entries$macro$25 = $n(x0$3).Lreactbuild_format_dxf_Block__f_entries;
        return new $c_Lshapeless_$colon$colon(layer$macro$20, new $c_Lshapeless_$colon$colon(name$macro$21, new $c_Lshapeless_$colon$colon(flags$macro$22, new $c_Lshapeless_$colon$colon(base$macro$23, new $c_Lshapeless_$colon$colon(name2$macro$24, new $c_Lshapeless_$colon$colon(entries$macro$25, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var layer$macro$14 = $as_Lreactbuild_format_dxf_NameOf($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var name$macro$15 = $as_Lreactbuild_format_dxf_NameOf($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var flags$macro$16 = $as_Lreactbuild_format_dxf_BlockFlags($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var base$macro$17 = $as_Lreactbuild_format_dxf_Point3D($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var name2$macro$18 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var entries$macro$19 = $as_sci_List($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_format_dxf_Block(layer$macro$14, name$macro$15, flags$macro$16, base$macro$17, name2$macro$18, entries$macro$19)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "entries"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "name2"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "base"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(3)), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$32);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$29__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$26 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$26
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$32__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$29 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
    var lo$1 = (4 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$29
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$32$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (8 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_BlockFlags$().Lreactbuild_format_dxf_BlockFlags$__f_deserializeBlockFlags;
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$47__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$32 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
    var lo$1 = (8 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$32
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$47$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (16 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$48__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$77__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$47 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
    var lo$1 = (16 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$47
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$48$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (32 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$48 = $m_Lreactbuild_format_dxf_Point3D$().Lreactbuild_format_dxf_Point3D$__f_decoderPoint3D;
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
    var lo$1 = (32 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$48
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$77$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$80__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$77 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
    var lo$1 = (1024 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$77
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$80$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$81__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$659__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$80 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
    var lo$1 = (2048 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$80
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$81$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (4096 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var decodeA = $m_Lreactbuild_format_dxf_Entity$().Lreactbuild_format_dxf_Entity$__f_decodeEntity;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$81 = new $c_Lreactbuild_format_dxf_Decoder$$anon$17(decodeA);
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
    var lo$1 = (4096 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$81
}
function $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$659$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$1;
  var lo = (262144 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$659 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    var b$1 = $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$1;
    var lo$1 = (262144 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$659
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1() {
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$26 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$29 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$32 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$47 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$48 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$77 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$80 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$81 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$659 = null;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0 = $L0;
  this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$1 = $L0
}
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.constructor = $c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype = $c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype;
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$1
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$26__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$26
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$29__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$29
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$32__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (8 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$32$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$32
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$47__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (16 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$47$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$47
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$48__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (32 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$48$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$48
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$77__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$77$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$77
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$80__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$80$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$80
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$81__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$0;
  var lo = (4096 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$81$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$81
  }
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.inst$macro$659__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_bitmap$1;
  var lo = (262144 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__inst$macro$659$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1__f_inst$macro$659
  }
});
var $d_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1: 0
}, false, "reactbuild.format.dxf.Block$anon$lazy$macro$684$1", {
  Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1.prototype.$classData = $d_Lreactbuild_format_dxf_Block$anon$lazy$macro$684$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_BlockFlags$() {
  this.Lreactbuild_format_dxf_BlockFlags$__f_serializeBlockFlags = null;
  this.Lreactbuild_format_dxf_BlockFlags$__f_deserializeBlockFlags = null;
  $n_Lreactbuild_format_dxf_BlockFlags$ = this;
  $m_Lreactbuild_format_dxf_Serializer$();
  var $$x4 = $m_Lreactbuild_format_dxf_Serializer$();
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_format_dxf_BlockFlags(x0$1$2);
    if ((x0$1 !== null)) {
      var referenced$macro$9 = $n(x0$1).Lreactbuild_format_dxf_BlockFlags__f_referenced;
      var dependentXrefResolved$macro$10 = $n(x0$1).Lreactbuild_format_dxf_BlockFlags__f_dependentXrefResolved;
      var dependentXref$macro$11 = $n(x0$1).Lreactbuild_format_dxf_BlockFlags__f_dependentXref;
      var xrefOverlay$macro$12 = $n(x0$1).Lreactbuild_format_dxf_BlockFlags__f_xrefOverlay;
      var isExternalXref$macro$13 = $n(x0$1).Lreactbuild_format_dxf_BlockFlags__f_isExternalXref;
      var hasNonConstantAttribute$macro$14 = $n(x0$1).Lreactbuild_format_dxf_BlockFlags__f_hasNonConstantAttribute;
      var anonymous$macro$15 = $n(x0$1).Lreactbuild_format_dxf_BlockFlags__f_anonymous;
      return new $c_Lshapeless_$colon$colon(referenced$macro$9, new $c_Lshapeless_$colon$colon(dependentXrefResolved$macro$10, new $c_Lshapeless_$colon$colon(dependentXref$macro$11, new $c_Lshapeless_$colon$colon(xrefOverlay$macro$12, new $c_Lshapeless_$colon$colon(isExternalXref$macro$13, new $c_Lshapeless_$colon$colon(hasNonConstantAttribute$macro$14, new $c_Lshapeless_$colon$colon(anonymous$macro$15, $m_Lshapeless_HNil$())))))))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  var g = new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_Lshapeless_$colon$colon(x0$2$2);
    if ((x0$2 !== null)) {
      var referenced$macro$2 = $uZ($n(x0$2).Lshapeless_$colon$colon__f_head);
      var p2 = $as_Lshapeless_$colon$colon($n(x0$2).Lshapeless_$colon$colon__f_tail);
      if ((p2 !== null)) {
        var dependentXrefResolved$macro$3 = $uZ($n(p2).Lshapeless_$colon$colon__f_head);
        var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
        if ((p3 !== null)) {
          var dependentXref$macro$4 = $uZ($n(p3).Lshapeless_$colon$colon__f_head);
          var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
          if ((p4 !== null)) {
            var xrefOverlay$macro$5 = $uZ($n(p4).Lshapeless_$colon$colon__f_head);
            var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
            if ((p5 !== null)) {
              var isExternalXref$macro$6 = $uZ($n(p5).Lshapeless_$colon$colon__f_head);
              var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
              if ((p6 !== null)) {
                var hasNonConstantAttribute$macro$7 = $uZ($n(p6).Lshapeless_$colon$colon__f_head);
                var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                if ((p7 !== null)) {
                  var anonymous$macro$8 = $uZ($n(p7).Lshapeless_$colon$colon__f_head);
                  var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p8)) {
                    return new $c_Lreactbuild_format_dxf_BlockFlags(referenced$macro$2, dependentXrefResolved$macro$3, dependentXref$macro$4, xrefOverlay$macro$5, isExternalXref$macro$6, hasNonConstantAttribute$macro$7, anonymous$macro$8)
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$2)
  }));
  var $$x3 = new $c_Lshapeless_Generic$$anon$1(f, g);
  var this$4 = $m_s_$less$colon$less$();
  var ev = this$4.s_$less$colon$less$__f_singleton;
  var this$5 = $m_sci_List$();
  var cbf = new $c_sc_IterableFactory$ToFactory(this$5);
  var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev);
  var u = new $c_Lshapeless_Lub$$anon$4();
  var this$9 = $m_sci_List$();
  var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$9);
  var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
  var u$1 = new $c_Lshapeless_Lub$$anon$4();
  var this$13 = $m_sci_List$();
  var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$13);
  var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
  var u$2 = new $c_Lshapeless_Lub$$anon$4();
  var this$17 = $m_sci_List$();
  var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$17);
  var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
  var u$3 = new $c_Lshapeless_Lub$$anon$4();
  var this$21 = $m_sci_List$();
  var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$21);
  var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
  var u$4 = new $c_Lshapeless_Lub$$anon$4();
  var this$25 = $m_sci_List$();
  var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$25);
  var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
  var u$5 = new $c_Lshapeless_Lub$$anon$4();
  var this$29 = $m_sci_List$();
  var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$29);
  var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
  var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(6)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(5)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(4)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(3)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(1)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(0)), $m_Lshapeless_HNil$())))))))));
  var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
  var this$33 = $m_s_$less$colon$less$();
  var ev$1 = this$33.s_$less$colon$less$__f_singleton;
  var this$34 = $m_sci_List$();
  var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$34);
  var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$1);
  var u$6 = new $c_Lshapeless_Lub$$anon$4();
  var this$38 = $m_sci_List$();
  var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$38);
  var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
  var u$7 = new $c_Lshapeless_Lub$$anon$4();
  var this$42 = $m_sci_List$();
  var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$42);
  var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
  var u$8 = new $c_Lshapeless_Lub$$anon$4();
  var this$46 = $m_sci_List$();
  var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$46);
  var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
  var u$9 = new $c_Lshapeless_Lub$$anon$4();
  var this$50 = $m_sci_List$();
  var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$50);
  var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
  var u$10 = new $c_Lshapeless_Lub$$anon$4();
  var this$54 = $m_sci_List$();
  var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$54);
  var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
  var u$11 = new $c_Lshapeless_Lub$$anon$4();
  var this$58 = $m_sci_List$();
  var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$58);
  var inst$macro$16 = $n($$x4).serializeBitSetCaseClass__Lshapeless_Generic__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lreactbuild_format_dxf_Serializer($$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11));
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$16));
  var serializer = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_BlockFlags$__f_serializeBlockFlags = $as_Lreactbuild_format_dxf_Serializer(serializer.value__O());
  var f$1 = new $c_sjsr_AnonFunction1(((x0$3$2) => {
    var x0$3 = $as_Lreactbuild_format_dxf_BlockFlags(x0$3$2);
    if ((x0$3 !== null)) {
      var referenced$macro$25 = $n(x0$3).Lreactbuild_format_dxf_BlockFlags__f_referenced;
      var dependentXrefResolved$macro$26 = $n(x0$3).Lreactbuild_format_dxf_BlockFlags__f_dependentXrefResolved;
      var dependentXref$macro$27 = $n(x0$3).Lreactbuild_format_dxf_BlockFlags__f_dependentXref;
      var xrefOverlay$macro$28 = $n(x0$3).Lreactbuild_format_dxf_BlockFlags__f_xrefOverlay;
      var isExternalXref$macro$29 = $n(x0$3).Lreactbuild_format_dxf_BlockFlags__f_isExternalXref;
      var hasNonConstantAttribute$macro$30 = $n(x0$3).Lreactbuild_format_dxf_BlockFlags__f_hasNonConstantAttribute;
      var anonymous$macro$31 = $n(x0$3).Lreactbuild_format_dxf_BlockFlags__f_anonymous;
      return new $c_Lshapeless_$colon$colon(referenced$macro$25, new $c_Lshapeless_$colon$colon(dependentXrefResolved$macro$26, new $c_Lshapeless_$colon$colon(dependentXref$macro$27, new $c_Lshapeless_$colon$colon(xrefOverlay$macro$28, new $c_Lshapeless_$colon$colon(isExternalXref$macro$29, new $c_Lshapeless_$colon$colon(hasNonConstantAttribute$macro$30, new $c_Lshapeless_$colon$colon(anonymous$macro$31, $m_Lshapeless_HNil$())))))))
    } else {
      throw new $c_s_MatchError(x0$3)
    }
  }));
  var g$1 = new $c_sjsr_AnonFunction1(((x0$4$2) => {
    var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
    if ((x0$4 !== null)) {
      var referenced$macro$18 = $uZ($n(x0$4).Lshapeless_$colon$colon__f_head);
      var p2$1 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
      if ((p2$1 !== null)) {
        var dependentXrefResolved$macro$19 = $uZ($n(p2$1).Lshapeless_$colon$colon__f_head);
        var p3$1 = $as_Lshapeless_$colon$colon($n(p2$1).Lshapeless_$colon$colon__f_tail);
        if ((p3$1 !== null)) {
          var dependentXref$macro$20 = $uZ($n(p3$1).Lshapeless_$colon$colon__f_head);
          var p4$1 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
          if ((p4$1 !== null)) {
            var xrefOverlay$macro$21 = $uZ($n(p4$1).Lshapeless_$colon$colon__f_head);
            var p5$1 = $as_Lshapeless_$colon$colon($n(p4$1).Lshapeless_$colon$colon__f_tail);
            if ((p5$1 !== null)) {
              var isExternalXref$macro$22 = $uZ($n(p5$1).Lshapeless_$colon$colon__f_head);
              var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
              if ((p6$1 !== null)) {
                var hasNonConstantAttribute$macro$23 = $uZ($n(p6$1).Lshapeless_$colon$colon__f_head);
                var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                if ((p7$1 !== null)) {
                  var anonymous$macro$24 = $uZ($n(p7$1).Lshapeless_$colon$colon__f_head);
                  var p8$1 = $as_Lshapeless_HNil($n(p7$1).Lshapeless_$colon$colon__f_tail);
                  var x$1 = $m_Lshapeless_HNil$();
                  if ((x$1 === p8$1)) {
                    return new $c_Lreactbuild_format_dxf_BlockFlags(referenced$macro$18, dependentXrefResolved$macro$19, dependentXref$macro$20, xrefOverlay$macro$21, isExternalXref$macro$22, hasNonConstantAttribute$macro$23, anonymous$macro$24)
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$4)
  }));
  new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
  $m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hnilFromTraversable__Lshapeless_ops_traversable$FromTraversable(), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable);
  var annotations$1 = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(6)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(5)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(4)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(3)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(1)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(0)), $m_Lshapeless_HNil$())))))))));
  new $c_Lshapeless_Annotations$$anon$2(annotations$1);
  var this$65 = $m_s_$less$colon$less$();
  var ev$2 = this$65.s_$less$colon$less$__f_singleton;
  var this$66 = $m_sci_List$();
  var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$66);
  var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$14, ev$2);
  var u$12 = new $c_Lshapeless_Lub$$anon$4();
  var this$70 = $m_sci_List$();
  var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$70);
  var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$12, tttvs$12);
  var u$13 = new $c_Lshapeless_Lub$$anon$4();
  var this$74 = $m_sci_List$();
  var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$74);
  var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$13, tttvs$13);
  var u$14 = new $c_Lshapeless_Lub$$anon$4();
  var this$78 = $m_sci_List$();
  var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$78);
  var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$14, tttvs$14);
  var u$15 = new $c_Lshapeless_Lub$$anon$4();
  var this$82 = $m_sci_List$();
  var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$82);
  var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$15, tttvs$15);
  var u$16 = new $c_Lshapeless_Lub$$anon$4();
  var this$86 = $m_sci_List$();
  var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$86);
  var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$16, tttvs$16);
  var u$17 = new $c_Lshapeless_Lub$$anon$4();
  var this$90 = $m_sci_List$();
  var cbf$20 = new $c_sc_IterableFactory$ToFactory(this$90);
  new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$20, u$17, tttvs$17);
  var inst$macro$32 = new $c_Lreactbuild_format_dxf_Parser$$anon$3();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$32));
  var parser = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_BlockFlags$__f_deserializeBlockFlags = $as_Lreactbuild_format_dxf_Parser(parser.value__O())
}
$c_Lreactbuild_format_dxf_BlockFlags$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_BlockFlags$.prototype.constructor = $c_Lreactbuild_format_dxf_BlockFlags$;
/** @constructor */
function $h_Lreactbuild_format_dxf_BlockFlags$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_BlockFlags$.prototype = $c_Lreactbuild_format_dxf_BlockFlags$.prototype;
var $d_Lreactbuild_format_dxf_BlockFlags$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_BlockFlags$: 0
}, false, "reactbuild.format.dxf.BlockFlags$", {
  Lreactbuild_format_dxf_BlockFlags$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_BlockFlags$.prototype.$classData = $d_Lreactbuild_format_dxf_BlockFlags$;
var $n_Lreactbuild_format_dxf_BlockFlags$;
function $m_Lreactbuild_format_dxf_BlockFlags$() {
  if ((!$n_Lreactbuild_format_dxf_BlockFlags$)) {
    $n_Lreactbuild_format_dxf_BlockFlags$ = new $c_Lreactbuild_format_dxf_BlockFlags$()
  };
  return $n_Lreactbuild_format_dxf_BlockFlags$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Blocks$() {
  this.Lreactbuild_format_dxf_Blocks$__f_encodeBlocksSection = null;
  this.Lreactbuild_format_dxf_Blocks$__f_decodeBlocksSection = null;
  $n_Lreactbuild_format_dxf_Blocks$ = this;
  var inst$macro$521 = new $c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$521));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Blocks$__f_encodeBlocksSection = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$1217 = new $c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1().inst$macro$522__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$1217));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Blocks$__f_decodeBlocksSection = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Blocks$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Blocks$.prototype.constructor = $c_Lreactbuild_format_dxf_Blocks$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Blocks$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Blocks$.prototype = $c_Lreactbuild_format_dxf_Blocks$.prototype;
var $d_Lreactbuild_format_dxf_Blocks$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Blocks$: 0
}, false, "reactbuild.format.dxf.Blocks$", {
  Lreactbuild_format_dxf_Blocks$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Blocks$.prototype.$classData = $d_Lreactbuild_format_dxf_Blocks$;
var $n_Lreactbuild_format_dxf_Blocks$;
function $m_Lreactbuild_format_dxf_Blocks$() {
  if ((!$n_Lreactbuild_format_dxf_Blocks$)) {
    $n_Lreactbuild_format_dxf_Blocks$ = new $c_Lreactbuild_format_dxf_Blocks$()
  };
  return $n_Lreactbuild_format_dxf_Blocks$
}
function $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__inst$macro$522$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$12 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "blockDefinitionEntities")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$127$2) => {
      var x0$127 = $as_Lreactbuild_format_dxf_Blocks(x0$127$2);
      if ((x0$127 !== null)) {
        var blockDefinitionEntities$macro$526 = $n(x0$127).Lreactbuild_format_dxf_Blocks__f_blockDefinitionEntities;
        return new $c_Lshapeless_$colon$colon(blockDefinitionEntities$macro$526, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$127)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$128$2) => {
      var x0$128 = $as_Lshapeless_$colon$colon(x0$128$2);
      if ((x0$128 !== null)) {
        var blockDefinitionEntities$macro$525 = $as_sci_List($n(x0$128).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$128).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_Blocks(blockDefinitionEntities$macro$525)
        }
      };
      throw new $c_s_MatchError(x0$128)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "blockDefinitionEntities"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$527__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$522 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$12);
    var b$1 = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$522
}
function $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__inst$macro$527$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$528__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1211__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$527 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$527
}
function $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__inst$macro$528$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var decodeA = $m_Lreactbuild_format_dxf_Block$().decodeBlock__Lreactbuild_format_dxf_Decoder();
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$528 = new $c_Lreactbuild_format_dxf_Decoder$$anon$17(decodeA);
    var b$1 = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0;
    var lo$1 = (4 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$528
}
function $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__inst$macro$1211$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$1;
  var lo = (2097152 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$1211 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    var b$1 = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$1;
    var lo$1 = (2097152 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$1211
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1() {
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$522 = null;
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$527 = null;
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$528 = null;
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$1211 = null;
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0 = $L0;
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$1 = $L0
}
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1.prototype.constructor = $c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1.prototype = $c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1.prototype;
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1.prototype.inst$macro$522__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__inst$macro$522$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$522
  }
});
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1.prototype.inst$macro$527__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__inst$macro$527$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$527
  }
});
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1.prototype.inst$macro$528__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__inst$macro$528$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$528
  }
});
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1.prototype.inst$macro$1211__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_bitmap$1;
  var lo = (2097152 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__inst$macro$1211$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1__f_inst$macro$1211
  }
});
var $d_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1: 0
}, false, "reactbuild.format.dxf.Blocks$anon$lazy$macro$1216$1", {
  Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1.prototype.$classData = $d_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$1216$1;
function $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$12 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "blockDefinitionEntities")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Blocks(x0$3$2);
      if ((x0$3 !== null)) {
        var blockDefinitionEntities$macro$5 = $n(x0$3).Lreactbuild_format_dxf_Blocks__f_blockDefinitionEntities;
        return new $c_Lshapeless_$colon$colon(blockDefinitionEntities$macro$5, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var blockDefinitionEntities$macro$4 = $as_sci_List($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_Blocks(blockDefinitionEntities$macro$4)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "blockDefinitionEntities"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$12, encoder, gen$1, annots);
    var b$1 = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encoderA = $m_Lreactbuild_format_dxf_Block$().encodeBlock__Lreactbuild_format_dxf_Encoder();
    var encodeV = new $c_Lreactbuild_format_dxf_Encoder$$anon$14(encoderA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$68__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$6 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$6
}
function $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__inst$macro$68$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0;
  var lo = (512 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$68 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    var b$1 = $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0;
    var lo$1 = (512 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$68
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1() {
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$6 = null;
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$68 = null;
  this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0 = $L0
}
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1.prototype.constructor = $c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1.prototype = $c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1.prototype;
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  var b = this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$1
  }
});
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1.prototype.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$6
  }
});
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1.prototype.inst$macro$68__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_bitmap$0;
  var lo = (512 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__inst$macro$68$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1__f_inst$macro$68
  }
});
var $d_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1: 0
}, false, "reactbuild.format.dxf.Blocks$anon$lazy$macro$520$1", {
  Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1.prototype.$classData = $d_Lreactbuild_format_dxf_Blocks$anon$lazy$macro$520$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Circle$() {
  this.Lreactbuild_format_dxf_Circle$__f_encodeCircle = null;
  this.Lreactbuild_format_dxf_Circle$__f_decodeCircle = null;
  $n_Lreactbuild_format_dxf_Circle$ = this;
  var inst$macro$80 = new $c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$80));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Circle$__f_encodeCircle = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$162 = new $c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1().inst$macro$81__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$162));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Circle$__f_decodeCircle = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Circle$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Circle$.prototype.constructor = $c_Lreactbuild_format_dxf_Circle$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Circle$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Circle$.prototype = $c_Lreactbuild_format_dxf_Circle$.prototype;
var $d_Lreactbuild_format_dxf_Circle$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Circle$: 0
}, false, "reactbuild.format.dxf.Circle$", {
  Lreactbuild_format_dxf_Circle$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Circle$.prototype.$classData = $d_Lreactbuild_format_dxf_Circle$;
var $n_Lreactbuild_format_dxf_Circle$;
function $m_Lreactbuild_format_dxf_Circle$() {
  if ((!$n_Lreactbuild_format_dxf_Circle$)) {
    $n_Lreactbuild_format_dxf_Circle$ = new $c_Lreactbuild_format_dxf_Circle$()
  };
  return $n_Lreactbuild_format_dxf_Circle$
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$81$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0)) {
    var this$28 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "layer"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "color"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "center"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "radius"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "thickness")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_format_dxf_Circle(x0$23$2);
      if ((x0$23 !== null)) {
        var layer$macro$97 = $n(x0$23).Lreactbuild_format_dxf_Circle__f_layer;
        var color$macro$98 = $n(x0$23).Lreactbuild_format_dxf_Circle__f_color;
        var center$macro$99 = $n(x0$23).Lreactbuild_format_dxf_Circle__f_center;
        var radius$macro$100 = $n(x0$23).Lreactbuild_format_dxf_Circle__f_radius;
        var thickness$macro$101 = $n(x0$23).Lreactbuild_format_dxf_Circle__f_thickness;
        return new $c_Lshapeless_$colon$colon(layer$macro$97, new $c_Lshapeless_$colon$colon(color$macro$98, new $c_Lshapeless_$colon$colon(center$macro$99, new $c_Lshapeless_$colon$colon(radius$macro$100, new $c_Lshapeless_$colon$colon(thickness$macro$101, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var layer$macro$92 = $as_Lreactbuild_format_dxf_NameOf($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var color$macro$93 = $as_Lreactbuild_format_dxf_ColorIndex($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var center$macro$94 = $as_Lreactbuild_format_dxf_Point3D($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var radius$macro$95 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var thickness$macro$96 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_format_dxf_Circle(layer$macro$92, color$macro$93, center$macro$94, radius$macro$95, thickness$macro$96)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "thickness"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "radius"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "center"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(40)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(39)), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$102__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$81 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$28);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$81
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$102$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$105__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$102 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$102
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$105$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_parseColorIndex;
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$108__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$105 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$105
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$108$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$109__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$138__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$108 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$108
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$109$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$109 = $m_Lreactbuild_format_dxf_Point3D$().Lreactbuild_format_dxf_Point3D$__f_decoderPoint3D;
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$109
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$138$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((512 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$139__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$138 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$138
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$139$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$140__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$139 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$139
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$140$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$140 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$140
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1() {
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$81 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$102 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$105 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$108 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$109 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$138 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$139 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$140 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.constructor = $c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype = $c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype;
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.inst$macro$81__Lreactbuild_format_dxf_Decoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$81$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$81)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.inst$macro$102__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$102$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$102)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.inst$macro$105__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$105$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$105)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.inst$macro$108__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$108$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$108)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.inst$macro$109__Lreactbuild_format_dxf_Decoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$109$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$109)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.inst$macro$138__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((512 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$138$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$138)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.inst$macro$139__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((1024 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$139$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$139)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.inst$macro$140__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((2048 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__inst$macro$140$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1__f_inst$macro$140)
});
var $d_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1: 0
}, false, "reactbuild.format.dxf.Circle$anon$lazy$macro$161$1", {
  Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1.prototype.$classData = $d_Lreactbuild_format_dxf_Circle$anon$lazy$macro$161$1;
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$28 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "layer"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "color"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "center"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "radius"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "thickness")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Circle(x0$3$2);
      if ((x0$3 !== null)) {
        var layer$macro$17 = $n(x0$3).Lreactbuild_format_dxf_Circle__f_layer;
        var color$macro$18 = $n(x0$3).Lreactbuild_format_dxf_Circle__f_color;
        var center$macro$19 = $n(x0$3).Lreactbuild_format_dxf_Circle__f_center;
        var radius$macro$20 = $n(x0$3).Lreactbuild_format_dxf_Circle__f_radius;
        var thickness$macro$21 = $n(x0$3).Lreactbuild_format_dxf_Circle__f_thickness;
        return new $c_Lshapeless_$colon$colon(layer$macro$17, new $c_Lshapeless_$colon$colon(color$macro$18, new $c_Lshapeless_$colon$colon(center$macro$19, new $c_Lshapeless_$colon$colon(radius$macro$20, new $c_Lshapeless_$colon$colon(thickness$macro$21, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var layer$macro$12 = $as_Lreactbuild_format_dxf_NameOf($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var color$macro$13 = $as_Lreactbuild_format_dxf_ColorIndex($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var center$macro$14 = $as_Lreactbuild_format_dxf_Point3D($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var radius$macro$15 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var thickness$macro$16 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_format_dxf_Circle(layer$macro$12, color$macro$13, center$macro$14, radius$macro$15, thickness$macro$16)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "thickness"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "radius"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "center"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(40)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(39)), $m_Lshapeless_HNil$())))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$22__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$28, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$22$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$25__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$22 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$22
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$25$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_serializeColorIndex;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$28__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$25 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$25
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$28$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$22 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var this$20 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "z")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_format_dxf_Point3D(x0$11$2);
      if ((x0$11 !== null)) {
        var x$macro$38 = $n(x0$11).Lreactbuild_format_dxf_Point3D__f_x;
        var y$macro$39 = $n(x0$11).Lreactbuild_format_dxf_Point3D__f_y;
        var z$macro$40 = $n(x0$11).Lreactbuild_format_dxf_Point3D__f_z;
        return new $c_Lshapeless_$colon$colon(x$macro$38, new $c_Lshapeless_$colon$colon(y$macro$39, new $c_Lshapeless_$colon$colon(z$macro$40, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
      if ((x0$12 !== null)) {
        var x$macro$35 = $uD($n(x0$12).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$12).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$36 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var z$macro$37 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_format_dxf_Point3D(x$macro$35, y$macro$36, z$macro$37)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$12)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "z"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(10)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(20)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(30)), $m_Lshapeless_HNil$())))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$41__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var encodeV = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$20, encoder, gen$1, annots);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$57__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$28 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$22, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$28
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$41$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$41 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$41
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$42$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$43__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$42 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$42
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$43$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$44__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$43 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$43
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$44$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$44 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$44
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$57$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$57 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$57
}
function $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$58$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$44__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$58 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1() {
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$22 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$25 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$28 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$41 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$42 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$43 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$44 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$57 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$58 = null;
  this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.constructor = $c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype = $c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype;
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$22__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$22$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$22)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$25__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$25$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$25)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$28__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$28$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$28)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$41__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$41$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$41)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$42__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$42$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$42)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$43__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((64 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$43$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$43)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$44__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((128 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$44$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$44)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$57__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((256 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$57$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$57)
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.inst$macro$58__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((512 & this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__inst$macro$58$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1__f_inst$macro$58)
});
var $d_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1: 0
}, false, "reactbuild.format.dxf.Circle$anon$lazy$macro$79$1", {
  Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1.prototype.$classData = $d_Lreactbuild_format_dxf_Circle$anon$lazy$macro$79$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Classes$() {
  this.Lreactbuild_format_dxf_Classes$__f_encodeClassesSection = null;
  this.Lreactbuild_format_dxf_Classes$__f_decodeClassesSection = null;
  $n_Lreactbuild_format_dxf_Classes$ = this;
  var inst$macro$4 = new $c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$4));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Classes$__f_encodeClassesSection = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$8 = new $c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1().inst$macro$5__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$8));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Classes$__f_decodeClassesSection = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Classes$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Classes$.prototype.constructor = $c_Lreactbuild_format_dxf_Classes$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Classes$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Classes$.prototype = $c_Lreactbuild_format_dxf_Classes$.prototype;
var $d_Lreactbuild_format_dxf_Classes$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Classes$: 0
}, false, "reactbuild.format.dxf.Classes$", {
  Lreactbuild_format_dxf_Classes$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Classes$.prototype.$classData = $d_Lreactbuild_format_dxf_Classes$;
var $n_Lreactbuild_format_dxf_Classes$;
function $m_Lreactbuild_format_dxf_Classes$() {
  if ((!$n_Lreactbuild_format_dxf_Classes$)) {
    $n_Lreactbuild_format_dxf_Classes$ = new $c_Lreactbuild_format_dxf_Classes$()
  };
  return $n_Lreactbuild_format_dxf_Classes$
}
function $p_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$8 = $m_Lreactbuild_format_dxf_Encoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Classes(x0$3$2);
      if ((x0$3 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_HNil(x0$4$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$4)) {
        return new $c_Lreactbuild_format_dxf_Classes()
      } else {
        throw new $c_s_MatchError(x0$4)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$8, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__inst$macro$2$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_inst$macro$2 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_inst$macro$2
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1() {
  this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_inst$macro$2 = null;
  this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1.prototype.constructor = $c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1.prototype = $c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1.prototype;
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1.prototype.inst$macro$2__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__inst$macro$2$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1__f_inst$macro$2)
});
var $d_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1: 0
}, false, "reactbuild.format.dxf.Classes$anon$lazy$macro$3$1", {
  Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1.prototype.$classData = $d_Lreactbuild_format_dxf_Classes$anon$lazy$macro$3$1;
function $p_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__inst$macro$5$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$8 = $m_Lreactbuild_format_dxf_Decoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_format_dxf_Classes(x0$11$2);
      if ((x0$11 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_HNil(x0$12$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$12)) {
        return new $c_Lreactbuild_format_dxf_Classes()
      } else {
        throw new $c_s_MatchError(x0$12)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_inst$macro$5 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$8);
    $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_inst$macro$5
}
function $p_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_inst$macro$6 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_inst$macro$6
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1() {
  this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_inst$macro$5 = null;
  this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_inst$macro$6 = null;
  this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1.prototype.constructor = $c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1.prototype = $c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1.prototype;
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1.prototype.inst$macro$5__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__inst$macro$5$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_inst$macro$5)
});
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1.prototype.inst$macro$6__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1__f_inst$macro$6)
});
var $d_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1: 0
}, false, "reactbuild.format.dxf.Classes$anon$lazy$macro$7$1", {
  Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1.prototype.$classData = $d_Lreactbuild_format_dxf_Classes$anon$lazy$macro$7$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_ColorIndex$() {
  this.Lreactbuild_format_dxf_ColorIndex$__f_serializeColorIndex = null;
  this.Lreactbuild_format_dxf_ColorIndex$__f_parseColorIndex = null;
  $n_Lreactbuild_format_dxf_ColorIndex$ = this;
  $m_Lreactbuild_format_dxf_Serializer$();
  var f = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_format_dxf_ColorIndex(x$3$2);
    return $n(x$3).Lreactbuild_format_dxf_ColorIndex__f_index
  }));
  var serializeB = $m_Lreactbuild_format_dxf_Serializer$().serializeInt__Lreactbuild_format_dxf_Serializer();
  this.Lreactbuild_format_dxf_ColorIndex$__f_serializeColorIndex = new $c_Lreactbuild_format_dxf_Serializer$$anon$2(serializeB, f);
  var parser = $m_Lreactbuild_format_dxf_Parser$().parseInt__Lreactbuild_format_dxf_Parser();
  var this$4 = $n(parser);
  var f$1 = new $c_sjsr_AnonFunction1(((ci$2) => {
    var ci = $uI(ci$2);
    return new $c_Lreactbuild_format_dxf_ColorIndex(ci)
  }));
  this.Lreactbuild_format_dxf_ColorIndex$__f_parseColorIndex = new $c_Lreactbuild_format_dxf_Parser$$anon$1(this$4, f$1)
}
$c_Lreactbuild_format_dxf_ColorIndex$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_ColorIndex$.prototype.constructor = $c_Lreactbuild_format_dxf_ColorIndex$;
/** @constructor */
function $h_Lreactbuild_format_dxf_ColorIndex$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_ColorIndex$.prototype = $c_Lreactbuild_format_dxf_ColorIndex$.prototype;
var $d_Lreactbuild_format_dxf_ColorIndex$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_ColorIndex$: 0
}, false, "reactbuild.format.dxf.ColorIndex$", {
  Lreactbuild_format_dxf_ColorIndex$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_ColorIndex$.prototype.$classData = $d_Lreactbuild_format_dxf_ColorIndex$;
var $n_Lreactbuild_format_dxf_ColorIndex$;
function $m_Lreactbuild_format_dxf_ColorIndex$() {
  if ((!$n_Lreactbuild_format_dxf_ColorIndex$)) {
    $n_Lreactbuild_format_dxf_ColorIndex$ = new $c_Lreactbuild_format_dxf_ColorIndex$()
  };
  return $n_Lreactbuild_format_dxf_ColorIndex$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Decoder$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Decoder$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Decoder$.prototype.constructor = $c_Lreactbuild_format_dxf_Decoder$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Decoder$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Decoder$.prototype = $c_Lreactbuild_format_dxf_Decoder$.prototype;
var $d_Lreactbuild_format_dxf_Decoder$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Decoder$: 0
}, false, "reactbuild.format.dxf.Decoder$", {
  Lreactbuild_format_dxf_Decoder$: 1,
  O: 1,
  Lreactbuild_format_dxf_LowPriorityImplicitsDecoder: 1
});
$c_Lreactbuild_format_dxf_Decoder$.prototype.$classData = $d_Lreactbuild_format_dxf_Decoder$;
var $n_Lreactbuild_format_dxf_Decoder$;
function $m_Lreactbuild_format_dxf_Decoder$() {
  if ((!$n_Lreactbuild_format_dxf_Decoder$)) {
    $n_Lreactbuild_format_dxf_Decoder$ = new $c_Lreactbuild_format_dxf_Decoder$()
  };
  return $n_Lreactbuild_format_dxf_Decoder$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Decoder$$anon$1(outer, f$1) {
  this.Lreactbuild_format_dxf_Decoder$$anon$1__f_$outer = null;
  this.Lreactbuild_format_dxf_Decoder$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_format_dxf_Decoder$$anon$1__f_$outer = outer
  };
  this.Lreactbuild_format_dxf_Decoder$$anon$1__f_f$1 = f$1
}
$c_Lreactbuild_format_dxf_Decoder$$anon$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Decoder$$anon$1.prototype.constructor = $c_Lreactbuild_format_dxf_Decoder$$anon$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Decoder$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Decoder$$anon$1.prototype = $c_Lreactbuild_format_dxf_Decoder$$anon$1.prototype;
$c_Lreactbuild_format_dxf_Decoder$$anon$1.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(c) {
  var x1 = $n(this.Lreactbuild_format_dxf_Decoder$$anon$1__f_$outer).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var a = $as_Lreactbuild_format_dxf_CursorResult($n(x2).s_util_Right__f_value);
    return new $c_s_util_Right($n(a).map__F1__Lreactbuild_format_dxf_CursorResult(this.Lreactbuild_format_dxf_Decoder$$anon$1__f_f$1))
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lreactbuild_format_dxf_Decoder$$anon$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Decoder$$anon$1: 0
}, false, "reactbuild.format.dxf.Decoder$$anon$1", {
  Lreactbuild_format_dxf_Decoder$$anon$1: 1,
  O: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_Decoder$$anon$1.prototype.$classData = $d_Lreactbuild_format_dxf_Decoder$$anon$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Decoder$$anon$18(decodeA$3) {
  this.Lreactbuild_format_dxf_Decoder$$anon$18__f_decodeA$3 = null;
  this.Lreactbuild_format_dxf_Decoder$$anon$18__f_decodeA$3 = decodeA$3
}
$c_Lreactbuild_format_dxf_Decoder$$anon$18.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Decoder$$anon$18.prototype.constructor = $c_Lreactbuild_format_dxf_Decoder$$anon$18;
/** @constructor */
function $h_Lreactbuild_format_dxf_Decoder$$anon$18() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Decoder$$anon$18.prototype = $c_Lreactbuild_format_dxf_Decoder$$anon$18.prototype;
$c_Lreactbuild_format_dxf_Decoder$$anon$18.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(c) {
  var x1 = $n(this.Lreactbuild_format_dxf_Decoder$$anon$18__f_decodeA$3).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Left)) {
    var this$1 = $n(c);
    return new $c_s_util_Right(new $c_Lreactbuild_format_dxf_CursorResult($m_s_None$(), this$1))
  } else if ((x1 instanceof $c_s_util_Right)) {
    var x3 = $as_s_util_Right(x1);
    var r = $as_Lreactbuild_format_dxf_CursorResult($n(x3).s_util_Right__f_value);
    var this$2 = $n(r);
    var arg1 = this$2.Lreactbuild_format_dxf_CursorResult__f_value;
    return new $c_s_util_Right(new $c_Lreactbuild_format_dxf_CursorResult(new $c_s_Some(arg1), this$2.Lreactbuild_format_dxf_CursorResult__f_c))
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lreactbuild_format_dxf_Decoder$$anon$18 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Decoder$$anon$18: 0
}, false, "reactbuild.format.dxf.Decoder$$anon$18", {
  Lreactbuild_format_dxf_Decoder$$anon$18: 1,
  O: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_Decoder$$anon$18.prototype.$classData = $d_Lreactbuild_format_dxf_Decoder$$anon$18;
/** @constructor */
function $c_Lreactbuild_format_dxf_Decoder$$anon$2(outer, prefix$1) {
  this.Lreactbuild_format_dxf_Decoder$$anon$2__f_$outer = null;
  this.Lreactbuild_format_dxf_Decoder$$anon$2__f_prefix$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_format_dxf_Decoder$$anon$2__f_$outer = outer
  };
  this.Lreactbuild_format_dxf_Decoder$$anon$2__f_prefix$1 = prefix$1
}
$c_Lreactbuild_format_dxf_Decoder$$anon$2.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Decoder$$anon$2.prototype.constructor = $c_Lreactbuild_format_dxf_Decoder$$anon$2;
/** @constructor */
function $h_Lreactbuild_format_dxf_Decoder$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Decoder$$anon$2.prototype = $c_Lreactbuild_format_dxf_Decoder$$anon$2.prototype;
$c_Lreactbuild_format_dxf_Decoder$$anon$2.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(c) {
  var x1 = $n(c).after__sci_Seq__s_Option(this.Lreactbuild_format_dxf_Decoder$$anon$2__f_prefix$1);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var c$2 = $as_Lreactbuild_format_dxf_RecordCursor($n(x2).s_Some__f_value);
    return $n(this.Lreactbuild_format_dxf_Decoder$$anon$2__f_$outer).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either(c$2)
  } else {
    return new $c_s_util_Left($m_s_Predef$().$qmark$qmark$qmark__E())
  }
});
var $d_Lreactbuild_format_dxf_Decoder$$anon$2 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Decoder$$anon$2: 0
}, false, "reactbuild.format.dxf.Decoder$$anon$2", {
  Lreactbuild_format_dxf_Decoder$$anon$2: 1,
  O: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_Decoder$$anon$2.prototype.$classData = $d_Lreactbuild_format_dxf_Decoder$$anon$2;
/** @constructor */
function $c_Lreactbuild_format_dxf_Decoder$$anon$3(outer, suffix$1) {
  this.Lreactbuild_format_dxf_Decoder$$anon$3__f_$outer = null;
  this.Lreactbuild_format_dxf_Decoder$$anon$3__f_suffix$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_format_dxf_Decoder$$anon$3__f_$outer = outer
  };
  this.Lreactbuild_format_dxf_Decoder$$anon$3__f_suffix$1 = suffix$1
}
$c_Lreactbuild_format_dxf_Decoder$$anon$3.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Decoder$$anon$3.prototype.constructor = $c_Lreactbuild_format_dxf_Decoder$$anon$3;
/** @constructor */
function $h_Lreactbuild_format_dxf_Decoder$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Decoder$$anon$3.prototype = $c_Lreactbuild_format_dxf_Decoder$$anon$3.prototype;
$c_Lreactbuild_format_dxf_Decoder$$anon$3.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(c) {
  var x1 = $n(this.Lreactbuild_format_dxf_Decoder$$anon$3__f_$outer).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var v = $as_Lreactbuild_format_dxf_CursorResult($n(x2).s_util_Right__f_value);
    var x1$2 = $n($n(v).Lreactbuild_format_dxf_CursorResult__f_c).after__sci_Seq__s_Option(this.Lreactbuild_format_dxf_Decoder$$anon$3__f_suffix$1);
    if ((x1$2 instanceof $c_s_Some)) {
      var x2$2 = $as_s_Some(x1$2);
      var c$2 = $as_Lreactbuild_format_dxf_RecordCursor($n(x2$2).s_Some__f_value);
      var this$1 = $n(v);
      var x$2 = this$1.Lreactbuild_format_dxf_CursorResult__f_value;
      $n(v);
      return new $c_s_util_Right(new $c_Lreactbuild_format_dxf_CursorResult(x$2, c$2))
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return new $c_s_util_Left($m_s_Predef$().$qmark$qmark$qmark__E())
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lreactbuild_format_dxf_Decoder$$anon$3 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Decoder$$anon$3: 0
}, false, "reactbuild.format.dxf.Decoder$$anon$3", {
  Lreactbuild_format_dxf_Decoder$$anon$3: 1,
  O: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_Decoder$$anon$3.prototype.$classData = $d_Lreactbuild_format_dxf_Decoder$$anon$3;
/** @constructor */
function $c_Lreactbuild_format_dxf_Decoder$$anon$4(outer, f$2) {
  this.Lreactbuild_format_dxf_Decoder$$anon$4__f_$outer = null;
  this.Lreactbuild_format_dxf_Decoder$$anon$4__f_f$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_format_dxf_Decoder$$anon$4__f_$outer = outer
  };
  this.Lreactbuild_format_dxf_Decoder$$anon$4__f_f$2 = f$2
}
$c_Lreactbuild_format_dxf_Decoder$$anon$4.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Decoder$$anon$4.prototype.constructor = $c_Lreactbuild_format_dxf_Decoder$$anon$4;
/** @constructor */
function $h_Lreactbuild_format_dxf_Decoder$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Decoder$$anon$4.prototype = $c_Lreactbuild_format_dxf_Decoder$$anon$4.prototype;
$c_Lreactbuild_format_dxf_Decoder$$anon$4.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(c) {
  var x1 = $uZ($n(this.Lreactbuild_format_dxf_Decoder$$anon$4__f_f$2).apply__O__O($n(c).value__Lreactbuild_format_dxf_Record()));
  if ((x1 === true)) {
    return $n(this.Lreactbuild_format_dxf_Decoder$$anon$4__f_$outer).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either($n(c).down__Lreactbuild_format_dxf_RecordCursor())
  } else if ((x1 === false)) {
    return new $c_s_util_Left($m_s_Predef$().$qmark$qmark$qmark__E())
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lreactbuild_format_dxf_Decoder$$anon$4 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Decoder$$anon$4: 0
}, false, "reactbuild.format.dxf.Decoder$$anon$4", {
  Lreactbuild_format_dxf_Decoder$$anon$4: 1,
  O: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_Decoder$$anon$4.prototype.$classData = $d_Lreactbuild_format_dxf_Decoder$$anon$4;
/** @constructor */
function $c_Lreactbuild_format_dxf_Encoder$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Encoder$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Encoder$.prototype.constructor = $c_Lreactbuild_format_dxf_Encoder$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Encoder$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Encoder$.prototype = $c_Lreactbuild_format_dxf_Encoder$.prototype;
var $d_Lreactbuild_format_dxf_Encoder$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Encoder$: 0
}, false, "reactbuild.format.dxf.Encoder$", {
  Lreactbuild_format_dxf_Encoder$: 1,
  O: 1,
  Lreactbuild_format_dxf_LowPriorityImplicitsEncoder: 1
});
$c_Lreactbuild_format_dxf_Encoder$.prototype.$classData = $d_Lreactbuild_format_dxf_Encoder$;
var $n_Lreactbuild_format_dxf_Encoder$;
function $m_Lreactbuild_format_dxf_Encoder$() {
  if ((!$n_Lreactbuild_format_dxf_Encoder$)) {
    $n_Lreactbuild_format_dxf_Encoder$ = new $c_Lreactbuild_format_dxf_Encoder$()
  };
  return $n_Lreactbuild_format_dxf_Encoder$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Encoder$$anon$1(outer, ifNotEmpty$1, prefix$1, suffix$1) {
  if ((outer === null)) {
    $n(null)
  }
}
$c_Lreactbuild_format_dxf_Encoder$$anon$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Encoder$$anon$1.prototype.constructor = $c_Lreactbuild_format_dxf_Encoder$$anon$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Encoder$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Encoder$$anon$1.prototype = $c_Lreactbuild_format_dxf_Encoder$$anon$1.prototype;
var $d_Lreactbuild_format_dxf_Encoder$$anon$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Encoder$$anon$1: 0
}, false, "reactbuild.format.dxf.Encoder$$anon$1", {
  Lreactbuild_format_dxf_Encoder$$anon$1: 1,
  O: 1,
  Lreactbuild_format_dxf_Encoder: 1
});
$c_Lreactbuild_format_dxf_Encoder$$anon$1.prototype.$classData = $d_Lreactbuild_format_dxf_Encoder$$anon$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Encoder$$anon$14(encoderA$1) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Encoder$$anon$14.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Encoder$$anon$14.prototype.constructor = $c_Lreactbuild_format_dxf_Encoder$$anon$14;
/** @constructor */
function $h_Lreactbuild_format_dxf_Encoder$$anon$14() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Encoder$$anon$14.prototype = $c_Lreactbuild_format_dxf_Encoder$$anon$14.prototype;
var $d_Lreactbuild_format_dxf_Encoder$$anon$14 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Encoder$$anon$14: 0
}, false, "reactbuild.format.dxf.Encoder$$anon$14", {
  Lreactbuild_format_dxf_Encoder$$anon$14: 1,
  O: 1,
  Lreactbuild_format_dxf_Encoder: 1
});
$c_Lreactbuild_format_dxf_Encoder$$anon$14.prototype.$classData = $d_Lreactbuild_format_dxf_Encoder$$anon$14;
/** @constructor */
function $c_Lreactbuild_format_dxf_Encoder$$anon$15(encoderA$2) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Encoder$$anon$15.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Encoder$$anon$15.prototype.constructor = $c_Lreactbuild_format_dxf_Encoder$$anon$15;
/** @constructor */
function $h_Lreactbuild_format_dxf_Encoder$$anon$15() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Encoder$$anon$15.prototype = $c_Lreactbuild_format_dxf_Encoder$$anon$15.prototype;
var $d_Lreactbuild_format_dxf_Encoder$$anon$15 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Encoder$$anon$15: 0
}, false, "reactbuild.format.dxf.Encoder$$anon$15", {
  Lreactbuild_format_dxf_Encoder$$anon$15: 1,
  O: 1,
  Lreactbuild_format_dxf_Encoder: 1
});
$c_Lreactbuild_format_dxf_Encoder$$anon$15.prototype.$classData = $d_Lreactbuild_format_dxf_Encoder$$anon$15;
/** @constructor */
function $c_Lreactbuild_format_dxf_Encoder$$anon$2(outer, f$1) {
  if ((outer === null)) {
    $n(null)
  }
}
$c_Lreactbuild_format_dxf_Encoder$$anon$2.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Encoder$$anon$2.prototype.constructor = $c_Lreactbuild_format_dxf_Encoder$$anon$2;
/** @constructor */
function $h_Lreactbuild_format_dxf_Encoder$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Encoder$$anon$2.prototype = $c_Lreactbuild_format_dxf_Encoder$$anon$2.prototype;
var $d_Lreactbuild_format_dxf_Encoder$$anon$2 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Encoder$$anon$2: 0
}, false, "reactbuild.format.dxf.Encoder$$anon$2", {
  Lreactbuild_format_dxf_Encoder$$anon$2: 1,
  O: 1,
  Lreactbuild_format_dxf_Encoder: 1
});
$c_Lreactbuild_format_dxf_Encoder$$anon$2.prototype.$classData = $d_Lreactbuild_format_dxf_Encoder$$anon$2;
/** @constructor */
function $c_Lreactbuild_format_dxf_Encoder$$anon$4(outer, f$3) {
  if ((outer === null)) {
    $n(null)
  }
}
$c_Lreactbuild_format_dxf_Encoder$$anon$4.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Encoder$$anon$4.prototype.constructor = $c_Lreactbuild_format_dxf_Encoder$$anon$4;
/** @constructor */
function $h_Lreactbuild_format_dxf_Encoder$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Encoder$$anon$4.prototype = $c_Lreactbuild_format_dxf_Encoder$$anon$4.prototype;
var $d_Lreactbuild_format_dxf_Encoder$$anon$4 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Encoder$$anon$4: 0
}, false, "reactbuild.format.dxf.Encoder$$anon$4", {
  Lreactbuild_format_dxf_Encoder$$anon$4: 1,
  O: 1,
  Lreactbuild_format_dxf_Encoder: 1
});
$c_Lreactbuild_format_dxf_Encoder$$anon$4.prototype.$classData = $d_Lreactbuild_format_dxf_Encoder$$anon$4;
/** @constructor */
function $c_Lreactbuild_format_dxf_Entities$() {
  this.Lreactbuild_format_dxf_Entities$__f_encodeEntitiesSection = null;
  this.Lreactbuild_format_dxf_Entities$__f_decodeEntitiesSection = null;
  $n_Lreactbuild_format_dxf_Entities$ = this;
  var inst$macro$423 = new $c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$423));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Entities$__f_encodeEntitiesSection = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$1043 = new $c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1().inst$macro$424__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$1043));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Entities$__f_decodeEntitiesSection = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Entities$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Entities$.prototype.constructor = $c_Lreactbuild_format_dxf_Entities$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Entities$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Entities$.prototype = $c_Lreactbuild_format_dxf_Entities$.prototype;
var $d_Lreactbuild_format_dxf_Entities$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Entities$: 0
}, false, "reactbuild.format.dxf.Entities$", {
  Lreactbuild_format_dxf_Entities$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Entities$.prototype.$classData = $d_Lreactbuild_format_dxf_Entities$;
var $n_Lreactbuild_format_dxf_Entities$;
function $m_Lreactbuild_format_dxf_Entities$() {
  if ((!$n_Lreactbuild_format_dxf_Entities$)) {
    $n_Lreactbuild_format_dxf_Entities$ = new $c_Lreactbuild_format_dxf_Entities$()
  };
  return $n_Lreactbuild_format_dxf_Entities$
}
function $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__inst$macro$424$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$12 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "drawingEntities")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$103$2) => {
      var x0$103 = $as_Lreactbuild_format_dxf_Entities(x0$103$2);
      if ((x0$103 !== null)) {
        var drawingEntities$macro$428 = $n(x0$103).Lreactbuild_format_dxf_Entities__f_drawingEntities;
        return new $c_Lshapeless_$colon$colon(drawingEntities$macro$428, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$103)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$104$2) => {
      var x0$104 = $as_Lshapeless_$colon$colon(x0$104$2);
      if ((x0$104 !== null)) {
        var drawingEntities$macro$427 = $as_sci_List($n(x0$104).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$104).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_Entities(drawingEntities$macro$427)
        }
      };
      throw new $c_s_MatchError(x0$104)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "drawingEntities"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$429__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$424 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$12);
    var b$1 = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$424
}
function $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__inst$macro$429$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$430__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1037__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$429 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$429
}
function $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__inst$macro$430$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var decodeA = $m_Lreactbuild_format_dxf_Entity$().Lreactbuild_format_dxf_Entity$__f_decodeEntity;
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$430 = new $c_Lreactbuild_format_dxf_Decoder$$anon$17(decodeA);
    var b$1 = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0;
    var lo$1 = (4 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$430
}
function $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__inst$macro$1037$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$1;
  var lo = (8192 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$1037 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    var b$1 = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$1;
    var lo$1 = (8192 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$1037
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1() {
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$424 = null;
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$429 = null;
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$430 = null;
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$1037 = null;
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0 = $L0;
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$1 = $L0
}
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1.prototype.constructor = $c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1.prototype = $c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1.prototype;
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1.prototype.inst$macro$424__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__inst$macro$424$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$424
  }
});
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1.prototype.inst$macro$429__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__inst$macro$429$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$429
  }
});
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1.prototype.inst$macro$430__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__inst$macro$430$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$430
  }
});
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1.prototype.inst$macro$1037__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_bitmap$1;
  var lo = (8192 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__inst$macro$1037$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1__f_inst$macro$1037
  }
});
var $d_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1: 0
}, false, "reactbuild.format.dxf.Entities$anon$lazy$macro$1042$1", {
  Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1.prototype.$classData = $d_Lreactbuild_format_dxf_Entities$anon$lazy$macro$1042$1;
function $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$12 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "drawingEntities")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Entities(x0$3$2);
      if ((x0$3 !== null)) {
        var drawingEntities$macro$5 = $n(x0$3).Lreactbuild_format_dxf_Entities__f_drawingEntities;
        return new $c_Lshapeless_$colon$colon(drawingEntities$macro$5, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var drawingEntities$macro$4 = $as_sci_List($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_Entities(drawingEntities$macro$4)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "drawingEntities"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$12, encoder, gen$1, annots);
    var b$1 = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encoderA = $m_Lreactbuild_format_dxf_Entity$().Lreactbuild_format_dxf_Entity$__f_encodeEntity;
    var encodeV = new $c_Lreactbuild_format_dxf_Encoder$$anon$14(encoderA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$50__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$6 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$6
}
function $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__inst$macro$50$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0;
  var lo = (512 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$50 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    var b$1 = $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0;
    var lo$1 = (512 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$50
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1() {
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$6 = null;
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$50 = null;
  this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0 = $L0
}
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1.prototype.constructor = $c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1.prototype = $c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1.prototype;
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$1
  }
});
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1.prototype.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$6
  }
});
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1.prototype.inst$macro$50__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_bitmap$0;
  var lo = (512 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__inst$macro$50$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1__f_inst$macro$50
  }
});
var $d_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1: 0
}, false, "reactbuild.format.dxf.Entities$anon$lazy$macro$422$1", {
  Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1.prototype.$classData = $d_Lreactbuild_format_dxf_Entities$anon$lazy$macro$422$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Entity$$anon$1() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Entity$$anon$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Entity$$anon$1.prototype.constructor = $c_Lreactbuild_format_dxf_Entity$$anon$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Entity$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Entity$$anon$1.prototype = $c_Lreactbuild_format_dxf_Entity$$anon$1.prototype;
var $d_Lreactbuild_format_dxf_Entity$$anon$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Entity$$anon$1: 0
}, false, "reactbuild.format.dxf.Entity$$anon$1", {
  Lreactbuild_format_dxf_Entity$$anon$1: 1,
  O: 1,
  Lreactbuild_format_dxf_ConfigAdt: 1
});
$c_Lreactbuild_format_dxf_Entity$$anon$1.prototype.$classData = $d_Lreactbuild_format_dxf_Entity$$anon$1;
function $p_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__inst$macro$415$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$23 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Circle"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Insert"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Line"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "LwPolyline")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_format_dxf_Entity(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_format_dxf_Circle)) {
        var $$x4 = 0
      } else if ((p instanceof $c_Lreactbuild_format_dxf_Insert)) {
        var $$x4 = 1
      } else if ((p instanceof $c_Lreactbuild_format_dxf_Line)) {
        var $$x4 = 2
      } else {
        if ((!(p instanceof $c_Lreactbuild_format_dxf_LwPolyline))) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7 = $as_Lshapeless_$colon$plus$colon(x$7$2);
      return $as_Lreactbuild_format_dxf_Entity($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$7))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "LwPolyline"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "Line"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "Insert"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "Circle"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$416__Lreactbuild_format_dxf_CoproductDecoder()));
    var decodeA = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_inst$macro$415 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15(this$23, decodeA, gen$1);
    var b$1 = $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_inst$macro$415
}
function $p_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__inst$macro$416$lzycompute__Lreactbuild_format_dxf_CoproductDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$13 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Circle"));
    var witK$3 = new $c_Lshapeless_Witness$$anon$1(value0);
    var decodeV$3 = $m_Lreactbuild_format_dxf_Circle$().Lreactbuild_format_dxf_Circle$__f_decodeCircle;
    var this$12 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    $m_Lshapeless_Witness$();
    var this$3 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Insert"));
    var witK$2 = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var decodeV$2 = $m_Lreactbuild_format_dxf_Insert$().Lreactbuild_format_dxf_Insert$__f_decodeInsert;
    var this$11 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "Line"));
    var witK$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var decodeV$1 = $m_Lreactbuild_format_dxf_Line$().Lreactbuild_format_dxf_Line$__f_decodeLine;
    var this$10 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "LwPolyline"));
    var witK = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var decodeV = $m_Lreactbuild_format_dxf_LwPolyline$().Lreactbuild_format_dxf_LwPolyline$__f_decodeLwPolyline;
    var this$9 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    var decodeR = new $c_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13(this$9);
    var decodeR$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12(this$10, witK, decodeV, decodeR);
    var decodeR$2 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12(this$11, witK$1, decodeV$1, decodeR$1);
    var decodeR$3 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12(this$12, witK$2, decodeV$2, decodeR$2);
    $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_inst$macro$416 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12(this$13, witK$3, decodeV$3, decodeR$3);
    var b$1 = $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_inst$macro$416
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1() {
  this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_inst$macro$415 = null;
  this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_inst$macro$416 = null;
  this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_bitmap$0 = $L0
}
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1.prototype.constructor = $c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1.prototype = $c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1.prototype;
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1.prototype.inst$macro$415__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__inst$macro$415$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_inst$macro$415
  }
});
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1.prototype.inst$macro$416__Lreactbuild_format_dxf_CoproductDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__inst$macro$416$lzycompute__Lreactbuild_format_dxf_CoproductDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1__f_inst$macro$416
  }
});
var $d_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1: 0
}, false, "reactbuild.format.dxf.Entity$anon$lazy$macro$1022$1", {
  Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1.prototype.$classData = $d_Lreactbuild_format_dxf_Entity$anon$lazy$macro$1022$1;
function $p_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$23 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Circle"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Insert"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Line"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "LwPolyline")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_format_dxf_Entity(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_format_dxf_Circle)) {
        var $$x4 = 0
      } else if ((p instanceof $c_Lreactbuild_format_dxf_Insert)) {
        var $$x4 = 1
      } else if ((p instanceof $c_Lreactbuild_format_dxf_Line)) {
        var $$x4 = 2
      } else {
        if ((!(p instanceof $c_Lreactbuild_format_dxf_LwPolyline))) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lshapeless_$colon$plus$colon(x$3$2);
      return $as_Lreactbuild_format_dxf_Entity($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$3))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "LwPolyline"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "Line"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "Insert"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "Circle"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lreactbuild_format_dxf_CoproductEncoder()));
    var encodeA = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12(this$23, encodeA, gen$1);
    var b$1 = $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__inst$macro$2$lzycompute__Lreactbuild_format_dxf_CoproductEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$13 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Circle"));
    var witK$3 = new $c_Lshapeless_Witness$$anon$1(value0);
    var encodeV$3 = $m_Lreactbuild_format_dxf_Circle$().Lreactbuild_format_dxf_Circle$__f_encodeCircle;
    var this$12 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    $m_Lshapeless_Witness$();
    var this$3 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Insert"));
    var witK$2 = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var encodeV$2 = $m_Lreactbuild_format_dxf_Insert$().Lreactbuild_format_dxf_Insert$__f_encodeInsert;
    var this$11 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "Line"));
    var witK$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var encodeV$1 = $m_Lreactbuild_format_dxf_Line$().Lreactbuild_format_dxf_Line$__f_encodeLine;
    var this$10 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "LwPolyline"));
    var witK = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var encodeV = $m_Lreactbuild_format_dxf_LwPolyline$().Lreactbuild_format_dxf_LwPolyline$__f_encodeLwPolyline;
    var this$9 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    var encodeR = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10(this$9);
    var config = $m_Lreactbuild_format_dxf_Entity$().Lreactbuild_format_dxf_Entity$__f_config;
    var encodeR$1 = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11(this$10, witK, encodeV, config, encodeR);
    var config$1 = $m_Lreactbuild_format_dxf_Entity$().Lreactbuild_format_dxf_Entity$__f_config;
    var encodeR$2 = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11(this$11, witK$1, encodeV$1, config$1, encodeR$1);
    var config$2 = $m_Lreactbuild_format_dxf_Entity$().Lreactbuild_format_dxf_Entity$__f_config;
    var encodeR$3 = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11(this$12, witK$2, encodeV$2, config$2, encodeR$2);
    var config$3 = $m_Lreactbuild_format_dxf_Entity$().Lreactbuild_format_dxf_Entity$__f_config;
    $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_inst$macro$2 = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11(this$13, witK$3, encodeV$3, config$3, encodeR$3);
    var b$1 = $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_inst$macro$2
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1() {
  this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_inst$macro$2 = null;
  this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_bitmap$0 = $L0
}
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1.prototype.constructor = $c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1.prototype = $c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1.prototype;
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_inst$macro$1
  }
});
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1.prototype.inst$macro$2__Lreactbuild_format_dxf_CoproductEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__inst$macro$2$lzycompute__Lreactbuild_format_dxf_CoproductEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1__f_inst$macro$2
  }
});
var $d_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1: 0
}, false, "reactbuild.format.dxf.Entity$anon$lazy$macro$413$1", {
  Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1.prototype.$classData = $d_Lreactbuild_format_dxf_Entity$anon$lazy$macro$413$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_File$() {
  this.Lreactbuild_format_dxf_File$__f_decodeFile = null;
  $n_Lreactbuild_format_dxf_File$ = this;
  var this$2 = $n($m_Lreactbuild_format_dxf_SectionList$().Lreactbuild_format_dxf_SectionList$__f_encodeSectionList);
  var f = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Lreactbuild_format_dxf_File(x$7$2);
    return $n(x$7).Lreactbuild_format_dxf_File__f_sectionList
  }));
  var qual$1 = new $c_Lreactbuild_format_dxf_Encoder$$anon$2(this$2, f);
  var x$1 = new $c_sjsr_AnonFunction1(((x$8$2) => {
    $as_Lreactbuild_format_dxf_File(x$8$2);
    return $m_s_package$().s_package$__f_Nil
  }));
  $n($m_s_package$().s_package$__f_List);
  var array = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "EOF")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var x$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  new $c_Lreactbuild_format_dxf_Encoder$$anon$1(qual$1, false, x$1, x$2);
  new $c_Lreactbuild_format_dxf_File$$anon$1();
  var this$7 = $n($m_Lreactbuild_format_dxf_SectionList$().Lreactbuild_format_dxf_SectionList$__f_decodeSectionList);
  var f$1 = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Lreactbuild_format_dxf_SectionList(x$9$2);
    return new $c_Lreactbuild_format_dxf_File(x$9)
  }));
  var this$11 = new $c_Lreactbuild_format_dxf_Decoder$$anon$1(this$7, f$1);
  var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "EOF")];
  var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lreactbuild_format_dxf_File$__f_decodeFile = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$11, suffix)
}
$c_Lreactbuild_format_dxf_File$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_File$.prototype.constructor = $c_Lreactbuild_format_dxf_File$;
/** @constructor */
function $h_Lreactbuild_format_dxf_File$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_File$.prototype = $c_Lreactbuild_format_dxf_File$.prototype;
var $d_Lreactbuild_format_dxf_File$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_File$: 0
}, false, "reactbuild.format.dxf.File$", {
  Lreactbuild_format_dxf_File$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_File$.prototype.$classData = $d_Lreactbuild_format_dxf_File$;
var $n_Lreactbuild_format_dxf_File$;
function $m_Lreactbuild_format_dxf_File$() {
  if ((!$n_Lreactbuild_format_dxf_File$)) {
    $n_Lreactbuild_format_dxf_File$ = new $c_Lreactbuild_format_dxf_File$()
  };
  return $n_Lreactbuild_format_dxf_File$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_File$$anon$1() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_File$$anon$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_File$$anon$1.prototype.constructor = $c_Lreactbuild_format_dxf_File$$anon$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_File$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_File$$anon$1.prototype = $c_Lreactbuild_format_dxf_File$$anon$1.prototype;
var $d_Lreactbuild_format_dxf_File$$anon$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_File$$anon$1: 0
}, false, "reactbuild.format.dxf.File$$anon$1", {
  Lreactbuild_format_dxf_File$$anon$1: 1,
  O: 1,
  Lreactbuild_format_dxf_Serializer: 1
});
$c_Lreactbuild_format_dxf_File$$anon$1.prototype.$classData = $d_Lreactbuild_format_dxf_File$$anon$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Header$() {
  this.Lreactbuild_format_dxf_Header$__f_encodeHeaderSection = null;
  this.Lreactbuild_format_dxf_Header$__f_decodeHeaderSection = null;
  $n_Lreactbuild_format_dxf_Header$ = this;
  var inst$macro$75 = new $c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$75));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Header$__f_encodeHeaderSection = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$199 = new $c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1().inst$macro$76__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$199));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Header$__f_decodeHeaderSection = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Header$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Header$.prototype.constructor = $c_Lreactbuild_format_dxf_Header$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Header$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Header$.prototype = $c_Lreactbuild_format_dxf_Header$.prototype;
var $d_Lreactbuild_format_dxf_Header$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Header$: 0
}, false, "reactbuild.format.dxf.Header$", {
  Lreactbuild_format_dxf_Header$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Header$.prototype.$classData = $d_Lreactbuild_format_dxf_Header$;
var $n_Lreactbuild_format_dxf_Header$;
function $m_Lreactbuild_format_dxf_Header$() {
  if ((!$n_Lreactbuild_format_dxf_Header$)) {
    $n_Lreactbuild_format_dxf_Header$ = new $c_Lreactbuild_format_dxf_Header$()
  };
  return $n_Lreactbuild_format_dxf_Header$
}
function $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__inst$macro$76$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0) === 0)) {
    var this$13 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "parameters")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$51$2) => {
      var x0$51 = $as_Lreactbuild_format_dxf_Header(x0$51$2);
      if ((x0$51 !== null)) {
        var parameters$macro$80 = $n(x0$51).Lreactbuild_format_dxf_Header__f_parameters;
        return new $c_Lshapeless_$colon$colon(parameters$macro$80, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$51)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$52$2) => {
      var x0$52 = $as_Lshapeless_$colon$colon(x0$52$2);
      if ((x0$52 !== null)) {
        var parameters$macro$79 = $as_sci_List($n(x0$52).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$52).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          $m_Lreactbuild_format_dxf_Header$();
          return new $c_Lreactbuild_format_dxf_Header(parameters$macro$79)
        }
      };
      throw new $c_s_MatchError(x0$52)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "parameters"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$9 = $m_s_$less$colon$less$();
    var ev = this$9.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$81__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$76 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$13);
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$76
}
function $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__inst$macro$81$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$82__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$193__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$81 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$81
}
function $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__inst$macro$82$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0) === 0)) {
    var decodeA = $m_Lreactbuild_format_dxf_Parameter$().Lreactbuild_format_dxf_Parameter$__f_decodeParameter;
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$82 = new $c_Lreactbuild_format_dxf_Decoder$$anon$17(decodeA);
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$82
}
function $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__inst$macro$193$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((33554432 & $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$193 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0 = (33554432 | $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$193
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1() {
  this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$76 = null;
  this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$81 = null;
  this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$82 = null;
  this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$193 = null;
  this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1.prototype.constructor = $c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1.prototype = $c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1.prototype;
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1.prototype.inst$macro$76__Lreactbuild_format_dxf_Decoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__inst$macro$76$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$76)
});
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1.prototype.inst$macro$81__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__inst$macro$81$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$81)
});
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1.prototype.inst$macro$82__Lreactbuild_format_dxf_Decoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__inst$macro$82$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$82)
});
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1.prototype.inst$macro$193__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((33554432 & this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__inst$macro$193$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1__f_inst$macro$193)
});
var $d_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1: 0
}, false, "reactbuild.format.dxf.Header$anon$lazy$macro$198$1", {
  Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1.prototype.$classData = $d_Lreactbuild_format_dxf_Header$anon$lazy$macro$198$1;
function $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0) === 0)) {
    var this$13 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "parameters")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Header(x0$3$2);
      if ((x0$3 !== null)) {
        var parameters$macro$5 = $n(x0$3).Lreactbuild_format_dxf_Header__f_parameters;
        return new $c_Lshapeless_$colon$colon(parameters$macro$5, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var parameters$macro$4 = $as_sci_List($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          $m_Lreactbuild_format_dxf_Header$();
          return new $c_Lreactbuild_format_dxf_Header(parameters$macro$4)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "parameters"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$9 = $m_s_$less$colon$less$();
    var ev = this$9.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$13, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0) === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encoderA = $m_Lreactbuild_format_dxf_Parameter$().Lreactbuild_format_dxf_Parameter$__f_encodeParameter;
    var encodeV = new $c_Lreactbuild_format_dxf_Encoder$$anon$14(encoderA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$13__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$6 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$6
}
function $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__inst$macro$13$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$13 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$13
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1() {
  this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$6 = null;
  this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$13 = null;
  this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1.prototype.constructor = $c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1.prototype = $c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1.prototype;
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1.prototype.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$6)
});
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1.prototype.inst$macro$13__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__inst$macro$13$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1__f_inst$macro$13)
});
var $d_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1: 0
}, false, "reactbuild.format.dxf.Header$anon$lazy$macro$74$1", {
  Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1.prototype.$classData = $d_Lreactbuild_format_dxf_Header$anon$lazy$macro$74$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(outer, encodeT$3, serializeV$2) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7.prototype = new $h_O();
$c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7.prototype.constructor = $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7;
/** @constructor */
function $h_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7.prototype = $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7.prototype;
var $d_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7 = new $TypeData().initClass({
  Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7: 0
}, false, "reactbuild.format.dxf.HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7", {
  Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7: 1,
  O: 1,
  Lreactbuild_format_dxf_AccumulatingEncoder: 1
});
$c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7.prototype.$classData = $d_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7;
/** @constructor */
function $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(outer, parseV$2) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8.prototype = new $h_O();
$c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8.prototype.constructor = $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8;
/** @constructor */
function $h_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8.prototype = $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8.prototype;
var $d_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8 = new $TypeData().initClass({
  Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8: 0
}, false, "reactbuild.format.dxf.HighPriorityImplicitsFieldDecoderInstances$$anon$8", {
  Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8: 1,
  O: 1,
  Lreactbuild_format_dxf_FieldDecoder: 1
});
$c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8.prototype.$classData = $d_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8;
/** @constructor */
function $c_Lreactbuild_format_dxf_Insert$() {
  this.Lreactbuild_format_dxf_Insert$__f_encodeInsert = null;
  this.Lreactbuild_format_dxf_Insert$__f_decodeInsert = null;
  $n_Lreactbuild_format_dxf_Insert$ = this;
  var inst$macro$145 = new $c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$145));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Insert$__f_encodeInsert = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$292 = new $c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1().inst$macro$146__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$292));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Insert$__f_decodeInsert = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Insert$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Insert$.prototype.constructor = $c_Lreactbuild_format_dxf_Insert$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Insert$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Insert$.prototype = $c_Lreactbuild_format_dxf_Insert$.prototype;
var $d_Lreactbuild_format_dxf_Insert$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Insert$: 0
}, false, "reactbuild.format.dxf.Insert$", {
  Lreactbuild_format_dxf_Insert$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Insert$.prototype.$classData = $d_Lreactbuild_format_dxf_Insert$;
var $n_Lreactbuild_format_dxf_Insert$;
function $m_Lreactbuild_format_dxf_Insert$() {
  if ((!$n_Lreactbuild_format_dxf_Insert$)) {
    $n_Lreactbuild_format_dxf_Insert$ = new $c_Lreactbuild_format_dxf_Insert$()
  };
  return $n_Lreactbuild_format_dxf_Insert$
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$56 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "layer"));
    var this$3 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "color"));
    var this$4 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "insertionPoint"));
    var this$5 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "scaleX"));
    var this$6 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "scaleY"));
    var this$7 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "scaleZ"));
    var this$8 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "rotation"));
    var this$9 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "columns"));
    var this$10 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "rows"));
    var this$11 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "columnSpacing"));
    var this$12 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "rowSpacing")), $m_Lshapeless_HNil$()))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Insert(x0$3$2);
      if ((x0$3 !== null)) {
        var name$macro$38 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_name;
        var layer$macro$39 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_layer;
        var color$macro$40 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_color;
        var insertionPoint$macro$41 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_insertionPoint;
        var scaleX$macro$42 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_scaleX;
        var scaleY$macro$43 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_scaleY;
        var scaleZ$macro$44 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_scaleZ;
        var rotation$macro$45 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_rotation;
        var columns$macro$46 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_columns;
        var rows$macro$47 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_rows;
        var columnSpacing$macro$48 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_columnSpacing;
        var rowSpacing$macro$49 = $n(x0$3).Lreactbuild_format_dxf_Insert__f_rowSpacing;
        return new $c_Lshapeless_$colon$colon(name$macro$38, new $c_Lshapeless_$colon$colon(layer$macro$39, new $c_Lshapeless_$colon$colon(color$macro$40, new $c_Lshapeless_$colon$colon(insertionPoint$macro$41, new $c_Lshapeless_$colon$colon(scaleX$macro$42, new $c_Lshapeless_$colon$colon(scaleY$macro$43, new $c_Lshapeless_$colon$colon(scaleZ$macro$44, new $c_Lshapeless_$colon$colon(rotation$macro$45, new $c_Lshapeless_$colon$colon(columns$macro$46, new $c_Lshapeless_$colon$colon(rows$macro$47, new $c_Lshapeless_$colon$colon(columnSpacing$macro$48, new $c_Lshapeless_$colon$colon(rowSpacing$macro$49, $m_Lshapeless_HNil$()))))))))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var name$macro$26 = $as_Lreactbuild_format_dxf_NameOf($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var layer$macro$27 = $as_Lreactbuild_format_dxf_NameOf($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var color$macro$28 = $as_Lreactbuild_format_dxf_ColorIndex($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var insertionPoint$macro$29 = $as_Lreactbuild_format_dxf_Point3D($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var scaleX$macro$30 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var scaleY$macro$31 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var scaleZ$macro$32 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var rotation$macro$33 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var columns$macro$34 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var rows$macro$35 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                          if ((p11 !== null)) {
                            var columnSpacing$macro$36 = $as_s_Option($n(p11).Lshapeless_$colon$colon__f_head);
                            var p12 = $as_Lshapeless_$colon$colon($n(p11).Lshapeless_$colon$colon__f_tail);
                            if ((p12 !== null)) {
                              var rowSpacing$macro$37 = $as_s_Option($n(p12).Lshapeless_$colon$colon__f_head);
                              var p13 = $as_Lshapeless_HNil($n(p12).Lshapeless_$colon$colon__f_tail);
                              var x = $m_Lshapeless_HNil$();
                              if ((x === p13)) {
                                return new $c_Lreactbuild_format_dxf_Insert(name$macro$26, layer$macro$27, color$macro$28, insertionPoint$macro$29, scaleX$macro$30, scaleY$macro$31, scaleZ$macro$32, rotation$macro$33, columns$macro$34, rows$macro$35, columnSpacing$macro$36, rowSpacing$macro$37)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "rowSpacing"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "columnSpacing"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "rows"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "columns"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$28 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "rotation"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "scaleZ"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "scaleY"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "scaleX"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "insertionPoint"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$10);
    var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$11);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
    var this$52 = $m_s_$less$colon$less$();
    var ev = this$52.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(41)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(42)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(43)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(50)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(71)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(44)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(45)), $m_Lshapeless_HNil$()))))))))))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$50__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$56, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$50$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$53__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$50 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$50
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$53$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$56__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$53 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$53
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$56$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_serializeColorIndex;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$59__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$56 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$56
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$59$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$22 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var this$20 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "z")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$13$2) => {
      var x0$13 = $as_Lreactbuild_format_dxf_Point3D(x0$13$2);
      if ((x0$13 !== null)) {
        var x$macro$69 = $n(x0$13).Lreactbuild_format_dxf_Point3D__f_x;
        var y$macro$70 = $n(x0$13).Lreactbuild_format_dxf_Point3D__f_y;
        var z$macro$71 = $n(x0$13).Lreactbuild_format_dxf_Point3D__f_z;
        return new $c_Lshapeless_$colon$colon(x$macro$69, new $c_Lshapeless_$colon$colon(y$macro$70, new $c_Lshapeless_$colon$colon(z$macro$71, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$13)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$14$2) => {
      var x0$14 = $as_Lshapeless_$colon$colon(x0$14$2);
      if ((x0$14 !== null)) {
        var x$macro$66 = $uD($n(x0$14).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$14).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$67 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var z$macro$68 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_format_dxf_Point3D(x$macro$66, y$macro$67, z$macro$68)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$14)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "z"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(10)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(20)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(30)), $m_Lshapeless_HNil$())))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$72__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var encodeV = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$20, encoder, gen$1, annots);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$88__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$59 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$22, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$59
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$72$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$73__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$72 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$72
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$73$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$74__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$73 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$73
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$74$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$75__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$74 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$74
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$75$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$75 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$75
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$88$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$89__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$88 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$88
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$89$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$90__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$89 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$89
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$90$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$91__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$90 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$90
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$91$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$92__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$91 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$91
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$92$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeInt__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$93__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$92 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$92
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$93$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeInt__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$94__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$93 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$93
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$94$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((32768 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$95__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$94 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (32768 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$94
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$95$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((65536 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$75__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$95 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = (65536 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$95
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1() {
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$50 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$53 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$56 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$59 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$72 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$73 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$74 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$75 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$88 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$89 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$90 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$91 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$92 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$93 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$94 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$95 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.constructor = $c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype = $c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype;
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$50__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$50$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$50)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$53__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$53$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$53)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$56__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$56$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$56)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$59__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$59$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$59)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$72__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$72$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$72)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$73__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((64 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$73$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$73)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$74__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((128 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$74$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$74)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$75__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((256 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$75$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$75)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$88__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((512 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$88$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$88)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$89__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((1024 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$89$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$89)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$90__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((2048 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$90$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$90)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$91__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((4096 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$91$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$91)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$92__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((8192 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$92$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$92)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$93__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((16384 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$93$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$93)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$94__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((32768 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$94$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$94)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.inst$macro$95__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((65536 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__inst$macro$95$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1__f_inst$macro$95)
});
var $d_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1: 0
}, false, "reactbuild.format.dxf.Insert$anon$lazy$macro$144$1", {
  Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1.prototype.$classData = $d_Lreactbuild_format_dxf_Insert$anon$lazy$macro$144$1;
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$146$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$56 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "layer"));
    var this$3 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "color"));
    var this$4 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "insertionPoint"));
    var this$5 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "scaleX"));
    var this$6 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "scaleY"));
    var this$7 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "scaleZ"));
    var this$8 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "rotation"));
    var this$9 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "columns"));
    var this$10 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "rows"));
    var this$11 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "columnSpacing"));
    var this$12 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "rowSpacing")), $m_Lshapeless_HNil$()))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$25$2) => {
      var x0$25 = $as_Lreactbuild_format_dxf_Insert(x0$25$2);
      if ((x0$25 !== null)) {
        var name$macro$183 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_name;
        var layer$macro$184 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_layer;
        var color$macro$185 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_color;
        var insertionPoint$macro$186 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_insertionPoint;
        var scaleX$macro$187 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_scaleX;
        var scaleY$macro$188 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_scaleY;
        var scaleZ$macro$189 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_scaleZ;
        var rotation$macro$190 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_rotation;
        var columns$macro$191 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_columns;
        var rows$macro$192 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_rows;
        var columnSpacing$macro$193 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_columnSpacing;
        var rowSpacing$macro$194 = $n(x0$25).Lreactbuild_format_dxf_Insert__f_rowSpacing;
        return new $c_Lshapeless_$colon$colon(name$macro$183, new $c_Lshapeless_$colon$colon(layer$macro$184, new $c_Lshapeless_$colon$colon(color$macro$185, new $c_Lshapeless_$colon$colon(insertionPoint$macro$186, new $c_Lshapeless_$colon$colon(scaleX$macro$187, new $c_Lshapeless_$colon$colon(scaleY$macro$188, new $c_Lshapeless_$colon$colon(scaleZ$macro$189, new $c_Lshapeless_$colon$colon(rotation$macro$190, new $c_Lshapeless_$colon$colon(columns$macro$191, new $c_Lshapeless_$colon$colon(rows$macro$192, new $c_Lshapeless_$colon$colon(columnSpacing$macro$193, new $c_Lshapeless_$colon$colon(rowSpacing$macro$194, $m_Lshapeless_HNil$()))))))))))))
      } else {
        throw new $c_s_MatchError(x0$25)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$26$2) => {
      var x0$26 = $as_Lshapeless_$colon$colon(x0$26$2);
      if ((x0$26 !== null)) {
        var name$macro$171 = $as_Lreactbuild_format_dxf_NameOf($n(x0$26).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$26).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var layer$macro$172 = $as_Lreactbuild_format_dxf_NameOf($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var color$macro$173 = $as_Lreactbuild_format_dxf_ColorIndex($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var insertionPoint$macro$174 = $as_Lreactbuild_format_dxf_Point3D($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var scaleX$macro$175 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var scaleY$macro$176 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var scaleZ$macro$177 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var rotation$macro$178 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var columns$macro$179 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var rows$macro$180 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                          if ((p11 !== null)) {
                            var columnSpacing$macro$181 = $as_s_Option($n(p11).Lshapeless_$colon$colon__f_head);
                            var p12 = $as_Lshapeless_$colon$colon($n(p11).Lshapeless_$colon$colon__f_tail);
                            if ((p12 !== null)) {
                              var rowSpacing$macro$182 = $as_s_Option($n(p12).Lshapeless_$colon$colon__f_head);
                              var p13 = $as_Lshapeless_HNil($n(p12).Lshapeless_$colon$colon__f_tail);
                              var x = $m_Lshapeless_HNil$();
                              if ((x === p13)) {
                                return new $c_Lreactbuild_format_dxf_Insert(name$macro$171, layer$macro$172, color$macro$173, insertionPoint$macro$174, scaleX$macro$175, scaleY$macro$176, scaleZ$macro$177, rotation$macro$178, columns$macro$179, rows$macro$180, columnSpacing$macro$181, rowSpacing$macro$182)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$26)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "rowSpacing"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "columnSpacing"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "rows"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "columns"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$28 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "rotation"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "scaleZ"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "scaleY"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "scaleX"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "insertionPoint"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$10);
    var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$11);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
    var this$52 = $m_s_$less$colon$less$();
    var ev = this$52.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(41)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(42)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(43)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(50)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(71)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(44)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(45)), $m_Lshapeless_HNil$()))))))))))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$195__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$146 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$56);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$146
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$195$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$198__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$195 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$195
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$198$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$201__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$198 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$198
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$201$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_parseColorIndex;
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$204__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$201 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$201
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$204$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$205__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$234__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$204 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$204
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$205$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$205 = $m_Lreactbuild_format_dxf_Point3D$().Lreactbuild_format_dxf_Point3D$__f_decoderPoint3D;
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$205
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$234$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$235__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$234 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$234
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$235$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$236__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$235 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$235
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$236$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$237__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$236 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$236
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$237$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$238__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$237 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$237
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$238$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseInt__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$239__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$238 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$238
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$239$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((32768 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseInt__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$240__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$239 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (32768 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$239
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$240$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((65536 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$241__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$240 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (65536 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$240
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$241$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((131072 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$242__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$241 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (131072 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$241
}
function $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$242$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((262144 & $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$242 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = (262144 | $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$242
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1() {
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$146 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$195 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$198 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$201 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$204 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$205 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$234 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$235 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$236 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$237 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$238 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$239 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$240 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$241 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$242 = null;
  this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.constructor = $c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype = $c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype;
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$146__Lreactbuild_format_dxf_Decoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$146$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$146)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$195__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$195$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$195)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$198__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$198$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$198)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$201__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$201$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$201)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$204__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$204$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$204)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$205__Lreactbuild_format_dxf_Decoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$205$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$205)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$234__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((1024 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$234$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$234)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$235__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((2048 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$235$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$235)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$236__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((4096 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$236$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$236)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$237__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((8192 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$237$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$237)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$238__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((16384 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$238$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$238)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$239__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((32768 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$239$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$239)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$240__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((65536 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$240$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$240)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$241__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((131072 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$241$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$241)
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.inst$macro$242__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((262144 & this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__inst$macro$242$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1__f_inst$macro$242)
});
var $d_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1: 0
}, false, "reactbuild.format.dxf.Insert$anon$lazy$macro$291$1", {
  Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1.prototype.$classData = $d_Lreactbuild_format_dxf_Insert$anon$lazy$macro$291$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_LType$() {
  this.Lreactbuild_format_dxf_LType$__f_continuous = null;
  this.Lreactbuild_format_dxf_LType$__f_encodeLType = null;
  this.Lreactbuild_format_dxf_LType$__f_decodeLType = null;
  $n_Lreactbuild_format_dxf_LType$ = this;
  this.Lreactbuild_format_dxf_LType$__f_continuous = new $c_Lreactbuild_format_dxf_LType(new $c_Lreactbuild_format_dxf_NameOf($as_T($n($as_Leu_timepit_refined_api_Refined($n($m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType).unsafeWrap__O__O("CONTINUOUS"))).Leu_timepit_refined_api_Refined__f_value)), new $c_Lreactbuild_format_dxf_LayerFlags(false, false, false, false, false, false), "Solid line", 65, ($m_Lreactbuild_format_dxf_LType$(), 0), ($m_Lreactbuild_format_dxf_LType$(), 0.0));
  var inst$macro$72 = new $c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$72));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  var qual$1 = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var x$1$3 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Lreactbuild_format_dxf_LType(x$1$2);
    $n($m_s_package$().s_package$__f_List);
    var array = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "LTYPE")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  }));
  var x$2 = $m_s_package$().s_package$__f_Nil;
  $n(qual$1);
  var x$3 = false;
  var this$9 = $n(qual$1);
  this.Lreactbuild_format_dxf_LType$__f_encodeLType = new $c_Lreactbuild_format_dxf_Encoder$$anon$1(this$9, x$3, x$1$3, x$2);
  var inst$macro$144 = new $c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1().inst$macro$73__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$144));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  var this$15 = $n($as_Lreactbuild_format_dxf_Decoder(decoder.value__O()));
  var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "LTYPE")];
  var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lreactbuild_format_dxf_LType$__f_decodeLType = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$15, prefix)
}
$c_Lreactbuild_format_dxf_LType$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LType$.prototype.constructor = $c_Lreactbuild_format_dxf_LType$;
/** @constructor */
function $h_Lreactbuild_format_dxf_LType$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LType$.prototype = $c_Lreactbuild_format_dxf_LType$.prototype;
var $d_Lreactbuild_format_dxf_LType$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_LType$: 0
}, false, "reactbuild.format.dxf.LType$", {
  Lreactbuild_format_dxf_LType$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LType$.prototype.$classData = $d_Lreactbuild_format_dxf_LType$;
var $n_Lreactbuild_format_dxf_LType$;
function $m_Lreactbuild_format_dxf_LType$() {
  if ((!$n_Lreactbuild_format_dxf_LType$)) {
    $n_Lreactbuild_format_dxf_LType$ = new $c_Lreactbuild_format_dxf_LType$()
  };
  return $n_Lreactbuild_format_dxf_LType$
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$73$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$32 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "flags"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "description"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "alignmentCode"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "numberOfLineTypeElements"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "totalPatternLength")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_format_dxf_LType(x0$15$2);
      if ((x0$15 !== null)) {
        var name$macro$92 = $n(x0$15).Lreactbuild_format_dxf_LType__f_name;
        var flags$macro$93 = $n(x0$15).Lreactbuild_format_dxf_LType__f_flags;
        var description$macro$94 = $n(x0$15).Lreactbuild_format_dxf_LType__f_description;
        var alignmentCode$macro$95 = $n(x0$15).Lreactbuild_format_dxf_LType__f_alignmentCode;
        var numberOfLineTypeElements$macro$96 = $n(x0$15).Lreactbuild_format_dxf_LType__f_numberOfLineTypeElements;
        var totalPatternLength$macro$97 = $n(x0$15).Lreactbuild_format_dxf_LType__f_totalPatternLength;
        return new $c_Lshapeless_$colon$colon(name$macro$92, new $c_Lshapeless_$colon$colon(flags$macro$93, new $c_Lshapeless_$colon$colon(description$macro$94, new $c_Lshapeless_$colon$colon(alignmentCode$macro$95, new $c_Lshapeless_$colon$colon(numberOfLineTypeElements$macro$96, new $c_Lshapeless_$colon$colon(totalPatternLength$macro$97, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var name$macro$86 = $as_Lreactbuild_format_dxf_NameOf($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var flags$macro$87 = $as_Lreactbuild_format_dxf_LayerFlags($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var description$macro$88 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var alignmentCode$macro$89 = $uI($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var numberOfLineTypeElements$macro$90 = $uI($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var totalPatternLength$macro$91 = $uD($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_format_dxf_LType(name$macro$86, flags$macro$87, description$macro$88, alignmentCode$macro$89, numberOfLineTypeElements$macro$90, totalPatternLength$macro$91)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "totalPatternLength"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "numberOfLineTypeElements"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "alignmentCode"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(3)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(72)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(73)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(40)), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$98__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$73 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$32);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$73
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$98$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$101__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$98 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$98
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$101$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_LayerFlags$().parseLayerFlags__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$114__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$101 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$101
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$114$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseString__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$115__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$114 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$114
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$115$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseInt__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$116__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$115 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$115
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$116$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseInt__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$117__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$116 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$116
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$117$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$118__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$117 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$117
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$118$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((128 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$118 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0 = (((128 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$118
}
/** @constructor */
function $c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1() {
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$73 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$98 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$101 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$114 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$115 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$116 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$117 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$118 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.constructor = $c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype = $c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype;
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.inst$macro$73__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$73$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$73)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.inst$macro$98__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$98$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$98)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.inst$macro$101__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$101$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$101)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.inst$macro$114__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((8 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$114$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$114)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.inst$macro$115__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((16 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$115$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$115)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.inst$macro$116__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((32 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$116$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$116)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.inst$macro$117__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((64 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$117$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$117)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.inst$macro$118__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((128 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__inst$macro$118$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1__f_inst$macro$118)
});
var $d_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1: 0
}, false, "reactbuild.format.dxf.LType$anon$lazy$macro$143$1", {
  Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1.prototype.$classData = $d_Lreactbuild_format_dxf_LType$anon$lazy$macro$143$1;
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$32 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "flags"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "description"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "alignmentCode"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "numberOfLineTypeElements"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "totalPatternLength")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_LType(x0$3$2);
      if ((x0$3 !== null)) {
        var name$macro$20 = $n(x0$3).Lreactbuild_format_dxf_LType__f_name;
        var flags$macro$21 = $n(x0$3).Lreactbuild_format_dxf_LType__f_flags;
        var description$macro$22 = $n(x0$3).Lreactbuild_format_dxf_LType__f_description;
        var alignmentCode$macro$23 = $n(x0$3).Lreactbuild_format_dxf_LType__f_alignmentCode;
        var numberOfLineTypeElements$macro$24 = $n(x0$3).Lreactbuild_format_dxf_LType__f_numberOfLineTypeElements;
        var totalPatternLength$macro$25 = $n(x0$3).Lreactbuild_format_dxf_LType__f_totalPatternLength;
        return new $c_Lshapeless_$colon$colon(name$macro$20, new $c_Lshapeless_$colon$colon(flags$macro$21, new $c_Lshapeless_$colon$colon(description$macro$22, new $c_Lshapeless_$colon$colon(alignmentCode$macro$23, new $c_Lshapeless_$colon$colon(numberOfLineTypeElements$macro$24, new $c_Lshapeless_$colon$colon(totalPatternLength$macro$25, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var name$macro$14 = $as_Lreactbuild_format_dxf_NameOf($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var flags$macro$15 = $as_Lreactbuild_format_dxf_LayerFlags($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var description$macro$16 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var alignmentCode$macro$17 = $uI($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var numberOfLineTypeElements$macro$18 = $uI($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var totalPatternLength$macro$19 = $uD($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_format_dxf_LType(name$macro$14, flags$macro$15, description$macro$16, alignmentCode$macro$17, numberOfLineTypeElements$macro$18, totalPatternLength$macro$19)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "totalPatternLength"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "numberOfLineTypeElements"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "alignmentCode"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(3)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(72)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(73)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(40)), $m_Lshapeless_HNil$()))))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$32, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$29__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$26 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$26
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_LayerFlags$().serializeLayerFlags__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$29 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$29
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$42$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeString__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$43__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$42 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$42
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$43$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeInt__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$44__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$43 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$43
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$44$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeInt__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$45__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$44 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$44
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$45$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$46__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$45 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$45
}
function $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$46$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((128 & $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$46 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0 = (((128 | $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$46
}
/** @constructor */
function $c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1() {
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$26 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$29 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$42 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$43 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$44 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$45 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$46 = null;
  this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.constructor = $c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype = $c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype;
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.inst$macro$26__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$26)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.inst$macro$29__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$29)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.inst$macro$42__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((8 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$42$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$42)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.inst$macro$43__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((16 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$43$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$43)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.inst$macro$44__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((32 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$44$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$44)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.inst$macro$45__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((64 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$45$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$45)
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.inst$macro$46__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((128 & this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__inst$macro$46$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1__f_inst$macro$46)
});
var $d_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1: 0
}, false, "reactbuild.format.dxf.LType$anon$lazy$macro$71$1", {
  Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1.prototype.$classData = $d_Lreactbuild_format_dxf_LType$anon$lazy$macro$71$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Layer$() {
  this.Lreactbuild_format_dxf_Layer$__f_encodeLayer = null;
  this.Lreactbuild_format_dxf_Layer$__f_decodeLayer = null;
  $n_Lreactbuild_format_dxf_Layer$ = this;
  new $c_Lreactbuild_format_dxf_Layer(new $c_Lreactbuild_format_dxf_NameOf($as_T($n($as_Leu_timepit_refined_api_Refined($n($m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType).unsafeWrap__O__O("0"))).Leu_timepit_refined_api_Refined__f_value)), new $c_Lreactbuild_format_dxf_LayerFlags(true, false, false, false, false, false), ($m_Lreactbuild_format_dxf_ColorIndex$(), new $c_Lreactbuild_format_dxf_ColorIndex(7)), $n($m_Lreactbuild_format_dxf_LType$().Lreactbuild_format_dxf_LType$__f_continuous).Lreactbuild_format_dxf_LType__f_name);
  var inst$macro$58 = new $c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$58));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  var qual$1 = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var x$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    $as_Lreactbuild_format_dxf_Layer(x$2$2);
    $n($m_s_package$().s_package$__f_List);
    var array = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "LAYER")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  }));
  var x$2$3 = $m_s_package$().s_package$__f_Nil;
  $n(qual$1);
  var x$3 = false;
  var this$10 = $n(qual$1);
  this.Lreactbuild_format_dxf_Layer$__f_encodeLayer = new $c_Lreactbuild_format_dxf_Encoder$$anon$1(this$10, x$3, x$1, x$2$3);
  var inst$macro$116 = new $c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1().inst$macro$59__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$116));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  var this$16 = $n($as_Lreactbuild_format_dxf_Decoder(decoder.value__O()));
  var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "LAYER")];
  var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lreactbuild_format_dxf_Layer$__f_decodeLayer = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$16, prefix)
}
$c_Lreactbuild_format_dxf_Layer$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Layer$.prototype.constructor = $c_Lreactbuild_format_dxf_Layer$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Layer$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Layer$.prototype = $c_Lreactbuild_format_dxf_Layer$.prototype;
var $d_Lreactbuild_format_dxf_Layer$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Layer$: 0
}, false, "reactbuild.format.dxf.Layer$", {
  Lreactbuild_format_dxf_Layer$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Layer$.prototype.$classData = $d_Lreactbuild_format_dxf_Layer$;
var $n_Lreactbuild_format_dxf_Layer$;
function $m_Lreactbuild_format_dxf_Layer$() {
  if ((!$n_Lreactbuild_format_dxf_Layer$)) {
    $n_Lreactbuild_format_dxf_Layer$ = new $c_Lreactbuild_format_dxf_Layer$()
  };
  return $n_Lreactbuild_format_dxf_Layer$
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$59$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$24 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "flags"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "color"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "lineType")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$19$2) => {
      var x0$19 = $as_Lreactbuild_format_dxf_Layer(x0$19$2);
      if ((x0$19 !== null)) {
        var name$macro$72 = $n(x0$19).Lreactbuild_format_dxf_Layer__f_name;
        var flags$macro$73 = $n(x0$19).Lreactbuild_format_dxf_Layer__f_flags;
        var color$macro$74 = $n(x0$19).Lreactbuild_format_dxf_Layer__f_color;
        var lineType$macro$75 = $n(x0$19).Lreactbuild_format_dxf_Layer__f_lineType;
        return new $c_Lshapeless_$colon$colon(name$macro$72, new $c_Lshapeless_$colon$colon(flags$macro$73, new $c_Lshapeless_$colon$colon(color$macro$74, new $c_Lshapeless_$colon$colon(lineType$macro$75, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$19)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$20$2) => {
      var x0$20 = $as_Lshapeless_$colon$colon(x0$20$2);
      if ((x0$20 !== null)) {
        var name$macro$68 = $as_Lreactbuild_format_dxf_NameOf($n(x0$20).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$20).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var flags$macro$69 = $as_Lreactbuild_format_dxf_LayerFlags($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var color$macro$70 = $as_Lreactbuild_format_dxf_ColorIndex($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var lineType$macro$71 = $as_Lreactbuild_format_dxf_NameOf($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_format_dxf_Layer(name$macro$68, flags$macro$69, color$macro$70, lineType$macro$71)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$20)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "lineType"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(6)), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$76__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$59 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$24);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$59
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$76$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$79__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$76 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$76
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$79$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_LayerFlags$().parseLayerFlags__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$92__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$79 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$79
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$92$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_parseColorIndex;
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$95__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$92 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$92
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$95$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$98__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$95 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$95
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$98$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$98 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$98
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1() {
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$59 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$76 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$79 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$92 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$95 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$98 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype.constructor = $c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype = $c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype;
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype.inst$macro$59__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$59$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$59)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype.inst$macro$76__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$76$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$76)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype.inst$macro$79__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$79$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$79)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype.inst$macro$92__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((8 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$92$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$92)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype.inst$macro$95__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((16 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$95$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$95)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype.inst$macro$98__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((32 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__inst$macro$98$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1__f_inst$macro$98)
});
var $d_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1: 0
}, false, "reactbuild.format.dxf.Layer$anon$lazy$macro$115$1", {
  Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1.prototype.$classData = $d_Lreactbuild_format_dxf_Layer$anon$lazy$macro$115$1;
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$24 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "flags"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "color"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "lineType")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Layer(x0$3$2);
      if ((x0$3 !== null)) {
        var name$macro$14 = $n(x0$3).Lreactbuild_format_dxf_Layer__f_name;
        var flags$macro$15 = $n(x0$3).Lreactbuild_format_dxf_Layer__f_flags;
        var color$macro$16 = $n(x0$3).Lreactbuild_format_dxf_Layer__f_color;
        var lineType$macro$17 = $n(x0$3).Lreactbuild_format_dxf_Layer__f_lineType;
        return new $c_Lshapeless_$colon$colon(name$macro$14, new $c_Lshapeless_$colon$colon(flags$macro$15, new $c_Lshapeless_$colon$colon(color$macro$16, new $c_Lshapeless_$colon$colon(lineType$macro$17, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var name$macro$10 = $as_Lreactbuild_format_dxf_NameOf($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var flags$macro$11 = $as_Lreactbuild_format_dxf_LayerFlags($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var color$macro$12 = $as_Lreactbuild_format_dxf_ColorIndex($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var lineType$macro$13 = $as_Lreactbuild_format_dxf_NameOf($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_format_dxf_Layer(name$macro$10, flags$macro$11, color$macro$12, lineType$macro$13)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "lineType"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(6)), $m_Lshapeless_HNil$()))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$24, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$18$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$21__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$18 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$18
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$21$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_LayerFlags$().serializeLayerFlags__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$21 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$21
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$34$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_serializeColorIndex;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$37__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$34 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$34
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$37$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$40__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$37 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$37
}
function $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$40$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$40 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$40
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1() {
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$18 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$21 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$34 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$37 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$40 = null;
  this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype.constructor = $c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype = $c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype;
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype.inst$macro$18__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$18$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$18)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype.inst$macro$21__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$21$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$21)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype.inst$macro$34__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((8 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$34$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$34)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype.inst$macro$37__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((16 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$37$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$37)
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype.inst$macro$40__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((32 & this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__inst$macro$40$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1__f_inst$macro$40)
});
var $d_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1: 0
}, false, "reactbuild.format.dxf.Layer$anon$lazy$macro$57$1", {
  Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1.prototype.$classData = $d_Lreactbuild_format_dxf_Layer$anon$lazy$macro$57$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_LayerFlags$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_LayerFlags$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LayerFlags$.prototype.constructor = $c_Lreactbuild_format_dxf_LayerFlags$;
/** @constructor */
function $h_Lreactbuild_format_dxf_LayerFlags$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LayerFlags$.prototype = $c_Lreactbuild_format_dxf_LayerFlags$.prototype;
$c_Lreactbuild_format_dxf_LayerFlags$.prototype.serializeLayerFlags__Lreactbuild_format_dxf_Serializer = (function() {
  $m_Lreactbuild_format_dxf_Serializer$();
  var $$x4 = $m_Lreactbuild_format_dxf_Serializer$();
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_format_dxf_LayerFlags(x0$1$2);
    if ((x0$1 !== null)) {
      var referenced$macro$8 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_referenced;
      var dependentXrefResolved$macro$9 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_dependentXrefResolved;
      var dependentXref$macro$10 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_dependentXref;
      var locked$macro$11 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_locked;
      var frozenInNewViewports$macro$12 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_frozenInNewViewports;
      var frozen$macro$13 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_frozen;
      return new $c_Lshapeless_$colon$colon(referenced$macro$8, new $c_Lshapeless_$colon$colon(dependentXrefResolved$macro$9, new $c_Lshapeless_$colon$colon(dependentXref$macro$10, new $c_Lshapeless_$colon$colon(locked$macro$11, new $c_Lshapeless_$colon$colon(frozenInNewViewports$macro$12, new $c_Lshapeless_$colon$colon(frozen$macro$13, $m_Lshapeless_HNil$()))))))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  var g = new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_Lshapeless_$colon$colon(x0$2$2);
    if ((x0$2 !== null)) {
      var referenced$macro$2 = $uZ($n(x0$2).Lshapeless_$colon$colon__f_head);
      var p2 = $as_Lshapeless_$colon$colon($n(x0$2).Lshapeless_$colon$colon__f_tail);
      if ((p2 !== null)) {
        var dependentXrefResolved$macro$3 = $uZ($n(p2).Lshapeless_$colon$colon__f_head);
        var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
        if ((p3 !== null)) {
          var dependentXref$macro$4 = $uZ($n(p3).Lshapeless_$colon$colon__f_head);
          var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
          if ((p4 !== null)) {
            var locked$macro$5 = $uZ($n(p4).Lshapeless_$colon$colon__f_head);
            var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
            if ((p5 !== null)) {
              var frozenInNewViewports$macro$6 = $uZ($n(p5).Lshapeless_$colon$colon__f_head);
              var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
              if ((p6 !== null)) {
                var frozen$macro$7 = $uZ($n(p6).Lshapeless_$colon$colon__f_head);
                var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p7)) {
                  return new $c_Lreactbuild_format_dxf_LayerFlags(referenced$macro$2, dependentXrefResolved$macro$3, dependentXref$macro$4, locked$macro$5, frozenInNewViewports$macro$6, frozen$macro$7)
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$2)
  }));
  var $$x3 = new $c_Lshapeless_Generic$$anon$1(f, g);
  var this$4 = $m_s_$less$colon$less$();
  var ev = this$4.s_$less$colon$less$__f_singleton;
  var this$5 = $m_sci_List$();
  var cbf = new $c_sc_IterableFactory$ToFactory(this$5);
  var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev);
  var u = new $c_Lshapeless_Lub$$anon$4();
  var this$9 = $m_sci_List$();
  var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$9);
  var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
  var u$1 = new $c_Lshapeless_Lub$$anon$4();
  var this$13 = $m_sci_List$();
  var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$13);
  var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
  var u$2 = new $c_Lshapeless_Lub$$anon$4();
  var this$17 = $m_sci_List$();
  var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$17);
  var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
  var u$3 = new $c_Lshapeless_Lub$$anon$4();
  var this$21 = $m_sci_List$();
  var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$21);
  var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
  var u$4 = new $c_Lshapeless_Lub$$anon$4();
  var this$25 = $m_sci_List$();
  var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$25);
  var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
  var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(6)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(5)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(4)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(1)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(0)), $m_Lshapeless_HNil$()))))))));
  var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
  var this$29 = $m_s_$less$colon$less$();
  var ev$1 = this$29.s_$less$colon$less$__f_singleton;
  var this$30 = $m_sci_List$();
  var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$30);
  var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$6, ev$1);
  var u$5 = new $c_Lshapeless_Lub$$anon$4();
  var this$34 = $m_sci_List$();
  var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$34);
  var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
  var u$6 = new $c_Lshapeless_Lub$$anon$4();
  var this$38 = $m_sci_List$();
  var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$38);
  var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
  var u$7 = new $c_Lshapeless_Lub$$anon$4();
  var this$42 = $m_sci_List$();
  var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$42);
  var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
  var u$8 = new $c_Lshapeless_Lub$$anon$4();
  var this$46 = $m_sci_List$();
  var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$46);
  var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
  var u$9 = new $c_Lshapeless_Lub$$anon$4();
  var this$50 = $m_sci_List$();
  var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$50);
  var inst$macro$14 = $n($$x4).serializeBitSetCaseClass__Lshapeless_Generic__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lreactbuild_format_dxf_Serializer($$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9));
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$14));
  var serializer = new $c_Lshapeless_Lazy$$anon$1(t);
  return $as_Lreactbuild_format_dxf_Serializer(serializer.value__O())
});
$c_Lreactbuild_format_dxf_LayerFlags$.prototype.parseLayerFlags__Lreactbuild_format_dxf_Parser = (function() {
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_format_dxf_LayerFlags(x0$1$2);
    if ((x0$1 !== null)) {
      var referenced$macro$8 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_referenced;
      var dependentXrefResolved$macro$9 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_dependentXrefResolved;
      var dependentXref$macro$10 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_dependentXref;
      var locked$macro$11 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_locked;
      var frozenInNewViewports$macro$12 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_frozenInNewViewports;
      var frozen$macro$13 = $n(x0$1).Lreactbuild_format_dxf_LayerFlags__f_frozen;
      return new $c_Lshapeless_$colon$colon(referenced$macro$8, new $c_Lshapeless_$colon$colon(dependentXrefResolved$macro$9, new $c_Lshapeless_$colon$colon(dependentXref$macro$10, new $c_Lshapeless_$colon$colon(locked$macro$11, new $c_Lshapeless_$colon$colon(frozenInNewViewports$macro$12, new $c_Lshapeless_$colon$colon(frozen$macro$13, $m_Lshapeless_HNil$()))))))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  var g = new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_Lshapeless_$colon$colon(x0$2$2);
    if ((x0$2 !== null)) {
      var referenced$macro$2 = $uZ($n(x0$2).Lshapeless_$colon$colon__f_head);
      var p2 = $as_Lshapeless_$colon$colon($n(x0$2).Lshapeless_$colon$colon__f_tail);
      if ((p2 !== null)) {
        var dependentXrefResolved$macro$3 = $uZ($n(p2).Lshapeless_$colon$colon__f_head);
        var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
        if ((p3 !== null)) {
          var dependentXref$macro$4 = $uZ($n(p3).Lshapeless_$colon$colon__f_head);
          var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
          if ((p4 !== null)) {
            var locked$macro$5 = $uZ($n(p4).Lshapeless_$colon$colon__f_head);
            var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
            if ((p5 !== null)) {
              var frozenInNewViewports$macro$6 = $uZ($n(p5).Lshapeless_$colon$colon__f_head);
              var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
              if ((p6 !== null)) {
                var frozen$macro$7 = $uZ($n(p6).Lshapeless_$colon$colon__f_head);
                var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p7)) {
                  return new $c_Lreactbuild_format_dxf_LayerFlags(referenced$macro$2, dependentXrefResolved$macro$3, dependentXref$macro$4, locked$macro$5, frozenInNewViewports$macro$6, frozen$macro$7)
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$2)
  }));
  new $c_Lshapeless_Generic$$anon$1(f, g);
  $m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hnilFromTraversable__Lshapeless_ops_traversable$FromTraversable(), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable);
  var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(6)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(5)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(4)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(1)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(0)), $m_Lshapeless_HNil$()))))))));
  new $c_Lshapeless_Annotations$$anon$2(annotations);
  var this$5 = $m_s_$less$colon$less$();
  var ev = this$5.s_$less$colon$less$__f_singleton;
  var this$6 = $m_sci_List$();
  var cbf = new $c_sc_IterableFactory$ToFactory(this$6);
  var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev);
  var u = new $c_Lshapeless_Lub$$anon$4();
  var this$10 = $m_sci_List$();
  var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$10);
  var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
  var u$1 = new $c_Lshapeless_Lub$$anon$4();
  var this$14 = $m_sci_List$();
  var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$14);
  var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
  var u$2 = new $c_Lshapeless_Lub$$anon$4();
  var this$18 = $m_sci_List$();
  var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$18);
  var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
  var u$3 = new $c_Lshapeless_Lub$$anon$4();
  var this$22 = $m_sci_List$();
  var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$22);
  var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
  var u$4 = new $c_Lshapeless_Lub$$anon$4();
  var this$26 = $m_sci_List$();
  var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$26);
  new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
  var inst$macro$14 = new $c_Lreactbuild_format_dxf_Parser$$anon$3();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$14));
  var parser = new $c_Lshapeless_Lazy$$anon$1(t);
  return $as_Lreactbuild_format_dxf_Parser(parser.value__O())
});
var $d_Lreactbuild_format_dxf_LayerFlags$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_LayerFlags$: 0
}, false, "reactbuild.format.dxf.LayerFlags$", {
  Lreactbuild_format_dxf_LayerFlags$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LayerFlags$.prototype.$classData = $d_Lreactbuild_format_dxf_LayerFlags$;
var $n_Lreactbuild_format_dxf_LayerFlags$;
function $m_Lreactbuild_format_dxf_LayerFlags$() {
  if ((!$n_Lreactbuild_format_dxf_LayerFlags$)) {
    $n_Lreactbuild_format_dxf_LayerFlags$ = new $c_Lreactbuild_format_dxf_LayerFlags$()
  };
  return $n_Lreactbuild_format_dxf_LayerFlags$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Line$() {
  this.Lreactbuild_format_dxf_Line$__f_encodeLine = null;
  this.Lreactbuild_format_dxf_Line$__f_decodeLine = null;
  $n_Lreactbuild_format_dxf_Line$ = this;
  var inst$macro$95 = new $c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$95));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Line$__f_encodeLine = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$168 = new $c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1().inst$macro$96__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$168));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Line$__f_decodeLine = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Line$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Line$.prototype.constructor = $c_Lreactbuild_format_dxf_Line$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Line$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Line$.prototype = $c_Lreactbuild_format_dxf_Line$.prototype;
var $d_Lreactbuild_format_dxf_Line$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Line$: 0
}, false, "reactbuild.format.dxf.Line$", {
  Lreactbuild_format_dxf_Line$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Line$.prototype.$classData = $d_Lreactbuild_format_dxf_Line$;
var $n_Lreactbuild_format_dxf_Line$;
function $m_Lreactbuild_format_dxf_Line$() {
  if ((!$n_Lreactbuild_format_dxf_Line$)) {
    $n_Lreactbuild_format_dxf_Line$ = new $c_Lreactbuild_format_dxf_Line$()
  };
  return $n_Lreactbuild_format_dxf_Line$
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$96$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0)) {
    var this$24 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "layer"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "color"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "start"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "end")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_format_dxf_Line(x0$31$2);
      if ((x0$31 !== null)) {
        var layer$macro$109 = $n(x0$31).Lreactbuild_format_dxf_Line__f_layer;
        var color$macro$110 = $n(x0$31).Lreactbuild_format_dxf_Line__f_color;
        var start$macro$111 = $n(x0$31).Lreactbuild_format_dxf_Line__f_start;
        var end$macro$112 = $n(x0$31).Lreactbuild_format_dxf_Line__f_end;
        return new $c_Lshapeless_$colon$colon(layer$macro$109, new $c_Lshapeless_$colon$colon(color$macro$110, new $c_Lshapeless_$colon$colon(start$macro$111, new $c_Lshapeless_$colon$colon(end$macro$112, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var layer$macro$105 = $as_Lreactbuild_format_dxf_NameOf($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$32).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var color$macro$106 = $as_Lreactbuild_format_dxf_ColorIndex($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var start$macro$107 = $as_Lreactbuild_format_dxf_Point3D($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var end$macro$108 = $as_Lreactbuild_format_dxf_Point3D($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_format_dxf_Line(layer$macro$105, color$macro$106, start$macro$107, end$macro$108)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "end"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "start"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$96 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$24);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$96
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$113$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$116__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$113 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$113
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$116$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_parseColorIndex;
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$119__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$116 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$116
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$119$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$120__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$149__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$119 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$119
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$120$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$120 = $m_Lreactbuild_format_dxf_Point3D$().Lreactbuild_format_dxf_Point3D$__f_decoderPoint3D;
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$120
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$149$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((512 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$120__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$150__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$149 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$149
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$150$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$150 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$150
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1() {
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$96 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$113 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$116 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$119 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$120 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$149 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$150 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype.constructor = $c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype = $c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype;
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype.inst$macro$96__Lreactbuild_format_dxf_Decoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$96$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$96)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype.inst$macro$113__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$113$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$113)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype.inst$macro$116__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$116$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$116)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype.inst$macro$119__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$119$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$119)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype.inst$macro$120__Lreactbuild_format_dxf_Decoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$120$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$120)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype.inst$macro$149__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((512 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$149$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$149)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype.inst$macro$150__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((1024 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__inst$macro$150$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1__f_inst$macro$150)
});
var $d_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1: 0
}, false, "reactbuild.format.dxf.Line$anon$lazy$macro$167$1", {
  Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1.prototype.$classData = $d_Lreactbuild_format_dxf_Line$anon$lazy$macro$167$1;
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0)) {
    var this$24 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "layer"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "color"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "start"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "end")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Line(x0$3$2);
      if ((x0$3 !== null)) {
        var layer$macro$14 = $n(x0$3).Lreactbuild_format_dxf_Line__f_layer;
        var color$macro$15 = $n(x0$3).Lreactbuild_format_dxf_Line__f_color;
        var start$macro$16 = $n(x0$3).Lreactbuild_format_dxf_Line__f_start;
        var end$macro$17 = $n(x0$3).Lreactbuild_format_dxf_Line__f_end;
        return new $c_Lshapeless_$colon$colon(layer$macro$14, new $c_Lshapeless_$colon$colon(color$macro$15, new $c_Lshapeless_$colon$colon(start$macro$16, new $c_Lshapeless_$colon$colon(end$macro$17, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var layer$macro$10 = $as_Lreactbuild_format_dxf_NameOf($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var color$macro$11 = $as_Lreactbuild_format_dxf_ColorIndex($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var start$macro$12 = $as_Lreactbuild_format_dxf_Point3D($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var end$macro$13 = $as_Lreactbuild_format_dxf_Point3D($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_format_dxf_Line(layer$macro$10, color$macro$11, start$macro$12, end$macro$13)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "end"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "start"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$24, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$18$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$21__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$18 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$18
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$21$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_serializeColorIndex;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$24__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$21 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$21
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$24$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0)) {
    var this$22 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var this$20 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "z")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_format_dxf_Point3D(x0$11$2);
      if ((x0$11 !== null)) {
        var x$macro$34 = $n(x0$11).Lreactbuild_format_dxf_Point3D__f_x;
        var y$macro$35 = $n(x0$11).Lreactbuild_format_dxf_Point3D__f_y;
        var z$macro$36 = $n(x0$11).Lreactbuild_format_dxf_Point3D__f_z;
        return new $c_Lshapeless_$colon$colon(x$macro$34, new $c_Lshapeless_$colon$colon(y$macro$35, new $c_Lshapeless_$colon$colon(z$macro$36, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
      if ((x0$12 !== null)) {
        var x$macro$31 = $uD($n(x0$12).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$12).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$32 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var z$macro$33 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_format_dxf_Point3D(x$macro$31, y$macro$32, z$macro$33)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$12)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "z"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(10)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(20)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(30)), $m_Lshapeless_HNil$())))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$37__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var encodeV = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$20, encoder, gen$1, annots);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$53__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$24 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$22, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$24
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$37$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$38__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$37 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$37
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$38$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$39__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$38 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$38
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$39$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$40__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$39 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$39
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$40$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$40 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$40
}
function $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$53$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0)) {
    var this$22 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var this$20 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "z")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$19$2) => {
      var x0$19 = $as_Lreactbuild_format_dxf_Point3D(x0$19$2);
      if ((x0$19 !== null)) {
        var x$macro$63 = $n(x0$19).Lreactbuild_format_dxf_Point3D__f_x;
        var y$macro$64 = $n(x0$19).Lreactbuild_format_dxf_Point3D__f_y;
        var z$macro$65 = $n(x0$19).Lreactbuild_format_dxf_Point3D__f_z;
        return new $c_Lshapeless_$colon$colon(x$macro$63, new $c_Lshapeless_$colon$colon(y$macro$64, new $c_Lshapeless_$colon$colon(z$macro$65, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$19)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$20$2) => {
      var x0$20 = $as_Lshapeless_$colon$colon(x0$20$2);
      if ((x0$20 !== null)) {
        var x$macro$60 = $uD($n(x0$20).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$20).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$61 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var z$macro$62 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_format_dxf_Point3D(x$macro$60, y$macro$61, z$macro$62)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$20)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "z"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(10)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(20)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(30)), $m_Lshapeless_HNil$())))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$37__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var encodeV = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$20, encoder, gen$1, annots);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$40__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$53 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$22, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$53
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1() {
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$18 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$21 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$24 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$37 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$38 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$39 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$40 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$53 = null;
  this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.constructor = $c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype = $c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype;
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.inst$macro$18__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$18$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$18)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.inst$macro$21__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$21$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$21)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.inst$macro$24__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$24$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$24)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.inst$macro$37__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$37$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$37)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.inst$macro$38__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$38$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$38)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.inst$macro$39__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((64 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$39$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$39)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.inst$macro$40__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((128 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$40$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$40)
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.inst$macro$53__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((256 & this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__inst$macro$53$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1__f_inst$macro$53)
});
var $d_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1: 0
}, false, "reactbuild.format.dxf.Line$anon$lazy$macro$94$1", {
  Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1.prototype.$classData = $d_Lreactbuild_format_dxf_Line$anon$lazy$macro$94$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(outer, encodeV$1, encodeT$1) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5.prototype.constructor = $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5;
/** @constructor */
function $h_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5.prototype = $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5.prototype;
var $d_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5: 0
}, false, "reactbuild.format.dxf.LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5", {
  Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5: 1,
  O: 1,
  Lreactbuild_format_dxf_AccumulatingEncoder: 1
});
$c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5.prototype.$classData = $d_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5;
/** @constructor */
function $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15(outer, decodeA$1, gen$1) {
  this.Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15__f_decodeA$1 = null;
  this.Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15__f_gen$1 = null;
  this.Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15__f_decodeA$1 = decodeA$1;
  this.Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15__f_gen$1 = gen$1
}
$c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15.prototype.constructor = $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15;
/** @constructor */
function $h_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15.prototype = $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15.prototype;
$c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(a) {
  var x1 = $n($as_Lreactbuild_format_dxf_Decoder($n(this.Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15__f_decodeA$1).value__O())).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either(a);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var v = $as_Lreactbuild_format_dxf_CursorResult($n(x2).s_util_Right__f_value);
    var this$1 = $n(v);
    var arg1 = this$1.Lreactbuild_format_dxf_CursorResult__f_value;
    var x$2 = $as_Lshapeless_Coproduct(arg1);
    return new $c_s_util_Right(new $c_Lreactbuild_format_dxf_CursorResult($n(this.Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15__f_gen$1).from__O__O(x$2), this$1.Lreactbuild_format_dxf_CursorResult__f_c))
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15: 0
}, false, "reactbuild.format.dxf.LowPriorityImplicitsDecoder$$anon$15", {
  Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15: 1,
  O: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15.prototype.$classData = $d_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15;
/** @constructor */
function $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(outer) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16.prototype.constructor = $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16;
/** @constructor */
function $h_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16.prototype = $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16.prototype;
$c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(c) {
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
var $d_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16: 0
}, false, "reactbuild.format.dxf.LowPriorityImplicitsDecoder$$anon$16", {
  Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16: 1,
  O: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16.prototype.$classData = $d_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16;
/** @constructor */
function $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12(outer, encodeA$1, gen$1) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12.prototype.constructor = $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12;
/** @constructor */
function $h_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12.prototype = $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12.prototype;
var $d_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12: 0
}, false, "reactbuild.format.dxf.LowPriorityImplicitsEncoder$$anon$12", {
  Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12: 1,
  O: 1,
  Lreactbuild_format_dxf_Encoder: 1
});
$c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12.prototype.$classData = $d_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12;
/** @constructor */
function $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(outer, encoder$1, gen$2, annots$2) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13.prototype.constructor = $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13;
/** @constructor */
function $h_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13.prototype = $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13.prototype;
var $d_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13: 0
}, false, "reactbuild.format.dxf.LowPriorityImplicitsEncoder$$anon$13", {
  Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13: 1,
  O: 1,
  Lreactbuild_format_dxf_Encoder: 1
});
$c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13.prototype.$classData = $d_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13;
/** @constructor */
function $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(outer, decodeV$1) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5.prototype.constructor = $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5;
/** @constructor */
function $h_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5.prototype = $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5.prototype;
var $d_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5: 0
}, false, "reactbuild.format.dxf.LowPriorityImplicitsFieldDecoderInstances$$anon$5", {
  Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5: 1,
  O: 1,
  Lreactbuild_format_dxf_FieldDecoder: 1
});
$c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5.prototype.$classData = $d_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5;
/** @constructor */
function $c_Lreactbuild_format_dxf_LwPolyline$() {
  this.Lreactbuild_format_dxf_LwPolyline$__f_encodeLwPolyline = null;
  this.Lreactbuild_format_dxf_LwPolyline$__f_decodeLwPolyline = null;
  $n_Lreactbuild_format_dxf_LwPolyline$ = this;
  var inst$macro$111 = new $c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$111));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  var this$9 = $n($as_Lreactbuild_format_dxf_Encoder(encoder.value__O()));
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_format_dxf_LwPolyline(v$2);
    var x$1 = new $c_s_Some($n($n(v).Lreactbuild_format_dxf_LwPolyline__f_vertices).length__I());
    var this$4 = $n(v);
    var x$2 = this$4.Lreactbuild_format_dxf_LwPolyline__f_layer;
    var this$5 = $n(v);
    var x$3 = this$5.Lreactbuild_format_dxf_LwPolyline__f_color;
    var this$6 = $n(v);
    var x$4 = this$6.Lreactbuild_format_dxf_LwPolyline__f_flags;
    var this$7 = $n(v);
    var x$5 = this$7.Lreactbuild_format_dxf_LwPolyline__f_vertices;
    $n(v);
    return new $c_Lreactbuild_format_dxf_LwPolyline(x$2, x$3, x$1, x$4, x$5)
  }));
  this.Lreactbuild_format_dxf_LwPolyline$__f_encodeLwPolyline = new $c_Lreactbuild_format_dxf_Encoder$$anon$4(this$9, f);
  var inst$macro$224 = new $c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1().inst$macro$112__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$224));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_LwPolyline$__f_decodeLwPolyline = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_LwPolyline$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LwPolyline$.prototype.constructor = $c_Lreactbuild_format_dxf_LwPolyline$;
/** @constructor */
function $h_Lreactbuild_format_dxf_LwPolyline$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LwPolyline$.prototype = $c_Lreactbuild_format_dxf_LwPolyline$.prototype;
var $d_Lreactbuild_format_dxf_LwPolyline$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_LwPolyline$: 0
}, false, "reactbuild.format.dxf.LwPolyline$", {
  Lreactbuild_format_dxf_LwPolyline$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LwPolyline$.prototype.$classData = $d_Lreactbuild_format_dxf_LwPolyline$;
var $n_Lreactbuild_format_dxf_LwPolyline$;
function $m_Lreactbuild_format_dxf_LwPolyline$() {
  if ((!$n_Lreactbuild_format_dxf_LwPolyline$)) {
    $n_Lreactbuild_format_dxf_LwPolyline$ = new $c_Lreactbuild_format_dxf_LwPolyline$()
  };
  return $n_Lreactbuild_format_dxf_LwPolyline$
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0)) {
    var this$28 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "layer"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "color"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "numberOfVertices"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "flags"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "vertices")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_LwPolyline(x0$3$2);
      if ((x0$3 !== null)) {
        var layer$macro$17 = $n(x0$3).Lreactbuild_format_dxf_LwPolyline__f_layer;
        var color$macro$18 = $n(x0$3).Lreactbuild_format_dxf_LwPolyline__f_color;
        var numberOfVertices$macro$19 = $n(x0$3).Lreactbuild_format_dxf_LwPolyline__f_numberOfVertices;
        var flags$macro$20 = $n(x0$3).Lreactbuild_format_dxf_LwPolyline__f_flags;
        var vertices$macro$21 = $n(x0$3).Lreactbuild_format_dxf_LwPolyline__f_vertices;
        return new $c_Lshapeless_$colon$colon(layer$macro$17, new $c_Lshapeless_$colon$colon(color$macro$18, new $c_Lshapeless_$colon$colon(numberOfVertices$macro$19, new $c_Lshapeless_$colon$colon(flags$macro$20, new $c_Lshapeless_$colon$colon(vertices$macro$21, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var layer$macro$12 = $as_Lreactbuild_format_dxf_NameOf($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var color$macro$13 = $as_Lreactbuild_format_dxf_ColorIndex($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var numberOfVertices$macro$14 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var flags$macro$15 = $as_Lreactbuild_format_dxf_LwPolylineFlags($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var vertices$macro$16 = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_format_dxf_LwPolyline(layer$macro$12, color$macro$13, numberOfVertices$macro$14, flags$macro$15, vertices$macro$16)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "vertices"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "numberOfVertices"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(90)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$22__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$28, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$22$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$25__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$22 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$22
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$25$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_serializeColorIndex;
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$28__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$25 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$25
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$28$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeInt__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$29__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$28 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$28
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0)) {
    var this$22 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var $$x4 = $m_Lreactbuild_format_dxf_Serializer$();
    var f = new $c_sjsr_AnonFunction1(((x0$9$2) => {
      var x0$9 = $as_Lreactbuild_format_dxf_LwPolylineFlags(x0$9$2);
      if ((x0$9 !== null)) {
        var plineGen$macro$32 = $n(x0$9).Lreactbuild_format_dxf_LwPolylineFlags__f_plineGen;
        var closed$macro$33 = $n(x0$9).Lreactbuild_format_dxf_LwPolylineFlags__f_closed;
        return new $c_Lshapeless_$colon$colon(plineGen$macro$32, new $c_Lshapeless_$colon$colon(closed$macro$33, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$9)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$10$2) => {
      var x0$10 = $as_Lshapeless_$colon$colon(x0$10$2);
      if ((x0$10 !== null)) {
        var plineGen$macro$30 = $uZ($n(x0$10).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$10).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var closed$macro$31 = $uZ($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_format_dxf_LwPolylineFlags(plineGen$macro$30, closed$macro$31)
          }
        }
      };
      throw new $c_s_MatchError(x0$10)
    }));
    var $$x3 = new $c_Lshapeless_Generic$$anon$1(f, g);
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var this$5 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$5);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$9 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$9);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(7)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(0)), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$13 = $m_s_$less$colon$less$();
    var ev$1 = this$13.s_$less$colon$less$__f_singleton;
    var this$14 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$14);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$1);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$18 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$18);
    var serializeV = $n($$x4).serializeBitSetCaseClass__Lshapeless_Generic__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lreactbuild_format_dxf_Serializer($$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$29 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$22, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$29
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$34$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encoderA = $m_Lreactbuild_format_dxf_Vertex2D$().Lreactbuild_format_dxf_Vertex2D$__f_encodeVertex2D;
    var encodeV = new $c_Lreactbuild_format_dxf_Encoder$$anon$14(encoderA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$65__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$34 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$34
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$65$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$65 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$65
}
/** @constructor */
function $c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1() {
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$22 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$25 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$28 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$29 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$34 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$65 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype.constructor = $c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype = $c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype;
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype.inst$macro$22__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$22$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$22)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype.inst$macro$25__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$25$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$25)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype.inst$macro$28__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$28$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$28)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype.inst$macro$29__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$29)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype.inst$macro$34__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$34$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$34)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype.inst$macro$65__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((4096 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__inst$macro$65$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1__f_inst$macro$65)
});
var $d_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1: 0
}, false, "reactbuild.format.dxf.LwPolyline$anon$lazy$macro$110$1", {
  Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1.prototype.$classData = $d_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$110$1;
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$112$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$28 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "layer"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "color"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "numberOfVertices"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "flags"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "vertices")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$25$2) => {
      var x0$25 = $as_Lreactbuild_format_dxf_LwPolyline(x0$25$2);
      if ((x0$25 !== null)) {
        var layer$macro$128 = $n(x0$25).Lreactbuild_format_dxf_LwPolyline__f_layer;
        var color$macro$129 = $n(x0$25).Lreactbuild_format_dxf_LwPolyline__f_color;
        var numberOfVertices$macro$130 = $n(x0$25).Lreactbuild_format_dxf_LwPolyline__f_numberOfVertices;
        var flags$macro$131 = $n(x0$25).Lreactbuild_format_dxf_LwPolyline__f_flags;
        var vertices$macro$132 = $n(x0$25).Lreactbuild_format_dxf_LwPolyline__f_vertices;
        return new $c_Lshapeless_$colon$colon(layer$macro$128, new $c_Lshapeless_$colon$colon(color$macro$129, new $c_Lshapeless_$colon$colon(numberOfVertices$macro$130, new $c_Lshapeless_$colon$colon(flags$macro$131, new $c_Lshapeless_$colon$colon(vertices$macro$132, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$25)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$26$2) => {
      var x0$26 = $as_Lshapeless_$colon$colon(x0$26$2);
      if ((x0$26 !== null)) {
        var layer$macro$123 = $as_Lreactbuild_format_dxf_NameOf($n(x0$26).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$26).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var color$macro$124 = $as_Lreactbuild_format_dxf_ColorIndex($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var numberOfVertices$macro$125 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var flags$macro$126 = $as_Lreactbuild_format_dxf_LwPolylineFlags($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var vertices$macro$127 = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_format_dxf_LwPolyline(layer$macro$123, color$macro$124, numberOfVertices$macro$125, flags$macro$126, vertices$macro$127)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$26)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "vertices"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "numberOfVertices"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "color"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "layer"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(8)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(62)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(90)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$133__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$112 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$28);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$112
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$133$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$136__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$133 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$133
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$136$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_ColorIndex$().Lreactbuild_format_dxf_ColorIndex$__f_parseColorIndex;
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$139__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$136 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$136
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$139$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseInt__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$140__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$139 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$139
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$140$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$14 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_format_dxf_LwPolylineFlags(x0$31$2);
      if ((x0$31 !== null)) {
        var plineGen$macro$143 = $n(x0$31).Lreactbuild_format_dxf_LwPolylineFlags__f_plineGen;
        var closed$macro$144 = $n(x0$31).Lreactbuild_format_dxf_LwPolylineFlags__f_closed;
        return new $c_Lshapeless_$colon$colon(plineGen$macro$143, new $c_Lshapeless_$colon$colon(closed$macro$144, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var plineGen$macro$141 = $uZ($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$32).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var closed$macro$142 = $uZ($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_format_dxf_LwPolylineFlags(plineGen$macro$141, closed$macro$142)
          }
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable($m_Lshapeless_ops_traversable$FromTraversable$().hnilFromTraversable__Lshapeless_ops_traversable$FromTraversable(), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable), $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(7)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_BitIndex(0)), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$5 = $m_s_$less$colon$less$();
    var ev = this$5.s_$less$colon$less$__f_singleton;
    var this$6 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$6);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$10 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$10);
    new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var parseV = new $c_Lreactbuild_format_dxf_Parser$$anon$3();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$14, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$145__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$140 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$140
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$145$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$146__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$202__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$145 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$145
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$146$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((64 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var decodeA = $m_Lreactbuild_format_dxf_Vertex2D$().Lreactbuild_format_dxf_Vertex2D$__f_decodeVertex2D;
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$146 = new $c_Lreactbuild_format_dxf_Decoder$$anon$17(decodeA);
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$146
}
function $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$202$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$202 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$202
}
/** @constructor */
function $c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1() {
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$112 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$133 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$136 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$139 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$140 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$145 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$146 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$202 = null;
  this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.constructor = $c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype = $c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype;
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.inst$macro$112__Lreactbuild_format_dxf_Decoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$112$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$112)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.inst$macro$133__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$133$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$133)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.inst$macro$136__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$136$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$136)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.inst$macro$139__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$139$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$139)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.inst$macro$140__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$140$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$140)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.inst$macro$145__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$145$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$145)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.inst$macro$146__Lreactbuild_format_dxf_Decoder = (function() {
  return (((64 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$146$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$146)
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.inst$macro$202__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((16384 & this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__inst$macro$202$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1__f_inst$macro$202)
});
var $d_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1: 0
}, false, "reactbuild.format.dxf.LwPolyline$anon$lazy$macro$223$1", {
  Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1.prototype.$classData = $d_Lreactbuild_format_dxf_LwPolyline$anon$lazy$macro$223$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(outer, serializeV$1, encodeT$2) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6.prototype = new $h_O();
$c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6.prototype.constructor = $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6;
/** @constructor */
function $h_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6.prototype = $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6.prototype;
var $d_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6 = new $TypeData().initClass({
  Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6: 0
}, false, "reactbuild.format.dxf.MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6", {
  Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6: 1,
  O: 1,
  Lreactbuild_format_dxf_AccumulatingEncoder: 1
});
$c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6.prototype.$classData = $d_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6;
/** @constructor */
function $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(outer, parseV$1) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6.prototype = new $h_O();
$c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6.prototype.constructor = $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6;
/** @constructor */
function $h_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6.prototype = $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6.prototype;
var $d_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6 = new $TypeData().initClass({
  Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6: 0
}, false, "reactbuild.format.dxf.MidPriorityImplicitsFieldDecoderInstances$$anon$6", {
  Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6: 1,
  O: 1,
  Lreactbuild_format_dxf_FieldDecoder: 1
});
$c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6.prototype.$classData = $d_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6;
/** @constructor */
function $c_Lreactbuild_format_dxf_NameOf$() {
  this.Lreactbuild_format_dxf_NameOf$__f_badPattern = null;
  $n_Lreactbuild_format_dxf_NameOf$ = this;
  this.Lreactbuild_format_dxf_NameOf$__f_badPattern = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[^A-Za-z0-9_]", $m_sci_Nil$()))
}
$c_Lreactbuild_format_dxf_NameOf$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_NameOf$.prototype.constructor = $c_Lreactbuild_format_dxf_NameOf$;
/** @constructor */
function $h_Lreactbuild_format_dxf_NameOf$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_NameOf$.prototype = $c_Lreactbuild_format_dxf_NameOf$.prototype;
$c_Lreactbuild_format_dxf_NameOf$.prototype.unsafe__T__Lreactbuild_format_dxf_NameOf = (function(value) {
  return new $c_Lreactbuild_format_dxf_NameOf(value)
});
$c_Lreactbuild_format_dxf_NameOf$.prototype.serializeNameOf__Lreactbuild_format_dxf_Serializer = (function() {
  $m_Lreactbuild_format_dxf_Serializer$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_format_dxf_NameOf(x$1$2);
    return $n(x$1).Lreactbuild_format_dxf_NameOf__f_value
  }));
  return new $c_Lreactbuild_format_dxf_Serializer$$anon$1(f)
});
$c_Lreactbuild_format_dxf_NameOf$.prototype.parseNameOf__Lreactbuild_format_dxf_Parser = (function() {
  var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_T(x$2$2);
    return $m_Lreactbuild_format_dxf_NameOf$().convert__T__Lreactbuild_format_dxf_NameOf(x$2)
  }));
  return new $c_Lreactbuild_format_dxf_Parser$$anon$2(f)
});
$c_Lreactbuild_format_dxf_NameOf$.prototype.convert__T__Lreactbuild_format_dxf_NameOf = (function(value) {
  return this.unsafe__T__Lreactbuild_format_dxf_NameOf($n(this.Lreactbuild_format_dxf_NameOf$__f_badPattern).replaceAllIn__jl_CharSequence__T__T($f_T__replaceAll__T__T__T($n($n($m_Lcom_iz2use_common_package$().Normalizer__Lcom_iz2use_common_PlatformSpecifics$Normalizer$()).normalize__T__Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form__T(value, $n($n($m_Lcom_iz2use_common_package$().Normalizer__Lcom_iz2use_common_PlatformSpecifics$Normalizer$()).Form__Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$()).NFD__Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$())), "[\u0300-\u036f]", ""), "_"))
});
var $d_Lreactbuild_format_dxf_NameOf$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_NameOf$: 0
}, false, "reactbuild.format.dxf.NameOf$", {
  Lreactbuild_format_dxf_NameOf$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_NameOf$.prototype.$classData = $d_Lreactbuild_format_dxf_NameOf$;
var $n_Lreactbuild_format_dxf_NameOf$;
function $m_Lreactbuild_format_dxf_NameOf$() {
  if ((!$n_Lreactbuild_format_dxf_NameOf$)) {
    $n_Lreactbuild_format_dxf_NameOf$ = new $c_Lreactbuild_format_dxf_NameOf$()
  };
  return $n_Lreactbuild_format_dxf_NameOf$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Objects$() {
  this.Lreactbuild_format_dxf_Objects$__f_encodeObjectsSection = null;
  this.Lreactbuild_format_dxf_Objects$__f_decodeObjectsSection = null;
  $n_Lreactbuild_format_dxf_Objects$ = this;
  var inst$macro$4 = new $c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$4));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Objects$__f_encodeObjectsSection = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$8 = new $c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2().inst$macro$5__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$8));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Objects$__f_decodeObjectsSection = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Objects$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Objects$.prototype.constructor = $c_Lreactbuild_format_dxf_Objects$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Objects$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Objects$.prototype = $c_Lreactbuild_format_dxf_Objects$.prototype;
var $d_Lreactbuild_format_dxf_Objects$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Objects$: 0
}, false, "reactbuild.format.dxf.Objects$", {
  Lreactbuild_format_dxf_Objects$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Objects$.prototype.$classData = $d_Lreactbuild_format_dxf_Objects$;
var $n_Lreactbuild_format_dxf_Objects$;
function $m_Lreactbuild_format_dxf_Objects$() {
  if ((!$n_Lreactbuild_format_dxf_Objects$)) {
    $n_Lreactbuild_format_dxf_Objects$ = new $c_Lreactbuild_format_dxf_Objects$()
  };
  return $n_Lreactbuild_format_dxf_Objects$
}
function $p_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$8 = $m_Lreactbuild_format_dxf_Encoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Objects(x0$3$2);
      if ((x0$3 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_HNil(x0$4$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$4)) {
        return new $c_Lreactbuild_format_dxf_Objects()
      } else {
        throw new $c_s_MatchError(x0$4)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$8, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__inst$macro$2$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_inst$macro$2 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_inst$macro$2
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2() {
  this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_inst$macro$2 = null;
  this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2.prototype.constructor = $c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2;
/** @constructor */
function $h_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2.prototype = $c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2.prototype;
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2.prototype.inst$macro$2__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__inst$macro$2$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2__f_inst$macro$2)
});
var $d_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2: 0
}, false, "reactbuild.format.dxf.Objects$anon$lazy$macro$3$2", {
  Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2.prototype.$classData = $d_Lreactbuild_format_dxf_Objects$anon$lazy$macro$3$2;
function $p_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__inst$macro$5$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$8 = $m_Lreactbuild_format_dxf_Decoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_format_dxf_Objects(x0$11$2);
      if ((x0$11 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_HNil(x0$12$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$12)) {
        return new $c_Lreactbuild_format_dxf_Objects()
      } else {
        throw new $c_s_MatchError(x0$12)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_inst$macro$5 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$8);
    $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_inst$macro$5
}
function $p_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_inst$macro$6 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_inst$macro$6
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2() {
  this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_inst$macro$5 = null;
  this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_inst$macro$6 = null;
  this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2.prototype.constructor = $c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2;
/** @constructor */
function $h_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2.prototype = $c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2.prototype;
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2.prototype.inst$macro$5__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__inst$macro$5$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_inst$macro$5)
});
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2.prototype.inst$macro$6__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2__f_inst$macro$6)
});
var $d_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2: 0
}, false, "reactbuild.format.dxf.Objects$anon$lazy$macro$7$2", {
  Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2.prototype.$classData = $d_Lreactbuild_format_dxf_Objects$anon$lazy$macro$7$2;
/** @constructor */
function $c_Lreactbuild_format_dxf_Parameter$$anon$1() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Parameter$$anon$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Parameter$$anon$1.prototype.constructor = $c_Lreactbuild_format_dxf_Parameter$$anon$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Parameter$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Parameter$$anon$1.prototype = $c_Lreactbuild_format_dxf_Parameter$$anon$1.prototype;
var $d_Lreactbuild_format_dxf_Parameter$$anon$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Parameter$$anon$1: 0
}, false, "reactbuild.format.dxf.Parameter$$anon$1", {
  Lreactbuild_format_dxf_Parameter$$anon$1: 1,
  O: 1,
  Lreactbuild_format_dxf_ConfigAdt: 1
});
$c_Lreactbuild_format_dxf_Parameter$$anon$1.prototype.$classData = $d_Lreactbuild_format_dxf_Parameter$$anon$1;
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$67$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    var this$23 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ACADVER"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "EXTMAX"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "EXTMIN"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "INSBASE")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_format_dxf_Parameter(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_format_dxf_ACADVER)) {
        var $$x4 = 0
      } else if ((p instanceof $c_Lreactbuild_format_dxf_EXTMAX)) {
        var $$x4 = 1
      } else if ((p instanceof $c_Lreactbuild_format_dxf_EXTMIN)) {
        var $$x4 = 2
      } else {
        if ((!(p instanceof $c_Lreactbuild_format_dxf_INSBASE))) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7 = $as_Lshapeless_$colon$plus$colon(x$7$2);
      return $as_Lreactbuild_format_dxf_Parameter($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$7))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "INSBASE"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "EXTMIN"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "EXTMAX"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "ACADVER"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$68__Lreactbuild_format_dxf_CoproductDecoder()));
    var decodeA = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$67 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$15(this$23, decodeA, gen$1);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$67
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$68$lzycompute__Lreactbuild_format_dxf_CoproductDecoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    var this$58 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ACADVER"));
    var witK$3 = new $c_Lshapeless_Witness$$anon$1(value0);
    var this$14 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "version")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$51$2) => {
      var x0$51 = $as_Lreactbuild_format_dxf_ACADVER(x0$51$2);
      if ((x0$51 !== null)) {
        var version$macro$82 = $n(x0$51).Lreactbuild_format_dxf_ACADVER__f_version;
        return new $c_Lshapeless_$colon$colon(version$macro$82, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$51)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$52$2) => {
      var x0$52 = $as_Lshapeless_$colon$colon(x0$52$2);
      if ((x0$52 !== null)) {
        var version$macro$81 = $as_T($n(x0$52).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$52).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_ACADVER(version$macro$81)
        }
      };
      throw new $c_s_MatchError(x0$52)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "version"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$10 = $m_s_$less$colon$less$();
    var ev = this$10.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(1)), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$83__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$3 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$14);
    var this$57 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "EXTMAX"));
    var witK$2 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var this$27 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "point")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var f$1 = new $c_sjsr_AnonFunction1(((x0$75$2) => {
      var x0$75 = $as_Lreactbuild_format_dxf_EXTMAX(x0$75$2);
      if ((x0$75 !== null)) {
        var point$macro$131 = $n(x0$75).Lreactbuild_format_dxf_EXTMAX__f_point;
        return new $c_Lshapeless_$colon$colon(point$macro$131, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$75)
      }
    }));
    var g$1 = new $c_sjsr_AnonFunction1(((x0$76$2) => {
      var x0$76 = $as_Lshapeless_$colon$colon(x0$76$2);
      if ((x0$76 !== null)) {
        var point$macro$130 = $as_Lreactbuild_format_dxf_Point3D($n(x0$76).Lshapeless_$colon$colon__f_head);
        var p2$1 = $as_Lshapeless_HNil($n(x0$76).Lshapeless_$colon$colon__f_tail);
        var x$1 = $m_Lshapeless_HNil$();
        if ((x$1 === p2$1)) {
          return new $c_Lreactbuild_format_dxf_EXTMAX(point$macro$130)
        }
      };
      throw new $c_s_MatchError(x0$76)
    }));
    var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$1 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "point"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$23 = $m_s_$less$colon$less$();
    var ev$1 = this$23.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$1);
    var annotations$1 = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_Annotations$$anon$2(annotations$1);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$132__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t$1);
    var decodeV$2 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$27);
    var this$56 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    $m_Lshapeless_Witness$();
    var this$28 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "EXTMIN"));
    var witK$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var this$40 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$30 = $m_s_Symbol$();
    var labels$2 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "point")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
    var f$2 = new $c_sjsr_AnonFunction1(((x0$91$2) => {
      var x0$91 = $as_Lreactbuild_format_dxf_EXTMIN(x0$91$2);
      if ((x0$91 !== null)) {
        var point$macro$151 = $n(x0$91).Lreactbuild_format_dxf_EXTMIN__f_point;
        return new $c_Lshapeless_$colon$colon(point$macro$151, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$91)
      }
    }));
    var g$2 = new $c_sjsr_AnonFunction1(((x0$92$2) => {
      var x0$92 = $as_Lshapeless_$colon$colon(x0$92$2);
      if ((x0$92 !== null)) {
        var point$macro$150 = $as_Lreactbuild_format_dxf_Point3D($n(x0$92).Lshapeless_$colon$colon__f_head);
        var p2$2 = $as_Lshapeless_HNil($n(x0$92).Lshapeless_$colon$colon__f_tail);
        var x$2 = $m_Lshapeless_HNil$();
        if ((x$2 === p2$2)) {
          return new $c_Lreactbuild_format_dxf_EXTMIN(point$macro$150)
        }
      };
      throw new $c_s_MatchError(x0$92)
    }));
    var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$2 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "point"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$36 = $m_s_$less$colon$less$();
    var ev$2 = this$36.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$2);
    var annotations$2 = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_Annotations$$anon$2(annotations$2);
    var t$2 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$152__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t$2);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$40);
    var this$55 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "INSBASE"));
    var witK = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var this$53 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$43 = $m_s_Symbol$();
    var labels$3 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "point")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
    var f$3 = new $c_sjsr_AnonFunction1(((x0$107$2) => {
      var x0$107 = $as_Lreactbuild_format_dxf_INSBASE(x0$107$2);
      if ((x0$107 !== null)) {
        var point$macro$171 = $n(x0$107).Lreactbuild_format_dxf_INSBASE__f_point;
        return new $c_Lshapeless_$colon$colon(point$macro$171, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$107)
      }
    }));
    var g$3 = new $c_sjsr_AnonFunction1(((x0$108$2) => {
      var x0$108 = $as_Lshapeless_$colon$colon(x0$108$2);
      if ((x0$108 !== null)) {
        var point$macro$170 = $as_Lreactbuild_format_dxf_Point3D($n(x0$108).Lshapeless_$colon$colon__f_head);
        var p2$3 = $as_Lshapeless_HNil($n(x0$108).Lshapeless_$colon$colon__f_tail);
        var x$3 = $m_Lshapeless_HNil$();
        if ((x$3 === p2$3)) {
          return new $c_Lreactbuild_format_dxf_INSBASE(point$macro$170)
        }
      };
      throw new $c_s_MatchError(x0$108)
    }));
    var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$3 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "point"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$49 = $m_s_$less$colon$less$();
    var ev$3 = this$49.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$3);
    var annotations$3 = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_Annotations$$anon$2(annotations$3);
    var t$3 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$172__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t$3);
    var decodeV = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$53);
    var this$54 = $m_Lreactbuild_format_dxf_CoproductDecoder$();
    var decodeR = new $c_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13(this$54);
    var decodeR$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12(this$55, witK, decodeV, decodeR);
    var decodeR$2 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12(this$56, witK$1, decodeV$1, decodeR$1);
    var decodeR$3 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12(this$57, witK$2, decodeV$2, decodeR$2);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$68 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12(this$58, witK$3, decodeV$3, decodeR$3);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$68
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$83$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseString__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$84__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$83 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$83
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$84$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$84 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$84
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$94$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((128 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$94 = $m_Lreactbuild_format_dxf_Point3D$().Lreactbuild_format_dxf_Point3D$__f_decoderPoint3D;
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$94
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$132$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$94__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$133__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$132 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$132
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$133$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$133 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$133
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$152$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((131072 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$94__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$153__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$152 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (131072 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$152
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$153$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((262144 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$153 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (262144 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$153
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$172$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((2097152 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$94__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$173__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$172 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (2097152 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$172
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$173$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((4194304 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$173 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = (4194304 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$173
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1() {
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$67 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$68 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$83 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$84 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$94 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$132 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$133 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$152 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$153 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$172 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$173 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.constructor = $c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype = $c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype;
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$67__Lreactbuild_format_dxf_Decoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$67$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$67)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$68__Lreactbuild_format_dxf_CoproductDecoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$68$lzycompute__Lreactbuild_format_dxf_CoproductDecoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$68)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$83__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$83$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$83)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$84__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$84$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$84)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$94__Lreactbuild_format_dxf_Decoder = (function() {
  return (((128 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$94$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$94)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$132__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((8192 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$132$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$132)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$133__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((16384 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$133$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$133)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$152__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((131072 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$152$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$152)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$153__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((262144 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$153$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$153)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$172__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((2097152 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$172$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$172)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.inst$macro$173__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((4194304 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__inst$macro$173$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1__f_inst$macro$173)
});
var $d_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1: 0
}, false, "reactbuild.format.dxf.Parameter$anon$lazy$macro$178$1", {
  Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1.prototype.$classData = $d_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$178$1;
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$23 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ACADVER"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "EXTMAX"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "EXTMIN"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "INSBASE")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_format_dxf_Parameter(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_format_dxf_ACADVER)) {
        var $$x4 = 0
      } else if ((p instanceof $c_Lreactbuild_format_dxf_EXTMAX)) {
        var $$x4 = 1
      } else if ((p instanceof $c_Lreactbuild_format_dxf_EXTMIN)) {
        var $$x4 = 2
      } else {
        if ((!(p instanceof $c_Lreactbuild_format_dxf_INSBASE))) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lshapeless_$colon$plus$colon(x$3$2);
      return $as_Lreactbuild_format_dxf_Parameter($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$3))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "INSBASE"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "EXTMIN"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "EXTMAX"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "ACADVER"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lreactbuild_format_dxf_CoproductEncoder()));
    var encodeA = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$12(this$23, encodeA, gen$1);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$2$lzycompute__Lreactbuild_format_dxf_CoproductEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$58 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    $m_Lshapeless_Witness$();
    var this$1 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ACADVER"));
    var witK$3 = new $c_Lshapeless_Witness$$anon$1(value0);
    var this$14 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "version")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_ACADVER(x0$3$2);
      if ((x0$3 !== null)) {
        var version$macro$6 = $n(x0$3).Lreactbuild_format_dxf_ACADVER__f_version;
        return new $c_Lshapeless_$colon$colon(version$macro$6, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var version$macro$5 = $as_T($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_ACADVER(version$macro$5)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "version"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$10 = $m_s_$less$colon$less$();
    var ev = this$10.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(1)), $m_Lshapeless_HNil$())));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$7__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var encodeV$3 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$14, encoder, gen$1, annots);
    var this$57 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "EXTMAX"));
    var witK$2 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var this$27 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "point")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var f$1 = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_format_dxf_EXTMAX(x0$11$2);
      if ((x0$11 !== null)) {
        var point$macro$16 = $n(x0$11).Lreactbuild_format_dxf_EXTMAX__f_point;
        return new $c_Lshapeless_$colon$colon(point$macro$16, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g$1 = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
      if ((x0$12 !== null)) {
        var point$macro$15 = $as_Lreactbuild_format_dxf_Point3D($n(x0$12).Lshapeless_$colon$colon__f_head);
        var p2$1 = $as_Lshapeless_HNil($n(x0$12).Lshapeless_$colon$colon__f_tail);
        var x$1 = $m_Lshapeless_HNil$();
        if ((x$1 === p2$1)) {
          return new $c_Lreactbuild_format_dxf_EXTMAX(point$macro$15)
        }
      };
      throw new $c_s_MatchError(x0$12)
    }));
    var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$1 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "point"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$23 = $m_s_$less$colon$less$();
    var ev$1 = this$23.s_$less$colon$less$__f_singleton;
    var gen$3 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$1);
    var annotations$1 = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var annots$1 = new $c_Lshapeless_Annotations$$anon$2(annotations$1);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$17__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder$1 = new $c_Lshapeless_Lazy$$anon$1(t$1);
    var encodeV$2 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$27, encoder$1, gen$3, annots$1);
    var this$56 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    $m_Lshapeless_Witness$();
    var this$28 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "EXTMIN"));
    var witK$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var this$40 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$30 = $m_s_Symbol$();
    var labels$2 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "point")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
    var f$2 = new $c_sjsr_AnonFunction1(((x0$27$2) => {
      var x0$27 = $as_Lreactbuild_format_dxf_EXTMIN(x0$27$2);
      if ((x0$27 !== null)) {
        var point$macro$52 = $n(x0$27).Lreactbuild_format_dxf_EXTMIN__f_point;
        return new $c_Lshapeless_$colon$colon(point$macro$52, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$27)
      }
    }));
    var g$2 = new $c_sjsr_AnonFunction1(((x0$28$2) => {
      var x0$28 = $as_Lshapeless_$colon$colon(x0$28$2);
      if ((x0$28 !== null)) {
        var point$macro$51 = $as_Lreactbuild_format_dxf_Point3D($n(x0$28).Lshapeless_$colon$colon__f_head);
        var p2$2 = $as_Lshapeless_HNil($n(x0$28).Lshapeless_$colon$colon__f_tail);
        var x$2 = $m_Lshapeless_HNil$();
        if ((x$2 === p2$2)) {
          return new $c_Lreactbuild_format_dxf_EXTMIN(point$macro$51)
        }
      };
      throw new $c_s_MatchError(x0$28)
    }));
    var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$2 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "point"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$36 = $m_s_$less$colon$less$();
    var ev$2 = this$36.s_$less$colon$less$__f_singleton;
    var gen$5 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$2);
    var annotations$2 = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var annots$2 = new $c_Lshapeless_Annotations$$anon$2(annotations$2);
    var t$2 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$17__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder$2 = new $c_Lshapeless_Lazy$$anon$1(t$2);
    var encodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$40, encoder$2, gen$5, annots$2);
    var this$55 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "INSBASE"));
    var witK = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var this$53 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$43 = $m_s_Symbol$();
    var labels$3 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "point")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
    var f$3 = new $c_sjsr_AnonFunction1(((x0$35$2) => {
      var x0$35 = $as_Lreactbuild_format_dxf_INSBASE(x0$35$2);
      if ((x0$35 !== null)) {
        var point$macro$60 = $n(x0$35).Lreactbuild_format_dxf_INSBASE__f_point;
        return new $c_Lshapeless_$colon$colon(point$macro$60, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$35)
      }
    }));
    var g$3 = new $c_sjsr_AnonFunction1(((x0$36$2) => {
      var x0$36 = $as_Lshapeless_$colon$colon(x0$36$2);
      if ((x0$36 !== null)) {
        var point$macro$59 = $as_Lreactbuild_format_dxf_Point3D($n(x0$36).Lshapeless_$colon$colon__f_head);
        var p2$3 = $as_Lshapeless_HNil($n(x0$36).Lshapeless_$colon$colon__f_tail);
        var x$3 = $m_Lshapeless_HNil$();
        if ((x$3 === p2$3)) {
          return new $c_Lreactbuild_format_dxf_INSBASE(point$macro$59)
        }
      };
      throw new $c_s_MatchError(x0$36)
    }));
    var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$3 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "point"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$49 = $m_s_$less$colon$less$();
    var ev$3 = this$49.s_$less$colon$less$__f_singleton;
    var gen$7 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$3);
    var annotations$3 = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var annots$3 = new $c_Lshapeless_Annotations$$anon$2(annotations$3);
    var t$3 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$17__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder$3 = new $c_Lshapeless_Lazy$$anon$1(t$3);
    var encodeV = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$53, encoder$3, gen$7, annots$3);
    var this$54 = $m_Lreactbuild_format_dxf_CoproductEncoder$();
    var encodeR = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10(this$54);
    var config = $m_Lreactbuild_format_dxf_Parameter$().Lreactbuild_format_dxf_Parameter$__f_config;
    var encodeR$1 = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11(this$55, witK, encodeV, config, encodeR);
    var config$1 = $m_Lreactbuild_format_dxf_Parameter$().Lreactbuild_format_dxf_Parameter$__f_config;
    var encodeR$2 = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11(this$56, witK$1, encodeV$1, config$1, encodeR$1);
    var config$2 = $m_Lreactbuild_format_dxf_Parameter$().Lreactbuild_format_dxf_Parameter$__f_config;
    var encodeR$3 = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11(this$57, witK$2, encodeV$2, config$2, encodeR$2);
    var config$3 = $m_Lreactbuild_format_dxf_Parameter$().Lreactbuild_format_dxf_Parameter$__f_config;
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$2 = new $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11(this$58, witK$3, encodeV$3, config$3, encodeR$3);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$2
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$7$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeString__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$8__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$7 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$7
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$8$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$8 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$8
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$17$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$22 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var this$20 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "z")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_format_dxf_Point3D(x0$15$2);
      if ((x0$15 !== null)) {
        var x$macro$27 = $n(x0$15).Lreactbuild_format_dxf_Point3D__f_x;
        var y$macro$28 = $n(x0$15).Lreactbuild_format_dxf_Point3D__f_y;
        var z$macro$29 = $n(x0$15).Lreactbuild_format_dxf_Point3D__f_z;
        return new $c_Lshapeless_$colon$colon(x$macro$27, new $c_Lshapeless_$colon$colon(y$macro$28, new $c_Lshapeless_$colon$colon(z$macro$29, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var x$macro$24 = $uD($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$25 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var z$macro$26 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_format_dxf_Point3D(x$macro$24, y$macro$25, z$macro$26)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "z"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(10)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(20)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(30)), $m_Lshapeless_HNil$())))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$30__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var encodeV = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$20, encoder, gen$1, annots);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$8__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$17 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$22, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$17
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$30$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$31__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$30 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$30
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$31$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$32__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$31 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$31
}
function $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$32$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((128 & $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$8__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$32 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0 = (((128 | $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$32
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1() {
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$2 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$7 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$8 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$17 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$30 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$31 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$32 = null;
  this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.constructor = $c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype = $c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype;
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.inst$macro$2__Lreactbuild_format_dxf_CoproductEncoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$2$lzycompute__Lreactbuild_format_dxf_CoproductEncoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$2)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.inst$macro$7__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$7$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$7)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.inst$macro$8__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((8 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$8$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$8)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.inst$macro$17__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((16 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$17$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$17)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.inst$macro$30__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((32 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$30$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$30)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.inst$macro$31__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((64 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$31$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$31)
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.inst$macro$32__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((128 & this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__inst$macro$32$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1__f_inst$macro$32)
});
var $d_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1: 0
}, false, "reactbuild.format.dxf.Parameter$anon$lazy$macro$65$1", {
  Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1.prototype.$classData = $d_Lreactbuild_format_dxf_Parameter$anon$lazy$macro$65$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Parser$$anon$1(outer, f$1) {
  if ((outer === null)) {
    $n(null)
  }
}
$c_Lreactbuild_format_dxf_Parser$$anon$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Parser$$anon$1.prototype.constructor = $c_Lreactbuild_format_dxf_Parser$$anon$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Parser$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Parser$$anon$1.prototype = $c_Lreactbuild_format_dxf_Parser$$anon$1.prototype;
var $d_Lreactbuild_format_dxf_Parser$$anon$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Parser$$anon$1: 0
}, false, "reactbuild.format.dxf.Parser$$anon$1", {
  Lreactbuild_format_dxf_Parser$$anon$1: 1,
  O: 1,
  Lreactbuild_format_dxf_Parser: 1
});
$c_Lreactbuild_format_dxf_Parser$$anon$1.prototype.$classData = $d_Lreactbuild_format_dxf_Parser$$anon$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Parser$$anon$2(f$2) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Parser$$anon$2.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Parser$$anon$2.prototype.constructor = $c_Lreactbuild_format_dxf_Parser$$anon$2;
/** @constructor */
function $h_Lreactbuild_format_dxf_Parser$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Parser$$anon$2.prototype = $c_Lreactbuild_format_dxf_Parser$$anon$2.prototype;
var $d_Lreactbuild_format_dxf_Parser$$anon$2 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Parser$$anon$2: 0
}, false, "reactbuild.format.dxf.Parser$$anon$2", {
  Lreactbuild_format_dxf_Parser$$anon$2: 1,
  O: 1,
  Lreactbuild_format_dxf_Parser: 1
});
$c_Lreactbuild_format_dxf_Parser$$anon$2.prototype.$classData = $d_Lreactbuild_format_dxf_Parser$$anon$2;
/** @constructor */
function $c_Lreactbuild_format_dxf_Parser$$anon$3() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Parser$$anon$3.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Parser$$anon$3.prototype.constructor = $c_Lreactbuild_format_dxf_Parser$$anon$3;
/** @constructor */
function $h_Lreactbuild_format_dxf_Parser$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Parser$$anon$3.prototype = $c_Lreactbuild_format_dxf_Parser$$anon$3.prototype;
var $d_Lreactbuild_format_dxf_Parser$$anon$3 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Parser$$anon$3: 0
}, false, "reactbuild.format.dxf.Parser$$anon$3", {
  Lreactbuild_format_dxf_Parser$$anon$3: 1,
  O: 1,
  Lreactbuild_format_dxf_Parser: 1
});
$c_Lreactbuild_format_dxf_Parser$$anon$3.prototype.$classData = $d_Lreactbuild_format_dxf_Parser$$anon$3;
/** @constructor */
function $c_Lreactbuild_format_dxf_Point3D$() {
  this.Lreactbuild_format_dxf_Point3D$__f_decoderPoint3D = null;
  $n_Lreactbuild_format_dxf_Point3D$ = this;
  new $c_Lreactbuild_format_dxf_Point3D(0.0, 0.0, 0.0);
  var inst$macro$31 = new $c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1().inst$macro$1__Lreactbuild_format_dxf_Decoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$31));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Point3D$__f_decoderPoint3D = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Point3D$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Point3D$.prototype.constructor = $c_Lreactbuild_format_dxf_Point3D$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Point3D$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Point3D$.prototype = $c_Lreactbuild_format_dxf_Point3D$.prototype;
var $d_Lreactbuild_format_dxf_Point3D$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Point3D$: 0
}, false, "reactbuild.format.dxf.Point3D$", {
  Lreactbuild_format_dxf_Point3D$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Point3D$.prototype.$classData = $d_Lreactbuild_format_dxf_Point3D$;
var $n_Lreactbuild_format_dxf_Point3D$;
function $m_Lreactbuild_format_dxf_Point3D$() {
  if ((!$n_Lreactbuild_format_dxf_Point3D$)) {
    $n_Lreactbuild_format_dxf_Point3D$ = new $c_Lreactbuild_format_dxf_Point3D$()
  };
  return $n_Lreactbuild_format_dxf_Point3D$
}
function $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$20 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "z")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Point3D(x0$3$2);
      if ((x0$3 !== null)) {
        var x$macro$11 = $n(x0$3).Lreactbuild_format_dxf_Point3D__f_x;
        var y$macro$12 = $n(x0$3).Lreactbuild_format_dxf_Point3D__f_y;
        var z$macro$13 = $n(x0$3).Lreactbuild_format_dxf_Point3D__f_z;
        return new $c_Lshapeless_$colon$colon(x$macro$11, new $c_Lshapeless_$colon$colon(y$macro$12, new $c_Lshapeless_$colon$colon(z$macro$13, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var x$macro$8 = $uD($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$9 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var z$macro$10 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_format_dxf_Point3D(x$macro$8, y$macro$9, z$macro$10)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "z"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(10)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(20)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(30)), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$20);
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$14$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$14 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$14
}
function $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$15$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$16__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$15 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$15
}
function $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$16$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$17__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$16 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$16
}
function $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$17$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$17 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$17
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1() {
  this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$14 = null;
  this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$15 = null;
  this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$16 = null;
  this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$17 = null;
  this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype.constructor = $c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype = $c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype;
$c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype.inst$macro$14__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$14$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$14)
});
$c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype.inst$macro$15__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$15$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$15)
});
$c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype.inst$macro$16__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((8 & this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$16$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$16)
});
$c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype.inst$macro$17__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((16 & this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__inst$macro$17$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1__f_inst$macro$17)
});
var $d_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1: 0
}, false, "reactbuild.format.dxf.Point3D$anon$lazy$macro$30$1", {
  Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1.prototype.$classData = $d_Lreactbuild_format_dxf_Point3D$anon$lazy$macro$30$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_RecordCursor$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_RecordCursor$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_RecordCursor$.prototype.constructor = $c_Lreactbuild_format_dxf_RecordCursor$;
/** @constructor */
function $h_Lreactbuild_format_dxf_RecordCursor$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_RecordCursor$.prototype = $c_Lreactbuild_format_dxf_RecordCursor$.prototype;
$c_Lreactbuild_format_dxf_RecordCursor$.prototype.arrayFromText__T__ALreactbuild_format_dxf_Record = (function(text) {
  var this$1 = $n(text);
  var lines = $f_T__split__T__I__AT(this$1, "\n", 0);
  $m_sc_ArrayOps$();
  var x$2 = 1;
  var this$7 = $n($m_sc_ArrayOps$().sliding$extension__O__I__I__sc_Iterator(lines, 2, x$2));
  var f = new $c_sjsr_AnonFunction1(((arr$2) => {
    var arr = $asArrayOf_T(arr$2, 1);
    $m_sc_StringOps$();
    var x = $n(arr).get(0);
    var this$6 = $m_jl_Integer$();
    return new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(this$6.parseInt__T__I__I(x, 10)), $n(arr).get(1))
  }));
  var this$9 = new $c_sc_Iterator$$anon$9(this$7, f);
  if ((this$9.knownSize__I() >= 0)) {
    var len = this$9.knownSize__I();
    var destination = new ($d_Lreactbuild_format_dxf_Record.getArrayOf().constr)(len);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$9, destination, 0, 2147483647);
    return destination
  } else {
    var capacity = 0;
    var jsElems = null;
    capacity = 0;
    jsElems = [];
    while (this$9.hasNext__Z()) {
      var elem = this$9.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    return new ($d_Lreactbuild_format_dxf_Record.getArrayOf().constr)(jsElems)
  }
});
$c_Lreactbuild_format_dxf_RecordCursor$.prototype.fromText__T__Lreactbuild_format_dxf_RecordCursor = (function(text) {
  return new $c_Lreactbuild_format_dxf_RecordCursor(0, this.arrayFromText__T__ALreactbuild_format_dxf_Record(text))
});
var $d_Lreactbuild_format_dxf_RecordCursor$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_RecordCursor$: 0
}, false, "reactbuild.format.dxf.RecordCursor$", {
  Lreactbuild_format_dxf_RecordCursor$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_RecordCursor$.prototype.$classData = $d_Lreactbuild_format_dxf_RecordCursor$;
var $n_Lreactbuild_format_dxf_RecordCursor$;
function $m_Lreactbuild_format_dxf_RecordCursor$() {
  if ((!$n_Lreactbuild_format_dxf_RecordCursor$)) {
    $n_Lreactbuild_format_dxf_RecordCursor$ = new $c_Lreactbuild_format_dxf_RecordCursor$()
  };
  return $n_Lreactbuild_format_dxf_RecordCursor$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Section$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Section$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Section$.prototype.constructor = $c_Lreactbuild_format_dxf_Section$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Section$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Section$.prototype = $c_Lreactbuild_format_dxf_Section$.prototype;
$c_Lreactbuild_format_dxf_Section$.prototype.encodeSection__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder = (function(ct, encodeT) {
  var this$2 = $n(encodeT);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_format_dxf_Section(x$1$2);
    return $n(x$1).Lreactbuild_format_dxf_Section__f_content
  }));
  var qual$1 = new $c_Lreactbuild_format_dxf_Encoder$$anon$2(this$2, f);
  var x$1$3 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    $as_Lreactbuild_format_dxf_Section(x$2$2);
    $n($m_s_package$().s_package$__f_List);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "SECTION");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$3 = $n($n($n(ct).runtimeClass__jl_Class()).getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$3.toUpperCase()))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  }));
  $n($m_s_package$().s_package$__f_List);
  var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDSEC")];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var x$2$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  return new $c_Lreactbuild_format_dxf_Encoder$$anon$1(qual$1, false, x$1$3, x$2$3)
});
var $d_Lreactbuild_format_dxf_Section$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Section$: 0
}, false, "reactbuild.format.dxf.Section$", {
  Lreactbuild_format_dxf_Section$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Section$.prototype.$classData = $d_Lreactbuild_format_dxf_Section$;
var $n_Lreactbuild_format_dxf_Section$;
function $m_Lreactbuild_format_dxf_Section$() {
  if ((!$n_Lreactbuild_format_dxf_Section$)) {
    $n_Lreactbuild_format_dxf_Section$ = new $c_Lreactbuild_format_dxf_Section$()
  };
  return $n_Lreactbuild_format_dxf_Section$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_SectionList$() {
  this.Lreactbuild_format_dxf_SectionList$__f_encodeSectionList = null;
  this.Lreactbuild_format_dxf_SectionList$__f_decodeSectionList = null;
  $n_Lreactbuild_format_dxf_SectionList$ = this;
  var inst$macro$1276 = new $c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$1276));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_SectionList$__f_encodeSectionList = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$2896 = new $c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1().inst$macro$1277__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$2896));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_SectionList$__f_decodeSectionList = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_SectionList$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_SectionList$.prototype.constructor = $c_Lreactbuild_format_dxf_SectionList$;
/** @constructor */
function $h_Lreactbuild_format_dxf_SectionList$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_SectionList$.prototype = $c_Lreactbuild_format_dxf_SectionList$.prototype;
var $d_Lreactbuild_format_dxf_SectionList$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_SectionList$: 0
}, false, "reactbuild.format.dxf.SectionList$", {
  Lreactbuild_format_dxf_SectionList$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_SectionList$.prototype.$classData = $d_Lreactbuild_format_dxf_SectionList$;
var $n_Lreactbuild_format_dxf_SectionList$;
function $m_Lreactbuild_format_dxf_SectionList$() {
  if ((!$n_Lreactbuild_format_dxf_SectionList$)) {
    $n_Lreactbuild_format_dxf_SectionList$ = new $c_Lreactbuild_format_dxf_SectionList$()
  };
  return $n_Lreactbuild_format_dxf_SectionList$
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$36 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "headers"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "classes"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "tables"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "blocks"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "entities"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "objects"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "thumbnailImage")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_SectionList(x0$3$2);
      if ((x0$3 !== null)) {
        var headers$macro$23 = $n(x0$3).Lreactbuild_format_dxf_SectionList__f_headers;
        var classes$macro$24 = $n(x0$3).Lreactbuild_format_dxf_SectionList__f_classes;
        var tables$macro$25 = $n(x0$3).Lreactbuild_format_dxf_SectionList__f_tables;
        var blocks$macro$26 = $n(x0$3).Lreactbuild_format_dxf_SectionList__f_blocks;
        var entities$macro$27 = $n(x0$3).Lreactbuild_format_dxf_SectionList__f_entities;
        var objects$macro$28 = $n(x0$3).Lreactbuild_format_dxf_SectionList__f_objects;
        var thumbnailImage$macro$29 = $n(x0$3).Lreactbuild_format_dxf_SectionList__f_thumbnailImage;
        return new $c_Lshapeless_$colon$colon(headers$macro$23, new $c_Lshapeless_$colon$colon(classes$macro$24, new $c_Lshapeless_$colon$colon(tables$macro$25, new $c_Lshapeless_$colon$colon(blocks$macro$26, new $c_Lshapeless_$colon$colon(entities$macro$27, new $c_Lshapeless_$colon$colon(objects$macro$28, new $c_Lshapeless_$colon$colon(thumbnailImage$macro$29, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var headers$macro$16 = $as_Lreactbuild_format_dxf_Section($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var classes$macro$17 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var tables$macro$18 = $as_Lreactbuild_format_dxf_Section($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var blocks$macro$19 = $as_Lreactbuild_format_dxf_Section($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var entities$macro$20 = $as_Lreactbuild_format_dxf_Section($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var objects$macro$21 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var thumbnailImage$macro$22 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_format_dxf_SectionList(headers$macro$16, classes$macro$17, tables$macro$18, blocks$macro$19, entities$macro$20, objects$macro$21, thumbnailImage$macro$22)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "thumbnailImage"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "objects"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "entities"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "blocks"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "tables"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "classes"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "headers"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$30__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$36, encoder, gen$1, annots);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$30$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encodeV = $m_Lreactbuild_format_dxf_Section$().encodeSection__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_Header.getClassOf()), $m_Lreactbuild_format_dxf_Header$().Lreactbuild_format_dxf_Header$__f_encodeHeaderSection);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$120__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$30 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$30
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$47$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$47 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
    var lo$1 = (64 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$47
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$120$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$5 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encoderA = $m_Lreactbuild_format_dxf_Section$().encodeSection__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_Classes.getClassOf()), $m_Lreactbuild_format_dxf_Classes$().Lreactbuild_format_dxf_Classes$__f_encodeClassesSection);
    var encodeV = new $c_Lreactbuild_format_dxf_Encoder$$anon$15(encoderA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$130__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$120 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$5, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
    var lo$1 = (2048 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$120
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$130$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (8192 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encodeV = $m_Lreactbuild_format_dxf_Section$().encodeSection__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_Tables.getClassOf()), $m_Lreactbuild_format_dxf_Tables$().Lreactbuild_format_dxf_Tables$__f_encodeTablesSection);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$668__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$130 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
    var lo$1 = (8192 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$130
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$668$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encodeV = $m_Lreactbuild_format_dxf_Section$().encodeSection__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_Blocks.getClassOf()), $m_Lreactbuild_format_dxf_Blocks$().Lreactbuild_format_dxf_Blocks$__f_encodeBlocksSection);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1200__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$668 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (8192 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$668
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$1200$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1;
  var lo = (8388608 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encodeV = $m_Lreactbuild_format_dxf_Section$().encodeSection__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_Entities.getClassOf()), $m_Lreactbuild_format_dxf_Entities$().Lreactbuild_format_dxf_Entities$__f_encodeEntitiesSection);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1227__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1200 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1;
    var lo$1 = (8388608 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1200
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$1227$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1;
  var lo = (67108864 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$5 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encoderA = $m_Lreactbuild_format_dxf_Section$().encodeSection__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_Objects.getClassOf()), $m_Lreactbuild_format_dxf_Objects$().Lreactbuild_format_dxf_Objects$__f_encodeObjectsSection);
    var encodeV = new $c_Lreactbuild_format_dxf_Encoder$$anon$15(encoderA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1237__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1227 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$5, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1;
    var lo$1 = (67108864 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1227
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$1237$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1;
  var lo = (268435456 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$5 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encoderA = $m_Lreactbuild_format_dxf_Section$().encodeSection__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_ThumbnailImage.getClassOf()), $m_Lreactbuild_format_dxf_ThumbnailImage$().Lreactbuild_format_dxf_ThumbnailImage$__f_encodeThumbnailImageSection);
    var encodeV = new $c_Lreactbuild_format_dxf_Encoder$$anon$15(encoderA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$47__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1237 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$5, encodeV, encodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1;
    var lo$1 = (268435456 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1237
}
/** @constructor */
function $c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1() {
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$30 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$47 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$120 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$130 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$668 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1200 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1227 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1237 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0 = $L0;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1 = $L0
}
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.constructor = $c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype = $c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype;
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.inst$macro$30__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$30$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$30
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.inst$macro$47__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$47$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$47
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.inst$macro$120__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$120$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$120
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.inst$macro$130__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var lo = (8192 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$130$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$130
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.inst$macro$668__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$0;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$668$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$668
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.inst$macro$1200__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1;
  var lo = (8388608 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$1200$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1200
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.inst$macro$1227__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1;
  var lo = (67108864 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$1227$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1227
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.inst$macro$1237__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_bitmap$1;
  var lo = (268435456 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__inst$macro$1237$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1__f_inst$macro$1237
  }
});
var $d_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1: 0
}, false, "reactbuild.format.dxf.SectionList$anon$lazy$macro$1275$1", {
  Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1.prototype.$classData = $d_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$1275$1;
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1277$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$36 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "headers"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "classes"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "tables"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "blocks"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "entities"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "objects"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "thumbnailImage")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$473$2) => {
      var x0$473 = $as_Lreactbuild_format_dxf_SectionList(x0$473$2);
      if ((x0$473 !== null)) {
        var headers$macro$1299 = $n(x0$473).Lreactbuild_format_dxf_SectionList__f_headers;
        var classes$macro$1300 = $n(x0$473).Lreactbuild_format_dxf_SectionList__f_classes;
        var tables$macro$1301 = $n(x0$473).Lreactbuild_format_dxf_SectionList__f_tables;
        var blocks$macro$1302 = $n(x0$473).Lreactbuild_format_dxf_SectionList__f_blocks;
        var entities$macro$1303 = $n(x0$473).Lreactbuild_format_dxf_SectionList__f_entities;
        var objects$macro$1304 = $n(x0$473).Lreactbuild_format_dxf_SectionList__f_objects;
        var thumbnailImage$macro$1305 = $n(x0$473).Lreactbuild_format_dxf_SectionList__f_thumbnailImage;
        return new $c_Lshapeless_$colon$colon(headers$macro$1299, new $c_Lshapeless_$colon$colon(classes$macro$1300, new $c_Lshapeless_$colon$colon(tables$macro$1301, new $c_Lshapeless_$colon$colon(blocks$macro$1302, new $c_Lshapeless_$colon$colon(entities$macro$1303, new $c_Lshapeless_$colon$colon(objects$macro$1304, new $c_Lshapeless_$colon$colon(thumbnailImage$macro$1305, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$473)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$474$2) => {
      var x0$474 = $as_Lshapeless_$colon$colon(x0$474$2);
      if ((x0$474 !== null)) {
        var headers$macro$1292 = $as_Lreactbuild_format_dxf_Section($n(x0$474).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$474).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var classes$macro$1293 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var tables$macro$1294 = $as_Lreactbuild_format_dxf_Section($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var blocks$macro$1295 = $as_Lreactbuild_format_dxf_Section($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var entities$macro$1296 = $as_Lreactbuild_format_dxf_Section($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var objects$macro$1297 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var thumbnailImage$macro$1298 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_format_dxf_SectionList(headers$macro$1292, classes$macro$1293, tables$macro$1294, blocks$macro$1295, entities$macro$1296, objects$macro$1297, thumbnailImage$macro$1298)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$474)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "thumbnailImage"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "objects"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "entities"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "blocks"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "tables"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "classes"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "headers"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1306__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1277 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$36);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1277
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1306$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1307__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1450__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1306 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1306
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1307$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_Header$().Lreactbuild_format_dxf_Header$__f_decodeHeaderSection;
    var this$3 = $n(decodeT);
    var f = new $c_sjsr_AnonFunction1(((x$3$2) => new $c_Lreactbuild_format_dxf_Section(x$3$2)));
    var this$8 = new $c_Lreactbuild_format_dxf_Decoder$$anon$1(this$3, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "SECTION");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$4 = $n($d_Lreactbuild_format_dxf_Header.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$4.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$12 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$8, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDSEC")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1307 = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$12, suffix);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
    var lo$1 = (4 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1307
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1450$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var hi = (2 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1451__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1465__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1450 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (2 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1450
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1451$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var hi = (4 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_Classes$().Lreactbuild_format_dxf_Classes$__f_decodeClassesSection;
    var this$3 = $n(decodeT);
    var f = new $c_sjsr_AnonFunction1(((x$3$2) => new $c_Lreactbuild_format_dxf_Section(x$3$2)));
    var this$8 = new $c_Lreactbuild_format_dxf_Decoder$$anon$1(this$3, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "SECTION");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$4 = $n($d_Lreactbuild_format_dxf_Classes.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$4.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$12 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$8, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDSEC")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var decodeA = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$12, suffix);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1451 = new $c_Lreactbuild_format_dxf_Decoder$$anon$18(decodeA);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (4 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1451
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1465$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var hi = (256 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1466__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2116__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1465 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (256 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1465
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1466$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var hi = (512 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_Tables$().Lreactbuild_format_dxf_Tables$__f_decodeTablesSection;
    var this$3 = $n(decodeT);
    var f = new $c_sjsr_AnonFunction1(((x$3$2) => new $c_Lreactbuild_format_dxf_Section(x$3$2)));
    var this$8 = new $c_Lreactbuild_format_dxf_Decoder$$anon$1(this$3, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "SECTION");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$4 = $n($d_Lreactbuild_format_dxf_Tables.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$4.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$12 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$8, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDSEC")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1466 = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$12, suffix);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (512 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1466
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2116$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$1;
  var hi = ((-2147483648) & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2117__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2803__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2116 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$1;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = ((-2147483648) | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$1 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2116
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2117$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$2;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_Blocks$().Lreactbuild_format_dxf_Blocks$__f_decodeBlocksSection;
    var this$3 = $n(decodeT);
    var f = new $c_sjsr_AnonFunction1(((x$3$2) => new $c_Lreactbuild_format_dxf_Section(x$3$2)));
    var this$8 = new $c_Lreactbuild_format_dxf_Decoder$$anon$1(this$3, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "SECTION");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$4 = $n($d_Lreactbuild_format_dxf_Blocks.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$4.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$12 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$8, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDSEC")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2117 = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$12, suffix);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$2;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$2 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2117
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2803$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var lo = (4194304 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2804__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2836__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2803 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
    var lo$1 = (4194304 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2803
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2804$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var lo = (8388608 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_Entities$().Lreactbuild_format_dxf_Entities$__f_decodeEntitiesSection;
    var this$3 = $n(decodeT);
    var f = new $c_sjsr_AnonFunction1(((x$3$2) => new $c_Lreactbuild_format_dxf_Section(x$3$2)));
    var this$8 = new $c_Lreactbuild_format_dxf_Decoder$$anon$1(this$3, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "SECTION");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$4 = $n($d_Lreactbuild_format_dxf_Entities.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$4.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$12 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$8, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDSEC")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2804 = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$12, suffix);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
    var lo$1 = (8388608 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2804
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2836$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var lo = ((-2147483648) & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2837__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2851__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2836 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
    var lo$1 = ((-2147483648) | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2836
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2837$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var hi = (1 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_Objects$().Lreactbuild_format_dxf_Objects$__f_decodeObjectsSection;
    var this$3 = $n(decodeT);
    var f = new $c_sjsr_AnonFunction1(((x$3$2) => new $c_Lreactbuild_format_dxf_Section(x$3$2)));
    var this$8 = new $c_Lreactbuild_format_dxf_Decoder$$anon$1(this$3, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "SECTION");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$4 = $n($d_Lreactbuild_format_dxf_Objects.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$4.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$12 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$8, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDSEC")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var decodeA = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$12, suffix);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2837 = new $c_Lreactbuild_format_dxf_Decoder$$anon$18(decodeA);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (1 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2837
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2851$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var hi = (64 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2852__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2866__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2851 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (64 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2851
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2852$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var hi = (128 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_ThumbnailImage$().Lreactbuild_format_dxf_ThumbnailImage$__f_decodeThumbnailImageSection;
    var this$3 = $n(decodeT);
    var f = new $c_sjsr_AnonFunction1(((x$3$2) => new $c_Lreactbuild_format_dxf_Section(x$3$2)));
    var this$8 = new $c_Lreactbuild_format_dxf_Decoder$$anon$1(this$3, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "SECTION");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$4 = $n($d_Lreactbuild_format_dxf_ThumbnailImage.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$4.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$12 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$8, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDSEC")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var decodeA = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$12, suffix);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2852 = new $c_Lreactbuild_format_dxf_Decoder$$anon$18(decodeA);
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (128 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2852
}
function $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2866$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2866 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    var b$1 = $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (8192 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2866
}
/** @constructor */
function $c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1() {
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1277 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1306 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1307 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1450 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1451 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1465 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1466 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2116 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2117 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2803 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2804 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2836 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2837 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2851 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2852 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2866 = null;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0 = $L0;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$1 = $L0;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$2 = $L0;
  this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3 = $L0
}
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.constructor = $c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype = $c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype;
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$1277__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1277$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1277
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$1306__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1306$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1306
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$1307__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1307$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1307
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$1450__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var hi = (2 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1450$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1450
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$1451__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var hi = (4 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1451$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1451
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$1465__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var hi = (256 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1465$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1465
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$1466__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$0;
  var hi = (512 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$1466$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$1466
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$2116__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$1;
  var hi = ((-2147483648) & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2116$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2116
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$2117__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$2;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2117$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2117
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$2803__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var lo = (4194304 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2803$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2803
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$2804__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var lo = (8388608 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2804$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2804
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$2836__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var lo = ((-2147483648) & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2836$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2836
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$2837__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var hi = (1 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2837$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2837
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$2851__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var hi = (64 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2851$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2851
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$2852__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var hi = (128 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2852$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2852
  }
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.inst$macro$2866__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_bitmap$3;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__inst$macro$2866$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1__f_inst$macro$2866
  }
});
var $d_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1: 0
}, false, "reactbuild.format.dxf.SectionList$anon$lazy$macro$2895$1", {
  Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1.prototype.$classData = $d_Lreactbuild_format_dxf_SectionList$anon$lazy$macro$2895$1;
function $ct_Lreactbuild_format_dxf_SeqDecoder__Lreactbuild_format_dxf_Decoder__($thiz, decodeA) {
  $thiz.Lreactbuild_format_dxf_SeqDecoder__f_decodeA = decodeA;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_format_dxf_SeqDecoder() {
  this.Lreactbuild_format_dxf_SeqDecoder__f_decodeA = null
}
$c_Lreactbuild_format_dxf_SeqDecoder.prototype = new $h_O();
$c_Lreactbuild_format_dxf_SeqDecoder.prototype.constructor = $c_Lreactbuild_format_dxf_SeqDecoder;
/** @constructor */
function $h_Lreactbuild_format_dxf_SeqDecoder() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_SeqDecoder.prototype = $c_Lreactbuild_format_dxf_SeqDecoder.prototype;
$c_Lreactbuild_format_dxf_SeqDecoder.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(c) {
  var current = c;
  $n($m_s_package$().s_package$__f_List);
  var builder = new $c_scm_ListBuffer();
  var failed = null;
  while (((failed === null) && $n(current).succeeded__Z())) {
    var x1 = $n(this.Lreactbuild_format_dxf_SeqDecoder__f_decodeA).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either(current);
    matchEnd6: {
      if ((x1 instanceof $c_s_util_Left)) {
        var x2 = $as_s_util_Left(x1);
        var e = $as_jl_Throwable($n(x2).s_util_Left__f_value);
        failed = e;
        break matchEnd6
      };
      if ((x1 instanceof $c_s_util_Right)) {
        var x3 = $as_s_util_Right(x1);
        var p4 = $as_Lreactbuild_format_dxf_CursorResult($n(x3).s_util_Right__f_value);
        if ((p4 !== null)) {
          var a = $n(p4).Lreactbuild_format_dxf_CursorResult__f_value;
          var c$2 = $n(p4).Lreactbuild_format_dxf_CursorResult__f_c;
          builder.addOne__O__scm_ListBuffer(a);
          current = c$2;
          break matchEnd6
        }
      };
      throw new $c_s_MatchError(x1)
    }
  };
  return new $c_s_util_Right(new $c_Lreactbuild_format_dxf_CursorResult(builder.toList__sci_List(), current))
});
/** @constructor */
function $c_Lreactbuild_format_dxf_Serializer$$anon$1(f$1) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Serializer$$anon$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Serializer$$anon$1.prototype.constructor = $c_Lreactbuild_format_dxf_Serializer$$anon$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Serializer$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Serializer$$anon$1.prototype = $c_Lreactbuild_format_dxf_Serializer$$anon$1.prototype;
var $d_Lreactbuild_format_dxf_Serializer$$anon$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Serializer$$anon$1: 0
}, false, "reactbuild.format.dxf.Serializer$$anon$1", {
  Lreactbuild_format_dxf_Serializer$$anon$1: 1,
  O: 1,
  Lreactbuild_format_dxf_Serializer: 1
});
$c_Lreactbuild_format_dxf_Serializer$$anon$1.prototype.$classData = $d_Lreactbuild_format_dxf_Serializer$$anon$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Serializer$$anon$2(serializeB$1, f$2) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Serializer$$anon$2.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Serializer$$anon$2.prototype.constructor = $c_Lreactbuild_format_dxf_Serializer$$anon$2;
/** @constructor */
function $h_Lreactbuild_format_dxf_Serializer$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Serializer$$anon$2.prototype = $c_Lreactbuild_format_dxf_Serializer$$anon$2.prototype;
var $d_Lreactbuild_format_dxf_Serializer$$anon$2 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Serializer$$anon$2: 0
}, false, "reactbuild.format.dxf.Serializer$$anon$2", {
  Lreactbuild_format_dxf_Serializer$$anon$2: 1,
  O: 1,
  Lreactbuild_format_dxf_Serializer: 1
});
$c_Lreactbuild_format_dxf_Serializer$$anon$2.prototype.$classData = $d_Lreactbuild_format_dxf_Serializer$$anon$2;
/** @constructor */
function $c_Lreactbuild_format_dxf_Style$() {
  this.Lreactbuild_format_dxf_Style$__f_encodeStyle = null;
  this.Lreactbuild_format_dxf_Style$__f_decodeStyle = null;
  $n_Lreactbuild_format_dxf_Style$ = this;
  var x$4 = new $c_Lreactbuild_format_dxf_NameOf($as_T($n($as_Leu_timepit_refined_api_Refined($n($m_Leu_timepit_refined_api_RefType$().Leu_timepit_refined_api_RefType$__f_refinedRefType).unsafeWrap__O__O("STANDARD"))).Leu_timepit_refined_api_Refined__f_value));
  var x$5 = new $c_Lreactbuild_format_dxf_LayerFlags(false, false, false, false, false, false);
  $m_Lreactbuild_format_dxf_Style$();
  var x$7 = 0.0;
  $m_Lreactbuild_format_dxf_Style$();
  var x$8 = 1.0;
  $m_Lreactbuild_format_dxf_Style$();
  var x$9 = 0.0;
  $m_Lreactbuild_format_dxf_Style$();
  var x$10 = 0;
  $m_Lreactbuild_format_dxf_Style$();
  var x$11 = 1.0;
  $m_Lreactbuild_format_dxf_Style$();
  var x$12 = "";
  new $c_Lreactbuild_format_dxf_Style(x$4, x$5, x$7, x$8, x$9, x$10, x$11, "ARIAL.TTF", x$12);
  var inst$macro$99 = new $c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$99));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  var qual$1 = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var x$1 = new $c_sjsr_AnonFunction1(((x$3$2) => {
    $as_Lreactbuild_format_dxf_Style(x$3$2);
    $n($m_s_package$().s_package$__f_List);
    var array = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "STYLE")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  }));
  var x$2 = $m_s_package$().s_package$__f_Nil;
  $n(qual$1);
  var x$3$3 = false;
  var this$9 = $n(qual$1);
  this.Lreactbuild_format_dxf_Style$__f_encodeStyle = new $c_Lreactbuild_format_dxf_Encoder$$anon$1(this$9, x$3$3, x$1, x$2);
  var inst$macro$198 = new $c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1().inst$macro$100__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$198));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  var this$15 = $n($as_Lreactbuild_format_dxf_Decoder(decoder.value__O()));
  var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "STYLE")];
  var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lreactbuild_format_dxf_Style$__f_decodeStyle = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$15, prefix)
}
$c_Lreactbuild_format_dxf_Style$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Style$.prototype.constructor = $c_Lreactbuild_format_dxf_Style$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Style$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Style$.prototype = $c_Lreactbuild_format_dxf_Style$.prototype;
var $d_Lreactbuild_format_dxf_Style$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Style$: 0
}, false, "reactbuild.format.dxf.Style$", {
  Lreactbuild_format_dxf_Style$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Style$.prototype.$classData = $d_Lreactbuild_format_dxf_Style$;
var $n_Lreactbuild_format_dxf_Style$;
function $m_Lreactbuild_format_dxf_Style$() {
  if ((!$n_Lreactbuild_format_dxf_Style$)) {
    $n_Lreactbuild_format_dxf_Style$ = new $c_Lreactbuild_format_dxf_Style$()
  };
  return $n_Lreactbuild_format_dxf_Style$
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$100$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$44 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "flags"));
    var this$3 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "fixedTextHeight"));
    var this$4 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "widthFactor"));
    var this$5 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "obliqueAngle"));
    var this$6 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "textGenerationFlags"));
    var this$7 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "lastHeightUsed"));
    var this$8 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "primaryFontFileName"));
    var this$9 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "bigfontFileName")), $m_Lshapeless_HNil$())))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_format_dxf_Style(x0$15$2);
      if ((x0$15 !== null)) {
        var name$macro$128 = $n(x0$15).Lreactbuild_format_dxf_Style__f_name;
        var flags$macro$129 = $n(x0$15).Lreactbuild_format_dxf_Style__f_flags;
        var fixedTextHeight$macro$130 = $n(x0$15).Lreactbuild_format_dxf_Style__f_fixedTextHeight;
        var widthFactor$macro$131 = $n(x0$15).Lreactbuild_format_dxf_Style__f_widthFactor;
        var obliqueAngle$macro$132 = $n(x0$15).Lreactbuild_format_dxf_Style__f_obliqueAngle;
        var textGenerationFlags$macro$133 = $n(x0$15).Lreactbuild_format_dxf_Style__f_textGenerationFlags;
        var lastHeightUsed$macro$134 = $n(x0$15).Lreactbuild_format_dxf_Style__f_lastHeightUsed;
        var primaryFontFileName$macro$135 = $n(x0$15).Lreactbuild_format_dxf_Style__f_primaryFontFileName;
        var bigfontFileName$macro$136 = $n(x0$15).Lreactbuild_format_dxf_Style__f_bigfontFileName;
        return new $c_Lshapeless_$colon$colon(name$macro$128, new $c_Lshapeless_$colon$colon(flags$macro$129, new $c_Lshapeless_$colon$colon(fixedTextHeight$macro$130, new $c_Lshapeless_$colon$colon(widthFactor$macro$131, new $c_Lshapeless_$colon$colon(obliqueAngle$macro$132, new $c_Lshapeless_$colon$colon(textGenerationFlags$macro$133, new $c_Lshapeless_$colon$colon(lastHeightUsed$macro$134, new $c_Lshapeless_$colon$colon(primaryFontFileName$macro$135, new $c_Lshapeless_$colon$colon(bigfontFileName$macro$136, $m_Lshapeless_HNil$())))))))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var name$macro$119 = $as_Lreactbuild_format_dxf_NameOf($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var flags$macro$120 = $as_Lreactbuild_format_dxf_LayerFlags($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var fixedTextHeight$macro$121 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var widthFactor$macro$122 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var obliqueAngle$macro$123 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var textGenerationFlags$macro$124 = $uI($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var lastHeightUsed$macro$125 = $uD($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var primaryFontFileName$macro$126 = $as_T($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var bigfontFileName$macro$127 = $as_T($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_HNil($n(p9).Lshapeless_$colon$colon__f_tail);
                        var x = $m_Lshapeless_HNil$();
                        if ((x === p10)) {
                          return new $c_Lreactbuild_format_dxf_Style(name$macro$119, flags$macro$120, fixedTextHeight$macro$121, widthFactor$macro$122, obliqueAngle$macro$123, textGenerationFlags$macro$124, lastHeightUsed$macro$125, primaryFontFileName$macro$126, bigfontFileName$macro$127)
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "bigfontFileName"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "primaryFontFileName"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "lastHeightUsed"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "textGenerationFlags"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "obliqueAngle"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$28 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "widthFactor"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "fixedTextHeight"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    var this$40 = $m_s_$less$colon$less$();
    var ev = this$40.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(40)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(41)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(50)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(71)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(42)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(3)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(4)), $m_Lshapeless_HNil$())))))))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$137__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$100 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$44);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$100
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$137$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_NameOf$().parseNameOf__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$140__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$137 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$137
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$140$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_LayerFlags$().parseLayerFlags__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$153__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$140 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$140
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$153$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$154__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$153 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$153
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$154$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$155__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$154 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$154
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$155$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$156__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$155 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$155
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$156$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseInt__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$157__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$156 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$156
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$157$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$158__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$157 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$157
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$158$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((256 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseString__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$159__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$158 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$158
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$159$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((512 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseString__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$160__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$159 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$159
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$160$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$160 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$160
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1() {
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$100 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$137 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$140 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$153 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$154 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$155 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$156 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$157 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$158 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$159 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$160 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.constructor = $c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype = $c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype;
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$100__Lreactbuild_format_dxf_Decoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$100$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$100)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$137__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$137$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$137)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$140__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$140$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$140)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$153__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$153$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$153)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$154__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$154$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$154)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$155__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$155$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$155)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$156__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((64 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$156$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$156)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$157__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((128 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$157$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$157)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$158__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((256 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$158$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$158)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$159__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((512 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$159$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$159)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.inst$macro$160__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((1024 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__inst$macro$160$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1__f_inst$macro$160)
});
var $d_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1: 0
}, false, "reactbuild.format.dxf.Style$anon$lazy$macro$197$1", {
  Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1.prototype.$classData = $d_Lreactbuild_format_dxf_Style$anon$lazy$macro$197$1;
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$44 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "flags"));
    var this$3 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "fixedTextHeight"));
    var this$4 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "widthFactor"));
    var this$5 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "obliqueAngle"));
    var this$6 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "textGenerationFlags"));
    var this$7 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "lastHeightUsed"));
    var this$8 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "primaryFontFileName"));
    var this$9 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "bigfontFileName")), $m_Lshapeless_HNil$())))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Style(x0$3$2);
      if ((x0$3 !== null)) {
        var name$macro$29 = $n(x0$3).Lreactbuild_format_dxf_Style__f_name;
        var flags$macro$30 = $n(x0$3).Lreactbuild_format_dxf_Style__f_flags;
        var fixedTextHeight$macro$31 = $n(x0$3).Lreactbuild_format_dxf_Style__f_fixedTextHeight;
        var widthFactor$macro$32 = $n(x0$3).Lreactbuild_format_dxf_Style__f_widthFactor;
        var obliqueAngle$macro$33 = $n(x0$3).Lreactbuild_format_dxf_Style__f_obliqueAngle;
        var textGenerationFlags$macro$34 = $n(x0$3).Lreactbuild_format_dxf_Style__f_textGenerationFlags;
        var lastHeightUsed$macro$35 = $n(x0$3).Lreactbuild_format_dxf_Style__f_lastHeightUsed;
        var primaryFontFileName$macro$36 = $n(x0$3).Lreactbuild_format_dxf_Style__f_primaryFontFileName;
        var bigfontFileName$macro$37 = $n(x0$3).Lreactbuild_format_dxf_Style__f_bigfontFileName;
        return new $c_Lshapeless_$colon$colon(name$macro$29, new $c_Lshapeless_$colon$colon(flags$macro$30, new $c_Lshapeless_$colon$colon(fixedTextHeight$macro$31, new $c_Lshapeless_$colon$colon(widthFactor$macro$32, new $c_Lshapeless_$colon$colon(obliqueAngle$macro$33, new $c_Lshapeless_$colon$colon(textGenerationFlags$macro$34, new $c_Lshapeless_$colon$colon(lastHeightUsed$macro$35, new $c_Lshapeless_$colon$colon(primaryFontFileName$macro$36, new $c_Lshapeless_$colon$colon(bigfontFileName$macro$37, $m_Lshapeless_HNil$())))))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var name$macro$20 = $as_Lreactbuild_format_dxf_NameOf($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var flags$macro$21 = $as_Lreactbuild_format_dxf_LayerFlags($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var fixedTextHeight$macro$22 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var widthFactor$macro$23 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var obliqueAngle$macro$24 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var textGenerationFlags$macro$25 = $uI($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var lastHeightUsed$macro$26 = $uD($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var primaryFontFileName$macro$27 = $as_T($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var bigfontFileName$macro$28 = $as_T($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_HNil($n(p9).Lshapeless_$colon$colon__f_tail);
                        var x = $m_Lshapeless_HNil$();
                        if ((x === p10)) {
                          return new $c_Lreactbuild_format_dxf_Style(name$macro$20, flags$macro$21, fixedTextHeight$macro$22, widthFactor$macro$23, obliqueAngle$macro$24, textGenerationFlags$macro$25, lastHeightUsed$macro$26, primaryFontFileName$macro$27, bigfontFileName$macro$28)
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "bigfontFileName"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "primaryFontFileName"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "lastHeightUsed"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "textGenerationFlags"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "obliqueAngle"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$28 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "widthFactor"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "fixedTextHeight"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    var this$40 = $m_s_$less$colon$less$();
    var ev = this$40.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(2)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(40)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(41)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(50)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(71)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(42)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(3)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(4)), $m_Lshapeless_HNil$())))))))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$38__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$44, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$38$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_NameOf$().serializeNameOf__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$41__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$38 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$38
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$41$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((4 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_LayerFlags$().serializeLayerFlags__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$54__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$41 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$41
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$54$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((8 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$55__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$54 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$54
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$55$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$56__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$55 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$55
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$56$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$57__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$56 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$56
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$57$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeInt__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$57 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$57
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$58$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$59__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$58 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$58
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$59$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeString__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$60__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$59 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$59
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$60$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeString__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$61__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$60 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$60
}
function $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$61$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$61 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$61
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1() {
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$38 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$41 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$54 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$55 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$56 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$57 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$58 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$59 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$60 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$61 = null;
  this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.constructor = $c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype = $c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype;
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$38__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$38$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$38)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$41__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((4 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$41$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$41)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$54__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((8 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$54$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$54)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$55__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$55$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$55)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$56__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$56$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$56)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$57__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((64 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$57$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$57)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$58__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((128 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$58$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$58)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$59__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((256 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$59$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$59)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$60__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((512 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$60$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$60)
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.inst$macro$61__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((1024 & this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__inst$macro$61$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1__f_inst$macro$61)
});
var $d_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1: 0
}, false, "reactbuild.format.dxf.Style$anon$lazy$macro$98$1", {
  Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1.prototype.$classData = $d_Lreactbuild_format_dxf_Style$anon$lazy$macro$98$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Table$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Table$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Table$.prototype.constructor = $c_Lreactbuild_format_dxf_Table$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Table$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Table$.prototype = $c_Lreactbuild_format_dxf_Table$.prototype;
$c_Lreactbuild_format_dxf_Table$.prototype.encodeTable__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder = (function(ct, encodeT) {
  var inst$macro$13 = new $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1(encodeT).inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$13));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  var qual$1 = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var x$1 = new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_Lreactbuild_format_dxf_Table(in$2);
    $n($m_s_package$().s_package$__f_List);
    var $$x4 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "TABLE");
    var $$x3 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$4 = $n($n($n(ct).runtimeClass__jl_Class()).getSimpleName__T());
    var $$x2 = new $c_Lreactbuild_format_dxf_Record($$x3, $as_T(this$4.toUpperCase()));
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(70);
    var this$5 = $n($n(in$1).Lreactbuild_format_dxf_Table__f_entries).length__I();
    var array = [$$x4, $$x2, new $c_Lreactbuild_format_dxf_Record($$x1, ("" + this$5))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  }));
  $n($m_s_package$().s_package$__f_List);
  var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDTAB")];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var x$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  $n(qual$1);
  var x$3 = false;
  var this$16 = $n(qual$1);
  return new $c_Lreactbuild_format_dxf_Encoder$$anon$1(this$16, x$3, x$1, x$2)
});
var $d_Lreactbuild_format_dxf_Table$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Table$: 0
}, false, "reactbuild.format.dxf.Table$", {
  Lreactbuild_format_dxf_Table$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Table$.prototype.$classData = $d_Lreactbuild_format_dxf_Table$;
var $n_Lreactbuild_format_dxf_Table$;
function $m_Lreactbuild_format_dxf_Table$() {
  if ((!$n_Lreactbuild_format_dxf_Table$)) {
    $n_Lreactbuild_format_dxf_Table$ = new $c_Lreactbuild_format_dxf_Table$()
  };
  return $n_Lreactbuild_format_dxf_Table$
}
function $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$12 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "entries")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Table(x0$3$2);
      if ((x0$3 !== null)) {
        var entries$macro$5 = $n(x0$3).Lreactbuild_format_dxf_Table__f_entries;
        return new $c_Lshapeless_$colon$colon(entries$macro$5, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var entries$macro$4 = $as_sci_List($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_Table(entries$macro$4)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "entries"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$12, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encoderA = $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_encodeT$1;
    var encodeV = new $c_Lreactbuild_format_dxf_Encoder$$anon$14(encoderA);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$7__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$6 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0) << 24) >> 24)
  };
  $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_encodeT$1 = null;
  return $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$6
}
function $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__inst$macro$7$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$7 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$7
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1(encodeT$1) {
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$6 = null;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$7 = null;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0 = 0;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_encodeT$1 = null;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_encodeT$1 = encodeT$1
}
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1.prototype.constructor = $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1.prototype = $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1.prototype;
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1.prototype.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$6)
});
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1.prototype.inst$macro$7__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__inst$macro$7$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1__f_inst$macro$7)
});
var $d_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1: 0
}, false, "reactbuild.format.dxf.Table$anon$lazy$macro$12$1", {
  Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1.prototype.$classData = $d_Lreactbuild_format_dxf_Table$anon$lazy$macro$12$1;
function $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$12 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "entries")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Table(x0$3$2);
      if ((x0$3 !== null)) {
        var entries$macro$5 = $n(x0$3).Lreactbuild_format_dxf_Table__f_entries;
        return new $c_Lshapeless_$colon$colon(entries$macro$5, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var entries$macro$4 = $as_sci_List($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_Table(entries$macro$4)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "entries"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$12);
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$7__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$8__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$6 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$6
}
function $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__inst$macro$7$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var decodeA = $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_decodeT$1;
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$7 = new $c_Lreactbuild_format_dxf_Decoder$$anon$17(decodeA);
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24)
  };
  $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_decodeT$1 = null;
  return $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$7
}
function $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__inst$macro$8$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$8 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$8
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1(decodeT$1) {
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$6 = null;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$7 = null;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$8 = null;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0 = 0;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_decodeT$1 = null;
  this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_decodeT$1 = decodeT$1
}
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1.prototype.constructor = $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1.prototype = $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1.prototype;
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1.prototype.inst$macro$6__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$6)
});
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1.prototype.inst$macro$7__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__inst$macro$7$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$7)
});
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1.prototype.inst$macro$8__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((8 & this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__inst$macro$8$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1__f_inst$macro$8)
});
var $d_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1: 0
}, false, "reactbuild.format.dxf.Table$anon$lazy$macro$13$1", {
  Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1.prototype.$classData = $d_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Tables$() {
  this.Lreactbuild_format_dxf_Tables$__f_encodeTablesSection = null;
  this.Lreactbuild_format_dxf_Tables$__f_decodeTablesSection = null;
  $n_Lreactbuild_format_dxf_Tables$ = this;
  var inst$macro$492 = new $c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$492));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Tables$__f_encodeTablesSection = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$1087 = new $c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1().inst$macro$493__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$1087));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Tables$__f_decodeTablesSection = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Tables$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Tables$.prototype.constructor = $c_Lreactbuild_format_dxf_Tables$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Tables$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Tables$.prototype = $c_Lreactbuild_format_dxf_Tables$.prototype;
var $d_Lreactbuild_format_dxf_Tables$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Tables$: 0
}, false, "reactbuild.format.dxf.Tables$", {
  Lreactbuild_format_dxf_Tables$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Tables$.prototype.$classData = $d_Lreactbuild_format_dxf_Tables$;
var $n_Lreactbuild_format_dxf_Tables$;
function $m_Lreactbuild_format_dxf_Tables$() {
  if ((!$n_Lreactbuild_format_dxf_Tables$)) {
    $n_Lreactbuild_format_dxf_Tables$ = new $c_Lreactbuild_format_dxf_Tables$()
  };
  return $n_Lreactbuild_format_dxf_Tables$
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$493$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$29 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "viewportConfigurationTable"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "lineTypeTable"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "layerTable"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "textStyleTable"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "viewTable")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$149$2) => {
      var x0$149 = $as_Lreactbuild_format_dxf_Tables(x0$149$2);
      if ((x0$149 !== null)) {
        var viewportConfigurationTable$macro$509 = $n(x0$149).Lreactbuild_format_dxf_Tables__f_viewportConfigurationTable;
        var lineTypeTable$macro$510 = $n(x0$149).Lreactbuild_format_dxf_Tables__f_lineTypeTable;
        var layerTable$macro$511 = $n(x0$149).Lreactbuild_format_dxf_Tables__f_layerTable;
        var textStyleTable$macro$512 = $n(x0$149).Lreactbuild_format_dxf_Tables__f_textStyleTable;
        var viewTable$macro$513 = $n(x0$149).Lreactbuild_format_dxf_Tables__f_viewTable;
        return new $c_Lshapeless_$colon$colon(viewportConfigurationTable$macro$509, new $c_Lshapeless_$colon$colon(lineTypeTable$macro$510, new $c_Lshapeless_$colon$colon(layerTable$macro$511, new $c_Lshapeless_$colon$colon(textStyleTable$macro$512, new $c_Lshapeless_$colon$colon(viewTable$macro$513, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$149)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$150$2) => {
      var x0$150 = $as_Lshapeless_$colon$colon(x0$150$2);
      if ((x0$150 !== null)) {
        var viewportConfigurationTable$macro$504 = $as_Lreactbuild_format_dxf_Table($n(x0$150).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$150).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var lineTypeTable$macro$505 = $as_Lreactbuild_format_dxf_Table($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var layerTable$macro$506 = $as_Lreactbuild_format_dxf_Table($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var textStyleTable$macro$507 = $as_Lreactbuild_format_dxf_Table($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var viewTable$macro$508 = $as_Lreactbuild_format_dxf_Table($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  $m_Lreactbuild_format_dxf_Tables$();
                  return new $c_Lreactbuild_format_dxf_Tables(viewportConfigurationTable$macro$504, lineTypeTable$macro$505, layerTable$macro$506, textStyleTable$macro$507, viewTable$macro$508)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$150)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "viewTable"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "textStyleTable"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "layerTable"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "lineTypeTable"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "viewportConfigurationTable"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$25 = $m_s_$less$colon$less$();
    var ev = this$25.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$514__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$493 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$29);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$493
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$514$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$515__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$571__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$514 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$514
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$515$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_VPort$().Lreactbuild_format_dxf_VPort$__f_decodeVPort;
    var inst$macro$14 = new $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1(decodeT).inst$macro$1__Lreactbuild_format_dxf_Decoder();
    var t = new $c_sjsr_AnonFunction0((() => inst$macro$14));
    var decoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var this$5 = $n($as_Lreactbuild_format_dxf_Decoder(decoder.value__O()));
    var f = new $c_sjsr_AnonFunction1(((x0$9$2) => {
      var x0$9 = $as_Lreactbuild_format_dxf_Record(x0$9$2);
      if ((x0$9 !== null)) {
        var p2 = $n(x0$9).Lreactbuild_format_dxf_Record__f_groupCode;
        if ((p2 !== null)) {
          var p4 = $n(p2).Lreactbuild_format_dxf_GroupCode__f_code;
          if ((p4 === 70)) {
            return true
          }
        }
      };
      return false
    }));
    var this$10 = new $c_Lreactbuild_format_dxf_Decoder$$anon$4(this$5, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "TABLE");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$6 = $n($d_Lreactbuild_format_dxf_VPort.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$6.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$14 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$10, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDTAB")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$515 = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$14, suffix);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
    var lo$1 = (4 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$515
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$571$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$572__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$722__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$571 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
    var lo$1 = (1024 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$571
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$572$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_LType$().Lreactbuild_format_dxf_LType$__f_decodeLType;
    var inst$macro$14 = new $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1(decodeT).inst$macro$1__Lreactbuild_format_dxf_Decoder();
    var t = new $c_sjsr_AnonFunction0((() => inst$macro$14));
    var decoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var this$5 = $n($as_Lreactbuild_format_dxf_Decoder(decoder.value__O()));
    var f = new $c_sjsr_AnonFunction1(((x0$9$2) => {
      var x0$9 = $as_Lreactbuild_format_dxf_Record(x0$9$2);
      if ((x0$9 !== null)) {
        var p2 = $n(x0$9).Lreactbuild_format_dxf_Record__f_groupCode;
        if ((p2 !== null)) {
          var p4 = $n(p2).Lreactbuild_format_dxf_GroupCode__f_code;
          if ((p4 === 70)) {
            return true
          }
        }
      };
      return false
    }));
    var this$10 = new $c_Lreactbuild_format_dxf_Decoder$$anon$4(this$5, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "TABLE");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$6 = $n($d_Lreactbuild_format_dxf_LType.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$6.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$14 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$10, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDTAB")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$572 = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$14, suffix);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
    var lo$1 = (2048 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$572
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$722$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (536870912 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$723__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$845__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$722 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
    var lo$1 = (536870912 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$722
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$723$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (1073741824 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_Layer$().Lreactbuild_format_dxf_Layer$__f_decodeLayer;
    var inst$macro$14 = new $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1(decodeT).inst$macro$1__Lreactbuild_format_dxf_Decoder();
    var t = new $c_sjsr_AnonFunction0((() => inst$macro$14));
    var decoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var this$5 = $n($as_Lreactbuild_format_dxf_Decoder(decoder.value__O()));
    var f = new $c_sjsr_AnonFunction1(((x0$9$2) => {
      var x0$9 = $as_Lreactbuild_format_dxf_Record(x0$9$2);
      if ((x0$9 !== null)) {
        var p2 = $n(x0$9).Lreactbuild_format_dxf_Record__f_groupCode;
        if ((p2 !== null)) {
          var p4 = $n(p2).Lreactbuild_format_dxf_GroupCode__f_code;
          if ((p4 === 70)) {
            return true
          }
        }
      };
      return false
    }));
    var this$10 = new $c_Lreactbuild_format_dxf_Decoder$$anon$4(this$5, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "TABLE");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$6 = $n($d_Lreactbuild_format_dxf_Layer.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$6.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$14 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$10, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDTAB")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$723 = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$14, suffix);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
    var lo$1 = (1073741824 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$723
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$845$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var hi = (4096 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$846__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1050__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$845 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (4096 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$845
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$846$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var decodeT = $m_Lreactbuild_format_dxf_Style$().Lreactbuild_format_dxf_Style$__f_decodeStyle;
    var inst$macro$14 = new $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1(decodeT).inst$macro$1__Lreactbuild_format_dxf_Decoder();
    var t = new $c_sjsr_AnonFunction0((() => inst$macro$14));
    var decoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var this$5 = $n($as_Lreactbuild_format_dxf_Decoder(decoder.value__O()));
    var f = new $c_sjsr_AnonFunction1(((x0$9$2) => {
      var x0$9 = $as_Lreactbuild_format_dxf_Record(x0$9$2);
      if ((x0$9 !== null)) {
        var p2 = $n(x0$9).Lreactbuild_format_dxf_Record__f_groupCode;
        if ((p2 !== null)) {
          var p4 = $n(p2).Lreactbuild_format_dxf_GroupCode__f_code;
          if ((p4 === 70)) {
            return true
          }
        }
      };
      return false
    }));
    var this$10 = new $c_Lreactbuild_format_dxf_Decoder$$anon$4(this$5, f);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "TABLE");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$6 = $n($d_Lreactbuild_format_dxf_Style.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$6.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$14 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$10, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDTAB")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$846 = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$14, suffix);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (8192 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$846
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$1050$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
  var lo = (32 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1051__Lreactbuild_format_dxf_Decoder()));
    var decodeV = new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeV$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances$$anon$5(this$3, decodeV);
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1065__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1050 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV$1, decodeT);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
    var lo$1 = (32 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1050
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$1051$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$9 = $m_Lreactbuild_format_dxf_Decoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$301$2) => {
      var x0$301 = $as_Lreactbuild_format_dxf_View(x0$301$2);
      if ((x0$301 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$301)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$302$2) => {
      var x0$302 = $as_Lshapeless_HNil(x0$302$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$302)) {
        return new $c_Lreactbuild_format_dxf_View()
      } else {
        throw new $c_s_MatchError(x0$302)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$5 = $m_s_$less$colon$less$();
    var ev = this$5.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$1064__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    var decodeT = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$9);
    var inst$macro$14 = new $c_Lreactbuild_format_dxf_Table$anon$lazy$macro$13$1(decodeT).inst$macro$1__Lreactbuild_format_dxf_Decoder();
    var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$14));
    var decoder$1 = new $c_Lshapeless_Lazy$$anon$1(t$1);
    var this$13 = $n($as_Lreactbuild_format_dxf_Decoder(decoder$1.value__O()));
    var f$1 = new $c_sjsr_AnonFunction1(((x0$9$2) => {
      var x0$9 = $as_Lreactbuild_format_dxf_Record(x0$9$2);
      if ((x0$9 !== null)) {
        var p2 = $n(x0$9).Lreactbuild_format_dxf_Record__f_groupCode;
        if ((p2 !== null)) {
          var p4 = $n(p2).Lreactbuild_format_dxf_GroupCode__f_code;
          if ((p4 === 70)) {
            return true
          }
        }
      };
      return false
    }));
    var this$18 = new $c_Lreactbuild_format_dxf_Decoder$$anon$4(this$13, f$1);
    var $$x2 = new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "TABLE");
    var $$x1 = new $c_Lreactbuild_format_dxf_GroupCode(2);
    var this$14 = $n($d_Lreactbuild_format_dxf_View.getClassOf().getSimpleName__T());
    var array = [$$x2, new $c_Lreactbuild_format_dxf_Record($$x1, $as_T(this$14.toUpperCase()))];
    var prefix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$22 = new $c_Lreactbuild_format_dxf_Decoder$$anon$2(this$18, prefix);
    var array$1 = [new $c_Lreactbuild_format_dxf_Record(new $c_Lreactbuild_format_dxf_GroupCode(0), "ENDTAB")];
    var suffix = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1051 = new $c_Lreactbuild_format_dxf_Decoder$$anon$3(this$22, suffix);
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
    var lo$1 = (64 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1051
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$1064$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1064 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
    var lo$1 = (2048 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1064
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$1065$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  var b = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
  var lo = (4096 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1065 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    var b$1 = $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
    var lo$1 = (4096 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1065
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1() {
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$493 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$514 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$515 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$571 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$572 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$722 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$723 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$845 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$846 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1050 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1051 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1064 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1065 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0 = $L0;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1 = $L0
}
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.constructor = $c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype = $c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype;
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$493__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$493$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$493
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$514__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$514$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$514
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$515__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$515$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$515
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$571__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$571$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$571
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$572__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$572$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$572
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$722__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (536870912 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$722$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$722
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$723__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var lo = (1073741824 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$723$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$723
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$845__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var hi = (4096 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$845$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$845
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$846__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$0;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$846$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$846
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$1050__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
  var lo = (32 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$1050$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1050
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$1051__Lreactbuild_format_dxf_Decoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$1051$lzycompute__Lreactbuild_format_dxf_Decoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1051
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$1064__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$1064$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1064
  }
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.inst$macro$1065__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  var b = this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_bitmap$1;
  var lo = (4096 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__inst$macro$1065$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this)
  } else {
    return this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1__f_inst$macro$1065
  }
});
var $d_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1: 0
}, false, "reactbuild.format.dxf.Tables$anon$lazy$macro$1086$1", {
  Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1.prototype.$classData = $d_Lreactbuild_format_dxf_Tables$anon$lazy$macro$1086$1;
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((1 & $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0)) {
    var this$29 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "viewportConfigurationTable"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "lineTypeTable"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "layerTable"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "textStyleTable"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "viewTable")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Tables(x0$3$2);
      if ((x0$3 !== null)) {
        var viewportConfigurationTable$macro$17 = $n(x0$3).Lreactbuild_format_dxf_Tables__f_viewportConfigurationTable;
        var lineTypeTable$macro$18 = $n(x0$3).Lreactbuild_format_dxf_Tables__f_lineTypeTable;
        var layerTable$macro$19 = $n(x0$3).Lreactbuild_format_dxf_Tables__f_layerTable;
        var textStyleTable$macro$20 = $n(x0$3).Lreactbuild_format_dxf_Tables__f_textStyleTable;
        var viewTable$macro$21 = $n(x0$3).Lreactbuild_format_dxf_Tables__f_viewTable;
        return new $c_Lshapeless_$colon$colon(viewportConfigurationTable$macro$17, new $c_Lshapeless_$colon$colon(lineTypeTable$macro$18, new $c_Lshapeless_$colon$colon(layerTable$macro$19, new $c_Lshapeless_$colon$colon(textStyleTable$macro$20, new $c_Lshapeless_$colon$colon(viewTable$macro$21, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var viewportConfigurationTable$macro$12 = $as_Lreactbuild_format_dxf_Table($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var lineTypeTable$macro$13 = $as_Lreactbuild_format_dxf_Table($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var layerTable$macro$14 = $as_Lreactbuild_format_dxf_Table($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var textStyleTable$macro$15 = $as_Lreactbuild_format_dxf_Table($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var viewTable$macro$16 = $as_Lreactbuild_format_dxf_Table($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  $m_Lreactbuild_format_dxf_Tables$();
                  return new $c_Lreactbuild_format_dxf_Tables(viewportConfigurationTable$macro$12, lineTypeTable$macro$13, layerTable$macro$14, textStyleTable$macro$15, viewTable$macro$16)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "viewTable"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "textStyleTable"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "layerTable"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "lineTypeTable"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "viewportConfigurationTable"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$25 = $m_s_$less$colon$less$();
    var ev = this$25.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$22__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$29, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$22$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((2 & $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encodeV = $m_Lreactbuild_format_dxf_Table$().encodeTable__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_VPort.getClassOf()), $m_Lreactbuild_format_dxf_VPort$().Lreactbuild_format_dxf_VPort$__f_encodeVPort);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$62__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$22 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$22
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$45$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((16 & $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$45 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$45
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$62$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((32 & $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encodeV = $m_Lreactbuild_format_dxf_Table$().encodeTable__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_LType.getClassOf()), $m_Lreactbuild_format_dxf_LType$().Lreactbuild_format_dxf_LType$__f_encodeLType);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$188__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$62 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$62
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$188$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encodeV = $m_Lreactbuild_format_dxf_Table$().encodeTable__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_Layer.getClassOf()), $m_Lreactbuild_format_dxf_Layer$().Lreactbuild_format_dxf_Layer$__f_encodeLayer);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$284__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$188 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$188
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$284$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((524288 & $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0)) {
    var this$4 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var encodeV = $m_Lreactbuild_format_dxf_Table$().encodeTable__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder(new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_Style.getClassOf()), $m_Lreactbuild_format_dxf_Style$().Lreactbuild_format_dxf_Style$__f_encodeStyle);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$461__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$284 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$4, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0 = (524288 | $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$284
}
function $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$461$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((1073741824 & $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0)) {
    var this$11 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var $$x2 = $m_Lreactbuild_format_dxf_Table$();
    var $$x1 = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_format_dxf_View.getClassOf());
    var this$9 = $m_Lreactbuild_format_dxf_Encoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$137$2) => {
      var x0$137 = $as_Lreactbuild_format_dxf_View(x0$137$2);
      if ((x0$137 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$137)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$138$2) => {
      var x0$138 = $as_Lshapeless_HNil(x0$138$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$138)) {
        return new $c_Lreactbuild_format_dxf_View()
      } else {
        throw new $c_s_MatchError(x0$138)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$5 = $m_s_$less$colon$less$();
    var ev = this$5.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$45__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    var encodeV = $n($$x2).encodeTable__s_reflect_ClassTag__Lreactbuild_format_dxf_Encoder__Lreactbuild_format_dxf_Encoder($$x1, new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$9, encoder, gen$1, annots));
    var t$1 = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$45__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t$1);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$461 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances$$anon$5(this$11, encodeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0 = (1073741824 | $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$461
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1() {
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$22 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$45 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$62 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$188 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$284 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$461 = null;
  this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype.constructor = $c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype = $c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype;
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((1 & this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype.inst$macro$22__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((2 & this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$22$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$22)
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype.inst$macro$45__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((16 & this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$45$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$45)
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype.inst$macro$62__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((32 & this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$62$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$62)
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype.inst$macro$188__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((8192 & this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$188$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$188)
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype.inst$macro$284__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((524288 & this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$284$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$284)
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype.inst$macro$461__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((1073741824 & this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_bitmap$0) === 0) ? $p_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__inst$macro$461$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1__f_inst$macro$461)
});
var $d_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1: 0
}, false, "reactbuild.format.dxf.Tables$anon$lazy$macro$491$1", {
  Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1.prototype.$classData = $d_Lreactbuild_format_dxf_Tables$anon$lazy$macro$491$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_ThumbnailImage$() {
  this.Lreactbuild_format_dxf_ThumbnailImage$__f_encodeThumbnailImageSection = null;
  this.Lreactbuild_format_dxf_ThumbnailImage$__f_decodeThumbnailImageSection = null;
  $n_Lreactbuild_format_dxf_ThumbnailImage$ = this;
  var inst$macro$4 = new $c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$4));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_ThumbnailImage$__f_encodeThumbnailImageSection = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$8 = new $c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3().inst$macro$5__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$8));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_ThumbnailImage$__f_decodeThumbnailImageSection = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_ThumbnailImage$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_ThumbnailImage$.prototype.constructor = $c_Lreactbuild_format_dxf_ThumbnailImage$;
/** @constructor */
function $h_Lreactbuild_format_dxf_ThumbnailImage$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_ThumbnailImage$.prototype = $c_Lreactbuild_format_dxf_ThumbnailImage$.prototype;
var $d_Lreactbuild_format_dxf_ThumbnailImage$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_ThumbnailImage$: 0
}, false, "reactbuild.format.dxf.ThumbnailImage$", {
  Lreactbuild_format_dxf_ThumbnailImage$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_ThumbnailImage$.prototype.$classData = $d_Lreactbuild_format_dxf_ThumbnailImage$;
var $n_Lreactbuild_format_dxf_ThumbnailImage$;
function $m_Lreactbuild_format_dxf_ThumbnailImage$() {
  if ((!$n_Lreactbuild_format_dxf_ThumbnailImage$)) {
    $n_Lreactbuild_format_dxf_ThumbnailImage$ = new $c_Lreactbuild_format_dxf_ThumbnailImage$()
  };
  return $n_Lreactbuild_format_dxf_ThumbnailImage$
}
function $p_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$8 = $m_Lreactbuild_format_dxf_Encoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_ThumbnailImage(x0$3$2);
      if ((x0$3 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_HNil(x0$4$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$4)) {
        return new $c_Lreactbuild_format_dxf_ThumbnailImage()
      } else {
        throw new $c_s_MatchError(x0$4)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$8, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__inst$macro$2$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_inst$macro$2 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_inst$macro$2
}
/** @constructor */
function $c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3() {
  this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_inst$macro$2 = null;
  this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3.prototype = new $h_O();
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3.prototype.constructor = $c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3;
/** @constructor */
function $h_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3.prototype = $c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3.prototype;
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3.prototype.inst$macro$2__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__inst$macro$2$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3__f_inst$macro$2)
});
var $d_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3 = new $TypeData().initClass({
  Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3: 0
}, false, "reactbuild.format.dxf.ThumbnailImage$anon$lazy$macro$3$3", {
  Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3.prototype.$classData = $d_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$3$3;
function $p_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__inst$macro$5$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$8 = $m_Lreactbuild_format_dxf_Decoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_format_dxf_ThumbnailImage(x0$11$2);
      if ((x0$11 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_HNil(x0$12$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$12)) {
        return new $c_Lreactbuild_format_dxf_ThumbnailImage()
      } else {
        throw new $c_s_MatchError(x0$12)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_inst$macro$5 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$8);
    $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_inst$macro$5
}
function $p_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_inst$macro$6 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_inst$macro$6
}
/** @constructor */
function $c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3() {
  this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_inst$macro$5 = null;
  this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_inst$macro$6 = null;
  this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3.prototype = new $h_O();
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3.prototype.constructor = $c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3;
/** @constructor */
function $h_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3.prototype = $c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3.prototype;
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3.prototype.inst$macro$5__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__inst$macro$5$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_inst$macro$5)
});
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3.prototype.inst$macro$6__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3__f_inst$macro$6)
});
var $d_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3 = new $TypeData().initClass({
  Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3: 0
}, false, "reactbuild.format.dxf.ThumbnailImage$anon$lazy$macro$7$3", {
  Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3.prototype.$classData = $d_Lreactbuild_format_dxf_ThumbnailImage$anon$lazy$macro$7$3;
/** @constructor */
function $c_Lreactbuild_format_dxf_VPort$() {
  this.Lreactbuild_format_dxf_VPort$__f_encodeVPort = null;
  this.Lreactbuild_format_dxf_VPort$__f_decodeVPort = null;
  $n_Lreactbuild_format_dxf_VPort$ = this;
  var inst$macro$25 = new $c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$25));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_VPort$__f_encodeVPort = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$50 = new $c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1().inst$macro$26__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$50));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_VPort$__f_decodeVPort = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_VPort$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_VPort$.prototype.constructor = $c_Lreactbuild_format_dxf_VPort$;
/** @constructor */
function $h_Lreactbuild_format_dxf_VPort$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_VPort$.prototype = $c_Lreactbuild_format_dxf_VPort$.prototype;
var $d_Lreactbuild_format_dxf_VPort$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_VPort$: 0
}, false, "reactbuild.format.dxf.VPort$", {
  Lreactbuild_format_dxf_VPort$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_VPort$.prototype.$classData = $d_Lreactbuild_format_dxf_VPort$;
var $n_Lreactbuild_format_dxf_VPort$;
function $m_Lreactbuild_format_dxf_VPort$() {
  if ((!$n_Lreactbuild_format_dxf_VPort$)) {
    $n_Lreactbuild_format_dxf_VPort$ = new $c_Lreactbuild_format_dxf_VPort$()
  };
  return $n_Lreactbuild_format_dxf_VPort$
}
function $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$12 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "flags")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_VPort(x0$3$2);
      if ((x0$3 !== null)) {
        var flags$macro$5 = $n(x0$3).Lreactbuild_format_dxf_VPort__f_flags;
        return new $c_Lshapeless_$colon$colon(flags$macro$5, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var flags$macro$4 = $as_Lreactbuild_format_dxf_LayerFlags($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_VPort(flags$macro$4)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), $m_Lshapeless_HNil$())));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$12, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_LayerFlags$().serializeLayerFlags__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$19__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$6 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$6
}
function $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__inst$macro$19$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$19 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$19
}
/** @constructor */
function $c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1() {
  this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$6 = null;
  this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$19 = null;
  this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1.prototype.constructor = $c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1.prototype = $c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1.prototype;
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1.prototype.inst$macro$6__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__inst$macro$6$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$6)
});
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1.prototype.inst$macro$19__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__inst$macro$19$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1__f_inst$macro$19)
});
var $d_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1: 0
}, false, "reactbuild.format.dxf.VPort$anon$lazy$macro$24$1", {
  Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1.prototype.$classData = $d_Lreactbuild_format_dxf_VPort$anon$lazy$macro$24$1;
function $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$12 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "flags")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$13$2) => {
      var x0$13 = $as_Lreactbuild_format_dxf_VPort(x0$13$2);
      if ((x0$13 !== null)) {
        var flags$macro$30 = $n(x0$13).Lreactbuild_format_dxf_VPort__f_flags;
        return new $c_Lshapeless_$colon$colon(flags$macro$30, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$13)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$14$2) => {
      var x0$14 = $as_Lshapeless_$colon$colon(x0$14$2);
      if ((x0$14 !== null)) {
        var flags$macro$29 = $as_Lreactbuild_format_dxf_LayerFlags($n(x0$14).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$14).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_format_dxf_VPort(flags$macro$29)
        }
      };
      throw new $c_s_MatchError(x0$14)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "flags"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(70)), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$31__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$26 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$12);
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$26
}
function $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__inst$macro$31$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_LayerFlags$().parseLayerFlags__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$44__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$31 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$31
}
function $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__inst$macro$44$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$44 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$44
}
/** @constructor */
function $c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1() {
  this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$26 = null;
  this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$31 = null;
  this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$44 = null;
  this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1.prototype.constructor = $c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1.prototype = $c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1.prototype;
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1.prototype.inst$macro$26__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$26)
});
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1.prototype.inst$macro$31__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__inst$macro$31$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$31)
});
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1.prototype.inst$macro$44__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__inst$macro$44$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1__f_inst$macro$44)
});
var $d_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1: 0
}, false, "reactbuild.format.dxf.VPort$anon$lazy$macro$49$1", {
  Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1.prototype.$classData = $d_Lreactbuild_format_dxf_VPort$anon$lazy$macro$49$1;
/** @constructor */
function $c_Lreactbuild_format_dxf_Vertex2D$() {
  this.Lreactbuild_format_dxf_Vertex2D$__f_encodeVertex2D = null;
  this.Lreactbuild_format_dxf_Vertex2D$__f_decodeVertex2D = null;
  $n_Lreactbuild_format_dxf_Vertex2D$ = this;
  var inst$macro$58 = new $c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1().inst$macro$1__Lreactbuild_format_dxf_Encoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$58));
  var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_format_dxf_Vertex2D$__f_encodeVertex2D = $as_Lreactbuild_format_dxf_Encoder(encoder.value__O());
  var inst$macro$116 = new $c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1().inst$macro$59__Lreactbuild_format_dxf_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$116));
  var decoder = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_format_dxf_Vertex2D$__f_decodeVertex2D = $as_Lreactbuild_format_dxf_Decoder(decoder.value__O())
}
$c_Lreactbuild_format_dxf_Vertex2D$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Vertex2D$.prototype.constructor = $c_Lreactbuild_format_dxf_Vertex2D$;
/** @constructor */
function $h_Lreactbuild_format_dxf_Vertex2D$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Vertex2D$.prototype = $c_Lreactbuild_format_dxf_Vertex2D$.prototype;
var $d_Lreactbuild_format_dxf_Vertex2D$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_Vertex2D$: 0
}, false, "reactbuild.format.dxf.Vertex2D$", {
  Lreactbuild_format_dxf_Vertex2D$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Vertex2D$.prototype.$classData = $d_Lreactbuild_format_dxf_Vertex2D$;
var $n_Lreactbuild_format_dxf_Vertex2D$;
function $m_Lreactbuild_format_dxf_Vertex2D$() {
  if ((!$n_Lreactbuild_format_dxf_Vertex2D$)) {
    $n_Lreactbuild_format_dxf_Vertex2D$ = new $c_Lreactbuild_format_dxf_Vertex2D$()
  };
  return $n_Lreactbuild_format_dxf_Vertex2D$
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$59$lzycompute__Lreactbuild_format_dxf_Decoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$32 = $m_Lreactbuild_format_dxf_Decoder$();
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "z"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "startingWith"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "endWith"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "bulge")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_format_dxf_Vertex2D(x0$11$2);
      if ((x0$11 !== null)) {
        var x$macro$78 = $n(x0$11).Lreactbuild_format_dxf_Vertex2D__f_x;
        var y$macro$79 = $n(x0$11).Lreactbuild_format_dxf_Vertex2D__f_y;
        var z$macro$80 = $n(x0$11).Lreactbuild_format_dxf_Vertex2D__f_z;
        var startingWith$macro$81 = $n(x0$11).Lreactbuild_format_dxf_Vertex2D__f_startingWith;
        var endWith$macro$82 = $n(x0$11).Lreactbuild_format_dxf_Vertex2D__f_endWith;
        var bulge$macro$83 = $n(x0$11).Lreactbuild_format_dxf_Vertex2D__f_bulge;
        return new $c_Lshapeless_$colon$colon(x$macro$78, new $c_Lshapeless_$colon$colon(y$macro$79, new $c_Lshapeless_$colon$colon(z$macro$80, new $c_Lshapeless_$colon$colon(startingWith$macro$81, new $c_Lshapeless_$colon$colon(endWith$macro$82, new $c_Lshapeless_$colon$colon(bulge$macro$83, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
      if ((x0$12 !== null)) {
        var x$macro$72 = $uD($n(x0$12).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$12).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$73 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var z$macro$74 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var startingWith$macro$75 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var endWith$macro$76 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var bulge$macro$77 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_format_dxf_Vertex2D(x$macro$72, y$macro$73, z$macro$74, startingWith$macro$75, endWith$macro$76, bulge$macro$77)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$12)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "bulge"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "endWith"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "startingWith"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "z"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(10)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(20)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(30)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(40)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(41)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(42)), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$84__Lreactbuild_format_dxf_AccumulatingDecoder()));
    new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$59 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsDecoder$$anon$16(this$32);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$59
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$84$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$85__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$84 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$84
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$85$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$86__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$85 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$85
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$86$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances$$anon$6(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$87__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$86 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$86
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$87$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$88__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$87 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$87
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$88$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$89__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$88 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$88
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$89$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_Lreactbuild_format_dxf_FieldDecoder$();
    var parseV = $m_Lreactbuild_format_dxf_Parser$().parseDouble__Lreactbuild_format_dxf_Parser();
    var decodeV = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances$$anon$8(this$1, parseV);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$90__Lreactbuild_format_dxf_AccumulatingDecoder()));
    var decodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$89 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$11(decodeV, decodeT);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$89
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$90$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder($thiz) {
  if (((((128 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$90 = new $c_Lreactbuild_format_dxf_AccumulatingDecoder$$anon$10();
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0 = (((128 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$90
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1() {
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$59 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$84 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$85 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$86 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$87 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$88 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$89 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$90 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.constructor = $c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype = $c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype;
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.inst$macro$59__Lreactbuild_format_dxf_Decoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$59$lzycompute__Lreactbuild_format_dxf_Decoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$59)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.inst$macro$84__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$84$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$84)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.inst$macro$85__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$85$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$85)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.inst$macro$86__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((8 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$86$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$86)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.inst$macro$87__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((16 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$87$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$87)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.inst$macro$88__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((32 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$88$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$88)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.inst$macro$89__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((64 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$89$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$89)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.inst$macro$90__Lreactbuild_format_dxf_AccumulatingDecoder = (function() {
  return (((((128 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__inst$macro$90$lzycompute__Lreactbuild_format_dxf_AccumulatingDecoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1__f_inst$macro$90)
});
var $d_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1: 0
}, false, "reactbuild.format.dxf.Vertex2D$anon$lazy$macro$115$1", {
  Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1.prototype.$classData = $d_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$115$1;
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$32 = $m_Lreactbuild_format_dxf_Encoder$();
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "z"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "startingWith"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "endWith"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "bulge")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_format_dxf_Vertex2D(x0$3$2);
      if ((x0$3 !== null)) {
        var x$macro$20 = $n(x0$3).Lreactbuild_format_dxf_Vertex2D__f_x;
        var y$macro$21 = $n(x0$3).Lreactbuild_format_dxf_Vertex2D__f_y;
        var z$macro$22 = $n(x0$3).Lreactbuild_format_dxf_Vertex2D__f_z;
        var startingWith$macro$23 = $n(x0$3).Lreactbuild_format_dxf_Vertex2D__f_startingWith;
        var endWith$macro$24 = $n(x0$3).Lreactbuild_format_dxf_Vertex2D__f_endWith;
        var bulge$macro$25 = $n(x0$3).Lreactbuild_format_dxf_Vertex2D__f_bulge;
        return new $c_Lshapeless_$colon$colon(x$macro$20, new $c_Lshapeless_$colon$colon(y$macro$21, new $c_Lshapeless_$colon$colon(z$macro$22, new $c_Lshapeless_$colon$colon(startingWith$macro$23, new $c_Lshapeless_$colon$colon(endWith$macro$24, new $c_Lshapeless_$colon$colon(bulge$macro$25, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var x$macro$14 = $uD($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$15 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var z$macro$16 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var startingWith$macro$17 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var endWith$macro$18 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var bulge$macro$19 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_format_dxf_Vertex2D(x$macro$14, y$macro$15, z$macro$16, startingWith$macro$17, endWith$macro$18, bulge$macro$19)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "bulge"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "endWith"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "startingWith"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "z"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(10)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(20)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(30)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(40)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(41)), new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_format_dxf_GroupCode(42)), $m_Lshapeless_HNil$()))))))));
    var annots = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encoder = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$1 = new $c_Lreactbuild_format_dxf_LowPriorityImplicitsEncoder$$anon$13(this$32, encoder, gen$1, annots);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$1
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$27__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$26 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$26
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$27$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$28__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$27 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$27
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$28$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$29__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$28 = new $c_Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances$$anon$6(this$3, serializeV, encodeT);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$28
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$30__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$29 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$29
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$30$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$31__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$30 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$30
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$31$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$3 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$();
    var serializeV = $m_Lreactbuild_format_dxf_Serializer$().serializeDouble__Lreactbuild_format_dxf_Serializer();
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$32__Lreactbuild_format_dxf_AccumulatingEncoder()));
    var encodeT = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$31 = new $c_Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances$$anon$7(this$3, encodeT, serializeV);
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$31
}
function $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$32$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder($thiz) {
  if (((((128 & $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$32 = $m_Lreactbuild_format_dxf_AccumulatingEncoder$().Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil;
    $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0 = (((128 | $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$32
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1() {
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$1 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$26 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$27 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$28 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$29 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$30 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$31 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$32 = null;
  this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0 = 0
}
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.constructor = $c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1;
/** @constructor */
function $h_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype = $c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype;
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.inst$macro$1__Lreactbuild_format_dxf_Encoder = (function() {
  return (((((1 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$1$lzycompute__Lreactbuild_format_dxf_Encoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$1)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.inst$macro$26__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((2 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$26$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$26)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.inst$macro$27__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((4 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$27$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$27)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.inst$macro$28__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((8 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$28$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$28)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.inst$macro$29__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((16 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$29$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$29)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.inst$macro$30__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((32 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$30$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$30)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.inst$macro$31__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((64 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$31$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$31)
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.inst$macro$32__Lreactbuild_format_dxf_AccumulatingEncoder = (function() {
  return (((((128 & this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__inst$macro$32$lzycompute__Lreactbuild_format_dxf_AccumulatingEncoder(this) : this.Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1__f_inst$macro$32)
});
var $d_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1: 0
}, false, "reactbuild.format.dxf.Vertex2D$anon$lazy$macro$57$1", {
  Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1.prototype.$classData = $d_Lreactbuild_format_dxf_Vertex2D$anon$lazy$macro$57$1;
/** @constructor */
function $c_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$(outer) {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$.prototype.constructor = $c_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$.prototype = $c_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$.prototype;
$c_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$.prototype.result__O__O = (function(acc) {
  var acc$1 = $as_scm_Buffer(acc);
  return $n(acc$1).toList__sci_List()
});
var $d_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$: 0
}, false, "reactbuild.format.iz2use.LowPriRepeater$GenericRepeatedImplicit0$", {
  Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$: 1,
  O: 1,
  Lfastparse_Implicits$Repeater: 1
});
$c_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$.prototype.$classData = $d_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$;
function $p_Lreactbuild_format_iz2use_Repeater$__GenericRepeatedImplicit0$lzycompute$1__V($thiz) {
  if (($m_Lreactbuild_format_iz2use_Repeater$().Lreactbuild_format_iz2use_Repeater$__f_GenericRepeatedImplicit0$module === null)) {
    $m_Lreactbuild_format_iz2use_Repeater$().Lreactbuild_format_iz2use_Repeater$__f_GenericRepeatedImplicit0$module = new $c_Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$($thiz)
  }
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_Repeater$() {
  this.Lreactbuild_format_iz2use_Repeater$__f_GenericRepeatedImplicit0$module = null
}
$c_Lreactbuild_format_iz2use_Repeater$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_Repeater$.prototype.constructor = $c_Lreactbuild_format_iz2use_Repeater$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_Repeater$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_Repeater$.prototype = $c_Lreactbuild_format_iz2use_Repeater$.prototype;
$c_Lreactbuild_format_iz2use_Repeater$.prototype.GenericRepeatedImplicit0__Lreactbuild_format_iz2use_LowPriRepeater$GenericRepeatedImplicit0$ = (function() {
  if (($m_Lreactbuild_format_iz2use_Repeater$().Lreactbuild_format_iz2use_Repeater$__f_GenericRepeatedImplicit0$module === null)) {
    $p_Lreactbuild_format_iz2use_Repeater$__GenericRepeatedImplicit0$lzycompute$1__V(this)
  };
  return $m_Lreactbuild_format_iz2use_Repeater$().Lreactbuild_format_iz2use_Repeater$__f_GenericRepeatedImplicit0$module
});
var $d_Lreactbuild_format_iz2use_Repeater$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_Repeater$: 0
}, false, "reactbuild.format.iz2use.Repeater$", {
  Lreactbuild_format_iz2use_Repeater$: 1,
  O: 1,
  Lreactbuild_format_iz2use_LowPriRepeater: 1
});
$c_Lreactbuild_format_iz2use_Repeater$.prototype.$classData = $d_Lreactbuild_format_iz2use_Repeater$;
var $n_Lreactbuild_format_iz2use_Repeater$;
function $m_Lreactbuild_format_iz2use_Repeater$() {
  if ((!$n_Lreactbuild_format_iz2use_Repeater$)) {
    $n_Lreactbuild_format_iz2use_Repeater$ = new $c_Lreactbuild_format_iz2use_Repeater$()
  };
  return $n_Lreactbuild_format_iz2use_Repeater$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_Repeater$UnitRepeater$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_Repeater$UnitRepeater$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_Repeater$UnitRepeater$.prototype.constructor = $c_Lreactbuild_format_iz2use_Repeater$UnitRepeater$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_Repeater$UnitRepeater$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_Repeater$UnitRepeater$.prototype = $c_Lreactbuild_format_iz2use_Repeater$UnitRepeater$.prototype;
$c_Lreactbuild_format_iz2use_Repeater$UnitRepeater$.prototype.result__O__O = (function(acc) {
  $as_jl_Void(acc)
});
var $d_Lreactbuild_format_iz2use_Repeater$UnitRepeater$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_Repeater$UnitRepeater$: 0
}, false, "reactbuild.format.iz2use.Repeater$UnitRepeater$", {
  Lreactbuild_format_iz2use_Repeater$UnitRepeater$: 1,
  O: 1,
  Lfastparse_Implicits$Repeater: 1
});
$c_Lreactbuild_format_iz2use_Repeater$UnitRepeater$.prototype.$classData = $d_Lreactbuild_format_iz2use_Repeater$UnitRepeater$;
var $n_Lreactbuild_format_iz2use_Repeater$UnitRepeater$;
function $m_Lreactbuild_format_iz2use_Repeater$UnitRepeater$() {
  if ((!$n_Lreactbuild_format_iz2use_Repeater$UnitRepeater$)) {
    $n_Lreactbuild_format_iz2use_Repeater$UnitRepeater$ = new $c_Lreactbuild_format_iz2use_Repeater$UnitRepeater$()
  };
  return $n_Lreactbuild_format_iz2use_Repeater$UnitRepeater$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Length$() {
  this.Lreactbuild_format_iz2use_package$Length$__f_reactbuild$format$iz2use$Length$$underlying = null;
  this.Lreactbuild_format_iz2use_package$Length$__f_numericLength = null;
  this.Lreactbuild_format_iz2use_package$Length$__f_Zero = null;
  $n_Lreactbuild_format_iz2use_package$Length$ = this;
  this.Lreactbuild_format_iz2use_package$Length$__f_reactbuild$format$iz2use$Length$$underlying = $m_s_math_Numeric$IntIsIntegral$();
  this.Lreactbuild_format_iz2use_package$Length$__f_numericLength = new $c_Lreactbuild_format_iz2use_package$Length$$anon$1();
  this.Lreactbuild_format_iz2use_package$Length$__f_Zero = new $c_Lreactbuild_format_iz2use_package$Length(0)
}
$c_Lreactbuild_format_iz2use_package$Length$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Length$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Length$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Length$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Length$.prototype = $c_Lreactbuild_format_iz2use_package$Length$.prototype;
$c_Lreactbuild_format_iz2use_package$Length$.prototype.witnessAsLength__Lshapeless_Witness__Lshapeless_ops_nat$ToInt__Leu_timepit_refined_internal_WitnessAs = (function(wa, ta) {
  return new $c_Leu_timepit_refined_internal_WitnessAs($n(wa).value__O(), new $c_Lreactbuild_format_iz2use_package$Length($n(ta).Lshapeless_ops_nat$ToInt$Inst__f_i))
});
var $d_Lreactbuild_format_iz2use_package$Length$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Length$: 0
}, false, "reactbuild.format.iz2use.package$Length$", {
  Lreactbuild_format_iz2use_package$Length$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Length$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Length$;
var $n_Lreactbuild_format_iz2use_package$Length$;
function $m_Lreactbuild_format_iz2use_package$Length$() {
  if ((!$n_Lreactbuild_format_iz2use_package$Length$)) {
    $n_Lreactbuild_format_iz2use_package$Length$ = new $c_Lreactbuild_format_iz2use_package$Length$()
  };
  return $n_Lreactbuild_format_iz2use_package$Length$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Vector2D$() {
  this.Lreactbuild_format_iz2use_package$Vector2D$__f_Zero = null;
  $n_Lreactbuild_format_iz2use_package$Vector2D$ = this;
  this.Lreactbuild_format_iz2use_package$Vector2D$__f_Zero = new $c_Lreactbuild_format_iz2use_package$Vector2D(($m_Lreactbuild_format_iz2use_package$Vector2D$(), $m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_Zero), ($m_Lreactbuild_format_iz2use_package$Vector2D$(), $m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_Zero))
}
$c_Lreactbuild_format_iz2use_package$Vector2D$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Vector2D$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Vector2D$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Vector2D$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Vector2D$.prototype = $c_Lreactbuild_format_iz2use_package$Vector2D$.prototype;
$c_Lreactbuild_format_iz2use_package$Vector2D$.prototype.asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2 = (function(vec) {
  return new $c_Lreactbuild_geom_Vector2($n($n(vec).Lreactbuild_format_iz2use_package$Vector2D__f_x).Lreactbuild_format_iz2use_package$Length__f_length, $n($n(vec).Lreactbuild_format_iz2use_package$Vector2D__f_y).Lreactbuild_format_iz2use_package$Length__f_length)
});
var $d_Lreactbuild_format_iz2use_package$Vector2D$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Vector2D$: 0
}, false, "reactbuild.format.iz2use.package$Vector2D$", {
  Lreactbuild_format_iz2use_package$Vector2D$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Vector2D$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Vector2D$;
var $n_Lreactbuild_format_iz2use_package$Vector2D$;
function $m_Lreactbuild_format_iz2use_package$Vector2D$() {
  if ((!$n_Lreactbuild_format_iz2use_package$Vector2D$)) {
    $n_Lreactbuild_format_iz2use_package$Vector2D$ = new $c_Lreactbuild_format_iz2use_package$Vector2D$()
  };
  return $n_Lreactbuild_format_iz2use_package$Vector2D$
}
/** @constructor */
function $c_Lreactbuild_geom_Line2$() {
  /*<skip>*/
}
$c_Lreactbuild_geom_Line2$.prototype = new $h_O();
$c_Lreactbuild_geom_Line2$.prototype.constructor = $c_Lreactbuild_geom_Line2$;
/** @constructor */
function $h_Lreactbuild_geom_Line2$() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Line2$.prototype = $c_Lreactbuild_geom_Line2$.prototype;
$c_Lreactbuild_geom_Line2$.prototype.intersectionWithSegment__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__s_Option = (function(a, ab, c, cd) {
  var this$1 = $n(ab);
  var q = $f_Lreactbuild_geom_Vector2Based__cross__Lreactbuild_geom_Vector2Based__D(this$1, cd);
  if ((q === 0.0)) {
    return $m_s_None$()
  } else {
    var k = ((-(((($n(a).x__D() * $n(cd).y__D()) - ($n(c).x__D() * $n(cd).y__D())) - ($n(cd).x__D() * $n(a).y__D())) + ($n(cd).x__D() * $n(c).y__D()))) / q);
    var m = ((-(((((-$n(ab).x__D()) * $n(a).y__D()) + ($n(ab).x__D() * $n(c).y__D())) + ($n(ab).y__D() * $n(a).x__D())) - ($n(ab).y__D() * $n(c).x__D()))) / q);
    if (((0.0 <= m) && (m <= 1.0))) {
      var this$2 = $n(ab);
      var this$3 = $n(((k === 1.0) ? this$2 : new $c_Lreactbuild_geom_Vector2((this$2.x__D() * k), (this$2.y__D() * k))));
      return new $c_s_Some(new $c_Lreactbuild_geom_Point2((this$3.x__D() + $n(a).x__D()), (this$3.y__D() + $n(a).y__D())))
    } else {
      return $m_s_None$()
    }
  }
});
$c_Lreactbuild_geom_Line2$.prototype.signedDistanceToPoint__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Point2Based__D = (function(origin, vector, pt) {
  if (($n(vector).x__D() === 0.0)) {
    return (($n(vector).y__D() > 0.0) ? ($n(pt).x__D() - $n(origin).x__D()) : ($n(origin).x__D() - $n(pt).x__D()))
  } else if (($n(vector).y__D() === 0.0)) {
    return (($n(vector).x__D() < 0.0) ? ($n(pt).y__D() - $n(origin).y__D()) : ($n(origin).y__D() - $n(pt).y__D()))
  } else {
    var $$x9 = $n(pt).x__D();
    var $$x8 = $n(origin).x__D();
    var $$x7 = $n(vector).y__D();
    var $$x6 = $n(pt).y__D();
    var $$x5 = $n(origin).y__D();
    var $$x4 = $n(vector).x__D();
    if (($n(vector).y__D() > $n(vector).x__D())) {
      var $$x2 = $n(vector).y__D();
      var this$1 = $n(vector);
      var v = this$1.x__D();
      var v$1 = this$1.y__D();
      var a = (1.0 + ((v * v) + (v$1 * v$1)));
      var $$x1 = ($$x2 * $uD(Math.sqrt(a)))
    } else {
      var $$x3 = $n(vector).x__D();
      var this$7 = $n(vector);
      var v$2 = this$7.x__D();
      var v$3 = this$7.y__D();
      var a$1 = (1.0 + ((v$2 * v$2) + (v$3 * v$3)));
      var $$x1 = ($$x3 * $uD(Math.sqrt(a$1)))
    };
    return (((($$x9 - $$x8) * $$x7) - (($$x6 - $$x5) * $$x4)) / $$x1)
  }
});
$c_Lreactbuild_geom_Line2$.prototype.distanceToPoint__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Point2Based__D = (function(origin, vector, pt) {
  var a = this.signedDistanceToPoint__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Point2Based__D(origin, vector, pt);
  return $uD(Math.abs(a))
});
var $d_Lreactbuild_geom_Line2$ = new $TypeData().initClass({
  Lreactbuild_geom_Line2$: 0
}, false, "reactbuild.geom.Line2$", {
  Lreactbuild_geom_Line2$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_geom_Line2$.prototype.$classData = $d_Lreactbuild_geom_Line2$;
var $n_Lreactbuild_geom_Line2$;
function $m_Lreactbuild_geom_Line2$() {
  if ((!$n_Lreactbuild_geom_Line2$)) {
    $n_Lreactbuild_geom_Line2$ = new $c_Lreactbuild_geom_Line2$()
  };
  return $n_Lreactbuild_geom_Line2$
}
/** @constructor */
function $c_Lreactbuild_geom_Point2$() {
  $n_Lreactbuild_geom_Point2$ = this;
  new $c_Lreactbuild_geom_Point2(0.0, 0.0)
}
$c_Lreactbuild_geom_Point2$.prototype = new $h_O();
$c_Lreactbuild_geom_Point2$.prototype.constructor = $c_Lreactbuild_geom_Point2$;
/** @constructor */
function $h_Lreactbuild_geom_Point2$() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Point2$.prototype = $c_Lreactbuild_geom_Point2$.prototype;
$c_Lreactbuild_geom_Point2$.prototype.projectToLine__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Z__Lreactbuild_geom_Point2Based = (function(pt, origin, vector, clamp) {
  var p = this.projectToLineParameter__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Z__D(pt, origin, vector, clamp);
  var this$1 = $n(vector);
  var this$2 = $n(((p === 1.0) ? this$1 : new $c_Lreactbuild_geom_Vector2((this$1.x__D() * p), (this$1.y__D() * p))));
  return new $c_Lreactbuild_geom_Point2((this$2.x__D() + $n(origin).x__D()), (this$2.y__D() + $n(origin).y__D()))
});
$c_Lreactbuild_geom_Point2$.prototype.projectToLineParameter__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Z__D = (function(pt, origin, vector, clamp) {
  if ((($n(pt).x__D() === $n(origin).x__D()) && ($n(pt).y__D() === $n(origin).y__D()))) {
    return 0.0
  } else {
    var this$1 = $n(pt);
    var v = new $c_Lreactbuild_geom_Vector2((this$1.x__D() - $n(origin).x__D()), (this$1.y__D() - $n(origin).y__D()));
    var $$x4 = v.Lreactbuild_geom_Vector2__f_x;
    var $$x3 = $n(vector).x__D();
    var $$x2 = v.Lreactbuild_geom_Vector2__f_y;
    var $$x1 = $n(vector).y__D();
    var this$2 = $n(vector);
    var v$1 = this$2.x__D();
    var v$2 = this$2.y__D();
    var t = ((($$x4 * $$x3) + ($$x2 * $$x1)) / ((v$1 * v$1) + (v$2 * v$2)));
    if (clamp) {
      var a = $uD(Math.min(t, 1.0));
      return $uD(Math.max(a, 0.0))
    } else {
      return t
    }
  }
});
var $d_Lreactbuild_geom_Point2$ = new $TypeData().initClass({
  Lreactbuild_geom_Point2$: 0
}, false, "reactbuild.geom.Point2$", {
  Lreactbuild_geom_Point2$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_geom_Point2$.prototype.$classData = $d_Lreactbuild_geom_Point2$;
var $n_Lreactbuild_geom_Point2$;
function $m_Lreactbuild_geom_Point2$() {
  if ((!$n_Lreactbuild_geom_Point2$)) {
    $n_Lreactbuild_geom_Point2$ = new $c_Lreactbuild_geom_Point2$()
  };
  return $n_Lreactbuild_geom_Point2$
}
function $is_Lreactbuild_geom_Point2Based(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_geom_Point2Based)))
}
function $as_Lreactbuild_geom_Point2Based(obj) {
  return (($is_Lreactbuild_geom_Point2Based(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.geom.Point2Based"))
}
function $isArrayOf_Lreactbuild_geom_Point2Based(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_geom_Point2Based)))
}
function $asArrayOf_Lreactbuild_geom_Point2Based(obj, depth) {
  return (($isArrayOf_Lreactbuild_geom_Point2Based(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.geom.Point2Based;", depth))
}
/** @constructor */
function $c_Lreactbuild_geom_Quaternion$() {
  this.Lreactbuild_geom_Quaternion$__f_half = 0.0;
  this.Lreactbuild_geom_Quaternion$__f_halfSqrt = 0.0;
  $n_Lreactbuild_geom_Quaternion$ = this;
  this.Lreactbuild_geom_Quaternion$__f_half = 0.5;
  var a = this.Lreactbuild_geom_Quaternion$__f_half;
  this.Lreactbuild_geom_Quaternion$__f_halfSqrt = $uD(Math.sqrt(a))
}
$c_Lreactbuild_geom_Quaternion$.prototype = new $h_O();
$c_Lreactbuild_geom_Quaternion$.prototype.constructor = $c_Lreactbuild_geom_Quaternion$;
/** @constructor */
function $h_Lreactbuild_geom_Quaternion$() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Quaternion$.prototype = $c_Lreactbuild_geom_Quaternion$.prototype;
$c_Lreactbuild_geom_Quaternion$.prototype.taitBryantToQuaternion__D__D__D__Lreactbuild_geom_Quaternion = (function(alpha, beta, gamma) {
  $n($m_s_package$().s_package$__f_List);
  var array = [((3.141592653589793 * (beta / 180.0)) * this.Lreactbuild_geom_Quaternion$__f_half), ((3.141592653589793 * (gamma / 180.0)) * this.Lreactbuild_geom_Quaternion$__f_half), ((3.141592653589793 * (alpha / 180.0)) * this.Lreactbuild_geom_Quaternion$__f_half)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var r = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$19 = $n(r);
  var f = ((x$1$2) => {
    var x$1 = $uD(x$1$2);
    return $uD(Math.cos(x$1))
  });
  if ((this$19 === $m_sci_Nil$())) {
    var c = $m_sci_Nil$()
  } else {
    var arg1 = this$19.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$19.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var c = h
  };
  var this$21 = $n(r);
  var f$1 = ((x$1$3$2) => {
    var x$1$3 = $uD(x$1$3$2);
    return $uD(Math.sin(x$1$3))
  });
  if ((this$21 === $m_sci_Nil$())) {
    var s = $m_sci_Nil$()
  } else {
    var arg1$2 = this$21.head__O();
    var h$1 = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = $as_sci_List(this$21.tail__O());
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$3 = $n(rest$1).head__O();
      var nx$1 = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
      $n(t$1).sci_$colon$colon__f_next = nx$1;
      t$1 = nx$1;
      rest$1 = $as_sci_List($n(rest$1).tail__O())
    };
    var s = h$1
  };
  var this$22 = $n(c);
  var $$x23 = $uD($f_sc_LinearSeqOps__apply__I__O(this$22, 0));
  var this$23 = $n(c);
  var $$x22 = $uD($f_sc_LinearSeqOps__apply__I__O(this$23, 1));
  var this$24 = $n(c);
  var $$x21 = $uD($f_sc_LinearSeqOps__apply__I__O(this$24, 2));
  var this$25 = $n(s);
  var $$x20 = $uD($f_sc_LinearSeqOps__apply__I__O(this$25, 0));
  var this$26 = $n(s);
  var $$x19 = $uD($f_sc_LinearSeqOps__apply__I__O(this$26, 1));
  var this$27 = $n(s);
  var $$x18 = $uD($f_sc_LinearSeqOps__apply__I__O(this$27, 2));
  var this$28 = $n(s);
  var $$x17 = $uD($f_sc_LinearSeqOps__apply__I__O(this$28, 0));
  var this$29 = $n(c);
  var $$x16 = $uD($f_sc_LinearSeqOps__apply__I__O(this$29, 1));
  var this$30 = $n(c);
  var $$x15 = $uD($f_sc_LinearSeqOps__apply__I__O(this$30, 2));
  var this$31 = $n(c);
  var $$x14 = $uD($f_sc_LinearSeqOps__apply__I__O(this$31, 0));
  var this$32 = $n(s);
  var $$x13 = $uD($f_sc_LinearSeqOps__apply__I__O(this$32, 1));
  var this$33 = $n(s);
  var $$x12 = $uD($f_sc_LinearSeqOps__apply__I__O(this$33, 2));
  var this$34 = $n(c);
  var $$x11 = $uD($f_sc_LinearSeqOps__apply__I__O(this$34, 0));
  var this$35 = $n(s);
  var $$x10 = $uD($f_sc_LinearSeqOps__apply__I__O(this$35, 1));
  var this$36 = $n(c);
  var $$x9 = $uD($f_sc_LinearSeqOps__apply__I__O(this$36, 2));
  var this$37 = $n(s);
  var $$x8 = $uD($f_sc_LinearSeqOps__apply__I__O(this$37, 0));
  var this$38 = $n(c);
  var $$x7 = $uD($f_sc_LinearSeqOps__apply__I__O(this$38, 1));
  var this$39 = $n(s);
  var $$x6 = $uD($f_sc_LinearSeqOps__apply__I__O(this$39, 2));
  var this$40 = $n(c);
  var $$x5 = $uD($f_sc_LinearSeqOps__apply__I__O(this$40, 0));
  var this$41 = $n(c);
  var $$x4 = $uD($f_sc_LinearSeqOps__apply__I__O(this$41, 1));
  var this$42 = $n(s);
  var $$x3 = $uD($f_sc_LinearSeqOps__apply__I__O(this$42, 2));
  var this$43 = $n(s);
  var $$x2 = $uD($f_sc_LinearSeqOps__apply__I__O(this$43, 0));
  var this$44 = $n(s);
  var $$x1 = $uD($f_sc_LinearSeqOps__apply__I__O(this$44, 1));
  var this$45 = $n(c);
  return new $c_Lreactbuild_geom_Quaternion(((($$x23 * $$x22) * $$x21) - (($$x20 * $$x19) * $$x18)), ((($$x17 * $$x16) * $$x15) - (($$x14 * $$x13) * $$x12)), ((($$x11 * $$x10) * $$x9) + (($$x8 * $$x7) * $$x6)), ((($$x5 * $$x4) * $$x3) + (($$x2 * $$x1) * $uD($f_sc_LinearSeqOps__apply__I__O(this$45, 2)))))
});
$c_Lreactbuild_geom_Quaternion$.prototype.computeQuaternion__D__D__D__D__Lreactbuild_geom_Quaternion = (function(alpha, beta, gamma, orientation) {
  var quaternion = this.taitBryantToQuaternion__D__D__D__Lreactbuild_geom_Quaternion(alpha, beta, gamma);
  var world = $n(quaternion).$times__Lreactbuild_geom_Quaternion__Lreactbuild_geom_Quaternion(new $c_Lreactbuild_geom_Quaternion(this.Lreactbuild_geom_Quaternion$__f_halfSqrt, (-this.Lreactbuild_geom_Quaternion$__f_halfSqrt), 0.0, 0.0));
  var angle = ((-(3.141592653589793 * (orientation / 180.0))) * this.Lreactbuild_geom_Quaternion$__f_half);
  return $n(world).$times__Lreactbuild_geom_Quaternion__Lreactbuild_geom_Quaternion(new $c_Lreactbuild_geom_Quaternion($uD(Math.cos(angle)), 0.0, (-$uD(Math.sin(angle))), 0.0))
});
var $d_Lreactbuild_geom_Quaternion$ = new $TypeData().initClass({
  Lreactbuild_geom_Quaternion$: 0
}, false, "reactbuild.geom.Quaternion$", {
  Lreactbuild_geom_Quaternion$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_geom_Quaternion$.prototype.$classData = $d_Lreactbuild_geom_Quaternion$;
var $n_Lreactbuild_geom_Quaternion$;
function $m_Lreactbuild_geom_Quaternion$() {
  if ((!$n_Lreactbuild_geom_Quaternion$)) {
    $n_Lreactbuild_geom_Quaternion$ = new $c_Lreactbuild_geom_Quaternion$()
  };
  return $n_Lreactbuild_geom_Quaternion$
}
/** @constructor */
function $c_Lreactbuild_geom_Vector2$() {
  this.Lreactbuild_geom_Vector2$__f_zero = null;
  this.Lreactbuild_geom_Vector2$__f_unit = null;
  this.Lreactbuild_geom_Vector2$__f_X_AXIS = null;
  this.Lreactbuild_geom_Vector2$__f_Y_AXIS = null;
  $n_Lreactbuild_geom_Vector2$ = this;
  this.Lreactbuild_geom_Vector2$__f_zero = new $c_Lreactbuild_geom_Vector2(0.0, 0.0);
  this.Lreactbuild_geom_Vector2$__f_unit = new $c_Lreactbuild_geom_Vector2(1.0, 1.0);
  this.Lreactbuild_geom_Vector2$__f_X_AXIS = new $c_Lreactbuild_geom_Vector2(1.0, 0.0);
  this.Lreactbuild_geom_Vector2$__f_Y_AXIS = new $c_Lreactbuild_geom_Vector2(0.0, 1.0)
}
$c_Lreactbuild_geom_Vector2$.prototype = new $h_O();
$c_Lreactbuild_geom_Vector2$.prototype.constructor = $c_Lreactbuild_geom_Vector2$;
/** @constructor */
function $h_Lreactbuild_geom_Vector2$() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Vector2$.prototype = $c_Lreactbuild_geom_Vector2$.prototype;
var $d_Lreactbuild_geom_Vector2$ = new $TypeData().initClass({
  Lreactbuild_geom_Vector2$: 0
}, false, "reactbuild.geom.Vector2$", {
  Lreactbuild_geom_Vector2$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_geom_Vector2$.prototype.$classData = $d_Lreactbuild_geom_Vector2$;
var $n_Lreactbuild_geom_Vector2$;
function $m_Lreactbuild_geom_Vector2$() {
  if ((!$n_Lreactbuild_geom_Vector2$)) {
    $n_Lreactbuild_geom_Vector2$ = new $c_Lreactbuild_geom_Vector2$()
  };
  return $n_Lreactbuild_geom_Vector2$
}
function $p_Lreactbuild_hooks_ClientSize$__b$1$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$1$lzy$1, reuseCoord$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability(reuseCoord$1);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_hooks_ClientSize$__b$1$1__sr_LazyRef__F2__F2($thiz, b$1$lzy$1, reuseCoord$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_hooks_ClientSize$__b$1$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$1$lzy$1, reuseCoord$1))
}
function $p_Lreactbuild_hooks_ClientSize$__updateSize$1__Lorg_scalajs_dom_HTMLElement__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline($thiz, elt$1, sizeRef$1) {
  var size = new $c_Lreactbuild_hooks_ClientSize($uI(elt$1.clientWidth), $uI(elt$1.clientHeight));
  console.log("updateSize", size);
  $m_Ljapgolly_scalajs_react_Reusable$();
  var this$1 = $n(sizeRef$1);
  var this$2 = $n($as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(this$1.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
  var r = $f_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF__modState__Ljapgolly_scalajs_react_Reusable(this$2);
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O(new $c_sjsr_AnonFunction1(((x$5$2) => {
    $as_s_Option(x$5$2);
    return $m_s_Option$().apply__O__s_Option(size)
  }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
}
/** @constructor */
function $c_Lreactbuild_hooks_ClientSize$() {
  this.Lreactbuild_hooks_ClientSize$__f_reuseClientSize = null;
  this.Lreactbuild_hooks_ClientSize$__f_hook = null;
  $n_Lreactbuild_hooks_ClientSize$ = this;
  var reuseCoord = $m_Ljapgolly_scalajs_react_Reusability$().double__D__F2(1.0);
  var $$x4 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var a$1 = new $c_sr_ObjectRef(null);
  var b$1$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_hooks_ClientSize(a$2);
    var b = $as_Lreactbuild_hooks_ClientSize(b$2);
    var this$3 = $n($p_Lreactbuild_hooks_ClientSize$__b$1$1__sr_LazyRef__F2__F2(this, b$1$lzy, reuseCoord));
    var v1 = $n(a).Lreactbuild_hooks_ClientSize__f_width;
    var v2 = $n(b).Lreactbuild_hooks_ClientSize__f_width;
    if ($uZ(this$3.apply__O__O__O(v1, v2))) {
      var this$4 = $n($p_Lreactbuild_hooks_ClientSize$__b$1$1__sr_LazyRef__F2__F2(this, b$1$lzy, reuseCoord));
      var v1$1 = $n(a).Lreactbuild_hooks_ClientSize__f_height;
      var v2$1 = $n(b).Lreactbuild_hooks_ClientSize__f_height;
      return $uZ(this$4.apply__O__O__O(v1$1, v2$1))
    } else {
      return false
    }
  }));
  a$1.sr_ObjectRef__f_elem = f;
  this.Lreactbuild_hooks_ClientSize$__f_reuseClientSize = $n($$x4).$bar$bar$extension__F2__F2__F2($$x3, $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(a$1.sr_ObjectRef__f_elem)));
  var this$8 = $n($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook).apply__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$First());
  var initialState = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var step = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$FirstStep();
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useState__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$8, initialState, step));
  var $$x11 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x10 = new $c_sjsr_AnonFunction2(((x$1$2, s$2) => {
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$1$2);
    var s = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(s$2);
    return s
  }));
  var $$x9 = new $c_sjsr_AnonFunction2(((x$2$2, s$3$2) => {
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$2$2);
    var s$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(s$3$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$3$2);
      return s$3
    }))
  }));
  var $$x8 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$();
  var this$10 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = this.Lreactbuild_hooks_ClientSize$__f_reuseClientSize;
  var $$x7 = $n($$x8).reusability__F2__F2(this$10.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var this$26 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x11.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x10, $$x9, $$x7, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(this$11))));
  var effect = new $c_sjsr_AnonFunction3(((ref$2, x$4$2, sizeRef$2) => {
    var ref = $as_Ljapgolly_scalajs_react_Ref$FullF(ref$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$4$2);
    var sizeRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(sizeRef$2);
    var $$x14 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x13 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var $$x12 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(ref).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$12 = $m_s_$less$colon$less$();
    var cb = $n($$x14).map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($n($$x13).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x12, this$12.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((elt$2) => {
      var this$ = $p_Lreactbuild_hooks_ClientSize$__updateSize$1__Lorg_scalajs_dom_HTMLElement__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline(this, elt$2, sizeRef);
      var this$14 = $n(this$);
      $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$14);
      var obs = new ResizeObserver(((arg1$2, arg2$2) => {
        $m_Lreactbuild_hooks_ClientSize$().reactbuild$hooks$ClientSize$$$anonfun$hook$8__sjs_js_Array__Lreactbuild_analyze_cost_modules_planner_ResizeObserver__Lorg_scalajs_dom_HTMLElement__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__V(arg1$2, arg2$2, elt$2, sizeRef)
      }));
      var handler = new $c_sjsr_AnonFunction1(((x$2$1) => {
        var this$$1 = $p_Lreactbuild_hooks_ClientSize$__updateSize$1__Lorg_scalajs_dom_HTMLElement__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline(this, elt$2, sizeRef);
        var this$16 = $n(this$$1);
        $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$16)
      }));
      window.addEventListener("resize", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(handler));
      obs.observe(elt$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        obs.disconnect();
        window.removeEventListener("resize", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(handler))
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    })), null);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(cb))
  }));
  var a$3 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().optionalCallback__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_OptionLike__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance);
  var this$25 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$25);
  var $$x6 = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$26, effect, a$3, step$1));
  var $$x5 = new $c_sjsr_AnonFunction3(((x$7$2, s$4$2, x$8$2) => {
    $as_Ljapgolly_scalajs_react_Ref$FullF(x$7$2);
    var s$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(s$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$8$2);
    var this$27 = $n(s$4);
    return $as_s_Option(this$27.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])
  }));
  var this$28 = $m_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$();
  this.Lreactbuild_hooks_ClientSize$__f_hook = $n($$x6).buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1($$x5, new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(this$28))
}
$c_Lreactbuild_hooks_ClientSize$.prototype = new $h_O();
$c_Lreactbuild_hooks_ClientSize$.prototype.constructor = $c_Lreactbuild_hooks_ClientSize$;
/** @constructor */
function $h_Lreactbuild_hooks_ClientSize$() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_ClientSize$.prototype = $c_Lreactbuild_hooks_ClientSize$.prototype;
$c_Lreactbuild_hooks_ClientSize$.prototype.reactbuild$hooks$ClientSize$$$anonfun$hook$8__sjs_js_Array__Lreactbuild_analyze_cost_modules_planner_ResizeObserver__Lorg_scalajs_dom_HTMLElement__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__V = (function(mutations, x$6, elt$1, sizeRef$1) {
  var this$ = $p_Lreactbuild_hooks_ClientSize$__updateSize$1__Lorg_scalajs_dom_HTMLElement__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_callback_Trampoline(this, elt$1, sizeRef$1);
  var this$2 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)
});
var $d_Lreactbuild_hooks_ClientSize$ = new $TypeData().initClass({
  Lreactbuild_hooks_ClientSize$: 0
}, false, "reactbuild.hooks.ClientSize$", {
  Lreactbuild_hooks_ClientSize$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_hooks_ClientSize$.prototype.$classData = $d_Lreactbuild_hooks_ClientSize$;
var $n_Lreactbuild_hooks_ClientSize$;
function $m_Lreactbuild_hooks_ClientSize$() {
  if ((!$n_Lreactbuild_hooks_ClientSize$)) {
    $n_Lreactbuild_hooks_ClientSize$ = new $c_Lreactbuild_hooks_ClientSize$()
  };
  return $n_Lreactbuild_hooks_ClientSize$
}
/** @constructor */
function $c_Lreactbuild_hooks_HooksApiExt$Secondary(api) {
  this.Lreactbuild_hooks_HooksApiExt$Primary__f_api = null;
  this.Lreactbuild_hooks_HooksApiExt$Secondary__f_api = null;
  this.Lreactbuild_hooks_HooksApiExt$Secondary__f_api = api;
  $ct_Lreactbuild_hooks_HooksApiExt$Primary__Ljapgolly_scalajs_react_hooks_Api$Primary__(this, api)
}
$c_Lreactbuild_hooks_HooksApiExt$Secondary.prototype = new $h_Lreactbuild_hooks_HooksApiExt$Primary();
$c_Lreactbuild_hooks_HooksApiExt$Secondary.prototype.constructor = $c_Lreactbuild_hooks_HooksApiExt$Secondary;
/** @constructor */
function $h_Lreactbuild_hooks_HooksApiExt$Secondary() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_HooksApiExt$Secondary.prototype = $c_Lreactbuild_hooks_HooksApiExt$Secondary.prototype;
$c_Lreactbuild_hooks_HooksApiExt$Secondary.prototype.useDragBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O = (function(ref, step) {
  return this.useDragBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((x$2$2) => $as_Ljapgolly_scalajs_react_Ref$FullF($n($as_F1($n($n(step).squash__F1()).apply__O__O(ref))).apply__O__O(x$2$2)))), step)
});
$c_Lreactbuild_hooks_HooksApiExt$Secondary.prototype.useDebouncedBy__s_concurrent_duration_FiniteDuration__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O = (function(interval, deps, r, step) {
  var this$3 = $n(this.Lreactbuild_hooks_HooksApiExt$Secondary__f_api);
  var hook = new $c_sjsr_AnonFunction1(((ctx$2) => new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Lreactbuild_hooks_UseDebounce$().useDebouncedBy__s_concurrent_duration_FiniteDuration__F0__F2__F1(interval, new $c_sjsr_AnonFunction0((() => $n($as_F1($n($n(step).squash__F1()).apply__O__O(deps))).apply__O__O(ctx$2))), r))));
  var this$2 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$2);
  return $f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$3, hook, step, d)
});
$c_Lreactbuild_hooks_HooksApiExt$Secondary.prototype.useDropBy__O__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O = (function(ref, accept, step) {
  return this.useDropBy__F1__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((x$3$2) => $as_Ljapgolly_scalajs_react_Ref$FullF($n($as_F1($n($n(step).squash__F1()).apply__O__O(ref))).apply__O__O(x$3$2)))), new $c_sjsr_AnonFunction1(((x$4$2) => $as_Lreactbuild_hooks_AcceptDrop($n($as_F1($n($n(step).squash__F1()).apply__O__O(accept))).apply__O__O(x$4$2)))), step)
});
$c_Lreactbuild_hooks_HooksApiExt$Secondary.prototype.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O = (function(deps, create, r, step) {
  return this.useDerivedRefBy__F1__F1__F2__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(new $c_sjsr_AnonFunction1(((ctx$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(deps))).apply__O__O(ctx$2))), new $c_sjsr_AnonFunction1(((ctx$3$2) => $as_F1($n($as_F1($n($n(step).squash__F1()).apply__O__O(create))).apply__O__O(ctx$3$2)))), r, step)
});
var $d_Lreactbuild_hooks_HooksApiExt$Secondary = new $TypeData().initClass({
  Lreactbuild_hooks_HooksApiExt$Secondary: 0
}, false, "reactbuild.hooks.HooksApiExt$Secondary", {
  Lreactbuild_hooks_HooksApiExt$Secondary: 1,
  Lreactbuild_hooks_HooksApiExt$Primary: 1,
  O: 1
});
$c_Lreactbuild_hooks_HooksApiExt$Secondary.prototype.$classData = $d_Lreactbuild_hooks_HooksApiExt$Secondary;
/** @constructor */
function $c_Lreactbuild_model_AllocatedTime$() {
  this.Lreactbuild_model_AllocatedTime$__f_codecForAllocatedTime = null;
  $n_Lreactbuild_model_AllocatedTime$ = this;
  var inst$macro$68 = new $c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$68));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_AllocatedTime$__f_codecForAllocatedTime = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_AllocatedTime$.prototype = new $h_O();
$c_Lreactbuild_model_AllocatedTime$.prototype.constructor = $c_Lreactbuild_model_AllocatedTime$;
/** @constructor */
function $h_Lreactbuild_model_AllocatedTime$() {
  /*<skip>*/
}
$h_Lreactbuild_model_AllocatedTime$.prototype = $c_Lreactbuild_model_AllocatedTime$.prototype;
var $d_Lreactbuild_model_AllocatedTime$ = new $TypeData().initClass({
  Lreactbuild_model_AllocatedTime$: 0
}, false, "reactbuild.model.AllocatedTime$", {
  Lreactbuild_model_AllocatedTime$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_AllocatedTime$.prototype.$classData = $d_Lreactbuild_model_AllocatedTime$;
var $n_Lreactbuild_model_AllocatedTime$;
function $m_Lreactbuild_model_AllocatedTime$() {
  if ((!$n_Lreactbuild_model_AllocatedTime$)) {
    $n_Lreactbuild_model_AllocatedTime$ = new $c_Lreactbuild_model_AllocatedTime$()
  };
  return $n_Lreactbuild_model_AllocatedTime$
}
function $p_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "project"));
    var this$4 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "stage"));
    var this$5 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "title"));
    var this$6 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "from"));
    var this$7 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "until"));
    var this$8 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "participant")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_AllocatedTime(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$58 = $n(x0$7).Lreactbuild_model_AllocatedTime__f__id;
        var organization$macro$59 = $n(x0$7).Lreactbuild_model_AllocatedTime__f_organization;
        var project$macro$60 = $n(x0$7).Lreactbuild_model_AllocatedTime__f_project;
        var stage$macro$61 = $n(x0$7).Lreactbuild_model_AllocatedTime__f_stage;
        var title$macro$62 = $n(x0$7).Lreactbuild_model_AllocatedTime__f_title;
        var from$macro$63 = $n(x0$7).Lreactbuild_model_AllocatedTime__f_from;
        var until$macro$64 = $n(x0$7).Lreactbuild_model_AllocatedTime__f_until;
        var participant$macro$65 = $n(x0$7).Lreactbuild_model_AllocatedTime__f_participant;
        return new $c_Lshapeless_$colon$colon(_id$macro$58, new $c_Lshapeless_$colon$colon(organization$macro$59, new $c_Lshapeless_$colon$colon(project$macro$60, new $c_Lshapeless_$colon$colon(stage$macro$61, new $c_Lshapeless_$colon$colon(title$macro$62, new $c_Lshapeless_$colon$colon(from$macro$63, new $c_Lshapeless_$colon$colon(until$macro$64, new $c_Lshapeless_$colon$colon(participant$macro$65, $m_Lshapeless_HNil$()))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$50 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$51 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var project$macro$52 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var stage$macro$53 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var title$macro$54 = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var from$macro$55 = $as_Ljava_time_LocalDateTime($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var until$macro$56 = $as_Ljava_time_LocalDateTime($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var participant$macro$57 = $as_Lreactbuild_common_model_RefTo($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p9)) {
                        return new $c_Lreactbuild_model_AllocatedTime(_id$macro$50, organization$macro$51, project$macro$52, stage$macro$53, title$macro$54, from$macro$55, until$macro$56, participant$macro$57)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "participant"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "until"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "from"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "stage"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    var this$36 = $m_s_$less$colon$less$();
    var ev = this$36.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$66__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_AllocatedTime$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_AllocatedTime$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_AllocatedTime$(), "")), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$43 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "_id"));
    var this$44 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "organization"));
    var this$45 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "project"));
    var this$46 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "stage"));
    var this$47 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "title"));
    var this$48 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "from"));
    var this$49 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "until"));
    var this$50 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "participant")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$62 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "_id"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$64 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "stage"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$66 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "title"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$10);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$71 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$71, "_id"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$73 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "organization"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$75 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$75, "project"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$77 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$77, "stage"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$79 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$79, "title"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$81 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$81, "from"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$83 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "until"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$85 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "participant"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$18);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var this$96 = $m_s_$less$colon$less$();
    var ev$1 = this$96.s_$less$colon$less$__f_singleton;
    var this$97 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$97);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$101 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$113);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$117 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$117);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$121 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$121);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$125 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$125);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$129 = $m_s_$less$colon$less$();
    var ev$2 = this$129.s_$less$colon$less$__f_singleton;
    var this$130 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$130);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$8, ev$2);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$134 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$134);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$138 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$138);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$142 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$142);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$146 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$146);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$150 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$150);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$154 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$154);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$158 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$158);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_inst$macro$1
}
function $p_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__inst$macro$66$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_inst$macro$66 = new $c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31($thiz);
    $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_inst$macro$66
}
/** @constructor */
function $c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2() {
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_inst$macro$1 = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_inst$macro$66 = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_bitmap$0 = 0
}
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2.prototype = new $h_O();
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2.prototype.constructor = $c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2;
/** @constructor */
function $h_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2.prototype = $c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2.prototype;
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_inst$macro$1)
});
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2.prototype.inst$macro$66__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__inst$macro$66$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2__f_inst$macro$66)
});
var $d_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2 = new $TypeData().initClass({
  Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2: 0
}, false, "reactbuild.model.AllocatedTime$anon$lazy$macro$67$2", {
  Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2.prototype.$classData = $d_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2;
/** @constructor */
function $c_Lreactbuild_model_BuildingPart$() {
  this.Lreactbuild_model_BuildingPart$__f_codecForBuildingPart = null;
  $n_Lreactbuild_model_BuildingPart$ = this;
  var inst$macro$36 = new $c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_BuildingPart$__f_codecForBuildingPart = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_BuildingPart$.prototype = new $h_O();
$c_Lreactbuild_model_BuildingPart$.prototype.constructor = $c_Lreactbuild_model_BuildingPart$;
/** @constructor */
function $h_Lreactbuild_model_BuildingPart$() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingPart$.prototype = $c_Lreactbuild_model_BuildingPart$.prototype;
var $d_Lreactbuild_model_BuildingPart$ = new $TypeData().initClass({
  Lreactbuild_model_BuildingPart$: 0
}, false, "reactbuild.model.BuildingPart$", {
  Lreactbuild_model_BuildingPart$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingPart$.prototype.$classData = $d_Lreactbuild_model_BuildingPart$;
var $n_Lreactbuild_model_BuildingPart$;
function $m_Lreactbuild_model_BuildingPart$() {
  if ((!$n_Lreactbuild_model_BuildingPart$)) {
    $n_Lreactbuild_model_BuildingPart$ = new $c_Lreactbuild_model_BuildingPart$()
  };
  return $n_Lreactbuild_model_BuildingPart$
}
function $p_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "label"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "parent")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_BuildingPart(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$30 = $n(x0$7).Lreactbuild_model_BuildingPart__f__id;
        var organization$macro$31 = $n(x0$7).Lreactbuild_model_BuildingPart__f_organization;
        var label$macro$32 = $n(x0$7).Lreactbuild_model_BuildingPart__f_label;
        var parent$macro$33 = $n(x0$7).Lreactbuild_model_BuildingPart__f_parent;
        return new $c_Lshapeless_$colon$colon(_id$macro$30, new $c_Lshapeless_$colon$colon(organization$macro$31, new $c_Lshapeless_$colon$colon(label$macro$32, new $c_Lshapeless_$colon$colon(parent$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$26 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$27 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var label$macro$28 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var parent$macro$29 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_BuildingPart(_id$macro$26, organization$macro$27, label$macro$28, parent$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "label"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$24 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "_id"));
    var this$25 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "organization"));
    var this$26 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "label"));
    var this$27 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "parent")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "organization"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "label"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "parent"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$48 = $m_s_$less$colon$less$();
    var ev$1 = this$48.s_$less$colon$less$__f_singleton;
    var this$49 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$49);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$53 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$61);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$65 = $m_s_$less$colon$less$();
    var ev$2 = this$65.s_$less$colon$less$__f_singleton;
    var this$66 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$78);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_inst$macro$1
}
function $p_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_inst$macro$34 = new $c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16($thiz);
    $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3() {
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_inst$macro$1 = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_inst$macro$34 = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_bitmap$0 = 0
}
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3.prototype = new $h_O();
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3.prototype.constructor = $c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3;
/** @constructor */
function $h_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3.prototype = $c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3.prototype;
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_inst$macro$1)
});
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3__f_inst$macro$34)
});
var $d_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3 = new $TypeData().initClass({
  Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3: 0
}, false, "reactbuild.model.BuildingPart$anon$lazy$macro$35$3", {
  Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3.prototype.$classData = $d_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3;
/** @constructor */
function $c_Lreactbuild_model_BuildingSiteStage$() {
  this.Lreactbuild_model_BuildingSiteStage$__f_localDateOrdering = null;
  this.Lreactbuild_model_BuildingSiteStage$__f_encodeBuildingSiteStage = null;
  this.Lreactbuild_model_BuildingSiteStage$__f_decodeBuildingSiteStage = null;
  $n_Lreactbuild_model_BuildingSiteStage$ = this;
  var this$3 = $n($m_s_package$().s_package$__f_Ordering);
  var this$2 = $m_s_$less$colon$less$();
  var asComparable = this$2.s_$less$colon$less$__f_singleton;
  this.Lreactbuild_model_BuildingSiteStage$__f_localDateOrdering = new $c_s_math_LowPriorityOrderingImplicits$$anon$2(this$3, asComparable);
  var inst$macro$20 = new $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3().inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var encode = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_BuildingSiteStage$__f_encodeBuildingSiteStage = $as_Lio_circe_Encoder$AsObject(encode.value__O());
  var inst$macro$40 = new $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1().inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => inst$macro$40));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t$1);
  this.Lreactbuild_model_BuildingSiteStage$__f_decodeBuildingSiteStage = $as_Lio_circe_Decoder(decode.value__O())
}
$c_Lreactbuild_model_BuildingSiteStage$.prototype = new $h_O();
$c_Lreactbuild_model_BuildingSiteStage$.prototype.constructor = $c_Lreactbuild_model_BuildingSiteStage$;
/** @constructor */
function $h_Lreactbuild_model_BuildingSiteStage$() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingSiteStage$.prototype = $c_Lreactbuild_model_BuildingSiteStage$.prototype;
$c_Lreactbuild_model_BuildingSiteStage$.prototype.encodeTypedRange__Lio_circe_Encoder__Lio_circe_Encoder = (function(encT) {
  $m_Lio_circe_Encoder$();
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Lcom_iz2use_common_TypedRange(c$2);
    var this$13 = $m_Lio_circe_Json$();
    var value = $n(c).Lcom_iz2use_common_TypedRange__f_from;
    var y = $n(encT).apply__O__Lio_circe_Json(value);
    var $$x1 = $ct_T2__O__O__(new $c_T2(), "from", y);
    var value$1 = $n(c).Lcom_iz2use_common_TypedRange__f_until;
    var y$1 = $n(encT).apply__O__Lio_circe_Json(value$1);
    var array = [$$x1, $ct_T2__O__O__(new $c_T2(), "until", y$1)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return this$13.fromFields__sc_Iterable__Lio_circe_Json(fields)
  }));
  return new $c_Lio_circe_Encoder$$anon$3(f)
});
$c_Lreactbuild_model_BuildingSiteStage$.prototype.decodeTypedRange__Lio_circe_Decoder__s_math_Ordering__Lio_circe_Decoder = (function(decT, ordering) {
  $m_Lio_circe_Decoder$();
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Lio_circe_HCursor(c$2);
    var this$2 = $n($n(c).downField__T__Lio_circe_ACursor("from"));
    var this$3 = $n($n(decT).tryDecode__Lio_circe_ACursor__s_util_Either(this$2));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var this$4 = $n($n(c).downField__T__Lio_circe_ACursor("until"));
      var this$5 = $n($n(decT).tryDecode__Lio_circe_ACursor__s_util_Either(this$4));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$5);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        return new $c_s_util_Right(new $c_Lcom_iz2use_common_TypedRange(b, b$1, ordering))
      } else {
        return this$5
      }
    } else {
      return this$3
    }
  }));
  return new $c_Lio_circe_Decoder$$anon$16(f)
});
var $d_Lreactbuild_model_BuildingSiteStage$ = new $TypeData().initClass({
  Lreactbuild_model_BuildingSiteStage$: 0
}, false, "reactbuild.model.BuildingSiteStage$", {
  Lreactbuild_model_BuildingSiteStage$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingSiteStage$.prototype.$classData = $d_Lreactbuild_model_BuildingSiteStage$;
var $n_Lreactbuild_model_BuildingSiteStage$;
function $m_Lreactbuild_model_BuildingSiteStage$() {
  if ((!$n_Lreactbuild_model_BuildingSiteStage$)) {
    $n_Lreactbuild_model_BuildingSiteStage$ = new $c_Lreactbuild_model_BuildingSiteStage$()
  };
  return $n_Lreactbuild_model_BuildingSiteStage$
}
function $p_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "range"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "stage")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_BuildingSiteStage(x0$7$2);
      if ((x0$7 !== null)) {
        var range$macro$16 = $n(x0$7).Lreactbuild_model_BuildingSiteStage__f_range;
        var stage$macro$17 = $n(x0$7).Lreactbuild_model_BuildingSiteStage__f_stage;
        return new $c_Lshapeless_$colon$colon(range$macro$16, new $c_Lshapeless_$colon$colon(stage$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var range$macro$14 = $as_Lcom_iz2use_common_TypedRange($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var stage$macro$15 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_BuildingSiteStage(range$macro$14, stage$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "stage"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "range"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "range"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "stage"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_inst$macro$1
}
function $p_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__inst$macro$18$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_inst$macro$18 = new $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26($thiz);
    $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3() {
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_inst$macro$1 = null;
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_inst$macro$18 = null;
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_bitmap$0 = 0
}
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3.prototype = new $h_O();
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3.prototype.constructor = $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3;
/** @constructor */
function $h_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3.prototype = $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3.prototype;
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3.prototype.inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((1 & this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_inst$macro$1)
});
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3.prototype.inst$macro$18__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((2 & this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__inst$macro$18$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3__f_inst$macro$18)
});
var $d_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3 = new $TypeData().initClass({
  Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3: 0
}, false, "reactbuild.model.BuildingSiteStage$anon$lazy$macro$19$3", {
  Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3.prototype.$classData = $d_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3;
function $p_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "range"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "stage")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_BuildingSiteStage(x0$15$2);
      if ((x0$15 !== null)) {
        var range$macro$36 = $n(x0$15).Lreactbuild_model_BuildingSiteStage__f_range;
        var stage$macro$37 = $n(x0$15).Lreactbuild_model_BuildingSiteStage__f_stage;
        return new $c_Lshapeless_$colon$colon(range$macro$36, new $c_Lshapeless_$colon$colon(stage$macro$37, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var range$macro$34 = $as_Lcom_iz2use_common_TypedRange($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var stage$macro$35 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_BuildingSiteStage(range$macro$34, stage$macro$35)
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "stage"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "range"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$38__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "range"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "stage")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "range"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "stage"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_inst$macro$21 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_inst$macro$21
}
function $p_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_inst$macro$38 = new $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27($thiz);
    $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_inst$macro$38
}
/** @constructor */
function $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1() {
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_inst$macro$21 = null;
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_inst$macro$38 = null;
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1.prototype = new $h_O();
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1.prototype.constructor = $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1;
/** @constructor */
function $h_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1.prototype = $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1.prototype;
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1.prototype.inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((1 & this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_inst$macro$21)
});
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1.prototype.inst$macro$38__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1__f_inst$macro$38)
});
var $d_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1 = new $TypeData().initClass({
  Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1: 0
}, false, "reactbuild.model.BuildingSiteStage$anon$lazy$macro$39$1", {
  Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1.prototype.$classData = $d_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1;
/** @constructor */
function $c_Lreactbuild_model_BuildingStage$() {
  this.Lreactbuild_model_BuildingStage$__f_codecForBuildingStage = null;
  $n_Lreactbuild_model_BuildingStage$ = this;
  var inst$macro$36 = new $c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_BuildingStage$__f_codecForBuildingStage = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_BuildingStage$.prototype = new $h_O();
$c_Lreactbuild_model_BuildingStage$.prototype.constructor = $c_Lreactbuild_model_BuildingStage$;
/** @constructor */
function $h_Lreactbuild_model_BuildingStage$() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingStage$.prototype = $c_Lreactbuild_model_BuildingStage$.prototype;
var $d_Lreactbuild_model_BuildingStage$ = new $TypeData().initClass({
  Lreactbuild_model_BuildingStage$: 0
}, false, "reactbuild.model.BuildingStage$", {
  Lreactbuild_model_BuildingStage$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingStage$.prototype.$classData = $d_Lreactbuild_model_BuildingStage$;
var $n_Lreactbuild_model_BuildingStage$;
function $m_Lreactbuild_model_BuildingStage$() {
  if ((!$n_Lreactbuild_model_BuildingStage$)) {
    $n_Lreactbuild_model_BuildingStage$ = new $c_Lreactbuild_model_BuildingStage$()
  };
  return $n_Lreactbuild_model_BuildingStage$
}
function $p_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "parent")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_BuildingStage(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$30 = $n(x0$7).Lreactbuild_model_BuildingStage__f__id;
        var organization$macro$31 = $n(x0$7).Lreactbuild_model_BuildingStage__f_organization;
        var name$macro$32 = $n(x0$7).Lreactbuild_model_BuildingStage__f_name;
        var parent$macro$33 = $n(x0$7).Lreactbuild_model_BuildingStage__f_parent;
        return new $c_Lshapeless_$colon$colon(_id$macro$30, new $c_Lshapeless_$colon$colon(organization$macro$31, new $c_Lshapeless_$colon$colon(name$macro$32, new $c_Lshapeless_$colon$colon(parent$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$26 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$27 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$28 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var parent$macro$29 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_BuildingStage(_id$macro$26, organization$macro$27, name$macro$28, parent$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_BuildingStage$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_BuildingStage$(), $m_s_None$())), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$27 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "_id"));
    var this$28 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "organization"));
    var this$29 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "name"));
    var this$30 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "parent")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "_id"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "parent"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$44 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "organization"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$48 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$50 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "parent"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$57 = $m_s_$less$colon$less$();
    var ev$1 = this$57.s_$less$colon$less$__f_singleton;
    var this$58 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$70);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$74 = $m_s_$less$colon$less$();
    var ev$2 = this$74.s_$less$colon$less$__f_singleton;
    var this$75 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$75);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$79 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$83);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$87 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$87);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_inst$macro$1
}
function $p_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_inst$macro$34 = new $c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13($thiz);
    $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1() {
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_inst$macro$34 = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1.prototype = new $h_O();
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1.prototype.constructor = $c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1;
/** @constructor */
function $h_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1.prototype = $c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1.prototype;
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_inst$macro$1)
});
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1__f_inst$macro$34)
});
var $d_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1 = new $TypeData().initClass({
  Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1: 0
}, false, "reactbuild.model.BuildingStage$anon$lazy$macro$35$1", {
  Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1.prototype.$classData = $d_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1;
/** @constructor */
function $c_Lreactbuild_model_CachedExpression$() {
  /*<skip>*/
}
$c_Lreactbuild_model_CachedExpression$.prototype = new $h_O();
$c_Lreactbuild_model_CachedExpression$.prototype.constructor = $c_Lreactbuild_model_CachedExpression$;
/** @constructor */
function $h_Lreactbuild_model_CachedExpression$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CachedExpression$.prototype = $c_Lreactbuild_model_CachedExpression$.prototype;
$c_Lreactbuild_model_CachedExpression$.prototype.encodeCachedExpression__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder = (function(encExprA, encOptB) {
  var inst$macro$20 = new $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7(encExprA, encOptB).inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var encode = new $c_Lshapeless_Lazy$$anon$1(t);
  return $as_Lio_circe_Encoder$AsObject(encode.value__O())
});
$c_Lreactbuild_model_CachedExpression$.prototype.decodeCachedExpression__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder = (function(decExprA, decOptB) {
  var inst$macro$20 = new $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8(decExprA, decOptB).inst$macro$1__Lio_circe_generic_extras_decoding_ConfiguredDecoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t);
  return $as_Lio_circe_Decoder(decode.value__O())
});
var $d_Lreactbuild_model_CachedExpression$ = new $TypeData().initClass({
  Lreactbuild_model_CachedExpression$: 0
}, false, "reactbuild.model.CachedExpression$", {
  Lreactbuild_model_CachedExpression$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CachedExpression$.prototype.$classData = $d_Lreactbuild_model_CachedExpression$;
var $n_Lreactbuild_model_CachedExpression$;
function $m_Lreactbuild_model_CachedExpression$() {
  if ((!$n_Lreactbuild_model_CachedExpression$)) {
    $n_Lreactbuild_model_CachedExpression$ = new $c_Lreactbuild_model_CachedExpression$()
  };
  return $n_Lreactbuild_model_CachedExpression$
}
function $p_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "expression"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "calculatedValue")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_CachedExpression(x0$7$2);
      if ((x0$7 !== null)) {
        var expression$macro$16 = $n(x0$7).Lreactbuild_model_CachedExpression__f_expression;
        var calculatedValue$macro$17 = $n(x0$7).Lreactbuild_model_CachedExpression__f_calculatedValue;
        return new $c_Lshapeless_$colon$colon(expression$macro$16, new $c_Lshapeless_$colon$colon(calculatedValue$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var expression$macro$14 = $as_Lreactbuild_model_Expression($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var calculatedValue$macro$15 = $n(p2).Lshapeless_$colon$colon__f_head;
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_CachedExpression(expression$macro$14, calculatedValue$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "calculatedValue"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "expression"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "expression"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "calculatedValue"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_inst$macro$1 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_inst$macro$1
}
function $p_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__inst$macro$18$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_inst$macro$18 = new $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80($thiz);
    $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7(encExprA$1, encOptB$1) {
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_inst$macro$1 = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_inst$macro$18 = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_bitmap$0 = 0;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_encExprA$1 = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_encOptB$1 = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_encExprA$1 = encExprA$1;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_encOptB$1 = encOptB$1
}
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7.prototype = new $h_O();
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7.prototype.constructor = $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7;
/** @constructor */
function $h_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7() {
  /*<skip>*/
}
$h_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7.prototype = $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7.prototype;
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7.prototype.inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((1 & this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_inst$macro$1)
});
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7.prototype.inst$macro$18__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((2 & this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__inst$macro$18$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_inst$macro$18)
});
var $d_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7 = new $TypeData().initClass({
  Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7: 0
}, false, "reactbuild.model.CachedExpression$anon$lazy$macro$19$7", {
  Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7.prototype.$classData = $d_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7;
function $p_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__inst$macro$1$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "expression"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "calculatedValue")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_CachedExpression(x0$7$2);
      if ((x0$7 !== null)) {
        var expression$macro$16 = $n(x0$7).Lreactbuild_model_CachedExpression__f_expression;
        var calculatedValue$macro$17 = $n(x0$7).Lreactbuild_model_CachedExpression__f_calculatedValue;
        return new $c_Lshapeless_$colon$colon(expression$macro$16, new $c_Lshapeless_$colon$colon(calculatedValue$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var expression$macro$14 = $as_Lreactbuild_model_Expression($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var calculatedValue$macro$15 = $n(p2).Lshapeless_$colon$colon__f_head;
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_CachedExpression(expression$macro$14, calculatedValue$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "calculatedValue"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "expression"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "expression"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "calculatedValue")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "expression"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "calculatedValue"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_inst$macro$1 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_inst$macro$1
}
function $p_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__inst$macro$18$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_inst$macro$18 = new $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81($thiz);
    $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8(decExprA$1, decOptB$1) {
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_inst$macro$1 = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_inst$macro$18 = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_bitmap$0 = 0;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_decExprA$1 = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_decOptB$1 = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_decExprA$1 = decExprA$1;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_decOptB$1 = decOptB$1
}
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8.prototype = new $h_O();
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8.prototype.constructor = $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8;
/** @constructor */
function $h_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8() {
  /*<skip>*/
}
$h_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8.prototype = $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8.prototype;
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8.prototype.inst$macro$1__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((1 & this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__inst$macro$1$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_inst$macro$1)
});
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8.prototype.inst$macro$18__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__inst$macro$18$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_inst$macro$18)
});
var $d_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8 = new $TypeData().initClass({
  Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8: 0
}, false, "reactbuild.model.CachedExpression$anon$lazy$macro$19$8", {
  Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8.prototype.$classData = $d_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8;
/** @constructor */
function $c_Lreactbuild_model_ChildWithParent$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ChildWithParent$.prototype = new $h_O();
$c_Lreactbuild_model_ChildWithParent$.prototype.constructor = $c_Lreactbuild_model_ChildWithParent$;
/** @constructor */
function $h_Lreactbuild_model_ChildWithParent$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ChildWithParent$.prototype = $c_Lreactbuild_model_ChildWithParent$.prototype;
$c_Lreactbuild_model_ChildWithParent$.prototype.decodeChildWithParent__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder = (function(decC, decP) {
  $m_Lio_circe_Decoder$();
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Lio_circe_HCursor(c$2);
    var this$2 = $n($n(c).downField__T__Lio_circe_ACursor("c"));
    var this$3 = $n($n(decC).tryDecode__Lio_circe_ACursor__s_util_Either(this$2));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var this$4 = $n($n(c).downField__T__Lio_circe_ACursor("p"));
      var this$5 = $n($n(decP).tryDecode__Lio_circe_ACursor__s_util_Either(this$4));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$5);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        return new $c_s_util_Right(new $c_Lreactbuild_model_ChildWithParent(b, b$1))
      } else {
        return this$5
      }
    } else {
      return this$3
    }
  }));
  return new $c_Lio_circe_Decoder$$anon$16(f)
});
var $d_Lreactbuild_model_ChildWithParent$ = new $TypeData().initClass({
  Lreactbuild_model_ChildWithParent$: 0
}, false, "reactbuild.model.ChildWithParent$", {
  Lreactbuild_model_ChildWithParent$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ChildWithParent$.prototype.$classData = $d_Lreactbuild_model_ChildWithParent$;
var $n_Lreactbuild_model_ChildWithParent$;
function $m_Lreactbuild_model_ChildWithParent$() {
  if ((!$n_Lreactbuild_model_ChildWithParent$)) {
    $n_Lreactbuild_model_ChildWithParent$ = new $c_Lreactbuild_model_ChildWithParent$()
  };
  return $n_Lreactbuild_model_ChildWithParent$
}
/** @constructor */
function $c_Lreactbuild_model_CommonData$() {
  this.Lreactbuild_model_CommonData$__f_codecForCommonData = null;
  $n_Lreactbuild_model_CommonData$ = this;
  var inst$macro$92 = new $c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$92));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_CommonData$__f_codecForCommonData = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_CommonData$.prototype = new $h_O();
$c_Lreactbuild_model_CommonData$.prototype.constructor = $c_Lreactbuild_model_CommonData$;
/** @constructor */
function $h_Lreactbuild_model_CommonData$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommonData$.prototype = $c_Lreactbuild_model_CommonData$.prototype;
var $d_Lreactbuild_model_CommonData$ = new $TypeData().initClass({
  Lreactbuild_model_CommonData$: 0
}, false, "reactbuild.model.CommonData$", {
  Lreactbuild_model_CommonData$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommonData$.prototype.$classData = $d_Lreactbuild_model_CommonData$;
var $n_Lreactbuild_model_CommonData$;
function $m_Lreactbuild_model_CommonData$() {
  if ((!$n_Lreactbuild_model_CommonData$)) {
    $n_Lreactbuild_model_CommonData$ = new $c_Lreactbuild_model_CommonData$()
  };
  return $n_Lreactbuild_model_CommonData$
}
function $p_Lreactbuild_model_CommonData$anon$lazy$macro$91$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "persons"));
    var this$2 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "personAnnotations"));
    var this$3 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "buildingParts"));
    var this$4 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "buildingSites"));
    var this$5 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "buildingStages"));
    var this$6 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "buildingSiteStages"));
    var this$7 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "resources"));
    var this$8 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "products"));
    var this$9 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "listTemplates"));
    var this$10 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "terms"));
    var this$11 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "organizationUsers")), $m_Lshapeless_HNil$())))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_CommonData(x0$7$2);
      if ((x0$7 !== null)) {
        var persons$macro$79 = $n(x0$7).Lreactbuild_model_CommonData__f_persons;
        var personAnnotations$macro$80 = $n(x0$7).Lreactbuild_model_CommonData__f_personAnnotations;
        var buildingParts$macro$81 = $n(x0$7).Lreactbuild_model_CommonData__f_buildingParts;
        var buildingSites$macro$82 = $n(x0$7).Lreactbuild_model_CommonData__f_buildingSites;
        var buildingStages$macro$83 = $n(x0$7).Lreactbuild_model_CommonData__f_buildingStages;
        var buildingSiteStages$macro$84 = $n(x0$7).Lreactbuild_model_CommonData__f_buildingSiteStages;
        var resources$macro$85 = $n(x0$7).Lreactbuild_model_CommonData__f_resources;
        var products$macro$86 = $n(x0$7).Lreactbuild_model_CommonData__f_products;
        var listTemplates$macro$87 = $n(x0$7).Lreactbuild_model_CommonData__f_listTemplates;
        var terms$macro$88 = $n(x0$7).Lreactbuild_model_CommonData__f_terms;
        var organizationUsers$macro$89 = $n(x0$7).Lreactbuild_model_CommonData__f_organizationUsers;
        return new $c_Lshapeless_$colon$colon(persons$macro$79, new $c_Lshapeless_$colon$colon(personAnnotations$macro$80, new $c_Lshapeless_$colon$colon(buildingParts$macro$81, new $c_Lshapeless_$colon$colon(buildingSites$macro$82, new $c_Lshapeless_$colon$colon(buildingStages$macro$83, new $c_Lshapeless_$colon$colon(buildingSiteStages$macro$84, new $c_Lshapeless_$colon$colon(resources$macro$85, new $c_Lshapeless_$colon$colon(products$macro$86, new $c_Lshapeless_$colon$colon(listTemplates$macro$87, new $c_Lshapeless_$colon$colon(terms$macro$88, new $c_Lshapeless_$colon$colon(organizationUsers$macro$89, $m_Lshapeless_HNil$())))))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var persons$macro$68 = $as_sci_List($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var personAnnotations$macro$69 = $as_sci_Map($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var buildingParts$macro$70 = $as_sci_List($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var buildingSites$macro$71 = $as_sci_List($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var buildingStages$macro$72 = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var buildingSiteStages$macro$73 = $as_sci_Map($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var resources$macro$74 = $as_sci_List($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var products$macro$75 = $as_sci_List($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var listTemplates$macro$76 = $as_sci_List($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var terms$macro$77 = $as_sci_List($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                          if ((p11 !== null)) {
                            var organizationUsers$macro$78 = $as_sci_List($n(p11).Lshapeless_$colon$colon__f_head);
                            var p12 = $as_Lshapeless_HNil($n(p11).Lshapeless_$colon$colon__f_tail);
                            var x = $m_Lshapeless_HNil$();
                            if ((x === p12)) {
                              return new $c_Lreactbuild_model_CommonData(persons$macro$68, personAnnotations$macro$69, buildingParts$macro$70, buildingSites$macro$71, buildingStages$macro$72, buildingSiteStages$macro$73, resources$macro$74, products$macro$75, listTemplates$macro$76, terms$macro$77, organizationUsers$macro$78)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "organizationUsers"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "terms"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "listTemplates"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "products"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "resources"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "buildingSiteStages"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "buildingStages"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "buildingSites"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "buildingParts"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "personAnnotations"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "persons"));
    new $c_Lshapeless_Witness$$anon$1(value0$10);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    var this$48 = $m_s_$less$colon$less$();
    var ev = this$48.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$90__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$52 = $m_s_Symbol$();
    var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "persons"));
    var this$53 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "personAnnotations"));
    var this$54 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "buildingParts"));
    var this$55 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "buildingSites"));
    var this$56 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "buildingStages"));
    var this$57 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "buildingSiteStages"));
    var this$58 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "resources"));
    var this$59 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "products"));
    var this$60 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "listTemplates"));
    var this$61 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "terms"));
    var this$62 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "organizationUsers")), $m_Lshapeless_HNil$())))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var tailHelper$8 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$7);
    var tailHelper$9 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$8);
    var tailHelper$10 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$9);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$10);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$77 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$77, "persons"));
    var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$79 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$79, "personAnnotations"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$81 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$81, "buildingParts"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$83 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "buildingSites"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$85 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "buildingStages"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$87 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$87, "buildingSiteStages"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$89 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$89, "resources"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$91 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$91, "products"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lshapeless_Witness$();
    var this$93 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "listTemplates"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$95 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$95, "terms"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lshapeless_Witness$();
    var this$97 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$97, "organizationUsers"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$21);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var kt$9 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var kt$10 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$9, kt$9);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$10, kt$10);
    var this$111 = $m_s_$less$colon$less$();
    var ev$1 = this$111.s_$less$colon$less$__f_singleton;
    var this$112 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$112);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$116 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$116);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$120 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$120);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$124 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$124);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$128 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$128);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$132 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$132);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$136 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$136);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$140 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$140);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$144 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$144);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$148 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$148);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$152 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$152);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$9, tttvs$9);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$156 = $m_s_$less$colon$less$();
    var ev$2 = this$156.s_$less$colon$less$__f_singleton;
    var this$157 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$157);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$11, ev$2);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$161 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$161);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$165 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$165);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$169 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$169);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$173 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$173);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$177 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$177);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$14, tttvs$14);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$181 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$181);
    var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$15, tttvs$15);
    var u$16 = new $c_Lshapeless_Lub$$anon$4();
    var this$185 = $m_sci_List$();
    var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$185);
    var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$16, tttvs$16);
    var u$17 = new $c_Lshapeless_Lub$$anon$4();
    var this$189 = $m_sci_List$();
    var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$189);
    var tttvs$18 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$17, tttvs$17);
    var u$18 = new $c_Lshapeless_Lub$$anon$4();
    var this$193 = $m_sci_List$();
    var cbf$20 = new $c_sc_IterableFactory$ToFactory(this$193);
    var tttvs$19 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$20, u$18, tttvs$18);
    var u$19 = new $c_Lshapeless_Lub$$anon$4();
    var this$197 = $m_sci_List$();
    var cbf$21 = new $c_sc_IterableFactory$ToFactory(this$197);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$21, u$19, tttvs$19);
    $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_inst$macro$1
}
function $p_Lreactbuild_model_CommonData$anon$lazy$macro$91$1__inst$macro$90$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_inst$macro$90 = new $c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32($thiz);
    $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_inst$macro$90
}
/** @constructor */
function $c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1() {
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_inst$macro$90 = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1.prototype = new $h_O();
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1.prototype.constructor = $c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1;
/** @constructor */
function $h_Lreactbuild_model_CommonData$anon$lazy$macro$91$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommonData$anon$lazy$macro$91$1.prototype = $c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1.prototype;
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CommonData$anon$lazy$macro$91$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_inst$macro$1)
});
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1.prototype.inst$macro$90__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CommonData$anon$lazy$macro$91$1__inst$macro$90$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1__f_inst$macro$90)
});
var $d_Lreactbuild_model_CommonData$anon$lazy$macro$91$1 = new $TypeData().initClass({
  Lreactbuild_model_CommonData$anon$lazy$macro$91$1: 0
}, false, "reactbuild.model.CommonData$anon$lazy$macro$91$1", {
  Lreactbuild_model_CommonData$anon$lazy$macro$91$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1.prototype.$classData = $d_Lreactbuild_model_CommonData$anon$lazy$macro$91$1;
/** @constructor */
function $c_Lreactbuild_model_Communication$() {
  this.Lreactbuild_model_Communication$__f_keyMapper = null;
  this.Lreactbuild_model_Communication$__f_codecForCommunication = null;
  $n_Lreactbuild_model_Communication$ = this;
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_model_Communication(x$1$2);
    return $n(x$1).Lreactbuild_model_Communication__f__id
  }));
  var ev = $m_Lreactbuild_common_model_RefTo$().keyMapper__Lcom_iz2use_common_KeyMapper();
  this.Lreactbuild_model_Communication$__f_keyMapper = new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f);
  var inst$macro$84 = new $c_Lreactbuild_model_Communication$anon$lazy$macro$83$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$84));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_Communication$__f_codecForCommunication = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_Communication$.prototype = new $h_O();
$c_Lreactbuild_model_Communication$.prototype.constructor = $c_Lreactbuild_model_Communication$;
/** @constructor */
function $h_Lreactbuild_model_Communication$() {
  /*<skip>*/
}
$h_Lreactbuild_model_Communication$.prototype = $c_Lreactbuild_model_Communication$.prototype;
var $d_Lreactbuild_model_Communication$ = new $TypeData().initClass({
  Lreactbuild_model_Communication$: 0
}, false, "reactbuild.model.Communication$", {
  Lreactbuild_model_Communication$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Communication$.prototype.$classData = $d_Lreactbuild_model_Communication$;
var $n_Lreactbuild_model_Communication$;
function $m_Lreactbuild_model_Communication$() {
  if ((!$n_Lreactbuild_model_Communication$)) {
    $n_Lreactbuild_model_Communication$ = new $c_Lreactbuild_model_Communication$()
  };
  return $n_Lreactbuild_model_Communication$
}
function $p_Lreactbuild_model_Communication$anon$lazy$macro$83$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "persons"));
    var this$4 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "senderAddress"));
    var this$5 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "receiverAddress"));
    var this$6 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "date"));
    var this$7 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "subject"));
    var this$8 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "bodies"));
    var this$9 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "attachments"));
    var this$10 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "headers")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_Communication(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$72 = $n(x0$7).Lreactbuild_model_Communication__f__id;
        var organization$macro$73 = $n(x0$7).Lreactbuild_model_Communication__f_organization;
        var persons$macro$74 = $n(x0$7).Lreactbuild_model_Communication__f_persons;
        var senderAddress$macro$75 = $n(x0$7).Lreactbuild_model_Communication__f_senderAddress;
        var receiverAddress$macro$76 = $n(x0$7).Lreactbuild_model_Communication__f_receiverAddress;
        var date$macro$77 = $n(x0$7).Lreactbuild_model_Communication__f_date;
        var subject$macro$78 = $n(x0$7).Lreactbuild_model_Communication__f_subject;
        var bodies$macro$79 = $n(x0$7).Lreactbuild_model_Communication__f_bodies;
        var attachments$macro$80 = $n(x0$7).Lreactbuild_model_Communication__f_attachments;
        var headers$macro$81 = $n(x0$7).Lreactbuild_model_Communication__f_headers;
        return new $c_Lshapeless_$colon$colon(_id$macro$72, new $c_Lshapeless_$colon$colon(organization$macro$73, new $c_Lshapeless_$colon$colon(persons$macro$74, new $c_Lshapeless_$colon$colon(senderAddress$macro$75, new $c_Lshapeless_$colon$colon(receiverAddress$macro$76, new $c_Lshapeless_$colon$colon(date$macro$77, new $c_Lshapeless_$colon$colon(subject$macro$78, new $c_Lshapeless_$colon$colon(bodies$macro$79, new $c_Lshapeless_$colon$colon(attachments$macro$80, new $c_Lshapeless_$colon$colon(headers$macro$81, $m_Lshapeless_HNil$()))))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$62 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$63 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var persons$macro$64 = $as_sci_Seq($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var senderAddress$macro$65 = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var receiverAddress$macro$66 = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var date$macro$67 = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var subject$macro$68 = $as_T($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var bodies$macro$69 = $as_sci_Seq($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var attachments$macro$70 = $as_sci_Seq($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var headers$macro$71 = $as_sci_Map($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                          var x = $m_Lshapeless_HNil$();
                          if ((x === p11)) {
                            return new $c_Lreactbuild_model_Communication(_id$macro$62, organization$macro$63, persons$macro$64, senderAddress$macro$65, receiverAddress$macro$66, date$macro$67, subject$macro$68, bodies$macro$69, attachments$macro$70, headers$macro$71)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "headers"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "attachments"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "bodies"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "subject"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "receiverAddress"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "senderAddress"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "persons"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    var this$44 = $m_s_$less$colon$less$();
    var ev = this$44.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$82__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Communication$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Communication$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Communication$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Communication$(), $n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$())), $m_Lshapeless_HNil$()))))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$53 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "_id"));
    var this$54 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "organization"));
    var this$55 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "persons"));
    var this$56 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "senderAddress"));
    var this$57 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "receiverAddress"));
    var this$58 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "date"));
    var this$59 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "subject"));
    var this$60 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "bodies"));
    var this$61 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "attachments"));
    var this$62 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "headers")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var tailHelper$8 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var tailHelper$9 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$8);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$9);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$76 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "persons"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$78 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "bodies"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$80 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "attachments"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$82 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$82, "headers"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$88 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "_id"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$90 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "organization"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$92 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "persons"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$94 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$94, "senderAddress"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$96 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$96, "receiverAddress"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lshapeless_Witness$();
    var this$98 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$98, "date"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$100 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$100, "subject"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lshapeless_Witness$();
    var this$102 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$102, "bodies"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$21);
    $m_Lshapeless_Witness$();
    var this$104 = $m_s_Symbol$();
    var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$104, "attachments"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$22);
    $m_Lshapeless_Witness$();
    var this$106 = $m_s_Symbol$();
    var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$106, "headers"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$23);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var kt$9 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$9, kt$9);
    var this$119 = $m_s_$less$colon$less$();
    var ev$1 = this$119.s_$less$colon$less$__f_singleton;
    var this$120 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$120);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$124 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$124);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$128 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$128);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$132 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$132);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$136 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$136);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$140 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$140);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$144 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$144);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$148 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$148);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$152 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$152);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$156 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$156);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$8, tttvs$8);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$160 = $m_s_$less$colon$less$();
    var ev$2 = this$160.s_$less$colon$less$__f_singleton;
    var this$161 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$161);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$10, ev$2);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$165 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$165);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$169 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$169);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$173 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$173);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$177 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$177);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$181 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$181);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$185 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$185);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$14, tttvs$14);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$189 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$189);
    var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$15, tttvs$15);
    var u$16 = new $c_Lshapeless_Lub$$anon$4();
    var this$193 = $m_sci_List$();
    var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$193);
    var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$16, tttvs$16);
    var u$17 = new $c_Lshapeless_Lub$$anon$4();
    var this$197 = $m_sci_List$();
    var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$197);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$17, tttvs$17);
    $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_inst$macro$1
}
function $p_Lreactbuild_model_Communication$anon$lazy$macro$83$1__inst$macro$82$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_inst$macro$82 = new $c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12($thiz);
    $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_inst$macro$82
}
/** @constructor */
function $c_Lreactbuild_model_Communication$anon$lazy$macro$83$1() {
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_inst$macro$82 = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1.prototype = new $h_O();
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1.prototype.constructor = $c_Lreactbuild_model_Communication$anon$lazy$macro$83$1;
/** @constructor */
function $h_Lreactbuild_model_Communication$anon$lazy$macro$83$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_Communication$anon$lazy$macro$83$1.prototype = $c_Lreactbuild_model_Communication$anon$lazy$macro$83$1.prototype;
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Communication$anon$lazy$macro$83$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_inst$macro$1)
});
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1.prototype.inst$macro$82__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Communication$anon$lazy$macro$83$1__inst$macro$82$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_Communication$anon$lazy$macro$83$1__f_inst$macro$82)
});
var $d_Lreactbuild_model_Communication$anon$lazy$macro$83$1 = new $TypeData().initClass({
  Lreactbuild_model_Communication$anon$lazy$macro$83$1: 0
}, false, "reactbuild.model.Communication$anon$lazy$macro$83$1", {
  Lreactbuild_model_Communication$anon$lazy$macro$83$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1.prototype.$classData = $d_Lreactbuild_model_Communication$anon$lazy$macro$83$1;
/** @constructor */
function $c_Lreactbuild_model_CommunicationAttachment$() {
  this.Lreactbuild_model_CommunicationAttachment$__f_codecForCommunicationAttachment = null;
  $n_Lreactbuild_model_CommunicationAttachment$ = this;
  var inst$macro$20 = new $c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_CommunicationAttachment$__f_codecForCommunicationAttachment = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_CommunicationAttachment$.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationAttachment$.prototype.constructor = $c_Lreactbuild_model_CommunicationAttachment$;
/** @constructor */
function $h_Lreactbuild_model_CommunicationAttachment$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationAttachment$.prototype = $c_Lreactbuild_model_CommunicationAttachment$.prototype;
var $d_Lreactbuild_model_CommunicationAttachment$ = new $TypeData().initClass({
  Lreactbuild_model_CommunicationAttachment$: 0
}, false, "reactbuild.model.CommunicationAttachment$", {
  Lreactbuild_model_CommunicationAttachment$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationAttachment$.prototype.$classData = $d_Lreactbuild_model_CommunicationAttachment$;
var $n_Lreactbuild_model_CommunicationAttachment$;
function $m_Lreactbuild_model_CommunicationAttachment$() {
  if ((!$n_Lreactbuild_model_CommunicationAttachment$)) {
    $n_Lreactbuild_model_CommunicationAttachment$ = new $c_Lreactbuild_model_CommunicationAttachment$()
  };
  return $n_Lreactbuild_model_CommunicationAttachment$
}
function $p_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "file")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_CommunicationAttachment(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$16 = $n(x0$7).Lreactbuild_model_CommunicationAttachment__f_id;
        var file$macro$17 = $n(x0$7).Lreactbuild_model_CommunicationAttachment__f_file;
        return new $c_Lshapeless_$colon$colon(id$macro$16, new $c_Lshapeless_$colon$colon(file$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$14 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var file$macro$15 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_CommunicationAttachment(id$macro$14, file$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "file"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_CommunicationAttachment$(), $m_ju_UUID$().randomUUID__ju_UUID())), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$17 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    var this$18 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "file")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "id"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "file"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$34 = $m_s_$less$colon$less$();
    var ev$1 = this$34.s_$less$colon$less$__f_singleton;
    var this$35 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$35);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$39 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$39);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$43 = $m_s_$less$colon$less$();
    var ev$2 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$48);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_inst$macro$1
}
function $p_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_inst$macro$18 = new $c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11($thiz);
    $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1() {
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_inst$macro$18 = null;
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1.prototype.constructor = $c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1;
/** @constructor */
function $h_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1.prototype = $c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1.prototype;
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_inst$macro$1)
});
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1__f_inst$macro$18)
});
var $d_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1: 0
}, false, "reactbuild.model.CommunicationAttachment$anon$lazy$macro$19$1", {
  Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1.prototype.$classData = $d_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1;
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "HtmlCommunicationBody"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "OtherCommunicationBody"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "TextCommunicationBody")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_CommunicationBody(p$2);
      var $$x4 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_model_HtmlCommunicationBody)) {
        var $$x3 = 0
      } else if ((p instanceof $c_Lreactbuild_model_OtherCommunicationBody)) {
        var $$x3 = 1
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_TextCommunicationBody))) {
          throw new $c_s_MatchError(p)
        };
        var $$x3 = 2
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x4).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x3, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_CommunicationBody($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "TextCommunicationBody"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "OtherCommunicationBody"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "HtmlCommunicationBody"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$1
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$2 = new $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4($thiz);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$2
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "textSource")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_TextCommunicationBody(x0$7$2);
      if ((x0$7 !== null)) {
        var textSource$macro$11 = $n(x0$7).Lreactbuild_model_TextCommunicationBody__f_textSource;
        return new $c_Lshapeless_$colon$colon(textSource$macro$11, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var textSource$macro$10 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_TextCommunicationBody(textSource$macro$10)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "textSource"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "textSource")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "textSource"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$3
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$12 = new $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5($thiz);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$12
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "source"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "part")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_OtherCommunicationBody(x0$15$2);
      if ((x0$15 !== null)) {
        var source$macro$28 = $n(x0$15).Lreactbuild_model_OtherCommunicationBody__f_source;
        var part$macro$29 = $n(x0$15).Lreactbuild_model_OtherCommunicationBody__f_part;
        return new $c_Lshapeless_$colon$colon(source$macro$28, new $c_Lshapeless_$colon$colon(part$macro$29, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var source$macro$26 = $as_T($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var part$macro$27 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_OtherCommunicationBody(source$macro$26, part$macro$27)
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "part"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "source"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$30__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "source"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "part")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "source"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "part"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$13 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$13
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$30$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$30 = new $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6($thiz);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$30
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$31$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "htmlSource")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_model_HtmlCommunicationBody(x0$23$2);
      if ((x0$23 !== null)) {
        var htmlSource$macro$39 = $n(x0$23).Lreactbuild_model_HtmlCommunicationBody__f_htmlSource;
        return new $c_Lshapeless_$colon$colon(htmlSource$macro$39, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var htmlSource$macro$38 = $as_T($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$24).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_HtmlCommunicationBody(htmlSource$macro$38)
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "htmlSource"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$40__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "htmlSource")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "htmlSource"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$31 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$31
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$40$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$40 = new $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7($thiz);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$40
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$41$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "textSource")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_model_TextCommunicationBody(x0$31$2);
      if ((x0$31 !== null)) {
        var textSource$macro$49 = $n(x0$31).Lreactbuild_model_TextCommunicationBody__f_textSource;
        return new $c_Lshapeless_$colon$colon(textSource$macro$49, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var textSource$macro$48 = $as_T($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$32).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_TextCommunicationBody(textSource$macro$48)
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "textSource"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$50__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "textSource"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$41 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$41
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$50 = new $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8($thiz);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$50
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$51$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "source"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "part")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_model_OtherCommunicationBody(x0$39$2);
      if ((x0$39 !== null)) {
        var source$macro$66 = $n(x0$39).Lreactbuild_model_OtherCommunicationBody__f_source;
        var part$macro$67 = $n(x0$39).Lreactbuild_model_OtherCommunicationBody__f_part;
        return new $c_Lshapeless_$colon$colon(source$macro$66, new $c_Lshapeless_$colon$colon(part$macro$67, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var source$macro$64 = $as_T($n(x0$40).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$40).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var part$macro$65 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_OtherCommunicationBody(source$macro$64, part$macro$65)
          }
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "part"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "source"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$68__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "source"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "part"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$51 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$51
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$68$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$68 = new $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9($thiz);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$68
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$69$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "htmlSource")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_model_HtmlCommunicationBody(x0$47$2);
      if ((x0$47 !== null)) {
        var htmlSource$macro$77 = $n(x0$47).Lreactbuild_model_HtmlCommunicationBody__f_htmlSource;
        return new $c_Lshapeless_$colon$colon(htmlSource$macro$77, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_$colon$colon(x0$48$2);
      if ((x0$48 !== null)) {
        var htmlSource$macro$76 = $as_T($n(x0$48).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$48).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_HtmlCommunicationBody(htmlSource$macro$76)
        }
      };
      throw new $c_s_MatchError(x0$48)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "htmlSource"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$78__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "htmlSource"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$69 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$69
}
function $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$78$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$78 = new $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10($thiz);
    $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$78
}
/** @constructor */
function $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1() {
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$12 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$13 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$30 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$31 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$40 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$41 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$50 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$51 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$68 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$69 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$78 = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.constructor = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1;
/** @constructor */
function $h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype;
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$1)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$2)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$3)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$12)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$13)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$30__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$30$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$30)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$31__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$31$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$31)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$40__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((128 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$40$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$40)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$41__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$41$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$41)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$50__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$50)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$51__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$51$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$51)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$68__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$68$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$68)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$69__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4096 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$69$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$69)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.inst$macro$78__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__inst$macro$78$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1__f_inst$macro$78)
});
var $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1: 0
}, false, "reactbuild.model.CommunicationBody$anon$lazy$macro$79$1", {
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1.prototype.$classData = $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1;
/** @constructor */
function $c_Lreactbuild_model_CommunicationPerson$() {
  this.Lreactbuild_model_CommunicationPerson$__f_codecForCommunicationPerson = null;
  $n_Lreactbuild_model_CommunicationPerson$ = this;
  var inst$macro$36 = new $c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_CommunicationPerson$__f_codecForCommunicationPerson = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_CommunicationPerson$.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationPerson$.prototype.constructor = $c_Lreactbuild_model_CommunicationPerson$;
/** @constructor */
function $h_Lreactbuild_model_CommunicationPerson$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationPerson$.prototype = $c_Lreactbuild_model_CommunicationPerson$.prototype;
var $d_Lreactbuild_model_CommunicationPerson$ = new $TypeData().initClass({
  Lreactbuild_model_CommunicationPerson$: 0
}, false, "reactbuild.model.CommunicationPerson$", {
  Lreactbuild_model_CommunicationPerson$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationPerson$.prototype.$classData = $d_Lreactbuild_model_CommunicationPerson$;
var $n_Lreactbuild_model_CommunicationPerson$;
function $m_Lreactbuild_model_CommunicationPerson$() {
  if ((!$n_Lreactbuild_model_CommunicationPerson$)) {
    $n_Lreactbuild_model_CommunicationPerson$ = new $c_Lreactbuild_model_CommunicationPerson$()
  };
  return $n_Lreactbuild_model_CommunicationPerson$
}
function $p_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "role"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "person"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "address"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "added")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_CommunicationPerson(x0$7$2);
      if ((x0$7 !== null)) {
        var role$macro$30 = $n(x0$7).Lreactbuild_model_CommunicationPerson__f_role;
        var person$macro$31 = $n(x0$7).Lreactbuild_model_CommunicationPerson__f_person;
        var address$macro$32 = $n(x0$7).Lreactbuild_model_CommunicationPerson__f_address;
        var added$macro$33 = $n(x0$7).Lreactbuild_model_CommunicationPerson__f_added;
        return new $c_Lshapeless_$colon$colon(role$macro$30, new $c_Lshapeless_$colon$colon(person$macro$31, new $c_Lshapeless_$colon$colon(address$macro$32, new $c_Lshapeless_$colon$colon(added$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var role$macro$26 = $as_Lreactbuild_model_CommunicationRole($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var person$macro$27 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var address$macro$28 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var added$macro$29 = $as_Ljava_time_Instant($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_CommunicationPerson(role$macro$26, person$macro$27, address$macro$28, added$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "added"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "address"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "person"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "role"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_CommunicationPerson$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_CommunicationPerson$(), $m_s_None$())), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$26 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "role"));
    var this$27 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "person"));
    var this$28 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "address"));
    var this$29 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "added")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "person"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "address"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "role"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "person"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "address"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "added"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$56 = $m_s_$less$colon$less$();
    var ev$1 = this$56.s_$less$colon$less$__f_singleton;
    var this$57 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$61);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$65 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$69);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$73 = $m_s_$less$colon$less$();
    var ev$2 = this$73.s_$less$colon$less$__f_singleton;
    var this$74 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$82);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$86 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$86);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_inst$macro$1
}
function $p_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_inst$macro$34 = new $c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3($thiz);
    $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1() {
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_inst$macro$34 = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1.prototype.constructor = $c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1;
/** @constructor */
function $h_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1.prototype = $c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1.prototype;
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_inst$macro$1)
});
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1__f_inst$macro$34)
});
var $d_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1: 0
}, false, "reactbuild.model.CommunicationPerson$anon$lazy$macro$35$1", {
  Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1.prototype.$classData = $d_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1;
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "From"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Recipient"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Sender"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "To")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_CommunicationRole(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_model_CommunicationRole$From$())) {
        var $$x4 = 0
      } else if ((p === $m_Lreactbuild_model_CommunicationRole$Recipient$())) {
        var $$x4 = 1
      } else if ((p === $m_Lreactbuild_model_CommunicationRole$Sender$())) {
        var $$x4 = 2
      } else {
        if ((p !== $m_Lreactbuild_model_CommunicationRole$To$())) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_CommunicationRole($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "To"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "Sender"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "Recipient"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "From"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$1
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$2 = new $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1($thiz);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$2
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_model_CommunicationRole$To$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_model_CommunicationRole$To$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$3
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$4
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_model_CommunicationRole$Sender$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_model_CommunicationRole$Sender$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$5
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_model_CommunicationRole$Recipient$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_model_CommunicationRole$Recipient$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$6 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$6
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_model_CommunicationRole$From$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_model_CommunicationRole$From$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$7 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$7
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      $as_Lreactbuild_model_CommunicationRole$To$(x0$39$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      $as_Lshapeless_HNil(x0$40$2);
      return $m_Lreactbuild_model_CommunicationRole$To$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$8 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$8
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$9 = new $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2($thiz);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$9
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      $as_Lreactbuild_model_CommunicationRole$Sender$(x0$47$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      $as_Lshapeless_HNil(x0$48$2);
      return $m_Lreactbuild_model_CommunicationRole$Sender$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$10 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$10
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$11$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      $as_Lreactbuild_model_CommunicationRole$Recipient$(x0$55$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      $as_Lshapeless_HNil(x0$56$2);
      return $m_Lreactbuild_model_CommunicationRole$Recipient$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$11 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$11
}
function $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      $as_Lreactbuild_model_CommunicationRole$From$(x0$63$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      $as_Lshapeless_HNil(x0$64$2);
      return $m_Lreactbuild_model_CommunicationRole$From$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$12 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$12
}
/** @constructor */
function $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1() {
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$4 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$5 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$6 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$7 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$8 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$9 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$10 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$11 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$12 = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.constructor = $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1;
/** @constructor */
function $h_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype = $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype;
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$1)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$2)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$3)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$4)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$5)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((32 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$6)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$7)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$8)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$9)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$10__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$10)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$11__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$11$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$11)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.inst$macro$12__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1__f_inst$macro$12)
});
var $d_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1: 0
}, false, "reactbuild.model.CommunicationRole$anon$lazy$macro$13$1", {
  Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1.prototype.$classData = $d_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1;
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "MissingDeliveryFormDetails"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "ReconciliedDeliveryFormDetails")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_DeliveryFormDetails(p$2);
      var $$x3 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_model_MissingDeliveryFormDetails)) {
        var $$x2 = 0
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_ReconciliedDeliveryFormDetails))) {
          throw new $c_s_MatchError(p)
        };
        var $$x2 = 1
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x3).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x2, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_DeliveryFormDetails($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "ReconciliedDeliveryFormDetails"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "MissingDeliveryFormDetails"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$1
}
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$2 = new $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36($thiz);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$2
}
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var $$x19 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "document"));
    var this$3 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "supplier"));
    var this$4 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "entryLine"));
    var this$5 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "deliveredQuantity"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "amount")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_ReconciliedDeliveryFormDetails(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$46 = $n(x0$7).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id;
        var document$macro$47 = $n(x0$7).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
        var supplier$macro$48 = $n(x0$7).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier;
        var entryLine$macro$49 = $n(x0$7).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
        var deliveredQuantity$macro$50 = $n(x0$7).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity;
        var amount$macro$51 = $n(x0$7).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount;
        return new $c_Lshapeless_$colon$colon(id$macro$46, new $c_Lshapeless_$colon$colon(document$macro$47, new $c_Lshapeless_$colon$colon(supplier$macro$48, new $c_Lshapeless_$colon$colon(entryLine$macro$49, new $c_Lshapeless_$colon$colon(deliveredQuantity$macro$50, new $c_Lshapeless_$colon$colon(amount$macro$51, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$40 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var document$macro$41 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var supplier$macro$42 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var entryLine$macro$43 = $as_ju_UUID($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var deliveredQuantity$macro$44 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var amount$macro$45 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_model_ReconciliedDeliveryFormDetails(id$macro$40, document$macro$41, supplier$macro$42, entryLine$macro$43, deliveredQuantity$macro$44, amount$macro$45)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "amount"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "deliveredQuantity"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "entryLine"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "document"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var $$x18 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$52__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x12 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some($m_ju_UUID$().randomUUID__ju_UUID()), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), $m_Lshapeless_HNil$()))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$35 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "id"));
    var this$36 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "document"));
    var this$37 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "supplier"));
    var this$38 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "entryLine"));
    var this$39 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "deliveredQuantity"));
    var this$40 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "amount")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$5);
    var $$x11 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$50 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "id"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$52 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "supplier"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$54 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "amount"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "id"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "document"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "supplier"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "entryLine"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$67 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "deliveredQuantity"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$69 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$69, "amount"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$14);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var this$78 = $m_s_$less$colon$less$();
    var ev$1 = this$78.s_$less$colon$less$__f_singleton;
    var this$79 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$83);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$87 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$91);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$95 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$95);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$99 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$99);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$103 = $m_s_$less$colon$less$();
    var ev$2 = this$103.s_$less$colon$less$__f_singleton;
    var this$104 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$104);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$6, ev$2);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$108 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$108);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$112 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$112);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$116 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$116);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$120 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$120);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$124 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$124);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$3 = $n($$x19).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x18, $$x12, $$x11, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9));
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$3
}
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$52$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$52 = new $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37($thiz);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$52
}
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$53$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "content")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_MissingDeliveryFormDetails(x0$15$2);
      if ((x0$15 !== null)) {
        var content$macro$61 = $n(x0$15).Lreactbuild_model_MissingDeliveryFormDetails__f_content;
        return new $c_Lshapeless_$colon$colon(content$macro$61, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var content$macro$60 = $as_Lreactbuild_model_InvoiceDetail($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$16).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_MissingDeliveryFormDetails(content$macro$60)
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "content"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$62__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "content")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "content"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$53 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$53
}
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$62$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$62 = new $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38($thiz);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$62
}
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$63$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "document"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "supplier"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "entryLine"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "deliveredQuantity"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "amount")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_model_ReconciliedDeliveryFormDetails(x0$23$2);
      if ((x0$23 !== null)) {
        var id$macro$106 = $n(x0$23).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id;
        var document$macro$107 = $n(x0$23).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
        var supplier$macro$108 = $n(x0$23).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier;
        var entryLine$macro$109 = $n(x0$23).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
        var deliveredQuantity$macro$110 = $n(x0$23).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity;
        var amount$macro$111 = $n(x0$23).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount;
        return new $c_Lshapeless_$colon$colon(id$macro$106, new $c_Lshapeless_$colon$colon(document$macro$107, new $c_Lshapeless_$colon$colon(supplier$macro$108, new $c_Lshapeless_$colon$colon(entryLine$macro$109, new $c_Lshapeless_$colon$colon(deliveredQuantity$macro$110, new $c_Lshapeless_$colon$colon(amount$macro$111, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var id$macro$100 = $as_ju_UUID($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var document$macro$101 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var supplier$macro$102 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var entryLine$macro$103 = $as_ju_UUID($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var deliveredQuantity$macro$104 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var amount$macro$105 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_model_ReconciliedDeliveryFormDetails(id$macro$100, document$macro$101, supplier$macro$102, entryLine$macro$103, deliveredQuantity$macro$104, amount$macro$105)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "amount"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "deliveredQuantity"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "entryLine"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "document"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$112__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "id"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "document"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "supplier"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "entryLine"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "deliveredQuantity"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "amount"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var this$50 = $m_s_$less$colon$less$();
    var ev$1 = this$50.s_$less$colon$less$__f_singleton;
    var this$51 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$51);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$55 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$55);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$59 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$59);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$63 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$63);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$67 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$67);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$71 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$71);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$75 = $m_s_$less$colon$less$();
    var ev$2 = this$75.s_$less$colon$less$__f_singleton;
    var this$76 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$76);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$6, ev$2);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$80 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$88);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$92 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$92);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$96 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$96);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$63 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$63
}
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$112$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$112 = new $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39($thiz);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$112
}
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$113$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "content")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_model_MissingDeliveryFormDetails(x0$31$2);
      if ((x0$31 !== null)) {
        var content$macro$121 = $n(x0$31).Lreactbuild_model_MissingDeliveryFormDetails__f_content;
        return new $c_Lshapeless_$colon$colon(content$macro$121, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var content$macro$120 = $as_Lreactbuild_model_InvoiceDetail($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$32).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_MissingDeliveryFormDetails(content$macro$120)
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "content"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$122__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "content"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$113 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$113
}
function $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$122$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$122 = new $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40($thiz);
    $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$122
}
/** @constructor */
function $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1() {
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$52 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$53 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$62 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$63 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$112 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$113 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$122 = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype = new $h_O();
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.constructor = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1;
/** @constructor */
function $h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype;
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$1)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$2)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$3)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$52__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$52$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$52)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$53__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$53$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$53)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$62__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$62$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$62)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$63__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((64 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$63$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$63)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$112__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$112$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$112)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$113__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$113$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$113)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.inst$macro$122__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__inst$macro$122$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1__f_inst$macro$122)
});
var $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1 = new $TypeData().initClass({
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1: 0
}, false, "reactbuild.model.DeliveryFormDetails$anon$lazy$macro$123$1", {
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1.prototype.$classData = $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1;
/** @constructor */
function $c_Lreactbuild_model_Duration$() {
  this.Lreactbuild_model_Duration$__f_encodeDuration = null;
  this.Lreactbuild_model_Duration$__f_decodeDuration = null;
  this.Lreactbuild_model_Duration$__f_zeroDuration = null;
  this.Lreactbuild_model_Duration$__f_numericDuration = null;
  $n_Lreactbuild_model_Duration$ = this;
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_model_Duration(x$1$2);
    return $n(x$1).Lreactbuild_model_Duration__f_value
  }));
  this.Lreactbuild_model_Duration$__f_encodeDuration = new $c_Lio_circe_Encoder$$anon$1(this$3, f);
  $m_Lio_circe_Decoder$();
  var instance$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  var this$5 = $n(instance$1);
  var f$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $uD(x$2$2);
    return new $c_Lreactbuild_model_Duration(x$2)
  }));
  this.Lreactbuild_model_Duration$__f_decodeDuration = new $c_Lio_circe_Decoder$$anon$1(this$5, f$1);
  this.Lreactbuild_model_Duration$__f_zeroDuration = new $c_Lreactbuild_model_Duration(0.0);
  this.Lreactbuild_model_Duration$__f_numericDuration = new $c_Lreactbuild_model_Duration$$anon$3()
}
$c_Lreactbuild_model_Duration$.prototype = new $h_O();
$c_Lreactbuild_model_Duration$.prototype.constructor = $c_Lreactbuild_model_Duration$;
/** @constructor */
function $h_Lreactbuild_model_Duration$() {
  /*<skip>*/
}
$h_Lreactbuild_model_Duration$.prototype = $c_Lreactbuild_model_Duration$.prototype;
var $d_Lreactbuild_model_Duration$ = new $TypeData().initClass({
  Lreactbuild_model_Duration$: 0
}, false, "reactbuild.model.Duration$", {
  Lreactbuild_model_Duration$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Duration$.prototype.$classData = $d_Lreactbuild_model_Duration$;
var $n_Lreactbuild_model_Duration$;
function $m_Lreactbuild_model_Duration$() {
  if ((!$n_Lreactbuild_model_Duration$)) {
    $n_Lreactbuild_model_Duration$ = new $c_Lreactbuild_model_Duration$()
  };
  return $n_Lreactbuild_model_Duration$
}
/** @constructor */
function $c_Lreactbuild_model_Expression$$anon$82() {
  /*<skip>*/
}
$c_Lreactbuild_model_Expression$$anon$82.prototype = new $h_O();
$c_Lreactbuild_model_Expression$$anon$82.prototype.constructor = $c_Lreactbuild_model_Expression$$anon$82;
/** @constructor */
function $h_Lreactbuild_model_Expression$$anon$82() {
  /*<skip>*/
}
$h_Lreactbuild_model_Expression$$anon$82.prototype = $c_Lreactbuild_model_Expression$$anon$82.prototype;
var $d_Lreactbuild_model_Expression$$anon$82 = new $TypeData().initClass({
  Lreactbuild_model_Expression$$anon$82: 0
}, false, "reactbuild.model.Expression$$anon$82", {
  Lreactbuild_model_Expression$$anon$82: 1,
  O: 1,
  Lreactbuild_model_Expression: 1
});
$c_Lreactbuild_model_Expression$$anon$82.prototype.$classData = $d_Lreactbuild_model_Expression$$anon$82;
function $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$1$lzycompute__Lio_circe_generic_codec_DerivedAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "UpdateCursorLocation")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_FromClient(p$2);
      var $$x1 = $m_Lshapeless_Coproduct$();
      if ((!(p instanceof $c_Lreactbuild_model_UpdateCursorLocation))) {
        throw new $c_s_MatchError(p)
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x1).unsafeMkCoproduct__I__O__Lshapeless_Coproduct(0, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_FromClient($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "UpdateCursorLocation"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$1 = new $c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1(codec, gen$1);
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$1
}
function $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$2$lzycompute__Lio_circe_generic_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$2 = new $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1($thiz);
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$2
}
function $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$3$lzycompute__Lio_circe_generic_decoding_DerivedDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "projectRef"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "x"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "y")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_model_UpdateCursorLocation(x0$3$2);
      if ((x0$3 !== null)) {
        var projectRef$macro$13 = $n(x0$3).Lreactbuild_model_UpdateCursorLocation__f_projectRef;
        var x$macro$14 = $n(x0$3).Lreactbuild_model_UpdateCursorLocation__f_x;
        var y$macro$15 = $n(x0$3).Lreactbuild_model_UpdateCursorLocation__f_y;
        return new $c_Lshapeless_$colon$colon(projectRef$macro$13, new $c_Lshapeless_$colon$colon(x$macro$14, new $c_Lshapeless_$colon$colon(y$macro$15, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var projectRef$macro$10 = $as_Lreactbuild_common_model_RefTo($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var x$macro$11 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var y$macro$12 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_model_UpdateCursorLocation(projectRef$macro$10, x$macro$11, y$macro$12)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "projectRef"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$16__Lio_circe_generic_decoding_ReprDecoder()));
    var decode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$3 = new $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1(decode, gen$1);
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$3
}
function $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$16$lzycompute__Lio_circe_generic_decoding_ReprDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$16 = new $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2($thiz);
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$16
}
function $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$17$lzycompute__Lio_circe_generic_encoding_DerivedAsObjectEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "projectRef"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "x"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "y")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_UpdateCursorLocation(x0$7$2);
      if ((x0$7 !== null)) {
        var projectRef$macro$27 = $n(x0$7).Lreactbuild_model_UpdateCursorLocation__f_projectRef;
        var x$macro$28 = $n(x0$7).Lreactbuild_model_UpdateCursorLocation__f_x;
        var y$macro$29 = $n(x0$7).Lreactbuild_model_UpdateCursorLocation__f_y;
        return new $c_Lshapeless_$colon$colon(projectRef$macro$27, new $c_Lshapeless_$colon$colon(x$macro$28, new $c_Lshapeless_$colon$colon(y$macro$29, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var projectRef$macro$24 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var x$macro$25 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var y$macro$26 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_model_UpdateCursorLocation(projectRef$macro$24, x$macro$25, y$macro$26)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "projectRef"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$30__Lio_circe_generic_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$17 = new $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1(encode, gen$1);
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$17
}
function $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$30$lzycompute__Lio_circe_generic_encoding_ReprAsObjectEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$30 = new $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3($thiz);
    $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$30
}
/** @constructor */
function $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1() {
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$16 = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$17 = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$30 = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype = new $h_O();
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype.constructor = $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1;
/** @constructor */
function $h_Lreactbuild_model_FromClient$anon$lazy$macro$31$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype = $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype;
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype.inst$macro$1__Lio_circe_generic_codec_DerivedAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$1$lzycompute__Lio_circe_generic_codec_DerivedAsObjectCodec(this) : this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$1)
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype.inst$macro$2__Lio_circe_generic_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$2$lzycompute__Lio_circe_generic_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$2)
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype.inst$macro$3__Lio_circe_generic_decoding_DerivedDecoder = (function() {
  return (((((4 & this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$3$lzycompute__Lio_circe_generic_decoding_DerivedDecoder(this) : this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$3)
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype.inst$macro$16__Lio_circe_generic_decoding_ReprDecoder = (function() {
  return (((((8 & this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$16$lzycompute__Lio_circe_generic_decoding_ReprDecoder(this) : this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$16)
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype.inst$macro$17__Lio_circe_generic_encoding_DerivedAsObjectEncoder = (function() {
  return (((((16 & this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$17$lzycompute__Lio_circe_generic_encoding_DerivedAsObjectEncoder(this) : this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$17)
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype.inst$macro$30__Lio_circe_generic_encoding_ReprAsObjectEncoder = (function() {
  return (((((32 & this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_FromClient$anon$lazy$macro$31$1__inst$macro$30$lzycompute__Lio_circe_generic_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1__f_inst$macro$30)
});
var $d_Lreactbuild_model_FromClient$anon$lazy$macro$31$1 = new $TypeData().initClass({
  Lreactbuild_model_FromClient$anon$lazy$macro$31$1: 0
}, false, "reactbuild.model.FromClient$anon$lazy$macro$31$1", {
  Lreactbuild_model_FromClient$anon$lazy$macro$31$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1.prototype.$classData = $d_Lreactbuild_model_FromClient$anon$lazy$macro$31$1;
/** @constructor */
function $c_Lreactbuild_model_Implicits$$$Lambda$1(f) {
  this.Lreactbuild_model_Implicits$$$Lambda$1__f_f = null;
  this.Lreactbuild_model_Implicits$$$Lambda$1__f_f = f
}
$c_Lreactbuild_model_Implicits$$$Lambda$1.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$$$Lambda$1.prototype.constructor = $c_Lreactbuild_model_Implicits$$$Lambda$1;
/** @constructor */
function $h_Lreactbuild_model_Implicits$$$Lambda$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$$$Lambda$1.prototype = $c_Lreactbuild_model_Implicits$$$Lambda$1.prototype;
$c_Lreactbuild_model_Implicits$$$Lambda$1.prototype.apply__O = (function() {
  return (0, this.Lreactbuild_model_Implicits$$$Lambda$1__f_f)()
});
var $d_Lreactbuild_model_Implicits$$$Lambda$1 = new $TypeData().initClass({
  Lreactbuild_model_Implicits$$$Lambda$1: 0
}, false, "reactbuild.model.Implicits$$$Lambda$1", {
  Lreactbuild_model_Implicits$$$Lambda$1: 1,
  O: 1,
  Lcom_iz2use_common_ParsingReference: 1
});
$c_Lreactbuild_model_Implicits$$$Lambda$1.prototype.$classData = $d_Lreactbuild_model_Implicits$$$Lambda$1;
/** @constructor */
function $c_Lreactbuild_model_Implicits$$anon$23() {
  this.Lreactbuild_model_Implicits$$anon$23__f_empty = null;
  this.Lreactbuild_model_Implicits$$anon$23__f_empty = new $c_Lreactbuild_model_Duration(0.0)
}
$c_Lreactbuild_model_Implicits$$anon$23.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$$anon$23.prototype.constructor = $c_Lreactbuild_model_Implicits$$anon$23;
/** @constructor */
function $h_Lreactbuild_model_Implicits$$anon$23() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$$anon$23.prototype = $c_Lreactbuild_model_Implicits$$anon$23.prototype;
$c_Lreactbuild_model_Implicits$$anon$23.prototype.empty__O = (function() {
  return this.Lreactbuild_model_Implicits$$anon$23__f_empty
});
var $d_Lreactbuild_model_Implicits$$anon$23 = new $TypeData().initClass({
  Lreactbuild_model_Implicits$$anon$23: 0
}, false, "reactbuild.model.Implicits$$anon$23", {
  Lreactbuild_model_Implicits$$anon$23: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_Default: 1
});
$c_Lreactbuild_model_Implicits$$anon$23.prototype.$classData = $d_Lreactbuild_model_Implicits$$anon$23;
/** @constructor */
function $c_Lreactbuild_model_Implicits$$anon$28(proxy$15) {
  this.Lreactbuild_model_Implicits$$anon$28__f_proxy$15 = null;
  this.Lreactbuild_model_Implicits$$anon$28__f_proxy$15 = proxy$15
}
$c_Lreactbuild_model_Implicits$$anon$28.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$$anon$28.prototype.constructor = $c_Lreactbuild_model_Implicits$$anon$28;
/** @constructor */
function $h_Lreactbuild_model_Implicits$$anon$28() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$$anon$28.prototype = $c_Lreactbuild_model_Implicits$$anon$28.prototype;
$c_Lreactbuild_model_Implicits$$anon$28.prototype.createNew__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(save) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).prompt__T__T__Ljapgolly_scalajs_react_callback_Trampoline("Quelle est la r\u00e9f\u00e9rence du nouveau projet ?", "R\u00e9f\u00e9rence");
  var this$1 = $m_s_$less$colon$less$();
  var co = $n($$x3).flatMap$extension__F0__F1__F0($n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$1.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((name$2) => {
    var name = $as_T(name$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
      var this$3 = $n(this.Lreactbuild_model_Implicits$$anon$28__f_proxy$15);
      var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
      return $n($as_Lreactbuild_analyze_cost_services_Model(this$4.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged
    }))), new $c_sjsr_AnonFunction1(((logged$2) => {
      var logged = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(logged$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var this$5 = $n($n(logged).Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations);
      var f = ((x$52$2) => {
        var x$52 = $as_Lreactbuild_common_model_LoggedUserOrganization(x$52$2);
        return $n(x$52).Lreactbuild_common_model_LoggedUserOrganization__f__id
      });
      if ((this$5 === $m_sci_Nil$())) {
        var x$1 = $m_sci_Nil$()
      } else {
        var arg1 = this$5.head__O();
        var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$5.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$1 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O())
        };
        var x$1 = h
      };
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$5 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$6 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$7 = $m_s_package$().s_package$__f_Nil;
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$8 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$9 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$10 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$11 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$12 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$13 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$14 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$15 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$16 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$17 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$18 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$19 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$20 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$21 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$22 = $m_s_None$();
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project);
      var x$23 = new $c_Lreactbuild_common_model_ProjectAddress(($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$()), ($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$()), ($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_package$().s_package$__f_Nil), ($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$()));
      var this$ = $n($$x4).toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(save).apply__O__O(new $c_Lreactbuild_common_model_Project(x$5, x$1, "", name, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, name)))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr);
      var f$1 = new $c_sjsr_AnonFunction1(((x$53$2) => {
        $as_jl_Void(x$53$2)
      }));
      var this$31 = $n(this$);
      var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$31, f$1);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    }))))
  })));
  var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$34 = $m_s_$less$colon$less$();
  return $n($$x5).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$34.s_$less$colon$less$__f_singleton)
});
$c_Lreactbuild_model_Implicits$$anon$28.prototype.update__Lreactbuild_common_model_Project__F1 = (function(value) {
  return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x3 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "project", "ProjectApi", "persistBuildingSite"];
    var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$13 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
    var evidence$2 = $m_Lreactbuild_common_model_Project$().Lreactbuild_common_model_Project$__f_codecForProject;
    var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(value, evidence$2);
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$13.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$15 = $n(new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self);
      var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
      this$15.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1)
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
var $d_Lreactbuild_model_Implicits$$anon$28 = new $TypeData().initClass({
  Lreactbuild_model_Implicits$$anon$28: 0
}, false, "reactbuild.model.Implicits$$anon$28", {
  Lreactbuild_model_Implicits$$anon$28: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Updateable: 1
});
$c_Lreactbuild_model_Implicits$$anon$28.prototype.$classData = $d_Lreactbuild_model_Implicits$$anon$28;
/** @constructor */
function $c_Lreactbuild_model_Implicits$$anon$29(pageProps$1) {
  this.Lreactbuild_model_Implicits$$anon$29__f_pageProps$1 = null;
  this.Lreactbuild_model_Implicits$$anon$29__f_pageProps$1 = pageProps$1
}
$c_Lreactbuild_model_Implicits$$anon$29.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$$anon$29.prototype.constructor = $c_Lreactbuild_model_Implicits$$anon$29;
/** @constructor */
function $h_Lreactbuild_model_Implicits$$anon$29() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$$anon$29.prototype = $c_Lreactbuild_model_Implicits$$anon$29.prototype;
$c_Lreactbuild_model_Implicits$$anon$29.prototype.render__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode = (function(item, moveActive) {
  var u = $m_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$().apply__Ldiode_data_Pot__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(item, this.Lreactbuild_model_Implicits$$anon$29__f_pageProps$1);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_model_Implicits$$anon$29 = new $TypeData().initClass({
  Lreactbuild_model_Implicits$$anon$29: 0
}, false, "reactbuild.model.Implicits$$anon$29", {
  Lreactbuild_model_Implicits$$anon$29: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_RenderItem: 1
});
$c_Lreactbuild_model_Implicits$$anon$29.prototype.$classData = $d_Lreactbuild_model_Implicits$$anon$29;
function $p_Lreactbuild_model_Implicits$$anon$31__childrenCount$lzycompute__I($thiz) {
  if ((!$thiz.Lreactbuild_model_Implicits$$anon$31__f_bitmap$0)) {
    $thiz.Lreactbuild_model_Implicits$$anon$31__f_childrenCount = $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__childrenCount__I($thiz);
    $thiz.Lreactbuild_model_Implicits$$anon$31__f_bitmap$0 = true
  };
  return $thiz.Lreactbuild_model_Implicits$$anon$31__f_childrenCount
}
/** @constructor */
function $c_Lreactbuild_model_Implicits$$anon$31(evL$2, ctc$1, mapC$1, evR$2, ctp$1, mapP$1) {
  this.Lreactbuild_model_Implicits$$anon$31__f_childrenCount = 0;
  this.Lreactbuild_model_Implicits$$anon$31__f_bitmap$0 = false;
  this.Lreactbuild_model_Implicits$$anon$31__f_evL$2 = null;
  this.Lreactbuild_model_Implicits$$anon$31__f_ctc$1 = null;
  this.Lreactbuild_model_Implicits$$anon$31__f_mapC$1 = null;
  this.Lreactbuild_model_Implicits$$anon$31__f_evR$2 = null;
  this.Lreactbuild_model_Implicits$$anon$31__f_ctp$1 = null;
  this.Lreactbuild_model_Implicits$$anon$31__f_mapP$1 = null;
  this.Lreactbuild_model_Implicits$$anon$31__f_evL$2 = evL$2;
  this.Lreactbuild_model_Implicits$$anon$31__f_ctc$1 = ctc$1;
  this.Lreactbuild_model_Implicits$$anon$31__f_mapC$1 = mapC$1;
  this.Lreactbuild_model_Implicits$$anon$31__f_evR$2 = evR$2;
  this.Lreactbuild_model_Implicits$$anon$31__f_ctp$1 = ctp$1;
  this.Lreactbuild_model_Implicits$$anon$31__f_mapP$1 = mapP$1
}
$c_Lreactbuild_model_Implicits$$anon$31.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$$anon$31.prototype.constructor = $c_Lreactbuild_model_Implicits$$anon$31;
/** @constructor */
function $h_Lreactbuild_model_Implicits$$anon$31() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$$anon$31.prototype = $c_Lreactbuild_model_Implicits$$anon$31.prototype;
$c_Lreactbuild_model_Implicits$$anon$31.prototype.newLevel__Z = (function() {
  return false
});
$c_Lreactbuild_model_Implicits$$anon$31.prototype.maxLevel__I = (function() {
  return $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__maxLevel__I(this)
});
$c_Lreactbuild_model_Implicits$$anon$31.prototype.renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List = (function(level, context) {
  return $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List(this, level, context)
});
$c_Lreactbuild_model_Implicits$$anon$31.prototype.renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode = (function(map, editing) {
  return $f_Lcom_iz2use_react_components_internal_multiview_ColumnFragment__renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode(this, map, editing)
});
$c_Lreactbuild_model_Implicits$$anon$31.prototype.childrenCount__I = (function() {
  return ((!this.Lreactbuild_model_Implicits$$anon$31__f_bitmap$0) ? $p_Lreactbuild_model_Implicits$$anon$31__childrenCount$lzycompute__I(this) : this.Lreactbuild_model_Implicits$$anon$31__f_childrenCount)
});
$c_Lreactbuild_model_Implicits$$anon$31.prototype.children__sci_List = (function() {
  var this$3 = $n(this.Lreactbuild_model_Implicits$$anon$31__f_evL$2);
  var columnGroupTitle = $n($n(this.Lreactbuild_model_Implicits$$anon$31__f_ctc$1).runtimeClass__jl_Class()).getSimpleName__T();
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_sci_Map(v$2);
    var $$x1 = $n(this.Lreactbuild_model_Implicits$$anon$31__f_mapC$1);
    var this$2 = $m_s_Symbol$();
    return $n($$x1).apply__O__sci_Map($n(v).apply__O__O($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "child"))))
  }));
  var rassoc$4 = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5(this$3, columnGroupTitle, f);
  var this$5 = $n(this.Lreactbuild_model_Implicits$$anon$31__f_evR$2);
  var columnGroupTitle$1 = $n($n(this.Lreactbuild_model_Implicits$$anon$31__f_ctp$1).runtimeClass__jl_Class()).getSimpleName__T();
  var f$1 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_sci_Map(v$3$2);
    var $$x2 = $n(this.Lreactbuild_model_Implicits$$anon$31__f_mapP$1);
    var this$4 = $m_s_Symbol$();
    return $n($$x2).apply__O__sci_Map($n(v$3).apply__O__O($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "parent"))))
  }));
  var rassoc$3 = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$5(this$5, columnGroupTitle$1, f$1);
  var this$6 = $n($m_s_package$().s_package$__f_Nil);
  var this$7 = new $c_sci_$colon$colon(rassoc$3, this$6);
  return new $c_sci_$colon$colon(rassoc$4, this$7)
});
var $d_Lreactbuild_model_Implicits$$anon$31 = new $TypeData().initClass({
  Lreactbuild_model_Implicits$$anon$31: 0
}, false, "reactbuild.model.Implicits$$anon$31", {
  Lreactbuild_model_Implicits$$anon$31: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_ColumnFragment: 1
});
$c_Lreactbuild_model_Implicits$$anon$31.prototype.$classData = $d_Lreactbuild_model_Implicits$$anon$31;
/** @constructor */
function $c_Lreactbuild_model_InvoiceDetail$() {
  this.Lreactbuild_model_InvoiceDetail$__f_codecForInvoiceDetail = null;
  $n_Lreactbuild_model_InvoiceDetail$ = this;
  var inst$macro$84 = new $c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$84));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_InvoiceDetail$__f_codecForInvoiceDetail = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_InvoiceDetail$.prototype = new $h_O();
$c_Lreactbuild_model_InvoiceDetail$.prototype.constructor = $c_Lreactbuild_model_InvoiceDetail$;
/** @constructor */
function $h_Lreactbuild_model_InvoiceDetail$() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoiceDetail$.prototype = $c_Lreactbuild_model_InvoiceDetail$.prototype;
var $d_Lreactbuild_model_InvoiceDetail$ = new $TypeData().initClass({
  Lreactbuild_model_InvoiceDetail$: 0
}, false, "reactbuild.model.InvoiceDetail$", {
  Lreactbuild_model_InvoiceDetail$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoiceDetail$.prototype.$classData = $d_Lreactbuild_model_InvoiceDetail$;
var $n_Lreactbuild_model_InvoiceDetail$;
function $m_Lreactbuild_model_InvoiceDetail$() {
  if ((!$n_Lreactbuild_model_InvoiceDetail$)) {
    $n_Lreactbuild_model_InvoiceDetail$ = new $c_Lreactbuild_model_InvoiceDetail$()
  };
  return $n_Lreactbuild_model_InvoiceDetail$
}
function $p_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "reference"));
    var this$3 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "description"));
    var this$4 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "quantity"));
    var this$5 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "unit"));
    var this$6 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "unitPrice"));
    var this$7 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "amount"));
    var this$8 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "tradeBody"));
    var this$9 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "buildingSite"));
    var this$10 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "deliveryDate")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_InvoiceDetail(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$72 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_id;
        var reference$macro$73 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_reference;
        var description$macro$74 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_description;
        var quantity$macro$75 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_quantity;
        var unit$macro$76 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_unit;
        var unitPrice$macro$77 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_unitPrice;
        var amount$macro$78 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_amount;
        var tradeBody$macro$79 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_tradeBody;
        var buildingSite$macro$80 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_buildingSite;
        var deliveryDate$macro$81 = $n(x0$7).Lreactbuild_model_InvoiceDetail__f_deliveryDate;
        return new $c_Lshapeless_$colon$colon(id$macro$72, new $c_Lshapeless_$colon$colon(reference$macro$73, new $c_Lshapeless_$colon$colon(description$macro$74, new $c_Lshapeless_$colon$colon(quantity$macro$75, new $c_Lshapeless_$colon$colon(unit$macro$76, new $c_Lshapeless_$colon$colon(unitPrice$macro$77, new $c_Lshapeless_$colon$colon(amount$macro$78, new $c_Lshapeless_$colon$colon(tradeBody$macro$79, new $c_Lshapeless_$colon$colon(buildingSite$macro$80, new $c_Lshapeless_$colon$colon(deliveryDate$macro$81, $m_Lshapeless_HNil$()))))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$62 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var reference$macro$63 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var description$macro$64 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var quantity$macro$65 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var unit$macro$66 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var unitPrice$macro$67 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var amount$macro$68 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var tradeBody$macro$69 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var buildingSite$macro$70 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var deliveryDate$macro$71 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                          var x = $m_Lshapeless_HNil$();
                          if ((x === p11)) {
                            return new $c_Lreactbuild_model_InvoiceDetail(id$macro$62, reference$macro$63, description$macro$64, quantity$macro$65, unit$macro$66, unitPrice$macro$67, amount$macro$68, tradeBody$macro$69, buildingSite$macro$70, deliveryDate$macro$71)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "deliveryDate"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "buildingSite"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "tradeBody"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "amount"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "unitPrice"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "unit"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "quantity"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    var this$44 = $m_s_$less$colon$less$();
    var ev = this$44.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$82__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_ju_UUID$().randomUUID__ju_UUID())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())), $m_Lshapeless_HNil$()))))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$58 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "id"));
    var this$59 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "reference"));
    var this$60 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "description"));
    var this$61 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "quantity"));
    var this$62 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "unit"));
    var this$63 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "unitPrice"));
    var this$64 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "amount"));
    var this$65 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "tradeBody"));
    var this$66 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "buildingSite"));
    var this$67 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "deliveryDate")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$6);
    var tailHelper$8 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var tailHelper$9 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$8);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$9);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$81 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$81, "id"));
    var wit$9 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$83 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "reference"));
    var wit$8 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$85 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "description"));
    var wit$7 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$87 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$87, "quantity"));
    var wit$6 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$89 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$89, "unit"));
    var wit$5 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$91 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$91, "unitPrice"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$93 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "amount"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$95 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$95, "tradeBody"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$97 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$97, "buildingSite"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$99 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$99, "deliveryDate"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$19);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var rtmT$5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var rtmT$6 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$5, wit$5);
    var rtmT$7 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$6, wit$6);
    var rtmT$8 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$7, wit$7);
    var rtmT$9 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$8, wit$8);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$9, wit$9);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$111 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$111, "id"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lshapeless_Witness$();
    var this$113 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$113, "reference"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$21);
    $m_Lshapeless_Witness$();
    var this$115 = $m_s_Symbol$();
    var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$115, "description"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$22);
    $m_Lshapeless_Witness$();
    var this$117 = $m_s_Symbol$();
    var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$117, "quantity"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$23);
    $m_Lshapeless_Witness$();
    var this$119 = $m_s_Symbol$();
    var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$119, "unit"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$24);
    $m_Lshapeless_Witness$();
    var this$121 = $m_s_Symbol$();
    var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$121, "unitPrice"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$25);
    $m_Lshapeless_Witness$();
    var this$123 = $m_s_Symbol$();
    var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$123, "amount"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$26);
    $m_Lshapeless_Witness$();
    var this$125 = $m_s_Symbol$();
    var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$125, "tradeBody"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$27);
    $m_Lshapeless_Witness$();
    var this$127 = $m_s_Symbol$();
    var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$127, "buildingSite"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$28);
    $m_Lshapeless_Witness$();
    var this$129 = $m_s_Symbol$();
    var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$129, "deliveryDate"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$29);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var kt$9 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$9, kt$9);
    var this$142 = $m_s_$less$colon$less$();
    var ev$1 = this$142.s_$less$colon$less$__f_singleton;
    var this$143 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$143);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$147 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$147);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$151 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$151);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$155 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$155);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$159 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$159);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$163 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$163);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$167 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$167);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$171 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$171);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$175 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$175);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$179 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$179);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$8, tttvs$8);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$183 = $m_s_$less$colon$less$();
    var ev$2 = this$183.s_$less$colon$less$__f_singleton;
    var this$184 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$184);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$10, ev$2);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$188 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$188);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$192 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$192);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$196 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$196);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$200 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$200);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$204 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$204);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$208 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$208);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$14, tttvs$14);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$212 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$212);
    var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$15, tttvs$15);
    var u$16 = new $c_Lshapeless_Lub$$anon$4();
    var this$216 = $m_sci_List$();
    var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$216);
    var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$16, tttvs$16);
    var u$17 = new $c_Lshapeless_Lub$$anon$4();
    var this$220 = $m_sci_List$();
    var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$220);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$17, tttvs$17);
    $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_inst$macro$1
}
function $p_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__inst$macro$82$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_inst$macro$82 = new $c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18($thiz);
    $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_inst$macro$82
}
/** @constructor */
function $c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2() {
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_inst$macro$1 = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_inst$macro$82 = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_bitmap$0 = 0
}
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2.prototype = new $h_O();
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2.prototype.constructor = $c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2;
/** @constructor */
function $h_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2.prototype = $c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2.prototype;
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_inst$macro$1)
});
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2.prototype.inst$macro$82__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__inst$macro$82$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2__f_inst$macro$82)
});
var $d_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2 = new $TypeData().initClass({
  Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2: 0
}, false, "reactbuild.model.InvoiceDetail$anon$lazy$macro$83$2", {
  Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2.prototype.$classData = $d_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2;
/** @constructor */
function $c_Lreactbuild_model_InvoicePage$() {
  this.Lreactbuild_model_InvoicePage$__f_codecForInvoicePage = null;
  $n_Lreactbuild_model_InvoicePage$ = this;
  var inst$macro$132 = new $c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$132));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_InvoicePage$__f_codecForInvoicePage = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_InvoicePage$.prototype = new $h_O();
$c_Lreactbuild_model_InvoicePage$.prototype.constructor = $c_Lreactbuild_model_InvoicePage$;
/** @constructor */
function $h_Lreactbuild_model_InvoicePage$() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePage$.prototype = $c_Lreactbuild_model_InvoicePage$.prototype;
$c_Lreactbuild_model_InvoicePage$.prototype.keyMapper__Lcom_iz2use_common_KeyMapper = (function() {
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lreactbuild_model_InvoicePage(x$5$2);
    return $n(x$5).Lreactbuild_model_InvoicePage__f__id
  }));
  var ev = $m_Lreactbuild_common_model_RefTo$().keyMapper__Lcom_iz2use_common_KeyMapper();
  return new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f)
});
var $d_Lreactbuild_model_InvoicePage$ = new $TypeData().initClass({
  Lreactbuild_model_InvoicePage$: 0
}, false, "reactbuild.model.InvoicePage$", {
  Lreactbuild_model_InvoicePage$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoicePage$.prototype.$classData = $d_Lreactbuild_model_InvoicePage$;
var $n_Lreactbuild_model_InvoicePage$;
function $m_Lreactbuild_model_InvoicePage$() {
  if ((!$n_Lreactbuild_model_InvoicePage$)) {
    $n_Lreactbuild_model_InvoicePage$ = new $c_Lreactbuild_model_InvoicePage$()
  };
  return $n_Lreactbuild_model_InvoicePage$
}
function $p_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "file"));
    var this$4 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "notDone"));
    var this$5 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "supplier"));
    var this$6 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "supplierOffice"));
    var this$7 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "date"));
    var this$8 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "reference"));
    var this$9 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "pageIndex"));
    var this$10 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "pageCount"));
    var this$11 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "amount"));
    var this$12 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "totalAmount"));
    var this$13 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "details"));
    var this$14 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "entryNumber"));
    var this$15 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "category"));
    var this$16 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "deletedAt")), $m_Lshapeless_HNil$()))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_InvoicePage(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$114 = $n(x0$7).Lreactbuild_model_InvoicePage__f__id;
        var organization$macro$115 = $n(x0$7).Lreactbuild_model_InvoicePage__f_organization;
        var file$macro$116 = $n(x0$7).Lreactbuild_model_InvoicePage__f_file;
        var notDone$macro$117 = $n(x0$7).Lreactbuild_model_InvoicePage__f_notDone;
        var supplier$macro$118 = $n(x0$7).Lreactbuild_model_InvoicePage__f_supplier;
        var supplierOffice$macro$119 = $n(x0$7).Lreactbuild_model_InvoicePage__f_supplierOffice;
        var date$macro$120 = $n(x0$7).Lreactbuild_model_InvoicePage__f_date;
        var reference$macro$121 = $n(x0$7).Lreactbuild_model_InvoicePage__f_reference;
        var pageIndex$macro$122 = $n(x0$7).Lreactbuild_model_InvoicePage__f_pageIndex;
        var pageCount$macro$123 = $n(x0$7).Lreactbuild_model_InvoicePage__f_pageCount;
        var amount$macro$124 = $n(x0$7).Lreactbuild_model_InvoicePage__f_amount;
        var totalAmount$macro$125 = $n(x0$7).Lreactbuild_model_InvoicePage__f_totalAmount;
        var details$macro$126 = $n(x0$7).Lreactbuild_model_InvoicePage__f_details;
        var entryNumber$macro$127 = $n(x0$7).Lreactbuild_model_InvoicePage__f_entryNumber;
        var category$macro$128 = $n(x0$7).Lreactbuild_model_InvoicePage__f_category;
        var deletedAt$macro$129 = $n(x0$7).Lreactbuild_model_InvoicePage__f_deletedAt;
        return new $c_Lshapeless_$colon$colon(_id$macro$114, new $c_Lshapeless_$colon$colon(organization$macro$115, new $c_Lshapeless_$colon$colon(file$macro$116, new $c_Lshapeless_$colon$colon(notDone$macro$117, new $c_Lshapeless_$colon$colon(supplier$macro$118, new $c_Lshapeless_$colon$colon(supplierOffice$macro$119, new $c_Lshapeless_$colon$colon(date$macro$120, new $c_Lshapeless_$colon$colon(reference$macro$121, new $c_Lshapeless_$colon$colon(pageIndex$macro$122, new $c_Lshapeless_$colon$colon(pageCount$macro$123, new $c_Lshapeless_$colon$colon(amount$macro$124, new $c_Lshapeless_$colon$colon(totalAmount$macro$125, new $c_Lshapeless_$colon$colon(details$macro$126, new $c_Lshapeless_$colon$colon(entryNumber$macro$127, new $c_Lshapeless_$colon$colon(category$macro$128, new $c_Lshapeless_$colon$colon(deletedAt$macro$129, $m_Lshapeless_HNil$()))))))))))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$98 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$99 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var file$macro$100 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var notDone$macro$101 = $uZ($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var supplier$macro$102 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var supplierOffice$macro$103 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var date$macro$104 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var reference$macro$105 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var pageIndex$macro$106 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var pageCount$macro$107 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                          if ((p11 !== null)) {
                            var amount$macro$108 = $as_s_Option($n(p11).Lshapeless_$colon$colon__f_head);
                            var p12 = $as_Lshapeless_$colon$colon($n(p11).Lshapeless_$colon$colon__f_tail);
                            if ((p12 !== null)) {
                              var totalAmount$macro$109 = $as_s_Option($n(p12).Lshapeless_$colon$colon__f_head);
                              var p13 = $as_Lshapeless_$colon$colon($n(p12).Lshapeless_$colon$colon__f_tail);
                              if ((p13 !== null)) {
                                var details$macro$110 = $as_sci_List($n(p13).Lshapeless_$colon$colon__f_head);
                                var p14 = $as_Lshapeless_$colon$colon($n(p13).Lshapeless_$colon$colon__f_tail);
                                if ((p14 !== null)) {
                                  var entryNumber$macro$111 = $as_s_Option($n(p14).Lshapeless_$colon$colon__f_head);
                                  var p15 = $as_Lshapeless_$colon$colon($n(p14).Lshapeless_$colon$colon__f_tail);
                                  if ((p15 !== null)) {
                                    var category$macro$112 = $as_s_Option($n(p15).Lshapeless_$colon$colon__f_head);
                                    var p16 = $as_Lshapeless_$colon$colon($n(p15).Lshapeless_$colon$colon__f_tail);
                                    if ((p16 !== null)) {
                                      var deletedAt$macro$113 = $as_s_Option($n(p16).Lshapeless_$colon$colon__f_head);
                                      var p17 = $as_Lshapeless_HNil($n(p16).Lshapeless_$colon$colon__f_tail);
                                      var x = $m_Lshapeless_HNil$();
                                      if ((x === p17)) {
                                        return new $c_Lreactbuild_model_InvoicePage(_id$macro$98, organization$macro$99, file$macro$100, notDone$macro$101, supplier$macro$102, supplierOffice$macro$103, date$macro$104, reference$macro$105, pageIndex$macro$106, pageCount$macro$107, amount$macro$108, totalAmount$macro$109, details$macro$110, entryNumber$macro$111, category$macro$112, deletedAt$macro$113)
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "deletedAt"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "entryNumber"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "totalAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "amount"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "pageCount"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "pageIndex"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$44 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$50 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "supplierOffice"));
    new $c_Lshapeless_Witness$$anon$1(value0$10);
    var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$11);
    var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
    $m_Lshapeless_Witness$();
    var this$56 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "notDone"));
    new $c_Lshapeless_Witness$$anon$1(value0$12);
    var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "file"));
    new $c_Lshapeless_Witness$$anon$1(value0$13);
    var zipWithKeys$14 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
    $m_Lshapeless_Witness$();
    var this$62 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$14);
    var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$15);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
    var this$68 = $m_s_$less$colon$less$();
    var ev = this$68.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$130__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), new $c_s_Some($m_Lreactbuild_model_DocumentCategory$Invoice$()))), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePage$(), $m_s_None$())), $m_Lshapeless_HNil$()))))))))))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$87 = $m_s_Symbol$();
    var $$x30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$87, "_id"));
    var this$88 = $m_s_Symbol$();
    var $$x29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "organization"));
    var this$89 = $m_s_Symbol$();
    var $$x28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$89, "file"));
    var this$90 = $m_s_Symbol$();
    var $$x27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "notDone"));
    var this$91 = $m_s_Symbol$();
    var $$x26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$91, "supplier"));
    var this$92 = $m_s_Symbol$();
    var $$x25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "supplierOffice"));
    var this$93 = $m_s_Symbol$();
    var $$x24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "date"));
    var this$94 = $m_s_Symbol$();
    var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$94, "reference"));
    var this$95 = $m_s_Symbol$();
    var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$95, "pageIndex"));
    var this$96 = $m_s_Symbol$();
    var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$96, "pageCount"));
    var this$97 = $m_s_Symbol$();
    var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$97, "amount"));
    var this$98 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$98, "totalAmount"));
    var this$99 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$99, "details"));
    var this$100 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$100, "entryNumber"));
    var this$101 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$101, "category"));
    var this$102 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x30, new $c_Lshapeless_$colon$colon($$x29, new $c_Lshapeless_$colon$colon($$x28, new $c_Lshapeless_$colon$colon($$x27, new $c_Lshapeless_$colon$colon($$x26, new $c_Lshapeless_$colon$colon($$x25, new $c_Lshapeless_$colon$colon($$x24, new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$102, "deletedAt")), $m_Lshapeless_HNil$()))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$6);
    var tailHelper$8 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var tailHelper$9 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$8);
    var tailHelper$10 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$9);
    var tailHelper$11 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$10);
    var tailHelper$12 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$11);
    var tailHelper$13 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$12);
    var tailHelper$14 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$13);
    var tailHelper$15 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$14);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$15);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$122 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$122, "_id"));
    var wit$13 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$124 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$124, "file"));
    var wit$12 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$126 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$126, "supplier"));
    var wit$11 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$128 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$128, "supplierOffice"));
    var wit$10 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$130 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$130, "date"));
    var wit$9 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$132 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$132, "reference"));
    var wit$8 = new $c_Lshapeless_Witness$$anon$1(value0$21);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$134 = $m_s_Symbol$();
    var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$134, "pageIndex"));
    var wit$7 = new $c_Lshapeless_Witness$$anon$1(value0$22);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$136 = $m_s_Symbol$();
    var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$136, "pageCount"));
    var wit$6 = new $c_Lshapeless_Witness$$anon$1(value0$23);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$138 = $m_s_Symbol$();
    var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$138, "amount"));
    var wit$5 = new $c_Lshapeless_Witness$$anon$1(value0$24);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$140 = $m_s_Symbol$();
    var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$140, "totalAmount"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$25);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$142 = $m_s_Symbol$();
    var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$142, "details"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$26);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$144 = $m_s_Symbol$();
    var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$144, "entryNumber"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$27);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$146 = $m_s_Symbol$();
    var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$146, "category"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$28);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$148 = $m_s_Symbol$();
    var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$148, "deletedAt"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$29);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var rtmT$5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var rtmT$6 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$5, wit$5);
    var rtmT$7 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$6, wit$6);
    var rtmT$8 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$7, wit$7);
    var rtmT$9 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$8, wit$8);
    var rtmT$10 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$9, wit$9);
    var rtmT$11 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$10, wit$10);
    var rtmT$12 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$11, wit$11);
    var rtmT$13 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$12, wit$12);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$13, wit$13);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$164 = $m_s_Symbol$();
    var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$164, "_id"));
    var wk$15 = new $c_Lshapeless_Witness$$anon$1(value0$30);
    $m_Lshapeless_Witness$();
    var this$166 = $m_s_Symbol$();
    var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$166, "organization"));
    var wk$14 = new $c_Lshapeless_Witness$$anon$1(value0$31);
    $m_Lshapeless_Witness$();
    var this$168 = $m_s_Symbol$();
    var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$168, "file"));
    var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$32);
    $m_Lshapeless_Witness$();
    var this$170 = $m_s_Symbol$();
    var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$170, "notDone"));
    var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$33);
    $m_Lshapeless_Witness$();
    var this$172 = $m_s_Symbol$();
    var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$172, "supplier"));
    var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$34);
    $m_Lshapeless_Witness$();
    var this$174 = $m_s_Symbol$();
    var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$174, "supplierOffice"));
    var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$35);
    $m_Lshapeless_Witness$();
    var this$176 = $m_s_Symbol$();
    var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$176, "date"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$36);
    $m_Lshapeless_Witness$();
    var this$178 = $m_s_Symbol$();
    var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$178, "reference"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$37);
    $m_Lshapeless_Witness$();
    var this$180 = $m_s_Symbol$();
    var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$180, "pageIndex"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$38);
    $m_Lshapeless_Witness$();
    var this$182 = $m_s_Symbol$();
    var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$182, "pageCount"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$39);
    $m_Lshapeless_Witness$();
    var this$184 = $m_s_Symbol$();
    var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$184, "amount"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$40);
    $m_Lshapeless_Witness$();
    var this$186 = $m_s_Symbol$();
    var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$186, "totalAmount"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$41);
    $m_Lshapeless_Witness$();
    var this$188 = $m_s_Symbol$();
    var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$188, "details"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$42);
    $m_Lshapeless_Witness$();
    var this$190 = $m_s_Symbol$();
    var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$190, "entryNumber"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$43);
    $m_Lshapeless_Witness$();
    var this$192 = $m_s_Symbol$();
    var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$192, "category"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$44);
    $m_Lshapeless_Witness$();
    var this$194 = $m_s_Symbol$();
    var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$194, "deletedAt"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$45);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var kt$9 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var kt$10 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$9, kt$9);
    var kt$11 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$10, kt$10);
    var kt$12 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$11, kt$11);
    var kt$13 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$12, kt$12);
    var kt$14 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$13, kt$13);
    var kt$15 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$14, kt$14);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$15, kt$15);
    var this$213 = $m_s_$less$colon$less$();
    var ev$1 = this$213.s_$less$colon$less$__f_singleton;
    var this$214 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$214);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$218 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$218);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$222 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$222);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$226 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$226);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$230 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$230);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$234 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$234);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$238 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$238);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$242 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$242);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$246 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$246);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$250 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$250);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$254 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$254);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$258 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$258);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$262 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$262);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$266 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$266);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$270 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$270);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$274 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$274);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$14, tttvs$14);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$278 = $m_s_$less$colon$less$();
    var ev$2 = this$278.s_$less$colon$less$__f_singleton;
    var this$279 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$279);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$16, ev$2);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$283 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$283);
    var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$15, tttvs$15);
    var u$16 = new $c_Lshapeless_Lub$$anon$4();
    var this$287 = $m_sci_List$();
    var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$287);
    var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$16, tttvs$16);
    var u$17 = new $c_Lshapeless_Lub$$anon$4();
    var this$291 = $m_sci_List$();
    var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$291);
    var tttvs$18 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$17, tttvs$17);
    var u$18 = new $c_Lshapeless_Lub$$anon$4();
    var this$295 = $m_sci_List$();
    var cbf$20 = new $c_sc_IterableFactory$ToFactory(this$295);
    var tttvs$19 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$20, u$18, tttvs$18);
    var u$19 = new $c_Lshapeless_Lub$$anon$4();
    var this$299 = $m_sci_List$();
    var cbf$21 = new $c_sc_IterableFactory$ToFactory(this$299);
    var tttvs$20 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$21, u$19, tttvs$19);
    var u$20 = new $c_Lshapeless_Lub$$anon$4();
    var this$303 = $m_sci_List$();
    var cbf$22 = new $c_sc_IterableFactory$ToFactory(this$303);
    var tttvs$21 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$22, u$20, tttvs$20);
    var u$21 = new $c_Lshapeless_Lub$$anon$4();
    var this$307 = $m_sci_List$();
    var cbf$23 = new $c_sc_IterableFactory$ToFactory(this$307);
    var tttvs$22 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$23, u$21, tttvs$21);
    var u$22 = new $c_Lshapeless_Lub$$anon$4();
    var this$311 = $m_sci_List$();
    var cbf$24 = new $c_sc_IterableFactory$ToFactory(this$311);
    var tttvs$23 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$24, u$22, tttvs$22);
    var u$23 = new $c_Lshapeless_Lub$$anon$4();
    var this$315 = $m_sci_List$();
    var cbf$25 = new $c_sc_IterableFactory$ToFactory(this$315);
    var tttvs$24 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$25, u$23, tttvs$23);
    var u$24 = new $c_Lshapeless_Lub$$anon$4();
    var this$319 = $m_sci_List$();
    var cbf$26 = new $c_sc_IterableFactory$ToFactory(this$319);
    var tttvs$25 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$26, u$24, tttvs$24);
    var u$25 = new $c_Lshapeless_Lub$$anon$4();
    var this$323 = $m_sci_List$();
    var cbf$27 = new $c_sc_IterableFactory$ToFactory(this$323);
    var tttvs$26 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$27, u$25, tttvs$25);
    var u$26 = new $c_Lshapeless_Lub$$anon$4();
    var this$327 = $m_sci_List$();
    var cbf$28 = new $c_sc_IterableFactory$ToFactory(this$327);
    var tttvs$27 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$28, u$26, tttvs$26);
    var u$27 = new $c_Lshapeless_Lub$$anon$4();
    var this$331 = $m_sci_List$();
    var cbf$29 = new $c_sc_IterableFactory$ToFactory(this$331);
    var tttvs$28 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$29, u$27, tttvs$27);
    var u$28 = new $c_Lshapeless_Lub$$anon$4();
    var this$335 = $m_sci_List$();
    var cbf$30 = new $c_sc_IterableFactory$ToFactory(this$335);
    var tttvs$29 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$30, u$28, tttvs$28);
    var u$29 = new $c_Lshapeless_Lub$$anon$4();
    var this$339 = $m_sci_List$();
    var cbf$31 = new $c_sc_IterableFactory$ToFactory(this$339);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$31, u$29, tttvs$29);
    $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_inst$macro$1
}
function $p_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__inst$macro$130$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_inst$macro$130 = new $c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7($thiz);
    $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_inst$macro$130
}
/** @constructor */
function $c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1() {
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_inst$macro$130 = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1.prototype = new $h_O();
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1.prototype.constructor = $c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1;
/** @constructor */
function $h_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1.prototype = $c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1.prototype;
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_inst$macro$1)
});
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1.prototype.inst$macro$130__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__inst$macro$130$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1__f_inst$macro$130)
});
var $d_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1 = new $TypeData().initClass({
  Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1: 0
}, false, "reactbuild.model.InvoicePage$anon$lazy$macro$131$1", {
  Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1.prototype.$classData = $d_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1;
/** @constructor */
function $c_Lreactbuild_model_InvoicePageFile$() {
  this.Lreactbuild_model_InvoicePageFile$__f_codecForInvoicePageFile = null;
  $n_Lreactbuild_model_InvoicePageFile$ = this;
  var inst$macro$12 = new $c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_InvoicePageFile$__f_codecForInvoicePageFile = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_InvoicePageFile$.prototype = new $h_O();
$c_Lreactbuild_model_InvoicePageFile$.prototype.constructor = $c_Lreactbuild_model_InvoicePageFile$;
/** @constructor */
function $h_Lreactbuild_model_InvoicePageFile$() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePageFile$.prototype = $c_Lreactbuild_model_InvoicePageFile$.prototype;
var $d_Lreactbuild_model_InvoicePageFile$ = new $TypeData().initClass({
  Lreactbuild_model_InvoicePageFile$: 0
}, false, "reactbuild.model.InvoicePageFile$", {
  Lreactbuild_model_InvoicePageFile$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoicePageFile$.prototype.$classData = $d_Lreactbuild_model_InvoicePageFile$;
var $n_Lreactbuild_model_InvoicePageFile$;
function $m_Lreactbuild_model_InvoicePageFile$() {
  if ((!$n_Lreactbuild_model_InvoicePageFile$)) {
    $n_Lreactbuild_model_InvoicePageFile$ = new $c_Lreactbuild_model_InvoicePageFile$()
  };
  return $n_Lreactbuild_model_InvoicePageFile$
}
function $p_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "path")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_InvoicePageFile(x0$7$2);
      if ((x0$7 !== null)) {
        var path$macro$9 = $n(x0$7).Lreactbuild_model_InvoicePageFile__f_path;
        return new $c_Lshapeless_$colon$colon(path$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var path$macro$8 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_InvoicePageFile(path$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "path"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "path")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "path"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_inst$macro$1
}
function $p_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_inst$macro$10 = new $c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6($thiz);
    $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2() {
  this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_inst$macro$1 = null;
  this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_inst$macro$10 = null;
  this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_bitmap$0 = 0
}
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2.prototype = new $h_O();
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2.prototype.constructor = $c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2;
/** @constructor */
function $h_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2.prototype = $c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2.prototype;
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_inst$macro$1)
});
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2__f_inst$macro$10)
});
var $d_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2 = new $TypeData().initClass({
  Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2: 0
}, false, "reactbuild.model.InvoicePageFile$anon$lazy$macro$11$2", {
  Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2.prototype.$classData = $d_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2;
/** @constructor */
function $c_Lreactbuild_model_InvoicePageGroup$() {
  this.Lreactbuild_model_InvoicePageGroup$__f_codecForInvoicePageGroup = null;
  $n_Lreactbuild_model_InvoicePageGroup$ = this;
  var inst$macro$84 = new $c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$84));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_InvoicePageGroup$__f_codecForInvoicePageGroup = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_InvoicePageGroup$.prototype = new $h_O();
$c_Lreactbuild_model_InvoicePageGroup$.prototype.constructor = $c_Lreactbuild_model_InvoicePageGroup$;
/** @constructor */
function $h_Lreactbuild_model_InvoicePageGroup$() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePageGroup$.prototype = $c_Lreactbuild_model_InvoicePageGroup$.prototype;
$c_Lreactbuild_model_InvoicePageGroup$.prototype.keyMapperInvoicePageGroup__Lcom_iz2use_common_KeyMapper = (function() {
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_model_InvoicePageGroup(v$2);
    var this$2 = $n($n(v).Lreactbuild_model_InvoicePageGroup__f_supplier);
    if (this$2.isEmpty__Z()) {
      var $$x1 = "***"
    } else {
      var arg1 = this$2.get__O();
      var x$6 = $as_Lreactbuild_common_model_RefTo(arg1);
      var $$x1 = $n($n(x$6).Lreactbuild_common_model_RefTo__f_id).toString__T()
    };
    return (($$x1 + "|") + $n($as_Lreactbuild_model_InvoicePage($n($n(v).Lreactbuild_model_InvoicePageGroup__f_pages).head__O())).Lreactbuild_model_InvoicePage__f__id)
  }));
  var ev = $m_Lcom_iz2use_common_KeyMapper$().Lcom_iz2use_common_KeyMapper$__f_fromString;
  return new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f)
});
var $d_Lreactbuild_model_InvoicePageGroup$ = new $TypeData().initClass({
  Lreactbuild_model_InvoicePageGroup$: 0
}, false, "reactbuild.model.InvoicePageGroup$", {
  Lreactbuild_model_InvoicePageGroup$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoicePageGroup$.prototype.$classData = $d_Lreactbuild_model_InvoicePageGroup$;
var $n_Lreactbuild_model_InvoicePageGroup$;
function $m_Lreactbuild_model_InvoicePageGroup$() {
  if ((!$n_Lreactbuild_model_InvoicePageGroup$)) {
    $n_Lreactbuild_model_InvoicePageGroup$ = new $c_Lreactbuild_model_InvoicePageGroup$()
  };
  return $n_Lreactbuild_model_InvoicePageGroup$
}
function $p_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "organization"));
    var this$2 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "supplier"));
    var this$3 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "date"));
    var this$4 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "entryNumber"));
    var this$5 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "reference"));
    var this$6 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "pages"));
    var this$7 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "totalAmount"));
    var this$8 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "expectedAmount"));
    var this$9 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "received"));
    var this$10 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "category")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_InvoicePageGroup(x0$7$2);
      if ((x0$7 !== null)) {
        var organization$macro$72 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_organization;
        var supplier$macro$73 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_supplier;
        var date$macro$74 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_date;
        var entryNumber$macro$75 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
        var reference$macro$76 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_reference;
        var pages$macro$77 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_pages;
        var totalAmount$macro$78 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
        var expectedAmount$macro$79 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
        var received$macro$80 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_received;
        var category$macro$81 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_category;
        return new $c_Lshapeless_$colon$colon(organization$macro$72, new $c_Lshapeless_$colon$colon(supplier$macro$73, new $c_Lshapeless_$colon$colon(date$macro$74, new $c_Lshapeless_$colon$colon(entryNumber$macro$75, new $c_Lshapeless_$colon$colon(reference$macro$76, new $c_Lshapeless_$colon$colon(pages$macro$77, new $c_Lshapeless_$colon$colon(totalAmount$macro$78, new $c_Lshapeless_$colon$colon(expectedAmount$macro$79, new $c_Lshapeless_$colon$colon(received$macro$80, new $c_Lshapeless_$colon$colon(category$macro$81, $m_Lshapeless_HNil$()))))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var organization$macro$62 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var supplier$macro$63 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var date$macro$64 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var entryNumber$macro$65 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var reference$macro$66 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var pages$macro$67 = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var totalAmount$macro$68 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var expectedAmount$macro$69 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var received$macro$70 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var category$macro$71 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                          var x = $m_Lshapeless_HNil$();
                          if ((x === p11)) {
                            return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$62, supplier$macro$63, date$macro$64, entryNumber$macro$65, reference$macro$66, pages$macro$67, totalAmount$macro$68, expectedAmount$macro$69, received$macro$70, category$macro$71)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "received"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "expectedAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "totalAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "pages"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "entryNumber"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    var this$44 = $m_s_$less$colon$less$();
    var ev = this$44.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$82__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePageGroup$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePageGroup$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePageGroup$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePageGroup$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePageGroup$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePageGroup$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePageGroup$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePageGroup$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_InvoicePageGroup$(), $m_s_None$())), $m_Lshapeless_HNil$()))))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$57 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "organization"));
    var this$58 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "supplier"));
    var this$59 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "date"));
    var this$60 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "entryNumber"));
    var this$61 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "reference"));
    var this$62 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "pages"));
    var this$63 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "totalAmount"));
    var this$64 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "expectedAmount"));
    var this$65 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "received"));
    var this$66 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "category")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$6);
    var tailHelper$8 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var tailHelper$9 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$8);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$9);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$80 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "supplier"));
    var wit$8 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$82 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$82, "date"));
    var wit$7 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$84 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$84, "entryNumber"));
    var wit$6 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$86 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$86, "reference"));
    var wit$5 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$88 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "pages"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$90 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "totalAmount"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$92 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "expectedAmount"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$94 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$94, "received"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$96 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$96, "category"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$18);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var rtmT$5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var rtmT$6 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$5, wit$5);
    var rtmT$7 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$6, wit$6);
    var rtmT$8 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$7, wit$7);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$8, wit$8);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$107 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$107, "organization"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$109 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$109, "supplier"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lshapeless_Witness$();
    var this$111 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$111, "date"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$21);
    $m_Lshapeless_Witness$();
    var this$113 = $m_s_Symbol$();
    var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$113, "entryNumber"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$22);
    $m_Lshapeless_Witness$();
    var this$115 = $m_s_Symbol$();
    var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$115, "reference"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$23);
    $m_Lshapeless_Witness$();
    var this$117 = $m_s_Symbol$();
    var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$117, "pages"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$24);
    $m_Lshapeless_Witness$();
    var this$119 = $m_s_Symbol$();
    var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$119, "totalAmount"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$25);
    $m_Lshapeless_Witness$();
    var this$121 = $m_s_Symbol$();
    var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$121, "expectedAmount"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$26);
    $m_Lshapeless_Witness$();
    var this$123 = $m_s_Symbol$();
    var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$123, "received"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$27);
    $m_Lshapeless_Witness$();
    var this$125 = $m_s_Symbol$();
    var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$125, "category"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$28);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var kt$9 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$9, kt$9);
    var this$138 = $m_s_$less$colon$less$();
    var ev$1 = this$138.s_$less$colon$less$__f_singleton;
    var this$139 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$139);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$143 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$143);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$147 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$147);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$151 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$151);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$155 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$155);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$159 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$159);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$163 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$163);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$167 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$167);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$171 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$171);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$175 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$175);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$8, tttvs$8);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$179 = $m_s_$less$colon$less$();
    var ev$2 = this$179.s_$less$colon$less$__f_singleton;
    var this$180 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$180);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$10, ev$2);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$184 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$184);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$188 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$188);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$192 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$192);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$196 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$196);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$200 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$200);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$204 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$204);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$14, tttvs$14);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$208 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$208);
    var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$15, tttvs$15);
    var u$16 = new $c_Lshapeless_Lub$$anon$4();
    var this$212 = $m_sci_List$();
    var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$212);
    var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$16, tttvs$16);
    var u$17 = new $c_Lshapeless_Lub$$anon$4();
    var this$216 = $m_sci_List$();
    var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$216);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$17, tttvs$17);
    $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_inst$macro$1
}
function $p_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__inst$macro$82$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_inst$macro$82 = new $c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8($thiz);
    $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_inst$macro$82
}
/** @constructor */
function $c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1() {
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_inst$macro$82 = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1.prototype = new $h_O();
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1.prototype.constructor = $c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1;
/** @constructor */
function $h_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1.prototype = $c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1.prototype;
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_inst$macro$1)
});
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1.prototype.inst$macro$82__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__inst$macro$82$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1__f_inst$macro$82)
});
var $d_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1 = new $TypeData().initClass({
  Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1: 0
}, false, "reactbuild.model.InvoicePageGroup$anon$lazy$macro$83$1", {
  Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1.prototype.$classData = $d_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1;
function $p_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__inst$macro$89$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "created"));
    var this$3 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "project"));
    var this$4 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "title"));
    var this$5 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "terms"));
    var this$6 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "duration"));
    var this$7 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "from"));
    var this$8 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "type")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_model_CustomListEntry(x0$23$2);
      if ((x0$23 !== null)) {
        var _id$macro$146 = $n(x0$23).Lreactbuild_model_CustomListEntry__f__id;
        var created$macro$147 = $n(x0$23).Lreactbuild_model_CustomListEntry__f_created;
        var project$macro$148 = $n(x0$23).Lreactbuild_model_CustomListEntry__f_project;
        var title$macro$149 = $n(x0$23).Lreactbuild_model_CustomListEntry__f_title;
        var terms$macro$150 = $n(x0$23).Lreactbuild_model_CustomListEntry__f_terms;
        var duration$macro$151 = $n(x0$23).Lreactbuild_model_CustomListEntry__f_duration;
        var from$macro$152 = $n(x0$23).Lreactbuild_model_CustomListEntry__f_from;
        var type$macro$153 = $n(x0$23).Lreactbuild_model_CustomListEntry__f_type;
        return new $c_Lshapeless_$colon$colon(_id$macro$146, new $c_Lshapeless_$colon$colon(created$macro$147, new $c_Lshapeless_$colon$colon(project$macro$148, new $c_Lshapeless_$colon$colon(title$macro$149, new $c_Lshapeless_$colon$colon(terms$macro$150, new $c_Lshapeless_$colon$colon(duration$macro$151, new $c_Lshapeless_$colon$colon(from$macro$152, new $c_Lshapeless_$colon$colon(type$macro$153, $m_Lshapeless_HNil$()))))))))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var _id$macro$138 = $as_Lreactbuild_common_model_RefTo($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var created$macro$139 = $as_Ljava_time_Instant($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var project$macro$140 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var title$macro$141 = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var terms$macro$142 = $as_sci_ListSet($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var duration$macro$143 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var from$macro$144 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var type$macro$145 = $as_Lreactbuild_model_ListEntryType($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p9)) {
                        return new $c_Lreactbuild_model_CustomListEntry(_id$macro$138, created$macro$139, project$macro$140, title$macro$141, terms$macro$142, duration$macro$143, from$macro$144, type$macro$145)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "type"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "from"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "duration"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "terms"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    var this$36 = $m_s_$less$colon$less$();
    var ev = this$36.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$154__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "_id"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "created"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "project"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "title"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "terms"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "duration"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "from"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "type"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$15);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var this$64 = $m_s_$less$colon$less$();
    var ev$1 = this$64.s_$less$colon$less$__f_singleton;
    var this$65 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$73);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$77 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$77);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$81 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$81);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$85 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$85);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$89 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$89);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$93 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$93);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$97 = $m_s_$less$colon$less$();
    var ev$2 = this$97.s_$less$colon$less$__f_singleton;
    var this$98 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$98);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$8, ev$2);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$102 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$102);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$106 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$106);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$110 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$110);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$114 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$114);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$118 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$118);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$122 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$122);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$126 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$126);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_inst$macro$89 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_inst$macro$89
}
function $p_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__inst$macro$154$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_inst$macro$154 = new $c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78($thiz);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_inst$macro$154
}
/** @constructor */
function $c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1() {
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_inst$macro$89 = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_inst$macro$154 = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1.prototype = new $h_O();
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1.prototype.constructor = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1;
/** @constructor */
function $h_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1.prototype = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1.prototype;
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1.prototype.inst$macro$89__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((1 & this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__inst$macro$89$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_inst$macro$89)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1.prototype.inst$macro$154__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((2 & this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__inst$macro$154$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1__f_inst$macro$154)
});
var $d_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1 = new $TypeData().initClass({
  Lreactbuild_model_ListEntry$anon$lazy$macro$155$1: 0
}, false, "reactbuild.model.ListEntry$anon$lazy$macro$155$1", {
  Lreactbuild_model_ListEntry$anon$lazy$macro$155$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1.prototype.$classData = $d_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1;
function $p_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__inst$macro$157$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x25 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "created"));
    var this$3 = $m_s_Symbol$();
    var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "project"));
    var this$4 = $m_s_Symbol$();
    var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "title"));
    var this$5 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "terms"));
    var this$6 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "duration"));
    var this$7 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "from"));
    var this$8 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "type")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_model_CustomListEntry(x0$31$2);
      if ((x0$31 !== null)) {
        var _id$macro$214 = $n(x0$31).Lreactbuild_model_CustomListEntry__f__id;
        var created$macro$215 = $n(x0$31).Lreactbuild_model_CustomListEntry__f_created;
        var project$macro$216 = $n(x0$31).Lreactbuild_model_CustomListEntry__f_project;
        var title$macro$217 = $n(x0$31).Lreactbuild_model_CustomListEntry__f_title;
        var terms$macro$218 = $n(x0$31).Lreactbuild_model_CustomListEntry__f_terms;
        var duration$macro$219 = $n(x0$31).Lreactbuild_model_CustomListEntry__f_duration;
        var from$macro$220 = $n(x0$31).Lreactbuild_model_CustomListEntry__f_from;
        var type$macro$221 = $n(x0$31).Lreactbuild_model_CustomListEntry__f_type;
        return new $c_Lshapeless_$colon$colon(_id$macro$214, new $c_Lshapeless_$colon$colon(created$macro$215, new $c_Lshapeless_$colon$colon(project$macro$216, new $c_Lshapeless_$colon$colon(title$macro$217, new $c_Lshapeless_$colon$colon(terms$macro$218, new $c_Lshapeless_$colon$colon(duration$macro$219, new $c_Lshapeless_$colon$colon(from$macro$220, new $c_Lshapeless_$colon$colon(type$macro$221, $m_Lshapeless_HNil$()))))))))
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var _id$macro$206 = $as_Lreactbuild_common_model_RefTo($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$32).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var created$macro$207 = $as_Ljava_time_Instant($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var project$macro$208 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var title$macro$209 = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var terms$macro$210 = $as_sci_ListSet($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var duration$macro$211 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var from$macro$212 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var type$macro$213 = $as_Lreactbuild_model_ListEntryType($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p9)) {
                        return new $c_Lreactbuild_model_CustomListEntry(_id$macro$206, created$macro$207, project$macro$208, title$macro$209, terms$macro$210, duration$macro$211, from$macro$212, type$macro$213)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "type"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "from"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "duration"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "terms"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    var this$36 = $m_s_$less$colon$less$();
    var ev = this$36.s_$less$colon$less$__f_singleton;
    var $$x24 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$222__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x16 = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x7 = new $c_s_Some(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())));
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x6 = $m_Ljava_time_Instant$();
    var this$46 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$46.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$46.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var defaults = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon(new $c_s_Some($n($$x6).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_sci_ListSet$EmptyListSet$()), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_Lreactbuild_model_ListEntryType$Issue$()), $m_Lshapeless_HNil$()))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$53 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "_id"));
    var this$54 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "created"));
    var this$55 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "project"));
    var this$56 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "title"));
    var this$57 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "terms"));
    var this$58 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "duration"));
    var this$59 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "from"));
    var this$60 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "type")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$6);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var $$x15 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$72 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$72, "_id"));
    var wit$5 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$74 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "created"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$76 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "terms"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$78 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "duration"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$80 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "from"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$82 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$82, "type"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var rtmT$5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$5, wit$5);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$90 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "_id"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$92 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "created"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$94 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$94, "project"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$96 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$96, "title"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$98 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$98, "terms"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lshapeless_Witness$();
    var this$100 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$100, "duration"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$102 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$102, "from"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lshapeless_Witness$();
    var this$104 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$104, "type"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$21);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var this$115 = $m_s_$less$colon$less$();
    var ev$1 = this$115.s_$less$colon$less$__f_singleton;
    var this$116 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$116);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$120 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$120);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$124 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$124);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$128 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$128);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$132 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$132);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$136 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$136);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$140 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$140);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$144 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$144);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$148 = $m_s_$less$colon$less$();
    var ev$2 = this$148.s_$less$colon$less$__f_singleton;
    var this$149 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$149);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$8, ev$2);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$153 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$153);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$157 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$157);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$161 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$161);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$165 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$165);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$169 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$169);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$173 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$173);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$177 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$177);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_inst$macro$157 = $n($$x25).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x24, $$x16, $$x15, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13));
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_inst$macro$157
}
function $p_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__inst$macro$222$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_inst$macro$222 = new $c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79($thiz);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_inst$macro$222
}
/** @constructor */
function $c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1() {
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_inst$macro$157 = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_inst$macro$222 = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1.prototype = new $h_O();
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1.prototype.constructor = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1;
/** @constructor */
function $h_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1.prototype = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1.prototype;
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1.prototype.inst$macro$157__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((1 & this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__inst$macro$157$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_inst$macro$157)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1.prototype.inst$macro$222__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__inst$macro$222$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1__f_inst$macro$222)
});
var $d_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1 = new $TypeData().initClass({
  Lreactbuild_model_ListEntry$anon$lazy$macro$223$1: 0
}, false, "reactbuild.model.ListEntry$anon$lazy$macro$223$1", {
  Lreactbuild_model_ListEntry$anon$lazy$macro$223$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1.prototype.$classData = $d_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1;
function $p_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "templateEntry"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "_id"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "created"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "project"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "duration")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_InstanceListEntry(x0$7$2);
      if ((x0$7 !== null)) {
        var templateEntry$macro$37 = $n(x0$7).Lreactbuild_model_InstanceListEntry__f_templateEntry;
        var _id$macro$38 = $n(x0$7).Lreactbuild_model_InstanceListEntry__f__id;
        var created$macro$39 = $n(x0$7).Lreactbuild_model_InstanceListEntry__f_created;
        var project$macro$40 = $n(x0$7).Lreactbuild_model_InstanceListEntry__f_project;
        var duration$macro$41 = $n(x0$7).Lreactbuild_model_InstanceListEntry__f_duration;
        return new $c_Lshapeless_$colon$colon(templateEntry$macro$37, new $c_Lshapeless_$colon$colon(_id$macro$38, new $c_Lshapeless_$colon$colon(created$macro$39, new $c_Lshapeless_$colon$colon(project$macro$40, new $c_Lshapeless_$colon$colon(duration$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var templateEntry$macro$32 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var _id$macro$33 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var created$macro$34 = $as_Ljava_time_Instant($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var project$macro$35 = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var duration$macro$36 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_model_InstanceListEntry(templateEntry$macro$32, _id$macro$33, created$macro$34, project$macro$35, duration$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "duration"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "templateEntry"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "templateEntry"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "created"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "project"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "duration"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$43 = $m_s_$less$colon$less$();
    var ev$1 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$48);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$52 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$52);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$56 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$56);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$60 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$60);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$64 = $m_s_$less$colon$less$();
    var ev$2 = this$64.s_$less$colon$less$__f_singleton;
    var this$65 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$73);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$77 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$77);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$81 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$81);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_inst$macro$1 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_inst$macro$1
}
function $p_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__inst$macro$42$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_inst$macro$42 = new $c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76($thiz);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8() {
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_inst$macro$1 = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_inst$macro$42 = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8.prototype = new $h_O();
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8.prototype.constructor = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8;
/** @constructor */
function $h_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8.prototype = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8.prototype;
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8.prototype.inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((1 & this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_inst$macro$1)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8.prototype.inst$macro$42__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((2 & this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__inst$macro$42$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8__f_inst$macro$42)
});
var $d_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8 = new $TypeData().initClass({
  Lreactbuild_model_ListEntry$anon$lazy$macro$43$8: 0
}, false, "reactbuild.model.ListEntry$anon$lazy$macro$43$8", {
  Lreactbuild_model_ListEntry$anon$lazy$macro$43$8: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8.prototype.$classData = $d_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8;
function $p_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__inst$macro$45$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x20 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "templateEntry"));
    var this$2 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "_id"));
    var this$3 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "created"));
    var this$4 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "project"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "duration")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_InstanceListEntry(x0$15$2);
      if ((x0$15 !== null)) {
        var templateEntry$macro$81 = $n(x0$15).Lreactbuild_model_InstanceListEntry__f_templateEntry;
        var _id$macro$82 = $n(x0$15).Lreactbuild_model_InstanceListEntry__f__id;
        var created$macro$83 = $n(x0$15).Lreactbuild_model_InstanceListEntry__f_created;
        var project$macro$84 = $n(x0$15).Lreactbuild_model_InstanceListEntry__f_project;
        var duration$macro$85 = $n(x0$15).Lreactbuild_model_InstanceListEntry__f_duration;
        return new $c_Lshapeless_$colon$colon(templateEntry$macro$81, new $c_Lshapeless_$colon$colon(_id$macro$82, new $c_Lshapeless_$colon$colon(created$macro$83, new $c_Lshapeless_$colon$colon(project$macro$84, new $c_Lshapeless_$colon$colon(duration$macro$85, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var templateEntry$macro$76 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var _id$macro$77 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var created$macro$78 = $as_Ljava_time_Instant($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var project$macro$79 = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var duration$macro$80 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_model_InstanceListEntry(templateEntry$macro$76, _id$macro$77, created$macro$78, project$macro$79, duration$macro$80)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "duration"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "templateEntry"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var $$x19 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$86__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x14 = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x8 = $m_s_None$();
    var $$x7 = new $c_s_Some(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())));
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x6 = $m_Ljava_time_Instant$();
    var this$34 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$34.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$34.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var defaults = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon(new $c_s_Some($n($$x6).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$37 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "templateEntry"));
    var this$38 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "_id"));
    var this$39 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "created"));
    var this$40 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "project"));
    var this$41 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "duration")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var $$x13 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$50 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "_id"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$52 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "created"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$54 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "duration"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "templateEntry"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "created"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "project"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$67 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "duration"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$12);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$75 = $m_s_$less$colon$less$();
    var ev$1 = this$75.s_$less$colon$less$__f_singleton;
    var this$76 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$76);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$80 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$88);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$92 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$92);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$96 = $m_s_$less$colon$less$();
    var ev$2 = this$96.s_$less$colon$less$__f_singleton;
    var this$97 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$97);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$101 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$113);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_inst$macro$45 = $n($$x20).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x19, $$x14, $$x13, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7));
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_inst$macro$45
}
function $p_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__inst$macro$86$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_inst$macro$86 = new $c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77($thiz);
    $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_inst$macro$86
}
/** @constructor */
function $c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1() {
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_inst$macro$45 = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_inst$macro$86 = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1.prototype = new $h_O();
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1.prototype.constructor = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1;
/** @constructor */
function $h_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1.prototype = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1.prototype;
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1.prototype.inst$macro$45__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((1 & this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__inst$macro$45$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_inst$macro$45)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1.prototype.inst$macro$86__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__inst$macro$86$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1__f_inst$macro$86)
});
var $d_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1 = new $TypeData().initClass({
  Lreactbuild_model_ListEntry$anon$lazy$macro$87$1: 0
}, false, "reactbuild.model.ListEntry$anon$lazy$macro$87$1", {
  Lreactbuild_model_ListEntry$anon$lazy$macro$87$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1.prototype.$classData = $d_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEvent$() {
  this.Lreactbuild_model_ListEntryEvent$__f_codecForListEntryEvent = null;
  $n_Lreactbuild_model_ListEntryEvent$ = this;
  var inst$macro$44 = new $c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_ListEntryEvent$__f_codecForListEntryEvent = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_ListEntryEvent$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEvent$.prototype.constructor = $c_Lreactbuild_model_ListEntryEvent$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEvent$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEvent$.prototype = $c_Lreactbuild_model_ListEntryEvent$.prototype;
var $d_Lreactbuild_model_ListEntryEvent$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEvent$: 0
}, false, "reactbuild.model.ListEntryEvent$", {
  Lreactbuild_model_ListEntryEvent$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEvent$.prototype.$classData = $d_Lreactbuild_model_ListEntryEvent$;
var $n_Lreactbuild_model_ListEntryEvent$;
function $m_Lreactbuild_model_ListEntryEvent$() {
  if ((!$n_Lreactbuild_model_ListEntryEvent$)) {
    $n_Lreactbuild_model_ListEntryEvent$ = new $c_Lreactbuild_model_ListEntryEvent$()
  };
  return $n_Lreactbuild_model_ListEntryEvent$
}
function $p_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "entry"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "created"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "user"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "body")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_ListEntryEvent(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$37 = $n(x0$7).Lreactbuild_model_ListEntryEvent__f__id;
        var entry$macro$38 = $n(x0$7).Lreactbuild_model_ListEntryEvent__f_entry;
        var created$macro$39 = $n(x0$7).Lreactbuild_model_ListEntryEvent__f_created;
        var user$macro$40 = $n(x0$7).Lreactbuild_model_ListEntryEvent__f_user;
        var body$macro$41 = $n(x0$7).Lreactbuild_model_ListEntryEvent__f_body;
        return new $c_Lshapeless_$colon$colon(_id$macro$37, new $c_Lshapeless_$colon$colon(entry$macro$38, new $c_Lshapeless_$colon$colon(created$macro$39, new $c_Lshapeless_$colon$colon(user$macro$40, new $c_Lshapeless_$colon$colon(body$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$32 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var entry$macro$33 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var created$macro$34 = $as_Ljava_time_Instant($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var user$macro$35 = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var body$macro$36 = $as_Lreactbuild_model_ListEntryEventBody($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_model_ListEntryEvent(_id$macro$32, entry$macro$33, created$macro$34, user$macro$35, body$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "body"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "user"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "entry"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x7 = new $c_s_Some(($m_Lreactbuild_model_ListEntryEvent$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())));
    var $$x6 = $m_s_None$();
    $m_Lreactbuild_model_ListEntryEvent$();
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x5 = $m_Ljava_time_Instant$();
    var this$34 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$34.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$34.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var defaults = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon(new $c_s_Some($n($$x5).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$36 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "_id"));
    var this$37 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "entry"));
    var this$38 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "created"));
    var this$39 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "user"));
    var this$40 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "body")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "_id"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "created"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "_id"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "entry"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "created"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "user"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "body"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$71 = $m_s_$less$colon$less$();
    var ev$1 = this$71.s_$less$colon$less$__f_singleton;
    var this$72 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$72);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$76 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$76);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$80 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$88);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$92 = $m_s_$less$colon$less$();
    var ev$2 = this$92.s_$less$colon$less$__f_singleton;
    var this$93 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$93);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$97 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$97);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$101 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$109);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_inst$macro$1
}
function $p_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_inst$macro$42 = new $c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63($thiz);
    $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7() {
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_inst$macro$1 = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_inst$macro$42 = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7.prototype.constructor = $c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7.prototype = $c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7.prototype;
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_inst$macro$1)
});
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7__f_inst$macro$42)
});
var $d_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7: 0
}, false, "reactbuild.model.ListEntryEvent$anon$lazy$macro$43$7", {
  Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7.prototype.$classData = $d_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7;
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Approved"));
    var this$2 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "ChangeTitle"));
    var this$3 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Comment"));
    var this$4 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "Compliant"));
    var this$5 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "Done"));
    var this$6 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "Followed"));
    var this$7 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "Ignored"));
    var this$8 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "InStock"));
    var this$9 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "NeedMoreDetails"));
    var this$10 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "NonCompliant"));
    var this$11 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "NotApplicable"));
    var this$12 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "Ordered"));
    var this$13 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "Pending"));
    var this$14 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "Pickup"));
    var this$15 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "Read"));
    var this$16 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "Received"));
    var this$17 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "Rejected"));
    var this$18 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "Reset"));
    var this$19 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "Shipped"));
    var this$20 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "TermAdded"));
    var this$21 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "TermRemoved")), $m_Lshapeless_HNil$())))))))))))))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_ListEntryEventBody(p$2);
      var $$x22 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_model_ListEntryEventBody$Approved$())) {
        var $$x21 = 0
      } else if ((p instanceof $c_Lreactbuild_model_ListEntryEventBody$ChangeTitle)) {
        var $$x21 = 1
      } else if ((p instanceof $c_Lreactbuild_model_ListEntryEventBody$Comment)) {
        var $$x21 = 2
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Compliant$())) {
        var $$x21 = 3
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Done$())) {
        var $$x21 = 4
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Followed$())) {
        var $$x21 = 5
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Ignored$())) {
        var $$x21 = 6
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$InStock$())) {
        var $$x21 = 7
      } else if ((p instanceof $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails)) {
        var $$x21 = 8
      } else if ((p instanceof $c_Lreactbuild_model_ListEntryEventBody$NonCompliant)) {
        var $$x21 = 9
      } else if ((p instanceof $c_Lreactbuild_model_ListEntryEventBody$NotApplicable)) {
        var $$x21 = 10
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Ordered$())) {
        var $$x21 = 11
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Pending$())) {
        var $$x21 = 12
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Pickup$())) {
        var $$x21 = 13
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Read$())) {
        var $$x21 = 14
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Received$())) {
        var $$x21 = 15
      } else if ((p instanceof $c_Lreactbuild_model_ListEntryEventBody$Rejected)) {
        var $$x21 = 16
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Reset$())) {
        var $$x21 = 17
      } else if ((p === $m_Lreactbuild_model_ListEntryEventBody$Shipped$())) {
        var $$x21 = 18
      } else if ((p instanceof $c_Lreactbuild_model_ListEntryEventBody$TermAdded)) {
        var $$x21 = 19
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_ListEntryEventBody$TermRemoved))) {
          throw new $c_s_MatchError(p)
        };
        var $$x21 = 20
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x22).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x21, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_ListEntryEventBody($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "TermRemoved"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$28 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "TermAdded"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "Shipped"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "Reset"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "Rejected"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "Received"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "Read"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "Pickup"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "Pending"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$52 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "Ordered"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zipWithKeys$10 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "NotApplicable"));
    new $c_Lshapeless_Witness$$anon$1(value0$10);
    var zipWithKeys$11 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$10);
    $m_Lshapeless_Witness$();
    var this$58 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "NonCompliant"));
    new $c_Lshapeless_Witness$$anon$1(value0$11);
    var zipWithKeys$12 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$11);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "NeedMoreDetails"));
    new $c_Lshapeless_Witness$$anon$1(value0$12);
    var zipWithKeys$13 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$12);
    $m_Lshapeless_Witness$();
    var this$64 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "InStock"));
    new $c_Lshapeless_Witness$$anon$1(value0$13);
    var zipWithKeys$14 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$13);
    $m_Lshapeless_Witness$();
    var this$67 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "Ignored"));
    new $c_Lshapeless_Witness$$anon$1(value0$14);
    var zipWithKeys$15 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$14);
    $m_Lshapeless_Witness$();
    var this$70 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$70, "Followed"));
    new $c_Lshapeless_Witness$$anon$1(value0$15);
    var zipWithKeys$16 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$15);
    $m_Lshapeless_Witness$();
    var this$73 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "Done"));
    new $c_Lshapeless_Witness$$anon$1(value0$16);
    var zipWithKeys$17 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$16);
    $m_Lshapeless_Witness$();
    var this$76 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "Compliant"));
    new $c_Lshapeless_Witness$$anon$1(value0$17);
    var zipWithKeys$18 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$17);
    $m_Lshapeless_Witness$();
    var this$79 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$79, "Comment"));
    new $c_Lshapeless_Witness$$anon$1(value0$18);
    var zipWithKeys$19 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$18);
    $m_Lshapeless_Witness$();
    var this$82 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$82, "ChangeTitle"));
    new $c_Lshapeless_Witness$$anon$1(value0$19);
    var zipWithKeys$20 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$19);
    $m_Lshapeless_Witness$();
    var this$85 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "Approved"));
    new $c_Lshapeless_Witness$$anon$1(value0$20);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$20);
    var this$88 = $m_s_$less$colon$less$();
    var ev = this$88.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (1 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$1
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$2 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$2
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "term")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_ListEntryEventBody$TermRemoved(x0$7$2);
      if ((x0$7 !== null)) {
        var term$macro$11 = $n(x0$7).Lreactbuild_model_ListEntryEventBody$TermRemoved__f_term;
        return new $c_Lshapeless_$colon$colon(term$macro$11, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var term$macro$10 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$TermRemoved(term$macro$10)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "term"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "term")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "term"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (4 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$3
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (8 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$12 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (8 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$12
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (16 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "term")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_ListEntryEventBody$TermAdded(x0$15$2);
      if ((x0$15 !== null)) {
        var term$macro$21 = $n(x0$15).Lreactbuild_model_ListEntryEventBody$TermAdded__f_term;
        return new $c_Lshapeless_$colon$colon(term$macro$21, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var term$macro$20 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$16).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$TermAdded(term$macro$20)
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "term"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "term")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "term"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$13 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (16 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$13
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (32 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Shipped$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Shipped$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$22 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (32 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$22
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$23$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$23 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (64 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$23
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$24$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (128 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Reset$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Reset$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$24 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (128 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$24
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$25$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (256 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "reason")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_model_ListEntryEventBody$Rejected(x0$39$2);
      if ((x0$39 !== null)) {
        var reason$macro$33 = $n(x0$39).Lreactbuild_model_ListEntryEventBody$Rejected__f_reason;
        return new $c_Lshapeless_$colon$colon(reason$macro$33, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var reason$macro$32 = $as_T($n(x0$40).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$40).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$Rejected(reason$macro$32)
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "reason"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "reason")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "reason"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$25 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (256 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$25
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (512 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$34 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (512 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$34
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$35$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Received$(x0$47$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      $as_Lshapeless_HNil(x0$48$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Received$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$35 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (1024 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$35
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$36$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Read$(x0$55$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      $as_Lshapeless_HNil(x0$56$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Read$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$36 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (2048 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$36
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (4096 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Pickup$(x0$63$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      $as_Lshapeless_HNil(x0$64$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Pickup$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$37 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (4096 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$37
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (8192 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$71$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Pending$(x0$71$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$72$2) => {
      $as_Lshapeless_HNil(x0$72$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Pending$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$38 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (8192 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$38
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$39$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (16384 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$79$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Ordered$(x0$79$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$80$2) => {
      $as_Lshapeless_HNil(x0$80$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Ordered$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$39 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (16384 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$39
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$40$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (32768 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "reason")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$87$2) => {
      var x0$87 = $as_Lreactbuild_model_ListEntryEventBody$NotApplicable(x0$87$2);
      if ((x0$87 !== null)) {
        var reason$macro$48 = $n(x0$87).Lreactbuild_model_ListEntryEventBody$NotApplicable__f_reason;
        return new $c_Lshapeless_$colon$colon(reason$macro$48, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$87)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$88$2) => {
      var x0$88 = $as_Lshapeless_$colon$colon(x0$88$2);
      if ((x0$88 !== null)) {
        var reason$macro$47 = $as_T($n(x0$88).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$88).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$NotApplicable(reason$macro$47)
        }
      };
      throw new $c_s_MatchError(x0$88)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "reason"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "reason")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "reason"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$40 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (32768 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$40
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$49$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (65536 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "reason")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$95$2) => {
      var x0$95 = $as_Lreactbuild_model_ListEntryEventBody$NonCompliant(x0$95$2);
      if ((x0$95 !== null)) {
        var reason$macro$57 = $n(x0$95).Lreactbuild_model_ListEntryEventBody$NonCompliant__f_reason;
        return new $c_Lshapeless_$colon$colon(reason$macro$57, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$95)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$96$2) => {
      var x0$96 = $as_Lshapeless_$colon$colon(x0$96$2);
      if ((x0$96 !== null)) {
        var reason$macro$56 = $as_T($n(x0$96).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$96).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$NonCompliant(reason$macro$56)
        }
      };
      throw new $c_s_MatchError(x0$96)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "reason"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "reason")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "reason"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$49 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (65536 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$49
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (131072 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "comment")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$103$2) => {
      var x0$103 = $as_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(x0$103$2);
      if ((x0$103 !== null)) {
        var comment$macro$66 = $n(x0$103).Lreactbuild_model_ListEntryEventBody$NeedMoreDetails__f_comment;
        return new $c_Lshapeless_$colon$colon(comment$macro$66, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$103)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$104$2) => {
      var x0$104 = $as_Lshapeless_$colon$colon(x0$104$2);
      if ((x0$104 !== null)) {
        var comment$macro$65 = $as_T($n(x0$104).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$104).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(comment$macro$65)
        }
      };
      throw new $c_s_MatchError(x0$104)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "comment"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$67__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "comment")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "comment"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$58 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (131072 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$58
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$67$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (262144 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$67 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (262144 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$67
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$68$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (524288 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$111$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$InStock$(x0$111$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$112$2) => {
      $as_Lshapeless_HNil(x0$112$2);
      return $m_Lreactbuild_model_ListEntryEventBody$InStock$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$68 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (524288 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$68
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$69$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (1048576 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$119$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Ignored$(x0$119$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$120$2) => {
      $as_Lshapeless_HNil(x0$120$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Ignored$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$69 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (1048576 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$69
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$70$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (2097152 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$127$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Followed$(x0$127$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$128$2) => {
      $as_Lshapeless_HNil(x0$128$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Followed$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$70 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (2097152 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$70
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$71$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (4194304 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$135$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Done$(x0$135$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$136$2) => {
      $as_Lshapeless_HNil(x0$136$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Done$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$71 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (4194304 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$71
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$72$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (8388608 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$143$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Compliant$(x0$143$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$144$2) => {
      $as_Lshapeless_HNil(x0$144$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Compliant$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$72 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (8388608 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$72
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$73$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (16777216 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "comment")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$151$2) => {
      var x0$151 = $as_Lreactbuild_model_ListEntryEventBody$Comment(x0$151$2);
      if ((x0$151 !== null)) {
        var comment$macro$81 = $n(x0$151).Lreactbuild_model_ListEntryEventBody$Comment__f_comment;
        return new $c_Lshapeless_$colon$colon(comment$macro$81, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$151)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$152$2) => {
      var x0$152 = $as_Lshapeless_$colon$colon(x0$152$2);
      if ((x0$152 !== null)) {
        var comment$macro$80 = $as_T($n(x0$152).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$152).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$Comment(comment$macro$80)
        }
      };
      throw new $c_s_MatchError(x0$152)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "comment"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$67__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "comment")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "comment"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$73 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (16777216 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$73
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$82$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (33554432 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "previousTitle")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$159$2) => {
      var x0$159 = $as_Lreactbuild_model_ListEntryEventBody$ChangeTitle(x0$159$2);
      if ((x0$159 !== null)) {
        var previousTitle$macro$90 = $n(x0$159).Lreactbuild_model_ListEntryEventBody$ChangeTitle__f_previousTitle;
        return new $c_Lshapeless_$colon$colon(previousTitle$macro$90, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$159)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$160$2) => {
      var x0$160 = $as_Lshapeless_$colon$colon(x0$160$2);
      if ((x0$160 !== null)) {
        var previousTitle$macro$89 = $as_T($n(x0$160).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$160).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$ChangeTitle(previousTitle$macro$89)
        }
      };
      throw new $c_s_MatchError(x0$160)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "previousTitle"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$91__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "previousTitle")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "previousTitle"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$82 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (33554432 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$82
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$91$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (67108864 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$91 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (67108864 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$91
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$92$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (134217728 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$167$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Approved$(x0$167$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$168$2) => {
      $as_Lshapeless_HNil(x0$168$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Approved$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$92 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (134217728 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$92
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$93$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (268435456 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "term")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$175$2) => {
      var x0$175 = $as_Lreactbuild_model_ListEntryEventBody$TermRemoved(x0$175$2);
      if ((x0$175 !== null)) {
        var term$macro$101 = $n(x0$175).Lreactbuild_model_ListEntryEventBody$TermRemoved__f_term;
        return new $c_Lshapeless_$colon$colon(term$macro$101, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$175)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$176$2) => {
      var x0$176 = $as_Lshapeless_$colon$colon(x0$176$2);
      if ((x0$176 !== null)) {
        var term$macro$100 = $as_Lreactbuild_common_model_RefTo($n(x0$176).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$176).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$TermRemoved(term$macro$100)
        }
      };
      throw new $c_s_MatchError(x0$176)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "term"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$102__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "term"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$93 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (268435456 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$93
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$102$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (536870912 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$102 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (536870912 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$102
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$103$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (1073741824 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "term")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$183$2) => {
      var x0$183 = $as_Lreactbuild_model_ListEntryEventBody$TermAdded(x0$183$2);
      if ((x0$183 !== null)) {
        var term$macro$111 = $n(x0$183).Lreactbuild_model_ListEntryEventBody$TermAdded__f_term;
        return new $c_Lshapeless_$colon$colon(term$macro$111, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$183)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$184$2) => {
      var x0$184 = $as_Lshapeless_$colon$colon(x0$184$2);
      if ((x0$184 !== null)) {
        var term$macro$110 = $as_Lreactbuild_common_model_RefTo($n(x0$184).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$184).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$TermAdded(term$macro$110)
        }
      };
      throw new $c_s_MatchError(x0$184)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "term"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$102__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "term"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$103 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = (1073741824 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$103
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$112$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = ((-2147483648) & b.RTLong__f_lo);
  if ((lo === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$191$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Shipped$(x0$191$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$192$2) => {
      $as_Lshapeless_HNil(x0$192$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Shipped$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$112 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo$1 = ((-2147483648) | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$112
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$113$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (1 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$113 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (1 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$113
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$114$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (2 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$199$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Reset$(x0$199$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$200$2) => {
      $as_Lshapeless_HNil(x0$200$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Reset$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$114 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (2 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$114
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$115$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (4 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "reason")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$207$2) => {
      var x0$207 = $as_Lreactbuild_model_ListEntryEventBody$Rejected(x0$207$2);
      if ((x0$207 !== null)) {
        var reason$macro$123 = $n(x0$207).Lreactbuild_model_ListEntryEventBody$Rejected__f_reason;
        return new $c_Lshapeless_$colon$colon(reason$macro$123, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$207)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$208$2) => {
      var x0$208 = $as_Lshapeless_$colon$colon(x0$208$2);
      if ((x0$208 !== null)) {
        var reason$macro$122 = $as_T($n(x0$208).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$208).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$Rejected(reason$macro$122)
        }
      };
      throw new $c_s_MatchError(x0$208)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "reason"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$124__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "reason"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$115 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (4 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$115
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$124$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (8 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$124 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (8 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$124
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$125$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (16 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$215$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Received$(x0$215$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$216$2) => {
      $as_Lshapeless_HNil(x0$216$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Received$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$125 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (16 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$125
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$126$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (32 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$223$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Read$(x0$223$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$224$2) => {
      $as_Lshapeless_HNil(x0$224$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Read$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$126 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (32 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$126
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$127$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (64 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$231$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Pickup$(x0$231$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$232$2) => {
      $as_Lshapeless_HNil(x0$232$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Pickup$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$127 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (64 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$127
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$128$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (128 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$239$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Pending$(x0$239$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$240$2) => {
      $as_Lshapeless_HNil(x0$240$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Pending$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$128 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (128 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$128
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$129$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (256 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$247$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Ordered$(x0$247$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$248$2) => {
      $as_Lshapeless_HNil(x0$248$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Ordered$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$129 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (256 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$129
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$130$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (512 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "reason")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$255$2) => {
      var x0$255 = $as_Lreactbuild_model_ListEntryEventBody$NotApplicable(x0$255$2);
      if ((x0$255 !== null)) {
        var reason$macro$138 = $n(x0$255).Lreactbuild_model_ListEntryEventBody$NotApplicable__f_reason;
        return new $c_Lshapeless_$colon$colon(reason$macro$138, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$255)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$256$2) => {
      var x0$256 = $as_Lshapeless_$colon$colon(x0$256$2);
      if ((x0$256 !== null)) {
        var reason$macro$137 = $as_T($n(x0$256).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$256).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$NotApplicable(reason$macro$137)
        }
      };
      throw new $c_s_MatchError(x0$256)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "reason"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$124__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "reason"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$130 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (512 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$130
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$139$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (1024 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "reason")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$263$2) => {
      var x0$263 = $as_Lreactbuild_model_ListEntryEventBody$NonCompliant(x0$263$2);
      if ((x0$263 !== null)) {
        var reason$macro$147 = $n(x0$263).Lreactbuild_model_ListEntryEventBody$NonCompliant__f_reason;
        return new $c_Lshapeless_$colon$colon(reason$macro$147, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$263)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$264$2) => {
      var x0$264 = $as_Lshapeless_$colon$colon(x0$264$2);
      if ((x0$264 !== null)) {
        var reason$macro$146 = $as_T($n(x0$264).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$264).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$NonCompliant(reason$macro$146)
        }
      };
      throw new $c_s_MatchError(x0$264)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "reason"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$124__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "reason"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$139 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (1024 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$139
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$148$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (2048 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "comment")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$271$2) => {
      var x0$271 = $as_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(x0$271$2);
      if ((x0$271 !== null)) {
        var comment$macro$156 = $n(x0$271).Lreactbuild_model_ListEntryEventBody$NeedMoreDetails__f_comment;
        return new $c_Lshapeless_$colon$colon(comment$macro$156, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$271)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$272$2) => {
      var x0$272 = $as_Lshapeless_$colon$colon(x0$272$2);
      if ((x0$272 !== null)) {
        var comment$macro$155 = $as_T($n(x0$272).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$272).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(comment$macro$155)
        }
      };
      throw new $c_s_MatchError(x0$272)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "comment"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$157__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "comment"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$148 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (2048 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$148
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$157$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (4096 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$157 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (4096 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$157
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$158$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$279$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$InStock$(x0$279$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$280$2) => {
      $as_Lshapeless_HNil(x0$280$2);
      return $m_Lreactbuild_model_ListEntryEventBody$InStock$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$158 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (8192 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$158
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$159$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (16384 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$287$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Ignored$(x0$287$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$288$2) => {
      $as_Lshapeless_HNil(x0$288$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Ignored$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$159 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (16384 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$159
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$160$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (32768 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$295$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Followed$(x0$295$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$296$2) => {
      $as_Lshapeless_HNil(x0$296$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Followed$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$160 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (32768 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$160
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$161$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (65536 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$303$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Done$(x0$303$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$304$2) => {
      $as_Lshapeless_HNil(x0$304$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Done$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$161 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (65536 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$161
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$162$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (131072 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$311$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Compliant$(x0$311$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$312$2) => {
      $as_Lshapeless_HNil(x0$312$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Compliant$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$162 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (131072 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$162
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$163$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (262144 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "comment")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$319$2) => {
      var x0$319 = $as_Lreactbuild_model_ListEntryEventBody$Comment(x0$319$2);
      if ((x0$319 !== null)) {
        var comment$macro$171 = $n(x0$319).Lreactbuild_model_ListEntryEventBody$Comment__f_comment;
        return new $c_Lshapeless_$colon$colon(comment$macro$171, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$319)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$320$2) => {
      var x0$320 = $as_Lshapeless_$colon$colon(x0$320$2);
      if ((x0$320 !== null)) {
        var comment$macro$170 = $as_T($n(x0$320).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$320).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$Comment(comment$macro$170)
        }
      };
      throw new $c_s_MatchError(x0$320)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "comment"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$157__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "comment"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$163 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (262144 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$163
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$172$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (524288 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "previousTitle")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$327$2) => {
      var x0$327 = $as_Lreactbuild_model_ListEntryEventBody$ChangeTitle(x0$327$2);
      if ((x0$327 !== null)) {
        var previousTitle$macro$180 = $n(x0$327).Lreactbuild_model_ListEntryEventBody$ChangeTitle__f_previousTitle;
        return new $c_Lshapeless_$colon$colon(previousTitle$macro$180, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$327)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$328$2) => {
      var x0$328 = $as_Lshapeless_$colon$colon(x0$328$2);
      if ((x0$328 !== null)) {
        var previousTitle$macro$179 = $as_T($n(x0$328).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$328).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_ListEntryEventBody$ChangeTitle(previousTitle$macro$179)
        }
      };
      throw new $c_s_MatchError(x0$328)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "previousTitle"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$181__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "previousTitle"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$172 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (524288 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$172
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$181$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (1048576 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$181 = new $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73($thiz);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (1048576 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$181
}
function $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$182$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  var b = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (2097152 & b.RTLong__f_hi);
  if ((hi === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$335$2) => {
      $as_Lreactbuild_model_ListEntryEventBody$Approved$(x0$335$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$336$2) => {
      $as_Lshapeless_HNil(x0$336$2);
      return $m_Lreactbuild_model_ListEntryEventBody$Approved$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$182 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    var b$1 = $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (2097152 | b$1.RTLong__f_hi);
    $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$182
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1() {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$12 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$13 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$22 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$23 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$24 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$25 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$34 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$35 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$36 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$37 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$38 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$39 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$40 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$49 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$58 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$67 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$68 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$69 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$70 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$71 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$72 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$73 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$82 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$91 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$92 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$93 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$102 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$103 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$112 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$113 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$114 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$115 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$124 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$125 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$126 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$127 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$128 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$129 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$130 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$139 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$148 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$157 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$158 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$159 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$160 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$161 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$162 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$163 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$172 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$181 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$182 = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0 = $L0
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (1 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$1
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$2
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$3
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (8 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$12
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (16 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$13
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$22__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (32 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$22
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$23__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$23$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$23
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$24__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (128 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$24$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$24
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$25__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (256 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$25$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$25
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$34__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (512 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$34
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$35__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$35$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$35
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$36__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (2048 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$36$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$36
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$37__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (4096 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$37
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$38__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (8192 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$38
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$39__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (16384 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$39$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$39
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$40__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (32768 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$40$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$40
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$49__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (65536 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$49$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$49
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$58__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (131072 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$58
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$67__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (262144 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$67$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$67
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$68__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (524288 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$68$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$68
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$69__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (1048576 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$69$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$69
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$70__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (2097152 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$70$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$70
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$71__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (4194304 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$71$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$71
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$72__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (8388608 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$72$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$72
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$73__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (16777216 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$73$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$73
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$82__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (33554432 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$82$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$82
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$91__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (67108864 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$91$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$91
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$92__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (134217728 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$92$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$92
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$93__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (268435456 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$93$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$93
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$102__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (536870912 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$102$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$102
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$103__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = (1073741824 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$103$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$103
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$112__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var lo = ((-2147483648) & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$112$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$112
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$113__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (1 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$113$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$113
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$114__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (2 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$114$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$114
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$115__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (4 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$115$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$115
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$124__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (8 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$124$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$124
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$125__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (16 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$125$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$125
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$126__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (32 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$126$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$126
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$127__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (64 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$127$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$127
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$128__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (128 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$128$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$128
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$129__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (256 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$129$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$129
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$130__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (512 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$130$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$130
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$139__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (1024 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$139$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$139
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$148__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (2048 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$148$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$148
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$157__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (4096 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$157$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$157
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$158__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$158$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$158
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$159__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (16384 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$159$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$159
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$160__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (32768 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$160$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$160
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$161__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (65536 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$161$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$161
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$162__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (131072 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$162$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$162
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$163__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (262144 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$163$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$163
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$172__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (524288 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$172$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$172
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$181__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (1048576 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$181$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$181
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.inst$macro$182__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  var b = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_bitmap$0;
  var hi = (2097152 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__inst$macro$182$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this)
  } else {
    return this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1__f_inst$macro$182
  }
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1;
function $is_Lreactbuild_model_ListEntryEventCheck(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ListEntryEventCheck)))
}
function $as_Lreactbuild_model_ListEntryEventCheck(obj) {
  return (($is_Lreactbuild_model_ListEntryEventCheck(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventCheck"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventCheck(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventCheck)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventCheck(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventCheck(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventCheck;", depth))
}
function $is_Lreactbuild_model_ListEntryEventGuideline(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ListEntryEventGuideline)))
}
function $as_Lreactbuild_model_ListEntryEventGuideline(obj) {
  return (($is_Lreactbuild_model_ListEntryEventGuideline(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventGuideline"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventGuideline(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventGuideline)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventGuideline(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventGuideline(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventGuideline;", depth))
}
function $is_Lreactbuild_model_ListEntryEventIssue(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ListEntryEventIssue)))
}
function $as_Lreactbuild_model_ListEntryEventIssue(obj) {
  return (($is_Lreactbuild_model_ListEntryEventIssue(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventIssue"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventIssue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventIssue)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventIssue(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventIssue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventIssue;", depth))
}
function $is_Lreactbuild_model_ListEntryEventSupply(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ListEntryEventSupply)))
}
function $as_Lreactbuild_model_ListEntryEventSupply(obj) {
  return (($is_Lreactbuild_model_ListEntryEventSupply(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventSupply"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventSupply(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventSupply)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventSupply(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventSupply(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventSupply;", depth))
}
function $is_Lreactbuild_model_ListEntryEventTask(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_model_ListEntryEventTask)))
}
function $as_Lreactbuild_model_ListEntryEventTask(obj) {
  return (($is_Lreactbuild_model_ListEntryEventTask(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventTask"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventTask(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventTask)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventTask(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventTask(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventTask;", depth))
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "CheckList"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Guideline"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Issue"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "Supply"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "TaskList")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_ListEntryType(p$2);
      var $$x6 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_model_ListEntryType$CheckList$())) {
        var $$x5 = 0
      } else if ((p === $m_Lreactbuild_model_ListEntryType$Guideline$())) {
        var $$x5 = 1
      } else if ((p === $m_Lreactbuild_model_ListEntryType$Issue$())) {
        var $$x5 = 2
      } else if ((p === $m_Lreactbuild_model_ListEntryType$Supply$())) {
        var $$x5 = 3
      } else {
        if ((p !== $m_Lreactbuild_model_ListEntryType$TaskList$())) {
          throw new $c_s_MatchError(p)
        };
        var $$x5 = 4
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x6).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x5, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_ListEntryType($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "TaskList"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "Supply"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "Issue"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "Guideline"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "CheckList"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$1
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$2 = new $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61($thiz);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$2
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_model_ListEntryType$TaskList$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_model_ListEntryType$TaskList$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$3
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$4
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_model_ListEntryType$Supply$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_model_ListEntryType$Supply$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$5
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_model_ListEntryType$Issue$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_model_ListEntryType$Issue$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$6 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$6
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_model_ListEntryType$Guideline$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_model_ListEntryType$Guideline$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$7 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$7
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$8$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      $as_Lreactbuild_model_ListEntryType$CheckList$(x0$39$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      $as_Lshapeless_HNil(x0$40$2);
      return $m_Lreactbuild_model_ListEntryType$CheckList$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$8 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$8
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      $as_Lreactbuild_model_ListEntryType$TaskList$(x0$47$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      $as_Lshapeless_HNil(x0$48$2);
      return $m_Lreactbuild_model_ListEntryType$TaskList$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$9 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$9
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$10 = new $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62($thiz);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$10
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$11$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      $as_Lreactbuild_model_ListEntryType$Supply$(x0$55$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      $as_Lshapeless_HNil(x0$56$2);
      return $m_Lreactbuild_model_ListEntryType$Supply$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$11 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (1024 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$11
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$12$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      $as_Lreactbuild_model_ListEntryType$Issue$(x0$63$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      $as_Lshapeless_HNil(x0$64$2);
      return $m_Lreactbuild_model_ListEntryType$Issue$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$12 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (2048 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$12
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$13$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$71$2) => {
      $as_Lreactbuild_model_ListEntryType$Guideline$(x0$71$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$72$2) => {
      $as_Lshapeless_HNil(x0$72$2);
      return $m_Lreactbuild_model_ListEntryType$Guideline$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$13 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (4096 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$13
}
function $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$14$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$79$2) => {
      $as_Lreactbuild_model_ListEntryType$CheckList$(x0$79$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$80$2) => {
      $as_Lshapeless_HNil(x0$80$2);
      return $m_Lreactbuild_model_ListEntryType$CheckList$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$14 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = (8192 | $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$14
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2() {
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$1 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$2 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$3 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$4 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$5 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$6 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$7 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$8 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$9 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$10 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$11 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$12 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$13 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$14 = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.constructor = $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2;
/** @constructor */
function $h_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype = $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype;
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$1)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$2)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$3)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$4)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$5)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((32 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$6)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$7)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$8__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((128 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$8$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$8)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$9__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$9)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$10__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$10)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$11__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$11$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$11)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$12__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$12$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$12)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$13__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4096 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$13$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$13)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.inst$macro$14__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__inst$macro$14$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2__f_inst$macro$14)
});
var $d_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2: 0
}, false, "reactbuild.model.ListEntryType$anon$lazy$macro$15$2", {
  Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2.prototype.$classData = $d_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2;
function $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "MediaMandatory"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "NoValidation")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_ListEntryValidation(p$2);
      var $$x3 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_model_ListEntryValidation$MediaMandatory$())) {
        var $$x2 = 0
      } else {
        if ((p !== $m_Lreactbuild_model_ListEntryValidation$NoValidation$())) {
          throw new $c_s_MatchError(p)
        };
        var $$x2 = 1
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x3).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x2, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_ListEntryValidation($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "NoValidation"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "MediaMandatory"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$1
}
function $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$2 = new $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59($thiz);
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$2
}
function $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_model_ListEntryValidation$NoValidation$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_model_ListEntryValidation$NoValidation$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$3
}
function $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$4
}
function $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_model_ListEntryValidation$MediaMandatory$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_model_ListEntryValidation$MediaMandatory$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$5
}
function $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_model_ListEntryValidation$NoValidation$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_model_ListEntryValidation$NoValidation$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$7__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$6 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$6
}
function $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$7 = new $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60($thiz);
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$7
}
function $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((128 & $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_model_ListEntryValidation$MediaMandatory$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_model_ListEntryValidation$MediaMandatory$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$7__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$8 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0 = (((128 | $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$8
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1() {
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$4 = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$5 = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$6 = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$7 = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$8 = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.constructor = $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1;
/** @constructor */
function $h_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype = $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype;
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$1)
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$2)
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((4 & this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$3)
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((8 & this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$4)
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((16 & this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$5)
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.inst$macro$6__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((32 & this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$6)
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.inst$macro$7__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((64 & this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$7)
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((128 & this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1__f_inst$macro$8)
});
var $d_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1: 0
}, false, "reactbuild.model.ListEntryValidation$anon$lazy$macro$9$1", {
  Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1.prototype.$classData = $d_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1;
/** @constructor */
function $c_Lreactbuild_model_ListTemplate$() {
  this.Lreactbuild_model_ListTemplate$__f_codecForListTemplate = null;
  $n_Lreactbuild_model_ListTemplate$ = this;
  var inst$macro$28 = new $c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_ListTemplate$__f_codecForListTemplate = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_ListTemplate$.prototype = new $h_O();
$c_Lreactbuild_model_ListTemplate$.prototype.constructor = $c_Lreactbuild_model_ListTemplate$;
/** @constructor */
function $h_Lreactbuild_model_ListTemplate$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListTemplate$.prototype = $c_Lreactbuild_model_ListTemplate$.prototype;
var $d_Lreactbuild_model_ListTemplate$ = new $TypeData().initClass({
  Lreactbuild_model_ListTemplate$: 0
}, false, "reactbuild.model.ListTemplate$", {
  Lreactbuild_model_ListTemplate$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListTemplate$.prototype.$classData = $d_Lreactbuild_model_ListTemplate$;
var $n_Lreactbuild_model_ListTemplate$;
function $m_Lreactbuild_model_ListTemplate$() {
  if ((!$n_Lreactbuild_model_ListTemplate$)) {
    $n_Lreactbuild_model_ListTemplate$ = new $c_Lreactbuild_model_ListTemplate$()
  };
  return $n_Lreactbuild_model_ListTemplate$
}
function $p_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "title")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_ListTemplate(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$23 = $n(x0$7).Lreactbuild_model_ListTemplate__f__id;
        var organization$macro$24 = $n(x0$7).Lreactbuild_model_ListTemplate__f_organization;
        var title$macro$25 = $n(x0$7).Lreactbuild_model_ListTemplate__f_title;
        return new $c_Lshapeless_$colon$colon(_id$macro$23, new $c_Lshapeless_$colon$colon(organization$macro$24, new $c_Lshapeless_$colon$colon(title$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$20 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$21 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var title$macro$22 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_model_ListTemplate(_id$macro$20, organization$macro$21, title$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_ListTemplate$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$22 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "_id"));
    var this$23 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "organization"));
    var this$24 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "title")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "_id"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "_id"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "organization"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "title"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$44 = $m_s_$less$colon$less$();
    var ev$1 = this$44.s_$less$colon$less$__f_singleton;
    var this$45 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$45);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$49 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$49);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$53 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$53);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$57 = $m_s_$less$colon$less$();
    var ev$2 = this$57.s_$less$colon$less$__f_singleton;
    var this$58 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$66);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_inst$macro$1
}
function $p_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_inst$macro$26 = new $c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74($thiz);
    $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2() {
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_inst$macro$1 = null;
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_inst$macro$26 = null;
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2.prototype = new $h_O();
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2.prototype.constructor = $c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2;
/** @constructor */
function $h_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2.prototype = $c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2.prototype;
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_inst$macro$1)
});
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2__f_inst$macro$26)
});
var $d_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2 = new $TypeData().initClass({
  Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2: 0
}, false, "reactbuild.model.ListTemplate$anon$lazy$macro$27$2", {
  Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2.prototype.$classData = $d_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2;
/** @constructor */
function $c_Lreactbuild_model_ListTemplateEntry$() {
  this.Lreactbuild_model_ListTemplateEntry$__f_codecForListTemplateEntry = null;
  $n_Lreactbuild_model_ListTemplateEntry$ = this;
  var inst$macro$68 = new $c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$68));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_ListTemplateEntry$__f_codecForListTemplateEntry = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_ListTemplateEntry$.prototype = new $h_O();
$c_Lreactbuild_model_ListTemplateEntry$.prototype.constructor = $c_Lreactbuild_model_ListTemplateEntry$;
/** @constructor */
function $h_Lreactbuild_model_ListTemplateEntry$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListTemplateEntry$.prototype = $c_Lreactbuild_model_ListTemplateEntry$.prototype;
var $d_Lreactbuild_model_ListTemplateEntry$ = new $TypeData().initClass({
  Lreactbuild_model_ListTemplateEntry$: 0
}, false, "reactbuild.model.ListTemplateEntry$", {
  Lreactbuild_model_ListTemplateEntry$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListTemplateEntry$.prototype.$classData = $d_Lreactbuild_model_ListTemplateEntry$;
var $n_Lreactbuild_model_ListTemplateEntry$;
function $m_Lreactbuild_model_ListTemplateEntry$() {
  if ((!$n_Lreactbuild_model_ListTemplateEntry$)) {
    $n_Lreactbuild_model_ListTemplateEntry$ = new $c_Lreactbuild_model_ListTemplateEntry$()
  };
  return $n_Lreactbuild_model_ListTemplateEntry$
}
function $p_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "template"));
    var this$3 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "title"));
    var this$4 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "type"));
    var this$5 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "terms"));
    var this$6 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "created"));
    var this$7 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "validation"));
    var this$8 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "duration")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_ListTemplateEntry(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$58 = $n(x0$7).Lreactbuild_model_ListTemplateEntry__f__id;
        var template$macro$59 = $n(x0$7).Lreactbuild_model_ListTemplateEntry__f_template;
        var title$macro$60 = $n(x0$7).Lreactbuild_model_ListTemplateEntry__f_title;
        var type$macro$61 = $n(x0$7).Lreactbuild_model_ListTemplateEntry__f_type;
        var terms$macro$62 = $n(x0$7).Lreactbuild_model_ListTemplateEntry__f_terms;
        var created$macro$63 = $n(x0$7).Lreactbuild_model_ListTemplateEntry__f_created;
        var validation$macro$64 = $n(x0$7).Lreactbuild_model_ListTemplateEntry__f_validation;
        var duration$macro$65 = $n(x0$7).Lreactbuild_model_ListTemplateEntry__f_duration;
        return new $c_Lshapeless_$colon$colon(_id$macro$58, new $c_Lshapeless_$colon$colon(template$macro$59, new $c_Lshapeless_$colon$colon(title$macro$60, new $c_Lshapeless_$colon$colon(type$macro$61, new $c_Lshapeless_$colon$colon(terms$macro$62, new $c_Lshapeless_$colon$colon(created$macro$63, new $c_Lshapeless_$colon$colon(validation$macro$64, new $c_Lshapeless_$colon$colon(duration$macro$65, $m_Lshapeless_HNil$()))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$50 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var template$macro$51 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var title$macro$52 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var type$macro$53 = $as_Lreactbuild_model_ListEntryType($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var terms$macro$54 = $as_sci_ListSet($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var created$macro$55 = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var validation$macro$56 = $as_Lreactbuild_model_ListEntryValidation($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var duration$macro$57 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p9)) {
                        return new $c_Lreactbuild_model_ListTemplateEntry(_id$macro$50, template$macro$51, title$macro$52, type$macro$53, terms$macro$54, created$macro$55, validation$macro$56, duration$macro$57)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "duration"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "validation"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "terms"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "type"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "template"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    var this$36 = $m_s_$less$colon$less$();
    var ev = this$36.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$66__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x13 = new $c_s_Some(($m_Lreactbuild_model_ListTemplateEntry$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())));
    var $$x12 = $m_s_None$();
    var $$x11 = new $c_s_Some(($m_Lreactbuild_model_ListTemplateEntry$(), ""));
    var $$x10 = $m_s_None$();
    var $$x9 = new $c_s_Some(($m_Lreactbuild_model_ListTemplateEntry$(), $m_sci_ListSet$EmptyListSet$()));
    $m_Lreactbuild_model_ListTemplateEntry$();
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x8 = $m_Ljava_time_Instant$();
    var this$48 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$48.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$48.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var defaults = new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon(new $c_s_Some($n($$x8).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_ListTemplateEntry$(), $m_Lreactbuild_model_ListEntryValidation$NoValidation$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_ListTemplateEntry$(), $m_s_None$())), $m_Lshapeless_HNil$()))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$52 = $m_s_Symbol$();
    var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "_id"));
    var this$53 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "template"));
    var this$54 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "title"));
    var this$55 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "type"));
    var this$56 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "terms"));
    var this$57 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "created"));
    var this$58 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "validation"));
    var this$59 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "duration")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$71 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$71, "_id"));
    var wit$5 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$73 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "title"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$75 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$75, "terms"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$77 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$77, "created"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$79 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$79, "validation"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$81 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$81, "duration"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var rtmT$5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$5, wit$5);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$89 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$89, "_id"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$91 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$91, "template"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$93 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "title"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$95 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$95, "type"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$97 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$97, "terms"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lshapeless_Witness$();
    var this$99 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$99, "created"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$101 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$101, "validation"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lshapeless_Witness$();
    var this$103 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$103, "duration"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$21);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var this$114 = $m_s_$less$colon$less$();
    var ev$1 = this$114.s_$less$colon$less$__f_singleton;
    var this$115 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$115);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$119 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$119);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$123 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$123);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$127 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$127);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$131 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$131);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$135 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$135);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$139 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$139);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$143 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$143);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$147 = $m_s_$less$colon$less$();
    var ev$2 = this$147.s_$less$colon$less$__f_singleton;
    var this$148 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$148);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$8, ev$2);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$152 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$152);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$156 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$156);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$160 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$160);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$164 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$164);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$168 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$168);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$172 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$172);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$176 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$176);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_inst$macro$1
}
function $p_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__inst$macro$66$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_inst$macro$66 = new $c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75($thiz);
    $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_inst$macro$66
}
/** @constructor */
function $c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4() {
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_inst$macro$1 = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_inst$macro$66 = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4.prototype = new $h_O();
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4.prototype.constructor = $c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4;
/** @constructor */
function $h_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4.prototype = $c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4.prototype;
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_inst$macro$1)
});
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4.prototype.inst$macro$66__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__inst$macro$66$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4__f_inst$macro$66)
});
var $d_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4 = new $TypeData().initClass({
  Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4: 0
}, false, "reactbuild.model.ListTemplateEntry$anon$lazy$macro$67$4", {
  Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4.prototype.$classData = $d_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$11(outer) {
  /*<skip>*/
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$11.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$11.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$11;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$11.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$11.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$11.prototype.parse__T__s_concurrent_Future = (function(in$1) {
  return $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "Impossible de cr\u00e9er un autre groupe de fournisseur, vous devez choisir l'un de ceux propos\u00e9s."))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$11.prototype.stringify__O__s_concurrent_Future = (function(in$1) {
  var group = $as_Lreactbuild_person_SupplierGroup(in$1);
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n(group).Lreactbuild_person_SupplierGroup__f_title)
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$11 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$11: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$11", {
  Lreactbuild_model_LowPriorityImplicits$$anon$11: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$11.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$11;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$12(outer) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$12__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$12__f_itemFetcher = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$12__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$12__f_$outer = outer
  };
  $n($m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_Tokenizer);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_person_SupplierGroup(v$2);
    $m_Lreactbuild_person_SupplierGroup$();
    return $n(v).Lreactbuild_person_SupplierGroup__f_title
  }));
  var underlying = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  this.Lreactbuild_model_LowPriorityImplicits$$anon$12__f_itemTokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1(underlying, f);
  this.Lreactbuild_model_LowPriorityImplicits$$anon$12__f_itemFetcher = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$12;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$12.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$12.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12.prototype.keyOf__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$20$2) => {
    var x$20 = $as_Lreactbuild_person_SupplierGroup(x$20$2);
    return $n(x$20).toString__T()
  }))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12.prototype.handleNonexistent__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((in$2) => {
    $as_T(in$2);
    return $m_s_None$()
  }))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12.prototype.renderContainer__T__Z__Lcom_iz2use_react_components_internal_TextEditorContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(text, open, context) {
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  var focusHandler = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2();
  var fetcher = this.Lreactbuild_model_LowPriorityImplicits$$anon$12__f_itemFetcher;
  var fetcherBackend = $m_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$();
  var filter = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
  var keyOf = this.keyOf__F1();
  var equiv = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$12__f_$outer).Lreactbuild_model_Implicits$__f_supplierGroupOrdering;
  var handleNonexistent = this.handleNonexistent__F1();
  var tokenMatcher = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
  var tokenizer = this.Lreactbuild_model_LowPriorityImplicits$$anon$12__f_itemTokenizer;
  var h = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1();
  var highlighter = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3(h);
  var u = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder(text, open, context, focusHandler, fetcher, fetcherBackend, filter, keyOf, equiv, handleNonexistent, tokenMatcher, tokenizer, highlighter).apply__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction2(((i$2, v$2) => {
    $as_Lreactbuild_person_SupplierGroup(i$2);
    var v = $as_sci_Seq(v$2);
    return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), v)
  })));
  var this$10 = $n(u);
  var n = this$10.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$12 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$12: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$12", {
  Lreactbuild_model_LowPriorityImplicits$$anon$12: 1,
  O: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$12;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$14(outer) {
  /*<skip>*/
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$14.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$14.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$14;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$14() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$14.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$14.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$14.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagMod = (function(pages) {
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$3 = $n(pages);
  var f = new $c_sjsr_AnonFunction1(((x$22$2) => {
    var x$22 = $as_Lreactbuild_model_InvoicePage(x$22$2);
    return $n(x$22).Lreactbuild_model_InvoicePage__f_pageIndex
  }));
  var ord = $m_s_math_Ordering$Int$();
  var ord$1 = new $c_s_math_Ordering$O$1(ord);
  var as = $as_sc_IterableOnce($n($as_sc_IterableOps($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$3, f, ord$1))).map__F1__O(new $c_sjsr_AnonFunction1(((page$2) => {
    var page = $as_Lreactbuild_model_InvoicePage(page$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$4 = $n($n(page).Lreactbuild_model_InvoicePage__f_pageIndex);
    if (this$4.isEmpty__Z()) {
      var v$1 = "?"
    } else {
      var arg1 = this$4.get__O();
      var v = $uI(arg1);
      var v$1 = ("" + v)
    };
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)
  }))));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var sep = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(", ");
  var this$12 = $m_s_$less$colon$less$();
  var f$1 = this$12.s_$less$colon$less$__f_singleton;
  return $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$14.prototype.apply__O__Ljapgolly_scalajs_react_vdom_TagMod = (function(value) {
  return this.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagMod($as_sci_Seq(value))
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$14 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$14: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$14", {
  Lreactbuild_model_LowPriorityImplicits$$anon$14: 1,
  O: 1,
  Lcom_iz2use_react_components_Viewable: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$14.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$14;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$3(outer) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$3__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$3__f_$outer = outer
  }
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$3.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$3.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$3;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$3.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$3.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$3.prototype.stringify__Lreactbuild_model_DocumentCategory__s_concurrent_Future = (function(category) {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$3__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryMap).apply__O__O(category))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$3.prototype.parse__T__s_concurrent_Future = (function(in$1) {
  var this$1 = $n(in$1);
  var x1 = $as_T(this$1.toUpperCase());
  switch (x1) {
    case "F": {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lreactbuild_model_DocumentCategory$Invoice$());
      break
    }
    case "B":
    case "L":
    case "BL": {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lreactbuild_model_DocumentCategory$DeliveryForm$());
      break
    }
    case "D": {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lreactbuild_model_DocumentCategory$Quote$());
      break
    }
    case "C": {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lreactbuild_model_DocumentCategory$Order$());
      break
    }
    case "O": {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lreactbuild_model_DocumentCategory$PriceOffer$());
      break
    }
    case "A": {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lreactbuild_model_DocumentCategory$Certificate$());
      break
    }
    case "R": {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lreactbuild_model_DocumentCategory$Statement$());
      break
    }
    default: {
      return $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "Impossible de cr\u00e9er une autre cat\u00e9gorie de document, vous devez choisir l'une de celles propos\u00e9es."))
    }
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$3.prototype.stringify__O__s_concurrent_Future = (function(in$1) {
  return this.stringify__Lreactbuild_model_DocumentCategory__s_concurrent_Future($as_Lreactbuild_model_DocumentCategory(in$1))
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$3 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$3: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$3", {
  Lreactbuild_model_LowPriorityImplicits$$anon$3: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$3.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$3;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$4(outer) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_itemFetcher = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_$outer = outer
  };
  $n($m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_Tokenizer);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_model_DocumentCategory(v$2);
    return $as_T($n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryMap).apply__O__O(v))
  }));
  var underlying = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_itemTokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1(underlying, f);
  this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_itemFetcher = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$4;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$4.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$4.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4.prototype.keyOf__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Lreactbuild_model_DocumentCategory(x$7$2);
    return $n(x$7).toString__T()
  }))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4.prototype.handleNonexistent__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((in$2) => {
    $as_T(in$2);
    return $m_s_None$()
  }))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4.prototype.renderContainer__T__Z__Lcom_iz2use_react_components_internal_TextEditorContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(text, open, context) {
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  var focusHandler = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2();
  var fetcher = this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_itemFetcher;
  var fetcherBackend = $m_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$();
  var filter = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
  var keyOf = this.keyOf__F1();
  var equiv = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_$outer).Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
  var handleNonexistent = this.handleNonexistent__F1();
  var tokenMatcher = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
  var tokenizer = this.Lreactbuild_model_LowPriorityImplicits$$anon$4__f_itemTokenizer;
  var h = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1();
  var highlighter = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3(h);
  var u = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder(text, open, context, focusHandler, fetcher, fetcherBackend, filter, keyOf, equiv, handleNonexistent, tokenMatcher, tokenizer, highlighter).apply__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction2(((i$2, v$2) => {
    $as_Lreactbuild_model_DocumentCategory(i$2);
    var v = $as_sci_Seq(v$2);
    return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), v)
  })));
  var this$10 = $n(u);
  var n = this$10.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$4 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$4: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$4", {
  Lreactbuild_model_LowPriorityImplicits$$anon$4: 1,
  O: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$4;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$6(outer) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$6__f_empty = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$6__f_empty = $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$()
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$6.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$6.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$6;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$6.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$6.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$6.prototype.empty__O = (function() {
  return this.Lreactbuild_model_LowPriorityImplicits$$anon$6__f_empty
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$6 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$6: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$6", {
  Lreactbuild_model_LowPriorityImplicits$$anon$6: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_Default: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$6.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$6;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$8(outer) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$8__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$8__f_$outer = outer
  }
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$8.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$8.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$8;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$8.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$8.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$8.prototype.stringify__Lreactbuild_analyze_cost_ReconciliationReportOrder__s_concurrent_Future = (function(order) {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$8__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderMap).apply__O__O(order))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$8.prototype.parse__T__s_concurrent_Future = (function(in$1) {
  return $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "Impossible cr\u00e9er un autre ordre de tri, choisissez l'une des propositions"))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$8.prototype.stringify__O__s_concurrent_Future = (function(in$1) {
  return this.stringify__Lreactbuild_analyze_cost_ReconciliationReportOrder__s_concurrent_Future($as_Lreactbuild_analyze_cost_ReconciliationReportOrder(in$1))
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$8 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$8: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$8", {
  Lreactbuild_model_LowPriorityImplicits$$anon$8: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$8.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$8;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$9(outer) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$9__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$9__f_itemFetcher = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$9__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$9__f_$outer = outer
  };
  $n($m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_Tokenizer);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder(v$2);
    return $as_T($n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$9__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderMap).apply__O__O(v))
  }));
  var underlying = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  this.Lreactbuild_model_LowPriorityImplicits$$anon$9__f_itemTokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1(underlying, f);
  this.Lreactbuild_model_LowPriorityImplicits$$anon$9__f_itemFetcher = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$9;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$9.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$9.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9.prototype.keyOf__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder(x$8$2);
    return $n(x$8).toString__T()
  }))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9.prototype.handleNonExistent__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((in$2) => {
    $as_T(in$2);
    return $m_s_None$()
  }))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9.prototype.renderContainer__T__Z__Lcom_iz2use_react_components_internal_TextEditorContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(text, open, context) {
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  var focusHandler = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2();
  var fetcher = this.Lreactbuild_model_LowPriorityImplicits$$anon$9__f_itemFetcher;
  var fetcherBackend = $m_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$();
  var filter = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
  var keyOf = this.keyOf__F1();
  var this$3 = $m_s_math_Equiv$();
  var equiv = this$3.universal__s_math_Equiv();
  var handleNonexistent = this.handleNonExistent__F1();
  var tokenMatcher = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
  var tokenizer = this.Lreactbuild_model_LowPriorityImplicits$$anon$9__f_itemTokenizer;
  var h = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1();
  var highlighter = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3(h);
  var u = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder(text, open, context, focusHandler, fetcher, fetcherBackend, filter, keyOf, equiv, handleNonexistent, tokenMatcher, tokenizer, highlighter).apply__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction2(((i$2, v$2) => {
    $as_Lreactbuild_analyze_cost_ReconciliationReportOrder(i$2);
    var v = $as_sci_Seq(v$2);
    return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), v)
  })));
  var this$11 = $n(u);
  var n = this$11.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$9 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$9: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$9", {
  Lreactbuild_model_LowPriorityImplicits$$anon$9: 1,
  O: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$9;
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Document"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Image"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Measure")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_MapFeature$MapFeature(p$2);
      var $$x4 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_model_MapFeature$Document)) {
        var $$x3 = 0
      } else if ((p instanceof $c_Lreactbuild_model_MapFeature$Image)) {
        var $$x3 = 1
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_MapFeature$Measure))) {
          throw new $c_s_MatchError(p)
        };
        var $$x3 = 2
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x4).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x3, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_MapFeature$MapFeature($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "Measure"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "Image"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "Document"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_MapFeature$().Lreactbuild_model_MapFeature$__f_config;
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$1
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$2 = new $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1($thiz);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$2
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var $$x15 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "level"));
    var this$3 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "altitude"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "label")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_MapFeature$Measure(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$32 = $n(x0$7).Lreactbuild_model_MapFeature$Measure__f__id;
        var level$macro$33 = $n(x0$7).Lreactbuild_model_MapFeature$Measure__f_level;
        var altitude$macro$34 = $n(x0$7).Lreactbuild_model_MapFeature$Measure__f_altitude;
        var label$macro$35 = $n(x0$7).Lreactbuild_model_MapFeature$Measure__f_label;
        return new $c_Lshapeless_$colon$colon(_id$macro$32, new $c_Lshapeless_$colon$colon(level$macro$33, new $c_Lshapeless_$colon$colon(altitude$macro$34, new $c_Lshapeless_$colon$colon(label$macro$35, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$28 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var level$macro$29 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var altitude$macro$30 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var label$macro$31 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_MapFeature$Measure(_id$macro$28, level$macro$29, altitude$macro$30, label$macro$31)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "label"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "altitude"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "level"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var $$x14 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$36__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x10 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$27 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "_id"));
    var this$28 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "level"));
    var this$29 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "altitude"));
    var this$30 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "label")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var $$x9 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "level"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "altitude"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "label"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var $$x4 = $m_Lreactbuild_model_MapFeature$().Lreactbuild_model_MapFeature$__f_config;
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "level"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "altitude"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "label"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$10);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$60 = $m_s_$less$colon$less$();
    var ev$1 = this$60.s_$less$colon$less$__f_singleton;
    var this$61 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$61);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$65 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$73);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$77 = $m_s_$less$colon$less$();
    var ev$2 = this$77.s_$less$colon$less$__f_singleton;
    var this$78 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$82);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$86 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$86);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$90 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$90);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$3 = $n($$x15).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x14, $$x10, $$x9, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5));
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$3
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$36$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$36 = new $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2($thiz);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$36
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var $$x21 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "project"));
    var this$3 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "orientation"));
    var this$4 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "level"));
    var this$5 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "file"));
    var this$6 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "metadata"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "markers")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_MapFeature$Image(x0$15$2);
      if ((x0$15 !== null)) {
        var _id$macro$87 = $n(x0$15).Lreactbuild_model_MapFeature$Image__f__id;
        var project$macro$88 = $n(x0$15).Lreactbuild_model_MapFeature$Image__f_project;
        var orientation$macro$89 = $n(x0$15).Lreactbuild_model_MapFeature$Image__f_orientation;
        var level$macro$90 = $n(x0$15).Lreactbuild_model_MapFeature$Image__f_level;
        var file$macro$91 = $n(x0$15).Lreactbuild_model_MapFeature$Image__f_file;
        var metadata$macro$92 = $n(x0$15).Lreactbuild_model_MapFeature$Image__f_metadata;
        var markers$macro$93 = $n(x0$15).Lreactbuild_model_MapFeature$Image__f_markers;
        return new $c_Lshapeless_$colon$colon(_id$macro$87, new $c_Lshapeless_$colon$colon(project$macro$88, new $c_Lshapeless_$colon$colon(orientation$macro$89, new $c_Lshapeless_$colon$colon(level$macro$90, new $c_Lshapeless_$colon$colon(file$macro$91, new $c_Lshapeless_$colon$colon(metadata$macro$92, new $c_Lshapeless_$colon$colon(markers$macro$93, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var _id$macro$80 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var project$macro$81 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var orientation$macro$82 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var level$macro$83 = $uI($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var file$macro$84 = $as_Lreactbuild_common_model_RefTo($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var metadata$macro$85 = $as_sci_Map($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var markers$macro$86 = $as_sci_List($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_model_MapFeature$Image(_id$macro$80, project$macro$81, orientation$macro$82, level$macro$83, file$macro$84, metadata$macro$85, markers$macro$86)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "markers"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "metadata"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "file"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "level"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "orientation"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var $$x20 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$94__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x13 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$36 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "_id"));
    var this$37 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "project"));
    var this$38 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "orientation"));
    var this$39 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "level"));
    var this$40 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "file"));
    var this$41 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "metadata"));
    var this$42 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "markers")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var $$x12 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_MapFeature$().Lreactbuild_model_MapFeature$__f_config;
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "_id"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "project"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "orientation"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "level"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "file"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "metadata"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "markers"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$75 = $m_s_$less$colon$less$();
    var ev$1 = this$75.s_$less$colon$less$__f_singleton;
    var this$76 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$76);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$80 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$88);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$92 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$92);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$96 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$96);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$100 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$100);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$104 = $m_s_$less$colon$less$();
    var ev$2 = this$104.s_$less$colon$less$__f_singleton;
    var this$105 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$113);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$117 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$117);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$121 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$121);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$125 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$125);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$129 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$129);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$37 = $n($$x21).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x20, $$x13, $$x12, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11));
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$37
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$94$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$94 = new $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3($thiz);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$94
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$95$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "file")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_model_MapFeature$Document(x0$23$2);
      if ((x0$23 !== null)) {
        var _id$macro$110 = $n(x0$23).Lreactbuild_model_MapFeature$Document__f__id;
        var file$macro$111 = $n(x0$23).Lreactbuild_model_MapFeature$Document__f_file;
        return new $c_Lshapeless_$colon$colon(_id$macro$110, new $c_Lshapeless_$colon$colon(file$macro$111, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var _id$macro$108 = $as_Lreactbuild_common_model_RefTo($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var file$macro$109 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_MapFeature$Document(_id$macro$108, file$macro$109)
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "file"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$112__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "_id"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "file")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_MapFeature$().Lreactbuild_model_MapFeature$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "_id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "file"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$95 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$95
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$112$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$112 = new $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4($thiz);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$112
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$113$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "level"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "altitude"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "label")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_model_MapFeature$Measure(x0$31$2);
      if ((x0$31 !== null)) {
        var _id$macro$142 = $n(x0$31).Lreactbuild_model_MapFeature$Measure__f__id;
        var level$macro$143 = $n(x0$31).Lreactbuild_model_MapFeature$Measure__f_level;
        var altitude$macro$144 = $n(x0$31).Lreactbuild_model_MapFeature$Measure__f_altitude;
        var label$macro$145 = $n(x0$31).Lreactbuild_model_MapFeature$Measure__f_label;
        return new $c_Lshapeless_$colon$colon(_id$macro$142, new $c_Lshapeless_$colon$colon(level$macro$143, new $c_Lshapeless_$colon$colon(altitude$macro$144, new $c_Lshapeless_$colon$colon(label$macro$145, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var _id$macro$138 = $as_Lreactbuild_common_model_RefTo($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$32).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var level$macro$139 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var altitude$macro$140 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var label$macro$141 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_MapFeature$Measure(_id$macro$138, level$macro$139, altitude$macro$140, label$macro$141)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "label"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "altitude"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "level"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$146__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_MapFeature$().Lreactbuild_model_MapFeature$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "level"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "altitude"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "label"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$36 = $m_s_$less$colon$less$();
    var ev$1 = this$36.s_$less$colon$less$__f_singleton;
    var this$37 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$37);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$41 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$41);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$45 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$45);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$49 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$49);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$53 = $m_s_$less$colon$less$();
    var ev$2 = this$53.s_$less$colon$less$__f_singleton;
    var this$54 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$54);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$58 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$66);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$113 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$113
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$146$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$146 = new $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5($thiz);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$146
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$147$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "project"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "orientation"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "level"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "file"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "metadata"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "markers")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_model_MapFeature$Image(x0$39$2);
      if ((x0$39 !== null)) {
        var _id$macro$197 = $n(x0$39).Lreactbuild_model_MapFeature$Image__f__id;
        var project$macro$198 = $n(x0$39).Lreactbuild_model_MapFeature$Image__f_project;
        var orientation$macro$199 = $n(x0$39).Lreactbuild_model_MapFeature$Image__f_orientation;
        var level$macro$200 = $n(x0$39).Lreactbuild_model_MapFeature$Image__f_level;
        var file$macro$201 = $n(x0$39).Lreactbuild_model_MapFeature$Image__f_file;
        var metadata$macro$202 = $n(x0$39).Lreactbuild_model_MapFeature$Image__f_metadata;
        var markers$macro$203 = $n(x0$39).Lreactbuild_model_MapFeature$Image__f_markers;
        return new $c_Lshapeless_$colon$colon(_id$macro$197, new $c_Lshapeless_$colon$colon(project$macro$198, new $c_Lshapeless_$colon$colon(orientation$macro$199, new $c_Lshapeless_$colon$colon(level$macro$200, new $c_Lshapeless_$colon$colon(file$macro$201, new $c_Lshapeless_$colon$colon(metadata$macro$202, new $c_Lshapeless_$colon$colon(markers$macro$203, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var _id$macro$190 = $as_Lreactbuild_common_model_RefTo($n(x0$40).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$40).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var project$macro$191 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var orientation$macro$192 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var level$macro$193 = $uI($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var file$macro$194 = $as_Lreactbuild_common_model_RefTo($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var metadata$macro$195 = $as_sci_Map($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var markers$macro$196 = $as_sci_List($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_model_MapFeature$Image(_id$macro$190, project$macro$191, orientation$macro$192, level$macro$193, file$macro$194, metadata$macro$195, markers$macro$196)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "markers"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "metadata"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "file"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "level"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "orientation"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$204__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_MapFeature$().Lreactbuild_model_MapFeature$__f_config;
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "_id"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "project"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "orientation"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "level"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "file"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "metadata"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "markers"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$57 = $m_s_$less$colon$less$();
    var ev$1 = this$57.s_$less$colon$less$__f_singleton;
    var this$58 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$82);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$86 = $m_s_$less$colon$less$();
    var ev$2 = this$86.s_$less$colon$less$__f_singleton;
    var this$87 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$91);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$95 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$95);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$99 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$99);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$103 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$103);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$107 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$107);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$111 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$111);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$147 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$147
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$204$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$204 = new $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6($thiz);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$204
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$205$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "file")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_model_MapFeature$Document(x0$47$2);
      if ((x0$47 !== null)) {
        var _id$macro$220 = $n(x0$47).Lreactbuild_model_MapFeature$Document__f__id;
        var file$macro$221 = $n(x0$47).Lreactbuild_model_MapFeature$Document__f_file;
        return new $c_Lshapeless_$colon$colon(_id$macro$220, new $c_Lshapeless_$colon$colon(file$macro$221, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_$colon$colon(x0$48$2);
      if ((x0$48 !== null)) {
        var _id$macro$218 = $as_Lreactbuild_common_model_RefTo($n(x0$48).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$48).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var file$macro$219 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_MapFeature$Document(_id$macro$218, file$macro$219)
          }
        }
      };
      throw new $c_s_MatchError(x0$48)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "file"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$222__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_MapFeature$().Lreactbuild_model_MapFeature$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "_id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "file"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$205 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$205
}
function $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$222$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$222 = new $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7($thiz);
    $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$222
}
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1() {
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$36 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$37 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$94 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$95 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$112 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$113 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$146 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$147 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$204 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$205 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$222 = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype;
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$1)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$2)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$3)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$36__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$36$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$36)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$37__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$37)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$94__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$94$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$94)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$95__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$95$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$95)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$112__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((128 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$112$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$112)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$113__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$113$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$113)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$146__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$146$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$146)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$147__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$147$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$147)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$204__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$204$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$204)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$205__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4096 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$205$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$205)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.inst$macro$222__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__inst$macro$222$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1__f_inst$macro$222)
});
var $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1 = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1: 0
}, false, "reactbuild.model.MapFeature$MapFeature$anon$lazy$macro$223$1", {
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeatureMarker$() {
  this.Lreactbuild_model_MapFeature$MapFeatureMarker$__f_codecForMapFeatureMarker = null;
  $n_Lreactbuild_model_MapFeature$MapFeatureMarker$ = this;
  var inst$macro$4 = new $c_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$4));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_MapFeature$MapFeatureMarker$__f_codecForMapFeatureMarker = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_MapFeature$MapFeatureMarker$.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$MapFeatureMarker$.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeatureMarker$;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeatureMarker$() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeatureMarker$.prototype = $c_Lreactbuild_model_MapFeature$MapFeatureMarker$.prototype;
var $d_Lreactbuild_model_MapFeature$MapFeatureMarker$ = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeatureMarker$: 0
}, false, "reactbuild.model.MapFeature$MapFeatureMarker$", {
  Lreactbuild_model_MapFeature$MapFeatureMarker$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker$.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeatureMarker$;
var $n_Lreactbuild_model_MapFeature$MapFeatureMarker$;
function $m_Lreactbuild_model_MapFeature$MapFeatureMarker$() {
  if ((!$n_Lreactbuild_model_MapFeature$MapFeatureMarker$)) {
    $n_Lreactbuild_model_MapFeature$MapFeatureMarker$ = new $c_Lreactbuild_model_MapFeature$MapFeatureMarker$()
  };
  return $n_Lreactbuild_model_MapFeature$MapFeatureMarker$
}
function $p_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_MapFeature$MapFeatureMarker(x0$7$2);
      if ((x0$7 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_HNil(x0$8$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$8)) {
        return new $c_Lreactbuild_model_MapFeature$MapFeatureMarker()
      } else {
        throw new $c_s_MatchError(x0$8)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_MapFeature$().Lreactbuild_model_MapFeature$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_inst$macro$1
}
function $p_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_inst$macro$2 = $m_Lio_circe_generic_extras_codec_ReprAsObjectCodec$().Lio_circe_generic_extras_codec_ReprAsObjectCodec$__f_hnilReprCodec;
    $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_inst$macro$2
}
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1() {
  this.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1.prototype = $c_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1.prototype;
$c_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_inst$macro$1)
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1__f_inst$macro$2)
});
var $d_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1 = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1: 0
}, false, "reactbuild.model.MapFeature$MapFeatureMarker$anon$lazy$macro$3$1", {
  Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeatureMarker$anon$lazy$macro$3$1;
/** @constructor */
function $c_Lreactbuild_model_PdfContent$() {
  this.Lreactbuild_model_PdfContent$__f_codecForPdfContent = null;
  $n_Lreactbuild_model_PdfContent$ = this;
  var inst$macro$12 = new $c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_PdfContent$__f_codecForPdfContent = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_PdfContent$.prototype = new $h_O();
$c_Lreactbuild_model_PdfContent$.prototype.constructor = $c_Lreactbuild_model_PdfContent$;
/** @constructor */
function $h_Lreactbuild_model_PdfContent$() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfContent$.prototype = $c_Lreactbuild_model_PdfContent$.prototype;
var $d_Lreactbuild_model_PdfContent$ = new $TypeData().initClass({
  Lreactbuild_model_PdfContent$: 0
}, false, "reactbuild.model.PdfContent$", {
  Lreactbuild_model_PdfContent$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfContent$.prototype.$classData = $d_Lreactbuild_model_PdfContent$;
var $n_Lreactbuild_model_PdfContent$;
function $m_Lreactbuild_model_PdfContent$() {
  if ((!$n_Lreactbuild_model_PdfContent$)) {
    $n_Lreactbuild_model_PdfContent$ = new $c_Lreactbuild_model_PdfContent$()
  };
  return $n_Lreactbuild_model_PdfContent$
}
function $p_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "pages")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_PdfContent(x0$7$2);
      if ((x0$7 !== null)) {
        var pages$macro$9 = $n(x0$7).Lreactbuild_model_PdfContent__f_pages;
        return new $c_Lshapeless_$colon$colon(pages$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var pages$macro$8 = $as_sci_List($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_PdfContent(pages$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "pages"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "pages")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "pages"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_inst$macro$1
}
function $p_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_inst$macro$10 = new $c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42($thiz);
    $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4() {
  this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_inst$macro$1 = null;
  this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_inst$macro$10 = null;
  this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_bitmap$0 = 0
}
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4.prototype = new $h_O();
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4.prototype.constructor = $c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4;
/** @constructor */
function $h_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4.prototype = $c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4.prototype;
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_inst$macro$1)
});
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4__f_inst$macro$10)
});
var $d_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4 = new $TypeData().initClass({
  Lreactbuild_model_PdfContent$anon$lazy$macro$11$4: 0
}, false, "reactbuild.model.PdfContent$anon$lazy$macro$11$4", {
  Lreactbuild_model_PdfContent$anon$lazy$macro$11$4: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4.prototype.$classData = $d_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4;
/** @constructor */
function $c_Lreactbuild_model_PdfLine$() {
  this.Lreactbuild_model_PdfLine$__f_codecForPdfLine = null;
  $n_Lreactbuild_model_PdfLine$ = this;
  var inst$macro$12 = new $c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_PdfLine$__f_codecForPdfLine = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_PdfLine$.prototype = new $h_O();
$c_Lreactbuild_model_PdfLine$.prototype.constructor = $c_Lreactbuild_model_PdfLine$;
/** @constructor */
function $h_Lreactbuild_model_PdfLine$() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfLine$.prototype = $c_Lreactbuild_model_PdfLine$.prototype;
var $d_Lreactbuild_model_PdfLine$ = new $TypeData().initClass({
  Lreactbuild_model_PdfLine$: 0
}, false, "reactbuild.model.PdfLine$", {
  Lreactbuild_model_PdfLine$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfLine$.prototype.$classData = $d_Lreactbuild_model_PdfLine$;
var $n_Lreactbuild_model_PdfLine$;
function $m_Lreactbuild_model_PdfLine$() {
  if ((!$n_Lreactbuild_model_PdfLine$)) {
    $n_Lreactbuild_model_PdfLine$ = new $c_Lreactbuild_model_PdfLine$()
  };
  return $n_Lreactbuild_model_PdfLine$
}
function $p_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "words")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_PdfLine(x0$7$2);
      if ((x0$7 !== null)) {
        var words$macro$9 = $n(x0$7).Lreactbuild_model_PdfLine__f_words;
        return new $c_Lshapeless_$colon$colon(words$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var words$macro$8 = $as_sci_List($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_PdfLine(words$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "words"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "words")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "words"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_inst$macro$1
}
function $p_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_inst$macro$10 = new $c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45($thiz);
    $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6() {
  this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_inst$macro$1 = null;
  this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_inst$macro$10 = null;
  this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_bitmap$0 = 0
}
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6.prototype = new $h_O();
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6.prototype.constructor = $c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6;
/** @constructor */
function $h_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6.prototype = $c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6.prototype;
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_inst$macro$1)
});
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6__f_inst$macro$10)
});
var $d_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6 = new $TypeData().initClass({
  Lreactbuild_model_PdfLine$anon$lazy$macro$11$6: 0
}, false, "reactbuild.model.PdfLine$anon$lazy$macro$11$6", {
  Lreactbuild_model_PdfLine$anon$lazy$macro$11$6: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6.prototype.$classData = $d_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6;
/** @constructor */
function $c_Lreactbuild_model_PdfPage$() {
  this.Lreactbuild_model_PdfPage$__f_codecForPdfPage = null;
  $n_Lreactbuild_model_PdfPage$ = this;
  var inst$macro$28 = new $c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_PdfPage$__f_codecForPdfPage = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_PdfPage$.prototype = new $h_O();
$c_Lreactbuild_model_PdfPage$.prototype.constructor = $c_Lreactbuild_model_PdfPage$;
/** @constructor */
function $h_Lreactbuild_model_PdfPage$() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfPage$.prototype = $c_Lreactbuild_model_PdfPage$.prototype;
var $d_Lreactbuild_model_PdfPage$ = new $TypeData().initClass({
  Lreactbuild_model_PdfPage$: 0
}, false, "reactbuild.model.PdfPage$", {
  Lreactbuild_model_PdfPage$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfPage$.prototype.$classData = $d_Lreactbuild_model_PdfPage$;
var $n_Lreactbuild_model_PdfPage$;
function $m_Lreactbuild_model_PdfPage$() {
  if ((!$n_Lreactbuild_model_PdfPage$)) {
    $n_Lreactbuild_model_PdfPage$ = new $c_Lreactbuild_model_PdfPage$()
  };
  return $n_Lreactbuild_model_PdfPage$
}
function $p_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "paragraphs"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "width"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "height")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_PdfPage(x0$7$2);
      if ((x0$7 !== null)) {
        var paragraphs$macro$23 = $n(x0$7).Lreactbuild_model_PdfPage__f_paragraphs;
        var width$macro$24 = $n(x0$7).Lreactbuild_model_PdfPage__f_width;
        var height$macro$25 = $n(x0$7).Lreactbuild_model_PdfPage__f_height;
        return new $c_Lshapeless_$colon$colon(paragraphs$macro$23, new $c_Lshapeless_$colon$colon(width$macro$24, new $c_Lshapeless_$colon$colon(height$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var paragraphs$macro$20 = $as_sci_List($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var width$macro$21 = $uF($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var height$macro$22 = $uF($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_model_PdfPage(paragraphs$macro$20, width$macro$21, height$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "height"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "width"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "paragraphs"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "paragraphs"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "width"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "height")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "paragraphs"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "width"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "height"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_inst$macro$1
}
function $p_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_inst$macro$26 = new $c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43($thiz);
    $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1() {
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_inst$macro$26 = null;
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1.prototype = new $h_O();
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1.prototype.constructor = $c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1;
/** @constructor */
function $h_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1.prototype = $c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1.prototype;
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_inst$macro$1)
});
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1__f_inst$macro$26)
});
var $d_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1 = new $TypeData().initClass({
  Lreactbuild_model_PdfPage$anon$lazy$macro$27$1: 0
}, false, "reactbuild.model.PdfPage$anon$lazy$macro$27$1", {
  Lreactbuild_model_PdfPage$anon$lazy$macro$27$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1.prototype.$classData = $d_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1;
/** @constructor */
function $c_Lreactbuild_model_PdfParagraph$() {
  this.Lreactbuild_model_PdfParagraph$__f_codecForPdfParagraph = null;
  $n_Lreactbuild_model_PdfParagraph$ = this;
  var inst$macro$12 = new $c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_PdfParagraph$__f_codecForPdfParagraph = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_PdfParagraph$.prototype = new $h_O();
$c_Lreactbuild_model_PdfParagraph$.prototype.constructor = $c_Lreactbuild_model_PdfParagraph$;
/** @constructor */
function $h_Lreactbuild_model_PdfParagraph$() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfParagraph$.prototype = $c_Lreactbuild_model_PdfParagraph$.prototype;
var $d_Lreactbuild_model_PdfParagraph$ = new $TypeData().initClass({
  Lreactbuild_model_PdfParagraph$: 0
}, false, "reactbuild.model.PdfParagraph$", {
  Lreactbuild_model_PdfParagraph$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfParagraph$.prototype.$classData = $d_Lreactbuild_model_PdfParagraph$;
var $n_Lreactbuild_model_PdfParagraph$;
function $m_Lreactbuild_model_PdfParagraph$() {
  if ((!$n_Lreactbuild_model_PdfParagraph$)) {
    $n_Lreactbuild_model_PdfParagraph$ = new $c_Lreactbuild_model_PdfParagraph$()
  };
  return $n_Lreactbuild_model_PdfParagraph$
}
function $p_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "lines")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_PdfParagraph(x0$7$2);
      if ((x0$7 !== null)) {
        var lines$macro$9 = $n(x0$7).Lreactbuild_model_PdfParagraph__f_lines;
        return new $c_Lshapeless_$colon$colon(lines$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var lines$macro$8 = $as_sci_List($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_PdfParagraph(lines$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "lines"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "lines")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "lines"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_inst$macro$1
}
function $p_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_inst$macro$10 = new $c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44($thiz);
    $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5() {
  this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_inst$macro$1 = null;
  this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_inst$macro$10 = null;
  this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_bitmap$0 = 0
}
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5.prototype = new $h_O();
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5.prototype.constructor = $c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5;
/** @constructor */
function $h_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5.prototype = $c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5.prototype;
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_inst$macro$1)
});
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5__f_inst$macro$10)
});
var $d_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5 = new $TypeData().initClass({
  Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5: 0
}, false, "reactbuild.model.PdfParagraph$anon$lazy$macro$11$5", {
  Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5.prototype.$classData = $d_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5;
/** @constructor */
function $c_Lreactbuild_model_PdfTextPosition$() {
  this.Lreactbuild_model_PdfTextPosition$__f_codecForPdfTextPosition = null;
  $n_Lreactbuild_model_PdfTextPosition$ = this;
  var inst$macro$44 = new $c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_PdfTextPosition$__f_codecForPdfTextPosition = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_PdfTextPosition$.prototype = new $h_O();
$c_Lreactbuild_model_PdfTextPosition$.prototype.constructor = $c_Lreactbuild_model_PdfTextPosition$;
/** @constructor */
function $h_Lreactbuild_model_PdfTextPosition$() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfTextPosition$.prototype = $c_Lreactbuild_model_PdfTextPosition$.prototype;
var $d_Lreactbuild_model_PdfTextPosition$ = new $TypeData().initClass({
  Lreactbuild_model_PdfTextPosition$: 0
}, false, "reactbuild.model.PdfTextPosition$", {
  Lreactbuild_model_PdfTextPosition$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfTextPosition$.prototype.$classData = $d_Lreactbuild_model_PdfTextPosition$;
var $n_Lreactbuild_model_PdfTextPosition$;
function $m_Lreactbuild_model_PdfTextPosition$() {
  if ((!$n_Lreactbuild_model_PdfTextPosition$)) {
    $n_Lreactbuild_model_PdfTextPosition$ = new $c_Lreactbuild_model_PdfTextPosition$()
  };
  return $n_Lreactbuild_model_PdfTextPosition$
}
function $p_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "x"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "y"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "width"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "height"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "size")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_PdfTextPosition(x0$7$2);
      if ((x0$7 !== null)) {
        var x$macro$37 = $n(x0$7).Lreactbuild_model_PdfTextPosition__f_x;
        var y$macro$38 = $n(x0$7).Lreactbuild_model_PdfTextPosition__f_y;
        var width$macro$39 = $n(x0$7).Lreactbuild_model_PdfTextPosition__f_width;
        var height$macro$40 = $n(x0$7).Lreactbuild_model_PdfTextPosition__f_height;
        var size$macro$41 = $n(x0$7).Lreactbuild_model_PdfTextPosition__f_size;
        return new $c_Lshapeless_$colon$colon(x$macro$37, new $c_Lshapeless_$colon$colon(y$macro$38, new $c_Lshapeless_$colon$colon(width$macro$39, new $c_Lshapeless_$colon$colon(height$macro$40, new $c_Lshapeless_$colon$colon(size$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var x$macro$32 = $uF($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var y$macro$33 = $uF($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var width$macro$34 = $uF($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var height$macro$35 = $uF($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var size$macro$36 = $uF($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_model_PdfTextPosition(x$macro$32, y$macro$33, width$macro$34, height$macro$35, size$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "size"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "height"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "width"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$28 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "x"));
    var this$29 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "y"));
    var this$30 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "width"));
    var this$31 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "height"));
    var this$32 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "size")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "x"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "y"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "width"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "height"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "size"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$57 = $m_s_$less$colon$less$();
    var ev$1 = this$57.s_$less$colon$less$__f_singleton;
    var this$58 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$74);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$78 = $m_s_$less$colon$less$();
    var ev$2 = this$78.s_$less$colon$less$__f_singleton;
    var this$79 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$83);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$87 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$91);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$95 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$95);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_inst$macro$1
}
function $p_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_inst$macro$42 = new $c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47($thiz);
    $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6() {
  this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_inst$macro$1 = null;
  this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_inst$macro$42 = null;
  this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_bitmap$0 = 0
}
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6.prototype = new $h_O();
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6.prototype.constructor = $c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6;
/** @constructor */
function $h_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6.prototype = $c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6.prototype;
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_inst$macro$1)
});
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6__f_inst$macro$42)
});
var $d_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6 = new $TypeData().initClass({
  Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6: 0
}, false, "reactbuild.model.PdfTextPosition$anon$lazy$macro$43$6", {
  Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6.prototype.$classData = $d_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6;
/** @constructor */
function $c_Lreactbuild_model_PdfWord$() {
  this.Lreactbuild_model_PdfWord$__f_codecForPdfWord = null;
  $n_Lreactbuild_model_PdfWord$ = this;
  var inst$macro$20 = new $c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_PdfWord$__f_codecForPdfWord = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_PdfWord$.prototype = new $h_O();
$c_Lreactbuild_model_PdfWord$.prototype.constructor = $c_Lreactbuild_model_PdfWord$;
/** @constructor */
function $h_Lreactbuild_model_PdfWord$() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfWord$.prototype = $c_Lreactbuild_model_PdfWord$.prototype;
var $d_Lreactbuild_model_PdfWord$ = new $TypeData().initClass({
  Lreactbuild_model_PdfWord$: 0
}, false, "reactbuild.model.PdfWord$", {
  Lreactbuild_model_PdfWord$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfWord$.prototype.$classData = $d_Lreactbuild_model_PdfWord$;
var $n_Lreactbuild_model_PdfWord$;
function $m_Lreactbuild_model_PdfWord$() {
  if ((!$n_Lreactbuild_model_PdfWord$)) {
    $n_Lreactbuild_model_PdfWord$ = new $c_Lreactbuild_model_PdfWord$()
  };
  return $n_Lreactbuild_model_PdfWord$
}
function $p_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "text"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "textPositions")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_PdfWord(x0$7$2);
      if ((x0$7 !== null)) {
        var text$macro$16 = $n(x0$7).Lreactbuild_model_PdfWord__f_text;
        var textPositions$macro$17 = $n(x0$7).Lreactbuild_model_PdfWord__f_textPositions;
        return new $c_Lshapeless_$colon$colon(text$macro$16, new $c_Lshapeless_$colon$colon(textPositions$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var text$macro$14 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var textPositions$macro$15 = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_PdfWord(text$macro$14, textPositions$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "textPositions"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "text"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "text"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "textPositions")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "text"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "textPositions"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_inst$macro$1
}
function $p_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_inst$macro$18 = new $c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46($thiz);
    $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4() {
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_inst$macro$1 = null;
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_inst$macro$18 = null;
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_bitmap$0 = 0
}
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4.prototype = new $h_O();
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4.prototype.constructor = $c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4;
/** @constructor */
function $h_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4.prototype = $c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4.prototype;
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_inst$macro$1)
});
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4__f_inst$macro$18)
});
var $d_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4 = new $TypeData().initClass({
  Lreactbuild_model_PdfWord$anon$lazy$macro$19$4: 0
}, false, "reactbuild.model.PdfWord$anon$lazy$macro$19$4", {
  Lreactbuild_model_PdfWord$anon$lazy$macro$19$4: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4.prototype.$classData = $d_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4;
/** @constructor */
function $c_Lreactbuild_model_Price$() {
  this.Lreactbuild_model_Price$__f_zero = null;
  this.Lreactbuild_model_Price$__f_numericPrice = null;
  this.Lreactbuild_model_Price$__f_codecForPrice = null;
  $n_Lreactbuild_model_Price$ = this;
  this.Lreactbuild_model_Price$__f_zero = new $c_Lreactbuild_model_Price(0.0);
  new $c_Lreactbuild_model_Price(1.0);
  this.Lreactbuild_model_Price$__f_numericPrice = new $c_Lreactbuild_model_Price$$anon$4();
  var inst$macro$12 = new $c_Lreactbuild_model_Price$anon$lazy$macro$11$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_Price$__f_codecForPrice = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_Price$.prototype = new $h_O();
$c_Lreactbuild_model_Price$.prototype.constructor = $c_Lreactbuild_model_Price$;
/** @constructor */
function $h_Lreactbuild_model_Price$() {
  /*<skip>*/
}
$h_Lreactbuild_model_Price$.prototype = $c_Lreactbuild_model_Price$.prototype;
var $d_Lreactbuild_model_Price$ = new $TypeData().initClass({
  Lreactbuild_model_Price$: 0
}, false, "reactbuild.model.Price$", {
  Lreactbuild_model_Price$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Price$.prototype.$classData = $d_Lreactbuild_model_Price$;
var $n_Lreactbuild_model_Price$;
function $m_Lreactbuild_model_Price$() {
  if ((!$n_Lreactbuild_model_Price$)) {
    $n_Lreactbuild_model_Price$ = new $c_Lreactbuild_model_Price$()
  };
  return $n_Lreactbuild_model_Price$
}
function $p_Lreactbuild_model_Price$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "amount")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_Price(x0$7$2);
      if ((x0$7 !== null)) {
        var amount$macro$9 = $n(x0$7).Lreactbuild_model_Price__f_amount;
        return new $c_Lshapeless_$colon$colon(amount$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var amount$macro$8 = $uD($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_Price(amount$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "amount"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "amount")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "amount"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_inst$macro$1
}
function $p_Lreactbuild_model_Price$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_inst$macro$10 = new $c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5($thiz);
    $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_model_Price$anon$lazy$macro$11$1() {
  this.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_inst$macro$10 = null;
  this.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1.prototype = new $h_O();
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1.prototype.constructor = $c_Lreactbuild_model_Price$anon$lazy$macro$11$1;
/** @constructor */
function $h_Lreactbuild_model_Price$anon$lazy$macro$11$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_Price$anon$lazy$macro$11$1.prototype = $c_Lreactbuild_model_Price$anon$lazy$macro$11$1.prototype;
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Price$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_inst$macro$1)
});
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Price$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_Price$anon$lazy$macro$11$1__f_inst$macro$10)
});
var $d_Lreactbuild_model_Price$anon$lazy$macro$11$1 = new $TypeData().initClass({
  Lreactbuild_model_Price$anon$lazy$macro$11$1: 0
}, false, "reactbuild.model.Price$anon$lazy$macro$11$1", {
  Lreactbuild_model_Price$anon$lazy$macro$11$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1.prototype.$classData = $d_Lreactbuild_model_Price$anon$lazy$macro$11$1;
/** @constructor */
function $c_Lreactbuild_model_PriceEvolutionProduct$() {
  this.Lreactbuild_model_PriceEvolutionProduct$__f_codecForPriceEvolutionProduct = null;
  $n_Lreactbuild_model_PriceEvolutionProduct$ = this;
  var inst$macro$44 = new $c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_PriceEvolutionProduct$__f_codecForPriceEvolutionProduct = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_PriceEvolutionProduct$.prototype = new $h_O();
$c_Lreactbuild_model_PriceEvolutionProduct$.prototype.constructor = $c_Lreactbuild_model_PriceEvolutionProduct$;
/** @constructor */
function $h_Lreactbuild_model_PriceEvolutionProduct$() {
  /*<skip>*/
}
$h_Lreactbuild_model_PriceEvolutionProduct$.prototype = $c_Lreactbuild_model_PriceEvolutionProduct$.prototype;
var $d_Lreactbuild_model_PriceEvolutionProduct$ = new $TypeData().initClass({
  Lreactbuild_model_PriceEvolutionProduct$: 0
}, false, "reactbuild.model.PriceEvolutionProduct$", {
  Lreactbuild_model_PriceEvolutionProduct$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PriceEvolutionProduct$.prototype.$classData = $d_Lreactbuild_model_PriceEvolutionProduct$;
var $n_Lreactbuild_model_PriceEvolutionProduct$;
function $m_Lreactbuild_model_PriceEvolutionProduct$() {
  if ((!$n_Lreactbuild_model_PriceEvolutionProduct$)) {
    $n_Lreactbuild_model_PriceEvolutionProduct$ = new $c_Lreactbuild_model_PriceEvolutionProduct$()
  };
  return $n_Lreactbuild_model_PriceEvolutionProduct$
}
function $p_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "description"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "buildingPart"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "unit"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "events")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_PriceEvolutionProduct(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$37 = $n(x0$7).Lreactbuild_model_PriceEvolutionProduct__f__id;
        var description$macro$38 = $n(x0$7).Lreactbuild_model_PriceEvolutionProduct__f_description;
        var buildingPart$macro$39 = $n(x0$7).Lreactbuild_model_PriceEvolutionProduct__f_buildingPart;
        var unit$macro$40 = $n(x0$7).Lreactbuild_model_PriceEvolutionProduct__f_unit;
        var events$macro$41 = $n(x0$7).Lreactbuild_model_PriceEvolutionProduct__f_events;
        return new $c_Lshapeless_$colon$colon(_id$macro$37, new $c_Lshapeless_$colon$colon(description$macro$38, new $c_Lshapeless_$colon$colon(buildingPart$macro$39, new $c_Lshapeless_$colon$colon(unit$macro$40, new $c_Lshapeless_$colon$colon(events$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$32 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var description$macro$33 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var buildingPart$macro$34 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var unit$macro$35 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var events$macro$36 = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_model_PriceEvolutionProduct(_id$macro$32, description$macro$33, buildingPart$macro$34, unit$macro$35, events$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "events"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "unit"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "buildingPart"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_PriceEvolutionProduct$(), $m_s_None$())), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$29 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
    var this$30 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "description"));
    var this$31 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "buildingPart"));
    var this$32 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "unit"));
    var this$33 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "events")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "buildingPart"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "_id"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "description"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "buildingPart"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "unit"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "events"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$10);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$61 = $m_s_$less$colon$less$();
    var ev$1 = this$61.s_$less$colon$less$__f_singleton;
    var this$62 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$78);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$82 = $m_s_$less$colon$less$();
    var ev$2 = this$82.s_$less$colon$less$__f_singleton;
    var this$83 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$83);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$87 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$91);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$95 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$95);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$99 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$99);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_inst$macro$1
}
function $p_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_inst$macro$42 = new $c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20($thiz);
    $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3() {
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_inst$macro$1 = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_inst$macro$42 = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_bitmap$0 = 0
}
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3.prototype = new $h_O();
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3.prototype.constructor = $c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3;
/** @constructor */
function $h_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3.prototype = $c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3.prototype;
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_inst$macro$1)
});
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3__f_inst$macro$42)
});
var $d_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3 = new $TypeData().initClass({
  Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3: 0
}, false, "reactbuild.model.PriceEvolutionProduct$anon$lazy$macro$43$3", {
  Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3.prototype.$classData = $d_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3;
/** @constructor */
function $c_Lreactbuild_model_PriceEvolutionProductEntry$() {
  this.Lreactbuild_model_PriceEvolutionProductEntry$__f_codecForPriceEvolutionProductEntry = null;
  $n_Lreactbuild_model_PriceEvolutionProductEntry$ = this;
  var inst$macro$76 = new $c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$76));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_PriceEvolutionProductEntry$__f_codecForPriceEvolutionProductEntry = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_PriceEvolutionProductEntry$.prototype = new $h_O();
$c_Lreactbuild_model_PriceEvolutionProductEntry$.prototype.constructor = $c_Lreactbuild_model_PriceEvolutionProductEntry$;
/** @constructor */
function $h_Lreactbuild_model_PriceEvolutionProductEntry$() {
  /*<skip>*/
}
$h_Lreactbuild_model_PriceEvolutionProductEntry$.prototype = $c_Lreactbuild_model_PriceEvolutionProductEntry$.prototype;
var $d_Lreactbuild_model_PriceEvolutionProductEntry$ = new $TypeData().initClass({
  Lreactbuild_model_PriceEvolutionProductEntry$: 0
}, false, "reactbuild.model.PriceEvolutionProductEntry$", {
  Lreactbuild_model_PriceEvolutionProductEntry$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PriceEvolutionProductEntry$.prototype.$classData = $d_Lreactbuild_model_PriceEvolutionProductEntry$;
var $n_Lreactbuild_model_PriceEvolutionProductEntry$;
function $m_Lreactbuild_model_PriceEvolutionProductEntry$() {
  if ((!$n_Lreactbuild_model_PriceEvolutionProductEntry$)) {
    $n_Lreactbuild_model_PriceEvolutionProductEntry$ = new $c_Lreactbuild_model_PriceEvolutionProductEntry$()
  };
  return $n_Lreactbuild_model_PriceEvolutionProductEntry$
}
function $p_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "invoicePage"));
    var this$2 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "reference"));
    var this$3 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "category"));
    var this$4 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "date"));
    var this$5 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "unitPrice"));
    var this$6 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "amount"));
    var this$7 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "quantity"));
    var this$8 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "buildingPart"));
    var this$9 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "supplier")), $m_Lshapeless_HNil$())))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_PriceEvolutionProductEntry(x0$7$2);
      if ((x0$7 !== null)) {
        var invoicePage$macro$65 = $n(x0$7).Lreactbuild_model_PriceEvolutionProductEntry__f_invoicePage;
        var reference$macro$66 = $n(x0$7).Lreactbuild_model_PriceEvolutionProductEntry__f_reference;
        var category$macro$67 = $n(x0$7).Lreactbuild_model_PriceEvolutionProductEntry__f_category;
        var date$macro$68 = $n(x0$7).Lreactbuild_model_PriceEvolutionProductEntry__f_date;
        var unitPrice$macro$69 = $n(x0$7).Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice;
        var amount$macro$70 = $n(x0$7).Lreactbuild_model_PriceEvolutionProductEntry__f_amount;
        var quantity$macro$71 = $n(x0$7).Lreactbuild_model_PriceEvolutionProductEntry__f_quantity;
        var buildingPart$macro$72 = $n(x0$7).Lreactbuild_model_PriceEvolutionProductEntry__f_buildingPart;
        var supplier$macro$73 = $n(x0$7).Lreactbuild_model_PriceEvolutionProductEntry__f_supplier;
        return new $c_Lshapeless_$colon$colon(invoicePage$macro$65, new $c_Lshapeless_$colon$colon(reference$macro$66, new $c_Lshapeless_$colon$colon(category$macro$67, new $c_Lshapeless_$colon$colon(date$macro$68, new $c_Lshapeless_$colon$colon(unitPrice$macro$69, new $c_Lshapeless_$colon$colon(amount$macro$70, new $c_Lshapeless_$colon$colon(quantity$macro$71, new $c_Lshapeless_$colon$colon(buildingPart$macro$72, new $c_Lshapeless_$colon$colon(supplier$macro$73, $m_Lshapeless_HNil$())))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var invoicePage$macro$56 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var reference$macro$57 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var category$macro$58 = $as_Lreactbuild_model_DocumentCategory($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var date$macro$59 = $as_Ljava_time_LocalDate($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var unitPrice$macro$60 = $as_Lreactbuild_model_Price($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var amount$macro$61 = $as_Lreactbuild_model_Price($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var quantity$macro$62 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var buildingPart$macro$63 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var supplier$macro$64 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_HNil($n(p9).Lshapeless_$colon$colon__f_tail);
                        var x = $m_Lshapeless_HNil$();
                        if ((x === p10)) {
                          return new $c_Lreactbuild_model_PriceEvolutionProductEntry(invoicePage$macro$56, reference$macro$57, category$macro$58, date$macro$59, unitPrice$macro$60, amount$macro$61, quantity$macro$62, buildingPart$macro$63, supplier$macro$64)
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "buildingPart"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "quantity"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "amount"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "unitPrice"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$28 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "invoicePage"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    var this$40 = $m_s_$less$colon$less$();
    var ev = this$40.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$74__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_PriceEvolutionProductEntry$(), $m_s_None$())), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_PriceEvolutionProductEntry$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_PriceEvolutionProductEntry$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_PriceEvolutionProductEntry$(), $m_s_None$())), $m_Lshapeless_HNil$())))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$48 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "invoicePage"));
    var this$49 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "reference"));
    var this$50 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "category"));
    var this$51 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "date"));
    var this$52 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "unitPrice"));
    var this$53 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "amount"));
    var this$54 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "quantity"));
    var this$55 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "buildingPart"));
    var this$56 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "supplier")), $m_Lshapeless_HNil$())))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var tailHelper$8 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$8);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$69 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$69, "reference"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$71 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$71, "quantity"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$73 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "buildingPart"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$75 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$75, "supplier"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$12);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$81 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$81, "invoicePage"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$83 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "reference"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$85 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "category"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$87 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$87, "date"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$89 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$89, "unitPrice"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$91 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$91, "amount"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lshapeless_Witness$();
    var this$93 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "quantity"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$95 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$95, "buildingPart"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lshapeless_Witness$();
    var this$97 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$97, "supplier"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$21);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var this$109 = $m_s_$less$colon$less$();
    var ev$1 = this$109.s_$less$colon$less$__f_singleton;
    var this$110 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$110);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$114 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$114);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$118 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$118);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$122 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$122);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$126 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$126);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$130 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$130);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$134 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$134);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$138 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$138);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$142 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$142);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$146 = $m_s_$less$colon$less$();
    var ev$2 = this$146.s_$less$colon$less$__f_singleton;
    var this$147 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$147);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$9, ev$2);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$151 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$151);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$155 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$155);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$159 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$159);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$163 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$163);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$167 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$167);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$171 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$171);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$175 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$175);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$14, tttvs$14);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$179 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$179);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$15, tttvs$15);
    $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_inst$macro$1
}
function $p_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__inst$macro$74$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_inst$macro$74 = new $c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19($thiz);
    $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_inst$macro$74
}
/** @constructor */
function $c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1() {
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_inst$macro$74 = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1.prototype = new $h_O();
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1.prototype.constructor = $c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1;
/** @constructor */
function $h_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1.prototype = $c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1.prototype;
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_inst$macro$1)
});
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1.prototype.inst$macro$74__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__inst$macro$74$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1__f_inst$macro$74)
});
var $d_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1 = new $TypeData().initClass({
  Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1: 0
}, false, "reactbuild.model.PriceEvolutionProductEntry$anon$lazy$macro$75$1", {
  Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1.prototype.$classData = $d_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1;
/** @constructor */
function $c_Lreactbuild_model_Product$() {
  this.Lreactbuild_model_Product$__f_codecForProduct = null;
  $n_Lreactbuild_model_Product$ = this;
  var inst$macro$52 = new $c_Lreactbuild_model_Product$anon$lazy$macro$51$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$52));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_Product$__f_codecForProduct = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_Product$.prototype = new $h_O();
$c_Lreactbuild_model_Product$.prototype.constructor = $c_Lreactbuild_model_Product$;
/** @constructor */
function $h_Lreactbuild_model_Product$() {
  /*<skip>*/
}
$h_Lreactbuild_model_Product$.prototype = $c_Lreactbuild_model_Product$.prototype;
var $d_Lreactbuild_model_Product$ = new $TypeData().initClass({
  Lreactbuild_model_Product$: 0
}, false, "reactbuild.model.Product$", {
  Lreactbuild_model_Product$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Product$.prototype.$classData = $d_Lreactbuild_model_Product$;
var $n_Lreactbuild_model_Product$;
function $m_Lreactbuild_model_Product$() {
  if ((!$n_Lreactbuild_model_Product$)) {
    $n_Lreactbuild_model_Product$ = new $c_Lreactbuild_model_Product$()
  };
  return $n_Lreactbuild_model_Product$
}
function $p_Lreactbuild_model_Product$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "reference"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "name"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "supplier"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "buildingPart")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_Product(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$44 = $n(x0$7).Lreactbuild_model_Product__f__id;
        var organization$macro$45 = $n(x0$7).Lreactbuild_model_Product__f_organization;
        var reference$macro$46 = $n(x0$7).Lreactbuild_model_Product__f_reference;
        var name$macro$47 = $n(x0$7).Lreactbuild_model_Product__f_name;
        var supplier$macro$48 = $n(x0$7).Lreactbuild_model_Product__f_supplier;
        var buildingPart$macro$49 = $n(x0$7).Lreactbuild_model_Product__f_buildingPart;
        return new $c_Lshapeless_$colon$colon(_id$macro$44, new $c_Lshapeless_$colon$colon(organization$macro$45, new $c_Lshapeless_$colon$colon(reference$macro$46, new $c_Lshapeless_$colon$colon(name$macro$47, new $c_Lshapeless_$colon$colon(supplier$macro$48, new $c_Lshapeless_$colon$colon(buildingPart$macro$49, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$38 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$39 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var reference$macro$40 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var name$macro$41 = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var supplier$macro$42 = $as_Lreactbuild_common_model_RefTo($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var buildingPart$macro$43 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_model_Product(_id$macro$38, organization$macro$39, reference$macro$40, name$macro$41, supplier$macro$42, buildingPart$macro$43)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "buildingPart"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Product$(), $m_s_None$())), $m_Lshapeless_HNil$()))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$33 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "_id"));
    var this$34 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "organization"));
    var this$35 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "reference"));
    var this$36 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "name"));
    var this$37 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "supplier"));
    var this$38 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "buildingPart")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$48 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "buildingPart"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "_id"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "organization"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "reference"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "name"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "supplier"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "buildingPart"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$12);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var this$70 = $m_s_$less$colon$less$();
    var ev$1 = this$70.s_$less$colon$less$__f_singleton;
    var this$71 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$71);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$75 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$75);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$79 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$83);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$87 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$91);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$95 = $m_s_$less$colon$less$();
    var ev$2 = this$95.s_$less$colon$less$__f_singleton;
    var this$96 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$96);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$6, ev$2);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$100 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$100);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$104 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$104);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$108 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$108);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$112 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$112);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$116 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$116);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_inst$macro$1
}
function $p_Lreactbuild_model_Product$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_inst$macro$50 = new $c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21($thiz);
    $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_inst$macro$50
}
/** @constructor */
function $c_Lreactbuild_model_Product$anon$lazy$macro$51$1() {
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_inst$macro$50 = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1.prototype = new $h_O();
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1.prototype.constructor = $c_Lreactbuild_model_Product$anon$lazy$macro$51$1;
/** @constructor */
function $h_Lreactbuild_model_Product$anon$lazy$macro$51$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_Product$anon$lazy$macro$51$1.prototype = $c_Lreactbuild_model_Product$anon$lazy$macro$51$1.prototype;
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Product$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_inst$macro$1)
});
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1.prototype.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Product$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_Product$anon$lazy$macro$51$1__f_inst$macro$50)
});
var $d_Lreactbuild_model_Product$anon$lazy$macro$51$1 = new $TypeData().initClass({
  Lreactbuild_model_Product$anon$lazy$macro$51$1: 0
}, false, "reactbuild.model.Product$anon$lazy$macro$51$1", {
  Lreactbuild_model_Product$anon$lazy$macro$51$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1.prototype.$classData = $d_Lreactbuild_model_Product$anon$lazy$macro$51$1;
/** @constructor */
function $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$() {
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$__f_codecForReconcileInvoicePageWithDeliveryForm = null;
  $n_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$ = this;
  var inst$macro$44 = new $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$__f_codecForReconcileInvoicePageWithDeliveryForm = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$.prototype = new $h_O();
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$.prototype.constructor = $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$;
/** @constructor */
function $h_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$.prototype = $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$.prototype;
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$.prototype.keyMapperReconcileInvoicePageWithDeliveryForm__Lcom_iz2use_common_KeyMapper = (function() {
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$19$2) => {
    var x$19 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x$19$2);
    return $n(x$19).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id
  }));
  var ev = $m_Lreactbuild_common_model_RefTo$().keyMapper__Lcom_iz2use_common_KeyMapper();
  return new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f)
});
var $d_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$ = new $TypeData().initClass({
  Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$: 0
}, false, "reactbuild.model.ReconcileInvoicePageWithDeliveryForm$", {
  Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$.prototype.$classData = $d_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$;
var $n_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$;
function $m_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$() {
  if ((!$n_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$)) {
    $n_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$ = new $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$()
  };
  return $n_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$
}
function $p_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "date"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "reference"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "details")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$37 = $n(x0$7).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id;
        var organization$macro$38 = $n(x0$7).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_organization;
        var date$macro$39 = $n(x0$7).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_date;
        var reference$macro$40 = $n(x0$7).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference;
        var details$macro$41 = $n(x0$7).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_details;
        return new $c_Lshapeless_$colon$colon(_id$macro$37, new $c_Lshapeless_$colon$colon(organization$macro$38, new $c_Lshapeless_$colon$colon(date$macro$39, new $c_Lshapeless_$colon$colon(reference$macro$40, new $c_Lshapeless_$colon$colon(details$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$32 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$33 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var date$macro$34 = $as_Lreactbuild_common_model_Date($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var reference$macro$35 = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var details$macro$36 = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(_id$macro$32, organization$macro$33, date$macro$34, reference$macro$35, details$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$(), $m_s_package$().s_package$__f_Nil)), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$31 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "_id"));
    var this$32 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "organization"));
    var this$33 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "date"));
    var this$34 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "reference"));
    var this$35 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "details")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$44 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "_id"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "details"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$50 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "_id"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$52 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "organization"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$54 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "date"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$56 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "reference"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$58 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "details"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$66 = $m_s_$less$colon$less$();
    var ev$1 = this$66.s_$less$colon$less$__f_singleton;
    var this$67 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$67);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$71 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$71);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$75 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$75);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$79 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$83);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$87 = $m_s_$less$colon$less$();
    var ev$2 = this$87.s_$less$colon$less$__f_singleton;
    var this$88 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$88);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$92 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$92);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$96 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$96);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$100 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$100);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$104 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$104);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_inst$macro$1
}
function $p_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_inst$macro$42 = new $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41($thiz);
    $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5() {
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_inst$macro$1 = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_inst$macro$42 = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5.prototype = new $h_O();
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5.prototype.constructor = $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5;
/** @constructor */
function $h_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5() {
  /*<skip>*/
}
$h_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5.prototype = $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5.prototype;
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_inst$macro$1)
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5__f_inst$macro$42)
});
var $d_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5 = new $TypeData().initClass({
  Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5: 0
}, false, "reactbuild.model.ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5", {
  Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5.prototype.$classData = $d_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5;
/** @constructor */
function $c_Lreactbuild_model_Resource$() {
  this.Lreactbuild_model_Resource$__f_codecForResource = null;
  $n_Lreactbuild_model_Resource$ = this;
  var inst$macro$60 = new $c_Lreactbuild_model_Resource$anon$lazy$macro$59$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$60));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_Resource$__f_codecForResource = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_Resource$.prototype = new $h_O();
$c_Lreactbuild_model_Resource$.prototype.constructor = $c_Lreactbuild_model_Resource$;
/** @constructor */
function $h_Lreactbuild_model_Resource$() {
  /*<skip>*/
}
$h_Lreactbuild_model_Resource$.prototype = $c_Lreactbuild_model_Resource$.prototype;
$c_Lreactbuild_model_Resource$.prototype.keyMapper__Lcom_iz2use_common_KeyMapper = (function() {
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Lreactbuild_model_Resource(x$10$2);
    return $n(x$10).Lreactbuild_model_Resource__f__id
  }));
  var ev = $m_Lreactbuild_common_model_RefTo$().keyMapper__Lcom_iz2use_common_KeyMapper();
  return new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f)
});
var $d_Lreactbuild_model_Resource$ = new $TypeData().initClass({
  Lreactbuild_model_Resource$: 0
}, false, "reactbuild.model.Resource$", {
  Lreactbuild_model_Resource$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Resource$.prototype.$classData = $d_Lreactbuild_model_Resource$;
var $n_Lreactbuild_model_Resource$;
function $m_Lreactbuild_model_Resource$() {
  if ((!$n_Lreactbuild_model_Resource$)) {
    $n_Lreactbuild_model_Resource$ = new $c_Lreactbuild_model_Resource$()
  };
  return $n_Lreactbuild_model_Resource$
}
function $p_Lreactbuild_model_Resource$anon$lazy$macro$59$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "costByHour"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "category"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "entry"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "release")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_Resource(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$51 = $n(x0$7).Lreactbuild_model_Resource__f__id;
        var organization$macro$52 = $n(x0$7).Lreactbuild_model_Resource__f_organization;
        var name$macro$53 = $n(x0$7).Lreactbuild_model_Resource__f_name;
        var costByHour$macro$54 = $n(x0$7).Lreactbuild_model_Resource__f_costByHour;
        var category$macro$55 = $n(x0$7).Lreactbuild_model_Resource__f_category;
        var entry$macro$56 = $n(x0$7).Lreactbuild_model_Resource__f_entry;
        var release$macro$57 = $n(x0$7).Lreactbuild_model_Resource__f_release;
        return new $c_Lshapeless_$colon$colon(_id$macro$51, new $c_Lshapeless_$colon$colon(organization$macro$52, new $c_Lshapeless_$colon$colon(name$macro$53, new $c_Lshapeless_$colon$colon(costByHour$macro$54, new $c_Lshapeless_$colon$colon(category$macro$55, new $c_Lshapeless_$colon$colon(entry$macro$56, new $c_Lshapeless_$colon$colon(release$macro$57, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$44 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$45 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$46 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var costByHour$macro$47 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var category$macro$48 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var entry$macro$49 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var release$macro$50 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_model_Resource(_id$macro$44, organization$macro$45, name$macro$46, costByHour$macro$47, category$macro$48, entry$macro$49, release$macro$50)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "release"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "entry"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "costByHour"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Resource$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Resource$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Resource$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Resource$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Resource$(), $m_s_None$())), $m_Lshapeless_HNil$())))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$42 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "_id"));
    var this$43 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "organization"));
    var this$44 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "name"));
    var this$45 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "costByHour"));
    var this$46 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "category"));
    var this$47 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "entry"));
    var this$48 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "release")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$6);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "_id"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "costByHour"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "category"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "entry"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$67 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "release"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$74 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "_id"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$76 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "organization"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$78 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "name"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$80 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "costByHour"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$82 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$82, "category"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$84 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$84, "entry"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$86 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$86, "release"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$18);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$96 = $m_s_$less$colon$less$();
    var ev$1 = this$96.s_$less$colon$less$__f_singleton;
    var this$97 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$97);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$101 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$113);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$117 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$117);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$121 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$121);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$125 = $m_s_$less$colon$less$();
    var ev$2 = this$125.s_$less$colon$less$__f_singleton;
    var this$126 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$126);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$130 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$130);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$134 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$134);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$138 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$138);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$142 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$142);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$146 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$146);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$150 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$150);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_inst$macro$1
}
function $p_Lreactbuild_model_Resource$anon$lazy$macro$59$2__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_inst$macro$58 = new $c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12($thiz);
    $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_model_Resource$anon$lazy$macro$59$2() {
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_inst$macro$1 = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_inst$macro$58 = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_bitmap$0 = 0
}
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2.prototype = new $h_O();
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2.prototype.constructor = $c_Lreactbuild_model_Resource$anon$lazy$macro$59$2;
/** @constructor */
function $h_Lreactbuild_model_Resource$anon$lazy$macro$59$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_Resource$anon$lazy$macro$59$2.prototype = $c_Lreactbuild_model_Resource$anon$lazy$macro$59$2.prototype;
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Resource$anon$lazy$macro$59$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_inst$macro$1)
});
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2.prototype.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Resource$anon$lazy$macro$59$2__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_Resource$anon$lazy$macro$59$2__f_inst$macro$58)
});
var $d_Lreactbuild_model_Resource$anon$lazy$macro$59$2 = new $TypeData().initClass({
  Lreactbuild_model_Resource$anon$lazy$macro$59$2: 0
}, false, "reactbuild.model.Resource$anon$lazy$macro$59$2", {
  Lreactbuild_model_Resource$anon$lazy$macro$59$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2.prototype.$classData = $d_Lreactbuild_model_Resource$anon$lazy$macro$59$2;
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Document"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Person"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "PersonReference"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "Project")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_SearchResult(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_model_SearchResult$Document)) {
        var $$x4 = 0
      } else if ((p instanceof $c_Lreactbuild_model_SearchResult$Person)) {
        var $$x4 = 1
      } else if ((p instanceof $c_Lreactbuild_model_SearchResult$PersonReference)) {
        var $$x4 = 2
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_SearchResult$Project))) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_SearchResult($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "Project"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "PersonReference"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "Person"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "Document"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$1
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$2 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93($thiz);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$2
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ref")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_SearchResult$Project(x0$7$2);
      if ((x0$7 !== null)) {
        var ref$macro$11 = $n(x0$7).Lreactbuild_model_SearchResult$Project__f_ref;
        return new $c_Lshapeless_$colon$colon(ref$macro$11, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var ref$macro$10 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_SearchResult$Project(ref$macro$10)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "ref")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "ref"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$3
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$12 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94($thiz);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$12
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "item")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_SearchResult$PersonReference(x0$15$2);
      if ((x0$15 !== null)) {
        var item$macro$21 = $n(x0$15).Lreactbuild_model_SearchResult$PersonReference__f_item;
        return new $c_Lshapeless_$colon$colon(item$macro$21, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var item$macro$20 = $as_Lreactbuild_person_PersonReferenceEvent($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$16).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_SearchResult$PersonReference(item$macro$20)
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "item"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$22__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "item")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "item"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$13 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$13
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$22$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$22 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95($thiz);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$22
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$23$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ref")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_model_SearchResult$Person(x0$23$2);
      if ((x0$23 !== null)) {
        var ref$macro$31 = $n(x0$23).Lreactbuild_model_SearchResult$Person__f_ref;
        return new $c_Lshapeless_$colon$colon(ref$macro$31, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var ref$macro$30 = $as_Lreactbuild_common_model_RefTo($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$24).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_SearchResult$Person(ref$macro$30)
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$32__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "ref")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "ref"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$23 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$23
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$32$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$32 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96($thiz);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$32
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$33$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ref")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_model_SearchResult$Document(x0$31$2);
      if ((x0$31 !== null)) {
        var ref$macro$41 = $n(x0$31).Lreactbuild_model_SearchResult$Document__f_ref;
        return new $c_Lshapeless_$colon$colon(ref$macro$41, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var ref$macro$40 = $as_Lreactbuild_common_model_RefTo($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$32).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_SearchResult$Document(ref$macro$40)
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "ref")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "ref"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$33 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$33
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$42$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$42 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97($thiz);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$42
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$43$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ref")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_model_SearchResult$Project(x0$39$2);
      if ((x0$39 !== null)) {
        var ref$macro$51 = $n(x0$39).Lreactbuild_model_SearchResult$Project__f_ref;
        return new $c_Lshapeless_$colon$colon(ref$macro$51, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var ref$macro$50 = $as_Lreactbuild_common_model_RefTo($n(x0$40).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$40).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_SearchResult$Project(ref$macro$50)
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$52__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "ref"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$43 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (1024 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$43
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$52$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$52 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98($thiz);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (2048 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$52
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$53$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "item")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_model_SearchResult$PersonReference(x0$47$2);
      if ((x0$47 !== null)) {
        var item$macro$61 = $n(x0$47).Lreactbuild_model_SearchResult$PersonReference__f_item;
        return new $c_Lshapeless_$colon$colon(item$macro$61, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_$colon$colon(x0$48$2);
      if ((x0$48 !== null)) {
        var item$macro$60 = $as_Lreactbuild_person_PersonReferenceEvent($n(x0$48).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$48).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_SearchResult$PersonReference(item$macro$60)
        }
      };
      throw new $c_s_MatchError(x0$48)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "item"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$62__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "item"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$53 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (4096 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$53
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$62$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$62 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99($thiz);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (8192 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$62
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$63$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ref")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      var x0$55 = $as_Lreactbuild_model_SearchResult$Person(x0$55$2);
      if ((x0$55 !== null)) {
        var ref$macro$71 = $n(x0$55).Lreactbuild_model_SearchResult$Person__f_ref;
        return new $c_Lshapeless_$colon$colon(ref$macro$71, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$55)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      var x0$56 = $as_Lshapeless_$colon$colon(x0$56$2);
      if ((x0$56 !== null)) {
        var ref$macro$70 = $as_Lreactbuild_common_model_RefTo($n(x0$56).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$56).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_SearchResult$Person(ref$macro$70)
        }
      };
      throw new $c_s_MatchError(x0$56)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$72__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "ref"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$63 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (16384 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$63
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$72$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((32768 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$72 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100($thiz);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (32768 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$72
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$73$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((65536 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ref")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      var x0$63 = $as_Lreactbuild_model_SearchResult$Document(x0$63$2);
      if ((x0$63 !== null)) {
        var ref$macro$81 = $n(x0$63).Lreactbuild_model_SearchResult$Document__f_ref;
        return new $c_Lshapeless_$colon$colon(ref$macro$81, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$63)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      var x0$64 = $as_Lshapeless_$colon$colon(x0$64$2);
      if ((x0$64 !== null)) {
        var ref$macro$80 = $as_Lreactbuild_common_model_RefTo($n(x0$64).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$64).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_SearchResult$Document(ref$macro$80)
        }
      };
      throw new $c_s_MatchError(x0$64)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$82__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "ref"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$73 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (65536 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$73
}
function $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$82$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((131072 & $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$82 = new $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101($thiz);
    $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = (131072 | $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$82
}
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4() {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$1 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$2 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$3 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$12 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$13 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$22 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$23 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$32 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$33 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$42 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$43 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$52 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$53 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$62 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$63 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$72 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$73 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$82 = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0 = 0
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$1)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$2)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$3)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$12)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$13)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$22__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$22$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$22)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$23__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$23$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$23)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$32__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((128 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$32$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$32)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$33__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((256 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$33$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$33)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$42__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((512 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$42$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$42)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$43__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$43$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$43)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$52__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$52$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$52)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$53__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4096 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$53$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$53)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$62__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$62$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$62)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$63__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((16384 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$63$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$63)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$72__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((32768 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$72$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$72)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$73__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((65536 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$73$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$73)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.inst$macro$82__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((131072 & this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_bitmap$0) === 0) ? $p_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__inst$macro$82$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4__f_inst$macro$82)
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4;
/** @constructor */
function $c_Lreactbuild_model_Task$() {
  this.Lreactbuild_model_Task$__f_keyMapper = null;
  this.Lreactbuild_model_Task$__f_codecForTask = null;
  $n_Lreactbuild_model_Task$ = this;
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_model_Task(x$1$2);
    return $n(x$1).Lreactbuild_model_Task__f__id
  }));
  var ev = $m_Lreactbuild_common_model_RefTo$().keyMapper__Lcom_iz2use_common_KeyMapper();
  this.Lreactbuild_model_Task$__f_keyMapper = new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f);
  var inst$macro$60 = new $c_Lreactbuild_model_Task$anon$lazy$macro$59$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$60));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_Task$__f_codecForTask = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_Task$.prototype = new $h_O();
$c_Lreactbuild_model_Task$.prototype.constructor = $c_Lreactbuild_model_Task$;
/** @constructor */
function $h_Lreactbuild_model_Task$() {
  /*<skip>*/
}
$h_Lreactbuild_model_Task$.prototype = $c_Lreactbuild_model_Task$.prototype;
var $d_Lreactbuild_model_Task$ = new $TypeData().initClass({
  Lreactbuild_model_Task$: 0
}, false, "reactbuild.model.Task$", {
  Lreactbuild_model_Task$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Task$.prototype.$classData = $d_Lreactbuild_model_Task$;
var $n_Lreactbuild_model_Task$;
function $m_Lreactbuild_model_Task$() {
  if ((!$n_Lreactbuild_model_Task$)) {
    $n_Lreactbuild_model_Task$ = new $c_Lreactbuild_model_Task$()
  };
  return $n_Lreactbuild_model_Task$
}
function $p_Lreactbuild_model_Task$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "persons"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "subject"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "attachments"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "created"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "done")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_Task(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$51 = $n(x0$7).Lreactbuild_model_Task__f__id;
        var organization$macro$52 = $n(x0$7).Lreactbuild_model_Task__f_organization;
        var persons$macro$53 = $n(x0$7).Lreactbuild_model_Task__f_persons;
        var subject$macro$54 = $n(x0$7).Lreactbuild_model_Task__f_subject;
        var attachments$macro$55 = $n(x0$7).Lreactbuild_model_Task__f_attachments;
        var created$macro$56 = $n(x0$7).Lreactbuild_model_Task__f_created;
        var done$macro$57 = $n(x0$7).Lreactbuild_model_Task__f_done;
        return new $c_Lshapeless_$colon$colon(_id$macro$51, new $c_Lshapeless_$colon$colon(organization$macro$52, new $c_Lshapeless_$colon$colon(persons$macro$53, new $c_Lshapeless_$colon$colon(new $c_Lcom_iz2use_common_Multiline(subject$macro$54), new $c_Lshapeless_$colon$colon(attachments$macro$55, new $c_Lshapeless_$colon$colon(created$macro$56, new $c_Lshapeless_$colon$colon(done$macro$57, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$44 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$45 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var persons$macro$46 = $as_sci_Seq($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var subject$macro$47 = $n($as_Lcom_iz2use_common_Multiline($n(p4).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var attachments$macro$48 = $as_sci_Seq($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var created$macro$49 = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var done$macro$50 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_model_Task(_id$macro$44, organization$macro$45, persons$macro$46, subject$macro$47, attachments$macro$48, created$macro$49, done$macro$50)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "done"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "attachments"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "subject"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "persons"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x12 = $m_s_None$();
    var $$x11 = $m_s_None$();
    var $$x10 = $m_s_None$();
    var $$x9 = $m_s_None$();
    var $$x8 = new $c_s_Some(($m_Lreactbuild_model_Task$(), $m_s_package$().s_package$__f_Nil));
    $m_Lreactbuild_model_Task$();
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x7 = $m_Ljava_time_Instant$();
    var this$41 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$41.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$41.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var defaults = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon(new $c_s_Some($n($$x7).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Task$(), $m_s_None$())), $m_Lshapeless_HNil$())))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$44 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "_id"));
    var this$45 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "organization"));
    var this$46 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "persons"));
    var this$47 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "subject"));
    var this$48 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "attachments"));
    var this$49 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "created"));
    var this$50 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "done")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "attachments"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "created"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "done"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$70 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$70, "_id"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$72 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$72, "organization"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$74 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "persons"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$76 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "subject"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$78 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "attachments"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$80 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "created"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$82 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$82, "done"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$16);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$92 = $m_s_$less$colon$less$();
    var ev$1 = this$92.s_$less$colon$less$__f_singleton;
    var this$93 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$93);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$97 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$97);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$101 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$113);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$117 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$117);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$121 = $m_s_$less$colon$less$();
    var ev$2 = this$121.s_$less$colon$less$__f_singleton;
    var this$122 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$122);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$126 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$126);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$130 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$130);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$134 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$134);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$138 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$138);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$142 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$142);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$146 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$146);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_inst$macro$1
}
function $p_Lreactbuild_model_Task$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_inst$macro$58 = new $c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13($thiz);
    $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_model_Task$anon$lazy$macro$59$1() {
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_inst$macro$58 = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1.prototype = new $h_O();
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1.prototype.constructor = $c_Lreactbuild_model_Task$anon$lazy$macro$59$1;
/** @constructor */
function $h_Lreactbuild_model_Task$anon$lazy$macro$59$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_Task$anon$lazy$macro$59$1.prototype = $c_Lreactbuild_model_Task$anon$lazy$macro$59$1.prototype;
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Task$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_inst$macro$1)
});
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1.prototype.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Task$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_Task$anon$lazy$macro$59$1__f_inst$macro$58)
});
var $d_Lreactbuild_model_Task$anon$lazy$macro$59$1 = new $TypeData().initClass({
  Lreactbuild_model_Task$anon$lazy$macro$59$1: 0
}, false, "reactbuild.model.Task$anon$lazy$macro$59$1", {
  Lreactbuild_model_Task$anon$lazy$macro$59$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1.prototype.$classData = $d_Lreactbuild_model_Task$anon$lazy$macro$59$1;
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "CommunicationTaskAttachment"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "FileTaskAttachment"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "ProjectTaskAttachment"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "TaskTaskAttachment")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_TaskAttachment(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_model_CommunicationTaskAttachment)) {
        var $$x4 = 0
      } else if ((p instanceof $c_Lreactbuild_model_FileTaskAttachment)) {
        var $$x4 = 1
      } else if ((p instanceof $c_Lreactbuild_model_ProjectTaskAttachment)) {
        var $$x4 = 2
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_TaskTaskAttachment))) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_TaskAttachment($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "TaskTaskAttachment"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "ProjectTaskAttachment"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "FileTaskAttachment"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "CommunicationTaskAttachment"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$1
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$2 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4($thiz);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$2
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_TaskTaskAttachment(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$18 = $n(x0$7).Lreactbuild_model_TaskTaskAttachment__f_id;
        var target$macro$19 = $n(x0$7).Lreactbuild_model_TaskTaskAttachment__f_target;
        return new $c_Lshapeless_$colon$colon(id$macro$18, new $c_Lshapeless_$colon$colon(target$macro$19, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$16 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var target$macro$17 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_TaskTaskAttachment(id$macro$16, target$macro$17)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$20__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some($m_ju_UUID$().randomUUID__ju_UUID()), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$17 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    var this$18 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "id"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "target"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$34 = $m_s_$less$colon$less$();
    var ev$1 = this$34.s_$less$colon$less$__f_singleton;
    var this$35 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$35);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$39 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$39);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$43 = $m_s_$less$colon$less$();
    var ev$2 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$48);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$3 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$3
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$20 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5($thiz);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$20
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_ProjectTaskAttachment(x0$15$2);
      if ((x0$15 !== null)) {
        var id$macro$36 = $n(x0$15).Lreactbuild_model_ProjectTaskAttachment__f_id;
        var target$macro$37 = $n(x0$15).Lreactbuild_model_ProjectTaskAttachment__f_target;
        return new $c_Lshapeless_$colon$colon(id$macro$36, new $c_Lshapeless_$colon$colon(target$macro$37, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var id$macro$34 = $as_ju_UUID($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var target$macro$35 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_ProjectTaskAttachment(id$macro$34, target$macro$35)
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$38__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some($m_ju_UUID$().randomUUID__ju_UUID()), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$17 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    var this$18 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "id"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "target"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$34 = $m_s_$less$colon$less$();
    var ev$1 = this$34.s_$less$colon$less$__f_singleton;
    var this$35 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$35);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$39 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$39);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$43 = $m_s_$less$colon$less$();
    var ev$2 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$48);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$21 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$21
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$38 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6($thiz);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$38
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$39$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_model_FileTaskAttachment(x0$23$2);
      if ((x0$23 !== null)) {
        var id$macro$54 = $n(x0$23).Lreactbuild_model_FileTaskAttachment__f_id;
        var target$macro$55 = $n(x0$23).Lreactbuild_model_FileTaskAttachment__f_target;
        return new $c_Lshapeless_$colon$colon(id$macro$54, new $c_Lshapeless_$colon$colon(target$macro$55, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var id$macro$52 = $as_ju_UUID($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var target$macro$53 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_FileTaskAttachment(id$macro$52, target$macro$53)
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$56__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some($m_ju_UUID$().randomUUID__ju_UUID()), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$17 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    var this$18 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "id"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "target"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$34 = $m_s_$less$colon$less$();
    var ev$1 = this$34.s_$less$colon$less$__f_singleton;
    var this$35 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$35);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$39 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$39);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$43 = $m_s_$less$colon$less$();
    var ev$2 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$48);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$39 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$39
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$56$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$56 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7($thiz);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$56
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$57$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_model_CommunicationTaskAttachment(x0$31$2);
      if ((x0$31 !== null)) {
        var id$macro$72 = $n(x0$31).Lreactbuild_model_CommunicationTaskAttachment__f_id;
        var target$macro$73 = $n(x0$31).Lreactbuild_model_CommunicationTaskAttachment__f_target;
        return new $c_Lshapeless_$colon$colon(id$macro$72, new $c_Lshapeless_$colon$colon(target$macro$73, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var id$macro$70 = $as_ju_UUID($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$32).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var target$macro$71 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_CommunicationTaskAttachment(id$macro$70, target$macro$71)
          }
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$74__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some($m_ju_UUID$().randomUUID__ju_UUID()), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$17 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    var this$18 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "id"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "target"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$34 = $m_s_$less$colon$less$();
    var ev$1 = this$34.s_$less$colon$less$__f_singleton;
    var this$35 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$35);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$39 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$39);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$43 = $m_s_$less$colon$less$();
    var ev$2 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$48);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$57 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$57
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$74$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$74 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8($thiz);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$74
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$75$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_model_TaskTaskAttachment(x0$39$2);
      if ((x0$39 !== null)) {
        var id$macro$90 = $n(x0$39).Lreactbuild_model_TaskTaskAttachment__f_id;
        var target$macro$91 = $n(x0$39).Lreactbuild_model_TaskTaskAttachment__f_target;
        return new $c_Lshapeless_$colon$colon(id$macro$90, new $c_Lshapeless_$colon$colon(target$macro$91, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var id$macro$88 = $as_ju_UUID($n(x0$40).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$40).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var target$macro$89 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_TaskTaskAttachment(id$macro$88, target$macro$89)
          }
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$92__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "target"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$75 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$75
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$92$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$92 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9($thiz);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$92
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$93$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_model_ProjectTaskAttachment(x0$47$2);
      if ((x0$47 !== null)) {
        var id$macro$108 = $n(x0$47).Lreactbuild_model_ProjectTaskAttachment__f_id;
        var target$macro$109 = $n(x0$47).Lreactbuild_model_ProjectTaskAttachment__f_target;
        return new $c_Lshapeless_$colon$colon(id$macro$108, new $c_Lshapeless_$colon$colon(target$macro$109, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_$colon$colon(x0$48$2);
      if ((x0$48 !== null)) {
        var id$macro$106 = $as_ju_UUID($n(x0$48).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$48).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var target$macro$107 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_ProjectTaskAttachment(id$macro$106, target$macro$107)
          }
        }
      };
      throw new $c_s_MatchError(x0$48)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$110__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "target"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$93 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$93
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$110$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$110 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10($thiz);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$110
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$111$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      var x0$55 = $as_Lreactbuild_model_FileTaskAttachment(x0$55$2);
      if ((x0$55 !== null)) {
        var id$macro$126 = $n(x0$55).Lreactbuild_model_FileTaskAttachment__f_id;
        var target$macro$127 = $n(x0$55).Lreactbuild_model_FileTaskAttachment__f_target;
        return new $c_Lshapeless_$colon$colon(id$macro$126, new $c_Lshapeless_$colon$colon(target$macro$127, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$55)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      var x0$56 = $as_Lshapeless_$colon$colon(x0$56$2);
      if ((x0$56 !== null)) {
        var id$macro$124 = $as_ju_UUID($n(x0$56).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$56).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var target$macro$125 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_FileTaskAttachment(id$macro$124, target$macro$125)
          }
        }
      };
      throw new $c_s_MatchError(x0$56)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$128__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "target"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$111 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$111
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$128$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((32768 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$128 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11($thiz);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (32768 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$128
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$129$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((65536 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "target")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      var x0$63 = $as_Lreactbuild_model_CommunicationTaskAttachment(x0$63$2);
      if ((x0$63 !== null)) {
        var id$macro$144 = $n(x0$63).Lreactbuild_model_CommunicationTaskAttachment__f_id;
        var target$macro$145 = $n(x0$63).Lreactbuild_model_CommunicationTaskAttachment__f_target;
        return new $c_Lshapeless_$colon$colon(id$macro$144, new $c_Lshapeless_$colon$colon(target$macro$145, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$63)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      var x0$64 = $as_Lshapeless_$colon$colon(x0$64$2);
      if ((x0$64 !== null)) {
        var id$macro$142 = $as_ju_UUID($n(x0$64).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$64).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var target$macro$143 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_CommunicationTaskAttachment(id$macro$142, target$macro$143)
          }
        }
      };
      throw new $c_s_MatchError(x0$64)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$146__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "target"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$129 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (65536 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$129
}
function $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$146$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((131072 & $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$146 = new $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12($thiz);
    $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = (131072 | $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$146
}
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1() {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$20 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$21 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$38 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$39 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$56 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$57 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$74 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$75 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$92 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$93 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$110 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$111 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$128 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$129 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$146 = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype = new $h_O();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$1)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$2)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$3)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$20__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$20)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$21)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$38__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$38)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$39__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$39$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$39)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$56__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((128 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$56$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$56)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$57__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((256 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$57$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$57)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$74__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((512 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$74$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$74)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$75__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$75$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$75)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$92__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$92$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$92)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$93__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4096 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$93$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$93)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$110__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$110$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$110)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$111__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((16384 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$111$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$111)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$128__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((32768 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$128$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$128)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$129__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((65536 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$129$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$129)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.inst$macro$146__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((131072 & this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__inst$macro$146$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1__f_inst$macro$146)
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1;
/** @constructor */
function $c_Lreactbuild_model_TaskPerson$() {
  this.Lreactbuild_model_TaskPerson$__f_codecForTaskPerson = null;
  $n_Lreactbuild_model_TaskPerson$ = this;
  var inst$macro$36 = new $c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_TaskPerson$__f_codecForTaskPerson = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_TaskPerson$.prototype = new $h_O();
$c_Lreactbuild_model_TaskPerson$.prototype.constructor = $c_Lreactbuild_model_TaskPerson$;
/** @constructor */
function $h_Lreactbuild_model_TaskPerson$() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskPerson$.prototype = $c_Lreactbuild_model_TaskPerson$.prototype;
var $d_Lreactbuild_model_TaskPerson$ = new $TypeData().initClass({
  Lreactbuild_model_TaskPerson$: 0
}, false, "reactbuild.model.TaskPerson$", {
  Lreactbuild_model_TaskPerson$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskPerson$.prototype.$classData = $d_Lreactbuild_model_TaskPerson$;
var $n_Lreactbuild_model_TaskPerson$;
function $m_Lreactbuild_model_TaskPerson$() {
  if ((!$n_Lreactbuild_model_TaskPerson$)) {
    $n_Lreactbuild_model_TaskPerson$ = new $c_Lreactbuild_model_TaskPerson$()
  };
  return $n_Lreactbuild_model_TaskPerson$
}
function $p_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "role"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "user"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "added")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_TaskPerson(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$30 = $n(x0$7).Lreactbuild_model_TaskPerson__f_id;
        var role$macro$31 = $n(x0$7).Lreactbuild_model_TaskPerson__f_role;
        var user$macro$32 = $n(x0$7).Lreactbuild_model_TaskPerson__f_user;
        var added$macro$33 = $n(x0$7).Lreactbuild_model_TaskPerson__f_added;
        return new $c_Lshapeless_$colon$colon(id$macro$30, new $c_Lshapeless_$colon$colon(role$macro$31, new $c_Lshapeless_$colon$colon(user$macro$32, new $c_Lshapeless_$colon$colon(added$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$26 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var role$macro$27 = $as_Lreactbuild_model_TaskRole($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var user$macro$28 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var added$macro$29 = $as_Ljava_time_Instant($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_TaskPerson(id$macro$26, role$macro$27, user$macro$28, added$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "added"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "user"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "role"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_TaskPerson$(), $m_ju_UUID$().randomUUID__ju_UUID())), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$25 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "id"));
    var this$26 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "role"));
    var this$27 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "user"));
    var this$28 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "added")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "id"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "role"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "user"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "added"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$52 = $m_s_$less$colon$less$();
    var ev$1 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$61);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$65 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$65);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$69 = $m_s_$less$colon$less$();
    var ev$2 = this$69.s_$less$colon$less$__f_singleton;
    var this$70 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$82);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_inst$macro$1
}
function $p_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_inst$macro$34 = new $c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3($thiz);
    $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1() {
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_inst$macro$34 = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1.prototype = new $h_O();
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1.prototype.constructor = $c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1;
/** @constructor */
function $h_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1.prototype = $c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1.prototype;
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_inst$macro$1)
});
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1__f_inst$macro$34)
});
var $d_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1 = new $TypeData().initClass({
  Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1: 0
}, false, "reactbuild.model.TaskPerson$anon$lazy$macro$35$1", {
  Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1.prototype.$classData = $d_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1;
function $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "From"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "To")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_TaskRole(p$2);
      var $$x3 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_model_TaskRole$From$())) {
        var $$x2 = 0
      } else {
        if ((p !== $m_Lreactbuild_model_TaskRole$To$())) {
          throw new $c_s_MatchError(p)
        };
        var $$x2 = 1
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x3).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x2, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_TaskRole($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "To"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "From"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$1
}
function $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$2 = new $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1($thiz);
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$2
}
function $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_model_TaskRole$To$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_model_TaskRole$To$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$3
}
function $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$4
}
function $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_model_TaskRole$From$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_model_TaskRole$From$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$5
}
function $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_model_TaskRole$To$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_model_TaskRole$To$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$7__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$6 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$6
}
function $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$7 = new $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2($thiz);
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$7
}
function $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((128 & $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_model_TaskRole$From$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_model_TaskRole$From$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$7__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$8 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0 = (((128 | $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$8
}
/** @constructor */
function $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1() {
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$4 = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$5 = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$6 = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$7 = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$8 = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype = new $h_O();
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.constructor = $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1;
/** @constructor */
function $h_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype = $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype;
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$1)
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$2)
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((4 & this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$3)
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((8 & this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$4)
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((16 & this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$5)
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.inst$macro$6__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((32 & this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$6)
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.inst$macro$7__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((64 & this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$7)
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((128 & this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1__f_inst$macro$8)
});
var $d_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1 = new $TypeData().initClass({
  Lreactbuild_model_TaskRole$anon$lazy$macro$9$1: 0
}, false, "reactbuild.model.TaskRole$anon$lazy$macro$9$1", {
  Lreactbuild_model_TaskRole$anon$lazy$macro$9$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1.prototype.$classData = $d_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1;
/** @constructor */
function $c_Lreactbuild_model_Term$() {
  this.Lreactbuild_model_Term$__f_codecForTerm = null;
  $n_Lreactbuild_model_Term$ = this;
  var inst$macro$36 = new $c_Lreactbuild_model_Term$anon$lazy$macro$35$4().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_Term$__f_codecForTerm = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_Term$.prototype = new $h_O();
$c_Lreactbuild_model_Term$.prototype.constructor = $c_Lreactbuild_model_Term$;
/** @constructor */
function $h_Lreactbuild_model_Term$() {
  /*<skip>*/
}
$h_Lreactbuild_model_Term$.prototype = $c_Lreactbuild_model_Term$.prototype;
var $d_Lreactbuild_model_Term$ = new $TypeData().initClass({
  Lreactbuild_model_Term$: 0
}, false, "reactbuild.model.Term$", {
  Lreactbuild_model_Term$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Term$.prototype.$classData = $d_Lreactbuild_model_Term$;
var $n_Lreactbuild_model_Term$;
function $m_Lreactbuild_model_Term$() {
  if ((!$n_Lreactbuild_model_Term$)) {
    $n_Lreactbuild_model_Term$ = new $c_Lreactbuild_model_Term$()
  };
  return $n_Lreactbuild_model_Term$
}
function $p_Lreactbuild_model_Term$anon$lazy$macro$35$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "label"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "parent")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_Term(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$30 = $n(x0$7).Lreactbuild_model_Term__f__id;
        var organization$macro$31 = $n(x0$7).Lreactbuild_model_Term__f_organization;
        var label$macro$32 = $n(x0$7).Lreactbuild_model_Term__f_label;
        var parent$macro$33 = $n(x0$7).Lreactbuild_model_Term__f_parent;
        return new $c_Lshapeless_$colon$colon(_id$macro$30, new $c_Lshapeless_$colon$colon(organization$macro$31, new $c_Lshapeless_$colon$colon(label$macro$32, new $c_Lshapeless_$colon$colon(parent$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$26 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$27 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var label$macro$28 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var parent$macro$29 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_Term(_id$macro$26, organization$macro$27, label$macro$28, parent$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "label"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_Term$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$26 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "_id"));
    var this$27 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "organization"));
    var this$28 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "label"));
    var this$29 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "parent")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "_id"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "organization"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$44 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "label"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "parent"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$53 = $m_s_$less$colon$less$();
    var ev$1 = this$53.s_$less$colon$less$__f_singleton;
    var this$54 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$54);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$58 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$66);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$70 = $m_s_$less$colon$less$();
    var ev$2 = this$70.s_$less$colon$less$__f_singleton;
    var this$71 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$71);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$75 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$75);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$79 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$83);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_inst$macro$1
}
function $p_Lreactbuild_model_Term$anon$lazy$macro$35$4__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_inst$macro$34 = new $c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17($thiz);
    $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_model_Term$anon$lazy$macro$35$4() {
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_inst$macro$1 = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_inst$macro$34 = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_bitmap$0 = 0
}
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4.prototype = new $h_O();
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4.prototype.constructor = $c_Lreactbuild_model_Term$anon$lazy$macro$35$4;
/** @constructor */
function $h_Lreactbuild_model_Term$anon$lazy$macro$35$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_Term$anon$lazy$macro$35$4.prototype = $c_Lreactbuild_model_Term$anon$lazy$macro$35$4.prototype;
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Term$anon$lazy$macro$35$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_inst$macro$1)
});
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_Term$anon$lazy$macro$35$4__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_Term$anon$lazy$macro$35$4__f_inst$macro$34)
});
var $d_Lreactbuild_model_Term$anon$lazy$macro$35$4 = new $TypeData().initClass({
  Lreactbuild_model_Term$anon$lazy$macro$35$4: 0
}, false, "reactbuild.model.Term$anon$lazy$macro$35$4", {
  Lreactbuild_model_Term$anon$lazy$macro$35$4: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4.prototype.$classData = $d_Lreactbuild_model_Term$anon$lazy$macro$35$4;
/** @constructor */
function $c_Lreactbuild_model_TimeReport$() {
  this.Lreactbuild_model_TimeReport$__f_codecForTimeReport = null;
  $n_Lreactbuild_model_TimeReport$ = this;
  var inst$macro$60 = new $c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$60));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_TimeReport$__f_codecForTimeReport = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_TimeReport$.prototype = new $h_O();
$c_Lreactbuild_model_TimeReport$.prototype.constructor = $c_Lreactbuild_model_TimeReport$;
/** @constructor */
function $h_Lreactbuild_model_TimeReport$() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReport$.prototype = $c_Lreactbuild_model_TimeReport$.prototype;
var $d_Lreactbuild_model_TimeReport$ = new $TypeData().initClass({
  Lreactbuild_model_TimeReport$: 0
}, false, "reactbuild.model.TimeReport$", {
  Lreactbuild_model_TimeReport$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TimeReport$.prototype.$classData = $d_Lreactbuild_model_TimeReport$;
var $n_Lreactbuild_model_TimeReport$;
function $m_Lreactbuild_model_TimeReport$() {
  if ((!$n_Lreactbuild_model_TimeReport$)) {
    $n_Lreactbuild_model_TimeReport$ = new $c_Lreactbuild_model_TimeReport$()
  };
  return $n_Lreactbuild_model_TimeReport$
}
function $p_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "date"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "resource"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "buildingSite"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "buildingStage"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "duration"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "comments")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_TimeReport(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$51 = $n(x0$7).Lreactbuild_model_TimeReport__f__id;
        var date$macro$52 = $n(x0$7).Lreactbuild_model_TimeReport__f_date;
        var resource$macro$53 = $n(x0$7).Lreactbuild_model_TimeReport__f_resource;
        var buildingSite$macro$54 = $n(x0$7).Lreactbuild_model_TimeReport__f_buildingSite;
        var buildingStage$macro$55 = $n(x0$7).Lreactbuild_model_TimeReport__f_buildingStage;
        var duration$macro$56 = $n(x0$7).Lreactbuild_model_TimeReport__f_duration;
        var comments$macro$57 = $n(x0$7).Lreactbuild_model_TimeReport__f_comments;
        return new $c_Lshapeless_$colon$colon(_id$macro$51, new $c_Lshapeless_$colon$colon(date$macro$52, new $c_Lshapeless_$colon$colon(resource$macro$53, new $c_Lshapeless_$colon$colon(buildingSite$macro$54, new $c_Lshapeless_$colon$colon(buildingStage$macro$55, new $c_Lshapeless_$colon$colon(duration$macro$56, new $c_Lshapeless_$colon$colon(comments$macro$57, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$44 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var date$macro$45 = $as_Ljava_time_LocalDate($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var resource$macro$46 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var buildingSite$macro$47 = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var buildingStage$macro$48 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var duration$macro$49 = $as_Lreactbuild_model_Duration($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var comments$macro$50 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_model_TimeReport(_id$macro$44, date$macro$45, resource$macro$46, buildingSite$macro$47, buildingStage$macro$48, duration$macro$49, comments$macro$50)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "comments"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "duration"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "buildingStage"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "buildingSite"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "resource"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_TimeReport$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_TimeReport$(), new $c_Lreactbuild_model_Duration(0.0))), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_TimeReport$(), $m_s_None$())), $m_Lshapeless_HNil$())))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$40 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "_id"));
    var this$41 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "date"));
    var this$42 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "resource"));
    var this$43 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "buildingSite"));
    var this$44 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "buildingStage"));
    var this$45 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "duration"));
    var this$46 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "comments")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$6);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "_id"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "duration"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "comments"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$66 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "_id"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$68 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "date"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$70 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$70, "resource"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$72 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$72, "buildingSite"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$74 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "buildingStage"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$76 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "duration"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$78 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "comments"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$16);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$88 = $m_s_$less$colon$less$();
    var ev$1 = this$88.s_$less$colon$less$__f_singleton;
    var this$89 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$89);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$93 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$93);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$97 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$97);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$101 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$113);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$117 = $m_s_$less$colon$less$();
    var ev$2 = this$117.s_$less$colon$less$__f_singleton;
    var this$118 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$118);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$122 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$122);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$126 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$126);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$130 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$130);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$134 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$134);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$138 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$138);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$142 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$142);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_inst$macro$1
}
function $p_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_inst$macro$58 = new $c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9($thiz);
    $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1() {
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_inst$macro$58 = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1.prototype = new $h_O();
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1.prototype.constructor = $c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1;
/** @constructor */
function $h_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1.prototype = $c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1.prototype;
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_inst$macro$1)
});
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1.prototype.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1__f_inst$macro$58)
});
var $d_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1 = new $TypeData().initClass({
  Lreactbuild_model_TimeReport$anon$lazy$macro$59$1: 0
}, false, "reactbuild.model.TimeReport$anon$lazy$macro$59$1", {
  Lreactbuild_model_TimeReport$anon$lazy$macro$59$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1.prototype.$classData = $d_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1;
/** @constructor */
function $c_Lreactbuild_model_TimeReportEvent$() {
  this.Lreactbuild_model_TimeReportEvent$__f_codecForTimeReportEvent = null;
  $n_Lreactbuild_model_TimeReportEvent$ = this;
  var inst$macro$44 = new $c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_TimeReportEvent$__f_codecForTimeReportEvent = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_TimeReportEvent$.prototype = new $h_O();
$c_Lreactbuild_model_TimeReportEvent$.prototype.constructor = $c_Lreactbuild_model_TimeReportEvent$;
/** @constructor */
function $h_Lreactbuild_model_TimeReportEvent$() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReportEvent$.prototype = $c_Lreactbuild_model_TimeReportEvent$.prototype;
$c_Lreactbuild_model_TimeReportEvent$.prototype.apply$default$3__Ljava_time_LocalDateTime = (function() {
  var aliasMap = $m_Ljava_time_ZoneId$().SHORT_IDS__ju_Map();
  var zone = $m_Ljava_time_ZoneId$().of__T__ju_Map__Ljava_time_ZoneId("ECT", aliasMap);
  return $m_Ljava_time_LocalDateTime$().now__Ljava_time_ZoneId__Ljava_time_LocalDateTime(zone)
});
var $d_Lreactbuild_model_TimeReportEvent$ = new $TypeData().initClass({
  Lreactbuild_model_TimeReportEvent$: 0
}, false, "reactbuild.model.TimeReportEvent$", {
  Lreactbuild_model_TimeReportEvent$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TimeReportEvent$.prototype.$classData = $d_Lreactbuild_model_TimeReportEvent$;
var $n_Lreactbuild_model_TimeReportEvent$;
function $m_Lreactbuild_model_TimeReportEvent$() {
  if ((!$n_Lreactbuild_model_TimeReportEvent$)) {
    $n_Lreactbuild_model_TimeReportEvent$ = new $c_Lreactbuild_model_TimeReportEvent$()
  };
  return $n_Lreactbuild_model_TimeReportEvent$
}
function $p_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "resource"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "date"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "ignore"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "manuallyAdded")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_TimeReportEvent(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$37 = $n(x0$7).Lreactbuild_model_TimeReportEvent__f__id;
        var resource$macro$38 = $n(x0$7).Lreactbuild_model_TimeReportEvent__f_resource;
        var date$macro$39 = $n(x0$7).Lreactbuild_model_TimeReportEvent__f_date;
        var ignore$macro$40 = $n(x0$7).Lreactbuild_model_TimeReportEvent__f_ignore;
        var manuallyAdded$macro$41 = $n(x0$7).Lreactbuild_model_TimeReportEvent__f_manuallyAdded;
        return new $c_Lshapeless_$colon$colon(_id$macro$37, new $c_Lshapeless_$colon$colon(resource$macro$38, new $c_Lshapeless_$colon$colon(date$macro$39, new $c_Lshapeless_$colon$colon(ignore$macro$40, new $c_Lshapeless_$colon$colon(manuallyAdded$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$32 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var resource$macro$33 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var date$macro$34 = $as_Ljava_time_LocalDateTime($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var ignore$macro$35 = $uZ($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var manuallyAdded$macro$36 = $uZ($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_model_TimeReportEvent(_id$macro$32, resource$macro$33, date$macro$34, ignore$macro$35, manuallyAdded$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "manuallyAdded"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "ignore"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "resource"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_TimeReportEvent$(), $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID()))), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_Lreactbuild_model_TimeReportEvent$().apply$default$3__Ljava_time_LocalDateTime()), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_TimeReportEvent$(), false)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_TimeReportEvent$(), false)), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$30 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "_id"));
    var this$31 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "resource"));
    var this$32 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "date"));
    var this$33 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "ignore"));
    var this$34 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "manuallyAdded")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "_id"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "date"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "ignore"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "manuallyAdded"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "_id"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "resource"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "date"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "ignore"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "manuallyAdded"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$71 = $m_s_$less$colon$less$();
    var ev$1 = this$71.s_$less$colon$less$__f_singleton;
    var this$72 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$72);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$76 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$76);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$80 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$88);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$92 = $m_s_$less$colon$less$();
    var ev$2 = this$92.s_$less$colon$less$__f_singleton;
    var this$93 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$93);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$97 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$97);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$101 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$109);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_inst$macro$1
}
function $p_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_inst$macro$42 = new $c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10($thiz);
    $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2() {
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_inst$macro$1 = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_inst$macro$42 = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_bitmap$0 = 0
}
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2.prototype = new $h_O();
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2.prototype.constructor = $c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2;
/** @constructor */
function $h_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2.prototype = $c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2.prototype;
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_inst$macro$1)
});
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2__f_inst$macro$42)
});
var $d_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2 = new $TypeData().initClass({
  Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2: 0
}, false, "reactbuild.model.TimeReportEvent$anon$lazy$macro$43$2", {
  Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2.prototype.$classData = $d_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2;
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_codec_DerivedAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "CursorLocationUpdate"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Ping")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_ToClient(p$2);
      var $$x3 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_model_CursorLocationUpdate)) {
        var $$x2 = 0
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_Ping))) {
          throw new $c_s_MatchError(p)
        };
        var $$x2 = 1
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x3).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x2, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_ToClient($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "Ping"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "CursorLocationUpdate"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$1 = new $c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1(codec, gen$1);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$1
}
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$2$lzycompute__Lio_circe_generic_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$2 = new $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4($thiz);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$2
}
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$3$lzycompute__Lio_circe_generic_decoding_DerivedDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "origin")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_model_Ping(x0$3$2);
      if ((x0$3 !== null)) {
        var origin$macro$7 = $n(x0$3).Lreactbuild_model_Ping__f_origin;
        return new $c_Lshapeless_$colon$colon(origin$macro$7, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var origin$macro$6 = $as_ju_UUID($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$4).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_Ping(origin$macro$6)
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "origin"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$8__Lio_circe_generic_decoding_ReprDecoder()));
    var decode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$3 = new $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1(decode, gen$1);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$3
}
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$8$lzycompute__Lio_circe_generic_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$8 = new $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5($thiz);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$8
}
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$9$lzycompute__Lio_circe_generic_decoding_DerivedDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "origin"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "user"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "projectRef"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "x"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "y")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_CursorLocationUpdate(x0$7$2);
      if ((x0$7 !== null)) {
        var origin$macro$25 = $n(x0$7).Lreactbuild_model_CursorLocationUpdate__f_origin;
        var user$macro$26 = $n(x0$7).Lreactbuild_model_CursorLocationUpdate__f_user;
        var projectRef$macro$27 = $n(x0$7).Lreactbuild_model_CursorLocationUpdate__f_projectRef;
        var x$macro$28 = $n(x0$7).Lreactbuild_model_CursorLocationUpdate__f_x;
        var y$macro$29 = $n(x0$7).Lreactbuild_model_CursorLocationUpdate__f_y;
        return new $c_Lshapeless_$colon$colon(origin$macro$25, new $c_Lshapeless_$colon$colon(user$macro$26, new $c_Lshapeless_$colon$colon(projectRef$macro$27, new $c_Lshapeless_$colon$colon(x$macro$28, new $c_Lshapeless_$colon$colon(y$macro$29, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var origin$macro$20 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var user$macro$21 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var projectRef$macro$22 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var x$macro$23 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var y$macro$24 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_model_CursorLocationUpdate(origin$macro$20, user$macro$21, projectRef$macro$22, x$macro$23, y$macro$24)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "projectRef"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "user"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "origin"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$30__Lio_circe_generic_decoding_ReprDecoder()));
    var decode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$9 = new $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1(decode, gen$1);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$9
}
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$30$lzycompute__Lio_circe_generic_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$30 = new $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6($thiz);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$30
}
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$31$lzycompute__Lio_circe_generic_encoding_DerivedAsObjectEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "origin")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_model_Ping(x0$11$2);
      if ((x0$11 !== null)) {
        var origin$macro$35 = $n(x0$11).Lreactbuild_model_Ping__f_origin;
        return new $c_Lshapeless_$colon$colon(origin$macro$35, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
      if ((x0$12 !== null)) {
        var origin$macro$34 = $as_ju_UUID($n(x0$12).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$12).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_Ping(origin$macro$34)
        }
      };
      throw new $c_s_MatchError(x0$12)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "origin"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$36__Lio_circe_generic_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$31 = new $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1(encode, gen$1);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$31
}
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$36$lzycompute__Lio_circe_generic_encoding_ReprAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$36 = new $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7($thiz);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$36
}
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$37$lzycompute__Lio_circe_generic_encoding_DerivedAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "origin"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "user"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "projectRef"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "x"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "y")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_CursorLocationUpdate(x0$15$2);
      if ((x0$15 !== null)) {
        var origin$macro$53 = $n(x0$15).Lreactbuild_model_CursorLocationUpdate__f_origin;
        var user$macro$54 = $n(x0$15).Lreactbuild_model_CursorLocationUpdate__f_user;
        var projectRef$macro$55 = $n(x0$15).Lreactbuild_model_CursorLocationUpdate__f_projectRef;
        var x$macro$56 = $n(x0$15).Lreactbuild_model_CursorLocationUpdate__f_x;
        var y$macro$57 = $n(x0$15).Lreactbuild_model_CursorLocationUpdate__f_y;
        return new $c_Lshapeless_$colon$colon(origin$macro$53, new $c_Lshapeless_$colon$colon(user$macro$54, new $c_Lshapeless_$colon$colon(projectRef$macro$55, new $c_Lshapeless_$colon$colon(x$macro$56, new $c_Lshapeless_$colon$colon(y$macro$57, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var origin$macro$48 = $as_ju_UUID($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var user$macro$49 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var projectRef$macro$50 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var x$macro$51 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var y$macro$52 = $uD($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_model_CursorLocationUpdate(origin$macro$48, user$macro$49, projectRef$macro$50, x$macro$51, y$macro$52)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "y"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "x"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "projectRef"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "user"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "origin"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$37 = new $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1(encode, gen$1);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$37
}
function $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$58 = new $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8($thiz);
    $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1() {
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$8 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$9 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$30 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$31 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$36 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$37 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$58 = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype = new $h_O();
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.constructor = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1;
/** @constructor */
function $h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype;
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$1__Lio_circe_generic_codec_DerivedAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_codec_DerivedAsObjectCodec(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$1)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$2__Lio_circe_generic_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$2$lzycompute__Lio_circe_generic_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$2)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$3__Lio_circe_generic_decoding_DerivedDecoder = (function() {
  return (((4 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$3$lzycompute__Lio_circe_generic_decoding_DerivedDecoder(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$3)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$8__Lio_circe_generic_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$8$lzycompute__Lio_circe_generic_decoding_ReprDecoder(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$8)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$9__Lio_circe_generic_decoding_DerivedDecoder = (function() {
  return (((16 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$9$lzycompute__Lio_circe_generic_decoding_DerivedDecoder(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$9)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$30__Lio_circe_generic_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$30$lzycompute__Lio_circe_generic_decoding_ReprDecoder(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$30)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$31__Lio_circe_generic_encoding_DerivedAsObjectEncoder = (function() {
  return (((64 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$31$lzycompute__Lio_circe_generic_encoding_DerivedAsObjectEncoder(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$31)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$36__Lio_circe_generic_encoding_ReprAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$36$lzycompute__Lio_circe_generic_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$36)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$37__Lio_circe_generic_encoding_DerivedAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$37$lzycompute__Lio_circe_generic_encoding_DerivedAsObjectEncoder(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$37)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.inst$macro$58__Lio_circe_generic_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_ToClient$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1__f_inst$macro$58)
});
var $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1 = new $TypeData().initClass({
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1: 0
}, false, "reactbuild.model.ToClient$anon$lazy$macro$59$1", {
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1.prototype.$classData = $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1;
/** @constructor */
function $c_Lreactbuild_model_WithChildren$() {
  /*<skip>*/
}
$c_Lreactbuild_model_WithChildren$.prototype = new $h_O();
$c_Lreactbuild_model_WithChildren$.prototype.constructor = $c_Lreactbuild_model_WithChildren$;
/** @constructor */
function $h_Lreactbuild_model_WithChildren$() {
  /*<skip>*/
}
$h_Lreactbuild_model_WithChildren$.prototype = $c_Lreactbuild_model_WithChildren$.prototype;
$c_Lreactbuild_model_WithChildren$.prototype.encodeWithChildren__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder = (function(encP, encC) {
  $m_Lio_circe_Encoder$();
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Lreactbuild_model_WithChildren(c$2);
    var this$14 = $m_Lio_circe_Json$();
    var value = $n(c).Lreactbuild_model_WithChildren__f_item;
    var y = $n(encC).apply__O__Lio_circe_Json(value);
    var $$x1 = $ct_T2__O__O__(new $c_T2(), "p", y);
    var value$1 = $n(c).Lreactbuild_model_WithChildren__f_children;
    $m_Lio_circe_Encoder$();
    var encoder = new $c_Lio_circe_Encoder$$anon$25(encP);
    var y$1 = $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(encoder, value$1);
    var array = [$$x1, $ct_T2__O__O__(new $c_T2(), "c", y$1)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return this$14.fromFields__sc_Iterable__Lio_circe_Json(fields)
  }));
  return new $c_Lio_circe_Encoder$$anon$3(f)
});
$c_Lreactbuild_model_WithChildren$.prototype.decodeWithChildren__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder = (function(decP, decC) {
  $m_Lio_circe_Decoder$();
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Lio_circe_HCursor(c$2);
    var this$2 = $n($n(c).downField__T__Lio_circe_ACursor("p"));
    var this$3 = $n($n(decP).tryDecode__Lio_circe_ACursor__s_util_Either(this$2));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var this$5 = $n($n(c).downField__T__Lio_circe_ACursor("c"));
      $m_Lio_circe_Decoder$();
      var d = new $c_Lio_circe_Decoder$$anon$44(decC);
      var this$6 = $n($f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(d, this$5));
      if ((this$6 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$6);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var children = $as_sci_List(b$1);
        return new $c_s_util_Right(new $c_Lreactbuild_model_WithChildren(b, children))
      } else {
        return this$6
      }
    } else {
      return this$3
    }
  }));
  return new $c_Lio_circe_Decoder$$anon$16(f)
});
var $d_Lreactbuild_model_WithChildren$ = new $TypeData().initClass({
  Lreactbuild_model_WithChildren$: 0
}, false, "reactbuild.model.WithChildren$", {
  Lreactbuild_model_WithChildren$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_WithChildren$.prototype.$classData = $d_Lreactbuild_model_WithChildren$;
var $n_Lreactbuild_model_WithChildren$;
function $m_Lreactbuild_model_WithChildren$() {
  if ((!$n_Lreactbuild_model_WithChildren$)) {
    $n_Lreactbuild_model_WithChildren$ = new $c_Lreactbuild_model_WithChildren$()
  };
  return $n_Lreactbuild_model_WithChildren$
}
/** @constructor */
function $c_Lreactbuild_model_process_PartialDate$() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_PartialDate$.prototype = new $h_O();
$c_Lreactbuild_model_process_PartialDate$.prototype.constructor = $c_Lreactbuild_model_process_PartialDate$;
/** @constructor */
function $h_Lreactbuild_model_process_PartialDate$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_PartialDate$.prototype = $c_Lreactbuild_model_process_PartialDate$.prototype;
$c_Lreactbuild_model_process_PartialDate$.prototype.encodePartialDate__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_model_process_PartialDate(v$2);
    $m_Lio_circe_Json$();
    var this$2 = $n($n(v).Lreactbuild_model_process_PartialDate__f_date);
    var value = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$2, $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime());
    var encoder = $m_Lio_circe_Encoder$().encodeLocalDateTime__Lio_circe_Encoder();
    var $$x1 = $n(encoder).apply__O__Lio_circe_Json(value);
    var this$5 = $n($n($n(v).Lreactbuild_model_process_PartialDate__f_date).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)));
    var value$1 = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$5, $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime());
    var encoder$1 = $m_Lio_circe_Encoder$().encodeLocalDateTime__Lio_circe_Encoder();
    var array = [$$x1, $n(encoder$1).apply__O__Lio_circe_Json(value$1)];
    var values = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_Lio_circe_Json$JArray($m_sci_Vector$().from__sc_IterableOnce__sci_Vector(values))
  }));
  return new $c_Lio_circe_Encoder$$anon$3(f)
});
$c_Lreactbuild_model_process_PartialDate$.prototype.decodePartialDate__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Lio_circe_HCursor(c$2);
    var arr = $n(c).downArray__Lio_circe_ACursor();
    var this$2 = $n(arr);
    var d = $m_Lio_circe_Decoder$().decodeLocalDateTime__Lio_circe_Decoder();
    var this$3 = $n($n(d).tryDecode__Lio_circe_ACursor__s_util_Either(this$2));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var start = $as_Ljava_time_LocalDateTime(b);
      var this$4 = $n($n(arr).right__Lio_circe_ACursor());
      var d$1 = $m_Lio_circe_Decoder$().decodeLocalDateTime__Lio_circe_Decoder();
      var this$5 = $n($n(d$1).tryDecode__Lio_circe_ACursor__s_util_Either(this$4));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$5);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        $as_Ljava_time_LocalDateTime(b$1);
        var this$6 = $n(start);
        return new $c_s_util_Right(new $c_Lreactbuild_model_process_PartialDate(this$6.Ljava_time_LocalDateTime__f_date))
      } else {
        return this$5
      }
    } else {
      return this$3
    }
  }));
  return new $c_Lio_circe_Decoder$$anon$16(f)
});
var $d_Lreactbuild_model_process_PartialDate$ = new $TypeData().initClass({
  Lreactbuild_model_process_PartialDate$: 0
}, false, "reactbuild.model.process.PartialDate$", {
  Lreactbuild_model_process_PartialDate$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_PartialDate$.prototype.$classData = $d_Lreactbuild_model_process_PartialDate$;
var $n_Lreactbuild_model_process_PartialDate$;
function $m_Lreactbuild_model_process_PartialDate$() {
  if ((!$n_Lreactbuild_model_process_PartialDate$)) {
    $n_Lreactbuild_model_process_PartialDate$ = new $c_Lreactbuild_model_process_PartialDate$()
  };
  return $n_Lreactbuild_model_process_PartialDate$
}
/** @constructor */
function $c_Lreactbuild_model_process_Process$() {
  this.Lreactbuild_model_process_Process$__f_codecForProcess = null;
  $n_Lreactbuild_model_process_Process$ = this;
  var inst$macro$36 = new $c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_process_Process$__f_codecForProcess = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_process_Process$.prototype = new $h_O();
$c_Lreactbuild_model_process_Process$.prototype.constructor = $c_Lreactbuild_model_process_Process$;
/** @constructor */
function $h_Lreactbuild_model_process_Process$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_Process$.prototype = $c_Lreactbuild_model_process_Process$.prototype;
var $d_Lreactbuild_model_process_Process$ = new $TypeData().initClass({
  Lreactbuild_model_process_Process$: 0
}, false, "reactbuild.model.process.Process$", {
  Lreactbuild_model_process_Process$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_Process$.prototype.$classData = $d_Lreactbuild_model_process_Process$;
var $n_Lreactbuild_model_process_Process$;
function $m_Lreactbuild_model_process_Process$() {
  if ((!$n_Lreactbuild_model_process_Process$)) {
    $n_Lreactbuild_model_process_Process$ = new $c_Lreactbuild_model_process_Process$()
  };
  return $n_Lreactbuild_model_process_Process$
}
function $p_Lreactbuild_model_process_Process$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "elements")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_process_Process(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$30 = $n(x0$7).Lreactbuild_model_process_Process__f__id;
        var organization$macro$31 = $n(x0$7).Lreactbuild_model_process_Process__f_organization;
        var name$macro$32 = $n(x0$7).Lreactbuild_model_process_Process__f_name;
        var elements$macro$33 = $n(x0$7).Lreactbuild_model_process_Process__f_elements;
        return new $c_Lshapeless_$colon$colon(_id$macro$30, new $c_Lshapeless_$colon$colon(organization$macro$31, new $c_Lshapeless_$colon$colon(name$macro$32, new $c_Lshapeless_$colon$colon(elements$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$26 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$27 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$28 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var elements$macro$29 = $as_sci_List($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_process_Process(_id$macro$26, organization$macro$27, name$macro$28, elements$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "elements"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_process_Process$(), "")), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_model_process_Process$(), $m_s_package$().s_package$__f_Nil)), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$25 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "_id"));
    var this$26 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "organization"));
    var this$27 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "name"));
    var this$28 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "elements")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "name"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "elements"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "_id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$44 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "organization"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$48 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "elements"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$55 = $m_s_$less$colon$less$();
    var ev$1 = this$55.s_$less$colon$less$__f_singleton;
    var this$56 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$56);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$60 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$60);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$64 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$64);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$68 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$68);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$72 = $m_s_$less$colon$less$();
    var ev$2 = this$72.s_$less$colon$less$__f_singleton;
    var this$73 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$73);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$77 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$77);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$81 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$81);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$85 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$85);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_inst$macro$1
}
function $p_Lreactbuild_model_process_Process$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_inst$macro$34 = new $c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26($thiz);
    $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1() {
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_inst$macro$34 = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1.prototype = new $h_O();
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1.prototype.constructor = $c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1;
/** @constructor */
function $h_Lreactbuild_model_process_Process$anon$lazy$macro$35$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_Process$anon$lazy$macro$35$1.prototype = $c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1.prototype;
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_Process$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_inst$macro$1)
});
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_Process$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1__f_inst$macro$34)
});
var $d_Lreactbuild_model_process_Process$anon$lazy$macro$35$1 = new $TypeData().initClass({
  Lreactbuild_model_process_Process$anon$lazy$macro$35$1: 0
}, false, "reactbuild.model.process.Process$anon$lazy$macro$35$1", {
  Lreactbuild_model_process_Process$anon$lazy$macro$35$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1.prototype.$classData = $d_Lreactbuild_model_process_Process$anon$lazy$macro$35$1;
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ProcessEdge"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "ProcessNode")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_process_ProcessElement(p$2);
      var $$x3 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_model_process_ProcessEdge)) {
        var $$x2 = 0
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_process_ProcessNode))) {
          throw new $c_s_MatchError(p)
        };
        var $$x2 = 1
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x3).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x2, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_process_ProcessElement($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "ProcessNode"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "ProcessEdge"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$1
}
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$2 = new $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1($thiz);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$2
}
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var $$x13 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "name"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "details")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_process_ProcessNode(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$25 = $n(x0$7).Lreactbuild_model_process_ProcessNode__f_id;
        var name$macro$26 = $n(x0$7).Lreactbuild_model_process_ProcessNode__f_name;
        var details$macro$27 = $n(x0$7).Lreactbuild_model_process_ProcessNode__f_details;
        return new $c_Lshapeless_$colon$colon(id$macro$25, new $c_Lshapeless_$colon$colon(name$macro$26, new $c_Lshapeless_$colon$colon(details$macro$27, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$22 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var name$macro$23 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var details$macro$24 = $as_Lreactbuild_model_process_ProcessNodeDetails($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_model_process_ProcessNode(id$macro$22, name$macro$23, details$macro$24)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var $$x12 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$28__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x9 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(""), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "id"));
    var this$21 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "name"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "details")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var $$x8 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "name"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "id"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "details"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$42 = $m_s_$less$colon$less$();
    var ev$1 = this$42.s_$less$colon$less$__f_singleton;
    var this$43 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$43);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$47 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$47);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$51 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$51);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$55 = $m_s_$less$colon$less$();
    var ev$2 = this$55.s_$less$colon$less$__f_singleton;
    var this$56 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$56);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$60 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$60);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$64 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$64);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$3 = $n($$x13).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x12, $$x9, $$x8, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3));
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$3
}
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$28$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$28 = new $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2($thiz);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$28
}
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$29$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var $$x15 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "name"));
    var this$3 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "sourceRef"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "targetRef")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_process_ProcessEdge(x0$15$2);
      if ((x0$15 !== null)) {
        var id$macro$58 = $n(x0$15).Lreactbuild_model_process_ProcessEdge__f_id;
        var name$macro$59 = $n(x0$15).Lreactbuild_model_process_ProcessEdge__f_name;
        var sourceRef$macro$60 = $n(x0$15).Lreactbuild_model_process_ProcessEdge__f_sourceRef;
        var targetRef$macro$61 = $n(x0$15).Lreactbuild_model_process_ProcessEdge__f_targetRef;
        return new $c_Lshapeless_$colon$colon(id$macro$58, new $c_Lshapeless_$colon$colon(name$macro$59, new $c_Lshapeless_$colon$colon(sourceRef$macro$60, new $c_Lshapeless_$colon$colon(targetRef$macro$61, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var id$macro$54 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var name$macro$55 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var sourceRef$macro$56 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var targetRef$macro$57 = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_process_ProcessEdge(id$macro$54, name$macro$55, sourceRef$macro$56, targetRef$macro$57)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "targetRef"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "sourceRef"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var $$x14 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$62__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x10 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(""), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$24 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "id"));
    var this$25 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "name"));
    var this$26 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "sourceRef"));
    var this$27 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "targetRef")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var $$x9 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "name"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "name"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "sourceRef"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$44 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "targetRef"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$51 = $m_s_$less$colon$less$();
    var ev$1 = this$51.s_$less$colon$less$__f_singleton;
    var this$52 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$52);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$56 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$56);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$60 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$60);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$64 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$64);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$68 = $m_s_$less$colon$less$();
    var ev$2 = this$68.s_$less$colon$less$__f_singleton;
    var this$69 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$73);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$77 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$77);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$81 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$81);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$29 = $n($$x15).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x14, $$x10, $$x9, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5));
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$29
}
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$62$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$62 = new $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3($thiz);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$62
}
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$63$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "name"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "details")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_model_process_ProcessNode(x0$23$2);
      if ((x0$23 !== null)) {
        var id$macro$85 = $n(x0$23).Lreactbuild_model_process_ProcessNode__f_id;
        var name$macro$86 = $n(x0$23).Lreactbuild_model_process_ProcessNode__f_name;
        var details$macro$87 = $n(x0$23).Lreactbuild_model_process_ProcessNode__f_details;
        return new $c_Lshapeless_$colon$colon(id$macro$85, new $c_Lshapeless_$colon$colon(name$macro$86, new $c_Lshapeless_$colon$colon(details$macro$87, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var id$macro$82 = $as_Lreactbuild_common_model_RefTo($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var name$macro$83 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var details$macro$84 = $as_Lreactbuild_model_process_ProcessNodeDetails($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_model_process_ProcessNode(id$macro$82, name$macro$83, details$macro$84)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$88__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "id"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "details"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$29 = $m_s_$less$colon$less$();
    var ev$1 = this$29.s_$less$colon$less$__f_singleton;
    var this$30 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$30);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$34 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$34);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$38 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$38);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$42 = $m_s_$less$colon$less$();
    var ev$2 = this$42.s_$less$colon$less$__f_singleton;
    var this$43 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$43);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$47 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$47);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$51 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$51);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$63 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$63
}
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$88$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$88 = new $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4($thiz);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$88
}
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$89$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "name"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "sourceRef"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "targetRef")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_model_process_ProcessEdge(x0$31$2);
      if ((x0$31 !== null)) {
        var id$macro$118 = $n(x0$31).Lreactbuild_model_process_ProcessEdge__f_id;
        var name$macro$119 = $n(x0$31).Lreactbuild_model_process_ProcessEdge__f_name;
        var sourceRef$macro$120 = $n(x0$31).Lreactbuild_model_process_ProcessEdge__f_sourceRef;
        var targetRef$macro$121 = $n(x0$31).Lreactbuild_model_process_ProcessEdge__f_targetRef;
        return new $c_Lshapeless_$colon$colon(id$macro$118, new $c_Lshapeless_$colon$colon(name$macro$119, new $c_Lshapeless_$colon$colon(sourceRef$macro$120, new $c_Lshapeless_$colon$colon(targetRef$macro$121, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var id$macro$114 = $as_Lreactbuild_common_model_RefTo($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$32).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var name$macro$115 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var sourceRef$macro$116 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var targetRef$macro$117 = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_model_process_ProcessEdge(id$macro$114, name$macro$115, sourceRef$macro$116, targetRef$macro$117)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "targetRef"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "sourceRef"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$122__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "name"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "sourceRef"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "targetRef"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$36 = $m_s_$less$colon$less$();
    var ev$1 = this$36.s_$less$colon$less$__f_singleton;
    var this$37 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$37);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$41 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$41);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$45 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$45);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$49 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$49);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$53 = $m_s_$less$colon$less$();
    var ev$2 = this$53.s_$less$colon$less$__f_singleton;
    var this$54 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$54);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$58 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$66);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$89 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$89
}
function $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$122$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$122 = new $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5($thiz);
    $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$122
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1() {
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$28 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$29 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$62 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$63 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$88 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$89 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$122 = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.constructor = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype;
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$1)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$2)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$3)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$28__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$28$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$28)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$29__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$29$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$29)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$62__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$62$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$62)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$63__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((64 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$63$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$63)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$88__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$88$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$88)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$89__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$89$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$89)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.inst$macro$122__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__inst$macro$122$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1__f_inst$macro$122)
});
var $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1: 0
}, false, "reactbuild.model.process.ProcessElement$anon$lazy$macro$123$1", {
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1.prototype.$classData = $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEvent$() {
  this.Lreactbuild_model_process_ProcessInstanceEvent$__f_codecForProcessInstanceEvent = null;
  $n_Lreactbuild_model_process_ProcessInstanceEvent$ = this;
  var inst$macro$52 = new $c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$52));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_process_ProcessInstanceEvent$__f_codecForProcessInstanceEvent = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_process_ProcessInstanceEvent$.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEvent$.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEvent$;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEvent$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEvent$.prototype = $c_Lreactbuild_model_process_ProcessInstanceEvent$.prototype;
var $d_Lreactbuild_model_process_ProcessInstanceEvent$ = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEvent$: 0
}, false, "reactbuild.model.process.ProcessInstanceEvent$", {
  Lreactbuild_model_process_ProcessInstanceEvent$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEvent$.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEvent$;
var $n_Lreactbuild_model_process_ProcessInstanceEvent$;
function $m_Lreactbuild_model_process_ProcessInstanceEvent$() {
  if ((!$n_Lreactbuild_model_process_ProcessInstanceEvent$)) {
    $n_Lreactbuild_model_process_ProcessInstanceEvent$ = new $c_Lreactbuild_model_process_ProcessInstanceEvent$()
  };
  return $n_Lreactbuild_model_process_ProcessInstanceEvent$
}
function $p_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "parents"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "user"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "date"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "details"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "instant")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_process_ProcessInstanceEvent(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$44 = $n(x0$7).Lreactbuild_model_process_ProcessInstanceEvent__f__id;
        var parents$macro$45 = $n(x0$7).Lreactbuild_model_process_ProcessInstanceEvent__f_parents;
        var user$macro$46 = $n(x0$7).Lreactbuild_model_process_ProcessInstanceEvent__f_user;
        var date$macro$47 = $n(x0$7).Lreactbuild_model_process_ProcessInstanceEvent__f_date;
        var details$macro$48 = $n(x0$7).Lreactbuild_model_process_ProcessInstanceEvent__f_details;
        var instant$macro$49 = $n(x0$7).Lreactbuild_model_process_ProcessInstanceEvent__f_instant;
        return new $c_Lshapeless_$colon$colon(_id$macro$44, new $c_Lshapeless_$colon$colon(parents$macro$45, new $c_Lshapeless_$colon$colon(user$macro$46, new $c_Lshapeless_$colon$colon(date$macro$47, new $c_Lshapeless_$colon$colon(details$macro$48, new $c_Lshapeless_$colon$colon(instant$macro$49, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$38 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var parents$macro$39 = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var user$macro$40 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var date$macro$41 = $as_Ljava_time_LocalDate($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var details$macro$42 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var instant$macro$43 = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_model_process_ProcessInstanceEvent(_id$macro$38, parents$macro$39, user$macro$40, date$macro$41, details$macro$42, instant$macro$43)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "instant"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "user"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "parents"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x11 = $m_s_None$();
    var $$x10 = $m_s_None$();
    var $$x9 = $m_s_None$();
    var $$x8 = $m_s_None$();
    var $$x7 = $m_s_None$();
    $m_Lreactbuild_model_process_ProcessInstanceEvent$();
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x6 = $m_Ljava_time_Instant$();
    var this$36 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$36.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$36.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var defaults = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon(new $c_s_Some($n($$x6).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))), $m_Lshapeless_HNil$()))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$38 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "_id"));
    var this$39 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "parents"));
    var this$40 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "user"));
    var this$41 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "date"));
    var this$42 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "details"));
    var this$43 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "instant")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "instant"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$56 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "_id"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$58 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "parents"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$60 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "user"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$62 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "date"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$64 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "details"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$66 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "instant"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$12);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var this$75 = $m_s_$less$colon$less$();
    var ev$1 = this$75.s_$less$colon$less$__f_singleton;
    var this$76 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$76);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$80 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$88);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$92 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$92);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$96 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$96);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$100 = $m_s_$less$colon$less$();
    var ev$2 = this$100.s_$less$colon$less$__f_singleton;
    var this$101 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$6, ev$2);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$113);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$117 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$117);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$121 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$121);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_inst$macro$1
}
function $p_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_inst$macro$50 = new $c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_inst$macro$50
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1() {
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_inst$macro$50 = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1.prototype = $c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_inst$macro$1)
});
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1.prototype.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1__f_inst$macro$50)
});
var $d_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1: 0
}, false, "reactbuild.model.process.ProcessInstanceEvent$anon$lazy$macro$51$1", {
  Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1;
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Comment"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Done"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Instantiate"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "Link"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "SetStepDate")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_process_ProcessInstanceEventDetails(p$2);
      var $$x6 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment)) {
        var $$x5 = 0
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done)) {
        var $$x5 = 1
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate)) {
        var $$x5 = 2
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link)) {
        var $$x5 = 3
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate))) {
          throw new $c_s_MatchError(p)
        };
        var $$x5 = 4
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x6).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x5, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_process_ProcessInstanceEventDetails($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "SetStepDate"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "Link"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "Instantiate"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "Done"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "Comment"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$1
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$2 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$2
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ref"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "value")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(x0$7$2);
      if ((x0$7 !== null)) {
        var ref$macro$18 = $n(x0$7).Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_ref;
        var value$macro$19 = $n(x0$7).Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_value;
        return new $c_Lshapeless_$colon$colon(ref$macro$18, new $c_Lshapeless_$colon$colon(value$macro$19, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var ref$macro$16 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var value$macro$17 = $as_Lreactbuild_model_process_PartialDate($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(ref$macro$16, value$macro$17)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "value"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$20__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "ref"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "value")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "ref"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "value"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$3 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$3
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$20 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$20
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "details")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(x0$15$2);
      if ((x0$15 !== null)) {
        var details$macro$29 = $n(x0$15).Lreactbuild_model_process_ProcessInstanceEventDetails$Link__f_details;
        return new $c_Lshapeless_$colon$colon(details$macro$29, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var details$macro$28 = $as_Lreactbuild_model_process_ProcessLink($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$16).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(details$macro$28)
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$30__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "details")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "details"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$21 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$21
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$30$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$30 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$30
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$31$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "process"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "customProcessName")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(x0$23$2);
      if ((x0$23 !== null)) {
        var process$macro$46 = $n(x0$23).Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_process;
        var customProcessName$macro$47 = $n(x0$23).Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_customProcessName;
        return new $c_Lshapeless_$colon$colon(process$macro$46, new $c_Lshapeless_$colon$colon(customProcessName$macro$47, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var process$macro$44 = $as_Lreactbuild_common_model_RefTo($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var customProcessName$macro$45 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(process$macro$44, customProcessName$macro$45)
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "customProcessName"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "process"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$48__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$17 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "process"));
    var this$18 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "customProcessName")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "customProcessName"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "process"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "customProcessName"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$34 = $m_s_$less$colon$less$();
    var ev$1 = this$34.s_$less$colon$less$__f_singleton;
    var this$35 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$35);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$39 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$39);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$43 = $m_s_$less$colon$less$();
    var ev$2 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$48);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$31 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$31
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$48$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$48 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$48
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$49$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "node")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(x0$31$2);
      if ((x0$31 !== null)) {
        var node$macro$57 = $n(x0$31).Lreactbuild_model_process_ProcessInstanceEventDetails$Done__f_node;
        return new $c_Lshapeless_$colon$colon(node$macro$57, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var node$macro$56 = $as_Lreactbuild_common_model_RefTo($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$32).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(node$macro$56)
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "node"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "node")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "node"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$49 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$49
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$58 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$58
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$59$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "message")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(x0$39$2);
      if ((x0$39 !== null)) {
        var message$macro$67 = $n(x0$39).Lreactbuild_model_process_ProcessInstanceEventDetails$Comment__f_message;
        return new $c_Lshapeless_$colon$colon(new $c_Lcom_iz2use_common_Multiline(message$macro$67), $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var message$macro$66 = $n($as_Lcom_iz2use_common_Multiline($n(x0$40).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
        var p2 = $as_Lshapeless_HNil($n(x0$40).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(message$macro$66)
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "message"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$68__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "message")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "message"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$59 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$59
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$68$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$68 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$68
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$69$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ref"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "value")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(x0$47$2);
      if ((x0$47 !== null)) {
        var ref$macro$84 = $n(x0$47).Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_ref;
        var value$macro$85 = $n(x0$47).Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_value;
        return new $c_Lshapeless_$colon$colon(ref$macro$84, new $c_Lshapeless_$colon$colon(value$macro$85, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_$colon$colon(x0$48$2);
      if ((x0$48 !== null)) {
        var ref$macro$82 = $as_Lreactbuild_common_model_RefTo($n(x0$48).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$48).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var value$macro$83 = $as_Lreactbuild_model_process_PartialDate($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(ref$macro$82, value$macro$83)
          }
        }
      };
      throw new $c_s_MatchError(x0$48)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "value"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$86__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "ref"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "value"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$69 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$69
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$86$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$86 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$86
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$87$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "details")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      var x0$55 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(x0$55$2);
      if ((x0$55 !== null)) {
        var details$macro$95 = $n(x0$55).Lreactbuild_model_process_ProcessInstanceEventDetails$Link__f_details;
        return new $c_Lshapeless_$colon$colon(details$macro$95, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$55)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      var x0$56 = $as_Lshapeless_$colon$colon(x0$56$2);
      if ((x0$56 !== null)) {
        var details$macro$94 = $as_Lreactbuild_model_process_ProcessLink($n(x0$56).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$56).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(details$macro$94)
        }
      };
      throw new $c_s_MatchError(x0$56)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$96__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "details"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$87 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$87
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$96$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((32768 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$96 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (32768 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$96
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$97$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((65536 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "process"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "customProcessName")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      var x0$63 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(x0$63$2);
      if ((x0$63 !== null)) {
        var process$macro$112 = $n(x0$63).Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_process;
        var customProcessName$macro$113 = $n(x0$63).Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_customProcessName;
        return new $c_Lshapeless_$colon$colon(process$macro$112, new $c_Lshapeless_$colon$colon(customProcessName$macro$113, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$63)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      var x0$64 = $as_Lshapeless_$colon$colon(x0$64$2);
      if ((x0$64 !== null)) {
        var process$macro$110 = $as_Lreactbuild_common_model_RefTo($n(x0$64).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$64).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var customProcessName$macro$111 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(process$macro$110, customProcessName$macro$111)
          }
        }
      };
      throw new $c_s_MatchError(x0$64)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "customProcessName"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "process"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$114__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "process"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "customProcessName"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$97 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (65536 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$97
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$114$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((131072 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$114 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (131072 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$114
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$115$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((262144 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "node")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$71$2) => {
      var x0$71 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(x0$71$2);
      if ((x0$71 !== null)) {
        var node$macro$123 = $n(x0$71).Lreactbuild_model_process_ProcessInstanceEventDetails$Done__f_node;
        return new $c_Lshapeless_$colon$colon(node$macro$123, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$71)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$72$2) => {
      var x0$72 = $as_Lshapeless_$colon$colon(x0$72$2);
      if ((x0$72 !== null)) {
        var node$macro$122 = $as_Lreactbuild_common_model_RefTo($n(x0$72).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$72).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(node$macro$122)
        }
      };
      throw new $c_s_MatchError(x0$72)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "node"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$124__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "node"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$115 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (262144 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$115
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$124$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((524288 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$124 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (524288 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$124
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$125$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1048576 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "message")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$79$2) => {
      var x0$79 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(x0$79$2);
      if ((x0$79 !== null)) {
        var message$macro$133 = $n(x0$79).Lreactbuild_model_process_ProcessInstanceEventDetails$Comment__f_message;
        return new $c_Lshapeless_$colon$colon(new $c_Lcom_iz2use_common_Multiline(message$macro$133), $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$79)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$80$2) => {
      var x0$80 = $as_Lshapeless_$colon$colon(x0$80$2);
      if ((x0$80 !== null)) {
        var message$macro$132 = $n($as_Lcom_iz2use_common_Multiline($n(x0$80).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
        var p2 = $as_Lshapeless_HNil($n(x0$80).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(message$macro$132)
        }
      };
      throw new $c_s_MatchError(x0$80)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "message"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$134__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "message"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$125 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (1048576 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$125
}
function $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$134$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((2097152 & $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$134 = new $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24($thiz);
    $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = (2097152 | $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$134
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1() {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$20 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$21 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$30 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$31 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$48 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$49 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$58 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$59 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$68 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$69 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$86 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$87 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$96 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$97 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$114 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$115 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$124 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$125 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$134 = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$1)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$2)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$3)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$20__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$20)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$21)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$30__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$30$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$30)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$31__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$31$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$31)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$48__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((128 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$48$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$48)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$49__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((256 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$49$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$49)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$58__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((512 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$58)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$59__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((1024 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$59$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$59)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$68__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((2048 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$68$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$68)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$69__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4096 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$69$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$69)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$86__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$86$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$86)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$87__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((16384 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$87$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$87)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$96__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((32768 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$96$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$96)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$97__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((65536 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$97$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$97)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$114__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((131072 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$114$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$114)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$115__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((262144 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$115$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$115)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$124__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((524288 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$124$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$124)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$125__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1048576 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$125$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$125)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.inst$macro$134__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((2097152 & this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__inst$macro$134$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1__f_inst$macro$134)
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLink$() {
  this.Lreactbuild_model_process_ProcessLink$__f_codecForProcessLink = null;
  $n_Lreactbuild_model_process_ProcessLink$ = this;
  var inst$macro$20 = new $c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_model_process_ProcessLink$__f_codecForProcessLink = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_model_process_ProcessLink$.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessLink$.prototype.constructor = $c_Lreactbuild_model_process_ProcessLink$;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLink$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLink$.prototype = $c_Lreactbuild_model_process_ProcessLink$.prototype;
var $d_Lreactbuild_model_process_ProcessLink$ = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLink$: 0
}, false, "reactbuild.model.process.ProcessLink$", {
  Lreactbuild_model_process_ProcessLink$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessLink$.prototype.$classData = $d_Lreactbuild_model_process_ProcessLink$;
var $n_Lreactbuild_model_process_ProcessLink$;
function $m_Lreactbuild_model_process_ProcessLink$() {
  if ((!$n_Lreactbuild_model_process_ProcessLink$)) {
    $n_Lreactbuild_model_process_ProcessLink$ = new $c_Lreactbuild_model_process_ProcessLink$()
  };
  return $n_Lreactbuild_model_process_ProcessLink$
}
function $p_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "ref"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "cls")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_process_ProcessLink(x0$7$2);
      if ((x0$7 !== null)) {
        var ref$macro$16 = $n(x0$7).Lreactbuild_model_process_ProcessLink__f_ref;
        var cls$macro$17 = $n(x0$7).Lreactbuild_model_process_ProcessLink__f_cls;
        return new $c_Lshapeless_$colon$colon(ref$macro$16, new $c_Lshapeless_$colon$colon(cls$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var ref$macro$14 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var cls$macro$15 = $as_Lreactbuild_model_process_ProcessLinkClass($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_model_process_ProcessLink(ref$macro$14, cls$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "cls"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "ref"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "ref"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "cls")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "ref"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "cls"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_inst$macro$1
}
function $p_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_inst$macro$18 = new $c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13($thiz);
    $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1() {
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_inst$macro$18 = null;
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1.prototype.constructor = $c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1.prototype = $c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1.prototype;
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_inst$macro$1)
});
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1__f_inst$macro$18)
});
var $d_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1: 0
}, false, "reactbuild.model.process.ProcessLink$anon$lazy$macro$19$1", {
  Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1.prototype.$classData = $d_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1;
function $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Person"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Project")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_process_ProcessLinkClass(p$2);
      var $$x3 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_model_process_ProcessLinkClass$Person$())) {
        var $$x2 = 0
      } else {
        if ((p !== $m_Lreactbuild_model_process_ProcessLinkClass$Project$())) {
          throw new $c_s_MatchError(p)
        };
        var $$x2 = 1
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x3).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x2, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_process_ProcessLinkClass($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "Project"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "Person"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$1
}
function $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$2 = new $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11($thiz);
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$2
}
function $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_model_process_ProcessLinkClass$Project$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_model_process_ProcessLinkClass$Project$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$3
}
function $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$4
}
function $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_model_process_ProcessLinkClass$Person$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_model_process_ProcessLinkClass$Person$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$5
}
function $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_model_process_ProcessLinkClass$Project$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_model_process_ProcessLinkClass$Project$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$7__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$6 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$6
}
function $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$7 = new $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12($thiz);
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$7
}
function $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((128 & $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_model_process_ProcessLinkClass$Person$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_model_process_ProcessLinkClass$Person$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$7__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$8 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0 = (((128 | $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$8
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1() {
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$4 = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$5 = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$6 = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$7 = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$8 = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.constructor = $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype = $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype;
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$1)
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$2)
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((4 & this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$3)
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((8 & this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$4)
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((16 & this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$5)
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.inst$macro$6__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((32 & this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$6)
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.inst$macro$7__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((64 & this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$7)
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((128 & this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1__f_inst$macro$8)
});
var $d_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1: 0
}, false, "reactbuild.model.process.ProcessLinkClass$anon$lazy$macro$9$1", {
  Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1.prototype.$classData = $d_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1;
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Ask"));
    var this$2 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "End"));
    var this$3 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Milestone"));
    var this$4 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "Receive"));
    var this$5 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "Send"));
    var this$6 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "Start"));
    var this$7 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "UserActivity"));
    var this$8 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "UserInput"));
    var this$9 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "Wait")), $m_Lshapeless_HNil$())))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_model_process_ProcessNodeDetails(p$2);
      var $$x10 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Ask)) {
        var $$x9 = 0
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$End)) {
        var $$x9 = 1
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Milestone)) {
        var $$x9 = 2
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Receive)) {
        var $$x9 = 3
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Send)) {
        var $$x9 = 4
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Start)) {
        var $$x9 = 5
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity)) {
        var $$x9 = 6
      } else if ((p instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$UserInput)) {
        var $$x9 = 7
      } else {
        if ((!(p instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Wait))) {
          throw new $c_s_MatchError(p)
        };
        var $$x9 = 8
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x10).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x9, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_model_process_ProcessNodeDetails($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "Wait"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "UserInput"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "UserActivity"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "Start"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "Send"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$28 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "Receive"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "Milestone"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "End"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "Ask"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$8);
    var this$40 = $m_s_$less$colon$less$();
    var ev = this$40.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$1
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$2 = new $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6($thiz);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$2
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "period")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_process_ProcessNodeDetails$Wait(x0$7$2);
      if ((x0$7 !== null)) {
        var period$macro$11 = $n(x0$7).Lreactbuild_model_process_ProcessNodeDetails$Wait__f_period;
        return new $c_Lshapeless_$colon$colon(period$macro$11, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var period$macro$10 = $as_Ljava_time_Period($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_process_ProcessNodeDetails$Wait(period$macro$10)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "period"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "period")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "period"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$3
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$12 = new $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7($thiz);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$12
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_process_ProcessNodeDetails$UserInput(x0$15$2);
      if ((x0$15 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_HNil(x0$16$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$16)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$UserInput()
      } else {
        throw new $c_s_MatchError(x0$16)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$13 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$13
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$14$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$14 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$14
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$15$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_model_process_ProcessNodeDetails$UserActivity(x0$23$2);
      if ((x0$23 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_HNil(x0$24$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$24)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity()
      } else {
        throw new $c_s_MatchError(x0$24)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$15 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$15
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$16$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_model_process_ProcessNodeDetails$Start(x0$31$2);
      if ((x0$31 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_HNil(x0$32$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$32)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Start()
      } else {
        throw new $c_s_MatchError(x0$32)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$16 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$16
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$17$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((256 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_model_process_ProcessNodeDetails$Send(x0$39$2);
      if ((x0$39 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_HNil(x0$40$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$40)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Send()
      } else {
        throw new $c_s_MatchError(x0$40)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$17 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$17
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((512 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_model_process_ProcessNodeDetails$Receive(x0$47$2);
      if ((x0$47 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_HNil(x0$48$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$48)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Receive()
      } else {
        throw new $c_s_MatchError(x0$48)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$18 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$18
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$19$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      var x0$55 = $as_Lreactbuild_model_process_ProcessNodeDetails$Milestone(x0$55$2);
      if ((x0$55 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$55)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      var x0$56 = $as_Lshapeless_HNil(x0$56$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$56)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Milestone()
      } else {
        throw new $c_s_MatchError(x0$56)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$19 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$19
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      var x0$63 = $as_Lreactbuild_model_process_ProcessNodeDetails$End(x0$63$2);
      if ((x0$63 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$63)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      var x0$64 = $as_Lshapeless_HNil(x0$64$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$64)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$End()
      } else {
        throw new $c_s_MatchError(x0$64)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$20 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$20
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$71$2) => {
      var x0$71 = $as_Lreactbuild_model_process_ProcessNodeDetails$Ask(x0$71$2);
      if ((x0$71 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$71)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$72$2) => {
      var x0$72 = $as_Lshapeless_HNil(x0$72$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$72)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Ask()
      } else {
        throw new $c_s_MatchError(x0$72)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$21 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$21
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "period")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$79$2) => {
      var x0$79 = $as_Lreactbuild_model_process_ProcessNodeDetails$Wait(x0$79$2);
      if ((x0$79 !== null)) {
        var period$macro$30 = $n(x0$79).Lreactbuild_model_process_ProcessNodeDetails$Wait__f_period;
        return new $c_Lshapeless_$colon$colon(period$macro$30, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$79)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$80$2) => {
      var x0$80 = $as_Lshapeless_$colon$colon(x0$80$2);
      if ((x0$80 !== null)) {
        var period$macro$29 = $as_Ljava_time_Period($n(x0$80).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$80).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_model_process_ProcessNodeDetails$Wait(period$macro$29)
        }
      };
      throw new $c_s_MatchError(x0$80)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "period"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$31__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "period"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$22 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$22
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$31$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$31 = new $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8($thiz);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$31
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$32$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((32768 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$87$2) => {
      var x0$87 = $as_Lreactbuild_model_process_ProcessNodeDetails$UserInput(x0$87$2);
      if ((x0$87 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$87)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$88$2) => {
      var x0$88 = $as_Lshapeless_HNil(x0$88$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$88)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$UserInput()
      } else {
        throw new $c_s_MatchError(x0$88)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$33__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$32 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (32768 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$32
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$33$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((65536 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$33 = new $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9($thiz);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (65536 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$33
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((131072 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$95$2) => {
      var x0$95 = $as_Lreactbuild_model_process_ProcessNodeDetails$UserActivity(x0$95$2);
      if ((x0$95 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$95)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$96$2) => {
      var x0$96 = $as_Lshapeless_HNil(x0$96$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$96)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity()
      } else {
        throw new $c_s_MatchError(x0$96)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$33__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$34 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (131072 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$34
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$35$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((262144 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$103$2) => {
      var x0$103 = $as_Lreactbuild_model_process_ProcessNodeDetails$Start(x0$103$2);
      if ((x0$103 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$103)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$104$2) => {
      var x0$104 = $as_Lshapeless_HNil(x0$104$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$104)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Start()
      } else {
        throw new $c_s_MatchError(x0$104)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$33__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$35 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (262144 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$35
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$36$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((524288 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$111$2) => {
      var x0$111 = $as_Lreactbuild_model_process_ProcessNodeDetails$Send(x0$111$2);
      if ((x0$111 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$111)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$112$2) => {
      var x0$112 = $as_Lshapeless_HNil(x0$112$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$112)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Send()
      } else {
        throw new $c_s_MatchError(x0$112)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$33__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$36 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (524288 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$36
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1048576 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$119$2) => {
      var x0$119 = $as_Lreactbuild_model_process_ProcessNodeDetails$Receive(x0$119$2);
      if ((x0$119 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$119)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$120$2) => {
      var x0$120 = $as_Lshapeless_HNil(x0$120$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$120)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Receive()
      } else {
        throw new $c_s_MatchError(x0$120)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$33__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$37 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (1048576 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$37
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((2097152 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$127$2) => {
      var x0$127 = $as_Lreactbuild_model_process_ProcessNodeDetails$Milestone(x0$127$2);
      if ((x0$127 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$127)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$128$2) => {
      var x0$128 = $as_Lshapeless_HNil(x0$128$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$128)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Milestone()
      } else {
        throw new $c_s_MatchError(x0$128)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$33__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$38 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (2097152 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$38
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$39$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4194304 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$135$2) => {
      var x0$135 = $as_Lreactbuild_model_process_ProcessNodeDetails$End(x0$135$2);
      if ((x0$135 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$135)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$136$2) => {
      var x0$136 = $as_Lshapeless_HNil(x0$136$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$136)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$End()
      } else {
        throw new $c_s_MatchError(x0$136)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$33__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$39 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (4194304 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$39
}
function $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$40$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((8388608 & $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$143$2) => {
      var x0$143 = $as_Lreactbuild_model_process_ProcessNodeDetails$Ask(x0$143$2);
      if ((x0$143 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$143)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$144$2) => {
      var x0$144 = $as_Lshapeless_HNil(x0$144$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$144)) {
        return new $c_Lreactbuild_model_process_ProcessNodeDetails$Ask()
      } else {
        throw new $c_s_MatchError(x0$144)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$33__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$40 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = (8388608 | $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$40
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1() {
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$1 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$2 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$3 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$12 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$13 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$14 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$15 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$16 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$17 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$18 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$19 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$20 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$21 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$22 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$31 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$32 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$33 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$34 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$35 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$36 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$37 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$38 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$39 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$40 = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0 = 0
}
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$1)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$2)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$3)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$12)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$13)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$14$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$14)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$15__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$15$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$15)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$16__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((128 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$16$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$16)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$17__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((256 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$17$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$17)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$18__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((512 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$18)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$19__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((1024 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$19$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$19)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$20__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((2048 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$20)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4096 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$21)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$22__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$22)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$31__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((16384 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$31$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$31)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$32__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((32768 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$32$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$32)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$33__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((65536 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$33$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$33)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$34__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((131072 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$34)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$35__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((262144 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$35$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$35)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$36__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((524288 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$36$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$36)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$37__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1048576 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$37)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$38__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((2097152 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$38)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$39__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4194304 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$39$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$39)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.inst$macro$40__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((8388608 & this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_bitmap$0) === 0) ? $p_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__inst$macro$40$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1__f_inst$macro$40)
});
var $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$anon$lazy$macro$41$1", {
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1;
/** @constructor */
function $c_Lreactbuild_package$$anon$3() {
  /*<skip>*/
}
$c_Lreactbuild_package$$anon$3.prototype = new $h_O();
$c_Lreactbuild_package$$anon$3.prototype.constructor = $c_Lreactbuild_package$$anon$3;
/** @constructor */
function $h_Lreactbuild_package$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_package$$anon$3.prototype = $c_Lreactbuild_package$$anon$3.prototype;
$c_Lreactbuild_package$$anon$3.prototype.get__T__Lio_circe_Decoder__s_concurrent_Future = (function(key, decoder) {
  return $m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($m_s_Option$().apply__O__s_Option($as_T(window.localStorage.getItem(key))));
    var p = new $c_sjsr_AnonFunction1(((found$2) => {
      var found = $as_T(found$2);
      return (found !== null)
    }));
    var this$3 = new $c_s_Option$WithFilter(this$2, p);
    var this$4 = $n(this$3.s_Option$WithFilter__f_$outer);
    var p$1 = this$3.s_Option$WithFilter__f_p;
    var this$5 = $n(((this$4.isEmpty__Z() || $uZ($n(p$1).apply__O__O(this$4.get__O()))) ? this$4 : $m_s_None$()));
    if (this$5.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$5.get__O();
      var found$3 = $as_T(arg1);
      var x1 = $m_Lio_circe_parser_package$().parse__T__s_util_Either(found$3);
      if ((x1 instanceof $c_s_util_Left)) {
        var $$x1 = $m_s_None$()
      } else {
        if ((!(x1 instanceof $c_s_util_Right))) {
          throw new $c_s_MatchError(x1)
        };
        var x3 = $as_s_util_Right(x1);
        var v = $as_Lio_circe_Json($n(x3).s_util_Right__f_value);
        var $$x1 = new $c_s_Some(v)
      };
      var this$6 = $n($$x1);
      if (this$6.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1$1 = this$6.get__O();
        var json = $as_Lio_circe_Json(arg1$1);
        var this$7 = $n(json);
        var x1$1 = $n(decoder).apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(this$7, null, null));
        if ((x1$1 instanceof $c_s_util_Left)) {
          var $$x2 = $m_s_None$()
        } else {
          if ((!(x1$1 instanceof $c_s_util_Right))) {
            throw new $c_s_MatchError(x1$1)
          };
          var x3$1 = $as_s_util_Right(x1$1);
          var v$1 = $n(x3$1).s_util_Right__f_value;
          var $$x2 = new $c_s_Some(v$1)
        };
        var this$9 = $n($$x2);
        if (this$9.isEmpty__Z()) {
          return $m_s_None$()
        } else {
          var arg1$2 = this$9.get__O();
          return new $c_s_Some(arg1$2)
        }
      }
    }
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
$c_Lreactbuild_package$$anon$3.prototype.put__T__O__Lio_circe_Encoder__s_concurrent_Future = (function(key, value, encoder) {
  return $m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
    var $$x1 = window.localStorage;
    var this$4 = $n($n(encoder).apply__O__Lio_circe_Json(value));
    $$x1.setItem(key, $n($m_Lio_circe_Printer$().Lio_circe_Printer$__f_spaces2).print__Lio_circe_Json__T(this$4))
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
var $d_Lreactbuild_package$$anon$3 = new $TypeData().initClass({
  Lreactbuild_package$$anon$3: 0
}, false, "reactbuild.package$$anon$3", {
  Lreactbuild_package$$anon$3: 1,
  O: 1,
  Lcom_iz2use_react_components_UserPreferenceStore: 1
});
$c_Lreactbuild_package$$anon$3.prototype.$classData = $d_Lreactbuild_package$$anon$3;
/** @constructor */
function $c_Lreactbuild_package$DefaultCommonData$$anon$1() {
  /*<skip>*/
}
$c_Lreactbuild_package$DefaultCommonData$$anon$1.prototype = new $h_O();
$c_Lreactbuild_package$DefaultCommonData$$anon$1.prototype.constructor = $c_Lreactbuild_package$DefaultCommonData$$anon$1;
/** @constructor */
function $h_Lreactbuild_package$DefaultCommonData$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_package$DefaultCommonData$$anon$1.prototype = $c_Lreactbuild_package$DefaultCommonData$$anon$1.prototype;
$c_Lreactbuild_package$DefaultCommonData$$anon$1.prototype.empty__O = (function() {
  $n($m_s_package$().s_package$__f_List);
  return $m_sci_Nil$()
});
var $d_Lreactbuild_package$DefaultCommonData$$anon$1 = new $TypeData().initClass({
  Lreactbuild_package$DefaultCommonData$$anon$1: 0
}, false, "reactbuild.package$DefaultCommonData$$anon$1", {
  Lreactbuild_package$DefaultCommonData$$anon$1: 1,
  O: 1,
  Lreactbuild_package$DefaultCommonData: 1
});
$c_Lreactbuild_package$DefaultCommonData$$anon$1.prototype.$classData = $d_Lreactbuild_package$DefaultCommonData$$anon$1;
/** @constructor */
function $c_Lreactbuild_package$DefaultCommonData$$anon$2() {
  /*<skip>*/
}
$c_Lreactbuild_package$DefaultCommonData$$anon$2.prototype = new $h_O();
$c_Lreactbuild_package$DefaultCommonData$$anon$2.prototype.constructor = $c_Lreactbuild_package$DefaultCommonData$$anon$2;
/** @constructor */
function $h_Lreactbuild_package$DefaultCommonData$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_package$DefaultCommonData$$anon$2.prototype = $c_Lreactbuild_package$DefaultCommonData$$anon$2.prototype;
$c_Lreactbuild_package$DefaultCommonData$$anon$2.prototype.empty__O = (function() {
  $n($m_s_Predef$().s_Predef$__f_Map);
  return $m_sci_Map$EmptyMap$()
});
var $d_Lreactbuild_package$DefaultCommonData$$anon$2 = new $TypeData().initClass({
  Lreactbuild_package$DefaultCommonData$$anon$2: 0
}, false, "reactbuild.package$DefaultCommonData$$anon$2", {
  Lreactbuild_package$DefaultCommonData$$anon$2: 1,
  O: 1,
  Lreactbuild_package$DefaultCommonData: 1
});
$c_Lreactbuild_package$DefaultCommonData$$anon$2.prototype.$classData = $d_Lreactbuild_package$DefaultCommonData$$anon$2;
function $p_Lreactbuild_package$PageProps$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_extra_router_RouterCtlF$().reusability__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_package$PageProps$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_package$PageProps$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lreactbuild_package$PageProps$__b$2$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$2$lzy$1, reuseProxy$1) {
  $n(b$2$lzy$1);
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability(reuseProxy$1);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_package$PageProps$__b$2$1__sr_LazyRef__F2__F2($thiz, b$2$lzy$1, reuseProxy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_package$PageProps$__b$2$lzycompute$1__sr_LazyRef__F2__F2($thiz, b$2$lzy$1, reuseProxy$1))
}
/** @constructor */
function $c_Lreactbuild_package$PageProps$() {
  this.Lreactbuild_package$PageProps$__f_reusePageProps = null;
  this.Lreactbuild_package$PageProps$__f_context = null;
  $n_Lreactbuild_package$PageProps$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  var reuseModel = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ldiode_react_ModelProxy(x$1$2);
    var this$3 = $n(x$1);
    var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
    return $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O())
  }));
  var reuseProxy = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(reuseModel, f);
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$1 = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_package$PageProps(a$2);
    var b = $as_Lreactbuild_package$PageProps(b$2);
    return ($uZ($n($p_Lreactbuild_package$PageProps$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_package$PageProps__f_router, $n(b).Lreactbuild_package$PageProps__f_router)) && $uZ($n($p_Lreactbuild_package$PageProps$__b$2$1__sr_LazyRef__F2__F2(this, b$2$lzy, reuseProxy)).apply__O__O__O($n(a).Lreactbuild_package$PageProps__f_proxy, $n(b).Lreactbuild_package$PageProps__f_proxy)))
  }));
  elem = f$1;
  this.Lreactbuild_package$PageProps$__f_reusePageProps = $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem));
  var this$8 = $m_Ljapgolly_scalajs_react_React$();
  this.Lreactbuild_package$PageProps$__f_context = $n(this$8.Ljapgolly_scalajs_react_React$__f_Context).apply__T__O__Ljapgolly_scalajs_react_feature_Context("PageProps", null)
}
$c_Lreactbuild_package$PageProps$.prototype = new $h_O();
$c_Lreactbuild_package$PageProps$.prototype.constructor = $c_Lreactbuild_package$PageProps$;
/** @constructor */
function $h_Lreactbuild_package$PageProps$() {
  /*<skip>*/
}
$h_Lreactbuild_package$PageProps$.prototype = $c_Lreactbuild_package$PageProps$.prototype;
var $d_Lreactbuild_package$PageProps$ = new $TypeData().initClass({
  Lreactbuild_package$PageProps$: 0
}, false, "reactbuild.package$PageProps$", {
  Lreactbuild_package$PageProps$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_package$PageProps$.prototype.$classData = $d_Lreactbuild_package$PageProps$;
var $n_Lreactbuild_package$PageProps$;
function $m_Lreactbuild_package$PageProps$() {
  if ((!$n_Lreactbuild_package$PageProps$)) {
    $n_Lreactbuild_package$PageProps$ = new $c_Lreactbuild_package$PageProps$()
  };
  return $n_Lreactbuild_package$PageProps$
}
/** @constructor */
function $c_Lreactbuild_person_Address$() {
  this.Lreactbuild_person_Address$__f_codecForAddress = null;
  $n_Lreactbuild_person_Address$ = this;
  var inst$macro$28 = new $c_Lreactbuild_person_Address$anon$lazy$macro$27$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_Address$__f_codecForAddress = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_Address$.prototype = new $h_O();
$c_Lreactbuild_person_Address$.prototype.constructor = $c_Lreactbuild_person_Address$;
/** @constructor */
function $h_Lreactbuild_person_Address$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Address$.prototype = $c_Lreactbuild_person_Address$.prototype;
var $d_Lreactbuild_person_Address$ = new $TypeData().initClass({
  Lreactbuild_person_Address$: 0
}, false, "reactbuild.person.Address$", {
  Lreactbuild_person_Address$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Address$.prototype.$classData = $d_Lreactbuild_person_Address$;
var $n_Lreactbuild_person_Address$;
function $m_Lreactbuild_person_Address$() {
  if ((!$n_Lreactbuild_person_Address$)) {
    $n_Lreactbuild_person_Address$ = new $c_Lreactbuild_person_Address$()
  };
  return $n_Lreactbuild_person_Address$
}
function $p_Lreactbuild_person_Address$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "details"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "usage")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_Address(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$23 = $n(x0$7).Lreactbuild_person_Address__f_id;
        var details$macro$24 = $n(x0$7).Lreactbuild_person_Address__f_details;
        var usage$macro$25 = $n(x0$7).Lreactbuild_person_Address__f_usage;
        return new $c_Lshapeless_$colon$colon(id$macro$23, new $c_Lshapeless_$colon$colon(details$macro$24, new $c_Lshapeless_$colon$colon(usage$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$20 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var details$macro$21 = $as_Lreactbuild_person_AddressDetails($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var usage$macro$22 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_Address(id$macro$20, details$macro$21, usage$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "usage"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_Address$(), $m_ju_UUID$().randomUUID__ju_UUID())), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_Address$(), $m_s_None$())), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$22 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "id"));
    var this$23 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "details"));
    var this$24 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "usage")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "id"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "usage"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "id"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "details"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "usage"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$47 = $m_s_$less$colon$less$();
    var ev$1 = this$47.s_$less$colon$less$__f_singleton;
    var this$48 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$48);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$52 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$52);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$56 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$56);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$60 = $m_s_$less$colon$less$();
    var ev$2 = this$60.s_$less$colon$less$__f_singleton;
    var this$61 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$61);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$65 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$69);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_inst$macro$1
}
function $p_Lreactbuild_person_Address$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_inst$macro$26 = new $c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10($thiz);
    $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_person_Address$anon$lazy$macro$27$1() {
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_inst$macro$26 = null;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1.prototype = new $h_O();
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1.prototype.constructor = $c_Lreactbuild_person_Address$anon$lazy$macro$27$1;
/** @constructor */
function $h_Lreactbuild_person_Address$anon$lazy$macro$27$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_Address$anon$lazy$macro$27$1.prototype = $c_Lreactbuild_person_Address$anon$lazy$macro$27$1.prototype;
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Address$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_inst$macro$1)
});
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Address$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_Address$anon$lazy$macro$27$1__f_inst$macro$26)
});
var $d_Lreactbuild_person_Address$anon$lazy$macro$27$1 = new $TypeData().initClass({
  Lreactbuild_person_Address$anon$lazy$macro$27$1: 0
}, false, "reactbuild.person.Address$anon$lazy$macro$27$1", {
  Lreactbuild_person_Address$anon$lazy$macro$27$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1.prototype.$classData = $d_Lreactbuild_person_Address$anon$lazy$macro$27$1;
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Email"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Location"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Phone"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "Postal"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "Website")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_person_AddressDetails(p$2);
      var $$x6 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_person_Email)) {
        var $$x5 = 0
      } else if ((p instanceof $c_Lreactbuild_person_Location)) {
        var $$x5 = 1
      } else if ((p instanceof $c_Lreactbuild_person_Phone)) {
        var $$x5 = 2
      } else if ((p instanceof $c_Lreactbuild_person_Postal)) {
        var $$x5 = 3
      } else {
        if ((!(p instanceof $c_Lreactbuild_person_Website))) {
          throw new $c_s_MatchError(p)
        };
        var $$x5 = 4
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x6).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x5, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_person_AddressDetails($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "Website"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "Postal"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "Phone"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "Location"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "Email"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$1
}
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$2 = new $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5($thiz);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$2
}
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "url"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "credentials")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_Website(x0$7$2);
      if ((x0$7 !== null)) {
        var url$macro$18 = $n(x0$7).Lreactbuild_person_Website__f_url;
        var credentials$macro$19 = $n(x0$7).Lreactbuild_person_Website__f_credentials;
        return new $c_Lshapeless_$colon$colon(url$macro$18, new $c_Lshapeless_$colon$colon(credentials$macro$19, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var url$macro$16 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var credentials$macro$17 = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_Website(url$macro$16, credentials$macro$17)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "credentials"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "url"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$20__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_package$().s_package$__f_Nil), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$17 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "url"));
    var this$18 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "credentials")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "credentials"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "url"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "credentials"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$34 = $m_s_$less$colon$less$();
    var ev$1 = this$34.s_$less$colon$less$__f_singleton;
    var this$35 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$35);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$39 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$39);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$43 = $m_s_$less$colon$less$();
    var ev$2 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$48);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$3 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$3
}
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$20 = new $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6($thiz);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$20
}
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    var $$x13 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "street"));
    var this$2 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "postalCode"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "city")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_person_Postal(x0$15$2);
      if ((x0$15 !== null)) {
        var street$macro$43 = $n(x0$15).Lreactbuild_person_Postal__f_street;
        var postalCode$macro$44 = $n(x0$15).Lreactbuild_person_Postal__f_postalCode;
        var city$macro$45 = $n(x0$15).Lreactbuild_person_Postal__f_city;
        return new $c_Lshapeless_$colon$colon(street$macro$43, new $c_Lshapeless_$colon$colon(postalCode$macro$44, new $c_Lshapeless_$colon$colon(city$macro$45, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var street$macro$40 = $as_T($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var postalCode$macro$41 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var city$macro$42 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_Postal(street$macro$40, postalCode$macro$41, city$macro$42)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "city"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "postalCode"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "street"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var $$x12 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$46__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x9 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "street"));
    var this$21 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "postalCode"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "city")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var $$x8 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "street"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "postalCode"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "city"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$21 = $n($$x13).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x12, $$x9, $$x8, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3));
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$21
}
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$46$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$46 = new $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7($thiz);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$46
}
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$47$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "url"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "credentials")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_person_Website(x0$23$2);
      if ((x0$23 !== null)) {
        var url$macro$62 = $n(x0$23).Lreactbuild_person_Website__f_url;
        var credentials$macro$63 = $n(x0$23).Lreactbuild_person_Website__f_credentials;
        return new $c_Lshapeless_$colon$colon(url$macro$62, new $c_Lshapeless_$colon$colon(credentials$macro$63, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var url$macro$60 = $as_T($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var credentials$macro$61 = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_Website(url$macro$60, credentials$macro$61)
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "credentials"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "url"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$64__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "url"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "credentials"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$47 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$47
}
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$64$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$64 = new $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8($thiz);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$64
}
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$65$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "street"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "postalCode"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "city")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_person_Postal(x0$31$2);
      if ((x0$31 !== null)) {
        var street$macro$87 = $n(x0$31).Lreactbuild_person_Postal__f_street;
        var postalCode$macro$88 = $n(x0$31).Lreactbuild_person_Postal__f_postalCode;
        var city$macro$89 = $n(x0$31).Lreactbuild_person_Postal__f_city;
        return new $c_Lshapeless_$colon$colon(street$macro$87, new $c_Lshapeless_$colon$colon(postalCode$macro$88, new $c_Lshapeless_$colon$colon(city$macro$89, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var street$macro$84 = $as_T($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$32).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var postalCode$macro$85 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var city$macro$86 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_Postal(street$macro$84, postalCode$macro$85, city$macro$86)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "city"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "postalCode"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "street"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$90__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "street"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "postalCode"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "city"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$29 = $m_s_$less$colon$less$();
    var ev$1 = this$29.s_$less$colon$less$__f_singleton;
    var this$30 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$30);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$34 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$34);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$38 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$38);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$42 = $m_s_$less$colon$less$();
    var ev$2 = this$42.s_$less$colon$less$__f_singleton;
    var this$43 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$43);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$47 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$47);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$51 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$51);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$65 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$65
}
function $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$90$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$90 = new $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9($thiz);
    $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$90
}
/** @constructor */
function $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1() {
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$2 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$3 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$20 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$21 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$46 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$47 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$64 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$65 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$90 = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype = new $h_O();
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.constructor = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1;
/** @constructor */
function $h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype;
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$1)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$2)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$3)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$20__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$20)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$21)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$46__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$46$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$46)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$47__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((64 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$47$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$47)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$64__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$64$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$64)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$65__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$65$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$65)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.inst$macro$90__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__inst$macro$90$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1__f_inst$macro$90)
});
var $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1 = new $TypeData().initClass({
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1: 0
}, false, "reactbuild.person.AddressDetails$anon$lazy$macro$91$1", {
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1.prototype.$classData = $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1;
/** @constructor */
function $c_Lreactbuild_person_BoundedField$() {
  /*<skip>*/
}
$c_Lreactbuild_person_BoundedField$.prototype = new $h_O();
$c_Lreactbuild_person_BoundedField$.prototype.constructor = $c_Lreactbuild_person_BoundedField$;
/** @constructor */
function $h_Lreactbuild_person_BoundedField$() {
  /*<skip>*/
}
$h_Lreactbuild_person_BoundedField$.prototype = $c_Lreactbuild_person_BoundedField$.prototype;
$c_Lreactbuild_person_BoundedField$.prototype.encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject = (function(encB) {
  var inst$macro$12 = new $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2(encB).inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var encode = new $c_Lshapeless_Lazy$$anon$1(t);
  return $as_Lio_circe_Encoder$AsObject(encode.value__O())
});
$c_Lreactbuild_person_BoundedField$.prototype.decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder = (function(decB) {
  var inst$macro$12 = new $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3(decB).inst$macro$1__Lio_circe_generic_extras_decoding_ConfiguredDecoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t);
  return $as_Lio_circe_Decoder(decode.value__O())
});
var $d_Lreactbuild_person_BoundedField$ = new $TypeData().initClass({
  Lreactbuild_person_BoundedField$: 0
}, false, "reactbuild.person.BoundedField$", {
  Lreactbuild_person_BoundedField$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_BoundedField$.prototype.$classData = $d_Lreactbuild_person_BoundedField$;
var $n_Lreactbuild_person_BoundedField$;
function $m_Lreactbuild_person_BoundedField$() {
  if ((!$n_Lreactbuild_person_BoundedField$)) {
    $n_Lreactbuild_person_BoundedField$ = new $c_Lreactbuild_person_BoundedField$()
  };
  return $n_Lreactbuild_person_BoundedField$
}
function $p_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "bounds")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_BoundedField(x0$7$2);
      if ((x0$7 !== null)) {
        var bounds$macro$9 = $n(x0$7).Lreactbuild_person_BoundedField__f_bounds;
        return new $c_Lshapeless_$colon$colon(bounds$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var bounds$macro$8 = $as_Lreactbuild_person_Bounds($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_BoundedField(bounds$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "bounds"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "bounds"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_inst$macro$1
}
function $p_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_inst$macro$10 = new $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5($thiz);
    $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2(encB$1) {
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_inst$macro$1 = null;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_inst$macro$10 = null;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_bitmap$0 = 0;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_encB$1 = null;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_encB$1 = encB$1
}
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2.prototype = new $h_O();
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2.prototype.constructor = $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2;
/** @constructor */
function $h_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2.prototype = $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2.prototype;
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2.prototype.inst$macro$1__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((1 & this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_inst$macro$1)
});
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2.prototype.inst$macro$10__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((2 & this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_inst$macro$10)
});
var $d_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2 = new $TypeData().initClass({
  Lreactbuild_person_BoundedField$anon$lazy$macro$11$2: 0
}, false, "reactbuild.person.BoundedField$anon$lazy$macro$11$2", {
  Lreactbuild_person_BoundedField$anon$lazy$macro$11$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2.prototype.$classData = $d_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2;
function $p_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "bounds")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_BoundedField(x0$7$2);
      if ((x0$7 !== null)) {
        var bounds$macro$9 = $n(x0$7).Lreactbuild_person_BoundedField__f_bounds;
        return new $c_Lshapeless_$colon$colon(bounds$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var bounds$macro$8 = $as_Lreactbuild_person_Bounds($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_BoundedField(bounds$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "bounds"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "bounds")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "bounds"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_inst$macro$1 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_inst$macro$1
}
function $p_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__inst$macro$10$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_inst$macro$10 = new $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6($thiz);
    $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3(decB$1) {
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_inst$macro$1 = null;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_inst$macro$10 = null;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_bitmap$0 = 0;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_decB$1 = null;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_decB$1 = decB$1
}
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3.prototype = new $h_O();
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3.prototype.constructor = $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3;
/** @constructor */
function $h_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3() {
  /*<skip>*/
}
$h_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3.prototype = $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3.prototype;
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3.prototype.inst$macro$1__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((1 & this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_inst$macro$1)
});
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3.prototype.inst$macro$10__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__inst$macro$10$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_inst$macro$10)
});
var $d_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3 = new $TypeData().initClass({
  Lreactbuild_person_BoundedField$anon$lazy$macro$11$3: 0
}, false, "reactbuild.person.BoundedField$anon$lazy$macro$11$3", {
  Lreactbuild_person_BoundedField$anon$lazy$macro$11$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3.prototype.$classData = $d_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3;
/** @constructor */
function $c_Lreactbuild_person_CachedQuantifiedExpression$() {
  this.Lreactbuild_person_CachedQuantifiedExpression$__f_codecForCachedQuantifiedExpression = null;
  $n_Lreactbuild_person_CachedQuantifiedExpression$ = this;
  var inst$macro$20 = new $c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_CachedQuantifiedExpression$__f_codecForCachedQuantifiedExpression = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_CachedQuantifiedExpression$.prototype = new $h_O();
$c_Lreactbuild_person_CachedQuantifiedExpression$.prototype.constructor = $c_Lreactbuild_person_CachedQuantifiedExpression$;
/** @constructor */
function $h_Lreactbuild_person_CachedQuantifiedExpression$() {
  /*<skip>*/
}
$h_Lreactbuild_person_CachedQuantifiedExpression$.prototype = $c_Lreactbuild_person_CachedQuantifiedExpression$.prototype;
var $d_Lreactbuild_person_CachedQuantifiedExpression$ = new $TypeData().initClass({
  Lreactbuild_person_CachedQuantifiedExpression$: 0
}, false, "reactbuild.person.CachedQuantifiedExpression$", {
  Lreactbuild_person_CachedQuantifiedExpression$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CachedQuantifiedExpression$.prototype.$classData = $d_Lreactbuild_person_CachedQuantifiedExpression$;
var $n_Lreactbuild_person_CachedQuantifiedExpression$;
function $m_Lreactbuild_person_CachedQuantifiedExpression$() {
  if ((!$n_Lreactbuild_person_CachedQuantifiedExpression$)) {
    $n_Lreactbuild_person_CachedQuantifiedExpression$ = new $c_Lreactbuild_person_CachedQuantifiedExpression$()
  };
  return $n_Lreactbuild_person_CachedQuantifiedExpression$
}
function $p_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "cache"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "expression")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_CachedQuantifiedExpression(x0$7$2);
      if ((x0$7 !== null)) {
        var cache$macro$16 = $n(x0$7).Lreactbuild_person_CachedQuantifiedExpression__f_cache;
        var expression$macro$17 = $n(x0$7).Lreactbuild_person_CachedQuantifiedExpression__f_expression;
        return new $c_Lshapeless_$colon$colon(cache$macro$16, new $c_Lshapeless_$colon$colon(expression$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var cache$macro$14 = $uD($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var expression$macro$15 = $as_Lreactbuild_person_QuantifiedExpression($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_CachedQuantifiedExpression(cache$macro$14, expression$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "expression"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "cache"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "cache"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "expression")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "cache"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "expression"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_inst$macro$1
}
function $p_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_inst$macro$18 = new $c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2($thiz);
    $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1() {
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_inst$macro$18 = null;
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1.prototype = new $h_O();
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1.prototype.constructor = $c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1;
/** @constructor */
function $h_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1.prototype = $c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1.prototype;
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_inst$macro$1)
});
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1__f_inst$macro$18)
});
var $d_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1 = new $TypeData().initClass({
  Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1: 0
}, false, "reactbuild.person.CachedQuantifiedExpression$anon$lazy$macro$19$1", {
  Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1.prototype.$classData = $d_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1;
/** @constructor */
function $c_Lreactbuild_person_Credential$() {
  this.Lreactbuild_person_Credential$__f_codecForCredential = null;
  $n_Lreactbuild_person_Credential$ = this;
  var inst$macro$20 = new $c_Lreactbuild_person_Credential$anon$lazy$macro$19$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_Credential$__f_codecForCredential = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_Credential$.prototype = new $h_O();
$c_Lreactbuild_person_Credential$.prototype.constructor = $c_Lreactbuild_person_Credential$;
/** @constructor */
function $h_Lreactbuild_person_Credential$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Credential$.prototype = $c_Lreactbuild_person_Credential$.prototype;
$c_Lreactbuild_person_Credential$.prototype.apply$default$2__sci_Map = (function() {
  var this$9 = $n($m_s_Predef$().s_Predef$__f_Map);
  var y = new $c_Lreactbuild_person_TextCredentialData("");
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "id", y);
  var y$1 = new $c_Lreactbuild_person_PasswordCredentialData($m_s_None$());
  var array = [$$x1, $ct_T2__O__O__(new $c_T2(), "password", y$1)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return this$9.from__sc_IterableOnce__sci_Map(elems)
});
var $d_Lreactbuild_person_Credential$ = new $TypeData().initClass({
  Lreactbuild_person_Credential$: 0
}, false, "reactbuild.person.Credential$", {
  Lreactbuild_person_Credential$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Credential$.prototype.$classData = $d_Lreactbuild_person_Credential$;
var $n_Lreactbuild_person_Credential$;
function $m_Lreactbuild_person_Credential$() {
  if ((!$n_Lreactbuild_person_Credential$)) {
    $n_Lreactbuild_person_Credential$ = new $c_Lreactbuild_person_Credential$()
  };
  return $n_Lreactbuild_person_Credential$
}
function $p_Lreactbuild_person_Credential$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "name"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "data")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_Credential(x0$7$2);
      if ((x0$7 !== null)) {
        var name$macro$16 = $n(x0$7).Lreactbuild_person_Credential__f_name;
        var data$macro$17 = $n(x0$7).Lreactbuild_person_Credential__f_data;
        return new $c_Lshapeless_$colon$colon(name$macro$16, new $c_Lshapeless_$colon$colon(data$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var name$macro$14 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var data$macro$15 = $as_sci_Map($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_Credential(name$macro$14, data$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "data"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_Credential$(), "identifiants de connexion")), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_Lreactbuild_person_Credential$().apply$default$2__sci_Map()), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "name"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "data")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "name"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "data"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "data"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$36 = $m_s_$less$colon$less$();
    var ev$1 = this$36.s_$less$colon$less$__f_singleton;
    var this$37 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$37);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$41 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$41);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$45 = $m_s_$less$colon$less$();
    var ev$2 = this$45.s_$less$colon$less$__f_singleton;
    var this$46 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$46);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$50 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$50);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_inst$macro$1
}
function $p_Lreactbuild_person_Credential$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_inst$macro$18 = new $c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4($thiz);
    $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_person_Credential$anon$lazy$macro$19$1() {
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_inst$macro$18 = null;
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1.prototype = new $h_O();
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1.prototype.constructor = $c_Lreactbuild_person_Credential$anon$lazy$macro$19$1;
/** @constructor */
function $h_Lreactbuild_person_Credential$anon$lazy$macro$19$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_Credential$anon$lazy$macro$19$1.prototype = $c_Lreactbuild_person_Credential$anon$lazy$macro$19$1.prototype;
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Credential$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_inst$macro$1)
});
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Credential$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_Credential$anon$lazy$macro$19$1__f_inst$macro$18)
});
var $d_Lreactbuild_person_Credential$anon$lazy$macro$19$1 = new $TypeData().initClass({
  Lreactbuild_person_Credential$anon$lazy$macro$19$1: 0
}, false, "reactbuild.person.Credential$anon$lazy$macro$19$1", {
  Lreactbuild_person_Credential$anon$lazy$macro$19$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1.prototype.$classData = $d_Lreactbuild_person_Credential$anon$lazy$macro$19$1;
function $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "PasswordCredentialData"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "TextCredentialData")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_person_CredentialData(p$2);
      var $$x3 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_person_PasswordCredentialData)) {
        var $$x2 = 0
      } else {
        if ((!(p instanceof $c_Lreactbuild_person_TextCredentialData))) {
          throw new $c_s_MatchError(p)
        };
        var $$x2 = 1
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x3).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x2, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_person_CredentialData($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "TextCredentialData"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "PasswordCredentialData"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$1
}
function $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$2 = new $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1($thiz);
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$2
}
function $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "password")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_PasswordCredentialData(x0$7$2);
      if ((x0$7 !== null)) {
        var password$macro$11 = $n(x0$7).Lreactbuild_person_PasswordCredentialData__f_password;
        return new $c_Lshapeless_$colon$colon(password$macro$11, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var password$macro$10 = $as_s_Option($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_PasswordCredentialData(password$macro$10)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "password"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$13 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "password")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "password"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "password"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$25 = $m_s_$less$colon$less$();
    var ev$1 = this$25.s_$less$colon$less$__f_singleton;
    var this$26 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$26);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$30 = $m_s_$less$colon$less$();
    var ev$2 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$31);
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$3
}
function $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$12 = new $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2($thiz);
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$12
}
function $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "password")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_person_PasswordCredentialData(x0$15$2);
      if ((x0$15 !== null)) {
        var password$macro$21 = $n(x0$15).Lreactbuild_person_PasswordCredentialData__f_password;
        return new $c_Lshapeless_$colon$colon(password$macro$21, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var password$macro$20 = $as_s_Option($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$16).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_PasswordCredentialData(password$macro$20)
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "password"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$22__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "password"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$13 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$13
}
function $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$22 = new $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3($thiz);
    $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$22
}
/** @constructor */
function $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1() {
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$2 = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$3 = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$12 = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$13 = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$22 = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype = new $h_O();
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype.constructor = $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1;
/** @constructor */
function $h_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype = $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype;
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$1)
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$2)
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((4 & this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$3)
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((8 & this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$12)
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype.inst$macro$13__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((16 & this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$13)
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype.inst$macro$22__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((32 & this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1__f_inst$macro$22)
});
var $d_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1 = new $TypeData().initClass({
  Lreactbuild_person_CredentialData$anon$lazy$macro$23$1: 0
}, false, "reactbuild.person.CredentialData$anon$lazy$macro$23$1", {
  Lreactbuild_person_CredentialData$anon$lazy$macro$23$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1.prototype.$classData = $d_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1;
/** @constructor */
function $c_Lreactbuild_person_CustomerFacet$() {
  this.Lreactbuild_person_CustomerFacet$__f_codecForCustomerFacet = null;
  $n_Lreactbuild_person_CustomerFacet$ = this;
  var inst$macro$4 = new $c_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$4));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_CustomerFacet$__f_codecForCustomerFacet = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_CustomerFacet$.prototype = new $h_O();
$c_Lreactbuild_person_CustomerFacet$.prototype.constructor = $c_Lreactbuild_person_CustomerFacet$;
/** @constructor */
function $h_Lreactbuild_person_CustomerFacet$() {
  /*<skip>*/
}
$h_Lreactbuild_person_CustomerFacet$.prototype = $c_Lreactbuild_person_CustomerFacet$.prototype;
var $d_Lreactbuild_person_CustomerFacet$ = new $TypeData().initClass({
  Lreactbuild_person_CustomerFacet$: 0
}, false, "reactbuild.person.CustomerFacet$", {
  Lreactbuild_person_CustomerFacet$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CustomerFacet$.prototype.$classData = $d_Lreactbuild_person_CustomerFacet$;
var $n_Lreactbuild_person_CustomerFacet$;
function $m_Lreactbuild_person_CustomerFacet$() {
  if ((!$n_Lreactbuild_person_CustomerFacet$)) {
    $n_Lreactbuild_person_CustomerFacet$ = new $c_Lreactbuild_person_CustomerFacet$()
  };
  return $n_Lreactbuild_person_CustomerFacet$
}
function $p_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_CustomerFacet(x0$7$2);
      if ((x0$7 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_HNil(x0$8$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$8)) {
        return new $c_Lreactbuild_person_CustomerFacet()
      } else {
        throw new $c_s_MatchError(x0$8)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_inst$macro$1
}
function $p_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_inst$macro$2 = $m_Lio_circe_generic_extras_codec_ReprAsObjectCodec$().Lio_circe_generic_extras_codec_ReprAsObjectCodec$__f_hnilReprCodec;
    $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_inst$macro$2
}
/** @constructor */
function $c_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1() {
  this.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_inst$macro$2 = null;
  this.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1.prototype = new $h_O();
$c_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1.prototype.constructor = $c_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1;
/** @constructor */
function $h_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1.prototype = $c_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1.prototype;
$c_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_inst$macro$1)
});
$c_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1__f_inst$macro$2)
});
var $d_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1 = new $TypeData().initClass({
  Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1: 0
}, false, "reactbuild.person.CustomerFacet$anon$lazy$macro$3$1", {
  Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1.prototype.$classData = $d_Lreactbuild_person_CustomerFacet$anon$lazy$macro$3$1;
/** @constructor */
function $c_Lreactbuild_person_DeliveryHeaderFormat$() {
  this.Lreactbuild_person_DeliveryHeaderFormat$__f_codecForDeliveryHeaderFormat = null;
  $n_Lreactbuild_person_DeliveryHeaderFormat$ = this;
  var inst$macro$28 = new $c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_DeliveryHeaderFormat$__f_codecForDeliveryHeaderFormat = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_DeliveryHeaderFormat$.prototype = new $h_O();
$c_Lreactbuild_person_DeliveryHeaderFormat$.prototype.constructor = $c_Lreactbuild_person_DeliveryHeaderFormat$;
/** @constructor */
function $h_Lreactbuild_person_DeliveryHeaderFormat$() {
  /*<skip>*/
}
$h_Lreactbuild_person_DeliveryHeaderFormat$.prototype = $c_Lreactbuild_person_DeliveryHeaderFormat$.prototype;
var $d_Lreactbuild_person_DeliveryHeaderFormat$ = new $TypeData().initClass({
  Lreactbuild_person_DeliveryHeaderFormat$: 0
}, false, "reactbuild.person.DeliveryHeaderFormat$", {
  Lreactbuild_person_DeliveryHeaderFormat$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DeliveryHeaderFormat$.prototype.$classData = $d_Lreactbuild_person_DeliveryHeaderFormat$;
var $n_Lreactbuild_person_DeliveryHeaderFormat$;
function $m_Lreactbuild_person_DeliveryHeaderFormat$() {
  if ((!$n_Lreactbuild_person_DeliveryHeaderFormat$)) {
    $n_Lreactbuild_person_DeliveryHeaderFormat$ = new $c_Lreactbuild_person_DeliveryHeaderFormat$()
  };
  return $n_Lreactbuild_person_DeliveryHeaderFormat$
}
function $p_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "date"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "supplierReference"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "reference")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_DeliveryHeaderFormat(x0$7$2);
      if ((x0$7 !== null)) {
        var date$macro$23 = $n(x0$7).Lreactbuild_person_DeliveryHeaderFormat__f_date;
        var supplierReference$macro$24 = $n(x0$7).Lreactbuild_person_DeliveryHeaderFormat__f_supplierReference;
        var reference$macro$25 = $n(x0$7).Lreactbuild_person_DeliveryHeaderFormat__f_reference;
        return new $c_Lshapeless_$colon$colon(date$macro$23, new $c_Lshapeless_$colon$colon(supplierReference$macro$24, new $c_Lshapeless_$colon$colon(reference$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var date$macro$20 = $as_Lreactbuild_person_BoundedField($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var supplierReference$macro$21 = $as_Lreactbuild_person_BoundedField($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var reference$macro$22 = $as_Lreactbuild_person_BoundedField($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_DeliveryHeaderFormat(date$macro$20, supplierReference$macro$21, reference$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "supplierReference"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "date"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "supplierReference"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "reference")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "date"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "supplierReference"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "reference"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_inst$macro$1
}
function $p_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_inst$macro$26 = new $c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9($thiz);
    $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1() {
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_inst$macro$26 = null;
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1.prototype = new $h_O();
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1.prototype.constructor = $c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1;
/** @constructor */
function $h_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1.prototype = $c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1.prototype;
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_inst$macro$1)
});
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1__f_inst$macro$26)
});
var $d_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1 = new $TypeData().initClass({
  Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1: 0
}, false, "reactbuild.person.DeliveryHeaderFormat$anon$lazy$macro$27$1", {
  Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1.prototype.$classData = $d_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1;
/** @constructor */
function $c_Lreactbuild_person_DocumentFieldLevel$() {
  this.Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel = null;
  $n_Lreactbuild_person_DocumentFieldLevel$ = this;
  var inst$macro$60 = new $c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$60));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_DocumentFieldLevel$.prototype = new $h_O();
$c_Lreactbuild_person_DocumentFieldLevel$.prototype.constructor = $c_Lreactbuild_person_DocumentFieldLevel$;
/** @constructor */
function $h_Lreactbuild_person_DocumentFieldLevel$() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentFieldLevel$.prototype = $c_Lreactbuild_person_DocumentFieldLevel$.prototype;
var $d_Lreactbuild_person_DocumentFieldLevel$ = new $TypeData().initClass({
  Lreactbuild_person_DocumentFieldLevel$: 0
}, false, "reactbuild.person.DocumentFieldLevel$", {
  Lreactbuild_person_DocumentFieldLevel$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentFieldLevel$.prototype.$classData = $d_Lreactbuild_person_DocumentFieldLevel$;
var $n_Lreactbuild_person_DocumentFieldLevel$;
function $m_Lreactbuild_person_DocumentFieldLevel$() {
  if ((!$n_Lreactbuild_person_DocumentFieldLevel$)) {
    $n_Lreactbuild_person_DocumentFieldLevel$ = new $c_Lreactbuild_person_DocumentFieldLevel$()
  };
  return $n_Lreactbuild_person_DocumentFieldLevel$
}
function $p_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "reference"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "netAmount"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "taxAmount"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "totalAmount"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "date"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "target"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "category")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_DocumentFieldLevel(x0$7$2);
      if ((x0$7 !== null)) {
        var reference$macro$51 = $n(x0$7).Lreactbuild_person_DocumentFieldLevel__f_reference;
        var netAmount$macro$52 = $n(x0$7).Lreactbuild_person_DocumentFieldLevel__f_netAmount;
        var taxAmount$macro$53 = $n(x0$7).Lreactbuild_person_DocumentFieldLevel__f_taxAmount;
        var totalAmount$macro$54 = $n(x0$7).Lreactbuild_person_DocumentFieldLevel__f_totalAmount;
        var date$macro$55 = $n(x0$7).Lreactbuild_person_DocumentFieldLevel__f_date;
        var target$macro$56 = $n(x0$7).Lreactbuild_person_DocumentFieldLevel__f_target;
        var category$macro$57 = $n(x0$7).Lreactbuild_person_DocumentFieldLevel__f_category;
        return new $c_Lshapeless_$colon$colon(reference$macro$51, new $c_Lshapeless_$colon$colon(netAmount$macro$52, new $c_Lshapeless_$colon$colon(taxAmount$macro$53, new $c_Lshapeless_$colon$colon(totalAmount$macro$54, new $c_Lshapeless_$colon$colon(date$macro$55, new $c_Lshapeless_$colon$colon(target$macro$56, new $c_Lshapeless_$colon$colon(category$macro$57, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var reference$macro$44 = $as_Lreactbuild_person_BoundedField($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var netAmount$macro$45 = $as_Lreactbuild_person_BoundedField($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var taxAmount$macro$46 = $as_Lreactbuild_person_BoundedField($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var totalAmount$macro$47 = $as_Lreactbuild_person_BoundedField($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var date$macro$48 = $as_Lreactbuild_person_BoundedField($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var target$macro$49 = $as_Lreactbuild_person_BoundedField($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var category$macro$50 = $as_Lreactbuild_person_BoundedField($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_person_DocumentFieldLevel(reference$macro$44, netAmount$macro$45, taxAmount$macro$46, totalAmount$macro$47, date$macro$48, target$macro$49, category$macro$50)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "totalAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "taxAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "netAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$36 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "reference"));
    var this$37 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "netAmount"));
    var this$38 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "taxAmount"));
    var this$39 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "totalAmount"));
    var this$40 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "date"));
    var this$41 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "target"));
    var this$42 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "category")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "reference"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "netAmount"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "taxAmount"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "totalAmount"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "date"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "target"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "category"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$75 = $m_s_$less$colon$less$();
    var ev$1 = this$75.s_$less$colon$less$__f_singleton;
    var this$76 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$76);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$80 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$88);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$92 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$92);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$96 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$96);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$100 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$100);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$104 = $m_s_$less$colon$less$();
    var ev$2 = this$104.s_$less$colon$less$__f_singleton;
    var this$105 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$113);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$117 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$117);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$121 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$121);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$125 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$125);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$129 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$129);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_inst$macro$1
}
function $p_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_inst$macro$58 = new $c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7($thiz);
    $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1() {
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_inst$macro$58 = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1.prototype = new $h_O();
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1.prototype.constructor = $c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1;
/** @constructor */
function $h_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1.prototype = $c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1.prototype;
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_inst$macro$1)
});
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1.prototype.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1__f_inst$macro$58)
});
var $d_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1 = new $TypeData().initClass({
  Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1: 0
}, false, "reactbuild.person.DocumentFieldLevel$anon$lazy$macro$59$1", {
  Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1.prototype.$classData = $d_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserArea$() {
  $n_Lreactbuild_person_DocumentParserArea$ = this;
  var inst$macro$60 = new $c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$60));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_DocumentParserArea$.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserArea$.prototype.constructor = $c_Lreactbuild_person_DocumentParserArea$;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserArea$() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserArea$.prototype = $c_Lreactbuild_person_DocumentParserArea$.prototype;
var $d_Lreactbuild_person_DocumentParserArea$ = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserArea$: 0
}, false, "reactbuild.person.DocumentParserArea$", {
  Lreactbuild_person_DocumentParserArea$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserArea$.prototype.$classData = $d_Lreactbuild_person_DocumentParserArea$;
var $n_Lreactbuild_person_DocumentParserArea$;
function $m_Lreactbuild_person_DocumentParserArea$() {
  if ((!$n_Lreactbuild_person_DocumentParserArea$)) {
    $n_Lreactbuild_person_DocumentParserArea$ = new $c_Lreactbuild_person_DocumentParserArea$()
  };
  return $n_Lreactbuild_person_DocumentParserArea$
}
function $p_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "left"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "top"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "width"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "height"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "id"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "name"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "columns")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_DocumentParserArea(x0$7$2);
      if ((x0$7 !== null)) {
        var left$macro$51 = $n(x0$7).Lreactbuild_person_DocumentParserArea__f_left;
        var top$macro$52 = $n(x0$7).Lreactbuild_person_DocumentParserArea__f_top;
        var width$macro$53 = $n(x0$7).Lreactbuild_person_DocumentParserArea__f_width;
        var height$macro$54 = $n(x0$7).Lreactbuild_person_DocumentParserArea__f_height;
        var id$macro$55 = $n(x0$7).Lreactbuild_person_DocumentParserArea__f_id;
        var name$macro$56 = $n(x0$7).Lreactbuild_person_DocumentParserArea__f_name;
        var columns$macro$57 = $n(x0$7).Lreactbuild_person_DocumentParserArea__f_columns;
        return new $c_Lshapeless_$colon$colon(left$macro$51, new $c_Lshapeless_$colon$colon(top$macro$52, new $c_Lshapeless_$colon$colon(width$macro$53, new $c_Lshapeless_$colon$colon(height$macro$54, new $c_Lshapeless_$colon$colon(id$macro$55, new $c_Lshapeless_$colon$colon(name$macro$56, new $c_Lshapeless_$colon$colon(columns$macro$57, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var left$macro$44 = $uD($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var top$macro$45 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var width$macro$46 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var height$macro$47 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var id$macro$48 = $as_ju_UUID($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var name$macro$49 = $as_T($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var columns$macro$50 = $as_sci_List($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_person_DocumentParserArea(left$macro$44, top$macro$45, width$macro$46, height$macro$47, id$macro$48, name$macro$49, columns$macro$50)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "columns"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "height"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "width"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "top"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "left"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_DocumentParserArea$(), $m_ju_UUID$().randomUUID__ju_UUID())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_DocumentParserArea$(), "")), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_DocumentParserArea$(), $m_s_package$().s_package$__f_Nil)), $m_Lshapeless_HNil$())))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$38 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "left"));
    var this$39 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "top"));
    var this$40 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "width"));
    var this$41 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "height"));
    var this$42 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "id"));
    var this$43 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "name"));
    var this$44 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "columns")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "id"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "name"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "columns"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$64 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "left"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$66 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "top"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$68 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "width"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$70 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$70, "height"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$72 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$72, "id"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$74 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "name"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$76 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "columns"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$16);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$86 = $m_s_$less$colon$less$();
    var ev$1 = this$86.s_$less$colon$less$__f_singleton;
    var this$87 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$91);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$95 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$95);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$99 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$99);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$103 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$103);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$107 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$107);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$111 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$111);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$115 = $m_s_$less$colon$less$();
    var ev$2 = this$115.s_$less$colon$less$__f_singleton;
    var this$116 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$116);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$120 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$120);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$124 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$124);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$128 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$128);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$132 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$132);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$136 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$136);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$140 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$140);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_inst$macro$1
}
function $p_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_inst$macro$58 = new $c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25($thiz);
    $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1() {
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_inst$macro$58 = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1.prototype.constructor = $c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1.prototype = $c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1.prototype;
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_inst$macro$1)
});
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1.prototype.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1__f_inst$macro$58)
});
var $d_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1: 0
}, false, "reactbuild.person.DocumentParserArea$anon$lazy$macro$59$1", {
  Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1.prototype.$classData = $d_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserColumn$() {
  this.Lreactbuild_person_DocumentParserColumn$__f_codecForDocumentParserColumn = null;
  $n_Lreactbuild_person_DocumentParserColumn$ = this;
  var inst$macro$28 = new $c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_DocumentParserColumn$__f_codecForDocumentParserColumn = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_DocumentParserColumn$.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserColumn$.prototype.constructor = $c_Lreactbuild_person_DocumentParserColumn$;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserColumn$() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserColumn$.prototype = $c_Lreactbuild_person_DocumentParserColumn$.prototype;
var $d_Lreactbuild_person_DocumentParserColumn$ = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserColumn$: 0
}, false, "reactbuild.person.DocumentParserColumn$", {
  Lreactbuild_person_DocumentParserColumn$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserColumn$.prototype.$classData = $d_Lreactbuild_person_DocumentParserColumn$;
var $n_Lreactbuild_person_DocumentParserColumn$;
function $m_Lreactbuild_person_DocumentParserColumn$() {
  if ((!$n_Lreactbuild_person_DocumentParserColumn$)) {
    $n_Lreactbuild_person_DocumentParserColumn$ = new $c_Lreactbuild_person_DocumentParserColumn$()
  };
  return $n_Lreactbuild_person_DocumentParserColumn$
}
function $p_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "width"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "id"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_DocumentParserColumn(x0$7$2);
      if ((x0$7 !== null)) {
        var width$macro$23 = $n(x0$7).Lreactbuild_person_DocumentParserColumn__f_width;
        var id$macro$24 = $n(x0$7).Lreactbuild_person_DocumentParserColumn__f_id;
        var name$macro$25 = $n(x0$7).Lreactbuild_person_DocumentParserColumn__f_name;
        return new $c_Lshapeless_$colon$colon(width$macro$23, new $c_Lshapeless_$colon$colon(id$macro$24, new $c_Lshapeless_$colon$colon(name$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var width$macro$20 = $uD($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var id$macro$21 = $as_ju_UUID($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$22 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_DocumentParserColumn(width$macro$20, id$macro$21, name$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "width"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_DocumentParserColumn$(), $m_ju_UUID$().randomUUID__ju_UUID())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_DocumentParserColumn$(), "")), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$21 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "width"));
    var this$22 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "id"));
    var this$23 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "name")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "id"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "name"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$4);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "width"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "name"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$46 = $m_s_$less$colon$less$();
    var ev$1 = this$46.s_$less$colon$less$__f_singleton;
    var this$47 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$47);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$51 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$51);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$55 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$55);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$59 = $m_s_$less$colon$less$();
    var ev$2 = this$59.s_$less$colon$less$__f_singleton;
    var this$60 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$60);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$64 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$64);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$68 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$68);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_inst$macro$1
}
function $p_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_inst$macro$26 = new $c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24($thiz);
    $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4() {
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_inst$macro$1 = null;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_inst$macro$26 = null;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_bitmap$0 = 0
}
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4.prototype.constructor = $c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4.prototype = $c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4.prototype;
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_inst$macro$1)
});
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4__f_inst$macro$26)
});
var $d_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4: 0
}, false, "reactbuild.person.DocumentParserColumn$anon$lazy$macro$27$4", {
  Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4.prototype.$classData = $d_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4;
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "CustomFormat"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "DocumentLevelOnly"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "DocumentWithRows"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "InvoiceWithDeliveryFormDetailGroup")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_person_DocumentParserFormat(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_person_CustomFormat)) {
        var $$x4 = 0
      } else if ((p instanceof $c_Lreactbuild_person_DocumentLevelOnly)) {
        var $$x4 = 1
      } else if ((p instanceof $c_Lreactbuild_person_DocumentWithRows)) {
        var $$x4 = 2
      } else {
        if ((!(p instanceof $c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup))) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_person_DocumentParserFormat($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "InvoiceWithDeliveryFormDetailGroup"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "DocumentWithRows"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "DocumentLevelOnly"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "CustomFormat"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$1
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$2 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10($thiz);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$2
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    var $$x15 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "documentFieldLevel"));
    var this$2 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "table"));
    var this$3 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "deliveryHeader"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "rowFieldLevel")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(x0$7$2);
      if ((x0$7 !== null)) {
        var documentFieldLevel$macro$32 = $n(x0$7).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_documentFieldLevel;
        var table$macro$33 = $n(x0$7).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_table;
        var deliveryHeader$macro$34 = $n(x0$7).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_deliveryHeader;
        var rowFieldLevel$macro$35 = $n(x0$7).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_rowFieldLevel;
        return new $c_Lshapeless_$colon$colon(documentFieldLevel$macro$32, new $c_Lshapeless_$colon$colon(table$macro$33, new $c_Lshapeless_$colon$colon(deliveryHeader$macro$34, new $c_Lshapeless_$colon$colon(rowFieldLevel$macro$35, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var documentFieldLevel$macro$28 = $as_Lreactbuild_person_DocumentFieldLevel($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var table$macro$29 = $as_Lreactbuild_person_VerticalInterval($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var deliveryHeader$macro$30 = $as_Lreactbuild_person_DeliveryHeaderFormat($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var rowFieldLevel$macro$31 = $as_Lreactbuild_person_RowFieldLevel($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(documentFieldLevel$macro$28, table$macro$29, deliveryHeader$macro$30, rowFieldLevel$macro$31)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "rowFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "deliveryHeader"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "table"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "documentFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var $$x14 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$36__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x10 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$24 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "documentFieldLevel"));
    var this$25 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "table"));
    var this$26 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "deliveryHeader"));
    var this$27 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "rowFieldLevel")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var $$x9 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "documentFieldLevel"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "table"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "deliveryHeader"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "rowFieldLevel"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$48 = $m_s_$less$colon$less$();
    var ev$1 = this$48.s_$less$colon$less$__f_singleton;
    var this$49 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$49);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$53 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$61);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$65 = $m_s_$less$colon$less$();
    var ev$2 = this$65.s_$less$colon$less$__f_singleton;
    var this$66 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$78);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$3 = $n($$x15).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x14, $$x10, $$x9, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5));
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$3
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$36$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$36 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11($thiz);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$36
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    var $$x13 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "documentFieldLevel"));
    var this$2 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "table"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "rowFieldLevel")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_person_DocumentWithRows(x0$15$2);
      if ((x0$15 !== null)) {
        var documentFieldLevel$macro$59 = $n(x0$15).Lreactbuild_person_DocumentWithRows__f_documentFieldLevel;
        var table$macro$60 = $n(x0$15).Lreactbuild_person_DocumentWithRows__f_table;
        var rowFieldLevel$macro$61 = $n(x0$15).Lreactbuild_person_DocumentWithRows__f_rowFieldLevel;
        return new $c_Lshapeless_$colon$colon(documentFieldLevel$macro$59, new $c_Lshapeless_$colon$colon(table$macro$60, new $c_Lshapeless_$colon$colon(rowFieldLevel$macro$61, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var documentFieldLevel$macro$56 = $as_Lreactbuild_person_DocumentFieldLevel($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var table$macro$57 = $as_Lreactbuild_person_VerticalInterval($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var rowFieldLevel$macro$58 = $as_Lreactbuild_person_RowFieldLevel($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_DocumentWithRows(documentFieldLevel$macro$56, table$macro$57, rowFieldLevel$macro$58)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "rowFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "table"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "documentFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var $$x12 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$62__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x9 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "documentFieldLevel"));
    var this$21 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "table"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "rowFieldLevel")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var $$x8 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "documentFieldLevel"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "table"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "rowFieldLevel"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$37 = $n($$x13).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x12, $$x9, $$x8, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3));
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$37
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$62$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$62 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12($thiz);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$62
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$63$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "documentFieldLevel"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "project")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_person_DocumentLevelOnly(x0$23$2);
      if ((x0$23 !== null)) {
        var documentFieldLevel$macro$78 = $n(x0$23).Lreactbuild_person_DocumentLevelOnly__f_documentFieldLevel;
        var project$macro$79 = $n(x0$23).Lreactbuild_person_DocumentLevelOnly__f_project;
        return new $c_Lshapeless_$colon$colon(documentFieldLevel$macro$78, new $c_Lshapeless_$colon$colon(project$macro$79, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var documentFieldLevel$macro$76 = $as_Lreactbuild_person_DocumentFieldLevel($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var project$macro$77 = $as_Lreactbuild_person_BoundedField($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_DocumentLevelOnly(documentFieldLevel$macro$76, project$macro$77)
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "documentFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$80__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "documentFieldLevel"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "project")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "documentFieldLevel"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "project"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$63 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$63
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$80$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$80 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13($thiz);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$80
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$81$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((256 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "documentFieldLevel")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_person_CustomFormat(x0$31$2);
      if ((x0$31 !== null)) {
        var documentFieldLevel$macro$89 = $n(x0$31).Lreactbuild_person_CustomFormat__f_documentFieldLevel;
        return new $c_Lshapeless_$colon$colon(documentFieldLevel$macro$89, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var documentFieldLevel$macro$88 = $as_Lreactbuild_person_DocumentFieldLevel($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$32).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_CustomFormat(documentFieldLevel$macro$88)
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "documentFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$90__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "documentFieldLevel")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "documentFieldLevel"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$81 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$81
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$90$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((512 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$90 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14($thiz);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$90
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$91$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "documentFieldLevel"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "table"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "deliveryHeader"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "rowFieldLevel")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(x0$39$2);
      if ((x0$39 !== null)) {
        var documentFieldLevel$macro$120 = $n(x0$39).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_documentFieldLevel;
        var table$macro$121 = $n(x0$39).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_table;
        var deliveryHeader$macro$122 = $n(x0$39).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_deliveryHeader;
        var rowFieldLevel$macro$123 = $n(x0$39).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_rowFieldLevel;
        return new $c_Lshapeless_$colon$colon(documentFieldLevel$macro$120, new $c_Lshapeless_$colon$colon(table$macro$121, new $c_Lshapeless_$colon$colon(deliveryHeader$macro$122, new $c_Lshapeless_$colon$colon(rowFieldLevel$macro$123, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var documentFieldLevel$macro$116 = $as_Lreactbuild_person_DocumentFieldLevel($n(x0$40).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$40).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var table$macro$117 = $as_Lreactbuild_person_VerticalInterval($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var deliveryHeader$macro$118 = $as_Lreactbuild_person_DeliveryHeaderFormat($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var rowFieldLevel$macro$119 = $as_Lreactbuild_person_RowFieldLevel($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(documentFieldLevel$macro$116, table$macro$117, deliveryHeader$macro$118, rowFieldLevel$macro$119)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "rowFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "deliveryHeader"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "table"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "documentFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$124__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "documentFieldLevel"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "table"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "deliveryHeader"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "rowFieldLevel"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$36 = $m_s_$less$colon$less$();
    var ev$1 = this$36.s_$less$colon$less$__f_singleton;
    var this$37 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$37);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$41 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$41);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$45 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$45);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$49 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$49);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$53 = $m_s_$less$colon$less$();
    var ev$2 = this$53.s_$less$colon$less$__f_singleton;
    var this$54 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$54);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$58 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$66);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$91 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$91
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$124$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$124 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15($thiz);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$124
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$125$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "documentFieldLevel"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "table"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "rowFieldLevel")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_person_DocumentWithRows(x0$47$2);
      if ((x0$47 !== null)) {
        var documentFieldLevel$macro$147 = $n(x0$47).Lreactbuild_person_DocumentWithRows__f_documentFieldLevel;
        var table$macro$148 = $n(x0$47).Lreactbuild_person_DocumentWithRows__f_table;
        var rowFieldLevel$macro$149 = $n(x0$47).Lreactbuild_person_DocumentWithRows__f_rowFieldLevel;
        return new $c_Lshapeless_$colon$colon(documentFieldLevel$macro$147, new $c_Lshapeless_$colon$colon(table$macro$148, new $c_Lshapeless_$colon$colon(rowFieldLevel$macro$149, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_$colon$colon(x0$48$2);
      if ((x0$48 !== null)) {
        var documentFieldLevel$macro$144 = $as_Lreactbuild_person_DocumentFieldLevel($n(x0$48).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$48).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var table$macro$145 = $as_Lreactbuild_person_VerticalInterval($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var rowFieldLevel$macro$146 = $as_Lreactbuild_person_RowFieldLevel($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_DocumentWithRows(documentFieldLevel$macro$144, table$macro$145, rowFieldLevel$macro$146)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$48)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "rowFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "table"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "documentFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$150__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "documentFieldLevel"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "table"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "rowFieldLevel"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$29 = $m_s_$less$colon$less$();
    var ev$1 = this$29.s_$less$colon$less$__f_singleton;
    var this$30 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$30);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$34 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$34);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$38 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$38);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$42 = $m_s_$less$colon$less$();
    var ev$2 = this$42.s_$less$colon$less$__f_singleton;
    var this$43 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$43);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$47 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$47);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$51 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$51);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$125 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$125
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$150$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$150 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16($thiz);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$150
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$151$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "documentFieldLevel"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "project")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      var x0$55 = $as_Lreactbuild_person_DocumentLevelOnly(x0$55$2);
      if ((x0$55 !== null)) {
        var documentFieldLevel$macro$166 = $n(x0$55).Lreactbuild_person_DocumentLevelOnly__f_documentFieldLevel;
        var project$macro$167 = $n(x0$55).Lreactbuild_person_DocumentLevelOnly__f_project;
        return new $c_Lshapeless_$colon$colon(documentFieldLevel$macro$166, new $c_Lshapeless_$colon$colon(project$macro$167, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$55)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      var x0$56 = $as_Lshapeless_$colon$colon(x0$56$2);
      if ((x0$56 !== null)) {
        var documentFieldLevel$macro$164 = $as_Lreactbuild_person_DocumentFieldLevel($n(x0$56).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$56).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var project$macro$165 = $as_Lreactbuild_person_BoundedField($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_DocumentLevelOnly(documentFieldLevel$macro$164, project$macro$165)
          }
        }
      };
      throw new $c_s_MatchError(x0$56)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "documentFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$168__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "documentFieldLevel"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "project"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$151 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$151
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$168$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((32768 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$168 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17($thiz);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (32768 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$168
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$169$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((65536 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "documentFieldLevel")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      var x0$63 = $as_Lreactbuild_person_CustomFormat(x0$63$2);
      if ((x0$63 !== null)) {
        var documentFieldLevel$macro$177 = $n(x0$63).Lreactbuild_person_CustomFormat__f_documentFieldLevel;
        return new $c_Lshapeless_$colon$colon(documentFieldLevel$macro$177, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$63)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      var x0$64 = $as_Lshapeless_$colon$colon(x0$64$2);
      if ((x0$64 !== null)) {
        var documentFieldLevel$macro$176 = $as_Lreactbuild_person_DocumentFieldLevel($n(x0$64).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$64).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_CustomFormat(documentFieldLevel$macro$176)
        }
      };
      throw new $c_s_MatchError(x0$64)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "documentFieldLevel"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$178__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "documentFieldLevel"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$169 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (65536 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$169
}
function $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$178$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((131072 & $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$178 = new $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18($thiz);
    $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = (131072 | $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$178
}
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1() {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$2 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$3 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$36 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$37 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$62 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$63 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$80 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$81 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$90 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$91 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$124 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$125 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$150 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$151 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$168 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$169 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$178 = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$1)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$2)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$3)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$36__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$36$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$36)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$37__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$37$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$37)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$62__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$62$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$62)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$63__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$63$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$63)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$80__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((128 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$80$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$80)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$81__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((256 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$81$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$81)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$90__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((512 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$90$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$90)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$91__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$91$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$91)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$124__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$124$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$124)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$125__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4096 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$125$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$125)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$150__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$150$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$150)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$151__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((16384 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$151$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$151)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$168__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((32768 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$168$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$168)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$169__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((65536 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$169$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$169)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.inst$macro$178__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((131072 & this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__inst$macro$178$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1__f_inst$macro$178)
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserSettings$() {
  this.Lreactbuild_person_DocumentParserSettings$__f_codecForDocumentParserSettings = null;
  $n_Lreactbuild_person_DocumentParserSettings$ = this;
  var inst$macro$12 = new $c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_DocumentParserSettings$__f_codecForDocumentParserSettings = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_DocumentParserSettings$.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserSettings$.prototype.constructor = $c_Lreactbuild_person_DocumentParserSettings$;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserSettings$() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserSettings$.prototype = $c_Lreactbuild_person_DocumentParserSettings$.prototype;
var $d_Lreactbuild_person_DocumentParserSettings$ = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserSettings$: 0
}, false, "reactbuild.person.DocumentParserSettings$", {
  Lreactbuild_person_DocumentParserSettings$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserSettings$.prototype.$classData = $d_Lreactbuild_person_DocumentParserSettings$;
var $n_Lreactbuild_person_DocumentParserSettings$;
function $m_Lreactbuild_person_DocumentParserSettings$() {
  if ((!$n_Lreactbuild_person_DocumentParserSettings$)) {
    $n_Lreactbuild_person_DocumentParserSettings$ = new $c_Lreactbuild_person_DocumentParserSettings$()
  };
  return $n_Lreactbuild_person_DocumentParserSettings$
}
function $p_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "formats")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_DocumentParserSettings(x0$7$2);
      if ((x0$7 !== null)) {
        var formats$macro$9 = $n(x0$7).Lreactbuild_person_DocumentParserSettings__f_formats;
        return new $c_Lshapeless_$colon$colon(formats$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var formats$macro$8 = $as_sci_List($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_DocumentParserSettings(formats$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "formats"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_DocumentParserSettings$(), $m_s_package$().s_package$__f_Nil)), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$13 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "formats")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "formats"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "formats"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$25 = $m_s_$less$colon$less$();
    var ev$1 = this$25.s_$less$colon$less$__f_singleton;
    var this$26 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$26);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$30 = $m_s_$less$colon$less$();
    var ev$2 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$31);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_inst$macro$1
}
function $p_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_inst$macro$10 = new $c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1($thiz);
    $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1() {
  this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_inst$macro$10 = null;
  this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1.prototype.constructor = $c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1.prototype = $c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1.prototype;
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_inst$macro$1)
});
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1__f_inst$macro$10)
});
var $d_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1: 0
}, false, "reactbuild.person.DocumentParserSettings$anon$lazy$macro$11$1", {
  Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1.prototype.$classData = $d_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1;
/** @constructor */
function $c_Lreactbuild_person_Email$() {
  /*<skip>*/
}
$c_Lreactbuild_person_Email$.prototype = new $h_O();
$c_Lreactbuild_person_Email$.prototype.constructor = $c_Lreactbuild_person_Email$;
/** @constructor */
function $h_Lreactbuild_person_Email$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Email$.prototype = $c_Lreactbuild_person_Email$.prototype;
$c_Lreactbuild_person_Email$.prototype.encodeEmail__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_person_Email(x$3$2);
    return $n(x$3).Lreactbuild_person_Email__f_email
  }));
  return new $c_Lio_circe_Encoder$$anon$1(this$3, f)
});
$c_Lreactbuild_person_Email$.prototype.decodeEmail__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var instance = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_T(x$4$2);
    return new $c_Lreactbuild_person_Email(x$4)
  }));
  return new $c_Lio_circe_Decoder$$anon$1(this$3, f)
});
var $d_Lreactbuild_person_Email$ = new $TypeData().initClass({
  Lreactbuild_person_Email$: 0
}, false, "reactbuild.person.Email$", {
  Lreactbuild_person_Email$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Email$.prototype.$classData = $d_Lreactbuild_person_Email$;
var $n_Lreactbuild_person_Email$;
function $m_Lreactbuild_person_Email$() {
  if ((!$n_Lreactbuild_person_Email$)) {
    $n_Lreactbuild_person_Email$ = new $c_Lreactbuild_person_Email$()
  };
  return $n_Lreactbuild_person_Email$
}
/** @constructor */
function $c_Lreactbuild_person_EstateAgentFacet$() {
  this.Lreactbuild_person_EstateAgentFacet$__f_codecForEstateAgentFacet = null;
  $n_Lreactbuild_person_EstateAgentFacet$ = this;
  var inst$macro$12 = new $c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_EstateAgentFacet$__f_codecForEstateAgentFacet = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_EstateAgentFacet$.prototype = new $h_O();
$c_Lreactbuild_person_EstateAgentFacet$.prototype.constructor = $c_Lreactbuild_person_EstateAgentFacet$;
/** @constructor */
function $h_Lreactbuild_person_EstateAgentFacet$() {
  /*<skip>*/
}
$h_Lreactbuild_person_EstateAgentFacet$.prototype = $c_Lreactbuild_person_EstateAgentFacet$.prototype;
var $d_Lreactbuild_person_EstateAgentFacet$ = new $TypeData().initClass({
  Lreactbuild_person_EstateAgentFacet$: 0
}, false, "reactbuild.person.EstateAgentFacet$", {
  Lreactbuild_person_EstateAgentFacet$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_EstateAgentFacet$.prototype.$classData = $d_Lreactbuild_person_EstateAgentFacet$;
var $n_Lreactbuild_person_EstateAgentFacet$;
function $m_Lreactbuild_person_EstateAgentFacet$() {
  if ((!$n_Lreactbuild_person_EstateAgentFacet$)) {
    $n_Lreactbuild_person_EstateAgentFacet$ = new $c_Lreactbuild_person_EstateAgentFacet$()
  };
  return $n_Lreactbuild_person_EstateAgentFacet$
}
function $p_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "showPrices")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_EstateAgentFacet(x0$7$2);
      if ((x0$7 !== null)) {
        var showPrices$macro$9 = $n(x0$7).Lreactbuild_person_EstateAgentFacet__f_showPrices;
        return new $c_Lshapeless_$colon$colon(showPrices$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var showPrices$macro$8 = $uZ($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_EstateAgentFacet(showPrices$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "showPrices"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_EstateAgentFacet$(), false)), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "showPrices")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "showPrices"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "showPrices"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$24 = $m_s_$less$colon$less$();
    var ev$1 = this$24.s_$less$colon$less$__f_singleton;
    var this$25 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$25);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$29 = $m_s_$less$colon$less$();
    var ev$2 = this$29.s_$less$colon$less$__f_singleton;
    var this$30 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$30);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_inst$macro$1
}
function $p_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_inst$macro$10 = new $c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17($thiz);
    $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2() {
  this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_inst$macro$1 = null;
  this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_inst$macro$10 = null;
  this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_bitmap$0 = 0
}
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2.prototype = new $h_O();
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2.prototype.constructor = $c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2;
/** @constructor */
function $h_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2.prototype = $c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2.prototype;
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_inst$macro$1)
});
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2__f_inst$macro$10)
});
var $d_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2 = new $TypeData().initClass({
  Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2: 0
}, false, "reactbuild.person.EstateAgentFacet$anon$lazy$macro$11$2", {
  Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2.prototype.$classData = $d_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2;
/** @constructor */
function $c_Lreactbuild_person_Facets$() {
  this.Lreactbuild_person_Facets$__f_encodeFacets = null;
  this.Lreactbuild_person_Facets$__f_decodeFacets = null;
  $n_Lreactbuild_person_Facets$ = this;
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString, $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeJson);
  var this$8 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_Lreactbuild_person_Facets(x$8$2);
    return $as_sci_Map($n($n(x$8).Lreactbuild_person_Facets__f_facets).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var key = $as_T($n(x0$1)._1__O());
        var value = $as_Lreactbuild_person_Facet($n(x0$1)._2__O());
        var this$5 = $m_Lreactbuild_person_FacetRegistry$();
        var encoder = $n($as_Lreactbuild_person_IsFacet($n(this$5.Lreactbuild_person_FacetRegistry$__f_registryByName).apply__O__O(key))).Lreactbuild_person_IsFacet__f_encoder;
        var y = $n(encoder).apply__O__Lio_circe_Json(value);
        return $ct_T2__O__O__(new $c_T2(), key, y)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    }))))
  }));
  this.Lreactbuild_person_Facets$__f_encodeFacets = new $c_Lio_circe_Encoder$$anon$1(this$8, f);
  $m_Lio_circe_Decoder$();
  $m_Lio_circe_Decoder$();
  var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
  var decodeV = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJson;
  var instance$1 = new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeV);
  var f$1 = new $c_sjsr_AnonFunction1(((facets$2) => {
    var facets = $as_sci_Map(facets$2);
    return new $c_Lreactbuild_person_Facets($as_sci_Map($n(facets).collect__s_PartialFunction__sc_IterableOps(new $c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1())))
  }));
  this.Lreactbuild_person_Facets$__f_decodeFacets = new $c_Lio_circe_Decoder$$anon$1(instance$1, f$1)
}
$c_Lreactbuild_person_Facets$.prototype = new $h_O();
$c_Lreactbuild_person_Facets$.prototype.constructor = $c_Lreactbuild_person_Facets$;
/** @constructor */
function $h_Lreactbuild_person_Facets$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Facets$.prototype = $c_Lreactbuild_person_Facets$.prototype;
var $d_Lreactbuild_person_Facets$ = new $TypeData().initClass({
  Lreactbuild_person_Facets$: 0
}, false, "reactbuild.person.Facets$", {
  Lreactbuild_person_Facets$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Facets$.prototype.$classData = $d_Lreactbuild_person_Facets$;
var $n_Lreactbuild_person_Facets$;
function $m_Lreactbuild_person_Facets$() {
  if ((!$n_Lreactbuild_person_Facets$)) {
    $n_Lreactbuild_person_Facets$ = new $c_Lreactbuild_person_Facets$()
  };
  return $n_Lreactbuild_person_Facets$
}
/** @constructor */
function $c_Lreactbuild_person_HorizontalInterval$() {
  this.Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval = null;
  $n_Lreactbuild_person_HorizontalInterval$ = this;
  var inst$macro$20 = new $c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_HorizontalInterval$.prototype = new $h_O();
$c_Lreactbuild_person_HorizontalInterval$.prototype.constructor = $c_Lreactbuild_person_HorizontalInterval$;
/** @constructor */
function $h_Lreactbuild_person_HorizontalInterval$() {
  /*<skip>*/
}
$h_Lreactbuild_person_HorizontalInterval$.prototype = $c_Lreactbuild_person_HorizontalInterval$.prototype;
var $d_Lreactbuild_person_HorizontalInterval$ = new $TypeData().initClass({
  Lreactbuild_person_HorizontalInterval$: 0
}, false, "reactbuild.person.HorizontalInterval$", {
  Lreactbuild_person_HorizontalInterval$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_HorizontalInterval$.prototype.$classData = $d_Lreactbuild_person_HorizontalInterval$;
var $n_Lreactbuild_person_HorizontalInterval$;
function $m_Lreactbuild_person_HorizontalInterval$() {
  if ((!$n_Lreactbuild_person_HorizontalInterval$)) {
    $n_Lreactbuild_person_HorizontalInterval$ = new $c_Lreactbuild_person_HorizontalInterval$()
  };
  return $n_Lreactbuild_person_HorizontalInterval$
}
function $p_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "left"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "right")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_HorizontalInterval(x0$7$2);
      if ((x0$7 !== null)) {
        var left$macro$16 = $n(x0$7).Lreactbuild_person_HorizontalInterval__f_left;
        var right$macro$17 = $n(x0$7).Lreactbuild_person_HorizontalInterval__f_right;
        return new $c_Lshapeless_$colon$colon(left$macro$16, new $c_Lshapeless_$colon$colon(right$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var left$macro$14 = $uD($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var right$macro$15 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_HorizontalInterval(left$macro$14, right$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "right"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "left"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "left"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "right")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "left"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "right"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_inst$macro$1
}
function $p_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_inst$macro$18 = new $c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2($thiz);
    $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1() {
  this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_inst$macro$18 = null;
  this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1.prototype = new $h_O();
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1.prototype.constructor = $c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1;
/** @constructor */
function $h_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1.prototype = $c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1.prototype;
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_inst$macro$1)
});
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1__f_inst$macro$18)
});
var $d_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1 = new $TypeData().initClass({
  Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1: 0
}, false, "reactbuild.person.HorizontalInterval$anon$lazy$macro$19$1", {
  Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1.prototype.$classData = $d_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1;
/** @constructor */
function $c_Lreactbuild_person_Location$() {
  /*<skip>*/
}
$c_Lreactbuild_person_Location$.prototype = new $h_O();
$c_Lreactbuild_person_Location$.prototype.constructor = $c_Lreactbuild_person_Location$;
/** @constructor */
function $h_Lreactbuild_person_Location$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Location$.prototype = $c_Lreactbuild_person_Location$.prototype;
$c_Lreactbuild_person_Location$.prototype.encodeLocation__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var instance = $m_Lreactbuild_common_model_Coordinates$().encodeCoordinates__Lio_circe_Encoder();
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_person_Location(v$2);
    return $n(v).Lreactbuild_person_Location__f_coordinates
  }));
  return new $c_Lio_circe_Encoder$$anon$1(this$3, f)
});
$c_Lreactbuild_person_Location$.prototype.decodeLocation__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var instance = $m_Lreactbuild_common_model_Coordinates$().decodeCoordinates__Lio_circe_Decoder();
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_common_model_Coordinates(v$2);
    return new $c_Lreactbuild_person_Location(v)
  }));
  return new $c_Lio_circe_Decoder$$anon$1(this$3, f)
});
var $d_Lreactbuild_person_Location$ = new $TypeData().initClass({
  Lreactbuild_person_Location$: 0
}, false, "reactbuild.person.Location$", {
  Lreactbuild_person_Location$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Location$.prototype.$classData = $d_Lreactbuild_person_Location$;
var $n_Lreactbuild_person_Location$;
function $m_Lreactbuild_person_Location$() {
  if ((!$n_Lreactbuild_person_Location$)) {
    $n_Lreactbuild_person_Location$ = new $c_Lreactbuild_person_Location$()
  };
  return $n_Lreactbuild_person_Location$
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "BankTransfer"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "BillOfExchange"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "DirectDebit")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_person_PaymentMethod(p$2);
      var $$x4 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_person_PaymentMethod$BankTransfer$())) {
        var $$x3 = 0
      } else if ((p === $m_Lreactbuild_person_PaymentMethod$BillOfExchange$())) {
        var $$x3 = 1
      } else {
        if ((p !== $m_Lreactbuild_person_PaymentMethod$DirectDebit$())) {
          throw new $c_s_MatchError(p)
        };
        var $$x3 = 2
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x4).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x3, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_person_PaymentMethod($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "DirectDebit"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "BillOfExchange"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "BankTransfer"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$1
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$2 = new $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11($thiz);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$2
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_person_PaymentMethod$DirectDebit$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_person_PaymentMethod$DirectDebit$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$3
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$4
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_person_PaymentMethod$BillOfExchange$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_person_PaymentMethod$BillOfExchange$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$5
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_person_PaymentMethod$BankTransfer$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_person_PaymentMethod$BankTransfer$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$6 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$6
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_person_PaymentMethod$DirectDebit$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_person_PaymentMethod$DirectDebit$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$8__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$7 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$7
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$8 = new $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12($thiz);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$8
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      $as_Lreactbuild_person_PaymentMethod$BillOfExchange$(x0$39$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      $as_Lshapeless_HNil(x0$40$2);
      return $m_Lreactbuild_person_PaymentMethod$BillOfExchange$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$8__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$9 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$9
}
function $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      $as_Lreactbuild_person_PaymentMethod$BankTransfer$(x0$47$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      $as_Lshapeless_HNil(x0$48$2);
      return $m_Lreactbuild_person_PaymentMethod$BankTransfer$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$8__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$10 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1() {
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$2 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$3 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$4 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$5 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$6 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$7 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$8 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$9 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$10 = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype = new $h_O();
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.constructor = $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1;
/** @constructor */
function $h_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype = $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype;
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$1)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$2)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$3)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$4)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$5)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((32 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$6)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$7__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((64 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$7)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$8__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$8)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$9__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$9)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.inst$macro$10__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1__f_inst$macro$10)
});
var $d_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1 = new $TypeData().initClass({
  Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1: 0
}, false, "reactbuild.person.PaymentMethod$anon$lazy$macro$11$1", {
  Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1.prototype.$classData = $d_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1;
/** @constructor */
function $c_Lreactbuild_person_PaymentTermAndConditions$() {
  this.Lreactbuild_person_PaymentTermAndConditions$__f_codecForPaymentTermAndConditions = null;
  $n_Lreactbuild_person_PaymentTermAndConditions$ = this;
  var inst$macro$28 = new $c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_PaymentTermAndConditions$__f_codecForPaymentTermAndConditions = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_PaymentTermAndConditions$.prototype = new $h_O();
$c_Lreactbuild_person_PaymentTermAndConditions$.prototype.constructor = $c_Lreactbuild_person_PaymentTermAndConditions$;
/** @constructor */
function $h_Lreactbuild_person_PaymentTermAndConditions$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentTermAndConditions$.prototype = $c_Lreactbuild_person_PaymentTermAndConditions$.prototype;
var $d_Lreactbuild_person_PaymentTermAndConditions$ = new $TypeData().initClass({
  Lreactbuild_person_PaymentTermAndConditions$: 0
}, false, "reactbuild.person.PaymentTermAndConditions$", {
  Lreactbuild_person_PaymentTermAndConditions$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PaymentTermAndConditions$.prototype.$classData = $d_Lreactbuild_person_PaymentTermAndConditions$;
var $n_Lreactbuild_person_PaymentTermAndConditions$;
function $m_Lreactbuild_person_PaymentTermAndConditions$() {
  if ((!$n_Lreactbuild_person_PaymentTermAndConditions$)) {
    $n_Lreactbuild_person_PaymentTermAndConditions$ = new $c_Lreactbuild_person_PaymentTermAndConditions$()
  };
  return $n_Lreactbuild_person_PaymentTermAndConditions$
}
function $p_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "method"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "period"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "before")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_PaymentTermAndConditions(x0$7$2);
      if ((x0$7 !== null)) {
        var method$macro$23 = $n(x0$7).Lreactbuild_person_PaymentTermAndConditions__f_method;
        var period$macro$24 = $n(x0$7).Lreactbuild_person_PaymentTermAndConditions__f_period;
        var before$macro$25 = $n(x0$7).Lreactbuild_person_PaymentTermAndConditions__f_before;
        return new $c_Lshapeless_$colon$colon(method$macro$23, new $c_Lshapeless_$colon$colon(period$macro$24, new $c_Lshapeless_$colon$colon(before$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var method$macro$20 = $as_s_Option($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var period$macro$21 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var before$macro$22 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_PaymentTermAndConditions(method$macro$20, period$macro$21, before$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "before"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "period"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "method"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_PaymentTermAndConditions$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_PaymentTermAndConditions$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_PaymentTermAndConditions$(), $m_s_None$())), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$23 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "method"));
    var this$24 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "period"));
    var this$25 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "before")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "method"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "period"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "before"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "method"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "period"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "before"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$51 = $m_s_$less$colon$less$();
    var ev$1 = this$51.s_$less$colon$less$__f_singleton;
    var this$52 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$52);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$56 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$56);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$60 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$60);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$64 = $m_s_$less$colon$less$();
    var ev$2 = this$64.s_$less$colon$less$__f_singleton;
    var this$65 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$73);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_inst$macro$1
}
function $p_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_inst$macro$26 = new $c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15($thiz);
    $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2() {
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_inst$macro$1 = null;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_inst$macro$26 = null;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_bitmap$0 = 0
}
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2.prototype = new $h_O();
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2.prototype.constructor = $c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2;
/** @constructor */
function $h_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2.prototype = $c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2.prototype;
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_inst$macro$1)
});
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2__f_inst$macro$26)
});
var $d_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2 = new $TypeData().initClass({
  Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2: 0
}, false, "reactbuild.person.PaymentTermAndConditions$anon$lazy$macro$27$2", {
  Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2.prototype.$classData = $d_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2;
/** @constructor */
function $c_Lreactbuild_person_Person$() {
  this.Lreactbuild_person_Person$__f_codecForPerson = null;
  $n_Lreactbuild_person_Person$ = this;
  var inst$macro$68 = new $c_Lreactbuild_person_Person$anon$lazy$macro$67$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$68));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_Person$__f_codecForPerson = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_Person$.prototype = new $h_O();
$c_Lreactbuild_person_Person$.prototype.constructor = $c_Lreactbuild_person_Person$;
/** @constructor */
function $h_Lreactbuild_person_Person$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Person$.prototype = $c_Lreactbuild_person_Person$.prototype;
$c_Lreactbuild_person_Person$.prototype.keyMapper__Lcom_iz2use_common_KeyMapper = (function() {
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Lreactbuild_person_Person(x$9$2);
    return $n(x$9).Lreactbuild_person_Person__f__id
  }));
  var ev = $m_Lreactbuild_common_model_RefTo$().keyMapper__Lcom_iz2use_common_KeyMapper();
  return new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev, f)
});
var $d_Lreactbuild_person_Person$ = new $TypeData().initClass({
  Lreactbuild_person_Person$: 0
}, false, "reactbuild.person.Person$", {
  Lreactbuild_person_Person$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Person$.prototype.$classData = $d_Lreactbuild_person_Person$;
var $n_Lreactbuild_person_Person$;
function $m_Lreactbuild_person_Person$() {
  if ((!$n_Lreactbuild_person_Person$)) {
    $n_Lreactbuild_person_Person$ = new $c_Lreactbuild_person_Person$()
  };
  return $n_Lreactbuild_person_Person$
}
function $p_Lreactbuild_person_Person$anon$lazy$macro$67$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name"));
    var this$4 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "code"));
    var this$5 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "facets"));
    var this$6 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "addresses"));
    var this$7 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "parent"));
    var this$8 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "imageUrl")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_Person(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$58 = $n(x0$7).Lreactbuild_person_Person__f__id;
        var organization$macro$59 = $n(x0$7).Lreactbuild_person_Person__f_organization;
        var name$macro$60 = $n(x0$7).Lreactbuild_person_Person__f_name;
        var code$macro$61 = $n(x0$7).Lreactbuild_person_Person__f_code;
        var facets$macro$62 = $n(x0$7).Lreactbuild_person_Person__f_facets;
        var addresses$macro$63 = $n(x0$7).Lreactbuild_person_Person__f_addresses;
        var parent$macro$64 = $n(x0$7).Lreactbuild_person_Person__f_parent;
        var imageUrl$macro$65 = $n(x0$7).Lreactbuild_person_Person__f_imageUrl;
        return new $c_Lshapeless_$colon$colon(_id$macro$58, new $c_Lshapeless_$colon$colon(organization$macro$59, new $c_Lshapeless_$colon$colon(name$macro$60, new $c_Lshapeless_$colon$colon(code$macro$61, new $c_Lshapeless_$colon$colon(facets$macro$62, new $c_Lshapeless_$colon$colon(addresses$macro$63, new $c_Lshapeless_$colon$colon(parent$macro$64, new $c_Lshapeless_$colon$colon(imageUrl$macro$65, $m_Lshapeless_HNil$()))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$50 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$51 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$52 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var code$macro$53 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var facets$macro$54 = $as_Lreactbuild_person_Facets($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var addresses$macro$55 = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var parent$macro$56 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var imageUrl$macro$57 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p9)) {
                        return new $c_Lreactbuild_person_Person(_id$macro$50, organization$macro$51, name$macro$52, code$macro$53, facets$macro$54, addresses$macro$55, parent$macro$56, imageUrl$macro$57)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "imageUrl"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "addresses"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "facets"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "code"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    var this$36 = $m_s_$less$colon$less$();
    var ev = this$36.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$66__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x11 = $m_s_None$();
    var $$x10 = $m_s_None$();
    var $$x9 = $m_s_None$();
    var $$x8 = new $c_s_Some(($m_Lreactbuild_person_Person$(), $m_s_None$()));
    $m_Lreactbuild_person_Person$();
    $m_Lreactbuild_person_Facets$();
    $m_Lreactbuild_person_Facets$();
    $n($m_s_Predef$().s_Predef$__f_Map);
    var facets = $m_sci_Map$EmptyMap$();
    var defaults = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon(new $c_s_Some(new $c_Lreactbuild_person_Facets(facets)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_Person$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_Person$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_Person$(), $m_s_None$())), $m_Lshapeless_HNil$()))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$48 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "_id"));
    var this$49 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "organization"));
    var this$50 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "name"));
    var this$51 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "code"));
    var this$52 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "facets"));
    var this$53 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "addresses"));
    var this$54 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "parent"));
    var this$55 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "imageUrl")), $m_Lshapeless_HNil$()))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$7);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$67 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "code"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$69 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$69, "facets"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$71 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$71, "addresses"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$73 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "parent"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$75 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$75, "imageUrl"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$12);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$82 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$82, "_id"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$84 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$84, "organization"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$86 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$86, "name"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$88 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "code"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$90 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "facets"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$92 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "addresses"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lshapeless_Witness$();
    var this$94 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$94, "parent"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$96 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$96, "imageUrl"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$20);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var this$107 = $m_s_$less$colon$less$();
    var ev$1 = this$107.s_$less$colon$less$__f_singleton;
    var this$108 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$108);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$112 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$112);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$116 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$116);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$120 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$120);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$124 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$124);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$128 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$128);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$132 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$132);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$136 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$136);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$140 = $m_s_$less$colon$less$();
    var ev$2 = this$140.s_$less$colon$less$__f_singleton;
    var this$141 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$141);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$8, ev$2);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$145 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$145);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$149 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$149);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$153 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$153);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$157 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$157);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$161 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$161);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$165 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$165);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$169 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$169);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_inst$macro$1
}
function $p_Lreactbuild_person_Person$anon$lazy$macro$67$1__inst$macro$66$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_inst$macro$66 = new $c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20($thiz);
    $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_inst$macro$66
}
/** @constructor */
function $c_Lreactbuild_person_Person$anon$lazy$macro$67$1() {
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_inst$macro$66 = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1.prototype = new $h_O();
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1.prototype.constructor = $c_Lreactbuild_person_Person$anon$lazy$macro$67$1;
/** @constructor */
function $h_Lreactbuild_person_Person$anon$lazy$macro$67$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_Person$anon$lazy$macro$67$1.prototype = $c_Lreactbuild_person_Person$anon$lazy$macro$67$1.prototype;
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Person$anon$lazy$macro$67$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_inst$macro$1)
});
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1.prototype.inst$macro$66__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Person$anon$lazy$macro$67$1__inst$macro$66$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_Person$anon$lazy$macro$67$1__f_inst$macro$66)
});
var $d_Lreactbuild_person_Person$anon$lazy$macro$67$1 = new $TypeData().initClass({
  Lreactbuild_person_Person$anon$lazy$macro$67$1: 0
}, false, "reactbuild.person.Person$anon$lazy$macro$67$1", {
  Lreactbuild_person_Person$anon$lazy$macro$67$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1.prototype.$classData = $d_Lreactbuild_person_Person$anon$lazy$macro$67$1;
/** @constructor */
function $c_Lreactbuild_person_PersonAnnotation$() {
  this.Lreactbuild_person_PersonAnnotation$__f_codecForPersonAnnotation = null;
  $n_Lreactbuild_person_PersonAnnotation$ = this;
  var inst$macro$44 = new $c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_PersonAnnotation$__f_codecForPersonAnnotation = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_PersonAnnotation$.prototype = new $h_O();
$c_Lreactbuild_person_PersonAnnotation$.prototype.constructor = $c_Lreactbuild_person_PersonAnnotation$;
/** @constructor */
function $h_Lreactbuild_person_PersonAnnotation$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonAnnotation$.prototype = $c_Lreactbuild_person_PersonAnnotation$.prototype;
var $d_Lreactbuild_person_PersonAnnotation$ = new $TypeData().initClass({
  Lreactbuild_person_PersonAnnotation$: 0
}, false, "reactbuild.person.PersonAnnotation$", {
  Lreactbuild_person_PersonAnnotation$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonAnnotation$.prototype.$classData = $d_Lreactbuild_person_PersonAnnotation$;
var $n_Lreactbuild_person_PersonAnnotation$;
function $m_Lreactbuild_person_PersonAnnotation$() {
  if ((!$n_Lreactbuild_person_PersonAnnotation$)) {
    $n_Lreactbuild_person_PersonAnnotation$ = new $c_Lreactbuild_person_PersonAnnotation$()
  };
  return $n_Lreactbuild_person_PersonAnnotation$
}
function $p_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "person"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "label"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "created"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "expired")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_PersonAnnotation(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$37 = $n(x0$7).Lreactbuild_person_PersonAnnotation__f__id;
        var person$macro$38 = $n(x0$7).Lreactbuild_person_PersonAnnotation__f_person;
        var label$macro$39 = $n(x0$7).Lreactbuild_person_PersonAnnotation__f_label;
        var created$macro$40 = $n(x0$7).Lreactbuild_person_PersonAnnotation__f_created;
        var expired$macro$41 = $n(x0$7).Lreactbuild_person_PersonAnnotation__f_expired;
        return new $c_Lshapeless_$colon$colon(_id$macro$37, new $c_Lshapeless_$colon$colon(person$macro$38, new $c_Lshapeless_$colon$colon(label$macro$39, new $c_Lshapeless_$colon$colon(created$macro$40, new $c_Lshapeless_$colon$colon(expired$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$32 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var person$macro$33 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var label$macro$34 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var created$macro$35 = $as_Ljava_time_Instant($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var expired$macro$36 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_person_PersonAnnotation(_id$macro$32, person$macro$33, label$macro$34, created$macro$35, expired$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "expired"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "label"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "person"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x8 = $m_s_None$();
    var $$x7 = $m_s_None$();
    var $$x6 = new $c_s_Some(($m_Lreactbuild_person_PersonAnnotation$(), ""));
    $m_Lreactbuild_person_PersonAnnotation$();
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x5 = $m_Ljava_time_Instant$();
    var this$32 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$32.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$32.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var defaults = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon(new $c_s_Some($n($$x5).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_PersonAnnotation$(), $m_s_None$())), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$35 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "_id"));
    var this$36 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "person"));
    var this$37 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "label"));
    var this$38 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "created"));
    var this$39 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "expired")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$48 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "label"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$50 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "created"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$52 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "expired"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "_id"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "person"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "label"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "created"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "expired"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$12);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$73 = $m_s_$less$colon$less$();
    var ev$1 = this$73.s_$less$colon$less$__f_singleton;
    var this$74 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$82);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$86 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$86);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$90 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$90);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$94 = $m_s_$less$colon$less$();
    var ev$2 = this$94.s_$less$colon$less$__f_singleton;
    var this$95 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$95);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$99 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$99);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$103 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$103);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$107 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$107);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$111 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$111);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_inst$macro$1
}
function $p_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_inst$macro$42 = new $c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23($thiz);
    $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1() {
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_inst$macro$42 = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1.prototype = new $h_O();
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1.prototype.constructor = $c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1;
/** @constructor */
function $h_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1.prototype = $c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1.prototype;
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_inst$macro$1)
});
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1__f_inst$macro$42)
});
var $d_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1 = new $TypeData().initClass({
  Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1: 0
}, false, "reactbuild.person.PersonAnnotation$anon$lazy$macro$43$1", {
  Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1.prototype.$classData = $d_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1;
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceDetails$() {
  this.Lreactbuild_person_PersonReferenceDetails$__f_decodePersonReferenceDetails = null;
  $n_Lreactbuild_person_PersonReferenceDetails$ = this;
  var inst$macro$20 = new $c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2().inst$macro$1__Lio_circe_generic_extras_decoding_ConfiguredDecoder();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var decode = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_PersonReferenceDetails$__f_decodePersonReferenceDetails = $as_Lio_circe_Decoder(decode.value__O())
}
$c_Lreactbuild_person_PersonReferenceDetails$.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceDetails$.prototype.constructor = $c_Lreactbuild_person_PersonReferenceDetails$;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceDetails$.prototype = $c_Lreactbuild_person_PersonReferenceDetails$.prototype;
$c_Lreactbuild_person_PersonReferenceDetails$.prototype.encodePersonReferenceDetails__Lio_circe_Encoder$AsObject = (function() {
  $m_Lio_circe_Encoder$AsObject$();
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_person_PersonReferenceDetails(v$2);
    var this$18 = $m_Lio_circe_JsonObject$();
    var value = new $c_Lreactbuild_person_PersonReferenceModel($n(v).Lreactbuild_person_PersonReferenceDetails__f_model);
    var encoder = $m_Lreactbuild_person_PersonReferenceModel$().encodePersonReferenceModel__Lio_circe_Encoder();
    var y = $n(encoder).apply__O__Lio_circe_Json(value);
    var $$x3 = $ct_T2__O__O__(new $c_T2(), "model", y);
    var value$1 = $n(v).Lreactbuild_person_PersonReferenceDetails__f_value;
    var encoder$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
    var y$1 = $n(encoder$1).apply__O__Lio_circe_Json(value$1);
    var $$x2 = $ct_T2__O__O__(new $c_T2(), "value", y$1);
    var $$x1 = $m_sc_StringOps$();
    var x = $n(v).Lreactbuild_person_PersonReferenceDetails__f_value;
    var value$2 = $n($$x1).reverse$extension__T__T(x);
    var encoder$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
    var y$2 = $n(encoder$2).apply__O__Lio_circe_Json(value$2);
    var array = [$$x3, $$x2, $ct_T2__O__O__(new $c_T2(), "reversedValue", y$2)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return this$18.fromIterable__sc_Iterable__Lio_circe_JsonObject(fields)
  }));
  return new $c_Lio_circe_Encoder$AsObject$$anon$67(f)
});
var $d_Lreactbuild_person_PersonReferenceDetails$ = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceDetails$: 0
}, false, "reactbuild.person.PersonReferenceDetails$", {
  Lreactbuild_person_PersonReferenceDetails$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceDetails$.prototype.$classData = $d_Lreactbuild_person_PersonReferenceDetails$;
var $n_Lreactbuild_person_PersonReferenceDetails$;
function $m_Lreactbuild_person_PersonReferenceDetails$() {
  if ((!$n_Lreactbuild_person_PersonReferenceDetails$)) {
    $n_Lreactbuild_person_PersonReferenceDetails$ = new $c_Lreactbuild_person_PersonReferenceDetails$()
  };
  return $n_Lreactbuild_person_PersonReferenceDetails$
}
function $p_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "model"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "value")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_PersonReferenceDetails(x0$7$2);
      if ((x0$7 !== null)) {
        var model$macro$16 = $n(x0$7).Lreactbuild_person_PersonReferenceDetails__f_model;
        var value$macro$17 = $n(x0$7).Lreactbuild_person_PersonReferenceDetails__f_value;
        return new $c_Lshapeless_$colon$colon(new $c_Lreactbuild_person_PersonReferenceModel(model$macro$16), new $c_Lshapeless_$colon$colon(value$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var model$macro$14 = $n($as_Lreactbuild_person_PersonReferenceModel($n(x0$8).Lshapeless_$colon$colon__f_head)).Lreactbuild_person_PersonReferenceModel__f_id;
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var value$macro$15 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_PersonReferenceDetails(model$macro$14, value$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "value"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "model"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "model"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "value")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "model"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "value"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_inst$macro$1 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_inst$macro$1
}
function $p_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__inst$macro$18$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_inst$macro$18 = new $c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22($thiz);
    $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2() {
  this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_inst$macro$1 = null;
  this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_inst$macro$18 = null;
  this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_bitmap$0 = 0
}
$c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2.prototype.constructor = $c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2.prototype = $c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2.prototype;
$c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2.prototype.inst$macro$1__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((1 & this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_inst$macro$1)
});
$c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2.prototype.inst$macro$18__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__inst$macro$18$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2__f_inst$macro$18)
});
var $d_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2 = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2: 0
}, false, "reactbuild.person.PersonReferenceDetails$anon$lazy$macro$19$2", {
  Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2.prototype.$classData = $d_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2;
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceEvent$() {
  this.Lreactbuild_person_PersonReferenceEvent$__f_codecForPersonReferenceEvent = null;
  $n_Lreactbuild_person_PersonReferenceEvent$ = this;
  var inst$macro$52 = new $c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$52));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_PersonReferenceEvent$__f_codecForPersonReferenceEvent = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_PersonReferenceEvent$.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceEvent$.prototype.constructor = $c_Lreactbuild_person_PersonReferenceEvent$;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceEvent$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceEvent$.prototype = $c_Lreactbuild_person_PersonReferenceEvent$.prototype;
var $d_Lreactbuild_person_PersonReferenceEvent$ = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceEvent$: 0
}, false, "reactbuild.person.PersonReferenceEvent$", {
  Lreactbuild_person_PersonReferenceEvent$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceEvent$.prototype.$classData = $d_Lreactbuild_person_PersonReferenceEvent$;
var $n_Lreactbuild_person_PersonReferenceEvent$;
function $m_Lreactbuild_person_PersonReferenceEvent$() {
  if ((!$n_Lreactbuild_person_PersonReferenceEvent$)) {
    $n_Lreactbuild_person_PersonReferenceEvent$ = new $c_Lreactbuild_person_PersonReferenceEvent$()
  };
  return $n_Lreactbuild_person_PersonReferenceEvent$
}
function $p_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "next"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "person"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "target"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "details"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "instant")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_PersonReferenceEvent(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$44 = $n(x0$7).Lreactbuild_person_PersonReferenceEvent__f__id;
        var next$macro$45 = $n(x0$7).Lreactbuild_person_PersonReferenceEvent__f_next;
        var person$macro$46 = $n(x0$7).Lreactbuild_person_PersonReferenceEvent__f_person;
        var target$macro$47 = $n(x0$7).Lreactbuild_person_PersonReferenceEvent__f_target;
        var details$macro$48 = $n(x0$7).Lreactbuild_person_PersonReferenceEvent__f_details;
        var instant$macro$49 = $n(x0$7).Lreactbuild_person_PersonReferenceEvent__f_instant;
        return new $c_Lshapeless_$colon$colon(_id$macro$44, new $c_Lshapeless_$colon$colon(next$macro$45, new $c_Lshapeless_$colon$colon(person$macro$46, new $c_Lshapeless_$colon$colon(target$macro$47, new $c_Lshapeless_$colon$colon(details$macro$48, new $c_Lshapeless_$colon$colon(instant$macro$49, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$38 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var next$macro$39 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var person$macro$40 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var target$macro$41 = $as_sci_List($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var details$macro$42 = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var instant$macro$43 = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_person_PersonReferenceEvent(_id$macro$38, next$macro$39, person$macro$40, target$macro$41, details$macro$42, instant$macro$43)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "instant"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "details"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "person"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "next"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var $$x11 = $m_s_None$();
    var $$x10 = new $c_s_Some(($m_Lreactbuild_person_PersonReferenceEvent$(), $m_s_None$()));
    var $$x9 = $m_s_None$();
    var $$x8 = $m_s_None$();
    var $$x7 = $m_s_None$();
    $m_Lreactbuild_person_PersonReferenceEvent$();
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x6 = $m_Ljava_time_Instant$();
    var this$37 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$37.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$37.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var defaults = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon(new $c_s_Some($n($$x6).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))), $m_Lshapeless_HNil$()))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$39 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "_id"));
    var this$40 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "next"));
    var this$41 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "person"));
    var this$42 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "target"));
    var this$43 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "details"));
    var this$44 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "instant")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$54 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "next"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$56 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "instant"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$60 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "_id"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$62 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "next"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$64 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "person"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$66 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "target"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$68 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "details"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$70 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$70, "instant"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var this$79 = $m_s_$less$colon$less$();
    var ev$1 = this$79.s_$less$colon$less$__f_singleton;
    var this$80 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$88);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$92 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$92);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$96 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$96);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$100 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$100);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$104 = $m_s_$less$colon$less$();
    var ev$2 = this$104.s_$less$colon$less$__f_singleton;
    var this$105 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$6, ev$2);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$113);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$117 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$117);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$121 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$121);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$125 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$125);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_inst$macro$1
}
function $p_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_inst$macro$50 = new $c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21($thiz);
    $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_inst$macro$50
}
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1() {
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_inst$macro$50 = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1.prototype.constructor = $c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1.prototype = $c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1.prototype;
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_inst$macro$1)
});
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1.prototype.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1__f_inst$macro$50)
});
var $d_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1 = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1: 0
}, false, "reactbuild.person.PersonReferenceEvent$anon$lazy$macro$51$1", {
  Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1.prototype.$classData = $d_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1;
function $p_Lreactbuild_person_PersonReferenceList$Targets$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_person_PersonReferenceList$Targets$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_person_PersonReferenceList$Targets$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lreactbuild_person_PersonReferenceList$Targets$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  $n(b$2$lzy$1);
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2()));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_person_PersonReferenceList$Targets$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_person_PersonReferenceList$Targets$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceList$Targets$() {
  this.Lreactbuild_person_PersonReferenceList$Targets$__f_reuseProps = null;
  $n_Lreactbuild_person_PersonReferenceList$Targets$ = this;
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_person_PersonReferenceList$Targets(a$2);
    var b = $as_Lreactbuild_person_PersonReferenceList$Targets(b$2);
    return ($uZ($n($p_Lreactbuild_person_PersonReferenceList$Targets$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt, $n(b).Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt)) && $uZ($n($p_Lreactbuild_person_PersonReferenceList$Targets$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList, $n(b).Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList)))
  }));
  elem = f;
  this.Lreactbuild_person_PersonReferenceList$Targets$__f_reuseProps = $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
}
$c_Lreactbuild_person_PersonReferenceList$Targets$.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceList$Targets$.prototype.constructor = $c_Lreactbuild_person_PersonReferenceList$Targets$;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceList$Targets$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceList$Targets$.prototype = $c_Lreactbuild_person_PersonReferenceList$Targets$.prototype;
var $d_Lreactbuild_person_PersonReferenceList$Targets$ = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceList$Targets$: 0
}, false, "reactbuild.person.PersonReferenceList$Targets$", {
  Lreactbuild_person_PersonReferenceList$Targets$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceList$Targets$.prototype.$classData = $d_Lreactbuild_person_PersonReferenceList$Targets$;
var $n_Lreactbuild_person_PersonReferenceList$Targets$;
function $m_Lreactbuild_person_PersonReferenceList$Targets$() {
  if ((!$n_Lreactbuild_person_PersonReferenceList$Targets$)) {
    $n_Lreactbuild_person_PersonReferenceList$Targets$ = new $c_Lreactbuild_person_PersonReferenceList$Targets$()
  };
  return $n_Lreactbuild_person_PersonReferenceList$Targets$
}
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceModel$() {
  /*<skip>*/
}
$c_Lreactbuild_person_PersonReferenceModel$.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceModel$.prototype.constructor = $c_Lreactbuild_person_PersonReferenceModel$;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceModel$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceModel$.prototype = $c_Lreactbuild_person_PersonReferenceModel$.prototype;
$c_Lreactbuild_person_PersonReferenceModel$.prototype.encodePersonReferenceModel__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $n($as_Lreactbuild_person_PersonReferenceModel(x$10$2)).Lreactbuild_person_PersonReferenceModel__f_id;
    return x$10
  }));
  return new $c_Lio_circe_Encoder$$anon$1(this$3, f)
});
$c_Lreactbuild_person_PersonReferenceModel$.prototype.decodePersonReferenceModel__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var instance = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_T(x$11$2);
    return new $c_Lreactbuild_person_PersonReferenceModel(x$11)
  }));
  return new $c_Lio_circe_Decoder$$anon$1(this$3, f)
});
$c_Lreactbuild_person_PersonReferenceModel$.prototype.productElement$extension__T__I__O = (function(this$, x$1) {
  return ((x$1 === 0) ? this$ : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_PersonReferenceModel$.prototype.productIterator$extension__T__sc_Iterator = (function(this$) {
  var x = new $c_Lreactbuild_person_PersonReferenceModel(this$);
  return new $c_sr_ScalaRunTime$$anon$1(x)
});
$c_Lreactbuild_person_PersonReferenceModel$.prototype.equals$extension__T__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Lreactbuild_person_PersonReferenceModel)) {
    var PersonReferenceModel$1 = ((x$1 === null) ? null : $n($as_Lreactbuild_person_PersonReferenceModel(x$1)).Lreactbuild_person_PersonReferenceModel__f_id);
    return (this$ === PersonReferenceModel$1)
  } else {
    return false
  }
});
$c_Lreactbuild_person_PersonReferenceModel$.prototype.toString$extension__T__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lreactbuild_person_PersonReferenceModel(this$))
});
var $d_Lreactbuild_person_PersonReferenceModel$ = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceModel$: 0
}, false, "reactbuild.person.PersonReferenceModel$", {
  Lreactbuild_person_PersonReferenceModel$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceModel$.prototype.$classData = $d_Lreactbuild_person_PersonReferenceModel$;
var $n_Lreactbuild_person_PersonReferenceModel$;
function $m_Lreactbuild_person_PersonReferenceModel$() {
  if ((!$n_Lreactbuild_person_PersonReferenceModel$)) {
    $n_Lreactbuild_person_PersonReferenceModel$ = new $c_Lreactbuild_person_PersonReferenceModel$()
  };
  return $n_Lreactbuild_person_PersonReferenceModel$
}
/** @constructor */
function $c_Lreactbuild_person_Phone$() {
  /*<skip>*/
}
$c_Lreactbuild_person_Phone$.prototype = new $h_O();
$c_Lreactbuild_person_Phone$.prototype.constructor = $c_Lreactbuild_person_Phone$;
/** @constructor */
function $h_Lreactbuild_person_Phone$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Phone$.prototype = $c_Lreactbuild_person_Phone$.prototype;
$c_Lreactbuild_person_Phone$.prototype.encodePhone__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lreactbuild_person_Phone(x$5$2);
    return $n(x$5).Lreactbuild_person_Phone__f_number
  }));
  return new $c_Lio_circe_Encoder$$anon$1(this$3, f)
});
$c_Lreactbuild_person_Phone$.prototype.decodePhone__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var instance = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_T(x$6$2);
    return new $c_Lreactbuild_person_Phone(x$6)
  }));
  return new $c_Lio_circe_Decoder$$anon$1(this$3, f)
});
var $d_Lreactbuild_person_Phone$ = new $TypeData().initClass({
  Lreactbuild_person_Phone$: 0
}, false, "reactbuild.person.Phone$", {
  Lreactbuild_person_Phone$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Phone$.prototype.$classData = $d_Lreactbuild_person_Phone$;
var $n_Lreactbuild_person_Phone$;
function $m_Lreactbuild_person_Phone$() {
  if ((!$n_Lreactbuild_person_Phone$)) {
    $n_Lreactbuild_person_Phone$ = new $c_Lreactbuild_person_Phone$()
  };
  return $n_Lreactbuild_person_Phone$
}
/** @constructor */
function $c_Lreactbuild_person_ProductGeneric$() {
  this.Lreactbuild_person_ProductGeneric$__f_codecForProductGeneric = null;
  $n_Lreactbuild_person_ProductGeneric$ = this;
  var inst$macro$28 = new $c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_ProductGeneric$__f_codecForProductGeneric = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_ProductGeneric$.prototype = new $h_O();
$c_Lreactbuild_person_ProductGeneric$.prototype.constructor = $c_Lreactbuild_person_ProductGeneric$;
/** @constructor */
function $h_Lreactbuild_person_ProductGeneric$() {
  /*<skip>*/
}
$h_Lreactbuild_person_ProductGeneric$.prototype = $c_Lreactbuild_person_ProductGeneric$.prototype;
var $d_Lreactbuild_person_ProductGeneric$ = new $TypeData().initClass({
  Lreactbuild_person_ProductGeneric$: 0
}, false, "reactbuild.person.ProductGeneric$", {
  Lreactbuild_person_ProductGeneric$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_ProductGeneric$.prototype.$classData = $d_Lreactbuild_person_ProductGeneric$;
var $n_Lreactbuild_person_ProductGeneric$;
function $m_Lreactbuild_person_ProductGeneric$() {
  if ((!$n_Lreactbuild_person_ProductGeneric$)) {
    $n_Lreactbuild_person_ProductGeneric$ = new $c_Lreactbuild_person_ProductGeneric$()
  };
  return $n_Lreactbuild_person_ProductGeneric$
}
function $p_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "title")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_ProductGeneric(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$23 = $n(x0$7).Lreactbuild_person_ProductGeneric__f__id;
        var organization$macro$24 = $n(x0$7).Lreactbuild_person_ProductGeneric__f_organization;
        var title$macro$25 = $n(x0$7).Lreactbuild_person_ProductGeneric__f_title;
        return new $c_Lshapeless_$colon$colon(_id$macro$23, new $c_Lshapeless_$colon$colon(organization$macro$24, new $c_Lshapeless_$colon$colon(title$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$20 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$21 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var title$macro$22 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_ProductGeneric(_id$macro$20, organization$macro$21, title$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "_id"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "organization"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "title")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "organization"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "title"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_inst$macro$1
}
function $p_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_inst$macro$26 = new $c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1($thiz);
    $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1() {
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_inst$macro$26 = null;
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1.prototype = new $h_O();
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1.prototype.constructor = $c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1;
/** @constructor */
function $h_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1.prototype = $c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1.prototype;
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_inst$macro$1)
});
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1__f_inst$macro$26)
});
var $d_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1 = new $TypeData().initClass({
  Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1: 0
}, false, "reactbuild.person.ProductGeneric$anon$lazy$macro$27$1", {
  Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1.prototype.$classData = $d_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1;
/** @constructor */
function $c_Lreactbuild_person_ProductProduct$() {
  this.Lreactbuild_person_ProductProduct$__f_codecForProductProduct = null;
  $n_Lreactbuild_person_ProductProduct$ = this;
  var inst$macro$84 = new $c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$84));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_ProductProduct$__f_codecForProductProduct = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_ProductProduct$.prototype = new $h_O();
$c_Lreactbuild_person_ProductProduct$.prototype.constructor = $c_Lreactbuild_person_ProductProduct$;
/** @constructor */
function $h_Lreactbuild_person_ProductProduct$() {
  /*<skip>*/
}
$h_Lreactbuild_person_ProductProduct$.prototype = $c_Lreactbuild_person_ProductProduct$.prototype;
var $d_Lreactbuild_person_ProductProduct$ = new $TypeData().initClass({
  Lreactbuild_person_ProductProduct$: 0
}, false, "reactbuild.person.ProductProduct$", {
  Lreactbuild_person_ProductProduct$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_ProductProduct$.prototype.$classData = $d_Lreactbuild_person_ProductProduct$;
var $n_Lreactbuild_person_ProductProduct$;
function $m_Lreactbuild_person_ProductProduct$() {
  if ((!$n_Lreactbuild_person_ProductProduct$)) {
    $n_Lreactbuild_person_ProductProduct$ = new $c_Lreactbuild_person_ProductProduct$()
  };
  return $n_Lreactbuild_person_ProductProduct$
}
function $p_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "title"));
    var this$3 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "template"));
    var this$4 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "supplier"));
    var this$5 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "reference"));
    var this$6 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "unitPrice"));
    var this$7 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "unit"));
    var this$8 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "unitSize"));
    var this$9 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "packaging"));
    var this$10 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "unitPerPackaging")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_ProductProduct(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$72 = $n(x0$7).Lreactbuild_person_ProductProduct__f__id;
        var title$macro$73 = $n(x0$7).Lreactbuild_person_ProductProduct__f_title;
        var template$macro$74 = $n(x0$7).Lreactbuild_person_ProductProduct__f_template;
        var supplier$macro$75 = $n(x0$7).Lreactbuild_person_ProductProduct__f_supplier;
        var reference$macro$76 = $n(x0$7).Lreactbuild_person_ProductProduct__f_reference;
        var unitPrice$macro$77 = $n(x0$7).Lreactbuild_person_ProductProduct__f_unitPrice;
        var unit$macro$78 = $n(x0$7).Lreactbuild_person_ProductProduct__f_unit;
        var unitSize$macro$79 = $n(x0$7).Lreactbuild_person_ProductProduct__f_unitSize;
        var packaging$macro$80 = $n(x0$7).Lreactbuild_person_ProductProduct__f_packaging;
        var unitPerPackaging$macro$81 = $n(x0$7).Lreactbuild_person_ProductProduct__f_unitPerPackaging;
        return new $c_Lshapeless_$colon$colon(_id$macro$72, new $c_Lshapeless_$colon$colon(title$macro$73, new $c_Lshapeless_$colon$colon(template$macro$74, new $c_Lshapeless_$colon$colon(supplier$macro$75, new $c_Lshapeless_$colon$colon(reference$macro$76, new $c_Lshapeless_$colon$colon(unitPrice$macro$77, new $c_Lshapeless_$colon$colon(unit$macro$78, new $c_Lshapeless_$colon$colon(unitSize$macro$79, new $c_Lshapeless_$colon$colon(packaging$macro$80, new $c_Lshapeless_$colon$colon(unitPerPackaging$macro$81, $m_Lshapeless_HNil$()))))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$62 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var title$macro$63 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var template$macro$64 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var supplier$macro$65 = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var reference$macro$66 = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var unitPrice$macro$67 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var unit$macro$68 = $as_T($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var unitSize$macro$69 = $as_Lreactbuild_person_Size($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var packaging$macro$70 = $as_T($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var unitPerPackaging$macro$71 = $as_T($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                          var x = $m_Lshapeless_HNil$();
                          if ((x === p11)) {
                            return new $c_Lreactbuild_person_ProductProduct(_id$macro$62, title$macro$63, template$macro$64, supplier$macro$65, reference$macro$66, unitPrice$macro$67, unit$macro$68, unitSize$macro$69, packaging$macro$70, unitPerPackaging$macro$71)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "unitPerPackaging"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "packaging"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "unitSize"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "unit"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "unitPrice"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "template"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    var this$44 = $m_s_$less$colon$less$();
    var ev = this$44.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$82__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_ProductProduct$(), $m_Lreactbuild_person_Size$Undefined$())), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$49 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "_id"));
    var this$50 = $m_s_Symbol$();
    var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "title"));
    var this$51 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "template"));
    var this$52 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "supplier"));
    var this$53 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "reference"));
    var this$54 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "unitPrice"));
    var this$55 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "unit"));
    var this$56 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "unitSize"));
    var this$57 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "packaging"));
    var this$58 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "unitPerPackaging")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$6);
    var tailHelper$8 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$7);
    var tailHelper$9 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$8);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$9);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$72 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$72, "unitSize"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$10);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$75 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$75, "_id"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$77 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$77, "title"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$79 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$79, "template"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$81 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$81, "supplier"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$83 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "reference"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$85 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "unitPrice"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$87 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$87, "unit"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$89 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$89, "unitSize"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lshapeless_Witness$();
    var this$91 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$91, "packaging"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$93 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "unitPerPackaging"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$20);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var kt$9 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$9, kt$9);
    var this$106 = $m_s_$less$colon$less$();
    var ev$1 = this$106.s_$less$colon$less$__f_singleton;
    var this$107 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$107);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$111 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$111);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$115 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$115);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$119 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$119);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$123 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$123);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$127 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$127);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$131 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$131);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$135 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$135);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$139 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$139);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$143 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$143);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$8, tttvs$8);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$147 = $m_s_$less$colon$less$();
    var ev$2 = this$147.s_$less$colon$less$__f_singleton;
    var this$148 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$148);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$10, ev$2);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$152 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$152);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$156 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$156);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$160 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$160);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$164 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$164);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$168 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$168);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$172 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$172);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$14, tttvs$14);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$176 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$176);
    var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$15, tttvs$15);
    var u$16 = new $c_Lshapeless_Lub$$anon$4();
    var this$180 = $m_sci_List$();
    var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$180);
    var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$16, tttvs$16);
    var u$17 = new $c_Lshapeless_Lub$$anon$4();
    var this$184 = $m_sci_List$();
    var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$184);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$17, tttvs$17);
    $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_inst$macro$1
}
function $p_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__inst$macro$82$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_inst$macro$82 = new $c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2($thiz);
    $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_inst$macro$82
}
/** @constructor */
function $c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1() {
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_inst$macro$82 = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1.prototype = new $h_O();
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1.prototype.constructor = $c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1;
/** @constructor */
function $h_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1.prototype = $c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1.prototype;
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_inst$macro$1)
});
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1.prototype.inst$macro$82__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__inst$macro$82$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1__f_inst$macro$82)
});
var $d_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1 = new $TypeData().initClass({
  Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1: 0
}, false, "reactbuild.person.ProductProduct$anon$lazy$macro$83$1", {
  Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1.prototype.$classData = $d_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1;
/** @constructor */
function $c_Lreactbuild_person_QuantifiedExpression$() {
  this.Lreactbuild_person_QuantifiedExpression$__f_codecForQuantifiedExpression = null;
  $n_Lreactbuild_person_QuantifiedExpression$ = this;
  var inst$macro$12 = new $c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_QuantifiedExpression$__f_codecForQuantifiedExpression = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_QuantifiedExpression$.prototype = new $h_O();
$c_Lreactbuild_person_QuantifiedExpression$.prototype.constructor = $c_Lreactbuild_person_QuantifiedExpression$;
/** @constructor */
function $h_Lreactbuild_person_QuantifiedExpression$() {
  /*<skip>*/
}
$h_Lreactbuild_person_QuantifiedExpression$.prototype = $c_Lreactbuild_person_QuantifiedExpression$.prototype;
var $d_Lreactbuild_person_QuantifiedExpression$ = new $TypeData().initClass({
  Lreactbuild_person_QuantifiedExpression$: 0
}, false, "reactbuild.person.QuantifiedExpression$", {
  Lreactbuild_person_QuantifiedExpression$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_QuantifiedExpression$.prototype.$classData = $d_Lreactbuild_person_QuantifiedExpression$;
var $n_Lreactbuild_person_QuantifiedExpression$;
function $m_Lreactbuild_person_QuantifiedExpression$() {
  if ((!$n_Lreactbuild_person_QuantifiedExpression$)) {
    $n_Lreactbuild_person_QuantifiedExpression$ = new $c_Lreactbuild_person_QuantifiedExpression$()
  };
  return $n_Lreactbuild_person_QuantifiedExpression$
}
function $p_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "code")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_QuantifiedExpression(x0$7$2);
      if ((x0$7 !== null)) {
        var code$macro$9 = $n(x0$7).Lreactbuild_person_QuantifiedExpression__f_code;
        return new $c_Lshapeless_$colon$colon(code$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var code$macro$8 = $as_T($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_QuantifiedExpression(code$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "code"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "code")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "code"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_inst$macro$1
}
function $p_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_inst$macro$10 = new $c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3($thiz);
    $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2() {
  this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_inst$macro$1 = null;
  this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_inst$macro$10 = null;
  this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_bitmap$0 = 0
}
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2.prototype = new $h_O();
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2.prototype.constructor = $c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2;
/** @constructor */
function $h_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2.prototype = $c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2.prototype;
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_inst$macro$1)
});
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2__f_inst$macro$10)
});
var $d_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2 = new $TypeData().initClass({
  Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2: 0
}, false, "reactbuild.person.QuantifiedExpression$anon$lazy$macro$11$2", {
  Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2.prototype.$classData = $d_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2;
/** @constructor */
function $c_Lreactbuild_person_Rectangle$() {
  this.Lreactbuild_person_Rectangle$__f_codecForRectangle = null;
  $n_Lreactbuild_person_Rectangle$ = this;
  var inst$macro$36 = new $c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_Rectangle$__f_codecForRectangle = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_Rectangle$.prototype = new $h_O();
$c_Lreactbuild_person_Rectangle$.prototype.constructor = $c_Lreactbuild_person_Rectangle$;
/** @constructor */
function $h_Lreactbuild_person_Rectangle$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Rectangle$.prototype = $c_Lreactbuild_person_Rectangle$.prototype;
var $d_Lreactbuild_person_Rectangle$ = new $TypeData().initClass({
  Lreactbuild_person_Rectangle$: 0
}, false, "reactbuild.person.Rectangle$", {
  Lreactbuild_person_Rectangle$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Rectangle$.prototype.$classData = $d_Lreactbuild_person_Rectangle$;
var $n_Lreactbuild_person_Rectangle$;
function $m_Lreactbuild_person_Rectangle$() {
  if ((!$n_Lreactbuild_person_Rectangle$)) {
    $n_Lreactbuild_person_Rectangle$ = new $c_Lreactbuild_person_Rectangle$()
  };
  return $n_Lreactbuild_person_Rectangle$
}
function $p_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "top"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "left"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "bottom"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "right")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_Rectangle(x0$7$2);
      if ((x0$7 !== null)) {
        var top$macro$30 = $n(x0$7).Lreactbuild_person_Rectangle__f_top;
        var left$macro$31 = $n(x0$7).Lreactbuild_person_Rectangle__f_left;
        var bottom$macro$32 = $n(x0$7).Lreactbuild_person_Rectangle__f_bottom;
        var right$macro$33 = $n(x0$7).Lreactbuild_person_Rectangle__f_right;
        return new $c_Lshapeless_$colon$colon(top$macro$30, new $c_Lshapeless_$colon$colon(left$macro$31, new $c_Lshapeless_$colon$colon(bottom$macro$32, new $c_Lshapeless_$colon$colon(right$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var top$macro$26 = $uD($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var left$macro$27 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var bottom$macro$28 = $uD($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var right$macro$29 = $uD($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_person_Rectangle(top$macro$26, left$macro$27, bottom$macro$28, right$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "right"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "bottom"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "left"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "top"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$24 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "top"));
    var this$25 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "left"));
    var this$26 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "bottom"));
    var this$27 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "right")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "top"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "left"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "bottom"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "right"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$48 = $m_s_$less$colon$less$();
    var ev$1 = this$48.s_$less$colon$less$__f_singleton;
    var this$49 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$49);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$53 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$61);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$65 = $m_s_$less$colon$less$();
    var ev$2 = this$65.s_$less$colon$less$__f_singleton;
    var this$66 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$78);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_inst$macro$1
}
function $p_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_inst$macro$34 = new $c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4($thiz);
    $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1() {
  this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_inst$macro$34 = null;
  this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1.prototype = new $h_O();
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1.prototype.constructor = $c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1;
/** @constructor */
function $h_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1.prototype = $c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1.prototype;
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_inst$macro$1)
});
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1__f_inst$macro$34)
});
var $d_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1 = new $TypeData().initClass({
  Lreactbuild_person_Rectangle$anon$lazy$macro$35$1: 0
}, false, "reactbuild.person.Rectangle$anon$lazy$macro$35$1", {
  Lreactbuild_person_Rectangle$anon$lazy$macro$35$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1.prototype.$classData = $d_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1;
/** @constructor */
function $c_Lreactbuild_person_ResourceFacet$() {
  this.Lreactbuild_person_ResourceFacet$__f_codecForResourceFacet = null;
  $n_Lreactbuild_person_ResourceFacet$ = this;
  var inst$macro$28 = new $c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_ResourceFacet$__f_codecForResourceFacet = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_ResourceFacet$.prototype = new $h_O();
$c_Lreactbuild_person_ResourceFacet$.prototype.constructor = $c_Lreactbuild_person_ResourceFacet$;
/** @constructor */
function $h_Lreactbuild_person_ResourceFacet$() {
  /*<skip>*/
}
$h_Lreactbuild_person_ResourceFacet$.prototype = $c_Lreactbuild_person_ResourceFacet$.prototype;
var $d_Lreactbuild_person_ResourceFacet$ = new $TypeData().initClass({
  Lreactbuild_person_ResourceFacet$: 0
}, false, "reactbuild.person.ResourceFacet$", {
  Lreactbuild_person_ResourceFacet$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_ResourceFacet$.prototype.$classData = $d_Lreactbuild_person_ResourceFacet$;
var $n_Lreactbuild_person_ResourceFacet$;
function $m_Lreactbuild_person_ResourceFacet$() {
  if ((!$n_Lreactbuild_person_ResourceFacet$)) {
    $n_Lreactbuild_person_ResourceFacet$ = new $c_Lreactbuild_person_ResourceFacet$()
  };
  return $n_Lreactbuild_person_ResourceFacet$
}
function $p_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "entry"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "release"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "costByHour")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_ResourceFacet(x0$7$2);
      if ((x0$7 !== null)) {
        var entry$macro$23 = $n(x0$7).Lreactbuild_person_ResourceFacet__f_entry;
        var release$macro$24 = $n(x0$7).Lreactbuild_person_ResourceFacet__f_release;
        var costByHour$macro$25 = $n(x0$7).Lreactbuild_person_ResourceFacet__f_costByHour;
        return new $c_Lshapeless_$colon$colon(entry$macro$23, new $c_Lshapeless_$colon$colon(release$macro$24, new $c_Lshapeless_$colon$colon(costByHour$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var entry$macro$20 = $as_s_Option($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var release$macro$21 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var costByHour$macro$22 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_ResourceFacet(entry$macro$20, release$macro$21, costByHour$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "costByHour"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "release"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "entry"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_ResourceFacet$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_ResourceFacet$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_ResourceFacet$(), $m_s_None$())), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$23 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "entry"));
    var this$24 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "release"));
    var this$25 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "costByHour")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "entry"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "release"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "costByHour"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "entry"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "release"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "costByHour"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$51 = $m_s_$less$colon$less$();
    var ev$1 = this$51.s_$less$colon$less$__f_singleton;
    var this$52 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$52);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$56 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$56);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$60 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$60);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$64 = $m_s_$less$colon$less$();
    var ev$2 = this$64.s_$less$colon$less$__f_singleton;
    var this$65 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$73);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_inst$macro$1
}
function $p_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_inst$macro$26 = new $c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19($thiz);
    $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3() {
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_inst$macro$1 = null;
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_inst$macro$26 = null;
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_bitmap$0 = 0
}
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3.prototype = new $h_O();
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3.prototype.constructor = $c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3;
/** @constructor */
function $h_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3() {
  /*<skip>*/
}
$h_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3.prototype = $c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3.prototype;
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_inst$macro$1)
});
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3__f_inst$macro$26)
});
var $d_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3 = new $TypeData().initClass({
  Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3: 0
}, false, "reactbuild.person.ResourceFacet$anon$lazy$macro$27$3", {
  Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3.prototype.$classData = $d_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3;
/** @constructor */
function $c_Lreactbuild_person_RowFieldLevel$() {
  this.Lreactbuild_person_RowFieldLevel$__f_codecForRowFieldLevel = null;
  $n_Lreactbuild_person_RowFieldLevel$ = this;
  var inst$macro$52 = new $c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$52));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_RowFieldLevel$__f_codecForRowFieldLevel = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_RowFieldLevel$.prototype = new $h_O();
$c_Lreactbuild_person_RowFieldLevel$.prototype.constructor = $c_Lreactbuild_person_RowFieldLevel$;
/** @constructor */
function $h_Lreactbuild_person_RowFieldLevel$() {
  /*<skip>*/
}
$h_Lreactbuild_person_RowFieldLevel$.prototype = $c_Lreactbuild_person_RowFieldLevel$.prototype;
var $d_Lreactbuild_person_RowFieldLevel$ = new $TypeData().initClass({
  Lreactbuild_person_RowFieldLevel$: 0
}, false, "reactbuild.person.RowFieldLevel$", {
  Lreactbuild_person_RowFieldLevel$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_RowFieldLevel$.prototype.$classData = $d_Lreactbuild_person_RowFieldLevel$;
var $n_Lreactbuild_person_RowFieldLevel$;
function $m_Lreactbuild_person_RowFieldLevel$() {
  if ((!$n_Lreactbuild_person_RowFieldLevel$)) {
    $n_Lreactbuild_person_RowFieldLevel$ = new $c_Lreactbuild_person_RowFieldLevel$()
  };
  return $n_Lreactbuild_person_RowFieldLevel$
}
function $p_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "reference"));
    var this$2 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "description"));
    var this$3 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "quantity"));
    var this$4 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "unit"));
    var this$5 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "unitPrice"));
    var this$6 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "amount")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_RowFieldLevel(x0$7$2);
      if ((x0$7 !== null)) {
        var reference$macro$44 = $n(x0$7).Lreactbuild_person_RowFieldLevel__f_reference;
        var description$macro$45 = $n(x0$7).Lreactbuild_person_RowFieldLevel__f_description;
        var quantity$macro$46 = $n(x0$7).Lreactbuild_person_RowFieldLevel__f_quantity;
        var unit$macro$47 = $n(x0$7).Lreactbuild_person_RowFieldLevel__f_unit;
        var unitPrice$macro$48 = $n(x0$7).Lreactbuild_person_RowFieldLevel__f_unitPrice;
        var amount$macro$49 = $n(x0$7).Lreactbuild_person_RowFieldLevel__f_amount;
        return new $c_Lshapeless_$colon$colon(reference$macro$44, new $c_Lshapeless_$colon$colon(description$macro$45, new $c_Lshapeless_$colon$colon(quantity$macro$46, new $c_Lshapeless_$colon$colon(unit$macro$47, new $c_Lshapeless_$colon$colon(unitPrice$macro$48, new $c_Lshapeless_$colon$colon(amount$macro$49, $m_Lshapeless_HNil$()))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var reference$macro$38 = $as_Lreactbuild_person_BoundedField($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var description$macro$39 = $as_Lreactbuild_person_BoundedField($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var quantity$macro$40 = $as_Lreactbuild_person_BoundedField($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var unit$macro$41 = $as_Lreactbuild_person_BoundedField($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var unitPrice$macro$42 = $as_Lreactbuild_person_BoundedField($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var amount$macro$43 = $as_Lreactbuild_person_BoundedField($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p7)) {
                    return new $c_Lreactbuild_person_RowFieldLevel(reference$macro$38, description$macro$39, quantity$macro$40, unit$macro$41, unitPrice$macro$42, amount$macro$43)
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "amount"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "unitPrice"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$16 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "unit"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$19 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "quantity"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$22 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    var this$28 = $m_s_$less$colon$less$();
    var ev = this$28.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$32 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "reference"));
    var this$33 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "description"));
    var this$34 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "quantity"));
    var this$35 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "unit"));
    var this$36 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "unitPrice"));
    var this$37 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "amount")), $m_Lshapeless_HNil$()))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$5);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "reference"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "description"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "quantity"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "unit"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "unitPrice"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "amount"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var this$66 = $m_s_$less$colon$less$();
    var ev$1 = this$66.s_$less$colon$less$__f_singleton;
    var this$67 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$67);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$71 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$71);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$75 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$75);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$79 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$83);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$87 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$87);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$91 = $m_s_$less$colon$less$();
    var ev$2 = this$91.s_$less$colon$less$__f_singleton;
    var this$92 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$92);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$6, ev$2);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$96 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$96);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$100 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$100);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$104 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$104);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$108 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$108);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$112 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$112);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_inst$macro$1
}
function $p_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_inst$macro$50 = new $c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8($thiz);
    $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_inst$macro$50
}
/** @constructor */
function $c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1() {
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_inst$macro$50 = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1.prototype = new $h_O();
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1.prototype.constructor = $c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1;
/** @constructor */
function $h_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1.prototype = $c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1.prototype;
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_inst$macro$1)
});
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1.prototype.inst$macro$50__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__inst$macro$50$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1__f_inst$macro$50)
});
var $d_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1 = new $TypeData().initClass({
  Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1: 0
}, false, "reactbuild.person.RowFieldLevel$anon$lazy$macro$51$1", {
  Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1.prototype.$classData = $d_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1;
/** @constructor */
function $c_Lreactbuild_person_RowListing$() {
  this.Lreactbuild_person_RowListing$__f_codecForRowListing = null;
  $n_Lreactbuild_person_RowListing$ = this;
  var inst$macro$36 = new $c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_RowListing$__f_codecForRowListing = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_RowListing$.prototype = new $h_O();
$c_Lreactbuild_person_RowListing$.prototype.constructor = $c_Lreactbuild_person_RowListing$;
/** @constructor */
function $h_Lreactbuild_person_RowListing$() {
  /*<skip>*/
}
$h_Lreactbuild_person_RowListing$.prototype = $c_Lreactbuild_person_RowListing$.prototype;
var $d_Lreactbuild_person_RowListing$ = new $TypeData().initClass({
  Lreactbuild_person_RowListing$: 0
}, false, "reactbuild.person.RowListing$", {
  Lreactbuild_person_RowListing$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_RowListing$.prototype.$classData = $d_Lreactbuild_person_RowListing$;
var $n_Lreactbuild_person_RowListing$;
function $m_Lreactbuild_person_RowListing$() {
  if ((!$n_Lreactbuild_person_RowListing$)) {
    $n_Lreactbuild_person_RowListing$ = new $c_Lreactbuild_person_RowListing$()
  };
  return $n_Lreactbuild_person_RowListing$
}
function $p_Lreactbuild_person_RowListing$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "lists"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "rows"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "generics"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "products")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_RowListing(x0$7$2);
      if ((x0$7 !== null)) {
        var lists$macro$30 = $n(x0$7).Lreactbuild_person_RowListing__f_lists;
        var rows$macro$31 = $n(x0$7).Lreactbuild_person_RowListing__f_rows;
        var generics$macro$32 = $n(x0$7).Lreactbuild_person_RowListing__f_generics;
        var products$macro$33 = $n(x0$7).Lreactbuild_person_RowListing__f_products;
        return new $c_Lshapeless_$colon$colon(lists$macro$30, new $c_Lshapeless_$colon$colon(rows$macro$31, new $c_Lshapeless_$colon$colon(generics$macro$32, new $c_Lshapeless_$colon$colon(products$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var lists$macro$26 = $as_sci_List($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var rows$macro$27 = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var generics$macro$28 = $as_sci_List($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var products$macro$29 = $as_sci_List($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_person_RowListing(lists$macro$26, rows$macro$27, generics$macro$28, products$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "products"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "generics"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "rows"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "lists"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$24 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "lists"));
    var this$25 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "rows"));
    var this$26 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "generics"));
    var this$27 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "products")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "lists"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "rows"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "generics"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "products"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$48 = $m_s_$less$colon$less$();
    var ev$1 = this$48.s_$less$colon$less$__f_singleton;
    var this$49 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$49);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$53 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$61);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$65 = $m_s_$less$colon$less$();
    var ev$2 = this$65.s_$less$colon$less$__f_singleton;
    var this$66 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$78);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_inst$macro$1
}
function $p_Lreactbuild_person_RowListing$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_inst$macro$34 = new $c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1($thiz);
    $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1() {
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_inst$macro$34 = null;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1.prototype = new $h_O();
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1.prototype.constructor = $c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1;
/** @constructor */
function $h_Lreactbuild_person_RowListing$anon$lazy$macro$35$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_RowListing$anon$lazy$macro$35$1.prototype = $c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1.prototype;
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_RowListing$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_inst$macro$1)
});
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_RowListing$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1__f_inst$macro$34)
});
var $d_Lreactbuild_person_RowListing$anon$lazy$macro$35$1 = new $TypeData().initClass({
  Lreactbuild_person_RowListing$anon$lazy$macro$35$1: 0
}, false, "reactbuild.person.RowListing$anon$lazy$macro$35$1", {
  Lreactbuild_person_RowListing$anon$lazy$macro$35$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1.prototype.$classData = $d_Lreactbuild_person_RowListing$anon$lazy$macro$35$1;
function $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Undefined")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_person_Size(p$2);
      var $$x1 = $m_Lshapeless_Coproduct$();
      if ((p !== $m_Lreactbuild_person_Size$Undefined$())) {
        throw new $c_s_MatchError(p)
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x1).unsafeMkCoproduct__I__O__Lshapeless_Coproduct(0, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_person_Size($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "Undefined"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$1
}
function $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$2 = new $c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3($thiz);
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$2
}
function $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_person_Size$Undefined$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_person_Size$Undefined$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$3
}
function $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$4
}
function $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_person_Size$Undefined$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_person_Size$Undefined$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$5 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$5
}
function $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$6 = new $c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4($thiz);
    $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$6
}
/** @constructor */
function $c_Lreactbuild_person_Size$anon$lazy$macro$7$1() {
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$2 = null;
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$3 = null;
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$4 = null;
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$5 = null;
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$6 = null;
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype = new $h_O();
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype.constructor = $c_Lreactbuild_person_Size$anon$lazy$macro$7$1;
/** @constructor */
function $h_Lreactbuild_person_Size$anon$lazy$macro$7$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype = $c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype;
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$1)
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$2)
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((4 & this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$3)
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((8 & this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$4)
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype.inst$macro$5__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((16 & this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$5)
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype.inst$macro$6__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((32 & this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_Size$anon$lazy$macro$7$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_Size$anon$lazy$macro$7$1__f_inst$macro$6)
});
var $d_Lreactbuild_person_Size$anon$lazy$macro$7$1 = new $TypeData().initClass({
  Lreactbuild_person_Size$anon$lazy$macro$7$1: 0
}, false, "reactbuild.person.Size$anon$lazy$macro$7$1", {
  Lreactbuild_person_Size$anon$lazy$macro$7$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1.prototype.$classData = $d_Lreactbuild_person_Size$anon$lazy$macro$7$1;
/** @constructor */
function $c_Lreactbuild_person_SupplierFacet$() {
  this.Lreactbuild_person_SupplierFacet$__f_codecForSupplierFacet = null;
  $n_Lreactbuild_person_SupplierFacet$ = this;
  var inst$macro$36 = new $c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_SupplierFacet$__f_codecForSupplierFacet = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_SupplierFacet$.prototype = new $h_O();
$c_Lreactbuild_person_SupplierFacet$.prototype.constructor = $c_Lreactbuild_person_SupplierFacet$;
/** @constructor */
function $h_Lreactbuild_person_SupplierFacet$() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierFacet$.prototype = $c_Lreactbuild_person_SupplierFacet$.prototype;
var $d_Lreactbuild_person_SupplierFacet$ = new $TypeData().initClass({
  Lreactbuild_person_SupplierFacet$: 0
}, false, "reactbuild.person.SupplierFacet$", {
  Lreactbuild_person_SupplierFacet$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplierFacet$.prototype.$classData = $d_Lreactbuild_person_SupplierFacet$;
var $n_Lreactbuild_person_SupplierFacet$;
function $m_Lreactbuild_person_SupplierFacet$() {
  if ((!$n_Lreactbuild_person_SupplierFacet$)) {
    $n_Lreactbuild_person_SupplierFacet$ = new $c_Lreactbuild_person_SupplierFacet$()
  };
  return $n_Lreactbuild_person_SupplierFacet$
}
function $p_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "reference"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "paymentTermAndConditions"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "group"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "documentParserSettings")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_SupplierFacet(x0$7$2);
      if ((x0$7 !== null)) {
        var reference$macro$30 = $n(x0$7).Lreactbuild_person_SupplierFacet__f_reference;
        var paymentTermAndConditions$macro$31 = $n(x0$7).Lreactbuild_person_SupplierFacet__f_paymentTermAndConditions;
        var group$macro$32 = $n(x0$7).Lreactbuild_person_SupplierFacet__f_group;
        var documentParserSettings$macro$33 = $n(x0$7).Lreactbuild_person_SupplierFacet__f_documentParserSettings;
        return new $c_Lshapeless_$colon$colon(reference$macro$30, new $c_Lshapeless_$colon$colon(paymentTermAndConditions$macro$31, new $c_Lshapeless_$colon$colon(group$macro$32, new $c_Lshapeless_$colon$colon(documentParserSettings$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var reference$macro$26 = $as_s_Option($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var paymentTermAndConditions$macro$27 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var group$macro$28 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var documentParserSettings$macro$29 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_person_SupplierFacet(reference$macro$26, paymentTermAndConditions$macro$27, group$macro$28, documentParserSettings$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "documentParserSettings"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "group"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "paymentTermAndConditions"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_SupplierFacet$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_SupplierFacet$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_SupplierFacet$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_SupplierFacet$(), $m_s_None$())), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$28 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "reference"));
    var this$29 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "paymentTermAndConditions"));
    var this$30 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "group"));
    var this$31 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "documentParserSettings")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "reference"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "paymentTermAndConditions"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "group"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "documentParserSettings"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "reference"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "paymentTermAndConditions"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "group"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "documentParserSettings"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$64 = $m_s_$less$colon$less$();
    var ev$1 = this$64.s_$less$colon$less$__f_singleton;
    var this$65 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$73);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$77 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$77);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$81 = $m_s_$less$colon$less$();
    var ev$2 = this$81.s_$less$colon$less$__f_singleton;
    var this$82 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$82);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$86 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$86);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$90 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$90);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$94 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$94);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_inst$macro$1
}
function $p_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_inst$macro$34 = new $c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16($thiz);
    $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1() {
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_inst$macro$34 = null;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1.prototype = new $h_O();
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1.prototype.constructor = $c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1;
/** @constructor */
function $h_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1.prototype = $c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1.prototype;
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_inst$macro$1)
});
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1__f_inst$macro$34)
});
var $d_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1 = new $TypeData().initClass({
  Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1: 0
}, false, "reactbuild.person.SupplierFacet$anon$lazy$macro$35$1", {
  Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1.prototype.$classData = $d_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1;
function $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "VendeeMateriaux")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_person_SupplierGroup(p$2);
      var $$x1 = $m_Lshapeless_Coproduct$();
      if ((p !== $m_Lreactbuild_person_SupplierGroup$VendeeMateriaux$())) {
        throw new $c_s_MatchError(p)
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x1).unsafeMkCoproduct__I__O__Lshapeless_Coproduct(0, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_person_SupplierGroup($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "VendeeMateriaux"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$1
}
function $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$2 = new $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13($thiz);
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$2
}
function $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_person_SupplierGroup$VendeeMateriaux$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_person_SupplierGroup$VendeeMateriaux$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$3
}
function $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$4
}
function $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_person_SupplierGroup$VendeeMateriaux$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_person_SupplierGroup$VendeeMateriaux$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$6__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$5 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$5
}
function $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$6 = new $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14($thiz);
    $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$6
}
/** @constructor */
function $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1() {
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$2 = null;
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$3 = null;
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$4 = null;
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$5 = null;
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$6 = null;
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype = new $h_O();
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype.constructor = $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1;
/** @constructor */
function $h_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype = $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype;
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$1)
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$2)
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((4 & this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$3)
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((8 & this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$4)
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype.inst$macro$5__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((16 & this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$5)
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype.inst$macro$6__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((32 & this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1__f_inst$macro$6)
});
var $d_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1 = new $TypeData().initClass({
  Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1: 0
}, false, "reactbuild.person.SupplierGroup$anon$lazy$macro$7$1", {
  Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1.prototype.$classData = $d_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1;
/** @constructor */
function $c_Lreactbuild_person_SupplyRow$() {
  this.Lreactbuild_person_SupplyRow$__f_codecForSupplyRow = null;
  $n_Lreactbuild_person_SupplyRow$ = this;
  var inst$macro$44 = new $c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$44));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_SupplyRow$__f_codecForSupplyRow = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_SupplyRow$.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRow$.prototype.constructor = $c_Lreactbuild_person_SupplyRow$;
/** @constructor */
function $h_Lreactbuild_person_SupplyRow$() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRow$.prototype = $c_Lreactbuild_person_SupplyRow$.prototype;
var $d_Lreactbuild_person_SupplyRow$ = new $TypeData().initClass({
  Lreactbuild_person_SupplyRow$: 0
}, false, "reactbuild.person.SupplyRow$", {
  Lreactbuild_person_SupplyRow$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRow$.prototype.$classData = $d_Lreactbuild_person_SupplyRow$;
var $n_Lreactbuild_person_SupplyRow$;
function $m_Lreactbuild_person_SupplyRow$() {
  if ((!$n_Lreactbuild_person_SupplyRow$)) {
    $n_Lreactbuild_person_SupplyRow$ = new $c_Lreactbuild_person_SupplyRow$()
  };
  return $n_Lreactbuild_person_SupplyRow$
}
function $p_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "list"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "project"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "target"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "quantity")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_SupplyRow(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$37 = $n(x0$7).Lreactbuild_person_SupplyRow__f__id;
        var list$macro$38 = $n(x0$7).Lreactbuild_person_SupplyRow__f_list;
        var project$macro$39 = $n(x0$7).Lreactbuild_person_SupplyRow__f_project;
        var target$macro$40 = $n(x0$7).Lreactbuild_person_SupplyRow__f_target;
        var quantity$macro$41 = $n(x0$7).Lreactbuild_person_SupplyRow__f_quantity;
        return new $c_Lshapeless_$colon$colon(_id$macro$37, new $c_Lshapeless_$colon$colon(list$macro$38, new $c_Lshapeless_$colon$colon(project$macro$39, new $c_Lshapeless_$colon$colon(target$macro$40, new $c_Lshapeless_$colon$colon(quantity$macro$41, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$32 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var list$macro$33 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var project$macro$34 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var target$macro$35 = $as_Lreactbuild_person_SupplyRowTarget($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var quantity$macro$36 = $as_Lreactbuild_person_CachedQuantifiedExpression($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_person_SupplyRow(_id$macro$32, list$macro$33, project$macro$34, target$macro$35, quantity$macro$36)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "quantity"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "target"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "list"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$28 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "_id"));
    var this$29 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "list"));
    var this$30 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "project"));
    var this$31 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "target"));
    var this$32 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "quantity")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$4);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "_id"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "list"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "project"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$47 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "target"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "quantity"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$57 = $m_s_$less$colon$less$();
    var ev$1 = this$57.s_$less$colon$less$__f_singleton;
    var this$58 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$58);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$62 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$62);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$66 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$74);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$78 = $m_s_$less$colon$less$();
    var ev$2 = this$78.s_$less$colon$less$__f_singleton;
    var this$79 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$79);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$83 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$83);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$87 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$91);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$95 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$95);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_inst$macro$1
}
function $p_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_inst$macro$42 = new $c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12($thiz);
    $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1() {
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_inst$macro$42 = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1.prototype.constructor = $c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1;
/** @constructor */
function $h_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1.prototype = $c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1.prototype;
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_inst$macro$1)
});
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1.prototype.inst$macro$42__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__inst$macro$42$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1__f_inst$macro$42)
});
var $d_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1: 0
}, false, "reactbuild.person.SupplyRow$anon$lazy$macro$43$1", {
  Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1.prototype.$classData = $d_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1;
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Generic"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Product"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Undefined")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_person_SupplyRowTarget(p$2);
      var $$x4 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_person_SupplyRowTarget$Generic)) {
        var $$x3 = 0
      } else if ((p instanceof $c_Lreactbuild_person_SupplyRowTarget$Product)) {
        var $$x3 = 1
      } else {
        if ((!(p instanceof $c_Lreactbuild_person_SupplyRowTarget$Undefined))) {
          throw new $c_s_MatchError(p)
        };
        var $$x3 = 2
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x4).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x3, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_person_SupplyRowTarget($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "Undefined"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "Product"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "Generic"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$1
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$2 = new $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5($thiz);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$2
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "stage"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "title")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_SupplyRowTarget$Undefined(x0$7$2);
      if ((x0$7 !== null)) {
        var stage$macro$18 = $n(x0$7).Lreactbuild_person_SupplyRowTarget$Undefined__f_stage;
        var title$macro$19 = $n(x0$7).Lreactbuild_person_SupplyRowTarget$Undefined__f_title;
        return new $c_Lshapeless_$colon$colon(stage$macro$18, new $c_Lshapeless_$colon$colon(title$macro$19, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var stage$macro$16 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var title$macro$17 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_SupplyRowTarget$Undefined(stage$macro$16, title$macro$17)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "stage"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$20__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "stage"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "title")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "stage"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "title"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$3 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$3
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$20 = new $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6($thiz);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$20
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    var $$x11 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "element"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "concrete")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_person_SupplyRowTarget$Product(x0$15$2);
      if ((x0$15 !== null)) {
        var element$macro$36 = $n(x0$15).Lreactbuild_person_SupplyRowTarget$Product__f_element;
        var concrete$macro$37 = $n(x0$15).Lreactbuild_person_SupplyRowTarget$Product__f_concrete;
        return new $c_Lshapeless_$colon$colon(element$macro$36, new $c_Lshapeless_$colon$colon(concrete$macro$37, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var element$macro$34 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var concrete$macro$35 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_SupplyRowTarget$Product(element$macro$34, concrete$macro$35)
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "concrete"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "element"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var $$x10 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$38__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x8 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "element"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "concrete")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var $$x7 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "element"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "concrete"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$21 = $n($$x11).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x10, $$x8, $$x7, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1));
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$21
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$38 = new $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7($thiz);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$38
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$39$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "element")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_person_SupplyRowTarget$Generic(x0$23$2);
      if ((x0$23 !== null)) {
        var element$macro$47 = $n(x0$23).Lreactbuild_person_SupplyRowTarget$Generic__f_element;
        return new $c_Lshapeless_$colon$colon(element$macro$47, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var element$macro$46 = $as_Lreactbuild_common_model_RefTo($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$24).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_SupplyRowTarget$Generic(element$macro$46)
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "element"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$48__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "element")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "element"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$39 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$39
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$48$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$48 = new $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8($thiz);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$48
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$49$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "stage"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "title")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_person_SupplyRowTarget$Undefined(x0$31$2);
      if ((x0$31 !== null)) {
        var stage$macro$64 = $n(x0$31).Lreactbuild_person_SupplyRowTarget$Undefined__f_stage;
        var title$macro$65 = $n(x0$31).Lreactbuild_person_SupplyRowTarget$Undefined__f_title;
        return new $c_Lshapeless_$colon$colon(stage$macro$64, new $c_Lshapeless_$colon$colon(title$macro$65, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var stage$macro$62 = $as_Lreactbuild_common_model_RefTo($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$32).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var title$macro$63 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_SupplyRowTarget$Undefined(stage$macro$62, title$macro$63)
          }
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "stage"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$66__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "stage"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "title"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$49 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$49
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$66$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$66 = new $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9($thiz);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$66
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$67$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "element"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "concrete")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_person_SupplyRowTarget$Product(x0$39$2);
      if ((x0$39 !== null)) {
        var element$macro$82 = $n(x0$39).Lreactbuild_person_SupplyRowTarget$Product__f_element;
        var concrete$macro$83 = $n(x0$39).Lreactbuild_person_SupplyRowTarget$Product__f_concrete;
        return new $c_Lshapeless_$colon$colon(element$macro$82, new $c_Lshapeless_$colon$colon(concrete$macro$83, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var element$macro$80 = $as_Lreactbuild_common_model_RefTo($n(x0$40).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$40).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var concrete$macro$81 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_SupplyRowTarget$Product(element$macro$80, concrete$macro$81)
          }
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "concrete"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "element"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$84__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "element"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "concrete"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$22 = $m_s_$less$colon$less$();
    var ev$1 = this$22.s_$less$colon$less$__f_singleton;
    var this$23 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$23);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$31 = $m_s_$less$colon$less$();
    var ev$2 = this$31.s_$less$colon$less$__f_singleton;
    var this$32 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$32);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$36 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$36);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$67 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$67
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$84$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$84 = new $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10($thiz);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$84
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$85$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "element")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_person_SupplyRowTarget$Generic(x0$47$2);
      if ((x0$47 !== null)) {
        var element$macro$93 = $n(x0$47).Lreactbuild_person_SupplyRowTarget$Generic__f_element;
        return new $c_Lshapeless_$colon$colon(element$macro$93, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_$colon$colon(x0$48$2);
      if ((x0$48 !== null)) {
        var element$macro$92 = $as_Lreactbuild_common_model_RefTo($n(x0$48).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$48).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_SupplyRowTarget$Generic(element$macro$92)
        }
      };
      throw new $c_s_MatchError(x0$48)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "element"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$94__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "element"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$85 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$85
}
function $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$94$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$94 = new $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11($thiz);
    $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$94
}
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1() {
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$2 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$3 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$20 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$21 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$38 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$39 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$48 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$49 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$66 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$67 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$84 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$85 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$94 = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype;
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$1)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$2)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$3)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$20__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$20)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$21)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$38__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$38$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$38)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$39__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$39$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$39)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$48__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((128 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$48$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$48)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$49__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$49$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$49)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$66__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$66$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$66)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$67__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$67$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$67)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$84__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$84$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$84)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$85__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4096 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$85$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$85)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.inst$macro$94__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_bitmap$0) === 0) ? $p_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__inst$macro$94$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1__f_inst$macro$94)
});
var $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1: 0
}, false, "reactbuild.person.SupplyRowTarget$anon$lazy$macro$95$1", {
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1;
/** @constructor */
function $c_Lreactbuild_person_SupplyTemplateList$() {
  this.Lreactbuild_person_SupplyTemplateList$__f_codecForSupplyTemplateList = null;
  $n_Lreactbuild_person_SupplyTemplateList$ = this;
  var inst$macro$28 = new $c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_SupplyTemplateList$__f_codecForSupplyTemplateList = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_SupplyTemplateList$.prototype = new $h_O();
$c_Lreactbuild_person_SupplyTemplateList$.prototype.constructor = $c_Lreactbuild_person_SupplyTemplateList$;
/** @constructor */
function $h_Lreactbuild_person_SupplyTemplateList$() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyTemplateList$.prototype = $c_Lreactbuild_person_SupplyTemplateList$.prototype;
var $d_Lreactbuild_person_SupplyTemplateList$ = new $TypeData().initClass({
  Lreactbuild_person_SupplyTemplateList$: 0
}, false, "reactbuild.person.SupplyTemplateList$", {
  Lreactbuild_person_SupplyTemplateList$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyTemplateList$.prototype.$classData = $d_Lreactbuild_person_SupplyTemplateList$;
var $n_Lreactbuild_person_SupplyTemplateList$;
function $m_Lreactbuild_person_SupplyTemplateList$() {
  if ((!$n_Lreactbuild_person_SupplyTemplateList$)) {
    $n_Lreactbuild_person_SupplyTemplateList$ = new $c_Lreactbuild_person_SupplyTemplateList$()
  };
  return $n_Lreactbuild_person_SupplyTemplateList$
}
function $p_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "_id"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "organization"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "title")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_SupplyTemplateList(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$23 = $n(x0$7).Lreactbuild_person_SupplyTemplateList__f__id;
        var organization$macro$24 = $n(x0$7).Lreactbuild_person_SupplyTemplateList__f_organization;
        var title$macro$25 = $n(x0$7).Lreactbuild_person_SupplyTemplateList__f_title;
        return new $c_Lshapeless_$colon$colon(_id$macro$23, new $c_Lshapeless_$colon$colon(organization$macro$24, new $c_Lshapeless_$colon$colon(title$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$20 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$21 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var title$macro$22 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_person_SupplyTemplateList(_id$macro$20, organization$macro$21, title$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "title"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "_id"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "organization"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "title")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "organization"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "title"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_inst$macro$1
}
function $p_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_inst$macro$26 = new $c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1($thiz);
    $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1() {
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_inst$macro$1 = null;
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_inst$macro$26 = null;
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_bitmap$0 = 0
}
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1.prototype = new $h_O();
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1.prototype.constructor = $c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1;
/** @constructor */
function $h_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1.prototype = $c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1.prototype;
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_inst$macro$1)
});
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1__f_inst$macro$26)
});
var $d_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1 = new $TypeData().initClass({
  Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1: 0
}, false, "reactbuild.person.SupplyTemplateList$anon$lazy$macro$27$1", {
  Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1.prototype.$classData = $d_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1;
/** @constructor */
function $c_Lreactbuild_person_TextCredentialData$() {
  /*<skip>*/
}
$c_Lreactbuild_person_TextCredentialData$.prototype = new $h_O();
$c_Lreactbuild_person_TextCredentialData$.prototype.constructor = $c_Lreactbuild_person_TextCredentialData$;
/** @constructor */
function $h_Lreactbuild_person_TextCredentialData$() {
  /*<skip>*/
}
$h_Lreactbuild_person_TextCredentialData$.prototype = $c_Lreactbuild_person_TextCredentialData$.prototype;
$c_Lreactbuild_person_TextCredentialData$.prototype.encodeTextCredentialData__Lio_circe_Encoder = (function() {
  $m_Lio_circe_Encoder$();
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_person_TextCredentialData(x$1$2);
    return $n(x$1).Lreactbuild_person_TextCredentialData__f_value
  }));
  return new $c_Lio_circe_Encoder$$anon$1(this$3, f)
});
$c_Lreactbuild_person_TextCredentialData$.prototype.decodeTextCredentialData__Lio_circe_Decoder = (function() {
  $m_Lio_circe_Decoder$();
  var instance = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_T(x$2$2);
    return new $c_Lreactbuild_person_TextCredentialData(x$2)
  }));
  return new $c_Lio_circe_Decoder$$anon$1(this$3, f)
});
var $d_Lreactbuild_person_TextCredentialData$ = new $TypeData().initClass({
  Lreactbuild_person_TextCredentialData$: 0
}, false, "reactbuild.person.TextCredentialData$", {
  Lreactbuild_person_TextCredentialData$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_TextCredentialData$.prototype.$classData = $d_Lreactbuild_person_TextCredentialData$;
var $n_Lreactbuild_person_TextCredentialData$;
function $m_Lreactbuild_person_TextCredentialData$() {
  if ((!$n_Lreactbuild_person_TextCredentialData$)) {
    $n_Lreactbuild_person_TextCredentialData$ = new $c_Lreactbuild_person_TextCredentialData$()
  };
  return $n_Lreactbuild_person_TextCredentialData$
}
/** @constructor */
function $c_Lreactbuild_person_UserFacet$() {
  this.Lreactbuild_person_UserFacet$__f_codecForUserFacet = null;
  $n_Lreactbuild_person_UserFacet$ = this;
  var inst$macro$12 = new $c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_UserFacet$__f_codecForUserFacet = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_UserFacet$.prototype = new $h_O();
$c_Lreactbuild_person_UserFacet$.prototype.constructor = $c_Lreactbuild_person_UserFacet$;
/** @constructor */
function $h_Lreactbuild_person_UserFacet$() {
  /*<skip>*/
}
$h_Lreactbuild_person_UserFacet$.prototype = $c_Lreactbuild_person_UserFacet$.prototype;
var $d_Lreactbuild_person_UserFacet$ = new $TypeData().initClass({
  Lreactbuild_person_UserFacet$: 0
}, false, "reactbuild.person.UserFacet$", {
  Lreactbuild_person_UserFacet$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_UserFacet$.prototype.$classData = $d_Lreactbuild_person_UserFacet$;
var $n_Lreactbuild_person_UserFacet$;
function $m_Lreactbuild_person_UserFacet$() {
  if ((!$n_Lreactbuild_person_UserFacet$)) {
    $n_Lreactbuild_person_UserFacet$ = new $c_Lreactbuild_person_UserFacet$()
  };
  return $n_Lreactbuild_person_UserFacet$
}
function $p_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "email")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_UserFacet(x0$7$2);
      if ((x0$7 !== null)) {
        var email$macro$9 = $n(x0$7).Lreactbuild_person_UserFacet__f_email;
        return new $c_Lshapeless_$colon$colon(email$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var email$macro$8 = $as_s_Option($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_person_UserFacet(email$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "email"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_person_UserFacet$(), $m_s_None$())), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$13 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "email")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "email"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "email"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$25 = $m_s_$less$colon$less$();
    var ev$1 = this$25.s_$less$colon$less$__f_singleton;
    var this$26 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$26);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$30 = $m_s_$less$colon$less$();
    var ev$2 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$31);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_inst$macro$1
}
function $p_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_inst$macro$10 = new $c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18($thiz);
    $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3() {
  this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_inst$macro$1 = null;
  this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_inst$macro$10 = null;
  this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_bitmap$0 = 0
}
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3.prototype = new $h_O();
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3.prototype.constructor = $c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3;
/** @constructor */
function $h_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3() {
  /*<skip>*/
}
$h_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3.prototype = $c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3.prototype;
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_inst$macro$1)
});
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3__f_inst$macro$10)
});
var $d_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3 = new $TypeData().initClass({
  Lreactbuild_person_UserFacet$anon$lazy$macro$11$3: 0
}, false, "reactbuild.person.UserFacet$anon$lazy$macro$11$3", {
  Lreactbuild_person_UserFacet$anon$lazy$macro$11$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3.prototype.$classData = $d_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3;
/** @constructor */
function $c_Lreactbuild_person_VerticalInterval$() {
  this.Lreactbuild_person_VerticalInterval$__f_codecForVerticalInterval = null;
  $n_Lreactbuild_person_VerticalInterval$ = this;
  var inst$macro$20 = new $c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_person_VerticalInterval$__f_codecForVerticalInterval = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_person_VerticalInterval$.prototype = new $h_O();
$c_Lreactbuild_person_VerticalInterval$.prototype.constructor = $c_Lreactbuild_person_VerticalInterval$;
/** @constructor */
function $h_Lreactbuild_person_VerticalInterval$() {
  /*<skip>*/
}
$h_Lreactbuild_person_VerticalInterval$.prototype = $c_Lreactbuild_person_VerticalInterval$.prototype;
var $d_Lreactbuild_person_VerticalInterval$ = new $TypeData().initClass({
  Lreactbuild_person_VerticalInterval$: 0
}, false, "reactbuild.person.VerticalInterval$", {
  Lreactbuild_person_VerticalInterval$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_VerticalInterval$.prototype.$classData = $d_Lreactbuild_person_VerticalInterval$;
var $n_Lreactbuild_person_VerticalInterval$;
function $m_Lreactbuild_person_VerticalInterval$() {
  if ((!$n_Lreactbuild_person_VerticalInterval$)) {
    $n_Lreactbuild_person_VerticalInterval$ = new $c_Lreactbuild_person_VerticalInterval$()
  };
  return $n_Lreactbuild_person_VerticalInterval$
}
function $p_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "top"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "bottom")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_person_VerticalInterval(x0$7$2);
      if ((x0$7 !== null)) {
        var top$macro$16 = $n(x0$7).Lreactbuild_person_VerticalInterval__f_top;
        var bottom$macro$17 = $n(x0$7).Lreactbuild_person_VerticalInterval__f_bottom;
        return new $c_Lshapeless_$colon$colon(top$macro$16, new $c_Lshapeless_$colon$colon(bottom$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var top$macro$14 = $uD($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var bottom$macro$15 = $uD($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_person_VerticalInterval(top$macro$14, bottom$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "bottom"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "top"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "top"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "bottom")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "top"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "bottom"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_inst$macro$1
}
function $p_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_inst$macro$18 = new $c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3($thiz);
    $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2() {
  this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_inst$macro$1 = null;
  this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_inst$macro$18 = null;
  this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_bitmap$0 = 0
}
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2.prototype = new $h_O();
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2.prototype.constructor = $c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2;
/** @constructor */
function $h_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2.prototype = $c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2.prototype;
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_inst$macro$1)
});
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2__f_inst$macro$18)
});
var $d_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2 = new $TypeData().initClass({
  Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2: 0
}, false, "reactbuild.person.VerticalInterval$anon$lazy$macro$19$2", {
  Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2.prototype.$classData = $d_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2;
function $is_Lreactbuild_plugins_devices_BLEDeviceMeasure(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_plugins_devices_BLEDeviceMeasure)))
}
function $as_Lreactbuild_plugins_devices_BLEDeviceMeasure(obj) {
  return (($is_Lreactbuild_plugins_devices_BLEDeviceMeasure(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.plugins.devices.BLEDeviceMeasure"))
}
function $isArrayOf_Lreactbuild_plugins_devices_BLEDeviceMeasure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_plugins_devices_BLEDeviceMeasure)))
}
function $asArrayOf_Lreactbuild_plugins_devices_BLEDeviceMeasure(obj, depth) {
  return (($isArrayOf_Lreactbuild_plugins_devices_BLEDeviceMeasure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.plugins.devices.BLEDeviceMeasure;", depth))
}
function $p_Lreactbuild_process_NewProcessInstanceEvent$Props$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($thiz.Lreactbuild_process_NewProcessInstanceEvent$Props$__f_reuseProcessLink);
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_process_NewProcessInstanceEvent$Props$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_process_NewProcessInstanceEvent$Props$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lreactbuild_process_NewProcessInstanceEvent$Props$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  $n(b$2$lzy$1);
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var e = new $c_Ljapgolly_scalajs_react_Reusability($m_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$().reusability__F2__F2($m_Lreactbuild_process_Processes$State$().Lreactbuild_process_Processes$State$__f_reuseState));
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_process_NewProcessInstanceEvent$Props$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_process_NewProcessInstanceEvent$Props$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
/** @constructor */
function $c_Lreactbuild_process_NewProcessInstanceEvent$Props$() {
  this.Lreactbuild_process_NewProcessInstanceEvent$Props$__f_reuseProcessLink = null;
  this.Lreactbuild_process_NewProcessInstanceEvent$Props$__f_reuseProps = null;
  $n_Lreactbuild_process_NewProcessInstanceEvent$Props$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_process_NewProcessInstanceEvent$Props$__f_reuseProcessLink = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_process_NewProcessInstanceEvent$Props(a$2);
    var b = $as_Lreactbuild_process_NewProcessInstanceEvent$Props(b$2);
    return ($uZ($n($p_Lreactbuild_process_NewProcessInstanceEvent$Props$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_process_NewProcessInstanceEvent$Props__f_defaultLink, $n(b).Lreactbuild_process_NewProcessInstanceEvent$Props__f_defaultLink)) && $uZ($n($p_Lreactbuild_process_NewProcessInstanceEvent$Props$__b$2$1__sr_LazyRef__F2(this, b$2$lzy)).apply__O__O__O($n(a).Lreactbuild_process_NewProcessInstanceEvent$Props__f_parentState, $n(b).Lreactbuild_process_NewProcessInstanceEvent$Props__f_parentState)))
  }));
  elem = f;
  this.Lreactbuild_process_NewProcessInstanceEvent$Props$__f_reuseProps = $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
}
$c_Lreactbuild_process_NewProcessInstanceEvent$Props$.prototype = new $h_O();
$c_Lreactbuild_process_NewProcessInstanceEvent$Props$.prototype.constructor = $c_Lreactbuild_process_NewProcessInstanceEvent$Props$;
/** @constructor */
function $h_Lreactbuild_process_NewProcessInstanceEvent$Props$() {
  /*<skip>*/
}
$h_Lreactbuild_process_NewProcessInstanceEvent$Props$.prototype = $c_Lreactbuild_process_NewProcessInstanceEvent$Props$.prototype;
var $d_Lreactbuild_process_NewProcessInstanceEvent$Props$ = new $TypeData().initClass({
  Lreactbuild_process_NewProcessInstanceEvent$Props$: 0
}, false, "reactbuild.process.NewProcessInstanceEvent$Props$", {
  Lreactbuild_process_NewProcessInstanceEvent$Props$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_NewProcessInstanceEvent$Props$.prototype.$classData = $d_Lreactbuild_process_NewProcessInstanceEvent$Props$;
var $n_Lreactbuild_process_NewProcessInstanceEvent$Props$;
function $m_Lreactbuild_process_NewProcessInstanceEvent$Props$() {
  if ((!$n_Lreactbuild_process_NewProcessInstanceEvent$Props$)) {
    $n_Lreactbuild_process_NewProcessInstanceEvent$Props$ = new $c_Lreactbuild_process_NewProcessInstanceEvent$Props$()
  };
  return $n_Lreactbuild_process_NewProcessInstanceEvent$Props$
}
/** @constructor */
function $c_Lreactbuild_process_Processes$State$() {
  this.Lreactbuild_process_Processes$State$__f_reuseState = null;
  $n_Lreactbuild_process_Processes$State$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_process_Processes$State$__f_reuseState = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2())
}
$c_Lreactbuild_process_Processes$State$.prototype = new $h_O();
$c_Lreactbuild_process_Processes$State$.prototype.constructor = $c_Lreactbuild_process_Processes$State$;
/** @constructor */
function $h_Lreactbuild_process_Processes$State$() {
  /*<skip>*/
}
$h_Lreactbuild_process_Processes$State$.prototype = $c_Lreactbuild_process_Processes$State$.prototype;
var $d_Lreactbuild_process_Processes$State$ = new $TypeData().initClass({
  Lreactbuild_process_Processes$State$: 0
}, false, "reactbuild.process.Processes$State$", {
  Lreactbuild_process_Processes$State$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_Processes$State$.prototype.$classData = $d_Lreactbuild_process_Processes$State$;
var $n_Lreactbuild_process_Processes$State$;
function $m_Lreactbuild_process_Processes$State$() {
  if ((!$n_Lreactbuild_process_Processes$State$)) {
    $n_Lreactbuild_process_Processes$State$ = new $c_Lreactbuild_process_Processes$State$()
  };
  return $n_Lreactbuild_process_Processes$State$
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "PersonResourceUsage"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "ProductResourceUsage")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_project_ResourceUsage(p$2);
      var $$x3 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_project_PersonResourceUsage)) {
        var $$x2 = 0
      } else {
        if ((!(p instanceof $c_Lreactbuild_project_ProductResourceUsage))) {
          throw new $c_s_MatchError(p)
        };
        var $$x2 = 1
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x3).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x2, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_project_ResourceUsage($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "ProductResourceUsage"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "PersonResourceUsage"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$1
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$2 = new $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6($thiz);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$2
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    var $$x29 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "project"));
    var this$2 = $m_s_Symbol$();
    var $$x26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "date"));
    var this$3 = $m_s_Symbol$();
    var $$x25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "supplier"));
    var this$4 = $m_s_Symbol$();
    var $$x24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "reference"));
    var this$5 = $m_s_Symbol$();
    var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "description"));
    var this$6 = $m_s_Symbol$();
    var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "buildingStage"));
    var this$7 = $m_s_Symbol$();
    var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "unitPrice"));
    var this$8 = $m_s_Symbol$();
    var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "unit"));
    var this$9 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "quantity"));
    var this$10 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "total"));
    var this$11 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x27, new $c_Lshapeless_$colon$colon($$x26, new $c_Lshapeless_$colon$colon($$x25, new $c_Lshapeless_$colon$colon($$x24, new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "parent")), $m_Lshapeless_HNil$())))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_project_ProductResourceUsage(x0$7$2);
      if ((x0$7 !== null)) {
        var project$macro$81 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_project;
        var date$macro$82 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_date;
        var supplier$macro$83 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_supplier;
        var reference$macro$84 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_reference;
        var description$macro$85 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_description;
        var buildingStage$macro$86 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_buildingStage;
        var unitPrice$macro$87 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_unitPrice;
        var unit$macro$88 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_unit;
        var quantity$macro$89 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_quantity;
        var total$macro$90 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_total;
        var parent$macro$91 = $n(x0$7).Lreactbuild_project_ProductResourceUsage__f_parent;
        return new $c_Lshapeless_$colon$colon(project$macro$81, new $c_Lshapeless_$colon$colon(date$macro$82, new $c_Lshapeless_$colon$colon(supplier$macro$83, new $c_Lshapeless_$colon$colon(reference$macro$84, new $c_Lshapeless_$colon$colon(description$macro$85, new $c_Lshapeless_$colon$colon(buildingStage$macro$86, new $c_Lshapeless_$colon$colon(unitPrice$macro$87, new $c_Lshapeless_$colon$colon(unit$macro$88, new $c_Lshapeless_$colon$colon(quantity$macro$89, new $c_Lshapeless_$colon$colon(total$macro$90, new $c_Lshapeless_$colon$colon(parent$macro$91, $m_Lshapeless_HNil$())))))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var project$macro$70 = $as_s_Option($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var date$macro$71 = $as_Ljava_time_LocalDate($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var supplier$macro$72 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var reference$macro$73 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var description$macro$74 = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var buildingStage$macro$75 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var unitPrice$macro$76 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var unit$macro$77 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var quantity$macro$78 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var total$macro$79 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                          if ((p11 !== null)) {
                            var parent$macro$80 = $as_Lreactbuild_model_InvoicePage($n(p11).Lshapeless_$colon$colon__f_head);
                            var p12 = $as_Lshapeless_HNil($n(p11).Lshapeless_$colon$colon__f_tail);
                            var x = $m_Lshapeless_HNil$();
                            if ((x === p12)) {
                              return new $c_Lreactbuild_project_ProductResourceUsage(project$macro$70, date$macro$71, supplier$macro$72, reference$macro$73, description$macro$74, buildingStage$macro$75, unitPrice$macro$76, unit$macro$77, quantity$macro$78, total$macro$79, parent$macro$80)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "total"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "quantity"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "unit"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "unitPrice"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "buildingStage"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$10);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    var this$48 = $m_s_$less$colon$less$();
    var ev = this$48.s_$less$colon$less$__f_singleton;
    var $$x28 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$92__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x17 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some(""), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$59 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "project"));
    var this$60 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "date"));
    var this$61 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "supplier"));
    var this$62 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "reference"));
    var this$63 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "description"));
    var this$64 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "buildingStage"));
    var this$65 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "unitPrice"));
    var this$66 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$66, "unit"));
    var this$67 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "quantity"));
    var this$68 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "total"));
    var this$69 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$69, "parent")), $m_Lshapeless_HNil$())))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$5);
    var tailHelper$7 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$6);
    var tailHelper$8 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$7);
    var tailHelper$9 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$8);
    var tailHelper$10 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$9);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$10);
    var $$x16 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$84 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$84, "project"));
    var wit$7 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$86 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$86, "reference"));
    var wit$6 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$88 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "description"));
    var wit$5 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$90 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "buildingStage"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$92 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "unitPrice"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$94 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$94, "unit"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$96 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$96, "quantity"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$98 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$98, "total"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$18);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var rtmT$5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var rtmT$6 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$5, wit$5);
    var rtmT$7 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$6, wit$6);
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$7, wit$7);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$108 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$108, "project"));
    var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$110 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$110, "date"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lshapeless_Witness$();
    var this$112 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$112, "supplier"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$21);
    $m_Lshapeless_Witness$();
    var this$114 = $m_s_Symbol$();
    var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$114, "reference"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$22);
    $m_Lshapeless_Witness$();
    var this$116 = $m_s_Symbol$();
    var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$116, "description"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$23);
    $m_Lshapeless_Witness$();
    var this$118 = $m_s_Symbol$();
    var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$118, "buildingStage"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$24);
    $m_Lshapeless_Witness$();
    var this$120 = $m_s_Symbol$();
    var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$120, "unitPrice"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$25);
    $m_Lshapeless_Witness$();
    var this$122 = $m_s_Symbol$();
    var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$122, "unit"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$26);
    $m_Lshapeless_Witness$();
    var this$124 = $m_s_Symbol$();
    var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$124, "quantity"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$27);
    $m_Lshapeless_Witness$();
    var this$126 = $m_s_Symbol$();
    var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$126, "total"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$28);
    $m_Lshapeless_Witness$();
    var this$128 = $m_s_Symbol$();
    var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$128, "parent"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$29);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var kt$9 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var kt$10 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$9, kt$9);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$10, kt$10);
    var this$142 = $m_s_$less$colon$less$();
    var ev$1 = this$142.s_$less$colon$less$__f_singleton;
    var this$143 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$143);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$147 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$147);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$151 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$151);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$155 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$155);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$159 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$159);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$163 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$163);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$167 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$167);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$171 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$171);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$175 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$175);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$179 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$179);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$183 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$183);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$9, tttvs$9);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$187 = $m_s_$less$colon$less$();
    var ev$2 = this$187.s_$less$colon$less$__f_singleton;
    var this$188 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$188);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$11, ev$2);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$192 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$192);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$196 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$196);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$200 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$200);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$204 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$204);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$208 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$208);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$14, tttvs$14);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$212 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$212);
    var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$15, tttvs$15);
    var u$16 = new $c_Lshapeless_Lub$$anon$4();
    var this$216 = $m_sci_List$();
    var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$216);
    var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$16, tttvs$16);
    var u$17 = new $c_Lshapeless_Lub$$anon$4();
    var this$220 = $m_sci_List$();
    var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$220);
    var tttvs$18 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$17, tttvs$17);
    var u$18 = new $c_Lshapeless_Lub$$anon$4();
    var this$224 = $m_sci_List$();
    var cbf$20 = new $c_sc_IterableFactory$ToFactory(this$224);
    var tttvs$19 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$20, u$18, tttvs$18);
    var u$19 = new $c_Lshapeless_Lub$$anon$4();
    var this$228 = $m_sci_List$();
    var cbf$21 = new $c_sc_IterableFactory$ToFactory(this$228);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$3 = $n($$x29).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x28, $$x17, $$x16, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$21, u$19, tttvs$19));
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$3
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$92$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$92 = new $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7($thiz);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$92
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$93$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    var $$x17 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "project"));
    var this$2 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "date"));
    var this$3 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "person"));
    var this$4 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "buildingStage"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "total")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_project_PersonResourceUsage(x0$15$2);
      if ((x0$15 !== null)) {
        var project$macro$129 = $n(x0$15).Lreactbuild_project_PersonResourceUsage__f_project;
        var date$macro$130 = $n(x0$15).Lreactbuild_project_PersonResourceUsage__f_date;
        var person$macro$131 = $n(x0$15).Lreactbuild_project_PersonResourceUsage__f_person;
        var buildingStage$macro$132 = $n(x0$15).Lreactbuild_project_PersonResourceUsage__f_buildingStage;
        var total$macro$133 = $n(x0$15).Lreactbuild_project_PersonResourceUsage__f_total;
        return new $c_Lshapeless_$colon$colon(project$macro$129, new $c_Lshapeless_$colon$colon(date$macro$130, new $c_Lshapeless_$colon$colon(person$macro$131, new $c_Lshapeless_$colon$colon(buildingStage$macro$132, new $c_Lshapeless_$colon$colon(total$macro$133, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var project$macro$124 = $as_s_Option($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var date$macro$125 = $as_Ljava_time_LocalDate($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var person$macro$126 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var buildingStage$macro$127 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var total$macro$128 = $as_Lreactbuild_model_Duration($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_project_PersonResourceUsage(project$macro$124, date$macro$125, person$macro$126, buildingStage$macro$127, total$macro$128)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "total"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "buildingStage"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "person"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var $$x16 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$134__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x11 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_s_None$()), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$30 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "project"));
    var this$31 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "date"));
    var this$32 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "person"));
    var this$33 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "buildingStage"));
    var this$34 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "total")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$3);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var $$x10 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "project"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "buildingStage"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$6);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var $$x5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "project"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "date"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "person"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "buildingStage"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "total"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$65 = $m_s_$less$colon$less$();
    var ev$1 = this$65.s_$less$colon$less$__f_singleton;
    var this$66 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$66);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$70 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$70);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$74 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$74);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$78 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$78);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$82 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$82);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$86 = $m_s_$less$colon$less$();
    var ev$2 = this$86.s_$less$colon$less$__f_singleton;
    var this$87 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$87);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$91 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$91);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$95 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$95);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$99 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$99);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$103 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$103);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$93 = $n($$x17).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x16, $$x11, $$x10, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7));
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$93
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$134$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$134 = new $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8($thiz);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$134
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$135$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "project"));
    var this$2 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "date"));
    var this$3 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "supplier"));
    var this$4 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "reference"));
    var this$5 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "description"));
    var this$6 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "buildingStage"));
    var this$7 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "unitPrice"));
    var this$8 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "unit"));
    var this$9 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "quantity"));
    var this$10 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "total"));
    var this$11 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "parent")), $m_Lshapeless_HNil$())))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_project_ProductResourceUsage(x0$23$2);
      if ((x0$23 !== null)) {
        var project$macro$213 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_project;
        var date$macro$214 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_date;
        var supplier$macro$215 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_supplier;
        var reference$macro$216 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_reference;
        var description$macro$217 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_description;
        var buildingStage$macro$218 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_buildingStage;
        var unitPrice$macro$219 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_unitPrice;
        var unit$macro$220 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_unit;
        var quantity$macro$221 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_quantity;
        var total$macro$222 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_total;
        var parent$macro$223 = $n(x0$23).Lreactbuild_project_ProductResourceUsage__f_parent;
        return new $c_Lshapeless_$colon$colon(project$macro$213, new $c_Lshapeless_$colon$colon(date$macro$214, new $c_Lshapeless_$colon$colon(supplier$macro$215, new $c_Lshapeless_$colon$colon(reference$macro$216, new $c_Lshapeless_$colon$colon(description$macro$217, new $c_Lshapeless_$colon$colon(buildingStage$macro$218, new $c_Lshapeless_$colon$colon(unitPrice$macro$219, new $c_Lshapeless_$colon$colon(unit$macro$220, new $c_Lshapeless_$colon$colon(quantity$macro$221, new $c_Lshapeless_$colon$colon(total$macro$222, new $c_Lshapeless_$colon$colon(parent$macro$223, $m_Lshapeless_HNil$())))))))))))
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var project$macro$202 = $as_s_Option($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$24).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var date$macro$203 = $as_Ljava_time_LocalDate($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var supplier$macro$204 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var reference$macro$205 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var description$macro$206 = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var buildingStage$macro$207 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var unitPrice$macro$208 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var unit$macro$209 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var quantity$macro$210 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var total$macro$211 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                          if ((p11 !== null)) {
                            var parent$macro$212 = $as_Lreactbuild_model_InvoicePage($n(p11).Lshapeless_$colon$colon__f_head);
                            var p12 = $as_Lshapeless_HNil($n(p11).Lshapeless_$colon$colon__f_tail);
                            var x = $m_Lshapeless_HNil$();
                            if ((x === p12)) {
                              return new $c_Lreactbuild_project_ProductResourceUsage(project$macro$202, date$macro$203, supplier$macro$204, reference$macro$205, description$macro$206, buildingStage$macro$207, unitPrice$macro$208, unit$macro$209, quantity$macro$210, total$macro$211, parent$macro$212)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "parent"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "total"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "quantity"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$24 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "unit"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "unitPrice"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$30 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "buildingStage"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "description"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$36 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$42 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$45 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$10);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    var this$48 = $m_s_$less$colon$less$();
    var ev = this$48.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$224__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "project"));
    var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "date"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "supplier"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "reference"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "description"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "buildingStage"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "unitPrice"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "unit"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lshapeless_Witness$();
    var this$67 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "quantity"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$69 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$69, "total"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    $m_Lshapeless_Witness$();
    var this$71 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$71, "parent"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$21);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var kt$7 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var kt$8 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$7, kt$7);
    var kt$9 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$8, kt$8);
    var kt$10 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$9, kt$9);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$10, kt$10);
    var this$85 = $m_s_$less$colon$less$();
    var ev$1 = this$85.s_$less$colon$less$__f_singleton;
    var this$86 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$86);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$90 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$90);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$94 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$94);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$98 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$98);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$102 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$102);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$106 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$106);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$110 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$110);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$114 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$114);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$118 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$118);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$122 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$122);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$126 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$126);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$9, tttvs$9);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$130 = $m_s_$less$colon$less$();
    var ev$2 = this$130.s_$less$colon$less$__f_singleton;
    var this$131 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$131);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$11, ev$2);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$135 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$135);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$139 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$139);
    var tttvs$12 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    var u$12 = new $c_Lshapeless_Lub$$anon$4();
    var this$143 = $m_sci_List$();
    var cbf$14 = new $c_sc_IterableFactory$ToFactory(this$143);
    var tttvs$13 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$14, u$12, tttvs$12);
    var u$13 = new $c_Lshapeless_Lub$$anon$4();
    var this$147 = $m_sci_List$();
    var cbf$15 = new $c_sc_IterableFactory$ToFactory(this$147);
    var tttvs$14 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$15, u$13, tttvs$13);
    var u$14 = new $c_Lshapeless_Lub$$anon$4();
    var this$151 = $m_sci_List$();
    var cbf$16 = new $c_sc_IterableFactory$ToFactory(this$151);
    var tttvs$15 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$16, u$14, tttvs$14);
    var u$15 = new $c_Lshapeless_Lub$$anon$4();
    var this$155 = $m_sci_List$();
    var cbf$17 = new $c_sc_IterableFactory$ToFactory(this$155);
    var tttvs$16 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$17, u$15, tttvs$15);
    var u$16 = new $c_Lshapeless_Lub$$anon$4();
    var this$159 = $m_sci_List$();
    var cbf$18 = new $c_sc_IterableFactory$ToFactory(this$159);
    var tttvs$17 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$18, u$16, tttvs$16);
    var u$17 = new $c_Lshapeless_Lub$$anon$4();
    var this$163 = $m_sci_List$();
    var cbf$19 = new $c_sc_IterableFactory$ToFactory(this$163);
    var tttvs$18 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$19, u$17, tttvs$17);
    var u$18 = new $c_Lshapeless_Lub$$anon$4();
    var this$167 = $m_sci_List$();
    var cbf$20 = new $c_sc_IterableFactory$ToFactory(this$167);
    var tttvs$19 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$20, u$18, tttvs$18);
    var u$19 = new $c_Lshapeless_Lub$$anon$4();
    var this$171 = $m_sci_List$();
    var cbf$21 = new $c_sc_IterableFactory$ToFactory(this$171);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$21, u$19, tttvs$19);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$135 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$135
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$224$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$224 = new $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9($thiz);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$224
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$225$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "project"));
    var this$2 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "date"));
    var this$3 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "person"));
    var this$4 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "buildingStage"));
    var this$5 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "total")), $m_Lshapeless_HNil$())))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_project_PersonResourceUsage(x0$31$2);
      if ((x0$31 !== null)) {
        var project$macro$261 = $n(x0$31).Lreactbuild_project_PersonResourceUsage__f_project;
        var date$macro$262 = $n(x0$31).Lreactbuild_project_PersonResourceUsage__f_date;
        var person$macro$263 = $n(x0$31).Lreactbuild_project_PersonResourceUsage__f_person;
        var buildingStage$macro$264 = $n(x0$31).Lreactbuild_project_PersonResourceUsage__f_buildingStage;
        var total$macro$265 = $n(x0$31).Lreactbuild_project_PersonResourceUsage__f_total;
        return new $c_Lshapeless_$colon$colon(project$macro$261, new $c_Lshapeless_$colon$colon(date$macro$262, new $c_Lshapeless_$colon$colon(person$macro$263, new $c_Lshapeless_$colon$colon(buildingStage$macro$264, new $c_Lshapeless_$colon$colon(total$macro$265, $m_Lshapeless_HNil$())))))
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var project$macro$256 = $as_s_Option($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$32).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var date$macro$257 = $as_Ljava_time_LocalDate($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var person$macro$258 = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var buildingStage$macro$259 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var total$macro$260 = $as_Lreactbuild_model_Duration($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p6)) {
                  return new $c_Lreactbuild_project_PersonResourceUsage(project$macro$256, date$macro$257, person$macro$258, buildingStage$macro$259, total$macro$260)
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "total"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$12 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "buildingStage"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$15 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "person"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "project"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    var this$24 = $m_s_$less$colon$less$();
    var ev = this$24.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$266__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "project"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "date"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "person"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "buildingStage"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "total"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var this$43 = $m_s_$less$colon$less$();
    var ev$1 = this$43.s_$less$colon$less$__f_singleton;
    var this$44 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$48);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$52 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$52);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$56 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$56);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$60 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$60);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$64 = $m_s_$less$colon$less$();
    var ev$2 = this$64.s_$less$colon$less$__f_singleton;
    var this$65 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$65);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$5, ev$2);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$69 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$69);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$73 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$73);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$77 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$77);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$81 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$81);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$225 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$225
}
function $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$266$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$266 = new $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10($thiz);
    $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$266
}
/** @constructor */
function $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1() {
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$1 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$2 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$3 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$92 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$93 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$134 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$135 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$224 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$225 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$266 = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0 = 0
}
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.constructor = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype;
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$1)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$2)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$3)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$92__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$92$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$92)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$93__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$93$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$93)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$134__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$134$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$134)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$135__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((64 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$135$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$135)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$224__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$224$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$224)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$225__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$225$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$225)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.inst$macro$266__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__inst$macro$266$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1__f_inst$macro$266)
});
var $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1: 0
}, false, "reactbuild.project.ResourceUsage$anon$lazy$macro$267$1", {
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1.prototype.$classData = $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1;
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "PersonFilter"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "ProjectFilter")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_project_ResourceUsageClause(p$2);
      var $$x3 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_project_ResourceUsageClause$PersonFilter)) {
        var $$x2 = 0
      } else {
        if ((!(p instanceof $c_Lreactbuild_project_ResourceUsageClause$ProjectFilter))) {
          throw new $c_s_MatchError(p)
        };
        var $$x2 = 1
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x3).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x2, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_project_ResourceUsageClause($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "ProjectFilter"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "PersonFilter"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$1
}
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$2 = new $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16($thiz);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$2
}
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "selection")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_project_ResourceUsageClause$ProjectFilter(x0$7$2);
      if ((x0$7 !== null)) {
        var selection$macro$11 = $n(x0$7).Lreactbuild_project_ResourceUsageClause$ProjectFilter__f_selection;
        return new $c_Lshapeless_$colon$colon(selection$macro$11, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var selection$macro$10 = $as_Lreactbuild_project_Selection($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_project_ResourceUsageClause$ProjectFilter(selection$macro$10)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "selection"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "selection")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "selection"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$3
}
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$12 = new $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17($thiz);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$12
}
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "selection")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_project_ResourceUsageClause$PersonFilter(x0$15$2);
      if ((x0$15 !== null)) {
        var selection$macro$21 = $n(x0$15).Lreactbuild_project_ResourceUsageClause$PersonFilter__f_selection;
        return new $c_Lshapeless_$colon$colon(selection$macro$21, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var selection$macro$20 = $as_Lreactbuild_project_Selection($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$16).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_project_ResourceUsageClause$PersonFilter(selection$macro$20)
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "selection"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$22__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "selection")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "selection"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$13 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$13
}
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$22 = new $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18($thiz);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$22
}
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$23$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((64 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "selection")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_project_ResourceUsageClause$ProjectFilter(x0$23$2);
      if ((x0$23 !== null)) {
        var selection$macro$31 = $n(x0$23).Lreactbuild_project_ResourceUsageClause$ProjectFilter__f_selection;
        return new $c_Lshapeless_$colon$colon(selection$macro$31, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_$colon$colon(x0$24$2);
      if ((x0$24 !== null)) {
        var selection$macro$30 = $as_Lreactbuild_project_Selection($n(x0$24).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$24).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_project_ResourceUsageClause$ProjectFilter(selection$macro$30)
        }
      };
      throw new $c_s_MatchError(x0$24)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "selection"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$32__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "selection"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$23 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$23
}
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$32$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$32 = new $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19($thiz);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$32
}
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$33$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "selection")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_project_ResourceUsageClause$PersonFilter(x0$31$2);
      if ((x0$31 !== null)) {
        var selection$macro$41 = $n(x0$31).Lreactbuild_project_ResourceUsageClause$PersonFilter__f_selection;
        return new $c_Lshapeless_$colon$colon(selection$macro$41, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_$colon$colon(x0$32$2);
      if ((x0$32 !== null)) {
        var selection$macro$40 = $as_Lreactbuild_project_Selection($n(x0$32).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$32).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_project_ResourceUsageClause$PersonFilter(selection$macro$40)
        }
      };
      throw new $c_s_MatchError(x0$32)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "selection"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$42__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "selection"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$33 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$33
}
function $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$42$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$42 = new $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20($thiz);
    $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$42
}
/** @constructor */
function $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1() {
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$1 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$2 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$3 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$12 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$13 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$22 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$23 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$32 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$33 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$42 = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0 = 0
}
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.constructor = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype;
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$1)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$2)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$3)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$12__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$12)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$13)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$22__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((32 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$22)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$23__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((64 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$23$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$23)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$32__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$32$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$32)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$33__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$33$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$33)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.inst$macro$42__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__inst$macro$42$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1__f_inst$macro$42)
});
var $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1: 0
}, false, "reactbuild.project.ResourceUsageClause$anon$lazy$macro$43$1", {
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1.prototype.$classData = $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1;
function $is_Lreactbuild_project_RichContent$Block(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_RichContent$Block)))
}
function $as_Lreactbuild_project_RichContent$Block(obj) {
  return (($is_Lreactbuild_project_RichContent$Block(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.RichContent$Block"))
}
function $isArrayOf_Lreactbuild_project_RichContent$Block(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_RichContent$Block)))
}
function $asArrayOf_Lreactbuild_project_RichContent$Block(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_RichContent$Block(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.RichContent$Block;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_RichContent$Line$() {
  /*<skip>*/
}
$c_Lreactbuild_project_RichContent$Line$.prototype = new $h_O();
$c_Lreactbuild_project_RichContent$Line$.prototype.constructor = $c_Lreactbuild_project_RichContent$Line$;
/** @constructor */
function $h_Lreactbuild_project_RichContent$Line$() {
  /*<skip>*/
}
$h_Lreactbuild_project_RichContent$Line$.prototype = $c_Lreactbuild_project_RichContent$Line$.prototype;
$c_Lreactbuild_project_RichContent$Line$.prototype.apply__T__Lreactbuild_project_RichContent$Line = (function(content) {
  matchEnd4: {
    var $$x1;
    if ((content !== null)) {
      var o7 = $n($m_Lreactbuild_project_RichContent$().Lreactbuild_project_RichContent$__f_imagePrefix).unapplySeq__jl_CharSequence__s_Option(content);
      if (((!$n(o7).isEmpty__Z()) && (($n(o7).get__O() !== null) && ($n($as_sci_List($n(o7).get__O())).lengthCompare__I__I(2) === 0)))) {
        var cls = $as_T($n($as_sc_LinearSeqOps($n(o7).get__O())).apply__I__O(0));
        var href = $as_T($n($as_sc_LinearSeqOps($n(o7).get__O())).apply__I__O(1));
        var $$x1 = new $c_Lreactbuild_project_RichContent$Image(href, cls);
        break matchEnd4
      }
    };
    var $$x1 = new $c_Lreactbuild_project_RichContent$Text(content)
  };
  return new $c_Lreactbuild_project_RichContent$Line($$x1)
});
var $d_Lreactbuild_project_RichContent$Line$ = new $TypeData().initClass({
  Lreactbuild_project_RichContent$Line$: 0
}, false, "reactbuild.project.RichContent$Line$", {
  Lreactbuild_project_RichContent$Line$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_RichContent$Line$.prototype.$classData = $d_Lreactbuild_project_RichContent$Line$;
var $n_Lreactbuild_project_RichContent$Line$;
function $m_Lreactbuild_project_RichContent$Line$() {
  if ((!$n_Lreactbuild_project_RichContent$Line$)) {
    $n_Lreactbuild_project_RichContent$Line$ = new $c_Lreactbuild_project_RichContent$Line$()
  };
  return $n_Lreactbuild_project_RichContent$Line$
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "All"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "List"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "None")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_project_Selection(p$2);
      var $$x4 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_project_Selection$All)) {
        var $$x3 = 0
      } else if ((p instanceof $c_Lreactbuild_project_Selection$List)) {
        var $$x3 = 1
      } else {
        if ((!(p instanceof $c_Lreactbuild_project_Selection$None))) {
          throw new $c_s_MatchError(p)
        };
        var $$x3 = 2
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x4).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x3, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_project_Selection($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "None"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "List"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "All"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var decodeR = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder(gen$1, decodeR, config);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$1
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$2 = new $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11($thiz);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$2
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_project_Selection$None(x0$7$2);
      if ((x0$7 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_HNil(x0$8$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$8)) {
        return new $c_Lreactbuild_project_Selection$None()
      } else {
        throw new $c_s_MatchError(x0$8)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$3
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$4
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "items")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_project_Selection$List(x0$15$2);
      if ((x0$15 !== null)) {
        var items$macro$13 = $n(x0$15).Lreactbuild_project_Selection$List__f_items;
        return new $c_Lshapeless_$colon$colon(items$macro$13, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var items$macro$12 = $as_sci_List($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$16).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_project_Selection$List(items$macro$12)
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "items"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$12 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "items")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "items"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$21 = $m_s_$less$colon$less$();
    var ev$1 = this$21.s_$less$colon$less$__f_singleton;
    var this$22 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$22);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$26 = $m_s_$less$colon$less$();
    var ev$2 = this$26.s_$less$colon$less$__f_singleton;
    var this$27 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$27);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2));
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$5
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$14$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$14 = new $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12($thiz);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$14
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$15$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      var x0$23 = $as_Lreactbuild_project_Selection$All(x0$23$2);
      if ((x0$23 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$23)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      var x0$24 = $as_Lshapeless_HNil(x0$24$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$24)) {
        return new $c_Lreactbuild_project_Selection$All()
      } else {
        throw new $c_s_MatchError(x0$24)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$15 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$15
}
/** @constructor */
function $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1(decode0$1) {
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$1 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$2 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$3 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$4 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$5 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$14 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$15 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0 = 0;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_decode0$1 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_decode0$1 = decode0$1
}
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype = new $h_O();
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype.constructor = $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1;
/** @constructor */
function $h_Lreactbuild_project_Selection$anon$lazy$macro$16$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype = $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype;
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype.inst$macro$1__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((1 & this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$1)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype.inst$macro$2__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((2 & this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$2)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((4 & this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$3)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((8 & this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$4)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((16 & this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$5)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype.inst$macro$14__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((((32 & this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$14$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$14)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype.inst$macro$15__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((((64 & this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$16$1__inst$macro$15$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_inst$macro$15)
});
var $d_Lreactbuild_project_Selection$anon$lazy$macro$16$1 = new $TypeData().initClass({
  Lreactbuild_project_Selection$anon$lazy$macro$16$1: 0
}, false, "reactbuild.project.Selection$anon$lazy$macro$16$1", {
  Lreactbuild_project_Selection$anon$lazy$macro$16$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1.prototype.$classData = $d_Lreactbuild_project_Selection$anon$lazy$macro$16$1;
function $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((1 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "All"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "List"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "None")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_project_Selection(p$2);
      var $$x4 = $m_Lshapeless_Coproduct$();
      if ((p instanceof $c_Lreactbuild_project_Selection$All)) {
        var $$x3 = 0
      } else if ((p instanceof $c_Lreactbuild_project_Selection$List)) {
        var $$x3 = 1
      } else {
        if ((!(p instanceof $c_Lreactbuild_project_Selection$None))) {
          throw new $c_s_MatchError(p)
        };
        var $$x3 = 2
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x4).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x3, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_Lshapeless_$colon$plus$colon(x$8$2);
      return $as_Lreactbuild_project_Selection($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$8))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "None"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "List"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "All"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$19__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$18 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2(config, encode, gen$1);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$18
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$19$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((2 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$19 = new $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13($thiz);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$19
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((4 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      var x0$31 = $as_Lreactbuild_project_Selection$None(x0$31$2);
      if ((x0$31 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$31)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      var x0$32 = $as_Lshapeless_HNil(x0$32$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$32)) {
        return new $c_Lreactbuild_project_Selection$None()
      } else {
        throw new $c_s_MatchError(x0$32)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$21__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$20 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0 = (((4 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$20
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((8 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$21 = new $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14($thiz);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0 = (((8 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$21
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((16 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "items")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      var x0$39 = $as_Lreactbuild_project_Selection$List(x0$39$2);
      if ((x0$39 !== null)) {
        var items$macro$30 = $n(x0$39).Lreactbuild_project_Selection$List__f_items;
        return new $c_Lshapeless_$colon$colon(items$macro$30, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$39)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      var x0$40 = $as_Lshapeless_$colon$colon(x0$40$2);
      if ((x0$40 !== null)) {
        var items$macro$29 = $as_sci_List($n(x0$40).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$40).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_project_Selection$List(items$macro$29)
        }
      };
      throw new $c_s_MatchError(x0$40)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "items"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$31__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "items"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$15 = $m_s_$less$colon$less$();
    var ev$1 = this$15.s_$less$colon$less$__f_singleton;
    var this$16 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$16);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$20 = $m_s_$less$colon$less$();
    var ev$2 = this$20.s_$less$colon$less$__f_singleton;
    var this$21 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$21);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$22 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0 = (((16 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$22
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$31$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((((32 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$31 = new $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15($thiz);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0 = (((32 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$31
}
function $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$32$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((((64 & $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      var x0$47 = $as_Lreactbuild_project_Selection$All(x0$47$2);
      if ((x0$47 !== null)) {
        return $m_Lshapeless_HNil$()
      } else {
        throw new $c_s_MatchError(x0$47)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      var x0$48 = $as_Lshapeless_HNil(x0$48$2);
      var x = $m_Lshapeless_HNil$();
      if ((x === x0$48)) {
        return new $c_Lreactbuild_project_Selection$All()
      } else {
        throw new $c_s_MatchError(x0$48)
      }
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$21__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$32 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0 = (((64 | $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$32
}
/** @constructor */
function $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1(encode0$1) {
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$18 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$19 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$20 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$21 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$22 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$31 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$32 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0 = 0;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_encode0$1 = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_encode0$1 = encode0$1
}
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype = new $h_O();
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype.constructor = $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1;
/** @constructor */
function $h_Lreactbuild_project_Selection$anon$lazy$macro$33$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype = $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype;
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype.inst$macro$18__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((1 & this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$18)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype.inst$macro$19__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((2 & this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$19$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$19)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype.inst$macro$20__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((4 & this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$20)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype.inst$macro$21__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((8 & this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$21)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype.inst$macro$22__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((16 & this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$22)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype.inst$macro$31__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((((32 & this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$31$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$31)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype.inst$macro$32__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((((64 & this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_Selection$anon$lazy$macro$33$1__inst$macro$32$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_inst$macro$32)
});
var $d_Lreactbuild_project_Selection$anon$lazy$macro$33$1 = new $TypeData().initClass({
  Lreactbuild_project_Selection$anon$lazy$macro$33$1: 0
}, false, "reactbuild.project.Selection$anon$lazy$macro$33$1", {
  Lreactbuild_project_Selection$anon$lazy$macro$33$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1.prototype.$classData = $d_Lreactbuild_project_Selection$anon$lazy$macro$33$1;
function $is_Lreactbuild_project_drawing_CommandTool(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_CommandTool)))
}
function $as_Lreactbuild_project_drawing_CommandTool(obj) {
  return (($is_Lreactbuild_project_drawing_CommandTool(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.CommandTool"))
}
function $isArrayOf_Lreactbuild_project_drawing_CommandTool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_CommandTool)))
}
function $asArrayOf_Lreactbuild_project_drawing_CommandTool(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_CommandTool(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.CommandTool;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Theme$() {
  this.Lreactbuild_project_drawing_Theme$__f_defaultTheme = null;
  this.Lreactbuild_project_drawing_Theme$__f_walls = null;
  this.Lreactbuild_project_drawing_Theme$__f_furnitures = null;
  this.Lreactbuild_project_drawing_Theme$__f_network = null;
  $n_Lreactbuild_project_drawing_Theme$ = this;
  var this$10 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $m_Lreactbuild_project_drawing_Wall$();
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self, "#000000");
  var self$1 = $m_Lreactbuild_project_drawing_Joinery$();
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$1, "#ff00ff");
  var self$2 = $m_Lreactbuild_project_drawing_KitchenFurniture$();
  var array = [$$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$2, "#ffaa00")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_project_drawing_Theme$__f_defaultTheme = new $c_Lreactbuild_project_drawing_Theme("#cccccc", "Gill Sans MT Condensed", this$10.from__sc_IterableOnce__sci_Map(elems));
  var this$16 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$3 = $m_Lreactbuild_project_drawing_Wall$();
  var array$1 = [$ct_T2__O__O__(new $c_T2(), self$3, "#0000ff")];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lreactbuild_project_drawing_Theme$__f_walls = new $c_Lreactbuild_project_drawing_Theme("#cccccc", "Gill Sans MT Condensed", this$16.from__sc_IterableOnce__sci_Map(elems$1));
  var this$28 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$4 = $m_Lreactbuild_project_drawing_Wall$();
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$4, "#000000");
  var self$5 = $m_Lreactbuild_project_drawing_Joinery$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$5, "#ff0000");
  var self$6 = $m_Lreactbuild_project_drawing_Furniture$();
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$6, "#0000ff");
  var self$7 = $m_Lreactbuild_project_drawing_KitchenFurniture$();
  var array$2 = [$$x5, $$x4, $$x3, $ct_T2__O__O__(new $c_T2(), self$7, "#ffaa00")];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lreactbuild_project_drawing_Theme$__f_furnitures = new $c_Lreactbuild_project_drawing_Theme("#cccccc", "Gill Sans MT Condensed", this$28.from__sc_IterableOnce__sci_Map(elems$2));
  var this$38 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self$8 = $m_Lreactbuild_project_drawing_Wall$();
  var $$x7 = $ct_T2__O__O__(new $c_T2(), self$8, "#000000");
  var self$9 = $m_Lreactbuild_project_drawing_Joinery$();
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self$9, "#cccccc");
  var self$10 = $m_Lreactbuild_project_drawing_KitchenFurniture$();
  var array$3 = [$$x7, $$x6, $ct_T2__O__O__(new $c_T2(), self$10, "#cccccc")];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  this.Lreactbuild_project_drawing_Theme$__f_network = new $c_Lreactbuild_project_drawing_Theme("#cccccc", "Gill Sans MT Condensed", this$38.from__sc_IterableOnce__sci_Map(elems$3))
}
$c_Lreactbuild_project_drawing_Theme$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Theme$.prototype.constructor = $c_Lreactbuild_project_drawing_Theme$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Theme$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Theme$.prototype = $c_Lreactbuild_project_drawing_Theme$.prototype;
var $d_Lreactbuild_project_drawing_Theme$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Theme$: 0
}, false, "reactbuild.project.drawing.Theme$", {
  Lreactbuild_project_drawing_Theme$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Theme$.prototype.$classData = $d_Lreactbuild_project_drawing_Theme$;
var $n_Lreactbuild_project_drawing_Theme$;
function $m_Lreactbuild_project_drawing_Theme$() {
  if ((!$n_Lreactbuild_project_drawing_Theme$)) {
    $n_Lreactbuild_project_drawing_Theme$ = new $c_Lreactbuild_project_drawing_Theme$()
  };
  return $n_Lreactbuild_project_drawing_Theme$
}
function $is_Lreactbuild_project_drawing_ToggleTool(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_ToggleTool)))
}
function $as_Lreactbuild_project_drawing_ToggleTool(obj) {
  return (($is_Lreactbuild_project_drawing_ToggleTool(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.ToggleTool"))
}
function $isArrayOf_Lreactbuild_project_drawing_ToggleTool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_ToggleTool)))
}
function $asArrayOf_Lreactbuild_project_drawing_ToggleTool(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_ToggleTool(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.ToggleTool;", depth))
}
function $is_Lreactbuild_project_drawing_UITool(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_UITool)))
}
function $as_Lreactbuild_project_drawing_UITool(obj) {
  return (($is_Lreactbuild_project_drawing_UITool(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.UITool"))
}
function $isArrayOf_Lreactbuild_project_drawing_UITool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_UITool)))
}
function $asArrayOf_Lreactbuild_project_drawing_UITool(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_UITool(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.UITool;", depth))
}
function $is_Lreactbuild_project_drawing_ViewportTool(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_project_drawing_ViewportTool)))
}
function $as_Lreactbuild_project_drawing_ViewportTool(obj) {
  return (($is_Lreactbuild_project_drawing_ViewportTool(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.ViewportTool"))
}
function $isArrayOf_Lreactbuild_project_drawing_ViewportTool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_ViewportTool)))
}
function $asArrayOf_Lreactbuild_project_drawing_ViewportTool(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_ViewportTool(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.ViewportTool;", depth))
}
/** @constructor */
function $c_Lreactbuild_project_generator_GeneratorPageContext$() {
  this.Lreactbuild_project_generator_GeneratorPageContext$__f_context = null;
  $n_Lreactbuild_project_generator_GeneratorPageContext$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_React$();
  this.Lreactbuild_project_generator_GeneratorPageContext$__f_context = $n(this$1.Ljapgolly_scalajs_react_React$__f_Context).apply__T__O__Ljapgolly_scalajs_react_feature_Context("GeneratorPageContext", null)
}
$c_Lreactbuild_project_generator_GeneratorPageContext$.prototype = new $h_O();
$c_Lreactbuild_project_generator_GeneratorPageContext$.prototype.constructor = $c_Lreactbuild_project_generator_GeneratorPageContext$;
/** @constructor */
function $h_Lreactbuild_project_generator_GeneratorPageContext$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_GeneratorPageContext$.prototype = $c_Lreactbuild_project_generator_GeneratorPageContext$.prototype;
var $d_Lreactbuild_project_generator_GeneratorPageContext$ = new $TypeData().initClass({
  Lreactbuild_project_generator_GeneratorPageContext$: 0
}, false, "reactbuild.project.generator.GeneratorPageContext$", {
  Lreactbuild_project_generator_GeneratorPageContext$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_GeneratorPageContext$.prototype.$classData = $d_Lreactbuild_project_generator_GeneratorPageContext$;
var $n_Lreactbuild_project_generator_GeneratorPageContext$;
function $m_Lreactbuild_project_generator_GeneratorPageContext$() {
  if ((!$n_Lreactbuild_project_generator_GeneratorPageContext$)) {
    $n_Lreactbuild_project_generator_GeneratorPageContext$ = new $c_Lreactbuild_project_generator_GeneratorPageContext$()
  };
  return $n_Lreactbuild_project_generator_GeneratorPageContext$
}
/** @constructor */
function $c_Lreactbuild_project_generator_MediaSize$() {
  this.Lreactbuild_project_generator_MediaSize$__f_A3 = null;
  this.Lreactbuild_project_generator_MediaSize$__f_A4 = null;
  $n_Lreactbuild_project_generator_MediaSize$ = this;
  this.Lreactbuild_project_generator_MediaSize$__f_A3 = new $c_Lreactbuild_project_generator_MediaSize(new $c_T2$mcDD$sp(297.0, 420.0));
  this.Lreactbuild_project_generator_MediaSize$__f_A4 = new $c_Lreactbuild_project_generator_MediaSize(new $c_T2$mcDD$sp(210.0, 297.0))
}
$c_Lreactbuild_project_generator_MediaSize$.prototype = new $h_O();
$c_Lreactbuild_project_generator_MediaSize$.prototype.constructor = $c_Lreactbuild_project_generator_MediaSize$;
/** @constructor */
function $h_Lreactbuild_project_generator_MediaSize$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_MediaSize$.prototype = $c_Lreactbuild_project_generator_MediaSize$.prototype;
var $d_Lreactbuild_project_generator_MediaSize$ = new $TypeData().initClass({
  Lreactbuild_project_generator_MediaSize$: 0
}, false, "reactbuild.project.generator.MediaSize$", {
  Lreactbuild_project_generator_MediaSize$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_MediaSize$.prototype.$classData = $d_Lreactbuild_project_generator_MediaSize$;
var $n_Lreactbuild_project_generator_MediaSize$;
function $m_Lreactbuild_project_generator_MediaSize$() {
  if ((!$n_Lreactbuild_project_generator_MediaSize$)) {
    $n_Lreactbuild_project_generator_MediaSize$ = new $c_Lreactbuild_project_generator_MediaSize$()
  };
  return $n_Lreactbuild_project_generator_MediaSize$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1(outer) {
  this.Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1__f_$outer = outer
  }
}
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1.prototype.toString__T = (function() {
  return "<function2>"
});
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1.prototype.apply__ju_UUID__s_Option__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, target) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1__f_$outer).Lreactbuild_project_generator_electricalboard_components_Table$Backend__f_reactbuild$project$generator$electricalboard$components$Table$Backend$$$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  var this$4 = $n($as_Ljapgolly_scalajs_react_StateAccess$ModState($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)));
  var mod = new $c_sjsr_AnonFunction1(((table$2) => {
    var table = $as_Lreactbuild_project_generator_electricalboard_model_Table(table$2);
    return $n(table).move__ju_UUID__s_Option__Lreactbuild_project_generator_electricalboard_model_Table(source, target)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$4, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1.prototype.apply__O__O__O = (function(v1, v2) {
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.apply__ju_UUID__s_Option__Ljapgolly_scalajs_react_callback_Trampoline($as_ju_UUID(v1), $as_s_Option(v2)))
});
var $d_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1: 0
}, false, "reactbuild.project.generator.electricalboard.components.Table$Backend$$anon$1", {
  Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1: 1,
  O: 1,
  F2: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Table$Backend$$anon$1;
function $p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  $n(b$1$lzy$1);
  if ($n(b$1$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__b$1$1__sr_LazyRef__F2($thiz, b$1$lzy$1) {
  return ($n(b$1$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$1$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__b$1$lzycompute$1__sr_LazyRef__F2($thiz, b$1$lzy$1))
}
function $p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  $n(b$2$lzy$1);
  if ($n(b$2$lzy$1).sr_LazyRef__f__initialized) {
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test
  } else {
    var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
    var e = new $c_Ljapgolly_scalajs_react_Reusability(this$1.by_$eq$eq__F2());
    return $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).initialize__O__O(e))).Ljapgolly_scalajs_react_Reusability__f_test
  }
}
function $p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__b$2$1__sr_LazyRef__F2($thiz, b$2$lzy$1) {
  return ($n(b$2$lzy$1).sr_LazyRef__f__initialized ? $n($as_Ljapgolly_scalajs_react_Reusability($n(b$2$lzy$1).sr_LazyRef__f__value)).Ljapgolly_scalajs_react_Reusability__f_test : $p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__b$2$lzycompute$1__sr_LazyRef__F2($thiz, b$2$lzy$1))
}
function $p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__upper$1__I($thiz) {
  return (((-1) + $n($m_Lreactbuild_project_generator_electricalboard_components_WireColors$().Lreactbuild_project_generator_electricalboard_components_WireColors$__f_wireColors).length__I()) | 0)
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State$() {
  $n_Lreactbuild_project_generator_electricalboard_components_WireColors$State$ = this;
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  new $c_sr_LazyRef();
  var elem = null;
  elem = null;
  var b$1$lzy = new $c_sr_LazyRef();
  var b$2$lzy = new $c_sr_LazyRef();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lreactbuild_project_generator_electricalboard_components_WireColors$State(a$2);
    var b = $as_Lreactbuild_project_generator_electricalboard_components_WireColors$State(b$2);
    if (($uZ($n($p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus, $n(b).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus)) && $uZ($n($p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__b$1$1__sr_LazyRef__F2(this, b$1$lzy)).apply__O__O__O($n(a).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver, $n(b).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver)))) {
      var this$3 = $n($p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__b$2$1__sr_LazyRef__F2(this, b$2$lzy));
      var v1 = $n(a).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index;
      var v2 = $n(b).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index;
      return $uZ(this$3.apply__O__O__O(v1, v2))
    } else {
      return false
    }
  }));
  elem = f;
  $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $as_F2(elem))
}
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_WireColors$State$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_WireColors$State$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State$.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State$.prototype.reducer__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((state$2, action$2) => {
    var state = $as_Lreactbuild_project_generator_electricalboard_components_WireColors$State(state$2);
    var action = $as_Lreactbuild_project_generator_electricalboard_components_WireColors$Action(action$2);
    var x = $m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$();
    if ((x === action)) {
      var this$2 = $n(state);
      var x$2$2 = this$2.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus;
      var this$3 = $n(state);
      var x$3 = this$3.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index;
      $n(state);
      return new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State(x$2$2, true, x$3)
    } else {
      var x$4 = $m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$();
      if ((x$4 === action)) {
        var this$5 = $n(state);
        var x$5$2 = this$5.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus;
        var this$6 = $n(state);
        var x$6 = this$6.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index;
        $n(state);
        return new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State(x$5$2, false, x$6)
      } else {
        var x$7 = $m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$();
        if ((x$7 === action)) {
          $n(state);
          var this$8 = $n(state);
          var mouseOver = this$8.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver;
          var this$9 = $n(state);
          var index = this$9.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index;
          return new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State(true, mouseOver, index)
        } else {
          var x$9 = $m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$();
          if ((x$9 === action)) {
            $n(state);
            var this$11 = $n(state);
            var mouseOver$1 = this$11.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver;
            var this$12 = $n(state);
            var index$1 = this$12.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index;
            return new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State(false, mouseOver$1, index$1)
          } else if ((action instanceof $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex)) {
            var x6 = $as_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex(action);
            var delta = $n(x6).Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_delta;
            var extended = $n(x6).Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_extended;
            if (extended) {
              var nextIndex = ((delta < 0) ? 0 : $p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__upper$1__I(this))
            } else {
              var a = $p_Lreactbuild_project_generator_electricalboard_components_WireColors$State$__upper$1__I(this);
              var b = (($n(state).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index + delta) | 0);
              var b$1 = ((a < b) ? a : b);
              var nextIndex = ((b$1 < 0) ? 0 : b$1)
            };
            var this$16 = $n(state);
            var x$8$2 = this$16.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus;
            var this$17 = $n(state);
            var x$9$2 = this$17.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver;
            $n(state);
            return new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State(x$8$2, x$9$2, nextIndex)
          } else {
            throw new $c_s_MatchError(action)
          }
        }
      }
    }
  }))
});
var $d_Lreactbuild_project_generator_electricalboard_components_WireColors$State$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_WireColors$State$: 0
}, false, "reactbuild.project.generator.electricalboard.components.WireColors$State$", {
  Lreactbuild_project_generator_electricalboard_components_WireColors$State$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_WireColors$State$;
var $n_Lreactbuild_project_generator_electricalboard_components_WireColors$State$;
function $m_Lreactbuild_project_generator_electricalboard_components_WireColors$State$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_WireColors$State$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_WireColors$State$ = new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_WireColors$State$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Cell$() {
  this.Lreactbuild_project_generator_electricalboard_model_Cell$__f_codecForCell = null;
  $n_Lreactbuild_project_generator_electricalboard_model_Cell$ = this;
  var inst$macro$60 = new $c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$60));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_project_generator_electricalboard_model_Cell$__f_codecForCell = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_project_generator_electricalboard_model_Cell$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Cell$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Cell$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Cell$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Cell$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Cell$.prototype;
var $d_Lreactbuild_project_generator_electricalboard_model_Cell$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Cell$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Cell$", {
  Lreactbuild_project_generator_electricalboard_model_Cell$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Cell$;
var $n_Lreactbuild_project_generator_electricalboard_model_Cell$;
function $m_Lreactbuild_project_generator_electricalboard_model_Cell$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Cell$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Cell$ = new $c_Lreactbuild_project_generator_electricalboard_model_Cell$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Cell$
}
function $p_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "label1"));
    var this$3 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "label2"));
    var this$4 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "icon"));
    var this$5 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "span"));
    var this$6 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "targets"));
    var this$7 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "intensity")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$51 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
        var label1$macro$52 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
        var label2$macro$53 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
        var icon$macro$54 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
        var span$macro$55 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
        var targets$macro$56 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
        var intensity$macro$57 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
        return new $c_Lshapeless_$colon$colon(id$macro$51, new $c_Lshapeless_$colon$colon(label1$macro$52, new $c_Lshapeless_$colon$colon(label2$macro$53, new $c_Lshapeless_$colon$colon(icon$macro$54, new $c_Lshapeless_$colon$colon(span$macro$55, new $c_Lshapeless_$colon$colon(targets$macro$56, new $c_Lshapeless_$colon$colon(intensity$macro$57, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$44 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var label1$macro$45 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var label2$macro$46 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var icon$macro$47 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var span$macro$48 = $uI($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var targets$macro$49 = $as_sci_List($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var intensity$macro$50 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_project_generator_electricalboard_model_Cell(id$macro$44, label1$macro$45, label2$macro$46, icon$macro$47, span$macro$48, targets$macro$49, intensity$macro$50)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "intensity"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "targets"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "span"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "icon"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "label2"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "label1"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$32 = $m_s_$less$colon$less$();
    var ev = this$32.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Cell$(), $m_ju_UUID$().randomUUID__ju_UUID())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Cell$(), "")), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Cell$(), "")), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Cell$(), $m_s_None$())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Cell$(), 1)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Cell$(), $m_s_package$().s_package$__f_Nil)), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Cell$(), $m_s_Option$().apply__O__s_Option(16))), $m_Lshapeless_HNil$())))))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$40 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "id"));
    var this$41 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "label1"));
    var this$42 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$42, "label2"));
    var this$43 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "icon"));
    var this$44 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "span"));
    var this$45 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "targets"));
    var this$46 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "intensity")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var tailHelper$4 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var tailHelper$5 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$4);
    var tailHelper$6 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$5);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$6);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$57 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "id"));
    var wit$6 = new $c_Lshapeless_Witness$$anon$1(value0$7);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$59 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "label1"));
    var wit$5 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$61 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "label2"));
    var wit$4 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "icon"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$65 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "span"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$67 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "targets"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$69 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$69, "intensity"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var rtmT$4 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var rtmT$5 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$4, wit$4);
    var rtmT$6 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$5, wit$5);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$6, wit$6);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$78 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "id"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    $m_Lshapeless_Witness$();
    var this$80 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "label1"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    $m_Lshapeless_Witness$();
    var this$82 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$82, "label2"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    $m_Lshapeless_Witness$();
    var this$84 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$84, "icon"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    $m_Lshapeless_Witness$();
    var this$86 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$86, "span"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    $m_Lshapeless_Witness$();
    var this$88 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "targets"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    $m_Lshapeless_Witness$();
    var this$90 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "intensity"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$20);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var kt$4 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var kt$5 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$4, kt$4);
    var kt$6 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$5, kt$5);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$6, kt$6);
    var this$100 = $m_s_$less$colon$less$();
    var ev$1 = this$100.s_$less$colon$less$__f_singleton;
    var this$101 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$101);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$105 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$105);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$109 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$109);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$113 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$113);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$117 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$117);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$121 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$121);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$125 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$125);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$5, tttvs$5);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$129 = $m_s_$less$colon$less$();
    var ev$2 = this$129.s_$less$colon$less$__f_singleton;
    var this$130 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$130);
    var tttvs$6 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$7, ev$2);
    var u$6 = new $c_Lshapeless_Lub$$anon$4();
    var this$134 = $m_sci_List$();
    var cbf$8 = new $c_sc_IterableFactory$ToFactory(this$134);
    var tttvs$7 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$8, u$6, tttvs$6);
    var u$7 = new $c_Lshapeless_Lub$$anon$4();
    var this$138 = $m_sci_List$();
    var cbf$9 = new $c_sc_IterableFactory$ToFactory(this$138);
    var tttvs$8 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$9, u$7, tttvs$7);
    var u$8 = new $c_Lshapeless_Lub$$anon$4();
    var this$142 = $m_sci_List$();
    var cbf$10 = new $c_sc_IterableFactory$ToFactory(this$142);
    var tttvs$9 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$10, u$8, tttvs$8);
    var u$9 = new $c_Lshapeless_Lub$$anon$4();
    var this$146 = $m_sci_List$();
    var cbf$11 = new $c_sc_IterableFactory$ToFactory(this$146);
    var tttvs$10 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$11, u$9, tttvs$9);
    var u$10 = new $c_Lshapeless_Lub$$anon$4();
    var this$150 = $m_sci_List$();
    var cbf$12 = new $c_sc_IterableFactory$ToFactory(this$150);
    var tttvs$11 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$12, u$10, tttvs$10);
    var u$11 = new $c_Lshapeless_Lub$$anon$4();
    var this$154 = $m_sci_List$();
    var cbf$13 = new $c_sc_IterableFactory$ToFactory(this$154);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$13, u$11, tttvs$11);
    $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_inst$macro$1
}
function $p_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_inst$macro$58 = new $c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1($thiz);
    $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_inst$macro$58
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1() {
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_inst$macro$1 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_inst$macro$58 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_bitmap$0 = 0
}
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_inst$macro$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1.prototype.inst$macro$58__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__inst$macro$58$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1__f_inst$macro$58)
});
var $d_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.Cell$anon$lazy$macro$59$1", {
  Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Line$() {
  this.Lreactbuild_project_generator_electricalboard_model_Line$__f_codecForLine = null;
  $n_Lreactbuild_project_generator_electricalboard_model_Line$ = this;
  var inst$macro$20 = new $c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$20));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_project_generator_electricalboard_model_Line$__f_codecForLine = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_project_generator_electricalboard_model_Line$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Line$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Line$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Line$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Line$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Line$.prototype;
var $d_Lreactbuild_project_generator_electricalboard_model_Line$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Line$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Line$", {
  Lreactbuild_project_generator_electricalboard_model_Line$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Line$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Line$;
var $n_Lreactbuild_project_generator_electricalboard_model_Line$;
function $m_Lreactbuild_project_generator_electricalboard_model_Line$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Line$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Line$ = new $c_Lreactbuild_project_generator_electricalboard_model_Line$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Line$
}
function $p_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "cells")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_project_generator_electricalboard_model_Line(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$16 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Line__f_id;
        var cells$macro$17 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Line__f_cells;
        return new $c_Lshapeless_$colon$colon(id$macro$16, new $c_Lshapeless_$colon$colon(cells$macro$17, $m_Lshapeless_HNil$()))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$14 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var cells$macro$15 = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_project_generator_electricalboard_model_Line(id$macro$14, cells$macro$15)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "cells"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Line$(), $m_ju_UUID$().randomUUID__ju_UUID())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Line$(), $m_s_package$().s_package$__f_Nil)), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$18 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "id"));
    var this$19 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "cells")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "id"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$27 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "cells"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "id"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "cells"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$38 = $m_s_$less$colon$less$();
    var ev$1 = this$38.s_$less$colon$less$__f_singleton;
    var this$39 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$39);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$43 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$43);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$47 = $m_s_$less$colon$less$();
    var ev$2 = this$47.s_$less$colon$less$__f_singleton;
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$52 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$52);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_inst$macro$1
}
function $p_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_inst$macro$18 = new $c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1($thiz);
    $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_inst$macro$18
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1() {
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_inst$macro$1 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_inst$macro$18 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_bitmap$0 = 0
}
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_inst$macro$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1.prototype.inst$macro$18__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1__f_inst$macro$18)
});
var $d_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.Line$anon$lazy$macro$19$1", {
  Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_LineSource$() {
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$__f_codecForLineSource = null;
  $n_Lreactbuild_project_generator_electricalboard_model_LineSource$ = this;
  var inst$macro$36 = new $c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$36));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$__f_codecForLineSource = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_LineSource$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_LineSource$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_LineSource$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_LineSource$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$.prototype.apply$default$4__sci_Set = (function() {
  var this$4 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [$m_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$(), $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return this$4.from__sc_IterableOnce__sci_Set(elems)
});
var $d_Lreactbuild_project_generator_electricalboard_model_LineSource$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_LineSource$: 0
}, false, "reactbuild.project.generator.electricalboard.model.LineSource$", {
  Lreactbuild_project_generator_electricalboard_model_LineSource$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_LineSource$;
var $n_Lreactbuild_project_generator_electricalboard_model_LineSource$;
function $m_Lreactbuild_project_generator_electricalboard_model_LineSource$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_LineSource$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_LineSource$ = new $c_Lreactbuild_project_generator_electricalboard_model_LineSource$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_LineSource$
}
function $p_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "id"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "label"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "diameter"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "wireColors")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(x0$7$2);
      if ((x0$7 !== null)) {
        var id$macro$30 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_LineSource__f_id;
        var label$macro$31 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_LineSource__f_label;
        var diameter$macro$32 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter;
        var wireColors$macro$33 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors;
        return new $c_Lshapeless_$colon$colon(id$macro$30, new $c_Lshapeless_$colon$colon(label$macro$31, new $c_Lshapeless_$colon$colon(diameter$macro$32, new $c_Lshapeless_$colon$colon(wireColors$macro$33, $m_Lshapeless_HNil$()))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var id$macro$26 = $as_ju_UUID($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var label$macro$27 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var diameter$macro$28 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var wireColors$macro$29 = $as_sci_Set($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p5)) {
                return new $c_Lreactbuild_project_generator_electricalboard_model_LineSource(id$macro$26, label$macro$27, diameter$macro$28, wireColors$macro$29)
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "wireColors"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "diameter"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "label"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "id"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_LineSource$(), $m_ju_UUID$().randomUUID__ju_UUID())), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_LineSource$(), "")), new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_LineSource$(), $m_s_Option$().apply__O__s_Option(2.5))), new $c_Lshapeless_$colon$colon(new $c_s_Some($m_Lreactbuild_project_generator_electricalboard_model_LineSource$().apply$default$4__sci_Set()), $m_Lshapeless_HNil$()))));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$26 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "id"));
    var this$27 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "label"));
    var this$28 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "diameter"));
    var this$29 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "wireColors")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1);
    var tailHelper$3 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$2);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$3);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "id"));
    var wit$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$39 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "label"));
    var wit$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "diameter"));
    var wit$1 = new $c_Lshapeless_Witness$$anon$1(value0$6);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "wireColors"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var rtmT$1 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var rtmT$2 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$1, wit$1);
    var rtmT$3 = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$2, wit$2);
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT$3, wit$3);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "id"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    $m_Lshapeless_Witness$();
    var this$51 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "label"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "diameter"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "wireColors"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var kt$3 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$3, kt$3);
    var this$62 = $m_s_$less$colon$less$();
    var ev$1 = this$62.s_$less$colon$less$__f_singleton;
    var this$63 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$63);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$67 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$67);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$71 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$71);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$75 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$75);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$2);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$79 = $m_s_$less$colon$less$();
    var ev$2 = this$79.s_$less$colon$less$__f_singleton;
    var this$80 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$80);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$4, ev$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$84 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$84);
    var tttvs$4 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    var u$4 = new $c_Lshapeless_Lub$$anon$4();
    var this$88 = $m_sci_List$();
    var cbf$6 = new $c_sc_IterableFactory$ToFactory(this$88);
    var tttvs$5 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$6, u$4, tttvs$4);
    var u$5 = new $c_Lshapeless_Lub$$anon$4();
    var this$92 = $m_sci_List$();
    var cbf$7 = new $c_sc_IterableFactory$ToFactory(this$92);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$7, u$5, tttvs$5);
    $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_inst$macro$1
}
function $p_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_inst$macro$34 = new $c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1($thiz);
    $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_inst$macro$34
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1() {
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_inst$macro$1 = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_inst$macro$34 = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_bitmap$0 = 0
}
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_inst$macro$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1.prototype.inst$macro$34__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__inst$macro$34$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1__f_inst$macro$34)
});
var $d_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.LineSource$anon$lazy$macro$35$1", {
  Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1;
function $f_Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor__$init$__V($thiz) {
  var rassoc$1 = $thiz.color__T();
  var this$1 = $n($m_s_package$().s_package$__f_Nil);
  $thiz.reactbuild$project$generator$electricalboard$model$SingleColorWireColor$_setter_$colors_$eq__sci_List__V(new $c_sci_$colon$colon(rassoc$1, this$1))
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Table$() {
  this.Lreactbuild_project_generator_electricalboard_model_Table$__f_codecForTable = null;
  $n_Lreactbuild_project_generator_electricalboard_model_Table$ = this;
  var inst$macro$12 = new $c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$12));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_project_generator_electricalboard_model_Table$__f_codecForTable = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_project_generator_electricalboard_model_Table$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Table$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Table$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Table$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Table$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Table$.prototype;
var $d_Lreactbuild_project_generator_electricalboard_model_Table$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Table$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Table$", {
  Lreactbuild_project_generator_electricalboard_model_Table$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Table$;
var $n_Lreactbuild_project_generator_electricalboard_model_Table$;
function $m_Lreactbuild_project_generator_electricalboard_model_Table$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Table$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Table$ = new $c_Lreactbuild_project_generator_electricalboard_model_Table$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Table$
}
function $p_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "lines")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_project_generator_electricalboard_model_Table(x0$7$2);
      if ((x0$7 !== null)) {
        var lines$macro$9 = $n(x0$7).Lreactbuild_project_generator_electricalboard_model_Table__f_lines;
        return new $c_Lshapeless_$colon$colon(lines$macro$9, $m_Lshapeless_HNil$())
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var lines$macro$8 = $as_sci_Seq($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_HNil($n(x0$8).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p2)) {
          return new $c_Lreactbuild_project_generator_electricalboard_model_Table(lines$macro$8)
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$5 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "lines"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    var this$8 = $m_s_$less$colon$less$();
    var ev = this$8.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon(new $c_s_Some(($m_Lreactbuild_project_generator_electricalboard_model_Table$(), $m_s_package$().s_package$__f_Nil)), $m_Lshapeless_HNil$());
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$13 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "lines")), $m_Lshapeless_HNil$());
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    $m_Lio_circe_generic_extras_util_RecordToMap$();
    $m_Lshapeless_Witness$();
    var this$18 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "lines"));
    var wit = new $c_Lshapeless_Witness$$anon$1(value0$1);
    var rtmT = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var defaultMapper = new $c_Lio_circe_generic_extras_util_RecordToMap$$anon$2(rtmT, wit);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$21 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "lines"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$2);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var this$25 = $m_s_$less$colon$less$();
    var ev$1 = this$25.s_$less$colon$less$__f_singleton;
    var this$26 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$26);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$30 = $m_s_$less$colon$less$();
    var ev$2 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$31);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$1, ev$2);
    $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_inst$macro$1
}
function $p_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_inst$macro$10 = new $c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1($thiz);
    $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_inst$macro$10
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1() {
  this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_inst$macro$1 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_inst$macro$10 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_bitmap$0 = 0
}
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_inst$macro$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1.prototype.inst$macro$10__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1__f_inst$macro$10)
});
var $d_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.Table$anon$lazy$macro$11$1", {
  Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1;
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Black"));
    var this$2 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Blue"));
    var this$3 = $m_s_Symbol$();
    var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Brown"));
    var this$4 = $m_s_Symbol$();
    var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "Gray"));
    var this$5 = $m_s_Symbol$();
    var $$x5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "Ground"));
    var this$6 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "LightBlue"));
    var this$7 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "Orange"));
    var this$8 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "Red"));
    var this$9 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "Violet"));
    var this$10 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($$x5, new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "White")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_project_generator_electricalboard_model_WireColor(p$2);
      var $$x11 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$())) {
        var $$x10 = 0
      } else if ((p === $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$())) {
        var $$x10 = 1
      } else if ((p === $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$())) {
        var $$x10 = 2
      } else if ((p === $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$())) {
        var $$x10 = 3
      } else if ((p === $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$())) {
        var $$x10 = 4
      } else if ((p === $m_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$())) {
        var $$x10 = 5
      } else if ((p === $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$())) {
        var $$x10 = 6
      } else if ((p === $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$())) {
        var $$x10 = 7
      } else if ((p === $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$())) {
        var $$x10 = 8
      } else {
        if ((p !== $m_Lreactbuild_project_generator_electricalboard_model_WireColor$White$())) {
          throw new $c_s_MatchError(p)
        };
        var $$x10 = 9
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x11).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x10, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_project_generator_electricalboard_model_WireColor($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "White"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "Violet"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "Red"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "Orange"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "LightBlue"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "Ground"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "Gray"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "Brown"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "Blue"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$41 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "Black"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$9);
    var this$44 = $m_s_$less$colon$less$();
    var ev = this$44.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$1
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$2 = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1($thiz);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$2
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$White$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$White$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$3
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$4
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$5
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$6 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$6
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$7 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$7
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((128 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$(x0$39$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      $as_Lshapeless_HNil(x0$40$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$8 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$8
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((256 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$(x0$47$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      $as_Lshapeless_HNil(x0$48$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$9 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$9
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((512 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$(x0$55$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      $as_Lshapeless_HNil(x0$56$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$10 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$10
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$11$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$(x0$63$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      $as_Lshapeless_HNil(x0$64$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$11 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$11
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$71$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$(x0$71$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$72$2) => {
      $as_Lshapeless_HNil(x0$72$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$12 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$12
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4096 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$79$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$(x0$79$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$80$2) => {
      $as_Lshapeless_HNil(x0$80$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$13 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (4096 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$13
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$14$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((8192 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$87$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$White$(x0$87$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$88$2) => {
      $as_Lshapeless_HNil(x0$88$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$White$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$14 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (8192 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$14
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$15$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((16384 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$15 = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2($thiz);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (16384 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$15
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$16$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((32768 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$95$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$(x0$95$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$96$2) => {
      $as_Lshapeless_HNil(x0$96$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$16 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (32768 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$16
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$17$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((65536 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$103$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$(x0$103$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$104$2) => {
      $as_Lshapeless_HNil(x0$104$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$17 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (65536 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$17
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((131072 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$111$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$(x0$111$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$112$2) => {
      $as_Lshapeless_HNil(x0$112$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$18 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (131072 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$18
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$19$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((262144 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$119$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$(x0$119$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$120$2) => {
      $as_Lshapeless_HNil(x0$120$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$19 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (262144 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$19
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((524288 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$127$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$(x0$127$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$128$2) => {
      $as_Lshapeless_HNil(x0$128$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$20 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (524288 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$20
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1048576 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$135$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$(x0$135$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$136$2) => {
      $as_Lshapeless_HNil(x0$136$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$21 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (1048576 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$21
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((2097152 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$143$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$(x0$143$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$144$2) => {
      $as_Lshapeless_HNil(x0$144$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$22 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (2097152 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$22
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$23$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((4194304 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$151$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$(x0$151$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$152$2) => {
      $as_Lshapeless_HNil(x0$152$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$23 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (4194304 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$23
}
function $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$24$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((8388608 & $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$159$2) => {
      $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$(x0$159$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$160$2) => {
      $as_Lshapeless_HNil(x0$160$2);
      return $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_project_generator_electricalboard_model_package$().Lreactbuild_project_generator_electricalboard_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$24 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = (8388608 | $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$24
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1() {
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$1 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$2 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$3 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$4 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$5 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$6 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$7 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$8 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$9 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$10 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$11 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$12 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$13 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$14 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$15 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$16 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$17 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$18 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$19 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$20 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$21 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$22 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$23 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$24 = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0 = 0
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$2)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$3)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$4)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$5)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((32 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$6)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$7)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$8__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((128 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$8)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$9__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((256 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$9)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$10__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((512 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$10)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$11__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((1024 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$11$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$11)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$12__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((2048 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$12)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4096 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$13$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$13)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$14__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((8192 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$14$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$14)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$15__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((16384 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$15$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$15)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$16__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((32768 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$16$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$16)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$17__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((65536 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$17$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$17)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$18__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((131072 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$18$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$18)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$19__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((262144 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$19$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$19)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$20__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((524288 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$20$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$20)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$21__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1048576 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$21$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$21)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$22__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((2097152 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$22$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$22)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$23__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((4194304 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$23$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$23)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.inst$macro$24__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((8388608 & this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_bitmap$0) === 0) ? $p_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__inst$macro$24$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1__f_inst$macro$24)
});
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$anon$lazy$macro$25$1", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Activity$() {
  this.Lreactbuild_task_TaskScheduler$Activity$__f_codecForActivity = null;
  $n_Lreactbuild_task_TaskScheduler$Activity$ = this;
  var inst$macro$28 = new $c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_task_TaskScheduler$Activity$__f_codecForActivity = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_task_TaskScheduler$Activity$.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Activity$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Activity$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Activity$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Activity$.prototype = $c_Lreactbuild_task_TaskScheduler$Activity$.prototype;
var $d_Lreactbuild_task_TaskScheduler$Activity$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Activity$: 0
}, false, "reactbuild.task.TaskScheduler$Activity$", {
  Lreactbuild_task_TaskScheduler$Activity$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$Activity$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Activity$;
var $n_Lreactbuild_task_TaskScheduler$Activity$;
function $m_Lreactbuild_task_TaskScheduler$Activity$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$Activity$)) {
    $n_Lreactbuild_task_TaskScheduler$Activity$ = new $c_Lreactbuild_task_TaskScheduler$Activity$()
  };
  return $n_Lreactbuild_task_TaskScheduler$Activity$
}
function $p_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "tpe"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "estimatedDuration"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "name")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_task_TaskScheduler$Activity(x0$7$2);
      if ((x0$7 !== null)) {
        var tpe$macro$23 = $n(x0$7).Lreactbuild_task_TaskScheduler$Activity__f_tpe;
        var estimatedDuration$macro$24 = $n(x0$7).Lreactbuild_task_TaskScheduler$Activity__f_estimatedDuration;
        var name$macro$25 = $n(x0$7).Lreactbuild_task_TaskScheduler$Activity__f_name;
        return new $c_Lshapeless_$colon$colon(tpe$macro$23, new $c_Lshapeless_$colon$colon(estimatedDuration$macro$24, new $c_Lshapeless_$colon$colon(name$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var tpe$macro$20 = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var estimatedDuration$macro$21 = $as_Ljava_time_Duration($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var name$macro$22 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_task_TaskScheduler$Activity(tpe$macro$20, estimatedDuration$macro$21, name$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "name"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "estimatedDuration"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "tpe"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "tpe"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "estimatedDuration"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "name")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "tpe"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "estimatedDuration"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "name"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_bitmap$0 = (((1 | $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_inst$macro$1
}
function $p_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_inst$macro$26 = new $c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6($thiz);
    $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_bitmap$0 = (((2 | $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3() {
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_inst$macro$1 = null;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_inst$macro$26 = null;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_bitmap$0 = 0
}
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3.prototype = $c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3.prototype;
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_inst$macro$1)
});
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3__f_inst$macro$26)
});
var $d_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3: 0
}, false, "reactbuild.task.TaskScheduler$Activity$anon$lazy$macro$27$3", {
  Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$ActivityTransition$() {
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$__f_codecForActivityTransition = null;
  $n_Lreactbuild_task_TaskScheduler$ActivityTransition$ = this;
  var inst$macro$28 = new $c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$__f_codecForActivityTransition = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$ActivityTransition$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$ActivityTransition$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$ActivityTransition$.prototype = $c_Lreactbuild_task_TaskScheduler$ActivityTransition$.prototype;
var $d_Lreactbuild_task_TaskScheduler$ActivityTransition$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$ActivityTransition$: 0
}, false, "reactbuild.task.TaskScheduler$ActivityTransition$", {
  Lreactbuild_task_TaskScheduler$ActivityTransition$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$ActivityTransition$;
var $n_Lreactbuild_task_TaskScheduler$ActivityTransition$;
function $m_Lreactbuild_task_TaskScheduler$ActivityTransition$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$ActivityTransition$)) {
    $n_Lreactbuild_task_TaskScheduler$ActivityTransition$ = new $c_Lreactbuild_task_TaskScheduler$ActivityTransition$()
  };
  return $n_Lreactbuild_task_TaskScheduler$ActivityTransition$
}
function $p_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "from"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "to"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "estimatedDuration")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_task_TaskScheduler$ActivityTransition(x0$7$2);
      if ((x0$7 !== null)) {
        var from$macro$23 = $n(x0$7).Lreactbuild_task_TaskScheduler$ActivityTransition__f_from;
        var to$macro$24 = $n(x0$7).Lreactbuild_task_TaskScheduler$ActivityTransition__f_to;
        var estimatedDuration$macro$25 = $n(x0$7).Lreactbuild_task_TaskScheduler$ActivityTransition__f_estimatedDuration;
        return new $c_Lshapeless_$colon$colon(from$macro$23, new $c_Lshapeless_$colon$colon(to$macro$24, new $c_Lshapeless_$colon$colon(estimatedDuration$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var from$macro$20 = $as_s_Option($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var to$macro$21 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var estimatedDuration$macro$22 = $as_Ljava_time_Duration($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_task_TaskScheduler$ActivityTransition(from$macro$20, to$macro$21, estimatedDuration$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "estimatedDuration"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "to"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "from"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "from"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "to"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "estimatedDuration")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "from"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "to"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "estimatedDuration"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_bitmap$0 = (((1 | $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_inst$macro$1
}
function $p_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_inst$macro$26 = new $c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5($thiz);
    $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_bitmap$0 = (((2 | $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2() {
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_inst$macro$1 = null;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_inst$macro$26 = null;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_bitmap$0 = 0
}
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2.prototype = $c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2.prototype;
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_inst$macro$1)
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2__f_inst$macro$26)
});
var $d_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2: 0
}, false, "reactbuild.task.TaskScheduler$ActivityTransition$anon$lazy$macro$27$2", {
  Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$() {
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$__f_codecForAllocatablePeriod = null;
  $n_Lreactbuild_task_TaskScheduler$AllocatablePeriod$ = this;
  var inst$macro$28 = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$__f_codecForAllocatablePeriod = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriod$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriod$.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$.prototype;
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriod$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriod$: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriod$", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriod$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriod$;
var $n_Lreactbuild_task_TaskScheduler$AllocatablePeriod$;
function $m_Lreactbuild_task_TaskScheduler$AllocatablePeriod$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$AllocatablePeriod$)) {
    $n_Lreactbuild_task_TaskScheduler$AllocatablePeriod$ = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$()
  };
  return $n_Lreactbuild_task_TaskScheduler$AllocatablePeriod$
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "tpe"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "start"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "end")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriod(x0$7$2);
      if ((x0$7 !== null)) {
        var tpe$macro$23 = $n(x0$7).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_tpe;
        var start$macro$24 = $n(x0$7).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_start;
        var end$macro$25 = $n(x0$7).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_end;
        return new $c_Lshapeless_$colon$colon(tpe$macro$23, new $c_Lshapeless_$colon$colon(start$macro$24, new $c_Lshapeless_$colon$colon(end$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var tpe$macro$20 = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var start$macro$21 = $as_Ljava_time_LocalTime($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var end$macro$22 = $as_Ljava_time_LocalTime($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod(tpe$macro$20, start$macro$21, end$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "end"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "start"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "tpe"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "tpe"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "start"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "end")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "tpe"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "start"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "end"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_inst$macro$1
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_inst$macro$26 = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4($thiz);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1() {
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_inst$macro$1 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_inst$macro$26 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_bitmap$0 = 0
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_inst$macro$1)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1__f_inst$macro$26)
});
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1;
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((1 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "Administrative"));
    var this$2 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "Craftwork"));
    var this$3 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "Dev"));
    var this$4 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "Draw")), $m_Lshapeless_HNil$()))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType(p$2);
      var $$x5 = $m_Lshapeless_Coproduct$();
      if ((p === $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$())) {
        var $$x4 = 0
      } else if ((p === $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$())) {
        var $$x4 = 1
      } else if ((p === $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$())) {
        var $$x4 = 2
      } else {
        if ((p !== $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$())) {
          throw new $c_s_MatchError(p)
        };
        var $$x4 = 3
      };
      return $as_Lshapeless_$colon$plus$colon($n($$x5).unsafeMkCoproduct__I__O__Lshapeless_Coproduct($$x4, p))
    }));
    var g = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lshapeless_$colon$plus$colon(x$1$2);
      return $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType($m_Lshapeless_Coproduct$().unsafeGet__Lshapeless_Coproduct__O(x$1))
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    $m_Lshapeless_ops_coproduct$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_coproduct$ZipWithKeys$().Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$8 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "Draw"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$11 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "Dev"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$14 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "Craftwork"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$17 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "Administrative"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zip = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$3);
    var this$20 = $m_s_$less$colon$less$();
    var ev = this$20.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$3(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$1, codec, config);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (1 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$1
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((2 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$2 = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1($thiz);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (2 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$2
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((4 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$(x0$7$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      $as_Lshapeless_HNil(x0$8$2);
      return $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$3 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (4 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$3
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder($thiz) {
  if (((8 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$4 = $m_Lio_circe_generic_extras_decoding_ReprDecoder$().Lio_circe_generic_extras_decoding_ReprDecoder$__f_hnilReprDecoder;
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (8 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$4
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((16 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$(x0$15$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      $as_Lshapeless_HNil(x0$16$2);
      return $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$5 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (16 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$5
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((32 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$23$2) => {
      $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(x0$23$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$24$2) => {
      $as_Lshapeless_HNil(x0$24$2);
      return $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$6 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (32 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$6
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder($thiz) {
  if (((64 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var $$x9 = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$();
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$31$2) => {
      $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$(x0$31$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$32$2) => {
      $as_Lshapeless_HNil(x0$32$2);
      return $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var $$x8 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder()));
    var $$x7 = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = $m_Lshapeless_HNil$();
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var labels$1 = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var $$x6 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var $$x5 = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var $$x4 = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var $$x3 = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$12 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$12);
    var $$x2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var $$x1 = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$16 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$16);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$7 = $n($$x9).decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder($$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1));
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (64 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$7
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((128 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$39$2) => {
      $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$(x0$39$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$40$2) => {
      $as_Lshapeless_HNil(x0$40$2);
      return $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$8 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (128 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$8
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($thiz) {
  if (((256 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$9 = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2($thiz);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (256 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$9
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((512 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$47$2) => {
      $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$(x0$47$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$48$2) => {
      $as_Lshapeless_HNil(x0$48$2);
      return $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$10 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (512 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$10
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$11$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((1024 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$55$2) => {
      $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(x0$55$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$56$2) => {
      $as_Lshapeless_HNil(x0$56$2);
      return $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$11 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (1024 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$11
}
function $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder($thiz) {
  if (((2048 & $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0)) {
    var labels = $m_Lshapeless_HNil$();
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$63$2) => {
      $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$(x0$63$2);
      return $m_Lshapeless_HNil$()
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$64$2) => {
      $as_Lshapeless_HNil(x0$64$2);
      return $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$()
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    var zip = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    var this$4 = $m_s_$less$colon$less$();
    var ev = this$4.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder()));
    var encode = new $c_Lshapeless_Lazy$$anon$1(t);
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var this$8 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$8);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf);
    var annotations = new $c_sjsr_AnonFunction0((() => $m_Lshapeless_HNil$()));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$12 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$12);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$12 = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config, keysToList, keys, fieldsToList, fields, encode, gen$1);
    $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = (2048 | $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$12
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1() {
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$1 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$2 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$3 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$4 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$5 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$6 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$7 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$8 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$9 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$10 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$11 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$12 = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0 = 0
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((1 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$1)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$2__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((2 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$2$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$2)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((4 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$3$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$3)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$4__Lio_circe_generic_extras_decoding_ReprDecoder = (function() {
  return (((8 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$4$lzycompute__Lio_circe_generic_extras_decoding_ReprDecoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$4)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((16 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$5$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$5)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((32 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$6$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$6)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function() {
  return (((64 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$7$lzycompute__Lio_circe_generic_extras_decoding_ConfiguredDecoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$7)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((128 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$8$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$8)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$9__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder = (function() {
  return (((256 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$9$lzycompute__Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$9)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$10__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((512 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$10$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$10)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$11__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((1024 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$11$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$11)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.inst$macro$12__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder = (function() {
  return (((2048 & this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_bitmap$0) === 0) ? $p_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__inst$macro$12$lzycompute__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(this) : this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1__f_inst$macro$12)
});
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Context$() {
  this.Lreactbuild_task_TaskScheduler$Context$__f_reuseContext = null;
  this.Lreactbuild_task_TaskScheduler$Context$__f_codecForContext = null;
  $n_Lreactbuild_task_TaskScheduler$Context$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_task_TaskScheduler$Context$__f_reuseContext = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var inst$macro$28 = new $c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$28));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_task_TaskScheduler$Context$__f_codecForContext = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_task_TaskScheduler$Context$.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Context$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Context$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Context$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Context$.prototype = $c_Lreactbuild_task_TaskScheduler$Context$.prototype;
var $d_Lreactbuild_task_TaskScheduler$Context$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Context$: 0
}, false, "reactbuild.task.TaskScheduler$Context$", {
  Lreactbuild_task_TaskScheduler$Context$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$Context$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Context$;
var $n_Lreactbuild_task_TaskScheduler$Context$;
function $m_Lreactbuild_task_TaskScheduler$Context$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$Context$)) {
    $n_Lreactbuild_task_TaskScheduler$Context$ = new $c_Lreactbuild_task_TaskScheduler$Context$()
  };
  return $n_Lreactbuild_task_TaskScheduler$Context$
}
function $p_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "dayTypes"));
    var this$2 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "tasks"));
    var this$3 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "transitions")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_task_TaskScheduler$Context(x0$7$2);
      if ((x0$7 !== null)) {
        var dayTypes$macro$23 = $n(x0$7).Lreactbuild_task_TaskScheduler$Context__f_dayTypes;
        var tasks$macro$24 = $n(x0$7).Lreactbuild_task_TaskScheduler$Context__f_tasks;
        var transitions$macro$25 = $n(x0$7).Lreactbuild_task_TaskScheduler$Context__f_transitions;
        return new $c_Lshapeless_$colon$colon(dayTypes$macro$23, new $c_Lshapeless_$colon$colon(tasks$macro$24, new $c_Lshapeless_$colon$colon(transitions$macro$25, $m_Lshapeless_HNil$())))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var dayTypes$macro$20 = $as_sci_List($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var tasks$macro$21 = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var transitions$macro$22 = $as_sci_List($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p4)) {
              return new $c_Lreactbuild_task_TaskScheduler$Context(dayTypes$macro$20, tasks$macro$21, transitions$macro$22)
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$7 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "transitions"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$10 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$10, "tasks"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$13 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "dayTypes"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    var this$16 = $m_s_$less$colon$less$();
    var ev = this$16.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$20 = $m_s_Symbol$();
    var $$x4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "dayTypes"));
    var this$21 = $m_s_Symbol$();
    var $$x3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "tasks"));
    var this$22 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x4, new $c_Lshapeless_$colon$colon($$x3, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "transitions")), $m_Lshapeless_HNil$())));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var tailHelper$2 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "dayTypes"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$3);
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "tasks"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$4);
    $m_Lshapeless_Witness$();
    var this$33 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "transitions"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$5);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var kt$2 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$2, kt$2);
    var this$39 = $m_s_$less$colon$less$();
    var ev$1 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$44);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$48 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$48);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$2, u$1, tttvs$1);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$())))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$52 = $m_s_$less$colon$less$();
    var ev$2 = this$52.s_$less$colon$less$__f_singleton;
    var this$53 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$53);
    var tttvs$2 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$3, ev$2);
    var u$2 = new $c_Lshapeless_Lub$$anon$4();
    var this$57 = $m_sci_List$();
    var cbf$4 = new $c_sc_IterableFactory$ToFactory(this$57);
    var tttvs$3 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$4, u$2, tttvs$2);
    var u$3 = new $c_Lshapeless_Lub$$anon$4();
    var this$61 = $m_sci_List$();
    var cbf$5 = new $c_sc_IterableFactory$ToFactory(this$61);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$5, u$3, tttvs$3);
    $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_bitmap$0 = (((1 | $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_inst$macro$1
}
function $p_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_inst$macro$26 = new $c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7($thiz);
    $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_bitmap$0 = (((2 | $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_inst$macro$26
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4() {
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_inst$macro$1 = null;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_inst$macro$26 = null;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_bitmap$0 = 0
}
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4.prototype = $c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4.prototype;
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_inst$macro$1)
});
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4.prototype.inst$macro$26__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__inst$macro$26$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4__f_inst$macro$26)
});
var $d_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4: 0
}, false, "reactbuild.task.TaskScheduler$Context$anon$lazy$macro$27$4", {
  Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$DayType$() {
  this.Lreactbuild_task_TaskScheduler$DayType$__f_codecForDayType = null;
  $n_Lreactbuild_task_TaskScheduler$DayType$ = this;
  var inst$macro$16 = new $c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1().inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
  var t = new $c_sjsr_AnonFunction0((() => inst$macro$16));
  var codec = new $c_Lshapeless_Lazy$$anon$1(t);
  this.Lreactbuild_task_TaskScheduler$DayType$__f_codecForDayType = $as_Lio_circe_Codec$AsObject(codec.value__O())
}
$c_Lreactbuild_task_TaskScheduler$DayType$.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$DayType$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$DayType$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$DayType$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$DayType$.prototype = $c_Lreactbuild_task_TaskScheduler$DayType$.prototype;
var $d_Lreactbuild_task_TaskScheduler$DayType$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$DayType$: 0
}, false, "reactbuild.task.TaskScheduler$DayType$", {
  Lreactbuild_task_TaskScheduler$DayType$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$DayType$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$DayType$;
var $n_Lreactbuild_task_TaskScheduler$DayType$;
function $m_Lreactbuild_task_TaskScheduler$DayType$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$DayType$)) {
    $n_Lreactbuild_task_TaskScheduler$DayType$ = new $c_Lreactbuild_task_TaskScheduler$DayType$()
  };
  return $n_Lreactbuild_task_TaskScheduler$DayType$
}
function $p_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec($thiz) {
  if (((((1 & $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $m_s_Symbol$();
    var $$x1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, "dow"));
    var this$2 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x1, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "periods")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_task_TaskScheduler$DayType(x0$7$2);
      return new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_task_TaskScheduler$DayType__f_dow, new $c_Lshapeless_$colon$colon($n(x0$7).Lreactbuild_task_TaskScheduler$DayType__f_periods, $m_Lshapeless_HNil$()))
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var dow$macro$11 = $as_sci_List($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var periods$macro$12 = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p3)) {
            return new $c_Lreactbuild_task_TaskScheduler$DayType(dow$macro$11, periods$macro$12)
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$6 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "periods"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$9 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "dow"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    var this$12 = $m_s_$less$colon$less$();
    var ev = this$12.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    var t = new $c_sjsr_AnonFunction0((() => $thiz.inst$macro$14__Lio_circe_generic_extras_codec_ReprAsObjectCodec()));
    var codec = new $c_Lshapeless_Lazy$$anon$1(t);
    var defaults = new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()));
    var default$1 = new $c_Lshapeless_Default$$anon$1(defaults);
    var this$16 = $m_s_Symbol$();
    var $$x2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "dow"));
    var this$17 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x2, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "periods")), $m_Lshapeless_HNil$()));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var tailHelper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$2();
    var tailHelper$1 = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper);
    var helper = new $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$1);
    var defaults$1 = new $c_Lshapeless_Default$AsRecord$$anon$5(helper, default$1);
    var defaultMapper = $m_Lio_circe_generic_extras_util_RecordToMap$().Lio_circe_generic_extras_util_RecordToMap$__f_hnilRecordToMap;
    var config = $m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_config;
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "dow"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$2);
    $m_Lshapeless_Witness$();
    var this$25 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "periods"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$3);
    var kt = new $c_Lshapeless_ops_record_Keys$$anon$28();
    var kt$1 = new $c_Lshapeless_ops_record_Keys$$anon$29(wk, kt);
    var fields = new $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1);
    var this$30 = $m_s_$less$colon$less$();
    var ev$1 = this$30.s_$less$colon$less$__f_singleton;
    var this$31 = $m_sci_List$();
    var cbf = new $c_sc_IterableFactory$ToFactory(this$31);
    var tttvs = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf, ev$1);
    var u = new $c_Lshapeless_Lub$$anon$4();
    var this$35 = $m_sci_List$();
    var cbf$1 = new $c_sc_IterableFactory$ToFactory(this$35);
    var fieldsToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$1, u, tttvs);
    var annotations = new $c_sjsr_AnonFunction0((() => new $c_Lshapeless_$colon$colon($m_s_None$(), new $c_Lshapeless_$colon$colon($m_s_None$(), $m_Lshapeless_HNil$()))));
    var keys = new $c_Lshapeless_Annotations$$anon$2(annotations);
    var this$39 = $m_s_$less$colon$less$();
    var ev$2 = this$39.s_$less$colon$less$__f_singleton;
    var this$40 = $m_sci_List$();
    var cbf$2 = new $c_sc_IterableFactory$ToFactory(this$40);
    var tttvs$1 = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$2);
    var u$1 = new $c_Lshapeless_Lub$$anon$4();
    var this$44 = $m_sci_List$();
    var cbf$3 = new $c_sc_IterableFactory$ToFactory(this$44);
    var keysToList = new $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$1, tttvs$1);
    $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_inst$macro$1 = new $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec, defaults$1, defaultMapper, config, fields, fieldsToList, keys, keysToList);
    $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_bitmap$0 = (((1 | $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_inst$macro$1
}
function $p_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__inst$macro$14$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec($thiz) {
  if (((((2 & $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_inst$macro$14 = new $c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3($thiz);
    $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_bitmap$0 = (((2 | $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_inst$macro$14
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1() {
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_inst$macro$1 = null;
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_inst$macro$14 = null;
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_bitmap$0 = 0
}
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1.prototype = $c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1.prototype;
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1.prototype.inst$macro$1__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec = (function() {
  return (((((1 & this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__inst$macro$1$lzycompute__Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_inst$macro$1)
});
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1.prototype.inst$macro$14__Lio_circe_generic_extras_codec_ReprAsObjectCodec = (function() {
  return (((((2 & this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__inst$macro$14$lzycompute__Lio_circe_generic_extras_codec_ReprAsObjectCodec(this) : this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1__f_inst$macro$14)
});
var $d_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1: 0
}, false, "reactbuild.task.TaskScheduler$DayType$anon$lazy$macro$15$1", {
  Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1;
/** @constructor */
function $c_s_$less$colon$less$() {
  this.s_$less$colon$less$__f_singleton = null;
  $n_s_$less$colon$less$ = this;
  this.s_$less$colon$less$__f_singleton = new $c_s_$less$colon$less$$anon$1()
}
$c_s_$less$colon$less$.prototype = new $h_O();
$c_s_$less$colon$less$.prototype.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
  /*<skip>*/
}
$h_s_$less$colon$less$.prototype = $c_s_$less$colon$less$.prototype;
var $d_s_$less$colon$less$ = new $TypeData().initClass({
  s_$less$colon$less$: 0
}, false, "scala.$less$colon$less$", {
  s_$less$colon$less$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_$less$colon$less$.prototype.$classData = $d_s_$less$colon$less$;
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$()
  };
  return $n_s_$less$colon$less$
}
function $p_s_Array$__slowcopy__O__I__O__I__I__V($thiz, src, srcPos, dest, destPos, length) {
  var i = srcPos;
  var j = destPos;
  var srcUntil = ((srcPos + length) | 0);
  while ((i < srcUntil)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(src, i));
    i = ((1 + i) | 0);
    j = ((1 + j) | 0)
  }
}
function $p_s_Array$__newUnitArray__I__Ajl_Void($thiz, len) {
  var result = new ($d_jl_Void.getArrayOf().constr)(len);
  $m_ju_Arrays$().fill__AO__O__V(result, (void 0));
  return result
}
/** @constructor */
function $c_s_Array$() {
  /*<skip>*/
}
$c_s_Array$.prototype = new $h_O();
$c_s_Array$.prototype.constructor = $c_s_Array$;
/** @constructor */
function $h_s_Array$() {
  /*<skip>*/
}
$h_s_Array$.prototype = $c_s_Array$.prototype;
$c_s_Array$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__O = (function(it, evidence$3) {
  var n = $n(it).knownSize__I();
  if ((n > (-1))) {
    var elements = $n(evidence$3).newArray__I__O(n);
    var iterator = $n(it).iterator__sc_Iterator();
    var i = 0;
    while ((i < n)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(elements, i, $n(iterator).next__O());
      i = ((1 + i) | 0)
    };
    return elements
  } else {
    var capacity = 0;
    var jsElems = null;
    var elementClass = $n(evidence$3).runtimeClass__jl_Class();
    capacity = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var iterator$2 = $n(it).iterator__sc_Iterator();
    while ($n(iterator$2).hasNext__Z()) {
      var elem = $n(iterator$2).next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(elementClass).jl_Class__f_data.zero : elem));
      jsElems.push(unboxedElem)
    };
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return $n(elemRuntimeClass).jl_Class__f_data.getArrayOf().wrapArray(jsElems)
  }
});
$c_s_Array$.prototype.copy__O__I__O__I__I__V = (function(src, srcPos, dest, destPos, length) {
  var this$1 = $n(src);
  var srcClass = $objectGetClass(this$1);
  if ($n(srcClass).isArray__Z()) {
    var this$2 = $n(dest);
    var $$x1 = $n($objectGetClass(this$2)).isAssignableFrom__jl_Class__Z(srcClass)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $systemArraycopyFull($n(src), srcPos, $n(dest), destPos, length)
  } else {
    $p_s_Array$__slowcopy__O__I__O__I__I__V(this, src, srcPos, dest, destPos, length)
  }
});
$c_s_Array$.prototype.copyOf__O__I__O = (function(original, newLength) {
  if ($isArrayOf_jl_Void(original, 1)) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength)
  } else if ((original instanceof $ac_O)) {
    var x3 = $asArrayOf_O(original, 1);
    return $m_ju_Arrays$().copyOf__AO__I__AO(x3, newLength)
  } else if ((original instanceof $ac_I)) {
    var x4 = $asArrayOf_I(original, 1);
    return $m_ju_Arrays$().copyOf__AI__I__AI(x4, newLength)
  } else if ((original instanceof $ac_D)) {
    var x5 = $asArrayOf_D(original, 1);
    return $m_ju_Arrays$().copyOf__AD__I__AD(x5, newLength)
  } else if ((original instanceof $ac_J)) {
    var x6 = $asArrayOf_J(original, 1);
    return $m_ju_Arrays$().copyOf__AJ__I__AJ(x6, newLength)
  } else if ((original instanceof $ac_F)) {
    var x7 = $asArrayOf_F(original, 1);
    return $m_ju_Arrays$().copyOf__AF__I__AF(x7, newLength)
  } else if ((original instanceof $ac_C)) {
    var x8 = $asArrayOf_C(original, 1);
    return $m_ju_Arrays$().copyOf__AC__I__AC(x8, newLength)
  } else if ((original instanceof $ac_B)) {
    var x9 = $asArrayOf_B(original, 1);
    return $m_ju_Arrays$().copyOf__AB__I__AB(x9, newLength)
  } else if ((original instanceof $ac_S)) {
    var x10 = $asArrayOf_S(original, 1);
    return $m_ju_Arrays$().copyOf__AS__I__AS(x10, newLength)
  } else if ((original instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(original, 1);
    return $m_ju_Arrays$().copyOf__AZ__I__AZ(x11, newLength)
  } else {
    throw new $c_s_MatchError(original)
  }
});
$c_s_Array$.prototype.copyAs__O__I__s_reflect_ClassTag__O = (function(original, newLength, ct) {
  var runtimeClass = $n(ct).runtimeClass__jl_Class();
  if ((runtimeClass !== null)) {
    var this$1 = $n(runtimeClass);
    var $$x1 = (this$1 === $d_V.getClassOf())
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength)
  } else {
    var this$2 = $n(original);
    if ($n(runtimeClass).isAssignableFrom__jl_Class__Z($n($objectGetClass(this$2)).getComponentType__jl_Class())) {
      if ($n(runtimeClass).isPrimitive__Z()) {
        return this.copyOf__O__I__O(original, newLength)
      } else {
        var this$3 = $n($m_jl_reflect_Array$().newInstance__jl_Class__I__O(runtimeClass, 0));
        var destArrayClass = $objectGetClass(this$3);
        var original$1 = $asArrayOf_O(original, 1);
        return $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, destArrayClass)
      }
    } else {
      var dest = $n(ct).newArray__I__O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(original));
      return dest
    }
  }
});
$c_s_Array$.prototype.equals__AO__AO__Z = (function(xs, ys) {
  if ((xs === ys)) {
    return true
  };
  if (($n(xs).u.length !== $n(ys).u.length)) {
    return false
  };
  var len = $n(xs).u.length;
  var i = 0;
  while ((i < len)) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($n(xs).get(i), $n(ys).get(i)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
var $d_s_Array$ = new $TypeData().initClass({
  s_Array$: 0
}, false, "scala.Array$", {
  s_Array$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Array$.prototype.$classData = $d_s_Array$;
var $n_s_Array$;
function $m_s_Array$() {
  if ((!$n_s_Array$)) {
    $n_s_Array$ = new $c_s_Array$()
  };
  return $n_s_Array$
}
/** @constructor */
function $c_s_Console$() {
  this.s_Console$__f_outVar = null;
  this.s_Console$__f_errVar = null;
  $n_s_Console$ = this;
  this.s_Console$__f_outVar = new $c_s_util_DynamicVariable($m_jl_System$Streams$().jl_System$Streams$__f_out);
  this.s_Console$__f_errVar = new $c_s_util_DynamicVariable($m_jl_System$Streams$().jl_System$Streams$__f_err);
  new $c_s_util_DynamicVariable(null)
}
$c_s_Console$.prototype = new $h_O();
$c_s_Console$.prototype.constructor = $c_s_Console$;
/** @constructor */
function $h_s_Console$() {
  /*<skip>*/
}
$h_s_Console$.prototype = $c_s_Console$.prototype;
$c_s_Console$.prototype.out__Ljava_io_PrintStream = (function() {
  return $as_Ljava_io_PrintStream($n(this.s_Console$__f_outVar).s_util_DynamicVariable__f_v)
});
$c_s_Console$.prototype.err__Ljava_io_PrintStream = (function() {
  return $as_Ljava_io_PrintStream($n(this.s_Console$__f_errVar).s_util_DynamicVariable__f_v)
});
var $d_s_Console$ = new $TypeData().initClass({
  s_Console$: 0
}, false, "scala.Console$", {
  s_Console$: 1,
  O: 1,
  s_io_AnsiColor: 1
});
$c_s_Console$.prototype.$classData = $d_s_Console$;
var $n_s_Console$;
function $m_s_Console$() {
  if ((!$n_s_Console$)) {
    $n_s_Console$ = new $c_s_Console$()
  };
  return $n_s_Console$
}
/** @constructor */
function $c_s_LowPriorityImplicits() {
  /*<skip>*/
}
$c_s_LowPriorityImplicits.prototype = new $h_s_LowPriorityImplicits2();
$c_s_LowPriorityImplicits.prototype.constructor = $c_s_LowPriorityImplicits;
/** @constructor */
function $h_s_LowPriorityImplicits() {
  /*<skip>*/
}
$h_s_LowPriorityImplicits.prototype = $c_s_LowPriorityImplicits.prototype;
$c_s_LowPriorityImplicits.prototype.genericWrapArray__O__scm_ArraySeq = (function(xs) {
  return ((xs === null) ? null : $m_scm_ArraySeq$().make__O__scm_ArraySeq(xs))
});
$c_s_LowPriorityImplicits.prototype.wrapRefArray__AO__scm_ArraySeq$ofRef = (function(xs) {
  if ((xs === null)) {
    return null
  } else if (($n(xs).u.length === 0)) {
    var this$3 = $m_scm_ArraySeq$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    return this$3.scm_ArraySeq$__f_EmptyArraySeq
  } else {
    return new $c_scm_ArraySeq$ofRef(xs)
  }
});
$c_s_LowPriorityImplicits.prototype.wrapDoubleArray__AD__scm_ArraySeq$ofDouble = (function(xs) {
  return ((xs !== null) ? new $c_scm_ArraySeq$ofDouble(xs) : null)
});
$c_s_LowPriorityImplicits.prototype.wrapString__T__sci_WrappedString = (function(s) {
  return ((s !== null) ? new $c_sci_WrappedString(s) : null)
});
/** @constructor */
function $c_s_Option$() {
  /*<skip>*/
}
$c_s_Option$.prototype = new $h_O();
$c_s_Option$.prototype.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
  /*<skip>*/
}
$h_s_Option$.prototype = $c_s_Option$.prototype;
$c_s_Option$.prototype.option2Iterable__s_Option__sc_Iterable = (function(xo) {
  if ($n(xo).isEmpty__Z()) {
    return $as_sc_Iterable($n($m_s_package$().s_package$__f_Iterable).empty__O())
  } else {
    $n($m_s_package$().s_package$__f_Iterable);
    var a = $n(xo).get__O();
    return new $c_sc_Iterable$$anon$1(a)
  }
});
$c_s_Option$.prototype.apply__O__s_Option = (function(x) {
  return ((x === null) ? $m_s_None$() : new $c_s_Some(x))
});
$c_s_Option$.prototype.when__Z__F0__s_Option = (function(cond, a) {
  return (cond ? new $c_s_Some($n(a).apply__O()) : $m_s_None$())
});
var $d_s_Option$ = new $TypeData().initClass({
  s_Option$: 0
}, false, "scala.Option$", {
  s_Option$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Option$.prototype.$classData = $d_s_Option$;
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$()
  };
  return $n_s_Option$
}
function $f_s_PartialFunction__andThen__F1__s_PartialFunction($thiz, k) {
  if ($is_s_PartialFunction(k)) {
    var x2 = $as_s_PartialFunction(k);
    return new $c_s_PartialFunction$Combined($thiz, x2)
  } else {
    return new $c_s_PartialFunction$AndThen($thiz, k)
  }
}
function $f_s_PartialFunction__applyOrElse__O__F1__O($thiz, x, default$1) {
  return ($thiz.isDefinedAt__O__Z(x) ? $thiz.apply__O__O(x) : $n(default$1).apply__O__O(x))
}
function $f_s_PartialFunction__runWith__F1__F1($thiz, action) {
  return new $c_sjsr_AnonFunction1(((x$2) => {
    var z = $thiz.applyOrElse__O__F1__O(x$2, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
    return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) && ($n(action).apply__O__O(z), true))
  }))
}
function $is_s_PartialFunction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_PartialFunction)))
}
function $as_s_PartialFunction(obj) {
  return (($is_s_PartialFunction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.PartialFunction"))
}
function $isArrayOf_s_PartialFunction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_PartialFunction)))
}
function $asArrayOf_s_PartialFunction(obj, depth) {
  return (($isArrayOf_s_PartialFunction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.PartialFunction;", depth))
}
function $is_s_Product(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_Product)))
}
function $as_s_Product(obj) {
  return (($is_s_Product(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Product"))
}
function $isArrayOf_s_Product(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Product)))
}
function $asArrayOf_s_Product(obj, depth) {
  return (($isArrayOf_s_Product(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Product;", depth))
}
var $d_s_Product = new $TypeData().initClass({
  s_Product: 0
}, true, "scala.Product", {
  s_Product: 1,
  O: 1,
  s_Equals: 1
});
/** @constructor */
function $c_s_Symbol(name) {
  this.s_Symbol__f_name = null;
  this.s_Symbol__f_name = name
}
$c_s_Symbol.prototype = new $h_O();
$c_s_Symbol.prototype.constructor = $c_s_Symbol;
/** @constructor */
function $h_s_Symbol() {
  /*<skip>*/
}
$h_s_Symbol.prototype = $c_s_Symbol.prototype;
$c_s_Symbol.prototype.toString__T = (function() {
  return (("Symbol(" + this.s_Symbol__f_name) + ")")
});
$c_s_Symbol.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I($n(this.s_Symbol__f_name))
});
$c_s_Symbol.prototype.equals__O__Z = (function(other) {
  return (this === other)
});
function $as_s_Symbol(obj) {
  return (((obj instanceof $c_s_Symbol) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Symbol"))
}
function $isArrayOf_s_Symbol(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Symbol)))
}
function $asArrayOf_s_Symbol(obj, depth) {
  return (($isArrayOf_s_Symbol(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Symbol;", depth))
}
var $d_s_Symbol = new $TypeData().initClass({
  s_Symbol: 0
}, false, "scala.Symbol", {
  s_Symbol: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Symbol.prototype.$classData = $d_s_Symbol;
/** @constructor */
function $c_sc_BuildFrom$$anon$5() {
  /*<skip>*/
}
$c_sc_BuildFrom$$anon$5.prototype = new $h_O();
$c_sc_BuildFrom$$anon$5.prototype.constructor = $c_sc_BuildFrom$$anon$5;
/** @constructor */
function $h_sc_BuildFrom$$anon$5() {
  /*<skip>*/
}
$h_sc_BuildFrom$$anon$5.prototype = $c_sc_BuildFrom$$anon$5.prototype;
$c_sc_BuildFrom$$anon$5.prototype.newBuilder__O__scm_Builder = (function(from) {
  $as_T(from);
  return $n($m_sc_Factory$().sc_Factory$__f_stringFactory).newBuilder__scm_Builder()
});
$c_sc_BuildFrom$$anon$5.prototype.fromSpecific__O__sc_IterableOnce__O = (function(from, it) {
  $as_T(from);
  return $as_T($n($m_sc_Factory$().sc_Factory$__f_stringFactory).fromSpecific__sc_IterableOnce__O(it))
});
var $d_sc_BuildFrom$$anon$5 = new $TypeData().initClass({
  sc_BuildFrom$$anon$5: 0
}, false, "scala.collection.BuildFrom$$anon$5", {
  sc_BuildFrom$$anon$5: 1,
  O: 1,
  sc_BuildFrom: 1
});
$c_sc_BuildFrom$$anon$5.prototype.$classData = $d_sc_BuildFrom$$anon$5;
/** @constructor */
function $c_sc_BuildFrom$$anon$6() {
  /*<skip>*/
}
$c_sc_BuildFrom$$anon$6.prototype = new $h_O();
$c_sc_BuildFrom$$anon$6.prototype.constructor = $c_sc_BuildFrom$$anon$6;
/** @constructor */
function $h_sc_BuildFrom$$anon$6() {
  /*<skip>*/
}
$h_sc_BuildFrom$$anon$6.prototype = $c_sc_BuildFrom$$anon$6.prototype;
$c_sc_BuildFrom$$anon$6.prototype.newBuilder__O__scm_Builder = (function(from) {
  $as_sci_WrappedString(from);
  return $m_sci_WrappedString$().newBuilder__scm_Builder()
});
$c_sc_BuildFrom$$anon$6.prototype.fromSpecific__O__sc_IterableOnce__O = (function(from, it) {
  $as_sci_WrappedString(from);
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(it)
});
var $d_sc_BuildFrom$$anon$6 = new $TypeData().initClass({
  sc_BuildFrom$$anon$6: 0
}, false, "scala.collection.BuildFrom$$anon$6", {
  sc_BuildFrom$$anon$6: 1,
  O: 1,
  sc_BuildFrom: 1
});
$c_sc_BuildFrom$$anon$6.prototype.$classData = $d_sc_BuildFrom$$anon$6;
/** @constructor */
function $c_sc_BuildFromLowPriority2$$anon$11(outer) {
  /*<skip>*/
}
$c_sc_BuildFromLowPriority2$$anon$11.prototype = new $h_O();
$c_sc_BuildFromLowPriority2$$anon$11.prototype.constructor = $c_sc_BuildFromLowPriority2$$anon$11;
/** @constructor */
function $h_sc_BuildFromLowPriority2$$anon$11() {
  /*<skip>*/
}
$h_sc_BuildFromLowPriority2$$anon$11.prototype = $c_sc_BuildFromLowPriority2$$anon$11.prototype;
$c_sc_BuildFromLowPriority2$$anon$11.prototype.fromSpecific__O__sc_IterableOnce__O = (function(from, it) {
  var from$1 = $as_sc_Iterable(from);
  return $as_sc_Iterable($n($n(from$1).iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(it))
});
$c_sc_BuildFromLowPriority2$$anon$11.prototype.newBuilder__O__scm_Builder = (function(from) {
  var from$1 = $as_sc_Iterable(from);
  return $n($n(from$1).iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder()
});
var $d_sc_BuildFromLowPriority2$$anon$11 = new $TypeData().initClass({
  sc_BuildFromLowPriority2$$anon$11: 0
}, false, "scala.collection.BuildFromLowPriority2$$anon$11", {
  sc_BuildFromLowPriority2$$anon$11: 1,
  O: 1,
  sc_BuildFrom: 1
});
$c_sc_BuildFromLowPriority2$$anon$11.prototype.$classData = $d_sc_BuildFromLowPriority2$$anon$11;
/** @constructor */
function $c_sc_WithFilter() {
  /*<skip>*/
}
$c_sc_WithFilter.prototype = new $h_O();
$c_sc_WithFilter.prototype.constructor = $c_sc_WithFilter;
/** @constructor */
function $h_sc_WithFilter() {
  /*<skip>*/
}
$h_sc_WithFilter.prototype = $c_sc_WithFilter.prototype;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$() {
  this.sc_convert_JavaCollectionWrappers$__f_scala$collection$convert$JavaCollectionWrappers$$PutNull = null;
  $n_sc_convert_JavaCollectionWrappers$ = this;
  this.sc_convert_JavaCollectionWrappers$__f_scala$collection$convert$JavaCollectionWrappers$$PutNull = new $c_sc_convert_JavaCollectionWrappers$$anon$7()
}
$c_sc_convert_JavaCollectionWrappers$.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$.prototype = $c_sc_convert_JavaCollectionWrappers$.prototype;
var $d_sc_convert_JavaCollectionWrappers$ = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$", {
  sc_convert_JavaCollectionWrappers$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sc_convert_JavaCollectionWrappers$.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$;
var $n_sc_convert_JavaCollectionWrappers$;
function $m_sc_convert_JavaCollectionWrappers$() {
  if ((!$n_sc_convert_JavaCollectionWrappers$)) {
    $n_sc_convert_JavaCollectionWrappers$ = new $c_sc_convert_JavaCollectionWrappers$()
  };
  return $n_sc_convert_JavaCollectionWrappers$
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1(f) {
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1__f_f = null;
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1__f_f = f
}
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1.prototype = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1.prototype;
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1.prototype.apply__O__O = (function(x$1) {
  return (0, this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1__f_f)(x$1)
});
var $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JMapWrapperLike$$Lambda$1", {
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1: 1,
  O: 1,
  ju_function_Function: 1
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3(f) {
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3__f_f = null;
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3__f_f = f
}
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3.prototype = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3.prototype;
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3.prototype.apply__O__O__O = (function(x$1, x$2) {
  return (0, this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3__f_f)(x$1, x$2)
});
var $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JMapWrapperLike$$Lambda$3", {
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3: 1,
  O: 1,
  ju_function_BiFunction: 1
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4(f) {
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4__f_f = null;
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4__f_f = f
}
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4.prototype = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4.prototype;
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4.prototype.apply__O__O__O = (function(x$1, x$2) {
  return (0, this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4__f_f)(x$1, x$2)
});
var $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JMapWrapperLike$$Lambda$4", {
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4: 1,
  O: 1,
  ju_function_BiFunction: 1
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3(outer) {
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_ui = null;
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_prev = null;
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_$outer = outer
  };
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_ui = $n($n($n(outer).sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2__f_$outer).sc_convert_JavaCollectionWrappers$MapWrapper__f_scala$collection$convert$JavaCollectionWrappers$MapWrapper$$underlying).iterator__sc_Iterator();
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_prev = $m_s_None$()
}
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3.prototype = $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3.prototype;
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3.prototype.hasNext__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_ui).hasNext__Z()
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3.prototype.next__ju_Map$Entry = (function() {
  var x1 = $as_T2($n(this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_ui).next__O());
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var k = $n(x1)._1__O();
  var v = $n(x1)._2__O();
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_prev = new $c_s_Some(k);
  return new $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4(this, k, v)
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3.prototype.remove__V = (function() {
  var x1 = this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_prev;
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var k = $n(x2).s_Some__f_value;
    var x1$2 = $n($n(this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_$outer).sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2__f_$outer).sc_convert_JavaCollectionWrappers$MapWrapper__f_scala$collection$convert$JavaCollectionWrappers$MapWrapper$$underlying;
    if ($is_scm_Map(x1$2)) {
      var x2$2 = $as_scm_Map(x1$2);
      var this$1 = $n(x2$2);
      this$1.subtractOne__O__scm_Shrinkable(k);
      this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3__f_prev = $m_s_None$()
    } else {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "remove")
    }
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove")
  }
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3.prototype.next__O = (function() {
  return this.next__ju_Map$Entry()
});
var $d_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3", {
  sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3: 1,
  O: 1,
  ju_Iterator: 1
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4(outer, k$1, v$1) {
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_k$1 = null;
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_v$1 = null;
  if ((outer === null)) {
    $n(null)
  };
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_k$1 = k$1;
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_v$1 = v$1
}
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4.prototype = $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4.prototype;
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4.prototype.getKey__O = (function() {
  return this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_k$1
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4.prototype.getValue__O = (function() {
  return this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_v$1
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4.prototype.hashCode__I = (function() {
  return (((this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_k$1 === null) ? 0 : $dp_hashCode__I($n(this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_k$1))) ^ ((this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_v$1 === null) ? 0 : $dp_hashCode__I($n(this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_v$1))))
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4.prototype.equals__O__Z = (function(other) {
  if ($is_ju_Map$Entry(other)) {
    var x2 = $as_ju_Map$Entry(other);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_k$1, $n(x2).getKey__O()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4__f_v$1, $n(x2).getValue__O()))
  } else {
    return false
  }
});
var $d_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4", {
  sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3$$anon$4;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1(outer) {
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer = outer
  };
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui = $n($n(outer).sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying).iterator__sc_Iterator();
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = $m_s_None$()
}
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype;
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.hasNext__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui).hasNext__Z()
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.next__O = (function() {
  var e = $n(this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui).next__O();
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = new $c_s_Some(e);
  return e
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.remove__V = (function() {
  var x1 = this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev;
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var e = $n(x2).s_Some__f_value;
    var x1$2 = $n(this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer).sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying;
    if ($is_scm_Set(x1$2)) {
      var x2$2 = $as_scm_Set(x1$2);
      $n(x2$2).remove__O__Z(e);
      this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = $m_s_None$()
    } else {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "remove")
    }
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove")
  }
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$SetWrapper$$anon$1", {
  sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1: 1,
  O: 1,
  ju_Iterator: 1
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1;
function $is_sci_LazyList$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_LazyList$State)))
}
function $as_sci_LazyList$State(obj) {
  return (($is_sci_LazyList$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList$State"))
}
function $isArrayOf_sci_LazyList$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList$State)))
}
function $asArrayOf_sci_LazyList$State(obj, depth) {
  return (($isArrayOf_sci_LazyList$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList$State;", depth))
}
/** @constructor */
function $c_sci_List$$anon$1() {
  /*<skip>*/
}
$c_sci_List$$anon$1.prototype = new $h_O();
$c_sci_List$$anon$1.prototype.constructor = $c_sci_List$$anon$1;
/** @constructor */
function $h_sci_List$$anon$1() {
  /*<skip>*/
}
$h_sci_List$$anon$1.prototype = $c_sci_List$$anon$1.prototype;
$c_sci_List$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this)
});
$c_sci_List$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sci_List$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sci_List$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sci_List$$anon$1.prototype.apply__O__O = (function(x) {
  return this
});
var $d_sci_List$$anon$1 = new $TypeData().initClass({
  sci_List$$anon$1: 0
}, false, "scala.collection.immutable.List$$anon$1", {
  sci_List$$anon$1: 1,
  O: 1,
  F1: 1
});
$c_sci_List$$anon$1.prototype.$classData = $d_sci_List$$anon$1;
/** @constructor */
function $c_sci_MapNode() {
  /*<skip>*/
}
$c_sci_MapNode.prototype = new $h_sci_Node();
$c_sci_MapNode.prototype.constructor = $c_sci_MapNode;
/** @constructor */
function $h_sci_MapNode() {
  /*<skip>*/
}
$h_sci_MapNode.prototype = $c_sci_MapNode.prototype;
function $as_sci_MapNode(obj) {
  return (((obj instanceof $c_sci_MapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapNode"))
}
function $isArrayOf_sci_MapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapNode)))
}
function $asArrayOf_sci_MapNode(obj, depth) {
  return (($isArrayOf_sci_MapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapNode;", depth))
}
function $p_sci_Range$__description__I__I__I__Z__T($thiz, start, end, step, isInclusive) {
  return ((((start + (isInclusive ? " to " : " until ")) + end) + " by ") + step)
}
/** @constructor */
function $c_sci_Range$() {
  /*<skip>*/
}
$c_sci_Range$.prototype = new $h_O();
$c_sci_Range$.prototype.constructor = $c_sci_Range$;
/** @constructor */
function $h_sci_Range$() {
  /*<skip>*/
}
$h_sci_Range$.prototype = $c_sci_Range$.prototype;
$c_sci_Range$.prototype.scala$collection$immutable$Range$$fail__I__I__I__Z__E = (function(start, end, step, isInclusive) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ($p_sci_Range$__description__I__I__I__Z__T(this, start, end, step, isInclusive) + ": seqs cannot contain more than Int.MaxValue elements."))
});
$c_sci_Range$.prototype.scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable = (function(what) {
  return $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), (what + " on empty Range"))
});
var $d_sci_Range$ = new $TypeData().initClass({
  sci_Range$: 0
}, false, "scala.collection.immutable.Range$", {
  sci_Range$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Range$.prototype.$classData = $d_sci_Range$;
var $n_sci_Range$;
function $m_sci_Range$() {
  if ((!$n_sci_Range$)) {
    $n_sci_Range$ = new $c_sci_Range$()
  };
  return $n_sci_Range$
}
/** @constructor */
function $c_sci_RedBlackTree$MapHelper() {
  this.sci_RedBlackTree$Helper__f_ordering = null
}
$c_sci_RedBlackTree$MapHelper.prototype = new $h_sci_RedBlackTree$Helper();
$c_sci_RedBlackTree$MapHelper.prototype.constructor = $c_sci_RedBlackTree$MapHelper;
/** @constructor */
function $h_sci_RedBlackTree$MapHelper() {
  /*<skip>*/
}
$h_sci_RedBlackTree$MapHelper.prototype = $c_sci_RedBlackTree$MapHelper.prototype;
$c_sci_RedBlackTree$MapHelper.prototype.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree = (function(tree, k, v) {
  if ((tree === null)) {
    $m_sci_RedBlackTree$();
    return new $c_sci_RedBlackTree$Tree(k, v, null, null, 0)
  } else {
    var this$2 = $n(tree);
    if (Object.is(k, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
      return $n(tree).mutableWithV__O__sci_RedBlackTree$Tree(v)
    } else {
      var $$x1 = $n(this.sci_RedBlackTree$Helper__f_ordering);
      var this$3 = $n(tree);
      var cmp = $n($$x1).compare__O__O__I(k, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$4 = $n(tree);
        return this.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, v))
      } else if ((cmp > 0)) {
        var this$5 = $n(tree);
        return this.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v))
      } else {
        return $n(tree).mutableWithV__O__sci_RedBlackTree$Tree(v)
      }
    }
  }
});
/** @constructor */
function $c_sci_RedBlackTree$SetHelper() {
  this.sci_RedBlackTree$Helper__f_ordering = null
}
$c_sci_RedBlackTree$SetHelper.prototype = new $h_sci_RedBlackTree$Helper();
$c_sci_RedBlackTree$SetHelper.prototype.constructor = $c_sci_RedBlackTree$SetHelper;
/** @constructor */
function $h_sci_RedBlackTree$SetHelper() {
  /*<skip>*/
}
$h_sci_RedBlackTree$SetHelper.prototype = $c_sci_RedBlackTree$SetHelper.prototype;
$c_sci_RedBlackTree$SetHelper.prototype.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree = (function(tree, k) {
  if ((tree === null)) {
    $m_sci_RedBlackTree$();
    return new $c_sci_RedBlackTree$Tree(k, (void 0), null, null, 0)
  } else {
    var this$2 = $n(tree);
    if (Object.is(k, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
      return tree
    } else {
      var $$x1 = $n(this.sci_RedBlackTree$Helper__f_ordering);
      var this$3 = $n(tree);
      var cmp = $n($$x1).compare__O__O__I(k, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$4 = $n(tree);
        return this.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k))
      } else if ((cmp > 0)) {
        var this$5 = $n(tree);
        return this.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k))
      } else {
        return tree
      }
    }
  }
});
/** @constructor */
function $c_sci_SetNode() {
  /*<skip>*/
}
$c_sci_SetNode.prototype = new $h_sci_Node();
$c_sci_SetNode.prototype.constructor = $c_sci_SetNode;
/** @constructor */
function $h_sci_SetNode() {
  /*<skip>*/
}
$h_sci_SetNode.prototype = $c_sci_SetNode.prototype;
function $as_sci_SetNode(obj) {
  return (((obj instanceof $c_sci_SetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetNode"))
}
function $isArrayOf_sci_SetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetNode)))
}
function $asArrayOf_sci_SetNode(obj, depth) {
  return (($isArrayOf_sci_SetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetNode;", depth))
}
function $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($thiz, xs) {
  if ((xs === $thiz)) {
    $thiz.addAll__sc_IterableOnce__scm_Growable($m_scm_Buffer$().from__sc_IterableOnce__sc_SeqOps(xs))
  } else {
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      $thiz.addOne__O__scm_Growable($n(it).next__O())
    }
  };
  return $thiz
}
function $is_scm_Growable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Growable)))
}
function $as_scm_Growable(obj) {
  return (($is_scm_Growable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Growable"))
}
function $isArrayOf_scm_Growable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Growable)))
}
function $asArrayOf_scm_Growable(obj, depth) {
  return (($isArrayOf_scm_Growable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Growable;", depth))
}
/** @constructor */
function $c_scm_StringBuilder$() {
  /*<skip>*/
}
$c_scm_StringBuilder$.prototype = new $h_O();
$c_scm_StringBuilder$.prototype.constructor = $c_scm_StringBuilder$;
/** @constructor */
function $h_scm_StringBuilder$() {
  /*<skip>*/
}
$h_scm_StringBuilder$.prototype = $c_scm_StringBuilder$.prototype;
var $d_scm_StringBuilder$ = new $TypeData().initClass({
  scm_StringBuilder$: 0
}, false, "scala.collection.mutable.StringBuilder$", {
  scm_StringBuilder$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_scm_StringBuilder$.prototype.$classData = $d_scm_StringBuilder$;
var $n_scm_StringBuilder$;
function $m_scm_StringBuilder$() {
  if ((!$n_scm_StringBuilder$)) {
    $n_scm_StringBuilder$ = new $c_scm_StringBuilder$()
  };
  return $n_scm_StringBuilder$
}
function $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V($thiz, runnable) {
  if ((runnable === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "runnable is null")
  };
  var tl = $thiz.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal;
  var b = $n(tl).get__O();
  if ((b instanceof $c_s_concurrent_BatchingExecutor$SyncBatch)) {
    $n($as_s_concurrent_BatchingExecutor$SyncBatch(b)).push__jl_Runnable__V(runnable)
  } else {
    if ((b !== null)) {
      var this$2 = $n($as_jl_Integer(b));
      var i = this$2
    } else {
      var i = 0
    };
    if ((i < 16)) {
      var $$x1 = $n(tl);
      var i$1 = ((1 + i) | 0);
      $n($$x1).set__O__V(i$1);
      try {
        $n(runnable).run__V()
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        if (false) {
          var x2 = $as_jl_InterruptedException(e$2);
          $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(x2)
        } else if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(e$2)
        } else {
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
        }
      } finally {
        $n(tl).set__O__V(b)
      }
    } else {
      var batch = new $c_s_concurrent_BatchingExecutor$SyncBatch($thiz, runnable);
      $n(tl).set__O__V(batch);
      batch.run__V();
      $n(tl).set__O__V(b)
    }
  }
}
function $is_s_concurrent_BatchingExecutor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_BatchingExecutor)))
}
function $as_s_concurrent_BatchingExecutor(obj) {
  return (($is_s_concurrent_BatchingExecutor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.BatchingExecutor"))
}
function $isArrayOf_s_concurrent_BatchingExecutor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BatchingExecutor)))
}
function $asArrayOf_s_concurrent_BatchingExecutor(obj, depth) {
  return (($isArrayOf_s_concurrent_BatchingExecutor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.BatchingExecutor;", depth))
}
function $is_s_concurrent_Future(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_Future)))
}
function $as_s_concurrent_Future(obj) {
  return (($is_s_concurrent_Future(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.Future"))
}
function $isArrayOf_s_concurrent_Future(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_Future)))
}
function $asArrayOf_s_concurrent_Future(obj, depth) {
  return (($isArrayOf_s_concurrent_Future(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.Future;", depth))
}
function $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, s) {
  var $$x1 = $m_s_Predef$();
  var this$1 = $n($f_T__trim__T($n(s)));
  var this$2 = $n($n($$x1).wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$1, "\\s+", 0)));
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2)
}
function $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($thiz, labels) {
  var x1 = $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, labels);
  if ((!(x1 instanceof $c_sci_$colon$colon))) {
    throw new $c_s_MatchError(x1)
  };
  var x2 = $as_sci_$colon$colon(x1);
  var hd = $as_T($n(x2).sci_$colon$colon__f_head);
  var rest = $n(x2).sci_$colon$colon__f_next;
  var this$1 = $n(rest);
  var rest$1 = this$1;
  var h = null;
  var t = null;
  while ((rest$1 !== $m_sci_Nil$())) {
    var arg1 = $n(rest$1).head__O();
    var s = $as_T(arg1);
    $n($m_s_package$().s_package$__f_List);
    var array = [s, (s + "s")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var it = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        $n(t).sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest$1 = $as_sci_List($n(rest$1).tail__O())
  };
  var this$6 = $n(((h === null) ? $m_sci_Nil$() : h));
  return new $c_sci_$colon$colon(hd, this$6)
}
/** @constructor */
function $c_s_concurrent_duration_Duration$() {
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = null;
  this.s_concurrent_duration_Duration$__f_timeUnitName = null;
  this.s_concurrent_duration_Duration$__f_Zero = null;
  this.s_concurrent_duration_Duration$__f_Undefined = null;
  this.s_concurrent_duration_Duration$__f_Inf = null;
  this.s_concurrent_duration_Duration$__f_MinusInf = null;
  $n_s_concurrent_duration_Duration$ = this;
  $n($m_s_package$().s_package$__f_List);
  var self = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
  var $$x6 = $ct_T2__O__O__(new $c_T2(), self, "d day");
  var self$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  var $$x5 = $ct_T2__O__O__(new $c_T2(), self$1, "h hr hour");
  var self$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  var $$x4 = $ct_T2__O__O__(new $c_T2(), self$2, "m min minute");
  var self$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var $$x3 = $ct_T2__O__O__(new $c_T2(), self$3, "s sec second");
  var self$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self$4, "ms milli millisecond");
  var self$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$5, "\u00b5s micro microsecond");
  var self$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$6, "ns nano nanosecond")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$20 = $n(this.s_concurrent_duration_Duration$__f_timeUnitLabels);
  var this$19 = $m_s_$less$colon$less$();
  var this$21 = $n($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$20));
  var this$23 = new $c_sc_MapView$Id(this$21);
  var f = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    return $as_T($n($p_s_concurrent_duration_Duration$__words__T__sci_List($m_s_concurrent_duration_Duration$(), s)).last__O())
  }));
  var this$25 = new $c_sc_MapView$MapValues(this$23, f);
  var this$24 = $m_s_$less$colon$less$();
  this.s_concurrent_duration_Duration$__f_timeUnitName = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$25);
  var this$26 = $n(this.s_concurrent_duration_Duration$__f_timeUnitLabels);
  var rest = this$26;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = $n(rest).head__O();
    var x0$1 = $as_T2(arg1);
    if ((x0$1 === null)) {
      throw new $c_s_MatchError(x0$1)
    };
    var unit = $as_ju_concurrent_TimeUnit($n(x0$1)._1__O());
    var names = $as_T($n(x0$1)._2__O());
    var this$30 = $n($p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($m_s_concurrent_duration_Duration$(), names));
    var f$1 = ((unit) => ((x$5$2) => {
      var x$5 = $as_T(x$5$2);
      return $ct_T2__O__O__(new $c_T2(), x$5, unit)
    }))(unit);
    if ((this$30 === $m_sci_Nil$())) {
      var $$x7 = $m_sci_Nil$()
    } else {
      var arg1$1 = this$30.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(this$30.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$2 = $n(rest$1).head__O();
        var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
        $n(t$1).sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest$1 = $as_sci_List($n(rest$1).tail__O())
      };
      var $$x7 = h$1
    };
    var it = $n($$x7).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1
      } else {
        $n(t).sci_$colon$colon__f_next = nx$1
      };
      t = nx$1
    };
    rest = $as_sci_List($n(rest).tail__O())
  };
  var this$32 = $n(((h === null) ? $m_sci_Nil$() : h));
  var this$31 = $m_s_$less$colon$less$();
  $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$32);
  this.s_concurrent_duration_Duration$__f_Zero = new $c_s_concurrent_duration_FiniteDuration($L0, $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS);
  this.s_concurrent_duration_Duration$__f_Undefined = new $c_s_concurrent_duration_Duration$$anon$1();
  this.s_concurrent_duration_Duration$__f_Inf = new $c_s_concurrent_duration_Duration$$anon$2();
  this.s_concurrent_duration_Duration$__f_MinusInf = new $c_s_concurrent_duration_Duration$$anon$3()
}
$c_s_concurrent_duration_Duration$.prototype = new $h_O();
$c_s_concurrent_duration_Duration$.prototype.constructor = $c_s_concurrent_duration_Duration$;
/** @constructor */
function $h_s_concurrent_duration_Duration$() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$.prototype = $c_s_concurrent_duration_Duration$.prototype;
$c_s_concurrent_duration_Duration$.prototype.apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration = (function(length, unit) {
  var this$1 = $n(unit).toNanos__J__J(new $c_RTLong(1, 0));
  return this.fromNanos__D__s_concurrent_duration_Duration(($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$1.RTLong__f_lo, this$1.RTLong__f_hi) * length))
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__D__s_concurrent_duration_Duration = (function(nanos) {
  if (((nanos === Infinity) || (nanos === (-Infinity)))) {
    return ((nanos > 0.0) ? this.s_concurrent_duration_Duration$__f_Inf : this.s_concurrent_duration_Duration$__f_MinusInf)
  } else if ((nanos !== nanos)) {
    return this.s_concurrent_duration_Duration$__f_Undefined
  } else if (((nanos > 9.223372036854776E18) || (nanos < (-9.223372036854776E18)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("trying to construct too large duration with " + nanos) + "ns"))
  } else {
    var this$8 = $m_RTLong$();
    var value = $uD(Math.round(nanos));
    var lo = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return this.fromNanos__J__s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi))
  }
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__J__s_concurrent_duration_FiniteDuration = (function(nanos) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === 0) && (hi === 0))) {
    $m_s_concurrent_duration_Duration$();
    var this$2 = $m_RTLong$();
    var lo$1 = this$2.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
    var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
    return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit)
  } else {
    var this$4 = $m_RTLong$();
    var lo$2 = this$4.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 817405952, 838);
    var hi$2 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo$2 === 0) && (hi$2 === 0))) {
      $m_s_concurrent_duration_Duration$();
      var this$5 = $m_RTLong$();
      var lo$3 = this$5.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 817405952, 838);
      var hi$3 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
      return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$3, hi$3), unit$1)
    } else {
      var this$7 = $m_RTLong$();
      var lo$4 = this$7.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-129542144), 13);
      var hi$4 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      if (((lo$4 === 0) && (hi$4 === 0))) {
        $m_s_concurrent_duration_Duration$();
        var this$8 = $m_RTLong$();
        var lo$5 = this$8.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-129542144), 13);
        var hi$5 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var unit$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
        return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$5, hi$5), unit$2)
      } else {
        var this$10 = $m_RTLong$();
        var lo$6 = this$10.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
        var hi$6 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        if (((lo$6 === 0) && (hi$6 === 0))) {
          $m_s_concurrent_duration_Duration$();
          var this$11 = $m_RTLong$();
          var lo$7 = this$11.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
          var hi$7 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var unit$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
          return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$7, hi$7), unit$3)
        } else {
          var this$13 = $m_RTLong$();
          var lo$8 = this$13.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000, 0);
          var hi$8 = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          if (((lo$8 === 0) && (hi$8 === 0))) {
            $m_s_concurrent_duration_Duration$();
            var this$14 = $m_RTLong$();
            var lo$9 = this$14.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000, 0);
            var hi$9 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            var unit$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
            return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$9, hi$9), unit$4)
          } else {
            var this$16 = $m_RTLong$();
            var lo$10 = this$16.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000, 0);
            var hi$10 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            if (((lo$10 === 0) && (hi$10 === 0))) {
              $m_s_concurrent_duration_Duration$();
              var this$17 = $m_RTLong$();
              var lo$11 = this$17.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000, 0);
              var hi$11 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var unit$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$11, hi$11), unit$5)
            } else {
              $m_s_concurrent_duration_Duration$();
              var unit$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(nanos, unit$6)
            }
          }
        }
      }
    }
  }
});
var $d_s_concurrent_duration_Duration$ = new $TypeData().initClass({
  s_concurrent_duration_Duration$: 0
}, false, "scala.concurrent.duration.Duration$", {
  s_concurrent_duration_Duration$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_concurrent_duration_Duration$.prototype.$classData = $d_s_concurrent_duration_Duration$;
var $n_s_concurrent_duration_Duration$;
function $m_s_concurrent_duration_Duration$() {
  if ((!$n_s_concurrent_duration_Duration$)) {
    $n_s_concurrent_duration_Duration$ = new $c_s_concurrent_duration_Duration$()
  };
  return $n_s_concurrent_duration_Duration$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationDouble(d) {
  this.s_concurrent_duration_package$DurationDouble__f_scala$concurrent$duration$DurationDouble$$d = 0.0;
  this.s_concurrent_duration_package$DurationDouble__f_scala$concurrent$duration$DurationDouble$$d = d
}
$c_s_concurrent_duration_package$DurationDouble.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationDouble.prototype.constructor = $c_s_concurrent_duration_package$DurationDouble;
/** @constructor */
function $h_s_concurrent_duration_package$DurationDouble() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationDouble.prototype = $c_s_concurrent_duration_package$DurationDouble.prototype;
$c_s_concurrent_duration_package$DurationDouble.prototype.hashCode__I = (function() {
  var this$ = this.s_concurrent_duration_package$DurationDouble__f_scala$concurrent$duration$DurationDouble$$d;
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(this$)
});
$c_s_concurrent_duration_package$DurationDouble.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationDouble$().equals$extension__D__O__Z(this.s_concurrent_duration_package$DurationDouble__f_scala$concurrent$duration$DurationDouble$$d, x$1)
});
function $as_s_concurrent_duration_package$DurationDouble(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationDouble"))
}
function $isArrayOf_s_concurrent_duration_package$DurationDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationDouble)))
}
function $asArrayOf_s_concurrent_duration_package$DurationDouble(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationDouble;", depth))
}
var $d_s_concurrent_duration_package$DurationDouble = new $TypeData().initClass({
  s_concurrent_duration_package$DurationDouble: 0
}, false, "scala.concurrent.duration.package$DurationDouble", {
  s_concurrent_duration_package$DurationDouble: 1,
  O: 1,
  s_concurrent_duration_DurationConversions: 1
});
$c_s_concurrent_duration_package$DurationDouble.prototype.$classData = $d_s_concurrent_duration_package$DurationDouble;
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt(n) {
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = 0;
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = n
}
$c_s_concurrent_duration_package$DurationInt.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt.prototype.constructor = $c_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationInt.prototype = $c_s_concurrent_duration_package$DurationInt.prototype;
$c_s_concurrent_duration_package$DurationInt.prototype.hashCode__I = (function() {
  var this$ = this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  return this$
});
$c_s_concurrent_duration_package$DurationInt.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationInt$().equals$extension__I__O__Z(this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n, x$1)
});
function $as_s_concurrent_duration_package$DurationInt(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationInt"))
}
function $isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationInt)))
}
function $asArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationInt;", depth))
}
var $d_s_concurrent_duration_package$DurationInt = new $TypeData().initClass({
  s_concurrent_duration_package$DurationInt: 0
}, false, "scala.concurrent.duration.package$DurationInt", {
  s_concurrent_duration_package$DurationInt: 1,
  O: 1,
  s_concurrent_duration_DurationConversions: 1
});
$c_s_concurrent_duration_package$DurationInt.prototype.$classData = $d_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong(n) {
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n = $L0;
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n = n
}
$c_s_concurrent_duration_package$DurationLong.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong.prototype.constructor = $c_s_concurrent_duration_package$DurationLong;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationLong.prototype = $c_s_concurrent_duration_package$DurationLong.prototype;
$c_s_concurrent_duration_package$DurationLong.prototype.hashCode__I = (function() {
  var t = this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
});
$c_s_concurrent_duration_package$DurationLong.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationLong$().equals$extension__J__O__Z(this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n, x$1)
});
function $as_s_concurrent_duration_package$DurationLong(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationLong"))
}
function $isArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationLong)))
}
function $asArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationLong;", depth))
}
var $d_s_concurrent_duration_package$DurationLong = new $TypeData().initClass({
  s_concurrent_duration_package$DurationLong: 0
}, false, "scala.concurrent.duration.package$DurationLong", {
  s_concurrent_duration_package$DurationLong: 1,
  O: 1,
  s_concurrent_duration_DurationConversions: 1
});
$c_s_concurrent_duration_package$DurationLong.prototype.$classData = $d_s_concurrent_duration_package$DurationLong;
/** @constructor */
function $c_s_concurrent_impl_Promise$ManyCallbacks(first, rest) {
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = first;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = rest
}
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype = new $h_O();
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.constructor = $c_s_concurrent_impl_Promise$ManyCallbacks;
/** @constructor */
function $h_s_concurrent_impl_Promise$ManyCallbacks() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$ManyCallbacks.prototype = $c_s_concurrent_impl_Promise$ManyCallbacks.prototype;
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.toString__T = (function() {
  return "ManyCallbacks"
});
function $as_s_concurrent_impl_Promise$ManyCallbacks(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$ManyCallbacks) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$ManyCallbacks"))
}
function $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$ManyCallbacks)))
}
function $asArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$ManyCallbacks;", depth))
}
var $d_s_concurrent_impl_Promise$ManyCallbacks = new $TypeData().initClass({
  s_concurrent_impl_Promise$ManyCallbacks: 0
}, false, "scala.concurrent.impl.Promise$ManyCallbacks", {
  s_concurrent_impl_Promise$ManyCallbacks: 1,
  O: 1,
  s_concurrent_impl_Promise$Callbacks: 1
});
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.$classData = $d_s_concurrent_impl_Promise$ManyCallbacks;
function $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) {
  if ((!$thiz.s_math_BigDecimal$__f_bitmap$0)) {
    $thiz.s_math_BigDecimal$__f_cache = new ($d_s_math_BigDecimal.getArrayOf().constr)(((1 + (($thiz.s_math_BigDecimal$__f_maxCached - $thiz.s_math_BigDecimal$__f_minCached) | 0)) | 0));
    $thiz.s_math_BigDecimal$__f_bitmap$0 = true
  };
  return $thiz.s_math_BigDecimal$__f_cache
}
function $p_s_math_BigDecimal$__cache__As_math_BigDecimal($thiz) {
  return ((!$thiz.s_math_BigDecimal$__f_bitmap$0) ? $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) : $thiz.s_math_BigDecimal$__f_cache)
}
/** @constructor */
function $c_s_math_BigDecimal$() {
  this.s_math_BigDecimal$__f_cache = null;
  this.s_math_BigDecimal$__f_minCached = 0;
  this.s_math_BigDecimal$__f_maxCached = 0;
  this.s_math_BigDecimal$__f_defaultMathContext = null;
  this.s_math_BigDecimal$__f_bitmap$0 = false;
  $n_s_math_BigDecimal$ = this;
  this.s_math_BigDecimal$__f_minCached = (-512);
  this.s_math_BigDecimal$__f_maxCached = 512;
  this.s_math_BigDecimal$__f_defaultMathContext = $m_Ljava_math_MathContext$().Ljava_math_MathContext$__f_DECIMAL128
}
$c_s_math_BigDecimal$.prototype = new $h_O();
$c_s_math_BigDecimal$.prototype.constructor = $c_s_math_BigDecimal$;
/** @constructor */
function $h_s_math_BigDecimal$() {
  /*<skip>*/
}
$h_s_math_BigDecimal$.prototype = $c_s_math_BigDecimal$.prototype;
$c_s_math_BigDecimal$.prototype.decimal__D__Ljava_math_MathContext__s_math_BigDecimal = (function(d, mc) {
  return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), ("" + d), mc), mc)
});
$c_s_math_BigDecimal$.prototype.exact__Ljava_math_BigDecimal__s_math_BigDecimal = (function(repr) {
  var $$x1 = $n(repr).precision__I();
  var this$1 = $n(this.s_math_BigDecimal$__f_defaultMathContext);
  if (($$x1 <= this$1.Ljava_math_MathContext__f_precision)) {
    var mc = this.s_math_BigDecimal$__f_defaultMathContext
  } else {
    var mc = new $c_Ljava_math_MathContext($n(repr).precision__I(), $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN)
  };
  return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), repr, mc)
});
$c_s_math_BigDecimal$.prototype.exact__T__s_math_BigDecimal = (function(s) {
  return this.exact__Ljava_math_BigDecimal__s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), s))
});
$c_s_math_BigDecimal$.prototype.apply__I__Ljava_math_MathContext__s_math_BigDecimal = (function(i, mc) {
  var x$2 = this.s_math_BigDecimal$__f_defaultMathContext;
  if (((((mc === null) ? (x$2 === null) : $n(mc).equals__O__Z(x$2)) && (this.s_math_BigDecimal$__f_minCached <= i)) && (i <= this.s_math_BigDecimal$__f_maxCached))) {
    var offset = ((i - this.s_math_BigDecimal$__f_minCached) | 0);
    var n = $n($p_s_math_BigDecimal$__cache__As_math_BigDecimal(this)).get(offset);
    if ((n === null)) {
      var hi = (i >> 31);
      n = $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(i, hi)), mc);
      $n($p_s_math_BigDecimal$__cache__As_math_BigDecimal(this)).set(offset, n)
    };
    return n
  } else {
    var hi$1 = (i >> 31);
    return this.apply__J__Ljava_math_MathContext__s_math_BigDecimal(new $c_RTLong(i, hi$1), mc)
  }
});
$c_s_math_BigDecimal$.prototype.apply__J__s_math_BigDecimal = (function(l) {
  var value = this.s_math_BigDecimal$__f_minCached;
  var hi = (value >> 31);
  var bhi = l.RTLong__f_hi;
  if (((hi === bhi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ l.RTLong__f_lo)) : (hi < bhi))) {
    var value$1 = this.s_math_BigDecimal$__f_maxCached;
    var hi$1 = (value$1 >> 31);
    var ahi = l.RTLong__f_hi;
    var $$x1 = ((ahi === hi$1) ? (((-2147483648) ^ l.RTLong__f_lo) <= ((-2147483648) ^ value$1)) : (ahi < hi$1))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var i = l.RTLong__f_lo;
    return this.apply__I__Ljava_math_MathContext__s_math_BigDecimal(i, this.s_math_BigDecimal$__f_defaultMathContext)
  } else {
    return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(l), this.s_math_BigDecimal$__f_defaultMathContext)
  }
});
$c_s_math_BigDecimal$.prototype.apply__J__Ljava_math_MathContext__s_math_BigDecimal = (function(l, mc) {
  return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), l, mc), mc)
});
$c_s_math_BigDecimal$.prototype.javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal = (function(x) {
  return ((x === null) ? null : $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), x, this.s_math_BigDecimal$__f_defaultMathContext))
});
var $d_s_math_BigDecimal$ = new $TypeData().initClass({
  s_math_BigDecimal$: 0
}, false, "scala.math.BigDecimal$", {
  s_math_BigDecimal$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_BigDecimal$.prototype.$classData = $d_s_math_BigDecimal$;
var $n_s_math_BigDecimal$;
function $m_s_math_BigDecimal$() {
  if ((!$n_s_math_BigDecimal$)) {
    $n_s_math_BigDecimal$ = new $c_s_math_BigDecimal$()
  };
  return $n_s_math_BigDecimal$
}
function $p_s_math_BigInt$__getCached__I__s_math_BigInt($thiz, i) {
  var offset = ((i - $thiz.s_math_BigInt$__f_minCached) | 0);
  var n = $n($thiz.s_math_BigInt$__f_cache).get(offset);
  if ((n === null)) {
    var hi = (i >> 31);
    n = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, new $c_RTLong(i, hi));
    $n($thiz.s_math_BigInt$__f_cache).set(offset, n)
  };
  return n
}
/** @constructor */
function $c_s_math_BigInt$() {
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = null;
  this.s_math_BigInt$__f_longMinValue = null;
  this.s_math_BigInt$__f_minCached = 0;
  this.s_math_BigInt$__f_maxCached = 0;
  this.s_math_BigInt$__f_cache = null;
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = null;
  $n_s_math_BigInt$ = this;
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_longMinValue = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger, new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_minCached = (-1024);
  this.s_math_BigInt$__f_maxCached = 1024;
  this.s_math_BigInt$__f_cache = new ($d_s_math_BigInt.getArrayOf().constr)(((1 + ((this.s_math_BigInt$__f_maxCached - this.s_math_BigInt$__f_minCached) | 0)) | 0));
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-1), (-1)))
}
$c_s_math_BigInt$.prototype = new $h_O();
$c_s_math_BigInt$.prototype.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
  /*<skip>*/
}
$h_s_math_BigInt$.prototype = $c_s_math_BigInt$.prototype;
$c_s_math_BigInt$.prototype.apply__I__s_math_BigInt = (function(i) {
  if (((this.s_math_BigInt$__f_minCached <= i) && (i <= this.s_math_BigInt$__f_maxCached))) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, i)
  } else {
    var hi = (i >> 31);
    return this.apply__J__s_math_BigInt(new $c_RTLong(i, hi))
  }
});
$c_s_math_BigInt$.prototype.apply__J__s_math_BigInt = (function(l) {
  var value = this.s_math_BigInt$__f_minCached;
  var hi = (value >> 31);
  var bhi = l.RTLong__f_hi;
  if (((hi === bhi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ l.RTLong__f_lo)) : (hi < bhi))) {
    var value$1 = this.s_math_BigInt$__f_maxCached;
    var hi$1 = (value$1 >> 31);
    var ahi = l.RTLong__f_hi;
    var $$x1 = ((ahi === hi$1) ? (((-2147483648) ^ l.RTLong__f_lo) <= ((-2147483648) ^ value$1)) : (ahi < hi$1))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l.RTLong__f_lo)
  } else {
    return (((l.RTLong__f_lo === 0) && (l.RTLong__f_hi === (-2147483648))) ? this.s_math_BigInt$__f_longMinValue : $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, l))
  }
});
$c_s_math_BigInt$.prototype.apply__Ljava_math_BigInteger__s_math_BigInt = (function(x) {
  var this$1 = $n(x);
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1) <= 63)) {
    var t = $n(x).longValue__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var value = this.s_math_BigInt$__f_minCached;
    var hi$1 = (value >> 31);
    if (((hi$1 === hi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ lo)) : (hi$1 < hi))) {
      var value$1 = this.s_math_BigInt$__f_maxCached;
      var hi$2 = (value$1 >> 31);
      var $$x1 = ((hi === hi$2) ? (((-2147483648) ^ lo) <= ((-2147483648) ^ value$1)) : (hi < hi$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, lo)
    } else {
      return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(lo, hi))
    }
  } else {
    return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(0, (-2147483648)))
  }
});
var $d_s_math_BigInt$ = new $TypeData().initClass({
  s_math_BigInt$: 0
}, false, "scala.math.BigInt$", {
  s_math_BigInt$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_BigInt$.prototype.$classData = $d_s_math_BigInt$;
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$()
  };
  return $n_s_math_BigInt$
}
function $is_s_math_Equiv(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Equiv)))
}
function $as_s_math_Equiv(obj) {
  return (($is_s_math_Equiv(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Equiv"))
}
function $isArrayOf_s_math_Equiv(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Equiv)))
}
function $asArrayOf_s_math_Equiv(obj, depth) {
  return (($isArrayOf_s_math_Equiv(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Equiv;", depth))
}
/** @constructor */
function $c_s_package$$anon$1() {
  /*<skip>*/
}
$c_s_package$$anon$1.prototype = new $h_O();
$c_s_package$$anon$1.prototype.constructor = $c_s_package$$anon$1;
/** @constructor */
function $h_s_package$$anon$1() {
  /*<skip>*/
}
$h_s_package$$anon$1.prototype = $c_s_package$$anon$1.prototype;
$c_s_package$$anon$1.prototype.toString__T = (function() {
  return "object AnyRef"
});
var $d_s_package$$anon$1 = new $TypeData().initClass({
  s_package$$anon$1: 0
}, false, "scala.package$$anon$1", {
  s_package$$anon$1: 1,
  O: 1,
  s_Specializable: 1
});
$c_s_package$$anon$1.prototype.$classData = $d_s_package$$anon$1;
/** @constructor */
function $c_s_reflect_ClassTag$() {
  /*<skip>*/
}
$c_s_reflect_ClassTag$.prototype = new $h_O();
$c_s_reflect_ClassTag$.prototype.constructor = $c_s_reflect_ClassTag$;
/** @constructor */
function $h_s_reflect_ClassTag$() {
  /*<skip>*/
}
$h_s_reflect_ClassTag$.prototype = $c_s_reflect_ClassTag$.prototype;
$c_s_reflect_ClassTag$.prototype.apply__jl_Class__s_reflect_ClassTag = (function(runtimeClass1) {
  return ((runtimeClass1 === $d_B.getClassOf()) ? $m_s_reflect_ManifestFactory$ByteManifest$() : ((runtimeClass1 === $d_S.getClassOf()) ? $m_s_reflect_ManifestFactory$ShortManifest$() : ((runtimeClass1 === $d_C.getClassOf()) ? $m_s_reflect_ManifestFactory$CharManifest$() : ((runtimeClass1 === $d_I.getClassOf()) ? $m_s_reflect_ManifestFactory$IntManifest$() : ((runtimeClass1 === $d_J.getClassOf()) ? $m_s_reflect_ManifestFactory$LongManifest$() : ((runtimeClass1 === $d_F.getClassOf()) ? $m_s_reflect_ManifestFactory$FloatManifest$() : ((runtimeClass1 === $d_D.getClassOf()) ? $m_s_reflect_ManifestFactory$DoubleManifest$() : ((runtimeClass1 === $d_Z.getClassOf()) ? $m_s_reflect_ManifestFactory$BooleanManifest$() : ((runtimeClass1 === $d_V.getClassOf()) ? $m_s_reflect_ManifestFactory$UnitManifest$() : ((runtimeClass1 === $d_O.getClassOf()) ? $m_s_reflect_ManifestFactory$ObjectManifest$() : ((runtimeClass1 === $d_sr_Nothing$.getClassOf()) ? $m_s_reflect_ManifestFactory$NothingManifest$() : ((runtimeClass1 === $d_sr_Null$.getClassOf()) ? $m_s_reflect_ManifestFactory$NullManifest$() : new $c_s_reflect_ClassTag$GenericClassTag(runtimeClass1)))))))))))))
});
var $d_s_reflect_ClassTag$ = new $TypeData().initClass({
  s_reflect_ClassTag$: 0
}, false, "scala.reflect.ClassTag$", {
  s_reflect_ClassTag$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_ClassTag$.prototype.$classData = $d_s_reflect_ClassTag$;
var $n_s_reflect_ClassTag$;
function $m_s_reflect_ClassTag$() {
  if ((!$n_s_reflect_ClassTag$)) {
    $n_s_reflect_ClassTag$ = new $c_s_reflect_ClassTag$()
  };
  return $n_s_reflect_ClassTag$
}
/** @constructor */
function $c_sr_AbstractFunction0() {
  /*<skip>*/
}
$c_sr_AbstractFunction0.prototype = new $h_O();
$c_sr_AbstractFunction0.prototype.constructor = $c_sr_AbstractFunction0;
/** @constructor */
function $h_sr_AbstractFunction0() {
  /*<skip>*/
}
$h_sr_AbstractFunction0.prototype = $c_sr_AbstractFunction0.prototype;
$c_sr_AbstractFunction0.prototype.toString__T = (function() {
  return "<function0>"
});
/** @constructor */
function $c_sr_AbstractFunction1() {
  /*<skip>*/
}
$c_sr_AbstractFunction1.prototype = new $h_O();
$c_sr_AbstractFunction1.prototype.constructor = $c_sr_AbstractFunction1;
/** @constructor */
function $h_sr_AbstractFunction1() {
  /*<skip>*/
}
$h_sr_AbstractFunction1.prototype = $c_sr_AbstractFunction1.prototype;
$c_sr_AbstractFunction1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1))
});
$c_sr_AbstractFunction1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sr_AbstractFunction1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sr_AbstractFunction1.prototype.toString__T = (function() {
  return "<function1>"
});
/** @constructor */
function $c_sr_AbstractFunction10() {
  /*<skip>*/
}
$c_sr_AbstractFunction10.prototype = new $h_O();
$c_sr_AbstractFunction10.prototype.constructor = $c_sr_AbstractFunction10;
/** @constructor */
function $h_sr_AbstractFunction10() {
  /*<skip>*/
}
$h_sr_AbstractFunction10.prototype = $c_sr_AbstractFunction10.prototype;
$c_sr_AbstractFunction10.prototype.toString__T = (function() {
  return "<function10>"
});
/** @constructor */
function $c_sr_AbstractFunction11() {
  /*<skip>*/
}
$c_sr_AbstractFunction11.prototype = new $h_O();
$c_sr_AbstractFunction11.prototype.constructor = $c_sr_AbstractFunction11;
/** @constructor */
function $h_sr_AbstractFunction11() {
  /*<skip>*/
}
$h_sr_AbstractFunction11.prototype = $c_sr_AbstractFunction11.prototype;
$c_sr_AbstractFunction11.prototype.toString__T = (function() {
  return "<function11>"
});
/** @constructor */
function $c_sr_AbstractFunction12() {
  /*<skip>*/
}
$c_sr_AbstractFunction12.prototype = new $h_O();
$c_sr_AbstractFunction12.prototype.constructor = $c_sr_AbstractFunction12;
/** @constructor */
function $h_sr_AbstractFunction12() {
  /*<skip>*/
}
$h_sr_AbstractFunction12.prototype = $c_sr_AbstractFunction12.prototype;
$c_sr_AbstractFunction12.prototype.toString__T = (function() {
  return "<function12>"
});
/** @constructor */
function $c_sr_AbstractFunction13() {
  /*<skip>*/
}
$c_sr_AbstractFunction13.prototype = new $h_O();
$c_sr_AbstractFunction13.prototype.constructor = $c_sr_AbstractFunction13;
/** @constructor */
function $h_sr_AbstractFunction13() {
  /*<skip>*/
}
$h_sr_AbstractFunction13.prototype = $c_sr_AbstractFunction13.prototype;
$c_sr_AbstractFunction13.prototype.toString__T = (function() {
  return "<function13>"
});
/** @constructor */
function $c_sr_AbstractFunction2() {
  /*<skip>*/
}
$c_sr_AbstractFunction2.prototype = new $h_O();
$c_sr_AbstractFunction2.prototype.constructor = $c_sr_AbstractFunction2;
/** @constructor */
function $h_sr_AbstractFunction2() {
  /*<skip>*/
}
$h_sr_AbstractFunction2.prototype = $c_sr_AbstractFunction2.prototype;
$c_sr_AbstractFunction2.prototype.toString__T = (function() {
  return "<function2>"
});
/** @constructor */
function $c_sr_AbstractFunction3() {
  /*<skip>*/
}
$c_sr_AbstractFunction3.prototype = new $h_O();
$c_sr_AbstractFunction3.prototype.constructor = $c_sr_AbstractFunction3;
/** @constructor */
function $h_sr_AbstractFunction3() {
  /*<skip>*/
}
$h_sr_AbstractFunction3.prototype = $c_sr_AbstractFunction3.prototype;
$c_sr_AbstractFunction3.prototype.toString__T = (function() {
  return "<function3>"
});
/** @constructor */
function $c_sr_AbstractFunction4() {
  /*<skip>*/
}
$c_sr_AbstractFunction4.prototype = new $h_O();
$c_sr_AbstractFunction4.prototype.constructor = $c_sr_AbstractFunction4;
/** @constructor */
function $h_sr_AbstractFunction4() {
  /*<skip>*/
}
$h_sr_AbstractFunction4.prototype = $c_sr_AbstractFunction4.prototype;
$c_sr_AbstractFunction4.prototype.toString__T = (function() {
  return "<function4>"
});
/** @constructor */
function $c_sr_AbstractFunction5() {
  /*<skip>*/
}
$c_sr_AbstractFunction5.prototype = new $h_O();
$c_sr_AbstractFunction5.prototype.constructor = $c_sr_AbstractFunction5;
/** @constructor */
function $h_sr_AbstractFunction5() {
  /*<skip>*/
}
$h_sr_AbstractFunction5.prototype = $c_sr_AbstractFunction5.prototype;
$c_sr_AbstractFunction5.prototype.toString__T = (function() {
  return "<function5>"
});
/** @constructor */
function $c_sr_AbstractFunction6() {
  /*<skip>*/
}
$c_sr_AbstractFunction6.prototype = new $h_O();
$c_sr_AbstractFunction6.prototype.constructor = $c_sr_AbstractFunction6;
/** @constructor */
function $h_sr_AbstractFunction6() {
  /*<skip>*/
}
$h_sr_AbstractFunction6.prototype = $c_sr_AbstractFunction6.prototype;
$c_sr_AbstractFunction6.prototype.toString__T = (function() {
  return "<function6>"
});
/** @constructor */
function $c_sr_AbstractFunction7() {
  /*<skip>*/
}
$c_sr_AbstractFunction7.prototype = new $h_O();
$c_sr_AbstractFunction7.prototype.constructor = $c_sr_AbstractFunction7;
/** @constructor */
function $h_sr_AbstractFunction7() {
  /*<skip>*/
}
$h_sr_AbstractFunction7.prototype = $c_sr_AbstractFunction7.prototype;
$c_sr_AbstractFunction7.prototype.toString__T = (function() {
  return "<function7>"
});
/** @constructor */
function $c_sr_AbstractFunction8() {
  /*<skip>*/
}
$c_sr_AbstractFunction8.prototype = new $h_O();
$c_sr_AbstractFunction8.prototype.constructor = $c_sr_AbstractFunction8;
/** @constructor */
function $h_sr_AbstractFunction8() {
  /*<skip>*/
}
$h_sr_AbstractFunction8.prototype = $c_sr_AbstractFunction8.prototype;
$c_sr_AbstractFunction8.prototype.toString__T = (function() {
  return "<function8>"
});
/** @constructor */
function $c_sr_AbstractFunction9() {
  /*<skip>*/
}
$c_sr_AbstractFunction9.prototype = new $h_O();
$c_sr_AbstractFunction9.prototype.constructor = $c_sr_AbstractFunction9;
/** @constructor */
function $h_sr_AbstractFunction9() {
  /*<skip>*/
}
$h_sr_AbstractFunction9.prototype = $c_sr_AbstractFunction9.prototype;
$c_sr_AbstractFunction9.prototype.toString__T = (function() {
  return "<function9>"
});
/** @constructor */
function $c_sr_BooleanRef(elem) {
  this.sr_BooleanRef__f_elem = false;
  this.sr_BooleanRef__f_elem = elem
}
$c_sr_BooleanRef.prototype = new $h_O();
$c_sr_BooleanRef.prototype.constructor = $c_sr_BooleanRef;
/** @constructor */
function $h_sr_BooleanRef() {
  /*<skip>*/
}
$h_sr_BooleanRef.prototype = $c_sr_BooleanRef.prototype;
$c_sr_BooleanRef.prototype.toString__T = (function() {
  var b = this.sr_BooleanRef__f_elem;
  return ("" + b)
});
var $d_sr_BooleanRef = new $TypeData().initClass({
  sr_BooleanRef: 0
}, false, "scala.runtime.BooleanRef", {
  sr_BooleanRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_BooleanRef.prototype.$classData = $d_sr_BooleanRef;
/** @constructor */
function $c_sr_IntRef(elem) {
  this.sr_IntRef__f_elem = 0;
  this.sr_IntRef__f_elem = elem
}
$c_sr_IntRef.prototype = new $h_O();
$c_sr_IntRef.prototype.constructor = $c_sr_IntRef;
/** @constructor */
function $h_sr_IntRef() {
  /*<skip>*/
}
$h_sr_IntRef.prototype = $c_sr_IntRef.prototype;
$c_sr_IntRef.prototype.toString__T = (function() {
  var i = this.sr_IntRef__f_elem;
  return ("" + i)
});
var $d_sr_IntRef = new $TypeData().initClass({
  sr_IntRef: 0
}, false, "scala.runtime.IntRef", {
  sr_IntRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_IntRef.prototype.$classData = $d_sr_IntRef;
/** @constructor */
function $c_sr_LazyRef() {
  this.sr_LazyRef__f__initialized = false;
  this.sr_LazyRef__f__value = null
}
$c_sr_LazyRef.prototype = new $h_O();
$c_sr_LazyRef.prototype.constructor = $c_sr_LazyRef;
/** @constructor */
function $h_sr_LazyRef() {
  /*<skip>*/
}
$h_sr_LazyRef.prototype = $c_sr_LazyRef.prototype;
$c_sr_LazyRef.prototype.initialize__O__O = (function(value) {
  this.sr_LazyRef__f__value = value;
  this.sr_LazyRef__f__initialized = true;
  return value
});
$c_sr_LazyRef.prototype.toString__T = (function() {
  return ("LazyRef " + (this.sr_LazyRef__f__initialized ? ("of: " + this.sr_LazyRef__f__value) : "thunk"))
});
var $d_sr_LazyRef = new $TypeData().initClass({
  sr_LazyRef: 0
}, false, "scala.runtime.LazyRef", {
  sr_LazyRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_LazyRef.prototype.$classData = $d_sr_LazyRef;
/** @constructor */
function $c_sr_ObjectRef(elem) {
  this.sr_ObjectRef__f_elem = null;
  this.sr_ObjectRef__f_elem = elem
}
$c_sr_ObjectRef.prototype = new $h_O();
$c_sr_ObjectRef.prototype.constructor = $c_sr_ObjectRef;
/** @constructor */
function $h_sr_ObjectRef() {
  /*<skip>*/
}
$h_sr_ObjectRef.prototype = $c_sr_ObjectRef.prototype;
$c_sr_ObjectRef.prototype.toString__T = (function() {
  var obj = this.sr_ObjectRef__f_elem;
  return ("" + obj)
});
var $d_sr_ObjectRef = new $TypeData().initClass({
  sr_ObjectRef: 0
}, false, "scala.runtime.ObjectRef", {
  sr_ObjectRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_ObjectRef.prototype.$classData = $d_sr_ObjectRef;
/** @constructor */
function $c_s_util_Left$() {
  /*<skip>*/
}
$c_s_util_Left$.prototype = new $h_O();
$c_s_util_Left$.prototype.constructor = $c_s_util_Left$;
/** @constructor */
function $h_s_util_Left$() {
  /*<skip>*/
}
$h_s_util_Left$.prototype = $c_s_util_Left$.prototype;
$c_s_util_Left$.prototype.toString__T = (function() {
  return "Left"
});
var $d_s_util_Left$ = new $TypeData().initClass({
  s_util_Left$: 0
}, false, "scala.util.Left$", {
  s_util_Left$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Left$.prototype.$classData = $d_s_util_Left$;
var $n_s_util_Left$;
function $m_s_util_Left$() {
  if ((!$n_s_util_Left$)) {
    $n_s_util_Left$ = new $c_s_util_Left$()
  };
  return $n_s_util_Left$
}
function $ct_s_util_Random__ju_Random__($thiz, self) {
  $thiz.s_util_Random__f_self = self;
  return $thiz
}
/** @constructor */
function $c_s_util_Random() {
  this.s_util_Random__f_self = null
}
$c_s_util_Random.prototype = new $h_O();
$c_s_util_Random.prototype.constructor = $c_s_util_Random;
/** @constructor */
function $h_s_util_Random() {
  /*<skip>*/
}
$h_s_util_Random.prototype = $c_s_util_Random.prototype;
/** @constructor */
function $c_s_util_Right$() {
  /*<skip>*/
}
$c_s_util_Right$.prototype = new $h_O();
$c_s_util_Right$.prototype.constructor = $c_s_util_Right$;
/** @constructor */
function $h_s_util_Right$() {
  /*<skip>*/
}
$h_s_util_Right$.prototype = $c_s_util_Right$.prototype;
$c_s_util_Right$.prototype.toString__T = (function() {
  return "Right"
});
var $d_s_util_Right$ = new $TypeData().initClass({
  s_util_Right$: 0
}, false, "scala.util.Right$", {
  s_util_Right$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Right$.prototype.$classData = $d_s_util_Right$;
var $n_s_util_Right$;
function $m_s_util_Right$() {
  if ((!$n_s_util_Right$)) {
    $n_s_util_Right$ = new $c_s_util_Right$()
  };
  return $n_s_util_Right$
}
/** @constructor */
function $c_s_util_Try$() {
  /*<skip>*/
}
$c_s_util_Try$.prototype = new $h_O();
$c_s_util_Try$.prototype.constructor = $c_s_util_Try$;
/** @constructor */
function $h_s_util_Try$() {
  /*<skip>*/
}
$h_s_util_Try$.prototype = $c_s_util_Try$.prototype;
$c_s_util_Try$.prototype.apply__F0__s_util_Try = (function(r) {
  try {
    return new $c_s_util_Success($n(r).apply__O())
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(o11).isEmpty__Z())) {
      var e$3 = $as_jl_Throwable($n(o11).get__O());
      return new $c_s_util_Failure(e$3)
    };
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
  }
});
var $d_s_util_Try$ = new $TypeData().initClass({
  s_util_Try$: 0
}, false, "scala.util.Try$", {
  s_util_Try$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Try$.prototype.$classData = $d_s_util_Try$;
var $n_s_util_Try$;
function $m_s_util_Try$() {
  if ((!$n_s_util_Try$)) {
    $n_s_util_Try$ = new $c_s_util_Try$()
  };
  return $n_s_util_Try$
}
/** @constructor */
function $c_s_util_control_NoStackTrace$() {
  this.s_util_control_NoStackTrace$__f__noSuppression = false;
  this.s_util_control_NoStackTrace$__f__noSuppression = false
}
$c_s_util_control_NoStackTrace$.prototype = new $h_O();
$c_s_util_control_NoStackTrace$.prototype.constructor = $c_s_util_control_NoStackTrace$;
/** @constructor */
function $h_s_util_control_NoStackTrace$() {
  /*<skip>*/
}
$h_s_util_control_NoStackTrace$.prototype = $c_s_util_control_NoStackTrace$.prototype;
var $d_s_util_control_NoStackTrace$ = new $TypeData().initClass({
  s_util_control_NoStackTrace$: 0
}, false, "scala.util.control.NoStackTrace$", {
  s_util_control_NoStackTrace$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_control_NoStackTrace$.prototype.$classData = $d_s_util_control_NoStackTrace$;
var $n_s_util_control_NoStackTrace$;
function $m_s_util_control_NoStackTrace$() {
  if ((!$n_s_util_control_NoStackTrace$)) {
    $n_s_util_control_NoStackTrace$ = new $c_s_util_control_NoStackTrace$()
  };
  return $n_s_util_control_NoStackTrace$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$() {
  this.s_util_hashing_MurmurHash3$__f_seqSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_mapSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_setSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = 0;
  $n_s_util_hashing_MurmurHash3$ = this;
  this.s_util_hashing_MurmurHash3$__f_seqSeed = $f_T__hashCode__I("Seq");
  this.s_util_hashing_MurmurHash3$__f_mapSeed = $f_T__hashCode__I("Map");
  this.s_util_hashing_MurmurHash3$__f_setSeed = $f_T__hashCode__I("Set");
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = this.unorderedHash__sc_IterableOnce__I__I($m_s_package$().s_package$__f_Nil, this.s_util_hashing_MurmurHash3$__f_mapSeed)
}
$c_s_util_hashing_MurmurHash3$.prototype = new $h_s_util_hashing_MurmurHash3();
$c_s_util_hashing_MurmurHash3$.prototype.constructor = $c_s_util_hashing_MurmurHash3$;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3$.prototype = $c_s_util_hashing_MurmurHash3$.prototype;
$c_s_util_hashing_MurmurHash3$.prototype.tuple2Hash__O__O__I = (function(x, y) {
  return this.tuple2Hash__I__I__I__I($m_sr_Statics$().anyHash__O__I(x), $m_sr_Statics$().anyHash__O__I(y), (-889275714))
});
$c_s_util_hashing_MurmurHash3$.prototype.seqHash__sc_Seq__I = (function(xs) {
  if ($is_sc_IndexedSeq(xs)) {
    var x2 = $as_sc_IndexedSeq(xs);
    return this.indexedSeqHash__sc_IndexedSeq__I__I(x2, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  } else if ((xs instanceof $c_sci_List)) {
    var x3 = $as_sci_List(xs);
    return this.listHash__sci_List__I__I(x3, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  } else {
    return this.orderedHash__sc_IterableOnce__I__I(xs, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  }
});
$c_s_util_hashing_MurmurHash3$.prototype.mapHash__sc_Map__I = (function(xs) {
  if ($n(xs).isEmpty__Z()) {
    return this.s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var accum = new $c_s_util_hashing_MurmurHash3$accum$1();
    var h = this.s_util_hashing_MurmurHash3$__f_mapSeed;
    $n(xs).foreachEntry__F2__V(accum);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_a);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_b);
    h = this.mixLast__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_c);
    return this.finalizeHash__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_n)
  }
});
var $d_s_util_hashing_MurmurHash3$ = new $TypeData().initClass({
  s_util_hashing_MurmurHash3$: 0
}, false, "scala.util.hashing.MurmurHash3$", {
  s_util_hashing_MurmurHash3$: 1,
  s_util_hashing_MurmurHash3: 1,
  O: 1
});
$c_s_util_hashing_MurmurHash3$.prototype.$classData = $d_s_util_hashing_MurmurHash3$;
var $n_s_util_hashing_MurmurHash3$;
function $m_s_util_hashing_MurmurHash3$() {
  if ((!$n_s_util_hashing_MurmurHash3$)) {
    $n_s_util_hashing_MurmurHash3$ = new $c_s_util_hashing_MurmurHash3$()
  };
  return $n_s_util_hashing_MurmurHash3$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$accum$1() {
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 1
}
$c_s_util_hashing_MurmurHash3$accum$1.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3$accum$1.prototype.constructor = $c_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$accum$1() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3$accum$1.prototype = $c_s_util_hashing_MurmurHash3$accum$1.prototype;
$c_s_util_hashing_MurmurHash3$accum$1.prototype.toString__T = (function() {
  return "<function2>"
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__V = (function(k, v) {
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(k, v);
  this.s_util_hashing_MurmurHash3$accum$1__f_a = ((this.s_util_hashing_MurmurHash3$accum$1__f_a + h) | 0);
  this.s_util_hashing_MurmurHash3$accum$1__f_b = (this.s_util_hashing_MurmurHash3$accum$1__f_b ^ h);
  this.s_util_hashing_MurmurHash3$accum$1__f_c = Math.imul(this.s_util_hashing_MurmurHash3$accum$1__f_c, (1 | h));
  this.s_util_hashing_MurmurHash3$accum$1__f_n = ((1 + this.s_util_hashing_MurmurHash3$accum$1__f_n) | 0)
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2)
});
var $d_s_util_hashing_MurmurHash3$accum$1 = new $TypeData().initClass({
  s_util_hashing_MurmurHash3$accum$1: 0
}, false, "scala.util.hashing.MurmurHash3$accum$1", {
  s_util_hashing_MurmurHash3$accum$1: 1,
  O: 1,
  F2: 1
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.$classData = $d_s_util_hashing_MurmurHash3$accum$1;
function $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, pattern, groupNames) {
  $thiz.s_util_matching_Regex__f_pattern = pattern;
  $thiz.s_util_matching_Regex__f_scala$util$matching$Regex$$groupNames = groupNames;
  return $thiz
}
function $ct_s_util_matching_Regex__T__sci_Seq__($thiz, regex, groupNames) {
  $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0), groupNames);
  return $thiz
}
/** @constructor */
function $c_s_util_matching_Regex() {
  this.s_util_matching_Regex__f_pattern = null;
  this.s_util_matching_Regex__f_scala$util$matching$Regex$$groupNames = null
}
$c_s_util_matching_Regex.prototype = new $h_O();
$c_s_util_matching_Regex.prototype.constructor = $c_s_util_matching_Regex;
/** @constructor */
function $h_s_util_matching_Regex() {
  /*<skip>*/
}
$h_s_util_matching_Regex.prototype = $c_s_util_matching_Regex.prototype;
$c_s_util_matching_Regex.prototype.unapplySeq__jl_CharSequence__s_Option = (function(s) {
  var this$1 = $n(this.s_util_matching_Regex__f_pattern);
  var m = new $c_ju_regex_Matcher(this$1, $dp_toString__T($n(s)));
  if (m.matches__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var n = $n(m.ju_regex_Matcher__f_pattern0).ju_regex_Pattern__f_groupCount;
    var b = new $c_scm_ListBuffer();
    var i = 0;
    while ((i < n)) {
      var arg1 = i;
      var elem = m.group__I__T(((1 + arg1) | 0));
      b.addOne__O__scm_ListBuffer(elem);
      i = ((1 + i) | 0)
    };
    return new $c_s_Some(b.toList__sci_List())
  } else {
    return $m_s_None$()
  }
});
$c_s_util_matching_Regex.prototype.matches__jl_CharSequence__Z = (function(source) {
  var this$1 = $n(this.s_util_matching_Regex__f_pattern);
  var m = new $c_ju_regex_Matcher(this$1, $dp_toString__T($n(source)));
  return m.matches__Z()
});
$c_s_util_matching_Regex.prototype.replaceAllIn__jl_CharSequence__T__T = (function(target, replacement) {
  var this$1 = $n(this.s_util_matching_Regex__f_pattern);
  var m = new $c_ju_regex_Matcher(this$1, $dp_toString__T($n(target)));
  return m.replaceAll__T__T(replacement)
});
$c_s_util_matching_Regex.prototype.toString__T = (function() {
  return $n(this.s_util_matching_Regex__f_pattern).ju_regex_Pattern__f__pattern
});
var $d_s_util_matching_Regex = new $TypeData().initClass({
  s_util_matching_Regex: 0
}, false, "scala.util.matching.Regex", {
  s_util_matching_Regex: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_matching_Regex.prototype.$classData = $d_s_util_matching_Regex;
function $p_s_util_matching_Regex$Match__starts$lzycompute__AI($thiz) {
  if (((((1 & $thiz.s_util_matching_Regex$Match__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $n($thiz.s_util_matching_Regex$Match__f_matcher);
    var n = ((1 + $n(this$1.ju_regex_Matcher__f_pattern0).ju_regex_Pattern__f_groupCount) | 0);
    $m_s_reflect_ManifestFactory$IntManifest$();
    if ((n <= 0)) {
      var $$x1 = new $ac_I(0)
    } else {
      var array = new $ac_I(n);
      var i = 0;
      while ((i < n)) {
        var $$x2 = i;
        var arg1 = i;
        array.set($$x2, $n($thiz.s_util_matching_Regex$Match__f_matcher).start__I__I(arg1));
        i = ((1 + i) | 0)
      };
      var $$x1 = array
    };
    $thiz.s_util_matching_Regex$Match__f_starts = $$x1;
    $thiz.s_util_matching_Regex$Match__f_bitmap$0 = (((1 | $thiz.s_util_matching_Regex$Match__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.s_util_matching_Regex$Match__f_starts
}
function $p_s_util_matching_Regex$Match__starts__AI($thiz) {
  return (((((1 & $thiz.s_util_matching_Regex$Match__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_util_matching_Regex$Match__starts$lzycompute__AI($thiz) : $thiz.s_util_matching_Regex$Match__f_starts)
}
function $p_s_util_matching_Regex$Match__ends$lzycompute__AI($thiz) {
  if (((((2 & $thiz.s_util_matching_Regex$Match__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $n($thiz.s_util_matching_Regex$Match__f_matcher);
    var n = ((1 + $n(this$1.ju_regex_Matcher__f_pattern0).ju_regex_Pattern__f_groupCount) | 0);
    $m_s_reflect_ManifestFactory$IntManifest$();
    if ((n <= 0)) {
      var $$x1 = new $ac_I(0)
    } else {
      var array = new $ac_I(n);
      var i = 0;
      while ((i < n)) {
        var $$x2 = i;
        var arg1 = i;
        array.set($$x2, $n($thiz.s_util_matching_Regex$Match__f_matcher).end__I__I(arg1));
        i = ((1 + i) | 0)
      };
      var $$x1 = array
    };
    $thiz.s_util_matching_Regex$Match__f_ends = $$x1;
    $thiz.s_util_matching_Regex$Match__f_bitmap$0 = (((2 | $thiz.s_util_matching_Regex$Match__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.s_util_matching_Regex$Match__f_ends
}
function $p_s_util_matching_Regex$Match__ends__AI($thiz) {
  return (((((2 & $thiz.s_util_matching_Regex$Match__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_util_matching_Regex$Match__ends$lzycompute__AI($thiz) : $thiz.s_util_matching_Regex$Match__f_ends)
}
/** @constructor */
function $c_s_util_matching_Regex$Match(source, matcher, _groupNames) {
  this.s_util_matching_Regex$Match__f_starts = null;
  this.s_util_matching_Regex$Match__f_ends = null;
  this.s_util_matching_Regex$Match__f_source = null;
  this.s_util_matching_Regex$Match__f_matcher = null;
  this.s_util_matching_Regex$Match__f_start = 0;
  this.s_util_matching_Regex$Match__f_end = 0;
  this.s_util_matching_Regex$Match__f_bitmap$0 = 0;
  this.s_util_matching_Regex$Match__f_source = source;
  this.s_util_matching_Regex$Match__f_matcher = matcher;
  this.s_util_matching_Regex$Match__f_start = $n(matcher).start__I();
  this.s_util_matching_Regex$Match__f_end = $n(matcher).end__I()
}
$c_s_util_matching_Regex$Match.prototype = new $h_O();
$c_s_util_matching_Regex$Match.prototype.constructor = $c_s_util_matching_Regex$Match;
/** @constructor */
function $h_s_util_matching_Regex$Match() {
  /*<skip>*/
}
$h_s_util_matching_Regex$Match.prototype = $c_s_util_matching_Regex$Match.prototype;
$c_s_util_matching_Regex$Match.prototype.toString__T = (function() {
  return $f_s_util_matching_Regex$MatchData__matched__T(this)
});
$c_s_util_matching_Regex$Match.prototype.source__jl_CharSequence = (function() {
  return this.s_util_matching_Regex$Match__f_source
});
$c_s_util_matching_Regex$Match.prototype.start__I = (function() {
  return this.s_util_matching_Regex$Match__f_start
});
$c_s_util_matching_Regex$Match.prototype.end__I = (function() {
  return this.s_util_matching_Regex$Match__f_end
});
$c_s_util_matching_Regex$Match.prototype.start__I__I = (function(i) {
  return $n($p_s_util_matching_Regex$Match__starts__AI(this)).get(i)
});
$c_s_util_matching_Regex$Match.prototype.end__I__I = (function(i) {
  return $n($p_s_util_matching_Regex$Match__ends__AI(this)).get(i)
});
$c_s_util_matching_Regex$Match.prototype.force__s_util_matching_Regex$Match = (function() {
  $p_s_util_matching_Regex$Match__starts__AI(this);
  $p_s_util_matching_Regex$Match__ends__AI(this);
  return this
});
var $d_s_util_matching_Regex$Match = new $TypeData().initClass({
  s_util_matching_Regex$Match: 0
}, false, "scala.util.matching.Regex$Match", {
  s_util_matching_Regex$Match: 1,
  O: 1,
  s_util_matching_Regex$MatchData: 1
});
$c_s_util_matching_Regex$Match.prototype.$classData = $d_s_util_matching_Regex$Match;
function $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod($thiz, s) {
  return ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $m_Ljapgolly_scalajs_react_vdom_Attr$ClassName$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(s).Lscalacss_internal_StyleA__f_htmlClass, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
}
/** @constructor */
function $c_Lscalacss_ScalatagsJsDomImplicits$$anon$1(outer, s$1) {
  this.Lscalacss_ScalatagsJsDomImplicits$$anon$1__f_s$1 = null;
  this.Lscalacss_ScalatagsJsDomImplicits$$anon$1__f_s$1 = s$1
}
$c_Lscalacss_ScalatagsJsDomImplicits$$anon$1.prototype = new $h_O();
$c_Lscalacss_ScalatagsJsDomImplicits$$anon$1.prototype.constructor = $c_Lscalacss_ScalatagsJsDomImplicits$$anon$1;
/** @constructor */
function $h_Lscalacss_ScalatagsJsDomImplicits$$anon$1() {
  /*<skip>*/
}
$h_Lscalacss_ScalatagsJsDomImplicits$$anon$1.prototype = $c_Lscalacss_ScalatagsJsDomImplicits$$anon$1.prototype;
$c_Lscalacss_ScalatagsJsDomImplicits$$anon$1.prototype.applyTo__Lorg_scalajs_dom_Element__V = (function(t) {
  var this$1 = $n($n(this.Lscalacss_ScalatagsJsDomImplicits$$anon$1__f_s$1).classNameIterator__sc_Iterator());
  while (this$1.hasNext__Z()) {
    var arg1 = this$1.next__O();
    var cn = $as_Lscalacss_internal_ClassName(arg1);
    t.classList.add($n(cn).Lscalacss_internal_ClassName__f_value)
  }
});
$c_Lscalacss_ScalatagsJsDomImplicits$$anon$1.prototype.applyTo__O__V = (function(t) {
  this.applyTo__Lorg_scalajs_dom_Element__V(t)
});
var $d_Lscalacss_ScalatagsJsDomImplicits$$anon$1 = new $TypeData().initClass({
  Lscalacss_ScalatagsJsDomImplicits$$anon$1: 0
}, false, "scalacss.ScalatagsJsDomImplicits$$anon$1", {
  Lscalacss_ScalatagsJsDomImplicits$$anon$1: 1,
  O: 1,
  Lscalatags_generic_Modifier: 1
});
$c_Lscalacss_ScalatagsJsDomImplicits$$anon$1.prototype.$classData = $d_Lscalacss_ScalatagsJsDomImplicits$$anon$1;
/** @constructor */
function $c_Lscalacss_ScalatagsJsDomRenderer(s) {
  this.Lscalacss_ScalatagsJsDomRenderer__f_s = null;
  this.Lscalacss_ScalatagsJsDomRenderer__f_s = s
}
$c_Lscalacss_ScalatagsJsDomRenderer.prototype = new $h_O();
$c_Lscalacss_ScalatagsJsDomRenderer.prototype.constructor = $c_Lscalacss_ScalatagsJsDomRenderer;
/** @constructor */
function $h_Lscalacss_ScalatagsJsDomRenderer() {
  /*<skip>*/
}
$h_Lscalacss_ScalatagsJsDomRenderer.prototype = $c_Lscalacss_ScalatagsJsDomRenderer.prototype;
$c_Lscalacss_ScalatagsJsDomRenderer.prototype.apply__sci_Vector__Lscalatags_JsDom$TypedTag = (function(css) {
  var this$1 = $m_Lscalatags_JsDom$tags2$();
  var $$x2 = $n(this$1.style__Lscalatags_JsDom$TypedTag());
  var $$x1 = $n($m_Lscalatags_JsDom$all$().type__Lscalatags_generic_Attr()).$colon$eq__O__Lscalatags_generic_AttrValue__Lscalatags_generic_AttrPair("text/css", $m_Lscalatags_JsDom$all$().Lscalatags_JsDom$all$__f_stringAttr);
  $m_Lscalatags_JsDom$all$();
  var v = $as_T($n(this.Lscalacss_ScalatagsJsDomRenderer__f_s).apply__sci_Vector__O(css));
  var array = [$$x1, new $c_Lscalatags_JsDom$StringFrag(v)];
  return $n($$x2).apply__sci_Seq__Lscalatags_JsDom$TypedTag($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lscalacss_ScalatagsJsDomRenderer.prototype.apply__sci_Vector__O = (function(css) {
  return this.apply__sci_Vector__Lscalatags_JsDom$TypedTag(css)
});
var $d_Lscalacss_ScalatagsJsDomRenderer = new $TypeData().initClass({
  Lscalacss_ScalatagsJsDomRenderer: 0
}, false, "scalacss.ScalatagsJsDomRenderer", {
  Lscalacss_ScalatagsJsDomRenderer: 1,
  O: 1,
  Lscalacss_internal_Renderer: 1
});
$c_Lscalacss_ScalatagsJsDomRenderer.prototype.$classData = $d_Lscalacss_ScalatagsJsDomRenderer;
function $f_Lscalacss_defaults_DefaultSettings$Dev__$init$__V($thiz) {
  $thiz.scalacss$defaults$DefaultSettings$Dev$_setter_$cssRegisterNameGen_$eq__Lscalacss_internal_mutable_Register$NameGen__V(new $c_Lscalacss_internal_mutable_Register$NameGen$IncFmt("%s-%04d", 1));
  $thiz.scalacss$defaults$DefaultSettings$Dev$_setter_$cssRegisterErrorHandler_$eq__Lscalacss_internal_mutable_Register$ErrorHandler__V($m_Lscalacss_internal_mutable_Register$ErrorHandler$().noisy__Lscalacss_internal_mutable_Register$ErrorHandler())
}
function $f_Lscalacss_defaults_Exports__$init$__V($thiz) {
  $thiz.scalacss$defaults$Exports$_setter_$PseudoType_$eq__Lscalacss_internal_PseudoType$__V($m_Lscalacss_internal_PseudoType$());
  $thiz.scalacss$defaults$Exports$_setter_$Pseudo_$eq__Lscalacss_internal_Pseudo$__V($m_Lscalacss_internal_Pseudo$());
  $thiz.scalacss$defaults$Exports$_setter_$Domain_$eq__Lscalacss_internal_Domain$__V($m_Lscalacss_internal_Domain$());
  $thiz.scalacss$defaults$Exports$_setter_$StyleA_$eq__Lscalacss_internal_StyleA$__V($m_Lscalacss_internal_StyleA$());
  $thiz.scalacss$defaults$Exports$_setter_$CssComposer_$eq__Lscalacss_internal_Compose$__V($m_Lscalacss_internal_Compose$());
  $thiz.scalacss$defaults$Exports$_setter_$CssEnv_$eq__Lscalacss_internal_Env$__V($m_Lscalacss_internal_Env$())
}
function $p_Lscalacss_internal_AliasAttr__real$lzycompute__sci_Set($thiz) {
  if ((!$thiz.Lscalacss_internal_AliasAttr__f_bitmap$0)) {
    $thiz.Lscalacss_internal_AliasAttr__f_real = $p_Lscalacss_internal_AliasAttr__go$1__sci_Set__sci_Set__sci_Vector__sci_Set($thiz, ($n($m_s_Predef$().s_Predef$__f_Set), $m_sci_Set$EmptySet$()), ($n($m_s_Predef$().s_Predef$__f_Set), $m_sci_Set$EmptySet$()), $n($as_Lscalacss_internal_NonEmptyVector($n($thiz.Lscalacss_internal_AliasAttr__f_targets).value__O())).whole__sci_Vector());
    $thiz.Lscalacss_internal_AliasAttr__f_bitmap$0 = true
  };
  return $thiz.Lscalacss_internal_AliasAttr__f_real
}
function $p_Lscalacss_internal_AliasAttr__go$1__sci_Set__sci_Set__sci_Vector__sci_Set($thiz, seen, found, queue) {
  while (true) {
    var this$1 = $n(queue);
    if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
      return found
    } else {
      var t = $n(queue).tail__sci_Vector();
      var x1 = $as_Lscalacss_internal_Attr($n(queue).head__O());
      if ($n(seen).contains__O__Z(x1)) {
        queue = t
      } else if ((x1 instanceof $c_Lscalacss_internal_RealAttr)) {
        var x2 = $as_Lscalacss_internal_RealAttr(x1);
        var this$2 = $n(seen);
        var temp$seen = $as_sci_Set(this$2.incl__O__sci_SetOps(x2));
        var this$3 = $n(found);
        var temp$found = $as_sci_Set(this$3.incl__O__sci_SetOps(x2));
        seen = temp$seen;
        found = temp$found;
        queue = t
      } else if ((x1 instanceof $c_Lscalacss_internal_AliasAttr)) {
        var x3 = $as_Lscalacss_internal_AliasAttr(x1);
        var this$4 = $n(seen);
        var temp$seen$2 = $as_sci_Set(this$4.incl__O__sci_SetOps(x3));
        var this$5 = $n($n($as_Lscalacss_internal_NonEmptyVector($n($n(x3).Lscalacss_internal_AliasAttr__f_targets).value__O())).whole__sci_Vector());
        var temp$queue$3 = this$5.appendedAll__sc_IterableOnce__sci_Vector(t);
        seen = temp$seen$2;
        queue = temp$queue$3
      } else {
        throw new $c_s_MatchError(x1)
      }
    }
  }
}
/** @constructor */
function $c_Lscalacss_internal_AliasAttr(id, gen, targets) {
  this.Lscalacss_internal_Attr__f_id = null;
  this.Lscalacss_internal_Attr__f_gen = null;
  this.Lscalacss_internal_AliasAttr__f_real = null;
  this.Lscalacss_internal_AliasAttr__f_targets = null;
  this.Lscalacss_internal_AliasAttr__f_bitmap$0 = false;
  this.Lscalacss_internal_AliasAttr__f_targets = targets;
  $ct_Lscalacss_internal_Attr__T__F1__(this, id, gen)
}
$c_Lscalacss_internal_AliasAttr.prototype = new $h_Lscalacss_internal_Attr();
$c_Lscalacss_internal_AliasAttr.prototype.constructor = $c_Lscalacss_internal_AliasAttr;
/** @constructor */
function $h_Lscalacss_internal_AliasAttr() {
  /*<skip>*/
}
$h_Lscalacss_internal_AliasAttr.prototype = $c_Lscalacss_internal_AliasAttr.prototype;
$c_Lscalacss_internal_AliasAttr.prototype.real__sci_Set = (function() {
  return ((!this.Lscalacss_internal_AliasAttr__f_bitmap$0) ? $p_Lscalacss_internal_AliasAttr__real$lzycompute__sci_Set(this) : this.Lscalacss_internal_AliasAttr__f_real)
});
function $as_Lscalacss_internal_AliasAttr(obj) {
  return (((obj instanceof $c_Lscalacss_internal_AliasAttr) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.AliasAttr"))
}
function $isArrayOf_Lscalacss_internal_AliasAttr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_AliasAttr)))
}
function $asArrayOf_Lscalacss_internal_AliasAttr(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_AliasAttr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.AliasAttr;", depth))
}
var $d_Lscalacss_internal_AliasAttr = new $TypeData().initClass({
  Lscalacss_internal_AliasAttr: 0
}, false, "scalacss.internal.AliasAttr", {
  Lscalacss_internal_AliasAttr: 1,
  Lscalacss_internal_Attr: 1,
  O: 1
});
$c_Lscalacss_internal_AliasAttr.prototype.$classData = $d_Lscalacss_internal_AliasAttr;
/** @constructor */
function $c_Lscalacss_internal_AttrAliasesAndValueTRules() {
  /*<skip>*/
}
$c_Lscalacss_internal_AttrAliasesAndValueTRules.prototype = new $h_Lscalacss_internal_ValueT$Rules();
$c_Lscalacss_internal_AttrAliasesAndValueTRules.prototype.constructor = $c_Lscalacss_internal_AttrAliasesAndValueTRules;
/** @constructor */
function $h_Lscalacss_internal_AttrAliasesAndValueTRules() {
  /*<skip>*/
}
$h_Lscalacss_internal_AttrAliasesAndValueTRules.prototype = $c_Lscalacss_internal_AttrAliasesAndValueTRules.prototype;
/** @constructor */
function $c_Lscalacss_internal_AttrCmp$Conflict() {
  /*<skip>*/
}
$c_Lscalacss_internal_AttrCmp$Conflict.prototype = new $h_Lscalacss_internal_AttrCmp();
$c_Lscalacss_internal_AttrCmp$Conflict.prototype.constructor = $c_Lscalacss_internal_AttrCmp$Conflict;
/** @constructor */
function $h_Lscalacss_internal_AttrCmp$Conflict() {
  /*<skip>*/
}
$h_Lscalacss_internal_AttrCmp$Conflict.prototype = $c_Lscalacss_internal_AttrCmp$Conflict.prototype;
$c_Lscalacss_internal_AttrCmp$Conflict.prototype.$greater$greater__F0__Lscalacss_internal_AttrCmp = (function(next) {
  return this
});
$c_Lscalacss_internal_AttrCmp$Conflict.prototype.conflict__Z = (function() {
  return true
});
/** @constructor */
function $c_Lscalacss_internal_Attrs$alignContent$() {
  this.Lscalacss_internal_Attrs$alignContent$__f_attr = null;
  $n_Lscalacss_internal_Attrs$alignContent$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  this.Lscalacss_internal_Attrs$alignContent$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("align-content", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$alignContent$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$alignContent$.prototype.constructor = $c_Lscalacss_internal_Attrs$alignContent$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$alignContent$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$alignContent$.prototype = $c_Lscalacss_internal_Attrs$alignContent$.prototype;
$c_Lscalacss_internal_Attrs$alignContent$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$alignContent$__f_attr
});
var $d_Lscalacss_internal_Attrs$alignContent$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$alignContent$: 0
}, false, "scalacss.internal.Attrs$alignContent$", {
  Lscalacss_internal_Attrs$alignContent$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$alignContent$.prototype.$classData = $d_Lscalacss_internal_Attrs$alignContent$;
var $n_Lscalacss_internal_Attrs$alignContent$;
function $m_Lscalacss_internal_Attrs$alignContent$() {
  if ((!$n_Lscalacss_internal_Attrs$alignContent$)) {
    $n_Lscalacss_internal_Attrs$alignContent$ = new $c_Lscalacss_internal_Attrs$alignContent$()
  };
  return $n_Lscalacss_internal_Attrs$alignContent$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$alignItems$() {
  this.Lscalacss_internal_Attrs$alignItems$__f_attr = null;
  $n_Lscalacss_internal_Attrs$alignItems$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  this.Lscalacss_internal_Attrs$alignItems$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("align-items", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$alignItems$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$alignItems$.prototype.constructor = $c_Lscalacss_internal_Attrs$alignItems$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$alignItems$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$alignItems$.prototype = $c_Lscalacss_internal_Attrs$alignItems$.prototype;
$c_Lscalacss_internal_Attrs$alignItems$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$alignItems$__f_attr
});
var $d_Lscalacss_internal_Attrs$alignItems$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$alignItems$: 0
}, false, "scalacss.internal.Attrs$alignItems$", {
  Lscalacss_internal_Attrs$alignItems$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$alignItems$.prototype.$classData = $d_Lscalacss_internal_Attrs$alignItems$;
var $n_Lscalacss_internal_Attrs$alignItems$;
function $m_Lscalacss_internal_Attrs$alignItems$() {
  if ((!$n_Lscalacss_internal_Attrs$alignItems$)) {
    $n_Lscalacss_internal_Attrs$alignItems$ = new $c_Lscalacss_internal_Attrs$alignItems$()
  };
  return $n_Lscalacss_internal_Attrs$alignItems$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$alignSelf$() {
  this.Lscalacss_internal_Attrs$alignSelf$__f_attr = null;
  $n_Lscalacss_internal_Attrs$alignSelf$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  this.Lscalacss_internal_Attrs$alignSelf$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("align-self", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$alignSelf$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$alignSelf$.prototype.constructor = $c_Lscalacss_internal_Attrs$alignSelf$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$alignSelf$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$alignSelf$.prototype = $c_Lscalacss_internal_Attrs$alignSelf$.prototype;
$c_Lscalacss_internal_Attrs$alignSelf$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$alignSelf$__f_attr
});
var $d_Lscalacss_internal_Attrs$alignSelf$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$alignSelf$: 0
}, false, "scalacss.internal.Attrs$alignSelf$", {
  Lscalacss_internal_Attrs$alignSelf$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$alignSelf$.prototype.$classData = $d_Lscalacss_internal_Attrs$alignSelf$;
var $n_Lscalacss_internal_Attrs$alignSelf$;
function $m_Lscalacss_internal_Attrs$alignSelf$() {
  if ((!$n_Lscalacss_internal_Attrs$alignSelf$)) {
    $n_Lscalacss_internal_Attrs$alignSelf$ = new $c_Lscalacss_internal_Attrs$alignSelf$()
  };
  return $n_Lscalacss_internal_Attrs$alignSelf$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$animationDirection$() {
  this.Lscalacss_internal_Attrs$animationDirection$__f_attr = null;
  $n_Lscalacss_internal_Attrs$animationDirection$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_animation;
  this.Lscalacss_internal_Attrs$animationDirection$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("animation-direction", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$animationDirection$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$animationDirection$.prototype.constructor = $c_Lscalacss_internal_Attrs$animationDirection$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$animationDirection$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$animationDirection$.prototype = $c_Lscalacss_internal_Attrs$animationDirection$.prototype;
$c_Lscalacss_internal_Attrs$animationDirection$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$animationDirection$__f_attr
});
var $d_Lscalacss_internal_Attrs$animationDirection$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$animationDirection$: 0
}, false, "scalacss.internal.Attrs$animationDirection$", {
  Lscalacss_internal_Attrs$animationDirection$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$animationDirection$.prototype.$classData = $d_Lscalacss_internal_Attrs$animationDirection$;
var $n_Lscalacss_internal_Attrs$animationDirection$;
function $m_Lscalacss_internal_Attrs$animationDirection$() {
  if ((!$n_Lscalacss_internal_Attrs$animationDirection$)) {
    $n_Lscalacss_internal_Attrs$animationDirection$ = new $c_Lscalacss_internal_Attrs$animationDirection$()
  };
  return $n_Lscalacss_internal_Attrs$animationDirection$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$animationIterationCount$() {
  this.Lscalacss_internal_Attrs$animationIterationCount$__f_attr = null;
  $n_Lscalacss_internal_Attrs$animationIterationCount$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_animation;
  this.Lscalacss_internal_Attrs$animationIterationCount$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("animation-iteration-count", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$animationIterationCount$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$animationIterationCount$.prototype.constructor = $c_Lscalacss_internal_Attrs$animationIterationCount$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$animationIterationCount$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$animationIterationCount$.prototype = $c_Lscalacss_internal_Attrs$animationIterationCount$.prototype;
$c_Lscalacss_internal_Attrs$animationIterationCount$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$animationIterationCount$__f_attr
});
var $d_Lscalacss_internal_Attrs$animationIterationCount$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$animationIterationCount$: 0
}, false, "scalacss.internal.Attrs$animationIterationCount$", {
  Lscalacss_internal_Attrs$animationIterationCount$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$animationIterationCount$.prototype.$classData = $d_Lscalacss_internal_Attrs$animationIterationCount$;
var $n_Lscalacss_internal_Attrs$animationIterationCount$;
function $m_Lscalacss_internal_Attrs$animationIterationCount$() {
  if ((!$n_Lscalacss_internal_Attrs$animationIterationCount$)) {
    $n_Lscalacss_internal_Attrs$animationIterationCount$ = new $c_Lscalacss_internal_Attrs$animationIterationCount$()
  };
  return $n_Lscalacss_internal_Attrs$animationIterationCount$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$animationName$() {
  this.Lscalacss_internal_Attrs$animationName$__f_attr = null;
  $n_Lscalacss_internal_Attrs$animationName$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_animation;
  this.Lscalacss_internal_Attrs$animationName$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("animation-name", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$animationName$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$animationName$.prototype.constructor = $c_Lscalacss_internal_Attrs$animationName$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$animationName$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$animationName$.prototype = $c_Lscalacss_internal_Attrs$animationName$.prototype;
$c_Lscalacss_internal_Attrs$animationName$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$animationName$__f_attr
});
$c_Lscalacss_internal_Attrs$animationName$.prototype.apply__Lscalacss_internal_Keyframes__Lscalacss_internal_AV = (function(a) {
  var v = $n($n(a).Lscalacss_internal_Keyframes__f_name).Lscalacss_internal_ClassName__f_value;
  return new $c_Lscalacss_internal_AV(this.Lscalacss_internal_Attrs$animationName$__f_attr, v)
});
var $d_Lscalacss_internal_Attrs$animationName$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$animationName$: 0
}, false, "scalacss.internal.Attrs$animationName$", {
  Lscalacss_internal_Attrs$animationName$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$animationName$.prototype.$classData = $d_Lscalacss_internal_Attrs$animationName$;
var $n_Lscalacss_internal_Attrs$animationName$;
function $m_Lscalacss_internal_Attrs$animationName$() {
  if ((!$n_Lscalacss_internal_Attrs$animationName$)) {
    $n_Lscalacss_internal_Attrs$animationName$ = new $c_Lscalacss_internal_Attrs$animationName$()
  };
  return $n_Lscalacss_internal_Attrs$animationName$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$animationTimingFunction$() {
  this.Lscalacss_internal_Attrs$animationTimingFunction$__f_attr = null;
  $n_Lscalacss_internal_Attrs$animationTimingFunction$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_animation;
  this.Lscalacss_internal_Attrs$animationTimingFunction$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("animation-timing-function", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$animationTimingFunction$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$animationTimingFunction$.prototype.constructor = $c_Lscalacss_internal_Attrs$animationTimingFunction$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$animationTimingFunction$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$animationTimingFunction$.prototype = $c_Lscalacss_internal_Attrs$animationTimingFunction$.prototype;
$c_Lscalacss_internal_Attrs$animationTimingFunction$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$animationTimingFunction$__f_attr
});
var $d_Lscalacss_internal_Attrs$animationTimingFunction$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$animationTimingFunction$: 0
}, false, "scalacss.internal.Attrs$animationTimingFunction$", {
  Lscalacss_internal_Attrs$animationTimingFunction$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$animationTimingFunction$.prototype.$classData = $d_Lscalacss_internal_Attrs$animationTimingFunction$;
var $n_Lscalacss_internal_Attrs$animationTimingFunction$;
function $m_Lscalacss_internal_Attrs$animationTimingFunction$() {
  if ((!$n_Lscalacss_internal_Attrs$animationTimingFunction$)) {
    $n_Lscalacss_internal_Attrs$animationTimingFunction$ = new $c_Lscalacss_internal_Attrs$animationTimingFunction$()
  };
  return $n_Lscalacss_internal_Attrs$animationTimingFunction$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderCollapse$() {
  this.Lscalacss_internal_Attrs$borderCollapse$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderCollapse$ = this;
  this.Lscalacss_internal_Attrs$borderCollapse$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-collapse")
}
$c_Lscalacss_internal_Attrs$borderCollapse$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$borderCollapse$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderCollapse$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderCollapse$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderCollapse$.prototype = $c_Lscalacss_internal_Attrs$borderCollapse$.prototype;
$c_Lscalacss_internal_Attrs$borderCollapse$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderCollapse$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderCollapse$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderCollapse$: 0
}, false, "scalacss.internal.Attrs$borderCollapse$", {
  Lscalacss_internal_Attrs$borderCollapse$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$borderCollapse$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderCollapse$;
var $n_Lscalacss_internal_Attrs$borderCollapse$;
function $m_Lscalacss_internal_Attrs$borderCollapse$() {
  if ((!$n_Lscalacss_internal_Attrs$borderCollapse$)) {
    $n_Lscalacss_internal_Attrs$borderCollapse$ = new $c_Lscalacss_internal_Attrs$borderCollapse$()
  };
  return $n_Lscalacss_internal_Attrs$borderCollapse$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$boxSizing$() {
  this.Lscalacss_internal_Attrs$boxSizing$__f_attr = null;
  $n_Lscalacss_internal_Attrs$boxSizing$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().css3Boxsizing__sci_Map();
  this.Lscalacss_internal_Attrs$boxSizing$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("box-sizing", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$boxSizing$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$boxSizing$.prototype.constructor = $c_Lscalacss_internal_Attrs$boxSizing$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$boxSizing$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$boxSizing$.prototype = $c_Lscalacss_internal_Attrs$boxSizing$.prototype;
$c_Lscalacss_internal_Attrs$boxSizing$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$boxSizing$__f_attr
});
var $d_Lscalacss_internal_Attrs$boxSizing$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$boxSizing$: 0
}, false, "scalacss.internal.Attrs$boxSizing$", {
  Lscalacss_internal_Attrs$boxSizing$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$boxSizing$.prototype.$classData = $d_Lscalacss_internal_Attrs$boxSizing$;
var $n_Lscalacss_internal_Attrs$boxSizing$;
function $m_Lscalacss_internal_Attrs$boxSizing$() {
  if ((!$n_Lscalacss_internal_Attrs$boxSizing$)) {
    $n_Lscalacss_internal_Attrs$boxSizing$ = new $c_Lscalacss_internal_Attrs$boxSizing$()
  };
  return $n_Lscalacss_internal_Attrs$boxSizing$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$cursor$() {
  this.Lscalacss_internal_Attrs$cursor$__f_attr = null;
  $n_Lscalacss_internal_Attrs$cursor$ = this;
  var $$x3 = $m_Lscalacss_internal_Attr$();
  var $$x2 = $m_Lscalacss_internal_Transform$();
  var $$x1 = $m_Lscalacss_internal_CanIUse$().css3CursorsNewer__sci_Map();
  var array = ["grabbing", "zoom-in", "zoom-out"];
  this.Lscalacss_internal_Attrs$cursor$__f_attr = $n($$x3).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("cursor", $n($$x2).values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($$x1, "grab", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
}
$c_Lscalacss_internal_Attrs$cursor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$cursor$.prototype.constructor = $c_Lscalacss_internal_Attrs$cursor$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$cursor$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$cursor$.prototype = $c_Lscalacss_internal_Attrs$cursor$.prototype;
$c_Lscalacss_internal_Attrs$cursor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$cursor$__f_attr
});
var $d_Lscalacss_internal_Attrs$cursor$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$cursor$: 0
}, false, "scalacss.internal.Attrs$cursor$", {
  Lscalacss_internal_Attrs$cursor$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$cursor$.prototype.$classData = $d_Lscalacss_internal_Attrs$cursor$;
var $n_Lscalacss_internal_Attrs$cursor$;
function $m_Lscalacss_internal_Attrs$cursor$() {
  if ((!$n_Lscalacss_internal_Attrs$cursor$)) {
    $n_Lscalacss_internal_Attrs$cursor$ = new $c_Lscalacss_internal_Attrs$cursor$()
  };
  return $n_Lscalacss_internal_Attrs$cursor$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$display$() {
  this.Lscalacss_internal_Attrs$display$__f_attr = null;
  $n_Lscalacss_internal_Attrs$display$ = this;
  var $$x7 = $m_Lscalacss_internal_Attr$();
  var $$x6 = $n($n($n($m_Lscalacss_internal_Transform$().values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($m_Lscalacss_internal_CanIUse$().displayContents__sci_Map(), "contents", $m_sci_Nil$())).$times__Lscalacss_internal_Transform__Lscalacss_internal_Transform($m_Lscalacss_internal_Transform$().values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($m_Lscalacss_internal_CanIUse$().flowRoot__sci_Map(), "flow-root", $m_sci_Nil$()))).$times__Lscalacss_internal_Transform__Lscalacss_internal_Transform($m_Lscalacss_internal_Transform$().values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($m_Lscalacss_internal_CanIUse$().runIn__sci_Map(), "run-in", $m_sci_Nil$())));
  var $$x5 = $m_Lscalacss_internal_Transform$();
  var $$x4 = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  var array = ["inline-flex"];
  var $$x3 = $n($$x6).$times__Lscalacss_internal_Transform__Lscalacss_internal_Transform($n($$x5).values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($$x4, "flex", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var $$x2 = $m_Lscalacss_internal_Transform$();
  var $$x1 = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_grid;
  var array$1 = ["inline-grid"];
  this.Lscalacss_internal_Attrs$display$__f_attr = $n($$x7).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("display", $n($$x3).$times__Lscalacss_internal_Transform__Lscalacss_internal_Transform($n($$x2).values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($$x1, "grid", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))))
}
$c_Lscalacss_internal_Attrs$display$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$display$.prototype.constructor = $c_Lscalacss_internal_Attrs$display$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$display$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$display$.prototype = $c_Lscalacss_internal_Attrs$display$.prototype;
$c_Lscalacss_internal_Attrs$display$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$display$__f_attr
});
var $d_Lscalacss_internal_Attrs$display$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$display$: 0
}, false, "scalacss.internal.Attrs$display$", {
  Lscalacss_internal_Attrs$display$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$display$.prototype.$classData = $d_Lscalacss_internal_Attrs$display$;
var $n_Lscalacss_internal_Attrs$display$;
function $m_Lscalacss_internal_Attrs$display$() {
  if ((!$n_Lscalacss_internal_Attrs$display$)) {
    $n_Lscalacss_internal_Attrs$display$ = new $c_Lscalacss_internal_Attrs$display$()
  };
  return $n_Lscalacss_internal_Attrs$display$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$flexDirection$() {
  this.Lscalacss_internal_Attrs$flexDirection$__f_attr = null;
  $n_Lscalacss_internal_Attrs$flexDirection$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  this.Lscalacss_internal_Attrs$flexDirection$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("flex-direction", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$flexDirection$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$flexDirection$.prototype.constructor = $c_Lscalacss_internal_Attrs$flexDirection$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$flexDirection$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$flexDirection$.prototype = $c_Lscalacss_internal_Attrs$flexDirection$.prototype;
$c_Lscalacss_internal_Attrs$flexDirection$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$flexDirection$__f_attr
});
var $d_Lscalacss_internal_Attrs$flexDirection$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$flexDirection$: 0
}, false, "scalacss.internal.Attrs$flexDirection$", {
  Lscalacss_internal_Attrs$flexDirection$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$flexDirection$.prototype.$classData = $d_Lscalacss_internal_Attrs$flexDirection$;
var $n_Lscalacss_internal_Attrs$flexDirection$;
function $m_Lscalacss_internal_Attrs$flexDirection$() {
  if ((!$n_Lscalacss_internal_Attrs$flexDirection$)) {
    $n_Lscalacss_internal_Attrs$flexDirection$ = new $c_Lscalacss_internal_Attrs$flexDirection$()
  };
  return $n_Lscalacss_internal_Attrs$flexDirection$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$flexWrap$() {
  this.Lscalacss_internal_Attrs$flexWrap$__f_attr = null;
  $n_Lscalacss_internal_Attrs$flexWrap$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  this.Lscalacss_internal_Attrs$flexWrap$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("flex-wrap", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$flexWrap$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$flexWrap$.prototype.constructor = $c_Lscalacss_internal_Attrs$flexWrap$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$flexWrap$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$flexWrap$.prototype = $c_Lscalacss_internal_Attrs$flexWrap$.prototype;
$c_Lscalacss_internal_Attrs$flexWrap$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$flexWrap$__f_attr
});
var $d_Lscalacss_internal_Attrs$flexWrap$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$flexWrap$: 0
}, false, "scalacss.internal.Attrs$flexWrap$", {
  Lscalacss_internal_Attrs$flexWrap$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$flexWrap$.prototype.$classData = $d_Lscalacss_internal_Attrs$flexWrap$;
var $n_Lscalacss_internal_Attrs$flexWrap$;
function $m_Lscalacss_internal_Attrs$flexWrap$() {
  if ((!$n_Lscalacss_internal_Attrs$flexWrap$)) {
    $n_Lscalacss_internal_Attrs$flexWrap$ = new $c_Lscalacss_internal_Attrs$flexWrap$()
  };
  return $n_Lscalacss_internal_Attrs$flexWrap$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$fontFamily$() {
  this.Lscalacss_internal_Attrs$fontFamily$__f_attr = null;
  $n_Lscalacss_internal_Attrs$fontFamily$ = this;
  this.Lscalacss_internal_Attrs$fontFamily$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("font-family", $m_Lscalacss_internal_Transform$().values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($m_Lscalacss_internal_CanIUse$().fontFamilySystemUi__sci_Map(), "system-ui", $m_sci_Nil$()))
}
$c_Lscalacss_internal_Attrs$fontFamily$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$fontFamily$.prototype.constructor = $c_Lscalacss_internal_Attrs$fontFamily$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$fontFamily$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$fontFamily$.prototype = $c_Lscalacss_internal_Attrs$fontFamily$.prototype;
$c_Lscalacss_internal_Attrs$fontFamily$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$fontFamily$__f_attr
});
var $d_Lscalacss_internal_Attrs$fontFamily$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$fontFamily$: 0
}, false, "scalacss.internal.Attrs$fontFamily$", {
  Lscalacss_internal_Attrs$fontFamily$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$fontFamily$.prototype.$classData = $d_Lscalacss_internal_Attrs$fontFamily$;
var $n_Lscalacss_internal_Attrs$fontFamily$;
function $m_Lscalacss_internal_Attrs$fontFamily$() {
  if ((!$n_Lscalacss_internal_Attrs$fontFamily$)) {
    $n_Lscalacss_internal_Attrs$fontFamily$ = new $c_Lscalacss_internal_Attrs$fontFamily$()
  };
  return $n_Lscalacss_internal_Attrs$fontFamily$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$fontStyle$() {
  this.Lscalacss_internal_Attrs$fontStyle$__f_attr = null;
  $n_Lscalacss_internal_Attrs$fontStyle$ = this;
  this.Lscalacss_internal_Attrs$fontStyle$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("font-style")
}
$c_Lscalacss_internal_Attrs$fontStyle$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$fontStyle$.prototype.constructor = $c_Lscalacss_internal_Attrs$fontStyle$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$fontStyle$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$fontStyle$.prototype = $c_Lscalacss_internal_Attrs$fontStyle$.prototype;
$c_Lscalacss_internal_Attrs$fontStyle$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$fontStyle$__f_attr
});
var $d_Lscalacss_internal_Attrs$fontStyle$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$fontStyle$: 0
}, false, "scalacss.internal.Attrs$fontStyle$", {
  Lscalacss_internal_Attrs$fontStyle$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$fontStyle$.prototype.$classData = $d_Lscalacss_internal_Attrs$fontStyle$;
var $n_Lscalacss_internal_Attrs$fontStyle$;
function $m_Lscalacss_internal_Attrs$fontStyle$() {
  if ((!$n_Lscalacss_internal_Attrs$fontStyle$)) {
    $n_Lscalacss_internal_Attrs$fontStyle$ = new $c_Lscalacss_internal_Attrs$fontStyle$()
  };
  return $n_Lscalacss_internal_Attrs$fontStyle$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$fontVariantCaps$() {
  this.Lscalacss_internal_Attrs$fontVariantCaps$__f_attr = null;
  $n_Lscalacss_internal_Attrs$fontVariantCaps$ = this;
  this.Lscalacss_internal_Attrs$fontVariantCaps$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("font-variant-caps")
}
$c_Lscalacss_internal_Attrs$fontVariantCaps$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$fontVariantCaps$.prototype.constructor = $c_Lscalacss_internal_Attrs$fontVariantCaps$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$fontVariantCaps$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$fontVariantCaps$.prototype = $c_Lscalacss_internal_Attrs$fontVariantCaps$.prototype;
$c_Lscalacss_internal_Attrs$fontVariantCaps$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$fontVariantCaps$__f_attr
});
var $d_Lscalacss_internal_Attrs$fontVariantCaps$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$fontVariantCaps$: 0
}, false, "scalacss.internal.Attrs$fontVariantCaps$", {
  Lscalacss_internal_Attrs$fontVariantCaps$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$fontVariantCaps$.prototype.$classData = $d_Lscalacss_internal_Attrs$fontVariantCaps$;
var $n_Lscalacss_internal_Attrs$fontVariantCaps$;
function $m_Lscalacss_internal_Attrs$fontVariantCaps$() {
  if ((!$n_Lscalacss_internal_Attrs$fontVariantCaps$)) {
    $n_Lscalacss_internal_Attrs$fontVariantCaps$ = new $c_Lscalacss_internal_Attrs$fontVariantCaps$()
  };
  return $n_Lscalacss_internal_Attrs$fontVariantCaps$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$fontVariantPosition$() {
  this.Lscalacss_internal_Attrs$fontVariantPosition$__f_attr = null;
  $n_Lscalacss_internal_Attrs$fontVariantPosition$ = this;
  this.Lscalacss_internal_Attrs$fontVariantPosition$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("font-variant-position")
}
$c_Lscalacss_internal_Attrs$fontVariantPosition$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$fontVariantPosition$.prototype.constructor = $c_Lscalacss_internal_Attrs$fontVariantPosition$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$fontVariantPosition$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$fontVariantPosition$.prototype = $c_Lscalacss_internal_Attrs$fontVariantPosition$.prototype;
$c_Lscalacss_internal_Attrs$fontVariantPosition$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$fontVariantPosition$__f_attr
});
var $d_Lscalacss_internal_Attrs$fontVariantPosition$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$fontVariantPosition$: 0
}, false, "scalacss.internal.Attrs$fontVariantPosition$", {
  Lscalacss_internal_Attrs$fontVariantPosition$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$fontVariantPosition$.prototype.$classData = $d_Lscalacss_internal_Attrs$fontVariantPosition$;
var $n_Lscalacss_internal_Attrs$fontVariantPosition$;
function $m_Lscalacss_internal_Attrs$fontVariantPosition$() {
  if ((!$n_Lscalacss_internal_Attrs$fontVariantPosition$)) {
    $n_Lscalacss_internal_Attrs$fontVariantPosition$ = new $c_Lscalacss_internal_Attrs$fontVariantPosition$()
  };
  return $n_Lscalacss_internal_Attrs$fontVariantPosition$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$fontWeight$() {
  this.Lscalacss_internal_Attrs$fontWeight$__f_attr = null;
  $n_Lscalacss_internal_Attrs$fontWeight$ = this;
  this.Lscalacss_internal_Attrs$fontWeight$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("font-weight")
}
$c_Lscalacss_internal_Attrs$fontWeight$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$fontWeight$.prototype.constructor = $c_Lscalacss_internal_Attrs$fontWeight$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$fontWeight$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$fontWeight$.prototype = $c_Lscalacss_internal_Attrs$fontWeight$.prototype;
$c_Lscalacss_internal_Attrs$fontWeight$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$fontWeight$__f_attr
});
var $d_Lscalacss_internal_Attrs$fontWeight$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$fontWeight$: 0
}, false, "scalacss.internal.Attrs$fontWeight$", {
  Lscalacss_internal_Attrs$fontWeight$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$fontWeight$.prototype.$classData = $d_Lscalacss_internal_Attrs$fontWeight$;
var $n_Lscalacss_internal_Attrs$fontWeight$;
function $m_Lscalacss_internal_Attrs$fontWeight$() {
  if ((!$n_Lscalacss_internal_Attrs$fontWeight$)) {
    $n_Lscalacss_internal_Attrs$fontWeight$ = new $c_Lscalacss_internal_Attrs$fontWeight$()
  };
  return $n_Lscalacss_internal_Attrs$fontWeight$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$gridTemplateAreas$() {
  this.Lscalacss_internal_Attrs$gridTemplateAreas$__f_attr = null;
  $n_Lscalacss_internal_Attrs$gridTemplateAreas$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_grid;
  this.Lscalacss_internal_Attrs$gridTemplateAreas$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("grid-template-areas", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$gridTemplateAreas$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$gridTemplateAreas$.prototype.constructor = $c_Lscalacss_internal_Attrs$gridTemplateAreas$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$gridTemplateAreas$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$gridTemplateAreas$.prototype = $c_Lscalacss_internal_Attrs$gridTemplateAreas$.prototype;
$c_Lscalacss_internal_Attrs$gridTemplateAreas$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$gridTemplateAreas$__f_attr
});
var $d_Lscalacss_internal_Attrs$gridTemplateAreas$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$gridTemplateAreas$: 0
}, false, "scalacss.internal.Attrs$gridTemplateAreas$", {
  Lscalacss_internal_Attrs$gridTemplateAreas$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$gridTemplateAreas$.prototype.$classData = $d_Lscalacss_internal_Attrs$gridTemplateAreas$;
var $n_Lscalacss_internal_Attrs$gridTemplateAreas$;
function $m_Lscalacss_internal_Attrs$gridTemplateAreas$() {
  if ((!$n_Lscalacss_internal_Attrs$gridTemplateAreas$)) {
    $n_Lscalacss_internal_Attrs$gridTemplateAreas$ = new $c_Lscalacss_internal_Attrs$gridTemplateAreas$()
  };
  return $n_Lscalacss_internal_Attrs$gridTemplateAreas$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$justifyContent$() {
  this.Lscalacss_internal_Attrs$justifyContent$__f_attr = null;
  $n_Lscalacss_internal_Attrs$justifyContent$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  this.Lscalacss_internal_Attrs$justifyContent$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("justify-content", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$justifyContent$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$justifyContent$.prototype.constructor = $c_Lscalacss_internal_Attrs$justifyContent$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$justifyContent$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$justifyContent$.prototype = $c_Lscalacss_internal_Attrs$justifyContent$.prototype;
$c_Lscalacss_internal_Attrs$justifyContent$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$justifyContent$__f_attr
});
var $d_Lscalacss_internal_Attrs$justifyContent$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$justifyContent$: 0
}, false, "scalacss.internal.Attrs$justifyContent$", {
  Lscalacss_internal_Attrs$justifyContent$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$justifyContent$.prototype.$classData = $d_Lscalacss_internal_Attrs$justifyContent$;
var $n_Lscalacss_internal_Attrs$justifyContent$;
function $m_Lscalacss_internal_Attrs$justifyContent$() {
  if ((!$n_Lscalacss_internal_Attrs$justifyContent$)) {
    $n_Lscalacss_internal_Attrs$justifyContent$ = new $c_Lscalacss_internal_Attrs$justifyContent$()
  };
  return $n_Lscalacss_internal_Attrs$justifyContent$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$objectFit$() {
  this.Lscalacss_internal_Attrs$objectFit$__f_attr = null;
  $n_Lscalacss_internal_Attrs$objectFit$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().objectFit__sci_Map();
  this.Lscalacss_internal_Attrs$objectFit$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("object-fit", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$objectFit$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$objectFit$.prototype.constructor = $c_Lscalacss_internal_Attrs$objectFit$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$objectFit$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$objectFit$.prototype = $c_Lscalacss_internal_Attrs$objectFit$.prototype;
$c_Lscalacss_internal_Attrs$objectFit$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$objectFit$__f_attr
});
var $d_Lscalacss_internal_Attrs$objectFit$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$objectFit$: 0
}, false, "scalacss.internal.Attrs$objectFit$", {
  Lscalacss_internal_Attrs$objectFit$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$objectFit$.prototype.$classData = $d_Lscalacss_internal_Attrs$objectFit$;
var $n_Lscalacss_internal_Attrs$objectFit$;
function $m_Lscalacss_internal_Attrs$objectFit$() {
  if ((!$n_Lscalacss_internal_Attrs$objectFit$)) {
    $n_Lscalacss_internal_Attrs$objectFit$ = new $c_Lscalacss_internal_Attrs$objectFit$()
  };
  return $n_Lscalacss_internal_Attrs$objectFit$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$overflow$() {
  this.Lscalacss_internal_Attrs$overflow$__f_attr = null;
  $n_Lscalacss_internal_Attrs$overflow$ = this;
  this.Lscalacss_internal_Attrs$overflow$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("overflow")
}
$c_Lscalacss_internal_Attrs$overflow$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$overflow$.prototype.constructor = $c_Lscalacss_internal_Attrs$overflow$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$overflow$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$overflow$.prototype = $c_Lscalacss_internal_Attrs$overflow$.prototype;
$c_Lscalacss_internal_Attrs$overflow$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$overflow$__f_attr
});
var $d_Lscalacss_internal_Attrs$overflow$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$overflow$: 0
}, false, "scalacss.internal.Attrs$overflow$", {
  Lscalacss_internal_Attrs$overflow$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$overflow$.prototype.$classData = $d_Lscalacss_internal_Attrs$overflow$;
var $n_Lscalacss_internal_Attrs$overflow$;
function $m_Lscalacss_internal_Attrs$overflow$() {
  if ((!$n_Lscalacss_internal_Attrs$overflow$)) {
    $n_Lscalacss_internal_Attrs$overflow$ = new $c_Lscalacss_internal_Attrs$overflow$()
  };
  return $n_Lscalacss_internal_Attrs$overflow$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$overflowX$() {
  this.Lscalacss_internal_Attrs$overflowX$__f_attr = null;
  $n_Lscalacss_internal_Attrs$overflowX$ = this;
  this.Lscalacss_internal_Attrs$overflowX$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("overflow-x")
}
$c_Lscalacss_internal_Attrs$overflowX$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$overflowX$.prototype.constructor = $c_Lscalacss_internal_Attrs$overflowX$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$overflowX$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$overflowX$.prototype = $c_Lscalacss_internal_Attrs$overflowX$.prototype;
$c_Lscalacss_internal_Attrs$overflowX$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$overflowX$__f_attr
});
var $d_Lscalacss_internal_Attrs$overflowX$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$overflowX$: 0
}, false, "scalacss.internal.Attrs$overflowX$", {
  Lscalacss_internal_Attrs$overflowX$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$overflowX$.prototype.$classData = $d_Lscalacss_internal_Attrs$overflowX$;
var $n_Lscalacss_internal_Attrs$overflowX$;
function $m_Lscalacss_internal_Attrs$overflowX$() {
  if ((!$n_Lscalacss_internal_Attrs$overflowX$)) {
    $n_Lscalacss_internal_Attrs$overflowX$ = new $c_Lscalacss_internal_Attrs$overflowX$()
  };
  return $n_Lscalacss_internal_Attrs$overflowX$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$overflowY$() {
  this.Lscalacss_internal_Attrs$overflowY$__f_attr = null;
  $n_Lscalacss_internal_Attrs$overflowY$ = this;
  this.Lscalacss_internal_Attrs$overflowY$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("overflow-y")
}
$c_Lscalacss_internal_Attrs$overflowY$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$overflowY$.prototype.constructor = $c_Lscalacss_internal_Attrs$overflowY$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$overflowY$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$overflowY$.prototype = $c_Lscalacss_internal_Attrs$overflowY$.prototype;
$c_Lscalacss_internal_Attrs$overflowY$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$overflowY$__f_attr
});
var $d_Lscalacss_internal_Attrs$overflowY$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$overflowY$: 0
}, false, "scalacss.internal.Attrs$overflowY$", {
  Lscalacss_internal_Attrs$overflowY$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$overflowY$.prototype.$classData = $d_Lscalacss_internal_Attrs$overflowY$;
var $n_Lscalacss_internal_Attrs$overflowY$;
function $m_Lscalacss_internal_Attrs$overflowY$() {
  if ((!$n_Lscalacss_internal_Attrs$overflowY$)) {
    $n_Lscalacss_internal_Attrs$overflowY$ = new $c_Lscalacss_internal_Attrs$overflowY$()
  };
  return $n_Lscalacss_internal_Attrs$overflowY$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$pageBreakBefore$() {
  this.Lscalacss_internal_Attrs$pageBreakBefore$__f_attr = null;
  $n_Lscalacss_internal_Attrs$pageBreakBefore$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().pageBreak__sci_Map();
  this.Lscalacss_internal_Attrs$pageBreakBefore$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("page-break-before", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$pageBreakBefore$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$pageBreakBefore$.prototype.constructor = $c_Lscalacss_internal_Attrs$pageBreakBefore$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$pageBreakBefore$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$pageBreakBefore$.prototype = $c_Lscalacss_internal_Attrs$pageBreakBefore$.prototype;
$c_Lscalacss_internal_Attrs$pageBreakBefore$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$pageBreakBefore$__f_attr
});
var $d_Lscalacss_internal_Attrs$pageBreakBefore$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$pageBreakBefore$: 0
}, false, "scalacss.internal.Attrs$pageBreakBefore$", {
  Lscalacss_internal_Attrs$pageBreakBefore$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$pageBreakBefore$.prototype.$classData = $d_Lscalacss_internal_Attrs$pageBreakBefore$;
var $n_Lscalacss_internal_Attrs$pageBreakBefore$;
function $m_Lscalacss_internal_Attrs$pageBreakBefore$() {
  if ((!$n_Lscalacss_internal_Attrs$pageBreakBefore$)) {
    $n_Lscalacss_internal_Attrs$pageBreakBefore$ = new $c_Lscalacss_internal_Attrs$pageBreakBefore$()
  };
  return $n_Lscalacss_internal_Attrs$pageBreakBefore$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$pageBreakInside$() {
  this.Lscalacss_internal_Attrs$pageBreakInside$__f_attr = null;
  $n_Lscalacss_internal_Attrs$pageBreakInside$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().pageBreak__sci_Map();
  this.Lscalacss_internal_Attrs$pageBreakInside$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("page-break-inside", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$pageBreakInside$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$pageBreakInside$.prototype.constructor = $c_Lscalacss_internal_Attrs$pageBreakInside$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$pageBreakInside$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$pageBreakInside$.prototype = $c_Lscalacss_internal_Attrs$pageBreakInside$.prototype;
$c_Lscalacss_internal_Attrs$pageBreakInside$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$pageBreakInside$__f_attr
});
var $d_Lscalacss_internal_Attrs$pageBreakInside$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$pageBreakInside$: 0
}, false, "scalacss.internal.Attrs$pageBreakInside$", {
  Lscalacss_internal_Attrs$pageBreakInside$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$pageBreakInside$.prototype.$classData = $d_Lscalacss_internal_Attrs$pageBreakInside$;
var $n_Lscalacss_internal_Attrs$pageBreakInside$;
function $m_Lscalacss_internal_Attrs$pageBreakInside$() {
  if ((!$n_Lscalacss_internal_Attrs$pageBreakInside$)) {
    $n_Lscalacss_internal_Attrs$pageBreakInside$ = new $c_Lscalacss_internal_Attrs$pageBreakInside$()
  };
  return $n_Lscalacss_internal_Attrs$pageBreakInside$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$pointerEvents$() {
  this.Lscalacss_internal_Attrs$pointerEvents$__f_attr = null;
  $n_Lscalacss_internal_Attrs$pointerEvents$ = this;
  this.Lscalacss_internal_Attrs$pointerEvents$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("pointer-events")
}
$c_Lscalacss_internal_Attrs$pointerEvents$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$pointerEvents$.prototype.constructor = $c_Lscalacss_internal_Attrs$pointerEvents$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$pointerEvents$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$pointerEvents$.prototype = $c_Lscalacss_internal_Attrs$pointerEvents$.prototype;
$c_Lscalacss_internal_Attrs$pointerEvents$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$pointerEvents$__f_attr
});
var $d_Lscalacss_internal_Attrs$pointerEvents$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$pointerEvents$: 0
}, false, "scalacss.internal.Attrs$pointerEvents$", {
  Lscalacss_internal_Attrs$pointerEvents$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$pointerEvents$.prototype.$classData = $d_Lscalacss_internal_Attrs$pointerEvents$;
var $n_Lscalacss_internal_Attrs$pointerEvents$;
function $m_Lscalacss_internal_Attrs$pointerEvents$() {
  if ((!$n_Lscalacss_internal_Attrs$pointerEvents$)) {
    $n_Lscalacss_internal_Attrs$pointerEvents$ = new $c_Lscalacss_internal_Attrs$pointerEvents$()
  };
  return $n_Lscalacss_internal_Attrs$pointerEvents$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$position$() {
  this.Lscalacss_internal_Attrs$position$__f_attr = null;
  $n_Lscalacss_internal_Attrs$position$ = this;
  this.Lscalacss_internal_Attrs$position$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("position")
}
$c_Lscalacss_internal_Attrs$position$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$position$.prototype.constructor = $c_Lscalacss_internal_Attrs$position$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$position$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$position$.prototype = $c_Lscalacss_internal_Attrs$position$.prototype;
$c_Lscalacss_internal_Attrs$position$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$position$__f_attr
});
var $d_Lscalacss_internal_Attrs$position$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$position$: 0
}, false, "scalacss.internal.Attrs$position$", {
  Lscalacss_internal_Attrs$position$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$position$.prototype.$classData = $d_Lscalacss_internal_Attrs$position$;
var $n_Lscalacss_internal_Attrs$position$;
function $m_Lscalacss_internal_Attrs$position$() {
  if ((!$n_Lscalacss_internal_Attrs$position$)) {
    $n_Lscalacss_internal_Attrs$position$ = new $c_Lscalacss_internal_Attrs$position$()
  };
  return $n_Lscalacss_internal_Attrs$position$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$scrollBehavior$() {
  this.Lscalacss_internal_Attrs$scrollBehavior$__f_attr = null;
  $n_Lscalacss_internal_Attrs$scrollBehavior$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().scrollBehavior__sci_Map();
  this.Lscalacss_internal_Attrs$scrollBehavior$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("scroll-behavior", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$scrollBehavior$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$scrollBehavior$.prototype.constructor = $c_Lscalacss_internal_Attrs$scrollBehavior$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$scrollBehavior$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$scrollBehavior$.prototype = $c_Lscalacss_internal_Attrs$scrollBehavior$.prototype;
$c_Lscalacss_internal_Attrs$scrollBehavior$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$scrollBehavior$__f_attr
});
var $d_Lscalacss_internal_Attrs$scrollBehavior$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$scrollBehavior$: 0
}, false, "scalacss.internal.Attrs$scrollBehavior$", {
  Lscalacss_internal_Attrs$scrollBehavior$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$scrollBehavior$.prototype.$classData = $d_Lscalacss_internal_Attrs$scrollBehavior$;
var $n_Lscalacss_internal_Attrs$scrollBehavior$;
function $m_Lscalacss_internal_Attrs$scrollBehavior$() {
  if ((!$n_Lscalacss_internal_Attrs$scrollBehavior$)) {
    $n_Lscalacss_internal_Attrs$scrollBehavior$ = new $c_Lscalacss_internal_Attrs$scrollBehavior$()
  };
  return $n_Lscalacss_internal_Attrs$scrollBehavior$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$tableLayout$() {
  this.Lscalacss_internal_Attrs$tableLayout$__f_attr = null;
  $n_Lscalacss_internal_Attrs$tableLayout$ = this;
  this.Lscalacss_internal_Attrs$tableLayout$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("table-layout")
}
$c_Lscalacss_internal_Attrs$tableLayout$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$tableLayout$.prototype.constructor = $c_Lscalacss_internal_Attrs$tableLayout$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$tableLayout$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$tableLayout$.prototype = $c_Lscalacss_internal_Attrs$tableLayout$.prototype;
$c_Lscalacss_internal_Attrs$tableLayout$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$tableLayout$__f_attr
});
var $d_Lscalacss_internal_Attrs$tableLayout$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$tableLayout$: 0
}, false, "scalacss.internal.Attrs$tableLayout$", {
  Lscalacss_internal_Attrs$tableLayout$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$tableLayout$.prototype.$classData = $d_Lscalacss_internal_Attrs$tableLayout$;
var $n_Lscalacss_internal_Attrs$tableLayout$;
function $m_Lscalacss_internal_Attrs$tableLayout$() {
  if ((!$n_Lscalacss_internal_Attrs$tableLayout$)) {
    $n_Lscalacss_internal_Attrs$tableLayout$ = new $c_Lscalacss_internal_Attrs$tableLayout$()
  };
  return $n_Lscalacss_internal_Attrs$tableLayout$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$textAlign$() {
  this.Lscalacss_internal_Attrs$textAlign$__f_attr = null;
  $n_Lscalacss_internal_Attrs$textAlign$ = this;
  var $$x4 = $m_Lscalacss_internal_Attr$();
  var $$x3 = $m_Lscalacss_internal_Transform$();
  var $$x2 = $m_Lscalacss_internal_CanIUse$().logicalProps__sci_Map();
  var $$x1 = $m_Lscalacss_internal_Literal$Typed$start$().Lscalacss_internal_Literal__f_value;
  var array = [$m_Lscalacss_internal_Literal$Typed$end$().Lscalacss_internal_Literal__f_value];
  this.Lscalacss_internal_Attrs$textAlign$__f_attr = $n($$x4).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("text-align", $n($n($$x3).values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($$x2, $$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))).$times__Lscalacss_internal_Transform__Lscalacss_internal_Transform($m_Lscalacss_internal_Transform$().values__sci_Map__T__sci_Seq__Lscalacss_internal_Transform($m_Lscalacss_internal_CanIUse$().textJustify__sci_Map(), "justify", $m_sci_Nil$())))
}
$c_Lscalacss_internal_Attrs$textAlign$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$textAlign$.prototype.constructor = $c_Lscalacss_internal_Attrs$textAlign$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$textAlign$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$textAlign$.prototype = $c_Lscalacss_internal_Attrs$textAlign$.prototype;
$c_Lscalacss_internal_Attrs$textAlign$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$textAlign$__f_attr
});
var $d_Lscalacss_internal_Attrs$textAlign$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$textAlign$: 0
}, false, "scalacss.internal.Attrs$textAlign$", {
  Lscalacss_internal_Attrs$textAlign$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$textAlign$.prototype.$classData = $d_Lscalacss_internal_Attrs$textAlign$;
var $n_Lscalacss_internal_Attrs$textAlign$;
function $m_Lscalacss_internal_Attrs$textAlign$() {
  if ((!$n_Lscalacss_internal_Attrs$textAlign$)) {
    $n_Lscalacss_internal_Attrs$textAlign$ = new $c_Lscalacss_internal_Attrs$textAlign$()
  };
  return $n_Lscalacss_internal_Attrs$textAlign$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$textDecorationStyle$() {
  this.Lscalacss_internal_Attrs$textDecorationStyle$__f_attr = null;
  $n_Lscalacss_internal_Attrs$textDecorationStyle$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_textDecoration;
  this.Lscalacss_internal_Attrs$textDecorationStyle$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("text-decoration-style", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$textDecorationStyle$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$textDecorationStyle$.prototype.constructor = $c_Lscalacss_internal_Attrs$textDecorationStyle$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$textDecorationStyle$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$textDecorationStyle$.prototype = $c_Lscalacss_internal_Attrs$textDecorationStyle$.prototype;
$c_Lscalacss_internal_Attrs$textDecorationStyle$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$textDecorationStyle$__f_attr
});
var $d_Lscalacss_internal_Attrs$textDecorationStyle$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$textDecorationStyle$: 0
}, false, "scalacss.internal.Attrs$textDecorationStyle$", {
  Lscalacss_internal_Attrs$textDecorationStyle$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$textDecorationStyle$.prototype.$classData = $d_Lscalacss_internal_Attrs$textDecorationStyle$;
var $n_Lscalacss_internal_Attrs$textDecorationStyle$;
function $m_Lscalacss_internal_Attrs$textDecorationStyle$() {
  if ((!$n_Lscalacss_internal_Attrs$textDecorationStyle$)) {
    $n_Lscalacss_internal_Attrs$textDecorationStyle$ = new $c_Lscalacss_internal_Attrs$textDecorationStyle$()
  };
  return $n_Lscalacss_internal_Attrs$textDecorationStyle$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$transitionTimingFunction$() {
  this.Lscalacss_internal_Attrs$transitionTimingFunction$__f_attr = null;
  $n_Lscalacss_internal_Attrs$transitionTimingFunction$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_transitions;
  this.Lscalacss_internal_Attrs$transitionTimingFunction$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("transition-timing-function", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$transitionTimingFunction$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$transitionTimingFunction$.prototype.constructor = $c_Lscalacss_internal_Attrs$transitionTimingFunction$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$transitionTimingFunction$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$transitionTimingFunction$.prototype = $c_Lscalacss_internal_Attrs$transitionTimingFunction$.prototype;
$c_Lscalacss_internal_Attrs$transitionTimingFunction$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$transitionTimingFunction$__f_attr
});
var $d_Lscalacss_internal_Attrs$transitionTimingFunction$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$transitionTimingFunction$: 0
}, false, "scalacss.internal.Attrs$transitionTimingFunction$", {
  Lscalacss_internal_Attrs$transitionTimingFunction$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$transitionTimingFunction$.prototype.$classData = $d_Lscalacss_internal_Attrs$transitionTimingFunction$;
var $n_Lscalacss_internal_Attrs$transitionTimingFunction$;
function $m_Lscalacss_internal_Attrs$transitionTimingFunction$() {
  if ((!$n_Lscalacss_internal_Attrs$transitionTimingFunction$)) {
    $n_Lscalacss_internal_Attrs$transitionTimingFunction$ = new $c_Lscalacss_internal_Attrs$transitionTimingFunction$()
  };
  return $n_Lscalacss_internal_Attrs$transitionTimingFunction$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$userSelect$() {
  this.Lscalacss_internal_Attrs$userSelect$__f_attr = null;
  $n_Lscalacss_internal_Attrs$userSelect$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().userSelectNone__sci_Map();
  this.Lscalacss_internal_Attrs$userSelect$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("user-select", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$userSelect$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$userSelect$.prototype.constructor = $c_Lscalacss_internal_Attrs$userSelect$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$userSelect$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$userSelect$.prototype = $c_Lscalacss_internal_Attrs$userSelect$.prototype;
$c_Lscalacss_internal_Attrs$userSelect$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$userSelect$__f_attr
});
var $d_Lscalacss_internal_Attrs$userSelect$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$userSelect$: 0
}, false, "scalacss.internal.Attrs$userSelect$", {
  Lscalacss_internal_Attrs$userSelect$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$userSelect$.prototype.$classData = $d_Lscalacss_internal_Attrs$userSelect$;
var $n_Lscalacss_internal_Attrs$userSelect$;
function $m_Lscalacss_internal_Attrs$userSelect$() {
  if ((!$n_Lscalacss_internal_Attrs$userSelect$)) {
    $n_Lscalacss_internal_Attrs$userSelect$ = new $c_Lscalacss_internal_Attrs$userSelect$()
  };
  return $n_Lscalacss_internal_Attrs$userSelect$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$visibility$() {
  this.Lscalacss_internal_Attrs$visibility$__f_attr = null;
  $n_Lscalacss_internal_Attrs$visibility$ = this;
  this.Lscalacss_internal_Attrs$visibility$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("visibility")
}
$c_Lscalacss_internal_Attrs$visibility$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$visibility$.prototype.constructor = $c_Lscalacss_internal_Attrs$visibility$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$visibility$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$visibility$.prototype = $c_Lscalacss_internal_Attrs$visibility$.prototype;
$c_Lscalacss_internal_Attrs$visibility$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$visibility$__f_attr
});
var $d_Lscalacss_internal_Attrs$visibility$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$visibility$: 0
}, false, "scalacss.internal.Attrs$visibility$", {
  Lscalacss_internal_Attrs$visibility$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$visibility$.prototype.$classData = $d_Lscalacss_internal_Attrs$visibility$;
var $n_Lscalacss_internal_Attrs$visibility$;
function $m_Lscalacss_internal_Attrs$visibility$() {
  if ((!$n_Lscalacss_internal_Attrs$visibility$)) {
    $n_Lscalacss_internal_Attrs$visibility$ = new $c_Lscalacss_internal_Attrs$visibility$()
  };
  return $n_Lscalacss_internal_Attrs$visibility$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$whiteSpace$() {
  this.Lscalacss_internal_Attrs$whiteSpace$__f_attr = null;
  $n_Lscalacss_internal_Attrs$whiteSpace$ = this;
  this.Lscalacss_internal_Attrs$whiteSpace$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("white-space")
}
$c_Lscalacss_internal_Attrs$whiteSpace$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$whiteSpace$.prototype.constructor = $c_Lscalacss_internal_Attrs$whiteSpace$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$whiteSpace$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$whiteSpace$.prototype = $c_Lscalacss_internal_Attrs$whiteSpace$.prototype;
$c_Lscalacss_internal_Attrs$whiteSpace$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$whiteSpace$__f_attr
});
var $d_Lscalacss_internal_Attrs$whiteSpace$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$whiteSpace$: 0
}, false, "scalacss.internal.Attrs$whiteSpace$", {
  Lscalacss_internal_Attrs$whiteSpace$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$whiteSpace$.prototype.$classData = $d_Lscalacss_internal_Attrs$whiteSpace$;
var $n_Lscalacss_internal_Attrs$whiteSpace$;
function $m_Lscalacss_internal_Attrs$whiteSpace$() {
  if ((!$n_Lscalacss_internal_Attrs$whiteSpace$)) {
    $n_Lscalacss_internal_Attrs$whiteSpace$ = new $c_Lscalacss_internal_Attrs$whiteSpace$()
  };
  return $n_Lscalacss_internal_Attrs$whiteSpace$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$wordBreak$() {
  this.Lscalacss_internal_Attrs$wordBreak$__f_attr = null;
  $n_Lscalacss_internal_Attrs$wordBreak$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().wordBreak__sci_Map();
  this.Lscalacss_internal_Attrs$wordBreak$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("word-break", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$wordBreak$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$wordBreak$.prototype.constructor = $c_Lscalacss_internal_Attrs$wordBreak$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$wordBreak$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$wordBreak$.prototype = $c_Lscalacss_internal_Attrs$wordBreak$.prototype;
$c_Lscalacss_internal_Attrs$wordBreak$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$wordBreak$__f_attr
});
var $d_Lscalacss_internal_Attrs$wordBreak$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$wordBreak$: 0
}, false, "scalacss.internal.Attrs$wordBreak$", {
  Lscalacss_internal_Attrs$wordBreak$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$wordBreak$.prototype.$classData = $d_Lscalacss_internal_Attrs$wordBreak$;
var $n_Lscalacss_internal_Attrs$wordBreak$;
function $m_Lscalacss_internal_Attrs$wordBreak$() {
  if ((!$n_Lscalacss_internal_Attrs$wordBreak$)) {
    $n_Lscalacss_internal_Attrs$wordBreak$ = new $c_Lscalacss_internal_Attrs$wordBreak$()
  };
  return $n_Lscalacss_internal_Attrs$wordBreak$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$wordWrap$() {
  this.Lscalacss_internal_Attrs$wordWrap$__f_attr = null;
  $n_Lscalacss_internal_Attrs$wordWrap$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().wordwrap__sci_Map();
  this.Lscalacss_internal_Attrs$wordWrap$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("word-wrap", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$wordWrap$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$wordWrap$.prototype.constructor = $c_Lscalacss_internal_Attrs$wordWrap$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$wordWrap$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$wordWrap$.prototype = $c_Lscalacss_internal_Attrs$wordWrap$.prototype;
$c_Lscalacss_internal_Attrs$wordWrap$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$wordWrap$__f_attr
});
var $d_Lscalacss_internal_Attrs$wordWrap$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$wordWrap$: 0
}, false, "scalacss.internal.Attrs$wordWrap$", {
  Lscalacss_internal_Attrs$wordWrap$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$wordWrap$.prototype.$classData = $d_Lscalacss_internal_Attrs$wordWrap$;
var $n_Lscalacss_internal_Attrs$wordWrap$;
function $m_Lscalacss_internal_Attrs$wordWrap$() {
  if ((!$n_Lscalacss_internal_Attrs$wordWrap$)) {
    $n_Lscalacss_internal_Attrs$wordWrap$ = new $c_Lscalacss_internal_Attrs$wordWrap$()
  };
  return $n_Lscalacss_internal_Attrs$wordWrap$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Agent$() {
  this.Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_AndroidUC = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_Chrome = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_Edge = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_Firefox = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_IE = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_IEMobile = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_IOSSafari = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_Opera = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_OperaMini = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_OperaMobile = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_QQBrowser = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_Safari = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_Samsung = null;
  this.Lscalacss_internal_CanIUse$Agent$__f_values = null;
  $n_Lscalacss_internal_CanIUse$Agent$ = this;
  this.Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$webkit$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$webkit$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$moz$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  var $$x1 = $m_Lscalacss_internal_CanIUse$Prefix$webkit$();
  var this$9 = $n($m_s_Predef$().s_Predef$__f_Map);
  var y = $m_Lscalacss_internal_CanIUse$Prefix$webkit$();
  var array = [$ct_T2__O__O__(new $c_T2(), "11.4", y)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lscalacss_internal_CanIUse$Agent$__f_AndroidUC = new $c_Lscalacss_internal_CanIUse$Agent($$x1, this$9.from__sc_IterableOnce__sci_Map(elems));
  this.Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$webkit$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$webkit$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_Chrome = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$webkit$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_Edge = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$ms$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_Firefox = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$moz$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_IE = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$ms$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_IEMobile = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$ms$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_IOSSafari = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$webkit$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  var $$x2 = $m_Lscalacss_internal_CanIUse$Prefix$webkit$();
  var this$23 = $n($m_s_Predef$().s_Predef$__f_Map);
  var y$1 = $m_Lscalacss_internal_CanIUse$Prefix$o$();
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "9,9.5-9.6,10.0-10.1,10.5,10.6,11,11.1,11.5,11.6,12,12.1", y$1)];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lscalacss_internal_CanIUse$Agent$__f_Opera = new $c_Lscalacss_internal_CanIUse$Agent($$x2, this$23.from__sc_IterableOnce__sci_Map(elems$1));
  this.Lscalacss_internal_CanIUse$Agent$__f_OperaMini = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$o$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  var $$x3 = $m_Lscalacss_internal_CanIUse$Prefix$o$();
  var this$30 = $n($m_s_Predef$().s_Predef$__f_Map);
  var y$2 = $m_Lscalacss_internal_CanIUse$Prefix$webkit$();
  var array$2 = [$ct_T2__O__O__(new $c_T2(), "37", y$2)];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lscalacss_internal_CanIUse$Agent$__f_OperaMobile = new $c_Lscalacss_internal_CanIUse$Agent($$x3, this$30.from__sc_IterableOnce__sci_Map(elems$2));
  this.Lscalacss_internal_CanIUse$Agent$__f_QQBrowser = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$webkit$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_Safari = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$webkit$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  this.Lscalacss_internal_CanIUse$Agent$__f_Samsung = new $c_Lscalacss_internal_CanIUse$Agent($m_Lscalacss_internal_CanIUse$Prefix$webkit$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  var h = this.Lscalacss_internal_CanIUse$Agent$__f_AndroidBrowser;
  var array$3 = [this.Lscalacss_internal_CanIUse$Agent$__f_AndroidChrome, this.Lscalacss_internal_CanIUse$Agent$__f_AndroidFirefox, this.Lscalacss_internal_CanIUse$Agent$__f_AndroidUC, this.Lscalacss_internal_CanIUse$Agent$__f_BaiduBrowser, this.Lscalacss_internal_CanIUse$Agent$__f_BlackberryBrowser, this.Lscalacss_internal_CanIUse$Agent$__f_Chrome, this.Lscalacss_internal_CanIUse$Agent$__f_Edge, this.Lscalacss_internal_CanIUse$Agent$__f_Firefox, this.Lscalacss_internal_CanIUse$Agent$__f_IE, this.Lscalacss_internal_CanIUse$Agent$__f_IEMobile, this.Lscalacss_internal_CanIUse$Agent$__f_IOSSafari, this.Lscalacss_internal_CanIUse$Agent$__f_Opera, this.Lscalacss_internal_CanIUse$Agent$__f_OperaMini, this.Lscalacss_internal_CanIUse$Agent$__f_OperaMobile, this.Lscalacss_internal_CanIUse$Agent$__f_QQBrowser, this.Lscalacss_internal_CanIUse$Agent$__f_Safari, this.Lscalacss_internal_CanIUse$Agent$__f_Samsung];
  var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var t$1 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t);
  this.Lscalacss_internal_CanIUse$Agent$__f_values = new $c_Lscalacss_internal_NonEmptyVector(h, t$1)
}
$c_Lscalacss_internal_CanIUse$Agent$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Agent$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Agent$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Agent$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Agent$.prototype = $c_Lscalacss_internal_CanIUse$Agent$.prototype;
var $d_Lscalacss_internal_CanIUse$Agent$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Agent$: 0
}, false, "scalacss.internal.CanIUse$Agent$", {
  Lscalacss_internal_CanIUse$Agent$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Agent$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Agent$;
var $n_Lscalacss_internal_CanIUse$Agent$;
function $m_Lscalacss_internal_CanIUse$Agent$() {
  if ((!$n_Lscalacss_internal_CanIUse$Agent$)) {
    $n_Lscalacss_internal_CanIUse$Agent$ = new $c_Lscalacss_internal_CanIUse$Agent$()
  };
  return $n_Lscalacss_internal_CanIUse$Agent$
}
function $p_Lscalacss_internal_Compose$__safe$lzycompute__Lscalacss_internal_Compose($thiz) {
  if (((((1 & $thiz.Lscalacss_internal_Compose$__f_bitmap$0) << 24) >> 24) === 0)) {
    var m = $m_Lscalacss_internal_Compose$Rules$().append__F2();
    var w = $m_Lscalacss_internal_Compose$Rules$().warn__F2();
    $thiz.Lscalacss_internal_Compose$__f_safe = new $c_Lscalacss_internal_Compose(new $c_Lscalacss_internal_Compose$Rules$$anon$1(m, w));
    $thiz.Lscalacss_internal_Compose$__f_bitmap$0 = (((1 | $thiz.Lscalacss_internal_Compose$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscalacss_internal_Compose$__f_safe
}
/** @constructor */
function $c_Lscalacss_internal_Compose$() {
  this.Lscalacss_internal_Compose$__f_safe = null;
  this.Lscalacss_internal_Compose$__f_bitmap$0 = 0
}
$c_Lscalacss_internal_Compose$.prototype = new $h_O();
$c_Lscalacss_internal_Compose$.prototype.constructor = $c_Lscalacss_internal_Compose$;
/** @constructor */
function $h_Lscalacss_internal_Compose$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Compose$.prototype = $c_Lscalacss_internal_Compose$.prototype;
$c_Lscalacss_internal_Compose$.prototype.safe__Lscalacss_internal_Compose = (function() {
  return (((((1 & this.Lscalacss_internal_Compose$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscalacss_internal_Compose$__safe$lzycompute__Lscalacss_internal_Compose(this) : this.Lscalacss_internal_Compose$__f_safe)
});
var $d_Lscalacss_internal_Compose$ = new $TypeData().initClass({
  Lscalacss_internal_Compose$: 0
}, false, "scalacss.internal.Compose$", {
  Lscalacss_internal_Compose$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Compose$.prototype.$classData = $d_Lscalacss_internal_Compose$;
var $n_Lscalacss_internal_Compose$;
function $m_Lscalacss_internal_Compose$() {
  if ((!$n_Lscalacss_internal_Compose$)) {
    $n_Lscalacss_internal_Compose$ = new $c_Lscalacss_internal_Compose$()
  };
  return $n_Lscalacss_internal_Compose$
}
/** @constructor */
function $c_Lscalacss_internal_Compose$Rules$$anon$1(m$1, w$1) {
  this.Lscalacss_internal_Compose$Rules$$anon$1__f_m$1 = null;
  this.Lscalacss_internal_Compose$Rules$$anon$1__f_w$1 = null;
  this.Lscalacss_internal_Compose$Rules$$anon$1__f_m$1 = m$1;
  this.Lscalacss_internal_Compose$Rules$$anon$1__f_w$1 = w$1
}
$c_Lscalacss_internal_Compose$Rules$$anon$1.prototype = new $h_O();
$c_Lscalacss_internal_Compose$Rules$$anon$1.prototype.constructor = $c_Lscalacss_internal_Compose$Rules$$anon$1;
/** @constructor */
function $h_Lscalacss_internal_Compose$Rules$$anon$1() {
  /*<skip>*/
}
$h_Lscalacss_internal_Compose$Rules$$anon$1.prototype = $c_Lscalacss_internal_Compose$Rules$$anon$1.prototype;
$c_Lscalacss_internal_Compose$Rules$$anon$1.prototype.mergeAVs__Lscalacss_internal_AVs__Lscalacss_internal_AVs__T2 = (function(lo, hi) {
  return $ct_T2__O__O__(new $c_T2(), $n(this.Lscalacss_internal_Compose$Rules$$anon$1__f_m$1).apply__O__O__O(lo, hi), $n(this.Lscalacss_internal_Compose$Rules$$anon$1__f_w$1).apply__O__O__O(lo, hi))
});
var $d_Lscalacss_internal_Compose$Rules$$anon$1 = new $TypeData().initClass({
  Lscalacss_internal_Compose$Rules$$anon$1: 0
}, false, "scalacss.internal.Compose$Rules$$anon$1", {
  Lscalacss_internal_Compose$Rules$$anon$1: 1,
  O: 1,
  Lscalacss_internal_Compose$Rules: 1
});
$c_Lscalacss_internal_Compose$Rules$$anon$1.prototype.$classData = $d_Lscalacss_internal_Compose$Rules$$anon$1;
/** @constructor */
function $c_Lscalacss_internal_Cond$() {
  this.Lscalacss_internal_Cond$__f_empty = null;
  this.Lscalacss_internal_Cond$__f_ordering = null;
  $n_Lscalacss_internal_Cond$ = this;
  this.Lscalacss_internal_Cond$__f_empty = new $c_Lscalacss_internal_Cond($m_s_None$(), ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()));
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_Lscalacss_internal_Cond(x$8$2);
    return $n(x$8).toString__T()
  }));
  var ord = $m_Lscalacss_internal_NaturalOrdering$();
  this.Lscalacss_internal_Cond$__f_ordering = new $c_s_math_Ordering$$anon$5(ord, f)
}
$c_Lscalacss_internal_Cond$.prototype = new $h_O();
$c_Lscalacss_internal_Cond$.prototype.constructor = $c_Lscalacss_internal_Cond$;
/** @constructor */
function $h_Lscalacss_internal_Cond$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Cond$.prototype = $c_Lscalacss_internal_Cond$.prototype;
var $d_Lscalacss_internal_Cond$ = new $TypeData().initClass({
  Lscalacss_internal_Cond$: 0
}, false, "scalacss.internal.Cond$", {
  Lscalacss_internal_Cond$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Cond$.prototype.$classData = $d_Lscalacss_internal_Cond$;
var $n_Lscalacss_internal_Cond$;
function $m_Lscalacss_internal_Cond$() {
  if ((!$n_Lscalacss_internal_Cond$)) {
    $n_Lscalacss_internal_Cond$ = new $c_Lscalacss_internal_Cond$()
  };
  return $n_Lscalacss_internal_Cond$
}
/** @constructor */
function $c_Lscalacss_internal_CssKV$() {
  this.Lscalacss_internal_CssKV$__f_key = null;
  this.Lscalacss_internal_CssKV$__f_value = null;
  $n_Lscalacss_internal_CssKV$ = this;
  this.Lscalacss_internal_CssKV$__f_key = new $c_Lscalacss_internal_CssKV$Lens(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lscalacss_internal_CssKV(x$1$2);
    return $n(x$1).Lscalacss_internal_CssKV__f_key
  })), new $c_sjsr_AnonFunction2(((a$2, b$2) => {
    var a = $as_Lscalacss_internal_CssKV(a$2);
    var b = $as_T(b$2);
    return new $c_Lscalacss_internal_CssKV(b, $n(a).Lscalacss_internal_CssKV__f_value)
  })));
  this.Lscalacss_internal_CssKV$__f_value = new $c_Lscalacss_internal_CssKV$Lens(new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lscalacss_internal_CssKV(x$2$2);
    return $n(x$2).Lscalacss_internal_CssKV__f_value
  })), new $c_sjsr_AnonFunction2(((a$3$2, b$3$2) => {
    var a$3 = $as_Lscalacss_internal_CssKV(a$3$2);
    var b$3 = $as_T(b$3$2);
    return new $c_Lscalacss_internal_CssKV($n(a$3).Lscalacss_internal_CssKV__f_key, b$3)
  })))
}
$c_Lscalacss_internal_CssKV$.prototype = new $h_O();
$c_Lscalacss_internal_CssKV$.prototype.constructor = $c_Lscalacss_internal_CssKV$;
/** @constructor */
function $h_Lscalacss_internal_CssKV$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CssKV$.prototype = $c_Lscalacss_internal_CssKV$.prototype;
var $d_Lscalacss_internal_CssKV$ = new $TypeData().initClass({
  Lscalacss_internal_CssKV$: 0
}, false, "scalacss.internal.CssKV$", {
  Lscalacss_internal_CssKV$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CssKV$.prototype.$classData = $d_Lscalacss_internal_CssKV$;
var $n_Lscalacss_internal_CssKV$;
function $m_Lscalacss_internal_CssKV$() {
  if ((!$n_Lscalacss_internal_CssKV$)) {
    $n_Lscalacss_internal_CssKV$ = new $c_Lscalacss_internal_CssKV$()
  };
  return $n_Lscalacss_internal_CssKV$
}
/** @constructor */
function $c_Lscalacss_internal_Domain$OverSeq(as) {
  this.Lscalacss_internal_Domain$OverSeq__f_as = null;
  this.Lscalacss_internal_Domain$OverSeq__f_size = 0;
  this.Lscalacss_internal_Domain$OverSeq__f_as = as;
  this.Lscalacss_internal_Domain$OverSeq__f_size = $n(as).length__I()
}
$c_Lscalacss_internal_Domain$OverSeq.prototype = new $h_O();
$c_Lscalacss_internal_Domain$OverSeq.prototype.constructor = $c_Lscalacss_internal_Domain$OverSeq;
/** @constructor */
function $h_Lscalacss_internal_Domain$OverSeq() {
  /*<skip>*/
}
$h_Lscalacss_internal_Domain$OverSeq.prototype = $c_Lscalacss_internal_Domain$OverSeq.prototype;
$c_Lscalacss_internal_Domain$OverSeq.prototype.size__I = (function() {
  return this.Lscalacss_internal_Domain$OverSeq__f_size
});
$c_Lscalacss_internal_Domain$OverSeq.prototype.apply__I__O = (function(i) {
  return $n(this.Lscalacss_internal_Domain$OverSeq__f_as).apply__I__O(i)
});
var $d_Lscalacss_internal_Domain$OverSeq = new $TypeData().initClass({
  Lscalacss_internal_Domain$OverSeq: 0
}, false, "scalacss.internal.Domain$OverSeq", {
  Lscalacss_internal_Domain$OverSeq: 1,
  O: 1,
  Lscalacss_internal_Domain: 1
});
$c_Lscalacss_internal_Domain$OverSeq.prototype.$classData = $d_Lscalacss_internal_Domain$OverSeq;
/** @constructor */
function $c_Lscalacss_internal_Domain$Pair(a, b) {
  this.Lscalacss_internal_Domain$Pair__f_a = null;
  this.Lscalacss_internal_Domain$Pair__f_b = null;
  this.Lscalacss_internal_Domain$Pair__f_as = 0;
  this.Lscalacss_internal_Domain$Pair__f_size = 0;
  this.Lscalacss_internal_Domain$Pair__f_a = a;
  this.Lscalacss_internal_Domain$Pair__f_b = b;
  this.Lscalacss_internal_Domain$Pair__f_as = $n(a).size__I();
  this.Lscalacss_internal_Domain$Pair__f_size = Math.imul(this.Lscalacss_internal_Domain$Pair__f_as, $n(b).size__I())
}
$c_Lscalacss_internal_Domain$Pair.prototype = new $h_O();
$c_Lscalacss_internal_Domain$Pair.prototype.constructor = $c_Lscalacss_internal_Domain$Pair;
/** @constructor */
function $h_Lscalacss_internal_Domain$Pair() {
  /*<skip>*/
}
$h_Lscalacss_internal_Domain$Pair.prototype = $c_Lscalacss_internal_Domain$Pair.prototype;
$c_Lscalacss_internal_Domain$Pair.prototype.size__I = (function() {
  return this.Lscalacss_internal_Domain$Pair__f_size
});
$c_Lscalacss_internal_Domain$Pair.prototype.apply__I__T2 = (function(i) {
  return $ct_T2__O__O__(new $c_T2(), $n(this.Lscalacss_internal_Domain$Pair__f_a).apply__I__O($intMod(i, this.Lscalacss_internal_Domain$Pair__f_as)), $n(this.Lscalacss_internal_Domain$Pair__f_b).apply__I__O($intDiv(i, this.Lscalacss_internal_Domain$Pair__f_as)))
});
$c_Lscalacss_internal_Domain$Pair.prototype.apply__I__O = (function(i) {
  return this.apply__I__T2(i)
});
var $d_Lscalacss_internal_Domain$Pair = new $TypeData().initClass({
  Lscalacss_internal_Domain$Pair: 0
}, false, "scalacss.internal.Domain$Pair", {
  Lscalacss_internal_Domain$Pair: 1,
  O: 1,
  Lscalacss_internal_Domain: 1
});
$c_Lscalacss_internal_Domain$Pair.prototype.$classData = $d_Lscalacss_internal_Domain$Pair;
/** @constructor */
function $c_Lscalacss_internal_DslBase$MediaQueryNeedType(f) {
  this.Lscalacss_internal_DslBase$MediaQueryNeedType__f_f = null;
  this.Lscalacss_internal_DslBase$MediaQueryNeedType__f_f = f
}
$c_Lscalacss_internal_DslBase$MediaQueryNeedType.prototype = new $h_O();
$c_Lscalacss_internal_DslBase$MediaQueryNeedType.prototype.constructor = $c_Lscalacss_internal_DslBase$MediaQueryNeedType;
/** @constructor */
function $h_Lscalacss_internal_DslBase$MediaQueryNeedType() {
  /*<skip>*/
}
$h_Lscalacss_internal_DslBase$MediaQueryNeedType.prototype = $c_Lscalacss_internal_DslBase$MediaQueryNeedType.prototype;
$c_Lscalacss_internal_DslBase$MediaQueryNeedType.prototype.T__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((t$2) => {
    var t = $as_Lscalacss_internal_Media$TypeA(t$2);
    $n($m_s_package$().s_package$__f_Left);
    var value = $n(this.Lscalacss_internal_DslBase$MediaQueryNeedType__f_f).apply__O__O(t);
    return new $c_Lscalacss_internal_Media$Query(new $c_s_util_Left(value), ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()))
  }))
});
var $d_Lscalacss_internal_DslBase$MediaQueryNeedType = new $TypeData().initClass({
  Lscalacss_internal_DslBase$MediaQueryNeedType: 0
}, false, "scalacss.internal.DslBase$MediaQueryNeedType", {
  Lscalacss_internal_DslBase$MediaQueryNeedType: 1,
  O: 1,
  Lscalacss_internal_Media$TypeAOps: 1
});
$c_Lscalacss_internal_DslBase$MediaQueryNeedType.prototype.$classData = $d_Lscalacss_internal_DslBase$MediaQueryNeedType;
/** @constructor */
function $c_Lscalacss_internal_Env$() {
  this.Lscalacss_internal_Env$__f_empty = null;
  $n_Lscalacss_internal_Env$ = this;
  var e = $m_s_None$();
  var $$x1 = new $c_Lscalacss_internal_Env$Platform(e, e, e, e, e, e, e, e);
  var e$1 = $m_s_None$();
  this.Lscalacss_internal_Env$__f_empty = new $c_Lscalacss_internal_Env($$x1, new $c_Lscalacss_internal_Env$Media(e$1, e$1, e$1, e$1, e$1, e$1, e$1, e$1, e$1, e$1, e$1, e$1, e$1))
}
$c_Lscalacss_internal_Env$.prototype = new $h_O();
$c_Lscalacss_internal_Env$.prototype.constructor = $c_Lscalacss_internal_Env$;
/** @constructor */
function $h_Lscalacss_internal_Env$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Env$.prototype = $c_Lscalacss_internal_Env$.prototype;
var $d_Lscalacss_internal_Env$ = new $TypeData().initClass({
  Lscalacss_internal_Env$: 0
}, false, "scalacss.internal.Env$", {
  Lscalacss_internal_Env$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Env$.prototype.$classData = $d_Lscalacss_internal_Env$;
var $n_Lscalacss_internal_Env$;
function $m_Lscalacss_internal_Env$() {
  if ((!$n_Lscalacss_internal_Env$)) {
    $n_Lscalacss_internal_Env$ = new $c_Lscalacss_internal_Env$()
  };
  return $n_Lscalacss_internal_Env$
}
/** @constructor */
function $c_Lscalacss_internal_Media$Type() {
  this.Lscalacss_internal_Media$TypeA__f_value = null
}
$c_Lscalacss_internal_Media$Type.prototype = new $h_Lscalacss_internal_Media$TypeA();
$c_Lscalacss_internal_Media$Type.prototype.constructor = $c_Lscalacss_internal_Media$Type;
/** @constructor */
function $h_Lscalacss_internal_Media$Type() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Type.prototype = $c_Lscalacss_internal_Media$Type.prototype;
/** @constructor */
function $c_Lscalacss_internal_Pseudo() {
  /*<skip>*/
}
$c_Lscalacss_internal_Pseudo.prototype = new $h_O();
$c_Lscalacss_internal_Pseudo.prototype.constructor = $c_Lscalacss_internal_Pseudo;
/** @constructor */
function $h_Lscalacss_internal_Pseudo() {
  /*<skip>*/
}
$h_Lscalacss_internal_Pseudo.prototype = $c_Lscalacss_internal_Pseudo.prototype;
$c_Lscalacss_internal_Pseudo.prototype.modSelector__T__T = (function(sel) {
  return (("" + sel) + this.cssValue__T())
});
$c_Lscalacss_internal_Pseudo.prototype.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Pseudo = (function(that) {
  var x1 = $ct_T2__O__O__(new $c_T2(), this, that);
  var a = $as_Lscalacss_internal_Pseudo(x1.T2__f__1);
  var b = $as_Lscalacss_internal_Pseudo(x1.T2__f__2);
  if ((b instanceof $c_Lscalacss_internal_Pseudo$Single)) {
    var x2 = $as_Lscalacss_internal_Pseudo$Single(b);
    if ($n(a).contains__Lscalacss_internal_Pseudo$Single__Z(x2)) {
      return a
    }
  };
  var a$2 = $as_Lscalacss_internal_Pseudo(x1.T2__f__1);
  var b$2 = $as_Lscalacss_internal_Pseudo(x1.T2__f__2);
  if ((a$2 instanceof $c_Lscalacss_internal_Pseudo$Single)) {
    var x3 = $as_Lscalacss_internal_Pseudo$Single(a$2);
    if ($n(b$2).contains__Lscalacss_internal_Pseudo$Single__Z(x3)) {
      return b$2
    }
  };
  var a$3 = $as_Lscalacss_internal_Pseudo(x1.T2__f__1);
  var b$3 = $as_Lscalacss_internal_Pseudo(x1.T2__f__2);
  if ((a$3 instanceof $c_Lscalacss_internal_Pseudo$Single)) {
    var x4 = $as_Lscalacss_internal_Pseudo$Single(a$3);
    if ((b$3 instanceof $c_Lscalacss_internal_Pseudo$Single)) {
      var x5 = $as_Lscalacss_internal_Pseudo$Single(b$3);
      var this$1 = $n($as_sci_SetOps($m_sci_SortedSet$().empty__O__O($m_Lscalacss_internal_Pseudo$().Lscalacss_internal_Pseudo$__f_order)));
      var t = $as_sci_SortedSet(this$1.incl__O__sci_SetOps(x5));
      return new $c_Lscalacss_internal_Pseudo$Composite(x4, t)
    }
  };
  var p = $as_Lscalacss_internal_Pseudo(x1.T2__f__1);
  var p6 = $as_Lscalacss_internal_Pseudo(x1.T2__f__2);
  if ((p instanceof $c_Lscalacss_internal_Pseudo$Single)) {
    var x8 = $as_Lscalacss_internal_Pseudo$Single(p);
    if ((p6 instanceof $c_Lscalacss_internal_Pseudo$Composite)) {
      var x7 = $as_Lscalacss_internal_Pseudo$Composite(p6);
      var h = $n(x7).Lscalacss_internal_Pseudo$Composite__f_h;
      var t$1 = $n(x7).Lscalacss_internal_Pseudo$Composite__f_t;
      var this$3 = $n(t$1);
      var t$2 = $as_sci_SortedSet(this$3.incl__O__sci_SetOps(h));
      return new $c_Lscalacss_internal_Pseudo$Composite(x8, t$2)
    }
  };
  var p9 = $as_Lscalacss_internal_Pseudo(x1.T2__f__1);
  var p$2 = $as_Lscalacss_internal_Pseudo(x1.T2__f__2);
  if ((p9 instanceof $c_Lscalacss_internal_Pseudo$Composite)) {
    var x10 = $as_Lscalacss_internal_Pseudo$Composite(p9);
    var h$2 = $n(x10).Lscalacss_internal_Pseudo$Composite__f_h;
    var t$2$1 = $n(x10).Lscalacss_internal_Pseudo$Composite__f_t;
    if ((p$2 instanceof $c_Lscalacss_internal_Pseudo$Single)) {
      var x11 = $as_Lscalacss_internal_Pseudo$Single(p$2);
      var this$5 = $n(t$2$1);
      var t$3 = $as_sci_SortedSet(this$5.incl__O__sci_SetOps(h$2));
      return new $c_Lscalacss_internal_Pseudo$Composite(x11, t$3)
    }
  };
  var p12 = $as_Lscalacss_internal_Pseudo(x1.T2__f__1);
  var p13 = $as_Lscalacss_internal_Pseudo(x1.T2__f__2);
  if ((p12 instanceof $c_Lscalacss_internal_Pseudo$Composite)) {
    var x14 = $as_Lscalacss_internal_Pseudo$Composite(p12);
    var a$4 = $n(x14).Lscalacss_internal_Pseudo$Composite__f_h;
    var b$4 = $n(x14).Lscalacss_internal_Pseudo$Composite__f_t;
    if ((p13 instanceof $c_Lscalacss_internal_Pseudo$Composite)) {
      var x15 = $as_Lscalacss_internal_Pseudo$Composite(p13);
      var c = $n(x15).Lscalacss_internal_Pseudo$Composite__f_h;
      var d = $n(x15).Lscalacss_internal_Pseudo$Composite__f_t;
      var this$7 = $n(b$4);
      var this$8 = $n($as_sci_SetOps(this$7.concat__sc_IterableOnce__sc_SetOps(d)));
      var t$4 = $as_sci_SortedSet(this$8.incl__O__sci_SetOps(c));
      return new $c_Lscalacss_internal_Pseudo$Composite(a$4, t$4)
    }
  };
  throw new $c_s_MatchError(x1)
});
function $as_Lscalacss_internal_Pseudo(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Pseudo) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Pseudo"))
}
function $isArrayOf_Lscalacss_internal_Pseudo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Pseudo)))
}
function $asArrayOf_Lscalacss_internal_Pseudo(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Pseudo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Pseudo;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_RealAttr(id, gen) {
  this.Lscalacss_internal_Attr__f_id = null;
  this.Lscalacss_internal_Attr__f_gen = null;
  this.Lscalacss_internal_RealAttr__f_real = null;
  $ct_Lscalacss_internal_Attr__T__F1__(this, id, gen);
  var this$4 = $n($m_s_Predef$().s_Predef$__f_Set);
  var array = [this];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lscalacss_internal_RealAttr__f_real = this$4.from__sc_IterableOnce__sci_Set(elems)
}
$c_Lscalacss_internal_RealAttr.prototype = new $h_Lscalacss_internal_Attr();
$c_Lscalacss_internal_RealAttr.prototype.constructor = $c_Lscalacss_internal_RealAttr;
/** @constructor */
function $h_Lscalacss_internal_RealAttr() {
  /*<skip>*/
}
$h_Lscalacss_internal_RealAttr.prototype = $c_Lscalacss_internal_RealAttr.prototype;
$c_Lscalacss_internal_RealAttr.prototype.real__sci_Set = (function() {
  return this.Lscalacss_internal_RealAttr__f_real
});
function $as_Lscalacss_internal_RealAttr(obj) {
  return (((obj instanceof $c_Lscalacss_internal_RealAttr) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.RealAttr"))
}
function $isArrayOf_Lscalacss_internal_RealAttr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_RealAttr)))
}
function $asArrayOf_Lscalacss_internal_RealAttr(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_RealAttr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.RealAttr;", depth))
}
var $d_Lscalacss_internal_RealAttr = new $TypeData().initClass({
  Lscalacss_internal_RealAttr: 0
}, false, "scalacss.internal.RealAttr", {
  Lscalacss_internal_RealAttr: 1,
  Lscalacss_internal_Attr: 1,
  O: 1
});
$c_Lscalacss_internal_RealAttr.prototype.$classData = $d_Lscalacss_internal_RealAttr;
/** @constructor */
function $c_Lscalacss_internal_StringRenderer$Default(format) {
  this.Lscalacss_internal_StringRenderer$Default__f_format = null;
  this.Lscalacss_internal_StringRenderer$Default__f_format = format
}
$c_Lscalacss_internal_StringRenderer$Default.prototype = new $h_O();
$c_Lscalacss_internal_StringRenderer$Default.prototype.constructor = $c_Lscalacss_internal_StringRenderer$Default;
/** @constructor */
function $h_Lscalacss_internal_StringRenderer$Default() {
  /*<skip>*/
}
$h_Lscalacss_internal_StringRenderer$Default.prototype = $c_Lscalacss_internal_StringRenderer$Default.prototype;
$c_Lscalacss_internal_StringRenderer$Default.prototype.apply__sci_Vector__T = (function(css) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var fmt = $as_Lscalacss_internal_StringRenderer$FormatSB($n(this.Lscalacss_internal_StringRenderer$Default__f_format).apply__O__O(sb));
  var x1 = $m_Lscalacss_internal_Css$().separateStylesAndKeyframes__sci_Vector__T3(css);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var styles = $as_sci_Vector($n(x1).T3__f__1);
  var keyframes = $as_sci_List($n(x1).T3__f__2);
  var fontFaces = $as_sci_List($n(x1).T3__f__3);
  var byMQ = $m_Lscalacss_internal_Css$().mapByMediaQuery__sci_Vector__sci_ListMap(styles);
  var this$1 = $n(fontFaces);
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var x$2 = $as_Lscalacss_internal_CssEntry$FontFace(arg1);
    $n(fmt).apply__Lscalacss_internal_CssEntry__V(x$2);
    these = $as_sci_List($n(these).tail__O())
  };
  var this$2 = $n(keyframes);
  var these$1 = this$2;
  while ((!$n(these$1).isEmpty__Z())) {
    var arg1$1 = $n(these$1).head__O();
    var x$3 = $as_Lscalacss_internal_CssEntry$Keyframes(arg1$1);
    $n(fmt).apply__Lscalacss_internal_CssEntry__V(x$3);
    these$1 = $as_sci_List($n(these$1).tail__O())
  };
  var this$3 = $n(byMQ);
  var it = this$3.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var arg1$2 = $n(it).next__O();
    var t = $as_T2(arg1$2);
    if ($n($as_s_Option($n(t)._1__O())).isEmpty__Z()) {
      $n(fmt).apply__s_Option__Lscalacss_internal_NonEmptyVector__V($m_s_None$(), $as_Lscalacss_internal_NonEmptyVector($n(t)._2__O()))
    }
  };
  var this$4 = $n(byMQ);
  var it$1 = this$4.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1$3 = $n(it$1).next__O();
    var t$3 = $as_T2(arg1$3);
    var this$5 = $n($as_s_Option($n(t$3)._1__O()));
    if ((!this$5.isEmpty__Z())) {
      $n(fmt).apply__s_Option__Lscalacss_internal_NonEmptyVector__V($as_s_Option($n(t$3)._1__O()), $as_Lscalacss_internal_NonEmptyVector($n(t$3)._2__O()))
    }
  };
  var this$6 = $n($n(fmt).Lscalacss_internal_StringRenderer$FormatSB__f_done);
  this$6.apply__O();
  return $n(sb.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Lscalacss_internal_StringRenderer$Default.prototype.apply__sci_Vector__O = (function(css) {
  return this.apply__sci_Vector__T(css)
});
var $d_Lscalacss_internal_StringRenderer$Default = new $TypeData().initClass({
  Lscalacss_internal_StringRenderer$Default: 0
}, false, "scalacss.internal.StringRenderer$Default", {
  Lscalacss_internal_StringRenderer$Default: 1,
  O: 1,
  Lscalacss_internal_Renderer: 1
});
$c_Lscalacss_internal_StringRenderer$Default.prototype.$classData = $d_Lscalacss_internal_StringRenderer$Default;
/** @constructor */
function $c_Lscalacss_internal_StringRenderer$Raw(format) {
  this.Lscalacss_internal_StringRenderer$Raw__f_format = null;
  this.Lscalacss_internal_StringRenderer$Raw__f_format = format
}
$c_Lscalacss_internal_StringRenderer$Raw.prototype = new $h_O();
$c_Lscalacss_internal_StringRenderer$Raw.prototype.constructor = $c_Lscalacss_internal_StringRenderer$Raw;
/** @constructor */
function $h_Lscalacss_internal_StringRenderer$Raw() {
  /*<skip>*/
}
$h_Lscalacss_internal_StringRenderer$Raw.prototype = $c_Lscalacss_internal_StringRenderer$Raw.prototype;
$c_Lscalacss_internal_StringRenderer$Raw.prototype.apply__sci_Vector__T = (function(css) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var fmt = $as_Lscalacss_internal_StringRenderer$FormatSB($n(this.Lscalacss_internal_StringRenderer$Raw__f_format).apply__O__O(sb));
  $n(css).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Lscalacss_internal_CssEntry(x$4$2);
    $n(fmt).apply__Lscalacss_internal_CssEntry__V(x$4)
  })));
  return $n(sb.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Lscalacss_internal_StringRenderer$Raw.prototype.apply__sci_Vector__O = (function(css) {
  return this.apply__sci_Vector__T(css)
});
var $d_Lscalacss_internal_StringRenderer$Raw = new $TypeData().initClass({
  Lscalacss_internal_StringRenderer$Raw: 0
}, false, "scalacss.internal.StringRenderer$Raw", {
  Lscalacss_internal_StringRenderer$Raw: 1,
  O: 1,
  Lscalacss_internal_Renderer: 1
});
$c_Lscalacss_internal_StringRenderer$Raw.prototype.$classData = $d_Lscalacss_internal_StringRenderer$Raw;
/** @constructor */
function $c_Lscalacss_internal_Style1() {
  /*<skip>*/
}
$c_Lscalacss_internal_Style1.prototype = new $h_O();
$c_Lscalacss_internal_Style1.prototype.constructor = $c_Lscalacss_internal_Style1;
/** @constructor */
function $h_Lscalacss_internal_Style1() {
  /*<skip>*/
}
$h_Lscalacss_internal_Style1.prototype = $c_Lscalacss_internal_Style1.prototype;
function $p_Lscalacss_internal_StyleLookup$$anon$1__ind__Z__I($thiz, b) {
  return (b ? 1 : 0)
}
/** @constructor */
function $c_Lscalacss_internal_StyleLookup$$anon$1() {
  /*<skip>*/
}
$c_Lscalacss_internal_StyleLookup$$anon$1.prototype = new $h_O();
$c_Lscalacss_internal_StyleLookup$$anon$1.prototype.constructor = $c_Lscalacss_internal_StyleLookup$$anon$1;
/** @constructor */
function $h_Lscalacss_internal_StyleLookup$$anon$1() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleLookup$$anon$1.prototype = $c_Lscalacss_internal_StyleLookup$$anon$1.prototype;
$c_Lscalacss_internal_StyleLookup$$anon$1.prototype.empty__ALscalacss_internal_StyleA = (function() {
  return new ($d_Lscalacss_internal_StyleA.getArrayOf().constr)(2)
});
$c_Lscalacss_internal_StyleLookup$$anon$1.prototype.add__F3 = (function() {
  return new $c_sjsr_AnonFunction3(((t$2, b$2, s$2) => {
    var t = $asArrayOf_Lscalacss_internal_StyleA(t$2, 1);
    var b = $uZ(b$2);
    var s = $as_Lscalacss_internal_StyleA(s$2);
    $n(t).set($p_Lscalacss_internal_StyleLookup$$anon$1__ind__Z__I(this, b), s);
    return t
  }))
});
$c_Lscalacss_internal_StyleLookup$$anon$1.prototype.get__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((array$2) => {
    var array = $asArrayOf_Lscalacss_internal_StyleA(array$2, 1);
    var t = new $c_s_Some($n(array).get($p_Lscalacss_internal_StyleLookup$$anon$1__ind__Z__I(this, true)));
    var f = new $c_s_Some($n(array).get($p_Lscalacss_internal_StyleLookup$$anon$1__ind__Z__I(this, false)));
    return new $c_sjsr_AnonFunction1(((b$2) => {
      var b = $uZ(b$2);
      return (b ? t : f)
    }))
  }))
});
$c_Lscalacss_internal_StyleLookup$$anon$1.prototype.empty__O = (function() {
  return this.empty__ALscalacss_internal_StyleA()
});
var $d_Lscalacss_internal_StyleLookup$$anon$1 = new $TypeData().initClass({
  Lscalacss_internal_StyleLookup$$anon$1: 0
}, false, "scalacss.internal.StyleLookup$$anon$1", {
  Lscalacss_internal_StyleLookup$$anon$1: 1,
  O: 1,
  Lscalacss_internal_StyleLookup: 1
});
$c_Lscalacss_internal_StyleLookup$$anon$1.prototype.$classData = $d_Lscalacss_internal_StyleLookup$$anon$1;
/** @constructor */
function $c_Lscalacss_internal_StyleLookup$$anon$2() {
  /*<skip>*/
}
$c_Lscalacss_internal_StyleLookup$$anon$2.prototype = new $h_O();
$c_Lscalacss_internal_StyleLookup$$anon$2.prototype.constructor = $c_Lscalacss_internal_StyleLookup$$anon$2;
/** @constructor */
function $h_Lscalacss_internal_StyleLookup$$anon$2() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleLookup$$anon$2.prototype = $c_Lscalacss_internal_StyleLookup$$anon$2.prototype;
$c_Lscalacss_internal_StyleLookup$$anon$2.prototype.add__F3 = (function() {
  return new $c_sjsr_AnonFunction3(((x$1$2, x$2$2, x$3$2) => {
    var x$1 = $as_sci_Map(x$1$2);
    var x$3 = $as_Lscalacss_internal_StyleA(x$3$2);
    return $as_sci_Map($n(x$1).updated__O__O__sci_MapOps(x$2$2, x$3))
  }))
});
$c_Lscalacss_internal_StyleLookup$$anon$2.prototype.get__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_sci_Map(x$4$2);
    return new $c_sjsr_AnonFunction1(((key$2) => $n(x$4).get__O__s_Option(key$2)))
  }))
});
$c_Lscalacss_internal_StyleLookup$$anon$2.prototype.empty__O = (function() {
  $n($m_s_Predef$().s_Predef$__f_Map);
  return $m_sci_Map$EmptyMap$()
});
var $d_Lscalacss_internal_StyleLookup$$anon$2 = new $TypeData().initClass({
  Lscalacss_internal_StyleLookup$$anon$2: 0
}, false, "scalacss.internal.StyleLookup$$anon$2", {
  Lscalacss_internal_StyleLookup$$anon$2: 1,
  O: 1,
  Lscalacss_internal_StyleLookup: 1
});
$c_Lscalacss_internal_StyleLookup$$anon$2.prototype.$classData = $d_Lscalacss_internal_StyleLookup$$anon$2;
/** @constructor */
function $c_Lscalacss_internal_StyleS$() {
  this.Lscalacss_internal_StyleS$__f_empty = null;
  $n_Lscalacss_internal_StyleS$ = this;
  this.Lscalacss_internal_StyleS$__f_empty = this.data__sci_SortedMap__Lscalacss_internal_StyleS($as_sci_SortedMap($m_sci_SortedMap$().empty__s_math_Ordering__O($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_ordering)))
}
$c_Lscalacss_internal_StyleS$.prototype = new $h_O();
$c_Lscalacss_internal_StyleS$.prototype.constructor = $c_Lscalacss_internal_StyleS$;
/** @constructor */
function $h_Lscalacss_internal_StyleS$() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleS$.prototype = $c_Lscalacss_internal_StyleS$.prototype;
$c_Lscalacss_internal_StyleS$.prototype.data__sci_SortedMap__Lscalacss_internal_StyleS = (function(d) {
  return new $c_Lscalacss_internal_StyleS(d, ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()), $m_s_None$(), ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()), ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()))
});
$c_Lscalacss_internal_StyleS$.prototype.data1__Lscalacss_internal_Cond__Lscalacss_internal_AVs__Lscalacss_internal_StyleS = (function(c, avs) {
  return this.data__sci_SortedMap__Lscalacss_internal_StyleS($as_sci_SortedMap($n($n(this.Lscalacss_internal_StyleS$__f_empty).Lscalacss_internal_StyleS__f_data).updated__O__O__sci_Map(c, avs)))
});
var $d_Lscalacss_internal_StyleS$ = new $TypeData().initClass({
  Lscalacss_internal_StyleS$: 0
}, false, "scalacss.internal.StyleS$", {
  Lscalacss_internal_StyleS$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_StyleS$.prototype.$classData = $d_Lscalacss_internal_StyleS$;
var $n_Lscalacss_internal_StyleS$;
function $m_Lscalacss_internal_StyleS$() {
  if ((!$n_Lscalacss_internal_StyleS$)) {
    $n_Lscalacss_internal_StyleS$ = new $c_Lscalacss_internal_StyleS$()
  };
  return $n_Lscalacss_internal_StyleS$
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$.prototype = new $h_O();
$c_Lscalacss_internal_ValueT$.prototype.constructor = $c_Lscalacss_internal_ValueT$;
/** @constructor */
function $h_Lscalacss_internal_ValueT$() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$.prototype = $c_Lscalacss_internal_ValueT$.prototype;
$c_Lscalacss_internal_ValueT$.prototype.concat__T__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__T = (function(sep, a, b) {
  return ((("" + $n(a).Lscalacss_internal_ValueT__f_value) + sep) + $n(b).Lscalacss_internal_ValueT__f_value)
});
$c_Lscalacss_internal_ValueT$.prototype.concat__T__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__T = (function(sep, a, b, c) {
  return ((("" + this.concat__T__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__T(sep, a, b)) + sep) + $n(c).Lscalacss_internal_ValueT__f_value)
});
var $d_Lscalacss_internal_ValueT$ = new $TypeData().initClass({
  Lscalacss_internal_ValueT$: 0
}, false, "scalacss.internal.ValueT$", {
  Lscalacss_internal_ValueT$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_ValueT$.prototype.$classData = $d_Lscalacss_internal_ValueT$;
var $n_Lscalacss_internal_ValueT$;
function $m_Lscalacss_internal_ValueT$() {
  if ((!$n_Lscalacss_internal_ValueT$)) {
    $n_Lscalacss_internal_ValueT$ = new $c_Lscalacss_internal_ValueT$()
  };
  return $n_Lscalacss_internal_ValueT$
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$3) {
  this.Lscalacss_internal_ValueT$Rule$$anon$1__f_f$3 = null;
  this.Lscalacss_internal_ValueT$Rule$$anon$1__f_f$3 = f$3
}
$c_Lscalacss_internal_ValueT$Rule$$anon$1.prototype = new $h_Lscalacss_internal_ValueT$Rule();
$c_Lscalacss_internal_ValueT$Rule$$anon$1.prototype.constructor = $c_Lscalacss_internal_ValueT$Rule$$anon$1;
/** @constructor */
function $h_Lscalacss_internal_ValueT$Rule$$anon$1() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$Rule$$anon$1.prototype = $c_Lscalacss_internal_ValueT$Rule$$anon$1.prototype;
$c_Lscalacss_internal_ValueT$Rule$$anon$1.prototype.apply__O__Lscalacss_internal_ValueT = (function(x) {
  return $as_Lscalacss_internal_ValueT($n(this.Lscalacss_internal_ValueT$Rule$$anon$1__f_f$3).apply__O__O(x))
});
var $d_Lscalacss_internal_ValueT$Rule$$anon$1 = new $TypeData().initClass({
  Lscalacss_internal_ValueT$Rule$$anon$1: 0
}, false, "scalacss.internal.ValueT$Rule$$anon$1", {
  Lscalacss_internal_ValueT$Rule$$anon$1: 1,
  Lscalacss_internal_ValueT$Rule: 1,
  O: 1
});
$c_Lscalacss_internal_ValueT$Rule$$anon$1.prototype.$classData = $d_Lscalacss_internal_ValueT$Rule$$anon$1;
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttrT1() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$TypedAttrT1.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_ValueT$TypedAttrT1.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttrT1;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttrT1() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttrT1.prototype = $c_Lscalacss_internal_ValueT$TypedAttrT1.prototype;
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttrT2() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$TypedAttrT2.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_ValueT$TypedAttrT2.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttrT2;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttrT2() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttrT2.prototype = $c_Lscalacss_internal_ValueT$TypedAttrT2.prototype;
function $ct_Lscalacss_internal_ValueT$TypedAttrT3__T__($thiz, sep) {
  $thiz.Lscalacss_internal_ValueT$TypedAttrT3__f_sep = sep;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttrT3() {
  this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep = null
}
$c_Lscalacss_internal_ValueT$TypedAttrT3.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_ValueT$TypedAttrT3.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttrT3;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttrT3() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttrT3.prototype = $c_Lscalacss_internal_ValueT$TypedAttrT3.prototype;
$c_Lscalacss_internal_ValueT$TypedAttrT3.prototype.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV = (function(a, b) {
  var v = $m_Lscalacss_internal_ValueT$().concat__T__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__T(this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep, a, b);
  return new $c_Lscalacss_internal_AV(this.attr__Lscalacss_internal_Attr(), v)
});
$c_Lscalacss_internal_ValueT$TypedAttrT3.prototype.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV = (function(a, b, c) {
  var v = $m_Lscalacss_internal_ValueT$().concat__T__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__T(this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep, a, b, c);
  return new $c_Lscalacss_internal_AV(this.attr__Lscalacss_internal_Attr(), v)
});
function $ct_Lscalacss_internal_ValueT$TypedAttrT4Edges__T__($thiz, sep) {
  $thiz.Lscalacss_internal_ValueT$TypedAttrT4Edges__f_sep = sep;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttrT4Edges() {
  this.Lscalacss_internal_ValueT$TypedAttrT4Edges__f_sep = null
}
$c_Lscalacss_internal_ValueT$TypedAttrT4Edges.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_ValueT$TypedAttrT4Edges.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttrT4Edges;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttrT4Edges() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttrT4Edges.prototype = $c_Lscalacss_internal_ValueT$TypedAttrT4Edges.prototype;
$c_Lscalacss_internal_ValueT$TypedAttrT4Edges.prototype.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV = (function(v, h) {
  var v$1 = $m_Lscalacss_internal_ValueT$().concat__T__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__T(this.Lscalacss_internal_ValueT$TypedAttrT4Edges__f_sep, v, h);
  return new $c_Lscalacss_internal_AV(this.attr__Lscalacss_internal_Attr(), v$1)
});
function $ct_Lscalacss_internal_ValueT$TypedAttrTN__T__($thiz, sep) {
  $thiz.Lscalacss_internal_ValueT$TypedAttrTN__f_sep = sep;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttrTN() {
  this.Lscalacss_internal_ValueT$TypedAttrTN__f_sep = null
}
$c_Lscalacss_internal_ValueT$TypedAttrTN.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_ValueT$TypedAttrTN.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttrTN;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttrTN() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttrTN.prototype = $c_Lscalacss_internal_ValueT$TypedAttrTN.prototype;
$c_Lscalacss_internal_ValueT$TypedAttrTN.prototype.apply__Lscalacss_internal_ValueT__sci_Seq__Lscalacss_internal_AV = (function(v1, vn) {
  var v = $as_T($n(vn).foldLeft__O__F2__O($n(v1).Lscalacss_internal_ValueT__f_value, new $c_sjsr_AnonFunction2(((x$9$2, x$10$2) => {
    var x$9 = $as_T(x$9$2);
    var x$10 = $as_Lscalacss_internal_ValueT(x$10$2);
    return ((("" + x$9) + this.Lscalacss_internal_ValueT$TypedAttrTN__f_sep) + $n(x$10).Lscalacss_internal_ValueT__f_value)
  }))));
  return new $c_Lscalacss_internal_AV(this.attr__Lscalacss_internal_Attr(), v)
});
/** @constructor */
function $c_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy(println) {
  this.Lscalacss_internal_mutable_Register$ErrorHandler$Noisy__f_println = null;
  this.Lscalacss_internal_mutable_Register$ErrorHandler$Noisy__f_println = println
}
$c_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy.prototype = new $h_O();
$c_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy.prototype.constructor = $c_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy;
/** @constructor */
function $h_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy.prototype = $c_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy.prototype;
$c_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy.prototype.warn__s_Some = (function() {
  return new $c_s_Some(new $c_sjsr_AnonFunction2(((cn$2, w$2) => {
    var cn = $as_Lscalacss_internal_ClassName(cn$2);
    var w = $as_Lscalacss_internal_package$Warning(w$2);
    $n(this.Lscalacss_internal_mutable_Register$ErrorHandler$Noisy__f_println).apply__O__O(((("[CSS WARNING] " + $m_Lscalacss_internal_Css$().selector__Lscalacss_internal_ClassName__Lscalacss_internal_Cond__T(cn, $n(w).Lscalacss_internal_package$Warning__f_cond)) + " -- ") + $n(w).Lscalacss_internal_package$Warning__f_msg))
  })))
});
$c_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy.prototype.badInput__Lscalacss_internal_StyleF__O__E = (function(s, i) {
  var this$1 = $n($n(s).Lscalacss_internal_StyleF__f_domain);
  var this$2 = $n($f_Lscalacss_internal_Domain__iterator__sc_Iterator(this$1));
  var legal = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", ",", "");
  var err = (((("[CSS ERROR] Invalid StyleF input: [" + i) + "]. Legal values are {") + legal) + "}.");
  $n(this.Lscalacss_internal_mutable_Register$ErrorHandler$Noisy__f_println).apply__O__O(err);
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), err)
});
var $d_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy = new $TypeData().initClass({
  Lscalacss_internal_mutable_Register$ErrorHandler$Noisy: 0
}, false, "scalacss.internal.mutable.Register$ErrorHandler$Noisy", {
  Lscalacss_internal_mutable_Register$ErrorHandler$Noisy: 1,
  O: 1,
  Lscalacss_internal_mutable_Register$ErrorHandler: 1
});
$c_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy.prototype.$classData = $d_Lscalacss_internal_mutable_Register$ErrorHandler$Noisy;
/** @constructor */
function $c_Lscalacss_internal_mutable_Register$MacroName$Use$() {
  this.Lscalacss_internal_mutable_Register$MacroName$Use$__f_cssIllegal = null;
  $n_Lscalacss_internal_mutable_Register$MacroName$Use$ = this;
  this.Lscalacss_internal_mutable_Register$MacroName$Use$__f_cssIllegal = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[^_a-zA-Z0-9\u00a0-\u00ff-]", $m_sci_Nil$()))
}
$c_Lscalacss_internal_mutable_Register$MacroName$Use$.prototype = new $h_O();
$c_Lscalacss_internal_mutable_Register$MacroName$Use$.prototype.constructor = $c_Lscalacss_internal_mutable_Register$MacroName$Use$;
/** @constructor */
function $h_Lscalacss_internal_mutable_Register$MacroName$Use$() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_Register$MacroName$Use$.prototype = $c_Lscalacss_internal_mutable_Register$MacroName$Use$.prototype;
$c_Lscalacss_internal_mutable_Register$MacroName$Use$.prototype.apply__Lscalacss_internal_ClassNameHint__T__s_Option = (function(cnh, name) {
  var this$1 = $n(name);
  if ((this$1 === "")) {
    return $m_s_None$()
  } else {
    var name2 = $n(this.Lscalacss_internal_mutable_Register$MacroName$Use$__f_cssIllegal).replaceAllIn__jl_CharSequence__T__T(name, "_");
    return new $c_s_Some(new $c_Lscalacss_internal_ClassName((($n(cnh).Lscalacss_internal_ClassNameHint__f_value + "-") + name2)))
  }
});
var $d_Lscalacss_internal_mutable_Register$MacroName$Use$ = new $TypeData().initClass({
  Lscalacss_internal_mutable_Register$MacroName$Use$: 0
}, false, "scalacss.internal.mutable.Register$MacroName$Use$", {
  Lscalacss_internal_mutable_Register$MacroName$Use$: 1,
  O: 1,
  Lscalacss_internal_mutable_Register$MacroName: 1
});
$c_Lscalacss_internal_mutable_Register$MacroName$Use$.prototype.$classData = $d_Lscalacss_internal_mutable_Register$MacroName$Use$;
var $n_Lscalacss_internal_mutable_Register$MacroName$Use$;
function $m_Lscalacss_internal_mutable_Register$MacroName$Use$() {
  if ((!$n_Lscalacss_internal_mutable_Register$MacroName$Use$)) {
    $n_Lscalacss_internal_mutable_Register$MacroName$Use$ = new $c_Lscalacss_internal_mutable_Register$MacroName$Use$()
  };
  return $n_Lscalacss_internal_mutable_Register$MacroName$Use$
}
/** @constructor */
function $c_Lscalacss_internal_mutable_Register$NameGen$IncFmt(fmt, nextInt) {
  this.Lscalacss_internal_mutable_Register$NameGen$IncFmt__f_fmt = null;
  this.Lscalacss_internal_mutable_Register$NameGen$IncFmt__f_nextInt = 0;
  this.Lscalacss_internal_mutable_Register$NameGen$IncFmt__f_fmt = fmt;
  this.Lscalacss_internal_mutable_Register$NameGen$IncFmt__f_nextInt = nextInt
}
$c_Lscalacss_internal_mutable_Register$NameGen$IncFmt.prototype = new $h_O();
$c_Lscalacss_internal_mutable_Register$NameGen$IncFmt.prototype.constructor = $c_Lscalacss_internal_mutable_Register$NameGen$IncFmt;
/** @constructor */
function $h_Lscalacss_internal_mutable_Register$NameGen$IncFmt() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_Register$NameGen$IncFmt.prototype = $c_Lscalacss_internal_mutable_Register$NameGen$IncFmt.prototype;
$c_Lscalacss_internal_mutable_Register$NameGen$IncFmt.prototype.next__Lscalacss_internal_ClassNameHint__T2 = (function(cnh) {
  var format = this.Lscalacss_internal_mutable_Register$NameGen$IncFmt__f_fmt;
  var $$x1 = $n(cnh).Lscalacss_internal_ClassNameHint__f_value;
  var x = this.Lscalacss_internal_mutable_Register$NameGen$IncFmt__f_nextInt;
  var args = new $ac_O([$$x1, x]);
  var cn = new $c_Lscalacss_internal_ClassName($m_jl_String$().format__T__AO__T(format, args));
  var ng = new $c_Lscalacss_internal_mutable_Register$NameGen$IncFmt(this.Lscalacss_internal_mutable_Register$NameGen$IncFmt__f_fmt, ((1 + this.Lscalacss_internal_mutable_Register$NameGen$IncFmt__f_nextInt) | 0));
  return $ct_T2__O__O__(new $c_T2(), cn, ng)
});
var $d_Lscalacss_internal_mutable_Register$NameGen$IncFmt = new $TypeData().initClass({
  Lscalacss_internal_mutable_Register$NameGen$IncFmt: 0
}, false, "scalacss.internal.mutable.Register$NameGen$IncFmt", {
  Lscalacss_internal_mutable_Register$NameGen$IncFmt: 1,
  O: 1,
  Lscalacss_internal_mutable_Register$NameGen: 1
});
$c_Lscalacss_internal_mutable_Register$NameGen$IncFmt.prototype.$classData = $d_Lscalacss_internal_mutable_Register$NameGen$IncFmt;
/** @constructor */
function $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle(outer) {
  if ((outer === null)) {
    $n(null)
  }
}
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle.prototype = new $h_O();
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle.prototype.constructor = $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle;
/** @constructor */
function $h_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle.prototype = $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle.prototype;
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle.prototype.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA = (function(t, c) {
  var s = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c);
  return new $c_Lscalacss_internal_StyleA(new $c_Lscalacss_internal_ClassName("keyframe"), $n(s).Lscalacss_internal_StyleS__f_addClassNames, s)
});
var $d_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle = new $TypeData().initClass({
  Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle: 0
}, false, "scalacss.internal.mutable.StyleSheet$Inline$MKStyle", {
  Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle: 1,
  O: 1,
  Lscalacss_internal_DslMacros$MStyle: 1
});
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle.prototype.$classData = $d_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle;
/** @constructor */
function $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes(outer, name) {
  this.Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes__f_name = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes__f_$outer = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes__f_name = name;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes__f_$outer = outer
  }
}
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes.prototype = new $h_O();
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes.prototype.constructor = $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes;
/** @constructor */
function $h_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes.prototype = $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes.prototype;
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes.prototype.apply__sci_Seq__Lscalacss_internal_Keyframes = (function(frames) {
  return $n($n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes__f_$outer).Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister).registerKeyframes__Lscalacss_internal_Keyframes__Lscalacss_internal_ClassNameHint__Lscalacss_internal_Keyframes(new $c_Lscalacss_internal_Keyframes(new $c_Lscalacss_internal_ClassName(this.Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes__f_name), frames), $n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes__f_$outer).Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint)
});
var $d_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes = new $TypeData().initClass({
  Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes: 0
}, false, "scalacss.internal.mutable.StyleSheet$Inline$MKeyframes", {
  Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes: 1,
  O: 1,
  Lscalacss_internal_DslMacros$MKeyframes: 1
});
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes.prototype.$classData = $d_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes;
/** @constructor */
function $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(outer, name) {
  this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_name = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_$outer = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_name = name;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_$outer = outer
  }
}
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle.prototype = new $h_O();
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle.prototype.constructor = $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle;
/** @constructor */
function $h_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle.prototype = $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle.prototype;
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle.prototype.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA = (function(t, c) {
  var s1 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c);
  var s2 = $n($n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_$outer).Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister).applyMacroName__T__Lscalacss_internal_StyleS__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleS(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_name, s1, $n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_$outer).Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint);
  return $n($n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_$outer).Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister).registerS__Lscalacss_internal_StyleS__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleA(s2, $n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_$outer).Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint)
});
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle.prototype.apply__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA = (function(className, t, c) {
  return $n($n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_$outer).Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister).registerS__Lscalacss_internal_StyleS__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleA($m_Lscalacss_internal_Dsl$().style__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(className, t, c), $n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyle__f_$outer).Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint)
});
var $d_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle = new $TypeData().initClass({
  Lscalacss_internal_mutable_StyleSheet$Inline$MStyle: 0
}, false, "scalacss.internal.mutable.StyleSheet$Inline$MStyle", {
  Lscalacss_internal_mutable_StyleSheet$Inline$MStyle: 1,
  O: 1,
  Lscalacss_internal_DslMacros$MStyle: 1
});
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle.prototype.$classData = $d_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle;
/** @constructor */
function $c_Lscalatags_JsDom$GenericAttr() {
  /*<skip>*/
}
$c_Lscalatags_JsDom$GenericAttr.prototype = new $h_O();
$c_Lscalatags_JsDom$GenericAttr.prototype.constructor = $c_Lscalatags_JsDom$GenericAttr;
/** @constructor */
function $h_Lscalatags_JsDom$GenericAttr() {
  /*<skip>*/
}
$h_Lscalatags_JsDom$GenericAttr.prototype = $c_Lscalatags_JsDom$GenericAttr.prototype;
$c_Lscalatags_JsDom$GenericAttr.prototype.apply__Lorg_scalajs_dom_Element__Lscalatags_generic_Attr__O__V = (function(t, a, v) {
  var x1 = $n(a).Lscalatags_generic_Attr__f_namespace;
  var x = $m_s_None$();
  if ((x === x1)) {
    if ((!$n(a).Lscalatags_generic_Attr__f_raw)) {
      if (($n(a).Lscalatags_generic_Attr__f_name === "class")) {
        $m_sc_ArrayOps$();
        var this$1 = $n($dp_toString__T($n(v)));
        var xs = $f_T__split__T__I__AT(this$1, " ", 0);
        var f = ((cls$2) => {
          var cls = $as_T(cls$2);
          t.classList.add($f_T__trim__T($n(cls)))
        });
        var len = $n(xs).u.length;
        var i = 0;
        if ((xs !== null)) {
          while ((i < len)) {
            var arg1 = $n(xs).get(i);
            f(arg1);
            i = ((1 + i) | 0)
          }
        } else if ((xs instanceof $ac_I)) {
          var x3 = $asArrayOf_I(xs, 1);
          while ((i < len)) {
            var arg1$1 = $n(x3).get(i);
            f(arg1$1);
            i = ((1 + i) | 0)
          }
        } else if ((xs instanceof $ac_D)) {
          var x4 = $asArrayOf_D(xs, 1);
          while ((i < len)) {
            var arg1$2 = $n(x4).get(i);
            f(arg1$2);
            i = ((1 + i) | 0)
          }
        } else if ((xs instanceof $ac_J)) {
          var x5 = $asArrayOf_J(xs, 1);
          while ((i < len)) {
            var t$1 = $n(x5).get(i);
            var lo = t$1.RTLong__f_lo;
            var hi = t$1.RTLong__f_hi;
            f(new $c_RTLong(lo, hi));
            i = ((1 + i) | 0)
          }
        } else if ((xs instanceof $ac_F)) {
          var x6 = $asArrayOf_F(xs, 1);
          while ((i < len)) {
            var arg1$3 = $n(x6).get(i);
            f(arg1$3);
            i = ((1 + i) | 0)
          }
        } else if ((xs instanceof $ac_C)) {
          var x7 = $asArrayOf_C(xs, 1);
          while ((i < len)) {
            var arg1$4 = $n(x7).get(i);
            f($bC(arg1$4));
            i = ((1 + i) | 0)
          }
        } else if ((xs instanceof $ac_B)) {
          var x8 = $asArrayOf_B(xs, 1);
          while ((i < len)) {
            var arg1$5 = $n(x8).get(i);
            f(arg1$5);
            i = ((1 + i) | 0)
          }
        } else if ((xs instanceof $ac_S)) {
          var x9 = $asArrayOf_S(xs, 1);
          while ((i < len)) {
            var arg1$6 = $n(x9).get(i);
            f(arg1$6);
            i = ((1 + i) | 0)
          }
        } else if ((xs instanceof $ac_Z)) {
          var x10 = $asArrayOf_Z(xs, 1);
          while ((i < len)) {
            var arg1$7 = $n(x10).get(i);
            f(arg1$7);
            i = ((1 + i) | 0)
          }
        } else {
          throw new $c_s_MatchError(xs)
        }
      } else {
        t.setAttribute($n(a).Lscalatags_generic_Attr__f_name, $dp_toString__T($n(v)))
      }
    } else {
      var tmpElm = document.createElement("p");
      tmpElm.innerHTML = (((("<p " + $n(a).Lscalatags_generic_Attr__f_name) + "=\"") + $dp_toString__T($n(v))) + "\"><p>");
      var newAttr = tmpElm.children[0].attributes[0].cloneNode(true);
      t.setAttributeNode(newAttr)
    }
  } else if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var namespace = $as_Lscalatags_generic_Namespace($n(x2).s_Some__f_value);
    t.setAttributeNS($n(namespace).uri__T(), $n(a).Lscalatags_generic_Attr__f_name, $dp_toString__T($n(v)))
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lscalatags_JsDom$GenericAttr = new $TypeData().initClass({
  Lscalatags_JsDom$GenericAttr: 0
}, false, "scalatags.JsDom$GenericAttr", {
  Lscalatags_JsDom$GenericAttr: 1,
  O: 1,
  Lscalatags_generic_AttrValue: 1
});
$c_Lscalatags_JsDom$GenericAttr.prototype.$classData = $d_Lscalatags_JsDom$GenericAttr;
/** @constructor */
function $c_Lscalatags_JsDom$GenericPixelStyle(ev) {
  /*<skip>*/
}
$c_Lscalatags_JsDom$GenericPixelStyle.prototype = new $h_O();
$c_Lscalatags_JsDom$GenericPixelStyle.prototype.constructor = $c_Lscalatags_JsDom$GenericPixelStyle;
/** @constructor */
function $h_Lscalatags_JsDom$GenericPixelStyle() {
  /*<skip>*/
}
$h_Lscalatags_JsDom$GenericPixelStyle.prototype = $c_Lscalatags_JsDom$GenericPixelStyle.prototype;
var $d_Lscalatags_JsDom$GenericPixelStyle = new $TypeData().initClass({
  Lscalatags_JsDom$GenericPixelStyle: 0
}, false, "scalatags.JsDom$GenericPixelStyle", {
  Lscalatags_JsDom$GenericPixelStyle: 1,
  O: 1,
  Lscalatags_generic_PixelStyleValue: 1
});
$c_Lscalatags_JsDom$GenericPixelStyle.prototype.$classData = $d_Lscalatags_JsDom$GenericPixelStyle;
/** @constructor */
function $c_Lscalatags_JsDom$GenericPixelStylePx(ev) {
  /*<skip>*/
}
$c_Lscalatags_JsDom$GenericPixelStylePx.prototype = new $h_O();
$c_Lscalatags_JsDom$GenericPixelStylePx.prototype.constructor = $c_Lscalatags_JsDom$GenericPixelStylePx;
/** @constructor */
function $h_Lscalatags_JsDom$GenericPixelStylePx() {
  /*<skip>*/
}
$h_Lscalatags_JsDom$GenericPixelStylePx.prototype = $c_Lscalatags_JsDom$GenericPixelStylePx.prototype;
var $d_Lscalatags_JsDom$GenericPixelStylePx = new $TypeData().initClass({
  Lscalatags_JsDom$GenericPixelStylePx: 0
}, false, "scalatags.JsDom$GenericPixelStylePx", {
  Lscalatags_JsDom$GenericPixelStylePx: 1,
  O: 1,
  Lscalatags_generic_PixelStyleValue: 1
});
$c_Lscalatags_JsDom$GenericPixelStylePx.prototype.$classData = $d_Lscalatags_JsDom$GenericPixelStylePx;
/** @constructor */
function $c_Lscalatags_JsDom$GenericStyle() {
  /*<skip>*/
}
$c_Lscalatags_JsDom$GenericStyle.prototype = new $h_O();
$c_Lscalatags_JsDom$GenericStyle.prototype.constructor = $c_Lscalatags_JsDom$GenericStyle;
/** @constructor */
function $h_Lscalatags_JsDom$GenericStyle() {
  /*<skip>*/
}
$h_Lscalatags_JsDom$GenericStyle.prototype = $c_Lscalatags_JsDom$GenericStyle.prototype;
var $d_Lscalatags_JsDom$GenericStyle = new $TypeData().initClass({
  Lscalatags_JsDom$GenericStyle: 0
}, false, "scalatags.JsDom$GenericStyle", {
  Lscalatags_JsDom$GenericStyle: 1,
  O: 1,
  Lscalatags_generic_StyleValue: 1
});
$c_Lscalatags_JsDom$GenericStyle.prototype.$classData = $d_Lscalatags_JsDom$GenericStyle;
function $f_Lscalatags_generic_Aggregate__$init$__V($thiz) {
  $thiz.Lscalatags_JsDom$all$__f_stringAttr = new $c_Lscalatags_JsDom$GenericAttr();
  new $c_Lscalatags_JsDom$GenericAttr();
  new $c_Lscalatags_JsDom$GenericAttr();
  new $c_Lscalatags_JsDom$GenericAttr();
  new $c_Lscalatags_JsDom$GenericAttr();
  new $c_Lscalatags_JsDom$GenericAttr();
  new $c_Lscalatags_JsDom$GenericAttr();
  new $c_Lscalatags_JsDom$GenericAttr();
  $thiz.Lscalatags_JsDom$all$__f_stringStyle = new $c_Lscalatags_JsDom$GenericStyle();
  $thiz.Lscalatags_JsDom$all$__f_booleanStyle = new $c_Lscalatags_JsDom$GenericStyle();
  new $c_Lscalatags_JsDom$GenericStyle();
  new $c_Lscalatags_JsDom$GenericStyle();
  new $c_Lscalatags_JsDom$GenericStyle();
  new $c_Lscalatags_JsDom$GenericStyle();
  new $c_Lscalatags_JsDom$GenericStyle();
  new $c_Lscalatags_JsDom$GenericStyle();
  var ev = $thiz.Lscalatags_JsDom$all$__f_stringStyle;
  new $c_Lscalatags_JsDom$GenericPixelStyle(ev);
  var ev$1 = $thiz.Lscalatags_JsDom$all$__f_booleanStyle;
  new $c_Lscalatags_JsDom$GenericPixelStyle(ev$1);
  var ev$2 = $thiz.Lscalatags_JsDom$all$__f_stringStyle;
  new $c_Lscalatags_JsDom$GenericPixelStylePx(ev$2);
  var ev$3 = $thiz.Lscalatags_JsDom$all$__f_stringStyle;
  new $c_Lscalatags_JsDom$GenericPixelStylePx(ev$3);
  var ev$4 = $thiz.Lscalatags_JsDom$all$__f_stringStyle;
  new $c_Lscalatags_JsDom$GenericPixelStylePx(ev$4);
  var ev$5 = $thiz.Lscalatags_JsDom$all$__f_stringStyle;
  new $c_Lscalatags_JsDom$GenericPixelStylePx(ev$5);
  var ev$6 = $thiz.Lscalatags_JsDom$all$__f_stringStyle;
  new $c_Lscalatags_JsDom$GenericPixelStylePx(ev$6);
  var ev$7 = $thiz.Lscalatags_JsDom$all$__f_stringStyle;
  new $c_Lscalatags_JsDom$GenericPixelStylePx(ev$7)
}
/** @constructor */
function $c_Lscalatags_generic_Namespace$$anon$1() {
  /*<skip>*/
}
$c_Lscalatags_generic_Namespace$$anon$1.prototype = new $h_O();
$c_Lscalatags_generic_Namespace$$anon$1.prototype.constructor = $c_Lscalatags_generic_Namespace$$anon$1;
/** @constructor */
function $h_Lscalatags_generic_Namespace$$anon$1() {
  /*<skip>*/
}
$h_Lscalatags_generic_Namespace$$anon$1.prototype = $c_Lscalatags_generic_Namespace$$anon$1.prototype;
$c_Lscalatags_generic_Namespace$$anon$1.prototype.uri__T = (function() {
  return "http://www.w3.org/1999/xhtml"
});
var $d_Lscalatags_generic_Namespace$$anon$1 = new $TypeData().initClass({
  Lscalatags_generic_Namespace$$anon$1: 0
}, false, "scalatags.generic.Namespace$$anon$1", {
  Lscalatags_generic_Namespace$$anon$1: 1,
  O: 1,
  Lscalatags_generic_Namespace: 1
});
$c_Lscalatags_generic_Namespace$$anon$1.prototype.$classData = $d_Lscalatags_generic_Namespace$$anon$1;
/** @constructor */
function $c_Lscalatags_generic_Namespace$$anon$2() {
  /*<skip>*/
}
$c_Lscalatags_generic_Namespace$$anon$2.prototype = new $h_O();
$c_Lscalatags_generic_Namespace$$anon$2.prototype.constructor = $c_Lscalatags_generic_Namespace$$anon$2;
/** @constructor */
function $h_Lscalatags_generic_Namespace$$anon$2() {
  /*<skip>*/
}
$h_Lscalatags_generic_Namespace$$anon$2.prototype = $c_Lscalatags_generic_Namespace$$anon$2.prototype;
$c_Lscalatags_generic_Namespace$$anon$2.prototype.uri__T = (function() {
  return "http://www.w3.org/2000/svg"
});
var $d_Lscalatags_generic_Namespace$$anon$2 = new $TypeData().initClass({
  Lscalatags_generic_Namespace$$anon$2: 0
}, false, "scalatags.generic.Namespace$$anon$2", {
  Lscalatags_generic_Namespace$$anon$2: 1,
  O: 1,
  Lscalatags_generic_Namespace: 1
});
$c_Lscalatags_generic_Namespace$$anon$2.prototype.$classData = $d_Lscalatags_generic_Namespace$$anon$2;
/** @constructor */
function $c_Lscalatags_generic_Namespace$$anon$3() {
  /*<skip>*/
}
$c_Lscalatags_generic_Namespace$$anon$3.prototype = new $h_O();
$c_Lscalatags_generic_Namespace$$anon$3.prototype.constructor = $c_Lscalatags_generic_Namespace$$anon$3;
/** @constructor */
function $h_Lscalatags_generic_Namespace$$anon$3() {
  /*<skip>*/
}
$h_Lscalatags_generic_Namespace$$anon$3.prototype = $c_Lscalatags_generic_Namespace$$anon$3.prototype;
$c_Lscalatags_generic_Namespace$$anon$3.prototype.uri__T = (function() {
  return "http://www.w3.org/1999/xlink"
});
var $d_Lscalatags_generic_Namespace$$anon$3 = new $TypeData().initClass({
  Lscalatags_generic_Namespace$$anon$3: 0
}, false, "scalatags.generic.Namespace$$anon$3", {
  Lscalatags_generic_Namespace$$anon$3: 1,
  O: 1,
  Lscalatags_generic_Namespace: 1
});
$c_Lscalatags_generic_Namespace$$anon$3.prototype.$classData = $d_Lscalatags_generic_Namespace$$anon$3;
function $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($thiz, s, ns, raw) {
  return new $c_Lscalatags_generic_Attr(s, $m_s_Option$().apply__O__s_Option(ns), raw)
}
/** @constructor */
function $c_Lshapeless_Nat$() {
  this.Lshapeless_Nat$__f__0 = null;
  $n_Lshapeless_Nat$ = this;
  $f_Lshapeless_Nats__$init$__V(this);
  this.Lshapeless_Nat$__f__0 = new $c_Lshapeless_\uff3f0()
}
$c_Lshapeless_Nat$.prototype = new $h_O();
$c_Lshapeless_Nat$.prototype.constructor = $c_Lshapeless_Nat$;
/** @constructor */
function $h_Lshapeless_Nat$() {
  /*<skip>*/
}
$h_Lshapeless_Nat$.prototype = $c_Lshapeless_Nat$.prototype;
var $d_Lshapeless_Nat$ = new $TypeData().initClass({
  Lshapeless_Nat$: 0
}, false, "shapeless.Nat$", {
  Lshapeless_Nat$: 1,
  O: 1,
  Lshapeless_Nats: 1
});
$c_Lshapeless_Nat$.prototype.$classData = $d_Lshapeless_Nat$;
var $n_Lshapeless_Nat$;
function $m_Lshapeless_Nat$() {
  if ((!$n_Lshapeless_Nat$)) {
    $n_Lshapeless_Nat$ = new $c_Lshapeless_Nat$()
  };
  return $n_Lshapeless_Nat$
}
/** @constructor */
function $c_Lshapeless_PolyDefns$$tilde$greater$() {
  /*<skip>*/
}
$c_Lshapeless_PolyDefns$$tilde$greater$.prototype = new $h_O();
$c_Lshapeless_PolyDefns$$tilde$greater$.prototype.constructor = $c_Lshapeless_PolyDefns$$tilde$greater$;
/** @constructor */
function $h_Lshapeless_PolyDefns$$tilde$greater$() {
  /*<skip>*/
}
$h_Lshapeless_PolyDefns$$tilde$greater$.prototype = $c_Lshapeless_PolyDefns$$tilde$greater$.prototype;
$c_Lshapeless_PolyDefns$$tilde$greater$.prototype.inst4__Lshapeless_PolyDefns$$tilde$greater__F1 = (function(f) {
  return new $c_sjsr_AnonFunction1(((x$7$2) => {
    $n(f);
    return x$7$2
  }))
});
var $d_Lshapeless_PolyDefns$$tilde$greater$ = new $TypeData().initClass({
  Lshapeless_PolyDefns$$tilde$greater$: 0
}, false, "shapeless.PolyDefns$$tilde$greater$", {
  Lshapeless_PolyDefns$$tilde$greater$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_PolyDefns$$tilde$greater$.prototype.$classData = $d_Lshapeless_PolyDefns$$tilde$greater$;
var $n_Lshapeless_PolyDefns$$tilde$greater$;
function $m_Lshapeless_PolyDefns$$tilde$greater$() {
  if ((!$n_Lshapeless_PolyDefns$$tilde$greater$)) {
    $n_Lshapeless_PolyDefns$$tilde$greater$ = new $c_Lshapeless_PolyDefns$$tilde$greater$()
  };
  return $n_Lshapeless_PolyDefns$$tilde$greater$
}
/** @constructor */
function $c_Lshapeless_Refute$$anon$2() {
  /*<skip>*/
}
$c_Lshapeless_Refute$$anon$2.prototype = new $h_O();
$c_Lshapeless_Refute$$anon$2.prototype.constructor = $c_Lshapeless_Refute$$anon$2;
/** @constructor */
function $h_Lshapeless_Refute$$anon$2() {
  /*<skip>*/
}
$h_Lshapeless_Refute$$anon$2.prototype = $c_Lshapeless_Refute$$anon$2.prototype;
var $d_Lshapeless_Refute$$anon$2 = new $TypeData().initClass({
  Lshapeless_Refute$$anon$2: 0
}, false, "shapeless.Refute$$anon$2", {
  Lshapeless_Refute$$anon$2: 1,
  O: 1,
  Lshapeless_Refute: 1
});
$c_Lshapeless_Refute$$anon$2.prototype.$classData = $d_Lshapeless_Refute$$anon$2;
function $f_Lshapeless_Typeable__toString__T($thiz) {
  return (("Typeable[" + $thiz.describe__T()) + "]")
}
function $is_Lshapeless_Typeable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lshapeless_Typeable)))
}
function $as_Lshapeless_Typeable(obj) {
  return (($is_Lshapeless_Typeable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.Typeable"))
}
function $isArrayOf_Lshapeless_Typeable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_Typeable)))
}
function $asArrayOf_Lshapeless_Typeable(obj, depth) {
  return (($isArrayOf_Lshapeless_Typeable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.Typeable;", depth))
}
var $d_Lshapeless_Typeable = new $TypeData().initClass({
  Lshapeless_Typeable: 0
}, true, "shapeless.Typeable", {
  Lshapeless_Typeable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
/** @constructor */
function $c_Lshapeless_ops_coproduct$ZipWithKeys$() {
  this.Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys = null;
  $n_Lshapeless_ops_coproduct$ZipWithKeys$ = this;
  this.Lshapeless_ops_coproduct$ZipWithKeys$__f_cnilZipWithKeys = new $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27()
}
$c_Lshapeless_ops_coproduct$ZipWithKeys$.prototype = new $h_O();
$c_Lshapeless_ops_coproduct$ZipWithKeys$.prototype.constructor = $c_Lshapeless_ops_coproduct$ZipWithKeys$;
/** @constructor */
function $h_Lshapeless_ops_coproduct$ZipWithKeys$() {
  /*<skip>*/
}
$h_Lshapeless_ops_coproduct$ZipWithKeys$.prototype = $c_Lshapeless_ops_coproduct$ZipWithKeys$.prototype;
var $d_Lshapeless_ops_coproduct$ZipWithKeys$ = new $TypeData().initClass({
  Lshapeless_ops_coproduct$ZipWithKeys$: 0
}, false, "shapeless.ops.coproduct$ZipWithKeys$", {
  Lshapeless_ops_coproduct$ZipWithKeys$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_coproduct$ZipWithKeys$.prototype.$classData = $d_Lshapeless_ops_coproduct$ZipWithKeys$;
var $n_Lshapeless_ops_coproduct$ZipWithKeys$;
function $m_Lshapeless_ops_coproduct$ZipWithKeys$() {
  if ((!$n_Lshapeless_ops_coproduct$ZipWithKeys$)) {
    $n_Lshapeless_ops_coproduct$ZipWithKeys$ = new $c_Lshapeless_ops_coproduct$ZipWithKeys$()
  };
  return $n_Lshapeless_ops_coproduct$ZipWithKeys$
}
/** @constructor */
function $c_Lshapeless_ops_hlist$ZipWithKeys$() {
  this.Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys = null;
  $n_Lshapeless_ops_hlist$ZipWithKeys$ = this;
  this.Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$160()
}
$c_Lshapeless_ops_hlist$ZipWithKeys$.prototype = new $h_O();
$c_Lshapeless_ops_hlist$ZipWithKeys$.prototype.constructor = $c_Lshapeless_ops_hlist$ZipWithKeys$;
/** @constructor */
function $h_Lshapeless_ops_hlist$ZipWithKeys$() {
  /*<skip>*/
}
$h_Lshapeless_ops_hlist$ZipWithKeys$.prototype = $c_Lshapeless_ops_hlist$ZipWithKeys$.prototype;
var $d_Lshapeless_ops_hlist$ZipWithKeys$ = new $TypeData().initClass({
  Lshapeless_ops_hlist$ZipWithKeys$: 0
}, false, "shapeless.ops.hlist$ZipWithKeys$", {
  Lshapeless_ops_hlist$ZipWithKeys$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_hlist$ZipWithKeys$.prototype.$classData = $d_Lshapeless_ops_hlist$ZipWithKeys$;
var $n_Lshapeless_ops_hlist$ZipWithKeys$;
function $m_Lshapeless_ops_hlist$ZipWithKeys$() {
  if ((!$n_Lshapeless_ops_hlist$ZipWithKeys$)) {
    $n_Lshapeless_ops_hlist$ZipWithKeys$ = new $c_Lshapeless_ops_hlist$ZipWithKeys$()
  };
  return $n_Lshapeless_ops_hlist$ZipWithKeys$
}
/** @constructor */
function $c_Lshapeless_ops_nat$ToInt$() {
  this.Lshapeless_ops_nat$ToInt$__f_toInt0 = null;
  $n_Lshapeless_ops_nat$ToInt$ = this;
  this.Lshapeless_ops_nat$ToInt$__f_toInt0 = new $c_Lshapeless_ops_nat$ToInt$Inst(0)
}
$c_Lshapeless_ops_nat$ToInt$.prototype = new $h_O();
$c_Lshapeless_ops_nat$ToInt$.prototype.constructor = $c_Lshapeless_ops_nat$ToInt$;
/** @constructor */
function $h_Lshapeless_ops_nat$ToInt$() {
  /*<skip>*/
}
$h_Lshapeless_ops_nat$ToInt$.prototype = $c_Lshapeless_ops_nat$ToInt$.prototype;
var $d_Lshapeless_ops_nat$ToInt$ = new $TypeData().initClass({
  Lshapeless_ops_nat$ToInt$: 0
}, false, "shapeless.ops.nat$ToInt$", {
  Lshapeless_ops_nat$ToInt$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_nat$ToInt$.prototype.$classData = $d_Lshapeless_ops_nat$ToInt$;
var $n_Lshapeless_ops_nat$ToInt$;
function $m_Lshapeless_ops_nat$ToInt$() {
  if ((!$n_Lshapeless_ops_nat$ToInt$)) {
    $n_Lshapeless_ops_nat$ToInt$ = new $c_Lshapeless_ops_nat$ToInt$()
  };
  return $n_Lshapeless_ops_nat$ToInt$
}
/** @constructor */
function $c_Lshapeless_ops_traversable$FromTraversable$() {
  /*<skip>*/
}
$c_Lshapeless_ops_traversable$FromTraversable$.prototype = new $h_O();
$c_Lshapeless_ops_traversable$FromTraversable$.prototype.constructor = $c_Lshapeless_ops_traversable$FromTraversable$;
/** @constructor */
function $h_Lshapeless_ops_traversable$FromTraversable$() {
  /*<skip>*/
}
$h_Lshapeless_ops_traversable$FromTraversable$.prototype = $c_Lshapeless_ops_traversable$FromTraversable$.prototype;
$c_Lshapeless_ops_traversable$FromTraversable$.prototype.hnilFromTraversable__Lshapeless_ops_traversable$FromTraversable = (function() {
  return new $c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1(((l$2) => {
    var l = $as_sc_Iterable(l$2);
    var cond = $n(l).isEmpty__Z();
    return (cond ? new $c_s_Some($m_Lshapeless_HNil$()) : $m_s_None$())
  }))
});
$c_Lshapeless_ops_traversable$FromTraversable$.prototype.hlistFromTraversable__Lshapeless_ops_traversable$FromTraversable__Lshapeless_Typeable__Lshapeless_ops_traversable$FromTraversable = (function(flt, oc) {
  return new $c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2(((l$2) => {
    var l = $as_sc_Iterable(l$2);
    if ($n(l).isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var t = $n(l).head__O();
      var this$4 = $n($n(oc).cast__O__s_Option(t));
      if (this$4.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1 = this$4.get__O();
        var this$5 = $n($n(flt).apply__sc_Iterable__s_Option($as_sc_Iterable($n(l).tail__O())));
        if (this$5.isEmpty__Z()) {
          return $m_s_None$()
        } else {
          var arg1$1 = this$5.get__O();
          var t$1 = $as_Lshapeless_HList(arg1$1);
          return new $c_s_Some(new $c_Lshapeless_syntax_HListOps(t$1).$colon$colon__O__Lshapeless_$colon$colon(arg1))
        }
      }
    }
  }))
});
var $d_Lshapeless_ops_traversable$FromTraversable$ = new $TypeData().initClass({
  Lshapeless_ops_traversable$FromTraversable$: 0
}, false, "shapeless.ops.traversable$FromTraversable$", {
  Lshapeless_ops_traversable$FromTraversable$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_traversable$FromTraversable$.prototype.$classData = $d_Lshapeless_ops_traversable$FromTraversable$;
var $n_Lshapeless_ops_traversable$FromTraversable$;
function $m_Lshapeless_ops_traversable$FromTraversable$() {
  if ((!$n_Lshapeless_ops_traversable$FromTraversable$)) {
    $n_Lshapeless_ops_traversable$FromTraversable$ = new $c_Lshapeless_ops_traversable$FromTraversable$()
  };
  return $n_Lshapeless_ops_traversable$FromTraversable$
}
/** @constructor */
function $c_Lshapeless_syntax_HListOps(l) {
  this.Lshapeless_syntax_HListOps__f_shapeless$syntax$HListOps$$l = null;
  this.Lshapeless_syntax_HListOps__f_shapeless$syntax$HListOps$$l = l
}
$c_Lshapeless_syntax_HListOps.prototype = new $h_O();
$c_Lshapeless_syntax_HListOps.prototype.constructor = $c_Lshapeless_syntax_HListOps;
/** @constructor */
function $h_Lshapeless_syntax_HListOps() {
  /*<skip>*/
}
$h_Lshapeless_syntax_HListOps.prototype = $c_Lshapeless_syntax_HListOps.prototype;
$c_Lshapeless_syntax_HListOps.prototype.$colon$colon__O__Lshapeless_$colon$colon = (function(h) {
  return new $c_Lshapeless_$colon$colon(h, this.Lshapeless_syntax_HListOps__f_shapeless$syntax$HListOps$$l)
});
$c_Lshapeless_syntax_HListOps.prototype.select__Lshapeless_ops_hlist$Selector__O = (function(selector) {
  var this$1 = $n(selector);
  var t = this.Lshapeless_syntax_HListOps__f_shapeless$syntax$HListOps$$l;
  return this$1.apply__Lshapeless_$colon$colon__O($as_Lshapeless_$colon$colon(t))
});
var $d_Lshapeless_syntax_HListOps = new $TypeData().initClass({
  Lshapeless_syntax_HListOps: 0
}, false, "shapeless.syntax.HListOps", {
  Lshapeless_syntax_HListOps: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_syntax_HListOps.prototype.$classData = $d_Lshapeless_syntax_HListOps;
/** @constructor */
function $c_Lshapeless_syntax_SingletonOps$$anon$1(w$1) {
  this.Lshapeless_syntax_SingletonOps$$anon$1__f_witness = null;
  this.Lshapeless_syntax_SingletonOps$$anon$1__f_witness = w$1
}
$c_Lshapeless_syntax_SingletonOps$$anon$1.prototype = new $h_O();
$c_Lshapeless_syntax_SingletonOps$$anon$1.prototype.constructor = $c_Lshapeless_syntax_SingletonOps$$anon$1;
/** @constructor */
function $h_Lshapeless_syntax_SingletonOps$$anon$1() {
  /*<skip>*/
}
$h_Lshapeless_syntax_SingletonOps$$anon$1.prototype = $c_Lshapeless_syntax_SingletonOps$$anon$1.prototype;
var $d_Lshapeless_syntax_SingletonOps$$anon$1 = new $TypeData().initClass({
  Lshapeless_syntax_SingletonOps$$anon$1: 0
}, false, "shapeless.syntax.SingletonOps$$anon$1", {
  Lshapeless_syntax_SingletonOps$$anon$1: 1,
  O: 1,
  Lshapeless_syntax_SingletonOps: 1
});
$c_Lshapeless_syntax_SingletonOps$$anon$1.prototype.$classData = $d_Lshapeless_syntax_SingletonOps$$anon$1;
function $as_Lcats_Eval$Defer(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Defer"))
}
function $isArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Defer)))
}
function $asArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Defer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Defer;", depth))
}
/** @constructor */
function $c_Lcats_Eval$FlatMap() {
  /*<skip>*/
}
$c_Lcats_Eval$FlatMap.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$FlatMap.prototype.constructor = $c_Lcats_Eval$FlatMap;
/** @constructor */
function $h_Lcats_Eval$FlatMap() {
  /*<skip>*/
}
$h_Lcats_Eval$FlatMap.prototype = $c_Lcats_Eval$FlatMap.prototype;
function $as_Lcats_Eval$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_Eval$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$FlatMap"))
}
function $isArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$FlatMap)))
}
function $asArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_Eval$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$FlatMap;", depth))
}
/** @constructor */
function $c_Lcats_Eval$Leaf() {
  /*<skip>*/
}
$c_Lcats_Eval$Leaf.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Leaf.prototype.constructor = $c_Lcats_Eval$Leaf;
/** @constructor */
function $h_Lcats_Eval$Leaf() {
  /*<skip>*/
}
$h_Lcats_Eval$Leaf.prototype = $c_Lcats_Eval$Leaf.prototype;
function $ct_Lcats_EvalInstances__($thiz) {
  $thiz.Lcats_EvalInstances__f_catsBimonadForEval = new $c_Lcats_EvalInstances$$anon$6($thiz);
  new $c_Lcats_EvalInstances$$anon$7($thiz);
  new $c_Lcats_EvalInstances$$anon$8($thiz);
  new $c_Lcats_EvalInstances$$anon$11($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcats_EvalInstances() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null
}
$c_Lcats_EvalInstances.prototype = new $h_Lcats_EvalInstances0();
$c_Lcats_EvalInstances.prototype.constructor = $c_Lcats_EvalInstances;
/** @constructor */
function $h_Lcats_EvalInstances() {
  /*<skip>*/
}
$h_Lcats_EvalInstances.prototype = $c_Lcats_EvalInstances.prototype;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$11(outer) {
  $n(outer)
}
$c_Lcats_EvalInstances$$anon$11.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$11.prototype.constructor = $c_Lcats_EvalInstances$$anon$11;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$11() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$11.prototype = $c_Lcats_EvalInstances$$anon$11.prototype;
var $d_Lcats_EvalInstances$$anon$11 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$11: 0
}, false, "cats.EvalInstances$$anon$11", {
  Lcats_EvalInstances$$anon$11: 1,
  O: 1,
  Lcats_Representable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_EvalInstances$$anon$11.prototype.$classData = $d_Lcats_EvalInstances$$anon$11;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$7(outer) {
  /*<skip>*/
}
$c_Lcats_EvalInstances$$anon$7.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$7.prototype.constructor = $c_Lcats_EvalInstances$$anon$7;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$7() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$7.prototype = $c_Lcats_EvalInstances$$anon$7.prototype;
var $d_Lcats_EvalInstances$$anon$7 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$7: 0
}, false, "cats.EvalInstances$$anon$7", {
  Lcats_EvalInstances$$anon$7: 1,
  O: 1,
  Lcats_Defer: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_EvalInstances$$anon$7.prototype.$classData = $d_Lcats_EvalInstances$$anon$7;
function $is_Lcats_Functor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Functor)))
}
function $as_Lcats_Functor(obj) {
  return (($is_Lcats_Functor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Functor"))
}
function $isArrayOf_Lcats_Functor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Functor)))
}
function $asArrayOf_Lcats_Functor(obj, depth) {
  return (($isArrayOf_Lcats_Functor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Functor;", depth))
}
/** @constructor */
function $c_Lcats_Functor$ToFunctorOps$$anon$4(outer, target$2, tc$2) {
  this.Lcats_Functor$ToFunctorOps$$anon$4__f_self = null;
  this.Lcats_Functor$ToFunctorOps$$anon$4__f_typeClassInstance = null;
  this.Lcats_Functor$ToFunctorOps$$anon$4__f_self = target$2;
  this.Lcats_Functor$ToFunctorOps$$anon$4__f_typeClassInstance = tc$2
}
$c_Lcats_Functor$ToFunctorOps$$anon$4.prototype = new $h_O();
$c_Lcats_Functor$ToFunctorOps$$anon$4.prototype.constructor = $c_Lcats_Functor$ToFunctorOps$$anon$4;
/** @constructor */
function $h_Lcats_Functor$ToFunctorOps$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Functor$ToFunctorOps$$anon$4.prototype = $c_Lcats_Functor$ToFunctorOps$$anon$4.prototype;
var $d_Lcats_Functor$ToFunctorOps$$anon$4 = new $TypeData().initClass({
  Lcats_Functor$ToFunctorOps$$anon$4: 0
}, false, "cats.Functor$ToFunctorOps$$anon$4", {
  Lcats_Functor$ToFunctorOps$$anon$4: 1,
  O: 1,
  Lcats_Functor$Ops: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Functor$ToFunctorOps$$anon$4.prototype.$classData = $d_Lcats_Functor$ToFunctorOps$$anon$4;
/** @constructor */
function $c_Lcats_SemigroupK$$anon$1(outer) {
  this.Lcats_SemigroupK$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcats_SemigroupK$$anon$1__f_$outer = outer
  }
}
$c_Lcats_SemigroupK$$anon$1.prototype = new $h_O();
$c_Lcats_SemigroupK$$anon$1.prototype.constructor = $c_Lcats_SemigroupK$$anon$1;
/** @constructor */
function $h_Lcats_SemigroupK$$anon$1() {
  /*<skip>*/
}
$h_Lcats_SemigroupK$$anon$1.prototype = $c_Lcats_SemigroupK$$anon$1.prototype;
$c_Lcats_SemigroupK$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return $n(this.Lcats_SemigroupK$$anon$1__f_$outer).combineK__O__O__O(x, y)
});
var $d_Lcats_SemigroupK$$anon$1 = new $TypeData().initClass({
  Lcats_SemigroupK$$anon$1: 0
}, false, "cats.SemigroupK$$anon$1", {
  Lcats_SemigroupK$$anon$1: 1,
  O: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_SemigroupK$$anon$1.prototype.$classData = $d_Lcats_SemigroupK$$anon$1;
function $is_Lcats_Show(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Show)))
}
function $as_Lcats_Show(obj) {
  return (($is_Lcats_Show(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Show"))
}
function $isArrayOf_Lcats_Show(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Show)))
}
function $asArrayOf_Lcats_Show(obj, depth) {
  return (($isArrayOf_Lcats_Show(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Show;", depth))
}
/** @constructor */
function $c_Lcats_UnorderedFoldable$() {
  $n_Lcats_UnorderedFoldable$ = this;
  new $c_Lcats_UnorderedFoldable$$anon$1();
  new $c_Lcats_UnorderedFoldable$$anon$2()
}
$c_Lcats_UnorderedFoldable$.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$.prototype.constructor = $c_Lcats_UnorderedFoldable$;
/** @constructor */
function $h_Lcats_UnorderedFoldable$() {
  /*<skip>*/
}
$h_Lcats_UnorderedFoldable$.prototype = $c_Lcats_UnorderedFoldable$.prototype;
var $d_Lcats_UnorderedFoldable$ = new $TypeData().initClass({
  Lcats_UnorderedFoldable$: 0
}, false, "cats.UnorderedFoldable$", {
  Lcats_UnorderedFoldable$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificTraverseInstances: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_UnorderedFoldable$.prototype.$classData = $d_Lcats_UnorderedFoldable$;
var $n_Lcats_UnorderedFoldable$;
function $m_Lcats_UnorderedFoldable$() {
  if ((!$n_Lcats_UnorderedFoldable$)) {
    $n_Lcats_UnorderedFoldable$ = new $c_Lcats_UnorderedFoldable$()
  };
  return $n_Lcats_UnorderedFoldable$
}
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$4() {
  /*<skip>*/
}
$c_Lcats_arrow_FunctionK$$anon$4.prototype = new $h_O();
$c_Lcats_arrow_FunctionK$$anon$4.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$4;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$4() {
  /*<skip>*/
}
$h_Lcats_arrow_FunctionK$$anon$4.prototype = $c_Lcats_arrow_FunctionK$$anon$4.prototype;
var $d_Lcats_arrow_FunctionK$$anon$4 = new $TypeData().initClass({
  Lcats_arrow_FunctionK$$anon$4: 0
}, false, "cats.arrow.FunctionK$$anon$4", {
  Lcats_arrow_FunctionK$$anon$4: 1,
  O: 1,
  Lcats_arrow_FunctionK: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_arrow_FunctionK$$anon$4.prototype.$classData = $d_Lcats_arrow_FunctionK$$anon$4;
function $ct_Lcats_data_NonEmptyListInstances__($thiz) {
  $thiz.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList = new $c_Lcats_data_NonEmptyListInstances$$anon$2($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList = null
}
$c_Lcats_data_NonEmptyListInstances.prototype = new $h_Lcats_data_NonEmptyListInstances0();
$c_Lcats_data_NonEmptyListInstances.prototype.constructor = $c_Lcats_data_NonEmptyListInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances.prototype = $c_Lcats_data_NonEmptyListInstances.prototype;
$c_Lcats_data_NonEmptyListInstances.prototype.catsDataSemigroupForNonEmptyList__Lcats_kernel_Semigroup = (function() {
  var instance = this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList;
  return $n(instance).algebra__Lcats_kernel_Semigroup()
});
function $ct_Lcats_data_ValidatedInstances__($thiz) {
  new $c_Lcats_data_ValidatedInstances$$anon$6($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances() {
  /*<skip>*/
}
$c_Lcats_data_ValidatedInstances.prototype = new $h_Lcats_data_ValidatedInstances1();
$c_Lcats_data_ValidatedInstances.prototype.constructor = $c_Lcats_data_ValidatedInstances;
/** @constructor */
function $h_Lcats_data_ValidatedInstances() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances.prototype = $c_Lcats_data_ValidatedInstances.prototype;
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$3(outer) {
  /*<skip>*/
}
$c_Lcats_instances_EitherInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$3.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_EitherInstances$$anon$3.prototype = $c_Lcats_instances_EitherInstances$$anon$3.prototype;
$c_Lcats_instances_EitherInstances$$anon$3.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this)
});
$c_Lcats_instances_EitherInstances$$anon$3.prototype.combineK__s_util_Either__s_util_Either__s_util_Either = (function(x, y) {
  if ((x instanceof $c_s_util_Left)) {
    return y
  } else if ((x instanceof $c_s_util_Right)) {
    return x
  } else {
    throw new $c_s_MatchError(x)
  }
});
$c_Lcats_instances_EitherInstances$$anon$3.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__s_util_Either__s_util_Either__s_util_Either($as_s_util_Either(x), $as_s_util_Either(y))
});
var $d_Lcats_instances_EitherInstances$$anon$3 = new $TypeData().initClass({
  Lcats_instances_EitherInstances$$anon$3: 0
}, false, "cats.instances.EitherInstances$$anon$3", {
  Lcats_instances_EitherInstances$$anon$3: 1,
  O: 1,
  Lcats_SemigroupK: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_EitherInstances$$anon$3.prototype.$classData = $d_Lcats_instances_EitherInstances$$anon$3;
function $f_Lcats_instances_EqInstances__$init$__V($thiz) {
  $thiz.cats$instances$EqInstances$_setter_$catsContravariantMonoidalForEq_$eq__Lcats_ContravariantMonoidal__V(new $c_Lcats_instances_EqInstances$$anon$1($thiz))
}
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$1$$anon$3(outer, fa$1, f$1) {
  this.Lcats_instances_EquivInstances$$anon$1$$anon$3__f_fa$1 = null;
  this.Lcats_instances_EquivInstances$$anon$1$$anon$3__f_f$1 = null;
  this.Lcats_instances_EquivInstances$$anon$1$$anon$3__f_fa$1 = fa$1;
  this.Lcats_instances_EquivInstances$$anon$1$$anon$3__f_f$1 = f$1
}
$c_Lcats_instances_EquivInstances$$anon$1$$anon$3.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$1$$anon$3.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$1$$anon$3;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$1$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_EquivInstances$$anon$1$$anon$3.prototype = $c_Lcats_instances_EquivInstances$$anon$1$$anon$3.prototype;
$c_Lcats_instances_EquivInstances$$anon$1$$anon$3.prototype.equiv__O__O__Z = (function(l, r) {
  return $n(this.Lcats_instances_EquivInstances$$anon$1$$anon$3__f_fa$1).equiv__O__O__Z($n(this.Lcats_instances_EquivInstances$$anon$1$$anon$3__f_f$1).apply__O__O(l), $n(this.Lcats_instances_EquivInstances$$anon$1$$anon$3__f_f$1).apply__O__O(r))
});
var $d_Lcats_instances_EquivInstances$$anon$1$$anon$3 = new $TypeData().initClass({
  Lcats_instances_EquivInstances$$anon$1$$anon$3: 0
}, false, "cats.instances.EquivInstances$$anon$1$$anon$3", {
  Lcats_instances_EquivInstances$$anon$1$$anon$3: 1,
  O: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_EquivInstances$$anon$1$$anon$3.prototype.$classData = $d_Lcats_instances_EquivInstances$$anon$1$$anon$3;
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$1$$anon$4(outer, fa$2, fb$1) {
  this.Lcats_instances_EquivInstances$$anon$1$$anon$4__f_fa$2 = null;
  this.Lcats_instances_EquivInstances$$anon$1$$anon$4__f_fb$1 = null;
  this.Lcats_instances_EquivInstances$$anon$1$$anon$4__f_fa$2 = fa$2;
  this.Lcats_instances_EquivInstances$$anon$1$$anon$4__f_fb$1 = fb$1
}
$c_Lcats_instances_EquivInstances$$anon$1$$anon$4.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$1$$anon$4.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$1$$anon$4;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$1$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_EquivInstances$$anon$1$$anon$4.prototype = $c_Lcats_instances_EquivInstances$$anon$1$$anon$4.prototype;
$c_Lcats_instances_EquivInstances$$anon$1$$anon$4.prototype.equiv__T2__T2__Z = (function(l, r) {
  return ($n(this.Lcats_instances_EquivInstances$$anon$1$$anon$4__f_fa$2).equiv__O__O__Z($n(l)._1__O(), $n(r)._1__O()) && $n(this.Lcats_instances_EquivInstances$$anon$1$$anon$4__f_fb$1).equiv__O__O__Z($n(l)._2__O(), $n(r)._2__O()))
});
$c_Lcats_instances_EquivInstances$$anon$1$$anon$4.prototype.equiv__O__O__Z = (function(x, y) {
  return this.equiv__T2__T2__Z($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_EquivInstances$$anon$1$$anon$4 = new $TypeData().initClass({
  Lcats_instances_EquivInstances$$anon$1$$anon$4: 0
}, false, "cats.instances.EquivInstances$$anon$1$$anon$4", {
  Lcats_instances_EquivInstances$$anon$1$$anon$4: 1,
  O: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_EquivInstances$$anon$1$$anon$4.prototype.$classData = $d_Lcats_instances_EquivInstances$$anon$1$$anon$4;
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$2(outer) {
  /*<skip>*/
}
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$2.prototype = new $h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$2.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$2;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$2.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$2.prototype;
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$2 = new $TypeData().initClass({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$2: 0
}, false, "cats.instances.FunctionInstancesBinCompat0$$anon$2", {
  Lcats_instances_FunctionInstancesBinCompat0$$anon$2: 1,
  O: 1,
  Lcats_Defer: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$2.prototype.$classData = $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$2;
function $f_Lcats_instances_HashInstances__$init$__V($thiz) {
  $thiz.cats$instances$HashInstances$_setter_$catsContravariantForHash_$eq__Lcats_Contravariant__V(new $c_Lcats_instances_HashInstances$$anon$1($thiz))
}
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5(outer, fa$3, fb$2) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5__f_fa$3 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5__f_fb$2 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5__f_fa$3 = fa$3;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5__f_fb$2 = fb$2
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5.prototype.combine__T2__T2__T2 = (function(x, y) {
  var self = $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5__f_fa$3).combine__O__O__O($n(x)._1__O(), $n(y)._1__O());
  var y$1 = $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5__f_fb$2).combine__O__O__O($n(x)._2__O(), $n(y)._2__O());
  return $ct_T2__O__O__(new $c_T2(), self, y$1)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$4$$anon$5", {
  Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5: 1,
  O: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6(outer, f$2, fa$4, g$2) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_f$2 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_fa$4 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_g$2 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_f$2 = f$2;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_fa$4 = fa$4;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_g$2 = g$2
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6.prototype.combine__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_f$2).apply__O__O($n(this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_fa$4).combine__O__O__O($n(this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_g$2).apply__O__O(x), $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6__f_g$2).apply__O__O(y)))
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$4$$anon$6", {
  Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6: 1,
  O: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6;
/** @constructor */
function $c_Lcats_instances_MapInstancesBinCompat0$$anon$3(outer) {
  /*<skip>*/
}
$c_Lcats_instances_MapInstancesBinCompat0$$anon$3.prototype = new $h_O();
$c_Lcats_instances_MapInstancesBinCompat0$$anon$3.prototype.constructor = $c_Lcats_instances_MapInstancesBinCompat0$$anon$3;
/** @constructor */
function $h_Lcats_instances_MapInstancesBinCompat0$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_MapInstancesBinCompat0$$anon$3.prototype = $c_Lcats_instances_MapInstancesBinCompat0$$anon$3.prototype;
var $d_Lcats_instances_MapInstancesBinCompat0$$anon$3 = new $TypeData().initClass({
  Lcats_instances_MapInstancesBinCompat0$$anon$3: 0
}, false, "cats.instances.MapInstancesBinCompat0$$anon$3", {
  Lcats_instances_MapInstancesBinCompat0$$anon$3: 1,
  O: 1,
  Lcats_arrow_Compose: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_MapInstancesBinCompat0$$anon$3.prototype.$classData = $d_Lcats_instances_MapInstancesBinCompat0$$anon$3;
function $f_Lcats_instances_OrderInstances__$init$__V($thiz) {
  $thiz.cats$instances$OrderInstances$_setter_$catsContravariantMonoidalForOrder_$eq__Lcats_ContravariantMonoidal__V(new $c_Lcats_instances_OrderInstances$$anon$1($thiz))
}
function $f_Lcats_instances_PartialOrderInstances__$init$__V($thiz) {
  $thiz.cats$instances$PartialOrderInstances$_setter_$catsContravariantMonoidalForPartialOrder_$eq__Lcats_ContravariantMonoidal__V(new $c_Lcats_instances_PartialOrderInstances$$anon$1($thiz))
}
function $f_Lcats_instances_SetInstances__$init$__V($thiz) {
  $thiz.cats$instances$SetInstances$_setter_$catsStdInstancesForSet_$eq__Lcats_UnorderedTraverse__V(new $c_Lcats_instances_SetInstances$$anon$1($thiz))
}
/** @constructor */
function $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3(outer) {
  /*<skip>*/
}
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3.prototype = new $h_O();
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3.prototype.constructor = $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3;
/** @constructor */
function $h_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3.prototype = $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3.prototype;
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3.prototype.product__sci_SortedSet__sci_SortedSet__sci_SortedSet = (function(fa, fb) {
  var orderingA = $n(fa).ordering__s_math_Ordering();
  var orderingB = $n(fb).ordering__s_math_Ordering();
  return $as_sci_SortedSet($n(fa).flatMap__F1__s_math_Ordering__sc_SortedSet(new $c_sjsr_AnonFunction1(((a$2) => $as_sci_SortedSet($n(fb).map__F1__s_math_Ordering__sc_SortedSet(new $c_sjsr_AnonFunction1(((b$2) => $ct_T2__O__O__(new $c_T2(), a$2, b$2))), new $c_s_math_Ordering$Tuple2Ordering(orderingA, orderingB))))), new $c_s_math_Ordering$Tuple2Ordering(orderingA, orderingB)))
});
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__sci_SortedSet__sci_SortedSet__sci_SortedSet($as_sci_SortedSet(fa), $as_sci_SortedSet(fb))
});
var $d_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3 = new $TypeData().initClass({
  Lcats_instances_SortedSetInstancesBinCompat0$$anon$3: 0
}, false, "cats.instances.SortedSetInstancesBinCompat0$$anon$3", {
  Lcats_instances_SortedSetInstancesBinCompat0$$anon$3: 1,
  O: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3.prototype.$classData = $d_Lcats_instances_SortedSetInstancesBinCompat0$$anon$3;
function $is_Lcats_kernel_CommutativeSemigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_CommutativeSemigroup)))
}
function $as_Lcats_kernel_CommutativeSemigroup(obj) {
  return (($is_Lcats_kernel_CommutativeSemigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.CommutativeSemigroup"))
}
function $isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_CommutativeSemigroup)))
}
function $asArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.CommutativeSemigroup;", depth))
}
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$2(ev$2, f$1) {
  this.Lcats_kernel_Eq$$anon$2__f_ev$2 = null;
  this.Lcats_kernel_Eq$$anon$2__f_f$1 = null;
  this.Lcats_kernel_Eq$$anon$2__f_ev$2 = ev$2;
  this.Lcats_kernel_Eq$$anon$2__f_f$1 = f$1
}
$c_Lcats_kernel_Eq$$anon$2.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$2.prototype.constructor = $c_Lcats_kernel_Eq$$anon$2;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$2() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$$anon$2.prototype = $c_Lcats_kernel_Eq$$anon$2.prototype;
$c_Lcats_kernel_Eq$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Eq$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $n(this.Lcats_kernel_Eq$$anon$2__f_ev$2).eqv__O__O__Z($n(this.Lcats_kernel_Eq$$anon$2__f_f$1).apply__O__O(x), $n(this.Lcats_kernel_Eq$$anon$2__f_f$1).apply__O__O(y))
});
var $d_Lcats_kernel_Eq$$anon$2 = new $TypeData().initClass({
  Lcats_kernel_Eq$$anon$2: 0
}, false, "cats.kernel.Eq$$anon$2", {
  Lcats_kernel_Eq$$anon$2: 1,
  O: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Eq$$anon$2.prototype.$classData = $d_Lcats_kernel_Eq$$anon$2;
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$5(f$2) {
  this.Lcats_kernel_Eq$$anon$5__f_f$2 = null;
  this.Lcats_kernel_Eq$$anon$5__f_f$2 = f$2
}
$c_Lcats_kernel_Eq$$anon$5.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$5.prototype.constructor = $c_Lcats_kernel_Eq$$anon$5;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$5() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$$anon$5.prototype = $c_Lcats_kernel_Eq$$anon$5.prototype;
$c_Lcats_kernel_Eq$$anon$5.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Eq$$anon$5.prototype.eqv__O__O__Z = (function(x, y) {
  return $uZ($n(this.Lcats_kernel_Eq$$anon$5__f_f$2).apply__O__O__O(x, y))
});
var $d_Lcats_kernel_Eq$$anon$5 = new $TypeData().initClass({
  Lcats_kernel_Eq$$anon$5: 0
}, false, "cats.kernel.Eq$$anon$5", {
  Lcats_kernel_Eq$$anon$5: 1,
  O: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Eq$$anon$5.prototype.$classData = $d_Lcats_kernel_Eq$$anon$5;
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$6() {
  /*<skip>*/
}
$c_Lcats_kernel_Eq$$anon$6.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$6.prototype.constructor = $c_Lcats_kernel_Eq$$anon$6;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$6() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$$anon$6.prototype = $c_Lcats_kernel_Eq$$anon$6.prototype;
$c_Lcats_kernel_Eq$$anon$6.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Eq$$anon$6.prototype.eqv__O__O__Z = (function(x, y) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
});
var $d_Lcats_kernel_Eq$$anon$6 = new $TypeData().initClass({
  Lcats_kernel_Eq$$anon$6: 0
}, false, "cats.kernel.Eq$$anon$6", {
  Lcats_kernel_Eq$$anon$6: 1,
  O: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Eq$$anon$6.prototype.$classData = $d_Lcats_kernel_Eq$$anon$6;
function $is_Lcats_kernel_Hash(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Hash)))
}
function $as_Lcats_kernel_Hash(obj) {
  return (($is_Lcats_kernel_Hash(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Hash"))
}
function $isArrayOf_Lcats_kernel_Hash(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Hash)))
}
function $asArrayOf_Lcats_kernel_Hash(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Hash(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Hash;", depth))
}
function $is_Lcats_kernel_Monoid(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Monoid)))
}
function $as_Lcats_kernel_Monoid(obj) {
  return (($is_Lcats_kernel_Monoid(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Monoid"))
}
function $isArrayOf_Lcats_kernel_Monoid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Monoid)))
}
function $asArrayOf_Lcats_kernel_Monoid(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Monoid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Monoid;", depth))
}
/** @constructor */
function $c_Lcats_kernel_OrderFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_OrderFunctions.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_OrderFunctions.prototype.constructor = $c_Lcats_kernel_OrderFunctions;
/** @constructor */
function $h_Lcats_kernel_OrderFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_OrderFunctions.prototype = $c_Lcats_kernel_OrderFunctions.prototype;
function $f_Lcats_kernel_PartialOrder__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.partialCompare__O__O__D(x, y) === 0.0)
}
function $is_Lcats_kernel_PartialOrder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_PartialOrder)))
}
function $as_Lcats_kernel_PartialOrder(obj) {
  return (($is_Lcats_kernel_PartialOrder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.PartialOrder"))
}
function $isArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_PartialOrder)))
}
function $asArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (($isArrayOf_Lcats_kernel_PartialOrder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.PartialOrder;", depth))
}
function $p_Lcats_kernel_instances_ListEq__loop$3__sci_List__sci_List__Z($thiz, xs, ys) {
  while (true) {
    var x1 = xs;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x1)) {
      return $n(ys).isEmpty__Z()
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x2 = $as_sci_$colon$colon(x1);
      var x$3 = $n(x2).sci_$colon$colon__f_head;
      var xs$2 = $n(x2).sci_$colon$colon__f_next;
      var x1$2 = ys;
      if ((x1$2 instanceof $c_sci_$colon$colon)) {
        var x2$2 = $as_sci_$colon$colon(x1$2);
        var y = $n(x2$2).sci_$colon$colon__f_head;
        var ys$2 = $n(x2$2).sci_$colon$colon__f_next;
        if ($n($thiz.Lcats_kernel_instances_ListEq__f_ev).eqv__O__O__Z(x$3, y)) {
          xs = xs$2;
          ys = ys$2
        } else {
          return false
        }
      } else {
        var x$4 = $m_sci_Nil$();
        if (x$4.equals__O__Z(x1$2)) {
          return false
        } else {
          throw new $c_s_MatchError(x1$2)
        }
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lcats_kernel_instances_ListEq(ev) {
  this.Lcats_kernel_instances_ListEq__f_ev = null;
  this.Lcats_kernel_instances_ListEq__f_ev = ev
}
$c_Lcats_kernel_instances_ListEq.prototype = new $h_O();
$c_Lcats_kernel_instances_ListEq.prototype.constructor = $c_Lcats_kernel_instances_ListEq;
/** @constructor */
function $h_Lcats_kernel_instances_ListEq() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ListEq.prototype = $c_Lcats_kernel_instances_ListEq.prototype;
$c_Lcats_kernel_instances_ListEq.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_ListEq.prototype.eqv__sci_List__sci_List__Z = (function(xs, ys) {
  return ((xs === ys) || $p_Lcats_kernel_instances_ListEq__loop$3__sci_List__sci_List__Z(this, xs, ys))
});
$c_Lcats_kernel_instances_ListEq.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_List__sci_List__Z($as_sci_List(x), $as_sci_List(y))
});
var $d_Lcats_kernel_instances_ListEq = new $TypeData().initClass({
  Lcats_kernel_instances_ListEq: 0
}, false, "cats.kernel.instances.ListEq", {
  Lcats_kernel_instances_ListEq: 1,
  O: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_instances_ListEq.prototype.$classData = $d_Lcats_kernel_instances_ListEq;
/** @constructor */
function $c_Lcats_package$$anon$2() {
  $m_Lcats_package$()
}
$c_Lcats_package$$anon$2.prototype = new $h_O();
$c_Lcats_package$$anon$2.prototype.constructor = $c_Lcats_package$$anon$2;
/** @constructor */
function $h_Lcats_package$$anon$2() {
  /*<skip>*/
}
$h_Lcats_package$$anon$2.prototype = $c_Lcats_package$$anon$2.prototype;
var $d_Lcats_package$$anon$2 = new $TypeData().initClass({
  Lcats_package$$anon$2: 0
}, false, "cats.package$$anon$2", {
  Lcats_package$$anon$2: 1,
  O: 1,
  Lcats_Representable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_package$$anon$2.prototype.$classData = $d_Lcats_package$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_common_BestPositionByTokenMatcher() {
  /*<skip>*/
}
$c_Lcom_iz2use_common_BestPositionByTokenMatcher.prototype = new $h_O();
$c_Lcom_iz2use_common_BestPositionByTokenMatcher.prototype.constructor = $c_Lcom_iz2use_common_BestPositionByTokenMatcher;
/** @constructor */
function $h_Lcom_iz2use_common_BestPositionByTokenMatcher() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_BestPositionByTokenMatcher.prototype = $c_Lcom_iz2use_common_BestPositionByTokenMatcher.prototype;
$c_Lcom_iz2use_common_BestPositionByTokenMatcher.prototype.processQueryToken__Lcom_iz2use_common_internal_tokenizer_Token__Lcom_iz2use_common_internal_tokenizer_Tokenized__scm_Builder__V = (function(searchToken, item, builder) {
  var elem = $m_s_None$();
  var result = new $c_sr_ObjectRef(elem);
  $n(item).process__F1__Z(new $c_sjsr_AnonFunction1(((token$2) => {
    var token = $as_Lcom_iz2use_common_internal_tokenizer_Token(token$2);
    var this$3 = $n($n(token).Lcom_iz2use_common_internal_tokenizer_Token__f_repr);
    var str = $n(searchToken).Lcom_iz2use_common_internal_tokenizer_Token__f_repr;
    var x1 = $uI(this$3.indexOf(str));
    switch (x1) {
      case (-1): {
        return true;
        break
      }
      case 0: {
        result.sr_ObjectRef__f_elem = new $c_s_Some($ct_T2__O__O__(new $c_T2(), token, 0));
        return false;
        break
      }
      default: {
        var this$6 = $n($as_s_Option(result.sr_ObjectRef__f_elem));
        if (this$6.isEmpty__Z()) {
          var $$x1 = true
        } else {
          var arg1 = this$6.get__O();
          var x$2 = $as_T2(arg1);
          var $$x1 = ($n(x$2)._2$mcI$sp__I() < x1)
        };
        var this$7 = $n(($$x1 ? this$6 : $m_s_None$()));
        result.sr_ObjectRef__f_elem = (this$7.isEmpty__Z() ? new $c_s_Some($ct_T2__O__O__(new $c_T2(), token, x1)) : this$7);
        return true
      }
    }
  })));
  var x1$1 = $as_s_Option(result.sr_ObjectRef__f_elem);
  matchEnd6: {
    var x = $m_s_None$();
    if ((x === x1$1)) {
      break matchEnd6
    };
    if ((x1$1 instanceof $c_s_Some)) {
      var x3 = $as_s_Some(x1$1);
      var p4 = $as_T2($n(x3).s_Some__f_value);
      if ((p4 !== null)) {
        var token$3 = $as_Lcom_iz2use_common_internal_tokenizer_Token($n(p4)._1__O());
        var idx = $n(p4)._2$mcI$sp__I();
        var this$10 = $n(builder);
        var elem$1 = new $c_Lcom_iz2use_common_TokenMatch(searchToken, token$3, idx);
        this$10.addOne__O__scm_Growable(elem$1);
        break matchEnd6
      }
    };
    throw new $c_s_MatchError(x1$1)
  }
});
var $d_Lcom_iz2use_common_BestPositionByTokenMatcher = new $TypeData().initClass({
  Lcom_iz2use_common_BestPositionByTokenMatcher: 0
}, false, "com.iz2use.common.BestPositionByTokenMatcher", {
  Lcom_iz2use_common_BestPositionByTokenMatcher: 1,
  O: 1,
  Lcom_iz2use_common_ForeachQueryTokenMatcher: 1,
  Lcom_iz2use_common_TokenMatcher: 1
});
$c_Lcom_iz2use_common_BestPositionByTokenMatcher.prototype.$classData = $d_Lcom_iz2use_common_BestPositionByTokenMatcher;
/** @constructor */
function $c_Lcom_iz2use_common_KeyMapper$$anon$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_common_KeyMapper$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_common_KeyMapper$$anon$1.prototype.constructor = $c_Lcom_iz2use_common_KeyMapper$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_common_KeyMapper$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_KeyMapper$$anon$1.prototype = $c_Lcom_iz2use_common_KeyMapper$$anon$1.prototype;
$c_Lcom_iz2use_common_KeyMapper$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  var t = $as_T(v1);
  return $uZ(t)
});
$c_Lcom_iz2use_common_KeyMapper$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_Lcom_iz2use_common_KeyMapper$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_Lcom_iz2use_common_KeyMapper$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_Lcom_iz2use_common_KeyMapper$$anon$1.prototype.apply__O__O = (function(v1) {
  var t = $as_T(v1);
  return t
});
var $d_Lcom_iz2use_common_KeyMapper$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_common_KeyMapper$$anon$1: 0
}, false, "com.iz2use.common.KeyMapper$$anon$1", {
  Lcom_iz2use_common_KeyMapper$$anon$1: 1,
  O: 1,
  Lcom_iz2use_common_KeyMapper: 1,
  F1: 1
});
$c_Lcom_iz2use_common_KeyMapper$$anon$1.prototype.$classData = $d_Lcom_iz2use_common_KeyMapper$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_common_KeyMapper$$anon$2(f$2) {
  this.Lcom_iz2use_common_KeyMapper$$anon$2__f_f$2 = null;
  this.Lcom_iz2use_common_KeyMapper$$anon$2__f_f$2 = f$2
}
$c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype.constructor = $c_Lcom_iz2use_common_KeyMapper$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_common_KeyMapper$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_KeyMapper$$anon$2.prototype = $c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype;
$c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__T(v1))
});
$c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype.toString__T = (function() {
  return "<function1>"
});
$c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype.apply__O__T = (function(t) {
  return $as_T($n(this.Lcom_iz2use_common_KeyMapper$$anon$2__f_f$2).apply__O__O(t))
});
$c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype.apply__O__O = (function(v1) {
  return this.apply__O__T(v1)
});
var $d_Lcom_iz2use_common_KeyMapper$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_common_KeyMapper$$anon$2: 0
}, false, "com.iz2use.common.KeyMapper$$anon$2", {
  Lcom_iz2use_common_KeyMapper$$anon$2: 1,
  O: 1,
  Lcom_iz2use_common_KeyMapper: 1,
  F1: 1
});
$c_Lcom_iz2use_common_KeyMapper$$anon$2.prototype.$classData = $d_Lcom_iz2use_common_KeyMapper$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev$1, f$3) {
  this.Lcom_iz2use_common_KeyMapper$$anon$3__f_ev$1 = null;
  this.Lcom_iz2use_common_KeyMapper$$anon$3__f_f$3 = null;
  this.Lcom_iz2use_common_KeyMapper$$anon$3__f_ev$1 = ev$1;
  this.Lcom_iz2use_common_KeyMapper$$anon$3__f_f$3 = f$3
}
$c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype.constructor = $c_Lcom_iz2use_common_KeyMapper$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_common_KeyMapper$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_KeyMapper$$anon$3.prototype = $c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype;
$c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__T(v1))
});
$c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype.toString__T = (function() {
  return "<function1>"
});
$c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype.apply__O__T = (function(t) {
  return $as_T($n(this.Lcom_iz2use_common_KeyMapper$$anon$3__f_ev$1).apply__O__O($n(this.Lcom_iz2use_common_KeyMapper$$anon$3__f_f$3).apply__O__O(t)))
});
$c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype.apply__O__O = (function(v1) {
  return this.apply__O__T(v1)
});
var $d_Lcom_iz2use_common_KeyMapper$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_common_KeyMapper$$anon$3: 0
}, false, "com.iz2use.common.KeyMapper$$anon$3", {
  Lcom_iz2use_common_KeyMapper$$anon$3: 1,
  O: 1,
  Lcom_iz2use_common_KeyMapper: 1,
  F1: 1
});
$c_Lcom_iz2use_common_KeyMapper$$anon$3.prototype.$classData = $d_Lcom_iz2use_common_KeyMapper$$anon$3;
function $is_Lcom_iz2use_common_Parsable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_iz2use_common_Parsable)))
}
function $as_Lcom_iz2use_common_Parsable(obj) {
  return (($is_Lcom_iz2use_common_Parsable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.Parsable"))
}
function $isArrayOf_Lcom_iz2use_common_Parsable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_Parsable)))
}
function $asArrayOf_Lcom_iz2use_common_Parsable(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_Parsable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.Parsable;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_common_Textualizable$$anon$1(outer, f$1) {
  this.Lcom_iz2use_common_Textualizable$$anon$1__f_$outer = null;
  this.Lcom_iz2use_common_Textualizable$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_common_Textualizable$$anon$1__f_$outer = outer
  };
  this.Lcom_iz2use_common_Textualizable$$anon$1__f_f$1 = f$1
}
$c_Lcom_iz2use_common_Textualizable$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_common_Textualizable$$anon$1.prototype.constructor = $c_Lcom_iz2use_common_Textualizable$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_common_Textualizable$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Textualizable$$anon$1.prototype = $c_Lcom_iz2use_common_Textualizable$$anon$1.prototype;
$c_Lcom_iz2use_common_Textualizable$$anon$1.prototype.stringify__O__T = (function(value) {
  return $n(this.Lcom_iz2use_common_Textualizable$$anon$1__f_$outer).stringify__O__T($n(this.Lcom_iz2use_common_Textualizable$$anon$1__f_f$1).apply__O__O(value))
});
var $d_Lcom_iz2use_common_Textualizable$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_common_Textualizable$$anon$1: 0
}, false, "com.iz2use.common.Textualizable$$anon$1", {
  Lcom_iz2use_common_Textualizable$$anon$1: 1,
  O: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Textualizable$$anon$1.prototype.$classData = $d_Lcom_iz2use_common_Textualizable$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_common_Textualizable$$anon$2(f$2) {
  this.Lcom_iz2use_common_Textualizable$$anon$2__f_f$2 = null;
  this.Lcom_iz2use_common_Textualizable$$anon$2__f_f$2 = f$2
}
$c_Lcom_iz2use_common_Textualizable$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_common_Textualizable$$anon$2.prototype.constructor = $c_Lcom_iz2use_common_Textualizable$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_common_Textualizable$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Textualizable$$anon$2.prototype = $c_Lcom_iz2use_common_Textualizable$$anon$2.prototype;
$c_Lcom_iz2use_common_Textualizable$$anon$2.prototype.stringify__O__T = (function(value) {
  return $as_T($n(this.Lcom_iz2use_common_Textualizable$$anon$2__f_f$2).apply__O__O(value))
});
var $d_Lcom_iz2use_common_Textualizable$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_common_Textualizable$$anon$2: 0
}, false, "com.iz2use.common.Textualizable$$anon$2", {
  Lcom_iz2use_common_Textualizable$$anon$2: 1,
  O: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Textualizable$$anon$2.prototype.$classData = $d_Lcom_iz2use_common_Textualizable$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1) {
  this.Lcom_iz2use_common_Textualizable$$anon$3__f_textualizable$1 = null;
  this.Lcom_iz2use_common_Textualizable$$anon$3__f_textualizable$1 = textualizable$1
}
$c_Lcom_iz2use_common_Textualizable$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_common_Textualizable$$anon$3.prototype.constructor = $c_Lcom_iz2use_common_Textualizable$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_common_Textualizable$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Textualizable$$anon$3.prototype = $c_Lcom_iz2use_common_Textualizable$$anon$3.prototype;
$c_Lcom_iz2use_common_Textualizable$$anon$3.prototype.stringify__s_Option__T = (function(value) {
  var x = $m_s_None$();
  if ((x === value)) {
    return ""
  } else if ((value instanceof $c_s_Some)) {
    var x3 = $as_s_Some(value);
    var v = $n(x3).s_Some__f_value;
    return $n(this.Lcom_iz2use_common_Textualizable$$anon$3__f_textualizable$1).stringify__O__T(v)
  } else {
    throw new $c_s_MatchError(value)
  }
});
$c_Lcom_iz2use_common_Textualizable$$anon$3.prototype.stringify__O__T = (function(value) {
  return this.stringify__s_Option__T($as_s_Option(value))
});
var $d_Lcom_iz2use_common_Textualizable$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_common_Textualizable$$anon$3: 0
}, false, "com.iz2use.common.Textualizable$$anon$3", {
  Lcom_iz2use_common_Textualizable$$anon$3: 1,
  O: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Textualizable$$anon$3.prototype.$classData = $d_Lcom_iz2use_common_Textualizable$$anon$3;
/** @constructor */
function $c_Lcom_iz2use_common_Textualizable$$anon$4() {
  this.Lcom_iz2use_common_Textualizable$$anon$4__f_localDateFormatter = null;
  this.Lcom_iz2use_common_Textualizable$$anon$4__f_localDateFormatter = $m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__Ljava_time_format_DateTimeFormatter("dd/MM/yyyy")
}
$c_Lcom_iz2use_common_Textualizable$$anon$4.prototype = new $h_O();
$c_Lcom_iz2use_common_Textualizable$$anon$4.prototype.constructor = $c_Lcom_iz2use_common_Textualizable$$anon$4;
/** @constructor */
function $h_Lcom_iz2use_common_Textualizable$$anon$4() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Textualizable$$anon$4.prototype = $c_Lcom_iz2use_common_Textualizable$$anon$4.prototype;
$c_Lcom_iz2use_common_Textualizable$$anon$4.prototype.stringify__O__T = (function(value) {
  var value$1 = $as_Ljava_time_LocalDate(value);
  return $n(this.Lcom_iz2use_common_Textualizable$$anon$4__f_localDateFormatter).format__Ljava_time_temporal_TemporalAccessor__T(value$1)
});
var $d_Lcom_iz2use_common_Textualizable$$anon$4 = new $TypeData().initClass({
  Lcom_iz2use_common_Textualizable$$anon$4: 0
}, false, "com.iz2use.common.Textualizable$$anon$4", {
  Lcom_iz2use_common_Textualizable$$anon$4: 1,
  O: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Textualizable$$anon$4.prototype.$classData = $d_Lcom_iz2use_common_Textualizable$$anon$4;
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$() {
  this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil = null;
  $n_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$ = this;
  this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1()
}
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$.prototype = $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$.prototype;
var $d_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$ = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$: 0
}, false, "com.iz2use.common.internal.tokenizer.AccumulatingTokenizer$", {
  Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$: 1,
  O: 1,
  Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizerLowPriorityImplicits: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$;
var $n_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$;
function $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$() {
  if ((!$n_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$)) {
    $n_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$ = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$()
  };
  return $n_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$
}
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1.prototype = $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1.prototype;
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1.prototype.tokenize__Lshapeless_HList__Lcom_iz2use_common_Filter__sci_List = (function(in$1, filter) {
  $as_Lshapeless_HNil(in$1);
  return $m_s_package$().s_package$__f_Nil
});
var $d_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1: 0
}, false, "com.iz2use.common.internal.tokenizer.AccumulatingTokenizer$$anon$1", {
  Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1: 1,
  O: 1,
  Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$1) {
  this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2__f_tt$1 = null;
  this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2__f_ht$1 = null;
  this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2__f_witness$1 = null;
  this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2__f_tt$1 = tt$1;
  this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2__f_ht$1 = ht$1;
  this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2__f_witness$1 = witness$1
}
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2.prototype = $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2.prototype;
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2.prototype.tokenize__Lshapeless_$colon$colon__Lcom_iz2use_common_Filter__sci_List = (function(in$1, filter) {
  var tail = $n(this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2__f_tt$1).tokenize__Lshapeless_HList__Lcom_iz2use_common_Filter__sci_List($n(in$1).Lshapeless_$colon$colon__f_tail, filter);
  var this$1 = $n($n(this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2__f_ht$1).Lcom_iz2use_common_FailableImplicit__f_value);
  if (this$1.isEmpty__Z()) {
    var $$x1 = tail
  } else {
    var arg1 = this$1.get__O();
    var tokenizer = $as_Lcom_iz2use_common_internal_tokenizer_Tokenizer(arg1);
    var self = $n(this.Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2__f_witness$1).value__O();
    var y = $n(tokenizer).tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_Tokenized($n(in$1).Lshapeless_$colon$colon__f_head, filter);
    var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, y);
    var this$4 = $n(tail);
    var $$x1 = new $c_sci_$colon$colon(rassoc$1, this$4)
  };
  return $as_sci_List($$x1)
});
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2.prototype.tokenize__Lshapeless_HList__Lcom_iz2use_common_Filter__sci_List = (function(in$1, filter) {
  return this.tokenize__Lshapeless_$colon$colon__Lcom_iz2use_common_Filter__sci_List($as_Lshapeless_$colon$colon(in$1), filter)
});
var $d_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2: 0
}, false, "com.iz2use.common.internal.tokenizer.AccumulatingTokenizer$$anon$2", {
  Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2: 1,
  O: 1,
  Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer$1, gen$1) {
  this.Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1__f_tokenizer$1 = null;
  this.Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1__f_gen$1 = null;
  this.Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1__f_tokenizer$1 = tokenizer$1;
  this.Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1__f_gen$1 = gen$1
}
$c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1.prototype = $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1.prototype;
$c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1.prototype.tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_MappedTokenized = (function(in$1, filter) {
  var this$2 = $n($n(this.Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1__f_tokenizer$1).tokenize__Lshapeless_HList__Lcom_iz2use_common_Filter__sci_List($as_Lshapeless_HList($n(this.Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1__f_gen$1).to__O__O(in$1)), filter));
  var this$1 = $m_s_$less$colon$less$();
  return new $c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$2), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_F1(x0$1$2);
    var x1$1 = $as_sci_Map(x1$1$2);
    return $n(x1$1).forall__F1__Z(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_T2(x$1$2);
      return $n($as_Lcom_iz2use_common_internal_tokenizer_Tokenized($n(x$1)._2__O())).process__F1__Z(x0$1)
    })))
  })))
});
$c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1.prototype.tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_Tokenized = (function(in$1, filter) {
  return this.tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_MappedTokenized(in$1, filter)
});
var $d_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1: 0
}, false, "com.iz2use.common.internal.tokenizer.ObjectTokenizer$$anon$1", {
  Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1: 1,
  O: 1,
  Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer: 1,
  Lcom_iz2use_common_internal_tokenizer_Tokenizer: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$() {
  /*<skip>*/
}
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_Tokenizer$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_Tokenizer$.prototype = $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$.prototype;
var $d_Lcom_iz2use_common_internal_tokenizer_Tokenizer$ = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_Tokenizer$: 0
}, false, "com.iz2use.common.internal.tokenizer.Tokenizer$", {
  Lcom_iz2use_common_internal_tokenizer_Tokenizer$: 1,
  O: 1,
  Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits: 1,
  Lcom_iz2use_common_internal_tokenizer_TokenizerLowPriorityImplicits: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_Tokenizer$;
var $n_Lcom_iz2use_common_internal_tokenizer_Tokenizer$;
function $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$() {
  if ((!$n_Lcom_iz2use_common_internal_tokenizer_Tokenizer$)) {
    $n_Lcom_iz2use_common_internal_tokenizer_Tokenizer$ = new $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$()
  };
  return $n_Lcom_iz2use_common_internal_tokenizer_Tokenizer$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_handleEvent = null;
  this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_handleEvent = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lcom_iz2use_react_components_Dialog$Event(x0$1$2);
    if ((x0$1 instanceof $c_Lcom_iz2use_react_components_Dialog$Push)) {
      var x2 = $as_Lcom_iz2use_react_components_Dialog$Push(x0$1);
      var f = $n(x2).Lcom_iz2use_react_components_Dialog$Push__f_f;
      var this$5 = $n(this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_sci_List(x$1$2);
        var self = $m_ju_UUID$().randomUUID__ju_UUID();
        var rassoc$1 = $ct_T2__O__O__(new $c_T2(), self, f);
        var this$4 = $n(x$1);
        return new $c_sci_$colon$colon(rassoc$1, this$4)
      }));
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$5, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else if ((x0$1 instanceof $c_Lcom_iz2use_react_components_Dialog$PushWithKey)) {
      var x3 = $as_Lcom_iz2use_react_components_Dialog$PushWithKey(x0$1);
      var key = $n(x3).Lcom_iz2use_react_components_Dialog$PushWithKey__f_key;
      var f$2 = $n(x3).Lcom_iz2use_react_components_Dialog$PushWithKey__f_f;
      var this$10 = $n(this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_$);
      var mod$1 = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_sci_List(s$2);
        var this$6 = $n(s);
        _return: {
          var these = this$6;
          while ((!$n(these).isEmpty__Z())) {
            var arg1 = $n(these).head__O();
            var x$2 = $as_T2(arg1);
            var x = $n(x$2)._1__O();
            if (((x === null) ? (key === null) : $dp_equals__O__Z($n(x), key))) {
              var $$x2 = true;
              break _return
            };
            these = $as_sci_List($n(these).tail__O())
          };
          var $$x2 = false
        };
        if ($$x2) {
          return s
        } else {
          var rassoc$2 = $ct_T2__O__O__(new $c_T2(), key, f$2);
          var this$9 = $n(s);
          return new $c_sci_$colon$colon(rassoc$2, this$9)
        }
      }));
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$10, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else {
      var x$3 = $m_Lcom_iz2use_react_components_Dialog$Pop$();
      if ((x$3 === x0$1)) {
        var this$11 = $n(this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_$);
        var mod$2 = new $c_sjsr_AnonFunction1(((s$3$2) => {
          var s$3 = $as_sci_List(s$3$2);
          return ($n(s$3).isEmpty__Z() ? s$3 : $as_sci_List($n(s$3).tail__O()))
        }));
        var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$11, mod$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
      } else {
        var $$x1;
        throw new $c_s_MatchError(x0$1)
      }
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))
}
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_Dialog$Placeholder$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype = $c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype;
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_Dialog$Placeholder$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype.handleClick__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var x = e$2.target;
    var y = e$2.currentTarget;
    var cond = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    if (cond) {
      var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline($m_Lcom_iz2use_react_components_Dialog$Pop$())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype.render__Lcom_iz2use_react_components_Dialog$Placeholder$Props__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x8 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var this$20 = $n(s);
  var f = ((dialog$2) => {
    var dialog = $as_T2(dialog$2);
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + $n(dialog)._1__O()), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var this$8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
    var this$9 = $n(this$8.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
    var x$2 = $n(s).head__O();
    var condition = ((dialog === null) ? (x$2 === null) : $n(dialog).equals__O__Z(x$2));
    var condition$1 = (!condition);
    var $$x4 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$9, condition$1);
    var this$10 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_dialogContainerWrapper;
    var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s$1);
    var $$x2 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.handleClick__F1(), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$13 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $n(arg1).Lcom_iz2use_react_style_Style__f_dialogContainer;
    var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$13, s$2), $as_Ljapgolly_scalajs_react_vdom_TagMod($n(dialog)._2__O())];
    var array$1 = [$$x5, $$x4, $$x3, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  });
  if ((this$20 === $m_sci_Nil$())) {
    var $$x7 = $m_sci_Nil$()
  } else {
    var arg1$1 = this$20.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$20.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x7 = h
  };
  return $n($$x8).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("Dialog", $$x7)
});
function $as_Lcom_iz2use_react_components_Dialog$Placeholder$Backend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Dialog$Placeholder$Backend"))
}
function $isArrayOf_Lcom_iz2use_react_components_Dialog$Placeholder$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Dialog$Placeholder$Backend)))
}
function $asArrayOf_Lcom_iz2use_react_components_Dialog$Placeholder$Backend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Dialog$Placeholder$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Dialog$Placeholder$Backend;", depth))
}
var $d_Lcom_iz2use_react_components_Dialog$Placeholder$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_Dialog$Placeholder$Backend: 0
}, false, "com.iz2use.react.components.Dialog$Placeholder$Backend", {
  Lcom_iz2use_react_components_Dialog$Placeholder$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_Dialog$Placeholder$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_Gesture$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_Gesture$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_Gesture$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_Gesture$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_Gesture$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_Gesture$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_Gesture$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Gesture$Backend.prototype = $c_Lcom_iz2use_react_components_Gesture$Backend.prototype;
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_Gesture$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_Gesture$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.render__Lcom_iz2use_react_components_Gesture$Props__jl_Void__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s, c) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c))];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.init__Lcom_iz2use_react_components_Gesture$Props__Lhammer_Hammer__T__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, hammer, eventList) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($n(p).Lcom_iz2use_react_components_Gesture$Props__f_events);
    var m = $as_scm_Map($m_scm_Map$().empty__O());
    var it = this$2.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var x$1 = $as_Lcom_iz2use_react_components_Gesture$GestureType(elem);
      $n(x$1);
      var key = new $c_s_Some($m_Lhammer_Recognizers$().Lhammer_Recognizers$__f_swipe);
      var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$2) => (() => this$2.newSpecificBuilder__scm_Builder()))(this$2))));
      var this$4 = $n(bldr);
      this$4.addOne__O__scm_Growable(elem)
    };
    var this$5 = $m_sci_HashMap$();
    var result = this$5.sci_HashMap$__f_EmptyMap;
    var mapIt = $n(m).iterator__sc_Iterator();
    while ($n(mapIt).hasNext__Z()) {
      var x1 = $as_T2($n(mapIt).next__O());
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1)
      };
      var k = $n(x1)._1__O();
      var v = $as_scm_Builder($n(x1)._2__O());
      result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
    };
    var this$6 = $n(result);
    var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var recognizer = $as_s_Option($n(x0$1)._1__O());
        var gestures = $as_sci_Seq($n(x0$1)._2__O());
        if ((recognizer instanceof $c_s_Some)) {
          var x2 = $as_s_Some(recognizer);
          var recognizer$2 = $n(x2).s_Some__f_value;
          hammer.get(recognizer$2).set($m_Lhammer_RecognizerOptions$().apply__I__Lhammer_RecognizerOptions($uI($n($as_sc_IterableOnceOps($n(gestures).map__F1__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
            var x$2 = $as_Lcom_iz2use_react_components_Gesture$GestureType(x$2$2);
            return $n(x$2).direction__I()
          }))))).reduceLeft__F2__O(new $c_sjsr_AnonFunction2(((x$3$2, x$4$2) => {
            var x$3 = $uI(x$3$2);
            var x$4 = $uI(x$4$2);
            return (x$3 | x$4)
          }))))))
        } else {
          var x = $m_s_None$();
          if ((!(x === recognizer))) {
            throw new $c_s_MatchError(recognizer)
          }
        }
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    }));
    $n(this$6.sci_HashMap__f_rootNode).foreach__F1__V(f);
    hammer.on(eventList, ((arg1$2) => {
      this.com$iz2use$react$components$Gesture$Backend$$$anonfun$init$6__Lhammer_HammerEvent__Lcom_iz2use_react_components_Gesture$Props__V(arg1$2, p)
    }))
  }));
  var f$2 = new $c_sjsr_AnonFunction0((() => {
    f$1.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2)
});
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.destroy__Lhammer_Hammer__T__Ljapgolly_scalajs_react_callback_Trampoline = (function(hammer, eventList) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    hammer.off(eventList);
    hammer.destroy()
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.initHammer__Lcom_iz2use_react_components_Gesture$Props__Ljapgolly_scalajs_react_callback_Trampoline = (function(p) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_Gesture$Backend__f_$).getDOMNode__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Ljapgolly_scalajs_react_ComponentDom(x$5$2);
    return $n(x$5).toElement__s_Option()
  }));
  var this$3 = $n(this$);
  var $$x1 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$3, f);
  var this$4 = $m_s_$less$colon$less$();
  var co = $n($$x3).flatMap$extension__F0__F1__F0($n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$4.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((node$2) => {
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f$1 = new $c_sjsr_AnonFunction0((() => new ($moduleDefault($i_hammerjs$002fhammer))(node$2)));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var this$$1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1);
    var f$2 = new $c_sjsr_AnonFunction1(((hammer$2) => {
      var this$8 = $n($as_sc_IterableOnceOps($n($n(p).Lcom_iz2use_react_components_Gesture$Props__f_events).map__F1__O(new $c_sjsr_AnonFunction1(((x$6$2) => {
        var x$6 = $as_Lcom_iz2use_react_components_Gesture$GestureType(x$6$2);
        var this$7 = $n($n(x$6).toString__T());
        return $as_T(this$7.toLowerCase())
      })))));
      var eventList = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "", " ", "");
      return $ct_T2__O__O__(new $c_T2(), hammer$2, eventList)
    }));
    var c = $n($$x4).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$2), new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9 = $as_T2(x$9$2);
      if ((x$9 !== null)) {
        var hammer = $n(x$9)._1__O();
        var eventList$1 = $as_T($n(x$9)._2__O());
        var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this.init__Lcom_iz2use_react_components_Gesture$Props__Lhammer_Hammer__T__Ljapgolly_scalajs_react_callback_Trampoline(p, hammer, eventList$1), new $c_sjsr_AnonFunction1(((x$8$2) => {
          $as_jl_Void(x$8$2);
          var f$3 = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.destroy__Lhammer_Hammer__T__Ljapgolly_scalajs_react_callback_Trampoline(hammer, eventList$1))));
          var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
          var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_extra_OnUnmountF__onUnmount__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, f$3, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var f$4 = new $c_sjsr_AnonFunction1(((x$7$2) => {
            $as_jl_Void(x$7$2)
          }));
          var this$12 = $n(this$$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$12, f$4))
        })))
      } else {
        var $$x5;
        throw new $c_s_MatchError(x$9)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x5)
    })));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  })));
  var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$15 = $m_s_$less$colon$less$();
  return $n($$x6).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$15.s_$less$colon$less$__f_singleton)
});
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.com$iz2use$react$components$Gesture$Backend$$$anonfun$init$6__Lhammer_HammerEvent__Lcom_iz2use_react_components_Gesture$Props__V = (function(ev, p$1) {
  if ($uZ(ev.isFinal)) {
    var x1 = $as_T(ev.type);
    matchEnd4: {
      if ((x1 !== null)) {
        var o7 = $m_Lcom_iz2use_react_components_Gesture$GestureType$().unapply__T__s_Option(x1);
        if ((!$n(o7).isEmpty__Z())) {
          var gestureType = $as_Lcom_iz2use_react_components_Gesture$GestureType($n(o7).get__O());
          var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p$1).Lcom_iz2use_react_components_Gesture$Props__f_cbo).apply__O__O(gestureType))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var this$2 = $n(this$);
          $as_jl_Void($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2));
          break matchEnd4
        }
      }
    }
  }
});
function $as_Lcom_iz2use_react_components_Gesture$Backend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Gesture$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Gesture$Backend"))
}
function $isArrayOf_Lcom_iz2use_react_components_Gesture$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Gesture$Backend)))
}
function $asArrayOf_Lcom_iz2use_react_components_Gesture$Backend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Gesture$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Gesture$Backend;", depth))
}
var $d_Lcom_iz2use_react_components_Gesture$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_Gesture$Backend: 0
}, false, "com.iz2use.react.components.Gesture$Backend", {
  Lcom_iz2use_react_components_Gesture$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_Gesture$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_Gesture$Backend;
function $p_Lcom_iz2use_react_components_LinkedViews$Backend__toggle$1__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((idx$2) => {
    var idx = $uI(idx$2);
    var this$4 = $n($thiz.Lcom_iz2use_react_components_LinkedViews$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((lst$2) => {
      var lst = $as_sci_List(lst$2);
      if ($n(lst).contains__O__Z(idx)) {
        var this$2 = $n(lst);
        var f = ((x$1$2) => {
          var x$1 = $uI(x$1$2);
          return (x$1 !== idx)
        });
        var l = this$2;
        block: {
          var result;
          while (true) {
            if ($n(l).isEmpty__Z()) {
              var result = $m_sci_Nil$();
              break
            } else {
              var h = $n(l).head__O();
              var t = $as_sci_List($n(l).tail__O());
              if (($uZ(f(h)) === false)) {
                l = t;
                continue
              };
              var start = l;
              var remaining = t;
              while (true) {
                if ($n(remaining).isEmpty__Z()) {
                  var result = start;
                  break block
                } else {
                  var x = $n(remaining).head__O();
                  if (($uZ(f(x)) !== false)) {
                    remaining = $as_sci_List($n(remaining).tail__O());
                    continue
                  };
                  var firstMiss = remaining;
                  var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                  var toProcess = $as_sci_List($n(start).tail__O());
                  var currentLast = newHead;
                  while ((toProcess !== firstMiss)) {
                    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem;
                    currentLast = newElem;
                    toProcess = $as_sci_List($n(toProcess).tail__O())
                  };
                  var next = $as_sci_List($n(firstMiss).tail__O());
                  var nextToCopy = next;
                  while ((!$n(next).isEmpty__Z())) {
                    var head = $n(next).head__O();
                    if (($uZ(f(head)) !== false)) {
                      next = $as_sci_List($n(next).tail__O())
                    } else {
                      while ((nextToCopy !== next)) {
                        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                        currentLast = newElem$2;
                        nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                      };
                      nextToCopy = $as_sci_List($n(next).tail__O());
                      next = $as_sci_List($n(next).tail__O())
                    }
                  };
                  if ((!$n(nextToCopy).isEmpty__Z())) {
                    $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                  };
                  var result = newHead;
                  break block
                }
              }
            }
          }
        };
        return result
      } else {
        var this$3 = $n(lst);
        return new $c_sci_$colon$colon(idx, this$3)
      }
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$4, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_LinkedViews$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_LinkedViews$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_LinkedViews$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_LinkedViews$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_LinkedViews$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_LinkedViews$Backend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_LinkedViews$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_LinkedViews$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_LinkedViews$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_LinkedViews$Backend.prototype = $c_Lcom_iz2use_react_components_LinkedViews$Backend.prototype;
$c_Lcom_iz2use_react_components_LinkedViews$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_LinkedViews$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_LinkedViews$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_LinkedViews$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_LinkedViews$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_LinkedViews$Backend.prototype.render__Lcom_iz2use_react_components_LinkedViews$Props__sci_List__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s, children) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var this$2 = $n($m_Ljapgolly_scalajs_react_PropsChildren$().toList$extension__sjs_js_Any__sci_List(children));
  var x1 = $as_sci_List($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$2));
  if ((x1 !== null)) {
    var o7 = $n($m_s_package$().s_package$__f_$colon$plus).unapply__sc_SeqOps__s_Option(x1);
    if ((!$n(o7).isEmpty__Z())) {
      var init = $as_sci_List($n($as_T2($n(o7).get__O()))._1__O());
      var last = $as_T2($n($as_T2($n(o7).get__O()))._2__O());
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$5 = $m_Lscalacss_ScalaCssReact$();
      var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_linkedViewContainer;
      var $$x4 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s$1);
      var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), init), new $c_sjsr_AnonFunction1(((view$2) => {
        var view = $as_T2(view$2);
        var $$x3 = $m_Lcom_iz2use_react_components_LinkedView$();
        var this$8 = $n(view)._2$mcI$sp__I();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = $n(view)._1__O();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        return $n($$x3).withKey__T__Ljapgolly_scalajs_react_vdom_VdomNode__I__Z__Z__F1__s_PartialFunction__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagOf(("" + this$8), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v), $n(view)._2$mcI$sp__I(), true, $n(s).contains__O__Z($n(view)._2$mcI$sp__I()), $p_Lcom_iz2use_react_components_LinkedViews$Backend__toggle$1__F1(this), $n(p).Lcom_iz2use_react_components_LinkedViews$Props__f_close, arg1)
      })));
      var $$x1 = $m_Lcom_iz2use_react_components_LinkedView$();
      var this$12 = $n(last)._2$mcI$sp__I();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(last)._1__O();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [$$x4, $$x2, $n($$x1).withKey__T__Ljapgolly_scalajs_react_vdom_VdomNode__I__Z__Z__F1__s_PartialFunction__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagOf(("" + this$12), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1), $n(last)._2$mcI$sp__I(), false, $n(s).contains__O__Z($n(last)._2$mcI$sp__I()), $p_Lcom_iz2use_react_components_LinkedViews$Backend__toggle$1__F1(this), $n(p).Lcom_iz2use_react_components_LinkedViews$Props__f_close, arg1)];
      return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    }
  };
  throw new $c_s_MatchError(x1)
});
function $as_Lcom_iz2use_react_components_LinkedViews$Backend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_LinkedViews$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.LinkedViews$Backend"))
}
function $isArrayOf_Lcom_iz2use_react_components_LinkedViews$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_LinkedViews$Backend)))
}
function $asArrayOf_Lcom_iz2use_react_components_LinkedViews$Backend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_LinkedViews$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.LinkedViews$Backend;", depth))
}
var $d_Lcom_iz2use_react_components_LinkedViews$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_LinkedViews$Backend: 0
}, false, "com.iz2use.react.components.LinkedViews$Backend", {
  Lcom_iz2use_react_components_LinkedViews$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_LinkedViews$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_LinkedViews$Backend;
function $ct_Lcom_iz2use_react_components_Multiview$ZTypedBackend__($thiz) {
  $thiz.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f$1 = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x1;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x1 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $n(x5).s_Some__f_value;
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_Multiview$ZBackend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f = new $c_sjsr_AnonFunction1(((p$2) => {
          var p = $as_Lcom_iz2use_react_components_Multiview$TypedProps(p$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_sourceHandler).update__O__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_source, v, cb$2, $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_hasIterator, $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_keyMapper))
        }));
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f);
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  $thiz.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_updateFn = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$1);
  $thiz.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_context = new $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1($thiz);
  var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_Multiview$ZBackend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$6 = $n(this$$1);
  var props = $as_Lcom_iz2use_react_components_Multiview$TypedProps($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$6));
  var reusabilityT = $n(props).Lcom_iz2use_react_components_Multiview$TypedProps__f_reusabilityT;
  var reusabilityC = $n(props).Lcom_iz2use_react_components_Multiview$TypedProps__f_reusabilityC;
  var hasIterator = $n(props).Lcom_iz2use_react_components_Multiview$TypedProps__f_hasIterator;
  var this$10 = $m_Lcom_iz2use_react_components_MultiviewRefiner$();
  var array = [new $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner(), new $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner(), new $c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner()];
  var in$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var lastRenderer = new $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$2($thiz, hasIterator);
  $thiz.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_refiner = $p_Lcom_iz2use_react_components_MultiviewRefiner$__traverse__sci_List__Lcom_iz2use_react_components_NextRefinerRenderer__Lcom_iz2use_react_components_internal_multiview_HasIterator__F2__F1__Lcom_iz2use_react_components_NextRefinerRenderer(this$10, ($m_sci_List$(), $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(in$1)), lastRenderer, hasIterator, reusabilityT, reusabilityC);
  $thiz.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_sourceChange = new $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$3($thiz);
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Lcom_iz2use_react_components_Multiview$TypedState(x$10$2);
    return $n(x$10).Lcom_iz2use_react_components_Multiview$TypedState__f_view
  }));
  var set = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lcom_iz2use_react_components_internal_multiview_View(s$2);
    return new $c_sjsr_AnonFunction1(((x$11$2) => {
      var x$11 = $as_Lcom_iz2use_react_components_Multiview$TypedState(x$11$2);
      var this$12 = $n(x$11);
      var x$2 = this$12.Lcom_iz2use_react_components_Multiview$TypedState__f_content;
      $n(x$11);
      return new $c_Lcom_iz2use_react_components_Multiview$TypedState(x$2, s)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var $$x2 = $thiz.Lcom_iz2use_react_components_Multiview$ZBackend__f_$;
  var this$16 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$16.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  $thiz.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_viewState = $n($$x4).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x3, $$x2, w);
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend() {
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_updateFn = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_context = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_refiner = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_sourceChange = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_viewState = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_Multiview$ZTypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Multiview$ZTypedBackend.prototype = $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend.prototype;
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_Multiview$ZTypedBackend.prototype.render__Lcom_iz2use_react_components_Multiview$TypedProps__Lcom_iz2use_react_components_Multiview$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var this$81 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var f$1 = new $c_sjsr_AnonFunction1(((style$2) => {
    var style = $as_Lcom_iz2use_react_style_Style(style$2);
    var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$4 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $n(style).Lcom_iz2use_react_style_Style__f_multiviewContainer;
    var $$x18 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
    var $$x17 = $m_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$();
    var $$x16 = new $c_sjsr_AnonFunction1(((x$12$2) => {
      $uI(x$12$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    }));
    var x$1 = $n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_views).Lcom_iz2use_react_components_internal_multiview_HasViews__f_views;
    var x$2 = $n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_viewState).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2());
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var x$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Disposition");
    $m_Lcom_iz2use_react_components_Selector$();
    var x$4 = true;
    var x$5 = new $c_sjsr_AnonFunction1(((view$2) => {
      var view = $as_Lcom_iz2use_react_components_internal_multiview_View(view$2);
      var $$x12 = $m_Lcom_iz2use_react_components_Icon$();
      var this$8 = $n(view);
      return $n($$x12).apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf(this$8.icon__Lcom_iz2use_react_components_IconSourceShape(), $n(view).name__T(), "24px")
    }));
    var x$6 = $m_Lcom_iz2use_react_components_Selector$().apply$default$6__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1(x$1, x$2, x$3, x$4);
    var $$x14 = $m_Lcom_iz2use_react_components_Selector$();
    var this$9 = $m_Lcom_iz2use_react_components_Selector$Focusable$();
    var $$x13 = new $c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3(this$9);
    $m_Lcom_iz2use_common_KeyMapper$();
    var f = $m_Lcom_iz2use_react_components_internal_multiview_View$().keyMapper__F1();
    var u = $n($$x14).apply__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1__F1__Lcom_iz2use_react_components_Selector$Focusable__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_Selector__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(x$1, x$2, x$3, x$4, x$5, x$6, $$x13, new $c_Lcom_iz2use_common_KeyMapper$$anon$2(f), ($m_Lcom_iz2use_react_components_Selector$(), new $c_Lcom_iz2use_react_components_Selector$$anon$2()));
    var this$13 = $n(u);
    var n = this$13.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x15 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$17 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $n(style).Lcom_iz2use_react_style_Style__f_multiviewSearch;
    var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$17, s$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chercher");
    var state = $n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$13$2) => {
      var x$13 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(x$13$2);
      return $n(x$13).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query
    })), new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_s_Option(v$2);
      return new $c_sjsr_AnonFunction1(((x$14$2) => {
        var x$14 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(x$14$2);
        var this$20 = $n(x$14);
        var x$8 = this$20.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view;
        var this$21 = $n(x$14);
        var x$9 = this$21.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected;
        var this$22 = $n(x$14);
        var x$10 = this$22.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders;
        $n(x$14);
        return new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(x$8, x$9, v, x$10)
      }))
    })));
    var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var filter = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
    var fieldRenderers = $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_fields;
    var parser = new $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1(filter, fieldRenderers);
    var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$27 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$27);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv = $m_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$().equiv__s_math_Equiv();
    var array = [$$x10, editorComponent.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement("search", label, state, optioner, ev, explainError, equiv)];
    var $$x9 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$36 = $m_Lscalacss_ScalaCssReact$();
    var s$3 = $n(style).Lcom_iz2use_react_style_Style__f_multiviewRender;
    var $$x7 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$36, s$3);
    var s$4 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var x$15 = $n(s$4).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders;
    var x$16$1 = $n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$15$2$2) => {
      var x$15$2 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(x$15$2$2);
      return $n(x$15$2).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders
    })), new $c_sjsr_AnonFunction1(((v$3$2) => {
      var v$3 = $as_sci_List(v$3$2);
      return new $c_sjsr_AnonFunction1(((x$16$2) => {
        var x$16 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(x$16$2);
        var this$37 = $n(x$16);
        var x$12$1 = this$37.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view;
        var this$38 = $n(x$16);
        var x$13$1 = this$38.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected;
        var this$39 = $n(x$16);
        var x$14$1 = this$39.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query;
        $n(x$16);
        return new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(x$12$1, x$13$1, x$14$1, v$3)
      }))
    })));
    var x$17 = ($n($n(s$4).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders).isEmpty__Z() ? ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Tri par d\u00e9faut")) : ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Tri par")));
    $m_Lcom_iz2use_react_components_Selector$();
    var x$18 = true;
    var x$19 = new $c_sjsr_AnonFunction1(((order$2) => {
      var order = $as_Lcom_iz2use_react_components_internal_multiview_Order(order$2);
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(order).Lcom_iz2use_react_components_internal_multiview_Order__f_field;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [($n(order).Lcom_iz2use_react_components_internal_multiview_Order__f_ascending ? ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("(a-z)")) : ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("(z-a)"))), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => {
        var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        $m_Ljapgolly_scalajs_react_package$();
        var this$56 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$56.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$57 = $n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_context);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $f_Lcom_iz2use_react_components_internal_multiview_MultiviewContext__toggleOrAddOrder__Lcom_iz2use_react_components_internal_multiview_Order__Ljapgolly_scalajs_react_callback_Trampoline(this$57, order)))
      })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
      var array$2 = [$$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
      return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    }));
    var x$20 = $m_Lcom_iz2use_react_components_Selector$().apply$default$6__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1(x$15, x$16$1, x$17, x$18);
    var $$x6 = $m_Lcom_iz2use_react_components_Selector$();
    var this$64 = $m_Lcom_iz2use_react_components_Selector$Focusable$();
    var u$1 = $n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1__F1__Lcom_iz2use_react_components_Selector$Focusable__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_Selector__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(x$15, x$16$1, x$17, x$18, x$19, x$20, new $c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3(this$64), $m_Lcom_iz2use_react_components_internal_multiview_Order$().Lcom_iz2use_react_components_internal_multiview_Order$__f_keyMapper, ($m_Lcom_iz2use_react_components_Selector$(), new $c_Lcom_iz2use_react_components_Selector$$anon$1()));
    var this$67 = $n(u$1);
    var n$1 = this$67.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$3 = [$$x7, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
    var array$4 = [$$x9, $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    var u$2 = $n($$x17).apply__Lcom_iz2use_react_style_Style__F1__Ljapgolly_scalajs_react_vdom_VdomNode__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(style, $$x16, $$x15, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var this$76 = $n(u$2);
    var n$2 = this$76.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$5 = [$$x18, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2), $n(this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_refiner).apply__Lcom_iz2use_react_components_internal_multiview_MultiviewState__Ljapgolly_scalajs_react_vdom_VdomElement(new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewState($n(s).Lcom_iz2use_react_components_Multiview$TypedState__f_content, $n(s).Lcom_iz2use_react_components_Multiview$TypedState__f_view, $as_s_Option($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState($n($n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_keyMapper, $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter, $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_fields, $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_tokenizer, $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_decorator, $n(p).Lcom_iz2use_react_components_Multiview$TypedProps__f_itemSimpleActions))];
    return $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
  }));
  return $as_Ljapgolly_scalajs_react_vdom_VdomElement(f$1.apply__O__O(this$81.Lcom_iz2use_react_components_StyleConsumer$__f_style))
});
function $as_Lcom_iz2use_react_components_Multiview$ZTypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Multiview$ZTypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Multiview$ZTypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_Multiview$ZTypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Multiview$ZTypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_Multiview$ZTypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Multiview$ZTypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Multiview$ZTypedBackend;", depth))
}
function $ct_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__Lcom_iz2use_react_components_MultiviewRefinerReactComponent__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_$outer = outer
  };
  $thiz.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend() {
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_$outer = null
}
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend.prototype = $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_multiview_MultiviewState__O__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var $$x1 = $n($n(this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_$outer).Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_nextRenderer);
  var this$1 = $n(p);
  var arg1 = this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
  return $n($$x1).apply__Lcom_iz2use_react_components_internal_multiview_MultiviewState__Ljapgolly_scalajs_react_vdom_VdomElement(new $c_Lcom_iz2use_react_components_internal_multiview_MultiviewState($n($n(this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_$outer).Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_refiner).apply__O__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ldiode_data_Pot(s, arg1, $n(this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_$outer).Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_com$iz2use$react$components$MultiviewRefinerReactComponent$$iterable), this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_view, this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_active, this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState, this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_keyMapper, this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_filter, this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_fields, this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_tokenizer, this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_decorator, this$1.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_itemSimpleActions))
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend.prototype.onPropsChange__Lcom_iz2use_react_components_internal_multiview_MultiviewState__Lcom_iz2use_react_components_internal_multiview_MultiviewState__O__Ljapgolly_scalajs_react_callback_Trampoline = (function(prev, next, state) {
  var this$2 = $n(this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var x1 = $n($n(this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_$outer).Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_refiner).handleNext__Lcom_iz2use_react_components_internal_multiview_MultiviewState__s_Option__s_Option__Lcom_iz2use_react_components_internal_multiview_HasIterator__s_Option(next, new $c_s_Some(prev), new $c_s_Some(s$2), $n(this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_$outer).Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_com$iz2use$react$components$MultiviewRefinerReactComponent$$iterable);
    var x = $m_s_None$();
    if ((x === x1)) {
      return s$2
    } else if ((x1 instanceof $c_s_Some)) {
      var x3 = $as_s_Some(x1);
      var s$2$1 = $n(x3).s_Some__f_value;
      return s$2$1
    } else {
      throw new $c_s_MatchError(x1)
    }
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
function $as_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.MultiviewRefinerReactComponent$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.MultiviewRefinerReactComponent$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_PlatformDependent$TypedBackend() {
  this.Lcom_iz2use_react_components_PlatformDependent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_PlatformDependent$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_PlatformDependent$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_PlatformDependent$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_PlatformDependent$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_PlatformDependent$TypedBackend.prototype = $c_Lcom_iz2use_react_components_PlatformDependent$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_PlatformDependent$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_PlatformDependent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_PlatformDependent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_PlatformDependent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_PlatformDependent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
function $as_Lcom_iz2use_react_components_PlatformDependent$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_PlatformDependent$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.PlatformDependent$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_PlatformDependent$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_PlatformDependent$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_PlatformDependent$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_PlatformDependent$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.PlatformDependent$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$TypedBackend() {
  this.Lcom_iz2use_react_components_Selector$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_Selector$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$TypedBackend.prototype = $c_Lcom_iz2use_react_components_Selector$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_Selector$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_Selector$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_Selector$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_Selector$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_Selector$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_Selector$TypedBackend.prototype.reset__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$1 = $n(this.Lcom_iz2use_react_components_Selector$Backend__f_$);
  var newState = $m_s_None$();
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$1, newState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_Selector$TypedBackend.prototype.render__Lcom_iz2use_react_components_Selector$TypedProps__s_Option__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var active = $n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_selectorLabelContainer;
  var $$x14 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
  var $$x13 = $n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_label;
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x11 = $n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_out).containerClass__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagMod(arg1);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$9 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$9.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onKeyDown");
  var eta$0$1 = new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13 = $as_F1(x$13$2);
    var this$13 = $n(this.Lcom_iz2use_react_components_Selector$Backend__f_$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$13, x$13))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var eta$1$1 = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.reset__Ljapgolly_scalajs_react_callback_Trampoline())));
  var $$x9 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_out).handleKeys__Lcom_iz2use_react_components_Selector$TypedProps__s_Option__F1__F0__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline(p, s, eta$0$1, eta$1$1, e$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  var $$x8 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onBlur")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.reset__Ljapgolly_scalajs_react_callback_Trampoline()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_out).wrapList__sci_Seq__sci_Seq($as_sci_Seq($n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_items).map__F1__O(new $c_sjsr_AnonFunction1(((item$2) => {
    var key = $as_T($n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(item$2));
    var $$x6 = $n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_out);
    var $$x5 = new $c_sjsr_AnonFunction1(((x$14$2) => {
      var x$14 = $as_F1(x$14$2);
      var this$16 = $n(this.Lcom_iz2use_react_components_Selector$Backend__f_$);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$16, x$14))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    var $$x4 = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.reset__Ljapgolly_scalajs_react_callback_Trampoline())));
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x2 = $m_Lcom_iz2use_react_components_package$().toTagMod__T__Ljapgolly_scalajs_react_vdom_TagMod($as_T($n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(item$2)));
    var this$19 = $n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_out);
    var state = $as_Lcom_iz2use_react_components_Selector$ItemState($m_Lcom_iz2use_react_components_Selector$ItemState$().from__Z__Z__s_Product($n(s).contains__O__Z(key), $n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_out).isActive__Lcom_iz2use_react_components_Selector$TypedProps__T__O__Z(p, key, active)));
    var $$x1 = $f_Lcom_iz2use_react_components_Selector__itemClass__Lcom_iz2use_react_components_Selector$ItemState__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagMod(this$19, state, arg1);
    $n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_ev);
    var t$1 = $n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_renderItem).apply__O__O(item$2);
    var t$2 = $as_Ljapgolly_scalajs_react_vdom_TagMod(t$1);
    var array = [$$x2, $$x1, t$2, $as_Ljapgolly_scalajs_react_vdom_TagMod($n($n(p).Lcom_iz2use_react_components_Selector$TypedProps__f_modifier).apply__O__O(item$2))];
    return $n($$x6).wrapItem__Lcom_iz2use_react_components_Selector$TypedProps__F1__F0__T__O__Ljapgolly_scalajs_react_vdom_TagOf__Ljapgolly_scalajs_react_vdom_TagMod(p, $$x5, $$x4, key, item$2, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })))));
  var this$26 = $m_s_$less$colon$less$();
  var array$1 = [$$x11, $$x10, $$x9, $$x8, $n($$x7).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$26.s_$less$colon$less$__f_singleton)];
  var array$2 = [$$x14, $$x13, $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  return $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
function $as_Lcom_iz2use_react_components_Selector$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Selector$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Selector$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_Selector$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Selector$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_Selector$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Selector$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Selector$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_TextEditorHelper$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_TextEditorHelper$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_TextEditorHelper$.prototype.constructor = $c_Lcom_iz2use_react_components_TextEditorHelper$;
/** @constructor */
function $h_Lcom_iz2use_react_components_TextEditorHelper$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_TextEditorHelper$.prototype = $c_Lcom_iz2use_react_components_TextEditorHelper$.prototype;
var $d_Lcom_iz2use_react_components_TextEditorHelper$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_TextEditorHelper$: 0
}, false, "com.iz2use.react.components.TextEditorHelper$", {
  Lcom_iz2use_react_components_TextEditorHelper$: 1,
  O: 1,
  Lcom_iz2use_react_components_MediumPriorityTextEditorHelperImplicits: 1,
  Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits: 1
});
$c_Lcom_iz2use_react_components_TextEditorHelper$.prototype.$classData = $d_Lcom_iz2use_react_components_TextEditorHelper$;
var $n_Lcom_iz2use_react_components_TextEditorHelper$;
function $m_Lcom_iz2use_react_components_TextEditorHelper$() {
  if ((!$n_Lcom_iz2use_react_components_TextEditorHelper$)) {
    $n_Lcom_iz2use_react_components_TextEditorHelper$ = new $c_Lcom_iz2use_react_components_TextEditorHelper$()
  };
  return $n_Lcom_iz2use_react_components_TextEditorHelper$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_UserPreference$TypedBackend() {
  this.Lcom_iz2use_react_components_UserPreference$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_UserPreference$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_UserPreference$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_UserPreference$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_UserPreference$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_UserPreference$TypedBackend.prototype = $c_Lcom_iz2use_react_components_UserPreference$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_UserPreference$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_UserPreference$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_UserPreference$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_UserPreference$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_UserPreference$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_UserPreference$TypedBackend.prototype.render__Lcom_iz2use_react_components_UserPreference$TypedProps__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lcom_iz2use_react_components_UserPreference$TypedProps__f_renderFn).apply__O__O($m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), s), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x1;
      var p2 = $as_s_Option(x1.T2__f__1);
      if ((p2 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(p2);
        var newState = $as_s_Option($n(x3).s_Some__f_value);
        var ec = $n(p).Lcom_iz2use_react_components_UserPreference$TypedProps__f_ec;
        var encoder = $n(p).Lcom_iz2use_react_components_UserPreference$TypedProps__f_encoder;
        var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_UserPreference$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
          $as_s_Option(s$2);
          return newState
        })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => $n($n($n(p).Lcom_iz2use_react_components_UserPreference$TypedProps__f_store).put__T__O__Lio_circe_Encoder__s_concurrent_Future($n($n(p).Lcom_iz2use_react_components_UserPreference$TypedProps__f_name).Lsourcecode_FullName__f_value, newState, ($m_Lio_circe_Encoder$(), new $c_Lio_circe_Encoder$$anon$21(encoder)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
          $as_jl_Void(x$1$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
        })), ec))), ec)))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p4)) {
        var $$x1 = cb;
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  })))))
});
function $as_Lcom_iz2use_react_components_UserPreference$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_UserPreference$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.UserPreference$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_UserPreference$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_UserPreference$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_UserPreference$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_UserPreference$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.UserPreference$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
function $as_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.TokenizeSearch$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.TokenizeSearch$TypedBackend;", depth))
}
function $ct_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $thiz.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_id = $n($m_ju_UUID$().randomUUID__ju_UUID()).toString__T();
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_id = null;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__Ljapgolly_scalajs_react_vdom_TagOf = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_checkboxField;
  var $$x8 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
  var this$5 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n(arg1).Lcom_iz2use_react_style_Style__f_checkboxFieldHasFocus;
  var this$6 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s$2));
  var condition = $n(s).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_focused;
  var $$x7 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$6, condition);
  var $$x6 = $n($n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$()).Ljapgolly_scalajs_react_vdom_HtmlTags$input$__f_checkbox);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$11 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "checked");
  var a = $n($n(p).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_optioner).transformOption__O__F1__O($n($n(p).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_s_Option(x$1$2);
    var this$10 = $n(x$1);
    return $uZ((this$10.isEmpty__Z() ? false : this$10.get__O()))
  })));
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$11.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$14 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "id");
  var a$1 = this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_id;
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array = [$$x5, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$14.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.change__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__F1(p, s), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onFocus")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.onFocus__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(p, s)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onBlur")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.onBlur__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(p, s)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + $n($n(p).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x4 = $n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$24 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $n(arg1).Lcom_iz2use_react_style_Style__f_checkboxFieldLabel;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$24, s$3);
  var $$x1 = $n(p).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_label;
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$27 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "htmlFor");
  var a$2 = this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_id;
  var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array$1 = [$$x2, $$x1, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$27.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$2)];
  var array$2 = [$$x8, $$x7, $$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("label", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype.change__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__F1 = (function(p, s) {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    var v = $uZ(e$2.target.checked);
    var this$2 = $n($n(p).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1$1 = $n($n(p).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_optioner).some__O__O(v);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype.onFocus__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  var this$3 = $n(this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(x$3$2);
    $n(x$3);
    return new $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(true, true)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend.prototype.onBlur__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  var this$3 = $n(this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(x$4$2);
    var this$2 = $n(x$4);
    var loaded = this$2.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_loaded;
    return new $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(false, loaded)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
function $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.CheckboxComponent$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.CheckboxComponent$TypedBackend;", depth))
}
function $ct_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $thiz.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_onReceivingText = new $c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture($thiz.onTextReceived__F1(), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
  $thiz.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_onReceivingValue = new $c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture($thiz.onValueReceived__F1(), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_onReceivingText = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_onReceivingValue = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.onTextReceived__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((result$2) => {
    var result = $as_s_util_Try(result$2);
    var this$9 = $n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(s$2);
      var pot = $n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text;
      var x$1 = new $c_Lcom_iz2use_react_components_internal_editor_package$RichPot(pot).withTry__s_util_Try__Ldiode_data_Pot(result);
      var this$3 = $n(s);
      var x$2 = this$3.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
      var this$4 = $n(s);
      var x$3 = this$4.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
      var this$5 = $n(s);
      var x$4 = this$5.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified;
      var this$6 = $n(s);
      var x$5 = this$6.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
      var this$7 = $n(s);
      var x$6 = this$7.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
      $n(s);
      return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$2, x$3, x$1, x$4, x$5, x$6)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$9, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.onValueReceived__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((result$2) => {
    var result = $as_s_util_Try(result$2);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps(p$2);
      var this$9 = $n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(s$2);
        $n(s);
        var pot = $n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
        var value = new $c_Lcom_iz2use_react_components_internal_editor_package$RichPot(pot).withTry__s_util_Try__Ldiode_data_Pot($n(result).map__F1__s_util_Try(new $c_sjsr_AnonFunction1(((x$1$2) => $n($n(p).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_optioner).some__O__O(x$1$2)))));
        var this$3 = $n(s);
        var lastText = this$3.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
        var this$4 = $n(s);
        var text = this$4.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text;
        var this$5 = $n(s);
        var modified = this$5.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified;
        var this$6 = $n(s);
        var focused = this$6.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
        var this$7 = $n(s);
        var loaded = this$7.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
        return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(value, lastText, text, modified, focused, loaded)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$9, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f))
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Ljapgolly_scalajs_react_vdom_TagOf = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var this$2 = $n($n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text);
  var this$3 = $n(((!this$2.isEmpty__Z()) ? new $c_s_Some(this$2.get__O()) : $m_s_None$()));
  var text = $as_T((this$3.isEmpty__Z() ? "" : this$3.get__O()));
  var x$1 = $n(p).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_label;
  var x$2 = $n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
  var this$6 = $n($n($n($n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value).exceptionOption__s_Option()).toList__sci_List());
  var f = ((x$2$2$2) => {
    var x$2$2 = $as_jl_Throwable(x$2$2$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(x$2$2).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
  });
  if ((this$6 === $m_sci_Nil$())) {
    var x$3 = $m_sci_Nil$()
  } else {
    var arg1$1 = this$6.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$6.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var x$3 = h
  };
  var x$4 = $m_s_package$().s_package$__f_Nil;
  var $$x3 = $m_sci_Seq$();
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$10 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_multilineTextEditor;
  var $$x1 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s$1);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$13 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rows");
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var array = [$$x1, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$13.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 8), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_value).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(text, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onBlur")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.onBlur__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(p, s)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.change__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__F1(p, s), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onFocus")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.onFocus__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(p, s)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((($n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text + " | ") + $n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$1 = [$n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("textarea", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var x$6 = $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
  return $m_Lcom_iz2use_react_components_WrapField$().apply__Ljapgolly_scalajs_react_vdom_TagMod__Z__sci_Seq__sci_Seq__Z__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(x$1, x$2, x$4, x$3, false, x$6)
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.change__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__F1 = (function(p, s) {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    var v = $as_T(e$2.target.value);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var cond = (!$n($n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text).contains__O__Z(v));
    if (cond) {
      var this$3 = $n(v);
      if ((this$3 === "")) {
        var this$9 = $n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$);
        var mod = new $c_sjsr_AnonFunction1(((s$2) => {
          var s$1 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(s$2);
          $n(s$1);
          $n($n(s$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value);
          var value = $n($n(p).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_optioner).none__O();
          var value$1 = new $c_Ldiode_data_Ready(value);
          var lastText = new $c_s_Some(v);
          $n($n(s$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text);
          var text = new $c_Ldiode_data_Ready(v);
          var this$6 = $n(s$1);
          var focused = this$6.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
          var this$7 = $n(s$1);
          var loaded = this$7.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
          return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(value$1, lastText, text, true, focused, loaded)
        }));
        var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$9, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
      } else {
        var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$3$2) => {
          var s$3 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(s$3$2);
          var x$1 = new $c_s_Some(v);
          $n($n(s$3).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text);
          var x$2 = new $c_Ldiode_data_Ready(v);
          var this$11 = $n(s$3);
          var x$4 = this$11.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
          var this$12 = $n(s$3);
          var x$5 = this$12.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
          var this$13 = $n(s$3);
          var x$6 = this$13.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
          $n(s$3);
          return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$4, x$1, x$2, true, x$5, x$6)
        })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_onReceivingValue).enqueue__s_concurrent_Future__Ljapgolly_scalajs_react_callback_Trampoline($n($n(p).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_resolver).parse__T__s_concurrent_Future(v))))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
      };
      var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.update__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var cond = $n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified;
  if (cond) {
    var v = $n($n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value).get__O();
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$3$2);
      var this$3 = $n(x$3);
      var x$2 = this$3.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
      var this$4 = $n(x$3);
      var x$3$2$1 = this$4.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
      var this$5 = $n(x$3);
      var x$4 = this$5.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text;
      var this$6 = $n(x$3);
      var x$5 = this$6.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
      var this$7 = $n(x$3);
      var x$6 = this$7.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
      $n(x$3);
      return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$2, x$3$2$1, x$4, false, x$5, x$6)
    })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.setText__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__F1(p)).apply__O__O(v))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$10 = $n($n(p).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$11 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$12 = $n(this$11.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$12.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$13 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$13.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$10.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(v), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.onFocus__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  var this$2 = $n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$5$2);
    return $n(x$5).focus__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState()
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.onBlur__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$2 = $n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$6$2);
    return $n(x$6).blur__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState()
  }));
  return $n($$x1).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, this.update__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(p, s))
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.setText__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__F1 = (function(p) {
  return new $c_sjsr_AnonFunction1(((x$7$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_optioner).transformOption__O__F1__O(x$7$2, new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    if ((x0$1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x0$1);
      var value = $n(x2).s_Some__f_value;
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(s$2);
        var x$1 = $n($n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text).pending__J__Ldiode_data_Pot($n($n(s).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text).pending$default$1__J());
        var this$2 = $n(s);
        var x$2 = this$2.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
        var this$3 = $n(s);
        var x$3 = this$3.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
        var this$4 = $n(s);
        var x$4 = this$4.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified;
        var this$5 = $n(s);
        var x$5 = this$5.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
        var this$6 = $n(s);
        var x$6 = this$6.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
        $n(s);
        return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$2, x$3, x$1, x$4, x$5, x$6)
      })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_onReceivingText).enqueue__s_concurrent_Future__Ljapgolly_scalajs_react_callback_Trampoline($n($n(p).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_resolver).stringify__O__s_concurrent_Future(value))))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else {
      var this$15 = $n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$3$2) => {
        var s$3 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(s$3$2);
        $n($n(s$3).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text);
        var x$7 = new $c_Ldiode_data_Ready("");
        var x$8 = new $c_s_Some("");
        var this$10 = $n(s$3);
        var x$9 = this$10.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
        var this$11 = $n(s$3);
        var x$10 = this$11.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified;
        var this$12 = $n(s$3);
        var x$11 = this$12.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
        var this$13 = $n(s$3);
        var x$12 = this$13.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
        $n(s$3);
        return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$9, x$8, x$7, x$10, x$11, x$12)
      }));
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$15, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)))
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend.prototype.onPropsChange__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(state, prev, next) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  if ((!$n($n(state).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value).contains__O__Z($n($n(next).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))) {
    var cond = true
  } else if ($n($n(state).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value).isEmpty__Z()) {
    var x = $n($n(prev).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var y = $n($n(next).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var cond = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))
  } else {
    var cond = false
  };
  if (cond) {
    var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(s$2);
      $n(s);
      var value = new $c_Ldiode_data_Ready($n($n(next).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
      var lastText = $m_s_None$();
      var text = $m_Ldiode_data_Empty$();
      var this$4 = $n(s);
      var focused = this$4.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
      var this$5 = $n(s);
      var loaded = this$5.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
      return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(value, lastText, text, false, focused, loaded)
    })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.setText__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__F1(next)).apply__O__O($n($n(next).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
function $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.MultilineComponent$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.MultilineComponent$TypedBackend;", depth))
}
function $p_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__loop$1__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLDivElement__V($thiz, node, dropDownContainer$1) {
  while (true) {
    if ((node !== null)) {
      var x = node;
      var y = document.documentElement;
      var $$x1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ($uZ(dropDownContainer$1.contains(node))) {
        $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_justClickedOnContainer = true
      } else {
        node = node.parentNode;
        continue
      }
    };
    return (void 0)
  }
}
function $ct_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_inputRef = $m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF();
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_dropDownContainerRef = $m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF();
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onSelect = $thiz.selectAndValid__Z__F1(false);
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onSelectAndValid = $thiz.selectAndValid__Z__F1(true);
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(p$2);
    var this$10 = $n($thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2);
      var qual$1 = $n(s).collapse__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState();
      $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value);
      var value = $n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner).none__O();
      var x$1 = new $c_Ldiode_data_Ready(value);
      var this$3 = $n(qual$1);
      var x$2 = this$3.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
      var this$4 = $n(qual$1);
      var x$3 = this$4.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
      var this$5 = $n(qual$1);
      var x$4 = this$5.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified;
      var this$6 = $n(qual$1);
      var x$5 = this$6.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
      var this$7 = $n(qual$1);
      var x$6 = this$7.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
      var this$8 = $n(qual$1);
      var x$7 = this$8.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
      $n(qual$1);
      return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$1, x$2, x$3, x$4, x$5, x$6, x$7)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$10, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onCancel = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f);
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_justClickedOnContainer = false;
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onKeyDown = new $c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster();
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_scrollIntoView = new $c_sjsr_AnonFunction0((() => {
    var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f$2 = new $c_sjsr_AnonFunction1(((s$2$1) => {
      var s$1 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2$1);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var cond = $n(s$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
      if (cond) {
        var this$13 = $n($thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_inputRef);
        var f$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
          x$2$2.scrollIntoView()
        }));
        var this$$1 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_Ref$GetF__foreach__F1__O(this$13, f$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
      } else {
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$2, f$2))
  }));
  var this$$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$3 = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3$1 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$3$2);
    return $n(x$3$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified
  }));
  var this$17 = $n(this$$3);
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_isModified = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$17, f$3);
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_context = new $c_Lcom_iz2use_react_components_internal_TextEditorContext($thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onKeyDown, $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onSelect, $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onSelectAndValid, $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onCancel, $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_scrollIntoView, $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_isModified);
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onReceivingText = new $c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture($thiz.onTextReceived__F1(), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor());
  $thiz.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onReceivingValue = new $c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture($thiz.onValueReceived__F1(), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor());
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_inputRef = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_dropDownContainerRef = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onSelect = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onSelectAndValid = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onCancel = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_justClickedOnContainer = false;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onKeyDown = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_scrollIntoView = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_isModified = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_context = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onReceivingText = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onReceivingValue = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.selectAndValid__Z__F1 = (function(valid) {
  return new $c_sjsr_AnonFunction1(((value$2) => {
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(p$2);
      var someValue = $n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner).some__O__O(value$2);
      if ((valid === true)) {
        var this$2 = $n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state);
        var callback = new $c_sjsr_AnonFunction0((() => {
          var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
        }));
        var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
        var next = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(someValue), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
      } else {
        if ((valid !== false)) {
          throw new $c_s_MatchError(valid)
        };
        var next = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2);
        var qual$1 = $n(s).collapse__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState();
        $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value);
        var x$1 = new $c_Ldiode_data_Ready(someValue);
        var this$7 = $n(qual$1);
        var x$3 = this$7.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
        var this$8 = $n(qual$1);
        var x$4 = this$8.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
        var this$9 = $n(qual$1);
        var x$5 = this$9.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
        var this$10 = $n(qual$1);
        var x$6 = this$10.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
        var this$11 = $n(qual$1);
        var x$7 = this$11.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
        $n(qual$1);
        return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$1, x$3, x$4, true, x$5, x$6, x$7)
      })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.setText__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__F1(p)).apply__O__O(someValue))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, next)))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f))
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.onTextReceived__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((result$2) => {
    var result = $as_s_util_Try(result$2);
    var this$10 = $n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2);
      var pot = $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
      var x$1 = new $c_Lcom_iz2use_react_components_internal_editor_package$RichPot(pot).withTry__s_util_Try__Ldiode_data_Pot(result);
      var this$3 = $n(s);
      var x$2 = this$3.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
      var this$4 = $n(s);
      var x$3 = this$4.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
      var this$5 = $n(s);
      var x$4 = this$5.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified;
      var this$6 = $n(s);
      var x$5 = this$6.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
      var this$7 = $n(s);
      var x$6 = this$7.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
      var this$8 = $n(s);
      var x$7 = this$8.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
      $n(s);
      return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$2, x$3, x$1, x$4, x$5, x$6, x$7)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$10, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.onValueReceived__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((result$2) => {
    var result = $as_s_util_Try(result$2);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(p$2);
      var this$10 = $n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2);
        $n(s);
        var pot = $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
        var value = new $c_Lcom_iz2use_react_components_internal_editor_package$RichPot(pot).withTry__s_util_Try__Ldiode_data_Pot($n(result).map__F1__s_util_Try(new $c_sjsr_AnonFunction1(((x$4$2) => $n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner).some__O__O(x$4$2)))));
        var this$3 = $n(s);
        var lastText = this$3.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
        var this$4 = $n(s);
        var text = this$4.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
        var this$5 = $n(s);
        var modified = this$5.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified;
        var this$6 = $n(s);
        var focused = this$6.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
        var this$7 = $n(s);
        var collapsed = this$7.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
        var this$8 = $n(s);
        var loaded = this$8.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
        return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(value, lastText, text, modified, focused, collapsed, loaded)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$10, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f))
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_vdom_TagOf = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var isOpen = $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_isOpen;
  var this$2 = $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text);
  var this$3 = $n(((!this$2.isEmpty__Z()) ? new $c_s_Some(this$2.get__O()) : $m_s_None$()));
  var text = $as_T((this$3.isEmpty__Z() ? "" : this$3.get__O()));
  var x$1 = $n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_label;
  var x$2 = $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
  var this$4 = $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text);
  if ((!this$4.isEmpty__Z())) {
    var arg1$1 = this$4.get__O();
    var x$5 = $as_T(arg1$1);
    $m_sc_StringOps$();
    var this$7 = $n(x$5);
    var $$x1 = (!(this$7 === ""))
  } else {
    var $$x1 = false
  };
  var x$3 = (!$$x1);
  var this$10 = $n($n($n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value).exceptionOption__s_Option()).toList__sci_List());
  var f = ((x$6$2) => {
    var x$6 = $as_jl_Throwable(x$6$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(x$6).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
  });
  if ((this$10 === $m_sci_Nil$())) {
    var x$4 = $m_sci_Nil$()
  } else {
    var arg1$2 = this$10.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$10.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$3 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var x$4 = h
  };
  var x$5$3 = $m_s_package$().s_package$__f_Nil;
  var $$x7 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$();
  var this$12 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_textEditor;
  var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$12, s$1);
  var $$x5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("text", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_value).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(text, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x3 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onBlur")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.onBlur__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(p, s)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onKeyDown");
  var array = [$$x6, $$x5, $$x4, $$x3, stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.handleKey__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__F1(p, s), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.change__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__F1(p, s), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onFocus")).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.onFocus__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(p, s)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((((($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text + " | isOpen=") + isOpen) + " | ") + $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x2 = $n($n($$x7).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var r = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_inputRef;
  var x$6$3 = $n($$x2).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(r));
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((isOpen ? "inherit" : "none"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded ? $n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_helper).renderContainer__T__Z__Lcom_iz2use_react_components_internal_TextEditorContext__Ljapgolly_scalajs_react_vdom_VdomNode(text, $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_isOpen, this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_context) : $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom)];
  var $$x8 = $n($n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
  var r$1 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_dropDownContainerRef;
  var x$7 = $n($$x8).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(r$1));
  var $$x10 = $m_Lcom_iz2use_react_components_WrapField$();
  var array$2 = [x$6$3, x$7];
  return $n($$x10).apply__Ljapgolly_scalajs_react_vdom_TagMod__Z__sci_Seq__sci_Seq__Z__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(x$1, x$2, x$5$3, x$4, x$3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.change__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__F1 = (function(p, s) {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    var v = $as_T(e$2.target.value);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var cond = (!$n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text).contains__O__Z(v));
    if (cond) {
      var this$3 = $n(v);
      if ((this$3 === "")) {
        var this$10 = $n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$);
        var mod = new $c_sjsr_AnonFunction1(((s$2) => {
          var s$1 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2);
          var qual$1 = $n(s$1).expand__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState();
          $n($n(s$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value);
          var value = $n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner).none__O();
          var x$1 = new $c_Ldiode_data_Ready(value);
          var x$2 = new $c_s_Some(v);
          $n($n(s$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text);
          var x$3 = new $c_Ldiode_data_Ready(v);
          var this$6 = $n(qual$1);
          var x$5 = this$6.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
          var this$7 = $n(qual$1);
          var x$6 = this$7.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
          var this$8 = $n(qual$1);
          var x$7 = this$8.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
          $n(qual$1);
          return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$1, x$2, x$3, true, x$5, x$6, x$7)
        }));
        var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$10, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
      } else {
        var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$3$2) => {
          var s$3 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$3$2);
          var qual$2 = $n(s$3).expand__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState();
          $n($n(s$3).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text);
          var x$8 = new $c_Ldiode_data_Ready(v);
          var x$9 = new $c_s_Some(v);
          var this$12 = $n(qual$2);
          var x$11 = this$12.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
          var this$13 = $n(qual$2);
          var x$12 = this$13.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
          var this$14 = $n(qual$2);
          var x$13 = this$14.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
          var this$15 = $n(qual$2);
          var x$14 = this$15.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
          $n(qual$2);
          return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$11, x$9, x$8, true, x$12, x$13, x$14)
        })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onReceivingValue).enqueue__s_concurrent_Future__Ljapgolly_scalajs_react_callback_Trampoline($n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_resolver).parse__T__s_concurrent_Future(v))))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
      };
      var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.handleKey__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__F1 = (function(p, s) {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    $m_Ljapgolly_scalajs_react_package$();
    $m_Ljapgolly_scalajs_react_package$();
    var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
    var x$6 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1(this, p, s);
    var ifEnter = qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e$2, $uI(e$2.keyCode), false, false, false, false, x$6);
    $m_Ljapgolly_scalajs_react_package$();
    $m_Ljapgolly_scalajs_react_package$();
    var qual$2 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
    var x$12 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2(this, p);
    var ifEscape = qual$2.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e$2, $uI(e$2.keyCode), false, false, false, false, x$12);
    var validKeys = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(($m_Ljapgolly_scalajs_react_callback_CallbackOption$(), $m_Ljapgolly_scalajs_react_callback_CallbackOption$().orElse$extension__F0__F0__F0(ifEscape, ifEnter)), new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_s_Option(v$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).require__F0__F0(new $c_sjsr_AnonFunction0((() => {
        var this$5 = $n(v);
        return (!this$5.isEmpty__Z())
      }))), new $c_sjsr_AnonFunction1(((x$8$2) => {
        $as_jl_Void(x$8$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_package$();
        var this$7 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e$2, this$7.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f = new $c_sjsr_AnonFunction1(((x$7$2) => {
          $as_jl_Void(x$7$2)
        }));
        var this$9 = $n(this$);
        var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$9, f);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
      }))))
    })));
    var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var $$x2 = $n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onKeyDown).broadcast__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline(e$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var cond = new $c_sjsr_AnonFunction0((() => $uZ(e$2.defaultPrevented)));
    var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().when$extension__F0__F0__F0(validKeys, new $c_sjsr_AnonFunction0((() => (!$uZ(cond.apply__O())))));
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$13 = $m_s_$less$colon$less$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x2, $n($$x1).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$13.s_$less$colon$less$__f_singleton)))
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.update__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var v = $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value).get__O();
  var this$11 = $n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state);
  var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$10$2);
    var this$1 = $n(x$10);
    var x$2 = this$1.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
    var this$3 = $n(x$10);
    var x$3 = this$3.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
    var this$4 = $n(x$10);
    var x$4 = this$4.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
    var this$5 = $n(x$10);
    var x$5 = this$5.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
    var this$6 = $n(x$10);
    var x$6 = this$6.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
    var this$7 = $n(x$10);
    var x$7 = this$7.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
    $n(x$10);
    return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$2, x$3, x$4, false, x$5, x$6, x$7)
  })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.resetText__Ljapgolly_scalajs_react_callback_Trampoline()))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  return $n($$x1).when$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$11.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(v), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction0((() => $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified)))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.onFocus__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var cond = (!this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_justClickedOnContainer);
  if (cond) {
    var this$3 = $n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((x$11$2) => {
      var x$11 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$11$2);
      return $n(x$11).focus__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState()
    }));
    var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.onBlur__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  if (this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_justClickedOnContainer) {
    this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_justClickedOnContainer = false;
    var this$2 = $n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_inputRef);
    var f = new $c_sjsr_AnonFunction1(((x$12$2) => {
      x$12$2.focus()
    }));
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_Ref$GetF__foreach__F1__O(this$2, f))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
  } else {
    var this$3 = $n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((x$13$2) => {
      var x$13 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$13$2);
      return $n(x$13).blur__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState()
    }));
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
  };
  var this$ = this.update__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(p, s);
  return $n($$x2).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.onFormSubmit__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2);
    var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline((((((($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text + " ") + $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value) + " mod=") + $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified) + " foc=") + $n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused), $m_sci_Nil$());
    var f = new $c_sjsr_AnonFunction1(((x$14$2) => {
      $as_jl_Void(x$14$2);
      return (!$n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified)
    }));
    var this$3 = $n(this$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$3, f))
  })))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.documentMouseDown__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f$3 = new $c_sjsr_AnonFunction1(((s$2) => {
      $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2);
      var this$5 = $n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_dropDownContainerRef);
      var f$2 = new $c_sjsr_AnonFunction1(((dropDownContainer$2) => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
        var f = new $c_sjsr_AnonFunction0((() => {
          this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_justClickedOnContainer = false;
          $p_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__loop$1__Lorg_scalajs_dom_Element__Lorg_scalajs_dom_HTMLDivElement__V(this, e$2.target, dropDownContainer$2)
        }));
        var f$1 = new $c_sjsr_AnonFunction0((() => {
          f.apply__O()
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_Ref$GetF__foreachCB__F1__O(this$5, f$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$3))
  }))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.onPropsChange__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(prevProps, nextProps, state) {
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var x = $n(prevProps).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext;
  var x$2 = $n(nextProps).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext;
  if ((x === null)) {
    var $$x2 = (x$2 === null)
  } else {
    var this$1 = $n(x);
    var $$x2 = (this$1 === x$2)
  };
  var cond = (!$$x2);
  if (cond) {
    var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($n(prevProps).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext).unregisterOnSubmit__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this.onFormSubmit__Ljapgolly_scalajs_react_callback_Trampoline()), $n($n(nextProps).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext).registerOnSubmit__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this.onFormSubmit__Ljapgolly_scalajs_react_callback_Trampoline()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    var $$x3 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  };
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var x$1 = $n($n(prevProps).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var y = $n($n(nextProps).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var cond$1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y));
  if (cond$1) {
    var this$$1 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.setText__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__F1(nextProps)).apply__O__O($n($n(nextProps).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  };
  return $n($$x4).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x3, $$x1)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.setText__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__F1 = (function(p) {
  return new $c_sjsr_AnonFunction1(((x$15$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner).transformOption__O__F1__O(x$15$2, new $c_sjsr_AnonFunction1(((value$2) => {
    var value = $as_s_Option(value$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2);
      var x$1 = $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text).pending__J__Ldiode_data_Pot($n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text).pending$default$1__J());
      var this$2 = $n(s);
      var x$2 = this$2.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
      var this$3 = $n(s);
      var x$3 = this$3.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
      var this$4 = $n(s);
      var x$4 = this$4.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified;
      var this$5 = $n(s);
      var x$5 = this$5.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
      var this$6 = $n(s);
      var x$6 = this$6.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
      var this$7 = $n(s);
      var x$7 = this$7.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
      $n(s);
      return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$2, x$3, x$1, x$4, x$5, x$6, x$7)
    })), new $c_sjsr_AnonFunction0((() => {
      var $$x2 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onReceivingText;
      var this$9 = $n(value);
      if (this$9.isEmpty__Z()) {
        var $$x1 = $m_s_concurrent_Future$().successful__O__s_concurrent_Future("")
      } else {
        var arg1 = this$9.get__O();
        var $$x1 = $n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_resolver).stringify__O__s_concurrent_Future(arg1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).enqueue__s_concurrent_Future__Ljapgolly_scalajs_react_callback_Trampoline($$x1))
    })), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.resetText__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext).registerOnSubmit__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this.onFormSubmit__Ljapgolly_scalajs_react_callback_Trampoline()), $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.setText__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__F1(p)).apply__O__O($n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend.prototype.saveOnUnmount__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  if ($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified) {
    var this$1 = $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value);
    var cond = (!this$1.isEmpty__Z())
  } else {
    var cond = false
  };
  if (cond) {
    var this$3 = $n($n(p).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$5 = $n(this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$5.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$6 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$6.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1$1 = $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value).get__O();
    var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
function $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.TextComponent$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.TextComponent$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingListRenderer$", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$;
var $n_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$;
function $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$ = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1(renderList$1) {
  this.Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1__f_name = null;
  this.Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1__f_icon = null;
  this.Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1__f_renderList$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1__f_renderList$1 = renderList$1;
  $f_Lcom_iz2use_react_components_internal_multiview_CompareRenderer__$init$__V(this)
}
$c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1.prototype.defaultOrder__I = (function() {
  return 700
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1.prototype.name__T = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1__f_name
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1.prototype.icon__Lcom_iz2use_react_components_IconSourceShape = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1__f_icon
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1.prototype.render__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_vdom_VdomElement = (function(items, iterator, keyMapper, context, itemSimpleActions, decorator) {
  var u = $m_Lcom_iz2use_react_components_internal_multiview_CompareView$().apply__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_RenderCompare__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(items, this.Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1__f_renderList$1, keyMapper, context, iterator);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.CompareRenderer$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_CompareRenderer: 1,
  Lcom_iz2use_react_components_internal_multiview_View: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_CompareRenderer$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var lst = $n($n(p).Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_items).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((items$2) => {
    $n($n(p).Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_iterator);
    var in$1 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_iterator).map__O__F1__O(items$2, new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_T2(x$1$2);
      return $n(x$1)._1__O()
    })));
    var in$2 = $as_sc_Iterable(in$1);
    var this$4 = $n($n(in$2).iterator__sc_Iterator());
    $m_sci_List$();
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4)
  })));
  return $n($n(p).Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_renderer).render__Ldiode_data_Pot__Ljapgolly_scalajs_react_vdom_VdomElement(lst)
});
function $as_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.CompareView$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.CompareView$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1(renderable$1) {
  this.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_name = null;
  this.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_icon = null;
  this.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_renderable$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_renderable$1 = renderable$1;
  $f_Lcom_iz2use_react_components_internal_multiview_GridRenderer__$init$__V(this)
}
$c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1.prototype.name__T = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_name
});
$c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1.prototype.icon__Lcom_iz2use_react_components_IconSourceShape = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_icon
});
$c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1.prototype.defaultOrder__I = (function() {
  $n(this.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_renderable$1);
  return 1
});
$c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1.prototype.render__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_vdom_VdomElement = (function(items, iterator, keyMapper, context, itemSimpleActions, decorator) {
  var $$x1 = $m_Lcom_iz2use_react_components_internal_multiview_grid_GridView$();
  var this$ = $n(context).active__Ljapgolly_scalajs_react_callback_Trampoline();
  var this$2 = $n(this$);
  var u = $n($$x1).apply__Ldiode_data_Pot__s_Option__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_GridRenderer__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_grid_GridRenderable__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(items, $as_s_Option($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)), keyMapper, this, itemSimpleActions, this.Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1__f_renderable$1, context, iterator, decorator);
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.GridRenderer$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_GridRenderer: 1,
  Lcom_iz2use_react_components_internal_multiview_View: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_GridRenderer$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_IterableIsIterator();
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.append__O__O__O = (function(in$1, item) {
  var in$2 = $as_sci_Seq(in$1);
  var this$1 = $n(in$2);
  return $as_sci_Seq(this$1.appended__O__O(item))
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.indexWhere__O__F1__I__I = (function(in$1, f, from) {
  var in$2 = $as_sci_Seq(in$1);
  return $n(in$2).indexWhere__F1__I__I(f, from)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.isEmpty__O__Z = (function(in$1) {
  var in$2 = $as_sci_Seq(in$1);
  return $n(in$2).isEmpty__Z()
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.apply__O__I__O = (function(in$1, index) {
  var in$2 = $as_sci_Seq(in$1);
  return $n(in$2).apply__I__O(index)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.length__O__I = (function(in$1) {
  var in$2 = $as_sci_Seq(in$1);
  return $n(in$2).length__I()
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.sortBy__O__F1__s_math_Ordering__O = (function(in$1, f, ord) {
  var in$2 = $as_sci_Seq(in$1);
  var this$1 = $n(in$2);
  return $as_sci_Seq($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$1, f, ord))
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.collect__O__s_PartialFunction__O = (function(in$1, pf) {
  var in$2 = $as_sci_Seq(in$1);
  return $as_sci_Seq($n(in$2).collect__s_PartialFunction__O(pf))
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.filter__O__F1__O = (function(in$1, f) {
  var in$2 = $as_sci_Seq(in$1);
  return $as_sci_Seq($n(in$2).filter__F1__O(f))
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.find__O__F1__s_Option = (function(in$1, f) {
  var in$2 = $as_sci_Seq(in$1);
  return $n(in$2).find__F1__s_Option(f)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.map__O__F1__O = (function(in$1, f) {
  var in$2 = $as_sci_Seq(in$1);
  return $as_sci_Seq($n(in$2).map__F1__O(f))
});
var $d_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.HasIterator$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1: 1,
  Lcom_iz2use_react_components_internal_multiview_IterableIsIterator: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_HasIterator: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_IterableIsIterator();
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype = $c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.append__O__O__O = (function(in$1, item) {
  var in$2 = $as_sci_List(in$1);
  var this$1 = $n(in$2);
  return $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$1, item))
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.indexWhere__O__F1__I__I = (function(in$1, f, from) {
  var in$2 = $as_sci_List(in$1);
  var this$1 = $n(in$2);
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this$1, f, from)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.isEmpty__O__Z = (function(in$1) {
  var in$2 = $as_sci_List(in$1);
  return $n(in$2).isEmpty__Z()
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.apply__O__I__O = (function(in$1, index) {
  var in$2 = $as_sci_List(in$1);
  var this$1 = $n(in$2);
  return $f_sc_LinearSeqOps__apply__I__O(this$1, index)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.length__O__I = (function(in$1) {
  var in$2 = $as_sci_List(in$1);
  return $n(in$2).length__I()
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.sortBy__O__F1__s_math_Ordering__O = (function(in$1, f, ord) {
  var in$2 = $as_sci_List(in$1);
  var this$1 = $n(in$2);
  return $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$1, f, ord))
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.collect__O__s_PartialFunction__O = (function(in$1, pf) {
  var in$2 = $as_sci_List(in$1);
  return $n(in$2).collect__s_PartialFunction__sci_List(pf)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.filter__O__F1__O = (function(in$1, f) {
  var in$2 = $as_sci_List(in$1);
  var this$1 = $n(in$2);
  return $p_sci_List__filterCommon__F1__Z__sci_List(this$1, f, false)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.find__O__F1__s_Option = (function(in$1, f) {
  var in$2 = $as_sci_List(in$1);
  return $n(in$2).find__F1__s_Option(f)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.map__O__F1__O = (function(in$1, f) {
  var in$2 = $as_sci_List(in$1);
  return $n(in$2).map__F1__sci_List(f)
});
var $d_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2: 0
}, false, "com.iz2use.react.components.internal.multiview.HasIterator$$anon$2", {
  Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2: 1,
  Lcom_iz2use_react_components_internal_multiview_IterableIsIterator: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_HasIterator: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_HasIterator$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1(renderer$1) {
  this.Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_fields = null;
  this.Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_name = null;
  this.Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_icon = null;
  $f_Lcom_iz2use_react_components_internal_multiview_ListRenderer__$init$__V(this);
  this.Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_fields = $n(renderer$1).fields__sci_List()
}
$c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1.prototype.name__T = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_name
});
$c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1.prototype.icon__Lcom_iz2use_react_components_IconSourceShape = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_icon
});
$c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1.prototype.defaultOrder__I = (function() {
  return 900
});
$c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1.prototype.render__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_vdom_VdomElement = (function(items, iterator, keyMapper, context, itemSimpleActions, decorator) {
  var u = new $c_Lcom_iz2use_react_components_internal_multiview_list_ListView(iterator).apply__Ldiode_data_Pot__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_ListRenderer__Lcom_iz2use_react_components_internal_multiview_Actions__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(items, keyMapper, this, itemSimpleActions);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.ListRenderer$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_ListRenderer: 1,
  Lcom_iz2use_react_components_internal_multiview_View: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype.toggle__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$2 = $n(this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $uZ(x$1$2);
    return (!x$1)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype.render__Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__Z__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s, c) {
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_style).Lcom_iz2use_react_style_Style__f_multiviewSettings;
  var $$x5 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var $$x4 = $n($m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.toggle__Ljapgolly_scalajs_react_callback_Trampoline()));
  var array = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_search, "", "24px")];
  var $$x3 = $n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  if (s) {
    var $$x2 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c))];
    var $$x1 = $n($$x2).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("children", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  } else {
    var this$16 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var $$x1 = this$16.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  };
  var array$2 = [$$x5, $$x3, $$x1, $n(p).Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_selector];
  return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
function $as_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.MultiviewSettings$Backend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.MultiviewSettings$Backend;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend: 0
}, false, "com.iz2use.react.components.internal.multiview.MultiviewSettings$Backend", {
  Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype = $c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype.update__Ldiode_data_Pot__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, item, cb, hasIterator, keyMapper) {
  var this$1 = $n(source);
  var x1 = ((!this$1.isEmpty__Z()) ? new $c_s_Some(this$1.get__O()) : $m_s_None$());
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n(x2).s_Some__f_value);
    var this$4 = $n(v);
    var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
    var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
    var arg1 = this$4.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var this$5 = $n(hasIterator);
    var arg1$1 = $f_Lcom_iz2use_react_components_internal_multiview_HasIterator__update__O__O__Lcom_iz2use_common_KeyMapper__O(this$5, arg1, item, keyMapper);
    return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return cb
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype.append__Ldiode_data_Pot__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, item, cb, hasIterator, keyMapper) {
  var this$1 = $n(source);
  var x1 = ((!this$1.isEmpty__Z()) ? new $c_s_Some(this$1.get__O()) : $m_s_None$());
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n(x2).s_Some__f_value);
    var this$4 = $n(v);
    var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
    var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
    var arg1 = this$4.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var arg1$1 = $n(hasIterator).append__O__O__O(arg1, item);
    return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return cb
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype.append__O__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, item, cb, hasIterator, keyMapper) {
  return this.append__Ldiode_data_Pot__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline($as_Ldiode_data_Pot(source), item, cb, hasIterator, keyMapper)
});
$c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype.update__O__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, item, cb, hasIterator, keyMapper) {
  return this.update__Ldiode_data_Pot__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline($as_Ldiode_data_Pot(source), item, cb, hasIterator, keyMapper)
});
$c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype.onPropsChange__O__O__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline = (function(previous, next, sourceChange) {
  $as_Ldiode_data_Pot(previous);
  var next$1 = $as_Ldiode_data_Pot(next);
  return $n(sourceChange).pure__Ldiode_data_Pot__Ljapgolly_scalajs_react_callback_Trampoline(next$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype.onMount__O__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, sourceChange) {
  var source$1 = $as_Ldiode_data_Pot(source);
  return $n(sourceChange).pure__Ldiode_data_Pot__Ljapgolly_scalajs_react_callback_Trampoline(source$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_PotSourceHandler: 0
}, false, "com.iz2use.react.components.internal.multiview.PotSourceHandler", {
  Lcom_iz2use_react_components_internal_multiview_PotSourceHandler: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_SourceHandler: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1(renderItem$1) {
  this.Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1__f_name = null;
  this.Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1__f_icon = null;
  this.Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1__f_renderItem$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1__f_renderItem$1 = renderItem$1;
  $f_Lcom_iz2use_react_components_internal_multiview_Slideshow__$init$__V(this)
}
$c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1.prototype.defaultOrder__I = (function() {
  return 500
});
$c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1.prototype.name__T = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1__f_name
});
$c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1.prototype.icon__Lcom_iz2use_react_components_IconSourceShape = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1__f_icon
});
$c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1.prototype.render__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_vdom_VdomElement = (function(items, iterator, keyMapper, context, itemSimpleActions, decorator) {
  var $$x1 = $m_Lcom_iz2use_react_components_internal_multiview_SlideshowView$();
  var this$ = $n(context).active__Ljapgolly_scalajs_react_callback_Trampoline();
  var this$2 = $n(this$);
  var u = $n($$x1).apply__s_Option__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_RenderItem__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_HasIterator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_s_Option($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)), items, this.Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1__f_renderItem$1, keyMapper, context, iterator);
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.Slideshow$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_Slideshow: 1,
  Lcom_iz2use_react_components_internal_multiview_View: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend.prototype.moveActive__I__Ljapgolly_scalajs_react_callback_Trampoline = (function(count) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
      var this$2 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_items);
      return ((!this$2.isEmpty__Z()) ? new $c_s_Some(this$2.get__O()) : $m_s_None$())
    }))), new $c_sjsr_AnonFunction1(((items$2) => {
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$3 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_active);
      if (this$3.isEmpty__Z()) {
        var $$x1 = $m_s_None$()
      } else {
        var arg1 = this$3.get__O();
        var active = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
        var activeKey = $as_T($n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_keyMapper).apply__O__O($n(active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
        var $$x1 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), active, activeKey))
      };
      var this$4 = $n($$x1);
      if (this$4.isEmpty__Z()) {
        var $$x2 = $m_s_None$()
      } else {
        var arg1$1 = this$4.get__O();
        var x$1 = $as_T2(arg1$1);
        if ((x$1 === null)) {
          throw new $c_s_MatchError(x$1)
        };
        var activeKey$1 = $as_T($n(x$1)._2__O());
        var x$2 = new $c_sjsr_AnonFunction1(((item$2) => {
          var item = $as_T2(item$2);
          var x = $n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_keyMapper).apply__O__O($n(item)._1__O());
          return ((x === null) ? (activeKey$1 === null) : $dp_equals__O__Z($n(x), activeKey$1))
        }));
        $n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_iterator);
        var x$3 = 0;
        var $$x2 = new $c_s_Some($n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_iterator).indexWhere__O__F1__I__I(items$2, x$2, x$3))
      };
      var this$6 = $n($$x2);
      var idx = $uI((this$6.isEmpty__Z() ? (-1) : this$6.get__O()));
      if ($n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_iterator).isEmpty__O__Z(items$2)) {
        var nextIdx$2 = $m_s_None$()
      } else {
        var nextIdx = ((idx + count) | 0);
        var len = $n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_iterator).length__O__I(items$2);
        var nextIdx$2 = new $c_s_Some(((nextIdx > len) ? (((-1) + len) | 0) : ((nextIdx < 0) ? 0 : nextIdx)))
      };
      var this$7 = $n(nextIdx$2);
      if (this$7.isEmpty__Z()) {
        var next = $m_s_None$()
      } else {
        var arg1$2 = this$7.get__O();
        var x$2$1 = $uI(arg1$2);
        var next = new $c_s_Some($n($as_T2($n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_iterator).apply__O__I__O(items$2, x$2$1)))._1__O())
      };
      var this$ = $n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_context).setActive__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(next);
      var f = new $c_sjsr_AnonFunction1(((cb$2) => {
        $as_jl_Void(cb$2)
      }));
      var this$9 = $n(this$);
      var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$9, f);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    }))))
  })));
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$12 = $m_s_$less$colon$less$();
  return $n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$12.s_$less$colon$less$__f_singleton)
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var active = $n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_items).flatMap__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((items$2) => {
    var this$3 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_active);
    if (this$3.isEmpty__Z()) {
      var $$x1 = $m_Ldiode_data_Empty$()
    } else {
      var arg1$1 = this$3.get__O();
      var x$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1$1);
      var $$x1 = new $c_Ldiode_data_Ready(x$3)
    };
    return $n($as_Ldiode_data_Pot($$x1)).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(v$2);
      return v
    })))
  })));
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$6 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_slideshowViewContainer;
  var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s$1);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$9 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$9.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$12 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n(arg1).Lcom_iz2use_react_style_Style__f_slideshowActiveItem;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$12, s$2), $n($n(p).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_renderer).render__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(active, new $c_sjsr_AnonFunction1(((count$2) => {
    var count = $uI(count$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.moveActive__I__Ljapgolly_scalajs_react_callback_Trampoline(count))
  })))];
  var $$x7 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$18 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $n(arg1).Lcom_iz2use_react_style_Style__f_slideshowViewNavigationBar;
  var $$x5 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$18, s$3);
  var $$x4 = $n($m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.moveActive__I__Ljapgolly_scalajs_react_callback_Trampoline((-1))));
  var this$19 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $n(arg1).Lcom_iz2use_react_style_Style__f_slideshowButton;
  var array$1 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$19, s$4), $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_arrowLeft, "", "24px")];
  var $$x3 = $n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x2 = $m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.moveActive__I__Ljapgolly_scalajs_react_callback_Trampoline(1));
  var this$23 = $m_Lscalacss_ScalaCssReact$();
  var s$5 = $n(arg1).Lcom_iz2use_react_style_Style__f_slideshowButton;
  var array$2 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$23, s$5), $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_arrowRight, "", "24px")];
  var array$3 = [$$x5, $$x3, $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var array$4 = [$$x10, $$x9, $$x7, $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  return $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
function $as_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.SlideshowView$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.SlideshowView$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment$1) {
  this.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_name = null;
  this.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_icon = null;
  this.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_columnFragment$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_columnFragment$1 = columnFragment$1;
  $f_Lcom_iz2use_react_components_internal_multiview_TableRenderer__$init$__V(this)
}
$c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype = $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype.defaultOrder__I = (function() {
  return 300
});
$c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype.name__T = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_name
});
$c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype.icon__Lcom_iz2use_react_components_IconSourceShape = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_icon
});
$c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype.render__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_vdom_VdomElement = (function(items, iterator, keyMapper, context, itemSimpleActions, decorator) {
  var $$x1 = $m_Lcom_iz2use_react_components_internal_multiview_table_TabularView$();
  var this$ = $n(context).active__Ljapgolly_scalajs_react_callback_Trampoline();
  var this$2 = $n(this$);
  var u = $n($$x1).apply__Ldiode_data_Pot__s_Option__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_TableRenderer__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(items, $as_s_Option($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)), keyMapper, this, itemSimpleActions, context, iterator, decorator);
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype.renderHeaders__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List = (function(context) {
  var end = $n(this.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_columnFragment$1).maxLevel__I();
  var isEmpty = (end < 0);
  if (isEmpty) {
    var scala$collection$immutable$Range$$numRangeElements = 0
  } else {
    var hi = (end >> 31);
    var lo = ((1 + end) | 0);
    var hi$1 = ((lo === 0) ? ((1 + hi) | 0) : hi);
    var scala$collection$immutable$Range$$numRangeElements = (((hi$1 === 0) ? (((-2147483648) ^ lo) > (-1)) : (hi$1 > 0)) ? (-1) : lo)
  };
  if ((scala$collection$immutable$Range$$numRangeElements < 0)) {
    $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, end, 1, true)
  };
  var b = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
  var it = new $c_sci_RangeIterator(0, 1, end, isEmpty);
  while (it.sci_RangeIterator__f__hasNext) {
    var this$7 = $n(b);
    var arg1 = it.next__I();
    var this$6 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var ns = $n(this.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_columnFragment$1).renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List(arg1, context);
    var elem = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$6, null, ns);
    this$7.addOne__O__scm_Growable(elem)
  };
  var this$8 = $n($as_sci_IndexedSeq($n(b).result__O()));
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$8)
});
$c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype.renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode = (function(in$1, editing) {
  return $n(this.Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2__f_columnFragment$1).renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode(in$1, $m_s_None$())
});
var $d_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2: 0
}, false, "com.iz2use.react.components.internal.multiview.TableRenderer$$anon$2", {
  Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_TableRenderer: 1,
  Lcom_iz2use_react_components_internal_multiview_View: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype = $c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.onMount__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, sourceChange) {
  return $n(sourceChange).pure__Ldiode_data_Pot__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ldiode_data_Ready(source))
});
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.onPropsChange__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline = (function(previous, next, sourceChange) {
  return $n(sourceChange).pure__Ldiode_data_Pot__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ldiode_data_Ready(next))
});
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.update__Ljapgolly_scalajs_react_extra_StateSnapshotF__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, item, cb, hasIterator, keyMapper) {
  var this$3 = $n(source);
  var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var arg1 = this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var this$4 = $n(hasIterator);
  var arg1$1 = $f_Lcom_iz2use_react_components_internal_multiview_HasIterator__update__O__O__Lcom_iz2use_common_KeyMapper__O(this$4, arg1, item, keyMapper);
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.append__Ljapgolly_scalajs_react_extra_StateSnapshotF__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, item, cb, hasIterator, keyMapper) {
  var this$3 = $n(source);
  var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var arg1 = this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var arg1$1 = $n(hasIterator).append__O__O__O(arg1, item);
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.append__O__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, item, cb, hasIterator, keyMapper) {
  return this.append__Ljapgolly_scalajs_react_extra_StateSnapshotF__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(source), item, cb, hasIterator, keyMapper)
});
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.update__O__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, item, cb, hasIterator, keyMapper) {
  return this.update__Ljapgolly_scalajs_react_extra_StateSnapshotF__O__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_callback_Trampoline($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(source), item, cb, hasIterator, keyMapper)
});
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.onPropsChange__O__O__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline = (function(previous, next, sourceChange) {
  return this.onPropsChange__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(previous), $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(next), sourceChange)
});
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.onMount__O__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, sourceChange) {
  return this.onMount__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_multiview_SourceChange__Ljapgolly_scalajs_react_callback_Trampoline($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(source), sourceChange)
});
var $d_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler: 0
}, false, "com.iz2use.react.components.internal.multiview.TraversableSourceHandler", {
  Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_SourceHandler: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend.prototype.click__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  var $$x1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
  $m_Ljapgolly_scalajs_react_package$();
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(p$2);
    $m_Ljapgolly_scalajs_react_Reusable$();
    var r = $n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActiveAndSelectView;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var self = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f);
  var this$$1 = $n($$x1).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev);
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p) {
  var model = $n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model;
  var this$1 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderable);
  var item = this$1.render__Lreactbuild_common_model_Project__Lcom_iz2use_react_components_internal_multiview_grid_GridItem($as_Lreactbuild_common_model_Project(model));
  var this$2 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$2.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x7 = $m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_ref);
  var $$x6 = $m_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$();
  var $$x5 = $n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_selected;
  var $$x4 = $n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_focused;
  var $$x3 = $n(item).Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_image;
  var $$x2 = $n(item).Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_imageOverlay;
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n(item).Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_title;
  var this$5 = $m_s_$less$colon$less$();
  return $as_Ljapgolly_scalajs_react_vdom_TagOf($n($$x7).foldLeft__O__F2__O($n($$x6).renderItem__Z__Z__s_Option__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagOf($$x5, $$x4, $$x3, $$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$5.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.click__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$2)))), arg1), new $c_sjsr_AnonFunction2(((x$1$2, x$2$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_vdom_TagOf(x$1$2);
    var x$2 = $as_Ljapgolly_scalajs_react_Ref$FullF(x$2$2);
    return $n(x$1).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(x$2))
  }))))
});
function $as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.grid.GridItem$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.grid.GridItem$TypedBackend;", depth))
}
function $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__renderLine$1__T2__Lcom_iz2use_react_components_internal_multiview_Actions__Z__Z__s_Option__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_Reusable__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__Ljapgolly_scalajs_react_vdom_TagMod($thiz, item, actions, selected, focused, ref, setActive, setActiveAndSelectView, decorator, p$3) {
  var u = $m_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$().withKey__T__O__sci_Map__Lcom_iz2use_react_components_internal_multiview_GridRenderer__Lcom_iz2use_react_components_internal_multiview_Actions__Z__Z__s_Option__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_Reusable__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Lcom_iz2use_react_components_internal_multiview_grid_GridRenderable__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_T($n($n(p$3).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper).apply__O__O($n(item)._1__O())), $n(item)._1__O(), $as_sci_Map($n(item)._2__O()), $n(p$3).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderer, actions, selected, focused, ref, setActive, $thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_setActiveAndGotoSlideshow, decorator, $n(p$3).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderable);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
}
function $ct_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_activeRowRef = new $c_s_Some($m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF());
  $thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_scrollDirection = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0();
  $thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_axes = $m_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$();
  var this$2 = $m_Ljapgolly_scalajs_react_Reusable$();
  var a = new $c_sjsr_AnonFunction1(((v$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)));
  this$2.const__O__Z__Ljapgolly_scalajs_react_Reusable(a, true);
  var this$4 = $m_Ljapgolly_scalajs_react_Reusable$();
  var a$1 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(p$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_context).setActive__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(new $c_s_Some(v$3$2)))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f))
  }));
  $thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_setActive = this$4.const__O__Z__Ljapgolly_scalajs_react_Reusable(a$1, true);
  var this$9 = $m_Ljapgolly_scalajs_react_Reusable$();
  var a$2 = new $c_sjsr_AnonFunction1(((v$4$2) => {
    var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f$1 = new $c_sjsr_AnonFunction1(((p$2$1) => {
      var p$1 = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(p$2$1);
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x2 = $n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_context).setActive__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(new $c_s_Some(v$4$2));
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co = $n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_context).selectView__s_reflect_ClassTag__F0(new $c_s_reflect_ClassTag$GenericClassTag($d_Lcom_iz2use_react_components_internal_multiview_Slideshow.getClassOf()));
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$7 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x2, $n($$x1).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$7.s_$less$colon$less$__f_singleton)))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$1))
  }));
  $thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_setActiveAndGotoSlideshow = this$9.const__O__Z__Ljapgolly_scalajs_react_Reusable(a$2, true);
  $thiz.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_axesContext = new $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_activeRowRef = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_scrollDirection = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_axes = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_setActive = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_setActiveAndGotoSlideshow = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_axesContext = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_gridListContainer;
  var $$x8 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$7 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$7.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onKeyDown");
  var $$x6 = new $c_sjsr_AnonFunction1(((e$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n(this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_axes).handleKey__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Lcom_iz2use_react_components_internal_multiview_AxesContext__F0(e$2, this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_axesContext))));
  var this$12 = $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$();
  var F = $m_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$();
  var $$x5 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod($$x6, $f_Ljapgolly_scalajs_react_vdom_Attr$EventCallback2__dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(this$12, F));
  var this$13 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items);
  if ((!this$13.isEmpty__Z())) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $n($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_hasIterator);
    var in$1 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items).get__O();
    var in$2 = $as_sc_Iterable(in$1);
    var as = $n(in$2).iterator__sc_Iterator();
    var $$x1 = $n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((item$2) => {
      var item = $as_T2(item$2);
      var this$16 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_active);
      if ((!this$16.isEmpty__Z())) {
        var arg1$1 = this$16.get__O();
        var x$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1$1);
        var x = $n(x$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
        var y = $n(item)._1__O();
        var isActive = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
      } else {
        var isActive = false
      };
      var $$x4 = $n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_itemSimpleActions;
      var this$17 = $n(this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_activeRowRef);
      if (this$17.isEmpty__Z()) {
        var $$x3 = true
      } else {
        var arg1$2 = this$17.s_Some__f_value;
        $as_Ljapgolly_scalajs_react_Ref$FullF(arg1$2);
        var $$x3 = isActive
      };
      return $p_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__renderLine$1__T2__Lcom_iz2use_react_components_internal_multiview_Actions__Z__Z__s_Option__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_Reusable__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__Ljapgolly_scalajs_react_vdom_TagMod(this, item, $$x4, isActive, isActive, ($$x3 ? this$17 : $m_s_None$()), this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_setActive, this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_setActiveAndGotoSlideshow, $n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_decorator, p)
    })))
  } else {
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "progress"), $m_sci_Nil$())
  };
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var o = $n($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_context).Lcom_iz2use_react_components_Multiview$ZTypedBackend$$anon$1__f_createNew;
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var array = [$$x8, $$x7, $$x5, $$x1, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(f$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$().renderItem__Z__Z__s_Option__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagOf(false, false, new $c_s_Some($m_Lcom_iz2use_react_components_internal_multiview_grid_GridView$().Lcom_iz2use_react_components_internal_multiview_grid_GridView$__f_newIcon), $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty, ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cr\u00e9er")), new $c_sjsr_AnonFunction1(((x$5$2) => {
      var this$ = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$().asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(($m_Ljapgolly_scalajs_react_package$(), f), x$5$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty))
    })), arg1)
  })))];
  return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype.onUpdate__Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(s) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_scrollDirection, new $c_sjsr_AnonFunction1(((direction$2) => {
    var direction = $as_Lcom_iz2use_react_components_internal_multiview_Direction(direction$2);
    var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$2 = $n(this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_activeRowRef);
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_Ref$GetF(this$2.s_Some__f_value)).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$3 = $m_s_$less$colon$less$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x3).flatMap$extension__F0__F1__F0($n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$3.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((elt$2) => {
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => this.findScrollableParent__Lorg_scalajs_dom_HTMLElement__D__s_Option(elt$2.parentElement, 0.0))));
      var condition = new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
        var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
        return (check$ifrefutable$1 !== null)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x4).map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$, condition), new $c_sjsr_AnonFunction1(((x$6$2) => {
        var x$6 = $as_T2(x$6$2);
        if ((x$6 !== null)) {
          var scrollableParent = $n(x$6)._1__O();
          var offsetTop = $n(x$6)._2$mcD$sp__D();
          this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_scrollDirection = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0();
          var top = $uD(elt$2.offsetTop);
          var bottom = (top + $uD(elt$2.offsetHeight));
          if (((bottom > ($uD(scrollableParent.offsetHeight) + $uD(scrollableParent.scrollTop))) || (top < $uD(scrollableParent.scrollTop)))) {
            var x = $m_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$();
            if ((x === direction)) {
              scrollableParent.scrollTop = (top - $uD(scrollableParent.offsetHeight))
            } else {
              var x$3 = $m_Lcom_iz2use_react_components_internal_multiview_Direction$Next$();
              if ((x$3 === direction)) {
                scrollableParent.scrollTop = (top - offsetTop)
              } else {
                throw new $c_s_MatchError(direction)
              }
            }
          }
        } else {
          throw new $c_s_MatchError(x$6)
        }
      })), null))
    }))))
  })));
  var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$6 = $m_s_$less$colon$less$();
  return $n($$x5).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$6.s_$less$colon$less$__f_singleton)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend.prototype.findScrollableParent__Lorg_scalajs_dom_HTMLElement__D__s_Option = (function(element, offset) {
  while (true) {
    if (($uI(element.scrollHeight) <= $uI(element.clientHeight))) {
      var x1 = element.parentElement;
      if ((x1 === null)) {
        return $m_s_None$()
      } else {
        var this$1 = $n($as_T(element.tagName));
        _return: {
          var len = this$1.length;
          if ((len === 5)) {
            var i = 0;
            while ((i !== len)) {
              var index = i;
              var c = $charAt(this$1, index);
              var $$x2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
              var index$1 = i;
              var c$1 = $charAt("TBODY", index$1);
              if (($$x2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
                var $$x1 = false;
                break _return
              };
              i = ((1 + i) | 0)
            };
            var $$x1 = true
          } else {
            var $$x1 = false
          }
        };
        if ($$x1) {
          var temp$offset = $uD(element.offsetTop)
        } else {
          var temp$offset = offset
        };
        element = x1;
        offset = temp$offset
      }
    } else {
      var self = element;
      var y = offset;
      return new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, y))
    }
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.grid.GridView$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.grid.GridView$TypedBackend;", depth))
}
function $ct_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__Lcom_iz2use_react_components_internal_multiview_list_ListView__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__f_$outer = outer
  };
  $thiz.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__f_$outer = null
}
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_listView;
  var $$x12 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n(arg1).Lcom_iz2use_react_style_Style__f_listItem;
  var $$x9 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$2);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("__check", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var $$x6 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$();
  var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("checkbox", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$1 = [$$x7, $n($$x6).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var $$x5 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n($n(p).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_renderer).Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1__f_fields;
  var array$3 = [$$x9, $$x5, $n($$x4).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((field$2) => {
    var field = $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(field$2);
    var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$20 = $m_Lscalacss_ScalaCssReact$();
    var s$3 = $n(arg1).Lcom_iz2use_react_style_Style__f_listItemField;
    var array$2 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$20, s$3), $n(field).renderInlineHeaderLabel__Ljapgolly_scalajs_react_vdom_TagMod()];
    return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  })))];
  var $$x3 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var this$27 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_items);
  if ((!this$27.isEmpty__Z())) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $n($n(this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__f_$outer).Lcom_iz2use_react_components_internal_multiview_list_ListView__f_com$iz2use$react$components$internal$multiview$list$ListView$$iterator);
    var in$1 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_items).get__O();
    var in$2 = $as_sc_Iterable(in$1);
    var as$1 = $n(in$2).iterator__sc_Iterator();
    var $$x1 = $n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var item = $n(x0$1)._1__O();
        var map = $as_sci_Map($n(x0$1)._2__O());
        var u = $m_Lcom_iz2use_react_components_internal_multiview_list_ListItem$().withKey__T__O__sci_Map__Lcom_iz2use_react_components_internal_multiview_ListRenderer__s_Option__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_T($n($n(p).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_keyMapper).apply__O__O(item)), item, map, $n(p).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_renderer, $m_s_None$(), $n(p).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_itemSimpleActions, arg1);
        var this$31 = $n(u);
        var n = this$31.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })))
  } else {
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "progress"), $m_sci_Nil$())
  };
  var array$4 = [$$x12, $$x3, $$x1];
  return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
function $as_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.list.ListView$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.list.ListView$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype.click__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  var $$x1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
  $m_Ljapgolly_scalajs_react_package$();
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(p$2);
    $m_Ljapgolly_scalajs_react_Reusable$();
    var r = $n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActive;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var self = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f);
  var this$$1 = $n($$x1).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev);
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype.dblClick__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  var $$x1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
  $m_Ljapgolly_scalajs_react_package$();
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(p$2);
    $m_Ljapgolly_scalajs_react_Reusable$();
    var r = $n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActiveAndSelectView;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(r).value__O())).apply__O__O($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  var self = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f);
  var this$$1 = $n($$x1).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev);
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p) {
  var model = $n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model;
  var gen = $n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_map;
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x14 = $m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_ref);
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_multiviewSelected;
  var this$5 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s));
  var condition = $n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_selected;
  var $$x12 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$5, condition);
  var this$6 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_multiviewFocused;
  var this$7 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s$1));
  var condition$1 = $n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_focused;
  var $$x11 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$7, condition$1);
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("__check", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS)];
  var $$x9 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.click__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDoubleClick");
  var $$x7 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$3$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.dblClick__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$3$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  var $$x6 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_renderer).renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode(gen, $m_s_None$());
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x2 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("__actions", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_itemSimpleActions);
  var as = $m_s_package$().s_package$__f_Nil;
  var array$3 = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((a$2) => {
    var a = $as_Lcom_iz2use_react_components_internal_multiview_Action(a$2);
    var x1 = $n(a).icon__Lcom_iz2use_react_components_IconSource();
    var x = $m_Lcom_iz2use_react_components_NoIconSource$();
    if ((x === x1)) {
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(a).name__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(a).description__T(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(a).action__F1()).apply__O__O(model))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
      return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    } else {
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$2 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($n(a).icon__Lcom_iz2use_react_components_IconSource(), "", "24px"), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(a).name__T(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(a).action__F1()).apply__O__O(model))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
      return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    }
  })))];
  var array$4 = [$$x12, $$x11, $$x9, $$x8, $$x7, $$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  return $as_Ljapgolly_scalajs_react_vdom_TagOf($n($$x14).foldLeft__O__F2__O($n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)), new $c_sjsr_AnonFunction2(((x$2$2, x$3$2) => {
    var x$2 = $as_Ljapgolly_scalajs_react_vdom_TagOf(x$2$2);
    var x$3 = $as_Ljapgolly_scalajs_react_Ref$FullF(x$3$2);
    return $n(x$2).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(x$3))
  }))))
});
function $as_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.table.TabularLine$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.table.TabularLine$TypedBackend;", depth))
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__renderLine$1__T2__Lcom_iz2use_react_components_internal_multiview_Actions__s_Option__Z__Z__s_Option__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_Reusable__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__Ljapgolly_scalajs_react_vdom_TagMod($thiz, item, actions, editing, selected, focused, ref, setActive, setActiveAndSelectView, decorator, p$2) {
  var u = $m_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$().withKey__T__O__sci_Map__Lcom_iz2use_react_components_internal_multiview_TableRenderer__s_Option__Lcom_iz2use_react_components_internal_multiview_Actions__Z__Z__s_Option__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_Reusable__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_T($n($n(p$2).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper).apply__O__O($n(item)._1__O())), $n(item)._1__O(), $as_sci_Map($n(item)._2__O()), $n(p$2).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer, editing, actions, selected, focused, ref, setActive, $thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_setActiveAndGotoSlideshow, decorator);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
}
function $ct_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  var _reuse = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  $thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_renderHeaders = $m_Ljapgolly_scalajs_react_React$().memo__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot__F2__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_Generic$ComponentSimple($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent).apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((r$2) => {
    var r = $as_Lcom_iz2use_react_components_internal_multiview_TableRenderer(r$2);
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var $$x1 = $n(r);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$6 = $n(this$);
    var as = $n($$x1).renderHeaders__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List($n($as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$6))).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_context);
    var array$1 = [$n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((lst$2) => {
      var lst = $as_Ljapgolly_scalajs_react_vdom_VdomNode(lst$2);
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array = [$m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "th"), $m_sci_Nil$()), lst, $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "th"), $m_sci_Nil$())];
      return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    })))];
    return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  })), $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null))), _reuse, $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)));
  $thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_activeRowRef = new $c_s_Some($m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF());
  $thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_scrollDirection = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0();
  $thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_axes = $m_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$();
  var this$20 = $m_Ljapgolly_scalajs_react_Reusable$();
  var a = new $c_sjsr_AnonFunction1(((v$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)));
  this$20.const__O__Z__Ljapgolly_scalajs_react_Reusable(a, true);
  var this$22 = $m_Ljapgolly_scalajs_react_Reusable$();
  var a$1 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(p$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_context).setActive__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(new $c_s_Some(v$3$2)))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f))
  }));
  $thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_setActive = this$22.const__O__Z__Ljapgolly_scalajs_react_Reusable(a$1, true);
  var this$27 = $m_Ljapgolly_scalajs_react_Reusable$();
  var a$2 = new $c_sjsr_AnonFunction1(((v$4$2) => {
    var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f$1 = new $c_sjsr_AnonFunction1(((p$2$1) => {
      var p$1 = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(p$2$1);
      var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x6 = $n($n(p$1).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_context).setActive__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(new $c_s_Some(v$4$2));
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co = $n($n(p$1).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_context).selectView__s_reflect_ClassTag__F0(new $c_s_reflect_ClassTag$GenericClassTag($d_Lcom_iz2use_react_components_internal_multiview_Slideshow.getClassOf()));
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$25 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x7).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x6, $n($$x5).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$25.s_$less$colon$less$__f_singleton)))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$2, f$1))
  }));
  $thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_setActiveAndGotoSlideshow = this$27.const__O__Z__Ljapgolly_scalajs_react_Reusable(a$2, true);
  $thiz.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_axesContext = new $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_renderHeaders = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_activeRowRef = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_scrollDirection = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_axes = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_setActive = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_setActiveAndGotoSlideshow = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_axesContext = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_tabularViewContainer;
  var $$x15 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$7 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$7.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onKeyDown");
  var $$x13 = new $c_sjsr_AnonFunction1(((e$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n(this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_axes).handleKey__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Lcom_iz2use_react_components_internal_multiview_AxesContext__F0(e$2, this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_axesContext))));
  var this$12 = $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$();
  var F = $m_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$();
  var $$x12 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod($$x13, $f_Ljapgolly_scalajs_react_vdom_Attr$EventCallback2__dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(this$12, F));
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$15 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n(arg1).Lcom_iz2use_react_style_Style__f_tabularView;
  var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$15, s$2);
  var c = this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_renderHeaders;
  var this$17 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = $n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer;
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$17.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$17.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$19 = $n(u);
  var n = this$19.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  var this$21 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items);
  if ((!this$21.isEmpty__Z())) {
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_hasIterator);
    var in$1 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items).get__O();
    var in$2 = $as_sc_Iterable(in$1);
    var as = $n(in$2).iterator__sc_Iterator();
    var array = [$n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((item$2) => {
      var item = $as_T2(item$2);
      var this$26 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_active);
      if ((!this$26.isEmpty__Z())) {
        var arg1$1 = this$26.get__O();
        var x$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1$1);
        var x = $n(x$3).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
        var y = $n(item)._1__O();
        var isActive = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
      } else {
        var isActive = false
      };
      var $$x6 = $n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_itemSimpleActions;
      var this$27 = $n($n(s).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__f_editing);
      if (this$27.isEmpty__Z()) {
        var $$x5 = true
      } else {
        var arg1$2 = this$27.get__O();
        var x$4 = $as_Lcom_iz2use_react_components_internal_multiview_table_Editing(arg1$2);
        var x$1 = $n(x$4).item__T2();
        var $$x5 = ((x$1 === null) ? (item === null) : $n(x$1).equals__O__Z(item))
      };
      if ($$x5) {
        var $$x4 = this$27
      } else {
        var $$x4 = $m_s_None$()
      };
      var this$28 = $n(this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_activeRowRef);
      if (this$28.isEmpty__Z()) {
        var $$x3 = true
      } else {
        var arg1$3 = this$28.s_Some__f_value;
        $as_Ljapgolly_scalajs_react_Ref$FullF(arg1$3);
        var $$x3 = isActive
      };
      return $p_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__renderLine$1__T2__Lcom_iz2use_react_components_internal_multiview_Actions__s_Option__Z__Z__s_Option__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_Reusable__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__Ljapgolly_scalajs_react_vdom_TagMod(this, item, $$x6, $$x4, isActive, isActive, ($$x3 ? this$28 : $m_s_None$()), this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_setActive, this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_setActiveAndGotoSlideshow, $n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_decorator, p)
    })))];
    var $$x1 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$34 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer);
    var array$1 = [$f_Lcom_iz2use_react_components_internal_multiview_TableRenderer__renderSkeleton__Ljapgolly_scalajs_react_vdom_VdomNode(this$34)];
    var $$x1 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  };
  var array$2 = [$$x10, $$x9, $$x1, $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "tfoot"), $m_sci_Nil$())];
  var array$3 = [$$x15, $$x14, $$x12, $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  return $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype.onUpdate__Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(s) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_scrollDirection, new $c_sjsr_AnonFunction1(((direction$2) => {
    var direction = $as_Lcom_iz2use_react_components_internal_multiview_Direction(direction$2);
    var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$2 = $n(this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_activeRowRef);
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_Ref$GetF(this$2.s_Some__f_value)).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$3 = $m_s_$less$colon$less$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x3).flatMap$extension__F0__F1__F0($n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$3.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((elt$2) => {
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => this.findScrollableParent__Lorg_scalajs_dom_HTMLElement__D__s_Option(elt$2.parentElement, 0.0))));
      var condition = new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
        var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
        return (check$ifrefutable$1 !== null)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x4).map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$, condition), new $c_sjsr_AnonFunction1(((x$6$2) => {
        var x$6 = $as_T2(x$6$2);
        if ((x$6 !== null)) {
          var scrollableParent = $n(x$6)._1__O();
          var offsetTop = $n(x$6)._2$mcD$sp__D();
          this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_scrollDirection = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0();
          var top = $uD(elt$2.offsetTop);
          var bottom = (top + $uD(elt$2.offsetHeight));
          if (((bottom > ($uD(scrollableParent.offsetHeight) + $uD(scrollableParent.scrollTop))) || (top < $uD(scrollableParent.scrollTop)))) {
            var x = $m_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$();
            if ((x === direction)) {
              scrollableParent.scrollTop = (top - $uD(scrollableParent.offsetHeight))
            } else {
              var x$3 = $m_Lcom_iz2use_react_components_internal_multiview_Direction$Next$();
              if ((x$3 === direction)) {
                scrollableParent.scrollTop = (top - offsetTop)
              } else {
                throw new $c_s_MatchError(direction)
              }
            }
          }
        } else {
          throw new $c_s_MatchError(x$6)
        }
      })), null))
    }))))
  })));
  var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$6 = $m_s_$less$colon$less$();
  return $n($$x5).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$6.s_$less$colon$less$__f_singleton)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend.prototype.findScrollableParent__Lorg_scalajs_dom_HTMLElement__D__s_Option = (function(element, offset) {
  while (true) {
    if (($uI(element.scrollHeight) <= $uI(element.clientHeight))) {
      var x1 = element.parentElement;
      if ((x1 === null)) {
        return $m_s_None$()
      } else {
        var this$1 = $n($as_T(element.tagName));
        _return: {
          var len = this$1.length;
          if ((len === 5)) {
            var i = 0;
            while ((i !== len)) {
              var index = i;
              var c = $charAt(this$1, index);
              var $$x2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
              var index$1 = i;
              var c$1 = $charAt("TBODY", index$1);
              if (($$x2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
                var $$x1 = false;
                break _return
              };
              i = ((1 + i) | 0)
            };
            var $$x1 = true
          } else {
            var $$x1 = false
          }
        };
        if ($$x1) {
          var temp$offset = $uD(element.offsetTop)
        } else {
          var temp$offset = offset
        };
        element = x1;
        offset = temp$offset
      }
    } else {
      var self = element;
      var y = offset;
      return new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, y))
    }
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.table.TabularView$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.table.TabularView$TypedBackend;", depth))
}
function $ct_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $thiz.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_onKeyDown = new $c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster();
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_onKeyDown = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype.create__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(p$2);
    var cb = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).traverseOption__F0__F1__F1(new $c_sjsr_AnonFunction0((() => $as_s_Option($n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_handleNonexistent).apply__O__O($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_search)))), new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_s_concurrent_Future(x$1$2);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => x$1)), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor()))
    }))), new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_s_Option(v$2);
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).traverseOption__F0__F1__F1(new $c_sjsr_AnonFunction0((() => v)), new $c_sjsr_AnonFunction1(((v$2$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_CallbackTo$().asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context).Lcom_iz2use_react_components_internal_TextEditorContext__f_selectAndValid).apply__O__O(v$2$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))))), new $c_sjsr_AnonFunction1(((x$2$2) => {
        $as_s_Option(x$2$2)
      }))))
    })));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(cb))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(p, s) {
  var $$x2 = $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$();
  var $$x1 = $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_search;
  var this$1 = $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context);
  var onKeyDown = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_onKeyDown;
  return $n($$x2).apply__T__Lcom_iz2use_react_components_internal_TextEditorContext__F2__Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler__Ljapgolly_scalajs_react_callback_Trampoline__Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__Lcom_iz2use_react_components_internal_suggestion_FetcherBackend__Lcom_iz2use_common_Filter__F1__s_math_Equiv__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_react_components_internal_Highlighter__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x1, new $c_Lcom_iz2use_react_components_internal_TextEditorContext(onKeyDown, this$1.Lcom_iz2use_react_components_internal_TextEditorContext__f_select, this$1.Lcom_iz2use_react_components_internal_TextEditorContext__f_selectAndValid, this$1.Lcom_iz2use_react_components_internal_TextEditorContext__f_cancel, this$1.Lcom_iz2use_react_components_internal_TextEditorContext__f_scrollIntoView, this$1.Lcom_iz2use_react_components_internal_TextEditorContext__f_isModified), $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_renderItem, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_focusHandler, this.create__Ljapgolly_scalajs_react_callback_Trampoline(), $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_fetcher, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_fetcherBackend, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_filter, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_keyOf, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_equiv, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_tokenizer, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_tokenMatcher, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_highlighter)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend.prototype.handleKeyDown__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().zip$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var f$1 = new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var p = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps($n(x0$1)._1__O());
        var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_package$();
        $m_Ljapgolly_scalajs_react_package$();
        var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
        var x$6 = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1(this);
        var ifEnter = $n($$x4).flatMap$extension__F0__F1__F0($n($$x3).flatMapOption$extension__F0__F1__F0($n($$x2).flatMap$extension__F0__F1__F0(qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e$2, $uI(e$2.keyCode), false, false, false, false, x$6), new $c_sjsr_AnonFunction1(((x$3$2$2) => {
          $as_jl_Void(x$3$2$2);
          var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var $$x5 = $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context).Lcom_iz2use_react_components_internal_TextEditorContext__f_isModified;
          var this$3 = $m_s_$less$colon$less$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x6).requireCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x5, this$3.s_$less$colon$less$__f_singleton))
        }))), new $c_sjsr_AnonFunction1(((x$4$2$2) => {
          $as_jl_Void(x$4$2$2);
          return $as_s_Option($n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_handleNonexistent).apply__O__O($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_search))
        }))), new $c_sjsr_AnonFunction1(((f$2) => {
          var f = $as_s_concurrent_Future(f$2);
          $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          var c = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => $n(f).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((v$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context).Lcom_iz2use_react_components_internal_TextEditorContext__f_select).apply__O__O(v$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor()))), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor());
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
        })));
        $m_Ljapgolly_scalajs_react_package$();
        $m_Ljapgolly_scalajs_react_package$();
        var qual$2 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
        var x$12 = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2(this, p);
        var others = qual$2.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e$2, $uI(e$2.keyCode), false, false, false, false, x$12);
        var $$x11 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var $$x10 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var $$x9 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_onKeyDown).broadcast__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline(e$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x7 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$();
        $m_Ljapgolly_scalajs_react_package$();
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var self$2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().orElse$extension__F0__F0__F0(ifEnter, others);
        var co = $n($$x7).asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0(self$2, e$2);
        var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$11 = $m_s_$less$colon$less$();
        var this$ = $n($$x11).when$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline($n($$x10).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x9, $n($$x8).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$11.s_$less$colon$less$__f_singleton)), new $c_sjsr_AnonFunction0((() => $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_open)));
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
      } else {
        var $$x1;
        throw new $c_s_MatchError(x0$1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$1))
  }))
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend.prototype.onPropsChange__Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(prevProps, nextProps, state) {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$3 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState(x$2$2);
    $n(x$2);
    var rendered = $n(nextProps).render__Ljapgolly_scalajs_react_vdom_VdomElement();
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState(rendered)
  }));
  var this$ = $n($$x1).when$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction0((() => (!((prevProps === null) ? (nextProps === null) : $n(prevProps).equals__O__Z(nextProps))))));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionItem$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionItem$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype.onMount__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(p) {
  $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcherBackend);
  var fetcher = $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcher;
  var fetcher$1 = $as_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher(fetcher);
  var x1 = new $c_s_Some($n(fetcher$1).initialFetch__s_concurrent_Future());
  var x = $m_s_None$();
  if ((x === x1)) {
    return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
  } else {
    var f = $as_s_concurrent_Future(x1.s_Some__f_value);
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$4 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(x$5$2);
      var this$3 = $n(x$5);
      var arg1 = this$3.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems;
      var loadedItems = $n(arg1).pending__J__Ldiode_data_Pot($n(arg1).pending$default$1__J());
      var arg1$1 = this$3.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems;
      var showedItems = $n(arg1$1).pending__J__Ldiode_data_Pot($n(arg1$1).pending$default$1__J());
      return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(loadedItems, showedItems)
    }));
    return $n($$x1).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$4, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$14$2) => {
      $as_jl_Void(x$14$2);
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
      var f$1 = new $c_sjsr_AnonFunction0((() => $n(f).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$8$2) => {
        var x$8 = $as_sci_Seq(x$8$2);
        return $n(p).mapTokenize__sci_Seq__sci_Seq(x$8)
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1), new $c_sjsr_AnonFunction1(((h$2) => {
        var h = $as_s_concurrent_Future(h$2);
        var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => $n($n(h).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((v$2) => {
          var v = $as_sci_Seq(v$2);
          var this$11 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend__f_$);
          var mod$1 = new $c_sjsr_AnonFunction1(((s$2) => {
            var s = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(s$2);
            var this$8 = $n(s);
            var arg1$2 = this$8.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems;
            $n(arg1$2);
            var loadedItems$1 = new $c_Ldiode_data_Ready(v);
            var arg1$3 = this$8.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems;
            $n(arg1$3);
            var value = $n(p).mapMatch__sci_Seq__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__sci_Seq(v, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizedSearch);
            var showedItems$1 = new $c_Ldiode_data_Ready(value);
            return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(loadedItems$1, showedItems$1)
          }));
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$11, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1(this), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
        var f$2 = new $c_sjsr_AnonFunction1(((i$2) => {
          $as_jl_Void(i$2)
        }));
        var this$16 = $n(this$);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$16, f$2))
      }))))
    })))
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype.handleSourceUpdate__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((x$15$2) => {
    var x$15 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(x$15$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.onMount__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline(x$15))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype.onPropsChange__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(prevProps, nextProps, state) {
  var x$2 = $n(state).updating$default$1__F1();
  var this$1 = $n(state);
  var loadedItems = $as_Ldiode_data_Pot($n(x$2).apply__O__O(this$1.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems));
  var arg1 = this$1.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems;
  var showedItems = $n(arg1).pending__J__Ldiode_data_Pot($n(arg1).pending$default$1__J());
  var s = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(loadedItems, showedItems);
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$3 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$17$2) => {
    $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(x$17$2);
    return s
  }));
  var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var $$x1 = this.wrapFutureAndHandleTokenizedItems__F1();
  var this$4 = $n($n(nextProps).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcherBackend);
  var fetcher = $n(nextProps).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcher;
  return $n($$x3).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x2, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).apply__O__O(this$4.onPropsChange__Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__s_concurrent_Future($as_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher(fetcher), nextProps, s)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend.prototype.wrapFutureAndHandleTokenizedItems__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_s_concurrent_Future(f$2);
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f$1 = new $c_sjsr_AnonFunction0((() => f));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1), new $c_sjsr_AnonFunction1(((g$2) => {
      var g = $as_s_concurrent_Future(g$2);
      var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => $n($n(g).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((v$2) => {
        var v = $as_sci_Seq(v$2);
        var this$6 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend__f_$);
        var mod = new $c_sjsr_AnonFunction1(((x$18$2) => {
          var x$18 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(x$18$2);
          var x$2 = $n(x$18).updating$default$1__F1();
          var this$4 = $n(x$18);
          var loadedItems = $as_Ldiode_data_Pot($n(x$2).apply__O__O(this$4.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems));
          var arg1 = this$4.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems;
          $n(arg1);
          var showedItems = new $c_Ldiode_data_Ready(v);
          return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(loadedItems, showedItems)
        }));
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$6, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1(this), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
      var f$3 = new $c_sjsr_AnonFunction1(((h$2) => {
        $as_jl_Void(h$2)
      }));
      var this$11 = $n(this$);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$11, f$3))
    }))))
  }))
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedBackend;", depth))
}
function $p_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__create$1__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagOf($thiz, p$1, style$1) {
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x2 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(p$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_create))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  var $$x1 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("create", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(style$1).Lcom_iz2use_react_style_Style__f_autocompleteItemActive;
  var array = [$$x2, $$x1, $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cr\u00e9er ?"))];
  return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
}
function $ct_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__($thiz) {
  $thiz.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $thiz.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_scrollTo = $m_s_None$();
  $thiz.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_listRef = $m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF();
  new $c_s_Some(0);
  return $thiz
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_scrollTo = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_listRef = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.render__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n(arg1).Lcom_iz2use_react_style_Style__f_autocompleteContainer;
  var $$x21 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
  var this$5 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n(arg1).Lcom_iz2use_react_style_Style__f_autocompleteContainerError;
  var this$6 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s$2));
  var condition = $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items).isFailed__Z();
  var $$x20 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$6, condition);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $n(arg1).Lcom_iz2use_react_style_Style__f_autocompleteContainerPending;
  var this$8 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$3));
  var condition$1 = $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items).isPending__Z();
  var $$x19 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$8, condition$1);
  var this$9 = $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items);
  if ((!this$9.isEmpty__Z())) {
    var items = $as_sci_Seq($n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items).get__O());
    var this$42 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var this$10 = $n($n(items).headOption__s_Option());
    if ((!this$10.isEmpty__Z())) {
      var arg1$1 = this$10.get__O();
      var x$3 = $as_T2(arg1$1);
      var $$x5 = ($n($as_Lcom_iz2use_common_TokenMatches($n(x$3)._2__O())).Lcom_iz2use_common_TokenMatches__f_score > 0.5)
    } else {
      var $$x5 = false
    };
    if ((!$$x5)) {
      var $$x4 = $p_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__create$1__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagOf(this, p, arg1)
    } else {
      var $$x4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
    };
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $as_sc_IterableOnce($n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items).get__O());
    var array$4 = [$$x4, $n($$x3).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var item = $n(x0$1)._1__O();
        var matches = $as_Lcom_iz2use_common_TokenMatches($n(x0$1)._2__O());
        var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x15 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_context).Lcom_iz2use_react_components_internal_TextEditorContext__f_selectAndValid).apply__O__O(item))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
        var $$x14 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_keyOf).apply__O__O(item), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
        var this$14 = $m_Lscalacss_ScalaCssReact$();
        var s$4 = $n(arg1).Lcom_iz2use_react_style_Style__f_autocompleteItemActive;
        var this$16 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$14, s$4));
        var this$15 = $n($n(s).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__f_selected);
        if ((!this$15.isEmpty__Z())) {
          var arg1$2 = this$15.get__O();
          var s$5 = $as_T2(arg1$2);
          var condition$2 = $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_equiv).equiv__O__O__Z($n(s$5)._1__O(), item)
        } else {
          var condition$2 = false
        };
        var $$x13 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$16, condition$2);
        var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$19 = $m_Lscalacss_ScalaCssReact$();
        var s$6 = $n(arg1).Lcom_iz2use_react_style_Style__f_autocompleteScoreWrapper;
        var $$x11 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$19, s$6);
        var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$22 = $m_Lscalacss_ScalaCssReact$();
        var s$7 = $n(arg1).Lcom_iz2use_react_style_Style__f_autocompleteScore;
        var $$x9 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$22, s$7);
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width");
        var $$x7 = $m_sc_StringOps$();
        var array = [(100.0 * $n(matches).Lcom_iz2use_common_TokenMatches__f_score)];
        var array$1 = [$$x9, $$x8.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n($$x7).format$extension__T__sci_Seq__T("%.0f%%", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
        var array$2 = [$$x11, $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
        var $$x6 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
        var u = $m_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$().apply__O__Lcom_iz2use_common_TokenMatches__Lcom_iz2use_react_components_internal_Highlighter__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(item, matches, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_highlighter, $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_renderItem);
        var this$34 = $n(u);
        var n = this$34.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var array$3 = [$$x15, $$x14, $$x13, $$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
        return $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })))];
    var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
    var $$x2 = this$42.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
  } else {
    var this$53 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var $$x18 = $p_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__create$1__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_style_Style__Ljapgolly_scalajs_react_vdom_TagOf(this, p, arg1);
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = ("" + $n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$5 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var array$6 = [$$x18, $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var ms$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
    var $$x2 = this$53.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1)
  };
  var array$7 = [$$x21, $$x20, $$x19, $$x2];
  var $$x1 = $n($n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)));
  var r = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_listRef;
  return $n($$x1).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(r))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.onUpdate__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(p) {
  var x1 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_scrollTo;
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var idx = $uI($n(x2).s_Some__f_value);
    this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_scrollTo = $m_s_None$();
    var this$2 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_listRef);
    var f = new $c_sjsr_AnonFunction1(((v$2) => {
      if ((idx < $uI(v$2.children.length))) {
        var item = v$2.children[idx];
        var top = $uD(item.offsetTop);
        var bottom = ($uD(item.offsetTop) + $uD(item.offsetHeight));
        if (((bottom > ($uD(v$2.offsetHeight) + $uD(v$2.scrollTop))) || (top < $uD(v$2.scrollTop)))) {
          v$2.scrollTop = top
        }
      }
    }));
    return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_Ref$GetF__foreach__F1__O(this$2, f))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
  } else {
    return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.handleKeyDown__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    var this$$2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().zip$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var p = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps($n(x0$1)._1__O());
        var s = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState($n(x0$1)._2__O());
        var x1$2 = $n(s).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__f_selected;
        matchEnd6: {
          var ifEnter;
          if ((x1$2 instanceof $c_s_Some)) {
            var x2 = $as_s_Some(x1$2);
            var p3 = $as_T2($n(x2).s_Some__f_value);
            if ((p3 !== null)) {
              var v = $n(p3)._1__O();
              $m_Ljapgolly_scalajs_react_package$();
              $m_Ljapgolly_scalajs_react_package$();
              var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
              var x$6 = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1(this, s, p, v);
              var ifEnter = qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e$2, $uI(e$2.keyCode), false, false, false, false, x$6);
              break matchEnd6
            }
          };
          var ifEnter = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0()
        };
        $m_Ljapgolly_scalajs_react_package$();
        $m_Ljapgolly_scalajs_react_package$();
        var qual$2 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
        var x$12 = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2(this, p, s);
        var others = qual$2.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(e$2, $uI(e$2.keyCode), false, false, false, false, x$12);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_package$();
        var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var c = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e$2, this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$ = $n($$x2).$greater$greater$extension__F0__F0__F0(ifEnter, $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c));
        var cond = new $c_sjsr_AnonFunction0((() => $uZ(e$2.defaultPrevented)));
        var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().when$extension__F0__F0__F0(this$, new $c_sjsr_AnonFunction0((() => (!$uZ(cond.apply__O())))));
        var tryNext = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$().asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0(($m_Ljapgolly_scalajs_react_package$(), others), e$2);
        var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().orElse$extension__F0__F0__F0(this$$1, tryNext);
        var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$11 = $m_s_$less$colon$less$();
        var $$x1 = $n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$11.s_$less$colon$less$__f_singleton)
      } else {
        var $$x1;
        throw new $c_s_MatchError(x0$1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$2, f))
  }))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.onMount__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(p) {
  var this$5 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend__f_$);
  var this$1 = $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items);
  var this$2 = $n($n($as_sc_IterableOps((this$1.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$1.get__O()))).headOption__s_Option());
  if (this$2.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var x$6 = $as_T2(arg1);
    var self = $n(x$6)._1__O();
    var $$x1 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, 0))
  };
  var newState = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState($$x1);
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$5, newState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.onPropsChange__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(prev, p) {
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$7 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$7$2) => {
    $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState(x$7$2);
    var this$2 = $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items);
    var this$3 = $n($n($as_sc_IterableOps((this$2.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$2.get__O()))).headOption__s_Option());
    if (this$3.isEmpty__Z()) {
      var $$x1 = true
    } else {
      var arg1 = this$3.get__O();
      var x$8 = $as_T2(arg1);
      var $$x1 = ($n($as_Lcom_iz2use_common_TokenMatches($n(x$8)._2__O())).Lcom_iz2use_common_TokenMatches__f_score > 0.5)
    };
    var this$4 = $n(($$x1 ? this$3 : $m_s_None$()));
    if (this$4.isEmpty__Z()) {
      var $$x2 = $m_s_None$()
    } else {
      var arg1$1 = this$4.get__O();
      var x$9 = $as_T2(arg1$1);
      var self = $n(x$9)._1__O();
      var $$x2 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, 0))
    };
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState($$x2)
  }));
  var this$ = $n($$x3).when$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$7, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction0((() => {
    var this$8 = $n($n(prev).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items);
    var x = (this$8.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$8.get__O());
    var this$9 = $n($n(p).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items);
    var y = (this$9.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$9.get__O());
    return (!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))
  })));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend.prototype.com$iz2use$react$components$internal$suggestion$SuggestionListFocuser$TypedBackend$$updateCursor$1__I__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(count, p$2, s$2) {
  var this$1 = $n($n(p$2).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items);
  var x1 = ((!this$1.isEmpty__Z()) ? new $c_s_Some(this$1.get__O()) : $m_s_None$());
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var lst = $as_sci_Seq($n(x2).s_Some__f_value);
    var x1$2 = $n(s$2).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__f_selected;
    matchEnd6: {
      var next;
      if ((x1$2 instanceof $c_s_Some)) {
        var x2$2 = $as_s_Some(x1$2);
        var p3 = $as_T2($n(x2$2).s_Some__f_value);
        if ((p3 !== null)) {
          var idx = $n(p3)._2$mcI$sp__I();
          var end = $n(lst).length__I();
          var isEmpty = (end <= 0);
          var x = ((idx + count) | 0);
          if (((x !== end) && (!((x < 0) || (x > end))))) {
            var self = $n($as_T2($n(lst).apply__I__O(((idx + count) | 0))))._1__O();
            var y = ((idx + count) | 0);
            var next = new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, y));
            break matchEnd6
          }
        }
      };
      var idx$2 = ((count < 0) ? (($n(lst).length__I() + count) | 0) : (((-1) + count) | 0));
      var self$1 = $n($as_T2($n(lst).apply__I__O(idx$2)))._1__O();
      var next = new $c_s_Some($ct_T2__O__O__(new $c_T2(), self$1, idx$2))
    }
  } else {
    var next = $m_s_None$()
  };
  var this$11 = $n(next);
  if (this$11.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$11.get__O();
    var x$4 = $as_T2(arg1);
    var $$x1 = new $c_s_Some($n(x$4)._2$mcI$sp__I())
  };
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_scrollTo = $$x1;
  var this$13 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState(x$5$2);
    $n(x$5);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState(next)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$13, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedBackend"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedBackend;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$(outer) {
  this.Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$__f_attr = null;
  this.Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("--feature-state-color")
}
$c_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$.prototype.constructor = $c_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$;
/** @constructor */
function $h_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$.prototype = $c_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$.prototype;
$c_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$__f_attr
});
var $d_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$: 0
}, false, "com.iz2use.react.style.ExtendedStyles$featureStateColor$", {
  Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$.prototype.$classData = $d_Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$;
/** @constructor */
function $c_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$(outer) {
  this.Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$__f_attr = null;
  this.Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill")
}
$c_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$.prototype.constructor = $c_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$;
/** @constructor */
function $h_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$.prototype = $c_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$.prototype;
$c_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$__f_attr
});
var $d_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$: 0
}, false, "com.iz2use.react.style.ExtendedStyles$svgFillColor$", {
  Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$.prototype.$classData = $d_Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$;
/** @constructor */
function $c_Lcom_iz2use_react_style_ExtendedStyles$svgR$(outer) {
  this.Lcom_iz2use_react_style_ExtendedStyles$svgR$__f_attr = null;
  this.Lcom_iz2use_react_style_ExtendedStyles$svgR$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("r")
}
$c_Lcom_iz2use_react_style_ExtendedStyles$svgR$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lcom_iz2use_react_style_ExtendedStyles$svgR$.prototype.constructor = $c_Lcom_iz2use_react_style_ExtendedStyles$svgR$;
/** @constructor */
function $h_Lcom_iz2use_react_style_ExtendedStyles$svgR$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_ExtendedStyles$svgR$.prototype = $c_Lcom_iz2use_react_style_ExtendedStyles$svgR$.prototype;
$c_Lcom_iz2use_react_style_ExtendedStyles$svgR$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lcom_iz2use_react_style_ExtendedStyles$svgR$__f_attr
});
var $d_Lcom_iz2use_react_style_ExtendedStyles$svgR$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_ExtendedStyles$svgR$: 0
}, false, "com.iz2use.react.style.ExtendedStyles$svgR$", {
  Lcom_iz2use_react_style_ExtendedStyles$svgR$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lcom_iz2use_react_style_ExtendedStyles$svgR$.prototype.$classData = $d_Lcom_iz2use_react_style_ExtendedStyles$svgR$;
/** @constructor */
function $c_Lcom_iz2use_react_style_ExtendedStyles$zoom$(outer) {
  this.Lcom_iz2use_react_style_ExtendedStyles$zoom$__f_attr = null;
  this.Lcom_iz2use_react_style_ExtendedStyles$zoom$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("zoom")
}
$c_Lcom_iz2use_react_style_ExtendedStyles$zoom$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lcom_iz2use_react_style_ExtendedStyles$zoom$.prototype.constructor = $c_Lcom_iz2use_react_style_ExtendedStyles$zoom$;
/** @constructor */
function $h_Lcom_iz2use_react_style_ExtendedStyles$zoom$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_ExtendedStyles$zoom$.prototype = $c_Lcom_iz2use_react_style_ExtendedStyles$zoom$.prototype;
$c_Lcom_iz2use_react_style_ExtendedStyles$zoom$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lcom_iz2use_react_style_ExtendedStyles$zoom$__f_attr
});
var $d_Lcom_iz2use_react_style_ExtendedStyles$zoom$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_ExtendedStyles$zoom$: 0
}, false, "com.iz2use.react.style.ExtendedStyles$zoom$", {
  Lcom_iz2use_react_style_ExtendedStyles$zoom$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lcom_iz2use_react_style_ExtendedStyles$zoom$.prototype.$classData = $d_Lcom_iz2use_react_style_ExtendedStyles$zoom$;
function $f_Lcom_iz2use_react_style_MyDev__cssStringRenderer__Lscalacss_internal_Renderer($thiz) {
  return new $c_Lscalacss_internal_StringRenderer$Raw($m_Lscalacss_internal_StringRenderer$().formatPretty__T__T__F1("  ", " "))
}
function $f_Ldiode_BaseModelR__value__O($thiz) {
  return $thiz.eval__O__O($n($thiz.root__Ldiode_ModelR()).value__O())
}
function $f_Ldiode_BaseModelR__zoom__F1__Ldiode_FastEq__Ldiode_ZoomModelR($thiz, get, feq) {
  return $ct_Ldiode_ZoomModelR__Ldiode_ModelR__F1__Ldiode_FastEq__(new $c_Ldiode_ZoomModelR(), $thiz.root__Ldiode_ModelR(), $n(get).compose__F1__F1(new $c_sjsr_AnonFunction1(((model$2) => $thiz.eval__O__O(model$2)))), feq)
}
function $p_Ldiode_Circuit__buildProcessChain__F1($thiz) {
  var this$2 = $n($n($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$processors).reverse__sci_List());
  var z = new $c_sjsr_AnonFunction1(((action$2) => $p_Ldiode_Circuit__process__O__Ldiode_ActionResult($thiz, action$2)));
  var acc = z;
  var these = this$2;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = acc;
    var arg2 = $n(these).head__O();
    var next = $as_F1(arg1);
    var processor = $as_Ldiode_ActionProcessor(arg2);
    acc = new $c_sjsr_AnonFunction1(((processor, next) => ((action$2$1) => $n(processor).process__Ldiode_Dispatcher__O__F1__O__Ldiode_ActionResult($thiz, action$2$1, next, $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_model)))(processor, next));
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return $as_F1(acc)
}
function $p_Ldiode_Circuit__baseHandler__O__Ldiode_ActionResult$NoChange$($thiz, action) {
  if (false) {
    var x2 = $as_Ldiode_ActionBatch(action);
    $n($n(x2).actions__sci_Seq()).foreach__F1__V(new $c_sjsr_AnonFunction1(((a$2) => $f_Ldiode_Circuit__dispatchBase__O__Z($thiz, a$2))));
    return $m_Ldiode_ActionResult$NoChange$()
  } else {
    var x = $m_Ldiode_NoAction$();
    if ((x === action)) {
      return $m_Ldiode_ActionResult$NoChange$()
    } else {
      var msg = (("Action " + action) + " was not handled by any action handler");
      $f_Ldiode_Circuit__handleError__T__V($thiz, msg);
      return $m_Ldiode_ActionResult$NoChange$()
    }
  }
}
function $f_Ldiode_Circuit__subscribe__Ldiode_ModelR__F1__F0($thiz, cursor, listener) {
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listenerId = ((1 + $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listenerId) | 0);
  var id = $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listenerId;
  var $$x1 = $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners;
  var y = new $c_Ldiode_Circuit$Subscription($thiz, listener, cursor, $n(cursor).eval__O__O($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_model));
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners = $as_sci_Map($n($$x1).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), id, y)));
  return new $c_sjsr_AnonFunction0((() => {
    var this$4 = $n($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners);
    $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners = $as_sci_Map(this$4.removed__O__sci_MapOps(id))
  }))
}
function $f_Ldiode_Circuit__handleFatal__O__jl_Throwable__V($thiz, action, e) {
  throw ((e instanceof $c_sjs_js_JavaScriptException) ? e.sjs_js_JavaScriptException__f_exception : $n(e))
}
function $f_Ldiode_Circuit__handleError__T__V($thiz, msg) {
  var th = $ct_jl_Exception__T__(new $c_jl_Exception(), ("handleError called with: " + msg));
  throw th
}
function $f_Ldiode_Circuit__handleEffectProcessingError__O__jl_Throwable__V($thiz, action, error) {
  var msg = ((("Error in processing effects for action " + action) + ": ") + error);
  $f_Ldiode_Circuit__handleError__T__V($thiz, msg)
}
function $p_Ldiode_Circuit__update__O__V($thiz, newModel) {
  if ((newModel !== $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_model)) {
    $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_model = $as_Lreactbuild_analyze_cost_services_RootModel(newModel)
  }
}
function $p_Ldiode_Circuit__process__O__Ldiode_ActionResult($thiz, action) {
  var this$1 = $n($as_s_Option($n($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_actionHandler).apply__O__O__O($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_model, action)));
  return $as_Ldiode_ActionResult((this$1.isEmpty__Z() ? $p_Ldiode_Circuit__baseHandler__O__Ldiode_ActionResult$NoChange$($thiz, action) : this$1.get__O()))
}
function $f_Ldiode_Circuit__foldHandlers__sci_Seq__F2($thiz, handlers) {
  return new $c_sjsr_AnonFunction2(((initialModel$2, action$2) => $as_s_Option($n($as_T2($n(handlers).foldLeft__O__F2__O($ct_T2__O__O__(new $c_T2(), initialModel$2, $m_s_None$()), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    var x1$1 = $as_F2(x1$1$2);
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
    var p2 = $as_T2(x1.T2__f__1);
    var handler = $as_F2(x1.T2__f__2);
    if ((p2 !== null)) {
      var currentModel = $n(p2)._1__O();
      var currentResult = $as_s_Option($n(p2)._2__O());
      var x1$2 = $as_s_Option($n(handler).apply__O__O__O(currentModel, action$2));
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return $ct_T2__O__O__(new $c_T2(), currentModel, currentResult)
      } else if ((x1$2 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x1$2);
        var result = $as_Ldiode_ActionResult($n(x3).s_Some__f_value);
        if ((currentResult instanceof $c_s_Some)) {
          var x2 = $as_s_Some(currentResult);
          var cr = $as_Ldiode_ActionResult($n(x2).s_Some__f_value);
          var x1$4 = $ct_T2__O__O__(new $c_T2(), $n(cr).effectOpt__s_Option(), $n(result).effectOpt__s_Option());
          matchEnd19: {
            var newEffect;
            var p2$2 = $as_s_Option(x1$4.T2__f__1);
            var p3 = $as_s_Option(x1$4.T2__f__2);
            if ((p2$2 instanceof $c_s_Some)) {
              var x4 = $as_s_Some(p2$2);
              var e1 = $as_Ldiode_Effect($n(x4).s_Some__f_value);
              if ((p3 instanceof $c_s_Some)) {
                var x5 = $as_s_Some(p3);
                var e2 = $as_Ldiode_Effect($n(x5).s_Some__f_value);
                var newEffect = new $c_s_Some($n(e1).$plus__Ldiode_Effect__Ldiode_EffectSet(e2));
                break matchEnd19
              }
            };
            var p6 = $as_s_Option(x1$4.T2__f__1);
            var p7 = $as_s_Option(x1$4.T2__f__2);
            if ((p6 instanceof $c_s_Some)) {
              var x8 = $as_s_Some(p6);
              var e1$2 = $as_Ldiode_Effect($n(x8).s_Some__f_value);
              var x$3 = $m_s_None$();
              if ((x$3 === p7)) {
                var newEffect = new $c_s_Some(e1$2);
                break matchEnd19
              }
            };
            var p10 = $as_s_Option(x1$4.T2__f__1);
            var p11 = $as_s_Option(x1$4.T2__f__2);
            var x$5 = $m_s_None$();
            if (((x$5 === p10) && (p11 instanceof $c_s_Some))) {
              var x12 = $as_s_Some(p11);
              var e2$2 = $as_Ldiode_Effect($n(x12).s_Some__f_value);
              var newEffect = new $c_s_Some(e2$2);
              break matchEnd19
            };
            var p14 = $as_s_Option(x1$4.T2__f__1);
            var p15 = $as_s_Option(x1$4.T2__f__2);
            var x$7 = $m_s_None$();
            if ((x$7 === p14)) {
              var x$9 = $m_s_None$();
              var $$x1 = (x$9 === p15)
            } else {
              var $$x1 = false
            };
            if ($$x1) {
              var newEffect = $m_s_None$();
              break matchEnd19
            };
            throw new $c_s_MatchError(x1$4)
          };
          var this$3 = $n($n(result).newModelOpt__s_Option());
          var newModel = (this$3.isEmpty__Z() ? $n(cr).newModelOpt__s_Option() : this$3);
          var this$4 = $n(newModel);
          var _1 = (this$4.isEmpty__Z() ? currentModel : this$4.get__O());
          var _2 = $m_Ldiode_ActionResult$().apply__s_Option__s_Option__Ldiode_ActionResult(newModel, newEffect);
          var x1$5___1 = _1;
          var x1$5___2 = _2
        } else {
          var x$11 = $m_s_None$();
          if ((!(x$11 === currentResult))) {
            throw new $c_s_MatchError(currentResult)
          };
          var this$5 = $n($n(result).newModelOpt__s_Option());
          var _1$1 = (this$5.isEmpty__Z() ? currentModel : this$5.get__O());
          var x1$5___1 = _1$1;
          var x1$5___2 = result
        };
        var nextModel = x1$5___1;
        var nextResult = $as_Ldiode_ActionResult(x1$5___2);
        return $ct_T2__O__O__(new $c_T2(), nextModel, new $c_s_Some(nextResult))
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    };
    throw new $c_s_MatchError(x1)
  })))))._2__O())))
}
function $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V($thiz, action, evidence$6) {
  if ((!$thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$isDispatching)) {
    $p_Ldiode_Circuit__liftedTree1$1__O__V($thiz, action);
    var this$1 = $n($n($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$dispatchQueue).dequeueOption__s_Option());
    if ((!this$1.isEmpty__Z())) {
      var arg1 = this$1.get__O();
      var x0$3 = $as_T2(arg1);
      if ((x0$3 !== null)) {
        var nextAction = $n(x0$3)._1__O();
        var queue = $as_sci_Queue($n(x0$3)._2__O());
        $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$dispatchQueue = queue;
        $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V($thiz, nextAction, null)
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }
  } else {
    $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$dispatchQueue = $n($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$dispatchQueue).enqueue__O__sci_Queue(action)
  }
}
function $f_Ldiode_Circuit__dispatchBase__O__Z($thiz, action) {
  try {
    var x1 = $as_Ldiode_ActionResult($n($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$processChain).apply__O__O(action));
    var x = $m_Ldiode_ActionResult$NoChange$();
    if ((!(x === x1))) {
      if ((x1 instanceof $c_Ldiode_ActionResult$ModelUpdate)) {
        var x3 = $as_Ldiode_ActionResult$ModelUpdate(x1);
        var newModel = $n(x3).Ldiode_ActionResult$ModelUpdate__f_newModel;
        $p_Ldiode_Circuit__update__O__V($thiz, newModel);
        return false
      } else if (false) {
        var x4 = $as_Ldiode_ActionResult$ModelUpdateSilent(x1);
        var newModel$2 = $n(x4).newModel__O();
        $p_Ldiode_Circuit__update__O__V($thiz, newModel$2);
        return true
      } else if ((x1 instanceof $c_Ldiode_ActionResult$EffectOnly)) {
        var x5 = $as_Ldiode_ActionResult$EffectOnly(x1);
        var effects = $n(x5).Ldiode_ActionResult$EffectOnly__f_effect;
        $n($n(effects).run__F1__s_concurrent_Future(new $c_sjsr_AnonFunction1(((a$2) => {
          var evidence$6 = $m_Ldiode_package$AnyAction$aType$();
          $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V($thiz, a$2, evidence$6)
        })))).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Ldiode_Circuit$$anonfun$dispatchBase$2($thiz, action), $n(effects).Ldiode_EffectBase__f_ec);
        return true
      } else if ((x1 instanceof $c_Ldiode_ActionResult$ModelUpdateEffect)) {
        var x6 = $as_Ldiode_ActionResult$ModelUpdateEffect(x1);
        var newModel$3 = $n(x6).Ldiode_ActionResult$ModelUpdateEffect__f_newModel;
        var effects$2 = $n(x6).Ldiode_ActionResult$ModelUpdateEffect__f_effect;
        $p_Ldiode_Circuit__update__O__V($thiz, newModel$3);
        $n($n(effects$2).run__F1__s_concurrent_Future(new $c_sjsr_AnonFunction1(((a$3$2) => {
          var evidence$6$1 = $m_Ldiode_package$AnyAction$aType$();
          $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V($thiz, a$3$2, evidence$6$1)
        })))).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Ldiode_Circuit$$anonfun$dispatchBase$4($thiz, action), $n(effects$2).Ldiode_EffectBase__f_ec);
        return false
      } else if (false) {
        var x7 = $as_Ldiode_ActionResult$ModelUpdateSilentEffect(x1);
        var newModel$4 = $n(x7).newModel__O();
        var effects$3 = $n(x7).effect__Ldiode_Effect();
        $p_Ldiode_Circuit__update__O__V($thiz, newModel$4);
        $n($n(effects$3).run__F1__s_concurrent_Future(new $c_sjsr_AnonFunction1(((a$4$2) => {
          var evidence$6$2 = $m_Ldiode_package$AnyAction$aType$();
          $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V($thiz, a$4$2, evidence$6$2)
        })))).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Ldiode_Circuit$$anonfun$dispatchBase$6($thiz, action), $n(effects$3).Ldiode_EffectBase__f_ec);
        return true
      } else {
        throw new $c_s_MatchError(x1)
      }
    } else {
      return false
    }
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    $f_Ldiode_Circuit__handleFatal__O__jl_Throwable__V($thiz, action, e$2);
    return true
  }
}
function $p_Ldiode_Circuit__liftedTree1$1__O__V($thiz, action$4) {
  try {
    $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$isDispatching = true;
    var oldModel = $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_model;
    var silent = $f_Ldiode_Circuit__dispatchBase__O__Z($thiz, action$4);
    if ((oldModel !== $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_model)) {
      var this$4 = $n($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners);
      var z = $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners;
      var f = ((x0$1$2, x1$1$2) => {
        var x0$1 = $as_sci_Map(x0$1$2);
        var x1$1 = $as_T2(x1$1$2);
        var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
        var l = $as_sci_Map(x1.T2__f__1);
        var p2 = $as_T2(x1.T2__f__2);
        if ((p2 !== null)) {
          var key = $n(p2)._1$mcI$sp__I();
          var sub = $as_Ldiode_Circuit$Subscription($n(p2)._2__O());
          var this$2 = $n($thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners);
          if (this$2.contains__O__Z(key)) {
            var x1$2 = $n(sub).changed__s_Option();
            if ((x1$2 instanceof $c_s_Some)) {
              var x2 = $as_s_Some(x1$2);
              var newSub = $as_Ldiode_Circuit$Subscription($n(x2).s_Some__f_value);
              if ((!silent)) {
                var this$3 = $n(sub);
                $n(this$3.Ldiode_Circuit$Subscription__f_listener).apply__O__O(this$3.Ldiode_Circuit$Subscription__f_cursor)
              };
              return $as_sci_Map($n(l).updated__O__O__sci_MapOps(key, newSub))
            } else {
              var x = $m_s_None$();
              if ((x === x1$2)) {
                return l
              } else {
                throw new $c_s_MatchError(x1$2)
              }
            }
          } else {
            return l
          }
        };
        throw new $c_s_MatchError(x1)
      });
      if ($is_sc_IndexedSeq(this$4)) {
        var x2$1 = $as_sc_IndexedSeq(this$4);
        var at = 0;
        var end = $n(x2$1).length__I();
        var acc = z;
        var $$x1;
        while (true) {
          if ((at !== end)) {
            var temp$at = ((1 + at) | 0);
            var arg1 = acc;
            var arg2 = $n(x2$1).apply__I__O(at);
            var temp$acc = f(arg1, arg2);
            at = temp$at;
            acc = temp$acc;
            continue
          };
          var $$x1 = acc;
          break
        }
      } else {
        var result = z;
        var it = this$4.iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var arg1$1 = result;
          var arg2$1 = $n(it).next__O();
          result = f(arg1$1, arg2$1)
        };
        var $$x1 = result
      };
      var updated = $as_sci_Map($$x1);
      var this$6 = $n(updated);
      var z$1 = $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners;
      var f$1 = ((x0$2$2, x1$2$2) => {
        var x0$2 = $as_sci_Map(x0$2$2);
        var x1$2$1 = $as_T2(x1$2$2);
        var x1$3 = $ct_T2__O__O__(new $c_T2(), x0$2, x1$2$1);
        var l$1 = $as_sci_Map(x1$3.T2__f__1);
        var p2$1 = $as_T2(x1$3.T2__f__2);
        if ((p2$1 !== null)) {
          var key$1 = $n(p2$1)._1$mcI$sp__I();
          var sub$1 = $as_Ldiode_Circuit$Subscription($n(p2$1)._2__O());
          var this$5 = $n(l$1);
          if (this$5.contains__O__Z(key$1)) {
            return $as_sci_Map($n(l$1).updated__O__O__sci_MapOps(key$1, sub$1))
          } else {
            return l$1
          }
        };
        throw new $c_s_MatchError(x1$3)
      });
      if ($is_sc_IndexedSeq(this$6)) {
        var x2$2 = $as_sc_IndexedSeq(this$6);
        var at$1 = 0;
        var end$1 = $n(x2$2).length__I();
        var acc$1 = z$1;
        var $$x2;
        while (true) {
          if ((at$1 !== end$1)) {
            var temp$at$1 = ((1 + at$1) | 0);
            var arg1$2 = acc$1;
            var arg2$2 = $n(x2$2).apply__I__O(at$1);
            var temp$acc$1 = f$1(arg1$2, arg2$2);
            at$1 = temp$at$1;
            acc$1 = temp$acc$1;
            continue
          };
          var $$x2 = acc$1;
          break
        }
      } else {
        var result$1 = z$1;
        var it$1 = this$6.iterator__sc_Iterator();
        while ($n(it$1).hasNext__Z()) {
          var arg1$3 = result$1;
          var arg2$3 = $n(it$1).next__O();
          result$1 = f$1(arg1$3, arg2$3)
        };
        var $$x2 = result$1
      };
      $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners = $as_sci_Map($$x2)
    }
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    $f_Ldiode_Circuit__handleFatal__O__jl_Throwable__V($thiz, action$4, e$2)
  } finally {
    $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$isDispatching = false
  }
}
function $f_Ldiode_Circuit__$init$__V($thiz) {
  var x$1 = $thiz.initialModel__Lreactbuild_analyze_cost_services_RootModel();
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_model = x$1;
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$modelRW = new $c_Ldiode_RootModelRW(new $c_sjsr_AnonFunction0((() => $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_model)));
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$isDispatching = false;
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$dispatchQueue = $m_sci_Queue$EmptyQueue$();
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listenerId = 0;
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners = ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$());
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$processors = ($n($m_s_package$().s_package$__f_List), $m_sci_Nil$());
  $thiz.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$processChain = $p_Ldiode_Circuit__buildProcessChain__F1($thiz)
}
function $is_Ldiode_Circuit(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ldiode_Circuit)))
}
function $as_Ldiode_Circuit(obj) {
  return (($is_Ldiode_Circuit(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.Circuit"))
}
function $isArrayOf_Ldiode_Circuit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_Circuit)))
}
function $asArrayOf_Ldiode_Circuit(obj, depth) {
  return (($isArrayOf_Ldiode_Circuit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.Circuit;", depth))
}
function $p_Ldiode_EffectBase$$anon$1__executeWith__F1__s_concurrent_Future($thiz, f) {
  return $n($n($thiz.Ldiode_EffectBase$$anon$1__f_runner$1).runAfter__s_concurrent_duration_FiniteDuration__F0__s_concurrent_Future($thiz.Ldiode_EffectBase$$anon$1__f_delay$1, new $c_sjsr_AnonFunction0((() => (void 0))))).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_jl_Void(x$1$2);
    return $as_s_concurrent_Future($n(f).apply__O__O($thiz.Ldiode_EffectBase$$anon$1__f_$outer))
  })), $thiz.Ldiode_EffectBase__f_ec)
}
/** @constructor */
function $c_Ldiode_EffectBase$$anon$1(outer, runner$1, delay$1) {
  this.Ldiode_EffectBase__f_ec = null;
  this.Ldiode_EffectBase$$anon$1__f_$outer = null;
  this.Ldiode_EffectBase$$anon$1__f_runner$1 = null;
  this.Ldiode_EffectBase$$anon$1__f_delay$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ldiode_EffectBase$$anon$1__f_$outer = outer
  };
  this.Ldiode_EffectBase$$anon$1__f_runner$1 = runner$1;
  this.Ldiode_EffectBase$$anon$1__f_delay$1 = delay$1;
  $ct_Ldiode_EffectBase__s_concurrent_ExecutionContext__(this, $n(outer).Ldiode_EffectBase__f_ec)
}
$c_Ldiode_EffectBase$$anon$1.prototype = new $h_Ldiode_EffectBase();
$c_Ldiode_EffectBase$$anon$1.prototype.constructor = $c_Ldiode_EffectBase$$anon$1;
/** @constructor */
function $h_Ldiode_EffectBase$$anon$1() {
  /*<skip>*/
}
$h_Ldiode_EffectBase$$anon$1.prototype = $c_Ldiode_EffectBase$$anon$1.prototype;
$c_Ldiode_EffectBase$$anon$1.prototype.run__F1__s_concurrent_Future = (function(dispatch) {
  return $p_Ldiode_EffectBase$$anon$1__executeWith__F1__s_concurrent_Future(this, new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Ldiode_Effect(x$2$2);
    return $n(x$2).run__F1__s_concurrent_Future(dispatch)
  })))
});
var $d_Ldiode_EffectBase$$anon$1 = new $TypeData().initClass({
  Ldiode_EffectBase$$anon$1: 0
}, false, "diode.EffectBase$$anon$1", {
  Ldiode_EffectBase$$anon$1: 1,
  Ldiode_EffectBase: 1,
  O: 1,
  Ldiode_Effect: 1
});
$c_Ldiode_EffectBase$$anon$1.prototype.$classData = $d_Ldiode_EffectBase$$anon$1;
/** @constructor */
function $c_Ldiode_EffectSingle(f, ec) {
  this.Ldiode_EffectBase__f_ec = null;
  this.Ldiode_EffectSingle__f_f = null;
  this.Ldiode_EffectSingle__f_f = f;
  $ct_Ldiode_EffectBase__s_concurrent_ExecutionContext__(this, ec)
}
$c_Ldiode_EffectSingle.prototype = new $h_Ldiode_EffectBase();
$c_Ldiode_EffectSingle.prototype.constructor = $c_Ldiode_EffectSingle;
/** @constructor */
function $h_Ldiode_EffectSingle() {
  /*<skip>*/
}
$h_Ldiode_EffectSingle.prototype = $c_Ldiode_EffectSingle.prototype;
$c_Ldiode_EffectSingle.prototype.run__F1__s_concurrent_Future = (function(dispatch) {
  return $n($as_s_concurrent_Future($n(this.Ldiode_EffectSingle__f_f).apply__O())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(dispatch, this.Ldiode_EffectBase__f_ec)
});
var $d_Ldiode_EffectSingle = new $TypeData().initClass({
  Ldiode_EffectSingle: 0
}, false, "diode.EffectSingle", {
  Ldiode_EffectSingle: 1,
  Ldiode_EffectBase: 1,
  O: 1,
  Ldiode_Effect: 1
});
$c_Ldiode_EffectSingle.prototype.$classData = $d_Ldiode_EffectSingle;
/** @constructor */
function $c_Ldiode_Implicits$runAfterImpl$() {
  /*<skip>*/
}
$c_Ldiode_Implicits$runAfterImpl$.prototype = new $h_Ldiode_util_RunAfterJS();
$c_Ldiode_Implicits$runAfterImpl$.prototype.constructor = $c_Ldiode_Implicits$runAfterImpl$;
/** @constructor */
function $h_Ldiode_Implicits$runAfterImpl$() {
  /*<skip>*/
}
$h_Ldiode_Implicits$runAfterImpl$.prototype = $c_Ldiode_Implicits$runAfterImpl$.prototype;
var $d_Ldiode_Implicits$runAfterImpl$ = new $TypeData().initClass({
  Ldiode_Implicits$runAfterImpl$: 0
}, false, "diode.Implicits$runAfterImpl$", {
  Ldiode_Implicits$runAfterImpl$: 1,
  Ldiode_util_RunAfterJS: 1,
  O: 1,
  Ldiode_util_RunAfter: 1
});
$c_Ldiode_Implicits$runAfterImpl$.prototype.$classData = $d_Ldiode_Implicits$runAfterImpl$;
var $n_Ldiode_Implicits$runAfterImpl$;
function $m_Ldiode_Implicits$runAfterImpl$() {
  if ((!$n_Ldiode_Implicits$runAfterImpl$)) {
    $n_Ldiode_Implicits$runAfterImpl$ = new $c_Ldiode_Implicits$runAfterImpl$()
  };
  return $n_Ldiode_Implicits$runAfterImpl$
}
/** @constructor */
function $c_Leu_timepit_refined_api_RefType$$anon$1() {
  /*<skip>*/
}
$c_Leu_timepit_refined_api_RefType$$anon$1.prototype = new $h_O();
$c_Leu_timepit_refined_api_RefType$$anon$1.prototype.constructor = $c_Leu_timepit_refined_api_RefType$$anon$1;
/** @constructor */
function $h_Leu_timepit_refined_api_RefType$$anon$1() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_RefType$$anon$1.prototype = $c_Leu_timepit_refined_api_RefType$$anon$1.prototype;
$c_Leu_timepit_refined_api_RefType$$anon$1.prototype.unwrap__O__O = (function(tp) {
  var tp$1 = $n($as_Leu_timepit_refined_api_Refined(tp)).Leu_timepit_refined_api_Refined__f_value;
  return tp$1
});
$c_Leu_timepit_refined_api_RefType$$anon$1.prototype.unsafeWrap__O__O = (function(t) {
  return new $c_Leu_timepit_refined_api_Refined(t)
});
var $d_Leu_timepit_refined_api_RefType$$anon$1 = new $TypeData().initClass({
  Leu_timepit_refined_api_RefType$$anon$1: 0
}, false, "eu.timepit.refined.api.RefType$$anon$1", {
  Leu_timepit_refined_api_RefType$$anon$1: 1,
  O: 1,
  Leu_timepit_refined_api_RefType: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_RefType$$anon$1.prototype.$classData = $d_Leu_timepit_refined_api_RefType$$anon$1;
/** @constructor */
function $c_Leu_timepit_refined_api_RefType$$anon$2() {
  /*<skip>*/
}
$c_Leu_timepit_refined_api_RefType$$anon$2.prototype = new $h_O();
$c_Leu_timepit_refined_api_RefType$$anon$2.prototype.constructor = $c_Leu_timepit_refined_api_RefType$$anon$2;
/** @constructor */
function $h_Leu_timepit_refined_api_RefType$$anon$2() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_RefType$$anon$2.prototype = $c_Leu_timepit_refined_api_RefType$$anon$2.prototype;
$c_Leu_timepit_refined_api_RefType$$anon$2.prototype.unsafeWrap__O__O = (function(t) {
  return t
});
$c_Leu_timepit_refined_api_RefType$$anon$2.prototype.unwrap__O__O = (function(tp) {
  return tp
});
var $d_Leu_timepit_refined_api_RefType$$anon$2 = new $TypeData().initClass({
  Leu_timepit_refined_api_RefType$$anon$2: 0
}, false, "eu.timepit.refined.api.RefType$$anon$2", {
  Leu_timepit_refined_api_RefType$$anon$2: 1,
  O: 1,
  Leu_timepit_refined_api_RefType: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_RefType$$anon$2.prototype.$classData = $d_Leu_timepit_refined_api_RefType$$anon$2;
/** @constructor */
function $c_Leu_timepit_refined_api_Validate$$anon$3(f$3, p$1, g$2) {
  this.Leu_timepit_refined_api_Validate$$anon$3__f_f$3 = null;
  this.Leu_timepit_refined_api_Validate$$anon$3__f_p$1 = null;
  this.Leu_timepit_refined_api_Validate$$anon$3__f_g$2 = null;
  this.Leu_timepit_refined_api_Validate$$anon$3__f_f$3 = f$3;
  this.Leu_timepit_refined_api_Validate$$anon$3__f_p$1 = p$1;
  this.Leu_timepit_refined_api_Validate$$anon$3__f_g$2 = g$2
}
$c_Leu_timepit_refined_api_Validate$$anon$3.prototype = new $h_O();
$c_Leu_timepit_refined_api_Validate$$anon$3.prototype.constructor = $c_Leu_timepit_refined_api_Validate$$anon$3;
/** @constructor */
function $h_Leu_timepit_refined_api_Validate$$anon$3() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_Validate$$anon$3.prototype = $c_Leu_timepit_refined_api_Validate$$anon$3.prototype;
$c_Leu_timepit_refined_api_Validate$$anon$3.prototype.showResult__O__Leu_timepit_refined_api_Result__T = (function(t, r) {
  return $f_Leu_timepit_refined_api_Validate__showResult__O__Leu_timepit_refined_api_Result__T(this, t, r)
});
$c_Leu_timepit_refined_api_Validate$$anon$3.prototype.validate__O__Leu_timepit_refined_api_Result = (function(t) {
  return $m_Leu_timepit_refined_api_Result$().fromBoolean__Z__O__Leu_timepit_refined_api_Result($uZ($n(this.Leu_timepit_refined_api_Validate$$anon$3__f_f$3).apply__O__O(t)), this.Leu_timepit_refined_api_Validate$$anon$3__f_p$1)
});
$c_Leu_timepit_refined_api_Validate$$anon$3.prototype.showExpr__O__T = (function(t) {
  return $as_T($n(this.Leu_timepit_refined_api_Validate$$anon$3__f_g$2).apply__O__O(t))
});
var $d_Leu_timepit_refined_api_Validate$$anon$3 = new $TypeData().initClass({
  Leu_timepit_refined_api_Validate$$anon$3: 0
}, false, "eu.timepit.refined.api.Validate$$anon$3", {
  Leu_timepit_refined_api_Validate$$anon$3: 1,
  O: 1,
  Leu_timepit_refined_api_Validate: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_Validate$$anon$3.prototype.$classData = $d_Leu_timepit_refined_api_Validate$$anon$3;
/** @constructor */
function $c_Leu_timepit_refined_boolean$Not$$anon$1(v$1) {
  this.Leu_timepit_refined_boolean$Not$$anon$1__f_v$1 = null;
  this.Leu_timepit_refined_boolean$Not$$anon$1__f_v$1 = v$1
}
$c_Leu_timepit_refined_boolean$Not$$anon$1.prototype = new $h_O();
$c_Leu_timepit_refined_boolean$Not$$anon$1.prototype.constructor = $c_Leu_timepit_refined_boolean$Not$$anon$1;
/** @constructor */
function $h_Leu_timepit_refined_boolean$Not$$anon$1() {
  /*<skip>*/
}
$h_Leu_timepit_refined_boolean$Not$$anon$1.prototype = $c_Leu_timepit_refined_boolean$Not$$anon$1.prototype;
$c_Leu_timepit_refined_boolean$Not$$anon$1.prototype.validate__O__Leu_timepit_refined_api_Result = (function(t) {
  var r = $n(this.Leu_timepit_refined_boolean$Not$$anon$1__f_v$1).validate__O__Leu_timepit_refined_api_Result(t);
  return $m_Leu_timepit_refined_api_Result$().fromBoolean__Z__O__Leu_timepit_refined_api_Result($n(r).isFailed__Z(), new $c_Leu_timepit_refined_boolean$Not(r))
});
$c_Leu_timepit_refined_boolean$Not$$anon$1.prototype.showExpr__O__T = (function(t) {
  return ("!" + $n(this.Leu_timepit_refined_boolean$Not$$anon$1__f_v$1).showExpr__O__T(t))
});
$c_Leu_timepit_refined_boolean$Not$$anon$1.prototype.showResult__O__Leu_timepit_refined_api_Result__T = (function(t, r) {
  var expr = $n(this.Leu_timepit_refined_boolean$Not$$anon$1__f_v$1).showExpr__O__T(t);
  var rp = $as_Leu_timepit_refined_api_Result($n($as_Leu_timepit_refined_boolean$Not($n(r).detail__O())).Leu_timepit_refined_boolean$Not__f_p);
  if ((rp instanceof $c_Leu_timepit_refined_api_Passed)) {
    return $m_Leu_timepit_refined_internal_Resources$().showResultNotInnerPassed__T__T(expr)
  } else if ((rp instanceof $c_Leu_timepit_refined_api_Failed)) {
    return $m_Leu_timepit_refined_internal_Resources$().showResultNotInnerFailed__T__T(expr)
  } else {
    throw new $c_s_MatchError(rp)
  }
});
var $d_Leu_timepit_refined_boolean$Not$$anon$1 = new $TypeData().initClass({
  Leu_timepit_refined_boolean$Not$$anon$1: 0
}, false, "eu.timepit.refined.boolean$Not$$anon$1", {
  Leu_timepit_refined_boolean$Not$$anon$1: 1,
  O: 1,
  Leu_timepit_refined_api_Validate: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_boolean$Not$$anon$1.prototype.$classData = $d_Leu_timepit_refined_boolean$Not$$anon$1;
/** @constructor */
function $c_Leu_timepit_refined_internal_WitnessAs$() {
  /*<skip>*/
}
$c_Leu_timepit_refined_internal_WitnessAs$.prototype = new $h_O();
$c_Leu_timepit_refined_internal_WitnessAs$.prototype.constructor = $c_Leu_timepit_refined_internal_WitnessAs$;
/** @constructor */
function $h_Leu_timepit_refined_internal_WitnessAs$() {
  /*<skip>*/
}
$h_Leu_timepit_refined_internal_WitnessAs$.prototype = $c_Leu_timepit_refined_internal_WitnessAs$.prototype;
$c_Leu_timepit_refined_internal_WitnessAs$.prototype.natWitnessAs__Lshapeless_Witness__Lshapeless_ops_nat$ToInt__s_math_Numeric__Leu_timepit_refined_internal_WitnessAs = (function(wa, ta, nb) {
  return new $c_Leu_timepit_refined_internal_WitnessAs($n(wa).value__O(), $n(nb).fromInt__I__O($n(ta).Lshapeless_ops_nat$ToInt$Inst__f_i))
});
var $d_Leu_timepit_refined_internal_WitnessAs$ = new $TypeData().initClass({
  Leu_timepit_refined_internal_WitnessAs$: 0
}, false, "eu.timepit.refined.internal.WitnessAs$", {
  Leu_timepit_refined_internal_WitnessAs$: 1,
  O: 1,
  Leu_timepit_refined_internal_WitnessAs1: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_internal_WitnessAs$.prototype.$classData = $d_Leu_timepit_refined_internal_WitnessAs$;
var $n_Leu_timepit_refined_internal_WitnessAs$;
function $m_Leu_timepit_refined_internal_WitnessAs$() {
  if ((!$n_Leu_timepit_refined_internal_WitnessAs$)) {
    $n_Leu_timepit_refined_internal_WitnessAs$ = new $c_Leu_timepit_refined_internal_WitnessAs$()
  };
  return $n_Leu_timepit_refined_internal_WitnessAs$
}
function $ct_Lio_circe_BiggerDecimalJsonNumber__T__($thiz, input) {
  $thiz.Lio_circe_BiggerDecimalJsonNumber__f_input = input;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_BiggerDecimalJsonNumber() {
  this.Lio_circe_BiggerDecimalJsonNumber__f_input = null
}
$c_Lio_circe_BiggerDecimalJsonNumber.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.constructor = $c_Lio_circe_BiggerDecimalJsonNumber;
/** @constructor */
function $h_Lio_circe_BiggerDecimalJsonNumber() {
  /*<skip>*/
}
$h_Lio_circe_BiggerDecimalJsonNumber.prototype = $c_Lio_circe_BiggerDecimalJsonNumber.prototype;
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toBigInt__s_Option = (function() {
  var this$1 = $n(this.Lio_circe_JsonBiggerDecimal__f_value);
  var this$2 = $n(this$1.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits));
  if (this$2.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var x$1 = $as_Ljava_math_BigInteger(arg1);
    return new $c_s_Some($n($m_s_package$().BigInt__s_math_BigInt$()).apply__Ljava_math_BigInteger__s_math_BigInt(x$1))
  }
});
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toBigDecimal__s_Option = (function() {
  var this$1 = $n($n(this.Lio_circe_JsonBiggerDecimal__f_value).toBigDecimal__s_Option());
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var value = $as_Ljava_math_BigDecimal(arg1);
    var yn = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
    if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(value, yn)) {
      var this$2 = $n($m_s_package$().BigDecimal__s_math_BigDecimal$());
      var bd = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
      var $$x1 = $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), bd, this$2.s_math_BigDecimal$__f_defaultMathContext)
    } else {
      try {
        var this$3 = $n($m_s_package$().BigDecimal__s_math_BigDecimal$());
        var x = this.Lio_circe_BiggerDecimalJsonNumber__f_input;
        var $$x1 = this$3.exact__T__s_math_BigDecimal(x)
      } catch (e) {
        if ((e instanceof $c_jl_NumberFormatException)) {
          var $$x1 = $m_s_math_BigDecimal$().javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal(value)
        } else {
          var $$x1;
          throw e
        }
      }
    };
    return new $c_s_Some($$x1)
  }
});
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toLong__s_Option = (function() {
  return $n(this.Lio_circe_JsonBiggerDecimal__f_value).toLong__s_Option()
});
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toString__T = (function() {
  return this.Lio_circe_BiggerDecimalJsonNumber__f_input
});
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var this$1 = $n(builder);
  var str = this.Lio_circe_BiggerDecimalJsonNumber__f_input;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
});
/** @constructor */
function $c_Lio_circe_Decoder$$anon$1(outer, f$1) {
  this.Lio_circe_Decoder$$anon$1__f_$outer = null;
  this.Lio_circe_Decoder$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_Decoder$$anon$1__f_$outer = outer
  };
  this.Lio_circe_Decoder$$anon$1__f_f$1 = f$1
}
$c_Lio_circe_Decoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$1.prototype.constructor = $c_Lio_circe_Decoder$$anon$1;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$1.prototype = $c_Lio_circe_Decoder$$anon$1.prototype;
$c_Lio_circe_Decoder$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c)
});
$c_Lio_circe_Decoder$$anon$1.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x1 = $n(this.Lio_circe_Decoder$$anon$1__f_$outer).tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var a = $n(x2).s_util_Right__f_value;
    $n($m_s_package$().s_package$__f_Right);
    var value = $n(this.Lio_circe_Decoder$$anon$1__f_f$1).apply__O__O(a);
    return new $c_s_util_Right(value)
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lio_circe_Decoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$1: 0
}, false, "io.circe.Decoder$$anon$1", {
  Lio_circe_Decoder$$anon$1: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$1.prototype.$classData = $d_Lio_circe_Decoder$$anon$1;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$16(f$7) {
  this.Lio_circe_Decoder$$anon$16__f_f$7 = null;
  this.Lio_circe_Decoder$$anon$16__f_f$7 = f$7
}
$c_Lio_circe_Decoder$$anon$16.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$16.prototype.constructor = $c_Lio_circe_Decoder$$anon$16;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$16() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$16.prototype = $c_Lio_circe_Decoder$$anon$16.prototype;
$c_Lio_circe_Decoder$$anon$16.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$16.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($n(this.Lio_circe_Decoder$$anon$16__f_f$7).apply__O__O(c))
});
var $d_Lio_circe_Decoder$$anon$16 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$16: 0
}, false, "io.circe.Decoder$$anon$16", {
  Lio_circe_Decoder$$anon$16: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$16.prototype.$classData = $d_Lio_circe_Decoder$$anon$16;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$2(outer, f$2) {
  this.Lio_circe_Decoder$$anon$2__f_$outer = null;
  this.Lio_circe_Decoder$$anon$2__f_f$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_Decoder$$anon$2__f_$outer = outer
  };
  this.Lio_circe_Decoder$$anon$2__f_f$2 = f$2
}
$c_Lio_circe_Decoder$$anon$2.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$2.prototype.constructor = $c_Lio_circe_Decoder$$anon$2;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$2.prototype = $c_Lio_circe_Decoder$$anon$2.prototype;
$c_Lio_circe_Decoder$$anon$2.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(this.Lio_circe_Decoder$$anon$2__f_$outer).apply__Lio_circe_HCursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var a = $n(x2).s_util_Right__f_value;
    return $n($as_Lio_circe_Decoder($n(this.Lio_circe_Decoder$$anon$2__f_f$2).apply__O__O(a))).apply__Lio_circe_HCursor__s_util_Either(c)
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lio_circe_Decoder$$anon$2.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x1 = $n(this.Lio_circe_Decoder$$anon$2__f_$outer).tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var a = $n(x2).s_util_Right__f_value;
    return $n($as_Lio_circe_Decoder($n(this.Lio_circe_Decoder$$anon$2__f_f$2).apply__O__O(a))).tryDecode__Lio_circe_ACursor__s_util_Either(c)
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lio_circe_Decoder$$anon$2 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$2: 0
}, false, "io.circe.Decoder$$anon$2", {
  Lio_circe_Decoder$$anon$2: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$2.prototype.$classData = $d_Lio_circe_Decoder$$anon$2;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$22() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$22.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$22.prototype.constructor = $c_Lio_circe_Decoder$$anon$22;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$22() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$22.prototype = $c_Lio_circe_Decoder$$anon$22.prototype;
$c_Lio_circe_Decoder$$anon$22.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$22.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  $n($m_s_package$().s_package$__f_Right);
  return new $c_s_util_Right(c)
});
var $d_Lio_circe_Decoder$$anon$22 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$22: 0
}, false, "io.circe.Decoder$$anon$22", {
  Lio_circe_Decoder$$anon$22: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$22.prototype.$classData = $d_Lio_circe_Decoder$$anon$22;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$23() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$23.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$23.prototype.constructor = $c_Lio_circe_Decoder$$anon$23;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$23() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$23.prototype = $c_Lio_circe_Decoder$$anon$23.prototype;
$c_Lio_circe_Decoder$$anon$23.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$23.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  $n($m_s_package$().s_package$__f_Right);
  var value = $n(c).value__Lio_circe_Json();
  return new $c_s_util_Right(value)
});
var $d_Lio_circe_Decoder$$anon$23 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$23: 0
}, false, "io.circe.Decoder$$anon$23", {
  Lio_circe_Decoder$$anon$23: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$23.prototype.$classData = $d_Lio_circe_Decoder$$anon$23;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$24() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$24.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$24.prototype.constructor = $c_Lio_circe_Decoder$$anon$24;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$24() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$24.prototype = $c_Lio_circe_Decoder$$anon$24.prototype;
$c_Lio_circe_Decoder$$anon$24.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$24.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n($n(c).value__Lio_circe_Json()).asObject__s_Option();
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $as_Lio_circe_JsonObject($n(x2).s_Some__f_value);
    $n($m_s_package$().s_package$__f_Right);
    return new $c_s_util_Right(v)
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      $n($m_s_package$().s_package$__f_Left);
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
      var value = new $c_Lio_circe_DecodingFailure$$anon$2("JsonObject", ops);
      return new $c_s_util_Left(value)
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
var $d_Lio_circe_Decoder$$anon$24 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$24: 0
}, false, "io.circe.Decoder$$anon$24", {
  Lio_circe_Decoder$$anon$24: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$24.prototype.$classData = $d_Lio_circe_Decoder$$anon$24;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$25() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$25.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$25.prototype.constructor = $c_Lio_circe_Decoder$$anon$25;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$25() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$25.prototype = $c_Lio_circe_Decoder$$anon$25.prototype;
$c_Lio_circe_Decoder$$anon$25.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$25.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n($n(c).value__Lio_circe_Json()).asNumber__s_Option();
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $as_Lio_circe_JsonNumber($n(x2).s_Some__f_value);
    $n($m_s_package$().s_package$__f_Right);
    return new $c_s_util_Right(v)
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      $n($m_s_package$().s_package$__f_Left);
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
      var value = new $c_Lio_circe_DecodingFailure$$anon$2("JsonNumber", ops);
      return new $c_s_util_Left(value)
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
var $d_Lio_circe_Decoder$$anon$25 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$25: 0
}, false, "io.circe.Decoder$$anon$25", {
  Lio_circe_Decoder$$anon$25: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$25.prototype.$classData = $d_Lio_circe_Decoder$$anon$25;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$26() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$26.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$26.prototype.constructor = $c_Lio_circe_Decoder$$anon$26;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$26() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$26.prototype = $c_Lio_circe_Decoder$$anon$26.prototype;
$c_Lio_circe_Decoder$$anon$26.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$26.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x2 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x2).Lio_circe_Json$JString__f_value;
    $n($m_s_package$().s_package$__f_Right);
    return new $c_s_util_Right(string)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value = new $c_Lio_circe_DecodingFailure$$anon$2("String", ops);
    return new $c_s_util_Left(value)
  }
});
var $d_Lio_circe_Decoder$$anon$26 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$26: 0
}, false, "io.circe.Decoder$$anon$26", {
  Lio_circe_Decoder$$anon$26: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$26.prototype.$classData = $d_Lio_circe_Decoder$$anon$26;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$27() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$27.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$27.prototype.constructor = $c_Lio_circe_Decoder$$anon$27;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$27() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$27.prototype = $c_Lio_circe_Decoder$$anon$27.prototype;
$c_Lio_circe_Decoder$$anon$27.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$27.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JObject)) {
    var x2 = $as_Lio_circe_Json$JObject(x1);
    var obj = $n(x2).Lio_circe_Json$JObject__f_value;
    if ($n(obj).isEmpty__Z()) {
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right((void 0))
    }
  };
  if ((x1 instanceof $c_Lio_circe_Json$JArray)) {
    var x3 = $as_Lio_circe_Json$JArray(x1);
    var arr = $n(x3).Lio_circe_Json$JArray__f_value;
    var this$2 = $n(arr);
    if ($f_sc_SeqOps__isEmpty__Z(this$2)) {
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right((void 0))
    }
  };
  if ($n(x1).isNull__Z()) {
    $n($m_s_package$().s_package$__f_Right);
    return new $c_s_util_Right((void 0))
  };
  $n($m_s_package$().s_package$__f_Left);
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
  var value = new $c_Lio_circe_DecodingFailure$$anon$2("Unit", ops);
  return new $c_s_util_Left(value)
});
var $d_Lio_circe_Decoder$$anon$27 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$27: 0
}, false, "io.circe.Decoder$$anon$27", {
  Lio_circe_Decoder$$anon$27: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$27.prototype.$classData = $d_Lio_circe_Decoder$$anon$27;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$28() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$28.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$28.prototype.constructor = $c_Lio_circe_Decoder$$anon$28;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$28() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$28.prototype = $c_Lio_circe_Decoder$$anon$28.prototype;
$c_Lio_circe_Decoder$$anon$28.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$28.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JBoolean)) {
    var x2 = $as_Lio_circe_Json$JBoolean(x1);
    var b = $n(x2).Lio_circe_Json$JBoolean__f_value;
    $n($m_s_package$().s_package$__f_Right);
    return new $c_s_util_Right(b)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value = new $c_Lio_circe_DecodingFailure$$anon$2("Boolean", ops);
    return new $c_s_util_Left(value)
  }
});
var $d_Lio_circe_Decoder$$anon$28 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$28: 0
}, false, "io.circe.Decoder$$anon$28", {
  Lio_circe_Decoder$$anon$28: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$28.prototype.$classData = $d_Lio_circe_Decoder$$anon$28;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$29() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$29.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$29.prototype.constructor = $c_Lio_circe_Decoder$$anon$29;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$29() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$29.prototype = $c_Lio_circe_Decoder$$anon$29.prototype;
$c_Lio_circe_Decoder$$anon$29.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$29.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x2 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x2).Lio_circe_Json$JString__f_value;
    var this$1 = $n(string);
    if ((this$1.length === 1)) {
      $n($m_s_package$().s_package$__f_Right);
      var this$2 = $n(string);
      var value = $charAt(this$2, 0);
      return new $c_s_util_Right($bC(value))
    }
  };
  $n($m_s_package$().s_package$__f_Left);
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
  var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("Char", ops);
  return new $c_s_util_Left(value$1)
});
var $d_Lio_circe_Decoder$$anon$29 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$29: 0
}, false, "io.circe.Decoder$$anon$29", {
  Lio_circe_Decoder$$anon$29: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$29.prototype.$classData = $d_Lio_circe_Decoder$$anon$29;
function $p_Lio_circe_Decoder$$anon$38__fail__Lio_circe_HCursor__s_util_Either($thiz, c) {
  $n($m_s_package$().s_package$__f_Left);
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
  var value = new $c_Lio_circe_DecodingFailure$$anon$2("UUID", ops);
  return new $c_s_util_Left(value)
}
/** @constructor */
function $c_Lio_circe_Decoder$$anon$38() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$38.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$38.prototype.constructor = $c_Lio_circe_Decoder$$anon$38;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$38() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$38.prototype = $c_Lio_circe_Decoder$$anon$38.prototype;
$c_Lio_circe_Decoder$$anon$38.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$38.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x2 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x2).Lio_circe_Json$JString__f_value;
    var this$1 = $n(string);
    if ((this$1.length === 36)) {
      try {
        $n($m_s_package$().s_package$__f_Right);
        var value = $m_ju_UUID$().fromString__T__ju_UUID(string);
        return new $c_s_util_Right(value)
      } catch (e) {
        if ((e instanceof $c_jl_IllegalArgumentException)) {
          return $p_Lio_circe_Decoder$$anon$38__fail__Lio_circe_HCursor__s_util_Either(this, c)
        } else {
          throw e
        }
      }
    }
  };
  return $p_Lio_circe_Decoder$$anon$38__fail__Lio_circe_HCursor__s_util_Either(this, c)
});
var $d_Lio_circe_Decoder$$anon$38 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$38: 0
}, false, "io.circe.Decoder$$anon$38", {
  Lio_circe_Decoder$$anon$38: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$38.prototype.$classData = $d_Lio_circe_Decoder$$anon$38;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$39(d$2) {
  this.Lio_circe_Decoder$$anon$39__f_d$2 = null;
  this.Lio_circe_Decoder$$anon$39__f_d$2 = d$2
}
$c_Lio_circe_Decoder$$anon$39.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$39.prototype.constructor = $c_Lio_circe_Decoder$$anon$39;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$39() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$39.prototype = $c_Lio_circe_Decoder$$anon$39.prototype;
$c_Lio_circe_Decoder$$anon$39.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c)
});
$c_Lio_circe_Decoder$$anon$39.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  if ((c instanceof $c_Lio_circe_HCursor)) {
    var x2 = $as_Lio_circe_HCursor(c);
    if ($n($n(x2).value__Lio_circe_Json()).isNull__Z()) {
      return $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_io$circe$Decoder$$rightNone
    } else {
      var x1$2 = $n(this.Lio_circe_Decoder$$anon$39__f_d$2).apply__Lio_circe_HCursor__s_util_Either(x2);
      if ((x1$2 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(x1$2);
        var a = $n(x2$2).s_util_Right__f_value;
        $n($m_s_package$().s_package$__f_Right);
        var value = new $c_s_Some(a);
        return new $c_s_util_Right(value)
      } else if ((x1$2 instanceof $c_s_util_Left)) {
        var x3 = $as_s_util_Left(x1$2);
        var df = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
        $n($m_s_package$().s_package$__f_Left);
        return new $c_s_util_Left(df)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else if ((c instanceof $c_Lio_circe_FailedCursor)) {
    var x3$2 = $as_Lio_circe_FailedCursor(c);
    if ((!$n(x3$2).incorrectFocus__Z())) {
      return $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_keyMissingNone
    } else {
      $n($m_s_package$().s_package$__f_Left);
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0((() => $n(x3$2).history__sci_List()));
      var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("[A]Option[A]", ops);
      return new $c_s_util_Left(value$1)
    }
  } else {
    throw new $c_s_MatchError(c)
  }
});
var $d_Lio_circe_Decoder$$anon$39 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$39: 0
}, false, "io.circe.Decoder$$anon$39", {
  Lio_circe_Decoder$$anon$39: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$39.prototype.$classData = $d_Lio_circe_Decoder$$anon$39;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$40() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$40.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$40.prototype.constructor = $c_Lio_circe_Decoder$$anon$40;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$40() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$40.prototype = $c_Lio_circe_Decoder$$anon$40.prototype;
$c_Lio_circe_Decoder$$anon$40.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$40.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  if ($n($n(c).value__Lio_circe_Json()).isNull__Z()) {
    $n($m_s_package$().s_package$__f_Right);
    var value = $m_s_None$();
    return new $c_s_util_Right(value)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("None", ops);
    return new $c_s_util_Left(value$1)
  }
});
var $d_Lio_circe_Decoder$$anon$40 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$40: 0
}, false, "io.circe.Decoder$$anon$40", {
  Lio_circe_Decoder$$anon$40: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$40.prototype.$classData = $d_Lio_circe_Decoder$$anon$40;
function $p_Lio_circe_Decoder$$anon$52__failure__Lio_circe_HCursor__s_util_Either($thiz, c) {
  $n($m_s_package$().s_package$__f_Left);
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
  var value = new $c_Lio_circe_DecodingFailure$$anon$2("[A, B]Either[A, B]", ops);
  return new $c_s_util_Left(value)
}
/** @constructor */
function $c_Lio_circe_Decoder$$anon$52(leftKey$1, rightKey$1, decodeA$10, decodeB$2) {
  this.Lio_circe_Decoder$$anon$52__f_leftKey$1 = null;
  this.Lio_circe_Decoder$$anon$52__f_rightKey$1 = null;
  this.Lio_circe_Decoder$$anon$52__f_decodeA$10 = null;
  this.Lio_circe_Decoder$$anon$52__f_decodeB$2 = null;
  this.Lio_circe_Decoder$$anon$52__f_leftKey$1 = leftKey$1;
  this.Lio_circe_Decoder$$anon$52__f_rightKey$1 = rightKey$1;
  this.Lio_circe_Decoder$$anon$52__f_decodeA$10 = decodeA$10;
  this.Lio_circe_Decoder$$anon$52__f_decodeB$2 = decodeB$2
}
$c_Lio_circe_Decoder$$anon$52.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$52.prototype.constructor = $c_Lio_circe_Decoder$$anon$52;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$52() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$52.prototype = $c_Lio_circe_Decoder$$anon$52.prototype;
$c_Lio_circe_Decoder$$anon$52.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$52.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var lf = $n(c).downField__T__Lio_circe_ACursor(this.Lio_circe_Decoder$$anon$52__f_leftKey$1);
  var rf = $n(c).downField__T__Lio_circe_ACursor(this.Lio_circe_Decoder$$anon$52__f_rightKey$1);
  if ((lf instanceof $c_Lio_circe_HCursor)) {
    var x2 = $as_Lio_circe_HCursor(lf);
    if ((rf instanceof $c_Lio_circe_HCursor)) {
      return $p_Lio_circe_Decoder$$anon$52__failure__Lio_circe_HCursor__s_util_Either(this, c)
    } else {
      var x1$3 = $n(this.Lio_circe_Decoder$$anon$52__f_decodeA$10).apply__Lio_circe_HCursor__s_util_Either(x2);
      if ((x1$3 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(x1$3);
        var v = $n(x2$2).s_util_Right__f_value;
        $n($m_s_package$().s_package$__f_Right);
        $n($m_s_package$().s_package$__f_Left);
        var value = new $c_s_util_Left(v);
        return new $c_s_util_Right(value)
      } else if ((x1$3 instanceof $c_s_util_Left)) {
        var x3 = $as_s_util_Left(x1$3);
        return x3
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    }
  } else if ((rf instanceof $c_Lio_circe_HCursor)) {
    var x2$3 = $as_Lio_circe_HCursor(rf);
    var x1$5 = $n(this.Lio_circe_Decoder$$anon$52__f_decodeB$2).apply__Lio_circe_HCursor__s_util_Either(x2$3);
    if ((x1$5 instanceof $c_s_util_Right)) {
      var x2$4 = $as_s_util_Right(x1$5);
      var v$2 = $n(x2$4).s_util_Right__f_value;
      $n($m_s_package$().s_package$__f_Right);
      $n($m_s_package$().s_package$__f_Right);
      var value$1 = new $c_s_util_Right(v$2);
      return new $c_s_util_Right(value$1)
    } else if ((x1$5 instanceof $c_s_util_Left)) {
      var x3$2 = $as_s_util_Left(x1$5);
      return x3$2
    } else {
      throw new $c_s_MatchError(x1$5)
    }
  } else {
    return $p_Lio_circe_Decoder$$anon$52__failure__Lio_circe_HCursor__s_util_Either(this, c)
  }
});
var $d_Lio_circe_Decoder$$anon$52 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$52: 0
}, false, "io.circe.Decoder$$anon$52", {
  Lio_circe_Decoder$$anon$52: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$52.prototype.$classData = $d_Lio_circe_Decoder$$anon$52;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$7(outer, errors$2) {
  this.Lio_circe_Decoder$$anon$7__f_$outer = null;
  this.Lio_circe_Decoder$$anon$7__f_errors$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_Decoder$$anon$7__f_$outer = outer
  };
  this.Lio_circe_Decoder$$anon$7__f_errors$2 = errors$2
}
$c_Lio_circe_Decoder$$anon$7.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$7.prototype.constructor = $c_Lio_circe_Decoder$$anon$7;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$7() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$7.prototype = $c_Lio_circe_Decoder$$anon$7.prototype;
$c_Lio_circe_Decoder$$anon$7.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$7.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var this$1 = $n($n($as_sc_LinearSeqOps($n(this.Lio_circe_Decoder$$anon$7__f_errors$2).apply__O__O(c))).headOption__s_Option());
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var message = $as_T(arg1);
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value = new $c_Lio_circe_DecodingFailure$$anon$2(message, ops);
    var $$x1 = new $c_s_Some(new $c_s_util_Left(value))
  };
  var this$5 = $n($$x1);
  return $as_s_util_Either((this$5.isEmpty__Z() ? $n(this.Lio_circe_Decoder$$anon$7__f_$outer).apply__Lio_circe_HCursor__s_util_Either(c) : this$5.get__O()))
});
var $d_Lio_circe_Decoder$$anon$7 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$7: 0
}, false, "io.circe.Decoder$$anon$7", {
  Lio_circe_Decoder$$anon$7: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$7.prototype.$classData = $d_Lio_circe_Decoder$$anon$7;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$8(outer, fb$1) {
  this.Lio_circe_Decoder$$anon$8__f_$outer = null;
  this.Lio_circe_Decoder$$anon$8__f_fb$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_Decoder$$anon$8__f_$outer = outer
  };
  this.Lio_circe_Decoder$$anon$8__f_fb$1 = fb$1
}
$c_Lio_circe_Decoder$$anon$8.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$8.prototype.constructor = $c_Lio_circe_Decoder$$anon$8;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$8() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$8.prototype = $c_Lio_circe_Decoder$$anon$8.prototype;
$c_Lio_circe_Decoder$$anon$8.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$$anon$8.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($n($m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance).product__O__O__O($n(this.Lio_circe_Decoder$$anon$8__f_$outer).apply__Lio_circe_HCursor__s_util_Either(c), $n(this.Lio_circe_Decoder$$anon$8__f_fb$1).apply__Lio_circe_HCursor__s_util_Either(c)))
});
var $d_Lio_circe_Decoder$$anon$8 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$8: 0
}, false, "io.circe.Decoder$$anon$8", {
  Lio_circe_Decoder$$anon$8: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$8.prototype.$classData = $d_Lio_circe_Decoder$$anon$8;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$9(outer, d$1) {
  this.Lio_circe_Decoder$$anon$9__f_$outer = null;
  this.Lio_circe_Decoder$$anon$9__f_d$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_Decoder$$anon$9__f_$outer = outer
  };
  this.Lio_circe_Decoder$$anon$9__f_d$1 = d$1
}
$c_Lio_circe_Decoder$$anon$9.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$9.prototype.constructor = $c_Lio_circe_Decoder$$anon$9;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$9() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$9.prototype = $c_Lio_circe_Decoder$$anon$9.prototype;
$c_Lio_circe_Decoder$$anon$9.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c)
});
$c_Lio_circe_Decoder$$anon$9.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x1 = $n(this.Lio_circe_Decoder$$anon$9__f_$outer).tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    return x2
  } else if ((x1 instanceof $c_s_util_Left)) {
    return $n($as_Lio_circe_Decoder($n(this.Lio_circe_Decoder$$anon$9__f_d$1).apply__O())).tryDecode__Lio_circe_ACursor__s_util_Either(c)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lio_circe_Decoder$$anon$9 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$9: 0
}, false, "io.circe.Decoder$$anon$9", {
  Lio_circe_Decoder$$anon$9: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$9.prototype.$classData = $d_Lio_circe_Decoder$$anon$9;
function $ct_Lio_circe_Decoder$DecoderWithFailure__T__($thiz, name) {
  $thiz.Lio_circe_Decoder$DecoderWithFailure__f_name = name;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_Decoder$DecoderWithFailure() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null
}
$c_Lio_circe_Decoder$DecoderWithFailure.prototype = new $h_O();
$c_Lio_circe_Decoder$DecoderWithFailure.prototype.constructor = $c_Lio_circe_Decoder$DecoderWithFailure;
/** @constructor */
function $h_Lio_circe_Decoder$DecoderWithFailure() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$DecoderWithFailure.prototype = $c_Lio_circe_Decoder$DecoderWithFailure.prototype;
$c_Lio_circe_Decoder$DecoderWithFailure.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$DecoderWithFailure.prototype.fail__Lio_circe_HCursor__s_util_Either = (function(c) {
  $n($m_s_package$().s_package$__f_Left);
  $m_Lio_circe_DecodingFailure$();
  var message = this.Lio_circe_Decoder$DecoderWithFailure__f_name;
  var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
  var value = new $c_Lio_circe_DecodingFailure$$anon$2(message, ops);
  return new $c_s_util_Left(value)
});
function $ct_Lio_circe_Decoder$JavaTimeDecoder__T__($thiz, name) {
  $thiz.Lio_circe_Decoder$JavaTimeDecoder__f_name = name;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_Decoder$JavaTimeDecoder() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null
}
$c_Lio_circe_Decoder$JavaTimeDecoder.prototype = new $h_O();
$c_Lio_circe_Decoder$JavaTimeDecoder.prototype.constructor = $c_Lio_circe_Decoder$JavaTimeDecoder;
/** @constructor */
function $h_Lio_circe_Decoder$JavaTimeDecoder() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$JavaTimeDecoder.prototype = $c_Lio_circe_Decoder$JavaTimeDecoder.prototype;
$c_Lio_circe_Decoder$JavaTimeDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_Decoder$JavaTimeDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x2 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x2).Lio_circe_Json$JString__f_value;
    try {
      $n($m_s_package$().s_package$__f_Right);
      var value = this.parseUnsafe__T__O(string);
      return new $c_s_util_Right(value)
    } catch (e) {
      if ((e instanceof $c_Ljava_time_DateTimeException)) {
        var e$2 = $as_Ljava_time_DateTimeException(e);
        var message = $n(e$2).jl_Throwable__f_s;
        if ((message === null)) {
          $n($m_s_package$().s_package$__f_Left);
          $m_Lio_circe_DecodingFailure$();
          var message$1 = this.Lio_circe_Decoder$JavaTimeDecoder__f_name;
          var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
          var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2(message$1, ops);
          return new $c_s_util_Left(value$1)
        } else {
          var newMessage = this.formatMessage__T__T__T(string, message);
          $n($m_s_package$().s_package$__f_Left);
          $m_Lio_circe_DecodingFailure$();
          var message$2 = (((this.Lio_circe_Decoder$JavaTimeDecoder__f_name + " (") + newMessage) + ")");
          var ops$1 = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
          var value$2 = new $c_Lio_circe_DecodingFailure$$anon$2(message$2, ops$1);
          return new $c_s_util_Left(value$2)
        }
      } else {
        throw e
      }
    }
  } else {
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var message$3 = this.Lio_circe_Decoder$JavaTimeDecoder__f_name;
    var ops$2 = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value$3 = new $c_Lio_circe_DecodingFailure$$anon$2(message$3, ops$2);
    return new $c_s_util_Left(value$3)
  }
});
/** @constructor */
function $c_Lio_circe_Encoder$$anon$1(outer, f$1) {
  this.Lio_circe_Encoder$$anon$1__f_$outer = null;
  this.Lio_circe_Encoder$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_Encoder$$anon$1__f_$outer = outer
  };
  this.Lio_circe_Encoder$$anon$1__f_f$1 = f$1
}
$c_Lio_circe_Encoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$1.prototype.constructor = $c_Lio_circe_Encoder$$anon$1;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$1.prototype = $c_Lio_circe_Encoder$$anon$1.prototype;
$c_Lio_circe_Encoder$$anon$1.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $n(this.Lio_circe_Encoder$$anon$1__f_$outer).apply__O__Lio_circe_Json($n(this.Lio_circe_Encoder$$anon$1__f_f$1).apply__O__O(a))
});
var $d_Lio_circe_Encoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$1: 0
}, false, "io.circe.Encoder$$anon$1", {
  Lio_circe_Encoder$$anon$1: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$1.prototype.$classData = $d_Lio_circe_Encoder$$anon$1;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$10() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$10.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$10.prototype.constructor = $c_Lio_circe_Encoder$$anon$10;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$10() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$10.prototype = $c_Lio_circe_Encoder$$anon$10.prototype;
$c_Lio_circe_Encoder$$anon$10.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uZ(a);
  return $m_Lio_circe_Json$().fromBoolean__Z__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$10 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$10: 0
}, false, "io.circe.Encoder$$anon$10", {
  Lio_circe_Encoder$$anon$10: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$10.prototype.$classData = $d_Lio_circe_Encoder$$anon$10;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$11() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$11.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$11.prototype.constructor = $c_Lio_circe_Encoder$$anon$11;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$11() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$11.prototype = $c_Lio_circe_Encoder$$anon$11.prototype;
$c_Lio_circe_Encoder$$anon$11.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uC(a);
  $m_Lio_circe_Json$();
  var value = $as_T(String.fromCharCode(a$1));
  return new $c_Lio_circe_Json$JString(value)
});
var $d_Lio_circe_Encoder$$anon$11 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$11: 0
}, false, "io.circe.Encoder$$anon$11", {
  Lio_circe_Encoder$$anon$11: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$11.prototype.$classData = $d_Lio_circe_Encoder$$anon$11;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$12() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$12.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$12.prototype.constructor = $c_Lio_circe_Encoder$$anon$12;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$12() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$12.prototype = $c_Lio_circe_Encoder$$anon$12.prototype;
$c_Lio_circe_Encoder$$anon$12.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uF(a);
  return $m_Lio_circe_Json$().fromFloatOrNull__F__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$12 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$12: 0
}, false, "io.circe.Encoder$$anon$12", {
  Lio_circe_Encoder$$anon$12: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$12.prototype.$classData = $d_Lio_circe_Encoder$$anon$12;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$13() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$13.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$13.prototype.constructor = $c_Lio_circe_Encoder$$anon$13;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$13() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$13.prototype = $c_Lio_circe_Encoder$$anon$13.prototype;
$c_Lio_circe_Encoder$$anon$13.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uD(a);
  return $m_Lio_circe_Json$().fromDoubleOrNull__D__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$13 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$13: 0
}, false, "io.circe.Encoder$$anon$13", {
  Lio_circe_Encoder$$anon$13: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$13.prototype.$classData = $d_Lio_circe_Encoder$$anon$13;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$14() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$14.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$14.prototype.constructor = $c_Lio_circe_Encoder$$anon$14;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$14() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$14.prototype = $c_Lio_circe_Encoder$$anon$14.prototype;
$c_Lio_circe_Encoder$$anon$14.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uB(a);
  return $m_Lio_circe_Json$().fromInt__I__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$14 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$14: 0
}, false, "io.circe.Encoder$$anon$14", {
  Lio_circe_Encoder$$anon$14: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$14.prototype.$classData = $d_Lio_circe_Encoder$$anon$14;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$15() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$15.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$15.prototype.constructor = $c_Lio_circe_Encoder$$anon$15;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$15() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$15.prototype = $c_Lio_circe_Encoder$$anon$15.prototype;
$c_Lio_circe_Encoder$$anon$15.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uS(a);
  return $m_Lio_circe_Json$().fromInt__I__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$15 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$15: 0
}, false, "io.circe.Encoder$$anon$15", {
  Lio_circe_Encoder$$anon$15: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$15.prototype.$classData = $d_Lio_circe_Encoder$$anon$15;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$16() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$16.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$16.prototype.constructor = $c_Lio_circe_Encoder$$anon$16;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$16() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$16.prototype = $c_Lio_circe_Encoder$$anon$16.prototype;
$c_Lio_circe_Encoder$$anon$16.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uI(a);
  return $m_Lio_circe_Json$().fromInt__I__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$16 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$16: 0
}, false, "io.circe.Encoder$$anon$16", {
  Lio_circe_Encoder$$anon$16: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$16.prototype.$classData = $d_Lio_circe_Encoder$$anon$16;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$17() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$17.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$17.prototype.constructor = $c_Lio_circe_Encoder$$anon$17;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$17() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$17.prototype = $c_Lio_circe_Encoder$$anon$17.prototype;
$c_Lio_circe_Encoder$$anon$17.prototype.apply__O__Lio_circe_Json = (function(a) {
  var t = $uJ(a);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_Lio_circe_Json$().fromLong__J__Lio_circe_Json(new $c_RTLong(lo, hi))
});
var $d_Lio_circe_Encoder$$anon$17 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$17: 0
}, false, "io.circe.Encoder$$anon$17", {
  Lio_circe_Encoder$$anon$17: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$17.prototype.$classData = $d_Lio_circe_Encoder$$anon$17;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$18() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$18.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$18.prototype.constructor = $c_Lio_circe_Encoder$$anon$18;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$18() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$18.prototype = $c_Lio_circe_Encoder$$anon$18.prototype;
$c_Lio_circe_Encoder$$anon$18.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_s_math_BigInt(a);
  return $m_Lio_circe_Json$().fromBigInt__s_math_BigInt__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$18 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$18: 0
}, false, "io.circe.Encoder$$anon$18", {
  Lio_circe_Encoder$$anon$18: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$18.prototype.$classData = $d_Lio_circe_Encoder$$anon$18;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$19() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$19.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$19.prototype.constructor = $c_Lio_circe_Encoder$$anon$19;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$19() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$19.prototype = $c_Lio_circe_Encoder$$anon$19.prototype;
$c_Lio_circe_Encoder$$anon$19.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_s_math_BigDecimal(a);
  return $m_Lio_circe_Json$().fromBigDecimal__s_math_BigDecimal__Lio_circe_Json(a$1)
});
var $d_Lio_circe_Encoder$$anon$19 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$19: 0
}, false, "io.circe.Encoder$$anon$19", {
  Lio_circe_Encoder$$anon$19: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$19.prototype.$classData = $d_Lio_circe_Encoder$$anon$19;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$20() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$20.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$20.prototype.constructor = $c_Lio_circe_Encoder$$anon$20;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$20() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$20.prototype = $c_Lio_circe_Encoder$$anon$20.prototype;
$c_Lio_circe_Encoder$$anon$20.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_ju_UUID(a);
  $m_Lio_circe_Json$();
  var value = $n(a$1).toString__T();
  return new $c_Lio_circe_Json$JString(value)
});
var $d_Lio_circe_Encoder$$anon$20 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$20: 0
}, false, "io.circe.Encoder$$anon$20", {
  Lio_circe_Encoder$$anon$20: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$20.prototype.$classData = $d_Lio_circe_Encoder$$anon$20;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$21(e$2) {
  this.Lio_circe_Encoder$$anon$21__f_e$2 = null;
  this.Lio_circe_Encoder$$anon$21__f_e$2 = e$2
}
$c_Lio_circe_Encoder$$anon$21.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$21.prototype.constructor = $c_Lio_circe_Encoder$$anon$21;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$21() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$21.prototype = $c_Lio_circe_Encoder$$anon$21.prototype;
$c_Lio_circe_Encoder$$anon$21.prototype.apply__s_Option__Lio_circe_Json = (function(a) {
  if ((a instanceof $c_s_Some)) {
    var x2 = $as_s_Some(a);
    var v = $n(x2).s_Some__f_value;
    return $n(this.Lio_circe_Encoder$$anon$21__f_e$2).apply__O__Lio_circe_Json(v)
  } else {
    var x = $m_s_None$();
    if ((x === a)) {
      return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null
    } else {
      throw new $c_s_MatchError(a)
    }
  }
});
$c_Lio_circe_Encoder$$anon$21.prototype.apply__O__Lio_circe_Json = (function(a) {
  return this.apply__s_Option__Lio_circe_Json($as_s_Option(a))
});
var $d_Lio_circe_Encoder$$anon$21 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$21: 0
}, false, "io.circe.Encoder$$anon$21", {
  Lio_circe_Encoder$$anon$21: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$21.prototype.$classData = $d_Lio_circe_Encoder$$anon$21;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$22() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$22.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$22.prototype.constructor = $c_Lio_circe_Encoder$$anon$22;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$22() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$22.prototype = $c_Lio_circe_Encoder$$anon$22.prototype;
$c_Lio_circe_Encoder$$anon$22.prototype.apply__O__Lio_circe_Json = (function(a) {
  $as_s_None$(a);
  return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null
});
var $d_Lio_circe_Encoder$$anon$22 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$22: 0
}, false, "io.circe.Encoder$$anon$22", {
  Lio_circe_Encoder$$anon$22: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$22.prototype.$classData = $d_Lio_circe_Encoder$$anon$22;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$3(f$3) {
  this.Lio_circe_Encoder$$anon$3__f_f$3 = null;
  this.Lio_circe_Encoder$$anon$3__f_f$3 = f$3
}
$c_Lio_circe_Encoder$$anon$3.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$3.prototype.constructor = $c_Lio_circe_Encoder$$anon$3;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$3() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$3.prototype = $c_Lio_circe_Encoder$$anon$3.prototype;
$c_Lio_circe_Encoder$$anon$3.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $as_Lio_circe_Json($n(this.Lio_circe_Encoder$$anon$3__f_f$3).apply__O__O(a))
});
var $d_Lio_circe_Encoder$$anon$3 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$3: 0
}, false, "io.circe.Encoder$$anon$3", {
  Lio_circe_Encoder$$anon$3: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$3.prototype.$classData = $d_Lio_circe_Encoder$$anon$3;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$37() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$37.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$37.prototype.constructor = $c_Lio_circe_Encoder$$anon$37;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$37() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$37.prototype = $c_Lio_circe_Encoder$$anon$37.prototype;
$c_Lio_circe_Encoder$$anon$37.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_Ljava_time_Duration(a);
  $m_Lio_circe_Json$();
  var value = $n(a$1).toString__T();
  return new $c_Lio_circe_Json$JString(value)
});
var $d_Lio_circe_Encoder$$anon$37 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$37: 0
}, false, "io.circe.Encoder$$anon$37", {
  Lio_circe_Encoder$$anon$37: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$37.prototype.$classData = $d_Lio_circe_Encoder$$anon$37;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$38() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$38.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$38.prototype.constructor = $c_Lio_circe_Encoder$$anon$38;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$38() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$38.prototype = $c_Lio_circe_Encoder$$anon$38.prototype;
$c_Lio_circe_Encoder$$anon$38.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_Ljava_time_Instant(a);
  $m_Lio_circe_Json$();
  var this$1 = $n(a$1);
  var value = $n($m_Ljava_time_format_DateTimeFormatter$().ISO_INSTANT__Ljava_time_format_DateTimeFormatter()).format__Ljava_time_temporal_TemporalAccessor__T(this$1);
  return new $c_Lio_circe_Json$JString(value)
});
var $d_Lio_circe_Encoder$$anon$38 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$38: 0
}, false, "io.circe.Encoder$$anon$38", {
  Lio_circe_Encoder$$anon$38: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$38.prototype.$classData = $d_Lio_circe_Encoder$$anon$38;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$39() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$39.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$39.prototype.constructor = $c_Lio_circe_Encoder$$anon$39;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$39() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$39.prototype = $c_Lio_circe_Encoder$$anon$39.prototype;
$c_Lio_circe_Encoder$$anon$39.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_Ljava_time_Period(a);
  $m_Lio_circe_Json$();
  var value = $n(a$1).toString__T();
  return new $c_Lio_circe_Json$JString(value)
});
var $d_Lio_circe_Encoder$$anon$39 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$39: 0
}, false, "io.circe.Encoder$$anon$39", {
  Lio_circe_Encoder$$anon$39: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$39.prototype.$classData = $d_Lio_circe_Encoder$$anon$39;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$5() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$5.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$5.prototype.constructor = $c_Lio_circe_Encoder$$anon$5;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$5() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$5.prototype = $c_Lio_circe_Encoder$$anon$5.prototype;
$c_Lio_circe_Encoder$$anon$5.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_Lio_circe_Json(a);
  return a$1
});
var $d_Lio_circe_Encoder$$anon$5 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$5: 0
}, false, "io.circe.Encoder$$anon$5", {
  Lio_circe_Encoder$$anon$5: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$5.prototype.$classData = $d_Lio_circe_Encoder$$anon$5;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$51() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$51.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$51.prototype.constructor = $c_Lio_circe_Encoder$$anon$51;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$51() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$51.prototype = $c_Lio_circe_Encoder$$anon$51.prototype;
$c_Lio_circe_Encoder$$anon$51.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_Ljava_time_LocalDate(a);
  $m_Lio_circe_Json$();
  var value = $n(a$1).toString__T();
  return new $c_Lio_circe_Json$JString(value)
});
var $d_Lio_circe_Encoder$$anon$51 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$51: 0
}, false, "io.circe.Encoder$$anon$51", {
  Lio_circe_Encoder$$anon$51: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$51.prototype.$classData = $d_Lio_circe_Encoder$$anon$51;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$7() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$7.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$7.prototype.constructor = $c_Lio_circe_Encoder$$anon$7;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$7() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$7.prototype = $c_Lio_circe_Encoder$$anon$7.prototype;
$c_Lio_circe_Encoder$$anon$7.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_Lio_circe_JsonNumber(a);
  $m_Lio_circe_Json$();
  return new $c_Lio_circe_Json$JNumber(a$1)
});
var $d_Lio_circe_Encoder$$anon$7 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$7: 0
}, false, "io.circe.Encoder$$anon$7", {
  Lio_circe_Encoder$$anon$7: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$7.prototype.$classData = $d_Lio_circe_Encoder$$anon$7;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$8() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$8.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$8.prototype.constructor = $c_Lio_circe_Encoder$$anon$8;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$8() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$8.prototype = $c_Lio_circe_Encoder$$anon$8.prototype;
$c_Lio_circe_Encoder$$anon$8.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_T(a);
  $m_Lio_circe_Json$();
  return new $c_Lio_circe_Json$JString(a$1)
});
var $d_Lio_circe_Encoder$$anon$8 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$8: 0
}, false, "io.circe.Encoder$$anon$8", {
  Lio_circe_Encoder$$anon$8: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$8.prototype.$classData = $d_Lio_circe_Encoder$$anon$8;
/** @constructor */
function $c_Lio_circe_Encoder$JavaTimeEncoder() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$JavaTimeEncoder.prototype = new $h_O();
$c_Lio_circe_Encoder$JavaTimeEncoder.prototype.constructor = $c_Lio_circe_Encoder$JavaTimeEncoder;
/** @constructor */
function $h_Lio_circe_Encoder$JavaTimeEncoder() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$JavaTimeEncoder.prototype = $c_Lio_circe_Encoder$JavaTimeEncoder.prototype;
$c_Lio_circe_Encoder$JavaTimeEncoder.prototype.apply__Ljava_time_temporal_TemporalAccessor__Lio_circe_Json = (function(a) {
  $m_Lio_circe_Json$();
  var value = $n(this.format__Ljava_time_format_DateTimeFormatter()).format__Ljava_time_temporal_TemporalAccessor__T(a);
  return new $c_Lio_circe_Json$JString(value)
});
$c_Lio_circe_Encoder$JavaTimeEncoder.prototype.apply__O__Lio_circe_Json = (function(a) {
  return this.apply__Ljava_time_temporal_TemporalAccessor__Lio_circe_Json($as_Ljava_time_temporal_TemporalAccessor(a))
});
/** @constructor */
function $c_Lio_circe_FailedCursor(lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_FailedCursor__f_lastCursor = null;
  this.Lio_circe_FailedCursor__f_lastOp = null;
  this.Lio_circe_FailedCursor__f_lastCursor = lastCursor;
  this.Lio_circe_FailedCursor__f_lastOp = lastOp;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp)
}
$c_Lio_circe_FailedCursor.prototype = new $h_Lio_circe_ACursor();
$c_Lio_circe_FailedCursor.prototype.constructor = $c_Lio_circe_FailedCursor;
/** @constructor */
function $h_Lio_circe_FailedCursor() {
  /*<skip>*/
}
$h_Lio_circe_FailedCursor.prototype = $c_Lio_circe_FailedCursor.prototype;
$c_Lio_circe_FailedCursor.prototype.incorrectFocus__Z = (function() {
  return (($n(this.Lio_circe_FailedCursor__f_lastOp).requiresObject__Z() && (!$n($n(this.Lio_circe_FailedCursor__f_lastCursor).value__Lio_circe_Json()).isObject__Z())) || ($n(this.Lio_circe_FailedCursor__f_lastOp).requiresArray__Z() && (!$n($n(this.Lio_circe_FailedCursor__f_lastCursor).value__Lio_circe_Json()).isArray__Z())))
});
$c_Lio_circe_FailedCursor.prototype.succeeded__Z = (function() {
  return false
});
$c_Lio_circe_FailedCursor.prototype.focus__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_FailedCursor.prototype.downField__T__Lio_circe_ACursor = (function(k) {
  return this
});
$c_Lio_circe_FailedCursor.prototype.right__Lio_circe_ACursor = (function() {
  return this
});
function $as_Lio_circe_FailedCursor(obj) {
  return (((obj instanceof $c_Lio_circe_FailedCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.FailedCursor"))
}
function $isArrayOf_Lio_circe_FailedCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_FailedCursor)))
}
function $asArrayOf_Lio_circe_FailedCursor(obj, depth) {
  return (($isArrayOf_Lio_circe_FailedCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.FailedCursor;", depth))
}
var $d_Lio_circe_FailedCursor = new $TypeData().initClass({
  Lio_circe_FailedCursor: 0
}, false, "io.circe.FailedCursor", {
  Lio_circe_FailedCursor: 1,
  Lio_circe_ACursor: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_FailedCursor.prototype.$classData = $d_Lio_circe_FailedCursor;
/** @constructor */
function $c_Lio_circe_HCursor() {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null
}
$c_Lio_circe_HCursor.prototype = new $h_Lio_circe_ACursor();
$c_Lio_circe_HCursor.prototype.constructor = $c_Lio_circe_HCursor;
/** @constructor */
function $h_Lio_circe_HCursor() {
  /*<skip>*/
}
$h_Lio_circe_HCursor.prototype = $c_Lio_circe_HCursor.prototype;
$c_Lio_circe_HCursor.prototype.succeeded__Z = (function() {
  return true
});
$c_Lio_circe_HCursor.prototype.focus__s_Option = (function() {
  return new $c_s_Some(this.value__Lio_circe_Json())
});
$c_Lio_circe_HCursor.prototype.keys__s_Option = (function() {
  var x1 = this.value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JObject)) {
    var x2 = $as_Lio_circe_Json$JObject(x1);
    var o = $n(x2).Lio_circe_Json$JObject__f_value;
    return new $c_s_Some($n(o).keys__sc_Iterable())
  } else {
    return $m_s_None$()
  }
});
$c_Lio_circe_HCursor.prototype.downArray__Lio_circe_ACursor = (function() {
  var x1 = this.value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JArray)) {
    var x2 = $as_Lio_circe_Json$JArray(x1);
    var values = $n(x2).Lio_circe_Json$JArray__f_value;
    var this$1 = $n(values);
    if ((!$f_sc_SeqOps__isEmpty__Z(this$1))) {
      return new $c_Lio_circe_cursor_ArrayCursor(values, 0, this, false, this, $m_Lio_circe_CursorOp$DownArray$())
    }
  };
  var op = $m_Lio_circe_CursorOp$DownArray$();
  return new $c_Lio_circe_FailedCursor(this, op)
});
$c_Lio_circe_HCursor.prototype.downField__T__Lio_circe_ACursor = (function(k) {
  var x1 = this.value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JObject)) {
    var x2 = $as_Lio_circe_Json$JObject(x1);
    var o = $n(x2).Lio_circe_Json$JObject__f_value;
    if ((!$n(o).contains__T__Z(k))) {
      var op = new $c_Lio_circe_CursorOp$DownField(k);
      return new $c_Lio_circe_FailedCursor(this, op)
    } else {
      return new $c_Lio_circe_cursor_ObjectCursor(o, k, this, false, this, new $c_Lio_circe_CursorOp$DownField(k))
    }
  } else {
    var op$1 = new $c_Lio_circe_CursorOp$DownField(k);
    return new $c_Lio_circe_FailedCursor(this, op$1)
  }
});
$c_Lio_circe_HCursor.prototype.downN__I__Lio_circe_ACursor = (function(n) {
  var x1 = this.value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JArray)) {
    var x2 = $as_Lio_circe_Json$JArray(x1);
    var values = $n(x2).Lio_circe_Json$JArray__f_value;
    if ((n >= 0)) {
      var this$1 = $n(values);
      var $$x1 = (this$1.length__I() > n)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return new $c_Lio_circe_cursor_ArrayCursor(values, n, this, false, this, new $c_Lio_circe_CursorOp$DownN(n))
    }
  };
  var op = new $c_Lio_circe_CursorOp$DownN(n);
  return new $c_Lio_circe_FailedCursor(this, op)
});
function $as_Lio_circe_HCursor(obj) {
  return (((obj instanceof $c_Lio_circe_HCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.HCursor"))
}
function $isArrayOf_Lio_circe_HCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_HCursor)))
}
function $asArrayOf_Lio_circe_HCursor(obj, depth) {
  return (($isArrayOf_Lio_circe_HCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.HCursor;", depth))
}
function $p_Lio_circe_JsonObject$LinkedHashMapJsonObject__toMapAndVectorJsonObject__Lio_circe_JsonObject$MapAndVectorJsonObject($thiz) {
  var mapBuilder = new $c_sci_MapBuilderImpl();
  $n($m_s_package$().s_package$__f_Vector);
  var keyBuilder = new $c_sci_VectorBuilder();
  $thiz.size__I();
  $thiz.size__I();
  var this$3 = $n($thiz.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields);
  var iterator = new $c_ju_HashMap$EntrySet(this$3).iterator__ju_Iterator();
  while ($n(iterator).hasNext__Z()) {
    var next = $as_ju_Map$Entry($n(iterator).next__O());
    var key = $as_T($n(next).getKey__O());
    var _2 = $n(next).getValue__O();
    mapBuilder.addOne__O__O__sci_MapBuilderImpl(key, _2);
    keyBuilder.addOne__O__sci_VectorBuilder(key)
  };
  return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject(mapBuilder.result__sci_Map(), keyBuilder.result__sci_Vector())
}
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject(fields) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields = null;
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields = fields
}
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype = new $h_Lio_circe_JsonObject();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.applyUnsafe__T__Lio_circe_Json = (function(key) {
  var this$1 = $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields);
  return $as_Lio_circe_Json($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, key, null))
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.size__I = (function() {
  return $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields).ju_HashMap__f_contentSize
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.contains__T__Z = (function(k) {
  return $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields).containsKey__O__Z(k)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.isEmpty__Z = (function() {
  return $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields).isEmpty__Z()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.keys__sc_Iterable = (function() {
  return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.toMap__sci_Map = (function() {
  var builder = new $c_sci_MapBuilderImpl();
  this.size__I();
  var this$2 = $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields);
  var iterator = new $c_ju_HashMap$EntrySet(this$2).iterator__ju_Iterator();
  while ($n(iterator).hasNext__Z()) {
    var next = $as_ju_Map$Entry($n(iterator).next__O());
    var _1 = $n(next).getKey__O();
    var _2 = $n(next).getValue__O();
    builder.addOne__O__O__sci_MapBuilderImpl(_1, _2)
  };
  return builder.result__sci_Map()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.toIterable__sc_Iterable = (function() {
  return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.appendToFolder__Lio_circe_Printer$PrintingFolder__V = (function(folder) {
  var originalDepth = $n(folder).Lio_circe_Printer$PrintingFolder__f_depth;
  var p = $n($n(folder).Lio_circe_Printer$PrintingFolder__f_pieces).apply__I__Lio_circe_Printer$Pieces($n(folder).Lio_circe_Printer$PrintingFolder__f_depth);
  var first = true;
  if ($n(folder).Lio_circe_Printer$PrintingFolder__f_sortKeys) {
    var this$1 = new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this);
    var this$3 = $n($m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$1));
    var f = new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_T2(x$3$2);
      return $as_T($n(x$3)._1__O())
    }));
    var ord = $m_s_math_Ordering$String$();
    var iterable = $as_sc_Iterable($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$3, f, ord))
  } else {
    var iterable = new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this)
  };
  var iterator = $n(iterable).iterator__sc_Iterator();
  $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_lBraces);
  while ($n(iterator).hasNext__Z()) {
    var next = $as_T2($n(iterator).next__O());
    var key = $as_T($n(next)._1__O());
    var value = $as_Lio_circe_Json($n(next)._2__O());
    if (((!$n(folder).Lio_circe_Printer$PrintingFolder__f_dropNullValues) || (!$n(value).isNull__Z()))) {
      if ((!first)) {
        $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_objectCommas)
      };
      $n(folder).onString__T__V(key);
      $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_colons);
      $n(folder).Lio_circe_Printer$PrintingFolder__f_depth = ((1 + $n(folder).Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      $n(value).foldWith__Lio_circe_Json$Folder__O(folder);
      $n(folder).Lio_circe_Printer$PrintingFolder__f_depth = originalDepth;
      first = false
    }
  };
  $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_rBraces)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.add__T__Lio_circe_Json__Lio_circe_JsonObject = (function(k, j) {
  return $n($p_Lio_circe_JsonObject$LinkedHashMapJsonObject__toMapAndVectorJsonObject__Lio_circe_JsonObject$MapAndVectorJsonObject(this)).add__T__Lio_circe_Json__Lio_circe_JsonObject(k, j)
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject = new $TypeData().initClass({
  Lio_circe_JsonObject$LinkedHashMapJsonObject: 0
}, false, "io.circe.JsonObject$LinkedHashMapJsonObject", {
  Lio_circe_JsonObject$LinkedHashMapJsonObject: 1,
  Lio_circe_JsonObject: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.$classData = $d_Lio_circe_JsonObject$LinkedHashMapJsonObject;
/** @constructor */
function $c_Lio_circe_JsonObject$MapAndVectorJsonObject(fields, orderedKeys) {
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields = null;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys = null;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields = fields;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys = orderedKeys
}
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype = new $h_Lio_circe_JsonObject();
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.constructor = $c_Lio_circe_JsonObject$MapAndVectorJsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject$MapAndVectorJsonObject() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype = $c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype;
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.applyUnsafe__T__Lio_circe_Json = (function(key) {
  return $as_Lio_circe_Json($n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).apply__O__O(key))
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.contains__T__Z = (function(key) {
  return $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).contains__O__Z(key)
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.isEmpty__Z = (function() {
  return $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).isEmpty__Z()
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.keys__sc_Iterable = (function() {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.toMap__sci_Map = (function() {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.toIterable__sc_Iterable = (function() {
  return $as_sc_Iterable($n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys).map__F1__O(new $c_sjsr_AnonFunction1(((key$2) => {
    var key = $as_T(key$2);
    return $ct_T2__O__O__(new $c_T2(), key, $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).apply__O__O(key))
  }))))
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.add__T__Lio_circe_Json__Lio_circe_JsonObject = (function(key, value) {
  if ($n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).contains__O__Z(key)) {
    return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($as_sci_Map($n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).updated__O__O__sci_MapOps(key, value)), this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys)
  } else {
    var $$x1 = $as_sci_Map($n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).updated__O__O__sci_MapOps(key, value));
    var this$1 = $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys);
    return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($$x1, $as_sci_Vector(this$1.appended__O__O(key)))
  }
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.appendToFolder__Lio_circe_Printer$PrintingFolder__V = (function(folder) {
  var originalDepth = $n(folder).Lio_circe_Printer$PrintingFolder__f_depth;
  var p = $n($n(folder).Lio_circe_Printer$PrintingFolder__f_pieces).apply__I__Lio_circe_Printer$Pieces($n(folder).Lio_circe_Printer$PrintingFolder__f_depth);
  var first = true;
  if ($n(folder).Lio_circe_Printer$PrintingFolder__f_sortKeys) {
    var this$1 = $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys);
    var ord = $m_s_math_Ordering$String$();
    var keyIterator = $n($as_sci_Vector($f_sc_SeqOps__sorted__s_math_Ordering__O(this$1, ord))).iterator__sc_Iterator()
  } else {
    var keyIterator = $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys).iterator__sc_Iterator()
  };
  $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_lBraces);
  while ($n(keyIterator).hasNext__Z()) {
    var key = $as_T($n(keyIterator).next__O());
    var value = $as_Lio_circe_Json($n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).apply__O__O(key));
    if (((!$n(folder).Lio_circe_Printer$PrintingFolder__f_dropNullValues) || (!$n(value).isNull__Z()))) {
      if ((!first)) {
        $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_objectCommas)
      };
      $n(folder).onString__T__V(key);
      $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_colons);
      $n(folder).Lio_circe_Printer$PrintingFolder__f_depth = ((1 + $n(folder).Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      $n(value).foldWith__Lio_circe_Json$Folder__O(folder);
      $n(folder).Lio_circe_Printer$PrintingFolder__f_depth = originalDepth;
      first = false
    }
  };
  $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_rBraces)
});
var $d_Lio_circe_JsonObject$MapAndVectorJsonObject = new $TypeData().initClass({
  Lio_circe_JsonObject$MapAndVectorJsonObject: 0
}, false, "io.circe.JsonObject$MapAndVectorJsonObject", {
  Lio_circe_JsonObject$MapAndVectorJsonObject: 1,
  Lio_circe_JsonObject: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.$classData = $d_Lio_circe_JsonObject$MapAndVectorJsonObject;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$1(outer, f$1) {
  this.Lio_circe_KeyDecoder$$anon$1__f_$outer = null;
  this.Lio_circe_KeyDecoder$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_KeyDecoder$$anon$1__f_$outer = outer
  };
  this.Lio_circe_KeyDecoder$$anon$1__f_f$1 = f$1
}
$c_Lio_circe_KeyDecoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$1.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$1;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$1.prototype = $c_Lio_circe_KeyDecoder$$anon$1.prototype;
$c_Lio_circe_KeyDecoder$$anon$1.prototype.apply__T__s_Option = (function(key) {
  var this$1 = $n($n(this.Lio_circe_KeyDecoder$$anon$1__f_$outer).apply__T__s_Option(key));
  var f = this.Lio_circe_KeyDecoder$$anon$1__f_f$1;
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())))
});
var $d_Lio_circe_KeyDecoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$1: 0
}, false, "io.circe.KeyDecoder$$anon$1", {
  Lio_circe_KeyDecoder$$anon$1: 1,
  O: 1,
  Lio_circe_KeyDecoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyDecoder$$anon$1.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$1;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$2(outer, f$2) {
  this.Lio_circe_KeyDecoder$$anon$2__f_$outer = null;
  this.Lio_circe_KeyDecoder$$anon$2__f_f$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_KeyDecoder$$anon$2__f_$outer = outer
  };
  this.Lio_circe_KeyDecoder$$anon$2__f_f$2 = f$2
}
$c_Lio_circe_KeyDecoder$$anon$2.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$2.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$2;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$2.prototype = $c_Lio_circe_KeyDecoder$$anon$2.prototype;
$c_Lio_circe_KeyDecoder$$anon$2.prototype.apply__T__s_Option = (function(key) {
  var this$1 = $n($n(this.Lio_circe_KeyDecoder$$anon$2__f_$outer).apply__T__s_Option(key));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    return $n($as_Lio_circe_KeyDecoder($n(this.Lio_circe_KeyDecoder$$anon$2__f_f$2).apply__O__O(arg1))).apply__T__s_Option(key)
  }
});
var $d_Lio_circe_KeyDecoder$$anon$2 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$2: 0
}, false, "io.circe.KeyDecoder$$anon$2", {
  Lio_circe_KeyDecoder$$anon$2: 1,
  O: 1,
  Lio_circe_KeyDecoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyDecoder$$anon$2.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$2;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$4(f$4) {
  this.Lio_circe_KeyDecoder$$anon$4__f_f$4 = null;
  this.Lio_circe_KeyDecoder$$anon$4__f_f$4 = f$4
}
$c_Lio_circe_KeyDecoder$$anon$4.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$4.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$4;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$4() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$4.prototype = $c_Lio_circe_KeyDecoder$$anon$4.prototype;
$c_Lio_circe_KeyDecoder$$anon$4.prototype.apply__T__s_Option = (function(key) {
  try {
    return new $c_s_Some($n(this.Lio_circe_KeyDecoder$$anon$4__f_f$4).apply__O__O(key))
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      return $m_s_None$()
    } else {
      throw e
    }
  }
});
var $d_Lio_circe_KeyDecoder$$anon$4 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$4: 0
}, false, "io.circe.KeyDecoder$$anon$4", {
  Lio_circe_KeyDecoder$$anon$4: 1,
  O: 1,
  Lio_circe_KeyDecoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyDecoder$$anon$4.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$4;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$7() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$$anon$7.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$7.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$7;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$7() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$7.prototype = $c_Lio_circe_KeyDecoder$$anon$7.prototype;
$c_Lio_circe_KeyDecoder$$anon$7.prototype.apply__T__s_Option = (function(key) {
  var this$1 = $n(key);
  if ((this$1.length === 36)) {
    try {
      return new $c_s_Some($m_ju_UUID$().fromString__T__ju_UUID(key))
    } catch (e) {
      if ((e instanceof $c_jl_IllegalArgumentException)) {
        return $m_s_None$()
      } else {
        throw e
      }
    }
  } else {
    return $m_s_None$()
  }
});
var $d_Lio_circe_KeyDecoder$$anon$7 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$7: 0
}, false, "io.circe.KeyDecoder$$anon$7", {
  Lio_circe_KeyDecoder$$anon$7: 1,
  O: 1,
  Lio_circe_KeyDecoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyDecoder$$anon$7.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$7;
/** @constructor */
function $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype.constructor = $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder;
/** @constructor */
function $h_Lio_circe_KeyDecoder$AlwaysKeyDecoder() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype = $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype;
$c_Lio_circe_KeyDecoder$AlwaysKeyDecoder.prototype.apply__T__s_Option = (function(key) {
  return new $c_s_Some(this.decodeSafe__T__O(key))
});
function $as_Lio_circe_KeyDecoder$AlwaysKeyDecoder(obj) {
  return (((obj instanceof $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.KeyDecoder$AlwaysKeyDecoder"))
}
function $isArrayOf_Lio_circe_KeyDecoder$AlwaysKeyDecoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_KeyDecoder$AlwaysKeyDecoder)))
}
function $asArrayOf_Lio_circe_KeyDecoder$AlwaysKeyDecoder(obj, depth) {
  return (($isArrayOf_Lio_circe_KeyDecoder$AlwaysKeyDecoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.KeyDecoder$AlwaysKeyDecoder;", depth))
}
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$1(outer, f$1) {
  this.Lio_circe_KeyEncoder$$anon$1__f_$outer = null;
  this.Lio_circe_KeyEncoder$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_KeyEncoder$$anon$1__f_$outer = outer
  };
  this.Lio_circe_KeyEncoder$$anon$1__f_f$1 = f$1
}
$c_Lio_circe_KeyEncoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$1.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$1;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$$anon$1.prototype = $c_Lio_circe_KeyEncoder$$anon$1.prototype;
$c_Lio_circe_KeyEncoder$$anon$1.prototype.apply__O__T = (function(key) {
  return $n(this.Lio_circe_KeyEncoder$$anon$1__f_$outer).apply__O__T($n(this.Lio_circe_KeyEncoder$$anon$1__f_f$1).apply__O__O(key))
});
var $d_Lio_circe_KeyEncoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_KeyEncoder$$anon$1: 0
}, false, "io.circe.KeyEncoder$$anon$1", {
  Lio_circe_KeyEncoder$$anon$1: 1,
  O: 1,
  Lio_circe_KeyEncoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$$anon$1.prototype.$classData = $d_Lio_circe_KeyEncoder$$anon$1;
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$3() {
  /*<skip>*/
}
$c_Lio_circe_KeyEncoder$$anon$3.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$3.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$3;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$3() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$$anon$3.prototype = $c_Lio_circe_KeyEncoder$$anon$3.prototype;
$c_Lio_circe_KeyEncoder$$anon$3.prototype.apply__O__T = (function(key) {
  var key$1 = $as_T(key);
  return key$1
});
var $d_Lio_circe_KeyEncoder$$anon$3 = new $TypeData().initClass({
  Lio_circe_KeyEncoder$$anon$3: 0
}, false, "io.circe.KeyEncoder$$anon$3", {
  Lio_circe_KeyEncoder$$anon$3: 1,
  O: 1,
  Lio_circe_KeyEncoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$$anon$3.prototype.$classData = $d_Lio_circe_KeyEncoder$$anon$3;
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$4() {
  /*<skip>*/
}
$c_Lio_circe_KeyEncoder$$anon$4.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$4.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$4;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$4() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$$anon$4.prototype = $c_Lio_circe_KeyEncoder$$anon$4.prototype;
$c_Lio_circe_KeyEncoder$$anon$4.prototype.apply__O__T = (function(key) {
  var key$1 = $as_s_Symbol(key);
  return $n(key$1).s_Symbol__f_name
});
var $d_Lio_circe_KeyEncoder$$anon$4 = new $TypeData().initClass({
  Lio_circe_KeyEncoder$$anon$4: 0
}, false, "io.circe.KeyEncoder$$anon$4", {
  Lio_circe_KeyEncoder$$anon$4: 1,
  O: 1,
  Lio_circe_KeyEncoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$$anon$4.prototype.$classData = $d_Lio_circe_KeyEncoder$$anon$4;
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$5() {
  /*<skip>*/
}
$c_Lio_circe_KeyEncoder$$anon$5.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$5.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$5;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$5() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$$anon$5.prototype = $c_Lio_circe_KeyEncoder$$anon$5.prototype;
$c_Lio_circe_KeyEncoder$$anon$5.prototype.apply__O__T = (function(key) {
  var key$1 = $as_ju_UUID(key);
  return $n(key$1).toString__T()
});
var $d_Lio_circe_KeyEncoder$$anon$5 = new $TypeData().initClass({
  Lio_circe_KeyEncoder$$anon$5: 0
}, false, "io.circe.KeyEncoder$$anon$5", {
  Lio_circe_KeyEncoder$$anon$5: 1,
  O: 1,
  Lio_circe_KeyEncoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$$anon$5.prototype.$classData = $d_Lio_circe_KeyEncoder$$anon$5;
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$6() {
  /*<skip>*/
}
$c_Lio_circe_KeyEncoder$$anon$6.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$6.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$6;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$6() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$$anon$6.prototype = $c_Lio_circe_KeyEncoder$$anon$6.prototype;
$c_Lio_circe_KeyEncoder$$anon$6.prototype.apply__O__T = (function(key) {
  var key$1 = $uB(key);
  return ("" + key$1)
});
var $d_Lio_circe_KeyEncoder$$anon$6 = new $TypeData().initClass({
  Lio_circe_KeyEncoder$$anon$6: 0
}, false, "io.circe.KeyEncoder$$anon$6", {
  Lio_circe_KeyEncoder$$anon$6: 1,
  O: 1,
  Lio_circe_KeyEncoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$$anon$6.prototype.$classData = $d_Lio_circe_KeyEncoder$$anon$6;
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$7() {
  /*<skip>*/
}
$c_Lio_circe_KeyEncoder$$anon$7.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$7.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$7;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$7() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$$anon$7.prototype = $c_Lio_circe_KeyEncoder$$anon$7.prototype;
$c_Lio_circe_KeyEncoder$$anon$7.prototype.apply__O__T = (function(key) {
  var key$1 = $uS(key);
  return ("" + key$1)
});
var $d_Lio_circe_KeyEncoder$$anon$7 = new $TypeData().initClass({
  Lio_circe_KeyEncoder$$anon$7: 0
}, false, "io.circe.KeyEncoder$$anon$7", {
  Lio_circe_KeyEncoder$$anon$7: 1,
  O: 1,
  Lio_circe_KeyEncoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$$anon$7.prototype.$classData = $d_Lio_circe_KeyEncoder$$anon$7;
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$8() {
  /*<skip>*/
}
$c_Lio_circe_KeyEncoder$$anon$8.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$8.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$8;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$8() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$$anon$8.prototype = $c_Lio_circe_KeyEncoder$$anon$8.prototype;
$c_Lio_circe_KeyEncoder$$anon$8.prototype.apply__O__T = (function(key) {
  var key$1 = $uI(key);
  return ("" + key$1)
});
var $d_Lio_circe_KeyEncoder$$anon$8 = new $TypeData().initClass({
  Lio_circe_KeyEncoder$$anon$8: 0
}, false, "io.circe.KeyEncoder$$anon$8", {
  Lio_circe_KeyEncoder$$anon$8: 1,
  O: 1,
  Lio_circe_KeyEncoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$$anon$8.prototype.$classData = $d_Lio_circe_KeyEncoder$$anon$8;
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$9() {
  /*<skip>*/
}
$c_Lio_circe_KeyEncoder$$anon$9.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$9.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$9;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$9() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$$anon$9.prototype = $c_Lio_circe_KeyEncoder$$anon$9.prototype;
$c_Lio_circe_KeyEncoder$$anon$9.prototype.apply__O__T = (function(key) {
  var t = $uJ(key);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi)
});
var $d_Lio_circe_KeyEncoder$$anon$9 = new $TypeData().initClass({
  Lio_circe_KeyEncoder$$anon$9: 0
}, false, "io.circe.KeyEncoder$$anon$9", {
  Lio_circe_KeyEncoder$$anon$9: 1,
  O: 1,
  Lio_circe_KeyEncoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$$anon$9.prototype.$classData = $d_Lio_circe_KeyEncoder$$anon$9;
function $p_Lio_circe_MapDecoder__createObjectCursor__Lio_circe_HCursor__Lio_circe_JsonObject__T__Lio_circe_HCursor($thiz, c, obj, key) {
  return new $c_Lio_circe_cursor_ObjectCursor(obj, key, c, false, c, new $c_Lio_circe_CursorOp$DownField(key))
}
function $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure($thiz, key, c, builder) {
  var x1 = $n($thiz.Lio_circe_MapDecoder__f_decodeV).apply__Lio_circe_HCursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var value = $n(x2).s_util_Right__f_value;
    var this$1 = $n(builder);
    var elem = $ct_T2__O__O__(new $c_T2(), key, value);
    this$1.addOne__O__scm_Growable(elem);
    return null
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    var error = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
    return error
  } else {
    throw new $c_s_MatchError(x1)
  }
}
function $p_Lio_circe_MapDecoder__decodeJsonObject__Lio_circe_HCursor__Lio_circe_JsonObject__s_util_Either($thiz, c, obj) {
  var it = $n($n(obj).keys__sc_Iterable()).iterator__sc_Iterator();
  var builder = new $c_sci_MapBuilderImpl();
  var failed = null;
  while (((failed === null) && $n(it).hasNext__Z())) {
    var key = $as_T($n(it).next__O());
    var atH = $p_Lio_circe_MapDecoder__createObjectCursor__Lio_circe_HCursor__Lio_circe_JsonObject__T__Lio_circe_HCursor($thiz, c, obj, key);
    if (($thiz.Lio_circe_MapDecoder__f_alwaysDecodeK !== null)) {
      failed = $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure($thiz, $n($thiz.Lio_circe_MapDecoder__f_alwaysDecodeK).decodeSafe__T__O(key), atH, builder)
    } else {
      var x1 = $n($thiz.Lio_circe_MapDecoder__f_decodeK).apply__T__s_Option(key);
      var x = $m_s_None$();
      if ((x === x1)) {
        failed = $m_Lio_circe_MapDecoder$().failure__Lio_circe_HCursor__Lio_circe_DecodingFailure(atH)
      } else {
        if ((!(x1 instanceof $c_s_Some))) {
          throw new $c_s_MatchError(x1)
        };
        var x2 = $as_s_Some(x1);
        var k = $n(x2).s_Some__f_value;
        failed = $p_Lio_circe_MapDecoder__handleResult__O__Lio_circe_HCursor__scm_Builder__Lio_circe_DecodingFailure($thiz, k, atH, builder)
      }
    }
  };
  if ((failed === null)) {
    $n($m_s_package$().s_package$__f_Right);
    var value = builder.result__sci_Map();
    return new $c_s_util_Right(value)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    var value$1 = failed;
    return new $c_s_util_Left(value$1)
  }
}
function $ct_Lio_circe_MapDecoder__Lio_circe_KeyDecoder__Lio_circe_Decoder__($thiz, decodeK, decodeV) {
  $thiz.Lio_circe_MapDecoder__f_decodeK = decodeK;
  $thiz.Lio_circe_MapDecoder__f_decodeV = decodeV;
  if ((decodeK instanceof $c_Lio_circe_KeyDecoder$AlwaysKeyDecoder)) {
    var x2 = $as_Lio_circe_KeyDecoder$AlwaysKeyDecoder(decodeK);
    var $$x1 = x2
  } else {
    var $$x1 = null
  };
  $thiz.Lio_circe_MapDecoder__f_alwaysDecodeK = $$x1;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_MapDecoder() {
  this.Lio_circe_MapDecoder__f_decodeK = null;
  this.Lio_circe_MapDecoder__f_decodeV = null;
  this.Lio_circe_MapDecoder__f_alwaysDecodeK = null
}
$c_Lio_circe_MapDecoder.prototype = new $h_O();
$c_Lio_circe_MapDecoder.prototype.constructor = $c_Lio_circe_MapDecoder;
/** @constructor */
function $h_Lio_circe_MapDecoder() {
  /*<skip>*/
}
$h_Lio_circe_MapDecoder.prototype = $c_Lio_circe_MapDecoder.prototype;
$c_Lio_circe_MapDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_MapDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JObject)) {
    var x2 = $as_Lio_circe_Json$JObject(x1);
    var obj = $n(x2).Lio_circe_Json$JObject__f_value;
    return $p_Lio_circe_MapDecoder__decodeJsonObject__Lio_circe_HCursor__Lio_circe_JsonObject__s_util_Either(this, c, obj)
  } else {
    return $m_Lio_circe_MapDecoder$().failureResult__Lio_circe_HCursor__s_util_Either(c)
  }
});
/** @constructor */
function $c_Lio_circe_Printer$ConstantPieces(pieces) {
  this.Lio_circe_Printer$ConstantPieces__f_pieces = null;
  this.Lio_circe_Printer$ConstantPieces__f_pieces = pieces
}
$c_Lio_circe_Printer$ConstantPieces.prototype = new $h_Lio_circe_Printer$PiecesAtDepth();
$c_Lio_circe_Printer$ConstantPieces.prototype.constructor = $c_Lio_circe_Printer$ConstantPieces;
/** @constructor */
function $h_Lio_circe_Printer$ConstantPieces() {
  /*<skip>*/
}
$h_Lio_circe_Printer$ConstantPieces.prototype = $c_Lio_circe_Printer$ConstantPieces.prototype;
$c_Lio_circe_Printer$ConstantPieces.prototype.apply__I__Lio_circe_Printer$Pieces = (function(i) {
  return this.Lio_circe_Printer$ConstantPieces__f_pieces
});
var $d_Lio_circe_Printer$ConstantPieces = new $TypeData().initClass({
  Lio_circe_Printer$ConstantPieces: 0
}, false, "io.circe.Printer$ConstantPieces", {
  Lio_circe_Printer$ConstantPieces: 1,
  Lio_circe_Printer$PiecesAtDepth: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Printer$ConstantPieces.prototype.$classData = $d_Lio_circe_Printer$ConstantPieces;
function $ct_Lio_circe_Printer$MemoizedPieces__T__($thiz, indent) {
  $thiz.Lio_circe_Printer$MemoizedPieces__f_indent = indent;
  $thiz.Lio_circe_Printer$MemoizedPieces__f_known = $ct_ju_concurrent_CopyOnWriteArrayList__AO__(new $c_ju_concurrent_CopyOnWriteArrayList(), new ($d_Lio_circe_Printer$Pieces.getArrayOf().constr)(128));
  return $thiz
}
/** @constructor */
function $c_Lio_circe_Printer$MemoizedPieces() {
  this.Lio_circe_Printer$MemoizedPieces__f_indent = null;
  this.Lio_circe_Printer$MemoizedPieces__f_known = null
}
$c_Lio_circe_Printer$MemoizedPieces.prototype = new $h_Lio_circe_Printer$PiecesAtDepth();
$c_Lio_circe_Printer$MemoizedPieces.prototype.constructor = $c_Lio_circe_Printer$MemoizedPieces;
/** @constructor */
function $h_Lio_circe_Printer$MemoizedPieces() {
  /*<skip>*/
}
$h_Lio_circe_Printer$MemoizedPieces.prototype = $c_Lio_circe_Printer$MemoizedPieces.prototype;
$c_Lio_circe_Printer$MemoizedPieces.prototype.addIndentation__jl_StringBuilder__T__I__V = (function(builder, s, depth) {
  var lastNewLineIndex = $f_T__lastIndexOf__I__I($n(s), 10);
  if ((lastNewLineIndex === (-1))) {
    var this$1 = $n(builder);
    this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s)
  } else {
    $n(builder).append__jl_CharSequence__I__I__jl_StringBuilder(s, 0, ((1 + lastNewLineIndex) | 0));
    var i = 0;
    while ((i < depth)) {
      var this$2 = $n(builder);
      var str = this.Lio_circe_Printer$MemoizedPieces__f_indent;
      this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      i = ((1 + i) | 0)
    };
    var $$x1 = $n(builder);
    var this$3 = $n(s);
    $n($$x1).append__jl_CharSequence__I__I__jl_StringBuilder(s, ((1 + lastNewLineIndex) | 0), this$3.length)
  }
});
$c_Lio_circe_Printer$MemoizedPieces.prototype.apply__I__Lio_circe_Printer$Pieces = (function(i) {
  if ((i >= 128)) {
    return this.compute__I__Lio_circe_Printer$Pieces(i)
  } else {
    var res = $as_Lio_circe_Printer$Pieces($n(this.Lio_circe_Printer$MemoizedPieces__f_known).get__I__O(i));
    if ((res !== null)) {
      return res
    } else {
      var tmp = this.compute__I__Lio_circe_Printer$Pieces(i);
      $n(this.Lio_circe_Printer$MemoizedPieces__f_known).set__I__O__O(i, tmp);
      return tmp
    }
  }
});
function $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__($thiz, writer, pieces, dropNullValues, escapeNonAscii, sortKeys) {
  $thiz.Lio_circe_Printer$PrintingFolder__f_writer = writer;
  $thiz.Lio_circe_Printer$PrintingFolder__f_pieces = pieces;
  $thiz.Lio_circe_Printer$PrintingFolder__f_dropNullValues = dropNullValues;
  $thiz.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = escapeNonAscii;
  $thiz.Lio_circe_Printer$PrintingFolder__f_sortKeys = sortKeys;
  $thiz.Lio_circe_Printer$PrintingFolder__f_depth = 0;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_Printer$PrintingFolder() {
  this.Lio_circe_Printer$PrintingFolder__f_writer = null;
  this.Lio_circe_Printer$PrintingFolder__f_pieces = null;
  this.Lio_circe_Printer$PrintingFolder__f_dropNullValues = false;
  this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = false;
  this.Lio_circe_Printer$PrintingFolder__f_sortKeys = false;
  this.Lio_circe_Printer$PrintingFolder__f_depth = 0
}
$c_Lio_circe_Printer$PrintingFolder.prototype = new $h_O();
$c_Lio_circe_Printer$PrintingFolder.prototype.constructor = $c_Lio_circe_Printer$PrintingFolder;
/** @constructor */
function $h_Lio_circe_Printer$PrintingFolder() {
  /*<skip>*/
}
$h_Lio_circe_Printer$PrintingFolder.prototype = $c_Lio_circe_Printer$PrintingFolder.prototype;
$c_Lio_circe_Printer$PrintingFolder.prototype.onString__T__V = (function(value) {
  $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__C__jl_Appendable(34);
  var i = 0;
  var offset = 0;
  while (true) {
    var $$x2 = i;
    var this$1 = $n(value);
    if (($$x2 < this$1.length)) {
      var this$2 = $n(value);
      var index = i;
      var c = $charAt(this$2, index);
      switch (c) {
        case 34: {
          var esc = 34;
          break
        }
        case 92: {
          var esc = 92;
          break
        }
        case 8: {
          var esc = 98;
          break
        }
        case 12: {
          var esc = 102;
          break
        }
        case 10: {
          var esc = 110;
          break
        }
        case 13: {
          var esc = 114;
          break
        }
        case 9: {
          var esc = 116;
          break
        }
        default: {
          if ((this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii && (c > 127))) {
            var $$x1 = true
          } else {
            var this$3 = $m_jl_Character$();
            var $$x1 = this$3.isISOControl__I__Z(c)
          };
          var esc = (65535 & ($$x1 ? 1 : 0))
        }
      };
      if ((esc !== 0)) {
        $n($n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__I__I__jl_Appendable(value, offset, i)).append__C__jl_Appendable(92);
        if ((esc !== 1)) {
          $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__C__jl_Appendable(esc)
        } else {
          $m_Lio_circe_Printer$().io$circe$Printer$$writeEscapedChar__jl_Appendable__C__V(this.Lio_circe_Printer$PrintingFolder__f_writer, c)
        };
        offset = ((1 + i) | 0)
      };
      i = ((1 + i) | 0)
    } else {
      break
    }
  };
  if ((offset < i)) {
    $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__I__I__jl_Appendable(value, offset, i)
  };
  $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__C__jl_Appendable(34)
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onArray__sci_Vector__V = (function(value) {
  var orig = this.Lio_circe_Printer$PrintingFolder__f_depth;
  var p = $n(this.Lio_circe_Printer$PrintingFolder__f_pieces).apply__I__Lio_circe_Printer$Pieces(this.Lio_circe_Printer$PrintingFolder__f_depth);
  var this$1 = $n(value);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_lrEmptyBrackets)
  } else {
    var iterator = $n(value).iterator__sc_Iterator();
    $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_lBrackets);
    this.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + this.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
    $n($as_Lio_circe_Json($n(iterator).next__O())).foldWith__Lio_circe_Json$Folder__O(this);
    this.Lio_circe_Printer$PrintingFolder__f_depth = orig;
    while ($n(iterator).hasNext__Z()) {
      $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_arrayCommas);
      this.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + this.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      $n($as_Lio_circe_Json($n(iterator).next__O())).foldWith__Lio_circe_Json$Folder__O(this);
      this.Lio_circe_Printer$PrintingFolder__f_depth = orig
    };
    $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_rBrackets)
  }
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onObject__Lio_circe_JsonObject__O = (function(value) {
  $n(value).appendToFolder__Lio_circe_Printer$PrintingFolder__V(this)
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onArray__sci_Vector__O = (function(value) {
  this.onArray__sci_Vector__V(value)
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onString__T__O = (function(value) {
  this.onString__T__V(value)
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onNull__O = (function() {
  $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable("null")
});
function $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__($thiz, decodeA) {
  $thiz.Lio_circe_SeqDecoder__f_decodeA = decodeA;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_SeqDecoder() {
  this.Lio_circe_SeqDecoder__f_decodeA = null
}
$c_Lio_circe_SeqDecoder.prototype = new $h_O();
$c_Lio_circe_SeqDecoder.prototype.constructor = $c_Lio_circe_SeqDecoder;
/** @constructor */
function $h_Lio_circe_SeqDecoder() {
  /*<skip>*/
}
$h_Lio_circe_SeqDecoder.prototype = $c_Lio_circe_SeqDecoder.prototype;
$c_Lio_circe_SeqDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_SeqDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var current = $n(c).downArray__Lio_circe_ACursor();
  if ($n(current).succeeded__Z()) {
    var builder = this.createBuilder__scm_Builder();
    var failed = null;
    while (((failed === null) && $n(current).succeeded__Z())) {
      var x1 = $n(this.Lio_circe_SeqDecoder__f_decodeA).apply__Lio_circe_HCursor__s_util_Either($as_Lio_circe_HCursor(current));
      if ((x1 instanceof $c_s_util_Left)) {
        var x2 = $as_s_util_Left(x1);
        var e = $as_Lio_circe_DecodingFailure($n(x2).s_util_Left__f_value);
        failed = e
      } else if ((x1 instanceof $c_s_util_Right)) {
        var x3 = $as_s_util_Right(x1);
        var a = $n(x3).s_util_Right__f_value;
        var this$1 = $n(builder);
        this$1.addOne__O__scm_Growable(a);
        current = $n(current).right__Lio_circe_ACursor()
      } else {
        throw new $c_s_MatchError(x1)
      }
    };
    if ((failed === null)) {
      $n($m_s_package$().s_package$__f_Right);
      var value = $n(builder).result__O();
      return new $c_s_util_Right(value)
    } else {
      $n($m_s_package$().s_package$__f_Left);
      var value$1 = failed;
      return new $c_s_util_Left(value$1)
    }
  } else if ($n($n(c).value__Lio_circe_Json()).isArray__Z()) {
    $n($m_s_package$().s_package$__f_Right);
    var value$2 = $n(this.createBuilder__scm_Builder()).result__O();
    return new $c_s_util_Right(value$2)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value$3 = new $c_Lio_circe_DecodingFailure$$anon$2("C[A]", ops);
    return new $c_s_util_Left(value$3)
  }
});
/** @constructor */
function $c_Lio_circe_TupleDecoders$$anon$2(outer, decodeA0$2, decodeA1$1) {
  this.Lio_circe_TupleDecoders$$anon$2__f_decodeA0$2 = null;
  this.Lio_circe_TupleDecoders$$anon$2__f_decodeA1$1 = null;
  this.Lio_circe_TupleDecoders$$anon$2__f_decodeA0$2 = decodeA0$2;
  this.Lio_circe_TupleDecoders$$anon$2__f_decodeA1$1 = decodeA1$1
}
$c_Lio_circe_TupleDecoders$$anon$2.prototype = new $h_O();
$c_Lio_circe_TupleDecoders$$anon$2.prototype.constructor = $c_Lio_circe_TupleDecoders$$anon$2;
/** @constructor */
function $h_Lio_circe_TupleDecoders$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_TupleDecoders$$anon$2.prototype = $c_Lio_circe_TupleDecoders$$anon$2.prototype;
$c_Lio_circe_TupleDecoders$$anon$2.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_TupleDecoders$$anon$2.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JArray)) {
    var x2 = $as_Lio_circe_Json$JArray(x1);
    var values = $n(x2).Lio_circe_Json$JArray__f_value;
    var this$1 = $n(values);
    if ((this$1.length__I() === 2)) {
      var this$2 = $n($m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance);
      var f1 = $n(this.Lio_circe_TupleDecoders$$anon$2__f_decodeA0$2).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downN__I__Lio_circe_ACursor(0));
      var f2 = $n(this.Lio_circe_TupleDecoders$$anon$2__f_decodeA1$1).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downN__I__Lio_circe_ACursor(1));
      var this$3 = $m_Lcats_Semigroupal$();
      return $as_s_util_Either($f_Lcats_SemigroupalArityFunctions__tuple2__O__O__Lcats_Semigroupal__Lcats_Invariant__O(this$3, f1, f2, this$2, this$2))
    }
  };
  $n($m_s_package$().s_package$__f_Left);
  $m_Lio_circe_DecodingFailure$();
  var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
  var value = new $c_Lio_circe_DecodingFailure$$anon$2("(A0, A1)", ops);
  return new $c_s_util_Left(value)
});
var $d_Lio_circe_TupleDecoders$$anon$2 = new $TypeData().initClass({
  Lio_circe_TupleDecoders$$anon$2: 0
}, false, "io.circe.TupleDecoders$$anon$2", {
  Lio_circe_TupleDecoders$$anon$2: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_TupleDecoders$$anon$2.prototype.$classData = $d_Lio_circe_TupleDecoders$$anon$2;
/** @constructor */
function $c_Lio_circe_generic_decoding_DerivedDecoder() {
  /*<skip>*/
}
$c_Lio_circe_generic_decoding_DerivedDecoder.prototype = new $h_O();
$c_Lio_circe_generic_decoding_DerivedDecoder.prototype.constructor = $c_Lio_circe_generic_decoding_DerivedDecoder;
/** @constructor */
function $h_Lio_circe_generic_decoding_DerivedDecoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_decoding_DerivedDecoder.prototype = $c_Lio_circe_generic_decoding_DerivedDecoder.prototype;
$c_Lio_circe_generic_decoding_DerivedDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
function $as_Lio_circe_generic_decoding_DerivedDecoder(obj) {
  return (((obj instanceof $c_Lio_circe_generic_decoding_DerivedDecoder) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.generic.decoding.DerivedDecoder"))
}
function $isArrayOf_Lio_circe_generic_decoding_DerivedDecoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_generic_decoding_DerivedDecoder)))
}
function $asArrayOf_Lio_circe_generic_decoding_DerivedDecoder(obj, depth) {
  return (($isArrayOf_Lio_circe_generic_decoding_DerivedDecoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.generic.decoding.DerivedDecoder;", depth))
}
/** @constructor */
function $c_Lio_circe_generic_decoding_ReprDecoder() {
  /*<skip>*/
}
$c_Lio_circe_generic_decoding_ReprDecoder.prototype = new $h_O();
$c_Lio_circe_generic_decoding_ReprDecoder.prototype.constructor = $c_Lio_circe_generic_decoding_ReprDecoder;
/** @constructor */
function $h_Lio_circe_generic_decoding_ReprDecoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_decoding_ReprDecoder.prototype = $c_Lio_circe_generic_decoding_ReprDecoder.prototype;
$c_Lio_circe_generic_decoding_ReprDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$() {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$.prototype = new $h_O();
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$.prototype = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$.prototype;
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$.prototype.decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder = (function(gen, decodeR, defaults, defaultMapper, config, fields, fieldsToList, keys, keysToList) {
  if ($n(config).Lio_circe_generic_extras_Configuration__f_useDefaults) {
    var $$x1 = $n(defaultMapper);
    var this$1 = $n(defaults);
    var defaultMap = $n($$x1).apply__Lshapeless_HList__sci_Map(this$1.apply__Lshapeless_HList())
  } else {
    var defaultMap = $m_sci_Map$EmptyMap$()
  };
  var this$3 = $n(fieldsToList);
  var l = $as_Lshapeless_HList($n(fields).apply__O());
  var this$5 = $n($as_sci_List($f_Lshapeless_ops_hlist$ToTraversable__apply__Lshapeless_HList__O(this$3, l)));
  var f = ((x$2$2) => {
    var x$2 = $as_s_Symbol(x$2$2);
    return $n(x$2).s_Symbol__f_name
  });
  if ((this$5 === $m_sci_Nil$())) {
    var keyNames = $m_sci_Nil$()
  } else {
    var arg1 = this$5.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$5.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var keyNames = h
  };
  var this$8 = $n(keyNames);
  var this$7 = $n(keysToList);
  var this$6 = $n(keys);
  var l$1 = this$6.apply__Lshapeless_HList();
  var that = $as_sc_IterableOnce($f_Lshapeless_ops_hlist$ToTraversable__apply__Lshapeless_HList__O(this$7, l$1));
  var this$10 = $n($n($as_sci_List($f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this$8, that))).collect__s_PartialFunction__sci_List(new $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1()));
  var this$9 = $m_s_$less$colon$less$();
  var keyAnnotationMap = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$10);
  if ($n(config).Lio_circe_generic_extras_Configuration__f_strictDecoding) {
    var t$1 = new $c_sjsr_AnonFunction0((() => $as_Lio_circe_generic_extras_decoding_ReprDecoder($n(decodeR).value__O())));
    return new $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder(gen, new $c_Lshapeless_Lazy$$anon$1(t$1), config, defaultMap, keyNames, keyAnnotationMap)
  } else {
    var t$2 = new $c_sjsr_AnonFunction0((() => $as_Lio_circe_generic_extras_decoding_ReprDecoder($n(decodeR).value__O())));
    return new $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder(gen, new $c_Lshapeless_Lazy$$anon$1(t$2), config, defaultMap, keyAnnotationMap)
  }
});
var $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$ = new $TypeData().initClass({
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$: 0
}, false, "io.circe.generic.extras.decoding.ConfiguredDecoder$", {
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$: 1,
  O: 1,
  Lio_circe_generic_extras_decoding_IncompleteConfiguredDecoders: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$.prototype.$classData = $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$;
var $n_Lio_circe_generic_extras_decoding_ConfiguredDecoder$;
function $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$() {
  if ((!$n_Lio_circe_generic_extras_decoding_ConfiguredDecoder$)) {
    $n_Lio_circe_generic_extras_decoding_ConfiguredDecoder$ = new $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$()
  };
  return $n_Lio_circe_generic_extras_decoding_ConfiguredDecoder$
}
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ReprDecoder() {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_decoding_ReprDecoder.prototype = new $h_O();
$c_Lio_circe_generic_extras_decoding_ReprDecoder.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ReprDecoder;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ReprDecoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ReprDecoder.prototype = $c_Lio_circe_generic_extras_decoding_ReprDecoder.prototype;
$c_Lio_circe_generic_extras_decoding_ReprDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
$c_Lio_circe_generic_extras_decoding_ReprDecoder.prototype.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either = (function(c, decoder, name, defaults) {
  var x1 = $n(decoder).tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    if ((x2 !== $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_keyMissingNone)) {
      return x2
    }
  };
  if ((x1 instanceof $c_s_util_Left)) {
    var x4 = $as_s_util_Left(x1);
    if (($n(c).succeeded__Z() && (!$n($n(c).focus__s_Option()).contains__O__Z($m_Lio_circe_Json$JNull$())))) {
      return x4
    }
  };
  var x1$2 = $n(defaults).get__O__s_Option(name);
  if ((x1$2 instanceof $c_s_Some)) {
    var x2$2 = $as_s_Some(x1$2);
    var d = $n(x2$2).s_Some__f_value;
    if ((d !== null)) {
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(d)
    }
  };
  return x1
});
$c_Lio_circe_generic_extras_decoding_ReprDecoder.prototype.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option = (function(decode, c, name, discriminator) {
  var x = $m_s_None$();
  if ((x === discriminator)) {
    var result = $n(c).downField__T__Lio_circe_ACursor(name);
    return ($n(result).succeeded__Z() ? new $c_s_Some($n(decode).tryDecode__Lio_circe_ACursor__s_util_Either(result)) : $m_s_None$())
  } else if ((discriminator instanceof $c_s_Some)) {
    var x2 = $as_s_Some(discriminator);
    var disc = $as_T($n(x2).s_Some__f_value);
    var rc8 = false;
    var x2$2 = null;
    var x1$2 = $n(c).get__T__Lio_circe_Decoder__s_util_Either(disc, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString);
    if ((x1$2 instanceof $c_s_util_Right)) {
      rc8 = true;
      x2$2 = $as_s_util_Right(x1$2);
      var leafType = $as_T($n(x2$2).s_util_Right__f_value);
      if ((leafType === name)) {
        return new $c_s_Some($n(decode).apply__Lio_circe_HCursor__s_util_Either(c))
      }
    };
    if (rc8) {
      return $m_s_None$()
    };
    if ((x1$2 instanceof $c_s_util_Left)) {
      var x5 = $as_s_util_Left(x1$2);
      return new $c_s_Some(x5)
    };
    throw new $c_s_MatchError(x1$2)
  } else {
    throw new $c_s_MatchError(discriminator)
  }
});
$c_Lio_circe_generic_extras_decoding_ReprDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either(c, new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return x
  })), new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_T(x$3$2);
    return x$3
  })), $m_sci_Map$EmptyMap$(), $m_s_None$())
});
function $as_Lio_circe_generic_extras_decoding_ReprDecoder(obj) {
  return (((obj instanceof $c_Lio_circe_generic_extras_decoding_ReprDecoder) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.generic.extras.decoding.ReprDecoder"))
}
function $isArrayOf_Lio_circe_generic_extras_decoding_ReprDecoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_generic_extras_decoding_ReprDecoder)))
}
function $asArrayOf_Lio_circe_generic_extras_decoding_ReprDecoder(obj, depth) {
  return (($isArrayOf_Lio_circe_generic_extras_decoding_ReprDecoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.generic.extras.decoding.ReprDecoder;", depth))
}
function $ct_Lio_circe_numbers_BiggerDecimal$Zero__($thiz) {
  $thiz.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = new $c_s_Some($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO);
  $thiz.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = new $c_s_Some($L0);
  return $thiz
}
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$Zero() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null
}
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype = new $h_Lio_circe_numbers_BiggerDecimal();
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$Zero;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$Zero() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal$Zero.prototype = $c_Lio_circe_numbers_BiggerDecimal$Zero.prototype;
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.toBigDecimal__s_Option = (function() {
  return this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal
});
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option = (function(maxDigits) {
  return new $c_s_Some($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO)
});
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.toLong__s_Option = (function() {
  return this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong
});
function $as_Lio_circe_numbers_BiggerDecimal$Zero(obj) {
  return (((obj instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.numbers.BiggerDecimal$Zero"))
}
function $isArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_numbers_BiggerDecimal$Zero)))
}
function $asArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) {
  return (($isArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.numbers.BiggerDecimal$Zero;", depth))
}
/** @constructor */
function $c_Lio_circe_numbers_SigAndExp(unscaled, scale) {
  this.Lio_circe_numbers_SigAndExp__f_unscaled = null;
  this.Lio_circe_numbers_SigAndExp__f_scale = null;
  this.Lio_circe_numbers_SigAndExp__f_unscaled = unscaled;
  this.Lio_circe_numbers_SigAndExp__f_scale = scale
}
$c_Lio_circe_numbers_SigAndExp.prototype = new $h_Lio_circe_numbers_BiggerDecimal();
$c_Lio_circe_numbers_SigAndExp.prototype.constructor = $c_Lio_circe_numbers_SigAndExp;
/** @constructor */
function $h_Lio_circe_numbers_SigAndExp() {
  /*<skip>*/
}
$h_Lio_circe_numbers_SigAndExp.prototype = $c_Lio_circe_numbers_SigAndExp.prototype;
$c_Lio_circe_numbers_SigAndExp.prototype.isWhole__Z = (function() {
  var this$1 = $n(this.Lio_circe_numbers_SigAndExp__f_scale);
  return (this$1.Ljava_math_BigInteger__f_sign < 1)
});
$c_Lio_circe_numbers_SigAndExp.prototype.toBigDecimal__s_Option = (function() {
  return ((($n(this.Lio_circe_numbers_SigAndExp__f_scale).compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxInt) <= 0) && ($n(this.Lio_circe_numbers_SigAndExp__f_scale).compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MinInt) >= 0)) ? new $c_s_Some($ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.Lio_circe_numbers_SigAndExp__f_unscaled, $n(this.Lio_circe_numbers_SigAndExp__f_scale).intValue__I())) : $m_s_None$())
});
$c_Lio_circe_numbers_SigAndExp.prototype.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option = (function(maxDigits) {
  if ((!this.isWhole__Z())) {
    return $m_s_None$()
  } else {
    var this$1 = $n($n(this.Lio_circe_numbers_SigAndExp__f_unscaled).abs__Ljava_math_BigInteger());
    var this$2 = $n($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1));
    var value = this$2.length;
    var hi = (value >> 31);
    var this$4 = $n($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(value, hi)));
    var bi = this.Lio_circe_numbers_SigAndExp__f_scale;
    var digits = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi);
    return (($n(digits).compareTo__Ljava_math_BigInteger__I(maxDigits) > 0) ? $m_s_None$() : new $c_s_Some($ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.Lio_circe_numbers_SigAndExp__f_unscaled, $n(this.Lio_circe_numbers_SigAndExp__f_scale).intValue__I()).toBigInteger__Ljava_math_BigInteger()))
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.toDouble__D = (function() {
  if ((($n(this.Lio_circe_numbers_SigAndExp__f_scale).compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxInt) <= 0) && ($n(this.Lio_circe_numbers_SigAndExp__f_scale).compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MinInt) >= 0))) {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.Lio_circe_numbers_SigAndExp__f_unscaled, $n(this.Lio_circe_numbers_SigAndExp__f_scale).intValue__I()).doubleValue__D()
  } else {
    var this$1 = $n(this.Lio_circe_numbers_SigAndExp__f_scale);
    if ((this$1.Ljava_math_BigInteger__f_sign === 1)) {
      var $$x1 = 0.0
    } else {
      var $$x1 = Infinity
    };
    var this$2 = $n(this.Lio_circe_numbers_SigAndExp__f_unscaled);
    return ($$x1 * this$2.Ljava_math_BigInteger__f_sign)
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.toFloat__F = (function() {
  if ((($n(this.Lio_circe_numbers_SigAndExp__f_scale).compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxInt) <= 0) && ($n(this.Lio_circe_numbers_SigAndExp__f_scale).compareTo__Ljava_math_BigInteger__I($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MinInt) >= 0))) {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.Lio_circe_numbers_SigAndExp__f_unscaled, $n(this.Lio_circe_numbers_SigAndExp__f_scale).intValue__I()).floatValue__F()
  } else {
    var this$1 = $n(this.Lio_circe_numbers_SigAndExp__f_scale);
    if ((this$1.Ljava_math_BigInteger__f_sign === 1)) {
      var $$x1 = 0.0
    } else {
      var $$x1 = Infinity
    };
    var this$2 = $n(this.Lio_circe_numbers_SigAndExp__f_unscaled);
    return Math.fround(($$x1 * Math.fround(this$2.Ljava_math_BigInteger__f_sign)))
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.toLong__s_Option = (function() {
  if ((!this.isWhole__Z())) {
    return $m_s_None$()
  } else {
    var x1 = this.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits);
    if ((x1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x1);
      var i = $as_Ljava_math_BigInteger($n(x2).s_Some__f_value);
      var t = $n(i).longValue__J();
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var xn = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi));
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, i)) {
        return new $c_s_Some(new $c_RTLong(lo, hi))
      } else {
        return $m_s_None$()
      }
    } else {
      var x = $m_s_None$();
      if ((x === x1)) {
        return $m_s_None$()
      } else {
        throw new $c_s_MatchError(x1)
      }
    }
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_SigAndExp)) {
    var x2 = $as_Lio_circe_numbers_SigAndExp(that);
    var xn = this.Lio_circe_numbers_SigAndExp__f_unscaled;
    var yn = $n(x2).Lio_circe_numbers_SigAndExp__f_unscaled;
    if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)) {
      var xn$1 = this.Lio_circe_numbers_SigAndExp__f_scale;
      var yn$1 = $n(x2).Lio_circe_numbers_SigAndExp__f_scale;
      return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn$1, yn$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.hashCode__I = (function() {
  return (($n(this.Lio_circe_numbers_SigAndExp__f_scale).hashCode__I() + $n(this.Lio_circe_numbers_SigAndExp__f_unscaled).hashCode__I()) | 0)
});
$c_Lio_circe_numbers_SigAndExp.prototype.toString__T = (function() {
  var xn = this.Lio_circe_numbers_SigAndExp__f_scale;
  var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)) {
    var this$1 = $n(this.Lio_circe_numbers_SigAndExp__f_unscaled);
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1)
  } else {
    return ((this.Lio_circe_numbers_SigAndExp__f_unscaled + "e") + $n(this.Lio_circe_numbers_SigAndExp__f_scale).negate__Ljava_math_BigInteger())
  }
});
function $as_Lio_circe_numbers_SigAndExp(obj) {
  return (((obj instanceof $c_Lio_circe_numbers_SigAndExp) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.numbers.SigAndExp"))
}
function $isArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_numbers_SigAndExp)))
}
function $asArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) {
  return (($isArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.numbers.SigAndExp;", depth))
}
var $d_Lio_circe_numbers_SigAndExp = new $TypeData().initClass({
  Lio_circe_numbers_SigAndExp: 0
}, false, "io.circe.numbers.SigAndExp", {
  Lio_circe_numbers_SigAndExp: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_numbers_SigAndExp.prototype.$classData = $d_Lio_circe_numbers_SigAndExp;
/** @constructor */
function $c_Lio_circe_parser_package$() {
  /*<skip>*/
}
$c_Lio_circe_parser_package$.prototype = new $h_O();
$c_Lio_circe_parser_package$.prototype.constructor = $c_Lio_circe_parser_package$;
/** @constructor */
function $h_Lio_circe_parser_package$() {
  /*<skip>*/
}
$h_Lio_circe_parser_package$.prototype = $c_Lio_circe_parser_package$.prototype;
$c_Lio_circe_parser_package$.prototype.parse__T__s_util_Either = (function(input) {
  try {
    var x1 = $m_Lio_circe_scalajs_package$().convertJsToJson__sjs_js_Any__s_util_Either(JSON.parse(input))
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    matchEnd8: {
      var x1;
      var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(o11).isEmpty__Z())) {
        var exception = $as_jl_Throwable($n(o11).get__O());
        $n($m_s_package$().s_package$__f_Left);
        var value = new $c_Lio_circe_ParsingFailure($n(exception).getMessage__T(), exception);
        var x1 = new $c_s_util_Left(value);
        break matchEnd8
      };
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
    }
  };
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    return x2
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x4$2 = $as_s_util_Left(x1);
    var exception$2 = $as_jl_Throwable($n(x4$2).s_util_Left__f_value);
    $n($m_s_package$().s_package$__f_Left);
    var value$1 = new $c_Lio_circe_ParsingFailure($n(exception$2).getMessage__T(), exception$2);
    return new $c_s_util_Left(value$1)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lio_circe_parser_package$ = new $TypeData().initClass({
  Lio_circe_parser_package$: 0
}, false, "io.circe.parser.package$", {
  Lio_circe_parser_package$: 1,
  O: 1,
  Lio_circe_Parser: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_parser_package$.prototype.$classData = $d_Lio_circe_parser_package$;
var $n_Lio_circe_parser_package$;
function $m_Lio_circe_parser_package$() {
  if ((!$n_Lio_circe_parser_package$)) {
    $n_Lio_circe_parser_package$ = new $c_Lio_circe_parser_package$()
  };
  return $n_Lio_circe_parser_package$
}
function $p_Ljapgolly_scalajs_react_Reusability$__go$1__sc_Iterator__sc_Iterator__F2__Z($thiz, i$1, j$1, evidence$1$1) {
  while (true) {
    var hasNext = $n(i$1).hasNext__Z();
    if ((hasNext === $n(j$1).hasNext__Z())) {
      if ((!hasNext)) {
        return true
      } else {
        $m_Ljapgolly_scalajs_react_internal_CoreGeneral$();
        var a = $n(i$1).next__O();
        var a$1 = $n(j$1).next__O();
        if ((!$uZ($n(evidence$1$1).apply__O__O__O(a, a$1)))) {
          return false
        }
      }
    } else {
      return false
    }
  }
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Reusability$() {
  this.Ljapgolly_scalajs_react_Reusability$__f_alwaysInstance = null;
  this.Ljapgolly_scalajs_react_Reusability$__f_neverInstance = null;
  $n_Ljapgolly_scalajs_react_Reusability$ = this;
  var f = new $c_sjsr_AnonFunction2(((x$5$2, x$6$2) => true));
  this.Ljapgolly_scalajs_react_Reusability$__f_alwaysInstance = f;
  var f$1 = new $c_sjsr_AnonFunction2(((x$7$2, x$8$2) => false));
  this.Ljapgolly_scalajs_react_Reusability$__f_neverInstance = f$1
}
$c_Ljapgolly_scalajs_react_Reusability$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_Reusability$.prototype.constructor = $c_Ljapgolly_scalajs_react_Reusability$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Reusability$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Reusability$.prototype = $c_Ljapgolly_scalajs_react_Reusability$.prototype;
$c_Ljapgolly_scalajs_react_Reusability$.prototype.always__F2 = (function() {
  var ev$1 = new $c_Ljapgolly_scalajs_react_Reusability(this.Ljapgolly_scalajs_react_Reusability$__f_alwaysInstance);
  return ev$1.Ljapgolly_scalajs_react_Reusability__f_test
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.never__F2 = (function() {
  var ev$1 = new $c_Ljapgolly_scalajs_react_Reusability(this.Ljapgolly_scalajs_react_Reusability$__f_neverInstance);
  return ev$1.Ljapgolly_scalajs_react_Reusability__f_test
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.byRef__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((a$2, b$2) => Object.is(a$2, b$2)))
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.by_$eq$eq__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((a$2, b$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(a$2, b$2)))
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.byIterator__F2__F2 = (function(evidence$1) {
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $as_sc_Iterable(x$2);
    var y = $as_sc_Iterable(y$2);
    var i = $n(x).iterator__sc_Iterator();
    var j = $n(y).iterator__sc_Iterator();
    return $p_Ljapgolly_scalajs_react_Reusability$__go$1__sc_Iterator__sc_Iterator__F2__Z(this, i, j, evidence$1)
  }));
  return f
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.double__D__F2 = (function(tolerance) {
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $uD(x$2);
    var y = $uD(y$2);
    var x$1 = (x - y);
    return ($uD(Math.abs(x$1)) <= tolerance)
  }));
  return f
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2 = (function(o, r) {
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => $uZ($n(o).fold__O__F0__F1__O(x$2, new $c_sjsr_AnonFunction0((() => $n(o).isEmpty__O__Z(y$2))), new $c_sjsr_AnonFunction1(((xa$2) => $uZ($n(o).fold__O__F0__F1__O(y$2, new $c_sjsr_AnonFunction0((() => false)), new $c_sjsr_AnonFunction1(((ya$2) => {
    $m_Ljapgolly_scalajs_react_internal_CoreGeneral$();
    return $uZ($n(r).apply__O__O__O(xa$2, ya$2))
  }))))))))));
  return f
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.list__F2__F2 = (function(evidence$6) {
  return $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this.byRef__F2(), this.byIterator__F2__F2(evidence$6))
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.box__F2__F2 = (function(evidence$9) {
  var f = new $c_sjsr_AnonFunction1(((x$21$2) => x$21$2.a));
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(evidence$9, f)
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.tuple2__F2__F2__F2 = (function(evidence$10, evidence$11) {
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => {
    var x = $as_T2(x$2);
    var y = $as_T2(y$2);
    $m_Ljapgolly_scalajs_react_internal_CoreGeneral$();
    var a = $n(x)._1__O();
    var a$1 = $n(y)._1__O();
    if ($uZ($n(evidence$10).apply__O__O__O(a, a$1))) {
      $m_Ljapgolly_scalajs_react_internal_CoreGeneral$();
      var a$2 = $n(x)._2__O();
      var a$3 = $n(y)._2__O();
      return $uZ($n(evidence$11).apply__O__O__O(a$2, a$3))
    } else {
      return false
    }
  }));
  return f
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.shouldComponentUpdateAnd__F1__F2__F2__Ljapgolly_scalajs_react_util_Effect$Sync__F1 = (function(f, evidence$262, evidence$263, G) {
  return new $c_sjsr_AnonFunction1(((x$27$2) => {
    var x$27 = $as_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(x$27$2);
    return $n(x$27).shouldComponentUpdate__F1__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((i$2) => {
      var i = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate(i$2);
      var r = new $c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult(i, evidence$262, evidence$263);
      var g = $n(f).apply__O__O(r);
      $n(G);
      var f$1 = new $c_sjsr_AnonFunction1(((x$28$2) => {
        $as_jl_Void(x$28$2);
        return r.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_update
      }));
      var fa = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(g)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$4 = $n(fa);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$4, f$1))
    })), G)
  }))
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.contramap$extension__F2__F1__F2 = (function(this$, f) {
  return new $c_sjsr_AnonFunction2(((x$2, y$2) => $uZ($n(this$).apply__O__O__O($n(f).apply__O__O(x$2), $n(f).apply__O__O(y$2)))))
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.testNot$extension__F2__F2 = (function(this$) {
  return new $c_sjsr_AnonFunction2(((x$1$2, x$2$2) => (!$uZ($n(this$).apply__O__O__O(x$1$2, x$2$2)))))
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.$bar$bar$extension__F2__F2__F2 = (function(this$, tryNext) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction2(((x$2, y$2) => ($uZ($n(this$).apply__O__O__O(x$2, y$2)) || $uZ($n(tryNext).apply__O__O__O(x$2, y$2)))));
  return f
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.equals$extension__F2__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_Reusability)) {
    var Reusability$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_Reusability(x$1)).Ljapgolly_scalajs_react_Reusability__f_test);
    if ((this$ === null)) {
      return (Reusability$1 === null)
    } else {
      var this$1 = $n(this$);
      return (this$1 === Reusability$1)
    }
  } else {
    return false
  }
});
var $d_Ljapgolly_scalajs_react_Reusability$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Reusability$: 0
}, false, "japgolly.scalajs.react.Reusability$", {
  Ljapgolly_scalajs_react_Reusability$: 1,
  O: 1,
  Ljapgolly_scalajs_react_ReusabilityMacros: 1,
  Ljapgolly_scalajs_react_ScalaVersionSpecificReusability: 1
});
$c_Ljapgolly_scalajs_react_Reusability$.prototype.$classData = $d_Ljapgolly_scalajs_react_Reusability$;
var $n_Ljapgolly_scalajs_react_Reusability$;
function $m_Ljapgolly_scalajs_react_Reusability$() {
  if ((!$n_Ljapgolly_scalajs_react_Reusability$)) {
    $n_Ljapgolly_scalajs_react_Reusability$ = new $c_Ljapgolly_scalajs_react_Reusability$()
  };
  return $n_Ljapgolly_scalajs_react_Reusability$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1(f) {
  this.Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1__f_f = null;
  this.Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1__f_f = f
}
$c_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1.prototype = new $h_sr_AbstractFunction1();
$c_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1.prototype.constructor = $c_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1.prototype = $c_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1.prototype;
$c_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1.prototype.apply__O__O = (function(a) {
  return $n(this.Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1__f_f).apply__O__O(a)
});
function $as_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.Reusable$FnInternals$Fn1"))
}
function $isArrayOf_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1)))
}
function $asArrayOf_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.Reusable$FnInternals$Fn1;", depth))
}
var $d_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1: 0
}, false, "japgolly.scalajs.react.Reusable$FnInternals$Fn1", {
  Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1.prototype.$classData = $d_Ljapgolly_scalajs_react_Reusable$FnInternals$Fn1;
function $is_Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot)))
}
function $as_Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot(obj) {
  return (($is_Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.Generic$UnmountedWithRoot"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.Generic$UnmountedWithRoot;", depth))
}
function $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__logger__F0__O($thiz, s) {
  $n($n($thiz.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var f = $n($n($thiz.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_logger).apply__O__O(s);
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().fromJsFn__sjs_js_Function0__Ljapgolly_scalajs_react_callback_Trampoline(f))
}
function $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__cmdOrPure__s_util_Either__Ljapgolly_scalajs_react_extra_router_RouteCmd($thiz, e) {
  var this$2 = $n(e);
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var fa = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var $$x1 = new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return(b)
  } else {
    if ((!(this$2 instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(this$2)
    };
    var x3 = $as_s_util_Left(this$2);
    var a = $n(x3).s_util_Left__f_value;
    var $$x1 = $n(fa).apply__O__O(a)
  };
  return $as_Ljapgolly_scalajs_react_extra_router_RouteCmd($$x1)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterLogicF(baseUrl, cfg) {
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_syncToWindowUrl = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_ctlByPath = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_ctl = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl = baseUrl;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg = cfg;
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this);
  $n($n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  $n($n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var a = new $c_sjsr_AnonFunction0((() => $m_Ljapgolly_scalajs_react_extra_router_AbsUrl$().fromWindow__Ljapgolly_scalajs_react_extra_router_AbsUrl()));
  var fa$10 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)));
  var f$5 = new $c_sjsr_AnonFunction1(((url$2) => {
    var url = $as_Ljapgolly_scalajs_react_extra_router_AbsUrl(url$2);
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var fa$8 = $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__logger__F0__O(this, new $c_sjsr_AnonFunction0((() => (("Syncing to " + url) + "."))));
    var f$4 = new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_jl_Void(x$5$2);
      $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
      var fa$6 = this.syncToUrl__Ljapgolly_scalajs_react_extra_router_AbsUrl__O(url);
      var f$3 = new $c_sjsr_AnonFunction1(((cmd$2) => {
        var cmd = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd(cmd$2);
        $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
        var fa$4 = this.interpret__Ljapgolly_scalajs_react_extra_router_RouteCmd__O(cmd);
        var f$2 = new $c_sjsr_AnonFunction1(((res$2) => {
          var res = $as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(res$2);
          $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
          var fa$2 = $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__logger__F0__O(this, new $c_sjsr_AnonFunction0((() => (("Resolved to page " + $n(res).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page) + "."))));
          var f$1 = new $c_sjsr_AnonFunction1(((x$6$2) => {
            $as_jl_Void(x$6$2);
            $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
            var fa = $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__logger__F0__O(this, new $c_sjsr_AnonFunction0((() => "")));
            var f = new $c_sjsr_AnonFunction1(((x$7$2) => {
              $as_jl_Void(x$7$2);
              return res
            }));
            var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var this$7 = $n(fa$1);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$7, f))
          }));
          var fa$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$3, f$1))
        }));
        var fa$5 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$4)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$5, f$2))
      }));
      var fa$7 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$6)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$7, f$3))
    }));
    var fa$9 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$8)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$9, f$4))
  }));
  var fa$11 = fa$10.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_syncToWindowUrl = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$11, f$5));
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_ctlByPath = new $c_Ljapgolly_scalajs_react_extra_router_RouterLogicF$$anon$1(this);
  var this$13 = $n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_ctlByPath);
  var f$6 = $n($n(cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules).Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_path;
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_ctl = new $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(this$13, f$6, this$13.F__Ljapgolly_scalajs_react_util_Effect$Sync())
}
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterLogicF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterLogicF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners__sci_List = (function() {
  return this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners_$eq__sci_List__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = x$1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  return $n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.syncToUrl__Ljapgolly_scalajs_react_extra_router_AbsUrl__O = (function(url) {
  var x1 = this.parseUrl__Ljapgolly_scalajs_react_extra_router_AbsUrl__s_Option(url);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var path = $as_Ljapgolly_scalajs_react_extra_router_Path($n(x2).s_Some__f_value);
    return this.syncToPath__Ljapgolly_scalajs_react_extra_router_Path__O(path)
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return this.wrongBase__Ljapgolly_scalajs_react_extra_router_AbsUrl__O(url)
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.wrongBase__Ljapgolly_scalajs_react_extra_router_AbsUrl__O = (function(wrongUrl) {
  var root = new $c_Ljapgolly_scalajs_react_extra_router_Path("");
  $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var fa = this.redirectToPath__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(root, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$());
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd(x$2);
    var msg = new $c_sjsr_AnonFunction0((() => {
      var base = this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl;
      return (((("Wrong base: " + wrongUrl) + " is outside of ") + $n(base).apply__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_AbsUrl(root)) + ".")
    }));
    return new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(msg).$greater$greater__Ljapgolly_scalajs_react_extra_router_RouteCmd__Ljapgolly_scalajs_react_extra_router_RouteCmd(x)
  }));
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$5 = $n(fa$1);
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$5, f))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.parseUrl__Ljapgolly_scalajs_react_extra_router_AbsUrl__s_Option = (function(url) {
  var this$1 = $n($n(url).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value);
  var prefix = $n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl).Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value;
  if ((this$1.length >= 0)) {
    var this$2 = $n(prefix);
    var $$x2 = this$1.substring(0, this$2.length);
    var $$x1 = ($as_T($$x2) === prefix)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var this$4 = $n($n(url).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value);
    var this$3 = $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl).Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value);
    var beginIndex = this$3.length;
    if (((beginIndex < 0) || (beginIndex > this$4.length))) {
      $charAt(this$4, beginIndex)
    };
    return new $c_s_Some(new $c_Ljapgolly_scalajs_react_extra_router_Path($as_T(this$4.substring(beginIndex))))
  } else {
    return $m_s_None$()
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.syncToPath__Ljapgolly_scalajs_react_extra_router_Path__O = (function(path) {
  $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var fa$2 = $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules).parse__Ljapgolly_scalajs_react_extra_router_Path__O(path);
  var f$1 = new $c_sjsr_AnonFunction1(((parsed$2) => {
    var parsed = $as_s_util_Either(parsed$2);
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    if ((parsed instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(parsed);
      var page = $n(x2).s_util_Right__f_value;
      var fa = this.resolveActionForPage__Ljapgolly_scalajs_react_extra_router_Path__O__O(path, page)
    } else {
      if ((!(parsed instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(parsed)
      };
      var x3 = $as_s_util_Left(parsed);
      var r = $as_Ljapgolly_scalajs_react_extra_router_Redirect($n(x3).s_util_Left__f_value);
      var fa = this.redirect__Ljapgolly_scalajs_react_extra_router_Redirect__O(r)
    };
    var f = new $c_sjsr_AnonFunction1(((cmd$2) => {
      var cmd = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd(cmd$2);
      var msg = new $c_sjsr_AnonFunction0((() => (((("Parsed " + path) + " to ") + parsed) + ".")));
      return new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(msg).$greater$greater__Ljapgolly_scalajs_react_extra_router_RouteCmd__Ljapgolly_scalajs_react_extra_router_RouteCmd(cmd)
    }));
    var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$4 = $n(fa$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$4, f))
  }));
  var fa$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$3, f$1))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.resolveActionForPage__Ljapgolly_scalajs_react_extra_router_Path__O__O = (function(path, page) {
  $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var fa$2 = $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules).action__Ljapgolly_scalajs_react_extra_router_Path__O__O(path, page);
  var f$1 = new $c_sjsr_AnonFunction1(((action$2) => {
    var action = $as_Ljapgolly_scalajs_react_extra_router_ActionF(action$2);
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var fa = this.resolveAction__O__Ljapgolly_scalajs_react_extra_router_ActionF__O(page, action);
    var f = new $c_sjsr_AnonFunction1(((cmd$2) => {
      var cmd = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd(cmd$2);
      var msg = new $c_sjsr_AnonFunction0((() => (((((("Action for page " + page) + " at ") + path) + " is ") + action) + ".")));
      return new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(msg).$greater$greater__Ljapgolly_scalajs_react_extra_router_RouteCmd__Ljapgolly_scalajs_react_extra_router_RouteCmd(cmd)
    }));
    var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$4 = $n(fa$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$4, f))
  }));
  var fa$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$3, f$1))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.resolveAction__O__Ljapgolly_scalajs_react_extra_router_ActionF__O = (function(page, action) {
  $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var fa = this.resolveAction__Ljapgolly_scalajs_react_extra_router_ActionF__O(action);
  var f = new $c_sjsr_AnonFunction1(((a$2) => {
    var a = $as_s_util_Either(a$2);
    var this$2 = $n(a);
    if ((this$2 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$2);
      var b = $n(x2).s_util_Right__f_value;
      var r = $as_Ljapgolly_scalajs_react_extra_router_RendererF(b);
      var this$3 = $n(r);
      var ctl = this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_ctl;
      var $$x1 = new $c_s_util_Right(new $c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(page, $as_F1($n(this$3.Ljapgolly_scalajs_react_extra_router_RendererF__f_render).apply__O__O(ctl))))
    } else {
      var $$x1 = this$2
    };
    return $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__cmdOrPure__s_util_Either__Ljapgolly_scalajs_react_extra_router_RouteCmd(this, $$x1)
  }));
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$6 = $n(fa$1);
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$6, f))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.resolveAction__Ljapgolly_scalajs_react_extra_router_ActionF__O = (function(a) {
  if ((a instanceof $c_Ljapgolly_scalajs_react_extra_router_RendererF)) {
    var x2 = $as_Ljapgolly_scalajs_react_extra_router_RendererF(a);
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    $n($m_s_package$().s_package$__f_Right);
    var value = $n(x2).withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RendererF($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var a$1 = new $c_s_util_Right(value);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a$1)))
  } else if ($is_Ljapgolly_scalajs_react_extra_router_Redirect(a)) {
    var x4 = $as_Ljapgolly_scalajs_react_extra_router_Redirect(a);
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var fa = this.redirect__Ljapgolly_scalajs_react_extra_router_Redirect__O(x4);
    var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd(x$8$2);
      $n($m_s_package$().s_package$__f_Left);
      return new $c_s_util_Left(x$8)
    }));
    var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$9 = $n(fa$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$9, f))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.redirect__Ljapgolly_scalajs_react_extra_router_Redirect__O = (function(r) {
  if ((r instanceof $c_Ljapgolly_scalajs_react_extra_router_RedirectToPage)) {
    var x2 = $as_Ljapgolly_scalajs_react_extra_router_RedirectToPage(r);
    var page = $n(x2).Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_page;
    var m = $n(x2).Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_via;
    return this.redirectToPath__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O($as_Ljapgolly_scalajs_react_extra_router_Path($n($n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules).Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_path).apply__O__O(page)), m)
  } else if ((r instanceof $c_Ljapgolly_scalajs_react_extra_router_RedirectToPath)) {
    var x3 = $as_Ljapgolly_scalajs_react_extra_router_RedirectToPath(r);
    var path = $n(x3).Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_path;
    var m$2 = $n(x3).Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_via;
    return this.redirectToPath__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(path, m$2)
  } else {
    throw new $c_s_MatchError(r)
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.redirectToPath__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O = (function(path, via) {
  $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var this$1 = $n(path);
  var base = this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl;
  var fa = this.syncToUrl__Ljapgolly_scalajs_react_extra_router_AbsUrl__O($n(base).apply__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_AbsUrl(this$1));
  var f = new $c_sjsr_AnonFunction1(((syncCmd$2) => {
    var syncCmd = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd(syncCmd$2);
    var msg = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $n(path);
      var base$1 = this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl;
      return (((("Redirecting to " + $n(base$1).apply__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_AbsUrl(this$3)) + " via ") + via) + ".")
    }));
    var $$x2 = new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(msg);
    var $$x1 = $m_Ljapgolly_scalajs_react_extra_router_RouteCmd$();
    var this$4 = $n(path);
    var base$2 = this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl;
    return $n($$x2.$greater$greater__Ljapgolly_scalajs_react_extra_router_RouteCmd__Ljapgolly_scalajs_react_extra_router_RouteCmd($n($$x1).setRoute__Ljapgolly_scalajs_react_extra_router_AbsUrl__Ljapgolly_scalajs_react_extra_router_SetRouteVia__Ljapgolly_scalajs_react_extra_router_RouteCmd($n(base$2).apply__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_AbsUrl(this$4), via))).$greater$greater__Ljapgolly_scalajs_react_extra_router_RouteCmd__Ljapgolly_scalajs_react_extra_router_RouteCmd(syncCmd)
  }));
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$7 = $n(fa$1);
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$7, f))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.interpret__Ljapgolly_scalajs_react_extra_router_RouteCmd__O = (function(r) {
  if ((r instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState)) {
    var x2 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState(r);
    var url = $n(x2).Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState__f_url;
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var fa = $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__logger__F0__O(this, new $c_sjsr_AnonFunction0((() => (("PushState: [" + $n(url).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value) + "]"))));
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var a = new $c_sjsr_AnonFunction0((() => {
      var $$x1 = window.history;
      var fields = $m_sci_Nil$();
      $$x1.pushState($m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields), "", $n(url).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value)
    }));
    var fb = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)));
    var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var fb$1 = fb.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, fb$1))
  } else if ((r instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState)) {
    var x3 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState(r);
    var url$2 = $n(x3).Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState__f_url;
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var fa$2 = $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__logger__F0__O(this, new $c_sjsr_AnonFunction0((() => (("ReplaceState: [" + $n(url$2).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value) + "]"))));
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var a$1 = new $c_sjsr_AnonFunction0((() => {
      var $$x2 = window.history;
      var fields$1 = $m_sci_Nil$();
      $$x2.replaceState($m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1), "", $n(url$2).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value)
    }));
    var fb$2 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$1)));
    var fa$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var fb$3 = fb$2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$3, fb$3))
  } else if ((r instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation)) {
    var x4 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation(r);
    var url$3 = $n(x4).Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation__f_url;
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var fa$4 = $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__logger__F0__O(this, new $c_sjsr_AnonFunction0((() => (("SetWindowLocation: [" + $n(url$3).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value) + "]"))));
    $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var a$2 = new $c_sjsr_AnonFunction0((() => {
      window.location.href = $n(url$3).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value
    }));
    var fb$4 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$2)));
    var fa$5 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$4)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var fb$5 = fb$4.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$5, fb$5))
  } else {
    var x = $m_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$();
    if ((x === r)) {
      $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
      var fa$6 = $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__logger__F0__O(this, new $c_sjsr_AnonFunction0((() => "Broadcasting sync request.")));
      var fb$6 = $f_Ljapgolly_scalajs_react_extra_BroadcasterF__broadcast__O__O(this, (void 0));
      var fa$7 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$6)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var fb$7 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fb$6)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$7, fb$7))
    } else if ((r instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return)) {
      var x6 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return(r);
      var a$3 = $n(x6).Ljapgolly_scalajs_react_extra_router_RouteCmd$Return__f_a;
      $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a$3)))
    } else if ((r instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log)) {
      var x7 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(r);
      var msg = $n(x7).Ljapgolly_scalajs_react_extra_router_RouteCmd$Log__f_msg;
      return $p_Ljapgolly_scalajs_react_extra_router_RouterLogicF__logger__F0__O(this, msg)
    } else if ((r instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence)) {
      var x8 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence(r);
      var a$2$1 = $n(x8).Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_init;
      var b = $n(x8).Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_last;
      $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
      var this$22 = $n(a$2$1);
      var this$21 = $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
      var z = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$21.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty);
      var at = 0;
      var end = this$22.length__I();
      var acc = z;
      var fa$11;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var arg1 = acc;
          var arg2 = this$22.apply__I__O(at);
          var y = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd(arg2);
          $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
          $n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
          var fa$8 = this.interpret__Ljapgolly_scalajs_react_extra_router_RouteCmd__O(y);
          var f = new $c_sjsr_AnonFunction1(((x$10$2) => (void 0)));
          var fa$9 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$8)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var this$26 = $n(fa$9);
          var fb$8 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$26, f));
          var fa$10 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(arg1)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var fb$9 = fb$8.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var temp$acc = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$10, fb$9));
          at = temp$at;
          acc = temp$acc;
          continue
        };
        var fa$11 = acc;
        break
      };
      var fb$10 = this.interpret__Ljapgolly_scalajs_react_extra_router_RouteCmd__O(b);
      var fa$12 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa$11)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var fb$11 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fb$10)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$12, fb$11))
    } else {
      throw new $c_s_MatchError(r)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.render__Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__O__Ljapgolly_scalajs_react_vdom_VdomElement = (function(r, props) {
  return $as_Ljapgolly_scalajs_react_vdom_VdomElement($n($as_F1($n($n(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_japgolly$scalajs$react$extra$router$RouterLogicF$$cfg).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_renderFn).apply__O__O__O(this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_ctl, r))).apply__O__O(props))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.setPath__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_SetRouteVia__Ljapgolly_scalajs_react_extra_router_RouteCmd = (function(path, via) {
  var msg = new $c_sjsr_AnonFunction0((() => ((("Set route to " + path) + " via ") + via)));
  var $$x2 = new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(msg);
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_router_RouteCmd$();
  var this$2 = $n(path);
  var base = this.Ljapgolly_scalajs_react_extra_router_RouterLogicF__f_baseUrl;
  return $n($$x2.$greater$greater__Ljapgolly_scalajs_react_extra_router_RouteCmd__Ljapgolly_scalajs_react_extra_router_RouteCmd($n($$x1).setRoute__Ljapgolly_scalajs_react_extra_router_AbsUrl__Ljapgolly_scalajs_react_extra_router_SetRouteVia__Ljapgolly_scalajs_react_extra_router_RouteCmd($n(base).apply__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_AbsUrl(this$2), via))).$greater$greater__Ljapgolly_scalajs_react_extra_router_RouteCmd__Ljapgolly_scalajs_react_extra_router_RouteCmd($m_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$())
});
var $d_Ljapgolly_scalajs_react_extra_router_RouterLogicF = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterLogicF: 0
}, false, "japgolly.scalajs.react.extra.router.RouterLogicF", {
  Ljapgolly_scalajs_react_extra_router_RouterLogicF: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterLogicF.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterLogicF;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(pattern, parseFn, buildFn) {
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_pattern = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_parseFn = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_buildFn = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_pattern = pattern;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_parseFn = parseFn;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_buildFn = buildFn
}
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype = new $h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon();
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype;
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype.toString__T = (function() {
  return (("Route(" + this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_pattern) + ")")
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype.pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route = (function(b, a) {
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_pattern, new $c_sjsr_AnonFunction1(((x$43$2) => {
    var x$43 = $as_ju_regex_Matcher(x$43$2);
    var this$2 = $n($as_s_Option($n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_parseFn).apply__O__O(x$43)));
    return (this$2.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(b).apply__O__O(this$2.get__O())))
  })), $n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_buildFn).compose__F1__F1(a))
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype.parse__Ljapgolly_scalajs_react_extra_router_Path__s_Option = (function(path) {
  var this$1 = $n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_pattern);
  var input = $n(path).Ljapgolly_scalajs_react_extra_router_Path__f_value;
  var this$2 = $n(input);
  var m = new $c_ju_regex_Matcher(this$1, this$2);
  return (m.matches__Z() ? $as_s_Option($n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_parseFn).apply__O__O(m)) : $m_s_None$())
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype.pathFor__O__Ljapgolly_scalajs_react_extra_router_Path = (function(a) {
  return $as_Ljapgolly_scalajs_react_extra_router_Path($n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route__f_buildFn).apply__O__O(a))
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype.pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon = (function(b, a) {
  return this.pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(b, a)
});
function $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.StaticDsl$Route"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_StaticDsl$Route)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.StaticDsl$Route;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_StaticDsl$Route: 0
}, false, "japgolly.scalajs.react.extra.router.StaticDsl$Route", {
  Ljapgolly_scalajs_react_extra_router_StaticDsl$Route: 1,
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_internal_RouterMacros$ForRoute: 1
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(regex, matchGroups, parse, build) {
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_regex = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_matchGroups = 0;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_parse = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_build = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_regex = regex;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_matchGroups = matchGroups;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_parse = parse;
  this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_build = build
}
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype = new $h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon();
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype;
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype.toString__T = (function() {
  return (("RouteB(" + this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_regex) + ")")
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype.$div__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB = (function(next, c) {
  var next$1 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$().Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$__f_$div;
  var this$1 = $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$();
  var c$1 = $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed__Ato___Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition(this$1);
  var this$2 = $n(c$1);
  var this$3 = $n($f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$2, this, next$1));
  var this$4 = $n(c);
  return $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition__apply__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this$4, this$3, next)
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype.pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB = (function(b, a) {
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_regex, this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_matchGroups, new $c_sjsr_AnonFunction1(((x$38$2) => {
    var x$38 = $as_F1(x$38$2);
    var this$2 = $n($as_s_Option($n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_parse).apply__O__O(x$38)));
    return (this$2.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(b).apply__O__O(this$2.get__O())))
  })), $n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_build).compose__F1__F1(a))
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype.option__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB = (function() {
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB((("(" + this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_regex) + ")?"), ((1 + this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_matchGroups) | 0), new $c_sjsr_AnonFunction1(((g$2) => {
    var g = $as_F1(g$2);
    return new $c_s_Some((($n(g).apply__O__O(0) === null) ? $m_s_None$() : $n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_parse).apply__O__O(new $c_sjsr_AnonFunction1(((i$2) => {
      var i = $uI(i$2);
      return $as_T($n(g).apply__O__O(((1 + i) | 0)))
    })))))
  })), new $c_sjsr_AnonFunction1(((x$39$2) => {
    var x$39 = $as_s_Option(x$39$2);
    var this$3 = $n(x$39);
    var f = this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_build;
    return $as_T((this$3.isEmpty__Z() ? "" : $n(f).apply__O__O(this$3.get__O())))
  })))
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype.route__Ljapgolly_scalajs_react_extra_router_StaticDsl$Route = (function() {
  var regex = (("^" + this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_regex) + "$");
  var p = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0);
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$Route(p, new $c_sjsr_AnonFunction1(((m$2) => {
    var m = $as_ju_regex_Matcher(m$2);
    return $as_s_Option($n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_parse).apply__O__O(new $c_sjsr_AnonFunction1(((i$2) => {
      var i = $uI(i$2);
      return $n(m).group__I__T(((1 + i) | 0))
    }))))
  })), new $c_sjsr_AnonFunction1(((a$2) => new $c_Ljapgolly_scalajs_react_extra_router_Path($as_T($n(this.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB__f_build).apply__O__O(a$2))))))
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype.pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon = (function(b, a) {
  return this.pmap__F1__F1__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(b, a)
});
function $as_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.StaticDsl$RouteB"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.StaticDsl$RouteB;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB: 0
}, false, "japgolly.scalajs.react.extra.router.StaticDsl$RouteB", {
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB: 1,
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteCommon: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_internal_RouterMacros$ForRouteB: 1
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB;
function $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed___toA__Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition($thiz) {
  var a = new $c_sjsr_AnonFunction1(((x$25$2) => (void 0)));
  var this$2 = $m_Ljapgolly_scalajs_react_util_Util$();
  var b = this$2.Ljapgolly_scalajs_react_util_Util$__f_identity;
  var c = new $c_sjsr_AnonFunction2(((x$26$2, a$2) => {
    $as_jl_Void(x$26$2);
    return a$2
  }));
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1(a, b, c)
}
function $f_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed__Ato___Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition($thiz) {
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var a = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  var b = new $c_sjsr_AnonFunction1(((x$27$2) => (void 0)));
  var c = new $c_sjsr_AnonFunction2(((a$2, x$28$2) => {
    $as_jl_Void(x$28$2);
    return a$2
  }));
  return new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$$anon$1(a, b, c)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$.prototype;
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$.prototype.const__O__F1 = (function(i) {
  return new $c_sjsr_AnonFunction1(((x$4$2) => i))
});
var $d_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook$Arg$: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook$Arg$", {
  Ljapgolly_scalajs_react_hooks_CustomHook$Arg$: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$ArgLowPri: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$;
var $n_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$;
function $m_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$() {
  if ((!$n_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$)) {
    $n_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$ = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$()
  };
  return $n_Ljapgolly_scalajs_react_hooks_CustomHook$Arg$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(buildFn) {
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent__f_buildFn = null;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent__f_buildFn = buildFn
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype;
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype.self__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent = (function(f, step) {
  var this$1 = $n(step);
  return $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent($n($f_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__self__F2(this$1)).apply__O__O__O(this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent__f_buildFn, f))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype.next__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__O = (function(f, step) {
  return $n($n(step).next__F2()).apply__O__O__O(this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent__f_buildFn, f)
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype.build__F1 = (function() {
  return this.buildReturning__F1__F1(new $c_sjsr_AnonFunction1(((x$7$2) => (void 0))))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype.buildReturning__F1__F1 = (function(f) {
  return $n(this.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent__f_buildFn).apply__F1__F1(f)
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype.buildReturning__O__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__F1 = (function(f, step) {
  return this.buildReturning__F1__F1(new $c_sjsr_AnonFunction1(((x$8$2) => $n($as_F1($n($n(step).squash__F1()).apply__O__O(f))).apply__O__O(x$8$2))))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.next__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__O(f, $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep(step))
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.self__F1__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(f, $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep(step))
});
function $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.CustomHook$Builder$Subsequent"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.CustomHook$Builder$Subsequent;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook$Builder$Subsequent", {
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$Secondary: 1,
  Ljapgolly_scalajs_react_hooks_Api$Primary: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent;
function $f_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep__self__F2($thiz) {
  return new $c_sjsr_AnonFunction2(((buildPrev$2, initNextHook$2) => {
    var buildPrev = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(buildPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var buildNext = new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep$$anon$2($thiz, buildPrev, initNextHook);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(buildNext)
  }))
}
function $is_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep)))
}
function $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep(obj) {
  return (($is_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.CustomHook$Builder$SubsequentStep"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.CustomHook$Builder$SubsequentStep;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First(init) {
  this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First__f_init = null;
  this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First__f_init = init
}
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype.self__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First = (function(f, step) {
  return $n(step).self__F1__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First__f_init, f)
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype.next__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent = (function(f, step) {
  return $n(step).next__F1__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First__f_init, f)
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype.withPropsChildren__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First = (function() {
  return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First(new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC0(ctx$2);
    $n(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First__f_init).apply__O__O($n(ctx).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props)
  })))
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.next__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(f, $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep(step))
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.self__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First(f, $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep(step))
});
var $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First: 0
}, false, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$First", {
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$PrimaryWithRender: 1,
  Ljapgolly_scalajs_react_hooks_Api$Primary: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First;
function $f_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep__self__F2($thiz) {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx$2) => {
        $n(initNextHook).apply__O__O(ctx$2);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx$2))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
}
function $is_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep)))
}
function $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep(obj) {
  return (($is_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$SubsequentStep"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$SubsequentStep;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First(init) {
  this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First__f_init = null;
  this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First__f_init = init
}
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First.prototype = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First.prototype.self__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First = (function(f, step) {
  return $n(step).self__F1__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First__f_init, f)
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First.prototype.next__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent = (function(f, step) {
  return $n(step).next__F1__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First__f_init, f)
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First.prototype.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.next__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(f, $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep(step))
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First.prototype.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.self__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First(f, $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$FirstStep(step))
});
var $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First: 0
}, false, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$First", {
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$PrimaryWithRender: 1,
  Ljapgolly_scalajs_react_hooks_Api$Primary: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$First;
function $f_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep__self__F2($thiz) {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F2($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx$2) => {
        $n(initNextHook).apply__O__O(ctx$2);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx$2))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(renderNext)
  }))
}
function $is_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep)))
}
function $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep(obj) {
  return (($is_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$SubsequentStep"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$SubsequentStep;", depth))
}
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I2__O__O__O__($thiz, input, hook1, hook2) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2 = hook2;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I1__O__O__($thiz, input, hook1);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$I2() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I2.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$I1();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I2.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$I2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$I2.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I2.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I2.prototype.toString__T = (function() {
  return (((((("HookCtx.withInput(\n  input = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$I2(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$I2) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$I2"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$I2)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I2(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$I2;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$I2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$I2: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$I2", {
  Ljapgolly_scalajs_react_hooks_HookCtx$I2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I2.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$I2;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P2__O__O__O__($thiz, props, hook1, hook2) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = hook2;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P1__O__O__($thiz, props, hook1);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P2() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P2.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P1();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P2.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P2.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P2.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P2.prototype.toString__T = (function() {
  return (((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P2(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P2) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P2"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P2)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P2(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P2;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P2", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P2.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P2;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC1__O__sjs_js_Any__O__($thiz, props, propsChildren, hook1) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1 = hook1;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC0__O__sjs_js_Any__($thiz, props, propsChildren);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$PC0();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$PC1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$PC1.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1.prototype.toString__T = (function() {
  return (((((("HookCtx.withChildren(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  propsChildren = ") + new $c_Ljapgolly_scalajs_react_PropsChildren(this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren)) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1) + ")")
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1.prototype.apply1__F3__O = (function(f) {
  return $n(f).apply__O__O__O__O(this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, new $c_Ljapgolly_scalajs_react_PropsChildren(this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren), this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1)
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$PC1"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$PC1)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$PC1;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$PC1: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$PC1", {
  Ljapgolly_scalajs_react_hooks_HookCtx$PC1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC0: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC1.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_EffectFallbacks4() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_EffectFallbacks4.prototype = new $h_Ljapgolly_scalajs_react_util_EffectFallbacks5();
$c_Ljapgolly_scalajs_react_util_EffectFallbacks4.prototype.constructor = $c_Ljapgolly_scalajs_react_util_EffectFallbacks4;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_EffectFallbacks4() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_EffectFallbacks4.prototype = $c_Ljapgolly_scalajs_react_util_EffectFallbacks4.prototype;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  $ct_Ljapgolly_scalajs_react_vdom_Attr__T__(this, "target")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Attr$Generic();
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlAttrs$target$", {
  Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$: 1,
  Ljapgolly_scalajs_react_vdom_Attr$Generic: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "alignItems")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$alignItems$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "alignSelf")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$alignSelf$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "borderCollapse")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$borderCollapse$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "boxSizing")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$boxSizing$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "color")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$color$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$color$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$color$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "cursor")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$cursor$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "display")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$display$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$display$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$display$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "flexDirection")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$flexDirection$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "flexWrap")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$flexWrap$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "fontSize")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$fontSize$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "fontWeight")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$fontWeight$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "justifyContent")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$justifyContent$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "overflowWrap")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$overflowWrap$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "position")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$position$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$position$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$position$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "textDecoration")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$textDecoration$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "textOverflow")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$textOverflow$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "verticalAlign")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$verticalAlign$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "visibility")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$visibility$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "whiteSpace")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$whiteSpace$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$(outer) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, "wordBreak")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStyles$wordBreak$", {
  Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle(name) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, name)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStylesStatic$AutoStyle", {
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius(name) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, name)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStylesStatic$BorderRadius", {
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle(name) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, name)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStylesStatic$MultiImageStyle", {
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$MultiImageStyle;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle(name) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, name)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStylesStatic$NoneOpenStyle", {
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NoneOpenStyle;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle(name) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, name)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStylesStatic$NormalOpenStyle", {
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow(name) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, name)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStylesStatic$Overflow", {
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign(name) {
  this.Ljapgolly_scalajs_react_vdom_Attr__f_attrName = null;
  this.Ljapgolly_scalajs_react_vdom_Style__f_name = null;
  $ct_Ljapgolly_scalajs_react_vdom_Style__T__(this, name)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign.prototype = new $h_Ljapgolly_scalajs_react_vdom_Style();
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign.prototype;
var $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign: 0
}, false, "japgolly.scalajs.react.vdom.HtmlStylesStatic$TextAlign", {
  Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign: 1,
  Ljapgolly_scalajs_react_vdom_Style: 1,
  Ljapgolly_scalajs_react_vdom_Attr: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign;
function $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr__vdomAttrVtDouble__F2($thiz) {
  return $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().byImplicit__F1__F2(new $c_sjsr_AnonFunction1(((value$2) => {
    var value = $uD(value$2);
    return value
  })))
}
function $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr__$init$__V($thiz) {
  $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().byImplicit__F1__F2(new $c_sjsr_AnonFunction1(((value$2) => {
    var value = $uZ(value$2);
    return value
  })));
  $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_string;
  $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().byImplicit__F1__F2(new $c_sjsr_AnonFunction1(((value$3$2) => {
    var value$3 = $uI(value$3$2);
    return value$3
  })));
  $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$()
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_VdomArray(rawArray) {
  this.Ljapgolly_scalajs_react_vdom_VdomArray__f_rawArray = null;
  this.Ljapgolly_scalajs_react_vdom_VdomArray__f_rawArray = rawArray
}
$c_Ljapgolly_scalajs_react_vdom_VdomArray.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_VdomArray.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_VdomArray;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_VdomArray() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_VdomArray.prototype = $c_Ljapgolly_scalajs_react_vdom_VdomArray.prototype;
$c_Ljapgolly_scalajs_react_vdom_VdomArray.prototype.rawNode__sjs_js_$bar = (function() {
  return this.Ljapgolly_scalajs_react_vdom_VdomArray__f_rawArray
});
$c_Ljapgolly_scalajs_react_vdom_VdomArray.prototype.applyTo__Ljapgolly_scalajs_react_vdom_VdomBuilder__V = (function(b) {
  $n($n(b).Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_appendChild).apply__O__O(this.Ljapgolly_scalajs_react_vdom_VdomArray__f_rawArray)
});
var $d_Ljapgolly_scalajs_react_vdom_VdomArray = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_VdomArray: 0
}, false, "japgolly.scalajs.react.vdom.VdomArray", {
  Ljapgolly_scalajs_react_vdom_VdomArray: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_VdomNode: 1,
  Ljapgolly_scalajs_react_vdom_TagMod: 1
});
$c_Ljapgolly_scalajs_react_vdom_VdomArray.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_VdomArray;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement() {
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_props = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_styles = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_children = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_key = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_nonEmptyClassName = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addAttr = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addClassName = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addEventHandler = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addStyle = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_addStylesObject = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_appendChild = null;
  this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_setKey = null;
  $f_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToJs__$init$__V(this)
}
$c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement.prototype = $c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement.prototype;
$c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement.prototype.render__T__Ljapgolly_scalajs_react_facade_React$Element = (function(tag) {
  $f_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToJs__addClassNameToProps__V(this);
  $f_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToJs__addStyleToProps__V(this);
  return $n($m_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$().Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement$__f_build).apply__O__O__O__O__O(tag, this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_props, this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_key, this.Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_children)
});
var $d_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement: 0
}, false, "japgolly.scalajs.react.vdom.VdomBuilder$ToRawReactElement", {
  Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_VdomBuilder$ToJs: 1,
  Ljapgolly_scalajs_react_vdom_VdomBuilder: 1
});
$c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement;
function $f_Ljapgolly_scalajs_react_vdom_VdomElement__rawNode__sjs_js_$bar($thiz) {
  var a = $thiz.rawElement__Ljapgolly_scalajs_react_facade_React$Element();
  return a
}
function $is_Ljapgolly_scalajs_react_vdom_VdomElement(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_vdom_VdomElement)))
}
function $as_Ljapgolly_scalajs_react_vdom_VdomElement(obj) {
  return (($is_Ljapgolly_scalajs_react_vdom_VdomElement(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.vdom.VdomElement"))
}
function $isArrayOf_Ljapgolly_scalajs_react_vdom_VdomElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_vdom_VdomElement)))
}
function $asArrayOf_Ljapgolly_scalajs_react_vdom_VdomElement(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_vdom_VdomElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.vdom.VdomElement;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(n$1) {
  this.Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1__f_n$1 = null;
  this.Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1__f_n$1 = n$1
}
$c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1.prototype = $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1.prototype.rawNode__sjs_js_$bar = (function() {
  return this.Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1__f_n$1
});
$c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1.prototype.applyTo__Ljapgolly_scalajs_react_vdom_VdomBuilder__V = (function(b) {
  $n($n(b).Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_appendChild).apply__O__O(this.Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1__f_n$1)
});
var $d_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1: 0
}, false, "japgolly.scalajs.react.vdom.VdomNode$$anon$1", {
  Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_VdomNode: 1,
  Ljapgolly_scalajs_react_vdom_TagMod: 1
});
$c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1;
/** @constructor */
function $c_Ljapgolly_univeq_UnivEq$() {
  this.Ljapgolly_univeq_UnivEq$__f_UnivEqAnyRef = null;
  this.Ljapgolly_univeq_UnivEq$__f_UnivEqInt = null;
  this.Ljapgolly_univeq_UnivEq$__f_UnivEqLong = null;
  $n_Ljapgolly_univeq_UnivEq$ = this;
  this.Ljapgolly_univeq_UnivEq$__f_UnivEqAnyRef = new $c_Ljapgolly_univeq_UnivEq$$anon$1();
  new $c_Ljapgolly_univeq_UnivEq$$anon$2();
  new $c_Ljapgolly_univeq_UnivEq$$anon$4();
  new $c_Ljapgolly_univeq_UnivEq$$anon$5();
  this.Ljapgolly_univeq_UnivEq$__f_UnivEqInt = new $c_Ljapgolly_univeq_UnivEq$$anon$7();
  this.Ljapgolly_univeq_UnivEq$__f_UnivEqLong = new $c_Ljapgolly_univeq_UnivEq$$anon$8()
}
$c_Ljapgolly_univeq_UnivEq$.prototype = new $h_O();
$c_Ljapgolly_univeq_UnivEq$.prototype.constructor = $c_Ljapgolly_univeq_UnivEq$;
/** @constructor */
function $h_Ljapgolly_univeq_UnivEq$() {
  /*<skip>*/
}
$h_Ljapgolly_univeq_UnivEq$.prototype = $c_Ljapgolly_univeq_UnivEq$.prototype;
var $d_Ljapgolly_univeq_UnivEq$ = new $TypeData().initClass({
  Ljapgolly_univeq_UnivEq$: 0
}, false, "japgolly.univeq.UnivEq$", {
  Ljapgolly_univeq_UnivEq$: 1,
  O: 1,
  Ljapgolly_univeq_ScalaUnivEq: 1,
  Ljapgolly_univeq_PlatformUnivEq: 1
});
$c_Ljapgolly_univeq_UnivEq$.prototype.$classData = $d_Ljapgolly_univeq_UnivEq$;
var $n_Ljapgolly_univeq_UnivEq$;
function $m_Ljapgolly_univeq_UnivEq$() {
  if ((!$n_Ljapgolly_univeq_UnivEq$)) {
    $n_Ljapgolly_univeq_UnivEq$ = new $c_Ljapgolly_univeq_UnivEq$()
  };
  return $n_Ljapgolly_univeq_UnivEq$
}
/** @constructor */
function $c_Ljapgolly_univeq_UnivEq$$anon$2() {
  /*<skip>*/
}
$c_Ljapgolly_univeq_UnivEq$$anon$2.prototype = new $h_O();
$c_Ljapgolly_univeq_UnivEq$$anon$2.prototype.constructor = $c_Ljapgolly_univeq_UnivEq$$anon$2;
/** @constructor */
function $h_Ljapgolly_univeq_UnivEq$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_univeq_UnivEq$$anon$2.prototype = $c_Ljapgolly_univeq_UnivEq$$anon$2.prototype;
var $d_Ljapgolly_univeq_UnivEq$$anon$2 = new $TypeData().initClass({
  Ljapgolly_univeq_UnivEq$$anon$2: 0
}, false, "japgolly.univeq.UnivEq$$anon$2", {
  Ljapgolly_univeq_UnivEq$$anon$2: 1,
  O: 1,
  Ljapgolly_univeq_UnivEq$mcZ$sp: 1,
  Ljapgolly_univeq_UnivEq: 1
});
$c_Ljapgolly_univeq_UnivEq$$anon$2.prototype.$classData = $d_Ljapgolly_univeq_UnivEq$$anon$2;
/** @constructor */
function $c_Ljapgolly_univeq_UnivEq$$anon$4() {
  /*<skip>*/
}
$c_Ljapgolly_univeq_UnivEq$$anon$4.prototype = new $h_O();
$c_Ljapgolly_univeq_UnivEq$$anon$4.prototype.constructor = $c_Ljapgolly_univeq_UnivEq$$anon$4;
/** @constructor */
function $h_Ljapgolly_univeq_UnivEq$$anon$4() {
  /*<skip>*/
}
$h_Ljapgolly_univeq_UnivEq$$anon$4.prototype = $c_Ljapgolly_univeq_UnivEq$$anon$4.prototype;
var $d_Ljapgolly_univeq_UnivEq$$anon$4 = new $TypeData().initClass({
  Ljapgolly_univeq_UnivEq$$anon$4: 0
}, false, "japgolly.univeq.UnivEq$$anon$4", {
  Ljapgolly_univeq_UnivEq$$anon$4: 1,
  O: 1,
  Ljapgolly_univeq_UnivEq$mcC$sp: 1,
  Ljapgolly_univeq_UnivEq: 1
});
$c_Ljapgolly_univeq_UnivEq$$anon$4.prototype.$classData = $d_Ljapgolly_univeq_UnivEq$$anon$4;
/** @constructor */
function $c_Ljapgolly_univeq_UnivEq$$anon$5() {
  /*<skip>*/
}
$c_Ljapgolly_univeq_UnivEq$$anon$5.prototype = new $h_O();
$c_Ljapgolly_univeq_UnivEq$$anon$5.prototype.constructor = $c_Ljapgolly_univeq_UnivEq$$anon$5;
/** @constructor */
function $h_Ljapgolly_univeq_UnivEq$$anon$5() {
  /*<skip>*/
}
$h_Ljapgolly_univeq_UnivEq$$anon$5.prototype = $c_Ljapgolly_univeq_UnivEq$$anon$5.prototype;
var $d_Ljapgolly_univeq_UnivEq$$anon$5 = new $TypeData().initClass({
  Ljapgolly_univeq_UnivEq$$anon$5: 0
}, false, "japgolly.univeq.UnivEq$$anon$5", {
  Ljapgolly_univeq_UnivEq$$anon$5: 1,
  O: 1,
  Ljapgolly_univeq_UnivEq$mcD$sp: 1,
  Ljapgolly_univeq_UnivEq: 1
});
$c_Ljapgolly_univeq_UnivEq$$anon$5.prototype.$classData = $d_Ljapgolly_univeq_UnivEq$$anon$5;
/** @constructor */
function $c_Ljapgolly_univeq_UnivEq$$anon$7() {
  /*<skip>*/
}
$c_Ljapgolly_univeq_UnivEq$$anon$7.prototype = new $h_O();
$c_Ljapgolly_univeq_UnivEq$$anon$7.prototype.constructor = $c_Ljapgolly_univeq_UnivEq$$anon$7;
/** @constructor */
function $h_Ljapgolly_univeq_UnivEq$$anon$7() {
  /*<skip>*/
}
$h_Ljapgolly_univeq_UnivEq$$anon$7.prototype = $c_Ljapgolly_univeq_UnivEq$$anon$7.prototype;
var $d_Ljapgolly_univeq_UnivEq$$anon$7 = new $TypeData().initClass({
  Ljapgolly_univeq_UnivEq$$anon$7: 0
}, false, "japgolly.univeq.UnivEq$$anon$7", {
  Ljapgolly_univeq_UnivEq$$anon$7: 1,
  O: 1,
  Ljapgolly_univeq_UnivEq$mcI$sp: 1,
  Ljapgolly_univeq_UnivEq: 1
});
$c_Ljapgolly_univeq_UnivEq$$anon$7.prototype.$classData = $d_Ljapgolly_univeq_UnivEq$$anon$7;
/** @constructor */
function $c_Ljapgolly_univeq_UnivEq$$anon$8() {
  /*<skip>*/
}
$c_Ljapgolly_univeq_UnivEq$$anon$8.prototype = new $h_O();
$c_Ljapgolly_univeq_UnivEq$$anon$8.prototype.constructor = $c_Ljapgolly_univeq_UnivEq$$anon$8;
/** @constructor */
function $h_Ljapgolly_univeq_UnivEq$$anon$8() {
  /*<skip>*/
}
$h_Ljapgolly_univeq_UnivEq$$anon$8.prototype = $c_Ljapgolly_univeq_UnivEq$$anon$8.prototype;
var $d_Ljapgolly_univeq_UnivEq$$anon$8 = new $TypeData().initClass({
  Ljapgolly_univeq_UnivEq$$anon$8: 0
}, false, "japgolly.univeq.UnivEq$$anon$8", {
  Ljapgolly_univeq_UnivEq$$anon$8: 1,
  O: 1,
  Ljapgolly_univeq_UnivEq$mcJ$sp: 1,
  Ljapgolly_univeq_UnivEq: 1
});
$c_Ljapgolly_univeq_UnivEq$$anon$8.prototype.$classData = $d_Ljapgolly_univeq_UnivEq$$anon$8;
function $p_jl_Class__computeCachedSimpleNameBestEffort__T($thiz) {
  if ($thiz.isArray__Z()) {
    return ($n($thiz.getComponentType__jl_Class()).getSimpleName__T() + "[]")
  } else {
    var name = $as_T($thiz.jl_Class__f_data.name);
    var this$1 = $n(name);
    var idx = (((-1) + this$1.length) | 0);
    while (true) {
      if ((idx >= 0)) {
        var this$2 = $n(name);
        var index = idx;
        var $$x1 = ($charAt(this$2, index) === 36)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        idx = (((-1) + idx) | 0)
      } else {
        break
      }
    };
    if ((idx >= 0)) {
      var this$3 = $n(name);
      var index$1 = idx;
      var c = $charAt(this$3, index$1);
      var $$x2 = ((c >= 48) && (c <= 57))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      idx = (((-1) + idx) | 0);
      while (true) {
        if ((idx >= 0)) {
          var this$4 = $n(name);
          var index$2 = idx;
          var c$1 = $charAt(this$4, index$2);
          var $$x3 = ((c$1 >= 48) && (c$1 <= 57))
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          idx = (((-1) + idx) | 0)
        } else {
          break
        }
      };
      while (true) {
        if ((idx >= 0)) {
          var this$5 = $n(name);
          var index$3 = idx;
          var $$x4 = ($charAt(this$5, index$3) === 36)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          idx = (((-1) + idx) | 0)
        } else {
          break
        }
      }
    };
    while (true) {
      if ((idx >= 0)) {
        var this$6 = $n(name);
        var index$4 = idx;
        var currChar = $charAt(this$6, index$4);
        var $$x5 = ((currChar !== 46) && (currChar !== 36))
      } else {
        var $$x5 = false
      };
      if ($$x5) {
        idx = (((-1) + idx) | 0)
      } else {
        break
      }
    };
    var this$7 = $n(name);
    var beginIndex = ((1 + idx) | 0);
    if (((beginIndex < 0) || (beginIndex > this$7.length))) {
      $charAt(this$7, beginIndex)
    };
    return $as_T(this$7.substring(beginIndex))
  }
}
/** @constructor */
function $c_jl_Class(data0) {
  this.jl_Class__f_data = null;
  this.jl_Class__f_cachedSimpleName = null;
  this.jl_Class__f_data = data0
}
$c_jl_Class.prototype = new $h_O();
$c_jl_Class.prototype.constructor = $c_jl_Class;
/** @constructor */
function $h_jl_Class() {
  /*<skip>*/
}
$h_jl_Class.prototype = $c_jl_Class.prototype;
$c_jl_Class.prototype.toString__T = (function() {
  return ((this.isInterface__Z() ? "interface " : (this.isPrimitive__Z() ? "" : "class ")) + this.getName__T())
});
$c_jl_Class.prototype.isInstance__O__Z = (function(obj) {
  return $uZ(this.jl_Class__f_data.isInstance(obj))
});
$c_jl_Class.prototype.isAssignableFrom__jl_Class__Z = (function(that) {
  return $uZ(this.jl_Class__f_data.isAssignableFrom($n(that).jl_Class__f_data))
});
$c_jl_Class.prototype.isInterface__Z = (function() {
  return $uZ(this.jl_Class__f_data.isInterface)
});
$c_jl_Class.prototype.isArray__Z = (function() {
  return $uZ(this.jl_Class__f_data.isArrayClass)
});
$c_jl_Class.prototype.isPrimitive__Z = (function() {
  return $uZ(this.jl_Class__f_data.isPrimitive)
});
$c_jl_Class.prototype.getName__T = (function() {
  return $as_T(this.jl_Class__f_data.name)
});
$c_jl_Class.prototype.getSimpleName__T = (function() {
  if ((this.jl_Class__f_cachedSimpleName === null)) {
    this.jl_Class__f_cachedSimpleName = $p_jl_Class__computeCachedSimpleNameBestEffort__T(this)
  };
  return this.jl_Class__f_cachedSimpleName
});
$c_jl_Class.prototype.getComponentType__jl_Class = (function() {
  return $as_jl_Class(this.jl_Class__f_data.getComponentType())
});
$c_jl_Class.prototype.newArrayOfThisClass__O__O = (function(dimensions) {
  return this.jl_Class__f_data.newArrayOfThisClass(dimensions)
});
function $as_jl_Class(obj) {
  return (((obj instanceof $c_jl_Class) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Class"))
}
function $isArrayOf_jl_Class(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Class)))
}
function $asArrayOf_jl_Class(obj, depth) {
  return (($isArrayOf_jl_Class(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Class;", depth))
}
var $d_jl_Class = new $TypeData().initClass({
  jl_Class: 0
}, false, "java.lang.Class", {
  jl_Class: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_constant_Constable: 1
});
$c_jl_Class.prototype.$classData = $d_jl_Class;
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.jl_Enum__f__name = _name;
  $thiz.jl_Enum__f__ordinal = _ordinal;
  return $thiz
}
/** @constructor */
function $c_jl_Enum() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_jl_Enum.prototype = new $h_O();
$c_jl_Enum.prototype.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
  /*<skip>*/
}
$h_jl_Enum.prototype = $c_jl_Enum.prototype;
$c_jl_Enum.prototype.toString__T = (function() {
  return this.jl_Enum__f__name
});
$c_jl_Enum.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_jl_Enum.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this)
});
$c_jl_Enum.prototype.compareTo__jl_Enum__I = (function(o) {
  var x = this.jl_Enum__f__ordinal;
  var y = $n(o).jl_Enum__f__ordinal;
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1))
});
$c_jl_Enum.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__jl_Enum__I($as_jl_Enum(o))
});
function $as_jl_Enum(obj) {
  return (((obj instanceof $c_jl_Enum) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Enum"))
}
function $isArrayOf_jl_Enum(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Enum)))
}
function $asArrayOf_jl_Enum(obj, depth) {
  return (($isArrayOf_jl_Enum(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Enum;", depth))
}
function $ct_jl_Error__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_Error extends $c_jl_Throwable {
}
function $as_jl_Error(obj) {
  return (((obj instanceof $c_jl_Error) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Error"))
}
function $isArrayOf_jl_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Error)))
}
function $asArrayOf_jl_Error(obj, depth) {
  return (($isArrayOf_jl_Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Error;", depth))
}
var $d_jl_Error = new $TypeData().initClass({
  jl_Error: 0
}, false, "java.lang.Error", {
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Error.prototype.$classData = $d_jl_Error;
function $ct_jl_Exception__T__jl_Throwable__($thiz, message, cause) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz
}
function $ct_jl_Exception__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_Exception__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_Exception extends $c_jl_Throwable {
}
var $d_jl_Exception = new $TypeData().initClass({
  jl_Exception: 0
}, false, "java.lang.Exception", {
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Exception.prototype.$classData = $d_jl_Exception;
/** @constructor */
function $c_Ljava_security_SecureRandom() {
  this.ju_Random__f_seedHi = 0;
  this.ju_Random__f_seedLo = 0;
  this.Ljava_security_SecureRandom__f_getRandomValuesFun = null;
  $ct_ju_Random__J__(this, $L0);
  this.Ljava_security_SecureRandom__f_getRandomValuesFun = $m_Ljava_security_SecureRandom$().java$security$SecureRandom$$getRandomValuesFun__sjs_js_Function1()
}
$c_Ljava_security_SecureRandom.prototype = new $h_ju_Random();
$c_Ljava_security_SecureRandom.prototype.constructor = $c_Ljava_security_SecureRandom;
/** @constructor */
function $h_Ljava_security_SecureRandom() {
  /*<skip>*/
}
$h_Ljava_security_SecureRandom.prototype = $c_Ljava_security_SecureRandom.prototype;
$c_Ljava_security_SecureRandom.prototype.setSeed__J__V = (function(x) {
  /*<skip>*/
});
$c_Ljava_security_SecureRandom.prototype.nextBytes__AB__V = (function(bytes) {
  var len = $n(bytes).u.length;
  var buffer = new Int8Array(len);
  (0, this.Ljava_security_SecureRandom__f_getRandomValuesFun)(buffer);
  var i = 0;
  while ((i !== len)) {
    $n(bytes).set(i, $uB(buffer[i]));
    i = ((1 + i) | 0)
  }
});
$c_Ljava_security_SecureRandom.prototype.next__I__I = (function(numBits) {
  if ((numBits <= 0)) {
    return 0
  } else {
    var buffer = new Int32Array(1);
    (0, this.Ljava_security_SecureRandom__f_getRandomValuesFun)(buffer);
    var rand32 = $uI(buffer[0]);
    return (rand32 & (((-1) >>> ((32 - numBits) | 0)) | 0))
  }
});
var $d_Ljava_security_SecureRandom = new $TypeData().initClass({
  Ljava_security_SecureRandom: 0
}, false, "java.security.SecureRandom", {
  Ljava_security_SecureRandom: 1,
  ju_Random: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_security_SecureRandom.prototype.$classData = $d_Ljava_security_SecureRandom;
/** @constructor */
function $c_Ljava_time_Clock$SystemClock(zone) {
  this.Ljava_time_Clock$SystemClock__f_zone = null;
  this.Ljava_time_Clock$SystemClock__f_zone = zone;
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "'zone' can not be null")
  }
}
$c_Ljava_time_Clock$SystemClock.prototype = new $h_Ljava_time_Clock();
$c_Ljava_time_Clock$SystemClock.prototype.constructor = $c_Ljava_time_Clock$SystemClock;
/** @constructor */
function $h_Ljava_time_Clock$SystemClock() {
  /*<skip>*/
}
$h_Ljava_time_Clock$SystemClock.prototype = $c_Ljava_time_Clock$SystemClock.prototype;
$c_Ljava_time_Clock$SystemClock.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_Clock$SystemClock)) {
    var x2 = $as_Ljava_time_Clock$SystemClock(obj);
    var x = this.Ljava_time_Clock$SystemClock__f_zone;
    var x$2 = $n(x2).Ljava_time_Clock$SystemClock__f_zone;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ljava_time_Clock$SystemClock.prototype.hashCode__I = (function() {
  return ((1 + $n(this.Ljava_time_Clock$SystemClock__f_zone).hashCode__I()) | 0)
});
$c_Ljava_time_Clock$SystemClock.prototype.toString__T = (function() {
  return (("SystemClock[" + this.Ljava_time_Clock$SystemClock__f_zone) + "]")
});
function $as_Ljava_time_Clock$SystemClock(obj) {
  return (((obj instanceof $c_Ljava_time_Clock$SystemClock) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Clock$SystemClock"))
}
function $isArrayOf_Ljava_time_Clock$SystemClock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Clock$SystemClock)))
}
function $asArrayOf_Ljava_time_Clock$SystemClock(obj, depth) {
  return (($isArrayOf_Ljava_time_Clock$SystemClock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Clock$SystemClock;", depth))
}
var $d_Ljava_time_Clock$SystemClock = new $TypeData().initClass({
  Ljava_time_Clock$SystemClock: 0
}, false, "java.time.Clock$SystemClock", {
  Ljava_time_Clock$SystemClock: 1,
  Ljava_time_Clock: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Clock$SystemClock.prototype.$classData = $d_Ljava_time_Clock$SystemClock;
/** @constructor */
function $c_Ljava_time_ZoneRegion(id, rules) {
  this.Ljava_time_ZoneRegion__f_id = null;
  this.Ljava_time_ZoneRegion__f_rules = null;
  this.Ljava_time_ZoneRegion__f_id = id;
  this.Ljava_time_ZoneRegion__f_rules = rules;
  $ct_Ljava_time_ZoneId__(this)
}
$c_Ljava_time_ZoneRegion.prototype = new $h_Ljava_time_ZoneId();
$c_Ljava_time_ZoneRegion.prototype.constructor = $c_Ljava_time_ZoneRegion;
/** @constructor */
function $h_Ljava_time_ZoneRegion() {
  /*<skip>*/
}
$h_Ljava_time_ZoneRegion.prototype = $c_Ljava_time_ZoneRegion.prototype;
$c_Ljava_time_ZoneRegion.prototype.getId__T = (function() {
  return this.Ljava_time_ZoneRegion__f_id
});
$c_Ljava_time_ZoneRegion.prototype.getRules__Ljava_time_zone_ZoneRules = (function() {
  return ((this.Ljava_time_ZoneRegion__f_rules !== null) ? this.Ljava_time_ZoneRegion__f_rules : $m_Ljava_time_zone_ZoneRulesProvider$().getRules__T__Z__Ljava_time_zone_ZoneRules(this.Ljava_time_ZoneRegion__f_id, false))
});
var $d_Ljava_time_ZoneRegion = new $TypeData().initClass({
  Ljava_time_ZoneRegion: 0
}, false, "java.time.ZoneRegion", {
  Ljava_time_ZoneRegion: 1,
  Ljava_time_ZoneId: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_ZoneRegion.prototype.$classData = $d_Ljava_time_ZoneRegion;
function $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V($thiz, fieldValues, field, value) {
  var current = $as_jl_Long($n(fieldValues).get__O__O(field));
  if ((current !== null)) {
    var this$1 = $n(current);
    var this$2 = $uJ(this$1);
    var $$x1 = (!((this$2.RTLong__f_lo === value.RTLong__f_lo) && (this$2.RTLong__f_hi === value.RTLong__f_hi)))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((("Invalid state, field: " + field) + " ") + current) + " conflicts with ") + field) + " ") + value))
  } else {
    $n(fieldValues).put__O__O__O(field, value)
  }
}
function $f_Ljava_time_chrono_Chronology__equals__O__Z($thiz, obj) {
  if ($is_Ljava_time_chrono_Chronology(obj)) {
    var x2 = $as_Ljava_time_chrono_Chronology(obj);
    return (($thiz === x2) || ($f_T__compareTo__T__I("ISO", ($n(x2), "ISO")) === 0))
  } else {
    return false
  }
}
function $f_Ljava_time_chrono_Chronology__hashCode__I($thiz) {
  var this$1 = $objectGetClass($thiz);
  return ($systemIdentityHashCode(this$1) ^ $f_T__hashCode__I("ISO"))
}
function $is_Ljava_time_chrono_Chronology(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_Chronology)))
}
function $as_Ljava_time_chrono_Chronology(obj) {
  return (($is_Ljava_time_chrono_Chronology(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.Chronology"))
}
function $isArrayOf_Ljava_time_chrono_Chronology(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_Chronology)))
}
function $asArrayOf_Ljava_time_chrono_Chronology(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_Chronology(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.Chronology;", depth))
}
function $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($thiz, field, value) {
  $n($thiz.fieldValues__ju_Map()).put__O__O__O(field, value);
  return $thiz
}
function $p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z($thiz, resolverStyle) {
  var changes = 0;
  var entries = $n($n($thiz.fieldValues__ju_Map()).entrySet__ju_Set()).iterator__ju_Iterator();
  var break$1 = false;
  while (((!break$1) && $n(entries).hasNext__Z())) {
    var entry = $as_ju_Map$Entry($n(entries).next__O());
    var targetField = $as_Ljava_time_temporal_TemporalField($n(entry).getKey__O());
    var resolvedObject = $n(targetField).resolve__ju_Map__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_ResolverStyle__Ljava_time_temporal_TemporalAccessor($thiz.fieldValues__ju_Map(), $thiz, resolverStyle);
    var x1 = resolvedObject;
    if ($is_Ljava_time_chrono_ChronoZonedDateTime(x1)) {
      var x2 = $as_Ljava_time_chrono_ChronoZonedDateTime(x1);
      if (($thiz.zone__Ljava_time_ZoneId() === null)) {
        var this$1 = $n(x2);
        $thiz.zone_$eq__Ljava_time_ZoneId__V(this$1.Ljava_time_ZonedDateTime__f_zone)
      } else {
        var x = $thiz.zone__Ljava_time_ZoneId();
        var this$2 = $n(x2);
        var x$2 = this$2.Ljava_time_ZonedDateTime__f_zone;
        if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("ChronoZonedDateTime must use the effective parsed zone: " + $thiz.zone__Ljava_time_ZoneId()))
        }
      };
      var this$3 = $n(x2);
      resolvedObject = this$3.Ljava_time_ZonedDateTime__f_dateTime
    } else if ($is_Ljava_time_chrono_ChronoLocalDate(x1)) {
      var x3 = $as_Ljava_time_chrono_ChronoLocalDate(x1);
      $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, x3);
      changes = ((1 + changes) | 0);
      break$1 = true
    } else if ((x1 instanceof $c_Ljava_time_LocalTime)) {
      var x4 = $as_Ljava_time_LocalTime(x1);
      $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, x4);
      changes = ((1 + changes) | 0);
      break$1 = true
    } else if ((x1 instanceof $c_Ljava_time_chrono_ChronoLocalDateTime)) {
      var x5 = $as_Ljava_time_chrono_ChronoLocalDateTime(x1);
      var this$4 = $n(x5);
      $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, this$4.Ljava_time_LocalDateTime__f_date);
      var this$5 = $n(x5);
      $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, this$5.Ljava_time_LocalDateTime__f_time);
      changes = ((1 + changes) | 0);
      break$1 = true
    } else if ((x1 === null)) {
      if ((!$n($thiz.fieldValues__ju_Map()).containsKey__O__Z(targetField))) {
        changes = ((1 + changes) | 0);
        break$1 = true
      }
    } else {
      var this$6 = $n(resolvedObject);
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unknown type: " + $objectGetClass(this$6).getName__T()))
    }
  };
  if ((changes === 100)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Badly written field")
  };
  return (changes > 0)
}
function $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, date) {
  var x = $thiz.chrono__Ljava_time_chrono_Chronology();
  $n(date);
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  if ((x === null)) {
    var $$x1 = (x$2 === null)
  } else {
    var this$2 = $n(x);
    var $$x1 = $f_Ljava_time_chrono_Chronology__equals__O__Z(this$2, x$2)
  };
  if ((!$$x1)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("ChronoLocalDate must use the effective parsed chronology: " + $thiz.chrono__Ljava_time_chrono_Chronology()))
  };
  var t = $n(date).toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var old = $as_jl_Long($n($thiz.fieldValues__ju_Map()).put__O__O__O($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo, hi)));
  if ((old !== null)) {
    var this$4 = $n(old);
    var this$5 = $uJ(this$4);
    var $$x2 = (!((this$5.RTLong__f_lo === lo) && (this$5.RTLong__f_hi === hi)))
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Conflict found: " + $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate($uJ(old))) + " differs from ") + $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi))) + " while resolving  ") + targetField))
  }
}
function $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, time) {
  var t = $n(time).toNanoOfDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var old = $as_jl_Long($n($thiz.fieldValues__ju_Map()).put__O__O__O($m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo, hi)));
  if ((old !== null)) {
    var this$2 = $n(old);
    var this$3 = $uJ(this$2);
    var $$x1 = (!((this$3.RTLong__f_lo === lo) && (this$3.RTLong__f_hi === hi)))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Conflict found: " + $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime($uJ(old))) + " differs from ") + time) + " while resolving  ") + targetField))
  }
}
function $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  if (($thiz.chrono__Ljava_time_chrono_Chronology() instanceof $c_Ljava_time_chrono_IsoChronology)) {
    $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, $n($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()).resolveDate__ju_Map__Ljava_time_format_ResolverStyle__Ljava_time_LocalDate($thiz.fieldValues__ju_Map(), resolverStyle))
  } else if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $$x1 = $m_Ljava_time_LocalDate$();
    var x = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField()));
    $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, $n($$x1).ofEpochDay__J__Ljava_time_LocalDate($uJ(x)))
  }
}
function $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, date) {
  if ((date !== null)) {
    $thiz.date_$eq__Ljava_time_chrono_ChronoLocalDate__V(date);
    var fields = $n($n($thiz.fieldValues__ju_Map()).keySet__ju_Set()).iterator__ju_Iterator();
    var break$1 = false;
    while (((!break$1) && $n(fields).hasNext__Z())) {
      var field = $as_Ljava_time_temporal_TemporalField($n(fields).next__O());
      if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
        if ($n(field).isDateBased__Z()) {
          var val1__lo = 0;
          var val1__hi = 0;
          try {
            var t = $n(date).getLong__Ljava_time_temporal_TemporalField__J(field);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            var $$x1__lo = lo;
            var $$x1__hi = hi;
            val1__lo = $$x1__lo;
            val1__hi = $$x1__hi
          } catch (e) {
            if ((e instanceof $c_Ljava_time_DateTimeException)) {
              break$1 = true
            } else {
              throw e
            }
          };
          if ((!break$1)) {
            var x = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O(field));
            var t$1 = $uJ(x);
            var lo$1 = t$1.RTLong__f_lo;
            var hi$1 = t$1.RTLong__f_hi;
            var this$2__lo = val1__lo;
            var this$2__hi = val1__hi;
            if ((!((this$2__lo === lo$1) && (this$2__hi === hi$1)))) {
              throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((((("Conflict found: Field " + field) + " ") + new $c_RTLong(val1__lo, val1__hi)) + " differs from ") + field) + " ") + new $c_RTLong(lo$1, hi$1)) + " derived from ") + date))
            }
          }
        }
      }
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      if ((!((resolverStyle === $m_Ljava_time_format_ResolverStyle$().SMART__Ljava_time_format_ResolverStyle()) && ((lo === 0) && (hi === 0))))) {
        var this$2 = $n($m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
        $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo, hi), this$2)
      }
    };
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), (((lo === 24) && (hi === 0)) ? $L0 : new $c_RTLong(lo, hi)))
  };
  if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField())) {
    var x$1 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()));
    var t$1 = $uJ(x$1);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      if ((!((resolverStyle === $m_Ljava_time_format_ResolverStyle$().SMART__Ljava_time_format_ResolverStyle()) && ((lo$1 === 0) && (hi$1 === 0))))) {
        var this$4 = $n($m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField());
        $n(this$4.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$1, hi$1), this$4)
      }
    };
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($m_Ljava_time_temporal_ChronoField$().HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), (((lo$1 === 12) && (hi$1 === 0)) ? $L0 : new $c_RTLong(lo$1, hi$1)))
  };
  if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
    if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().AMPM_OF_DAY__Ljava_time_temporal_ChronoField())) {
      var this$6 = $n($m_Ljava_time_temporal_ChronoField$().AMPM_OF_DAY__Ljava_time_temporal_ChronoField());
      var x$2 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().AMPM_OF_DAY__Ljava_time_temporal_ChronoField()));
      var t$2 = $uJ(x$2);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      $n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$2, hi$2), this$6)
    };
    if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().HOUR_OF_AMPM__Ljava_time_temporal_ChronoField())) {
      var this$8 = $n($m_Ljava_time_temporal_ChronoField$().HOUR_OF_AMPM__Ljava_time_temporal_ChronoField());
      var x$3 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()));
      var t$3 = $uJ(x$3);
      var lo$3 = t$3.RTLong__f_lo;
      var hi$3 = t$3.RTLong__f_hi;
      $n(this$8.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$3, hi$3), this$8)
    }
  };
  if (($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().AMPM_OF_DAY__Ljava_time_temporal_ChronoField()) && $n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()))) {
    var x$4 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().AMPM_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$4 = $uJ(x$4);
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var x$5 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()));
    var t$5 = $uJ(x$5);
    var lo$5 = t$5.RTLong__f_lo;
    var hi$5 = t$5.RTLong__f_hi;
    var $$x1 = $m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var b0 = (65535 & lo$4);
    var b1 = ((lo$4 >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo$6 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$6 = ((Math.imul(12, hi$4) + ((c1part >>> 16) | 0)) | 0);
    var lo$7 = ((lo$6 + lo$5) | 0);
    var hi$7 = ((((-2147483648) ^ lo$7) < ((-2147483648) ^ lo$6)) ? ((1 + ((hi$6 + hi$5) | 0)) | 0) : ((hi$6 + hi$5) | 0));
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x1, new $c_RTLong(lo$7, hi$7))
  };
  if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$6 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$6 = $uJ(x$6);
    var lo$8 = t$6.RTLong__f_lo;
    var hi$8 = t$6.RTLong__f_hi;
    if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$13 = $n($m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField());
      $n(this$13.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$8, hi$8), this$13)
    };
    var $$x2 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$14 = $m_RTLong$();
    var lo$9 = this$14.divideImpl__I__I__I__I__I(lo$8, hi$8, 1000000000, 0);
    var hi$9 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x2, new $c_RTLong(lo$9, hi$9));
    var $$x3 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$15 = $m_RTLong$();
    var lo$10 = this$15.remainderImpl__I__I__I__I__I(lo$8, hi$8, 1000000000, 0);
    var hi$10 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x3, new $c_RTLong(lo$10, hi$10))
  };
  if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MICRO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$7 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().MICRO_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$7 = $uJ(x$7);
    var lo$11 = t$7.RTLong__f_lo;
    var hi$11 = t$7.RTLong__f_hi;
    if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$17 = $n($m_Ljava_time_temporal_ChronoField$().MICRO_OF_DAY__Ljava_time_temporal_ChronoField());
      $n(this$17.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$11, hi$11), this$17)
    };
    var $$x4 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$18 = $m_RTLong$();
    var lo$12 = this$18.divideImpl__I__I__I__I__I(lo$11, hi$11, 1000000, 0);
    var hi$12 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x4, new $c_RTLong(lo$12, hi$12));
    var $$x5 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$19 = $m_RTLong$();
    var lo$13 = this$19.remainderImpl__I__I__I__I__I(lo$11, hi$11, 1000000, 0);
    var hi$13 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x5, new $c_RTLong(lo$13, hi$13))
  };
  if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MILLI_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$8 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().MILLI_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$8 = $uJ(x$8);
    var lo$14 = t$8.RTLong__f_lo;
    var hi$14 = t$8.RTLong__f_hi;
    if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$21 = $n($m_Ljava_time_temporal_ChronoField$().MILLI_OF_DAY__Ljava_time_temporal_ChronoField());
      $n(this$21.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$14, hi$14), this$21)
    };
    var $$x6 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$22 = $m_RTLong$();
    var lo$15 = this$22.divideImpl__I__I__I__I__I(lo$14, hi$14, 1000, 0);
    var hi$15 = this$22.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x6, new $c_RTLong(lo$15, hi$15));
    var $$x7 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$23 = $m_RTLong$();
    var lo$16 = this$23.remainderImpl__I__I__I__I__I(lo$14, hi$14, 1000, 0);
    var hi$16 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x7, new $c_RTLong(lo$16, hi$16))
  };
  if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$9 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$9 = $uJ(x$9);
    var lo$17 = t$9.RTLong__f_lo;
    var hi$17 = t$9.RTLong__f_hi;
    if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$25 = $n($m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField());
      $n(this$25.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$17, hi$17), this$25)
    };
    var $$x8 = $m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$26 = $m_RTLong$();
    var lo$18 = this$26.divideImpl__I__I__I__I__I(lo$17, hi$17, 3600, 0);
    var hi$18 = this$26.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x8, new $c_RTLong(lo$18, hi$18));
    var $$x9 = $m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var this$27 = $m_RTLong$();
    var lo$19 = this$27.divideImpl__I__I__I__I__I(lo$17, hi$17, 60, 0);
    var hi$19 = this$27.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$28 = $m_RTLong$();
    var lo$20 = this$28.remainderImpl__I__I__I__I__I(lo$19, hi$19, 60, 0);
    var hi$20 = this$28.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x9, new $c_RTLong(lo$20, hi$20));
    var $$x10 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    var this$29 = $m_RTLong$();
    var lo$21 = this$29.remainderImpl__I__I__I__I__I(lo$17, hi$17, 60, 0);
    var hi$21 = this$29.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x10, new $c_RTLong(lo$21, hi$21))
  };
  if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$10 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_DAY__Ljava_time_temporal_ChronoField()));
    var t$10 = $uJ(x$10);
    var lo$22 = t$10.RTLong__f_lo;
    var hi$22 = t$10.RTLong__f_hi;
    if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$31 = $n($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_DAY__Ljava_time_temporal_ChronoField());
      $n(this$31.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$22, hi$22), this$31)
    };
    var $$x11 = $m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$32 = $m_RTLong$();
    var lo$23 = this$32.divideImpl__I__I__I__I__I(lo$22, hi$22, 60, 0);
    var hi$23 = this$32.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x11, new $c_RTLong(lo$23, hi$23));
    var $$x12 = $m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var this$33 = $m_RTLong$();
    var lo$24 = this$33.remainderImpl__I__I__I__I__I(lo$22, hi$22, 60, 0);
    var hi$24 = this$33.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x12, new $c_RTLong(lo$24, hi$24))
  };
  if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
    if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var this$35 = $n($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField());
      var x$11 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()));
      var t$11 = $uJ(x$11);
      var lo$25 = t$11.RTLong__f_lo;
      var hi$25 = t$11.RTLong__f_hi;
      $n(this$35.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$25, hi$25), this$35)
    };
    if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var this$37 = $n($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField());
      var x$12 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()));
      var t$12 = $uJ(x$12);
      var lo$26 = t$12.RTLong__f_lo;
      var hi$26 = t$12.RTLong__f_hi;
      $n(this$37.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$26, hi$26), this$37)
    }
  };
  if (($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()) && $n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var x$13 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var t$13 = $uJ(x$13);
    var lo$27 = t$13.RTLong__f_lo;
    var hi$27 = t$13.RTLong__f_hi;
    var x$14 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var t$14 = $uJ(x$14);
    var lo$28 = t$14.RTLong__f_lo;
    var hi$28 = t$14.RTLong__f_hi;
    var $$x13 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$1 = (65535 & lo$27);
    var b1$1 = ((lo$27 >>> 16) | 0);
    var a0b0$1 = Math.imul(1000, b0$1);
    var a0b1$1 = Math.imul(1000, b1$1);
    var lo$29 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$29 = ((Math.imul(1000, hi$27) + ((c1part$1 >>> 16) | 0)) | 0);
    var this$40 = $m_RTLong$();
    var lo$30 = this$40.remainderImpl__I__I__I__I__I(lo$28, hi$28, 1000, 0);
    var hi$30 = this$40.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$31 = ((lo$29 + lo$30) | 0);
    var hi$31 = ((((-2147483648) ^ lo$31) < ((-2147483648) ^ lo$29)) ? ((1 + ((hi$29 + hi$30) | 0)) | 0) : ((hi$29 + hi$30) | 0));
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x13, new $c_RTLong(lo$31, hi$31))
  };
  if (($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()) && $n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var x$15 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var t$15 = $uJ(x$15);
    var lo$32 = t$15.RTLong__f_lo;
    var hi$32 = t$15.RTLong__f_hi;
    var $$x14 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$43 = $m_RTLong$();
    var lo$33 = this$43.divideImpl__I__I__I__I__I(lo$32, hi$32, 1000, 0);
    var hi$33 = this$43.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x14, new $c_RTLong(lo$33, hi$33));
    $n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())
  };
  if (($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()) && $n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var x$16 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var t$16 = $uJ(x$16);
    var lo$34 = t$16.RTLong__f_lo;
    var hi$34 = t$16.RTLong__f_hi;
    var $$x15 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$45 = $m_RTLong$();
    var lo$35 = this$45.divideImpl__I__I__I__I__I(lo$34, hi$34, 1000000, 0);
    var hi$35 = this$45.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x15, new $c_RTLong(lo$35, hi$35));
    $n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())
  };
  if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var x$17 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var t$17 = $uJ(x$17);
    var lo$36 = t$17.RTLong__f_lo;
    var hi$36 = t$17.RTLong__f_hi;
    var $$x16 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$2 = (65535 & lo$36);
    var b1$2 = ((lo$36 >>> 16) | 0);
    var a0b0$2 = Math.imul(1000, b0$2);
    var a0b1$2 = Math.imul(1000, b1$2);
    var lo$37 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$37 = ((Math.imul(1000, hi$36) + ((c1part$2 >>> 16) | 0)) | 0);
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x16, new $c_RTLong(lo$37, hi$37))
  } else if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var x$18 = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var t$18 = $uJ(x$18);
    var lo$38 = t$18.RTLong__f_lo;
    var hi$38 = t$18.RTLong__f_hi;
    var $$x17 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$3 = (65535 & lo$38);
    var b1$3 = ((lo$38 >>> 16) | 0);
    var a0b0$3 = Math.imul(16960, b0$3);
    var a1b0 = Math.imul(15, b0$3);
    var a0b1$3 = Math.imul(16960, b1$3);
    var lo$39 = ((a0b0$3 + (((a1b0 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$39 = ((((((Math.imul(1000000, hi$38) + Math.imul(15, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0) | 0) >>> 16) | 0)) | 0);
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x17, new $c_RTLong(lo$39, hi$39))
  }
}
function $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  var hod = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField()));
  var moh = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField()));
  var som = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField()));
  var nos = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField()));
  if ((hod === null)) {
    return (void 0)
  };
  if (((moh === null) && ((som !== null) || (nos !== null)))) {
    return (void 0)
  };
  if ((((moh !== null) && (som === null)) && (nos !== null))) {
    return (void 0)
  };
  if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
    if ((hod !== null)) {
      if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().SMART__Ljava_time_format_ResolverStyle())) {
        var this$1 = $n(hod);
        var this$2 = $uJ(this$1);
        var $$x4 = ((this$2.RTLong__f_lo === 24) && (this$2.RTLong__f_hi === 0))
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        if ((moh === null)) {
          var $$x3 = true
        } else {
          var this$3 = $n(moh);
          var this$4 = $uJ(this$3);
          var $$x3 = ((this$4.RTLong__f_lo === 0) && (this$4.RTLong__f_hi === 0))
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        if ((som === null)) {
          var $$x2 = true
        } else {
          var this$5 = $n(som);
          var this$6 = $uJ(this$5);
          var $$x2 = ((this$6.RTLong__f_lo === 0) && (this$6.RTLong__f_hi === 0))
        }
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        if ((nos === null)) {
          var $$x1 = true
        } else {
          var this$7 = $n(nos);
          var this$8 = $uJ(this$7);
          var $$x1 = ((this$8.RTLong__f_lo === 0) && (this$8.RTLong__f_hi === 0))
        }
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        hod = $L0;
        var this$10 = $m_Ljava_time_Period$();
        $thiz.excessDays_$eq__Ljava_time_Period__V(this$10.java$time$Period$$create__I__I__I__Ljava_time_Period(0, 0, 1))
      };
      var this$12 = $n($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
      var x = hod;
      var t = $uJ(x);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var hodVal = $n(this$12.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo, hi), this$12);
      if ((moh !== null)) {
        var this$14 = $n($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
        var t$1 = $uJ(moh);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var mohVal = $n(this$14.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$1, hi$1), this$14);
        if ((som !== null)) {
          var this$16 = $n($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
          var t$2 = $uJ(som);
          var lo$2 = t$2.RTLong__f_lo;
          var hi$2 = t$2.RTLong__f_hi;
          var somVal = $n(this$16.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$2, hi$2), this$16);
          if ((nos !== null)) {
            var this$18 = $n($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
            var x$1 = nos;
            var t$3 = $uJ(x$1);
            var lo$3 = t$3.RTLong__f_lo;
            var hi$3 = t$3.RTLong__f_hi;
            var nosVal = $n(this$18.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$3, hi$3), this$18);
            var time = $m_Ljava_time_LocalTime$().of__I__I__I__I__Ljava_time_LocalTime(hodVal, mohVal, somVal, nosVal);
            $thiz.time_$eq__Ljava_time_LocalTime__V(time)
          } else {
            var time$1 = $m_Ljava_time_LocalTime$().of__I__I__I__Ljava_time_LocalTime(hodVal, mohVal, somVal);
            $thiz.time_$eq__Ljava_time_LocalTime__V(time$1)
          }
        } else if ((nos === null)) {
          var time$2 = $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(hodVal, mohVal);
          $thiz.time_$eq__Ljava_time_LocalTime__V(time$2)
        }
      } else if (((som === null) && (nos === null))) {
        var time$3 = $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(hodVal, 0);
        $thiz.time_$eq__Ljava_time_LocalTime__V(time$3)
      }
    }
  } else if ((hod !== null)) {
    var x$2 = hod;
    var t$4 = $uJ(x$2);
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var hodVal$2__lo = lo$4;
    var hodVal$2__hi = hi$4;
    if ((moh !== null)) {
      if ((som !== null)) {
        if ((nos === null)) {
          nos = $L0
        };
        var a__lo = hodVal$2__lo;
        var a__hi = hodVal$2__hi;
        var t$5 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a__lo, a__hi), new $c_RTLong(817405952, 838));
        var lo$5 = t$5.RTLong__f_lo;
        var hi$5 = t$5.RTLong__f_hi;
        var totalNanos__lo = lo$5;
        var totalNanos__hi = hi$5;
        var a$1__lo = totalNanos__lo;
        var a$1__hi = totalNanos__hi;
        var t$6 = $uJ(moh);
        var lo$6 = t$6.RTLong__f_lo;
        var hi$6 = t$6.RTLong__f_hi;
        var t$7 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$6, hi$6), new $c_RTLong((-129542144), 13));
        var lo$7 = t$7.RTLong__f_lo;
        var hi$7 = t$7.RTLong__f_hi;
        var t$8 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a$1__lo, a$1__hi), new $c_RTLong(lo$7, hi$7));
        var lo$8 = t$8.RTLong__f_lo;
        var hi$8 = t$8.RTLong__f_hi;
        var $$x5__lo = lo$8;
        var $$x5__hi = hi$8;
        totalNanos__lo = $$x5__lo;
        totalNanos__hi = $$x5__hi;
        var a$2__lo = totalNanos__lo;
        var a$2__hi = totalNanos__hi;
        var t$9 = $uJ(som);
        var lo$9 = t$9.RTLong__f_lo;
        var hi$9 = t$9.RTLong__f_hi;
        var t$10 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$9, hi$9), new $c_RTLong(1000000000, 0));
        var lo$10 = t$10.RTLong__f_lo;
        var hi$10 = t$10.RTLong__f_hi;
        var t$11 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a$2__lo, a$2__hi), new $c_RTLong(lo$10, hi$10));
        var lo$11 = t$11.RTLong__f_lo;
        var hi$11 = t$11.RTLong__f_hi;
        var $$x6__lo = lo$11;
        var $$x6__hi = hi$11;
        totalNanos__lo = $$x6__lo;
        totalNanos__hi = $$x6__hi;
        var a$3__lo = totalNanos__lo;
        var a$3__hi = totalNanos__hi;
        var x$3 = nos;
        var t$12 = $uJ(x$3);
        var lo$12 = t$12.RTLong__f_lo;
        var hi$12 = t$12.RTLong__f_hi;
        var t$13 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a$3__lo, a$3__hi), new $c_RTLong(lo$12, hi$12));
        var lo$13 = t$13.RTLong__f_lo;
        var hi$13 = t$13.RTLong__f_hi;
        var $$x7__lo = lo$13;
        var $$x7__hi = hi$13;
        totalNanos__lo = $$x7__lo;
        totalNanos__hi = $$x7__hi;
        var a$4__lo = totalNanos__lo;
        var a$4__hi = totalNanos__hi;
        var this$24 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(a$4__lo, a$4__hi), new $c_RTLong((-1857093632), 20116));
        var excessDays = this$24.RTLong__f_lo;
        var a$5__lo = totalNanos__lo;
        var a$5__hi = totalNanos__hi;
        var t$14 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(a$5__lo, a$5__hi), new $c_RTLong((-1857093632), 20116));
        var lo$14 = t$14.RTLong__f_lo;
        var hi$14 = t$14.RTLong__f_hi;
        var time$4 = $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$14, hi$14));
        $thiz.time_$eq__Ljava_time_LocalTime__V(time$4);
        var this$25 = $m_Ljava_time_Period$();
        $thiz.excessDays_$eq__Ljava_time_Period__V(this$25.java$time$Period$$create__I__I__I__Ljava_time_Period(0, 0, excessDays))
      } else {
        var a$6__lo = hodVal$2__lo;
        var a$6__hi = hodVal$2__hi;
        var t$15 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$6__lo, a$6__hi), new $c_RTLong(3600, 0));
        var lo$15 = t$15.RTLong__f_lo;
        var hi$15 = t$15.RTLong__f_hi;
        var totalSecs__lo = lo$15;
        var totalSecs__hi = hi$15;
        var a$7__lo = totalSecs__lo;
        var a$7__hi = totalSecs__hi;
        var t$16 = $uJ(moh);
        var lo$16 = t$16.RTLong__f_lo;
        var hi$16 = t$16.RTLong__f_hi;
        var t$17 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$16, hi$16), new $c_RTLong(60, 0));
        var lo$17 = t$17.RTLong__f_lo;
        var hi$17 = t$17.RTLong__f_hi;
        var t$18 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a$7__lo, a$7__hi), new $c_RTLong(lo$17, hi$17));
        var lo$18 = t$18.RTLong__f_lo;
        var hi$18 = t$18.RTLong__f_hi;
        var $$x8__lo = lo$18;
        var $$x8__hi = hi$18;
        totalSecs__lo = $$x8__lo;
        totalSecs__hi = $$x8__hi;
        var a$8__lo = totalSecs__lo;
        var a$8__hi = totalSecs__hi;
        var this$27 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(a$8__lo, a$8__hi), new $c_RTLong(86400, 0));
        var excessDays$2 = this$27.RTLong__f_lo;
        var a$9__lo = totalSecs__lo;
        var a$9__hi = totalSecs__hi;
        var t$19 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(a$9__lo, a$9__hi), new $c_RTLong(86400, 0));
        var lo$19 = t$19.RTLong__f_lo;
        var hi$19 = t$19.RTLong__f_hi;
        var time$5 = $m_Ljava_time_LocalTime$().ofSecondOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$19, hi$19));
        $thiz.time_$eq__Ljava_time_LocalTime__V(time$5);
        var this$28 = $m_Ljava_time_Period$();
        $thiz.excessDays_$eq__Ljava_time_Period__V(this$28.java$time$Period$$create__I__I__I__Ljava_time_Period(0, 0, excessDays$2))
      }
    } else {
      var a$10__lo = hodVal$2__lo;
      var a$10__hi = hodVal$2__hi;
      var t$20 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(a$10__lo, a$10__hi), new $c_RTLong(24, 0));
      var lo$20 = t$20.RTLong__f_lo;
      var hi$20 = t$20.RTLong__f_hi;
      var excessDays$3 = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo$20, hi$20));
      var a$11__lo = hodVal$2__lo;
      var a$11__hi = hodVal$2__hi;
      var t$21 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(a$11__lo, a$11__hi), new $c_RTLong(24, 0));
      var lo$21 = t$21.RTLong__f_lo;
      var hi$21 = t$21.RTLong__f_hi;
      var $$x9__lo = lo$21;
      var $$x9__hi = hi$21;
      hodVal$2__lo = $$x9__lo;
      hodVal$2__hi = $$x9__hi;
      var $$x10 = $m_Ljava_time_LocalTime$();
      var this$29__lo = hodVal$2__lo;
      var this$29__hi = hodVal$2__hi;
      var time$6 = $n($$x10).of__I__I__Ljava_time_LocalTime(this$29__lo, 0);
      $thiz.time_$eq__Ljava_time_LocalTime__V(time$6);
      var this$30 = $m_Ljava_time_Period$();
      $thiz.excessDays_$eq__Ljava_time_Period__V(this$30.java$time$Period$$create__I__I__I__Ljava_time_Period(0, 0, excessDays$3))
    }
  };
  $n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  $n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  $n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  $n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField())
}
function $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V($thiz) {
  if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
    if (($thiz.zone__Ljava_time_ZoneId() !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, $thiz.zone__Ljava_time_ZoneId())
    } else {
      var offsetSecs = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField()));
      if ((offsetSecs !== null)) {
        var $$x1 = $m_Ljava_time_ZoneOffset$();
        var this$1 = $n(offsetSecs);
        var offset = $n($$x1).ofTotalSeconds__I__Ljava_time_ZoneOffset(this$1.RTLong__f_lo);
        $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, offset)
      }
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, selectedZone) {
  var this$2 = $m_Ljava_time_Instant$();
  var x = $as_jl_Long($n($thiz.fieldValues__ju_Map()).remove__O__O($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField()));
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var instant = this$2.java$time$Instant$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo, hi), 0);
  $n($thiz.chrono__Ljava_time_chrono_Chronology());
  var zdt = $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(instant, selectedZone);
  if (($thiz.date__Ljava_time_chrono_ChronoLocalDate() === null)) {
    var this$4 = $n(zdt);
    var this$5 = $n(this$4.Ljava_time_ZonedDateTime__f_dateTime);
    var date = this$5.Ljava_time_LocalDateTime__f_date;
    $thiz.date_$eq__Ljava_time_chrono_ChronoLocalDate__V(date)
  } else {
    var $$x1 = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    var this$6 = $n(zdt);
    var this$7 = $n(this$6.Ljava_time_ZonedDateTime__f_dateTime);
    $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, $$x1, this$7.Ljava_time_LocalDateTime__f_date)
  };
  var $$x2 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var this$8 = $n(zdt);
  var this$9 = $n(this$8.Ljava_time_ZonedDateTime__f_dateTime);
  var value = $n(this$9.Ljava_time_LocalDateTime__f_time).toSecondOfDay__I();
  var hi$1 = (value >> 31);
  $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($$x2, new $c_RTLong(value, hi$1))
}
function $p_Ljava_time_format_DateTimeBuilder__crossCheck__V($thiz) {
  if (($n($thiz.fieldValues__ju_Map()).size__I() > 0)) {
    if ((($thiz.date__Ljava_time_chrono_ChronoLocalDate() !== null) && ($thiz.time__Ljava_time_LocalTime() !== null))) {
      var this$1 = $n($thiz.date__Ljava_time_chrono_ChronoLocalDate());
      var localTime = $thiz.time__Ljava_time_LocalTime();
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$1, localTime))
    } else if (($thiz.date__Ljava_time_chrono_ChronoLocalDate() !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $thiz.date__Ljava_time_chrono_ChronoLocalDate())
    } else if (($thiz.time__Ljava_time_LocalTime() !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $thiz.time__Ljava_time_LocalTime())
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, temporal) {
  var it = $n($n($thiz.fieldValues__ju_Map()).entrySet__ju_Set()).iterator__ju_Iterator();
  while ($n(it).hasNext__Z()) {
    var entry = $as_ju_Map$Entry($n(it).next__O());
    var field = $as_Ljava_time_temporal_TemporalField($n(entry).getKey__O());
    var x = $as_jl_Long($n(entry).getValue__O());
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z(field)) {
      var temporalValue__lo = 0;
      var temporalValue__hi = 0;
      try {
        var t$1 = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J(field);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var $$x1__lo = lo$1;
        var $$x1__hi = hi$1;
        temporalValue__lo = $$x1__lo;
        temporalValue__hi = $$x1__hi
      } catch (e) {
        var e$1 = e;
        var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
        if ((!(e$2 instanceof $c_jl_RuntimeException))) {
          throw e
        }
      };
      var this$3__lo = temporalValue__lo;
      var this$3__hi = temporalValue__hi;
      if ((!((this$3__lo === lo) && (this$3__hi === hi)))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((("Cross check failed: " + field) + " ") + new $c_RTLong(temporalValue__lo, temporalValue__hi)) + " vs ") + field) + " ") + new $c_RTLong(lo, hi)))
      };
      $n(it).remove__V()
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V($thiz) {
  if ((($thiz.time__Ljava_time_LocalTime() === null) && (($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || $n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField())) || $n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField())))) {
    if ($n($thiz.fieldValues__ju_Map()).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var x = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField()));
      var t = $uJ(x);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var $$x2 = $n($thiz.fieldValues__ju_Map());
      var $$x1 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      var this$2 = $m_RTLong$();
      var lo$1 = this$2.divideImpl__I__I__I__I__I(lo, hi, 1000, 0);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      $n($$x2).put__O__O__O($$x1, new $c_RTLong(lo$1, hi$1));
      var $$x4 = $n($thiz.fieldValues__ju_Map());
      var $$x3 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      var this$4 = $m_RTLong$();
      var lo$2 = this$4.divideImpl__I__I__I__I__I(lo, hi, 1000000, 0);
      var hi$2 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      $n($$x4).put__O__O__O($$x3, new $c_RTLong(lo$2, hi$2))
    } else {
      $n($thiz.fieldValues__ju_Map()).put__O__O__O($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), $L0);
      $n($thiz.fieldValues__ju_Map()).put__O__O__O($m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField(), $L0);
      $n($thiz.fieldValues__ju_Map()).put__O__O__O($m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField(), $L0)
    }
  }
}
function $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V($thiz) {
  if ((($thiz.date__Ljava_time_chrono_ChronoLocalDate() !== null) && ($thiz.time__Ljava_time_LocalTime() !== null))) {
    var offsetSecs = $as_jl_Long($n($thiz.fieldValues__ju_Map()).get__O__O($m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField()));
    if ((offsetSecs !== null)) {
      var $$x1 = $m_Ljava_time_ZoneOffset$();
      var this$1 = $n(offsetSecs);
      var offset = $n($$x1).ofTotalSeconds__I__Ljava_time_ZoneOffset(this$1.RTLong__f_lo);
      var this$2 = $n($thiz.date__Ljava_time_chrono_ChronoLocalDate());
      var localTime = $thiz.time__Ljava_time_LocalTime();
      var this$3 = $n($m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$2, localTime));
      var this$4 = $m_Ljava_time_ZonedDateTime$();
      var t = $n(this$4.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this$3, offset, null)).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      $n($thiz.fieldValues__ju_Map()).put__O__O__O($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo, hi))
    } else if (($thiz.zone__Ljava_time_ZoneId() !== null)) {
      var this$6 = $n($thiz.date__Ljava_time_chrono_ChronoLocalDate());
      var localTime$1 = $thiz.time__Ljava_time_LocalTime();
      var this$7 = $n($m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$6, localTime$1));
      var zone = $thiz.zone__Ljava_time_ZoneId();
      var this$8 = $m_Ljava_time_ZonedDateTime$();
      var t$1 = $n(this$8.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this$7, zone, null)).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      $n($thiz.fieldValues__ju_Map()).put__O__O__O($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo$1, hi$1))
    }
  }
}
/** @constructor */
function $c_Ljava_time_format_DateTimeBuilder() {
  this.Ljava_time_format_DateTimeBuilder__f_fieldValues = null;
  this.Ljava_time_format_DateTimeBuilder__f_chrono = null;
  this.Ljava_time_format_DateTimeBuilder__f_zone = null;
  this.Ljava_time_format_DateTimeBuilder__f_date = null;
  this.Ljava_time_format_DateTimeBuilder__f_time = null;
  this.Ljava_time_format_DateTimeBuilder__f_excessDays = null;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = 0;
  this.Ljava_time_format_DateTimeBuilder__f_fieldValues = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((1 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_DateTimeBuilder__f_chrono = null;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((2 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_DateTimeBuilder__f_zone = null;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((4 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_DateTimeBuilder__f_date = null;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((8 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_DateTimeBuilder__f_time = null;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((16 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((32 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_format_DateTimeBuilder__f_excessDays = null;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((64 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_format_DateTimeBuilder.prototype = new $h_O();
$c_Ljava_time_format_DateTimeBuilder.prototype.constructor = $c_Ljava_time_format_DateTimeBuilder;
/** @constructor */
function $h_Ljava_time_format_DateTimeBuilder() {
  /*<skip>*/
}
$h_Ljava_time_format_DateTimeBuilder.prototype = $c_Ljava_time_format_DateTimeBuilder.prototype;
$c_Ljava_time_format_DateTimeBuilder.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.fieldValues__ju_Map = (function() {
  if (((((1 & this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeBuilder.scala: 76")
  };
  return this.Ljava_time_format_DateTimeBuilder__f_fieldValues
});
$c_Ljava_time_format_DateTimeBuilder.prototype.chrono__Ljava_time_chrono_Chronology = (function() {
  if (((((2 & this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeBuilder.scala: 81")
  };
  return this.Ljava_time_format_DateTimeBuilder__f_chrono
});
$c_Ljava_time_format_DateTimeBuilder.prototype.chrono_$eq__Ljava_time_chrono_Chronology__V = (function(x$1) {
  this.Ljava_time_format_DateTimeBuilder__f_chrono = x$1;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((2 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.zone__Ljava_time_ZoneId = (function() {
  if (((((4 & this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeBuilder.scala: 85")
  };
  return this.Ljava_time_format_DateTimeBuilder__f_zone
});
$c_Ljava_time_format_DateTimeBuilder.prototype.zone_$eq__Ljava_time_ZoneId__V = (function(x$1) {
  this.Ljava_time_format_DateTimeBuilder__f_zone = x$1;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((4 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.date__Ljava_time_chrono_ChronoLocalDate = (function() {
  if (((((8 & this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeBuilder.scala: 89")
  };
  return this.Ljava_time_format_DateTimeBuilder__f_date
});
$c_Ljava_time_format_DateTimeBuilder.prototype.date_$eq__Ljava_time_chrono_ChronoLocalDate__V = (function(x$1) {
  this.Ljava_time_format_DateTimeBuilder__f_date = x$1;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((8 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.time__Ljava_time_LocalTime = (function() {
  if (((((16 & this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeBuilder.scala: 93")
  };
  return this.Ljava_time_format_DateTimeBuilder__f_time
});
$c_Ljava_time_format_DateTimeBuilder.prototype.time_$eq__Ljava_time_LocalTime__V = (function(x$1) {
  this.Ljava_time_format_DateTimeBuilder__f_time = x$1;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((16 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.leapSecond_$eq__Z__V = (function(x$1) {
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((32 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.excessDays__Ljava_time_Period = (function() {
  if (((((64 & this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/DateTimeBuilder.scala: 101")
  };
  return this.Ljava_time_format_DateTimeBuilder__f_excessDays
});
$c_Ljava_time_format_DateTimeBuilder.prototype.excessDays_$eq__Ljava_time_Period__V = (function(x$1) {
  this.Ljava_time_format_DateTimeBuilder__f_excessDays = x$1;
  this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0 = (((64 | this.Ljava_time_format_DateTimeBuilder__f_bitmap$init$0) << 24) >> 24)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder = (function(field, value) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  var old = $as_jl_Long($n(this.fieldValues__ju_Map()).get__O__O(field));
  if ((old !== null)) {
    var this$2 = $n(old);
    var this$3 = $uJ(this$2);
    var $$x1 = (!((this$3.RTLong__f_lo === value.RTLong__f_lo) && (this$3.RTLong__f_hi === value.RTLong__f_hi)))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((((("Conflict found: " + field) + " ") + old) + " differs from ") + field) + " ") + value) + ": ") + this))
  } else {
    return $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder(this, field, value)
  }
});
$c_Ljava_time_format_DateTimeBuilder.prototype.resolve__Ljava_time_format_ResolverStyle__ju_Set__Ljava_time_format_DateTimeBuilder = (function(resolverStyle, resolverFields) {
  if ((resolverFields !== null)) {
    $n($n(this.fieldValues__ju_Map()).keySet__ju_Set()).retainAll__ju_Collection__Z(resolverFields)
  };
  $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V(this);
  $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  if ($p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z(this, resolverStyle)) {
    $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V(this);
    $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
    $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V(this, resolverStyle)
  };
  $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  $p_Ljava_time_format_DateTimeBuilder__crossCheck__V(this);
  if (((((this.excessDays__Ljava_time_Period() !== null) && (!$n(this.excessDays__Ljava_time_Period()).isZero__Z())) && (this.date__Ljava_time_chrono_ChronoLocalDate() !== null)) && (this.time__Ljava_time_LocalTime() !== null))) {
    var this$1 = $n(this.date__Ljava_time_chrono_ChronoLocalDate());
    var amount = this.excessDays__Ljava_time_Period();
    this.date_$eq__Ljava_time_chrono_ChronoLocalDate__V($as_Ljava_time_LocalDate($n(amount).addTo__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this$1)));
    this.excessDays_$eq__Ljava_time_Period__V($m_Ljava_time_Period$().ZERO__Ljava_time_Period())
  };
  $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V(this);
  $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V(this);
  return this
});
$c_Ljava_time_format_DateTimeBuilder.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field !== null)) {
    if ($n(this.fieldValues__ju_Map()).containsKey__O__Z(field)) {
      var $$x1 = true
    } else if ((this.date__Ljava_time_chrono_ChronoLocalDate() !== null)) {
      var this$1 = $n(this.date__Ljava_time_chrono_ChronoLocalDate());
      var $$x1 = $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$1, field)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return true
    } else {
      return ((this.time__Ljava_time_LocalTime() !== null) && $n(this.time__Ljava_time_LocalTime()).isSupported__Ljava_time_temporal_TemporalField__Z(field))
    }
  } else {
    return false
  }
});
$c_Ljava_time_format_DateTimeBuilder.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field")
  };
  var value = $as_jl_Long($n(this.fieldValues__ju_Map()).get__O__O(field));
  if ((value === null)) {
    if ((this.date__Ljava_time_chrono_ChronoLocalDate() !== null)) {
      var this$2 = $n(this.date__Ljava_time_chrono_ChronoLocalDate());
      var $$x1 = $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$2, field)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $n(this.date__Ljava_time_chrono_ChronoLocalDate()).getLong__Ljava_time_temporal_TemporalField__J(field)
    };
    if (((this.time__Ljava_time_LocalTime() !== null) && $n(this.time__Ljava_time_LocalTime()).isSupported__Ljava_time_temporal_TemporalField__Z(field))) {
      return $n(this.time__Ljava_time_LocalTime()).getLong__Ljava_time_temporal_TemporalField__J(field)
    };
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field not found: " + field))
  };
  return $uJ(value)
});
$c_Ljava_time_format_DateTimeBuilder.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) ? this.zone__Ljava_time_ZoneId() : ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.chrono__Ljava_time_chrono_Chronology() : ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? ((this.date__Ljava_time_chrono_ChronoLocalDate() !== null) ? $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(this.date__Ljava_time_chrono_ChronoLocalDate()) : null) : ((query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery()) ? this.time__Ljava_time_LocalTime() : (((query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this) : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? null : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)))))))
});
$c_Ljava_time_format_DateTimeBuilder.prototype.toString__T = (function() {
  var fields = (($n(this.fieldValues__ju_Map()).size__I() > 0) ? (("fields=" + this.fieldValues__ju_Map()) + ", ") : "");
  return (((((((((("DateTimeBuilder[" + fields) + " ") + this.chrono__Ljava_time_chrono_Chronology()) + ", ") + this.zone__Ljava_time_ZoneId()) + ", ") + this.date__Ljava_time_chrono_ChronoLocalDate()) + ", ") + this.time__Ljava_time_LocalTime()) + "]")
});
var $d_Ljava_time_format_DateTimeBuilder = new $TypeData().initClass({
  Ljava_time_format_DateTimeBuilder: 0
}, false, "java.time.format.DateTimeBuilder", {
  Ljava_time_format_DateTimeBuilder: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  jl_Cloneable: 1
});
$c_Ljava_time_format_DateTimeBuilder.prototype.$classData = $d_Ljava_time_format_DateTimeBuilder;
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__($thiz, field, minWidth, maxWidth, baseValue, baseDate, subsequentWidth) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue = baseValue;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate = baseDate;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, $m_Ljava_time_format_SignStyle$().NOT_NEGATIVE__Ljava_time_format_SignStyle(), subsequentWidth);
  if ((($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth < 1) || ($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth > 10))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The width must be from 1 to 10 inclusive but was " + $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth))
  };
  if ((($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth < 1) || ($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth > 10))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The maxWidth must be from 1 to 10 inclusive but was " + $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth))
  };
  if (($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth < $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "The maxWidth must be greater than the width")
  };
  if ((baseDate === null)) {
    var $$x1 = $n($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field).range__Ljava_time_temporal_ValueRange();
    var hi = (baseValue >> 31);
    if ((!$n($$x1).isValidValue__J__Z(new $c_RTLong(baseValue, hi)))) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "The base value must be within the range of the field")
    };
    var hi$1 = (baseValue >> 31);
    var value = $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().EXCEED_POINTS__AI()).get($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth);
    var hi$2 = (value >> 31);
    var lo = ((baseValue + value) | 0);
    var hi$3 = ((((-2147483648) ^ lo) < ((-2147483648) ^ baseValue)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
    if (((hi$3 === 0) ? (((-2147483648) ^ lo) > (-1)) : (hi$3 > 0))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Unable to add printer-parser as the range exceeds the capacity of an int")
    }
  };
  return $thiz
}
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__($thiz, field, minWidth, maxWidth, baseValue, baseDate) {
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__($thiz, field, minWidth, maxWidth, baseValue, baseDate, 0);
  return $thiz
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate = null
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.getValue__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_Long__jl_Long = (function(context, value) {
  var t = $uJ(value);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if ((hi < 0)) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var x__lo = lo$1;
    var x__hi = hi$1
  } else {
    var x__lo = lo;
    var x__hi = hi
  };
  var baseValue = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue;
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate !== null)) {
    var $$x1 = $m_Ljava_time_chrono_Chronology$();
    var this$6 = $n(context);
    var chrono = $n($$x1).from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(this$6.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal);
    $n(chrono);
    var temporal = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate;
    baseValue = $n($m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)).get__Ljava_time_temporal_TemporalField__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field)
  };
  var this$10 = $uJ(value);
  var value$1 = baseValue;
  var hi$2 = (value$1 >> 31);
  var ahi = this$10.RTLong__f_hi;
  if (((ahi === hi$2) ? (((-2147483648) ^ this$10.RTLong__f_lo) >= ((-2147483648) ^ value$1)) : (ahi > hi$2))) {
    var this$13 = $uJ(value);
    var value$2 = ((baseValue + $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().EXCEED_POINTS__AI()).get(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) | 0);
    var hi$3 = (value$2 >> 31);
    var ahi$1 = this$13.RTLong__f_hi;
    var $$x2 = ((ahi$1 === hi$3) ? (((-2147483648) ^ this$13.RTLong__f_lo) < ((-2147483648) ^ value$2)) : (ahi$1 < hi$3))
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var this$16 = $uJ(new $c_RTLong(x__lo, x__hi));
    var value$3 = $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().EXCEED_POINTS__AI()).get(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth);
    var hi$4 = (value$3 >> 31);
    var this$17 = $m_RTLong$();
    var lo$2 = this$17.remainderImpl__I__I__I__I__I(this$16.RTLong__f_lo, this$16.RTLong__f_hi, value$3, hi$4);
    var hi$5 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$2, hi$5)
  };
  var this$21 = $uJ(new $c_RTLong(x__lo, x__hi));
  var value$4 = $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().EXCEED_POINTS__AI()).get(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth);
  var hi$6 = (value$4 >> 31);
  var this$22 = $m_RTLong$();
  var lo$3 = this$22.remainderImpl__I__I__I__I__I(this$21.RTLong__f_lo, this$21.RTLong__f_hi, value$4, hi$6);
  var hi$7 = this$22.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo$3, hi$7)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I = (function(context, value, errorPos, successPos) {
  var _value = value;
  var baseValue = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue;
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate !== null)) {
    var chrono = $n(context).getEffectiveChronology__Ljava_time_chrono_Chronology();
    $n(chrono);
    var temporal = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate;
    baseValue = $n($m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal)).get__Ljava_time_temporal_TemporalField__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field);
    var $$x1 = $n(context);
    var x = _value;
    $n($$x1).addChronologyChangedParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__J__I__I__V(this, $uJ(x), errorPos, successPos)
  };
  var parseLen = ((successPos - errorPos) | 0);
  if ((parseLen === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) {
    var x$1 = _value;
    var this$4 = $uJ(x$1);
    var ahi = this$4.RTLong__f_hi;
    var $$x2 = (ahi >= 0)
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var value$1 = $n($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().EXCEED_POINTS__AI()).get(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth);
    var hi = (value$1 >> 31);
    var value$2 = baseValue;
    var hi$1 = (value$2 >> 31);
    var b = $uJ(new $c_RTLong(value$1, hi));
    var this$9 = $m_RTLong$();
    var lo = this$9.remainderImpl__I__I__I__I__I(value$2, hi$1, b.RTLong__f_lo, b.RTLong__f_hi);
    var hi$2 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var value$3 = baseValue;
    var hi$3 = (value$3 >> 31);
    var b$1 = $uJ(new $c_RTLong(lo, hi$2));
    var bhi = b$1.RTLong__f_hi;
    var lo$1 = ((value$3 - b$1.RTLong__f_lo) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value$3)) ? (((-1) + ((hi$3 - bhi) | 0)) | 0) : ((hi$3 - bhi) | 0));
    if ((baseValue > 0)) {
      var this$17 = $uJ(new $c_RTLong(lo$1, hi$4));
      var x$2 = _value;
      var b$2 = $uJ(x$2);
      var alo = this$17.RTLong__f_lo;
      var ahi$1 = this$17.RTLong__f_hi;
      var bhi$1 = b$2.RTLong__f_hi;
      var lo$2 = ((alo + b$2.RTLong__f_lo) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ alo)) ? ((1 + ((ahi$1 + bhi$1) | 0)) | 0) : ((ahi$1 + bhi$1) | 0));
      _value = new $c_RTLong(lo$2, hi$5)
    } else {
      var this$22 = $uJ(new $c_RTLong(lo$1, hi$4));
      var x$3 = _value;
      var b$3 = $uJ(x$3);
      var alo$1 = this$22.RTLong__f_lo;
      var ahi$2 = this$22.RTLong__f_hi;
      var bhi$2 = b$3.RTLong__f_hi;
      var lo$3 = ((alo$1 - b$3.RTLong__f_lo) | 0);
      var hi$6 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$2 - bhi$2) | 0)) | 0) : ((ahi$2 - bhi$2) | 0));
      _value = new $c_RTLong(lo$3, hi$6)
    };
    var x$4 = _value;
    var this$27 = $uJ(x$4);
    var value$4 = baseValue;
    var hi$7 = (value$4 >> 31);
    var ahi$3 = this$27.RTLong__f_hi;
    if (((ahi$3 === hi$7) ? (((-2147483648) ^ this$27.RTLong__f_lo) < ((-2147483648) ^ value$4)) : (ahi$3 < hi$7))) {
      var x$5 = _value;
      var this$30 = $uJ(x$5);
      var b$4 = $uJ(new $c_RTLong(value$1, hi));
      var alo$2 = this$30.RTLong__f_lo;
      var ahi$4 = this$30.RTLong__f_hi;
      var bhi$3 = b$4.RTLong__f_hi;
      var lo$4 = ((alo$2 + b$4.RTLong__f_lo) | 0);
      var hi$8 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ alo$2)) ? ((1 + ((ahi$4 + bhi$3) | 0)) | 0) : ((ahi$4 + bhi$3) | 0));
      _value = new $c_RTLong(lo$4, hi$8)
    }
  };
  var $$x4 = $n(context);
  var $$x3 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field;
  var x$6 = _value;
  return $n($$x4).setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($$x3, $uJ(x$6), errorPos, successPos)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate, (-1)))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser = (function(subsequentWidth) {
  return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate, ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth + subsequentWidth) | 0))
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z = (function(context) {
  var this$1 = $n(context);
  if (this$1.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict) {
    return $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z.call(this, context)
  } else {
    return false
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.toString__T = (function() {
  return (((((((("ReducedValue(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) + ",") + ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate !== null) ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue)) + ")")
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function(subsequentWidth) {
  return this.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(subsequentWidth)
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ReducedPrinterParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser: 1,
  O: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser;
function $p_Ljava_time_zone_StandardZoneRules__lastRulesCache__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_zone_StandardZoneRules__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/zone/StandardZoneRules.scala: 151")
  };
  return $thiz.Ljava_time_zone_StandardZoneRules__f_lastRulesCache
}
function $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__O($thiz, dt) {
  var nonLocalReturnKey1 = $ct_O__(new $c_O());
  try {
    if ((($n($thiz.Ljava_time_zone_StandardZoneRules__f_lastRules).u.length > 0) && $n(dt).isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z($n($thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions).get((((-1) + $n($thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions).u.length) | 0))))) {
      var this$1 = $n(dt);
      var this$2 = $n(this$1.Ljava_time_LocalDateTime__f_date);
      var transArray = $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition($thiz, this$2.Ljava_time_LocalDate__f_year);
      var info = new $c_sr_ObjectRef(null);
      $m_sc_ArrayOps$();
      var f = ((trans$2) => {
        var trans = $as_Ljava_time_zone_ZoneOffsetTransition(trans$2);
        info.sr_ObjectRef__f_elem = $p_Ljava_time_zone_StandardZoneRules__findOffsetInfo__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition__O($thiz, dt, trans);
        if ((info.sr_ObjectRef__f_elem instanceof $c_Ljava_time_zone_ZoneOffsetTransition)) {
          var $$x1 = true
        } else {
          var x = info.sr_ObjectRef__f_elem;
          var this$6 = $n(trans);
          var x$2 = this$6.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
          var $$x1 = ((x === null) ? (x$2 === null) : $dp_equals__O__Z($n(x), x$2))
        };
        if ($$x1) {
          throw $ct_sr_NonLocalReturnControl__O__O__(new $c_sr_NonLocalReturnControl(), nonLocalReturnKey1, info.sr_ObjectRef__f_elem)
        }
      });
      var len = $n(transArray).u.length;
      var i = 0;
      if ((transArray !== null)) {
        while ((i < len)) {
          var arg1 = $n(transArray).get(i);
          f(arg1);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_I)) {
        var x3 = $asArrayOf_I(transArray, 1);
        while ((i < len)) {
          var arg1$1 = $n(x3).get(i);
          f(arg1$1);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_D)) {
        var x4 = $asArrayOf_D(transArray, 1);
        while ((i < len)) {
          var arg1$2 = $n(x4).get(i);
          f(arg1$2);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_J)) {
        var x5 = $asArrayOf_J(transArray, 1);
        while ((i < len)) {
          var t = $n(x5).get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_F)) {
        var x6 = $asArrayOf_F(transArray, 1);
        while ((i < len)) {
          var arg1$3 = $n(x6).get(i);
          f(arg1$3);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_C)) {
        var x7 = $asArrayOf_C(transArray, 1);
        while ((i < len)) {
          var arg1$4 = $n(x7).get(i);
          f($bC(arg1$4));
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_B)) {
        var x8 = $asArrayOf_B(transArray, 1);
        while ((i < len)) {
          var arg1$5 = $n(x8).get(i);
          f(arg1$5);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_S)) {
        var x9 = $asArrayOf_S(transArray, 1);
        while ((i < len)) {
          var arg1$6 = $n(x9).get(i);
          f(arg1$6);
          i = ((1 + i) | 0)
        }
      } else if ((transArray instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(transArray, 1);
        while ((i < len)) {
          var arg1$7 = $n(x10).get(i);
          f(arg1$7);
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(transArray)
      };
      return info.sr_ObjectRef__f_elem
    };
    var a = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions;
    var index = $m_ju_Arrays$().binarySearch__AO__O__I(a, dt);
    if ((index === (-1))) {
      return $n($thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets).get(0)
    };
    if ((index < 0)) {
      index = (((-2) - index) | 0)
    } else {
      if ((index < (((-1) + $n($thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions).u.length) | 0))) {
        var x$1 = $n($thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions).get(index);
        var x$2$1 = $n($thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions).get(((1 + index) | 0));
        var $$x2 = ((x$1 === null) ? (x$2$1 === null) : $n(x$1).equals__O__Z(x$2$1))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        index = ((1 + index) | 0)
      }
    };
    if (((1 & index) === 0)) {
      var dtBefore = $n($thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions).get(index);
      var dtAfter = $n($thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions).get(((1 + index) | 0));
      var offsetBefore = $n($thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets).get(((index / 2) | 0));
      var offsetAfter = $n($thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets).get(((1 + ((index / 2) | 0)) | 0));
      var this$8 = $n(offsetAfter);
      var $$x3 = this$8.Ljava_time_ZoneOffset__f_totalSeconds;
      var this$9 = $n(offsetBefore);
      if (($$x3 > this$9.Ljava_time_ZoneOffset__f_totalSeconds)) {
        return new $c_Ljava_time_zone_ZoneOffsetTransition(dtBefore, offsetBefore, offsetAfter)
      } else {
        return new $c_Ljava_time_zone_ZoneOffsetTransition(dtAfter, offsetBefore, offsetAfter)
      }
    } else {
      return $n($thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets).get(((1 + ((index / 2) | 0)) | 0))
    }
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = $as_sr_NonLocalReturnControl(e);
      if (($n(ex).sr_NonLocalReturnControl__f_key === nonLocalReturnKey1)) {
        return $n(ex).value__O()
      } else {
        throw ((ex === null) ? $n(null) : ex)
      }
    } else {
      throw e
    }
  }
}
function $p_Ljava_time_zone_StandardZoneRules__findOffsetInfo__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition__O($thiz, dt, trans) {
  var this$1 = $n(trans);
  var localTransition = this$1.Ljava_time_zone_ZoneOffsetTransition__f_transition;
  if ($n(trans).isGap__Z()) {
    if ($n(dt).isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z(localTransition)) {
      var this$2 = $n(trans);
      return this$2.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore
    } else {
      var this$3 = $n(trans);
      var this$5 = $n(this$3.Ljava_time_zone_ZoneOffsetTransition__f_transition);
      var value = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(this$3);
      var hi = (value >> 31);
      if ($n(dt).isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$5, this$5.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value, hi), $L0, 1))) {
        return trans
      } else {
        var this$6 = $n(trans);
        return this$6.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter
      }
    }
  } else if ((!$n(dt).isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z(localTransition))) {
    var this$7 = $n(trans);
    return this$7.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter
  } else {
    var this$8 = $n(trans);
    var this$10 = $n(this$8.Ljava_time_zone_ZoneOffsetTransition__f_transition);
    var value$1 = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(this$8);
    var hi$1 = (value$1 >> 31);
    if ($n(dt).isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$10, this$10.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value$1, hi$1), $L0, 1))) {
      var this$11 = $n(trans);
      return this$11.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore
    } else {
      return trans
    }
  }
}
function $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition($thiz, year) {
  var transArray = $asArrayOf_Ljava_time_zone_ZoneOffsetTransition($n($p_Ljava_time_zone_StandardZoneRules__lastRulesCache__ju_Map($thiz)).get__O__O(year), 1);
  if ((transArray !== null)) {
    return transArray
  };
  var ruleArray = $thiz.Ljava_time_zone_StandardZoneRules__f_lastRules;
  transArray = new ($d_Ljava_time_zone_ZoneOffsetTransition.getArrayOf().constr)($n(ruleArray).u.length);
  var i = 0;
  while ((i < $n(ruleArray).u.length)) {
    $n(transArray).set(i, $n($n(ruleArray).get(i)).createTransition__I__Ljava_time_zone_ZoneOffsetTransition(year));
    i = ((1 + i) | 0)
  };
  if ((year < $m_Ljava_time_zone_StandardZoneRules$().java$time$zone$StandardZoneRules$$LAST_CACHED_YEAR__I())) {
    $n($p_Ljava_time_zone_StandardZoneRules__lastRulesCache__ju_Map($thiz)).put__O__O__O(year, transArray)
  };
  return transArray
}
function $p_Ljava_time_zone_StandardZoneRules__findYear__J__Ljava_time_ZoneOffset__I($thiz, epochSecond, offset) {
  var this$1 = $n(offset);
  var value = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  var alo = epochSecond.RTLong__f_lo;
  var ahi = epochSecond.RTLong__f_hi;
  var lo = ((alo + value) | 0);
  var hi$1 = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi) | 0)) | 0) : ((ahi + hi) | 0));
  var t = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo, hi$1), new $c_RTLong(86400, 0));
  var lo$1 = t.RTLong__f_lo;
  var hi$2 = t.RTLong__f_hi;
  var this$4 = $n($m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$2)));
  return this$4.Ljava_time_LocalDate__f_year
}
/** @constructor */
function $c_Ljava_time_zone_StandardZoneRules(standardTransitions, standardOffsets, savingsInstantTransitions, wallOffsets, lastRules, savingsLocalTransitions) {
  this.Ljava_time_zone_StandardZoneRules__f_standardTransitions = null;
  this.Ljava_time_zone_StandardZoneRules__f_standardOffsets = null;
  this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions = null;
  this.Ljava_time_zone_StandardZoneRules__f_wallOffsets = null;
  this.Ljava_time_zone_StandardZoneRules__f_lastRules = null;
  this.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions = null;
  this.Ljava_time_zone_StandardZoneRules__f_lastRulesCache = null;
  this.Ljava_time_zone_StandardZoneRules__f_bitmap$init$0 = false;
  this.Ljava_time_zone_StandardZoneRules__f_standardTransitions = standardTransitions;
  this.Ljava_time_zone_StandardZoneRules__f_standardOffsets = standardOffsets;
  this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions = savingsInstantTransitions;
  this.Ljava_time_zone_StandardZoneRules__f_wallOffsets = wallOffsets;
  this.Ljava_time_zone_StandardZoneRules__f_lastRules = lastRules;
  this.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions = savingsLocalTransitions;
  this.Ljava_time_zone_StandardZoneRules__f_lastRulesCache = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_zone_StandardZoneRules__f_bitmap$init$0 = true
}
$c_Ljava_time_zone_StandardZoneRules.prototype = new $h_Ljava_time_zone_ZoneRules();
$c_Ljava_time_zone_StandardZoneRules.prototype.constructor = $c_Ljava_time_zone_StandardZoneRules;
/** @constructor */
function $h_Ljava_time_zone_StandardZoneRules() {
  /*<skip>*/
}
$h_Ljava_time_zone_StandardZoneRules.prototype = $c_Ljava_time_zone_StandardZoneRules.prototype;
$c_Ljava_time_zone_StandardZoneRules.prototype.isFixedOffset__Z = (function() {
  return ($n(this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions).u.length === 0)
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  var this$1 = $n(instant);
  var t = this$1.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (($n(this.Ljava_time_zone_StandardZoneRules__f_lastRules).u.length > 0)) {
    var b = $n(this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions).get((((-1) + $n(this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions).u.length) | 0));
    var bhi = b.RTLong__f_hi;
    var $$x1 = ((hi === bhi) ? (((-2147483648) ^ lo) > ((-2147483648) ^ b.RTLong__f_lo)) : (hi > bhi))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var year = $p_Ljava_time_zone_StandardZoneRules__findYear__J__Ljava_time_ZoneOffset__I(this, new $c_RTLong(lo, hi), $n(this.Ljava_time_zone_StandardZoneRules__f_wallOffsets).get((((-1) + $n(this.Ljava_time_zone_StandardZoneRules__f_wallOffsets).u.length) | 0)));
    var transArray = $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition(this, year);
    var trans = null;
    var i = 0;
    while ((i < $n(transArray).u.length)) {
      trans = $n(transArray).get(i);
      var this$2 = $n(trans);
      var b$1 = $n(this$2.Ljava_time_zone_ZoneOffsetTransition__f_transition).toEpochSecond__Ljava_time_ZoneOffset__J(this$2.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
      var bhi$1 = b$1.RTLong__f_hi;
      if (((hi === bhi$1) ? (((-2147483648) ^ lo) < ((-2147483648) ^ b$1.RTLong__f_lo)) : (hi < bhi$1))) {
        var this$3 = $n(trans);
        return this$3.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore
      };
      i = ((1 + i) | 0)
    };
    var this$4 = $n(trans);
    return this$4.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter
  };
  var a = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
  var index = $m_ju_Arrays$().binarySearch__AJ__J__I(a, new $c_RTLong(lo, hi));
  if ((index < 0)) {
    index = (((-2) - index) | 0)
  };
  return $n(this.Ljava_time_zone_StandardZoneRules__f_wallOffsets).get(((1 + index) | 0))
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getValidOffsets__Ljava_time_LocalDateTime__ju_List = (function(localDateTime) {
  var x1 = $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__O(this, localDateTime);
  if ((x1 instanceof $c_Ljava_time_zone_ZoneOffsetTransition)) {
    var x2 = $as_Ljava_time_zone_ZoneOffsetTransition(x1);
    return $n(x2).getValidOffsets__ju_List()
  } else if ((x1 instanceof $c_Ljava_time_ZoneOffset)) {
    var x3 = $as_Ljava_time_ZoneOffset(x1);
    return $m_ju_Collections$().singletonList__O__ju_List(x3)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getTransition__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition = (function(localDateTime) {
  var x1 = $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__O(this, localDateTime);
  if ((x1 instanceof $c_Ljava_time_zone_ZoneOffsetTransition)) {
    var x2 = $as_Ljava_time_zone_ZoneOffsetTransition(x1);
    return x2
  } else {
    return null
  }
});
$c_Ljava_time_zone_StandardZoneRules.prototype.isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z = (function(localDateTime, offset) {
  return $n(this.getValidOffsets__Ljava_time_LocalDateTime__ju_List(localDateTime)).contains__O__Z(offset)
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getStandardOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  var this$1 = $n(instant);
  var t = this$1.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var a = this.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
  var index = $m_ju_Arrays$().binarySearch__AJ__J__I(a, new $c_RTLong(lo, hi));
  if ((index < 0)) {
    index = (((-2) - index) | 0)
  };
  return $n(this.Ljava_time_zone_StandardZoneRules__f_standardOffsets).get(((1 + index) | 0))
});
$c_Ljava_time_zone_StandardZoneRules.prototype.isDaylightSavings__Ljava_time_Instant__Z = (function(instant) {
  var x = this.getStandardOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  var x$2 = this.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  return (!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))
});
$c_Ljava_time_zone_StandardZoneRules.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_zone_StandardZoneRules)) {
    var x2 = $as_Ljava_time_zone_StandardZoneRules(obj);
    if ((this === x2)) {
      return true
    } else {
      var a = this.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
      var b = $n(x2).Ljava_time_zone_StandardZoneRules__f_standardTransitions;
      if ($m_ju_Arrays$().equals__AJ__AJ__Z(a, b)) {
        var a$1 = this.Ljava_time_zone_StandardZoneRules__f_standardOffsets;
        var b$1 = $n(x2).Ljava_time_zone_StandardZoneRules__f_standardOffsets;
        var $$x3 = $m_ju_Arrays$().equals__AO__AO__Z(a$1, b$1)
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var a$2 = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
        var b$2 = $n(x2).Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
        var $$x2 = $m_ju_Arrays$().equals__AJ__AJ__Z(a$2, b$2)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var a$3 = this.Ljava_time_zone_StandardZoneRules__f_wallOffsets;
        var b$3 = $n(x2).Ljava_time_zone_StandardZoneRules__f_wallOffsets;
        var $$x1 = $m_ju_Arrays$().equals__AO__AO__Z(a$3, b$3)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a$4 = this.Ljava_time_zone_StandardZoneRules__f_lastRules;
        var b$4 = $n(x2).Ljava_time_zone_StandardZoneRules__f_lastRules;
        return $m_ju_Arrays$().equals__AO__AO__Z(a$4, b$4)
      } else {
        return false
      }
    }
  } else if ((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed)) {
    if (this.isFixedOffset__Z()) {
      var x = this.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant());
      var this$1 = $n($as_Ljava_time_zone_ZoneRules$Fixed(obj));
      $m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant();
      var x$2 = this$1.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_time_zone_StandardZoneRules.prototype.hashCode__I = (function() {
  var a = this.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
  var $$x4 = $m_ju_Arrays$().hashCode__AJ__I(a);
  var a$1 = this.Ljava_time_zone_StandardZoneRules__f_standardOffsets;
  var $$x3 = $m_ju_Arrays$().hashCode__AO__I(a$1);
  var a$2 = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
  var $$x2 = $m_ju_Arrays$().hashCode__AJ__I(a$2);
  var a$3 = this.Ljava_time_zone_StandardZoneRules__f_wallOffsets;
  var $$x1 = $m_ju_Arrays$().hashCode__AO__I(a$3);
  var a$4 = this.Ljava_time_zone_StandardZoneRules__f_lastRules;
  return (((($$x4 ^ $$x3) ^ $$x2) ^ $$x1) ^ $m_ju_Arrays$().hashCode__AO__I(a$4))
});
$c_Ljava_time_zone_StandardZoneRules.prototype.toString__T = (function() {
  return (("StandardZoneRules[currentStandardOffset=" + $n(this.Ljava_time_zone_StandardZoneRules__f_standardOffsets).get((((-1) + $n(this.Ljava_time_zone_StandardZoneRules__f_standardOffsets).u.length) | 0))) + "]")
});
function $as_Ljava_time_zone_StandardZoneRules(obj) {
  return (((obj instanceof $c_Ljava_time_zone_StandardZoneRules) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.StandardZoneRules"))
}
function $isArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_StandardZoneRules)))
}
function $asArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.StandardZoneRules;", depth))
}
var $d_Ljava_time_zone_StandardZoneRules = new $TypeData().initClass({
  Ljava_time_zone_StandardZoneRules: 0
}, false, "java.time.zone.StandardZoneRules", {
  Ljava_time_zone_StandardZoneRules: 1,
  Ljava_time_zone_ZoneRules: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_StandardZoneRules.prototype.$classData = $d_Ljava_time_zone_StandardZoneRules;
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$Fixed(offset) {
  this.Ljava_time_zone_ZoneRules$Fixed__f_offset = null;
  this.Ljava_time_zone_ZoneRules$Fixed__f_offset = offset
}
$c_Ljava_time_zone_ZoneRules$Fixed.prototype = new $h_Ljava_time_zone_ZoneRules();
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.constructor = $c_Ljava_time_zone_ZoneRules$Fixed;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$Fixed() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneRules$Fixed.prototype = $c_Ljava_time_zone_ZoneRules$Fixed.prototype;
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.isFixedOffset__Z = (function() {
  return true
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  return this.Ljava_time_zone_ZoneRules$Fixed__f_offset
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getValidOffsets__Ljava_time_LocalDateTime__ju_List = (function(localDateTime) {
  var o = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return $m_ju_Collections$().singletonList__O__ju_List(o)
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getTransition__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition = (function(localDateTime) {
  return null
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z = (function(dateTime, offset) {
  var x = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return ((x === null) ? (offset === null) : $n(x).equals__O__Z(offset))
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getStandardOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  return this.Ljava_time_zone_ZoneRules$Fixed__f_offset
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.isDaylightSavings__Ljava_time_Instant__Z = (function(instant) {
  return false
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed)) {
    var x2 = $as_Ljava_time_zone_ZoneRules$Fixed(obj);
    if ((this === x2)) {
      return true
    } else {
      var x = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      var x$2 = $n(x2).Ljava_time_zone_ZoneRules$Fixed__f_offset;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    }
  } else if ((obj instanceof $c_Ljava_time_zone_StandardZoneRules)) {
    var x3 = $as_Ljava_time_zone_StandardZoneRules(obj);
    if ($n(x3).isFixedOffset__Z()) {
      var x$3 = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      var x$4 = $n(x3).getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant());
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.hashCode__I = (function() {
  var this$1 = $n(this.Ljava_time_zone_ZoneRules$Fixed__f_offset);
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $n(this.Ljava_time_zone_ZoneRules$Fixed__f_offset);
  return (1 ^ (((31 + $$x1) | 0) ^ ((31 + this$2.Ljava_time_ZoneOffset__f_totalSeconds) | 0)))
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.toString__T = (function() {
  return ("FixedRules:" + this.Ljava_time_zone_ZoneRules$Fixed__f_offset)
});
function $as_Ljava_time_zone_ZoneRules$Fixed(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRules$Fixed"))
}
function $isArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRules$Fixed)))
}
function $asArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRules$Fixed;", depth))
}
var $d_Ljava_time_zone_ZoneRules$Fixed = new $TypeData().initClass({
  Ljava_time_zone_ZoneRules$Fixed: 0
}, false, "java.time.zone.ZoneRules$Fixed", {
  Ljava_time_zone_ZoneRules$Fixed: 1,
  Ljava_time_zone_ZoneRules: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.$classData = $d_Ljava_time_zone_ZoneRules$Fixed;
function $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z($thiz, iter, o$2) {
  while (true) {
    if ($n(iter).hasNext__Z()) {
      var a = $n(iter).next__O();
      if (((a === null) ? (o$2 === null) : $dp_equals__O__Z($n(a), o$2))) {
        $n(iter).remove__V();
        return true
      }
    } else {
      return false
    }
  }
}
/** @constructor */
function $c_ju_AbstractCollection() {
  /*<skip>*/
}
$c_ju_AbstractCollection.prototype = new $h_O();
$c_ju_AbstractCollection.prototype.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
  /*<skip>*/
}
$h_ju_AbstractCollection.prototype = $c_ju_AbstractCollection.prototype;
$c_ju_AbstractCollection.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0)
});
$c_ju_AbstractCollection.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.iterator__ju_Iterator();
  while ($n(_\uff3fself).hasNext__Z()) {
    var x$1$2 = $n(_\uff3fself).next__O();
    if (((o === null) ? (x$1$2 === null) : $dp_equals__O__Z($n(o), x$1$2))) {
      return true
    }
  };
  return false
});
$c_ju_AbstractCollection.prototype.toArray__AO = (function() {
  return this.toArray__AO__AO(new $ac_O(this.size__I()))
});
$c_ju_AbstractCollection.prototype.toArray__AO__AO = (function(a) {
  if (($n(a).u.length >= this.size__I())) {
    var toFill = a
  } else {
    var $$x1 = $m_jl_reflect_Array$();
    var this$1 = $n(a);
    var toFill = $asArrayOf_O($n($$x1).newInstance__jl_Class__I__O($objectGetClass(this$1).getComponentType__jl_Class(), this.size__I()), 1)
  };
  var iter = this.iterator__ju_Iterator();
  var end = this.size__I();
  var i = 0;
  while ((i < end)) {
    var i$2 = i;
    $n(toFill).set(i$2, $n(iter).next__O());
    i = ((1 + i) | 0)
  };
  if (($n(toFill).u.length > this.size__I())) {
    $n(toFill).set(this.size__I(), null)
  };
  return toFill
});
$c_ju_AbstractCollection.prototype.add__O__Z = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_AbstractCollection.prototype.remove__O__Z = (function(o) {
  return $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z(this, this.iterator__ju_Iterator(), o)
});
$c_ju_AbstractCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = $n(c).iterator__ju_Iterator();
  _return: {
    while ($n(_\uff3fself).hasNext__Z()) {
      var x$2 = $n(_\uff3fself).next__O();
      if ((!this.contains__O__Z(x$2))) {
        var $$x1 = true;
        break _return
      }
    };
    var $$x1 = false
  };
  return (!$$x1)
});
$c_ju_AbstractCollection.prototype.addAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = $n(c).iterator__ju_Iterator();
  var result = false;
  while ($n(_\uff3fself).hasNext__Z()) {
    var prev$2 = result;
    var elem$2 = $n(_\uff3fself).next__O();
    var prev = $uZ(prev$2);
    result = (this.add__O__Z(elem$2) || prev)
  };
  return $uZ(result)
});
$c_ju_AbstractCollection.prototype.retainAll__ju_Collection__Z = (function(c) {
  var iter = this.iterator__ju_Iterator();
  var changed = false;
  while ($n(iter).hasNext__Z()) {
    var x$4$2 = $n(iter).next__O();
    if ((!$n(c).contains__O__Z(x$4$2))) {
      $n(iter).remove__V();
      changed = true
    }
  };
  return changed
});
$c_ju_AbstractCollection.prototype.toString__T = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = "[";
  var first = true;
  while ($n(_\uff3fself).hasNext__Z()) {
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (("" + result) + $n(_\uff3fself).next__O())
  };
  return (result + "]")
});
/** @constructor */
function $c_ju_AbstractMap$SimpleImmutableEntry(key, value) {
  this.ju_AbstractMap$SimpleImmutableEntry__f_key = null;
  this.ju_AbstractMap$SimpleImmutableEntry__f_value = null;
  this.ju_AbstractMap$SimpleImmutableEntry__f_key = key;
  this.ju_AbstractMap$SimpleImmutableEntry__f_value = value
}
$c_ju_AbstractMap$SimpleImmutableEntry.prototype = new $h_O();
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.constructor = $c_ju_AbstractMap$SimpleImmutableEntry;
/** @constructor */
function $h_ju_AbstractMap$SimpleImmutableEntry() {
  /*<skip>*/
}
$h_ju_AbstractMap$SimpleImmutableEntry.prototype = $c_ju_AbstractMap$SimpleImmutableEntry.prototype;
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.getKey__O = (function() {
  return this.ju_AbstractMap$SimpleImmutableEntry__f_key
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.getValue__O = (function() {
  return this.ju_AbstractMap$SimpleImmutableEntry__f_value
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.equals__O__Z = (function(o) {
  return $m_ju_AbstractMap$().java$util$AbstractMap$$entryEquals__ju_Map$Entry__O__Z(this, o)
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.hashCode__I = (function() {
  return $m_ju_AbstractMap$().java$util$AbstractMap$$entryHashCode__ju_Map$Entry__I(this)
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.toString__T = (function() {
  return ((this.ju_AbstractMap$SimpleImmutableEntry__f_key + "=") + this.ju_AbstractMap$SimpleImmutableEntry__f_value)
});
var $d_ju_AbstractMap$SimpleImmutableEntry = new $TypeData().initClass({
  ju_AbstractMap$SimpleImmutableEntry: 0
}, false, "java.util.AbstractMap$SimpleImmutableEntry", {
  ju_AbstractMap$SimpleImmutableEntry: 1,
  O: 1,
  ju_Map$Entry: 1,
  Ljava_io_Serializable: 1
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.$classData = $d_ju_AbstractMap$SimpleImmutableEntry;
function $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__($thiz, inner) {
  $thiz.ju_Collections$UnmodifiableIterator__f_inner = inner;
  return $thiz
}
/** @constructor */
function $c_ju_Collections$UnmodifiableIterator() {
  this.ju_Collections$UnmodifiableIterator__f_inner = null
}
$c_ju_Collections$UnmodifiableIterator.prototype = new $h_O();
$c_ju_Collections$UnmodifiableIterator.prototype.constructor = $c_ju_Collections$UnmodifiableIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableIterator() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableIterator.prototype = $c_ju_Collections$UnmodifiableIterator.prototype;
$c_ju_Collections$UnmodifiableIterator.prototype.hasNext__Z = (function() {
  return $n(this.ju_Collections$UnmodifiableIterator__f_inner).hasNext__Z()
});
$c_ju_Collections$UnmodifiableIterator.prototype.next__O = (function() {
  return $n(this.ju_Collections$UnmodifiableIterator__f_inner).next__O()
});
$c_ju_Collections$UnmodifiableIterator.prototype.remove__V = (function() {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
var $d_ju_Collections$UnmodifiableIterator = new $TypeData().initClass({
  ju_Collections$UnmodifiableIterator: 0
}, false, "java.util.Collections$UnmodifiableIterator", {
  ju_Collections$UnmodifiableIterator: 1,
  O: 1,
  ju_Collections$WrappedIterator: 1,
  ju_Iterator: 1
});
$c_ju_Collections$UnmodifiableIterator.prototype.$classData = $d_ju_Collections$UnmodifiableIterator;
/** @constructor */
function $c_ju_HashMap$KeyIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer)
}
$c_ju_HashMap$KeyIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$KeyIterator.prototype.constructor = $c_ju_HashMap$KeyIterator;
/** @constructor */
function $h_ju_HashMap$KeyIterator() {
  /*<skip>*/
}
$h_ju_HashMap$KeyIterator.prototype = $c_ju_HashMap$KeyIterator.prototype;
$c_ju_HashMap$KeyIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return $n(node).ju_HashMap$Node__f_key
});
var $d_ju_HashMap$KeyIterator = new $TypeData().initClass({
  ju_HashMap$KeyIterator: 0
}, false, "java.util.HashMap$KeyIterator", {
  ju_HashMap$KeyIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_HashMap$KeyIterator.prototype.$classData = $d_ju_HashMap$KeyIterator;
/** @constructor */
function $c_ju_HashMap$NodeIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer)
}
$c_ju_HashMap$NodeIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$NodeIterator.prototype.constructor = $c_ju_HashMap$NodeIterator;
/** @constructor */
function $h_ju_HashMap$NodeIterator() {
  /*<skip>*/
}
$h_ju_HashMap$NodeIterator.prototype = $c_ju_HashMap$NodeIterator.prototype;
$c_ju_HashMap$NodeIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node
});
var $d_ju_HashMap$NodeIterator = new $TypeData().initClass({
  ju_HashMap$NodeIterator: 0
}, false, "java.util.HashMap$NodeIterator", {
  ju_HashMap$NodeIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_HashMap$NodeIterator.prototype.$classData = $d_ju_HashMap$NodeIterator;
/** @constructor */
function $c_ju_LinkedHashMap$KeyIterator(outer) {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer)
}
$c_ju_LinkedHashMap$KeyIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$c_ju_LinkedHashMap$KeyIterator.prototype.constructor = $c_ju_LinkedHashMap$KeyIterator;
/** @constructor */
function $h_ju_LinkedHashMap$KeyIterator() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$KeyIterator.prototype = $c_ju_LinkedHashMap$KeyIterator.prototype;
$c_ju_LinkedHashMap$KeyIterator.prototype.extract__ju_LinkedHashMap$Node__O = (function(node) {
  return $n(node).ju_HashMap$Node__f_key
});
var $d_ju_LinkedHashMap$KeyIterator = new $TypeData().initClass({
  ju_LinkedHashMap$KeyIterator: 0
}, false, "java.util.LinkedHashMap$KeyIterator", {
  ju_LinkedHashMap$KeyIterator: 1,
  ju_LinkedHashMap$AbstractLinkedHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_LinkedHashMap$KeyIterator.prototype.$classData = $d_ju_LinkedHashMap$KeyIterator;
/** @constructor */
function $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, older, younger) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  this.ju_LinkedHashMap$Node__f_older = null;
  this.ju_LinkedHashMap$Node__f_younger = null;
  this.ju_LinkedHashMap$Node__f_older = older;
  this.ju_LinkedHashMap$Node__f_younger = younger;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next)
}
$c_ju_LinkedHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_LinkedHashMap$Node.prototype.constructor = $c_ju_LinkedHashMap$Node;
/** @constructor */
function $h_ju_LinkedHashMap$Node() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$Node.prototype = $c_ju_LinkedHashMap$Node.prototype;
function $as_ju_LinkedHashMap$Node(obj) {
  return (((obj instanceof $c_ju_LinkedHashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.LinkedHashMap$Node"))
}
function $isArrayOf_ju_LinkedHashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_LinkedHashMap$Node)))
}
function $asArrayOf_ju_LinkedHashMap$Node(obj, depth) {
  return (($isArrayOf_ju_LinkedHashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.LinkedHashMap$Node;", depth))
}
var $d_ju_LinkedHashMap$Node = new $TypeData().initClass({
  ju_LinkedHashMap$Node: 0
}, false, "java.util.LinkedHashMap$Node", {
  ju_LinkedHashMap$Node: 1,
  ju_HashMap$Node: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_ju_LinkedHashMap$Node.prototype.$classData = $d_ju_LinkedHashMap$Node;
/** @constructor */
function $c_ju_LinkedHashMap$NodeIterator(outer) {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer)
}
$c_ju_LinkedHashMap$NodeIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$c_ju_LinkedHashMap$NodeIterator.prototype.constructor = $c_ju_LinkedHashMap$NodeIterator;
/** @constructor */
function $h_ju_LinkedHashMap$NodeIterator() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$NodeIterator.prototype = $c_ju_LinkedHashMap$NodeIterator.prototype;
$c_ju_LinkedHashMap$NodeIterator.prototype.extract__ju_LinkedHashMap$Node__O = (function(node) {
  return node
});
var $d_ju_LinkedHashMap$NodeIterator = new $TypeData().initClass({
  ju_LinkedHashMap$NodeIterator: 0
}, false, "java.util.LinkedHashMap$NodeIterator", {
  ju_LinkedHashMap$NodeIterator: 1,
  ju_LinkedHashMap$AbstractLinkedHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_LinkedHashMap$NodeIterator.prototype.$classData = $d_ju_LinkedHashMap$NodeIterator;
function $f_ju_List__sort__ju_Comparator__V($thiz, c) {
  var arrayBuf = $thiz.toArray__AO();
  $m_ju_Arrays$().sort__AO__ju_Comparator__V(arrayBuf, c);
  var len = $n(arrayBuf).u.length;
  if ($is_ju_RandomAccess($thiz)) {
    var i = 0;
    while ((i !== len)) {
      $thiz.set__I__O__O(i, $n(arrayBuf).get(i));
      i = ((1 + i) | 0)
    }
  } else {
    var i$2 = 0;
    var iter = $thiz.listIterator__ju_ListIterator();
    while ((i$2 !== len)) {
      $n(iter).next__O();
      $n(iter).set__O__V($n(arrayBuf).get(i$2));
      i$2 = ((1 + i$2) | 0)
    }
  }
}
function $is_ju_List(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_List)))
}
function $as_ju_List(obj) {
  return (($is_ju_List(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.List"))
}
function $isArrayOf_ju_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_List)))
}
function $asArrayOf_ju_List(obj, depth) {
  return (($isArrayOf_ju_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.List;", depth))
}
/** @constructor */
function $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next)
}
$c_ju_NullRejectingHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_NullRejectingHashMap$Node.prototype.constructor = $c_ju_NullRejectingHashMap$Node;
/** @constructor */
function $h_ju_NullRejectingHashMap$Node() {
  /*<skip>*/
}
$h_ju_NullRejectingHashMap$Node.prototype = $c_ju_NullRejectingHashMap$Node.prototype;
var $d_ju_NullRejectingHashMap$Node = new $TypeData().initClass({
  ju_NullRejectingHashMap$Node: 0
}, false, "java.util.NullRejectingHashMap$Node", {
  ju_NullRejectingHashMap$Node: 1,
  ju_HashMap$Node: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_ju_NullRejectingHashMap$Node.prototype.$classData = $d_ju_NullRejectingHashMap$Node;
function $is_ju_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Set)))
}
function $as_ju_Set(obj) {
  return (($is_ju_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Set"))
}
function $isArrayOf_ju_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Set)))
}
function $asArrayOf_ju_Set(obj, depth) {
  return (($isArrayOf_ju_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Set;", depth))
}
function $p_ju_TimeZone__atIndex$1__AT__I__s_Option($thiz, strs, idx) {
  return (((idx >= 0) && (idx < $n(strs).u.length)) ? $m_s_Option$().apply__O__s_Option($n(strs).get(idx)) : $m_s_None$())
}
function $p_ju_TimeZone__currentIdStrings$1__AT__T__Z($thiz, strs, id$1) {
  var this$1 = $n($p_ju_TimeZone__atIndex$1__AT__I__s_Option($thiz, strs, 0));
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var x$2 = $as_T(arg1);
    return (x$2 === id$1)
  } else {
    return false
  }
}
function $ct_ju_TimeZone__($thiz) {
  return $thiz
}
/** @constructor */
function $c_ju_TimeZone() {
  /*<skip>*/
}
$c_ju_TimeZone.prototype = new $h_O();
$c_ju_TimeZone.prototype.constructor = $c_ju_TimeZone;
/** @constructor */
function $h_ju_TimeZone() {
  /*<skip>*/
}
$h_ju_TimeZone.prototype = $c_ju_TimeZone.prototype;
$c_ju_TimeZone.prototype.getDisplayName__Z__I__ju_Locale__T = (function(daylight, style, locale) {
  if (((style !== 0) && (style !== 1))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Illegal timezone style: " + style))
  };
  var id = this.ju_SimpleTimeZone__f_ID;
  var zoneStrings = $n($m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale)).Ljava_text_DateFormatSymbols__f_zoneStrings;
  $m_sc_ArrayOps$();
  $m_sc_ArrayOps$();
  $m_sc_ArrayOps$();
  var from = 0;
  _return: {
    var i = from;
    while ((i < $n(zoneStrings).u.length)) {
      var x1 = i;
      var arg1 = $n(zoneStrings).get(x1);
      var strs = $asArrayOf_T(arg1, 1);
      if ($p_ju_TimeZone__currentIdStrings$1__AT__T__Z(this, strs, id)) {
        var idx = i;
        break _return
      };
      i = ((1 + i) | 0)
    };
    var idx = (-1)
  };
  var this$4 = $n(((idx === (-1)) ? $m_s_None$() : new $c_s_Some($n(zoneStrings).get(idx))));
  if (this$4.isEmpty__Z()) {
    var zoneName = $m_s_None$()
  } else {
    var arg1$1 = this$4.get__O();
    var strs$3 = $asArrayOf_T(arg1$1, 1);
    var zoneName = (((daylight === false) && (style === 1)) ? $p_ju_TimeZone__atIndex$1__AT__I__s_Option(this, strs$3, 1) : (((daylight === false) && (style === 0)) ? $p_ju_TimeZone__atIndex$1__AT__I__s_Option(this, strs$3, 2) : (((daylight === true) && (style === 1)) ? $p_ju_TimeZone__atIndex$1__AT__I__s_Option(this, strs$3, 3) : (((daylight === true) && (style === 0)) ? $p_ju_TimeZone__atIndex$1__AT__I__s_Option(this, strs$3, 4) : $m_s_None$()))))
  };
  var this$5 = $n(zoneName);
  if (this$5.isEmpty__Z()) {
    var this$6 = $n(id);
    if (((this$6.length >= 0) && ($as_T(this$6.substring(0, 4)) === "GMT+"))) {
      var $$x2 = true
    } else {
      var this$7 = $n(id);
      var $$x2 = ((this$7.length >= 0) && ($as_T(this$7.substring(0, 4)) === "GMT-"))
    };
    if ($$x2) {
      var $$x1 = new $c_s_Some(id)
    } else {
      var $$x1 = $m_s_None$()
    }
  } else {
    var $$x1 = this$5
  };
  var this$9 = $n($$x1);
  var this$8 = $m_s_$less$colon$less$();
  var ev = this$8.s_$less$colon$less$__f_singleton;
  return $as_T((this$9.isEmpty__Z() ? ($n(ev), null) : this$9.get__O()))
});
/** @constructor */
function $c_ju_UUID(i1, i2, i3, i4) {
  this.ju_UUID__f_java$util$UUID$$i1 = 0;
  this.ju_UUID__f_java$util$UUID$$i2 = 0;
  this.ju_UUID__f_java$util$UUID$$i3 = 0;
  this.ju_UUID__f_java$util$UUID$$i4 = 0;
  this.ju_UUID__f_java$util$UUID$$i1 = i1;
  this.ju_UUID__f_java$util$UUID$$i2 = i2;
  this.ju_UUID__f_java$util$UUID$$i3 = i3;
  this.ju_UUID__f_java$util$UUID$$i4 = i4
}
$c_ju_UUID.prototype = new $h_O();
$c_ju_UUID.prototype.constructor = $c_ju_UUID;
/** @constructor */
function $h_ju_UUID() {
  /*<skip>*/
}
$h_ju_UUID.prototype = $c_ju_UUID.prototype;
$c_ju_UUID.prototype.toString__T = (function() {
  var i = this.ju_UUID__f_java$util$UUID$$i1;
  var s = $as_T($uD((i >>> 0.0)).toString(16));
  var this$2 = $n(s);
  var beginIndex = this$2.length;
  if (((beginIndex < 0) || (beginIndex > 8))) {
    $charAt("00000000", beginIndex)
  };
  var $$x5 = $as_T("00000000".substring(beginIndex));
  var i$1 = ((this.ju_UUID__f_java$util$UUID$$i2 >>> 16) | 0);
  var s$1 = $as_T($uD((i$1 >>> 0.0)).toString(16));
  var this$4 = $n(s$1);
  var beginIndex$1 = this$4.length;
  if (((beginIndex$1 < 0) || (beginIndex$1 > 4))) {
    $charAt("0000", beginIndex$1)
  };
  var $$x4 = $as_T("0000".substring(beginIndex$1));
  var i$2 = (65535 & this.ju_UUID__f_java$util$UUID$$i2);
  var s$2 = $as_T($uD((i$2 >>> 0.0)).toString(16));
  var this$6 = $n(s$2);
  var beginIndex$2 = this$6.length;
  if (((beginIndex$2 < 0) || (beginIndex$2 > 4))) {
    $charAt("0000", beginIndex$2)
  };
  var $$x3 = $as_T("0000".substring(beginIndex$2));
  var i$3 = ((this.ju_UUID__f_java$util$UUID$$i3 >>> 16) | 0);
  var s$3 = $as_T($uD((i$3 >>> 0.0)).toString(16));
  var this$8 = $n(s$3);
  var beginIndex$3 = this$8.length;
  if (((beginIndex$3 < 0) || (beginIndex$3 > 4))) {
    $charAt("0000", beginIndex$3)
  };
  var $$x2 = $as_T("0000".substring(beginIndex$3));
  var i$4 = (65535 & this.ju_UUID__f_java$util$UUID$$i3);
  var s$4 = $as_T($uD((i$4 >>> 0.0)).toString(16));
  var this$10 = $n(s$4);
  var beginIndex$4 = this$10.length;
  if (((beginIndex$4 < 0) || (beginIndex$4 > 4))) {
    $charAt("0000", beginIndex$4)
  };
  var $$x1 = $as_T("0000".substring(beginIndex$4));
  var i$5 = this.ju_UUID__f_java$util$UUID$$i4;
  var s$5 = $as_T($uD((i$5 >>> 0.0)).toString(16));
  var this$12 = $n(s$5);
  var beginIndex$5 = this$12.length;
  if (((beginIndex$5 < 0) || (beginIndex$5 > 8))) {
    $charAt("00000000", beginIndex$5)
  };
  return ((((((((((("" + $$x5) + s) + "-") + (("" + $$x4) + s$1)) + "-") + (("" + $$x3) + s$2)) + "-") + (("" + $$x2) + s$3)) + "-") + (("" + $$x1) + s$4)) + (("" + $as_T("00000000".substring(beginIndex$5))) + s$5))
});
$c_ju_UUID.prototype.hashCode__I = (function() {
  return (((this.ju_UUID__f_java$util$UUID$$i1 ^ this.ju_UUID__f_java$util$UUID$$i2) ^ this.ju_UUID__f_java$util$UUID$$i3) ^ this.ju_UUID__f_java$util$UUID$$i4)
});
$c_ju_UUID.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_ju_UUID)) {
    var x2 = $as_ju_UUID(that);
    return ((((this.ju_UUID__f_java$util$UUID$$i1 === $n(x2).ju_UUID__f_java$util$UUID$$i1) && (this.ju_UUID__f_java$util$UUID$$i2 === $n(x2).ju_UUID__f_java$util$UUID$$i2)) && (this.ju_UUID__f_java$util$UUID$$i3 === $n(x2).ju_UUID__f_java$util$UUID$$i3)) && (this.ju_UUID__f_java$util$UUID$$i4 === $n(x2).ju_UUID__f_java$util$UUID$$i4))
  } else {
    return false
  }
});
$c_ju_UUID.prototype.compareTo__ju_UUID__I = (function(that) {
  var value = this.ju_UUID__f_java$util$UUID$$i1;
  var value$1 = this.ju_UUID__f_java$util$UUID$$i2;
  var this$3 = $n(that);
  var value$2 = this$3.ju_UUID__f_java$util$UUID$$i1;
  var value$3 = this$3.ju_UUID__f_java$util$UUID$$i2;
  if ((!((value$1 === value$3) && (value === value$2)))) {
    return (((value === value$2) ? (((-2147483648) ^ value$1) < ((-2147483648) ^ value$3)) : (value < value$2)) ? (-1) : 1)
  } else {
    var value$4 = this.ju_UUID__f_java$util$UUID$$i3;
    var value$5 = this.ju_UUID__f_java$util$UUID$$i4;
    var this$8 = $n(that);
    var value$6 = this$8.ju_UUID__f_java$util$UUID$$i3;
    var value$7 = this$8.ju_UUID__f_java$util$UUID$$i4;
    return ((!((value$5 === value$7) && (value$4 === value$6))) ? (((value$4 === value$6) ? (((-2147483648) ^ value$5) < ((-2147483648) ^ value$7)) : (value$4 < value$6)) ? (-1) : 1) : 0)
  }
});
$c_ju_UUID.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__ju_UUID__I($as_ju_UUID(o))
});
function $as_ju_UUID(obj) {
  return (((obj instanceof $c_ju_UUID) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.UUID"))
}
function $isArrayOf_ju_UUID(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_UUID)))
}
function $asArrayOf_ju_UUID(obj, depth) {
  return (($isArrayOf_ju_UUID(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.UUID;", depth))
}
var $d_ju_UUID = new $TypeData().initClass({
  ju_UUID: 0
}, false, "java.util.UUID", {
  ju_UUID: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_ju_UUID.prototype.$classData = $d_ju_UUID;
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer)
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return $n(node).ju_HashMap$Node__f_key
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator = new $TypeData().initClass({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator: 0
}, false, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$KeyIterator", {
  ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype.$classData = $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator;
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer)
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator = new $TypeData().initClass({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator: 0
}, false, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$NodeIterator", {
  ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.$classData = $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_dateRef = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_newDetailState = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$3 = $n(this$);
    var this$4 = $n($n($as_Lreactbuild_model_InvoicePage($n($n($as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$3))).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePage__f_date);
    if (this$4.isEmpty__Z()) {
      var this$5 = $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Date);
      var this$6 = $m_Ljava_time_LocalDate$();
      var $$x1 = this$5.fromLocalDate__Ljava_time_LocalDate__Lreactbuild_common_model_Date(this$6.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId())))
    } else {
      var $$x1 = this$4.get__O()
    };
    return $as_Lreactbuild_common_model_Date($$x1)
  }));
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_dateRef = new $c_Lcom_iz2use_common_ParsingReference$Simple(f);
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f$1 = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x2;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x2 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $as_Lreactbuild_model_InvoiceDetail($n(x5).s_Some__f_value);
        var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1 = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(x$1$2);
          $n(x$1);
          var this$9 = $n(x$1);
          var selectedDetails = this$9.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails;
          var this$10 = $n(x$1);
          var pdfText = this$10.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
          var this$11 = $n(x$1);
          var checkboxDragging = this$11.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging;
          return new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(v, selectedDetails, pdfText, checkboxDragging)
        })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  }));
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_newDetailState = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$1)
}
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype = $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.toggleAllDetails__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$8 = $n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction2(((s$2, p$2) => {
    var s = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$2);
    var p = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(p$2);
    var this$2 = $n($n($as_Lreactbuild_model_InvoicePage($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePage__f_details);
    var f = ((x$2$2) => {
      var x$2 = $as_Lreactbuild_model_InvoiceDetail(x$2$2);
      return $n(x$2).Lreactbuild_model_InvoiceDetail__f_id
    });
    if ((this$2 === $m_sci_Nil$())) {
      var details = $m_sci_Nil$()
    } else {
      var arg1 = this$2.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$2.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var details = h
    };
    var this$3 = $n(details);
    _return: {
      var these = this$3;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$2 = $n(these).head__O();
        if ((!$n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails).contains__O__Z(arg1$2))) {
          var $$x1 = false;
          break _return
        };
        these = $as_sci_List($n(these).tail__O())
      };
      var $$x1 = true
    };
    if ($$x1) {
      var x$1 = $m_s_package$().s_package$__f_Nil
    } else {
      var x$1 = details
    };
    var this$4 = $n(s);
    var x$2$3 = this$4.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
    var this$5 = $n(s);
    var x$3 = this$5.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
    var this$6 = $n(s);
    var x$4 = this$6.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging;
    $n(s);
    return new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(x$2$3, x$1, x$3, x$4)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModStateWithProps__modState__F2__O(this$8, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.dragStartCheckBox__ju_UUID__F1 = (function(uuid) {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var cond = ($uI(ev$2.button) === 0);
    if (cond) {
      var this$8 = $n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$2);
        var active = $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails).contains__O__Z(uuid);
        var x$1 = new $c_s_Some((!active));
        if (active) {
          var this$3 = $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails);
          var f = ((x$3$2) => {
            var x$3 = $as_ju_UUID(x$3$2);
            return ((x$3 === null) ? (uuid === null) : $n(x$3).equals__O__Z(uuid))
          });
          var l = this$3;
          block: {
            var result;
            while (true) {
              if ($n(l).isEmpty__Z()) {
                var result = $m_sci_Nil$();
                break
              } else {
                var h = $n(l).head__O();
                var t = $as_sci_List($n(l).tail__O());
                if (($uZ(f(h)) === true)) {
                  l = t;
                  continue
                };
                var start = l;
                var remaining = t;
                while (true) {
                  if ($n(remaining).isEmpty__Z()) {
                    var result = start;
                    break block
                  } else {
                    var x = $n(remaining).head__O();
                    if (($uZ(f(x)) !== true)) {
                      remaining = $as_sci_List($n(remaining).tail__O());
                      continue
                    };
                    var firstMiss = remaining;
                    var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                    var toProcess = $as_sci_List($n(start).tail__O());
                    var currentLast = newHead;
                    while ((toProcess !== firstMiss)) {
                      var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                      $n(currentLast).sci_$colon$colon__f_next = newElem;
                      currentLast = newElem;
                      toProcess = $as_sci_List($n(toProcess).tail__O())
                    };
                    var next = $as_sci_List($n(firstMiss).tail__O());
                    var nextToCopy = next;
                    while ((!$n(next).isEmpty__Z())) {
                      var head = $n(next).head__O();
                      if (($uZ(f(head)) !== true)) {
                        next = $as_sci_List($n(next).tail__O())
                      } else {
                        while ((nextToCopy !== next)) {
                          var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                          $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                          currentLast = newElem$2;
                          nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                        };
                        nextToCopy = $as_sci_List($n(next).tail__O());
                        next = $as_sci_List($n(next).tail__O())
                      }
                    };
                    if ((!$n(nextToCopy).isEmpty__Z())) {
                      $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                    };
                    var result = newHead;
                    break block
                  }
                }
              }
            }
          };
          var x$2 = result
        } else {
          var this$4 = $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails);
          var x$2 = new $c_sci_$colon$colon(uuid, this$4)
        };
        var this$5 = $n(s);
        var x$3$3 = this$5.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
        var this$6 = $n(s);
        var x$4 = this$6.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
        $n(s);
        return new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(x$3$3, x$2, x$4, x$1)
      }));
      var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$8, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.dragMoveCheckBox__ju_UUID__F1 = (function(uuid) {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    if (((1 & $uI(ev$2.buttons)) === 1)) {
      var this$9 = $n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$2);
        var this$2 = $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging);
        if (this$2.isEmpty__Z()) {
          return $m_s_None$()
        } else {
          var arg1 = this$2.get__O();
          var switchOn = $uZ(arg1);
          var active = $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails).contains__O__Z(uuid);
          if ((switchOn !== active)) {
            if ((!switchOn)) {
              var this$3 = $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails);
              var f = ((x$4$2) => {
                var x$4 = $as_ju_UUID(x$4$2);
                return ((x$4 === null) ? (uuid === null) : $n(x$4).equals__O__Z(uuid))
              });
              var l = this$3;
              block: {
                var result;
                while (true) {
                  if ($n(l).isEmpty__Z()) {
                    var result = $m_sci_Nil$();
                    break
                  } else {
                    var h = $n(l).head__O();
                    var t = $as_sci_List($n(l).tail__O());
                    if (($uZ(f(h)) === true)) {
                      l = t;
                      continue
                    };
                    var start = l;
                    var remaining = t;
                    while (true) {
                      if ($n(remaining).isEmpty__Z()) {
                        var result = start;
                        break block
                      } else {
                        var x = $n(remaining).head__O();
                        if (($uZ(f(x)) !== true)) {
                          remaining = $as_sci_List($n(remaining).tail__O());
                          continue
                        };
                        var firstMiss = remaining;
                        var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                        var toProcess = $as_sci_List($n(start).tail__O());
                        var currentLast = newHead;
                        while ((toProcess !== firstMiss)) {
                          var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                          $n(currentLast).sci_$colon$colon__f_next = newElem;
                          currentLast = newElem;
                          toProcess = $as_sci_List($n(toProcess).tail__O())
                        };
                        var next = $as_sci_List($n(firstMiss).tail__O());
                        var nextToCopy = next;
                        while ((!$n(next).isEmpty__Z())) {
                          var head = $n(next).head__O();
                          if (($uZ(f(head)) !== true)) {
                            next = $as_sci_List($n(next).tail__O())
                          } else {
                            while ((nextToCopy !== next)) {
                              var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                              $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                              currentLast = newElem$2;
                              nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                            };
                            nextToCopy = $as_sci_List($n(next).tail__O());
                            next = $as_sci_List($n(next).tail__O())
                          }
                        };
                        if ((!$n(nextToCopy).isEmpty__Z())) {
                          $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                        };
                        var result = newHead;
                        break block
                      }
                    }
                  }
                }
              };
              var x$1 = result
            } else {
              var this$4 = $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails);
              var x$1 = new $c_sci_$colon$colon(uuid, this$4)
            };
            var this$5 = $n(s);
            var x$2 = this$5.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
            var this$6 = $n(s);
            var x$3 = this$6.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
            var this$7 = $n(s);
            var x$4$3 = this$7.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging;
            $n(s);
            return new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(x$2, x$1, x$3, x$4$3))
          } else {
            return $m_s_None$()
          }
        }
      }));
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modStateOption__F1__O(this$9, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else {
      var this$15 = $n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$);
      var mod$1 = new $c_sjsr_AnonFunction1(((s$3$2) => {
        var s$3 = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$3$2);
        var this$10 = $n($n(s$3).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging);
        if (this$10.isEmpty__Z()) {
          return $m_s_None$()
        } else {
          var arg1$1 = this$10.get__O();
          $uZ(arg1$1);
          var x$5$2 = $m_s_None$();
          var this$11 = $n(s$3);
          var x$6 = this$11.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
          var this$12 = $n(s$3);
          var x$7 = this$12.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails;
          var this$13 = $n(s$3);
          var x$8 = this$13.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
          $n(s$3);
          return new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(x$6, x$7, x$8, x$5$2))
        }
      }));
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modStateOption__F1__O(this$15, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.dragStopCheckBox__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var cond = ($uI(ev$2.button) === 0);
    if (cond) {
      var this$8 = $n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$2);
        var this$3 = $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging);
        if (this$3.isEmpty__Z()) {
          return $m_s_None$()
        } else {
          var arg1 = this$3.get__O();
          $uZ(arg1);
          if ($n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging).isEmpty__Z()) {
            return $m_s_None$()
          } else {
            var x$1 = $m_s_None$();
            var this$4 = $n(s);
            var x$2 = this$4.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
            var this$5 = $n(s);
            var x$3 = this$5.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails;
            var this$6 = $n(s);
            var x$4 = this$6.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
            $n(s);
            return new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(x$2, x$3, x$4, x$1))
          }
        }
      }));
      var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modStateOption__F1__O(this$8, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.isAllDetailsSelected__Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__Lreactbuild_analyze_cost_components_DocumentPageEditor$State__Z = (function(p, s) {
  var this$1 = $n($n($as_Lreactbuild_model_InvoicePage($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePage__f_details);
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var d = $as_Lreactbuild_model_InvoiceDetail(arg1);
    if ((!$n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails).contains__O__Z($n(d).Lreactbuild_model_InvoiceDetail__f_id))) {
      return false
    };
    these = $as_sci_List($n(these).tail__O())
  };
  return true
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.updateSelection__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$3 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(p$2);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f$2 = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$2);
      var this$2 = $n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document);
      var callback = new $c_sjsr_AnonFunction0((() => {
        var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
      }));
      var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var doc = $as_Lreactbuild_model_InvoicePage(arg1);
      var this$6 = $n($n(doc).Lreactbuild_model_InvoicePage__f_details);
      var f$1 = ((d$2) => {
        var d = $as_Lreactbuild_model_InvoiceDetail(d$2);
        return ($n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails).contains__O__Z($n(d).Lreactbuild_model_InvoiceDetail__f_id) ? $as_Lreactbuild_model_InvoiceDetail($n(f).apply__O__O(d)) : d)
      });
      if ((this$6 === $m_sci_Nil$())) {
        var x$1 = $m_sci_Nil$()
      } else {
        var arg1$1 = this$6.head__O();
        var h = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$6.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O())
        };
        var x$1 = h
      };
      var this$7 = $n(doc);
      var x$2 = this$7.Lreactbuild_model_InvoicePage__f__id;
      var this$8 = $n(doc);
      var x$3 = this$8.Lreactbuild_model_InvoicePage__f_organization;
      var this$9 = $n(doc);
      var x$4 = this$9.Lreactbuild_model_InvoicePage__f_file;
      var this$10 = $n(doc);
      var x$5 = this$10.Lreactbuild_model_InvoicePage__f_notDone;
      var this$11 = $n(doc);
      var x$6 = this$11.Lreactbuild_model_InvoicePage__f_supplier;
      var this$12 = $n(doc);
      var x$7 = this$12.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$13 = $n(doc);
      var x$8 = this$13.Lreactbuild_model_InvoicePage__f_date;
      var this$14 = $n(doc);
      var x$9 = this$14.Lreactbuild_model_InvoicePage__f_reference;
      var this$15 = $n(doc);
      var x$10 = this$15.Lreactbuild_model_InvoicePage__f_pageIndex;
      var this$16 = $n(doc);
      var x$11 = this$16.Lreactbuild_model_InvoicePage__f_pageCount;
      var this$17 = $n(doc);
      var x$12 = this$17.Lreactbuild_model_InvoicePage__f_amount;
      var this$18 = $n(doc);
      var x$13 = this$18.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$19 = $n(doc);
      var x$14 = this$19.Lreactbuild_model_InvoicePage__f_entryNumber;
      var this$20 = $n(doc);
      var x$15 = this$20.Lreactbuild_model_InvoicePage__f_category;
      var this$21 = $n(doc);
      var x$16 = this$21.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(doc);
      var arg1$3 = new $c_Lreactbuild_model_InvoicePage(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$1, x$14, x$15, x$16);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$3), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$2))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$3)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.deleter__I__Ljapgolly_scalajs_react_callback_Trampoline = (function(i) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(p$2);
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var doc = $as_Lreactbuild_model_InvoicePage(arg1);
    var this$6 = $n($n(doc).Lreactbuild_model_InvoicePage__f_details);
    var other = $m_s_package$().s_package$__f_Nil;
    var x$1 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$6, i, other, 1));
    var this$7 = $n(doc);
    var x$2 = this$7.Lreactbuild_model_InvoicePage__f__id;
    var this$8 = $n(doc);
    var x$3 = this$8.Lreactbuild_model_InvoicePage__f_organization;
    var this$9 = $n(doc);
    var x$4 = this$9.Lreactbuild_model_InvoicePage__f_file;
    var this$10 = $n(doc);
    var x$5 = this$10.Lreactbuild_model_InvoicePage__f_notDone;
    var this$11 = $n(doc);
    var x$6 = this$11.Lreactbuild_model_InvoicePage__f_supplier;
    var this$12 = $n(doc);
    var x$7 = this$12.Lreactbuild_model_InvoicePage__f_supplierOffice;
    var this$13 = $n(doc);
    var x$8 = this$13.Lreactbuild_model_InvoicePage__f_date;
    var this$14 = $n(doc);
    var x$9 = this$14.Lreactbuild_model_InvoicePage__f_reference;
    var this$15 = $n(doc);
    var x$10 = this$15.Lreactbuild_model_InvoicePage__f_pageIndex;
    var this$16 = $n(doc);
    var x$11 = this$16.Lreactbuild_model_InvoicePage__f_pageCount;
    var this$17 = $n(doc);
    var x$12 = this$17.Lreactbuild_model_InvoicePage__f_amount;
    var this$18 = $n(doc);
    var x$13 = this$18.Lreactbuild_model_InvoicePage__f_totalAmount;
    var this$19 = $n(doc);
    var x$14 = this$19.Lreactbuild_model_InvoicePage__f_entryNumber;
    var this$20 = $n(doc);
    var x$15 = this$20.Lreactbuild_model_InvoicePage__f_category;
    var this$21 = $n(doc);
    var x$16 = this$21.Lreactbuild_model_InvoicePage__f_deletedAt;
    $n(doc);
    var arg1$1 = new $c_Lreactbuild_model_InvoicePage(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$1, x$14, x$15, x$16);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.adder__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$1 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(p$2);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$2);
      var this$18 = $n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document);
      var callback = new $c_sjsr_AnonFunction0((() => {
        var this$16 = $n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$);
        var mod = new $c_sjsr_AnonFunction1(((s$2$1) => {
          var s$1 = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$2$1);
          $n(s$1);
          $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var id = $m_ju_UUID$().randomUUID__ju_UUID();
          var this$2 = $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var reference = this$2.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$3 = $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var description = this$3.Lreactbuild_model_InvoiceDetail__f_description;
          var this$4 = $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var quantity = this$4.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$5 = $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var unit = this$5.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$6 = $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var unitPrice = this$6.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$7 = $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var amount = this$7.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$8 = $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var tradeBody = this$8.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$9 = $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var buildingSite = this$9.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$10 = $n($n(s$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail);
          var deliveryDate = this$10.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          var newDetail = new $c_Lreactbuild_model_InvoiceDetail(id, reference, description, quantity, unit, unitPrice, amount, tradeBody, buildingSite, deliveryDate);
          var this$12 = $n(s$1);
          var selectedDetails = this$12.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails;
          var this$13 = $n(s$1);
          var pdfText = this$13.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
          var this$14 = $n(s$1);
          var checkboxDragging = this$14.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging;
          return new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(newDetail, selectedDetails, pdfText, checkboxDragging)
        }));
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$16, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      }));
      var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
      var arg1 = this$18.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var doc = $as_Lreactbuild_model_InvoicePage(arg1);
      var this$19 = $n($n(doc).Lreactbuild_model_InvoicePage__f_details);
      var elem = $n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
      var x$1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$19, elem));
      var this$20 = $n(doc);
      var x$2 = this$20.Lreactbuild_model_InvoicePage__f__id;
      var this$21 = $n(doc);
      var x$3 = this$21.Lreactbuild_model_InvoicePage__f_organization;
      var this$22 = $n(doc);
      var x$4 = this$22.Lreactbuild_model_InvoicePage__f_file;
      var this$23 = $n(doc);
      var x$5 = this$23.Lreactbuild_model_InvoicePage__f_notDone;
      var this$24 = $n(doc);
      var x$6 = this$24.Lreactbuild_model_InvoicePage__f_supplier;
      var this$25 = $n(doc);
      var x$7 = this$25.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$26 = $n(doc);
      var x$8 = this$26.Lreactbuild_model_InvoicePage__f_date;
      var this$27 = $n(doc);
      var x$9 = this$27.Lreactbuild_model_InvoicePage__f_reference;
      var this$28 = $n(doc);
      var x$10 = this$28.Lreactbuild_model_InvoicePage__f_pageIndex;
      var this$29 = $n(doc);
      var x$11 = this$29.Lreactbuild_model_InvoicePage__f_pageCount;
      var this$30 = $n(doc);
      var x$12 = this$30.Lreactbuild_model_InvoicePage__f_amount;
      var this$31 = $n(doc);
      var x$13 = this$31.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$32 = $n(doc);
      var x$14 = this$32.Lreactbuild_model_InvoicePage__f_entryNumber;
      var this$33 = $n(doc);
      var x$15 = this$33.Lreactbuild_model_InvoicePage__f_category;
      var this$34 = $n(doc);
      var x$16 = this$34.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(doc);
      var arg1$1 = new $c_Lreactbuild_model_InvoicePage(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$1, x$14, x$15, x$16);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$18.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$1)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.renderSum__sci_List__Ljapgolly_scalajs_react_vdom_TagOf = (function(c) {
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x9 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("sum", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$17 = $n(c);
  var acc = 0.0;
  var these = this$17;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = acc;
    var arg2 = $n(these).head__O();
    var acc$1 = $uD(arg1);
    var c$2 = $as_Lreactbuild_model_InvoiceDetail(arg2);
    var this$18 = $n($n(c$2).Lreactbuild_model_InvoiceDetail__f_amount);
    if (this$18.isEmpty__Z()) {
      var $$x1 = $m_s_None$()
    } else {
      var arg1$1 = this$18.get__O();
      var x$7 = $as_Lreactbuild_model_Price(arg1$1);
      var $$x1 = new $c_s_Some($n(x$7).Lreactbuild_model_Price__f_amount)
    };
    var this$19 = $n($$x1);
    acc = (acc$1 + $uD((this$19.isEmpty__Z() ? 0.0 : this$19.get__O())));
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  var v = new $c_Lreactbuild_model_Price($uD(acc));
  var ev = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
  var v$1 = $n(ev).stringify__O__T(v);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
  var array$1 = [$$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$()), $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$()), $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$()), $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$())];
  return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.renderInvoiceDetail__Lreactbuild_analyze_cost_services_Model__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_components_DocumentPageEditor$State__Ljapgolly_scalajs_react_vdom_TagMod__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf = (function(m, c, s, actions, proxy) {
  var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x29 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n($n($as_Lreactbuild_model_InvoiceDetail($n(c).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoiceDetail__f_id).toString__T(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x27 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$()).Ljapgolly_scalajs_react_vdom_HtmlTags$input$__f_checkbox;
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseDown");
  var $$x26 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.dragStartCheckBox__ju_UUID__F1($n($as_Lreactbuild_model_InvoiceDetail($n(c).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoiceDetail__f_id), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$2 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseMove");
  var $$x25 = stabilizer$2.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.dragMoveCheckBox__ju_UUID__F1($n($as_Lreactbuild_model_InvoiceDetail($n(c).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoiceDetail__f_id), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$3 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseUp");
  var $$x24 = stabilizer$3.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.dragStopCheckBox__F1(), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$13 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "checked");
  var a = $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails).contains__O__Z($n($as_Lreactbuild_model_InvoiceDetail($n(c).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoiceDetail__f_id);
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
  var array = [$$x26, $$x25, $$x24, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$13.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a)];
  var array$1 = [$n($$x27).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var $$x23 = $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence");
  var $$x19 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value = $n($as_Lreactbuild_model_InvoiceDetail($n(c).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoiceDetail__f_reference;
  var state = $n($$x19).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x20;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x20 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $as_s_Option($n(x5).s_Some__f_value);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).optionCallback__F0__F0(new $c_sjsr_AnonFunction0((() => {
          var this$26 = $n(v);
          var p = new $c_sjsr_AnonFunction1(((ref$2) => {
            $as_T(ref$2);
            return $n($n($as_Lreactbuild_model_InvoiceDetail($n(c).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoiceDetail__f_tradeBody).isEmpty__Z()
          }));
          return new $c_s_Option$WithFilter(this$26, p).flatMap__F1__s_Option(new $c_sjsr_AnonFunction1(((ref$3$2) => {
            var ref$3 = $as_T(ref$3$2);
            var this$40 = $n($n($as_sci_List($m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O(proxy, new $c_sjsr_AnonFunction1(((x$8$2) => {
              var x$8 = $as_Lreactbuild_model_CommonData(x$8$2);
              return $n(x$8).Lreactbuild_model_CommonData__f_products
            })), new $c_Lreactbuild_package$DefaultCommonData$$anon$1()))).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$9$2) => {
              var x$9 = $as_Lreactbuild_model_Product(x$9$2);
              return ($n(x$9).Lreactbuild_model_Product__f_reference === ref$3)
            }))));
            var f$1 = new $c_sjsr_AnonFunction1(((product$2) => {
              var product = $as_Lreactbuild_model_Product(product$2);
              var this$39 = $n($n(product).Lreactbuild_model_Product__f_buildingPart);
              var f = new $c_sjsr_AnonFunction1(((buildingPart$2) => {
                var buildingPart = $as_Lreactbuild_common_model_RefTo(buildingPart$2);
                var this$38 = $n(c);
                var mod = new $c_sjsr_AnonFunction1(((x$10$2) => {
                  var x$10 = $as_Lreactbuild_model_InvoiceDetail(x$10$2);
                  var x$2 = new $c_s_Some(buildingPart);
                  var this$28 = $n(x$10);
                  var x$3 = this$28.Lreactbuild_model_InvoiceDetail__f_id;
                  var this$29 = $n(x$10);
                  var x$4 = this$29.Lreactbuild_model_InvoiceDetail__f_description;
                  var this$30 = $n(x$10);
                  var x$5 = this$30.Lreactbuild_model_InvoiceDetail__f_quantity;
                  var this$31 = $n(x$10);
                  var x$6 = this$31.Lreactbuild_model_InvoiceDetail__f_unit;
                  var this$32 = $n(x$10);
                  var x$7 = this$32.Lreactbuild_model_InvoiceDetail__f_unitPrice;
                  var this$33 = $n(x$10);
                  var x$8$1 = this$33.Lreactbuild_model_InvoiceDetail__f_amount;
                  var this$34 = $n(x$10);
                  var x$9$1 = this$34.Lreactbuild_model_InvoiceDetail__f_buildingSite;
                  var this$35 = $n(x$10);
                  var x$10$2$1 = this$35.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
                  $n(x$10);
                  return new $c_Lreactbuild_model_InvoiceDetail(x$3, v, x$4, x$5, x$6, x$7, x$8$1, x$2, x$9$1, x$10$2$1)
                }));
                var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)));
                var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
                return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$38, mod, callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
              }));
              return (this$39.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$39.get__O())))
            }));
            return (this$40.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$1.apply__O__O(this$40.get__O())))
          })))
        })));
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$52 = $n(c);
        var mod$1 = new $c_sjsr_AnonFunction1(((x$11$2) => {
          var x$11 = $as_Lreactbuild_model_InvoiceDetail(x$11$2);
          var this$41 = $n(x$11);
          var x$12 = this$41.Lreactbuild_model_InvoiceDetail__f_id;
          var this$42 = $n(x$11);
          var x$13 = this$42.Lreactbuild_model_InvoiceDetail__f_description;
          var this$43 = $n(x$11);
          var x$14 = this$43.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$44 = $n(x$11);
          var x$15 = this$44.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$45 = $n(x$11);
          var x$16 = this$45.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$46 = $n(x$11);
          var x$17 = this$46.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$47 = $n(x$11);
          var x$18 = this$47.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$48 = $n(x$11);
          var x$19 = this$48.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$49 = $n(x$11);
          var x$20 = this$49.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$11);
          return new $c_Lreactbuild_model_InvoiceDetail(x$12, v, x$13, x$14, x$15, x$16, x$17, x$18, x$19, x$20)
        }));
        var callback$1 = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)));
        var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
        var c$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$52, mod$1, callback$1, G$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var tryNext = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1);
        var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().orElse$extension__F0__F0__F0(this$, tryNext);
        var $$x21 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$56 = $m_s_$less$colon$less$();
        var $$x20 = $n($$x21).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$56.s_$less$colon$less$__f_singleton);
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x20)
  })));
  var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  $m_Lcom_iz2use_common_Parsable$();
  var ev = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev);
  var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$61 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$61);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv = $m_s_math_Equiv$String$();
  var equiv = new $c_s_math_Equiv$OptionEquiv(eqv);
  var array$2 = [editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$1, explainError, equiv)];
  var $$x18 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Description");
  var state$1 = $n(c).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12$1 = $as_Lreactbuild_model_InvoiceDetail(x$12$2);
    return $n(x$12$1).Lreactbuild_model_InvoiceDetail__f_description
  })), new $c_sjsr_AnonFunction1(((v$2) => {
    var v$1 = $as_s_Option(v$2);
    return new $c_sjsr_AnonFunction1(((x$13$2) => {
      var x$13$1 = $as_Lreactbuild_model_InvoiceDetail(x$13$2);
      var this$73 = $n(x$13$1);
      var x$22 = this$73.Lreactbuild_model_InvoiceDetail__f_id;
      var this$74 = $n(x$13$1);
      var x$23 = this$74.Lreactbuild_model_InvoiceDetail__f_reference;
      var this$75 = $n(x$13$1);
      var x$24 = this$75.Lreactbuild_model_InvoiceDetail__f_quantity;
      var this$76 = $n(x$13$1);
      var x$25 = this$76.Lreactbuild_model_InvoiceDetail__f_unit;
      var this$77 = $n(x$13$1);
      var x$26 = this$77.Lreactbuild_model_InvoiceDetail__f_unitPrice;
      var this$78 = $n(x$13$1);
      var x$27 = this$78.Lreactbuild_model_InvoiceDetail__f_amount;
      var this$79 = $n(x$13$1);
      var x$28 = this$79.Lreactbuild_model_InvoiceDetail__f_tradeBody;
      var this$80 = $n(x$13$1);
      var x$29 = this$80.Lreactbuild_model_InvoiceDetail__f_buildingSite;
      var this$81 = $n(x$13$1);
      var x$30 = this$81.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
      $n(x$13$1);
      return new $c_Lreactbuild_model_InvoiceDetail(x$22, x$23, v$1, x$24, x$25, x$26, x$27, x$28, x$29, x$30)
    }))
  })));
  var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$2);
  var ev$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$87 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$87);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv$1 = $m_s_math_Equiv$String$();
  var equiv$1 = new $c_s_math_Equiv$OptionEquiv(eqv$1);
  var array$3 = [editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$3, explainError$1, equiv$1)];
  var $$x16 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Qt\u00e9");
  var state$2 = $n(c).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$14$2) => {
    var x$14$1 = $as_Lreactbuild_model_InvoiceDetail(x$14$2);
    return $n(x$14$1).Lreactbuild_model_InvoiceDetail__f_quantity
  })), new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_s_Option(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$15$2) => {
      var x$15$1 = $as_Lreactbuild_model_InvoiceDetail(x$15$2);
      var this$99 = $n(x$15$1);
      var x$32 = this$99.Lreactbuild_model_InvoiceDetail__f_id;
      var this$100 = $n(x$15$1);
      var x$33 = this$100.Lreactbuild_model_InvoiceDetail__f_reference;
      var this$101 = $n(x$15$1);
      var x$34 = this$101.Lreactbuild_model_InvoiceDetail__f_description;
      var this$102 = $n(x$15$1);
      var x$35 = this$102.Lreactbuild_model_InvoiceDetail__f_unit;
      var this$103 = $n(x$15$1);
      var x$36 = this$103.Lreactbuild_model_InvoiceDetail__f_unitPrice;
      var this$104 = $n(x$15$1);
      var x$37 = this$104.Lreactbuild_model_InvoiceDetail__f_amount;
      var this$105 = $n(x$15$1);
      var x$38 = this$105.Lreactbuild_model_InvoiceDetail__f_tradeBody;
      var this$106 = $n(x$15$1);
      var x$39 = this$106.Lreactbuild_model_InvoiceDetail__f_buildingSite;
      var this$107 = $n(x$15$1);
      var x$40 = this$107.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
      $n(x$15$1);
      return new $c_Lreactbuild_model_InvoiceDetail(x$32, x$33, x$34, v$3, x$35, x$36, x$37, x$38, x$39, x$40)
    }))
  })));
  var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$4);
  var ev$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$113 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$113);
  var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
  var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv$2 = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
  var equiv$2 = new $c_s_math_Equiv$OptionEquiv(eqv$2);
  var array$4 = [editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$2, optioner$2, ev$5, explainError$2, equiv$2)];
  var $$x14 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Unit\u00e9");
  var state$3 = $n(c).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$16$2) => {
    var x$16$1 = $as_Lreactbuild_model_InvoiceDetail(x$16$2);
    return $n(x$16$1).Lreactbuild_model_InvoiceDetail__f_unit
  })), new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4 = $as_s_Option(v$4$2);
    return new $c_sjsr_AnonFunction1(((x$17$2) => {
      var x$17$1 = $as_Lreactbuild_model_InvoiceDetail(x$17$2);
      var this$125 = $n(x$17$1);
      var x$42 = this$125.Lreactbuild_model_InvoiceDetail__f_id;
      var this$126 = $n(x$17$1);
      var x$43 = this$126.Lreactbuild_model_InvoiceDetail__f_reference;
      var this$127 = $n(x$17$1);
      var x$44 = this$127.Lreactbuild_model_InvoiceDetail__f_description;
      var this$128 = $n(x$17$1);
      var x$45 = this$128.Lreactbuild_model_InvoiceDetail__f_quantity;
      var this$129 = $n(x$17$1);
      var x$46 = this$129.Lreactbuild_model_InvoiceDetail__f_unitPrice;
      var this$130 = $n(x$17$1);
      var x$47 = this$130.Lreactbuild_model_InvoiceDetail__f_amount;
      var this$131 = $n(x$17$1);
      var x$48 = this$131.Lreactbuild_model_InvoiceDetail__f_tradeBody;
      var this$132 = $n(x$17$1);
      var x$49 = this$132.Lreactbuild_model_InvoiceDetail__f_buildingSite;
      var this$133 = $n(x$17$1);
      var x$50 = this$133.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
      $n(x$17$1);
      return new $c_Lreactbuild_model_InvoiceDetail(x$42, x$43, x$44, x$45, v$4, x$46, x$47, x$48, x$49, x$50)
    }))
  })));
  var evDefault$3 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$3 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$6);
  var ev$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$139 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$139);
  var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
  var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv$3 = $m_s_math_Equiv$String$();
  var equiv$3 = new $c_s_math_Equiv$OptionEquiv(eqv$3);
  var array$5 = [editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$3, optioner$3, ev$7, explainError$3, equiv$3)];
  var $$x12 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix unitaire");
  var state$4 = $n(c).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$18$2) => {
    var x$18$1 = $as_Lreactbuild_model_InvoiceDetail(x$18$2);
    return $n(x$18$1).Lreactbuild_model_InvoiceDetail__f_unitPrice
  })), new $c_sjsr_AnonFunction1(((v$5$2) => {
    var v$5 = $as_s_Option(v$5$2);
    return new $c_sjsr_AnonFunction1(((x$19$2) => {
      var x$19$1 = $as_Lreactbuild_model_InvoiceDetail(x$19$2);
      var this$151 = $n(x$19$1);
      var x$52 = this$151.Lreactbuild_model_InvoiceDetail__f_id;
      var this$152 = $n(x$19$1);
      var x$53 = this$152.Lreactbuild_model_InvoiceDetail__f_reference;
      var this$153 = $n(x$19$1);
      var x$54 = this$153.Lreactbuild_model_InvoiceDetail__f_description;
      var this$154 = $n(x$19$1);
      var x$55 = this$154.Lreactbuild_model_InvoiceDetail__f_quantity;
      var this$155 = $n(x$19$1);
      var x$56 = this$155.Lreactbuild_model_InvoiceDetail__f_unit;
      var this$156 = $n(x$19$1);
      var x$57 = this$156.Lreactbuild_model_InvoiceDetail__f_amount;
      var this$157 = $n(x$19$1);
      var x$58 = this$157.Lreactbuild_model_InvoiceDetail__f_tradeBody;
      var this$158 = $n(x$19$1);
      var x$59 = this$158.Lreactbuild_model_InvoiceDetail__f_buildingSite;
      var this$159 = $n(x$19$1);
      var x$60 = this$159.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
      $n(x$19$1);
      return new $c_Lreactbuild_model_InvoiceDetail(x$52, x$53, x$54, x$55, x$56, v$5, x$57, x$58, x$59, x$60)
    }))
  })));
  var optioner$4 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
  var ev$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$163 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$4 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$163);
  var editorComponent$4 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$4);
  var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
  var array$6 = [editorComponent$4.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$4, state$4, optioner$4, ev$8, explainError$4, equiv$4)];
  var $$x10 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix total HT");
  var state$5 = $n(c).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$20$2) => {
    var x$20$1 = $as_Lreactbuild_model_InvoiceDetail(x$20$2);
    return $n(x$20$1).Lreactbuild_model_InvoiceDetail__f_amount
  })), new $c_sjsr_AnonFunction1(((v$6$2) => {
    var v$6 = $as_s_Option(v$6$2);
    return new $c_sjsr_AnonFunction1(((x$21$2) => {
      var x$21 = $as_Lreactbuild_model_InvoiceDetail(x$21$2);
      var this$174 = $n(x$21);
      var x$62 = this$174.Lreactbuild_model_InvoiceDetail__f_id;
      var this$175 = $n(x$21);
      var x$63 = this$175.Lreactbuild_model_InvoiceDetail__f_reference;
      var this$176 = $n(x$21);
      var x$64 = this$176.Lreactbuild_model_InvoiceDetail__f_description;
      var this$177 = $n(x$21);
      var x$65 = this$177.Lreactbuild_model_InvoiceDetail__f_quantity;
      var this$178 = $n(x$21);
      var x$66 = this$178.Lreactbuild_model_InvoiceDetail__f_unit;
      var this$179 = $n(x$21);
      var x$67 = this$179.Lreactbuild_model_InvoiceDetail__f_unitPrice;
      var this$180 = $n(x$21);
      var x$68 = this$180.Lreactbuild_model_InvoiceDetail__f_tradeBody;
      var this$181 = $n(x$21);
      var x$69 = this$181.Lreactbuild_model_InvoiceDetail__f_buildingSite;
      var this$182 = $n(x$21);
      var x$70 = this$182.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
      $n(x$21);
      return new $c_Lreactbuild_model_InvoiceDetail(x$62, x$63, x$64, x$65, x$66, x$67, v$6, x$68, x$69, x$70)
    }))
  })));
  var optioner$5 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
  var ev$9 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$186 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$5 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$186);
  var editorComponent$5 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$5);
  var explainError$5 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
  var array$7 = [editorComponent$5.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$5, state$5, optioner$5, ev$9, explainError$5, equiv$5)];
  var $$x8 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Corps d'\u00e9tat");
  var state$6 = $n(c).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$22$2) => {
    var x$22$1 = $as_Lreactbuild_model_InvoiceDetail(x$22$2);
    return $n(x$22$1).Lreactbuild_model_InvoiceDetail__f_tradeBody
  })), new $c_sjsr_AnonFunction1(((v$7$2) => {
    var v$7 = $as_s_Option(v$7$2);
    return new $c_sjsr_AnonFunction1(((x$23$2) => {
      var x$23$1 = $as_Lreactbuild_model_InvoiceDetail(x$23$2);
      var this$197 = $n(x$23$1);
      var x$72 = this$197.Lreactbuild_model_InvoiceDetail__f_id;
      var this$198 = $n(x$23$1);
      var x$73 = this$198.Lreactbuild_model_InvoiceDetail__f_reference;
      var this$199 = $n(x$23$1);
      var x$74 = this$199.Lreactbuild_model_InvoiceDetail__f_description;
      var this$200 = $n(x$23$1);
      var x$75 = this$200.Lreactbuild_model_InvoiceDetail__f_quantity;
      var this$201 = $n(x$23$1);
      var x$76 = this$201.Lreactbuild_model_InvoiceDetail__f_unit;
      var this$202 = $n(x$23$1);
      var x$77 = this$202.Lreactbuild_model_InvoiceDetail__f_unitPrice;
      var this$203 = $n(x$23$1);
      var x$78 = this$203.Lreactbuild_model_InvoiceDetail__f_amount;
      var this$204 = $n(x$23$1);
      var x$79 = this$204.Lreactbuild_model_InvoiceDetail__f_buildingSite;
      var this$205 = $n(x$23$1);
      var x$80 = this$205.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
      $n(x$23$1);
      return new $c_Lreactbuild_model_InvoiceDetail(x$72, x$73, x$74, x$75, x$76, x$77, x$78, v$7, x$79, x$80)
    }))
  })));
  var optioner$6 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$209 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization = $m_s_None$();
  var ev$11 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$16(this$209, proxy, organization);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$211 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization$1 = $m_s_None$();
  var helper$6 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$16(this$211, proxy, organization$1);
  var editorComponent$6 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$6);
  var explainError$6 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$215 = $m_Lreactbuild_model_Implicits$();
  var this$214 = $m_Lreactbuild_model_Implicits$();
  var ev$10 = $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$214, proxy);
  var equiv$6 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$215, ev$10);
  var array$8 = [editorComponent$6.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$6, state$6, optioner$6, ev$11, explainError$6, equiv$6)];
  var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$7 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chantier");
  var state$7 = $n(c).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$24$2) => {
    var x$24$1 = $as_Lreactbuild_model_InvoiceDetail(x$24$2);
    return $n(x$24$1).Lreactbuild_model_InvoiceDetail__f_buildingSite
  })), new $c_sjsr_AnonFunction1(((v$8$2) => {
    var v$8 = $as_s_Option(v$8$2);
    return new $c_sjsr_AnonFunction1(((x$25$2) => {
      var x$25$1 = $as_Lreactbuild_model_InvoiceDetail(x$25$2);
      var this$224 = $n(x$25$1);
      var x$82 = this$224.Lreactbuild_model_InvoiceDetail__f_id;
      var this$225 = $n(x$25$1);
      var x$83 = this$225.Lreactbuild_model_InvoiceDetail__f_reference;
      var this$226 = $n(x$25$1);
      var x$84 = this$226.Lreactbuild_model_InvoiceDetail__f_description;
      var this$227 = $n(x$25$1);
      var x$85 = this$227.Lreactbuild_model_InvoiceDetail__f_quantity;
      var this$228 = $n(x$25$1);
      var x$86 = this$228.Lreactbuild_model_InvoiceDetail__f_unit;
      var this$229 = $n(x$25$1);
      var x$87 = this$229.Lreactbuild_model_InvoiceDetail__f_unitPrice;
      var this$230 = $n(x$25$1);
      var x$88 = this$230.Lreactbuild_model_InvoiceDetail__f_amount;
      var this$231 = $n(x$25$1);
      var x$89 = this$231.Lreactbuild_model_InvoiceDetail__f_tradeBody;
      var this$232 = $n(x$25$1);
      var x$90 = this$232.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
      $n(x$25$1);
      return new $c_Lreactbuild_model_InvoiceDetail(x$82, x$83, x$84, x$85, x$86, x$87, x$88, x$89, v$8, x$90)
    }))
  })));
  var optioner$7 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$235 = $m_Lreactbuild_model_Implicits$();
  var ev$13 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$235, proxy);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$236 = $m_Lreactbuild_model_Implicits$();
  var helper$7 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$236, proxy);
  var editorComponent$7 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$7);
  var explainError$7 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$240 = $m_Lreactbuild_model_Implicits$();
  var this$239 = $m_Lreactbuild_model_Implicits$();
  var ev$12 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$239, proxy);
  var equiv$7 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$240, ev$12);
  var array$9 = [editorComponent$7.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$7, state$7, optioner$7, ev$13, explainError$7, equiv$7)];
  var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Livr\u00e9 le");
  var state$8 = $n(c).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$26$2) => {
    var x$26$1 = $as_Lreactbuild_model_InvoiceDetail(x$26$2);
    return $n(x$26$1).Lreactbuild_model_InvoiceDetail__f_deliveryDate
  })), new $c_sjsr_AnonFunction1(((v$9$2) => {
    var v$9 = $as_s_Option(v$9$2);
    return new $c_sjsr_AnonFunction1(((x$27$2) => {
      var x$27$1 = $as_Lreactbuild_model_InvoiceDetail(x$27$2);
      var this$249 = $n(x$27$1);
      var x$92 = this$249.Lreactbuild_model_InvoiceDetail__f_id;
      var this$250 = $n(x$27$1);
      var x$93 = this$250.Lreactbuild_model_InvoiceDetail__f_reference;
      var this$251 = $n(x$27$1);
      var x$94 = this$251.Lreactbuild_model_InvoiceDetail__f_description;
      var this$252 = $n(x$27$1);
      var x$95 = this$252.Lreactbuild_model_InvoiceDetail__f_quantity;
      var this$253 = $n(x$27$1);
      var x$96 = this$253.Lreactbuild_model_InvoiceDetail__f_unit;
      var this$254 = $n(x$27$1);
      var x$97 = this$254.Lreactbuild_model_InvoiceDetail__f_unitPrice;
      var this$255 = $n(x$27$1);
      var x$98 = this$255.Lreactbuild_model_InvoiceDetail__f_amount;
      var this$256 = $n(x$27$1);
      var x$99 = this$256.Lreactbuild_model_InvoiceDetail__f_tradeBody;
      var this$257 = $n(x$27$1);
      var x$100 = this$257.Lreactbuild_model_InvoiceDetail__f_buildingSite;
      $n(x$27$1);
      return new $c_Lreactbuild_model_InvoiceDetail(x$92, x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, v$9)
    }))
  })));
  var optioner$8 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$6 = $m_Lreactbuild_model_Implicits$().dateParsable__Lcom_iz2use_common_ParsingReference__Lcom_iz2use_common_Parsable(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_dateRef);
  var ev$14 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$261 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$8 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$261);
  var editorComponent$8 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$8);
  var explainError$8 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$8 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
  var array$10 = [editorComponent$8.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$8, state$8, optioner$8, ev$14, explainError$8, equiv$8)];
  var $$x2 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$11 = [actions];
  var array$12 = [$$x29, $$x23, $$x18, $$x16, $$x14, $$x12, $$x10, $$x8, $$x6, $$x4, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
  return $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.processPdf__Lreactbuild_model_InvoicePage__Ljapgolly_scalajs_react_callback_Trampoline = (function(doc) {
  return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x3 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "processPdfFile"];
    var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$13 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
    var r = $n($n($n(doc).Lreactbuild_model_InvoicePage__f__id).Lreactbuild_common_model_RefTo__f_id).toString__T();
    var evidence$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
    var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "file", y)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$13.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$15 = $n(new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self);
      var evidence$1 = $m_Lreactbuild_model_PdfContent$().Lreactbuild_model_PdfContent$__f_codecForPdfContent;
      return $as_Lreactbuild_model_PdfContent(this$15.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2) => {
      var x = $as_Lreactbuild_model_PdfContent(x$2);
      var this$21 = $n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$2);
        $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText);
        var x$2$1 = new $c_Ldiode_data_Ready(x);
        var this$17 = $n(s);
        var x$3 = this$17.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
        var this$18 = $n(s);
        var x$4 = this$18.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails;
        var this$19 = $n(s);
        var x$5 = this$19.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging;
        $n(s);
        return new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(x$3, x$4, x$2$1, x$5)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$21, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.render__Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__Lreactbuild_analyze_cost_components_DocumentPageEditor$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var state = $n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document;
  var v = $as_Lreactbuild_model_InvoicePage($n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var pageProps = $n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_pageProps;
  var this$1 = $n($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_pageProps).Lreactbuild_package$PageProps__f_proxy);
  var this$2 = $n(this$1.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$2.value__O());
  var organizationOpt = $m_s_Option$().apply__O__s_Option($n(v).Lreactbuild_model_InvoicePage__f_organization);
  var this$745 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x144 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$());
  var $$x143 = this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("wrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$6 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x142 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x141 = this$7.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x140 = this$8.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x139 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x138 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 6em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Organisation");
  var state$1 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((s$2$2) => {
    var s$2 = $as_Lreactbuild_model_InvoicePage(s$2$2);
    return $m_s_Option$().apply__O__s_Option($n(s$2).Lreactbuild_model_InvoicePage__f_organization)
  })), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    if ((x0$1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x0$1);
      var ref = $as_Lreactbuild_common_model_RefTo($n(x2).s_Some__f_value);
      return new $c_sjsr_AnonFunction1(((x$28$2) => {
        var x$28 = $as_Lreactbuild_model_InvoicePage(x$28$2);
        var this$16 = $n(x$28);
        var x$2 = this$16.Lreactbuild_model_InvoicePage__f__id;
        var this$17 = $n(x$28);
        var x$3 = this$17.Lreactbuild_model_InvoicePage__f_file;
        var this$18 = $n(x$28);
        var x$4 = this$18.Lreactbuild_model_InvoicePage__f_notDone;
        var this$19 = $n(x$28);
        var x$5 = this$19.Lreactbuild_model_InvoicePage__f_supplier;
        var this$20 = $n(x$28);
        var x$6 = this$20.Lreactbuild_model_InvoicePage__f_supplierOffice;
        var this$21 = $n(x$28);
        var x$7 = this$21.Lreactbuild_model_InvoicePage__f_date;
        var this$22 = $n(x$28);
        var x$8 = this$22.Lreactbuild_model_InvoicePage__f_reference;
        var this$23 = $n(x$28);
        var x$9 = this$23.Lreactbuild_model_InvoicePage__f_pageIndex;
        var this$24 = $n(x$28);
        var x$10 = this$24.Lreactbuild_model_InvoicePage__f_pageCount;
        var this$25 = $n(x$28);
        var x$11 = this$25.Lreactbuild_model_InvoicePage__f_amount;
        var this$26 = $n(x$28);
        var x$12 = this$26.Lreactbuild_model_InvoicePage__f_totalAmount;
        var this$27 = $n(x$28);
        var x$13 = this$27.Lreactbuild_model_InvoicePage__f_details;
        var this$28 = $n(x$28);
        var x$14 = this$28.Lreactbuild_model_InvoicePage__f_entryNumber;
        var this$29 = $n(x$28);
        var x$15 = this$29.Lreactbuild_model_InvoicePage__f_category;
        var this$30 = $n(x$28);
        var x$16 = this$30.Lreactbuild_model_InvoicePage__f_deletedAt;
        $n(x$28);
        return new $c_Lreactbuild_model_InvoicePage(x$2, ref, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16)
      }))
    } else {
      return new $c_sjsr_AnonFunction1(((x$2$1) => {
        var x = $as_Lreactbuild_model_InvoicePage(x$2$1);
        return x
      }))
    }
  })));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$35 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$35, proxy);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$37 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$37, proxy$1);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$42 = $m_Lreactbuild_model_Implicits$();
  var this$41 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$41, proxy$2);
  var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$42, ev);
  var array = [$$x138, editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state$1, optioner, ev$1, explainError, equiv)];
  var $$x137 = $n($$x139).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x136 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x135 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 10em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Emetteur");
  var state$2 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$29$2) => {
    var x$29 = $as_Lreactbuild_model_InvoicePage(x$29$2);
    return $n(x$29).Lreactbuild_model_InvoicePage__f_supplier
  })), new $c_sjsr_AnonFunction1(((v$2$2) => {
    var v$2 = $as_s_Option(v$2$2);
    return new $c_sjsr_AnonFunction1(((x$30$2) => {
      var x$30 = $as_Lreactbuild_model_InvoicePage(x$30$2);
      var this$53 = $n(x$30);
      var x$18 = this$53.Lreactbuild_model_InvoicePage__f__id;
      var this$54 = $n(x$30);
      var x$19 = this$54.Lreactbuild_model_InvoicePage__f_organization;
      var this$55 = $n(x$30);
      var x$20 = this$55.Lreactbuild_model_InvoicePage__f_file;
      var this$56 = $n(x$30);
      var x$21 = this$56.Lreactbuild_model_InvoicePage__f_notDone;
      var this$57 = $n(x$30);
      var x$22 = this$57.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$58 = $n(x$30);
      var x$23 = this$58.Lreactbuild_model_InvoicePage__f_date;
      var this$59 = $n(x$30);
      var x$24 = this$59.Lreactbuild_model_InvoicePage__f_reference;
      var this$60 = $n(x$30);
      var x$25 = this$60.Lreactbuild_model_InvoicePage__f_pageIndex;
      var this$61 = $n(x$30);
      var x$26 = this$61.Lreactbuild_model_InvoicePage__f_pageCount;
      var this$62 = $n(x$30);
      var x$27 = this$62.Lreactbuild_model_InvoicePage__f_amount;
      var this$63 = $n(x$30);
      var x$28$1 = this$63.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$64 = $n(x$30);
      var x$29$1 = this$64.Lreactbuild_model_InvoicePage__f_details;
      var this$65 = $n(x$30);
      var x$30$2$1 = this$65.Lreactbuild_model_InvoicePage__f_entryNumber;
      var this$66 = $n(x$30);
      var x$31 = this$66.Lreactbuild_model_InvoicePage__f_category;
      var this$67 = $n(x$30);
      var x$32 = this$67.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(x$30);
      return new $c_Lreactbuild_model_InvoicePage(x$18, x$19, x$20, x$21, v$2, x$22, x$23, x$24, x$25, x$26, x$27, x$28$1, x$29$1, x$30$2$1, x$31, x$32)
    }))
  })));
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$71 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$3 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var ev$3 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$71, proxy$3, organizationOpt);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$73 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$4 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var helper$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$73, proxy$4, organizationOpt);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$78 = $m_Lreactbuild_model_Implicits$();
  var this$77 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$5 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$77, proxy$5);
  var equiv$1 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$78, ev$2);
  var array$1 = [$$x135, editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$2, optioner$1, ev$3, explainError$1, equiv$1)];
  var $$x134 = $n($$x136).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x133 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x132 = $m_Lcom_iz2use_react_components_Link$();
  var this$106 = $n(state);
  var mod = new $c_sjsr_AnonFunction1(((s$3$2) => {
    var s$3 = $as_Lreactbuild_model_InvoicePage(s$3$2);
    var x1 = $n(s$3).Lreactbuild_model_InvoicePage__f_deletedAt;
    var x$1 = $m_s_None$();
    if ((x$1 === x1)) {
      new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
      var $$x131 = $m_Ljava_time_Instant$();
      var this$89 = $m_RTLong$();
      var value = $uD(new Date().getTime());
      var lo = this$89.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
      var nextDeletedAt = new $c_s_Some($n($$x131).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, this$89.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)))
    } else {
      var nextDeletedAt = $m_s_None$()
    };
    var this$90 = $n(s$3);
    var x$34 = this$90.Lreactbuild_model_InvoicePage__f__id;
    var this$91 = $n(s$3);
    var x$35 = this$91.Lreactbuild_model_InvoicePage__f_organization;
    var this$92 = $n(s$3);
    var x$36 = this$92.Lreactbuild_model_InvoicePage__f_file;
    var this$93 = $n(s$3);
    var x$37 = this$93.Lreactbuild_model_InvoicePage__f_notDone;
    var this$94 = $n(s$3);
    var x$38 = this$94.Lreactbuild_model_InvoicePage__f_supplier;
    var this$95 = $n(s$3);
    var x$39 = this$95.Lreactbuild_model_InvoicePage__f_supplierOffice;
    var this$96 = $n(s$3);
    var x$40 = this$96.Lreactbuild_model_InvoicePage__f_date;
    var this$97 = $n(s$3);
    var x$41 = this$97.Lreactbuild_model_InvoicePage__f_reference;
    var this$98 = $n(s$3);
    var x$42 = this$98.Lreactbuild_model_InvoicePage__f_pageIndex;
    var this$99 = $n(s$3);
    var x$43 = this$99.Lreactbuild_model_InvoicePage__f_pageCount;
    var this$100 = $n(s$3);
    var x$44 = this$100.Lreactbuild_model_InvoicePage__f_amount;
    var this$101 = $n(s$3);
    var x$45 = this$101.Lreactbuild_model_InvoicePage__f_totalAmount;
    var this$102 = $n(s$3);
    var x$46 = this$102.Lreactbuild_model_InvoicePage__f_details;
    var this$103 = $n(s$3);
    var x$47 = this$103.Lreactbuild_model_InvoicePage__f_entryNumber;
    var this$104 = $n(s$3);
    var x$48 = this$104.Lreactbuild_model_InvoicePage__f_category;
    $n(s$3);
    return new $c_Lreactbuild_model_InvoicePage(x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, x$48, nextDeletedAt)
  }));
  var $$x130 = $n($$x132).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$106, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$109 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var $$x129 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$109.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, (-1));
  var this$110 = $n($n($as_Lreactbuild_model_InvoicePage($n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePage__f_deletedAt);
  if ((!this$110.isEmpty__Z())) {
    var this$116 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var array$2 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#C0C0C0", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Supprim\u00e9"))];
    var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    var $$x128 = this$116.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
  } else {
    var this$122 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Marquer comme supprim\u00e9"))];
    var ms$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    var $$x128 = this$122.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1)
  };
  var array$4 = [$$x129, $$x128];
  var array$5 = [$n($$x130).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var array$6 = [$$x143, $$x142, $$x141, $$x140, $$x137, $$x134, $n($$x133).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  var $$x127 = $n($$x144).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x126 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$134 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x123 = this$134.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var o = $n(v).Lreactbuild_model_InvoicePage__f_supplier;
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var array$8 = [$$x123, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((supplierRef$2) => {
    var supplierRef = $as_Lreactbuild_common_model_RefTo(supplierRef$2);
    var $$x124 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$137 = $n($as_sc_MapOps($m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_pageProps).Lreactbuild_package$PageProps__f_proxy, new $c_sjsr_AnonFunction1(((x$31$2) => {
      var x$31$1 = $as_Lreactbuild_model_CommonData(x$31$2);
      return $n(x$31$1).Lreactbuild_model_CommonData__f_personAnnotations
    })), new $c_Lreactbuild_package$DefaultCommonData$$anon$2())));
    var default$1 = new $c_sjsr_AnonFunction1(((x$32$2) => {
      $as_Lreactbuild_common_model_RefTo(x$32$2);
      return $m_s_package$().s_package$__f_Nil
    }));
    var as = $as_sc_IterableOnce($f_sc_MapOps__applyOrElse__O__F1__O(this$137, supplierRef, default$1));
    return $n($$x124).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((personAnnotation$2) => {
      var personAnnotation = $as_Lreactbuild_person_PersonAnnotation(personAnnotation$2);
      var $$x125 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(personAnnotation).Lreactbuild_person_PersonAnnotation__f_label;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$7 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      return $n($$x125).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
    })))
  })))];
  var $$x122 = $n($$x126).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
  var $$x121 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$151 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$());
  var $$x120 = this$151.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("wrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$152 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x119 = this$152.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$153 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x118 = this$153.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$154 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x117 = this$154.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x116 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x115 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 8em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date");
  var state$3 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$33$2) => {
    var x$33 = $as_Lreactbuild_model_InvoicePage(x$33$2);
    return $n(x$33).Lreactbuild_model_InvoicePage__f_date
  })), new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_s_Option(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$34$2) => {
      var x$34$1 = $as_Lreactbuild_model_InvoicePage(x$34$2);
      var this$161 = $n(x$34$1);
      var x$50 = this$161.Lreactbuild_model_InvoicePage__f__id;
      var this$162 = $n(x$34$1);
      var x$51 = this$162.Lreactbuild_model_InvoicePage__f_organization;
      var this$163 = $n(x$34$1);
      var x$52 = this$163.Lreactbuild_model_InvoicePage__f_file;
      var this$164 = $n(x$34$1);
      var x$53 = this$164.Lreactbuild_model_InvoicePage__f_notDone;
      var this$165 = $n(x$34$1);
      var x$54 = this$165.Lreactbuild_model_InvoicePage__f_supplier;
      var this$166 = $n(x$34$1);
      var x$55 = this$166.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$167 = $n(x$34$1);
      var x$56 = this$167.Lreactbuild_model_InvoicePage__f_reference;
      var this$168 = $n(x$34$1);
      var x$57 = this$168.Lreactbuild_model_InvoicePage__f_pageIndex;
      var this$169 = $n(x$34$1);
      var x$58 = this$169.Lreactbuild_model_InvoicePage__f_pageCount;
      var this$170 = $n(x$34$1);
      var x$59 = this$170.Lreactbuild_model_InvoicePage__f_amount;
      var this$171 = $n(x$34$1);
      var x$60 = this$171.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$172 = $n(x$34$1);
      var x$61 = this$172.Lreactbuild_model_InvoicePage__f_details;
      var this$173 = $n(x$34$1);
      var x$62 = this$173.Lreactbuild_model_InvoicePage__f_entryNumber;
      var this$174 = $n(x$34$1);
      var x$63 = this$174.Lreactbuild_model_InvoicePage__f_category;
      var this$175 = $n(x$34$1);
      var x$64 = this$175.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(x$34$1);
      return new $c_Lreactbuild_model_InvoicePage(x$50, x$51, x$52, x$53, x$54, x$55, v$3, x$56, x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64)
    }))
  })));
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser = $m_Lreactbuild_model_Implicits$().dateParsable__Lcom_iz2use_common_ParsingReference__Lcom_iz2use_common_Parsable(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_dateRef);
  var ev$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$179 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$179);
  var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
  var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
  var array$9 = [$$x115, editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$3, optioner$2, ev$4, explainError$2, equiv$2)];
  var $$x114 = $n($$x116).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x113 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x112 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 10em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Type de document");
  var state$4 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$35$2) => {
    var x$35$1 = $as_Lreactbuild_model_InvoicePage(x$35$2);
    return $n(x$35$1).Lreactbuild_model_InvoicePage__f_category
  })), new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4 = $as_s_Option(v$4$2);
    return new $c_sjsr_AnonFunction1(((x$36$2) => {
      var x$36$1 = $as_Lreactbuild_model_InvoicePage(x$36$2);
      var this$192 = $n(x$36$1);
      var x$66 = this$192.Lreactbuild_model_InvoicePage__f__id;
      var this$193 = $n(x$36$1);
      var x$67 = this$193.Lreactbuild_model_InvoicePage__f_organization;
      var this$194 = $n(x$36$1);
      var x$68 = this$194.Lreactbuild_model_InvoicePage__f_file;
      var this$195 = $n(x$36$1);
      var x$69 = this$195.Lreactbuild_model_InvoicePage__f_notDone;
      var this$196 = $n(x$36$1);
      var x$70 = this$196.Lreactbuild_model_InvoicePage__f_supplier;
      var this$197 = $n(x$36$1);
      var x$71 = this$197.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$198 = $n(x$36$1);
      var x$72 = this$198.Lreactbuild_model_InvoicePage__f_date;
      var this$199 = $n(x$36$1);
      var x$73 = this$199.Lreactbuild_model_InvoicePage__f_reference;
      var this$200 = $n(x$36$1);
      var x$74 = this$200.Lreactbuild_model_InvoicePage__f_pageIndex;
      var this$201 = $n(x$36$1);
      var x$75 = this$201.Lreactbuild_model_InvoicePage__f_pageCount;
      var this$202 = $n(x$36$1);
      var x$76 = this$202.Lreactbuild_model_InvoicePage__f_amount;
      var this$203 = $n(x$36$1);
      var x$77 = this$203.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$204 = $n(x$36$1);
      var x$78 = this$204.Lreactbuild_model_InvoicePage__f_details;
      var this$205 = $n(x$36$1);
      var x$79 = this$205.Lreactbuild_model_InvoicePage__f_entryNumber;
      var this$206 = $n(x$36$1);
      var x$80 = this$206.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(x$36$1);
      return new $c_Lreactbuild_model_InvoicePage(x$66, x$67, x$68, x$69, x$70, x$71, x$72, x$73, x$74, x$75, x$76, x$77, x$78, x$79, v$4, x$80)
    }))
  })));
  var optioner$3 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var ev$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var helper$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryHelper;
  var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
  var this$210 = $m_Lcom_iz2use_react_components_ExplainError$();
  var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1(this$210);
  var equiv$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
  var array$10 = [$$x112, editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$4, optioner$3, ev$5, explainError$3, equiv$3)];
  var $$x111 = $n($$x113).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
  var $$x110 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x109 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 8em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("N\u00b0 document");
  var state$5 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$37$2) => {
    var x$37$1 = $as_Lreactbuild_model_InvoicePage(x$37$2);
    return $n(x$37$1).Lreactbuild_model_InvoicePage__f_reference
  })), new $c_sjsr_AnonFunction1(((v$5$2) => {
    var v$5 = $as_s_Option(v$5$2);
    return new $c_sjsr_AnonFunction1(((x$38$2) => {
      var x$38$1 = $as_Lreactbuild_model_InvoicePage(x$38$2);
      var this$221 = $n(x$38$1);
      var x$82 = this$221.Lreactbuild_model_InvoicePage__f__id;
      var this$222 = $n(x$38$1);
      var x$83 = this$222.Lreactbuild_model_InvoicePage__f_organization;
      var this$223 = $n(x$38$1);
      var x$84 = this$223.Lreactbuild_model_InvoicePage__f_file;
      var this$224 = $n(x$38$1);
      var x$85 = this$224.Lreactbuild_model_InvoicePage__f_notDone;
      var this$225 = $n(x$38$1);
      var x$86 = this$225.Lreactbuild_model_InvoicePage__f_supplier;
      var this$226 = $n(x$38$1);
      var x$87 = this$226.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$227 = $n(x$38$1);
      var x$88 = this$227.Lreactbuild_model_InvoicePage__f_date;
      var this$228 = $n(x$38$1);
      var x$89 = this$228.Lreactbuild_model_InvoicePage__f_pageIndex;
      var this$229 = $n(x$38$1);
      var x$90 = this$229.Lreactbuild_model_InvoicePage__f_pageCount;
      var this$230 = $n(x$38$1);
      var x$91 = this$230.Lreactbuild_model_InvoicePage__f_amount;
      var this$231 = $n(x$38$1);
      var x$92 = this$231.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$232 = $n(x$38$1);
      var x$93 = this$232.Lreactbuild_model_InvoicePage__f_details;
      var this$233 = $n(x$38$1);
      var x$94 = this$233.Lreactbuild_model_InvoicePage__f_entryNumber;
      var this$234 = $n(x$38$1);
      var x$95 = this$234.Lreactbuild_model_InvoicePage__f_category;
      var this$235 = $n(x$38$1);
      var x$96 = this$235.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(x$38$1);
      return new $c_Lreactbuild_model_InvoicePage(x$82, x$83, x$84, x$85, x$86, x$87, x$88, v$5, x$89, x$90, x$91, x$92, x$93, x$94, x$95, x$96)
    }))
  })));
  var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$6);
  var ev$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$241 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$4 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$241);
  var editorComponent$4 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$4);
  var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv = $m_s_math_Equiv$String$();
  var equiv$4 = new $c_s_math_Equiv$OptionEquiv(eqv);
  var array$11 = [$$x109, editorComponent$4.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$4, state$5, optioner$4, ev$7, explainError$4, equiv$4)];
  var array$12 = [$$x120, $$x119, $$x118, $$x117, $$x114, $$x111, $n($$x110).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
  var $$x108 = $n($$x121).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
  var $$x107 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$254 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$());
  var $$x106 = this$254.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("wrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$255 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x105 = this$255.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$256 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x104 = this$256.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$257 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x103 = this$257.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x102 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x101 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 6em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("N\u00b0 \u00e9criture");
  var state$6 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$39$2) => {
    var x$39$1 = $as_Lreactbuild_model_InvoicePage(x$39$2);
    return $n(x$39$1).Lreactbuild_model_InvoicePage__f_entryNumber
  })), new $c_sjsr_AnonFunction1(((v$6$2) => {
    var v$6 = $as_s_Option(v$6$2);
    return new $c_sjsr_AnonFunction1(((x$40$2) => {
      var x$40$1 = $as_Lreactbuild_model_InvoicePage(x$40$2);
      var this$264 = $n(x$40$1);
      var x$98 = this$264.Lreactbuild_model_InvoicePage__f__id;
      var this$265 = $n(x$40$1);
      var x$99 = this$265.Lreactbuild_model_InvoicePage__f_organization;
      var this$266 = $n(x$40$1);
      var x$100 = this$266.Lreactbuild_model_InvoicePage__f_file;
      var this$267 = $n(x$40$1);
      var x$101 = this$267.Lreactbuild_model_InvoicePage__f_notDone;
      var this$268 = $n(x$40$1);
      var x$102 = this$268.Lreactbuild_model_InvoicePage__f_supplier;
      var this$269 = $n(x$40$1);
      var x$103 = this$269.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$270 = $n(x$40$1);
      var x$104 = this$270.Lreactbuild_model_InvoicePage__f_date;
      var this$271 = $n(x$40$1);
      var x$105 = this$271.Lreactbuild_model_InvoicePage__f_reference;
      var this$272 = $n(x$40$1);
      var x$106 = this$272.Lreactbuild_model_InvoicePage__f_pageIndex;
      var this$273 = $n(x$40$1);
      var x$107 = this$273.Lreactbuild_model_InvoicePage__f_pageCount;
      var this$274 = $n(x$40$1);
      var x$108 = this$274.Lreactbuild_model_InvoicePage__f_amount;
      var this$275 = $n(x$40$1);
      var x$109 = this$275.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$276 = $n(x$40$1);
      var x$110 = this$276.Lreactbuild_model_InvoicePage__f_details;
      var this$277 = $n(x$40$1);
      var x$111 = this$277.Lreactbuild_model_InvoicePage__f_category;
      var this$278 = $n(x$40$1);
      var x$112 = this$278.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(x$40$1);
      return new $c_Lreactbuild_model_InvoicePage(x$98, x$99, x$100, x$101, x$102, x$103, x$104, x$105, x$106, x$107, x$108, x$109, x$110, v$6, x$111, x$112)
    }))
  })));
  var optioner$5 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
  var ev$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$282 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$5 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$282);
  var editorComponent$5 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$5);
  var explainError$5 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$5 = $m_s_math_Equiv$Int$();
  var array$13 = [$$x101, editorComponent$5.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$5, state$6, optioner$5, ev$8, explainError$5, equiv$5)];
  var $$x100 = $n($$x102).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
  var $$x99 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x98 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Page n\u00b0");
  var state$7 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$41$2) => {
    var x$41$1 = $as_Lreactbuild_model_InvoicePage(x$41$2);
    return $n(x$41$1).Lreactbuild_model_InvoicePage__f_pageIndex
  })), new $c_sjsr_AnonFunction1(((v$7$2) => {
    var v$7 = $as_s_Option(v$7$2);
    return new $c_sjsr_AnonFunction1(((x$42$2) => {
      var x$42$1 = $as_Lreactbuild_model_InvoicePage(x$42$2);
      var this$295 = $n(x$42$1);
      var x$114 = this$295.Lreactbuild_model_InvoicePage__f__id;
      var this$296 = $n(x$42$1);
      var x$115 = this$296.Lreactbuild_model_InvoicePage__f_organization;
      var this$297 = $n(x$42$1);
      var x$116 = this$297.Lreactbuild_model_InvoicePage__f_file;
      var this$298 = $n(x$42$1);
      var x$117 = this$298.Lreactbuild_model_InvoicePage__f_notDone;
      var this$299 = $n(x$42$1);
      var x$118 = this$299.Lreactbuild_model_InvoicePage__f_supplier;
      var this$300 = $n(x$42$1);
      var x$119 = this$300.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$301 = $n(x$42$1);
      var x$120 = this$301.Lreactbuild_model_InvoicePage__f_date;
      var this$302 = $n(x$42$1);
      var x$121 = this$302.Lreactbuild_model_InvoicePage__f_reference;
      var this$303 = $n(x$42$1);
      var x$122 = this$303.Lreactbuild_model_InvoicePage__f_pageCount;
      var this$304 = $n(x$42$1);
      var x$123 = this$304.Lreactbuild_model_InvoicePage__f_amount;
      var this$305 = $n(x$42$1);
      var x$124 = this$305.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$306 = $n(x$42$1);
      var x$125 = this$306.Lreactbuild_model_InvoicePage__f_details;
      var this$307 = $n(x$42$1);
      var x$126 = this$307.Lreactbuild_model_InvoicePage__f_entryNumber;
      var this$308 = $n(x$42$1);
      var x$127 = this$308.Lreactbuild_model_InvoicePage__f_category;
      var this$309 = $n(x$42$1);
      var x$128 = this$309.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(x$42$1);
      return new $c_Lreactbuild_model_InvoicePage(x$114, x$115, x$116, x$117, x$118, x$119, x$120, x$121, v$7, x$122, x$123, x$124, x$125, x$126, x$127, x$128)
    }))
  })));
  var optioner$6 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
  var ev$9 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$313 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$6 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$313);
  var editorComponent$6 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$6);
  var explainError$6 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$6 = $m_s_math_Equiv$Int$();
  var array$14 = [$$x98, editorComponent$6.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$6, state$7, optioner$6, ev$9, explainError$6, equiv$6)];
  var $$x97 = $n($$x99).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
  var $$x96 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x95 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$7 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Nombre total de pages");
  var state$8 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$43$2) => {
    var x$43$1 = $as_Lreactbuild_model_InvoicePage(x$43$2);
    return $n(x$43$1).Lreactbuild_model_InvoicePage__f_pageCount
  })), new $c_sjsr_AnonFunction1(((v$8$2) => {
    var v$8 = $as_s_Option(v$8$2);
    return new $c_sjsr_AnonFunction1(((x$44$2) => {
      var x$44$1 = $as_Lreactbuild_model_InvoicePage(x$44$2);
      var this$326 = $n(x$44$1);
      var x$130 = this$326.Lreactbuild_model_InvoicePage__f__id;
      var this$327 = $n(x$44$1);
      var x$131 = this$327.Lreactbuild_model_InvoicePage__f_organization;
      var this$328 = $n(x$44$1);
      var x$132 = this$328.Lreactbuild_model_InvoicePage__f_file;
      var this$329 = $n(x$44$1);
      var x$133 = this$329.Lreactbuild_model_InvoicePage__f_notDone;
      var this$330 = $n(x$44$1);
      var x$134 = this$330.Lreactbuild_model_InvoicePage__f_supplier;
      var this$331 = $n(x$44$1);
      var x$135 = this$331.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$332 = $n(x$44$1);
      var x$136 = this$332.Lreactbuild_model_InvoicePage__f_date;
      var this$333 = $n(x$44$1);
      var x$137 = this$333.Lreactbuild_model_InvoicePage__f_reference;
      var this$334 = $n(x$44$1);
      var x$138 = this$334.Lreactbuild_model_InvoicePage__f_pageIndex;
      var this$335 = $n(x$44$1);
      var x$139 = this$335.Lreactbuild_model_InvoicePage__f_amount;
      var this$336 = $n(x$44$1);
      var x$140 = this$336.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$337 = $n(x$44$1);
      var x$141 = this$337.Lreactbuild_model_InvoicePage__f_details;
      var this$338 = $n(x$44$1);
      var x$142 = this$338.Lreactbuild_model_InvoicePage__f_entryNumber;
      var this$339 = $n(x$44$1);
      var x$143 = this$339.Lreactbuild_model_InvoicePage__f_category;
      var this$340 = $n(x$44$1);
      var x$144 = this$340.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(x$44$1);
      return new $c_Lreactbuild_model_InvoicePage(x$130, x$131, x$132, x$133, x$134, x$135, x$136, x$137, x$138, v$8, x$139, x$140, x$141, x$142, x$143, x$144)
    }))
  })));
  var optioner$7 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
  var ev$10 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$344 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$7 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$344);
  var editorComponent$7 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$7);
  var explainError$7 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$7 = $m_s_math_Equiv$Int$();
  var array$15 = [$$x95, editorComponent$7.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$7, state$8, optioner$7, ev$10, explainError$7, equiv$7)];
  var $$x94 = $n($$x96).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15));
  var $$x93 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x92 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1 8em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Montant global HT");
  var state$9 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$45$2) => {
    var x$45$1 = $as_Lreactbuild_model_InvoicePage(x$45$2);
    return $n(x$45$1).Lreactbuild_model_InvoicePage__f_amount
  })), new $c_sjsr_AnonFunction1(((v$9$2) => {
    var v$9 = $as_s_Option(v$9$2);
    return new $c_sjsr_AnonFunction1(((x$46$2) => {
      var x$46$1 = $as_Lreactbuild_model_InvoicePage(x$46$2);
      var this$357 = $n(x$46$1);
      var x$146 = this$357.Lreactbuild_model_InvoicePage__f__id;
      var this$358 = $n(x$46$1);
      var x$147 = this$358.Lreactbuild_model_InvoicePage__f_organization;
      var this$359 = $n(x$46$1);
      var x$148 = this$359.Lreactbuild_model_InvoicePage__f_file;
      var this$360 = $n(x$46$1);
      var x$149 = this$360.Lreactbuild_model_InvoicePage__f_notDone;
      var this$361 = $n(x$46$1);
      var x$150 = this$361.Lreactbuild_model_InvoicePage__f_supplier;
      var this$362 = $n(x$46$1);
      var x$151 = this$362.Lreactbuild_model_InvoicePage__f_supplierOffice;
      var this$363 = $n(x$46$1);
      var x$152 = this$363.Lreactbuild_model_InvoicePage__f_date;
      var this$364 = $n(x$46$1);
      var x$153 = this$364.Lreactbuild_model_InvoicePage__f_reference;
      var this$365 = $n(x$46$1);
      var x$154 = this$365.Lreactbuild_model_InvoicePage__f_pageIndex;
      var this$366 = $n(x$46$1);
      var x$155 = this$366.Lreactbuild_model_InvoicePage__f_pageCount;
      var this$367 = $n(x$46$1);
      var x$156 = this$367.Lreactbuild_model_InvoicePage__f_totalAmount;
      var this$368 = $n(x$46$1);
      var x$157 = this$368.Lreactbuild_model_InvoicePage__f_details;
      var this$369 = $n(x$46$1);
      var x$158 = this$369.Lreactbuild_model_InvoicePage__f_entryNumber;
      var this$370 = $n(x$46$1);
      var x$159 = this$370.Lreactbuild_model_InvoicePage__f_category;
      var this$371 = $n(x$46$1);
      var x$160 = this$371.Lreactbuild_model_InvoicePage__f_deletedAt;
      $n(x$46$1);
      return new $c_Lreactbuild_model_InvoicePage(x$146, x$147, x$148, x$149, x$150, x$151, x$152, x$153, x$154, x$155, v$9, x$156, x$157, x$158, x$159, x$160)
    }))
  })));
  var optioner$8 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
  var ev$11 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$375 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$8 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$375);
  var editorComponent$8 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$8);
  var explainError$8 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$8 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
  var array$16 = [$$x92, editorComponent$8.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$8, state$9, optioner$8, ev$11, explainError$8, equiv$8)];
  var array$17 = [$$x106, $$x105, $$x104, $$x103, $$x100, $$x97, $$x94, $n($$x93).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
  var $$x91 = $n($$x107).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17));
  var $$x90 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x89 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$18 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Page \u00e9ventuellement en relation"))];
  var $$x88 = $n($$x89).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18));
  var c = $m_Lreactbuild_analyze_cost_components_MaybeRelated$().Lreactbuild_analyze_cost_components_MaybeRelated$__f_component;
  var this$396 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_components_MaybeRelated$Props($n(v).Lreactbuild_model_InvoicePage__f__id, $n(v).Lreactbuild_model_InvoicePage__f_supplier, $n(v).Lreactbuild_model_InvoicePage__f_date, $n(v).Lreactbuild_model_InvoicePage__f_reference, $n(v).Lreactbuild_model_InvoicePage__f_pageIndex, $n(v).Lreactbuild_model_InvoicePage__f_pageCount, $n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_pageProps).Lreactbuild_package$PageProps__f_router, new $c_sjsr_AnonFunction1(((x$47$2) => {
    var x$47$1 = $as_F1(x$47$2);
    var this$395 = $n(state);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$395, x$47$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$396.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$396.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$398 = $n(u);
  var n = this$398.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$19 = [$$x88, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  var $$x87 = $n($$x90).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19));
  var $$x86 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x85 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$407 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x84 = this$407.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$408 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x83 = this$408.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$409 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x82 = this$409.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x81 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$20 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9tails de la facture"))];
  var $$x80 = $n($$x81).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20));
  var $$x79 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$21 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" "))];
  var $$x78 = $n($$x79).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21));
  var $$x77 = $m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.processPdf__Lreactbuild_model_InvoicePage__Ljapgolly_scalajs_react_callback_Trampoline(v));
  var array$22 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Importer le texte du PDF"))];
  var array$23 = [$$x84, $$x83, $$x82, $$x80, $$x78, $n($$x77).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22))];
  var $$x76 = $n($$x85).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23));
  var $$x75 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x74 = $m_Ldiode_react_ReactPot$potWithReact$();
  var pot = $n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
  var $$x73 = $n($$x74).renderPending$extension__Ldiode_data_Pot__F1__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot, new $c_sjsr_AnonFunction1(((x$48$2) => {
    var x$48$1 = $uI(x$48$2);
    return (x$48$1 > 500)
  })), new $c_sjsr_AnonFunction1(((x$49$2) => {
    $uI(x$49$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chargement en cours")
  })));
  var this$443 = $n($n($as_Lreactbuild_model_InvoicePage($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePage__f_supplier);
  var ifEmpty = new $c_sjsr_AnonFunction0((() => {
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Renseigner d'abord un \u00e9metteur")
  }));
  var f = new $c_sjsr_AnonFunction1(((supplier$2) => {
    var supplier = $as_Lreactbuild_common_model_RefTo(supplier$2);
    var $$x72 = $m_Ldiode_react_ReactPot$potWithReact$();
    var pot$1 = $n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
    return $n($$x72).render$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot$1, new $c_sjsr_AnonFunction1(((x$50$2) => {
      var x$50$1 = $as_Lreactbuild_model_PdfContent(x$50$2);
      var u$1 = $m_Lreactbuild_analyze_cost_components_PDFText$().apply__Lreactbuild_common_model_RefTo__Lreactbuild_model_PdfContent__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(supplier, x$50$1);
      var this$441 = $n(u$1);
      var n$1 = this$441.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    })))
  }));
  var array$24 = [$$x73, $as_Ljapgolly_scalajs_react_vdom_TagMod((this$443.isEmpty__Z() ? ifEmpty.apply__O() : f.apply__O__O(this$443.get__O())))];
  var $$x71 = $n($$x75).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24));
  var $$x70 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$449 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
  var $$x69 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$449, s$1);
  var $$x68 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x67 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x66 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x65 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$()).Ljapgolly_scalajs_react_vdom_HtmlTags$input$__f_checkbox;
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$458 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "checked");
  var a = this.isAllDetailsSelected__Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__Lreactbuild_analyze_cost_components_DocumentPageEditor$State__Z(p, s);
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
  var array$25 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$458.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.toggleAllDetails__Ljapgolly_scalajs_react_callback_Trampoline()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var array$26 = [$n($$x65).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25))];
  var $$x64 = $n($$x66).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$26));
  var $$x63 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$27 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x62 = $n($$x63).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$27));
  var $$x61 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$28 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9signation")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x60 = $n($$x61).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$28));
  var $$x59 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$29 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Qt\u00e9")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x58 = $n($$x59).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$29));
  var $$x57 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$30 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Unit\u00e9")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x56 = $n($$x57).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$30));
  var $$x55 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$31 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix unitaire HT")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x54 = $n($$x55).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$31));
  var $$x53 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$32 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix total HT")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("6em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x52 = $n($$x53).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$32));
  var $$x51 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$33 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Corps d'\u00e9tat")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("15em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x50 = $n($$x51).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$33));
  var $$x49 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$34 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chantier")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("15em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x48 = $n($$x49).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$34));
  var $$x47 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$35 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Livraison")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("6em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("6em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x46 = $n($$x47).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$35));
  var $$x45 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$36 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Action")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$37 = [$$x64, $$x62, $$x60, $$x58, $$x56, $$x54, $$x52, $$x50, $$x48, $$x46, $n($$x45).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$36))];
  var array$38 = [$n($$x67).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$37))];
  var $$x44 = $n($$x68).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$38));
  var $$x43 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x42 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x41 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("updateSelection", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var $$x40 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).when__Z__F0__Ljapgolly_scalajs_react_vdom_TagMod($n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails).isEmpty__Z(), new $c_sjsr_AnonFunction0((() => {
    var this$574 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).visibility__Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$());
    return this$574.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
  })));
  var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x38 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x37 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x35 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
  var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$589 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_stickyTop;
  var $$x32 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$589, s$4);
  var $$x31 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("zIndex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("9", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$593 = $n($n($as_Lreactbuild_model_InvoicePage($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePage__f_details);
  var op = new $c_sjsr_AnonFunction2(((acc$2, c$2) => {
    var acc = $uD(acc$2);
    var c$1 = $as_Lreactbuild_model_InvoiceDetail(c$2);
    var this$591 = $n($n(c$1).Lreactbuild_model_InvoiceDetail__f_amount);
    var p$1 = new $c_sjsr_AnonFunction1(((x$51$2) => {
      $as_Lreactbuild_model_Price(x$51$2);
      return $n($n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails).contains__O__Z($n(c$1).Lreactbuild_model_InvoiceDetail__f_id)
    }));
    var this$592 = $n(((this$591.isEmpty__Z() || $uZ(p$1.apply__O__O(this$591.get__O()))) ? this$591 : $m_s_None$()));
    var ifEmpty$1 = new $c_sjsr_AnonFunction0((() => 0.0));
    var f$1 = new $c_sjsr_AnonFunction1(((x$52$2) => {
      var x$52$1 = $as_Lreactbuild_model_Price(x$52$2);
      return $n(x$52$1).Lreactbuild_model_Price__f_amount
    }));
    return (acc + $uD((this$592.isEmpty__Z() ? ifEmpty$1.apply__O() : f$1.apply__O__O(this$592.get__O()))))
  }));
  var v$10 = new $c_Lreactbuild_model_Price($uD($f_sc_LinearSeqOps__foldLeft__O__F2__O(this$593, 0.0, op)));
  var ev$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
  var v$11 = $n(ev$12).stringify__O__T(v$10);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$39 = [$$x32, $$x31, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$11)];
  var $$x30 = $n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$39));
  var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$602 = $m_Lscalacss_ScalaCssReact$();
  var s$5 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_stickyTop;
  var $$x28 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$602, s$5);
  var $$x27 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("zIndex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("9", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Corps d'\u00e9tat");
  var $$x25 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value$1 = $m_s_None$();
  var state$10 = $n($$x25).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$1, new $c_sjsr_AnonFunction2(((x0$2$2, x1$1$2) => {
    var x0$2 = $as_s_Option(x0$2$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1$2 = $ct_T2__O__O__(new $c_T2(), x0$2, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x26;
      var p2 = $as_s_Option(x1$2.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x$17 = $m_s_None$();
      if ((x$17 === p2)) {
        var $$x26 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1$2.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v$12 = $as_s_Option($n(x5).s_Some__f_value);
        var $$x26 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this.updateSelection__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction1(((x$53$2) => {
          var x$53$1 = $as_Lreactbuild_model_InvoiceDetail(x$53$2);
          var this$607 = $n(x$53$1);
          var x$162 = this$607.Lreactbuild_model_InvoiceDetail__f_id;
          var this$608 = $n(x$53$1);
          var x$163 = this$608.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$609 = $n(x$53$1);
          var x$164 = this$609.Lreactbuild_model_InvoiceDetail__f_description;
          var this$610 = $n(x$53$1);
          var x$165 = this$610.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$611 = $n(x$53$1);
          var x$166 = this$611.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$612 = $n(x$53$1);
          var x$167 = this$612.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$613 = $n(x$53$1);
          var x$168 = this$613.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$614 = $n(x$53$1);
          var x$169 = this$614.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$615 = $n(x$53$1);
          var x$170 = this$615.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$53$1);
          return new $c_Lreactbuild_model_InvoiceDetail(x$162, x$163, x$164, x$165, x$166, x$167, x$168, v$12, x$169, x$170)
        }))), cb$2);
        break matchEnd7
      };
      throw new $c_s_MatchError(x1$2)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x26)
  })));
  var optioner$9 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$619 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$6 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var ev$14 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$16(this$619, proxy$6, organizationOpt);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$621 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$7 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var helper$9 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$16(this$621, proxy$7, organizationOpt);
  var editorComponent$9 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$9);
  var explainError$9 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$626 = $m_Lreactbuild_model_Implicits$();
  var this$625 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$8 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var ev$13 = $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$625, proxy$8);
  var equiv$9 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$626, ev$13);
  var array$40 = [$$x28, $$x27, editorComponent$9.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$9, state$10, optioner$9, ev$14, explainError$9, equiv$9)];
  var $$x24 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$40));
  var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$633 = $m_Lscalacss_ScalaCssReact$();
  var s$6 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_stickyTop;
  var $$x22 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$633, s$6);
  var $$x21 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("zIndex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("9", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$10 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chantier");
  var $$x19 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value$2 = $m_s_None$();
  var state$11 = $n($$x19).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$2, new $c_sjsr_AnonFunction2(((x0$3$2, x1$2$2) => {
    var x0$3 = $as_s_Option(x0$3$2);
    var x1$2$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1$3 = $ct_T2__O__O__(new $c_T2(), x0$3, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2$1));
    matchEnd7$1: {
      var $$x20;
      var p2$1 = $as_s_Option(x1$3.T2__f__1);
      var cb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x$65 = $m_s_None$();
      if ((x$65 === p2$1)) {
        var $$x20 = cb$1;
        break matchEnd7$1
      };
      var p4$1 = $as_s_Option(x1$3.T2__f__1);
      var cb$2$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4$1 instanceof $c_s_Some)) {
        var x5$1 = $as_s_Some(p4$1);
        var v$13 = $as_s_Option($n(x5$1).s_Some__f_value);
        var $$x20 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this.updateSelection__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction1(((x$54$2) => {
          var x$54$1 = $as_Lreactbuild_model_InvoiceDetail(x$54$2);
          var this$638 = $n(x$54$1);
          var x$172 = this$638.Lreactbuild_model_InvoiceDetail__f_id;
          var this$639 = $n(x$54$1);
          var x$173 = this$639.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$640 = $n(x$54$1);
          var x$174 = this$640.Lreactbuild_model_InvoiceDetail__f_description;
          var this$641 = $n(x$54$1);
          var x$175 = this$641.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$642 = $n(x$54$1);
          var x$176 = this$642.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$643 = $n(x$54$1);
          var x$177 = this$643.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$644 = $n(x$54$1);
          var x$178 = this$644.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$645 = $n(x$54$1);
          var x$179 = this$645.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$646 = $n(x$54$1);
          var x$180 = this$646.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$54$1);
          return new $c_Lreactbuild_model_InvoiceDetail(x$172, x$173, x$174, x$175, x$176, x$177, x$178, x$179, v$13, x$180)
        }))), cb$2$1);
        break matchEnd7$1
      };
      throw new $c_s_MatchError(x1$3)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x20)
  })));
  var optioner$10 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$650 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$9 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var ev$16 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$650, proxy$9);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$652 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$10 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var helper$10 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$652, proxy$10);
  var editorComponent$10 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$10);
  var explainError$10 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$657 = $m_Lreactbuild_model_Implicits$();
  var this$656 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var proxy$11 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
  var ev$15 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$656, proxy$11);
  var equiv$10 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$657, ev$15);
  var array$41 = [$$x22, $$x21, editorComponent$10.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$10, state$11, optioner$10, ev$16, explainError$10, equiv$10)];
  var $$x18 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$41));
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$664 = $m_Lscalacss_ScalaCssReact$();
  var s$7 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_stickyTop;
  var $$x16 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$664, s$7);
  var $$x15 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("zIndex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("9", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$11 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Livraison");
  var $$x13 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value$3 = $m_s_None$();
  var state$12 = $n($$x13).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$3, new $c_sjsr_AnonFunction2(((x0$4$2, x1$3$2) => {
    var x0$4 = $as_s_Option(x0$4$2);
    var x1$3$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1$4 = $ct_T2__O__O__(new $c_T2(), x0$4, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3$1));
    matchEnd7$2: {
      var $$x14;
      var p2$2 = $as_s_Option(x1$4.T2__f__1);
      var cb$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$4.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x$81 = $m_s_None$();
      if ((x$81 === p2$2)) {
        var $$x14 = cb$3;
        break matchEnd7$2
      };
      var p4$2 = $as_s_Option(x1$4.T2__f__1);
      var cb$2$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$4.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4$2 instanceof $c_s_Some)) {
        var x5$2 = $as_s_Some(p4$2);
        var v$14 = $as_s_Option($n(x5$2).s_Some__f_value);
        var $$x14 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this.updateSelection__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction1(((x$55$2) => {
          var x$55$1 = $as_Lreactbuild_model_InvoiceDetail(x$55$2);
          var this$669 = $n(x$55$1);
          var x$182 = this$669.Lreactbuild_model_InvoiceDetail__f_id;
          var this$670 = $n(x$55$1);
          var x$183 = this$670.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$671 = $n(x$55$1);
          var x$184 = this$671.Lreactbuild_model_InvoiceDetail__f_description;
          var this$672 = $n(x$55$1);
          var x$185 = this$672.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$673 = $n(x$55$1);
          var x$186 = this$673.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$674 = $n(x$55$1);
          var x$187 = this$674.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$675 = $n(x$55$1);
          var x$188 = this$675.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$676 = $n(x$55$1);
          var x$189 = this$676.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$677 = $n(x$55$1);
          var x$190 = this$677.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          $n(x$55$1);
          return new $c_Lreactbuild_model_InvoiceDetail(x$182, x$183, x$184, x$185, x$186, x$187, x$188, x$189, x$190, v$14)
        }))), cb$2$2);
        break matchEnd7$2
      };
      throw new $c_s_MatchError(x1$4)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x14)
  })));
  var optioner$11 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$6 = $m_Lreactbuild_model_Implicits$().dateParsable__Lcom_iz2use_common_ParsingReference__Lcom_iz2use_common_Parsable(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_dateRef);
  var ev$17 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$681 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$11 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$681);
  var editorComponent$11 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$11);
  var explainError$11 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
  var array$42 = [$$x16, $$x15, editorComponent$11.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$11, state$12, optioner$11, ev$17, explainError$11, equiv$11)];
  var array$43 = [$$x41, $$x40, $$x39, $$x38, $$x37, $$x36, $$x35, $$x34, $$x30, $$x24, $$x18, $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$42))];
  var $$x12 = $n($$x42).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$43));
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$691 = $n($n(v).Lreactbuild_model_InvoicePage__f_details);
  var end = this$691.length__I();
  var as$1 = new $c_sci_Range$Exclusive(0, end, 1);
  var $$x7 = $n($$x8).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((i$2) => {
    var i = $uI(i$2);
    var $$x10 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$56$2) => {
      var x$56$1 = $as_Lreactbuild_model_InvoicePage(x$56$2);
      var this$694 = $n($n(x$56$1).Lreactbuild_model_InvoicePage__f_details);
      return $as_Lreactbuild_model_InvoiceDetail($f_sc_LinearSeqOps__apply__I__O(this$694, i))
    })), new $c_sjsr_AnonFunction1(((v$2$1) => {
      var v$15 = $as_Lreactbuild_model_InvoiceDetail(v$2$1);
      return new $c_sjsr_AnonFunction1(((s$2$1) => {
        var s$8 = $as_Lreactbuild_model_InvoicePage(s$2$1);
        var this$698 = $n($n(s$8).Lreactbuild_model_InvoicePage__f_details);
        var $$x11 = $n($m_s_package$().s_package$__f_Seq);
        var array$44 = [v$15];
        var other = $n($$x11).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$44));
        var x$191 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$698, i, other, 1));
        var this$699 = $n(s$8);
        var x$192 = this$699.Lreactbuild_model_InvoicePage__f__id;
        var this$700 = $n(s$8);
        var x$193 = this$700.Lreactbuild_model_InvoicePage__f_organization;
        var this$701 = $n(s$8);
        var x$194 = this$701.Lreactbuild_model_InvoicePage__f_file;
        var this$702 = $n(s$8);
        var x$195 = this$702.Lreactbuild_model_InvoicePage__f_notDone;
        var this$703 = $n(s$8);
        var x$196 = this$703.Lreactbuild_model_InvoicePage__f_supplier;
        var this$704 = $n(s$8);
        var x$197 = this$704.Lreactbuild_model_InvoicePage__f_supplierOffice;
        var this$705 = $n(s$8);
        var x$198 = this$705.Lreactbuild_model_InvoicePage__f_date;
        var this$706 = $n(s$8);
        var x$199 = this$706.Lreactbuild_model_InvoicePage__f_reference;
        var this$707 = $n(s$8);
        var x$200 = this$707.Lreactbuild_model_InvoicePage__f_pageIndex;
        var this$708 = $n(s$8);
        var x$201 = this$708.Lreactbuild_model_InvoicePage__f_pageCount;
        var this$709 = $n(s$8);
        var x$202 = this$709.Lreactbuild_model_InvoicePage__f_amount;
        var this$710 = $n(s$8);
        var x$203 = this$710.Lreactbuild_model_InvoicePage__f_totalAmount;
        var this$711 = $n(s$8);
        var x$204 = this$711.Lreactbuild_model_InvoicePage__f_entryNumber;
        var this$712 = $n(s$8);
        var x$205 = this$712.Lreactbuild_model_InvoicePage__f_category;
        var this$713 = $n(s$8);
        var x$206 = this$713.Lreactbuild_model_InvoicePage__f_deletedAt;
        $n(s$8);
        return new $c_Lreactbuild_model_InvoicePage(x$192, x$193, x$194, x$195, x$196, x$197, x$198, x$199, x$200, x$201, x$202, x$203, x$191, x$204, x$205, x$206)
      }))
    })));
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$45 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("-")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.deleter__I__Ljapgolly_scalajs_react_callback_Trampoline(i)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    return this.renderInvoiceDetail__Lreactbuild_analyze_cost_services_Model__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_components_DocumentPageEditor$State__Ljapgolly_scalajs_react_vdom_TagMod__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf(m, $$x10, s, $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$45)), ($m_Lreactbuild_model_Implicits$(), $n(pageProps).Lreactbuild_package$PageProps__f_proxy))
  })));
  var $$x6 = this.renderSum__sci_List__Ljapgolly_scalajs_react_vdom_TagOf($n(v).Lreactbuild_model_InvoicePage__f_details);
  var $$x5 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
  var $$x4 = this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_newDetailState;
  var $$x3 = $n(s).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
  $m_Lreactbuild_model_Implicits$();
  var this$724 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x2 = $n($$x5).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($$x4, $$x3, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$724.byRef__F2(), this$724.by_$eq$eq__F2()));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$46 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("+")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.adder__Ljapgolly_scalajs_react_callback_Trampoline()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var array$47 = [$$x12, $$x7, $$x6, this.renderInvoiceDetail__Lreactbuild_analyze_cost_services_Model__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_components_DocumentPageEditor$State__Ljapgolly_scalajs_react_vdom_TagMod__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf(m, $$x2, s, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$46)), ($m_Lreactbuild_model_Implicits$(), $n(pageProps).Lreactbuild_package$PageProps__f_proxy))];
  var array$48 = [$$x69, $$x44, $n($$x43).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$47))];
  var array$49 = [$$x76, $$x71, $n($$x70).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$48))];
  var array$50 = [$$x127, $$x122, $$x108, $$x91, $$x87, $n($$x86).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$49))];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$50);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$745, null, ns)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.onPropsChange__Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__Lreactbuild_analyze_cost_components_DocumentPageEditor$State__Ljapgolly_scalajs_react_callback_Trampoline = (function(prevProps, nextProps, state) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var x = $n($as_Lreactbuild_model_InvoicePage($n($n(prevProps).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePage__f__id;
  var x$2 = $n($as_Lreactbuild_model_InvoicePage($n($n(nextProps).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_InvoicePage__f__id;
  var cond = (!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)));
  if (cond) {
    var this$7 = $n(this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(s$2);
      var x$1 = $m_s_package$().s_package$__f_Nil;
      var x$2$1 = $m_Ldiode_data_Empty$();
      var this$4 = $n(s);
      var x$3 = this$4.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
      var this$5 = $n(s);
      var x$4 = this$5.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging;
      $n(s);
      return new $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(x$3, x$1, x$2$1, x$4)
    }));
    var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$7, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
function $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.DocumentPageEditor$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.DocumentPageEditor$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend: 0
}, false, "reactbuild.analyze.cost.components.DocumentPageEditor$Backend", {
  Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DocumentPageEditor$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_selectActive = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x1;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x1 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var ref = $as_Lreactbuild_common_model_RefTo($n(x5).s_Some__f_value);
        var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$8$2) => {
          $as_Ldiode_data_Pot(x$8$2);
          return new $c_Ldiode_data_Ready(ref)
        })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_selectActive = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f)
}
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend.prototype = $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend.prototype.render__Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__Ldiode_data_Pot__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var pageProps = $n(p).Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_pageProps;
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_horizontalLayout;
  var $$x13 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var $$x12 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_verticalLayout;
  var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$2);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$9 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
  var $$x9 = this$9.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$10 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignSelf__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$());
  var $$x8 = this$10.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("stretch", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var u = $m_Lreactbuild_analyze_cost_components_PDFViewer$().apply__Ldiode_data_Pot__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(s);
  var this$12 = $n(u);
  var n = this$12.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [$$x10, $$x9, $$x8, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  var $$x7 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$19 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_verticalLayout;
  var $$x4 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$19, s$3);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$21 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
  var $$x3 = this$21.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x2 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("50%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$24 = $n(s);
  if (this$24.isEmpty__Z()) {
    var this$25 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var ns = $m_sci_Nil$();
    var $$x1 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$25, null, ns)
  } else {
    var arg1 = this$24.get__O();
    var ref = $as_Lreactbuild_common_model_RefTo(arg1);
    var $$x1 = $m_Lreactbuild_analyze_cost_components_DocumentPageList$().apply__Ldiode_data_Pot__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_invoicePageGroup).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$9$2);
      return $as_Lreactbuild_model_InvoicePageGroup($n(x$9).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
    }))), $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$().apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend__f_selectActive, ref, $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2()))
  };
  var array$1 = [$$x4, $$x3, $$x2, $as_Ljapgolly_scalajs_react_vdom_TagMod($$x1), $m_Lreactbuild_analyze_cost_components_DocumentPageEditor$().apply__Ldiode_data_Pot__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_invoicePageGroup).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$10$2);
    var this$37 = $n(x$10);
    var g = new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_Lreactbuild_model_InvoicePage(v$2);
      return new $c_sjsr_AnonFunction1(((old$2) => {
        var old = $as_Lreactbuild_model_InvoicePageGroup(old$2);
        var x$1 = $as_sci_Seq($n($n(old).Lreactbuild_model_InvoicePageGroup__f_pages).map__F1__O(new $c_sjsr_AnonFunction1(((page$2) => {
          var page = $as_Lreactbuild_model_InvoicePage(page$2);
          return ($n(s).contains__O__Z($n(page).Lreactbuild_model_InvoicePage__f__id) ? v : page)
        }))));
        var this$27 = $n(old);
        var x$2 = this$27.Lreactbuild_model_InvoicePageGroup__f_organization;
        var this$28 = $n(old);
        var x$3 = this$28.Lreactbuild_model_InvoicePageGroup__f_supplier;
        var this$29 = $n(old);
        var x$4 = this$29.Lreactbuild_model_InvoicePageGroup__f_date;
        var this$30 = $n(old);
        var x$5 = this$30.Lreactbuild_model_InvoicePageGroup__f_entryNumber;
        var this$31 = $n(old);
        var x$6 = this$31.Lreactbuild_model_InvoicePageGroup__f_reference;
        var this$32 = $n(old);
        var x$7 = this$32.Lreactbuild_model_InvoicePageGroup__f_totalAmount;
        var this$33 = $n(old);
        var x$8 = this$33.Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
        var this$34 = $n(old);
        var x$9$1 = this$34.Lreactbuild_model_InvoicePageGroup__f_received;
        var this$35 = $n(old);
        var x$10$1 = this$35.Lreactbuild_model_InvoicePageGroup__f_category;
        $n(old);
        return new $c_Lreactbuild_model_InvoicePageGroup(x$2, x$3, x$4, x$5, x$6, x$1, x$7, x$8, x$9$1, x$10$1)
      }))
    }));
    var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$37.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
    var arg1$1 = this$37.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$11 = $as_Lreactbuild_model_InvoicePageGroup(arg1$1);
    return $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$37, $as_Lreactbuild_model_InvoicePage($n($n($n(x$11).Lreactbuild_model_InvoicePageGroup__f_pages).find__F1__s_Option(new $c_sjsr_AnonFunction1(((p$2) => {
      var p$1 = $as_Lreactbuild_model_InvoicePage(p$2);
      return $n(s).contains__O__Z($n(p$1).Lreactbuild_model_InvoicePage__f__id)
    })))).get__O()), new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
      var ot = $as_s_Option(ot$2);
      var $$x5 = $n($as_F2($n(this$37.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
      var this$38 = $n(ot);
      return $n($$x5).apply__O__O__O((this$38.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$38.get__O()))), cb$2)
    })))
  }))), pageProps)];
  var array$2 = [$$x13, $$x12, $$x7, $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  return $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
function $as_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.DocumentPageGroupEditor$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.DocumentPageGroupEditor$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend: 0
}, false, "reactbuild.analyze.cost.components.DocumentPageGroupEditor$Backend", {
  Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend() {
  this.Lreactbuild_analyze_cost_components_DropArea$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DropArea$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_DropArea$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_DropArea$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.handleDragStart__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev.defaultPrevented)))), new $c_sjsr_AnonFunction1(((x$7$2) => {
    $as_jl_Void(x$7$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var f = new $c_sjsr_AnonFunction0((() => {
      ev.dataTransfer.dropEffect = "copy"
    }));
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      f.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var c = $n($$x1).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1), new $c_sjsr_AnonFunction1(((x$6$2) => {
      $as_jl_Void(x$6$2);
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var this$8 = $n(this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$3$2) => {
        var x$3 = $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(x$3$2);
        $n(x$3);
        var this$6 = $n(x$3);
        var result = this$6.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result;
        return new $c_Lreactbuild_analyze_cost_components_DropArea$TypedState(true, result)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$8, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$5$2) => {
        $as_jl_Void(x$5$2);
        $m_Ljapgolly_scalajs_react_package$();
        var this$10 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev, this$10.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f$2 = new $c_sjsr_AnonFunction1(((x$4$2) => {
          $as_jl_Void(x$4$2)
        }));
        var this$12 = $n(this$);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$12, f$2))
      }))))
    })));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  })));
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$15 = $m_s_$less$colon$less$();
  return $n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$15.s_$less$colon$less$__f_singleton)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.handleDragOver__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev.defaultPrevented)))), new $c_sjsr_AnonFunction1(((x$10$2) => {
    $as_jl_Void(x$10$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var c$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(s$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).require__F0__F0(new $c_sjsr_AnonFunction0((() => $n(s).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver))), new $c_sjsr_AnonFunction1(((x$9$2) => {
        $as_jl_Void(x$9$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_package$();
        var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
          $as_jl_Void(x$8$2)
        }));
        var this$6 = $n(this$);
        var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$6, f);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
      })));
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$9 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$9.s_$less$colon$less$__f_singleton))
    })));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1))
  })));
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$12 = $m_s_$less$colon$less$();
  return $n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$1, this$12.s_$less$colon$less$__f_singleton)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.handleFiles__Lreactbuild_analyze_cost_components_DropArea$TypedProps__sci_List__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, files) {
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(s$2);
    var x$1 = $n($n(s).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result).pending__J__Ldiode_data_Pot($n($n(s).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result).pending$default$1__J());
    var this$2 = $n(s);
    var x$2 = this$2.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver;
    $n(s);
    return new $c_Lreactbuild_analyze_cost_components_DropArea$TypedState(x$2, x$1)
  })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().handleError$extension__F1__F1__F1($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n($n(p).Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_handler).apply__O__O(files))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, new $c_sjsr_AnonFunction1(((v$2) => {
    var this$7 = $n(this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2$1) => {
      var s$1 = $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(s$2$1);
      $n($n(s$1).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result);
      var x$3 = new $c_Ldiode_data_Ready(v$2);
      var this$5 = $n(s$1);
      var x$4 = this$5.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver;
      $n(s$1);
      return new $c_Lreactbuild_analyze_cost_components_DropArea$TypedState(x$4, x$3)
    }));
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$7, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_CallbackTo$().delayMs$extension__Ljapgolly_scalajs_react_callback_Trampoline__D__F1(this$, 1.0))
  }))), new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_jl_Throwable(v$3$2);
    var this$11 = $n(this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$);
    var mod$1 = new $c_sjsr_AnonFunction1(((s$2$2) => {
      var s$3 = $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(s$2$2);
      var x$5 = $n($n(s$3).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result).fail__jl_Throwable__Ldiode_data_Pot(v$3);
      var this$9 = $n(s$3);
      var x$6 = this$9.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver;
      $n(s$3);
      return new $c_Lreactbuild_analyze_cost_components_DropArea$TypedState(x$6, x$5)
    }));
    var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$11, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_CallbackTo$().delayMs$extension__Ljapgolly_scalajs_react_callback_Trampoline__D__F1(this$$1, 1.0))
  }))))))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.handleEvent__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev, getFiles) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev.defaultPrevented)))), new $c_sjsr_AnonFunction1(((x$12$2) => {
    $as_jl_Void(x$12$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var c = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_analyze_cost_components_DropArea$TypedProps(p$2);
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var domList = $n(getFiles).apply__O__O(ev);
      var this$4 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList);
      $m_sci_List$();
      var this$ = this.handleFiles__Lreactbuild_analyze_cost_components_DropArea$TypedProps__sci_List__Ljapgolly_scalajs_react_callback_Trampoline(p, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($$x1).toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_CallbackTo$().delayMs$extension__Ljapgolly_scalajs_react_callback_Trampoline__D__F1(this$, 1.0)), new $c_sjsr_AnonFunction1(((result$2) => {
        $as_jl_Void(result$2);
        $m_Ljapgolly_scalajs_react_package$();
        var this$8 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev, this$8.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f = new $c_sjsr_AnonFunction1(((x$11$2) => {
          $as_jl_Void(x$11$2)
        }));
        var this$10 = $n(this$$1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$10, f))
      }))))
    })));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  })));
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$13 = $m_s_$less$colon$less$();
  return $n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$13.s_$less$colon$less$__f_singleton)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.handleDragLeave__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev.defaultPrevented)))), new $c_sjsr_AnonFunction1(((x$17$2) => {
    $as_jl_Void(x$17$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var c$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(s$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).require__F0__F0(new $c_sjsr_AnonFunction0((() => $n(s).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver))), new $c_sjsr_AnonFunction1(((x$16$2) => {
        $as_jl_Void(x$16$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var this$5 = $n(this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$);
        var mod = new $c_sjsr_AnonFunction1(((x$13$2) => {
          var x$13 = $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(x$13$2);
          $n(x$13);
          var this$3 = $n(x$13);
          var result = this$3.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result;
          return new $c_Lreactbuild_analyze_cost_components_DropArea$TypedState(false, result)
        }));
        var c = $n($$x1).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$5, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$15$2) => {
          $as_jl_Void(x$15$2);
          $m_Ljapgolly_scalajs_react_package$();
          var this$7 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev, this$7.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var f = new $c_sjsr_AnonFunction1(((x$14$2) => {
            $as_jl_Void(x$14$2)
          }));
          var this$9 = $n(this$);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$9, f))
        })));
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
      })));
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$12 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$12.s_$less$colon$less$__f_singleton))
    })));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1))
  })));
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$15 = $m_s_$less$colon$less$();
  return $n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$1, this$15.s_$less$colon$less$__f_singleton)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.handleDrop__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  return this.handleEvent__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline(ev, new $c_sjsr_AnonFunction1(((x$18$2) => x$18$2.dataTransfer.files)))
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.handleInputFile__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  return this.handleEvent__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline(ev, new $c_sjsr_AnonFunction1(((x$19$2) => x$19$2.target.files)))
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend.prototype.render__Lreactbuild_analyze_cost_components_DropArea$TypedProps__Lreactbuild_analyze_cost_components_DropArea$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x17 = $n(p).Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_render;
  var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$());
  var $$x15 = $n(this$3.withType__T__Ljapgolly_scalajs_react_vdom_TagOf("file"));
  var $$x14 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("files", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$6 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "multiple");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
  var array = [$$x14, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$6.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, true), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleInputFile__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var $$x13 = $n($$x15).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDragEnter");
  var $$x11 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$3$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleDragStart__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$3$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$2 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDragOver");
  var $$x10 = stabilizer$2.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$4$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleDragOver__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$4$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$3 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDragLeave");
  var $$x9 = stabilizer$3.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$5$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleDragLeave__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$5$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$4 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDrop");
  var array$1 = [$$x11, $$x10, $$x9, stabilizer$4.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$6$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleDrop__Ljapgolly_scalajs_react_facade_SyntheticDragEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$6$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("area", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "border")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2px dashed hsla(0,0%,0%,0.5)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "padding")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hsla(0,0%,0%,0.5)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9posez vos fichiers ici"))];
  var $$x8 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var pot = $n(s).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result;
  if ($n(pot).isPending__Z()) {
    var qual$1 = $as_Ldiode_data_PendingBase(pot);
    $n(qual$1);
    var this$34 = $ct_ju_Date__(new $c_ju_Date());
    var t$1 = this$34.ju_Date__f_java$util$Date$$millis;
    var lo = t$1.RTLong__f_lo;
    var hi = t$1.RTLong__f_hi;
    var this$35 = $n(qual$1);
    var duration = $f_Ldiode_data_PendingBase__duration__J__I(this$35, new $c_RTLong(lo, hi));
    if ((duration > 500)) {
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chargement en cours"))];
      var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    } else {
      var $$x6 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
    }
  } else {
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var this$44 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var this$43 = $n($n(s).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result);
  var cond = (!this$43.isEmpty__Z());
  var $$x5 = (cond ? $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_preview).apply__O__O($n($n(s).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result).toTry__s_util_Try())) : this$44.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty);
  var pot$1 = $n(s).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result;
  if ($n(pot$1).isReady__Z()) {
    var arg1 = $n(pot$1).get__O();
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Enregister")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => {
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_whenValid).apply__O__O(arg1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$54 = $n(this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2) => {
        var s$1 = $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(s$2);
        var x$1 = $m_Ldiode_data_Empty$();
        var this$52 = $n(s$1);
        var x$2 = this$52.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver;
        $n(s$1);
        return new $c_Lreactbuild_analyze_cost_components_DropArea$TypedState(x$2, x$1)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x2, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$54, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
    })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var $$x1 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  } else {
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var array$4 = [$$x13, $$x8, $$x6, $$x5, $$x1];
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($$x17).apply__O__O($n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))))
});
function $as_Lreactbuild_analyze_cost_components_DropArea$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_DropArea$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.DropArea$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_DropArea$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_DropArea$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_DropArea$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_DropArea$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.DropArea$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_ExpandableCard$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_ExpandableCard$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_ExpandableCard$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_ExpandableCard$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_ExpandableCard$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_ExpandableCard$Backend.prototype = $c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_ExpandableCard$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_ExpandableCard$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend.prototype.render__Lreactbuild_analyze_cost_components_ExpandableCard$Props__Z__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s, c) {
  var $$x1 = $m_Lcom_iz2use_react_components_Link$();
  var this$2 = $n(this.Lreactbuild_analyze_cost_components_ExpandableCard$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $uZ(x$1$2);
    return (!x$1)
  }));
  var invert = $n($$x1).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  var $$x2 = $n(invert);
  var array = [$n(p).Lreactbuild_analyze_cost_components_ExpandableCard$Props__f_title];
  var x$1$3 = $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x3 = $n(invert);
  var array$1 = [$m_Lcom_iz2use_react_components_Icon$().conditional__Z__Lcom_iz2use_react_components_IconSource__Lcom_iz2use_react_components_IconSource__T__T__T__Ljapgolly_scalajs_react_vdom_TagOf(s, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_expandLess, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_expandMore, "", "", "24px")];
  var x$2 = $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var x$3 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
  var x$4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
  var $$x5 = $m_sci_Seq$();
  if (s) {
    var this$17 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    var $$x4 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$17, null, ns)
  } else {
    var this$18 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var ns$1 = $m_sci_Nil$();
    var $$x4 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$18, null, ns$1)
  };
  var array$3 = [$$x4];
  var x$5 = $as_sci_Seq($n($$x5).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)));
  return $m_Lcom_iz2use_react_components_Card$().apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(x$1$3, x$3, x$2, x$4, x$5)
});
function $as_Lreactbuild_analyze_cost_components_ExpandableCard$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.ExpandableCard$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_ExpandableCard$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_ExpandableCard$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_ExpandableCard$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_ExpandableCard$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.ExpandableCard$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_ExpandableCard$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_ExpandableCard$Backend: 0
}, false, "reactbuild.analyze.cost.components.ExpandableCard$Backend", {
  Lreactbuild_analyze_cost_components_ExpandableCard$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_ExpandableCard$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_LateralBar$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_openedReuse = null;
  this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_analyze_cost_components_LateralBar$State(x$2$2);
    return $n(x$2).Lreactbuild_analyze_cost_components_LateralBar$State__f_opened
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $uZ(v$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lreactbuild_analyze_cost_components_LateralBar$State(x$3$2);
      $n(x$3);
      return new $c_Lreactbuild_analyze_cost_components_LateralBar$State(v)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$6 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$6.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_openedReuse = $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w);
  var this$8 = $n(\u03b4);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_components_LateralBar$State(s$2);
    $n(s);
    var opened = (!$n(s).Lreactbuild_analyze_cost_components_LateralBar$State__f_opened);
    return new $c_Lreactbuild_analyze_cost_components_LateralBar$State(opened)
  }));
  $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$8, mod)));
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value = $m_Lreactbuild_Loc$().Lreactbuild_Loc$__f_pages;
  $n($$x3).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var _2 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1);
    var cb = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)
  })));
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f$1 = new $c_sjsr_AnonFunction2(((x0$2$2, x1$2$2) => {
    var x0$2 = $as_s_Option(x0$2$2);
    var x1$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var _2$1 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2);
    matchEnd8: {
      var $$x4;
      var cb$1 = _2$1.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((x0$2 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x0$2);
        var p4 = $as_s_Option($n(x3).s_Some__f_value);
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v$1 = $as_T($n(x5).s_Some__f_value);
          var this$10 = $n($m_Lreactbuild_Loc$().Lreactbuild_Loc$__f_pages);
          _return: {
            var these = this$10;
            while ((!$n(these).isEmpty__Z())) {
              var arg1 = $n(these).head__O();
              var x$4 = $as_Lreactbuild_Loc(arg1);
              var x = $n($m_Lreactbuild_Loc$().keyMapper__Lcom_iz2use_common_KeyMapper()).apply__O__O(x$4);
              if (((x === null) ? (v$1 === null) : $dp_equals__O__Z($n(x), v$1))) {
                var this$11 = new $c_s_Some($n(these).head__O());
                break _return
              };
              these = $as_sci_List($n(these).tail__O())
            };
            var this$11 = $m_s_None$()
          };
          if (this$11.isEmpty__Z()) {
            var $$x5 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$1)
          } else {
            var arg1$1 = this$11.get__O();
            var loc = $as_Lreactbuild_Loc(arg1$1);
            var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
              var x$5 = $as_Lreactbuild_analyze_cost_components_LateralBar$Props(x$5$2);
              var this$12 = $n($n(x$5).Lreactbuild_analyze_cost_components_LateralBar$Props__f_c);
              return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$12.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(loc, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
            }));
            var $$x6 = $n($$x7).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f), cb$1);
            var this$15 = $n(this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_$);
            var mod$1 = new $c_sjsr_AnonFunction1(((x$6$2) => {
              var x$6 = $as_Lreactbuild_analyze_cost_components_LateralBar$State(x$6$2);
              $n(x$6);
              return new $c_Lreactbuild_analyze_cost_components_LateralBar$State(false)
            }));
            var $$x5 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x8).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x6, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$15, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
          };
          var $$x4 = $n($$x5).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          break matchEnd8
        }
      };
      var cb$2 = _2$1.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x4 = cb$2
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x4)
  }));
  $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$1)
}
$c_Lreactbuild_analyze_cost_components_LateralBar$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_LateralBar$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_LateralBar$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_LateralBar$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_LateralBar$Backend.prototype = $c_Lreactbuild_analyze_cost_components_LateralBar$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_LateralBar$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Backend.prototype.render__Lreactbuild_analyze_cost_components_LateralBar$Props__Lreactbuild_analyze_cost_components_LateralBar$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x1 = $n(this.Lreactbuild_analyze_cost_components_LateralBar$Backend__f_openedReuse);
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $n($$x1).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$1.by_$eq$eq__F2());
  var $$x14 = $m_Lreactbuild_analyze_cost_components_Toolbar$();
  var $$x13 = $m_Lreactbuild_analyze_cost_components_Tabs$();
  var this$2 = $n($n(p).Lreactbuild_analyze_cost_components_LateralBar$Props__f_m);
  var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
  if ($n($n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged).isEmpty__Z()) {
    var $$x12 = $m_Lreactbuild_analyze_cost_components_LateralBar$().Lreactbuild_analyze_cost_components_LateralBar$__f_notConnectedPages
  } else {
    var $$x12 = $m_Lreactbuild_Loc$().Lreactbuild_Loc$__f_pages
  };
  var $$x11 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($m_Lreactbuild_components_SearchBox$().show__Ljapgolly_scalajs_react_callback_Trampoline()));
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  var this$4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  var $$x9 = $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T(this$4);
  var array = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 .5rem", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("/images/reactbuild_16.png", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$1 = [$n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x9, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var $$x8 = $n($$x11).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var this$42 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$2 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x5 = $m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($n(p).Lreactbuild_analyze_cost_components_LateralBar$Props__f_m).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_actions_PleaseLogout$(), $m_Ldiode_Action$aType$()));
  var this$19 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_tab;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$19, s$1);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$20 = $n($n(p).Lreactbuild_analyze_cost_components_LateralBar$Props__f_m);
  var this$21 = $n(this$20.Ldiode_react_ModelProxy__f_modelReader);
  var o = $n($as_Lreactbuild_analyze_cost_services_Model(this$21.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged;
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var array$4 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((logged$2) => {
    var logged = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(logged$2);
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    var this$24 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    var $$x3 = $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T(this$24);
    var array$3 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n($n(logged).Lreactbuild_common_model_LoggedUserWithOrganizations__f_user).Lreactbuild_common_model_LoggedUser__f_avatar, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "borderRadius")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  }))), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ")), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Se d\u00e9connecter"))];
  var array$5 = [$$x6, $n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var this$46 = $n(this$42.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms));
  var this$43 = $n($n(p).Lreactbuild_analyze_cost_components_LateralBar$Props__f_m);
  var this$44 = $n(this$43.Ldiode_react_ModelProxy__f_modelReader);
  var this$45 = $n($n($as_Lreactbuild_analyze_cost_services_Model(this$44.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged);
  var condition = (!this$45.isEmpty__Z());
  return $n($$x14).apply__Ljapgolly_scalajs_react_vdom_VdomNode__Z__Ljapgolly_scalajs_react_vdom_TagOf($n($$x13).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__F1__Ljapgolly_scalajs_react_vdom_TagOf($$x12, $$x8, $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$46, condition), new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_Loc(v$2);
    var this$47 = $n(v);
    var x = $objectGetClass(this$47);
    var this$48 = $n($n($n(p).Lreactbuild_analyze_cost_components_LateralBar$Props__f_r).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page);
    var x$2 = $objectGetClass(this$48);
    return (x === x$2)
  })), new $c_sjsr_AnonFunction1(((page$2) => {
    var page = $as_Lreactbuild_Loc(page$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = $n(page).title__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Lreactbuild_analyze_cost_components_Tab(new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1), $n($n(p).Lreactbuild_analyze_cost_components_LateralBar$Props__f_c).link__O__Ljapgolly_scalajs_react_vdom_TagOf(page))
  }))), true)
});
function $as_Lreactbuild_analyze_cost_components_LateralBar$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_LateralBar$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.LateralBar$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_LateralBar$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_LateralBar$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_LateralBar$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_LateralBar$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.LateralBar$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_LateralBar$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_LateralBar$Backend: 0
}, false, "reactbuild.analyze.cost.components.LateralBar$Backend", {
  Lreactbuild_analyze_cost_components_LateralBar$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_LateralBar$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_MaybeRelated$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype = $c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_MaybeRelated$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype.render__Lreactbuild_analyze_cost_components_MaybeRelated$Props__Lreactbuild_analyze_cost_components_MaybeRelated$State__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var $$x38 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_maybeRelated;
  var $$x37 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x35 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x32 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var $$x31 = $n($m_s_package$().s_package$__f_Seq);
  var array = ["Date", "N\u00b0 facture", "N\u00b0 \u00e9criture", "Page n\u00b0", "Nombre total de pages", "Montant d\u00e9tails", "Montant"];
  var as = $n($$x31).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var array$2 = [$n($$x32).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T(x$1$2);
    var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(x$1))];
    return $n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  })))];
  var array$3 = [$n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var $$x30 = $n($$x35).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$30 = $n($n(s).Lreactbuild_analyze_cost_components_MaybeRelated$State__f_invoicePages);
  var x1 = ((!this$30.isEmpty__Z()) ? new $c_s_Some(this$30.get__O()) : $m_s_None$());
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var list = $as_sci_List($n(x2).s_Some__f_value);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), list), new $c_sjsr_AnonFunction1(((invoicePage$2) => {
      var invoicePage = $as_Lreactbuild_model_InvoicePage(invoicePage$2);
      var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$34 = $m_Lscalacss_ScalaCssReact$();
      var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_processingSameReferenceInvoicePage;
      var this$35 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$34, s$2));
      var x = $n(p).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_reference;
      var x$2 = $n(invoicePage).Lreactbuild_model_InvoicePage__f_reference;
      var condition = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
      var $$x24 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$35, condition);
      var this$36 = $m_Lscalacss_ScalaCssReact$();
      var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_processingActualInvoicePage;
      var this$37 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$36, s$3));
      var x$3 = $n(p).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_current;
      var x$4 = $n(invoicePage).Lreactbuild_model_InvoicePage__f__id;
      var condition$1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
      var $$x23 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$37, condition$1);
      var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v = $n(invoicePage).Lreactbuild_model_InvoicePage__f_date;
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var ev = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
      var v$1 = ev.stringify__s_Option__T(v);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      var $$x21 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
      var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Lcom_iz2use_common_Textualizable$();
      var v$2 = $n(invoicePage).Lreactbuild_model_InvoicePage__f_reference;
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
      var r = ev$1.stringify__s_Option__T(v$2);
      var x1$1 = $n(invoicePage).Lreactbuild_model_InvoicePage__f_reference;
      if ((x1$1 instanceof $c_s_Some)) {
        var x2$1 = $as_s_Some(x1$1);
        var _id = $as_T($n(x2$1).s_Some__f_value);
        var $$x19 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$());
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$54 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
        var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$5 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$54.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#"), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$2) => {
          var $$x18 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          $m_Ljapgolly_scalajs_react_package$();
          var this$56 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x18).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e$2, this$56.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_update).apply__O__O(new $c_sjsr_AnonFunction1(((s$2$1) => {
            var s$4 = $as_Lreactbuild_model_InvoicePage(s$2$1);
            var x$1$1 = new $c_s_Some(_id);
            var this$57 = $n(s$4);
            var x$2$1 = this$57.Lreactbuild_model_InvoicePage__f__id;
            var this$58 = $n(s$4);
            var x$3$1 = this$58.Lreactbuild_model_InvoicePage__f_organization;
            var this$59 = $n(s$4);
            var x$4$1 = this$59.Lreactbuild_model_InvoicePage__f_file;
            var this$60 = $n(s$4);
            var x$5 = this$60.Lreactbuild_model_InvoicePage__f_notDone;
            var this$61 = $n(s$4);
            var x$6 = this$61.Lreactbuild_model_InvoicePage__f_supplier;
            var this$62 = $n(s$4);
            var x$7 = this$62.Lreactbuild_model_InvoicePage__f_supplierOffice;
            var this$63 = $n(s$4);
            var x$8 = this$63.Lreactbuild_model_InvoicePage__f_date;
            var this$64 = $n(s$4);
            var x$9 = this$64.Lreactbuild_model_InvoicePage__f_pageIndex;
            var this$65 = $n(s$4);
            var x$10 = this$65.Lreactbuild_model_InvoicePage__f_pageCount;
            var this$66 = $n(s$4);
            var x$11 = this$66.Lreactbuild_model_InvoicePage__f_amount;
            var this$67 = $n(s$4);
            var x$12 = this$67.Lreactbuild_model_InvoicePage__f_totalAmount;
            var this$68 = $n(s$4);
            var x$13 = this$68.Lreactbuild_model_InvoicePage__f_details;
            var this$69 = $n(s$4);
            var x$14 = this$69.Lreactbuild_model_InvoicePage__f_entryNumber;
            var this$70 = $n(s$4);
            var x$15 = this$70.Lreactbuild_model_InvoicePage__f_category;
            var this$71 = $n(s$4);
            var x$16 = this$71.Lreactbuild_model_InvoicePage__f_deletedAt;
            $n(s$4);
            return new $c_Lreactbuild_model_InvoicePage(x$2$1, x$3$1, x$4$1, x$5, x$6, x$7, x$8, x$1$1, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16)
          }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
        })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(r))];
        var $$x17 = $n($$x19).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
      } else {
        var x$5$1 = $m_s_None$();
        if ((!(x$5$1 === x1$1))) {
          throw new $c_s_MatchError(x1$1)
        };
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x17 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(r)
      };
      var array$6 = [$$x17];
      var $$x16 = $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
      var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$3 = $n(invoicePage).Lreactbuild_model_InvoicePage__f_entryNumber;
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var ev$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
      var v$4 = ev$2.stringify__s_Option__T(v$3);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$7 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
      var $$x14 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
      var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x12 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$97 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rel");
      var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x11 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$97.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "noopener noreferrer");
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$100 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
      var a = $n($n($n(p).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_router).urlFor__O__Ljapgolly_scalajs_react_extra_router_AbsUrl(new $c_Lreactbuild_Loc$Processing(new $c_s_Some($n(invoicePage).Lreactbuild_model_InvoicePage__f__id)))).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value;
      var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x10 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$100.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$101 = $n($n(invoicePage).Lreactbuild_model_InvoicePage__f_pageIndex);
      if (this$101.isEmpty__Z()) {
        var $$x9 = "?"
      } else {
        var arg1 = this$101.get__O();
        var x$2$2 = $uI(arg1);
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var $$x9 = $n(parsable$2).stringify__O__T(x$2$2)
      };
      var v$5 = $as_T($$x9);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$8 = [$$x11, $$x10, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
      var array$9 = [$n($$x12).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
      var $$x8 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$6 = $n(invoicePage).Lreactbuild_model_InvoicePage__f_pageCount;
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var ev$3 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$3);
      var v$7 = ev$3.stringify__s_Option__T(v$6);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$10 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)];
      var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$124 = $n($n(invoicePage).Lreactbuild_model_InvoicePage__f_details);
      var acc = 0.0;
      var these = this$124;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$1 = acc;
        var arg2 = $n(these).head__O();
        var acc$1 = $uD(arg1$1);
        var c = $as_Lreactbuild_model_InvoiceDetail(arg2);
        var this$125 = $n($n(c).Lreactbuild_model_InvoiceDetail__f_amount);
        if (this$125.isEmpty__Z()) {
          var $$x4 = $m_s_None$()
        } else {
          var arg1$2 = this$125.get__O();
          var x$3$2 = $as_Lreactbuild_model_Price(arg1$2);
          var $$x4 = new $c_s_Some($n(x$3$2).Lreactbuild_model_Price__f_amount)
        };
        var this$126 = $n($$x4);
        acc = (acc$1 + $uD((this$126.isEmpty__Z() ? 0.0 : this$126.get__O())));
        these = $as_sc_LinearSeq($n(these).tail__O())
      };
      var v$8 = new $c_Lreactbuild_model_Price($uD(acc));
      var ev$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var v$9 = $n(ev$4).stringify__O__T(v$8);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$11 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$9)];
      var $$x3 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
      var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$10 = $n(invoicePage).Lreactbuild_model_InvoicePage__f_amount;
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var ev$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1);
      var v$11 = ev$5.stringify__s_Option__T(v$10);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$12 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$11)];
      var array$13 = [$$x24, $$x23, $$x21, $$x16, $$x14, $$x8, $$x6, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
      return $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))
    })))
  } else {
    var x$17 = $m_s_None$();
    if ((!(x$17 === x1))) {
      throw new $c_s_MatchError(x1)
    };
    var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$151 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
    var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x26 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$151.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 5);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$12 = $n($n(s).Lreactbuild_analyze_cost_components_MaybeRelated$State__f_invoicePages).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$14 = [$$x26, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$12)];
    var array$15 = [$n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
    var $$x1 = $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))
  };
  var array$16 = [$$x1];
  var array$17 = [$$x30, $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
  var array$18 = [$$x37, $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))];
  return $n($$x38).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype.onPropsChange__Lreactbuild_analyze_cost_components_MaybeRelated$Props__Lreactbuild_analyze_cost_components_MaybeRelated$Props__Ljapgolly_scalajs_react_callback_Trampoline = (function(prevProps, nextProps) {
  var x = $n(prevProps).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_supplier;
  var x$2 = $n(nextProps).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_supplier;
  if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
    var $$x2 = true
  } else {
    var x$3 = $n(prevProps).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_reference;
    var x$4 = $n(nextProps).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_reference;
    var $$x2 = (!((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4)))
  };
  if ($$x2) {
    var $$x1 = true
  } else {
    var x$5 = $n(prevProps).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_date;
    var x$6 = $n(nextProps).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_date;
    var $$x1 = (!((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6)))
  };
  if ($$x1) {
    var x1 = $n(nextProps).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_supplier;
    var x$7 = $m_s_None$();
    if ((x$7 === x1)) {
      var this$3 = $n(this.Lreactbuild_analyze_cost_components_MaybeRelated$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$4$2$2) => {
        var x$4$2 = $as_Lreactbuild_analyze_cost_components_MaybeRelated$State(x$4$2$2);
        $n(x$4$2);
        var invoicePages = $m_Ldiode_data_Empty$();
        return new $c_Lreactbuild_analyze_cost_components_MaybeRelated$State(invoicePages)
      }));
      return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else if ((x1 instanceof $c_s_Some)) {
      var x3 = $as_s_Some(x1);
      var supplier = $as_Lreactbuild_common_model_RefTo($n(x3).s_Some__f_value);
      return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_MaybeRelated$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lreactbuild_analyze_cost_components_MaybeRelated$State(s$2);
        $n(s);
        var this$6 = $ct_ju_Date__(new $c_ju_Date());
        var t = this$6.ju_Date__f_java$util$Date$$millis;
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var invoicePages$1 = new $c_Ldiode_data_Pending(new $c_RTLong(lo, hi));
        return new $c_Lreactbuild_analyze_cost_components_MaybeRelated$State(invoicePages$1)
      })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
        var this$9 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x7 = new $c_Lautowire_ClientProxy(this$9).Lautowire_ClientProxy__f_self;
        var $$x6 = $m_s_package$().s_package$__f_Seq;
        var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listInvoicePages"];
        var $$x5 = $as_sci_Seq($n($$x6).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
        var this$30 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$15 = $n(new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self);
        var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
        var y = this$15.write__O__Lio_circe_Encoder__Lio_circe_Json(supplier, evidence$2);
        var $$x4 = $ct_T2__O__O__(new $c_T2(), "supplier", y);
        var this$18 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$20 = $n(new $c_Lautowire_ClientProxy(this$18).Lautowire_ClientProxy__f_self);
        var r = $n(nextProps).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_date;
        $m_Lio_circe_Encoder$();
        var e = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
        var evidence$2$1 = new $c_Lio_circe_Encoder$$anon$21(e);
        var y$1 = this$20.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2$1);
        var $$x3 = $ct_T2__O__O__(new $c_T2(), "date", y$1);
        var this$23 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$25 = $n(new $c_Lautowire_ClientProxy(this$23).Lautowire_ClientProxy__f_self);
        var r$1 = $n(nextProps).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_reference;
        $m_Lio_circe_Encoder$();
        var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
        var evidence$2$2 = new $c_Lio_circe_Encoder$$anon$21(e$1);
        var y$2 = this$25.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$2);
        var array$1 = [$$x4, $$x3, $ct_T2__O__O__(new $c_T2(), "reference", y$2)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        return $n($n($n($$x7).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x5, this$30.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1 = $as_Lio_circe_Json(x$1$2);
          var this$31 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$33 = $n(new $c_Lautowire_ClientProxy(this$31).Lautowire_ClientProxy__f_self);
          $m_Lio_circe_Decoder$();
          var decodeA = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
          var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
          return $as_sci_List(this$33.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((result$2) => {
          var result = $as_sci_List(result$2);
          var this$36 = $n(this.Lreactbuild_analyze_cost_components_MaybeRelated$Backend__f_$);
          var mod$1 = new $c_sjsr_AnonFunction1(((s$2$1) => {
            var s$1 = $as_Lreactbuild_analyze_cost_components_MaybeRelated$State(s$2$1);
            $n(s$1);
            $n($n(s$1).Lreactbuild_analyze_cost_components_MaybeRelated$State__f_invoicePages);
            var invoicePages$2 = new $c_Ldiode_data_Ready(result);
            return new $c_Lreactbuild_analyze_cost_components_MaybeRelated$State(invoicePages$2)
          }));
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$36, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else {
      throw new $c_s_MatchError(x1)
    }
  } else {
    return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
function $as_Lreactbuild_analyze_cost_components_MaybeRelated$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.MaybeRelated$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_MaybeRelated$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_MaybeRelated$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_MaybeRelated$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_MaybeRelated$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.MaybeRelated$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_MaybeRelated$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_MaybeRelated$Backend: 0
}, false, "reactbuild.analyze.cost.components.MaybeRelated$Backend", {
  Lreactbuild_analyze_cost_components_MaybeRelated$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_MaybeRelated$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFPage$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_containerRef = null;
  this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_eventHandlers = null;
  this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_containerRef = $m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF();
  var this$11 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseDown");
  var $$x2 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.handleMouseStart__F1(), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$2 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseMove");
  var $$x1 = stabilizer$2.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.handleMouseMove__F1(), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$3 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseUp");
  var array = [$$x2, $$x1, stabilizer$3.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleEnd__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_eventHandlers = this$11.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
}
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFPage$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFPage$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype = $c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.setSelected__s_Option__Ljapgolly_scalajs_react_callback_Trampoline = (function(opt) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_PDFPage$Props(p$2);
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var s = $as_Lreactbuild_analyze_cost_components_PDFText$State(arg1);
    var this$6 = $n(s);
    var x$2 = this$6.Lreactbuild_analyze_cost_components_PDFText$State__f_areas;
    var this$7 = $n(s);
    var x$3 = this$7.Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
    $n(s);
    var arg1$1 = new $c_Lreactbuild_analyze_cost_components_PDFText$State(x$2, opt, x$3);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.renderColumns__Lreactbuild_person_DocumentParserArea__sci_List__D__sci_List__Ljapgolly_scalajs_react_vdom_TagMod = (function(area, rest, acc, dones) {
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as = dones;
      var this$3 = $m_s_$less$colon$less$();
      return $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$3.s_$less$colon$less$__f_singleton)
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var c = $as_Lreactbuild_person_DocumentParserColumn($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      var $$x3 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.setSelected__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn($n(area).Lreactbuild_person_DocumentParserArea__f_id, $n(c).Lreactbuild_person_DocumentParserColumn__f_id)))));
      var this$4 = $n($n(c).Lreactbuild_person_DocumentParserColumn__f_name);
      if ((this$4 === "")) {
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Change")
      } else {
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = $n(c).Lreactbuild_person_DocumentParserColumn__f_name;
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
      };
      var array = [$$x2];
      var link = $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$14 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
      var array$1 = [this$14.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("absolute", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + $n(c).Lreactbuild_person_DocumentParserColumn__f_id), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((acc + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(c).Lreactbuild_person_DocumentParserColumn__f_width + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("top")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "borderRight")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1px solid black", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), link];
      var v$1 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var temp$acc = (acc + $n(c).Lreactbuild_person_DocumentParserColumn__f_width);
      var this$24 = $n(dones);
      var temp$dones = new $c_sci_$colon$colon(v$1, this$24);
      rest = tail;
      acc = temp$acc;
      dones = temp$dones
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.renderArea__Lreactbuild_person_DocumentParserArea__Ljapgolly_scalajs_react_vdom_TagMod = (function(area) {
  var this$20 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var this$1 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
  var $$x10 = this$1.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("absolute", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x9 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(area).Lreactbuild_person_DocumentParserArea__f_left + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x8 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("top")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(area).Lreactbuild_person_DocumentParserArea__f_top + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x7 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(area).Lreactbuild_person_DocumentParserArea__f_width + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x6 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(area).Lreactbuild_person_DocumentParserArea__f_height + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x5 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hsla(60, 100%, 50%, 0.5)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + $n(area).Lreactbuild_person_DocumentParserArea__f_id), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var this$8 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var cond = $n($n(area).Lreactbuild_person_DocumentParserArea__f_columns).isEmpty__Z();
  if (cond) {
    var $$x3 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.setSelected__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea($n(area).Lreactbuild_person_DocumentParserArea__f_id)))));
    var this$9 = $n($n(area).Lreactbuild_person_DocumentParserArea__f_name);
    if ((this$9 === "")) {
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Change")
    } else {
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(area).Lreactbuild_person_DocumentParserArea__f_name;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
    };
    var array = [$$x2];
    var $$x1 = $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var $$x1 = this$8.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  };
  var array$1 = [$$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x1];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  return this$20.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.withPoint__F2__F1 = (function(f) {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    var this$2 = $n(this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_containerRef);
    var f$1 = new $c_sjsr_AnonFunction1(((container$2) => {
      var rect = container$2.getBoundingClientRect();
      var pt = new $c_Lreactbuild_analyze_cost_components_PDFText$Point(($uD(ev$2.clientX) - $uD(rect.left)), ($uD(ev$2.clientY) - $uD(rect.top)));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O__O__O(ev$2, pt))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_Ref$GetF__foreachCB__F1__O(this$2, f$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }))
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.handleStart__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Lreactbuild_analyze_cost_components_PDFText$Point__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev, pt) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_PDFPage$Props(p$2);
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var s = $as_Lreactbuild_analyze_cost_components_PDFText$State(arg1);
    var x1 = $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
    var x = $m_Lreactbuild_analyze_cost_components_PDFText$Idle$();
    if ((x === x1)) {
      var item = new $c_Lreactbuild_person_DocumentParserArea($n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_x, $n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_y, 0.0, 0.0, ($m_Lreactbuild_person_DocumentParserArea$(), $m_ju_UUID$().randomUUID__ju_UUID()), ($m_Lreactbuild_person_DocumentParserArea$(), ""), ($m_Lreactbuild_person_DocumentParserArea$(), $m_s_package$().s_package$__f_Nil));
      var this$8 = $n($n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas);
      var x$1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$8, item));
      var x$2$2 = new $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(item, $m_Lreactbuild_analyze_cost_components_Handle$SouthEast$(), pt);
      var this$9 = $n(s);
      var x$3 = this$9.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      $n(s);
      var $$x1 = new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_PDFText$State(x$1, x$3, x$2$2))
    } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Hover)) {
      var x3 = $as_Lreactbuild_analyze_cost_components_PDFText$Hover(x1);
      var a = $n(x3).Lreactbuild_analyze_cost_components_PDFText$Hover__f_value;
      var handle = $n(x3).Lreactbuild_analyze_cost_components_PDFText$Hover__f_handle;
      var x$4 = new $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(a, handle, pt);
      var this$11 = $n(s);
      var x$5 = this$11.Lreactbuild_analyze_cost_components_PDFText$State__f_areas;
      var this$12 = $n(s);
      var x$6 = this$12.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      $n(s);
      var $$x1 = new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_PDFText$State(x$5, x$6, x$4))
    } else {
      var $$x1 = $m_s_None$()
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($$x1, callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.handleMove__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Lreactbuild_analyze_cost_components_PDFText$Point__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev, pt) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$2 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_PDFPage$Props(p$2);
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var s = $as_Lreactbuild_analyze_cost_components_PDFText$State(arg1);
    var x1 = $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
    var x = $m_Lreactbuild_analyze_cost_components_PDFText$Idle$();
    if (((x === x1) || (x1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Hover))) {
      var this$9 = $n($n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas);
      var f = ((v$2) => {
        var v = $as_Lreactbuild_person_DocumentParserArea(v$2);
        var y = ($m_Lreactbuild_analyze_cost_components_PDFText$(), new $c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea(v)).classifyPoint__Lreactbuild_analyze_cost_components_PDFText$Point__D__s_Option(pt, 10.0);
        return $ct_T2__O__O__(new $c_T2(), v, y)
      });
      if ((this$9 === $m_sci_Nil$())) {
        var $$x2 = $m_sci_Nil$()
      } else {
        var arg1$1 = this$9.head__O();
        var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$9.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O())
        };
        var $$x2 = h
      };
      var results = $n($$x2).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1(this));
      var this$10 = $n(results);
      if ((!this$10.isEmpty__Z())) {
        var this$11 = $n(results);
        var f$1 = new $c_sjsr_AnonFunction1(((x$21$2) => {
          var x$21 = $as_T2(x$21$2);
          return $n($as_Lreactbuild_analyze_cost_components_Handle($n(x$21)._2__O())).order__I()
        }));
        var ord = $m_s_math_Ordering$Int$();
        var first = $as_T2($f_sc_IterableOnceOps__minBy__F1__s_math_Ordering__O(this$11, f$1, ord));
        var result = new $c_Lreactbuild_analyze_cost_components_PDFText$Hover($as_Lreactbuild_person_DocumentParserArea($n(first)._1__O()), $as_Lreactbuild_analyze_cost_components_Handle($n(first)._2__O()))
      } else {
        var result = $m_Lreactbuild_analyze_cost_components_PDFText$Idle$()
      };
      var this$12 = $n(s);
      var x$2$2 = this$12.Lreactbuild_analyze_cost_components_PDFText$State__f_areas;
      var this$13 = $n(s);
      var x$3 = this$13.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      $n(s);
      var editing = $as_Lreactbuild_analyze_cost_components_PDFText$ActionState(result);
      var $$x1 = new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_PDFText$State(x$2$2, x$3, editing))
    } else {
      var $$x1 = $m_s_None$()
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($$x1, callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$2)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.handleMouseStart__F1 = (function() {
  return this.withPoint__F2__F1(new $c_sjsr_AnonFunction2(((ev$2, pt$2) => {
    var pt = $as_Lreactbuild_analyze_cost_components_PDFText$Point(pt$2);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var cond = ($uI(ev$2.button) === 0);
    if (cond) {
      var $$x4 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
      $m_Ljapgolly_scalajs_react_package$();
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x2 = this.handleStart__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Lreactbuild_analyze_cost_components_PDFText$Point__Ljapgolly_scalajs_react_callback_Trampoline(ev$2, pt);
      $m_Ljapgolly_scalajs_react_package$();
      var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var self = $n($$x3).$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x2, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).stopPropagationCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
      var this$ = $n($$x4).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev$2);
      var this$$1 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  })))
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.handleMouseMove__F1 = (function() {
  return this.withPoint__F2__F1(new $c_sjsr_AnonFunction2(((ev$2, pt$2) => {
    var pt = $as_Lreactbuild_analyze_cost_components_PDFText$Point(pt$2);
    var $$x3 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
    $m_Ljapgolly_scalajs_react_package$();
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var x1 = $uI(ev$2.buttons);
    switch (x1) {
      case 0: {
        var $$x1 = this.handleMove__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Lreactbuild_analyze_cost_components_PDFText$Point__Ljapgolly_scalajs_react_callback_Trampoline(ev$2, pt);
        break
      }
      case 1: {
        var $$x1 = this.handleDragging__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Lreactbuild_analyze_cost_components_PDFText$Point__Ljapgolly_scalajs_react_callback_Trampoline(ev$2, pt);
        break
      }
      default: {
        var $$x1;
        throw new $c_s_MatchError(x1)
      }
    };
    $m_Ljapgolly_scalajs_react_package$();
    var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var self = $n($$x2).$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).stopPropagationCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var this$ = $n($$x3).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty))
  })))
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.handleDragging__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Lreactbuild_analyze_cost_components_PDFText$Point__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev, pt) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_PDFPage$Props(p$2);
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var s = $as_Lreactbuild_analyze_cost_components_PDFText$State(arg1);
    var x1 = $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
    if ((x1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle)) {
      var x2 = $as_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(x1);
      var area = $n(x2).Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_value;
      var oldHandle = $n(x2).Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_handle;
      var original = $n(x2).Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_initialPoint;
      var x1$2 = $as_Lreactbuild_analyze_cost_components_AreaWithHandle($n($n(oldHandle).moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1($n(pt).$minus__Lreactbuild_analyze_cost_components_PDFText$Point__Lreactbuild_analyze_cost_components_PDFText$Point(original))).apply__O__O(area));
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var item = $n(x1$2).Lreactbuild_analyze_cost_components_AreaWithHandle__f_area;
      var handle = $n(x1$2).Lreactbuild_analyze_cost_components_AreaWithHandle__f_handle;
      var this$6 = $n($n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas);
      _return: {
        var i = 0;
        var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$6, 0, this$6);
        while (true) {
          var this$9 = $n(these);
          if ((!this$9.isEmpty__Z())) {
            var arg1$1 = $n(these).head__O();
            var x$23 = $as_Lreactbuild_person_DocumentParserArea(arg1$1);
            var x = $n(x$23).Lreactbuild_person_DocumentParserArea__f_id;
            var x$2 = $n(area).Lreactbuild_person_DocumentParserArea__f_id;
            if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
              var x1$3 = i;
              break _return
            };
            i = ((1 + i) | 0);
            these = $as_sc_LinearSeq($n(these).tail__O())
          } else {
            break
          }
        };
        var x1$3 = (-1)
      };
      if ((x1$3 === (-1))) {
        var updatedAreas = $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas
      } else {
        var this$13 = $n($n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas);
        var $$x2 = $n($m_s_package$().s_package$__f_Seq);
        var array = [item];
        var other = $n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
        var updatedAreas = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$13, x1$3, other, 1))
      };
      var x$2$1 = new $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(item, handle, pt);
      var this$14 = $n(s);
      var x$3 = this$14.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      $n(s);
      var $$x1 = new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_PDFText$State(updatedAreas, x$3, x$2$1))
    } else {
      var $$x1 = $m_s_None$()
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($$x1, callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.handleEnd__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_components_PDFPage$Props(p$2);
    var $$x8 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
    $m_Ljapgolly_scalajs_react_package$();
    var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_state);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var s = $as_Lreactbuild_analyze_cost_components_PDFText$State(arg1);
    var x1 = $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
    var x = $m_Lreactbuild_analyze_cost_components_PDFText$Idle$();
    if ((x === x1)) {
      var $$x2 = $m_s_None$()
    } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle)) {
      var x3 = $as_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(x1);
      var oldItem = $n(x3).Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_value;
      if (((($n(oldItem).Lreactbuild_person_DocumentParserArea__f_width < 10.0) && ($n(oldItem).Lreactbuild_person_DocumentParserArea__f_height < 10.0)) || (($n(oldItem).Lreactbuild_person_DocumentParserArea__f_width < 1.0) || ($n(oldItem).Lreactbuild_person_DocumentParserArea__f_height < 1.0)))) {
        var this$6 = $n($n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas);
        _return: {
          var i = 0;
          var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$6, 0, this$6);
          while (true) {
            var this$9 = $n(these);
            if ((!this$9.isEmpty__Z())) {
              var arg1$1 = $n(these).head__O();
              var x$24 = $as_Lreactbuild_person_DocumentParserArea(arg1$1);
              var x$1 = $n(x$24).Lreactbuild_person_DocumentParserArea__f_id;
              var x$2 = $n(oldItem).Lreactbuild_person_DocumentParserArea__f_id;
              if (((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2))) {
                var x1$2 = i;
                break _return
              };
              i = ((1 + i) | 0);
              these = $as_sc_LinearSeq($n(these).tail__O())
            } else {
              break
            }
          };
          var x1$2 = (-1)
        };
        if ((x1$2 === (-1))) {
          var updatedAreas = $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas
        } else {
          var this$10 = $n($n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas);
          var other = $m_s_package$().s_package$__f_Nil;
          var updatedAreas = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$10, x1$2, other, 1))
        }
      } else {
        var $$x4 = $m_s_Option$();
        $m_Lreactbuild_analyze_cost_components_PDFText$();
        var qual$1 = new $c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea(oldItem);
        var x$2$2 = qual$1.findColumn$default$2__sci_List();
        var position = 0.0;
        var rest = x$2$2;
        var $$x3;
        while (true) {
          var x1$1 = rest;
          var x$3 = $m_s_package$().s_package$__f_Nil;
          if (((x$3 === null) ? (x1$1 === null) : $n(x$3).equals__O__Z(x1$1))) {
            var $$x3 = $m_s_None$();
            break
          } else {
            if ((!(x1$1 instanceof $c_sci_$colon$colon))) {
              throw new $c_s_MatchError(x1$1)
            };
            var x3$1 = $as_sci_$colon$colon(x1$1);
            var c = $as_Lreactbuild_person_DocumentParserColumn($n(x3$1).sci_$colon$colon__f_head);
            var tail = $n(x3$1).sci_$colon$colon__f_next;
            var acc = (position + $n(c).Lreactbuild_person_DocumentParserColumn__f_width);
            var x1$2$1 = ((acc > $n(oldItem).Lreactbuild_person_DocumentParserArea__f_width) ? new $c_s_Some($n(c).Lreactbuild_person_DocumentParserColumn__f_id) : $m_s_None$());
            var x$3$1 = $m_s_None$();
            if ((x$3$1 === x1$2$1)) {
              position = acc;
              rest = tail;
              continue
            };
            var $$x3 = x1$2$1;
            break
          }
        };
        var updatedAreas = $as_sci_List($n($n($$x4).option2Iterable__s_Option__sc_Iterable($$x3)).foldLeft__O__F2__O($n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas, new $c_sjsr_AnonFunction2(((acc$3$2, c$3$2) => {
          $as_sci_List(acc$3$2);
          var c$3 = $as_ju_UUID(c$3$2);
          var this$12 = $n($n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas);
          _return$1: {
            var i$1 = 0;
            var these$1 = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$12, 0, this$12);
            while (true) {
              var this$15 = $n(these$1);
              if ((!this$15.isEmpty__Z())) {
                var arg1$2 = $n(these$1).head__O();
                var x$25 = $as_Lreactbuild_person_DocumentParserArea(arg1$2);
                var x$4 = $n(x$25).Lreactbuild_person_DocumentParserArea__f_id;
                var x$2$1 = $n(oldItem).Lreactbuild_person_DocumentParserArea__f_id;
                if (((x$4 === null) ? (x$2$1 === null) : $n(x$4).equals__O__Z(x$2$1))) {
                  var x1$3 = i$1;
                  break _return$1
                };
                i$1 = ((1 + i$1) | 0);
                these$1 = $as_sc_LinearSeq($n(these$1).tail__O())
              } else {
                break
              }
            };
            var x1$3 = (-1)
          };
          if ((x1$3 === (-1))) {
            return $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas
          } else {
            var this$27 = $n($n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas);
            var $$x6 = $n($m_s_package$().s_package$__f_Seq);
            var this$16 = $n($n(oldItem).Lreactbuild_person_DocumentParserArea__f_columns);
            var b = new $c_scm_ListBuffer();
            var these$2 = this$16;
            while (true) {
              if ((!$n(these$2).isEmpty__Z())) {
                var arg1$3 = $n(these$2).head__O();
                var x$26 = $as_Lreactbuild_person_DocumentParserColumn(arg1$3);
                var x$5 = $n(x$26).Lreactbuild_person_DocumentParserColumn__f_id;
                var $$x5 = (!((x$5 === null) ? (c$3 === null) : $n(x$5).equals__O__Z(c$3)))
              } else {
                var $$x5 = false
              };
              if ($$x5) {
                var elem = $n(these$2).head__O();
                b.addOne__O__scm_ListBuffer(elem);
                these$2 = $as_sci_List($n(these$2).tail__O())
              } else {
                break
              }
            };
            var x$4$1 = b.toList__sci_List();
            var this$17 = $n(oldItem);
            var x$5$1 = this$17.Lreactbuild_person_DocumentParserArea__f_left;
            var this$18 = $n(oldItem);
            var x$6 = this$18.Lreactbuild_person_DocumentParserArea__f_top;
            var this$19 = $n(oldItem);
            var x$7 = this$19.Lreactbuild_person_DocumentParserArea__f_width;
            var this$20 = $n(oldItem);
            var x$8 = this$20.Lreactbuild_person_DocumentParserArea__f_height;
            var this$21 = $n(oldItem);
            var x$9 = this$21.Lreactbuild_person_DocumentParserArea__f_id;
            var this$22 = $n(oldItem);
            var x$10 = this$22.Lreactbuild_person_DocumentParserArea__f_name;
            $n(oldItem);
            var array = [new $c_Lreactbuild_person_DocumentParserArea(x$5$1, x$6, x$7, x$8, x$9, x$10, x$4$1)];
            var other$1 = $n($$x6).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
            return $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$27, x1$3, other$1, 1))
          }
        }))))
      };
      var x$12 = $m_Lreactbuild_analyze_cost_components_PDFText$Idle$();
      var this$28 = $n(s);
      var x$13 = this$28.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      $n(s);
      var $$x2 = new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_PDFText$State(updatedAreas, x$13, x$12))
    } else {
      var x$14 = $m_Lreactbuild_analyze_cost_components_PDFText$Idle$();
      var this$30 = $n(s);
      var x$15 = this$30.Lreactbuild_analyze_cost_components_PDFText$State__f_areas;
      var this$31 = $n(s);
      var x$16 = this$31.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      $n(s);
      var $$x2 = new $c_s_Some(new $c_Lreactbuild_analyze_cost_components_PDFText$State(x$15, x$16, x$14))
    };
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($$x2, callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    $m_Ljapgolly_scalajs_react_package$();
    var this$34 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var self = $n($$x7).$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev, this$34.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).stopPropagationCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var this$ = $n($$x8).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.renderEditing__Lreactbuild_analyze_cost_components_PDFText$State__Ljapgolly_scalajs_react_vdom_TagMod = (function(s) {
  var x1 = $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Hover)) {
    var x2 = $as_Lreactbuild_analyze_cost_components_PDFText$Hover(x1);
    var a = $n(x2).Lreactbuild_analyze_cost_components_PDFText$Hover__f_value;
    var handle = $n(x2).Lreactbuild_analyze_cost_components_PDFText$Hover__f_handle;
    var $$x1 = $n($m_Lreactbuild_analyze_cost_components_Handle$().apply__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_Handle__Ljapgolly_scalajs_react_vdom_TagOf(a, handle));
    var array = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hsla(0, 100%, 50%, .5)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle)) {
    var x3 = $as_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(x1);
    var a$2 = $n(x3).Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_value;
    var handle$2 = $n(x3).Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_handle;
    var $$x2 = $n($m_Lreactbuild_analyze_cost_components_Handle$().apply__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_Handle__Ljapgolly_scalajs_react_vdom_TagOf(a$2, handle$2));
    var array$1 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hsla(128, 100%, 50%, 1)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    return $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  } else {
    return $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  }
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.render__Lreactbuild_analyze_cost_components_PDFPage$Props__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p) {
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
  var $$x8 = this$3.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("relative", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x7 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_page).Lreactbuild_model_PdfPage__f_width + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x6 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_page).Lreactbuild_model_PdfPage__f_height + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x5 = this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_eventHandlers;
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n($as_Lreactbuild_analyze_cost_components_PDFText$State($n($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_PDFText$State__f_areas;
  var $$x2 = $n($$x3).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [this.renderArea__Lreactbuild_person_DocumentParserArea__Ljapgolly_scalajs_react_vdom_TagMod(area), this.renderColumns__Lreactbuild_person_DocumentParserArea__sci_List__D__sci_List__Ljapgolly_scalajs_react_vdom_TagMod(area, $n(area).Lreactbuild_person_DocumentParserArea__f_columns, 0.0, $m_s_package$().s_package$__f_Nil)];
    return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })));
  var u = $m_Lreactbuild_analyze_cost_components_PDFPageContent$().apply__Lreactbuild_model_PdfPage__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_page);
  var this$14 = $n(u);
  var n = this$14.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$1 = [$$x8, $$x7, $$x6, $$x5, $$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n), this.renderEditing__Lreactbuild_analyze_cost_components_PDFText$State__Ljapgolly_scalajs_react_vdom_TagMod($as_Lreactbuild_analyze_cost_components_PDFText$State($n($n(p).Lreactbuild_analyze_cost_components_PDFPage$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))];
  var $$x1 = $n($n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
  var r = this.Lreactbuild_analyze_cost_components_PDFPage$Backend__f_containerRef;
  return $n($$x1).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(r))
});
function $as_Lreactbuild_analyze_cost_components_PDFPage$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFPage$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFPage$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFPage$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFPage$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFPage$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFPage$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFPage$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFPage$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFPage$Backend: 0
}, false, "reactbuild.analyze.cost.components.PDFPage$Backend", {
  Lreactbuild_analyze_cost_components_PDFPage$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFPage$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_stateSnapshot = null;
  this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_reuseAreas = null;
  this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$();
  var this$1 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$1.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_stateSnapshot = $$x1.prepareVia__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_Reusable(\u03b4, w);
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$15$2) => {
    var x$15 = $as_Lreactbuild_analyze_cost_components_PDFText$State(x$15$2);
    return $n(x$15).Lreactbuild_analyze_cost_components_PDFText$State__f_areas
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_sci_List(v$2);
    return new $c_sjsr_AnonFunction1(((x$16$2) => {
      var x$16 = $as_Lreactbuild_analyze_cost_components_PDFText$State(x$16$2);
      $n(x$16);
      var this$3 = $n(x$16);
      var selectedArea = this$3.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      var this$4 = $n(x$16);
      var editing = this$4.Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
      return new $c_Lreactbuild_analyze_cost_components_PDFText$State(v, selectedArea, editing)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x2 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$8 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$1 = this$8.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_reuseAreas = $n($$x3).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x2, \u03b4, w$1)
}
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.process__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().zip$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var p = $as_Lreactbuild_analyze_cost_components_PDFText$Props($n(x0$1)._1__O());
      var s = $as_Lreactbuild_analyze_cost_components_PDFText$State($n(x0$1)._2__O());
      var $$x2 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var this$2 = $n($n($n(p).Lreactbuild_analyze_cost_components_PDFText$Props__f_content).Lreactbuild_model_PdfContent__f_pages);
      var rest = this$2;
      var h = null;
      var t = null;
      while ((rest !== $m_sci_Nil$())) {
        var arg1 = $n(rest).head__O();
        var x$17 = $as_Lreactbuild_model_PdfPage(arg1);
        var it = $n(this.processPage__Lreactbuild_model_PdfPage__sci_List__sci_List(x$17, $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_areas)).iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
          if ((t === null)) {
            h = nx
          } else {
            $n(t).sci_$colon$colon__f_next = nx
          };
          t = nx
        };
        rest = $as_sci_List($n(rest).tail__O())
      };
      var this$3 = $n(((h === null) ? $m_sci_Nil$() : h));
      var $$x1 = $n($$x2).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline($f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", "\n", ""), $m_sci_Nil$())
    } else {
      var $$x1;
      throw new $c_s_MatchError(x0$1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.save__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().zip$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var p = $as_Lreactbuild_analyze_cost_components_PDFText$Props($n(x0$1)._1__O());
      var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
        var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x5 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
        var $$x4 = $m_s_package$().s_package$__f_Seq;
        var array = ["reactbuild", "person", "PersonApi", "persistSupplierDocumentParserSettings"];
        var $$x3 = $as_sci_Seq($n($$x4).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
        var this$19 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
        var r = $n(p).Lreactbuild_analyze_cost_components_PDFText$Props__f_supplier;
        var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
        var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
        var $$x2 = $ct_T2__O__O__(new $c_T2(), "person", y);
        var this$11 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$14 = $n(new $c_Lautowire_ClientProxy(this$11).Lautowire_ClientProxy__f_self);
        var r$1 = new $c_s_Some(new $c_Lreactbuild_person_DocumentParserSettings(($m_Lreactbuild_person_DocumentParserSettings$(), $m_s_package$().s_package$__f_Nil)));
        $m_Lio_circe_Encoder$();
        var e = $m_Lreactbuild_person_DocumentParserSettings$().Lreactbuild_person_DocumentParserSettings$__f_codecForDocumentParserSettings;
        var evidence$2$1 = new $c_Lio_circe_Encoder$$anon$21(e);
        var y$1 = this$14.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
        var array$1 = [$$x2, $ct_T2__O__O__(new $c_T2(), "data", y$1)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        return $n($n($n($$x5).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x3, this$19.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1 = $as_Lio_circe_Json(x$1$2);
          var this$20 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$21 = $n(new $c_Lautowire_ClientProxy(this$20).Lautowire_ClientProxy__f_self);
          var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
          this$21.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$18$2) => {
          $as_jl_Void(x$18$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    } else {
      var $$x1;
      throw new $c_s_MatchError(x0$1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.processPage__Lreactbuild_model_PdfPage__sci_List__sci_List = (function(page, areas) {
  var this$3 = $n(areas);
  var f = ((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    return ($m_Lreactbuild_analyze_cost_components_PDFText$(), new $c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea(area)).processPage__Lreactbuild_model_PdfPage__Lreactbuild_analyze_cost_components_PDFText$Result(page)
  });
  if ((this$3 === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var arg1 = this$3.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$3.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    return h
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.render__Lreactbuild_analyze_cost_components_PDFText$Props__Lreactbuild_analyze_cost_components_PDFText$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var ss = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$().apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_stateSnapshot, s, $m_Ljapgolly_scalajs_react_Reusability$().never__F2());
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var o = $n(s).Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((selectable$2) => {
    var selectable = $as_Lreactbuild_analyze_cost_components_PDFText$Selectable(selectable$2);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $n(selectable).fields__sci_List();
    return $n($$x7).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((field$2) => {
      var field = $as_T(field$2);
      var $$x9 = $m_Lcom_iz2use_react_components_Link$();
      var this$8 = $n($n(this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_reuseAreas).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_analyze_cost_components_PDFText$().Lreactbuild_analyze_cost_components_PDFText$__f_reuseArea)));
      var callback = new $c_sjsr_AnonFunction0((() => {
        var this$9 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$10 = $n(this$9.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$10.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
      }));
      var this$11 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var G = this$11.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var arg1 = this$8.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var areas = $as_sci_List(arg1);
      var this$12 = $n(selectable);
      var arg1$1 = $f_Lreactbuild_analyze_cost_components_PDFText$Selectable__updateAreas__sci_List__T__sci_List(this$12, areas, field);
      var $$x8 = $n($n($$x9).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$8.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
      var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(field)), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 .2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
      return $n($$x8).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    })))
  })));
  var $$x5 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.process__Ljapgolly_scalajs_react_callback_Trampoline()));
  var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Essayer")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 .2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x4 = $n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x3 = $m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.save__Ljapgolly_scalajs_react_callback_Trampoline());
  var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Enregistrer")), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 .2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$3 = [$$x6, $$x4, $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var $$x2 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as$1 = $n($n(p).Lreactbuild_analyze_cost_components_PDFText$Props__f_content).Lreactbuild_model_PdfContent__f_pages;
  var array$4 = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((page$2) => {
    var page = $as_Lreactbuild_model_PdfPage(page$2);
    var u = $m_Lreactbuild_analyze_cost_components_PDFPage$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_model_PdfPage__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(ss, page);
    var this$36 = $n(u);
    var n = this$36.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })))];
  return $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.onUpdate__s_Option__Lreactbuild_analyze_cost_components_PDFText$Props__Ljapgolly_scalajs_react_callback_Trampoline = (function(prev, next) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var this$1 = $n(prev);
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var x$19 = $as_Lreactbuild_analyze_cost_components_PDFText$Props(arg1);
    var x = $n(x$19).Lreactbuild_analyze_cost_components_PDFText$Props__f_supplier;
    var x$2 = $n(next).Lreactbuild_analyze_cost_components_PDFText$Props__f_supplier;
    var cond = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    var cond = false
  };
  var cond$1 = (!cond);
  if (cond$1) {
    var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
      var this$4 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x3 = new $c_Lautowire_ClientProxy(this$4).Lautowire_ClientProxy__f_self;
      var $$x2 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "person", "PersonApi", "getSupplierDocumentParserSettings"];
      var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$15 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$9 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$10 = $n(new $c_Lautowire_ClientProxy(this$9).Lautowire_ClientProxy__f_self);
      var r = $n(next).Lreactbuild_analyze_cost_components_PDFText$Props__f_supplier;
      var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y = this$10.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
      var array$1 = [$ct_T2__O__O__(new $c_T2(), "person", y)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      return $n($n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$15.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$16 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$18 = $n(new $c_Lautowire_ClientProxy(this$16).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        var d = $m_Lreactbuild_person_DocumentParserSettings$().Lreactbuild_person_DocumentParserSettings$__f_codecForDocumentParserSettings;
        var evidence$1 = new $c_Lio_circe_Decoder$$anon$39(d);
        return $as_s_Option(this$18.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((settingsOpt$2) => {
        $as_s_Option(settingsOpt$2);
        var this$23 = $n(this.Lreactbuild_analyze_cost_components_PDFText$Backend__f_$);
        var mod = new $c_sjsr_AnonFunction1(((x$20$2) => {
          var x$20 = $as_Lreactbuild_analyze_cost_components_PDFText$State(x$20$2);
          $n(x$20);
          var this$19 = $n(x$20);
          var areas = this$19.Lreactbuild_analyze_cost_components_PDFText$State__f_areas;
          var this$20 = $n(x$20);
          var selectedArea = this$20.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
          var this$21 = $n(x$20);
          var editing = this$21.Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
          return new $c_Lreactbuild_analyze_cost_components_PDFText$State(areas, selectedArea, editing)
        }));
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$23, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$Backend: 0
}, false, "reactbuild.analyze.cost.components.PDFText$Backend", {
  Lreactbuild_analyze_cost_components_PDFText$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFViewer$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_PDFViewer$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_PDFViewer$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_PDFViewer$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_PDFViewer$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFViewer$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFViewer$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype = $c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_PDFViewer$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_PDFViewer$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype.prev__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$5 = $n(this.Lreactbuild_analyze_cost_components_PDFViewer$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_components_PDFViewer$State(s$2);
    $n(s);
    var this$2 = $n($n(s).Lreactbuild_analyze_cost_components_PDFViewer$State__f_page);
    if (this$2.isEmpty__Z()) {
      var $$x1 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$1 = $uI(arg1);
      var $$x1 = new $c_s_Some((((-1) + x$1) | 0))
    };
    var this$3 = $n($$x1);
    if (this$3.isEmpty__Z()) {
      var $$x2 = true
    } else {
      var arg1$1 = this$3.get__O();
      var x$2 = $uI(arg1$1);
      var $$x2 = (x$2 > 0)
    };
    if ($$x2) {
      var page = this$3
    } else {
      var page = $m_s_None$()
    };
    return new $c_Lreactbuild_analyze_cost_components_PDFViewer$State(page)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$5, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype.next__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$4 = $n(this.Lreactbuild_analyze_cost_components_PDFViewer$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_components_PDFViewer$State(s$2);
    $n(s);
    var this$2 = $n($n(s).Lreactbuild_analyze_cost_components_PDFViewer$State__f_page);
    var page = new $c_s_Some(((1 + $uI((this$2.isEmpty__Z() ? 0 : this$2.get__O()))) | 0));
    return new $c_Lreactbuild_analyze_cost_components_PDFViewer$State(page)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$4, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype.render__Lreactbuild_analyze_cost_components_PDFViewer$Props__Lreactbuild_analyze_cost_components_PDFViewer$State__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_pdfViewerContainer;
  var $$x25 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var pot = $n(p).Lreactbuild_analyze_cost_components_PDFViewer$Props__f_ref;
  if ($n(pot).isEmpty__Z()) {
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun document s\u00e9lectionn\u00e9 pour le moment"))];
    var $$x23 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var $$x23 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var pot$1 = $n(p).Lreactbuild_analyze_cost_components_PDFViewer$Props__f_ref;
  var this$15 = $n($n(pot$1).exceptionOption__s_Option());
  if (this$15.isEmpty__Z()) {
    var $$x21 = $m_s_None$()
  } else {
    var arg1 = this$15.get__O();
    var e = $as_jl_Throwable(arg1);
    var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + e), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
    var $$x21 = new $c_s_Some($n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
  };
  var this$23 = $n($$x21);
  var $$x20 = $as_Ljapgolly_scalajs_react_vdom_VdomNode((this$23.isEmpty__Z() ? $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom : this$23.get__O()));
  var pot$2 = $n(p).Lreactbuild_analyze_cost_components_PDFViewer$Props__f_ref;
  var this$26 = $n(pot$2);
  if ((!this$26.isEmpty__Z())) {
    var arg1$1 = $n(pot$2).get__O();
    var ref = $as_Lreactbuild_common_model_RefTo(arg1$1);
    var $$x19 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var u = $m_Lcom_iz2use_react_components_PlatformDependent$().apply__F1__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lcom_iz2use_react_components_Platform(x$3$2);
      return $n(x$3).isMobile__Z()
    })), new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $uZ(x0$1$2);
      if ((x0$1 === false)) {
        var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$2 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((("./cost-analyze/invoice-page/" + $n(ref).Lreactbuild_common_model_RefTo__f_id) + "#toolbar=0"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("application/pdf", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
        return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("iframe", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
      } else if ((x0$1 === true)) {
        var this$87 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
        var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$38 = $m_Lscalacss_ScalaCssReact$();
        var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_pdfViewerAsImageTools;
        var $$x17 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$38, s$2);
        var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$44 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "disabled");
        var this$43 = $n($n(s).Lreactbuild_analyze_cost_components_PDFViewer$State__f_page);
        if ((!this$43.isEmpty__Z())) {
          var arg1$2 = this$43.get__O();
          var x$4 = $uI(arg1$2);
          var $$x15 = (x$4 > 0)
        } else {
          var $$x15 = false
        };
        var a = (!$$x15);
        var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
        var array$3 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$44.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("<")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.prev__Ljapgolly_scalajs_react_callback_Trampoline()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
        var $$x14 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var this$50 = $n($n(s).Lreactbuild_analyze_cost_components_PDFViewer$State__f_page);
        if (this$50.isEmpty__Z()) {
          var this$51 = 1
        } else {
          var arg1$3 = this$50.get__O();
          var x$5 = $uI(arg1$3);
          var this$51 = ((1 + x$5) | 0)
        };
        var v = ("" + this$51);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x13 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
        var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(">")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.next__Ljapgolly_scalajs_react_callback_Trampoline()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
        var $$x11 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
        var $$x10 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$64 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
        var a$1 = ("./cost-analyze/invoice-page/" + $n(ref).Lreactbuild_common_model_RefTo__f_id);
        var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$5 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$64.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("T\u00e9l\u00e9charger le fichier PDF"))];
        var array$6 = [$$x17, $$x14, $$x13, $$x11, $n($$x10).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
        var $$x9 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
        var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$75 = $m_Lscalacss_ScalaCssReact$();
        var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_pdfViewerAsImageContainer;
        var $$x7 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$75, s$3);
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        var this$76 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        var $$x5 = $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T(this$76);
        var $$x4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src;
        var $$x3 = $n(ref).Lreactbuild_common_model_RefTo__f_id;
        var this$77 = $n($n(s).Lreactbuild_analyze_cost_components_PDFViewer$State__f_page);
        var array$7 = [$n($$x4).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(((("./cost-analyze/invoice-page-image/" + $$x3) + "/") + (this$77.isEmpty__Z() ? 0 : this$77.get__O())), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
        var array$8 = [$$x7, $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
        var array$9 = [$$x9, $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
        var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
        return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$87, null, ns)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })));
    var this$89 = $n(u);
    var n = this$89.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$10 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    var $$x1 = $n($$x19).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("view-pdf", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))
  } else {
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var array$11 = [$$x25, $$x23, $$x20, $$x1];
  return $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
});
function $as_Lreactbuild_analyze_cost_components_PDFViewer$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFViewer$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFViewer$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFViewer$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFViewer$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFViewer$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFViewer$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFViewer$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFViewer$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFViewer$Backend: 0
}, false, "reactbuild.analyze.cost.components.PDFViewer$Backend", {
  Lreactbuild_analyze_cost_components_PDFViewer$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFViewer$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_PeriodProvider$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_PeriodProvider$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PeriodProvider$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PeriodProvider$Backend.prototype = $c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_PeriodProvider$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_PeriodProvider$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend.prototype.render__Lreactbuild_analyze_cost_components_PeriodProvider$Props__jl_Void__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x2 = $n(p).Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_render;
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var this$1 = $n($n(p).Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_proxy);
  var this$2 = $n(this$1.Ldiode_react_ModelProxy__f_modelReader);
  var value = $n($as_Lreactbuild_analyze_cost_services_Model(this$2.value__O())).Lreactbuild_analyze_cost_services_Model__f_period;
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($$x2).apply__O__O($n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x3;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x3 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $as_Lreactbuild_analyze_cost_components_Period($n(x5).s_Some__f_value);
        var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($n(p).Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_proxy).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_analyze_cost_actions_SelectPeriod(v), $m_Ldiode_Action$aType$()), cb$2);
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x3)
  })))))
});
function $as_Lreactbuild_analyze_cost_components_PeriodProvider$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PeriodProvider$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PeriodProvider$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PeriodProvider$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PeriodProvider$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PeriodProvider$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PeriodProvider$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PeriodProvider$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PeriodProvider$Backend: 0
}, false, "reactbuild.analyze.cost.components.PeriodProvider$Backend", {
  Lreactbuild_analyze_cost_components_PeriodProvider$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PeriodProvider$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_PeriodSelector$Backend__f_dateRef = null;
  this.Lreactbuild_analyze_cost_components_PeriodSelector$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_PeriodSelector$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljava_time_LocalDate$();
    return this$2.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
  }));
  this.Lreactbuild_analyze_cost_components_PeriodSelector$Backend__f_dateRef = new $c_Lcom_iz2use_common_ParsingReference$Simple(f)
}
$c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PeriodSelector$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PeriodSelector$Backend.prototype = $c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_PeriodSelector$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_PeriodSelector$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend.prototype.render__Ljapgolly_scalajs_react_extra_StateSnapshotF__jl_Void__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var this$45 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x11 = this$3.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x10 = this$4.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x9 = this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x8 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "boxShadow")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1pt 1pt 3pt #0C0", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x7 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2pt", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x6 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "padding")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x5 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "borderRadius")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("4px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x4 = $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_link, "", "24px");
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9but de p\u00e9riode analys\u00e9e");
  var this$17 = $n(p);
  var g = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_s_Option(v$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lreactbuild_analyze_cost_components_Period(x$5$2);
      $n(x$5);
      var this$15 = $n(x$5);
      var to = this$15.Lreactbuild_analyze_cost_components_Period__f_to;
      return new $c_Lreactbuild_analyze_cost_components_Period(v, to)
    }))
  }));
  var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$17.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1 = this$17.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$4 = $as_Lreactbuild_analyze_cost_components_Period(arg1);
  var state = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$17, $n(x$4).Lreactbuild_analyze_cost_components_Period__f_from, new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
    var ot = $as_s_Option(ot$2);
    var $$x2 = $n($as_F2($n(this$17.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$18 = $n(ot);
    return $n($$x2).apply__O__O__O((this$18.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$18.get__O()))), cb$2)
  })));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  $m_Lcom_iz2use_common_Parsable$();
  var reference = this.Lreactbuild_analyze_cost_components_PeriodSelector$Backend__f_dateRef;
  var parser = new $c_Lcom_iz2use_common_Parsable$$anon$4(reference);
  var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$22 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$22);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var $$x3 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Fin de p\u00e9riode analys\u00e9e");
  var this$30 = $n(p);
  var g$2 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_s_Option(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7 = $as_Lreactbuild_analyze_cost_components_Period(x$7$2);
      var this$28 = $n(x$7);
      var x$2 = this$28.Lreactbuild_analyze_cost_components_Period__f_from;
      $n(x$7);
      return new $c_Lreactbuild_analyze_cost_components_Period(x$2, v$3)
    }))
  }));
  var g$3 = new $c_sjsr_AnonFunction1(((x$1$2$1) => $n($as_F1(g$2.apply__O__O(x$1$2$1))).apply__O__O(this$30.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1$1 = this$30.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$6 = $as_Lreactbuild_analyze_cost_components_Period(arg1$1);
  var state$1 = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$30, $n(x$6).Lreactbuild_analyze_cost_components_Period__f_to, new $c_sjsr_AnonFunction2(((ot$2$1, cb$2$1) => {
    var ot$1 = $as_s_Option(ot$2$1);
    var $$x1 = $n($as_F2($n(this$30.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$31 = $n(ot$1);
    return $n($$x1).apply__O__O__O((this$31.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$3.apply__O__O(this$31.get__O()))), cb$2$1)
  })));
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  $m_Lcom_iz2use_common_Parsable$();
  var reference$1 = this.Lreactbuild_analyze_cost_components_PeriodSelector$Backend__f_dateRef;
  var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$4(reference$1);
  var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$35 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$35);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var array = [$$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$1, explainError$1, equiv$1)];
  var array$1 = [$n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$45, null, ns)
});
function $as_Lreactbuild_analyze_cost_components_PeriodSelector$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PeriodSelector$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PeriodSelector$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PeriodSelector$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PeriodSelector$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PeriodSelector$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PeriodSelector$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PeriodSelector$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PeriodSelector$Backend: 0
}, false, "reactbuild.analyze.cost.components.PeriodSelector$Backend", {
  Lreactbuild_analyze_cost_components_PeriodSelector$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_PeriodSelector$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PeriodSelector$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Refine$TypedBackend() {
  this.Lreactbuild_analyze_cost_components_Refine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_components_Refine$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Refine$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Refine$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Refine$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Refine$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_components_Refine$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_components_Refine$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_Refine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_Refine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedBackend.prototype.onUpdate__Lreactbuild_analyze_cost_components_Refine$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(p) {
  var this$2 = $n(this.Lreactbuild_analyze_cost_components_Refine$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$1$2) => $n($n(p).Lreactbuild_analyze_cost_components_Refine$TypedProps__f_refiner).apply__O__O($n(p).Lreactbuild_analyze_cost_components_Refine$TypedProps__f_value)));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
function $as_Lreactbuild_analyze_cost_components_Refine$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Refine$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Refine$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Refine$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Refine$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Refine$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Refine$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Refine$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend() {
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend.prototype.render__Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x29 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$6 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX");
  var $$x28 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$9 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reportTable;
  var $$x26 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$9, s$1);
  var this$10 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
  var $$x25 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s$2);
  var this$11 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
  var $$x24 = this$11.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x15 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Etape");
  var $$x14 = $m_Lcom_iz2use_react_components_Link$();
  var this$25 = $n(this.Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2$2) => {
    var s$2$1 = $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState(s$2$2);
    var x$1 = (!$n(s$2$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_accumulate);
    var this$21 = $n(s$2$1);
    var x$2 = this$21.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList;
    var this$22 = $n(s$2$1);
    var x$3 = this$22.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekAccumulators;
    var this$23 = $n(s$2$1);
    var x$4 = this$23.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_items;
    $n(s$2$1);
    return new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState(x$2, x$3, x$4, x$1)
  }));
  var $$x13 = $n($$x14).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$25, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  var array = [($n(s).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_accumulate ? ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" [Cumuls]")) : ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" [Valeurs]")))];
  var array$1 = [$$x15, $n($$x13).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var $$x12 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n(s).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList;
  var array$5 = [$$x12, $n($$x11).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((date$2) => {
    var date = $as_Ljava_time_LocalDate(date$2);
    var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$40 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x20 = this$40.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x19 = $as_Ljapgolly_scalajs_react_vdom_TagOf($n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_seeMore).apply__O__O(date));
    var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$43 = $n(date);
    var formatter = $m_Lreactbuild_analyze_cost_modules_AccumulatingTable$().Lreactbuild_analyze_cost_modules_AccumulatingTable$__f_yearFormatter;
    var v = $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T(this$43, formatter);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x17 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("sub", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = ("." + $n(date).get__Ljava_time_temporal_TemporalField__I($n($m_Ljava_time_temporal_WeekFields$().ISO__Ljava_time_temporal_WeekFields()).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField()));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$3 = [$$x17, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    var array$4 = [$$x20, $n($$x19).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    return $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
  })))];
  var array$6 = [$n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  var $$x10 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as$1 = $n(s).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_items;
  var array$9 = [$n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((item$2) => {
    var item = $as_s_Option(item$2);
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$70 = $n(item);
    if (this$70.isEmpty__Z()) {
      var $$x6 = $m_s_None$()
    } else {
      var arg1 = this$70.get__O();
      var $$x6 = new $c_s_Some($n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_rTextualizable).stringify__O__T(arg1))
    };
    var this$71 = $n($$x6);
    var v$2 = $as_T((this$71.isEmpty__Z() ? "Ind\u00e9fini" : this$71.get__O()));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$7 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
    var array$8 = [$n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)), $as_Ljapgolly_scalajs_react_vdom_TagMod($n($as_F1($n($n(s).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_renderLine).apply__O__O(p))).apply__O__O(new $c_sjsr_AnonFunction1(((date$2$1) => {
      var date$1 = $as_Ljava_time_LocalDate(date$2$1);
      return $n($n(s).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekAccumulators).getOrElse__O__F0__O($ct_T2__O__O__(new $c_T2(), date$1, item), new $c_sjsr_AnonFunction0((() => $n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric).zero__O())))
    }))))];
    return $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  })))];
  var $$x4 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$90 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  var array$10 = [this$90.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("left", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Total"))];
  var array$11 = [$n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10)), $as_Ljapgolly_scalajs_react_vdom_TagMod($n($as_F1($n($n(s).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_renderLine).apply__O__O(p))).apply__O__O(new $c_sjsr_AnonFunction1(((date$3$2) => {
    var date$3 = $as_Ljava_time_LocalDate(date$3$2);
    var this$96 = $n($n(s).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekAccumulators);
    var z = $n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric).zero__O();
    var f = ((acc$2, c$2) => {
      var c = $as_T2(c$2);
      var x = $n($as_T2($n(c)._1__O()))._1__O();
      if (((x === null) ? (date$3 === null) : $dp_equals__O__Z($n(x), date$3))) {
        return $n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric).plus__O__O__O(acc$2, $n(c)._2__O())
      } else {
        return acc$2
      }
    });
    if ($is_sc_IndexedSeq(this$96)) {
      var x2 = $as_sc_IndexedSeq(this$96);
      var at = 0;
      var end = $n(x2).length__I();
      var acc = z;
      while (true) {
        if ((at === end)) {
          return acc
        } else {
          var temp$at = ((1 + at) | 0);
          var arg1$1 = acc;
          var arg2 = $n(x2).apply__I__O(at);
          var temp$acc = f(arg1$1, arg2);
          at = temp$at;
          acc = temp$acc
        }
      }
    } else {
      var result = z;
      var it = this$96.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var arg1$2 = result;
        var arg2$1 = $n(it).next__O();
        result = f(arg1$2, arg2$1)
      };
      return result
    }
  }))))];
  var array$12 = [$n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
  var array$13 = [$$x26, $$x25, $$x24, $$x10, $$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tfoot", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  var array$14 = [$$x29, $$x28, $n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
  return $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))
});
function $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.AccumulatingTable$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.AccumulatingTable$TypedBackend;", depth))
}
function $ct_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__($thiz) {
  $thiz.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $thiz.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__f_reuseQuery = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend() {
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__f_reuseQuery = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend.prototype.render__Lreactbuild_analyze_cost_modules_Crossed$TypedProps__Lreactbuild_analyze_cost_modules_Crossed$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var this$1 = $n($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_proxy);
  var this$2 = $n(this$1.Ldiode_react_ModelProxy__f_modelReader);
  var pot = $n($as_Lreactbuild_analyze_cost_services_Model(this$2.value__O())).Lreactbuild_analyze_cost_services_Model__f_commonData;
  var this$5 = $n(pot);
  if ((!this$5.isEmpty__Z())) {
    var arg1 = $n(pot).get__O();
    var m = $as_Lreactbuild_model_CommonData(arg1);
    var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x17 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$11 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowY");
    var $$x16 = this$11.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $as_sc_IterableOnce($n($m_Lreactbuild_analyze_cost_modules_Crossed$().Lreactbuild_analyze_cost_modules_Crossed$__f_crossTypes).zipWithIndex__O());
    var $$x12 = $n($$x13).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var ct = $as_Lreactbuild_analyze_cost_modules_CrossType($n(x0$1)._1__O());
        var idx = $n(x0$1)._2$mcI$sp__I();
        var $$x14 = $n($n($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$Crossed(new $c_s_Some(idx))));
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = ((((" " + $n($n(ct).Lreactbuild_analyze_cost_modules_CrossType__f_row).Lreactbuild_analyze_cost_modules_CrossSpec__f_name) + " x ") + $n($n(ct).Lreactbuild_analyze_cost_modules_CrossType__f_column).Lreactbuild_analyze_cost_modules_CrossSpec__f_name) + " ");
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
        return $n($$x14).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })));
    var $$x6 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$().withKey__T__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_vdom_VdomElement((("" + $n($n($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_row).Lreactbuild_analyze_cost_modules_CrossSpec__f_name) + $n($n($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_column).Lreactbuild_analyze_cost_modules_CrossSpec__f_name), $n($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_getCrossedAmounts, new $c_sjsr_AnonFunction1(((crossedAmounts$2) => {
      var crossedAmounts = $as_Ldiode_data_Pot(crossedAmounts$2);
      var c = $m_Lreactbuild_analyze_cost_modules_CrossedTable$().Lreactbuild_analyze_cost_modules_CrossedTable$__f_component;
      var this$34 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
      var $$x11 = $n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_proxy;
      var $$x10 = $n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType;
      var this$23 = $n($as_sci_List($n($n($n($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_row).Lreactbuild_analyze_cost_modules_CrossSpec__f_fromModel).apply__O__O(m)));
      var f = ((x$15$2) => new $c_s_Some(x$15$2));
      if ((this$23 === $m_sci_Nil$())) {
        var $$x9 = $m_sci_Nil$()
      } else {
        var arg1$1 = this$23.head__O();
        var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$23.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O())
        };
        var $$x9 = h
      };
      var this$24 = $n($$x9);
      var elem = $m_s_None$();
      var $$x8 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$24, elem));
      var this$25 = $n($as_sci_List($n($n($n($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_column).Lreactbuild_analyze_cost_modules_CrossSpec__f_fromModel).apply__O__O(m)));
      var f$1 = ((x$16$2) => new $c_s_Some(x$16$2));
      if ((this$25 === $m_sci_Nil$())) {
        var $$x7 = $m_sci_Nil$()
      } else {
        var arg1$3 = this$25.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(this$25.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$4 = $n(rest$1).head__O();
          var nx$1 = new $c_sci_$colon$colon(f$1(arg1$4), $m_sci_Nil$());
          $n(t$1).sci_$colon$colon__f_next = nx$1;
          t$1 = nx$1;
          rest$1 = $as_sci_List($n(rest$1).tail__O())
        };
        var $$x7 = h$1
      };
      var this$26 = $n($$x7);
      var elem$1 = $m_s_None$();
      var props = new $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps($$x11, $$x10, $$x8, $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$26, elem$1)), $n(crossedAmounts).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$17$2) => {
        var x$17 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$17$2);
        return $as_sci_Map($n(x$17).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
      }))), $n(s).Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart, new $c_sjsr_AnonFunction1(((selected$2) => {
        var selected = $as_T2(selected$2);
        var this$33 = $n(this.Lreactbuild_analyze_cost_modules_Crossed$Backend__f_$);
        var mod = new $c_sjsr_AnonFunction1(((s$2) => {
          var s$1 = $as_Lreactbuild_analyze_cost_modules_Crossed$TypedState(s$2);
          if ($n($n(s$1).Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart).contains__O__Z(selected)) {
            var this$27 = $n($n(s$1).Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart);
            var f$2 = ((x$18$2) => {
              var x$18 = $as_T2(x$18$2);
              return (!((selected === null) ? (x$18 === null) : $n(selected).equals__O__Z(x$18)))
            });
            var l = this$27;
            block: {
              var result;
              while (true) {
                if ($n(l).isEmpty__Z()) {
                  var result = $m_sci_Nil$();
                  break
                } else {
                  var h$2 = $n(l).head__O();
                  var t$2 = $as_sci_List($n(l).tail__O());
                  if (($uZ(f$2(h$2)) === false)) {
                    l = t$2;
                    continue
                  };
                  var start = l;
                  var remaining = t$2;
                  while (true) {
                    if ($n(remaining).isEmpty__Z()) {
                      var result = start;
                      break block
                    } else {
                      var x = $n(remaining).head__O();
                      if (($uZ(f$2(x)) !== false)) {
                        remaining = $as_sci_List($n(remaining).tail__O());
                        continue
                      };
                      var firstMiss = remaining;
                      var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                      var toProcess = $as_sci_List($n(start).tail__O());
                      var currentLast = newHead;
                      while ((toProcess !== firstMiss)) {
                        var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                        $n(currentLast).sci_$colon$colon__f_next = newElem;
                        currentLast = newElem;
                        toProcess = $as_sci_List($n(toProcess).tail__O())
                      };
                      var next = $as_sci_List($n(firstMiss).tail__O());
                      var nextToCopy = next;
                      while ((!$n(next).isEmpty__Z())) {
                        var head = $n(next).head__O();
                        if (($uZ(f$2(head)) !== false)) {
                          next = $as_sci_List($n(next).tail__O())
                        } else {
                          while ((nextToCopy !== next)) {
                            var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                            $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                            currentLast = newElem$2;
                            nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                          };
                          nextToCopy = $as_sci_List($n(next).tail__O());
                          next = $as_sci_List($n(next).tail__O())
                        }
                      };
                      if ((!$n(nextToCopy).isEmpty__Z())) {
                        $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                      };
                      var result = newHead;
                      break block
                    }
                  }
                }
              }
            };
            var this$28 = $n(s$1);
            var x$2 = this$28.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_crossedAmounts;
            $n(s$1);
            return new $c_Lreactbuild_analyze_cost_modules_Crossed$TypedState(x$2, result)
          } else {
            var this$30 = $n($n(s$1).Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart);
            var x$3 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$30, selected));
            var this$31 = $n(s$1);
            var x$4 = this$31.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_crossedAmounts;
            $n(s$1);
            return new $c_Lreactbuild_analyze_cost_modules_Crossed$TypedState(x$4, x$3)
          }
        }));
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$33, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      })));
      var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$34.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$34.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
      var this$36 = $n(u);
      var n = this$36.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    })), this.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__f_reuseQuery, $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$40 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
    var $$x3 = this$40.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$41 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$());
    var $$x2 = this$41.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("wrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$42 = $n($n(s).Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart);
    var as$1 = $as_sc_IterableOnce($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$42));
    var array$1 = [$$x3, $$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((x0$2$2) => {
      var x0$2 = $as_T2(x0$2$2);
      if ((x0$2 !== null)) {
        var selection = $as_T2($n(x0$2)._1__O());
        var idx$1 = $n(x0$2)._2$mcI$sp__I();
        var c$1 = $m_Lreactbuild_analyze_cost_modules_CrossedDetails$().Lreactbuild_analyze_cost_modules_CrossedDetails$__f_component;
        var $$x4 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c$1).ctor__Ljapgolly_scalajs_react_CtorType());
        var a = $n(selection).toString__T();
        var this$49 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x4).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
        var props$1 = new $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_proxy, $n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType, new $c_sjsr_AnonFunction2(((page$2, detail$2) => {
          var page = $as_Lreactbuild_model_InvoicePage(page$2);
          var detail = $as_Lreactbuild_model_InvoiceDetail(detail$2);
          return $ct_T2__O__O__(new $c_T2(), $n($n($n($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_row).Lreactbuild_analyze_cost_modules_CrossSpec__f_fromDetail).apply__O__O__O(page, detail), $n($n($n($n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_column).Lreactbuild_analyze_cost_modules_CrossSpec__f_fromDetail).apply__O__O__O(page, detail))
        })), selection, idx$1, $n(p).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_router);
        var u$1 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$49.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props$1, this$49.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
        var this$51 = $n(u$1);
        var n$1 = this$51.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
      } else {
        throw new $c_s_MatchError(x0$2)
      }
    })))];
    var array$2 = [$$x12, $$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    var array$3 = [$$x17, $$x16, $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
    return $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  } else {
    return $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  }
});
function $as_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Crossed$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Crossed$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend() {
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype.render__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  if ($n($n(s).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages).isEmpty__Z()) {
    var x1 = $n($n(s).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages).state__Ldiode_data_PotState();
    var x = $m_Ldiode_data_PotState$PotEmpty$();
    if ((x === x1)) {
      var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    } else {
      var x$3 = $m_Ldiode_data_PotState$PotUnavailable$();
      if ((x$3 === x1)) {
        var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Indisponible"))];
        return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      } else {
        var x$5 = $m_Ldiode_data_PotState$PotReady$();
        if ((x$5 === x1)) {
          var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Pr\u00eat"))];
          return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
        } else {
          var x$7 = $m_Ldiode_data_PotState$PotPending$();
          if ((x$7 === x1)) {
            var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chargement en cours"))];
            return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
          } else {
            var x$9 = $m_Ldiode_data_PotState$PotFailed$();
            if ((x$9 === x1)) {
              var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
              $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
              $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
              $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
              var v = ("Erreur " + $n(s).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages);
              $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
              var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
              return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
            } else {
              throw new $c_s_MatchError(x1)
            }
          }
        }
      }
    }
  } else {
    var $$x47 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$38 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $as_Lscalacss_internal_StyleA($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_crossDetails).apply__O__O($n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_index));
    var $$x46 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$38, s$1);
    var this$39 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
    var $$x45 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$39, s$2);
    var $$x44 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x43 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x42 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$48 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x41 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$48.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 5);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var $$x40 = $m_s_Option$();
    var this$49 = $n($as_s_Option($n($n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection)._1__O()));
    if (this$49.isEmpty__Z()) {
      var $$x39 = $m_s_None$()
    } else {
      var arg1 = this$49.get__O();
      var x$24 = $as_Lreactbuild_common_model_RefTo(arg1);
      var $$x39 = new $c_s_Some($n($as_Lcom_iz2use_common_Textualizable($n($n($n($n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_row).Lreactbuild_analyze_cost_modules_CrossSpec__f_textualizable).apply__O__O($n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_proxy))).stringify__O__T(x$24))
    };
    var this$51 = $n($n($$x40).option2Iterable__s_Option__sc_Iterable($$x39));
    var this$50 = $n($as_s_Option($n($n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection)._2__O()));
    if (this$50.isEmpty__Z()) {
      var suffix = $m_s_None$()
    } else {
      var arg1$1 = this$50.get__O();
      var x$25 = $as_Lreactbuild_common_model_RefTo(arg1$1);
      var suffix = new $c_s_Some($n($as_Lcom_iz2use_common_Textualizable($n($n($n($n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_column).Lreactbuild_analyze_cost_modules_CrossSpec__f_textualizable).apply__O__O($n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_proxy))).stringify__O__T(x$25))
    };
    var this$52 = $n($as_sc_IterableOnceOps(this$51.concat__sc_IterableOnce__O(suffix)));
    var v$1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$52, "", ", ", "");
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$5 = [$$x41, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    var $$x38 = $n($$x42).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
    var $$x37 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aper\u00e7u"))];
    var $$x35 = $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Facture"))];
    var $$x33 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
    var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$8 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date"))];
    var $$x31 = $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
    var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$9 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9signation"))];
    var $$x29 = $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
    var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$10 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Montant"))];
    var array$11 = [$$x35, $$x33, $$x31, $$x29, $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
    var array$12 = [$$x38, $n($$x37).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
    var $$x27 = $n($$x43).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
    var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x25 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$103 = $n($n(s).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages);
    var this$104 = $n($as_sci_List((this$103.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$103.get__O())));
    var rest = this$104;
    var h = null;
    var t$1 = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest).head__O();
      var page = $as_Lreactbuild_model_InvoicePage(arg1$2);
      var this$106 = $n($n(page).Lreactbuild_model_InvoicePage__f_details);
      var p$1 = new $c_sjsr_AnonFunction1(((p, page) => ((detail$2) => {
        var detail = $as_Lreactbuild_model_InvoiceDetail(detail$2);
        var x$1 = $n($n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_getRef).apply__O__O__O(page, detail);
        var x$2 = $n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection;
        return ((x$1 === null) ? (x$2 === null) : $dp_equals__O__Z($n(x$1), x$2))
      }))(p, page));
      var it = $n($as_sci_List($ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this$106, p$1).map__F1__O(new $c_sjsr_AnonFunction1(((page, p) => ((detail$3$2) => {
        var detail$3 = $as_Lreactbuild_model_InvoiceDetail(detail$3$2);
        var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x22 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$113 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
        var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$13 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$113.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#crossed"), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.showPDF__Lreactbuild_model_InvoicePage__F1(page), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("aper\u00e7u"))];
        var array$14 = [$n($$x22).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
        var $$x21 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
        var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x19 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$126 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
        var a = $n($n($n(p).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_router).urlFor__O__Ljapgolly_scalajs_react_extra_router_AbsUrl(new $c_Lreactbuild_Loc$Processing(new $c_s_Some($n(page).Lreactbuild_model_InvoicePage__f__id)))).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value;
        var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x18 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$126.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
        var this$127 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).target__Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$());
        var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x17 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$127.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "_blank");
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$130 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rel");
        var t$5 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var $$x16 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$5, this$130.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "noopener noreferrer");
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Lcom_iz2use_common_Textualizable$();
        var v$2 = $n(page).Lreactbuild_model_InvoicePage__f_reference;
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var ev = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
        var v$3 = ev.stringify__s_Option__T(v$2);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$15 = [$$x18, $$x17, $$x16, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
        var array$16 = [$n($$x19).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
        var $$x15 = $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
        var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$144 = $n($n(detail$3).Lreactbuild_model_InvoiceDetail__f_deliveryDate);
        var v$4 = (this$144.isEmpty__Z() ? $n(page).Lreactbuild_model_InvoicePage__f_date : this$144);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
        var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
        var v$5 = ev$1.stringify__s_Option__T(v$4);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$17 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
        var $$x13 = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17));
        var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Lcom_iz2use_common_Textualizable$();
        var v$6 = $n(detail$3).Lreactbuild_model_InvoiceDetail__f_description;
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var ev$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
        var v$7 = ev$2.stringify__s_Option__T(v$6);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$18 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)];
        var $$x11 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18));
        var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Lcom_iz2use_common_Textualizable$();
        var v$8 = $n(detail$3).Lreactbuild_model_InvoiceDetail__f_amount;
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var ev$3 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1);
        var v$9 = ev$3.stringify__s_Option__T(v$8);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$19 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$9)];
        var array$20 = [$$x21, $$x15, $$x13, $$x11, $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19))];
        return $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20))
      }))(page, p))))).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t$1 === null)) {
          h = nx
        } else {
          $n(t$1).sci_$colon$colon__f_next = nx
        };
        t$1 = nx
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    var as = ((h === null) ? $m_sci_Nil$() : h);
    var this$176 = $m_s_$less$colon$less$();
    var array$21 = [$n($$x25).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$176.s_$less$colon$less$__f_singleton)];
    var array$22 = [$$x27, $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21))];
    var $$x9 = $n($$x44).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22));
    var this$196 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$183 = $n($n(s).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_selectedInvoice);
    if (this$183.isEmpty__Z()) {
      var o = $m_s_None$()
    } else {
      var arg1$3 = this$183.get__O();
      var p$2 = $as_Lreactbuild_model_InvoicePage(arg1$3);
      var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x7 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("42vw", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x6 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("59.4vw", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var u = $m_Lreactbuild_analyze_cost_components_PDFViewer$().apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p$2).Lreactbuild_model_InvoicePage__f__id);
      var this$189 = $n(u);
      var n = this$189.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$23 = [$$x7, $$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
      var o = new $c_s_Some($n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23)))
    };
    var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
    var this$195 = $m_s_$less$colon$less$();
    var f = this$195.s_$less$colon$less$__f_singleton;
    var array$24 = [$$x46, $$x45, $$x9, $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$196, o, O, f)];
    return $n($$x47).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24))
  }
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype.showPDF__Lreactbuild_model_InvoicePage__F1 = (function(page) {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$5 = $n(this.Lreactbuild_analyze_cost_modules_CrossedDetails$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(s$2);
      var this$2 = new $c_s_Some(page);
      if (this$2.isEmpty__Z()) {
        var $$x2 = true
      } else {
        var arg1 = this$2.s_Some__f_value;
        var x$26 = $as_Lreactbuild_model_InvoicePage(arg1);
        var x = $n(s).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_selectedInvoice;
        var $$x2 = (!((x === null) ? (x$26 === null) : $n(x).equals__O__Z(x$26)))
      };
      if ($$x2) {
        var x$1 = this$2
      } else {
        var x$1 = $m_s_None$()
      };
      var this$3 = $n(s);
      var x$2 = this$3.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages;
      $n(s);
      return new $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(x$2, x$1)
    }));
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$5, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    $m_Ljapgolly_scalajs_react_package$();
    var this$7 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$7.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
  }))
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend.prototype.onPropsChange__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(prevProps, nextProps) {
  var x = $n(prevProps).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection;
  var x$2 = $n(nextProps).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection;
  if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
    return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_CrossedDetails$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(s$2);
      $n(s);
      var this$4 = $ct_ju_Date__(new $c_ju_Date());
      var t = this$4.ju_Date__f_java$util$Date$$millis;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var invoicePages = new $c_Ldiode_data_Pending(new $c_RTLong(lo, hi));
      var selectedInvoice = $m_s_None$();
      return new $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(invoicePages, selectedInvoice)
    })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => $n($as_s_concurrent_Future($n($n($n(nextProps).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_getInvoiceDetails).apply__O__O__O($n($n(nextProps).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection)._1__O(), $n($n(nextProps).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection)._2__O()))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((result$2) => {
      var result = $as_sci_List(result$2);
      var this$19 = $n(this.Lreactbuild_analyze_cost_modules_CrossedDetails$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2$1) => {
        var s$1 = $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(s$2$1);
        $n(s$1);
        $n($n(s$1).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages);
        var this$15 = $n(result);
        var f = new $c_sjsr_AnonFunction1(((p$2) => {
          var p = $as_Lreactbuild_model_InvoicePage(p$2);
          var this$7 = $n($n($n(p).Lreactbuild_model_InvoicePage__f_details).headOption__s_Option());
          if (this$7.isEmpty__Z()) {
            return $m_s_None$()
          } else {
            var arg1 = this$7.get__O();
            var d = $as_Lreactbuild_model_InvoiceDetail(arg1);
            var this$8 = $n($n(d).Lreactbuild_model_InvoiceDetail__f_deliveryDate);
            var this$9 = $n((this$8.isEmpty__Z() ? $n(p).Lreactbuild_model_InvoicePage__f_date : this$8));
            if (this$9.isEmpty__Z()) {
              var $$x1 = $m_s_None$()
            } else {
              var arg1$1 = this$9.get__O();
              var x$27 = $as_Lreactbuild_common_model_Date(arg1$1);
              var $$x1 = new $c_s_Some($n(x$27).Lreactbuild_common_model_Date__f_value)
            };
            return new $c_s_Some(new $c_T3($$x1, $n(p).Lreactbuild_model_InvoicePage__f_reference, $n(p).Lreactbuild_model_InvoicePage__f_pageIndex))
          }
        }));
        var ord = $m_s_math_Ordering$Long$();
        var ord1 = new $c_s_math_Ordering$O$1(ord);
        var ord$1 = $m_s_math_Ordering$String$();
        var ord2 = new $c_s_math_Ordering$O$1(ord$1);
        var ord$2 = $m_s_math_Ordering$Int$();
        var ord3 = new $c_s_math_Ordering$O$1(ord$2);
        var ord$3 = new $c_s_math_Ordering$Tuple3Ordering(ord1, ord2, ord3);
        var ord$4 = new $c_s_math_Ordering$O$1(ord$3);
        var value = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$15, f, ord$4);
        var invoicePages$1 = new $c_Ldiode_data_Ready(value);
        var this$17 = $n(s$1);
        var selectedInvoice$1 = this$17.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_selectedInvoice;
        return new $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(invoicePages$1, selectedInvoice$1)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$19, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue))), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
  } else {
    return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
function $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.CrossedDetails$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.CrossedDetails$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend() {
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend.prototype.render__Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__Lreactbuild_analyze_cost_modules_CrossedTable$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_crossedTable;
  var $$x24 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
  var $$x23 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$2);
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = $n($n($n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_row).Lreactbuild_analyze_cost_modules_CrossSpec__f_name;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  var $$x18 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_columns;
  var array$2 = [$$x18, $n($$x17).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((column$2) => {
    var column = $as_s_Option(column$2);
    var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$23 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$20 = $n(column);
    if (this$20.isEmpty__Z()) {
      var o = $m_s_None$()
    } else {
      var arg1 = this$20.get__O();
      var o = new $c_s_Some($as_T($n($n($n($n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_column).Lreactbuild_analyze_cost_modules_CrossSpec__f_label).apply__O__O(arg1)))
    };
    var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
    var f = new $c_sjsr_AnonFunction1(((v$2) => {
      var v$1 = $as_T(v$2);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)
    }));
    var array$1 = [$f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$23, o, O, f)];
    return $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  })))];
  var array$3 = [$n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var $$x16 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as$1 = $n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_rows;
  var array$10 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((row$2) => {
    var row = $as_s_Option(row$2);
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$38 = $n(row);
    if (this$38.isEmpty__Z()) {
      var content = $m_s_None$()
    } else {
      var arg1$1 = this$38.get__O();
      var content = new $c_s_Some($as_T($n($n($n($n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_row).Lreactbuild_analyze_cost_modules_CrossSpec__f_label).apply__O__O(arg1$1)))
    };
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$43 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var O$1 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
    var f$1 = new $c_sjsr_AnonFunction1(((v$2$1) => {
      var v$3 = $as_T(v$2$1);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
    }));
    var array$4 = [$f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$43, content, O$1, f$1)];
    var $$x3 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as$2 = $n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_columns;
    var array$9 = [$$x3, $n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$2, new $c_sjsr_AnonFunction1(((column$2$1) => {
      var column$1 = $as_s_Option(column$2$1);
      $n(p);
      var this$48 = $n(row);
      if (this$48.isEmpty__Z()) {
        var self = $m_s_None$()
      } else {
        var arg1$2 = this$48.get__O();
        var self = new $c_s_Some($as_Lreactbuild_common_model_RefTo($n($n($n($n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_row).Lreactbuild_analyze_cost_modules_CrossSpec__f__id).apply__O__O(arg1$2)))
      };
      var this$50 = $n(column$1);
      if (this$50.isEmpty__Z()) {
        var y = $m_s_None$()
      } else {
        var arg1$3 = this$50.get__O();
        var y = new $c_s_Some($as_Lreactbuild_common_model_RefTo($n($n($n($n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType).Lreactbuild_analyze_cost_modules_CrossType__f_column).Lreactbuild_analyze_cost_modules_CrossSpec__f__id).apply__O__O(arg1$3)))
      };
      var _id = $ct_T2__O__O__(new $c_T2(), self, y);
      var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x12 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_setSelection).apply__O__O(_id))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$54 = $n($n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_selection);
      var x1 = $f_sc_SeqOps__indexOf__O__I__I(this$54, _id, 0);
      var this$55 = $n(((x1 === (-1)) ? $m_s_None$() : new $c_s_Some(x1)));
      if (this$55.isEmpty__Z()) {
        var o$1 = $m_s_None$()
      } else {
        var arg1$4 = this$55.get__O();
        var index = $uI(arg1$4);
        var o$1 = new $c_s_Some($as_Lscalacss_internal_StyleA($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_crossedTableActiveCell).apply__O__O(index)))
      };
      var O$2 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var $$x11 = new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o$1, O$2).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((s$2$1) => {
        var s$3 = $as_Lscalacss_internal_StyleA(s$2$1);
        var this$57 = $m_Lscalacss_ScalaCssReact$();
        return $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$57, s$3)
      })));
      var pot = $n(p).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_amounts;
      if ($n(pot).isFailed__Z()) {
        var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v$4 = $n(pot).toString__T();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$5 = [$$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
        var $$x5 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
      } else {
        var this$68 = $n(pot);
        if ((!this$68.isEmpty__Z())) {
          var arg1$5 = $n(pot).get__O();
          var x$23 = $as_sci_Map(arg1$5);
          var this$69 = $n($n(x$23).get__O__s_Option(_id));
          if (this$69.isEmpty__Z()) {
            var $$x8 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
          } else {
            var arg1$6 = this$69.get__O();
            var v$5 = $as_Lreactbuild_model_Price(arg1$6);
            var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            $m_Lcom_iz2use_common_Textualizable$();
            var ev = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
            var v$6 = $n(ev).stringify__O__T(v$5);
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$6)];
            var $$x8 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
          };
          var $$x5 = $as_Ljapgolly_scalajs_react_vdom_VdomNode($$x8)
        } else if ($n(pot).isPending__Z()) {
          var $$x5 = $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
        } else {
          var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
          var $$x5 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
        }
      };
      var array$8 = [$$x12, $$x11, $$x5];
      return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
    })))];
    return $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
  })))];
  var array$11 = [$$x24, $$x23, $$x16, $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
  return $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
});
function $as_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.CrossedTable$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.CrossedTable$TypedBackend;", depth))
}
function $p_Lreactbuild_analyze_cost_modules_EditListEntry$Backend__newDate$1__s_Option__Lreactbuild_analyze_cost_modules_EditListEntry$Props__s_Option($thiz, created$1, p$6) {
  var this$1 = $n(created$1);
  if (this$1.isEmpty__Z()) {
    var $$x1 = true
  } else {
    var arg1 = this$1.get__O();
    var x$51 = $as_Ljava_time_LocalDate(arg1);
    var this$2 = $m_Ljava_time_LocalDate$();
    var x = this$2.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()));
    var $$x1 = (!((x === null) ? (x$51 === null) : $n(x).equals__O__Z(x$51)))
  };
  var this$4 = $n(($$x1 ? this$1 : $m_s_None$()));
  if (this$4.isEmpty__Z()) {
    var $$x2 = $m_s_None$()
  } else {
    var arg1$1 = this$4.get__O();
    var x$52 = $as_Ljava_time_LocalDate(arg1$1);
    var this$5 = $n(x$52);
    var $$x2 = new $c_s_Some($n($m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$5, $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime())).toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset()))
  };
  var this$6 = $n($$x2);
  return (this$6.isEmpty__Z() ? $n(p$6).created__s_Option() : this$6)
}
function $p_Lreactbuild_analyze_cost_modules_EditListEntry$Backend__oldDate$1__s_Option__Lreactbuild_analyze_cost_modules_EditListEntry$Props__s_Option($thiz, created$1, p$6) {
  var this$1 = $n(created$1);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var v = $as_Ljava_time_LocalDate(arg1);
    var this$2 = $n($n(p$6).created__s_Option());
    var pf = new $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1($thiz, v);
    if ((!this$2.isEmpty__Z())) {
      var this$3 = new $c_s_PartialFunction$Lifted(pf);
      var v1 = this$2.get__O();
      var $$x1 = this$3.apply__O__s_Option(v1)
    } else {
      var $$x1 = $m_s_None$()
    }
  };
  var this$4 = $n($$x1);
  return (this$4.isEmpty__Z() ? $p_Lreactbuild_analyze_cost_modules_EditListEntry$Backend__newDate$1__s_Option__Lreactbuild_analyze_cost_modules_EditListEntry$Props__s_Option($thiz, created$1, p$6) : this$4)
}
function $p_Lreactbuild_analyze_cost_modules_EditListEntry$Backend__loop$2__sci_List__s_Option__s_Option__sci_List__sci_List__Lreactbuild_analyze_cost_modules_EditListEntry$Props__Lreactbuild_analyze_cost_components_ProgressContext__Lreactbuild_common_model_RefTo__Lreactbuild_model_ListEntryType__sci_ListSet__Ljava_time_Instant__Ljapgolly_scalajs_react_callback_Trampoline($thiz, titles, entryOpt, templateOpt, nextTemplates, nextInstances, p$6, context$2, templateRef$1, tpe$1, terms$2, nextDate$1) {
  while (true) {
    var x1 = titles;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x1)) {
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x1 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback;
      var nextTemplates$2 = nextTemplates;
      var after = $n($$x2).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($$x1).traverse__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0(((nextTemplates$1) => (() => nextTemplates$1))(nextTemplates$2)), new $c_sjsr_AnonFunction1(((p$6) => ((nextTemplate$2) => {
        var nextTemplate = $as_Lreactbuild_model_ListTemplateEntry(nextTemplate$2);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(p$6).context__Lreactbuild_analyze_cost_modules_EditListEntry$Context()).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_proxy).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry(nextTemplate), $m_Ldiode_Action$aType$()))
      }))(p$6))), $n($n(p$6).update__Lreactbuild_analyze_cost_modules_EntryList$Updater()).apply__sci_List__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n(nextInstances).map__F1__sci_List(new $c_sjsr_AnonFunction1(((p$6) => ((nextInstance$2) => {
        var nextInstance = $as_Lreactbuild_model_ListEntry(nextInstance$2);
        var this$4 = $n($n(p$6).entryOpt__s_Option());
        var p = new $c_sjsr_AnonFunction1(((x$53$2) => {
          var x$53 = $as_Lreactbuild_model_ListEntry(x$53$2);
          var x$1 = $n(x$53)._id__Lreactbuild_common_model_RefTo();
          var x$2 = $n(nextInstance)._id__Lreactbuild_common_model_RefTo();
          return ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2))
        }));
        return new $c_Lreactbuild_model_WithChildren(nextInstance, ((!((!this$4.isEmpty__Z()) && $uZ(p.apply__O__O(this$4.get__O())))) ? $m_sci_Nil$() : $as_sci_List($n(p$6).foldExisting__F0__F1__O(new $c_sjsr_AnonFunction0((() => $m_sci_Nil$())), new $c_sjsr_AnonFunction1(((x$54$2) => {
          var x$54 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps(x$54$2);
          return $n(x$54).history__sci_List()
        }))))))
      }))(p$6))), $m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline($m_Lcom_iz2use_react_components_Dialog$Pop$())));
      var $$x8 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x4 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback);
      var nextTemplates$4 = nextTemplates;
      var $$x3 = $n($$x4).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0(((nextTemplates$3) => (() => {
        var this$6 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x7 = new $c_Lautowire_ClientProxy(this$6).Lautowire_ClientProxy__f_self;
        var $$x6 = $m_s_package$().s_package$__f_Seq;
        var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistListTemplateEntries"];
        var $$x5 = $as_sci_Seq($n($$x6).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
        var this$18 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$11 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$13 = $n(new $c_Lautowire_ClientProxy(this$11).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Encoder$();
        var encodeA = $m_Lreactbuild_model_ListTemplateEntry$().Lreactbuild_model_ListTemplateEntry$__f_codecForListTemplateEntry;
        var evidence$2 = new $c_Lio_circe_Encoder$$anon$25(encodeA);
        var y = this$13.write__O__Lio_circe_Encoder__Lio_circe_Json(nextTemplates$3, evidence$2);
        var array$1 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        return $n($n($$x7).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x5, this$18.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1$1 = $as_Lio_circe_Json(x$1$2);
          var this$19 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$20 = $n(new $c_Lautowire_ClientProxy(this$19).Lautowire_ClientProxy__f_self);
          var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
          this$20.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1$1, evidence$1)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      }))(nextTemplates$4)), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
      var nextInstances$2 = nextInstances;
      var updateServer = $n($$x8).flatMap$extension__F1__F1__F1($$x3, new $c_sjsr_AnonFunction1(((nextInstances$1) => ((x$56$2) => {
        $as_jl_Void(x$56$2);
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
          var this$21 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var $$x11 = new $c_Lautowire_ClientProxy(this$21).Lautowire_ClientProxy__f_self;
          var $$x10 = $m_s_package$().s_package$__f_Seq;
          var array$2 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistListEntries"];
          var $$x9 = $as_sci_Seq($n($$x10).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
          var this$33 = $n($m_s_Predef$().s_Predef$__f_Map);
          var this$26 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$28 = $n(new $c_Lautowire_ClientProxy(this$26).Lautowire_ClientProxy__f_self);
          $m_Lio_circe_Encoder$();
          var encodeA$1 = $m_Lreactbuild_model_ListEntry$().Lreactbuild_model_ListEntry$__f_encodeListEntry;
          var evidence$2$1 = new $c_Lio_circe_Encoder$$anon$25(encodeA$1);
          var y$1 = this$28.write__O__Lio_circe_Encoder__Lio_circe_Json(nextInstances$1, evidence$2$1);
          var array$3 = [$ct_T2__O__O__(new $c_T2(), "x", y$1)];
          var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
          return $n($n($$x11).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x9, this$33.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
            var x$2$1 = $as_Lio_circe_Json(x$2$2);
            var this$34 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var this$35 = $n(new $c_Lautowire_ClientProxy(this$34).Lautowire_ClientProxy__f_self);
            var evidence$1$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
            this$35.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2$1, evidence$1$1)
          })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue), new $c_sjsr_AnonFunction1(((x$55$2) => {
          $as_jl_Void(x$55$2)
        }))))
      }))(nextInstances$2)));
      return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(context$2).Lreactbuild_analyze_cost_components_ProgressContext__f_track).apply__O__O__O(new $c_Ljapgolly_scalajs_react_callback_AsyncCallback(updateServer), new $c_Ljapgolly_scalajs_react_callback_CallbackTo(after)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    };
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var p4 = $as_T2($n(x3).sci_$colon$colon__f_head);
      var tl = $n(x3).sci_$colon$colon__f_next;
      if ((p4 !== null)) {
        var title = $as_T($n(p4)._2__O());
        var this$36 = $n($f_T__trim__T($n(title)));
        if ((this$36 === "")) {
          titles = tl;
          continue
        } else {
          var this$38 = $n(templateOpt);
          var default$1 = new $c_sjsr_AnonFunction0((() => {
            $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
            return new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())
          }));
          var nextTemplateEntry = new $c_Lreactbuild_model_ListTemplateEntry($as_Lreactbuild_common_model_RefTo((this$38.isEmpty__Z() ? default$1.apply__O() : this$38.get__O())), templateRef$1, title, tpe$1, terms$2, nextDate$1, ($m_Lreactbuild_model_ListTemplateEntry$(), $m_Lreactbuild_model_ListEntryValidation$NoValidation$()), ($m_Lreactbuild_model_ListTemplateEntry$(), $m_s_None$()));
          var $$x13 = nextTemplateEntry.Lreactbuild_model_ListTemplateEntry__f__id;
          var this$42 = $n(entryOpt);
          var ifEmpty = new $c_sjsr_AnonFunction0((() => {
            $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
            return new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())
          }));
          var f = new $c_sjsr_AnonFunction1(((x$57$2) => {
            var x$57 = $as_Lreactbuild_model_ListEntry(x$57$2);
            return $n(x$57)._id__Lreactbuild_common_model_RefTo()
          }));
          var $$x12 = $as_Lreactbuild_common_model_RefTo((this$42.isEmpty__Z() ? ifEmpty.apply__O() : f.apply__O__O(this$42.get__O())));
          var this$43 = $n(p$6);
          var nextInstance$3 = new $c_Lreactbuild_model_InstanceListEntry($$x13, $$x12, nextDate$1, $n($n(this$43.context__Lreactbuild_analyze_cost_modules_EditListEntry$Context()).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_project).Lreactbuild_common_model_Project__f__id, $m_s_None$());
          var temp$entryOpt = $m_s_None$();
          var temp$templateOpt = $m_s_None$();
          var this$45 = $n(nextTemplates);
          var temp$nextTemplates = new $c_sci_$colon$colon(nextTemplateEntry, this$45);
          var this$46 = $n(nextInstances);
          var temp$nextInstances = new $c_sci_$colon$colon(nextInstance$3, this$46);
          titles = tl;
          entryOpt = temp$entryOpt;
          templateOpt = temp$templateOpt;
          nextTemplates = temp$nextTemplates;
          nextInstances = temp$nextInstances;
          continue
        }
      }
    };
    throw new $c_s_MatchError(x1)
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseTitle = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseDate = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseCustomDate = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseType = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseTemplate = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_addTerm = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x1;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x1 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $as_T2($n(x5).s_Some__f_value);
        var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
          var s = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(s$2);
          var this$2 = $n($n(s).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title);
          _return: {
            var i = 0;
            var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$2, 0, this$2);
            while (true) {
              var this$5 = $n(these);
              if ((!this$5.isEmpty__Z())) {
                var arg1 = $n(these).head__O();
                var x$37 = $as_T2(arg1);
                var x$1 = $n(x$37)._1__O();
                var y = $n(v)._1__O();
                if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y)) {
                  var x1$2 = i;
                  break _return
                };
                i = ((1 + i) | 0);
                these = $as_sc_LinearSeq($n(these).tail__O())
              } else {
                break
              }
            };
            var x1$2 = (-1)
          };
          if ((x1$2 === (-1))) {
            var this$6 = $n($n(s).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title);
            var this$9 = $n($as_sc_SeqOps($f_sc_StrictOptimizedSeqOps__appended__O__O(this$6, v)));
            var self = $m_ju_UUID$().randomUUID__ju_UUID();
            var elem = $ct_T2__O__O__(new $c_T2(), self, "");
            var nextTitle = $as_sci_List(this$9.appended__O__O(elem))
          } else {
            var this$11 = $n($n(s).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title);
            var this$10 = $m_sci_Nil$();
            var other = new $c_sci_$colon$colon(v, this$10);
            var updated = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$11, x1$2, other, 1));
            if ((x1$2 === (((-1) + $n($n(s).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title).length__I()) | 0))) {
              var this$14 = $n(updated);
              var self$1 = $m_ju_UUID$().randomUUID__ju_UUID();
              var elem$1 = $ct_T2__O__O__(new $c_T2(), self$1, "");
              var nextTitle = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$14, elem$1))
            } else {
              var nextTitle = updated
            }
          };
          var this$15 = $n(s);
          var x$2 = this$15.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
          var this$16 = $n(s);
          var x$3 = this$16.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
          var this$17 = $n(s);
          var x$4 = this$17.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
          var this$18 = $n(s);
          var x$5 = this$18.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
          var this$19 = $n(s);
          var x$6 = this$19.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate;
          var this$20 = $n(s);
          var x$7 = this$20.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
          $n(s);
          return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$2, nextTitle, x$3, x$4, x$5, x$6, x$7)
        })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseTitle = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f);
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$38$2) => {
    var x$38 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$38$2);
    return $n(x$38).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v$1 = $as_s_Option(v$2);
    return new $c_sjsr_AnonFunction1(((x$39$2) => {
      var x$39 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$39$2);
      var this$25 = $n(x$39);
      var x$9 = this$25.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
      var this$26 = $n(x$39);
      var x$10 = this$26.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
      var this$27 = $n(x$39);
      var x$11 = this$27.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
      var this$28 = $n(x$39);
      var x$12 = this$28.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
      var this$29 = $n(x$39);
      var x$13 = this$29.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate;
      var this$30 = $n(x$39);
      var x$14 = this$30.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
      $n(x$39);
      return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$9, x$10, x$11, v$1, x$12, x$13, x$14)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x2 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$34 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$34.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseDate = $n($$x3).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x2, \u03b4, w);
  var $$x5 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$1 = new $c_sjsr_AnonFunction1(((x$40$2) => {
    var x$40 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$40$2);
    return $n(x$40).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate
  }));
  var set$1 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $uZ(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$41$2) => {
      var x$41 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$41$2);
      var this$35 = $n(x$41);
      var x$16 = this$35.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
      var this$36 = $n(x$41);
      var x$17 = this$36.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
      var this$37 = $n(x$41);
      var x$18 = this$37.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
      var this$38 = $n(x$41);
      var x$19 = this$38.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
      var this$39 = $n(x$41);
      var x$20 = this$39.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
      var this$40 = $n(x$41);
      var x$21 = this$40.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
      $n(x$41);
      return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$16, x$17, x$18, x$19, x$20, v$3, x$21)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x4 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$1, set$1);
  var this$44 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$1 = this$44.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseCustomDate = $n($$x5).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x4, \u03b4, w$1);
  var $$x7 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$2 = new $c_sjsr_AnonFunction1(((x$42$2) => {
    var x$42 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$42$2);
    return $n(x$42).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe
  }));
  var set$2 = new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4 = $as_Lreactbuild_model_ListEntryType(v$4$2);
    return new $c_sjsr_AnonFunction1(((x$43$2) => {
      var x$43 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$43$2);
      $n(x$43);
      var this$45 = $n(x$43);
      var title = this$45.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
      var this$46 = $n(x$43);
      var terms = this$46.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
      var this$47 = $n(x$43);
      var created = this$47.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
      var this$48 = $n(x$43);
      var template = this$48.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
      var this$49 = $n(x$43);
      var customDate = this$49.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate;
      var this$50 = $n(x$43);
      var validation = this$50.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
      return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(v$4, title, terms, created, template, customDate, validation)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x6 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$2, set$2);
  var this$54 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$2 = this$54.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseType = $n($$x7).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x6, \u03b4, w$2);
  var $$x9 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$3 = new $c_sjsr_AnonFunction1(((x$44$2) => {
    var x$44 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$44$2);
    return $n(x$44).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms
  }));
  var set$3 = new $c_sjsr_AnonFunction1(((v$5$2) => {
    var v$5 = $as_sci_ListSet(v$5$2);
    return new $c_sjsr_AnonFunction1(((x$45$2) => {
      var x$45 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$45$2);
      var this$55 = $n(x$45);
      var x$23 = this$55.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
      var this$56 = $n(x$45);
      var x$24 = this$56.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
      var this$57 = $n(x$45);
      var x$25 = this$57.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
      var this$58 = $n(x$45);
      var x$26 = this$58.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
      var this$59 = $n(x$45);
      var x$27 = this$59.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate;
      var this$60 = $n(x$45);
      var x$28 = this$60.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
      $n(x$45);
      return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$23, x$24, v$5, x$25, x$26, x$27, x$28)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x8 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$3, set$3);
  var this$64 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$3 = this$64.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  $n($$x9).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x8, \u03b4, w$3);
  var $$x11 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$4 = new $c_sjsr_AnonFunction1(((x$46$2) => {
    var x$46 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$46$2);
    return $n(x$46).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template
  }));
  var set$4 = new $c_sjsr_AnonFunction1(((v$6$2) => {
    var v$6 = $as_s_Option(v$6$2);
    return new $c_sjsr_AnonFunction1(((x$47$2) => {
      var x$47 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$47$2);
      var this$65 = $n(x$47);
      var x$30 = this$65.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
      var this$66 = $n(x$47);
      var x$31 = this$66.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
      var this$67 = $n(x$47);
      var x$32 = this$67.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
      var this$68 = $n(x$47);
      var x$33 = this$68.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
      var this$69 = $n(x$47);
      var x$34 = this$69.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate;
      var this$70 = $n(x$47);
      var x$35 = this$70.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
      $n(x$47);
      return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$30, x$31, x$32, x$33, v$6, x$34, x$35)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x10 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$4, set$4);
  var this$74 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$4 = this$74.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseTemplate = $n($$x11).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x10, \u03b4, w$4);
  var $$x13 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$5 = new $c_sjsr_AnonFunction1(((x$48$2) => {
    var x$48 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$48$2);
    var x$8 = $n(x$48).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
    var x$2$1 = $m_Lreactbuild_model_ListEntryValidation$MediaMandatory$();
    if ((x$8 !== null)) {
      var this$75 = $n(x$8);
      return (this$75 === x$2$1)
    } else {
      return false
    }
  }));
  var set$5 = new $c_sjsr_AnonFunction1(((v$7$2) => {
    var v$7 = $uZ(v$7$2);
    return new $c_sjsr_AnonFunction1(((x$49$2) => {
      var x$49 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$49$2);
      var x$36 = (v$7 ? $m_Lreactbuild_model_ListEntryValidation$MediaMandatory$() : $m_Lreactbuild_model_ListEntryValidation$NoValidation$());
      var this$76 = $n(x$49);
      var x$37$1 = this$76.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
      var this$77 = $n(x$49);
      var x$38$1 = this$77.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
      var this$78 = $n(x$49);
      var x$39$1 = this$78.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
      var this$79 = $n(x$49);
      var x$40$1 = this$79.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
      var this$80 = $n(x$49);
      var x$41$1 = this$80.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
      var this$81 = $n(x$49);
      var x$42$1 = this$81.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate;
      $n(x$49);
      return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$37$1, x$38$1, x$39$1, x$40$1, x$41$1, x$42$1, x$36)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x12 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$5, set$5);
  var this$85 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$5 = this$85.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  $n($$x13).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x12, \u03b4, w$5);
  var $$x17 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f$1 = new $c_sjsr_AnonFunction2(((x0$2$2, x1$2$2) => {
    var x0$2 = $as_s_Option(x0$2$2);
    var x1$2$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var _2 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2$1);
    matchEnd8: {
      var $$x15;
      if ((x0$2 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x0$2);
        var p4$1 = $as_s_Option($n(x3).s_Some__f_value);
        if ((p4$1 instanceof $c_s_Some)) {
          var x5$1 = $as_s_Some(p4$1);
          var v$8 = $as_Lreactbuild_common_model_RefTo($n(x5$1).s_Some__f_value);
          var this$94 = $n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_$);
          var mod = new $c_sjsr_AnonFunction1(((s$2$1) => {
            var s$1 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(s$2$1);
            var this$86 = $n($n(s$1).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms);
            var x$43$1 = this$86.incl__O__sci_ListSet(v$8);
            var this$87 = $n(s$1);
            var x$44$1 = this$87.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
            var this$88 = $n(s$1);
            var x$45$1 = this$88.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
            var this$89 = $n(s$1);
            var x$46$1 = this$89.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
            var this$90 = $n(s$1);
            var x$47$1 = this$90.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
            var this$91 = $n(s$1);
            var x$48$1 = this$91.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate;
            var this$92 = $n(s$1);
            var x$49$1 = this$92.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
            $n(s$1);
            return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$44$1, x$45$1, x$43$1, x$46$1, x$47$1, x$48$1, x$49$1)
          }));
          var $$x15 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$94, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          break matchEnd8
        }
      };
      var cb$1 = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x15 = cb$1
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x15)
  }));
  var $$x16 = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$1);
  var $$x14 = $m_s_None$();
  var this$97 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_addTerm = $n($$x17).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($$x16, $$x14, this$97.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3))
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype.update__Lreactbuild_analyze_cost_components_ProgressContext__Ljapgolly_scalajs_react_callback_Trampoline = (function(context) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_EditListEntry$Props(p$2);
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var condition = new $c_sjsr_AnonFunction1(((check$ifrefutable$2$2) => {
      var check$ifrefutable$2 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(check$ifrefutable$2$2);
      return (check$ifrefutable$2 !== null)
    }));
    var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$, condition);
    var condition$1 = new $c_sjsr_AnonFunction1(((x$63$2) => {
      var x$63 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$63$2);
      if ((x$63 !== null)) {
        var titles = $n(x$63).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
        var this$3 = $n(titles);
        var these = this$3;
        while ((!$n(these).isEmpty__Z())) {
          var arg1 = $n(these).head__O();
          var x$50 = $as_T2(arg1);
          $m_sc_StringOps$();
          var x = $f_T__trim__T($n($as_T($n(x$50)._2__O())));
          var this$6 = $n(x);
          if ((!(this$6 === ""))) {
            return true
          };
          these = $as_sci_List($n(these).tail__O())
        };
        return false
      } else {
        throw new $c_s_MatchError(x$63)
      }
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x1).flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$$1, condition$1), new $c_sjsr_AnonFunction1(((x$65$2) => {
      var x$65 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$65$2);
      if ((x$65 !== null)) {
        var tpe = $n(x$65).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
        var titles$1 = $n(x$65).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
        var terms = $n(x$65).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
        var created = $n(x$65).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
        var template = $n(x$65).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        if ((p instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps)) {
          var this$8 = $n($p_Lreactbuild_analyze_cost_modules_EditListEntry$Backend__oldDate$1__s_Option__Lreactbuild_analyze_cost_modules_EditListEntry$Props__s_Option(this, created, p));
          if (this$8.isEmpty__Z()) {
            new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
            var $$x4 = $m_Ljava_time_Instant$();
            var this$13 = $m_RTLong$();
            var value = $uD(new Date().getTime());
            var lo = this$13.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
            var hi = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            var $$x3 = $n($$x4).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))
          } else {
            var $$x3 = this$8.get__O()
          };
          var nextDate = $as_Ljava_time_Instant($$x3)
        } else if ((p instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps)) {
          var this$14 = $n($p_Lreactbuild_analyze_cost_modules_EditListEntry$Backend__oldDate$1__s_Option__Lreactbuild_analyze_cost_modules_EditListEntry$Props__s_Option(this, created, p));
          if (this$14.isEmpty__Z()) {
            new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
            var $$x6 = $m_Ljava_time_Instant$();
            var this$19 = $m_RTLong$();
            var value$1 = $uD(new Date().getTime());
            var lo$1 = this$19.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
            var hi$1 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            var $$x5 = $n($$x6).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo$1, hi$1))
          } else {
            var $$x5 = this$14.get__O()
          };
          var nextDate = $as_Ljava_time_Instant($$x5)
        } else {
          if ((!(p instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps))) {
            throw new $c_s_MatchError(p)
          };
          var this$20 = $n($p_Lreactbuild_analyze_cost_modules_EditListEntry$Backend__newDate$1__s_Option__Lreactbuild_analyze_cost_modules_EditListEntry$Props__s_Option(this, created, p));
          if (this$20.isEmpty__Z()) {
            new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
            var $$x8 = $m_Ljava_time_Instant$();
            var this$25 = $m_RTLong$();
            var value$2 = $uD(new Date().getTime());
            var lo$2 = this$25.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$2);
            var hi$2 = this$25.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            var $$x7 = $n($$x8).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo$2, hi$2))
          } else {
            var $$x7 = this$20.get__O()
          };
          var nextDate = $as_Ljava_time_Instant($$x7)
        };
        if ((template instanceof $c_s_Some)) {
          var x2 = $as_s_Some(template);
          var templateRef = $as_Lreactbuild_common_model_RefTo($n(x2).s_Some__f_value);
          var this$$2 = $p_Lreactbuild_analyze_cost_modules_EditListEntry$Backend__loop$2__sci_List__s_Option__s_Option__sci_List__sci_List__Lreactbuild_analyze_cost_modules_EditListEntry$Props__Lreactbuild_analyze_cost_components_ProgressContext__Lreactbuild_common_model_RefTo__Lreactbuild_model_ListEntryType__sci_ListSet__Ljava_time_Instant__Ljapgolly_scalajs_react_callback_Trampoline(this, titles$1, $n(p).entryOpt__s_Option(), $as_s_Option($n(p).foldInstance__F0__F1__O(new $c_sjsr_AnonFunction0((() => $m_s_None$())), new $c_sjsr_AnonFunction1(((v$2) => {
            var v = $as_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(v$2);
            return $m_s_Option$().apply__O__s_Option($n($n(v).Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_templateEntry).Lreactbuild_model_ListTemplateEntry__f__id)
          })))), $m_sci_Nil$(), $m_sci_Nil$(), p, context, templateRef, tpe, terms, nextDate)
        } else {
          var x$1 = $m_s_None$();
          if ((!(x$1 === template))) {
            throw new $c_s_MatchError(template)
          };
          if ((p instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps)) {
            var x2$2 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps(p);
            var entry = $n(x2$2).Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entry;
            var duration = $n($as_Lreactbuild_model_CustomListEntry($n(entry).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_CustomListEntry__f_duration
          } else if ((p instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps)) {
            var x3 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(p);
            var entry$2 = $n(x3).Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entry;
            var this$26 = $n(entry$2);
            if (this$26.isEmpty__Z()) {
              var duration = $m_s_None$()
            } else {
              var arg1$1 = this$26.get__O();
              var x$58 = $as_Lreactbuild_model_WithChildren(arg1$1);
              var this$27 = $n($n($as_Lreactbuild_model_InstanceListEntry($n(x$58).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_InstanceListEntry__f_duration);
              if (this$27.isEmpty__Z()) {
                var duration = $m_s_None$()
              } else {
                var arg1$2 = this$27.get__O();
                var x$59 = $as_Lreactbuild_model_CachedExpression(arg1$2);
                var duration = new $c_s_Some($as_Ljava_time_Duration($n(x$59).Lreactbuild_model_CachedExpression__f_calculatedValue))
              }
            }
          } else {
            if ((!(p instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps))) {
              throw new $c_s_MatchError(p)
            };
            var duration = $m_s_None$()
          };
          if ((p instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps)) {
            var x2$3 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps(p);
            var entry$3 = $n(x2$3).Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entry;
            var from = $n($as_Lreactbuild_model_CustomListEntry($n(entry$3).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_CustomListEntry__f_from
          } else {
            var from = $m_s_None$()
          };
          var nextEntries = $n(titles$1).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2(this, p, nextDate, terms, duration, from, tpe));
          var updateServer = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
            var this$28 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var $$x11 = new $c_Lautowire_ClientProxy(this$28).Lautowire_ClientProxy__f_self;
            var $$x10 = $m_s_package$().s_package$__f_Seq;
            var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistListEntries"];
            var $$x9 = $as_sci_Seq($n($$x10).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
            var this$40 = $n($m_s_Predef$().s_Predef$__f_Map);
            var this$33 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var this$35 = $n(new $c_Lautowire_ClientProxy(this$33).Lautowire_ClientProxy__f_self);
            $m_Lio_circe_Encoder$();
            var encodeA = $m_Lreactbuild_model_ListEntry$().Lreactbuild_model_ListEntry$__f_encodeListEntry;
            var evidence$2 = new $c_Lio_circe_Encoder$$anon$25(encodeA);
            var y = this$35.write__O__Lio_circe_Encoder__Lio_circe_Json(nextEntries, evidence$2);
            var array$1 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
            return $n($n($$x11).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x9, this$40.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
              var x$1$1 = $as_Lio_circe_Json(x$1$2);
              var this$41 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
              var this$42 = $n(new $c_Lautowire_ClientProxy(this$41).Lautowire_ClientProxy__f_self);
              var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
              this$42.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1$1, evidence$1)
            })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
          })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
          var $$x14 = $n($n(p).update__Lreactbuild_analyze_cost_modules_EntryList$Updater());
          var this$44 = $n(nextEntries);
          var f = ((nextEntry$2) => {
            var nextEntry = $as_Lreactbuild_model_ListEntry(nextEntry$2);
            var this$43 = $n($n(p).entryOpt__s_Option());
            if ((!this$43.isEmpty__Z())) {
              var arg1$3 = this$43.get__O();
              var x$61 = $as_Lreactbuild_model_ListEntry(arg1$3);
              var x$2 = $n(x$61)._id__Lreactbuild_common_model_RefTo();
              var x$2$1 = $n(nextEntry)._id__Lreactbuild_common_model_RefTo();
              var $$x12 = ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
            } else {
              var $$x12 = false
            };
            return new $c_Lreactbuild_model_WithChildren(nextEntry, ((!$$x12) ? $m_sci_Nil$() : $as_sci_List($n(p).foldExisting__F0__F1__O(new $c_sjsr_AnonFunction0((() => $m_sci_Nil$())), new $c_sjsr_AnonFunction1(((x$62$2) => {
              var x$62 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps(x$62$2);
              return $n(x$62).history__sci_List()
            }))))))
          });
          if ((this$44 === $m_sci_Nil$())) {
            var $$x13 = $m_sci_Nil$()
          } else {
            var arg1$4 = this$44.head__O();
            var h = new $c_sci_$colon$colon(f(arg1$4), $m_sci_Nil$());
            var t = h;
            var rest = $as_sci_List(this$44.tail__O());
            while ((rest !== $m_sci_Nil$())) {
              var arg1$5 = $n(rest).head__O();
              var nx = new $c_sci_$colon$colon(f(arg1$5), $m_sci_Nil$());
              $n(t).sci_$colon$colon__f_next = nx;
              t = nx;
              rest = $as_sci_List($n(rest).tail__O())
            };
            var $$x13 = h
          };
          var after = $n($$x14).apply__sci_List__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x13, $m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline($m_Lcom_iz2use_react_components_Dialog$Pop$()));
          var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(context).Lreactbuild_analyze_cost_components_ProgressContext__f_track).apply__O__O__O(new $c_Ljapgolly_scalajs_react_callback_AsyncCallback(updateServer), new $c_Ljapgolly_scalajs_react_callback_CallbackTo(after)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
        };
        var f$1 = new $c_sjsr_AnonFunction1(((x$64$2) => {
          $as_jl_Void(x$64$2)
        }));
        var this$47 = $n(this$$2);
        var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$47, f$1);
        var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c)
      } else {
        var $$x2;
        throw new $c_s_MatchError(x$65)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($$x2)
    }))))
  })));
  var $$x15 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$50 = $m_s_$less$colon$less$();
  return $n($$x15).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$50.s_$less$colon$less$__f_singleton)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype.remove__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_callback_Trampoline = (function(termRef) {
  var this$11 = $n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(s$2);
    var this$2 = $n($n(s).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms);
    var b = new $c_sci_ListSet$$anon$1();
    var it = this$2.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var x$66 = $as_Lreactbuild_common_model_RefTo(elem);
      if ((((x$66 === null) ? (termRef === null) : $n(x$66).equals__O__Z(termRef)) !== true)) {
        b.addOne__O__sci_ListSet$$anon$1(elem)
      }
    };
    var x$1 = $as_sci_ListSet(b.scm_ImmutableBuilder__f_elems);
    var this$4 = $n(s);
    var x$2 = this$4.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
    var this$5 = $n(s);
    var x$3 = this$5.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
    var this$6 = $n(s);
    var x$4 = this$6.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
    var this$7 = $n(s);
    var x$5 = this$7.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
    var this$8 = $n(s);
    var x$6 = this$8.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate;
    var this$9 = $n(s);
    var x$7 = this$9.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
    $n(s);
    return new $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$2, x$3, x$1, x$4, x$5, x$6, x$7)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$11, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype.render__Lreactbuild_analyze_cost_modules_EditListEntry$Props__Lreactbuild_analyze_cost_modules_EditListEntry$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var u = $m_Lreactbuild_analyze_cost_components_Progress$().apply__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((context$2) => {
    var context = $as_Lreactbuild_analyze_cost_components_ProgressContext(context$2);
    var this$2 = $n(p);
    var proxy = $n(this$2.context__Lreactbuild_analyze_cost_modules_EditListEntry$Context()).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_proxy;
    var this$3 = $n(p);
    var organization = $n($n($n(this$3.context__Lreactbuild_analyze_cost_modules_EditListEntry$Context()).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_project).Lreactbuild_common_model_Project__f_organizations).headOption__s_Option();
    var f = new $c_sjsr_AnonFunction0((() => {
      var this$4 = $m_Ljava_time_LocalDate$();
      return this$4.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
    }));
    var dateRef = new $c_Lcom_iz2use_common_ParsingReference$Simple(f);
    var submit = new $c_sjsr_AnonFunction1(((ev$2) => {
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_package$();
      var this$8 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$8.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, this.update__Lreactbuild_analyze_cost_components_ProgressContext__Ljapgolly_scalajs_react_callback_Trampoline(context)))
    }));
    var $$x38 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onSubmit");
    var $$x37 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(submit, $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    var $$x36 = $m_Lcom_iz2use_react_components_Dialog$();
    var s$1 = $n(context).Lreactbuild_analyze_cost_components_ProgressContext__f_statusIcon;
    var this$14 = $n(s$1);
    var array = [$f_Lreactbuild_analyze_cost_components_Progress$State__render__Ljapgolly_scalajs_react_vdom_VdomNode(this$14), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Enregistrement d'une entr\u00e9e"))];
    var $$x35 = $n($$x36).header__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$22 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_horizontalLayout;
    var $$x33 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$22, s$2);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$24 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX");
    var $$x32 = this$24.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("visible", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Changer la date de cr\u00e9ation (si demande pass\u00e9e)");
    var $$x30 = $n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseCustomDate);
    var this$27 = $m_Ljapgolly_scalajs_react_Reusability$();
    var state = $n($$x30).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$27.by_$eq$eq__F2());
    var evDefault = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
    var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv = $m_s_math_Equiv$Boolean$();
    var this$32 = $n(editorComponent);
    var $$x31 = this$32.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement("customDate", label, state, optioner, ev, explainError, equiv);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date de l'entr\u00e9e");
    var $$x28 = $n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseDate);
    var this$35 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3 = $m_Lreactbuild_model_Implicits$().reusabilityLocalDate__F2();
    var state$1 = $n($$x28).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$35.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    $m_Lcom_iz2use_common_Parsable$();
    var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$4(dateRef);
    var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$39 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$39);
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
    var $$x29 = editorComponent$1.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement("date", label$1, state$1, optioner$1, ev$1, explainError$1, equiv$1);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Type");
    var state$2 = $n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseType).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $m_Lreactbuild_analyze_cost_modules_EditListEntry$().Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$reusabilityType);
    var evDefault$1 = $m_Lreactbuild_analyze_cost_modules_EditListEntry$().Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$defaultType;
    var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    var ev$3 = $m_Lreactbuild_analyze_cost_modules_EditListEntry$().Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$resolverType;
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var helper$1 = $m_Lreactbuild_analyze_cost_modules_EditListEntry$().Lreactbuild_analyze_cost_modules_EditListEntry$__f_reactbuild$analyze$cost$modules$EditListEntry$$typeHelper;
    var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
    var this$47 = $m_Lcom_iz2use_react_components_ExplainError$();
    var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1(this$47);
    var this$48 = $m_s_math_Equiv$();
    var equiv$2 = this$48.universal__s_math_Equiv();
    var $$x27 = editorComponent$2.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement("type", label$2, state$2, optioner$2, ev$3, explainError$2, equiv$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Liste mod\u00e8le (servira sur tous les projets si renseign\u00e9)");
    var $$x26 = $n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseTemplate);
    var this$52 = $m_Ljapgolly_scalajs_react_Reusability$();
    var evidence$3$1 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
    var state$3 = $n($$x26).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$52.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$1));
    var optioner$3 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var this$54 = $m_Lreactbuild_model_Implicits$();
    var ev$4 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$19(this$54, proxy, organization);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$55 = $m_Lreactbuild_model_Implicits$();
    var helper$2 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$19(this$55, proxy, organization);
    var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
    var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$58 = $m_s_math_Equiv$();
    var equiv$3 = this$58.universal__s_math_Equiv();
    var array$1 = [$$x33, $$x32, $$x31, $$x29, $$x27, editorComponent$3.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement("template", label$3, state$3, optioner$3, ev$4, explainError$3, equiv$3)];
    var $$x25 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x19 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $n(s).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
    var $$x18 = $n($$x19).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((title$2) => {
      var title = $as_T2(title$2);
      var key = ("" + $n(title)._1__O());
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Intitul\u00e9");
      var $$x23 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
      var $$x22 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_reuseTitle;
      var $$x21 = $m_Ljapgolly_scalajs_react_Reusability$();
      var this$66 = $m_Ljapgolly_scalajs_react_Reusability$();
      var $$x20 = this$66.by_$eq$eq__F2();
      var this$67 = $m_Ljapgolly_scalajs_react_Reusability$();
      var this$70 = $n($n($$x23).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($$x22, title, $n($$x21).tuple2__F2__F2__F2($$x20, this$67.by_$eq$eq__F2())));
      var g = new $c_sjsr_AnonFunction1(((v$2) => {
        var v = $as_T(v$2);
        return new $c_sjsr_AnonFunction1(((x$68$2) => {
          var x$68 = $as_T2(x$68$2);
          var self = $n(x$68)._1__O();
          return $ct_T2__O__O__(new $c_T2(), self, v)
        }))
      }));
      var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$70.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
      var arg1 = this$70.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var x$67 = $as_T2(arg1);
      var state$4 = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$70, $as_T($n(x$67)._2__O()), new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
        var ot = $as_s_Option(ot$2);
        var $$x24 = $n($as_F2($n(this$70.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
        var this$71 = $n(ot);
        return $n($$x24).apply__O__O__O((this$71.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$71.get__O()))), cb$2)
      })));
      var evDefault$2 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
      var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
      var parser$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var ev$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$74 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$74);
      var editorComponent$4 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
      var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var equiv$4 = $m_s_math_Equiv$String$();
      return editorComponent$4.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(key, label$4, state$4, optioner$4, ev$5, explainError$4, equiv$4)
    })));
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$80 = $m_Lscalacss_ScalaCssReact$();
    var s$3 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_selectorLabelContainer;
    var $$x16 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$80, s$3);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x15 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Liste");
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$85 = $m_Lscalacss_ScalaCssReact$();
    var s$4 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_selector;
    var $$x13 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$85, s$4);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as$1 = $n(s).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
    var $$x6 = $n($$x7).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((termRef$2) => {
      var termRef = $as_Lreactbuild_common_model_RefTo(termRef$2);
      var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x11 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + termRef), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$89 = $n($n($n($n(p).context__Lreactbuild_analyze_cost_modules_EditListEntry$Context()).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termMap).get__O__s_Option(termRef));
      if (this$89.isEmpty__Z()) {
        var $$x9 = "?"
      } else {
        var arg1$1 = this$89.get__O();
        var x$69 = $as_Lreactbuild_model_Term(arg1$1);
        var $$x9 = $n(x$69).Lreactbuild_model_Term__f_label
      };
      var v$1 = $as_T($$x9);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x10 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
      var $$x8 = $m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.remove__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_callback_Trampoline(termRef));
      var array$2 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_delete, "", "24px")];
      var array$3 = [$$x11, $$x10, $n($$x8).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
      return $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    })));
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("add", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ajouter une liste");
    var state$5 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend__f_addTerm;
    var optioner$5 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var this$103 = $m_Lreactbuild_model_Implicits$();
    var ev$6 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$18(this$103, proxy, organization);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$104 = $m_Lreactbuild_model_Implicits$();
    var helper$4 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$18(this$104, proxy, organization);
    var editorComponent$5 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$4);
    var explainError$5 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var this$107 = $m_s_math_Equiv$();
    var equiv$5 = this$107.universal__s_math_Equiv();
    var array$4 = [$$x4, editorComponent$5.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$5, state$5, optioner$5, ev$6, explainError$5, equiv$5)];
    var array$5 = [$$x13, $$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var array$6 = [$$x16, $$x15, $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var $$x3 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    var $$x2 = $m_Lcom_iz2use_react_components_Button$().submit__Ljapgolly_scalajs_react_vdom_TagOf();
    var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Enregistrer"))];
    var array$8 = [$$x37, $$x35, $$x25, $$x18, $$x3, $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
    return $n($$x38).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("form", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  })));
  var this$127 = $n(u);
  var n = this$127.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
function $as_Lreactbuild_analyze_cost_modules_EditListEntry$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditListEntry$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditListEntry$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$Backend: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$Backend", {
  Lreactbuild_analyze_cost_modules_EditListEntry$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditPerson$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_EditPerson$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_EditPerson$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_EditPerson$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_EditPerson$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditPerson$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditPerson$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditPerson$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_EditPerson$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditPerson$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_EditPerson$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend.prototype.render__Lreactbuild_analyze_cost_modules_EditPerson$Props__Lreactbuild_analyze_cost_modules_EditPerson$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_proxy;
  var state = $n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot;
  var v = $as_Lreactbuild_person_Person($n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var x1$3 = $as_T2($n($m_Lreactbuild_analyze_cost_modules_person_package$().Lreactbuild_analyze_cost_modules_person_package$__f_facetModifiers).foldLeft__O__F2__O($ct_T2__O__O__(new $c_T2(), $m_s_package$().s_package$__f_Nil, $m_s_package$().s_package$__f_Nil), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    var x1$1 = $as_Lreactbuild_analyze_cost_modules_person_package$FacetModifier(x1$1$2);
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
    var p2 = $as_T2(x1.T2__f__1);
    var modifier = $as_Lreactbuild_analyze_cost_modules_person_package$FacetModifier(x1.T2__f__2);
    if ((p2 !== null)) {
      var editors = $as_sci_Seq($n(p2)._1__O());
      var adders = $as_sci_Seq($n(p2)._2__O());
      if ((modifier !== null)) {
        var x1$2 = $n($n(v).Lreactbuild_person_Person__f_facets).get__s_reflect_ClassTag__s_Option($n(modifier).Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_classTag);
        if ((x1$2 instanceof $c_s_Some)) {
          var x2 = $as_s_Some(x1$2);
          var facet = $as_Lreactbuild_person_Facet($n(x2).s_Some__f_value);
          var this$4 = $n(editors);
          var elem = $ct_T2__O__O__(new $c_T2(), modifier, facet);
          return $ct_T2__O__O__(new $c_T2(), this$4.appended__O__O(elem), adders)
        } else {
          var x = $m_s_None$();
          if ((x === x1$2)) {
            var this$5 = $n(adders);
            return $ct_T2__O__O__(new $c_T2(), editors, this$5.appended__O__O(modifier))
          } else {
            throw new $c_s_MatchError(x1$2)
          }
        }
      }
    };
    throw new $c_s_MatchError(x1)
  }))));
  if ((x1$3 !== null)) {
    var facetEditors = $as_sci_Seq($n(x1$3)._1__O());
    var facetAdders = $as_sci_Seq($n(x1$3)._2__O());
    var x$10 = $ct_T2__O__O__(new $c_T2(), facetEditors, facetAdders)
  } else {
    var x$10;
    throw new $c_s_MatchError(x1$3)
  };
  var facetEditors$2 = $as_sci_Seq($n(x$10)._1__O());
  var facetAdders$2 = $as_sci_Seq($n(x$10)._2__O());
  var x1$3$2 = $as_T2($n($m_Lreactbuild_analyze_cost_modules_person_package$().Lreactbuild_analyze_cost_modules_person_package$__f_addressDetailsModifiers).foldLeft__O__F2__O($ct_T2__O__O__(new $c_T2(), $m_s_package$().s_package$__f_Nil, $m_s_package$().s_package$__f_Nil), new $c_sjsr_AnonFunction2(((x0$2$2, x1$2$2) => {
    var x0$2 = $as_T2(x0$2$2);
    var x1$2$1 = $as_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier(x1$2$2);
    var x1$4 = $ct_T2__O__O__(new $c_T2(), x0$2, x1$2$1);
    var p2$1 = $as_T2(x1$4.T2__f__1);
    var modifier$1 = $as_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier(x1$4.T2__f__2);
    if ((p2$1 !== null)) {
      var editors$1 = $as_sci_Seq($n(p2$1)._1__O());
      var adders$1 = $as_sci_Seq($n(p2$1)._2__O());
      if ((modifier$1 !== null)) {
        var x1$3$1 = $as_sci_Seq($n($n(v).Lreactbuild_person_Person__f_addresses).collect__s_PartialFunction__O(new $c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1(this, modifier$1)));
        if ((x1$3$1 !== null)) {
          $n($m_s_package$().s_package$__f_Seq);
          if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x1$3$1), true) && ($n(x1$3$1).lengthCompare__I__I(0) === 0))) {
            var this$10 = $n(adders$1);
            return $ct_T2__O__O__(new $c_T2(), editors$1, this$10.appended__O__O(modifier$1))
          }
        };
        var this$13 = $n(editors$1);
        var elem$1 = $ct_T2__O__O__(new $c_T2(), modifier$1, x1$3$1);
        return $ct_T2__O__O__(new $c_T2(), this$13.appended__O__O(elem$1), adders$1)
      }
    };
    throw new $c_s_MatchError(x1$4)
  }))));
  if ((x1$3$2 !== null)) {
    var addressDetailsEditors = $as_sci_Seq($n(x1$3$2)._1__O());
    var addressDetailsAdders = $as_sci_Seq($n(x1$3$2)._2__O());
    var x$11 = $ct_T2__O__O__(new $c_T2(), addressDetailsEditors, addressDetailsAdders)
  } else {
    var x$11;
    throw new $c_s_MatchError(x1$3$2)
  };
  var addressDetailsEditors$2 = $as_sci_Seq($n(x$11)._1__O());
  var addressDetailsAdders$2 = $as_sci_Seq($n(x$11)._2__O());
  var $$x54 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x53 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$18 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX");
  var $$x52 = this$18.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x51 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$21 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x50 = this$21.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$22 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x49 = this$22.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x48 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$24 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$());
  var $$x47 = this$24.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("wrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var u = $m_Lreactbuild_components_ImageEditor$().apply__s_Option__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n($as_Lreactbuild_person_Person($n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_person_Person__f_imageUrl);
  var this$26 = $n(u);
  var n = this$26.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x46 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Code (nom abr\u00e9g\u00e9 pour faciliter la recherche)");
  var state$1 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12 = $as_Lreactbuild_person_Person(x$12$2);
    return $n(x$12).Lreactbuild_person_Person__f_code
  })), new $c_sjsr_AnonFunction1(((v$2$2) => {
    var v$2 = $as_s_Option(v$2$2);
    return new $c_sjsr_AnonFunction1(((x$13$2) => {
      var x$13 = $as_Lreactbuild_person_Person(x$13$2);
      var this$30 = $n(x$13);
      var x$2 = this$30.Lreactbuild_person_Person__f__id;
      var this$31 = $n(x$13);
      var x$3 = this$31.Lreactbuild_person_Person__f_organization;
      var this$32 = $n(x$13);
      var x$4 = this$32.Lreactbuild_person_Person__f_name;
      var this$33 = $n(x$13);
      var x$5 = this$33.Lreactbuild_person_Person__f_facets;
      var this$34 = $n(x$13);
      var x$6 = this$34.Lreactbuild_person_Person__f_addresses;
      var this$35 = $n(x$13);
      var x$7 = this$35.Lreactbuild_person_Person__f_parent;
      var this$36 = $n(x$13);
      var x$8 = this$36.Lreactbuild_person_Person__f_imageUrl;
      $n(x$13);
      return new $c_Lreactbuild_person_Person(x$2, x$3, x$4, v$2, x$5, x$6, x$7, x$8)
    }))
  })));
  var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  $m_Lcom_iz2use_common_Parsable$();
  var ev = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev);
  var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$42 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$42);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv = $m_s_math_Equiv$String$();
  var equiv = new $c_s_math_Equiv$OptionEquiv(eqv);
  var $$x45 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state$1, optioner, ev$1, explainError, equiv);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Nom");
  var state$2 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$14$2) => {
    var x$14 = $as_Lreactbuild_person_Person(x$14$2);
    return $n(x$14).Lreactbuild_person_Person__f_name
  })), new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_T(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$15$2) => {
      var x$15 = $as_Lreactbuild_person_Person(x$15$2);
      var this$49 = $n(x$15);
      var x$10$1 = this$49.Lreactbuild_person_Person__f__id;
      var this$50 = $n(x$15);
      var x$11$1 = this$50.Lreactbuild_person_Person__f_organization;
      var this$51 = $n(x$15);
      var x$12$1 = this$51.Lreactbuild_person_Person__f_code;
      var this$52 = $n(x$15);
      var x$13$1 = this$52.Lreactbuild_person_Person__f_facets;
      var this$53 = $n(x$15);
      var x$14$1 = this$53.Lreactbuild_person_Person__f_addresses;
      var this$54 = $n(x$15);
      var x$15$2$1 = this$54.Lreactbuild_person_Person__f_parent;
      var this$55 = $n(x$15);
      var x$16 = this$55.Lreactbuild_person_Person__f_imageUrl;
      $n(x$15);
      return new $c_Lreactbuild_person_Person(x$10$1, x$11$1, v$3, x$12$1, x$13$1, x$14$1, x$15$2$1, x$16)
    }))
  })));
  var evDefault$1 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  var parser$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$59 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$59);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$1 = $m_s_math_Equiv$String$();
  var $$x44 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$2, optioner$1, ev$2, explainError$1, equiv$1);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Parent");
  var state$3 = $n(state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$16$2) => {
    var x$16$1 = $as_Lreactbuild_person_Person(x$16$2);
    return $n(x$16$1).Lreactbuild_person_Person__f_parent
  })), new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4 = $as_s_Option(v$4$2);
    return new $c_sjsr_AnonFunction1(((x$17$2) => {
      var x$17 = $as_Lreactbuild_person_Person(x$17$2);
      var this$65 = $n(x$17);
      var x$18 = this$65.Lreactbuild_person_Person__f__id;
      var this$66 = $n(x$17);
      var x$19 = this$66.Lreactbuild_person_Person__f_organization;
      var this$67 = $n(x$17);
      var x$20 = this$67.Lreactbuild_person_Person__f_name;
      var this$68 = $n(x$17);
      var x$21 = this$68.Lreactbuild_person_Person__f_code;
      var this$69 = $n(x$17);
      var x$22 = this$69.Lreactbuild_person_Person__f_facets;
      var this$70 = $n(x$17);
      var x$23 = this$70.Lreactbuild_person_Person__f_addresses;
      var this$71 = $n(x$17);
      var x$24 = this$71.Lreactbuild_person_Person__f_imageUrl;
      $n(x$17);
      return new $c_Lreactbuild_person_Person(x$18, x$19, x$20, x$21, x$22, x$23, v$4, x$24)
    }))
  })));
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$75 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization = $m_s_None$();
  var ev$4 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$75, proxy, organization);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$77 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization$1 = $m_s_None$();
  var helper$2 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$77, proxy, organization$1);
  var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
  var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$81 = $m_Lreactbuild_model_Implicits$();
  var this$80 = $m_Lreactbuild_model_Implicits$();
  var ev$3 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$80, proxy);
  var equiv$2 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$81, ev$3);
  var array = [$$x50, $$x49, $$x48, $$x47, $$x46, $$x45, $$x44, editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$3, optioner$2, ev$4, explainError$2, equiv$2)];
  var $$x43 = $n($$x51).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x42 = $m_Lcom_iz2use_react_components_SideBySideLayout$();
  var this$86 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x41 = this$86.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("stretch", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$110 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var ns = $as_sci_Seq($n(facetEditors$2).map__F1__O(new $c_sjsr_AnonFunction1(((x0$3$2) => {
    var x0$3 = $as_T2(x0$3$2);
    if ((x0$3 !== null)) {
      var modifier$2 = $as_Lreactbuild_analyze_cost_modules_person_package$FacetModifier($n(x0$3)._1__O());
      var facet$1 = $as_Lreactbuild_person_Facet($n(x0$3)._2__O());
      var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x38 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("fit-content", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(modifier$2).Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_label;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var x$25 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
      var x$26 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var x$27 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
      var x$28 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
      var $$x37 = $m_sci_Seq$();
      var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [$as_Ljapgolly_scalajs_react_vdom_TagMod($n($n(modifier$2).Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_editing).apply__O__O($m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), facet$1), new $c_sjsr_AnonFunction2(((x0$4$2, x1$3$2$1) => {
        var x0$4 = $as_s_Option(x0$4$2);
        var x1$3$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3$2$1)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1$5 = $ct_T2__O__O__(new $c_T2(), x0$4, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3$3));
        matchEnd8: {
          var $$x35;
          var p2$2 = $as_s_Option(x1$5.T2__f__1);
          if ((p2$2 instanceof $c_s_Some)) {
            var x3 = $as_s_Some(p2$2);
            var newState = $as_Lreactbuild_person_Facet($n(x3).s_Some__f_value);
            if ((newState !== null)) {
              var this$100 = $n($n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot);
              var mod = new $c_sjsr_AnonFunction1(((x$18$2) => {
                var x$18$1 = $as_Lreactbuild_person_Person(x$18$2);
                return $n(x$18$1).updateFacet__F1__s_reflect_ClassTag__Lreactbuild_person_Person(new $c_sjsr_AnonFunction1(((x$19$2) => {
                  $as_Lreactbuild_person_Facet(x$19$2);
                  return newState
                })), $n(modifier$2).Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_classTag)
              }));
              var $$x35 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$100, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
              break matchEnd8
            }
          };
          var p5 = $as_s_Option(x1$5.T2__f__1);
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$5.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x$1 = $m_s_None$();
          if ((x$1 === p5)) {
            var $$x35 = cb;
            break matchEnd8
          };
          throw new $c_s_MatchError(x1$5)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x35)
      })))))];
      var array$2 = [$n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
      var x$29 = $as_sci_Seq($n($$x37).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
      var array$3 = [$$x38, $m_Lcom_iz2use_react_components_Card$().apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(x$25, x$27, x$28, x$26, x$29)];
      return $n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    } else {
      throw new $c_s_MatchError(x0$3)
    }
  }))));
  var $$x40 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$110, null, ns);
  var this$191 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var ns$1 = $as_sci_Seq($n(addressDetailsEditors$2).map__F1__O(new $c_sjsr_AnonFunction1(((x0$5$2) => {
    var x0$5 = $as_T2(x0$5$2);
    if ((x0$5 !== null)) {
      var modifier$3 = $as_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier($n(x0$5)._1__O());
      var addresses = $as_sci_Seq($n(x0$5)._2__O());
      var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x32 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("fit-content", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$5 = $n(modifier$3).Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_label;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var x$41 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5);
      var x$42 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x17 = $m_Lcom_iz2use_react_components_Link$();
      var this$130 = $n($n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot);
      var mod$1 = new $c_sjsr_AnonFunction1(((s$2) => {
        var s$1 = $as_Lreactbuild_person_Person(s$2);
        var this$121 = $n($n(s$1).Lreactbuild_person_Person__f_addresses);
        var x$30 = $as_Lreactbuild_person_AddressDetails($n($n(modifier$3).Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_empty).apply__O());
        $m_Lreactbuild_person_Address$();
        var x$31 = $m_ju_UUID$().randomUUID__ju_UUID();
        $m_Lreactbuild_person_Address$();
        var x$32 = $m_s_None$();
        var elem$2 = new $c_Lreactbuild_person_Address(x$31, x$30, x$32);
        var x$33 = $as_sci_Seq(this$121.appended__O__O(elem$2));
        var this$122 = $n(s$1);
        var x$34 = this$122.Lreactbuild_person_Person__f__id;
        var this$123 = $n(s$1);
        var x$35 = this$123.Lreactbuild_person_Person__f_organization;
        var this$124 = $n(s$1);
        var x$36 = this$124.Lreactbuild_person_Person__f_name;
        var this$125 = $n(s$1);
        var x$37 = this$125.Lreactbuild_person_Person__f_code;
        var this$126 = $n(s$1);
        var x$38 = this$126.Lreactbuild_person_Person__f_facets;
        var this$127 = $n(s$1);
        var x$39 = this$127.Lreactbuild_person_Person__f_parent;
        var this$128 = $n(s$1);
        var x$40 = this$128.Lreactbuild_person_Person__f_imageUrl;
        $n(s$1);
        return new $c_Lreactbuild_person_Person(x$34, x$35, x$36, x$37, x$38, x$33, x$39, x$40)
      }));
      var $$x16 = $n($n($$x17).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$130, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
      var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ajouter"))];
      var x$43 = $n($$x16).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
      var x$44 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
      var $$x31 = $m_sci_Seq$();
      var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$7 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), addresses), new $c_sjsr_AnonFunction1(((address$2) => {
        var address = $as_Lreactbuild_person_Address(address$2);
        var updater = new $c_sjsr_AnonFunction1(((f$2) => {
          var f = $as_F1(f$2);
          var this$149 = $n($n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot);
          var mod$2 = new $c_sjsr_AnonFunction1(((s$2$1) => {
            var s$3 = $as_Lreactbuild_person_Person(s$2$1);
            var $$x18 = $n(s$3).Lreactbuild_person_Person__f_addresses;
            var this$140 = $n($n(s$3).Lreactbuild_person_Person__f_addresses);
            var x$45 = $as_sci_Seq($n($$x18).updated__I__O__O(this$140.indexOf__O__I__I(address, 0), $n(f).apply__O__O(address)));
            var this$141 = $n(s$3);
            var x$46 = this$141.Lreactbuild_person_Person__f__id;
            var this$142 = $n(s$3);
            var x$47 = this$142.Lreactbuild_person_Person__f_organization;
            var this$143 = $n(s$3);
            var x$48 = this$143.Lreactbuild_person_Person__f_name;
            var this$144 = $n(s$3);
            var x$49 = this$144.Lreactbuild_person_Person__f_code;
            var this$145 = $n(s$3);
            var x$50 = this$145.Lreactbuild_person_Person__f_facets;
            var this$146 = $n(s$3);
            var x$51 = this$146.Lreactbuild_person_Person__f_parent;
            var this$147 = $n(s$3);
            var x$52 = this$147.Lreactbuild_person_Person__f_imageUrl;
            $n(s$3);
            return new $c_Lreactbuild_person_Person(x$46, x$47, x$48, x$49, x$50, x$45, x$51, x$52)
          }));
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$149, mod$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        }));
        var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$152 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
        var $$x28 = this$152.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        var this$153 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
        var $$x27 = this$153.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        var $$x25 = $n(modifier$3).Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_editing;
        var $$x24 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
        $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
        var value = $n(address).Lreactbuild_person_Address__f_details;
        var $$x23 = $as_Ljapgolly_scalajs_react_vdom_TagMod($n($$x25).apply__O__O($n($$x24).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$6$2, x1$4$2) => {
          var x0$6 = $as_s_Option(x0$6$2);
          var x1$4$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$4$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x1$6 = $ct_T2__O__O__(new $c_T2(), x0$6, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$4$1));
          matchEnd8$1: {
            var $$x26;
            var p2$3 = $as_s_Option(x1$6.T2__f__1);
            if ((p2$3 instanceof $c_s_Some)) {
              var x3$1 = $as_s_Some(p2$3);
              var newState$1 = $as_Lreactbuild_person_AddressDetails($n(x3$1).s_Some__f_value);
              if ((newState$1 !== null)) {
                var $$x26 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(updater.apply__O__O(new $c_sjsr_AnonFunction1(((x$20$2) => {
                  var x$20$1 = $as_Lreactbuild_person_Address(x$20$2);
                  var this$155 = $n(x$20$1);
                  var x$54 = this$155.Lreactbuild_person_Address__f_id;
                  var this$156 = $n(x$20$1);
                  var x$55 = this$156.Lreactbuild_person_Address__f_usage;
                  $n(x$20$1);
                  return new $c_Lreactbuild_person_Address(x$54, newState$1, x$55)
                }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
                break matchEnd8$1
              }
            };
            var p5$1 = $as_s_Option(x1$6.T2__f__1);
            var cb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$6.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var x$9 = $m_s_None$();
            if ((x$9 === p5$1)) {
              var $$x26 = cb$1;
              break matchEnd8$1
            };
            throw new $c_s_MatchError(x1$6)
          };
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x26)
        })))));
        var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$160 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignSelf__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$());
        var $$x21 = this$160.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Usage (mobile/accueil/service atelier/...)");
        var $$x19 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
        $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
        var value$1 = $n(address).Lreactbuild_person_Address__f_usage;
        var state$4 = $n($$x19).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$1, new $c_sjsr_AnonFunction2(((x0$7$2, x1$5$2) => {
          var x0$7 = $as_s_Option(x0$7$2);
          var x1$5$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$5$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x1$7 = $ct_T2__O__O__(new $c_T2(), x0$7, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$5$1));
          matchEnd7: {
            var $$x20;
            var p2$4 = $as_s_Option(x1$7.T2__f__1);
            var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$7.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var x$53 = $m_s_None$();
            if ((x$53 === p2$4)) {
              var $$x20 = cb$2;
              break matchEnd7
            };
            var p4 = $as_s_Option(x1$7.T2__f__1);
            var cb$2$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$7.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            if ((p4 instanceof $c_s_Some)) {
              var x5 = $as_s_Some(p4);
              var v$6 = $as_s_Option($n(x5).s_Some__f_value);
              var $$x20 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(updater.apply__O__O(new $c_sjsr_AnonFunction1(((x$21$2) => {
                var x$21$1 = $as_Lreactbuild_person_Address(x$21$2);
                var this$164 = $n(x$21$1);
                var x$57 = this$164.Lreactbuild_person_Address__f_id;
                var this$165 = $n(x$21$1);
                var x$58 = this$165.Lreactbuild_person_Address__f_details;
                $n(x$21$1);
                return new $c_Lreactbuild_person_Address(x$57, x$58, v$6)
              }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2$1);
              break matchEnd7
            };
            throw new $c_s_MatchError(x1$7)
          };
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x20)
        })));
        var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
        var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$5);
        var ev$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
        $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
        var this$171 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
        var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$171);
        var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
        var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
        var eqv$1 = $m_s_math_Equiv$String$();
        var equiv$3 = new $c_s_math_Equiv$OptionEquiv(eqv$1);
        var array$5 = [$$x21, editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$4, optioner$3, ev$6, explainError$3, equiv$3)];
        var array$6 = [$$x28, $$x27, $$x23, $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
        return $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
      })))];
      var array$8 = [$n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
      var x$59 = $as_sci_Seq($n($$x31).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8)));
      var array$9 = [$$x32, $m_Lcom_iz2use_react_components_Card$().apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(x$41, x$44, x$43, x$42, x$59)];
      return $n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
    } else {
      throw new $c_s_MatchError(x0$5)
    }
  }))));
  var $$x34 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$191, null, ns$1);
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$194 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x14 = this$194.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x13 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("fit-content", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$203 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var ns$2 = $as_sci_Seq($n(facetAdders$2).map__F1__O(new $c_sjsr_AnonFunction1(((modifier$2$1) => {
    var modifier$4 = $as_Lreactbuild_analyze_cost_modules_person_package$FacetModifier(modifier$2$1);
    var $$x11 = $m_Lcom_iz2use_react_components_Link$();
    var this$197 = $n($n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot);
    var mod$3 = new $c_sjsr_AnonFunction1(((x$22$2) => {
      var x$22$1 = $as_Lreactbuild_person_Person(x$22$2);
      return $n(x$22$1).addFacet__Lreactbuild_person_Facet__s_reflect_ClassTag__Lreactbuild_person_Person($as_Lreactbuild_person_Facet($n($n(modifier$4).Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_empty).apply__O()), $n(modifier$4).Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_classTag)
    }));
    var $$x10 = $n($n($$x11).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$197, mod$3))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$7 = ("Ajouter le r\u00f4le " + $n(modifier$4).Lreactbuild_analyze_cost_modules_person_package$FacetModifier__f_label);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$10 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)];
    return $n($$x10).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))
  }))));
  var $$x12 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$203, null, ns$2);
  var this$221 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var ns$3 = $as_sci_Seq($n(addressDetailsAdders$2).map__F1__O(new $c_sjsr_AnonFunction1(((modifier$3$2) => {
    var modifier$3$1 = $as_Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier(modifier$3$2);
    var $$x9 = $m_Lcom_iz2use_react_components_Link$();
    var this$215 = $n($n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot);
    var mod$4 = new $c_sjsr_AnonFunction1(((s$2$2) => {
      var s$4 = $as_Lreactbuild_person_Person(s$2$2);
      var this$206 = $n($n(s$4).Lreactbuild_person_Person__f_addresses);
      var x$60 = $as_Lreactbuild_person_AddressDetails($n($n(modifier$3$1).Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_empty).apply__O());
      $m_Lreactbuild_person_Address$();
      var x$61 = $m_ju_UUID$().randomUUID__ju_UUID();
      $m_Lreactbuild_person_Address$();
      var x$62 = $m_s_None$();
      var elem$3 = new $c_Lreactbuild_person_Address(x$61, x$60, x$62);
      var x$63 = $as_sci_Seq(this$206.appended__O__O(elem$3));
      var this$207 = $n(s$4);
      var x$64 = this$207.Lreactbuild_person_Person__f__id;
      var this$208 = $n(s$4);
      var x$65 = this$208.Lreactbuild_person_Person__f_organization;
      var this$209 = $n(s$4);
      var x$66 = this$209.Lreactbuild_person_Person__f_name;
      var this$210 = $n(s$4);
      var x$67 = this$210.Lreactbuild_person_Person__f_code;
      var this$211 = $n(s$4);
      var x$68 = this$211.Lreactbuild_person_Person__f_facets;
      var this$212 = $n(s$4);
      var x$69 = this$212.Lreactbuild_person_Person__f_parent;
      var this$213 = $n(s$4);
      var x$70 = this$213.Lreactbuild_person_Person__f_imageUrl;
      $n(s$4);
      return new $c_Lreactbuild_person_Person(x$64, x$65, x$66, x$67, x$68, x$63, x$69, x$70)
    }));
    var $$x8 = $n($n($$x9).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$215, mod$4))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$8 = ("Ajouter " + $n(modifier$3$1).Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_label);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$11 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$8)];
    return $n($$x8).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
  }))));
  var array$12 = [$$x14, $$x13, $$x12, $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$221, null, ns$3)];
  var array$13 = [$$x40, $$x34, $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  var $$x7 = $n($$x42).apply__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x41, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
  var this$247 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var this$229 = $n($as_sc_MapOps($m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O($n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_proxy, new $c_sjsr_AnonFunction1(((x$23$2) => {
    var x$23$1 = $as_Lreactbuild_model_CommonData(x$23$2);
    return $n(x$23$1).Lreactbuild_model_CommonData__f_personAnnotations
  })), new $c_Lreactbuild_package$DefaultCommonData$$anon$2())));
  var x$56 = $n(v).Lreactbuild_person_Person__f__id;
  var default$1 = new $c_sjsr_AnonFunction1(((x$24$2) => {
    $as_Lreactbuild_common_model_RefTo(x$24$2);
    return $m_s_package$().s_package$__f_Nil
  }));
  var this$230 = $n($as_sc_SeqOps($f_sc_MapOps__applyOrElse__O__F1__O(this$229, x$56, default$1)));
  var elem$4 = $n(s).Lreactbuild_analyze_cost_modules_EditPerson$State__f_newPersonAnnotation;
  var ns$4 = $as_sci_Seq($n($as_sc_IterableOps(this$230.appended__O__O(elem$4))).map__F1__O(new $c_sjsr_AnonFunction1(((personAnnotation$2) => {
    var personAnnotation = $as_Lreactbuild_person_PersonAnnotation(personAnnotation$2);
    var this$231 = $n($n(personAnnotation).Lreactbuild_person_PersonAnnotation__f__id);
    var key = $m_sr_ScalaRunTime$()._toString__s_Product__T(this$231);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Annotation");
    var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value$2 = $n(personAnnotation).Lreactbuild_person_PersonAnnotation__f_label;
    var state$5 = $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$2, new $c_sjsr_AnonFunction2(((x0$8$2, x1$6$2) => {
      var x0$8 = $as_s_Option(x0$8$2);
      var x1$6$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$6$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$8 = $ct_T2__O__O__(new $c_T2(), x0$8, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$6$1));
      matchEnd7$1: {
        var $$x2;
        var p2$5 = $as_s_Option(x1$8.T2__f__1);
        var cb$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$8.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$71 = $m_s_None$();
        if ((x$71 === p2$5)) {
          var $$x2 = cb$3;
          break matchEnd7$1
        };
        var p4$1 = $as_s_Option(x1$8.T2__f__1);
        var cb$2$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$8.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4$1 instanceof $c_s_Some)) {
          var x5$1 = $as_s_Some(p4$1);
          var i = $as_T($n(x5$1).s_Some__f_value);
          var x$3$1 = $n($n(s).Lreactbuild_analyze_cost_modules_EditPerson$State__f_newPersonAnnotation).Lreactbuild_person_PersonAnnotation__f__id;
          var x$4$1 = $n(personAnnotation).Lreactbuild_person_PersonAnnotation__f__id;
          if (((x$3$1 === null) ? (x$4$1 === null) : $n(x$3$1).equals__O__Z(x$4$1))) {
            var this$235 = $n(this.Lreactbuild_analyze_cost_modules_EditPerson$Backend__f_$);
            var mod$5 = new $c_sjsr_AnonFunction1(((x$25$2) => {
              $as_Lreactbuild_analyze_cost_modules_EditPerson$State(x$25$2);
              return $n(p).deriveState__Lreactbuild_analyze_cost_modules_EditPerson$State()
            }));
            var ifNew = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$235, mod$5))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
          } else {
            var ifNew = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
          };
          var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var $$x3 = $n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_proxy;
          var this$236 = $n(personAnnotation);
          var x$72 = this$236.Lreactbuild_person_PersonAnnotation__f__id;
          var this$237 = $n(personAnnotation);
          var x$73 = this$237.Lreactbuild_person_PersonAnnotation__f_person;
          var this$238 = $n(personAnnotation);
          var x$74 = this$238.Lreactbuild_person_PersonAnnotation__f_created;
          var this$239 = $n(personAnnotation);
          var x$75 = this$239.Lreactbuild_person_PersonAnnotation__f_expired;
          $n(personAnnotation);
          var $$x2 = $n($$x5).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($$x4).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(ifNew, $n($$x3).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation(new $c_Lreactbuild_person_PersonAnnotation(x$72, x$73, i, x$74, x$75)), $m_Ldiode_Action$aType$())), cb$2$2);
          break matchEnd7$1
        };
        throw new $c_s_MatchError(x1$8)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
    })));
    var evDefault$3 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
    var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
    var parser$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$243 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$4 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$243);
    var editorComponent$4 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$4);
    var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$4 = $m_s_math_Equiv$String$();
    return editorComponent$4.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(key, label$4, state$5, optioner$4, ev$7, explainError$4, equiv$4)
  }))));
  var $$x6 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$247, null, ns$4);
  var u$1 = $m_Lreactbuild_person_PersonReferenceList$().apply__s_Option__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_s_Option$().apply__O__s_Option($n($as_Lreactbuild_person_Person($n($n(p).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_person_Person__f__id), $m_s_package$().s_package$__f_Nil);
  var this$249 = $n(u$1);
  var n$1 = this$249.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$14 = [$$x53, $$x52, $$x43, $$x7, $$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  return $n($$x54).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))
});
function $as_Lreactbuild_analyze_cost_modules_EditPerson$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditPerson$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditPerson$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditPerson$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditPerson$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditPerson$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditPerson$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditPerson$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditPerson$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditPerson$Backend: 0
}, false, "reactbuild.analyze.cost.modules.EditPerson$Backend", {
  Lreactbuild_analyze_cost_modules_EditPerson$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditPerson$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditProject$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_removeOrganization = null;
  this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_addOrganization = null;
  this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_removeOrganization = new $c_sjsr_AnonFunction1(((org$2) => {
    var org = $as_Lreactbuild_common_model_RefTo(org$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_analyze_cost_modules_EditProject$Props(p$2);
      var this$2 = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project);
      var callback = new $c_sjsr_AnonFunction0((() => {
        var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
      }));
      var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var s = $as_Lreactbuild_common_model_Project(arg1);
      var x$1$3 = $as_sci_Seq($n($n(s).Lreactbuild_common_model_Project__f_organizations).filterNot__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lreactbuild_common_model_RefTo(x$1$2);
        return ((x$1 === null) ? (org === null) : $n(x$1).equals__O__Z(org))
      }))));
      var this$6 = $n(s);
      var x$2 = this$6.Lreactbuild_common_model_Project__f__id;
      var this$7 = $n(s);
      var x$3 = this$7.Lreactbuild_common_model_Project__f_name;
      var this$8 = $n(s);
      var x$4 = this$8.Lreactbuild_common_model_Project__f_title;
      var this$9 = $n(s);
      var x$5 = this$9.Lreactbuild_common_model_Project__f_description;
      var this$10 = $n(s);
      var x$6 = this$10.Lreactbuild_common_model_Project__f_images;
      var this$11 = $n(s);
      var x$7 = this$11.Lreactbuild_common_model_Project__f_location;
      var this$12 = $n(s);
      var x$8 = this$12.Lreactbuild_common_model_Project__f_areas;
      var this$13 = $n(s);
      var x$9 = this$13.Lreactbuild_common_model_Project__f_price;
      var this$14 = $n(s);
      var x$10 = this$14.Lreactbuild_common_model_Project__f_soldOut;
      var this$15 = $n(s);
      var x$11 = this$15.Lreactbuild_common_model_Project__f_privacy;
      var this$16 = $n(s);
      var x$12 = this$16.Lreactbuild_common_model_Project__f_scenes;
      var this$17 = $n(s);
      var x$13 = this$17.Lreactbuild_common_model_Project__f_renderSettings;
      var this$18 = $n(s);
      var x$14 = this$18.Lreactbuild_common_model_Project__f_city;
      var this$19 = $n(s);
      var x$15 = this$19.Lreactbuild_common_model_Project__f_district;
      var this$20 = $n(s);
      var x$16 = this$20.Lreactbuild_common_model_Project__f_topic;
      var this$21 = $n(s);
      var x$17 = this$21.Lreactbuild_common_model_Project__f_modelSource;
      var this$22 = $n(s);
      var x$18 = this$22.Lreactbuild_common_model_Project__f_procedureState;
      var this$23 = $n(s);
      var x$19 = this$23.Lreactbuild_common_model_Project__f_summary;
      var this$24 = $n(s);
      var x$20 = this$24.Lreactbuild_common_model_Project__f_archived;
      var this$25 = $n(s);
      var x$21 = this$25.Lreactbuild_common_model_Project__f_parent;
      var this$26 = $n(s);
      var x$22 = this$26.Lreactbuild_common_model_Project__f_address;
      var this$27 = $n(s);
      var x$23 = this$27.Lreactbuild_common_model_Project__f_reference;
      $n(s);
      var arg1$1 = new $c_Lreactbuild_common_model_Project(x$2, x$1$3, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23);
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var f = new $c_sjsr_AnonFunction1(((x$2$2) => {
        $as_jl_Void(x$2$2)
      }));
      var this$30 = $n(this$);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$30, f))
    }))))
  }));
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f$2 = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var _2 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1);
    matchEnd8: {
      var $$x2;
      var cb = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((x0$1 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x0$1);
        var p4 = $as_s_Option($n(x3).s_Some__f_value);
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v = $as_Lreactbuild_common_model_RefTo($n(x5).s_Some__f_value);
          var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2$1) => {
            var p$1 = $as_Lreactbuild_analyze_cost_modules_EditProject$Props(p$2$1);
            var this$32 = $n($n(p$1).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project);
            var callback$1 = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
            var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
            var arg1$2 = this$32.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
            var s$1 = $as_Lreactbuild_common_model_Project(arg1$2);
            var this$33 = $n($n(s$1).Lreactbuild_common_model_Project__f_organizations);
            var x$24 = $as_sci_Seq(this$33.appended__O__O(v));
            var this$34 = $n(s$1);
            var x$25 = this$34.Lreactbuild_common_model_Project__f__id;
            var this$35 = $n(s$1);
            var x$26 = this$35.Lreactbuild_common_model_Project__f_name;
            var this$36 = $n(s$1);
            var x$27 = this$36.Lreactbuild_common_model_Project__f_title;
            var this$37 = $n(s$1);
            var x$28 = this$37.Lreactbuild_common_model_Project__f_description;
            var this$38 = $n(s$1);
            var x$29 = this$38.Lreactbuild_common_model_Project__f_images;
            var this$39 = $n(s$1);
            var x$30 = this$39.Lreactbuild_common_model_Project__f_location;
            var this$40 = $n(s$1);
            var x$31 = this$40.Lreactbuild_common_model_Project__f_areas;
            var this$41 = $n(s$1);
            var x$32 = this$41.Lreactbuild_common_model_Project__f_price;
            var this$42 = $n(s$1);
            var x$33 = this$42.Lreactbuild_common_model_Project__f_soldOut;
            var this$43 = $n(s$1);
            var x$34 = this$43.Lreactbuild_common_model_Project__f_privacy;
            var this$44 = $n(s$1);
            var x$35 = this$44.Lreactbuild_common_model_Project__f_scenes;
            var this$45 = $n(s$1);
            var x$36 = this$45.Lreactbuild_common_model_Project__f_renderSettings;
            var this$46 = $n(s$1);
            var x$37 = this$46.Lreactbuild_common_model_Project__f_city;
            var this$47 = $n(s$1);
            var x$38 = this$47.Lreactbuild_common_model_Project__f_district;
            var this$48 = $n(s$1);
            var x$39 = this$48.Lreactbuild_common_model_Project__f_topic;
            var this$49 = $n(s$1);
            var x$40 = this$49.Lreactbuild_common_model_Project__f_modelSource;
            var this$50 = $n(s$1);
            var x$41 = this$50.Lreactbuild_common_model_Project__f_procedureState;
            var this$51 = $n(s$1);
            var x$42 = this$51.Lreactbuild_common_model_Project__f_summary;
            var this$52 = $n(s$1);
            var x$43 = this$52.Lreactbuild_common_model_Project__f_archived;
            var this$53 = $n(s$1);
            var x$44 = this$53.Lreactbuild_common_model_Project__f_parent;
            var this$54 = $n(s$1);
            var x$45 = this$54.Lreactbuild_common_model_Project__f_address;
            var this$55 = $n(s$1);
            var x$46 = this$55.Lreactbuild_common_model_Project__f_reference;
            $n(s$1);
            var arg1$3 = new $c_Lreactbuild_common_model_Project(x$25, x$24, x$26, x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46);
            var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$32.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$3), callback$1, G$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var f$1 = new $c_sjsr_AnonFunction1(((x$3$2) => {
              $as_jl_Void(x$3$2)
            }));
            var this$58 = $n(this$$1);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$58, f$1))
          })));
          break matchEnd8
        }
      };
      var cb$2 = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x2 = cb$2
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  }));
  var $$x3 = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$2);
  var $$x1 = $m_s_None$();
  var this$61 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_addOrganization = $n($$x4).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($$x3, $$x1, this$61.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3))
}
$c_Lreactbuild_analyze_cost_modules_EditProject$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditProject$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditProject$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditProject$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditProject$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_EditProject$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_EditProject$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Backend.prototype.render__Lreactbuild_analyze_cost_modules_EditProject$Props__Lreactbuild_analyze_cost_modules_EditProject$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_pageProps).Lreactbuild_package$PageProps__f_proxy;
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Date);
    var this$3 = $m_Ljava_time_LocalDate$();
    return this$2.fromLocalDate__Ljava_time_LocalDate__Lreactbuild_common_model_Date(this$3.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId())))
  }));
  var dateRef = new $c_Lcom_iz2use_common_ParsingReference$Simple(f);
  var $$x41 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x40 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$10 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
  var $$x39 = this$10.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x38 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x37 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$14 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x36 = this$14.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$15 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x35 = this$15.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x34 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence");
  var state = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Lreactbuild_common_model_Project(x$4$2);
    return $n(x$4).Lreactbuild_common_model_Project__f_reference
  })), new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_T(v$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lreactbuild_common_model_Project(x$5$2);
      var this$19 = $n(x$5);
      var x$2 = this$19.Lreactbuild_common_model_Project__f__id;
      var this$20 = $n(x$5);
      var x$3 = this$20.Lreactbuild_common_model_Project__f_organizations;
      var this$21 = $n(x$5);
      var x$4$1 = this$21.Lreactbuild_common_model_Project__f_name;
      var this$22 = $n(x$5);
      var x$5$2$1 = this$22.Lreactbuild_common_model_Project__f_title;
      var this$23 = $n(x$5);
      var x$6 = this$23.Lreactbuild_common_model_Project__f_description;
      var this$24 = $n(x$5);
      var x$7 = this$24.Lreactbuild_common_model_Project__f_images;
      var this$25 = $n(x$5);
      var x$8 = this$25.Lreactbuild_common_model_Project__f_location;
      var this$26 = $n(x$5);
      var x$9 = this$26.Lreactbuild_common_model_Project__f_areas;
      var this$27 = $n(x$5);
      var x$10 = this$27.Lreactbuild_common_model_Project__f_price;
      var this$28 = $n(x$5);
      var x$11 = this$28.Lreactbuild_common_model_Project__f_soldOut;
      var this$29 = $n(x$5);
      var x$12 = this$29.Lreactbuild_common_model_Project__f_privacy;
      var this$30 = $n(x$5);
      var x$13 = this$30.Lreactbuild_common_model_Project__f_scenes;
      var this$31 = $n(x$5);
      var x$14 = this$31.Lreactbuild_common_model_Project__f_renderSettings;
      var this$32 = $n(x$5);
      var x$15 = this$32.Lreactbuild_common_model_Project__f_city;
      var this$33 = $n(x$5);
      var x$16 = this$33.Lreactbuild_common_model_Project__f_district;
      var this$34 = $n(x$5);
      var x$17 = this$34.Lreactbuild_common_model_Project__f_topic;
      var this$35 = $n(x$5);
      var x$18 = this$35.Lreactbuild_common_model_Project__f_modelSource;
      var this$36 = $n(x$5);
      var x$19 = this$36.Lreactbuild_common_model_Project__f_procedureState;
      var this$37 = $n(x$5);
      var x$20 = this$37.Lreactbuild_common_model_Project__f_summary;
      var this$38 = $n(x$5);
      var x$21 = this$38.Lreactbuild_common_model_Project__f_archived;
      var this$39 = $n(x$5);
      var x$22 = this$39.Lreactbuild_common_model_Project__f_parent;
      var this$40 = $n(x$5);
      var x$23 = this$40.Lreactbuild_common_model_Project__f_address;
      $n(x$5);
      return new $c_Lreactbuild_common_model_Project(x$2, x$3, x$4$1, x$5$2$1, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, v)
    }))
  })));
  var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$44 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$44);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv = $m_s_math_Equiv$String$();
  var $$x33 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Intitul\u00e9");
  var state$1 = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6$1 = $as_Lreactbuild_common_model_Project(x$6$2);
    return $n(x$6$1).Lreactbuild_common_model_Project__f_title
  })), new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_T(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7$1 = $as_Lreactbuild_common_model_Project(x$7$2);
      var this$50 = $n(x$7$1);
      var x$25 = this$50.Lreactbuild_common_model_Project__f__id;
      var this$51 = $n(x$7$1);
      var x$26 = this$51.Lreactbuild_common_model_Project__f_organizations;
      var this$52 = $n(x$7$1);
      var x$27 = this$52.Lreactbuild_common_model_Project__f_name;
      var this$53 = $n(x$7$1);
      var x$28 = this$53.Lreactbuild_common_model_Project__f_description;
      var this$54 = $n(x$7$1);
      var x$29 = this$54.Lreactbuild_common_model_Project__f_images;
      var this$55 = $n(x$7$1);
      var x$30 = this$55.Lreactbuild_common_model_Project__f_location;
      var this$56 = $n(x$7$1);
      var x$31 = this$56.Lreactbuild_common_model_Project__f_areas;
      var this$57 = $n(x$7$1);
      var x$32 = this$57.Lreactbuild_common_model_Project__f_price;
      var this$58 = $n(x$7$1);
      var x$33 = this$58.Lreactbuild_common_model_Project__f_soldOut;
      var this$59 = $n(x$7$1);
      var x$34 = this$59.Lreactbuild_common_model_Project__f_privacy;
      var this$60 = $n(x$7$1);
      var x$35 = this$60.Lreactbuild_common_model_Project__f_scenes;
      var this$61 = $n(x$7$1);
      var x$36 = this$61.Lreactbuild_common_model_Project__f_renderSettings;
      var this$62 = $n(x$7$1);
      var x$37 = this$62.Lreactbuild_common_model_Project__f_city;
      var this$63 = $n(x$7$1);
      var x$38 = this$63.Lreactbuild_common_model_Project__f_district;
      var this$64 = $n(x$7$1);
      var x$39 = this$64.Lreactbuild_common_model_Project__f_topic;
      var this$65 = $n(x$7$1);
      var x$40 = this$65.Lreactbuild_common_model_Project__f_modelSource;
      var this$66 = $n(x$7$1);
      var x$41 = this$66.Lreactbuild_common_model_Project__f_procedureState;
      var this$67 = $n(x$7$1);
      var x$42 = this$67.Lreactbuild_common_model_Project__f_summary;
      var this$68 = $n(x$7$1);
      var x$43 = this$68.Lreactbuild_common_model_Project__f_archived;
      var this$69 = $n(x$7$1);
      var x$44 = this$69.Lreactbuild_common_model_Project__f_parent;
      var this$70 = $n(x$7$1);
      var x$45 = this$70.Lreactbuild_common_model_Project__f_address;
      var this$71 = $n(x$7$1);
      var x$46 = this$71.Lreactbuild_common_model_Project__f_reference;
      $n(x$7$1);
      return new $c_Lreactbuild_common_model_Project(x$25, x$26, x$27, v$3, x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46)
    }))
  })));
  var evDefault$1 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  var parser$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$75 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$75);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$1 = $m_s_math_Equiv$String$();
  var $$x32 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$1, explainError$1, equiv$1);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Nom");
  var state$2 = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8$1 = $as_Lreactbuild_common_model_Project(x$8$2);
    return $n(x$8$1).Lreactbuild_common_model_Project__f_name
  })), new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4 = $as_T(v$4$2);
    return new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9$1 = $as_Lreactbuild_common_model_Project(x$9$2);
      var this$81 = $n(x$9$1);
      var x$48 = this$81.Lreactbuild_common_model_Project__f__id;
      var this$82 = $n(x$9$1);
      var x$49 = this$82.Lreactbuild_common_model_Project__f_organizations;
      var this$83 = $n(x$9$1);
      var x$50 = this$83.Lreactbuild_common_model_Project__f_title;
      var this$84 = $n(x$9$1);
      var x$51 = this$84.Lreactbuild_common_model_Project__f_description;
      var this$85 = $n(x$9$1);
      var x$52 = this$85.Lreactbuild_common_model_Project__f_images;
      var this$86 = $n(x$9$1);
      var x$53 = this$86.Lreactbuild_common_model_Project__f_location;
      var this$87 = $n(x$9$1);
      var x$54 = this$87.Lreactbuild_common_model_Project__f_areas;
      var this$88 = $n(x$9$1);
      var x$55 = this$88.Lreactbuild_common_model_Project__f_price;
      var this$89 = $n(x$9$1);
      var x$56 = this$89.Lreactbuild_common_model_Project__f_soldOut;
      var this$90 = $n(x$9$1);
      var x$57 = this$90.Lreactbuild_common_model_Project__f_privacy;
      var this$91 = $n(x$9$1);
      var x$58 = this$91.Lreactbuild_common_model_Project__f_scenes;
      var this$92 = $n(x$9$1);
      var x$59 = this$92.Lreactbuild_common_model_Project__f_renderSettings;
      var this$93 = $n(x$9$1);
      var x$60 = this$93.Lreactbuild_common_model_Project__f_city;
      var this$94 = $n(x$9$1);
      var x$61 = this$94.Lreactbuild_common_model_Project__f_district;
      var this$95 = $n(x$9$1);
      var x$62 = this$95.Lreactbuild_common_model_Project__f_topic;
      var this$96 = $n(x$9$1);
      var x$63 = this$96.Lreactbuild_common_model_Project__f_modelSource;
      var this$97 = $n(x$9$1);
      var x$64 = this$97.Lreactbuild_common_model_Project__f_procedureState;
      var this$98 = $n(x$9$1);
      var x$65 = this$98.Lreactbuild_common_model_Project__f_summary;
      var this$99 = $n(x$9$1);
      var x$66 = this$99.Lreactbuild_common_model_Project__f_archived;
      var this$100 = $n(x$9$1);
      var x$67 = this$100.Lreactbuild_common_model_Project__f_parent;
      var this$101 = $n(x$9$1);
      var x$68 = this$101.Lreactbuild_common_model_Project__f_address;
      var this$102 = $n(x$9$1);
      var x$69 = this$102.Lreactbuild_common_model_Project__f_reference;
      $n(x$9$1);
      return new $c_Lreactbuild_common_model_Project(x$48, x$49, v$4, x$50, x$51, x$52, x$53, x$54, x$55, x$56, x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$69)
    }))
  })));
  var evDefault$2 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
  var parser$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$106 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$106);
  var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
  var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$2 = $m_s_math_Equiv$String$();
  var $$x31 = editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$2, optioner$2, ev$2, explainError$2, equiv$2);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Adresse");
  var state$3 = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10$1 = $as_Lreactbuild_common_model_Project(x$10$2);
    return $n($n(x$10$1).Lreactbuild_common_model_Project__f_address).Lreactbuild_common_model_ProjectAddress__f_raw
  })), new $c_sjsr_AnonFunction1(((v$5$2) => {
    var v$5 = $as_s_Option(v$5$2);
    return new $c_sjsr_AnonFunction1(((s$2) => {
      var s$1 = $as_Lreactbuild_common_model_Project(s$2);
      var this$112 = $n($n(s$1).Lreactbuild_common_model_Project__f_address);
      var x$71 = this$112.Lreactbuild_common_model_ProjectAddress__f_country;
      var this$113 = $n($n(s$1).Lreactbuild_common_model_Project__f_address);
      var x$72 = this$113.Lreactbuild_common_model_ProjectAddress__f_parcels;
      var this$114 = $n($n(s$1).Lreactbuild_common_model_Project__f_address);
      var x$73 = this$114.Lreactbuild_common_model_ProjectAddress__f_coordinates;
      $n($n(s$1).Lreactbuild_common_model_Project__f_address);
      var x$74 = new $c_Lreactbuild_common_model_ProjectAddress(x$71, v$5, x$72, x$73);
      var this$116 = $n(s$1);
      var x$75 = this$116.Lreactbuild_common_model_Project__f__id;
      var this$117 = $n(s$1);
      var x$76 = this$117.Lreactbuild_common_model_Project__f_organizations;
      var this$118 = $n(s$1);
      var x$77 = this$118.Lreactbuild_common_model_Project__f_name;
      var this$119 = $n(s$1);
      var x$78 = this$119.Lreactbuild_common_model_Project__f_title;
      var this$120 = $n(s$1);
      var x$79 = this$120.Lreactbuild_common_model_Project__f_description;
      var this$121 = $n(s$1);
      var x$80 = this$121.Lreactbuild_common_model_Project__f_images;
      var this$122 = $n(s$1);
      var x$81 = this$122.Lreactbuild_common_model_Project__f_location;
      var this$123 = $n(s$1);
      var x$82 = this$123.Lreactbuild_common_model_Project__f_areas;
      var this$124 = $n(s$1);
      var x$83 = this$124.Lreactbuild_common_model_Project__f_price;
      var this$125 = $n(s$1);
      var x$84 = this$125.Lreactbuild_common_model_Project__f_soldOut;
      var this$126 = $n(s$1);
      var x$85 = this$126.Lreactbuild_common_model_Project__f_privacy;
      var this$127 = $n(s$1);
      var x$86 = this$127.Lreactbuild_common_model_Project__f_scenes;
      var this$128 = $n(s$1);
      var x$87 = this$128.Lreactbuild_common_model_Project__f_renderSettings;
      var this$129 = $n(s$1);
      var x$88 = this$129.Lreactbuild_common_model_Project__f_city;
      var this$130 = $n(s$1);
      var x$89 = this$130.Lreactbuild_common_model_Project__f_district;
      var this$131 = $n(s$1);
      var x$90 = this$131.Lreactbuild_common_model_Project__f_topic;
      var this$132 = $n(s$1);
      var x$91 = this$132.Lreactbuild_common_model_Project__f_modelSource;
      var this$133 = $n(s$1);
      var x$92 = this$133.Lreactbuild_common_model_Project__f_procedureState;
      var this$134 = $n(s$1);
      var x$93 = this$134.Lreactbuild_common_model_Project__f_summary;
      var this$135 = $n(s$1);
      var x$94 = this$135.Lreactbuild_common_model_Project__f_archived;
      var this$136 = $n(s$1);
      var x$95 = this$136.Lreactbuild_common_model_Project__f_parent;
      var this$137 = $n(s$1);
      var x$96 = this$137.Lreactbuild_common_model_Project__f_reference;
      $n(s$1);
      return new $c_Lreactbuild_common_model_Project(x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, x$84, x$85, x$86, x$87, x$88, x$89, x$90, x$91, x$92, x$93, x$94, x$95, x$74, x$96)
    }))
  })));
  var evDefault$3 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$3 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$3);
  var ev$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$143 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$143);
  var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
  var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv = $m_s_math_Equiv$String$();
  var equiv$3 = new $c_s_math_Equiv$OptionEquiv(eqv);
  var $$x30 = editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$3, optioner$3, ev$4, explainError$3, equiv$3);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Parent");
  var state$4 = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11$1 = $as_Lreactbuild_common_model_Project(x$11$2);
    return $n(x$11$1).Lreactbuild_common_model_Project__f_parent
  })), new $c_sjsr_AnonFunction1(((v$6$2) => {
    var v$6 = $as_s_Option(v$6$2);
    return new $c_sjsr_AnonFunction1(((x$12$2) => {
      var x$12$1 = $as_Lreactbuild_common_model_Project(x$12$2);
      var this$150 = $n(x$12$1);
      var x$98 = this$150.Lreactbuild_common_model_Project__f__id;
      var this$151 = $n(x$12$1);
      var x$99 = this$151.Lreactbuild_common_model_Project__f_organizations;
      var this$152 = $n(x$12$1);
      var x$100 = this$152.Lreactbuild_common_model_Project__f_name;
      var this$153 = $n(x$12$1);
      var x$101 = this$153.Lreactbuild_common_model_Project__f_title;
      var this$154 = $n(x$12$1);
      var x$102 = this$154.Lreactbuild_common_model_Project__f_description;
      var this$155 = $n(x$12$1);
      var x$103 = this$155.Lreactbuild_common_model_Project__f_images;
      var this$156 = $n(x$12$1);
      var x$104 = this$156.Lreactbuild_common_model_Project__f_location;
      var this$157 = $n(x$12$1);
      var x$105 = this$157.Lreactbuild_common_model_Project__f_areas;
      var this$158 = $n(x$12$1);
      var x$106 = this$158.Lreactbuild_common_model_Project__f_price;
      var this$159 = $n(x$12$1);
      var x$107 = this$159.Lreactbuild_common_model_Project__f_soldOut;
      var this$160 = $n(x$12$1);
      var x$108 = this$160.Lreactbuild_common_model_Project__f_privacy;
      var this$161 = $n(x$12$1);
      var x$109 = this$161.Lreactbuild_common_model_Project__f_scenes;
      var this$162 = $n(x$12$1);
      var x$110 = this$162.Lreactbuild_common_model_Project__f_renderSettings;
      var this$163 = $n(x$12$1);
      var x$111 = this$163.Lreactbuild_common_model_Project__f_city;
      var this$164 = $n(x$12$1);
      var x$112 = this$164.Lreactbuild_common_model_Project__f_district;
      var this$165 = $n(x$12$1);
      var x$113 = this$165.Lreactbuild_common_model_Project__f_topic;
      var this$166 = $n(x$12$1);
      var x$114 = this$166.Lreactbuild_common_model_Project__f_modelSource;
      var this$167 = $n(x$12$1);
      var x$115 = this$167.Lreactbuild_common_model_Project__f_procedureState;
      var this$168 = $n(x$12$1);
      var x$116 = this$168.Lreactbuild_common_model_Project__f_summary;
      var this$169 = $n(x$12$1);
      var x$117 = this$169.Lreactbuild_common_model_Project__f_archived;
      var this$170 = $n(x$12$1);
      var x$118 = this$170.Lreactbuild_common_model_Project__f_address;
      var this$171 = $n(x$12$1);
      var x$119 = this$171.Lreactbuild_common_model_Project__f_reference;
      $n(x$12$1);
      return new $c_Lreactbuild_common_model_Project(x$98, x$99, x$100, x$101, x$102, x$103, x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, x$112, x$113, x$114, x$115, x$116, x$117, v$6, x$118, x$119)
    }))
  })));
  var optioner$4 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$174 = $m_Lreactbuild_model_Implicits$();
  var ev$6 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$174, proxy);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$175 = $m_Lreactbuild_model_Implicits$();
  var helper$4 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$175, proxy);
  var editorComponent$4 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$4);
  var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$179 = $m_Lreactbuild_model_Implicits$();
  var this$178 = $m_Lreactbuild_model_Implicits$();
  var ev$5 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$178, proxy);
  var equiv$4 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$179, ev$5);
  var $$x29 = editorComponent$4.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$4, state$4, optioner$4, ev$6, explainError$4, equiv$4);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Archiv\u00e9 depuis");
  var state$5 = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13$1 = $as_Lreactbuild_common_model_Project(x$13$2);
    return $n(x$13$1).Lreactbuild_common_model_Project__f_archived
  })), new $c_sjsr_AnonFunction1(((v$7$2) => {
    var v$7 = $as_s_Option(v$7$2);
    return new $c_sjsr_AnonFunction1(((x$14$2) => {
      var x$14$1 = $as_Lreactbuild_common_model_Project(x$14$2);
      var this$183 = $n(x$14$1);
      var x$121 = this$183.Lreactbuild_common_model_Project__f__id;
      var this$184 = $n(x$14$1);
      var x$122 = this$184.Lreactbuild_common_model_Project__f_organizations;
      var this$185 = $n(x$14$1);
      var x$123 = this$185.Lreactbuild_common_model_Project__f_name;
      var this$186 = $n(x$14$1);
      var x$124 = this$186.Lreactbuild_common_model_Project__f_title;
      var this$187 = $n(x$14$1);
      var x$125 = this$187.Lreactbuild_common_model_Project__f_description;
      var this$188 = $n(x$14$1);
      var x$126 = this$188.Lreactbuild_common_model_Project__f_images;
      var this$189 = $n(x$14$1);
      var x$127 = this$189.Lreactbuild_common_model_Project__f_location;
      var this$190 = $n(x$14$1);
      var x$128 = this$190.Lreactbuild_common_model_Project__f_areas;
      var this$191 = $n(x$14$1);
      var x$129 = this$191.Lreactbuild_common_model_Project__f_price;
      var this$192 = $n(x$14$1);
      var x$130 = this$192.Lreactbuild_common_model_Project__f_soldOut;
      var this$193 = $n(x$14$1);
      var x$131 = this$193.Lreactbuild_common_model_Project__f_privacy;
      var this$194 = $n(x$14$1);
      var x$132 = this$194.Lreactbuild_common_model_Project__f_scenes;
      var this$195 = $n(x$14$1);
      var x$133 = this$195.Lreactbuild_common_model_Project__f_renderSettings;
      var this$196 = $n(x$14$1);
      var x$134 = this$196.Lreactbuild_common_model_Project__f_city;
      var this$197 = $n(x$14$1);
      var x$135 = this$197.Lreactbuild_common_model_Project__f_district;
      var this$198 = $n(x$14$1);
      var x$136 = this$198.Lreactbuild_common_model_Project__f_topic;
      var this$199 = $n(x$14$1);
      var x$137 = this$199.Lreactbuild_common_model_Project__f_modelSource;
      var this$200 = $n(x$14$1);
      var x$138 = this$200.Lreactbuild_common_model_Project__f_procedureState;
      var this$201 = $n(x$14$1);
      var x$139 = this$201.Lreactbuild_common_model_Project__f_summary;
      var this$202 = $n(x$14$1);
      var x$140 = this$202.Lreactbuild_common_model_Project__f_parent;
      var this$203 = $n(x$14$1);
      var x$141 = this$203.Lreactbuild_common_model_Project__f_address;
      var this$204 = $n(x$14$1);
      var x$142 = this$204.Lreactbuild_common_model_Project__f_reference;
      $n(x$14$1);
      return new $c_Lreactbuild_common_model_Project(x$121, x$122, x$123, x$124, x$125, x$126, x$127, x$128, x$129, x$130, x$131, x$132, x$133, x$134, x$135, x$136, x$137, x$138, x$139, v$7, x$140, x$141, x$142)
    }))
  })));
  var optioner$5 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$4 = $m_Lreactbuild_model_Implicits$().dateParsable__Lcom_iz2use_common_ParsingReference__Lcom_iz2use_common_Parsable(dateRef);
  var ev$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$208 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$5 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$208);
  var editorComponent$5 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$5);
  var explainError$5 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
  var $$x28 = editorComponent$5.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$5, state$5, optioner$5, ev$7, explainError$5, equiv$5);
  var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x26 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("pictures", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Photos"))];
  var $$x24 = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var u = $m_Lreactbuild_analyze_cost_modules_project_ProjectImageList$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$15$2) => {
    var x$15$1 = $as_Lreactbuild_common_model_Project(x$15$2);
    return $n(x$15$1).Lreactbuild_common_model_Project__f_images
  })), new $c_sjsr_AnonFunction1(((images$2) => {
    var images = $as_sci_Seq(images$2);
    return new $c_sjsr_AnonFunction1(((x$16$2) => {
      var x$16$1 = $as_Lreactbuild_common_model_Project(x$16$2);
      var this$221 = $n(x$16$1);
      var x$144 = this$221.Lreactbuild_common_model_Project__f__id;
      var this$222 = $n(x$16$1);
      var x$145 = this$222.Lreactbuild_common_model_Project__f_organizations;
      var this$223 = $n(x$16$1);
      var x$146 = this$223.Lreactbuild_common_model_Project__f_name;
      var this$224 = $n(x$16$1);
      var x$147 = this$224.Lreactbuild_common_model_Project__f_title;
      var this$225 = $n(x$16$1);
      var x$148 = this$225.Lreactbuild_common_model_Project__f_description;
      var this$226 = $n(x$16$1);
      var x$149 = this$226.Lreactbuild_common_model_Project__f_location;
      var this$227 = $n(x$16$1);
      var x$150 = this$227.Lreactbuild_common_model_Project__f_areas;
      var this$228 = $n(x$16$1);
      var x$151 = this$228.Lreactbuild_common_model_Project__f_price;
      var this$229 = $n(x$16$1);
      var x$152 = this$229.Lreactbuild_common_model_Project__f_soldOut;
      var this$230 = $n(x$16$1);
      var x$153 = this$230.Lreactbuild_common_model_Project__f_privacy;
      var this$231 = $n(x$16$1);
      var x$154 = this$231.Lreactbuild_common_model_Project__f_scenes;
      var this$232 = $n(x$16$1);
      var x$155 = this$232.Lreactbuild_common_model_Project__f_renderSettings;
      var this$233 = $n(x$16$1);
      var x$156 = this$233.Lreactbuild_common_model_Project__f_city;
      var this$234 = $n(x$16$1);
      var x$157 = this$234.Lreactbuild_common_model_Project__f_district;
      var this$235 = $n(x$16$1);
      var x$158 = this$235.Lreactbuild_common_model_Project__f_topic;
      var this$236 = $n(x$16$1);
      var x$159 = this$236.Lreactbuild_common_model_Project__f_modelSource;
      var this$237 = $n(x$16$1);
      var x$160 = this$237.Lreactbuild_common_model_Project__f_procedureState;
      var this$238 = $n(x$16$1);
      var x$161 = this$238.Lreactbuild_common_model_Project__f_summary;
      var this$239 = $n(x$16$1);
      var x$162 = this$239.Lreactbuild_common_model_Project__f_archived;
      var this$240 = $n(x$16$1);
      var x$163 = this$240.Lreactbuild_common_model_Project__f_parent;
      var this$241 = $n(x$16$1);
      var x$164 = this$241.Lreactbuild_common_model_Project__f_address;
      var this$242 = $n(x$16$1);
      var x$165 = this$242.Lreactbuild_common_model_Project__f_reference;
      $n(x$16$1);
      return new $c_Lreactbuild_common_model_Project(x$144, x$145, x$146, x$147, x$148, images, x$149, x$150, x$151, x$152, x$153, x$154, x$155, x$156, x$157, x$158, x$159, x$160, x$161, x$162, x$163, x$164, x$165)
    }))
  }))));
  var this$245 = $n(u);
  var n = this$245.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$1 = [$$x26, $$x24, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  var $$x23 = $n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Synth\u00e8se mod\u00e8le SVG");
  var state$6 = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$17$2) => {
    var x$17$1 = $as_Lreactbuild_common_model_Project(x$17$2);
    return $n(x$17$1).Lreactbuild_common_model_Project__f_summary
  })), new $c_sjsr_AnonFunction1(((v$8$2) => {
    var v$8 = $as_s_Option(v$8$2);
    return new $c_sjsr_AnonFunction1(((x$18$2) => {
      var x$18$1 = $as_Lreactbuild_common_model_Project(x$18$2);
      var this$252 = $n(x$18$1);
      var x$167 = this$252.Lreactbuild_common_model_Project__f__id;
      var this$253 = $n(x$18$1);
      var x$168 = this$253.Lreactbuild_common_model_Project__f_organizations;
      var this$254 = $n(x$18$1);
      var x$169 = this$254.Lreactbuild_common_model_Project__f_name;
      var this$255 = $n(x$18$1);
      var x$170 = this$255.Lreactbuild_common_model_Project__f_title;
      var this$256 = $n(x$18$1);
      var x$171 = this$256.Lreactbuild_common_model_Project__f_description;
      var this$257 = $n(x$18$1);
      var x$172 = this$257.Lreactbuild_common_model_Project__f_images;
      var this$258 = $n(x$18$1);
      var x$173 = this$258.Lreactbuild_common_model_Project__f_location;
      var this$259 = $n(x$18$1);
      var x$174 = this$259.Lreactbuild_common_model_Project__f_areas;
      var this$260 = $n(x$18$1);
      var x$175 = this$260.Lreactbuild_common_model_Project__f_price;
      var this$261 = $n(x$18$1);
      var x$176 = this$261.Lreactbuild_common_model_Project__f_soldOut;
      var this$262 = $n(x$18$1);
      var x$177 = this$262.Lreactbuild_common_model_Project__f_privacy;
      var this$263 = $n(x$18$1);
      var x$178 = this$263.Lreactbuild_common_model_Project__f_scenes;
      var this$264 = $n(x$18$1);
      var x$179 = this$264.Lreactbuild_common_model_Project__f_renderSettings;
      var this$265 = $n(x$18$1);
      var x$180 = this$265.Lreactbuild_common_model_Project__f_city;
      var this$266 = $n(x$18$1);
      var x$181 = this$266.Lreactbuild_common_model_Project__f_district;
      var this$267 = $n(x$18$1);
      var x$182 = this$267.Lreactbuild_common_model_Project__f_topic;
      var this$268 = $n(x$18$1);
      var x$183 = this$268.Lreactbuild_common_model_Project__f_modelSource;
      var this$269 = $n(x$18$1);
      var x$184 = this$269.Lreactbuild_common_model_Project__f_procedureState;
      var this$270 = $n(x$18$1);
      var x$185 = this$270.Lreactbuild_common_model_Project__f_archived;
      var this$271 = $n(x$18$1);
      var x$186 = this$271.Lreactbuild_common_model_Project__f_parent;
      var this$272 = $n(x$18$1);
      var x$187 = this$272.Lreactbuild_common_model_Project__f_address;
      var this$273 = $n(x$18$1);
      var x$188 = this$273.Lreactbuild_common_model_Project__f_reference;
      $n(x$18$1);
      return new $c_Lreactbuild_common_model_Project(x$167, x$168, x$169, x$170, x$171, x$172, x$173, x$174, x$175, x$176, x$177, x$178, x$179, x$180, x$181, x$182, x$183, x$184, v$8, x$185, x$186, x$187, x$188)
    }))
  })));
  var optioner$6 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableMultiline;
  var ev$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
  var editorComponent$6 = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_multilineComponent;
  var explainError$6 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$278 = $m_s_math_Equiv$();
  var equiv$6 = this$278.universal__s_math_Equiv();
  var this$280 = $n(editorComponent$6);
  var $$x22 = this$280.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$6, state$6, optioner$6, ev$8, explainError$6, equiv$6);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$7 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Source du mod\u00e8le");
  var state$7 = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$19$2) => {
    var x$19$1 = $as_Lreactbuild_common_model_Project(x$19$2);
    return $n(x$19$1).Lreactbuild_common_model_Project__f_modelSource
  })), new $c_sjsr_AnonFunction1(((v$9$2) => {
    var v$9 = $as_s_Option(v$9$2);
    return new $c_sjsr_AnonFunction1(((x$20$2) => {
      var x$20$1 = $as_Lreactbuild_common_model_Project(x$20$2);
      var this$283 = $n(x$20$1);
      var x$190 = this$283.Lreactbuild_common_model_Project__f__id;
      var this$284 = $n(x$20$1);
      var x$191 = this$284.Lreactbuild_common_model_Project__f_organizations;
      var this$285 = $n(x$20$1);
      var x$192 = this$285.Lreactbuild_common_model_Project__f_name;
      var this$286 = $n(x$20$1);
      var x$193 = this$286.Lreactbuild_common_model_Project__f_title;
      var this$287 = $n(x$20$1);
      var x$194 = this$287.Lreactbuild_common_model_Project__f_description;
      var this$288 = $n(x$20$1);
      var x$195 = this$288.Lreactbuild_common_model_Project__f_images;
      var this$289 = $n(x$20$1);
      var x$196 = this$289.Lreactbuild_common_model_Project__f_location;
      var this$290 = $n(x$20$1);
      var x$197 = this$290.Lreactbuild_common_model_Project__f_areas;
      var this$291 = $n(x$20$1);
      var x$198 = this$291.Lreactbuild_common_model_Project__f_price;
      var this$292 = $n(x$20$1);
      var x$199 = this$292.Lreactbuild_common_model_Project__f_soldOut;
      var this$293 = $n(x$20$1);
      var x$200 = this$293.Lreactbuild_common_model_Project__f_privacy;
      var this$294 = $n(x$20$1);
      var x$201 = this$294.Lreactbuild_common_model_Project__f_scenes;
      var this$295 = $n(x$20$1);
      var x$202 = this$295.Lreactbuild_common_model_Project__f_renderSettings;
      var this$296 = $n(x$20$1);
      var x$203 = this$296.Lreactbuild_common_model_Project__f_city;
      var this$297 = $n(x$20$1);
      var x$204 = this$297.Lreactbuild_common_model_Project__f_district;
      var this$298 = $n(x$20$1);
      var x$205 = this$298.Lreactbuild_common_model_Project__f_topic;
      var this$299 = $n(x$20$1);
      var x$206 = this$299.Lreactbuild_common_model_Project__f_procedureState;
      var this$300 = $n(x$20$1);
      var x$207 = this$300.Lreactbuild_common_model_Project__f_summary;
      var this$301 = $n(x$20$1);
      var x$208 = this$301.Lreactbuild_common_model_Project__f_archived;
      var this$302 = $n(x$20$1);
      var x$209 = this$302.Lreactbuild_common_model_Project__f_parent;
      var this$303 = $n(x$20$1);
      var x$210 = this$303.Lreactbuild_common_model_Project__f_address;
      var this$304 = $n(x$20$1);
      var x$211 = this$304.Lreactbuild_common_model_Project__f_reference;
      $n(x$20$1);
      return new $c_Lreactbuild_common_model_Project(x$190, x$191, x$192, x$193, x$194, x$195, x$196, x$197, x$198, x$199, x$200, x$201, x$202, x$203, x$204, x$205, v$9, x$206, x$207, x$208, x$209, x$210, x$211)
    }))
  })));
  var optioner$7 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableMultiline;
  var ev$9 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
  var editorComponent$7 = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_multilineComponent;
  var explainError$7 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$309 = $m_s_math_Equiv$();
  var equiv$7 = this$309.universal__s_math_Equiv();
  var this$311 = $n(editorComponent$7);
  var $$x21 = this$311.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$7, state$7, optioner$7, ev$9, explainError$7, equiv$7);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Etat des proc\u00e9dures");
  var state$8 = $n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$21$2) => {
    var x$21$1 = $as_Lreactbuild_common_model_Project(x$21$2);
    return $n(x$21$1).Lreactbuild_common_model_Project__f_procedureState
  })), new $c_sjsr_AnonFunction1(((v$10$2) => {
    var v$10 = $as_s_Option(v$10$2);
    return new $c_sjsr_AnonFunction1(((x$22$2) => {
      var x$22$1 = $as_Lreactbuild_common_model_Project(x$22$2);
      var this$314 = $n(x$22$1);
      var x$213 = this$314.Lreactbuild_common_model_Project__f__id;
      var this$315 = $n(x$22$1);
      var x$214 = this$315.Lreactbuild_common_model_Project__f_organizations;
      var this$316 = $n(x$22$1);
      var x$215 = this$316.Lreactbuild_common_model_Project__f_name;
      var this$317 = $n(x$22$1);
      var x$216 = this$317.Lreactbuild_common_model_Project__f_title;
      var this$318 = $n(x$22$1);
      var x$217 = this$318.Lreactbuild_common_model_Project__f_description;
      var this$319 = $n(x$22$1);
      var x$218 = this$319.Lreactbuild_common_model_Project__f_images;
      var this$320 = $n(x$22$1);
      var x$219 = this$320.Lreactbuild_common_model_Project__f_location;
      var this$321 = $n(x$22$1);
      var x$220 = this$321.Lreactbuild_common_model_Project__f_areas;
      var this$322 = $n(x$22$1);
      var x$221 = this$322.Lreactbuild_common_model_Project__f_price;
      var this$323 = $n(x$22$1);
      var x$222 = this$323.Lreactbuild_common_model_Project__f_soldOut;
      var this$324 = $n(x$22$1);
      var x$223 = this$324.Lreactbuild_common_model_Project__f_privacy;
      var this$325 = $n(x$22$1);
      var x$224 = this$325.Lreactbuild_common_model_Project__f_scenes;
      var this$326 = $n(x$22$1);
      var x$225 = this$326.Lreactbuild_common_model_Project__f_renderSettings;
      var this$327 = $n(x$22$1);
      var x$226 = this$327.Lreactbuild_common_model_Project__f_city;
      var this$328 = $n(x$22$1);
      var x$227 = this$328.Lreactbuild_common_model_Project__f_district;
      var this$329 = $n(x$22$1);
      var x$228 = this$329.Lreactbuild_common_model_Project__f_topic;
      var this$330 = $n(x$22$1);
      var x$229 = this$330.Lreactbuild_common_model_Project__f_modelSource;
      var this$331 = $n(x$22$1);
      var x$230 = this$331.Lreactbuild_common_model_Project__f_summary;
      var this$332 = $n(x$22$1);
      var x$231 = this$332.Lreactbuild_common_model_Project__f_archived;
      var this$333 = $n(x$22$1);
      var x$232 = this$333.Lreactbuild_common_model_Project__f_parent;
      var this$334 = $n(x$22$1);
      var x$233 = this$334.Lreactbuild_common_model_Project__f_address;
      var this$335 = $n(x$22$1);
      var x$234 = this$335.Lreactbuild_common_model_Project__f_reference;
      $n(x$22$1);
      return new $c_Lreactbuild_common_model_Project(x$213, x$214, x$215, x$216, x$217, x$218, x$219, x$220, x$221, x$222, x$223, x$224, x$225, x$226, x$227, x$228, x$229, v$10, x$230, x$231, x$232, x$233, x$234)
    }))
  })));
  var optioner$8 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableMultiline;
  var ev$10 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
  var editorComponent$8 = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_multilineComponent;
  var explainError$8 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$340 = $m_s_math_Equiv$();
  var equiv$8 = this$340.universal__s_math_Equiv();
  var this$342 = $n(editorComponent$8);
  var $$x20 = this$342.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$8, state$8, optioner$8, ev$10, explainError$8, equiv$8);
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$345 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexRow;
  var $$x18 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$345, s$3);
  var this$346 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x17 = this$346.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$2 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 0.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Organisations"))];
  var $$x15 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$357 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexRow;
  var $$x13 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$357, s$4);
  var this$358 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$());
  var $$x12 = this$358.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("wrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$359 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x11 = this$359.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n($as_Lreactbuild_common_model_Project($n($n(p).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_organizations;
  var $$x3 = $n($$x4).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((orgRef$2) => {
    var orgRef = $as_Lreactbuild_common_model_RefTo(orgRef$2);
    var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$363 = $m_Lscalacss_ScalaCssReact$();
    var s$5 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexRow;
    var $$x9 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$363, s$5);
    var this$364 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
    var $$x8 = this$364.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + orgRef), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$365 = $m_Lreactbuild_model_Implicits$();
    var ev$11 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$365, proxy);
    var v$1 = $n(ev$11).stringify__O__T(orgRef);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
    var $$x5 = $m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_removeOrganization).apply__O__O(orgRef))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var array$3 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_delete, "", "24px")];
    var array$4 = [$$x9, $$x8, $$x7, $$x6, $n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    return $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
  })));
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x1 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("add", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ajouter une organisation");
  var state$9 = this.Lreactbuild_analyze_cost_modules_EditProject$Backend__f_addOrganization;
  var optioner$9 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$380 = $m_Lreactbuild_model_Implicits$();
  var ev$13 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$380, proxy);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$381 = $m_Lreactbuild_model_Implicits$();
  var helper$6 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$381, proxy);
  var editorComponent$9 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$6);
  var explainError$9 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$385 = $m_Lreactbuild_model_Implicits$();
  var this$384 = $m_Lreactbuild_model_Implicits$();
  var ev$12 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$384, proxy);
  var equiv$9 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$385, ev$12);
  var array$5 = [$$x1, editorComponent$9.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$9, state$9, optioner$9, ev$13, explainError$9, equiv$9)];
  var array$6 = [$$x13, $$x12, $$x11, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  var array$7 = [$$x18, $$x17, $$x15, $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
  var array$8 = [$$x36, $$x35, $$x34, $$x33, $$x32, $$x31, $$x30, $$x29, $$x28, $$x23, $$x22, $$x21, $$x20, $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  var array$9 = [$$x40, $$x39, $$x38, $n($$x37).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  return $n($$x41).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
});
function $as_Lreactbuild_analyze_cost_modules_EditProject$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditProject$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditProject$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditProject$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditProject$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditProject$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditProject$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditProject$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditProject$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditProject$Backend: 0
}, false, "reactbuild.analyze.cost.modules.EditProject$Backend", {
  Lreactbuild_analyze_cost_modules_EditProject$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditProject$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditResource$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_EditResource$Backend__f_dateRef = null;
  this.Lreactbuild_analyze_cost_modules_EditResource$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_EditResource$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljava_time_LocalDate$();
    return this$2.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
  }));
  this.Lreactbuild_analyze_cost_modules_EditResource$Backend__f_dateRef = new $c_Lcom_iz2use_common_ParsingReference$Simple(f)
}
$c_Lreactbuild_analyze_cost_modules_EditResource$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditResource$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditResource$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditResource$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditResource$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_EditResource$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_EditResource$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditResource$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_EditResource$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Backend.prototype.render__Lreactbuild_analyze_cost_modules_EditResource$Props__Lreactbuild_analyze_cost_modules_EditResource$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  $n(p);
  var v = $n(p).Lreactbuild_analyze_cost_modules_EditResource$Props__f_resource;
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x20 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$5 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
  var $$x19 = this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x18 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$9 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x16 = this$9.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$10 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x15 = this$10.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x14 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Nom");
  var this$21 = $n(v);
  var g = new $c_sjsr_AnonFunction1(((v$2$2) => {
    var v$2 = $as_T(v$2$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lreactbuild_model_Resource(x$2$2);
      var this$14 = $n(x$2);
      var x$2$2$1 = this$14.Lreactbuild_model_Resource__f__id;
      var this$15 = $n(x$2);
      var x$3 = this$15.Lreactbuild_model_Resource__f_organization;
      var this$16 = $n(x$2);
      var x$4 = this$16.Lreactbuild_model_Resource__f_costByHour;
      var this$17 = $n(x$2);
      var x$5 = this$17.Lreactbuild_model_Resource__f_category;
      var this$18 = $n(x$2);
      var x$6 = this$18.Lreactbuild_model_Resource__f_entry;
      var this$19 = $n(x$2);
      var x$7 = this$19.Lreactbuild_model_Resource__f_release;
      $n(x$2);
      return new $c_Lreactbuild_model_Resource(x$2$2$1, x$3, v$2, x$4, x$5, x$6, x$7)
    }))
  }));
  var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$21.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1 = this$21.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$1 = $as_Lreactbuild_model_Resource(arg1);
  var state = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$21, $n(x$1).Lreactbuild_model_Resource__f_name, new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
    var ot = $as_s_Option(ot$2);
    var $$x12 = $n($as_F2($n(this$21.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$22 = $n(ot);
    return $n($$x12).apply__O__O__O((this$22.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$22.get__O()))), cb$2)
  })));
  var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$25 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$25);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv = $m_s_math_Equiv$String$();
  var $$x13 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Co\u00fbt horaire");
  var this$38 = $n(v);
  var g$2 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_s_Option(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4$1 = $as_Lreactbuild_model_Resource(x$4$2);
      var this$31 = $n(x$4$1);
      var x$9 = this$31.Lreactbuild_model_Resource__f__id;
      var this$32 = $n(x$4$1);
      var x$10 = this$32.Lreactbuild_model_Resource__f_organization;
      var this$33 = $n(x$4$1);
      var x$11 = this$33.Lreactbuild_model_Resource__f_name;
      var this$34 = $n(x$4$1);
      var x$12 = this$34.Lreactbuild_model_Resource__f_category;
      var this$35 = $n(x$4$1);
      var x$13 = this$35.Lreactbuild_model_Resource__f_entry;
      var this$36 = $n(x$4$1);
      var x$14 = this$36.Lreactbuild_model_Resource__f_release;
      $n(x$4$1);
      return new $c_Lreactbuild_model_Resource(x$9, x$10, x$11, v$3, x$12, x$13, x$14)
    }))
  }));
  var g$3 = new $c_sjsr_AnonFunction1(((x$1$2$1) => $n($as_F1(g$2.apply__O__O(x$1$2$1))).apply__O__O(this$38.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1$1 = this$38.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$3$1 = $as_Lreactbuild_model_Resource(arg1$1);
  var state$1 = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$38, $n(x$3$1).Lreactbuild_model_Resource__f_costByHour, new $c_sjsr_AnonFunction2(((ot$2$1, cb$2$1) => {
    var ot$1 = $as_s_Option(ot$2$1);
    var $$x10 = $n($as_F2($n(this$38.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$39 = $n(ot$1);
    return $n($$x10).apply__O__O__O((this$39.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$3.apply__O__O(this$39.get__O()))), cb$2$1)
  })));
  var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$1);
  var ev$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$44 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$44);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
  var equiv$1 = new $c_s_math_Equiv$OptionEquiv(eqv);
  var $$x11 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$2, explainError$1, equiv$1);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cat\u00e9gorie de ressource (P=Personne)");
  var this$58 = $n(v);
  var g$4 = new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4 = $as_s_Option(v$4$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6$1 = $as_Lreactbuild_model_Resource(x$6$2);
      var this$51 = $n(x$6$1);
      var x$16 = this$51.Lreactbuild_model_Resource__f__id;
      var this$52 = $n(x$6$1);
      var x$17 = this$52.Lreactbuild_model_Resource__f_organization;
      var this$53 = $n(x$6$1);
      var x$18 = this$53.Lreactbuild_model_Resource__f_name;
      var this$54 = $n(x$6$1);
      var x$19 = this$54.Lreactbuild_model_Resource__f_costByHour;
      var this$55 = $n(x$6$1);
      var x$20 = this$55.Lreactbuild_model_Resource__f_entry;
      var this$56 = $n(x$6$1);
      var x$21 = this$56.Lreactbuild_model_Resource__f_release;
      $n(x$6$1);
      return new $c_Lreactbuild_model_Resource(x$16, x$17, x$18, x$19, v$4, x$20, x$21)
    }))
  }));
  var g$5 = new $c_sjsr_AnonFunction1(((x$1$2$2) => $n($as_F1(g$4.apply__O__O(x$1$2$2))).apply__O__O(this$58.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1$2 = this$58.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$5$1 = $as_Lreactbuild_model_Resource(arg1$2);
  var state$2 = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$58, $n(x$5$1).Lreactbuild_model_Resource__f_category, new $c_sjsr_AnonFunction2(((ot$2$2, cb$2$2) => {
    var ot$3 = $as_s_Option(ot$2$2);
    var $$x9 = $n($as_F2($n(this$58.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$59 = $n(ot$3);
    return $n($$x9).apply__O__O__O((this$59.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$5.apply__O__O(this$59.get__O()))), cb$2$2)
  })));
  var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$3);
  var ev$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$64 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$64);
  var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
  var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv$1 = $m_s_math_Equiv$String$();
  var equiv$2 = new $c_s_math_Equiv$OptionEquiv(eqv$1);
  var array = [$$x16, $$x15, $$x14, $$x13, $$x11, editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$2, optioner$2, ev$4, explainError$2, equiv$2)];
  var $$x8 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$74 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x6 = this$74.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$75 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x5 = this$75.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x4 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date d'entr\u00e9e");
  var this$86 = $n(v);
  var g$6 = new $c_sjsr_AnonFunction1(((v$5$2) => {
    var v$5 = $as_s_Option(v$5$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_Lreactbuild_model_Resource(x$8$2);
      var this$79 = $n(x$8);
      var x$23 = this$79.Lreactbuild_model_Resource__f__id;
      var this$80 = $n(x$8);
      var x$24 = this$80.Lreactbuild_model_Resource__f_organization;
      var this$81 = $n(x$8);
      var x$25 = this$81.Lreactbuild_model_Resource__f_name;
      var this$82 = $n(x$8);
      var x$26 = this$82.Lreactbuild_model_Resource__f_costByHour;
      var this$83 = $n(x$8);
      var x$27 = this$83.Lreactbuild_model_Resource__f_category;
      var this$84 = $n(x$8);
      var x$28 = this$84.Lreactbuild_model_Resource__f_release;
      $n(x$8);
      return new $c_Lreactbuild_model_Resource(x$23, x$24, x$25, x$26, x$27, v$5, x$28)
    }))
  }));
  var g$7 = new $c_sjsr_AnonFunction1(((x$1$2$3) => $n($as_F1(g$6.apply__O__O(x$1$2$3))).apply__O__O(this$86.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1$3 = this$86.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$7$1 = $as_Lreactbuild_model_Resource(arg1$3);
  var state$3 = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$86, $n(x$7$1).Lreactbuild_model_Resource__f_entry, new $c_sjsr_AnonFunction2(((ot$2$3, cb$2$3) => {
    var ot$4 = $as_s_Option(ot$2$3);
    var $$x2 = $n($as_F2($n(this$86.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$87 = $n(ot$4);
    return $n($$x2).apply__O__O__O((this$87.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$7.apply__O__O(this$87.get__O()))), cb$2$3)
  })));
  var optioner$3 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  $m_Lcom_iz2use_common_Parsable$();
  var reference = this.Lreactbuild_analyze_cost_modules_EditResource$Backend__f_dateRef;
  var parser$3 = new $c_Lcom_iz2use_common_Parsable$$anon$4(reference);
  var ev$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$91 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$91);
  var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
  var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var $$x3 = editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$3, optioner$3, ev$5, explainError$3, equiv$3);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date de sortie");
  var this$104 = $n(v);
  var g$8 = new $c_sjsr_AnonFunction1(((v$6$2) => {
    var v$6 = $as_s_Option(v$6$2);
    return new $c_sjsr_AnonFunction1(((x$10$2) => {
      var x$10$1 = $as_Lreactbuild_model_Resource(x$10$2);
      var this$97 = $n(x$10$1);
      var x$30 = this$97.Lreactbuild_model_Resource__f__id;
      var this$98 = $n(x$10$1);
      var x$31 = this$98.Lreactbuild_model_Resource__f_organization;
      var this$99 = $n(x$10$1);
      var x$32 = this$99.Lreactbuild_model_Resource__f_name;
      var this$100 = $n(x$10$1);
      var x$33 = this$100.Lreactbuild_model_Resource__f_costByHour;
      var this$101 = $n(x$10$1);
      var x$34 = this$101.Lreactbuild_model_Resource__f_category;
      var this$102 = $n(x$10$1);
      var x$35 = this$102.Lreactbuild_model_Resource__f_entry;
      $n(x$10$1);
      return new $c_Lreactbuild_model_Resource(x$30, x$31, x$32, x$33, x$34, x$35, v$6)
    }))
  }));
  var g$9 = new $c_sjsr_AnonFunction1(((x$1$2$4) => $n($as_F1(g$8.apply__O__O(x$1$2$4))).apply__O__O(this$104.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1$4 = this$104.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$9$1 = $as_Lreactbuild_model_Resource(arg1$4);
  var state$4 = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$104, $n(x$9$1).Lreactbuild_model_Resource__f_release, new $c_sjsr_AnonFunction2(((ot$2$4, cb$2$4) => {
    var ot$5 = $as_s_Option(ot$2$4);
    var $$x1 = $n($as_F2($n(this$104.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$105 = $n(ot$5);
    return $n($$x1).apply__O__O__O((this$105.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$9.apply__O__O(this$105.get__O()))), cb$2$4)
  })));
  var optioner$4 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  $m_Lcom_iz2use_common_Parsable$();
  var reference$1 = this.Lreactbuild_analyze_cost_modules_EditResource$Backend__f_dateRef;
  var parser$4 = new $c_Lcom_iz2use_common_Parsable$$anon$4(reference$1);
  var ev$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$109 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$4 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$109);
  var editorComponent$4 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$4);
  var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var array$1 = [$$x6, $$x5, $$x4, $$x3, editorComponent$4.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$4, state$4, optioner$4, ev$6, explainError$4, equiv$4)];
  var array$2 = [$$x20, $$x19, $$x18, $$x8, $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  return $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
function $as_Lreactbuild_analyze_cost_modules_EditResource$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditResource$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditResource$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditResource$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditResource$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditResource$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditResource$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditResource$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditResource$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditResource$Backend: 0
}, false, "reactbuild.analyze.cost.modules.EditResource$Backend", {
  Lreactbuild_analyze_cost_modules_EditResource$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditResource$Backend;
function $p_Lreactbuild_analyze_cost_modules_EntryList$Backend__loop$1__sci_List__sci_List__sci_Map__sci_List__Lreactbuild_analyze_cost_modules_EditListEntry$Context__Lreactbuild_analyze_cost_modules_EntryList$State__sci_List__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, rest, customEntries, templatedEntries, templates$1, context$1, s$1, terms$1, flattenTemplates$1) {
  while (true) {
    var x1 = rest;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x1)) {
      var $$x2 = customEntries;
      var $$x1 = templatedEntries;
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r = $thiz.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_updateEntry;
      var data = new $c_Lreactbuild_analyze_cost_modules_IndexedListEntry(templates$1, $$x2, $$x1, $as_Lreactbuild_analyze_cost_modules_EntryList$Updater($n(r).value__O()));
      var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x10 = $m_Lreactbuild_analyze_cost_modules_TermLevel$();
      var $$x9 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$();
      var u = $m_Lreactbuild_analyze_cost_modules_EditListEntry$().apply__Lreactbuild_analyze_cost_modules_EditListEntry$Props__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps(context$1, data.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update, $m_s_None$(), $m_s_None$()));
      var this$8 = $n(u);
      var n = this$8.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x8 = $n($$x9).dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lcom_iz2use_react_components_Dialog$Push(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)));
      var $$x7 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty;
      var this$12 = $n($thiz.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_reactbuild$analyze$cost$modules$EntryList$Backend$$$);
      var mod = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lreactbuild_analyze_cost_modules_EntryList$State(s$2);
        var x$1 = (!$n(s).Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms);
        var this$10 = $n(s);
        var x$2 = this$10.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedTerms;
        $n(s);
        return new $c_Lreactbuild_analyze_cost_modules_EntryList$State(x$2, x$1)
      }));
      var $$x6 = $n($$x10).renderHeader__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Z__I__T__Ljapgolly_scalajs_react_vdom_TagOf($$x8, $$x7, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$12, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n(s$1).Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms, 0, "Sans liste associ\u00e9e");
      var this$13 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var cond = $n(s$1).Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms;
      if (cond) {
        var u$1 = $m_Lreactbuild_analyze_cost_modules_TermListEntries$().apply__Lreactbuild_analyze_cost_modules_EditListEntry$Context__Lreactbuild_analyze_cost_modules_IndexedListEntry__I__s_Option__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(context$1, data.filter__F1__Lreactbuild_analyze_cost_modules_IndexedListEntry(new $c_sjsr_AnonFunction1(((x$9$2) => {
          var x$9 = $as_sci_Set(x$9$2);
          return $n(x$9).isEmpty__Z()
        }))), 1, $m_s_None$());
        var this$16 = $n(u$1);
        var n$1 = this$16.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var $$x5 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
      } else {
        var $$x5 = this$13.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
      };
      var $$x4 = $m_Lreactbuild_analyze_cost_modules_TermTree$();
      var $$x3 = $thiz.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_reuseExpandedTerm;
      var this$18 = $m_Ljapgolly_scalajs_react_Reusability$();
      var u$2 = $n($$x4).apply__Lreactbuild_analyze_cost_modules_EditListEntry$Context__sci_List__Lreactbuild_analyze_cost_modules_IndexedListEntry__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(context$1, terms$1, data, $n($$x3).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s$1, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$18.byRef__F2(), this$18.by_$eq$eq__F2())));
      var this$20 = $n(u$2);
      var n$2 = this$20.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array = [$$x6, $$x5, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
      return $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $as_Lreactbuild_model_WithChildren($n(x3).sci_$colon$colon__f_head);
      var tl = $n(x3).sci_$colon$colon__f_next;
      var x1$2 = $as_Lreactbuild_model_ListEntry($n(head).Lreactbuild_model_WithChildren__f_item);
      if ((x1$2 instanceof $c_Lreactbuild_model_InstanceListEntry)) {
        var x2 = $as_Lreactbuild_model_InstanceListEntry(x1$2);
        var this$25 = $n(flattenTemplates$1);
        var pf = new $c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1($thiz, x2);
        var x1$3 = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this$25, pf);
        if ((x1$3 instanceof $c_s_Some)) {
          var x2$2 = $as_s_Some(x1$3);
          var templateEntry = $as_Lreactbuild_model_ListTemplateEntry($n(x2$2).s_Some__f_value);
          var $$x12 = templatedEntries;
          $n(head);
          var this$27 = $n(head);
          var children = this$27.Lreactbuild_model_WithChildren__f_children;
          var y = new $c_Lreactbuild_model_WithChildren(x2, children);
          var temp$templatedEntries = $as_sci_Map($n($$x12).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), templateEntry, y)));
          rest = tl;
          templatedEntries = temp$templatedEntries
        } else {
          var x$3 = $m_s_None$();
          if ((x$3 === x1$3)) {
            console.error(("there is no template for " + x2));
            rest = tl
          } else {
            throw new $c_s_MatchError(x1$3)
          }
        }
      } else if ((x1$2 instanceof $c_Lreactbuild_model_CustomListEntry)) {
        var x3$2 = $as_Lreactbuild_model_CustomListEntry(x1$2);
        $n(head);
        var this$30 = $n(head);
        var children$1 = this$30.Lreactbuild_model_WithChildren__f_children;
        var rassoc$3 = new $c_Lreactbuild_model_WithChildren(x3$2, children$1);
        var this$32 = $n(customEntries);
        var temp$customEntries = new $c_sci_$colon$colon(rassoc$3, this$32);
        rest = tl;
        customEntries = temp$customEntries
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryList$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_reactbuild$analyze$cost$modules$EntryList$Backend$$$ = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_reuseExpandedTerm = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_updateEntry = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_reactbuild$analyze$cost$modules$EntryList$Backend$$$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_EntryList$State(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedTerms
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_sci_Set(v$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lreactbuild_analyze_cost_modules_EntryList$State(x$2$2);
      $n(x$2);
      var this$3 = $n(x$2);
      var expandedNoTerms = this$3.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms;
      return new $c_Lreactbuild_analyze_cost_modules_EntryList$State(v, expandedNoTerms)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$7 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$7.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_reuseExpandedTerm = $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w);
  var this$8 = $m_Ljapgolly_scalajs_react_Reusable$();
  var a = new $c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anon$1(this);
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_updateEntry = this$8.const__O__Z__Ljapgolly_scalajs_react_Reusable(a, true)
}
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryList$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryList$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryList$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_EntryList$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend.prototype.render__Lreactbuild_analyze_cost_modules_EntryList$Props__Lreactbuild_analyze_cost_modules_EntryList$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_EntryList$Props__f_proxy;
  $m_Lreactbuild_package$();
  var proxy$1 = $n(p).Lreactbuild_analyze_cost_modules_EntryList$Props__f_proxy;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy$1);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$5 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$5).Lreactbuild_model_CommonData__f_terms
  };
  var terms = $as_sci_List($$x1);
  var this$6 = $n(terms);
  var f = ((x$6$2) => {
    var x$6 = $as_Lreactbuild_model_Term(x$6$2);
    return $n(x$6).Lreactbuild_model_Term__f__id
  });
  if ((this$6 === $m_sci_Nil$())) {
    var termIds = $m_sci_Nil$()
  } else {
    var arg1$1 = this$6.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$6.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var termIds = h
  };
  $m_Lreactbuild_package$();
  var proxy$2 = $n(p).Lreactbuild_analyze_cost_modules_EntryList$Props__f_proxy;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$9 = $n(proxy$2);
  var this$10 = $n(this$9.Ldiode_react_ModelProxy__f_modelReader);
  var m$1 = $as_Lreactbuild_analyze_cost_services_Model(this$10.value__O());
  if ($n($n(m$1).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x2 = $m_sci_Nil$()
  } else {
    var arg1$3 = $n($n(m$1).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$7 = $as_Lreactbuild_model_CommonData(arg1$3);
    var $$x2 = $n(x$7).Lreactbuild_model_CommonData__f_listTemplates
  };
  var templates = $as_sci_List($$x2);
  var this$12 = $n(templates);
  var rest$1 = this$12;
  var h$1 = null;
  var t$1 = null;
  while ((rest$1 !== $m_sci_Nil$())) {
    var arg1$4 = $n(rest$1).head__O();
    var x$8 = $as_Lreactbuild_model_WithChildren(arg1$4);
    var it = $n($n(x$8).Lreactbuild_model_WithChildren__f_children).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t$1 === null)) {
        h$1 = nx$1
      } else {
        $n(t$1).sci_$colon$colon__f_next = nx$1
      };
      t$1 = nx$1
    };
    rest$1 = $as_sci_List($n(rest$1).tail__O())
  };
  var flattenTemplates = ((h$1 === null) ? $m_sci_Nil$() : h$1);
  var $$x4 = $n(p).Lreactbuild_analyze_cost_modules_EntryList$Props__f_project;
  var this$13 = $n(termIds);
  var $$x3 = $as_sc_IterableOnceOps($f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this$13, terms));
  var this$14 = $m_s_$less$colon$less$();
  var context = new $c_Lreactbuild_analyze_cost_modules_EditListEntry$Context(proxy, templates, $$x4, termIds, $n($$x3).toMap__s_$less$colon$less__sci_Map(this$14.s_$less$colon$less$__f_singleton), $n(p).Lreactbuild_analyze_cost_modules_EntryList$Props__f_user);
  var $$x5 = $m_Lreactbuild_analyze_cost_components_ScrollBlockContainer$();
  var array = [$p_Lreactbuild_analyze_cost_modules_EntryList$Backend__loop$1__sci_List__sci_List__sci_Map__sci_List__Lreactbuild_analyze_cost_modules_EditListEntry$Context__Lreactbuild_analyze_cost_modules_EntryList$State__sci_List__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode(this, $as_sci_List($n($n(p).Lreactbuild_analyze_cost_modules_EntryList$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $m_sci_Nil$(), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()), templates, context, s, terms, flattenTemplates)];
  return $n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
function $as_Lreactbuild_analyze_cost_modules_EntryList$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EntryList$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EntryList$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EntryList$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EntryList$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EntryList$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EntryList$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EntryList$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EntryList$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryList$Backend: 0
}, false, "reactbuild.analyze.cost.modules.EntryList$Backend", {
  Lreactbuild_analyze_cost_modules_EntryList$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryList$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_activateButton = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_addComment = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_edit = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_toggleExpanded = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_collapse = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_activateButton = $m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).prompt__T__Ljapgolly_scalajs_react_callback_Trampoline("Votre commentaire");
  var this$1 = $m_s_$less$colon$less$();
  var this$ = $n($$x2).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x1, this$1.s_$less$colon$less$__f_singleton);
  var f = new $c_sjsr_AnonFunction1(((comment$2) => {
    var comment = $as_T(comment$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var c = this.appendBody__Lreactbuild_model_ListEntryEventBody__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_model_ListEntryEventBody$Comment(comment));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  }));
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_addComment = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, f);
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_edit = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(\u03b4).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(p$2);
    var $$x3 = $m_Lcom_iz2use_react_components_Dialog$Broadcaster$();
    var u = $m_Lreactbuild_analyze_cost_modules_EditListEntry$().apply__Lreactbuild_analyze_cost_modules_EditListEntry$Props__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry);
    var this$7 = $n(u);
    var n = this$7.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var this$$1 = $n($$x3).dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lcom_iz2use_react_components_Dialog$Push(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)));
    var f$1 = new $c_sjsr_AnonFunction1(((x$25$2) => {
      $as_jl_Void(x$25$2)
    }));
    var this$10 = $n(this$$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$10, f$1))
  })));
  var this$12 = $n(\u03b4);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_modules_EntryListEntry$State(s$2);
    $n(s);
    var expanded = (!$n(s).Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded);
    return new $c_Lreactbuild_analyze_cost_modules_EntryListEntry$State(expanded)
  }));
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_toggleExpanded = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$12, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$14 = $n(\u03b4);
  var mod$1 = new $c_sjsr_AnonFunction1(((s$3$2) => {
    var s$3 = $as_Lreactbuild_analyze_cost_modules_EntryListEntry$State(s$3$2);
    $n(s$3);
    return new $c_Lreactbuild_analyze_cost_modules_EntryListEntry$State(false)
  }));
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_collapse = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$14, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
}
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype.appendBody__Lreactbuild_model_ListEntryEventBody__Ljapgolly_scalajs_react_callback_Trampoline = (function(body) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(p$2);
    var $$x3 = $n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_progressContext).Lreactbuild_analyze_cost_components_ProgressContext__f_track;
    $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry);
    var this$ = $f_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps__saveNewEvent__Lreactbuild_model_ListEntryEventBody__F1(this$2, body);
    var g = new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_Lreactbuild_model_WithChildren(v$2);
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var qual$1 = $n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).update__Lreactbuild_analyze_cost_modules_EntryList$Updater();
      var this$3 = $m_sci_Nil$();
      var x$1 = new $c_sci_$colon$colon(v, this$3);
      $n(qual$1);
      var x$2 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty;
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x2).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n(qual$1).apply__sci_List__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(x$1, x$2)))
    }));
    var $$x1 = new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1(this$, g));
    var this$7 = $n(this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((x$23$2) => {
      var x$23 = $as_Lreactbuild_analyze_cost_modules_EntryListEntry$State(x$23$2);
      $n(x$23);
      return new $c_Lreactbuild_analyze_cost_modules_EntryListEntry$State(true)
    }));
    var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).apply__O__O__O($$x1, $f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$7, mod)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((x$24$2) => {
      $as_jl_Void(x$24$2)
    }));
    var this$9 = $n(this$$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$9, f))
  })))
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype.render__Lreactbuild_analyze_cost_modules_EntryListEntry$Props__Lreactbuild_analyze_cost_modules_EntryListEntry$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var header = $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader($n($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_headers).apply__O__O($n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).tpe__Lreactbuild_model_ListEntryType()));
  var summary = $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary($n($n(header).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_historySummary).apply__O__O__O($n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).history__sci_List(), $n($n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).context__Lreactbuild_analyze_cost_modules_EditListEntry$Context()).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_user));
  var this$1 = $n($n(summary).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_state);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var v = $as_Lreactbuild_model_ListEntryEventBody(arg1);
    var $$x2 = $n($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_eventTypes);
    var this$2 = $n(v);
    var $$x1 = $n($$x2).get__O__s_Option($objectGetClass(this$2))
  };
  var this$3 = $n($$x1);
  var decoration = $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType((this$3.isEmpty__Z() ? $n(header).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_defaultState : this$3.get__O()));
  var $$x57 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$6 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_entryListEntry;
  var $$x56 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s$1);
  var $$x55 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x54 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontSize__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("120%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x53 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$11 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexRow;
  var $$x52 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$11, s$2);
  var this$12 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x51 = this$12.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x50 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$15 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $as_Lscalacss_internal_StyleA($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_expandableSelectorStart).apply__O__O($n(s).Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded));
  var $$x49 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$15, s$3);
  var $$x48 = $m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_toggleExpanded);
  var $$x47 = $n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_progressContext).Lreactbuild_analyze_cost_components_ProgressContext__f_statusIcon;
  var $$x46 = $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($n(decoration).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_iconSource, "", "24px");
  var array = [$n(decoration).style__Ljapgolly_scalajs_react_vdom_TagMod()];
  var array$1 = [$n($$x47).getOrElse__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_VdomNode($n($$x46).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))];
  var array$2 = [$$x49, $n($$x48).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var $$x45 = $n($n($$x50).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
  var r = this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_activateButton;
  var $$x44 = $n($$x45).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(r));
  var $$x43 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$28 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexColumn;
  var $$x42 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$28, s$4);
  var $$x41 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$31 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var cond = $n(s).Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded;
  if (cond) {
    var $$x40 = $m_Lreactbuild_analyze_cost_modules_ExpandablePicker$();
    var $$x39 = this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_collapse;
    var $$x38 = this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_activateButton;
    var this$44 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$32 = $n($n($n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).tpe__Lreactbuild_model_ListEntryType()).actions__sci_ListSet());
    var b = new $c_sci_ListSet$$anon$1();
    var it = this$32.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1$1 = $n(it).next__O();
      var key = $as_jl_Class(arg1$1);
      var xs = $n($m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_eventTypes).get__O__s_Option(key);
      $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, xs)
    };
    var this$43 = $n($n($as_sc_IterableOnceOps(b.scm_ImmutableBuilder__f_elems)).toList__sci_List());
    var f$1 = ((tpe$2) => {
      var tpe = $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(tpe$2);
      var $$x36 = $m_Lcom_iz2use_react_components_Button$();
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$ = $n(tpe).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_create;
      var f = new $c_sjsr_AnonFunction1(((body$2) => {
        var body = $as_Lreactbuild_model_ListEntryEventBody(body$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var c = this.appendBody__Lreactbuild_model_ListEntryEventBody__Ljapgolly_scalajs_react_callback_Trampoline(body);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
      }));
      var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, f);
      var $$x35 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$37 = $m_s_$less$colon$less$();
      var $$x34 = $n($n($$x36).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x35).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$37.s_$less$colon$less$__f_singleton)));
      var $$x33 = $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($n(tpe).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_iconSource, "", "24px");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $n(tpe).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$3 = [$$x33, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1), $n(tpe).style__Ljapgolly_scalajs_react_vdom_TagMod()];
      return $n($$x34).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    });
    if ((this$43 === $m_sci_Nil$())) {
      var ns = $m_sci_Nil$()
    } else {
      var arg1$2 = this$43.head__O();
      var h = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$43.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$3 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var ns = h
    };
    var $$x37 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$44, null, ns);
    var $$x32 = $n($m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_edit));
    var array$4 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_create, "", "24px"), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Modifier"))];
    var $$x31 = $n($$x32).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var $$x30 = $m_Lcom_iz2use_react_components_Button$();
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var co$1 = this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend__f_addComment;
    var $$x29 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$51 = $m_s_$less$colon$less$();
    var $$x28 = $n($$x30).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x29).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$1, this$51.s_$less$colon$less$__f_singleton));
    var array$5 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_chat, "", "24px"), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Commentaire"))];
    var array$6 = [$$x37, $$x31, $n($$x28).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var u = $n($$x40).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_Ref$FullF__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x39, $$x38, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    var this$61 = $n(u);
    var n = this$61.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x27 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  } else {
    var $$x27 = this$31.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  };
  var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$65 = $m_Lscalacss_ScalaCssReact$();
  var s$5 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_entryListEntryTitle;
  var $$x25 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$65, s$5);
  var $$x24 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("title", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$2 = $n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).title__T();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$7 = [$$x25, $$x24, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2), $n(decoration).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_lineDecoration];
  var array$8 = [$$x42, $$x41, $$x27, $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  var array$9 = [$$x52, $$x51, $$x44, $n($$x43).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var array$10 = [$$x54, $n($$x53).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))];
  var $$x23 = $n($$x55).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x21 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "paddingLeft")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x19 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "paddingLeft")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x18 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "borderLeft")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1px solid #ccc", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x17 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "borderBottom")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1px solid #ccc", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x16 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$BorderRadius("borderBottomLeftRadius")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$93 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var cond$1 = ($n($n(summary).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_myState).isEmpty__Z() || $n(s).Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded);
  if (cond$1) {
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x14 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$());
    var this$96 = $n($n(summary).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_myState);
    var $$x13 = $n($$x14).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(((!this$96.isEmpty__Z()) ? "#999" : "#d00"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var $$x12 = $m_Lreactbuild_analyze_cost_modules_FlatList$();
    var this$100 = $m_Lreactbuild_analyze_cost_modules_FlatListItem$();
    var this$97 = $n($n(summary).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_myState);
    var value = (this$97.isEmpty__Z() ? $n($n(header).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_defaultState).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name : this$97.get__O());
    var f$2 = new $c_sjsr_AnonFunction1(((v$2$1) => {
      var v$3 = $as_T(v$2$1);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
    }));
    var $$x11 = new $c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2(this$100, f$2, value);
    var optional = $n(summary).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_status;
    var f$4 = new $c_sjsr_AnonFunction1(((value$2) => {
      var value$1 = $as_T(value$2);
      var this$103 = $m_Lreactbuild_analyze_cost_modules_FlatListItem$();
      var f$3 = new $c_sjsr_AnonFunction1(((v$2$2) => {
        var v$4 = $as_T(v$2$2);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)
      }));
      return new $c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2(this$103, f$3, value$1)
    }));
    var $$x10 = new $c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4(optional, f$4);
    var this$110 = $m_Lreactbuild_analyze_cost_modules_FlatListItem$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$5 = $n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).created__s_Option();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$105 = $m_Lreactbuild_model_Implicits$();
    var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$105, locale);
    var ev = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
    var value$3 = ("cr\u00e9\u00e9 le " + ev.stringify__s_Option__T(v$5));
    var f$5 = new $c_sjsr_AnonFunction1(((v$3$2) => {
      var v$3$1 = $as_T(v$3$2);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3$1)
    }));
    var $$x9 = new $c_Lreactbuild_analyze_cost_modules_FlatListItemLowPriorityImplicits$$anon$2(this$110, f$5, value$3);
    var optional$1 = $as_s_Option($n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).foldInstance__F0__F1__O(new $c_sjsr_AnonFunction0((() => $m_s_None$())), new $c_sjsr_AnonFunction1(((entry$2) => {
      var entry = $as_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(entry$2);
      var this$111 = $n($n($n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).context__Lreactbuild_analyze_cost_modules_EditListEntry$Context()).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_templates);
      var pf = new $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1(this, entry);
      return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this$111, pf)
    }))));
    var f$6 = new $c_sjsr_AnonFunction1(((value$3$2) => {
      var value$3$1 = $as_Ljapgolly_scalajs_react_vdom_TagMod(value$3$2);
      return new $c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$3(value$3$1)
    }));
    var array$11 = [$$x11, $$x10, $$x9, new $c_Lreactbuild_analyze_cost_modules_FlatListItem$$anon$4(optional$1, f$6)];
    var as = $n($$x12).apply__sci_Seq__sci_Seq($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var sep = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" \u2022 ");
    var this$121 = $m_s_$less$colon$less$();
    var f$7 = this$121.s_$less$colon$less$__f_singleton;
    var array$12 = [$$x13, $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$7)];
    var $$x8 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))
  } else {
    var $$x8 = this$93.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  };
  var this$126 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  $n(s);
  var cond$2 = true;
  if (cond$2) {
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as$1 = $n($n(p).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry).history__sci_List();
    var $$x3 = $n($$x4).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((e$2) => {
      var e = $as_Lreactbuild_model_ListEntryEvent(e$2);
      var $$x5 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_eventTypes;
      var this$129 = $n($n(e).Lreactbuild_model_ListEntryEvent__f_body);
      var this$130 = $n($n($$x5).get__O__s_Option($objectGetClass(this$129)));
      if (this$130.isEmpty__Z()) {
        var $$x6 = ("" + $n(e).Lreactbuild_model_ListEntryEvent__f_body)
      } else {
        var arg1$4 = this$130.get__O();
        var eventType = $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(arg1$4);
        var $$x6 = $as_T($n($n(e).Lreactbuild_model_ListEntryEvent__f_body).fold__F0__F1__O(new $c_sjsr_AnonFunction0((() => $n(eventType).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name)), new $c_sjsr_AnonFunction1(((comment$2) => {
          var comment = $as_T(comment$2);
          return (($n(eventType).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name + " ") + comment)
        }))))
      };
      var v$6 = $as_T($$x6);
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var v$7 = $n(e).Lreactbuild_model_ListEntryEvent__f_created;
      var this$133 = $m_Lreactbuild_model_Implicits$();
      var locale$1 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
      var ev$1 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$133, locale$1);
      var v$8 = ((v$6 + " le ") + $n(ev$1).stringify__O__T(v$7));
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$13 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$8)];
      return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))
    })))
  } else {
    var $$x3 = this$126.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  };
  var array$14 = [$$x19, $$x18, $$x17, $$x16, $$x8, $$x3];
  var array$15 = [$$x21, $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  var array$16 = [$$x56, $$x23, $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
  return $n($$x57).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))
});
function $as_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EntryListEntry$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EntryListEntry$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryListEntry$Backend: 0
}, false, "reactbuild.analyze.cost.modules.EntryListEntry$Backend", {
  Lreactbuild_analyze_cost_modules_EntryListEntry$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_top = null;
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_close = null;
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_top = $m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF();
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_close = new $c_sjsr_AnonFunction1(((ev$2) => {
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var condition = new $c_sjsr_AnonFunction1(((p$2) => {
      $as_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props(p$2);
      return (!$uZ(ev$2.defaultPrevented))
    }));
    var co = $n($$x1).flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$, condition), new $c_sjsr_AnonFunction1(((p$3$2) => {
      var p$3 = $as_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props(p$3$2);
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_top).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$3 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x4).flatMap$extension__F0__F1__F0($n($$x3).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x2, this$3.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((root$2) => {
        var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var $$x5 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p$3).Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_activateButton).Ljapgolly_scalajs_react_Ref$$anon$1__f_get)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$4 = $m_s_$less$colon$less$();
        var this$$1 = $n($$x7).map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($n($$x6).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x5, this$4.s_$less$colon$less$__f_singleton), new $c_sjsr_AnonFunction1(((activateButton$2) => {
          var node = ev$2.target;
          return $ct_T2__O__O__(new $c_T2(), activateButton$2, node)
        })), null);
        var condition$1 = new $c_sjsr_AnonFunction1(((x$19$2) => {
          var x$19 = $as_T2(x$19$2);
          if ((x$19 !== null)) {
            var activateButton = $n(x$19)._1__O();
            var node$1 = $n(x$19)._2__O();
            return ((!$uZ(root$2.contains(node$1))) && (!$uZ(activateButton.contains(node$1))))
          } else {
            throw new $c_s_MatchError(x$19)
          }
        }));
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x8).flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$$1, condition$1), new $c_sjsr_AnonFunction1(((x$21$2) => {
          var x$21 = $as_T2(x$21$2);
          if ((x$21 !== null)) {
            $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
            var this$$2 = $n(p$3).Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_close;
            var f = new $c_sjsr_AnonFunction1(((x$20$2) => {
              $as_jl_Void(x$20$2)
            }));
            var this$7 = $n(this$$2);
            var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$7, f);
            var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c)
          } else {
            var $$x9;
            throw new $c_s_MatchError(x$21)
          };
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($$x9)
        }))))
      }))))
    })));
    var $$x10 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$10 = $m_s_$less$colon$less$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x10).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$10.s_$less$colon$less$__f_singleton))
  }))
}
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend.prototype.render__Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, c) {
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexRow;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_expandableSelectorEnd;
  var array = [$$x2, $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c))];
  var $$x1 = $n($n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var r = this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend__f_top;
  return $n($$x1).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(r))
});
function $as_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ExpandablePicker$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ExpandablePicker$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ExpandablePicker$Backend", {
  Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ExpandablePicker$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Processing$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Processing$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Processing$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.persist__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_model_InvoicePage__I__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, invoicePage, way) {
  return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x4 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x3 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistInvoicePage"];
    var $$x2 = $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$17 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
    var evidence$2 = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
    var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(invoicePage, evidence$2);
    var $$x1 = $ct_T2__O__O__(new $c_T2(), "x", y);
    var this$11 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$12 = $n(new $c_Lautowire_ClientProxy(this$11).Lautowire_ClientProxy__f_self);
    var evidence$2$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
    var y$1 = this$12.write__O__Lio_circe_Encoder__Lio_circe_Json(way, evidence$2$1);
    var array$1 = [$$x1, $ct_T2__O__O__(new $c_T2(), "way", y$1)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($n($$x4).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x2, this$17.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$18 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$20 = $n(new $c_Lautowire_ClientProxy(this$18).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var d = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$39(d);
      return $as_s_Option(this$20.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((nextInvoicePageOpt$2) => {
      var nextInvoicePageOpt = $as_s_Option(nextInvoicePageOpt$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.goto__Lreactbuild_analyze_cost_modules_Processing$Props__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(p, nextInvoicePageOpt))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.goto__Lreactbuild_analyze_cost_modules_Processing$Props__s_Option__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, nextInvoicePageOpt) {
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_Processing$State(x$1$2);
    $n(x$1);
    var x = $m_s_None$();
    if ((x === nextInvoicePageOpt)) {
      var invoicePage = $m_Ldiode_data_Empty$()
    } else {
      if ((!(nextInvoicePageOpt instanceof $c_s_Some))) {
        throw new $c_s_MatchError(nextInvoicePageOpt)
      };
      var x3 = $as_s_Some(nextInvoicePageOpt);
      var v = $as_Lreactbuild_model_InvoicePage($n(x3).s_Some__f_value);
      var invoicePage = new $c_Ldiode_data_Ready(v)
    };
    return new $c_Lreactbuild_analyze_cost_modules_Processing$State(invoicePage)
  })), new $c_sjsr_AnonFunction0((() => {
    var this$4 = $n($n($n(p).Lreactbuild_analyze_cost_modules_Processing$Props__f_pageProps).Lreactbuild_package$PageProps__f_router);
    var this$3 = $n(nextInvoicePageOpt);
    if (this$3.isEmpty__Z()) {
      var $$x1 = $m_s_None$()
    } else {
      var arg1 = this$3.get__O();
      var x$2 = $as_Lreactbuild_model_InvoicePage(arg1);
      var $$x1 = new $c_s_Some($n(x$2).Lreactbuild_model_InvoicePage__f__id)
    };
    var route = new $c_Lreactbuild_Loc$Processing($$x1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.save__I__Ljapgolly_scalajs_react_callback_Trampoline = (function(way) {
  var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$1 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_Processing$Props(p$2);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_modules_Processing$State(s$2);
      var this$4 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var oca = new $c_sjsr_AnonFunction0((() => {
        var this$2 = $n($n(s).Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage);
        var this$3 = $n(((!this$2.isEmpty__Z()) ? new $c_s_Some(this$2.get__O()) : $m_s_None$()));
        if (this$3.isEmpty__Z()) {
          return $m_s_None$()
        } else {
          var arg1 = this$3.get__O();
          var v = $as_Lreactbuild_model_InvoicePage(arg1);
          return new $c_s_Some(new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.persist__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_model_InvoicePage__I__Ljapgolly_scalajs_react_callback_Trampoline(p, v, way)))
        }
      }));
      var this$5 = $m_Ljapgolly_scalajs_react_util_Util$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(oca, this$5.Ljapgolly_scalajs_react_util_Util$__f_identity))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$1)
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.trash__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_modules_Processing$State(s$2);
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
      var this$2 = $n($n(s).Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage);
      return ((!this$2.isEmpty__Z()) ? new $c_s_Some(this$2.get__O()) : $m_s_None$())
    })));
    var condition = new $c_sjsr_AnonFunction1(((invoicePage$2) => {
      var invoicePage = $as_Lreactbuild_model_InvoicePage(invoicePage$2);
      return $n($n(invoicePage).Lreactbuild_model_InvoicePage__f_deletedAt).isEmpty__Z()
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x1).flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$, condition), new $c_sjsr_AnonFunction1(((invoicePage$3$2) => {
      var invoicePage$3 = $as_Lreactbuild_model_InvoicePage(invoicePage$3$2);
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).prompt__T__T__Ljapgolly_scalajs_react_callback_Trampoline("Confirmez la suppression en tapant DELETE en lettre majuscules :", ""));
      var condition$1 = new $c_sjsr_AnonFunction1(((userInput$2) => {
        var userInput = $as_s_Option(userInput$2);
        var this$4 = $n(userInput);
        if ((!this$4.isEmpty__Z())) {
          var arg1 = this$4.get__O();
          var x$3 = $as_T(arg1);
          return ($f_T__trim__T($n(x$3)) === "DELETE")
        } else {
          return false
        }
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x2).flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$$1, condition$1), new $c_sjsr_AnonFunction1(((userInput$3$2) => {
        $as_s_Option(userInput$3$2);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((p$2) => {
          var p = $as_Lreactbuild_analyze_cost_modules_Processing$Props(p$2);
          $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
          new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
          var $$x3 = $m_Ljava_time_Instant$();
          var this$10 = $m_RTLong$();
          var value = $uD(new Date().getTime());
          var lo = this$10.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
          var hi = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var x$1 = new $c_s_Some($n($$x3).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi)));
          var this$11 = $n(invoicePage$3);
          var x$2 = this$11.Lreactbuild_model_InvoicePage__f__id;
          var this$12 = $n(invoicePage$3);
          var x$3$1 = this$12.Lreactbuild_model_InvoicePage__f_organization;
          var this$13 = $n(invoicePage$3);
          var x$4 = this$13.Lreactbuild_model_InvoicePage__f_file;
          var this$14 = $n(invoicePage$3);
          var x$5 = this$14.Lreactbuild_model_InvoicePage__f_notDone;
          var this$15 = $n(invoicePage$3);
          var x$6 = this$15.Lreactbuild_model_InvoicePage__f_supplier;
          var this$16 = $n(invoicePage$3);
          var x$7 = this$16.Lreactbuild_model_InvoicePage__f_supplierOffice;
          var this$17 = $n(invoicePage$3);
          var x$8 = this$17.Lreactbuild_model_InvoicePage__f_date;
          var this$18 = $n(invoicePage$3);
          var x$9 = this$18.Lreactbuild_model_InvoicePage__f_reference;
          var this$19 = $n(invoicePage$3);
          var x$10 = this$19.Lreactbuild_model_InvoicePage__f_pageIndex;
          var this$20 = $n(invoicePage$3);
          var x$11 = this$20.Lreactbuild_model_InvoicePage__f_pageCount;
          var this$21 = $n(invoicePage$3);
          var x$12 = this$21.Lreactbuild_model_InvoicePage__f_amount;
          var this$22 = $n(invoicePage$3);
          var x$13 = this$22.Lreactbuild_model_InvoicePage__f_totalAmount;
          var this$23 = $n(invoicePage$3);
          var x$14 = this$23.Lreactbuild_model_InvoicePage__f_details;
          var this$24 = $n(invoicePage$3);
          var x$15 = this$24.Lreactbuild_model_InvoicePage__f_entryNumber;
          var this$25 = $n(invoicePage$3);
          var x$16 = this$25.Lreactbuild_model_InvoicePage__f_category;
          $n(invoicePage$3);
          var this$$2 = this.persist__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_model_InvoicePage__I__Ljapgolly_scalajs_react_callback_Trampoline(p, new $c_Lreactbuild_model_InvoicePage(x$2, x$3$1, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$1), 1);
          var f = new $c_sjsr_AnonFunction1(((x$4$2$2) => {
            $as_jl_Void(x$4$2$2)
          }));
          var this$28 = $n(this$$2);
          var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$28, f);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
        }))))
      }))))
    }))))
  })));
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$31 = $m_s_$less$colon$less$();
  return $n($$x4).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$31.s_$less$colon$less$__f_singleton)
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.render__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_analyze_cost_modules_Processing$State__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var pageProps = $n(p).Lreactbuild_analyze_cost_modules_Processing$Props__f_pageProps;
  var this$1 = $n($n(pageProps).Lreactbuild_package$PageProps__f_proxy);
  var this$2 = $n(this$1.Ldiode_react_ModelProxy__f_modelReader);
  $as_Lreactbuild_analyze_cost_services_Model(this$2.value__O());
  var this$3 = $n($n(s).Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage);
  var x1 = ((!this$3.isEmpty__Z()) ? new $c_s_Some(this$3.get__O()) : $m_s_None$());
  var x = $m_s_None$();
  if ((x === x1)) {
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = ("No invoice found ! " + $n(s).Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Refresh")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
      var this$13 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x3 = new $c_Lautowire_ClientProxy(this$13).Lautowire_ClientProxy__f_self;
      var $$x2 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "getFirstInQueue"];
      var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$17 = $n($m_s_Predef$().s_Predef$__f_Map);
      var elems = $m_sci_Nil$();
      return $n($n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$17.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$18 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$20 = $n(new $c_Lautowire_ClientProxy(this$18).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        var d = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
        var evidence$1 = new $c_Lio_circe_Decoder$$anon$39(d);
        return $as_s_Option(this$20.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((r$2) => {
        var r = $as_s_Option(r$2);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.goto__Lreactbuild_analyze_cost_modules_Processing$Props__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(p, r))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var array$2 = [$$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var v$1 = $as_Lreactbuild_model_InvoicePage($n(x3).s_Some__f_value);
    $m_s_Option$().apply__O__s_Option($n(v$1).Lreactbuild_model_InvoicePage__f_organization);
    var $$x50 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x49 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key);
    var this$29 = $n($n(v$1).Lreactbuild_model_InvoicePage__f_file);
    if (this$29.isEmpty__Z()) {
      var this$30 = $n($n(v$1).Lreactbuild_model_InvoicePage__f__id);
      var $$x48 = $m_sr_ScalaRunTime$()._toString__s_Product__T(this$30)
    } else {
      var arg1 = this$29.get__O();
      var x$5 = $as_Lreactbuild_model_InvoicePageFile(arg1);
      var $$x48 = $n(x$5).Lreactbuild_model_InvoicePageFile__f_path
    };
    var $$x47 = $n($$x49).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($$x48, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var $$x46 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x45 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$34 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
    var $$x44 = this$34.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x43 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x42 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x41 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x40 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x38 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var u = $m_Lreactbuild_analyze_cost_components_PDFViewer$().apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(v$1).Lreactbuild_model_InvoicePage__f__id);
    var this$43 = $n(u);
    var n = this$43.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$3 = [$$x38, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    var $$x37 = $n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x35 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x33 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowY")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x32 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x31 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x30 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "padding")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0.5em 1em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x29 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).boxSizing__Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("border-box", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("-50")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.save__I__Ljapgolly_scalajs_react_callback_Trampoline((-50))))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var $$x25 = $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("-10")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.save__I__Ljapgolly_scalajs_react_callback_Trampoline((-10))))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var $$x23 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
    var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Pr\u00e9c\u00e9dent")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.save__I__Ljapgolly_scalajs_react_callback_Trampoline((-1))))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var $$x21 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x20 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Facture");
    var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Suivant")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.save__I__Ljapgolly_scalajs_react_callback_Trampoline(1)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var $$x18 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$8 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("+10")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.save__I__Ljapgolly_scalajs_react_callback_Trampoline(10)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var $$x16 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$9 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("+50")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.save__I__Ljapgolly_scalajs_react_callback_Trampoline(50)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var $$x14 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x12 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("DETRUIRE");
    var $$x11 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.trash__Ljapgolly_scalajs_react_callback_Trampoline()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$114 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "disabled");
    var this$113 = $n($n(v$1).Lreactbuild_model_InvoicePage__f_deletedAt);
    var a = (!this$113.isEmpty__Z());
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
    var array$10 = [$$x12, $$x11, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$114.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a)];
    var array$11 = [$$x25, $$x23, $$x21, $$x20, $$x18, $$x16, $$x14, $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
    var $$x10 = $n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h2", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
    var $$x8 = $m_Lreactbuild_analyze_cost_components_DocumentPageEditor$().apply__Ldiode_data_Pot__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode(new $c_Ldiode_data_Ready($m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), v$1), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$2 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x9;
        var p2 = $as_s_Option(x1$2.T2__f__1);
        if ((p2 instanceof $c_s_Some)) {
          var x3$1 = $as_s_Some(p2);
          var v$2 = $as_Lreactbuild_model_InvoicePage($n(x3$1).s_Some__f_value);
          var this$123 = $n(this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$);
          var mod = new $c_sjsr_AnonFunction1(((s$2) => {
            var s$1 = $as_Lreactbuild_analyze_cost_modules_Processing$State(s$2);
            $n(s$1);
            var invoicePage = $n($n(s$1).Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$6$2) => {
              $as_Lreactbuild_model_InvoicePage(x$6$2);
              return v$2
            })));
            return new $c_Lreactbuild_analyze_cost_modules_Processing$State(invoicePage)
          }));
          var $$x9 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$123, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1$2.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$2 = $m_s_None$();
        if ((x$2 === p4)) {
          var $$x9 = cb;
          break matchEnd7
        };
        throw new $c_s_MatchError(x1$2)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x9)
    })))), $n(p).Lreactbuild_analyze_cost_modules_Processing$Props__f_pageProps);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$12 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Enregister")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.save__I__Ljapgolly_scalajs_react_callback_Trampoline(1)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var array$13 = [$$x10, $$x8, $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
    var array$14 = [$$x33, $$x32, $$x31, $$x30, $$x29, $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
    var array$15 = [$$x35, $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
    var array$16 = [$$x42, $$x41, $$x40, $$x37, $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
    var array$17 = [$$x47, $$x46, $$x45, $$x44, $n($$x43).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
    return $n($$x50).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.onPropsChange__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_analyze_cost_modules_Processing$Props__Lreactbuild_analyze_cost_modules_Processing$State__Ljapgolly_scalajs_react_callback_Trampoline = (function(prevProps, nextProps, state) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var x = $n(prevProps).Lreactbuild_analyze_cost_modules_Processing$Props__f_ref;
  var x$2 = $n(nextProps).Lreactbuild_analyze_cost_modules_Processing$Props__f_ref;
  if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
    var this$1 = $n($n(state).Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage);
    if ((!this$1.isEmpty__Z())) {
      var arg1 = this$1.get__O();
      var page = $as_Lreactbuild_model_InvoicePage(arg1);
      var this$2 = $n($n(nextProps).Lreactbuild_analyze_cost_modules_Processing$Props__f_ref);
      if ((!this$2.isEmpty__Z())) {
        var arg1$1 = this$2.get__O();
        var x$7 = $as_Lreactbuild_common_model_RefTo(arg1$1);
        var x$2$1 = $n(page).Lreactbuild_model_InvoicePage__f__id;
        var $$x1 = ((x$7 === null) ? (x$2$1 === null) : $n(x$7).equals__O__Z(x$2$1))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    var cond = (!$$x1)
  } else {
    var cond = false
  };
  if (cond) {
    var x1 = $n(nextProps).Lreactbuild_analyze_cost_modules_Processing$Props__f_ref;
    var x$1 = $m_s_None$();
    if ((x$1 === x1)) {
      var this$6 = $n(this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lreactbuild_analyze_cost_modules_Processing$State(s$2);
        $n(s);
        var invoicePage = $m_Ldiode_data_Empty$();
        return new $c_Lreactbuild_analyze_cost_modules_Processing$State(invoicePage)
      }));
      var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$6, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else {
      if ((!(x1 instanceof $c_s_Some))) {
        throw new $c_s_MatchError(x1)
      };
      var x3 = $as_s_Some(x1);
      var ref = $as_Lreactbuild_common_model_RefTo($n(x3).s_Some__f_value);
      var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$3$2) => {
        var s$3 = $as_Lreactbuild_analyze_cost_modules_Processing$State(s$3$2);
        $n(s$3);
        var this$9 = $ct_ju_Date__(new $c_ju_Date());
        var t = this$9.ju_Date__f_java$util$Date$$millis;
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var invoicePage$1 = new $c_Ldiode_data_Pending(new $c_RTLong(lo, hi));
        return new $c_Lreactbuild_analyze_cost_modules_Processing$State(invoicePage$1)
      })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
        var this$12 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x5 = new $c_Lautowire_ClientProxy(this$12).Lautowire_ClientProxy__f_self;
        var $$x4 = $m_s_package$().s_package$__f_Seq;
        var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "getInvoicePage"];
        var $$x3 = $as_sci_Seq($n($$x4).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
        var this$23 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$17 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$18 = $n(new $c_Lautowire_ClientProxy(this$17).Lautowire_ClientProxy__f_self);
        var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
        var y = this$18.write__O__Lio_circe_Encoder__Lio_circe_Json(ref, evidence$2);
        var array$1 = [$ct_T2__O__O__(new $c_T2(), "ref", y)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        return $n($n($n($$x5).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x3, this$23.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1$1 = $as_Lio_circe_Json(x$1$2);
          var this$24 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$25 = $n(new $c_Lautowire_ClientProxy(this$24).Lautowire_ClientProxy__f_self);
          var evidence$1 = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
          return $as_Lreactbuild_model_InvoicePage(this$25.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1$1, evidence$1))
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((v$2) => {
          var v = $as_Lreactbuild_model_InvoicePage(v$2);
          var this$28 = $n(this.Lreactbuild_analyze_cost_modules_Processing$Backend__f_$);
          var mod$1 = new $c_sjsr_AnonFunction1(((s$2$1) => {
            var s$1 = $as_Lreactbuild_analyze_cost_modules_Processing$State(s$2$1);
            $n(s$1);
            $n($n(s$1).Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage);
            var invoicePage$2 = new $c_Ldiode_data_Ready(v);
            return new $c_Lreactbuild_analyze_cost_modules_Processing$State(invoicePage$2)
          }));
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$28, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    };
    var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.fromKeyboardEvent__Lorg_scalajs_dom_KeyboardEvent__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent = (function(ev) {
  var value = $uI(ev.location);
  var $$x9 = $ct_T2__O__O__(new $c_T2(), "location", value);
  var value$1 = $uZ(ev.altKey);
  var $$x8 = $ct_T2__O__O__(new $c_T2(), "altKey", value$1);
  var value$2 = $uZ(ev.ctrlKey);
  var $$x7 = $ct_T2__O__O__(new $c_T2(), "ctrlKey", value$2);
  var value$3 = $uZ(ev.metaKey);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "metaKey", value$3);
  var value$4 = $uZ(ev.shiftKey);
  var $$x5 = $ct_T2__O__O__(new $c_T2(), "shiftKey", value$4);
  var value$5 = $uZ(ev.repeat);
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "repeat", value$5);
  var s = $as_T(ev.key);
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "key", s);
  var value$6 = $uI(ev.charCode);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "charCode", value$6);
  var value$7 = $uI(ev.keyCode);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "keyCode", value$7);
  var s$1 = $as_T(ev.key);
  var array = [$$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "which", s$1)];
  var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
  return ev
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.onKeyDown__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((e$2) => {
    var ev = this.fromKeyboardEvent__Lorg_scalajs_dom_KeyboardEvent__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent(e$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionExt$();
    $m_Ljapgolly_scalajs_react_package$();
    $m_Ljapgolly_scalajs_react_package$();
    $m_Ljapgolly_scalajs_react_package$();
    var qual$1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackOptionObjExt$();
    var x$6 = new $c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1(this);
    var self$1 = qual$1.keyEventSwitch__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__O__Z__Z__Z__Z__s_PartialFunction__F0(ev, $uI(ev.keyCode), false, true, false, false, x$6);
    var co = $n($$x1).asEventDefault$extension__F0__Ljapgolly_scalajs_react_facade_SyntheticEvent__F0(self$1, ev);
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$5 = $m_s_$less$colon$less$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$5.s_$less$colon$less$__f_singleton))
  }))
});
function $as_Lreactbuild_analyze_cost_modules_Processing$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Processing$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Processing$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Processing$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Processing$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Processing$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Processing$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Processing$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_Processing$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Processing$Backend: 0
}, false, "reactbuild.analyze.cost.modules.Processing$Backend", {
  Lreactbuild_analyze_cost_modules_Processing$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Processing$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Projects$$anon$4(pageProps$3) {
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$4__f_name = null;
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$4__f_icon = null;
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$4__f_pageProps$3 = null;
  this.Lreactbuild_analyze_cost_modules_Projects$$anon$4__f_pageProps$3 = pageProps$3;
  $f_Lcom_iz2use_react_components_internal_multiview_GanttRenderer__$init$__V(this)
}
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$4.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$4.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Projects$$anon$4;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Projects$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Projects$$anon$4.prototype = $c_Lreactbuild_analyze_cost_modules_Projects$$anon$4.prototype;
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$4.prototype.defaultOrder__I = (function() {
  return 800
});
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$4.prototype.name__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_Projects$$anon$4__f_name
});
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$4.prototype.icon__Lcom_iz2use_react_components_IconSourceShape = (function() {
  return this.Lreactbuild_analyze_cost_modules_Projects$$anon$4__f_icon
});
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$4.prototype.render__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_react_components_internal_multiview_MultiviewDecorator__Ljapgolly_scalajs_react_vdom_VdomElement = (function(items, iterator, keyMapper, context, itemSimpleActions, decorator) {
  var u = $m_Lreactbuild_analyze_cost_modules_planner_Planner$().apply__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(this.Lreactbuild_analyze_cost_modules_Projects$$anon$4__f_pageProps$3).Lreactbuild_package$PageProps__f_proxy);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
var $d_Lreactbuild_analyze_cost_modules_Projects$$anon$4 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Projects$$anon$4: 0
}, false, "reactbuild.analyze.cost.modules.Projects$$anon$4", {
  Lreactbuild_analyze_cost_modules_Projects$$anon$4: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_GanttRenderer: 1,
  Lcom_iz2use_react_components_internal_multiview_View: 1
});
$c_Lreactbuild_analyze_cost_modules_Projects$$anon$4.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Projects$$anon$4;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_orgReuse = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_dateReuse = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_refReuse = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_activeReuse = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_dateRef = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization
  }));
  var set = new $c_sjsr_AnonFunction1(((org$2) => {
    var org = $as_s_Option(org$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$2$2);
      var this$3 = $n(x$2);
      var x$2$2$1 = this$3.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date;
      var this$4 = $n(x$2);
      var x$3 = this$4.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference;
      var this$5 = $n(x$2);
      var x$4 = this$5.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active;
      $n(x$2);
      return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$2$2$1, x$3, org, x$4)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$9 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$9.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_orgReuse = $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w);
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$1 = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$3$2);
    return $n(x$3$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date
  }));
  var set$1 = new $c_sjsr_AnonFunction1(((date$2) => {
    var date = $as_s_Option(date$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$4$2);
      $n(x$4$1);
      var this$10 = $n(x$4$1);
      var reference = this$10.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference;
      var this$11 = $n(x$4$1);
      var organization = this$11.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization;
      var this$12 = $n(x$4$1);
      var active = this$12.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active;
      return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(date, reference, organization, active)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$1, set$1);
  var this$16 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$1 = this$16.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_dateReuse = $n($$x4).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x3, \u03b4, w$1);
  var $$x6 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$2 = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$5$2);
    return $n(x$5).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference
  }));
  var set$2 = new $c_sjsr_AnonFunction1(((reference$2) => {
    var reference$1 = $as_s_Option(reference$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$6$2);
      var this$17 = $n(x$6);
      var x$6$2$1 = this$17.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date;
      var this$18 = $n(x$6);
      var x$7 = this$18.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization;
      var this$19 = $n(x$6);
      var x$8 = this$19.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active;
      $n(x$6);
      return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$6$2$1, reference$1, x$7, x$8)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x5 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$2, set$2);
  var this$23 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$2 = this$23.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_refReuse = $n($$x6).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x5, \u03b4, w$2);
  var $$x8 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$3 = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$7$2);
    return $n(x$7$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active
  }));
  var set$3 = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_s_Option(s$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$8$2);
      var this$24 = $n(x$8$1);
      var x$10 = this$24.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date;
      var this$25 = $n(x$8$1);
      var x$11 = this$25.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference;
      var this$26 = $n(x$8$1);
      var x$12 = this$26.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization;
      $n(x$8$1);
      return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$10, x$11, x$12, s)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x7 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$3, set$3);
  var this$30 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$3 = this$30.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_activeReuse = $n($$x8).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x7, \u03b4, w$3);
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$32 = $n(this$);
    var this$33 = $n($n($as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$32))).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active);
    if (this$33.isEmpty__Z()) {
      var $$x9 = $m_s_None$()
    } else {
      var arg1 = this$33.get__O();
      var v = $as_Lreactbuild_model_ChildWithParent(arg1);
      var this$34 = $n($n($as_Lreactbuild_model_InvoiceDetail($n(v).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_deliveryDate);
      var $$x9 = (this$34.isEmpty__Z() ? $n($as_Lreactbuild_model_InvoicePage($n(v).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f_date : this$34)
    };
    var this$35 = $n($$x9);
    if (this$35.isEmpty__Z()) {
      var this$36 = $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Date);
      var this$37 = $m_Ljava_time_LocalDate$();
      var $$x10 = this$36.fromLocalDate__Ljava_time_LocalDate__Lreactbuild_common_model_Date(this$37.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId())))
    } else {
      var $$x10 = this$35.get__O()
    };
    return $as_Lreactbuild_common_model_Date($$x10)
  }));
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_dateRef = new $c_Lcom_iz2use_common_ParsingReference$Simple(f)
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend.prototype.render__Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_proxy;
  var this$1 = $n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_proxy);
  var this$2 = $n(this$1.Ldiode_react_ModelProxy__f_modelReader);
  $as_Lreactbuild_analyze_cost_services_Model(this$2.value__O());
  var $$x1 = $n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_activeReuse);
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Lreactbuild_model_Implicits$();
  var this$4 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$4.byRef__F2(), this$4.by_$eq$eq__F2());
  var active = $n($$x1).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$5.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var $$x44 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$8 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_horizontalLayout;
  var $$x43 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$8, s$1);
  var $$x42 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x41 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$12 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_verticalLayout;
  var $$x40 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$12, s$2);
  var $$x39 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("50%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x38 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$17 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x37 = this$17.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$18 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x36 = this$18.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Organisation");
  var $$x34 = $n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_orgReuse);
  var this$21 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$1 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  var state = $n($$x34).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$21.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$1));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$23 = $m_Lreactbuild_model_Implicits$();
  var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$23, proxy);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$24 = $m_Lreactbuild_model_Implicits$();
  var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$24, proxy);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$28 = $m_Lreactbuild_model_Implicits$();
  var this$27 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$27, proxy);
  var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$28, ev);
  var $$x35 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$1, explainError, equiv);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date de livraison");
  var $$x32 = $n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_dateReuse);
  var this$32 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$2 = $m_Lreactbuild_model_Implicits$().reusabilityDate__F2();
  var state$1 = $n($$x32).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$32.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$2));
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser = $m_Lreactbuild_model_Implicits$().dateParsable__Lcom_iz2use_common_ParsingReference__Lcom_iz2use_common_Parsable(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_dateRef);
  var ev$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$35 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$35);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
  var $$x33 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$2, explainError$1, equiv$1);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence");
  var $$x31 = $n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend__f_refReuse);
  var this$42 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$41 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$3 = this$41.by_$eq$eq__F2();
  var state$2 = $n($$x31).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$42.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$3));
  var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$3);
  var ev$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$47 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$47);
  var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
  var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv = $m_s_math_Equiv$String$();
  var equiv$2 = new $c_s_math_Equiv$OptionEquiv(eqv);
  var array = [$$x37, $$x36, $$x35, $$x33, editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$2, optioner$2, ev$4, explainError$2, equiv$2)];
  var $$x30 = $n($$x38).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$57 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_verticalLayout;
  var $$x28 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$57, s$3);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$59 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
  var $$x27 = this$59.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$163 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$159 = $n($n(s).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date);
  var f$2 = new $c_sjsr_AnonFunction1(((date$2) => {
    var date = $as_Lreactbuild_common_model_Date(date$2);
    var this$158 = $n($n(s).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference);
    var f$1 = new $c_sjsr_AnonFunction1(((reference$2) => {
      var reference = $as_T(reference$2);
      var this$157 = $n($n(s).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization);
      var f = new $c_sjsr_AnonFunction1(((organization$2) => {
        var organization = $as_Lreactbuild_common_model_RefTo(organization$2);
        var $$x26 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
        var $$x22 = new $c_sjsr_AnonFunction1(((date$3) => {
          var date$1 = $as_Lreactbuild_common_model_Date(date$3);
          var this$61 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var $$x25 = new $c_Lautowire_ClientProxy(this$61).Lautowire_ClientProxy__f_self;
          var $$x24 = $m_s_package$().s_package$__f_Seq;
          var array$1 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listInvoiceDetails"];
          var $$x23 = $as_sci_Seq($n($$x24).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
          var this$72 = $n($m_s_Predef$().s_Predef$__f_Map);
          var this$66 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$67 = $n(new $c_Lautowire_ClientProxy(this$66).Lautowire_ClientProxy__f_self);
          var evidence$2$1 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
          var y = this$67.write__O__Lio_circe_Encoder__Lio_circe_Json(date$1, evidence$2$1);
          var array$2 = [$ct_T2__O__O__(new $c_T2(), "date", y)];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
          return $n($n($$x25).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x23, this$72.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
            var x$1 = $as_Lio_circe_Json(x$1$2);
            var this$73 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var this$75 = $n(new $c_Lautowire_ClientProxy(this$73).Lautowire_ClientProxy__f_self);
            $m_Lio_circe_Decoder$();
            var decodeA = $m_Lreactbuild_model_ChildWithParent$().decodeChildWithParent__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_model_InvoiceDetail$().Lreactbuild_model_InvoiceDetail$__f_codecForInvoiceDetail, $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage);
            var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
            return $as_sci_List(this$75.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
          })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
        }));
        var $$x8 = new $c_sjsr_AnonFunction1(((invoiceLines$2) => {
          var invoiceLines = $as_Ldiode_data_Pot(invoiceLines$2);
          return $m_Lcom_iz2use_react_components_FetchCacheAndRender$().withKey__T__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_vdom_VdomElement((("" + date) + reference), new $c_sjsr_AnonFunction0((() => {
            var this$76 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var $$x12 = new $c_Lautowire_ClientProxy(this$76).Lautowire_ClientProxy__f_self;
            var $$x11 = $m_s_package$().s_package$__f_Seq;
            var array$3 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listReconcileInvoicePageWithDeliveryForm"];
            var $$x10 = $as_sci_Seq($n($$x11).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)));
            var this$91 = $n($m_s_Predef$().s_Predef$__f_Map);
            var this$81 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var this$82 = $n(new $c_Lautowire_ClientProxy(this$81).Lautowire_ClientProxy__f_self);
            var evidence$2$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
            var y$1 = this$82.write__O__Lio_circe_Encoder__Lio_circe_Json(organization, evidence$2$2);
            var $$x9 = $ct_T2__O__O__(new $c_T2(), "organization", y$1);
            var this$85 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var this$86 = $n(new $c_Lautowire_ClientProxy(this$85).Lautowire_ClientProxy__f_self);
            var evidence$2$3 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
            var y$2 = this$86.write__O__Lio_circe_Encoder__Lio_circe_Json(date, evidence$2$3);
            var array$4 = [$$x9, $ct_T2__O__O__(new $c_T2(), "date", y$2)];
            var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
            return $n($n($$x12).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x10, this$91.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
              var x$2 = $as_Lio_circe_Json(x$2$2);
              var this$92 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
              var this$94 = $n(new $c_Lautowire_ClientProxy(this$92).Lautowire_ClientProxy__f_self);
              $m_Lio_circe_Decoder$();
              var decodeA$1 = $m_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$().Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$__f_codecForReconcileInvoicePageWithDeliveryForm;
              var evidence$1$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA$1);
              return $as_sci_List(this$94.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2, evidence$1$1))
            })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
          })), new $c_sjsr_AnonFunction1(((x$9$2) => {
            var x$9 = $as_Ldiode_data_Pot(x$9$2);
            return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode(x$9, new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode())), new $c_sjsr_AnonFunction1(((deliveryForms$2) => {
              var deliveryForms = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(deliveryForms$2);
              var form = $n(deliveryForms).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$10$2) => {
                var x$10 = $as_sci_List(x$10$2);
                var this$97 = $n($n(x$10).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$11$2) => {
                  var x$11 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x$11$2);
                  return ($n(x$11).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference === reference)
                }))));
                var default$1 = new $c_sjsr_AnonFunction0((() => {
                  var x$6 = $m_s_package$().s_package$__f_Nil;
                  $m_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$();
                  $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
                  var x$7 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
                  return new $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x$7, organization, date, reference, x$6)
                }));
                return $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm((this$97.isEmpty__Z() ? default$1.apply__O() : this$97.get__O()))
              })), new $c_sjsr_AnonFunction1(((v$2) => {
                var v = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(v$2);
                return new $c_sjsr_AnonFunction1(((lst$2) => {
                  var lst = $as_sci_List(lst$2);
                  var this$98 = $n(lst);
                  var p$1 = new $c_sjsr_AnonFunction1(((x$12$2) => {
                    var x$12 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x$12$2);
                    var x = $n(x$12).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id;
                    var x$2$1 = $n(v).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id;
                    return ((x === null) ? (x$2$1 === null) : $n(x).equals__O__Z(x$2$1))
                  }));
                  var x1 = $f_sc_LinearSeqOps__indexWhere__F1__I__I(this$98, p$1, 0);
                  if ((x1 === (-1))) {
                    var this$99 = $n(lst);
                    return $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$99, v))
                  } else {
                    var this$101 = $n(lst);
                    var this$100 = $n($m_s_package$().s_package$__f_Nil);
                    var other = new $c_sci_$colon$colon(v, this$100);
                    return $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$101, x1, other, 1))
                  }
                }))
              })));
              var this$102 = $n($as_sci_List($n(deliveryForms).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
              var p$2 = new $c_sjsr_AnonFunction1(((x$13$2) => {
                var x$13 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x$13$2);
                var x$3 = $n(x$13).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id;
                var x$2$3 = $n($as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm($n(form).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id;
                return ((x$3 === null) ? (x$2$3 === null) : $n(x$3).equals__O__Z(x$2$3))
              }));
              var otherDeliveryForms = $p_sci_List__filterCommon__F1__Z__sci_List(this$102, p$2, true);
              var this$154 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
              var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
              $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
              $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
              var $$x20 = $m_Lreactbuild_analyze_cost_components_ExpandableCard$();
              $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
              $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
              var $$x19 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Autres bons de livraison de la journ\u00e9e");
              var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
              $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
              $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
              var array$6 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), otherDeliveryForms), new $c_sjsr_AnonFunction1(((form$2$2) => {
                var form$2 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(form$2$2);
                var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
                $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
                $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
                $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
                var v$1 = $n(form$2).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference;
                $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
                var array$5 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
                return $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
              })))];
              var array$7 = [$n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
              var u = $n($$x20).apply__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x19, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
              var this$124 = $n(u);
              var n = this$124.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
              var array$8 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
              var $$x16 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
              var u$1 = $m_Lreactbuild_analyze_cost_components_AutomaticallySave$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__F1__F1__F2__Lcom_iz2use_common_KeyMapper__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(form, new $c_sjsr_AnonFunction1(((v$3$2) => {
                var v$3 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(v$3$2);
                return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
                  var this$129 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                  var $$x15 = new $c_Lautowire_ClientProxy(this$129).Lautowire_ClientProxy__f_self;
                  var $$x14 = $m_s_package$().s_package$__f_Seq;
                  var array$9 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistReconcileInvoicePageWithDeliveryForm"];
                  var $$x13 = $as_sci_Seq($n($$x14).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9)));
                  var this$140 = $n($m_s_Predef$().s_Predef$__f_Map);
                  var this$134 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                  var this$135 = $n(new $c_Lautowire_ClientProxy(this$134).Lautowire_ClientProxy__f_self);
                  var evidence$2$4 = $m_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$().Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$__f_codecForReconcileInvoicePageWithDeliveryForm;
                  var y$3 = this$135.write__O__Lio_circe_Encoder__Lio_circe_Json(v$3, evidence$2$4);
                  var array$10 = [$ct_T2__O__O__(new $c_T2(), "x", y$3)];
                  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
                  return $n($n($n($$x15).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x13, this$140.from__sc_IterableOnce__sci_Map(elems$2)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$8$2) => {
                    var x$8 = $as_Lio_circe_Json(x$8$2);
                    var this$141 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                    var this$142 = $n(new $c_Lautowire_ClientProxy(this$141).Lautowire_ClientProxy__f_self);
                    var evidence$1$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
                    this$142.read__Lio_circe_Json__Lio_circe_Decoder__O(x$8, evidence$1$2)
                  })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$14$2) => {
                    $as_jl_Void(x$14$2);
                    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
                  })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
                })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue))
              })), new $c_sjsr_AnonFunction1(((savedForm$2) => {
                var savedForm = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(savedForm$2);
                var ss = $n(savedForm).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$15$2) => {
                  var x$15 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x$15$2);
                  return $n(x$15).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_details
                })), new $c_sjsr_AnonFunction1(((details$2) => {
                  var details = $as_sci_List(details$2);
                  return new $c_sjsr_AnonFunction1(((x$16$2) => {
                    var x$16 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x$16$2);
                    var this$143 = $n(x$16);
                    var x$10$1 = this$143.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id;
                    var this$144 = $n(x$16);
                    var x$11$1 = this$144.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_organization;
                    var this$145 = $n(x$16);
                    var x$12$1 = this$145.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_date;
                    var this$146 = $n(x$16);
                    var x$13$1 = this$146.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference;
                    $n(x$16);
                    return new $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x$10$1, x$11$1, x$12$1, x$13$1, details)
                  }))
                })));
                return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode(invoiceLines, new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode())), new $c_sjsr_AnonFunction1(((invoiceLines$2$1) => {
                  var invoiceLines$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(invoiceLines$2$1);
                  return $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_common_model_Date__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomElement(invoiceLines$1, ss, date, active, otherDeliveryForms)
                })))
              })), $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$().Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$__f_reuseReconcileInvoicePageWithDeliveryForm, $m_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$().keyMapperReconcileInvoicePageWithDeliveryForm__Lcom_iz2use_common_KeyMapper());
              var this$149 = $n(u$1);
              var n$1 = this$149.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
              var array$11 = [$$x16, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
              var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
              return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$154, null, ns)
            })))
          })), $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$().Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$__f_reuseReconcileInvoicePageWithDeliveryForm), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
        }));
        var $$x7 = $m_Lreactbuild_model_Implicits$().reusabilityDate__F2();
        var $$x6 = $m_Ljapgolly_scalajs_react_Reusability$();
        $m_Lreactbuild_model_Implicits$();
        var this$156 = $m_Ljapgolly_scalajs_react_Reusability$();
        return $n($$x26).query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(date, $$x22, $$x8, $$x7, $n($$x6).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$156.byRef__F2(), this$156.by_$eq$eq__F2())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      }));
      return (this$157.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$157.get__O())))
    }));
    return (this$158.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$1.apply__O__O(this$158.get__O())))
  }));
  var o = (this$159.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$2.apply__O__O(this$159.get__O())));
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var f$3 = new $c_sjsr_AnonFunction1(((u$2) => {
    var u$3 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(u$2);
    var this$161 = $n(u$3);
    var n$2 = this$161.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
  }));
  var array$12 = [$$x28, $$x27, $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode__vdomNodeFromOption__O__Ljapgolly_scalajs_react_util_OptionLike__F1__Ljapgolly_scalajs_react_vdom_VdomNode(this$163, o, O, f$3)];
  var array$13 = [$$x40, $$x39, $$x30, $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  var $$x5 = $n($$x41).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$172 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_verticalLayout;
  var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$172, s$4);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$174 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
  var $$x2 = this$174.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var o$1 = $n(s).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active;
  var O$1 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var array$14 = [$$x3, $$x2, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o$1, O$1).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((sel$2) => {
    var sel = $as_Lreactbuild_model_ChildWithParent(sel$2);
    var u$4 = $m_Lreactbuild_analyze_cost_components_PDFViewer$().apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n($as_Lreactbuild_model_InvoicePage($n(sel).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f__id);
    var this$177 = $n(u$4);
    var n$3 = this$177.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)
  })))];
  var array$15 = [$$x43, $$x42, $$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  return $n($$x44).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))
});
function $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReconcileDeliveryForm$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReconcileDeliveryForm$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryForm$Backend", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x1;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x1 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $as_Lreactbuild_model_MissingDeliveryFormDetails($n(x5).s_Some__f_value);
        var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$17$2) => {
          var x$17 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(x$17$2);
          $n(x$17);
          return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(v)
        })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f)
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend.prototype.render__Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x42 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_tabularView;
  var $$x41 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var $$x40 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x38 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence"))];
  var $$x37 = $n($$x38).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Description"))];
  var $$x35 = $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Qt\u00e9 factur\u00e9e"))];
  var $$x33 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Qt\u00e9 livr\u00e9e, tous bons confondus"))];
  var $$x31 = $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Qt\u00e9 livr\u00e9e pour ce bon"))];
  var $$x29 = $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Unit\u00e9"))];
  var $$x27 = $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix unitaire"))];
  var $$x25 = $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix total HT"))];
  var $$x23 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$8 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix livr\u00e9 HT"))];
  var $$x21 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
  var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$9 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Fournisseur"))];
  var $$x19 = $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$10 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence"))];
  var $$x17 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
  var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$11 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Corps d'\u00e9tat"))];
  var $$x15 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$12 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chantier"))];
  var array$13 = [$$x37, $$x35, $$x33, $$x31, $$x29, $$x27, $$x25, $$x23, $$x21, $$x19, $$x17, $$x15, $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  var array$14 = [$n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
  var $$x13 = $n($$x40).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $as_sc_IterableOnce($n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_invoiceDetails).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var $$x7 = $n($$x8).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((invoiceDetail$2) => {
    var invoiceDetail = $as_Lreactbuild_model_ChildWithParent(invoiceDetail$2);
    var $$x10 = $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$();
    var $$x9 = new $c_s_Some(invoiceDetail);
    var this$116 = $n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_reconciliationLines);
    var g = new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_s_Option(v$2);
      return new $c_sjsr_AnonFunction1(((lst$2) => {
        var lst = $as_sci_List(lst$2);
        var this$109 = $n(lst);
        var eta$0$1 = new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1(this, invoiceDetail);
        _return: {
          var i = 0;
          var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$109, 0, this$109);
          while (true) {
            var this$112 = $n(these);
            if ((!this$112.isEmpty__Z())) {
              var arg1 = $n(these).head__O();
              var x = $as_Lreactbuild_model_DeliveryFormDetails(arg1);
              if (eta$0$1.isDefinedAt__Lreactbuild_model_DeliveryFormDetails__Z(x)) {
                var x1 = i;
                break _return
              };
              i = ((1 + i) | 0);
              these = $as_sc_LinearSeq($n(these).tail__O())
            } else {
              break
            }
          };
          var x1 = (-1)
        };
        if ((x1 === (-1))) {
          var this$113 = $n(v);
          if (this$113.isEmpty__Z()) {
            return lst
          } else {
            var arg1$1 = this$113.get__O();
            var x$19 = $as_Lreactbuild_model_DeliveryFormDetails(arg1$1);
            var this$114 = $n(lst);
            return $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$114, x$19))
          }
        } else {
          var this$115 = $n(lst);
          var other = $n(v).toList__sci_List();
          return $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$115, x1, other, 1))
        }
      }))
    }));
    var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$116.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
    var arg1$2 = this$116.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$18 = $as_sci_List(arg1$2);
    var this$117 = $n(x$18);
    var pf = new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1(this, invoiceDetail);
    var u = $n($$x10).apply__s_Option__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_common_model_Date__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x9, $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$116, $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this$117, pf), new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
      var ot = $as_s_Option(ot$2);
      var $$x11 = $n($as_F2($n(this$116.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
      var this$118 = $n(ot);
      return $n($$x11).apply__O__O__O((this$118.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$118.get__O()))), cb$2)
    }))), $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_date, $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_active, $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_deliveryForms, $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_proxy);
    var this$120 = $n(u);
    var n = this$120.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })));
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as$1 = $n($as_sci_List($n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_reconciliationLines).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39(this, p));
  var $$x5 = $n($$x6).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((u$2) => {
    var u$1 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(u$2);
    var this$124 = $n(u$1);
    var n$1 = this$124.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  })));
  var $$x3 = $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$();
  var $$x2 = $m_s_None$();
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value = $m_s_Option$().apply__O__s_Option($n(s).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State__f_newReconciliationLine);
  var u$3 = $n($$x3).apply__s_Option__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_common_model_Date__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x2, $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var _2 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1);
    matchEnd8: {
      var $$x4;
      var cb = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((x0$1 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x0$1);
        var p4 = $as_s_Option($n(x3).s_Some__f_value);
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v$1 = $as_Lreactbuild_model_DeliveryFormDetails($n(x5).s_Some__f_value);
          var this$139 = $n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_reconciliationLines);
          var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$22$2) => {
            var x$22 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(x$22$2);
            $n(x$22);
            var x$2 = $m_s_Option$().apply__O__s_Option($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_date);
            $m_Lreactbuild_model_InvoiceDetail$();
            var x$3 = $m_ju_UUID$().randomUUID__ju_UUID();
            $m_Lreactbuild_model_InvoiceDetail$();
            var x$4 = $m_s_None$();
            $m_Lreactbuild_model_InvoiceDetail$();
            var x$5 = $m_s_None$();
            $m_Lreactbuild_model_InvoiceDetail$();
            var x$6 = $m_s_None$();
            $m_Lreactbuild_model_InvoiceDetail$();
            var x$7 = $m_s_None$();
            $m_Lreactbuild_model_InvoiceDetail$();
            var x$8 = $m_s_None$();
            $m_Lreactbuild_model_InvoiceDetail$();
            var x$9 = $m_s_None$();
            $m_Lreactbuild_model_InvoiceDetail$();
            var x$10 = $m_s_None$();
            $m_Lreactbuild_model_InvoiceDetail$();
            var x$11 = $m_s_None$();
            var newReconciliationLine = new $c_Lreactbuild_model_MissingDeliveryFormDetails(new $c_Lreactbuild_model_InvoiceDetail(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$2));
            return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(newReconciliationLine)
          })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)));
          var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
          var arg1$3 = this$139.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
          var x$21 = $as_sci_List(arg1$3);
          var this$140 = $n(x$21);
          var arg1$4 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$140, v$1));
          var $$x4 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$139.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$4), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          break matchEnd8
        }
      };
      var cb$2$1 = _2.Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x4 = cb$2$1
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x4)
  }))), $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_date, $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_active, $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_deliveryForms, $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_proxy);
  var this$142 = $n(u$3);
  var n$2 = this$142.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$15 = [$$x7, $$x5, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
  var array$16 = [$$x41, $$x13, $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
  return $n($$x42).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))
});
function $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$Backend", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend;
function $p_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__takeOrGenerate$1__Lreactbuild_model_ChildWithParent__F1($thiz, invoiceDetail$3) {
  return new $c_sjsr_AnonFunction1(((x$24$2) => {
    var x$24 = $as_s_Option(x$24$2);
    var this$2 = $n(x$24);
    if (this$2.isEmpty__Z()) {
      var $$x1 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$25 = $as_Lreactbuild_model_DeliveryFormDetails(arg1);
      var $$x1 = $n(x$25).asReconcilied__s_Option()
    };
    var this$3 = $n($$x1);
    if (this$3.isEmpty__Z()) {
      var x$1 = $n($as_Lreactbuild_model_InvoicePage($n(invoiceDetail$3).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f__id;
      var x$2 = $n($as_Lreactbuild_model_InvoicePage($n(invoiceDetail$3).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f_supplier;
      var x$3 = $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail$3).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_id;
      var x$5 = $m_s_None$();
      var x$6 = $m_ju_UUID$().randomUUID__ju_UUID();
      return new $c_s_Some(new $c_Lreactbuild_model_ReconciliedDeliveryFormDetails(x$6, x$1, x$2, x$3, 0.0, x$5))
    } else {
      return this$3
    }
  }))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype.click__s_Option__F1 = (function(v) {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    var $$x1 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
    $m_Ljapgolly_scalajs_react_package$();
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((x$23$2) => {
      var x$23 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props(x$23$2);
      var this$2 = $n($n(x$23).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_active);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$2, v))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    var self = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f);
    var this$$1 = $n($$x1).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty))
  }))
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype.render__Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__jl_Void__Ljapgolly_scalajs_react_vdom_TagOf = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_proxy;
  var x1 = $n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_invoiceDetail;
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var invoiceDetail = $as_Lreactbuild_model_ChildWithParent($n(x2).s_Some__f_value);
    var active = $as_s_Option($n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var this$3 = $n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_deliveryForms);
    var op$1 = new $c_sjsr_AnonFunction2(((acc$2, form$2) => {
      var acc = $uD(acc$2);
      var form = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(form$2);
      var this$2 = $n($n(form).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_details);
      var op = new $c_sjsr_AnonFunction2(((acc$2$2, c$2) => {
        var acc$2$1 = $uD(acc$2$2);
        var c = $as_Lreactbuild_model_DeliveryFormDetails(c$2);
        return ($n(c).isSameLine__Lreactbuild_common_model_RefTo__ju_UUID__Z($n($as_Lreactbuild_model_InvoicePage($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f__id, $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_id) ? (acc$2$1 + $n(c).deliveredQuantity__D()) : acc$2$1)
      }));
      return $uD($f_sc_LinearSeqOps__foldLeft__O__F2__O(this$2, acc, op))
    }));
    var $$x1 = $uD($f_sc_LinearSeqOps__foldLeft__O__F2__O(this$3, 0.0, op$1));
    var this$4 = $n($as_s_Option($n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_reconciliationLine).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
    var ifEmpty = new $c_sjsr_AnonFunction0((() => 0.0));
    var f = new $c_sjsr_AnonFunction1(((x$26$2) => {
      var x$26 = $as_Lreactbuild_model_DeliveryFormDetails(x$26$2);
      return $n(x$26).deliveredQuantity__D()
    }));
    var totalDelivered = ($$x1 + $uD((this$4.isEmpty__Z() ? ifEmpty.apply__O() : f.apply__O__O(this$4.get__O()))));
    var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var x1$2 = $n(active).contains__O__Z(invoiceDetail);
    if ((x1$2 === true)) {
      var this$7 = $m_Lscalacss_ScalaCssReact$();
      var s$1 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_multiviewFocused;
      var $$x28 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$1)
    } else if ((x1$2 === false)) {
      var this$8 = $n($n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_quantity);
      var p$1 = new $c_sjsr_AnonFunction1(((x$27$2) => {
        var x$27 = $uD(x$27$2);
        return (x$27 === totalDelivered)
      }));
      if (((!this$8.isEmpty__Z()) && $uZ(p$1.apply__O__O(this$8.get__O())))) {
        var $$x28 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hsla(120, 100%, 50%, 0.12)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
      } else {
        var $$x28 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hsla(36, 100%, 50%, 0.12)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)
      }
    } else {
      var $$x28;
      throw new $c_s_MatchError(x1$2)
    };
    var $$x27 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.click__s_Option__F1(new $c_s_Some(invoiceDetail)), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v = $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_reference;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable);
    var v$1 = ev.stringify__s_Option__T(v);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    var $$x25 = $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$2 = $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_description;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
    var v$3 = ev$1.stringify__s_Option__T(v$2);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
    var $$x23 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$4 = $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_quantity;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var ev$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$2);
    var v$5 = ev$2.stringify__s_Option__T(v$4);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
    var $$x21 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$6 = new $c_Lreactbuild_model_Price(totalDelivered);
    var ev$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var v$7 = $n(ev$3).stringify__O__T(v$6);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)];
    var $$x19 = $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Quantit\u00e9 livr\u00e9e");
    var state = $n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_reconciliationLine).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$28$2) => {
      var x$28 = $as_s_Option(x$28$2);
      var this$55 = $n(x$28);
      var f$1 = new $c_sjsr_AnonFunction1(((x$29$2) => {
        var x$29 = $as_Lreactbuild_model_DeliveryFormDetails(x$29$2);
        return $n(x$29).deliveredQuantity__D()
      }));
      return (this$55.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$1.apply__O__O(this$55.get__O())))
    })), new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x = $m_s_None$();
      if ((x === x0$1)) {
        return new $c_sjsr_AnonFunction1(((x$30$2) => {
          $as_s_Option(x$30$2);
          return $m_s_None$()
        }))
      } else if ((x0$1 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x0$1);
        var v$8 = $uD($n(x3).s_Some__f_value);
        return new $c_sjsr_AnonFunction1(((x$31$2) => {
          var x$31 = $as_s_Option(x$31$2);
          var this$62 = $n($as_s_Option($n($p_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__takeOrGenerate$1__Lreactbuild_model_ChildWithParent__F1(this, invoiceDetail)).apply__O__O(x$31)));
          var f$2 = new $c_sjsr_AnonFunction1(((x$32$2) => {
            var x$32 = $as_Lreactbuild_model_ReconciliedDeliveryFormDetails(x$32$2);
            var this$56 = $n(x$32);
            var x$2 = this$56.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id;
            var this$57 = $n(x$32);
            var x$3 = this$57.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
            var this$58 = $n(x$32);
            var x$4 = this$58.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier;
            var this$59 = $n(x$32);
            var x$5 = this$59.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
            var this$60 = $n(x$32);
            var x$6 = this$60.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount;
            $n(x$32);
            return new $c_Lreactbuild_model_ReconciliedDeliveryFormDetails(x$2, x$3, x$4, x$5, v$8, x$6)
          }));
          return (this$62.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$2.apply__O__O(this$62.get__O())))
        }))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })));
    var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$4);
    var ev$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$67 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$67);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
    var equiv = new $c_s_math_Equiv$OptionEquiv(eqv);
    var array$4 = [editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$5, explainError, equiv)];
    var $$x17 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$9 = $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_unit;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$6 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$3);
    var v$10 = ev$6.stringify__s_Option__T(v$9);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$5 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$10)];
    var $$x15 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$11 = $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_unitPrice;
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var ev$7 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
    var v$12 = ev$7.stringify__s_Option__T(v$11);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$12)];
    var $$x13 = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$13 = $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_amount;
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var ev$8 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1);
    var v$14 = ev$8.stringify__s_Option__T(v$13);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$7 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$14)];
    var $$x11 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
    var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix diff\u00e9rent sur bon de livraison");
    var state$1 = $n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_reconciliationLine).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$33$2) => {
      var x$33 = $as_s_Option(x$33$2);
      var this$107 = $n(x$33);
      var f$3 = new $c_sjsr_AnonFunction1(((x$34$2) => {
        var x$34 = $as_Lreactbuild_model_DeliveryFormDetails(x$34$2);
        return $n(x$34).amount__s_Option()
      }));
      return (this$107.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$3.apply__O__O(this$107.get__O())))
    })), new $c_sjsr_AnonFunction1(((v$2$1) => {
      var v$15 = $as_s_Option(v$2$1);
      return new $c_sjsr_AnonFunction1(((x$35$2) => {
        var x$35 = $as_s_Option(x$35$2);
        var this$114 = $n($as_s_Option($n($p_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend__takeOrGenerate$1__Lreactbuild_model_ChildWithParent__F1(this, invoiceDetail)).apply__O__O(x$35)));
        var f$4 = new $c_sjsr_AnonFunction1(((x$36$2) => {
          var x$36 = $as_Lreactbuild_model_ReconciliedDeliveryFormDetails(x$36$2);
          var this$108 = $n(x$36);
          var x$8 = this$108.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id;
          var this$109 = $n(x$36);
          var x$9 = this$109.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
          var this$110 = $n(x$36);
          var x$10 = this$110.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier;
          var this$111 = $n(x$36);
          var x$11 = this$111.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
          var this$112 = $n(x$36);
          var x$12 = this$112.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity;
          $n(x$36);
          return new $c_Lreactbuild_model_ReconciliedDeliveryFormDetails(x$8, x$9, x$10, x$11, x$12, v$15)
        }));
        return (this$114.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$4.apply__O__O(this$114.get__O())))
      }))
    })));
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var ev$9 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$117 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$117);
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
    var array$8 = [editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$9, explainError$1, equiv$1)];
    var $$x9 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$16 = $n($as_Lreactbuild_model_InvoicePage($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f_supplier;
    $m_Lcom_iz2use_common_Textualizable$();
    var this$126 = $m_Lreactbuild_model_Implicits$();
    var textualizable$2 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$126, proxy);
    var ev$10 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$2);
    var v$17 = ev$10.stringify__s_Option__T(v$16);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$9 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$17)];
    var $$x7 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$18 = $n($as_Lreactbuild_model_InvoicePage($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f_reference;
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var ev$11 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$4);
    var v$19 = ev$11.stringify__s_Option__T(v$18);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$10 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$19)];
    var $$x5 = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$20 = $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_tradeBody;
    $m_Lcom_iz2use_common_Textualizable$();
    var this$146 = $m_Lreactbuild_model_Implicits$();
    var textualizable$3 = $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$146, proxy);
    var ev$12 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$3);
    var v$21 = ev$12.stringify__s_Option__T(v$20);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$11 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$21)];
    var $$x3 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var v$22 = $n($as_Lreactbuild_model_InvoiceDetail($n(invoiceDetail).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_buildingSite;
    $m_Lcom_iz2use_common_Textualizable$();
    var this$156 = $m_Lreactbuild_model_Implicits$();
    var textualizable$4 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$156, proxy);
    var ev$13 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$4);
    var v$23 = ev$13.stringify__s_Option__T(v$22);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$12 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$23)];
    var array$13 = [$$x28, $$x27, $$x25, $$x23, $$x21, $$x19, $$x17, $$x15, $$x13, $$x11, $$x9, $$x7, $$x5, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
    return $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))
  } else {
    var x$1 = $m_s_None$();
    if ((x$1 === x1)) {
      var ss = $n($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_reconciliationLine).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x0$2$2) => {
        var x0$2 = $as_s_Option(x0$2$2);
        if ((x0$2 instanceof $c_s_Some)) {
          var x2$1 = $as_s_Some(x0$2);
          var p3 = $as_Lreactbuild_model_DeliveryFormDetails($n(x2$1).s_Some__f_value);
          if ((p3 instanceof $c_Lreactbuild_model_MissingDeliveryFormDetails)) {
            var x4 = $as_Lreactbuild_model_MissingDeliveryFormDetails(p3);
            var c$1 = $n(x4).Lreactbuild_model_MissingDeliveryFormDetails__f_content;
            return c$1
          }
        };
        var x$13 = $m_s_Option$().apply__O__s_Option($n(p).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_date);
        $m_Lreactbuild_model_InvoiceDetail$();
        var x$14 = $m_ju_UUID$().randomUUID__ju_UUID();
        $m_Lreactbuild_model_InvoiceDetail$();
        var x$15 = $m_s_None$();
        $m_Lreactbuild_model_InvoiceDetail$();
        var x$16 = $m_s_None$();
        $m_Lreactbuild_model_InvoiceDetail$();
        var x$17 = $m_s_None$();
        $m_Lreactbuild_model_InvoiceDetail$();
        var x$18 = $m_s_None$();
        $m_Lreactbuild_model_InvoiceDetail$();
        var x$19 = $m_s_None$();
        $m_Lreactbuild_model_InvoiceDetail$();
        var x$20 = $m_s_None$();
        $m_Lreactbuild_model_InvoiceDetail$();
        var x$21 = $m_s_None$();
        $m_Lreactbuild_model_InvoiceDetail$();
        var x$22 = $m_s_None$();
        return new $c_Lreactbuild_model_InvoiceDetail(x$14, x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$13)
      })), new $c_sjsr_AnonFunction1(((v$3$2) => {
        var v$3$1 = $as_Lreactbuild_model_InvoiceDetail(v$3$2);
        return new $c_sjsr_AnonFunction1(((x$37$2) => {
          $as_s_Option(x$37$2);
          return $m_s_Option$().apply__O__s_Option(new $c_Lreactbuild_model_MissingDeliveryFormDetails(v$3$1))
        }))
      })));
      var $$x51 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x50 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hsla(0, 100%, 50%, 0.12)", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x49 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f\u00e9rence");
      var state$2 = $n(ss).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$38$2) => {
        var x$38 = $as_Lreactbuild_model_InvoiceDetail(x$38$2);
        return $n(x$38).Lreactbuild_model_InvoiceDetail__f_reference
      })), new $c_sjsr_AnonFunction1(((v$4$2) => {
        var v$4$1 = $as_s_Option(v$4$2);
        return new $c_sjsr_AnonFunction1(((x$39$2) => {
          var x$39 = $as_Lreactbuild_model_InvoiceDetail(x$39$2);
          var this$184 = $n(x$39);
          var x$24 = this$184.Lreactbuild_model_InvoiceDetail__f_id;
          var this$185 = $n(x$39);
          var x$25 = this$185.Lreactbuild_model_InvoiceDetail__f_description;
          var this$186 = $n(x$39);
          var x$26$1 = this$186.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$187 = $n(x$39);
          var x$27$1 = this$187.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$188 = $n(x$39);
          var x$28$1 = this$188.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$189 = $n(x$39);
          var x$29$1 = this$189.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$190 = $n(x$39);
          var x$30$1 = this$190.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$191 = $n(x$39);
          var x$31$1 = this$191.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$192 = $n(x$39);
          var x$32$1 = this$192.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$39);
          return new $c_Lreactbuild_model_InvoiceDetail(x$24, v$4$1, x$25, x$26$1, x$27$1, x$28$1, x$29$1, x$30$1, x$31$1, x$32$1)
        }))
      })));
      var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$14 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$14);
      var ev$15 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$198 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$198);
      var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
      var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var eqv$1 = $m_s_math_Equiv$String$();
      var equiv$2 = new $c_s_math_Equiv$OptionEquiv(eqv$1);
      var array$14 = [editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$2, optioner$2, ev$15, explainError$2, equiv$2)];
      var $$x48 = $n($$x49).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
      var $$x47 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Description");
      var state$3 = $n(ss).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$40$2) => {
        var x$40 = $as_Lreactbuild_model_InvoiceDetail(x$40$2);
        return $n(x$40).Lreactbuild_model_InvoiceDetail__f_description
      })), new $c_sjsr_AnonFunction1(((v$5$2) => {
        var v$5$1 = $as_s_Option(v$5$2);
        return new $c_sjsr_AnonFunction1(((x$41$2) => {
          var x$41 = $as_Lreactbuild_model_InvoiceDetail(x$41$2);
          var this$210 = $n(x$41);
          var x$34$1 = this$210.Lreactbuild_model_InvoiceDetail__f_id;
          var this$211 = $n(x$41);
          var x$35$1 = this$211.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$212 = $n(x$41);
          var x$36$1 = this$212.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$213 = $n(x$41);
          var x$37$1 = this$213.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$214 = $n(x$41);
          var x$38$1 = this$214.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$215 = $n(x$41);
          var x$39$1 = this$215.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$216 = $n(x$41);
          var x$40$1 = this$216.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$217 = $n(x$41);
          var x$41$2$1 = this$217.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$218 = $n(x$41);
          var x$42 = this$218.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$41);
          return new $c_Lreactbuild_model_InvoiceDetail(x$34$1, x$35$1, v$5$1, x$36$1, x$37$1, x$38$1, x$39$1, x$40$1, x$41$2$1, x$42)
        }))
      })));
      var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$16 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$3 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$16);
      var ev$17 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$224 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$224);
      var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
      var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var eqv$2 = $m_s_math_Equiv$String$();
      var equiv$3 = new $c_s_math_Equiv$OptionEquiv(eqv$2);
      var array$15 = [editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$3, optioner$3, ev$17, explainError$3, equiv$3)];
      var $$x46 = $n($$x47).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15));
      var $$x45 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
      var $$x44 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
      var $$x43 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Quantit\u00e9 livr\u00e9e");
      var state$4 = $n(ss).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$42$2) => {
        var x$42$1 = $as_Lreactbuild_model_InvoiceDetail(x$42$2);
        return $n(x$42$1).Lreactbuild_model_InvoiceDetail__f_quantity
      })), new $c_sjsr_AnonFunction1(((v$6$2) => {
        var v$6$1 = $as_s_Option(v$6$2);
        return new $c_sjsr_AnonFunction1(((x$43$2) => {
          var x$43 = $as_Lreactbuild_model_InvoiceDetail(x$43$2);
          var this$240 = $n(x$43);
          var x$44 = this$240.Lreactbuild_model_InvoiceDetail__f_id;
          var this$241 = $n(x$43);
          var x$45 = this$241.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$242 = $n(x$43);
          var x$46 = this$242.Lreactbuild_model_InvoiceDetail__f_description;
          var this$243 = $n(x$43);
          var x$47 = this$243.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$244 = $n(x$43);
          var x$48 = this$244.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$245 = $n(x$43);
          var x$49 = this$245.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$246 = $n(x$43);
          var x$50 = this$246.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$247 = $n(x$43);
          var x$51 = this$247.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$248 = $n(x$43);
          var x$52 = this$248.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$43);
          return new $c_Lreactbuild_model_InvoiceDetail(x$44, x$45, x$46, v$6$1, x$47, x$48, x$49, x$50, x$51, x$52)
        }))
      })));
      var evDefault$3 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$18 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
      var parser$4 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$18);
      var ev$19 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$254 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper$4 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$254);
      var editorComponent$4 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$4);
      var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var eqv$3 = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
      var equiv$4 = new $c_s_math_Equiv$OptionEquiv(eqv$3);
      var array$16 = [editorComponent$4.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$4, state$4, optioner$4, ev$19, explainError$4, equiv$4)];
      var $$x42 = $n($$x43).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
      var $$x41 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Unit\u00e9");
      var state$5 = $n(ss).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$44$2) => {
        var x$44$1 = $as_Lreactbuild_model_InvoiceDetail(x$44$2);
        return $n(x$44$1).Lreactbuild_model_InvoiceDetail__f_unit
      })), new $c_sjsr_AnonFunction1(((v$7$2) => {
        var v$7$1 = $as_s_Option(v$7$2);
        return new $c_sjsr_AnonFunction1(((x$45$2) => {
          var x$45$1 = $as_Lreactbuild_model_InvoiceDetail(x$45$2);
          var this$266 = $n(x$45$1);
          var x$54 = this$266.Lreactbuild_model_InvoiceDetail__f_id;
          var this$267 = $n(x$45$1);
          var x$55 = this$267.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$268 = $n(x$45$1);
          var x$56 = this$268.Lreactbuild_model_InvoiceDetail__f_description;
          var this$269 = $n(x$45$1);
          var x$57 = this$269.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$270 = $n(x$45$1);
          var x$58 = this$270.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$271 = $n(x$45$1);
          var x$59 = this$271.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$272 = $n(x$45$1);
          var x$60 = this$272.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$273 = $n(x$45$1);
          var x$61 = this$273.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$274 = $n(x$45$1);
          var x$62 = this$274.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$45$1);
          return new $c_Lreactbuild_model_InvoiceDetail(x$54, x$55, x$56, x$57, v$7$1, x$58, x$59, x$60, x$61, x$62)
        }))
      })));
      var evDefault$4 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$5 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$4);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$20 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$5 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$20);
      var ev$21 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$280 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper$5 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$280);
      var editorComponent$5 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$5);
      var explainError$5 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var eqv$4 = $m_s_math_Equiv$String$();
      var equiv$5 = new $c_s_math_Equiv$OptionEquiv(eqv$4);
      var array$17 = [editorComponent$5.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$5, state$5, optioner$5, ev$21, explainError$5, equiv$5)];
      var $$x40 = $n($$x41).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17));
      var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix unitaire");
      var state$6 = $n(ss).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$46$2) => {
        var x$46$1 = $as_Lreactbuild_model_InvoiceDetail(x$46$2);
        return $n(x$46$1).Lreactbuild_model_InvoiceDetail__f_unitPrice
      })), new $c_sjsr_AnonFunction1(((v$8$2) => {
        var v$8$1 = $as_s_Option(v$8$2);
        return new $c_sjsr_AnonFunction1(((x$47$2) => {
          var x$47$1 = $as_Lreactbuild_model_InvoiceDetail(x$47$2);
          var this$292 = $n(x$47$1);
          var x$64 = this$292.Lreactbuild_model_InvoiceDetail__f_id;
          var this$293 = $n(x$47$1);
          var x$65 = this$293.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$294 = $n(x$47$1);
          var x$66 = this$294.Lreactbuild_model_InvoiceDetail__f_description;
          var this$295 = $n(x$47$1);
          var x$67 = this$295.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$296 = $n(x$47$1);
          var x$68 = this$296.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$297 = $n(x$47$1);
          var x$69 = this$297.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$298 = $n(x$47$1);
          var x$70 = this$298.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$299 = $n(x$47$1);
          var x$71 = this$299.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$300 = $n(x$47$1);
          var x$72 = this$300.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$47$1);
          return new $c_Lreactbuild_model_InvoiceDetail(x$64, x$65, x$66, x$67, x$68, v$8$1, x$69, x$70, x$71, x$72)
        }))
      })));
      var optioner$6 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var ev$22 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$304 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper$6 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$304);
      var editorComponent$6 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$6);
      var explainError$6 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var equiv$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var array$18 = [editorComponent$6.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$6, state$6, optioner$6, ev$22, explainError$6, equiv$6)];
      var $$x38 = $n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18));
      var $$x37 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
      var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$7 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Prix livr\u00e9 HT");
      var state$7 = $n(ss).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$48$2) => {
        var x$48$1 = $as_Lreactbuild_model_InvoiceDetail(x$48$2);
        return $n(x$48$1).Lreactbuild_model_InvoiceDetail__f_amount
      })), new $c_sjsr_AnonFunction1(((v$9$2) => {
        var v$9$1 = $as_s_Option(v$9$2);
        return new $c_sjsr_AnonFunction1(((x$49$2) => {
          var x$49$1 = $as_Lreactbuild_model_InvoiceDetail(x$49$2);
          var this$317 = $n(x$49$1);
          var x$74 = this$317.Lreactbuild_model_InvoiceDetail__f_id;
          var this$318 = $n(x$49$1);
          var x$75 = this$318.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$319 = $n(x$49$1);
          var x$76 = this$319.Lreactbuild_model_InvoiceDetail__f_description;
          var this$320 = $n(x$49$1);
          var x$77 = this$320.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$321 = $n(x$49$1);
          var x$78 = this$321.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$322 = $n(x$49$1);
          var x$79 = this$322.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$323 = $n(x$49$1);
          var x$80 = this$323.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$324 = $n(x$49$1);
          var x$81 = this$324.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$325 = $n(x$49$1);
          var x$82 = this$325.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$49$1);
          return new $c_Lreactbuild_model_InvoiceDetail(x$74, x$75, x$76, x$77, x$78, x$79, v$9$1, x$80, x$81, x$82)
        }))
      })));
      var optioner$7 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var ev$23 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$329 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
      var helper$7 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$329);
      var editorComponent$7 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$7);
      var explainError$7 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var equiv$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var array$19 = [editorComponent$7.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$7, state$7, optioner$7, ev$23, explainError$7, equiv$7)];
      var $$x35 = $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19));
      var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
      var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "td"), $m_sci_Nil$());
      var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Corps d'\u00e9tat");
      var state$8 = $n(ss).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$50$2) => {
        var x$50$1 = $as_Lreactbuild_model_InvoiceDetail(x$50$2);
        return $n(x$50$1).Lreactbuild_model_InvoiceDetail__f_tradeBody
      })), new $c_sjsr_AnonFunction1(((v$10$2) => {
        var v$10$1 = $as_s_Option(v$10$2);
        return new $c_sjsr_AnonFunction1(((x$51$2) => {
          var x$51$1 = $as_Lreactbuild_model_InvoiceDetail(x$51$2);
          var this$344 = $n(x$51$1);
          var x$84 = this$344.Lreactbuild_model_InvoiceDetail__f_id;
          var this$345 = $n(x$51$1);
          var x$85 = this$345.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$346 = $n(x$51$1);
          var x$86 = this$346.Lreactbuild_model_InvoiceDetail__f_description;
          var this$347 = $n(x$51$1);
          var x$87 = this$347.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$348 = $n(x$51$1);
          var x$88 = this$348.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$349 = $n(x$51$1);
          var x$89 = this$349.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$350 = $n(x$51$1);
          var x$90 = this$350.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$351 = $n(x$51$1);
          var x$91 = this$351.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var this$352 = $n(x$51$1);
          var x$92 = this$352.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$51$1);
          return new $c_Lreactbuild_model_InvoiceDetail(x$84, x$85, x$86, x$87, x$88, x$89, x$90, v$10$1, x$91, x$92)
        }))
      })));
      var optioner$8 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var this$356 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var organization = $m_s_None$();
      var ev$25 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$16(this$356, proxy, organization);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$358 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var organization$1 = $m_s_None$();
      var helper$8 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$16(this$358, proxy, organization$1);
      var editorComponent$8 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$8);
      var explainError$8 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var this$362 = $m_Lreactbuild_model_Implicits$();
      var this$361 = $m_Lreactbuild_model_Implicits$();
      var ev$24 = $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$361, proxy);
      var equiv$8 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$362, ev$24);
      var array$20 = [editorComponent$8.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$8, state$8, optioner$8, ev$25, explainError$8, equiv$8)];
      var $$x31 = $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20));
      var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label$9 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chantier");
      var state$9 = $n(ss).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$52$2) => {
        var x$52$1 = $as_Lreactbuild_model_InvoiceDetail(x$52$2);
        return $n(x$52$1).Lreactbuild_model_InvoiceDetail__f_buildingSite
      })), new $c_sjsr_AnonFunction1(((v$11$2) => {
        var v$11$1 = $as_s_Option(v$11$2);
        return new $c_sjsr_AnonFunction1(((x$53$2) => {
          var x$53 = $as_Lreactbuild_model_InvoiceDetail(x$53$2);
          var this$371 = $n(x$53);
          var x$94 = this$371.Lreactbuild_model_InvoiceDetail__f_id;
          var this$372 = $n(x$53);
          var x$95 = this$372.Lreactbuild_model_InvoiceDetail__f_reference;
          var this$373 = $n(x$53);
          var x$96 = this$373.Lreactbuild_model_InvoiceDetail__f_description;
          var this$374 = $n(x$53);
          var x$97 = this$374.Lreactbuild_model_InvoiceDetail__f_quantity;
          var this$375 = $n(x$53);
          var x$98 = this$375.Lreactbuild_model_InvoiceDetail__f_unit;
          var this$376 = $n(x$53);
          var x$99 = this$376.Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var this$377 = $n(x$53);
          var x$100 = this$377.Lreactbuild_model_InvoiceDetail__f_amount;
          var this$378 = $n(x$53);
          var x$101 = this$378.Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var this$379 = $n(x$53);
          var x$102 = this$379.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          $n(x$53);
          return new $c_Lreactbuild_model_InvoiceDetail(x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, v$11$1, x$102)
        }))
      })));
      var optioner$9 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var this$382 = $m_Lreactbuild_model_Implicits$();
      var ev$27 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$382, proxy);
      $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
      var this$383 = $m_Lreactbuild_model_Implicits$();
      var helper$9 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$383, proxy);
      var editorComponent$9 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$9);
      var explainError$9 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var this$387 = $m_Lreactbuild_model_Implicits$();
      var this$386 = $m_Lreactbuild_model_Implicits$();
      var ev$26 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$386, proxy);
      var equiv$9 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$387, ev$26);
      var array$21 = [editorComponent$9.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$9, state$9, optioner$9, ev$27, explainError$9, equiv$9)];
      var array$22 = [$$x50, $$x48, $$x46, $$x45, $$x44, $$x42, $$x40, $$x38, $$x37, $$x35, $$x34, $$x33, $$x31, $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21))];
      return $n($$x51).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22))
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReconcileDeliveryLine$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReconcileDeliveryLine$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryLine$Backend", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Report$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_Report$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_Report$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_Report$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_Report$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_Report$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Report$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Report$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Report$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Report$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_Report$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_Report$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_Report$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_Report$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_Report$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_Report$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_Report$Backend.prototype.changeWeek__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((weeks$2) => {
    var weeks = $uI(weeks$2);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_Report$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_analyze_cost_modules_Report$Props(p$2);
      var this$3 = $n($n(p).Lreactbuild_analyze_cost_modules_Report$Props__f_router);
      var $$x1 = $n($n(p).Lreactbuild_analyze_cost_modules_Report$Props__f_periodRange).Lreactbuild_analyze_cost_modules_PeriodRange__f_start;
      var value = Math.imul(7, weeks);
      var hi = (value >> 31);
      var route = new $c_Lreactbuild_Loc$TimeReport(new $c_s_Some($n($$x1).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(value, hi))));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f))
  }))
});
$c_Lreactbuild_analyze_cost_modules_Report$Backend.prototype.render__Lreactbuild_analyze_cost_modules_Report$Props__Lreactbuild_analyze_cost_modules_Report$State__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  $n(p);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_autoScrollContainer;
  var $$x4 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$6 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x2 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x1 = this$7.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var c = $m_Lreactbuild_analyze_cost_modules_ReportFragment$().Lreactbuild_analyze_cost_modules_ReportFragment$__f_component;
  var this$9 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var props = new $c_Lreactbuild_analyze_cost_modules_ReportFragment$Props($n(p).Lreactbuild_analyze_cost_modules_Report$Props__f_proxy, $n(p).Lreactbuild_analyze_cost_modules_Report$Props__f_periodRange, this.changeWeek__F1());
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$9.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$9.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$11 = $n(u);
  var n = this$11.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [$$x2, $$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  var array$1 = [$$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
function $as_Lreactbuild_analyze_cost_modules_Report$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Report$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Report$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Report$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Report$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Report$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Report$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Report$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_Report$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Report$Backend: 0
}, false, "reactbuild.analyze.cost.modules.Report$Backend", {
  Lreactbuild_analyze_cost_modules_Report$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_Report$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Report$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend() {
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend.prototype.newItem__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$3 = $n(this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(x$6$2);
      $n(x$6);
      return new $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(true)
    }));
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    $m_Ljapgolly_scalajs_react_package$();
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
  }))
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend.prototype.render__Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var x1 = $n(s).Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState__f_active;
  if ((x1 === false)) {
    var $$x4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$());
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$3 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$3.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("+");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n($n(p).Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_fieldSpec).name__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.newItem__F1(), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    return $n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else if ((x1 === true)) {
    return $n($n(p).Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_fieldSpec).editor__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_VdomNode(new $c_sjsr_AnonFunction1(((x$7$2) => {
      var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x5 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_done).apply__O__O(x$7$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var this$15 = $n(this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$8$2) => {
        var x$8 = $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(x$8$2);
        $n(x$8);
        return new $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(false)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x6).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x5, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$15, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
    })), $n(p).Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_proxy)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportAddLevelItem$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportAddLevelItem$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend() {
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
function $as_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportExtractHeaders$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportExtractHeaders$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$ = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_ctx = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_ctx = new $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anon$5(this)
}
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragment$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype.updateTimeReports__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((o$2, n$2) => {
    var o = $as_s_Option(o$2);
    var n = $as_Lreactbuild_model_TimeReport(n$2);
    var this$10 = $n(this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_modules_ReportFragment$State(s$2);
      $n(s);
      var timeReports = $n($n(s).Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((lst$2) => {
        var lst = $as_sci_Seq(lst$2);
        var this$2 = $n(o);
        if (this$2.isEmpty__Z()) {
          var x1 = $m_s_None$()
        } else {
          var arg1 = this$2.get__O();
          var x$37 = $as_Lreactbuild_model_TimeReport(arg1);
          var this$3 = $n(lst);
          var x1 = new $c_s_Some(this$3.indexOf__O__I__I(x$37, 0))
        };
        if ((x1 instanceof $c_s_Some)) {
          var x2 = $as_s_Some(x1);
          var idx = $uI($n(x2).s_Some__f_value);
          if ((idx !== (-1))) {
            var $$x1 = $m_s_package$().s_package$__f_Seq;
            var array = [n];
            return $as_sci_Seq($n(lst).patch__I__sc_IterableOnce__I__O(idx, $n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), 1))
          }
        };
        var this$7 = $n(lst);
        return $as_sci_Seq(this$7.appended__O__O(n))
      })));
      var this$8 = $n(s);
      var searchItem = this$8.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem;
      return new $c_Lreactbuild_analyze_cost_modules_ReportFragment$State(timeReports, searchItem)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$10, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }))
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype.render__Lreactbuild_analyze_cost_modules_ReportFragment$Props__Lreactbuild_analyze_cost_modules_ReportFragment$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var u$2 = $m_Lcom_iz2use_react_components_UserPreference$().apply__F1__Lsourcecode_FullName__Lcom_iz2use_react_components_UserPreferenceStore__Lio_circe_Encoder__Lio_circe_Decoder__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((fieldOrdersState$2) => {
    var fieldOrdersState = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(fieldOrdersState$2);
    var this$2 = $n($as_s_Option($n(fieldOrdersState).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
    var fieldOrders = $as_sci_List((this$2.isEmpty__Z() ? $m_Lreactbuild_analyze_cost_modules_ReportFieldSpec$().Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_defaultList : this$2.get__O()));
    var this$44 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x13 = $m_Lreactbuild_analyze_cost_modules_ReportTotal$();
    var $$x12 = $n(p).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_proxy;
    var $$x11 = $n(p).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange;
    var this$3 = $n($n(s).Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports);
    var u = $n($$x13).apply__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_PeriodRange__sci_Seq__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x12, $$x11, $as_sci_Seq((this$3.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$3.get__O())), $n(p).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_changeWeek);
    var this$5 = $n(u);
    var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x14 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var this$7 = $n(fieldOrdersState);
    var g = new $c_sjsr_AnonFunction1(((x$39$2) => {
      var x$39 = $as_sci_List(x$39$2);
      return new $c_s_Some(x$39)
    }));
    var arg1 = this$7.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$38 = $as_s_Option(arg1);
    var this$8 = $n(x$38);
    var x$2 = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$7, $as_sci_List((this$8.isEmpty__Z() ? $m_Lreactbuild_analyze_cost_modules_ReportFieldSpec$().Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_defaultList : this$8.get__O())), new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
      var ot = $as_s_Option(ot$2);
      var $$x8 = $n($as_F2($n(this$7.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
      var this$9 = $n(ot);
      return $n($$x8).apply__O__O__O((this$9.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g.apply__O__O(this$9.get__O()))), cb$2)
    })));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var x$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ordre");
    var x$5 = new $c_sjsr_AnonFunction1(((field$2) => {
      var field = $as_Lreactbuild_analyze_cost_modules_ReportFieldSpec(field$2);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(field).name__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
    }));
    var x$6 = $m_Lcom_iz2use_react_components_Selector$().apply$default$6__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1(fieldOrders, x$2, x$3, false);
    var $$x9 = $m_Lcom_iz2use_react_components_Selector$();
    var this$14 = $m_Lcom_iz2use_react_components_Selector$Focusable$();
    var u$1 = $n($$x9).apply__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1__F1__Lcom_iz2use_react_components_Selector$Focusable__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_Selector__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(fieldOrders, x$2, x$3, false, x$5, x$6, new $c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3(this$14), $m_Lreactbuild_analyze_cost_modules_ReportFieldSpec$().Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_keyMapperReportFieldSpec, ($m_Lcom_iz2use_react_components_Selector$(), new $c_Lcom_iz2use_react_components_Selector$$anon$1()));
    var this$17 = $n(u$1);
    var n$1 = this$17.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x10 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$21 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reportTable;
    var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$21, s$1);
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [$m_Lreactbuild_analyze_cost_modules_ReportFragment$().Lreactbuild_analyze_cost_modules_ReportFragment$__f_columns];
    var array$1 = [$n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var $$x3 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    matchEnd4: {
      var $$x1;
      if ((fieldOrders !== null)) {
        var o7 = $n($m_s_package$().s_package$__f_$plus$colon).unapply__sc_SeqOps__s_Option(fieldOrders);
        if ((!$n(o7).isEmpty__Z())) {
          var head = $as_Lreactbuild_analyze_cost_modules_ReportFieldSpec($n($as_T2($n(o7).get__O()))._1__O());
          var tail = $as_sci_List($n($as_T2($n(o7).get__O()))._2__O());
          var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var this$34 = $n(head);
          var parents = $m_s_package$().s_package$__f_Nil;
          var reportContext = this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_ctx;
          var levels = $n(fieldOrders).length__I();
          var updateTimeReports = this.updateTimeReports__F2();
          var array$2 = [$f_Lreactbuild_analyze_cost_modules_ReportFieldSpec__render__sci_List__sci_List__Lreactbuild_analyze_cost_modules_ReportContext__I__I__F2__Ljapgolly_scalajs_react_vdom_VdomNode(this$34, parents, tail, reportContext, 0, levels, updateTimeReports)];
          var $$x1 = $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
          break matchEnd4
        }
      };
      throw new $c_s_MatchError(fieldOrders)
    };
    var array$3 = [$$x6, $$x3, $$x1];
    var array$4 = [$$x14, $$x10, $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$44, null, ns)
  })), new $c_Lsourcecode_FullName("reactbuild.analyze.cost.modules.ReportFragment.Backend.render"), $m_Lreactbuild_package$().Lreactbuild_package$__f_userPreferenceStore, $m_Lreactbuild_analyze_cost_modules_ReportFragment$().Lreactbuild_analyze_cost_modules_ReportFragment$__f_encodePreference, $m_Lreactbuild_analyze_cost_modules_ReportFragment$().Lreactbuild_analyze_cost_modules_ReportFragment$__f_decodePreference, $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
  var this$46 = $n(u$2);
  var n$2 = this$46.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype.refresh__Lreactbuild_analyze_cost_modules_ReportFragment$Props__Ljapgolly_scalajs_react_callback_Trampoline = (function(p) {
  $n(p);
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_modules_ReportFragment$State(s$2);
    $n(s);
    var timeReports = $n($n(s).Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports).pending__J__Ldiode_data_Pot($n($n(s).Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports).pending$default$1__J());
    var this$2 = $n(s);
    var searchItem = this$2.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem;
    return new $c_Lreactbuild_analyze_cost_modules_ReportFragment$State(timeReports, searchItem)
  })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
    var this$4 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x4 = new $c_Lautowire_ClientProxy(this$4).Lautowire_ClientProxy__f_self;
    var $$x3 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listTimeReports"];
    var $$x2 = $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$19 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$9 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$10 = $n(new $c_Lautowire_ClientProxy(this$9).Lautowire_ClientProxy__f_self);
    var r = $n($n(p).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange).Lreactbuild_analyze_cost_modules_PeriodRange__f_start;
    var evidence$2 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
    var y = this$10.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
    var $$x1 = $ct_T2__O__O__(new $c_T2(), "from", y);
    var this$13 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$14 = $n(new $c_Lautowire_ClientProxy(this$13).Lautowire_ClientProxy__f_self);
    var r$1 = $n($n(p).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange).Lreactbuild_analyze_cost_modules_PeriodRange__f_end;
    var evidence$2$1 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
    var y$1 = this$14.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
    var array$1 = [$$x1, $ct_T2__O__O__(new $c_T2(), "to", y$1)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($n($n($$x4).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x2, this$19.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$20 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$22 = $n(new $c_Lautowire_ClientProxy(this$20).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_model_TimeReport$().Lreactbuild_model_TimeReport$__f_codecForTimeReport;
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$22.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((r$2) => {
      var r$3 = $as_sci_List(r$2);
      var this$26 = $n(this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$);
      var mod = new $c_sjsr_AnonFunction1(((s$2$1) => {
        var s$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragment$State(s$2$1);
        $n(s$1);
        $n($n(s$1).Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports);
        var timeReports$1 = new $c_Ldiode_data_Ready(r$3);
        var this$24 = $n(s$1);
        var searchItem$1 = this$24.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem;
        return new $c_Lreactbuild_analyze_cost_modules_ReportFragment$State(timeReports$1, searchItem$1)
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$26, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).recoverWith__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1(this), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype.onPropsChange__Lreactbuild_analyze_cost_modules_ReportFragment$Props__Lreactbuild_analyze_cost_modules_ReportFragment$Props__Ljapgolly_scalajs_react_callback_Trampoline = (function(prev, p) {
  $n(p);
  var x = $n(prev).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange;
  var x$2 = $n(p).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange;
  if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
    return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_modules_ReportFragment$State(s$2);
      $n(s);
      var timeReports = $m_Ldiode_data_Empty$();
      var this$2 = $n(s);
      var searchItem = this$2.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem;
      return new $c_Lreactbuild_analyze_cost_modules_ReportFragment$State(timeReports, searchItem)
    })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.refresh__Lreactbuild_analyze_cost_modules_ReportFragment$Props__Ljapgolly_scalajs_react_callback_Trampoline(p)))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
  } else {
    return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragment$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragment$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragment$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragment$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportFragment$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragment$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragment$Backend", {
  Lreactbuild_analyze_cost_modules_ReportFragment$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragment$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend() {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype.makeNew__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__Lreactbuild_model_TimeReport = (function(p) {
  var $$x4 = $m_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$().Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_generic;
  var $$x3 = $m_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$().Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_fromMap;
  $n($m_s_package$().s_package$__f_List);
  var self = $m_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$().Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f__idSymbol;
  var y = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
  var $$x2 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$().Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_durationSymbol;
  var y$1 = new $c_Lreactbuild_model_Duration(0.0);
  var $$x1 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$().Lreactbuild_analyze_cost_modules_ReportFragmentDetails$__f_commentsSymbol;
  var y$2 = $m_s_None$();
  var array = [$$x2, $$x1, $ct_T2__O__O__(new $c_T2(), self$2, y$2)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var rassoc$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$12 = $n($n($n(p).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_parents).$colon$colon$colon__sci_List__sci_List(rassoc$3));
  var this$11 = $m_s_$less$colon$less$();
  return $as_Lreactbuild_model_TimeReport($n($$x4).from__O__O($n($n($$x3).apply__sci_Map__s_Option($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$12))).get__O()))
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype.update__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$2 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps(p$2);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f$1 = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(s$2);
      var this$2 = $n($n(s).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport);
      var nextState = $as_Lreactbuild_model_TimeReport($n(f).apply__O__O((this$2.isEmpty__Z() ? this.makeNew__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__Lreactbuild_model_TimeReport(p) : this$2.get__O())));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
        var this$3 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x3 = new $c_Lautowire_ClientProxy(this$3).Lautowire_ClientProxy__f_self;
        var $$x2 = $m_s_package$().s_package$__f_Seq;
        var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistTimeReport"];
        var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
        var this$14 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$8 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$9 = $n(new $c_Lautowire_ClientProxy(this$8).Lautowire_ClientProxy__f_self);
        var evidence$2 = $m_Lreactbuild_model_TimeReport$().Lreactbuild_model_TimeReport$__f_codecForTimeReport;
        var y = this$9.write__O__Lio_circe_Encoder__Lio_circe_Json(nextState, evidence$2);
        var array$1 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        return $n($n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$14.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1 = $as_Lio_circe_Json(x$1$2);
          var this$15 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$16 = $n(new $c_Lautowire_ClientProxy(this$15).Lautowire_ClientProxy__f_self);
          var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
          this$16.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((r$2) => {
          $as_jl_Void(r$2);
          var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var this$18 = $n(this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend__f_$);
          var mod = new $c_sjsr_AnonFunction1(((s$3) => {
            var s$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(s$3);
            $n(s$1);
            var timeReport = new $c_s_Some(nextState);
            return new $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(timeReport)
          }));
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x4).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$18, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_updateTimeReports).apply__O__O__O($n(s).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport, nextState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$1))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$2)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype.render__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Temps utilisation");
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var this$8 = $n($n(s).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport);
  var f = new $c_sjsr_AnonFunction1(((x$41$2) => {
    var x$41 = $as_Lreactbuild_model_TimeReport(x$41$2);
    return $n(x$41).Lreactbuild_model_TimeReport__f_duration
  }));
  var value = (this$8.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$8.get__O())));
  var state = $n($$x4).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x5;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x5 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $as_s_Option($n(x5).s_Some__f_value);
        var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().when$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline(this.update__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction1(((x$42$2) => {
          var x$42 = $as_Lreactbuild_model_TimeReport(x$42$2);
          var this$10 = $n(v);
          var default$1 = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_model_Duration(0.0)));
          var x$1 = $as_Lreactbuild_model_Duration((this$10.isEmpty__Z() ? default$1.apply__O() : this$10.get__O()));
          var this$11 = $n(x$42);
          var x$2 = this$11.Lreactbuild_model_TimeReport__f__id;
          var this$12 = $n(x$42);
          var x$3 = this$12.Lreactbuild_model_TimeReport__f_date;
          var this$13 = $n(x$42);
          var x$4 = this$13.Lreactbuild_model_TimeReport__f_resource;
          var this$14 = $n(x$42);
          var x$5 = this$14.Lreactbuild_model_TimeReport__f_buildingSite;
          var this$15 = $n(x$42);
          var x$6 = this$15.Lreactbuild_model_TimeReport__f_buildingStage;
          var this$16 = $n(x$42);
          var x$7 = this$16.Lreactbuild_model_TimeReport__f_comments;
          $n(x$42);
          return new $c_Lreactbuild_model_TimeReport(x$2, x$3, x$4, x$5, x$6, x$1, x$7)
        }))), new $c_sjsr_AnonFunction0((() => {
          var this$18 = $n($n(s).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport);
          if ((!this$18.isEmpty__Z())) {
            return true
          } else {
            var this$19 = $n(v);
            return (!this$19.isEmpty__Z())
          }
        })));
        var $$x5 = $n($$x6).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty), cb$2);
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x5)
  })));
  $m_Lreactbuild_model_Implicits$();
  var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  $m_Lcom_iz2use_common_Parsable$();
  var ev = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
  var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev);
  var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$25 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$25);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_numericDuration;
  var equiv = new $c_s_math_Equiv$OptionEquiv(eqv);
  var $$x7 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$1, explainError, equiv);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Commentaires");
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var this$32 = $n($n(s).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport);
  var f$1 = new $c_sjsr_AnonFunction1(((x$43$2) => {
    var x$43 = $as_Lreactbuild_model_TimeReport(x$43$2);
    return $n(x$43).Lreactbuild_model_TimeReport__f_comments
  }));
  var value$1 = (this$32.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$1.apply__O__O(this$32.get__O())));
  var state$1 = $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$1, new $c_sjsr_AnonFunction2(((x0$2$2, x1$2$2) => {
    var x0$2 = $as_s_Option(x0$2$2);
    var x1$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1$3 = $ct_T2__O__O__(new $c_T2(), x0$2, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2));
    matchEnd7$1: {
      var $$x2;
      var p2$1 = $as_s_Option(x1$3.T2__f__1);
      var cb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x$8 = $m_s_None$();
      if ((x$8 === p2$1)) {
        var $$x2 = cb$1;
        break matchEnd7$1
      };
      var p4$1 = $as_s_Option(x1$3.T2__f__1);
      var cb$2$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4$1 instanceof $c_s_Some)) {
        var x5$1 = $as_s_Some(p4$1);
        var v$1 = $as_s_Option($n(x5$1).s_Some__f_value);
        var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().when$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline(this.update__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction1(((x$44$2) => {
          var x$44 = $as_Lreactbuild_model_TimeReport(x$44$2);
          var this$34 = $n(x$44);
          var x$9 = this$34.Lreactbuild_model_TimeReport__f__id;
          var this$35 = $n(x$44);
          var x$10 = this$35.Lreactbuild_model_TimeReport__f_date;
          var this$36 = $n(x$44);
          var x$11 = this$36.Lreactbuild_model_TimeReport__f_resource;
          var this$37 = $n(x$44);
          var x$12 = this$37.Lreactbuild_model_TimeReport__f_buildingSite;
          var this$38 = $n(x$44);
          var x$13 = this$38.Lreactbuild_model_TimeReport__f_buildingStage;
          var this$39 = $n(x$44);
          var x$14 = this$39.Lreactbuild_model_TimeReport__f_duration;
          $n(x$44);
          return new $c_Lreactbuild_model_TimeReport(x$9, x$10, x$11, x$12, x$13, x$14, v$1)
        }))), new $c_sjsr_AnonFunction0((() => {
          var this$41 = $n($n(s).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport);
          if ((!this$41.isEmpty__Z())) {
            return true
          } else {
            var this$42 = $n(v$1);
            return (!this$42.isEmpty__Z())
          }
        })));
        var $$x2 = $n($$x3).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty), cb$2$1);
        break matchEnd7$1
      };
      throw new $c_s_MatchError(x1$3)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  })));
  var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$2);
  var ev$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$48 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$48);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv$1 = $m_s_math_Equiv$String$();
  var equiv$1 = new $c_s_math_Equiv$OptionEquiv(eqv$1);
  var array = [$$x7, editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$3, explainError$1, equiv$1)];
  var array$1 = [$n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend.prototype.onPropsChange__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(prev, p) {
  var this$2 = $n(this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(s$2);
    return $n(p).deriveState__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState()
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragmentDetails$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragmentDetails$TypedBackend;", depth))
}
function $ct_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__($thiz) {
  $thiz.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $thiz.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__f_ctx = new $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend$$anon$6($thiz);
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend() {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__f_ctx = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend.prototype.render__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var x1 = $n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrderTail;
  if ((x1 !== null)) {
    var o7 = $n($m_s_package$().s_package$__f_$plus$colon).unapply__sc_SeqOps__s_Option(x1);
    if ((!$n(o7).isEmpty__Z())) {
      var head = $as_Lreactbuild_analyze_cost_modules_ReportFieldSpec($n($as_T2($n(o7).get__O()))._1__O());
      var tail = $as_sci_List($n($as_T2($n(o7).get__O()))._2__O());
      var this$28 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      if (($n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level > 0)) {
        var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$7 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
        var a = $n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level;
        var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
        var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$7.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a)];
        var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
      } else {
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
      };
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$15 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
      var a$1 = (($n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_levels - $n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level) | 0);
      var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
      var $$x2 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$15.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n($n($n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrder).label__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable($n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_proxy)).stringify__O__T($n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldValue);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$1 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      var array$2 = [$$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
      var $$x1 = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var this$24 = $n(head);
      var parents = $n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_parents;
      var reportContext = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__f_ctx;
      var level = ((1 + $n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level) | 0);
      var levels = $n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_levels;
      var updateTimeReports = $n(p).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_updateTimeReports;
      var array$3 = [$$x1, $f_Lreactbuild_analyze_cost_modules_ReportFieldSpec__render__sci_List__sci_List__Lreactbuild_analyze_cost_modules_ReportContext__I__I__F2__Ljapgolly_scalajs_react_vdom_VdomNode(this$24, parents, tail, reportContext, level, levels, updateTimeReports)];
      var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$28, null, ns)
    }
  };
  throw new $c_s_MatchError(x1)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend.prototype.onPropsChange__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline = (function(prev, p) {
  var this$2 = $n(this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$47$2) => {
    $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState(x$47$2);
    return $n(p).deriveState__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState()
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragmentGroup$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragmentGroup$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend() {
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend.prototype.render__Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x3 = $n(p).Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps__f_f;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var $$x1 = this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend__f_$;
  var this$2 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$2.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($$x3).apply__O__O($n($$x2).setStateVia$extension__O__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $$x1, w)))
});
function $as_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportSelectAdditionalHeaders$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportSelectAdditionalHeaders$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportTotal$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportTotal$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype.handleGesture__Lreactbuild_analyze_cost_modules_ReportTotal$Props__F1 = (function(p) {
  return new $c_sjsr_AnonFunction1(((x$49$2) => {
    var x$49 = $as_Lcom_iz2use_react_components_Gesture$GestureType(x$49$2);
    var x = $m_Lcom_iz2use_react_components_Gesture$SwipeLeft$();
    if ((x === x$49)) {
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_changeWeek).apply__O__O(1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else {
      var x$3 = $m_Lcom_iz2use_react_components_Gesture$SwipeRight$();
      if ((x$3 === x$49)) {
        var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_changeWeek).apply__O__O((-1)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
      } else {
        var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
      }
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype.render__Lreactbuild_analyze_cost_modules_ReportTotal$Props__Lreactbuild_analyze_cost_modules_ReportTotal$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x32 = $m_Lcom_iz2use_react_components_Gesture$();
  var $$x31 = $m_s_package$().s_package$__f_Seq;
  var array = [$m_Lcom_iz2use_react_components_Gesture$SwipeLeft$(), $m_Lcom_iz2use_react_components_Gesture$SwipeRight$()];
  var $$x30 = $as_sci_Seq($n($$x31).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var $$x29 = this.handleGesture__Lreactbuild_analyze_cost_modules_ReportTotal$Props__F1(p);
  var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$6 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reportTable;
  var $$x27 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$6, s$1);
  var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$15 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x21 = this$15.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$16 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x20 = this$16.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$17 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$());
  var $$x19 = this$17.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("wrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = ("Sem n\u00b0 " + $n($n($n(p).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_periodRange).Lreactbuild_analyze_cost_modules_PeriodRange__f_start).get__Ljava_time_temporal_TemporalField__I($n($m_Ljava_time_temporal_WeekFields$().ISO__Ljava_time_temporal_WeekFields()).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField()));
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  var $$x17 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("<")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_changeWeek).apply__O__O((-1)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var $$x14 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(">")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_changeWeek).apply__O__O(1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var array$4 = [$$x14, $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var array$5 = [$$x21, $$x20, $$x19, $$x17, $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var array$6 = [$n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  var $$x12 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $m_Lreactbuild_analyze_cost_modules_ReportTotal$().Lreactbuild_analyze_cost_modules_ReportTotal$__f_days;
  var array$8 = [$$x12, $n($$x11).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((idx$2) => {
    var idx = $uI(idx$2);
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = $n($m_Lreactbuild_analyze_cost_modules_ReportFieldSpec$().Lreactbuild_analyze_cost_modules_ReportFieldSpec$__f_localDateTextualizable).stringify__O__T($n($n($n(p).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_periodRange).Lreactbuild_analyze_cost_modules_PeriodRange__f_days).apply__I__O(idx));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$7 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    return $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
  })))];
  var array$9 = [$n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x10 = $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as$1 = $n(s).Lreactbuild_analyze_cost_modules_ReportTotal$State__f_byResources;
  var array$14 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var resRef = $as_Lreactbuild_common_model_RefTo($n(x0$1)._1__O());
      var dates = $as_sci_Map($n(x0$1)._2__O());
      var this$102 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lreactbuild_package$();
      var proxy = $n(p).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_proxy;
      new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
      var this$74 = $n(proxy);
      var this$75 = $n(this$74.Ldiode_react_ModelProxy__f_modelReader);
      var m = $as_Lreactbuild_analyze_cost_services_Model(this$75.value__O());
      if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
        $n($m_s_package$().s_package$__f_List);
        var $$x4 = $m_sci_Nil$()
      } else {
        var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
        var x$50 = $as_Lreactbuild_model_CommonData(arg1);
        var $$x4 = $n(x$50).Lreactbuild_model_CommonData__f_resources
      };
      var this$77 = $n($as_sci_List($$x4));
      _return: {
        var these = this$77;
        while ((!$n(these).isEmpty__Z())) {
          var arg1$1 = $n(these).head__O();
          var x$51 = $as_Lreactbuild_model_Resource(arg1$1);
          var x = $n(x$51).Lreactbuild_model_Resource__f__id;
          if (((x === null) ? (resRef === null) : $n(x).equals__O__Z(resRef))) {
            var o = new $c_s_Some($n(these).head__O());
            break _return
          };
          these = $as_sci_List($n(these).tail__O())
        };
        var o = $m_s_None$()
      };
      var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var array$10 = [new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((x$52$2) => {
        var x$52 = $as_Lreactbuild_model_Resource(x$52$2);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v$2 = $n(x$52).Lreactbuild_model_Resource__f_name;
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)
      })))];
      var $$x3 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
      var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as$2 = $m_Lreactbuild_analyze_cost_modules_ReportTotal$().Lreactbuild_analyze_cost_modules_ReportTotal$__f_days;
      var array$12 = [$$x3, $n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$2, new $c_sjsr_AnonFunction1(((idx$2$1) => {
        var idx$1 = $uI(idx$2$1);
        var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        var this$88 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
        var $$x6 = this$88.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var o$1 = $n(dates).get__O__s_Option(idx$1);
        var O$1 = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
        var array$11 = [$$x6, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o$1, O$1).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((x$53$2) => {
          var x$53 = $as_Lreactbuild_model_Duration(x$53$2);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Lcom_iz2use_common_Textualizable$();
          var ev$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
          var v$3 = $n(ev$1).stringify__O__T(x$53);
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)
        })))];
        return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
      })))];
      var array$13 = [$n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
      var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$102, null, ns)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))];
  var array$15 = [$$x27, $$x10, $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  var array$16 = [$n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
  var u = $n($$x32).apply__sci_Seq__F1__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x30, $$x29, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
  var this$113 = $n(u);
  var n = this$113.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype.onPropsChange__Lreactbuild_analyze_cost_modules_ReportTotal$Props__Ljapgolly_scalajs_react_callback_Trampoline = (function(p) {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_ReportTotal$Backend__f_$);
  var newState = $n(p).deriveState__Lreactbuild_analyze_cost_modules_ReportTotal$State();
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$1, newState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
function $as_Lreactbuild_analyze_cost_modules_ReportTotal$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportTotal$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportTotal$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportTotal$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportTotal$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportTotal$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportTotal$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportTotal$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportTotal$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReportTotal$Backend", {
  Lreactbuild_analyze_cost_modules_ReportTotal$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportTotal$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend.prototype.render__Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props__Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("to come / Websocket ?"))];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
function $as_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.RetrieveSupplierDocuments$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.RetrieveSupplierDocuments$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend: 0
}, false, "reactbuild.analyze.cost.modules.RetrieveSupplierDocuments$Backend", {
  Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_SendReceipt$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_SendReceipt$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_SendReceipt$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_SendReceipt$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_SendReceipt$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_SendReceipt$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
function $as_Lreactbuild_analyze_cost_modules_SendReceipt$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.SendReceipt$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_SendReceipt$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_SendReceipt$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_SendReceipt$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_SendReceipt$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.SendReceipt$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_SendReceipt$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_SendReceipt$Backend: 0
}, false, "reactbuild.analyze.cost.modules.SendReceipt$Backend", {
  Lreactbuild_analyze_cost_modules_SendReceipt$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_SendReceipt$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_SupplyList$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_SupplyList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_SupplyList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_SupplyList$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_SupplyList$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_SupplyList$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_SupplyList$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_SupplyList$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_SupplyList$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_SupplyList$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_SupplyList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_SupplyList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Backend.prototype.render__Lreactbuild_analyze_cost_modules_SupplyList$Props__Lreactbuild_analyze_cost_modules_SupplyList$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var listing = $as_Lreactbuild_person_RowListing($n($n(p).Lreactbuild_analyze_cost_modules_SupplyList$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Quantit\u00e9"))];
  var $$x10 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9signation"))];
  var $$x8 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Command\u00e9"))];
  var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Re\u00e7u"))];
  var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("En stock"))];
  var array$5 = [$$x10, $$x8, $$x6, $$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var array$6 = [$n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  var $$x2 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n(listing).Lreactbuild_person_RowListing__f_lists;
  var array$21 = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((list$2) => {
    var list = $as_Lreactbuild_person_SupplyTemplateList(list$2);
    var $$x38 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x37 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x36 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("head", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var $$x35 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$58 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$58.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 3);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(list).Lreactbuild_person_SupplyTemplateList__f_title;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$7 = [$$x34, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var array$8 = [$$x36, $n($$x35).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
    var $$x33 = $n($$x37).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
    var $$x25 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$67 = $n($n(listing).Lreactbuild_person_RowListing__f_rows);
    var f = ((x$1$2) => {
      var x$1 = $as_Lreactbuild_person_SupplyRow(x$1$2);
      var x = $n(x$1).Lreactbuild_person_SupplyRow__f_list;
      var x$2 = $n(list).Lreactbuild_person_SupplyTemplateList__f__id;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    });
    var l = this$67;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break
        } else {
          var h = $n(l).head__O();
          var t$1 = $as_sci_List($n(l).tail__O());
          if (($uZ(f(h)) === false)) {
            l = t$1;
            continue
          };
          var start = l;
          var remaining = t$1;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block
            } else {
              var x$3 = $n(remaining).head__O();
              if (($uZ(f(x$3)) !== false)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue
              };
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O())
              };
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f(head)) !== false)) {
                  next = $as_sci_List($n(next).tail__O())
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                  };
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O())
                }
              };
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy
              };
              var result = newHead;
              break block
            }
          }
        }
      }
    };
    var $$x24 = $n($$x25).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(result, new $c_sjsr_AnonFunction1(((row$2) => {
      var row = $as_Lreactbuild_person_SupplyRow(row$2);
      var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x31 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + $n(row).Lreactbuild_person_SupplyRow__f__id), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
      var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = ("" + $n(row).Lreactbuild_person_SupplyRow__f_quantity);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$9 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      var $$x29 = $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
      var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$2 = $n($n(row).Lreactbuild_person_SupplyRow__f_target).renderTitle__Lreactbuild_person_RowListing__T(listing);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$10 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      var $$x27 = $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
      var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$11 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Command\u00e9 / Livr\u00e9 / A r\u00e9cup\u00e9rer en drive / Re\u00e7u / ..."))];
      var array$12 = [$$x31, $$x29, $$x27, $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
      return $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))
    })));
    var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x22 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("next", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x20 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$101 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "placeholder");
    var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array$13 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$101.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "Quantit\u00e9")];
    var array$14 = [$n($$x20).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
    var $$x19 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
    var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x17 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$112 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "placeholder");
    var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array$15 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$112.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "Chercher une r\u00e9f\u00e9rence")];
    var array$16 = [$n($$x17).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
    var $$x16 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x14 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).input__Ljapgolly_scalajs_react_vdom_HtmlTags$input$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$123 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "placeholder");
    var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array$17 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$123.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "Command\u00e9")];
    var array$18 = [$n($$x14).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))];
    var array$19 = [$$x22, $$x19, $$x16, $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))];
    var array$20 = [$$x33, $$x24, $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19))];
    return $n($$x38).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20))
  })))];
  return $n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21))
});
function $as_Lreactbuild_analyze_cost_modules_SupplyList$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_SupplyList$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.SupplyList$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_SupplyList$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_SupplyList$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_SupplyList$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_SupplyList$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.SupplyList$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_SupplyList$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_SupplyList$Backend: 0
}, false, "reactbuild.analyze.cost.modules.SupplyList$Backend", {
  Lreactbuild_analyze_cost_modules_SupplyList$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_SupplyList$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermListEntries$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermListEntries$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_TermListEntries$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend.prototype.render__Lreactbuild_analyze_cost_modules_TermListEntries$Props__Lreactbuild_analyze_cost_modules_TermListEntries$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x4 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "paddingLeft")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(p).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_level + "em"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n($n(p).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_customEntries;
  var $$x2 = $n($$x3).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((entry$2) => {
    var entry = $as_Lreactbuild_model_WithChildren(entry$2);
    var u = $m_Lreactbuild_analyze_cost_modules_EntryListEntry$().apply__Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps($n($m_Lreactbuild_analyze_cost_modules_EntryListEntry$().Lreactbuild_analyze_cost_modules_EntryListEntry$__f_custom).apply__O__O__O__O($n(p).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_context, entry, $n($n(p).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update)));
    var this$8 = $n(u);
    var n = this$8.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as$1 = $n($n(p).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templates;
  var array = [$$x4, $$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((template$2) => {
    var template = $as_Lreactbuild_model_WithChildren(template$2);
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as$2 = $n(template).Lreactbuild_model_WithChildren__f_children;
    return $n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$2, new $c_sjsr_AnonFunction1(((templateEntry$2) => {
      var templateEntry = $as_Lreactbuild_model_ListTemplateEntry(templateEntry$2);
      var u$1 = $m_Lreactbuild_analyze_cost_modules_EntryListEntry$().apply__Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps($n($m_Lreactbuild_analyze_cost_modules_EntryListEntry$().Lreactbuild_analyze_cost_modules_EntryListEntry$__f_templated).apply__O__O__O__O__O($n(p).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_context, $n($n($n(p).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templatedEntries).get__O__s_Option(templateEntry), templateEntry, $n($n(p).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update)));
      var this$13 = $n(u$1);
      var n$1 = this$13.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    })))
  })))];
  return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
function $as_Lreactbuild_analyze_cost_modules_TermListEntries$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.TermListEntries$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_TermListEntries$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_TermListEntries$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_TermListEntries$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_TermListEntries$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.TermListEntries$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_TermListEntries$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermListEntries$Backend: 0
}, false, "reactbuild.analyze.cost.modules.TermListEntries$Backend", {
  Lreactbuild_analyze_cost_modules_TermListEntries$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermListEntries$Backend;
function $p_Lreactbuild_analyze_cost_modules_TermTree$Backend__loop$4__sci_List__sci_List__Lreactbuild_analyze_cost_modules_TermTree$Props__sci_List($thiz, rest, acc, p$11) {
  while (true) {
    var x1 = rest;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x1)) {
      return $n(acc).reverse__sci_List()
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $as_sci_List($n(x3).sci_$colon$colon__f_head);
      var parentTl = $n(x3).sci_$colon$colon__f_next;
      var x$3 = $m_sci_Nil$();
      if (x$3.equals__O__Z(head)) {
        rest = parentTl
      } else if ((head instanceof $c_sci_$colon$colon)) {
        var x3$2 = $as_sci_$colon$colon(head);
        var head$2 = $as_Lreactbuild_model_Term($n(x3$2).sci_$colon$colon__f_head);
        var tl = $n(x3$2).sci_$colon$colon__f_next;
        var node = $m_Lreactbuild_analyze_cost_modules_TermLevel$().apply__Lreactbuild_analyze_cost_modules_EditListEntry$Context__Lreactbuild_model_Term__I__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_modules_IndexedListEntry__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(p$11).Lreactbuild_analyze_cost_modules_TermTree$Props__f_context, head$2, $n(rest).length__I(), $n(p$11).Lreactbuild_analyze_cost_modules_TermTree$Props__f_expanded, $n(p$11).Lreactbuild_analyze_cost_modules_TermTree$Props__f_data);
        var this$2 = $n($n(p$11).Lreactbuild_analyze_cost_modules_TermTree$Props__f_terms);
        var f = ((head$2) => ((x$76$2) => {
          var x$76 = $as_Lreactbuild_model_Term(x$76$2);
          var x$1 = $n(x$76).Lreactbuild_model_Term__f_parent;
          var x$2 = new $c_s_Some($n(head$2).Lreactbuild_model_Term__f__id);
          return ((x$1 !== null) && $n(x$1).equals__O__Z(x$2))
        }))(head$2);
        var l = this$2;
        block$1: {
          var result;
          while (true) {
            if ($n(l).isEmpty__Z()) {
              var result = $m_sci_Nil$();
              break
            } else {
              var h = $n(l).head__O();
              var t = $as_sci_List($n(l).tail__O());
              if (($uZ(f(h)) === false)) {
                l = t;
                continue
              };
              var start = l;
              var remaining = t;
              while (true) {
                if ($n(remaining).isEmpty__Z()) {
                  var result = start;
                  break block$1
                } else {
                  var x$4 = $n(remaining).head__O();
                  if (($uZ(f(x$4)) !== false)) {
                    remaining = $as_sci_List($n(remaining).tail__O());
                    continue
                  };
                  var firstMiss = remaining;
                  var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                  var toProcess = $as_sci_List($n(start).tail__O());
                  var currentLast = newHead;
                  while ((toProcess !== firstMiss)) {
                    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem;
                    currentLast = newElem;
                    toProcess = $as_sci_List($n(toProcess).tail__O())
                  };
                  var next = $as_sci_List($n(firstMiss).tail__O());
                  var nextToCopy = next;
                  while ((!$n(next).isEmpty__Z())) {
                    var head$1 = $n(next).head__O();
                    if (($uZ(f(head$1)) !== false)) {
                      next = $as_sci_List($n(next).tail__O())
                    } else {
                      while ((nextToCopy !== next)) {
                        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                        currentLast = newElem$2;
                        nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                      };
                      nextToCopy = $as_sci_List($n(next).tail__O());
                      next = $as_sci_List($n(next).tail__O())
                    }
                  };
                  if ((!$n(nextToCopy).isEmpty__Z())) {
                    $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                  };
                  var result = newHead;
                  break block$1
                }
              }
            }
          }
        };
        var this$3 = $n(parentTl);
        var this$4 = new $c_sci_$colon$colon(tl, this$3);
        var temp$rest$2 = new $c_sci_$colon$colon(result, this$4);
        var this$8 = $n(acc);
        var this$6 = $n(node);
        var n = this$6.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var elem = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
        var temp$acc = new $c_sci_$colon$colon(elem, this$8);
        rest = temp$rest$2;
        acc = temp$acc
      } else {
        throw new $c_s_MatchError(head)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermTree$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_TermTree$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_TermTree$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_TermTree$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermTree$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermTree$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermTree$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermTree$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_TermTree$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_TermTree$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_TermTree$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_TermTree$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Backend.prototype.render__Lreactbuild_analyze_cost_modules_TermTree$Props__Lreactbuild_analyze_cost_modules_TermTree$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  $n($n(p).Lreactbuild_analyze_cost_modules_TermTree$Props__f_context);
  var this$4 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var this$2 = $n($n(p).Lreactbuild_analyze_cost_modules_TermTree$Props__f_terms);
  var f = ((x$77$2) => {
    var x$77 = $as_Lreactbuild_model_Term(x$77$2);
    return $n($n(x$77).Lreactbuild_model_Term__f_parent).isEmpty__Z()
  });
  var l = this$2;
  block: {
    var result;
    while (true) {
      if ($n(l).isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break
      } else {
        var h = $n(l).head__O();
        var t = $as_sci_List($n(l).tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue
        };
        var start = l;
        var remaining = t;
        while (true) {
          if ($n(remaining).isEmpty__Z()) {
            var result = start;
            break block
          } else {
            var x = $n(remaining).head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List($n(remaining).tail__O());
              continue
            };
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List($n(start).tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
              $n(currentLast).sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List($n(toProcess).tail__O())
            };
            var next = $as_sci_List($n(firstMiss).tail__O());
            var nextToCopy = next;
            while ((!$n(next).isEmpty__Z())) {
              var head = $n(next).head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List($n(next).tail__O())
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                };
                nextToCopy = $as_sci_List($n(next).tail__O());
                next = $as_sci_List($n(next).tail__O())
              }
            };
            if ((!$n(nextToCopy).isEmpty__Z())) {
              $n(currentLast).sci_$colon$colon__f_next = nextToCopy
            };
            var result = newHead;
            break block
          }
        }
      }
    }
  };
  var this$3 = $m_sci_Nil$();
  var ns = $p_Lreactbuild_analyze_cost_modules_TermTree$Backend__loop$4__sci_List__sci_List__Lreactbuild_analyze_cost_modules_TermTree$Props__sci_List(this, new $c_sci_$colon$colon(result, this$3), $m_sci_Nil$(), p);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$4, null, ns)
});
function $as_Lreactbuild_analyze_cost_modules_TermTree$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_TermTree$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.TermTree$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_TermTree$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_TermTree$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_TermTree$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_TermTree$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.TermTree$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_TermTree$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermTree$Backend: 0
}, false, "reactbuild.analyze.cost.modules.TermTree$Backend", {
  Lreactbuild_analyze_cost_modules_TermTree$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermTree$Backend;
function $p_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__isActive$1__Lreactbuild_model_Resource__Ljapgolly_scalajs_react_extra_StateSnapshotF__Z($thiz, r, data$1) {
  var this$1 = $n($as_sci_List($n($as_T2($n(data$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))._1__O()));
  _return: {
    var these = this$1;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x$11 = $as_Lreactbuild_model_TimeReportEvent(arg1);
      var x = $n(x$11).Lreactbuild_model_TimeReportEvent__f_resource;
      var x$2 = $n(r).Lreactbuild_model_Resource__f__id;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var $$x1 = true;
        break _return
      };
      these = $as_sci_List($n(these).tail__O())
    };
    var $$x1 = false
  };
  if ($$x1) {
    return true
  } else {
    var this$2 = $n($as_sci_List($n($as_T2($n(data$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))._2__O()));
    var these$1 = this$2;
    while ((!$n(these$1).isEmpty__Z())) {
      var arg1$1 = $n(these$1).head__O();
      var x$12 = $as_Lreactbuild_model_TimeReport(arg1$1);
      var x$1 = $n(x$12).Lreactbuild_model_TimeReport__f_resource;
      var x$2$1 = $n(r).Lreactbuild_model_Resource__f__id;
      if (((x$1 === null) ? (x$2$1 === null) : $n(x$1).equals__O__Z(x$2$1))) {
        return true
      };
      these$1 = $as_sci_List($n(these$1).tail__O())
    };
    return false
  }
}
function $p_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__isInWorkingPeriod$1__Lreactbuild_model_Resource__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__Z($thiz, r, s$1) {
  var this$1 = $n($n(r).Lreactbuild_model_Resource__f_entry);
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var x$13 = $as_Ljava_time_LocalDate(arg1);
    var $$x1 = $n(x$13).isAfter__Ljava_time_chrono_ChronoLocalDate__Z($n(s$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date)
  } else {
    var $$x1 = false
  };
  if ((!$$x1)) {
    var this$2 = $n($n(r).Lreactbuild_model_Resource__f_release);
    if ((!this$2.isEmpty__Z())) {
      var arg1$1 = this$2.get__O();
      var x$14 = $as_Ljava_time_LocalDate(arg1$1);
      var $$x2 = $n(x$14).isBefore__Ljava_time_chrono_ChronoLocalDate__Z($n(s$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date)
    } else {
      var $$x2 = false
    };
    return (!$$x2)
  } else {
    return false
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_dateState = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_includeAllUsersState = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_reuseT = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(x$4$2);
    return $n(x$4).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date
  }));
  var set = new $c_sjsr_AnonFunction1(((date$2) => {
    var date = $as_Ljava_time_LocalDate(date$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(x$5$2);
      $n(x$5);
      var this$3 = $n(x$5);
      var includeAllUsers = this$3.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers;
      return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(date, includeAllUsers)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$7 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$7.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_dateState = $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w);
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$1 = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(x$6$2);
    return $n(x$6).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers
  }));
  var set$1 = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $uZ(v$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(x$7$2);
      var this$8 = $n(x$7);
      var x$2 = this$8.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
      $n(x$7);
      return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(x$2, v)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$1, set$1);
  var this$12 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$1 = this$12.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_includeAllUsersState = $n($$x4).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x3, \u03b4, w$1);
  var this$13 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_reuseT = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$13.byRef__F2(), this$13.by_$eq$eq__F2())
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend.prototype.render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var this$118 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u = $m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__I__I__Z__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_dateState).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $m_Lreactbuild_model_Implicits$().reusabilityLocalDate__F2()), ($m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$(), (-1)), ($m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$(), 1), ($m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$(), true), new $c_sjsr_AnonFunction1(((day$2) => {
    var day = $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell(day$2);
    var $$x2 = $m_Lcom_iz2use_react_components_Link$();
    var this$7 = $n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(x$8$2);
      $n(x$8);
      var date = $n(day).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell__f_date;
      var this$5 = $n(x$8);
      var includeAllUsers = this$5.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers;
      return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(date, includeAllUsers)
    }));
    var $$x1 = $n($n($$x2).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$7, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
    var this$8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
    var array = [this$8.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("block", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell$().cellToTagMod__Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell__Ljapgolly_scalajs_react_vdom_TagMod(day)];
    return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })));
  var this$13 = $n(u);
  var n = this$13.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  var array$9 = [$n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)), $m_Lcom_iz2use_react_components_FetchCacheAndRender$().withKey__T__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_vdom_VdomElement(("" + $n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date), new $c_sjsr_AnonFunction0((() => {
    var this$18 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x7 = new $c_Lautowire_ClientProxy(this$18).Lautowire_ClientProxy__f_self;
    var $$x6 = $m_s_package$().s_package$__f_Seq;
    var array$2 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listTimeReportEvents"];
    var $$x5 = $as_sci_Seq($n($$x6).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
    var this$33 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$23 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$24 = $n(new $c_Lautowire_ClientProxy(this$23).Lautowire_ClientProxy__f_self);
    var r = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
    var evidence$2 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
    var y = this$24.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
    var $$x4 = $ct_T2__O__O__(new $c_T2(), "from", y);
    var this$27 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$28 = $n(new $c_Lautowire_ClientProxy(this$27).Lautowire_ClientProxy__f_self);
    var r$1 = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
    var evidence$2$1 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
    var y$1 = this$28.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
    var array$3 = [$$x4, $ct_T2__O__O__(new $c_T2(), "to", y$1)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    var this$56 = $n($n($n($$x7).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x5, this$33.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$34 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$36 = $n(new $c_Lautowire_ClientProxy(this$34).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_model_TimeReportEvent$().Lreactbuild_model_TimeReportEvent$__f_codecForTimeReportEvent;
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$36.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue));
    var this$37 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x11 = new $c_Lautowire_ClientProxy(this$37).Lautowire_ClientProxy__f_self;
    var $$x10 = $m_s_package$().s_package$__f_Seq;
    var array$4 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listTimeReports"];
    var $$x9 = $as_sci_Seq($n($$x10).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)));
    var this$52 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$42 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$43 = $n(new $c_Lautowire_ClientProxy(this$42).Lautowire_ClientProxy__f_self);
    var r$2 = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
    var evidence$2$2 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
    var y$2 = this$43.write__O__Lio_circe_Encoder__Lio_circe_Json(r$2, evidence$2$2);
    var $$x8 = $ct_T2__O__O__(new $c_T2(), "from", y$2);
    var this$46 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$47 = $n(new $c_Lautowire_ClientProxy(this$46).Lautowire_ClientProxy__f_self);
    var r$3 = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
    var evidence$2$3 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
    var y$3 = this$47.write__O__Lio_circe_Encoder__Lio_circe_Json(r$3, evidence$2$3);
    var array$5 = [$$x8, $ct_T2__O__O__(new $c_T2(), "to", y$3)];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
    var that = $n($n($$x11).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x9, this$52.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lio_circe_Json(x$2$2);
      var this$53 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$55 = $n(new $c_Lautowire_ClientProxy(this$53).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA$1 = $m_Lreactbuild_model_TimeReport$().Lreactbuild_model_TimeReport$__f_codecForTimeReport;
      var evidence$1$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA$1);
      return $as_sci_List(this$55.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2, evidence$1$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    return this$56.zipWith__s_concurrent_Future__F2__s_concurrent_ExecutionContext__s_concurrent_Future(that, $m_s_concurrent_Future$().s_concurrent_Future$__f__zipWithTuple2, $m_s_concurrent_ExecutionContext$parasitic$())
  })), new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Ldiode_data_Pot(x$9$2);
    if ($n(x$9).isFailed__Z()) {
      var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x12 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(x$9).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$6 = [$$x12, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
    } else {
      var this$67 = $n(x$9);
      if ((!this$67.isEmpty__Z())) {
        var arg1 = $n(x$9).get__O();
        var data = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
        var proxy = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props__f_proxy;
        $m_Lreactbuild_package$();
        new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
        var this$70 = $n(proxy);
        var this$71 = $n(this$70.Ldiode_react_ModelProxy__f_modelReader);
        var m = $as_Lreactbuild_analyze_cost_services_Model(this$71.value__O());
        if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
          $n($m_s_package$().s_package$__f_List);
          var $$x14 = $m_sci_Nil$()
        } else {
          var arg1$1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
          var x$10 = $as_Lreactbuild_model_CommonData(arg1$1);
          var $$x14 = $n(x$10).Lreactbuild_model_CommonData__f_buildingSites
        };
        var projects = $n($as_sci_List($$x14)).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1(this));
        $m_Lreactbuild_package$();
        new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
        var this$75 = $n(proxy);
        var this$76 = $n(this$75.Ldiode_react_ModelProxy__f_modelReader);
        var m$1 = $as_Lreactbuild_analyze_cost_services_Model(this$76.value__O());
        if ($n($n(m$1).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
          $n($m_s_package$().s_package$__f_List);
          var $$x15 = $m_sci_Nil$()
        } else {
          var arg1$2 = $n($n(m$1).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
          var x$15 = $as_Lreactbuild_model_CommonData(arg1$2);
          var $$x15 = $n(x$15).Lreactbuild_model_CommonData__f_resources
        };
        var this$78 = $n($as_sci_List($$x15));
        var f = ((r$3$2) => {
          var r$3$1 = $as_Lreactbuild_model_Resource(r$3$2);
          return ($n($n(r$3$1).Lreactbuild_model_Resource__f_category).contains__O__Z("P") && ($p_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__isInWorkingPeriod$1__Lreactbuild_model_Resource__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__Z(this, r$3$1, s) || $p_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__isActive$1__Lreactbuild_model_Resource__Ljapgolly_scalajs_react_extra_StateSnapshotF__Z(this, r$3$1, data)))
        });
        var l = this$78;
        block: {
          var result;
          while (true) {
            if ($n(l).isEmpty__Z()) {
              var result = $m_sci_Nil$();
              break
            } else {
              var h = $n(l).head__O();
              var t = $as_sci_List($n(l).tail__O());
              if (($uZ(f(h)) === false)) {
                l = t;
                continue
              };
              var start = l;
              var remaining = t;
              while (true) {
                if ($n(remaining).isEmpty__Z()) {
                  var result = start;
                  break block
                } else {
                  var x = $n(remaining).head__O();
                  if (($uZ(f(x)) !== false)) {
                    remaining = $as_sci_List($n(remaining).tail__O());
                    continue
                  };
                  var firstMiss = remaining;
                  var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                  var toProcess = $as_sci_List($n(start).tail__O());
                  var currentLast = newHead;
                  while ((toProcess !== firstMiss)) {
                    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem;
                    currentLast = newElem;
                    toProcess = $as_sci_List($n(toProcess).tail__O())
                  };
                  var next = $as_sci_List($n(firstMiss).tail__O());
                  var nextToCopy = next;
                  while ((!$n(next).isEmpty__Z())) {
                    var head = $n(next).head__O();
                    if (($uZ(f(head)) !== false)) {
                      next = $as_sci_List($n(next).tail__O())
                    } else {
                      while ((nextToCopy !== next)) {
                        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                        currentLast = newElem$2;
                        nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                      };
                      nextToCopy = $as_sci_List($n(next).tail__O());
                      next = $as_sci_List($n(next).tail__O())
                    }
                  };
                  if ((!$n(nextToCopy).isEmpty__Z())) {
                    $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                  };
                  var result = newHead;
                  break block
                }
              }
            }
          }
        };
        var this$79 = $n(result);
        var f$1 = new $c_sjsr_AnonFunction1(((x$16$2) => {
          var x$16 = $as_Lreactbuild_model_Resource(x$16$2);
          return $n(x$16).Lreactbuild_model_Resource__f_name
        }));
        var ord = $m_s_math_Ordering$String$();
        var resources = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$79, f$1, ord));
        var this$80 = $n(resources);
        if (this$80.isEmpty__Z()) {
          var x1$1 = $m_sci_List$().sci_List$__f_scala$collection$immutable$List$$TupleOfNil
        } else {
          $m_sci_List$();
          var l$1 = new $c_scm_ListBuffer();
          $m_sci_List$();
          var r$4 = new $c_scm_ListBuffer();
          var this$83 = $n(this$80.iterator__sc_Iterator());
          while (this$83.hasNext__Z()) {
            var arg1$3 = this$83.next__O();
            var r$5 = $as_Lreactbuild_model_Resource(arg1$3);
            var this$84 = $n(($p_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__isActive$1__Lreactbuild_model_Resource__Ljapgolly_scalajs_react_extra_StateSnapshotF__Z(this, r$5, data) ? l$1 : r$4));
            this$84.addOne__O__scm_ListBuffer(arg1$3)
          };
          var x1 = $ct_T2__O__O__(new $c_T2(), l$1.toList__sci_List(), r$4.toList__sci_List());
          matchEnd7$1: {
            var x1$1;
            var p2 = $as_sci_List(x1.T2__f__1);
            var x$3 = $m_sci_Nil$();
            if (x$3.equals__O__Z(p2)) {
              var x1$1 = $ct_T2__O__O__(new $c_T2(), $m_sci_Nil$(), this$80);
              break matchEnd7$1
            };
            var p4 = $as_sci_List(x1.T2__f__2);
            var x$3$1 = $m_sci_Nil$();
            if (x$3$1.equals__O__Z(p4)) {
              var x1$1 = $ct_T2__O__O__(new $c_T2(), this$80, $m_sci_Nil$());
              break matchEnd7$1
            };
            var x1$1 = x1
          }
        };
        if ((x1$1 === null)) {
          throw new $c_s_MatchError(x1$1)
        };
        var activeResources = $as_sci_List($n(x1$1)._1__O());
        var inactiveResources = $as_sci_List($n(x1$1)._2__O());
        $m_Lreactbuild_package$();
        new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
        var this$87 = $n(proxy);
        var this$88 = $n(this$87.Ldiode_react_ModelProxy__f_modelReader);
        var m$2 = $as_Lreactbuild_analyze_cost_services_Model(this$88.value__O());
        if ($n($n(m$2).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
          $n($m_s_package$().s_package$__f_List);
          var $$x16 = $m_sci_Nil$()
        } else {
          var arg1$4 = $n($n(m$2).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
          var x$18 = $as_Lreactbuild_model_CommonData(arg1$4);
          var $$x16 = $n(x$18).Lreactbuild_model_CommonData__f_buildingStages
        };
        var this$90 = $n($as_sci_List($$x16));
        var f$2 = ((v$2) => {
          var v$1 = $as_Lreactbuild_model_BuildingStage(v$2);
          return $m_s_Option$().apply__O__s_Option($n(v$1).Lreactbuild_model_BuildingStage__f__id)
        });
        if ((this$90 === $m_sci_Nil$())) {
          var $$x17 = $m_sci_Nil$()
        } else {
          var arg1$5 = this$90.head__O();
          var h$1 = new $c_sci_$colon$colon(f$2(arg1$5), $m_sci_Nil$());
          var t$1 = h$1;
          var rest = $as_sci_List(this$90.tail__O());
          while ((rest !== $m_sci_Nil$())) {
            var arg1$6 = $n(rest).head__O();
            var nx = new $c_sci_$colon$colon(f$2(arg1$6), $m_sci_Nil$());
            $n(t$1).sci_$colon$colon__f_next = nx;
            t$1 = nx;
            rest = $as_sci_List($n(rest).tail__O())
          };
          var $$x17 = h$1
        };
        var this$91 = $n($$x17);
        var elem = $m_s_None$();
        var buildingStages = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$91, elem));
        var $$x20 = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers;
        var this$92 = $n(activeResources);
        var f$3 = ((x$19$2) => {
          var x$19 = $as_Lreactbuild_model_Resource(x$19$2);
          return $n(x$19).Lreactbuild_model_Resource__f__id
        });
        if ((this$92 === $m_sci_Nil$())) {
          var $$x19 = $m_sci_Nil$()
        } else {
          var arg1$7 = this$92.head__O();
          var h$2 = new $c_sci_$colon$colon(f$3(arg1$7), $m_sci_Nil$());
          var t$2 = h$2;
          var rest$1 = $as_sci_List(this$92.tail__O());
          while ((rest$1 !== $m_sci_Nil$())) {
            var arg1$8 = $n(rest$1).head__O();
            var nx$1 = new $c_sci_$colon$colon(f$3(arg1$8), $m_sci_Nil$());
            $n(t$2).sci_$colon$colon__f_next = nx$1;
            t$2 = nx$1;
            rest$1 = $as_sci_List($n(rest$1).tail__O())
          };
          var $$x19 = h$2
        };
        var this$93 = $n(inactiveResources);
        var f$4 = ((x$20$2) => {
          var x$20 = $as_Lreactbuild_model_Resource(x$20$2);
          return $n(x$20).Lreactbuild_model_Resource__f__id
        });
        if ((this$93 === $m_sci_Nil$())) {
          var $$x18 = $m_sci_Nil$()
        } else {
          var arg1$9 = this$93.head__O();
          var h$3 = new $c_sci_$colon$colon(f$4(arg1$9), $m_sci_Nil$());
          var t$3 = h$3;
          var rest$2 = $as_sci_List(this$93.tail__O());
          while ((rest$2 !== $m_sci_Nil$())) {
            var arg1$10 = $n(rest$2).head__O();
            var nx$2 = new $c_sci_$colon$colon(f$4(arg1$10), $m_sci_Nil$());
            $n(t$3).sci_$colon$colon__f_next = nx$2;
            t$3 = nx$2;
            rest$2 = $as_sci_List($n(rest$2).tail__O())
          };
          var $$x18 = h$3
        };
        var context = new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context(data, $$x20, projects, buildingStages, $$x19, $$x18);
        var $$x26 = $m_Lreactbuild_analyze_cost_components_AutoScrollArea$();
        var $$x24 = $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$();
        var $$x23 = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
        var $$x22 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_includeAllUsersState;
        var this$94 = $m_Ljapgolly_scalajs_react_Reusability$();
        var u$1 = $n($$x24).apply__Ljava_time_LocalDate__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x23, $n($$x22).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$94.by_$eq$eq__F2()), proxy, context);
        var this$96 = $n(u$1);
        var n$1 = this$96.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var $$x25 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
        var $$x21 = $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportAssignments$();
        var rassoc$2 = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
        var this$98 = $m_Lshapeless_HNil$();
        var u$2 = $n($$x21).apply__Lshapeless_$colon$colon__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_Lshapeless_$colon$colon(rassoc$2, this$98), proxy, context);
        var this$100 = $n(u$2);
        var n$2 = this$100.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var array$7 = [$$x25, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
        var u$3 = $n($$x26).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
        var this$106 = $n(u$3);
        var n$3 = this$106.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)
      } else if ($n(x$9).isPending__Z()) {
        return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$8 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        return $n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
      }
    }
  })), this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend__f_reuseT, $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$118, null, ns)
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Backend", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend.prototype.render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_proxy;
  var context = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_context;
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x12 = $n($m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$().Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$__f_userSelect).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$6 = $n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2$2) => {
    var s$2 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State(s$2$2);
    $n(s$2);
    var this$4 = $n($n(s$2).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__f_editing);
    if (this$4.isEmpty__Z()) {
      var $$x8 = $m_s_Option$().apply__O__s_Option($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_context)
    } else {
      var arg1 = this$4.get__O();
      $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context(arg1);
      var $$x8 = $m_s_None$()
    };
    var editing = $as_s_Option($$x8);
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State(editing)
  }));
  var action = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$6, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$7 = $n($n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__f_editing);
  if (this$7.isEmpty__Z()) {
    var this$13 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var this$8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).cursor__Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$());
    var array = [this$8.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("pointer", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(action))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var $$x9 = this$13.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
  } else {
    var arg1$1 = this$7.get__O();
    $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context(arg1$1);
    var this$20 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var $$x11 = $n($m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$().Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$__f_touchAction).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x10 = $m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(action);
    var array$1 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_expandLess, "", "24px")];
    var array$2 = [$$x11, $n($$x10).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    var ms$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    var $$x9 = this$20.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1)
  };
  var x1 = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__f_editing;
  var x = $m_s_None$();
  if ((x === x1)) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_resourceTimeReports;
    var $$x1 = $n($$x2).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var k = $as_Lreactbuild_common_model_RefTo($n(x0$1)._1__O());
        var lst = $as_sci_List($n(x0$1)._2__O());
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$24 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
        var $$x3 = this$24.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$25 = $m_Lreactbuild_model_Implicits$();
        var ev = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$25, proxy);
        var v = $n(ev).stringify__O__T(k);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$3 = [$$x3, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" = ")), $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), lst), new $c_sjsr_AnonFunction1(((r$2) => {
          var r = $as_Lreactbuild_model_TimeReport(r$2);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Lcom_iz2use_common_Textualizable$();
          var v$1 = $n(r).Lreactbuild_model_TimeReport__f_duration;
          var ev$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
          var v$2 = $n(ev$1).stringify__O__T(v$1);
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)
        })))];
        return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })))
  } else {
    if ((!(x1 instanceof $c_s_Some))) {
      throw new $c_s_MatchError(x1)
    };
    var x3 = $as_s_Some(x1);
    var ctx = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context($n(x3).s_Some__f_value);
    var f = ((x$3$2$2) => {
      var x$3$2 = $as_sci_List(x$3$2$2);
      return $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), x$3$2), new $c_sjsr_AnonFunction1(((res$2) => {
        var res = $as_Lreactbuild_common_model_RefTo(res$2);
        var $$x6 = $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$();
        var this$39 = $n($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_resourceTimeReports).get__O__s_Option(res));
        if (this$39.isEmpty__Z()) {
          var $$x5 = $m_s_None$()
        } else {
          var arg1$2 = this$39.get__O();
          var x$4 = $as_sci_List(arg1$2);
          var $$x5 = $n(x$4).headOption__s_Option()
        };
        var l = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_stack;
        var u = $n($$x6).apply__s_Option__Lshapeless_$colon$colon__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x5, new $c_Lshapeless_syntax_HListOps(l).$colon$colon__O__Lshapeless_$colon$colon(res), proxy, context);
        var this$42 = $n(u);
        var n = this$42.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      })))
    });
    if ($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_context).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_includeAllUsers) {
      var this$47 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var arg1$3 = $n(ctx).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_activeResources;
      var $$x7 = $as_Ljapgolly_scalajs_react_vdom_TagMod(f(arg1$3));
      var arg1$4 = $n(ctx).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_inactiveResources;
      var array$4 = [$$x7, $as_Ljapgolly_scalajs_react_vdom_TagMod(f(arg1$4))];
      var ms$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
      var $$x1 = this$47.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$2)
    } else {
      var arg1$5 = $n(ctx).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_activeResources;
      var $$x1 = $as_Ljapgolly_scalajs_react_vdom_TagMod(f(arg1$5))
    }
  };
  var array$5 = [$$x12, $$x9, $$x1];
  return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$Backend", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.handleStart__Ljapgolly_scalajs_react_facade_SyntheticEvent__D__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev, x) {
  var $$x3 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
  $m_Ljapgolly_scalajs_react_package$();
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$6 = $n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(x0$1$2);
    if ((x0$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle)) {
      var x2 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle(x0$1);
      var v = $n(x2).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle__f_value;
      var this$2 = $n(v);
      return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving($uD((this$2.isEmpty__Z() ? 0.0 : this$2.get__O())), x, 0.0)
    } else if ((x0$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving)) {
      var x3 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(x0$1);
      var origin = $n(x3).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin;
      var x$1 = (x - origin);
      var this$3 = $n(x3);
      var x$2 = this$3.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_initial;
      var this$4 = $n(x3);
      var x$3 = this$4.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin;
      $n(x3);
      return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(x$2, x$3, x$1)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$6, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  $m_Ljapgolly_scalajs_react_package$();
  var this$8 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var self = $n($$x2).$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev, this$8.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).stopPropagationCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  var this$ = $n($$x3).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev);
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.handleMove__Ljapgolly_scalajs_react_facade_SyntheticEvent__D__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev, x) {
  var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(x0$1$2);
    if ((x0$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving)) {
      var x2 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(x0$1);
      var origin = $n(x2).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin;
      var $$x4 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
      $m_Ljapgolly_scalajs_react_package$();
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var this$5 = $n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$2$2) => {
        $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(x$2$2);
        var x$1 = (x - origin);
        var this$2 = $n(x2);
        var x$2$2$1 = this$2.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_initial;
        var this$3 = $n(x2);
        var x$3 = this$3.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin;
        $n(x2);
        return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(x$2$2$1, x$3, x$1)
      }));
      var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$5, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      $m_Ljapgolly_scalajs_react_package$();
      var this$7 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var self = $n($$x3).$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x2, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev, this$7.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).stopPropagationCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
      var this$ = $n($$x4).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev);
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.handleEnd__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(x0$1$2);
    if ((x0$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving)) {
      var x2 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(x0$1);
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var $$x4 = $m_Ljapgolly_scalajs_react_internal_ReactCallbackExtensions$CallbackToExt$();
      $m_Ljapgolly_scalajs_react_package$();
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var this$2 = $n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$3$2) => {
        $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State(x$3$2);
        return new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle($n(x2).value__s_Option())
      }));
      var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      $m_Ljapgolly_scalajs_react_package$();
      var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var self = $n($$x3).$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x2, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev, this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).stopPropagationCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
      var this$ = $n($$x4).asEventDefault$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(self, ev);
      var $$x1 = $n($$x5).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty), this.persist__s_Option__Ljapgolly_scalajs_react_callback_Trampoline($n(x2).value__s_Option()))
    } else {
      var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.fingerX__Ljapgolly_scalajs_react_facade_SyntheticTouchEvent__D = (function(ev) {
  var domList = ev.changedTouches;
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList);
  var firstFinger = $n(this$2.iterator__sc_Iterator()).next__O();
  return $uD(firstFinger.clientX)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.handleTouchStart__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    var x = this.fingerX__Ljapgolly_scalajs_react_facade_SyntheticTouchEvent__D(ev$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleStart__Ljapgolly_scalajs_react_facade_SyntheticEvent__D__Ljapgolly_scalajs_react_callback_Trampoline(ev$2, x))
  }))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.handleTouchMove__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    var x = this.fingerX__Ljapgolly_scalajs_react_facade_SyntheticTouchEvent__D(ev$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleMove__Ljapgolly_scalajs_react_facade_SyntheticEvent__D__Ljapgolly_scalajs_react_callback_Trampoline(ev$2, x))
  }))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.handleMouseStart__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    var x = $uD(ev$2.clientX);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var cond = ($uI(ev$2.button) === 0);
    if (cond) {
      var this$ = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleStart__Ljapgolly_scalajs_react_facade_SyntheticEvent__D__Ljapgolly_scalajs_react_callback_Trampoline(ev$2, x)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.handleMouseMove__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((ev$2) => {
    var x = $uD(ev$2.clientX);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleMove__Ljapgolly_scalajs_react_facade_SyntheticEvent__D__Ljapgolly_scalajs_react_callback_Trampoline(ev$2, x))
  }))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.persistToServer__Lreactbuild_model_TimeReport__s_concurrent_Future = (function(report) {
  var this$1 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
  var $$x3 = new $c_Lautowire_ClientProxy(this$1).Lautowire_ClientProxy__f_self;
  var $$x2 = $m_s_package$().s_package$__f_Seq;
  var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistTimeReport"];
  var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var this$12 = $n($m_s_Predef$().s_Predef$__f_Map);
  var this$6 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
  var this$7 = $n(new $c_Lautowire_ClientProxy(this$6).Lautowire_ClientProxy__f_self);
  var evidence$2 = $m_Lreactbuild_model_TimeReport$().Lreactbuild_model_TimeReport$__f_codecForTimeReport;
  var y = this$7.write__O__Lio_circe_Encoder__Lio_circe_Json(report, evidence$2);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  return $n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$12.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lio_circe_Json(x$1$2);
    var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$15 = $n(new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self);
    var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
    this$15.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1)
  })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.persist__s_Option__Ljapgolly_scalajs_react_callback_Trampoline = (function(duration) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props(p$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var x1 = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_resourceTimeReport;
    matchEnd5: {
      var $$x1;
      if ((x1 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x1);
        var report = $as_Lreactbuild_model_TimeReport($n(x2).s_Some__f_value);
        var x = $n(report).Lreactbuild_model_TimeReport__f_duration;
        var this$2 = $n(duration);
        var x$2 = (this$2.isEmpty__Z() ? 0.0 : this$2.get__O());
        if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
          var $$x2 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption);
          var this$3 = $n(duration);
          var x$1 = new $c_Lreactbuild_model_Duration($uD((this$3.isEmpty__Z() ? 0.0 : this$3.get__O())));
          var this$4 = $n(report);
          var x$2$2 = this$4.Lreactbuild_model_TimeReport__f__id;
          var this$5 = $n(report);
          var x$3 = this$5.Lreactbuild_model_TimeReport__f_date;
          var this$6 = $n(report);
          var x$4 = this$6.Lreactbuild_model_TimeReport__f_resource;
          var this$7 = $n(report);
          var x$5 = this$7.Lreactbuild_model_TimeReport__f_buildingSite;
          var this$8 = $n(report);
          var x$6 = this$8.Lreactbuild_model_TimeReport__f_buildingStage;
          var this$9 = $n(report);
          var x$7 = this$9.Lreactbuild_model_TimeReport__f_comments;
          $n(report);
          var $$x1 = $n($$x2).pure__O__F0(new $c_Lreactbuild_model_TimeReport(x$2$2, x$3, x$4, x$5, x$6, x$1, x$7));
          break matchEnd5
        }
      };
      var x$8 = $m_s_None$();
      if ((x$8 === x1)) {
        var this$11 = $n(duration);
        var $$x3 = (!this$11.isEmpty__Z())
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var $$x7 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption);
        var l = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack;
        var $$x4 = new $c_Lshapeless_syntax_HListOps(l);
        var st = new $c_Lshapeless_ops_hlist$Selector$$anon$62();
        var st$1 = new $c_Lshapeless_ops_hlist$Selector$$anon$63(st);
        var st$2 = new $c_Lshapeless_ops_hlist$Selector$$anon$63(st$1);
        var x$8$2 = $as_Ljava_time_LocalDate($$x4.select__Lshapeless_ops_hlist$Selector__O(new $c_Lshapeless_ops_hlist$Selector$$anon$63(st$2)));
        var l$1 = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack;
        var x$9$2 = $as_Lreactbuild_common_model_RefTo(new $c_Lshapeless_syntax_HListOps(l$1).select__Lshapeless_ops_hlist$Selector__O(new $c_Lshapeless_ops_hlist$Selector$$anon$62()));
        var l$2 = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack;
        var $$x5 = new $c_Lshapeless_syntax_HListOps(l$2);
        var st$3 = new $c_Lshapeless_ops_hlist$Selector$$anon$62();
        var x$10 = $as_Lreactbuild_common_model_RefTo($$x5.select__Lshapeless_ops_hlist$Selector__O(new $c_Lshapeless_ops_hlist$Selector$$anon$63(st$3)));
        var l$3 = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack;
        var $$x6 = new $c_Lshapeless_syntax_HListOps(l$3);
        var st$4 = new $c_Lshapeless_ops_hlist$Selector$$anon$62();
        var st$5 = new $c_Lshapeless_ops_hlist$Selector$$anon$63(st$4);
        var x$11 = $as_s_Option($$x6.select__Lshapeless_ops_hlist$Selector__O(new $c_Lshapeless_ops_hlist$Selector$$anon$63(st$5)));
        var this$26 = $n(duration);
        var x$12 = new $c_Lreactbuild_model_Duration($uD((this$26.isEmpty__Z() ? 0.0 : this$26.get__O())));
        $m_Lreactbuild_model_TimeReport$();
        $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
        var x$13 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
        $m_Lreactbuild_model_TimeReport$();
        var x$14 = $m_s_None$();
        var $$x1 = $n($$x7).pure__O__F0(new $c_Lreactbuild_model_TimeReport(x$13, x$8$2, x$9$2, x$10, x$11, x$12, x$14));
        break matchEnd5
      };
      var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0()
    };
    var co = $n($$x8).flatMap$extension__F0__F1__F0($$x1, new $c_sjsr_AnonFunction1(((report$2$2) => {
      var report$2 = $as_Lreactbuild_model_TimeReport(report$2$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => $n(this.persistToServer__Lreactbuild_model_TimeReport__s_concurrent_Future(report$2)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$4$2) => {
        $as_jl_Void(x$4$2);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_context).updateTimeReport__Lreactbuild_model_TimeReport__Ljapgolly_scalajs_react_callback_Trampoline(report$2))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue))), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
      var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
        $as_jl_Void(x$5$2)
      }));
      var this$31 = $n(this$);
      var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$31, f);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    })));
    var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$34 = $m_s_$less$colon$less$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x9).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$34.s_$less$colon$less$__f_singleton))
  })))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_proxy;
  var $$x31 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x30 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "padding")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("6px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x29 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("6px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x28 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "border")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1px solid #aaa", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x27 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "borderRadius")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x26 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("120px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$12 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x25 = this$12.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$13 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x24 = this$13.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$14 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).justifyContent__Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$());
  var $$x23 = this$14.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("space-between", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$16 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
  var $$x22 = this$16.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$17 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
  var $$x21 = this$17.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("relative", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$20 = $n($n(s).value__s_Option());
  var v = ((this$20.isEmpty__Z() ? 0.0 : this$20.get__O()) + " h");
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  var $$x19 = $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var v$1 = $n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack).Lshapeless_$colon$colon__f_head;
  var this$28 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$28, proxy);
  var v$2 = $n(ev).stringify__O__T(v$1);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
  var $$x17 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$37 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
  var $$x15 = this$37.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("absolute", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x14 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n(s).isIdle__Z() ? "#000" : "#00a"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x13 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x12 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x11 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("bottom")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var $$x10 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width");
  var this$44 = $n($n(s).value__s_Option());
  var array$2 = [$$x15, $$x14, $$x13, $$x12, $$x11, $$x10.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((((100.0 * $uD((this$44.isEmpty__Z() ? 0.0 : this$44.get__O()))) / 12.0) + "%"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x9 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var this$48 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).cursor__Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$());
  var $$x8 = this$48.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("pointer", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onTouchStart");
  var $$x7 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.handleTouchStart__F1(), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$2 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onTouchMove");
  var $$x6 = stabilizer$2.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.handleTouchMove__F1(), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$3 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onTouchCancel");
  var $$x5 = stabilizer$3.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleEnd__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$4 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onTouchEnd");
  var $$x4 = stabilizer$4.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$3$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleEnd__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$3$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$5 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseDown");
  var $$x3 = stabilizer$5.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.handleMouseStart__F1(), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$6 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseMove");
  var $$x2 = stabilizer$6.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(this.handleMouseMove__F1(), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$7 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseUp");
  var $$x1 = stabilizer$7.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$4$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleEnd__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$4$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$8 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onMouseLeave");
  var array$3 = [$$x30, $$x29, $$x28, $$x27, $$x26, $$x25, $$x24, $$x23, $$x22, $$x21, $$x19, $$x17, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, stabilizer$8.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$5$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.handleEnd__Ljapgolly_scalajs_react_facade_SyntheticEvent__Ljapgolly_scalajs_react_callback_Trampoline(ev$5$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  return $n($$x31).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Backend", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype.toggleIgnore__Lreactbuild_model_TimeReportEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(event) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
      var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x4 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
      var $$x3 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "ignoreTimeReportEvent"];
      var $$x2 = $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$17 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
      var r = $n(event).Lreactbuild_model_TimeReportEvent__f__id;
      var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
      var $$x1 = $ct_T2__O__O__(new $c_T2(), "eventRef", y);
      var this$11 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$12 = $n(new $c_Lautowire_ClientProxy(this$11).Lautowire_ClientProxy__f_self);
      var r$1 = (!$n(event).Lreactbuild_model_TimeReportEvent__f_ignore);
      var evidence$2$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
      var y$1 = this$12.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
      var array$1 = [$$x1, $ct_T2__O__O__(new $c_T2(), "ignore", y$1)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      return $n($n($n($$x4).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x2, this$17.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$18 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$19 = $n(new $c_Lautowire_ClientProxy(this$18).Lautowire_ClientProxy__f_self);
        var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$19.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
        $as_jl_Void(x$2$2);
        var x$2$2$1 = (!$n(event).Lreactbuild_model_TimeReportEvent__f_ignore);
        var this$20 = $n(event);
        var x$3 = this$20.Lreactbuild_model_TimeReportEvent__f__id;
        var this$21 = $n(event);
        var x$4 = this$21.Lreactbuild_model_TimeReportEvent__f_resource;
        var this$22 = $n(event);
        var x$5 = this$22.Lreactbuild_model_TimeReportEvent__f_date;
        var this$23 = $n(event);
        var x$6 = this$23.Lreactbuild_model_TimeReportEvent__f_manuallyAdded;
        $n(event);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(p).updateEvent__Lreactbuild_model_TimeReportEvent__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_model_TimeReportEvent(x$3, x$4, x$5, x$2$2$1, x$6)))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype.saveEvent__Ljava_time_LocalTime__Ljapgolly_scalajs_react_callback_Trampoline = (function(time) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(p$2);
    var x$1 = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_resource;
    var this$2 = $n(time);
    var date = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_date;
    var x$2 = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(date, this$2);
    $m_Lreactbuild_model_TimeReportEvent$();
    $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
    var x$4 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
    $m_Lreactbuild_model_TimeReportEvent$();
    var x$5 = false;
    var event = new $c_Lreactbuild_model_TimeReportEvent(x$4, x$1, x$2, x$5, true);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
      var this$5 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x3 = new $c_Lautowire_ClientProxy(this$5).Lautowire_ClientProxy__f_self;
      var $$x2 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistTimeReportEvent"];
      var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$16 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$10 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$11 = $n(new $c_Lautowire_ClientProxy(this$10).Lautowire_ClientProxy__f_self);
      var evidence$2 = $m_Lreactbuild_model_TimeReportEvent$().Lreactbuild_model_TimeReportEvent$__f_codecForTimeReportEvent;
      var y = this$11.write__O__Lio_circe_Encoder__Lio_circe_Json(event, evidence$2);
      var array$1 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      return $n($n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$16.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$6$2) => {
        var x$6 = $as_Lio_circe_Json(x$6$2);
        var this$17 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$18 = $n(new $c_Lautowire_ClientProxy(this$17).Lautowire_ClientProxy__f_self);
        var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$18.read__Lio_circe_Json__Lio_circe_Decoder__O(x$6, evidence$1)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$3$2) => {
        $as_jl_Void(x$3$2);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(p).updateEvent__Lreactbuild_model_TimeReportEvent__Ljapgolly_scalajs_react_callback_Trampoline(event))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype.render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x32 = this$3.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$4 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x31 = this$4.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$());
  var $$x30 = this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("wrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$6 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x29 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_intervals;
  var $$x4 = $n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((hours$2) => {
    var hours = $as_Lreactbuild_model_TimeReportInterval(hours$2);
    var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x27 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "borderRadius")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x26 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "padding")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 .5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x25 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "background")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#d9d9d980", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x24 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x13 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#aaa", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as$1 = $n(hours).Lreactbuild_model_TimeReportInterval__f_details;
    var array$4 = [$$x13, $n($$x12).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((hour$2) => {
      var hour = $as_Lreactbuild_model_TimeReportEvent(hour$2);
      var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x21 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x20 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("inline-block", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var this$25 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
      var $$x19 = this$25.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var this$26 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var cond = $n(hour).Lreactbuild_model_TimeReportEvent__f_manuallyAdded;
      if (cond) {
        var this$32 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var this$27 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$());
        var $$x18 = this$27.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("red", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        var this$28 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontWeight__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$());
        var array = [$$x18, this$28.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("bold", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
        var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        var $$x17 = this$32.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
      } else {
        var $$x17 = this$26.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
      };
      var this$33 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var cond$1 = $n(hour).Lreactbuild_model_TimeReportEvent__f_ignore;
      if (cond$1) {
        var this$37 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var array$1 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).textDecoration__Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("line-through", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$().Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$__f_textDecorationColor).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#ff000080", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$().Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$__f_textDecorationStyle).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("double", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
        var ms$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        var $$x16 = this$37.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1)
      } else {
        var $$x16 = this$33.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
      };
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$38 = $n($n(hour).Lreactbuild_model_TimeReportEvent__f_date);
      var v = this$38.Ljava_time_LocalDateTime__f_time;
      var ev = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableLocalTime;
      var v$1 = $n(ev).stringify__O__T(v);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x15 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
      var $$x14 = $m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.toggleIgnore__Lreactbuild_model_TimeReportEvent__Ljapgolly_scalajs_react_callback_Trampoline(hour));
      var array$2 = [$m_Lcom_iz2use_react_components_Icon$().conditional__Z__Lcom_iz2use_react_components_IconSource__Lcom_iz2use_react_components_IconSource__T__T__T__Ljapgolly_scalajs_react_vdom_TagOf($n(hour).Lreactbuild_model_TimeReportEvent__f_ignore, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_add, $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_delete, "", "", "24px")];
      var array$3 = [$$x21, $$x20, $$x19, $$x17, $$x16, $$x15, $n($$x14).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
      return $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    })))];
    var $$x11 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    matchEnd6: {
      var $$x6;
      if ((hours !== null)) {
        var a = $n(hours).Lreactbuild_model_TimeReportInterval__f_start;
        var p2 = $n(hours).Lreactbuild_model_TimeReportInterval__f_end;
        if ((p2 instanceof $c_s_Some)) {
          var x4 = $as_s_Some(p2);
          var b = $as_Ljava_time_LocalDateTime($n(x4).s_Some__f_value);
          var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var $$x9 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("3em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          var $$x8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("inline-block", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
          var this$55 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
          var $$x7 = this$55.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Lcom_iz2use_common_Textualizable$();
          var v$2 = $m_Ljava_time_Duration$().between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration(a, b);
          var ev$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_textualizableJDuration;
          var v$3 = $n(ev$1).stringify__O__T(v$2);
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var array$5 = [$$x9, $$x8, $$x7, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
          var $$x6 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
          break matchEnd6
        }
      };
      var $$x6 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
    };
    var array$6 = [$$x27, $$x26, $$x25, $$x24, $$x11, $$x6];
    return $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
  })));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ajouter un horaire manquant");
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value = $m_s_None$();
  var state = $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x2;
      var p2$1 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2$1)) {
        var $$x2 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v$4 = $as_s_Option($n(x5).s_Some__f_value);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().$greater$greater$extension__F0__F0__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMapCB$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => v$4))), new $c_sjsr_AnonFunction1(((v$2$2) => {
          var v$2$1 = $as_Ljava_time_LocalTime(v$2$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.saveEvent__Ljava_time_LocalTime__Ljapgolly_scalajs_react_callback_Trampoline(v$2$1))
        }))), ($m_Ljapgolly_scalajs_react_callback_CallbackOption$(), $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(cb$2)));
        var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$70 = $m_s_$less$colon$less$();
        var $$x2 = $n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$70.s_$less$colon$less$__f_singleton);
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  })));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableLocalTime;
  var ev$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$73 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$73);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$76 = $m_s_math_Equiv$();
  var equiv = this$76.universal__s_math_Equiv();
  var array$7 = [$$x32, $$x31, $$x30, $$x29, $$x4, editorComponent.withKey__T__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement("add-new", label, state, optioner, ev$2, explainError, equiv)];
  return $n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$Backend", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend.prototype.render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__jl_Void__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_proxy;
  var context = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_context;
  var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x26 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("workingTime", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reportTable;
  var $$x25 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
  var $$x24 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$2);
  var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ressources"))];
  var $$x20 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("3em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Dur\u00e9e r\u00e9alis\u00e9e"))];
  var $$x18 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$2 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("3em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Dur\u00e9e affect\u00e9e"))];
  var $$x16 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9tails pointages"))];
  var array$4 = [$$x20, $$x18, $$x16, $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var array$5 = [$n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var $$x14 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_context).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_activeResources;
  var array$6 = [$n($$x11).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((res$2) => {
    var res = $as_Lreactbuild_common_model_RefTo(res$2);
    var $$x12 = $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$();
    var this$49 = $n($as_sci_List($n($as_T2($n($n(context).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))._1__O()));
    var f = ((x$1$2) => {
      var x$1 = $as_Lreactbuild_model_TimeReportEvent(x$1$2);
      var x = $n(x$1).Lreactbuild_model_TimeReportEvent__f_resource;
      return ((x === null) ? (res === null) : $n(x).equals__O__Z(res))
    });
    var l = this$49;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break
        } else {
          var h = $n(l).head__O();
          var t = $as_sci_List($n(l).tail__O());
          if (($uZ(f(h)) === false)) {
            l = t;
            continue
          };
          var start = l;
          var remaining = t;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block
            } else {
              var x$2 = $n(remaining).head__O();
              if (($uZ(f(x$2)) !== false)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue
              };
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O())
              };
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f(head)) !== false)) {
                  next = $as_sci_List($n(next).tail__O())
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                  };
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O())
                }
              };
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy
              };
              var result = newHead;
              break block
            }
          }
        }
      }
    };
    var u = $n($$x12).apply__Lreactbuild_common_model_RefTo__sci_List__Ljava_time_LocalDate__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(res, result, $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_date, proxy, context);
    var this$51 = $n(u);
    var n = this$51.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })))];
  var $$x10 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$64 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "colSpan");
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$64.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 4);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Inclure tous les utilisateurs");
  var state = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_includeAllUsers;
  var evDefault = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
  var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv = $m_s_math_Equiv$Boolean$();
  var this$71 = $n(editorComponent);
  var array$7 = [$$x6, this$71.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv)];
  var array$8 = [$n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  var array$9 = [$n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x5 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$83 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var this$84 = $n(this$83.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  var condition = $uZ($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_includeAllUsers).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var condition$1 = (!condition);
  var $$x2 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$84, condition$1);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as$1 = $n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_context).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_inactiveResources;
  var array$10 = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((res$3$2) => {
    var res$3 = $as_Lreactbuild_common_model_RefTo(res$3$2);
    var $$x3 = $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$();
    var this$86 = $n($as_sci_List($n($as_T2($n($n(context).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))._1__O()));
    var f$1 = ((x$2$2) => {
      var x$2$1 = $as_Lreactbuild_model_TimeReportEvent(x$2$2);
      var x$3 = $n(x$2$1).Lreactbuild_model_TimeReportEvent__f_resource;
      return ((x$3 === null) ? (res$3 === null) : $n(x$3).equals__O__Z(res$3))
    });
    var l$1 = this$86;
    block$2: {
      var result$1;
      while (true) {
        if ($n(l$1).isEmpty__Z()) {
          var result$1 = $m_sci_Nil$();
          break
        } else {
          var h$1 = $n(l$1).head__O();
          var t$2 = $as_sci_List($n(l$1).tail__O());
          if (($uZ(f$1(h$1)) === false)) {
            l$1 = t$2;
            continue
          };
          var start$1 = l$1;
          var remaining$1 = t$2;
          while (true) {
            if ($n(remaining$1).isEmpty__Z()) {
              var result$1 = start$1;
              break block$2
            } else {
              var x$4 = $n(remaining$1).head__O();
              if (($uZ(f$1(x$4)) !== false)) {
                remaining$1 = $as_sci_List($n(remaining$1).tail__O());
                continue
              };
              var firstMiss$1 = remaining$1;
              var newHead$1 = new $c_sci_$colon$colon($n(start$1).head__O(), $m_sci_Nil$());
              var toProcess$1 = $as_sci_List($n(start$1).tail__O());
              var currentLast$1 = newHead$1;
              while ((toProcess$1 !== firstMiss$1)) {
                var newElem$1 = new $c_sci_$colon$colon($n(toProcess$1).head__O(), $m_sci_Nil$());
                $n(currentLast$1).sci_$colon$colon__f_next = newElem$1;
                currentLast$1 = newElem$1;
                toProcess$1 = $as_sci_List($n(toProcess$1).tail__O())
              };
              var next$1 = $as_sci_List($n(firstMiss$1).tail__O());
              var nextToCopy$1 = next$1;
              while ((!$n(next$1).isEmpty__Z())) {
                var head$1 = $n(next$1).head__O();
                if (($uZ(f$1(head$1)) !== false)) {
                  next$1 = $as_sci_List($n(next$1).tail__O())
                } else {
                  while ((nextToCopy$1 !== next$1)) {
                    var newElem$2$1 = new $c_sci_$colon$colon($n(nextToCopy$1).head__O(), $m_sci_Nil$());
                    $n(currentLast$1).sci_$colon$colon__f_next = newElem$2$1;
                    currentLast$1 = newElem$2$1;
                    nextToCopy$1 = $as_sci_List($n(nextToCopy$1).tail__O())
                  };
                  nextToCopy$1 = $as_sci_List($n(next$1).tail__O());
                  next$1 = $as_sci_List($n(next$1).tail__O())
                }
              };
              if ((!$n(nextToCopy$1).isEmpty__Z())) {
                $n(currentLast$1).sci_$colon$colon__f_next = nextToCopy$1
              };
              var result$1 = newHead$1;
              break block$2
            }
          }
        }
      }
    };
    var u$1 = $n($$x3).apply__Lreactbuild_common_model_RefTo__sci_List__Ljava_time_LocalDate__Ldiode_react_ModelProxy__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(res$3, result$1, $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_date, proxy, context);
    var this$88 = $n(u$1);
    var n$1 = this$88.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  })))];
  var array$11 = [$$x26, $$x25, $$x24, $$x14, $$x10, $$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
  return $n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportResourceSummary$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportResourceSummary$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportResourceSummary$Backend", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend.prototype.render__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_proxy;
  var res = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_resource;
  var context = $as_T2($n($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_context).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  $m_Lreactbuild_model_TimeReportEvent$();
  var events = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_events;
  var intervals = new $c_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList(events).intervals__sci_List();
  var total = new $c_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval(intervals).total__s_Option();
  var this$4 = $n($m_s_Option$().apply__O__s_Option(new $c_Lreactbuild_model_Duration($uD($n($as_sc_LinearSeqOps($n(context)._2__O())).foldLeft__O__F2__O(0.0, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $uD(x0$1$2);
    var x1$1 = $as_Lreactbuild_model_TimeReport(x1$1$2);
    var x = $n(x1$1).Lreactbuild_model_TimeReport__f_resource;
    if (((x === null) ? (res === null) : $n(x).equals__O__Z(res))) {
      return (x0$1 + $n($n(x1$1).Lreactbuild_model_TimeReport__f_duration).Lreactbuild_model_Duration__f_value)
    } else {
      return x0$1
    }
  })))))));
  if (this$4.isEmpty__Z()) {
    var $$x1 = true
  } else {
    var arg1 = this$4.get__O();
    var x$1 = $as_Lreactbuild_model_Duration(arg1);
    var $$x1 = ($n(x$1).Lreactbuild_model_Duration__f_value > 0.0)
  };
  if ($$x1) {
    var assigned = this$4
  } else {
    var assigned = $m_s_None$()
  };
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$9 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$9, proxy);
  var v = $n(ev).stringify__O__T(res);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  var $$x11 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$19 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  var $$x9 = this$19.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
  var ev$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
  var v$1 = ev$1.stringify__s_Option__T(total);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$1 = [$$x9, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
  var $$x8 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$30 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  var $$x6 = this$30.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
  var ev$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1);
  var v$2 = ev$2.stringify__s_Option__T(assigned);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2);
  var $$x4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title;
  var this$35 = $n($n($as_sci_List($n(context)._2__O())).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3(this, res, proxy)));
  var array$2 = [$$x6, $$x5, $n($$x4).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($f_sc_IterableOnceOps__mkString__T__T__T__T(this$35, "", "\n", ""), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x3 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u = $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_common_model_RefTo__Ljava_time_LocalDate__sci_List__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_context).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_events, $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_resource, $n(p).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_date, intervals);
  var this$42 = $n(u);
  var n = this$42.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  var array$4 = [$$x11, $$x8, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$Backend", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend.prototype.render__Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var current = $as_Ljava_time_LocalDate($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_date).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var this$1 = $m_Ljava_time_LocalDate$();
  var now = this$1.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()));
  var $$x1 = $n(current);
  var value = (((-1) + $n($n(current).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I()) | 0);
  var hi = (value >> 31);
  var firstDay = $n($$x1).minusDays__J__Ljava_time_LocalDate(new $c_RTLong(value, hi));
  if ($n(p).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_notFuture) {
    var value$1 = (((-1) + $n($n(now).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I()) | 0);
    var hi$1 = (value$1 >> 31);
    var $$x2 = ($n(firstDay).compareTo__Ljava_time_chrono_ChronoLocalDate__I($n(now).minusDays__J__Ljava_time_LocalDate(new $c_RTLong(value$1, hi$1))) >= 0)
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var weekFutureOffset = ((-$n(p).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekAfter) | 0)
  } else {
    var weekFutureOffset = 0
  };
  var $$x49 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$7 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_calendarContainer;
  var $$x48 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$7, s$1);
  var $$x47 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$10 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_calendarTable;
  var $$x46 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$10, s$2);
  var $$x45 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x44 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x43 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x42 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Semaine"))];
  var array$1 = [$n($$x42).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var $$x41 = $n($$x43).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x40 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x39 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Lundi"))];
  var array$3 = [$n($$x39).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var $$x38 = $n($$x40).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x37 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Mardi"))];
  var array$5 = [$n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var $$x35 = $n($$x37).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Mecredi"))];
  var array$7 = [$n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
  var $$x32 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var $$x31 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$8 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Jeudi"))];
  var array$9 = [$n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x29 = $n($$x31).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x27 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$10 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Vendredi"))];
  var array$11 = [$n($$x27).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
  var $$x26 = $n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
  var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$12 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Samedi"))];
  var array$13 = [$n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  var $$x23 = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$14 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Dimanche"))];
  var array$15 = [$n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  var array$16 = [$$x41, $$x38, $$x35, $$x32, $$x29, $$x26, $$x23, $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
  var array$17 = [$n($$x44).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
  var $$x20 = $n($$x45).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17));
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var x = (($n(p).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekBefore + weekFutureOffset) | 0);
  var end = (($n(p).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekAfter + weekFutureOffset) | 0);
  var isEmpty = (x > end);
  var f = new $c_sjsr_AnonFunction1(((weekOffset$2) => {
    var weekOffset = $uI(weekOffset$2);
    var $$x8 = $n(firstDay);
    var hi$6 = (weekOffset >> 31);
    var startOfWeek = $n($$x8).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(weekOffset, hi$6));
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = ("" + $n(startOfWeek).get__Ljava_time_temporal_TemporalField__I($n($m_Ljava_time_temporal_WeekFields$().ISO__Ljava_time_temporal_WeekFields()).weekOfWeekBasedYear__Ljava_time_temporal_TemporalField()));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$18 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x10 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18));
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$().Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_days;
    var array$20 = [$$x10, $n($$x9).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((idx$2) => {
      var idx = $uI(idx$2);
      var $$x12 = $n(startOfWeek);
      var hi$7 = (idx >> 31);
      var day = $n($$x12).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(idx, hi$7));
      var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$142 = $m_Lscalacss_ScalaCssReact$();
      var s$3 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_calendarOther;
      var $$x15 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$142, s$3);
      var this$143 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var cond = ((day === null) ? (now === null) : $n(day).equals__O__Z(now));
      if (cond) {
        var this$144 = $m_Lscalacss_ScalaCssReact$();
        var s$4 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_calendarNow;
        var $$x14 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$144, s$4)
      } else {
        var $$x14 = this$143.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
      };
      var this$145 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var cond$1 = ((day === null) ? (current === null) : $n(day).equals__O__Z(current));
      if (cond$1) {
        var this$146 = $m_Lscalacss_ScalaCssReact$();
        var s$5 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_calendarActive;
        var $$x13 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$146, s$5)
      } else {
        var $$x13 = this$145.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
      };
      var array$19 = [$$x15, $$x14, $$x13, $as_Ljapgolly_scalajs_react_vdom_TagMod($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_render).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell(day)))];
      return $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19))
    })))];
    return $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20))
  }));
  var $$x18 = $m_Ljapgolly_scalajs_react_vdom_TagMod$();
  var this$154 = new $c_sci_RangeIterator(x, 1, end, isEmpty);
  var array$21 = [$n($$x18).fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sc_Iterator$$anon$9(this$154, f))];
  var array$22 = [$$x46, $$x20, $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21))];
  var $$x7 = $n($$x47).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22));
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$163 = $m_Lscalacss_ScalaCssReact$();
  var s$6 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_calendarMonthContainer;
  var $$x5 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$163, s$6);
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$166 = $m_Lscalacss_ScalaCssReact$();
  var s$7 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_calendarMonthWrapper;
  var $$x3 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$166, s$7);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$167 = $n(current);
  var formatter = $m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$().Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_dateFormatter;
  var v$1 = $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T(this$167, formatter);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$23 = [$$x3, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
  var array$24 = [$$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23))];
  var array$25 = [$$x48, $$x7, $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24))];
  return $n($$x49).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25))
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.Multiweeks$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$Backend", {
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(x$2$2);
    return $n(x$2).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_s_Option(v$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(x$3$2);
      var this$3 = $n(x$3);
      var x$2$1 = this$3.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range;
      $n(x$3);
      return new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(x$2$1, v)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$7 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$7.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w)
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype.setPeriod__I__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__Ljapgolly_scalajs_react_callback_Trampoline = (function(i, s) {
  var this$4 = $n(this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2$2) => {
    var s$2 = $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(s$2$2);
    $n(s$2);
    var range = $m_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$().fromDate__Ljava_time_LocalDate__I__Lreactbuild_analyze_cost_modules_hometimereport_MonthRange($n($n(s$2).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start, i);
    var this$2 = $n(s$2);
    var resource = this$2.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource;
    return new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(range, resource)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$4, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype.periodLink__I__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__Ljapgolly_scalajs_react_vdom_TagOf = (function(i, s) {
  var $$x3 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(this.setPeriod__I__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__Ljapgolly_scalajs_react_callback_Trampoline(i, s)));
  var this$1 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_withLittlePadding;
  var $$x2 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$1, s$1);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var $$x1 = $n($n(s).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start;
  var hi = (i >> 31);
  var this$3 = $n($n($$x1).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(i, hi)));
  var formatter = $m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$().Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_dateFormatter;
  var v = $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T(this$3, formatter);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  return $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype.render__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props__f_proxy;
  var u$2 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$().query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(s).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range, new $c_sjsr_AnonFunction1(((range$2) => {
    var range = $as_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(range$2);
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x4 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x3 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listTimeReportEvents"];
    var $$x2 = $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$17 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
    var r = $n(range).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start;
    var evidence$2 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
    var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
    var $$x1 = $ct_T2__O__O__(new $c_T2(), "from", y);
    var this$11 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$12 = $n(new $c_Lautowire_ClientProxy(this$11).Lautowire_ClientProxy__f_self);
    var r$1 = $n(range).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_end;
    var evidence$2$1 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
    var y$1 = this$12.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
    var array$1 = [$$x1, $ct_T2__O__O__(new $c_T2(), "to", y$1)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($$x4).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x2, this$17.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$18 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$20 = $n(new $c_Lautowire_ClientProxy(this$18).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_model_TimeReportEvent$().Lreactbuild_model_TimeReportEvent$__f_codecForTimeReportEvent;
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$20.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), new $c_sjsr_AnonFunction1(((potSS$2) => {
    var potSS = $as_Ldiode_data_Pot(potSS$2);
    var this$24 = $n($n(potSS).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$4$2);
      var this$21 = $n($as_sc_IterableOps($n(x$4).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
      var m = $as_scm_Map($m_scm_Map$().empty__O());
      var it = this$21.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var elem = $n(it).next__O();
        var x$5 = $as_Lreactbuild_model_TimeReportEvent(elem);
        var key = $n(x$5).Lreactbuild_model_TimeReportEvent__f_resource;
        var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$21) => (() => this$21.newSpecificBuilder__scm_Builder()))(this$21))));
        var this$22 = $n(bldr);
        this$22.addOne__O__scm_Growable(elem)
      };
      var this$23 = $m_sci_HashMap$();
      var result = this$23.sci_HashMap$__f_EmptyMap;
      var mapIt = $n(m).iterator__sc_Iterator();
      while ($n(mapIt).hasNext__Z()) {
        var x1 = $as_T2($n(mapIt).next__O());
        if ((x1 === null)) {
          throw new $c_s_MatchError(x1)
        };
        var k = $n(x1)._1__O();
        var v = $as_scm_Builder($n(x1)._2__O());
        result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
      };
      return result
    }))));
    var grouped = $as_sci_Map((this$24.isEmpty__Z() ? ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()) : this$24.get__O()));
    $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
    var f = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$2 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x5;
        var p2 = $as_s_Option(x1$2.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p2 instanceof $c_s_Some)) {
          var x3 = $as_s_Some(p2);
          var newList = $as_sci_List($n(x3).s_Some__f_value);
          var this$27 = $n($n(potSS).toList__sci_List());
          var z = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb);
          var acc = z;
          var these = this$27;
          while ((!$n(these).isEmpty__Z())) {
            var arg1 = acc;
            var arg2 = $n(these).head__O();
            var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(arg1)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var ss = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg2);
            var updated = $n($as_sc_IterableOnceOps($n($as_sc_IterableOps($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(s).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource)).foldLeft__O__F2__O(grouped, new $c_sjsr_AnonFunction2(((newList) => ((x$6$2, x$7$2) => {
              var x$6 = $as_sci_Map(x$6$2);
              var x$7 = $as_Lreactbuild_common_model_RefTo(x$7$2);
              return $as_sci_Map($n(x$6).updated__O__O__sci_MapOps(x$7, newList))
            }))(newList))))).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$8$2) => {
              var x$8 = $as_T2(x$8$2);
              return $as_sci_List($n(x$8)._2__O())
            }))))).toList__sci_List();
            var this$29 = $n(ss);
            var callback = new $c_sjsr_AnonFunction0(((cb$2) => (() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)))(cb$2));
            var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
            var arg1$1 = this$29.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
            $as_sci_List(arg1$1);
            acc = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$29.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(updated), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
            these = $as_sc_LinearSeq($n(these).tail__O())
          };
          var $$x5 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(acc)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1$2.T2__f__1);
        var cb$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x = $m_s_None$();
        if ((x === p4)) {
          var $$x5 = cb$3;
          break matchEnd7
        };
        throw new $c_s_MatchError(x1$2)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x5)
    }));
    var reuseEvents = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f);
    var $$x22 = $m_Lreactbuild_analyze_cost_components_AutoScrollArea$();
    var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$34 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexRow;
    var $$x20 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$34, s$1);
    var $$x19 = this.periodLink__I__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__Ljapgolly_scalajs_react_vdom_TagOf((-1), s);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$35 = $n($n($n(s).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start);
    var formatter = $m_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$().Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$__f_dateFormatter;
    var v$1 = $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T(this$35, formatter);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$2 = [$$x20, $$x19, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1), this.periodLink__I__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__Ljapgolly_scalajs_react_vdom_TagOf(1, s)];
    var $$x18 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$43 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexRow;
    var $$x12 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$43, s$2);
    var $$x11 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $n(grouped).keySet__sci_Set();
    var array$4 = [$$x12, $n($$x11).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((res$2) => {
      var res = $as_Lreactbuild_common_model_RefTo(res$2);
      var $$x16 = $m_Lcom_iz2use_react_components_Link$();
      var this$47 = $n(this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$10$2) => {
        var x$10 = $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(x$10$2);
        var x$2 = $m_s_Option$().apply__O__s_Option(res);
        var this$45 = $n(x$10);
        var x$3 = this$45.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range;
        $n(x$10);
        return new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(x$3, x$2)
      }));
      var $$x15 = $n($n($$x16).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$47, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
      var this$48 = $m_Lscalacss_ScalaCssReact$();
      var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerEventSelected;
      var this$49 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$48, s$3));
      var condition = $n($n(s).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource).contains__O__Z(res);
      var $$x14 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$49, condition);
      var this$50 = $m_Lscalacss_ScalaCssReact$();
      var s$4 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_withLittlePadding;
      var $$x13 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$50, s$4);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$51 = $m_Lreactbuild_model_Implicits$();
      var ev = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$51, proxy);
      var v$2 = $n(ev).stringify__O__T(res);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$3 = [$$x14, $$x13, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      return $n($$x15).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    })))];
    var $$x10 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var this$61 = $n($n(s).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource);
    if (this$61.isEmpty__Z()) {
      var events = $m_s_None$()
    } else {
      var arg1$2 = this$61.get__O();
      var res$3 = $as_Lreactbuild_common_model_RefTo(arg1$2);
      var this$62 = $n($n(grouped).get__O__s_Option(res$3));
      if (this$62.isEmpty__Z()) {
        var events = $m_s_None$()
      } else {
        var arg1$3 = this$62.get__O();
        var lst = $as_sci_List(arg1$3);
        var events = new $c_s_Some(lst)
      }
    };
    var $$x9 = $m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$();
    var $$x8 = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range;
    var $$x7 = $n(s).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource;
    var $$x6 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
    var this$63 = $n(events);
    var u = $n($$x9).apply__Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__s_Option__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x8, $$x7, $n($$x6).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(reuseEvents, (this$63.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$63.get__O()), $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$().Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__f_reusableTimeReportEvent)));
    var this$65 = $n(u);
    var n = this$65.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$5 = [$$x18, $$x10, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    var u$1 = $n($$x22).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
    var this$71 = $n(u$1);
    var n$1 = this$71.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  })), $m_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$().Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$__f_reusableMonthRange, $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$().Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$__f_reusableTimeReportEvent), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
  var this$74 = $n(u$2);
  var n$2 = this$74.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$Backend", {
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend.prototype.render__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var base = $n($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_range).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start).minusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0));
  var this$1 = $n($as_sc_IterableOps($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_events).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var x$11 = $as_Lreactbuild_model_TimeReportEvent(elem);
    var this$2 = $n($n(x$11).Lreactbuild_model_TimeReportEvent__f_date);
    var key = this$2.Ljava_time_LocalDateTime__f_date;
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(this$1))));
    var this$3 = $n(bldr);
    this$3.addOne__O__scm_Growable(elem)
  };
  var this$4 = $m_sci_HashMap$();
  var result = this$4.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
  };
  var groupedEvents = result;
  var this$5 = $n($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_range).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start);
  var x = $p_Ljava_time_LocalDate__day__S(this$5);
  var this$7 = $n($n($n(p).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_range).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_end);
  var end = $p_Ljava_time_LocalDate__day__S(this$7);
  var isEmpty = (x > end);
  if (isEmpty) {
    var scala$collection$immutable$Range$$numRangeElements = 0
  } else {
    var hi = (end >> 31);
    var hi$1 = (x >> 31);
    var lo = ((end - x) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ end)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
    var lo$1 = ((1 + lo) | 0);
    var hi$3 = ((lo$1 === 0) ? ((1 + hi$2) | 0) : hi$2);
    var scala$collection$immutable$Range$$numRangeElements = (((hi$3 === 0) ? (((-2147483648) ^ lo$1) > (-1)) : (hi$3 > 0)) ? (-1) : lo$1)
  };
  if ((scala$collection$immutable$Range$$numRangeElements < 0)) {
    $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(x, end, 1, true)
  };
  var b = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
  var it$1 = new $c_sci_RangeIterator(x, 1, end, isEmpty);
  while (it$1.sci_RangeIterator__f__hasNext) {
    var this$18 = $n(b);
    var arg1 = it$1.next__I();
    var $$x1 = $n(base);
    var hi$4 = (arg1 >> 31);
    var day = $n($$x1).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(arg1, hi$4));
    $m_Lreactbuild_model_TimeReportEvent$();
    var events = $as_sci_List($n(groupedEvents).getOrElse__O__F0__O(day, new $c_sjsr_AnonFunction0((() => $m_s_package$().s_package$__f_Nil))));
    var intervals = new $c_Lreactbuild_model_TimeReportEvent$RichTimeReportEventList(events).intervals__sci_List();
    var elem$1 = new $c_T4(arg1, day, new $c_Lreactbuild_model_TimeReportInterval$RichTimeReportInterval(intervals).total__s_Option(), intervals);
    this$18.addOne__O__scm_Growable(elem$1)
  };
  var dayList = $as_sci_IndexedSeq($n(b).result__O());
  var monthTotal = new $c_Lreactbuild_model_Duration($uD($n(dayList).foldLeft__O__F2__O(0.0, new $c_sjsr_AnonFunction2(((acc$2, c$2) => {
    var acc = $uD(acc$2);
    var c = $as_T4(c$2);
    return $uD($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($as_s_Option($n(c).T4__f__3))).foldLeft__O__F2__O(acc, new $c_sjsr_AnonFunction2(((x$12$2, x$13$2) => {
      var x$12 = $uD(x$12$2);
      var x$13 = $as_Lreactbuild_model_Duration(x$13$2);
      return (x$12 + $n(x$13).Lreactbuild_model_Duration__f_value)
    }))))
  })))));
  var $$x37 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$21 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reportTable;
  var $$x36 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$21, s$1);
  var this$22 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
  var $$x35 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$22, s$2);
  var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x31 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Jour"))];
  var array$1 = [$n($$x31).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var $$x30 = $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x28 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Heures travaill\u00e9es"))];
  var array$3 = [$n($$x28).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var $$x27 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9tails pointages"))];
  var array$5 = [$n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var array$6 = [$$x30, $$x27, $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  var array$7 = [$n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
  var $$x24 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$13 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), dayList), new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T4(x0$1$2);
    if ((x0$1 !== null)) {
      var day$1 = $as_Ljava_time_LocalDate($n(x0$1).T4__f__2);
      var total = $as_s_Option($n(x0$1).T4__f__3);
      var intervals$1 = $as_sci_List($n(x0$1).T4__f__4);
      var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var this$77 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
      var $$x20 = this$77.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$80 = $n(day$1);
      var formatter = $m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$().Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$__f_dayFormatter;
      var v$1 = $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T(this$80, formatter);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$8 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      var array$9 = [$$x20, $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
      var $$x18 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
      var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var this$92 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
      var $$x16 = this$92.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
      var ev = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
      var v$2 = ev.stringify__s_Option__T(total);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$10 = [$$x16, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      var $$x15 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
      var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var o = $n(p).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_resource;
      var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
      var array$11 = [new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((resource$2) => {
        var resource = $as_Lreactbuild_common_model_RefTo(resource$2);
        var u = $m_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_common_model_RefTo__Ljava_time_LocalDate__sci_List__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_events, resource, day$1, intervals$1);
        var this$104 = $n(u);
        var n = this$104.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      })))];
      var array$12 = [$$x18, $$x15, $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
      return $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))];
  var $$x13 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$122 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  var $$x9 = this$122.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$125 = $n(groupedEvents);
  var v$3 = $n(this$125.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size;
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
  var $$x7 = $n(parsable).stringify__O__T(v$3);
  $m_Lcom_iz2use_common_Textualizable$();
  var v$4 = $n(dayList).length__I();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
  var v$5 = ((($$x7 + " / ") + $n(parsable$1).stringify__O__T(v$4)) + " jours");
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$14 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
  var array$15 = [$$x9, $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  var $$x6 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15));
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$141 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  var $$x4 = this$141.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var ev$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
  var v$6 = $n(ev$1).stringify__O__T(monthTotal);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$16 = [$$x4, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$6)];
  var $$x3 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$17 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Total"))];
  var array$18 = [$$x6, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))];
  var array$19 = [$n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))];
  var array$20 = [$$x36, $$x35, $$x24, $$x13, $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tfoot", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19))];
  return $n($$x37).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20))
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$Backend", {
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseOrganization = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseTitle = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseProject = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseFrom = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseUntil = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseStage = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseParticipant = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_save = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_form = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_dateRef = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_startRef = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_s_Option(v$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$2$2);
      $n(x$2);
      var this$3 = $n(x$2);
      var from = this$3.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from;
      var this$4 = $n(x$2);
      var until = this$4.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until;
      var this$5 = $n(x$2);
      var title = this$5.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title;
      var this$6 = $n(x$2);
      var stage = this$6.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage;
      var this$7 = $n(x$2);
      var participant = this$7.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant;
      var this$8 = $n(x$2);
      var project = this$8.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project;
      return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(v, from, until, title, stage, participant, project)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$12 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$12.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseOrganization = $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w);
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$1 = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$3$2);
    return $n(x$3).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title
  }));
  var set$1 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_s_Option(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$4$2);
      var this$13 = $n(x$4);
      var x$2$1 = this$13.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization;
      var this$14 = $n(x$4);
      var x$3$1 = this$14.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from;
      var this$15 = $n(x$4);
      var x$4$2$1 = this$15.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until;
      var this$16 = $n(x$4);
      var x$5 = this$16.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage;
      var this$17 = $n(x$4);
      var x$6 = this$17.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant;
      var this$18 = $n(x$4);
      var x$7 = this$18.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project;
      $n(x$4);
      return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$2$1, x$3$1, x$4$2$1, v$3, x$5, x$6, x$7)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$1, set$1);
  var this$22 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$1 = this$22.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseTitle = $n($$x4).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x3, \u03b4, w$1);
  var $$x6 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$2 = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$5$2);
    return $n(x$5$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project
  }));
  var set$2 = new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4 = $as_s_Option(v$4$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$6$2);
      var this$23 = $n(x$6$1);
      var x$9 = this$23.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization;
      var this$24 = $n(x$6$1);
      var x$10 = this$24.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from;
      var this$25 = $n(x$6$1);
      var x$11 = this$25.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until;
      var this$26 = $n(x$6$1);
      var x$12 = this$26.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title;
      var this$27 = $n(x$6$1);
      var x$13 = this$27.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage;
      var this$28 = $n(x$6$1);
      var x$14 = this$28.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant;
      $n(x$6$1);
      return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$9, x$10, x$11, x$12, x$13, x$14, v$4)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x5 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$2, set$2);
  var this$32 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$2 = this$32.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseProject = $n($$x6).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x5, \u03b4, w$2);
  var $$x8 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$3 = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$7$2);
    var this$33 = $n($n(x$7$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from);
    if (this$33.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$33.get__O();
      var x$8 = $as_Ljava_time_LocalDateTime(arg1);
      var this$34 = $n(x$8);
      return new $c_s_Some(this$34.Ljava_time_LocalDateTime__f_date)
    }
  }));
  var set$3 = new $c_sjsr_AnonFunction1(((v$5$2) => {
    var v$5 = $as_s_Option(v$5$2);
    return new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$9$2);
      var this$35 = $n(v$5);
      if (this$35.isEmpty__Z()) {
        var x$15 = $m_s_None$()
      } else {
        var arg1$1 = this$35.get__O();
        var x$10$1 = $as_Ljava_time_LocalDate(arg1$1);
        var this$36 = $n(x$10$1);
        var x$15 = new $c_s_Some($m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$36, $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime()))
      };
      var this$37 = $n(x$9$1);
      var x$16 = this$37.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization;
      var this$38 = $n(x$9$1);
      var x$17 = this$38.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until;
      var this$39 = $n(x$9$1);
      var x$18 = this$39.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title;
      var this$40 = $n(x$9$1);
      var x$19 = this$40.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage;
      var this$41 = $n(x$9$1);
      var x$20 = this$41.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant;
      var this$42 = $n(x$9$1);
      var x$21 = this$42.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project;
      $n(x$9$1);
      return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$16, x$15, x$17, x$18, x$19, x$20, x$21)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x7 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$3, set$3);
  var this$46 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$3 = this$46.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseFrom = $n($$x8).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x7, \u03b4, w$3);
  var $$x10 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$4 = new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$11$2);
    var this$47 = $n($n(x$11$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until);
    if (this$47.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$2 = this$47.get__O();
      var x$12$1 = $as_Ljava_time_LocalDateTime(arg1$2);
      var this$48 = $n($n(x$12$1).minusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(1, 0)));
      return new $c_s_Some(this$48.Ljava_time_LocalDateTime__f_date)
    }
  }));
  var set$4 = new $c_sjsr_AnonFunction1(((v$6$2) => {
    var v$6 = $as_s_Option(v$6$2);
    return new $c_sjsr_AnonFunction1(((x$13$2) => {
      var x$13$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$13$2);
      var this$49 = $n(v$6);
      if (this$49.isEmpty__Z()) {
        var x$22 = $m_s_None$()
      } else {
        var arg1$3 = this$49.get__O();
        var x$14$1 = $as_Ljava_time_LocalDate(arg1$3);
        var this$50 = $n($n(x$14$1).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)));
        var x$22 = new $c_s_Some($m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$50, $m_Ljava_time_LocalTime$().MIDNIGHT__Ljava_time_LocalTime()))
      };
      var this$51 = $n(x$13$1);
      var x$23 = this$51.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization;
      var this$52 = $n(x$13$1);
      var x$24 = this$52.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from;
      var this$53 = $n(x$13$1);
      var x$25 = this$53.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title;
      var this$54 = $n(x$13$1);
      var x$26 = this$54.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage;
      var this$55 = $n(x$13$1);
      var x$27 = this$55.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant;
      var this$56 = $n(x$13$1);
      var x$28 = this$56.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project;
      $n(x$13$1);
      return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$23, x$24, x$22, x$25, x$26, x$27, x$28)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x9 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$4, set$4);
  var this$60 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$4 = this$60.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseUntil = $n($$x10).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x9, \u03b4, w$4);
  var $$x12 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$5 = new $c_sjsr_AnonFunction1(((x$15$2) => {
    var x$15$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$15$2);
    return $n(x$15$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage
  }));
  var set$5 = new $c_sjsr_AnonFunction1(((v$7$2) => {
    var v$7 = $as_s_Option(v$7$2);
    return new $c_sjsr_AnonFunction1(((x$16$2) => {
      var x$16$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$16$2);
      var this$61 = $n(x$16$1);
      var x$30 = this$61.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization;
      var this$62 = $n(x$16$1);
      var x$31 = this$62.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from;
      var this$63 = $n(x$16$1);
      var x$32 = this$63.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until;
      var this$64 = $n(x$16$1);
      var x$33 = this$64.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title;
      var this$65 = $n(x$16$1);
      var x$34 = this$65.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant;
      var this$66 = $n(x$16$1);
      var x$35 = this$66.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project;
      $n(x$16$1);
      return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$30, x$31, x$32, x$33, v$7, x$34, x$35)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x11 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$5, set$5);
  var this$70 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$5 = this$70.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseStage = $n($$x12).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x11, \u03b4, w$5);
  var $$x14 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$6 = new $c_sjsr_AnonFunction1(((x$17$2) => {
    var x$17$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$17$2);
    return $n(x$17$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant
  }));
  var set$6 = new $c_sjsr_AnonFunction1(((v$8$2) => {
    var v$8 = $as_s_Option(v$8$2);
    return new $c_sjsr_AnonFunction1(((x$18$2) => {
      var x$18$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$18$2);
      var this$71 = $n(x$18$1);
      var x$37 = this$71.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization;
      var this$72 = $n(x$18$1);
      var x$38 = this$72.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from;
      var this$73 = $n(x$18$1);
      var x$39 = this$73.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until;
      var this$74 = $n(x$18$1);
      var x$40 = this$74.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title;
      var this$75 = $n(x$18$1);
      var x$41 = this$75.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage;
      var this$76 = $n(x$18$1);
      var x$42 = this$76.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project;
      $n(x$18$1);
      return new $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$37, x$38, x$39, x$40, x$41, v$8, x$42)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x13 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$6, set$6);
  var this$80 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$6 = this$80.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseParticipant = $n($$x14).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x13, \u03b4, w$6);
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(\u03b4).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((v$2$1) => {
      var v$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(v$2$1);
      var this$81 = $n($n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_event);
      var prev = new $c_s_util_Either$RightProjection(this$81).toOption__s_Option();
      return $ct_T2__O__O__(new $c_T2(), v$1, prev)
    })), null), new $c_sjsr_AnonFunction1(((x$28$2) => {
      var x$28$1 = $as_T2(x$28$2);
      if ((x$28$1 !== null)) {
        var v$9 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State($n(x$28$1)._1__O());
        var prev$1 = $as_s_Option($n(x$28$1)._2__O());
        var $$x15 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
          var this$82 = $n($n(v$9).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from);
          if (this$82.isEmpty__Z()) {
            var this$83 = $n(prev$1);
            if (this$83.isEmpty__Z()) {
              return $m_s_None$()
            } else {
              var arg1$4 = this$83.get__O();
              var x$19$1 = $as_Lreactbuild_model_AllocatedTime(arg1$4);
              return new $c_s_Some($n(x$19$1).Lreactbuild_model_AllocatedTime__f_from)
            }
          } else {
            return this$82
          }
        }))), new $c_sjsr_AnonFunction1(((from$2) => {
          var from$1 = $as_Ljava_time_LocalDateTime(from$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
            var this$84 = $n($n(v$9).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until);
            if (this$84.isEmpty__Z()) {
              var this$85 = $n(prev$1);
              if (this$85.isEmpty__Z()) {
                return $m_s_None$()
              } else {
                var arg1$5 = this$85.get__O();
                var x$20$1 = $as_Lreactbuild_model_AllocatedTime(arg1$5);
                return new $c_s_Some($n(x$20$1).Lreactbuild_model_AllocatedTime__f_until)
              }
            } else {
              return this$84
            }
          }))), new $c_sjsr_AnonFunction1(((until$2) => {
            var until$1 = $as_Ljava_time_LocalDateTime(until$2);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
              var this$86 = $n($n(v$9).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project);
              if (this$86.isEmpty__Z()) {
                var this$87 = $n(prev$1);
                if (this$87.isEmpty__Z()) {
                  return $m_s_None$()
                } else {
                  var arg1$6 = this$87.get__O();
                  var x$21$1 = $as_Lreactbuild_model_AllocatedTime(arg1$6);
                  return new $c_s_Some($n(x$21$1).Lreactbuild_model_AllocatedTime__f_project)
                }
              } else {
                return this$86
              }
            }))), new $c_sjsr_AnonFunction1(((project$2) => {
              var project$1 = $as_Lreactbuild_common_model_RefTo(project$2);
              return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
                var this$88 = $n($n(v$9).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization);
                if (this$88.isEmpty__Z()) {
                  var this$89 = $n(prev$1);
                  if (this$89.isEmpty__Z()) {
                    return $m_s_None$()
                  } else {
                    var arg1$7 = this$89.get__O();
                    var x$22$1 = $as_Lreactbuild_model_AllocatedTime(arg1$7);
                    return new $c_s_Some($n(x$22$1).Lreactbuild_model_AllocatedTime__f_organization)
                  }
                } else {
                  return this$88
                }
              }))), new $c_sjsr_AnonFunction1(((organization$2) => {
                var organization = $as_Lreactbuild_common_model_RefTo(organization$2);
                return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
                  var this$90 = $n($n(v$9).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title);
                  if (this$90.isEmpty__Z()) {
                    var this$91 = $n(prev$1);
                    if (this$91.isEmpty__Z()) {
                      return $m_s_None$()
                    } else {
                      var arg1$8 = this$91.get__O();
                      var x$23$1 = $as_Lreactbuild_model_AllocatedTime(arg1$8);
                      return new $c_s_Some($n(x$23$1).Lreactbuild_model_AllocatedTime__f_title)
                    }
                  } else {
                    return this$90
                  }
                }))), new $c_sjsr_AnonFunction1(((title$2) => {
                  var title$1 = $as_T(title$2);
                  var $$x17 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
                  var $$x16 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
                  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
                  var this$ = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
                    var this$92 = $n($n(v$9).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant);
                    if (this$92.isEmpty__Z()) {
                      var this$93 = $n(prev$1);
                      if (this$93.isEmpty__Z()) {
                        return $m_s_None$()
                      } else {
                        var arg1$9 = this$93.get__O();
                        var x$24$1 = $as_Lreactbuild_model_AllocatedTime(arg1$9);
                        return new $c_s_Some($n(x$24$1).Lreactbuild_model_AllocatedTime__f_participant)
                      }
                    } else {
                      return this$92
                    }
                  })));
                  var condition = new $c_sjsr_AnonFunction1(((participant$2) => {
                    $as_Lreactbuild_common_model_RefTo(participant$2);
                    return $n(from$1).isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z(until$1)
                  }));
                  return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($n($$x17).flatMap$extension__F0__F1__F0($n($$x16).map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$, condition), new $c_sjsr_AnonFunction1(((participant$3$2) => {
                    var participant$3 = $as_Lreactbuild_common_model_RefTo(participant$3$2);
                    var this$95 = $n(prev$1);
                    if (this$95.isEmpty__Z()) {
                      var $$x18 = $m_s_None$()
                    } else {
                      var arg1$10 = this$95.get__O();
                      var x$25$1 = $as_Lreactbuild_model_AllocatedTime(arg1$10);
                      var $$x18 = new $c_s_Some($n(x$25$1).Lreactbuild_model_AllocatedTime__f__id)
                    };
                    var this$96 = $n($$x18);
                    var next = new $c_Lreactbuild_model_AllocatedTime($as_Lreactbuild_common_model_RefTo((this$96.isEmpty__Z() ? ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())) : this$96.get__O())), organization, project$1, $n(v$9).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage, title$1, from$1, until$1, participant$3);
                    return $ct_T2__O__O__(new $c_T2(), participant$3, next)
                  })), null), new $c_sjsr_AnonFunction1(((x$27$2) => {
                    var x$27$1 = $as_T2(x$27$2);
                    if ((x$27$1 !== null)) {
                      var next$1 = $as_Lreactbuild_model_AllocatedTime($n(x$27$1)._2__O());
                      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
                      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_context).Lreactbuild_analyze_cost_components_ProgressContext__f_track).apply__O__O__O(new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
                        var this$98 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                        var $$x22 = new $c_Lautowire_ClientProxy(this$98).Lautowire_ClientProxy__f_self;
                        var $$x21 = $m_s_package$().s_package$__f_Seq;
                        var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistAllocatedTime"];
                        var $$x20 = $as_sci_Seq($n($$x21).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
                        var this$109 = $n($m_s_Predef$().s_Predef$__f_Map);
                        var this$103 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                        var this$104 = $n(new $c_Lautowire_ClientProxy(this$103).Lautowire_ClientProxy__f_self);
                        var evidence$2 = $m_Lreactbuild_model_AllocatedTime$().Lreactbuild_model_AllocatedTime$__f_codecForAllocatedTime;
                        var y = this$104.write__O__Lio_circe_Encoder__Lio_circe_Json(next$1, evidence$2);
                        var array$1 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
                        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
                        return $n($n($$x22).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x20, this$109.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$43$2) => {
                          var x$43 = $as_Lio_circe_Json(x$43$2);
                          var this$110 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
                          var this$111 = $n(new $c_Lautowire_ClientProxy(this$110).Lautowire_ClientProxy__f_self);
                          var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
                          this$111.read__Lio_circe_Json__Lio_circe_Decoder__O(x$43, evidence$1)
                        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
                      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)), $n($n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_modState).apply__O__O__O(next$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline($m_Lcom_iz2use_react_components_Dialog$Pop$())))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
                      var f = new $c_sjsr_AnonFunction1(((x$26$2) => {
                        $as_jl_Void(x$26$2)
                      }));
                      var this$114 = $n(this$$1);
                      var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$114, f);
                      var $$x19 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c)
                    } else {
                      var $$x19;
                      throw new $c_s_MatchError(x$27$1)
                    };
                    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($$x19)
                  }))))
                }))))
              }))))
            }))))
          }))))
        })))
      } else {
        var $$x15;
        throw new $c_s_MatchError(x$28$1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($$x15)
    }))))
  })));
  var $$x23 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$117 = $m_s_$less$colon$less$();
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_save = $n($$x23).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$117.s_$less$colon$less$__f_singleton);
  var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onSubmit");
  var array$2 = [stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => {
    var $$x24 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $m_Ljapgolly_scalajs_react_package$();
    var this$123 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x24).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$123.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_save))
  })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_form = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("form", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    var this$127 = $m_Ljava_time_LocalDate$();
    return this$127.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
  }));
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_dateRef = new $c_Lcom_iz2use_common_ParsingReference$Simple(f$1);
  var f$2 = new $c_sjsr_AnonFunction0((() => {
    var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$131 = $n(this$$2);
    var this$132 = $n($n($as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$131))).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from);
    if (this$132.isEmpty__Z()) {
      var this$133 = $m_Ljava_time_LocalDate$();
      return this$133.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
    } else {
      var arg1$11 = this$132.get__O();
      var x$29 = $as_Ljava_time_LocalDateTime(arg1$11);
      var this$135 = $n(x$29);
      return this$135.Ljava_time_LocalDateTime__f_date
    }
  }));
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_startRef = new $c_Lcom_iz2use_common_ParsingReference$Simple(f$2)
}
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend.prototype.render__Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_proxy;
  var this$1 = $n($n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_event);
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var x$30 = $as_Lreactbuild_model_AllocatedTime(b);
    new $c_s_util_Right($n(x$30).Lreactbuild_model_AllocatedTime__f_organization)
  };
  var this$159 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x26 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_form;
  var this$2 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
  var $$x25 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$2, s$1);
  var $$x24 = $m_Lcom_iz2use_react_components_Dialog$();
  var s$2 = $n($n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_context).Lreactbuild_analyze_cost_components_ProgressContext__f_statusIcon;
  var this$4 = $n(s$2);
  var array = [$f_Lreactbuild_analyze_cost_components_Progress$State__render__Ljapgolly_scalajs_react_vdom_VdomNode(this$4), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Planification d'un \u00e9v\u00e9nement"))];
  var $$x23 = $n($$x24).header__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var c = $m_Lcom_iz2use_react_components_Layout$().Lcom_iz2use_react_components_Layout$__f_horizontal;
  var this$149 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var s$3 = $n($n(p).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_context).Lreactbuild_analyze_cost_components_ProgressContext__f_statusIcon;
  var this$12 = $n(s$3);
  var $$x22 = $f_Lreactbuild_analyze_cost_components_Progress$State__render__Ljapgolly_scalajs_react_vdom_VdomNode(this$12);
  var c$1 = $m_Lcom_iz2use_react_components_Layout$().Lcom_iz2use_react_components_Layout$__f_vertical;
  var this$142 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c$1).ctor__Ljapgolly_scalajs_react_CtorType()));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Organisation");
  var $$x20 = $n(this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseOrganization);
  var this$16 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  var state = $n($$x20).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$16.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$18 = $m_Lreactbuild_model_Implicits$();
  var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$18, proxy);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$19 = $m_Lreactbuild_model_Implicits$();
  var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(this$19, proxy);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$23 = $m_Lreactbuild_model_Implicits$();
  var this$22 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$22, proxy);
  var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$23, ev);
  var $$x21 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$1, explainError, equiv);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Projet");
  var $$x18 = $n(this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseProject);
  var this$27 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$1 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  var state$1 = $n($$x18).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$27.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$1));
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$29 = $m_Lreactbuild_model_Implicits$();
  var ev$3 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$29, proxy);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$30 = $m_Lreactbuild_model_Implicits$();
  var helper$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(this$30, proxy);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$34 = $m_Lreactbuild_model_Implicits$();
  var this$33 = $m_Lreactbuild_model_Implicits$();
  var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$33, proxy);
  var equiv$1 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$34, ev$2);
  var $$x19 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$3, explainError$1, equiv$1);
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$38 = $m_Lscalacss_ScalaCssReact$();
  var s$4 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_horizontalLayout;
  var $$x16 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$38, s$4);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$40 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX");
  var $$x15 = this$40.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("visible", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Stade d'avancement");
  var $$x12 = $n(this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseStage);
  var this$43 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$2 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  var state$2 = $n($$x12).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$43.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$2));
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$46 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization = $m_s_None$();
  var ev$4 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$17(this$46, proxy, organization);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$48 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization$1 = $m_s_None$();
  var helper$2 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$17(this$48, proxy, organization$1);
  var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
  var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var $$x13 = $m_Lreactbuild_model_Implicits$();
  var this$51 = $m_Lreactbuild_model_Implicits$();
  var equiv$2 = $n($$x13).buildingStageRefOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering($f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$51, proxy));
  var $$x14 = editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$2, optioner$2, ev$4, explainError$2, equiv$2);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Intitul\u00e9 de la r\u00e9servation");
  var $$x11 = $n(this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseTitle);
  var this$56 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$55 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$3 = this$55.by_$eq$eq__F2();
  var state$3 = $n($$x11).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$56.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$3));
  var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$5);
  var ev$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$61 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$61);
  var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
  var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv = $m_s_math_Equiv$String$();
  var equiv$3 = new $c_s_math_Equiv$OptionEquiv(eqv);
  var array$1 = [$$x16, $$x15, $$x14, editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$3, optioner$3, ev$6, explainError$3, equiv$3)];
  var $$x10 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Intervenant");
  var $$x8 = $n(this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseParticipant);
  var this$71 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$4 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  var state$4 = $n($$x8).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$71.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$4));
  var optioner$4 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$74 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization$2 = $m_s_None$();
  var ev$8 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$74, proxy, organization$2);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$76 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization$3 = $m_s_None$();
  var helper$4 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$76, proxy, organization$3);
  var editorComponent$4 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$4);
  var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$80 = $m_Lreactbuild_model_Implicits$();
  var this$79 = $m_Lreactbuild_model_Implicits$();
  var ev$7 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$79, proxy);
  var equiv$4 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$80, ev$7);
  var $$x9 = editorComponent$4.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$4, state$4, optioner$4, ev$8, explainError$4, equiv$4);
  var c$2 = $m_Lcom_iz2use_react_components_Layout$().Lcom_iz2use_react_components_Layout$__f_horizontal;
  var this$112 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c$2).ctor__Ljapgolly_scalajs_react_CtorType()));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9but");
  var $$x5 = $n(this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseFrom);
  var this$85 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$5 = $m_Lreactbuild_model_Implicits$().reusabilityLocalDate__F2();
  var state$5 = $n($$x5).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$85.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$5));
  var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$5 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  $m_Lcom_iz2use_common_Parsable$();
  $m_Lcom_iz2use_common_Parsable$();
  var reference = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_dateRef;
  var ev$9 = new $c_Lcom_iz2use_common_Parsable$$anon$4(reference);
  var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$9);
  var ev$10 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$91 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$5 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$91);
  var editorComponent$5 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$5);
  var explainError$5 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var equiv$5 = new $c_s_math_Equiv$OptionEquiv(eqv$1);
  var $$x6 = editorComponent$5.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$5, state$5, optioner$5, ev$10, explainError$5, equiv$5);
  var dateRef = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_startRef;
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Fin");
  var $$x4 = $n(this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend__f_reuseUntil);
  var this$98 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$6 = $m_Lreactbuild_model_Implicits$().reusabilityLocalDate__F2();
  var state$6 = $n($$x4).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$98.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$6));
  var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$6 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
  $m_Lcom_iz2use_common_Parsable$();
  $m_Lcom_iz2use_common_Parsable$();
  var ev$11 = new $c_Lcom_iz2use_common_Parsable$$anon$4(dateRef);
  var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$11);
  var ev$12 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$104 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$6 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$104);
  var editorComponent$6 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$6);
  var explainError$6 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var eqv$2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var equiv$6 = new $c_s_math_Equiv$OptionEquiv(eqv$2);
  var array$2 = [$$x6, editorComponent$6.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$6, state$6, optioner$6, ev$12, explainError$6, equiv$6)];
  var children = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$112.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$112.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children));
  var this$114 = $n(u);
  var n = this$114.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x7 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  var c$3 = $m_Lcom_iz2use_react_components_Layout$().Lcom_iz2use_react_components_Layout$__f_horizontal;
  var this$135 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c$3).ctor__Ljapgolly_scalajs_react_CtorType()));
  var $$x3 = $n($m_Lcom_iz2use_react_components_Button$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline($m_Lcom_iz2use_react_components_Dialog$Pop$())));
  var array$3 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("reset", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Annuler"))];
  var $$x2 = $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var $$x1 = $m_Lcom_iz2use_react_components_Button$().submit__Ljapgolly_scalajs_react_vdom_TagOf();
  var array$4 = [($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Enregistrer"))];
  var array$5 = [$$x2, $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var children$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var u$1 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$135.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$135.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children$1));
  var this$137 = $n(u$1);
  var n$1 = this$137.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$6 = [$$x21, $$x19, $$x10, $$x9, $$x7, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  var children$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var u$2 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$142.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$142.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children$2));
  var this$144 = $n(u$2);
  var n$2 = this$144.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$7 = [$$x22, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
  var children$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var u$3 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$149.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$149.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children$3));
  var this$151 = $n(u$3);
  var n$3 = this$151.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$8 = [$$x25, $$x23, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)];
  var array$9 = [$n($$x26).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$159, null, ns)
});
function $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend: 0
}, false, "reactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$Backend", {
  Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Backend;
function $p_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend__loop$1__D__Ljava_time_LocalDateTime__Z__sci_List__Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, pos, time, isFirst, acc, p$1, unitDescription$1, attr$1) {
  while (true) {
    if ($n(time).isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z($as_Ljava_time_chrono_ChronoLocalDateTime($n($n($n(p$1).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped).Lcom_iz2use_common_MappedTypedRange__f_fromRange).Lcom_iz2use_common_TypedRange__f_until))) {
      var this$1 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var ns = $n(acc).reverse__sci_List();
      return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$1, null, ns)
    } else {
      var fixedNext = $as_Ljava_time_LocalDateTime($n($n(unitDescription$1).Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_next).apply__O__O((isFirst ? $n($n(unitDescription$1).Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_startOf).apply__O__O(time) : time)));
      var nextPos = $uD($n($n(p$1).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped).apply__O__O(fixedNext));
      var width = (nextPos - pos);
      var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$4 = $m_Lscalacss_ScalaCssReact$();
      var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerTimeRulerLine;
      var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((pos + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((width + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), attr$1];
      var line = $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      if ((width < 20.0)) {
        var this$10 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
        var ns$1 = $m_sci_Nil$();
        var text = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$10, null, ns$1)
      } else {
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$13 = $m_Lscalacss_ScalaCssReact$();
        var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerTimeRulerText;
        var $$x5 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$13, s$1);
        var $$x4 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((pos + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        var $$x3 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((width + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        var $$x2 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + time), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = $n($n(unitDescription$1).formatter__Ljava_time_format_DateTimeFormatter()).format__Ljava_time_temporal_TemporalAccessor__T((isFirst ? $as_Ljava_time_temporal_TemporalAccessor($n($n(unitDescription$1).Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_startOf).apply__O__O(time)) : time));
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$1 = [$$x5, $$x4, $$x3, $$x2, attr$1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
        var text = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      };
      var this$21 = $n(acc);
      var this$22 = new $c_sci_$colon$colon(line, this$21);
      var x$3 = new $c_sci_$colon$colon(text, this$22);
      pos = nextPos;
      time = fixedNext;
      isFirst = false;
      acc = x$3
    }
  }
}
function $p_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend__generateLines$1__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Ljapgolly_scalajs_react_vdom_TagMod__Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, unitDescription, attr, p$1) {
  var t = $n(unitDescription).Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_unit;
  var this$1 = $n($n(p$1).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_leftColumn);
  return $p_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend__loop$1__D__Ljava_time_LocalDateTime__Z__sci_List__Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, $uD((this$1.isEmpty__Z() ? 0.0 : this$1.get__O())), $as_Ljava_time_LocalDateTime($n($n($n(p$1).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped).Lcom_iz2use_common_MappedTypedRange__f_fromRange).Lcom_iz2use_common_TypedRange__f_from), true, $m_s_package$().s_package$__f_Nil, p$1, unitDescription, attr)
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend.prototype.render__Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__Lreactbuild_analyze_cost_modules_planner_TimeRuler$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  $n($n(p).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped);
  var this$1 = $m_Ljava_time_LocalDateTime$();
  var now = this$1.now__Ljava_time_Clock__Ljava_time_LocalDateTime(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()));
  var this$24 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$5 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerTimeRulerNow;
  var $$x4 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s$1);
  var this$6 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var this$7 = $n(this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString));
  var condition = $n($as_Lcom_iz2use_common_TypedRange($n($n(p).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).contains__O__Z(now);
  var condition$1 = (!condition);
  var array = [$$x4, $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$7, condition$1), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(($n($n(p).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped).apply__O__O(now) + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var $$x3 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x2 = $p_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend__generateLines$1__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Ljapgolly_scalajs_react_vdom_TagMod__Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__Ljapgolly_scalajs_react_vdom_VdomNode(this, $n($n(p).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_timeScale).Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_primary, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("top")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), p);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$15 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_plannerHorizontalLine;
  var array$1 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$15, s$2), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("top")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$2 = [$$x3, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)), $p_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend__generateLines$1__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Ljapgolly_scalajs_react_vdom_TagMod__Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__Ljapgolly_scalajs_react_vdom_VdomNode(this, $n($n(p).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_timeScale).Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_secondary, ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("top")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), p)];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$24, null, ns)
});
function $as_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.TimeRuler$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.TimeRuler$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend: 0
}, false, "reactbuild.analyze.cost.modules.planner.TimeRuler$Backend", {
  Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend.prototype.render__Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var pageProps = $n(p).Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_pageProps;
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reportTable;
  var $$x13 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
  var $$x12 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$2);
  var this$5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
  var $$x11 = this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ressources"))];
  var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("r\u00e9f\u00e9rences"))];
  var array$2 = [$$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var $$x4 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var u = $m_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$().apply__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(p).Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_projects, pageProps);
  var this$30 = $n(u);
  var n = this$30.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Total"))];
  var array$4 = [$$x4, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var array$5 = [$n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var $$x1 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var u$1 = $m_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$().apply__sci_List__Ldiode_data_Pot__F1__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_projects, $n(p).Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_resourceUsage, $n(p).Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_showDetails, pageProps);
  var this$46 = $n(u$1);
  var n$1 = this$46.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$6 = [$$x13, $$x12, $$x11, $$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  return $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
});
function $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.CompareProjectTable$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.CompareProjectTable$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjectTable$Backend", {
  Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_reuseT = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_reuseT = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2())
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype.showDetails__s_Option__Ljapgolly_scalajs_react_callback_Trampoline = (function(v) {
  var this$3 = $n(this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_modules_project_CompareProjects$State(x$1$2);
    $n(x$1);
    return new $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State(v)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype.render__Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__Lreactbuild_analyze_cost_modules_project_CompareProjects$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var pageProps = $n(p).Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_pageProps;
  var projectPot = $n($n(p).Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_projects).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_sci_List(x$2$2);
    var this$2 = $n(x$2);
    var f = ((x$3$2) => {
      var x$3 = $as_Lreactbuild_common_model_Project(x$3$2);
      return $n(x$3).Lreactbuild_common_model_Project__f__id
    });
    if ((this$2 === $m_sci_Nil$())) {
      return $m_sci_Nil$()
    } else {
      var arg1 = this$2.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$2.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      return h
    }
  })));
  var $$x30 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
  var $$x26 = new $c_sjsr_AnonFunction1(((q$2) => {
    var q = $as_Ldiode_data_Pot(q$2);
    var this$23 = $n($n(q).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((projects$2) => {
      var projects = $as_sci_List(projects$2);
      var this$3 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x29 = new $c_Lautowire_ClientProxy(this$3).Lautowire_ClientProxy__f_self;
      var $$x28 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "project", "ProjectApi", "listResourceUsage"];
      var $$x27 = $as_sci_Seq($n($$x28).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$19 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$8 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$14 = $n(new $c_Lautowire_ClientProxy(this$8).Lautowire_ClientProxy__f_self);
      $n($m_s_package$().s_package$__f_List);
      var array$1 = [new $c_Lreactbuild_project_ResourceUsageClause$ProjectFilter(new $c_Lreactbuild_project_Selection$List(projects))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      var r = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
      $m_Lio_circe_Encoder$();
      var encodeA = $m_Lreactbuild_project_ResourceUsageClause$().Lreactbuild_project_ResourceUsageClause$__f_codecForResourceUsageClause;
      var evidence$2 = new $c_Lio_circe_Encoder$$anon$25(encodeA);
      var y = this$14.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
      var array$2 = [$ct_T2__O__O__(new $c_T2(), "filters", y)];
      var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return $n($n($$x29).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x27, this$19.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$20 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$22 = $n(new $c_Lautowire_ClientProxy(this$20).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lreactbuild_project_ResourceUsage$().Lreactbuild_project_ResourceUsage$__f_codecForResourceUsage;
        var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
        return $as_sci_List(this$22.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }))));
    return $as_s_concurrent_Future((this$23.isEmpty__Z() ? $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_sci_Nil$()) : this$23.get__O()))
  }));
  var $$x2 = new $c_sjsr_AnonFunction1(((r$2) => {
    var r$1 = $as_Ldiode_data_Pot(r$2);
    var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$26 = $m_Lscalacss_ScalaCssReact$();
    var s$1 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_horizontalLayout;
    var $$x24 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$26, s$1);
    var $$x23 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$29 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
    var $$x22 = this$29.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x21 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$34 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_verticalLayout;
    var $$x19 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$34, s$2);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$36 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
    var $$x18 = this$36.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x16 = $m_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$();
    var this$39 = $n(projectPot);
    var u = $n($$x16).apply__sci_List__Ldiode_data_Pot__F1__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_sci_List((this$39.isEmpty__Z() ? $m_sci_Nil$() : this$39.get__O())), $n(r$1).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$4$2);
      return $as_sci_List($n(x$4).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
    }))), new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_s_Option(v$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.showDetails__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(v))
    })), pageProps);
    var this$41 = $n(u);
    var n = this$41.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    var array$4 = [$$x19, $$x18, $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    var $$x15 = $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var this$49 = $n($n(s).Lreactbuild_analyze_cost_modules_project_CompareProjects$State__f_invoiceDetails);
    if (this$49.isEmpty__Z()) {
      var this$50 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var ns = $m_sci_Nil$();
      var $$x3 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$50, null, ns)
    } else {
      var arg1$2 = this$49.get__O();
      var ref = $as_Lreactbuild_common_model_RefTo(arg1$2);
      var $$x14 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
      var $$x10 = new $c_sjsr_AnonFunction1(((ref$2$2) => {
        var ref$2 = $as_Lreactbuild_common_model_RefTo(ref$2$2);
        var this$51 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x13 = new $c_Lautowire_ClientProxy(this$51).Lautowire_ClientProxy__f_self;
        var $$x12 = $m_s_package$().s_package$__f_Seq;
        var array$5 = ["reactbuild", "project", "ProjectApi", "listDocumentForId"];
        var $$x11 = $as_sci_Seq($n($$x12).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)));
        var this$62 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$56 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$57 = $n(new $c_Lautowire_ClientProxy(this$56).Lautowire_ClientProxy__f_self);
        var evidence$2$1 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
        var y$1 = this$57.write__O__Lio_circe_Encoder__Lio_circe_Json(ref$2, evidence$2$1);
        var array$6 = [$ct_T2__O__O__(new $c_T2(), "ref", y$1)];
        var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
        return $n($n($$x13).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x11, this$62.from__sc_IterableOnce__sci_Map(elems$2)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2$1) => {
          var x$2$1 = $as_Lio_circe_Json(x$2$2$1);
          var this$63 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$64 = $n(new $c_Lautowire_ClientProxy(this$63).Lautowire_ClientProxy__f_self);
          var evidence$1$1 = $m_Lreactbuild_model_InvoicePageGroup$().Lreactbuild_model_InvoicePageGroup$__f_codecForInvoicePageGroup;
          return $as_Lreactbuild_model_InvoicePageGroup(this$64.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2$1, evidence$1$1))
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      }));
      var $$x5 = new $c_sjsr_AnonFunction1(((r$2$1) => {
        var r$3 = $as_Ldiode_data_Pot(r$2$1);
        var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$67 = $m_Lscalacss_ScalaCssReact$();
        var s$3 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_verticalLayout;
        var $$x8 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$67, s$3);
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
        var this$69 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
        var $$x7 = this$69.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        var this$70 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignSelf__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$());
        var $$x6 = this$70.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("stretch", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        var u$1 = $m_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$().apply__Ldiode_data_Pot__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(r$3, pageProps);
        var this$72 = $n(u$1);
        var n$1 = this$72.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var array$7 = [$$x8, $$x7, $$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
        return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
      }));
      var $$x4 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
      $m_Lreactbuild_model_Implicits$();
      var this$78 = $m_Ljapgolly_scalajs_react_Reusability$();
      var u$2 = $n($$x14).query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(ref, $$x10, $$x5, $$x4, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$78.byRef__F2(), this$78.by_$eq$eq__F2()), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
      var this$80 = $n(u$2);
      var n$2 = this$80.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
    };
    var array$8 = [$$x24, $$x23, $$x22, $$x21, $$x15, $as_Ljapgolly_scalajs_react_vdom_TagMod($$x3)];
    return $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  }));
  var $$x1 = $m_Lreactbuild_model_Implicits$();
  var this$85 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2());
  var u$3 = $n($$x30).query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(projectPot, $$x26, $$x2, $n($$x1).reusabilityPotC__F2__F2(this$85.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3)), this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend__f_reuseT, $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
  var this$87 = $n(u$3);
  var n$3 = this$87.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)
});
function $as_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.CompareProjects$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.CompareProjects$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjects$Backend", {
  Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjects$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype.toggleDetails__s_Option__Ljapgolly_scalajs_react_callback_Trampoline = (function(key) {
  var this$6 = $n(this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State(s$2);
    if ($n($n(s).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails).contains__O__Z(key)) {
      var this$2 = $n($n(s).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails);
      var x$1 = $as_sci_Set(this$2.excl__O__sci_SetOps(key))
    } else {
      var this$3 = $n($n(s).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails);
      var x$1 = $as_sci_Set(this$3.incl__O__sci_SetOps(key))
    };
    var this$4 = $n(s);
    var x$2 = this$4.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_groupByBuildingStage;
    $n(s);
    return new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State(x$2, x$1)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$6, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype.renderPart__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__s_Option__T__Ldiode_data_Pot__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s, key, label, pot) {
  var pageProps = $n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_pageProps;
  var this$1 = $n(pot);
  var lst = $as_sci_List((this$1.isEmpty__Z() ? $m_sci_Nil$() : this$1.get__O()));
  if ($n(lst).isEmpty__Z()) {
    var $$x1 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var a = ("" + key);
    return $n($$x1).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a, $m_sci_Nil$())
  } else {
    var $$x18 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var a$1 = ("" + key);
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#F00", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(label)), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.toggleDetails__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(key)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
    var array$1 = [$n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var array$2 = [$n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    var $$x14 = $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    if ($n($n(s).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails).contains__O__Z(key)) {
      var this$25 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var ns = $m_sci_Nil$();
      var $$x13 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$25, null, ns)
    } else {
      var u = $m_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$().apply__sci_List__Ldiode_data_Pot__F1__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_projects, pot, $n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_showDetails, pageProps);
      var this$27 = $n(u);
      var n = this$27.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x13 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    };
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = ("Total " + label);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x9 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_projects;
    var $$x4 = $n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((ref$2) => {
      var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
      var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var this$44 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
      var $$x7 = this$44.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var this$45 = $n(lst);
      var acc = 0.0;
      var these = this$45;
      while ((!$n(these).isEmpty__Z())) {
        var arg1 = acc;
        var arg2 = $n(these).head__O();
        var acc$1 = $uD(arg1);
        var c = $as_Lreactbuild_project_ResourceUsage(arg2);
        acc = (acc$1 + $uD($n(c).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((ref) => ((p$2) => {
          var p$1 = $as_Lreactbuild_project_ProductResourceUsage(p$2);
          if ((!$n($n(p$1).Lreactbuild_project_ProductResourceUsage__f_project).contains__O__Z(ref))) {
            return 0.0
          } else {
            var this$46 = $n($n(p$1).Lreactbuild_project_ProductResourceUsage__f_total);
            if (this$46.isEmpty__Z()) {
              return 0.0
            } else {
              var arg1$1 = this$46.get__O();
              var x$5 = $as_Lreactbuild_model_Price(arg1$1);
              return $n(x$5).Lreactbuild_model_Price__f_amount
            }
          }
        }))(ref)), new $c_sjsr_AnonFunction1(((x$6$2) => {
          $as_Lreactbuild_project_PersonResourceUsage(x$6$2);
          return 0.0
        })))));
        these = $as_sc_LinearSeq($n(these).tail__O())
      };
      var total = $uD(acc);
      if ((total === 0.0)) {
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("")
      } else {
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Lcom_iz2use_common_Textualizable$();
        var v$1 = new $c_Lreactbuild_model_Price(total);
        var ev$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var v$2 = $n(ev$4).stringify__O__T(v$1);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)
      };
      var array$4 = [$$x7, $$x6];
      return $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
    })));
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$58 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x2 = this$58.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$59 = $n(lst);
    var acc$2 = 0.0;
    var these$1 = this$59;
    while ((!$n(these$1).isEmpty__Z())) {
      var arg1$2 = acc$2;
      var arg2$1 = $n(these$1).head__O();
      var acc$3 = $uD(arg1$2);
      var c$1 = $as_Lreactbuild_project_ResourceUsage(arg2$1);
      acc$2 = (acc$3 + $uD($n(c$1).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((x$7$2) => {
        var x$7 = $as_Lreactbuild_project_ProductResourceUsage(x$7$2);
        var this$61 = $n($n(x$7).Lreactbuild_project_ProductResourceUsage__f_total);
        if (this$61.isEmpty__Z()) {
          return 0.0
        } else {
          var arg1$3 = this$61.get__O();
          var x$8 = $as_Lreactbuild_model_Price(arg1$3);
          return $n(x$8).Lreactbuild_model_Price__f_amount
        }
      })), new $c_sjsr_AnonFunction1(((x$9$2) => {
        $as_Lreactbuild_project_PersonResourceUsage(x$9$2);
        return 0.0
      })))));
      these$1 = $as_sc_LinearSeq($n(these$1).tail__O())
    };
    var v$3 = new $c_Lreactbuild_model_Price($uD(acc$2));
    var ev$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var v$4 = $n(ev$5).stringify__O__T(v$3);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$5 = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
    var array$6 = [$$x9, $$x4, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var array$7 = [$n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
    var array$8 = [$$x14, $$x13, $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tfoot", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
    return $n($$x18).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a$1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype.render__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_pageProps).Lreactbuild_package$PageProps__f_proxy;
  $n($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_pageProps);
  var this$1 = $n($n(s).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_groupByBuildingStage);
  var map = $as_sci_Map((this$1.isEmpty__Z() ? ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()) : this$1.get__O()));
  var this$10 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var rassoc$1 = this.renderPart__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__s_Option__T__Ldiode_data_Pot__Ljapgolly_scalajs_react_vdom_VdomElement(p, s, $m_s_None$(), "(Non d\u00e9fini)", $n($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_resourceUsage).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$10$2) => {
    $as_sci_List(x$10$2);
    return $as_sci_List($n(map).getOrElse__O__F0__O($m_s_None$(), new $c_sjsr_AnonFunction0((() => $m_sci_Nil$()))))
  }))));
  $m_Lreactbuild_package$();
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$5 = $n(proxy);
  var this$6 = $n(this$5.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$6.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$11 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$11).Lreactbuild_model_CommonData__f_buildingParts
  };
  var this$8 = $n($as_sci_List($$x1));
  var f = ((part$2) => {
    var part = $as_Lreactbuild_model_BuildingPart(part$2);
    var key = new $c_s_Some($n(part).Lreactbuild_model_BuildingPart__f__id);
    var lst = $as_sci_List($n(map).getOrElse__O__F0__O(key, new $c_sjsr_AnonFunction0((() => $m_sci_Nil$()))));
    return this.renderPart__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__s_Option__T__Ldiode_data_Pot__Ljapgolly_scalajs_react_vdom_VdomElement(p, s, key, $n(part).Lreactbuild_model_BuildingPart__f_label, $n($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_resourceUsage).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$12$2) => {
      $as_sci_List(x$12$2);
      return lst
    }))))
  });
  if ((this$8 === $m_sci_Nil$())) {
    var $$x2 = $m_sci_Nil$()
  } else {
    var arg1$1 = this$8.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$8.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x2 = h
  };
  var this$9 = $n($$x2);
  var ns = new $c_sci_$colon$colon(rassoc$1, this$9);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$10, null, ns)
});
function $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$Backend", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend.prototype.render__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var pageProps = $n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_pageProps;
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).verticalAlign__Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$());
  var $$x2 = this$3.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("text-top", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$4 = $n($n(s).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State__f_groupByRefOrDesc);
  var as = $as_sc_IterableOnce((this$4.isEmpty__Z() ? $m_sci_Nil$() : this$4.get__O()));
  var array = [$$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((pair$2) => {
    var pair = $as_T2(pair$2);
    var u = $m_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$().apply__T__T__sci_List__Ldiode_data_Pot__F1__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_T($n(pair)._1__O()), $as_T($n($as_Lreactbuild_project_ResourceUsage($n($as_sc_IterableOps($n(pair)._2__O())).head__O())).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((x$17$2) => {
      var x$17 = $as_Lreactbuild_project_ProductResourceUsage(x$17$2);
      return $n(x$17).Lreactbuild_project_ProductResourceUsage__f_description
    })), new $c_sjsr_AnonFunction1(((x$18$2) => {
      var x$18 = $as_Lreactbuild_project_PersonResourceUsage(x$18$2);
      return $as_T($n($m_Lreactbuild_common_model_RefTo$().keyMapper__Lcom_iz2use_common_KeyMapper()).apply__O__O($n(x$18).Lreactbuild_project_PersonResourceUsage__f_person))
    })))), $n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_projects, $n($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_resourceUsage).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$19$2) => {
      $as_sci_List(x$19$2);
      return $as_sci_List($n(pair)._2__O())
    }))), $n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_showDetails, pageProps);
    var this$7 = $n(u);
    var n = this$7.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  })))];
  return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
function $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$Backend", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Backend;
function $p_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend__loop$1__sci_List__Lreactbuild_model_Price__D__sci_List__sci_List__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__Ljapgolly_scalajs_react_vdom_TagMod($thiz, rest, amount, quantity, unitPrices, src$1, s$3, p$3) {
  while (true) {
    var x1 = rest;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x1)) {
      if ($n(src$1).isEmpty__Z()) {
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("")
      } else {
        var this$153 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
        var $$x38 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Lcom_iz2use_common_Textualizable$();
        var v = amount;
        var ev = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var v$1 = $n(ev).stringify__O__T(v);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
        var $$x37 = $n($$x38).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
        var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x35 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#BBB", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
        if (((quantity === 0.0) || $n(unitPrices).isEmpty__Z())) {
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var $$x32 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("")
        } else {
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Lcom_iz2use_common_Textualizable$();
          var v$2 = quantity;
          $m_Lcom_iz2use_common_Textualizable$();
          var parsable = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
          var $$x34 = $n(parsable).stringify__O__T(v$2);
          $m_Lcom_iz2use_common_Textualizable$();
          var this$17 = $n(unitPrices);
          var num = $m_s_math_Numeric$DoubleIsFractional$();
          var $$x33 = $uD($f_sc_IterableOnceOps__sum__s_math_Numeric__O(this$17, num));
          var this$18 = $n(unitPrices);
          var v$3 = new $c_Lreactbuild_model_Price(($$x33 / this$18.length__I()));
          var ev$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
          var v$4 = (($$x34 + " x ") + $n(ev$1).stringify__O__T(v$3));
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var $$x32 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)
        };
        var array$1 = [$$x35, $$x32];
        var $$x31 = $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
        if ((!$n(s$3).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__f_showDetails)) {
          var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), $m_sci_Nil$())
        } else {
          var $$x30 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var this$29 = $m_Lscalacss_ScalaCssReact$();
          var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_reportTable;
          var $$x29 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$29, s);
          var this$30 = $m_Lscalacss_ScalaCssReact$();
          var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_fixedHeadersTable;
          var $$x28 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$30, s$1);
          var this$31 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
          var $$x27 = this$31.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
          var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Date"))];
          var $$x24 = $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
          var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9f."))];
          var $$x22 = $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
          var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Qt\u00e9"))];
          var $$x20 = $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
          var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Mnt U"))];
          var $$x18 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
          var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Total"))];
          var array$7 = [$$x24, $$x22, $$x20, $$x18, $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
          var $$x16 = $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
          var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$15 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), src$1), new $c_sjsr_AnonFunction1(((p$3) => ((r$2) => {
            var r = $as_Lreactbuild_project_ResourceUsage(r$2);
            var qty = $as_T($n(r).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((x$23$2) => {
              var x$23 = $as_Lreactbuild_project_ProductResourceUsage(x$23$2);
              var this$76 = $n($n(x$23).Lreactbuild_project_ProductResourceUsage__f_quantity);
              if (this$76.isEmpty__Z()) {
                var $$x2 = ""
              } else {
                var arg1 = this$76.get__O();
                var x$24 = $uD(arg1);
                $m_Lcom_iz2use_common_Textualizable$();
                $m_Lcom_iz2use_common_Textualizable$();
                var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
                var $$x2 = $n(parsable$1).stringify__O__T(x$24)
              };
              return $as_T($$x2)
            })), new $c_sjsr_AnonFunction1(((x$25$2) => {
              $as_Lreactbuild_project_PersonResourceUsage(x$25$2);
              return ""
            }))));
            var total = $as_T($n(r).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((v$2$1) => {
              var v$5 = $as_Lreactbuild_project_ProductResourceUsage(v$2$1);
              $m_Lcom_iz2use_common_Textualizable$();
              var v$6 = $n(v$5).Lreactbuild_project_ProductResourceUsage__f_total;
              $m_Lcom_iz2use_common_Textualizable$();
              var textualizable = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
              var ev$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
              return ev$2.stringify__s_Option__T(v$6)
            })), new $c_sjsr_AnonFunction1(((v$3$2) => {
              var v$3$1 = $as_Lreactbuild_project_PersonResourceUsage(v$3$2);
              $m_Lcom_iz2use_common_Textualizable$();
              var v$7 = $n(v$3$1).Lreactbuild_project_PersonResourceUsage__f_total;
              var ev$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
              return $n(ev$3).stringify__O__T(v$7)
            }))));
            var unitPrice = $as_T($n(r).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((v$4$2) => {
              var v$4$1 = $as_Lreactbuild_project_ProductResourceUsage(v$4$2);
              $m_Lcom_iz2use_common_Textualizable$();
              var this$82 = $n($n(v$4$1).Lreactbuild_project_ProductResourceUsage__f_quantity);
              if (this$82.isEmpty__Z()) {
                var v$8 = $m_s_None$()
              } else {
                var arg1$1 = this$82.get__O();
                var q = $uD(arg1$1);
                var this$83 = $n($n(v$4$1).Lreactbuild_project_ProductResourceUsage__f_total);
                if (this$83.isEmpty__Z()) {
                  var v$8 = $m_s_None$()
                } else {
                  var arg1$2 = this$83.get__O();
                  var a = $as_Lreactbuild_model_Price(arg1$2);
                  var v$8 = new $c_s_Some(new $c_Lreactbuild_model_Price(($n(a).Lreactbuild_model_Price__f_amount / q)))
                }
              };
              $m_Lcom_iz2use_common_Textualizable$();
              var textualizable$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
              var ev$4 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1);
              return ev$4.stringify__s_Option__T(v$8)
            })), new $c_sjsr_AnonFunction1(((x$26$2) => {
              $as_Lreactbuild_project_PersonResourceUsage(x$26$2);
              return ""
            }))));
            var link = $as_Ljapgolly_scalajs_react_vdom_TagMod($n(r).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((v$5$2) => {
              var v$5$1 = $as_Lreactbuild_project_ProductResourceUsage(v$5$2);
              var $$x4 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p$3).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_showDetails).apply__O__O(new $c_s_Some($n($n(v$5$1).Lreactbuild_project_ProductResourceUsage__f_parent).Lreactbuild_model_InvoicePage__f__id)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
              $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
              $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
              var this$88 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
              var a$1 = $n($n($n($n(p$3).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_pageProps).Lreactbuild_package$PageProps__f_router).urlFor__O__Ljapgolly_scalajs_react_extra_router_AbsUrl(new $c_Lreactbuild_Loc$Processing(new $c_s_Some($n($n(v$5$1).Lreactbuild_project_ProductResourceUsage__f_parent).Lreactbuild_model_InvoicePage__f__id)))).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value;
              var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
              var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$88.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
              $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
              var this$89 = $n($n($n(v$5$1).Lreactbuild_project_ProductResourceUsage__f_parent).Lreactbuild_model_InvoicePage__f_reference);
              var v$9 = ("" + (this$89.isEmpty__Z() ? "R\u00e9f\u00e9rence facture inconnue" : this$89.get__O()));
              $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
              var array$8 = [$$x3, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$9)];
              return $n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
            })), new $c_sjsr_AnonFunction1(((x$27$2) => {
              $as_Lreactbuild_project_PersonResourceUsage(x$27$2);
              $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
              $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
              return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("")
            }))));
            var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
            $m_Lcom_iz2use_common_Textualizable$();
            var v$10 = $n(r).date__Ljava_time_LocalDate();
            var ev$5 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
            var v$11 = $n(ev$5).stringify__O__T(v$10);
            $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
            var array$9 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$11)];
            var $$x12 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
            var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
            var this$110 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
            var array$10 = [this$110.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), link];
            var $$x10 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
            var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
            var this$117 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
            var array$11 = [this$117.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(qty))];
            var $$x8 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
            var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
            var this$126 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
            var array$12 = [this$126.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(unitPrice))];
            var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
            var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
            var this$135 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
            var array$13 = [this$135.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(total))];
            var array$14 = [$$x12, $$x10, $$x8, $$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
            return $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))
          }))(p$3)))];
          var array$16 = [$$x29, $$x28, $$x27, $$x16, $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
          var $$x1 = $n($$x30).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))
        };
        var array$17 = [$$x37, $$x31, $$x1];
        var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
        return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$153, null, ns)
      }
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $as_Lreactbuild_project_ResourceUsage($n(x3).sci_$colon$colon__f_head);
      var tl = $n(x3).sci_$colon$colon__f_next;
      var amount$2 = amount;
      var $$x39 = new $c_sjsr_AnonFunction1(((amount$1) => ((p$2) => {
        var p = $as_Lreactbuild_project_ProductResourceUsage(p$2);
        return $as_Lreactbuild_model_Price($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(p).Lreactbuild_project_ProductResourceUsage__f_total)).foldLeft__O__F2__O(amount$1, new $c_sjsr_AnonFunction2(((x$28$2, x$29$2) => {
          var x$28 = $as_Lreactbuild_model_Price(x$28$2);
          var x$29 = $as_Lreactbuild_model_Price(x$29$2);
          return $as_Lreactbuild_model_Price($n($m_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$().Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$__f_numPrice).plus__O__O__O(x$28, x$29))
        }))))
      }))(amount$2));
      var amount$4 = amount;
      var nextAmount = $as_Lreactbuild_model_Price($n(head).fold__F1__F1__O($$x39, new $c_sjsr_AnonFunction1(((amount$3) => ((x$30$2) => {
        $as_Lreactbuild_project_PersonResourceUsage(x$30$2);
        return amount$3
      }))(amount$4))));
      var quantity$2 = quantity;
      var $$x40 = new $c_sjsr_AnonFunction1(((quantity$1) => ((p$4$2) => {
        var p$4 = $as_Lreactbuild_project_ProductResourceUsage(p$4$2);
        return $uD($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(p$4).Lreactbuild_project_ProductResourceUsage__f_quantity)).foldLeft__O__F2__O(quantity$1, new $c_sjsr_AnonFunction2(((x$31$2, x$32$2) => {
          var x$31 = $uD(x$31$2);
          var x$32 = $uD(x$32$2);
          return (x$31 + x$32)
        }))))
      }))(quantity$2));
      var quantity$4 = quantity;
      var nextQuantity = $uD($n(head).fold__F1__F1__O($$x40, new $c_sjsr_AnonFunction1(((quantity$3) => ((x$33$2) => {
        $as_Lreactbuild_project_PersonResourceUsage(x$33$2);
        return quantity$3
      }))(quantity$4))));
      var unitPrices$2 = unitPrices;
      var $$x41 = new $c_sjsr_AnonFunction1(((unitPrices$1) => ((p$5$2) => {
        var p$5 = $as_Lreactbuild_project_ProductResourceUsage(p$5$2);
        return $as_sci_List($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(p$5).Lreactbuild_project_ProductResourceUsage__f_total)).foldLeft__O__F2__O(unitPrices$1, new $c_sjsr_AnonFunction2(((acc$2, c$2) => {
          var acc = $as_sci_List(acc$2);
          var c = $as_Lreactbuild_model_Price(c$2);
          var $$x43 = $m_s_Option$();
          var this$154 = $n($n(p$5).Lreactbuild_project_ProductResourceUsage__f_quantity);
          if (this$154.isEmpty__Z()) {
            var $$x42 = true
          } else {
            var arg1$3 = this$154.get__O();
            var x$34 = $uD(arg1$3);
            var $$x42 = (x$34 !== 0.0)
          };
          return $as_sci_List($n($n($$x43).option2Iterable__s_Option__sc_Iterable(($$x42 ? this$154 : $m_s_None$()))).foldLeft__O__F2__O(acc, new $c_sjsr_AnonFunction2(((acc$2$2, qty$2) => {
            var acc$2$1 = $as_sci_List(acc$2$2);
            var qty$1 = $uD(qty$2);
            var rassoc$2 = ($n(c).Lreactbuild_model_Price__f_amount / qty$1);
            var this$155 = $n(acc$2$1);
            return new $c_sci_$colon$colon(rassoc$2, this$155)
          }))))
        }))))
      }))(unitPrices$2));
      var unitPrices$4 = unitPrices;
      var nextUnitPrices = $as_sci_List($n(head).fold__F1__F1__O($$x41, new $c_sjsr_AnonFunction1(((unitPrices$3) => ((x$35$2) => {
        $as_Lreactbuild_project_PersonResourceUsage(x$35$2);
        return unitPrices$3
      }))(unitPrices$4))));
      rest = tl;
      amount = nextAmount;
      quantity = nextQuantity;
      unitPrices = nextUnitPrices
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype.toggleDetails__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$3 = $n(this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State(s$2);
    $n(s);
    var showDetails = (!$n(s).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__f_showDetails);
    return new $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State(showDetails)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype.accumulate__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__sci_List__Ljapgolly_scalajs_react_vdom_TagMod = (function(p, s, src) {
  $n($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_pageProps);
  return $p_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend__loop$1__sci_List__Lreactbuild_model_Price__D__sci_List__sci_List__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__Ljapgolly_scalajs_react_vdom_TagMod(this, src, $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_zero, 0.0, $m_sci_Nil$(), src, s, p)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype.render__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var this$1 = $n($n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_resourceUsage);
  var usages = $as_sci_List((this$1.isEmpty__Z() ? $m_sci_Nil$() : this$1.get__O()));
  var this$2 = $n(usages);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$2.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var x$36 = $as_Lreactbuild_project_ResourceUsage(elem);
    var key = $n(x$36).project__s_Option();
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => {
      $m_sci_List$();
      return new $c_scm_ListBuffer()
    }))));
    var this$4 = $n(bldr);
    this$4.addOne__O__scm_Growable(elem)
  };
  var this$5 = $m_sci_HashMap$();
  var result = this$5.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
  };
  var grp = result;
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x12 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.toggleDetails__Ljapgolly_scalajs_react_callback_Trampoline()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$1 = $n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_label;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
  var $$x10 = $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$19 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontWeight__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$());
  var $$x8 = this$19.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("lighter", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$20 = $n(grp);
  var v$2 = $as_T($n($as_Lreactbuild_project_ResourceUsage($n($as_sc_IterableOps($n($as_T2($n(this$20.iterator__sc_Iterator()).next__O()))._2__O())).head__O())).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((x$37$2) => {
    var x$37 = $as_Lreactbuild_project_ProductResourceUsage(x$37$2);
    var this$21 = $n($n(x$37).Lreactbuild_project_ProductResourceUsage__f_reference);
    return $as_T((this$21.isEmpty__Z() ? "" : this$21.get__O()))
  })), new $c_sjsr_AnonFunction1(((x$38$2) => {
    $as_Lreactbuild_project_PersonResourceUsage(x$38$2);
    return ""
  }))));
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$1 = [$$x8, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
  var array$2 = [$$x12, $$x10, $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  var $$x7 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n(p).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_projects;
  var $$x2 = $n($$x3).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((ref$2) => {
    var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$34 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x5 = this$34.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$35 = $n(grp);
    _return: {
      var it$1 = this$35.iterator__sc_Iterator();
      while ($n(it$1).hasNext__Z()) {
        var a = $n(it$1).next__O();
        var x$39 = $as_T2(a);
        if ($n($as_s_Option($n(x$39)._1__O())).contains__O__Z(ref)) {
          var this$36 = new $c_s_Some(a);
          break _return
        }
      };
      var this$36 = $m_s_None$()
    };
    if (this$36.isEmpty__Z()) {
      var $$x4 = $m_s_None$()
    } else {
      var arg1 = this$36.get__O();
      var x$40 = $as_T2(arg1);
      var $$x4 = new $c_s_Some($as_sci_List($n(x$40)._2__O()))
    };
    var this$37 = $n($$x4);
    var array$3 = [$$x5, this.accumulate__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__sci_List__Ljapgolly_scalajs_react_vdom_TagMod(p, s, $as_sci_List((this$37.isEmpty__Z() ? $m_sci_Nil$() : this$37.get__O())))];
    return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  })));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$44 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
  var array$4 = [this$44.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), this.accumulate__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__sci_List__Ljapgolly_scalajs_react_vdom_TagMod(p, s, usages)];
  var array$5 = [$$x7, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  return $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
});
function $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$Backend", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Backend;
function $p_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__loop$1__I__sci_Vector__I__Lreactbuild_analyze_cost_modules_project_ProjectImageContext__sci_Seq__sci_Vector($thiz, index, acc, len$1, context$1, images$2) {
  while (true) {
    if ((index === len$1)) {
      var $$x6 = $n(acc);
      $n($m_s_package$().s_package$__f_List);
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var u = $m_Lreactbuild_analyze_cost_modules_project_InsertionPoint$().apply__I__Lreactbuild_analyze_cost_modules_project_ProjectImageContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(index, context$1);
      var this$4 = $n(u);
      var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
      var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_add, "", "24px")];
      var $$x2 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$16 = $m_Lscalacss_ScalaCssReact$();
      var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_projectImageListSpace;
      var array$2 = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$16, s)];
      var array$3 = [$$x4, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
      return $n($$x6).appendedAll__sc_IterableOnce__sci_Vector($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems))
    } else {
      $n($m_s_package$().s_package$__f_List);
      var u$1 = $m_Lreactbuild_analyze_cost_modules_project_InsertionPoint$().apply__I__Lreactbuild_analyze_cost_modules_project_ProjectImageContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(index, context$1);
      var this$25 = $n(u$1);
      var n$1 = this$25.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x7 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
      var u$2 = $m_Lreactbuild_analyze_cost_modules_project_ProjectImage$().apply__Lreactbuild_common_model_Image__Lreactbuild_analyze_cost_modules_project_ProjectImageContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($as_Lreactbuild_common_model_Image($n(images$2).apply__I__O(index)), context$1);
      var this$28 = $n(u$2);
      var n$2 = this$28.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$4 = [$$x7, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
      var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
      var base = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
      var temp$index = ((1 + index) | 0);
      var temp$acc = $n(acc).appendedAll__sc_IterableOnce__sci_Vector(base);
      index = temp$index;
      acc = temp$acc
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_reuseDragSource = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_reuseDragTarget = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(x$3$2);
    return $n(x$3).Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragSource
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_s_Option(v$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(x$4$2);
      $n(x$4);
      var this$3 = $n(x$4);
      var dragTarget = this$3.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragTarget;
      return new $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(v, dragTarget)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$7 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$7.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_reuseDragSource = $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w);
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$1 = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(x$5$2);
    return $n(x$5).Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragTarget
  }));
  var set$1 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_s_Option(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(x$6$2);
      var this$8 = $n(x$6);
      var x$2 = this$8.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragSource;
      $n(x$6);
      return new $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(x$2, v$3)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$1, set$1);
  var this$12 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$1 = this$12.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_reuseDragTarget = $n($$x4).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x3, \u03b4, w$1)
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype.update__s_util_Either__s_Option__Ljapgolly_scalajs_react_callback_Trampoline = (function(source, target) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(p$2);
    var this$2 = $n($n(p).Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__f_images);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$4 = $n(this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$2.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var images = $as_sci_Seq(arg1);
    var arg1$1 = $m_Lreactbuild_analyze_cost_modules_project_ProjectImageList$().updatedList__sci_Seq__s_util_Either__s_Option__sci_List(images, source, target);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$2.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((x$7$2) => {
      $as_jl_Void(x$7$2)
    }));
    var this$7 = $n(this$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$7, f))
  })))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype.indexOf__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_callback_Trampoline = (function(image) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(p$2);
    var this$2 = $n($as_sc_SeqOps($n($n(p).Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__f_images).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
    return this$2.indexOf__O__I__I(image, 0)
  }));
  var this$4 = $n(this$);
  return $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$4, f)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype.resetDrag__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(p$2);
    var this$3 = $n(this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(x$8$2);
      $n(x$8);
      var dragSource = $m_s_None$();
      var dragTarget = $m_s_None$();
      return new $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(dragSource, dragTarget)
    }));
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f = new $c_sjsr_AnonFunction1(((x$9$2) => {
      $as_jl_Void(x$9$2)
    }));
    var this$5 = $n(this$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$5, f))
  })))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype.render__Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x3 = $n(this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_reuseDragSource);
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_analyze_cost_modules_project_ProjectImageList$().Lreactbuild_analyze_cost_modules_project_ProjectImageList$__f_reusableImage;
  var $$x2 = $n($$x3).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$1.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
  var $$x1 = this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__f_reuseDragTarget;
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$1 = this$2.by_$eq$eq__F2();
  var context = new $c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext($$x2, $n($$x1).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$3.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$1)), new $c_sjsr_AnonFunction1(((image$2) => {
    var image = $as_Lreactbuild_common_model_Image(image$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.indexOf__Lreactbuild_common_model_Image__Ljapgolly_scalajs_react_callback_Trampoline(image))
  })), new $c_sjsr_AnonFunction2(((source$2, target$2) => {
    var source = $as_s_util_Either(source$2);
    var target = $as_s_Option(target$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.update__s_util_Either__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(source, target))
  })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.resetDrag__Ljapgolly_scalajs_react_callback_Trampoline()))));
  var images = $as_sci_Seq($n($n(p).Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__f_images).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var len = $n(images).length__I();
  $n(images).length__I();
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$11 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexRow;
  var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$11, s$1);
  var this$12 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$());
  var $$x5 = this$12.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("wrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $p_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend__loop$1__I__sci_Vector__I__Lreactbuild_analyze_cost_modules_project_ProjectImageContext__sci_Seq__sci_Vector(this, 0, ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()), len, context, images);
  var this$16 = $m_s_$less$colon$less$();
  var array = [$$x6, $$x5, $n($$x4).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$16.s_$less$colon$less$__f_singleton)];
  return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectImageList$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectImageList$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectImageList$Backend", {
  Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend() {
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend.prototype.render__Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var x1 = $n(s).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState__f_result;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(x1);
    var err = $as_T($n(x2).s_util_Left__f_value);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(err))];
    return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else if ((x1 instanceof $c_s_util_Right)) {
    var x3 = $as_s_util_Right(x1);
    var result = $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(x3).s_util_Right__f_value);
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$11 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
    var a = $n(p).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_width;
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$11.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$14 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
    var a$1 = $n(p).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height;
    var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var array$1 = [$$x2, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$14.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1), result];
    return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("svg", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  } else {
    throw new $c_s_MatchError(x1)
  }
});
function $as_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ui.GraphOverTime$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ui.GraphOverTime$TypedBackend;", depth))
}
function $ct_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__($thiz) {
  $thiz.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f$1 = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x1;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x1 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2));
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        $as_sci_List($n(x5).s_Some__f_value);
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($thiz.Lreactbuild_analyze_cost_ui_ItemDetailView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f = new $c_sjsr_AnonFunction1(((p$2) => {
          var p = $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps(p$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($n($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty))
        }));
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f);
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  $thiz.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__f_updateItem = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$1);
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend() {
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__f_updateItem = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend.prototype.render__Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var value = $n(s).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState;
  var ss = $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x2;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p2 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(p2);
        var v = $n(x3).s_Some__f_value;
        var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_ui_ItemDetailView$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
          var x$2 = $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(x$2$2);
          var this$3 = $n(x$2);
          var x$2$2$1 = this$3.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_selected;
          $n(x$2);
          return new $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(x$2$2$1, v)
        })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p4)) {
        var $$x2 = cb$2;
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  })));
  var items = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$().apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__f_updateItem, $n($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler).getItemList__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List(p, ss), $m_Ljapgolly_scalajs_react_Reusability$().byIterator__F2__F2($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_reusability));
  var head = $n($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler).getMasterView__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomNode(items, p, ss);
  var x1$2 = $n($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler).getDetailsView__sci_List__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_Seq($as_sci_List($n(items).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), p, ss);
  matchEnd4: {
    var details;
    if ((x1$2 !== null)) {
      var o7 = $n($m_s_package$().s_package$__f_$plus$colon).unapply__sc_SeqOps__s_Option(x1$2);
      if ((!$n(o7).isEmpty__Z())) {
        var head$2 = $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($as_T2($n(o7).get__O()))._1__O());
        var tail = $as_sci_Seq($n($as_T2($n(o7).get__O()))._2__O());
        var $$x12 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
        var this$6 = $n($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_active);
        if (this$6.isEmpty__Z()) {
          var a = "no"
        } else {
          var arg1 = this$6.get__O();
          var x$3 = $as_Lreactbuild_common_model_RefTo(arg1);
          var a = $n($n(x$3).Lreactbuild_common_model_RefTo__f_id).toString__T()
        };
        var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var this$12 = $n($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_active);
        if (this$12.isEmpty__Z()) {
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("?")
        } else {
          var arg1$1 = this$12.get__O();
          var x$4 = $as_Lreactbuild_common_model_RefTo(arg1$1);
          var $$x8 = $n($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler).getTitleOf__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_vdom_TagMod(x$4, p)
        };
        var array = [$as_Ljapgolly_scalajs_react_vdom_TagMod($$x8)];
        var $$x7 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
        var $$x6 = $m_Lreactbuild_analyze_cost_components_Toolbar$();
        var $$x5 = $m_Lreactbuild_analyze_cost_components_Tabs$();
        var $$x4 = $n($n(p).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler).getTabList__sci_Seq();
        var this$19 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var ms = $m_sci_Nil$();
        var $$x3 = this$19.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms);
        var this$21 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
        var ms$1 = $m_sci_Nil$();
        var array$1 = [$$x7, $n($$x6).apply__Ljapgolly_scalajs_react_vdom_VdomNode__Z__Ljapgolly_scalajs_react_vdom_TagOf($n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__F1__Ljapgolly_scalajs_react_vdom_TagOf($$x4, $$x3, this$21.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1), new $c_sjsr_AnonFunction1(((x$5$2) => {
          var x$5 = $as_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase(x$5$2);
          var this$22 = $n(x$5);
          var x$1 = $objectGetClass(this$22);
          var this$23 = $n($n(s).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState);
          var x$2$1 = $objectGetClass(this$23);
          return (x$1 === x$2$1)
        })), new $c_sjsr_AnonFunction1(((item$2) => {
          var item = $as_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase(item$2);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var v$1 = $n(item).title__T();
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var $$x11 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
          var $$x10 = $m_Lcom_iz2use_react_components_Link$();
          var this$28 = $n(this.Lreactbuild_analyze_cost_ui_ItemDetailView$Backend__f_$);
          var mod = new $c_sjsr_AnonFunction1(((x$6$2) => {
            var x$6 = $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(x$6$2);
            var this$26 = $n(x$6);
            var x$4$1 = this$26.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_selected;
            $n(x$6);
            return new $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(x$4$1, item)
          }));
          return new $c_Lreactbuild_analyze_cost_components_Tab($$x11, $n($$x10).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$28, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
        }))), false), head$2];
        var rassoc$2 = $n($$x12).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
        var this$32 = $n(tail);
        var details = $as_sci_Seq(this$32.prepended__O__O(rassoc$2));
        break matchEnd4
      }
    };
    var details = x1$2
  };
  var $$x13 = $m_Lcom_iz2use_react_components_LinkedViews$();
  var this$33 = $n(details);
  var u = $n($$x13).apply__sci_Seq__s_PartialFunction__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($as_sci_Seq(this$33.prepended__O__O(head)), new $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11(this, p, p, ss, s));
  var this$35 = $n(u);
  var n = this$35.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
function $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ui.ItemDetailView$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ui.ItemDetailView$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_Admin$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_views_Admin$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_views_Admin$Backend__f_cdReuse = null;
  this.Lreactbuild_analyze_cost_views_Admin$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_views_Admin$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_views_Admin$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f$1 = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x1;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x1 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $as_Lreactbuild_common_model_AssetDefinition($n(x5).s_Some__f_value);
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_views_Admin$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var f = new $c_sjsr_AnonFunction1(((p$2) => {
          var p = $as_Lreactbuild_analyze_cost_views_Admin$Props(p$2);
          var this$20 = $n($n(p).Lreactbuild_analyze_cost_views_Admin$Props__f_definitions);
          var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
            var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var $$x4 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
            var $$x3 = $m_s_package$().s_package$__f_Seq;
            var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistInLibrary"];
            var $$x2 = $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
            var this$13 = $n($m_s_Predef$().s_Predef$__f_Map);
            var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
            var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
            var evidence$2 = $m_Lreactbuild_common_model_AssetDefinition$().Lreactbuild_common_model_AssetDefinition$__f_codecForAssetDefinition;
            var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(v, evidence$2);
            var array$1 = [$ct_T2__O__O__(new $c_T2(), "definition", y)];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
            return $n($n($n($$x4).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x2, this$13.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
              var x$1 = $as_Lio_circe_Json(x$1$2);
              var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
              var this$15 = $n(new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self);
              var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
              this$15.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1)
            })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$3$2) => {
              $as_jl_Void(x$3$2);
              return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
            })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
          })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), cb$2))));
          var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
          var arg1 = this$20.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
          var lst = $as_sci_List(arg1);
          var this$21 = $n(lst);
          _return: {
            var i = 0;
            var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$21, 0, this$21);
            while (true) {
              var this$24 = $n(these);
              if ((!this$24.isEmpty__Z())) {
                var arg1$1 = $n(these).head__O();
                var x$2 = $as_Lreactbuild_common_model_AssetDefinition(arg1$1);
                var x$4 = $n(x$2).Lreactbuild_common_model_AssetDefinition__f__id;
                var x$3$1 = $n(v).Lreactbuild_common_model_AssetDefinition__f__id;
                if (((x$4 === null) ? (x$3$1 === null) : $n(x$4).equals__O__Z(x$3$1))) {
                  var x1$2 = i;
                  break _return
                };
                i = ((1 + i) | 0);
                these = $as_sc_LinearSeq($n(these).tail__O())
              } else {
                break
              }
            };
            var x1$2 = (-1)
          };
          if ((x1$2 === (-1))) {
            var this$25 = $n(lst);
            var arg1$2 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$25, v))
          } else {
            var this$29 = $n(lst);
            var $$x5 = $n($m_s_package$().s_package$__f_Seq);
            var array$2 = [v];
            var other = $n($$x5).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
            var arg1$2 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$29, x1$2, other, 1))
          };
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$20.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$2), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        }));
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f);
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  this.Lreactbuild_analyze_cost_views_Admin$Backend__f_cdReuse = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$1)
}
$c_Lreactbuild_analyze_cost_views_Admin$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_Admin$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_views_Admin$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_Admin$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_Admin$Backend.prototype = $c_Lreactbuild_analyze_cost_views_Admin$Backend.prototype;
$c_Lreactbuild_analyze_cost_views_Admin$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_views_Admin$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_views_Admin$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_views_Admin$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_views_Admin$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_views_Admin$Backend.prototype.renderItem__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagOf = (function(reuse) {
  var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x21 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key);
  var this$3 = $n($n($as_Lreactbuild_common_model_AssetDefinition($n(reuse).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_AssetDefinition__f__id);
  var $$x20 = $n($$x21).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($m_sr_ScalaRunTime$()._toString__s_Product__T(this$3), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Nom du composant");
  var this$12 = $n(reuse);
  var g = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_T(v$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lreactbuild_common_model_AssetDefinition(x$5$2);
      var this$8 = $n(x$5);
      var x$2 = this$8.Lreactbuild_common_model_AssetDefinition__f__id;
      var this$9 = $n(x$5);
      var x$3 = this$9.Lreactbuild_common_model_AssetDefinition__f_category;
      var this$10 = $n(x$5);
      var x$4 = this$10.Lreactbuild_common_model_AssetDefinition__f_details;
      $n(x$5);
      return new $c_Lreactbuild_common_model_AssetDefinition(x$2, v, x$3, x$4)
    }))
  }));
  var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$12.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1 = this$12.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$4$1 = $as_Lreactbuild_common_model_AssetDefinition(arg1);
  var state = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$12, $n(x$4$1).Lreactbuild_common_model_AssetDefinition__f_name, new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
    var ot = $as_s_Option(ot$2);
    var $$x18 = $n($as_F2($n(this$12.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$13 = $n(ot);
    return $n($$x18).apply__O__O__O((this$13.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$13.get__O()))), cb$2)
  })));
  var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$16 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$16);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv = $m_s_math_Equiv$String$();
  var array = [editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv)];
  var $$x17 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cat\u00e9gorie");
  var this$31 = $n(reuse);
  var g$2 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_T(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7 = $as_Lreactbuild_common_model_AssetDefinition(x$7$2);
      var this$27 = $n(x$7);
      var x$6 = this$27.Lreactbuild_common_model_AssetDefinition__f__id;
      var this$28 = $n(x$7);
      var x$7$2$1 = this$28.Lreactbuild_common_model_AssetDefinition__f_name;
      var this$29 = $n(x$7);
      var x$8 = this$29.Lreactbuild_common_model_AssetDefinition__f_details;
      $n(x$7);
      return new $c_Lreactbuild_common_model_AssetDefinition(x$6, x$7$2$1, v$3, x$8)
    }))
  }));
  var g$3 = new $c_sjsr_AnonFunction1(((x$1$2$1) => $n($as_F1(g$2.apply__O__O(x$1$2$1))).apply__O__O(this$31.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1$1 = this$31.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$6$1 = $as_Lreactbuild_common_model_AssetDefinition(arg1$1);
  var state$1 = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$31, $n(x$6$1).Lreactbuild_common_model_AssetDefinition__f_category, new $c_sjsr_AnonFunction2(((ot$2$1, cb$2$1) => {
    var ot$1 = $as_s_Option(ot$2$1);
    var $$x15 = $n($as_F2($n(this$31.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$32 = $n(ot$1);
    return $n($$x15).apply__O__O__O((this$32.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$3.apply__O__O(this$32.get__O()))), cb$2$1)
  })));
  var evDefault$1 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  var parser$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$35 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$35);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$1 = $m_s_math_Equiv$String$();
  var array$1 = [editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$1, explainError$1, equiv$1)];
  var $$x14 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var u$1 = $m_Lreactbuild_analyze_cost_components_DropArea$().apply__F1__F1__F1__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_sci_List(x0$1$2);
    matchEnd6: {
      var $$x1;
      if ((x0$1 instanceof $c_sci_$colon$colon)) {
        var x2 = $as_sci_$colon$colon(x0$1);
        var v$1 = $n(x2).sci_$colon$colon__f_head;
        var p3 = $n(x2).sci_$colon$colon__f_next;
        var x = $m_s_package$().s_package$__f_Nil;
        if (((x === null) ? (p3 === null) : $n(x).equals__O__Z(p3))) {
          $m_Lio_circe_Decoder$();
          var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
          var decodeB = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
          var decodeEither = new $c_Lio_circe_Decoder$$anon$52("left", "right", decodeA, decodeB);
          var withHeaders = new Headers();
          withHeaders.set("filename", $as_T(v$1.name));
          var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
            var $$x3 = $m_Lreactbuild_common_AjaxJson$();
            var a$3 = (() => {
              var outer = null;
              var v$4 = null;
              var withHeaders$1 = null;
              outer = this;
              v$4 = v$1;
              withHeaders$1 = withHeaders;
              var this$48 = {};
              var a = $m_Lorg_scalajs_dom_HttpMethod$().Lorg_scalajs_dom_HttpMethod$__f_POST;
              this$48.method = a;
              var a$1 = v$4;
              this$48.body = a$1;
              var a$2 = withHeaders$1;
              this$48.headers = a$2;
              return this$48
            })();
            var $$x2 = $m_Lreactbuild_common_AjaxJson$().fetch$default$3__F0();
            $m_Lio_circe_Decoder$();
            var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
            return $n($$x3).fetch__sjs_js_$bar__sjs_js_$bar__F0__Lio_circe_Decoder__s_concurrent_ExecutionContext__s_concurrent_Future("/api/file", a$3, $$x2, new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeEither), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
          })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
          break matchEnd6
        }
      };
      $m_s_Predef$().$qmark$qmark$qmark__E()
    };
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($$x1)
  })), new $c_sjsr_AnonFunction1(((submitFile$2) => {
    var submitFile = $as_Ljapgolly_scalajs_react_vdom_VdomNode(submitFile$2);
    var this$95 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var x1 = $n($as_Lreactbuild_common_model_AssetDefinition($n(reuse).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_AssetDefinition__f_details;
    if ((x1 instanceof $c_Lreactbuild_common_model_ComponentDetails)) {
      var x2$1 = $as_Lreactbuild_common_model_ComponentDetails(x1);
      var files3d = $n(x2$1).Lreactbuild_common_model_ComponentDetails__f_files3d;
      var this$79 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var this$78 = $n(files3d);
      var f = ((ref$2) => {
        var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var u = $m_Lreactbuild_analyze_cost_views_FilePreview$().apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(ref);
        var this$73 = $n(u);
        var n = this$73.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
        return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
      });
      if ((this$78 === $m_sci_Nil$())) {
        var ns = $m_sci_Nil$()
      } else {
        var arg1$2 = this$78.head__O();
        var h = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$78.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$3 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O())
        };
        var ns = h
      };
      var $$x5 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$79, null, ns)
    } else {
      var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$5 = ("Non pris en charge : " + x1);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
      var $$x5 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    };
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$4 = [submitFile];
    var array$5 = [$$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$95, null, ns$1)
  })), new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_s_util_Try(x0$2$2);
    if ((x0$2 instanceof $c_s_util_Success)) {
      var x2$2 = $as_s_util_Success(x0$2);
      var map = $as_sci_Map($n(x2$2).s_util_Success__f_value);
      var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$98 = $n(map);
      var v$6 = $f_sc_Iterable__toString__T(this$98);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$6)];
      return $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
    } else if ((x0$2 instanceof $c_s_util_Failure)) {
      var x3 = $as_s_util_Failure(x0$2);
      var t$1 = $n(x3).s_util_Failure__f_exception;
      var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$7 = $n(t$1).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$7 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)];
      return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
    } else {
      throw new $c_s_MatchError(x0$2)
    }
  })), new $c_sjsr_AnonFunction1(((map$2) => {
    var map$1 = $as_sci_Map(map$2);
    var $$x12 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x10 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
      var this$111 = $n(map$1);
      var this$112 = $n($f_sc_IterableOps__headOption__s_Option(this$111));
      if (this$112.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1$4 = this$112.get__O();
        var x$8$1 = $as_T2(arg1$4);
        return new $c_s_Some($as_s_util_Either($n(x$8$1)._2__O()))
      }
    }))), new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_s_util_Either(x0$3$2);
      if ((x0$3 instanceof $c_s_util_Right)) {
        var x2$3 = $as_s_util_Right(x0$3);
        var v$8 = $as_Lreactbuild_common_model_RefTo($n(x2$3).s_util_Right__f_value);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$113 = $n(reuse);
        var callback = new $c_sjsr_AnonFunction0((() => {
          var this$114 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var this$115 = $n(this$114.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$115.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
        }));
        var this$116 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var G = this$116.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
        var arg1$5 = this$113.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
        var x0$4 = $as_Lreactbuild_common_model_AssetDefinition(arg1$5);
        matchEnd7: {
          var arg1$6;
          if ((x0$4 !== null)) {
            var cd = $n(x0$4).Lreactbuild_common_model_AssetDefinition__f_details;
            if ((cd instanceof $c_Lreactbuild_common_model_ComponentDetails)) {
              var x5 = $as_Lreactbuild_common_model_ComponentDetails(cd);
              $n(x5);
              var this$117 = $n($n(x5).Lreactbuild_common_model_ComponentDetails__f_files3d);
              var files3d$1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$117, v$8));
              var this$118 = $n(x5);
              var files2d = this$118.Lreactbuild_common_model_ComponentDetails__f_files2d;
              var this$119 = $n(x5);
              var loader = this$119.Lreactbuild_common_model_ComponentDetails__f_loader;
              var x$9 = new $c_Lreactbuild_common_model_ComponentDetails(files3d$1, files2d, loader);
              var this$121 = $n(x0$4);
              var x$10 = this$121.Lreactbuild_common_model_AssetDefinition__f__id;
              var this$122 = $n(x0$4);
              var x$11 = this$122.Lreactbuild_common_model_AssetDefinition__f_name;
              var this$123 = $n(x0$4);
              var x$12 = this$123.Lreactbuild_common_model_AssetDefinition__f_category;
              $n(x0$4);
              var arg1$6 = new $c_Lreactbuild_common_model_AssetDefinition(x$10, x$11, x$12, x$9);
              break matchEnd7
            }
          };
          var arg1$6 = x0$4
        };
        var c = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$113.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$6), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var $$x11 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c)
      } else if ((x0$3 instanceof $c_s_util_Left)) {
        var x3$1 = $as_s_util_Left(x0$3);
        var v$2$1 = $as_T($n(x3$1).s_util_Left__f_value);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var c$1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).alert__T__Ljapgolly_scalajs_react_callback_Trampoline(("Impossible de traiter ce fichier : " + v$2$1));
        var $$x11 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1)
      } else {
        var $$x11;
        throw new $c_s_MatchError(x0$3)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($$x11)
    })));
    var this$127 = $m_s_$less$colon$less$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x12).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline($$x10, this$127.s_$less$colon$less$__f_singleton))
  })));
  var this$129 = $n(u$1);
  var n$1 = this$129.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$8 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  var array$9 = [$$x20, $$x17, $$x14, $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  return $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
});
$c_Lreactbuild_analyze_cost_views_Admin$Backend.prototype.render__Lreactbuild_analyze_cost_views_Admin$Props__Lreactbuild_analyze_cost_views_Admin$State__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var $$x20 = $m_Lreactbuild_analyze_cost_components_AutoScrollArea$();
  var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x16 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Composant"))];
  var $$x15 = $n($$x16).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x14 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cat\u00e9gorie"))];
  var $$x13 = $n($$x14).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Fichiers 3D"))];
  var $$x11 = $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Fichiers 2D"))];
  var array$4 = [$$x15, $$x13, $$x11, $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var array$5 = [$n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tr", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var $$x9 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("thead", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $as_sc_IterableOnce($n($n(p).Lreactbuild_analyze_cost_views_Admin$Props__f_definitions).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var $$x4 = $n($$x5).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((cd$2) => {
    var cd = $as_Lreactbuild_common_model_AssetDefinition(cd$2);
    var $$x7 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
    var $$x6 = this.Lreactbuild_analyze_cost_views_Admin$Backend__f_cdReuse;
    $m_Lreactbuild_model_Implicits$();
    var this$46 = $m_Ljapgolly_scalajs_react_Reusability$();
    return this.renderItem__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagOf($n($$x7).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($$x6, cd, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$46.byRef__F2(), this$46.by_$eq$eq__F2())))
  })));
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
  var $$x2 = this.Lreactbuild_analyze_cost_views_Admin$Backend__f_cdReuse;
  var x$3 = new $c_Lreactbuild_common_model_ComponentDetails(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_ComponentDetails), $m_s_package$().s_package$__f_Nil), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_ComponentDetails), $m_s_package$().s_package$__f_Nil), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_ComponentDetails), "OBJ"));
  $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_AssetDefinition);
  var x$4 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
  var $$x1 = new $c_Lreactbuild_common_model_AssetDefinition(x$4, "", "", x$3);
  $m_Lreactbuild_model_Implicits$();
  var this$52 = $m_Ljapgolly_scalajs_react_Reusability$();
  var array$6 = [$$x4, this.renderItem__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagOf($n($$x3).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($$x2, $$x1, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$52.byRef__F2(), this$52.by_$eq$eq__F2())))];
  var array$7 = [$$x9, $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("tbody", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
  var array$8 = [$n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("table", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  var u = $n($$x20).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
  var this$63 = $n(u);
  var n = this$63.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
function $as_Lreactbuild_analyze_cost_views_Admin$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_Admin$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.Admin$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_Admin$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_Admin$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_Admin$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_Admin$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.Admin$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_views_Admin$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_Admin$Backend: 0
}, false, "reactbuild.analyze.cost.views.Admin$Backend", {
  Lreactbuild_analyze_cost_views_Admin$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_views_Admin$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_views_Admin$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_FilePreview$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_views_FilePreview$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_views_FilePreview$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_views_FilePreview$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_FilePreview$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_views_FilePreview$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_FilePreview$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_FilePreview$Backend.prototype = $c_Lreactbuild_analyze_cost_views_FilePreview$Backend.prototype;
$c_Lreactbuild_analyze_cost_views_FilePreview$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_views_FilePreview$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_views_FilePreview$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_views_FilePreview$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_views_FilePreview$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_views_FilePreview$Backend.prototype.render__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_views_FilePreview$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$3 = $n(p);
  var v = $m_sr_ScalaRunTime$()._toString__s_Product__T(this$3);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
function $as_Lreactbuild_analyze_cost_views_FilePreview$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_FilePreview$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.FilePreview$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_FilePreview$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_FilePreview$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_FilePreview$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_FilePreview$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.FilePreview$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_views_FilePreview$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_FilePreview$Backend: 0
}, false, "reactbuild.analyze.cost.views.FilePreview$Backend", {
  Lreactbuild_analyze_cost_views_FilePreview$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_views_FilePreview$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_views_FilePreview$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_Inbox$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_views_Inbox$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_views_Inbox$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_views_Inbox$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_Inbox$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_views_Inbox$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_Inbox$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_Inbox$Backend.prototype = $c_Lreactbuild_analyze_cost_views_Inbox$Backend.prototype;
$c_Lreactbuild_analyze_cost_views_Inbox$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_views_Inbox$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_views_Inbox$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_views_Inbox$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_views_Inbox$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_views_Inbox$Backend.prototype.render__Lreactbuild_analyze_cost_views_Inbox$Props__jl_Void__Ljapgolly_scalajs_react_vdom_VdomElement = (function(p, s) {
  var $$x100 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
  var $$x96 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x99 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x98 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "getPendingTasks"];
    var $$x97 = $as_sci_Seq($n($$x98).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$6 = $n($m_s_Predef$().s_Predef$__f_Map);
    var elems = $m_sci_Nil$();
    return $n($n($$x99).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x97, this$6.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$9 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_model_Task$().Lreactbuild_model_Task$__f_codecForTask;
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$9.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  }));
  var $$x2 = new $c_sjsr_AnonFunction1(((tasks$2) => {
    var tasks = $as_Ldiode_data_Pot(tasks$2);
    var router = $n(p).Lreactbuild_analyze_cost_views_Inbox$Props__f_router;
    var proxy = $n(p).Lreactbuild_analyze_cost_views_Inbox$Props__f_proxy;
    var $$x95 = $m_Lcom_iz2use_react_components_Multiview$();
    var $$x94 = new $c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler();
    var this$11 = $m_s_Symbol$();
    var $$x92 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$11, "_id"));
    var this$12 = $m_s_Symbol$();
    var $$x91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "organization"));
    var this$13 = $m_s_Symbol$();
    var $$x90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "persons"));
    var this$14 = $m_s_Symbol$();
    var $$x89 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$14, "subject"));
    var this$15 = $m_s_Symbol$();
    var $$x88 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "attachments"));
    var this$16 = $m_s_Symbol$();
    var $$x87 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "created"));
    var this$17 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x92, new $c_Lshapeless_$colon$colon($$x91, new $c_Lshapeless_$colon$colon($$x90, new $c_Lshapeless_$colon$colon($$x89, new $c_Lshapeless_$colon$colon($$x88, new $c_Lshapeless_$colon$colon($$x87, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$17, "done")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_model_Task(x0$3$2);
      if ((x0$3 !== null)) {
        var _id$macro$22 = $n(x0$3).Lreactbuild_model_Task__f__id;
        var organization$macro$23 = $n(x0$3).Lreactbuild_model_Task__f_organization;
        var persons$macro$24 = $n(x0$3).Lreactbuild_model_Task__f_persons;
        var subject$macro$25 = $n(x0$3).Lreactbuild_model_Task__f_subject;
        var attachments$macro$26 = $n(x0$3).Lreactbuild_model_Task__f_attachments;
        var created$macro$27 = $n(x0$3).Lreactbuild_model_Task__f_created;
        var done$macro$28 = $n(x0$3).Lreactbuild_model_Task__f_done;
        return new $c_Lshapeless_$colon$colon(_id$macro$22, new $c_Lshapeless_$colon$colon(organization$macro$23, new $c_Lshapeless_$colon$colon(persons$macro$24, new $c_Lshapeless_$colon$colon(new $c_Lcom_iz2use_common_Multiline(subject$macro$25), new $c_Lshapeless_$colon$colon(attachments$macro$26, new $c_Lshapeless_$colon$colon(created$macro$27, new $c_Lshapeless_$colon$colon(done$macro$28, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var _id$macro$15 = $as_Lreactbuild_common_model_RefTo($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var organization$macro$16 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var persons$macro$17 = $as_sci_Seq($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var subject$macro$18 = $n($as_Lcom_iz2use_common_Multiline($n(p4).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var attachments$macro$19 = $as_sci_Seq($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var created$macro$20 = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var done$macro$21 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p8)) {
                      return new $c_Lreactbuild_model_Task(_id$macro$15, organization$macro$16, persons$macro$17, subject$macro$18, attachments$macro$19, created$macro$20, done$macro$21)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$20 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "done"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$23 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$26 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "attachments"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$29 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "subject"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$32 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "persons"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$35 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$38 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    var this$41 = $m_s_$less$colon$less$();
    var ev = this$41.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "done"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
    var tailToMap = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk);
    var keyLub = new $c_Lshapeless_Lub$$anon$4();
    var valueLub = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$48 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$48, "created"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
    var tailToMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap, keyLub, valueLub, wk$1);
    var keyLub$1 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$1 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$53 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "attachments"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
    var tailToMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$2);
    var keyLub$2 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$2 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$58 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "subject"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
    var tailToMap$3 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$2, keyLub$2, valueLub$2, wk$3);
    var keyLub$3 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$3 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "persons"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var tailToMap$4 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$3, keyLub$3, valueLub$3, wk$4);
    var keyLub$4 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$4 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$68 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "organization"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    var tailToMap$5 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$4, keyLub$4, valueLub$4, wk$5);
    var keyLub$5 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$5 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$73 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "_id"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var toMap = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$5, keyLub$5, valueLub$5, wk$6);
    $m_Lshapeless_Witness$();
    var this$76 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "_id"));
    var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    var tv$6 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
    $m_Lshapeless_Witness$();
    var this$78 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "organization"));
    var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    var tv$5 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
    $m_Lshapeless_Witness$();
    var this$80 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "persons"));
    var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    var tv$4 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_TaskPerson.getClassOf(), new $c_sjsr_AnonFunction0((() => "TaskPerson"))));
    $m_Lshapeless_Witness$();
    var this$83 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "subject"));
    var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    var tv$3 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lcom_iz2use_common_Multiline.getClassOf(), new $c_sjsr_AnonFunction0((() => "Multiline")));
    $m_Lshapeless_Witness$();
    var this$85 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "attachments"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    var tv$2 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_TaskAttachment.getClassOf(), new $c_sjsr_AnonFunction0((() => "TaskAttachment"))));
    $m_Lshapeless_Witness$();
    var this$88 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "created"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    var tv$1 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_Instant.getClassOf(), new $c_sjsr_AnonFunction0((() => "Instant")));
    $m_Lshapeless_Witness$();
    var this$90 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "done"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    var tv = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_Instant.getClassOf(), new $c_sjsr_AnonFunction0((() => "Instant"))));
    var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
    var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$7, tv, fmt);
    var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$8, tv$1, fmt$1);
    var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$9, tv$2, fmt$2);
    var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$10, tv$3, fmt$3);
    var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$11, tv$4, fmt$4);
    var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$12, tv$5, fmt$5);
    var fromMap = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$13, tv$6, fmt$6);
    var $$x93 = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap, gen$1, fromMap);
    $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$();
    var this$254 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$253 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$252 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$251 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$101 = $m_s_Symbol$();
    var $$x47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$101, "_id"));
    var this$102 = $m_s_Symbol$();
    var $$x46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$102, "organization"));
    var this$103 = $m_s_Symbol$();
    var $$x45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$103, "persons"));
    var this$104 = $m_s_Symbol$();
    var $$x44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$104, "subject"));
    var this$105 = $m_s_Symbol$();
    var $$x43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$105, "attachments"));
    var this$106 = $m_s_Symbol$();
    var $$x42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$106, "created"));
    var this$107 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x47, new $c_Lshapeless_$colon$colon($$x46, new $c_Lshapeless_$colon$colon($$x45, new $c_Lshapeless_$colon$colon($$x44, new $c_Lshapeless_$colon$colon($$x43, new $c_Lshapeless_$colon$colon($$x42, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$107, "done")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var f$1 = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_Task(x0$7$2);
      if ((x0$7 !== null)) {
        var _id$macro$50 = $n(x0$7).Lreactbuild_model_Task__f__id;
        var organization$macro$51 = $n(x0$7).Lreactbuild_model_Task__f_organization;
        var persons$macro$52 = $n(x0$7).Lreactbuild_model_Task__f_persons;
        var subject$macro$53 = $n(x0$7).Lreactbuild_model_Task__f_subject;
        var attachments$macro$54 = $n(x0$7).Lreactbuild_model_Task__f_attachments;
        var created$macro$55 = $n(x0$7).Lreactbuild_model_Task__f_created;
        var done$macro$56 = $n(x0$7).Lreactbuild_model_Task__f_done;
        return new $c_Lshapeless_$colon$colon(_id$macro$50, new $c_Lshapeless_$colon$colon(organization$macro$51, new $c_Lshapeless_$colon$colon(persons$macro$52, new $c_Lshapeless_$colon$colon(new $c_Lcom_iz2use_common_Multiline(subject$macro$53), new $c_Lshapeless_$colon$colon(attachments$macro$54, new $c_Lshapeless_$colon$colon(created$macro$55, new $c_Lshapeless_$colon$colon(done$macro$56, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g$1 = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var _id$macro$43 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2$1 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2$1 !== null)) {
          var organization$macro$44 = $as_Lreactbuild_common_model_RefTo($n(p2$1).Lshapeless_$colon$colon__f_head);
          var p3$1 = $as_Lshapeless_$colon$colon($n(p2$1).Lshapeless_$colon$colon__f_tail);
          if ((p3$1 !== null)) {
            var persons$macro$45 = $as_sci_Seq($n(p3$1).Lshapeless_$colon$colon__f_head);
            var p4$1 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
            if ((p4$1 !== null)) {
              var subject$macro$46 = $n($as_Lcom_iz2use_common_Multiline($n(p4$1).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
              var p5$1 = $as_Lshapeless_$colon$colon($n(p4$1).Lshapeless_$colon$colon__f_tail);
              if ((p5$1 !== null)) {
                var attachments$macro$47 = $as_sci_Seq($n(p5$1).Lshapeless_$colon$colon__f_head);
                var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
                if ((p6$1 !== null)) {
                  var created$macro$48 = $as_Ljava_time_Instant($n(p6$1).Lshapeless_$colon$colon__f_head);
                  var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                  if ((p7$1 !== null)) {
                    var done$macro$49 = $as_s_Option($n(p7$1).Lshapeless_$colon$colon__f_head);
                    var p8$1 = $as_Lshapeless_HNil($n(p7$1).Lshapeless_$colon$colon__f_tail);
                    var x$2 = $m_Lshapeless_HNil$();
                    if ((x$2 === p8$1)) {
                      return new $c_Lreactbuild_model_Task(_id$macro$43, organization$macro$44, persons$macro$45, subject$macro$46, attachments$macro$47, created$macro$48, done$macro$49)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$7 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$110 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$110, "done"));
    new $c_Lshapeless_Witness$$anon$1(value0$21);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$113 = $m_s_Symbol$();
    var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$113, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$22);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$116 = $m_s_Symbol$();
    var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$116, "attachments"));
    new $c_Lshapeless_Witness$$anon$1(value0$23);
    var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    $m_Lshapeless_Witness$();
    var this$119 = $m_s_Symbol$();
    var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$119, "subject"));
    new $c_Lshapeless_Witness$$anon$1(value0$24);
    var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    $m_Lshapeless_Witness$();
    var this$122 = $m_s_Symbol$();
    var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$122, "persons"));
    new $c_Lshapeless_Witness$$anon$1(value0$25);
    var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
    $m_Lshapeless_Witness$();
    var this$125 = $m_s_Symbol$();
    var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$125, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$26);
    var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
    $m_Lshapeless_Witness$();
    var this$128 = $m_s_Symbol$();
    var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$128, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$27);
    var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
    var this$131 = $m_s_$less$colon$less$();
    var ev$1 = this$131.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$1);
    var this$169 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Task", "reactbuild.model.RefTo[reactbuild.model.Task]");
    var this$168 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$133 = $m_s_Symbol$();
    var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$133, "organization"));
    var witness$3 = new $c_Lshapeless_Witness$$anon$1(value0$28);
    var $$x51 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var this$135 = $m_Lreactbuild_model_Implicits$();
    var format = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$135);
    var $$x50 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format);
    var this$138 = $m_Lreactbuild_model_Implicits$();
    var this$137 = $m_Lreactbuild_model_Implicits$();
    var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$137, proxy);
    var $$x49 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$138, ev$2)));
    var $$x48 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$140 = $m_Lreactbuild_model_Implicits$();
    var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$140, proxy);
    var fieldRenderable$3 = $n($$x51).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x50, $$x49, $$x48, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$167 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Task", "Seq[reactbuild.model.TaskPerson]");
    var this$166 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$142 = $m_s_Symbol$();
    var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$142, "subject"));
    var witness$2 = new $c_Lshapeless_Witness$$anon$1(value0$29);
    var $$x55 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$1 = $m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_formatMultiline;
    var $$x54 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$1);
    var $$x53 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_orderingMultiline));
    var $$x52 = new $c_Lcom_iz2use_react_components_NotEditable();
    var textualizable$1 = $m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_parsableMultiline;
    var fieldRenderable$2 = $n($$x55).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x54, $$x53, $$x52, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$1), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_parsableMultiline)));
    var this$165 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Task", "Seq[reactbuild.model.TaskAttachment]");
    var this$164 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$147 = $m_s_Symbol$();
    var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$147, "created"));
    var witness$1 = new $c_Lshapeless_Witness$$anon$1(value0$30);
    var $$x59 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$2 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
    var $$x58 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$2);
    var $$x57 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering));
    var $$x56 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$151 = $m_Lreactbuild_model_Implicits$();
    var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$2 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$151, locale);
    var fieldRenderable$1 = $n($$x59).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x58, $$x57, $$x56, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$2), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$163 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$153 = $m_s_Symbol$();
    var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$153, "done"));
    var witness = new $c_Lshapeless_Witness$$anon$1(value0$31);
    var $$x63 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$3 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
    var format$4 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$3);
    var $$x62 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$4);
    var ord = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
    var $$x61 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord)));
    var $$x60 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$159 = $m_Lreactbuild_model_Implicits$();
    var locale$1 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$3 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$159, locale$1);
    var textualizable$4 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$3);
    var fieldRenderable = $n($$x63).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x62, $$x61, $$x60, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$4), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var tail = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4();
    var tail$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$163, fieldRenderable, witness, tail);
    var tail$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$164, fieldRenderable$1, witness$1, tail$1);
    var tail$3 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$165, tail$2);
    var tail$4 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$166, fieldRenderable$2, witness$2, tail$3);
    var tail$5 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$167, tail$4);
    var tail$6 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$168, fieldRenderable$3, witness$3, tail$5);
    var renderer = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$169, tail$6);
    $m_s_DummyImplicit$();
    new $c_Lshapeless_Refute$$anon$2();
    var view$2 = new $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1(renderer);
    var this$249 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    $m_Lreactbuild_analyze_cost_views_Inbox$();
    var renderItem = new $c_Lreactbuild_analyze_cost_views_Inbox$$anon$1(router, proxy);
    var view$1 = new $c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1(renderItem);
    var this$174 = $m_s_Symbol$();
    var $$x69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$174, "_id"));
    var this$175 = $m_s_Symbol$();
    var $$x68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$175, "organization"));
    var this$176 = $m_s_Symbol$();
    var $$x67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$176, "persons"));
    var this$177 = $m_s_Symbol$();
    var $$x66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$177, "subject"));
    var this$178 = $m_s_Symbol$();
    var $$x65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$178, "attachments"));
    var this$179 = $m_s_Symbol$();
    var $$x64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$179, "created"));
    var this$180 = $m_s_Symbol$();
    var labels$2 = new $c_Lshapeless_$colon$colon($$x69, new $c_Lshapeless_$colon$colon($$x68, new $c_Lshapeless_$colon$colon($$x67, new $c_Lshapeless_$colon$colon($$x66, new $c_Lshapeless_$colon$colon($$x65, new $c_Lshapeless_$colon$colon($$x64, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$180, "done")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
    var f$2 = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_model_Task(x0$11$2);
      if ((x0$11 !== null)) {
        var _id$macro$78 = $n(x0$11).Lreactbuild_model_Task__f__id;
        var organization$macro$79 = $n(x0$11).Lreactbuild_model_Task__f_organization;
        var persons$macro$80 = $n(x0$11).Lreactbuild_model_Task__f_persons;
        var subject$macro$81 = $n(x0$11).Lreactbuild_model_Task__f_subject;
        var attachments$macro$82 = $n(x0$11).Lreactbuild_model_Task__f_attachments;
        var created$macro$83 = $n(x0$11).Lreactbuild_model_Task__f_created;
        var done$macro$84 = $n(x0$11).Lreactbuild_model_Task__f_done;
        return new $c_Lshapeless_$colon$colon(_id$macro$78, new $c_Lshapeless_$colon$colon(organization$macro$79, new $c_Lshapeless_$colon$colon(persons$macro$80, new $c_Lshapeless_$colon$colon(new $c_Lcom_iz2use_common_Multiline(subject$macro$81), new $c_Lshapeless_$colon$colon(attachments$macro$82, new $c_Lshapeless_$colon$colon(created$macro$83, new $c_Lshapeless_$colon$colon(done$macro$84, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g$2 = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
      if ((x0$12 !== null)) {
        var _id$macro$71 = $as_Lreactbuild_common_model_RefTo($n(x0$12).Lshapeless_$colon$colon__f_head);
        var p2$2 = $as_Lshapeless_$colon$colon($n(x0$12).Lshapeless_$colon$colon__f_tail);
        if ((p2$2 !== null)) {
          var organization$macro$72 = $as_Lreactbuild_common_model_RefTo($n(p2$2).Lshapeless_$colon$colon__f_head);
          var p3$2 = $as_Lshapeless_$colon$colon($n(p2$2).Lshapeless_$colon$colon__f_tail);
          if ((p3$2 !== null)) {
            var persons$macro$73 = $as_sci_Seq($n(p3$2).Lshapeless_$colon$colon__f_head);
            var p4$2 = $as_Lshapeless_$colon$colon($n(p3$2).Lshapeless_$colon$colon__f_tail);
            if ((p4$2 !== null)) {
              var subject$macro$74 = $n($as_Lcom_iz2use_common_Multiline($n(p4$2).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
              var p5$2 = $as_Lshapeless_$colon$colon($n(p4$2).Lshapeless_$colon$colon__f_tail);
              if ((p5$2 !== null)) {
                var attachments$macro$75 = $as_sci_Seq($n(p5$2).Lshapeless_$colon$colon__f_head);
                var p6$2 = $as_Lshapeless_$colon$colon($n(p5$2).Lshapeless_$colon$colon__f_tail);
                if ((p6$2 !== null)) {
                  var created$macro$76 = $as_Ljava_time_Instant($n(p6$2).Lshapeless_$colon$colon__f_head);
                  var p7$2 = $as_Lshapeless_$colon$colon($n(p6$2).Lshapeless_$colon$colon__f_tail);
                  if ((p7$2 !== null)) {
                    var done$macro$77 = $as_s_Option($n(p7$2).Lshapeless_$colon$colon__f_head);
                    var p8$2 = $as_Lshapeless_HNil($n(p7$2).Lshapeless_$colon$colon__f_tail);
                    var x$3 = $m_Lshapeless_HNil$();
                    if ((x$3 === p8$2)) {
                      return new $c_Lreactbuild_model_Task(_id$macro$71, organization$macro$72, persons$macro$73, subject$macro$74, attachments$macro$75, created$macro$76, done$macro$77)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$12)
    }));
    var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$14 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$183 = $m_s_Symbol$();
    var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$183, "done"));
    new $c_Lshapeless_Witness$$anon$1(value0$32);
    var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
    $m_Lshapeless_Witness$();
    var this$186 = $m_s_Symbol$();
    var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$186, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$33);
    var zipWithKeys$16 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
    $m_Lshapeless_Witness$();
    var this$189 = $m_s_Symbol$();
    var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$189, "attachments"));
    new $c_Lshapeless_Witness$$anon$1(value0$34);
    var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
    $m_Lshapeless_Witness$();
    var this$192 = $m_s_Symbol$();
    var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$192, "subject"));
    new $c_Lshapeless_Witness$$anon$1(value0$35);
    var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
    $m_Lshapeless_Witness$();
    var this$195 = $m_s_Symbol$();
    var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$195, "persons"));
    new $c_Lshapeless_Witness$$anon$1(value0$36);
    var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
    $m_Lshapeless_Witness$();
    var this$198 = $m_s_Symbol$();
    var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$198, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$37);
    var zipWithKeys$20 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
    $m_Lshapeless_Witness$();
    var this$201 = $m_s_Symbol$();
    var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$201, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$38);
    var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
    var this$204 = $m_s_$less$colon$less$();
    var ev$3 = this$204.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$3);
    var this$242 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Task", "reactbuild.model.RefTo[reactbuild.model.Task]");
    var this$241 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$206 = $m_s_Symbol$();
    var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$206, "organization"));
    var witness$7 = new $c_Lshapeless_Witness$$anon$1(value0$39);
    var $$x73 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    var this$208 = $m_Lreactbuild_model_Implicits$();
    var format$5 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$208);
    var $$x72 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$5);
    var this$211 = $m_Lreactbuild_model_Implicits$();
    var this$210 = $m_Lreactbuild_model_Implicits$();
    var ev$4 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$210, proxy);
    var $$x71 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$211, ev$4)));
    var $$x70 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$213 = $m_Lreactbuild_model_Implicits$();
    var textualizable$5 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$213, proxy);
    var columnRenderable$3 = $n($$x73).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x72, $$x71, $$x70, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$5));
    var this$240 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Task", "Seq[reactbuild.model.TaskPerson]");
    var this$239 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$215 = $m_s_Symbol$();
    var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$215, "subject"));
    var witness$6 = new $c_Lshapeless_Witness$$anon$1(value0$40);
    var $$x77 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    var format$6 = $m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_formatMultiline;
    var $$x76 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$6);
    var $$x75 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_orderingMultiline));
    var $$x74 = new $c_Lcom_iz2use_react_components_NotEditable();
    var textualizable$6 = $m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_parsableMultiline;
    var columnRenderable$2 = $n($$x77).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x76, $$x75, $$x74, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$6));
    var this$238 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Task", "Seq[reactbuild.model.TaskAttachment]");
    var this$237 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$220 = $m_s_Symbol$();
    var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$220, "created"));
    var witness$5 = new $c_Lshapeless_Witness$$anon$1(value0$41);
    var $$x81 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    var format$7 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
    var $$x80 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$7);
    var $$x79 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering));
    var $$x78 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$224 = $m_Lreactbuild_model_Implicits$();
    var locale$2 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$7 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$224, locale$2);
    var columnRenderable$1 = $n($$x81).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x80, $$x79, $$x78, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$7));
    var this$236 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$226 = $m_s_Symbol$();
    var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$226, "done"));
    var witness$4 = new $c_Lshapeless_Witness$$anon$1(value0$42);
    var $$x85 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$8 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
    var format$9 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$8);
    var $$x84 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$9);
    var ord$1 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
    var $$x83 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$1)));
    var $$x82 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$232 = $m_Lreactbuild_model_Implicits$();
    var locale$3 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$8 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$232, locale$3);
    var textualizable$9 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$8);
    var columnRenderable = $n($$x85).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x84, $$x83, $$x82, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$9));
    var tail$7 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
    var tail$8 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$236, columnRenderable, witness$4, tail$7);
    var tail$9 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$237, columnRenderable$1, witness$5, tail$8);
    var tail$10 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$238, tail$9);
    var tail$11 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$239, columnRenderable$2, witness$6, tail$10);
    var tail$12 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$240, tail$11);
    var tail$13 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$241, columnRenderable$3, witness$7, tail$12);
    var renderer$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$242, tail$13);
    $m_s_DummyImplicit$();
    new $c_Lshapeless_Refute$$anon$2();
    var columnFragment = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$1);
    var view = new $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment);
    var tail$14 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2();
    var tail$15 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view, tail$14);
    var tail$16 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$1, tail$15);
    var tail$17 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$249, tail$16);
    var tail$18 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$2, tail$17);
    var tail$19 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$251, tail$18);
    var tail$20 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$252, tail$19);
    var tail$21 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$253, tail$20);
    var mat = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$254, tail$21);
    $m_s_DummyImplicit$();
    new $c_Lshapeless_Refute$$anon$2();
    var $$x86 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViews(mat.apply__sci_List());
    var $$x41 = $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$().Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable;
    var this$257 = $m_s_Symbol$();
    var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$257, "_id"));
    var this$258 = $m_s_Symbol$();
    var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$258, "organization"));
    var this$259 = $m_s_Symbol$();
    var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$259, "persons"));
    var this$260 = $m_s_Symbol$();
    var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$260, "subject"));
    var this$261 = $m_s_Symbol$();
    var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$261, "attachments"));
    var this$262 = $m_s_Symbol$();
    var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$262, "created"));
    var this$263 = $m_s_Symbol$();
    var labels$3 = new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$263, "done")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
    var f$3 = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_Task(x0$15$2);
      if ((x0$15 !== null)) {
        var _id$macro$106 = $n(x0$15).Lreactbuild_model_Task__f__id;
        var organization$macro$107 = $n(x0$15).Lreactbuild_model_Task__f_organization;
        var persons$macro$108 = $n(x0$15).Lreactbuild_model_Task__f_persons;
        var subject$macro$109 = $n(x0$15).Lreactbuild_model_Task__f_subject;
        var attachments$macro$110 = $n(x0$15).Lreactbuild_model_Task__f_attachments;
        var created$macro$111 = $n(x0$15).Lreactbuild_model_Task__f_created;
        var done$macro$112 = $n(x0$15).Lreactbuild_model_Task__f_done;
        return new $c_Lshapeless_$colon$colon(_id$macro$106, new $c_Lshapeless_$colon$colon(organization$macro$107, new $c_Lshapeless_$colon$colon(persons$macro$108, new $c_Lshapeless_$colon$colon(new $c_Lcom_iz2use_common_Multiline(subject$macro$109), new $c_Lshapeless_$colon$colon(attachments$macro$110, new $c_Lshapeless_$colon$colon(created$macro$111, new $c_Lshapeless_$colon$colon(done$macro$112, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g$3 = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var _id$macro$99 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2$3 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2$3 !== null)) {
          var organization$macro$100 = $as_Lreactbuild_common_model_RefTo($n(p2$3).Lshapeless_$colon$colon__f_head);
          var p3$3 = $as_Lshapeless_$colon$colon($n(p2$3).Lshapeless_$colon$colon__f_tail);
          if ((p3$3 !== null)) {
            var persons$macro$101 = $as_sci_Seq($n(p3$3).Lshapeless_$colon$colon__f_head);
            var p4$3 = $as_Lshapeless_$colon$colon($n(p3$3).Lshapeless_$colon$colon__f_tail);
            if ((p4$3 !== null)) {
              var subject$macro$102 = $n($as_Lcom_iz2use_common_Multiline($n(p4$3).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
              var p5$3 = $as_Lshapeless_$colon$colon($n(p4$3).Lshapeless_$colon$colon__f_tail);
              if ((p5$3 !== null)) {
                var attachments$macro$103 = $as_sci_Seq($n(p5$3).Lshapeless_$colon$colon__f_head);
                var p6$3 = $as_Lshapeless_$colon$colon($n(p5$3).Lshapeless_$colon$colon__f_tail);
                if ((p6$3 !== null)) {
                  var created$macro$104 = $as_Ljava_time_Instant($n(p6$3).Lshapeless_$colon$colon__f_head);
                  var p7$3 = $as_Lshapeless_$colon$colon($n(p6$3).Lshapeless_$colon$colon__f_tail);
                  if ((p7$3 !== null)) {
                    var done$macro$105 = $as_s_Option($n(p7$3).Lshapeless_$colon$colon__f_head);
                    var p8$3 = $as_Lshapeless_HNil($n(p7$3).Lshapeless_$colon$colon__f_tail);
                    var x$4 = $m_Lshapeless_HNil$();
                    if ((x$4 === p8$3)) {
                      return new $c_Lreactbuild_model_Task(_id$macro$99, organization$macro$100, persons$macro$101, subject$macro$102, attachments$macro$103, created$macro$104, done$macro$105)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$21 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$266 = $m_s_Symbol$();
    var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$266, "done"));
    new $c_Lshapeless_Witness$$anon$1(value0$43);
    var zipWithKeys$22 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
    $m_Lshapeless_Witness$();
    var this$269 = $m_s_Symbol$();
    var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$269, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$44);
    var zipWithKeys$23 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
    $m_Lshapeless_Witness$();
    var this$272 = $m_s_Symbol$();
    var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$272, "attachments"));
    new $c_Lshapeless_Witness$$anon$1(value0$45);
    var zipWithKeys$24 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$23);
    $m_Lshapeless_Witness$();
    var this$275 = $m_s_Symbol$();
    var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$275, "subject"));
    new $c_Lshapeless_Witness$$anon$1(value0$46);
    var zipWithKeys$25 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$24);
    $m_Lshapeless_Witness$();
    var this$278 = $m_s_Symbol$();
    var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$278, "persons"));
    new $c_Lshapeless_Witness$$anon$1(value0$47);
    var zipWithKeys$26 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$25);
    $m_Lshapeless_Witness$();
    var this$281 = $m_s_Symbol$();
    var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$281, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$48);
    var zipWithKeys$27 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$26);
    $m_Lshapeless_Witness$();
    var this$284 = $m_s_Symbol$();
    var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$284, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$49);
    var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$27);
    var this$287 = $m_s_$less$colon$less$();
    var ev$5 = this$287.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$5);
    var this$325 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    $m_Lshapeless_Witness$();
    var this$289 = $m_s_Symbol$();
    var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$289, "organization"));
    var witness$11 = new $c_Lshapeless_Witness$$anon$1(value0$50);
    var $$x27 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var this$291 = $m_Lreactbuild_model_Implicits$();
    var format$10 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$291);
    var $$x26 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$10);
    var this$294 = $m_Lreactbuild_model_Implicits$();
    var this$293 = $m_Lreactbuild_model_Implicits$();
    var ev$6 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$293, proxy);
    var $$x25 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$294, ev$6)));
    var $$x24 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$296 = $m_Lreactbuild_model_Implicits$();
    var textualizable$10 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$296, proxy);
    var fieldRenderable$7 = $n($$x27).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x26, $$x25, $$x24, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$10), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$323 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    $m_Lshapeless_Witness$();
    var this$298 = $m_s_Symbol$();
    var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$298, "subject"));
    var witness$10 = new $c_Lshapeless_Witness$$anon$1(value0$51);
    var $$x31 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$11 = $m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_formatMultiline;
    var $$x30 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$11);
    var $$x29 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_orderingMultiline));
    var $$x28 = new $c_Lcom_iz2use_react_components_NotEditable();
    var textualizable$11 = $m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_parsableMultiline;
    var fieldRenderable$6 = $n($$x31).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x30, $$x29, $$x28, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$11), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_parsableMultiline)));
    var this$321 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
    $m_Lshapeless_Witness$();
    var this$303 = $m_s_Symbol$();
    var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$303, "created"));
    var witness$9 = new $c_Lshapeless_Witness$$anon$1(value0$52);
    var $$x35 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$12 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
    var $$x34 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$12);
    var $$x33 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering));
    var $$x32 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$307 = $m_Lreactbuild_model_Implicits$();
    var locale$4 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$12 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$307, locale$4);
    var fieldRenderable$5 = $n($$x35).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x34, $$x33, $$x32, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$12), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    $m_Lshapeless_Witness$();
    var this$309 = $m_s_Symbol$();
    var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$309, "done"));
    var witness$8 = new $c_Lshapeless_Witness$$anon$1(value0$53);
    var $$x39 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$13 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
    var format$14 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$13);
    var $$x38 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$14);
    var ord$2 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
    var $$x37 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$2)));
    var $$x36 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$315 = $m_Lreactbuild_model_Implicits$();
    var locale$5 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$13 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$315, locale$5);
    var textualizable$14 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$13);
    var fieldRenderable$4 = $n($$x39).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x38, $$x37, $$x36, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$14), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var tail$22 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3();
    var tail$23 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$4, witness$8, tail$22);
    var tail$24 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$5, witness$9, tail$23);
    var tail$25 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$321, tail$24);
    var tail$26 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$6, witness$10, tail$25);
    var tail$27 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$323, tail$26);
    var tail$28 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$7, witness$11, tail$27);
    var renderer$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$325, tail$28);
    var $$x40 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$2);
    var $$x17 = $m_Lreactbuild_model_Task$().Lreactbuild_model_Task$__f_keyMapper;
    var $$x16 = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
    var $$x15 = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
    var this$327 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$327, "_id"));
    var this$328 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$328, "organization"));
    var this$329 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$329, "persons"));
    var this$330 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$330, "subject"));
    var this$331 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$331, "attachments"));
    var this$332 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$332, "created"));
    var this$333 = $m_s_Symbol$();
    var labels$4 = new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$333, "done")), $m_Lshapeless_HNil$())))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$4);
    var f$4 = new $c_sjsr_AnonFunction1(((x0$19$2) => {
      var x0$19 = $as_Lreactbuild_model_Task(x0$19$2);
      if ((x0$19 !== null)) {
        var _id$macro$134 = $n(x0$19).Lreactbuild_model_Task__f__id;
        var organization$macro$135 = $n(x0$19).Lreactbuild_model_Task__f_organization;
        var persons$macro$136 = $n(x0$19).Lreactbuild_model_Task__f_persons;
        var subject$macro$137 = $n(x0$19).Lreactbuild_model_Task__f_subject;
        var attachments$macro$138 = $n(x0$19).Lreactbuild_model_Task__f_attachments;
        var created$macro$139 = $n(x0$19).Lreactbuild_model_Task__f_created;
        var done$macro$140 = $n(x0$19).Lreactbuild_model_Task__f_done;
        return new $c_Lshapeless_$colon$colon(_id$macro$134, new $c_Lshapeless_$colon$colon(organization$macro$135, new $c_Lshapeless_$colon$colon(persons$macro$136, new $c_Lshapeless_$colon$colon(new $c_Lcom_iz2use_common_Multiline(subject$macro$137), new $c_Lshapeless_$colon$colon(attachments$macro$138, new $c_Lshapeless_$colon$colon(created$macro$139, new $c_Lshapeless_$colon$colon(done$macro$140, $m_Lshapeless_HNil$())))))))
      } else {
        throw new $c_s_MatchError(x0$19)
      }
    }));
    var g$4 = new $c_sjsr_AnonFunction1(((x0$20$2) => {
      var x0$20 = $as_Lshapeless_$colon$colon(x0$20$2);
      if ((x0$20 !== null)) {
        var _id$macro$127 = $as_Lreactbuild_common_model_RefTo($n(x0$20).Lshapeless_$colon$colon__f_head);
        var p2$4 = $as_Lshapeless_$colon$colon($n(x0$20).Lshapeless_$colon$colon__f_tail);
        if ((p2$4 !== null)) {
          var organization$macro$128 = $as_Lreactbuild_common_model_RefTo($n(p2$4).Lshapeless_$colon$colon__f_head);
          var p3$4 = $as_Lshapeless_$colon$colon($n(p2$4).Lshapeless_$colon$colon__f_tail);
          if ((p3$4 !== null)) {
            var persons$macro$129 = $as_sci_Seq($n(p3$4).Lshapeless_$colon$colon__f_head);
            var p4$4 = $as_Lshapeless_$colon$colon($n(p3$4).Lshapeless_$colon$colon__f_tail);
            if ((p4$4 !== null)) {
              var subject$macro$130 = $n($as_Lcom_iz2use_common_Multiline($n(p4$4).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
              var p5$4 = $as_Lshapeless_$colon$colon($n(p4$4).Lshapeless_$colon$colon__f_tail);
              if ((p5$4 !== null)) {
                var attachments$macro$131 = $as_sci_Seq($n(p5$4).Lshapeless_$colon$colon__f_head);
                var p6$4 = $as_Lshapeless_$colon$colon($n(p5$4).Lshapeless_$colon$colon__f_tail);
                if ((p6$4 !== null)) {
                  var created$macro$132 = $as_Ljava_time_Instant($n(p6$4).Lshapeless_$colon$colon__f_head);
                  var p7$4 = $as_Lshapeless_$colon$colon($n(p6$4).Lshapeless_$colon$colon__f_tail);
                  if ((p7$4 !== null)) {
                    var done$macro$133 = $as_s_Option($n(p7$4).Lshapeless_$colon$colon__f_head);
                    var p8$4 = $as_Lshapeless_HNil($n(p7$4).Lshapeless_$colon$colon__f_tail);
                    var x$5 = $m_Lshapeless_HNil$();
                    if ((x$5 === p8$4)) {
                      return new $c_Lreactbuild_model_Task(_id$macro$127, organization$macro$128, persons$macro$129, subject$macro$130, attachments$macro$131, created$macro$132, done$macro$133)
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$20)
    }));
    var gen$8 = new $c_Lshapeless_Generic$$anon$1(f$4, g$4);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$28 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$336 = $m_s_Symbol$();
    var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$336, "done"));
    new $c_Lshapeless_Witness$$anon$1(value0$54);
    var zipWithKeys$29 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$28);
    $m_Lshapeless_Witness$();
    var this$339 = $m_s_Symbol$();
    var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$339, "created"));
    new $c_Lshapeless_Witness$$anon$1(value0$55);
    var zipWithKeys$30 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$29);
    $m_Lshapeless_Witness$();
    var this$342 = $m_s_Symbol$();
    var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$342, "attachments"));
    new $c_Lshapeless_Witness$$anon$1(value0$56);
    var zipWithKeys$31 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$30);
    $m_Lshapeless_Witness$();
    var this$345 = $m_s_Symbol$();
    var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$345, "subject"));
    new $c_Lshapeless_Witness$$anon$1(value0$57);
    var zipWithKeys$32 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$31);
    $m_Lshapeless_Witness$();
    var this$348 = $m_s_Symbol$();
    var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$348, "persons"));
    new $c_Lshapeless_Witness$$anon$1(value0$58);
    var zipWithKeys$33 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$32);
    $m_Lshapeless_Witness$();
    var this$351 = $m_s_Symbol$();
    var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$351, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$59);
    var zipWithKeys$34 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$33);
    $m_Lshapeless_Witness$();
    var this$354 = $m_s_Symbol$();
    var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$354, "_id"));
    new $c_Lshapeless_Witness$$anon$1(value0$60);
    var zip$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$34);
    var this$357 = $m_s_$less$colon$less$();
    var ev$7 = this$357.s_$less$colon$less$__f_singleton;
    var gen$9 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$4, gen$8, ev$7);
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$359 = $m_s_Symbol$();
    var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$359, "_id"));
    var witness$18 = new $c_Lshapeless_Witness$$anon$1(value0$61);
    var ht$6 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$361 = $m_s_Symbol$();
    var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$361, "organization"));
    var witness$17 = new $c_Lshapeless_Witness$$anon$1(value0$62);
    var this$364 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    var this$363 = $m_Lreactbuild_model_Implicits$();
    var textualizable$15 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$363, proxy);
    var ev$8 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$5 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$364, textualizable$15, ev$8)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$365 = $m_s_Symbol$();
    var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$365, "persons"));
    var witness$16 = new $c_Lshapeless_Witness$$anon$1(value0$63);
    var ht$4 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$367 = $m_s_Symbol$();
    var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$367, "subject"));
    var witness$15 = new $c_Lshapeless_Witness$$anon$1(value0$64);
    var this$369 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    var textualizable$16 = $m_Lreactbuild_analyze_cost_views_Inbox$().Lreactbuild_analyze_cost_views_Inbox$__f_parsableMultiline;
    var ev$9 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$3 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$369, textualizable$16, ev$9)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$370 = $m_s_Symbol$();
    var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$370, "attachments"));
    var witness$14 = new $c_Lshapeless_Witness$$anon$1(value0$65);
    var ht$2 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$372 = $m_s_Symbol$();
    var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$372, "created"));
    var witness$13 = new $c_Lshapeless_Witness$$anon$1(value0$66);
    var this$375 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    var this$374 = $m_Lreactbuild_model_Implicits$();
    var locale$6 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$17 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$374, locale$6);
    var ev$10 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$1 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$375, textualizable$17, ev$10)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$376 = $m_s_Symbol$();
    var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$376, "done"));
    var witness$12 = new $c_Lshapeless_Witness$$anon$1(value0$67);
    var this$380 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$378 = $m_Lreactbuild_model_Implicits$();
    var locale$7 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$18 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$378, locale$7);
    var textualizable$19 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$18);
    var ev$11 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$380, textualizable$19, ev$11)));
    var tt = $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$().Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil;
    var tt$1 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt, ht, witness$12);
    var tt$2 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$13);
    var tt$3 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$2, ht$2, witness$14);
    var tt$4 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$3, ht$3, witness$15);
    var tt$5 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$4, ht$4, witness$16);
    var tt$6 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$5, ht$5, witness$17);
    var tokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$6, ht$6, witness$18);
    var $$x14 = new $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer, gen$9);
    var $$x7 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var $$x6 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var $$x5 = new $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1();
    var $$x4 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var $$x3 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    $m_Lreactbuild_model_Implicits$();
    var this$391 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u = $n($$x95).noExternalStateNorActive__O__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(tasks, $$x94, $$x93, $$x86, $$x41, $$x40, $$x17, $$x16, $$x15, $$x14, $$x7, $$x6, $$x5, $$x4, $$x3, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$391.byRef__F2(), this$391.by_$eq$eq__F2()), new $c_sjsr_AnonFunction1(((evT$2) => {
      var evT = $n($as_Ljapgolly_scalajs_react_Reusability(evT$2)).Ljapgolly_scalajs_react_Reusability__f_test;
      return new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityMultiviewItemColl__F2__F2(evT))
    })), $m_Lcom_iz2use_react_components_internal_multiview_View$().defaultViewOrdering__s_math_Ordering());
    var this$393 = $n(u);
    var n = this$393.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Lreactbuild_model_Implicits$();
  var this$396 = $m_Ljapgolly_scalajs_react_Reusability$();
  var u$1 = $n($$x100).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x96, $$x2, $n($$x1).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$396.byRef__F2(), this$396.by_$eq$eq__F2())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
  var this$398 = $n(u$1);
  var n$1 = this$398.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
});
function $as_Lreactbuild_analyze_cost_views_Inbox$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_Inbox$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.Inbox$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_Inbox$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_Inbox$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_Inbox$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_Inbox$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.Inbox$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_views_Inbox$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_Inbox$Backend: 0
}, false, "reactbuild.analyze.cost.views.Inbox$Backend", {
  Lreactbuild_analyze_cost_views_Inbox$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_views_Inbox$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_views_Inbox$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_ProcessTask$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_views_ProcessTask$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_views_ProcessTask$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_views_ProcessTask$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_ProcessTask$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_views_ProcessTask$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_ProcessTask$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_ProcessTask$Backend.prototype = $c_Lreactbuild_analyze_cost_views_ProcessTask$Backend.prototype;
$c_Lreactbuild_analyze_cost_views_ProcessTask$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_views_ProcessTask$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_views_ProcessTask$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Backend.prototype.render__Lreactbuild_analyze_cost_views_ProcessTask$Props__Lreactbuild_analyze_cost_views_ProcessTask$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var pot = $n(p).Lreactbuild_analyze_cost_views_ProcessTask$Props__f_task;
  if ($n(pot).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(pot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(pot);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(pot).get__O();
      var tasks = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
      var task = $as_Lreactbuild_model_Task($n(tasks).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
      var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$14 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
      var $$x19 = this$14.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var this$15 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
      var $$x18 = this$15.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x17 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
      var this$19 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
      var $$x16 = this$19.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x15 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var x1 = $n(task).Lreactbuild_model_Task__f_attachments;
      matchEnd6: {
        var $$x3;
        if ((x1 !== null)) {
          $n($m_s_package$().s_package$__f_Seq);
          if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x1), true) && ($n(x1).lengthCompare__I__I(1) === 0))) {
            var p3 = $as_Lreactbuild_model_TaskAttachment($n(x1).apply__I__O(0));
            if ((p3 instanceof $c_Lreactbuild_model_CommunicationTaskAttachment)) {
              var x4 = $as_Lreactbuild_model_CommunicationTaskAttachment(p3);
              var target = $n(x4).Lreactbuild_model_CommunicationTaskAttachment__f_target;
              var $$x3 = $m_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$().apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_common_model_RefTo__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_VdomElement($n(p).Lreactbuild_analyze_cost_views_ProcessTask$Props__f_router, $n(p).Lreactbuild_analyze_cost_views_ProcessTask$Props__f_proxy, target, $n(task).Lreactbuild_model_Task__f__id, $n(p).Lreactbuild_analyze_cost_views_ProcessTask$Props__f_next);
              break matchEnd6
            }
          }
        };
        var $$x14 = $m_Lcom_iz2use_react_components_Card$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v$1 = $n(task).Lreactbuild_model_Task__f_subject;
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x13 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1);
        var $$x12 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
        var $$x11 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
        var $$x10 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
        var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var this$36 = $n($n(task).Lreactbuild_model_Task__f_organization);
        var v$2 = $m_sr_ScalaRunTime$()._toString__s_Product__T(this$36);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
        var $$x7 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
        var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var this$44 = $n($n(task).Lreactbuild_model_Task__f_created);
        var v$3 = $n($m_Ljava_time_format_DateTimeFormatter$().ISO_INSTANT__Ljava_time_format_DateTimeFormatter()).format__Ljava_time_temporal_TemporalAccessor__T(this$44);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
        var array$3 = [$$x7, $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
        var $$x5 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
        var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v$4 = ("T\u00e2che non g\u00e9r\u00e9e actuellement : " + task);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
        var array$5 = [$$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
        var $$x3 = $n($$x14).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x13, $$x12, $$x11, $$x10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
      };
      var array$6 = [$$x19, $$x18, $$x17, $$x16, $$x15, $$x3];
      return $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
    } else if ($n(pot).isPending__Z()) {
      return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$7 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
    }
  }
});
function $as_Lreactbuild_analyze_cost_views_ProcessTask$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_ProcessTask$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.ProcessTask$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_ProcessTask$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_ProcessTask$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_ProcessTask$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_ProcessTask$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.ProcessTask$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_views_ProcessTask$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_ProcessTask$Backend: 0
}, false, "reactbuild.analyze.cost.views.ProcessTask$Backend", {
  Lreactbuild_analyze_cost_views_ProcessTask$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_views_ProcessTask$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_displayedBodyReuse = null;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(x$3$2);
    return $n(x$3).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__f_displayedBody
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $uI(v$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(x$4$2);
      $n(x$4);
      return new $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(v)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$6 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$6.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_displayedBodyReuse = $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w)
}
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype = $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype;
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype.render__Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var proxy = $n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_proxy;
  var this$5 = $n($as_sc_SeqOps($n($n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_persons).filter__F1__O(new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lreactbuild_model_CommunicationPerson(x$5$2);
    return $n($n(x$5).Lreactbuild_model_CommunicationPerson__f_role).isSender__Z()
  })))));
  var f = new $c_sjsr_AnonFunction1(((person$2) => {
    var person = $as_Lreactbuild_model_CommunicationPerson(person$2);
    var $$x2 = $n($n(person).Lreactbuild_model_CommunicationPerson__f_person).isEmpty__Z();
    var x = $n(person).Lreactbuild_model_CommunicationPerson__f_role;
    var x$2 = $m_Lreactbuild_model_CommunicationRole$From$();
    if ((x !== null)) {
      var this$3 = $n(x);
      var $$x1 = (this$3 === x$2)
    } else {
      var $$x1 = false
    };
    return new $c_T2$mcZZ$sp($$x2, (!$$x1))
  }));
  var ord1 = $m_s_math_Ordering$Boolean$();
  var ord2 = $m_s_math_Ordering$Boolean$();
  var ord = new $c_s_math_Ordering$Tuple2Ordering(ord1, ord2);
  var sender = $n($as_sc_IterableOps($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$5, f, ord))).headOption__s_Option();
  var this$6 = $n(sender);
  var f$1 = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Lreactbuild_model_CommunicationPerson(x$6$2);
    return $n(x$6).Lreactbuild_model_CommunicationPerson__f_address
  }));
  var this$10 = $n((this$6.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$1.apply__O__O(this$6.get__O()))));
  var p$1 = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_T(x$7$2);
    $m_sc_StringOps$();
    var this$9 = $n(x$7);
    return (!(this$9 === ""))
  }));
  var this$11 = $n(((this$10.isEmpty__Z() || $uZ(p$1.apply__O__O(this$10.get__O()))) ? this$10 : $m_s_None$()));
  var default$1 = new $c_sjsr_AnonFunction0((() => $n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_senderAddress));
  var senderAddressRaw = $as_T((this$11.isEmpty__Z() ? default$1.apply__O() : this$11.get__O()));
  var this$12 = $n(senderAddressRaw);
  var x1 = $uI(this$12.lastIndexOf("@"));
  if ((x1 === (-1))) {
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$16 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX");
    var $$x5 = this$16.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$18 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x4 = this$18.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$19 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$());
    var $$x3 = this$19.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("red", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$20 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontWeight__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$());
    var array = [$$x5, $$x4, $$x3, this$20.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("bold", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(senderAddressRaw))];
    var senderAddress = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$51 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$29 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX");
    var $$x12 = this$29.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$30 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).textOverflow__Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$());
    var $$x11 = this$30.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("ellipsis", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $m_sc_StringOps$().take$extension__T__I__T(senderAddressRaw, x1);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$1 = [$$x12, $$x11, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x10 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$40 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX");
    var $$x8 = this$40.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("visible", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$41 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontWeight__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$());
    var $$x7 = this$41.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("bold", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = $m_sc_StringOps$().drop$extension__T__I__T(senderAddressRaw, x1);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$2 = [$$x8, $$x7, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    var array$3 = [$$x10, $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    var senderAddress = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$51, null, ns)
  };
  var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$54 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x23 = this$54.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$55 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x22 = this$55.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$56 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
  var $$x21 = this$56.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x20 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x19 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$61 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX");
  var $$x18 = this$61.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x17 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x16 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Exp\u00e9diteur");
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$67 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
  var $$x15 = this$67.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x14 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("3em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$70 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).textOverflow__Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$());
  var array$4 = [$$x16, $$x15, $$x14, this$70.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("ellipsis", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "paddingRight")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$5 = [$$x23, $$x22, $$x21, $$x20, $$x19, $$x18, $n($$x17).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)), senderAddress];
  var senderAddressLabel = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$2 = $n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_subject;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var x$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2);
  var this$87 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var $$x25 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$83 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflow");
  var array$6 = [$$x25, this$83.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var x$2$1 = this$87.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms);
  var x$3 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
  var x$4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
  var $$x66 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x65 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x64 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowY")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("auto", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x63 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$97 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x62 = this$97.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$98 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x61 = this$98.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$99 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
  var $$x60 = this$99.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x59 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("marginBottom")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("16px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x58 = $m_Lcom_iz2use_react_components_SideBySideLayout$();
  var $$x57 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod).Ljapgolly_scalajs_react_vdom_TagMod$__f_empty;
  var $$x56 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$104 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x55 = this$104.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$105 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x54 = this$105.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x53 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x52 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("30em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x51 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var this$110 = $n(sender);
  var f$2 = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_Lreactbuild_model_CommunicationPerson(x$8$2);
    return $n(x$8).Lreactbuild_model_CommunicationPerson__f_person
  }));
  var value = (this$110.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f$2.apply__O__O(this$110.get__O())));
  var state = $n($$x51).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1$2 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)
  })));
  var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var this$114 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization = $m_s_None$();
  var ev$1 = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$114, proxy, organization);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$116 = $m_Lreactbuild_model_Implicits$();
  $m_Lreactbuild_model_Implicits$();
  var organization$1 = $m_s_None$();
  var helper = new $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(this$116, proxy, organization$1);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var this$120 = $m_Lreactbuild_model_Implicits$();
  var this$119 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$119, proxy);
  var equiv = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$120, ev);
  var array$7 = [$$x55, $$x54, $$x53, $$x52, editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(senderAddressLabel, state, optioner, ev$1, explainError, equiv)];
  var $$x50 = $n($$x56).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var $$x49 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$127 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
  var $$x48 = this$127.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x47 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "flex")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("1", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x46 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#666", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x45 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $as_sc_IterableOnce($n($n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_persons).filter__F1__O(new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Lreactbuild_model_CommunicationPerson(x$9$2);
    return $n($n(x$9).Lreactbuild_model_CommunicationPerson__f_role).isRecipient__Z()
  }))));
  var array$8 = [$$x48, $$x47, $$x46, $n($$x45).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((person$3$2) => {
    var person$3 = $as_Lreactbuild_model_CommunicationPerson(person$3$2);
    var this$133 = $n($n(person$3).Lreactbuild_model_CommunicationPerson__f_person);
    var f$3 = new $c_sjsr_AnonFunction1(((r$2) => {
      var r = $as_Lreactbuild_common_model_RefTo(r$2);
      $m_Lcom_iz2use_common_Textualizable$();
      var this$131 = $m_Lreactbuild_model_Implicits$();
      var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$131, proxy);
      return $n(ev$2).stringify__O__T(r)
    }));
    var this$135 = $n((this$133.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$3.apply__O__O(this$133.get__O()))));
    var default$3 = new $c_sjsr_AnonFunction0((() => {
      var this$134 = $n($n(person$3).Lreactbuild_model_CommunicationPerson__f_address);
      var default$2 = new $c_sjsr_AnonFunction0((() => $n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_receiverAddress));
      return $as_T((this$134.isEmpty__Z() ? default$2.apply__O() : this$134.get__O()))
    }));
    var v$3 = $as_T((this$135.isEmpty__Z() ? default$3.apply__O() : this$135.get__O()));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$4 = ("\u00e0 " + v$3);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)
  })))];
  var array$9 = [$$x50, $n($$x49).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x44 = $n($$x58).apply__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x57, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x43 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$146 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$());
  var $$x42 = this$146.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("nowrap", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var v$5 = $n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_date;
  var this$147 = $m_Lreactbuild_model_Implicits$();
  var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
  var ev$3 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$147, locale);
  var v$6 = $n(ev$3).stringify__O__T(v$5);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$10 = [$$x42, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$6)];
  var array$11 = [$$x62, $$x61, $$x60, $$x59, $$x44, $n($$x43).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
  var $$x41 = $n($$x63).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
  var $$x40 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var this$160 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$Overflow("overflowX");
  var $$x29 = this$160.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("hidden", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x28 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).wordBreak__Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("break-word", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x27 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "maxWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x26 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod;
  var this$163 = $n($n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_bodies);
  var array$18 = [$$x29, $$x28, $$x27, $n($$x26).when__Z__F0__Ljapgolly_scalajs_react_vdom_TagMod((!this$163.isEmpty__Z()), new $c_sjsr_AnonFunction0((() => {
    var this$223 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var end = $n($n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_bodies).length__I();
    var x$5$1 = new $c_sci_Range$Exclusive(0, end, 1);
    var $$x37 = $n(this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_displayedBodyReuse);
    var this$167 = $m_Ljapgolly_scalajs_react_Reusability$();
    var x$6$1 = $n($$x37).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$167.by_$eq$eq__F2());
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var x$7$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Parties");
    var x$9$1 = new $c_sjsr_AnonFunction1(((idx$2) => {
      var idx = $uI(idx$2);
      var x1$3 = $as_Lreactbuild_model_CommunicationBody($n($n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_bodies).apply__I__O(idx));
      if ((x1$3 instanceof $c_Lreactbuild_model_TextCommunicationBody)) {
        var text = "texte"
      } else if ((x1$3 instanceof $c_Lreactbuild_model_HtmlCommunicationBody)) {
        var text = "version html"
      } else if ((x1$3 instanceof $c_Lreactbuild_model_OtherCommunicationBody)) {
        var text = ("" + idx)
      } else {
        var text;
        throw new $c_s_MatchError(x1$3)
      };
      var this$182 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var array$12 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(text)), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("#E0E0E0", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).justifyContent__Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("center", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "minWidth")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 .5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "padding")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(".1em .2em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
      var ms$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
      return this$182.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$1)
    }));
    var x$10 = $m_Lcom_iz2use_react_components_Selector$().apply$default$6__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1(x$5$1, x$6$1, x$7$1, false);
    var $$x38 = $m_Lcom_iz2use_react_components_Selector$();
    var this$183 = $m_Lcom_iz2use_react_components_Selector$Focusable$();
    var u = $n($$x38).apply__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod__Z__F1__F1__Lcom_iz2use_react_components_Selector$Focusable__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_Selector__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(x$5$1, x$6$1, x$7$1, false, x$9$1, x$10, new $c_Lcom_iz2use_react_components_Selector$LowPriorityFocusable$$anon$3(this$183), $m_Lcom_iz2use_common_KeyMapper$().Lcom_iz2use_common_KeyMapper$__f_fromInt, ($m_Lcom_iz2use_react_components_Selector$(), new $c_Lcom_iz2use_react_components_Selector$$anon$2()));
    var this$186 = $n(u);
    var n = this$186.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x39 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var x1$4 = $as_Lreactbuild_model_CommunicationBody($n($n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_bodies).apply__I__O($n(s).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__f_displayedBody));
    if ((x1$4 instanceof $c_Lreactbuild_model_TextCommunicationBody)) {
      var x2 = $as_Lreactbuild_model_TextCommunicationBody(x1$4);
      var text$1 = $n(x2).Lreactbuild_model_TextCommunicationBody__f_textSource;
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$188 = $n(text$1);
      var as$1 = $f_T__split__T__I__AT(this$188, "\r?\n", 0);
      var this$ = $m_s_Predef$().genericWrapArray__O__scm_ArraySeq(as$1);
      var $$x31 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      var this$190 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      var sep = $n($$x31).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_vdom_HtmlTags__br__T(this$190), $m_sci_Nil$());
      var f$4 = new $c_sjsr_AnonFunction1(((v$2$1) => {
        var v$7 = $as_T(v$2$1);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$7)
      }));
      var $$x30 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(this$, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$4)
    } else if ((x1$4 instanceof $c_Lreactbuild_model_HtmlCommunicationBody)) {
      var x3 = $as_Lreactbuild_model_HtmlCommunicationBody(x1$4);
      var html = $n(x3).Lreactbuild_model_HtmlCommunicationBody__f_htmlSource;
      var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$13 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(html))];
      var $$x30 = $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("code", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))
    } else if ((x1$4 instanceof $c_Lreactbuild_model_OtherCommunicationBody)) {
      var x4 = $as_Lreactbuild_model_OtherCommunicationBody(x1$4);
      var source = $n(x4).Lreactbuild_model_OtherCommunicationBody__f_source;
      var part = $n(x4).Lreactbuild_model_OtherCommunicationBody__f_part;
      var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x35 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$14 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(source))];
      var $$x34 = $n($$x35).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h5", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
      var $$x33 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$15 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(part))];
      var array$16 = [$$x34, $n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("code", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
      var $$x30 = $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))
    } else {
      var $$x30;
      throw new $c_s_MatchError(x1$4)
    };
    var array$17 = [$$x39, $$x30];
    var ms$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17);
    return this$223.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms$2)
  })))];
  var array$19 = [$$x65, $$x64, $$x41, $n($$x40).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))];
  var x$16 = $n($$x66).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19));
  var $$x67 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$232 = $n($n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f_attachments);
  var v$8 = (this$232.length__I() + " pi\u00e8ces jointes");
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$20 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$8)];
  var x$17 = $n($$x67).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20));
  var $$x93 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var $$x92 = $n($m_s_package$().s_package$__f_Seq);
  var $$x91 = $m_Lcom_iz2use_react_components_Link$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x86 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).confirm__T__Ljapgolly_scalajs_react_callback_Trampoline("Confirmez-vous la suppression d\u00e9finitive de cet \u00e9l\u00e9ment ?"));
  var condition = new $c_sjsr_AnonFunction1(((v$2$2) => {
    var v$9 = $uZ(v$2$2);
    return v$9
  }));
  var co = $n($$x86).flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$$1, condition), new $c_sjsr_AnonFunction1(((v$3$2) => {
    $uZ(v$3$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$$2 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
      var this$241 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x89 = new $c_Lautowire_ClientProxy(this$241).Lautowire_ClientProxy__f_self;
      var $$x88 = $m_s_package$().s_package$__f_Seq;
      var array$21 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "doneTask"];
      var $$x87 = $as_sci_Seq($n($$x88).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21)));
      var this$252 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$246 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$247 = $n(new $c_Lautowire_ClientProxy(this$246).Lautowire_ClientProxy__f_self);
      var r$1 = $n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_task;
      var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y = this$247.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2);
      var array$22 = [$ct_T2__O__O__(new $c_T2(), "taskRef", y)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22);
      return $n($n($n($$x89).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x87, this$252.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$12$2) => {
        var x$12 = $as_Lio_circe_Json(x$12$2);
        var this$253 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$254 = $n(new $c_Lautowire_ClientProxy(this$253).Lautowire_ClientProxy__f_self);
        var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$254.read__Lio_circe_Json__Lio_circe_Decoder__O(x$12, evidence$1)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$10$2) => {
        $as_jl_Void(x$10$2);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_next)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var f$5 = new $c_sjsr_AnonFunction1(((x$11$2) => {
      $as_jl_Void(x$11$2)
    }));
    var this$256 = $n(this$$2);
    var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$256, f$5);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  })));
  var $$x90 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$259 = $m_s_$less$colon$less$();
  var $$x85 = $n($n($$x91).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x90).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$259.s_$less$colon$less$__f_singleton)));
  var array$23 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Supprimer d\u00e9finitivement"))];
  var $$x84 = $n($$x85).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23));
  var $$x83 = $m_Lcom_iz2use_react_components_Link$();
  var this$$3 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
    var this$265 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x82 = new $c_Lautowire_ClientProxy(this$265).Lautowire_ClientProxy__f_self;
    var $$x81 = $m_s_package$().s_package$__f_Seq;
    var array$24 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "doneTask"];
    var $$x80 = $as_sci_Seq($n($$x81).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24)));
    var this$276 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$270 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$271 = $n(new $c_Lautowire_ClientProxy(this$270).Lautowire_ClientProxy__f_self);
    var r$3 = $n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_task;
    var evidence$2$1 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var y$1 = this$271.write__O__Lio_circe_Encoder__Lio_circe_Json(r$3, evidence$2$1);
    var array$25 = [$ct_T2__O__O__(new $c_T2(), "taskRef", y$1)];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25);
    return $n($n($n($$x82).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x80, this$276.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$13$2) => {
      var x$13 = $as_Lio_circe_Json(x$13$2);
      var this$277 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$278 = $n(new $c_Lautowire_ClientProxy(this$277).Lautowire_ClientProxy__f_self);
      var evidence$1$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
      this$278.read__Lio_circe_Json__Lio_circe_Decoder__O(x$13, evidence$1$1)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$12$2$1) => {
      $as_jl_Void(x$12$2$1);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_next)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
  var f$6 = new $c_sjsr_AnonFunction1(((x$13$2$1) => {
    $as_jl_Void(x$13$2$1)
  }));
  var this$280 = $n(this$$3);
  var $$x79 = $n($n($$x83).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$280, f$6)));
  var array$26 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Traiter"))];
  var $$x78 = $n($$x79).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$26));
  var $$x77 = $m_Lcom_iz2use_react_components_Link$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x69 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$$4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).confirm__T__Ljapgolly_scalajs_react_callback_Trampoline("Confirmez-vous le traitement de cette t\u00e2che et l'enregistrement des documents joints comme factures \u00e0 traiter"));
  var condition$1 = new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4$1 = $uZ(v$4$2);
    return v$4$1
  }));
  var co$1 = $n($$x69).flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$$4, condition$1), new $c_sjsr_AnonFunction1(((v$5$2) => {
    $uZ(v$5$2);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$$5 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).future__F0__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => {
      var this$287 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x72 = new $c_Lautowire_ClientProxy(this$287).Lautowire_ClientProxy__f_self;
      var $$x71 = $m_s_package$().s_package$__f_Seq;
      var array$27 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "setCommunicationAttachmentsAsInvoices"];
      var $$x70 = $as_sci_Seq($n($$x71).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$27)));
      var this$298 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$292 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$293 = $n(new $c_Lautowire_ClientProxy(this$292).Lautowire_ClientProxy__f_self);
      var r$4 = $n($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication).Lreactbuild_model_Communication__f__id;
      var evidence$2$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y$2 = this$293.write__O__Lio_circe_Encoder__Lio_circe_Json(r$4, evidence$2$2);
      var array$28 = [$ct_T2__O__O__(new $c_T2(), "communicationRef", y$2)];
      var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$28);
      return $n($n($n($$x72).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x70, this$298.from__sc_IterableOnce__sci_Map(elems$2)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$14$2) => {
        var x$14 = $as_Lio_circe_Json(x$14$2);
        var this$299 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$300 = $n(new $c_Lautowire_ClientProxy(this$299).Lautowire_ClientProxy__f_self);
        var evidence$1$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$300.read__Lio_circe_Json__Lio_circe_Decoder__O(x$14, evidence$1$2)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$15$2) => {
        $as_jl_Void(x$15$2);
        var this$301 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x75 = new $c_Lautowire_ClientProxy(this$301).Lautowire_ClientProxy__f_self;
        var $$x74 = $m_s_package$().s_package$__f_Seq;
        var array$29 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "doneTask"];
        var $$x73 = $as_sci_Seq($n($$x74).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$29)));
        var this$312 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$306 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$307 = $n(new $c_Lautowire_ClientProxy(this$306).Lautowire_ClientProxy__f_self);
        var r$5 = $n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_task;
        var evidence$2$3 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
        var y$3 = this$307.write__O__Lio_circe_Encoder__Lio_circe_Json(r$5, evidence$2$3);
        var array$30 = [$ct_T2__O__O__(new $c_T2(), "taskRef", y$3)];
        var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$30);
        return $n($n($n($$x75).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x73, this$312.from__sc_IterableOnce__sci_Map(elems$3)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$15$2$2) => {
          var x$15$2$1 = $as_Lio_circe_Json(x$15$2$2);
          var this$313 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$314 = $n(new $c_Lautowire_ClientProxy(this$313).Lautowire_ClientProxy__f_self);
          var evidence$1$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
          this$314.read__Lio_circe_Json__Lio_circe_Decoder__O(x$15$2$1, evidence$1$3)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$14$2$1) => {
          $as_jl_Void(x$14$2$1);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(p).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_next)
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var f$7 = new $c_sjsr_AnonFunction1(((x$16$2) => {
      $as_jl_Void(x$16$2)
    }));
    var this$316 = $n(this$$5);
    var c$1 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$316, f$7);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1))
  })));
  var $$x76 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$319 = $m_s_$less$colon$less$();
  var $$x68 = $n($$x77).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x76).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co$1, this$319.s_$less$colon$less$__f_singleton));
  var array$31 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Mettre dans les factures en attente de traitement"))];
  var array$32 = [$$x84, $$x78, $n($$x68).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$31))];
  var as$2 = $n($$x92).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$32));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var sep$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" ");
  var this$332 = $m_s_$less$colon$less$();
  var f$8 = this$332.s_$less$colon$less$__f_singleton;
  var array$33 = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$2, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep$1, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$8)];
  var x$18 = $n($$x93).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$33));
  var $$x94 = $m_Lcom_iz2use_react_components_Card$();
  var array$34 = [x$16, x$17, x$18];
  return $n($$x94).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(x$1, x$3, x$4, x$2$1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$34))
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype.reset__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$3 = $n(this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(s$2);
    $n(s);
    return new $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(0)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
function $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.ProcessTaskCommunication$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.ProcessTaskCommunication$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend: 0
}, false, "reactbuild.analyze.cost.views.ProcessTaskCommunication$Backend", {
  Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Backend;
/** @constructor */
function $c_Lreactbuild_common_components_DrawingViewer$Backend(\u03b4) {
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_$ = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_divRef = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_controls = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_stopAnimation = false;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugGroup = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_componentMaterial = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugModeReuse = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_$ = \u03b4;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_divRef = $m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF();
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene = new $i_three$002fsrc$002fscenes$002fScene.Scene();
  console.log(this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene);
  var $$x2 = $i_three$002fsrc$002frenderers$002fWebGLRenderer.WebGLRenderer;
  var array = [$ct_T2__O__O__(new $c_T2(), "antialias", true)];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x1 = new $$x2($m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields));
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer = $$x1;
  console.log(this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer);
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera = new $i_three$002fsrc$002fcameras$002fPerspectiveCamera.PerspectiveCamera(70.0, ($uD(window.innerWidth) / $uD(window.innerHeight)), 0.1, 1000.0);
  console.log(this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera);
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugGroup = new $i_three.Group();
  var params = {};
  params.color = 2699571;
  params.roughness = 0.3;
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_componentMaterial = new $i_three$002fsrc$002fmaterials$002fMeshPhysicalMaterial.MeshPhysicalMaterial(params);
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_common_components_DrawingViewer$State(x$3$2);
    return $n(x$3).Lreactbuild_common_components_DrawingViewer$State__f_debugMode
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $uZ(v$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Lreactbuild_common_components_DrawingViewer$State(x$4$2);
      $n(x$4);
      return new $c_Lreactbuild_common_components_DrawingViewer$State(v)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$15 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$15.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugModeReuse = $n($$x4).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x3, \u03b4, w)
}
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype = new $h_O();
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.constructor = $c_Lreactbuild_common_components_DrawingViewer$Backend;
/** @constructor */
function $h_Lreactbuild_common_components_DrawingViewer$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_DrawingViewer$Backend.prototype = $c_Lreactbuild_common_components_DrawingViewer$Backend.prototype;
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_common_components_DrawingViewer$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_common_components_DrawingViewer$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.init__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$22 = $n(this.Lreactbuild_common_components_DrawingViewer$Backend__f_divRef);
  var f$4 = new $c_sjsr_AnonFunction1(((container$2) => {
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera.position.set(2.0, 1.6, 1.0);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.add(this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugGroup.visible = false;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.add(this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugGroup);
    $n($m_s_package$().s_package$__f_List);
    var array = ["px", "nx", "py", "ny", "pz", "nz"];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$6 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
    var f = ((n$2) => {
      var n = $as_T(n$2);
      return (("/assets/textures/hdri/trees/cube/1024/" + n) + ".png")
    });
    if ((this$6 === $m_sci_Nil$())) {
      var urls = $m_sci_Nil$()
    } else {
      var arg1 = this$6.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$6.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var urls = h
    };
    var qual$1 = new $i_three.CubeTextureLoader();
    var x$1 = $m_sjs_js_JSConverters$JSRichIterableOnce$().toJSArray$extension__sc_IterableOnce__sjs_js_Array(urls);
    var reflectionCube = qual$1.load(x$1);
    reflectionCube.format = $i_three.RGBFormat;
    reflectionCube.encoding = $i_three.sRGBEncoding;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.background = reflectionCube;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.add(new $i_three.AxesHelper());
    var hemilight = new $i_three.HemisphereLight(1.6777215E7, 4473924.0);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.add(hemilight);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugGroup.add(new $i_three.HemisphereLightHelper(hemilight, 5.0));
    var light = new $i_three.DirectionalLight(1.6777215E7, 1.0);
    light.position.set(100.0, 100.0, (-100.0));
    light.castShadow = true;
    light.shadow.bias = 1.0E-5;
    light.shadow.mapSize.width = 512.0;
    light.shadow.mapSize.height = 512.0;
    var cam = light.shadow.camera;
    cam.near = 50.0;
    cam.far = 200.0;
    cam.bottom = (-10.0);
    cam.top = 10.0;
    cam.left = (-10.0);
    cam.right = 10.0;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.add(light);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.add(light.target);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugGroup.add(new $i_three.DirectionalLightHelper(light, 5.0));
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugGroup.add(new $i_three.CameraHelper(cam));
    var this$ = this.handleFile__Ljapgolly_scalajs_react_callback_Trampoline();
    var f$3 = new $c_sjsr_AnonFunction1(((m$2) => {
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.add(m$2)
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    }));
    var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$3);
    var this$16 = $n(this$$1);
    $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$16);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.devicePixelRatio = $uD(window.devicePixelRatio);
    var r = this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer;
    r.physicallyCorrectLights = true;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.gammaInput = true;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.gammaOutput = true;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.gammaFactor = 2.2;
    var r$1 = this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer;
    var $$x1 = r$1.shadowMap;
    $$x1.enabled = true;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.shadowMapSoft = true;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.shadowCameraNear = 1.0;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.shadowCameraFar = 2000.0;
    var r$2 = this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer;
    var r$3 = $i_three;
    var $$x2 = r$3.ReinhardToneMapping;
    r$2.toneMapping = $$x2;
    var r$4 = this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer;
    r$4.toneMappingExposure = 1.0;
    container$2.appendChild(this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.domElement);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_controls = new $i_three$002fexamples$002fjsm$002fcontrols$002fOrbitControls.OrbitControls(this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera, this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.domElement);
    this.animate__V()
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_Ref$GetF__foreach__F1__O(this$22, f$4))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.animate__V = (function() {
  if ((!this.Lreactbuild_common_components_DrawingViewer$Backend__f_stopAnimation)) {
    window.requestAnimationFrame(((arg1$2) => {
      $uD(arg1$2);
      this.animate__V()
    }));
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_controls.update();
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.render(this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene, this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera)
  } else {
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_controls.enabled = false;
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_controls.dispose();
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.vr.enabled = true;
    var controller1 = this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.vr.getController(0);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.add(controller1);
    var controller2 = this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.vr.getController(1);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene.add(controller2);
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.setAnimationLoop($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
      this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.render(this.Lreactbuild_common_components_DrawingViewer$Backend__f_scene, this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera)
    }))));
    var this$3 = $n(this.Lreactbuild_common_components_DrawingViewer$Backend__f_divRef);
    var f = new $c_sjsr_AnonFunction1(((container$2) => {
      container$2.appendChild($i_three.WEBVR.createButton(this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer))
    }));
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_Ref$GetF__foreach__F1__O(this$3, f))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$5 = $n(this$);
    $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$5)
  }
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.onResize__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera.aspect = ($uD(window.innerWidth) / $uD(window.innerHeight));
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_camera.updateProjectionMatrix();
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_renderer.setSize($uD(window.innerWidth), $uD(window.innerHeight))
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.activateVR__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    this.Lreactbuild_common_components_DrawingViewer$Backend__f_stopAnimation = true
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.render__Lreactbuild_common_components_DrawingViewer$Props__Lreactbuild_common_components_DrawingViewer$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var this$28 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Mode debug");
  var $$x4 = $n(this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugModeReuse);
  var this$5 = $m_Ljapgolly_scalajs_react_Reusability$();
  var state = $n($$x4).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$5.by_$eq$eq__F2());
  var evDefault = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
  var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv = $m_s_math_Equiv$Boolean$();
  var this$10 = $n(editorComponent);
  var $$x5 = this$10.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv);
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("En VR")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.activateVR__Ljapgolly_scalajs_react_callback_Trampoline()))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var array$1 = [$$x5, $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var $$x2 = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), $m_sci_Nil$());
  var r = this.Lreactbuild_common_components_DrawingViewer$Backend__f_divRef;
  var array$2 = [$$x2, $n($$x1).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(r))];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$28, null, ns)
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.handleFile__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_common_components_DrawingViewer$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_common_components_DrawingViewer$Props(p$2);
    var $$x1 = $m_Lfastparse_package$();
    var t = $n(p).Lreactbuild_common_components_DrawingViewer$Props__f_modelSource;
    var conv = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_T(s$2);
      return new $c_Lfastparse_IndexedParserInput(s)
    }));
    var x1 = $n($$x1).parse__Lfastparse_ParserInputSource__F1__Z__I__Lfastparse_internal_Instrument__Lfastparse_Parsed(new $c_Lfastparse_ParserInputSource$fromParserInput(t, conv), new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Lfastparse_ParsingRun(x$5$2);
      return $m_Lreactbuild_format_iz2use_Parser$().root__Lfastparse_ParsingRun__Lfastparse_ParsingRun(x$5)
    })), ($m_Lfastparse_package$(), false), ($m_Lfastparse_package$(), 0), ($m_Lfastparse_package$(), null));
    matchEnd7: {
      var $$x2;
      if ((x1 instanceof $c_Lfastparse_Parsed$Success)) {
        var x2 = $as_Lfastparse_Parsed$Success(x1);
        var v = $as_Lreactbuild_format_iz2use_package$Building($n(x2).Lfastparse_Parsed$Success__f_value);
        var $$x2 = this.buildBuilding__Lreactbuild_format_iz2use_package$Building__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline(v, $n(p).Lreactbuild_common_components_DrawingViewer$Props__f_library);
        break matchEnd7
      };
      if ((x1 instanceof $c_Lfastparse_Parsed$Failure)) {
        var x4 = $as_Lfastparse_Parsed$Failure(x1);
        var o11 = $m_Lfastparse_Parsed$Failure$().unapply__Lfastparse_Parsed$Failure__s_Option(x4);
        if ((!$n(o11).isEmpty__Z())) {
          var expected = $as_T($n($as_T3($n(o11).get__O())).T3__f__1);
          var index = $uI($n($as_T3($n(o11).get__O())).T3__f__2);
          var extra = $as_Lfastparse_Parsed$Extra($n($as_T3($n(o11).get__O())).T3__f__3);
          var traced = $n(extra).trace__Z__Lfastparse_Parsed$TracedFailure(true);
          throw $ct_jl_Exception__T__(new $c_jl_Exception(), (((((((($n(traced).Lfastparse_Parsed$TracedFailure__f_failure + " at index ") + index) + ", expected ") + expected) + "\n") + traced) + "\n") + $n(traced).stack__sci_List()))
        }
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.buildStorey__Lorg_denigma_threejs_Group__Lreactbuild_format_iz2use_package$Storey__Lorg_denigma_threejs_Material__Lorg_denigma_threejs_Material__Lorg_denigma_threejs_Material__Lorg_denigma_threejs_Material__sci_Seq__Lorg_denigma_threejs_Material__Lorg_denigma_threejs_Group = (function(parent, storey, outsideWallMaterial, insideWallMaterial, floorMaterial, ceilMaterial, library, componentMaterial) {
  var builder = new $c_Lreactbuild_common_components_LocalBuilder(2.85, 2.5, outsideWallMaterial, insideWallMaterial, floorMaterial, ceilMaterial, library, componentMaterial);
  var this$1 = $n(storey);
  var storeyNode = $f_Lreactbuild_format_iz2use_package$GenerateGeometry__buildEdgesAndComponents__Lreactbuild_format_iz2use_package$EdgeAndComponentBuilder__O(this$1, builder);
  var this$2 = $n($n(storey).Lreactbuild_format_iz2use_package$Storey__f_rooms);
  var these = this$2;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var room = $as_Lreactbuild_format_iz2use_package$Room(arg1);
    var this$3 = $n(room);
    var node = $f_Lreactbuild_format_iz2use_package$GenerateGeometry__buildEdgesAndComponents__Lreactbuild_format_iz2use_package$EdgeAndComponentBuilder__O(this$3, builder);
    node.position.set(($n($n($n(room).Lreactbuild_format_iz2use_package$Room__f_origin).Lreactbuild_format_iz2use_package$Vector2D__f_x).Lreactbuild_format_iz2use_package$Length__f_length / 1000.0), 0.0, (((-$n($n($n(room).Lreactbuild_format_iz2use_package$Room__f_origin).Lreactbuild_format_iz2use_package$Vector2D__f_y).Lreactbuild_format_iz2use_package$Length__f_length) | 0) / 1000.0));
    node.name = $n(room).Lreactbuild_format_iz2use_package$Room__f_name;
    var this$6 = $n($n(room).Lreactbuild_format_iz2use_package$Room__f_sides);
    var f = ((x$6$2) => {
      var x$6 = $as_Lreactbuild_format_iz2use_package$Side(x$6$2);
      return $n(x$6).Lreactbuild_format_iz2use_package$Side__f_edge
    });
    if ((this$6 === $m_sci_Nil$())) {
      var $$x1 = $m_sci_Nil$()
    } else {
      var arg1$1 = this$6.head__O();
      var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$6.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$2 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var $$x1 = h
    };
    var this$7 = $n($$x1);
    var s = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$7, "", "; ", "");
    node.sides = s;
    storeyNode.add(node);
    these = $as_sci_List($n(these).tail__O())
  };
  builder.finalBuild__V();
  return storeyNode
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.buildMaterial__D__D__Lorg_denigma_threejs_MeshPhysicalMaterial = (function(color, roughness) {
  var materialParams = {};
  var colorObj = new $i_three.Color(color);
  colorObj.convertSRGBToLinear();
  materialParams.color = colorObj;
  materialParams.roughness = roughness;
  materialParams.metalness = 0.0;
  materialParams.flatShading = true;
  var material = new $i_three$002fsrc$002fmaterials$002fMeshPhysicalMaterial.MeshPhysicalMaterial(materialParams);
  material.side = $i_three.DoubleSide;
  return material
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.buildBuilding__Lreactbuild_format_iz2use_package$Building__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline = (function(building, library) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
  var f = new $c_sjsr_AnonFunction0((() => {
    var loader = new $i_three.TextureLoader();
    var material1 = this.buildMaterial__D__D__Lorg_denigma_threejs_MeshPhysicalMaterial(1.6777215E7, 0.8);
    material1.bumpMap = loader.load("/assets/textures/2x2_v3_wall_finish_bump.jpg");
    material1.bumpMap.encoding = $i_three.sRGBEncoding;
    material1.bumpMap.wrapS = $i_three.RepeatWrapping;
    material1.bumpMap.wrapT = $i_three.RepeatWrapping;
    material1.bumpMap.repeat.set(2.0, 2.0);
    material1.bumpScale = 0.01;
    var material2 = this.buildMaterial__D__D__Lorg_denigma_threejs_MeshPhysicalMaterial(1.6777215E7, 0.08);
    material2.bumpMap = loader.load("/assets/textures/bruit2_alpha.png");
    material2.bumpMap.encoding = $i_three.sRGBEncoding;
    material2.bumpMap.wrapS = $i_three.RepeatWrapping;
    material2.bumpMap.wrapT = $i_three.RepeatWrapping;
    material2.bumpMap.repeat.set(16.0, 16.0);
    material2.bumpScale = 0.01;
    var material3 = this.buildMaterial__D__D__Lorg_denigma_threejs_MeshPhysicalMaterial(1.6777215E7, 0.5);
    material3.bumpMap = loader.load("/assets/textures/floor/4x4_18b_ns_tiles_bump.jpg");
    material3.bumpMap.encoding = $i_three.sRGBEncoding;
    material3.bumpMap.wrapS = $i_three.RepeatWrapping;
    material3.bumpMap.wrapT = $i_three.RepeatWrapping;
    material3.bumpMap.repeat.set(0.5, 0.5);
    material3.bumpScale = 0.01;
    material3.map = loader.load("/assets/textures/floor/4x4_18b_ns_tiles_diffuse.jpg");
    material3.map.wrapS = $i_three.RepeatWrapping;
    material3.map.wrapT = $i_three.RepeatWrapping;
    material3.map.encoding = $i_three.sRGBEncoding;
    material3.map.repeat.set(0.5, 0.5);
    var material4 = material2.clone();
    material4.side = $i_three.BackSide;
    var node = new $i_three.Group();
    node.name = $n(building).Lreactbuild_format_iz2use_package$Building__f_name;
    var this$2 = $n($n(building).Lreactbuild_format_iz2use_package$Building__f_storeys);
    $n($n($as_sc_IterableOps($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$2))).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
      var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
      return (check$ifrefutable$1 !== null)
    })))).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7 = $as_T2(x$7$2);
      if ((x$7 !== null)) {
        var storey = $as_Lreactbuild_format_iz2use_package$Storey($n(x$7)._1__O());
        var idx = $n(x$7)._2$mcI$sp__I();
        var storeyNode = this.buildStorey__Lorg_denigma_threejs_Group__Lreactbuild_format_iz2use_package$Storey__Lorg_denigma_threejs_Material__Lorg_denigma_threejs_Material__Lorg_denigma_threejs_Material__Lorg_denigma_threejs_Material__sci_Seq__Lorg_denigma_threejs_Material__Lorg_denigma_threejs_Group(node, storey, material1, material2, material3, material4, library, this.Lreactbuild_common_components_DrawingViewer$Backend__f_componentMaterial);
        storeyNode.name = ("Level." + idx);
        node.add(storeyNode)
      } else {
        throw new $c_s_MatchError(x$7)
      }
    })));
    console.log(node);
    return node
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.onChange__Lreactbuild_common_components_DrawingViewer$State__Lreactbuild_common_components_DrawingViewer$State__Ljapgolly_scalajs_react_callback_Trampoline = (function(prev, next) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    if (($n(prev).Lreactbuild_common_components_DrawingViewer$State__f_debugMode !== $n(next).Lreactbuild_common_components_DrawingViewer$State__f_debugMode)) {
      this.Lreactbuild_common_components_DrawingViewer$Backend__f_debugGroup.visible = $n(next).Lreactbuild_common_components_DrawingViewer$State__f_debugMode
    }
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
function $as_Lreactbuild_common_components_DrawingViewer$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_DrawingViewer$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.DrawingViewer$Backend"))
}
function $isArrayOf_Lreactbuild_common_components_DrawingViewer$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_DrawingViewer$Backend)))
}
function $asArrayOf_Lreactbuild_common_components_DrawingViewer$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_DrawingViewer$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.DrawingViewer$Backend;", depth))
}
var $d_Lreactbuild_common_components_DrawingViewer$Backend = new $TypeData().initClass({
  Lreactbuild_common_components_DrawingViewer$Backend: 0
}, false, "reactbuild.common.components.DrawingViewer$Backend", {
  Lreactbuild_common_components_DrawingViewer$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_common_components_DrawingViewer$Backend.prototype.$classData = $d_Lreactbuild_common_components_DrawingViewer$Backend;
function $ct_Lreactbuild_common_components_InteractionController$TypedBackend__($thiz) {
  $thiz.Lreactbuild_common_components_InteractionController$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $thiz.Lreactbuild_common_components_InteractionController$TypedBackend__f_ref = $m_Ljapgolly_scalajs_react_Ref$().apply__Ljapgolly_scalajs_react_Ref$FullF();
  var $$x13 = $m_s_package$().s_package$__f_Seq;
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onPointerCancel");
  var $$x12 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.pointerHandler__Lreactbuild_common_components_Input$PointerWay__Ljapgolly_scalajs_react_facade_SyntheticPointerEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$Cancel$(), e$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$2 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onPointerDown");
  var $$x11 = stabilizer$2.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$3$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.pointerHandler__Lreactbuild_common_components_Input$PointerWay__Ljapgolly_scalajs_react_facade_SyntheticPointerEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$Start$(), e$3$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$3 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onPointerEnter");
  var $$x10 = stabilizer$3.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$4$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.pointerHandler__Lreactbuild_common_components_Input$PointerWay__Ljapgolly_scalajs_react_facade_SyntheticPointerEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$Enter$(), e$4$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$4 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onPointerLeave");
  var $$x9 = stabilizer$4.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$5$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.pointerHandler__Lreactbuild_common_components_Input$PointerWay__Ljapgolly_scalajs_react_facade_SyntheticPointerEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$Leave$(), e$5$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$5 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onPointerMove");
  var $$x8 = stabilizer$5.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$6$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.pointerHandler__Lreactbuild_common_components_Input$PointerWay__Ljapgolly_scalajs_react_facade_SyntheticPointerEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$Move$(), e$6$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$6 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onPointerOut");
  var $$x7 = stabilizer$6.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$7$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.pointerHandler__Lreactbuild_common_components_Input$PointerWay__Ljapgolly_scalajs_react_facade_SyntheticPointerEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$Out$(), e$7$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$7 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onPointerOver");
  var $$x6 = stabilizer$7.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$8$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.pointerHandler__Lreactbuild_common_components_Input$PointerWay__Ljapgolly_scalajs_react_facade_SyntheticPointerEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$Over$(), e$8$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$8 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onPointerUp");
  var $$x5 = stabilizer$8.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$9$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.pointerHandler__Lreactbuild_common_components_Input$PointerWay__Ljapgolly_scalajs_react_facade_SyntheticPointerEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$End$(), e$9$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$9 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDoubleClick");
  var $$x4 = stabilizer$9.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$10$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.mouseHandler__Lreactbuild_common_components_Input$MouseWay__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$DoubleTap$(), e$10$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$10 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onKeyDown");
  var $$x3 = stabilizer$10.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$11$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.keyboardHandler__Lreactbuild_common_components_Input$KeyboardWay__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$Start$(), e$11$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$11 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onKeyPress");
  var $$x2 = stabilizer$11.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$12$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.keyboardHandler__Lreactbuild_common_components_Input$KeyboardWay__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$Tap$(), e$12$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$12 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onKeyUp");
  var $$x1 = stabilizer$12.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$13$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.keyboardHandler__Lreactbuild_common_components_Input$KeyboardWay__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_components_Input$End$(), e$13$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$13 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onWheel");
  var array = [$$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $$x1, stabilizer$13.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$14$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($thiz.wheelHandler__Ljapgolly_scalajs_react_facade_SyntheticWheelEvent__Ljapgolly_scalajs_react_callback_Trampoline(e$14$2)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomStyle), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "touchAction")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomStyle), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "userSelect")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  $thiz.Lreactbuild_common_components_InteractionController$TypedBackend__f_eventHandlers = $as_sci_Seq($n($$x13).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_common_components_InteractionController$TypedBackend() {
  this.Lreactbuild_common_components_InteractionController$TypedBackend__f_ref = null;
  this.Lreactbuild_common_components_InteractionController$TypedBackend__f_eventHandlers = null;
  this.Lreactbuild_common_components_InteractionController$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.constructor = $c_Lreactbuild_common_components_InteractionController$TypedBackend;
/** @constructor */
function $h_Lreactbuild_common_components_InteractionController$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_InteractionController$TypedBackend.prototype = $c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype;
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_common_components_InteractionController$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_common_components_InteractionController$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.finishHandle__Lreactbuild_common_components_InteractionController$TypedProps__Lreactbuild_common_components_InteractionController$TypedState__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__F0 = (function(p, s, ev, trackedPointers) {
  var this$1 = $n($n(s).Lreactbuild_common_components_InteractionController$TypedState__f_interactions);
  var context = $n(p).Lreactbuild_common_components_InteractionController$TypedProps__f_context;
  var x1 = $p_Lreactbuild_common_components_Interactions__loop$1__I__sci_List__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult(this$1, 0, this$1.Lreactbuild_common_components_Interactions__f_orderedList, ev, trackedPointers, context);
  var x = $m_Lreactbuild_common_components_Skip$();
  if ((x === x1)) {
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).fail__F0();
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var c = $n(p).Lreactbuild_common_components_InteractionController$TypedProps__f_interactionEmpty;
    return $n($$x2).$less$times$extension__F0__F0__F0($$x1, $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  } else if ($is_Lreactbuild_common_components_ProcessedInteractionResult(x1)) {
    var x3 = $as_Lreactbuild_common_components_ProcessedInteractionResult(x1);
    return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).pure__O__F0($n(this.Lreactbuild_common_components_InteractionController$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lreactbuild_common_components_InteractionController$TypedState(x$1$2);
      $n(x$1);
      var interactions = $as_Lreactbuild_common_components_Interactions($n(x3).state__O());
      var this$4 = $n(x$1);
      var trackedPointers$1 = this$4.Lreactbuild_common_components_InteractionController$TypedState__f_trackedPointers;
      var this$5 = $n(x$1);
      var lastEvents = this$5.Lreactbuild_common_components_InteractionController$TypedState__f_lastEvents;
      return new $c_Lreactbuild_common_components_InteractionController$TypedState(interactions, trackedPointers$1, lastEvents)
    })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($n(x3).isDone__Z() ? $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n(p).Lreactbuild_common_components_InteractionController$TypedProps__f_interactionDone, $n(x3).cb__Ljapgolly_scalajs_react_callback_Trampoline()) : $n(x3).cb__Ljapgolly_scalajs_react_callback_Trampoline())))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.process__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline = (function(e, f) {
  var this$12 = $n(this.Lreactbuild_common_components_InteractionController$TypedBackend__f_ref);
  var f$3 = new $c_sjsr_AnonFunction1(((node$2) => {
    if (($as_T(e.type) === "pointerdown")) {
      var x = document.activeElement;
      var $$x1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x, node$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var preventDefaultCB = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
    } else {
      var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_package$();
      var this$3 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var $$x2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e, this$3.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      $m_Ljapgolly_scalajs_react_package$();
      var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var preventDefaultCB = $n($$x3).$less$times$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x2, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(e, this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).stopPropagationCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    };
    e.persist();
    var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_common_components_InteractionController$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var f$2 = new $c_sjsr_AnonFunction1(((p$2) => {
      $as_Lreactbuild_common_components_InteractionController$TypedProps(p$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().$less$times$extension__F0__F0__F0(this.handle__Lreactbuild_common_components_Input$Event__F0($as_Lreactbuild_common_components_Input$Event($n(f).apply__O__O(node$2))), ($m_Ljapgolly_scalajs_react_callback_CallbackOption$(), $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(preventDefaultCB)));
      var cond = new $c_sjsr_AnonFunction0((() => $uZ(e.defaultPrevented)));
      var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().when$extension__F0__F0__F0(this$, new $c_sjsr_AnonFunction0((() => (!$uZ(cond.apply__O())))));
      var f$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x$2$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(x$2))
      }));
      var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$$1, f$1);
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$10 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x4).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$10.s_$less$colon$less$__f_singleton))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$2, f$2))
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_Ref$GetF__foreachCB__F1__O(this$12, f$3))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.handle__Lreactbuild_common_components_Input$Event__F0 = (function(ev) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_common_components_InteractionController$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_common_components_InteractionController$TypedProps(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_common_components_InteractionController$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_common_components_InteractionController$TypedState(s$2);
      var updatedTrackedPointers = $n($n(s).Lreactbuild_common_components_InteractionController$TypedState__f_trackedPointers).update__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers(ev);
      return $ct_T2__O__O__(new $c_T2(), s, updatedTrackedPointers)
    })), null), new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_T2(x$4$2);
      if ((x$4 !== null)) {
        var s$1 = $as_Lreactbuild_common_components_InteractionController$TypedState($n(x$4)._1__O());
        var updatedTrackedPointers$1 = $as_Lreactbuild_common_components_TrackedPointers($n(x$4)._2__O());
        var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var this$5 = $n(this.Lreactbuild_common_components_InteractionController$Backend__f_$);
        var mod = new $c_sjsr_AnonFunction1(((s$2$2) => {
          var s$2$1 = $as_Lreactbuild_common_components_InteractionController$TypedState(s$2$2);
          var this$2 = $n($n($n(s$2$1).Lreactbuild_common_components_InteractionController$TypedState__f_lastEvents).take__I__sci_List(15));
          var x$2 = new $c_sci_$colon$colon(ev, this$2);
          var this$3 = $n(s$2$1);
          var x$3 = this$3.Lreactbuild_common_components_InteractionController$TypedState__f_interactions;
          $n(s$2$1);
          return new $c_Lreactbuild_common_components_InteractionController$TypedState(x$3, updatedTrackedPointers$1, x$2)
        }));
        var $$x1 = $n($$x3).flatMap$extension__F0__F1__F0($n($$x2).toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$5, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$3$2) => {
          $as_jl_Void(x$3$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0(this.finishHandle__Lreactbuild_common_components_InteractionController$TypedProps__Lreactbuild_common_components_InteractionController$TypedState__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__F0(p, s$1, ev, updatedTrackedPointers$1), new $c_sjsr_AnonFunction1(((cb$2) => {
            var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)
          })), null))
        })))
      } else {
        var $$x1;
        throw new $c_s_MatchError(x$4)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($$x1)
    }))))
  })))
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.pointerHandler__Lreactbuild_common_components_Input$PointerWay__Ljapgolly_scalajs_react_facade_SyntheticPointerEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(way, e) {
  return this.process__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline(e, new $c_sjsr_AnonFunction1(((elt$2) => {
    var x1 = $as_T(e.pointerType);
    switch (x1) {
      case "pen": {
        var tpe = $m_Lreactbuild_common_components_Input$Pen$();
        break
      }
      case "mouse": {
        var tpe = $m_Lreactbuild_common_components_Input$Mouse$();
        break
      }
      case "touch": {
        var tpe = $m_Lreactbuild_common_components_Input$Touch$();
        break
      }
      default: {
        var tpe = $m_Lreactbuild_common_components_Input$PointerTypeUnknown$()
      }
    };
    return new $c_Lreactbuild_common_components_Input$PointerEvent(way, $uD(e.pointerId), $m_Lreactbuild_common_components_InteractionController$().position__Lreactbuild_common_components_HasClientPosition__Lreactbuild_common_components_Input$CursorType__Lorg_scalajs_dom_Node__Lreactbuild_common_components_Input$Coords(e, tpe, elt$2), $uZ(e.isPrimary), $m_Lreactbuild_common_components_Input$PointerButton$().fromOne__I__Lreactbuild_common_components_Input$PointerButton($uI(e.button)), $m_Lreactbuild_common_components_Input$PointerButton$().fromMultiple__I__sci_Seq($uI(e.buttons)), $uD(e.width), $uD(e.height), $uD(e.pressure), $m_Lreactbuild_common_components_Input$ModifierKey$().from__Lorg_scalajs_dom_ModifierKeyEvent__Lreactbuild_common_components_Input$ModifierKey(e.nativeEvent), $uD(e.timeStamp))
  })))
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.mouseHandler__Lreactbuild_common_components_Input$MouseWay__Ljapgolly_scalajs_react_facade_SyntheticMouseEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(way, e) {
  return this.process__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline(e, new $c_sjsr_AnonFunction1(((svg$2) => {
    var x = $m_Lreactbuild_common_components_Input$Start$();
    if ((x === way)) {
      var $$x1 = true
    } else {
      var x$3 = $m_Lreactbuild_common_components_Input$End$();
      var $$x1 = (x$3 === way)
    };
    if ($$x1) {
      var changedButton = $m_Lreactbuild_common_components_Input$MouseButton$().fromOne__I__Lreactbuild_common_components_Input$MouseButton($uI(e.button))
    } else {
      var changedButton = $m_Lreactbuild_common_components_Input$DontKnow$()
    };
    return new $c_Lreactbuild_common_components_Input$MouseEvent(way, $m_Lreactbuild_common_components_InteractionController$().position__Lreactbuild_common_components_HasClientPosition__Lreactbuild_common_components_Input$CursorType__Lorg_scalajs_dom_Node__Lreactbuild_common_components_Input$Coords(e, $m_Lreactbuild_common_components_Input$Mouse$(), svg$2), changedButton, $m_Lreactbuild_common_components_Input$MouseButton$().fromMultiple__I__sci_Seq($uI(e.buttons)), $m_Lreactbuild_common_components_Input$ModifierKey$().from__Lorg_scalajs_dom_ModifierKeyEvent__Lreactbuild_common_components_Input$ModifierKey(e.nativeEvent), $uD(e.timeStamp))
  })))
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.keyboardHandler__Lreactbuild_common_components_Input$KeyboardWay__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(way, e) {
  return this.process__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline(e, new $c_sjsr_AnonFunction1(((svg$2) => new $c_Lreactbuild_common_components_Input$KeyboardEvent(way, $uI(e.charCode), $uI(e.keyCode), $m_Lreactbuild_common_components_Input$ModifierKey$().from__Lorg_scalajs_dom_ModifierKeyEvent__Lreactbuild_common_components_Input$ModifierKey(e.nativeEvent), $m_Lreactbuild_common_components_Input$KeyboardLocation$().from__D__Lreactbuild_common_components_Input$KeyboardLocation($uD(e.location)), $uD(e.timeStamp)))))
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.wheelHandler__Ljapgolly_scalajs_react_facade_SyntheticWheelEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(e) {
  return this.process__Ljapgolly_scalajs_react_facade_SyntheticEvent__F1__Ljapgolly_scalajs_react_callback_Trampoline(e, new $c_sjsr_AnonFunction1(((svg$2) => new $c_Lreactbuild_common_components_Input$WheelEvent($m_Lreactbuild_common_components_InteractionController$().position__Lreactbuild_common_components_HasClientPosition__Lreactbuild_common_components_Input$CursorType__Lorg_scalajs_dom_Node__Lreactbuild_common_components_Input$Coords(e, $m_Lreactbuild_common_components_Input$Mouse$(), svg$2), $uD(e.deltaX), $uD(e.deltaY), $uD(e.deltaZ), $doubleToInt($uD(e.deltaMode)), $uD(e.timeStamp)))))
});
$c_Lreactbuild_common_components_InteractionController$TypedBackend.prototype.render__Lreactbuild_common_components_InteractionController$TypedProps__Lreactbuild_common_components_InteractionController$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x1 = $n($n($n(p).Lreactbuild_common_components_InteractionController$TypedProps__f_tagOf).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(this.Lreactbuild_common_components_InteractionController$TypedBackend__f_eventHandlers));
  var r = this.Lreactbuild_common_components_InteractionController$TypedBackend__f_ref;
  return $n($$x1).withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf(new $c_s_Some(r))
});
function $as_Lreactbuild_common_components_InteractionController$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_InteractionController$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.InteractionController$TypedBackend"))
}
function $isArrayOf_Lreactbuild_common_components_InteractionController$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_InteractionController$TypedBackend)))
}
function $asArrayOf_Lreactbuild_common_components_InteractionController$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_InteractionController$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.InteractionController$TypedBackend;", depth))
}
function $p_Lreactbuild_common_services_AjaxClient__strip__sci_Seq__sci_Seq__sci_Seq__sci_Seq($thiz, in$1, done, toStrip) {
  while (true) {
    var x1 = in$1;
    if ((x1 !== null)) {
      $n($m_s_package$().s_package$__f_Seq);
      if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x1), true) && ($n(x1).lengthCompare__I__I(0) === 0))) {
        return done
      }
    };
    var x1$2 = $n(toStrip).collectFirst__s_PartialFunction__s_Option(new $c_Lreactbuild_common_services_AjaxClient$$anonfun$1($thiz, x1));
    if ((x1$2 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x1$2);
      var stripping = $as_sci_Seq($n(x2).s_Some__f_value);
      var temp$in = $as_sci_Seq($n(in$1).drop__I__O($n(stripping).length__I()));
      var temp$toStrip = $as_sci_Seq($n(toStrip).filter__F1__O(new $c_sjsr_AnonFunction1(((stripping) => ((x$1$2) => {
        var x$1 = $as_sci_Seq(x$1$2);
        return (!((x$1 === null) ? (stripping === null) : $n(x$1).equals__O__Z(stripping)))
      }))(stripping))));
      in$1 = temp$in;
      toStrip = temp$toStrip
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        var temp$in$2 = $as_sci_Seq($n(in$1).tail__O());
        var this$6 = $n(done);
        var elem = $n(in$1).head__O();
        var temp$done = $as_sci_Seq(this$6.appended__O__O(elem));
        in$1 = temp$in$2;
        done = temp$done
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  }
}
/** @constructor */
function $c_Lreactbuild_common_services_AjaxClient() {
  /*<skip>*/
}
$c_Lreactbuild_common_services_AjaxClient.prototype = new $h_O();
$c_Lreactbuild_common_services_AjaxClient.prototype.constructor = $c_Lreactbuild_common_services_AjaxClient;
/** @constructor */
function $h_Lreactbuild_common_services_AjaxClient() {
  /*<skip>*/
}
$h_Lreactbuild_common_services_AjaxClient.prototype = $c_Lreactbuild_common_services_AjaxClient.prototype;
$c_Lreactbuild_common_services_AjaxClient.prototype.doCall__Lautowire_Core$Request__s_concurrent_Future = (function(req) {
  var stripped = $p_Lreactbuild_common_services_AjaxClient__strip__sci_Seq__sci_Seq__sci_Seq__sci_Seq(this, $n(req).Lautowire_Core$Request__f_path, $m_s_package$().s_package$__f_Nil, this.Lreactbuild_analyze_cost_services_AjaxClient$__f_strip);
  var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
  var $$x1 = fetch;
  var this$1 = $n(stripped);
  var a = ("/api/" + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", "/", ""));
  var p = $$x1(a, (() => {
    var outer = null;
    var req$1 = null;
    outer = this;
    req$1 = req;
    var this$5 = {};
    new Headers().append("Content-Type", "application/json");
    var a$1 = (void 0);
    this$5.headers = a$1;
    var this$9 = $n($m_Lio_circe_Json$().fromFields__sc_Iterable__Lio_circe_Json($n(req$1).Lautowire_Core$Request__f_args));
    var a$2 = $n($m_Lio_circe_Printer$().Lio_circe_Printer$__f_spaces2).print__Lio_circe_Json__T(this$9);
    this$5.body = a$2;
    var a$3 = $m_Lorg_scalajs_dom_HttpMethod$().Lorg_scalajs_dom_HttpMethod$__f_POST;
    this$5.method = a$3;
    var a$4 = $m_Lorg_scalajs_dom_RequestCache$().Lorg_scalajs_dom_RequestCache$__f_no$minusstore;
    this$5.cache = a$4;
    var a$5 = $m_Lorg_scalajs_dom_RequestCredentials$().Lorg_scalajs_dom_RequestCredentials$__f_include;
    this$5.credentials = a$5;
    return this$5
  })());
  return $n($n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((response$2) => {
    var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
    var p$1 = response$2.text();
    return $n($n($$x3).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((responseText$2) => {
      var responseText = $as_T(responseText$2);
      if (($uI(response$2.status) === 401)) {
        var this$26 = $m_Lreactbuild_analyze_cost_services_AppCircuit$();
        var action = $m_Lreactbuild_common_actions_NotConnected$();
        var evidence$6 = $m_Ldiode_Action$aType$();
        $f_Ldiode_Circuit__dispatch__O__Ldiode_ActionType__V(this$26, action, evidence$6);
        var $$x4 = $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_Exception__T__(new $c_jl_Exception(), "Unauthorized"))
      } else if (((($uI(response$2.status) >= 200) && ($uI(response$2.status) < 300)) || ($uI(response$2.status) === 304))) {
        var $$x6 = $m_s_concurrent_Future$();
        var this$27 = $n($m_Lio_circe_parser_package$().parse__T__s_util_Either(responseText));
        var this$28 = new $c_s_util_Either$LeftProjection(this$27);
        var x1 = this$28.s_util_Either$LeftProjection__f_e;
        if ((x1 instanceof $c_s_util_Left)) {
          var x2 = $as_s_util_Left(x1);
          var a$6 = $n(x2).s_util_Left__f_value;
          var e = $as_Lio_circe_ParsingFailure(a$6);
          var $$x5 = new $c_s_util_Left($ct_jl_Exception__T__jl_Throwable__(new $c_jl_Exception(), ("JSON parse " + responseText), e))
        } else {
          var $$x5 = this$28.s_util_Either$LeftProjection__f_e
        };
        var this$29 = $m_s_$less$colon$less$();
        var $$x4 = $n($$x6).fromTry__s_util_Try__s_concurrent_Future($n($$x5).toTry__s_$less$colon$less__s_util_Try(this$29.s_$less$colon$less$__f_singleton))
      } else {
        var $$x4 = $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_Exception__T__(new $c_jl_Exception(), ("Not allowed status " + $uI(response$2.status))))
      };
      return $n($$x4).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((parsed$2) => {
        var parsed = $as_Lio_circe_Json(parsed$2);
        return parsed
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
$c_Lreactbuild_common_services_AjaxClient.prototype.read__Lio_circe_Json__Lio_circe_Decoder__O = (function(p, evidence$1) {
  var this$1 = $n(p);
  var e = $n(evidence$1).apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(this$1, null, null));
  var this$3 = $n(e);
  if ((this$3 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$3);
    var b = $n(x2).s_util_Right__f_value;
    return b
  } else if ((this$3 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(this$3);
    var a = $n(x3).s_util_Left__f_value;
    var x$2 = $as_Lio_circe_DecodingFailure(a);
    throw $n(x$2)
  } else {
    throw new $c_s_MatchError(this$3)
  }
});
$c_Lreactbuild_common_services_AjaxClient.prototype.write__O__Lio_circe_Encoder__Lio_circe_Json = (function(r, evidence$2) {
  return $n(evidence$2).apply__O__Lio_circe_Json(r)
});
/** @constructor */
function $c_Lreactbuild_format_dxf_CoproductDecoder$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_CoproductDecoder$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_CoproductDecoder$.prototype.constructor = $c_Lreactbuild_format_dxf_CoproductDecoder$;
/** @constructor */
function $h_Lreactbuild_format_dxf_CoproductDecoder$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_CoproductDecoder$.prototype = $c_Lreactbuild_format_dxf_CoproductDecoder$.prototype;
var $d_Lreactbuild_format_dxf_CoproductDecoder$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_CoproductDecoder$: 0
}, false, "reactbuild.format.dxf.CoproductDecoder$", {
  Lreactbuild_format_dxf_CoproductDecoder$: 1,
  O: 1,
  Lreactbuild_format_dxf_CoproductDecoderInstances: 1,
  Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances: 1
});
$c_Lreactbuild_format_dxf_CoproductDecoder$.prototype.$classData = $d_Lreactbuild_format_dxf_CoproductDecoder$;
var $n_Lreactbuild_format_dxf_CoproductDecoder$;
function $m_Lreactbuild_format_dxf_CoproductDecoder$() {
  if ((!$n_Lreactbuild_format_dxf_CoproductDecoder$)) {
    $n_Lreactbuild_format_dxf_CoproductDecoder$ = new $c_Lreactbuild_format_dxf_CoproductDecoder$()
  };
  return $n_Lreactbuild_format_dxf_CoproductDecoder$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13(outer) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13.prototype = new $h_O();
$c_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13.prototype.constructor = $c_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13;
/** @constructor */
function $h_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13.prototype = $c_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13.prototype;
$c_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(c) {
  return new $c_s_util_Left($m_s_Predef$().$qmark$qmark$qmark__E())
});
var $d_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13 = new $TypeData().initClass({
  Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13: 0
}, false, "reactbuild.format.dxf.CoproductDecoderInstances$$anon$13", {
  Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13: 1,
  O: 1,
  Lreactbuild_format_dxf_CoproductDecoder: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13.prototype.$classData = $d_Lreactbuild_format_dxf_CoproductDecoderInstances$$anon$13;
/** @constructor */
function $c_Lreactbuild_format_dxf_CoproductEncoder$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_CoproductEncoder$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_CoproductEncoder$.prototype.constructor = $c_Lreactbuild_format_dxf_CoproductEncoder$;
/** @constructor */
function $h_Lreactbuild_format_dxf_CoproductEncoder$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_CoproductEncoder$.prototype = $c_Lreactbuild_format_dxf_CoproductEncoder$.prototype;
var $d_Lreactbuild_format_dxf_CoproductEncoder$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_CoproductEncoder$: 0
}, false, "reactbuild.format.dxf.CoproductEncoder$", {
  Lreactbuild_format_dxf_CoproductEncoder$: 1,
  O: 1,
  Lreactbuild_format_dxf_CoproductEncoderInstances: 1,
  Lreactbuild_format_dxf_LowPriorityImplicitsCoproductEncoderInstances: 1
});
$c_Lreactbuild_format_dxf_CoproductEncoder$.prototype.$classData = $d_Lreactbuild_format_dxf_CoproductEncoder$;
var $n_Lreactbuild_format_dxf_CoproductEncoder$;
function $m_Lreactbuild_format_dxf_CoproductEncoder$() {
  if ((!$n_Lreactbuild_format_dxf_CoproductEncoder$)) {
    $n_Lreactbuild_format_dxf_CoproductEncoder$ = new $c_Lreactbuild_format_dxf_CoproductEncoder$()
  };
  return $n_Lreactbuild_format_dxf_CoproductEncoder$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10(outer) {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10.prototype = new $h_O();
$c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10.prototype.constructor = $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10;
/** @constructor */
function $h_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10.prototype = $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10.prototype;
var $d_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10 = new $TypeData().initClass({
  Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10: 0
}, false, "reactbuild.format.dxf.CoproductEncoderInstances$$anon$10", {
  Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10: 1,
  O: 1,
  Lreactbuild_format_dxf_CoproductEncoder: 1,
  Lreactbuild_format_dxf_Encoder: 1
});
$c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10.prototype.$classData = $d_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$10;
/** @constructor */
function $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11(outer, witK$2, encodeV$3, config$1, encodeR$2) {
  $n($as_s_Symbol($n(witK$2).value__O()))
}
$c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11.prototype = new $h_O();
$c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11.prototype.constructor = $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11;
/** @constructor */
function $h_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11.prototype = $c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11.prototype;
var $d_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11 = new $TypeData().initClass({
  Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11: 0
}, false, "reactbuild.format.dxf.CoproductEncoderInstances$$anon$11", {
  Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11: 1,
  O: 1,
  Lreactbuild_format_dxf_CoproductEncoder: 1,
  Lreactbuild_format_dxf_Encoder: 1
});
$c_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11.prototype.$classData = $d_Lreactbuild_format_dxf_CoproductEncoderInstances$$anon$11;
/** @constructor */
function $c_Lreactbuild_format_dxf_Decoder$$anon$17(decodeA$2) {
  this.Lreactbuild_format_dxf_SeqDecoder__f_decodeA = null;
  $ct_Lreactbuild_format_dxf_SeqDecoder__Lreactbuild_format_dxf_Decoder__(this, decodeA$2)
}
$c_Lreactbuild_format_dxf_Decoder$$anon$17.prototype = new $h_Lreactbuild_format_dxf_SeqDecoder();
$c_Lreactbuild_format_dxf_Decoder$$anon$17.prototype.constructor = $c_Lreactbuild_format_dxf_Decoder$$anon$17;
/** @constructor */
function $h_Lreactbuild_format_dxf_Decoder$$anon$17() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Decoder$$anon$17.prototype = $c_Lreactbuild_format_dxf_Decoder$$anon$17.prototype;
var $d_Lreactbuild_format_dxf_Decoder$$anon$17 = new $TypeData().initClass({
  Lreactbuild_format_dxf_Decoder$$anon$17: 0
}, false, "reactbuild.format.dxf.Decoder$$anon$17", {
  Lreactbuild_format_dxf_Decoder$$anon$17: 1,
  Lreactbuild_format_dxf_SeqDecoder: 1,
  O: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_Decoder$$anon$17.prototype.$classData = $d_Lreactbuild_format_dxf_Decoder$$anon$17;
/** @constructor */
function $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12(outer, witK$1, decodeV$3, decodeR$1) {
  this.Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12__f_decodeV$3 = null;
  this.Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12__f_decodeR$1 = null;
  this.Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12__f_decodeV$3 = decodeV$3;
  this.Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12__f_decodeR$1 = decodeR$1;
  $n($as_s_Symbol($n(witK$1).value__O()))
}
$c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12.prototype.constructor = $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12;
/** @constructor */
function $h_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12.prototype = $c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12.prototype;
$c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12.prototype.apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either = (function(a) {
  var x1 = $n(this.Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12__f_decodeV$3).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either(a);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var v = $as_Lreactbuild_format_dxf_CursorResult($n(x2).s_util_Right__f_value);
    var this$1 = $n(v);
    var arg1 = this$1.Lreactbuild_format_dxf_CursorResult__f_value;
    return new $c_s_util_Right(new $c_Lreactbuild_format_dxf_CursorResult(new $c_Lshapeless_Inl((new $c_Lshapeless_labelled$FieldBuilder(), arg1)), this$1.Lreactbuild_format_dxf_CursorResult__f_c))
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    var x1$2 = $n(this.Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12__f_decodeR$1).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either(a);
    if ((x1$2 instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(x1$2);
      var v$2 = $as_Lreactbuild_format_dxf_CursorResult($n(x2$2).s_util_Right__f_value);
      var this$4 = $n(v$2);
      var arg1$1 = this$4.Lreactbuild_format_dxf_CursorResult__f_value;
      var x$1 = $as_Lshapeless_Coproduct(arg1$1);
      return new $c_s_util_Right(new $c_Lreactbuild_format_dxf_CursorResult(new $c_Lshapeless_Inr(x$1), this$4.Lreactbuild_format_dxf_CursorResult__f_c))
    } else {
      return x3
    }
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12 = new $TypeData().initClass({
  Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12: 0
}, false, "reactbuild.format.dxf.LowPriorityImplicitsCoproductDecoderInstances$$anon$12", {
  Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12: 1,
  O: 1,
  Lreactbuild_format_dxf_CoproductDecoder: 1,
  Lreactbuild_format_dxf_Decoder: 1
});
$c_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12.prototype.$classData = $d_Lreactbuild_format_dxf_LowPriorityImplicitsCoproductDecoderInstances$$anon$12;
function $ct_Lreactbuild_model_BaseRefToResolver__($thiz) {
  $thiz.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = new $c_Lreactbuild_model_BaseRefToResolver$$anon$1($thiz);
  $n($m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_Tokenizer);
  var f = new $c_sjsr_AnonFunction1(((in$2) => $thiz.getTitle__O__T(in$2)));
  var underlying = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  $thiz.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_Tokenizer$$anon$1(underlying, f);
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_model_BaseRefToResolver() {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null
}
$c_Lreactbuild_model_BaseRefToResolver.prototype = new $h_O();
$c_Lreactbuild_model_BaseRefToResolver.prototype.constructor = $c_Lreactbuild_model_BaseRefToResolver;
/** @constructor */
function $h_Lreactbuild_model_BaseRefToResolver() {
  /*<skip>*/
}
$h_Lreactbuild_model_BaseRefToResolver.prototype = $c_Lreactbuild_model_BaseRefToResolver.prototype;
$c_Lreactbuild_model_BaseRefToResolver.prototype.stringify__Lreactbuild_common_model_RefTo__s_concurrent_Future = (function(ref) {
  var this$1 = $n(this.allItems__sci_List());
  _return: {
    var these = this$1;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x = this.getRef__O__Lreactbuild_common_model_RefTo(arg1);
      if (((x === null) ? (ref === null) : $n(x).equals__O__Z(ref))) {
        var this$2 = new $c_s_Some($n(these).head__O());
        break _return
      };
      these = $as_sci_List($n(these).tail__O())
    };
    var this$2 = $m_s_None$()
  };
  if (this$2.isEmpty__Z()) {
    var x1 = $m_s_None$()
  } else {
    var arg1$1 = this$2.get__O();
    var x1 = new $c_s_Some(this.getTitle__O__T(arg1$1))
  };
  var x$1 = $m_s_None$();
  if ((x$1 === x1)) {
    return $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ("non trouv\u00e9 : " + ref)))
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var s = $as_T($n(x3).s_Some__f_value);
    return $m_s_concurrent_Future$().successful__O__s_concurrent_Future(s)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lreactbuild_model_BaseRefToResolver.prototype.parse__T__s_concurrent_Future = (function(in$1) {
  return $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ("Can not parse : " + in$1)))
});
$c_Lreactbuild_model_BaseRefToResolver.prototype.handleNonexistent__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_T(in$2);
    var this$2 = $n($f_T__trim__T($n(in$1)));
    if ((this$2 === "")) {
      return $m_s_None$()
    } else {
      return this.createItem__T__s_Option(in$1)
    }
  }))
});
$c_Lreactbuild_model_BaseRefToResolver.prototype.keyOf__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$2$2) => $n($n(this.getRef__O__Lreactbuild_common_model_RefTo(x$2$2)).Lreactbuild_common_model_RefTo__f_id).toString__T()))
});
$c_Lreactbuild_model_BaseRefToResolver.prototype.renderContainer__T__Z__Lcom_iz2use_react_components_internal_TextEditorContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(text, open, context) {
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  var context$1 = $n(context).contramap__F1__Lcom_iz2use_react_components_internal_TextEditorContext(new $c_sjsr_AnonFunction1(((in$2) => this.getRef__O__Lreactbuild_common_model_RefTo(in$2))));
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  var focusHandler = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2();
  var fetcher = this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher;
  var fetcherBackend = $m_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$();
  var filter = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
  var keyOf = this.keyOf__F1();
  var this$4 = $m_s_math_Equiv$();
  var equiv = this$4.universal__s_math_Equiv();
  var handleNonexistent = this.handleNonexistent__F1();
  var tokenMatcher = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
  var tokenizer = this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer;
  var h = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1();
  var highlighter = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3(h);
  var u = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder(text, open, context$1, focusHandler, fetcher, fetcherBackend, filter, keyOf, equiv, handleNonexistent, tokenMatcher, tokenizer, highlighter).apply__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction2(((i$2, v$2) => {
    var v = $as_sci_Seq(v$2);
    return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), v)
  })));
  var this$11 = $n(u);
  var n = this$11.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_model_BaseRefToResolver.prototype.stringify__O__s_concurrent_Future = (function(in$1) {
  return this.stringify__Lreactbuild_common_model_RefTo__s_concurrent_Future($as_Lreactbuild_common_model_RefTo(in$1))
});
function $p_Lreactbuild_model_Implicits$__loop$1__I__I__I__scm_StringBuilder__I__T__T($thiz, i, last, startOfDigits, builder, len$1, text$1) {
  while (true) {
    if ((i < len$1)) {
      var this$1 = $n(text$1);
      var index = i;
      var c = $charAt(this$1, index);
      var isDigit = ((c >= 48) && (c <= 57))
    } else {
      var isDigit = false
    };
    if (((last !== (-1)) && ((isDigit && (startOfDigits === (-1))) || (i >= len$1)))) {
      var $$x1 = $n(builder);
      var this$2 = $n(text$1);
      var beginIndex = last;
      var endIndex = i;
      if ((beginIndex < 0)) {
        $charAt(this$2, beginIndex)
      };
      if ((endIndex > this$2.length)) {
        $charAt(this$2, endIndex)
      };
      if ((endIndex < beginIndex)) {
        $charAt(this$2, (-1))
      };
      $n($$x1).append__T__scm_StringBuilder($as_T(this$2.substring(beginIndex, endIndex)))
    };
    if (((!isDigit) && (startOfDigits !== (-1)))) {
      $m_sc_StringOps$();
      var this$3 = $n(text$1);
      var beginIndex$1 = startOfDigits;
      var endIndex$1 = i;
      if ((beginIndex$1 < 0)) {
        $charAt(this$3, beginIndex$1)
      };
      if ((endIndex$1 > this$3.length)) {
        $charAt(this$3, endIndex$1)
      };
      if ((endIndex$1 < beginIndex$1)) {
        $charAt(this$3, (-1))
      };
      var x = $as_T(this$3.substring(beginIndex$1, endIndex$1));
      $m_sc_StringOps$();
      $m_sc_StringOps$();
      var from = 0;
      _return: {
        var this$7 = $n(x);
        var len = this$7.length;
        var i$1 = from;
        while ((i$1 < len)) {
          var this$8 = $n(x);
          var index$1 = i$1;
          var arg1 = $charAt(this$8, index$1);
          if ((arg1 !== 48)) {
            var x1 = i$1;
            break _return
          };
          i$1 = ((1 + i$1) | 0)
        };
        var x1 = (-1)
      };
      if ((x1 === (-1))) {
        var sub = ""
      } else {
        var this$9 = $n(x);
        if (((x1 < 0) || (x1 > this$9.length))) {
          $charAt(this$9, x1)
        };
        var sub = $as_T(this$9.substring(x1))
      };
      var this$10 = $n(sub);
      if ((this$10.length < 8)) {
        var $$x3 = $n(builder);
        var $$x2 = $m_sc_StringOps$();
        var this$12 = $n(sub);
        $n($$x3).append__T__scm_StringBuilder($n($$x2).$times$extension__T__I__T("0", ((8 - this$12.length) | 0)))
      };
      $n(builder).append__T__scm_StringBuilder(sub)
    };
    if ((i < len$1)) {
      if (isDigit) {
        var temp$i = ((1 + i) | 0);
        var temp$startOfDigits = ((startOfDigits === (-1)) ? i : startOfDigits);
        i = temp$i;
        last = (-1);
        startOfDigits = temp$startOfDigits
      } else {
        var temp$i$2 = ((1 + i) | 0);
        var temp$last$2 = ((last === (-1)) ? i : last);
        i = temp$i$2;
        last = temp$last$2;
        startOfDigits = (-1)
      }
    } else {
      var this$13 = $n(builder);
      return $n(this$13.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
    }
  }
}
/** @constructor */
function $c_Lreactbuild_model_Implicits$() {
  this.Lreactbuild_model_Implicits$__f_dateFormat = null;
  this.Lreactbuild_model_Implicits$__f_dateOrdering = null;
  this.Lreactbuild_model_Implicits$__f_dateTextualizable = null;
  this.Lreactbuild_model_Implicits$__f_durationDefault = null;
  this.Lreactbuild_model_Implicits$__f_duration = null;
  this.Lreactbuild_model_Implicits$__f_localDateFormat = null;
  this.Lreactbuild_model_Implicits$__f_localDateTimeOrdering = null;
  this.Lreactbuild_model_Implicits$__f_priceFormat = null;
  this.Lreactbuild_model_Implicits$__f_priceOrdering = null;
  this.Lreactbuild_model_Implicits$__f_priceParsable = null;
  this.Lreactbuild_model_Implicits$__f_paymentTermAndConditionsParsable = null;
  this.Lreactbuild_model_Implicits$__f_parsableLocalTime = null;
  this.Lreactbuild_model_Implicits$__f_textualizableJDuration = null;
  this.Lreactbuild_model_Implicits$__f_keyMapperInvoiceDetail = null;
  this.Lreactbuild_model_Implicits$__f_dateTimePattern = null;
  this.Lreactbuild_model_Implicits$__f_localDateOrdering = null;
  this.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryMap = null;
  this.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryFromName = null;
  this.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryList = null;
  this.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryIndex = null;
  this.Lreactbuild_model_Implicits$__f_documentCategoryOrdering = null;
  this.Lreactbuild_model_Implicits$__f_documentCategoryFormat = null;
  this.Lreactbuild_model_Implicits$__f_parsableDocumentCategory = null;
  this.Lreactbuild_model_Implicits$__f_documentCategoryResolver = null;
  this.Lreactbuild_model_Implicits$__f_documentCategoryHelper = null;
  this.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderMap = null;
  this.Lreactbuild_model_Implicits$__f_reconciliationReportDefault = null;
  this.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportFromName = null;
  this.Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderList = null;
  this.Lreactbuild_model_Implicits$__f_reconciliationReportOrderResolver = null;
  this.Lreactbuild_model_Implicits$__f_reconciliationReportOrderHelper = null;
  this.Lreactbuild_model_Implicits$__f_supplierGroupResolver = null;
  this.Lreactbuild_model_Implicits$__f_supplierGroupOrdering = null;
  this.Lreactbuild_model_Implicits$__f_supplierGroupHelper = null;
  this.Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsFormat = null;
  this.Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsSeqOrdering = null;
  $n_Lreactbuild_model_Implicits$ = this;
  $f_Lreactbuild_model_LowPriorityImplicits__$init$__V(this);
  $m_sc_StringOps$();
  $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([0-9]{1,2})([/.-])([0-9]{1,2})\\2([0-9]{1,4})", $m_sci_Nil$());
  $m_sc_StringOps$();
  $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "([0-9]{2})([0-9]{2})([0-9]{4}|[0-9]{2}|)", $m_sci_Nil$());
  $n($m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_Format);
  var format = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
  var this$6 = $n(format);
  this.Lreactbuild_model_Implicits$__f_dateFormat = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(this$6);
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((x$41$2) => {
    var x$41 = $as_Lreactbuild_common_model_Date(x$41$2);
    return $n(x$41).Lreactbuild_common_model_Date__f_value
  }));
  var ord = $m_s_math_Ordering$Long$();
  this.Lreactbuild_model_Implicits$__f_dateOrdering = new $c_s_math_Ordering$$anon$5(ord, f);
  $m_Lcom_iz2use_common_Textualizable$();
  var f$1 = new $c_sjsr_AnonFunction1(((x$42$2) => {
    var x$42 = $as_Lreactbuild_common_model_Date(x$42$2);
    return $n(x$42).toLocalDate__Ljava_time_LocalDate()
  }));
  var ev = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var this$10 = $n(ev);
  this.Lreactbuild_model_Implicits$__f_dateTextualizable = new $c_Lcom_iz2use_common_Textualizable$$anon$1(this$10, f$1);
  this.Lreactbuild_model_Implicits$__f_durationDefault = new $c_Lreactbuild_model_Implicits$$anon$23();
  $n($m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_Format);
  var format$1 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
  var this$12 = $n(format$1);
  new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(this$12);
  $m_sc_StringOps$();
  $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^([0-9]+(?:\\.[0-9]*)?|\\.[0-9]+)[ \t]*h?$", $m_sci_Nil$());
  this.Lreactbuild_model_Implicits$__f_duration = new $c_Lreactbuild_model_Implicits$$anon$24();
  $n($m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_Format);
  var format$2 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
  var this$16 = $n(format$2);
  this.Lreactbuild_model_Implicits$__f_localDateFormat = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(this$16);
  var this$19 = $n($m_s_package$().s_package$__f_Ordering);
  var this$18 = $m_s_$less$colon$less$();
  var asComparable = this$18.s_$less$colon$less$__f_singleton;
  this.Lreactbuild_model_Implicits$__f_localDateTimeOrdering = new $c_s_math_LowPriorityOrderingImplicits$$anon$2(this$19, asComparable);
  $n($m_Lcom_iz2use_react_components_Multiview$().Lcom_iz2use_react_components_Multiview$__f_Format);
  var format$3 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_double;
  var this$21 = $n(format$3);
  this.Lreactbuild_model_Implicits$__f_priceFormat = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$1(this$21);
  $n($m_s_package$().s_package$__f_Ordering);
  var f$2 = new $c_sjsr_AnonFunction1(((x$46$2) => {
    var x$46 = $as_Lreactbuild_model_Price(x$46$2);
    return $n(x$46).Lreactbuild_model_Price__f_amount
  }));
  var ord$1 = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  this.Lreactbuild_model_Implicits$__f_priceOrdering = new $c_s_math_Ordering$$anon$5(ord$1, f$2);
  this.Lreactbuild_model_Implicits$__f_priceParsable = new $c_Lreactbuild_model_Implicits$$anon$25();
  var f$3 = new $c_sjsr_AnonFunction1(((details$2) => {
    var details = $as_sci_List(details$2);
    var this$23 = $n(details);
    var rest = this$23;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var x$48 = $as_Lreactbuild_model_InvoiceDetail(arg1);
      var this$24 = $n($n(x$48).Lreactbuild_model_InvoiceDetail__f_amount);
      if (this$24.isEmpty__Z()) {
        var $$x1 = $m_s_None$()
      } else {
        var arg1$1 = this$24.get__O();
        var x$49 = $as_Lreactbuild_model_Price(arg1$1);
        var $$x1 = new $c_s_Some($n(x$49).Lreactbuild_model_Price__f_amount)
      };
      var it = $n($$x1).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx
        } else {
          $n(t).sci_$colon$colon__f_next = nx
        };
        t = nx
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    var this$25 = $n(((h === null) ? $m_sci_Nil$() : h));
    var num = $m_s_math_Numeric$DoubleIsFractional$();
    return new $c_Lreactbuild_model_Price($uD($f_sc_IterableOnceOps__sum__s_math_Numeric__O(this$25, num)))
  }));
  var textualizable = this.Lreactbuild_model_Implicits$__f_priceParsable;
  var viewable = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable);
  new $c_Lcom_iz2use_react_components_Viewable$$anon$2(viewable, f$3);
  this.Lreactbuild_model_Implicits$__f_paymentTermAndConditionsParsable = new $c_Lreactbuild_model_Implicits$$anon$26();
  this.Lreactbuild_model_Implicits$__f_parsableLocalTime = new $c_Lreactbuild_model_Implicits$$anon$27();
  $m_Lcom_iz2use_common_Textualizable$();
  var f$4 = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljava_time_Duration(x$2);
    var t$1 = $n(x).toMinutes__J();
    var lo = t$1.RTLong__f_lo;
    var hi = t$1.RTLong__f_hi;
    var $$x3 = $m_sc_StringOps$();
    var this$28 = $m_RTLong$();
    var lo$1 = this$28.divideImpl__I__I__I__I__I(lo, hi, 60, 0);
    var hi$1 = this$28.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $$x2 = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo$1, hi$1);
    var this$29 = $m_RTLong$();
    var lo$2 = this$29.remainderImpl__I__I__I__I__I(lo, hi, 60, 0);
    var hi$2 = this$29.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var array = [$$x2, $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo$2, hi$2)];
    return $n($$x3).format$extension__T__sci_Seq__T("%02.0fh%02.0f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  this.Lreactbuild_model_Implicits$__f_textualizableJDuration = new $c_Lcom_iz2use_common_Textualizable$$anon$2(f$4);
  $m_Lcom_iz2use_common_KeyMapper$();
  var f$5 = new $c_sjsr_AnonFunction1(((x$63$2) => {
    var x$63 = $as_Lreactbuild_model_InvoiceDetail(x$63$2);
    return $n(x$63).Lreactbuild_model_InvoiceDetail__f_id
  }));
  var ev$1 = $m_Lcom_iz2use_common_KeyMapper$().Lcom_iz2use_common_KeyMapper$__f_fromUUID;
  this.Lreactbuild_model_Implicits$__f_keyMapperInvoiceDetail = new $c_Lcom_iz2use_common_KeyMapper$$anon$3(ev$1, f$5)
}
$c_Lreactbuild_model_Implicits$.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$.prototype.constructor = $c_Lreactbuild_model_Implicits$;
/** @constructor */
function $h_Lreactbuild_model_Implicits$() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$.prototype = $c_Lreactbuild_model_Implicits$.prototype;
$c_Lreactbuild_model_Implicits$.prototype.dateParsable__Lcom_iz2use_common_ParsingReference__Lcom_iz2use_common_Parsable = (function(reference) {
  $m_Lcom_iz2use_common_Parsable$();
  var reference$1 = new $c_Lreactbuild_model_Implicits$$$Lambda$1((() => $n($as_Lreactbuild_common_model_Date($n(reference).apply__O())).toLocalDate__Ljava_time_LocalDate()));
  var this$4 = new $c_Lcom_iz2use_common_Parsable$$anon$4(reference$1);
  var f = new $c_sjsr_AnonFunction1(((d$2) => {
    var d = $as_Ljava_time_LocalDate(d$2);
    return $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Date).fromLocalDate__Ljava_time_LocalDate__Lreactbuild_common_model_Date(d)
  }));
  var g = new $c_sjsr_AnonFunction1(((x$43$2) => {
    var x$43 = $as_Lreactbuild_common_model_Date(x$43$2);
    return $n(x$43).toLocalDate__Ljava_time_LocalDate()
  }));
  return new $c_Lcom_iz2use_common_Parsable$$anon$1(this$4, f, g)
});
$c_Lreactbuild_model_Implicits$.prototype.transformNumericToLargeNumeric__T__T = (function(text) {
  var this$1 = $n(text);
  var len = this$1.length;
  return $p_Lreactbuild_model_Implicits$__loop$1__I__I__I__scm_StringBuilder__I__T__T(this, 0, (-1), (-1), ($n($m_s_package$().s_package$__f_StringBuilder), $ct_scm_StringBuilder__(new $c_scm_StringBuilder())), len, text)
});
$c_Lreactbuild_model_Implicits$.prototype.buildingStageRefOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering = (function(ev) {
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_common_model_RefTo(v$2);
    return $m_Lreactbuild_model_Implicits$().transformNumericToLargeNumeric__T__T($n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T($n(ev).stringify__O__T(v)))
  }));
  var ord = $m_s_math_Ordering$String$();
  return new $c_s_math_Ordering$$anon$5(ord, f)
});
$c_Lreactbuild_model_Implicits$.prototype.buildingStageOrdering__s_math_Ordering = (function() {
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_model_BuildingStage(v$2);
    return $m_Lreactbuild_model_Implicits$().transformNumericToLargeNumeric__T__T($n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T($n(v).Lreactbuild_model_BuildingStage__f_name))
  }));
  var ord = $m_s_math_Ordering$String$();
  return new $c_s_math_Ordering$$anon$5(ord, f)
});
$c_Lreactbuild_model_Implicits$.prototype.termOrdering__s_math_Ordering = (function() {
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_model_Term(v$2);
    return $m_Lreactbuild_model_Implicits$().transformNumericToLargeNumeric__T__T($n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T($n(v).Lreactbuild_model_Term__f_label))
  }));
  var ord = $m_s_math_Ordering$String$();
  return new $c_s_math_Ordering$$anon$5(ord, f)
});
$c_Lreactbuild_model_Implicits$.prototype.personOrdering__s_math_Ordering = (function() {
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_person_Person(v$2);
    return $n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T($n(v).Lreactbuild_person_Person__f_name)
  }));
  var ord = $m_s_math_Ordering$String$();
  return new $c_s_math_Ordering$$anon$5(ord, f)
});
$c_Lreactbuild_model_Implicits$.prototype.projectOrdering__s_math_Ordering = (function() {
  $n($m_s_package$().s_package$__f_Ordering);
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_common_model_Project(v$2);
    return $ct_T2__O__O__(new $c_T2(), $n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T($n(v).Lreactbuild_common_model_Project__f_reference), $n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T($n(v).Lreactbuild_common_model_Project__f_name))
  }));
  var ord1 = $m_s_math_Ordering$String$();
  var ord2 = $m_s_math_Ordering$String$();
  var ord = new $c_s_math_Ordering$Tuple2Ordering(ord1, ord2);
  return new $c_s_math_Ordering$$anon$5(ord, f)
});
$c_Lreactbuild_model_Implicits$.prototype.reusabilityPotC__F2__F2 = (function(reusableC) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$54$2) => {
    var x$54 = $as_Ldiode_data_Pot(x$54$2);
    var this$2 = $n(x$54);
    return ((!this$2.isEmpty__Z()) ? new $c_s_Some(this$2.get__O()) : $m_s_None$())
  }));
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(reusableC, f)
});
$c_Lreactbuild_model_Implicits$.prototype.reusabilityLocalDate__F2 = (function() {
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$55$2) => {
    var x$55 = $as_Ljava_time_LocalDate(x$55$2);
    return $n(x$55).toEpochDay__J()
  }));
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$3.by_$eq$eq__F2();
  return $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f))
});
$c_Lreactbuild_model_Implicits$.prototype.reusabilityLocalDateTime__F2 = (function() {
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$56$2) => {
    var x$56 = $as_Ljava_time_LocalDateTime(x$56$2);
    return $n(x$56).toEpochSecond__Ljava_time_ZoneOffset__J($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset())
  }));
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$3.by_$eq$eq__F2();
  return $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f))
});
$c_Lreactbuild_model_Implicits$.prototype.reusabilityDate__F2 = (function() {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$57$2) => {
    var x$57 = $as_Lreactbuild_common_model_Date(x$57$2);
    return $n(x$57).Lreactbuild_common_model_Date__f_value
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
});
$c_Lreactbuild_model_Implicits$.prototype.reusabilityRefTo__F2 = (function() {
  var $$x2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().byRef__F2();
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$60$2) => {
    var x$60 = $as_Lreactbuild_common_model_RefTo(x$60$2);
    return $n(x$60).Lreactbuild_common_model_RefTo__f_id
  }));
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$2.by_$eq$eq__F2();
  return $n($$x2).$bar$bar$extension__F2__F2__F2($$x1, $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f))
});
$c_Lreactbuild_model_Implicits$.prototype.reusabilityMultiviewItem__F2__F2 = (function(evT) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((x$61$2) => {
    var x$61 = $as_T2(x$61$2);
    return $n(x$61)._1__O()
  }));
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(evT, f)
});
$c_Lreactbuild_model_Implicits$.prototype.reusabilityMultiviewItemColl__F2__F2 = (function(evT) {
  $m_Ljapgolly_scalajs_react_Reusability$().byIterator__F2__F2(this.reusabilityMultiviewItem__F2__F2(evT));
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  return $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2())
});
$c_Lreactbuild_model_Implicits$.prototype.keyMapperChildWithParent__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_KeyMapper = (function(keyMapperC) {
  $m_Lcom_iz2use_common_KeyMapper$();
  var f = new $c_sjsr_AnonFunction1(((x$62$2) => {
    var x$62 = $as_Lreactbuild_model_ChildWithParent(x$62$2);
    return $n(x$62).Lreactbuild_model_ChildWithParent__f_child
  }));
  return new $c_Lcom_iz2use_common_KeyMapper$$anon$3(keyMapperC, f)
});
var $d_Lreactbuild_model_Implicits$ = new $TypeData().initClass({
  Lreactbuild_model_Implicits$: 0
}, false, "reactbuild.model.Implicits$", {
  Lreactbuild_model_Implicits$: 1,
  O: 1,
  Lreactbuild_common_model_Implicits: 1,
  Lreactbuild_model_LowPriorityImplicits: 1
});
$c_Lreactbuild_model_Implicits$.prototype.$classData = $d_Lreactbuild_model_Implicits$;
var $n_Lreactbuild_model_Implicits$;
function $m_Lreactbuild_model_Implicits$() {
  if ((!$n_Lreactbuild_model_Implicits$)) {
    $n_Lreactbuild_model_Implicits$ = new $c_Lreactbuild_model_Implicits$()
  };
  return $n_Lreactbuild_model_Implicits$
}
/** @constructor */
function $c_Lreactbuild_model_package$() {
  this.Lreactbuild_model_package$__f_config = null;
  this.Lreactbuild_model_package$__f_RefTo = null;
  this.Lreactbuild_model_package$__f_Date = null;
  this.Lreactbuild_model_package$__f_Project = null;
  this.Lreactbuild_model_package$__f_AssetDefinition = null;
  this.Lreactbuild_model_package$__f_ComponentDetails = null;
  $n_Lreactbuild_model_package$ = this;
  $f_Lreactbuild_common_ReferenceToModel__$init$__V(this);
  $f_Lreactbuild_common_CirceExtendedImplicits__$init$__V(this)
}
$c_Lreactbuild_model_package$.prototype = new $h_O();
$c_Lreactbuild_model_package$.prototype.constructor = $c_Lreactbuild_model_package$;
/** @constructor */
function $h_Lreactbuild_model_package$() {
  /*<skip>*/
}
$h_Lreactbuild_model_package$.prototype = $c_Lreactbuild_model_package$.prototype;
$c_Lreactbuild_model_package$.prototype.reactbuild$common$CirceExtendedImplicits$_setter_$config_$eq__Lio_circe_generic_extras_Configuration__V = (function(x$1) {
  this.Lreactbuild_model_package$__f_config = x$1
});
var $d_Lreactbuild_model_package$ = new $TypeData().initClass({
  Lreactbuild_model_package$: 0
}, false, "reactbuild.model.package$", {
  Lreactbuild_model_package$: 1,
  O: 1,
  Lreactbuild_common_ReferenceToModel: 1,
  Lreactbuild_common_CirceExtendedImplicits: 1
});
$c_Lreactbuild_model_package$.prototype.$classData = $d_Lreactbuild_model_package$;
var $n_Lreactbuild_model_package$;
function $m_Lreactbuild_model_package$() {
  if ((!$n_Lreactbuild_model_package$)) {
    $n_Lreactbuild_model_package$ = new $c_Lreactbuild_model_package$()
  };
  return $n_Lreactbuild_model_package$
}
function $f_Lreactbuild_package$MyDev__cssStringRenderer__Lscalacss_internal_Renderer($thiz) {
  return new $c_Lscalacss_internal_StringRenderer$Raw($m_Lscalacss_internal_StringRenderer$().formatPretty__T__T__F1("  ", " "))
}
/** @constructor */
function $c_Lreactbuild_project_Page$Backend(\u03b4) {
  this.Lreactbuild_project_Page$Backend__f_switchPrint = null;
  this.Lreactbuild_project_Page$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_Page$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var this$3 = $n(\u03b4);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_project_Page$State(s$2);
    $n(s);
    var print = (!$n(s).Lreactbuild_project_Page$State__f_print);
    return new $c_Lreactbuild_project_Page$State(print)
  }));
  this.Lreactbuild_project_Page$Backend__f_switchPrint = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
}
$c_Lreactbuild_project_Page$Backend.prototype = new $h_O();
$c_Lreactbuild_project_Page$Backend.prototype.constructor = $c_Lreactbuild_project_Page$Backend;
/** @constructor */
function $h_Lreactbuild_project_Page$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_Page$Backend.prototype = $c_Lreactbuild_project_Page$Backend.prototype;
$c_Lreactbuild_project_Page$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_Page$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_Page$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_Page$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_Page$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_Page$Backend.prototype.render__Lreactbuild_project_Page$Props__Lreactbuild_project_Page$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_documentPaperPage;
  var $$x7 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var this$4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var cond = $n(s).Lreactbuild_project_Page$State__f_print;
  var cond$1 = (!cond);
  if (cond$1) {
    var this$5 = $m_Lscalacss_ScalaCssReact$();
    var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_skipPaperPage;
    var $$x6 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$5, s$2)
  } else {
    var $$x6 = this$4.Ljapgolly_scalajs_react_vdom_TagMod$__f_empty
  };
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$8 = $m_Lscalacss_ScalaCssReact$();
  var s$3 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_documentPaperPageContent;
  var $$x4 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$8, s$3);
  var this$9 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var $$x3 = this$9.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$10 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
  var $$x2 = this$10.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("column", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $n(p).Lreactbuild_project_Page$Props__f_children;
  var this$13 = $m_s_$less$colon$less$();
  var array = [$$x4, $$x3, $$x2, $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$13.s_$less$colon$less$__f_singleton)];
  var array$1 = [$$x7, $$x6, $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_project_Page$Backend__f_switchPrint))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  return $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
function $as_Lreactbuild_project_Page$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_Page$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.Page$Backend"))
}
function $isArrayOf_Lreactbuild_project_Page$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_Page$Backend)))
}
function $asArrayOf_Lreactbuild_project_Page$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_Page$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.Page$Backend;", depth))
}
var $d_Lreactbuild_project_Page$Backend = new $TypeData().initClass({
  Lreactbuild_project_Page$Backend: 0
}, false, "reactbuild.project.Page$Backend", {
  Lreactbuild_project_Page$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_project_Page$Backend.prototype.$classData = $d_Lreactbuild_project_Page$Backend;
/** @constructor */
function $c_Lreactbuild_project_PreviewDrawing$Backend(\u03b4) {
  this.Lreactbuild_project_PreviewDrawing$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_PreviewDrawing$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_project_PreviewDrawing$State(x$1$2);
    return $n(x$1).Lreactbuild_project_PreviewDrawing$State__f_scale
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $uD(v$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lreactbuild_project_PreviewDrawing$State(x$2$2);
      $n(x$2);
      var this$3 = $n(x$2);
      var hideControls = this$3.Lreactbuild_project_PreviewDrawing$State__f_hideControls;
      return new $c_Lreactbuild_project_PreviewDrawing$State(v, hideControls)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$7 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$7.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w)
}
$c_Lreactbuild_project_PreviewDrawing$Backend.prototype = new $h_O();
$c_Lreactbuild_project_PreviewDrawing$Backend.prototype.constructor = $c_Lreactbuild_project_PreviewDrawing$Backend;
/** @constructor */
function $h_Lreactbuild_project_PreviewDrawing$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_PreviewDrawing$Backend.prototype = $c_Lreactbuild_project_PreviewDrawing$Backend.prototype;
$c_Lreactbuild_project_PreviewDrawing$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_PreviewDrawing$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_PreviewDrawing$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_PreviewDrawing$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_PreviewDrawing$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_PreviewDrawing$Backend.prototype.render__Lreactbuild_project_PreviewDrawing$Props__Lreactbuild_project_PreviewDrawing$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var u = $m_Lreactbuild_project_drawing_DrawingContext$().apply__Lreactbuild_common_model_Project__T__D__T2__s_Option__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lreactbuild_project_PreviewDrawing$Props__f_project, $n(p).Lreactbuild_project_PreviewDrawing$Props__f_modelSource, ($n(s).Lreactbuild_project_PreviewDrawing$State__f_scale / 0.26458333333333334), new $c_T2$mcDD$sp(1000.0, 1000.0), $n(p).Lreactbuild_project_PreviewDrawing$Props__f_serverConnection, new $c_sjsr_AnonFunction1(((ctx$2) => {
    var ctx = $as_Lreactbuild_project_drawing_BoxedDrawingContext(ctx$2);
    return $m_Lreactbuild_project_drawing_DrawBuilding$().apply__Lreactbuild_project_drawing_LOD__Lreactbuild_project_drawing_BoxedDrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode($m_Lreactbuild_project_drawing_LOD500$(), ctx)
  })));
  var this$3 = $n(u);
  var n = this$3.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
function $as_Lreactbuild_project_PreviewDrawing$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_PreviewDrawing$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.PreviewDrawing$Backend"))
}
function $isArrayOf_Lreactbuild_project_PreviewDrawing$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_PreviewDrawing$Backend)))
}
function $asArrayOf_Lreactbuild_project_PreviewDrawing$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_PreviewDrawing$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.PreviewDrawing$Backend;", depth))
}
var $d_Lreactbuild_project_PreviewDrawing$Backend = new $TypeData().initClass({
  Lreactbuild_project_PreviewDrawing$Backend: 0
}, false, "reactbuild.project.PreviewDrawing$Backend", {
  Lreactbuild_project_PreviewDrawing$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_project_PreviewDrawing$Backend.prototype.$classData = $d_Lreactbuild_project_PreviewDrawing$Backend;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawBuilding$Backend(\u03b4) {
  this.Lreactbuild_project_drawing_DrawBuilding$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_drawing_DrawBuilding$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_project_drawing_DrawBuilding$Backend.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawBuilding$Backend.prototype.constructor = $c_Lreactbuild_project_drawing_DrawBuilding$Backend;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawBuilding$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawBuilding$Backend.prototype = $c_Lreactbuild_project_drawing_DrawBuilding$Backend.prototype;
$c_Lreactbuild_project_drawing_DrawBuilding$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_drawing_DrawBuilding$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_drawing_DrawBuilding$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_drawing_DrawBuilding$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_drawing_DrawBuilding$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_drawing_DrawBuilding$Backend.prototype.render__Lreactbuild_project_drawing_DrawBuilding$Props__jl_Void__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var this$1 = $n($n($n($as_Lreactbuild_format_iz2use_package$Building($n($n($n($n(p).Lreactbuild_project_drawing_DrawBuilding$Props__f_context).Lreactbuild_project_drawing_BoxedDrawingContext__f_context).Lreactbuild_project_drawing_DrawingContextImpl__f_building).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_format_iz2use_package$Building__f_storeys).take__I__sci_List(1));
  var mappedStorey = $as_sci_List($n($n($as_sc_IterableOps($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$1))).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
    var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
    return (check$ifrefutable$1 !== null)
  })))).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T2(x$1$2);
    if ((x$1 !== null)) {
      var storey = $as_Lreactbuild_format_iz2use_package$Storey($n(x$1)._1__O());
      var idx = $n(x$1)._2$mcI$sp__I();
      return $m_Lreactbuild_project_drawing_DrawStorey$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_project_drawing_LOD__Lreactbuild_project_drawing_BoxedDrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode($m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), storey), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
        var x0$1 = $as_s_Option(x0$1$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        matchEnd7: {
          var $$x1;
          var p2 = $as_s_Option(x1.T2__f__1);
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x = $m_s_None$();
          if ((x === p2)) {
            var $$x1 = cb;
            break matchEnd7
          };
          var p4 = $as_s_Option(x1.T2__f__1);
          var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          if ((p4 instanceof $c_s_Some)) {
            var x5 = $as_s_Some(p4);
            var v = $as_Lreactbuild_format_iz2use_package$Storey($n(x5).s_Some__f_value);
            var this$5 = $n($n($n($n(p).Lreactbuild_project_drawing_DrawBuilding$Props__f_context).Lreactbuild_project_drawing_BoxedDrawingContext__f_context).Lreactbuild_project_drawing_DrawingContextImpl__f_building);
            var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)));
            var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
            var arg1 = this$5.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
            var s$1 = $as_Lreactbuild_format_iz2use_package$Building(arg1);
            var this$7 = $n($n(s$1).Lreactbuild_format_iz2use_package$Building__f_storeys);
            var this$6 = $n($m_s_package$().s_package$__f_Nil);
            var other = new $c_sci_$colon$colon(v, this$6);
            var x$1$1 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$7, idx, other, 1));
            var this$8 = $n(s$1);
            var x$2 = this$8.Lreactbuild_format_iz2use_package$Building__f_name;
            var this$9 = $n(s$1);
            var x$3 = this$9.Lreactbuild_format_iz2use_package$Building__f_description;
            var this$10 = $n(s$1);
            var x$4 = this$10.Lreactbuild_format_iz2use_package$Building__f_settings;
            $n(s$1);
            var arg1$1 = new $c_Lreactbuild_format_iz2use_package$Building(x$2, x$3, x$4, x$1$1);
            var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$5.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            break matchEnd7
          };
          throw new $c_s_MatchError(x1)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
      }))), $n(p).Lreactbuild_project_drawing_DrawBuilding$Props__f_lod, $n(p).Lreactbuild_project_drawing_DrawBuilding$Props__f_context)
    } else {
      throw new $c_s_MatchError(x$1)
    }
  }))));
  var this$12 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$12, null, mappedStorey)
});
function $as_Lreactbuild_project_drawing_DrawBuilding$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawBuilding$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawBuilding$Backend"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawBuilding$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawBuilding$Backend)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawBuilding$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawBuilding$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawBuilding$Backend;", depth))
}
var $d_Lreactbuild_project_drawing_DrawBuilding$Backend = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawBuilding$Backend: 0
}, false, "reactbuild.project.drawing.DrawBuilding$Backend", {
  Lreactbuild_project_drawing_DrawBuilding$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_project_drawing_DrawBuilding$Backend.prototype.$classData = $d_Lreactbuild_project_drawing_DrawBuilding$Backend;
function $p_Lreactbuild_project_drawing_DrawStorey$Backend__gridLoop$1__D__D__sci_List__D__D__I__I__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, x, y, acc, xMax$1, yMax$1, xMin$1, gridSize$1, context$1) {
  while (true) {
    if ((x >= xMax$1)) {
      if ((y >= yMax$1)) {
        var $$x2 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var as = acc;
        var this$4 = $m_s_$less$colon$less$();
        var array = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, this$4.s_$less$colon$less$__f_singleton)];
        return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("g", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
      } else {
        var temp$x = xMin$1;
        var temp$y = (y + gridSize$1);
        x = temp$x;
        y = temp$y
      }
    } else {
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$11 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
      var a = (("translate(" + $n(context$1).apply__D__D__T(x, y)) + ")");
      var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$11.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$14 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "r");
      var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$14.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$17 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
      var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$1 = [$$x4, $$x3, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$17.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, ".2")];
      var point = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("circle", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var temp$x$2 = (x + gridSize$1);
      var this$21 = $n(acc);
      var temp$acc = new $c_sci_$colon$colon(point, this$21);
      x = temp$x$2;
      acc = temp$acc
    }
  }
}
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawStorey$Backend(\u03b4) {
  this.Lreactbuild_project_drawing_DrawStorey$Backend__f_$ = null;
  this.Lreactbuild_project_drawing_DrawStorey$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_drawing_DrawStorey$Backend__f_$ = \u03b4;
  this.Lreactbuild_project_drawing_DrawStorey$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_project_drawing_DrawStorey$Backend.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawStorey$Backend.prototype.constructor = $c_Lreactbuild_project_drawing_DrawStorey$Backend;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawStorey$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawStorey$Backend.prototype = $c_Lreactbuild_project_drawing_DrawStorey$Backend.prototype;
$c_Lreactbuild_project_drawing_DrawStorey$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_drawing_DrawStorey$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_drawing_DrawStorey$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_drawing_DrawStorey$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_drawing_DrawStorey$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_drawing_DrawStorey$Backend.prototype.recomputeData__Lreactbuild_project_drawing_DrawStorey$Props__Ljapgolly_scalajs_react_callback_Trampoline = (function(p) {
  var context = $n($n(p).Lreactbuild_project_drawing_DrawStorey$Props__f_context).Lreactbuild_project_drawing_BoxedDrawingContext__f_context;
  var storey = $as_Lreactbuild_format_iz2use_package$Storey($n($n(p).Lreactbuild_project_drawing_DrawStorey$Props__f_storeySS).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var storeyShape = $n(storey).shape__sci_List();
  var this$2 = $n($n(storey).Lreactbuild_format_iz2use_package$Storey__f_rooms);
  var f = ((x$1$2) => {
    var x$1 = $as_Lreactbuild_format_iz2use_package$Room(x$1$2);
    return $n(x$1).shape__sci_List()
  });
  if ((this$2 === $m_sci_Nil$())) {
    var roomShapes = $m_sci_Nil$()
  } else {
    var arg1 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var roomShapes = h
  };
  var this$3 = $n(storeyShape);
  var f$1 = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_geom_Point2(x$2$2);
    return $n(x$2).Lreactbuild_geom_Point2__f_y
  }));
  var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var maxY = $n($as_Lreactbuild_geom_Point2($f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O(this$3, f$1, ord))).Lreactbuild_geom_Point2__f_y;
  var this$4 = $n(storeyShape);
  var f$2 = new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_geom_Point2(x$3$2);
    return $n(x$3).Lreactbuild_geom_Point2__f_x
  }));
  var ord$1 = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var maxX = $n($as_Lreactbuild_geom_Point2($f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O(this$4, f$2, ord$1))).Lreactbuild_geom_Point2__f_x;
  $n(context);
  var xMax = (maxX + 500.0);
  var yMax = (maxY + 500.0);
  var grid = $p_Lreactbuild_project_drawing_DrawStorey$Backend__gridLoop$1__D__D__sci_List__D__D__I__I__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode(this, 0.0, 0.0, $m_s_package$().s_package$__f_Nil, xMax, yMax, 0, 500, context);
  var x1 = $n(p).Lreactbuild_project_drawing_DrawStorey$Props__f_lod;
  var x = $m_Lreactbuild_project_drawing_LOD100$();
  if ((x === x1)) {
    var this$9 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x2 = $m_Lreactbuild_project_drawing_DrawWallSides$();
    var $$x1 = $n(p).Lreactbuild_project_drawing_DrawStorey$Props__f_storeySS;
    var this$5 = $n(context);
    var part = $m_Lreactbuild_project_drawing_Wall$();
    var array = [$n($$x2).apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__T__s_Option__sci_List__Z__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$5, part), $m_s_None$(), $m_s_package$().s_package$__f_Nil, true, context), grid];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var drawing = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$9, null, ns)
  } else {
    var this$10 = $n($n(storey).Lreactbuild_format_iz2use_package$Storey__f_rooms);
    var mappedRooms = $as_sci_List($n($n($as_sc_IterableOps($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$10))).withFilter__F1__sc_WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
      var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
      return (check$ifrefutable$1 !== null)
    })))).map__F1__O(new $c_sjsr_AnonFunction1(((x$4$2$2) => {
      var x$4$2 = $as_T2(x$4$2$2);
      if ((x$4$2 !== null)) {
        var room = $as_Lreactbuild_format_iz2use_package$Room($n(x$4$2)._1__O());
        var idx = $n(x$4$2)._2$mcI$sp__I();
        var room$1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), room), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
          var x0$1 = $as_s_Option(x0$1$2);
          var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x1$2 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
          matchEnd7: {
            var $$x3;
            var p2 = $as_s_Option(x1$2.T2__f__1);
            var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var x$4 = $m_s_None$();
            if ((x$4 === p2)) {
              var $$x3 = cb;
              break matchEnd7
            };
            var p4 = $as_s_Option(x1$2.T2__f__1);
            var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            if ((p4 instanceof $c_s_Some)) {
              var x5 = $as_s_Some(p4);
              var v = $as_Lreactbuild_format_iz2use_package$Room($n(x5).s_Some__f_value);
              var this$13 = $n($n(p).Lreactbuild_project_drawing_DrawStorey$Props__f_storeySS);
              var callback = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)));
              var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
              var arg1$2 = this$13.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
              var s = $as_Lreactbuild_format_iz2use_package$Storey(arg1$2);
              var this$15 = $n($n(s).Lreactbuild_format_iz2use_package$Storey__f_rooms);
              var this$14 = $n($m_s_package$().s_package$__f_Nil);
              var other = new $c_sci_$colon$colon(v, this$14);
              var x$1$1 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$15, idx, other, 1));
              var this$16 = $n(s);
              var x$2$1 = this$16.Lreactbuild_format_iz2use_package$Storey__f_sides;
              var this$17 = $n(s);
              var x$3$1 = this$17.Lreactbuild_format_iz2use_package$Storey__f_roofs;
              $n(s);
              var arg1$3 = new $c_Lreactbuild_format_iz2use_package$Storey(x$2$1, x$1$1, x$3$1);
              var $$x3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$13.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$3), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
              break matchEnd7
            };
            throw new $c_s_MatchError(x1$2)
          };
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x3)
        })));
        $n(p);
        return $m_Lreactbuild_project_drawing_DrawWallSides$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__T__s_Option__sci_List__Z__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomElement(room$1, "#000000", $m_s_None$(), $m_s_package$().s_package$__f_Nil, false, context)
      } else {
        throw new $c_s_MatchError(x$4$2)
      }
    }))));
    var this$25 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x6 = $m_Lreactbuild_project_drawing_DrawWallSides$();
    var $$x5 = $n(p).Lreactbuild_project_drawing_DrawStorey$Props__f_storeySS;
    var this$20 = $n(context);
    var part$1 = $m_Lreactbuild_project_drawing_Wall$();
    var $$x4 = $n($$x6).apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__T__s_Option__sci_List__Z__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomElement($$x5, $f_Lreactbuild_project_drawing_DrawingContext__color__Lreactbuild_project_drawing_BuildingPart__T(this$20, part$1), new $c_s_Some("#fafafa"), roomShapes, true, context);
    var this$21 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var array$1 = [$$x4, $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$21, null, mappedRooms), grid];
    var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var drawing = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$25, null, ns$1)
  };
  var size = new $c_Lreactbuild_geom_Vector2(maxX, maxY);
  var $$x9 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$26 = $n($n($n(p).Lreactbuild_project_drawing_DrawStorey$Props__f_context).Lreactbuild_project_drawing_BoxedDrawingContext__f_size);
  var callback$1 = new $c_sjsr_AnonFunction0((() => {
    var this$27 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$28 = $n(this$27.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$28.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$29 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var G$1 = this$29.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var arg1$4 = this$26.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  $as_Lreactbuild_geom_Vector2Based(arg1$4);
  var $$x7 = $n($$x8).unless$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$26.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(size), callback$1, G$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction0((() => {
    var x$6 = $n($n($n(p).Lreactbuild_project_drawing_DrawStorey$Props__f_context).Lreactbuild_project_drawing_BoxedDrawingContext__f_size).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    return ((x$6 !== null) && $dp_equals__O__Z($n(x$6), size))
  })));
  var this$30 = $n(this.Lreactbuild_project_drawing_DrawStorey$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$5$3$2) => {
    $as_Ljapgolly_scalajs_react_vdom_VdomNode(x$5$3$2);
    return drawing
  }));
  return $n($$x9).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($$x7, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$30, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
});
function $as_Lreactbuild_project_drawing_DrawStorey$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawStorey$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawStorey$Backend"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawStorey$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawStorey$Backend)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawStorey$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawStorey$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawStorey$Backend;", depth))
}
var $d_Lreactbuild_project_drawing_DrawStorey$Backend = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawStorey$Backend: 0
}, false, "reactbuild.project.drawing.DrawStorey$Backend", {
  Lreactbuild_project_drawing_DrawStorey$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_project_drawing_DrawStorey$Backend.prototype.$classData = $d_Lreactbuild_project_drawing_DrawStorey$Backend;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingParser$Backend(\u03b4) {
  this.Lreactbuild_project_drawing_DrawingParser$Backend__f_$ = null;
  this.Lreactbuild_project_drawing_DrawingParser$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_drawing_DrawingParser$Backend__f_$ = \u03b4;
  this.Lreactbuild_project_drawing_DrawingParser$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingParser$Backend;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingParser$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingParser$Backend.prototype = $c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype;
$c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_drawing_DrawingParser$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_drawing_DrawingParser$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype.render__Lreactbuild_project_drawing_DrawingParser$Props__Lreactbuild_project_drawing_DrawingParser$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var this$40 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var pot = $n(s).Lreactbuild_project_drawing_DrawingParser$State__f_model;
  if ($n(pot).isEmpty__Z()) {
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun mod\u00e8le charg\u00e9"))];
    var $$x7 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var pot$1 = $n(s).Lreactbuild_project_drawing_DrawingParser$State__f_model;
  if ($n(pot$1).isPending__Z()) {
    var qual$1 = $as_Ldiode_data_PendingBase(pot$1);
    $n(qual$1);
    var this$14 = $ct_ju_Date__(new $c_ju_Date());
    var t = this$14.ju_Date__f_java$util$Date$$millis;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$15 = $n(qual$1);
    $f_Ldiode_data_PendingBase__duration__J__I(this$15, new $c_RTLong(lo, hi));
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Chargement en cours du mod\u00e8le ..."))];
    var $$x5 = $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  } else {
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var pot$2 = $n(s).Lreactbuild_project_drawing_DrawingParser$State__f_model;
  var this$25 = $n($n(pot$2).exceptionOption__s_Option());
  if (this$25.isEmpty__Z()) {
    var $$x3 = $m_s_None$()
  } else {
    var arg1$1 = this$25.get__O();
    var e = $as_jl_Throwable(arg1$1);
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = ("Une erreur s'est produite pendant la lecture du mod\u00e8le : " + $n(e).getMessage__T());
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x3 = new $c_s_Some($n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)))
  };
  var this$33 = $n($$x3);
  var $$x2 = $as_Ljapgolly_scalajs_react_vdom_VdomNode((this$33.isEmpty__Z() ? $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom : this$33.get__O()));
  var pot$3 = $n(s).Lreactbuild_project_drawing_DrawingParser$State__f_model;
  var this$36 = $n(pot$3);
  if ((!this$36.isEmpty__Z())) {
    var arg1$2 = $n(pot$3).get__O();
    var model = $as_Lreactbuild_project_drawing_DrawingParser$Model(arg1$2);
    var $$x1 = $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lreactbuild_project_drawing_DrawingParser$Props__f_f).apply__O__O(model))
  } else {
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  };
  var array$3 = [$$x7, $$x5, $$x2, $$x1];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$40, null, ns)
});
$c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype.update__Lreactbuild_project_drawing_DrawingParser$Props__Ljapgolly_scalajs_react_callback_Trampoline = (function(p) {
  var $$x1 = $m_Lfastparse_package$();
  var t = $n(p).Lreactbuild_project_drawing_DrawingParser$Props__f_modelSource;
  var conv = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    return new $c_Lfastparse_IndexedParserInput(s)
  }));
  var x1 = $n($$x1).parse__Lfastparse_ParserInputSource__F1__Z__I__Lfastparse_internal_Instrument__Lfastparse_Parsed(new $c_Lfastparse_ParserInputSource$fromParserInput(t, conv), new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lfastparse_ParsingRun(x$2$2);
    return $m_Lreactbuild_format_iz2use_Parser$().root__Lfastparse_ParsingRun__Lfastparse_ParsingRun(x$2)
  })), ($m_Lfastparse_package$(), false), ($m_Lfastparse_package$(), 0), ($m_Lfastparse_package$(), null));
  if ((x1 instanceof $c_Lfastparse_Parsed$Success)) {
    var x2 = $as_Lfastparse_Parsed$Success(x1);
    var v = $as_Lreactbuild_format_iz2use_package$Building($n(x2).Lfastparse_Parsed$Success__f_value);
    var this$4 = $n($n(v).Lreactbuild_format_iz2use_package$Building__f_storeys);
    var rest = this$4;
    var h = null;
    var t$1 = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var storey = $as_Lreactbuild_format_iz2use_package$Storey(arg1);
      var y = $m_ju_UUID$().randomUUID__ju_UUID();
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), storey, y);
      var this$10 = $n($n(storey).Lreactbuild_format_iz2use_package$Storey__f_rooms);
      var f = ((x$3$2) => {
        var x$3 = $as_Lreactbuild_format_iz2use_package$Room(x$3$2);
        var y$1 = $m_ju_UUID$().randomUUID__ju_UUID();
        return $ct_T2__O__O__(new $c_T2(), x$3, y$1)
      });
      if ((this$10 === $m_sci_Nil$())) {
        var $$x2 = $m_sci_Nil$()
      } else {
        var arg1$1 = this$10.head__O();
        var h$1 = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        var t$2 = h$1;
        var rest$1 = $as_sci_List(this$10.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest$1).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
          $n(t$2).sci_$colon$colon__f_next = nx;
          t$2 = nx;
          rest$1 = $as_sci_List($n(rest$1).tail__O())
        };
        var $$x2 = h$1
      };
      var this$11 = $n($$x2);
      var this$12 = new $c_sci_$colon$colon(rassoc$1, this$11);
      var f$1 = ((pair$2) => {
        var pair = $as_T2(pair$2);
        return pair
      });
      if ((this$12 === $m_sci_Nil$())) {
        var $$x3 = $m_sci_Nil$()
      } else {
        var arg1$3 = this$12.sci_$colon$colon__f_head;
        var h$2 = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
        var t$3 = h$2;
        var rest$2 = this$12.sci_$colon$colon__f_next;
        while ((rest$2 !== $m_sci_Nil$())) {
          var arg1$4 = $n(rest$2).head__O();
          var nx$1 = new $c_sci_$colon$colon(f$1(arg1$4), $m_sci_Nil$());
          $n(t$3).sci_$colon$colon__f_next = nx$1;
          t$3 = nx$1;
          rest$2 = $as_sci_List($n(rest$2).tail__O())
        };
        var $$x3 = h$2
      };
      var it = $n($$x3).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx$2 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t$1 === null)) {
          h = nx$2
        } else {
          $n(t$1).sci_$colon$colon__f_next = nx$2
        };
        t$1 = nx$2
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    var this$14 = $n(((h === null) ? $m_sci_Nil$() : h));
    var this$13 = $m_s_$less$colon$less$();
    var ids = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$14);
    var this$17 = $n(this.Lreactbuild_project_drawing_DrawingParser$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$3$2) => {
      var s$3 = $as_Lreactbuild_project_drawing_DrawingParser$State(s$3$2);
      $n(s$3);
      $n($n(s$3).Lreactbuild_project_drawing_DrawingParser$State__f_model);
      var value = new $c_Lreactbuild_project_drawing_DrawingParser$Model(v, ids);
      var model = new $c_Ldiode_data_Ready(value);
      return new $c_Lreactbuild_project_drawing_DrawingParser$State(model)
    }));
    return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$17, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
  };
  if ((x1 instanceof $c_Lfastparse_Parsed$Failure)) {
    var x4 = $as_Lfastparse_Parsed$Failure(x1);
    var o11 = $m_Lfastparse_Parsed$Failure$().unapply__Lfastparse_Parsed$Failure__s_Option(x4);
    if ((!$n(o11).isEmpty__Z())) {
      var expected = $as_T($n($as_T3($n(o11).get__O())).T3__f__1);
      var index = $uI($n($as_T3($n(o11).get__O())).T3__f__2);
      var extra = $as_Lfastparse_Parsed$Extra($n($as_T3($n(o11).get__O())).T3__f__3);
      var this$18 = $n(extra);
      var traced = this$18.trace__Z__Lfastparse_Parsed$TracedFailure(false);
      var this$21 = $n(this.Lreactbuild_project_drawing_DrawingParser$Backend__f_$);
      var mod$1 = new $c_sjsr_AnonFunction1(((s$4$2) => {
        var s$4 = $as_Lreactbuild_project_drawing_DrawingParser$State(s$4$2);
        $n(s$4);
        var $$x5 = $n($n(s$4).Lreactbuild_project_drawing_DrawingParser$State__f_model);
        var $$x4 = $n(traced).Lfastparse_Parsed$TracedFailure__f_failure;
        var this$19 = $n(traced);
        var model$1 = $n($$x5).fail__jl_Throwable__Ldiode_data_Pot($ct_jl_Exception__T__(new $c_jl_Exception(), (((((((($$x4 + " at index ") + index) + ", expected ") + expected) + "\n") + this$19.aggregateMsg__T()) + "\n") + $n(traced).stack__sci_List())));
        return new $c_Lreactbuild_project_drawing_DrawingParser$State(model$1)
      }));
      return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$21, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    }
  };
  throw new $c_s_MatchError(x1)
});
$c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype.computeState__Lreactbuild_project_drawing_DrawingParser$Props__s_Option__Ljapgolly_scalajs_react_callback_Trampoline = (function(next, prev) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var this$1 = $n(prev);
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var x$4 = $as_Lreactbuild_project_drawing_DrawingParser$Props(arg1);
    var $$x1 = ($n(x$4).Lreactbuild_project_drawing_DrawingParser$Props__f_modelSource === $n(next).Lreactbuild_project_drawing_DrawingParser$Props__f_modelSource)
  } else {
    var $$x1 = false
  };
  var cond = (!$$x1);
  if (cond) {
    var this$ = this.update__Lreactbuild_project_drawing_DrawingParser$Props__Ljapgolly_scalajs_react_callback_Trampoline(next);
    var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_jl_Void(x$5$2)
    }));
    var this$5 = $n(this$);
    var this$$1 = new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$5, f)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
  } else {
    return $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty
  }
});
function $as_Lreactbuild_project_drawing_DrawingParser$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawingParser$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawingParser$Backend"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawingParser$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawingParser$Backend)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawingParser$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawingParser$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawingParser$Backend;", depth))
}
var $d_Lreactbuild_project_drawing_DrawingParser$Backend = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingParser$Backend: 0
}, false, "reactbuild.project.drawing.DrawingParser$Backend", {
  Lreactbuild_project_drawing_DrawingParser$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_project_drawing_DrawingParser$Backend.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingParser$Backend;
function $p_Lreactbuild_project_drawing_ToolSelector$Backend__button$1__Lreactbuild_project_drawing_Tool__Ljapgolly_scalajs_react_callback_Trampoline__Z__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomNode($thiz, tool, cb, active, modifiers) {
  var $$x3 = $m_Lreactbuild_project_drawing_Button$();
  var $$x2 = $n(tool).icon__T();
  var $$x1 = $n(tool).name__T();
  var this$1 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingButtonActive;
  var this$2 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$1, s));
  var array = [$f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$2, active)];
  var u = $n($$x3).apply__T__T__Ljapgolly_scalajs_react_callback_Trampoline__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x2, $$x1, cb, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var this$7 = $n(u);
  var n = this$7.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
}
/** @constructor */
function $c_Lreactbuild_project_drawing_ToolSelector$Backend(\u03b4) {
  this.Lreactbuild_project_drawing_ToolSelector$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_drawing_ToolSelector$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_project_drawing_ToolSelector$Backend.prototype = new $h_O();
$c_Lreactbuild_project_drawing_ToolSelector$Backend.prototype.constructor = $c_Lreactbuild_project_drawing_ToolSelector$Backend;
/** @constructor */
function $h_Lreactbuild_project_drawing_ToolSelector$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_ToolSelector$Backend.prototype = $c_Lreactbuild_project_drawing_ToolSelector$Backend.prototype;
$c_Lreactbuild_project_drawing_ToolSelector$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_drawing_ToolSelector$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_drawing_ToolSelector$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_drawing_ToolSelector$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_drawing_ToolSelector$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_drawing_ToolSelector$Backend.prototype.render__Lreactbuild_project_drawing_ToolSelector$Props__Lreactbuild_project_drawing_ToolSelector$State__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(p, s) {
  var fullScreen = $uZ($n($n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_fullScreen).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  if (fullScreen) {
    var $$x2 = $m_Lreactbuild_project_drawing_Button$();
    var $$x1 = $m_Lreactbuild_project_drawing_ToolSelector$().Lreactbuild_project_drawing_ToolSelector$__f_exitFullScreenIcon;
    var this$1 = $n($n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_fullScreen);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$1.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    $uZ(arg1);
    var arg1$1 = false;
    var u = $n($$x2).apply__T__T__Ljapgolly_scalajs_react_callback_Trampoline__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x1, "Sortir du mode plein \u00e9cran", $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$1.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $m_sci_Nil$());
    var this$6 = $n(u);
    var n = this$6.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var toggleFullScreenButton = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  } else {
    var $$x4 = $m_Lreactbuild_project_drawing_Button$();
    var $$x3 = $m_Lreactbuild_project_drawing_ToolSelector$().Lreactbuild_project_drawing_ToolSelector$__f_switchToFullScreenIcon;
    var this$8 = $n($n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_fullScreen);
    var callback$1 = new $c_sjsr_AnonFunction0((() => {
      var this$9 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$10 = $n(this$9.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$10.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$11 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G$1 = this$11.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1$2 = this$8.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    $uZ(arg1$2);
    var arg1$3 = true;
    var u$1 = $n($$x4).apply__T__T__Ljapgolly_scalajs_react_callback_Trampoline__sci_Seq__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x3, "Basculer en mode plein \u00e9cran", $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$8.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$3), callback$1, G$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $m_sci_Nil$());
    var this$13 = $n(u$1);
    var n$1 = this$13.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var toggleFullScreenButton = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  };
  var this$15 = $n($as_s_Option($n($n($n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_context).Lreactbuild_project_drawing_DrawingContextImpl__f_tool).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
  if (this$15.isEmpty__Z()) {
    var currentTool = $m_s_None$()
  } else {
    var arg1$4 = this$15.get__O();
    var x$3 = $as_Lreactbuild_project_drawing_Tool(arg1$4);
    var this$16 = $n(x$3);
    var currentTool = new $c_s_Some($objectGetClass(this$16))
  };
  var this$17 = $m_Lreactbuild_project_drawing_ToolRegistry$();
  var this$18 = $n(this$17.Lreactbuild_project_drawing_ToolRegistry$__f_registered);
  var this$32 = $n($as_sc_SeqOps($n($m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq(this$18)).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_project_drawing_Tool(x0$1$2);
    if ($is_Lreactbuild_project_drawing_ToggleTool(x0$1)) {
      var x2 = $as_Lreactbuild_project_drawing_ToggleTool(x0$1);
      var state = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF($n($n(x2).state__F1()).apply__O__O($n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_context));
      var this$19 = $n(state);
      var callback$2 = new $c_sjsr_AnonFunction0((() => {
        var this$20 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$21 = $n(this$20.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$21.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
      }));
      var this$22 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var G$2 = this$22.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var arg1$5 = this$19.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var x$4 = $uZ(arg1$5);
      var arg1$6 = (!x$4);
      return $p_Lreactbuild_project_drawing_ToolSelector$Backend__button$1__Lreactbuild_project_drawing_Tool__Ljapgolly_scalajs_react_callback_Trampoline__Z__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomNode(this, x2, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$19.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$6), callback$2, G$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $uZ($n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $m_sci_Nil$())
    } else if ($is_Lreactbuild_project_drawing_CommandTool(x0$1)) {
      var x3 = $as_Lreactbuild_project_drawing_CommandTool(x0$1);
      return $p_Lreactbuild_project_drawing_ToolSelector$Backend__button$1__Lreactbuild_project_drawing_Tool__Ljapgolly_scalajs_react_callback_Trampoline__Z__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomNode(this, x3, $n(x3).run__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_callback_Trampoline($n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_context), false, $m_sci_Nil$())
    } else {
      var $$x5 = $n(currentTool);
      var this$23 = $n(x0$1);
      var isActive = $n($$x5).contains__O__Z($objectGetClass(this$23));
      if (isActive) {
        var this$24 = $n($n($n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_context).Lreactbuild_project_drawing_DrawingContextImpl__f_tool);
        var callback$3 = new $c_sjsr_AnonFunction0((() => {
          var this$25 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var this$26 = $n(this$25.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$26.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
        }));
        var this$27 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var G$3 = this$27.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
        var arg1$7 = this$24.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
        $as_s_Option(arg1$7);
        var arg1$8 = $m_s_None$();
        var $$x6 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$24.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$8), callback$3, G$3))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
      } else {
        var this$28 = $n($n($n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_context).Lreactbuild_project_drawing_DrawingContextImpl__f_tool);
        var callback$4 = new $c_sjsr_AnonFunction0((() => {
          var this$29 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var this$30 = $n(this$29.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$30.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
        }));
        var this$31 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var G$4 = this$31.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
        var arg1$9 = this$28.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
        $as_s_Option(arg1$9);
        var arg1$10 = new $c_s_Some(x0$1);
        var $$x6 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$28.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$10), callback$4, G$4))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
      };
      return $p_Lreactbuild_project_drawing_ToolSelector$Backend__button$1__Lreactbuild_project_drawing_Tool__Ljapgolly_scalajs_react_callback_Trampoline__Z__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomNode(this, x0$1, $$x6, isActive, $m_sci_Nil$())
    }
  })))));
  var tools = $as_sci_IndexedSeq(this$32.appended__O__O(toggleFullScreenButton));
  var $$x13 = $m_Lreactbuild_project_drawing_Area$();
  var $$x12 = $m_Lreactbuild_project_drawing_Area$Axis$Horizontal$();
  var $$x11 = $m_Lreactbuild_project_drawing_Area$Position$Start$();
  var $$x10 = $n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_hidecontrols;
  $m_Lreactbuild_project_drawing_Area$();
  var $$x9 = $m_Lreactbuild_project_drawing_Area$Alignment$Middle$();
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = ("" + $n($n(p).Lreactbuild_project_drawing_ToolSelector$Props__f_project).Lreactbuild_common_model_Project__f_name);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  var $$x7 = $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var u$2 = $m_Lreactbuild_project_drawing_Toolbar$().apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(tools);
  var this$42 = $n(u$2);
  var n$2 = this$42.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$1 = [$$x7, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
  return $n($$x13).apply__Lreactbuild_project_drawing_Area$Axis__Lreactbuild_project_drawing_Area$Position__Z__Lreactbuild_project_drawing_Area$Alignment__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x12, $$x11, $$x10, $$x9, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
function $as_Lreactbuild_project_drawing_ToolSelector$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_ToolSelector$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.ToolSelector$Backend"))
}
function $isArrayOf_Lreactbuild_project_drawing_ToolSelector$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_ToolSelector$Backend)))
}
function $asArrayOf_Lreactbuild_project_drawing_ToolSelector$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_ToolSelector$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.ToolSelector$Backend;", depth))
}
var $d_Lreactbuild_project_drawing_ToolSelector$Backend = new $TypeData().initClass({
  Lreactbuild_project_drawing_ToolSelector$Backend: 0
}, false, "reactbuild.project.drawing.ToolSelector$Backend", {
  Lreactbuild_project_drawing_ToolSelector$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_project_drawing_ToolSelector$Backend.prototype.$classData = $d_Lreactbuild_project_drawing_ToolSelector$Backend;
/** @constructor */
function $c_Lreactbuild_project_drawing_Viewport$Backend(\u03b4) {
  this.Lreactbuild_project_drawing_Viewport$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_drawing_Viewport$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_project_drawing_Viewport$Backend.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Viewport$Backend.prototype.constructor = $c_Lreactbuild_project_drawing_Viewport$Backend;
/** @constructor */
function $h_Lreactbuild_project_drawing_Viewport$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Viewport$Backend.prototype = $c_Lreactbuild_project_drawing_Viewport$Backend.prototype;
$c_Lreactbuild_project_drawing_Viewport$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_drawing_Viewport$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_drawing_Viewport$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_drawing_Viewport$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_drawing_Viewport$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_drawing_Viewport$Backend.prototype.render__Lreactbuild_project_drawing_Viewport$Props__Lreactbuild_project_drawing_Viewport$State__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s, c) {
  var $$x7 = $m_Lreactbuild_common_components_InteractionController$();
  var $$x6 = $n(p).Lreactbuild_project_drawing_Viewport$Props__f_context;
  var $$x5 = $m_Lreactbuild_project_drawing_interaction_package$().Lreactbuild_project_drawing_interaction_package$__f_DrawingInteractions;
  var this$1 = $n($n(p).Lreactbuild_project_drawing_Viewport$Props__f_context);
  var $$x4 = $n(this$1.Lreactbuild_project_drawing_DrawingContextImpl__f_backend).showControls__Ljapgolly_scalajs_react_callback_Trampoline();
  var this$2 = $n($n(p).Lreactbuild_project_drawing_Viewport$Props__f_context);
  var $$x3 = $n(this$2.Lreactbuild_project_drawing_DrawingContextImpl__f_backend).showControls__Ljapgolly_scalajs_react_callback_Trampoline();
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingViewport;
  var $$x1 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$1);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$7 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var array = [$$x1, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$7.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c))];
  var u = $n($$x7).apply__O__Lreactbuild_common_components_Interactions__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x6, $$x5, $$x4, $$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("svg", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var this$15 = $n(u);
  var n = this$15.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
function $as_Lreactbuild_project_drawing_Viewport$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_Viewport$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Viewport$Backend"))
}
function $isArrayOf_Lreactbuild_project_drawing_Viewport$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Viewport$Backend)))
}
function $asArrayOf_Lreactbuild_project_drawing_Viewport$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Viewport$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Viewport$Backend;", depth))
}
var $d_Lreactbuild_project_drawing_Viewport$Backend = new $TypeData().initClass({
  Lreactbuild_project_drawing_Viewport$Backend: 0
}, false, "reactbuild.project.drawing.Viewport$Backend", {
  Lreactbuild_project_drawing_Viewport$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_project_drawing_Viewport$Backend.prototype.$classData = $d_Lreactbuild_project_drawing_Viewport$Backend;
function $f_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal__$init$__V($thiz) {
  $thiz.reactbuild$project$drawing$tool$PlaceNetworkTerminal$_setter_$name_$eq__T__V("R\u00e9seaux");
  $thiz.reactbuild$project$drawing$tool$PlaceNetworkTerminal$_setter_$icon_$eq__T__V("m 7,4 v 7 H 0 v 2 h 7 v 7 l 12,-7 h 5 v -2 h -5 z")
}
function $ct_Lreactbuild_project_generator_electricalboard_model_LineWireColor__I__T__I__($thiz, order, color, keycode) {
  $thiz.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_order = order;
  $thiz.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_color = color;
  $thiz.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_keycode = keycode;
  $f_Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor__$init$__V($thiz);
  $thiz.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_mainOrder = 1;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_LineWireColor() {
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_colors = null
}
$c_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_LineWireColor;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_LineWireColor() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype = $c_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype.reactbuild$project$generator$electricalboard$model$SingleColorWireColor$_setter_$colors_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_colors = x$1
});
$c_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype.order__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_order
});
$c_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype.color__T = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_color
});
$c_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype.keycode__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_keycode
});
$c_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype.mainOrder__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_mainOrder
});
$c_Lreactbuild_project_generator_electricalboard_model_LineWireColor.prototype.colors__sci_Seq = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_colors
});
function $ct_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__I__T__I__($thiz, order, color, keycode) {
  $thiz.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_order = order;
  $thiz.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_color = color;
  $thiz.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_keycode = keycode;
  $f_Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor__$init$__V($thiz);
  $thiz.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_mainOrder = 0;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor() {
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_colors = null
}
$c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype = $c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype.reactbuild$project$generator$electricalboard$model$SingleColorWireColor$_setter_$colors_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_colors = x$1
});
$c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype.order__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_order
});
$c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype.color__T = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_color
});
$c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype.keycode__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_keycode
});
$c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype.mainOrder__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_mainOrder
});
$c_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor.prototype.colors__sci_Seq = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_colors
});
function $ct_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__I__T__I__($thiz, order, color, keycode) {
  $thiz.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_order = order;
  $thiz.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_color = color;
  $thiz.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_keycode = keycode;
  $f_Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor__$init$__V($thiz);
  $thiz.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_mainOrder = 2;
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor() {
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_colors = null
}
$c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype = $c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype.reactbuild$project$generator$electricalboard$model$SingleColorWireColor$_setter_$colors_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_colors = x$1
});
$c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype.order__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_order
});
$c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype.color__T = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_color
});
$c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype.keycode__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_keycode
});
$c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype.mainOrder__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_mainOrder
});
$c_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor.prototype.colors__sci_Seq = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_colors
});
/** @constructor */
function $c_s_$less$colon$less() {
  /*<skip>*/
}
$c_s_$less$colon$less.prototype = new $h_O();
$c_s_$less$colon$less.prototype.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
  /*<skip>*/
}
$h_s_$less$colon$less.prototype = $c_s_$less$colon$less.prototype;
$c_s_$less$colon$less.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(v1)
});
/** @constructor */
function $c_s_Predef$() {
  this.s_Predef$__f_Map = null;
  this.s_Predef$__f_Set = null;
  $n_s_Predef$ = this;
  $m_s_package$();
  $m_sci_List$();
  this.s_Predef$__f_Map = $m_sci_Map$();
  this.s_Predef$__f_Set = $m_sci_Set$()
}
$c_s_Predef$.prototype = new $h_s_LowPriorityImplicits();
$c_s_Predef$.prototype.constructor = $c_s_Predef$;
/** @constructor */
function $h_s_Predef$() {
  /*<skip>*/
}
$h_s_Predef$.prototype = $c_s_Predef$.prototype;
$c_s_Predef$.prototype.assert__Z__V = (function(assertion) {
  if ((!assertion)) {
    throw new $c_jl_AssertionError("assertion failed")
  }
});
$c_s_Predef$.prototype.require__Z__V = (function(requirement) {
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed")
  }
});
$c_s_Predef$.prototype.$qmark$qmark$qmark__E = (function() {
  throw new $c_s_NotImplementedError()
});
var $d_s_Predef$ = new $TypeData().initClass({
  s_Predef$: 0
}, false, "scala.Predef$", {
  s_Predef$: 1,
  s_LowPriorityImplicits: 1,
  s_LowPriorityImplicits2: 1,
  O: 1
});
$c_s_Predef$.prototype.$classData = $d_s_Predef$;
var $n_s_Predef$;
function $m_s_Predef$() {
  if ((!$n_s_Predef$)) {
    $n_s_Predef$ = new $c_s_Predef$()
  };
  return $n_s_Predef$
}
function $f_s_Product10__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T10__f__1;
      break
    }
    case 1: {
      return $thiz.T10__f__2;
      break
    }
    case 2: {
      return $thiz.T10__f__3;
      break
    }
    case 3: {
      return $thiz.T10__f__4;
      break
    }
    case 4: {
      return $thiz.T10__f__5;
      break
    }
    case 5: {
      return $thiz.T10__f__6;
      break
    }
    case 6: {
      return $thiz.T10__f__7;
      break
    }
    case 7: {
      return $thiz.T10__f__8;
      break
    }
    case 8: {
      return $thiz.T10__f__9;
      break
    }
    case 9: {
      return $thiz.T10__f__10;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 9)"))
    }
  }
}
function $f_s_Product11__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T11__f__1;
      break
    }
    case 1: {
      return $thiz.T11__f__2;
      break
    }
    case 2: {
      return $thiz.T11__f__3;
      break
    }
    case 3: {
      return $thiz.T11__f__4;
      break
    }
    case 4: {
      return $thiz.T11__f__5;
      break
    }
    case 5: {
      return $thiz.T11__f__6;
      break
    }
    case 6: {
      return $thiz.T11__f__7;
      break
    }
    case 7: {
      return $thiz.T11__f__8;
      break
    }
    case 8: {
      return $thiz.T11__f__9;
      break
    }
    case 9: {
      return $thiz.T11__f__10;
      break
    }
    case 10: {
      return $thiz.T11__f__11;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 10)"))
    }
  }
}
function $f_s_Product12__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T12__f__1;
      break
    }
    case 1: {
      return $thiz.T12__f__2;
      break
    }
    case 2: {
      return $thiz.T12__f__3;
      break
    }
    case 3: {
      return $thiz.T12__f__4;
      break
    }
    case 4: {
      return $thiz.T12__f__5;
      break
    }
    case 5: {
      return $thiz.T12__f__6;
      break
    }
    case 6: {
      return $thiz.T12__f__7;
      break
    }
    case 7: {
      return $thiz.T12__f__8;
      break
    }
    case 8: {
      return $thiz.T12__f__9;
      break
    }
    case 9: {
      return $thiz.T12__f__10;
      break
    }
    case 10: {
      return $thiz.T12__f__11;
      break
    }
    case 11: {
      return $thiz.T12__f__12;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 11)"))
    }
  }
}
function $f_s_Product13__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T13__f__1;
      break
    }
    case 1: {
      return $thiz.T13__f__2;
      break
    }
    case 2: {
      return $thiz.T13__f__3;
      break
    }
    case 3: {
      return $thiz.T13__f__4;
      break
    }
    case 4: {
      return $thiz.T13__f__5;
      break
    }
    case 5: {
      return $thiz.T13__f__6;
      break
    }
    case 6: {
      return $thiz.T13__f__7;
      break
    }
    case 7: {
      return $thiz.T13__f__8;
      break
    }
    case 8: {
      return $thiz.T13__f__9;
      break
    }
    case 9: {
      return $thiz.T13__f__10;
      break
    }
    case 10: {
      return $thiz.T13__f__11;
      break
    }
    case 11: {
      return $thiz.T13__f__12;
      break
    }
    case 12: {
      return $thiz.T13__f__13;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 12)"))
    }
  }
}
function $f_s_Product14__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T14__f__1;
      break
    }
    case 1: {
      return $thiz.T14__f__2;
      break
    }
    case 2: {
      return $thiz.T14__f__3;
      break
    }
    case 3: {
      return $thiz.T14__f__4;
      break
    }
    case 4: {
      return $thiz.T14__f__5;
      break
    }
    case 5: {
      return $thiz.T14__f__6;
      break
    }
    case 6: {
      return $thiz.T14__f__7;
      break
    }
    case 7: {
      return $thiz.T14__f__8;
      break
    }
    case 8: {
      return $thiz.T14__f__9;
      break
    }
    case 9: {
      return $thiz.T14__f__10;
      break
    }
    case 10: {
      return $thiz.T14__f__11;
      break
    }
    case 11: {
      return $thiz.T14__f__12;
      break
    }
    case 12: {
      return $thiz.T14__f__13;
      break
    }
    case 13: {
      return $thiz.T14__f__14;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 13)"))
    }
  }
}
function $f_s_Product15__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T15__f__1;
      break
    }
    case 1: {
      return $thiz.T15__f__2;
      break
    }
    case 2: {
      return $thiz.T15__f__3;
      break
    }
    case 3: {
      return $thiz.T15__f__4;
      break
    }
    case 4: {
      return $thiz.T15__f__5;
      break
    }
    case 5: {
      return $thiz.T15__f__6;
      break
    }
    case 6: {
      return $thiz.T15__f__7;
      break
    }
    case 7: {
      return $thiz.T15__f__8;
      break
    }
    case 8: {
      return $thiz.T15__f__9;
      break
    }
    case 9: {
      return $thiz.T15__f__10;
      break
    }
    case 10: {
      return $thiz.T15__f__11;
      break
    }
    case 11: {
      return $thiz.T15__f__12;
      break
    }
    case 12: {
      return $thiz.T15__f__13;
      break
    }
    case 13: {
      return $thiz.T15__f__14;
      break
    }
    case 14: {
      return $thiz.T15__f__15;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 14)"))
    }
  }
}
function $f_s_Product16__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T16__f__1;
      break
    }
    case 1: {
      return $thiz.T16__f__2;
      break
    }
    case 2: {
      return $thiz.T16__f__3;
      break
    }
    case 3: {
      return $thiz.T16__f__4;
      break
    }
    case 4: {
      return $thiz.T16__f__5;
      break
    }
    case 5: {
      return $thiz.T16__f__6;
      break
    }
    case 6: {
      return $thiz.T16__f__7;
      break
    }
    case 7: {
      return $thiz.T16__f__8;
      break
    }
    case 8: {
      return $thiz.T16__f__9;
      break
    }
    case 9: {
      return $thiz.T16__f__10;
      break
    }
    case 10: {
      return $thiz.T16__f__11;
      break
    }
    case 11: {
      return $thiz.T16__f__12;
      break
    }
    case 12: {
      return $thiz.T16__f__13;
      break
    }
    case 13: {
      return $thiz.T16__f__14;
      break
    }
    case 14: {
      return $thiz.T16__f__15;
      break
    }
    case 15: {
      return $thiz.T16__f__16;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 15)"))
    }
  }
}
function $f_s_Product17__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T17__f__1;
      break
    }
    case 1: {
      return $thiz.T17__f__2;
      break
    }
    case 2: {
      return $thiz.T17__f__3;
      break
    }
    case 3: {
      return $thiz.T17__f__4;
      break
    }
    case 4: {
      return $thiz.T17__f__5;
      break
    }
    case 5: {
      return $thiz.T17__f__6;
      break
    }
    case 6: {
      return $thiz.T17__f__7;
      break
    }
    case 7: {
      return $thiz.T17__f__8;
      break
    }
    case 8: {
      return $thiz.T17__f__9;
      break
    }
    case 9: {
      return $thiz.T17__f__10;
      break
    }
    case 10: {
      return $thiz.T17__f__11;
      break
    }
    case 11: {
      return $thiz.T17__f__12;
      break
    }
    case 12: {
      return $thiz.T17__f__13;
      break
    }
    case 13: {
      return $thiz.T17__f__14;
      break
    }
    case 14: {
      return $thiz.T17__f__15;
      break
    }
    case 15: {
      return $thiz.T17__f__16;
      break
    }
    case 16: {
      return $thiz.T17__f__17;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 16)"))
    }
  }
}
function $f_s_Product18__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T18__f__1;
      break
    }
    case 1: {
      return $thiz.T18__f__2;
      break
    }
    case 2: {
      return $thiz.T18__f__3;
      break
    }
    case 3: {
      return $thiz.T18__f__4;
      break
    }
    case 4: {
      return $thiz.T18__f__5;
      break
    }
    case 5: {
      return $thiz.T18__f__6;
      break
    }
    case 6: {
      return $thiz.T18__f__7;
      break
    }
    case 7: {
      return $thiz.T18__f__8;
      break
    }
    case 8: {
      return $thiz.T18__f__9;
      break
    }
    case 9: {
      return $thiz.T18__f__10;
      break
    }
    case 10: {
      return $thiz.T18__f__11;
      break
    }
    case 11: {
      return $thiz.T18__f__12;
      break
    }
    case 12: {
      return $thiz.T18__f__13;
      break
    }
    case 13: {
      return $thiz.T18__f__14;
      break
    }
    case 14: {
      return $thiz.T18__f__15;
      break
    }
    case 15: {
      return $thiz.T18__f__16;
      break
    }
    case 16: {
      return $thiz.T18__f__17;
      break
    }
    case 17: {
      return $thiz.T18__f__18;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 17)"))
    }
  }
}
function $f_s_Product19__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T19__f__1;
      break
    }
    case 1: {
      return $thiz.T19__f__2;
      break
    }
    case 2: {
      return $thiz.T19__f__3;
      break
    }
    case 3: {
      return $thiz.T19__f__4;
      break
    }
    case 4: {
      return $thiz.T19__f__5;
      break
    }
    case 5: {
      return $thiz.T19__f__6;
      break
    }
    case 6: {
      return $thiz.T19__f__7;
      break
    }
    case 7: {
      return $thiz.T19__f__8;
      break
    }
    case 8: {
      return $thiz.T19__f__9;
      break
    }
    case 9: {
      return $thiz.T19__f__10;
      break
    }
    case 10: {
      return $thiz.T19__f__11;
      break
    }
    case 11: {
      return $thiz.T19__f__12;
      break
    }
    case 12: {
      return $thiz.T19__f__13;
      break
    }
    case 13: {
      return $thiz.T19__f__14;
      break
    }
    case 14: {
      return $thiz.T19__f__15;
      break
    }
    case 15: {
      return $thiz.T19__f__16;
      break
    }
    case 16: {
      return $thiz.T19__f__17;
      break
    }
    case 17: {
      return $thiz.T19__f__18;
      break
    }
    case 18: {
      return $thiz.T19__f__19;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 18)"))
    }
  }
}
function $f_s_Product2__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz._1__O();
      break
    }
    case 1: {
      return $thiz._2__O();
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"))
    }
  }
}
function $f_s_Product20__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T20__f__1;
      break
    }
    case 1: {
      return $thiz.T20__f__2;
      break
    }
    case 2: {
      return $thiz.T20__f__3;
      break
    }
    case 3: {
      return $thiz.T20__f__4;
      break
    }
    case 4: {
      return $thiz.T20__f__5;
      break
    }
    case 5: {
      return $thiz.T20__f__6;
      break
    }
    case 6: {
      return $thiz.T20__f__7;
      break
    }
    case 7: {
      return $thiz.T20__f__8;
      break
    }
    case 8: {
      return $thiz.T20__f__9;
      break
    }
    case 9: {
      return $thiz.T20__f__10;
      break
    }
    case 10: {
      return $thiz.T20__f__11;
      break
    }
    case 11: {
      return $thiz.T20__f__12;
      break
    }
    case 12: {
      return $thiz.T20__f__13;
      break
    }
    case 13: {
      return $thiz.T20__f__14;
      break
    }
    case 14: {
      return $thiz.T20__f__15;
      break
    }
    case 15: {
      return $thiz.T20__f__16;
      break
    }
    case 16: {
      return $thiz.T20__f__17;
      break
    }
    case 17: {
      return $thiz.T20__f__18;
      break
    }
    case 18: {
      return $thiz.T20__f__19;
      break
    }
    case 19: {
      return $thiz.T20__f__20;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 19)"))
    }
  }
}
function $f_s_Product21__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T21__f__1;
      break
    }
    case 1: {
      return $thiz.T21__f__2;
      break
    }
    case 2: {
      return $thiz.T21__f__3;
      break
    }
    case 3: {
      return $thiz.T21__f__4;
      break
    }
    case 4: {
      return $thiz.T21__f__5;
      break
    }
    case 5: {
      return $thiz.T21__f__6;
      break
    }
    case 6: {
      return $thiz.T21__f__7;
      break
    }
    case 7: {
      return $thiz.T21__f__8;
      break
    }
    case 8: {
      return $thiz.T21__f__9;
      break
    }
    case 9: {
      return $thiz.T21__f__10;
      break
    }
    case 10: {
      return $thiz.T21__f__11;
      break
    }
    case 11: {
      return $thiz.T21__f__12;
      break
    }
    case 12: {
      return $thiz.T21__f__13;
      break
    }
    case 13: {
      return $thiz.T21__f__14;
      break
    }
    case 14: {
      return $thiz.T21__f__15;
      break
    }
    case 15: {
      return $thiz.T21__f__16;
      break
    }
    case 16: {
      return $thiz.T21__f__17;
      break
    }
    case 17: {
      return $thiz.T21__f__18;
      break
    }
    case 18: {
      return $thiz.T21__f__19;
      break
    }
    case 19: {
      return $thiz.T21__f__20;
      break
    }
    case 20: {
      return $thiz.T21__f__21;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 20)"))
    }
  }
}
function $f_s_Product22__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T22__f__1;
      break
    }
    case 1: {
      return $thiz.T22__f__2;
      break
    }
    case 2: {
      return $thiz.T22__f__3;
      break
    }
    case 3: {
      return $thiz.T22__f__4;
      break
    }
    case 4: {
      return $thiz.T22__f__5;
      break
    }
    case 5: {
      return $thiz.T22__f__6;
      break
    }
    case 6: {
      return $thiz.T22__f__7;
      break
    }
    case 7: {
      return $thiz.T22__f__8;
      break
    }
    case 8: {
      return $thiz.T22__f__9;
      break
    }
    case 9: {
      return $thiz.T22__f__10;
      break
    }
    case 10: {
      return $thiz.T22__f__11;
      break
    }
    case 11: {
      return $thiz.T22__f__12;
      break
    }
    case 12: {
      return $thiz.T22__f__13;
      break
    }
    case 13: {
      return $thiz.T22__f__14;
      break
    }
    case 14: {
      return $thiz.T22__f__15;
      break
    }
    case 15: {
      return $thiz.T22__f__16;
      break
    }
    case 16: {
      return $thiz.T22__f__17;
      break
    }
    case 17: {
      return $thiz.T22__f__18;
      break
    }
    case 18: {
      return $thiz.T22__f__19;
      break
    }
    case 19: {
      return $thiz.T22__f__20;
      break
    }
    case 20: {
      return $thiz.T22__f__21;
      break
    }
    case 21: {
      return $thiz.T22__f__22;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 21)"))
    }
  }
}
function $f_s_Product3__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T3__f__1;
      break
    }
    case 1: {
      return $thiz.T3__f__2;
      break
    }
    case 2: {
      return $thiz.T3__f__3;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"))
    }
  }
}
function $f_s_Product4__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T4__f__1;
      break
    }
    case 1: {
      return $thiz.T4__f__2;
      break
    }
    case 2: {
      return $thiz.T4__f__3;
      break
    }
    case 3: {
      return $thiz.T4__f__4;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"))
    }
  }
}
function $f_s_Product5__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T5__f__1;
      break
    }
    case 1: {
      return $thiz.T5__f__2;
      break
    }
    case 2: {
      return $thiz.T5__f__3;
      break
    }
    case 3: {
      return $thiz.T5__f__4;
      break
    }
    case 4: {
      return $thiz.T5__f__5;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 4)"))
    }
  }
}
function $f_s_Product6__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T6__f__1;
      break
    }
    case 1: {
      return $thiz.T6__f__2;
      break
    }
    case 2: {
      return $thiz.T6__f__3;
      break
    }
    case 3: {
      return $thiz.T6__f__4;
      break
    }
    case 4: {
      return $thiz.T6__f__5;
      break
    }
    case 5: {
      return $thiz.T6__f__6;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 5)"))
    }
  }
}
function $f_s_Product7__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T7__f__1;
      break
    }
    case 1: {
      return $thiz.T7__f__2;
      break
    }
    case 2: {
      return $thiz.T7__f__3;
      break
    }
    case 3: {
      return $thiz.T7__f__4;
      break
    }
    case 4: {
      return $thiz.T7__f__5;
      break
    }
    case 5: {
      return $thiz.T7__f__6;
      break
    }
    case 6: {
      return $thiz.T7__f__7;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 6)"))
    }
  }
}
function $f_s_Product8__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T8__f__1;
      break
    }
    case 1: {
      return $thiz.T8__f__2;
      break
    }
    case 2: {
      return $thiz.T8__f__3;
      break
    }
    case 3: {
      return $thiz.T8__f__4;
      break
    }
    case 4: {
      return $thiz.T8__f__5;
      break
    }
    case 5: {
      return $thiz.T8__f__6;
      break
    }
    case 6: {
      return $thiz.T8__f__7;
      break
    }
    case 7: {
      return $thiz.T8__f__8;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 7)"))
    }
  }
}
function $f_s_Product9__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T9__f__1;
      break
    }
    case 1: {
      return $thiz.T9__f__2;
      break
    }
    case 2: {
      return $thiz.T9__f__3;
      break
    }
    case 3: {
      return $thiz.T9__f__4;
      break
    }
    case 4: {
      return $thiz.T9__f__5;
      break
    }
    case 5: {
      return $thiz.T9__f__6;
      break
    }
    case 6: {
      return $thiz.T9__f__7;
      break
    }
    case 7: {
      return $thiz.T9__f__8;
      break
    }
    case 8: {
      return $thiz.T9__f__9;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 8)"))
    }
  }
}
/** @constructor */
function $c_s_Symbol$() {
  this.s_JSUniquenessCache__f_cache = null;
  $ct_s_JSUniquenessCache__(this)
}
$c_s_Symbol$.prototype = new $h_s_JSUniquenessCache();
$c_s_Symbol$.prototype.constructor = $c_s_Symbol$;
/** @constructor */
function $h_s_Symbol$() {
  /*<skip>*/
}
$h_s_Symbol$.prototype = $c_s_Symbol$.prototype;
var $d_s_Symbol$ = new $TypeData().initClass({
  s_Symbol$: 0
}, false, "scala.Symbol$", {
  s_Symbol$: 1,
  s_JSUniquenessCache: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Symbol$.prototype.$classData = $d_s_Symbol$;
var $n_s_Symbol$;
function $m_s_Symbol$() {
  if ((!$n_s_Symbol$)) {
    $n_s_Symbol$ = new $c_s_Symbol$()
  };
  return $n_s_Symbol$
}
/** @constructor */
function $c_sc_BuildFrom$() {
  $n_sc_BuildFrom$ = this;
  new $c_sc_BuildFrom$$anon$5();
  new $c_sc_BuildFrom$$anon$6()
}
$c_sc_BuildFrom$.prototype = new $h_O();
$c_sc_BuildFrom$.prototype.constructor = $c_sc_BuildFrom$;
/** @constructor */
function $h_sc_BuildFrom$() {
  /*<skip>*/
}
$h_sc_BuildFrom$.prototype = $c_sc_BuildFrom$.prototype;
var $d_sc_BuildFrom$ = new $TypeData().initClass({
  sc_BuildFrom$: 0
}, false, "scala.collection.BuildFrom$", {
  sc_BuildFrom$: 1,
  O: 1,
  sc_BuildFromLowPriority1: 1,
  sc_BuildFromLowPriority2: 1
});
$c_sc_BuildFrom$.prototype.$classData = $d_sc_BuildFrom$;
var $n_sc_BuildFrom$;
function $m_sc_BuildFrom$() {
  if ((!$n_sc_BuildFrom$)) {
    $n_sc_BuildFrom$ = new $c_sc_BuildFrom$()
  };
  return $n_sc_BuildFrom$
}
function $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__($thiz, delegate) {
  $thiz.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null
}
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = new $h_O();
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.constructor = $c_sc_ClassTagIterableFactory$AnyIterableDelegate;
/** @constructor */
function $h_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  /*<skip>*/
}
$h_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = $c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype;
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.empty__O = (function() {
  return $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate).empty__O__O($m_s_reflect_ManifestFactory$AnyManifest$())
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate).from__sc_IterableOnce__O__O(it, $m_s_reflect_ManifestFactory$AnyManifest$())
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate);
  var evidence$12 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$3.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12)
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.apply__sci_Seq__O = (function(elems) {
  var this$3 = $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate);
  var evidence$7 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$3.from__sc_IterableOnce__O__O(elems, evidence$7)
});
function $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__($thiz, delegate) {
  $thiz.sc_EvidenceIterableFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_EvidenceIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null
}
$c_sc_EvidenceIterableFactory$Delegate.prototype = new $h_O();
$c_sc_EvidenceIterableFactory$Delegate.prototype.constructor = $c_sc_EvidenceIterableFactory$Delegate;
/** @constructor */
function $h_sc_EvidenceIterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_EvidenceIterableFactory$Delegate.prototype = $c_sc_EvidenceIterableFactory$Delegate.prototype;
$c_sc_EvidenceIterableFactory$Delegate.prototype.apply__sci_Seq__O__O = (function(xs, evidence$18) {
  return $n(this.sc_EvidenceIterableFactory$Delegate__f_delegate).apply__sci_Seq__O__O(xs, evidence$18)
});
$c_sc_EvidenceIterableFactory$Delegate.prototype.empty__O__O = (function(evidence$19) {
  return $n(this.sc_EvidenceIterableFactory$Delegate__f_delegate).empty__O__O(evidence$19)
});
$c_sc_EvidenceIterableFactory$Delegate.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$20) {
  return $n(this.sc_EvidenceIterableFactory$Delegate__f_delegate).from__sc_IterableOnce__O__O(it, evidence$20)
});
$c_sc_EvidenceIterableFactory$Delegate.prototype.newBuilder__O__scm_Builder = (function(evidence$21) {
  return $n(this.sc_EvidenceIterableFactory$Delegate__f_delegate).newBuilder__O__scm_Builder(evidence$21)
});
/** @constructor */
function $c_sc_Factory$StringFactory() {
  /*<skip>*/
}
$c_sc_Factory$StringFactory.prototype = new $h_O();
$c_sc_Factory$StringFactory.prototype.constructor = $c_sc_Factory$StringFactory;
/** @constructor */
function $h_sc_Factory$StringFactory() {
  /*<skip>*/
}
$h_sc_Factory$StringFactory.prototype = $c_sc_Factory$StringFactory.prototype;
$c_sc_Factory$StringFactory.prototype.fromSpecific__sc_IterableOnce__T = (function(it) {
  var y = $n(it).knownSize__I();
  var b = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), ((y < 0) ? 0 : y));
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, it);
  return $n(b.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sc_Factory$StringFactory.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder())
});
$c_sc_Factory$StringFactory.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return this.fromSpecific__sc_IterableOnce__T(it)
});
var $d_sc_Factory$StringFactory = new $TypeData().initClass({
  sc_Factory$StringFactory: 0
}, false, "scala.collection.Factory$StringFactory", {
  sc_Factory$StringFactory: 1,
  O: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Factory$StringFactory.prototype.$classData = $d_sc_Factory$StringFactory;
function $ct_sc_IterableFactory$Delegate__sc_IterableFactory__($thiz, delegate) {
  $thiz.sc_IterableFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_IterableFactory$Delegate() {
  this.sc_IterableFactory$Delegate__f_delegate = null
}
$c_sc_IterableFactory$Delegate.prototype = new $h_O();
$c_sc_IterableFactory$Delegate.prototype.constructor = $c_sc_IterableFactory$Delegate;
/** @constructor */
function $h_sc_IterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_IterableFactory$Delegate.prototype = $c_sc_IterableFactory$Delegate.prototype;
$c_sc_IterableFactory$Delegate.prototype.empty__O = (function() {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).empty__O()
});
$c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).from__sc_IterableOnce__O(it)
});
$c_sc_IterableFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).newBuilder__scm_Builder()
});
/** @constructor */
function $c_sc_IterableFactory$ToFactory(factory) {
  this.sc_IterableFactory$ToFactory__f_factory = null;
  this.sc_IterableFactory$ToFactory__f_factory = factory
}
$c_sc_IterableFactory$ToFactory.prototype = new $h_O();
$c_sc_IterableFactory$ToFactory.prototype.constructor = $c_sc_IterableFactory$ToFactory;
/** @constructor */
function $h_sc_IterableFactory$ToFactory() {
  /*<skip>*/
}
$h_sc_IterableFactory$ToFactory.prototype = $c_sc_IterableFactory$ToFactory.prototype;
$c_sc_IterableFactory$ToFactory.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_IterableFactory$ToFactory__f_factory).from__sc_IterableOnce__O(it)
});
$c_sc_IterableFactory$ToFactory.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_IterableFactory$ToFactory__f_factory).newBuilder__scm_Builder()
});
var $d_sc_IterableFactory$ToFactory = new $TypeData().initClass({
  sc_IterableFactory$ToFactory: 0
}, false, "scala.collection.IterableFactory$ToFactory", {
  sc_IterableFactory$ToFactory: 1,
  O: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IterableFactory$ToFactory.prototype.$classData = $d_sc_IterableFactory$ToFactory;
/** @constructor */
function $c_sc_IterableOnceOps$$anon$1(outer) {
  /*<skip>*/
}
$c_sc_IterableOnceOps$$anon$1.prototype = new $h_sr_AbstractFunction1();
$c_sc_IterableOnceOps$$anon$1.prototype.constructor = $c_sc_IterableOnceOps$$anon$1;
/** @constructor */
function $h_sc_IterableOnceOps$$anon$1() {
  /*<skip>*/
}
$h_sc_IterableOnceOps$$anon$1.prototype = $c_sc_IterableOnceOps$$anon$1.prototype;
$c_sc_IterableOnceOps$$anon$1.prototype.apply__O__O = (function(v1) {
  return this
});
var $d_sc_IterableOnceOps$$anon$1 = new $TypeData().initClass({
  sc_IterableOnceOps$$anon$1: 0
}, false, "scala.collection.IterableOnceOps$$anon$1", {
  sc_IterableOnceOps$$anon$1: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_sc_IterableOnceOps$$anon$1.prototype.$classData = $d_sc_IterableOnceOps$$anon$1;
/** @constructor */
function $c_sc_IterableOnceOps$Maximized(outer, descriptor, f, cmp) {
  this.sc_IterableOnceOps$Maximized__f_descriptor = null;
  this.sc_IterableOnceOps$Maximized__f_f = null;
  this.sc_IterableOnceOps$Maximized__f_cmp = null;
  this.sc_IterableOnceOps$Maximized__f_maxElem = null;
  this.sc_IterableOnceOps$Maximized__f_maxF = null;
  this.sc_IterableOnceOps$Maximized__f_nonEmpty = false;
  this.sc_IterableOnceOps$Maximized__f_descriptor = descriptor;
  this.sc_IterableOnceOps$Maximized__f_f = f;
  this.sc_IterableOnceOps$Maximized__f_cmp = cmp;
  if ((outer === null)) {
    $n(null)
  };
  this.sc_IterableOnceOps$Maximized__f_maxElem = null;
  this.sc_IterableOnceOps$Maximized__f_maxF = null;
  this.sc_IterableOnceOps$Maximized__f_nonEmpty = false
}
$c_sc_IterableOnceOps$Maximized.prototype = new $h_sr_AbstractFunction2();
$c_sc_IterableOnceOps$Maximized.prototype.constructor = $c_sc_IterableOnceOps$Maximized;
/** @constructor */
function $h_sc_IterableOnceOps$Maximized() {
  /*<skip>*/
}
$h_sc_IterableOnceOps$Maximized.prototype = $c_sc_IterableOnceOps$Maximized.prototype;
$c_sc_IterableOnceOps$Maximized.prototype.result__O = (function() {
  if (this.sc_IterableOnceOps$Maximized__f_nonEmpty) {
    return this.sc_IterableOnceOps$Maximized__f_maxElem
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), ("empty." + this.sc_IterableOnceOps$Maximized__f_descriptor))
  }
});
$c_sc_IterableOnceOps$Maximized.prototype.apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized = (function(m, a) {
  if ($n(m).sc_IterableOnceOps$Maximized__f_nonEmpty) {
    var fa = $n(this.sc_IterableOnceOps$Maximized__f_f).apply__O__O(a);
    if ($uZ($n(this.sc_IterableOnceOps$Maximized__f_cmp).apply__O__O__O(fa, this.sc_IterableOnceOps$Maximized__f_maxF))) {
      this.sc_IterableOnceOps$Maximized__f_maxF = fa;
      this.sc_IterableOnceOps$Maximized__f_maxElem = a
    };
    return m
  } else {
    $n(m).sc_IterableOnceOps$Maximized__f_nonEmpty = true;
    $n(m).sc_IterableOnceOps$Maximized__f_maxElem = a;
    $n(m).sc_IterableOnceOps$Maximized__f_maxF = $n(this.sc_IterableOnceOps$Maximized__f_f).apply__O__O(a);
    return m
  }
});
$c_sc_IterableOnceOps$Maximized.prototype.apply__O__O__O = (function(v1, v2) {
  return this.apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized($as_sc_IterableOnceOps$Maximized(v1), v2)
});
function $as_sc_IterableOnceOps$Maximized(obj) {
  return (((obj instanceof $c_sc_IterableOnceOps$Maximized) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnceOps$Maximized"))
}
function $isArrayOf_sc_IterableOnceOps$Maximized(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnceOps$Maximized)))
}
function $asArrayOf_sc_IterableOnceOps$Maximized(obj, depth) {
  return (($isArrayOf_sc_IterableOnceOps$Maximized(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnceOps$Maximized;", depth))
}
var $d_sc_IterableOnceOps$Maximized = new $TypeData().initClass({
  sc_IterableOnceOps$Maximized: 0
}, false, "scala.collection.IterableOnceOps$Maximized", {
  sc_IterableOnceOps$Maximized: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1
});
$c_sc_IterableOnceOps$Maximized.prototype.$classData = $d_sc_IterableOnceOps$Maximized;
function $f_sc_IterableOps__headOption__s_Option($thiz) {
  var it = $thiz.iterator__sc_Iterator();
  return ($n(it).hasNext__Z() ? new $c_s_Some($n(it).next__O()) : $m_s_None$())
}
function $f_sc_IterableOps__last__O($thiz) {
  var it = $thiz.iterator__sc_Iterator();
  var lst = $n(it).next__O();
  while ($n(it).hasNext__Z()) {
    lst = $n(it).next__O()
  };
  return lst
}
function $f_sc_IterableOps__sizeCompare__I__I($thiz, otherSize) {
  if ((otherSize < 0)) {
    return 1
  } else {
    var known = $thiz.knownSize__I();
    if ((known >= 0)) {
      return ((known === otherSize) ? 0 : ((known < otherSize) ? (-1) : 1))
    } else {
      var i = 0;
      var it = $thiz.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        if ((i === otherSize)) {
          return 1
        };
        $n(it).next__O();
        i = ((1 + i) | 0)
      };
      return ((i - otherSize) | 0)
    }
  }
}
function $f_sc_IterableOps__filter__F1__O($thiz, pred) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$Filter($thiz, pred, false))
}
function $f_sc_IterableOps__filterNot__F1__O($thiz, pred) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$Filter($thiz, pred, true))
}
function $f_sc_IterableOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Take__sc_IterableOps__I__(new $c_sc_View$Take(), $thiz, n))
}
function $f_sc_IterableOps__takeWhile__F1__O($thiz, p) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$TakeWhile($thiz, p))
}
function $f_sc_IterableOps__span__F1__T2($thiz, p) {
  return $ct_T2__O__O__(new $c_T2(), $thiz.takeWhile__F1__O(p), $thiz.dropWhile__F1__O(p))
}
function $f_sc_IterableOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $thiz, n))
}
function $f_sc_IterableOps__dropRight__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$DropRight__sc_IterableOps__I__(new $c_sc_View$DropRight(), $thiz, n))
}
function $f_sc_IterableOps__dropWhile__F1__O($thiz, p) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$DropWhile($thiz, p))
}
function $f_sc_IterableOps__sliding__I__I__sc_Iterator($thiz, size, step) {
  var this$1 = $n($thiz.iterator__sc_Iterator());
  var this$3 = new $c_sc_Iterator$GroupedIterator(this$1, this$1, size, step);
  var f = new $c_sjsr_AnonFunction1(((coll$2) => {
    var coll = $as_sc_IterableOnce(coll$2);
    return $thiz.fromSpecific__sc_IterableOnce__O(coll)
  }));
  return new $c_sc_Iterator$$anon$9(this$3, f)
}
function $f_sc_IterableOps__tail__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  };
  return $thiz.drop__I__O(1)
}
function $f_sc_IterableOps__init__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  };
  return $thiz.dropRight__I__O(1)
}
function $f_sc_IterableOps__slice__I__I__O($thiz, from, until) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $ct_sc_View$Take__sc_IterableOps__I__(new $c_sc_View$Take(), $thiz, until), from))
}
function $f_sc_IterableOps__groupBy__F1__sci_Map($thiz, f) {
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var key = $n(f).apply__O__O(elem);
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => $thiz.newSpecificBuilder__scm_Builder()))));
    var this$2 = $n(bldr);
    this$2.addOne__O__scm_Growable(elem)
  };
  var this$3 = $m_sci_HashMap$();
  var result = this$3.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
  };
  return result
}
function $f_sc_IterableOps__scanLeft__O__F2__O($thiz, z, op) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$ScanLeft($thiz, z, op))
}
function $f_sc_IterableOps__map__F1__O($thiz, f) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f))
}
function $f_sc_IterableOps__flatMap__F1__O($thiz, f) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$FlatMap($thiz, f))
}
function $f_sc_IterableOps__collect__s_PartialFunction__O($thiz, pf) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$Collect($thiz, pf))
}
function $f_sc_IterableOps__concat__sc_IterableOnce__O($thiz, suffix) {
  var $$x2 = $n($thiz.iterableFactory__sc_IterableFactory());
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $$x1 = new $c_sc_View$Concat($thiz, x2)
  } else {
    var this$2 = $n($thiz.iterator__sc_Iterator());
    var xs = new $c_sjsr_AnonFunction0((() => $n(suffix).iterator__sc_Iterator()));
    var $$x1 = this$2.concat__F0__sc_Iterator(xs)
  };
  return $n($$x2).from__sc_IterableOnce__O($$x1)
}
function $f_sc_IterableOps__zip__sc_IterableOnce__O($thiz, that) {
  var $$x2 = $n($thiz.iterableFactory__sc_IterableFactory());
  if ($is_sc_Iterable(that)) {
    var x2 = $as_sc_Iterable(that);
    var $$x1 = new $c_sc_View$Zip($thiz, x2)
  } else {
    var this$1 = $n($thiz.iterator__sc_Iterator());
    var $$x1 = new $c_sc_Iterator$$anon$14(this$1, that)
  };
  return $n($$x2).from__sc_IterableOnce__O($$x1)
}
function $f_sc_IterableOps__zipWithIndex__O($thiz) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$ZipWithIndex($thiz))
}
function $is_sc_IterableOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOps)))
}
function $as_sc_IterableOps(obj) {
  return (($is_sc_IterableOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOps"))
}
function $isArrayOf_sc_IterableOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOps)))
}
function $asArrayOf_sc_IterableOps(obj, depth) {
  return (($isArrayOf_sc_IterableOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOps;", depth))
}
function $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__($thiz, self, p) {
  $thiz.sc_IterableOps$WithFilter__f_self = self;
  $thiz.sc_IterableOps$WithFilter__f_p = p;
  return $thiz
}
/** @constructor */
function $c_sc_IterableOps$WithFilter() {
  this.sc_IterableOps$WithFilter__f_self = null;
  this.sc_IterableOps$WithFilter__f_p = null
}
$c_sc_IterableOps$WithFilter.prototype = new $h_sc_WithFilter();
$c_sc_IterableOps$WithFilter.prototype.constructor = $c_sc_IterableOps$WithFilter;
/** @constructor */
function $h_sc_IterableOps$WithFilter() {
  /*<skip>*/
}
$h_sc_IterableOps$WithFilter.prototype = $c_sc_IterableOps$WithFilter.prototype;
$c_sc_IterableOps$WithFilter.prototype.filtered__sc_Iterable = (function() {
  return new $c_sc_View$Filter(this.sc_IterableOps$WithFilter__f_self, this.sc_IterableOps$WithFilter__f_p, false)
});
$c_sc_IterableOps$WithFilter.prototype.map__F1__O = (function(f) {
  return $n($n(this.sc_IterableOps$WithFilter__f_self).iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), this.filtered__sc_Iterable(), f))
});
$c_sc_IterableOps$WithFilter.prototype.flatMap__F1__O = (function(f) {
  return $n($n(this.sc_IterableOps$WithFilter__f_self).iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$FlatMap(this.filtered__sc_Iterable(), f))
});
$c_sc_IterableOps$WithFilter.prototype.foreach__F1__V = (function(f) {
  $n(this.filtered__sc_Iterable()).foreach__F1__V(f)
});
$c_sc_IterableOps$WithFilter.prototype.withFilter__F1__sc_IterableOps$WithFilter = (function(q) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this.sc_IterableOps$WithFilter__f_self, new $c_sjsr_AnonFunction1(((a$2) => ($uZ($n(this.sc_IterableOps$WithFilter__f_p).apply__O__O(a$2)) && $uZ($n(q).apply__O__O(a$2))))))
});
$c_sc_IterableOps$WithFilter.prototype.withFilter__F1__sc_WithFilter = (function(q) {
  return this.withFilter__F1__sc_IterableOps$WithFilter(q)
});
var $d_sc_IterableOps$WithFilter = new $TypeData().initClass({
  sc_IterableOps$WithFilter: 0
}, false, "scala.collection.IterableOps$WithFilter", {
  sc_IterableOps$WithFilter: 1,
  sc_WithFilter: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IterableOps$WithFilter.prototype.$classData = $d_sc_IterableOps$WithFilter;
function $f_sc_Iterator__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var dropped = $thiz.drop__I__sc_Iterator(from);
  while ($n(dropped).hasNext__Z()) {
    if ($uZ($n(p).apply__O__O($n(dropped).next__O()))) {
      return i
    };
    i = ((1 + i) | 0)
  };
  return (-1)
}
function $f_sc_Iterator__concat__F0__sc_Iterator($thiz, xs) {
  return new $c_sc_Iterator$ConcatIterator($thiz).concat__F0__sc_Iterator(xs)
}
function $f_sc_Iterator__take__I__sc_Iterator($thiz, n) {
  return $thiz.sliceIterator__I__I__sc_Iterator(0, ((n > 0) ? n : 0))
}
function $f_sc_Iterator__sliceIterator__I__I__sc_Iterator($thiz, from, until) {
  var lo = ((from > 0) ? from : 0);
  var rest = ((until < 0) ? (-1) : ((until <= lo) ? 0 : ((until - lo) | 0)));
  return ((rest === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_Iterator$SliceIterator($thiz, lo, rest))
}
function $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz, that) {
  var those = $n(that).iterator__sc_Iterator();
  while (($thiz.hasNext__Z() && $n(those).hasNext__Z())) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($thiz.next__O(), $n(those).next__O()))) {
      return false
    }
  };
  return ($thiz.hasNext__Z() === $n(those).hasNext__Z())
}
function $is_sc_Iterator(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterator)))
}
function $as_sc_Iterator(obj) {
  return (($is_sc_Iterator(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator"))
}
function $isArrayOf_sc_Iterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator)))
}
function $asArrayOf_sc_Iterator(obj, depth) {
  return (($isArrayOf_sc_Iterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator;", depth))
}
/** @constructor */
function $c_sc_Iterator$() {
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = null;
  $n_sc_Iterator$ = this;
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = new $c_sc_Iterator$$anon$19()
}
$c_sc_Iterator$.prototype = new $h_O();
$c_sc_Iterator$.prototype.constructor = $c_sc_Iterator$;
/** @constructor */
function $h_sc_Iterator$() {
  /*<skip>*/
}
$h_sc_Iterator$.prototype = $c_sc_Iterator$.prototype;
$c_sc_Iterator$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sc_Iterator$$anon$21()
});
$c_sc_Iterator$.prototype.empty__O = (function() {
  return this.sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sc_Iterator$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $n(source).iterator__sc_Iterator()
});
var $d_sc_Iterator$ = new $TypeData().initClass({
  sc_Iterator$: 0
}, false, "scala.collection.Iterator$", {
  sc_Iterator$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Iterator$.prototype.$classData = $d_sc_Iterator$;
var $n_sc_Iterator$;
function $m_sc_Iterator$() {
  if ((!$n_sc_Iterator$)) {
    $n_sc_Iterator$ = new $c_sc_Iterator$()
  };
  return $n_sc_Iterator$
}
/** @constructor */
function $c_sc_JavaConverters$() {
  /*<skip>*/
}
$c_sc_JavaConverters$.prototype = new $h_O();
$c_sc_JavaConverters$.prototype.constructor = $c_sc_JavaConverters$;
/** @constructor */
function $h_sc_JavaConverters$() {
  /*<skip>*/
}
$h_sc_JavaConverters$.prototype = $c_sc_JavaConverters$.prototype;
$c_sc_JavaConverters$.prototype.setAsJavaSetConverter__sc_Set__sc_JavaConverters$AsJava = (function(s) {
  return new $c_sc_JavaConverters$AsJava(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_sc_JavaConverters$();
    return $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set(this$2, s)
  })))
});
$c_sc_JavaConverters$.prototype.mapAsJavaMapConverter__sc_Map__sc_JavaConverters$AsJava = (function(m) {
  return new $c_sc_JavaConverters$AsJava(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_sc_JavaConverters$();
    return $f_sc_convert_AsJavaConverters__asJava__sc_Map__ju_Map(this$2, m)
  })))
});
$c_sc_JavaConverters$.prototype.asScalaSetConverter__ju_Set__sc_JavaConverters$AsScala = (function(s) {
  return new $c_sc_JavaConverters$AsScala(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_sc_JavaConverters$();
    return $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set(this$2, s)
  })))
});
$c_sc_JavaConverters$.prototype.mapAsScalaMapConverter__ju_Map__sc_JavaConverters$AsScala = (function(m) {
  return new $c_sc_JavaConverters$AsScala(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_sc_JavaConverters$();
    return $f_sc_convert_AsScalaConverters__asScala__ju_Map__scm_Map(this$2, m)
  })))
});
var $d_sc_JavaConverters$ = new $TypeData().initClass({
  sc_JavaConverters$: 0
}, false, "scala.collection.JavaConverters$", {
  sc_JavaConverters$: 1,
  O: 1,
  sc_convert_AsJavaConverters: 1,
  sc_convert_AsScalaConverters: 1
});
$c_sc_JavaConverters$.prototype.$classData = $d_sc_JavaConverters$;
var $n_sc_JavaConverters$;
function $m_sc_JavaConverters$() {
  if ((!$n_sc_JavaConverters$)) {
    $n_sc_JavaConverters$ = new $c_sc_JavaConverters$()
  };
  return $n_sc_JavaConverters$
}
function $ct_sc_MapFactory$Delegate__sc_MapFactory__($thiz, delegate) {
  $thiz.sc_MapFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_MapFactory$Delegate() {
  this.sc_MapFactory$Delegate__f_delegate = null
}
$c_sc_MapFactory$Delegate.prototype = new $h_O();
$c_sc_MapFactory$Delegate.prototype.constructor = $c_sc_MapFactory$Delegate;
/** @constructor */
function $h_sc_MapFactory$Delegate() {
  /*<skip>*/
}
$h_sc_MapFactory$Delegate.prototype = $c_sc_MapFactory$Delegate.prototype;
$c_sc_MapFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return $n(this.sc_MapFactory$Delegate__f_delegate).apply__sci_Seq__O(elems)
});
$c_sc_MapFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_MapFactory$Delegate__f_delegate).from__sc_IterableOnce__O(it)
});
$c_sc_MapFactory$Delegate.prototype.empty__O = (function() {
  return $n(this.sc_MapFactory$Delegate__f_delegate).empty__O()
});
$c_sc_MapFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_MapFactory$Delegate__f_delegate).newBuilder__scm_Builder()
});
function $ct_sc_SortedMapFactory$Delegate__sc_SortedMapFactory__($thiz, delegate) {
  $thiz.sc_SortedMapFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_SortedMapFactory$Delegate() {
  this.sc_SortedMapFactory$Delegate__f_delegate = null
}
$c_sc_SortedMapFactory$Delegate.prototype = new $h_O();
$c_sc_SortedMapFactory$Delegate.prototype.constructor = $c_sc_SortedMapFactory$Delegate;
/** @constructor */
function $h_sc_SortedMapFactory$Delegate() {
  /*<skip>*/
}
$h_sc_SortedMapFactory$Delegate.prototype = $c_sc_SortedMapFactory$Delegate.prototype;
$c_sc_SortedMapFactory$Delegate.prototype.apply__sci_Seq__s_math_Ordering__O = (function(elems, evidence$45) {
  return $n(this.sc_SortedMapFactory$Delegate__f_delegate).apply__sci_Seq__s_math_Ordering__O(elems, evidence$45)
});
$c_sc_SortedMapFactory$Delegate.prototype.from__sc_IterableOnce__s_math_Ordering__O = (function(it, evidence$46) {
  return $n(this.sc_SortedMapFactory$Delegate__f_delegate).from__sc_IterableOnce__s_math_Ordering__O(it, evidence$46)
});
$c_sc_SortedMapFactory$Delegate.prototype.empty__s_math_Ordering__O = (function(evidence$47) {
  return $n(this.sc_SortedMapFactory$Delegate__f_delegate).empty__s_math_Ordering__O(evidence$47)
});
$c_sc_SortedMapFactory$Delegate.prototype.newBuilder__s_math_Ordering__scm_Builder = (function(evidence$48) {
  return $n(this.sc_SortedMapFactory$Delegate__f_delegate).newBuilder__s_math_Ordering__scm_Builder(evidence$48)
});
/** @constructor */
function $c_sc_View$() {
  /*<skip>*/
}
$c_sc_View$.prototype = new $h_O();
$c_sc_View$.prototype.constructor = $c_sc_View$;
/** @constructor */
function $h_sc_View$() {
  /*<skip>*/
}
$h_sc_View$.prototype = $c_sc_View$.prototype;
$c_sc_View$.prototype.from__sc_IterableOnce__sc_View = (function(it) {
  if ($is_sc_View(it)) {
    var x2 = $as_sc_View(it);
    return x2
  } else if ($is_sc_Iterable(it)) {
    var x3 = $as_sc_Iterable(it);
    var it$1 = new $c_sjsr_AnonFunction0((() => $n(x3).iterator__sc_Iterator()));
    return new $c_sc_View$$anon$1(it$1)
  } else {
    var this$3 = $n($m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(it));
    return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this$3)
  }
});
$c_sc_View$.prototype.newBuilder__scm_Builder = (function() {
  $m_scm_ArrayBuffer$();
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((it$2) => {
    var it = $as_sc_IterableOnce(it$2);
    return $m_sc_View$().from__sc_IterableOnce__sc_View(it)
  }));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sc_View$.prototype.dropRightIterator__sc_Iterator__I__sc_Iterator = (function(it, n) {
  if ((n <= 0)) {
    return it
  } else {
    var k = $n(it).knownSize__I();
    return ((k >= 0) ? $n(it).take__I__sc_Iterator(((k - n) | 0)) : new $c_sc_View$DropRightIterator(it, n))
  }
});
$c_sc_View$.prototype.empty__O = (function() {
  return $m_sc_View$Empty$()
});
$c_sc_View$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_View(source)
});
var $d_sc_View$ = new $TypeData().initClass({
  sc_View$: 0
}, false, "scala.collection.View$", {
  sc_View$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$.prototype.$classData = $d_sc_View$;
var $n_sc_View$;
function $m_sc_View$() {
  if ((!$n_sc_View$)) {
    $n_sc_View$ = new $c_sc_View$()
  };
  return $n_sc_View$
}
/** @constructor */
function $c_sci_BitmapIndexedMapNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedMapNode__f_dataMap = 0;
  this.sci_BitmapIndexedMapNode__f_nodeMap = 0;
  this.sci_BitmapIndexedMapNode__f_content = null;
  this.sci_BitmapIndexedMapNode__f_originalHashes = null;
  this.sci_BitmapIndexedMapNode__f_size = 0;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedMapNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedMapNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedMapNode__f_content = content;
  this.sci_BitmapIndexedMapNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedMapNode__f_size = size;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode
}
$c_sci_BitmapIndexedMapNode.prototype = new $h_sci_MapNode();
$c_sci_BitmapIndexedMapNode.prototype.constructor = $c_sci_BitmapIndexedMapNode;
/** @constructor */
function $h_sci_BitmapIndexedMapNode() {
  /*<skip>*/
}
$h_sci_BitmapIndexedMapNode.prototype = $c_sci_BitmapIndexedMapNode.prototype;
$c_sci_BitmapIndexedMapNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_size
});
$c_sci_BitmapIndexedMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode
});
$c_sci_BitmapIndexedMapNode.prototype.getKey__I__O = (function(index) {
  return $n(this.sci_BitmapIndexedMapNode__f_content).get((index << 1))
});
$c_sci_BitmapIndexedMapNode.prototype.getValue__I__O = (function(index) {
  return $n(this.sci_BitmapIndexedMapNode__f_content).get(((1 + (index << 1)) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.getPayload__I__T2 = (function(index) {
  return $ct_T2__O__O__(new $c_T2(), $n(this.sci_BitmapIndexedMapNode__f_content).get((index << 1)), $n(this.sci_BitmapIndexedMapNode__f_content).get(((1 + (index << 1)) | 0)))
});
$c_sci_BitmapIndexedMapNode.prototype.getHash__I__I = (function(index) {
  return $n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(index)
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  return $as_sci_MapNode($n(this.sci_BitmapIndexedMapNode__f_content).get((((((-1) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - index) | 0)))
});
$c_sci_BitmapIndexedMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index))) {
      return this.getValue__I__O(index)
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    return $n(this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos))).apply__O__I__I__I__O(key, originalHash, keyHash, ((5 + shift) | 0))
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_BitmapIndexedMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? new $c_s_Some(this.getValue__I__O(index)) : $m_s_None$())
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return $n(this.getNode__I__sci_MapNode(index$2)).get__O__I__I__I__s_Option(key, originalHash, keyHash, ((5 + shift) | 0))
  } else {
    return $m_s_None$()
  }
});
$c_sci_BitmapIndexedMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, keyHash, shift, f) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? this.getValue__I__O(index) : $n(f).apply__O())
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return $n(this.getNode__I__sci_MapNode(index$2)).getOrElse__O__I__I__I__F0__O(key, originalHash, keyHash, ((5 + shift) | 0), f)
  } else {
    return $n(f).apply__O()
  }
});
$c_sci_BitmapIndexedMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    return (($n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index)))
  } else {
    return (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0) && $n(this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos))).containsKey__O__I__I__I__Z(key, originalHash, keyHash, ((5 + shift) | 0)))
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode = (function(key, value, originalHash, keyHash, shift, replaceValue) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      if (replaceValue) {
        var value0 = this.getValue__I__O(index);
        return ((Object.is(key0, key) && Object.is(value0, value)) ? this : this.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode(bitpos, key, value))
      } else {
        return this
      }
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      return this.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew)
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew$2 = $n(subNode).updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), replaceValue);
    return ((subNodeNew$2 === subNode) ? this : this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew$2))
  } else {
    return this.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode(bitpos, key, originalHash, keyHash, value)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_BitmapIndexedMapNode = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key0, key)) {
      var i = this.sci_BitmapIndexedMapNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
        var $$x1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(keyHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(1), this.getValue__I__O(1)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(1)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1))) : new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(0), this.getValue__I__O(0)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(0)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0))))
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode(bitpos, keyHash)
      }
    } else {
      return this
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew = $n(subNode).removed__O__I__I__I__sci_MapNode(key, originalHash, keyHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this
    };
    var subNodeNewSize = $n(subNodeNew).size__I();
    return ((subNodeNewSize === 1) ? ((this.sci_BitmapIndexedMapNode__f_size === $n(subNode).size__I()) ? $as_sci_BitmapIndexedMapNode(subNodeNew) : this.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew)) : ((subNodeNewSize > 1) ? this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew) : this))
  } else {
    return this
  }
});
$c_sci_BitmapIndexedMapNode.prototype.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode = (function(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [$ct_T2__O__O__(new $c_T2(), key0, value0), $ct_T2__O__O__(new $c_T2(), key1, value1)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionMapNode(originalHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    var newCachedHash = ((keyHash0 + keyHash1) | 0);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key0, value0, key1, value1]), new $ac_I(new Int32Array([originalHash0, originalHash1])), 2, newCachedHash) : new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key1, value1, key0, value0]), new $ac_I(new Int32Array([originalHash1, originalHash0])), 2, newCachedHash))
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedMapNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, $n(node).size__I(), $n(node).cachedJavaKeySetHashCode__I())
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_nodeMap !== 0)
});
$c_sci_BitmapIndexedMapNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_dataMap !== 0)
});
$c_sci_BitmapIndexedMapNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode = (function(bitpos, newKey, newValue) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  var length = $n(src).u.length;
  $systemArraycopyRefs($n(src), 0, dst, 0, length);
  $n(dst).set(((1 + idx) | 0), newValue);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  var length = $n(src).u.length;
  $systemArraycopyRefs($n(src), 0, dst, 0, length);
  $n(dst).set(idx, newNode);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, ((((this.sci_BitmapIndexedMapNode__f_size - $n(oldNode).size__I()) | 0) + $n(newNode).size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(newNode).cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode = (function(bitpos, key, originalHash, keyHash, value) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idx);
  $n(dst).set(idx, key);
  $n(dst).set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = (($n(src).u.length - idx) | 0);
  $systemArraycopyRefs($n(src), idx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode = (function(bitpos, keyHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-2) + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idx);
  var srcPos = ((2 + idx) | 0);
  var length = (((-2) + (($n(src).u.length - idx) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, idx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, idxOld, length);
  $n(dst).set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + (($n(src).u.length - idxNew) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedMapNode__f_nodeMap = (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedMapNode__f_content = dst;
  this.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedMapNode__f_size = (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + $n(node).size__I()) | 0);
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0);
  return this
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, idxOld, length);
  $n(dst).set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + (($n(src).u.length - idxNew) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + $n(node).size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, node) {
  var idxOld = (((((-1) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var idxNew = (dataIxNew << 1);
  var key = $n(node).getKey__I__O(0);
  var value = $n(node).getValue__I__O(0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((1 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idxNew);
  $n(dst).set(idxNew, key);
  $n(dst).set(((1 + idxNew) | 0), value);
  var destPos = ((2 + idxNew) | 0);
  var length = ((idxOld - idxNew) | 0);
  $systemArraycopyRefs($n(src), idxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((2 + idxOld) | 0);
  var length$1 = (((-1) + (($n(src).u.length - idxOld) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, destPos$1, length$1);
  var hash = $n(node).getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedMapNode__f_size - $n(oldNode).size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    $n(f).apply__O__O(this.getPayload__I__T2(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_MapNode(j)).foreach__F1__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachEntry__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    $n(f).apply__O__O__O(this.getKey__I__O(i$1), this.getValue__I__O(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_MapNode(j)).foreachEntry__F2__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var i = 0;
  var i$1 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i$1);
  while ((i < iN)) {
    $n(f).apply__O__O__O__O(this.getKey__I__O(i), this.getValue__I__O(i), this.getHash__I__I(i));
    i = ((1 + i) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_MapNode(j)).foreachWithHash__F3__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this === x2)) {
      return true
    } else {
      if (((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode === $n(x2).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedMapNode__f_nodeMap === $n(x2).sci_BitmapIndexedMapNode__f_nodeMap)) && (this.sci_BitmapIndexedMapNode__f_dataMap === $n(x2).sci_BitmapIndexedMapNode__f_dataMap)) && (this.sci_BitmapIndexedMapNode__f_size === $n(x2).sci_BitmapIndexedMapNode__f_size))) {
        var a = this.sci_BitmapIndexedMapNode__f_originalHashes;
        var b = $n(x2).sci_BitmapIndexedMapNode__f_originalHashes;
        var $$x1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a1 = this.sci_BitmapIndexedMapNode__f_content;
        var a2 = $n(x2).sci_BitmapIndexedMapNode__f_content;
        var length = $n(this.sci_BitmapIndexedMapNode__f_content).u.length;
        if ((a1 === a2)) {
          return true
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z($n(a1).get(i), $n(a2).get(i));
            i = ((1 + i) | 0)
          };
          return isEqual
        }
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_BitmapIndexedMapNode = (function() {
  var this$1 = $n(this.sci_BitmapIndexedMapNode__f_content);
  var contentClone = $n(this$1).clone__O();
  var contentLength = $n(contentClone).u.length;
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var i$1 = ($m_jl_Integer$().bitCount__I__I(i) << 1);
  while ((i$1 < contentLength)) {
    $n(contentClone).set(i$1, $n($as_sci_MapNode($n(contentClone).get(i$1))).copy__sci_MapNode());
    i$1 = ((1 + i$1) | 0)
  };
  var $$x2 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var $$x1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var this$2 = $n(this.sci_BitmapIndexedMapNode__f_originalHashes);
  return new $c_sci_BitmapIndexedMapNode($$x2, $$x1, contentClone, $n(this$2).clone__O(), this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_BitmapIndexedMapNode = (function(pred, flipped) {
  if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
    return this
  } else if ((this.sci_BitmapIndexedMapNode__f_size === 1)) {
    if (($uZ($n(pred).apply__O__O(this.getPayload__I__T2(0))) !== flipped)) {
      return this
    } else {
      var this$1 = $m_sci_MapNode$();
      return this$1.sci_MapNode$__f_EmptyMapNode
    }
  } else if ((this.sci_BitmapIndexedMapNode__f_nodeMap === 0)) {
    var i = this.sci_BitmapIndexedMapNode__f_dataMap;
    if ((i === 0)) {
      var minimumIndex = 32
    } else {
      var i$1 = (i & ((-i) | 0));
      var minimumIndex = ((31 - $uI(Math.clz32(i$1))) | 0)
    };
    var i$2 = this.sci_BitmapIndexedMapNode__f_dataMap;
    var maximumIndex = ((32 - $uI(Math.clz32(i$2))) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i$3);
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload = this.getPayload__I__T2(dataIndex);
        var passed = ($uZ($n(pred).apply__O__O(payload)) !== flipped);
        if (passed) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex))) | 0)
        };
        dataIndex = ((1 + dataIndex) | 0)
      };
      i$3 = ((1 + i$3) | 0)
    };
    if ((newDataMap === 0)) {
      var this$4 = $m_sci_MapNode$();
      return this$4.sci_MapNode$__f_EmptyMapNode
    } else if ((newDataMap === this.sci_BitmapIndexedMapNode__f_dataMap)) {
      return this
    } else {
      var i$4 = newDataMap;
      var newSize = $m_jl_Integer$().bitCount__I__I(i$4);
      var newContent = new $ac_O((newSize << 1));
      var newOriginalHashCodes = new $ac_I(newSize);
      var i$5 = newDataMap;
      var newMaximumIndex = ((32 - $uI(Math.clz32(i$5))) | 0);
      var i$6 = newDataMap;
      if ((i$6 === 0)) {
        var j = 32
      } else {
        var i$7 = (i$6 & ((-i$6) | 0));
        var j = ((31 - $uI(Math.clz32(i$7))) | 0)
      };
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().bitposFrom__I__I(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, bitpos$2);
          $n(newContent).set((newDataIndex << 1), $n(this.sci_BitmapIndexedMapNode__f_content).get((oldIndex << 1)));
          $n(newContent).set(((1 + (newDataIndex << 1)) | 0), $n(this.sci_BitmapIndexedMapNode__f_content).get(((1 + (oldIndex << 1)) | 0)));
          $n(newOriginalHashCodes).set(newDataIndex, $n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(oldIndex));
          newDataIndex = ((1 + newDataIndex) | 0)
        };
        j = ((1 + j) | 0)
      };
      return new $c_sci_BitmapIndexedMapNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode)
    }
  } else {
    var allMap = (this.sci_BitmapIndexedMapNode__f_dataMap | this.sci_BitmapIndexedMapNode__f_nodeMap);
    if ((allMap === 0)) {
      var minimumIndex$2 = 32
    } else {
      var i$8 = (allMap & ((-allMap) | 0));
      var minimumIndex$2 = ((31 - $uI(Math.clz32(i$8))) | 0)
    };
    var maximumIndex$2 = ((32 - $uI(Math.clz32(allMap))) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().bitposFrom__I__I(i$2$1);
      if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload$2 = this.getPayload__I__T2(dataIndex$2);
        var passed$2 = ($uZ($n(pred).apply__O__O(payload$2)) !== flipped);
        if (passed$2) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex$2))) | 0)
        };
        dataIndex$2 = ((1 + dataIndex$2) | 0)
      } else if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        var oldSubNode = this.getNode__I__sci_MapNode(nodeIndex);
        var newSubNode = $n(oldSubNode).filterImpl__F1__Z__sci_MapNode(pred, flipped);
        newSize$2 = ((newSize$2 + $n(newSubNode).size__I()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + $n(newSubNode).cachedJavaKeySetHashCode__I()) | 0);
        if (($n(newSubNode).size__I() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3)
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16)
            };
            var this$10 = $n(newNodes);
            this$10.addOne__O__scm_ArrayDeque(newSubNode)
          }
        } else if (($n(newSubNode).size__I() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            var elems = $m_sci_Nil$();
            var this$12 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            nodesToMigrateToData = $as_scm_Queue(this$12.addAll__sc_IterableOnce__scm_ArrayDeque(elems))
          };
          var this$13 = $n(nodesToMigrateToData);
          this$13.addOne__O__scm_ArrayDeque(newSubNode)
        };
        nodeIndex = ((1 + nodeIndex) | 0)
      };
      i$2$1 = ((1 + i$2$1) | 0)
    };
    if ((newSize$2 === 0)) {
      var this$14 = $m_sci_MapNode$();
      return this$14.sci_MapNode$__f_EmptyMapNode
    } else if ((newSize$2 === this.sci_BitmapIndexedMapNode__f_size)) {
      return this
    } else {
      var i$9 = newDataMap$2;
      var newDataSize = $m_jl_Integer$().bitCount__I__I(i$9);
      var i$10 = newNodeMap;
      var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(i$10)) | 0);
      var newContent$2 = new $ac_O(newContentSize);
      var newOriginalHashes = new $ac_I(newDataSize);
      var newAllMap = (newDataMap$2 | newNodeMap);
      var maxIndex = ((32 - $uI(Math.clz32(newAllMap))) | 0);
      var i$3$1 = minimumIndex$2;
      var oldDataIndex = 0;
      var oldNodeIndex = 0;
      var newDataIndex$2 = 0;
      var newNodeIndex = 0;
      while ((i$3$1 < maxIndex)) {
        var bitpos$4 = $m_sci_Node$().bitposFrom__I__I(i$3$1);
        if (((bitpos$4 & oldDataPassThrough) !== 0)) {
          $n(newContent$2).set((newDataIndex$2 << 1), this.getKey__I__O(oldDataIndex));
          $n(newContent$2).set(((1 + (newDataIndex$2 << 1)) | 0), this.getValue__I__O(oldDataIndex));
          $n(newOriginalHashes).set(newDataIndex$2, this.getHash__I__I(oldDataIndex));
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldDataIndex = ((1 + oldDataIndex) | 0)
        } else if (((bitpos$4 & nodesToPassThroughMap) !== 0)) {
          $n(newContent$2).set((((-1) + ((newContentSize - newNodeIndex) | 0)) | 0), this.getNode__I__sci_MapNode(oldNodeIndex));
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0)
        } else if (((bitpos$4 & nodeMigrateToDataTargetMap) !== 0)) {
          var this$16 = $n(nodesToMigrateToData);
          var node = $as_sci_MapNode(this$16.removeHead__Z__O(false));
          $n(newContent$2).set((newDataIndex$2 << 1), $n(node).getKey__I__O(0));
          $n(newContent$2).set(((1 + (newDataIndex$2 << 1)) | 0), $n(node).getValue__I__O(0));
          $n(newOriginalHashes).set(newDataIndex$2, $n(node).getHash__I__I(0));
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0)
        } else if (((bitpos$4 & mapOfNewNodes) !== 0)) {
          var $$x2 = $n(newContent$2);
          var $$x1 = newNodeIndex;
          var this$17 = $n(newNodes);
          $$x2.set((((-1) + ((newContentSize - $$x1) | 0)) | 0), this$17.removeHead__Z__O(false));
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0)
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          oldDataIndex = ((1 + oldDataIndex) | 0)
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          oldNodeIndex = ((1 + oldNodeIndex) | 0)
        };
        i$3$1 = ((1 + i$3$1) | 0)
      };
      return new $c_sci_BitmapIndexedMapNode(newDataMap$2, newNodeMap, newContent$2, newOriginalHashes, newSize$2, newCachedHashCode$2)
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, isFlipped) {
  return this.filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped)
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_MapNode = (function() {
  return this.copy__sci_BitmapIndexedMapNode()
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, originalHash, hash, shift)
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, hash, shift, replaceValue)
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index)
});
function $as_sci_BitmapIndexedMapNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedMapNode"))
}
function $isArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedMapNode)))
}
function $asArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedMapNode;", depth))
}
var $d_sci_BitmapIndexedMapNode = new $TypeData().initClass({
  sci_BitmapIndexedMapNode: 0
}, false, "scala.collection.immutable.BitmapIndexedMapNode", {
  sci_BitmapIndexedMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_BitmapIndexedMapNode.prototype.$classData = $d_sci_BitmapIndexedMapNode;
function $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode($thiz, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode) {
  if ((newSize === 0)) {
    var this$1 = $m_sci_SetNode$();
    return this$1.sci_SetNode$__f_EmptySetNode
  } else if ((newSize === $thiz.sci_BitmapIndexedSetNode__f_size)) {
    return $thiz
  } else {
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newAllMap = (newDataMap | newNodeMap);
    var maxIndex = ((32 - $uI(Math.clz32(newAllMap))) | 0);
    var i = minimumIndex;
    var oldDataIndex = 0;
    var oldNodeIndex = 0;
    var newDataIndex = 0;
    var newNodeIndex = 0;
    while ((i < maxIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i);
      if (((bitpos & oldDataPassThrough) !== 0)) {
        $n(newContent).set(newDataIndex, $thiz.getPayload__I__O(oldDataIndex));
        $n(newOriginalHashes).set(newDataIndex, $thiz.getHash__I__I(oldDataIndex));
        newDataIndex = ((1 + newDataIndex) | 0);
        oldDataIndex = ((1 + oldDataIndex) | 0)
      } else if (((bitpos & nodesToPassThroughMap) !== 0)) {
        $n(newContent).set((((-1) + ((newContentSize - newNodeIndex) | 0)) | 0), $thiz.getNode__I__sci_SetNode(oldNodeIndex));
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0)
      } else if (((bitpos & nodeMigrateToDataTargetMap) !== 0)) {
        var this$3 = $n(nodesToMigrateToData);
        var node = $as_sci_SetNode(this$3.removeHead__Z__O(false));
        $n(newContent).set(newDataIndex, $n(node).getPayload__I__O(0));
        $n(newOriginalHashes).set(newDataIndex, $n(node).getHash__I__I(0));
        newDataIndex = ((1 + newDataIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0)
      } else if (((bitpos & mapOfNewNodes) !== 0)) {
        var $$x2 = $n(newContent);
        var $$x1 = newNodeIndex;
        var this$4 = $n(newNodes);
        $$x2.set((((-1) + ((newContentSize - $$x1) | 0)) | 0), this$4.removeHead__Z__O(false));
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0)
      } else if (((bitpos & $thiz.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        oldDataIndex = ((1 + oldDataIndex) | 0)
      } else if (((bitpos & $thiz.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        oldNodeIndex = ((1 + oldNodeIndex) | 0)
      };
      i = ((1 + i) | 0)
    };
    return new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode)
  }
}
/** @constructor */
function $c_sci_BitmapIndexedSetNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedSetNode__f_dataMap = 0;
  this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
  this.sci_BitmapIndexedSetNode__f_content = null;
  this.sci_BitmapIndexedSetNode__f_originalHashes = null;
  this.sci_BitmapIndexedSetNode__f_size = 0;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedSetNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedSetNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedSetNode__f_content = content;
  this.sci_BitmapIndexedSetNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedSetNode__f_size = size;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode
}
$c_sci_BitmapIndexedSetNode.prototype = new $h_sci_SetNode();
$c_sci_BitmapIndexedSetNode.prototype.constructor = $c_sci_BitmapIndexedSetNode;
/** @constructor */
function $h_sci_BitmapIndexedSetNode() {
  /*<skip>*/
}
$h_sci_BitmapIndexedSetNode.prototype = $c_sci_BitmapIndexedSetNode.prototype;
$c_sci_BitmapIndexedSetNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_size
});
$c_sci_BitmapIndexedSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode
});
$c_sci_BitmapIndexedSetNode.prototype.getPayload__I__O = (function(index) {
  return $n(this.sci_BitmapIndexedSetNode__f_content).get(index)
});
$c_sci_BitmapIndexedSetNode.prototype.getHash__I__I = (function(index) {
  return $n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(index)
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  return $as_sci_SetNode($n(this.sci_BitmapIndexedSetNode__f_content).get((((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - index) | 0)))
});
$c_sci_BitmapIndexedSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    return (($n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element, this.getPayload__I__O(index)))
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    return $n(this.getNode__I__sci_SetNode(index$2)).contains__O__I__I__I__Z(element, originalHash, elementHash, ((5 + shift) | 0))
  };
  return false
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if (Object.is(element0, element)) {
      return this
    } else {
      var element0UnimprovedHash = this.getHash__I__I(index);
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      if (((originalHash === element0UnimprovedHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        return this
      } else {
        var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        return this.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew)
      }
    }
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew$2 = $n(subNode).updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNode === subNodeNew$2)) {
      return this
    } else {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew$2)
    }
  };
  return this.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode(bitpos, element, originalHash, elementHash)
});
$c_sci_BitmapIndexedSetNode.prototype.updateWithShallowMutations__O__I__I__I__I__I = (function(element, originalHash, elementHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    var element0UnimprovedHash = this.getHash__I__I(index);
    if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
      return shallowlyMutableNodeMap
    } else {
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos)
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeSize = $n(subNode).size__I();
    var subNodeCachedJavaKeySetHashCode = $n(subNode).cachedJavaKeySetHashCode__I();
    var returnNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$3;
      if ((subNode instanceof $c_sci_BitmapIndexedSetNode)) {
        var x2 = $as_sci_BitmapIndexedSetNode(subNode);
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          $n(x2).updateWithShallowMutations__O__I__I__I__I__I(element, originalHash, elementHash, ((5 + shift) | 0), 0);
          var subNodeNew$3 = x2;
          break matchEnd4
        }
      };
      var subNodeNew$2 = $n(subNode).updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
      if ((subNodeNew$2 !== subNode)) {
        returnNodeMap = (returnNodeMap | bitpos)
      };
      var subNodeNew$3 = subNodeNew$2
    };
    $n(this.sci_BitmapIndexedSetNode__f_content).set((((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew$3);
    this.sci_BitmapIndexedSetNode__f_size = ((((this.sci_BitmapIndexedSetNode__f_size - subNodeSize) | 0) + $n(subNodeNew$3).size__I()) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - subNodeCachedJavaKeySetHashCode) | 0) + $n(subNodeNew$3).cachedJavaKeySetHashCode__I()) | 0);
    return returnNodeMap
  } else {
    var dataIx = this.dataIndex__I__I(bitpos);
    var src = this.sci_BitmapIndexedSetNode__f_content;
    var dst = new $ac_O(((1 + $n(src).u.length) | 0));
    $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
    $n(dst).set(dataIx, element);
    var destPos = ((1 + dataIx) | 0);
    var length = (($n(src).u.length - dataIx) | 0);
    $systemArraycopyRefs($n(src), dataIx, dst, destPos, length);
    var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
    this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedSetNode__f_content = dst;
    this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
    this.sci_BitmapIndexedSetNode__f_size = ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0);
    return shallowlyMutableNodeMap
  }
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $$x1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(elementHash, 0)));
        if ((index === 0)) {
          return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(1)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(1)])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I($n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(1)))
        } else {
          return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(0)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(0)])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I($n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(0)))
        }
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode(bitpos, elementHash)
      }
    } else {
      return this
    }
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = $n(subNode).removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this
    };
    var subNodeNewSize = $n(subNodeNew).size__I();
    if ((subNodeNewSize === 1)) {
      if ((this.sci_BitmapIndexedSetNode__f_size === $n(subNode).size__I())) {
        return $as_sci_BitmapIndexedSetNode(subNodeNew)
      } else {
        return this.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, elementHash, subNode, subNodeNew)
      }
    } else if ((subNodeNewSize > 1)) {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew)
    }
  };
  return this
});
$c_sci_BitmapIndexedSetNode.prototype.removeWithShallowMutations__O__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, 0);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $$x1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var newDataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
        if ((index === 0)) {
          var newContent = new $ac_O([this.getPayload__I__O(1)]);
          var newOriginalHashes = new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(1)]));
          var newCachedJavaKeySetHashCode = $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1));
          this.sci_BitmapIndexedSetNode__f_content = newContent;
          this.sci_BitmapIndexedSetNode__f_originalHashes = newOriginalHashes;
          this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = newCachedJavaKeySetHashCode
        } else {
          var newContent$2 = new $ac_O([this.getPayload__I__O(0)]);
          var newOriginalHashes$2 = new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(0)]));
          var newCachedJavaKeySetHashCode$2 = $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0));
          this.sci_BitmapIndexedSetNode__f_content = newContent$2;
          this.sci_BitmapIndexedSetNode__f_originalHashes = newOriginalHashes$2;
          this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = newCachedJavaKeySetHashCode$2
        };
        this.sci_BitmapIndexedSetNode__f_dataMap = newDataMap;
        this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
        this.sci_BitmapIndexedSetNode__f_size = 1;
        return this
      } else {
        var dataIx = this.dataIndex__I__I(bitpos);
        var src = this.sci_BitmapIndexedSetNode__f_content;
        var dst = new $ac_O((((-1) + $n(src).u.length) | 0));
        $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
        var srcPos = ((1 + dataIx) | 0);
        var length = (((-1) + (($n(src).u.length - dataIx) | 0)) | 0);
        $systemArraycopyRefs($n(src), srcPos, dst, dataIx, length);
        var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
        this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
        this.sci_BitmapIndexedSetNode__f_content = dst;
        this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
        this.sci_BitmapIndexedSetNode__f_size = (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0);
        this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0);
        return this
      }
    } else {
      return this
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = $as_sci_BitmapIndexedSetNode($n(subNode).removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, 5));
    if ((subNodeNew === subNode)) {
      return this
    };
    if (($n(subNodeNew).sci_BitmapIndexedSetNode__f_size === 1)) {
      var i$2 = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i$2) === 0)) {
        var i$3 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $$x2 = ($m_jl_Integer$().bitCount__I__I(i$3) === 1)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        this.sci_BitmapIndexedSetNode__f_dataMap = $n(subNodeNew).sci_BitmapIndexedSetNode__f_dataMap;
        this.sci_BitmapIndexedSetNode__f_nodeMap = $n(subNodeNew).sci_BitmapIndexedSetNode__f_nodeMap;
        this.sci_BitmapIndexedSetNode__f_content = $n(subNodeNew).sci_BitmapIndexedSetNode__f_content;
        this.sci_BitmapIndexedSetNode__f_originalHashes = $n(subNodeNew).sci_BitmapIndexedSetNode__f_originalHashes;
        this.sci_BitmapIndexedSetNode__f_size = $n(subNodeNew).sci_BitmapIndexedSetNode__f_size;
        this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = $n(subNodeNew).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode;
        return this
      } else {
        this.migrateFromNodeToInlineInPlace__I__I__I__sci_SetNode__sci_SetNode__V(bitpos, originalHash, elementHash, subNode, subNodeNew);
        return this
      }
    } else {
      $n(this.sci_BitmapIndexedSetNode__f_content).set((((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew);
      this.sci_BitmapIndexedSetNode__f_size = (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0);
      this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(subNode).cachedJavaKeySetHashCode__I()) | 0) + $n(subNodeNew).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) | 0);
      return this
    }
  } else {
    return this
  }
});
$c_sci_BitmapIndexedSetNode.prototype.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode = (function(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [key0, key1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionSetNode(originalKeyHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      var newCachedHashCode = ((keyHash0 + keyHash1) | 0);
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key0, key1]), new $ac_I(new Int32Array([originalKeyHash0, originalKeyHash1])), 2, newCachedHashCode) : new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key1, key0]), new $ac_I(new Int32Array([originalKeyHash1, originalKeyHash0])), 2, newCachedHashCode))
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedSetNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, $n(node).size__I(), $n(node).cachedJavaKeySetHashCode__I())
    }
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_dataMap !== 0)
});
$c_sci_BitmapIndexedSetNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_nodeMap !== 0)
});
$c_sci_BitmapIndexedSetNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  var length = $n(src).u.length;
  $systemArraycopyRefs($n(src), 0, dst, 0, length);
  $n(dst).set(idx, newNode);
  return new $c_sci_BitmapIndexedSetNode(this.sci_BitmapIndexedSetNode__f_dataMap, this.sci_BitmapIndexedSetNode__f_nodeMap, dst, this.sci_BitmapIndexedSetNode__f_originalHashes, ((((this.sci_BitmapIndexedSetNode__f_size - $n(oldNode).size__I()) | 0) + $n(newNode).size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(newNode).cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode = (function(bitpos, key, originalHash, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  $n(dst).set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = (($n(src).u.length - dataIx) | 0);
  $systemArraycopyRefs($n(src), dataIx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode = (function(bitpos, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O((((-1) + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = (((-1) + (($n(src).u.length - dataIx) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, dataIx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((idxNew - dataIx) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, dataIx, length);
  $n(dst).set(idxNew, node);
  var srcPos$1 = ((1 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-1) + (($n(src).u.length - idxNew) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + $n(node).size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var srcPos = ((1 + dataIx) | 0);
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var length = ((idxNew - dataIx) | 0);
  $systemArraycopyRefs($n(src), srcPos, $n(dest), dataIx, length);
  $n(this.sci_BitmapIndexedSetNode__f_content).set(idxNew, node);
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedSetNode__f_size = (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + $n(node).size__I()) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0);
  return this
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, oldNode, node) {
  var idxOld = (((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIxNew);
  $n(dst).set(dataIxNew, $n(node).getPayload__I__O(0));
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  $systemArraycopyRefs($n(src), dataIxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((1 + idxOld) | 0);
  var length$1 = (((-1) + (($n(src).u.length - idxOld) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, destPos$1, length$1);
  var hash = $n(node).getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedSetNode__f_size - $n(oldNode).size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromNodeToInlineInPlace__I__I__I__sci_SetNode__sci_SetNode__V = (function(bitpos, originalHash, elementHash, oldNode, node) {
  var idxOld = (((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var element = $n(node).getPayload__I__O(0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  $systemArraycopyRefs($n(src), dataIxNew, $n(dest), destPos, length);
  $n(this.sci_BitmapIndexedSetNode__f_content).set(dataIxNew, element);
  var hash = $n(node).getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedSetNode__f_size = ((1 + ((this.sci_BitmapIndexedSetNode__f_size - $n(oldNode).size__I()) | 0)) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0)
});
$c_sci_BitmapIndexedSetNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var thisPayloadArity = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < thisPayloadArity)) {
    $n(f).apply__O__O(this.getPayload__I__O(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var thisNodeArity = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < thisNodeArity)) {
    $n(this.getNode__I__sci_SetNode(j)).foreach__F1__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedSetNode.prototype.filterImpl__F1__Z__sci_BitmapIndexedSetNode = (function(pred, flipped) {
  if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
    return this
  } else if ((this.sci_BitmapIndexedSetNode__f_size === 1)) {
    if (($uZ($n(pred).apply__O__O(this.getPayload__I__O(0))) !== flipped)) {
      return this
    } else {
      var this$1 = $m_sci_SetNode$();
      return this$1.sci_SetNode$__f_EmptySetNode
    }
  } else if ((this.sci_BitmapIndexedSetNode__f_nodeMap === 0)) {
    var i = this.sci_BitmapIndexedSetNode__f_dataMap;
    if ((i === 0)) {
      var minimumIndex = 32
    } else {
      var i$1 = (i & ((-i) | 0));
      var minimumIndex = ((31 - $uI(Math.clz32(i$1))) | 0)
    };
    var i$2 = this.sci_BitmapIndexedSetNode__f_dataMap;
    var maximumIndex = ((32 - $uI(Math.clz32(i$2))) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i$3);
      if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        var payload = this.getPayload__I__O(dataIndex);
        var passed = ($uZ($n(pred).apply__O__O(payload)) !== flipped);
        if (passed) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex))) | 0)
        };
        dataIndex = ((1 + dataIndex) | 0)
      };
      i$3 = ((1 + i$3) | 0)
    };
    if ((newDataMap === 0)) {
      var this$4 = $m_sci_SetNode$();
      return this$4.sci_SetNode$__f_EmptySetNode
    } else if ((newDataMap === this.sci_BitmapIndexedSetNode__f_dataMap)) {
      return this
    } else {
      var i$4 = newDataMap;
      var newSize = $m_jl_Integer$().bitCount__I__I(i$4);
      var newContent = new $ac_O(newSize);
      var newOriginalHashCodes = new $ac_I(newSize);
      var i$5 = newDataMap;
      var newMaximumIndex = ((32 - $uI(Math.clz32(i$5))) | 0);
      var i$6 = newDataMap;
      if ((i$6 === 0)) {
        var j = 32
      } else {
        var i$7 = (i$6 & ((-i$6) | 0));
        var j = ((31 - $uI(Math.clz32(i$7))) | 0)
      };
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().bitposFrom__I__I(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos$2);
          $n(newContent).set(newDataIndex, $n(this.sci_BitmapIndexedSetNode__f_content).get(oldIndex));
          $n(newOriginalHashCodes).set(newDataIndex, $n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(oldIndex));
          newDataIndex = ((1 + newDataIndex) | 0)
        };
        j = ((1 + j) | 0)
      };
      return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode)
    }
  } else {
    var allMap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
    if ((allMap === 0)) {
      var minimumIndex$2 = 32
    } else {
      var i$8 = (allMap & ((-allMap) | 0));
      var minimumIndex$2 = ((31 - $uI(Math.clz32(i$8))) | 0)
    };
    var maximumIndex$2 = ((32 - $uI(Math.clz32(allMap))) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().bitposFrom__I__I(i$2$1);
      if (((bitpos$3 & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        var payload$2 = this.getPayload__I__O(dataIndex$2);
        var passed$2 = ($uZ($n(pred).apply__O__O(payload$2)) !== flipped);
        if (passed$2) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex$2))) | 0)
        };
        dataIndex$2 = ((1 + dataIndex$2) | 0)
      } else if (((bitpos$3 & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        var oldSubNode = this.getNode__I__sci_SetNode(nodeIndex);
        var newSubNode = $n(oldSubNode).filterImpl__F1__Z__sci_SetNode(pred, flipped);
        newSize$2 = ((newSize$2 + $n(newSubNode).size__I()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + $n(newSubNode).cachedJavaKeySetHashCode__I()) | 0);
        if (($n(newSubNode).size__I() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3)
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16)
            };
            var this$10 = $n(newNodes);
            this$10.addOne__O__scm_ArrayDeque(newSubNode)
          }
        } else if (($n(newSubNode).size__I() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            nodesToMigrateToData = $ct_scm_Queue__I__(new $c_scm_Queue(), 16)
          };
          var this$12 = $n(nodesToMigrateToData);
          this$12.addOne__O__scm_ArrayDeque(newSubNode)
        };
        nodeIndex = ((1 + nodeIndex) | 0)
      };
      i$2$1 = ((1 + i$2$1) | 0)
    };
    return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize$2, newDataMap$2, newNodeMap, minimumIndex$2, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode$2)
  }
});
$c_sci_BitmapIndexedSetNode.prototype.diff__sci_SetNode__I__sci_BitmapIndexedSetNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
      return this
    } else if ((this.sci_BitmapIndexedSetNode__f_size === 1)) {
      var h = this.getHash__I__I(0);
      if ($n(that).contains__O__I__I__I__Z(this.getPayload__I__O(0), h, $m_sc_Hashing$().improve__I__I(h), shift)) {
        var this$1 = $m_sci_SetNode$();
        return this$1.sci_SetNode$__f_EmptySetNode
      } else {
        return this
      }
    } else {
      var allMap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
      if ((allMap === 0)) {
        var minimumIndex = 32
      } else {
        var i = (allMap & ((-allMap) | 0));
        var minimumIndex = ((31 - $uI(Math.clz32(i))) | 0)
      };
      var maximumIndex = ((32 - $uI(Math.clz32(allMap))) | 0);
      var oldDataPassThrough = 0;
      var nodeMigrateToDataTargetMap = 0;
      var nodesToMigrateToData = null;
      var nodesToPassThroughMap = 0;
      var mapOfNewNodes = 0;
      var newNodes = null;
      var newDataMap = 0;
      var newNodeMap = 0;
      var newSize = 0;
      var newCachedHashCode = 0;
      var dataIndex = 0;
      var nodeIndex = 0;
      var i$1 = minimumIndex;
      while ((i$1 < maximumIndex)) {
        var bitpos = $m_sci_Node$().bitposFrom__I__I(i$1);
        if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          var payload = this.getPayload__I__O(dataIndex);
          var originalHash = this.getHash__I__I(dataIndex);
          var hash = $m_sc_Hashing$().improve__I__I(originalHash);
          if ((!$n(x2).contains__O__I__I__I__Z(payload, originalHash, hash, shift))) {
            newDataMap = (newDataMap | bitpos);
            oldDataPassThrough = (oldDataPassThrough | bitpos);
            newSize = ((1 + newSize) | 0);
            newCachedHashCode = ((newCachedHashCode + hash) | 0)
          };
          dataIndex = ((1 + dataIndex) | 0)
        } else if (((bitpos & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          var oldSubNode = this.getNode__I__sci_SetNode(nodeIndex);
          if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
            var thatDataIndex = $m_sci_Node$().indexFrom__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_dataMap, bitpos);
            var thatPayload = $n(x2).getPayload__I__O(thatDataIndex);
            var thatOriginalHash = $n(x2).getHash__I__I(thatDataIndex);
            var thatHash = $m_sc_Hashing$().improve__I__I(thatOriginalHash);
            var newSubNode = $n(oldSubNode).removed__O__I__I__I__sci_SetNode(thatPayload, thatOriginalHash, thatHash, ((5 + shift) | 0))
          } else {
            var newSubNode = (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_nodeMap) !== 0) ? $n(oldSubNode).diff__sci_SetNode__I__sci_SetNode($n(x2).getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_nodeMap, bitpos)), ((5 + shift) | 0)) : oldSubNode)
          };
          newSize = ((newSize + $n(newSubNode).size__I()) | 0);
          newCachedHashCode = ((newCachedHashCode + $n(newSubNode).cachedJavaKeySetHashCode__I()) | 0);
          if (($n(newSubNode).size__I() > 1)) {
            newNodeMap = (newNodeMap | bitpos);
            if ((oldSubNode === newSubNode)) {
              nodesToPassThroughMap = (nodesToPassThroughMap | bitpos)
            } else {
              mapOfNewNodes = (mapOfNewNodes | bitpos);
              if ((newNodes === null)) {
                newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16)
              };
              var this$5 = $n(newNodes);
              this$5.addOne__O__scm_ArrayDeque(newSubNode)
            }
          } else if (($n(newSubNode).size__I() === 1)) {
            newDataMap = (newDataMap | bitpos);
            nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos);
            if ((nodesToMigrateToData === null)) {
              nodesToMigrateToData = $ct_scm_Queue__I__(new $c_scm_Queue(), 16)
            };
            var this$7 = $n(nodesToMigrateToData);
            this$7.addOne__O__scm_ArrayDeque(newSubNode)
          };
          nodeIndex = ((1 + nodeIndex) | 0)
        };
        i$1 = ((1 + i$1) | 0)
      };
      return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode)
    }
  } else if ((that instanceof $c_sci_HashCollisionSetNode)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "BitmapIndexedSetNode diff HashCollisionSetNode")
  } else {
    throw new $c_s_MatchError(that)
  }
});
$c_sci_BitmapIndexedSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this === x2)) {
      return true
    } else {
      if (((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode === $n(x2).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedSetNode__f_nodeMap === $n(x2).sci_BitmapIndexedSetNode__f_nodeMap)) && (this.sci_BitmapIndexedSetNode__f_dataMap === $n(x2).sci_BitmapIndexedSetNode__f_dataMap)) && (this.sci_BitmapIndexedSetNode__f_size === $n(x2).sci_BitmapIndexedSetNode__f_size))) {
        var a = this.sci_BitmapIndexedSetNode__f_originalHashes;
        var b = $n(x2).sci_BitmapIndexedSetNode__f_originalHashes;
        var $$x1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a1 = this.sci_BitmapIndexedSetNode__f_content;
        var a2 = $n(x2).sci_BitmapIndexedSetNode__f_content;
        var length = $n(this.sci_BitmapIndexedSetNode__f_content).u.length;
        if ((a1 === a2)) {
          return true
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z($n(a1).get(i), $n(a2).get(i));
            i = ((1 + i) | 0)
          };
          return isEqual
        }
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_BitmapIndexedSetNode = (function() {
  var this$1 = $n(this.sci_BitmapIndexedSetNode__f_content);
  var contentClone = $n(this$1).clone__O();
  var contentLength = $n(contentClone).u.length;
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var i$1 = $m_jl_Integer$().bitCount__I__I(i);
  while ((i$1 < contentLength)) {
    $n(contentClone).set(i$1, $n($as_sci_SetNode($n(contentClone).get(i$1))).copy__sci_SetNode());
    i$1 = ((1 + i$1) | 0)
  };
  var $$x2 = this.sci_BitmapIndexedSetNode__f_dataMap;
  var $$x1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var this$2 = $n(this.sci_BitmapIndexedSetNode__f_originalHashes);
  return new $c_sci_BitmapIndexedSetNode($$x2, $$x1, contentClone, $n(this$2).clone__O(), this.sci_BitmapIndexedSetNode__f_size, this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_BitmapIndexedSetNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
      return x2
    } else if ((($n(x2).sci_BitmapIndexedSetNode__f_size === 0) || (x2 === this))) {
      return this
    } else if (($n(x2).sci_BitmapIndexedSetNode__f_size === 1)) {
      var originalHash = $n(x2).getHash__I__I(0);
      return this.updated__O__I__I__I__sci_BitmapIndexedSetNode($n(x2).getPayload__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift)
    };
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedSetNode__f_dataMap | $n(x2).sci_BitmapIndexedSetNode__f_dataMap) | this.sci_BitmapIndexedSetNode__f_nodeMap) | $n(x2).sci_BitmapIndexedSetNode__f_nodeMap);
    var $$x2 = $m_sci_Node$();
    if ((allMap === 0)) {
      var $$x1 = 32
    } else {
      var i = (allMap & ((-allMap) | 0));
      var $$x1 = ((31 - $uI(Math.clz32(i))) | 0)
    };
    var minimumBitPos = $n($$x2).bitposFrom__I__I($$x1);
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - $uI(Math.clz32(allMap))) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataLeftOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          if (((this.getHash__I__I(leftIdx) === $n(x2).getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getPayload__I__O(leftIdx), $n(x2).getPayload__I__O(rightIdx)))) {
            leftDataRightDataLeftOverwrites = (leftDataRightDataLeftOverwrites | bitpos)
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(this.getHash__I__I(leftIdx)), shift)))
          };
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos)
        } else {
          leftDataOnly = (leftDataOnly | bitpos)
        };
        leftIdx = ((1 + leftIdx) | 0)
      } else if (((bitpos & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos)
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos)
        }
      } else if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0)
      } else if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos)
      };
      if ((bitpos === maximumBitPos)) {
        finished = true
      } else {
        bitpos = (bitpos << 1)
      }
    };
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataLeftOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (leftDataOnly | leftDataRightDataLeftOverwrites)) && (newNodeMap === leftNodeOnly))) {
      return this
    };
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var leftNode = this.getNode__I__sci_SetNode(leftNodeIdx);
        var newNode = $n(leftNode).concat__sci_SetNode__I__sci_SetNode($n(x2).getNode__I__sci_SetNode(rightNodeIdx), nextShift);
        if ((leftNode !== newNode)) {
          anyChangesMadeSoFar = true
        };
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + $n(newNode).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode).cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var n = $n(x2).getNode__I__sci_SetNode(rightNodeIdx);
        var leftPayload = this.getPayload__I__O(leftDataIdx);
        var leftOriginalHash = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash);
        var newNode$2 = $n(n).updated__O__I__I__I__sci_SetNode(leftPayload, leftOriginalHash, leftImproved, nextShift);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$2);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + $n(newNode$2).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$2).cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        var rightOriginalHash = $n(x2).getHash__I__I(rightDataIdx);
        var leftNode$2 = this.getNode__I__sci_SetNode(leftNodeIdx);
        var updated = $n(leftNode$2).updated__O__I__I__I__sci_SetNode($n(x2).getPayload__I__O(rightDataIdx), $n(x2).getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift);
        if ((updated !== leftNode$2)) {
          anyChangesMadeSoFar = true
        };
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), updated);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + $n(updated).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(updated).cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        var originalHash$2 = $n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(leftDataIdx);
        $n(newContent).set(compressedDataIdx, this.getPayload__I__O(leftDataIdx));
        $n(newOriginalHashes).set(compressedDataIdx, originalHash$2);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0)
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$3 = $n($n(x2).sci_BitmapIndexedSetNode__f_originalHashes).get(rightDataIdx);
        $n(newContent).set(compressedDataIdx, $n(x2).getPayload__I__O(rightDataIdx));
        $n(newOriginalHashes).set(compressedDataIdx, originalHash$3);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0)
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        var newNode$4 = this.getNode__I__sci_SetNode(leftNodeIdx);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$4);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + $n(newNode$4).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$4).cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$5 = $n(x2).getNode__I__sci_SetNode(rightNodeIdx);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$5);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + $n(newNode$5).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$5).cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = $n(x2).getHash__I__I(rightDataIdx);
        var newNode$6 = $n(x2).mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(this.getPayload__I__O(leftDataIdx), leftOriginalHash$2, $m_sc_Hashing$().improve__I__I(leftOriginalHash$2), $n(x2).getPayload__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$6);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + $n(newNode$6).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$6).cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataLeftOverwrites) !== 0)) {
        var originalHash$4 = $n($n(x2).sci_BitmapIndexedSetNode__f_originalHashes).get(rightDataIdx);
        $n(newContent).set(compressedDataIdx, $n(x2).getPayload__I__O(rightDataIdx));
        $n(newOriginalHashes).set(compressedDataIdx, originalHash$4);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0)
      };
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true
      } else {
        bitpos$2 = (bitpos$2 << 1)
      }
    };
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : this)
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode")
  }
});
$c_sci_BitmapIndexedSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    $n(f).apply__O__O__O(this.getPayload__I__O(i$1), this.getHash__I__I(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_SetNode(j)).foreachWithHash__F2__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.concat__sci_SetNode__I__sci_BitmapIndexedSetNode(that, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_SetNode = (function() {
  return this.copy__sci_BitmapIndexedSetNode()
});
$c_sci_BitmapIndexedSetNode.prototype.diff__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.diff__sci_SetNode__I__sci_BitmapIndexedSetNode(that, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.filterImpl__F1__Z__sci_SetNode = (function(pred, flipped) {
  return this.filterImpl__F1__Z__sci_BitmapIndexedSetNode(pred, flipped)
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index)
});
function $as_sci_BitmapIndexedSetNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedSetNode"))
}
function $isArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedSetNode)))
}
function $asArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedSetNode;", depth))
}
var $d_sci_BitmapIndexedSetNode = new $TypeData().initClass({
  sci_BitmapIndexedSetNode: 0
}, false, "scala.collection.immutable.BitmapIndexedSetNode", {
  sci_BitmapIndexedSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_BitmapIndexedSetNode.prototype.$classData = $d_sci_BitmapIndexedSetNode;
/** @constructor */
function $c_sci_HashCollisionMapNode(originalHash, hash, content) {
  this.sci_HashCollisionMapNode__f_originalHash = 0;
  this.sci_HashCollisionMapNode__f_hash = 0;
  this.sci_HashCollisionMapNode__f_content = null;
  this.sci_HashCollisionMapNode__f_originalHash = originalHash;
  this.sci_HashCollisionMapNode__f_hash = hash;
  this.sci_HashCollisionMapNode__f_content = content;
  $m_s_Predef$().require__Z__V(($n(this.sci_HashCollisionMapNode__f_content).length__I() >= 2))
}
$c_sci_HashCollisionMapNode.prototype = new $h_sci_MapNode();
$c_sci_HashCollisionMapNode.prototype.constructor = $c_sci_HashCollisionMapNode;
/** @constructor */
function $h_sci_HashCollisionMapNode() {
  /*<skip>*/
}
$h_sci_HashCollisionMapNode.prototype = $c_sci_HashCollisionMapNode.prototype;
$c_sci_HashCollisionMapNode.prototype.indexOf__O__I = (function(key) {
  var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
  var i = 0;
  while ($n(iter).hasNext__Z()) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n($as_T2($n(iter).next__O()))._1__O(), key)) {
      return i
    };
    i = ((1 + i) | 0)
  };
  return (-1)
});
$c_sci_HashCollisionMapNode.prototype.size__I = (function() {
  return $n(this.sci_HashCollisionMapNode__f_content).length__I()
});
$c_sci_HashCollisionMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, hash, shift) {
  var this$1 = $n(this.get__O__I__I__I__s_Option(key, originalHash, hash, shift));
  if (this$1.isEmpty__Z()) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
    throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException())
  } else {
    return this$1.get__O()
  }
});
$c_sci_HashCollisionMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, hash, shift) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var index = this.indexOf__O__I(key);
    return ((index >= 0) ? new $c_s_Some($n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O()) : $m_s_None$())
  } else {
    return $m_s_None$()
  }
});
$c_sci_HashCollisionMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, hash, shift, f) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var x1 = this.indexOf__O__I(key);
    return ((x1 === (-1)) ? $n(f).apply__O() : $n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(x1)))._2__O())
  } else {
    return $n(f).apply__O()
  }
});
$c_sci_HashCollisionMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, hash, shift) {
  return ((this.sci_HashCollisionMapNode__f_hash === hash) && (this.indexOf__O__I(key) >= 0))
});
$c_sci_HashCollisionMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  var index = this.indexOf__O__I(key);
  return ((index >= 0) ? (replaceValue ? (Object.is($n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O(), value) ? this : new $c_sci_HashCollisionMapNode(originalHash, hash, $n(this.sci_HashCollisionMapNode__f_content).updated__I__O__sci_Vector(index, $ct_T2__O__O__(new $c_T2(), key, value)))) : this) : new $c_sci_HashCollisionMapNode(originalHash, hash, $n(this.sci_HashCollisionMapNode__f_content).appended__O__sci_Vector($ct_T2__O__O__(new $c_T2(), key, value))))
});
$c_sci_HashCollisionMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  if ((!this.containsKey__O__I__I__I__Z(key, originalHash, hash, shift))) {
    return this
  } else {
    var this$2 = $n(this.sci_HashCollisionMapNode__f_content);
    var pred = new $c_sjsr_AnonFunction1(((keyValuePair$2) => {
      var keyValuePair = $as_T2(keyValuePair$2);
      return $m_sr_BoxesRunTime$().equals__O__O__Z($n(keyValuePair)._1__O(), key)
    }));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var this$3 = $n(updatedContent);
    var x1 = this$3.length__I();
    if ((x1 === 1)) {
      var x1$2 = $as_T2($n(updatedContent).apply__I__O(0));
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var k = $n(x1$2)._1__O();
      var v = $n(x1$2)._2__O();
      return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([originalHash])), 1, hash)
    } else {
      return new $c_sci_HashCollisionMapNode(originalHash, hash, updatedContent)
    }
  }
});
$c_sci_HashCollisionMapNode.prototype.hasNodes__Z = (function() {
  return false
});
$c_sci_HashCollisionMapNode.prototype.nodeArity__I = (function() {
  return 0
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.")
});
$c_sci_HashCollisionMapNode.prototype.hasPayload__Z = (function() {
  return true
});
$c_sci_HashCollisionMapNode.prototype.payloadArity__I = (function() {
  return $n(this.sci_HashCollisionMapNode__f_content).length__I()
});
$c_sci_HashCollisionMapNode.prototype.getKey__I__O = (function(index) {
  return $n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._1__O()
});
$c_sci_HashCollisionMapNode.prototype.getValue__I__O = (function(index) {
  return $n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O()
});
$c_sci_HashCollisionMapNode.prototype.getPayload__I__T2 = (function(index) {
  return $as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index))
});
$c_sci_HashCollisionMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionMapNode__f_originalHash
});
$c_sci_HashCollisionMapNode.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_HashCollisionMapNode__f_content).foreach__F1__V(f)
});
$c_sci_HashCollisionMapNode.prototype.foreachEntry__F2__V = (function(f) {
  $n(this.sci_HashCollisionMapNode__f_content).foreach__F1__V(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = $n(x0$1)._1__O();
      var v = $n(x0$1)._2__O();
      return $n(f).apply__O__O__O(k, v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))
});
$c_sci_HashCollisionMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var next = $as_T2($n(iter).next__O());
    $n(f).apply__O__O__O__O($n(next)._1__O(), $n(next)._2__O(), this.sci_HashCollisionMapNode__f_originalHash)
  }
});
$c_sci_HashCollisionMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((this === x2)) {
      return true
    } else if (((this.sci_HashCollisionMapNode__f_hash === $n(x2).sci_HashCollisionMapNode__f_hash) && ($n(this.sci_HashCollisionMapNode__f_content).length__I() === $n($n(x2).sci_HashCollisionMapNode__f_content).length__I()))) {
      var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        var x1$2 = $as_T2($n(iter).next__O());
        if ((x1$2 === null)) {
          throw new $c_s_MatchError(x1$2)
        };
        var key = $n(x1$2)._1__O();
        var value = $n(x1$2)._2__O();
        var index = $n(x2).indexOf__O__I(key);
        if (((index < 0) || (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, $n($as_T2($n($n(x2).sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O())))) {
          return false
        }
      };
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_sci_HashCollisionMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, flipped) {
  var newContent = $n(this.sci_HashCollisionMapNode__f_content).filterImpl__F1__Z__sci_Vector(pred, flipped);
  var newContentLength = $n(newContent).length__I();
  if ((newContentLength === 0)) {
    var this$1 = $m_sci_MapNode$();
    return this$1.sci_MapNode$__f_EmptyMapNode
  } else if ((newContentLength === 1)) {
    var x1 = $as_T2($n(newContent).head__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = $n(x1)._1__O();
    var v = $n(x1)._2__O();
    return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(this.sci_HashCollisionMapNode__f_hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([this.sci_HashCollisionMapNode__f_originalHash])), 1, this.sci_HashCollisionMapNode__f_hash)
  } else {
    return ((newContentLength === $n(this.sci_HashCollisionMapNode__f_content).length__I()) ? this : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, newContent))
  }
});
$c_sci_HashCollisionMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_HashCollisionMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul($n(this.sci_HashCollisionMapNode__f_content).length__I(), this.sci_HashCollisionMapNode__f_hash)
});
$c_sci_HashCollisionMapNode.prototype.copy__sci_MapNode = (function() {
  return new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, this.sci_HashCollisionMapNode__f_content)
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index)
});
function $as_sci_HashCollisionMapNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionMapNode"))
}
function $isArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionMapNode)))
}
function $asArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionMapNode;", depth))
}
var $d_sci_HashCollisionMapNode = new $TypeData().initClass({
  sci_HashCollisionMapNode: 0
}, false, "scala.collection.immutable.HashCollisionMapNode", {
  sci_HashCollisionMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_HashCollisionMapNode.prototype.$classData = $d_sci_HashCollisionMapNode;
/** @constructor */
function $c_sci_HashCollisionSetNode(originalHash, hash, content) {
  this.sci_HashCollisionSetNode__f_originalHash = 0;
  this.sci_HashCollisionSetNode__f_hash = 0;
  this.sci_HashCollisionSetNode__f_content = null;
  this.sci_HashCollisionSetNode__f_originalHash = originalHash;
  this.sci_HashCollisionSetNode__f_hash = hash;
  this.sci_HashCollisionSetNode__f_content = content;
  $m_s_Predef$().require__Z__V(($n(this.sci_HashCollisionSetNode__f_content).length__I() >= 2))
}
$c_sci_HashCollisionSetNode.prototype = new $h_sci_SetNode();
$c_sci_HashCollisionSetNode.prototype.constructor = $c_sci_HashCollisionSetNode;
/** @constructor */
function $h_sci_HashCollisionSetNode() {
  /*<skip>*/
}
$h_sci_HashCollisionSetNode.prototype = $c_sci_HashCollisionSetNode.prototype;
$c_sci_HashCollisionSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, hash, shift) {
  if ((this.sci_HashCollisionSetNode__f_hash === hash)) {
    var this$1 = $n(this.sci_HashCollisionSetNode__f_content);
    return $f_sc_SeqOps__contains__O__Z(this$1, element)
  } else {
    return false
  }
});
$c_sci_HashCollisionSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return (this.contains__O__I__I__I__Z(element, originalHash, hash, shift) ? this : new $c_sci_HashCollisionSetNode(originalHash, hash, $n(this.sci_HashCollisionSetNode__f_content).appended__O__sci_Vector(element)))
});
$c_sci_HashCollisionSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  if ((!this.contains__O__I__I__I__Z(element, originalHash, hash, shift))) {
    return this
  } else {
    var this$2 = $n(this.sci_HashCollisionSetNode__f_content);
    var pred = new $c_sjsr_AnonFunction1(((element0$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(element0$2, element)));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var this$3 = $n(updatedContent);
    var x1 = this$3.length__I();
    return ((x1 === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([$n(updatedContent).apply__I__O(0)]), new $ac_I(new Int32Array([originalHash])), 1, hash) : new $c_sci_HashCollisionSetNode(originalHash, hash, updatedContent))
  }
});
$c_sci_HashCollisionSetNode.prototype.hasNodes__Z = (function() {
  return false
});
$c_sci_HashCollisionSetNode.prototype.nodeArity__I = (function() {
  return 0
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.")
});
$c_sci_HashCollisionSetNode.prototype.hasPayload__Z = (function() {
  return true
});
$c_sci_HashCollisionSetNode.prototype.payloadArity__I = (function() {
  return $n(this.sci_HashCollisionSetNode__f_content).length__I()
});
$c_sci_HashCollisionSetNode.prototype.getPayload__I__O = (function(index) {
  return $n(this.sci_HashCollisionSetNode__f_content).apply__I__O(index)
});
$c_sci_HashCollisionSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionSetNode__f_originalHash
});
$c_sci_HashCollisionSetNode.prototype.size__I = (function() {
  return $n(this.sci_HashCollisionSetNode__f_content).length__I()
});
$c_sci_HashCollisionSetNode.prototype.foreach__F1__V = (function(f) {
  var iter = $n(this.sci_HashCollisionSetNode__f_content).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    $n(f).apply__O__O($n(iter).next__O())
  }
});
$c_sci_HashCollisionSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul($n(this.sci_HashCollisionSetNode__f_content).length__I(), this.sci_HashCollisionSetNode__f_hash)
});
$c_sci_HashCollisionSetNode.prototype.filterImpl__F1__Z__sci_SetNode = (function(pred, flipped) {
  var newContent = $n(this.sci_HashCollisionSetNode__f_content).filterImpl__F1__Z__sci_Vector(pred, flipped);
  var newContentLength = $n(newContent).length__I();
  if ((newContentLength === 0)) {
    var this$1 = $m_sci_SetNode$();
    return this$1.sci_SetNode$__f_EmptySetNode
  } else {
    return ((newContentLength === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(this.sci_HashCollisionSetNode__f_hash, 0)), 0, new $ac_O([$n(newContent).head__O()]), new $ac_I(new Int32Array([this.sci_HashCollisionSetNode__f_originalHash])), 1, this.sci_HashCollisionSetNode__f_hash) : (($n(newContent).length__I() === $n(this.sci_HashCollisionSetNode__f_content).length__I()) ? this : new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, newContent)))
  }
});
$c_sci_HashCollisionSetNode.prototype.diff__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.filterImpl__F1__Z__sci_SetNode(new $c_sjsr_AnonFunction1(((x$1$2) => $n(that).contains__O__I__I__I__Z(x$1$2, this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, shift))), true)
});
$c_sci_HashCollisionSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((this === x2)) {
      return true
    } else {
      if ((this.sci_HashCollisionSetNode__f_hash === $n(x2).sci_HashCollisionSetNode__f_hash)) {
        var this$1 = $n(this.sci_HashCollisionSetNode__f_content);
        var $$x2 = this$1.length__I();
        var this$2 = $n($n(x2).sci_HashCollisionSetNode__f_content);
        var $$x1 = ($$x2 === this$2.length__I())
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var this$3 = $n(this.sci_HashCollisionSetNode__f_content);
        var eta$0$1 = $n(x2).sci_HashCollisionSetNode__f_content;
        var res = true;
        var it = this$3.iterator__sc_Iterator();
        while ((res && $n(it).hasNext__Z())) {
          var arg1 = $n(it).next__O();
          var this$4 = $n(eta$0$1);
          res = $f_sc_SeqOps__contains__O__Z(this$4, arg1)
        };
        return res
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_HashCollisionSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_HashCollisionSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((x2 === this)) {
      return this
    } else {
      var newContent = null;
      var iter = $n($n(x2).sci_HashCollisionSetNode__f_content).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        var nextPayload = $n(iter).next__O();
        var this$1 = $n(this.sci_HashCollisionSetNode__f_content);
        if ((!$f_sc_SeqOps__contains__O__Z(this$1, nextPayload))) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            $n(newContent).addAll__sc_IterableOnce__sci_VectorBuilder(this.sci_HashCollisionSetNode__f_content)
          };
          $n(newContent).addOne__O__sci_VectorBuilder(nextPayload)
        }
      };
      return ((newContent === null) ? this : new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, $n(newContent).result__sci_Vector()))
    }
  } else if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode")
  } else {
    throw new $c_s_MatchError(that)
  }
});
$c_sci_HashCollisionSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var iter = $n(this.sci_HashCollisionSetNode__f_content).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var next = $n(iter).next__O();
    $n(f).apply__O__O__O(next, this.sci_HashCollisionSetNode__f_originalHash)
  }
});
$c_sci_HashCollisionSetNode.prototype.copy__sci_SetNode = (function() {
  return new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, this.sci_HashCollisionSetNode__f_content)
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index)
});
function $as_sci_HashCollisionSetNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionSetNode"))
}
function $isArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionSetNode)))
}
function $asArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionSetNode;", depth))
}
var $d_sci_HashCollisionSetNode = new $TypeData().initClass({
  sci_HashCollisionSetNode: 0
}, false, "scala.collection.immutable.HashCollisionSetNode", {
  sci_HashCollisionSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_HashCollisionSetNode.prototype.$classData = $d_sci_HashCollisionSetNode;
/** @constructor */
function $c_sci_HashMap$() {
  this.sci_HashMap$__f_EmptyMap = null;
  $n_sci_HashMap$ = this;
  var this$1 = $m_sci_MapNode$();
  this.sci_HashMap$__f_EmptyMap = new $c_sci_HashMap(this$1.sci_MapNode$__f_EmptyMapNode)
}
$c_sci_HashMap$.prototype = new $h_O();
$c_sci_HashMap$.prototype.constructor = $c_sci_HashMap$;
/** @constructor */
function $h_sci_HashMap$() {
  /*<skip>*/
}
$h_sci_HashMap$.prototype = $c_sci_HashMap$.prototype;
$c_sci_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_HashMap(elems)
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__sci_HashMap = (function(source) {
  if ((source instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(source);
    return x2
  } else {
    var this$1 = new $c_sci_HashMapBuilder();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_HashMapBuilder(source));
    return this$2.result__sci_HashMap()
  }
});
$c_sci_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashMapBuilder()
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_HashMap(it)
});
$c_sci_HashMap$.prototype.empty__O = (function() {
  return this.sci_HashMap$__f_EmptyMap
});
var $d_sci_HashMap$ = new $TypeData().initClass({
  sci_HashMap$: 0
}, false, "scala.collection.immutable.HashMap$", {
  sci_HashMap$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap$.prototype.$classData = $d_sci_HashMap$;
var $n_sci_HashMap$;
function $m_sci_HashMap$() {
  if ((!$n_sci_HashMap$)) {
    $n_sci_HashMap$ = new $c_sci_HashMap$()
  };
  return $n_sci_HashMap$
}
/** @constructor */
function $c_sci_HashSet$() {
  this.sci_HashSet$__f_EmptySet = null;
  $n_sci_HashSet$ = this;
  var this$1 = $m_sci_SetNode$();
  this.sci_HashSet$__f_EmptySet = new $c_sci_HashSet(this$1.sci_SetNode$__f_EmptySetNode)
}
$c_sci_HashSet$.prototype = new $h_O();
$c_sci_HashSet$.prototype.constructor = $c_sci_HashSet$;
/** @constructor */
function $h_sci_HashSet$() {
  /*<skip>*/
}
$h_sci_HashSet$.prototype = $c_sci_HashSet$.prototype;
$c_sci_HashSet$.prototype.from__sc_IterableOnce__sci_HashSet = (function(source) {
  if ((source instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(source);
    return x2
  } else if (($n(source).knownSize__I() === 0)) {
    return this.sci_HashSet$__f_EmptySet
  } else {
    var this$1 = new $c_sci_HashSetBuilder();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_HashSetBuilder(source));
    return this$2.result__sci_HashSet()
  }
});
$c_sci_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashSetBuilder()
});
$c_sci_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_HashSet(source)
});
$c_sci_HashSet$.prototype.empty__O = (function() {
  return this.sci_HashSet$__f_EmptySet
});
var $d_sci_HashSet$ = new $TypeData().initClass({
  sci_HashSet$: 0
}, false, "scala.collection.immutable.HashSet$", {
  sci_HashSet$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashSet$.prototype.$classData = $d_sci_HashSet$;
var $n_sci_HashSet$;
function $m_sci_HashSet$() {
  if ((!$n_sci_HashSet$)) {
    $n_sci_HashSet$ = new $c_sci_HashSet$()
  };
  return $n_sci_HashSet$
}
/** @constructor */
function $c_sci_LazyList$State$Cons(head, tail) {
  this.sci_LazyList$State$Cons__f_head = null;
  this.sci_LazyList$State$Cons__f_tail = null;
  this.sci_LazyList$State$Cons__f_head = head;
  this.sci_LazyList$State$Cons__f_tail = tail
}
$c_sci_LazyList$State$Cons.prototype = new $h_O();
$c_sci_LazyList$State$Cons.prototype.constructor = $c_sci_LazyList$State$Cons;
/** @constructor */
function $h_sci_LazyList$State$Cons() {
  /*<skip>*/
}
$h_sci_LazyList$State$Cons.prototype = $c_sci_LazyList$State$Cons.prototype;
$c_sci_LazyList$State$Cons.prototype.head__O = (function() {
  return this.sci_LazyList$State$Cons__f_head
});
$c_sci_LazyList$State$Cons.prototype.tail__sci_LazyList = (function() {
  return this.sci_LazyList$State$Cons__f_tail
});
var $d_sci_LazyList$State$Cons = new $TypeData().initClass({
  sci_LazyList$State$Cons: 0
}, false, "scala.collection.immutable.LazyList$State$Cons", {
  sci_LazyList$State$Cons: 1,
  O: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$State$Cons.prototype.$classData = $d_sci_LazyList$State$Cons;
/** @constructor */
function $c_sci_LazyList$State$Empty$() {
  /*<skip>*/
}
$c_sci_LazyList$State$Empty$.prototype = new $h_O();
$c_sci_LazyList$State$Empty$.prototype.constructor = $c_sci_LazyList$State$Empty$;
/** @constructor */
function $h_sci_LazyList$State$Empty$() {
  /*<skip>*/
}
$h_sci_LazyList$State$Empty$.prototype = $c_sci_LazyList$State$Empty$.prototype;
$c_sci_LazyList$State$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty lazy list")
});
$c_sci_LazyList$State$Empty$.prototype.tail__sci_LazyList = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty lazy list")
});
$c_sci_LazyList$State$Empty$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_LazyList$State$Empty$ = new $TypeData().initClass({
  sci_LazyList$State$Empty$: 0
}, false, "scala.collection.immutable.LazyList$State$Empty$", {
  sci_LazyList$State$Empty$: 1,
  O: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$State$Empty$.prototype.$classData = $d_sci_LazyList$State$Empty$;
var $n_sci_LazyList$State$Empty$;
function $m_sci_LazyList$State$Empty$() {
  if ((!$n_sci_LazyList$State$Empty$)) {
    $n_sci_LazyList$State$Empty$ = new $c_sci_LazyList$State$Empty$()
  };
  return $n_sci_LazyList$State$Empty$
}
/** @constructor */
function $c_sci_LazyList$WithFilter(lazyList, p) {
  this.sci_LazyList$WithFilter__f_filtered = null;
  this.sci_LazyList$WithFilter__f_filtered = $n(lazyList).filter__F1__sci_LazyList(p)
}
$c_sci_LazyList$WithFilter.prototype = new $h_sc_WithFilter();
$c_sci_LazyList$WithFilter.prototype.constructor = $c_sci_LazyList$WithFilter;
/** @constructor */
function $h_sci_LazyList$WithFilter() {
  /*<skip>*/
}
$h_sci_LazyList$WithFilter.prototype = $c_sci_LazyList$WithFilter.prototype;
$c_sci_LazyList$WithFilter.prototype.map__F1__sci_LazyList = (function(f) {
  return $n(this.sci_LazyList$WithFilter__f_filtered).map__F1__sci_LazyList(f)
});
$c_sci_LazyList$WithFilter.prototype.flatMap__F1__sci_LazyList = (function(f) {
  return $n(this.sci_LazyList$WithFilter__f_filtered).flatMap__F1__sci_LazyList(f)
});
$c_sci_LazyList$WithFilter.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_LazyList$WithFilter__f_filtered).foreach__F1__V(f)
});
$c_sci_LazyList$WithFilter.prototype.withFilter__F1__sc_WithFilter = (function(q) {
  return new $c_sci_LazyList$WithFilter(this.sci_LazyList$WithFilter__f_filtered, q)
});
$c_sci_LazyList$WithFilter.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_LazyList(f)
});
$c_sci_LazyList$WithFilter.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_LazyList(f)
});
var $d_sci_LazyList$WithFilter = new $TypeData().initClass({
  sci_LazyList$WithFilter: 0
}, false, "scala.collection.immutable.LazyList$WithFilter", {
  sci_LazyList$WithFilter: 1,
  sc_WithFilter: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$WithFilter.prototype.$classData = $d_sci_LazyList$WithFilter;
/** @constructor */
function $c_sci_ListMap$() {
  /*<skip>*/
}
$c_sci_ListMap$.prototype = new $h_O();
$c_sci_ListMap$.prototype.constructor = $c_sci_ListMap$;
/** @constructor */
function $h_sci_ListMap$() {
  /*<skip>*/
}
$h_sci_ListMap$.prototype = $c_sci_ListMap$.prototype;
$c_sci_ListMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_ListMap(elems)
});
$c_sci_ListMap$.prototype.from__sc_IterableOnce__sci_ListMap = (function(it) {
  if ((it instanceof $c_sci_ListMap)) {
    var x2 = $as_sci_ListMap(it);
    return x2
  } else if (false) {
    var x3 = $as_scm_LinkedHashMap(it);
    var current = $m_sci_ListMap$EmptyListMap$();
    var firstEntry = $n(x3)._firstEntry__scm_LinkedHashMap$LinkedEntry();
    while ((firstEntry !== null)) {
      current = new $c_sci_ListMap$Node($n(firstEntry).key__O(), $n(firstEntry).value__O(), current);
      firstEntry = $n(firstEntry).later__scm_LinkedHashMap$LinkedEntry()
    };
    return current
  } else if (($is_sc_Map(it) || $is_sc_MapView(it))) {
    var current$2 = $m_sci_ListMap$EmptyListMap$();
    var iter = $n(it).iterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var x1$2 = $as_T2($n(iter).next__O());
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var k = $n(x1$2)._1__O();
      var v = $n(x1$2)._2__O();
      current$2 = new $c_sci_ListMap$Node(k, v, current$2)
    };
    return current$2
  } else {
    var this$1 = new $c_sci_ListMapBuilder();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_ListMapBuilder(it));
    return this$2.result__sci_ListMap()
  }
});
$c_sci_ListMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_ListMapBuilder()
});
$c_sci_ListMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_ListMap(it)
});
$c_sci_ListMap$.prototype.empty__O = (function() {
  return $m_sci_ListMap$EmptyListMap$()
});
var $d_sci_ListMap$ = new $TypeData().initClass({
  sci_ListMap$: 0
}, false, "scala.collection.immutable.ListMap$", {
  sci_ListMap$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ListMap$.prototype.$classData = $d_sci_ListMap$;
var $n_sci_ListMap$;
function $m_sci_ListMap$() {
  if ((!$n_sci_ListMap$)) {
    $n_sci_ListMap$ = new $c_sci_ListMap$()
  };
  return $n_sci_ListMap$
}
/** @constructor */
function $c_sci_ListSet$() {
  /*<skip>*/
}
$c_sci_ListSet$.prototype = new $h_O();
$c_sci_ListSet$.prototype.constructor = $c_sci_ListSet$;
/** @constructor */
function $h_sci_ListSet$() {
  /*<skip>*/
}
$h_sci_ListSet$.prototype = $c_sci_ListSet$.prototype;
$c_sci_ListSet$.prototype.from__sc_IterableOnce__sci_ListSet = (function(it) {
  if ((it instanceof $c_sci_ListSet)) {
    var x2 = $as_sci_ListSet(it);
    return x2
  } else if (($n(it).knownSize__I() === 0)) {
    return $m_sci_ListSet$EmptyListSet$()
  } else {
    var this$1 = new $c_sci_ListSet$$anon$1();
    return $as_sci_ListSet($n($as_scm_Builder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this$1, it))).result__O())
  }
});
$c_sci_ListSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_ListSet$$anon$1()
});
$c_sci_ListSet$.prototype.empty__O = (function() {
  return $m_sci_ListSet$EmptyListSet$()
});
$c_sci_ListSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_ListSet(source)
});
var $d_sci_ListSet$ = new $TypeData().initClass({
  sci_ListSet$: 0
}, false, "scala.collection.immutable.ListSet$", {
  sci_ListSet$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ListSet$.prototype.$classData = $d_sci_ListSet$;
var $n_sci_ListSet$;
function $m_sci_ListSet$() {
  if ((!$n_sci_ListSet$)) {
    $n_sci_ListSet$ = new $c_sci_ListSet$()
  };
  return $n_sci_ListSet$
}
/** @constructor */
function $c_sci_Map$() {
  /*<skip>*/
}
$c_sci_Map$.prototype = new $h_O();
$c_sci_Map$.prototype.constructor = $c_sci_Map$;
/** @constructor */
function $h_sci_Map$() {
  /*<skip>*/
}
$h_sci_Map$.prototype = $c_sci_Map$.prototype;
$c_sci_Map$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Map(elems)
});
$c_sci_Map$.prototype.from__sc_IterableOnce__sci_Map = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    if ($n(x2).isEmpty__Z()) {
      return $m_sci_Map$EmptyMap$()
    }
  };
  if ((it instanceof $c_sci_HashMap)) {
    var x3 = $as_sci_HashMap(it);
    return x3
  };
  if ((it instanceof $c_sci_Map$Map1)) {
    var x4 = $as_sci_Map$Map1(it);
    return x4
  };
  if ((it instanceof $c_sci_Map$Map2)) {
    var x5 = $as_sci_Map$Map2(it);
    return x5
  };
  if ((it instanceof $c_sci_Map$Map3)) {
    var x6 = $as_sci_Map$Map3(it);
    return x6
  };
  if ((it instanceof $c_sci_Map$Map4)) {
    var x7 = $as_sci_Map$Map4(it);
    return x7
  };
  if ((it instanceof $c_sci_ListMap)) {
    var x8 = $as_sci_ListMap(it);
    return x8
  };
  if (false) {
    var x9 = $as_sci_TreeSeqMap(it);
    return x9
  };
  if (false) {
    var x10 = $as_sci_VectorMap(it);
    return x10
  };
  if (false) {
    var x11 = $as_sci_SeqMap$SeqMap1(it);
    return x11
  };
  if (false) {
    var x12 = $as_sci_SeqMap$SeqMap2(it);
    return x12
  };
  if (false) {
    var x13 = $as_sci_SeqMap$SeqMap3(it);
    return x13
  };
  if (false) {
    var x14 = $as_sci_SeqMap$SeqMap4(it);
    return x14
  };
  var this$1 = new $c_sci_MapBuilderImpl();
  var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_MapBuilderImpl(it));
  return this$2.result__sci_Map()
});
$c_sci_Map$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_MapBuilderImpl()
});
$c_sci_Map$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Map(it)
});
$c_sci_Map$.prototype.empty__O = (function() {
  return $m_sci_Map$EmptyMap$()
});
var $d_sci_Map$ = new $TypeData().initClass({
  sci_Map$: 0
}, false, "scala.collection.immutable.Map$", {
  sci_Map$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$.prototype.$classData = $d_sci_Map$;
var $n_sci_Map$;
function $m_sci_Map$() {
  if ((!$n_sci_Map$)) {
    $n_sci_Map$ = new $c_sci_Map$()
  };
  return $n_sci_Map$
}
/** @constructor */
function $c_sci_Set$() {
  /*<skip>*/
}
$c_sci_Set$.prototype = new $h_O();
$c_sci_Set$.prototype.constructor = $c_sci_Set$;
/** @constructor */
function $h_sci_Set$() {
  /*<skip>*/
}
$h_sci_Set$.prototype = $c_sci_Set$.prototype;
$c_sci_Set$.prototype.from__sc_IterableOnce__sci_Set = (function(it) {
  if (($n(it).knownSize__I() === 0)) {
    return $m_sci_Set$EmptySet$()
  } else if ((it instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(it);
    return x2
  } else if ((it instanceof $c_sci_ListSet)) {
    var x3 = $as_sci_ListSet(it);
    return x3
  } else if ((it instanceof $c_sci_Set$Set1)) {
    var x4 = $as_sci_Set$Set1(it);
    return x4
  } else if ((it instanceof $c_sci_Set$Set2)) {
    var x5 = $as_sci_Set$Set2(it);
    return x5
  } else if ((it instanceof $c_sci_Set$Set3)) {
    var x6 = $as_sci_Set$Set3(it);
    return x6
  } else if ((it instanceof $c_sci_Set$Set4)) {
    var x7 = $as_sci_Set$Set4(it);
    return x7
  } else if ((it instanceof $c_sci_HashMap$HashKeySet)) {
    var x8 = $as_sci_HashMap$HashKeySet(it);
    return x8
  } else if ((it instanceof $c_sci_MapOps$ImmutableKeySet)) {
    var x9 = $as_sci_MapOps$ImmutableKeySet(it);
    return x9
  } else {
    var this$1 = new $c_sci_SetBuilderImpl();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_SetBuilderImpl(it));
    return this$2.result__sci_Set()
  }
});
$c_sci_Set$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_SetBuilderImpl()
});
$c_sci_Set$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Set(source)
});
$c_sci_Set$.prototype.empty__O = (function() {
  return $m_sci_Set$EmptySet$()
});
var $d_sci_Set$ = new $TypeData().initClass({
  sci_Set$: 0
}, false, "scala.collection.immutable.Set$", {
  sci_Set$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$.prototype.$classData = $d_sci_Set$;
var $n_sci_Set$;
function $m_sci_Set$() {
  if ((!$n_sci_Set$)) {
    $n_sci_Set$ = new $c_sci_Set$()
  };
  return $n_sci_Set$
}
function $p_sci_Stream$WithFilter__filtered$lzycompute__sci_Stream($thiz) {
  if ((!$thiz.sci_Stream$WithFilter__f_bitmap$0)) {
    var this$1 = $n($thiz.sci_Stream$WithFilter__f_s);
    var pred = $thiz.sci_Stream$WithFilter__f_p;
    var f = this$1.filterImpl__F1__Z__sci_Stream(pred, false);
    $thiz.sci_Stream$WithFilter__f_s = null;
    $thiz.sci_Stream$WithFilter__f_filtered = f;
    $thiz.sci_Stream$WithFilter__f_bitmap$0 = true
  };
  return $thiz.sci_Stream$WithFilter__f_filtered
}
function $p_sci_Stream$WithFilter__filtered__sci_Stream($thiz) {
  return ((!$thiz.sci_Stream$WithFilter__f_bitmap$0) ? $p_sci_Stream$WithFilter__filtered$lzycompute__sci_Stream($thiz) : $thiz.sci_Stream$WithFilter__f_filtered)
}
/** @constructor */
function $c_sci_Stream$WithFilter(l, p) {
  this.sci_Stream$WithFilter__f_filtered = null;
  this.sci_Stream$WithFilter__f_p = null;
  this.sci_Stream$WithFilter__f_s = null;
  this.sci_Stream$WithFilter__f_bitmap$0 = false;
  this.sci_Stream$WithFilter__f_p = p;
  this.sci_Stream$WithFilter__f_s = l
}
$c_sci_Stream$WithFilter.prototype = new $h_sc_WithFilter();
$c_sci_Stream$WithFilter.prototype.constructor = $c_sci_Stream$WithFilter;
/** @constructor */
function $h_sci_Stream$WithFilter() {
  /*<skip>*/
}
$h_sci_Stream$WithFilter.prototype = $c_sci_Stream$WithFilter.prototype;
$c_sci_Stream$WithFilter.prototype.foreach__F1__V = (function(f) {
  $n($p_sci_Stream$WithFilter__filtered__sci_Stream(this)).foreach__F1__V(f)
});
$c_sci_Stream$WithFilter.prototype.withFilter__F1__sc_WithFilter = (function(q) {
  return new $c_sci_Stream$WithFilter($p_sci_Stream$WithFilter__filtered__sci_Stream(this), q)
});
$c_sci_Stream$WithFilter.prototype.flatMap__F1__O = (function(f) {
  return $n($p_sci_Stream$WithFilter__filtered__sci_Stream(this)).flatMap__F1__sci_Stream(f)
});
$c_sci_Stream$WithFilter.prototype.map__F1__O = (function(f) {
  return $n($p_sci_Stream$WithFilter__filtered__sci_Stream(this)).map__F1__sci_Stream(f)
});
var $d_sci_Stream$WithFilter = new $TypeData().initClass({
  sci_Stream$WithFilter: 0
}, false, "scala.collection.immutable.Stream$WithFilter", {
  sci_Stream$WithFilter: 1,
  sc_WithFilter: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$WithFilter.prototype.$classData = $d_sci_Stream$WithFilter;
/** @constructor */
function $c_sci_TreeMap$() {
  /*<skip>*/
}
$c_sci_TreeMap$.prototype = new $h_O();
$c_sci_TreeMap$.prototype.constructor = $c_sci_TreeMap$;
/** @constructor */
function $h_sci_TreeMap$() {
  /*<skip>*/
}
$h_sci_TreeMap$.prototype = $c_sci_TreeMap$.prototype;
$c_sci_TreeMap$.prototype.apply__sci_Seq__s_math_Ordering__O = (function(elems, evidence$38) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap(elems, evidence$38)
});
$c_sci_TreeMap$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap = (function(it, ordering) {
  if ((it instanceof $c_sci_TreeMap)) {
    var x2 = $as_sci_TreeMap(it);
    var x$2 = $n(x2).sci_TreeMap__f_ordering;
    if (((ordering === null) ? (x$2 === null) : $n(ordering).equals__O__Z(x$2))) {
      return x2
    }
  };
  if ($is_sc_SortedMap(it)) {
    var x3 = $as_sc_SortedMap(it);
    var x$4 = $n(x3).ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : $n(ordering).equals__O__Z(x$4))) {
      return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), $m_sci_RedBlackTree$().fromOrderedEntries__sc_Iterator__I__sci_RedBlackTree$Tree($n(x3).iterator__sc_Iterator(), $n(x3).size__I()), ordering)
    }
  };
  var t = null;
  var i = $n(it).iterator__sc_Iterator();
  while ($n(i).hasNext__Z()) {
    var x1$2 = $as_T2($n(i).next__O());
    if ((x1$2 === null)) {
      throw new $c_s_MatchError(x1$2)
    };
    var k = $n(x1$2)._1__O();
    var v = $n(x1$2)._2__O();
    t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, k, v, true, ordering)
  };
  return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), t, ordering)
});
$c_sci_TreeMap$.prototype.newBuilder__s_math_Ordering__scm_Builder = (function(evidence$39) {
  return new $c_sci_TreeMap$TreeMapBuilder(evidence$39)
});
$c_sci_TreeMap$.prototype.from__sc_IterableOnce__s_math_Ordering__O = (function(it, evidence$37) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap(it, evidence$37)
});
$c_sci_TreeMap$.prototype.empty__s_math_Ordering__O = (function(evidence$36) {
  return $ct_sci_TreeMap__s_math_Ordering__(new $c_sci_TreeMap(), evidence$36)
});
var $d_sci_TreeMap$ = new $TypeData().initClass({
  sci_TreeMap$: 0
}, false, "scala.collection.immutable.TreeMap$", {
  sci_TreeMap$: 1,
  O: 1,
  sc_SortedMapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_TreeMap$.prototype.$classData = $d_sci_TreeMap$;
var $n_sci_TreeMap$;
function $m_sci_TreeMap$() {
  if ((!$n_sci_TreeMap$)) {
    $n_sci_TreeMap$ = new $c_sci_TreeMap$()
  };
  return $n_sci_TreeMap$
}
/** @constructor */
function $c_sci_TreeMap$TreeMapBuilder$adder$(outer) {
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = null;
  this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer = outer
  };
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = null
}
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype = new $h_sr_AbstractFunction2();
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype.constructor = $c_sci_TreeMap$TreeMapBuilder$adder$;
/** @constructor */
function $h_sci_TreeMap$TreeMapBuilder$adder$() {
  /*<skip>*/
}
$h_sci_TreeMap$TreeMapBuilder$adder$.prototype = $c_sci_TreeMap$TreeMapBuilder$adder$.prototype;
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype.addForEach__sc_Map__V = (function(hasForEach) {
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = $n(this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer).sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree;
  $n(hasForEach).foreachEntry__F2__V(this);
  $n(this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer).sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator;
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = null
});
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype.apply__O__O__V = (function(key, value) {
  this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator = $n(this.sci_TreeMap$TreeMapBuilder$adder$__f_$outer).mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this.sci_TreeMap$TreeMapBuilder$adder$__f_accumulator, key, value)
});
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2)
});
var $d_sci_TreeMap$TreeMapBuilder$adder$ = new $TypeData().initClass({
  sci_TreeMap$TreeMapBuilder$adder$: 0
}, false, "scala.collection.immutable.TreeMap$TreeMapBuilder$adder$", {
  sci_TreeMap$TreeMapBuilder$adder$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1
});
$c_sci_TreeMap$TreeMapBuilder$adder$.prototype.$classData = $d_sci_TreeMap$TreeMapBuilder$adder$;
/** @constructor */
function $c_sci_TreeSet$sub$1$(outer) {
  this.sci_TreeSet$sub$1$__f_currentTree = null;
  this.sci_TreeSet$sub$1$__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sci_TreeSet$sub$1$__f_$outer = outer
  };
  this.sci_TreeSet$sub$1$__f_currentTree = $n(outer).sci_TreeSet__f_tree
}
$c_sci_TreeSet$sub$1$.prototype = new $h_sr_AbstractFunction1();
$c_sci_TreeSet$sub$1$.prototype.constructor = $c_sci_TreeSet$sub$1$;
/** @constructor */
function $h_sci_TreeSet$sub$1$() {
  /*<skip>*/
}
$h_sci_TreeSet$sub$1$.prototype = $c_sci_TreeSet$sub$1$.prototype;
$c_sci_TreeSet$sub$1$.prototype.apply__O__V = (function(k) {
  this.sci_TreeSet$sub$1$__f_currentTree = $m_sci_RedBlackTree$().delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet$sub$1$__f_currentTree, k, $n(this.sci_TreeSet$sub$1$__f_$outer).sci_TreeSet__f_ordering)
});
$c_sci_TreeSet$sub$1$.prototype.apply__O__O = (function(v1) {
  this.apply__O__V(v1)
});
function $as_sci_TreeSet$sub$1$(obj) {
  return (((obj instanceof $c_sci_TreeSet$sub$1$) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSet$sub$1$"))
}
function $isArrayOf_sci_TreeSet$sub$1$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSet$sub$1$)))
}
function $asArrayOf_sci_TreeSet$sub$1$(obj, depth) {
  return (($isArrayOf_sci_TreeSet$sub$1$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSet$sub$1$;", depth))
}
var $d_sci_TreeSet$sub$1$ = new $TypeData().initClass({
  sci_TreeSet$sub$1$: 0
}, false, "scala.collection.immutable.TreeSet$sub$1$", {
  sci_TreeSet$sub$1$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_sci_TreeSet$sub$1$.prototype.$classData = $d_sci_TreeSet$sub$1$;
function $f_scm_Builder__sizeHint__sc_IterableOnce__I__V($thiz, coll, delta) {
  var s = $n(coll).knownSize__I();
  if ((s !== (-1))) {
    $thiz.sizeHint__I__V(((s + delta) | 0))
  }
}
function $is_scm_Builder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Builder)))
}
function $as_scm_Builder(obj) {
  return (($is_scm_Builder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Builder"))
}
function $isArrayOf_scm_Builder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Builder)))
}
function $asArrayOf_scm_Builder(obj, depth) {
  return (($isArrayOf_scm_Builder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Builder;", depth))
}
/** @constructor */
function $c_scm_HashMap$() {
  /*<skip>*/
}
$c_scm_HashMap$.prototype = new $h_O();
$c_scm_HashMap$.prototype.constructor = $c_scm_HashMap$;
/** @constructor */
function $h_scm_HashMap$() {
  /*<skip>*/
}
$h_scm_HashMap$.prototype = $c_scm_HashMap$.prototype;
$c_scm_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_HashMap(elems)
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__scm_HashMap = (function(it) {
  var k = $n(it).knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  return $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), cap, 0.75).addAll__sc_IterableOnce__scm_HashMap(it)
});
$c_scm_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashMap$$anon$6(16, 0.75)
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__scm_HashMap(it)
});
$c_scm_HashMap$.prototype.empty__O = (function() {
  return $ct_scm_HashMap__(new $c_scm_HashMap())
});
var $d_scm_HashMap$ = new $TypeData().initClass({
  scm_HashMap$: 0
}, false, "scala.collection.mutable.HashMap$", {
  scm_HashMap$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashMap$.prototype.$classData = $d_scm_HashMap$;
var $n_scm_HashMap$;
function $m_scm_HashMap$() {
  if ((!$n_scm_HashMap$)) {
    $n_scm_HashMap$ = new $c_scm_HashMap$()
  };
  return $n_scm_HashMap$
}
/** @constructor */
function $c_scm_HashSet$() {
  /*<skip>*/
}
$c_scm_HashSet$.prototype = new $h_O();
$c_scm_HashSet$.prototype.constructor = $c_scm_HashSet$;
/** @constructor */
function $h_scm_HashSet$() {
  /*<skip>*/
}
$h_scm_HashSet$.prototype = $c_scm_HashSet$.prototype;
$c_scm_HashSet$.prototype.from__sc_IterableOnce__scm_HashSet = (function(it) {
  var k = $n(it).knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  var this$1 = $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), cap, 0.75);
  return this$1.addAll__sc_IterableOnce__scm_HashSet(it)
});
$c_scm_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashSet$$anon$4(16, 0.75)
});
$c_scm_HashSet$.prototype.empty__O = (function() {
  return $ct_scm_HashSet__(new $c_scm_HashSet())
});
$c_scm_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_HashSet(source)
});
var $d_scm_HashSet$ = new $TypeData().initClass({
  scm_HashSet$: 0
}, false, "scala.collection.mutable.HashSet$", {
  scm_HashSet$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashSet$.prototype.$classData = $d_scm_HashSet$;
var $n_scm_HashSet$;
function $m_scm_HashSet$() {
  if ((!$n_scm_HashSet$)) {
    $n_scm_HashSet$ = new $c_scm_HashSet$()
  };
  return $n_scm_HashSet$
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$SyncBatch(outer, runnable) {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null;
  $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__(this, outer, runnable, $m_s_concurrent_BatchingExecutorStatics$().s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray, 1)
}
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype = new $h_s_concurrent_BatchingExecutor$AbstractBatch();
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$SyncBatch() {
  /*<skip>*/
}
$h_s_concurrent_BatchingExecutor$SyncBatch.prototype = $c_s_concurrent_BatchingExecutor$SyncBatch.prototype;
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.run__V = (function() {
  while (true) {
    try {
      this.runN__I__V(1024)
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if (false) {
        var x2 = $as_jl_InterruptedException(e$2);
        $n(this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer);
        $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(x2)
      } else if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        $n(this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer);
        $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(e$2)
      } else {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
      }
    };
    if ((this.s_concurrent_BatchingExecutor$AbstractBatch__f_size > 0)) {
      continue
    };
    return (void 0)
  }
});
function $as_s_concurrent_BatchingExecutor$SyncBatch(obj) {
  return (((obj instanceof $c_s_concurrent_BatchingExecutor$SyncBatch) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.BatchingExecutor$SyncBatch"))
}
function $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BatchingExecutor$SyncBatch)))
}
function $asArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (($isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.BatchingExecutor$SyncBatch;", depth))
}
var $d_s_concurrent_BatchingExecutor$SyncBatch = new $TypeData().initClass({
  s_concurrent_BatchingExecutor$SyncBatch: 0
}, false, "scala.concurrent.BatchingExecutor$SyncBatch", {
  s_concurrent_BatchingExecutor$SyncBatch: 1,
  s_concurrent_BatchingExecutor$AbstractBatch: 1,
  O: 1,
  jl_Runnable: 1
});
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.$classData = $d_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $c_s_concurrent_impl_Promise$Link(to) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, to)
}
$c_s_concurrent_impl_Promise$Link.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$Link.prototype.constructor = $c_s_concurrent_impl_Promise$Link;
/** @constructor */
function $h_s_concurrent_impl_Promise$Link() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$Link.prototype = $c_s_concurrent_impl_Promise$Link.prototype;
$c_s_concurrent_impl_Promise$Link.prototype.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise = (function(owner) {
  var c = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value);
  var current = c;
  var target = c;
  while (true) {
    var value = $n(target).ju_concurrent_atomic_AtomicReference__f_value;
    if ($is_s_concurrent_impl_Promise$Callbacks(value)) {
      if (this.compareAndSet__O__O__Z(current, target)) {
        return target
      } else {
        current = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value)
      }
    } else if ((value instanceof $c_s_concurrent_impl_Promise$Link)) {
      target = $as_s_concurrent_impl_Promise$DefaultPromise($n($as_s_concurrent_impl_Promise$Link(value)).ju_concurrent_atomic_AtomicReference__f_value)
    } else {
      $n(owner).unlink__s_util_Try__V($as_s_util_Try(value));
      return owner
    }
  }
});
function $as_s_concurrent_impl_Promise$Link(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Link) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Link"))
}
function $isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Link)))
}
function $asArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Link;", depth))
}
var $d_s_concurrent_impl_Promise$Link = new $TypeData().initClass({
  s_concurrent_impl_Promise$Link: 0
}, false, "scala.concurrent.impl.Promise$Link", {
  s_concurrent_impl_Promise$Link: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_concurrent_impl_Promise$Link.prototype.$classData = $d_s_concurrent_impl_Promise$Link;
/** @constructor */
function $c_s_jdk_CollectionConverters$() {
  /*<skip>*/
}
$c_s_jdk_CollectionConverters$.prototype = new $h_O();
$c_s_jdk_CollectionConverters$.prototype.constructor = $c_s_jdk_CollectionConverters$;
/** @constructor */
function $h_s_jdk_CollectionConverters$() {
  /*<skip>*/
}
$h_s_jdk_CollectionConverters$.prototype = $c_s_jdk_CollectionConverters$.prototype;
var $d_s_jdk_CollectionConverters$ = new $TypeData().initClass({
  s_jdk_CollectionConverters$: 0
}, false, "scala.jdk.CollectionConverters$", {
  s_jdk_CollectionConverters$: 1,
  O: 1,
  sc_convert_AsJavaExtensions: 1,
  sc_convert_AsScalaExtensions: 1
});
$c_s_jdk_CollectionConverters$.prototype.$classData = $d_s_jdk_CollectionConverters$;
var $n_s_jdk_CollectionConverters$;
function $m_s_jdk_CollectionConverters$() {
  if ((!$n_s_jdk_CollectionConverters$)) {
    $n_s_jdk_CollectionConverters$ = new $c_s_jdk_CollectionConverters$()
  };
  return $n_s_jdk_CollectionConverters$
}
/** @constructor */
function $c_s_jdk_javaapi_CollectionConverters$() {
  /*<skip>*/
}
$c_s_jdk_javaapi_CollectionConverters$.prototype = new $h_O();
$c_s_jdk_javaapi_CollectionConverters$.prototype.constructor = $c_s_jdk_javaapi_CollectionConverters$;
/** @constructor */
function $h_s_jdk_javaapi_CollectionConverters$() {
  /*<skip>*/
}
$h_s_jdk_javaapi_CollectionConverters$.prototype = $c_s_jdk_javaapi_CollectionConverters$.prototype;
var $d_s_jdk_javaapi_CollectionConverters$ = new $TypeData().initClass({
  s_jdk_javaapi_CollectionConverters$: 0
}, false, "scala.jdk.javaapi.CollectionConverters$", {
  s_jdk_javaapi_CollectionConverters$: 1,
  O: 1,
  sc_convert_AsJavaConverters: 1,
  sc_convert_AsScalaConverters: 1
});
$c_s_jdk_javaapi_CollectionConverters$.prototype.$classData = $d_s_jdk_javaapi_CollectionConverters$;
var $n_s_jdk_javaapi_CollectionConverters$;
function $m_s_jdk_javaapi_CollectionConverters$() {
  if ((!$n_s_jdk_javaapi_CollectionConverters$)) {
    $n_s_jdk_javaapi_CollectionConverters$ = new $c_s_jdk_javaapi_CollectionConverters$()
  };
  return $n_s_jdk_javaapi_CollectionConverters$
}
/** @constructor */
function $c_s_math_Equiv$() {
  /*<skip>*/
}
$c_s_math_Equiv$.prototype = new $h_O();
$c_s_math_Equiv$.prototype.constructor = $c_s_math_Equiv$;
/** @constructor */
function $h_s_math_Equiv$() {
  /*<skip>*/
}
$h_s_math_Equiv$.prototype = $c_s_math_Equiv$.prototype;
$c_s_math_Equiv$.prototype.universal__s_math_Equiv = (function() {
  return new $c_s_math_Equiv$$$Lambda$2(((x$3$2, x$4$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(x$3$2, x$4$2)))
});
$c_s_math_Equiv$.prototype.by__F1__s_math_Equiv__s_math_Equiv = (function(f, evidence$1) {
  return new $c_s_math_Equiv$$$Lambda$5(((x$2, y$2) => $n(evidence$1).equiv__O__O__Z($n(f).apply__O__O(x$2), $n(f).apply__O__O(y$2))))
});
var $d_s_math_Equiv$ = new $TypeData().initClass({
  s_math_Equiv$: 0
}, false, "scala.math.Equiv$", {
  s_math_Equiv$: 1,
  O: 1,
  s_math_LowPriorityEquiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$.prototype.$classData = $d_s_math_Equiv$;
var $n_s_math_Equiv$;
function $m_s_math_Equiv$() {
  if ((!$n_s_math_Equiv$)) {
    $n_s_math_Equiv$ = new $c_s_math_Equiv$()
  };
  return $n_s_math_Equiv$
}
/** @constructor */
function $c_s_math_Equiv$$$Lambda$2(f) {
  this.s_math_Equiv$$$Lambda$2__f_f = null;
  this.s_math_Equiv$$$Lambda$2__f_f = f
}
$c_s_math_Equiv$$$Lambda$2.prototype = new $h_O();
$c_s_math_Equiv$$$Lambda$2.prototype.constructor = $c_s_math_Equiv$$$Lambda$2;
/** @constructor */
function $h_s_math_Equiv$$$Lambda$2() {
  /*<skip>*/
}
$h_s_math_Equiv$$$Lambda$2.prototype = $c_s_math_Equiv$$$Lambda$2.prototype;
$c_s_math_Equiv$$$Lambda$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $uZ((0, this.s_math_Equiv$$$Lambda$2__f_f)(x, y))
});
var $d_s_math_Equiv$$$Lambda$2 = new $TypeData().initClass({
  s_math_Equiv$$$Lambda$2: 0
}, false, "scala.math.Equiv$$$Lambda$2", {
  s_math_Equiv$$$Lambda$2: 1,
  O: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$$$Lambda$2.prototype.$classData = $d_s_math_Equiv$$$Lambda$2;
/** @constructor */
function $c_s_math_Equiv$$$Lambda$5(f) {
  this.s_math_Equiv$$$Lambda$5__f_f = null;
  this.s_math_Equiv$$$Lambda$5__f_f = f
}
$c_s_math_Equiv$$$Lambda$5.prototype = new $h_O();
$c_s_math_Equiv$$$Lambda$5.prototype.constructor = $c_s_math_Equiv$$$Lambda$5;
/** @constructor */
function $h_s_math_Equiv$$$Lambda$5() {
  /*<skip>*/
}
$h_s_math_Equiv$$$Lambda$5.prototype = $c_s_math_Equiv$$$Lambda$5.prototype;
$c_s_math_Equiv$$$Lambda$5.prototype.equiv__O__O__Z = (function(x$3, y$3) {
  return $uZ((0, this.s_math_Equiv$$$Lambda$5__f_f)(x$3, y$3))
});
var $d_s_math_Equiv$$$Lambda$5 = new $TypeData().initClass({
  s_math_Equiv$$$Lambda$5: 0
}, false, "scala.math.Equiv$$$Lambda$5", {
  s_math_Equiv$$$Lambda$5: 1,
  O: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$$$Lambda$5.prototype.$classData = $d_s_math_Equiv$$$Lambda$5;
/** @constructor */
function $c_s_math_Equiv$Boolean$() {
  /*<skip>*/
}
$c_s_math_Equiv$Boolean$.prototype = new $h_O();
$c_s_math_Equiv$Boolean$.prototype.constructor = $c_s_math_Equiv$Boolean$;
/** @constructor */
function $h_s_math_Equiv$Boolean$() {
  /*<skip>*/
}
$h_s_math_Equiv$Boolean$.prototype = $c_s_math_Equiv$Boolean$.prototype;
$c_s_math_Equiv$Boolean$.prototype.equiv__Z__Z__Z = (function(x, y) {
  return (x === y)
});
$c_s_math_Equiv$Boolean$.prototype.equiv__O__O__Z = (function(x, y) {
  return this.equiv__Z__Z__Z($uZ(x), $uZ(y))
});
var $d_s_math_Equiv$Boolean$ = new $TypeData().initClass({
  s_math_Equiv$Boolean$: 0
}, false, "scala.math.Equiv$Boolean$", {
  s_math_Equiv$Boolean$: 1,
  O: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$Boolean$.prototype.$classData = $d_s_math_Equiv$Boolean$;
var $n_s_math_Equiv$Boolean$;
function $m_s_math_Equiv$Boolean$() {
  if ((!$n_s_math_Equiv$Boolean$)) {
    $n_s_math_Equiv$Boolean$ = new $c_s_math_Equiv$Boolean$()
  };
  return $n_s_math_Equiv$Boolean$
}
function $f_s_math_Equiv$Double$StrictEquiv__equiv__D__D__Z($thiz, x, y) {
  return ($m_jl_Double$().compare__D__D__I(x, y) === 0)
}
/** @constructor */
function $c_s_math_Equiv$Int$() {
  /*<skip>*/
}
$c_s_math_Equiv$Int$.prototype = new $h_O();
$c_s_math_Equiv$Int$.prototype.constructor = $c_s_math_Equiv$Int$;
/** @constructor */
function $h_s_math_Equiv$Int$() {
  /*<skip>*/
}
$h_s_math_Equiv$Int$.prototype = $c_s_math_Equiv$Int$.prototype;
$c_s_math_Equiv$Int$.prototype.equiv__I__I__Z = (function(x, y) {
  return (x === y)
});
$c_s_math_Equiv$Int$.prototype.equiv__O__O__Z = (function(x, y) {
  return this.equiv__I__I__Z($uI(x), $uI(y))
});
var $d_s_math_Equiv$Int$ = new $TypeData().initClass({
  s_math_Equiv$Int$: 0
}, false, "scala.math.Equiv$Int$", {
  s_math_Equiv$Int$: 1,
  O: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$Int$.prototype.$classData = $d_s_math_Equiv$Int$;
var $n_s_math_Equiv$Int$;
function $m_s_math_Equiv$Int$() {
  if ((!$n_s_math_Equiv$Int$)) {
    $n_s_math_Equiv$Int$ = new $c_s_math_Equiv$Int$()
  };
  return $n_s_math_Equiv$Int$
}
/** @constructor */
function $c_s_math_Equiv$OptionEquiv(eqv) {
  this.s_math_Equiv$OptionEquiv__f_eqv = null;
  this.s_math_Equiv$OptionEquiv__f_eqv = eqv
}
$c_s_math_Equiv$OptionEquiv.prototype = new $h_O();
$c_s_math_Equiv$OptionEquiv.prototype.constructor = $c_s_math_Equiv$OptionEquiv;
/** @constructor */
function $h_s_math_Equiv$OptionEquiv() {
  /*<skip>*/
}
$h_s_math_Equiv$OptionEquiv.prototype = $c_s_math_Equiv$OptionEquiv.prototype;
$c_s_math_Equiv$OptionEquiv.prototype.equiv__s_Option__s_Option__Z = (function(x, y) {
  var x$2 = $m_s_None$();
  if ((x$2 === x)) {
    var x$4 = $m_s_None$();
    var $$x1 = (x$4 === y)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return true
  };
  if ((x instanceof $c_s_Some)) {
    var x8 = $as_s_Some(x);
    var x$6 = $n(x8).s_Some__f_value;
    if ((y instanceof $c_s_Some)) {
      var x9 = $as_s_Some(y);
      var y$2 = $n(x9).s_Some__f_value;
      return $n(this.s_math_Equiv$OptionEquiv__f_eqv).equiv__O__O__Z(x$6, y$2)
    }
  };
  return false
});
$c_s_math_Equiv$OptionEquiv.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true
    }
  };
  if ((obj instanceof $c_s_math_Equiv$OptionEquiv)) {
    var x3 = $as_s_math_Equiv$OptionEquiv(obj);
    var x = this.s_math_Equiv$OptionEquiv__f_eqv;
    var x$2 = $n(x3).s_math_Equiv$OptionEquiv__f_eqv;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  };
  return false
});
$c_s_math_Equiv$OptionEquiv.prototype.hashCode__I = (function() {
  return Math.imul(43, $n(this.s_math_Equiv$OptionEquiv__f_eqv).hashCode__I())
});
$c_s_math_Equiv$OptionEquiv.prototype.equiv__O__O__Z = (function(x, y) {
  return this.equiv__s_Option__s_Option__Z($as_s_Option(x), $as_s_Option(y))
});
function $as_s_math_Equiv$OptionEquiv(obj) {
  return (((obj instanceof $c_s_math_Equiv$OptionEquiv) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Equiv$OptionEquiv"))
}
function $isArrayOf_s_math_Equiv$OptionEquiv(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Equiv$OptionEquiv)))
}
function $asArrayOf_s_math_Equiv$OptionEquiv(obj, depth) {
  return (($isArrayOf_s_math_Equiv$OptionEquiv(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Equiv$OptionEquiv;", depth))
}
var $d_s_math_Equiv$OptionEquiv = new $TypeData().initClass({
  s_math_Equiv$OptionEquiv: 0
}, false, "scala.math.Equiv$OptionEquiv", {
  s_math_Equiv$OptionEquiv: 1,
  O: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$OptionEquiv.prototype.$classData = $d_s_math_Equiv$OptionEquiv;
/** @constructor */
function $c_s_math_Equiv$String$() {
  /*<skip>*/
}
$c_s_math_Equiv$String$.prototype = new $h_O();
$c_s_math_Equiv$String$.prototype.constructor = $c_s_math_Equiv$String$;
/** @constructor */
function $h_s_math_Equiv$String$() {
  /*<skip>*/
}
$h_s_math_Equiv$String$.prototype = $c_s_math_Equiv$String$.prototype;
$c_s_math_Equiv$String$.prototype.equiv__T__T__Z = (function(x, y) {
  return (x === y)
});
$c_s_math_Equiv$String$.prototype.equiv__O__O__Z = (function(x, y) {
  return this.equiv__T__T__Z($as_T(x), $as_T(y))
});
var $d_s_math_Equiv$String$ = new $TypeData().initClass({
  s_math_Equiv$String$: 0
}, false, "scala.math.Equiv$String$", {
  s_math_Equiv$String$: 1,
  O: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$String$.prototype.$classData = $d_s_math_Equiv$String$;
var $n_s_math_Equiv$String$;
function $m_s_math_Equiv$String$() {
  if ((!$n_s_math_Equiv$String$)) {
    $n_s_math_Equiv$String$ = new $c_s_math_Equiv$String$()
  };
  return $n_s_math_Equiv$String$
}
/** @constructor */
function $c_s_math_Ordering$() {
  /*<skip>*/
}
$c_s_math_Ordering$.prototype = new $h_O();
$c_s_math_Ordering$.prototype.constructor = $c_s_math_Ordering$;
/** @constructor */
function $h_s_math_Ordering$() {
  /*<skip>*/
}
$h_s_math_Ordering$.prototype = $c_s_math_Ordering$.prototype;
var $d_s_math_Ordering$ = new $TypeData().initClass({
  s_math_Ordering$: 0
}, false, "scala.math.Ordering$", {
  s_math_Ordering$: 1,
  O: 1,
  s_math_LowPriorityOrderingImplicits: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$.prototype.$classData = $d_s_math_Ordering$;
var $n_s_math_Ordering$;
function $m_s_math_Ordering$() {
  if ((!$n_s_math_Ordering$)) {
    $n_s_math_Ordering$ = new $c_s_math_Ordering$()
  };
  return $n_s_math_Ordering$
}
function $f_s_math_PartialOrdering__equiv__O__O__Z($thiz, x, y) {
  return ($thiz.lteq__O__O__Z(x, y) && $thiz.lteq__O__O__Z(y, x))
}
function $is_s_math_PartialOrdering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_PartialOrdering)))
}
function $as_s_math_PartialOrdering(obj) {
  return (($is_s_math_PartialOrdering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.PartialOrdering"))
}
function $isArrayOf_s_math_PartialOrdering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_PartialOrdering)))
}
function $asArrayOf_s_math_PartialOrdering(obj, depth) {
  return (($isArrayOf_s_math_PartialOrdering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.PartialOrdering;", depth))
}
/** @constructor */
function $c_s_math_ScalaNumber() {
  /*<skip>*/
}
$c_s_math_ScalaNumber.prototype = new $h_jl_Number();
$c_s_math_ScalaNumber.prototype.constructor = $c_s_math_ScalaNumber;
/** @constructor */
function $h_s_math_ScalaNumber() {
  /*<skip>*/
}
$h_s_math_ScalaNumber.prototype = $c_s_math_ScalaNumber.prototype;
function $as_s_math_ScalaNumber(obj) {
  return (((obj instanceof $c_s_math_ScalaNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.ScalaNumber"))
}
function $isArrayOf_s_math_ScalaNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_ScalaNumber)))
}
function $asArrayOf_s_math_ScalaNumber(obj, depth) {
  return (($isArrayOf_s_math_ScalaNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.ScalaNumber;", depth))
}
/** @constructor */
function $c_sr_AbstractPartialFunction() {
  /*<skip>*/
}
$c_sr_AbstractPartialFunction.prototype = new $h_O();
$c_sr_AbstractPartialFunction.prototype.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
  /*<skip>*/
}
$h_sr_AbstractPartialFunction.prototype = $c_sr_AbstractPartialFunction.prototype;
$c_sr_AbstractPartialFunction.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that)
});
$c_sr_AbstractPartialFunction.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sr_AbstractPartialFunction.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this)
});
$c_sr_AbstractPartialFunction.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action)
});
$c_sr_AbstractPartialFunction.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sr_AbstractPartialFunction.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sr_AbstractPartialFunction.prototype.apply__O__O = (function(x) {
  return this.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf)
});
$c_sr_AbstractPartialFunction.prototype.apply$mcZI$sp__I__Z = (function(x) {
  return $uZ(this.apply__O__O(x))
});
$c_sr_AbstractPartialFunction.prototype.andThen__F1__F1 = (function(g) {
  return this.andThen__F1__s_PartialFunction(g)
});
var $d_sr_Nothing$ = new $TypeData().initClass({
  sr_Nothing$: 0
}, false, "scala.runtime.Nothing$", {
  sr_Nothing$: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
/** @constructor */
function $c_sjs_js_Any$() {
  /*<skip>*/
}
$c_sjs_js_Any$.prototype = new $h_O();
$c_sjs_js_Any$.prototype.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
  /*<skip>*/
}
$h_sjs_js_Any$.prototype = $c_sjs_js_Any$.prototype;
$c_sjs_js_Any$.prototype.undefOr2jsAny__sjs_js_$bar__F1__sjs_js_Any = (function(value, ev) {
  if ((value === (void 0))) {
    return (void 0)
  } else {
    var a = $n(ev).apply__O__O(value);
    return a
  }
});
$c_sjs_js_Any$.prototype.fromFunction0__F0__sjs_js_Function0 = (function(f) {
  return (() => $n(f).apply__O())
});
$c_sjs_js_Any$.prototype.fromFunction1__F1__sjs_js_Function1 = (function(f) {
  return ((arg1$2) => $n(f).apply__O__O(arg1$2))
});
$c_sjs_js_Any$.prototype.fromFunction2__F2__sjs_js_Function2 = (function(f) {
  return ((arg1$2, arg2$2) => $n(f).apply__O__O__O(arg1$2, arg2$2))
});
$c_sjs_js_Any$.prototype.fromFunction3__F3__sjs_js_Function3 = (function(f) {
  return ((arg1$2, arg2$2, arg3$2) => $n(f).apply__O__O__O__O(arg1$2, arg2$2, arg3$2))
});
var $d_sjs_js_Any$ = new $TypeData().initClass({
  sjs_js_Any$: 0
}, false, "scala.scalajs.js.Any$", {
  sjs_js_Any$: 1,
  O: 1,
  sjs_js_LowPrioAnyImplicits: 1,
  sjs_js_LowestPrioAnyImplicits: 1
});
$c_sjs_js_Any$.prototype.$classData = $d_sjs_js_Any$;
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$()
  };
  return $n_sjs_js_Any$
}
/** @constructor */
function $c_sjsr_AnonFunction0(f) {
  this.sjsr_AnonFunction0__f_f = null;
  this.sjsr_AnonFunction0__f_f = f
}
$c_sjsr_AnonFunction0.prototype = new $h_sr_AbstractFunction0();
$c_sjsr_AnonFunction0.prototype.constructor = $c_sjsr_AnonFunction0;
/** @constructor */
function $h_sjsr_AnonFunction0() {
  /*<skip>*/
}
$h_sjsr_AnonFunction0.prototype = $c_sjsr_AnonFunction0.prototype;
$c_sjsr_AnonFunction0.prototype.apply__O = (function() {
  return (0, this.sjsr_AnonFunction0__f_f)()
});
var $d_sjsr_AnonFunction0 = new $TypeData().initClass({
  sjsr_AnonFunction0: 0
}, false, "scala.scalajs.runtime.AnonFunction0", {
  sjsr_AnonFunction0: 1,
  sr_AbstractFunction0: 1,
  O: 1,
  F0: 1
});
$c_sjsr_AnonFunction0.prototype.$classData = $d_sjsr_AnonFunction0;
/** @constructor */
function $c_sjsr_AnonFunction1(f) {
  this.sjsr_AnonFunction1__f_f = null;
  this.sjsr_AnonFunction1__f_f = f
}
$c_sjsr_AnonFunction1.prototype = new $h_sr_AbstractFunction1();
$c_sjsr_AnonFunction1.prototype.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
  /*<skip>*/
}
$h_sjsr_AnonFunction1.prototype = $c_sjsr_AnonFunction1.prototype;
$c_sjsr_AnonFunction1.prototype.apply__O__O = (function(arg1) {
  return (0, this.sjsr_AnonFunction1__f_f)(arg1)
});
var $d_sjsr_AnonFunction1 = new $TypeData().initClass({
  sjsr_AnonFunction1: 0
}, false, "scala.scalajs.runtime.AnonFunction1", {
  sjsr_AnonFunction1: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_sjsr_AnonFunction1.prototype.$classData = $d_sjsr_AnonFunction1;
/** @constructor */
function $c_sjsr_AnonFunction10(f) {
  this.sjsr_AnonFunction10__f_f = null;
  this.sjsr_AnonFunction10__f_f = f
}
$c_sjsr_AnonFunction10.prototype = new $h_sr_AbstractFunction10();
$c_sjsr_AnonFunction10.prototype.constructor = $c_sjsr_AnonFunction10;
/** @constructor */
function $h_sjsr_AnonFunction10() {
  /*<skip>*/
}
$h_sjsr_AnonFunction10.prototype = $c_sjsr_AnonFunction10.prototype;
$c_sjsr_AnonFunction10.prototype.apply__O__O__O__O__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10) {
  return (0, this.sjsr_AnonFunction10__f_f)(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10)
});
var $d_sjsr_AnonFunction10 = new $TypeData().initClass({
  sjsr_AnonFunction10: 0
}, false, "scala.scalajs.runtime.AnonFunction10", {
  sjsr_AnonFunction10: 1,
  sr_AbstractFunction10: 1,
  O: 1,
  F10: 1
});
$c_sjsr_AnonFunction10.prototype.$classData = $d_sjsr_AnonFunction10;
/** @constructor */
function $c_sjsr_AnonFunction11(f) {
  this.sjsr_AnonFunction11__f_f = null;
  this.sjsr_AnonFunction11__f_f = f
}
$c_sjsr_AnonFunction11.prototype = new $h_sr_AbstractFunction11();
$c_sjsr_AnonFunction11.prototype.constructor = $c_sjsr_AnonFunction11;
/** @constructor */
function $h_sjsr_AnonFunction11() {
  /*<skip>*/
}
$h_sjsr_AnonFunction11.prototype = $c_sjsr_AnonFunction11.prototype;
$c_sjsr_AnonFunction11.prototype.apply__O__O__O__O__O__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10, arg11) {
  return (0, this.sjsr_AnonFunction11__f_f)(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10, arg11)
});
var $d_sjsr_AnonFunction11 = new $TypeData().initClass({
  sjsr_AnonFunction11: 0
}, false, "scala.scalajs.runtime.AnonFunction11", {
  sjsr_AnonFunction11: 1,
  sr_AbstractFunction11: 1,
  O: 1,
  F11: 1
});
$c_sjsr_AnonFunction11.prototype.$classData = $d_sjsr_AnonFunction11;
/** @constructor */
function $c_sjsr_AnonFunction12(f) {
  this.sjsr_AnonFunction12__f_f = null;
  this.sjsr_AnonFunction12__f_f = f
}
$c_sjsr_AnonFunction12.prototype = new $h_sr_AbstractFunction12();
$c_sjsr_AnonFunction12.prototype.constructor = $c_sjsr_AnonFunction12;
/** @constructor */
function $h_sjsr_AnonFunction12() {
  /*<skip>*/
}
$h_sjsr_AnonFunction12.prototype = $c_sjsr_AnonFunction12.prototype;
$c_sjsr_AnonFunction12.prototype.apply__O__O__O__O__O__O__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10, arg11, arg12) {
  return (0, this.sjsr_AnonFunction12__f_f)(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10, arg11, arg12)
});
var $d_sjsr_AnonFunction12 = new $TypeData().initClass({
  sjsr_AnonFunction12: 0
}, false, "scala.scalajs.runtime.AnonFunction12", {
  sjsr_AnonFunction12: 1,
  sr_AbstractFunction12: 1,
  O: 1,
  F12: 1
});
$c_sjsr_AnonFunction12.prototype.$classData = $d_sjsr_AnonFunction12;
/** @constructor */
function $c_sjsr_AnonFunction13(f) {
  this.sjsr_AnonFunction13__f_f = null;
  this.sjsr_AnonFunction13__f_f = f
}
$c_sjsr_AnonFunction13.prototype = new $h_sr_AbstractFunction13();
$c_sjsr_AnonFunction13.prototype.constructor = $c_sjsr_AnonFunction13;
/** @constructor */
function $h_sjsr_AnonFunction13() {
  /*<skip>*/
}
$h_sjsr_AnonFunction13.prototype = $c_sjsr_AnonFunction13.prototype;
$c_sjsr_AnonFunction13.prototype.apply__O__O__O__O__O__O__O__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10, arg11, arg12, arg13) {
  return (0, this.sjsr_AnonFunction13__f_f)(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10, arg11, arg12, arg13)
});
var $d_sjsr_AnonFunction13 = new $TypeData().initClass({
  sjsr_AnonFunction13: 0
}, false, "scala.scalajs.runtime.AnonFunction13", {
  sjsr_AnonFunction13: 1,
  sr_AbstractFunction13: 1,
  O: 1,
  F13: 1
});
$c_sjsr_AnonFunction13.prototype.$classData = $d_sjsr_AnonFunction13;
/** @constructor */
function $c_sjsr_AnonFunction2(f) {
  this.sjsr_AnonFunction2__f_f = null;
  this.sjsr_AnonFunction2__f_f = f
}
$c_sjsr_AnonFunction2.prototype = new $h_sr_AbstractFunction2();
$c_sjsr_AnonFunction2.prototype.constructor = $c_sjsr_AnonFunction2;
/** @constructor */
function $h_sjsr_AnonFunction2() {
  /*<skip>*/
}
$h_sjsr_AnonFunction2.prototype = $c_sjsr_AnonFunction2.prototype;
$c_sjsr_AnonFunction2.prototype.apply__O__O__O = (function(arg1, arg2) {
  return (0, this.sjsr_AnonFunction2__f_f)(arg1, arg2)
});
var $d_sjsr_AnonFunction2 = new $TypeData().initClass({
  sjsr_AnonFunction2: 0
}, false, "scala.scalajs.runtime.AnonFunction2", {
  sjsr_AnonFunction2: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1
});
$c_sjsr_AnonFunction2.prototype.$classData = $d_sjsr_AnonFunction2;
/** @constructor */
function $c_sjsr_AnonFunction3(f) {
  this.sjsr_AnonFunction3__f_f = null;
  this.sjsr_AnonFunction3__f_f = f
}
$c_sjsr_AnonFunction3.prototype = new $h_sr_AbstractFunction3();
$c_sjsr_AnonFunction3.prototype.constructor = $c_sjsr_AnonFunction3;
/** @constructor */
function $h_sjsr_AnonFunction3() {
  /*<skip>*/
}
$h_sjsr_AnonFunction3.prototype = $c_sjsr_AnonFunction3.prototype;
$c_sjsr_AnonFunction3.prototype.apply__O__O__O__O = (function(arg1, arg2, arg3) {
  return (0, this.sjsr_AnonFunction3__f_f)(arg1, arg2, arg3)
});
var $d_sjsr_AnonFunction3 = new $TypeData().initClass({
  sjsr_AnonFunction3: 0
}, false, "scala.scalajs.runtime.AnonFunction3", {
  sjsr_AnonFunction3: 1,
  sr_AbstractFunction3: 1,
  O: 1,
  F3: 1
});
$c_sjsr_AnonFunction3.prototype.$classData = $d_sjsr_AnonFunction3;
/** @constructor */
function $c_sjsr_AnonFunction4(f) {
  this.sjsr_AnonFunction4__f_f = null;
  this.sjsr_AnonFunction4__f_f = f
}
$c_sjsr_AnonFunction4.prototype = new $h_sr_AbstractFunction4();
$c_sjsr_AnonFunction4.prototype.constructor = $c_sjsr_AnonFunction4;
/** @constructor */
function $h_sjsr_AnonFunction4() {
  /*<skip>*/
}
$h_sjsr_AnonFunction4.prototype = $c_sjsr_AnonFunction4.prototype;
$c_sjsr_AnonFunction4.prototype.apply__O__O__O__O__O = (function(arg1, arg2, arg3, arg4) {
  return (0, this.sjsr_AnonFunction4__f_f)(arg1, arg2, arg3, arg4)
});
var $d_sjsr_AnonFunction4 = new $TypeData().initClass({
  sjsr_AnonFunction4: 0
}, false, "scala.scalajs.runtime.AnonFunction4", {
  sjsr_AnonFunction4: 1,
  sr_AbstractFunction4: 1,
  O: 1,
  F4: 1
});
$c_sjsr_AnonFunction4.prototype.$classData = $d_sjsr_AnonFunction4;
/** @constructor */
function $c_sjsr_AnonFunction5(f) {
  this.sjsr_AnonFunction5__f_f = null;
  this.sjsr_AnonFunction5__f_f = f
}
$c_sjsr_AnonFunction5.prototype = new $h_sr_AbstractFunction5();
$c_sjsr_AnonFunction5.prototype.constructor = $c_sjsr_AnonFunction5;
/** @constructor */
function $h_sjsr_AnonFunction5() {
  /*<skip>*/
}
$h_sjsr_AnonFunction5.prototype = $c_sjsr_AnonFunction5.prototype;
$c_sjsr_AnonFunction5.prototype.apply__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5) {
  return (0, this.sjsr_AnonFunction5__f_f)(arg1, arg2, arg3, arg4, arg5)
});
var $d_sjsr_AnonFunction5 = new $TypeData().initClass({
  sjsr_AnonFunction5: 0
}, false, "scala.scalajs.runtime.AnonFunction5", {
  sjsr_AnonFunction5: 1,
  sr_AbstractFunction5: 1,
  O: 1,
  F5: 1
});
$c_sjsr_AnonFunction5.prototype.$classData = $d_sjsr_AnonFunction5;
/** @constructor */
function $c_sjsr_AnonFunction6(f) {
  this.sjsr_AnonFunction6__f_f = null;
  this.sjsr_AnonFunction6__f_f = f
}
$c_sjsr_AnonFunction6.prototype = new $h_sr_AbstractFunction6();
$c_sjsr_AnonFunction6.prototype.constructor = $c_sjsr_AnonFunction6;
/** @constructor */
function $h_sjsr_AnonFunction6() {
  /*<skip>*/
}
$h_sjsr_AnonFunction6.prototype = $c_sjsr_AnonFunction6.prototype;
$c_sjsr_AnonFunction6.prototype.apply__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6) {
  return (0, this.sjsr_AnonFunction6__f_f)(arg1, arg2, arg3, arg4, arg5, arg6)
});
var $d_sjsr_AnonFunction6 = new $TypeData().initClass({
  sjsr_AnonFunction6: 0
}, false, "scala.scalajs.runtime.AnonFunction6", {
  sjsr_AnonFunction6: 1,
  sr_AbstractFunction6: 1,
  O: 1,
  F6: 1
});
$c_sjsr_AnonFunction6.prototype.$classData = $d_sjsr_AnonFunction6;
/** @constructor */
function $c_sjsr_AnonFunction7(f) {
  this.sjsr_AnonFunction7__f_f = null;
  this.sjsr_AnonFunction7__f_f = f
}
$c_sjsr_AnonFunction7.prototype = new $h_sr_AbstractFunction7();
$c_sjsr_AnonFunction7.prototype.constructor = $c_sjsr_AnonFunction7;
/** @constructor */
function $h_sjsr_AnonFunction7() {
  /*<skip>*/
}
$h_sjsr_AnonFunction7.prototype = $c_sjsr_AnonFunction7.prototype;
$c_sjsr_AnonFunction7.prototype.apply__O__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
  return (0, this.sjsr_AnonFunction7__f_f)(arg1, arg2, arg3, arg4, arg5, arg6, arg7)
});
var $d_sjsr_AnonFunction7 = new $TypeData().initClass({
  sjsr_AnonFunction7: 0
}, false, "scala.scalajs.runtime.AnonFunction7", {
  sjsr_AnonFunction7: 1,
  sr_AbstractFunction7: 1,
  O: 1,
  F7: 1
});
$c_sjsr_AnonFunction7.prototype.$classData = $d_sjsr_AnonFunction7;
/** @constructor */
function $c_sjsr_AnonFunction8(f) {
  this.sjsr_AnonFunction8__f_f = null;
  this.sjsr_AnonFunction8__f_f = f
}
$c_sjsr_AnonFunction8.prototype = new $h_sr_AbstractFunction8();
$c_sjsr_AnonFunction8.prototype.constructor = $c_sjsr_AnonFunction8;
/** @constructor */
function $h_sjsr_AnonFunction8() {
  /*<skip>*/
}
$h_sjsr_AnonFunction8.prototype = $c_sjsr_AnonFunction8.prototype;
$c_sjsr_AnonFunction8.prototype.apply__O__O__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8) {
  return (0, this.sjsr_AnonFunction8__f_f)(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8)
});
var $d_sjsr_AnonFunction8 = new $TypeData().initClass({
  sjsr_AnonFunction8: 0
}, false, "scala.scalajs.runtime.AnonFunction8", {
  sjsr_AnonFunction8: 1,
  sr_AbstractFunction8: 1,
  O: 1,
  F8: 1
});
$c_sjsr_AnonFunction8.prototype.$classData = $d_sjsr_AnonFunction8;
/** @constructor */
function $c_sjsr_AnonFunction9(f) {
  this.sjsr_AnonFunction9__f_f = null;
  this.sjsr_AnonFunction9__f_f = f
}
$c_sjsr_AnonFunction9.prototype = new $h_sr_AbstractFunction9();
$c_sjsr_AnonFunction9.prototype.constructor = $c_sjsr_AnonFunction9;
/** @constructor */
function $h_sjsr_AnonFunction9() {
  /*<skip>*/
}
$h_sjsr_AnonFunction9.prototype = $c_sjsr_AnonFunction9.prototype;
$c_sjsr_AnonFunction9.prototype.apply__O__O__O__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
  return (0, this.sjsr_AnonFunction9__f_f)(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9)
});
var $d_sjsr_AnonFunction9 = new $TypeData().initClass({
  sjsr_AnonFunction9: 0
}, false, "scala.scalajs.runtime.AnonFunction9", {
  sjsr_AnonFunction9: 1,
  sr_AbstractFunction9: 1,
  O: 1,
  F9: 1
});
$c_sjsr_AnonFunction9.prototype.$classData = $d_sjsr_AnonFunction9;
/** @constructor */
function $c_s_util_Random$() {
  this.s_util_Random__f_self = null;
  $ct_s_util_Random__ju_Random__(this, $ct_ju_Random__(new $c_ju_Random()))
}
$c_s_util_Random$.prototype = new $h_s_util_Random();
$c_s_util_Random$.prototype.constructor = $c_s_util_Random$;
/** @constructor */
function $h_s_util_Random$() {
  /*<skip>*/
}
$h_s_util_Random$.prototype = $c_s_util_Random$.prototype;
var $d_s_util_Random$ = new $TypeData().initClass({
  s_util_Random$: 0
}, false, "scala.util.Random$", {
  s_util_Random$: 1,
  s_util_Random: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Random$.prototype.$classData = $d_s_util_Random$;
var $n_s_util_Random$;
function $m_s_util_Random$() {
  if ((!$n_s_util_Random$)) {
    $n_s_util_Random$ = new $c_s_util_Random$()
  };
  return $n_s_util_Random$
}
class $c_s_util_control_ControlThrowable extends $c_jl_Throwable {
}
function $as_s_util_control_ControlThrowable(obj) {
  return (((obj instanceof $c_s_util_control_ControlThrowable) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.control.ControlThrowable"))
}
function $isArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_control_ControlThrowable)))
}
function $asArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (($isArrayOf_s_util_control_ControlThrowable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.control.ControlThrowable;", depth))
}
/** @constructor */
function $c_Lscalacss_ScalaCssReact$() {
  /*<skip>*/
}
$c_Lscalacss_ScalaCssReact$.prototype = new $h_O();
$c_Lscalacss_ScalaCssReact$.prototype.constructor = $c_Lscalacss_ScalaCssReact$;
/** @constructor */
function $h_Lscalacss_ScalaCssReact$() {
  /*<skip>*/
}
$h_Lscalacss_ScalaCssReact$.prototype = $c_Lscalacss_ScalaCssReact$.prototype;
var $d_Lscalacss_ScalaCssReact$ = new $TypeData().initClass({
  Lscalacss_ScalaCssReact$: 0
}, false, "scalacss.ScalaCssReact$", {
  Lscalacss_ScalaCssReact$: 1,
  O: 1,
  Lscalacss_ScalaCssReactImplicits: 1,
  Lscalacss_defaults_PlatformExports: 1
});
$c_Lscalacss_ScalaCssReact$.prototype.$classData = $d_Lscalacss_ScalaCssReact$;
var $n_Lscalacss_ScalaCssReact$;
function $m_Lscalacss_ScalaCssReact$() {
  if ((!$n_Lscalacss_ScalaCssReact$)) {
    $n_Lscalacss_ScalaCssReact$ = new $c_Lscalacss_ScalaCssReact$()
  };
  return $n_Lscalacss_ScalaCssReact$
}
/** @constructor */
function $c_Lscalacss_ScalatagsCss$() {
  /*<skip>*/
}
$c_Lscalacss_ScalatagsCss$.prototype = new $h_O();
$c_Lscalacss_ScalatagsCss$.prototype.constructor = $c_Lscalacss_ScalatagsCss$;
/** @constructor */
function $h_Lscalacss_ScalatagsCss$() {
  /*<skip>*/
}
$h_Lscalacss_ScalatagsCss$.prototype = $c_Lscalacss_ScalatagsCss$.prototype;
var $d_Lscalacss_ScalatagsCss$ = new $TypeData().initClass({
  Lscalacss_ScalatagsCss$: 0
}, false, "scalacss.ScalatagsCss$", {
  Lscalacss_ScalatagsCss$: 1,
  O: 1,
  Lscalacss_ScalatagsTextImplicits: 1,
  Lscalacss_ScalatagsJsDomImplicits: 1
});
$c_Lscalacss_ScalatagsCss$.prototype.$classData = $d_Lscalacss_ScalatagsCss$;
var $n_Lscalacss_ScalatagsCss$;
function $m_Lscalacss_ScalatagsCss$() {
  if ((!$n_Lscalacss_ScalatagsCss$)) {
    $n_Lscalacss_ScalatagsCss$ = new $c_Lscalacss_ScalatagsCss$()
  };
  return $n_Lscalacss_ScalatagsCss$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$BorderRadiusNext(a) {
  this.Lscalacss_internal_Attrs$BorderRadiusNext__f_a = null;
  this.Lscalacss_internal_Attrs$BorderRadiusNext__f_a = a
}
$c_Lscalacss_internal_Attrs$BorderRadiusNext.prototype = new $h_O();
$c_Lscalacss_internal_Attrs$BorderRadiusNext.prototype.constructor = $c_Lscalacss_internal_Attrs$BorderRadiusNext;
/** @constructor */
function $h_Lscalacss_internal_Attrs$BorderRadiusNext() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$BorderRadiusNext.prototype = $c_Lscalacss_internal_Attrs$BorderRadiusNext.prototype;
$c_Lscalacss_internal_Attrs$BorderRadiusNext.prototype.av__Lscalacss_internal_AV = (function() {
  return new $c_Lscalacss_internal_AV($m_Lscalacss_internal_Attrs$borderRadius$().Lscalacss_internal_Attrs$borderRadius$__f_attr, this.Lscalacss_internal_Attrs$BorderRadiusNext__f_a)
});
var $d_Lscalacss_internal_Attrs$BorderRadiusNext = new $TypeData().initClass({
  Lscalacss_internal_Attrs$BorderRadiusNext: 0
}, false, "scalacss.internal.Attrs$BorderRadiusNext", {
  Lscalacss_internal_Attrs$BorderRadiusNext: 1,
  O: 1,
  Lscalacss_internal_Attrs$RorderRadiusOps: 1,
  Lscalacss_internal_ToAV: 1
});
$c_Lscalacss_internal_Attrs$BorderRadiusNext.prototype.$classData = $d_Lscalacss_internal_Attrs$BorderRadiusNext;
/** @constructor */
function $c_Lscalacss_internal_Attrs$animationDelay$() {
  this.Lscalacss_internal_ValueT$TypedAttrTN__f_sep = null;
  this.Lscalacss_internal_Attrs$animationDelay$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttrTN__T__(this, ",");
  $n_Lscalacss_internal_Attrs$animationDelay$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_animation;
  this.Lscalacss_internal_Attrs$animationDelay$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("animation-delay", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$animationDelay$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrTN();
$c_Lscalacss_internal_Attrs$animationDelay$.prototype.constructor = $c_Lscalacss_internal_Attrs$animationDelay$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$animationDelay$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$animationDelay$.prototype = $c_Lscalacss_internal_Attrs$animationDelay$.prototype;
$c_Lscalacss_internal_Attrs$animationDelay$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$animationDelay$__f_attr
});
var $d_Lscalacss_internal_Attrs$animationDelay$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$animationDelay$: 0
}, false, "scalacss.internal.Attrs$animationDelay$", {
  Lscalacss_internal_Attrs$animationDelay$: 1,
  Lscalacss_internal_ValueT$TypedAttrTN: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$animationDelay$.prototype.$classData = $d_Lscalacss_internal_Attrs$animationDelay$;
var $n_Lscalacss_internal_Attrs$animationDelay$;
function $m_Lscalacss_internal_Attrs$animationDelay$() {
  if ((!$n_Lscalacss_internal_Attrs$animationDelay$)) {
    $n_Lscalacss_internal_Attrs$animationDelay$ = new $c_Lscalacss_internal_Attrs$animationDelay$()
  };
  return $n_Lscalacss_internal_Attrs$animationDelay$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$animationDuration$() {
  this.Lscalacss_internal_ValueT$TypedAttrTN__f_sep = null;
  this.Lscalacss_internal_Attrs$animationDuration$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttrTN__T__(this, ",");
  $n_Lscalacss_internal_Attrs$animationDuration$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_animation;
  this.Lscalacss_internal_Attrs$animationDuration$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("animation-duration", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$animationDuration$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrTN();
$c_Lscalacss_internal_Attrs$animationDuration$.prototype.constructor = $c_Lscalacss_internal_Attrs$animationDuration$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$animationDuration$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$animationDuration$.prototype = $c_Lscalacss_internal_Attrs$animationDuration$.prototype;
$c_Lscalacss_internal_Attrs$animationDuration$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$animationDuration$__f_attr
});
var $d_Lscalacss_internal_Attrs$animationDuration$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$animationDuration$: 0
}, false, "scalacss.internal.Attrs$animationDuration$", {
  Lscalacss_internal_Attrs$animationDuration$: 1,
  Lscalacss_internal_ValueT$TypedAttrTN: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$animationDuration$.prototype.$classData = $d_Lscalacss_internal_Attrs$animationDuration$;
var $n_Lscalacss_internal_Attrs$animationDuration$;
function $m_Lscalacss_internal_Attrs$animationDuration$() {
  if ((!$n_Lscalacss_internal_Attrs$animationDuration$)) {
    $n_Lscalacss_internal_Attrs$animationDuration$ = new $c_Lscalacss_internal_Attrs$animationDuration$()
  };
  return $n_Lscalacss_internal_Attrs$animationDuration$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$backgroundClip$() {
  this.Lscalacss_internal_Attrs$backgroundClip$__f_attr = null;
  $n_Lscalacss_internal_Attrs$backgroundClip$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().backgroundImgOpts__sci_Map();
  this.Lscalacss_internal_Attrs$backgroundClip$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("background-clip", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$backgroundClip$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$backgroundClip$.prototype.constructor = $c_Lscalacss_internal_Attrs$backgroundClip$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$backgroundClip$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$backgroundClip$.prototype = $c_Lscalacss_internal_Attrs$backgroundClip$.prototype;
$c_Lscalacss_internal_Attrs$backgroundClip$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$backgroundClip$__f_attr
});
var $d_Lscalacss_internal_Attrs$backgroundClip$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$backgroundClip$: 0
}, false, "scalacss.internal.Attrs$backgroundClip$", {
  Lscalacss_internal_Attrs$backgroundClip$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_Attrs$BackgroundClipDecorationOps: 1
});
$c_Lscalacss_internal_Attrs$backgroundClip$.prototype.$classData = $d_Lscalacss_internal_Attrs$backgroundClip$;
var $n_Lscalacss_internal_Attrs$backgroundClip$;
function $m_Lscalacss_internal_Attrs$backgroundClip$() {
  if ((!$n_Lscalacss_internal_Attrs$backgroundClip$)) {
    $n_Lscalacss_internal_Attrs$backgroundClip$ = new $c_Lscalacss_internal_Attrs$backgroundClip$()
  };
  return $n_Lscalacss_internal_Attrs$backgroundClip$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$columnCount$() {
  this.Lscalacss_internal_Attrs$columnCount$__f_attr = null;
  $n_Lscalacss_internal_Attrs$columnCount$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_multicolumn;
  this.Lscalacss_internal_Attrs$columnCount$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("column-count", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$columnCount$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$columnCount$.prototype.constructor = $c_Lscalacss_internal_Attrs$columnCount$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$columnCount$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$columnCount$.prototype = $c_Lscalacss_internal_Attrs$columnCount$.prototype;
$c_Lscalacss_internal_Attrs$columnCount$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$columnCount$__f_attr
});
var $d_Lscalacss_internal_Attrs$columnCount$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$columnCount$: 0
}, false, "scalacss.internal.Attrs$columnCount$", {
  Lscalacss_internal_Attrs$columnCount$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$columnCount$.prototype.$classData = $d_Lscalacss_internal_Attrs$columnCount$;
var $n_Lscalacss_internal_Attrs$columnCount$;
function $m_Lscalacss_internal_Attrs$columnCount$() {
  if ((!$n_Lscalacss_internal_Attrs$columnCount$)) {
    $n_Lscalacss_internal_Attrs$columnCount$ = new $c_Lscalacss_internal_Attrs$columnCount$()
  };
  return $n_Lscalacss_internal_Attrs$columnCount$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$flexGrow$() {
  this.Lscalacss_internal_Attrs$flexGrow$__f_attr = null;
  $n_Lscalacss_internal_Attrs$flexGrow$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  this.Lscalacss_internal_Attrs$flexGrow$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("flex-grow", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$flexGrow$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$flexGrow$.prototype.constructor = $c_Lscalacss_internal_Attrs$flexGrow$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$flexGrow$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$flexGrow$.prototype = $c_Lscalacss_internal_Attrs$flexGrow$.prototype;
$c_Lscalacss_internal_Attrs$flexGrow$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$flexGrow$__f_attr
});
var $d_Lscalacss_internal_Attrs$flexGrow$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$flexGrow$: 0
}, false, "scalacss.internal.Attrs$flexGrow$", {
  Lscalacss_internal_Attrs$flexGrow$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$flexGrow$.prototype.$classData = $d_Lscalacss_internal_Attrs$flexGrow$;
var $n_Lscalacss_internal_Attrs$flexGrow$;
function $m_Lscalacss_internal_Attrs$flexGrow$() {
  if ((!$n_Lscalacss_internal_Attrs$flexGrow$)) {
    $n_Lscalacss_internal_Attrs$flexGrow$ = new $c_Lscalacss_internal_Attrs$flexGrow$()
  };
  return $n_Lscalacss_internal_Attrs$flexGrow$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$flexShrink$() {
  this.Lscalacss_internal_Attrs$flexShrink$__f_attr = null;
  $n_Lscalacss_internal_Attrs$flexShrink$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_flexbox;
  this.Lscalacss_internal_Attrs$flexShrink$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("flex-shrink", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$flexShrink$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$flexShrink$.prototype.constructor = $c_Lscalacss_internal_Attrs$flexShrink$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$flexShrink$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$flexShrink$.prototype = $c_Lscalacss_internal_Attrs$flexShrink$.prototype;
$c_Lscalacss_internal_Attrs$flexShrink$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$flexShrink$__f_attr
});
var $d_Lscalacss_internal_Attrs$flexShrink$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$flexShrink$: 0
}, false, "scalacss.internal.Attrs$flexShrink$", {
  Lscalacss_internal_Attrs$flexShrink$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$flexShrink$.prototype.$classData = $d_Lscalacss_internal_Attrs$flexShrink$;
var $n_Lscalacss_internal_Attrs$flexShrink$;
function $m_Lscalacss_internal_Attrs$flexShrink$() {
  if ((!$n_Lscalacss_internal_Attrs$flexShrink$)) {
    $n_Lscalacss_internal_Attrs$flexShrink$ = new $c_Lscalacss_internal_Attrs$flexShrink$()
  };
  return $n_Lscalacss_internal_Attrs$flexShrink$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$opacity$() {
  this.Lscalacss_internal_Attrs$opacity$__f_attr = null;
  $n_Lscalacss_internal_Attrs$opacity$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().opacity__sci_Map();
  this.Lscalacss_internal_Attrs$opacity$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("opacity", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$opacity$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$opacity$.prototype.constructor = $c_Lscalacss_internal_Attrs$opacity$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$opacity$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$opacity$.prototype = $c_Lscalacss_internal_Attrs$opacity$.prototype;
$c_Lscalacss_internal_Attrs$opacity$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$opacity$__f_attr
});
var $d_Lscalacss_internal_Attrs$opacity$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$opacity$: 0
}, false, "scalacss.internal.Attrs$opacity$", {
  Lscalacss_internal_Attrs$opacity$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$opacity$.prototype.$classData = $d_Lscalacss_internal_Attrs$opacity$;
var $n_Lscalacss_internal_Attrs$opacity$;
function $m_Lscalacss_internal_Attrs$opacity$() {
  if ((!$n_Lscalacss_internal_Attrs$opacity$)) {
    $n_Lscalacss_internal_Attrs$opacity$ = new $c_Lscalacss_internal_Attrs$opacity$()
  };
  return $n_Lscalacss_internal_Attrs$opacity$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$textDecorationLine$() {
  this.Lscalacss_internal_Attrs$textDecorationLine$__f_attr = null;
  $n_Lscalacss_internal_Attrs$textDecorationLine$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_textDecoration;
  this.Lscalacss_internal_Attrs$textDecorationLine$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("text-decoration-line", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$textDecorationLine$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$textDecorationLine$.prototype.constructor = $c_Lscalacss_internal_Attrs$textDecorationLine$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$textDecorationLine$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$textDecorationLine$.prototype = $c_Lscalacss_internal_Attrs$textDecorationLine$.prototype;
$c_Lscalacss_internal_Attrs$textDecorationLine$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$textDecorationLine$__f_attr
});
var $d_Lscalacss_internal_Attrs$textDecorationLine$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$textDecorationLine$: 0
}, false, "scalacss.internal.Attrs$textDecorationLine$", {
  Lscalacss_internal_Attrs$textDecorationLine$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_Attrs$TextDecorationLineOps: 1
});
$c_Lscalacss_internal_Attrs$textDecorationLine$.prototype.$classData = $d_Lscalacss_internal_Attrs$textDecorationLine$;
var $n_Lscalacss_internal_Attrs$textDecorationLine$;
function $m_Lscalacss_internal_Attrs$textDecorationLine$() {
  if ((!$n_Lscalacss_internal_Attrs$textDecorationLine$)) {
    $n_Lscalacss_internal_Attrs$textDecorationLine$ = new $c_Lscalacss_internal_Attrs$textDecorationLine$()
  };
  return $n_Lscalacss_internal_Attrs$textDecorationLine$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$transitionDelay$() {
  this.Lscalacss_internal_ValueT$TypedAttrTN__f_sep = null;
  this.Lscalacss_internal_Attrs$transitionDelay$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttrTN__T__(this, ",");
  $n_Lscalacss_internal_Attrs$transitionDelay$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_transitions;
  this.Lscalacss_internal_Attrs$transitionDelay$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("transition-delay", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$transitionDelay$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrTN();
$c_Lscalacss_internal_Attrs$transitionDelay$.prototype.constructor = $c_Lscalacss_internal_Attrs$transitionDelay$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$transitionDelay$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$transitionDelay$.prototype = $c_Lscalacss_internal_Attrs$transitionDelay$.prototype;
$c_Lscalacss_internal_Attrs$transitionDelay$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$transitionDelay$__f_attr
});
var $d_Lscalacss_internal_Attrs$transitionDelay$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$transitionDelay$: 0
}, false, "scalacss.internal.Attrs$transitionDelay$", {
  Lscalacss_internal_Attrs$transitionDelay$: 1,
  Lscalacss_internal_ValueT$TypedAttrTN: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$transitionDelay$.prototype.$classData = $d_Lscalacss_internal_Attrs$transitionDelay$;
var $n_Lscalacss_internal_Attrs$transitionDelay$;
function $m_Lscalacss_internal_Attrs$transitionDelay$() {
  if ((!$n_Lscalacss_internal_Attrs$transitionDelay$)) {
    $n_Lscalacss_internal_Attrs$transitionDelay$ = new $c_Lscalacss_internal_Attrs$transitionDelay$()
  };
  return $n_Lscalacss_internal_Attrs$transitionDelay$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$transitionDuration$() {
  this.Lscalacss_internal_ValueT$TypedAttrTN__f_sep = null;
  this.Lscalacss_internal_Attrs$transitionDuration$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttrTN__T__(this, ",");
  $n_Lscalacss_internal_Attrs$transitionDuration$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_transitions;
  this.Lscalacss_internal_Attrs$transitionDuration$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("transition-duration", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$transitionDuration$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrTN();
$c_Lscalacss_internal_Attrs$transitionDuration$.prototype.constructor = $c_Lscalacss_internal_Attrs$transitionDuration$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$transitionDuration$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$transitionDuration$.prototype = $c_Lscalacss_internal_Attrs$transitionDuration$.prototype;
$c_Lscalacss_internal_Attrs$transitionDuration$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$transitionDuration$__f_attr
});
var $d_Lscalacss_internal_Attrs$transitionDuration$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$transitionDuration$: 0
}, false, "scalacss.internal.Attrs$transitionDuration$", {
  Lscalacss_internal_Attrs$transitionDuration$: 1,
  Lscalacss_internal_ValueT$TypedAttrTN: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$transitionDuration$.prototype.$classData = $d_Lscalacss_internal_Attrs$transitionDuration$;
var $n_Lscalacss_internal_Attrs$transitionDuration$;
function $m_Lscalacss_internal_Attrs$transitionDuration$() {
  if ((!$n_Lscalacss_internal_Attrs$transitionDuration$)) {
    $n_Lscalacss_internal_Attrs$transitionDuration$ = new $c_Lscalacss_internal_Attrs$transitionDuration$()
  };
  return $n_Lscalacss_internal_Attrs$transitionDuration$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$zIndex$() {
  this.Lscalacss_internal_Attrs$zIndex$__f_attr = null;
  $n_Lscalacss_internal_Attrs$zIndex$ = this;
  this.Lscalacss_internal_Attrs$zIndex$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("z-index")
}
$c_Lscalacss_internal_Attrs$zIndex$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$zIndex$.prototype.constructor = $c_Lscalacss_internal_Attrs$zIndex$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$zIndex$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$zIndex$.prototype = $c_Lscalacss_internal_Attrs$zIndex$.prototype;
$c_Lscalacss_internal_Attrs$zIndex$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$zIndex$__f_attr
});
var $d_Lscalacss_internal_Attrs$zIndex$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$zIndex$: 0
}, false, "scalacss.internal.Attrs$zIndex$", {
  Lscalacss_internal_Attrs$zIndex$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1
});
$c_Lscalacss_internal_Attrs$zIndex$.prototype.$classData = $d_Lscalacss_internal_Attrs$zIndex$;
var $n_Lscalacss_internal_Attrs$zIndex$;
function $m_Lscalacss_internal_Attrs$zIndex$() {
  if ((!$n_Lscalacss_internal_Attrs$zIndex$)) {
    $n_Lscalacss_internal_Attrs$zIndex$ = new $c_Lscalacss_internal_Attrs$zIndex$()
  };
  return $n_Lscalacss_internal_Attrs$zIndex$
}
/** @constructor */
function $c_Lscalacss_internal_DslBase$MediaQueryEmpty$() {
  /*<skip>*/
}
$c_Lscalacss_internal_DslBase$MediaQueryEmpty$.prototype = new $h_O();
$c_Lscalacss_internal_DslBase$MediaQueryEmpty$.prototype.constructor = $c_Lscalacss_internal_DslBase$MediaQueryEmpty$;
/** @constructor */
function $h_Lscalacss_internal_DslBase$MediaQueryEmpty$() {
  /*<skip>*/
}
$h_Lscalacss_internal_DslBase$MediaQueryEmpty$.prototype = $c_Lscalacss_internal_DslBase$MediaQueryEmpty$.prototype;
$c_Lscalacss_internal_DslBase$MediaQueryEmpty$.prototype.F__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_Lscalacss_internal_Media$Feature(f$2);
    return new $c_Lscalacss_internal_Media$Query(($n($m_s_package$().s_package$__f_Right), new $c_s_util_Right(f)), ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()))
  }))
});
$c_Lscalacss_internal_DslBase$MediaQueryEmpty$.prototype.T__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((t$2) => {
    var t = $as_Lscalacss_internal_Media$TypeA(t$2);
    $n($m_s_package$().s_package$__f_Left);
    var value = new $c_Lscalacss_internal_Media$Just(t);
    return new $c_Lscalacss_internal_Media$Query(new $c_s_util_Left(value), ($n($m_s_package$().s_package$__f_Vector), $m_sci_Vector0$()))
  }))
});
var $d_Lscalacss_internal_DslBase$MediaQueryEmpty$ = new $TypeData().initClass({
  Lscalacss_internal_DslBase$MediaQueryEmpty$: 0
}, false, "scalacss.internal.DslBase$MediaQueryEmpty$", {
  Lscalacss_internal_DslBase$MediaQueryEmpty$: 1,
  O: 1,
  Lscalacss_internal_Media$TypeAOps: 1,
  Lscalacss_internal_Media$FeatureOps: 1
});
$c_Lscalacss_internal_DslBase$MediaQueryEmpty$.prototype.$classData = $d_Lscalacss_internal_DslBase$MediaQueryEmpty$;
var $n_Lscalacss_internal_DslBase$MediaQueryEmpty$;
function $m_Lscalacss_internal_DslBase$MediaQueryEmpty$() {
  if ((!$n_Lscalacss_internal_DslBase$MediaQueryEmpty$)) {
    $n_Lscalacss_internal_DslBase$MediaQueryEmpty$ = new $c_Lscalacss_internal_DslBase$MediaQueryEmpty$()
  };
  return $n_Lscalacss_internal_DslBase$MediaQueryEmpty$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$auto$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "auto")
}
$c_Lscalacss_internal_Literal$Typed$auto$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$auto$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$auto$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$auto$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$auto$.prototype = $c_Lscalacss_internal_Literal$Typed$auto$.prototype;
var $d_Lscalacss_internal_Literal$Typed$auto$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$auto$: 0
}, false, "scalacss.internal.Literal$Typed$auto$", {
  Lscalacss_internal_Literal$Typed$auto$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$OverflowBehaviour: 1
});
$c_Lscalacss_internal_Literal$Typed$auto$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$auto$;
var $n_Lscalacss_internal_Literal$Typed$auto$;
function $m_Lscalacss_internal_Literal$Typed$auto$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$auto$)) {
    $n_Lscalacss_internal_Literal$Typed$auto$ = new $c_Lscalacss_internal_Literal$Typed$auto$()
  };
  return $n_Lscalacss_internal_Literal$Typed$auto$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$dashed$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "dashed")
}
$c_Lscalacss_internal_Literal$Typed$dashed$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$dashed$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$dashed$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$dashed$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$dashed$.prototype = $c_Lscalacss_internal_Literal$Typed$dashed$.prototype;
var $d_Lscalacss_internal_Literal$Typed$dashed$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$dashed$: 0
}, false, "scalacss.internal.Literal$Typed$dashed$", {
  Lscalacss_internal_Literal$Typed$dashed$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$BrStyle: 1
});
$c_Lscalacss_internal_Literal$Typed$dashed$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$dashed$;
var $n_Lscalacss_internal_Literal$Typed$dashed$;
function $m_Lscalacss_internal_Literal$Typed$dashed$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$dashed$)) {
    $n_Lscalacss_internal_Literal$Typed$dashed$ = new $c_Lscalacss_internal_Literal$Typed$dashed$()
  };
  return $n_Lscalacss_internal_Literal$Typed$dashed$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$dotted$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "dotted")
}
$c_Lscalacss_internal_Literal$Typed$dotted$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$dotted$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$dotted$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$dotted$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$dotted$.prototype = $c_Lscalacss_internal_Literal$Typed$dotted$.prototype;
var $d_Lscalacss_internal_Literal$Typed$dotted$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$dotted$: 0
}, false, "scalacss.internal.Literal$Typed$dotted$", {
  Lscalacss_internal_Literal$Typed$dotted$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$BrStyle: 1
});
$c_Lscalacss_internal_Literal$Typed$dotted$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$dotted$;
var $n_Lscalacss_internal_Literal$Typed$dotted$;
function $m_Lscalacss_internal_Literal$Typed$dotted$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$dotted$)) {
    $n_Lscalacss_internal_Literal$Typed$dotted$ = new $c_Lscalacss_internal_Literal$Typed$dotted$()
  };
  return $n_Lscalacss_internal_Literal$Typed$dotted$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$easeOut$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "ease-out")
}
$c_Lscalacss_internal_Literal$Typed$easeOut$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$easeOut$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$easeOut$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$easeOut$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$easeOut$.prototype = $c_Lscalacss_internal_Literal$Typed$easeOut$.prototype;
var $d_Lscalacss_internal_Literal$Typed$easeOut$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$easeOut$: 0
}, false, "scalacss.internal.Literal$Typed$easeOut$", {
  Lscalacss_internal_Literal$Typed$easeOut$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$TimingFunction: 1
});
$c_Lscalacss_internal_Literal$Typed$easeOut$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$easeOut$;
var $n_Lscalacss_internal_Literal$Typed$easeOut$;
function $m_Lscalacss_internal_Literal$Typed$easeOut$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$easeOut$)) {
    $n_Lscalacss_internal_Literal$Typed$easeOut$ = new $c_Lscalacss_internal_Literal$Typed$easeOut$()
  };
  return $n_Lscalacss_internal_Literal$Typed$easeOut$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$end$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "end")
}
$c_Lscalacss_internal_Literal$Typed$end$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$end$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$end$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$end$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$end$.prototype = $c_Lscalacss_internal_Literal$Typed$end$.prototype;
var $d_Lscalacss_internal_Literal$Typed$end$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$end$: 0
}, false, "scalacss.internal.Literal$Typed$end$", {
  Lscalacss_internal_Literal$Typed$end$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$TimingFunctionDirection: 1
});
$c_Lscalacss_internal_Literal$Typed$end$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$end$;
var $n_Lscalacss_internal_Literal$Typed$end$;
function $m_Lscalacss_internal_Literal$Typed$end$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$end$)) {
    $n_Lscalacss_internal_Literal$Typed$end$ = new $c_Lscalacss_internal_Literal$Typed$end$()
  };
  return $n_Lscalacss_internal_Literal$Typed$end$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$hidden$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "hidden")
}
$c_Lscalacss_internal_Literal$Typed$hidden$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$hidden$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$hidden$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$hidden$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$hidden$.prototype = $c_Lscalacss_internal_Literal$Typed$hidden$.prototype;
var $d_Lscalacss_internal_Literal$Typed$hidden$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$hidden$: 0
}, false, "scalacss.internal.Literal$Typed$hidden$", {
  Lscalacss_internal_Literal$Typed$hidden$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$BrStyle: 1
});
$c_Lscalacss_internal_Literal$Typed$hidden$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$hidden$;
var $n_Lscalacss_internal_Literal$Typed$hidden$;
function $m_Lscalacss_internal_Literal$Typed$hidden$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$hidden$)) {
    $n_Lscalacss_internal_Literal$Typed$hidden$ = new $c_Lscalacss_internal_Literal$Typed$hidden$()
  };
  return $n_Lscalacss_internal_Literal$Typed$hidden$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$inherit$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "inherit")
}
$c_Lscalacss_internal_Literal$Typed$inherit$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$inherit$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$inherit$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$inherit$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$inherit$.prototype = $c_Lscalacss_internal_Literal$Typed$inherit$.prototype;
var $d_Lscalacss_internal_Literal$Typed$inherit$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$inherit$: 0
}, false, "scalacss.internal.Literal$Typed$inherit$", {
  Lscalacss_internal_Literal$Typed$inherit$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$Anywhere: 1
});
$c_Lscalacss_internal_Literal$Typed$inherit$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$inherit$;
var $n_Lscalacss_internal_Literal$Typed$inherit$;
function $m_Lscalacss_internal_Literal$Typed$inherit$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$inherit$)) {
    $n_Lscalacss_internal_Literal$Typed$inherit$ = new $c_Lscalacss_internal_Literal$Typed$inherit$()
  };
  return $n_Lscalacss_internal_Literal$Typed$inherit$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$initial$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "initial")
}
$c_Lscalacss_internal_Literal$Typed$initial$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$initial$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$initial$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$initial$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$initial$.prototype = $c_Lscalacss_internal_Literal$Typed$initial$.prototype;
var $d_Lscalacss_internal_Literal$Typed$initial$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$initial$: 0
}, false, "scalacss.internal.Literal$Typed$initial$", {
  Lscalacss_internal_Literal$Typed$initial$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$Anywhere: 1
});
$c_Lscalacss_internal_Literal$Typed$initial$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$initial$;
var $n_Lscalacss_internal_Literal$Typed$initial$;
function $m_Lscalacss_internal_Literal$Typed$initial$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$initial$)) {
    $n_Lscalacss_internal_Literal$Typed$initial$ = new $c_Lscalacss_internal_Literal$Typed$initial$()
  };
  return $n_Lscalacss_internal_Literal$Typed$initial$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$noRepeat$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "no-repeat")
}
$c_Lscalacss_internal_Literal$Typed$noRepeat$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$noRepeat$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$noRepeat$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$noRepeat$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$noRepeat$.prototype = $c_Lscalacss_internal_Literal$Typed$noRepeat$.prototype;
var $d_Lscalacss_internal_Literal$Typed$noRepeat$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$noRepeat$: 0
}, false, "scalacss.internal.Literal$Typed$noRepeat$", {
  Lscalacss_internal_Literal$Typed$noRepeat$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$RepeatStyle: 1
});
$c_Lscalacss_internal_Literal$Typed$noRepeat$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$noRepeat$;
var $n_Lscalacss_internal_Literal$Typed$noRepeat$;
function $m_Lscalacss_internal_Literal$Typed$noRepeat$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$noRepeat$)) {
    $n_Lscalacss_internal_Literal$Typed$noRepeat$ = new $c_Lscalacss_internal_Literal$Typed$noRepeat$()
  };
  return $n_Lscalacss_internal_Literal$Typed$noRepeat$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$solid$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "solid")
}
$c_Lscalacss_internal_Literal$Typed$solid$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$solid$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$solid$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$solid$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$solid$.prototype = $c_Lscalacss_internal_Literal$Typed$solid$.prototype;
var $d_Lscalacss_internal_Literal$Typed$solid$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$solid$: 0
}, false, "scalacss.internal.Literal$Typed$solid$", {
  Lscalacss_internal_Literal$Typed$solid$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$BrStyle: 1
});
$c_Lscalacss_internal_Literal$Typed$solid$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$solid$;
var $n_Lscalacss_internal_Literal$Typed$solid$;
function $m_Lscalacss_internal_Literal$Typed$solid$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$solid$)) {
    $n_Lscalacss_internal_Literal$Typed$solid$ = new $c_Lscalacss_internal_Literal$Typed$solid$()
  };
  return $n_Lscalacss_internal_Literal$Typed$solid$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$start$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "start")
}
$c_Lscalacss_internal_Literal$Typed$start$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$start$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$start$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$start$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$start$.prototype = $c_Lscalacss_internal_Literal$Typed$start$.prototype;
var $d_Lscalacss_internal_Literal$Typed$start$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$start$: 0
}, false, "scalacss.internal.Literal$Typed$start$", {
  Lscalacss_internal_Literal$Typed$start$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$TimingFunctionDirection: 1
});
$c_Lscalacss_internal_Literal$Typed$start$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$start$;
var $n_Lscalacss_internal_Literal$Typed$start$;
function $m_Lscalacss_internal_Literal$Typed$start$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$start$)) {
    $n_Lscalacss_internal_Literal$Typed$start$ = new $c_Lscalacss_internal_Literal$Typed$start$()
  };
  return $n_Lscalacss_internal_Literal$Typed$start$
}
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$unset$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "unset")
}
$c_Lscalacss_internal_Literal$Typed$unset$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$unset$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$unset$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$unset$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$unset$.prototype = $c_Lscalacss_internal_Literal$Typed$unset$.prototype;
var $d_Lscalacss_internal_Literal$Typed$unset$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$unset$: 0
}, false, "scalacss.internal.Literal$Typed$unset$", {
  Lscalacss_internal_Literal$Typed$unset$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$Anywhere: 1
});
$c_Lscalacss_internal_Literal$Typed$unset$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$unset$;
var $n_Lscalacss_internal_Literal$Typed$unset$;
function $m_Lscalacss_internal_Literal$Typed$unset$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$unset$)) {
    $n_Lscalacss_internal_Literal$Typed$unset$ = new $c_Lscalacss_internal_Literal$Typed$unset$()
  };
  return $n_Lscalacss_internal_Literal$Typed$unset$
}
function $ct_Lscalacss_internal_Pseudo$Single__T__Lscalacss_internal_PseudoType__($thiz, cssValue, pseudoType) {
  $thiz.Lscalacss_internal_Pseudo$Single__f_cssValue = cssValue;
  $thiz.Lscalacss_internal_Pseudo$Single__f_pseudoType = pseudoType;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_Pseudo$Single() {
  this.Lscalacss_internal_Pseudo$Single__f_cssValue = null;
  this.Lscalacss_internal_Pseudo$Single__f_pseudoType = null
}
$c_Lscalacss_internal_Pseudo$Single.prototype = new $h_Lscalacss_internal_Pseudo();
$c_Lscalacss_internal_Pseudo$Single.prototype.constructor = $c_Lscalacss_internal_Pseudo$Single;
/** @constructor */
function $h_Lscalacss_internal_Pseudo$Single() {
  /*<skip>*/
}
$h_Lscalacss_internal_Pseudo$Single.prototype = $c_Lscalacss_internal_Pseudo$Single.prototype;
$c_Lscalacss_internal_Pseudo$Single.prototype.cssValue__T = (function() {
  return this.Lscalacss_internal_Pseudo$Single__f_cssValue
});
$c_Lscalacss_internal_Pseudo$Single.prototype.contains__Lscalacss_internal_Pseudo$Single__Z = (function(p) {
  return (this === p)
});
function $as_Lscalacss_internal_Pseudo$Single(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Pseudo$Single) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Pseudo$Single"))
}
function $isArrayOf_Lscalacss_internal_Pseudo$Single(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Pseudo$Single)))
}
function $asArrayOf_Lscalacss_internal_Pseudo$Single(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Pseudo$Single(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Pseudo$Single;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_StyleF(f, domain) {
  this.Lscalacss_internal_StyleF__f_f = null;
  this.Lscalacss_internal_StyleF__f_domain = null;
  this.Lscalacss_internal_StyleF__f_f = f;
  this.Lscalacss_internal_StyleF__f_domain = domain
}
$c_Lscalacss_internal_StyleF.prototype = new $h_Lscalacss_internal_Style1();
$c_Lscalacss_internal_StyleF.prototype.constructor = $c_Lscalacss_internal_StyleF;
/** @constructor */
function $h_Lscalacss_internal_StyleF() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleF.prototype = $c_Lscalacss_internal_StyleF.prototype;
function $as_Lscalacss_internal_StyleF(obj) {
  return (((obj instanceof $c_Lscalacss_internal_StyleF) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.StyleF"))
}
function $isArrayOf_Lscalacss_internal_StyleF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_StyleF)))
}
function $asArrayOf_Lscalacss_internal_StyleF(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_StyleF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.StyleF;", depth))
}
var $d_Lscalacss_internal_StyleF = new $TypeData().initClass({
  Lscalacss_internal_StyleF: 0
}, false, "scalacss.internal.StyleF", {
  Lscalacss_internal_StyleF: 1,
  Lscalacss_internal_Style1: 1,
  O: 1,
  Lscalacss_internal_Style: 1
});
$c_Lscalacss_internal_StyleF.prototype.$classData = $d_Lscalacss_internal_StyleF;
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle.prototype = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle.prototype;
function $ct_Lscalacss_internal_mutable_StyleSheet$Inline__Lscalacss_internal_mutable_Register__($thiz, cssRegister) {
  $thiz.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister = cssRegister;
  $ct_Lscalacss_internal_mutable_StyleSheet$Base__($thiz);
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_mutable_StyleSheet$Inline() {
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module = null;
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister = null
}
$c_Lscalacss_internal_mutable_StyleSheet$Inline.prototype = new $h_Lscalacss_internal_mutable_StyleSheet$Base();
$c_Lscalacss_internal_mutable_StyleSheet$Inline.prototype.constructor = $c_Lscalacss_internal_mutable_StyleSheet$Inline;
/** @constructor */
function $h_Lscalacss_internal_mutable_StyleSheet$Inline() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_StyleSheet$Inline.prototype = $c_Lscalacss_internal_mutable_StyleSheet$Inline.prototype;
/** @constructor */
function $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF(outer, name) {
  this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF__f_name = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF__f_$outer = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF__f_name = name;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF__f_$outer = outer
  }
}
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF.prototype = new $h_O();
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF.prototype.constructor = $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF;
/** @constructor */
function $h_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF.prototype = $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF.prototype;
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF.prototype.create__s_Option__Lscalacss_internal_Domain__F1__F2__Lscalacss_internal_StyleLookup__F1 = (function(manualName, d, f, classNameSuffix, evidence$1) {
  var x = $m_s_None$();
  if ((x === manualName)) {
    return $n($n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF__f_$outer).Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister).registerFM__Lscalacss_internal_StyleF__T__F2__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleLookup__F1($as_Lscalacss_internal_StyleF($n($as_F1($m_Lscalacss_internal_StyleF$().apply__F1__Lscalacss_internal_StyleF$P(f))).apply__O__O(d)), this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF__f_name, classNameSuffix, $n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF__f_$outer).Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint, evidence$1)
  } else if ((manualName instanceof $c_s_Some)) {
    var x3 = $as_s_Some(manualName);
    var n = $as_T($n(x3).s_Some__f_value);
    return $n($n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF__f_$outer).Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister).registerF2__Lscalacss_internal_StyleF__T__F2__Lscalacss_internal_ClassNameHint__Lscalacss_internal_StyleLookup__F1($as_Lscalacss_internal_StyleF($n($as_F1($m_Lscalacss_internal_StyleF$().apply__F1__Lscalacss_internal_StyleF$P(f))).apply__O__O(d)), n, classNameSuffix, $n(this.Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF__f_$outer).Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint, evidence$1)
  } else {
    throw new $c_s_MatchError(manualName)
  }
});
var $d_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF = new $TypeData().initClass({
  Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF: 0
}, false, "scalacss.internal.mutable.StyleSheet$Inline$MStyleF", {
  Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF: 1,
  O: 1,
  Lscalacss_internal_DslMacros$MStyleF: 1,
  Lscalacss_internal_DslMacros$MStyleF2: 1
});
$c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF.prototype.$classData = $d_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF;
function $f_Lscalatags_JsDom$Aggregate__$init$__V($thiz) {
  /*<skip>*/
}
function $f_Lscalatags_generic_MouseEventAttrs__$init$__V($thiz) {
  $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($thiz, "ondrag", null, false)
}
function $f_Lscalatags_generic_TypedTag__build__O__V($thiz, b) {
  var current = $thiz.Lscalatags_JsDom$TypedTag__f_modifiers;
  var arr = new ($d_sci_Seq.getArrayOf().constr)($n($thiz.Lscalatags_JsDom$TypedTag__f_modifiers).length__I());
  var i = 0;
  while (true) {
    var x = current;
    var x$2 = $m_s_package$().s_package$__f_Nil;
    if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
      $n(arr).set(i, $as_sci_Seq($n(current).head__O()));
      current = $as_sci_List($n(current).tail__O());
      i = ((1 + i) | 0)
    } else {
      break
    }
  };
  var j = $n(arr).u.length;
  while ((j > 0)) {
    j = (((-1) + j) | 0);
    var frag = $n(arr).get(j);
    var i$2 = 0;
    while ((i$2 < $n(frag).length__I())) {
      $n($as_Lscalatags_generic_Modifier($n(frag).apply__I__O(i$2))).applyTo__O__V(b);
      i$2 = ((1 + i$2) | 0)
    }
  }
}
function $f_Lscalatags_jsdom_Frag__applyTo__Lorg_scalajs_dom_Element__V($thiz, b) {
  b.appendChild($thiz.render__Lorg_scalajs_dom_Node())
}
function $f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag($thiz, s, void$1, ns) {
  if ((!$m_Lscalatags_Escaping$().validTag__T__Z(s))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("Illegal tag name: " + s) + " is not a valid XML tag name"))
  };
  return new $c_Lscalatags_JsDom$TypedTag(s, $m_s_package$().s_package$__f_Nil, void$1, ns)
}
/** @constructor */
function $c_Lshapeless_Coproduct$() {
  /*<skip>*/
}
$c_Lshapeless_Coproduct$.prototype = new $h_O();
$c_Lshapeless_Coproduct$.prototype.constructor = $c_Lshapeless_Coproduct$;
/** @constructor */
function $h_Lshapeless_Coproduct$() {
  /*<skip>*/
}
$h_Lshapeless_Coproduct$.prototype = $c_Lshapeless_Coproduct$.prototype;
$c_Lshapeless_Coproduct$.prototype.unsafeMkCoproduct__I__O__Lshapeless_Coproduct = (function(length, value) {
  var isEmpty = (length <= 0);
  if (isEmpty) {
    var scala$collection$immutable$Range$$numRangeElements = 0
  } else {
    var hi = (length >> 31);
    var scala$collection$immutable$Range$$numRangeElements = (((hi === 0) ? (((-2147483648) ^ length) > (-1)) : (hi > 0)) ? (-1) : length)
  };
  var z = new $c_Lshapeless_Inl(value);
  var at = 0;
  if ((scala$collection$immutable$Range$$numRangeElements < 0)) {
    $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, length, 1, false)
  };
  var acc = z;
  var $$x1;
  while (true) {
    if ((at !== scala$collection$immutable$Range$$numRangeElements)) {
      var temp$at = ((1 + at) | 0);
      var arg1 = acc;
      var i = at;
      if ((scala$collection$immutable$Range$$numRangeElements < 0)) {
        $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, length, 1, false)
      };
      if (((i < 0) || (i >= scala$collection$immutable$Range$$numRangeElements))) {
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((i + " is out of bounds (min 0, max ") + (((-1) + scala$collection$immutable$Range$$numRangeElements) | 0)) + ")"))
      };
      var accum = $as_Lshapeless_Coproduct(arg1);
      var temp$acc = new $c_Lshapeless_Inr(accum);
      at = temp$at;
      acc = temp$acc;
      continue
    };
    var $$x1 = acc;
    break
  };
  return $as_Lshapeless_Coproduct($$x1)
});
$c_Lshapeless_Coproduct$.prototype.unsafeGet__Lshapeless_Coproduct__O = (function(c) {
  while (true) {
    var x1 = c;
    if ((x1 instanceof $c_Lshapeless_Inl)) {
      var x2 = $as_Lshapeless_Inl(x1);
      var h = $n(x2).Lshapeless_Inl__f_head;
      return h
    } else if ((x1 instanceof $c_Lshapeless_Inr)) {
      var x3 = $as_Lshapeless_Inr(x1);
      var c$2 = $n(x3).Lshapeless_Inr__f_tail;
      c = c$2
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
var $d_Lshapeless_Coproduct$ = new $TypeData().initClass({
  Lshapeless_Coproduct$: 0
}, false, "shapeless.Coproduct$", {
  Lshapeless_Coproduct$: 1,
  O: 1,
  s_Dynamic: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Coproduct$.prototype.$classData = $d_Lshapeless_Coproduct$;
var $n_Lshapeless_Coproduct$;
function $m_Lshapeless_Coproduct$() {
  if ((!$n_Lshapeless_Coproduct$)) {
    $n_Lshapeless_Coproduct$ = new $c_Lshapeless_Coproduct$()
  };
  return $n_Lshapeless_Coproduct$
}
/** @constructor */
function $c_Lshapeless_Generic$$anon$1(f$1, g$1) {
  this.Lshapeless_Generic$$anon$1__f_f$1 = null;
  this.Lshapeless_Generic$$anon$1__f_g$1 = null;
  this.Lshapeless_Generic$$anon$1__f_f$1 = f$1;
  this.Lshapeless_Generic$$anon$1__f_g$1 = g$1
}
$c_Lshapeless_Generic$$anon$1.prototype = new $h_O();
$c_Lshapeless_Generic$$anon$1.prototype.constructor = $c_Lshapeless_Generic$$anon$1;
/** @constructor */
function $h_Lshapeless_Generic$$anon$1() {
  /*<skip>*/
}
$h_Lshapeless_Generic$$anon$1.prototype = $c_Lshapeless_Generic$$anon$1.prototype;
$c_Lshapeless_Generic$$anon$1.prototype.to__O__O = (function(t) {
  return $n(this.Lshapeless_Generic$$anon$1__f_f$1).apply__O__O(t)
});
$c_Lshapeless_Generic$$anon$1.prototype.from__O__O = (function(r) {
  return $n(this.Lshapeless_Generic$$anon$1__f_g$1).apply__O__O(r)
});
var $d_Lshapeless_Generic$$anon$1 = new $TypeData().initClass({
  Lshapeless_Generic$$anon$1: 0
}, false, "shapeless.Generic$$anon$1", {
  Lshapeless_Generic$$anon$1: 1,
  O: 1,
  Lshapeless_Generic: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Generic$$anon$1.prototype.$classData = $d_Lshapeless_Generic$$anon$1;
/** @constructor */
function $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$1, ev$1) {
  this.Lshapeless_LabelledGeneric$$anon$2__f_zip$1 = null;
  this.Lshapeless_LabelledGeneric$$anon$2__f_gen$1 = null;
  this.Lshapeless_LabelledGeneric$$anon$2__f_ev$1 = null;
  this.Lshapeless_LabelledGeneric$$anon$2__f_zip$1 = zip$1;
  this.Lshapeless_LabelledGeneric$$anon$2__f_gen$1 = gen$1;
  this.Lshapeless_LabelledGeneric$$anon$2__f_ev$1 = ev$1
}
$c_Lshapeless_LabelledGeneric$$anon$2.prototype = new $h_O();
$c_Lshapeless_LabelledGeneric$$anon$2.prototype.constructor = $c_Lshapeless_LabelledGeneric$$anon$2;
/** @constructor */
function $h_Lshapeless_LabelledGeneric$$anon$2() {
  /*<skip>*/
}
$h_Lshapeless_LabelledGeneric$$anon$2.prototype = $c_Lshapeless_LabelledGeneric$$anon$2.prototype;
$c_Lshapeless_LabelledGeneric$$anon$2.prototype.to__O__Lshapeless_HList = (function(t) {
  return $as_Lshapeless_HList($n(this.Lshapeless_LabelledGeneric$$anon$2__f_zip$1).apply__O__O($n(this.Lshapeless_LabelledGeneric$$anon$2__f_gen$1).to__O__O(t)))
});
$c_Lshapeless_LabelledGeneric$$anon$2.prototype.from__Lshapeless_HList__O = (function(r) {
  return $n(this.Lshapeless_LabelledGeneric$$anon$2__f_gen$1).from__O__O(($n(this.Lshapeless_LabelledGeneric$$anon$2__f_ev$1), r))
});
$c_Lshapeless_LabelledGeneric$$anon$2.prototype.from__O__O = (function(r) {
  return this.from__Lshapeless_HList__O($as_Lshapeless_HList(r))
});
$c_Lshapeless_LabelledGeneric$$anon$2.prototype.to__O__O = (function(t) {
  return this.to__O__Lshapeless_HList(t)
});
var $d_Lshapeless_LabelledGeneric$$anon$2 = new $TypeData().initClass({
  Lshapeless_LabelledGeneric$$anon$2: 0
}, false, "shapeless.LabelledGeneric$$anon$2", {
  Lshapeless_LabelledGeneric$$anon$2: 1,
  O: 1,
  Lshapeless_LabelledGeneric: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_LabelledGeneric$$anon$2.prototype.$classData = $d_Lshapeless_LabelledGeneric$$anon$2;
/** @constructor */
function $c_Lshapeless_LabelledGeneric$$anon$3(zip$2, gen$2, ev$2) {
  this.Lshapeless_LabelledGeneric$$anon$3__f_zip$2 = null;
  this.Lshapeless_LabelledGeneric$$anon$3__f_gen$2 = null;
  this.Lshapeless_LabelledGeneric$$anon$3__f_ev$2 = null;
  this.Lshapeless_LabelledGeneric$$anon$3__f_zip$2 = zip$2;
  this.Lshapeless_LabelledGeneric$$anon$3__f_gen$2 = gen$2;
  this.Lshapeless_LabelledGeneric$$anon$3__f_ev$2 = ev$2
}
$c_Lshapeless_LabelledGeneric$$anon$3.prototype = new $h_O();
$c_Lshapeless_LabelledGeneric$$anon$3.prototype.constructor = $c_Lshapeless_LabelledGeneric$$anon$3;
/** @constructor */
function $h_Lshapeless_LabelledGeneric$$anon$3() {
  /*<skip>*/
}
$h_Lshapeless_LabelledGeneric$$anon$3.prototype = $c_Lshapeless_LabelledGeneric$$anon$3.prototype;
$c_Lshapeless_LabelledGeneric$$anon$3.prototype.to__O__Lshapeless_Coproduct = (function(t) {
  return $as_Lshapeless_Coproduct($n(this.Lshapeless_LabelledGeneric$$anon$3__f_zip$2).apply__O__O($n(this.Lshapeless_LabelledGeneric$$anon$3__f_gen$2).to__O__O(t)))
});
$c_Lshapeless_LabelledGeneric$$anon$3.prototype.from__Lshapeless_Coproduct__O = (function(r) {
  return $n(this.Lshapeless_LabelledGeneric$$anon$3__f_gen$2).from__O__O(($n(this.Lshapeless_LabelledGeneric$$anon$3__f_ev$2), r))
});
$c_Lshapeless_LabelledGeneric$$anon$3.prototype.from__O__O = (function(r) {
  return this.from__Lshapeless_Coproduct__O($as_Lshapeless_Coproduct(r))
});
$c_Lshapeless_LabelledGeneric$$anon$3.prototype.to__O__O = (function(t) {
  return this.to__O__Lshapeless_Coproduct(t)
});
var $d_Lshapeless_LabelledGeneric$$anon$3 = new $TypeData().initClass({
  Lshapeless_LabelledGeneric$$anon$3: 0
}, false, "shapeless.LabelledGeneric$$anon$3", {
  Lshapeless_LabelledGeneric$$anon$3: 1,
  O: 1,
  Lshapeless_LabelledGeneric: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_LabelledGeneric$$anon$3.prototype.$classData = $d_Lshapeless_LabelledGeneric$$anon$3;
function $p_Lshapeless_Lazy$$anon$1__value$lzycompute__O($thiz) {
  if ((!$thiz.Lshapeless_Lazy$$anon$1__f_bitmap$0)) {
    $thiz.Lshapeless_Lazy$$anon$1__f_value = $n($thiz.Lshapeless_Lazy$$anon$1__f_t$1).apply__O();
    $thiz.Lshapeless_Lazy$$anon$1__f_bitmap$0 = true
  };
  $thiz.Lshapeless_Lazy$$anon$1__f_t$1 = null;
  return $thiz.Lshapeless_Lazy$$anon$1__f_value
}
/** @constructor */
function $c_Lshapeless_Lazy$$anon$1(t$1) {
  this.Lshapeless_Lazy$$anon$1__f_value = null;
  this.Lshapeless_Lazy$$anon$1__f_bitmap$0 = false;
  this.Lshapeless_Lazy$$anon$1__f_t$1 = null;
  this.Lshapeless_Lazy$$anon$1__f_t$1 = t$1
}
$c_Lshapeless_Lazy$$anon$1.prototype = new $h_O();
$c_Lshapeless_Lazy$$anon$1.prototype.constructor = $c_Lshapeless_Lazy$$anon$1;
/** @constructor */
function $h_Lshapeless_Lazy$$anon$1() {
  /*<skip>*/
}
$h_Lshapeless_Lazy$$anon$1.prototype = $c_Lshapeless_Lazy$$anon$1.prototype;
$c_Lshapeless_Lazy$$anon$1.prototype.value__O = (function() {
  return ((!this.Lshapeless_Lazy$$anon$1__f_bitmap$0) ? $p_Lshapeless_Lazy$$anon$1__value$lzycompute__O(this) : this.Lshapeless_Lazy$$anon$1__f_value)
});
var $d_Lshapeless_Lazy$$anon$1 = new $TypeData().initClass({
  Lshapeless_Lazy$$anon$1: 0
}, false, "shapeless.Lazy$$anon$1", {
  Lshapeless_Lazy$$anon$1: 1,
  O: 1,
  Lshapeless_Lazy: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Lazy$$anon$1.prototype.$classData = $d_Lshapeless_Lazy$$anon$1;
/** @constructor */
function $c_Lshapeless_Lub$$anon$4() {
  /*<skip>*/
}
$c_Lshapeless_Lub$$anon$4.prototype = new $h_O();
$c_Lshapeless_Lub$$anon$4.prototype.constructor = $c_Lshapeless_Lub$$anon$4;
/** @constructor */
function $h_Lshapeless_Lub$$anon$4() {
  /*<skip>*/
}
$h_Lshapeless_Lub$$anon$4.prototype = $c_Lshapeless_Lub$$anon$4.prototype;
var $d_Lshapeless_Lub$$anon$4 = new $TypeData().initClass({
  Lshapeless_Lub$$anon$4: 0
}, false, "shapeless.Lub$$anon$4", {
  Lshapeless_Lub$$anon$4: 1,
  O: 1,
  Lshapeless_Lub: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Lub$$anon$4.prototype.$classData = $d_Lshapeless_Lub$$anon$4;
/** @constructor */
function $c_Lshapeless_Typeable$$anon$1(description$1, f$1) {
  this.Lshapeless_Typeable$$anon$1__f_description$1 = null;
  this.Lshapeless_Typeable$$anon$1__f_f$1 = null;
  this.Lshapeless_Typeable$$anon$1__f_description$1 = description$1;
  this.Lshapeless_Typeable$$anon$1__f_f$1 = f$1
}
$c_Lshapeless_Typeable$$anon$1.prototype = new $h_O();
$c_Lshapeless_Typeable$$anon$1.prototype.constructor = $c_Lshapeless_Typeable$$anon$1;
/** @constructor */
function $h_Lshapeless_Typeable$$anon$1() {
  /*<skip>*/
}
$h_Lshapeless_Typeable$$anon$1.prototype = $c_Lshapeless_Typeable$$anon$1.prototype;
$c_Lshapeless_Typeable$$anon$1.prototype.toString__T = (function() {
  return $f_Lshapeless_Typeable__toString__T(this)
});
$c_Lshapeless_Typeable$$anon$1.prototype.describe__T = (function() {
  return $as_T($n(this.Lshapeless_Typeable$$anon$1__f_description$1).apply__O())
});
$c_Lshapeless_Typeable$$anon$1.prototype.cast__O__s_Option = (function(t) {
  return $as_s_Option($n(this.Lshapeless_Typeable$$anon$1__f_f$1).apply__O__O(t))
});
var $d_Lshapeless_Typeable$$anon$1 = new $TypeData().initClass({
  Lshapeless_Typeable$$anon$1: 0
}, false, "shapeless.Typeable$$anon$1", {
  Lshapeless_Typeable$$anon$1: 1,
  O: 1,
  Lshapeless_Typeable: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Typeable$$anon$1.prototype.$classData = $d_Lshapeless_Typeable$$anon$1;
/** @constructor */
function $c_Lshapeless_Witness$() {
  this.Lshapeless_Witness$__f_witness0 = null;
  $n_Lshapeless_Witness$ = this;
  this.Lshapeless_Witness$__f_witness0 = new $c_Lshapeless_Witness$$anon$2()
}
$c_Lshapeless_Witness$.prototype = new $h_O();
$c_Lshapeless_Witness$.prototype.constructor = $c_Lshapeless_Witness$;
/** @constructor */
function $h_Lshapeless_Witness$() {
  /*<skip>*/
}
$h_Lshapeless_Witness$.prototype = $c_Lshapeless_Witness$.prototype;
var $d_Lshapeless_Witness$ = new $TypeData().initClass({
  Lshapeless_Witness$: 0
}, false, "shapeless.Witness$", {
  Lshapeless_Witness$: 1,
  O: 1,
  s_Dynamic: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Witness$.prototype.$classData = $d_Lshapeless_Witness$;
var $n_Lshapeless_Witness$;
function $m_Lshapeless_Witness$() {
  if ((!$n_Lshapeless_Witness$)) {
    $n_Lshapeless_Witness$ = new $c_Lshapeless_Witness$()
  };
  return $n_Lshapeless_Witness$
}
/** @constructor */
function $c_Lshapeless_Witness$$anon$1(value0$1) {
  this.Lshapeless_Witness$$anon$1__f_value = null;
  this.Lshapeless_Witness$$anon$1__f_value = value0$1
}
$c_Lshapeless_Witness$$anon$1.prototype = new $h_O();
$c_Lshapeless_Witness$$anon$1.prototype.constructor = $c_Lshapeless_Witness$$anon$1;
/** @constructor */
function $h_Lshapeless_Witness$$anon$1() {
  /*<skip>*/
}
$h_Lshapeless_Witness$$anon$1.prototype = $c_Lshapeless_Witness$$anon$1.prototype;
$c_Lshapeless_Witness$$anon$1.prototype.value__O = (function() {
  return this.Lshapeless_Witness$$anon$1__f_value
});
var $d_Lshapeless_Witness$$anon$1 = new $TypeData().initClass({
  Lshapeless_Witness$$anon$1: 0
}, false, "shapeless.Witness$$anon$1", {
  Lshapeless_Witness$$anon$1: 1,
  O: 1,
  Lshapeless_Witness: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Witness$$anon$1.prototype.$classData = $d_Lshapeless_Witness$$anon$1;
/** @constructor */
function $c_Lshapeless_Witness$$anon$2() {
  this.Lshapeless_Witness$$anon$2__f_value = null;
  this.Lshapeless_Witness$$anon$2__f_value = $m_Lshapeless_Nat$().Lshapeless_Nat$__f__0
}
$c_Lshapeless_Witness$$anon$2.prototype = new $h_O();
$c_Lshapeless_Witness$$anon$2.prototype.constructor = $c_Lshapeless_Witness$$anon$2;
/** @constructor */
function $h_Lshapeless_Witness$$anon$2() {
  /*<skip>*/
}
$h_Lshapeless_Witness$$anon$2.prototype = $c_Lshapeless_Witness$$anon$2.prototype;
$c_Lshapeless_Witness$$anon$2.prototype.value__O = (function() {
  return this.Lshapeless_Witness$$anon$2__f_value
});
var $d_Lshapeless_Witness$$anon$2 = new $TypeData().initClass({
  Lshapeless_Witness$$anon$2: 0
}, false, "shapeless.Witness$$anon$2", {
  Lshapeless_Witness$$anon$2: 1,
  O: 1,
  Lshapeless_Witness: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Witness$$anon$2.prototype.$classData = $d_Lshapeless_Witness$$anon$2;
/** @constructor */
function $c_Lshapeless_\uff3f0() {
  /*<skip>*/
}
$c_Lshapeless_\uff3f0.prototype = new $h_O();
$c_Lshapeless_\uff3f0.prototype.constructor = $c_Lshapeless_\uff3f0;
/** @constructor */
function $h_Lshapeless_\uff3f0() {
  /*<skip>*/
}
$h_Lshapeless_\uff3f0.prototype = $c_Lshapeless_\uff3f0.prototype;
var $d_Lshapeless_\uff3f0 = new $TypeData().initClass({
  Lshapeless_\uff3f0: 0
}, false, "shapeless._0", {
  Lshapeless_\uff3f0: 1,
  O: 1,
  Lshapeless_Nat: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_\uff3f0.prototype.$classData = $d_Lshapeless_\uff3f0;
function $f_Lshapeless_ops_hlist$ToTraversable__apply__Lshapeless_HList__O($thiz, l) {
  var b = $thiz.builder__scm_Builder();
  $thiz.append__Lshapeless_HList__scm_Builder__F1__V(l, b, $m_Lshapeless_PolyDefns$$tilde$greater$().inst4__Lshapeless_PolyDefns$$tilde$greater__F1($m_Lshapeless_PolyDefns$identity$()));
  return $n(b).result__O()
}
/** @constructor */
function $c_Lshapeless_ops_maps$FromMap$$anon$1() {
  /*<skip>*/
}
$c_Lshapeless_ops_maps$FromMap$$anon$1.prototype = new $h_O();
$c_Lshapeless_ops_maps$FromMap$$anon$1.prototype.constructor = $c_Lshapeless_ops_maps$FromMap$$anon$1;
/** @constructor */
function $h_Lshapeless_ops_maps$FromMap$$anon$1() {
  /*<skip>*/
}
$h_Lshapeless_ops_maps$FromMap$$anon$1.prototype = $c_Lshapeless_ops_maps$FromMap$$anon$1.prototype;
$c_Lshapeless_ops_maps$FromMap$$anon$1.prototype.apply__sci_Map__s_Option = (function(m) {
  return new $c_s_Some($m_Lshapeless_HNil$())
});
var $d_Lshapeless_ops_maps$FromMap$$anon$1 = new $TypeData().initClass({
  Lshapeless_ops_maps$FromMap$$anon$1: 0
}, false, "shapeless.ops.maps$FromMap$$anon$1", {
  Lshapeless_ops_maps$FromMap$$anon$1: 1,
  O: 1,
  Lshapeless_ops_maps$FromMap: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_maps$FromMap$$anon$1.prototype.$classData = $d_Lshapeless_ops_maps$FromMap$$anon$1;
/** @constructor */
function $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$1, tv$1, fmt$1) {
  this.Lshapeless_ops_maps$FromMap$$anon$2__f_wk$1 = null;
  this.Lshapeless_ops_maps$FromMap$$anon$2__f_tv$1 = null;
  this.Lshapeless_ops_maps$FromMap$$anon$2__f_fmt$1 = null;
  this.Lshapeless_ops_maps$FromMap$$anon$2__f_wk$1 = wk$1;
  this.Lshapeless_ops_maps$FromMap$$anon$2__f_tv$1 = tv$1;
  this.Lshapeless_ops_maps$FromMap$$anon$2__f_fmt$1 = fmt$1
}
$c_Lshapeless_ops_maps$FromMap$$anon$2.prototype = new $h_O();
$c_Lshapeless_ops_maps$FromMap$$anon$2.prototype.constructor = $c_Lshapeless_ops_maps$FromMap$$anon$2;
/** @constructor */
function $h_Lshapeless_ops_maps$FromMap$$anon$2() {
  /*<skip>*/
}
$h_Lshapeless_ops_maps$FromMap$$anon$2.prototype = $c_Lshapeless_ops_maps$FromMap$$anon$2.prototype;
$c_Lshapeless_ops_maps$FromMap$$anon$2.prototype.apply__sci_Map__s_Option = (function(m) {
  var this$1 = $n($n(m).get__O__s_Option($n(this.Lshapeless_ops_maps$FromMap$$anon$2__f_wk$1).value__O()));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var this$2 = $n($n(this.Lshapeless_ops_maps$FromMap$$anon$2__f_tv$1).cast__O__s_Option(arg1));
    if (this$2.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$1 = this$2.get__O();
      var this$3 = $n($n(this.Lshapeless_ops_maps$FromMap$$anon$2__f_fmt$1).apply__sci_Map__s_Option(m));
      if (this$3.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1$2 = this$3.get__O();
        var rest = $as_Lshapeless_HList(arg1$2);
        new $c_Lshapeless_labelled$FieldBuilder();
        return new $c_s_Some(new $c_Lshapeless_syntax_HListOps(rest).$colon$colon__O__Lshapeless_$colon$colon(arg1$1))
      }
    }
  }
});
var $d_Lshapeless_ops_maps$FromMap$$anon$2 = new $TypeData().initClass({
  Lshapeless_ops_maps$FromMap$$anon$2: 0
}, false, "shapeless.ops.maps$FromMap$$anon$2", {
  Lshapeless_ops_maps$FromMap$$anon$2: 1,
  O: 1,
  Lshapeless_ops_maps$FromMap: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_maps$FromMap$$anon$2.prototype.$classData = $d_Lshapeless_ops_maps$FromMap$$anon$2;
/** @constructor */
function $c_Lshapeless_ops_nat$ToInt$Inst(i) {
  this.Lshapeless_ops_nat$ToInt$Inst__f_i = 0;
  this.Lshapeless_ops_nat$ToInt$Inst__f_i = i
}
$c_Lshapeless_ops_nat$ToInt$Inst.prototype = new $h_O();
$c_Lshapeless_ops_nat$ToInt$Inst.prototype.constructor = $c_Lshapeless_ops_nat$ToInt$Inst;
/** @constructor */
function $h_Lshapeless_ops_nat$ToInt$Inst() {
  /*<skip>*/
}
$h_Lshapeless_ops_nat$ToInt$Inst.prototype = $c_Lshapeless_ops_nat$ToInt$Inst.prototype;
var $d_Lshapeless_ops_nat$ToInt$Inst = new $TypeData().initClass({
  Lshapeless_ops_nat$ToInt$Inst: 0
}, false, "shapeless.ops.nat$ToInt$Inst", {
  Lshapeless_ops_nat$ToInt$Inst: 1,
  O: 1,
  Lshapeless_ops_nat$ToInt: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_nat$ToInt$Inst.prototype.$classData = $d_Lshapeless_ops_nat$ToInt$Inst;
/** @constructor */
function $c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1(f) {
  this.Lshapeless_ops_traversable$FromTraversable$$$Lambda$1__f_f = null;
  this.Lshapeless_ops_traversable$FromTraversable$$$Lambda$1__f_f = f
}
$c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1.prototype = new $h_O();
$c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1.prototype.constructor = $c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1;
/** @constructor */
function $h_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1() {
  /*<skip>*/
}
$h_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1.prototype = $c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1.prototype;
$c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1.prototype.apply__sc_Iterable__s_Option = (function(l$3) {
  return $as_s_Option((0, this.Lshapeless_ops_traversable$FromTraversable$$$Lambda$1__f_f)(l$3))
});
var $d_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1 = new $TypeData().initClass({
  Lshapeless_ops_traversable$FromTraversable$$$Lambda$1: 0
}, false, "shapeless.ops.traversable$FromTraversable$$$Lambda$1", {
  Lshapeless_ops_traversable$FromTraversable$$$Lambda$1: 1,
  O: 1,
  Lshapeless_ops_traversable$FromTraversable: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1.prototype.$classData = $d_Lshapeless_ops_traversable$FromTraversable$$$Lambda$1;
/** @constructor */
function $c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2(f) {
  this.Lshapeless_ops_traversable$FromTraversable$$$Lambda$2__f_f = null;
  this.Lshapeless_ops_traversable$FromTraversable$$$Lambda$2__f_f = f
}
$c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2.prototype = new $h_O();
$c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2.prototype.constructor = $c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2;
/** @constructor */
function $h_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2() {
  /*<skip>*/
}
$h_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2.prototype = $c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2.prototype;
$c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2.prototype.apply__sc_Iterable__s_Option = (function(l$3) {
  return $as_s_Option((0, this.Lshapeless_ops_traversable$FromTraversable$$$Lambda$2__f_f)(l$3))
});
var $d_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2 = new $TypeData().initClass({
  Lshapeless_ops_traversable$FromTraversable$$$Lambda$2: 0
}, false, "shapeless.ops.traversable$FromTraversable$$$Lambda$2", {
  Lshapeless_ops_traversable$FromTraversable$$$Lambda$2: 1,
  O: 1,
  Lshapeless_ops_traversable$FromTraversable: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2.prototype.$classData = $d_Lshapeless_ops_traversable$FromTraversable$$$Lambda$2;
/** @constructor */
function $c_Lautowire_ClientProxy(self) {
  this.Lautowire_ClientProxy__f_self = null;
  this.Lautowire_ClientProxy__f_self = self
}
$c_Lautowire_ClientProxy.prototype = new $h_O();
$c_Lautowire_ClientProxy.prototype.constructor = $c_Lautowire_ClientProxy;
/** @constructor */
function $h_Lautowire_ClientProxy() {
  /*<skip>*/
}
$h_Lautowire_ClientProxy.prototype = $c_Lautowire_ClientProxy.prototype;
$c_Lautowire_ClientProxy.prototype.productPrefix__T = (function() {
  return "ClientProxy"
});
$c_Lautowire_ClientProxy.prototype.productArity__I = (function() {
  return 1
});
$c_Lautowire_ClientProxy.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lautowire_ClientProxy__f_self : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lautowire_ClientProxy.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lautowire_ClientProxy.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lautowire_ClientProxy.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lautowire_ClientProxy.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lautowire_ClientProxy)) {
    var ClientProxy$1 = $as_Lautowire_ClientProxy(x$1);
    var x = this.Lautowire_ClientProxy__f_self;
    var x$2 = $n(ClientProxy$1).Lautowire_ClientProxy__f_self;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      $n(ClientProxy$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lautowire_ClientProxy(obj) {
  return (((obj instanceof $c_Lautowire_ClientProxy) || (obj === null)) ? obj : $throwClassCastException(obj, "autowire.ClientProxy"))
}
function $isArrayOf_Lautowire_ClientProxy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lautowire_ClientProxy)))
}
function $asArrayOf_Lautowire_ClientProxy(obj, depth) {
  return (($isArrayOf_Lautowire_ClientProxy(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lautowire.ClientProxy;", depth))
}
var $d_Lautowire_ClientProxy = new $TypeData().initClass({
  Lautowire_ClientProxy: 0
}, false, "autowire.ClientProxy", {
  Lautowire_ClientProxy: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lautowire_ClientProxy.prototype.$classData = $d_Lautowire_ClientProxy;
/** @constructor */
function $c_Lautowire_Core$Request(path, args) {
  this.Lautowire_Core$Request__f_path = null;
  this.Lautowire_Core$Request__f_args = null;
  this.Lautowire_Core$Request__f_path = path;
  this.Lautowire_Core$Request__f_args = args
}
$c_Lautowire_Core$Request.prototype = new $h_O();
$c_Lautowire_Core$Request.prototype.constructor = $c_Lautowire_Core$Request;
/** @constructor */
function $h_Lautowire_Core$Request() {
  /*<skip>*/
}
$h_Lautowire_Core$Request.prototype = $c_Lautowire_Core$Request.prototype;
$c_Lautowire_Core$Request.prototype.productPrefix__T = (function() {
  return "Request"
});
$c_Lautowire_Core$Request.prototype.productArity__I = (function() {
  return 2
});
$c_Lautowire_Core$Request.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lautowire_Core$Request__f_path;
      break
    }
    case 1: {
      return this.Lautowire_Core$Request__f_args;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lautowire_Core$Request.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lautowire_Core$Request.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lautowire_Core$Request.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lautowire_Core$Request.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lautowire_Core$Request)) {
    var Request$1 = $as_Lautowire_Core$Request(x$1);
    var x = this.Lautowire_Core$Request__f_path;
    var x$2 = $n(Request$1).Lautowire_Core$Request__f_path;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lautowire_Core$Request__f_args;
      var x$4 = $n(Request$1).Lautowire_Core$Request__f_args;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(Request$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lautowire_Core$Request(obj) {
  return (((obj instanceof $c_Lautowire_Core$Request) || (obj === null)) ? obj : $throwClassCastException(obj, "autowire.Core$Request"))
}
function $isArrayOf_Lautowire_Core$Request(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lautowire_Core$Request)))
}
function $asArrayOf_Lautowire_Core$Request(obj, depth) {
  return (($isArrayOf_Lautowire_Core$Request(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lautowire.Core$Request;", depth))
}
var $d_Lautowire_Core$Request = new $TypeData().initClass({
  Lautowire_Core$Request: 0
}, false, "autowire.Core$Request", {
  Lautowire_Core$Request: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lautowire_Core$Request.prototype.$classData = $d_Lautowire_Core$Request;
/** @constructor */
function $c_Lcats_Eval$$anon$1(outer, x2$1, f$2) {
  this.Lcats_Eval$$anon$1__f_start = null;
  this.Lcats_Eval$$anon$1__f_run = null;
  this.Lcats_Eval$$anon$1__f_x2$1 = null;
  this.Lcats_Eval$$anon$1__f_f$2 = null;
  this.Lcats_Eval$$anon$1__f_x2$1 = x2$1;
  this.Lcats_Eval$$anon$1__f_f$2 = f$2;
  this.Lcats_Eval$$anon$1__f_start = $n(x2$1).start__F0();
  this.Lcats_Eval$$anon$1__f_run = new $c_sjsr_AnonFunction1(((s$2) => new $c_Lcats_Eval$$anon$1$$anon$2(this, s$2)))
}
$c_Lcats_Eval$$anon$1.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$1.prototype.constructor = $c_Lcats_Eval$$anon$1;
/** @constructor */
function $h_Lcats_Eval$$anon$1() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$1.prototype = $c_Lcats_Eval$$anon$1.prototype;
$c_Lcats_Eval$$anon$1.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$1__f_start
});
$c_Lcats_Eval$$anon$1.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$1__f_run
});
var $d_Lcats_Eval$$anon$1 = new $TypeData().initClass({
  Lcats_Eval$$anon$1: 0
}, false, "cats.Eval$$anon$1", {
  Lcats_Eval$$anon$1: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$1.prototype.$classData = $d_Lcats_Eval$$anon$1;
/** @constructor */
function $c_Lcats_Eval$$anon$1$$anon$2(outer, s$1) {
  this.Lcats_Eval$$anon$1$$anon$2__f_start = null;
  this.Lcats_Eval$$anon$1$$anon$2__f_run = null;
  this.Lcats_Eval$$anon$1$$anon$2__f_$outer = null;
  this.Lcats_Eval$$anon$1$$anon$2__f_s$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcats_Eval$$anon$1$$anon$2__f_$outer = outer
  };
  this.Lcats_Eval$$anon$1$$anon$2__f_s$1 = s$1;
  this.Lcats_Eval$$anon$1$$anon$2__f_start = new $c_sjsr_AnonFunction0((() => $as_Lcats_Eval($n($n($n(this.Lcats_Eval$$anon$1$$anon$2__f_$outer).Lcats_Eval$$anon$1__f_x2$1).run__F1()).apply__O__O(this.Lcats_Eval$$anon$1$$anon$2__f_s$1))));
  this.Lcats_Eval$$anon$1$$anon$2__f_run = $n(outer).Lcats_Eval$$anon$1__f_f$2
}
$c_Lcats_Eval$$anon$1$$anon$2.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$1$$anon$2.prototype.constructor = $c_Lcats_Eval$$anon$1$$anon$2;
/** @constructor */
function $h_Lcats_Eval$$anon$1$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$1$$anon$2.prototype = $c_Lcats_Eval$$anon$1$$anon$2.prototype;
$c_Lcats_Eval$$anon$1$$anon$2.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$1$$anon$2__f_start
});
$c_Lcats_Eval$$anon$1$$anon$2.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$1$$anon$2__f_run
});
var $d_Lcats_Eval$$anon$1$$anon$2 = new $TypeData().initClass({
  Lcats_Eval$$anon$1$$anon$2: 0
}, false, "cats.Eval$$anon$1$$anon$2", {
  Lcats_Eval$$anon$1$$anon$2: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$1$$anon$2.prototype.$classData = $d_Lcats_Eval$$anon$1$$anon$2;
/** @constructor */
function $c_Lcats_Eval$$anon$3(outer, x3$1, f$2) {
  this.Lcats_Eval$$anon$3__f_start = null;
  this.Lcats_Eval$$anon$3__f_run = null;
  this.Lcats_Eval$$anon$3__f_start = $n(x3$1).thunk__F0();
  this.Lcats_Eval$$anon$3__f_run = f$2
}
$c_Lcats_Eval$$anon$3.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$3.prototype.constructor = $c_Lcats_Eval$$anon$3;
/** @constructor */
function $h_Lcats_Eval$$anon$3() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$3.prototype = $c_Lcats_Eval$$anon$3.prototype;
$c_Lcats_Eval$$anon$3.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$3__f_start
});
$c_Lcats_Eval$$anon$3.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$3__f_run
});
var $d_Lcats_Eval$$anon$3 = new $TypeData().initClass({
  Lcats_Eval$$anon$3: 0
}, false, "cats.Eval$$anon$3", {
  Lcats_Eval$$anon$3: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$3.prototype.$classData = $d_Lcats_Eval$$anon$3;
/** @constructor */
function $c_Lcats_Eval$$anon$4(outer, f$2) {
  this.Lcats_Eval$$anon$4__f_start = null;
  this.Lcats_Eval$$anon$4__f_run = null;
  this.Lcats_Eval$$anon$4__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcats_Eval$$anon$4__f_$outer = outer
  };
  this.Lcats_Eval$$anon$4__f_start = new $c_sjsr_AnonFunction0((() => this.Lcats_Eval$$anon$4__f_$outer));
  this.Lcats_Eval$$anon$4__f_run = f$2
}
$c_Lcats_Eval$$anon$4.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$4.prototype.constructor = $c_Lcats_Eval$$anon$4;
/** @constructor */
function $h_Lcats_Eval$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$4.prototype = $c_Lcats_Eval$$anon$4.prototype;
$c_Lcats_Eval$$anon$4.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$4__f_start
});
$c_Lcats_Eval$$anon$4.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$4__f_run
});
var $d_Lcats_Eval$$anon$4 = new $TypeData().initClass({
  Lcats_Eval$$anon$4: 0
}, false, "cats.Eval$$anon$4", {
  Lcats_Eval$$anon$4: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$4.prototype.$classData = $d_Lcats_Eval$$anon$4;
/** @constructor */
function $c_Lcats_MonoidK$$anon$1(outer) {
  this.Lcats_MonoidK$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcats_MonoidK$$anon$1__f_$outer = outer
  }
}
$c_Lcats_MonoidK$$anon$1.prototype = new $h_O();
$c_Lcats_MonoidK$$anon$1.prototype.constructor = $c_Lcats_MonoidK$$anon$1;
/** @constructor */
function $h_Lcats_MonoidK$$anon$1() {
  /*<skip>*/
}
$h_Lcats_MonoidK$$anon$1.prototype = $c_Lcats_MonoidK$$anon$1.prototype;
$c_Lcats_MonoidK$$anon$1.prototype.empty__O = (function() {
  return $n(this.Lcats_MonoidK$$anon$1__f_$outer).empty__O()
});
$c_Lcats_MonoidK$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return $n(this.Lcats_MonoidK$$anon$1__f_$outer).combineK__O__O__O(x, y)
});
var $d_Lcats_MonoidK$$anon$1 = new $TypeData().initClass({
  Lcats_MonoidK$$anon$1: 0
}, false, "cats.MonoidK$$anon$1", {
  Lcats_MonoidK$$anon$1: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_MonoidK$$anon$1.prototype.$classData = $d_Lcats_MonoidK$$anon$1;
/** @constructor */
function $c_Lcats_Parallel$$anon$2(evidence$32$1) {
  new $c_Lcats_arrow_FunctionK$$anon$4();
  new $c_Lcats_arrow_FunctionK$$anon$4()
}
$c_Lcats_Parallel$$anon$2.prototype = new $h_O();
$c_Lcats_Parallel$$anon$2.prototype.constructor = $c_Lcats_Parallel$$anon$2;
/** @constructor */
function $h_Lcats_Parallel$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Parallel$$anon$2.prototype = $c_Lcats_Parallel$$anon$2.prototype;
var $d_Lcats_Parallel$$anon$2 = new $TypeData().initClass({
  Lcats_Parallel$$anon$2: 0
}, false, "cats.Parallel$$anon$2", {
  Lcats_Parallel$$anon$2: 1,
  O: 1,
  Lcats_Parallel: 1,
  Lcats_NonEmptyParallel: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Parallel$$anon$2.prototype.$classData = $d_Lcats_Parallel$$anon$2;
/** @constructor */
function $c_Lcats_Semigroupal$() {
  $n_Lcats_Semigroupal$ = this;
  $m_Lcats_instances_package$order$();
  $m_Lcats_instances_package$partialOrder$();
  $m_Lcats_instances_package$ordering$();
  $m_Lcats_instances_package$partialOrdering$();
  $m_Lcats_instances_package$eq$();
  $m_Lcats_instances_package$equiv$();
  var this$1 = $m_Lcats_instances_package$invariant$();
  new $c_Lcats_instances_InvariantMonoidalInstances$$anon$1(this$1);
  $m_Lcats_instances_package$invariant$();
  $m_Lcats_instances_package$invariant$()
}
$c_Lcats_Semigroupal$.prototype = new $h_O();
$c_Lcats_Semigroupal$.prototype.constructor = $c_Lcats_Semigroupal$;
/** @constructor */
function $h_Lcats_Semigroupal$() {
  /*<skip>*/
}
$h_Lcats_Semigroupal$.prototype = $c_Lcats_Semigroupal$.prototype;
var $d_Lcats_Semigroupal$ = new $TypeData().initClass({
  Lcats_Semigroupal$: 0
}, false, "cats.Semigroupal$", {
  Lcats_Semigroupal$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificSemigroupalInstances: 1,
  Lcats_SemigroupalArityFunctions: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Semigroupal$.prototype.$classData = $d_Lcats_Semigroupal$;
var $n_Lcats_Semigroupal$;
function $m_Lcats_Semigroupal$() {
  if ((!$n_Lcats_Semigroupal$)) {
    $n_Lcats_Semigroupal$ = new $c_Lcats_Semigroupal$()
  };
  return $n_Lcats_Semigroupal$
}
/** @constructor */
function $c_Lcats_Show$() {
  $n_Lcats_Show$ = this;
  new $c_Lcats_Show$$anon$4()
}
$c_Lcats_Show$.prototype = new $h_O();
$c_Lcats_Show$.prototype.constructor = $c_Lcats_Show$;
/** @constructor */
function $h_Lcats_Show$() {
  /*<skip>*/
}
$h_Lcats_Show$.prototype = $c_Lcats_Show$.prototype;
var $d_Lcats_Show$ = new $TypeData().initClass({
  Lcats_Show$: 0
}, false, "cats.Show$", {
  Lcats_Show$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificShowInstances: 1,
  Lcats_ShowInstances: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Show$.prototype.$classData = $d_Lcats_Show$;
var $n_Lcats_Show$;
function $m_Lcats_Show$() {
  if ((!$n_Lcats_Show$)) {
    $n_Lcats_Show$ = new $c_Lcats_Show$()
  };
  return $n_Lcats_Show$
}
/** @constructor */
function $c_Lcats_Show$$anon$2(f$1) {
  this.Lcats_Show$$anon$2__f_f$1 = null;
  this.Lcats_Show$$anon$2__f_f$1 = f$1
}
$c_Lcats_Show$$anon$2.prototype = new $h_O();
$c_Lcats_Show$$anon$2.prototype.constructor = $c_Lcats_Show$$anon$2;
/** @constructor */
function $h_Lcats_Show$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$2.prototype = $c_Lcats_Show$$anon$2.prototype;
$c_Lcats_Show$$anon$2.prototype.show__O__T = (function(a) {
  return $as_T($n(this.Lcats_Show$$anon$2__f_f$1).apply__O__O(a))
});
var $d_Lcats_Show$$anon$2 = new $TypeData().initClass({
  Lcats_Show$$anon$2: 0
}, false, "cats.Show$$anon$2", {
  Lcats_Show$$anon$2: 1,
  O: 1,
  Lcats_Show: 1,
  Lcats_Show$ContravariantShow: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Show$$anon$2.prototype.$classData = $d_Lcats_Show$$anon$2;
/** @constructor */
function $c_Lcats_Show$$anon$3() {
  /*<skip>*/
}
$c_Lcats_Show$$anon$3.prototype = new $h_O();
$c_Lcats_Show$$anon$3.prototype.constructor = $c_Lcats_Show$$anon$3;
/** @constructor */
function $h_Lcats_Show$$anon$3() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$3.prototype = $c_Lcats_Show$$anon$3.prototype;
$c_Lcats_Show$$anon$3.prototype.show__O__T = (function(a) {
  return $dp_toString__T($n(a))
});
var $d_Lcats_Show$$anon$3 = new $TypeData().initClass({
  Lcats_Show$$anon$3: 0
}, false, "cats.Show$$anon$3", {
  Lcats_Show$$anon$3: 1,
  O: 1,
  Lcats_Show: 1,
  Lcats_Show$ContravariantShow: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Show$$anon$3.prototype.$classData = $d_Lcats_Show$$anon$3;
/** @constructor */
function $c_Lcats_Show$$anon$4() {
  /*<skip>*/
}
$c_Lcats_Show$$anon$4.prototype = new $h_O();
$c_Lcats_Show$$anon$4.prototype.constructor = $c_Lcats_Show$$anon$4;
/** @constructor */
function $h_Lcats_Show$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$4.prototype = $c_Lcats_Show$$anon$4.prototype;
$c_Lcats_Show$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  return this.contramap__Lcats_Show__F1__Lcats_Show($as_Lcats_Show(fa), fi)
});
$c_Lcats_Show$$anon$4.prototype.contramap__Lcats_Show__F1__Lcats_Show = (function(fa, f) {
  $m_Lcats_Show$();
  var this$2 = new $c_sjsr_AnonFunction1(((t$2) => $n(fa).show__O__T(t$2)));
  var f$1 = $f_F1__compose__F1__F1(this$2, f);
  return new $c_Lcats_Show$$anon$2(f$1)
});
var $d_Lcats_Show$$anon$4 = new $TypeData().initClass({
  Lcats_Show$$anon$4: 0
}, false, "cats.Show$$anon$4", {
  Lcats_Show$$anon$4: 1,
  O: 1,
  Lcats_Contravariant: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Show$$anon$4.prototype.$classData = $d_Lcats_Show$$anon$4;
/** @constructor */
function $c_Lcats_data_AndThen$() {
  $ct_Lcats_data_AndThenInstances0__(this)
}
$c_Lcats_data_AndThen$.prototype = new $h_Lcats_data_AndThenInstances0();
$c_Lcats_data_AndThen$.prototype.constructor = $c_Lcats_data_AndThen$;
/** @constructor */
function $h_Lcats_data_AndThen$() {
  /*<skip>*/
}
$h_Lcats_data_AndThen$.prototype = $c_Lcats_data_AndThen$.prototype;
$c_Lcats_data_AndThen$.prototype.apply__F1__Lcats_data_AndThen = (function(f) {
  if ((f instanceof $c_Lcats_data_AndThen)) {
    var x2 = $as_Lcats_data_AndThen(f);
    return x2
  } else {
    return new $c_Lcats_data_AndThen$Single(f, 0)
  }
});
$c_Lcats_data_AndThen$.prototype.andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen = (function(ab, bc) {
  if ((ab instanceof $c_Lcats_data_AndThen$Single)) {
    var x2 = $as_Lcats_data_AndThen$Single(ab);
    var f = $n(x2).Lcats_data_AndThen$Single__f_f;
    var indexf = $n(x2).Lcats_data_AndThen$Single__f_index;
    if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
      var x2$2 = $as_Lcats_data_AndThen$Single(bc);
      var g = $n(x2$2).Lcats_data_AndThen$Single__f_f;
      var indexg = $n(x2$2).Lcats_data_AndThen$Single__f_index;
      return ((((indexf + indexg) | 0) < 128) ? new $c_Lcats_data_AndThen$Single($n(f).andThen__F1__F1(g), ((1 + ((indexf + indexg) | 0)) | 0)) : new $c_Lcats_data_AndThen$Concat(ab, bc))
    };
    if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
      var x3 = $as_Lcats_data_AndThen$Concat(bc);
      var p4 = $n(x3).Lcats_data_AndThen$Concat__f_left;
      var right = $n(x3).Lcats_data_AndThen$Concat__f_right;
      if ((p4 instanceof $c_Lcats_data_AndThen$Single)) {
        var x5 = $as_Lcats_data_AndThen$Single(p4);
        var g$2 = $n(x5).Lcats_data_AndThen$Single__f_f;
        var indexg$2 = $n(x5).Lcats_data_AndThen$Single__f_index;
        if ((((indexf + indexg$2) | 0) < 128)) {
          return new $c_Lcats_data_AndThen$Concat(new $c_Lcats_data_AndThen$Single($n(f).andThen__F1__F1(g$2), ((1 + ((indexf + indexg$2) | 0)) | 0)), right)
        }
      }
    };
    return new $c_Lcats_data_AndThen$Concat(ab, bc)
  };
  if ((ab instanceof $c_Lcats_data_AndThen$Concat)) {
    var x3$2 = $as_Lcats_data_AndThen$Concat(ab);
    var leftf = $n(x3$2).Lcats_data_AndThen$Concat__f_left;
    var p4$2 = $n(x3$2).Lcats_data_AndThen$Concat__f_right;
    if ((p4$2 instanceof $c_Lcats_data_AndThen$Single)) {
      var x5$2 = $as_Lcats_data_AndThen$Single(p4$2);
      var f$2 = $n(x5$2).Lcats_data_AndThen$Single__f_f;
      var indexf$2 = $n(x5$2).Lcats_data_AndThen$Single__f_index;
      if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
        var x2$3 = $as_Lcats_data_AndThen$Single(bc);
        var g$3 = $n(x2$3).Lcats_data_AndThen$Single__f_f;
        var indexg$3 = $n(x2$3).Lcats_data_AndThen$Single__f_index;
        return ((((indexf$2 + indexg$3) | 0) < 128) ? new $c_Lcats_data_AndThen$Concat(leftf, new $c_Lcats_data_AndThen$Single($n(f$2).andThen__F1__F1(g$3), ((1 + ((indexf$2 + indexg$3) | 0)) | 0))) : new $c_Lcats_data_AndThen$Concat(ab, bc))
      };
      if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
        var x3$3 = $as_Lcats_data_AndThen$Concat(bc);
        var p4$3 = $n(x3$3).Lcats_data_AndThen$Concat__f_left;
        var right$2 = $n(x3$3).Lcats_data_AndThen$Concat__f_right;
        if ((p4$3 instanceof $c_Lcats_data_AndThen$Single)) {
          var x5$3 = $as_Lcats_data_AndThen$Single(p4$3);
          var g$4 = $n(x5$3).Lcats_data_AndThen$Single__f_f;
          var indexg$4 = $n(x5$3).Lcats_data_AndThen$Single__f_index;
          if ((((indexf$2 + indexg$4) | 0) < 128)) {
            return new $c_Lcats_data_AndThen$Concat(leftf, new $c_Lcats_data_AndThen$Concat(new $c_Lcats_data_AndThen$Single($n(f$2).andThen__F1__F1(g$4), ((1 + ((indexf$2 + indexg$4) | 0)) | 0)), right$2))
          }
        }
      };
      return new $c_Lcats_data_AndThen$Concat(ab, bc)
    }
  };
  return new $c_Lcats_data_AndThen$Concat(ab, bc)
});
var $d_Lcats_data_AndThen$ = new $TypeData().initClass({
  Lcats_data_AndThen$: 0
}, false, "cats.data.AndThen$", {
  Lcats_data_AndThen$: 1,
  Lcats_data_AndThenInstances0: 1,
  Lcats_data_AndThenInstances1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_AndThen$.prototype.$classData = $d_Lcats_data_AndThen$;
var $n_Lcats_data_AndThen$;
function $m_Lcats_data_AndThen$() {
  if ((!$n_Lcats_data_AndThen$)) {
    $n_Lcats_data_AndThen$ = new $c_Lcats_data_AndThen$()
  };
  return $n_Lcats_data_AndThen$
}
/** @constructor */
function $c_Lcats_data_Validated() {
  /*<skip>*/
}
$c_Lcats_data_Validated.prototype = new $h_O();
$c_Lcats_data_Validated.prototype.constructor = $c_Lcats_data_Validated;
/** @constructor */
function $h_Lcats_data_Validated() {
  /*<skip>*/
}
$h_Lcats_data_Validated.prototype = $c_Lcats_data_Validated.prototype;
$c_Lcats_data_Validated.prototype.product__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated = (function(fb, EE) {
  var x1 = $ct_T2__O__O__(new $c_T2(), this, fb);
  var p2 = $as_Lcats_data_Validated(x1.T2__f__1);
  var p3 = $as_Lcats_data_Validated(x1.T2__f__2);
  if ((p2 instanceof $c_Lcats_data_Validated$Valid)) {
    var x4 = $as_Lcats_data_Validated$Valid(p2);
    var a = $n(x4).Lcats_data_Validated$Valid__f_a;
    if ((p3 instanceof $c_Lcats_data_Validated$Valid)) {
      var x5 = $as_Lcats_data_Validated$Valid(p3);
      var b = $n(x5).Lcats_data_Validated$Valid__f_a;
      return new $c_Lcats_data_Validated$Valid($ct_T2__O__O__(new $c_T2(), a, b))
    }
  };
  var p6 = $as_Lcats_data_Validated(x1.T2__f__1);
  var p7 = $as_Lcats_data_Validated(x1.T2__f__2);
  if ((p6 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x8 = $as_Lcats_data_Validated$Invalid(p6);
    var e1 = $n(x8).Lcats_data_Validated$Invalid__f_e;
    if ((p7 instanceof $c_Lcats_data_Validated$Invalid)) {
      var x9 = $as_Lcats_data_Validated$Invalid(p7);
      var e2 = $n(x9).Lcats_data_Validated$Invalid__f_e;
      return new $c_Lcats_data_Validated$Invalid($n(EE).combine__O__O__O(e1, e2))
    }
  };
  var e = $as_Lcats_data_Validated(x1.T2__f__1);
  if ((e instanceof $c_Lcats_data_Validated$Invalid)) {
    var x11 = $as_Lcats_data_Validated$Invalid(e);
    return x11
  };
  var e$2 = $as_Lcats_data_Validated(x1.T2__f__2);
  if ((e$2 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x14 = $as_Lcats_data_Validated$Invalid(e$2);
    return x14
  };
  throw new $c_s_MatchError(x1)
});
$c_Lcats_data_Validated.prototype.map__F1__Lcats_data_Validated = (function(f) {
  if ((this instanceof $c_Lcats_data_Validated$Invalid)) {
    var x2 = $as_Lcats_data_Validated$Invalid(this);
    return x2
  } else if ((this instanceof $c_Lcats_data_Validated$Valid)) {
    var x4 = $as_Lcats_data_Validated$Valid(this);
    var a = $n(x4).Lcats_data_Validated$Valid__f_a;
    return new $c_Lcats_data_Validated$Valid($n(f).apply__O__O(a))
  } else {
    throw new $c_s_MatchError(this)
  }
});
$c_Lcats_data_Validated.prototype.combine__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_kernel_Semigroup__Lcats_data_Validated = (function(that, EE, AA) {
  if ((this instanceof $c_Lcats_data_Validated$Valid)) {
    var x4 = $as_Lcats_data_Validated$Valid(this);
    var a = $n(x4).Lcats_data_Validated$Valid__f_a;
    if ((that instanceof $c_Lcats_data_Validated$Valid)) {
      var x5 = $as_Lcats_data_Validated$Valid(that);
      var b = $n(x5).Lcats_data_Validated$Valid__f_a;
      return new $c_Lcats_data_Validated$Valid($n(AA).combine__O__O__O(a, b))
    }
  };
  if ((this instanceof $c_Lcats_data_Validated$Invalid)) {
    var x8 = $as_Lcats_data_Validated$Invalid(this);
    var a$2 = $n(x8).Lcats_data_Validated$Invalid__f_e;
    if ((that instanceof $c_Lcats_data_Validated$Invalid)) {
      var x9 = $as_Lcats_data_Validated$Invalid(that);
      var b$2 = $n(x9).Lcats_data_Validated$Invalid__f_e;
      return new $c_Lcats_data_Validated$Invalid($n(EE).combine__O__O__O(a$2, b$2))
    }
  };
  if ((this instanceof $c_Lcats_data_Validated$Invalid)) {
    return this
  };
  return that
});
function $as_Lcats_data_Validated(obj) {
  return (((obj instanceof $c_Lcats_data_Validated) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated"))
}
function $isArrayOf_Lcats_data_Validated(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated)))
}
function $asArrayOf_Lcats_data_Validated(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated;", depth))
}
function $f_Lcats_instances_EitherInstances__$init$__V($thiz) {
  $thiz.cats$instances$EitherInstances$_setter_$catsStdBitraverseForEither_$eq__Lcats_Bitraverse__V(new $c_Lcats_instances_EitherInstances$$anon$1($thiz))
}
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$9(outer) {
  this.Lcats_instances_Function1Instances$$anon$9__f_category = null;
  var instance = $n(outer).catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice();
  this.Lcats_instances_Function1Instances$$anon$9__f_category = instance
}
$c_Lcats_instances_Function1Instances$$anon$9.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$9.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$9;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$9() {
  /*<skip>*/
}
$h_Lcats_instances_Function1Instances$$anon$9.prototype = $c_Lcats_instances_Function1Instances$$anon$9.prototype;
$c_Lcats_instances_Function1Instances$$anon$9.prototype.combineK__F1__F1__F1 = (function(x, y) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen($as_F1($n(this.Lcats_instances_Function1Instances$$anon$9__f_category).compose__O__O__O(x, y)))
});
$c_Lcats_instances_Function1Instances$$anon$9.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this)
});
$c_Lcats_instances_Function1Instances$$anon$9.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__F1__F1__F1($as_F1(x), $as_F1(y))
});
$c_Lcats_instances_Function1Instances$$anon$9.prototype.empty__O = (function() {
  var this$1 = $n(this.Lcats_instances_Function1Instances$$anon$9__f_category);
  return $as_F1($f_Lcats_arrow_Arrow__id__O(this$1))
});
var $d_Lcats_instances_Function1Instances$$anon$9 = new $TypeData().initClass({
  Lcats_instances_Function1Instances$$anon$9: 0
}, false, "cats.instances.Function1Instances$$anon$9", {
  Lcats_instances_Function1Instances$$anon$9: 1,
  O: 1,
  Lcats_MonoidK: 1,
  Lcats_SemigroupK: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_Function1Instances$$anon$9.prototype.$classData = $d_Lcats_instances_Function1Instances$$anon$9;
/** @constructor */
function $c_Lcats_instances_HashInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_HashInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_HashInstances$$anon$1.prototype.constructor = $c_Lcats_instances_HashInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_HashInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_HashInstances$$anon$1.prototype = $c_Lcats_instances_HashInstances$$anon$1.prototype;
$c_Lcats_instances_HashInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var ha = $as_Lcats_kernel_Hash(fa);
  $n($m_Lcats_package$().Lcats_package$__f_Hash);
  return new $c_Lcats_kernel_Hash$$anon$1(ha, fi)
});
var $d_Lcats_instances_HashInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_HashInstances$$anon$1: 0
}, false, "cats.instances.HashInstances$$anon$1", {
  Lcats_instances_HashInstances$$anon$1: 1,
  O: 1,
  Lcats_Contravariant: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_HashInstances$$anon$1.prototype.$classData = $d_Lcats_instances_HashInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2(outer, fa$1, fb$1) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2__f_empty = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2__f_fa$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2__f_fb$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2__f_fa$1 = fa$1;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2__f_fb$1 = fb$1;
  var self = $n(fa$1).empty__O();
  var y = $n(fb$1).empty__O();
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2__f_empty = $ct_T2__O__O__(new $c_T2(), self, y)
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2.prototype.combine__T2__T2__T2 = (function(x, y) {
  var self = $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2__f_fa$1).combine__O__O__O($n(x)._1__O(), $n(y)._1__O());
  var y$1 = $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2__f_fb$1).combine__O__O__O($n(x)._2__O(), $n(y)._2__O());
  return $ct_T2__O__O__(new $c_T2(), self, y$1)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2($as_T2(x), $as_T2(y))
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2.prototype.empty__O = (function() {
  return this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2__f_empty
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$1$$anon$2", {
  Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3(outer, f$1, fa$2, g$1) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_f$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_fa$2 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_g$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_f$1 = f$1;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_fa$2 = fa$2;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_g$1 = g$1
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3.prototype.empty__O = (function() {
  return $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_f$1).apply__O__O($n(this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_fa$2).empty__O())
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3.prototype.combine__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_f$1).apply__O__O($n(this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_fa$2).combine__O__O__O($n(this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_g$1).apply__O__O(x), $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3__f_g$1).apply__O__O(y)))
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$1$$anon$3", {
  Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8(outer, fa$5, fb$3) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8__f_fa$5 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8__f_fb$3 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8__f_fa$5 = fa$5;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8__f_fb$3 = fb$3
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8.prototype.combine__T2__T2__T2 = (function(x, y) {
  var self = $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8__f_fa$5).combine__O__O__O($n(x)._1__O(), $n(y)._1__O());
  var y$1 = $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8__f_fb$3).combine__O__O__O($n(x)._2__O(), $n(y)._2__O());
  return $ct_T2__O__O__(new $c_T2(), self, y$1)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$7$$anon$8", {
  Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8: 1,
  O: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9(outer, f$3, fa$6, g$3) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_f$3 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_fa$6 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_g$3 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_f$3 = f$3;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_fa$6 = fa$6;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_g$3 = g$3
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9.prototype.combine__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_f$3).apply__O__O($n(this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_fa$6).combine__O__O__O($n(this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_g$3).apply__O__O(x), $n(this.Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9__f_g$3).apply__O__O(y)))
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$7$$anon$9", {
  Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9: 1,
  O: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9;
function $f_Lcats_instances_LazyListInstances__$init$__V($thiz) {
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Traverse__V(new $c_Lcats_instances_LazyListInstances$$anon$1($thiz));
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_LazyListInstances$$anon$3($thiz))
}
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$3(outer) {
  $n(outer).catsStdInstancesForLazyList__Lcats_Traverse()
}
$c_Lcats_instances_LazyListInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$3.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_LazyListInstances$$anon$3.prototype = $c_Lcats_instances_LazyListInstances$$anon$3.prototype;
var $d_Lcats_instances_LazyListInstances$$anon$3 = new $TypeData().initClass({
  Lcats_instances_LazyListInstances$$anon$3: 0
}, false, "cats.instances.LazyListInstances$$anon$3", {
  Lcats_instances_LazyListInstances$$anon$3: 1,
  O: 1,
  Lcats_TraverseFilter: 1,
  Lcats_FunctorFilter: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_LazyListInstances$$anon$3.prototype.$classData = $d_Lcats_instances_LazyListInstances$$anon$3;
function $f_Lcats_instances_ListInstances__$init$__V($thiz) {
  $thiz.cats$instances$ListInstances$_setter_$catsStdInstancesForList_$eq__Lcats_Traverse__V(new $c_Lcats_instances_ListInstances$$anon$1($thiz))
}
/** @constructor */
function $c_Lcats_instances_ListInstancesBinCompat0$$anon$6(outer) {
  $m_Lcats_instances_package$list$()
}
$c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype = new $h_O();
$c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype.constructor = $c_Lcats_instances_ListInstancesBinCompat0$$anon$6;
/** @constructor */
function $h_Lcats_instances_ListInstancesBinCompat0$$anon$6() {
  /*<skip>*/
}
$h_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype = $c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype;
var $d_Lcats_instances_ListInstancesBinCompat0$$anon$6 = new $TypeData().initClass({
  Lcats_instances_ListInstancesBinCompat0$$anon$6: 0
}, false, "cats.instances.ListInstancesBinCompat0$$anon$6", {
  Lcats_instances_ListInstancesBinCompat0$$anon$6: 1,
  O: 1,
  Lcats_TraverseFilter: 1,
  Lcats_FunctorFilter: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype.$classData = $d_Lcats_instances_ListInstancesBinCompat0$$anon$6;
/** @constructor */
function $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3(outer) {
  $m_Lcats_instances_package$option$()
}
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype = new $h_O();
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype.constructor = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3;
/** @constructor */
function $h_Lcats_instances_OptionInstancesBinCompat0$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype;
var $d_Lcats_instances_OptionInstancesBinCompat0$$anon$3 = new $TypeData().initClass({
  Lcats_instances_OptionInstancesBinCompat0$$anon$3: 0
}, false, "cats.instances.OptionInstancesBinCompat0$$anon$3", {
  Lcats_instances_OptionInstancesBinCompat0$$anon$3: 1,
  O: 1,
  Lcats_TraverseFilter: 1,
  Lcats_FunctorFilter: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype.$classData = $d_Lcats_instances_OptionInstancesBinCompat0$$anon$3;
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2(outer, fa$1, fb$1) {
  this.Lcats_instances_PartialOrderInstances$$anon$1$$anon$2__f_fa$1 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$1$$anon$2__f_fb$1 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$1$$anon$2__f_fa$1 = fa$1;
  this.Lcats_instances_PartialOrderInstances$$anon$1$$anon$2__f_fb$1 = fb$1
}
$c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2.prototype.partialCompare__T2__T2__D = (function(x, y) {
  var z = $n(this.Lcats_instances_PartialOrderInstances$$anon$1$$anon$2__f_fa$1).partialCompare__O__O__D($n(x)._1__O(), $n(y)._1__O());
  return ((z === 0.0) ? $n(this.Lcats_instances_PartialOrderInstances$$anon$1$$anon$2__f_fb$1).partialCompare__O__O__D($n(x)._2__O(), $n(y)._2__O()) : z)
});
$c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__T2__T2__D($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2 = new $TypeData().initClass({
  Lcats_instances_PartialOrderInstances$$anon$1$$anon$2: 0
}, false, "cats.instances.PartialOrderInstances$$anon$1$$anon$2", {
  Lcats_instances_PartialOrderInstances$$anon$1$$anon$2: 1,
  O: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2.prototype.$classData = $d_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2;
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2(outer, fa$1, f$1) {
  this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_fa$1 = null;
  this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_f$1 = null;
  this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_fa$1 = fa$1;
  this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_f$1 = f$1
}
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2.prototype;
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_PartialOrdering__equiv__O__O__Z(this, x, y)
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $n(this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_fa$1).lteq__O__O__Z($n(this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_f$1).apply__O__O(x), $n(this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_f$1).apply__O__O(y))
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $n(this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_fa$1).tryCompare__O__O__s_Option($n(this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_f$1).apply__O__O(x), $n(this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2__f_f$1).apply__O__O(y))
});
var $d_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2 = new $TypeData().initClass({
  Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2: 0
}, false, "cats.instances.PartialOrderingInstances$$anon$1$$anon$2", {
  Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2: 1,
  O: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2.prototype.$classData = $d_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2;
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3(outer, fa$2, fb$1) {
  this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3__f_fa$2 = null;
  this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3__f_fb$1 = null;
  this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3__f_fa$2 = fa$2;
  this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3__f_fb$1 = fb$1
}
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype;
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_PartialOrdering__equiv__O__O__Z(this, x, y)
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype.lteq__T2__T2__Z = (function(x, y) {
  var this$1 = $n(this.tryCompare__T2__T2__s_Option(x, y));
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var x$1 = $uI(arg1);
    return (x$1 <= 0)
  } else {
    return false
  }
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype.tryCompare__T2__T2__s_Option = (function(x, y) {
  var x1 = $n(this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3__f_fa$2).tryCompare__O__O__s_Option($n(x)._1__O(), $n(y)._1__O());
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var p3 = $uI($n(x2).s_Some__f_value);
    if ((p3 === 0)) {
      return $n(this.Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3__f_fb$1).tryCompare__O__O__s_Option($n(x)._2__O(), $n(y)._2__O())
    }
  };
  return x1
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return this.tryCompare__T2__T2__s_Option($as_T2(x), $as_T2(y))
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype.lteq__O__O__Z = (function(x, y) {
  return this.lteq__T2__T2__Z($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3 = new $TypeData().initClass({
  Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3: 0
}, false, "cats.instances.PartialOrderingInstances$$anon$1$$anon$3", {
  Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3: 1,
  O: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3.prototype.$classData = $d_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3;
function $f_Lcats_instances_QueueInstances__$init$__V($thiz) {
  $thiz.cats$instances$QueueInstances$_setter_$catsStdInstancesForQueue_$eq__Lcats_Traverse__V(new $c_Lcats_instances_QueueInstances$$anon$1($thiz))
}
function $f_Lcats_instances_SeqInstances__$init$__V($thiz) {
  $thiz.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Traverse__V(new $c_Lcats_instances_SeqInstances$$anon$1($thiz));
  $thiz.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_SeqInstances$$anon$2($thiz))
}
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$2(outer) {
  $m_Lcats_instances_package$seq$()
}
$c_Lcats_instances_SeqInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$2.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_SeqInstances$$anon$2.prototype = $c_Lcats_instances_SeqInstances$$anon$2.prototype;
var $d_Lcats_instances_SeqInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_SeqInstances$$anon$2: 0
}, false, "cats.instances.SeqInstances$$anon$2", {
  Lcats_instances_SeqInstances$$anon$2: 1,
  O: 1,
  Lcats_TraverseFilter: 1,
  Lcats_FunctorFilter: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_SeqInstances$$anon$2.prototype.$classData = $d_Lcats_instances_SeqInstances$$anon$2;
function $f_Lcats_instances_StreamInstances__$init$__V($thiz) {
  $thiz.cats$instances$StreamInstances$_setter_$catsStdInstancesForStream_$eq__Lcats_Traverse__V(new $c_Lcats_instances_StreamInstances$$anon$1($thiz))
}
/** @constructor */
function $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7(outer) {
  $m_Lcats_instances_package$stream$()
}
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype = new $h_O();
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype.constructor = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7;
/** @constructor */
function $h_Lcats_instances_StreamInstancesBinCompat0$$anon$7() {
  /*<skip>*/
}
$h_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype;
var $d_Lcats_instances_StreamInstancesBinCompat0$$anon$7 = new $TypeData().initClass({
  Lcats_instances_StreamInstancesBinCompat0$$anon$7: 0
}, false, "cats.instances.StreamInstancesBinCompat0$$anon$7", {
  Lcats_instances_StreamInstancesBinCompat0$$anon$7: 1,
  O: 1,
  Lcats_TraverseFilter: 1,
  Lcats_FunctorFilter: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype.$classData = $d_Lcats_instances_StreamInstancesBinCompat0$$anon$7;
/** @constructor */
function $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2(outer) {
  /*<skip>*/
}
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2.prototype = new $h_O();
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2.prototype.constructor = $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2;
/** @constructor */
function $h_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2.prototype = $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2.prototype;
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__T2__F1__T2($as_T2(fa), f)
});
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2.prototype.map__T2__F1__T2 = (function(fa, f) {
  return $ct_T2__O__O__(new $c_T2(), $n(f).apply__O__O($n(fa)._1__O()), $n(f).apply__O__O($n(fa)._2__O()))
});
var $d_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2 = new $TypeData().initClass({
  Lcats_instances_Tuple2InstancesBinCompat0$$anon$2: 0
}, false, "cats.instances.Tuple2InstancesBinCompat0$$anon$2", {
  Lcats_instances_Tuple2InstancesBinCompat0$$anon$2: 1,
  O: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2.prototype.$classData = $d_Lcats_instances_Tuple2InstancesBinCompat0$$anon$2;
function $f_Lcats_instances_VectorInstances__$init$__V($thiz) {
  $thiz.cats$instances$VectorInstances$_setter_$catsStdInstancesForVector_$eq__Lcats_Traverse__V(new $c_Lcats_instances_VectorInstances$$anon$1($thiz))
}
/** @constructor */
function $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6(outer) {
  $m_Lcats_instances_package$vector$()
}
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype = new $h_O();
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype.constructor = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6;
/** @constructor */
function $h_Lcats_instances_VectorInstancesBinCompat0$$anon$6() {
  /*<skip>*/
}
$h_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype;
var $d_Lcats_instances_VectorInstancesBinCompat0$$anon$6 = new $TypeData().initClass({
  Lcats_instances_VectorInstancesBinCompat0$$anon$6: 0
}, false, "cats.instances.VectorInstancesBinCompat0$$anon$6", {
  Lcats_instances_VectorInstancesBinCompat0$$anon$6: 1,
  O: 1,
  Lcats_TraverseFilter: 1,
  Lcats_FunctorFilter: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype.$classData = $d_Lcats_instances_VectorInstancesBinCompat0$$anon$6;
/** @constructor */
function $c_Lcats_instances_package$eq$() {
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = null;
  $n_Lcats_instances_package$eq$ = this;
  $f_Lcats_instances_EqInstances__$init$__V(this)
}
$c_Lcats_instances_package$eq$.prototype = new $h_O();
$c_Lcats_instances_package$eq$.prototype.constructor = $c_Lcats_instances_package$eq$;
/** @constructor */
function $h_Lcats_instances_package$eq$() {
  /*<skip>*/
}
$h_Lcats_instances_package$eq$.prototype = $c_Lcats_instances_package$eq$.prototype;
$c_Lcats_instances_package$eq$.prototype.cats$instances$EqInstances$_setter_$catsContravariantMonoidalForEq_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = x$1
});
var $d_Lcats_instances_package$eq$ = new $TypeData().initClass({
  Lcats_instances_package$eq$: 0
}, false, "cats.instances.package$eq$", {
  Lcats_instances_package$eq$: 1,
  O: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1
});
$c_Lcats_instances_package$eq$.prototype.$classData = $d_Lcats_instances_package$eq$;
var $n_Lcats_instances_package$eq$;
function $m_Lcats_instances_package$eq$() {
  if ((!$n_Lcats_instances_package$eq$)) {
    $n_Lcats_instances_package$eq$ = new $c_Lcats_instances_package$eq$()
  };
  return $n_Lcats_instances_package$eq$
}
/** @constructor */
function $c_Lcats_instances_package$order$() {
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = null;
  $n_Lcats_instances_package$order$ = this;
  $f_Lcats_instances_OrderInstances__$init$__V(this)
}
$c_Lcats_instances_package$order$.prototype = new $h_O();
$c_Lcats_instances_package$order$.prototype.constructor = $c_Lcats_instances_package$order$;
/** @constructor */
function $h_Lcats_instances_package$order$() {
  /*<skip>*/
}
$h_Lcats_instances_package$order$.prototype = $c_Lcats_instances_package$order$.prototype;
$c_Lcats_instances_package$order$.prototype.cats$instances$OrderInstances$_setter_$catsContravariantMonoidalForOrder_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = x$1
});
var $d_Lcats_instances_package$order$ = new $TypeData().initClass({
  Lcats_instances_package$order$: 0
}, false, "cats.instances.package$order$", {
  Lcats_instances_package$order$: 1,
  O: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1
});
$c_Lcats_instances_package$order$.prototype.$classData = $d_Lcats_instances_package$order$;
var $n_Lcats_instances_package$order$;
function $m_Lcats_instances_package$order$() {
  if ((!$n_Lcats_instances_package$order$)) {
    $n_Lcats_instances_package$order$ = new $c_Lcats_instances_package$order$()
  };
  return $n_Lcats_instances_package$order$
}
/** @constructor */
function $c_Lcats_instances_package$partialOrder$() {
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = null;
  $n_Lcats_instances_package$partialOrder$ = this;
  $f_Lcats_instances_PartialOrderInstances__$init$__V(this)
}
$c_Lcats_instances_package$partialOrder$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrder$.prototype.constructor = $c_Lcats_instances_package$partialOrder$;
/** @constructor */
function $h_Lcats_instances_package$partialOrder$() {
  /*<skip>*/
}
$h_Lcats_instances_package$partialOrder$.prototype = $c_Lcats_instances_package$partialOrder$.prototype;
$c_Lcats_instances_package$partialOrder$.prototype.cats$instances$PartialOrderInstances$_setter_$catsContravariantMonoidalForPartialOrder_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = x$1
});
var $d_Lcats_instances_package$partialOrder$ = new $TypeData().initClass({
  Lcats_instances_package$partialOrder$: 0
}, false, "cats.instances.package$partialOrder$", {
  Lcats_instances_package$partialOrder$: 1,
  O: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1
});
$c_Lcats_instances_package$partialOrder$.prototype.$classData = $d_Lcats_instances_package$partialOrder$;
var $n_Lcats_instances_package$partialOrder$;
function $m_Lcats_instances_package$partialOrder$() {
  if ((!$n_Lcats_instances_package$partialOrder$)) {
    $n_Lcats_instances_package$partialOrder$ = new $c_Lcats_instances_package$partialOrder$()
  };
  return $n_Lcats_instances_package$partialOrder$
}
function $ct_Lcats_kernel_Comparison__I__D__($thiz, toInt, toDouble) {
  return $thiz
}
/** @constructor */
function $c_Lcats_kernel_Comparison() {
  /*<skip>*/
}
$c_Lcats_kernel_Comparison.prototype = new $h_O();
$c_Lcats_kernel_Comparison.prototype.constructor = $c_Lcats_kernel_Comparison;
/** @constructor */
function $h_Lcats_kernel_Comparison() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison.prototype = $c_Lcats_kernel_Comparison.prototype;
/** @constructor */
function $c_Lcats_kernel_Hash$() {
  /*<skip>*/
}
$c_Lcats_kernel_Hash$.prototype = new $h_Lcats_kernel_HashFunctions();
$c_Lcats_kernel_Hash$.prototype.constructor = $c_Lcats_kernel_Hash$;
/** @constructor */
function $h_Lcats_kernel_Hash$() {
  /*<skip>*/
}
$h_Lcats_kernel_Hash$.prototype = $c_Lcats_kernel_Hash$.prototype;
var $d_Lcats_kernel_Hash$ = new $TypeData().initClass({
  Lcats_kernel_Hash$: 0
}, false, "cats.kernel.Hash$", {
  Lcats_kernel_Hash$: 1,
  Lcats_kernel_HashFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Hash$.prototype.$classData = $d_Lcats_kernel_Hash$;
var $n_Lcats_kernel_Hash$;
function $m_Lcats_kernel_Hash$() {
  if ((!$n_Lcats_kernel_Hash$)) {
    $n_Lcats_kernel_Hash$ = new $c_Lcats_kernel_Hash$()
  };
  return $n_Lcats_kernel_Hash$
}
/** @constructor */
function $c_Lcats_kernel_Hash$$anon$1(ev$1, f$1) {
  this.Lcats_kernel_Hash$$anon$1__f_ev$1 = null;
  this.Lcats_kernel_Hash$$anon$1__f_f$1 = null;
  this.Lcats_kernel_Hash$$anon$1__f_ev$1 = ev$1;
  this.Lcats_kernel_Hash$$anon$1__f_f$1 = f$1
}
$c_Lcats_kernel_Hash$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_Hash$$anon$1.prototype.constructor = $c_Lcats_kernel_Hash$$anon$1;
/** @constructor */
function $h_Lcats_kernel_Hash$$anon$1() {
  /*<skip>*/
}
$h_Lcats_kernel_Hash$$anon$1.prototype = $c_Lcats_kernel_Hash$$anon$1.prototype;
$c_Lcats_kernel_Hash$$anon$1.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Hash$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return $n(this.Lcats_kernel_Hash$$anon$1__f_ev$1).eqv__O__O__Z($n(this.Lcats_kernel_Hash$$anon$1__f_f$1).apply__O__O(x), $n(this.Lcats_kernel_Hash$$anon$1__f_f$1).apply__O__O(y))
});
var $d_Lcats_kernel_Hash$$anon$1 = new $TypeData().initClass({
  Lcats_kernel_Hash$$anon$1: 0
}, false, "cats.kernel.Hash$$anon$1", {
  Lcats_kernel_Hash$$anon$1: 1,
  O: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Hash$$anon$1.prototype.$classData = $d_Lcats_kernel_Hash$$anon$1;
function $f_Lcats_kernel_Order__partialCompare__O__O__D($thiz, x, y) {
  return $thiz.compare__O__O__I(x, y)
}
function $f_Lcats_kernel_Order__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0)
}
function $f_Lcats_kernel_Order__neqv__O__O__Z($thiz, x, y) {
  return (!$thiz.eqv__O__O__Z(x, y))
}
function $is_Lcats_kernel_Order(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Order)))
}
function $as_Lcats_kernel_Order(obj) {
  return (($is_Lcats_kernel_Order(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Order"))
}
function $isArrayOf_Lcats_kernel_Order(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Order)))
}
function $asArrayOf_Lcats_kernel_Order(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Order(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Order;", depth))
}
/** @constructor */
function $c_Lcats_kernel_PartialOrder$$anon$1(ev$1, f$1) {
  this.Lcats_kernel_PartialOrder$$anon$1__f_ev$1 = null;
  this.Lcats_kernel_PartialOrder$$anon$1__f_f$1 = null;
  this.Lcats_kernel_PartialOrder$$anon$1__f_ev$1 = ev$1;
  this.Lcats_kernel_PartialOrder$$anon$1__f_f$1 = f$1
}
$c_Lcats_kernel_PartialOrder$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.constructor = $c_Lcats_kernel_PartialOrder$$anon$1;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$$anon$1() {
  /*<skip>*/
}
$h_Lcats_kernel_PartialOrder$$anon$1.prototype = $c_Lcats_kernel_PartialOrder$$anon$1.prototype;
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.partialCompare__O__O__D = (function(x, y) {
  return $n(this.Lcats_kernel_PartialOrder$$anon$1__f_ev$1).partialCompare__O__O__D($n(this.Lcats_kernel_PartialOrder$$anon$1__f_f$1).apply__O__O(x), $n(this.Lcats_kernel_PartialOrder$$anon$1__f_f$1).apply__O__O(y))
});
var $d_Lcats_kernel_PartialOrder$$anon$1 = new $TypeData().initClass({
  Lcats_kernel_PartialOrder$$anon$1: 0
}, false, "cats.kernel.PartialOrder$$anon$1", {
  Lcats_kernel_PartialOrder$$anon$1: 1,
  O: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.$classData = $d_Lcats_kernel_PartialOrder$$anon$1;
/** @constructor */
function $c_Lcats_kernel_instances_LazyListMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_LazyListMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_LazyListMonoid.prototype.constructor = $c_Lcats_kernel_instances_LazyListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_LazyListMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_LazyListMonoid.prototype = $c_Lcats_kernel_instances_LazyListMonoid.prototype;
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_LazyList(x);
  var y$1 = $as_sci_LazyList(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_LazyList(y$1)
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.empty__O = (function() {
  return $n($m_s_package$().s_package$__f_LazyList).sci_LazyList$__f__empty
});
var $d_Lcats_kernel_instances_LazyListMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_LazyListMonoid: 0
}, false, "cats.kernel.instances.LazyListMonoid", {
  Lcats_kernel_instances_LazyListMonoid: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.$classData = $d_Lcats_kernel_instances_LazyListMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_ListMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ListMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_ListMonoid.prototype.constructor = $c_Lcats_kernel_instances_ListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_ListMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ListMonoid.prototype = $c_Lcats_kernel_instances_ListMonoid.prototype;
$c_Lcats_kernel_instances_ListMonoid.prototype.combine__sci_List__sci_List__sci_List = (function(x, y) {
  return $n(y).$colon$colon$colon__sci_List__sci_List(x)
});
$c_Lcats_kernel_instances_ListMonoid.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__sci_List__sci_List__sci_List($as_sci_List(x), $as_sci_List(y))
});
$c_Lcats_kernel_instances_ListMonoid.prototype.empty__O = (function() {
  return $m_sci_Nil$()
});
var $d_Lcats_kernel_instances_ListMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_ListMonoid: 0
}, false, "cats.kernel.instances.ListMonoid", {
  Lcats_kernel_instances_ListMonoid: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_instances_ListMonoid.prototype.$classData = $d_Lcats_kernel_instances_ListMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_QueueMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_QueueMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_QueueMonoid.prototype.constructor = $c_Lcats_kernel_instances_QueueMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_QueueMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_QueueMonoid.prototype = $c_Lcats_kernel_instances_QueueMonoid.prototype;
$c_Lcats_kernel_instances_QueueMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Queue(x);
  var y$1 = $as_sci_Queue(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Queue(y$1)
});
$c_Lcats_kernel_instances_QueueMonoid.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$()
});
var $d_Lcats_kernel_instances_QueueMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_QueueMonoid: 0
}, false, "cats.kernel.instances.QueueMonoid", {
  Lcats_kernel_instances_QueueMonoid: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_instances_QueueMonoid.prototype.$classData = $d_Lcats_kernel_instances_QueueMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_SeqMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_SeqMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_SeqMonoid.prototype.constructor = $c_Lcats_kernel_instances_SeqMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_SeqMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_SeqMonoid.prototype = $c_Lcats_kernel_instances_SeqMonoid.prototype;
$c_Lcats_kernel_instances_SeqMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Seq(x);
  var y$1 = $as_sci_Seq(y);
  var this$1 = $n(x$1);
  return $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(y$1))
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.empty__O = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps())
});
var $d_Lcats_kernel_instances_SeqMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_SeqMonoid: 0
}, false, "cats.kernel.instances.SeqMonoid", {
  Lcats_kernel_instances_SeqMonoid: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.$classData = $d_Lcats_kernel_instances_SeqMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_StreamMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_StreamMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StreamMonoid.prototype.constructor = $c_Lcats_kernel_instances_StreamMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StreamMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StreamMonoid.prototype = $c_Lcats_kernel_instances_StreamMonoid.prototype;
$c_Lcats_kernel_instances_StreamMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Stream(x);
  var y$1 = $as_sci_Stream(y);
  var this$1 = $n(x$1);
  return $as_sci_Stream($f_sc_IterableOps__concat__sc_IterableOnce__O(this$1, y$1))
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.empty__O = (function() {
  $n($m_s_package$().s_package$__f_Stream);
  return $m_sci_Stream$Empty$()
});
var $d_Lcats_kernel_instances_StreamMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_StreamMonoid: 0
}, false, "cats.kernel.instances.StreamMonoid", {
  Lcats_kernel_instances_StreamMonoid: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.$classData = $d_Lcats_kernel_instances_StreamMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_StringMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_StringMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StringMonoid.prototype.constructor = $c_Lcats_kernel_instances_StringMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StringMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StringMonoid.prototype = $c_Lcats_kernel_instances_StringMonoid.prototype;
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__T__T__T = (function(x, y) {
  return (("" + x) + y)
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T__T__T($as_T(x), $as_T(y))
});
$c_Lcats_kernel_instances_StringMonoid.prototype.empty__O = (function() {
  return ""
});
var $d_Lcats_kernel_instances_StringMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_StringMonoid: 0
}, false, "cats.kernel.instances.StringMonoid", {
  Lcats_kernel_instances_StringMonoid: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_instances_StringMonoid.prototype.$classData = $d_Lcats_kernel_instances_StringMonoid;
/** @constructor */
function $c_Lcats_kernel_instances_VectorMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_VectorMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_VectorMonoid.prototype.constructor = $c_Lcats_kernel_instances_VectorMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_VectorMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_VectorMonoid.prototype = $c_Lcats_kernel_instances_VectorMonoid.prototype;
$c_Lcats_kernel_instances_VectorMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Vector(x);
  var y$1 = $as_sci_Vector(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Vector(y$1)
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.empty__O = (function() {
  $n($m_s_package$().s_package$__f_Vector);
  return $m_sci_Vector0$()
});
var $d_Lcats_kernel_instances_VectorMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_VectorMonoid: 0
}, false, "cats.kernel.instances.VectorMonoid", {
  Lcats_kernel_instances_VectorMonoid: 1,
  O: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.$classData = $d_Lcats_kernel_instances_VectorMonoid;
/** @constructor */
function $c_Lcats_syntax_package$functor$() {
  /*<skip>*/
}
$c_Lcats_syntax_package$functor$.prototype = new $h_O();
$c_Lcats_syntax_package$functor$.prototype.constructor = $c_Lcats_syntax_package$functor$;
/** @constructor */
function $h_Lcats_syntax_package$functor$() {
  /*<skip>*/
}
$h_Lcats_syntax_package$functor$.prototype = $c_Lcats_syntax_package$functor$.prototype;
var $d_Lcats_syntax_package$functor$ = new $TypeData().initClass({
  Lcats_syntax_package$functor$: 0
}, false, "cats.syntax.package$functor$", {
  Lcats_syntax_package$functor$: 1,
  O: 1,
  Lcats_syntax_FunctorSyntax: 1,
  Lcats_Functor$ToFunctorOps: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_syntax_package$functor$.prototype.$classData = $d_Lcats_syntax_package$functor$;
var $n_Lcats_syntax_package$functor$;
function $m_Lcats_syntax_package$functor$() {
  if ((!$n_Lcats_syntax_package$functor$)) {
    $n_Lcats_syntax_package$functor$ = new $c_Lcats_syntax_package$functor$()
  };
  return $n_Lcats_syntax_package$functor$
}
/** @constructor */
function $c_Lcom_iz2use_common_FailableImplicit(value) {
  this.Lcom_iz2use_common_FailableImplicit__f_value = null;
  this.Lcom_iz2use_common_FailableImplicit__f_value = value
}
$c_Lcom_iz2use_common_FailableImplicit.prototype = new $h_O();
$c_Lcom_iz2use_common_FailableImplicit.prototype.constructor = $c_Lcom_iz2use_common_FailableImplicit;
/** @constructor */
function $h_Lcom_iz2use_common_FailableImplicit() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_FailableImplicit.prototype = $c_Lcom_iz2use_common_FailableImplicit.prototype;
$c_Lcom_iz2use_common_FailableImplicit.prototype.productPrefix__T = (function() {
  return "FailableImplicit"
});
$c_Lcom_iz2use_common_FailableImplicit.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_common_FailableImplicit.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_common_FailableImplicit__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_common_FailableImplicit.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_FailableImplicit.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_common_FailableImplicit.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_FailableImplicit.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_FailableImplicit)) {
    var FailableImplicit$1 = $as_Lcom_iz2use_common_FailableImplicit(x$1);
    var x = this.Lcom_iz2use_common_FailableImplicit__f_value;
    var x$2 = $n(FailableImplicit$1).Lcom_iz2use_common_FailableImplicit__f_value;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_FailableImplicit(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_FailableImplicit) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.FailableImplicit"))
}
function $isArrayOf_Lcom_iz2use_common_FailableImplicit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_FailableImplicit)))
}
function $asArrayOf_Lcom_iz2use_common_FailableImplicit(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_FailableImplicit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.FailableImplicit;", depth))
}
var $d_Lcom_iz2use_common_FailableImplicit = new $TypeData().initClass({
  Lcom_iz2use_common_FailableImplicit: 0
}, false, "com.iz2use.common.FailableImplicit", {
  Lcom_iz2use_common_FailableImplicit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_FailableImplicit.prototype.$classData = $d_Lcom_iz2use_common_FailableImplicit;
/** @constructor */
function $c_Lcom_iz2use_common_MappedTypedRange(fromRange, toRange, doubleFromT, doubleToU, numericU) {
  this.Lcom_iz2use_common_MappedTypedRange__f_fromRange = null;
  this.Lcom_iz2use_common_MappedTypedRange__f_toRange = null;
  this.Lcom_iz2use_common_MappedTypedRange__f_doubleFromT = null;
  this.Lcom_iz2use_common_MappedTypedRange__f_doubleToU = null;
  this.Lcom_iz2use_common_MappedTypedRange__f_fromAmplitude = 0.0;
  this.Lcom_iz2use_common_MappedTypedRange__f_fromOffset = 0.0;
  this.Lcom_iz2use_common_MappedTypedRange__f_toAmplitude = 0.0;
  this.Lcom_iz2use_common_MappedTypedRange__f_toOffset = 0.0;
  this.Lcom_iz2use_common_MappedTypedRange__f_fromRange = fromRange;
  this.Lcom_iz2use_common_MappedTypedRange__f_toRange = toRange;
  this.Lcom_iz2use_common_MappedTypedRange__f_doubleFromT = doubleFromT;
  this.Lcom_iz2use_common_MappedTypedRange__f_doubleToU = doubleToU;
  this.Lcom_iz2use_common_MappedTypedRange__f_fromAmplitude = ($uD($n(doubleFromT).apply__O__O($n(fromRange).Lcom_iz2use_common_TypedRange__f_until)) - $uD($n(doubleFromT).apply__O__O($n(fromRange).Lcom_iz2use_common_TypedRange__f_from)));
  this.Lcom_iz2use_common_MappedTypedRange__f_fromOffset = $uD($n(doubleFromT).apply__O__O($n(fromRange).Lcom_iz2use_common_TypedRange__f_from));
  this.Lcom_iz2use_common_MappedTypedRange__f_toAmplitude = ($n(numericU).toDouble__O__D($n(toRange).Lcom_iz2use_common_TypedRange__f_until) - $n(numericU).toDouble__O__D($n(toRange).Lcom_iz2use_common_TypedRange__f_from));
  this.Lcom_iz2use_common_MappedTypedRange__f_toOffset = $n(numericU).toDouble__O__D($n(toRange).Lcom_iz2use_common_TypedRange__f_from)
}
$c_Lcom_iz2use_common_MappedTypedRange.prototype = new $h_O();
$c_Lcom_iz2use_common_MappedTypedRange.prototype.constructor = $c_Lcom_iz2use_common_MappedTypedRange;
/** @constructor */
function $h_Lcom_iz2use_common_MappedTypedRange() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_MappedTypedRange.prototype = $c_Lcom_iz2use_common_MappedTypedRange.prototype;
$c_Lcom_iz2use_common_MappedTypedRange.prototype.apply__O__O = (function(value) {
  var normalized = $n(this.Lcom_iz2use_common_MappedTypedRange__f_fromRange).normalizeValue__O__O(value);
  var offsetT = ($uD($n(this.Lcom_iz2use_common_MappedTypedRange__f_doubleFromT).apply__O__O(normalized)) - this.Lcom_iz2use_common_MappedTypedRange__f_fromOffset);
  var offsetU = (((offsetT * this.Lcom_iz2use_common_MappedTypedRange__f_toAmplitude) / this.Lcom_iz2use_common_MappedTypedRange__f_fromAmplitude) + this.Lcom_iz2use_common_MappedTypedRange__f_toOffset);
  return $n(this.Lcom_iz2use_common_MappedTypedRange__f_doubleToU).apply__O__O(offsetU)
});
$c_Lcom_iz2use_common_MappedTypedRange.prototype.productPrefix__T = (function() {
  return "MappedTypedRange"
});
$c_Lcom_iz2use_common_MappedTypedRange.prototype.productArity__I = (function() {
  return 4
});
$c_Lcom_iz2use_common_MappedTypedRange.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_common_MappedTypedRange__f_fromRange;
      break
    }
    case 1: {
      return this.Lcom_iz2use_common_MappedTypedRange__f_toRange;
      break
    }
    case 2: {
      return this.Lcom_iz2use_common_MappedTypedRange__f_doubleFromT;
      break
    }
    case 3: {
      return this.Lcom_iz2use_common_MappedTypedRange__f_doubleToU;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_common_MappedTypedRange.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_MappedTypedRange.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_common_MappedTypedRange.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_MappedTypedRange.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_MappedTypedRange)) {
    var MappedTypedRange$1 = $as_Lcom_iz2use_common_MappedTypedRange(x$1);
    var x = this.Lcom_iz2use_common_MappedTypedRange__f_fromRange;
    var x$2 = $n(MappedTypedRange$1).Lcom_iz2use_common_MappedTypedRange__f_fromRange;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_common_MappedTypedRange__f_toRange;
      var x$4 = $n(MappedTypedRange$1).Lcom_iz2use_common_MappedTypedRange__f_toRange;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_common_MappedTypedRange__f_doubleFromT;
      var x$6 = $n(MappedTypedRange$1).Lcom_iz2use_common_MappedTypedRange__f_doubleFromT;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lcom_iz2use_common_MappedTypedRange__f_doubleToU;
        var x$8 = $n(MappedTypedRange$1).Lcom_iz2use_common_MappedTypedRange__f_doubleToU;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_MappedTypedRange(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_MappedTypedRange) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.MappedTypedRange"))
}
function $isArrayOf_Lcom_iz2use_common_MappedTypedRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_MappedTypedRange)))
}
function $asArrayOf_Lcom_iz2use_common_MappedTypedRange(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_MappedTypedRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.MappedTypedRange;", depth))
}
var $d_Lcom_iz2use_common_MappedTypedRange = new $TypeData().initClass({
  Lcom_iz2use_common_MappedTypedRange: 0
}, false, "com.iz2use.common.MappedTypedRange", {
  Lcom_iz2use_common_MappedTypedRange: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_MappedTypedRange.prototype.$classData = $d_Lcom_iz2use_common_MappedTypedRange;
/** @constructor */
function $c_Lcom_iz2use_common_MaybeImplicit(value) {
  this.Lcom_iz2use_common_MaybeImplicit__f_value = null;
  this.Lcom_iz2use_common_MaybeImplicit__f_value = value
}
$c_Lcom_iz2use_common_MaybeImplicit.prototype = new $h_O();
$c_Lcom_iz2use_common_MaybeImplicit.prototype.constructor = $c_Lcom_iz2use_common_MaybeImplicit;
/** @constructor */
function $h_Lcom_iz2use_common_MaybeImplicit() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_MaybeImplicit.prototype = $c_Lcom_iz2use_common_MaybeImplicit.prototype;
$c_Lcom_iz2use_common_MaybeImplicit.prototype.productPrefix__T = (function() {
  return "MaybeImplicit"
});
$c_Lcom_iz2use_common_MaybeImplicit.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_common_MaybeImplicit.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_common_MaybeImplicit__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_common_MaybeImplicit.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_MaybeImplicit.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_common_MaybeImplicit.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_MaybeImplicit.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_MaybeImplicit)) {
    var MaybeImplicit$1 = $as_Lcom_iz2use_common_MaybeImplicit(x$1);
    var x = this.Lcom_iz2use_common_MaybeImplicit__f_value;
    var x$2 = $n(MaybeImplicit$1).Lcom_iz2use_common_MaybeImplicit__f_value;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_MaybeImplicit(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_MaybeImplicit) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.MaybeImplicit"))
}
function $isArrayOf_Lcom_iz2use_common_MaybeImplicit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_MaybeImplicit)))
}
function $asArrayOf_Lcom_iz2use_common_MaybeImplicit(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_MaybeImplicit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.MaybeImplicit;", depth))
}
var $d_Lcom_iz2use_common_MaybeImplicit = new $TypeData().initClass({
  Lcom_iz2use_common_MaybeImplicit: 0
}, false, "com.iz2use.common.MaybeImplicit", {
  Lcom_iz2use_common_MaybeImplicit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_MaybeImplicit.prototype.$classData = $d_Lcom_iz2use_common_MaybeImplicit;
/** @constructor */
function $c_Lcom_iz2use_common_Multiline(underlying) {
  this.Lcom_iz2use_common_Multiline__f_underlying = null;
  this.Lcom_iz2use_common_Multiline__f_underlying = underlying
}
$c_Lcom_iz2use_common_Multiline.prototype = new $h_O();
$c_Lcom_iz2use_common_Multiline.prototype.constructor = $c_Lcom_iz2use_common_Multiline;
/** @constructor */
function $h_Lcom_iz2use_common_Multiline() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Multiline.prototype = $c_Lcom_iz2use_common_Multiline.prototype;
$c_Lcom_iz2use_common_Multiline.prototype.productPrefix__T = (function() {
  return "Multiline"
});
$c_Lcom_iz2use_common_Multiline.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_common_Multiline.prototype.productElement__I__O = (function(x$1) {
  return $m_Lcom_iz2use_common_Multiline$().productElement$extension__T__I__O(this.Lcom_iz2use_common_Multiline__f_underlying, x$1)
});
$c_Lcom_iz2use_common_Multiline.prototype.productIterator__sc_Iterator = (function() {
  return $m_Lcom_iz2use_common_Multiline$().productIterator$extension__T__sc_Iterator(this.Lcom_iz2use_common_Multiline__f_underlying)
});
$c_Lcom_iz2use_common_Multiline.prototype.hashCode__I = (function() {
  var this$ = this.Lcom_iz2use_common_Multiline__f_underlying;
  return $f_T__hashCode__I($n(this$))
});
$c_Lcom_iz2use_common_Multiline.prototype.equals__O__Z = (function(x$1) {
  return $m_Lcom_iz2use_common_Multiline$().equals$extension__T__O__Z(this.Lcom_iz2use_common_Multiline__f_underlying, x$1)
});
$c_Lcom_iz2use_common_Multiline.prototype.toString__T = (function() {
  return $m_Lcom_iz2use_common_Multiline$().toString$extension__T__T(this.Lcom_iz2use_common_Multiline__f_underlying)
});
function $as_Lcom_iz2use_common_Multiline(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_Multiline) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.Multiline"))
}
function $isArrayOf_Lcom_iz2use_common_Multiline(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_Multiline)))
}
function $asArrayOf_Lcom_iz2use_common_Multiline(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_Multiline(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.Multiline;", depth))
}
var $d_Lcom_iz2use_common_Multiline = new $TypeData().initClass({
  Lcom_iz2use_common_Multiline: 0
}, false, "com.iz2use.common.Multiline", {
  Lcom_iz2use_common_Multiline: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Multiline.prototype.$classData = $d_Lcom_iz2use_common_Multiline;
/** @constructor */
function $c_Lcom_iz2use_common_Parsable$$anon$1(outer, f$1, g$1) {
  this.Lcom_iz2use_common_Parsable$$anon$1__f_$outer = null;
  this.Lcom_iz2use_common_Parsable$$anon$1__f_f$1 = null;
  this.Lcom_iz2use_common_Parsable$$anon$1__f_g$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_common_Parsable$$anon$1__f_$outer = outer
  };
  this.Lcom_iz2use_common_Parsable$$anon$1__f_f$1 = f$1;
  this.Lcom_iz2use_common_Parsable$$anon$1__f_g$1 = g$1
}
$c_Lcom_iz2use_common_Parsable$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_common_Parsable$$anon$1.prototype.constructor = $c_Lcom_iz2use_common_Parsable$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_common_Parsable$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Parsable$$anon$1.prototype = $c_Lcom_iz2use_common_Parsable$$anon$1.prototype;
$c_Lcom_iz2use_common_Parsable$$anon$1.prototype.parse__T__s_util_Try = (function(in$1) {
  return $n($n(this.Lcom_iz2use_common_Parsable$$anon$1__f_$outer).parse__T__s_util_Try(in$1)).map__F1__s_util_Try(this.Lcom_iz2use_common_Parsable$$anon$1__f_f$1)
});
$c_Lcom_iz2use_common_Parsable$$anon$1.prototype.stringify__O__T = (function(value) {
  return $n(this.Lcom_iz2use_common_Parsable$$anon$1__f_$outer).stringify__O__T($n(this.Lcom_iz2use_common_Parsable$$anon$1__f_g$1).apply__O__O(value))
});
var $d_Lcom_iz2use_common_Parsable$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_common_Parsable$$anon$1: 0
}, false, "com.iz2use.common.Parsable$$anon$1", {
  Lcom_iz2use_common_Parsable$$anon$1: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Parsable$$anon$1.prototype.$classData = $d_Lcom_iz2use_common_Parsable$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_common_Parsable$$anon$2(parser$1, stringifier$1) {
  this.Lcom_iz2use_common_Parsable$$anon$2__f_parser$1 = null;
  this.Lcom_iz2use_common_Parsable$$anon$2__f_stringifier$1 = null;
  this.Lcom_iz2use_common_Parsable$$anon$2__f_parser$1 = parser$1;
  this.Lcom_iz2use_common_Parsable$$anon$2__f_stringifier$1 = stringifier$1
}
$c_Lcom_iz2use_common_Parsable$$anon$2.prototype = new $h_O();
$c_Lcom_iz2use_common_Parsable$$anon$2.prototype.constructor = $c_Lcom_iz2use_common_Parsable$$anon$2;
/** @constructor */
function $h_Lcom_iz2use_common_Parsable$$anon$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Parsable$$anon$2.prototype = $c_Lcom_iz2use_common_Parsable$$anon$2.prototype;
$c_Lcom_iz2use_common_Parsable$$anon$2.prototype.parse__T__s_util_Try = (function(in$1) {
  return $as_s_util_Try($n(this.Lcom_iz2use_common_Parsable$$anon$2__f_parser$1).apply__O__O(in$1))
});
$c_Lcom_iz2use_common_Parsable$$anon$2.prototype.stringify__O__T = (function(value) {
  return $as_T($n(this.Lcom_iz2use_common_Parsable$$anon$2__f_stringifier$1).apply__O__O(value))
});
var $d_Lcom_iz2use_common_Parsable$$anon$2 = new $TypeData().initClass({
  Lcom_iz2use_common_Parsable$$anon$2: 0
}, false, "com.iz2use.common.Parsable$$anon$2", {
  Lcom_iz2use_common_Parsable$$anon$2: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Parsable$$anon$2.prototype.$classData = $d_Lcom_iz2use_common_Parsable$$anon$2;
/** @constructor */
function $c_Lcom_iz2use_common_Parsable$$anon$3(ev$1) {
  this.Lcom_iz2use_common_Parsable$$anon$3__f_ev$1 = null;
  this.Lcom_iz2use_common_Parsable$$anon$3__f_ev$1 = ev$1
}
$c_Lcom_iz2use_common_Parsable$$anon$3.prototype = new $h_O();
$c_Lcom_iz2use_common_Parsable$$anon$3.prototype.constructor = $c_Lcom_iz2use_common_Parsable$$anon$3;
/** @constructor */
function $h_Lcom_iz2use_common_Parsable$$anon$3() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Parsable$$anon$3.prototype = $c_Lcom_iz2use_common_Parsable$$anon$3.prototype;
$c_Lcom_iz2use_common_Parsable$$anon$3.prototype.parse__T__s_util_Try = (function(in$1) {
  var this$1 = $n(in$1);
  if ((this$1 === "")) {
    return new $c_s_util_Success($m_s_None$())
  } else {
    return $n($n(this.Lcom_iz2use_common_Parsable$$anon$3__f_ev$1).parse__T__s_util_Try(in$1)).map__F1__s_util_Try(new $c_sjsr_AnonFunction1(((x$3$2) => new $c_s_Some(x$3$2))))
  }
});
$c_Lcom_iz2use_common_Parsable$$anon$3.prototype.stringify__s_Option__T = (function(value) {
  var x = $m_s_None$();
  if ((x === value)) {
    return ""
  } else if ((value instanceof $c_s_Some)) {
    var x3 = $as_s_Some(value);
    var value$2 = $n(x3).s_Some__f_value;
    return $n(this.Lcom_iz2use_common_Parsable$$anon$3__f_ev$1).stringify__O__T(value$2)
  } else {
    throw new $c_s_MatchError(value)
  }
});
$c_Lcom_iz2use_common_Parsable$$anon$3.prototype.stringify__O__T = (function(value) {
  return this.stringify__s_Option__T($as_s_Option(value))
});
var $d_Lcom_iz2use_common_Parsable$$anon$3 = new $TypeData().initClass({
  Lcom_iz2use_common_Parsable$$anon$3: 0
}, false, "com.iz2use.common.Parsable$$anon$3", {
  Lcom_iz2use_common_Parsable$$anon$3: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Parsable$$anon$3.prototype.$classData = $d_Lcom_iz2use_common_Parsable$$anon$3;
/** @constructor */
function $c_Lcom_iz2use_common_Parsable$$anon$4(reference$1) {
  this.Lcom_iz2use_common_Parsable$$anon$4__f_other = null;
  this.Lcom_iz2use_common_Parsable$$anon$4__f_reference$1 = null;
  this.Lcom_iz2use_common_Parsable$$anon$4__f_reference$1 = reference$1;
  this.Lcom_iz2use_common_Parsable$$anon$4__f_other = new $c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1(this)
}
$c_Lcom_iz2use_common_Parsable$$anon$4.prototype = new $h_O();
$c_Lcom_iz2use_common_Parsable$$anon$4.prototype.constructor = $c_Lcom_iz2use_common_Parsable$$anon$4;
/** @constructor */
function $h_Lcom_iz2use_common_Parsable$$anon$4() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Parsable$$anon$4.prototype = $c_Lcom_iz2use_common_Parsable$$anon$4.prototype;
$c_Lcom_iz2use_common_Parsable$$anon$4.prototype.parse__T__s_util_Try = (function(input) {
  var this$1 = $m_Lcom_iz2use_common_TimeParser$();
  var reference = $as_Ljava_time_LocalDate($n(this.Lcom_iz2use_common_Parsable$$anon$4__f_reference$1).apply__O());
  var this$3 = new $c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1(this$1, reference);
  var k = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Ljava_time_LocalDate(x$9$2);
    return new $c_s_util_Success(x$9)
  }));
  return $as_s_util_Try($n($n($f_s_PartialFunction__andThen__F1__s_PartialFunction(this$3, k)).orElse__s_PartialFunction__s_PartialFunction(this.Lcom_iz2use_common_Parsable$$anon$4__f_other)).apply__O__O($f_T__trim__T($n(input))))
});
$c_Lcom_iz2use_common_Parsable$$anon$4.prototype.stringify__O__T = (function(value) {
  var date = $as_Ljava_time_LocalDate(value);
  return $n($m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate).stringify__O__T(date)
});
var $d_Lcom_iz2use_common_Parsable$$anon$4 = new $TypeData().initClass({
  Lcom_iz2use_common_Parsable$$anon$4: 0
}, false, "com.iz2use.common.Parsable$$anon$4", {
  Lcom_iz2use_common_Parsable$$anon$4: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Parsable$$anon$4.prototype.$classData = $d_Lcom_iz2use_common_Parsable$$anon$4;
/** @constructor */
function $c_Lcom_iz2use_common_TokenMatch(searchToken, itemToken, index) {
  this.Lcom_iz2use_common_TokenMatch__f_searchToken = null;
  this.Lcom_iz2use_common_TokenMatch__f_itemToken = null;
  this.Lcom_iz2use_common_TokenMatch__f_index = 0;
  this.Lcom_iz2use_common_TokenMatch__f_searchToken = searchToken;
  this.Lcom_iz2use_common_TokenMatch__f_itemToken = itemToken;
  this.Lcom_iz2use_common_TokenMatch__f_index = index
}
$c_Lcom_iz2use_common_TokenMatch.prototype = new $h_O();
$c_Lcom_iz2use_common_TokenMatch.prototype.constructor = $c_Lcom_iz2use_common_TokenMatch;
/** @constructor */
function $h_Lcom_iz2use_common_TokenMatch() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TokenMatch.prototype = $c_Lcom_iz2use_common_TokenMatch.prototype;
$c_Lcom_iz2use_common_TokenMatch.prototype.productPrefix__T = (function() {
  return "TokenMatch"
});
$c_Lcom_iz2use_common_TokenMatch.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_common_TokenMatch.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_common_TokenMatch__f_searchToken;
      break
    }
    case 1: {
      return this.Lcom_iz2use_common_TokenMatch__f_itemToken;
      break
    }
    case 2: {
      return this.Lcom_iz2use_common_TokenMatch__f_index;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_common_TokenMatch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_TokenMatch.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TokenMatch");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_common_TokenMatch__f_searchToken;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lcom_iz2use_common_TokenMatch__f_itemToken;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lcom_iz2use_common_TokenMatch__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lcom_iz2use_common_TokenMatch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_TokenMatch.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_TokenMatch)) {
    var TokenMatch$1 = $as_Lcom_iz2use_common_TokenMatch(x$1);
    if ((this.Lcom_iz2use_common_TokenMatch__f_index === $n(TokenMatch$1).Lcom_iz2use_common_TokenMatch__f_index)) {
      var x = this.Lcom_iz2use_common_TokenMatch__f_searchToken;
      var x$2 = $n(TokenMatch$1).Lcom_iz2use_common_TokenMatch__f_searchToken;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lcom_iz2use_common_TokenMatch__f_itemToken;
        var x$4 = $n(TokenMatch$1).Lcom_iz2use_common_TokenMatch__f_itemToken;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_TokenMatch(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_TokenMatch) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.TokenMatch"))
}
function $isArrayOf_Lcom_iz2use_common_TokenMatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_TokenMatch)))
}
function $asArrayOf_Lcom_iz2use_common_TokenMatch(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_TokenMatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.TokenMatch;", depth))
}
var $d_Lcom_iz2use_common_TokenMatch = new $TypeData().initClass({
  Lcom_iz2use_common_TokenMatch: 0
}, false, "com.iz2use.common.TokenMatch", {
  Lcom_iz2use_common_TokenMatch: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_TokenMatch.prototype.$classData = $d_Lcom_iz2use_common_TokenMatch;
/** @constructor */
function $c_Lcom_iz2use_common_TokenMatches(matches, tokenized, score) {
  this.Lcom_iz2use_common_TokenMatches__f_matches = null;
  this.Lcom_iz2use_common_TokenMatches__f_tokenized = null;
  this.Lcom_iz2use_common_TokenMatches__f_score = 0.0;
  this.Lcom_iz2use_common_TokenMatches__f_matches = matches;
  this.Lcom_iz2use_common_TokenMatches__f_tokenized = tokenized;
  this.Lcom_iz2use_common_TokenMatches__f_score = score
}
$c_Lcom_iz2use_common_TokenMatches.prototype = new $h_O();
$c_Lcom_iz2use_common_TokenMatches.prototype.constructor = $c_Lcom_iz2use_common_TokenMatches;
/** @constructor */
function $h_Lcom_iz2use_common_TokenMatches() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TokenMatches.prototype = $c_Lcom_iz2use_common_TokenMatches.prototype;
$c_Lcom_iz2use_common_TokenMatches.prototype.productPrefix__T = (function() {
  return "TokenMatches"
});
$c_Lcom_iz2use_common_TokenMatches.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_common_TokenMatches.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_common_TokenMatches__f_matches;
      break
    }
    case 1: {
      return this.Lcom_iz2use_common_TokenMatches__f_tokenized;
      break
    }
    case 2: {
      return this.Lcom_iz2use_common_TokenMatches__f_score;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_common_TokenMatches.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_TokenMatches.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TokenMatches");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_common_TokenMatches__f_matches;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lcom_iz2use_common_TokenMatches__f_tokenized;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv = this.Lcom_iz2use_common_TokenMatches__f_score;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lcom_iz2use_common_TokenMatches.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_TokenMatches.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_TokenMatches)) {
    var TokenMatches$1 = $as_Lcom_iz2use_common_TokenMatches(x$1);
    if ((this.Lcom_iz2use_common_TokenMatches__f_score === $n(TokenMatches$1).Lcom_iz2use_common_TokenMatches__f_score)) {
      var x = this.Lcom_iz2use_common_TokenMatches__f_matches;
      var x$2 = $n(TokenMatches$1).Lcom_iz2use_common_TokenMatches__f_matches;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lcom_iz2use_common_TokenMatches__f_tokenized;
        var x$4 = $n(TokenMatches$1).Lcom_iz2use_common_TokenMatches__f_tokenized;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_TokenMatches(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_TokenMatches) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.TokenMatches"))
}
function $isArrayOf_Lcom_iz2use_common_TokenMatches(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_TokenMatches)))
}
function $asArrayOf_Lcom_iz2use_common_TokenMatches(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_TokenMatches(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.TokenMatches;", depth))
}
var $d_Lcom_iz2use_common_TokenMatches = new $TypeData().initClass({
  Lcom_iz2use_common_TokenMatches: 0
}, false, "com.iz2use.common.TokenMatches", {
  Lcom_iz2use_common_TokenMatches: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_TokenMatches.prototype.$classData = $d_Lcom_iz2use_common_TokenMatches;
/** @constructor */
function $c_Lcom_iz2use_common_TypedRange(from, until, orderingT) {
  this.Lcom_iz2use_common_TypedRange__f_from = null;
  this.Lcom_iz2use_common_TypedRange__f_until = null;
  this.Lcom_iz2use_common_TypedRange__f_orderingT = null;
  this.Lcom_iz2use_common_TypedRange__f_from = from;
  this.Lcom_iz2use_common_TypedRange__f_until = until;
  this.Lcom_iz2use_common_TypedRange__f_orderingT = orderingT
}
$c_Lcom_iz2use_common_TypedRange.prototype = new $h_O();
$c_Lcom_iz2use_common_TypedRange.prototype.constructor = $c_Lcom_iz2use_common_TypedRange;
/** @constructor */
function $h_Lcom_iz2use_common_TypedRange() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TypedRange.prototype = $c_Lcom_iz2use_common_TypedRange.prototype;
$c_Lcom_iz2use_common_TypedRange.prototype.normalizeValue__O__O = (function(value) {
  return ($n(this.Lcom_iz2use_common_TypedRange__f_orderingT).lt__O__O__Z(value, this.Lcom_iz2use_common_TypedRange__f_from) ? this.Lcom_iz2use_common_TypedRange__f_from : ($n(this.Lcom_iz2use_common_TypedRange__f_orderingT).lt__O__O__Z(this.Lcom_iz2use_common_TypedRange__f_until, value) ? this.Lcom_iz2use_common_TypedRange__f_until : value))
});
$c_Lcom_iz2use_common_TypedRange.prototype.$plus__O__Lcom_iz2use_common_TypedRange = (function(value) {
  if ($n(this.Lcom_iz2use_common_TypedRange__f_orderingT).lt__O__O__Z(value, this.Lcom_iz2use_common_TypedRange__f_from)) {
    var until = this.Lcom_iz2use_common_TypedRange__f_until;
    var orderingT = this.Lcom_iz2use_common_TypedRange__f_orderingT;
    return new $c_Lcom_iz2use_common_TypedRange(value, until, orderingT)
  } else if ($n(this.Lcom_iz2use_common_TypedRange__f_orderingT).lt__O__O__Z(this.Lcom_iz2use_common_TypedRange__f_until, value)) {
    var x$2 = this.Lcom_iz2use_common_TypedRange__f_from;
    var orderingT$1 = this.Lcom_iz2use_common_TypedRange__f_orderingT;
    return new $c_Lcom_iz2use_common_TypedRange(x$2, value, orderingT$1)
  } else {
    return this
  }
});
$c_Lcom_iz2use_common_TypedRange.prototype.extendsWith__O__O__Lcom_iz2use_common_TypedRange = (function(from2, until2) {
  var from = $n(this.Lcom_iz2use_common_TypedRange__f_orderingT).min__O__O__O(this.Lcom_iz2use_common_TypedRange__f_from, from2);
  var until = $n(this.Lcom_iz2use_common_TypedRange__f_orderingT).max__O__O__O(this.Lcom_iz2use_common_TypedRange__f_until, until2);
  var orderingT = this.Lcom_iz2use_common_TypedRange__f_orderingT;
  return new $c_Lcom_iz2use_common_TypedRange(from, until, orderingT)
});
$c_Lcom_iz2use_common_TypedRange.prototype.contains__O__Z = (function(value) {
  return ($n(this.Lcom_iz2use_common_TypedRange__f_orderingT).lteq__O__O__Z(this.Lcom_iz2use_common_TypedRange__f_from, value) && $n(this.Lcom_iz2use_common_TypedRange__f_orderingT).lt__O__O__Z(value, this.Lcom_iz2use_common_TypedRange__f_until))
});
$c_Lcom_iz2use_common_TypedRange.prototype.intersects__O__O__Z = (function(from2, until2) {
  return ($n(this.Lcom_iz2use_common_TypedRange__f_orderingT).lt__O__O__Z(this.Lcom_iz2use_common_TypedRange__f_from, until2) && $n(this.Lcom_iz2use_common_TypedRange__f_orderingT).lt__O__O__Z(from2, this.Lcom_iz2use_common_TypedRange__f_until))
});
$c_Lcom_iz2use_common_TypedRange.prototype.productPrefix__T = (function() {
  return "TypedRange"
});
$c_Lcom_iz2use_common_TypedRange.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_common_TypedRange.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_common_TypedRange__f_from;
      break
    }
    case 1: {
      return this.Lcom_iz2use_common_TypedRange__f_until;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_common_TypedRange.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_TypedRange.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_common_TypedRange.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_TypedRange.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_TypedRange)) {
    var TypedRange$1 = $as_Lcom_iz2use_common_TypedRange(x$1);
    var x = this.Lcom_iz2use_common_TypedRange__f_from;
    var y = $n(TypedRange$1).Lcom_iz2use_common_TypedRange__f_from;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lcom_iz2use_common_TypedRange__f_until;
      var y$1 = $n(TypedRange$1).Lcom_iz2use_common_TypedRange__f_until;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_TypedRange(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_TypedRange) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.TypedRange"))
}
function $isArrayOf_Lcom_iz2use_common_TypedRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_TypedRange)))
}
function $asArrayOf_Lcom_iz2use_common_TypedRange(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_TypedRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.TypedRange;", depth))
}
var $d_Lcom_iz2use_common_TypedRange = new $TypeData().initClass({
  Lcom_iz2use_common_TypedRange: 0
}, false, "com.iz2use.common.TypedRange", {
  Lcom_iz2use_common_TypedRange: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_TypedRange.prototype.$classData = $d_Lcom_iz2use_common_TypedRange;
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_Token(repr, start, end) {
  this.Lcom_iz2use_common_internal_tokenizer_Token__f_repr = null;
  this.Lcom_iz2use_common_internal_tokenizer_Token__f_start = 0;
  this.Lcom_iz2use_common_internal_tokenizer_Token__f_end = 0;
  this.Lcom_iz2use_common_internal_tokenizer_Token__f_repr = repr;
  this.Lcom_iz2use_common_internal_tokenizer_Token__f_start = start;
  this.Lcom_iz2use_common_internal_tokenizer_Token__f_end = end
}
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_Token;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_Token() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_Token.prototype = $c_Lcom_iz2use_common_internal_tokenizer_Token.prototype;
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype.productPrefix__T = (function() {
  return "Token"
});
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_common_internal_tokenizer_Token__f_repr;
      break
    }
    case 1: {
      return this.Lcom_iz2use_common_internal_tokenizer_Token__f_start;
      break
    }
    case 2: {
      return this.Lcom_iz2use_common_internal_tokenizer_Token__f_end;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Token");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_common_internal_tokenizer_Token__f_repr;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcom_iz2use_common_internal_tokenizer_Token__f_start;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lcom_iz2use_common_internal_tokenizer_Token__f_end;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_internal_tokenizer_Token)) {
    var Token$1 = $as_Lcom_iz2use_common_internal_tokenizer_Token(x$1);
    return ((this.Lcom_iz2use_common_internal_tokenizer_Token__f_start === $n(Token$1).Lcom_iz2use_common_internal_tokenizer_Token__f_start) && ((this.Lcom_iz2use_common_internal_tokenizer_Token__f_end === $n(Token$1).Lcom_iz2use_common_internal_tokenizer_Token__f_end) && (this.Lcom_iz2use_common_internal_tokenizer_Token__f_repr === $n(Token$1).Lcom_iz2use_common_internal_tokenizer_Token__f_repr)))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_internal_tokenizer_Token(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_internal_tokenizer_Token) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.internal.tokenizer.Token"))
}
function $isArrayOf_Lcom_iz2use_common_internal_tokenizer_Token(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_internal_tokenizer_Token)))
}
function $asArrayOf_Lcom_iz2use_common_internal_tokenizer_Token(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_internal_tokenizer_Token(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.internal.tokenizer.Token;", depth))
}
var $d_Lcom_iz2use_common_internal_tokenizer_Token = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_Token: 0
}, false, "com.iz2use.common.internal.tokenizer.Token", {
  Lcom_iz2use_common_internal_tokenizer_Token: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_Token.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_Token;
function $p_Lcom_iz2use_common_package$__Normalizer$lzycompute$1__V($thiz) {
  if (($m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_Normalizer$module === null)) {
    $m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_Normalizer$module = new $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$($thiz)
  }
}
/** @constructor */
function $c_Lcom_iz2use_common_package$() {
  this.Lcom_iz2use_common_package$__f_Tokenizer = null;
  this.Lcom_iz2use_common_package$__f_Normalizer$module = null;
  this.Lcom_iz2use_common_package$__f_reuseKey = null;
  $n_Lcom_iz2use_common_package$ = this;
  $f_Lcom_iz2use_common_PlatformSpecifics__$init$__V(this);
  this.Lcom_iz2use_common_package$__f_Tokenizer = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$()
}
$c_Lcom_iz2use_common_package$.prototype = new $h_O();
$c_Lcom_iz2use_common_package$.prototype.constructor = $c_Lcom_iz2use_common_package$;
/** @constructor */
function $h_Lcom_iz2use_common_package$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_package$.prototype = $c_Lcom_iz2use_common_package$.prototype;
$c_Lcom_iz2use_common_package$.prototype.Normalizer__Lcom_iz2use_common_PlatformSpecifics$Normalizer$ = (function() {
  if (($m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_Normalizer$module === null)) {
    $p_Lcom_iz2use_common_package$__Normalizer$lzycompute$1__V(this)
  };
  return $m_Lcom_iz2use_common_package$().Lcom_iz2use_common_package$__f_Normalizer$module
});
var $d_Lcom_iz2use_common_package$ = new $TypeData().initClass({
  Lcom_iz2use_common_package$: 0
}, false, "com.iz2use.common.package$", {
  Lcom_iz2use_common_package$: 1,
  O: 1,
  Lcom_iz2use_common_KeyImports: 1,
  Lcom_iz2use_common_TraversableImplicits: 1,
  Lcom_iz2use_common_PlatformSpecifics: 1
});
$c_Lcom_iz2use_common_package$.prototype.$classData = $d_Lcom_iz2use_common_package$;
var $n_Lcom_iz2use_common_package$;
function $m_Lcom_iz2use_common_package$() {
  if ((!$n_Lcom_iz2use_common_package$)) {
    $n_Lcom_iz2use_common_package$ = new $c_Lcom_iz2use_common_package$()
  };
  return $n_Lcom_iz2use_common_package$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Dialog$Placeholder$Props() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype.constructor = $c_Lcom_iz2use_react_components_Dialog$Placeholder$Props;
/** @constructor */
function $h_Lcom_iz2use_react_components_Dialog$Placeholder$Props() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype = $c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype;
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_Dialog$Placeholder$Props)
});
function $as_Lcom_iz2use_react_components_Dialog$Placeholder$Props(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Dialog$Placeholder$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Dialog$Placeholder$Props"))
}
function $isArrayOf_Lcom_iz2use_react_components_Dialog$Placeholder$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Dialog$Placeholder$Props)))
}
function $asArrayOf_Lcom_iz2use_react_components_Dialog$Placeholder$Props(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Dialog$Placeholder$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Dialog$Placeholder$Props;", depth))
}
var $d_Lcom_iz2use_react_components_Dialog$Placeholder$Props = new $TypeData().initClass({
  Lcom_iz2use_react_components_Dialog$Placeholder$Props: 0
}, false, "com.iz2use.react.components.Dialog$Placeholder$Props", {
  Lcom_iz2use_react_components_Dialog$Placeholder$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Dialog$Placeholder$Props.prototype.$classData = $d_Lcom_iz2use_react_components_Dialog$Placeholder$Props;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$Props(renderFn, request, reusableC, reusableT, ec) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_renderFn = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_request = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_reusableC = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_reusableT = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_ec = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_renderFn = renderFn;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_request = request;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_reusableC = reusableC;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_reusableT = reusableT;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_ec = ec
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$Props;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$Props() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_renderFn;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_request;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Props)) {
    var Props$1 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Props(x$1);
    var x = this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_renderFn;
    var x$2 = $n(Props$1).Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_renderFn;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_request;
      var x$4 = $n(Props$1).Lcom_iz2use_react_components_FetchCacheAndRender$Props__f_request;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$Props(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$Props"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$Props)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Props(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$Props;", depth))
}
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$Props = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$Props: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$Props", {
  Lcom_iz2use_react_components_FetchCacheAndRender$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Props.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$Props;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(criterion, expandQuery, fetcher, updateCache) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_criterion = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_expandQuery = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_fetcher = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_updateCache = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_criterion = criterion;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_expandQuery = expandQuery;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_fetcher = fetcher;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_updateCache = updateCache
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype.productPrefix__T = (function() {
  return "QueryRequest"
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype.productArity__I = (function() {
  return 4
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_criterion;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_expandQuery;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_fetcher;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_updateCache;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest)) {
    var QueryRequest$1 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(x$1);
    var x = this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_criterion;
    var y = $n(QueryRequest$1).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_criterion;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_expandQuery;
      var x$2$1 = $n(QueryRequest$1).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_expandQuery;
      if ((x$2 === null)) {
        var $$x1 = (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        var $$x1 = (this$1 === x$2$1)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_fetcher;
      var x$4 = $n(QueryRequest$1).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_fetcher;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_updateCache;
        var x$6 = $n(QueryRequest$1).Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest__f_updateCache;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$2 = $n(x$5);
          return (this$2 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$QueryRequest"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$QueryRequest;", depth))
}
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$QueryRequest", {
  Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$QueryRequest;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(data, criterion, updateCache) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data = data;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion = criterion;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache = updateCache
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype.productPrefix__T = (function() {
  return "QueryState"
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState)) {
    var QueryState$1 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(x$1);
    var x = this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data;
    var x$2 = $n(QueryState$1).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_data;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
      var y = $n(QueryState$1).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_criterion;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y)) {
        var x$3$1 = this.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache;
        var x$4 = $n(QueryState$1).Lcom_iz2use_react_components_FetchCacheAndRender$QueryState__f_updateCache;
        if ((x$3$1 === null)) {
          return (x$4 === null)
        } else {
          var this$1 = $n(x$3$1);
          return (this$1 === x$4)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$QueryState"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$QueryState)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$QueryState;", depth))
}
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$QueryState: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$QueryState", {
  Lcom_iz2use_react_components_FetchCacheAndRender$QueryState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$QueryState;
/** @constructor */
function $c_Lcom_iz2use_react_components_Gesture$Props(events, cbo) {
  this.Lcom_iz2use_react_components_Gesture$Props__f_events = null;
  this.Lcom_iz2use_react_components_Gesture$Props__f_cbo = null;
  this.Lcom_iz2use_react_components_Gesture$Props__f_events = events;
  this.Lcom_iz2use_react_components_Gesture$Props__f_cbo = cbo
}
$c_Lcom_iz2use_react_components_Gesture$Props.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Gesture$Props.prototype.constructor = $c_Lcom_iz2use_react_components_Gesture$Props;
/** @constructor */
function $h_Lcom_iz2use_react_components_Gesture$Props() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Gesture$Props.prototype = $c_Lcom_iz2use_react_components_Gesture$Props.prototype;
$c_Lcom_iz2use_react_components_Gesture$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lcom_iz2use_react_components_Gesture$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_Gesture$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_Gesture$Props__f_events;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_Gesture$Props__f_cbo;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_Gesture$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Gesture$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_Gesture$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_Gesture$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_Gesture$Props)) {
    var Props$1 = $as_Lcom_iz2use_react_components_Gesture$Props(x$1);
    var x = this.Lcom_iz2use_react_components_Gesture$Props__f_events;
    var x$2 = $n(Props$1).Lcom_iz2use_react_components_Gesture$Props__f_events;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_Gesture$Props__f_cbo;
      var x$4 = $n(Props$1).Lcom_iz2use_react_components_Gesture$Props__f_cbo;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_Gesture$Props(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Gesture$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Gesture$Props"))
}
function $isArrayOf_Lcom_iz2use_react_components_Gesture$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Gesture$Props)))
}
function $asArrayOf_Lcom_iz2use_react_components_Gesture$Props(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Gesture$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Gesture$Props;", depth))
}
var $d_Lcom_iz2use_react_components_Gesture$Props = new $TypeData().initClass({
  Lcom_iz2use_react_components_Gesture$Props: 0
}, false, "com.iz2use.react.components.Gesture$Props", {
  Lcom_iz2use_react_components_Gesture$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Gesture$Props.prototype.$classData = $d_Lcom_iz2use_react_components_Gesture$Props;
/** @constructor */
function $c_Lcom_iz2use_react_components_LinkedViews$Props(close) {
  this.Lcom_iz2use_react_components_LinkedViews$Props__f_close = null;
  this.Lcom_iz2use_react_components_LinkedViews$Props__f_close = close
}
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype = new $h_O();
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype.constructor = $c_Lcom_iz2use_react_components_LinkedViews$Props;
/** @constructor */
function $h_Lcom_iz2use_react_components_LinkedViews$Props() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_LinkedViews$Props.prototype = $c_Lcom_iz2use_react_components_LinkedViews$Props.prototype;
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_LinkedViews$Props__f_close : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_LinkedViews$Props)) {
    var Props$1 = $as_Lcom_iz2use_react_components_LinkedViews$Props(x$1);
    var x = this.Lcom_iz2use_react_components_LinkedViews$Props__f_close;
    var x$2 = $n(Props$1).Lcom_iz2use_react_components_LinkedViews$Props__f_close;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Props$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_LinkedViews$Props(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_LinkedViews$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.LinkedViews$Props"))
}
function $isArrayOf_Lcom_iz2use_react_components_LinkedViews$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_LinkedViews$Props)))
}
function $asArrayOf_Lcom_iz2use_react_components_LinkedViews$Props(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_LinkedViews$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.LinkedViews$Props;", depth))
}
var $d_Lcom_iz2use_react_components_LinkedViews$Props = new $TypeData().initClass({
  Lcom_iz2use_react_components_LinkedViews$Props: 0
}, false, "com.iz2use.react.components.LinkedViews$Props", {
  Lcom_iz2use_react_components_LinkedViews$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_LinkedViews$Props.prototype.$classData = $d_Lcom_iz2use_react_components_LinkedViews$Props;
/** @constructor */
function $c_Lcom_iz2use_react_components_Multiview$TypedProps(isItemCollection, source, views, defaultView, updater, filter, tokenMatcher, highlighter, active, state, sourceHandler, hasIterator, keyMapper, asMap, fields, tokenizer, decorator, proposedSorts, proposedSearches, itemSimpleActions, reusabilityT, reusabilityC, orderViews) {
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_isItemCollection = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_source = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_views = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_defaultView = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_updater = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_filter = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_tokenMatcher = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_highlighter = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_active = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_state = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_sourceHandler = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_hasIterator = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_keyMapper = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_asMap = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_fields = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_tokenizer = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_decorator = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_itemSimpleActions = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_reusabilityT = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_reusabilityC = null;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_isItemCollection = isItemCollection;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_source = source;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_views = views;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_defaultView = defaultView;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_updater = updater;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_filter = filter;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_tokenMatcher = tokenMatcher;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_highlighter = highlighter;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_active = active;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_state = state;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_sourceHandler = sourceHandler;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_hasIterator = hasIterator;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_keyMapper = keyMapper;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_asMap = asMap;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_fields = fields;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_tokenizer = tokenizer;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_decorator = decorator;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_itemSimpleActions = itemSimpleActions;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_reusabilityT = reusabilityT;
  this.Lcom_iz2use_react_components_Multiview$TypedProps__f_reusabilityC = reusabilityC
}
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_Multiview$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_Multiview$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Multiview$TypedProps.prototype = $c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype;
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype.productArity__I = (function() {
  return 10
});
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_isItemCollection;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_source;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_views;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_defaultView;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_updater;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_filter;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_tokenMatcher;
      break
    }
    case 7: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_highlighter;
      break
    }
    case 8: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_active;
      break
    }
    case 9: {
      return this.Lcom_iz2use_react_components_Multiview$TypedProps__f_state;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_Multiview$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_Multiview$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_isItemCollection;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_isItemCollection;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_source;
      var y = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_source;
      var $$x2 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3$1 = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_views;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_views;
      if (((x$3$1 === null) ? (x$4 === null) : $n(x$3$1).equals__O__Z(x$4))) {
        var x$5 = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_defaultView;
        var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_defaultView;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var x$7 = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_updater;
          var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_updater;
          var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_filter;
      var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_filter;
      if ((x$9 === null)) {
        var $$x4 = (x$10 === null)
      } else {
        var this$1 = $n(x$9);
        var $$x4 = (this$1 === x$10)
      };
      if ($$x4) {
        var x$11 = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_tokenMatcher;
        var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_tokenMatcher;
        if ((x$11 === null)) {
          var $$x3 = (x$12 === null)
        } else {
          var this$2 = $n(x$11);
          var $$x3 = (this$2 === x$12)
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$13 = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_highlighter;
        var x$14 = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_highlighter;
        if ((x$13 === null)) {
          var $$x5 = (x$14 === null)
        } else {
          var this$3 = $n(x$13);
          var $$x5 = (this$3 === x$14)
        };
        if ($$x5) {
          var x$15 = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_active;
          var x$16 = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_active;
          if ((x$15 === null)) {
            var $$x6 = (x$16 === null)
          } else {
            var this$4 = $n(x$15);
            var $$x6 = (this$4 === x$16)
          };
          if ($$x6) {
            var x$17 = this.Lcom_iz2use_react_components_Multiview$TypedProps__f_state;
            var x$18 = $n(TypedProps$1).Lcom_iz2use_react_components_Multiview$TypedProps__f_state;
            if ((x$17 === null)) {
              return (x$18 === null)
            } else {
              var this$5 = $n(x$17);
              return (this$5 === x$18)
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_Multiview$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Multiview$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Multiview$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_Multiview$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Multiview$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_Multiview$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Multiview$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Multiview$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_Multiview$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_Multiview$TypedProps: 0
}, false, "com.iz2use.react.components.Multiview$TypedProps", {
  Lcom_iz2use_react_components_Multiview$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Multiview$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_Multiview$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_Multiview$TypedState(content, view) {
  this.Lcom_iz2use_react_components_Multiview$TypedState__f_content = null;
  this.Lcom_iz2use_react_components_Multiview$TypedState__f_view = null;
  this.Lcom_iz2use_react_components_Multiview$TypedState__f_content = content;
  this.Lcom_iz2use_react_components_Multiview$TypedState__f_view = view
}
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_Multiview$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_Multiview$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Multiview$TypedState.prototype = $c_Lcom_iz2use_react_components_Multiview$TypedState.prototype;
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_Multiview$TypedState__f_content;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_Multiview$TypedState__f_view;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_Multiview$TypedState)) {
    var TypedState$1 = $as_Lcom_iz2use_react_components_Multiview$TypedState(x$1);
    var x = this.Lcom_iz2use_react_components_Multiview$TypedState__f_content;
    var x$2 = $n(TypedState$1).Lcom_iz2use_react_components_Multiview$TypedState__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_Multiview$TypedState__f_view;
      var x$4 = $n(TypedState$1).Lcom_iz2use_react_components_Multiview$TypedState__f_view;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_Multiview$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Multiview$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Multiview$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_Multiview$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Multiview$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_Multiview$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Multiview$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Multiview$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_Multiview$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_Multiview$TypedState: 0
}, false, "com.iz2use.react.components.Multiview$TypedState", {
  Lcom_iz2use_react_components_Multiview$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Multiview$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_Multiview$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_Multiview$ZBackend(\u03b4) {
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_updateFn = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_context = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_refiner = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_sourceChange = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_viewState = null;
  this.Lcom_iz2use_react_components_Multiview$ZTypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_Multiview$ZBackend__f_$ = null;
  this.Lcom_iz2use_react_components_Multiview$ZBackend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_Multiview$ZTypedBackend__(this)
}
$c_Lcom_iz2use_react_components_Multiview$ZBackend.prototype = new $h_Lcom_iz2use_react_components_Multiview$ZTypedBackend();
$c_Lcom_iz2use_react_components_Multiview$ZBackend.prototype.constructor = $c_Lcom_iz2use_react_components_Multiview$ZBackend;
/** @constructor */
function $h_Lcom_iz2use_react_components_Multiview$ZBackend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Multiview$ZBackend.prototype = $c_Lcom_iz2use_react_components_Multiview$ZBackend.prototype;
var $d_Lcom_iz2use_react_components_Multiview$ZBackend = new $TypeData().initClass({
  Lcom_iz2use_react_components_Multiview$ZBackend: 0
}, false, "com.iz2use.react.components.Multiview$ZBackend", {
  Lcom_iz2use_react_components_Multiview$ZBackend: 1,
  Lcom_iz2use_react_components_Multiview$ZTypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_Multiview$ZBackend.prototype.$classData = $d_Lcom_iz2use_react_components_Multiview$ZBackend;
/** @constructor */
function $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend(outer, \u03b4) {
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__f_$outer = null;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend__Lcom_iz2use_react_components_MultiviewRefinerReactComponent__(this, outer)
}
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend.prototype = new $h_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend();
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend.prototype = $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend.prototype;
var $d_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend: 0
}, false, "com.iz2use.react.components.MultiviewRefinerReactComponent$Backend", {
  Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend: 1,
  Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_PlatformDependent$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_PlatformDependent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_PlatformDependent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_PlatformDependent$Backend.prototype = new $h_Lcom_iz2use_react_components_PlatformDependent$TypedBackend();
$c_Lcom_iz2use_react_components_PlatformDependent$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_PlatformDependent$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_PlatformDependent$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_PlatformDependent$Backend.prototype = $c_Lcom_iz2use_react_components_PlatformDependent$Backend.prototype;
var $d_Lcom_iz2use_react_components_PlatformDependent$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_PlatformDependent$Backend: 0
}, false, "com.iz2use.react.components.PlatformDependent$Backend", {
  Lcom_iz2use_react_components_PlatformDependent$Backend: 1,
  Lcom_iz2use_react_components_PlatformDependent$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_PlatformDependent$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_PlatformDependent$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_PlatformDependent$TypedProps(f, render) {
  this.Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_f = null;
  this.Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_render = null;
  this.Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_f = f;
  this.Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_render = render
}
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_PlatformDependent$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_PlatformDependent$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype = $c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype;
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_f;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_render;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_PlatformDependent$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_PlatformDependent$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_f;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_f;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_render;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_PlatformDependent$TypedProps__f_render;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_PlatformDependent$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_PlatformDependent$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.PlatformDependent$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_PlatformDependent$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_PlatformDependent$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_PlatformDependent$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_PlatformDependent$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.PlatformDependent$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_PlatformDependent$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_PlatformDependent$TypedProps: 0
}, false, "com.iz2use.react.components.PlatformDependent$TypedProps", {
  Lcom_iz2use_react_components_PlatformDependent$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_PlatformDependent$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_PlatformDependent$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_Selector$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_Selector$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_Selector$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_Selector$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_Selector$Backend.prototype = new $h_Lcom_iz2use_react_components_Selector$TypedBackend();
$c_Lcom_iz2use_react_components_Selector$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$Backend.prototype = $c_Lcom_iz2use_react_components_Selector$Backend.prototype;
var $d_Lcom_iz2use_react_components_Selector$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$Backend: 0
}, false, "com.iz2use.react.components.Selector$Backend", {
  Lcom_iz2use_react_components_Selector$Backend: 1,
  Lcom_iz2use_react_components_Selector$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_Selector$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$TypedProps(items, active, renderItem, modifier, label, deleteable, ev, out, keyMapper) {
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_items = null;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_active = null;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_renderItem = null;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_modifier = null;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_label = null;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_deleteable = false;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_ev = null;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_out = null;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper = null;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_items = items;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_active = active;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_renderItem = renderItem;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_modifier = modifier;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_label = label;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_deleteable = deleteable;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_ev = ev;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_out = out;
  this.Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper = keyMapper
}
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$TypedProps.prototype = $c_Lcom_iz2use_react_components_Selector$TypedProps.prototype;
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype.productArity__I = (function() {
  return 6
});
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_Selector$TypedProps__f_items;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_Selector$TypedProps__f_active;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_Selector$TypedProps__f_renderItem;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_Selector$TypedProps__f_modifier;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_Selector$TypedProps__f_label;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_Selector$TypedProps__f_deleteable;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_react_components_Selector$TypedProps__f_items;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lcom_iz2use_react_components_Selector$TypedProps__f_active;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lcom_iz2use_react_components_Selector$TypedProps__f_renderItem;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lcom_iz2use_react_components_Selector$TypedProps__f_modifier;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lcom_iz2use_react_components_Selector$TypedProps__f_label;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lcom_iz2use_react_components_Selector$TypedProps__f_deleteable ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_Selector$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_Selector$TypedProps(x$1);
    if ((this.Lcom_iz2use_react_components_Selector$TypedProps__f_deleteable === $n(TypedProps$1).Lcom_iz2use_react_components_Selector$TypedProps__f_deleteable)) {
      var x = this.Lcom_iz2use_react_components_Selector$TypedProps__f_items;
      var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_Selector$TypedProps__f_items;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lcom_iz2use_react_components_Selector$TypedProps__f_active;
        var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_Selector$TypedProps__f_active;
        if ((x$3 === null)) {
          var $$x1 = (x$4 === null)
        } else {
          var this$1 = $n(x$3);
          var $$x1 = (this$1 === x$4)
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_react_components_Selector$TypedProps__f_renderItem;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_Selector$TypedProps__f_renderItem;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lcom_iz2use_react_components_Selector$TypedProps__f_modifier;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_Selector$TypedProps__f_modifier;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lcom_iz2use_react_components_Selector$TypedProps__f_label;
          var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_Selector$TypedProps__f_label;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_Selector$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Selector$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Selector$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_Selector$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Selector$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_Selector$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Selector$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Selector$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_Selector$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$TypedProps: 0
}, false, "com.iz2use.react.components.Selector$TypedProps", {
  Lcom_iz2use_react_components_Selector$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Selector$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props(size, f) {
  this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_size = 0;
  this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_f = null;
  this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_size = size;
  this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_f = f
}
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype.constructor = $c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props;
/** @constructor */
function $h_Lcom_iz2use_react_components_Skeleton$RandomSize$Props() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype = $c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype;
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_size;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_size;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_f;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props)) {
    var Props$1 = $as_Lcom_iz2use_react_components_Skeleton$RandomSize$Props(x$1);
    if ((this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_size === $n(Props$1).Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_size)) {
      var x = this.Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_f;
      var x$2 = $n(Props$1).Lcom_iz2use_react_components_Skeleton$RandomSize$Props__f_f;
      if ((x === null)) {
        return (x$2 === null)
      } else {
        var this$1 = $n(x);
        return (this$1 === x$2)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_Skeleton$RandomSize$Props(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Skeleton$RandomSize$Props"))
}
function $isArrayOf_Lcom_iz2use_react_components_Skeleton$RandomSize$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Skeleton$RandomSize$Props)))
}
function $asArrayOf_Lcom_iz2use_react_components_Skeleton$RandomSize$Props(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Skeleton$RandomSize$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Skeleton$RandomSize$Props;", depth))
}
var $d_Lcom_iz2use_react_components_Skeleton$RandomSize$Props = new $TypeData().initClass({
  Lcom_iz2use_react_components_Skeleton$RandomSize$Props: 0
}, false, "com.iz2use.react.components.Skeleton$RandomSize$Props", {
  Lcom_iz2use_react_components_Skeleton$RandomSize$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Skeleton$RandomSize$Props.prototype.$classData = $d_Lcom_iz2use_react_components_Skeleton$RandomSize$Props;
/** @constructor */
function $c_Lcom_iz2use_react_components_StateProvider$TypedProps(initial, render, reuseT) {
  this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_initial = null;
  this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_render = null;
  this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_reuseT = null;
  this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_initial = initial;
  this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_render = render;
  this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_reuseT = reuseT
}
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_StateProvider$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_StateProvider$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype = $c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype;
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_initial;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_render;
      break
    }
    case 2: {
      return new $c_Ljapgolly_scalajs_react_Reusability(this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_reuseT);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_StateProvider$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_StateProvider$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_initial;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_StateProvider$TypedProps__f_initial;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_render;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_StateProvider$TypedProps__f_render;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lcom_iz2use_react_components_StateProvider$TypedProps__f_reuseT;
        var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_StateProvider$TypedProps__f_reuseT;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$2 = $n(x$5);
          return (this$2 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_StateProvider$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_StateProvider$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.StateProvider$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_StateProvider$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_StateProvider$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_StateProvider$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_StateProvider$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.StateProvider$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_StateProvider$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_StateProvider$TypedProps: 0
}, false, "com.iz2use.react.components.StateProvider$TypedProps", {
  Lcom_iz2use_react_components_StateProvider$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_StateProvider$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_StateProvider$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_UserPreference$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_UserPreference$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_UserPreference$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_UserPreference$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_UserPreference$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_UserPreference$Backend.prototype = new $h_Lcom_iz2use_react_components_UserPreference$TypedBackend();
$c_Lcom_iz2use_react_components_UserPreference$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_UserPreference$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_UserPreference$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_UserPreference$Backend.prototype = $c_Lcom_iz2use_react_components_UserPreference$Backend.prototype;
var $d_Lcom_iz2use_react_components_UserPreference$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_UserPreference$Backend: 0
}, false, "com.iz2use.react.components.UserPreference$Backend", {
  Lcom_iz2use_react_components_UserPreference$Backend: 1,
  Lcom_iz2use_react_components_UserPreference$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_UserPreference$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_UserPreference$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_UserPreference$TypedProps(renderFn, name, store, encoder, decoder, ec) {
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_renderFn = null;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_name = null;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_store = null;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_encoder = null;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_decoder = null;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_ec = null;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_renderFn = renderFn;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_name = name;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_store = store;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_encoder = encoder;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_decoder = decoder;
  this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_ec = ec
}
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_UserPreference$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_UserPreference$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype = $c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype;
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype.productArity__I = (function() {
  return 6
});
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_renderFn;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_name;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_store;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_encoder;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_decoder;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_ec;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_UserPreference$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_UserPreference$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_renderFn;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_UserPreference$TypedProps__f_renderFn;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_name;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_UserPreference$TypedProps__f_name;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_store;
        var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_UserPreference$TypedProps__f_store;
        if ((x$5 === null)) {
          var $$x1 = (x$6 === null)
        } else {
          var this$1 = $n(x$5);
          var $$x1 = (this$1 === x$6)
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_encoder;
      var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_UserPreference$TypedProps__f_encoder;
      if ((x$7 === null)) {
        var $$x3 = (x$8 === null)
      } else {
        var this$2 = $n(x$7);
        var $$x3 = (this$2 === x$8)
      };
      if ($$x3) {
        var x$9 = this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_decoder;
        var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_UserPreference$TypedProps__f_decoder;
        if ((x$9 === null)) {
          var $$x2 = (x$10 === null)
        } else {
          var this$3 = $n(x$9);
          var $$x2 = (this$3 === x$10)
        }
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$11 = this.Lcom_iz2use_react_components_UserPreference$TypedProps__f_ec;
        var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_UserPreference$TypedProps__f_ec;
        if ((x$11 === null)) {
          var $$x4 = (x$12 === null)
        } else {
          var this$4 = $n(x$11);
          var $$x4 = (this$4 === x$12)
        };
        if ($$x4) {
          $n(TypedProps$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_UserPreference$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_UserPreference$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.UserPreference$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_UserPreference$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_UserPreference$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_UserPreference$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_UserPreference$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.UserPreference$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_UserPreference$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_UserPreference$TypedProps: 0
}, false, "com.iz2use.react.components.UserPreference$TypedProps", {
  Lcom_iz2use_react_components_UserPreference$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_UserPreference$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_UserPreference$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_TextEditorContext(onKeyDown, select, selectAndValid, cancel, scrollIntoView, isModified) {
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_onKeyDown = null;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_select = null;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_selectAndValid = null;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_cancel = null;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_scrollIntoView = null;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_isModified = null;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_onKeyDown = onKeyDown;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_select = select;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_selectAndValid = selectAndValid;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_cancel = cancel;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_scrollIntoView = scrollIntoView;
  this.Lcom_iz2use_react_components_internal_TextEditorContext__f_isModified = isModified
}
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.constructor = $c_Lcom_iz2use_react_components_internal_TextEditorContext;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_TextEditorContext() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_TextEditorContext.prototype = $c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype;
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.contramap__F1__Lcom_iz2use_react_components_internal_TextEditorContext = (function(f) {
  return new $c_Lcom_iz2use_react_components_internal_TextEditorContext(this.Lcom_iz2use_react_components_internal_TextEditorContext__f_onKeyDown, $n(f).andThen__F1__F1(this.Lcom_iz2use_react_components_internal_TextEditorContext__f_select), $n(f).andThen__F1__F1(this.Lcom_iz2use_react_components_internal_TextEditorContext__f_selectAndValid), this.Lcom_iz2use_react_components_internal_TextEditorContext__f_cancel, this.Lcom_iz2use_react_components_internal_TextEditorContext__f_scrollIntoView, this.Lcom_iz2use_react_components_internal_TextEditorContext__f_isModified)
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.productPrefix__T = (function() {
  return "TextEditorContext"
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.productArity__I = (function() {
  return 6
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_TextEditorContext__f_onKeyDown;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_TextEditorContext__f_select;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_TextEditorContext__f_selectAndValid;
      break
    }
    case 3: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lcom_iz2use_react_components_internal_TextEditorContext__f_cancel);
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_TextEditorContext__f_scrollIntoView;
      break
    }
    case 5: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lcom_iz2use_react_components_internal_TextEditorContext__f_isModified);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_TextEditorContext)) {
    var TextEditorContext$1 = $as_Lcom_iz2use_react_components_internal_TextEditorContext(x$1);
    var x = this.Lcom_iz2use_react_components_internal_TextEditorContext__f_onKeyDown;
    var x$2 = $n(TextEditorContext$1).Lcom_iz2use_react_components_internal_TextEditorContext__f_onKeyDown;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_TextEditorContext__f_select;
      var x$4 = $n(TextEditorContext$1).Lcom_iz2use_react_components_internal_TextEditorContext__f_select;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lcom_iz2use_react_components_internal_TextEditorContext__f_selectAndValid;
        var x$6 = $n(TextEditorContext$1).Lcom_iz2use_react_components_internal_TextEditorContext__f_selectAndValid;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lcom_iz2use_react_components_internal_TextEditorContext__f_cancel;
      var x$8 = $n(TextEditorContext$1).Lcom_iz2use_react_components_internal_TextEditorContext__f_cancel;
      if ((x$7 === null)) {
        var $$x2 = (x$8 === null)
      } else {
        var this$1 = $n(x$7);
        var $$x2 = (this$1 === x$8)
      };
      if ($$x2) {
        var x$9 = this.Lcom_iz2use_react_components_internal_TextEditorContext__f_scrollIntoView;
        var x$10 = $n(TextEditorContext$1).Lcom_iz2use_react_components_internal_TextEditorContext__f_scrollIntoView;
        if ((x$9 === null)) {
          var $$x3 = (x$10 === null)
        } else {
          var this$2 = $n(x$9);
          var $$x3 = (this$2 === x$10)
        };
        if ($$x3) {
          var x$11 = this.Lcom_iz2use_react_components_internal_TextEditorContext__f_isModified;
          var x$12 = $n(TextEditorContext$1).Lcom_iz2use_react_components_internal_TextEditorContext__f_isModified;
          if ((x$11 === null)) {
            return (x$12 === null)
          } else {
            var this$3 = $n(x$11);
            return (this$3 === x$12)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_TextEditorContext(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_TextEditorContext) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.TextEditorContext"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_TextEditorContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_TextEditorContext)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_TextEditorContext(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_TextEditorContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.TextEditorContext;", depth))
}
var $d_Lcom_iz2use_react_components_internal_TextEditorContext = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_TextEditorContext: 0
}, false, "com.iz2use.react.components.internal.TextEditorContext", {
  Lcom_iz2use_react_components_internal_TextEditorContext: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext.prototype.$classData = $d_Lcom_iz2use_react_components_internal_TextEditorContext;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend();
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend.prototype = $c_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_TokenizeSearch$Backend: 0
}, false, "com.iz2use.react.components.internal.TokenizeSearch$Backend", {
  Lcom_iz2use_react_components_internal_TokenizeSearch$Backend: 1,
  Lcom_iz2use_react_components_internal_TokenizeSearch$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_TokenizeSearch$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps(search, renderFn, filter) {
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_search = null;
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_renderFn = null;
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_filter = null;
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_search = search;
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_renderFn = renderFn;
  this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_filter = filter
}
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_search;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_renderFn;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_filter;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps(x$1);
    if ((this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_search === $n(TypedProps$1).Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_search)) {
      var x = this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_renderFn;
      var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_renderFn;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_filter;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps__f_filter;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x2 = (this$1 === x$4)
      };
      if ($$x2) {
        $n(TypedProps$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.TokenizeSearch$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.TokenizeSearch$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps: 0
}, false, "com.iz2use.react.components.internal.TokenizeSearch$TypedProps", {
  Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_TokenizeSearch$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_id = null;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend__(this)
}
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend();
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend.prototype = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend: 0
}, false, "com.iz2use.react.components.internal.editor.CheckboxComponent$Backend", {
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend: 1,
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps(label, state, explainError, equiv, optioner) {
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_label = null;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_state = null;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_explainError = null;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_equiv = null;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_optioner = null;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_label = label;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_state = state;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_explainError = explainError;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_equiv = equiv;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_optioner = optioner
}
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype.productArity__I = (function() {
  return 5
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_label;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_state;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_explainError;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_equiv;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_optioner;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_label;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_label;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_state;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_state;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_explainError;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_explainError;
      if ((x$5 === null)) {
        var $$x2 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x2 = (this$2 === x$6)
      };
      if ($$x2) {
        var x$7 = this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_equiv;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_equiv;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_optioner;
          var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps__f_optioner;
          if ((x$9 === null)) {
            return (x$10 === null)
          } else {
            var this$3 = $n(x$9);
            return (this$3 === x$10)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.CheckboxComponent$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.CheckboxComponent$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps: 0
}, false, "com.iz2use.react.components.internal.editor.CheckboxComponent$TypedProps", {
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(focused, loaded) {
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_focused = false;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_loaded = false;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_focused = focused;
  this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_loaded = loaded
}
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_focused;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_loaded;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedState");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_focused ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_loaded ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState)) {
    var TypedState$1 = $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(x$1);
    return ((this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_focused === $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_focused) && (this.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_loaded === $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState__f_loaded))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.CheckboxComponent$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.CheckboxComponent$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState: 0
}, false, "com.iz2use.react.components.internal.editor.CheckboxComponent$TypedState", {
  Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_CheckboxComponent$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture(f, ec) {
  this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_f = null;
  this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_ec = null;
  this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_lastFuture = null;
  this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_f = f;
  this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_ec = ec;
  this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_lastFuture = $m_s_None$()
}
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype = $c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype;
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.enqueue__s_concurrent_Future__Ljapgolly_scalajs_react_callback_Trampoline = (function(fut) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n(fut);
    var x1 = $m_s_Option$().apply__O__s_Option($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(this$2));
    if ((x1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x1);
      $as_s_util_Try($n(x2).s_Some__f_value)
    };
    this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_lastFuture = new $c_s_Some(fut);
    $n(fut).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1(((result$2$2) => {
      var result$2 = $as_s_util_Try(result$2$2);
      var this$3 = $n(this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_lastFuture);
      if ((!this$3.isEmpty__Z())) {
        var arg1 = this$3.get__O();
        var x$1 = $as_s_concurrent_Future(arg1);
        if ((x$1 === null)) {
          var $$x1 = (fut === null)
        } else {
          var this$4 = $n(x$1);
          var $$x1 = (this$4 === fut)
        }
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_f).apply__O__O(result$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$6 = $n(this$);
        $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$6);
        this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_lastFuture = $m_s_None$()
      }
    })), this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_ec)
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.productPrefix__T = (function() {
  return "DiscardOlderFuture"
});
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_f : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture)) {
    var DiscardOlderFuture$1 = $as_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture(x$1);
    var x = this.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_f;
    var x$2 = $n(DiscardOlderFuture$1).Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture__f_f;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.DiscardOlderFuture"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.DiscardOlderFuture;", depth))
}
var $d_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture: 0
}, false, "com.iz2use.react.components.internal.editor.DiscardOlderFuture", {
  Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_DiscardOlderFuture;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_onReceivingText = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_onReceivingValue = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend__(this)
}
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend();
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend.prototype = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend: 0
}, false, "com.iz2use.react.components.internal.editor.MultilineComponent$Backend", {
  Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend: 1,
  Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps(label, state, resolver, explainError, equiv, optioner) {
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_label = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_resolver = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_explainError = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_equiv = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_optioner = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_label = label;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state = state;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_resolver = resolver;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_explainError = explainError;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_equiv = equiv;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_optioner = optioner
}
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype.productArity__I = (function() {
  return 6
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_label;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_resolver;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_explainError;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_equiv;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_optioner;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_label;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_label;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_state;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x2 = (this$1 === x$4)
      };
      if ($$x2) {
        var x$5 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_resolver;
        var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_resolver;
        if ((x$5 === null)) {
          var $$x1 = (x$6 === null)
        } else {
          var this$2 = $n(x$5);
          var $$x1 = (this$2 === x$6)
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_explainError;
      var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_explainError;
      if ((x$7 === null)) {
        var $$x3 = (x$8 === null)
      } else {
        var this$3 = $n(x$7);
        var $$x3 = (this$3 === x$8)
      };
      if ($$x3) {
        var x$9 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_equiv;
        var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_equiv;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_optioner;
          var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps__f_optioner;
          if ((x$11 === null)) {
            return (x$12 === null)
          } else {
            var this$4 = $n(x$11);
            return (this$4 === x$12)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.MultilineComponent$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.MultilineComponent$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps: 0
}, false, "com.iz2use.react.components.internal.editor.MultilineComponent$TypedProps", {
  Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(value, lastText, text, modified, focused, loaded) {
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text = null;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified = false;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused = false;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded = false;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value = value;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText = lastText;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text = text;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified = modified;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused = focused;
  this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded = loaded
}
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.blur__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState = (function() {
  var x$2 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
  var x$3 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
  var x$4 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text;
  var x$5 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified;
  var x$6 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
  return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$2, x$3, x$4, x$5, false, x$6)
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.focus__Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState = (function() {
  var x$3 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
  var x$4 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
  var x$5 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text;
  var x$6 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified;
  return new $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$3, x$4, x$5, x$6, true, true)
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.productArity__I = (function() {
  return 6
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedState");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState)) {
    var TypedState$1 = $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(x$1);
    if (((this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified === $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_modified) && ((this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused === $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_focused) && (this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded === $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_loaded)))) {
      var x = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
      var x$2 = $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_value;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
        var x$4 = $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_lastText;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text;
          var x$6 = $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState__f_text;
          return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.MultilineComponent$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.MultilineComponent$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState: 0
}, false, "com.iz2use.react.components.internal.editor.MultilineComponent$TypedState", {
  Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_MultilineComponent$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_inputRef = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_dropDownContainerRef = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onSelect = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onSelectAndValid = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onCancel = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_justClickedOnContainer = false;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onKeyDown = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_scrollIntoView = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_isModified = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_context = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onReceivingText = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_onReceivingValue = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend__(this)
}
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend();
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend.prototype = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_TextComponent$Backend: 0
}, false, "com.iz2use.react.components.internal.editor.TextComponent$Backend", {
  Lcom_iz2use_react_components_internal_editor_TextComponent$Backend: 1,
  Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_TextComponent$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(formContext, label, state, resolver, explainError, helper, equiv, optioner) {
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_label = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_resolver = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_explainError = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_helper = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_equiv = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext = formContext;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_label = label;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state = state;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_resolver = resolver;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_explainError = explainError;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_helper = helper;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_equiv = equiv;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner = optioner
}
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype.productArity__I = (function() {
  return 8
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_label;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_resolver;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_explainError;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_helper;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_equiv;
      break
    }
    case 7: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_formContext;
    if ((x === null)) {
      var $$x3 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x3 = (this$1 === x$2)
    };
    if ($$x3) {
      var x$3 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_label;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_label;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_state;
      if ((x$5 === null)) {
        var $$x4 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x4 = (this$2 === x$6)
      };
      if ($$x4) {
        var x$7 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_resolver;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_resolver;
        if ((x$7 === null)) {
          var $$x1 = (x$8 === null)
        } else {
          var this$3 = $n(x$7);
          var $$x1 = (this$3 === x$8)
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_explainError;
      var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_explainError;
      if ((x$9 === null)) {
        var $$x6 = (x$10 === null)
      } else {
        var this$4 = $n(x$9);
        var $$x6 = (this$4 === x$10)
      };
      if ($$x6) {
        var x$11 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_helper;
        var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_helper;
        if ((x$11 === null)) {
          var $$x5 = (x$12 === null)
        } else {
          var this$5 = $n(x$11);
          var $$x5 = (this$5 === x$12)
        }
      } else {
        var $$x5 = false
      };
      if ($$x5) {
        var x$13 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_equiv;
        var x$14 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_equiv;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          var x$15 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner;
          var x$16 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner;
          if ((x$15 === null)) {
            return (x$16 === null)
          } else {
            var this$6 = $n(x$15);
            return (this$6 === x$16)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.TextComponent$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.TextComponent$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps: 0
}, false, "com.iz2use.react.components.internal.editor.TextComponent$TypedProps", {
  Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(value, lastText, text, modified, focused, collapsed, loaded) {
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified = false;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused = false;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed = false;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded = false;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_isOpen = false;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value = value;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText = lastText;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text = text;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified = modified;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused = focused;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed = collapsed;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded = loaded;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_isOpen = (focused && (!collapsed))
}
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.blur__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState = (function() {
  var x$3 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
  var x$4 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
  var x$5 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
  var x$6 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified;
  var x$7 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
  return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$3, x$4, x$5, x$6, false, true, x$7)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.collapse__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState = (function() {
  var x$2 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
  var x$3 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
  var x$4 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
  var x$5 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified;
  var x$6 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
  var x$7 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
  return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$2, x$3, x$4, x$5, x$6, true, x$7)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.expand__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState = (function() {
  var x$2 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
  var x$3 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
  var x$4 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
  var x$5 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified;
  var x$6 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
  var x$7 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
  return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$2, x$3, x$4, x$5, x$6, false, x$7)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.focus__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState = (function() {
  var x$4 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
  var x$5 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
  var x$6 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
  var x$7 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified;
  return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$4, x$5, x$6, x$7, true, false, true)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.productArity__I = (function() {
  return 7
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedState");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var data$7 = (this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState)) {
    var TypedState$1 = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$1);
    if (((this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified === $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_modified) && ((this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused === $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused) && (this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed === $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed)))) {
      if ((this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded === $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded)) {
        var x = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
        var x$2 = $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value;
        var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$3 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
        var x$4 = $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
          var x$6 = $n(TypedState$1).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text;
          return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.editor.TextComponent$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.editor.TextComponent$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState: 0
}, false, "com.iz2use.react.components.internal.editor.TextComponent$TypedState", {
  Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$: 0
}, false, "com.iz2use.react.components.internal.multiview.AccumulatingTableRenderer$", {
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererHighPriorityImplicits: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits: 1,
  Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$;
var $n_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$;
function $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$ = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$
}
function $as_Lcom_iz2use_react_components_internal_multiview_Action(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.Action"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_Action)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_Action(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.Action;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend();
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_CompareView$Backend: 0
}, false, "com.iz2use.react.components.internal.multiview.CompareView$Backend", {
  Lcom_iz2use_react_components_internal_multiview_CompareView$Backend: 1,
  Lcom_iz2use_react_components_internal_multiview_CompareView$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_CompareView$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps(items, renderer, keyMapper, context, iterator) {
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_items = null;
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_renderer = null;
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_iterator = null;
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_items = items;
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_renderer = renderer;
  this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_iterator = iterator
}
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_items;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_renderer;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_items;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_items;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_renderer;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps__f_renderer;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.CompareView$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.CompareView$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps: 0
}, false, "com.iz2use.react.components.internal.multiview.CompareView$TypedProps", {
  Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState)
});
function $as_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.CompareView$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.CompareView$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState: 0
}, false, "com.iz2use.react.components.internal.multiview.CompareView$TypedState", {
  Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_CompareView$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer(item, field) {
  this.Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_item = null;
  this.Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_field = null;
  this.Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_item = item;
  this.Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_field = field
}
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype = $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype.productPrefix__T = (function() {
  return "DecoratorRenderer"
});
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_item;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_field;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer)) {
    var DecoratorRenderer$1 = $as_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_item;
    var x$2 = $n(DecoratorRenderer$1).Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_item;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_field;
      var x$4 = $n(DecoratorRenderer$1).Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer__f_field;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.DecoratorRenderer"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.DecoratorRenderer;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer: 0
}, false, "com.iz2use.react.components.internal.multiview.DecoratorRenderer", {
  Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_DecoratorRenderer;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_DefinedViews() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype = $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype.productPrefix__T = (function() {
  return "DefinedViews"
});
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews)
});
function $as_Lcom_iz2use_react_components_internal_multiview_DefinedViews(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_DefinedViews) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.DefinedViews"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_DefinedViews(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_DefinedViews)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_DefinedViews(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_DefinedViews(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.DefinedViews;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_DefinedViews = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_DefinedViews: 0
}, false, "com.iz2use.react.components.internal.multiview.DefinedViews", {
  Lcom_iz2use_react_components_internal_multiview_DefinedViews: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_DefinedViews.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_DefinedViews;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch(startIndex, negative, name, operator, valueStartIndex, value, endIndex) {
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_startIndex = 0;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_negative = false;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_name = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_operator = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_valueStartIndex = 0;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_value = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_endIndex = 0;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_startIndex = startIndex;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_negative = negative;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_name = name;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_operator = operator;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_valueStartIndex = valueStartIndex;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_value = value;
  this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_endIndex = endIndex
}
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_FieldMatch() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype = $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype.productPrefix__T = (function() {
  return "FieldMatch"
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype.productArity__I = (function() {
  return 7
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_startIndex;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_negative;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_name;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_operator;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_valueStartIndex;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_value;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_endIndex;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("FieldMatch");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_startIndex;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_negative ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x = this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_name;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$1 = this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_operator;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_valueStartIndex;
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$2 = this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_value;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var data$7 = this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_endIndex;
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch)) {
    var FieldMatch$1 = $as_Lcom_iz2use_react_components_internal_multiview_FieldMatch(x$1);
    return (((this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_startIndex === $n(FieldMatch$1).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_startIndex) && ((this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_negative === $n(FieldMatch$1).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_negative) && (this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_valueStartIndex === $n(FieldMatch$1).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_valueStartIndex))) && (((this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_endIndex === $n(FieldMatch$1).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_endIndex) && (this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_name === $n(FieldMatch$1).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_name)) && ((this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_operator === $n(FieldMatch$1).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_operator) && (this.Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_value === $n(FieldMatch$1).Lcom_iz2use_react_components_internal_multiview_FieldMatch__f_value))))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_FieldMatch(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.FieldMatch"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_FieldMatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_FieldMatch)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_FieldMatch(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_FieldMatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.FieldMatch;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_FieldMatch = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_FieldMatch: 0
}, false, "com.iz2use.react.components.internal.multiview.FieldMatch", {
  Lcom_iz2use_react_components_internal_multiview_FieldMatch: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_FieldMatch;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch$.prototype = new $h_sr_AbstractFunction7();
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_FieldMatch$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_FieldMatch$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch$.prototype.toString__T = (function() {
  return "FieldMatch"
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch$.prototype.apply__O__O__O__O__O__O__O__O = (function(v1, v2, v3, v4, v5, v6, v7) {
  var startIndex = $uI(v1);
  var negative = $uZ(v2);
  var name = $as_T(v3);
  var operator = $as_T(v4);
  var valueStartIndex = $uI(v5);
  var value = $as_T(v6);
  var endIndex = $uI(v7);
  return new $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch(startIndex, negative, name, operator, valueStartIndex, value, endIndex)
});
var $d_Lcom_iz2use_react_components_internal_multiview_FieldMatch$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_FieldMatch$: 0
}, false, "com.iz2use.react.components.internal.multiview.FieldMatch$", {
  Lcom_iz2use_react_components_internal_multiview_FieldMatch$: 1,
  sr_AbstractFunction7: 1,
  O: 1,
  F7: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldMatch$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_FieldMatch$;
var $n_Lcom_iz2use_react_components_internal_multiview_FieldMatch$;
function $m_Lcom_iz2use_react_components_internal_multiview_FieldMatch$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_FieldMatch$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_FieldMatch$ = new $c_Lcom_iz2use_react_components_internal_multiview_FieldMatch$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_FieldMatch$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable(format, ordering, editor, viewer, parser) {
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_format = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_ordering = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_editor = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_viewer = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_parser = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_format = format;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_ordering = ordering;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_editor = editor;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_viewer = viewer;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_parser = parser
}
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_FieldRenderable() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype = $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype.productPrefix__T = (function() {
  return "FieldRenderable"
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable)
});
function $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderable(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.FieldRenderable"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_FieldRenderable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_FieldRenderable)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_FieldRenderable(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_FieldRenderable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.FieldRenderable;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_FieldRenderable = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_FieldRenderable: 0
}, false, "com.iz2use.react.components.internal.multiview.FieldRenderable", {
  Lcom_iz2use_react_components_internal_multiview_FieldRenderable: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderable.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_FieldRenderable;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(title, key, renderable) {
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_title = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable = null;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_title = title;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key = key;
  this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable = renderable
}
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_FieldRenderer() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype = $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.parse__T__s_util_Try = (function(in$1) {
  var x1 = $n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_parser;
  var x = $m_s_None$();
  if ((x === x1)) {
    return new $c_s_util_Failure($ct_jl_Exception__T__(new $c_jl_Exception(), ("No parser for field " + this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_title)))
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var parser = $as_Lcom_iz2use_common_Parsable($n(x3).s_Some__f_value);
    return $n(parser).parse__T__s_util_Try(in$1)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.renderInlineHeaderLabel__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  var this$6 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var $$x3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key).toString__T(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
  var $$x2 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_format).alignment__Ljapgolly_scalajs_react_vdom_TagMod();
  var $$x1 = $n($n($n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_format).sizing__Lcom_iz2use_react_components_internal_multiview_Sizing()).Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenFlex;
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_title;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [$$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return this$6.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.renderInlineFieldWithLabel__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_TagMod = (function(in$1, editing) {
  var x1 = $n(in$1).get__O__s_Option(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key);
  var x = $m_s_None$();
  if ((x === x1)) {
    return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var v = $n(x3).s_Some__f_value;
    var this$15 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var $$x8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key).toString__T(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS);
    var $$x7 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_format).alignment__Ljapgolly_scalajs_react_vdom_TagMod();
    var $$x6 = $n($n($n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_format).sizing__Lcom_iz2use_react_components_internal_multiview_Sizing()).Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenFlex;
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_title;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("label", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var x$3 = $m_s_None$();
    if ((x$3 === editing)) {
      var $$x1 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_viewer).apply__O__Ljapgolly_scalajs_react_vdom_TagMod(v)
    } else {
      if ((!(editing instanceof $c_s_Some))) {
        throw new $c_s_MatchError(editing)
      };
      var x3$2 = $as_s_Some(editing);
      var editing$2 = $as_F1($n(x3$2).s_Some__f_value);
      var $$x2 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_editor);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$2 = $n(this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key).s_Symbol__f_name;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x1 = $n($$x2).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod(new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2), $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), v), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
        var x0$1 = $as_s_Option(x0$1$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1$2 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        matchEnd7: {
          var $$x3;
          var p2 = $as_s_Option(x1$2.T2__f__1);
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x$1 = $m_s_None$();
          if ((x$1 === p2)) {
            var $$x3 = cb;
            break matchEnd7
          };
          var p4 = $as_s_Option(x1$2.T2__f__1);
          var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          if ((p4 instanceof $c_s_Some)) {
            var x5 = $as_s_Some(p4);
            var v$3 = $n(x5).s_Some__f_value;
            var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(editing$2).apply__O__O(v$3))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2);
            break matchEnd7
          };
          throw new $c_s_MatchError(x1$2)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x3)
      }))))
    };
    var array$1 = [$$x8, $$x7, $$x6, $$x4, $$x1];
    var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return this$15.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.productPrefix__T = (function() {
  return "FieldRenderer"
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_title;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer)) {
    var FieldRenderer$1 = $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(x$1);
    if ((this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_title === $n(FieldRenderer$1).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_title)) {
      var x = this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key;
      var x$2 = $n(FieldRenderer$1).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable;
        var x$4 = $n(FieldRenderer$1).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.FieldRenderer"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_FieldRenderer)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_FieldRenderer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.FieldRenderer;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_FieldRenderer = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_FieldRenderer: 0
}, false, "com.iz2use.react.components.internal.multiview.FieldRenderer", {
  Lcom_iz2use_react_components_internal_multiview_FieldRenderer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_FieldRenderer.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_FieldRenderer;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_ForgetField(tpe, fieldName) {
  this.Lcom_iz2use_react_components_internal_multiview_ForgetField__f_tpe = null;
  this.Lcom_iz2use_react_components_internal_multiview_ForgetField__f_fieldName = null;
  this.Lcom_iz2use_react_components_internal_multiview_ForgetField__f_tpe = tpe;
  this.Lcom_iz2use_react_components_internal_multiview_ForgetField__f_fieldName = fieldName
}
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_ForgetField;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_ForgetField() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype = $c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype.productPrefix__T = (function() {
  return "ForgetField"
});
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_ForgetField__f_tpe;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_ForgetField__f_fieldName;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_ForgetField)) {
    var ForgetField$1 = $as_Lcom_iz2use_react_components_internal_multiview_ForgetField(x$1);
    return ((this.Lcom_iz2use_react_components_internal_multiview_ForgetField__f_tpe === $n(ForgetField$1).Lcom_iz2use_react_components_internal_multiview_ForgetField__f_tpe) && (this.Lcom_iz2use_react_components_internal_multiview_ForgetField__f_fieldName === $n(ForgetField$1).Lcom_iz2use_react_components_internal_multiview_ForgetField__f_fieldName))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_ForgetField(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_ForgetField) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.ForgetField"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_ForgetField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_ForgetField)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_ForgetField(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_ForgetField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.ForgetField;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_ForgetField = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_ForgetField: 0
}, false, "com.iz2use.react.components.internal.multiview.ForgetField", {
  Lcom_iz2use_react_components_internal_multiview_ForgetField: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_ForgetField.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_ForgetField;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_HasViews(views) {
  this.Lcom_iz2use_react_components_internal_multiview_HasViews__f_views = null;
  this.Lcom_iz2use_react_components_internal_multiview_HasViews__f_views = views
}
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_HasViews;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_HasViews() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype = $c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype.productPrefix__T = (function() {
  return "HasViews"
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_internal_multiview_HasViews__f_views : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_HasViews)) {
    var HasViews$1 = $as_Lcom_iz2use_react_components_internal_multiview_HasViews(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_HasViews__f_views;
    var x$2 = $n(HasViews$1).Lcom_iz2use_react_components_internal_multiview_HasViews__f_views;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_HasViews(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_HasViews) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.HasViews"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_HasViews(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_HasViews)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_HasViews(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_HasViews(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.HasViews;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_HasViews = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_HasViews: 0
}, false, "com.iz2use.react.components.internal.multiview.HasViews", {
  Lcom_iz2use_react_components_internal_multiview_HasViews: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_HasViews.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_HasViews;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MatchingField(negative, name, operator, value, field) {
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_negative = false;
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_name = null;
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_operator = null;
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_value = null;
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field = null;
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_negative = negative;
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_name = name;
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_operator = operator;
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_value = value;
  this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field = field
}
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MatchingField;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MatchingField() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.apply__F1 = (function() {
  var x1 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_ordering;
  var x = $m_s_None$();
  if ((x === x1)) {
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      $as_sci_Map(x$1$2);
      return true
    }))
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var ord = $as_s_math_Ordering($n(x3).s_Some__f_value);
    var x1$2 = this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_operator;
    switch (x1$2) {
      case "<=": {
        var comp = new $c_sjsr_AnonFunction2(((x$3$2, y$2) => $n(ord).lteq__O__O__Z(x$3$2, y$2)));
        break
      }
      case "<": {
        var comp = new $c_sjsr_AnonFunction2(((x$4$2, y$3$2) => $n(ord).lt__O__O__Z(x$4$2, y$3$2)));
        break
      }
      case ">=": {
        var comp = new $c_sjsr_AnonFunction2(((x$5$2, y$4$2) => $n(ord).gteq__O__O__Z(x$5$2, y$4$2)));
        break
      }
      case ">": {
        var comp = new $c_sjsr_AnonFunction2(((x$6$2, y$5$2) => $n(ord).gt__O__O__Z(x$6$2, y$5$2)));
        break
      }
      case "=":
      case "==":
      case ":": {
        var comp = new $c_sjsr_AnonFunction2(((x$7$2, y$6$2) => $n(ord).equiv__O__O__Z(x$7$2, y$6$2)));
        break
      }
      default: {
        var comp = new $c_sjsr_AnonFunction2(((x$8$2, y$7$2) => $n(ord).equiv__O__O__Z(x$8$2, y$7$2)))
      }
    };
    return new $c_sjsr_AnonFunction1(((x$2$2$2) => {
      var x$2$2 = $as_sci_Map(x$2$2$2);
      var x1$1 = $n(x$2$2).get__O__s_Option($n(this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_key);
      var x$2 = $m_s_None$();
      if ((x$2 === x1$1)) {
        return true
      } else if ((x1$1 instanceof $c_s_Some)) {
        var x3$1 = $as_s_Some(x1$1);
        var v = $n(x3$1).s_Some__f_value;
        var cr = $uZ($n(comp).apply__O__O__O(v, this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_value));
        return (this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_negative ? (!cr) : cr)
      } else {
        throw new $c_s_MatchError(x1$1)
      }
    }))
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.productPrefix__T = (function() {
  return "MatchingField"
});
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.productArity__I = (function() {
  return 5
});
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_negative;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_name;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_operator;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_value;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("MatchingField");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_negative ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_name;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_operator;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_value;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_MatchingField)) {
    var MatchingField$1 = $as_Lcom_iz2use_react_components_internal_multiview_MatchingField(x$1);
    if (((this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_negative === $n(MatchingField$1).Lcom_iz2use_react_components_internal_multiview_MatchingField__f_negative) && (this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_name === $n(MatchingField$1).Lcom_iz2use_react_components_internal_multiview_MatchingField__f_name))) {
      if ((this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_operator === $n(MatchingField$1).Lcom_iz2use_react_components_internal_multiview_MatchingField__f_operator)) {
        var x = this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_value;
        var y = $n(MatchingField$1).Lcom_iz2use_react_components_internal_multiview_MatchingField__f_value;
        if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
          var x$2 = this.Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field;
          var x$2$1 = $n(MatchingField$1).Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field;
          return ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_MatchingField(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_MatchingField) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.MatchingField"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_MatchingField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_MatchingField)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_MatchingField(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_MatchingField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.MatchingField;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_MatchingField = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_MatchingField: 0
}, false, "com.iz2use.react.components.internal.multiview.MatchingField", {
  Lcom_iz2use_react_components_internal_multiview_MatchingField: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_MatchingField.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_MatchingField;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(view, selected, query, orders) {
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view = view;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected = selected;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query = query;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders = orders
}
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype.productPrefix__T = (function() {
  return "MultiviewCurrentState"
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype.productArity__I = (function() {
  return 4
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState)) {
    var MultiviewCurrentState$1 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view;
    var x$2 = $n(MultiviewCurrentState$1).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_view;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected;
      var x$4 = $n(MultiviewCurrentState$1).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_selected;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query;
      var x$6 = $n(MultiviewCurrentState$1).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_query;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders;
        var x$8 = $n(MultiviewCurrentState$1).Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState__f_orders;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.MultiviewCurrentState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.MultiviewCurrentState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState: 0
}, false, "com.iz2use.react.components.internal.multiview.MultiviewCurrentState", {
  Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_MultiviewCurrentState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props(style, moveActive, selector) {
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_style = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_moveActive = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_selector = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_style = style;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_moveActive = moveActive;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_selector = selector
}
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_style;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_moveActive;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_selector;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props)) {
    var Props$1 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_style;
    var x$2 = $n(Props$1).Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_style;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_moveActive;
      var x$4 = $n(Props$1).Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_moveActive;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_selector;
        var x$6 = $n(Props$1).Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props__f_selector;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$2 = $n(x$5);
          return (this$2 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.MultiviewSettings$Props"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.MultiviewSettings$Props;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props: 0
}, false, "com.iz2use.react.components.internal.multiview.MultiviewSettings$Props", {
  Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_MultiviewSettings$Props;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_MultiviewState(source, view, active, currentState, keyMapper, filter, fields, tokenizer, decorator, itemSimpleActions) {
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_view = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_active = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_keyMapper = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_filter = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_fields = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_tokenizer = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_decorator = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_itemSimpleActions = null;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source = source;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_view = view;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_active = active;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState = currentState;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_keyMapper = keyMapper;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_filter = filter;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_fields = fields;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_tokenizer = tokenizer;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_decorator = decorator;
  this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_itemSimpleActions = itemSimpleActions
}
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_MultiviewState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype.productPrefix__T = (function() {
  return "MultiviewState"
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype.productArity__I = (function() {
  return 4
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_view;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_active;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_MultiviewState)) {
    var MultiviewState$1 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
    var x$2 = $n(MultiviewState$1).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_source;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_view;
      var x$4 = $n(MultiviewState$1).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_view;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_active;
      var x$6 = $n(MultiviewState$1).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_active;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState;
        var x$8 = $n(MultiviewState$1).Lcom_iz2use_react_components_internal_multiview_MultiviewState__f_currentState;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_MultiviewState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.MultiviewState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_MultiviewState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_MultiviewState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.MultiviewState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_MultiviewState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_MultiviewState: 0
}, false, "com.iz2use.react.components.internal.multiview.MultiviewState", {
  Lcom_iz2use_react_components_internal_multiview_MultiviewState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_MultiviewState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_MultiviewState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Order(field, ascending) {
  this.Lcom_iz2use_react_components_internal_multiview_Order__f_field = null;
  this.Lcom_iz2use_react_components_internal_multiview_Order__f_ascending = false;
  this.Lcom_iz2use_react_components_internal_multiview_Order__f_field = field;
  this.Lcom_iz2use_react_components_internal_multiview_Order__f_ascending = ascending
}
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Order;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Order() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Order.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Order.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype.productPrefix__T = (function() {
  return "Order"
});
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_Order__f_field;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_Order__f_ascending;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Order");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_react_components_internal_multiview_Order__f_field;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lcom_iz2use_react_components_internal_multiview_Order__f_ascending ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_Order)) {
    var Order$1 = $as_Lcom_iz2use_react_components_internal_multiview_Order(x$1);
    return ((this.Lcom_iz2use_react_components_internal_multiview_Order__f_ascending === $n(Order$1).Lcom_iz2use_react_components_internal_multiview_Order__f_ascending) && (this.Lcom_iz2use_react_components_internal_multiview_Order__f_field === $n(Order$1).Lcom_iz2use_react_components_internal_multiview_Order__f_field))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_Order(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_Order) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.Order"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_Order(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_Order)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_Order(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_Order(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.Order;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_Order = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Order: 0
}, false, "com.iz2use.react.components.internal.multiview.Order", {
  Lcom_iz2use_react_components_internal_multiview_Order: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Order.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Order;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(input, matchingFields, rest, tokenized) {
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_input = null;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_matchingFields = null;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_rest = null;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_tokenized = null;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_input = input;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_matchingFields = matchingFields;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_rest = rest;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_tokenized = tokenized
}
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_ParsedQuery() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype = $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype.productPrefix__T = (function() {
  return "ParsedQuery"
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype.productArity__I = (function() {
  return 4
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_input;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_matchingFields;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_rest;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_tokenized;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery)) {
    var ParsedQuery$1 = $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(x$1);
    if ((this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_input === $n(ParsedQuery$1).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_input)) {
      var x = this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_matchingFields;
      var x$2 = $n(ParsedQuery$1).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_matchingFields;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_rest === $n(ParsedQuery$1).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_rest)) {
        var x$3 = this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_tokenized;
        var x$4 = $n(ParsedQuery$1).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_tokenized;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.ParsedQuery"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_ParsedQuery)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.ParsedQuery;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_ParsedQuery = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_ParsedQuery: 0
}, false, "com.iz2use.react.components.internal.multiview.ParsedQuery", {
  Lcom_iz2use_react_components_internal_multiview_ParsedQuery: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_ParsedQuery;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1(filter$1, fieldRenderers$1) {
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1__f_filter$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1__f_fieldRenderers$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1__f_filter$1 = filter$1;
  this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1__f_fieldRenderers$1 = fieldRenderers$1
}
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1.prototype.parse__T__s_util_Try = (function(in$1) {
  var this$1 = $n($m_Lcom_iz2use_react_components_internal_multiview_QueryParser$().apply__T__Lcom_iz2use_common_Filter__sci_Seq__Lcats_data_Validated(in$1, this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1__f_filter$1, this.Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1__f_fieldRenderers$1));
  if ((this$1 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x2 = $as_Lcats_data_Validated$Invalid(this$1);
    var e = $n(x2).Lcats_data_Validated$Invalid__f_e;
    var e$1 = $as_Lcats_data_NonEmptyList(e);
    var $$x1 = new $c_s_util_Failure($ct_jl_Exception__T__(new $c_jl_Exception(), $n(e$1).toString__T()))
  } else {
    if ((!(this$1 instanceof $c_Lcats_data_Validated$Valid))) {
      throw new $c_s_MatchError(this$1)
    };
    var x3 = $as_Lcats_data_Validated$Valid(this$1);
    var a = $n(x3).Lcats_data_Validated$Valid__f_a;
    var x$3 = $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(a);
    var $$x1 = new $c_s_util_Success(x$3)
  };
  return $as_s_util_Try($$x1)
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1.prototype.stringify__O__T = (function(value) {
  var in$1 = $as_Lcom_iz2use_react_components_internal_multiview_ParsedQuery(value);
  return $n(in$1).Lcom_iz2use_react_components_internal_multiview_ParsedQuery__f_input
});
var $d_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.ParsedQuery$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_ParsedQuery$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Sizing(whenTable, whenFlex) {
  this.Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenTable = null;
  this.Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenFlex = null;
  this.Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenTable = whenTable;
  this.Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenFlex = whenFlex
}
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Sizing;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Sizing() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype.productPrefix__T = (function() {
  return "Sizing"
});
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenTable;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenFlex;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_Sizing)) {
    var Sizing$1 = $as_Lcom_iz2use_react_components_internal_multiview_Sizing(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenTable;
    var x$2 = $n(Sizing$1).Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenTable;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenFlex;
      var x$4 = $n(Sizing$1).Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenFlex;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Sizing$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_Sizing(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_Sizing) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.Sizing"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_Sizing(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_Sizing)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_Sizing(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_Sizing(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.Sizing;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_Sizing = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Sizing: 0
}, false, "com.iz2use.react.components.internal.multiview.Sizing", {
  Lcom_iz2use_react_components_internal_multiview_Sizing: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Sizing.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Sizing;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend();
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend: 0
}, false, "com.iz2use.react.components.internal.multiview.SlideshowView$Backend", {
  Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend: 1,
  Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SlideshowView$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps(active, items, renderer, keyMapper, context, iterator) {
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_active = null;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_items = null;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_renderer = null;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_keyMapper = null;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_context = null;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_iterator = null;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_active = active;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_items = items;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_renderer = renderer;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_keyMapper = keyMapper;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_context = context;
  this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_iterator = iterator
}
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_active;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_items;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_renderer;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_active;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_active;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_items;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_items;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_renderer;
        var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps__f_renderer;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$1 = $n(x$5);
          return (this$1 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.SlideshowView$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.SlideshowView$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps: 0
}, false, "com.iz2use.react.components.internal.multiview.SlideshowView$TypedProps", {
  Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState)
});
function $as_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.SlideshowView$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.SlideshowView$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState: 0
}, false, "com.iz2use.react.components.internal.multiview.SlideshowView$TypedState", {
  Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SlideshowView$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem(key, image, imageOverlay, title) {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_key = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_image = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_imageOverlay = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_title = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_key = key;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_image = image;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_imageOverlay = imageOverlay;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_title = title
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype.productPrefix__T = (function() {
  return "GridItem"
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype.productArity__I = (function() {
  return 4
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_key;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_image;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_imageOverlay;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_title;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem)) {
    var GridItem$1 = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem(x$1);
    if ((this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_key === $n(GridItem$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_key)) {
      var x = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_image;
      var x$2 = $n(GridItem$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_image;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_imageOverlay;
      var x$4 = $n(GridItem$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_imageOverlay;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_title;
        var x$6 = $n(GridItem$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem__f_title;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.grid.GridItem"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_grid_GridItem)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridItem(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridItem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.grid.GridItem;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridItem = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridItem: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridItem", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridItem: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridItem;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridItem$Backend", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend: 1,
  Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(key, model, map, renderer, itemSimpleActions, selected, focused, ref, setActive, setActiveAndSelectView, decorator, renderable) {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_key = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_map = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderer = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_itemSimpleActions = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_selected = false;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_focused = false;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_ref = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActive = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActiveAndSelectView = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_decorator = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderable = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_key = key;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model = model;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_map = map;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderer = renderer;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_itemSimpleActions = itemSimpleActions;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_selected = selected;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_focused = focused;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_ref = ref;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActive = setActive;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActiveAndSelectView = setActiveAndSelectView;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_decorator = decorator;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderable = renderable
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype.productArity__I = (function() {
  return 12
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_key;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_map;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderer;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_itemSimpleActions;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_selected;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_focused;
      break
    }
    case 7: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_ref;
      break
    }
    case 8: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActive;
      break
    }
    case 9: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActiveAndSelectView;
      break
    }
    case 10: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_decorator;
      break
    }
    case 11: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderable;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_key;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_map;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderer;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_itemSimpleActions;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_selected ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var data$7 = (this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_focused ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$5 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_ref;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$6 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActive;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$7 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActiveAndSelectView;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var x$8 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_decorator;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$8);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  var x$9 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderable;
  var data$12 = $m_sr_Statics$().anyHash__O__I(x$9);
  acc = $m_sr_Statics$().mix__I__I__I(hash$12, data$12);
  var hash$13 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$13, 12)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(x$1);
    if (((this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_selected === $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_selected) && ((this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_focused === $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_focused) && (this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_key === $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_key)))) {
      var x = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model;
      var y = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_model;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
        var x$2 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_map;
        var x$2$1 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_map;
        if (((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))) {
          var x$3 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderer;
          var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderer;
          if ((x$3 === null)) {
            var $$x1 = (x$4 === null)
          } else {
            var this$1 = $n(x$3);
            var $$x1 = (this$1 === x$4)
          }
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_itemSimpleActions;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_itemSimpleActions;
      if ((x$5 === null)) {
        var $$x3 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x3 = (this$2 === x$6)
      };
      if ($$x3) {
        var x$7 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_ref;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_ref;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActive;
          var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActive;
          if ((x$9 === null)) {
            var $$x2 = (x$10 === null)
          } else {
            var this$3 = $n(x$9);
            var $$x2 = (this$3 === x$10)
          }
        } else {
          var $$x2 = false
        }
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$11 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActiveAndSelectView;
        var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_setActiveAndSelectView;
        if ((x$11 === null)) {
          var $$x4 = (x$12 === null)
        } else {
          var this$4 = $n(x$11);
          var $$x4 = (this$4 === x$12)
        };
        if ($$x4) {
          var x$13 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_decorator;
          var x$14 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_decorator;
          if ((x$13 === null)) {
            var $$x5 = (x$14 === null)
          } else {
            var this$5 = $n(x$13);
            var $$x5 = (this$5 === x$14)
          };
          if ($$x5) {
            var x$15 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderable;
            var x$16 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps__f_renderable;
            if ((x$15 === null)) {
              return (x$16 === null)
            } else {
              var this$6 = $n(x$15);
              return (this$6 === x$16)
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.grid.GridItem$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.grid.GridItem$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridItem$TypedProps", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridItem$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_activeRowRef = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_scrollDirection = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_axes = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_setActive = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_setActiveAndGotoSlideshow = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_axesContext = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__(this)
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridView$Backend", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend: 1,
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(items, active, keyMapper, renderer, itemSimpleActions, renderable, context, hasIterator, decorator) {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_active = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderer = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_itemSimpleActions = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderable = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_context = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_hasIterator = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_decorator = null;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items = items;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_active = active;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper = keyMapper;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderer = renderer;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_itemSimpleActions = itemSimpleActions;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderable = renderable;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_context = context;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_hasIterator = hasIterator;
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_decorator = decorator
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype.productArity__I = (function() {
  return 6
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_active;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderer;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_itemSimpleActions;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderable;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_active;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_active;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper;
        var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper;
        if ((x$5 === null)) {
          var $$x1 = (x$6 === null)
        } else {
          var this$1 = $n(x$5);
          var $$x1 = (this$1 === x$6)
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderer;
      var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderer;
      if ((x$7 === null)) {
        var $$x2 = (x$8 === null)
      } else {
        var this$2 = $n(x$7);
        var $$x2 = (this$2 === x$8)
      };
      if ($$x2) {
        var x$9 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_itemSimpleActions;
        var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_itemSimpleActions;
        if ((x$9 === null)) {
          var $$x3 = (x$10 === null)
        } else {
          var this$3 = $n(x$9);
          var $$x3 = (this$3 === x$10)
        };
        if ($$x3) {
          var x$11 = this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderable;
          var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_renderable;
          if ((x$11 === null)) {
            return (x$12 === null)
          } else {
            var this$4 = $n(x$11);
            return (this$4 === x$12)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.grid.GridView$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.grid.GridView$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridView$TypedProps", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState)
});
function $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.grid.GridView$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.grid.GridView$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridView$TypedState", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps(key, model, map, renderer, editing, itemSimpleActions, style) {
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_key = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_model = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_map = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_renderer = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_editing = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_itemSimpleActions = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_style = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_key = key;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_model = model;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_map = map;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_renderer = renderer;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_editing = editing;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_itemSimpleActions = itemSimpleActions;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_style = style
}
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype.productArity__I = (function() {
  return 7
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_key;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_model;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_map;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_renderer;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_editing;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_itemSimpleActions;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_style;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps(x$1);
    if ((this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_key === $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_key)) {
      var x = this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_model;
      var y = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_model;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
        var x$2 = this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_map;
        var x$2$1 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_map;
        var $$x1 = ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_renderer;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_renderer;
      if ((x$3 === null)) {
        var $$x3 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x3 = (this$1 === x$4)
      };
      if ($$x3) {
        var x$5 = this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_editing;
        var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_editing;
        var $$x2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$7 = this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_itemSimpleActions;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_itemSimpleActions;
        if ((x$7 === null)) {
          var $$x4 = (x$8 === null)
        } else {
          var this$2 = $n(x$7);
          var $$x4 = (this$2 === x$8)
        };
        if ($$x4) {
          var x$9 = this.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_style;
          var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps__f_style;
          if ((x$9 === null)) {
            return (x$10 === null)
          } else {
            var this$3 = $n(x$9);
            return (this$3 === x$10)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.list.ListItem$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.list.ListItem$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps: 0
}, false, "com.iz2use.react.components.internal.multiview.list.ListItem$TypedProps", {
  Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_list_ListItem$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_list_ListView(iterator) {
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView__f_com$iz2use$react$components$internal$multiview$list$ListView$$iterator = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView__f_component = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView__f_com$iz2use$react$components$internal$multiview$list$ListView$$iterator = iterator;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView__f_component = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("ListView", new $c_sjsr_AnonFunction1(((p$2) => {
    $as_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps(p$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState(this, $m_s_None$())
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend(this, x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $as_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState($f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5)))
  })))).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_list_ListView() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.apply__Ldiode_data_Pot__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_ListRenderer__Lcom_iz2use_react_components_internal_multiview_Actions__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(items, keyMapper, renderer, itemSimpleActions) {
  var c = this.Lcom_iz2use_react_components_internal_multiview_list_ListView__f_component;
  var this$6 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType())).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType("ListView")));
  var props = new $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps(this, items, keyMapper, renderer, itemSimpleActions);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$6.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$6.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.productPrefix__T = (function() {
  return "ListView"
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_list_ListView)
});
function $as_Lcom_iz2use_react_components_internal_multiview_list_ListView(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_list_ListView) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.list.ListView"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_list_ListView)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.list.ListView;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_list_ListView = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_list_ListView: 0
}, false, "com.iz2use.react.components.internal.multiview.list.ListView", {
  Lcom_iz2use_react_components_internal_multiview_list_ListView: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_list_ListView;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend(outer, \u03b4) {
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__f_$outer = null;
  $ct_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend__Lcom_iz2use_react_components_internal_multiview_list_ListView__(this, outer)
}
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend();
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend: 0
}, false, "com.iz2use.react.components.internal.multiview.list.ListView$Backend", {
  Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend: 1,
  Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_list_ListView$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps(outer, items, keyMapper, renderer, itemSimpleActions) {
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_items = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_keyMapper = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_renderer = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_itemSimpleActions = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_items = items;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_keyMapper = keyMapper;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_renderer = renderer;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_itemSimpleActions = itemSimpleActions;
  if ((outer === null)) {
    $n(null)
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype.productArity__I = (function() {
  return 4
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_items;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_keyMapper;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_renderer;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_itemSimpleActions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_items;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_items;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_keyMapper;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_keyMapper;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_renderer;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_renderer;
      if ((x$5 === null)) {
        var $$x2 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x2 = (this$2 === x$6)
      };
      if ($$x2) {
        var x$7 = this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_itemSimpleActions;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps__f_itemSimpleActions;
        if ((x$7 === null)) {
          return (x$8 === null)
        } else {
          var this$3 = $n(x$7);
          return (this$3 === x$8)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.list.ListView$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.list.ListView$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps: 0
}, false, "com.iz2use.react.components.internal.multiview.list.ListView$TypedProps", {
  Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState(outer, editing) {
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState__f_editing = null;
  this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState__f_editing = editing;
  if ((outer === null)) {
    $n(null)
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState__f_editing : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState)) {
    var TypedState$1 = $as_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState__f_editing;
    var x$2 = $n(TypedState$1).Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState__f_editing;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.list.ListView$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.list.ListView$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState: 0
}, false, "com.iz2use.react.components.internal.multiview.list.ListView$TypedState", {
  Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_list_ListView$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable(format, ordering, editable, viewable) {
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_format = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_ordering = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_editable = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_viewable = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_format = format;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_ordering = ordering;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_editable = editable;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_viewable = viewable
}
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype.productPrefix__T = (function() {
  return "ColumnRenderable"
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable)
});
function $as_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.table.ColumnRenderable"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.table.ColumnRenderable;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable: 0
}, false, "com.iz2use.react.components.internal.multiview.table.ColumnRenderable", {
  Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn(tpe, columnName) {
  this.Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_tpe = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_columnName = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_tpe = tpe;
  this.Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_columnName = columnName
}
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype.productPrefix__T = (function() {
  return "ForgetColumn"
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_tpe;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_columnName;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn)) {
    var ForgetColumn$1 = $as_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn(x$1);
    return ((this.Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_tpe === $n(ForgetColumn$1).Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_tpe) && (this.Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_columnName === $n(ForgetColumn$1).Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn__f_columnName))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.table.ForgetColumn"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.table.ForgetColumn;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn: 0
}, false, "com.iz2use.react.components.internal.multiview.table.ForgetColumn", {
  Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend: 0
}, false, "com.iz2use.react.components.internal.multiview.table.TabularLine$Backend", {
  Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend: 1,
  Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(key, model, map, renderer, editing, itemSimpleActions, selected, focused, ref, setActive, setActiveAndSelectView, decorator) {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_key = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_map = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_renderer = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_editing = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_itemSimpleActions = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_selected = false;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_focused = false;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_ref = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActive = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActiveAndSelectView = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_decorator = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_key = key;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model = model;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_map = map;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_renderer = renderer;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_editing = editing;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_itemSimpleActions = itemSimpleActions;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_selected = selected;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_focused = focused;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_ref = ref;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActive = setActive;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActiveAndSelectView = setActiveAndSelectView;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_decorator = decorator
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype.productArity__I = (function() {
  return 12
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_key;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_map;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_renderer;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_editing;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_itemSimpleActions;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_selected;
      break
    }
    case 7: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_focused;
      break
    }
    case 8: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_ref;
      break
    }
    case 9: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActive;
      break
    }
    case 10: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActiveAndSelectView;
      break
    }
    case 11: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_decorator;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_key;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_map;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_renderer;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_editing;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$5 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_itemSimpleActions;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var data$7 = (this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_selected ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var data$8 = (this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_focused ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$6 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_ref;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$7 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActive;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var x$8 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActiveAndSelectView;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$8);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  var x$9 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_decorator;
  var data$12 = $m_sr_Statics$().anyHash__O__I(x$9);
  acc = $m_sr_Statics$().mix__I__I__I(hash$12, data$12);
  var hash$13 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$13, 12)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(x$1);
    if (((this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_selected === $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_selected) && ((this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_focused === $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_focused) && (this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_key === $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_key)))) {
      var x = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model;
      var y = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_model;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
        var x$2 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_map;
        var x$2$1 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_map;
        if (((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))) {
          var x$3 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_renderer;
          var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_renderer;
          if ((x$3 === null)) {
            var $$x1 = (x$4 === null)
          } else {
            var this$1 = $n(x$3);
            var $$x1 = (this$1 === x$4)
          }
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_editing;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_editing;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_itemSimpleActions;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_itemSimpleActions;
        if ((x$7 === null)) {
          var $$x3 = (x$8 === null)
        } else {
          var this$2 = $n(x$7);
          var $$x3 = (this$2 === x$8)
        };
        if ($$x3) {
          var x$9 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_ref;
          var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_ref;
          var $$x2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          var $$x2 = false
        }
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$11 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActive;
        var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActive;
        if ((x$11 === null)) {
          var $$x4 = (x$12 === null)
        } else {
          var this$3 = $n(x$11);
          var $$x4 = (this$3 === x$12)
        };
        if ($$x4) {
          var x$13 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActiveAndSelectView;
          var x$14 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_setActiveAndSelectView;
          if ((x$13 === null)) {
            var $$x5 = (x$14 === null)
          } else {
            var this$4 = $n(x$13);
            var $$x5 = (this$4 === x$14)
          };
          if ($$x5) {
            var x$15 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_decorator;
            var x$16 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps__f_decorator;
            if ((x$15 === null)) {
              return (x$16 === null)
            } else {
              var this$5 = $n(x$15);
              return (this$5 === x$16)
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.table.TabularLine$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.table.TabularLine$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps: 0
}, false, "com.iz2use.react.components.internal.multiview.table.TabularLine$TypedProps", {
  Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_TabularLine$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_renderHeaders = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_activeRowRef = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_scrollDirection = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_axes = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_setActive = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_setActiveAndGotoSlideshow = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_axesContext = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend__(this)
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend: 0
}, false, "com.iz2use.react.components.internal.multiview.table.TabularView$Backend", {
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend: 1,
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(items, active, keyMapper, renderer, itemSimpleActions, context, hasIterator, decorator) {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_active = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_itemSimpleActions = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_context = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_hasIterator = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_decorator = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items = items;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_active = active;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper = keyMapper;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer = renderer;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_itemSimpleActions = itemSimpleActions;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_context = context;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_hasIterator = hasIterator;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_decorator = decorator
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype.productArity__I = (function() {
  return 5
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_active;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_itemSimpleActions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_active;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_active;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper;
      if ((x$5 === null)) {
        var $$x2 = (x$6 === null)
      } else {
        var this$1 = $n(x$5);
        var $$x2 = (this$1 === x$6)
      };
      if ($$x2) {
        var x$7 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_renderer;
        if ((x$7 === null)) {
          var $$x3 = (x$8 === null)
        } else {
          var this$2 = $n(x$7);
          var $$x3 = (this$2 === x$8)
        };
        if ($$x3) {
          var x$9 = this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_itemSimpleActions;
          var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_itemSimpleActions;
          if ((x$9 === null)) {
            return (x$10 === null)
          } else {
            var this$3 = $n(x$9);
            return (this$3 === x$10)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.table.TabularView$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.table.TabularView$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps: 0
}, false, "com.iz2use.react.components.internal.multiview.table.TabularView$TypedProps", {
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState(editing) {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__f_editing = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__f_editing = editing
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__f_editing : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState)) {
    var TypedState$1 = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__f_editing;
    var x$2 = $n(TypedState$1).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState__f_editing;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.table.TabularView$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.table.TabularView$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState: 0
}, false, "com.iz2use.react.components.internal.multiview.table.TabularView$TypedState", {
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_onKeyDown = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend__(this)
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$Backend", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(search, open, context, focusHandler, renderItem, fetcher, fetcherBackend, filter, keyOf, equiv, handleNonexistent, tokenMatcher, tokenizer, highlighter) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_search = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_open = false;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_focusHandler = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_renderItem = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_fetcher = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_fetcherBackend = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_filter = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_keyOf = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_equiv = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_handleNonexistent = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_tokenMatcher = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_tokenizer = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_highlighter = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_search = search;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_open = open;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context = context;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_focusHandler = focusHandler;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_renderItem = renderItem;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_fetcher = fetcher;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_fetcherBackend = fetcherBackend;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_filter = filter;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_keyOf = keyOf;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_equiv = equiv;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_handleNonexistent = handleNonexistent;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_tokenMatcher = tokenMatcher;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_tokenizer = tokenizer;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_highlighter = highlighter
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype.productArity__I = (function() {
  return 5
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_search;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_open;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_focusHandler;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_renderItem;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_search;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_open ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_focusHandler;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_renderItem;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(x$1);
    if (((this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_open === $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_open) && (this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_search === $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_search))) {
      var x = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context;
      var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_focusHandler;
        var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_focusHandler;
        if ((x$3 === null)) {
          var $$x1 = (x$4 === null)
        } else {
          var this$1 = $n(x$3);
          var $$x1 = (this$1 === x$4)
        };
        if ($$x1) {
          var x$5 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_renderItem;
          var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_renderItem;
          if ((x$5 === null)) {
            return (x$6 === null)
          } else {
            var this$2 = $n(x$5);
            return (this$2 === x$6)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedProps", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState)
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedState", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionItem$Backend", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps(item, matches, highlighter, f) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_item = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_matches = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_highlighter = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_f = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_item = item;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_matches = matches;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_highlighter = highlighter;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_f = f
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.render__Ljapgolly_scalajs_react_vdom_VdomElement = (function() {
  return $as_Ljapgolly_scalajs_react_vdom_VdomElement($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_f).apply__O__O__O(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_item, $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_highlighter).highlight__sci_Seq__Lcom_iz2use_common_internal_tokenizer_Tokenized__O($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_matches).Lcom_iz2use_common_TokenMatches__f_matches, $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_matches).Lcom_iz2use_common_TokenMatches__f_tokenized)))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.productArity__I = (function() {
  return 4
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_item;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_matches;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_highlighter;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_item;
    var y = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_item;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_matches;
      var x$2$1 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_matches;
      var $$x1 = ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_highlighter;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_highlighter;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x2 = (this$1 === x$4)
      };
      if ($$x2) {
        var x$5 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_f;
        var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps__f_f;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$2 = $n(x$5);
          return (this$2 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionItem$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionItem$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionItem$TypedProps", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState(rendered) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState__f_rendered = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState__f_rendered = rendered
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState__f_rendered : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState)) {
    var TypedState$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState__f_rendered;
    var x$2 = $n(TypedState$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState__f_rendered;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionItem$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionItem$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionItem$TypedState", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionItem$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps(search, context, focusHandler, create, fetcher, fetcherBackend, filter, keyOf, equiv, tokenizer, tokenMatcher, highlighter, renderItem) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_search = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_context = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_focusHandler = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_create = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcher = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcherBackend = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_filter = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_keyOf = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_equiv = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenizer = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenMatcher = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_highlighter = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_renderItem = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_search = search;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_context = context;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_focusHandler = focusHandler;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_create = create;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcher = fetcher;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcherBackend = fetcherBackend;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_filter = filter;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_keyOf = keyOf;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_equiv = equiv;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenizer = tokenizer;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenMatcher = tokenMatcher;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_highlighter = highlighter;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_renderItem = renderItem
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype.productArity__I = (function() {
  return 13
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_search;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_context;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_focusHandler;
      break
    }
    case 3: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_create);
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcher;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcherBackend;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_filter;
      break
    }
    case 7: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_keyOf;
      break
    }
    case 8: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_equiv;
      break
    }
    case 9: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenizer;
      break
    }
    case 10: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenMatcher;
      break
    }
    case 11: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_highlighter;
      break
    }
    case 12: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_renderItem;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps(x$1);
    if ((this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_search === $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_search)) {
      var x = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_context;
      var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_context;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_focusHandler;
        var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_focusHandler;
        if ((x$3 === null)) {
          var $$x2 = (x$4 === null)
        } else {
          var this$1 = $n(x$3);
          var $$x2 = (this$1 === x$4)
        }
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_create;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_create;
      if ((x$5 === null)) {
        var $$x3 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x3 = (this$2 === x$6)
      };
      if ($$x3) {
        var x$7 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcher;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcher;
        if ((x$7 === null)) {
          var $$x4 = (x$8 === null)
        } else {
          var this$3 = $n(x$7);
          var $$x4 = (this$3 === x$8)
        };
        if ($$x4) {
          var x$9 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcherBackend;
          var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_fetcherBackend;
          if ((x$9 === null)) {
            var $$x1 = (x$10 === null)
          } else {
            var this$4 = $n(x$9);
            var $$x1 = (this$4 === x$10)
          }
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_filter;
      var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_filter;
      if ((x$11 === null)) {
        var $$x6 = (x$12 === null)
      } else {
        var this$5 = $n(x$11);
        var $$x6 = (this$5 === x$12)
      };
      if ($$x6) {
        var x$13 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_keyOf;
        var x$14 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_keyOf;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          var x$15 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_equiv;
          var x$16 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_equiv;
          var $$x5 = ((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))
        } else {
          var $$x5 = false
        }
      } else {
        var $$x5 = false
      };
      if ($$x5) {
        var x$17 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenizer;
        var x$18 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenizer;
        if ((x$17 === null)) {
          var $$x8 = (x$18 === null)
        } else {
          var this$6 = $n(x$17);
          var $$x8 = (this$6 === x$18)
        };
        if ($$x8) {
          var x$19 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenMatcher;
          var x$20 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_tokenMatcher;
          if ((x$19 === null)) {
            var $$x7 = (x$20 === null)
          } else {
            var this$7 = $n(x$19);
            var $$x7 = (this$7 === x$20)
          }
        } else {
          var $$x7 = false
        };
        if ($$x7) {
          var x$21 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_highlighter;
          var x$22 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_highlighter;
          if ((x$21 === null)) {
            var $$x9 = (x$22 === null)
          } else {
            var this$8 = $n(x$21);
            var $$x9 = (this$8 === x$22)
          };
          if ($$x9) {
            var x$23 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_renderItem;
            var x$24 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps__f_renderItem;
            if ((x$23 === null)) {
              return (x$24 === null)
            } else {
              var this$9 = $n(x$23);
              return (this$9 === x$24)
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionList$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionList$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionList$TypedProps", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionList$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend__f_$ = \u03b4;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFetcher$Backend", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(tokenizedSearch, fetcher, fetcherBackend, filter, tokenizer, tokenMatcher, renderFn) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizedSearch = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcher = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcherBackend = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_filter = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizer = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenMatcher = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_renderFn = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizedSearch = tokenizedSearch;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcher = fetcher;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcherBackend = fetcherBackend;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_filter = filter;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizer = tokenizer;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenMatcher = tokenMatcher;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_renderFn = renderFn
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.mapTokenize__sci_Seq__sci_Seq = (function(items) {
  return $as_sci_Seq($n(items).map__F1__O(new $c_sjsr_AnonFunction1(((i$2) => {
    var y = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizer).tokenize__O__Lcom_iz2use_common_Filter__Lcom_iz2use_common_internal_tokenizer_Tokenized(i$2, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_filter);
    return $ct_T2__O__O__(new $c_T2(), i$2, y)
  }))))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.mapMatch__sci_Seq__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__sci_Seq = (function(loadedItems, search) {
  var this$5 = $n($as_sc_SeqOps($n(loadedItems).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var i = $n(x0$1)._1__O();
      var r = $as_Lcom_iz2use_common_internal_tokenizer_Tokenized($n(x0$1)._2__O());
      var this$3 = $n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenMatcher);
      var y = $f_Lcom_iz2use_common_ForeachQueryTokenMatcher__matches__Lcom_iz2use_common_internal_tokenizer_SeqTokenized__Lcom_iz2use_common_internal_tokenizer_Tokenized__Lcom_iz2use_common_TokenMatches(this$3, search, r);
      return $ct_T2__O__O__(new $c_T2(), i, y)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))));
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T2(x$1$2);
    return $as_Lcom_iz2use_common_TokenMatches($n(x$1)._2__O())
  }));
  var ord = $m_Lcom_iz2use_common_TokenMatches$().tokenMatchesOrdering__s_math_Ordering();
  return $as_sci_Seq($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$5, f, ord))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.productArity__I = (function() {
  return 7
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizedSearch;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcher;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcherBackend;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_filter;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizer;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenMatcher;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_renderFn;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizedSearch;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizedSearch;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcher;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcher;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x2 = (this$1 === x$4)
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcherBackend;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_fetcherBackend;
      if ((x$5 === null)) {
        var $$x3 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x3 = (this$2 === x$6)
      };
      if ($$x3) {
        var x$7 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_filter;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_filter;
        if ((x$7 === null)) {
          var $$x1 = (x$8 === null)
        } else {
          var this$3 = $n(x$7);
          var $$x1 = (this$3 === x$8)
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizer;
      var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenizer;
      if ((x$9 === null)) {
        var $$x5 = (x$10 === null)
      } else {
        var this$4 = $n(x$9);
        var $$x5 = (this$4 === x$10)
      };
      if ($$x5) {
        var x$11 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenMatcher;
        var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_tokenMatcher;
        if ((x$11 === null)) {
          var $$x4 = (x$12 === null)
        } else {
          var this$5 = $n(x$11);
          var $$x4 = (this$5 === x$12)
        }
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var x$13 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_renderFn;
        var x$14 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps__f_renderFn;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          $n(TypedProps$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedProps", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(loadedItems, showedItems) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems = loadedItems;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems = showedItems
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.updating$default$1__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ldiode_data_Pot(x$2);
    return x
  }))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState)) {
    var TypedState$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems;
    var x$2 = $n(TypedState$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems;
      var x$4 = $n(TypedState$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(TypedState$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedState", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend(\u03b4) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_scrollTo = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_listRef = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend__f_$ = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend__f_$ = \u03b4;
  $ct_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend__(this)
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend.prototype;
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFocuser$Backend", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$Backend;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(items, context, focusHandler, keyOf, equiv, highlighter, renderItem, create) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_context = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_focusHandler = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_keyOf = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_equiv = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_highlighter = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_renderItem = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_create = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items = items;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_context = context;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_focusHandler = focusHandler;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_keyOf = keyOf;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_equiv = equiv;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_highlighter = highlighter;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_renderItem = renderItem;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_create = create
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype.productArity__I = (function() {
  return 8
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_context;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_focusHandler;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_keyOf;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_equiv;
      break
    }
    case 5: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_highlighter;
      break
    }
    case 6: {
      return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_renderItem;
      break
    }
    case 7: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_create);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps)) {
    var TypedProps$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(x$1);
    var x = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items;
    var x$2 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_items;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_context;
      var x$4 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_context;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_focusHandler;
      var x$6 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_focusHandler;
      if ((x$5 === null)) {
        var $$x3 = (x$6 === null)
      } else {
        var this$1 = $n(x$5);
        var $$x3 = (this$1 === x$6)
      };
      if ($$x3) {
        var x$7 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_keyOf;
        var x$8 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_keyOf;
        var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_equiv;
      var x$10 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_equiv;
      if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
        var x$11 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_highlighter;
        var x$12 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_highlighter;
        if ((x$11 === null)) {
          var $$x4 = (x$12 === null)
        } else {
          var this$2 = $n(x$11);
          var $$x4 = (this$2 === x$12)
        }
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var x$13 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_renderItem;
        var x$14 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_renderItem;
        if ((x$13 === null)) {
          var $$x5 = (x$14 === null)
        } else {
          var this$3 = $n(x$13);
          var $$x5 = (this$3 === x$14)
        };
        if ($$x5) {
          var x$15 = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_create;
          var x$16 = $n(TypedProps$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_create;
          if ((x$15 === null)) {
            return (x$16 === null)
          } else {
            var this$4 = $n(x$15);
            return (this$4 === x$16)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedProps"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedProps;", depth))
}
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedProps", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState(selected) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__f_selected = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__f_selected = selected
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__f_selected : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState)) {
    var TypedState$1 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__f_selected;
    var x$2 = $n(TypedState$1).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__f_selected;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedState", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState;
/** @constructor */
function $c_Lcom_iz2use_react_style_Theme(background, foreground, highlight, focused, lineBorder) {
  this.Lcom_iz2use_react_style_Theme__f_background = null;
  this.Lcom_iz2use_react_style_Theme__f_foreground = null;
  this.Lcom_iz2use_react_style_Theme__f_highlight = null;
  this.Lcom_iz2use_react_style_Theme__f_focused = null;
  this.Lcom_iz2use_react_style_Theme__f_lineBorder = null;
  this.Lcom_iz2use_react_style_Theme__f_background = background;
  this.Lcom_iz2use_react_style_Theme__f_foreground = foreground;
  this.Lcom_iz2use_react_style_Theme__f_highlight = highlight;
  this.Lcom_iz2use_react_style_Theme__f_focused = focused;
  this.Lcom_iz2use_react_style_Theme__f_lineBorder = lineBorder
}
$c_Lcom_iz2use_react_style_Theme.prototype = new $h_O();
$c_Lcom_iz2use_react_style_Theme.prototype.constructor = $c_Lcom_iz2use_react_style_Theme;
/** @constructor */
function $h_Lcom_iz2use_react_style_Theme() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_Theme.prototype = $c_Lcom_iz2use_react_style_Theme.prototype;
$c_Lcom_iz2use_react_style_Theme.prototype.productPrefix__T = (function() {
  return "Theme"
});
$c_Lcom_iz2use_react_style_Theme.prototype.productArity__I = (function() {
  return 5
});
$c_Lcom_iz2use_react_style_Theme.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_style_Theme__f_background;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_style_Theme__f_foreground;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_style_Theme__f_highlight;
      break
    }
    case 3: {
      return this.Lcom_iz2use_react_style_Theme__f_focused;
      break
    }
    case 4: {
      return this.Lcom_iz2use_react_style_Theme__f_lineBorder;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_style_Theme.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_Theme.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_style_Theme.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_style_Theme.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_style_Theme)) {
    var Theme$1 = $as_Lcom_iz2use_react_style_Theme(x$1);
    var x = this.Lcom_iz2use_react_style_Theme__f_background;
    var x$2 = $n(Theme$1).Lcom_iz2use_react_style_Theme__f_background;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_style_Theme__f_foreground;
      var x$4 = $n(Theme$1).Lcom_iz2use_react_style_Theme__f_foreground;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcom_iz2use_react_style_Theme__f_highlight;
      var x$6 = $n(Theme$1).Lcom_iz2use_react_style_Theme__f_highlight;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lcom_iz2use_react_style_Theme__f_focused;
        var x$8 = $n(Theme$1).Lcom_iz2use_react_style_Theme__f_focused;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lcom_iz2use_react_style_Theme__f_lineBorder;
          var x$10 = $n(Theme$1).Lcom_iz2use_react_style_Theme__f_lineBorder;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_style_Theme(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_style_Theme) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.style.Theme"))
}
function $isArrayOf_Lcom_iz2use_react_style_Theme(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_style_Theme)))
}
function $asArrayOf_Lcom_iz2use_react_style_Theme(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_style_Theme(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.style.Theme;", depth))
}
var $d_Lcom_iz2use_react_style_Theme = new $TypeData().initClass({
  Lcom_iz2use_react_style_Theme: 0
}, false, "com.iz2use.react.style.Theme", {
  Lcom_iz2use_react_style_Theme: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_Theme.prototype.$classData = $d_Lcom_iz2use_react_style_Theme;
/** @constructor */
function $c_Lcom_iz2use_react_style_ThemeColor(default$1, inverse) {
  this.Lcom_iz2use_react_style_ThemeColor__f_default = null;
  this.Lcom_iz2use_react_style_ThemeColor__f_inverse = null;
  this.Lcom_iz2use_react_style_ThemeColor__f_default = default$1;
  this.Lcom_iz2use_react_style_ThemeColor__f_inverse = inverse
}
$c_Lcom_iz2use_react_style_ThemeColor.prototype = new $h_O();
$c_Lcom_iz2use_react_style_ThemeColor.prototype.constructor = $c_Lcom_iz2use_react_style_ThemeColor;
/** @constructor */
function $h_Lcom_iz2use_react_style_ThemeColor() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_ThemeColor.prototype = $c_Lcom_iz2use_react_style_ThemeColor.prototype;
$c_Lcom_iz2use_react_style_ThemeColor.prototype.productPrefix__T = (function() {
  return "ThemeColor"
});
$c_Lcom_iz2use_react_style_ThemeColor.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_style_ThemeColor.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_style_ThemeColor__f_default;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_style_ThemeColor__f_inverse;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_style_ThemeColor.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_ThemeColor.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_style_ThemeColor.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_style_ThemeColor.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_style_ThemeColor)) {
    var ThemeColor$1 = $as_Lcom_iz2use_react_style_ThemeColor(x$1);
    var x = this.Lcom_iz2use_react_style_ThemeColor__f_default;
    var x$2 = $n(ThemeColor$1).Lcom_iz2use_react_style_ThemeColor__f_default;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_style_ThemeColor__f_inverse;
      var x$4 = $n(ThemeColor$1).Lcom_iz2use_react_style_ThemeColor__f_inverse;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_style_ThemeColor(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_style_ThemeColor) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.style.ThemeColor"))
}
function $isArrayOf_Lcom_iz2use_react_style_ThemeColor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_style_ThemeColor)))
}
function $asArrayOf_Lcom_iz2use_react_style_ThemeColor(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_style_ThemeColor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.style.ThemeColor;", depth))
}
var $d_Lcom_iz2use_react_style_ThemeColor = new $TypeData().initClass({
  Lcom_iz2use_react_style_ThemeColor: 0
}, false, "com.iz2use.react.style.ThemeColor", {
  Lcom_iz2use_react_style_ThemeColor: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_ThemeColor.prototype.$classData = $d_Lcom_iz2use_react_style_ThemeColor;
/** @constructor */
function $c_Lcom_iz2use_react_style_ThemeOneColor(h, s, l) {
  this.Lcom_iz2use_react_style_ThemeOneColor__f_h = 0;
  this.Lcom_iz2use_react_style_ThemeOneColor__f_s = 0;
  this.Lcom_iz2use_react_style_ThemeOneColor__f_l = 0;
  this.Lcom_iz2use_react_style_ThemeOneColor__f_h = h;
  this.Lcom_iz2use_react_style_ThemeOneColor__f_s = s;
  this.Lcom_iz2use_react_style_ThemeOneColor__f_l = l
}
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype = new $h_O();
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.constructor = $c_Lcom_iz2use_react_style_ThemeOneColor;
/** @constructor */
function $h_Lcom_iz2use_react_style_ThemeOneColor() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_ThemeOneColor.prototype = $c_Lcom_iz2use_react_style_ThemeOneColor.prototype;
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.apply__Lcom_iz2use_react_style_OpacityLevel__Lscalacss_internal_DslBase__Lscalacss_internal_ValueT = (function(opacity, dsl) {
  if (($n(opacity).Lcom_iz2use_react_style_OpacityLevel__f_level === 1.0)) {
    var this$1 = $n(dsl);
    var h = this.Lcom_iz2use_react_style_ThemeOneColor__f_h;
    var s = new $c_Lscalacss_internal_Percentage$mcI$sp(this.Lcom_iz2use_react_style_ThemeOneColor__f_s);
    var l = new $c_Lscalacss_internal_Percentage$mcI$sp(this.Lcom_iz2use_react_style_ThemeOneColor__f_l);
    return $as_Lscalacss_internal_ValueT($f_Lscalacss_internal_ColorOps__hsl__I__Lscalacss_internal_Percentage__Lscalacss_internal_Percentage__O(this$1, h, s, l))
  } else {
    var this$2 = $n(dsl);
    var h$1 = this.Lcom_iz2use_react_style_ThemeOneColor__f_h;
    var s$1 = new $c_Lscalacss_internal_Percentage$mcI$sp(this.Lcom_iz2use_react_style_ThemeOneColor__f_s);
    var l$1 = new $c_Lscalacss_internal_Percentage$mcI$sp(this.Lcom_iz2use_react_style_ThemeOneColor__f_l);
    var a = $n(opacity).Lcom_iz2use_react_style_OpacityLevel__f_level;
    return $as_Lscalacss_internal_ValueT($f_Lscalacss_internal_ColorOps__hsla__I__Lscalacss_internal_Percentage__Lscalacss_internal_Percentage__D__O(this$2, h$1, s$1, l$1, a))
  }
});
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.productPrefix__T = (function() {
  return "ThemeOneColor"
});
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_style_ThemeOneColor__f_h;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_style_ThemeOneColor__f_s;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_style_ThemeOneColor__f_l;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ThemeOneColor");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lcom_iz2use_react_style_ThemeOneColor__f_h;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcom_iz2use_react_style_ThemeOneColor__f_s;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lcom_iz2use_react_style_ThemeOneColor__f_l;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_style_ThemeOneColor)) {
    var ThemeOneColor$1 = $as_Lcom_iz2use_react_style_ThemeOneColor(x$1);
    return ((this.Lcom_iz2use_react_style_ThemeOneColor__f_h === $n(ThemeOneColor$1).Lcom_iz2use_react_style_ThemeOneColor__f_h) && ((this.Lcom_iz2use_react_style_ThemeOneColor__f_s === $n(ThemeOneColor$1).Lcom_iz2use_react_style_ThemeOneColor__f_s) && (this.Lcom_iz2use_react_style_ThemeOneColor__f_l === $n(ThemeOneColor$1).Lcom_iz2use_react_style_ThemeOneColor__f_l)))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_style_ThemeOneColor(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_style_ThemeOneColor) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.style.ThemeOneColor"))
}
function $isArrayOf_Lcom_iz2use_react_style_ThemeOneColor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_style_ThemeOneColor)))
}
function $asArrayOf_Lcom_iz2use_react_style_ThemeOneColor(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_style_ThemeOneColor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.style.ThemeOneColor;", depth))
}
var $d_Lcom_iz2use_react_style_ThemeOneColor = new $TypeData().initClass({
  Lcom_iz2use_react_style_ThemeOneColor: 0
}, false, "com.iz2use.react.style.ThemeOneColor", {
  Lcom_iz2use_react_style_ThemeOneColor: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_ThemeOneColor.prototype.$classData = $d_Lcom_iz2use_react_style_ThemeOneColor;
/** @constructor */
function $c_Ldiode_Circuit$Subscription(outer, listener, cursor, lastValue) {
  this.Ldiode_Circuit$Subscription__f_listener = null;
  this.Ldiode_Circuit$Subscription__f_cursor = null;
  this.Ldiode_Circuit$Subscription__f_lastValue = null;
  this.Ldiode_Circuit$Subscription__f_$outer = null;
  this.Ldiode_Circuit$Subscription__f_listener = listener;
  this.Ldiode_Circuit$Subscription__f_cursor = cursor;
  this.Ldiode_Circuit$Subscription__f_lastValue = lastValue;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ldiode_Circuit$Subscription__f_$outer = outer
  }
}
$c_Ldiode_Circuit$Subscription.prototype = new $h_O();
$c_Ldiode_Circuit$Subscription.prototype.constructor = $c_Ldiode_Circuit$Subscription;
/** @constructor */
function $h_Ldiode_Circuit$Subscription() {
  /*<skip>*/
}
$h_Ldiode_Circuit$Subscription.prototype = $c_Ldiode_Circuit$Subscription.prototype;
$c_Ldiode_Circuit$Subscription.prototype.changed__s_Option = (function() {
  if ($n(this.Ldiode_Circuit$Subscription__f_cursor).$eq$eq$eq__O__Z(this.Ldiode_Circuit$Subscription__f_lastValue)) {
    return $m_s_None$()
  } else {
    var $$x1 = $n(this.Ldiode_Circuit$Subscription__f_cursor);
    var this$1 = $n(this.Ldiode_Circuit$Subscription__f_$outer);
    var x$1 = $n($$x1).eval__O__O(this$1.Lreactbuild_analyze_cost_services_AppCircuit$__f_model);
    var x$2 = this.Ldiode_Circuit$Subscription__f_listener;
    var x$3 = this.Ldiode_Circuit$Subscription__f_cursor;
    return new $c_s_Some(new $c_Ldiode_Circuit$Subscription(this.Ldiode_Circuit$Subscription__f_$outer, x$2, x$3, x$1))
  }
});
$c_Ldiode_Circuit$Subscription.prototype.productPrefix__T = (function() {
  return "Subscription"
});
$c_Ldiode_Circuit$Subscription.prototype.productArity__I = (function() {
  return 3
});
$c_Ldiode_Circuit$Subscription.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ldiode_Circuit$Subscription__f_listener;
      break
    }
    case 1: {
      return this.Ldiode_Circuit$Subscription__f_cursor;
      break
    }
    case 2: {
      return this.Ldiode_Circuit$Subscription__f_lastValue;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ldiode_Circuit$Subscription.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_Circuit$Subscription.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiode_Circuit$Subscription.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_Circuit$Subscription.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if (((x$1 instanceof $c_Ldiode_Circuit$Subscription) && ($n($as_Ldiode_Circuit$Subscription(x$1)).Ldiode_Circuit$Subscription__f_$outer === this.Ldiode_Circuit$Subscription__f_$outer))) {
    var Subscription$1 = $as_Ldiode_Circuit$Subscription(x$1);
    var x = this.Ldiode_Circuit$Subscription__f_listener;
    var x$2 = $n(Subscription$1).Ldiode_Circuit$Subscription__f_listener;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ldiode_Circuit$Subscription__f_cursor;
      var x$4 = $n(Subscription$1).Ldiode_Circuit$Subscription__f_cursor;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Ldiode_Circuit$Subscription__f_lastValue;
      var y = $n(Subscription$1).Ldiode_Circuit$Subscription__f_lastValue;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$5, y)) {
        $n(Subscription$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ldiode_Circuit$Subscription(obj) {
  return (((obj instanceof $c_Ldiode_Circuit$Subscription) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.Circuit$Subscription"))
}
function $isArrayOf_Ldiode_Circuit$Subscription(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_Circuit$Subscription)))
}
function $asArrayOf_Ldiode_Circuit$Subscription(obj, depth) {
  return (($isArrayOf_Ldiode_Circuit$Subscription(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.Circuit$Subscription;", depth))
}
var $d_Ldiode_Circuit$Subscription = new $TypeData().initClass({
  Ldiode_Circuit$Subscription: 0
}, false, "diode.Circuit$Subscription", {
  Ldiode_Circuit$Subscription: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_Circuit$Subscription.prototype.$classData = $d_Ldiode_Circuit$Subscription;
/** @constructor */
function $c_Ldiode_EffectSet(head, tail, ec) {
  this.Ldiode_EffectBase__f_ec = null;
  this.Ldiode_EffectSet__f_head = null;
  this.Ldiode_EffectSet__f_tail = null;
  this.Ldiode_EffectSet__f_head = head;
  this.Ldiode_EffectSet__f_tail = tail;
  $ct_Ldiode_EffectBase__s_concurrent_ExecutionContext__(this, ec)
}
$c_Ldiode_EffectSet.prototype = new $h_Ldiode_EffectBase();
$c_Ldiode_EffectSet.prototype.constructor = $c_Ldiode_EffectSet;
/** @constructor */
function $h_Ldiode_EffectSet() {
  /*<skip>*/
}
$h_Ldiode_EffectSet.prototype = $c_Ldiode_EffectSet.prototype;
$c_Ldiode_EffectSet.prototype.run__F1__s_concurrent_Future = (function(dispatch) {
  var f = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_Ldiode_Effect(x$9$2);
    return $n(x$9).run__F1__s_concurrent_Future(dispatch)
  }));
  return $n($f_Ldiode_EffectSetExecutionOps__executeWith__F1__s_concurrent_Future(this, f)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$10$2) => {
    $as_sci_Set(x$10$2)
  })), this.Ldiode_EffectBase__f_ec)
});
$c_Ldiode_EffectSet.prototype.$plus__Ldiode_Effect__Ldiode_EffectSet = (function(that) {
  var $$x1 = this.Ldiode_EffectSet__f_head;
  var this$1 = $n(this.Ldiode_EffectSet__f_tail);
  return new $c_Ldiode_EffectSet($$x1, $as_sci_Set(this$1.incl__O__sci_SetOps(that)), this.Ldiode_EffectBase__f_ec)
});
function $as_Ldiode_EffectSet(obj) {
  return (((obj instanceof $c_Ldiode_EffectSet) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.EffectSet"))
}
function $isArrayOf_Ldiode_EffectSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_EffectSet)))
}
function $asArrayOf_Ldiode_EffectSet(obj, depth) {
  return (($isArrayOf_Ldiode_EffectSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.EffectSet;", depth))
}
var $d_Ldiode_EffectSet = new $TypeData().initClass({
  Ldiode_EffectSet: 0
}, false, "diode.EffectSet", {
  Ldiode_EffectSet: 1,
  Ldiode_EffectBase: 1,
  O: 1,
  Ldiode_Effect: 1,
  Ldiode_EffectSetExecutionOps: 1
});
$c_Ldiode_EffectSet.prototype.$classData = $d_Ldiode_EffectSet;
function $ct_Ldiode_RootModelR__F0__($thiz, get) {
  $thiz.Ldiode_RootModelR__f_get = get;
  return $thiz
}
/** @constructor */
function $c_Ldiode_RootModelR() {
  this.Ldiode_RootModelR__f_get = null
}
$c_Ldiode_RootModelR.prototype = new $h_O();
$c_Ldiode_RootModelR.prototype.constructor = $c_Ldiode_RootModelR;
/** @constructor */
function $h_Ldiode_RootModelR() {
  /*<skip>*/
}
$h_Ldiode_RootModelR.prototype = $c_Ldiode_RootModelR.prototype;
$c_Ldiode_RootModelR.prototype.eval__O__O = (function(model) {
  return $n(this.Ldiode_RootModelR__f_get).apply__O()
});
$c_Ldiode_RootModelR.prototype.value__O = (function() {
  return $n(this.Ldiode_RootModelR__f_get).apply__O()
});
$c_Ldiode_RootModelR.prototype.$eq$eq$eq__O__Z = (function(that) {
  return (this === that)
});
$c_Ldiode_RootModelR.prototype.root__Ldiode_ModelR = (function() {
  return this
});
function $ct_Ldiode_ZoomModelR__Ldiode_ModelR__F1__Ldiode_FastEq__($thiz, root, get, feq) {
  $thiz.Ldiode_ZoomModelR__f_root = root;
  $thiz.Ldiode_ZoomModelR__f_get = get;
  $thiz.Ldiode_ZoomModelR__f_feq = feq;
  return $thiz
}
/** @constructor */
function $c_Ldiode_ZoomModelR() {
  this.Ldiode_ZoomModelR__f_root = null;
  this.Ldiode_ZoomModelR__f_get = null;
  this.Ldiode_ZoomModelR__f_feq = null
}
$c_Ldiode_ZoomModelR.prototype = new $h_O();
$c_Ldiode_ZoomModelR.prototype.constructor = $c_Ldiode_ZoomModelR;
/** @constructor */
function $h_Ldiode_ZoomModelR() {
  /*<skip>*/
}
$h_Ldiode_ZoomModelR.prototype = $c_Ldiode_ZoomModelR.prototype;
$c_Ldiode_ZoomModelR.prototype.value__O = (function() {
  return $f_Ldiode_BaseModelR__value__O(this)
});
$c_Ldiode_ZoomModelR.prototype.root__Ldiode_ModelR = (function() {
  return this.Ldiode_ZoomModelR__f_root
});
$c_Ldiode_ZoomModelR.prototype.eval__O__O = (function(model) {
  return $n(this.Ldiode_ZoomModelR__f_get).apply__O__O(model)
});
$c_Ldiode_ZoomModelR.prototype.$eq$eq$eq__O__Z = (function(that) {
  return $n(this.Ldiode_ZoomModelR__f_feq).eqv__O__O__Z($f_Ldiode_BaseModelR__value__O(this), that)
});
var $d_Ldiode_ZoomModelR = new $TypeData().initClass({
  Ldiode_ZoomModelR: 0
}, false, "diode.ZoomModelR", {
  Ldiode_ZoomModelR: 1,
  O: 1,
  Ldiode_BaseModelR: 1,
  Ldiode_ModelR: 1,
  Ldiode_ModelRO: 1
});
$c_Ldiode_ZoomModelR.prototype.$classData = $d_Ldiode_ZoomModelR;
/** @constructor */
function $c_Ldiode_data_Pot() {
  /*<skip>*/
}
$c_Ldiode_data_Pot.prototype = new $h_O();
$c_Ldiode_data_Pot.prototype.constructor = $c_Ldiode_data_Pot;
/** @constructor */
function $h_Ldiode_data_Pot() {
  /*<skip>*/
}
$h_Ldiode_data_Pot.prototype = $c_Ldiode_data_Pot.prototype;
$c_Ldiode_data_Pot.prototype.isReady__Z = (function() {
  return ((!this.isEmpty__Z()) && (!this.isStale__Z()))
});
$c_Ldiode_data_Pot.prototype.map__F1__Ldiode_data_Pot = (function(f) {
  var x = $m_Ldiode_data_Empty$();
  if ((x === this)) {
    return $m_Ldiode_data_Empty$()
  } else if ((this instanceof $c_Ldiode_data_Ready)) {
    var x3 = $as_Ldiode_data_Ready(this);
    var x$3 = $n(x3).Ldiode_data_Ready__f_x;
    return new $c_Ldiode_data_Ready($n(f).apply__O__O(x$3))
  } else if ((this instanceof $c_Ldiode_data_Pending)) {
    var x4 = $as_Ldiode_data_Pending(this);
    var t = $n(x4).Ldiode_data_Pending__f_startTime;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_Ldiode_data_Pending(new $c_RTLong(lo, hi))
  } else if ((this instanceof $c_Ldiode_data_PendingStale)) {
    var x5 = $as_Ldiode_data_PendingStale(this);
    var x$4 = $n(x5).Ldiode_data_PendingStale__f_x;
    var t$1 = $n(x5).Ldiode_data_PendingStale__f_startTime;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    return new $c_Ldiode_data_PendingStale($n(f).apply__O__O(x$4), new $c_RTLong(lo$1, hi$1))
  } else if ((this instanceof $c_Ldiode_data_Failed)) {
    var x6 = $as_Ldiode_data_Failed(this);
    var e = $n(x6).Ldiode_data_Failed__f_exception;
    return new $c_Ldiode_data_Failed(e)
  } else if ((this instanceof $c_Ldiode_data_FailedStale)) {
    var x7 = $as_Ldiode_data_FailedStale(this);
    var x$5 = $n(x7).Ldiode_data_FailedStale__f_x;
    var e$2 = $n(x7).Ldiode_data_FailedStale__f_exception;
    return new $c_Ldiode_data_FailedStale($n(f).apply__O__O(x$5), e$2)
  } else {
    var x$6 = $m_Ldiode_data_Unavailable$();
    if ((x$6 === this)) {
      return $m_Ldiode_data_Unavailable$()
    } else {
      throw new $c_s_MatchError(this)
    }
  }
});
$c_Ldiode_data_Pot.prototype.flatMap__F1__Ldiode_data_Pot = (function(f) {
  var $$x1 = $n(this.map__F1__Ldiode_data_Pot(f));
  var this$1 = $m_s_$less$colon$less$();
  return $n($$x1).flatten__s_$less$colon$less__Ldiode_data_Pot(this$1.s_$less$colon$less$__f_singleton)
});
$c_Ldiode_data_Pot.prototype.flatten__s_$less$colon$less__Ldiode_data_Pot = (function(ev) {
  var x = $m_Ldiode_data_Empty$();
  if ((x === this)) {
    return $m_Ldiode_data_Empty$()
  } else if ((this instanceof $c_Ldiode_data_Ready)) {
    var x3 = $as_Ldiode_data_Ready(this);
    var x$3 = $n(x3).Ldiode_data_Ready__f_x;
    return $as_Ldiode_data_Pot(($n(ev), x$3))
  } else if ((this instanceof $c_Ldiode_data_Pending)) {
    var x4 = $as_Ldiode_data_Pending(this);
    var t = $n(x4).Ldiode_data_Pending__f_startTime;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_Ldiode_data_Pending(new $c_RTLong(lo, hi))
  } else if ((this instanceof $c_Ldiode_data_PendingStale)) {
    var x5 = $as_Ldiode_data_PendingStale(this);
    var x$4 = $n(x5).Ldiode_data_PendingStale__f_x;
    var t$1 = $n(x5).Ldiode_data_PendingStale__f_startTime;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var x1$2 = $as_Ldiode_data_Pot(($n(ev), x$4));
    var x$5 = $m_Ldiode_data_Empty$();
    if ((x$5 === x1$2)) {
      return new $c_Ldiode_data_Pending(new $c_RTLong(lo$1, hi$1))
    } else if ((x1$2 instanceof $c_Ldiode_data_Ready)) {
      var x3$2 = $as_Ldiode_data_Ready(x1$2);
      var y = $n(x3$2).Ldiode_data_Ready__f_x;
      return new $c_Ldiode_data_PendingStale(y, new $c_RTLong(lo$1, hi$1))
    } else if ((x1$2 instanceof $c_Ldiode_data_Pending)) {
      var x4$2 = $as_Ldiode_data_Pending(x1$2);
      var t$2 = $n(x4$2).Ldiode_data_Pending__f_startTime;
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      return new $c_Ldiode_data_Pending((((hi$2 === hi$1) ? (((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) : (hi$2 < hi$1)) ? new $c_RTLong(lo$2, hi$2) : new $c_RTLong(lo$1, hi$1)))
    } else if ((x1$2 instanceof $c_Ldiode_data_PendingStale)) {
      var x5$2 = $as_Ldiode_data_PendingStale(x1$2);
      var y$2 = $n(x5$2).Ldiode_data_PendingStale__f_x;
      var t$3 = $n(x5$2).Ldiode_data_PendingStale__f_startTime;
      var lo$3 = t$3.RTLong__f_lo;
      var hi$3 = t$3.RTLong__f_hi;
      return new $c_Ldiode_data_PendingStale(y$2, (((hi$3 === hi$1) ? (((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$1)) : (hi$3 < hi$1)) ? new $c_RTLong(lo$3, hi$3) : new $c_RTLong(lo$1, hi$1)))
    } else {
      return x1$2
    }
  } else if ((this instanceof $c_Ldiode_data_Failed)) {
    var x6 = $as_Ldiode_data_Failed(this);
    var e = $n(x6).Ldiode_data_Failed__f_exception;
    return new $c_Ldiode_data_Failed(e)
  } else if ((this instanceof $c_Ldiode_data_FailedStale)) {
    var x7 = $as_Ldiode_data_FailedStale(this);
    var x$7 = $n(x7).Ldiode_data_FailedStale__f_x;
    var e$2 = $n(x7).Ldiode_data_FailedStale__f_exception;
    var x1$3 = $as_Ldiode_data_Pot(($n(ev), x$7));
    var x$8 = $m_Ldiode_data_Empty$();
    if ((x$8 === x1$3)) {
      return new $c_Ldiode_data_Failed(e$2)
    } else {
      return x1$3
    }
  } else {
    var x$10 = $m_Ldiode_data_Unavailable$();
    if ((x$10 === this)) {
      return $m_Ldiode_data_Unavailable$()
    } else {
      throw new $c_s_MatchError(this)
    }
  }
});
$c_Ldiode_data_Pot.prototype.contains__O__Z = (function(elem) {
  if ((!this.isEmpty__Z())) {
    var x = this.get__O();
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, elem)
  } else {
    return false
  }
});
$c_Ldiode_data_Pot.prototype.exceptionOption__s_Option = (function() {
  return $m_s_None$()
});
$c_Ldiode_data_Pot.prototype.toTry__s_util_Try = (function() {
  if (this.isEmpty__Z()) {
    return new $c_s_util_Failure($ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException()))
  } else if ((this instanceof $c_Ldiode_data_Failed)) {
    var x2 = $as_Ldiode_data_Failed(this);
    var ex = $n(x2).Ldiode_data_Failed__f_exception;
    return new $c_s_util_Failure(ex)
  } else if ((this instanceof $c_Ldiode_data_FailedStale)) {
    var x3 = $as_Ldiode_data_FailedStale(this);
    var ex$2 = $n(x3).Ldiode_data_FailedStale__f_exception;
    return new $c_s_util_Failure(ex$2)
  } else {
    return new $c_s_util_Success(this.get__O())
  }
});
$c_Ldiode_data_Pot.prototype.toList__sci_List = (function() {
  if (this.isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var elems = $m_sci_Nil$();
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  } else {
    return new $c_sci_$colon$colon(this.get__O(), $m_s_package$().s_package$__f_Nil)
  }
});
function $as_Ldiode_data_Pot(obj) {
  return (((obj instanceof $c_Ldiode_data_Pot) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.data.Pot"))
}
function $isArrayOf_Ldiode_data_Pot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_data_Pot)))
}
function $asArrayOf_Ldiode_data_Pot(obj, depth) {
  return (($isArrayOf_Ldiode_data_Pot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.data.Pot;", depth))
}
/** @constructor */
function $c_Ldiode_react_ModelProxy(modelReader, theDispatch, connector) {
  this.Ldiode_react_ModelProxy__f_modelReader = null;
  this.Ldiode_react_ModelProxy__f_theDispatch = null;
  this.Ldiode_react_ModelProxy__f_connector = null;
  this.Ldiode_react_ModelProxy__f_modelReader = modelReader;
  this.Ldiode_react_ModelProxy__f_theDispatch = theDispatch;
  this.Ldiode_react_ModelProxy__f_connector = connector
}
$c_Ldiode_react_ModelProxy.prototype = new $h_O();
$c_Ldiode_react_ModelProxy.prototype.constructor = $c_Ldiode_react_ModelProxy;
/** @constructor */
function $h_Ldiode_react_ModelProxy() {
  /*<skip>*/
}
$h_Ldiode_react_ModelProxy.prototype = $c_Ldiode_react_ModelProxy.prototype;
$c_Ldiode_react_ModelProxy.prototype.dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline = (function(action, evidence$1) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    $n(this.Ldiode_react_ModelProxy__f_theDispatch).apply__O__O(action)
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Ldiode_react_ModelProxy.prototype.productPrefix__T = (function() {
  return "ModelProxy"
});
$c_Ldiode_react_ModelProxy.prototype.productArity__I = (function() {
  return 3
});
$c_Ldiode_react_ModelProxy.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ldiode_react_ModelProxy__f_modelReader;
      break
    }
    case 1: {
      return this.Ldiode_react_ModelProxy__f_theDispatch;
      break
    }
    case 2: {
      return this.Ldiode_react_ModelProxy__f_connector;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ldiode_react_ModelProxy.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_react_ModelProxy.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiode_react_ModelProxy.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_react_ModelProxy.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ldiode_react_ModelProxy)) {
    var ModelProxy$1 = $as_Ldiode_react_ModelProxy(x$1);
    var x = this.Ldiode_react_ModelProxy__f_modelReader;
    var x$2 = $n(ModelProxy$1).Ldiode_react_ModelProxy__f_modelReader;
    if ((x === null)) {
      var $$x2 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x2 = (this$1 === x$2)
    };
    if ($$x2) {
      var x$3 = this.Ldiode_react_ModelProxy__f_theDispatch;
      var x$4 = $n(ModelProxy$1).Ldiode_react_ModelProxy__f_theDispatch;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Ldiode_react_ModelProxy__f_connector;
      var x$6 = $n(ModelProxy$1).Ldiode_react_ModelProxy__f_connector;
      if ((x$5 === null)) {
        var $$x3 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x3 = (this$2 === x$6)
      };
      if ($$x3) {
        $n(ModelProxy$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ldiode_react_ModelProxy(obj) {
  return (((obj instanceof $c_Ldiode_react_ModelProxy) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.react.ModelProxy"))
}
function $isArrayOf_Ldiode_react_ModelProxy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_react_ModelProxy)))
}
function $asArrayOf_Ldiode_react_ModelProxy(obj, depth) {
  return (($isArrayOf_Ldiode_react_ModelProxy(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.react.ModelProxy;", depth))
}
var $d_Ldiode_react_ModelProxy = new $TypeData().initClass({
  Ldiode_react_ModelProxy: 0
}, false, "diode.react.ModelProxy", {
  Ldiode_react_ModelProxy: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_react_ModelProxy.prototype.$classData = $d_Ldiode_react_ModelProxy;
/** @constructor */
function $c_Leu_timepit_refined_api_Result() {
  /*<skip>*/
}
$c_Leu_timepit_refined_api_Result.prototype = new $h_O();
$c_Leu_timepit_refined_api_Result.prototype.constructor = $c_Leu_timepit_refined_api_Result;
/** @constructor */
function $h_Leu_timepit_refined_api_Result() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_Result.prototype = $c_Leu_timepit_refined_api_Result.prototype;
$c_Leu_timepit_refined_api_Result.prototype.isPassed__Z = (function() {
  if ((this instanceof $c_Leu_timepit_refined_api_Passed)) {
    return true
  } else if ((this instanceof $c_Leu_timepit_refined_api_Failed)) {
    return false
  } else {
    throw new $c_s_MatchError(this)
  }
});
$c_Leu_timepit_refined_api_Result.prototype.isFailed__Z = (function() {
  if ((!(this instanceof $c_Leu_timepit_refined_api_Passed))) {
    if ((this instanceof $c_Leu_timepit_refined_api_Failed)) {
      return true
    } else {
      throw new $c_s_MatchError(this)
    }
  } else {
    return false
  }
});
$c_Leu_timepit_refined_api_Result.prototype.morph__O__O__O = (function(ifPassed, ifFailed) {
  if ((this instanceof $c_Leu_timepit_refined_api_Passed)) {
    var x2 = $as_Leu_timepit_refined_api_Passed(this);
    $n(x2);
    return ifPassed
  } else if ((this instanceof $c_Leu_timepit_refined_api_Failed)) {
    var x3 = $as_Leu_timepit_refined_api_Failed(this);
    $n(x3);
    return ifFailed
  } else {
    throw new $c_s_MatchError(this)
  }
});
function $as_Leu_timepit_refined_api_Result(obj) {
  return (((obj instanceof $c_Leu_timepit_refined_api_Result) || (obj === null)) ? obj : $throwClassCastException(obj, "eu.timepit.refined.api.Result"))
}
function $isArrayOf_Leu_timepit_refined_api_Result(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Leu_timepit_refined_api_Result)))
}
function $asArrayOf_Leu_timepit_refined_api_Result(obj, depth) {
  return (($isArrayOf_Leu_timepit_refined_api_Result(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Leu.timepit.refined.api.Result;", depth))
}
/** @constructor */
function $c_Leu_timepit_refined_boolean$Not(p) {
  this.Leu_timepit_refined_boolean$Not__f_p = null;
  this.Leu_timepit_refined_boolean$Not__f_p = p
}
$c_Leu_timepit_refined_boolean$Not.prototype = new $h_O();
$c_Leu_timepit_refined_boolean$Not.prototype.constructor = $c_Leu_timepit_refined_boolean$Not;
/** @constructor */
function $h_Leu_timepit_refined_boolean$Not() {
  /*<skip>*/
}
$h_Leu_timepit_refined_boolean$Not.prototype = $c_Leu_timepit_refined_boolean$Not.prototype;
$c_Leu_timepit_refined_boolean$Not.prototype.productPrefix__T = (function() {
  return "Not"
});
$c_Leu_timepit_refined_boolean$Not.prototype.productArity__I = (function() {
  return 1
});
$c_Leu_timepit_refined_boolean$Not.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Leu_timepit_refined_boolean$Not__f_p : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Leu_timepit_refined_boolean$Not.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Leu_timepit_refined_boolean$Not.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Leu_timepit_refined_boolean$Not.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Leu_timepit_refined_boolean$Not.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Leu_timepit_refined_boolean$Not)) {
    var Not$1 = $as_Leu_timepit_refined_boolean$Not(x$1);
    var x = this.Leu_timepit_refined_boolean$Not__f_p;
    var y = $n(Not$1).Leu_timepit_refined_boolean$Not__f_p;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Leu_timepit_refined_boolean$Not(obj) {
  return (((obj instanceof $c_Leu_timepit_refined_boolean$Not) || (obj === null)) ? obj : $throwClassCastException(obj, "eu.timepit.refined.boolean$Not"))
}
function $isArrayOf_Leu_timepit_refined_boolean$Not(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Leu_timepit_refined_boolean$Not)))
}
function $asArrayOf_Leu_timepit_refined_boolean$Not(obj, depth) {
  return (($isArrayOf_Leu_timepit_refined_boolean$Not(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Leu.timepit.refined.boolean$Not;", depth))
}
var $d_Leu_timepit_refined_boolean$Not = new $TypeData().initClass({
  Leu_timepit_refined_boolean$Not: 0
}, false, "eu.timepit.refined.boolean$Not", {
  Leu_timepit_refined_boolean$Not: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_boolean$Not.prototype.$classData = $d_Leu_timepit_refined_boolean$Not;
/** @constructor */
function $c_Leu_timepit_refined_internal_WitnessAs(fst, snd) {
  this.Leu_timepit_refined_internal_WitnessAs__f_fst = null;
  this.Leu_timepit_refined_internal_WitnessAs__f_snd = null;
  this.Leu_timepit_refined_internal_WitnessAs__f_fst = fst;
  this.Leu_timepit_refined_internal_WitnessAs__f_snd = snd
}
$c_Leu_timepit_refined_internal_WitnessAs.prototype = new $h_O();
$c_Leu_timepit_refined_internal_WitnessAs.prototype.constructor = $c_Leu_timepit_refined_internal_WitnessAs;
/** @constructor */
function $h_Leu_timepit_refined_internal_WitnessAs() {
  /*<skip>*/
}
$h_Leu_timepit_refined_internal_WitnessAs.prototype = $c_Leu_timepit_refined_internal_WitnessAs.prototype;
$c_Leu_timepit_refined_internal_WitnessAs.prototype.productPrefix__T = (function() {
  return "WitnessAs"
});
$c_Leu_timepit_refined_internal_WitnessAs.prototype.productArity__I = (function() {
  return 2
});
$c_Leu_timepit_refined_internal_WitnessAs.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Leu_timepit_refined_internal_WitnessAs__f_fst;
      break
    }
    case 1: {
      return this.Leu_timepit_refined_internal_WitnessAs__f_snd;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Leu_timepit_refined_internal_WitnessAs.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Leu_timepit_refined_internal_WitnessAs.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Leu_timepit_refined_internal_WitnessAs.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Leu_timepit_refined_internal_WitnessAs.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Leu_timepit_refined_internal_WitnessAs)) {
    var WitnessAs$1 = $as_Leu_timepit_refined_internal_WitnessAs(x$1);
    var x = this.Leu_timepit_refined_internal_WitnessAs__f_fst;
    var y = $n(WitnessAs$1).Leu_timepit_refined_internal_WitnessAs__f_fst;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Leu_timepit_refined_internal_WitnessAs__f_snd;
      var y$1 = $n(WitnessAs$1).Leu_timepit_refined_internal_WitnessAs__f_snd;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Leu_timepit_refined_internal_WitnessAs(obj) {
  return (((obj instanceof $c_Leu_timepit_refined_internal_WitnessAs) || (obj === null)) ? obj : $throwClassCastException(obj, "eu.timepit.refined.internal.WitnessAs"))
}
function $isArrayOf_Leu_timepit_refined_internal_WitnessAs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Leu_timepit_refined_internal_WitnessAs)))
}
function $asArrayOf_Leu_timepit_refined_internal_WitnessAs(obj, depth) {
  return (($isArrayOf_Leu_timepit_refined_internal_WitnessAs(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Leu.timepit.refined.internal.WitnessAs;", depth))
}
var $d_Leu_timepit_refined_internal_WitnessAs = new $TypeData().initClass({
  Leu_timepit_refined_internal_WitnessAs: 0
}, false, "eu.timepit.refined.internal.WitnessAs", {
  Leu_timepit_refined_internal_WitnessAs: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_internal_WitnessAs.prototype.$classData = $d_Leu_timepit_refined_internal_WitnessAs;
/** @constructor */
function $c_Leu_timepit_refined_numeric$Less(n) {
  this.Leu_timepit_refined_numeric$Less__f_n = null;
  this.Leu_timepit_refined_numeric$Less__f_n = n
}
$c_Leu_timepit_refined_numeric$Less.prototype = new $h_O();
$c_Leu_timepit_refined_numeric$Less.prototype.constructor = $c_Leu_timepit_refined_numeric$Less;
/** @constructor */
function $h_Leu_timepit_refined_numeric$Less() {
  /*<skip>*/
}
$h_Leu_timepit_refined_numeric$Less.prototype = $c_Leu_timepit_refined_numeric$Less.prototype;
$c_Leu_timepit_refined_numeric$Less.prototype.productPrefix__T = (function() {
  return "Less"
});
$c_Leu_timepit_refined_numeric$Less.prototype.productArity__I = (function() {
  return 1
});
$c_Leu_timepit_refined_numeric$Less.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Leu_timepit_refined_numeric$Less__f_n : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Leu_timepit_refined_numeric$Less.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Leu_timepit_refined_numeric$Less.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Leu_timepit_refined_numeric$Less.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Leu_timepit_refined_numeric$Less.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Leu_timepit_refined_numeric$Less)) {
    var Less$1 = $as_Leu_timepit_refined_numeric$Less(x$1);
    var x = this.Leu_timepit_refined_numeric$Less__f_n;
    var y = $n(Less$1).Leu_timepit_refined_numeric$Less__f_n;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Leu_timepit_refined_numeric$Less(obj) {
  return (((obj instanceof $c_Leu_timepit_refined_numeric$Less) || (obj === null)) ? obj : $throwClassCastException(obj, "eu.timepit.refined.numeric$Less"))
}
function $isArrayOf_Leu_timepit_refined_numeric$Less(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Leu_timepit_refined_numeric$Less)))
}
function $asArrayOf_Leu_timepit_refined_numeric$Less(obj, depth) {
  return (($isArrayOf_Leu_timepit_refined_numeric$Less(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Leu.timepit.refined.numeric$Less;", depth))
}
var $d_Leu_timepit_refined_numeric$Less = new $TypeData().initClass({
  Leu_timepit_refined_numeric$Less: 0
}, false, "eu.timepit.refined.numeric$Less", {
  Leu_timepit_refined_numeric$Less: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_numeric$Less.prototype.$classData = $d_Leu_timepit_refined_numeric$Less;
/** @constructor */
function $c_Lfastparse_Parsed$TracedFailure(terminals, groups, failure) {
  this.Lfastparse_Parsed$TracedFailure__f_terminals = null;
  this.Lfastparse_Parsed$TracedFailure__f_groups = null;
  this.Lfastparse_Parsed$TracedFailure__f_failure = null;
  this.Lfastparse_Parsed$TracedFailure__f_terminals = terminals;
  this.Lfastparse_Parsed$TracedFailure__f_groups = groups;
  this.Lfastparse_Parsed$TracedFailure__f_failure = failure
}
$c_Lfastparse_Parsed$TracedFailure.prototype = new $h_O();
$c_Lfastparse_Parsed$TracedFailure.prototype.constructor = $c_Lfastparse_Parsed$TracedFailure;
/** @constructor */
function $h_Lfastparse_Parsed$TracedFailure() {
  /*<skip>*/
}
$h_Lfastparse_Parsed$TracedFailure.prototype = $c_Lfastparse_Parsed$TracedFailure.prototype;
$c_Lfastparse_Parsed$TracedFailure.prototype.input__Lfastparse_ParserInput = (function() {
  return $n($n(this.Lfastparse_Parsed$TracedFailure__f_failure).Lfastparse_Parsed$Failure__f_extra).Lfastparse_Parsed$Extra__f_input
});
$c_Lfastparse_Parsed$TracedFailure.prototype.stack__sci_List = (function() {
  return $n($n(this.Lfastparse_Parsed$TracedFailure__f_failure).Lfastparse_Parsed$Failure__f_extra).Lfastparse_Parsed$Extra__f_stack
});
$c_Lfastparse_Parsed$TracedFailure.prototype.aggregateMsg__T = (function() {
  var $$x2 = $m_Lfastparse_Parsed$Failure$();
  var $$x1 = this.input__Lfastparse_ParserInput();
  $m_sci_List$();
  var this$1 = $n(this.Lfastparse_Parsed$TracedFailure__f_groups);
  var self = $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this$1.Lfastparse_internal_Msgs__f_value);
  var y = $n(this.Lfastparse_Parsed$TracedFailure__f_failure).Lfastparse_Parsed$Failure__f_index;
  var array = [$ct_T2__O__O__(new $c_T2(), self, y)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $n($$x2).formatMsg__Lfastparse_ParserInput__sci_List__I__T($$x1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), $n(this.Lfastparse_Parsed$TracedFailure__f_failure).Lfastparse_Parsed$Failure__f_index)
});
$c_Lfastparse_Parsed$TracedFailure.prototype.productPrefix__T = (function() {
  return "TracedFailure"
});
$c_Lfastparse_Parsed$TracedFailure.prototype.productArity__I = (function() {
  return 3
});
$c_Lfastparse_Parsed$TracedFailure.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lfastparse_Parsed$TracedFailure__f_terminals;
      break
    }
    case 1: {
      return this.Lfastparse_Parsed$TracedFailure__f_groups;
      break
    }
    case 2: {
      return this.Lfastparse_Parsed$TracedFailure__f_failure;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lfastparse_Parsed$TracedFailure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lfastparse_Parsed$TracedFailure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfastparse_Parsed$TracedFailure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfastparse_Parsed$TracedFailure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lfastparse_Parsed$TracedFailure)) {
    var TracedFailure$1 = $as_Lfastparse_Parsed$TracedFailure(x$1);
    var x = this.Lfastparse_Parsed$TracedFailure__f_terminals;
    var x$2 = $n(TracedFailure$1).Lfastparse_Parsed$TracedFailure__f_terminals;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lfastparse_Parsed$TracedFailure__f_groups;
      var x$4 = $n(TracedFailure$1).Lfastparse_Parsed$TracedFailure__f_groups;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lfastparse_Parsed$TracedFailure__f_failure;
      var x$6 = $n(TracedFailure$1).Lfastparse_Parsed$TracedFailure__f_failure;
      if ((x$5 === null)) {
        var $$x1 = (x$6 === null)
      } else {
        var this$1 = $n(x$5);
        var $$x1 = (this$1 === x$6)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(TracedFailure$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lfastparse_Parsed$TracedFailure(obj) {
  return (((obj instanceof $c_Lfastparse_Parsed$TracedFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.Parsed$TracedFailure"))
}
function $isArrayOf_Lfastparse_Parsed$TracedFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_Parsed$TracedFailure)))
}
function $asArrayOf_Lfastparse_Parsed$TracedFailure(obj, depth) {
  return (($isArrayOf_Lfastparse_Parsed$TracedFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.Parsed$TracedFailure;", depth))
}
var $d_Lfastparse_Parsed$TracedFailure = new $TypeData().initClass({
  Lfastparse_Parsed$TracedFailure: 0
}, false, "fastparse.Parsed$TracedFailure", {
  Lfastparse_Parsed$TracedFailure: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lfastparse_Parsed$TracedFailure.prototype.$classData = $d_Lfastparse_Parsed$TracedFailure;
/** @constructor */
function $c_Lfastparse_internal_Msgs(value) {
  this.Lfastparse_internal_Msgs__f_value = null;
  this.Lfastparse_internal_Msgs__f_value = value
}
$c_Lfastparse_internal_Msgs.prototype = new $h_O();
$c_Lfastparse_internal_Msgs.prototype.constructor = $c_Lfastparse_internal_Msgs;
/** @constructor */
function $h_Lfastparse_internal_Msgs() {
  /*<skip>*/
}
$h_Lfastparse_internal_Msgs.prototype = $c_Lfastparse_internal_Msgs.prototype;
$c_Lfastparse_internal_Msgs.prototype.$colon$colon$colon__Lfastparse_internal_Msgs__Lfastparse_internal_Msgs = (function(other) {
  var rassoc$1 = $n(other).Lfastparse_internal_Msgs__f_value;
  return new $c_Lfastparse_internal_Msgs($n(this.Lfastparse_internal_Msgs__f_value).$colon$colon$colon__sci_List__sci_List(rassoc$1))
});
$c_Lfastparse_internal_Msgs.prototype.$colon$colon__Lfastparse_internal_Lazy__Lfastparse_internal_Msgs = (function(other) {
  var this$1 = $n(this.Lfastparse_internal_Msgs__f_value);
  return new $c_Lfastparse_internal_Msgs(new $c_sci_$colon$colon(other, this$1))
});
$c_Lfastparse_internal_Msgs.prototype.toString__T = (function() {
  return $m_Lfastparse_internal_Util$().parenthize__sci_Seq__T(this.Lfastparse_internal_Msgs__f_value)
});
$c_Lfastparse_internal_Msgs.prototype.productPrefix__T = (function() {
  return "Msgs"
});
$c_Lfastparse_internal_Msgs.prototype.productArity__I = (function() {
  return 1
});
$c_Lfastparse_internal_Msgs.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lfastparse_internal_Msgs__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lfastparse_internal_Msgs.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lfastparse_internal_Msgs.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfastparse_internal_Msgs.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lfastparse_internal_Msgs)) {
    var Msgs$1 = $as_Lfastparse_internal_Msgs(x$1);
    var x = this.Lfastparse_internal_Msgs__f_value;
    var x$2 = $n(Msgs$1).Lfastparse_internal_Msgs__f_value;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Msgs$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lfastparse_internal_Msgs(obj) {
  return (((obj instanceof $c_Lfastparse_internal_Msgs) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.internal.Msgs"))
}
function $isArrayOf_Lfastparse_internal_Msgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_internal_Msgs)))
}
function $asArrayOf_Lfastparse_internal_Msgs(obj, depth) {
  return (($isArrayOf_Lfastparse_internal_Msgs(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.internal.Msgs;", depth))
}
var $d_Lfastparse_internal_Msgs = new $TypeData().initClass({
  Lfastparse_internal_Msgs: 0
}, false, "fastparse.internal.Msgs", {
  Lfastparse_internal_Msgs: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lfastparse_internal_Msgs.prototype.$classData = $d_Lfastparse_internal_Msgs;
/** @constructor */
function $c_Lio_circe_CollectionDecoders$$anon$2(outer, decodeA$1, factory$2) {
  this.Lio_circe_SeqDecoder__f_decodeA = null;
  this.Lio_circe_CollectionDecoders$$anon$2__f_factory$2 = null;
  this.Lio_circe_CollectionDecoders$$anon$2__f_factory$2 = factory$2;
  $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__(this, decodeA$1)
}
$c_Lio_circe_CollectionDecoders$$anon$2.prototype = new $h_Lio_circe_SeqDecoder();
$c_Lio_circe_CollectionDecoders$$anon$2.prototype.constructor = $c_Lio_circe_CollectionDecoders$$anon$2;
/** @constructor */
function $h_Lio_circe_CollectionDecoders$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_CollectionDecoders$$anon$2.prototype = $c_Lio_circe_CollectionDecoders$$anon$2.prototype;
$c_Lio_circe_CollectionDecoders$$anon$2.prototype.createBuilder__scm_Builder = (function() {
  return $n(this.Lio_circe_CollectionDecoders$$anon$2__f_factory$2).newBuilder__scm_Builder()
});
var $d_Lio_circe_CollectionDecoders$$anon$2 = new $TypeData().initClass({
  Lio_circe_CollectionDecoders$$anon$2: 0
}, false, "io.circe.CollectionDecoders$$anon$2", {
  Lio_circe_CollectionDecoders$$anon$2: 1,
  Lio_circe_SeqDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CollectionDecoders$$anon$2.prototype.$classData = $d_Lio_circe_CollectionDecoders$$anon$2;
/** @constructor */
function $c_Lio_circe_CursorOp() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp.prototype = new $h_O();
$c_Lio_circe_CursorOp.prototype.constructor = $c_Lio_circe_CursorOp;
/** @constructor */
function $h_Lio_circe_CursorOp() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp.prototype = $c_Lio_circe_CursorOp.prototype;
function $as_Lio_circe_CursorOp(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp"))
}
function $isArrayOf_Lio_circe_CursorOp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp)))
}
function $asArrayOf_Lio_circe_CursorOp(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp;", depth))
}
/** @constructor */
function $c_Lio_circe_Decoder$$anon$30() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Float")
}
$c_Lio_circe_Decoder$$anon$30.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$30.prototype.constructor = $c_Lio_circe_Decoder$$anon$30;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$30() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$30.prototype = $c_Lio_circe_Decoder$$anon$30.prototype;
$c_Lio_circe_Decoder$$anon$30.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JNumber)) {
    var x2 = $as_Lio_circe_Json$JNumber(x1);
    var number = $n(x2).Lio_circe_Json$JNumber__f_value;
    $n($m_s_package$().s_package$__f_Right);
    var value = $n(number).toFloat__F();
    return new $c_s_util_Right(value)
  } else if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x3 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x3).Lio_circe_Json$JString__f_value;
    var this$2 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(string));
    if (this$2.isEmpty__Z()) {
      var x1$2 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$6 = $as_Lio_circe_JsonNumber(arg1);
      var x1$2 = new $c_s_Some($n(x$6).toFloat__F())
    };
    if ((x1$2 instanceof $c_s_Some)) {
      var x2$2 = $as_s_Some(x1$2);
      var v = $uF($n(x2$2).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(v)
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else {
    return ($n(x1).isNull__Z() ? ($n($m_s_package$().s_package$__f_Right), new $c_s_util_Right((NaN))) : this.fail__Lio_circe_HCursor__s_util_Either(c))
  }
});
var $d_Lio_circe_Decoder$$anon$30 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$30: 0
}, false, "io.circe.Decoder$$anon$30", {
  Lio_circe_Decoder$$anon$30: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$30.prototype.$classData = $d_Lio_circe_Decoder$$anon$30;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$31() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Double")
}
$c_Lio_circe_Decoder$$anon$31.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$31.prototype.constructor = $c_Lio_circe_Decoder$$anon$31;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$31() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$31.prototype = $c_Lio_circe_Decoder$$anon$31.prototype;
$c_Lio_circe_Decoder$$anon$31.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JNumber)) {
    var x2 = $as_Lio_circe_Json$JNumber(x1);
    var number = $n(x2).Lio_circe_Json$JNumber__f_value;
    $n($m_s_package$().s_package$__f_Right);
    var value = $n(number).toDouble__D();
    return new $c_s_util_Right(value)
  } else if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x3 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x3).Lio_circe_Json$JString__f_value;
    var this$2 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(string));
    if (this$2.isEmpty__Z()) {
      var x1$2 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$7 = $as_Lio_circe_JsonNumber(arg1);
      var x1$2 = new $c_s_Some($n(x$7).toDouble__D())
    };
    if ((x1$2 instanceof $c_s_Some)) {
      var x2$2 = $as_s_Some(x1$2);
      var v = $uD($n(x2$2).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(v)
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else {
    return ($n(x1).isNull__Z() ? ($n($m_s_package$().s_package$__f_Right), new $c_s_util_Right((NaN))) : this.fail__Lio_circe_HCursor__s_util_Either(c))
  }
});
var $d_Lio_circe_Decoder$$anon$31 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$31: 0
}, false, "io.circe.Decoder$$anon$31", {
  Lio_circe_Decoder$$anon$31: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$31.prototype.$classData = $d_Lio_circe_Decoder$$anon$31;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$32() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Byte")
}
$c_Lio_circe_Decoder$$anon$32.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$32.prototype.constructor = $c_Lio_circe_Decoder$$anon$32;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$32() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$32.prototype = $c_Lio_circe_Decoder$$anon$32.prototype;
$c_Lio_circe_Decoder$$anon$32.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JNumber)) {
    var x2 = $as_Lio_circe_Json$JNumber(x1);
    var number = $n(x2).Lio_circe_Json$JNumber__f_value;
    var x1$2 = $n(number).toByte__s_Option();
    if ((x1$2 instanceof $c_s_Some)) {
      var x2$2 = $as_s_Some(x1$2);
      var v = $uB($n(x2$2).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(v)
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x3 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x3).Lio_circe_Json$JString__f_value;
    var this$2 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(string));
    if (this$2.isEmpty__Z()) {
      var x1$3 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$8 = $as_Lio_circe_JsonNumber(arg1);
      var x1$3 = $n(x$8).toByte__s_Option()
    };
    if ((x1$3 instanceof $c_s_Some)) {
      var x2$3 = $as_s_Some(x1$3);
      var value = $uB($n(x2$3).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(value)
    } else {
      var x$3 = $m_s_None$();
      if ((x$3 === x1$3)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    }
  } else {
    return this.fail__Lio_circe_HCursor__s_util_Either(c)
  }
});
var $d_Lio_circe_Decoder$$anon$32 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$32: 0
}, false, "io.circe.Decoder$$anon$32", {
  Lio_circe_Decoder$$anon$32: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$32.prototype.$classData = $d_Lio_circe_Decoder$$anon$32;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$33() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Short")
}
$c_Lio_circe_Decoder$$anon$33.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$33.prototype.constructor = $c_Lio_circe_Decoder$$anon$33;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$33() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$33.prototype = $c_Lio_circe_Decoder$$anon$33.prototype;
$c_Lio_circe_Decoder$$anon$33.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JNumber)) {
    var x2 = $as_Lio_circe_Json$JNumber(x1);
    var number = $n(x2).Lio_circe_Json$JNumber__f_value;
    var x1$2 = $n(number).toShort__s_Option();
    if ((x1$2 instanceof $c_s_Some)) {
      var x2$2 = $as_s_Some(x1$2);
      var v = $uS($n(x2$2).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(v)
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x3 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x3).Lio_circe_Json$JString__f_value;
    var this$2 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(string));
    if (this$2.isEmpty__Z()) {
      var x1$3 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$9 = $as_Lio_circe_JsonNumber(arg1);
      var x1$3 = $n(x$9).toShort__s_Option()
    };
    if ((x1$3 instanceof $c_s_Some)) {
      var x2$3 = $as_s_Some(x1$3);
      var value = $uS($n(x2$3).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(value)
    } else {
      var x$3 = $m_s_None$();
      if ((x$3 === x1$3)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    }
  } else {
    return this.fail__Lio_circe_HCursor__s_util_Either(c)
  }
});
var $d_Lio_circe_Decoder$$anon$33 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$33: 0
}, false, "io.circe.Decoder$$anon$33", {
  Lio_circe_Decoder$$anon$33: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$33.prototype.$classData = $d_Lio_circe_Decoder$$anon$33;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$34() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Int")
}
$c_Lio_circe_Decoder$$anon$34.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$34.prototype.constructor = $c_Lio_circe_Decoder$$anon$34;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$34() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$34.prototype = $c_Lio_circe_Decoder$$anon$34.prototype;
$c_Lio_circe_Decoder$$anon$34.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JNumber)) {
    var x2 = $as_Lio_circe_Json$JNumber(x1);
    var number = $n(x2).Lio_circe_Json$JNumber__f_value;
    var x1$2 = $n(number).toInt__s_Option();
    if ((x1$2 instanceof $c_s_Some)) {
      var x2$2 = $as_s_Some(x1$2);
      var v = $uI($n(x2$2).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(v)
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x3 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x3).Lio_circe_Json$JString__f_value;
    var this$2 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(string));
    if (this$2.isEmpty__Z()) {
      var x1$3 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$10 = $as_Lio_circe_JsonNumber(arg1);
      var x1$3 = $n(x$10).toInt__s_Option()
    };
    if ((x1$3 instanceof $c_s_Some)) {
      var x2$3 = $as_s_Some(x1$3);
      var value = $uI($n(x2$3).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(value)
    } else {
      var x$3 = $m_s_None$();
      if ((x$3 === x1$3)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    }
  } else {
    return this.fail__Lio_circe_HCursor__s_util_Either(c)
  }
});
var $d_Lio_circe_Decoder$$anon$34 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$34: 0
}, false, "io.circe.Decoder$$anon$34", {
  Lio_circe_Decoder$$anon$34: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$34.prototype.$classData = $d_Lio_circe_Decoder$$anon$34;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$35() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Long")
}
$c_Lio_circe_Decoder$$anon$35.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$35.prototype.constructor = $c_Lio_circe_Decoder$$anon$35;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$35() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$35.prototype = $c_Lio_circe_Decoder$$anon$35.prototype;
$c_Lio_circe_Decoder$$anon$35.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JNumber)) {
    var x2 = $as_Lio_circe_Json$JNumber(x1);
    var number = $n(x2).Lio_circe_Json$JNumber__f_value;
    var x1$2 = $n(number).toLong__s_Option();
    if ((x1$2 instanceof $c_s_Some)) {
      var x2$2 = $as_s_Some(x1$2);
      var t = $uJ($n(x2$2).s_Some__f_value);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(new $c_RTLong(lo, hi))
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x3 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x3).Lio_circe_Json$JString__f_value;
    var this$2 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(string));
    if (this$2.isEmpty__Z()) {
      var x1$3 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$11 = $as_Lio_circe_JsonNumber(arg1);
      var x1$3 = $n(x$11).toLong__s_Option()
    };
    if ((x1$3 instanceof $c_s_Some)) {
      var x2$3 = $as_s_Some(x1$3);
      var t$1 = $uJ($n(x2$3).s_Some__f_value);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(new $c_RTLong(lo$1, hi$1))
    } else {
      var x$3 = $m_s_None$();
      if ((x$3 === x1$3)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    }
  } else {
    return this.fail__Lio_circe_HCursor__s_util_Either(c)
  }
});
var $d_Lio_circe_Decoder$$anon$35 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$35: 0
}, false, "io.circe.Decoder$$anon$35", {
  Lio_circe_Decoder$$anon$35: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$35.prototype.$classData = $d_Lio_circe_Decoder$$anon$35;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$36() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "BigInt")
}
$c_Lio_circe_Decoder$$anon$36.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$36.prototype.constructor = $c_Lio_circe_Decoder$$anon$36;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$36() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$36.prototype = $c_Lio_circe_Decoder$$anon$36.prototype;
$c_Lio_circe_Decoder$$anon$36.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JNumber)) {
    var x2 = $as_Lio_circe_Json$JNumber(x1);
    var number = $n(x2).Lio_circe_Json$JNumber__f_value;
    var x1$2 = $n(number).toBigInt__s_Option();
    if ((x1$2 instanceof $c_s_Some)) {
      var x2$2 = $as_s_Some(x1$2);
      var v = $as_s_math_BigInt($n(x2$2).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(v)
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x3 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x3).Lio_circe_Json$JString__f_value;
    var this$2 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(string));
    if (this$2.isEmpty__Z()) {
      var x1$3 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$12 = $as_Lio_circe_JsonNumber(arg1);
      var x1$3 = $n(x$12).toBigInt__s_Option()
    };
    if ((x1$3 instanceof $c_s_Some)) {
      var x2$3 = $as_s_Some(x1$3);
      var value = $as_s_math_BigInt($n(x2$3).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(value)
    } else {
      var x$3 = $m_s_None$();
      if ((x$3 === x1$3)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    }
  } else {
    return this.fail__Lio_circe_HCursor__s_util_Either(c)
  }
});
var $d_Lio_circe_Decoder$$anon$36 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$36: 0
}, false, "io.circe.Decoder$$anon$36", {
  Lio_circe_Decoder$$anon$36: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$36.prototype.$classData = $d_Lio_circe_Decoder$$anon$36;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$37() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "BigDecimal")
}
$c_Lio_circe_Decoder$$anon$37.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$37.prototype.constructor = $c_Lio_circe_Decoder$$anon$37;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$37() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$37.prototype = $c_Lio_circe_Decoder$$anon$37.prototype;
$c_Lio_circe_Decoder$$anon$37.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n(c).value__Lio_circe_Json();
  if ((x1 instanceof $c_Lio_circe_Json$JNumber)) {
    var x2 = $as_Lio_circe_Json$JNumber(x1);
    var number = $n(x2).Lio_circe_Json$JNumber__f_value;
    var x1$2 = $n(number).toBigDecimal__s_Option();
    if ((x1$2 instanceof $c_s_Some)) {
      var x2$2 = $as_s_Some(x1$2);
      var v = $as_s_math_BigDecimal($n(x2$2).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(v)
    } else {
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  } else if ((x1 instanceof $c_Lio_circe_Json$JString)) {
    var x3 = $as_Lio_circe_Json$JString(x1);
    var string = $n(x3).Lio_circe_Json$JString__f_value;
    var this$2 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(string));
    if (this$2.isEmpty__Z()) {
      var x1$3 = $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$14 = $as_Lio_circe_JsonNumber(arg1);
      var x1$3 = $n(x$14).toBigDecimal__s_Option()
    };
    if ((x1$3 instanceof $c_s_Some)) {
      var x2$3 = $as_s_Some(x1$3);
      var value = $as_s_math_BigDecimal($n(x2$3).s_Some__f_value);
      $n($m_s_package$().s_package$__f_Right);
      return new $c_s_util_Right(value)
    } else {
      var x$3 = $m_s_None$();
      if ((x$3 === x1$3)) {
        return this.fail__Lio_circe_HCursor__s_util_Either(c)
      } else {
        throw new $c_s_MatchError(x1$3)
      }
    }
  } else {
    return this.fail__Lio_circe_HCursor__s_util_Either(c)
  }
});
var $d_Lio_circe_Decoder$$anon$37 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$37: 0
}, false, "io.circe.Decoder$$anon$37", {
  Lio_circe_Decoder$$anon$37: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$37.prototype.$classData = $d_Lio_circe_Decoder$$anon$37;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$41(decodeK$1, decodeV$1) {
  this.Lio_circe_MapDecoder__f_decodeK = null;
  this.Lio_circe_MapDecoder__f_decodeV = null;
  this.Lio_circe_MapDecoder__f_alwaysDecodeK = null;
  $ct_Lio_circe_MapDecoder__Lio_circe_KeyDecoder__Lio_circe_Decoder__(this, decodeK$1, decodeV$1)
}
$c_Lio_circe_Decoder$$anon$41.prototype = new $h_Lio_circe_MapDecoder();
$c_Lio_circe_Decoder$$anon$41.prototype.constructor = $c_Lio_circe_Decoder$$anon$41;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$41() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$41.prototype = $c_Lio_circe_Decoder$$anon$41.prototype;
var $d_Lio_circe_Decoder$$anon$41 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$41: 0
}, false, "io.circe.Decoder$$anon$41", {
  Lio_circe_Decoder$$anon$41: 1,
  Lio_circe_MapDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$41.prototype.$classData = $d_Lio_circe_Decoder$$anon$41;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$42(decodeA$1) {
  this.Lio_circe_SeqDecoder__f_decodeA = null;
  $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__(this, decodeA$1)
}
$c_Lio_circe_Decoder$$anon$42.prototype = new $h_Lio_circe_SeqDecoder();
$c_Lio_circe_Decoder$$anon$42.prototype.constructor = $c_Lio_circe_Decoder$$anon$42;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$42() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$42.prototype = $c_Lio_circe_Decoder$$anon$42.prototype;
$c_Lio_circe_Decoder$$anon$42.prototype.createBuilder__scm_Builder = (function() {
  return $m_sci_Seq$().newBuilder__scm_Builder()
});
var $d_Lio_circe_Decoder$$anon$42 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$42: 0
}, false, "io.circe.Decoder$$anon$42", {
  Lio_circe_Decoder$$anon$42: 1,
  Lio_circe_SeqDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$42.prototype.$classData = $d_Lio_circe_Decoder$$anon$42;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$43(decodeA$2) {
  this.Lio_circe_SeqDecoder__f_decodeA = null;
  $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__(this, decodeA$2)
}
$c_Lio_circe_Decoder$$anon$43.prototype = new $h_Lio_circe_SeqDecoder();
$c_Lio_circe_Decoder$$anon$43.prototype.constructor = $c_Lio_circe_Decoder$$anon$43;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$43() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$43.prototype = $c_Lio_circe_Decoder$$anon$43.prototype;
$c_Lio_circe_Decoder$$anon$43.prototype.createBuilder__scm_Builder = (function() {
  return new $c_sci_SetBuilderImpl()
});
var $d_Lio_circe_Decoder$$anon$43 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$43: 0
}, false, "io.circe.Decoder$$anon$43", {
  Lio_circe_Decoder$$anon$43: 1,
  Lio_circe_SeqDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$43.prototype.$classData = $d_Lio_circe_Decoder$$anon$43;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$44(decodeA$3) {
  this.Lio_circe_SeqDecoder__f_decodeA = null;
  $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__(this, decodeA$3)
}
$c_Lio_circe_Decoder$$anon$44.prototype = new $h_Lio_circe_SeqDecoder();
$c_Lio_circe_Decoder$$anon$44.prototype.constructor = $c_Lio_circe_Decoder$$anon$44;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$44() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$44.prototype = $c_Lio_circe_Decoder$$anon$44.prototype;
$c_Lio_circe_Decoder$$anon$44.prototype.createBuilder__scm_Builder = (function() {
  $m_sci_List$();
  return new $c_scm_ListBuffer()
});
var $d_Lio_circe_Decoder$$anon$44 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$44: 0
}, false, "io.circe.Decoder$$anon$44", {
  Lio_circe_Decoder$$anon$44: 1,
  Lio_circe_SeqDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$44.prototype.$classData = $d_Lio_circe_Decoder$$anon$44;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$53() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null;
  $ct_Lio_circe_Decoder$JavaTimeDecoder__T__(this, "Duration")
}
$c_Lio_circe_Decoder$$anon$53.prototype = new $h_Lio_circe_Decoder$JavaTimeDecoder();
$c_Lio_circe_Decoder$$anon$53.prototype.constructor = $c_Lio_circe_Decoder$$anon$53;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$53() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$53.prototype = $c_Lio_circe_Decoder$$anon$53.prototype;
$c_Lio_circe_Decoder$$anon$53.prototype.formatMessage__T__T__T = (function(input, message) {
  return (("Text '" + input) + "' cannot be parsed to a Duration")
});
$c_Lio_circe_Decoder$$anon$53.prototype.parseUnsafe__T__O = (function(input) {
  return $m_Ljava_time_Duration$().parse__jl_CharSequence__Ljava_time_Duration(input)
});
var $d_Lio_circe_Decoder$$anon$53 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$53: 0
}, false, "io.circe.Decoder$$anon$53", {
  Lio_circe_Decoder$$anon$53: 1,
  Lio_circe_Decoder$JavaTimeDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$53.prototype.$classData = $d_Lio_circe_Decoder$$anon$53;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$55() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null;
  $ct_Lio_circe_Decoder$JavaTimeDecoder__T__(this, "Period")
}
$c_Lio_circe_Decoder$$anon$55.prototype = new $h_Lio_circe_Decoder$JavaTimeDecoder();
$c_Lio_circe_Decoder$$anon$55.prototype.constructor = $c_Lio_circe_Decoder$$anon$55;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$55() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$55.prototype = $c_Lio_circe_Decoder$$anon$55.prototype;
$c_Lio_circe_Decoder$$anon$55.prototype.formatMessage__T__T__T = (function(input, message) {
  return (("Text '" + input) + "' cannot be parsed to a Period")
});
$c_Lio_circe_Decoder$$anon$55.prototype.parseUnsafe__T__O = (function(input) {
  return $m_Ljava_time_Period$().parse__jl_CharSequence__Ljava_time_Period(input)
});
var $d_Lio_circe_Decoder$$anon$55 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$55: 0
}, false, "io.circe.Decoder$$anon$55", {
  Lio_circe_Decoder$$anon$55: 1,
  Lio_circe_Decoder$JavaTimeDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$55.prototype.$classData = $d_Lio_circe_Decoder$$anon$55;
/** @constructor */
function $c_Lio_circe_Decoder$StandardJavaTimeDecoder() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null
}
$c_Lio_circe_Decoder$StandardJavaTimeDecoder.prototype = new $h_Lio_circe_Decoder$JavaTimeDecoder();
$c_Lio_circe_Decoder$StandardJavaTimeDecoder.prototype.constructor = $c_Lio_circe_Decoder$StandardJavaTimeDecoder;
/** @constructor */
function $h_Lio_circe_Decoder$StandardJavaTimeDecoder() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$StandardJavaTimeDecoder.prototype = $c_Lio_circe_Decoder$StandardJavaTimeDecoder.prototype;
$c_Lio_circe_Decoder$StandardJavaTimeDecoder.prototype.formatMessage__T__T__T = (function(input, message) {
  return message
});
/** @constructor */
function $c_Lio_circe_Encoder$$anon$36() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$36.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$36.prototype.constructor = $c_Lio_circe_Encoder$$anon$36;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$36() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$36.prototype = $c_Lio_circe_Encoder$$anon$36.prototype;
$c_Lio_circe_Encoder$$anon$36.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var e = $as_Lio_circe_Encoder(fa);
  var this$1 = $n(e);
  return new $c_Lio_circe_Encoder$$anon$1(this$1, fi)
});
var $d_Lio_circe_Encoder$$anon$36 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$36: 0
}, false, "io.circe.Encoder$$anon$36", {
  Lio_circe_Encoder$$anon$36: 1,
  O: 1,
  Lcats_Contravariant: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$36.prototype.$classData = $d_Lio_circe_Encoder$$anon$36;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$52() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$52.prototype = new $h_Lio_circe_Encoder$JavaTimeEncoder();
$c_Lio_circe_Encoder$$anon$52.prototype.constructor = $c_Lio_circe_Encoder$$anon$52;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$52() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$52.prototype = $c_Lio_circe_Encoder$$anon$52.prototype;
$c_Lio_circe_Encoder$$anon$52.prototype.format__Ljava_time_format_DateTimeFormatter = (function() {
  return $m_Ljava_time_format_DateTimeFormatter$().ISO_LOCAL_TIME__Ljava_time_format_DateTimeFormatter()
});
var $d_Lio_circe_Encoder$$anon$52 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$52: 0
}, false, "io.circe.Encoder$$anon$52", {
  Lio_circe_Encoder$$anon$52: 1,
  Lio_circe_Encoder$JavaTimeEncoder: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$52.prototype.$classData = $d_Lio_circe_Encoder$$anon$52;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$53() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$53.prototype = new $h_Lio_circe_Encoder$JavaTimeEncoder();
$c_Lio_circe_Encoder$$anon$53.prototype.constructor = $c_Lio_circe_Encoder$$anon$53;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$53() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$53.prototype = $c_Lio_circe_Encoder$$anon$53.prototype;
$c_Lio_circe_Encoder$$anon$53.prototype.format__Ljava_time_format_DateTimeFormatter = (function() {
  return $m_Ljava_time_format_DateTimeFormatter$().ISO_LOCAL_DATE_TIME__Ljava_time_format_DateTimeFormatter()
});
var $d_Lio_circe_Encoder$$anon$53 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$53: 0
}, false, "io.circe.Encoder$$anon$53", {
  Lio_circe_Encoder$$anon$53: 1,
  Lio_circe_Encoder$JavaTimeEncoder: 1,
  O: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$53.prototype.$classData = $d_Lio_circe_Encoder$$anon$53;
function $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json($thiz, a) {
  $m_Lio_circe_Json$();
  var values = $thiz.encodeArray__O__sci_Vector(a);
  return new $c_Lio_circe_Json$JArray($n(values))
}
function $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json($thiz, a) {
  $m_Lio_circe_Json$();
  var value = $thiz.encodeObject__O__Lio_circe_JsonObject(a);
  return new $c_Lio_circe_Json$JObject(value)
}
function $is_Lio_circe_Encoder$AsObject(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_Encoder$AsObject)))
}
function $as_Lio_circe_Encoder$AsObject(obj) {
  return (($is_Lio_circe_Encoder$AsObject(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Encoder$AsObject"))
}
function $isArrayOf_Lio_circe_Encoder$AsObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Encoder$AsObject)))
}
function $asArrayOf_Lio_circe_Encoder$AsObject(obj, depth) {
  return (($isArrayOf_Lio_circe_Encoder$AsObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Encoder$AsObject;", depth))
}
/** @constructor */
function $c_Lio_circe_Encoder$AsObject$() {
  $n_Lio_circe_Encoder$AsObject$ = this;
  new $c_Lio_circe_Encoder$AsObject$$anon$68()
}
$c_Lio_circe_Encoder$AsObject$.prototype = new $h_Lio_circe_Encoder$LowPriorityAsObjectEncoders();
$c_Lio_circe_Encoder$AsObject$.prototype.constructor = $c_Lio_circe_Encoder$AsObject$;
/** @constructor */
function $h_Lio_circe_Encoder$AsObject$() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$AsObject$.prototype = $c_Lio_circe_Encoder$AsObject$.prototype;
var $d_Lio_circe_Encoder$AsObject$ = new $TypeData().initClass({
  Lio_circe_Encoder$AsObject$: 0
}, false, "io.circe.Encoder$AsObject$", {
  Lio_circe_Encoder$AsObject$: 1,
  Lio_circe_Encoder$LowPriorityAsObjectEncoders: 1,
  O: 1,
  Lio_circe_EncoderDerivation: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$AsObject$.prototype.$classData = $d_Lio_circe_Encoder$AsObject$;
var $n_Lio_circe_Encoder$AsObject$;
function $m_Lio_circe_Encoder$AsObject$() {
  if ((!$n_Lio_circe_Encoder$AsObject$)) {
    $n_Lio_circe_Encoder$AsObject$ = new $c_Lio_circe_Encoder$AsObject$()
  };
  return $n_Lio_circe_Encoder$AsObject$
}
/** @constructor */
function $c_Lio_circe_Encoder$AsObject$$anon$68() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$AsObject$$anon$68.prototype = new $h_O();
$c_Lio_circe_Encoder$AsObject$$anon$68.prototype.constructor = $c_Lio_circe_Encoder$AsObject$$anon$68;
/** @constructor */
function $h_Lio_circe_Encoder$AsObject$$anon$68() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$AsObject$$anon$68.prototype = $c_Lio_circe_Encoder$AsObject$$anon$68.prototype;
$c_Lio_circe_Encoder$AsObject$$anon$68.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var e = $as_Lio_circe_Encoder$AsObject(fa);
  var this$1 = $n(e);
  return new $c_Lio_circe_Encoder$AsObject$$anon$65(this$1, fi)
});
var $d_Lio_circe_Encoder$AsObject$$anon$68 = new $TypeData().initClass({
  Lio_circe_Encoder$AsObject$$anon$68: 0
}, false, "io.circe.Encoder$AsObject$$anon$68", {
  Lio_circe_Encoder$AsObject$$anon$68: 1,
  O: 1,
  Lcats_Contravariant: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$AsObject$$anon$68.prototype.$classData = $d_Lio_circe_Encoder$AsObject$$anon$68;
class $c_Lio_circe_Error extends $c_jl_Exception {
  fillInStackTrace__jl_Throwable() {
    return this
  };
}
/** @constructor */
function $c_Lio_circe_Json() {
  /*<skip>*/
}
$c_Lio_circe_Json.prototype = new $h_O();
$c_Lio_circe_Json.prototype.constructor = $c_Lio_circe_Json;
/** @constructor */
function $h_Lio_circe_Json() {
  /*<skip>*/
}
$h_Lio_circe_Json.prototype = $c_Lio_circe_Json.prototype;
$c_Lio_circe_Json.prototype.toString__T = (function() {
  return $n($m_Lio_circe_Printer$().Lio_circe_Printer$__f_spaces2).print__Lio_circe_Json__T(this)
});
$c_Lio_circe_Json.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_Json)) {
    var x2 = $as_Lio_circe_Json(that);
    return $n($m_Lio_circe_Json$().Lio_circe_Json$__f_eqJson).eqv__O__O__Z(this, x2)
  } else {
    return false
  }
});
function $as_Lio_circe_Json(obj) {
  return (((obj instanceof $c_Lio_circe_Json) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json"))
}
function $isArrayOf_Lio_circe_Json(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json)))
}
function $asArrayOf_Lio_circe_Json(obj, depth) {
  return (($isArrayOf_Lio_circe_Json(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json;", depth))
}
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2(outer) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2__f_underlying = null;
  var this$1 = $n($n($n(outer).Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1__f_$outer).Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields);
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2__f_underlying = new $c_ju_HashMap$KeySet(this$1).iterator__ju_Iterator()
}
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype = new $h_O();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.hasNext__Z = (function() {
  return $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2__f_underlying).hasNext__Z()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.next__T = (function() {
  return $as_T($n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2__f_underlying).next__O())
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.next__O = (function() {
  return this.next__T()
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2 = new $TypeData().initClass({
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2: 0
}, false, "io.circe.JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2", {
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2.prototype.$classData = $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2;
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6(outer) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6__f_underlying = null;
  var this$1 = $n($n($n(outer).Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5__f_$outer).Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields);
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6__f_underlying = new $c_ju_HashMap$EntrySet(this$1).iterator__ju_Iterator()
}
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype = new $h_O();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.hasNext__Z = (function() {
  return $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6__f_underlying).hasNext__Z()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.next__T2 = (function() {
  var field = $as_ju_Map$Entry($n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6__f_underlying).next__O());
  return $ct_T2__O__O__(new $c_T2(), $n(field).getKey__O(), $n(field).getValue__O())
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6 = new $TypeData().initClass({
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6: 0
}, false, "io.circe.JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6", {
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6.prototype.$classData = $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$5() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$$anon$5.prototype = new $h_Lio_circe_KeyDecoder$AlwaysKeyDecoder();
$c_Lio_circe_KeyDecoder$$anon$5.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$5;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$5() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$5.prototype = $c_Lio_circe_KeyDecoder$$anon$5.prototype;
$c_Lio_circe_KeyDecoder$$anon$5.prototype.decodeSafe__T__O = (function(key) {
  return key
});
var $d_Lio_circe_KeyDecoder$$anon$5 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$5: 0
}, false, "io.circe.KeyDecoder$$anon$5", {
  Lio_circe_KeyDecoder$$anon$5: 1,
  Lio_circe_KeyDecoder$AlwaysKeyDecoder: 1,
  O: 1,
  Lio_circe_KeyDecoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyDecoder$$anon$5.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$5;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$6() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$$anon$6.prototype = new $h_Lio_circe_KeyDecoder$AlwaysKeyDecoder();
$c_Lio_circe_KeyDecoder$$anon$6.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$6;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$6() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$6.prototype = $c_Lio_circe_KeyDecoder$$anon$6.prototype;
$c_Lio_circe_KeyDecoder$$anon$6.prototype.decodeSafe__T__O = (function(key) {
  var this$1 = $m_s_Symbol$();
  return $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$1, key))
});
var $d_Lio_circe_KeyDecoder$$anon$6 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$6: 0
}, false, "io.circe.KeyDecoder$$anon$6", {
  Lio_circe_KeyDecoder$$anon$6: 1,
  Lio_circe_KeyDecoder$AlwaysKeyDecoder: 1,
  O: 1,
  Lio_circe_KeyDecoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyDecoder$$anon$6.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$6;
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$10() {
  /*<skip>*/
}
$c_Lio_circe_KeyEncoder$$anon$10.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$10.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$10;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$10() {
  /*<skip>*/
}
$h_Lio_circe_KeyEncoder$$anon$10.prototype = $c_Lio_circe_KeyEncoder$$anon$10.prototype;
$c_Lio_circe_KeyEncoder$$anon$10.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var e = $as_Lio_circe_KeyEncoder(fa);
  var this$1 = $n(e);
  return new $c_Lio_circe_KeyEncoder$$anon$1(this$1, fi)
});
var $d_Lio_circe_KeyEncoder$$anon$10 = new $TypeData().initClass({
  Lio_circe_KeyEncoder$$anon$10: 0
}, false, "io.circe.KeyEncoder$$anon$10", {
  Lio_circe_KeyEncoder$$anon$10: 1,
  O: 1,
  Lcats_Contravariant: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_KeyEncoder$$anon$10.prototype.$classData = $d_Lio_circe_KeyEncoder$$anon$10;
function $p_Lio_circe_Printer__concat__T__T__T__T($thiz, left, text, right) {
  var builder = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + left);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + text);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + right);
  return builder.jl_StringBuilder__f_java$lang$StringBuilder$$content
}
/** @constructor */
function $c_Lio_circe_Printer(dropNullValues, indent, lbraceLeft, lbraceRight, rbraceLeft, rbraceRight, lbracketLeft, lbracketRight, rbracketLeft, rbracketRight, lrbracketsEmpty, arrayCommaLeft, arrayCommaRight, objectCommaLeft, objectCommaRight, colonLeft, colonRight, reuseWriters, predictSize, escapeNonAscii, sortKeys) {
  this.Lio_circe_Printer__f_dropNullValues = false;
  this.Lio_circe_Printer__f_indent = null;
  this.Lio_circe_Printer__f_lbraceLeft = null;
  this.Lio_circe_Printer__f_lbraceRight = null;
  this.Lio_circe_Printer__f_rbraceLeft = null;
  this.Lio_circe_Printer__f_rbraceRight = null;
  this.Lio_circe_Printer__f_lbracketLeft = null;
  this.Lio_circe_Printer__f_lbracketRight = null;
  this.Lio_circe_Printer__f_rbracketLeft = null;
  this.Lio_circe_Printer__f_rbracketRight = null;
  this.Lio_circe_Printer__f_lrbracketsEmpty = null;
  this.Lio_circe_Printer__f_arrayCommaLeft = null;
  this.Lio_circe_Printer__f_arrayCommaRight = null;
  this.Lio_circe_Printer__f_objectCommaLeft = null;
  this.Lio_circe_Printer__f_objectCommaRight = null;
  this.Lio_circe_Printer__f_colonLeft = null;
  this.Lio_circe_Printer__f_colonRight = null;
  this.Lio_circe_Printer__f_reuseWriters = false;
  this.Lio_circe_Printer__f_predictSize = false;
  this.Lio_circe_Printer__f_escapeNonAscii = false;
  this.Lio_circe_Printer__f_sortKeys = false;
  this.Lio_circe_Printer__f_io$circe$Printer$$pieces = null;
  this.Lio_circe_Printer__f_stringWriter = null;
  this.Lio_circe_Printer__f_dropNullValues = dropNullValues;
  this.Lio_circe_Printer__f_indent = indent;
  this.Lio_circe_Printer__f_lbraceLeft = lbraceLeft;
  this.Lio_circe_Printer__f_lbraceRight = lbraceRight;
  this.Lio_circe_Printer__f_rbraceLeft = rbraceLeft;
  this.Lio_circe_Printer__f_rbraceRight = rbraceRight;
  this.Lio_circe_Printer__f_lbracketLeft = lbracketLeft;
  this.Lio_circe_Printer__f_lbracketRight = lbracketRight;
  this.Lio_circe_Printer__f_rbracketLeft = rbracketLeft;
  this.Lio_circe_Printer__f_rbracketRight = rbracketRight;
  this.Lio_circe_Printer__f_lrbracketsEmpty = lrbracketsEmpty;
  this.Lio_circe_Printer__f_arrayCommaLeft = arrayCommaLeft;
  this.Lio_circe_Printer__f_arrayCommaRight = arrayCommaRight;
  this.Lio_circe_Printer__f_objectCommaLeft = objectCommaLeft;
  this.Lio_circe_Printer__f_objectCommaRight = objectCommaRight;
  this.Lio_circe_Printer__f_colonLeft = colonLeft;
  this.Lio_circe_Printer__f_colonRight = colonRight;
  this.Lio_circe_Printer__f_reuseWriters = reuseWriters;
  this.Lio_circe_Printer__f_predictSize = predictSize;
  this.Lio_circe_Printer__f_escapeNonAscii = escapeNonAscii;
  this.Lio_circe_Printer__f_sortKeys = sortKeys;
  var this$1 = $n(indent);
  this.Lio_circe_Printer__f_io$circe$Printer$$pieces = ((this$1 === "") ? new $c_Lio_circe_Printer$ConstantPieces(new $c_Lio_circe_Printer$Pieces($p_Lio_circe_Printer__concat__T__T__T__T(this, lbraceLeft, "{", lbraceRight), $p_Lio_circe_Printer__concat__T__T__T__T(this, rbraceRight, "}", rbraceLeft), $p_Lio_circe_Printer__concat__T__T__T__T(this, lbracketLeft, "[", lbracketRight), $p_Lio_circe_Printer__concat__T__T__T__T(this, rbracketLeft, "]", rbracketRight), $p_Lio_circe_Printer__concat__T__T__T__T(this, "[", lrbracketsEmpty, "]"), $p_Lio_circe_Printer__concat__T__T__T__T(this, arrayCommaLeft, ",", arrayCommaRight), $p_Lio_circe_Printer__concat__T__T__T__T(this, objectCommaLeft, ",", objectCommaRight), $p_Lio_circe_Printer__concat__T__T__T__T(this, colonLeft, ":", colonRight))) : new $c_Lio_circe_Printer$$anon$1(this));
  this.Lio_circe_Printer__f_stringWriter = new $c_Lio_circe_Printer$$anon$2(this);
  new $c_Lio_circe_Printer$$anon$3(this)
}
$c_Lio_circe_Printer.prototype = new $h_O();
$c_Lio_circe_Printer.prototype.constructor = $c_Lio_circe_Printer;
/** @constructor */
function $h_Lio_circe_Printer() {
  /*<skip>*/
}
$h_Lio_circe_Printer.prototype = $c_Lio_circe_Printer.prototype;
$c_Lio_circe_Printer.prototype.print__Lio_circe_Json__T = (function(json) {
  if ((this.Lio_circe_Printer__f_reuseWriters && (this.Lio_circe_Printer__f_stringWriter !== null))) {
    var w = $as_jl_StringBuilder($n(this.Lio_circe_Printer__f_stringWriter).get__O());
    $n(w).setLength__I__V(0);
    var writer = w
  } else {
    var writer = $ct_jl_StringBuilder__(new $c_jl_StringBuilder())
  };
  var folder = new $c_Lio_circe_Printer$StringBuilderFolder(this, writer);
  $n(json).foldWith__Lio_circe_Json$Folder__O(folder);
  return $n(writer).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Lio_circe_Printer.prototype.productPrefix__T = (function() {
  return "Printer"
});
$c_Lio_circe_Printer.prototype.productArity__I = (function() {
  return 21
});
$c_Lio_circe_Printer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lio_circe_Printer__f_dropNullValues;
      break
    }
    case 1: {
      return this.Lio_circe_Printer__f_indent;
      break
    }
    case 2: {
      return this.Lio_circe_Printer__f_lbraceLeft;
      break
    }
    case 3: {
      return this.Lio_circe_Printer__f_lbraceRight;
      break
    }
    case 4: {
      return this.Lio_circe_Printer__f_rbraceLeft;
      break
    }
    case 5: {
      return this.Lio_circe_Printer__f_rbraceRight;
      break
    }
    case 6: {
      return this.Lio_circe_Printer__f_lbracketLeft;
      break
    }
    case 7: {
      return this.Lio_circe_Printer__f_lbracketRight;
      break
    }
    case 8: {
      return this.Lio_circe_Printer__f_rbracketLeft;
      break
    }
    case 9: {
      return this.Lio_circe_Printer__f_rbracketRight;
      break
    }
    case 10: {
      return this.Lio_circe_Printer__f_lrbracketsEmpty;
      break
    }
    case 11: {
      return this.Lio_circe_Printer__f_arrayCommaLeft;
      break
    }
    case 12: {
      return this.Lio_circe_Printer__f_arrayCommaRight;
      break
    }
    case 13: {
      return this.Lio_circe_Printer__f_objectCommaLeft;
      break
    }
    case 14: {
      return this.Lio_circe_Printer__f_objectCommaRight;
      break
    }
    case 15: {
      return this.Lio_circe_Printer__f_colonLeft;
      break
    }
    case 16: {
      return this.Lio_circe_Printer__f_colonRight;
      break
    }
    case 17: {
      return this.Lio_circe_Printer__f_reuseWriters;
      break
    }
    case 18: {
      return this.Lio_circe_Printer__f_predictSize;
      break
    }
    case 19: {
      return this.Lio_circe_Printer__f_escapeNonAscii;
      break
    }
    case 20: {
      return this.Lio_circe_Printer__f_sortKeys;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lio_circe_Printer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_Printer.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Printer");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lio_circe_Printer__f_dropNullValues ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lio_circe_Printer__f_indent;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lio_circe_Printer__f_lbraceLeft;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lio_circe_Printer__f_lbraceRight;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lio_circe_Printer__f_rbraceLeft;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lio_circe_Printer__f_rbraceRight;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.Lio_circe_Printer__f_lbracketLeft;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.Lio_circe_Printer__f_lbracketRight;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$7 = this.Lio_circe_Printer__f_rbracketLeft;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$8 = this.Lio_circe_Printer__f_rbracketRight;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$8);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var x$9 = this.Lio_circe_Printer__f_lrbracketsEmpty;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$9);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  var x$10 = this.Lio_circe_Printer__f_arrayCommaLeft;
  var data$12 = $m_sr_Statics$().anyHash__O__I(x$10);
  acc = $m_sr_Statics$().mix__I__I__I(hash$12, data$12);
  var hash$13 = acc;
  var x$11 = this.Lio_circe_Printer__f_arrayCommaRight;
  var data$13 = $m_sr_Statics$().anyHash__O__I(x$11);
  acc = $m_sr_Statics$().mix__I__I__I(hash$13, data$13);
  var hash$14 = acc;
  var x$12 = this.Lio_circe_Printer__f_objectCommaLeft;
  var data$14 = $m_sr_Statics$().anyHash__O__I(x$12);
  acc = $m_sr_Statics$().mix__I__I__I(hash$14, data$14);
  var hash$15 = acc;
  var x$13 = this.Lio_circe_Printer__f_objectCommaRight;
  var data$15 = $m_sr_Statics$().anyHash__O__I(x$13);
  acc = $m_sr_Statics$().mix__I__I__I(hash$15, data$15);
  var hash$16 = acc;
  var x$14 = this.Lio_circe_Printer__f_colonLeft;
  var data$16 = $m_sr_Statics$().anyHash__O__I(x$14);
  acc = $m_sr_Statics$().mix__I__I__I(hash$16, data$16);
  var hash$17 = acc;
  var x$15 = this.Lio_circe_Printer__f_colonRight;
  var data$17 = $m_sr_Statics$().anyHash__O__I(x$15);
  acc = $m_sr_Statics$().mix__I__I__I(hash$17, data$17);
  var hash$18 = acc;
  var data$18 = (this.Lio_circe_Printer__f_reuseWriters ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$18, data$18);
  var hash$19 = acc;
  var data$19 = (this.Lio_circe_Printer__f_predictSize ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$19, data$19);
  var hash$20 = acc;
  var data$20 = (this.Lio_circe_Printer__f_escapeNonAscii ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$20, data$20);
  var hash$21 = acc;
  var data$21 = (this.Lio_circe_Printer__f_sortKeys ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$21, data$21);
  var hash$22 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$22, 21)
});
$c_Lio_circe_Printer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_Printer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_circe_Printer)) {
    var Printer$1 = $as_Lio_circe_Printer(x$1);
    return (((((((((((((((((((((this.Lio_circe_Printer__f_dropNullValues === $n(Printer$1).Lio_circe_Printer__f_dropNullValues) && (this.Lio_circe_Printer__f_reuseWriters === $n(Printer$1).Lio_circe_Printer__f_reuseWriters)) && (this.Lio_circe_Printer__f_predictSize === $n(Printer$1).Lio_circe_Printer__f_predictSize)) && (this.Lio_circe_Printer__f_escapeNonAscii === $n(Printer$1).Lio_circe_Printer__f_escapeNonAscii)) && (this.Lio_circe_Printer__f_sortKeys === $n(Printer$1).Lio_circe_Printer__f_sortKeys)) && (this.Lio_circe_Printer__f_indent === $n(Printer$1).Lio_circe_Printer__f_indent)) && (this.Lio_circe_Printer__f_lbraceLeft === $n(Printer$1).Lio_circe_Printer__f_lbraceLeft)) && (this.Lio_circe_Printer__f_lbraceRight === $n(Printer$1).Lio_circe_Printer__f_lbraceRight)) && (this.Lio_circe_Printer__f_rbraceLeft === $n(Printer$1).Lio_circe_Printer__f_rbraceLeft)) && (this.Lio_circe_Printer__f_rbraceRight === $n(Printer$1).Lio_circe_Printer__f_rbraceRight)) && (this.Lio_circe_Printer__f_lbracketLeft === $n(Printer$1).Lio_circe_Printer__f_lbracketLeft)) && (this.Lio_circe_Printer__f_lbracketRight === $n(Printer$1).Lio_circe_Printer__f_lbracketRight)) && (this.Lio_circe_Printer__f_rbracketLeft === $n(Printer$1).Lio_circe_Printer__f_rbracketLeft)) && (this.Lio_circe_Printer__f_rbracketRight === $n(Printer$1).Lio_circe_Printer__f_rbracketRight)) && (this.Lio_circe_Printer__f_lrbracketsEmpty === $n(Printer$1).Lio_circe_Printer__f_lrbracketsEmpty)) && (this.Lio_circe_Printer__f_arrayCommaLeft === $n(Printer$1).Lio_circe_Printer__f_arrayCommaLeft)) && (this.Lio_circe_Printer__f_arrayCommaRight === $n(Printer$1).Lio_circe_Printer__f_arrayCommaRight)) && (this.Lio_circe_Printer__f_objectCommaLeft === $n(Printer$1).Lio_circe_Printer__f_objectCommaLeft)) && (this.Lio_circe_Printer__f_objectCommaRight === $n(Printer$1).Lio_circe_Printer__f_objectCommaRight)) && (this.Lio_circe_Printer__f_colonLeft === $n(Printer$1).Lio_circe_Printer__f_colonLeft)) && (this.Lio_circe_Printer__f_colonRight === $n(Printer$1).Lio_circe_Printer__f_colonRight))
  } else {
    return false
  }
});
function $as_Lio_circe_Printer(obj) {
  return (((obj instanceof $c_Lio_circe_Printer) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Printer"))
}
function $isArrayOf_Lio_circe_Printer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Printer)))
}
function $asArrayOf_Lio_circe_Printer(obj, depth) {
  return (($isArrayOf_Lio_circe_Printer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Printer;", depth))
}
var $d_Lio_circe_Printer = new $TypeData().initClass({
  Lio_circe_Printer: 0
}, false, "io.circe.Printer", {
  Lio_circe_Printer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Printer.prototype.$classData = $d_Lio_circe_Printer;
/** @constructor */
function $c_Lio_circe_Printer$$anon$1(outer) {
  this.Lio_circe_Printer$MemoizedPieces__f_indent = null;
  this.Lio_circe_Printer$MemoizedPieces__f_known = null;
  this.Lio_circe_Printer$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_Printer$$anon$1__f_$outer = outer
  };
  $ct_Lio_circe_Printer$MemoizedPieces__T__(this, $n(outer).Lio_circe_Printer__f_indent)
}
$c_Lio_circe_Printer$$anon$1.prototype = new $h_Lio_circe_Printer$MemoizedPieces();
$c_Lio_circe_Printer$$anon$1.prototype.constructor = $c_Lio_circe_Printer$$anon$1;
/** @constructor */
function $h_Lio_circe_Printer$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_Printer$$anon$1.prototype = $c_Lio_circe_Printer$$anon$1.prototype;
$c_Lio_circe_Printer$$anon$1.prototype.compute__I__Lio_circe_Printer$Pieces = (function(i) {
  var builder = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lbraceLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "{");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lbraceRight, ((1 + i) | 0));
  var lBraces = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_rbraceLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "}");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_rbraceRight, ((1 + i) | 0));
  var rBraces = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lbracketLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "[");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lbracketRight, ((1 + i) | 0));
  var lBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_rbracketLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "]");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_rbracketRight, ((1 + i) | 0));
  var rBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "[");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lrbracketsEmpty, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "]");
  var lrEmptyBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_arrayCommaLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_arrayCommaRight, ((1 + i) | 0));
  var arrayCommas = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_objectCommaLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_objectCommaRight, ((1 + i) | 0));
  var objectCommas = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_colonLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_colonRight, ((1 + i) | 0));
  var colons = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return new $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons)
});
var $d_Lio_circe_Printer$$anon$1 = new $TypeData().initClass({
  Lio_circe_Printer$$anon$1: 0
}, false, "io.circe.Printer$$anon$1", {
  Lio_circe_Printer$$anon$1: 1,
  Lio_circe_Printer$MemoizedPieces: 1,
  Lio_circe_Printer$PiecesAtDepth: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Printer$$anon$1.prototype.$classData = $d_Lio_circe_Printer$$anon$1;
/** @constructor */
function $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons) {
  this.Lio_circe_Printer$Pieces__f_lBraces = null;
  this.Lio_circe_Printer$Pieces__f_rBraces = null;
  this.Lio_circe_Printer$Pieces__f_lBrackets = null;
  this.Lio_circe_Printer$Pieces__f_rBrackets = null;
  this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets = null;
  this.Lio_circe_Printer$Pieces__f_arrayCommas = null;
  this.Lio_circe_Printer$Pieces__f_objectCommas = null;
  this.Lio_circe_Printer$Pieces__f_colons = null;
  this.Lio_circe_Printer$Pieces__f_lBraces = lBraces;
  this.Lio_circe_Printer$Pieces__f_rBraces = rBraces;
  this.Lio_circe_Printer$Pieces__f_lBrackets = lBrackets;
  this.Lio_circe_Printer$Pieces__f_rBrackets = rBrackets;
  this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets = lrEmptyBrackets;
  this.Lio_circe_Printer$Pieces__f_arrayCommas = arrayCommas;
  this.Lio_circe_Printer$Pieces__f_objectCommas = objectCommas;
  this.Lio_circe_Printer$Pieces__f_colons = colons
}
$c_Lio_circe_Printer$Pieces.prototype = new $h_O();
$c_Lio_circe_Printer$Pieces.prototype.constructor = $c_Lio_circe_Printer$Pieces;
/** @constructor */
function $h_Lio_circe_Printer$Pieces() {
  /*<skip>*/
}
$h_Lio_circe_Printer$Pieces.prototype = $c_Lio_circe_Printer$Pieces.prototype;
$c_Lio_circe_Printer$Pieces.prototype.productPrefix__T = (function() {
  return "Pieces"
});
$c_Lio_circe_Printer$Pieces.prototype.productArity__I = (function() {
  return 8
});
$c_Lio_circe_Printer$Pieces.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lio_circe_Printer$Pieces__f_lBraces;
      break
    }
    case 1: {
      return this.Lio_circe_Printer$Pieces__f_rBraces;
      break
    }
    case 2: {
      return this.Lio_circe_Printer$Pieces__f_lBrackets;
      break
    }
    case 3: {
      return this.Lio_circe_Printer$Pieces__f_rBrackets;
      break
    }
    case 4: {
      return this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets;
      break
    }
    case 5: {
      return this.Lio_circe_Printer$Pieces__f_arrayCommas;
      break
    }
    case 6: {
      return this.Lio_circe_Printer$Pieces__f_objectCommas;
      break
    }
    case 7: {
      return this.Lio_circe_Printer$Pieces__f_colons;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lio_circe_Printer$Pieces.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_Printer$Pieces.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_Printer$Pieces.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_Printer$Pieces.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_circe_Printer$Pieces)) {
    var Pieces$1 = $as_Lio_circe_Printer$Pieces(x$1);
    return ((((((((this.Lio_circe_Printer$Pieces__f_lBraces === $n(Pieces$1).Lio_circe_Printer$Pieces__f_lBraces) && (this.Lio_circe_Printer$Pieces__f_rBraces === $n(Pieces$1).Lio_circe_Printer$Pieces__f_rBraces)) && (this.Lio_circe_Printer$Pieces__f_lBrackets === $n(Pieces$1).Lio_circe_Printer$Pieces__f_lBrackets)) && (this.Lio_circe_Printer$Pieces__f_rBrackets === $n(Pieces$1).Lio_circe_Printer$Pieces__f_rBrackets)) && (this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets === $n(Pieces$1).Lio_circe_Printer$Pieces__f_lrEmptyBrackets)) && (this.Lio_circe_Printer$Pieces__f_arrayCommas === $n(Pieces$1).Lio_circe_Printer$Pieces__f_arrayCommas)) && (this.Lio_circe_Printer$Pieces__f_objectCommas === $n(Pieces$1).Lio_circe_Printer$Pieces__f_objectCommas)) && (this.Lio_circe_Printer$Pieces__f_colons === $n(Pieces$1).Lio_circe_Printer$Pieces__f_colons))
  } else {
    return false
  }
});
function $as_Lio_circe_Printer$Pieces(obj) {
  return (((obj instanceof $c_Lio_circe_Printer$Pieces) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Printer$Pieces"))
}
function $isArrayOf_Lio_circe_Printer$Pieces(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Printer$Pieces)))
}
function $asArrayOf_Lio_circe_Printer$Pieces(obj, depth) {
  return (($isArrayOf_Lio_circe_Printer$Pieces(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Printer$Pieces;", depth))
}
var $d_Lio_circe_Printer$Pieces = new $TypeData().initClass({
  Lio_circe_Printer$Pieces: 0
}, false, "io.circe.Printer$Pieces", {
  Lio_circe_Printer$Pieces: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lio_circe_Printer$Pieces.prototype.$classData = $d_Lio_circe_Printer$Pieces;
/** @constructor */
function $c_Lio_circe_Printer$StringBuilderFolder(outer, writer) {
  this.Lio_circe_Printer$PrintingFolder__f_writer = null;
  this.Lio_circe_Printer$PrintingFolder__f_pieces = null;
  this.Lio_circe_Printer$PrintingFolder__f_dropNullValues = false;
  this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = false;
  this.Lio_circe_Printer$PrintingFolder__f_sortKeys = false;
  this.Lio_circe_Printer$PrintingFolder__f_depth = 0;
  $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__(this, writer, $n(outer).Lio_circe_Printer__f_io$circe$Printer$$pieces, $n(outer).Lio_circe_Printer__f_dropNullValues, $n(outer).Lio_circe_Printer__f_escapeNonAscii, $n(outer).Lio_circe_Printer__f_sortKeys)
}
$c_Lio_circe_Printer$StringBuilderFolder.prototype = new $h_Lio_circe_Printer$PrintingFolder();
$c_Lio_circe_Printer$StringBuilderFolder.prototype.constructor = $c_Lio_circe_Printer$StringBuilderFolder;
/** @constructor */
function $h_Lio_circe_Printer$StringBuilderFolder() {
  /*<skip>*/
}
$h_Lio_circe_Printer$StringBuilderFolder.prototype = $c_Lio_circe_Printer$StringBuilderFolder.prototype;
$c_Lio_circe_Printer$StringBuilderFolder.prototype.onNumber__Lio_circe_JsonNumber__O = (function(value) {
  $n(value).appendToStringBuilder__jl_StringBuilder__V($as_jl_StringBuilder(this.Lio_circe_Printer$PrintingFolder__f_writer))
});
$c_Lio_circe_Printer$StringBuilderFolder.prototype.onBoolean__Z__O = (function(value) {
  var this$1 = $n($as_jl_StringBuilder(this.Lio_circe_Printer$PrintingFolder__f_writer));
  var str = ("" + value);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str)
});
var $d_Lio_circe_Printer$StringBuilderFolder = new $TypeData().initClass({
  Lio_circe_Printer$StringBuilderFolder: 0
}, false, "io.circe.Printer$StringBuilderFolder", {
  Lio_circe_Printer$StringBuilderFolder: 1,
  Lio_circe_Printer$PrintingFolder: 1,
  O: 1,
  Lio_circe_Json$Folder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Printer$StringBuilderFolder.prototype.$classData = $d_Lio_circe_Printer$StringBuilderFolder;
/** @constructor */
function $c_Lio_circe_cursor_ArrayCursor(values, index, parent, changed, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_ArrayCursor__f_values = null;
  this.Lio_circe_cursor_ArrayCursor__f_index = 0;
  this.Lio_circe_cursor_ArrayCursor__f_parent = null;
  this.Lio_circe_cursor_ArrayCursor__f_changed = false;
  this.Lio_circe_cursor_ArrayCursor__f_values = values;
  this.Lio_circe_cursor_ArrayCursor__f_index = index;
  this.Lio_circe_cursor_ArrayCursor__f_parent = parent;
  this.Lio_circe_cursor_ArrayCursor__f_changed = changed;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp)
}
$c_Lio_circe_cursor_ArrayCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_ArrayCursor.prototype.constructor = $c_Lio_circe_cursor_ArrayCursor;
/** @constructor */
function $h_Lio_circe_cursor_ArrayCursor() {
  /*<skip>*/
}
$h_Lio_circe_cursor_ArrayCursor.prototype = $c_Lio_circe_cursor_ArrayCursor.prototype;
$c_Lio_circe_cursor_ArrayCursor.prototype.value__Lio_circe_Json = (function() {
  return $as_Lio_circe_Json($n(this.Lio_circe_cursor_ArrayCursor__f_values).apply__I__O(this.Lio_circe_cursor_ArrayCursor__f_index))
});
$c_Lio_circe_cursor_ArrayCursor.prototype.right__Lio_circe_ACursor = (function() {
  var $$x1 = this.Lio_circe_cursor_ArrayCursor__f_index;
  var this$1 = $n(this.Lio_circe_cursor_ArrayCursor__f_values);
  if (($$x1 === (((-1) + this$1.length__I()) | 0))) {
    var op = $m_Lio_circe_CursorOp$MoveRight$();
    return new $c_Lio_circe_FailedCursor(this, op)
  } else {
    return new $c_Lio_circe_cursor_ArrayCursor(this.Lio_circe_cursor_ArrayCursor__f_values, ((1 + this.Lio_circe_cursor_ArrayCursor__f_index) | 0), this.Lio_circe_cursor_ArrayCursor__f_parent, this.Lio_circe_cursor_ArrayCursor__f_changed, this, $m_Lio_circe_CursorOp$MoveRight$())
  }
});
var $d_Lio_circe_cursor_ArrayCursor = new $TypeData().initClass({
  Lio_circe_cursor_ArrayCursor: 0
}, false, "io.circe.cursor.ArrayCursor", {
  Lio_circe_cursor_ArrayCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_cursor_ArrayCursor.prototype.$classData = $d_Lio_circe_cursor_ArrayCursor;
/** @constructor */
function $c_Lio_circe_cursor_ObjectCursor(obj, key, parent, changed, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_ObjectCursor__f_obj = null;
  this.Lio_circe_cursor_ObjectCursor__f_key = null;
  this.Lio_circe_cursor_ObjectCursor__f_obj = obj;
  this.Lio_circe_cursor_ObjectCursor__f_key = key;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp)
}
$c_Lio_circe_cursor_ObjectCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_ObjectCursor.prototype.constructor = $c_Lio_circe_cursor_ObjectCursor;
/** @constructor */
function $h_Lio_circe_cursor_ObjectCursor() {
  /*<skip>*/
}
$h_Lio_circe_cursor_ObjectCursor.prototype = $c_Lio_circe_cursor_ObjectCursor.prototype;
$c_Lio_circe_cursor_ObjectCursor.prototype.value__Lio_circe_Json = (function() {
  return $n(this.Lio_circe_cursor_ObjectCursor__f_obj).applyUnsafe__T__Lio_circe_Json(this.Lio_circe_cursor_ObjectCursor__f_key)
});
$c_Lio_circe_cursor_ObjectCursor.prototype.right__Lio_circe_ACursor = (function() {
  var op = $m_Lio_circe_CursorOp$MoveRight$();
  return new $c_Lio_circe_FailedCursor(this, op)
});
var $d_Lio_circe_cursor_ObjectCursor = new $TypeData().initClass({
  Lio_circe_cursor_ObjectCursor: 0
}, false, "io.circe.cursor.ObjectCursor", {
  Lio_circe_cursor_ObjectCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_cursor_ObjectCursor.prototype.$classData = $d_Lio_circe_cursor_ObjectCursor;
/** @constructor */
function $c_Lio_circe_cursor_TopCursor(value, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_TopCursor__f_value = null;
  this.Lio_circe_cursor_TopCursor__f_value = value;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp)
}
$c_Lio_circe_cursor_TopCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_TopCursor.prototype.constructor = $c_Lio_circe_cursor_TopCursor;
/** @constructor */
function $h_Lio_circe_cursor_TopCursor() {
  /*<skip>*/
}
$h_Lio_circe_cursor_TopCursor.prototype = $c_Lio_circe_cursor_TopCursor.prototype;
$c_Lio_circe_cursor_TopCursor.prototype.value__Lio_circe_Json = (function() {
  return this.Lio_circe_cursor_TopCursor__f_value
});
$c_Lio_circe_cursor_TopCursor.prototype.right__Lio_circe_ACursor = (function() {
  var op = $m_Lio_circe_CursorOp$MoveRight$();
  return new $c_Lio_circe_FailedCursor(this, op)
});
var $d_Lio_circe_cursor_TopCursor = new $TypeData().initClass({
  Lio_circe_cursor_TopCursor: 0
}, false, "io.circe.cursor.TopCursor", {
  Lio_circe_cursor_TopCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_cursor_TopCursor.prototype.$classData = $d_Lio_circe_cursor_TopCursor;
/** @constructor */
function $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1(decode$1, gen$1) {
  this.Lio_circe_generic_decoding_DerivedDecoder$$anon$1__f_decode$1 = null;
  this.Lio_circe_generic_decoding_DerivedDecoder$$anon$1__f_gen$1 = null;
  this.Lio_circe_generic_decoding_DerivedDecoder$$anon$1__f_decode$1 = decode$1;
  this.Lio_circe_generic_decoding_DerivedDecoder$$anon$1__f_gen$1 = gen$1
}
$c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1.prototype = new $h_Lio_circe_generic_decoding_DerivedDecoder();
$c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1.prototype.constructor = $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1;
/** @constructor */
function $h_Lio_circe_generic_decoding_DerivedDecoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_decoding_DerivedDecoder$$anon$1.prototype = $c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1.prototype;
$c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n($as_Lio_circe_Decoder($n(this.Lio_circe_generic_decoding_DerivedDecoder$$anon$1__f_decode$1).value__O())).apply__Lio_circe_HCursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var r = $n(x2).s_util_Right__f_value;
    $n($m_s_package$().s_package$__f_Right);
    var value = $n(this.Lio_circe_generic_decoding_DerivedDecoder$$anon$1__f_gen$1).from__O__O(r);
    return new $c_s_util_Right(value)
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lio_circe_generic_decoding_DerivedDecoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_generic_decoding_DerivedDecoder$$anon$1: 0
}, false, "io.circe.generic.decoding.DerivedDecoder$$anon$1", {
  Lio_circe_generic_decoding_DerivedDecoder$$anon$1: 1,
  Lio_circe_generic_decoding_DerivedDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_decoding_DerivedDecoder$$anon$1.prototype.$classData = $d_Lio_circe_generic_decoding_DerivedDecoder$$anon$1;
/** @constructor */
function $c_Lio_circe_generic_decoding_ReprDecoder$$anon$1() {
  /*<skip>*/
}
$c_Lio_circe_generic_decoding_ReprDecoder$$anon$1.prototype = new $h_Lio_circe_generic_decoding_ReprDecoder();
$c_Lio_circe_generic_decoding_ReprDecoder$$anon$1.prototype.constructor = $c_Lio_circe_generic_decoding_ReprDecoder$$anon$1;
/** @constructor */
function $h_Lio_circe_generic_decoding_ReprDecoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_decoding_ReprDecoder$$anon$1.prototype = $c_Lio_circe_generic_decoding_ReprDecoder$$anon$1.prototype;
$c_Lio_circe_generic_decoding_ReprDecoder$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  if ($n($n(c).value__Lio_circe_Json()).isObject__Z()) {
    $n($m_s_package$().s_package$__f_Right);
    var value = $m_Lshapeless_HNil$();
    return new $c_s_util_Right(value)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("HNil", ops);
    return new $c_s_util_Left(value$1)
  }
});
var $d_Lio_circe_generic_decoding_ReprDecoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_generic_decoding_ReprDecoder$$anon$1: 0
}, false, "io.circe.generic.decoding.ReprDecoder$$anon$1", {
  Lio_circe_generic_decoding_ReprDecoder$$anon$1: 1,
  Lio_circe_generic_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_decoding_ReprDecoder$$anon$1.prototype.$classData = $d_Lio_circe_generic_decoding_ReprDecoder$$anon$1;
/** @constructor */
function $c_Lio_circe_generic_extras_Configuration(transformMemberNames, transformConstructorNames, useDefaults, discriminator, strictDecoding) {
  this.Lio_circe_generic_extras_Configuration__f_transformMemberNames = null;
  this.Lio_circe_generic_extras_Configuration__f_transformConstructorNames = null;
  this.Lio_circe_generic_extras_Configuration__f_useDefaults = false;
  this.Lio_circe_generic_extras_Configuration__f_discriminator = null;
  this.Lio_circe_generic_extras_Configuration__f_strictDecoding = false;
  this.Lio_circe_generic_extras_Configuration__f_transformMemberNames = transformMemberNames;
  this.Lio_circe_generic_extras_Configuration__f_transformConstructorNames = transformConstructorNames;
  this.Lio_circe_generic_extras_Configuration__f_useDefaults = useDefaults;
  this.Lio_circe_generic_extras_Configuration__f_discriminator = discriminator;
  this.Lio_circe_generic_extras_Configuration__f_strictDecoding = strictDecoding
}
$c_Lio_circe_generic_extras_Configuration.prototype = new $h_O();
$c_Lio_circe_generic_extras_Configuration.prototype.constructor = $c_Lio_circe_generic_extras_Configuration;
/** @constructor */
function $h_Lio_circe_generic_extras_Configuration() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_Configuration.prototype = $c_Lio_circe_generic_extras_Configuration.prototype;
$c_Lio_circe_generic_extras_Configuration.prototype.withDefaults__Lio_circe_generic_extras_Configuration = (function() {
  var x$2 = this.Lio_circe_generic_extras_Configuration__f_transformMemberNames;
  var x$3 = this.Lio_circe_generic_extras_Configuration__f_transformConstructorNames;
  var x$4 = this.Lio_circe_generic_extras_Configuration__f_discriminator;
  var x$5 = this.Lio_circe_generic_extras_Configuration__f_strictDecoding;
  return new $c_Lio_circe_generic_extras_Configuration(x$2, x$3, true, x$4, x$5)
});
$c_Lio_circe_generic_extras_Configuration.prototype.withDiscriminator__T__Lio_circe_generic_extras_Configuration = (function(discriminator) {
  var x$1 = new $c_s_Some(discriminator);
  var x$2 = this.Lio_circe_generic_extras_Configuration__f_transformMemberNames;
  var x$3 = this.Lio_circe_generic_extras_Configuration__f_transformConstructorNames;
  var x$4 = this.Lio_circe_generic_extras_Configuration__f_useDefaults;
  var x$5 = this.Lio_circe_generic_extras_Configuration__f_strictDecoding;
  return new $c_Lio_circe_generic_extras_Configuration(x$2, x$3, x$4, x$1, x$5)
});
$c_Lio_circe_generic_extras_Configuration.prototype.productPrefix__T = (function() {
  return "Configuration"
});
$c_Lio_circe_generic_extras_Configuration.prototype.productArity__I = (function() {
  return 5
});
$c_Lio_circe_generic_extras_Configuration.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lio_circe_generic_extras_Configuration__f_transformMemberNames;
      break
    }
    case 1: {
      return this.Lio_circe_generic_extras_Configuration__f_transformConstructorNames;
      break
    }
    case 2: {
      return this.Lio_circe_generic_extras_Configuration__f_useDefaults;
      break
    }
    case 3: {
      return this.Lio_circe_generic_extras_Configuration__f_discriminator;
      break
    }
    case 4: {
      return this.Lio_circe_generic_extras_Configuration__f_strictDecoding;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lio_circe_generic_extras_Configuration.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_generic_extras_Configuration.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Configuration");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lio_circe_generic_extras_Configuration__f_transformMemberNames;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lio_circe_generic_extras_Configuration__f_transformConstructorNames;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lio_circe_generic_extras_Configuration__f_useDefaults ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lio_circe_generic_extras_Configuration__f_discriminator;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lio_circe_generic_extras_Configuration__f_strictDecoding ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lio_circe_generic_extras_Configuration.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_generic_extras_Configuration.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_circe_generic_extras_Configuration)) {
    var Configuration$1 = $as_Lio_circe_generic_extras_Configuration(x$1);
    if (((this.Lio_circe_generic_extras_Configuration__f_useDefaults === $n(Configuration$1).Lio_circe_generic_extras_Configuration__f_useDefaults) && (this.Lio_circe_generic_extras_Configuration__f_strictDecoding === $n(Configuration$1).Lio_circe_generic_extras_Configuration__f_strictDecoding))) {
      var x = this.Lio_circe_generic_extras_Configuration__f_transformMemberNames;
      var x$2 = $n(Configuration$1).Lio_circe_generic_extras_Configuration__f_transformMemberNames;
      var $$x2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3 = this.Lio_circe_generic_extras_Configuration__f_transformConstructorNames;
      var x$4 = $n(Configuration$1).Lio_circe_generic_extras_Configuration__f_transformConstructorNames;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lio_circe_generic_extras_Configuration__f_discriminator;
      var x$6 = $n(Configuration$1).Lio_circe_generic_extras_Configuration__f_discriminator;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lio_circe_generic_extras_Configuration(obj) {
  return (((obj instanceof $c_Lio_circe_generic_extras_Configuration) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.generic.extras.Configuration"))
}
function $isArrayOf_Lio_circe_generic_extras_Configuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_generic_extras_Configuration)))
}
function $asArrayOf_Lio_circe_generic_extras_Configuration(obj, depth) {
  return (($isArrayOf_Lio_circe_generic_extras_Configuration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.generic.extras.Configuration;", depth))
}
var $d_Lio_circe_generic_extras_Configuration = new $TypeData().initClass({
  Lio_circe_generic_extras_Configuration: 0
}, false, "io.circe.generic.extras.Configuration", {
  Lio_circe_generic_extras_Configuration: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_Configuration.prototype.$classData = $d_Lio_circe_generic_extras_Configuration;
function $ct_Lio_circe_generic_extras_decoding_ConfiguredDecoder__Lio_circe_generic_extras_Configuration__($thiz, config) {
  $thiz.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_config = config;
  $thiz.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_constructorNameCache = $ct_ju_concurrent_ConcurrentHashMap__(new $c_ju_concurrent_ConcurrentHashMap());
  return $thiz
}
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder() {
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_config = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_constructorNameCache = null
}
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder.prototype = new $h_Lio_circe_generic_decoding_DerivedDecoder();
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ConfiguredDecoder.prototype = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder.prototype;
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder.prototype.constructorNameTransformer__T__T = (function(value) {
  var current = $as_T($n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_constructorNameCache).get__O__O(value));
  if ((current === null)) {
    var transformed = $as_T($n($n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_config).Lio_circe_generic_extras_Configuration__f_transformConstructorNames).apply__O__O(value));
    $n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_constructorNameCache).put__O__O__O(value, transformed);
    return transformed
  } else {
    return current
  }
});
function $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(obj) {
  return (((obj instanceof $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.generic.extras.decoding.ConfiguredDecoder"))
}
function $isArrayOf_Lio_circe_generic_extras_decoding_ConfiguredDecoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_generic_extras_decoding_ConfiguredDecoder)))
}
function $asArrayOf_Lio_circe_generic_extras_decoding_ConfiguredDecoder(obj, depth) {
  return (($isArrayOf_Lio_circe_generic_extras_decoding_ConfiguredDecoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.generic.extras.decoding.ConfiguredDecoder;", depth))
}
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1() {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1.prototype = $c_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1.prototype;
$c_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  if ($n($n(c).value__Lio_circe_Json()).isObject__Z()) {
    $n($m_s_package$().s_package$__f_Right);
    var value = $m_Lshapeless_HNil$();
    return new $c_s_util_Right(value)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("HNil", ops);
    return new $c_s_util_Left(value$1)
  }
});
var $d_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1: 0
}, false, "io.circe.generic.extras.decoding.ReprDecoder$$anon$1", {
  Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1.prototype.$classData = $d_Lio_circe_generic_extras_decoding_ReprDecoder$$anon$1;
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$$anon$1() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
  $ct_Lio_circe_numbers_BiggerDecimal$Zero__(this)
}
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype = new $h_Lio_circe_numbers_BiggerDecimal$Zero();
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$$anon$1;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype = $c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype;
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.isNegativeZero__Z = (function() {
  return false
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.toDouble__D = (function() {
  return 0.0
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.toFloat__F = (function() {
  return 0.0
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero)) {
    var x2 = $as_Lio_circe_numbers_BiggerDecimal$Zero(that);
    return (!$n(x2).isNegativeZero__Z())
  } else {
    return false
  }
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.hashCode__I = (function() {
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(0.0)
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.toString__T = (function() {
  return "0"
});
var $d_Lio_circe_numbers_BiggerDecimal$$anon$1 = new $TypeData().initClass({
  Lio_circe_numbers_BiggerDecimal$$anon$1: 0
}, false, "io.circe.numbers.BiggerDecimal$$anon$1", {
  Lio_circe_numbers_BiggerDecimal$$anon$1: 1,
  Lio_circe_numbers_BiggerDecimal$Zero: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.$classData = $d_Lio_circe_numbers_BiggerDecimal$$anon$1;
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$$anon$2() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
  $ct_Lio_circe_numbers_BiggerDecimal$Zero__(this)
}
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype = new $h_Lio_circe_numbers_BiggerDecimal$Zero();
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$$anon$2;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype = $c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype;
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.isNegativeZero__Z = (function() {
  return true
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.toDouble__D = (function() {
  return (-0)
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.toFloat__F = (function() {
  return (-0)
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero)) {
    var x2 = $as_Lio_circe_numbers_BiggerDecimal$Zero(that);
    return $n(x2).isNegativeZero__Z()
  } else {
    return false
  }
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.hashCode__I = (function() {
  return $m_jl_FloatingPointBits$().numberHashCode__D__I((-0))
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.toString__T = (function() {
  return "-0"
});
var $d_Lio_circe_numbers_BiggerDecimal$$anon$2 = new $TypeData().initClass({
  Lio_circe_numbers_BiggerDecimal$$anon$2: 0
}, false, "io.circe.numbers.BiggerDecimal$$anon$2", {
  Lio_circe_numbers_BiggerDecimal$$anon$2: 1,
  Lio_circe_numbers_BiggerDecimal$Zero: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.$classData = $d_Lio_circe_numbers_BiggerDecimal$$anon$2;
/** @constructor */
function $c_Lio_circe_scalajs_package$$anon$1() {
  /*<skip>*/
}
$c_Lio_circe_scalajs_package$$anon$1.prototype = new $h_O();
$c_Lio_circe_scalajs_package$$anon$1.prototype.constructor = $c_Lio_circe_scalajs_package$$anon$1;
/** @constructor */
function $h_Lio_circe_scalajs_package$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_scalajs_package$$anon$1.prototype = $c_Lio_circe_scalajs_package$$anon$1.prototype;
$c_Lio_circe_scalajs_package$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  var value = $as_Lio_circe_Json(v1);
  return $uZ($n(value).foldWith__Lio_circe_Json$Folder__O(this))
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onArray__sci_Vector__sjs_js_Any = (function(value) {
  var $$x1 = $m_sjs_js_JSConverters$JSRichIterableOnce$();
  var col = $as_sc_IterableOnce($n(value).map__F1__O(this));
  return $n($$x1).toJSArray$extension__sc_IterableOnce__sjs_js_Array(col)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onObject__Lio_circe_JsonObject__sjs_js_Any = (function(value) {
  var this$1 = $n($n(value).toMap__sci_Map());
  var this$3 = new $c_sc_MapView$MapValues(this$1, this);
  var this$2 = $m_s_$less$colon$less$();
  var map = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3);
  var result = {};
  $n(map).foreach__F1__V(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var key = $as_T($n(x0$1)._1__O());
      var value$1 = $n(x0$1)._2__O();
      result[key] = value$1
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })));
  return result
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onObject__Lio_circe_JsonObject__O = (function(value) {
  return this.onObject__Lio_circe_JsonObject__sjs_js_Any(value)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onArray__sci_Vector__O = (function(value) {
  return this.onArray__sci_Vector__sjs_js_Any(value)
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onString__T__O = (function(value) {
  return value
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onNumber__Lio_circe_JsonNumber__O = (function(value) {
  var value$1 = $n(value).toDouble__D();
  return value$1
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onBoolean__Z__O = (function(value) {
  return value
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.onNull__O = (function() {
  return null
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.apply__O__O = (function(v1) {
  var value = $as_Lio_circe_Json(v1);
  return $n(value).foldWith__Lio_circe_Json$Folder__O(this)
});
var $d_Lio_circe_scalajs_package$$anon$1 = new $TypeData().initClass({
  Lio_circe_scalajs_package$$anon$1: 0
}, false, "io.circe.scalajs.package$$anon$1", {
  Lio_circe_scalajs_package$$anon$1: 1,
  O: 1,
  Lio_circe_Json$Folder: 1,
  Ljava_io_Serializable: 1,
  F1: 1
});
$c_Lio_circe_scalajs_package$$anon$1.prototype.$classData = $d_Lio_circe_scalajs_package$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$Mod(mod) {
  this.Ljapgolly_scalajs_react_CtorType$Mod__f_mod = null;
  this.Ljapgolly_scalajs_react_CtorType$Mod__f_mod = mod
}
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$Mod;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$Mod() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$Mod.prototype = $c_Ljapgolly_scalajs_react_CtorType$Mod.prototype;
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype.productPrefix__T = (function() {
  return "Mod"
});
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype.productElement__I__O = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_CtorType$Mod$().productElement$extension__F1__I__O(this.Ljapgolly_scalajs_react_CtorType$Mod__f_mod, x$1)
});
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype.productIterator__sc_Iterator = (function() {
  return $m_Ljapgolly_scalajs_react_CtorType$Mod$().productIterator$extension__F1__sc_Iterator(this.Ljapgolly_scalajs_react_CtorType$Mod__f_mod)
});
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype.hashCode__I = (function() {
  var this$ = this.Ljapgolly_scalajs_react_CtorType$Mod__f_mod;
  return $n(this$).hashCode__I()
});
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_CtorType$Mod$().equals$extension__F1__O__Z(this.Ljapgolly_scalajs_react_CtorType$Mod__f_mod, x$1)
});
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_CtorType$Mod$().toString$extension__F1__T(this.Ljapgolly_scalajs_react_CtorType$Mod__f_mod)
});
function $as_Ljapgolly_scalajs_react_CtorType$Mod(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_CtorType$Mod) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.CtorType$Mod"))
}
function $isArrayOf_Ljapgolly_scalajs_react_CtorType$Mod(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_CtorType$Mod)))
}
function $asArrayOf_Ljapgolly_scalajs_react_CtorType$Mod(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_CtorType$Mod(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.CtorType$Mod;", depth))
}
var $d_Ljapgolly_scalajs_react_CtorType$Mod = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$Mod: 0
}, false, "japgolly.scalajs.react.CtorType$Mod", {
  Ljapgolly_scalajs_react_CtorType$Mod: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_CtorType$Mod.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$Mod;
/** @constructor */
function $c_Ljapgolly_scalajs_react_CtorType$Mod$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype = new $h_sr_AbstractFunction1();
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.constructor = $c_Ljapgolly_scalajs_react_CtorType$Mod$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_CtorType$Mod$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_CtorType$Mod$.prototype = $c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype;
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.toString__T = (function() {
  return "Mod"
});
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.applyAndCast$extension__F1__sjs_js_Object__sjs_js_Object = (function(this$, o) {
  $n(this$).apply__O__O(o);
  return o
});
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.$greater$greater$extension__F1__F1__F1 = (function(this$, f) {
  return new $c_sjsr_AnonFunction1(((o$2) => {
    $n(this$).apply__O__O(o$2);
    $n(f).apply__O__O(o$2)
  }))
});
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.productElement$extension__F1__I__O = (function(this$, x$1) {
  return ((x$1 === 0) ? this$ : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.productIterator$extension__F1__sc_Iterator = (function(this$) {
  var x = new $c_Ljapgolly_scalajs_react_CtorType$Mod(this$);
  return new $c_sr_ScalaRunTime$$anon$1(x)
});
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.equals$extension__F1__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Ljapgolly_scalajs_react_CtorType$Mod)) {
    var Mod$1 = ((x$1 === null) ? null : $n($as_Ljapgolly_scalajs_react_CtorType$Mod(x$1)).Ljapgolly_scalajs_react_CtorType$Mod__f_mod);
    return ((this$ === null) ? (Mod$1 === null) : $n(this$).equals__O__Z(Mod$1))
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.toString$extension__F1__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Ljapgolly_scalajs_react_CtorType$Mod(this$))
});
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.apply__O__O = (function(v1) {
  var mod = $as_F1(v1);
  return new $c_Ljapgolly_scalajs_react_CtorType$Mod(mod)
});
var $d_Ljapgolly_scalajs_react_CtorType$Mod$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_CtorType$Mod$: 0
}, false, "japgolly.scalajs.react.CtorType$Mod$", {
  Ljapgolly_scalajs_react_CtorType$Mod$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_CtorType$Mod$.prototype.$classData = $d_Ljapgolly_scalajs_react_CtorType$Mod$;
var $n_Ljapgolly_scalajs_react_CtorType$Mod$;
function $m_Ljapgolly_scalajs_react_CtorType$Mod$() {
  if ((!$n_Ljapgolly_scalajs_react_CtorType$Mod$)) {
    $n_Ljapgolly_scalajs_react_CtorType$Mod$ = new $c_Ljapgolly_scalajs_react_CtorType$Mod$()
  };
  return $n_Ljapgolly_scalajs_react_CtorType$Mod$
}
function $f_Ljapgolly_scalajs_react_NonEmptyRef$FullF__mod__F1__O($thiz, f) {
  $n($thiz.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_FF);
  var fa = $thiz.get__O();
  var f$1 = new $c_sjsr_AnonFunction1(((o$2) => $thiz.set__O__O($n(f).apply__O__O(o$2))));
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, f$1))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_ReactCaughtError(rawError, rawInfo) {
  this.Ljapgolly_scalajs_react_ReactCaughtError__f_rawError = null;
  this.Ljapgolly_scalajs_react_ReactCaughtError__f_rawInfo = null;
  this.Ljapgolly_scalajs_react_ReactCaughtError__f_rawError = rawError;
  this.Ljapgolly_scalajs_react_ReactCaughtError__f_rawInfo = rawInfo;
  $as_T((typeof rawError));
  if ($uZ((rawError instanceof Error))) {
    $n($m_s_package$().s_package$__f_Right);
    new $c_s_util_Right(rawError)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    new $c_s_util_Left(rawError)
  }
}
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.constructor = $c_Ljapgolly_scalajs_react_ReactCaughtError;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ReactCaughtError() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ReactCaughtError.prototype = $c_Ljapgolly_scalajs_react_ReactCaughtError.prototype;
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.toString__T = (function() {
  return (("ReactCaughtError(" + this.rawErrorString__T()) + ")")
});
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.rawErrorString__T = (function() {
  try {
    return ("" + this.Ljapgolly_scalajs_react_ReactCaughtError__f_rawError)
  } catch (e) {
    return ""
  }
});
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.productPrefix__T = (function() {
  return "ReactCaughtError"
});
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.productArity__I = (function() {
  return 2
});
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_ReactCaughtError__f_rawError;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_ReactCaughtError__f_rawInfo;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_ReactCaughtError)) {
    var ReactCaughtError$1 = $as_Ljapgolly_scalajs_react_ReactCaughtError(x$1);
    var x = this.Ljapgolly_scalajs_react_ReactCaughtError__f_rawError;
    var y = $n(ReactCaughtError$1).Ljapgolly_scalajs_react_ReactCaughtError__f_rawError;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Ljapgolly_scalajs_react_ReactCaughtError__f_rawInfo;
      var y$1 = $n(ReactCaughtError$1).Ljapgolly_scalajs_react_ReactCaughtError__f_rawInfo;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_ReactCaughtError(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_ReactCaughtError) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.ReactCaughtError"))
}
function $isArrayOf_Ljapgolly_scalajs_react_ReactCaughtError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_ReactCaughtError)))
}
function $asArrayOf_Ljapgolly_scalajs_react_ReactCaughtError(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_ReactCaughtError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.ReactCaughtError;", depth))
}
var $d_Ljapgolly_scalajs_react_ReactCaughtError = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ReactCaughtError: 0
}, false, "japgolly.scalajs.react.ReactCaughtError", {
  Ljapgolly_scalajs_react_ReactCaughtError: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_ReactCaughtError.prototype.$classData = $d_Ljapgolly_scalajs_react_ReactCaughtError;
function $f_Ljapgolly_scalajs_react_Ref$FullF__narrowOption__s_reflect_ClassTag__Ljapgolly_scalajs_react_Ref$FullF($thiz, ct) {
  return $thiz.mapOption__F1__Ljapgolly_scalajs_react_Ref$FullF(new $c_sjsr_AnonFunction1(((x$2) => $n(ct).unapply__O__s_Option(x$2))))
}
function $is_Ljapgolly_scalajs_react_Ref$FullF(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_Ref$FullF)))
}
function $as_Ljapgolly_scalajs_react_Ref$FullF(obj) {
  return (($is_Ljapgolly_scalajs_react_Ref$FullF(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.Ref$FullF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_Ref$FullF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_Ref$FullF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_Ref$FullF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_Ref$FullF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.Ref$FullF;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult(self, evidence$266, evidence$267) {
  this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self = null;
  this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_updateProps = false;
  this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_updateState = false;
  this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_update = false;
  this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self = self;
  $m_Ljapgolly_scalajs_react_internal_CoreGeneral$();
  var this$1 = $n(this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self);
  var a = $n(this$1.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O();
  var a$1 = $n(this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self).Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextProps;
  this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_updateProps = (!$uZ($n(evidence$266).apply__O__O__O(a, a$1)));
  $m_Ljapgolly_scalajs_react_internal_CoreGeneral$();
  var this$4 = $n(this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self);
  var a$2 = $n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O();
  var a$3 = $n(this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self).Ljapgolly_scalajs_react_component_builder_LifecycleF$ShouldComponentUpdate__f_nextState;
  this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_updateState = (!$uZ($n(evidence$267).apply__O__O__O(a$2, a$3)));
  this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_update = (this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_updateProps || this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_updateState)
}
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype.constructor = $c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype = $c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype;
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype.productPrefix__T = (function() {
  return "ShouldComponentUpdateResult"
});
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult)) {
    var ShouldComponentUpdateResult$1 = $as_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult(x$1);
    var x = this.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self;
    var x$2 = $n(ShouldComponentUpdateResult$1).Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult__f_self;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.Reusability$ShouldComponentUpdateResult"))
}
function $isArrayOf_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult)))
}
function $asArrayOf_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.Reusability$ShouldComponentUpdateResult;", depth))
}
var $d_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult: 0
}, false, "japgolly.scalajs.react.Reusability$ShouldComponentUpdateResult", {
  Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult.prototype.$classData = $d_Ljapgolly_scalajs_react_Reusability$ShouldComponentUpdateResult;
function $is_Ljapgolly_scalajs_react_StateAccess$Write(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_StateAccess$Write)))
}
function $as_Ljapgolly_scalajs_react_StateAccess$Write(obj) {
  return (($is_Ljapgolly_scalajs_react_StateAccess$Write(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.StateAccess$Write"))
}
function $isArrayOf_Ljapgolly_scalajs_react_StateAccess$Write(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_StateAccess$Write)))
}
function $asArrayOf_Ljapgolly_scalajs_react_StateAccess$Write(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_StateAccess$Write(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.StateAccess$Write;", depth))
}
function $p_Ljapgolly_scalajs_react_StateAccessor$__japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance$lzycompute__Ljapgolly_scalajs_react_StateAccessor$ReadWrite($thiz) {
  if (((((1 & $thiz.Ljapgolly_scalajs_react_StateAccessor$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljapgolly_scalajs_react_StateAccessor$__f_japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance = $f_Ljapgolly_scalajs_react_StateAccessorImplicits2__stateAccess__Ljapgolly_scalajs_react_StateAccessor$ReadWrite($thiz);
    $thiz.Ljapgolly_scalajs_react_StateAccessor$__f_bitmap$0 = (((1 | $thiz.Ljapgolly_scalajs_react_StateAccessor$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljapgolly_scalajs_react_StateAccessor$__f_japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_StateAccessor$() {
  this.Ljapgolly_scalajs_react_StateAccessor$__f_japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance = null;
  this.Ljapgolly_scalajs_react_StateAccessor$__f_bitmap$0 = 0
}
$c_Ljapgolly_scalajs_react_StateAccessor$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_StateAccessor$.prototype.constructor = $c_Ljapgolly_scalajs_react_StateAccessor$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_StateAccessor$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_StateAccessor$.prototype = $c_Ljapgolly_scalajs_react_StateAccessor$.prototype;
$c_Ljapgolly_scalajs_react_StateAccessor$.prototype.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite = (function() {
  return (((((1 & this.Ljapgolly_scalajs_react_StateAccessor$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljapgolly_scalajs_react_StateAccessor$__japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance$lzycompute__Ljapgolly_scalajs_react_StateAccessor$ReadWrite(this) : this.Ljapgolly_scalajs_react_StateAccessor$__f_japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance)
});
var $d_Ljapgolly_scalajs_react_StateAccessor$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_StateAccessor$: 0
}, false, "japgolly.scalajs.react.StateAccessor$", {
  Ljapgolly_scalajs_react_StateAccessor$: 1,
  O: 1,
  Ljapgolly_scalajs_react_StateAccessorImplicits: 1,
  Ljapgolly_scalajs_react_StateAccessorImplicits1: 1,
  Ljapgolly_scalajs_react_StateAccessorImplicits2: 1
});
$c_Ljapgolly_scalajs_react_StateAccessor$.prototype.$classData = $d_Ljapgolly_scalajs_react_StateAccessor$;
var $n_Ljapgolly_scalajs_react_StateAccessor$;
function $m_Ljapgolly_scalajs_react_StateAccessor$() {
  if ((!$n_Ljapgolly_scalajs_react_StateAccessor$)) {
    $n_Ljapgolly_scalajs_react_StateAccessor$ = new $c_Ljapgolly_scalajs_react_StateAccessor$()
  };
  return $n_Ljapgolly_scalajs_react_StateAccessor$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_StateAccessor$$anon$3(r$2, w$2) {
  this.Ljapgolly_scalajs_react_StateAccessor$$anon$3__f_write = null;
  this.Ljapgolly_scalajs_react_StateAccessor$$anon$3__f_write = w$2
}
$c_Ljapgolly_scalajs_react_StateAccessor$$anon$3.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_StateAccessor$$anon$3.prototype.constructor = $c_Ljapgolly_scalajs_react_StateAccessor$$anon$3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_StateAccessor$$anon$3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_StateAccessor$$anon$3.prototype = $c_Ljapgolly_scalajs_react_StateAccessor$$anon$3.prototype;
var $d_Ljapgolly_scalajs_react_StateAccessor$$anon$3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_StateAccessor$$anon$3: 0
}, false, "japgolly.scalajs.react.StateAccessor$$anon$3", {
  Ljapgolly_scalajs_react_StateAccessor$$anon$3: 1,
  O: 1,
  Ljapgolly_scalajs_react_StateAccessor$ReadWrite: 1,
  Ljapgolly_scalajs_react_StateAccessor$Read: 1,
  Ljapgolly_scalajs_react_StateAccessor$Write: 1
});
$c_Ljapgolly_scalajs_react_StateAccessor$$anon$3.prototype.$classData = $d_Ljapgolly_scalajs_react_StateAccessor$$anon$3;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF(componentDidCatch, componentDidMount, componentDidUpdate, componentWillMount, componentWillReceiveProps, componentWillUnmount, componentWillUpdate, getDerivedStateFromProps, getSnapshotBeforeUpdate, shouldComponentUpdate) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch = componentDidCatch;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount = componentDidMount;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate = componentDidUpdate;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount = componentWillMount;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps = componentWillReceiveProps;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount = componentWillUnmount;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate = componentWillUpdate;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps = getDerivedStateFromProps;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate = getSnapshotBeforeUpdate;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate = shouldComponentUpdate
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.append__Ljapgolly_scalajs_react_internal_Lens__F1__F2__Ljapgolly_scalajs_react_component_builder_LifecycleF = (function(lens, g, s) {
  return $as_Ljapgolly_scalajs_react_component_builder_LifecycleF($n($as_F1($n($n(lens).Ljapgolly_scalajs_react_internal_Lens__f_mod).apply__O__O(new $c_sjsr_AnonFunction1(((o$2) => {
    var o = $as_s_Option(o$2);
    var this$2 = $n(o);
    if (this$2.isEmpty__Z()) {
      var $$x1 = g
    } else {
      var arg1 = this$2.get__O();
      var f = $as_F1(arg1);
      var $$x1 = new $c_sjsr_AnonFunction1(((i$2) => $n(s).apply__O__O__O($n(f).apply__O__O(i$2), new $c_sjsr_AnonFunction0((() => $n(g).apply__O__O(i$2))))))
    };
    return new $c_s_Some($$x1)
  }))))).apply__O__O(this))
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.productPrefix__T = (function() {
  return "LifecycleF"
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.productArity__I = (function() {
  return 10
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
      break
    }
    case 2: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
      break
    }
    case 3: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
      break
    }
    case 4: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
      break
    }
    case 5: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
      break
    }
    case 6: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
      break
    }
    case 7: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps;
      break
    }
    case 8: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
      break
    }
    case 9: {
      return this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF)) {
    var LifecycleF$1 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(x$1);
    var x = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
    var x$2 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidCatch;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
      var x$4 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidMount;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
      var x$6 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentDidUpdate;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
        var x$8 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillMount;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
          var x$10 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillReceiveProps;
          var $$x1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
      var x$12 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUnmount;
      if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
        var x$13 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
        var x$14 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_componentWillUpdate;
        var $$x3 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$15 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps;
        var x$16 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getDerivedStateFromProps;
        if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
          var x$17 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
          var x$18 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_getSnapshotBeforeUpdate;
          if (((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))) {
            var x$19 = this.Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
            var x$20 = $n(LifecycleF$1).Ljapgolly_scalajs_react_component_builder_LifecycleF__f_shouldComponentUpdate;
            return ((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_component_builder_LifecycleF(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.LifecycleF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_LifecycleF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.LifecycleF;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF;
function $is_Ljapgolly_scalajs_react_extra_Broadcaster(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_extra_Broadcaster)))
}
function $as_Ljapgolly_scalajs_react_extra_Broadcaster(obj) {
  return (($is_Ljapgolly_scalajs_react_extra_Broadcaster(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.Broadcaster"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_Broadcaster(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_Broadcaster)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_Broadcaster(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_Broadcaster(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.Broadcaster;", depth))
}
function $is_Ljapgolly_scalajs_react_extra_router_ActionF(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_extra_router_ActionF)))
}
function $as_Ljapgolly_scalajs_react_extra_router_ActionF(obj) {
  return (($is_Ljapgolly_scalajs_react_extra_router_ActionF(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.ActionF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_ActionF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_ActionF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_ActionF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_ActionF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.ActionF;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(page, renderP) {
  this.Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page = null;
  this.Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_renderP = null;
  this.Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page = page;
  this.Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_renderP = renderP
}
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype = $c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype;
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype.productPrefix__T = (function() {
  return "ResolutionWithProps"
});
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype.productArity__I = (function() {
  return 2
});
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_renderP;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps)) {
    var ResolutionWithProps$1 = $as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page;
    var y = $n(ResolutionWithProps$1).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_page;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_renderP;
      var x$2$1 = $n(ResolutionWithProps$1).Ljapgolly_scalajs_react_extra_router_ResolutionWithProps__f_renderP;
      return ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.ResolutionWithProps"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_ResolutionWithProps)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.ResolutionWithProps;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_ResolutionWithProps: 0
}, false, "japgolly.scalajs.react.extra.router.ResolutionWithProps", {
  Ljapgolly_scalajs_react_extra_router_ResolutionWithProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_ResolutionWithProps;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(rules, renderFn, postRenderFn, logger, effect) {
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_renderFn = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_logger = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules = rules;
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_renderFn = renderFn;
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn = postRenderFn;
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_logger = logger;
  this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect = effect
}
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.logWith__F1__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = (function(l) {
  var x$2 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules;
  var x$3 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_renderFn;
  var x$4 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn;
  var effect = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect;
  return new $c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(x$2, x$3, x$4, l, effect)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.renderWithP__F2__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = (function(f) {
  var x$2 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules;
  var x$3 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn;
  var x$4 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_logger;
  var effect = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect;
  return new $c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(x$2, f, x$3, x$4, effect)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.setPostRenderP__F3__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = (function(f, G) {
  var this$1 = $n(this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var x$1 = $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatchFn3__F3__Ljapgolly_scalajs_react_util_Effect$Dispatch__F3(this$1, f, G);
  var x$2 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules;
  var x$3 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_renderFn;
  var x$4 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_logger;
  var effect = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect;
  return new $c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(x$2, x$3, x$1, x$4, effect)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.onPostRenderP__F3__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = (function(f, G) {
  var this$1 = $n(this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
  var f2 = $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatchFn3__F3__Ljapgolly_scalajs_react_util_Effect$Dispatch__F3(this$1, f, G);
  return this.setPostRenderP__F3__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(new $c_sjsr_AnonFunction3(((a$2, b$2, c$2) => {
    var a = $as_s_Option(a$2);
    $n(this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
    var fa = $n(this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn).apply__O__O__O__O(a, b$2, c$2);
    var fb = $n(f2).apply__O__O__O__O(a, b$2, c$2);
    var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var fb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fb)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, fb$1))
  })), this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.setTitleP__F2__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = (function(f) {
  return this.setTitleOptionP__F2__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(new $c_sjsr_AnonFunction2(((p$2, c$2) => new $c_s_Some($n(f).apply__O__O__O(p$2, c$2)))))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.setTitleOptionP__F2__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = (function(f) {
  return this.onPostRenderP__F3__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(new $c_sjsr_AnonFunction3(((x$4$2, page$2, c$2) => {
    $as_s_Option(x$4$2);
    var this$2 = $n($as_s_Option($n(f).apply__O__O__O(page$2, c$2)));
    if (this$2.isEmpty__Z()) {
      var this$3 = $n(this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    } else {
      var arg1 = this$2.get__O();
      var title = $as_T(arg1);
      $n(this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect);
      var a = new $c_sjsr_AnonFunction0((() => {
        document.title = title
      }));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
    }
  })), this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_effect)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.productPrefix__T = (function() {
  return "RouterWithPropsConfigF"
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.productArity__I = (function() {
  return 4
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_renderFn;
      break
    }
    case 2: {
      return this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn;
      break
    }
    case 3: {
      return this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_logger;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF)) {
    var RouterWithPropsConfigF$1 = $as_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules;
    var x$2 = $n(RouterWithPropsConfigF$1).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_rules;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_renderFn;
      var x$4 = $n(RouterWithPropsConfigF$1).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_renderFn;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn;
      var x$6 = $n(RouterWithPropsConfigF$1).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_postRenderFn;
      if ((x$5 === null)) {
        var $$x2 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x2 = (this$2 === x$6)
      };
      if ($$x2) {
        var x$7 = this.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_logger;
        var x$8 = $n(RouterWithPropsConfigF$1).Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF__f_logger;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          $n(RouterWithPropsConfigF$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouterWithPropsConfigF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouterWithPropsConfigF;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF: 0
}, false, "japgolly.scalajs.react.extra.router.RouterWithPropsConfigF", {
  Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF(rule, fallbackPath, fallbackAction, F) {
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_rule = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackPath = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackAction = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_F = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_rule = rule;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackPath = fallbackPath;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackAction = fallbackAction;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_F = F
}
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.notFound__F1__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = (function(whenNotFound) {
  return this.notFoundDynamic__F1__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Ljapgolly_scalajs_react_extra_router_Path(p$2);
    $n(this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_F);
    var a = new $c_sjsr_AnonFunction0((() => $as_s_util_Either($n(whenNotFound).apply__O__O(p))));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
  })))
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.notFoundDynamic__F1__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF = (function(whenNotFound) {
  var rules = $m_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$().fromRule__Ljapgolly_scalajs_react_extra_router_RoutingRule__F1__F2__F1__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RoutingRulesF(this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_rule, this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackPath, this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackAction, whenNotFound, this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_F);
  return $m_Ljapgolly_scalajs_react_extra_router_RouterConfig$().withDefaults__Ljapgolly_scalajs_react_extra_router_RoutingRulesF__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RouterWithPropsConfigF(rules, this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_F)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.productPrefix__T = (function() {
  return "WithFallbackF"
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.productArity__I = (function() {
  return 3
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_rule;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackPath;
      break
    }
    case 2: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackAction;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF)) {
    var WithFallbackF$1 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_rule;
    var x$2 = $n(WithFallbackF$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_rule;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackPath;
      var x$4 = $n(WithFallbackF$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackPath;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackAction;
        var x$6 = $n(WithFallbackF$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF__f_fallbackAction;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$1 = $n(x$5);
          return (this$1 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RoutingRule$WithFallbackF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RoutingRule$WithFallbackF;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRule$WithFallbackF", {
  Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$WithFallbackF;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF(parseMulti, path, actionMulti, fallbackAction, whenNotFound, F) {
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_parseMulti = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_path = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_actionMulti = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_fallbackAction = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_whenNotFound = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_F = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_parseMulti = parseMulti;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_path = path;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_actionMulti = actionMulti;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_fallbackAction = fallbackAction;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_whenNotFound = whenNotFound;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_F = F
}
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RoutingRulesF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype = $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.parse__Ljapgolly_scalajs_react_extra_router_Path__O = (function(path) {
  $n(this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_F);
  var fa = $m_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$().selectParsed__Ljapgolly_scalajs_react_extra_router_Path__F1__Ljapgolly_scalajs_react_util_Effect$Sync__O(path, this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_parseMulti, this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_F);
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    if ((x0$1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x0$1);
      var a = $as_s_util_Either($n(x2).s_Some__f_value);
      $n(this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_F);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a)))
    } else {
      var x = $m_s_None$();
      if ((x === x0$1)) {
        return $n(this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_whenNotFound).apply__O__O(path)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    }
  }));
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, f))
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.action__Ljapgolly_scalajs_react_extra_router_Path__O__O = (function(path, page) {
  $n(this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_F);
  var fa = $m_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$().selectAction__Ljapgolly_scalajs_react_extra_router_Path__O__F2__Ljapgolly_scalajs_react_util_Effect$Sync__O(path, page, this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_actionMulti, this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_F);
  var f = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_s_Option(x$8$2);
    var this$2 = $n(x$8);
    return $as_Ljapgolly_scalajs_react_extra_router_ActionF((this$2.isEmpty__Z() ? $as_Ljapgolly_scalajs_react_extra_router_ActionF($n(this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_fallbackAction).apply__O__O__O(path, page)) : this$2.get__O()))
  }));
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$5 = $n(fa$1);
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$5, f))
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.productPrefix__T = (function() {
  return "RoutingRulesF"
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.productArity__I = (function() {
  return 5
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_parseMulti;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_path;
      break
    }
    case 2: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_actionMulti;
      break
    }
    case 3: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_fallbackAction;
      break
    }
    case 4: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_whenNotFound;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF)) {
    var RoutingRulesF$1 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRulesF(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_parseMulti;
    var x$2 = $n(RoutingRulesF$1).Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_parseMulti;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_path;
      var x$4 = $n(RoutingRulesF$1).Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_path;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_actionMulti;
      var x$6 = $n(RoutingRulesF$1).Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_actionMulti;
      if ((x$5 === null)) {
        var $$x2 = (x$6 === null)
      } else {
        var this$1 = $n(x$5);
        var $$x2 = (this$1 === x$6)
      };
      if ($$x2) {
        var x$7 = this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_fallbackAction;
        var x$8 = $n(RoutingRulesF$1).Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_fallbackAction;
        if ((x$7 === null)) {
          var $$x3 = (x$8 === null)
        } else {
          var this$2 = $n(x$7);
          var $$x3 = (this$2 === x$8)
        };
        if ($$x3) {
          var x$9 = this.Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_whenNotFound;
          var x$10 = $n(RoutingRulesF$1).Ljapgolly_scalajs_react_extra_router_RoutingRulesF__f_whenNotFound;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RoutingRulesF(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RoutingRulesF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRulesF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RoutingRulesF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRulesF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRulesF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RoutingRulesF;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRulesF", {
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$.prototype = $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$.prototype;
var $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$: 0
}, false, "japgolly.scalajs.react.extra.router.StaticDsl$RouteB$Composition$", {
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriMed: 1,
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLow: 1,
  Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition\uff3fPriLowest: 1
});
$c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$;
var $n_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$;
function $m_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$)) {
    $n_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$ = new $c_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_StaticDsl$RouteB$Composition$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(value) {
  this.Ljapgolly_scalajs_react_extra_router_StaticOrDynamic__f_value = null;
  this.Ljapgolly_scalajs_react_extra_router_StaticOrDynamic__f_value = value
}
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype = $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype;
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype.productPrefix__T = (function() {
  return "StaticOrDynamic"
});
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_StaticOrDynamic__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic)) {
    var StaticOrDynamic$1 = $as_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_StaticOrDynamic__f_value;
    var x$2 = $n(StaticOrDynamic$1).Ljapgolly_scalajs_react_extra_router_StaticOrDynamic__f_value;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.StaticOrDynamic"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_StaticOrDynamic)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.StaticOrDynamic;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_StaticOrDynamic: 0
}, false, "japgolly.scalajs.react.extra.router.StaticOrDynamic", {
  Ljapgolly_scalajs_react_extra_router_StaticOrDynamic: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_StaticOrDynamic;
function $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($thiz, f, step, s) {
  return $thiz.render__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_sjsr_AnonFunction1(((x$61$2) => $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($as_F1($n($n(step).squash__F1()).apply__O__O(f))).apply__O__O(x$61$2)))), s)
}
function $is_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender)))
}
function $as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender(obj) {
  return (($is_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.Api$SecondaryWithRender"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.Api$SecondaryWithRender;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F2($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx1$2) => {
        var ctx1 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(ctx1$2);
        var h2 = $n(initNextHook).apply__O__O(ctx1);
        var props = $n(ctx1).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var propsChildren = $n(ctx1).Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren;
        var hook1 = $n(ctx1).Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1;
        var ctx2 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC2__O__sjs_js_Any__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2(), props, propsChildren, hook1, h2);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx2))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F3(f$2);
    return new $c_sjsr_AnonFunction1(((x$21$2) => {
      var x$21 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC1(x$21$2);
      return $n(x$21).apply1__F3__O(f)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21: 0
}, false, "japgolly.scalajs.react.hooks.ComponentPC_SubsequentSteps$$anon$21", {
  Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$21;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F2($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx2$2) => {
        var ctx2 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC2(ctx2$2);
        var h3 = $n(initNextHook).apply__O__O(ctx2);
        var props = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var propsChildren = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren;
        var hook1 = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1;
        var hook2 = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2;
        var ctx3 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC3__O__sjs_js_Any__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3(), props, propsChildren, hook1, hook2, h3);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx3))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F4(f$2);
    return new $c_sjsr_AnonFunction1(((x$22$2) => {
      var x$22 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC2(x$22$2);
      return $n(x$22).apply2__F4__O(f)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22: 0
}, false, "japgolly.scalajs.react.hooks.ComponentPC_SubsequentSteps$$anon$22", {
  Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$22;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F2($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx3$2) => {
        var ctx3 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC3(ctx3$2);
        var h4 = $n(initNextHook).apply__O__O(ctx3);
        var props = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var propsChildren = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren;
        var hook1 = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1;
        var hook2 = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2;
        var hook3 = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$PC3__f_hook3;
        var ctx4 = new $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC4(props, propsChildren, hook1, hook2, hook3, h4);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx4))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F5(f$2);
    return new $c_sjsr_AnonFunction1(((x$23$2) => {
      var x$23 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC3(x$23$2);
      return $n(x$23).apply3__F5__O(f)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23: 0
}, false, "japgolly.scalajs.react.hooks.ComponentPC_SubsequentSteps$$anon$23", {
  Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentPC\uff3fSubsequentSteps$$anon$23;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx1$2) => {
        var ctx1 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P1(ctx1$2);
        var h2 = $n(initNextHook).apply__O__O(ctx1);
        var props = $n(ctx1).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx1).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var ctx2 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P2__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P2(), props, hook1, h2);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx2))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F2(f$2);
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P1(x$1$2);
      var this$2 = $n(x$1);
      return $n(f).apply__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$1", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx10$2) => {
        var ctx10 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P10(ctx10$2);
        var h11 = $n(initNextHook).apply__O__O(ctx10);
        var props = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var hook4 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4;
        var hook5 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5;
        var hook6 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6;
        var hook7 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7;
        var hook8 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8;
        var hook9 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9;
        var hook10 = $n(ctx10).Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10;
        var ctx11 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P11__O__O__O__O__O__O__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P11(), props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10, h11);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx11))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F11(f$2);
    return new $c_sjsr_AnonFunction1(((x$10$2) => {
      var x$10 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P10(x$10$2);
      var this$2 = $n(x$10);
      return $n(f).apply__O__O__O__O__O__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$10", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx11$2) => {
        var ctx11 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P11(ctx11$2);
        var h12 = $n(initNextHook).apply__O__O(ctx11);
        var props = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var hook4 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4;
        var hook5 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5;
        var hook6 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6;
        var hook7 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7;
        var hook8 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8;
        var hook9 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9;
        var hook10 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10;
        var hook11 = $n(ctx11).Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11;
        var ctx12 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P12__O__O__O__O__O__O__O__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P12(), props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10, hook11, h12);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx12))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F12(f$2);
    return new $c_sjsr_AnonFunction1(((x$11$2) => {
      var x$11 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P11(x$11$2);
      var this$2 = $n(x$11);
      return $n(f).apply__O__O__O__O__O__O__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$11", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx12$2) => {
        var ctx12 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P12(ctx12$2);
        var h13 = $n(initNextHook).apply__O__O(ctx12);
        var props = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var hook4 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4;
        var hook5 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5;
        var hook6 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6;
        var hook7 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7;
        var hook8 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8;
        var hook9 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9;
        var hook10 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10;
        var hook11 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11;
        var hook12 = $n(ctx12).Ljapgolly_scalajs_react_hooks_HookCtx$P12__f_hook12;
        var ctx13 = new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P13(props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10, hook11, hook12, h13);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx13))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F13(f$2);
    return new $c_sjsr_AnonFunction1(((x$12$2) => {
      var x$12 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P12(x$12$2);
      var this$2 = $n(x$12);
      return $n(f).apply__O__O__O__O__O__O__O__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P12__f_hook12)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$12", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx2$2) => {
        var ctx2 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P2(ctx2$2);
        var h3 = $n(initNextHook).apply__O__O(ctx2);
        var props = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx2).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var ctx3 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P3__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P3(), props, hook1, hook2, h3);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx3))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F3(f$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P2(x$2$2);
      var this$2 = $n(x$2);
      return $n(f).apply__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$2", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx3$2) => {
        var ctx3 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P3(ctx3$2);
        var h4 = $n(initNextHook).apply__O__O(ctx3);
        var props = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx3).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var ctx4 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P4__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P4(), props, hook1, hook2, hook3, h4);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx4))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F4(f$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P3(x$3$2);
      var this$2 = $n(x$3);
      return $n(f).apply__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$3", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx4$2) => {
        var ctx4 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P4(ctx4$2);
        var h5 = $n(initNextHook).apply__O__O(ctx4);
        var props = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var hook4 = $n(ctx4).Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4;
        var ctx5 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P5__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P5(), props, hook1, hook2, hook3, hook4, h5);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx5))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F5(f$2);
    return new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P4(x$4$2);
      var this$2 = $n(x$4);
      return $n(f).apply__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$4", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx5$2) => {
        var ctx5 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P5(ctx5$2);
        var h6 = $n(initNextHook).apply__O__O(ctx5);
        var props = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var hook4 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4;
        var hook5 = $n(ctx5).Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5;
        var ctx6 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P6__O__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P6(), props, hook1, hook2, hook3, hook4, hook5, h6);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx6))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F6(f$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P5(x$5$2);
      var this$2 = $n(x$5);
      return $n(f).apply__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$5", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx6$2) => {
        var ctx6 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P6(ctx6$2);
        var h7 = $n(initNextHook).apply__O__O(ctx6);
        var props = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var hook4 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4;
        var hook5 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5;
        var hook6 = $n(ctx6).Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6;
        var ctx7 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P7__O__O__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P7(), props, hook1, hook2, hook3, hook4, hook5, hook6, h7);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx7))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F7(f$2);
    return new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P6(x$6$2);
      var this$2 = $n(x$6);
      return $n(f).apply__O__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$6", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx7$2) => {
        var ctx7 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P7(ctx7$2);
        var h8 = $n(initNextHook).apply__O__O(ctx7);
        var props = $n(ctx7).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx7).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx7).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx7).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var hook4 = $n(ctx7).Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4;
        var hook5 = $n(ctx7).Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5;
        var hook6 = $n(ctx7).Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6;
        var hook7 = $n(ctx7).Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7;
        var ctx8 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P8__O__O__O__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P8(), props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, h8);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx8))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F8(f$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P7(x$7$2);
      var this$2 = $n(x$7);
      return $n(f).apply__O__O__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$7", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx8$2) => {
        var ctx8 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P8(ctx8$2);
        var h9 = $n(initNextHook).apply__O__O(ctx8);
        var props = $n(ctx8).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx8).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx8).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx8).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var hook4 = $n(ctx8).Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4;
        var hook5 = $n(ctx8).Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5;
        var hook6 = $n(ctx8).Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6;
        var hook7 = $n(ctx8).Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7;
        var hook8 = $n(ctx8).Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8;
        var ctx9 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P9__O__O__O__O__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P9(), props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, h9);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx9))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F9(f$2);
    return new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P8(x$8$2);
      var this$2 = $n(x$8);
      return $n(f).apply__O__O__O__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$8", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9.prototype = $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9.prototype;
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((renderPrev$2, initNextHook$2) => {
    var renderPrev = $as_F1(renderPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var renderNext = new $c_sjsr_AnonFunction1(((render$2) => {
      var render = $as_F1(render$2);
      return $as_F1($n(renderPrev).apply__O__O(new $c_sjsr_AnonFunction1(((ctx9$2) => {
        var ctx9 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P9(ctx9$2);
        var h10 = $n(initNextHook).apply__O__O(ctx9);
        var props = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props;
        var hook1 = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1;
        var hook2 = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2;
        var hook3 = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3;
        var hook4 = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4;
        var hook5 = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5;
        var hook6 = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6;
        var hook7 = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7;
        var hook8 = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8;
        var hook9 = $n(ctx9).Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9;
        var ctx10 = $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P10__O__O__O__O__O__O__O__O__O__O__O__(new $c_Ljapgolly_scalajs_react_hooks_HookCtx$P10(), props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, h10);
        return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(render).apply__O__O(ctx10))
      }))))
    }));
    return new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F10(f$2);
    return new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$P9(x$9$2);
      var this$2 = $n(x$9);
      return $n(f).apply__O__O__O__O__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9: 0
}, false, "japgolly.scalajs.react.hooks.ComponentP_SubsequentSteps$$anon$9", {
  Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState(value, rev) {
  this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_value = null;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_rev = 0;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_skipTest = false;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_asTuple = null;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_value = value;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_rev = rev;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_skipTest = true;
  this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_asTuple = $ct_T2__O__O__(new $c_T2(), value, rev)
}
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype = $c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype;
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype.productPrefix__T = (function() {
  return "ReusableDepState"
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype.productArity__I = (function() {
  return 2
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_value;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_rev;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ReusableDepState");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_value;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_rev;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState)) {
    var ReusableDepState$1 = $as_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState(x$1);
    if ((this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_rev === $n(ReusableDepState$1).Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_rev)) {
      var x = this.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_value;
      var y = $n(ReusableDepState$1).Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState__f_value;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.CustomHook$ReusableDepState"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.CustomHook$ReusableDepState;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState: 0
}, false, "japgolly.scalajs.react.hooks.CustomHook$ReusableDepState", {
  Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_CustomHook$ReusableDepState;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((buildPrev$2, initNextHook$2) => {
    var buildPrev = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(buildPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var buildNext = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40$$anon$41(this, buildPrev, initNextHook);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(buildNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F2(f$2);
    return new $c_sjsr_AnonFunction1(((x$40$2) => {
      var x$40 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I1(x$40$2);
      var this$2 = $n(x$40);
      return $n(f).apply__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$40", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$40;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((buildPrev$2, initNextHook$2) => {
    var buildPrev = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(buildPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var buildNext = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42$$anon$43(this, buildPrev, initNextHook);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(buildNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F3(f$2);
    return new $c_sjsr_AnonFunction1(((x$41$2) => {
      var x$41 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I2(x$41$2);
      var this$2 = $n(x$41);
      return $n(f).apply__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$42", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$42;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((buildPrev$2, initNextHook$2) => {
    var buildPrev = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(buildPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var buildNext = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44$$anon$45(this, buildPrev, initNextHook);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(buildNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F4(f$2);
    return new $c_sjsr_AnonFunction1(((x$42$2) => {
      var x$42 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I3(x$42$2);
      var this$2 = $n(x$42);
      return $n(f).apply__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$44", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$44;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((buildPrev$2, initNextHook$2) => {
    var buildPrev = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(buildPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var buildNext = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46$$anon$47(this, buildPrev, initNextHook);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(buildNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F5(f$2);
    return new $c_sjsr_AnonFunction1(((x$43$2) => {
      var x$43 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I4(x$43$2);
      var this$2 = $n(x$43);
      return $n(f).apply__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$46", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$46;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((buildPrev$2, initNextHook$2) => {
    var buildPrev = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(buildPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var buildNext = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48$$anon$49(this, buildPrev, initNextHook);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(buildNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F6(f$2);
    return new $c_sjsr_AnonFunction1(((x$44$2) => {
      var x$44 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I5(x$44$2);
      var this$2 = $n(x$44);
      return $n(f).apply__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$48", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$48;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50(outer) {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50.prototype = $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50.prototype;
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50.prototype.next__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((buildPrev$2, initNextHook$2) => {
    var buildPrev = $as_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$BuildFn(buildPrev$2);
    var initNextHook = $as_F1(initNextHook$2);
    var buildNext = new $c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50$$anon$51(this, buildPrev, initNextHook);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook$Builder$Subsequent(buildNext)
  }))
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50.prototype.squash__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F7(f$2);
    return new $c_sjsr_AnonFunction1(((x$45$2) => {
      var x$45 = $as_Ljapgolly_scalajs_react_hooks_HookCtx$I6(x$45$2);
      var this$2 = $n(x$45);
      return $n(f).apply__O__O__O__O__O__O__O__O(this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5, this$2.Ljapgolly_scalajs_react_hooks_HookCtx$I6__f_hook6)
    }))
  }))
});
var $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50: 0
}, false, "japgolly.scalajs.react.hooks.Custom_SubsequentSteps$$anon$50", {
  Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_CustomHook$Builder$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$SubsequentStep: 1,
  Ljapgolly_scalajs_react_hooks_Api$AbstractStep: 1
});
$c_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Custom\uff3fSubsequentSteps$$anon$50;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I3__O__O__O__O__($thiz, input, hook1, hook2, hook3) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3 = hook3;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I2__O__O__O__($thiz, input, hook1, hook2);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$I3() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I3.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$I2();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I3.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$I3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$I3.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I3.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I3.prototype.toString__T = (function() {
  return (((((((("HookCtx.withInput(\n  input = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$I3(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$I3) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$I3"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$I3)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I3(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$I3;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$I3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$I3: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$I3", {
  Ljapgolly_scalajs_react_hooks_HookCtx$I3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I3.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$I3;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P3__O__O__O__O__($thiz, props, hook1, hook2, hook3) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = hook3;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P2__O__O__O__($thiz, props, hook1, hook2);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P3() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P3.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P2();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P3.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P3.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P3.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P3.prototype.toString__T = (function() {
  return (((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P3(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P3) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P3"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P3)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P3(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P3;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P3", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P3.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P3;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC2__O__sjs_js_Any__O__O__($thiz, props, propsChildren, hook1, hook2) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2 = hook2;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC1__O__sjs_js_Any__O__($thiz, props, propsChildren, hook1);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$PC1();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$PC2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$PC2.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2.prototype.toString__T = (function() {
  return (((((((("HookCtx.withChildren(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  propsChildren = ") + new $c_Ljapgolly_scalajs_react_PropsChildren(this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren)) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2) + ")")
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2.prototype.apply2__F4__O = (function(f) {
  return $n(f).apply__O__O__O__O__O(this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, new $c_Ljapgolly_scalajs_react_PropsChildren(this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren), this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1, this.Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2)
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC2(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$PC2"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$PC2)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC2(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$PC2;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$PC2: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$PC2", {
  Ljapgolly_scalajs_react_hooks_HookCtx$PC2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC0: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC2.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(raw, originalDispatch) {
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw = null;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_originalDispatch = null;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw = raw;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_originalDispatch = originalDispatch
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.dispatch__O__Ljapgolly_scalajs_react_Reusable = (function(a) {
  var $$x1 = $n(this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_originalDispatch);
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  $n(this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
  var a$1 = new $c_sjsr_AnonFunction0((() => {
    (0, this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[1])(a)
  }));
  return $n($$x1).withValue__O__Ljapgolly_scalajs_react_Reusable(new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$1))))
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.productPrefix__T = (function() {
  return "UseReducer"
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.productArity__I = (function() {
  return 2
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_originalDispatch;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer)) {
    var UseReducer$1 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$1);
    var x = this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw;
    var y = $n(UseReducer$1).Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_originalDispatch;
      var x$2$1 = $n(UseReducer$1).Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_originalDispatch;
      if ((x$2 === null)) {
        return (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$2$1)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.Hooks$UseReducer"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.Hooks$UseReducer;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseReducer: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseReducer", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseReducer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer;
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_DefaultEffects$() {
  this.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync = null;
  this.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async = null;
  $n_Ljapgolly_scalajs_react_util_DefaultEffects$ = this;
  this.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async = $m_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$();
  this.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()
}
$c_Ljapgolly_scalajs_react_util_DefaultEffects$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_DefaultEffects$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_DefaultEffects$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_DefaultEffects$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_DefaultEffects$.prototype = $c_Ljapgolly_scalajs_react_util_DefaultEffects$.prototype;
var $d_Ljapgolly_scalajs_react_util_DefaultEffects$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_DefaultEffects$: 0
}, false, "japgolly.scalajs.react.util.DefaultEffects$", {
  Ljapgolly_scalajs_react_util_DefaultEffects$: 1,
  O: 1,
  Ljapgolly_scalajs_react_util_DefaultEffectsLowPri: 1,
  Ljapgolly_scalajs_react_util_DefaultEffectsApiLowPri: 1,
  Ljapgolly_scalajs_react_util_DefaultEffectsApi: 1
});
$c_Ljapgolly_scalajs_react_util_DefaultEffects$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_DefaultEffects$;
var $n_Ljapgolly_scalajs_react_util_DefaultEffects$;
function $m_Ljapgolly_scalajs_react_util_DefaultEffects$() {
  if ((!$n_Ljapgolly_scalajs_react_util_DefaultEffects$)) {
    $n_Ljapgolly_scalajs_react_util_DefaultEffects$ = new $c_Ljapgolly_scalajs_react_util_DefaultEffects$()
  };
  return $n_Ljapgolly_scalajs_react_util_DefaultEffects$
}
function $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O($thiz, ga, g) {
  return (($thiz === g) ? $n(ga).apply__O() : $thiz.delay__F0__O(new $c_sjsr_AnonFunction0((() => $n(g).runSync__F0__O(ga)))))
}
function $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSyncFn1__F1__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__F1($thiz, f, g) {
  return (($thiz === g) ? f : new $c_sjsr_AnonFunction1(((a$2) => $thiz.delay__F0__O(new $c_sjsr_AnonFunction0((() => $n(g).runSync__F0__O(new $c_sjsr_AnonFunction0((() => $n(f).apply__O__O(a$2))))))))))
}
function $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatch__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, f, g) {
  return (($thiz === g) ? $n(f).apply__O() : $thiz.delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    $n(g).dispatch__O__V($n(f).apply__O())
  }))))
}
function $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatchFn1__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($thiz, f, g) {
  return (($thiz === g) ? f : new $c_sjsr_AnonFunction1(((a$2) => $thiz.delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    $n(g).dispatch__O__V($n(f).apply__O__O(a$2))
  }))))))
}
function $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatchFn3__F3__Ljapgolly_scalajs_react_util_Effect$Dispatch__F3($thiz, f, g) {
  return (($thiz === g) ? f : new $c_sjsr_AnonFunction3(((a$2, b$2, c$2) => $thiz.delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    $n(g).dispatch__O__V($n(f).apply__O__O__O__O(a$2, b$2, c$2))
  }))))))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype = $c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype;
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.handleError__F0__F1__F0 = (function(fa, f) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackOption$().handleError$extension__F0__F1__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackOption($n(fa).apply__O())).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr, f)
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.dispatch__F0__V = (function(fa) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var this$ = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(fa);
  $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.dispatchFn__F0__sjs_js_Function0 = (function(fa) {
  return (() => {
    $m_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$().japgolly$scalajs$react$util$EffectCallback$callbackOption$$$anonfun$dispatchFn$1__F0__V(fa)
  })
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.dispatch__O__V = (function(fa) {
  this.dispatch__F0__V($n($as_Ljapgolly_scalajs_react_callback_CallbackOption(fa)).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr)
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.finallyRun__F0__F0__O = (function(fa, runFinally) {
  return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().finallyRun$extension__F0__F0__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackOption($n(fa).apply__O())).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr, $n($as_Ljapgolly_scalajs_react_callback_CallbackOption($n(runFinally).apply__O())).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.handleError__F0__F1__O = (function(fa, f) {
  return new $c_Ljapgolly_scalajs_react_callback_CallbackOption(this.handleError__F0__F1__F0(fa, f))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackOption(fa)).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(fa$1, f))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackOption(fa)).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0(fa$1, f, null))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.pure__O__O = (function(a) {
  return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().pure__O__F0(a))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.delay__F0__O = (function(a) {
  return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().delay__F0__F0(a))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.japgolly$scalajs$react$util$EffectCallback$callbackOption$$$anonfun$dispatchFn$1__F0__V = (function(fa$1) {
  $n($n($as_Ljapgolly_scalajs_react_callback_CallbackOption($n(fa$1).apply__O())).Ljapgolly_scalajs_react_callback_CallbackOption__f_underlyingRepr).apply__O()
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.chain__O__O__O = (function(fa, fb) {
  return $f_Ljapgolly_scalajs_react_util_Monad__chain__O__O__O(this, fa, fb)
});
var $d_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$: 0
}, false, "japgolly.scalajs.react.util.EffectCallback$callbackOption$", {
  Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$: 1,
  O: 1,
  Ljapgolly_scalajs_react_util_Effect$Dispatch: 1,
  Ljapgolly_scalajs_react_util_Effect: 1,
  Ljapgolly_scalajs_react_util_Monad: 1
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$;
var $n_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$;
function $m_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$() {
  if ((!$n_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$)) {
    $n_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$ = new $c_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$()
  };
  return $n_Ljapgolly_scalajs_react_util_EffectCallback$callbackOption$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_EffectFallbacks3() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_EffectFallbacks3.prototype = new $h_Ljapgolly_scalajs_react_util_EffectFallbacks4();
$c_Ljapgolly_scalajs_react_util_EffectFallbacks3.prototype.constructor = $c_Ljapgolly_scalajs_react_util_EffectFallbacks3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_EffectFallbacks3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_EffectFallbacks3.prototype = $c_Ljapgolly_scalajs_react_util_EffectFallbacks3.prototype;
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__borderCollapse$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_borderCollapse$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_borderCollapse$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__boxSizing$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_boxSizing$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_boxSizing$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__color$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_color$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_color$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$color$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__cursor$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_cursor$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_cursor$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__display$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_display$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_display$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$display$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__overflowWrap$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_overflowWrap$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_overflowWrap$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__verticalAlign$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_verticalAlign$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_verticalAlign$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__position$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_position$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_position$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$position$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__fontSize$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontSize$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontSize$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__fontWeight$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontWeight$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontWeight$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__textDecoration$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textDecoration$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textDecoration$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__textOverflow$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textOverflow$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textOverflow$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__visibility$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_visibility$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_visibility$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__whiteSpace$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_whiteSpace$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_whiteSpace$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__alignSelf$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignSelf$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignSelf$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__flexWrap$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexWrap$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexWrap$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__alignItems$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignItems$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignItems$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__justifyContent$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_justifyContent$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_justifyContent$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__flexDirection$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexDirection$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexDirection$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__wordBreak$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_wordBreak$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_wordBreak$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$($thiz)
  }
}
function $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__target$lzycompute$1__V($thiz) {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_target$module === null)) {
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_target$module = new $c_Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$($thiz)
  }
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$() {
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_borderCollapse$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_boxSizing$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_color$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_cursor$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_display$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_overflowWrap$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_verticalAlign$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_position$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontSize$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontWeight$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textDecoration$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textOverflow$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_visibility$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_whiteSpace$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignSelf$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexWrap$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignItems$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_justifyContent$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexDirection$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_wordBreak$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_target$module = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_value = null;
  $n_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$ = this;
  $f_Ljapgolly_scalajs_react_vdom_HtmlAttrs__$init$__V(this)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype;
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.borderCollapse__Ljapgolly_scalajs_react_vdom_HtmlStyles$borderCollapse$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_borderCollapse$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__borderCollapse$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_borderCollapse$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.boxSizing__Ljapgolly_scalajs_react_vdom_HtmlStyles$boxSizing$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_boxSizing$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__boxSizing$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_boxSizing$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_color$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__color$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_color$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.cursor__Ljapgolly_scalajs_react_vdom_HtmlStyles$cursor$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_cursor$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__cursor$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_cursor$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_display$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__display$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_display$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.overflowWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$overflowWrap$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_overflowWrap$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__overflowWrap$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_overflowWrap$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.verticalAlign__Ljapgolly_scalajs_react_vdom_HtmlStyles$verticalAlign$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_verticalAlign$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__verticalAlign$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_verticalAlign$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_position$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__position$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_position$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.fontSize__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontSize$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontSize$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__fontSize$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontSize$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.fontWeight__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontWeight$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__fontWeight$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_fontWeight$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.textDecoration__Ljapgolly_scalajs_react_vdom_HtmlStyles$textDecoration$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textDecoration$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__textDecoration$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textDecoration$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.textOverflow__Ljapgolly_scalajs_react_vdom_HtmlStyles$textOverflow$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textOverflow$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__textOverflow$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_textOverflow$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.visibility__Ljapgolly_scalajs_react_vdom_HtmlStyles$visibility$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_visibility$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__visibility$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_visibility$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.whiteSpace__Ljapgolly_scalajs_react_vdom_HtmlStyles$whiteSpace$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_whiteSpace$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__whiteSpace$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_whiteSpace$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.alignSelf__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignSelf$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignSelf$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__alignSelf$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignSelf$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.flexWrap__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexWrap$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexWrap$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__flexWrap$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexWrap$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignItems$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__alignItems$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_alignItems$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.justifyContent__Ljapgolly_scalajs_react_vdom_HtmlStyles$justifyContent$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_justifyContent$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__justifyContent$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_justifyContent$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexDirection$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__flexDirection$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_flexDirection$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.wordBreak__Ljapgolly_scalajs_react_vdom_HtmlStyles$wordBreak$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_wordBreak$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__wordBreak$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_wordBreak$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.target__Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$ = (function() {
  if (($m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_target$module === null)) {
    $p_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__target$lzycompute$1__V(this)
  };
  return $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$().Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_target$module
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$key_$eq__Ljapgolly_scalajs_react_vdom_Attr$Key$__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_key = x$1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$onChange_$eq__Ljapgolly_scalajs_react_vdom_Attr$Event__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange = x$1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$onClick_$eq__Ljapgolly_scalajs_react_vdom_Attr$Event__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick = x$1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$onClickCapture_$eq__Ljapgolly_scalajs_react_vdom_Attr$Event__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$src_$eq__Ljapgolly_scalajs_react_vdom_Attr__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src = x$1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$title_$eq__Ljapgolly_scalajs_react_vdom_Attr__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title = x$1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$type_$eq__Ljapgolly_scalajs_react_vdom_Attr__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_type = x$1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.japgolly$scalajs$react$vdom$HtmlAttrs$_setter_$value_$eq__Ljapgolly_scalajs_react_vdom_Attr__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_value = x$1
});
var $d_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlAttrAndStyles$", {
  Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles: 1,
  Ljapgolly_scalajs_react_vdom_HtmlAttrs: 1,
  Ljapgolly_scalajs_react_vdom_HtmlStyles: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$;
var $n_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$;
function $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$)) {
    $n_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$ = new $c_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf(name) {
  this.Ljapgolly_scalajs_react_vdom_HtmlTagOf__f_name = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlTagOf__f_name = name
}
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlTagOf() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype;
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype.productPrefix__T = (function() {
  return "HtmlTagOf"
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype.productElement__I__O = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().productElement$extension__T__I__O(this.Ljapgolly_scalajs_react_vdom_HtmlTagOf__f_name, x$1)
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype.productIterator__sc_Iterator = (function() {
  return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().productIterator$extension__T__sc_Iterator(this.Ljapgolly_scalajs_react_vdom_HtmlTagOf__f_name)
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype.hashCode__I = (function() {
  var this$ = this.Ljapgolly_scalajs_react_vdom_HtmlTagOf__f_name;
  return $f_T__hashCode__I($n(this$))
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype.equals__O__Z = (function(x$1) {
  return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().equals$extension__T__O__Z(this.Ljapgolly_scalajs_react_vdom_HtmlTagOf__f_name, x$1)
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().toString$extension__T__T(this.Ljapgolly_scalajs_react_vdom_HtmlTagOf__f_name)
});
function $as_Ljapgolly_scalajs_react_vdom_HtmlTagOf(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_vdom_HtmlTagOf) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.vdom.HtmlTagOf"))
}
function $isArrayOf_Ljapgolly_scalajs_react_vdom_HtmlTagOf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_vdom_HtmlTagOf)))
}
function $asArrayOf_Ljapgolly_scalajs_react_vdom_HtmlTagOf(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_vdom_HtmlTagOf(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.vdom.HtmlTagOf;", depth))
}
var $d_Ljapgolly_scalajs_react_vdom_HtmlTagOf = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlTagOf: 0
}, false, "japgolly.scalajs.react.vdom.HtmlTagOf", {
  Ljapgolly_scalajs_react_vdom_HtmlTagOf: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTagOf.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlTagOf;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$.prototype = $c_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$: 0
}, false, "japgolly.scalajs.react.vdom.SvgAttrAndStyles$", {
  Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles: 1,
  Ljapgolly_scalajs_react_vdom_SvgAttrs: 1,
  Ljapgolly_scalajs_react_vdom_SvgStyles: 1
});
$c_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$;
var $n_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$;
function $m_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$)) {
    $n_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$ = new $c_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$
}
function $p_Ljapgolly_scalajs_react_vdom_TagOf__rawElement$lzycompute__Ljapgolly_scalajs_react_facade_React$Element($thiz) {
  if ((!$thiz.Ljapgolly_scalajs_react_vdom_TagOf__f_bitmap$0)) {
    var b = new $c_Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement();
    var arr = [];
    var current = $thiz.Ljapgolly_scalajs_react_vdom_TagOf__f_modifiers;
    while (true) {
      var x = current;
      var x$2 = $m_s_package$().s_package$__f_Nil;
      if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
        arr.push($as_sci_Seq($n(current).head__O()));
        current = $as_sci_List($n(current).tail__O())
      } else {
        break
      }
    };
    var j = $uI(arr.length);
    while ((j > 0)) {
      j = (((-1) + j) | 0);
      $n($as_sc_IterableOnceOps(arr[j])).foreach__F1__V(new $c_sjsr_AnonFunction1(((b) => ((x$1$2) => {
        var x$1 = $as_Ljapgolly_scalajs_react_vdom_TagMod(x$1$2);
        $n(x$1).applyTo__Ljapgolly_scalajs_react_vdom_VdomBuilder__V(b)
      }))(b)))
    };
    $thiz.Ljapgolly_scalajs_react_vdom_TagOf__f_rawElement = b.render__T__Ljapgolly_scalajs_react_facade_React$Element($thiz.Ljapgolly_scalajs_react_vdom_TagOf__f_tag);
    $thiz.Ljapgolly_scalajs_react_vdom_TagOf__f_bitmap$0 = true
  };
  return $thiz.Ljapgolly_scalajs_react_vdom_TagOf__f_rawElement
}
function $ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__($thiz, tag, modifiers) {
  $thiz.Ljapgolly_scalajs_react_vdom_TagOf__f_tag = tag;
  $thiz.Ljapgolly_scalajs_react_vdom_TagOf__f_modifiers = modifiers;
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_TagOf() {
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_rawElement = null;
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_tag = null;
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_modifiers = null;
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_bitmap$0 = false
}
$c_Ljapgolly_scalajs_react_vdom_TagOf.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_TagOf.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_TagOf;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_TagOf() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_TagOf.prototype = $c_Ljapgolly_scalajs_react_vdom_TagOf.prototype;
$c_Ljapgolly_scalajs_react_vdom_TagOf.prototype.withRef__s_Option__Ljapgolly_scalajs_react_vdom_TagOf = (function(ref) {
  if ((ref instanceof $c_s_Some)) {
    var x2 = $as_s_Some(ref);
    var r = $as_Ljapgolly_scalajs_react_Ref$SetF($n(x2).s_Some__f_value);
    var array = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod($m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_direct, "ref", $n(r).rawSetFn__sjs_js_Function1())];
    return this.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var x = $m_s_None$();
    if ((x === ref)) {
      return this
    } else {
      throw new $c_s_MatchError(ref)
    }
  }
});
$c_Ljapgolly_scalajs_react_vdom_TagOf.prototype.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf = (function(xs) {
  var this$1 = $n(this.Ljapgolly_scalajs_react_vdom_TagOf__f_modifiers);
  var x$1 = new $c_sci_$colon$colon(xs, this$1);
  var x$2 = this.Ljapgolly_scalajs_react_vdom_TagOf__f_tag;
  return $ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(new $c_Ljapgolly_scalajs_react_vdom_TagOf(), x$2, x$1)
});
$c_Ljapgolly_scalajs_react_vdom_TagOf.prototype.rawElement__Ljapgolly_scalajs_react_facade_React$Element = (function() {
  return ((!this.Ljapgolly_scalajs_react_vdom_TagOf__f_bitmap$0) ? $p_Ljapgolly_scalajs_react_vdom_TagOf__rawElement$lzycompute__Ljapgolly_scalajs_react_facade_React$Element(this) : this.Ljapgolly_scalajs_react_vdom_TagOf__f_rawElement)
});
$c_Ljapgolly_scalajs_react_vdom_TagOf.prototype.applyTo__Ljapgolly_scalajs_react_vdom_VdomBuilder__V = (function(b) {
  var $$x1 = $n($n(b).Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_appendChild);
  var a = this.rawElement__Ljapgolly_scalajs_react_facade_React$Element();
  $n($$x1).apply__O__O(a)
});
$c_Ljapgolly_scalajs_react_vdom_TagOf.prototype.toString__T = (function() {
  return ($n(this.Ljapgolly_scalajs_react_vdom_TagOf__f_modifiers).isEmpty__Z() ? (("<" + this.Ljapgolly_scalajs_react_vdom_TagOf__f_tag) + " />") : (((("<" + this.Ljapgolly_scalajs_react_vdom_TagOf__f_tag) + ">\u2026</") + this.Ljapgolly_scalajs_react_vdom_TagOf__f_tag) + ">"))
});
$c_Ljapgolly_scalajs_react_vdom_TagOf.prototype.rawNode__sjs_js_$bar = (function() {
  return $f_Ljapgolly_scalajs_react_vdom_VdomElement__rawNode__sjs_js_$bar(this)
});
function $as_Ljapgolly_scalajs_react_vdom_TagOf(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_vdom_TagOf) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.vdom.TagOf"))
}
function $isArrayOf_Ljapgolly_scalajs_react_vdom_TagOf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_vdom_TagOf)))
}
function $asArrayOf_Ljapgolly_scalajs_react_vdom_TagOf(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_vdom_TagOf(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.vdom.TagOf;", depth))
}
var $d_Ljapgolly_scalajs_react_vdom_TagOf = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_TagOf: 0
}, false, "japgolly.scalajs.react.vdom.TagOf", {
  Ljapgolly_scalajs_react_vdom_TagOf: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_VdomElement: 1,
  Ljapgolly_scalajs_react_vdom_VdomNode: 1,
  Ljapgolly_scalajs_react_vdom_TagMod: 1
});
$c_Ljapgolly_scalajs_react_vdom_TagOf.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_TagOf;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1) {
  this.Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1__f_n$1 = null;
  this.Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1__f_n$1 = n$1
}
$c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1.prototype = $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1.prototype.rawElement__Ljapgolly_scalajs_react_facade_React$Element = (function() {
  return this.Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1__f_n$1
});
$c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1.prototype.applyTo__Ljapgolly_scalajs_react_vdom_VdomBuilder__V = (function(b) {
  $n($n(b).Ljapgolly_scalajs_react_vdom_VdomBuilder$ToRawReactElement__f_appendChild).apply__O__O($f_Ljapgolly_scalajs_react_vdom_VdomElement__rawNode__sjs_js_$bar(this))
});
$c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1.prototype.rawNode__sjs_js_$bar = (function() {
  return $f_Ljapgolly_scalajs_react_vdom_VdomElement__rawNode__sjs_js_$bar(this)
});
var $d_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1: 0
}, false, "japgolly.scalajs.react.vdom.VdomElement$$anon$1", {
  Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_VdomElement: 1,
  Ljapgolly_scalajs_react_vdom_VdomNode: 1,
  Ljapgolly_scalajs_react_vdom_TagMod: 1
});
$c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1;
function $as_Ljava_io_IOException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.IOException"))
}
function $isArrayOf_Ljava_io_IOException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_IOException)))
}
function $asArrayOf_Ljava_io_IOException(obj, depth) {
  return (($isArrayOf_Ljava_io_IOException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.IOException;", depth))
}
/** @constructor */
function $c_Ljava_io_OutputStream() {
  /*<skip>*/
}
$c_Ljava_io_OutputStream.prototype = new $h_O();
$c_Ljava_io_OutputStream.prototype.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
  /*<skip>*/
}
$h_Ljava_io_OutputStream.prototype = $c_Ljava_io_OutputStream.prototype;
class $c_jl_AssertionError extends $c_jl_Error {
  constructor(detailMessage) {
    super();
    var message = ("" + detailMessage);
    if ((detailMessage instanceof $c_jl_Throwable)) {
      var x2 = $as_jl_Throwable(detailMessage);
      var cause = x2
    } else {
      var cause = null
    };
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
  };
}
var $d_jl_AssertionError = new $TypeData().initClass({
  jl_AssertionError: 0
}, false, "java.lang.AssertionError", {
  jl_AssertionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_AssertionError.prototype.$classData = $d_jl_AssertionError;
function $f_jl_Boolean__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_jl_Boolean__hashCode__I($thiz) {
  return ($thiz ? 1231 : 1237)
}
function $f_jl_Boolean__toString__T($thiz) {
  return ("" + $thiz)
}
function $f_jl_Boolean__compareTo__O__I($thiz, o) {
  var that = $as_jl_Boolean(o);
  var this$1 = $n(that);
  return (($thiz === this$1) ? 0 : ($thiz ? 1 : (-1)))
}
function $as_jl_Boolean(obj) {
  return ((((typeof obj) === "boolean") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Boolean"))
}
function $isArrayOf_jl_Boolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Boolean)))
}
function $asArrayOf_jl_Boolean(obj, depth) {
  return (($isArrayOf_jl_Boolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Boolean;", depth))
}
var $d_jl_Boolean = new $TypeData().initClass({
  jl_Boolean: 0
}, false, "java.lang.Boolean", {
  jl_Boolean: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => ((typeof x) === "boolean")));
function $f_jl_Character__hashCode__I($thiz) {
  return $thiz
}
function $f_jl_Character__equals__O__Z($thiz, that) {
  if ((that instanceof $Char)) {
    var this$1 = $uC($n($as_jl_Character(that)));
    return ($thiz === this$1)
  } else {
    return false
  }
}
function $f_jl_Character__toString__T($thiz) {
  return $as_T(String.fromCharCode($thiz))
}
function $f_jl_Character__compareTo__O__I($thiz, o) {
  var that = $as_jl_Character(o);
  var this$1 = $uC($n(that));
  return (($thiz - this$1) | 0)
}
function $as_jl_Character(obj) {
  return (((obj instanceof $Char) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Character"))
}
function $isArrayOf_jl_Character(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Character)))
}
function $asArrayOf_jl_Character(obj, depth) {
  return (($isArrayOf_jl_Character(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Character;", depth))
}
var $d_jl_Character = new $TypeData().initClass({
  jl_Character: 0
}, false, "java.lang.Character", {
  jl_Character: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => (x instanceof $Char)));
function $as_jl_InterruptedException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.InterruptedException"))
}
function $isArrayOf_jl_InterruptedException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_InterruptedException)))
}
function $asArrayOf_jl_InterruptedException(obj, depth) {
  return (($isArrayOf_jl_InterruptedException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.InterruptedException;", depth))
}
function $as_jl_LinkageError(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.LinkageError"))
}
function $isArrayOf_jl_LinkageError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_LinkageError)))
}
function $asArrayOf_jl_LinkageError(obj, depth) {
  return (($isArrayOf_jl_LinkageError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.LinkageError;", depth))
}
class $c_jl_ReflectiveOperationException extends $c_jl_Exception {
}
function $ct_jl_RuntimeException__jl_Throwable__($thiz, e) {
  var message = ((e === null) ? null : $n(e).toString__T());
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, e, true, true);
  return $thiz
}
function $ct_jl_RuntimeException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_RuntimeException extends $c_jl_Exception {
}
function $as_jl_RuntimeException(obj) {
  return (((obj instanceof $c_jl_RuntimeException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.RuntimeException"))
}
function $isArrayOf_jl_RuntimeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_RuntimeException)))
}
function $asArrayOf_jl_RuntimeException(obj, depth) {
  return (($isArrayOf_jl_RuntimeException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.RuntimeException;", depth))
}
var $d_jl_RuntimeException = new $TypeData().initClass({
  jl_RuntimeException: 0
}, false, "java.lang.RuntimeException", {
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_RuntimeException.prototype.$classData = $d_jl_RuntimeException;
function $ct_jl_StringBuffer__jl_StringBuilder__($thiz, builder) {
  $thiz.jl_StringBuffer__f_builder = builder;
  return $thiz
}
function $ct_jl_StringBuffer__($thiz) {
  $ct_jl_StringBuffer__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz
}
function $ct_jl_StringBuffer__T__($thiz, str) {
  $ct_jl_StringBuffer__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), str));
  return $thiz
}
function $ct_jl_StringBuffer__jl_CharSequence__($thiz, seq) {
  $ct_jl_StringBuffer__T__($thiz, $dp_toString__T($n(seq)));
  return $thiz
}
/** @constructor */
function $c_jl_StringBuffer() {
  this.jl_StringBuffer__f_builder = null
}
$c_jl_StringBuffer.prototype = new $h_O();
$c_jl_StringBuffer.prototype.constructor = $c_jl_StringBuffer;
/** @constructor */
function $h_jl_StringBuffer() {
  /*<skip>*/
}
$h_jl_StringBuffer.prototype = $c_jl_StringBuffer.prototype;
$c_jl_StringBuffer.prototype.length__I = (function() {
  return $n(this.jl_StringBuffer__f_builder).length__I()
});
$c_jl_StringBuffer.prototype.charAt__I__C = (function(index) {
  return $n(this.jl_StringBuffer__f_builder).charAt__I__C(index)
});
$c_jl_StringBuffer.prototype.append__T__jl_StringBuffer = (function(str) {
  var this$1 = $n(this.jl_StringBuffer__f_builder);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__jl_StringBuffer = (function(s) {
  var this$1 = $n(this.jl_StringBuffer__f_builder);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__I__I__jl_StringBuffer = (function(s, start, end) {
  $n(this.jl_StringBuffer__f_builder).append__jl_CharSequence__I__I__jl_StringBuilder(s, start, end);
  return this
});
$c_jl_StringBuffer.prototype.append__C__jl_StringBuffer = (function(c) {
  var this$1 = $n(this.jl_StringBuffer__f_builder);
  var str = $as_T(String.fromCharCode(c));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_jl_StringBuffer.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  var this$1 = $n(this.jl_StringBuffer__f_builder);
  return this$1.substring__I__I__T(start, end)
});
$c_jl_StringBuffer.prototype.toString__T = (function() {
  return $n(this.jl_StringBuffer__f_builder).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_jl_StringBuffer.prototype.append__C__jl_Appendable = (function(c) {
  return this.append__C__jl_StringBuffer(c)
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__jl_StringBuffer(csq, start, end)
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  return this.append__jl_CharSequence__jl_StringBuffer(csq)
});
var $d_jl_StringBuffer = new $TypeData().initClass({
  jl_StringBuffer: 0
}, false, "java.lang.StringBuffer", {
  jl_StringBuffer: 1,
  O: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringBuffer.prototype.$classData = $d_jl_StringBuffer;
function $ct_jl_StringBuilder__($thiz) {
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = "";
  return $thiz
}
function $ct_jl_StringBuilder__T__($thiz, str) {
  $ct_jl_StringBuilder__($thiz);
  if ((str === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = str;
  return $thiz
}
function $ct_jl_StringBuilder__I__($thiz, initialCapacity) {
  $ct_jl_StringBuilder__($thiz);
  if ((initialCapacity < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  return $thiz
}
/** @constructor */
function $c_jl_StringBuilder() {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = null
}
$c_jl_StringBuilder.prototype = new $h_O();
$c_jl_StringBuilder.prototype.constructor = $c_jl_StringBuilder;
/** @constructor */
function $h_jl_StringBuilder() {
  /*<skip>*/
}
$h_jl_StringBuilder.prototype = $c_jl_StringBuilder.prototype;
$c_jl_StringBuilder.prototype.append__jl_CharSequence__I__I__jl_StringBuilder = (function(s, start, end) {
  var s$1 = $dp_subSequence__I__I__jl_CharSequence($n(((s === null) ? "null" : s)), start, end);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s$1);
  return this
});
$c_jl_StringBuilder.prototype.append__AC__jl_StringBuilder = (function(str) {
  var this$1 = $m_jl_String$();
  var count = $n(str).u.length;
  var str$1 = this$1.new__AC__I__I__T(str, 0, count);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
  return this
});
$c_jl_StringBuilder.prototype.deleteCharAt__I__jl_StringBuilder = (function(index) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  if ((index < 0)) {
    var $$x1 = true
  } else {
    var this$1 = $n(oldContent);
    var $$x1 = (index >= this$1.length)
  };
  if ($$x1) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), index)
  };
  var this$2 = $n(oldContent);
  if ((index > this$2.length)) {
    $charAt(this$2, index)
  };
  if ((index < 0)) {
    $charAt(this$2, (-1))
  };
  var $$x2 = $as_T(this$2.substring(0, index));
  var this$3 = $n(oldContent);
  var beginIndex = ((1 + index) | 0);
  if (((beginIndex < 0) || (beginIndex > this$3.length))) {
    $charAt(this$3, beginIndex)
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + $$x2) + $as_T(this$3.substring(beginIndex)));
  return this
});
$c_jl_StringBuilder.prototype.replace__I__I__T__jl_StringBuilder = (function(start, end, str) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var this$1 = $n(oldContent);
  var length = this$1.length;
  if ((((start < 0) || (start > length)) || (start > end))) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), start)
  };
  var this$2 = $n(oldContent);
  if ((start > this$2.length)) {
    $charAt(this$2, start)
  };
  if ((start < 0)) {
    $charAt(this$2, (-1))
  };
  var firstPart = (("" + $as_T(this$2.substring(0, start))) + str);
  if ((end >= length)) {
    var $$x1 = firstPart
  } else {
    var this$3 = $n(oldContent);
    if (((end < 0) || (end > this$3.length))) {
      $charAt(this$3, end)
    };
    var $$x1 = (firstPart + $as_T(this$3.substring(end)))
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = $$x1;
  return this
});
$c_jl_StringBuilder.prototype.insert__I__T__jl_StringBuilder = (function(offset, str) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  if ((offset < 0)) {
    var $$x1 = true
  } else {
    var this$1 = $n(oldContent);
    var $$x1 = (offset > this$1.length)
  };
  if ($$x1) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), offset)
  };
  var this$2 = $n(oldContent);
  if ((offset > this$2.length)) {
    $charAt(this$2, offset)
  };
  if ((offset < 0)) {
    $charAt(this$2, (-1))
  };
  var $$x2 = $as_T(this$2.substring(0, offset));
  var this$3 = $n(oldContent);
  if (((offset < 0) || (offset > this$3.length))) {
    $charAt(this$3, offset)
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = ((("" + $$x2) + str) + $as_T(this$3.substring(offset)));
  return this
});
$c_jl_StringBuilder.prototype.reverse__jl_StringBuilder = (function() {
  var original = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var result = "";
  var this$1 = $n(original);
  var i = (((-1) + this$1.length) | 0);
  while ((i > 0)) {
    var this$2 = $n(original);
    var index = i;
    var c = $charAt(this$2, index);
    if (((64512 & c) === 56320)) {
      var this$4 = $n(original);
      var index$1 = (((-1) + i) | 0);
      var c2 = $charAt(this$4, index$1);
      if (((64512 & c2) === 55296)) {
        result = ((("" + result) + $as_T(String.fromCharCode(c2))) + $as_T(String.fromCharCode(c)));
        i = (((-2) + i) | 0)
      } else {
        result = (("" + result) + $as_T(String.fromCharCode(c)));
        i = (((-1) + i) | 0)
      }
    } else {
      result = (("" + result) + $as_T(String.fromCharCode(c)));
      i = (((-1) + i) | 0)
    }
  };
  if ((i === 0)) {
    var $$x1 = result;
    var this$10 = $n(original);
    var this$11 = $charAt(this$10, 0);
    result = (("" + $$x1) + $as_T(String.fromCharCode(this$11)))
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = result;
  return this
});
$c_jl_StringBuilder.prototype.toString__T = (function() {
  return this.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_jl_StringBuilder.prototype.length__I = (function() {
  var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  return this$1.length
});
$c_jl_StringBuilder.prototype.setLength__I__V = (function(newLength) {
  if ((newLength < 0)) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), newLength)
  };
  var newContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var this$1 = $n(newContent);
  var additional = ((newLength - this$1.length) | 0);
  if ((additional < 0)) {
    var this$2 = $n(newContent);
    if ((newLength > this$2.length)) {
      $charAt(this$2, newLength)
    };
    if ((newLength < 0)) {
      $charAt(this$2, (-1))
    };
    newContent = $as_T(this$2.substring(0, newLength))
  } else {
    var i = 0;
    while ((i !== additional)) {
      newContent = (newContent + "\u0000");
      i = ((1 + i) | 0)
    }
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = newContent
});
$c_jl_StringBuilder.prototype.charAt__I__C = (function(index) {
  var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  return $charAt(this$1, index)
});
$c_jl_StringBuilder.prototype.getChars__I__I__AC__I__V = (function(srcBegin, srcEnd, dst, dstBegin) {
  $f_T__getChars__I__I__AC__I__V($n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content), srcBegin, srcEnd, dst, dstBegin)
});
$c_jl_StringBuilder.prototype.setCharAt__I__C__V = (function(index, ch) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  if ((index < 0)) {
    var $$x1 = true
  } else {
    var this$1 = $n(oldContent);
    var $$x1 = (index >= this$1.length)
  };
  if ($$x1) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), index)
  };
  var this$2 = $n(oldContent);
  if ((index > this$2.length)) {
    $charAt(this$2, index)
  };
  if ((index < 0)) {
    $charAt(this$2, (-1))
  };
  var $$x2 = $as_T(this$2.substring(0, index));
  var this$3 = $n(oldContent);
  var beginIndex = ((1 + index) | 0);
  if (((beginIndex < 0) || (beginIndex > this$3.length))) {
    $charAt(this$3, beginIndex)
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = ((("" + $$x2) + $bC(ch)) + $as_T(this$3.substring(beginIndex)))
});
$c_jl_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.substring__I__I__T(start, end)
});
$c_jl_StringBuilder.prototype.substring__I__I__T = (function(start, end) {
  var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  if ((start < 0)) {
    $charAt(this$1, start)
  };
  if ((end > this$1.length)) {
    $charAt(this$1, end)
  };
  if ((end < start)) {
    $charAt(this$1, (-1))
  };
  return $as_T(this$1.substring(start, end))
});
$c_jl_StringBuilder.prototype.append__C__jl_Appendable = (function(c) {
  var str = $as_T(String.fromCharCode(c));
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__jl_StringBuilder(csq, start, end)
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + csq);
  return this
});
function $as_jl_StringBuilder(obj) {
  return (((obj instanceof $c_jl_StringBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.StringBuilder"))
}
function $isArrayOf_jl_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StringBuilder)))
}
function $asArrayOf_jl_StringBuilder(obj, depth) {
  return (($isArrayOf_jl_StringBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.StringBuilder;", depth))
}
var $d_jl_StringBuilder = new $TypeData().initClass({
  jl_StringBuilder: 0
}, false, "java.lang.StringBuilder", {
  jl_StringBuilder: 1,
  O: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringBuilder.prototype.$classData = $d_jl_StringBuilder;
function $as_jl_ThreadDeath(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ThreadDeath"))
}
function $isArrayOf_jl_ThreadDeath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ThreadDeath)))
}
function $asArrayOf_jl_ThreadDeath(obj, depth) {
  return (($isArrayOf_jl_ThreadDeath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ThreadDeath;", depth))
}
class $c_jl_VirtualMachineError extends $c_jl_Error {
}
function $as_jl_VirtualMachineError(obj) {
  return (((obj instanceof $c_jl_VirtualMachineError) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.VirtualMachineError"))
}
function $isArrayOf_jl_VirtualMachineError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_VirtualMachineError)))
}
function $asArrayOf_jl_VirtualMachineError(obj, depth) {
  return (($isArrayOf_jl_VirtualMachineError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.VirtualMachineError;", depth))
}
function $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I($thiz, value) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === (-2147483648)))) {
    return 19
  } else {
    var $$x3 = $m_ju_Arrays$();
    var $$x2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows;
    var ahi = value.RTLong__f_hi;
    if ((ahi < 0)) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var $$x1 = new $c_RTLong(x__lo, x__hi)
    } else {
      var $$x1 = value
    };
    var index = $n($$x3).binarySearch__AJ__J__I($$x2, $$x1);
    return ((index < 0) ? (((-1) - index) | 0) : ((1 + index) | 0))
  }
}
function $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc) {
  var mcPrecision = $n(mc).Ljava_math_MathContext__f_precision;
  var discardedPrecision = (($thiz.precision__I() - mcPrecision) | 0);
  var mcPrecGood = (($p_Ljava_math_BigDecimal__approxPrecision__I($thiz) < mcPrecision) || (mcPrecision === 0));
  if ((!(mcPrecGood || (discardedPrecision <= 0)))) {
    if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision)
    } else {
      var $$x1 = $m_Ljava_math_Multiplication$();
      var hi = (discardedPrecision >> 31);
      var sizeOfFraction = $n($$x1).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(discardedPrecision, hi));
      var integerAndFraction = $n($thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger(sizeOfFraction);
      var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value >> 31);
      var hi$2 = (discardedPrecision >> 31);
      var lo = ((value - discardedPrecision) | 0);
      var hi$3 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      var this$5 = $n($n(integerAndFraction).get(1));
      if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
        var absBi = $n($n(integerAndFraction).get(1)).abs__Ljava_math_BigInteger();
        var compRem = $n($n(absBi).shiftLeftOneBit__Ljava_math_BigInteger()).compareTo__Ljava_math_BigInteger__I(sizeOfFraction);
        var parityBit = ($n($n(integerAndFraction).get(0)).testBit__I__Z(0) ? 1 : 0);
        var this$6 = $n($n(integerAndFraction).get(1));
        var frac = Math.imul(this$6.Ljava_math_BigInteger__f_sign, ((5 + compRem) | 0));
        var carry = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, frac, $n(mc).Ljava_math_MathContext__f_roundingMode);
        if ((carry !== 0)) {
          var $$x2 = $m_Ljava_math_BigInteger$();
          var hi$4 = (carry >> 31);
          var bi = $n($$x2).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(carry, hi$4));
          var $$x3 = $n(integerAndFraction);
          var this$8 = $n($n(integerAndFraction).get(0));
          $$x3.set(0, $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, bi))
        };
        var tempBD = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__(new $c_Ljava_math_BigDecimal(), $n(integerAndFraction).get(0));
        if ((tempBD.precision__I() > mcPrecision)) {
          $n(integerAndFraction).set(0, $n($n(integerAndFraction).get(0)).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN));
          var lo$1 = (((-1) + lo) | 0);
          var hi$5 = ((lo$1 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
          var newScale__lo = lo$1;
          var newScale__hi = hi$5
        } else {
          var newScale__lo = lo;
          var newScale__hi = hi$3
        }
      } else {
        var newScale__lo = lo;
        var newScale__hi = hi$3
      };
      $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(newScale__lo, newScale__hi));
      $thiz.Ljava_math_BigDecimal__f__precision = mcPrecision;
      $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $n(integerAndFraction).get(0))
    }
  }
}
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
    var this$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    return (!((this$1.RTLong__f_lo === (-1)) && (this$1.RTLong__f_hi === (-1))))
  } else {
    return false
  }
}
function $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal($thiz, newScale) {
  if ($p_Ljava_math_BigDecimal__isZero__Z($thiz)) {
    var $$x1 = $m_Ljava_math_BigDecimal$();
    var ahi = newScale.RTLong__f_hi;
    return $n($$x1).java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal((((ahi === 0) ? (newScale.RTLong__f_lo !== 0) : (ahi > 0)) ? newScale : $L0))
  } else {
    var ahi$1 = newScale.RTLong__f_hi;
    if ((ahi$1 >= 0)) {
      return (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64) ? $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(newScale)) : $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(newScale)))
    } else {
      var lo = newScale.RTLong__f_lo;
      var hi = newScale.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var value = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).u.length;
      var hi$2 = (value >> 31);
      if ((((hi$1 === hi$2) ? (((-2147483648) ^ lo$1) < ((-2147483648) ^ value)) : (hi$1 < hi$2)) && ((($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal__lptbLen$1__J__I($thiz, newScale)) | 0) < 64))) {
        var $$x2 = $m_Ljava_math_BigDecimal$();
        var this$5 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(((-newScale.RTLong__f_lo) | 0));
        var alo = this$5.RTLong__f_lo;
        var blo = b.RTLong__f_lo;
        var a0 = (65535 & alo);
        var a1 = ((alo >>> 16) | 0);
        var b0 = (65535 & blo);
        var b1 = ((blo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$3 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$5.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        return $n($$x2).valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$2, hi$3), 0)
      } else {
        var $$x5 = $m_Ljava_math_Multiplication$();
        var $$x4 = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
        var $$x3 = $m_Ljava_math_BigDecimal$();
        var lo$3 = newScale.RTLong__f_lo;
        var hi$4 = newScale.RTLong__f_hi;
        var lo$4 = ((-lo$3) | 0);
        var hi$5 = ((lo$3 !== 0) ? (~hi$4) : ((-hi$4) | 0));
        var value$1 = $n($$x3).java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$4, hi$5));
        var hi$6 = (value$1 >> 31);
        return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $n($$x5).multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x4, new $c_RTLong(value$1, hi$6)), 0)
      }
    }
  }
}
function $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision) {
  var t = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(discardedPrecision);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value >> 31);
  var hi$2 = (discardedPrecision >> 31);
  var lo$1 = ((value - discardedPrecision) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
  var t$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
  var lo$2 = t$1.RTLong__f_lo;
  var hi$4 = t$1.RTLong__f_hi;
  var this$4 = $m_RTLong$();
  var lo$3 = this$4.divideImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$5 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$5 = $m_RTLong$();
  var lo$4 = this$5.remainderImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$6 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((!((lo$4 === 0) && (hi$6 === 0)))) {
    var $$x1 = $m_Ljava_math_BigDecimal$();
    if ((hi$6 < 0)) {
      var lo$5 = ((-lo$4) | 0);
      var hi$7 = ((lo$4 !== 0) ? (~hi$6) : ((-hi$6) | 0));
      var this$9__lo = lo$5;
      var this$9__hi = hi$7
    } else {
      var this$9__lo = lo$4;
      var this$9__hi = hi$6
    };
    var lo$6 = this$9__lo;
    var lo$7 = (lo$6 << 1);
    var hi$8 = (((lo$6 >>> 31) | 0) | (this$9__hi << 1));
    var compRem = $n($$x1).java$math$BigDecimal$$longCompareTo__J__J__I(new $c_RTLong(lo$7, hi$8), new $c_RTLong(lo, hi));
    var frac = Math.imul(((hi$6 < 0) ? (-1) : (((hi$6 === 0) && (lo$4 === 0)) ? 0 : 1)), ((5 + compRem) | 0));
    var value$1 = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & lo$3), frac, $n(mc).Ljava_math_MathContext__f_roundingMode);
    var hi$9 = (value$1 >> 31);
    var lo$8 = ((lo$3 + value$1) | 0);
    var hi$10 = ((((-2147483648) ^ lo$8) < ((-2147483648) ^ lo$3)) ? ((1 + ((hi$5 + hi$9) | 0)) | 0) : ((hi$5 + hi$9) | 0));
    if ((hi$10 < 0)) {
      var lo$9 = ((-lo$8) | 0);
      var hi$11 = ((lo$8 !== 0) ? (~hi$10) : ((-hi$10) | 0));
      var this$16__lo = lo$9;
      var this$16__hi = hi$11
    } else {
      var this$16__lo = lo$8;
      var this$16__hi = hi$10
    };
    var a = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$16__lo, this$16__hi);
    if (($uD(Math.log10(a)) >= $n(mc).Ljava_math_MathContext__f_precision)) {
      var lo$10 = (((-1) + lo$1) | 0);
      var hi$12 = ((lo$10 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
      var this$19 = $m_RTLong$();
      var lo$11 = this$19.divideImpl__I__I__I__I__I(lo$8, hi$10, 10, 0);
      var hi$13 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var x1___1 = new $c_RTLong(lo$10, hi$12);
      var x1___2 = new $c_RTLong(lo$11, hi$13)
    } else {
      var x1___1 = new $c_RTLong(lo$1, hi$3);
      var x1___2 = new $c_RTLong(lo$8, hi$10)
    }
  } else {
    var x1___1 = new $c_RTLong(lo$1, hi$3);
    var x1___2 = new $c_RTLong(lo$3, hi$5)
  };
  var t$2 = $uJ(x1___1);
  var lo$12 = t$2.RTLong__f_lo;
  var hi$14 = t$2.RTLong__f_hi;
  var t$3 = $uJ(x1___2);
  var lo$13 = t$3.RTLong__f_lo;
  var hi$15 = t$3.RTLong__f_hi;
  var t$4 = $uJ(new $c_RTLong(lo$12, hi$14));
  var lo$14 = t$4.RTLong__f_lo;
  var hi$16 = t$4.RTLong__f_hi;
  var t$5 = $uJ(new $c_RTLong(lo$13, hi$15));
  var lo$15 = t$5.RTLong__f_lo;
  var hi$17 = t$5.RTLong__f_hi;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$14, hi$16));
  $thiz.Ljava_math_BigDecimal__f__precision = $n(mc).Ljava_math_MathContext__f_precision;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(lo$15, hi$17);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(new $c_RTLong(lo$15, hi$17));
  $thiz.Ljava_math_BigDecimal__f__intVal = null
}
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  if (((hi$3 === 0) ? (((-2147483648) ^ lo$1) > (-2147483629)) : (hi$3 > 0))) {
    throw new $c_jl_ArithmeticException("Rounding necessary")
  };
  var bigInteger = $thiz.toBigIntegerExact__Ljava_math_BigInteger();
  var this$6 = $n(bigInteger);
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$6) < bitLengthOfType)) {
    return $n(bigInteger).longValue__J()
  } else {
    throw new $c_jl_ArithmeticException("Rounding necessary")
  }
}
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.Ljava_math_BigDecimal__f__precision > 0) ? $thiz.Ljava_math_BigDecimal__f__precision : ((1 + $doubleToInt((0.3010299956639812 * (((-1) + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0))
}
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.Ljava_math_BigDecimal__f__intVal = unscaledVal;
  var this$1 = $n(unscaledVal);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1);
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $n(unscaledVal).longValue__J()
  }
}
function $p_Ljava_math_BigDecimal__powTenLen$1__I__I($thiz, diffScale$2) {
  return $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength).get(diffScale$2)
}
function $p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I($thiz, subtrahend$1, diffScale$2) {
  var a = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var b = (($n(subtrahend$1).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal__powTenLen$1__I__I($thiz, diffScale$2)) | 0);
  return ((1 + ((a > b) ? a : b)) | 0)
}
function $p_Ljava_math_BigDecimal__powTenLen$2__I__I($thiz, negDiffScale$1) {
  return $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength).get(negDiffScale$1)
}
function $p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I($thiz, subtrahend$1, negDiffScale$1) {
  var a = (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal__powTenLen$2__I__I($thiz, negDiffScale$1)) | 0);
  var b = $n(subtrahend$1).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  return ((1 + ((a > b) ? a : b)) | 0)
}
function $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal($thiz, divisor$1, diffScale$3, scale$1, roundingMode$1) {
  var scaledDividend0 = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var scaledDivisor0 = $n(divisor$1).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  if ((diffScale$3 > 0)) {
    var $$x1 = $m_Ljava_math_Multiplication$();
    var hi = (diffScale$3 >> 31);
    var _2 = $n($$x1).multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger(scaledDivisor0, new $c_RTLong(diffScale$3, hi));
    var x1___1 = scaledDividend0;
    var x1___2 = _2
  } else if ((diffScale$3 < 0)) {
    var $$x2 = $m_Ljava_math_Multiplication$();
    var value = ((-diffScale$3) | 0);
    var hi$1 = (value >> 31);
    var _1 = $n($$x2).multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger(scaledDividend0, new $c_RTLong(value, hi$1));
    var x1___1 = _1;
    var x1___2 = scaledDivisor0
  } else {
    var x1___1 = scaledDividend0;
    var x1___2 = scaledDivisor0
  };
  var scaledDividend = $as_Ljava_math_BigInteger(x1___1);
  var scaledDivisor = $as_Ljava_math_BigInteger(x1___2);
  return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$divideBigIntegers__Ljava_math_BigInteger__Ljava_math_BigInteger__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(scaledDividend, scaledDivisor, scale$1, roundingMode$1)
}
function $p_Ljava_math_BigDecimal__cmp$1__J__I($thiz, diffScale$6) {
  return (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength).get(diffScale$6.RTLong__f_lo)) | 0)
}
function $p_Ljava_math_BigDecimal__lptbLen$1__J__I($thiz, newScale$2) {
  return $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength).get(((-newScale$2.RTLong__f_lo) | 0))
}
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.Ljava_math_BigDecimal__f__toStringImage = null;
  $thiz.Ljava_math_BigDecimal__f__hashCode = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  $thiz.Ljava_math_BigDecimal__f__precision = 0;
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = smallValue;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(smallValue);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(smallValue, hi);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$bitLength__I__I(smallValue);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, in$1, offset, len) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var last = (((-1) + ((offset + len) | 0)) | 0);
  if ((in$1 === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "in == null")
  };
  if (((((last >= $n(in$1).u.length) || (offset < 0)) || (len <= 0)) || (last < 0))) {
    throw new $c_jl_NumberFormatException(((((("Bad offset/length: offset=" + offset) + " len=") + len) + " in.length=") + $n(in$1).u.length))
  };
  var index = offset;
  if (((offset <= last) && ($n(in$1).get(offset) === 43))) {
    index = ((1 + index) | 0);
    if (((index < last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([43, 45]))))) {
      throw new $c_jl_NumberFormatException(("For input string: " + $n(in$1).toString__T()))
    }
  } else {
    var isMinus = ((index <= last) && ($n(in$1).get(index) === 45));
    var nextIsSign = ((((1 + index) | 0) < last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z($n(in$1).get(((1 + index) | 0)), new $ac_C(new Uint16Array([43, 45]))));
    if ((isMinus && nextIsSign)) {
      throw new $c_jl_NumberFormatException(("For input string: " + $n(in$1).toString__T()))
    }
  };
  var begin = index;
  var counter = 0;
  var wasNonZero = false;
  while (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charNotEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([46, 101, 69]))))) {
    if ((!wasNonZero)) {
      if (($n(in$1).get(index) === 48)) {
        counter = ((1 + counter) | 0)
      } else {
        wasNonZero = true
      }
    };
    index = ((1 + index) | 0)
  };
  var count = ((index - begin) | 0);
  var this$1 = $m_jl_String$();
  var u = this$1.new__AC__I__I__T(in$1, begin, count);
  var b = ((index - begin) | 0);
  if (((index <= last) && ($n(in$1).get(index) === 46))) {
    index = ((1 + index) | 0);
    var begin$2 = index;
    while (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charNotEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([101, 69]))))) {
      if ((!wasNonZero)) {
        if (($n(in$1).get(index) === 48)) {
          counter = ((1 + counter) | 0)
        } else {
          wasNonZero = true
        }
      };
      index = ((1 + index) | 0)
    };
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = ((index - begin$2) | 0);
    var count$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var this$2 = $m_jl_String$();
    var _1 = (("" + u) + this$2.new__AC__I__I__T(in$1, begin$2, count$1));
    var _2 = ((b + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    var x1___1 = _1;
    var x1___2 = _2
  } else {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
    var x1___1 = u;
    var x1___2 = b
  };
  var unscaled = $as_T(x1___1);
  var bufLength = $uI(x1___2);
  if (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([101, 69]))))) {
    index = ((1 + index) | 0);
    var indexIsPlus = ((index <= last) && ($n(in$1).get(index) === 43));
    var nextIsNotMinus = ((((1 + index) | 0) <= last) && ($n(in$1).get(((1 + index) | 0)) !== 45));
    var begin$3 = ((indexIsPlus && nextIsNotMinus) ? ((1 + index) | 0) : index);
    var count$2 = ((((1 + last) | 0) - begin$3) | 0);
    var this$3 = $m_jl_String$();
    var scaleString = this$3.new__AC__I__I__T(in$1, begin$3, count$2);
    var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var this$5 = $m_jl_Integer$();
    var value$1 = this$5.parseInt__T__I__I(scaleString, 10);
    var hi$1 = (value$1 >> 31);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = lo;
    var value$2 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$3 = (value$2 >> 31);
    if ((!((lo === value$2) && (hi$2 === hi$3)))) {
      throw new $c_jl_NumberFormatException("Scale out of range")
    }
  };
  if ((bufLength < 19)) {
    var this$9 = $m_jl_Long$();
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = this$9.parseLong__T__I__J(unscaled, 10);
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
  } else {
    $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), unscaled))
  };
  return $thiz
}
function $ct_Ljava_math_BigDecimal__T__($thiz, sVal) {
  var $$x1 = $f_T__toCharArray__AC($n(sVal));
  var this$1 = $n(sVal);
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $$x1, 0, this$1.length);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__($thiz, sVal, mc) {
  var $$x1 = $f_T__toCharArray__AC($n(sVal));
  var this$1 = $n(sVal);
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $$x1, 0, this$1.length);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  if ((unscaledVal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "unscaledVal == null")
  };
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__($thiz, bi) {
  $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, bi, 0);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__I__($thiz, iVal) {
  $ct_Ljava_math_BigDecimal__I__I__($thiz, iVal, 0);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__($thiz, lVal) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal, 0);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__($thiz, lVal, mc) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal, 0);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz
}
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.Ljava_math_BigDecimal__f__toStringImage = null;
  this.Ljava_math_BigDecimal__f__hashCode = 0;
  this.Ljava_math_BigDecimal__f__intVal = null;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  this.Ljava_math_BigDecimal__f__precision = 0
}
$c_Ljava_math_BigDecimal.prototype = new $h_jl_Number();
$c_Ljava_math_BigDecimal.prototype.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
  /*<skip>*/
}
$h_Ljava_math_BigDecimal.prototype = $c_Ljava_math_BigDecimal.prototype;
$c_Ljava_math_BigDecimal.prototype.add__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(augend) {
  var diffScale = ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale - $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return augend
  } else if (($p_Ljava_math_BigDecimal__isZero__Z($n(augend)) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this
  } else if ((diffScale === 0)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    var b = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $$x1 = $m_Ljava_math_BigDecimal$();
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo = this$2.RTLong__f_lo;
      var ahi = this$2.RTLong__f_hi;
      var bhi = b$1.RTLong__f_hi;
      var lo = ((alo + b$1.RTLong__f_lo) | 0);
      var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
      return $n($$x1).valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo, hi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    } else {
      var this$4 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
      var bi = $n(augend).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    }
  } else {
    return ((diffScale > 0) ? $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(this, augend, diffScale) : $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(augend, this, ((-diffScale) | 0)))
  }
});
$c_Ljava_math_BigDecimal.prototype.subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(subtrahend) {
  var diffScale = ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale - $n(subtrahend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return $n(subtrahend).negate__Ljava_math_BigDecimal()
  } else if (($p_Ljava_math_BigDecimal__isZero__Z($n(subtrahend)) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this
  } else if ((diffScale === 0)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    var b = $n(subtrahend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $$x1 = $m_Ljava_math_BigDecimal$();
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = $n(subtrahend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo = this$2.RTLong__f_lo;
      var ahi = this$2.RTLong__f_hi;
      var bhi = b$1.RTLong__f_hi;
      var lo = ((alo - b$1.RTLong__f_lo) | 0);
      var hi = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
      return $n($$x1).valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo, hi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    } else {
      var this$4 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
      var bi = $n(subtrahend).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    }
  } else if ((diffScale > 0)) {
    if (((diffScale < $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).u.length) && ($p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I(this, subtrahend, diffScale) < 64))) {
      var t = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(diffScale);
      var lo$1 = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      var $$x2 = $m_Ljava_math_BigDecimal$();
      var this$6 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var this$5 = $n(subtrahend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo$1 = this$5.RTLong__f_lo;
      var a0 = (65535 & alo$1);
      var a1 = ((alo$1 >>> 16) | 0);
      var b0 = (65535 & lo$1);
      var b1 = ((lo$1 >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(alo$1, hi$1) + Math.imul(this$5.RTLong__f_hi, lo$1)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var alo$2 = this$6.RTLong__f_lo;
      var ahi$1 = this$6.RTLong__f_hi;
      var lo$3 = ((alo$2 - lo$2) | 0);
      var hi$3 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$1 - hi$2) | 0)) | 0) : ((ahi$1 - hi$2) | 0));
      return $n($$x2).valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$3, hi$3), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    } else {
      var $$x4 = $m_Ljava_math_Multiplication$();
      var $$x3 = $n(subtrahend).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var hi$4 = (diffScale >> 31);
      var mult = $n($$x4).multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x3, new $c_RTLong(diffScale, hi$4));
      var this$9 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$9, mult), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    }
  } else {
    var negDiffScale = ((-diffScale) | 0);
    if (((negDiffScale < $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).u.length) && ($p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I(this, subtrahend, negDiffScale) < 64))) {
      var t$1 = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(negDiffScale);
      var lo$4 = t$1.RTLong__f_lo;
      var hi$5 = t$1.RTLong__f_hi;
      var $$x5 = $m_Ljava_math_BigDecimal$();
      var this$10 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo$3 = this$10.RTLong__f_lo;
      var a0$1 = (65535 & alo$3);
      var a1$1 = ((alo$3 >>> 16) | 0);
      var b0$1 = (65535 & lo$4);
      var b1$1 = ((lo$4 >>> 16) | 0);
      var a0b0$1 = Math.imul(a0$1, b0$1);
      var a1b0$1 = Math.imul(a1$1, b0$1);
      var a0b1$1 = Math.imul(a0$1, b1$1);
      var lo$5 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$6 = ((((((((Math.imul(alo$3, hi$5) + Math.imul(this$10.RTLong__f_hi, lo$4)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var b$2 = $n(subtrahend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var bhi$1 = b$2.RTLong__f_hi;
      var lo$6 = ((lo$5 - b$2.RTLong__f_lo) | 0);
      var hi$7 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ lo$5)) ? (((-1) + ((hi$6 - bhi$1) | 0)) | 0) : ((hi$6 - bhi$1) | 0));
      return $n($$x5).valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$6, hi$7), $n(subtrahend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    } else {
      var $$x7 = $m_Ljava_math_Multiplication$();
      var $$x6 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var hi$8 = (negDiffScale >> 31);
      var mult$2 = $n($$x7).multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x6, new $c_RTLong(negDiffScale, hi$8));
      var this$13 = $n(mult$2);
      var bi$1 = $n(subtrahend).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var multSub = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$13, bi$1);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), multSub, $n(subtrahend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.multiply__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(multiplicand) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var value$1 = $n(multiplicand).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value$1 >> 31);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) || $p_Ljava_math_BigDecimal__isZero__Z($n(multiplicand)))) {
    return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi$2))
  } else if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $n(multiplicand).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0) < 64)) {
    var this$4 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var b = $n(multiplicand).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var alo = this$4.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$3 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$4.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    if (((lo$1 === 0) && (hi$3 === (-2147483648)))) {
      var this$5 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi = this$5.RTLong__f_hi;
      var $$x2 = (ahi < 0)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var this$6 = $n(multiplicand).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi$1 = this$6.RTLong__f_hi;
      var $$x1 = (ahi$1 < 0)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger(63), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$3), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
    }
  } else {
    var unscaled = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n(multiplicand).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), unscaled, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.divide__Ljava_math_BigDecimal__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(divisor, scale, roundingMode) {
  if ((roundingMode === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "roundingMode == null")
  } else if ($p_Ljava_math_BigDecimal__isZero__Z($n(divisor))) {
    throw new $c_jl_ArithmeticException("Division by zero")
  };
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var value$1 = $n(divisor).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value$1 >> 31);
  var lo = ((value - value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  var hi$3 = (scale >> 31);
  var lo$1 = ((lo - scale) | 0);
  var hi$4 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ lo)) ? (((-1) + ((hi$2 - hi$3) | 0)) | 0) : ((hi$2 - hi$3) | 0));
  var hi$5 = (lo$1 >> 31);
  if ((!((lo$1 === lo$1) && (hi$5 === hi$4)))) {
    throw new $c_jl_ArithmeticException((("Unable to scale as difference is too big (" + new $c_RTLong(lo$1, hi$4)) + ")"))
  };
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64) && ($n(divisor).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
    var lptLen = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).u.length;
    if ((lo$1 === 0)) {
      var t = $n(divisor).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var lo$2 = t.RTLong__f_lo;
      var hi$6 = t.RTLong__f_hi;
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, new $c_RTLong(lo$2, hi$6), scale, roundingMode)
    } else if ((lo$1 > 0)) {
      if (((lo$1 < lptLen) && ((($n(divisor).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength).get(lo$1)) | 0) < 64))) {
        var this$7 = $n(divisor).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(lo$1);
        var alo = this$7.RTLong__f_lo;
        var blo = b.RTLong__f_lo;
        var a0 = (65535 & alo);
        var a1 = ((alo >>> 16) | 0);
        var b0 = (65535 & blo);
        var b1 = ((blo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo$3 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$7 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$7.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, new $c_RTLong(lo$3, hi$7), scale, roundingMode)
      } else {
        return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode)
      }
    } else if (((lo$1 > ((-lptLen) | 0)) && (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength).get(((-lo$1) | 0))) | 0) < 64))) {
      var this$8 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(((-lo$1) | 0));
      var alo$1 = this$8.RTLong__f_lo;
      var blo$1 = b$1.RTLong__f_lo;
      var a0$1 = (65535 & alo$1);
      var a1$1 = ((alo$1 >>> 16) | 0);
      var b0$1 = (65535 & blo$1);
      var b1$1 = ((blo$1 >>> 16) | 0);
      var a0b0$1 = Math.imul(a0$1, b0$1);
      var a1b0$1 = Math.imul(a1$1, b0$1);
      var a0b1$1 = Math.imul(a0$1, b1$1);
      var lo$4 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$8 = ((((((((Math.imul(alo$1, b$1.RTLong__f_hi) + Math.imul(this$8.RTLong__f_hi, blo$1)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(new $c_RTLong(lo$4, hi$8), $n(divisor).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, scale, roundingMode)
    } else {
      return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode)
    }
  } else {
    return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode)
  }
});
$c_Ljava_math_BigDecimal.prototype.negate__Ljava_math_BigDecimal = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 63)) {
    var $$x1 = true
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 63)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var $$x1 = (!((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === (-2147483648))))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var $$x2 = $m_Ljava_math_BigDecimal$();
    var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var lo = this$2.RTLong__f_lo;
    var hi = this$2.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return $n($$x2).valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()).negate__Ljava_math_BigInteger(), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  }
});
$c_Ljava_math_BigDecimal.prototype.signum__I = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi < 0)) {
      return (-1)
    } else {
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi$1 = this$2.RTLong__f_hi;
      if (((ahi$1 === 0) ? (this$2.RTLong__f_lo !== 0) : (ahi$1 > 0))) {
        return 1
      } else {
        return 0
      }
    }
  } else {
    var this$3 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    return this$3.Ljava_math_BigInteger__f_sign
  }
});
$c_Ljava_math_BigDecimal.prototype.precision__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__precision === 0)) {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
      var $$x1 = 1
    } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var $$x1 = $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I(this, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
    } else {
      var decimalDigits = ((1 + $doubleToInt((0.3010299956639812 * (((-1) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0);
      var $$x3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var $$x2 = $m_Ljava_math_Multiplication$();
      var hi = (decimalDigits >> 31);
      var this$2 = $n($n($$x3).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($n($$x2).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(decimalDigits, hi))));
      if ((this$2.Ljava_math_BigInteger__f_sign !== 0)) {
        var $$x1 = ((1 + decimalDigits) | 0)
      } else {
        var $$x1 = decimalDigits
      }
    };
    this.Ljava_math_BigDecimal__f__precision = $$x1
  };
  return this.Ljava_math_BigDecimal__f__precision
});
$c_Ljava_math_BigDecimal.prototype.setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(newScale, roundingMode) {
  if ((roundingMode === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "roundingMode == null")
  };
  var hi = (newScale >> 31);
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value >> 31);
  var lo = ((newScale - value) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ newScale)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if (((lo === 0) && (hi$2 === 0))) {
    return this
  } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
    var value$1 = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).u.length;
    var hi$3 = (value$1 >> 31);
    if ((((hi$2 === hi$3) ? (((-2147483648) ^ lo) < ((-2147483648) ^ value$1)) : (hi$2 < hi$3)) && ($p_Ljava_math_BigDecimal__cmp$1__J__I(this, new $c_RTLong(lo, hi$2)) < 64))) {
      var $$x1 = $m_Ljava_math_BigDecimal$();
      var this$5 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(lo);
      var alo = this$5.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var a0 = (65535 & alo);
      var a1 = ((alo >>> 16) | 0);
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$5.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $n($$x1).valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$4), newScale)
    } else {
      var $$x3 = $m_Ljava_math_Multiplication$();
      var $$x2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var hi$5 = (lo >> 31);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $n($$x3).multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x2, new $c_RTLong(lo, hi$5)), newScale)
    }
  } else {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var lo$2 = ((-lo) | 0);
      var hi$6 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var value$2 = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).u.length;
      var hi$7 = (value$2 >> 31);
      var $$x4 = ((hi$6 === hi$7) ? (((-2147483648) ^ lo$2) < ((-2147483648) ^ value$2)) : (hi$6 < hi$7))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var t = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(((-lo) | 0));
      var lo$3 = t.RTLong__f_lo;
      var hi$8 = t.RTLong__f_hi;
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, new $c_RTLong(lo$3, hi$8), newScale, roundingMode)
    } else {
      var $$x5 = $m_Ljava_math_Multiplication$();
      var lo$4 = ((-lo) | 0);
      var hi$9 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var powTen = $n($$x5).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo$4, hi$9));
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$divideBigIntegers__Ljava_math_BigInteger__Ljava_math_BigInteger__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), powTen, newScale, roundingMode)
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.movePointLeft__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value + n) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
  return $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal(this, new $c_RTLong(lo, hi$2))
});
$c_Ljava_math_BigDecimal.prototype.movePointRight__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  return $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal(this, new $c_RTLong(lo, hi$2))
});
$c_Ljava_math_BigDecimal.prototype.scaleByPowerOfTen__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$4 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    if (((this$4.RTLong__f_lo === 0) && (this$4.RTLong__f_hi === 0))) {
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi$2))
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.stripTrailingZeros__Ljava_math_BigDecimal = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return this
  } else {
    var lastPow = (((-1) + $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).u.length) | 0);
    var i = 1;
    var strippedBI = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var scale__lo = value;
    var scale__hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!$n(strippedBI).testBit__I__Z(0))) {
        var qr = $n(strippedBI).divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).get(i));
        var this$2 = $n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_rem);
        if ((this$2.Ljava_math_BigInteger__f_sign === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = $n(qr).Ljava_math_BigInteger$QuotAndRem__f_quot;
          var this$4__lo = scale__lo;
          var this$4__hi = scale__hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var alo = this$4__lo;
          var ahi = this$4__hi;
          var lo = ((alo - value$1) | 0);
          var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$1) | 0)) | 0) : ((ahi - hi$1) | 0));
          i = temp$i;
          strippedBI = temp$strippedBI;
          var $$x1__lo = lo;
          var $$x1__hi = hi$2;
          scale__lo = $$x1__lo;
          scale__hi = $$x1__hi;
          continue
        };
        if ((i !== 1)) {
          i = 1;
          continue
        };
        var _1 = strippedBI;
        var _2__lo = scale__lo;
        var _2__hi = scale__hi;
        var x1___1 = _1;
        var x1___2 = new $c_RTLong(_2__lo, _2__hi);
        break
      } else {
        var _1$1 = strippedBI;
        var _2$1__lo = scale__lo;
        var _2$1__hi = scale__hi;
        var x1___1 = _1$1;
        var x1___2 = new $c_RTLong(_2$1__lo, _2$1__hi);
        break
      }
    };
    var strippedBI$1 = $as_Ljava_math_BigInteger(x1___1);
    var t = $uJ(x1___2);
    var lo$1 = t.RTLong__f_lo;
    var hi$3 = t.RTLong__f_hi;
    var t$1 = $uJ(new $c_RTLong(lo$1, hi$3));
    var lo$2 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$2, hi$4)))
  }
});
$c_Ljava_math_BigDecimal.prototype.compareTo__Ljava_math_BigDecimal__I = (function(bi) {
  var thisSign = this.signum__I();
  var valueSign = $n(bi).signum__I();
  if ((thisSign === valueSign)) {
    if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) && ($n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
      var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi = this$1.RTLong__f_hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))) {
        return (-1)
      } else {
        var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b$1 = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var ahi$1 = this$2.RTLong__f_hi;
        var bhi$1 = b$1.RTLong__f_hi;
        if (((ahi$1 === bhi$1) ? (((-2147483648) ^ this$2.RTLong__f_lo) > ((-2147483648) ^ b$1.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
          return 1
        } else {
          return 0
        }
      }
    } else {
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var value$1 = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I($n(bi))) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((lo$1 === 0) ? ((1 + hi$2) | 0) : hi$2);
      if (((hi$3 === hi$4) ? (((-2147483648) ^ diffPrecision) > ((-2147483648) ^ lo$1)) : (hi$3 > hi$4))) {
        return thisSign
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = (((-1) + lo) | 0);
        var hi$6 = ((lo$2 !== (-1)) ? hi$2 : (((-1) + hi$2) | 0));
        if (((hi$5 === hi$6) ? (((-2147483648) ^ diffPrecision) < ((-2147483648) ^ lo$2)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0)
        } else {
          var t = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          var v = $n(bi).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          if ((hi$2 < 0)) {
            var $$x2 = $n(t);
            var $$x1 = $m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
            var _1 = $n($$x2).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($$x1).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo$3, hi$7)));
            var x1___1 = _1;
            var x1___2 = v
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var _2 = $n(v).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$2)));
            var x1___1 = t;
            var x1___2 = _2
          } else {
            var x1___1 = t;
            var x1___2 = v
          };
          var thisUnscaled = $as_Ljava_math_BigInteger(x1___1);
          var valUnscaled = $as_Ljava_math_BigInteger(x1___2);
          return $n(thisUnscaled).compareTo__Ljava_math_BigInteger__I(valUnscaled)
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1)
  }
});
$c_Ljava_math_BigDecimal.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    var x2 = $as_Ljava_math_BigDecimal(x);
    if (($n(x2).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)) {
      if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
        var this$1 = $n(x2).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
      } else {
        return $n(this.Ljava_math_BigDecimal__f__intVal).equals__O__Z($n(x2).Ljava_math_BigDecimal__f__intVal)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__hashCode !== 0)) {
    return this.Ljava_math_BigDecimal__f__hashCode
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    this.Ljava_math_BigDecimal__f__hashCode = this$1.RTLong__f_lo;
    var $$x1 = this.Ljava_math_BigDecimal__f__hashCode;
    var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var hi = this$2.RTLong__f_hi;
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(33, $$x1) + hi) | 0);
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, this.Ljava_math_BigDecimal__f__hashCode) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode
  } else {
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, $n(this.Ljava_math_BigDecimal__f__intVal).hashCode__I()) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode
  }
});
$c_Ljava_math_BigDecimal.prototype.toString__T = (function() {
  if ((this.Ljava_math_BigDecimal__f__toStringImage !== null)) {
    return this.Ljava_math_BigDecimal__f__toStringImage
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 32)) {
    this.Ljava_math_BigDecimal__f__toStringImage = $m_Ljava_math_Conversion$().toDecimalScaledString__J__I__T(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    return this.Ljava_math_BigDecimal__f__toStringImage
  } else {
    var this$1 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var intString = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
      return intString
    } else {
      var this$2 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
      if ((this$2.Ljava_math_BigInteger__f_sign < 0)) {
        var begin = 2
      } else {
        var begin = 1
      };
      var this$3 = $n(intString);
      var end = this$3.length;
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$3 - hi$4) | 0)) | 0) : ((hi$3 - hi$4) | 0));
      if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0) && ((hi$5 === (-1)) ? (((-2147483648) ^ lo$2) >= 2147483642) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
          $m_Ljava_math_BigDecimal$();
          var this$14 = $n(intString);
          if ((pos > this$14.length)) {
            $charAt(this$14, pos)
          };
          if ((pos < 0)) {
            $charAt(this$14, (-1))
          };
          var $$x1 = $as_T(this$14.substring(0, pos));
          var this$15 = $n(intString);
          if (((pos < 0) || (pos > this$15.length))) {
            $charAt(this$15, pos)
          };
          var result = (($$x1 + ".") + $as_T(this$15.substring(pos)))
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = (((-1) + begin) | 0);
          $m_Ljava_math_BigDecimal$();
          var this$19 = $n(intString);
          if ((pos$1 > this$19.length)) {
            $charAt(this$19, pos$1)
          };
          if ((pos$1 < 0)) {
            $charAt(this$19, (-1))
          };
          var $$x2 = $as_T(this$19.substring(0, pos$1));
          var this$20 = $n(intString);
          if (((pos$1 < 0) || (pos$1 > this$20.length))) {
            $charAt(this$20, pos$1)
          };
          var s = (($$x2 + "0.") + $as_T(this$20.substring(pos$1)));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
          var s2Len = (((-1) - lo$2) | 0);
          $m_Ljava_math_BigDecimal$();
          var this$24 = $n(s2);
          if ((s2Len > this$24.length)) {
            $charAt(this$24, s2Len)
          };
          if ((s2Len < 0)) {
            $charAt(this$24, (-1))
          };
          var s2$1 = $as_T(this$24.substring(0, s2Len));
          if ((pos$2 > s.length)) {
            $charAt(s, pos$2)
          };
          if ((pos$2 < 0)) {
            $charAt(s, (-1))
          };
          var $$x3 = $as_T(s.substring(0, pos$2));
          if (((pos$2 < 0) || (pos$2 > s.length))) {
            $charAt(s, pos$2)
          };
          var result = ((("" + $$x3) + s2$1) + $as_T(s.substring(pos$2)))
        }
      } else {
        if ((((end - begin) | 0) >= 1)) {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var this$28 = $n(intString);
          if ((begin > this$28.length)) {
            $charAt(this$28, begin)
          };
          if ((begin < 0)) {
            $charAt(this$28, (-1))
          };
          var $$x4 = $as_T(this$28.substring(0, begin));
          var this$29 = $n(intString);
          if (((begin < 0) || (begin > this$29.length))) {
            $charAt(this$29, begin)
          };
          var r0 = (($$x4 + ".") + $as_T(this$29.substring(begin)))
        } else {
          var r0 = intString
        };
        var r1 = (r0 + "E");
        var r2 = (((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1);
        var result = (r2 + $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$2, hi$5))
      };
      this.Ljava_math_BigDecimal__f__toStringImage = result;
      return this.Ljava_math_BigDecimal__f__toStringImage
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.toPlainString__T = (function() {
  var this$1 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
  var intStr = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || ($p_Ljava_math_BigDecimal__isZero__Z(this) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)))) {
    return intStr
  } else {
    var begin = ((this.signum__I() < 0) ? 1 : 0);
    var delta = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var result = ((begin === 1) ? "-" : "");
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0)) {
      var $$x1 = delta;
      var this$2 = $n(intStr);
      delta = (($$x1 - ((this$2.length - begin) | 0)) | 0);
      if ((delta >= 0)) {
        result = (result + "0.");
        while ((delta > 100)) {
          result = (("" + result) + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros);
          delta = (((-100) + delta) | 0)
        };
        var $$x3 = result;
        var this$3 = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros);
        var endIndex = delta;
        if ((endIndex > this$3.length)) {
          $charAt(this$3, endIndex)
        };
        if ((endIndex < 0)) {
          $charAt(this$3, (-1))
        };
        var $$x2 = $as_T(this$3.substring(0, endIndex));
        var this$4 = $n(intStr);
        if (((begin < 0) || (begin > this$4.length))) {
          $charAt(this$4, begin)
        };
        result = ((("" + $$x3) + $$x2) + $as_T(this$4.substring(begin)))
      } else {
        delta = ((begin - delta) | 0);
        var $$x5 = result;
        var this$5 = $n(intStr);
        var endIndex$1 = delta;
        if ((begin < 0)) {
          $charAt(this$5, begin)
        };
        if ((endIndex$1 > this$5.length)) {
          $charAt(this$5, endIndex$1)
        };
        if ((endIndex$1 < begin)) {
          $charAt(this$5, (-1))
        };
        var $$x4 = $as_T(this$5.substring(begin, endIndex$1));
        var this$6 = $n(intStr);
        var beginIndex = delta;
        if (((beginIndex < 0) || (beginIndex > this$6.length))) {
          $charAt(this$6, beginIndex)
        };
        result = (($$x5 + ($$x4 + ".")) + $as_T(this$6.substring(beginIndex)))
      }
    } else {
      var $$x6 = result;
      var this$7 = $n(intStr);
      if (((begin < 0) || (begin > this$7.length))) {
        $charAt(this$7, begin)
      };
      result = (("" + $$x6) + $as_T(this$7.substring(begin)));
      while ((delta < (-100))) {
        result = (("" + result) + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros);
        delta = ((100 + delta) | 0)
      };
      var $$x7 = result;
      var this$8 = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros);
      var endIndex$2 = ((-delta) | 0);
      if ((endIndex$2 > this$8.length)) {
        $charAt(this$8, endIndex$2)
      };
      if ((endIndex$2 < 0)) {
        $charAt(this$8, (-1))
      };
      result = (("" + $$x7) + $as_T(this$8.substring(0, endIndex$2)))
    };
    return result
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigInteger__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $$x2 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $$x1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $n($$x2).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($$x1).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)))
  } else {
    var $$x4 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $$x3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    return $n($$x4).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($n($$x3).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigIntegerExact__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $$x2 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $$x1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $n($$x2).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($$x1).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)))
  } else {
    if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()).getLowestSetBit__I()))) {
      throw new $c_jl_ArithmeticException("Rounding necessary")
    };
    var $$x4 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $$x3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $n($$x4).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($n($$x3).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)));
    var this$5 = $n($n(integerAndFraction).get(1));
    if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
      throw new $c_jl_ArithmeticException("Rounding necessary")
    };
    return $n(integerAndFraction).get(0)
  }
});
$c_Ljava_math_BigDecimal.prototype.longValue__J = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-64)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? $L0 : $n(this.toBigInteger__Ljava_math_BigInteger()).longValue__J())
});
$c_Ljava_math_BigDecimal.prototype.intValue__I = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-32)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? 0 : $n(this.toBigInteger__Ljava_math_BigInteger()).intValue__I())
});
$c_Ljava_math_BigDecimal.prototype.intValueExact__I = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 32);
  return this$1.RTLong__f_lo
});
$c_Ljava_math_BigDecimal.prototype.shortValueExact__S = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 16);
  return ((this$1.RTLong__f_lo << 16) >> 16)
});
$c_Ljava_math_BigDecimal.prototype.byteValueExact__B = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 8);
  return ((this$1.RTLong__f_lo << 24) >> 24)
});
$c_Ljava_math_BigDecimal.prototype.floatValue__F = (function() {
  return $m_jl_Float$().parseFloat__T__F(((this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger() + "e") + ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)))
});
$c_Ljava_math_BigDecimal.prototype.doubleValue__D = (function() {
  return $m_jl_Double$().parseDouble__T__D(((this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger() + "e") + ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)))
});
$c_Ljava_math_BigDecimal.prototype.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger = (function() {
  if ((this.Ljava_math_BigDecimal__f__intVal === null)) {
    this.Ljava_math_BigDecimal__f__intVal = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
  };
  return this.Ljava_math_BigDecimal__f__intVal
});
$c_Ljava_math_BigDecimal.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_math_BigDecimal__I($as_Ljava_math_BigDecimal(o))
});
function $as_Ljava_math_BigDecimal(obj) {
  return (((obj instanceof $c_Ljava_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigDecimal"))
}
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigDecimal)))
}
function $asArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (($isArrayOf_Ljava_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigDecimal;", depth))
}
var $d_Ljava_math_BigDecimal = new $TypeData().initClass({
  Ljava_math_BigDecimal: 0
}, false, "java.math.BigDecimal", {
  Ljava_math_BigDecimal: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_Ljava_math_BigDecimal.prototype.$classData = $d_Ljava_math_BigDecimal;
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger")
  };
  var this$1 = $n(s);
  var stringLength0 = this$1.length;
  var this$2 = $n(s);
  if (($charAt(this$2, 0) === 45)) {
    var _3 = (((-1) + stringLength0) | 0);
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = _3
  } else {
    var this$3 = $n(s);
    if (($charAt(this$3, 0) === 43)) {
      var _3$1 = (((-1) + stringLength0) | 0);
      var x1___1 = 1;
      var x1___2 = 1;
      var x1___3 = _3$1
    } else {
      var x1___1 = 1;
      var x1___2 = 0;
      var x1___3 = stringLength0
    }
  };
  var _sign = $uI(x1___1);
  var startChar = $uI(x1___2);
  var stringLength = $uI(x1___3);
  var i = startChar;
  while ((i < stringLength0)) {
    var i$2 = i;
    var this$6 = $n(s);
    var c = $charAt(this$6, i$2);
    if (((c === 43) || (c === 45))) {
      throw new $c_jl_NumberFormatException("Illegal embedded sign character")
    };
    i = ((1 + i) | 0)
  };
  var charsPerInt = $n($m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_DigitFitInInt).get(radix);
  var bigRadixDigitsLength = $intDiv(stringLength, charsPerInt);
  var topChars = $intMod(stringLength, charsPerInt);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0)
  };
  var _digits = new $ac_I(bigRadixDigitsLength);
  var bigRadix = $n($m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_BigRadices).get((((-2) + radix) | 0));
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var $$x1 = $m_jl_Integer$();
    var this$7 = $n(s);
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    if ((beginIndex < 0)) {
      $charAt(this$7, beginIndex)
    };
    if ((endIndex > this$7.length)) {
      $charAt(this$7, endIndex)
    };
    if ((endIndex < beginIndex)) {
      $charAt(this$7, (-1))
    };
    var bigRadixDigit = $n($$x1).parseInt__T__I__I($as_T(this$7.substring(beginIndex, endIndex)), radix);
    var this$8 = $m_Ljava_math_Multiplication$();
    var aSize = digitIndex;
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this$8, _digits, _digits, aSize, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().inplaceAdd__AI__I__I__I(_digits, digitIndex, bigRadixDigit)) | 0);
    $n(_digits).set(digitIndex, newDigit);
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0)
  };
  $thiz.Ljava_math_BigInteger__f_sign = _sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = digitIndex;
  $thiz.Ljava_math_BigInteger__f_digits = _digits;
  $thiz.cutOffLeadingZeroes__V()
}
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = (-2);
  $thiz.Ljava_math_BigInteger__f__hashCode = 0;
  return $thiz
}
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  $m_Ljava_math_BigInteger$();
  if ((s === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if (((radix < 2) || (radix > 36))) {
    throw new $c_jl_NumberFormatException("Radix out of range")
  };
  var this$2 = $n(s);
  if ((this$2 === "")) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger")
  };
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz
}
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = 1;
  $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([value]));
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if (($n(digits).u.length === 0)) {
    $thiz.Ljava_math_BigInteger__f_sign = 0;
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([0]))
  } else {
    $thiz.Ljava_math_BigInteger__f_sign = signum;
    $thiz.Ljava_math_BigInteger__f_numberLength = $n(digits).u.length;
    $thiz.Ljava_math_BigInteger__f_digits = digits;
    $thiz.cutOffLeadingZeroes__V()
  };
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = numberLength;
  $thiz.Ljava_math_BigInteger__f_digits = digits;
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  var hi = lVal.RTLong__f_hi;
  if ((hi === 0)) {
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo]))
  } else {
    $thiz.Ljava_math_BigInteger__f_numberLength = 2;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo, hi]))
  };
  return $thiz
}
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.Ljava_math_BigInteger__f_digits = null;
  this.Ljava_math_BigInteger__f_numberLength = 0;
  this.Ljava_math_BigInteger__f_sign = 0;
  this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = 0;
  this.Ljava_math_BigInteger__f__hashCode = 0
}
$c_Ljava_math_BigInteger.prototype = new $h_jl_Number();
$c_Ljava_math_BigInteger.prototype.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger.prototype = $c_Ljava_math_BigInteger.prototype;
$c_Ljava_math_BigInteger.prototype.abs__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits) : this)
});
$c_Ljava_math_BigInteger.prototype.compareTo__Ljava_math_BigInteger__I = (function(bi) {
  return ((this.Ljava_math_BigInteger__f_sign > $n(bi).Ljava_math_BigInteger__f_sign) ? 1 : ((this.Ljava_math_BigInteger__f_sign < $n(bi).Ljava_math_BigInteger__f_sign) ? (-1) : ((this.Ljava_math_BigInteger__f_numberLength > $n(bi).Ljava_math_BigInteger__f_numberLength) ? this.Ljava_math_BigInteger__f_sign : ((this.Ljava_math_BigInteger__f_numberLength < $n(bi).Ljava_math_BigInteger__f_numberLength) ? ((-$n(bi).Ljava_math_BigInteger__f_sign) | 0) : Math.imul(this.Ljava_math_BigInteger__f_sign, $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, $n(bi).Ljava_math_BigInteger__f_digits, this.Ljava_math_BigInteger__f_numberLength))))))
});
$c_Ljava_math_BigInteger.prototype.divide__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(divisor) {
  if (($n(divisor).Ljava_math_BigInteger__f_sign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero")
  };
  var divisorSign = $n(divisor).Ljava_math_BigInteger__f_sign;
  if ($n(divisor).isOne__Z()) {
    return (($n(divisor).Ljava_math_BigInteger__f_sign > 0) ? this : this.negate__Ljava_math_BigInteger())
  } else {
    var thisSign = this.Ljava_math_BigInteger__f_sign;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var divisorLen = $n(divisor).Ljava_math_BigInteger__f_numberLength;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var value = $n(this.Ljava_math_BigInteger__f_digits).get(0);
      var value$1 = $n($n(divisor).Ljava_math_BigInteger__f_digits).get(0);
      var this$3 = $m_RTLong$();
      var lo = this$3.divideImpl__I__I__I__I__I(value, 0, value$1, 0);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var bi__lo = lo;
      var bi__hi = hi$2;
      if ((thisSign !== divisorSign)) {
        var this$4__lo = bi__lo;
        var this$4__hi = bi__hi;
        var lo$1 = this$4__lo;
        var hi$3 = this$4__hi;
        var lo$2 = ((-lo$1) | 0);
        var hi$4 = ((lo$1 !== 0) ? (~hi$3) : ((-hi$3) | 0));
        var $$x1__lo = lo$2;
        var $$x1__hi = hi$4;
        bi__lo = $$x1__lo;
        bi__hi = $$x1__hi
      };
      return $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(bi__lo, bi__hi))
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, $n(divisor).Ljava_math_BigInteger__f_digits, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE)
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(resDigits, this.Ljava_math_BigInteger__f_digits, thisLen, $n($n(divisor).Ljava_math_BigInteger__f_digits).get(0))
        } else {
          $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(resDigits, resLength, this.Ljava_math_BigInteger__f_digits, thisLen, $n(divisor).Ljava_math_BigInteger__f_digits, divisorLen)
        };
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.cutOffLeadingZeroes__V();
        return result
      }
    }
  }
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger = (function(divisor) {
  return $n(this.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(divisor)).toArray__ALjava_math_BigInteger()
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem = (function(divisor) {
  var divisorSign = $n(divisor).Ljava_math_BigInteger__f_sign;
  if ((divisorSign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero")
  };
  var divisorLen = $n(divisor).Ljava_math_BigInteger__f_numberLength;
  var divisorDigits = $n(divisor).Ljava_math_BigInteger__f_digits;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem(this, $n(divisorDigits).get(0), divisorSign)
  } else {
    var thisDigits = this.Ljava_math_BigInteger__f_digits;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(thisDigits, divisorDigits, thisLen));
    if ((cmp < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO, this)
    } else {
      var thisSign = this.Ljava_math_BigInteger__f_sign;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.cutOffLeadingZeroes__V();
      result1.cutOffLeadingZeroes__V();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1)
    }
  }
});
$c_Ljava_math_BigInteger.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigInteger)) {
    var x2 = $as_Ljava_math_BigInteger(x);
    return (((this.Ljava_math_BigInteger__f_sign === $n(x2).Ljava_math_BigInteger__f_sign) && (this.Ljava_math_BigInteger__f_numberLength === $n(x2).Ljava_math_BigInteger__f_numberLength)) && this.equalsArrays__AI__Z($n(x2).Ljava_math_BigInteger__f_digits))
  } else {
    return false
  }
});
$c_Ljava_math_BigInteger.prototype.getLowestSetBit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_sign === 0)) {
    return (-1)
  } else {
    var i = this.getFirstNonzeroDigit__I();
    var i$1 = $n(this.Ljava_math_BigInteger__f_digits).get(i);
    if ((i$1 === 0)) {
      var $$x1 = 32
    } else {
      var i$2 = (i$1 & ((-i$1) | 0));
      var $$x1 = ((31 - $uI(Math.clz32(i$2))) | 0)
    };
    return (((i << 5) + $$x1) | 0)
  }
});
$c_Ljava_math_BigInteger.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigInteger__f__hashCode !== 0)) {
    return this.Ljava_math_BigInteger__f__hashCode
  } else {
    var end = this.Ljava_math_BigInteger__f_numberLength;
    var i = 0;
    while ((i < end)) {
      var i$2 = i;
      this.Ljava_math_BigInteger__f__hashCode = ((Math.imul(33, this.Ljava_math_BigInteger__f__hashCode) + $n(this.Ljava_math_BigInteger__f_digits).get(i$2)) | 0);
      i = ((1 + i) | 0)
    };
    this.Ljava_math_BigInteger__f__hashCode = Math.imul(this.Ljava_math_BigInteger__f__hashCode, this.Ljava_math_BigInteger__f_sign);
    return this.Ljava_math_BigInteger__f__hashCode
  }
});
$c_Ljava_math_BigInteger.prototype.intValue__I = (function() {
  return Math.imul(this.Ljava_math_BigInteger__f_sign, $n(this.Ljava_math_BigInteger__f_digits).get(0))
});
$c_Ljava_math_BigInteger.prototype.longValue__J = (function() {
  if ((this.Ljava_math_BigInteger__f_numberLength > 1)) {
    var value = $n(this.Ljava_math_BigInteger__f_digits).get(1);
    var value$1 = $n(this.Ljava_math_BigInteger__f_digits).get(0);
    var value$3__lo = value$1;
    var value$3__hi = value
  } else {
    var value$2 = $n(this.Ljava_math_BigInteger__f_digits).get(0);
    var value$3__lo = value$2;
    var value$3__hi = 0
  };
  var value$4 = this.Ljava_math_BigInteger__f_sign;
  var hi$3 = (value$4 >> 31);
  var blo = value$3__lo;
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(value$4, value$3__hi) + Math.imul(hi$3, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi$4)
});
$c_Ljava_math_BigInteger.prototype.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(bi) {
  if ((($n(bi).Ljava_math_BigInteger__f_sign === 0) || (this.Ljava_math_BigInteger__f_sign === 0))) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
  } else {
    var this$1 = $m_Ljava_math_Multiplication$();
    return this$1.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this, bi)
  }
});
$c_Ljava_math_BigInteger.prototype.negate__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.Ljava_math_BigInteger__f_sign) | 0), this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits))
});
$c_Ljava_math_BigInteger.prototype.pow__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < 0)) {
    throw new $c_jl_ArithmeticException("Negative exponent")
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE
  } else if ((((exp === 1) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE)) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO))) {
    return this
  } else if ((!this.testBit__I__Z(0))) {
    var x = 1;
    while ((!this.testBit__I__Z(x))) {
      x = ((1 + x) | 0)
    };
    return $n($m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger(Math.imul(x, exp))).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n(this.shiftRight__I__Ljava_math_BigInteger(x)).pow__I__Ljava_math_BigInteger(exp))
  } else {
    return $m_Ljava_math_Multiplication$().pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, exp)
  }
});
$c_Ljava_math_BigInteger.prototype.shiftLeft__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))))
});
$c_Ljava_math_BigInteger.prototype.shiftRight__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))))
});
$c_Ljava_math_BigInteger.prototype.testBit__I__Z = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & $n(this.Ljava_math_BigInteger__f_digits).get(0)) !== 0)
  } else if ((n < 0)) {
    throw new $c_jl_ArithmeticException("Negative bit address")
  } else if ((intCount >= this.Ljava_math_BigInteger__f_numberLength)) {
    return (this.Ljava_math_BigInteger__f_sign < 0)
  } else if ((!((this.Ljava_math_BigInteger__f_sign < 0) && (intCount < this.getFirstNonzeroDigit__I())))) {
    var digit = $n(this.Ljava_math_BigInteger__f_digits).get(intCount);
    if ((this.Ljava_math_BigInteger__f_sign < 0)) {
      digit = ((this.getFirstNonzeroDigit__I() === intCount) ? ((-digit) | 0) : (~digit))
    };
    var i = (1 << (31 & n));
    return ((digit & i) !== 0)
  } else {
    return false
  }
});
$c_Ljava_math_BigInteger.prototype.toString__T = (function() {
  return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this)
});
$c_Ljava_math_BigInteger.prototype.cutOffLeadingZeroes__V = (function() {
  while (true) {
    if ((this.Ljava_math_BigInteger__f_numberLength > 0)) {
      this.Ljava_math_BigInteger__f_numberLength = (((-1) + this.Ljava_math_BigInteger__f_numberLength) | 0);
      if (($n(this.Ljava_math_BigInteger__f_digits).get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
        continue
      }
    };
    break
  };
  if (($n(this.Ljava_math_BigInteger__f_digits).get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
    this.Ljava_math_BigInteger__f_sign = 0
  };
  this.Ljava_math_BigInteger__f_numberLength = ((1 + this.Ljava_math_BigInteger__f_numberLength) | 0)
});
$c_Ljava_math_BigInteger.prototype.equalsArrays__AI__Z = (function(b) {
  var i = 0;
  while ((i !== this.Ljava_math_BigInteger__f_numberLength)) {
    if (($n(this.Ljava_math_BigInteger__f_digits).get(i) !== $n(b).get(i))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_Ljava_math_BigInteger.prototype.getFirstNonzeroDigit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit === (-2))) {
    if ((this.Ljava_math_BigInteger__f_sign === 0)) {
      var $$x1 = (-1)
    } else {
      var i = 0;
      while (($n(this.Ljava_math_BigInteger__f_digits).get(i) === 0)) {
        i = ((1 + i) | 0)
      };
      var $$x1 = i
    };
    this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = $$x1
  };
  return this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit
});
$c_Ljava_math_BigInteger.prototype.isOne__Z = (function() {
  return ((this.Ljava_math_BigInteger__f_numberLength === 1) && ($n(this.Ljava_math_BigInteger__f_digits).get(0) === 1))
});
$c_Ljava_math_BigInteger.prototype.shiftLeftOneBit__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $m_Ljava_math_BitLevel$().shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger(this))
});
$c_Ljava_math_BigInteger.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_math_BigInteger__I($as_Ljava_math_BigInteger(o))
});
function $as_Ljava_math_BigInteger(obj) {
  return (((obj instanceof $c_Ljava_math_BigInteger) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigInteger"))
}
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigInteger)))
}
function $asArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (($isArrayOf_Ljava_math_BigInteger(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigInteger;", depth))
}
var $d_Ljava_math_BigInteger = new $TypeData().initClass({
  Ljava_math_BigInteger: 0
}, false, "java.math.BigInteger", {
  Ljava_math_BigInteger: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_Ljava_math_BigInteger.prototype.$classData = $d_Ljava_math_BigInteger;
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_math_RoundingMode.prototype = new $h_jl_Enum();
$c_Ljava_math_RoundingMode.prototype.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
  /*<skip>*/
}
$h_Ljava_math_RoundingMode.prototype = $c_Ljava_math_RoundingMode.prototype;
var $d_Ljava_math_RoundingMode = new $TypeData().initClass({
  Ljava_math_RoundingMode: 0
}, false, "java.math.RoundingMode", {
  Ljava_math_RoundingMode: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_RoundingMode.prototype.$classData = $d_Ljava_math_RoundingMode;
/** @constructor */
function $c_Ljava_time_Period(years, months, days) {
  this.Ljava_time_Period__f_years = 0;
  this.Ljava_time_Period__f_months = 0;
  this.Ljava_time_Period__f_days = 0;
  this.Ljava_time_Period__f_years = years;
  this.Ljava_time_Period__f_months = months;
  this.Ljava_time_Period__f_days = days
}
$c_Ljava_time_Period.prototype = new $h_O();
$c_Ljava_time_Period.prototype.constructor = $c_Ljava_time_Period;
/** @constructor */
function $h_Ljava_time_Period() {
  /*<skip>*/
}
$h_Ljava_time_Period.prototype = $c_Ljava_time_Period.prototype;
$c_Ljava_time_Period.prototype.isZero__Z = (function() {
  return (this === $m_Ljava_time_Period$().ZERO__Ljava_time_Period())
});
$c_Ljava_time_Period.prototype.toTotalMonths__J = (function() {
  var value = this.Ljava_time_Period__f_years;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = this.Ljava_time_Period__f_months;
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  return new $c_RTLong(lo$1, hi$3)
});
$c_Ljava_time_Period.prototype.addTo__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var _temporal = temporal;
  var obj = _temporal;
  if ((obj === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "temporal")
  };
  if ((this.Ljava_time_Period__f_years !== 0)) {
    if ((this.Ljava_time_Period__f_months !== 0)) {
      _temporal = $n(_temporal).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(this.toTotalMonths__J(), $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit())
    } else {
      var $$x1 = $n(_temporal);
      var value = this.Ljava_time_Period__f_years;
      var hi = (value >> 31);
      _temporal = $n($$x1).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value, hi), $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit())
    }
  } else if ((this.Ljava_time_Period__f_months !== 0)) {
    var $$x2 = $n(_temporal);
    var value$1 = this.Ljava_time_Period__f_months;
    var hi$1 = (value$1 >> 31);
    _temporal = $n($$x2).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value$1, hi$1), $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit())
  };
  if ((this.Ljava_time_Period__f_days !== 0)) {
    var $$x3 = $n(_temporal);
    var value$2 = this.Ljava_time_Period__f_days;
    var hi$2 = (value$2 >> 31);
    _temporal = $n($$x3).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value$2, hi$2), $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit())
  };
  return _temporal
});
$c_Ljava_time_Period.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_Period)) {
    var x2 = $as_Ljava_time_Period(obj);
    return ((this === x2) || (((this.Ljava_time_Period__f_years === $n(x2).Ljava_time_Period__f_years) && (this.Ljava_time_Period__f_months === $n(x2).Ljava_time_Period__f_months)) && (this.Ljava_time_Period__f_days === $n(x2).Ljava_time_Period__f_days)))
  } else {
    return false
  }
});
$c_Ljava_time_Period.prototype.hashCode__I = (function() {
  var $$x1 = this.Ljava_time_Period__f_years;
  var i = this.Ljava_time_Period__f_months;
  var i$1 = this.Ljava_time_Period__f_days;
  return (((($$x1 + ((i << 8) | ((i >>> 24) | 0))) | 0) + ((i$1 << 16) | ((i$1 >>> 16) | 0))) | 0)
});
$c_Ljava_time_Period.prototype.toString__T = (function() {
  if ((this === $m_Ljava_time_Period$().ZERO__Ljava_time_Period())) {
    return "P0D"
  } else {
    var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
    buf.append__C__scm_StringBuilder(80);
    if ((this.Ljava_time_Period__f_years !== 0)) {
      $n(buf.append__I__scm_StringBuilder(this.Ljava_time_Period__f_years)).append__C__scm_StringBuilder(89)
    };
    if ((this.Ljava_time_Period__f_months !== 0)) {
      $n(buf.append__I__scm_StringBuilder(this.Ljava_time_Period__f_months)).append__C__scm_StringBuilder(77)
    };
    if ((this.Ljava_time_Period__f_days !== 0)) {
      $n(buf.append__I__scm_StringBuilder(this.Ljava_time_Period__f_days)).append__C__scm_StringBuilder(68)
    };
    return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
});
function $as_Ljava_time_Period(obj) {
  return (((obj instanceof $c_Ljava_time_Period) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Period"))
}
function $isArrayOf_Ljava_time_Period(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Period)))
}
function $asArrayOf_Ljava_time_Period(obj, depth) {
  return (($isArrayOf_Ljava_time_Period(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Period;", depth))
}
var $d_Ljava_time_Period = new $TypeData().initClass({
  Ljava_time_Period: 0
}, false, "java.time.Period", {
  Ljava_time_Period: 1,
  O: 1,
  Ljava_time_chrono_ChronoPeriod: 1,
  Ljava_time_temporal_TemporalAmount: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Period.prototype.$classData = $d_Ljava_time_Period;
/** @constructor */
function $c_Ljava_time_format_ResolverStyle(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_format_ResolverStyle.prototype = new $h_jl_Enum();
$c_Ljava_time_format_ResolverStyle.prototype.constructor = $c_Ljava_time_format_ResolverStyle;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle() {
  /*<skip>*/
}
$h_Ljava_time_format_ResolverStyle.prototype = $c_Ljava_time_format_ResolverStyle.prototype;
var $d_Ljava_time_format_ResolverStyle = new $TypeData().initClass({
  Ljava_time_format_ResolverStyle: 0
}, false, "java.time.format.ResolverStyle", {
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_ResolverStyle.prototype.$classData = $d_Ljava_time_format_ResolverStyle;
/** @constructor */
function $c_Ljava_time_format_SignStyle(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_format_SignStyle.prototype = new $h_jl_Enum();
$c_Ljava_time_format_SignStyle.prototype.constructor = $c_Ljava_time_format_SignStyle;
/** @constructor */
function $h_Ljava_time_format_SignStyle() {
  /*<skip>*/
}
$h_Ljava_time_format_SignStyle.prototype = $c_Ljava_time_format_SignStyle.prototype;
$c_Ljava_time_format_SignStyle.prototype.parse__Z__Z__Z__Z = (function(positive, strict, fixedWidth) {
  var x1 = this.Ljava_time_format_SignStyle__f_ordinal;
  switch (x1) {
    case 0: {
      return ((!positive) || (!strict));
      break
    }
    case 1:
    case 4: {
      return true;
      break
    }
    default: {
      return ((!strict) && (!fixedWidth))
    }
  }
});
var $d_Ljava_time_format_SignStyle = new $TypeData().initClass({
  Ljava_time_format_SignStyle: 0
}, false, "java.time.format.SignStyle", {
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_SignStyle.prototype.$classData = $d_Ljava_time_format_SignStyle;
/** @constructor */
function $c_Ljava_time_format_TextStyle(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_TextStyle__f_ordinal = 0;
  this.Ljava_time_format_TextStyle__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_format_TextStyle.prototype = new $h_jl_Enum();
$c_Ljava_time_format_TextStyle.prototype.constructor = $c_Ljava_time_format_TextStyle;
/** @constructor */
function $h_Ljava_time_format_TextStyle() {
  /*<skip>*/
}
$h_Ljava_time_format_TextStyle.prototype = $c_Ljava_time_format_TextStyle.prototype;
$c_Ljava_time_format_TextStyle.prototype.asNormal__Ljava_time_format_TextStyle = (function() {
  return $n($m_Ljava_time_format_TextStyle$().values__ALjava_time_format_TextStyle()).get(((-2) & this.Ljava_time_format_TextStyle__f_ordinal))
});
function $as_Ljava_time_format_TextStyle(obj) {
  return (((obj instanceof $c_Ljava_time_format_TextStyle) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.TextStyle"))
}
function $isArrayOf_Ljava_time_format_TextStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_TextStyle)))
}
function $asArrayOf_Ljava_time_format_TextStyle(obj, depth) {
  return (($isArrayOf_Ljava_time_format_TextStyle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.TextStyle;", depth))
}
var $d_Ljava_time_format_TextStyle = new $TypeData().initClass({
  Ljava_time_format_TextStyle: 0
}, false, "java.time.format.TextStyle", {
  Ljava_time_format_TextStyle: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_TextStyle.prototype.$classData = $d_Ljava_time_format_TextStyle;
function $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__parsable__T2($thiz) {
  if ((!$thiz.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_bitmap$init$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/format/internal/TTBPSimpleDateTimeTextProvider.scala: 85")
  };
  return $thiz.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_parsable
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(valueTextMap) {
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap = null;
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_parsable = null;
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_bitmap$init$0 = false;
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap = valueTextMap;
  var this$18 = $n(valueTextMap);
  var z = $ct_T2__O__O__(new $c_T2(), ($m_sci_List$(), $m_sci_Nil$()), ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()));
  var f$2 = ((x0$1$2, x1$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    var x1$1 = $as_T2(x1$1$2);
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
    var p2 = $as_T2(x1.T2__f__1);
    var p3 = $as_T2(x1.T2__f__2);
    if ((p2 !== null)) {
      var all = $as_sci_List($n(p2)._1__O());
      var map = $as_sci_Map($n(p2)._2__O());
      if ((p3 !== null)) {
        var style = $as_Ljava_time_format_TextStyle($n(p3)._1__O());
        var entries = $as_sci_Map($n(p3)._2__O());
        var this$4 = $n(entries);
        $m_sci_List$();
        var this$7 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4));
        var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1 = $as_T2(x$1$2);
          var this$6 = $n(x$1);
          return $uJ(this$6._1__O())
        }));
        var ord = $m_s_math_Ordering$Long$();
        var reverse = $as_T2($n($as_sc_LinearSeqOps($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$7, f, ord))).foldLeft__O__F2__O($ct_T2__O__O__(new $c_T2(), true, ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$())), new $c_sjsr_AnonFunction2(((x0$2$2, x1$2$2) => {
          var x0$2 = $as_T2(x0$2$2);
          var x1$2 = $as_T2(x1$2$2);
          var x1$3 = $ct_T2__O__O__(new $c_T2(), x0$2, x1$2);
          var a = $as_T2(x1$3.T2__f__1);
          if ((a !== null)) {
            var p3$1 = $n(a)._1$mcZ$sp__Z();
            if ((p3$1 === false)) {
              return a
            }
          };
          var p5 = $as_T2(x1$3.T2__f__1);
          var p6 = $as_T2(x1$3.T2__f__2);
          if ((p5 !== null)) {
            var p7 = $n(p5)._1$mcZ$sp__Z();
            var acc = $as_sci_Map($n(p5)._2__O());
            if (((p7 === true) && (p6 !== null))) {
              var this$9 = $n(p6);
              var t = $uJ(this$9._1__O());
              var lo = t.RTLong__f_lo;
              var hi = t.RTLong__f_hi;
              var v = $as_T($n(p6)._2__O());
              var continue$1 = (!$n(acc).contains__O__Z(v));
              var y = $ct_T2__O__O__(new $c_T2(), v, new $c_RTLong(lo, hi));
              return $ct_T2__O__O__(new $c_T2(), continue$1, $n(acc).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), v, y)))
            }
          };
          throw new $c_s_MatchError(x1$3)
        }))));
        var this$15 = $n($n($n($as_sc_MapOps($n(reverse)._2__O())).values__sc_Iterable()).toList__sci_List());
        var f$1 = new $c_sjsr_AnonFunction1(((x$2) => {
          var x = $as_T2(x$2);
          var this$14 = $n($as_T($n(x)._1__O()));
          return ((-this$14.length) | 0)
        }));
        var ord$1 = $m_s_math_Ordering$Int$();
        var list = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$15, f$1, ord$1));
        return $ct_T2__O__O__(new $c_T2(), $n(list).$colon$colon$colon__sci_List__sci_List(all), $n(map).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), style, list)))
      }
    };
    throw new $c_s_MatchError(x1)
  });
  if ($is_sc_IndexedSeq(this$18)) {
    var x2 = $as_sc_IndexedSeq(this$18);
    var at = 0;
    var end = $n(x2).length__I();
    var acc$1 = z;
    var $$x1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1 = acc$1;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f$2(arg1, arg2);
        at = temp$at;
        acc$1 = temp$acc;
        continue
      };
      var $$x1 = acc$1;
      break
    }
  } else {
    var result = z;
    var it = this$18.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1$1 = result;
      var arg2$1 = $n(it).next__O();
      result = f$2(arg1$1, arg2$1)
    };
    var $$x1 = result
  };
  var u = $as_T2($$x1);
  var this$20 = $n($as_sc_SeqOps($n(u)._1__O()));
  var f$3 = new $c_sjsr_AnonFunction1(((x$2$1) => {
    var x$3 = $as_T2(x$2$1);
    var this$19 = $n($as_T($n(x$3)._1__O()));
    return ((-this$19.length) | 0)
  }));
  var ord$2 = $m_s_math_Ordering$Int$();
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_parsable = $ct_T2__O__O__(new $c_T2(), $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$20, f$3, ord$2), $n(u)._2__O());
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_bitmap$init$0 = true
}
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.constructor = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype;
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.getText__J__Ljava_time_format_TextStyle__T = (function(value, style) {
  var this$1 = $n($n(this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap).get__O__s_Option(style));
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x$2 = $as_sci_Map(arg1);
    var $$x1 = $n(x$2).get__O__s_Option(value)
  };
  var this$3 = $n($$x1);
  var this$2 = $m_s_$less$colon$less$();
  var ev = this$2.s_$less$colon$less$__f_singleton;
  return $as_T((this$3.isEmpty__Z() ? ($n(ev), null) : this$3.get__O()))
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.getTextIterator__Ljava_time_format_TextStyle__sc_Iterator = (function(style) {
  return $n($as_sc_StrictOptimizedLinearSeqOps($n($as_sc_MapOps($n($p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__parsable__T2(this))._2__O())).getOrElse__O__F0__O(style, new $c_sjsr_AnonFunction0((() => $as_sci_List($n($p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__parsable__T2(this))._1__O())))))).iterator__sc_Iterator()
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.productPrefix__T = (function() {
  return "LocaleStore"
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.productArity__I = (function() {
  return 1
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore)) {
    var LocaleStore$1 = $as_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(x$1);
    var x = this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap;
    var x$2 = $n(LocaleStore$1).Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(obj) {
  return (((obj instanceof $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.TTBPSimpleDateTimeTextProvider$LocaleStore"))
}
function $isArrayOf_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore)))
}
function $asArrayOf_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.TTBPSimpleDateTimeTextProvider$LocaleStore;", depth))
}
var $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore: 0
}, false, "java.time.format.internal.TTBPSimpleDateTimeTextProvider$LocaleStore", {
  Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.$classData = $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore;
function $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I($thiz) {
  var this$1 = $n($thiz.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter);
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $n($thiz.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  return (($$x1 - this$2.Ljava_time_ZoneOffset__f_totalSeconds) | 0)
}
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransition(transition, offsetBefore, offsetAfter) {
  this.Ljava_time_zone_ZoneOffsetTransition__f_transition = null;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore = null;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter = null;
  this.Ljava_time_zone_ZoneOffsetTransition__f_transition = transition;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore = offsetBefore;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter = offsetAfter
}
$c_Ljava_time_zone_ZoneOffsetTransition.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransition;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransition() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransition.prototype = $c_Ljava_time_zone_ZoneOffsetTransition.prototype;
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.isGap__Z = (function() {
  var this$1 = $n(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter);
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $n(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  return ($$x1 > this$2.Ljava_time_ZoneOffset__f_totalSeconds)
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.getValidOffsets__ju_List = (function() {
  if (this.isGap__Z()) {
    var this$1 = $m_ju_Collections$();
    return this$1.EMPTY_LIST__ju_List()
  } else {
    var a = new ($d_Ljava_time_ZoneOffset.getArrayOf().constr)([this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore, this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter]);
    return $m_ju_Arrays$().asList__AO__ju_List(a)
  }
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_zone_ZoneOffsetTransition)) {
    var x2 = $as_Ljava_time_zone_ZoneOffsetTransition(other);
    if ((this === x2)) {
      return true
    } else {
      var x = this.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      var x$2 = $n(x2).Ljava_time_zone_ZoneOffsetTransition__f_transition;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
        var x$4 = $n(x2).Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$5 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
        var x$6 = $n(x2).Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.hashCode__I = (function() {
  var $$x2 = $n(this.Ljava_time_zone_ZoneOffsetTransition__f_transition).hashCode__I();
  var this$1 = $n(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $n(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter);
  var i = this$2.Ljava_time_ZoneOffset__f_totalSeconds;
  return (($$x2 ^ $$x1) ^ ((i << 16) | ((i >>> 16) | 0)))
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.toString__T = (function() {
  var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  $n($n($n($n($n($n($n(buf.append__T__scm_StringBuilder("Transition[")).append__T__scm_StringBuilder((this.isGap__Z() ? "Gap" : "Overlap"))).append__T__scm_StringBuilder(" at ")).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransition__f_transition)).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore)).append__T__scm_StringBuilder(" to ")).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter)).append__C__scm_StringBuilder(93);
  return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_zone_ZoneOffsetTransition(that);
  var this$2 = $n($n(this.Ljava_time_zone_ZoneOffsetTransition__f_transition).toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore));
  var this$1 = $n(other);
  var other$1 = $n(this$1.Ljava_time_zone_ZoneOffsetTransition__f_transition).toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(this$1.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  return this$2.compare__Ljava_time_Instant__I(other$1)
});
function $as_Ljava_time_zone_ZoneOffsetTransition(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneOffsetTransition) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneOffsetTransition"))
}
function $isArrayOf_Ljava_time_zone_ZoneOffsetTransition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneOffsetTransition)))
}
function $asArrayOf_Ljava_time_zone_ZoneOffsetTransition(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneOffsetTransition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneOffsetTransition;", depth))
}
var $d_Ljava_time_zone_ZoneOffsetTransition = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransition: 0
}, false, "java.time.zone.ZoneOffsetTransition", {
  Ljava_time_zone_ZoneOffsetTransition: 1,
  O: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransition;
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype = new $h_jl_Enum();
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition() {
  /*<skip>*/
}
$h_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype = $c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype;
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype.createDateTime__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime = (function(dateTime, standardOffset, wallOffset) {
  var x = $m_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$().UTC__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $$x1 = (this$1 === this)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var this$2 = $n(wallOffset);
    var $$x2 = this$2.Ljava_time_ZoneOffset__f_totalSeconds;
    var this$3 = $n($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var difference = (($$x2 - this$3.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
    var this$5 = $n(dateTime);
    var hi = (difference >> 31);
    return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$5, this$5.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(difference, hi), $L0, 1)
  } else {
    var x$3 = $m_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition$().STANDARD__Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition();
    if ((x$3 !== null)) {
      var this$6 = $n(x$3);
      var $$x3 = (this$6 === this)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var this$7 = $n(wallOffset);
      var $$x4 = this$7.Ljava_time_ZoneOffset__f_totalSeconds;
      var this$8 = $n(standardOffset);
      var difference$2 = (($$x4 - this$8.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
      var this$10 = $n(dateTime);
      var hi$1 = (difference$2 >> 31);
      return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$10, this$10.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(difference$2, hi$1), $L0, 1)
    } else {
      return dateTime
    }
  }
});
var $d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition = new $TypeData().initClass({
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition: 0
}, false, "java.time.zone.ZoneOffsetTransitionRule$TimeDefinition", {
  Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition.prototype.$classData = $d_Ljava_time_zone_ZoneOffsetTransitionRule$TimeDefinition;
function $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V($thiz) {
  if (($thiz.ju_AbstractRandomAccessListIterator__f_last === (-1))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException())
  }
}
function $ct_ju_AbstractRandomAccessListIterator__I__I__I__($thiz, i, start, end) {
  $thiz.ju_AbstractRandomAccessListIterator__f_i = i;
  $thiz.ju_AbstractRandomAccessListIterator__f_end = end;
  $thiz.ju_AbstractRandomAccessListIterator__f_last = (-1);
  return $thiz
}
/** @constructor */
function $c_ju_AbstractRandomAccessListIterator() {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0
}
$c_ju_AbstractRandomAccessListIterator.prototype = new $h_O();
$c_ju_AbstractRandomAccessListIterator.prototype.constructor = $c_ju_AbstractRandomAccessListIterator;
/** @constructor */
function $h_ju_AbstractRandomAccessListIterator() {
  /*<skip>*/
}
$h_ju_AbstractRandomAccessListIterator.prototype = $c_ju_AbstractRandomAccessListIterator.prototype;
$c_ju_AbstractRandomAccessListIterator.prototype.hasNext__Z = (function() {
  return (this.ju_AbstractRandomAccessListIterator__f_i < this.ju_AbstractRandomAccessListIterator__f_end)
});
$c_ju_AbstractRandomAccessListIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  this.ju_AbstractRandomAccessListIterator__f_last = this.ju_AbstractRandomAccessListIterator__f_i;
  this.ju_AbstractRandomAccessListIterator__f_i = ((1 + this.ju_AbstractRandomAccessListIterator__f_i) | 0);
  return this.get__I__O(this.ju_AbstractRandomAccessListIterator__f_last)
});
$c_ju_AbstractRandomAccessListIterator.prototype.remove__V = (function() {
  $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V(this);
  this.remove__I__V(this.ju_AbstractRandomAccessListIterator__f_last);
  if ((this.ju_AbstractRandomAccessListIterator__f_last < this.ju_AbstractRandomAccessListIterator__f_i)) {
    this.ju_AbstractRandomAccessListIterator__f_i = (((-1) + this.ju_AbstractRandomAccessListIterator__f_i) | 0)
  };
  this.ju_AbstractRandomAccessListIterator__f_last = (-1);
  this.ju_AbstractRandomAccessListIterator__f_end = (((-1) + this.ju_AbstractRandomAccessListIterator__f_end) | 0)
});
$c_ju_AbstractRandomAccessListIterator.prototype.set__O__V = (function(e) {
  $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V(this);
  this.set__I__O__V(this.ju_AbstractRandomAccessListIterator__f_last, e)
});
function $ct_ju_Date__J__($thiz, millis) {
  $thiz.ju_Date__f_java$util$Date$$millis = millis;
  return $thiz
}
function $ct_ju_Date__($thiz) {
  var this$1 = $m_RTLong$();
  var value = $uD(Date.now());
  var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  $ct_ju_Date__J__($thiz, new $c_RTLong(lo, hi));
  return $thiz
}
/** @constructor */
function $c_ju_Date() {
  this.ju_Date__f_java$util$Date$$millis = $L0
}
$c_ju_Date.prototype = new $h_O();
$c_ju_Date.prototype.constructor = $c_ju_Date;
/** @constructor */
function $h_ju_Date() {
  /*<skip>*/
}
$h_ju_Date.prototype = $c_ju_Date.prototype;
$c_ju_Date.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_ju_Date)) {
    var x2 = $as_ju_Date(obj);
    var this$1 = $n(x2).ju_Date__f_java$util$Date$$millis;
    var b = this.ju_Date__f_java$util$Date$$millis;
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return false
  }
});
$c_ju_Date.prototype.hashCode__I = (function() {
  var this$1 = this.ju_Date__f_java$util$Date$$millis;
  return (this$1.RTLong__f_lo ^ this$1.RTLong__f_hi)
});
$c_ju_Date.prototype.java$util$Date$$asDate__O = (function() {
  var this$1 = this.ju_Date__f_java$util$Date$$millis;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-2011657)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= (-1121714176)) : (ahi > (-2011657)))) {
    var this$2 = this.ju_Date__f_java$util$Date$$millis;
    var ahi$1 = this$2.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 2011656) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= 1121714176) : (ahi$1 < 2011656))
  } else {
    var $$x1 = false
  };
  if ((!$$x1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("cannot convert this java.util.Date (" + this.ju_Date__f_java$util$Date$$millis) + " millis) to a js.Date"))
  };
  var $$x2 = Date;
  var this$3 = this.ju_Date__f_java$util$Date$$millis;
  return new $$x2($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$3.RTLong__f_lo, this$3.RTLong__f_hi))
});
$c_ju_Date.prototype.toString__T = (function() {
  var this$1 = this.ju_Date__f_java$util$Date$$millis;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-2011657)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= (-1121714176)) : (ahi > (-2011657)))) {
    var this$2 = this.ju_Date__f_java$util$Date$$millis;
    var ahi$1 = this$2.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 2011656) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= 1121714176) : (ahi$1 < 2011656))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var date = this.java$util$Date$$asDate__O();
    var offset = ((-$doubleToInt($uD(date.getTimezoneOffset()))) | 0);
    $m_ju_Date$().java$util$Date$$pad0__I__T(((((offset < 0) ? ((-offset) | 0) : offset) / 60) | 0));
    $m_ju_Date$().java$util$Date$$pad0__I__T(((((offset < 0) ? ((-offset) | 0) : offset) % 60) | 0));
    return (((((((((((($n($m_ju_Date$().ju_Date$__f_java$util$Date$$Days).get($doubleToInt($uD(date.getDay()))) + " ") + $n($m_ju_Date$().ju_Date$__f_java$util$Date$$Months).get($doubleToInt($uD(date.getMonth())))) + " ") + $m_ju_Date$().java$util$Date$$pad0__I__T($doubleToInt($uD(date.getDate())))) + " ") + $m_ju_Date$().java$util$Date$$pad0__I__T($doubleToInt($uD(date.getHours())))) + ":") + $m_ju_Date$().java$util$Date$$pad0__I__T($doubleToInt($uD(date.getMinutes())))) + ":") + $m_ju_Date$().java$util$Date$$pad0__I__T($doubleToInt($uD(date.getSeconds())))) + " GMT ") + $doubleToInt($uD(date.getFullYear())))
  } else {
    return (("java.util.Date(" + this.ju_Date__f_java$util$Date$$millis) + ")")
  }
});
$c_ju_Date.prototype.compareTo__O__I = (function(o) {
  var anotherDate = $as_ju_Date(o);
  var this$1 = this.ju_Date__f_java$util$Date$$millis;
  var b = $n(anotherDate).ju_Date__f_java$util$Date$$millis;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this$1.RTLong__f_lo, this$1.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi)
});
function $as_ju_Date(obj) {
  return (((obj instanceof $c_ju_Date) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Date"))
}
function $isArrayOf_ju_Date(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Date)))
}
function $asArrayOf_ju_Date(obj, depth) {
  return (($isArrayOf_ju_Date(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Date;", depth))
}
var $d_ju_Date = new $TypeData().initClass({
  ju_Date: 0
}, false, "java.util.Date", {
  ju_Date: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1,
  jl_Comparable: 1
});
$c_ju_Date.prototype.$classData = $d_ju_Date;
function $p_ju_Formatter__sendToDest__T__V($thiz, s) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (("" + $thiz.ju_Formatter__f_stringOutput) + s)
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s])
  }
}
function $p_ju_Formatter__sendToDest__T__T__V($thiz, s1, s2) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = ((("" + $thiz.ju_Formatter__f_stringOutput) + s1) + s2)
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2])
  }
}
function $p_ju_Formatter__sendToDest__T__T__T__V($thiz, s1, s2, s3) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (($thiz.ju_Formatter__f_stringOutput + (("" + s1) + s2)) + s3)
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2, s3])
  }
}
function $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, ss) {
  try {
    var len = $uI(ss.length);
    var i = 0;
    while ((i !== len)) {
      var x$1$2 = ss[i];
      var x$1 = $as_T(x$1$2);
      $n($thiz.ju_Formatter__f_dest).append__jl_CharSequence__jl_Appendable(x$1);
      i = ((1 + i) | 0)
    }
  } catch (e) {
    if (false) {
      $as_Ljava_io_IOException(e)
    } else {
      throw e
    }
  }
}
function $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter($thiz, localeInfo, format, args) {
  if ($thiz.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException()
  };
  var lastImplicitArgIndex = 0;
  var lastArgIndex = 0;
  var this$1 = $n(format);
  var fmtLength = this$1.length;
  var fmtIndex = 0;
  while ((fmtIndex !== fmtLength)) {
    var this$2 = $n(format);
    var fromIndex = fmtIndex;
    var nextPercentIndex = $uI(this$2.indexOf("%", fromIndex));
    if ((nextPercentIndex < 0)) {
      var this$3 = $n(format);
      var beginIndex = fmtIndex;
      if (((beginIndex < 0) || (beginIndex > this$3.length))) {
        $charAt(this$3, beginIndex)
      };
      $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(this$3.substring(beginIndex)));
      return $thiz
    };
    var this$4 = $n(format);
    var beginIndex$1 = fmtIndex;
    if ((beginIndex$1 < 0)) {
      $charAt(this$4, beginIndex$1)
    };
    if ((nextPercentIndex > this$4.length)) {
      $charAt(this$4, nextPercentIndex)
    };
    if ((nextPercentIndex < beginIndex$1)) {
      $charAt(this$4, (-1))
    };
    $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(this$4.substring(beginIndex$1, nextPercentIndex)));
    var formatSpecifierIndex = ((1 + nextPercentIndex) | 0);
    var re = $m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$FormatSpecifier;
    re.lastIndex = formatSpecifierIndex;
    var execResult = re.exec(format);
    if (((execResult === null) || ($uI(execResult.index) !== formatSpecifierIndex))) {
      if ((formatSpecifierIndex === fmtLength)) {
        var conversion = 37
      } else {
        var this$5 = $n(format);
        var conversion = $charAt(this$5, formatSpecifierIndex)
      };
      $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion)
    };
    fmtIndex = $uI(re.lastIndex);
    var this$6 = $n(format);
    var index = (((-1) + fmtIndex) | 0);
    var conversion$2 = $charAt(this$6, index);
    var flags = $p_ju_Formatter__parseFlags__T__C__I($thiz, $as_T(execResult[2]), conversion$2);
    var width = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[3]);
    var precision = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[4]);
    if ((width === (-2))) {
      $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, (-2147483648))
    };
    if ((precision === (-2))) {
      $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, (-2147483648))
    };
    if ((conversion$2 === 110)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision)
      };
      if ((width !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width)
      };
      if ((flags !== 0)) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags)
      };
      $p_ju_Formatter__sendToDest__T__V($thiz, "\n")
    } else if ((conversion$2 === 37)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision)
      };
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags)
      };
      if ((((1 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__O__T($thiz, execResult))
      };
      if ((((-2) & flags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(37, flags, (-2))
      };
      $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, "%")
    } else {
      var conversionLower = (((256 & flags) !== 0) ? (65535 & ((32 + conversion$2) | 0)) : conversion$2);
      var illegalFlags = $n($m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags).get((((-97) + conversionLower) | 0));
      if (((illegalFlags === (-1)) || (((256 & flags) & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion$2)
      };
      if ((((17 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__O__T($thiz, execResult))
      };
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags)
      };
      if (((precision !== (-1)) && ((512 & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision)
      };
      if (((flags & illegalFlags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, illegalFlags)
      };
      if (((128 & flags) !== 0)) {
        var argIndex = lastArgIndex
      } else {
        var i = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[1]);
        if ((i === (-1))) {
          lastImplicitArgIndex = ((1 + lastImplicitArgIndex) | 0);
          var argIndex = lastImplicitArgIndex
        } else {
          if ((i <= 0)) {
            $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, i)
          };
          var argIndex = i
        }
      };
      if (((argIndex <= 0) || (argIndex > $n(args).u.length))) {
        $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__O__T($thiz, execResult))
      };
      lastArgIndex = argIndex;
      var arg = $n(args).get((((-1) + argIndex) | 0));
      if ((((arg === null) && (conversionLower !== 98)) && (conversionLower !== 115))) {
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, "null")
      } else {
        $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision)
      }
    }
  };
  return $thiz
}
function $p_ju_Formatter__parseFlags__T__C__I($thiz, flags, conversion) {
  var bits = (((conversion >= 65) && (conversion <= 90)) ? 256 : 0);
  var this$1 = $n(flags);
  var len = this$1.length;
  var i = 0;
  while ((i !== len)) {
    var this$2 = $n(flags);
    var index = i;
    var f = $charAt(this$2, index);
    switch (f) {
      case 45: {
        var bit = 1;
        break
      }
      case 35: {
        var bit = 2;
        break
      }
      case 43: {
        var bit = 4;
        break
      }
      case 32: {
        var bit = 8;
        break
      }
      case 48: {
        var bit = 16;
        break
      }
      case 44: {
        var bit = 32;
        break
      }
      case 40: {
        var bit = 64;
        break
      }
      case 60: {
        var bit = 128;
        break
      }
      default: {
        var bit;
        throw new $c_jl_AssertionError($bC(f))
      }
    };
    if (((bits & bit) !== 0)) {
      $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, f)
    };
    bits = (bits | bit);
    i = ((1 + i) | 0)
  };
  return bits
}
function $p_ju_Formatter__parsePositiveInt__O__I($thiz, capture) {
  if ((capture !== (void 0))) {
    var s = $as_T(capture);
    var x = $uD(parseInt(s, 10));
    return ((x <= 2.147483647E9) ? $doubleToInt(x) : (-2))
  } else {
    return (-1)
  }
}
function $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision) {
  switch (conversionLower) {
    case 98: {
      var str = (((arg === false) || (arg === null)) ? "false" : "true");
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str);
      break
    }
    case 104: {
      var i = $dp_hashCode__I($n(arg));
      var str$2 = $as_T($uD((i >>> 0.0)).toString(16));
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str$2);
      break
    }
    case 115: {
      if ($is_ju_Formattable(arg)) {
        var x2 = $as_ju_Formattable(arg);
        var formattableFlags = (((((1 & flags) !== 0) ? 1 : 0) | (((2 & flags) !== 0) ? 4 : 0)) | (((256 & flags) !== 0) ? 2 : 0));
        $n(x2).formatTo__ju_Formatter__I__I__I__V($thiz, formattableFlags, width, precision)
      } else {
        if (((2 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 2)
        };
        var str$3 = ("" + arg);
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str$3)
      };
      break
    }
    case 99: {
      if ((arg instanceof $Char)) {
        var x2$2 = $uC(arg);
        var str$4 = $as_T(String.fromCharCode(x2$2))
      } else {
        if ((!$isInt(arg))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
        };
        var x3 = $uI(arg);
        if ((!((x3 >= 0) && (x3 <= 1114111)))) {
          $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, x3)
        };
        var str$4 = ((x3 < 65536) ? $as_T(String.fromCharCode(x3)) : $as_T(String.fromCharCode((55296 | (((-64) + (x3 >> 10)) | 0)), (56320 | (1023 & x3)))))
      };
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, (-1), str$4);
      break
    }
    case 100: {
      if ($isInt(arg)) {
        var x2$3 = $uI(arg);
        var str$5 = ("" + x2$3)
      } else if ((arg instanceof $c_RTLong)) {
        var t = $uJ(arg);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var str$5 = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi)
      } else {
        if ((!(arg instanceof $c_Ljava_math_BigInteger))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
        };
        var x4 = $as_Ljava_math_BigInteger(arg);
        var this$10 = $n(x4);
        var str$5 = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$10)
      };
      $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str$5, "");
      break
    }
    case 111:
    case 120: {
      var isOctal = (conversionLower === 111);
      var prefix = (((2 & flags) === 0) ? "" : (isOctal ? "0" : (((256 & flags) !== 0) ? "0X" : "0x")));
      if ((arg instanceof $c_Ljava_math_BigInteger)) {
        var x2$4 = $as_Ljava_math_BigInteger(arg);
        var radix = (isOctal ? 8 : 16);
        var $$x1 = $m_ju_Formatter$RootLocaleInfo$();
        var this$13 = $n(x2$4);
        $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $$x1, flags, width, $m_Ljava_math_Conversion$().bigInteger2String__Ljava_math_BigInteger__I__T(this$13, radix), prefix)
      } else {
        if ($isInt(arg)) {
          var x2$5 = $uI(arg);
          var str$6 = (isOctal ? $as_T($uD((x2$5 >>> 0.0)).toString(8)) : $as_T($uD((x2$5 >>> 0.0)).toString(16)))
        } else {
          if ((!(arg instanceof $c_RTLong))) {
            $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
          };
          var t$1 = $uJ(arg);
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          if (isOctal) {
            var this$16 = $m_jl_Long$();
            var str$6 = this$16.java$lang$Long$$toOctalString__I__I__T(lo$1, hi$1)
          } else {
            var this$17 = $m_jl_Long$();
            var str$6 = this$17.java$lang$Long$$toHexString__I__I__T(lo$1, hi$1)
          }
        };
        if (((76 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 76)
        };
        $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str$6))
      };
      break
    }
    case 101:
    case 102:
    case 103: {
      if (((typeof arg) === "number")) {
        var x2$6 = $uD(arg);
        if (((x2$6 !== x2$6) || ((x2$6 === Infinity) || (x2$6 === (-Infinity))))) {
          $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x2$6)
        } else {
          $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal(x2$6), flags, precision, conversionLower, localeInfo, width)
        }
      } else if ((arg instanceof $c_Ljava_math_BigDecimal)) {
        var x3$4 = $as_Ljava_math_BigDecimal(arg);
        $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal(x3$4), flags, precision, conversionLower, localeInfo, width)
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
      };
      break
    }
    case 97: {
      if (((typeof arg) === "number")) {
        var x2$7 = $uD(arg);
        $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, x2$7)
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
      };
      break
    }
    default: {
      throw new $c_jl_AssertionError((("Unknown conversion '" + $bC(conversionLower)) + "' was not rejected earlier"))
    }
  }
}
function $p_ju_Formatter__flagsToString__I__T($thiz, flags) {
  return ((((((((((1 & flags) !== 0) ? "-" : "") + (((2 & flags) !== 0) ? "#" : "")) + (((4 & flags) !== 0) ? "+" : "")) + (((8 & flags) !== 0) ? " " : "")) + (((16 & flags) !== 0) ? "0" : "")) + (((32 & flags) !== 0) ? "," : "")) + (((64 & flags) !== 0) ? "(" : "")) + (((128 & flags) !== 0) ? "<" : ""))
}
function $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, digitsAfterDot, forceDecimalSep) {
  var rounded = $n(x).round__I__ju_Formatter$Decimal(((1 + digitsAfterDot) | 0));
  var signStr = ($n(rounded).ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = $n(rounded).ju_Formatter$Decimal__f_unscaledValue;
  var this$1 = $n(intStr);
  var fractionalDigitCount = (((-1) + this$1.length) | 0);
  var missingZeros = ((digitsAfterDot - fractionalDigitCount) | 0);
  var this$2 = $n(intStr);
  if ((this$2.length < 1)) {
    $charAt(this$2, 1)
  };
  var integerPart = $as_T(this$2.substring(0, 1));
  var this$3 = $n(intStr);
  if ((this$3.length < 1)) {
    $charAt(this$3, 1)
  };
  var fractionalPart = (("" + $as_T(this$3.substring(1))) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(missingZeros));
  var significandStr = (((fractionalPart === "") && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + fractionalPart));
  var exponent = ((fractionalDigitCount - $n(rounded).ju_Formatter$Decimal__f_scale) | 0);
  var exponentSign = ((exponent < 0) ? "-" : "+");
  var this$5 = ((exponent < 0) ? ((-exponent) | 0) : exponent);
  var exponentAbsStr0 = ("" + this$5);
  var exponentAbsStr = ((exponentAbsStr0.length === 1) ? ("0" + exponentAbsStr0) : exponentAbsStr0);
  return ((((signStr + significandStr) + "e") + exponentSign) + exponentAbsStr)
}
function $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, scale, forceDecimalSep) {
  var rounded = $n(x).setScale__I__ju_Formatter$Decimal(scale);
  var signStr = ($n(rounded).ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = $n(rounded).ju_Formatter$Decimal__f_unscaledValue;
  var this$1 = $n(intStr);
  var intStrLen = this$1.length;
  var minDigits = ((1 + scale) | 0);
  var expandedIntStr = ((intStrLen >= minDigits) ? intStr : (("" + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((minDigits - intStrLen) | 0))) + intStr));
  var this$2 = $n(expandedIntStr);
  var dotPos = ((this$2.length - scale) | 0);
  var this$3 = $n(expandedIntStr);
  if ((dotPos > this$3.length)) {
    $charAt(this$3, dotPos)
  };
  if ((dotPos < 0)) {
    $charAt(this$3, (-1))
  };
  var integerPart = (signStr + $as_T(this$3.substring(0, dotPos)));
  if (((scale === 0) && (!forceDecimalSep))) {
    return integerPart
  } else {
    var this$4 = $n(expandedIntStr);
    if (((dotPos < 0) || (dotPos > this$4.length))) {
      $charAt(this$4, dotPos)
    };
    return ((integerPart + ".") + $as_T(this$4.substring(dotPos)))
  }
}
function $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, precision, forceDecimalSep) {
  var p = ((precision === 0) ? 1 : precision);
  var rounded = $n(x).round__I__ju_Formatter$Decimal(p);
  var this$1 = $n(rounded);
  var this$2 = $n(this$1.ju_Formatter$Decimal__f_unscaledValue);
  var orderOfMagnitude = (((((-1) + this$2.length) | 0) - $n(rounded).ju_Formatter$Decimal__f_scale) | 0);
  if (((orderOfMagnitude >= (-4)) && (orderOfMagnitude < p))) {
    var b = (((-1) + ((p - orderOfMagnitude) | 0)) | 0);
    return $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((b < 0) ? 0 : b), forceDecimalSep)
  } else {
    return $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, (((-1) + p) | 0), forceDecimalSep)
  }
}
function $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, arg) {
  if (((arg !== arg) || ((arg === Infinity) || (arg === (-Infinity))))) {
    $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, arg)
  } else {
    var t = $m_jl_FloatingPointBits$().doubleToLongBits__D__J(arg);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var negative = (hi < 0);
    var hi$1 = (1048575 & hi);
    var lo$1 = ((hi >>> 20) | 0);
    var biasedExponent = (2047 & lo$1);
    var actualPrecision = ((precision === 0) ? 1 : ((precision > 12) ? (-1) : precision));
    var signStr = (negative ? "-" : (((4 & flags) !== 0) ? "+" : (((8 & flags) !== 0) ? " " : "")));
    if ((biasedExponent === 0)) {
      if (((lo === 0) && (hi$1 === 0))) {
        var x1___1 = "0";
        var x1___2 = $L0;
        var x1___3 = 0
      } else if ((actualPrecision === (-1))) {
        var x1___1 = "0";
        var x1___2 = new $c_RTLong(lo, hi$1);
        var x1___3 = (-1022)
      } else {
        var leadingZeros = ((hi$1 !== 0) ? $uI(Math.clz32(hi$1)) : ((32 + $uI(Math.clz32(lo))) | 0));
        var shift = (((-11) + leadingZeros) | 0);
        var lo$2 = (((32 & shift) === 0) ? (lo << shift) : 0);
        var hi$2 = (((32 & shift) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - shift) | 0)) | 0) | (hi$1 << shift)) : (lo << shift));
        var hi$3 = (1048575 & hi$2);
        var normalizedExponent = (((-1022) - shift) | 0);
        var x1___1 = "1";
        var x1___2 = new $c_RTLong(lo$2, hi$3);
        var x1___3 = normalizedExponent
      }
    } else {
      var _3 = (((-1023) + biasedExponent) | 0);
      var x1___1 = "1";
      var x1___2 = new $c_RTLong(lo, hi$1);
      var x1___3 = _3
    };
    var implicitBitStr = $as_T(x1___1);
    var t$1 = $uJ(x1___2);
    var lo$3 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    var exponent = $uI(x1___3);
    var t$2 = $uJ(new $c_RTLong(lo$3, hi$4));
    var lo$4 = t$2.RTLong__f_lo;
    var hi$5 = t$2.RTLong__f_hi;
    if ((actualPrecision === (-1))) {
      var roundedMantissa__lo = lo$4;
      var roundedMantissa__hi = hi$5
    } else {
      var n = ((52 - (actualPrecision << 2)) | 0);
      var lo$5 = (((32 & n) === 0) ? (1 << n) : 0);
      var hi$6 = (((32 & n) === 0) ? 0 : (1 << n));
      var lo$6 = (((-1) + lo$5) | 0);
      var hi$7 = ((lo$6 !== (-1)) ? hi$6 : (((-1) + hi$6) | 0));
      var lo$7 = (((lo$5 >>> 1) | 0) | (hi$6 << 31));
      var hi$8 = (hi$6 >> 1);
      var lo$8 = (~lo$6);
      var hi$9 = (~hi$7);
      var lo$9 = (lo$4 & lo$8);
      var hi$10 = (hi$5 & hi$9);
      var lo$10 = (lo$4 & lo$6);
      var hi$11 = (hi$5 & hi$7);
      if (((hi$11 === hi$8) ? (((-2147483648) ^ lo$10) < ((-2147483648) ^ lo$7)) : (hi$11 < hi$8))) {
        var roundedMantissa__lo = lo$9;
        var roundedMantissa__hi = hi$10
      } else if (((hi$11 === hi$8) ? (((-2147483648) ^ lo$10) > ((-2147483648) ^ lo$7)) : (hi$11 > hi$8))) {
        var lo$11 = ((lo$9 + lo$5) | 0);
        var hi$12 = ((((-2147483648) ^ lo$11) < ((-2147483648) ^ lo$9)) ? ((1 + ((hi$10 + hi$6) | 0)) | 0) : ((hi$10 + hi$6) | 0));
        var roundedMantissa__lo = lo$11;
        var roundedMantissa__hi = hi$12
      } else {
        var lo$12 = (lo$9 & lo$5);
        var hi$13 = (hi$10 & hi$6);
        if (((lo$12 === 0) && (hi$13 === 0))) {
          var roundedMantissa__lo = lo$9;
          var roundedMantissa__hi = hi$10
        } else {
          var lo$13 = ((lo$9 + lo$5) | 0);
          var hi$14 = ((((-2147483648) ^ lo$13) < ((-2147483648) ^ lo$9)) ? ((1 + ((hi$10 + hi$6) | 0)) | 0) : ((hi$10 + hi$6) | 0));
          var roundedMantissa__lo = lo$13;
          var roundedMantissa__hi = hi$14
        }
      }
    };
    var this$12 = $m_jl_Long$();
    var hi$15 = roundedMantissa__hi;
    var baseStr = this$12.java$lang$Long$$toHexString__I__I__T(roundedMantissa__lo, hi$15);
    var this$13 = $n(baseStr);
    var beginIndex = this$13.length;
    if (((beginIndex < 0) || (beginIndex > 13))) {
      $charAt("0000000000000", beginIndex)
    };
    var padded = (("" + $as_T("0000000000000".substring(beginIndex))) + baseStr);
    $m_ju_Formatter$();
    var condition = (padded.length === 13);
    if ((!condition)) {
      throw new $c_jl_AssertionError("padded mantissa does not have the right number of bits")
    };
    var minLength = ((actualPrecision < 1) ? 1 : actualPrecision);
    var len = padded.length;
    while (true) {
      if ((len > minLength)) {
        var index = (((-1) + len) | 0);
        var $$x1 = ($charAt(padded, index) === 48)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        len = (((-1) + len) | 0)
      } else {
        break
      }
    };
    var endIndex = len;
    if ((endIndex > padded.length)) {
      $charAt(padded, endIndex)
    };
    if ((endIndex < 0)) {
      $charAt(padded, (-1))
    };
    var mantissaStr = $as_T(padded.substring(0, endIndex));
    var exponentStr = ("" + exponent);
    var prefix = (signStr + (((256 & flags) !== 0) ? "0X" : "0x"));
    var rest = ((((implicitBitStr + ".") + mantissaStr) + "p") + exponentStr);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest))
  }
}
function $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str) {
  if ((precision < 0)) {
    var $$x1 = true
  } else {
    var this$1 = $n(str);
    var $$x1 = (precision >= this$1.length)
  };
  if ($$x1) {
    var truncatedStr = str
  } else {
    var this$2 = $n(str);
    if ((precision > this$2.length)) {
      $charAt(this$2, precision)
    };
    if ((precision < 0)) {
      $charAt(this$2, (-1))
    };
    var truncatedStr = $as_T(this$2.substring(0, precision))
  };
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, truncatedStr))
}
function $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x) {
  var str = ((x !== x) ? "NaN" : ((x > 0.0) ? (((4 & flags) !== 0) ? "+Infinity" : (((8 & flags) !== 0) ? " Infinity" : "Infinity")) : (((64 & flags) !== 0) ? "(Infinity)" : "-Infinity")));
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str))
}
function $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str, basePrefix) {
  var this$1 = $n(str);
  if (((this$1.length >= width) && ((110 & flags) === 0))) {
    $n(localeInfo);
    var str$1 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str);
    $p_ju_Formatter__sendToDest__T__V($thiz, str$1)
  } else if (((126 & flags) === 0)) {
    $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str))
  } else {
    var this$5 = $n(str);
    if (($charAt(this$5, 0) !== 45)) {
      if (((4 & flags) !== 0)) {
        var x1___1 = "+";
        var x1___2 = str
      } else if (((8 & flags) !== 0)) {
        var x1___1 = " ";
        var x1___2 = str
      } else {
        var x1___1 = "";
        var x1___2 = str
      }
    } else if (((64 & flags) !== 0)) {
      var this$9 = $n(str);
      if ((this$9.length < 1)) {
        $charAt(this$9, 1)
      };
      var _2 = ($as_T(this$9.substring(1)) + ")");
      var x1___1 = "(";
      var x1___2 = _2
    } else {
      var this$10 = $n(str);
      if ((this$10.length < 1)) {
        $charAt(this$10, 1)
      };
      var _2$1 = $as_T(this$10.substring(1));
      var x1___1 = "-";
      var x1___2 = _2$1
    };
    var numberPrefix = $as_T(x1___1);
    var rest0 = $as_T(x1___2);
    var prefix = (("" + numberPrefix) + basePrefix);
    var rest = (((32 & flags) !== 0) ? $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, rest0) : rest0);
    $n(localeInfo);
    var str$2 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str$2)
  }
}
function $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, s) {
  $n(localeInfo);
  var groupingSize = 3;
  var this$1 = $n(s);
  var len = this$1.length;
  var index = 0;
  while (true) {
    if ((index !== len)) {
      var this$2 = $n(s);
      var index$1 = index;
      var c = $charAt(this$2, index$1);
      var $$x1 = ((c >= 48) && (c <= 57))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index = ((1 + index) | 0)
    } else {
      break
    }
  };
  index = ((index - groupingSize) | 0);
  if ((index <= 0)) {
    return s
  } else {
    var this$3 = $n(s);
    var beginIndex = index;
    if (((beginIndex < 0) || (beginIndex > this$3.length))) {
      $charAt(this$3, beginIndex)
    };
    var result = $as_T(this$3.substring(beginIndex));
    while ((index > groupingSize)) {
      var next = ((index - groupingSize) | 0);
      var this$4 = $n(s);
      var endIndex = index;
      if ((next < 0)) {
        $charAt(this$4, next)
      };
      if ((endIndex > this$4.length)) {
        $charAt(this$4, endIndex)
      };
      if ((endIndex < next)) {
        $charAt(this$4, (-1))
      };
      result = (($as_T(this$4.substring(next, endIndex)) + ",") + result);
      index = next
    };
    var this$5 = $n(s);
    var endIndex$1 = index;
    if ((endIndex$1 > this$5.length)) {
      $charAt(this$5, endIndex$1)
    };
    if ((endIndex$1 < 0)) {
      $charAt(this$5, (-1))
    };
    return (($as_T(this$5.substring(0, endIndex$1)) + ",") + result)
  }
}
function $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str) {
  if (((256 & flags) !== 0)) {
    var this$2 = $n(str);
    return $as_T(this$2.toUpperCase())
  } else {
    return str
  }
}
function $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, str) {
  if (((256 & flags) !== 0)) {
    $n(localeInfo);
    var this$3 = $n(str);
    return $as_T(this$3.toUpperCase())
  } else {
    return str
  }
}
function $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, str) {
  var this$1 = $n(str);
  var len = this$1.length;
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__V($thiz, str)
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)))
  } else {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), str)
  }
}
function $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str) {
  var this$1 = $n(prefix);
  var this$2 = $n(str);
  var len = ((this$1.length + this$2.length) | 0);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, prefix, str)
  } else if (((16 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, $p_ju_Formatter__strRepeat__T__I__T($thiz, ($n(localeInfo), "0"), ((width - len) | 0)), str)
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)))
  } else {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), prefix, str)
  }
}
function $p_ju_Formatter__strRepeat__T__I__T($thiz, s, times) {
  var result = "";
  var i = 0;
  while ((i !== times)) {
    result = (("" + result) + s);
    i = ((1 + i) | 0)
  };
  return result
}
function $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, flag) {
  throw new $c_ju_DuplicateFormatFlagsException($as_T(String.fromCharCode(flag)))
}
function $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion) {
  throw new $c_ju_UnknownFormatConversionException($as_T(String.fromCharCode(conversion)))
}
function $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision) {
  throw new $c_ju_IllegalFormatPrecisionException(precision)
}
function $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width) {
  throw new $c_ju_IllegalFormatWidthException(width)
}
function $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, index) {
  var msg = ((index === 0) ? "Illegal format argument index = 0" : "Format argument index: (not representable as int)");
  throw new $c_ju_IllegalFormatArgumentIndexException(msg)
}
function $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatWidthException(fullFormatSpecifier)
}
function $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatArgumentException(fullFormatSpecifier)
}
function $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, arg) {
  throw new $c_ju_IllegalFormatCodePointException(arg)
}
function $p_ju_Formatter__fullFormatSpecifier$1__O__T($thiz, execResult$1) {
  return ("%" + execResult$1[0])
}
function $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, x, flags$1, precision$1, conversionLower$1, localeInfo$1, width$1) {
  var forceDecimalSep = ((2 & flags$1) !== 0);
  var actualPrecision = ((precision$1 >= 0) ? precision$1 : 6);
  switch (conversionLower$1) {
    case 101: {
      var notation = $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break
    }
    case 102: {
      var notation = $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break
    }
    default: {
      var notation = $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep)
    }
  };
  $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo$1, flags$1, width$1, notation, "")
}
function $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, dest, formatterLocaleInfo) {
  $thiz.ju_Formatter__f_dest = dest;
  $thiz.ju_Formatter__f_formatterLocaleInfo = formatterLocaleInfo;
  $thiz.ju_Formatter__f_stringOutput = "";
  $thiz.ju_Formatter__f_java$util$Formatter$$closed = false;
  return $thiz
}
function $ct_ju_Formatter__($thiz) {
  $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, null, $m_ju_Formatter$RootLocaleInfo$());
  return $thiz
}
/** @constructor */
function $c_ju_Formatter() {
  this.ju_Formatter__f_dest = null;
  this.ju_Formatter__f_formatterLocaleInfo = null;
  this.ju_Formatter__f_stringOutput = null;
  this.ju_Formatter__f_java$util$Formatter$$closed = false
}
$c_ju_Formatter.prototype = new $h_O();
$c_ju_Formatter.prototype.constructor = $c_ju_Formatter;
/** @constructor */
function $h_ju_Formatter() {
  /*<skip>*/
}
$h_ju_Formatter.prototype = $c_ju_Formatter.prototype;
$c_ju_Formatter.prototype.format__T__AO__ju_Formatter = (function(format, args) {
  return $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter(this, this.ju_Formatter__f_formatterLocaleInfo, format, args)
});
$c_ju_Formatter.prototype.toString__T = (function() {
  if (this.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException()
  };
  return ((this.ju_Formatter__f_dest === null) ? this.ju_Formatter__f_stringOutput : $n(this.ju_Formatter__f_dest).toString__T())
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatFlagsException__I__E = (function(flags) {
  throw new $c_ju_IllegalFormatFlagsException($p_ju_Formatter__flagsToString__I__T(this, flags))
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E = (function(conversionLower, flags, illegalFlags) {
  throw new $c_ju_FormatFlagsConversionMismatchException($p_ju_Formatter__flagsToString__I__T(this, (flags & illegalFlags)), conversionLower)
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E = (function(conversionLower, arg) {
  var this$1 = $n(arg);
  throw new $c_ju_IllegalFormatConversionException(conversionLower, $objectGetClass(this$1))
});
var $d_ju_Formatter = new $TypeData().initClass({
  ju_Formatter: 0
}, false, "java.util.Formatter", {
  ju_Formatter: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
});
$c_ju_Formatter.prototype.$classData = $d_ju_Formatter;
/** @constructor */
function $c_ju_Locale$Category(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_ju_Locale$Category.prototype = new $h_jl_Enum();
$c_ju_Locale$Category.prototype.constructor = $c_ju_Locale$Category;
/** @constructor */
function $h_ju_Locale$Category() {
  /*<skip>*/
}
$h_ju_Locale$Category.prototype = $c_ju_Locale$Category.prototype;
function $as_ju_Locale$Category(obj) {
  return (((obj instanceof $c_ju_Locale$Category) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Locale$Category"))
}
function $isArrayOf_ju_Locale$Category(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale$Category)))
}
function $asArrayOf_ju_Locale$Category(obj, depth) {
  return (($isArrayOf_ju_Locale$Category(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Locale$Category;", depth))
}
var $d_ju_Locale$Category = new $TypeData().initClass({
  ju_Locale$Category: 0
}, false, "java.util.Locale$Category", {
  ju_Locale$Category: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Locale$Category.prototype.$classData = $d_ju_Locale$Category;
/** @constructor */
function $c_ju_Locale$LocaleBuilder(strict, language, region, variant, script, extensions, unicodeExtensions, unicodeAttributes) {
  this.ju_Locale$LocaleBuilder__f_strict = false;
  this.ju_Locale$LocaleBuilder__f_language = null;
  this.ju_Locale$LocaleBuilder__f_region = null;
  this.ju_Locale$LocaleBuilder__f_variant = null;
  this.ju_Locale$LocaleBuilder__f_script = null;
  this.ju_Locale$LocaleBuilder__f_extensions = null;
  this.ju_Locale$LocaleBuilder__f_unicodeExtensions = null;
  this.ju_Locale$LocaleBuilder__f_unicodeAttributes = null;
  this.ju_Locale$LocaleBuilder__f_strict = strict;
  this.ju_Locale$LocaleBuilder__f_language = language;
  this.ju_Locale$LocaleBuilder__f_region = region;
  this.ju_Locale$LocaleBuilder__f_variant = variant;
  this.ju_Locale$LocaleBuilder__f_script = script;
  this.ju_Locale$LocaleBuilder__f_extensions = extensions;
  this.ju_Locale$LocaleBuilder__f_unicodeExtensions = unicodeExtensions;
  this.ju_Locale$LocaleBuilder__f_unicodeAttributes = unicodeAttributes
}
$c_ju_Locale$LocaleBuilder.prototype = new $h_O();
$c_ju_Locale$LocaleBuilder.prototype.constructor = $c_ju_Locale$LocaleBuilder;
/** @constructor */
function $h_ju_Locale$LocaleBuilder() {
  /*<skip>*/
}
$h_ju_Locale$LocaleBuilder.prototype = $c_ju_Locale$LocaleBuilder.prototype;
$c_ju_Locale$LocaleBuilder.prototype.language__T__s_Option = (function(language) {
  if ((language === null)) {
    var $$x1 = true
  } else {
    var this$1 = $n(language);
    var $$x1 = (this$1 === "")
  };
  if ($$x1) {
    var x$1 = $m_s_None$();
    var x$2 = this.ju_Locale$LocaleBuilder__f_strict;
    var x$3 = this.ju_Locale$LocaleBuilder__f_region;
    var x$4 = this.ju_Locale$LocaleBuilder__f_variant;
    var x$5 = this.ju_Locale$LocaleBuilder__f_script;
    var x$6 = this.ju_Locale$LocaleBuilder__f_extensions;
    var x$7 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var x$8 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    return new $c_s_Some(new $c_ju_Locale$LocaleBuilder(x$2, x$1, x$3, x$4, x$5, x$6, x$7, x$8))
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkLanguage__T__Z(language))) {
    var this$2 = $n(language);
    var x$9 = new $c_s_Some($as_T(this$2.toLowerCase()));
    var x$10 = this.ju_Locale$LocaleBuilder__f_strict;
    var x$11 = this.ju_Locale$LocaleBuilder__f_region;
    var x$12 = this.ju_Locale$LocaleBuilder__f_variant;
    var x$13 = this.ju_Locale$LocaleBuilder__f_script;
    var x$14 = this.ju_Locale$LocaleBuilder__f_extensions;
    var x$15 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var x$16 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    return new $c_s_Some(new $c_ju_Locale$LocaleBuilder(x$10, x$9, x$11, x$12, x$13, x$14, x$15, x$16))
  } else {
    return $m_s_None$()
  }
});
$c_ju_Locale$LocaleBuilder.prototype.script__T__s_Option = (function(script) {
  if ((script === null)) {
    var $$x1 = true
  } else {
    var this$1 = $n(script);
    var $$x1 = (this$1 === "")
  };
  if ($$x1) {
    var x$1 = $m_s_None$();
    var x$2 = this.ju_Locale$LocaleBuilder__f_strict;
    var x$3 = this.ju_Locale$LocaleBuilder__f_language;
    var x$4 = this.ju_Locale$LocaleBuilder__f_region;
    var x$5 = this.ju_Locale$LocaleBuilder__f_variant;
    var x$6 = this.ju_Locale$LocaleBuilder__f_extensions;
    var x$7 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var x$8 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    return new $c_s_Some(new $c_ju_Locale$LocaleBuilder(x$2, x$3, x$4, x$5, x$1, x$6, x$7, x$8))
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkScript__T__Z(script))) {
    var this$2 = $n(script);
    var c = $charAt(this$2, 0);
    var $$x2 = $m_jl_Character$().toUpperCase__C__C(c);
    var this$5 = $n(script);
    if ((this$5.length < 1)) {
      $charAt(this$5, 1)
    };
    var x$9 = new $c_s_Some((("" + $bC($$x2)) + $as_T(this$5.substring(1))));
    var x$10 = this.ju_Locale$LocaleBuilder__f_strict;
    var x$11 = this.ju_Locale$LocaleBuilder__f_language;
    var x$12 = this.ju_Locale$LocaleBuilder__f_region;
    var x$13 = this.ju_Locale$LocaleBuilder__f_variant;
    var x$14 = this.ju_Locale$LocaleBuilder__f_extensions;
    var x$15 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var x$16 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    return new $c_s_Some(new $c_ju_Locale$LocaleBuilder(x$10, x$11, x$12, x$13, x$9, x$14, x$15, x$16))
  } else {
    return $m_s_None$()
  }
});
$c_ju_Locale$LocaleBuilder.prototype.region__T__s_Option = (function(region) {
  if ((region === null)) {
    var $$x1 = true
  } else {
    var this$1 = $n(region);
    var $$x1 = (this$1 === "")
  };
  if ($$x1) {
    var x$1 = $m_s_None$();
    var x$2 = this.ju_Locale$LocaleBuilder__f_strict;
    var x$3 = this.ju_Locale$LocaleBuilder__f_language;
    var x$4 = this.ju_Locale$LocaleBuilder__f_variant;
    var x$5 = this.ju_Locale$LocaleBuilder__f_script;
    var x$6 = this.ju_Locale$LocaleBuilder__f_extensions;
    var x$7 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var x$8 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    return new $c_s_Some(new $c_ju_Locale$LocaleBuilder(x$2, x$3, x$1, x$4, x$5, x$6, x$7, x$8))
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkRegion__T__Z(region))) {
    var this$2 = $n(region);
    var x$9 = new $c_s_Some($as_T(this$2.toUpperCase()));
    var x$10 = this.ju_Locale$LocaleBuilder__f_strict;
    var x$11 = this.ju_Locale$LocaleBuilder__f_language;
    var x$12 = this.ju_Locale$LocaleBuilder__f_variant;
    var x$13 = this.ju_Locale$LocaleBuilder__f_script;
    var x$14 = this.ju_Locale$LocaleBuilder__f_extensions;
    var x$15 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var x$16 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    return new $c_s_Some(new $c_ju_Locale$LocaleBuilder(x$10, x$11, x$9, x$12, x$13, x$14, x$15, x$16))
  } else {
    return $m_s_None$()
  }
});
$c_ju_Locale$LocaleBuilder.prototype.variant__T__s_Option = (function(variant) {
  if ((variant === null)) {
    var $$x1 = true
  } else {
    var this$1 = $n(variant);
    var $$x1 = (this$1 === "")
  };
  if ($$x1) {
    var x$1 = $m_s_None$();
    var x$2 = this.ju_Locale$LocaleBuilder__f_strict;
    var x$3 = this.ju_Locale$LocaleBuilder__f_language;
    var x$4 = this.ju_Locale$LocaleBuilder__f_region;
    var x$5 = this.ju_Locale$LocaleBuilder__f_script;
    var x$6 = this.ju_Locale$LocaleBuilder__f_extensions;
    var x$7 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var x$8 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    return new $c_s_Some(new $c_ju_Locale$LocaleBuilder(x$2, x$3, x$4, x$1, x$5, x$6, x$7, x$8))
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkVariant__T__Z(variant))) {
    var this$2 = $n(variant);
    var x$9 = new $c_s_Some($as_T(this$2.split("-").join("_")));
    var x$10 = this.ju_Locale$LocaleBuilder__f_strict;
    var x$11 = this.ju_Locale$LocaleBuilder__f_language;
    var x$12 = this.ju_Locale$LocaleBuilder__f_region;
    var x$13 = this.ju_Locale$LocaleBuilder__f_script;
    var x$14 = this.ju_Locale$LocaleBuilder__f_extensions;
    var x$15 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var x$16 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    return new $c_s_Some(new $c_ju_Locale$LocaleBuilder(x$10, x$11, x$12, x$9, x$13, x$14, x$15, x$16))
  } else {
    return $m_s_None$()
  }
});
$c_ju_Locale$LocaleBuilder.prototype.build__ju_Locale = (function() {
  var this$1 = $n(this.ju_Locale$LocaleBuilder__f_language);
  var $$x2 = $as_T((this$1.isEmpty__Z() ? "" : this$1.get__O()));
  var this$2 = $n(this.ju_Locale$LocaleBuilder__f_region);
  var $$x1 = $as_T((this$2.isEmpty__Z() ? "" : this$2.get__O()));
  var this$3 = $n(this.ju_Locale$LocaleBuilder__f_variant);
  return new $c_ju_Locale($$x2, $$x1, $as_T((this$3.isEmpty__Z() ? "" : this$3.get__O())), this.ju_Locale$LocaleBuilder__f_script, this.ju_Locale$LocaleBuilder__f_extensions, this.ju_Locale$LocaleBuilder__f_unicodeExtensions, this.ju_Locale$LocaleBuilder__f_unicodeAttributes, ($m_ju_Locale$(), true))
});
$c_ju_Locale$LocaleBuilder.prototype.productPrefix__T = (function() {
  return "LocaleBuilder"
});
$c_ju_Locale$LocaleBuilder.prototype.productArity__I = (function() {
  return 8
});
$c_ju_Locale$LocaleBuilder.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.ju_Locale$LocaleBuilder__f_strict;
      break
    }
    case 1: {
      return this.ju_Locale$LocaleBuilder__f_language;
      break
    }
    case 2: {
      return this.ju_Locale$LocaleBuilder__f_region;
      break
    }
    case 3: {
      return this.ju_Locale$LocaleBuilder__f_variant;
      break
    }
    case 4: {
      return this.ju_Locale$LocaleBuilder__f_script;
      break
    }
    case 5: {
      return this.ju_Locale$LocaleBuilder__f_extensions;
      break
    }
    case 6: {
      return this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      break
    }
    case 7: {
      return this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_ju_Locale$LocaleBuilder.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_ju_Locale$LocaleBuilder.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LocaleBuilder");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.ju_Locale$LocaleBuilder__f_strict ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.ju_Locale$LocaleBuilder__f_language;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.ju_Locale$LocaleBuilder__f_region;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.ju_Locale$LocaleBuilder__f_variant;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.ju_Locale$LocaleBuilder__f_script;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.ju_Locale$LocaleBuilder__f_extensions;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$9, 8)
});
$c_ju_Locale$LocaleBuilder.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_ju_Locale$LocaleBuilder.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_ju_Locale$LocaleBuilder)) {
    var LocaleBuilder$1 = $as_ju_Locale$LocaleBuilder(x$1);
    if ((this.ju_Locale$LocaleBuilder__f_strict === $n(LocaleBuilder$1).ju_Locale$LocaleBuilder__f_strict)) {
      var x = this.ju_Locale$LocaleBuilder__f_language;
      var x$2 = $n(LocaleBuilder$1).ju_Locale$LocaleBuilder__f_language;
      var $$x7 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x7 = false
    };
    if ($$x7) {
      var x$3 = this.ju_Locale$LocaleBuilder__f_region;
      var x$4 = $n(LocaleBuilder$1).ju_Locale$LocaleBuilder__f_region;
      var $$x6 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$5 = this.ju_Locale$LocaleBuilder__f_variant;
      var x$6 = $n(LocaleBuilder$1).ju_Locale$LocaleBuilder__f_variant;
      var $$x5 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$7 = this.ju_Locale$LocaleBuilder__f_script;
      var x$8 = $n(LocaleBuilder$1).ju_Locale$LocaleBuilder__f_script;
      var $$x4 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$9 = this.ju_Locale$LocaleBuilder__f_extensions;
      var x$10 = $n(LocaleBuilder$1).ju_Locale$LocaleBuilder__f_extensions;
      var $$x3 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$11 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      var x$12 = $n(LocaleBuilder$1).ju_Locale$LocaleBuilder__f_unicodeExtensions;
      var $$x2 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$13 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      var x$14 = $n(LocaleBuilder$1).ju_Locale$LocaleBuilder__f_unicodeAttributes;
      var $$x1 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(LocaleBuilder$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_ju_Locale$LocaleBuilder(obj) {
  return (((obj instanceof $c_ju_Locale$LocaleBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Locale$LocaleBuilder"))
}
function $isArrayOf_ju_Locale$LocaleBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale$LocaleBuilder)))
}
function $asArrayOf_ju_Locale$LocaleBuilder(obj, depth) {
  return (($isArrayOf_ju_Locale$LocaleBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Locale$LocaleBuilder;", depth))
}
var $d_ju_Locale$LocaleBuilder = new $TypeData().initClass({
  ju_Locale$LocaleBuilder: 0
}, false, "java.util.Locale$LocaleBuilder", {
  ju_Locale$LocaleBuilder: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Locale$LocaleBuilder.prototype.$classData = $d_ju_Locale$LocaleBuilder;
/** @constructor */
function $c_ju_SimpleTimeZone(rawOffset, ID) {
  this.ju_SimpleTimeZone__f_ID = null;
  this.ju_SimpleTimeZone__f_ID = ID;
  $ct_ju_TimeZone__(this)
}
$c_ju_SimpleTimeZone.prototype = new $h_ju_TimeZone();
$c_ju_SimpleTimeZone.prototype.constructor = $c_ju_SimpleTimeZone;
/** @constructor */
function $h_ju_SimpleTimeZone() {
  /*<skip>*/
}
$h_ju_SimpleTimeZone.prototype = $c_ju_SimpleTimeZone.prototype;
var $d_ju_SimpleTimeZone = new $TypeData().initClass({
  ju_SimpleTimeZone: 0
}, false, "java.util.SimpleTimeZone", {
  ju_SimpleTimeZone: 1,
  ju_TimeZone: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
});
$c_ju_SimpleTimeZone.prototype.$classData = $d_ju_SimpleTimeZone;
class $c_ju_concurrent_ExecutionException extends $c_jl_Exception {
  constructor(message, cause) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
  };
}
var $d_ju_concurrent_ExecutionException = new $TypeData().initClass({
  ju_concurrent_ExecutionException: 0
}, false, "java.util.concurrent.ExecutionException", {
  ju_concurrent_ExecutionException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_ExecutionException.prototype.$classData = $d_ju_concurrent_ExecutionException;
/** @constructor */
function $c_ju_concurrent_TimeUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_ju_concurrent_TimeUnit.prototype = new $h_jl_Enum();
$c_ju_concurrent_TimeUnit.prototype.constructor = $c_ju_concurrent_TimeUnit;
/** @constructor */
function $h_ju_concurrent_TimeUnit() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit.prototype = $c_ju_concurrent_TimeUnit.prototype;
function $as_ju_concurrent_TimeUnit(obj) {
  return (((obj instanceof $c_ju_concurrent_TimeUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.TimeUnit"))
}
function $isArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_TimeUnit)))
}
function $asArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (($isArrayOf_ju_concurrent_TimeUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.TimeUnit;", depth))
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$ByteArrayOps$() {
  /*<skip>*/
}
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ByteArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ByteArrayOps$() {
  /*<skip>*/
}
$h_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uB(o1);
  var y = $uB(o2);
  return ((x - y) | 0)
});
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_B(a, 1);
  var v$1 = $uB(v);
  $n(a$1).set(i, v$1)
});
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_B(a, 1);
  return $n(a$1).get(i)
});
var $d_ju_internal_GenericArrayOps$ByteArrayOps$ = new $TypeData().initClass({
  ju_internal_GenericArrayOps$ByteArrayOps$: 0
}, false, "java.util.internal.GenericArrayOps$ByteArrayOps$", {
  ju_internal_GenericArrayOps$ByteArrayOps$: 1,
  O: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
});
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.$classData = $d_ju_internal_GenericArrayOps$ByteArrayOps$;
var $n_ju_internal_GenericArrayOps$ByteArrayOps$;
function $m_ju_internal_GenericArrayOps$ByteArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ByteArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ByteArrayOps$ = new $c_ju_internal_GenericArrayOps$ByteArrayOps$()
  };
  return $n_ju_internal_GenericArrayOps$ByteArrayOps$
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$CharArrayOps$() {
  /*<skip>*/
}
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$CharArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$CharArrayOps$() {
  /*<skip>*/
}
$h_ju_internal_GenericArrayOps$CharArrayOps$.prototype = $c_ju_internal_GenericArrayOps$CharArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uC(o1);
  var y = $uC(o2);
  return ((x - y) | 0)
});
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_C(a, 1);
  var v$1 = $uC(v);
  $n(a$1).set(i, v$1)
});
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_C(a, 1);
  return $bC($n(a$1).get(i))
});
var $d_ju_internal_GenericArrayOps$CharArrayOps$ = new $TypeData().initClass({
  ju_internal_GenericArrayOps$CharArrayOps$: 0
}, false, "java.util.internal.GenericArrayOps$CharArrayOps$", {
  ju_internal_GenericArrayOps$CharArrayOps$: 1,
  O: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
});
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.$classData = $d_ju_internal_GenericArrayOps$CharArrayOps$;
var $n_ju_internal_GenericArrayOps$CharArrayOps$;
function $m_ju_internal_GenericArrayOps$CharArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$CharArrayOps$)) {
    $n_ju_internal_GenericArrayOps$CharArrayOps$ = new $c_ju_internal_GenericArrayOps$CharArrayOps$()
  };
  return $n_ju_internal_GenericArrayOps$CharArrayOps$
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$IntArrayOps$() {
  /*<skip>*/
}
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$IntArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$IntArrayOps$() {
  /*<skip>*/
}
$h_ju_internal_GenericArrayOps$IntArrayOps$.prototype = $c_ju_internal_GenericArrayOps$IntArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uI(o1);
  var y = $uI(o2);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1))
});
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_I(a, 1);
  var v$1 = $uI(v);
  $n(a$1).set(i, v$1)
});
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_I(a, 1);
  return $n(a$1).get(i)
});
var $d_ju_internal_GenericArrayOps$IntArrayOps$ = new $TypeData().initClass({
  ju_internal_GenericArrayOps$IntArrayOps$: 0
}, false, "java.util.internal.GenericArrayOps$IntArrayOps$", {
  ju_internal_GenericArrayOps$IntArrayOps$: 1,
  O: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
});
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.$classData = $d_ju_internal_GenericArrayOps$IntArrayOps$;
var $n_ju_internal_GenericArrayOps$IntArrayOps$;
function $m_ju_internal_GenericArrayOps$IntArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$IntArrayOps$)) {
    $n_ju_internal_GenericArrayOps$IntArrayOps$ = new $c_ju_internal_GenericArrayOps$IntArrayOps$()
  };
  return $n_ju_internal_GenericArrayOps$IntArrayOps$
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$LongArrayOps$() {
  /*<skip>*/
}
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$LongArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$LongArrayOps$() {
  /*<skip>*/
}
$h_ju_internal_GenericArrayOps$LongArrayOps$.prototype = $c_ju_internal_GenericArrayOps$LongArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var t = $uJ(o1);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(o2);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1)
});
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_J(a, 1);
  var t = $uJ(v);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  $n(a$1).set(i, new $c_RTLong(lo, hi))
});
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_J(a, 1);
  return $n(a$1).get(i)
});
var $d_ju_internal_GenericArrayOps$LongArrayOps$ = new $TypeData().initClass({
  ju_internal_GenericArrayOps$LongArrayOps$: 0
}, false, "java.util.internal.GenericArrayOps$LongArrayOps$", {
  ju_internal_GenericArrayOps$LongArrayOps$: 1,
  O: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
});
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.$classData = $d_ju_internal_GenericArrayOps$LongArrayOps$;
var $n_ju_internal_GenericArrayOps$LongArrayOps$;
function $m_ju_internal_GenericArrayOps$LongArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$LongArrayOps$)) {
    $n_ju_internal_GenericArrayOps$LongArrayOps$ = new $c_ju_internal_GenericArrayOps$LongArrayOps$()
  };
  return $n_ju_internal_GenericArrayOps$LongArrayOps$
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$ShortArrayOps$() {
  /*<skip>*/
}
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ShortArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ShortArrayOps$() {
  /*<skip>*/
}
$h_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uS(o1);
  var y = $uS(o2);
  return ((x - y) | 0)
});
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_S(a, 1);
  var v$1 = $uS(v);
  $n(a$1).set(i, v$1)
});
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_S(a, 1);
  return $n(a$1).get(i)
});
var $d_ju_internal_GenericArrayOps$ShortArrayOps$ = new $TypeData().initClass({
  ju_internal_GenericArrayOps$ShortArrayOps$: 0
}, false, "java.util.internal.GenericArrayOps$ShortArrayOps$", {
  ju_internal_GenericArrayOps$ShortArrayOps$: 1,
  O: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
});
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.$classData = $d_ju_internal_GenericArrayOps$ShortArrayOps$;
var $n_ju_internal_GenericArrayOps$ShortArrayOps$;
function $m_ju_internal_GenericArrayOps$ShortArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ShortArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ShortArrayOps$ = new $c_ju_internal_GenericArrayOps$ShortArrayOps$()
  };
  return $n_ju_internal_GenericArrayOps$ShortArrayOps$
}
/** @constructor */
function $c_Llocales_cldr_CLDRMetadata(isoCountries, iso3Countries, isoLanguages, iso3Languages, scripts) {
  this.Llocales_cldr_CLDRMetadata__f_isoCountries = null;
  this.Llocales_cldr_CLDRMetadata__f_iso3Countries = null;
  this.Llocales_cldr_CLDRMetadata__f_isoLanguages = null;
  this.Llocales_cldr_CLDRMetadata__f_iso3Languages = null;
  this.Llocales_cldr_CLDRMetadata__f_scripts = null;
  this.Llocales_cldr_CLDRMetadata__f_isoCountries = isoCountries;
  this.Llocales_cldr_CLDRMetadata__f_iso3Countries = iso3Countries;
  this.Llocales_cldr_CLDRMetadata__f_isoLanguages = isoLanguages;
  this.Llocales_cldr_CLDRMetadata__f_iso3Languages = iso3Languages;
  this.Llocales_cldr_CLDRMetadata__f_scripts = scripts
}
$c_Llocales_cldr_CLDRMetadata.prototype = new $h_O();
$c_Llocales_cldr_CLDRMetadata.prototype.constructor = $c_Llocales_cldr_CLDRMetadata;
/** @constructor */
function $h_Llocales_cldr_CLDRMetadata() {
  /*<skip>*/
}
$h_Llocales_cldr_CLDRMetadata.prototype = $c_Llocales_cldr_CLDRMetadata.prototype;
$c_Llocales_cldr_CLDRMetadata.prototype.productPrefix__T = (function() {
  return "CLDRMetadata"
});
$c_Llocales_cldr_CLDRMetadata.prototype.productArity__I = (function() {
  return 5
});
$c_Llocales_cldr_CLDRMetadata.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CLDRMetadata__f_isoCountries;
      break
    }
    case 1: {
      return this.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      break
    }
    case 2: {
      return this.Llocales_cldr_CLDRMetadata__f_isoLanguages;
      break
    }
    case 3: {
      return this.Llocales_cldr_CLDRMetadata__f_iso3Languages;
      break
    }
    case 4: {
      return this.Llocales_cldr_CLDRMetadata__f_scripts;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CLDRMetadata.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CLDRMetadata.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CLDRMetadata.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CLDRMetadata.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CLDRMetadata)) {
    var CLDRMetadata$1 = $as_Llocales_cldr_CLDRMetadata(x$1);
    if ((this.Llocales_cldr_CLDRMetadata__f_isoCountries === $n(CLDRMetadata$1).Llocales_cldr_CLDRMetadata__f_isoCountries)) {
      var x = this.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      var x$2 = $n(CLDRMetadata$1).Llocales_cldr_CLDRMetadata__f_iso3Countries;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Llocales_cldr_CLDRMetadata__f_isoLanguages === $n(CLDRMetadata$1).Llocales_cldr_CLDRMetadata__f_isoLanguages)) {
        var x$3 = this.Llocales_cldr_CLDRMetadata__f_iso3Languages;
        var x$4 = $n(CLDRMetadata$1).Llocales_cldr_CLDRMetadata__f_iso3Languages;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          return (this.Llocales_cldr_CLDRMetadata__f_scripts === $n(CLDRMetadata$1).Llocales_cldr_CLDRMetadata__f_scripts)
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_CLDRMetadata(obj) {
  return (((obj instanceof $c_Llocales_cldr_CLDRMetadata) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CLDRMetadata"))
}
function $isArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CLDRMetadata)))
}
function $asArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CLDRMetadata;", depth))
}
var $d_Llocales_cldr_CLDRMetadata = new $TypeData().initClass({
  Llocales_cldr_CLDRMetadata: 0
}, false, "locales.cldr.CLDRMetadata", {
  Llocales_cldr_CLDRMetadata: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CLDRMetadata.prototype.$classData = $d_Llocales_cldr_CLDRMetadata;
/** @constructor */
function $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns) {
  this.Llocales_cldr_CalendarPatterns__f_datePatterns = null;
  this.Llocales_cldr_CalendarPatterns__f_timePatterns = null;
  this.Llocales_cldr_CalendarPatterns__f_datePatterns = datePatterns;
  this.Llocales_cldr_CalendarPatterns__f_timePatterns = timePatterns
}
$c_Llocales_cldr_CalendarPatterns.prototype = new $h_O();
$c_Llocales_cldr_CalendarPatterns.prototype.constructor = $c_Llocales_cldr_CalendarPatterns;
/** @constructor */
function $h_Llocales_cldr_CalendarPatterns() {
  /*<skip>*/
}
$h_Llocales_cldr_CalendarPatterns.prototype = $c_Llocales_cldr_CalendarPatterns.prototype;
$c_Llocales_cldr_CalendarPatterns.prototype.productPrefix__T = (function() {
  return "CalendarPatterns"
});
$c_Llocales_cldr_CalendarPatterns.prototype.productArity__I = (function() {
  return 2
});
$c_Llocales_cldr_CalendarPatterns.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CalendarPatterns__f_datePatterns;
      break
    }
    case 1: {
      return this.Llocales_cldr_CalendarPatterns__f_timePatterns;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CalendarPatterns.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CalendarPatterns.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CalendarPatterns.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CalendarPatterns.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CalendarPatterns)) {
    var CalendarPatterns$1 = $as_Llocales_cldr_CalendarPatterns(x$1);
    var x = this.Llocales_cldr_CalendarPatterns__f_datePatterns;
    var x$2 = $n(CalendarPatterns$1).Llocales_cldr_CalendarPatterns__f_datePatterns;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CalendarPatterns__f_timePatterns;
      var x$4 = $n(CalendarPatterns$1).Llocales_cldr_CalendarPatterns__f_timePatterns;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_CalendarPatterns(obj) {
  return (((obj instanceof $c_Llocales_cldr_CalendarPatterns) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CalendarPatterns"))
}
function $isArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CalendarPatterns)))
}
function $asArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CalendarPatterns;", depth))
}
var $d_Llocales_cldr_CalendarPatterns = new $TypeData().initClass({
  Llocales_cldr_CalendarPatterns: 0
}, false, "locales.cldr.CalendarPatterns", {
  Llocales_cldr_CalendarPatterns: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CalendarPatterns.prototype.$classData = $d_Llocales_cldr_CalendarPatterns;
/** @constructor */
function $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras) {
  this.Llocales_cldr_CalendarSymbols__f_months = null;
  this.Llocales_cldr_CalendarSymbols__f_shortMonths = null;
  this.Llocales_cldr_CalendarSymbols__f_weekdays = null;
  this.Llocales_cldr_CalendarSymbols__f_shortWeekdays = null;
  this.Llocales_cldr_CalendarSymbols__f_amPm = null;
  this.Llocales_cldr_CalendarSymbols__f_eras = null;
  this.Llocales_cldr_CalendarSymbols__f_months = months;
  this.Llocales_cldr_CalendarSymbols__f_shortMonths = shortMonths;
  this.Llocales_cldr_CalendarSymbols__f_weekdays = weekdays;
  this.Llocales_cldr_CalendarSymbols__f_shortWeekdays = shortWeekdays;
  this.Llocales_cldr_CalendarSymbols__f_amPm = amPm;
  this.Llocales_cldr_CalendarSymbols__f_eras = eras
}
$c_Llocales_cldr_CalendarSymbols.prototype = new $h_O();
$c_Llocales_cldr_CalendarSymbols.prototype.constructor = $c_Llocales_cldr_CalendarSymbols;
/** @constructor */
function $h_Llocales_cldr_CalendarSymbols() {
  /*<skip>*/
}
$h_Llocales_cldr_CalendarSymbols.prototype = $c_Llocales_cldr_CalendarSymbols.prototype;
$c_Llocales_cldr_CalendarSymbols.prototype.productPrefix__T = (function() {
  return "CalendarSymbols"
});
$c_Llocales_cldr_CalendarSymbols.prototype.productArity__I = (function() {
  return 6
});
$c_Llocales_cldr_CalendarSymbols.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CalendarSymbols__f_months;
      break
    }
    case 1: {
      return this.Llocales_cldr_CalendarSymbols__f_shortMonths;
      break
    }
    case 2: {
      return this.Llocales_cldr_CalendarSymbols__f_weekdays;
      break
    }
    case 3: {
      return this.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      break
    }
    case 4: {
      return this.Llocales_cldr_CalendarSymbols__f_amPm;
      break
    }
    case 5: {
      return this.Llocales_cldr_CalendarSymbols__f_eras;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CalendarSymbols.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CalendarSymbols.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CalendarSymbols.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CalendarSymbols.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CalendarSymbols)) {
    var CalendarSymbols$1 = $as_Llocales_cldr_CalendarSymbols(x$1);
    var x = this.Llocales_cldr_CalendarSymbols__f_months;
    var x$2 = $n(CalendarSymbols$1).Llocales_cldr_CalendarSymbols__f_months;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CalendarSymbols__f_shortMonths;
      var x$4 = $n(CalendarSymbols$1).Llocales_cldr_CalendarSymbols__f_shortMonths;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Llocales_cldr_CalendarSymbols__f_weekdays;
        var x$6 = $n(CalendarSymbols$1).Llocales_cldr_CalendarSymbols__f_weekdays;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      var x$8 = $n(CalendarSymbols$1).Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Llocales_cldr_CalendarSymbols__f_amPm;
        var x$10 = $n(CalendarSymbols$1).Llocales_cldr_CalendarSymbols__f_amPm;
        var $$x2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$11 = this.Llocales_cldr_CalendarSymbols__f_eras;
        var x$12 = $n(CalendarSymbols$1).Llocales_cldr_CalendarSymbols__f_eras;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          $n(CalendarSymbols$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_CalendarSymbols(obj) {
  return (((obj instanceof $c_Llocales_cldr_CalendarSymbols) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CalendarSymbols"))
}
function $isArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CalendarSymbols)))
}
function $asArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CalendarSymbols;", depth))
}
var $d_Llocales_cldr_CalendarSymbols = new $TypeData().initClass({
  Llocales_cldr_CalendarSymbols: 0
}, false, "locales.cldr.CalendarSymbols", {
  Llocales_cldr_CalendarSymbols: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CalendarSymbols.prototype.$classData = $d_Llocales_cldr_CalendarSymbols;
/** @constructor */
function $c_Llocales_cldr_CurrencyData(currencyTypes, fractions, regions, numericCodes) {
  this.Llocales_cldr_CurrencyData__f_currencyTypes = null;
  this.Llocales_cldr_CurrencyData__f_fractions = null;
  this.Llocales_cldr_CurrencyData__f_regions = null;
  this.Llocales_cldr_CurrencyData__f_numericCodes = null;
  this.Llocales_cldr_CurrencyData__f_currencyTypes = currencyTypes;
  this.Llocales_cldr_CurrencyData__f_fractions = fractions;
  this.Llocales_cldr_CurrencyData__f_regions = regions;
  this.Llocales_cldr_CurrencyData__f_numericCodes = numericCodes
}
$c_Llocales_cldr_CurrencyData.prototype = new $h_O();
$c_Llocales_cldr_CurrencyData.prototype.constructor = $c_Llocales_cldr_CurrencyData;
/** @constructor */
function $h_Llocales_cldr_CurrencyData() {
  /*<skip>*/
}
$h_Llocales_cldr_CurrencyData.prototype = $c_Llocales_cldr_CurrencyData.prototype;
$c_Llocales_cldr_CurrencyData.prototype.productPrefix__T = (function() {
  return "CurrencyData"
});
$c_Llocales_cldr_CurrencyData.prototype.productArity__I = (function() {
  return 4
});
$c_Llocales_cldr_CurrencyData.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CurrencyData__f_currencyTypes;
      break
    }
    case 1: {
      return this.Llocales_cldr_CurrencyData__f_fractions;
      break
    }
    case 2: {
      return this.Llocales_cldr_CurrencyData__f_regions;
      break
    }
    case 3: {
      return this.Llocales_cldr_CurrencyData__f_numericCodes;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CurrencyData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CurrencyData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CurrencyData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CurrencyData.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CurrencyData)) {
    var CurrencyData$1 = $as_Llocales_cldr_CurrencyData(x$1);
    var x = this.Llocales_cldr_CurrencyData__f_currencyTypes;
    var x$2 = $n(CurrencyData$1).Llocales_cldr_CurrencyData__f_currencyTypes;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CurrencyData__f_fractions;
      var x$4 = $n(CurrencyData$1).Llocales_cldr_CurrencyData__f_fractions;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Llocales_cldr_CurrencyData__f_regions;
      var x$6 = $n(CurrencyData$1).Llocales_cldr_CurrencyData__f_regions;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Llocales_cldr_CurrencyData__f_numericCodes;
        var x$8 = $n(CurrencyData$1).Llocales_cldr_CurrencyData__f_numericCodes;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_CurrencyData(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencyData) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencyData"))
}
function $isArrayOf_Llocales_cldr_CurrencyData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyData)))
}
function $asArrayOf_Llocales_cldr_CurrencyData(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencyData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencyData;", depth))
}
var $d_Llocales_cldr_CurrencyData = new $TypeData().initClass({
  Llocales_cldr_CurrencyData: 0
}, false, "locales.cldr.CurrencyData", {
  Llocales_cldr_CurrencyData: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CurrencyData.prototype.$classData = $d_Llocales_cldr_CurrencyData;
/** @constructor */
function $c_Llocales_cldr_CurrencyDataFractionsInfo(currencyCode, digits, rounding, cashDigits, cashRounding) {
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_currencyCode = null;
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_digits = 0;
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_rounding = 0;
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashDigits = null;
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashRounding = null;
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_currencyCode = currencyCode;
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_digits = digits;
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_rounding = rounding;
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashDigits = cashDigits;
  this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashRounding = cashRounding
}
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype = new $h_O();
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype.constructor = $c_Llocales_cldr_CurrencyDataFractionsInfo;
/** @constructor */
function $h_Llocales_cldr_CurrencyDataFractionsInfo() {
  /*<skip>*/
}
$h_Llocales_cldr_CurrencyDataFractionsInfo.prototype = $c_Llocales_cldr_CurrencyDataFractionsInfo.prototype;
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype.productPrefix__T = (function() {
  return "CurrencyDataFractionsInfo"
});
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype.productArity__I = (function() {
  return 5
});
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CurrencyDataFractionsInfo__f_currencyCode;
      break
    }
    case 1: {
      return this.Llocales_cldr_CurrencyDataFractionsInfo__f_digits;
      break
    }
    case 2: {
      return this.Llocales_cldr_CurrencyDataFractionsInfo__f_rounding;
      break
    }
    case 3: {
      return this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashDigits;
      break
    }
    case 4: {
      return this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashRounding;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("CurrencyDataFractionsInfo");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llocales_cldr_CurrencyDataFractionsInfo__f_currencyCode;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Llocales_cldr_CurrencyDataFractionsInfo__f_digits;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Llocales_cldr_CurrencyDataFractionsInfo__f_rounding;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$1 = this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashDigits;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$2 = this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashRounding;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CurrencyDataFractionsInfo)) {
    var CurrencyDataFractionsInfo$1 = $as_Llocales_cldr_CurrencyDataFractionsInfo(x$1);
    if (((this.Llocales_cldr_CurrencyDataFractionsInfo__f_digits === $n(CurrencyDataFractionsInfo$1).Llocales_cldr_CurrencyDataFractionsInfo__f_digits) && (this.Llocales_cldr_CurrencyDataFractionsInfo__f_rounding === $n(CurrencyDataFractionsInfo$1).Llocales_cldr_CurrencyDataFractionsInfo__f_rounding))) {
      if ((this.Llocales_cldr_CurrencyDataFractionsInfo__f_currencyCode === $n(CurrencyDataFractionsInfo$1).Llocales_cldr_CurrencyDataFractionsInfo__f_currencyCode)) {
        var x = this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashDigits;
        var x$2 = $n(CurrencyDataFractionsInfo$1).Llocales_cldr_CurrencyDataFractionsInfo__f_cashDigits;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          var x$3 = this.Llocales_cldr_CurrencyDataFractionsInfo__f_cashRounding;
          var x$4 = $n(CurrencyDataFractionsInfo$1).Llocales_cldr_CurrencyDataFractionsInfo__f_cashRounding;
          return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_CurrencyDataFractionsInfo(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencyDataFractionsInfo) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencyDataFractionsInfo"))
}
function $isArrayOf_Llocales_cldr_CurrencyDataFractionsInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyDataFractionsInfo)))
}
function $asArrayOf_Llocales_cldr_CurrencyDataFractionsInfo(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencyDataFractionsInfo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencyDataFractionsInfo;", depth))
}
var $d_Llocales_cldr_CurrencyDataFractionsInfo = new $TypeData().initClass({
  Llocales_cldr_CurrencyDataFractionsInfo: 0
}, false, "locales.cldr.CurrencyDataFractionsInfo", {
  Llocales_cldr_CurrencyDataFractionsInfo: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CurrencyDataFractionsInfo.prototype.$classData = $d_Llocales_cldr_CurrencyDataFractionsInfo;
/** @constructor */
function $c_Llocales_cldr_CurrencyDataRegion(countryCode, currencies) {
  this.Llocales_cldr_CurrencyDataRegion__f_countryCode = null;
  this.Llocales_cldr_CurrencyDataRegion__f_currencies = null;
  this.Llocales_cldr_CurrencyDataRegion__f_countryCode = countryCode;
  this.Llocales_cldr_CurrencyDataRegion__f_currencies = currencies
}
$c_Llocales_cldr_CurrencyDataRegion.prototype = new $h_O();
$c_Llocales_cldr_CurrencyDataRegion.prototype.constructor = $c_Llocales_cldr_CurrencyDataRegion;
/** @constructor */
function $h_Llocales_cldr_CurrencyDataRegion() {
  /*<skip>*/
}
$h_Llocales_cldr_CurrencyDataRegion.prototype = $c_Llocales_cldr_CurrencyDataRegion.prototype;
$c_Llocales_cldr_CurrencyDataRegion.prototype.productPrefix__T = (function() {
  return "CurrencyDataRegion"
});
$c_Llocales_cldr_CurrencyDataRegion.prototype.productArity__I = (function() {
  return 2
});
$c_Llocales_cldr_CurrencyDataRegion.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CurrencyDataRegion__f_countryCode;
      break
    }
    case 1: {
      return this.Llocales_cldr_CurrencyDataRegion__f_currencies;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CurrencyDataRegion.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CurrencyDataRegion.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CurrencyDataRegion.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CurrencyDataRegion.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CurrencyDataRegion)) {
    var CurrencyDataRegion$1 = $as_Llocales_cldr_CurrencyDataRegion(x$1);
    if ((this.Llocales_cldr_CurrencyDataRegion__f_countryCode === $n(CurrencyDataRegion$1).Llocales_cldr_CurrencyDataRegion__f_countryCode)) {
      var x = this.Llocales_cldr_CurrencyDataRegion__f_currencies;
      var x$2 = $n(CurrencyDataRegion$1).Llocales_cldr_CurrencyDataRegion__f_currencies;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_CurrencyDataRegion(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencyDataRegion) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencyDataRegion"))
}
function $isArrayOf_Llocales_cldr_CurrencyDataRegion(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyDataRegion)))
}
function $asArrayOf_Llocales_cldr_CurrencyDataRegion(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencyDataRegion(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencyDataRegion;", depth))
}
var $d_Llocales_cldr_CurrencyDataRegion = new $TypeData().initClass({
  Llocales_cldr_CurrencyDataRegion: 0
}, false, "locales.cldr.CurrencyDataRegion", {
  Llocales_cldr_CurrencyDataRegion: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CurrencyDataRegion.prototype.$classData = $d_Llocales_cldr_CurrencyDataRegion;
/** @constructor */
function $c_Llocales_cldr_CurrencyDataRegionCurrency(currencyCode, from, to, tender) {
  this.Llocales_cldr_CurrencyDataRegionCurrency__f_currencyCode = null;
  this.Llocales_cldr_CurrencyDataRegionCurrency__f_from = null;
  this.Llocales_cldr_CurrencyDataRegionCurrency__f_to = null;
  this.Llocales_cldr_CurrencyDataRegionCurrency__f_tender = null;
  this.Llocales_cldr_CurrencyDataRegionCurrency__f_currencyCode = currencyCode;
  this.Llocales_cldr_CurrencyDataRegionCurrency__f_from = from;
  this.Llocales_cldr_CurrencyDataRegionCurrency__f_to = to;
  this.Llocales_cldr_CurrencyDataRegionCurrency__f_tender = tender
}
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype = new $h_O();
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype.constructor = $c_Llocales_cldr_CurrencyDataRegionCurrency;
/** @constructor */
function $h_Llocales_cldr_CurrencyDataRegionCurrency() {
  /*<skip>*/
}
$h_Llocales_cldr_CurrencyDataRegionCurrency.prototype = $c_Llocales_cldr_CurrencyDataRegionCurrency.prototype;
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype.productPrefix__T = (function() {
  return "CurrencyDataRegionCurrency"
});
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype.productArity__I = (function() {
  return 4
});
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CurrencyDataRegionCurrency__f_currencyCode;
      break
    }
    case 1: {
      return this.Llocales_cldr_CurrencyDataRegionCurrency__f_from;
      break
    }
    case 2: {
      return this.Llocales_cldr_CurrencyDataRegionCurrency__f_to;
      break
    }
    case 3: {
      return this.Llocales_cldr_CurrencyDataRegionCurrency__f_tender;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CurrencyDataRegionCurrency)) {
    var CurrencyDataRegionCurrency$1 = $as_Llocales_cldr_CurrencyDataRegionCurrency(x$1);
    if ((this.Llocales_cldr_CurrencyDataRegionCurrency__f_currencyCode === $n(CurrencyDataRegionCurrency$1).Llocales_cldr_CurrencyDataRegionCurrency__f_currencyCode)) {
      var x = this.Llocales_cldr_CurrencyDataRegionCurrency__f_from;
      var x$2 = $n(CurrencyDataRegionCurrency$1).Llocales_cldr_CurrencyDataRegionCurrency__f_from;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Llocales_cldr_CurrencyDataRegionCurrency__f_to;
      var x$4 = $n(CurrencyDataRegionCurrency$1).Llocales_cldr_CurrencyDataRegionCurrency__f_to;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Llocales_cldr_CurrencyDataRegionCurrency__f_tender;
        var x$6 = $n(CurrencyDataRegionCurrency$1).Llocales_cldr_CurrencyDataRegionCurrency__f_tender;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_CurrencyDataRegionCurrency(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencyDataRegionCurrency) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencyDataRegionCurrency"))
}
function $isArrayOf_Llocales_cldr_CurrencyDataRegionCurrency(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyDataRegionCurrency)))
}
function $asArrayOf_Llocales_cldr_CurrencyDataRegionCurrency(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencyDataRegionCurrency(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencyDataRegionCurrency;", depth))
}
var $d_Llocales_cldr_CurrencyDataRegionCurrency = new $TypeData().initClass({
  Llocales_cldr_CurrencyDataRegionCurrency: 0
}, false, "locales.cldr.CurrencyDataRegionCurrency", {
  Llocales_cldr_CurrencyDataRegionCurrency: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CurrencyDataRegionCurrency.prototype.$classData = $d_Llocales_cldr_CurrencyDataRegionCurrency;
/** @constructor */
function $c_Llocales_cldr_CurrencyDisplayName(name, count) {
  this.Llocales_cldr_CurrencyDisplayName__f_name = null;
  this.Llocales_cldr_CurrencyDisplayName__f_count = null;
  this.Llocales_cldr_CurrencyDisplayName__f_name = name;
  this.Llocales_cldr_CurrencyDisplayName__f_count = count
}
$c_Llocales_cldr_CurrencyDisplayName.prototype = new $h_O();
$c_Llocales_cldr_CurrencyDisplayName.prototype.constructor = $c_Llocales_cldr_CurrencyDisplayName;
/** @constructor */
function $h_Llocales_cldr_CurrencyDisplayName() {
  /*<skip>*/
}
$h_Llocales_cldr_CurrencyDisplayName.prototype = $c_Llocales_cldr_CurrencyDisplayName.prototype;
$c_Llocales_cldr_CurrencyDisplayName.prototype.productPrefix__T = (function() {
  return "CurrencyDisplayName"
});
$c_Llocales_cldr_CurrencyDisplayName.prototype.productArity__I = (function() {
  return 2
});
$c_Llocales_cldr_CurrencyDisplayName.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CurrencyDisplayName__f_name;
      break
    }
    case 1: {
      return this.Llocales_cldr_CurrencyDisplayName__f_count;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CurrencyDisplayName.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CurrencyDisplayName.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CurrencyDisplayName.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CurrencyDisplayName.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CurrencyDisplayName)) {
    var CurrencyDisplayName$1 = $as_Llocales_cldr_CurrencyDisplayName(x$1);
    if ((this.Llocales_cldr_CurrencyDisplayName__f_name === $n(CurrencyDisplayName$1).Llocales_cldr_CurrencyDisplayName__f_name)) {
      var x = this.Llocales_cldr_CurrencyDisplayName__f_count;
      var x$2 = $n(CurrencyDisplayName$1).Llocales_cldr_CurrencyDisplayName__f_count;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_CurrencyDisplayName(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencyDisplayName) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencyDisplayName"))
}
function $isArrayOf_Llocales_cldr_CurrencyDisplayName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyDisplayName)))
}
function $asArrayOf_Llocales_cldr_CurrencyDisplayName(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencyDisplayName(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencyDisplayName;", depth))
}
var $d_Llocales_cldr_CurrencyDisplayName = new $TypeData().initClass({
  Llocales_cldr_CurrencyDisplayName: 0
}, false, "locales.cldr.CurrencyDisplayName", {
  Llocales_cldr_CurrencyDisplayName: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CurrencyDisplayName.prototype.$classData = $d_Llocales_cldr_CurrencyDisplayName;
/** @constructor */
function $c_Llocales_cldr_CurrencyNumericCode(currencyCode, numericCode) {
  this.Llocales_cldr_CurrencyNumericCode__f_currencyCode = null;
  this.Llocales_cldr_CurrencyNumericCode__f_numericCode = 0;
  this.Llocales_cldr_CurrencyNumericCode__f_currencyCode = currencyCode;
  this.Llocales_cldr_CurrencyNumericCode__f_numericCode = numericCode
}
$c_Llocales_cldr_CurrencyNumericCode.prototype = new $h_O();
$c_Llocales_cldr_CurrencyNumericCode.prototype.constructor = $c_Llocales_cldr_CurrencyNumericCode;
/** @constructor */
function $h_Llocales_cldr_CurrencyNumericCode() {
  /*<skip>*/
}
$h_Llocales_cldr_CurrencyNumericCode.prototype = $c_Llocales_cldr_CurrencyNumericCode.prototype;
$c_Llocales_cldr_CurrencyNumericCode.prototype.productPrefix__T = (function() {
  return "CurrencyNumericCode"
});
$c_Llocales_cldr_CurrencyNumericCode.prototype.productArity__I = (function() {
  return 2
});
$c_Llocales_cldr_CurrencyNumericCode.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CurrencyNumericCode__f_currencyCode;
      break
    }
    case 1: {
      return this.Llocales_cldr_CurrencyNumericCode__f_numericCode;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CurrencyNumericCode.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CurrencyNumericCode.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("CurrencyNumericCode");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llocales_cldr_CurrencyNumericCode__f_currencyCode;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Llocales_cldr_CurrencyNumericCode__f_numericCode;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Llocales_cldr_CurrencyNumericCode.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CurrencyNumericCode.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CurrencyNumericCode)) {
    var CurrencyNumericCode$1 = $as_Llocales_cldr_CurrencyNumericCode(x$1);
    return ((this.Llocales_cldr_CurrencyNumericCode__f_numericCode === $n(CurrencyNumericCode$1).Llocales_cldr_CurrencyNumericCode__f_numericCode) && (this.Llocales_cldr_CurrencyNumericCode__f_currencyCode === $n(CurrencyNumericCode$1).Llocales_cldr_CurrencyNumericCode__f_currencyCode))
  } else {
    return false
  }
});
function $as_Llocales_cldr_CurrencyNumericCode(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencyNumericCode) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencyNumericCode"))
}
function $isArrayOf_Llocales_cldr_CurrencyNumericCode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyNumericCode)))
}
function $asArrayOf_Llocales_cldr_CurrencyNumericCode(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencyNumericCode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencyNumericCode;", depth))
}
var $d_Llocales_cldr_CurrencyNumericCode = new $TypeData().initClass({
  Llocales_cldr_CurrencyNumericCode: 0
}, false, "locales.cldr.CurrencyNumericCode", {
  Llocales_cldr_CurrencyNumericCode: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CurrencyNumericCode.prototype.$classData = $d_Llocales_cldr_CurrencyNumericCode;
/** @constructor */
function $c_Llocales_cldr_CurrencySymbol(symbol, alt) {
  this.Llocales_cldr_CurrencySymbol__f_symbol = null;
  this.Llocales_cldr_CurrencySymbol__f_alt = null;
  this.Llocales_cldr_CurrencySymbol__f_symbol = symbol;
  this.Llocales_cldr_CurrencySymbol__f_alt = alt
}
$c_Llocales_cldr_CurrencySymbol.prototype = new $h_O();
$c_Llocales_cldr_CurrencySymbol.prototype.constructor = $c_Llocales_cldr_CurrencySymbol;
/** @constructor */
function $h_Llocales_cldr_CurrencySymbol() {
  /*<skip>*/
}
$h_Llocales_cldr_CurrencySymbol.prototype = $c_Llocales_cldr_CurrencySymbol.prototype;
$c_Llocales_cldr_CurrencySymbol.prototype.productPrefix__T = (function() {
  return "CurrencySymbol"
});
$c_Llocales_cldr_CurrencySymbol.prototype.productArity__I = (function() {
  return 2
});
$c_Llocales_cldr_CurrencySymbol.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CurrencySymbol__f_symbol;
      break
    }
    case 1: {
      return this.Llocales_cldr_CurrencySymbol__f_alt;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CurrencySymbol.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CurrencySymbol.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CurrencySymbol.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CurrencySymbol.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CurrencySymbol)) {
    var CurrencySymbol$1 = $as_Llocales_cldr_CurrencySymbol(x$1);
    if ((this.Llocales_cldr_CurrencySymbol__f_symbol === $n(CurrencySymbol$1).Llocales_cldr_CurrencySymbol__f_symbol)) {
      var x = this.Llocales_cldr_CurrencySymbol__f_alt;
      var x$2 = $n(CurrencySymbol$1).Llocales_cldr_CurrencySymbol__f_alt;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_CurrencySymbol(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencySymbol) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencySymbol"))
}
function $isArrayOf_Llocales_cldr_CurrencySymbol(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencySymbol)))
}
function $asArrayOf_Llocales_cldr_CurrencySymbol(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencySymbol(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencySymbol;", depth))
}
var $d_Llocales_cldr_CurrencySymbol = new $TypeData().initClass({
  Llocales_cldr_CurrencySymbol: 0
}, false, "locales.cldr.CurrencySymbol", {
  Llocales_cldr_CurrencySymbol: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CurrencySymbol.prototype.$classData = $d_Llocales_cldr_CurrencySymbol;
/** @constructor */
function $c_Llocales_cldr_CurrencyType(currencyCode, currencyName) {
  this.Llocales_cldr_CurrencyType__f_currencyCode = null;
  this.Llocales_cldr_CurrencyType__f_currencyName = null;
  this.Llocales_cldr_CurrencyType__f_currencyCode = currencyCode;
  this.Llocales_cldr_CurrencyType__f_currencyName = currencyName
}
$c_Llocales_cldr_CurrencyType.prototype = new $h_O();
$c_Llocales_cldr_CurrencyType.prototype.constructor = $c_Llocales_cldr_CurrencyType;
/** @constructor */
function $h_Llocales_cldr_CurrencyType() {
  /*<skip>*/
}
$h_Llocales_cldr_CurrencyType.prototype = $c_Llocales_cldr_CurrencyType.prototype;
$c_Llocales_cldr_CurrencyType.prototype.productPrefix__T = (function() {
  return "CurrencyType"
});
$c_Llocales_cldr_CurrencyType.prototype.productArity__I = (function() {
  return 2
});
$c_Llocales_cldr_CurrencyType.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_CurrencyType__f_currencyCode;
      break
    }
    case 1: {
      return this.Llocales_cldr_CurrencyType__f_currencyName;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_CurrencyType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_CurrencyType.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_CurrencyType.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_CurrencyType.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_CurrencyType)) {
    var CurrencyType$1 = $as_Llocales_cldr_CurrencyType(x$1);
    return ((this.Llocales_cldr_CurrencyType__f_currencyCode === $n(CurrencyType$1).Llocales_cldr_CurrencyType__f_currencyCode) && (this.Llocales_cldr_CurrencyType__f_currencyName === $n(CurrencyType$1).Llocales_cldr_CurrencyType__f_currencyName))
  } else {
    return false
  }
});
function $as_Llocales_cldr_CurrencyType(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencyType) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencyType"))
}
function $isArrayOf_Llocales_cldr_CurrencyType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyType)))
}
function $asArrayOf_Llocales_cldr_CurrencyType(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencyType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencyType;", depth))
}
var $d_Llocales_cldr_CurrencyType = new $TypeData().initClass({
  Llocales_cldr_CurrencyType: 0
}, false, "locales.cldr.CurrencyType", {
  Llocales_cldr_CurrencyType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_CurrencyType.prototype.$classData = $d_Llocales_cldr_CurrencyType;
function $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__($thiz, parent, locale, defaultNS, digitSymbols, calendarSymbols, calendarPatterns, currencies, numberPatterns) {
  $thiz.Llocales_cldr_LDML__f_parent = parent;
  $thiz.Llocales_cldr_LDML__f_locale = locale;
  $thiz.Llocales_cldr_LDML__f_defaultNS = defaultNS;
  $thiz.Llocales_cldr_LDML__f_digitSymbols = digitSymbols;
  $thiz.Llocales_cldr_LDML__f_calendarSymbols = calendarSymbols;
  $thiz.Llocales_cldr_LDML__f_calendarPatterns = calendarPatterns;
  $thiz.Llocales_cldr_LDML__f_currencies = currencies;
  $thiz.Llocales_cldr_LDML__f_numberPatterns = numberPatterns;
  var this$1 = $n(currencies);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var x$1 = $as_Llocales_cldr_NumberCurrency(elem);
    var key = $n(x$1).Llocales_cldr_NumberCurrency__f_currencyCode;
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => {
      $m_sci_List$();
      return new $c_scm_ListBuffer()
    }))));
    var this$3 = $n(bldr);
    this$3.addOne__O__scm_Growable(elem)
  };
  var this$4 = $m_sci_HashMap$();
  var result = this$4.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
  };
  var this$5 = $n(result);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$5.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1 = $n(it$1).next__O();
    var x0$1 = $as_T2(arg1);
    if ((x0$1 === null)) {
      throw new $c_s_MatchError(x0$1)
    };
    var code = $as_T($n(x0$1)._1__O());
    var list = $as_sci_List($n(x0$1)._2__O());
    var this$7 = $n(code);
    var self = $as_T(this$7.toUpperCase());
    var y = $n(list).head__O();
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var h = $m_sr_Statics$().anyHash__O__I(self);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, self, y, h, im, 0)
  };
  b.result__sci_HashMap();
  return $thiz
}
/** @constructor */
function $c_Llocales_cldr_LDML() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null
}
$c_Llocales_cldr_LDML.prototype = new $h_O();
$c_Llocales_cldr_LDML.prototype.constructor = $c_Llocales_cldr_LDML;
/** @constructor */
function $h_Llocales_cldr_LDML() {
  /*<skip>*/
}
$h_Llocales_cldr_LDML.prototype = $c_Llocales_cldr_LDML.prototype;
$c_Llocales_cldr_LDML.prototype.toLocale__ju_Locale = (function() {
  if (($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_language === "root")) {
    var $$x3 = new $c_ju_Locale$Builder().setLanguage__T__ju_Locale$Builder("");
    var this$1 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_territory);
    var $$x2 = $n($n($$x3).setRegion__T__ju_Locale$Builder($as_T((this$1.isEmpty__Z() ? "" : this$1.get__O()))));
    var this$2 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_script);
    var $$x1 = $n($$x2).setScript__T__ju_Locale$Builder($as_T((this$2.isEmpty__Z() ? "" : this$2.get__O())));
    var this$3 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_variant);
    return $n($n($$x1).setVariant__T__ju_Locale$Builder($as_T((this$3.isEmpty__Z() ? "" : this$3.get__O())))).build__ju_Locale()
  } else {
    var $$x6 = new $c_ju_Locale$Builder().setLanguage__T__ju_Locale$Builder($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_language);
    var this$4 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_territory);
    var $$x5 = $n($n($$x6).setRegion__T__ju_Locale$Builder($as_T((this$4.isEmpty__Z() ? "" : this$4.get__O()))));
    var this$5 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_script);
    var $$x4 = $n($$x5).setScript__T__ju_Locale$Builder($as_T((this$5.isEmpty__Z() ? "" : this$5.get__O())));
    var this$6 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_variant);
    return $n($n($$x4).setVariant__T__ju_Locale$Builder($as_T((this$6.isEmpty__Z() ? "" : this$6.get__O())))).build__ju_Locale()
  }
});
$c_Llocales_cldr_LDML.prototype.productPrefix__T = (function() {
  return "LDML"
});
$c_Llocales_cldr_LDML.prototype.productArity__I = (function() {
  return 8
});
$c_Llocales_cldr_LDML.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_LDML__f_parent;
      break
    }
    case 1: {
      return this.Llocales_cldr_LDML__f_locale;
      break
    }
    case 2: {
      return this.Llocales_cldr_LDML__f_defaultNS;
      break
    }
    case 3: {
      return this.Llocales_cldr_LDML__f_digitSymbols;
      break
    }
    case 4: {
      return this.Llocales_cldr_LDML__f_calendarSymbols;
      break
    }
    case 5: {
      return this.Llocales_cldr_LDML__f_calendarPatterns;
      break
    }
    case 6: {
      return this.Llocales_cldr_LDML__f_currencies;
      break
    }
    case 7: {
      return this.Llocales_cldr_LDML__f_numberPatterns;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_LDML.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_LDML.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_LDML.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_LDML.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_LDML)) {
    var LDML$1 = $as_Llocales_cldr_LDML(x$1);
    var x = this.Llocales_cldr_LDML__f_parent;
    var x$2 = $n(LDML$1).Llocales_cldr_LDML__f_parent;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_LDML__f_locale;
      var x$4 = $n(LDML$1).Llocales_cldr_LDML__f_locale;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Llocales_cldr_LDML__f_defaultNS;
      var x$6 = $n(LDML$1).Llocales_cldr_LDML__f_defaultNS;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Llocales_cldr_LDML__f_digitSymbols;
        var x$8 = $n(LDML$1).Llocales_cldr_LDML__f_digitSymbols;
        var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Llocales_cldr_LDML__f_calendarSymbols;
      var x$10 = $n(LDML$1).Llocales_cldr_LDML__f_calendarSymbols;
      if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
        var x$11 = this.Llocales_cldr_LDML__f_calendarPatterns;
        var x$12 = $n(LDML$1).Llocales_cldr_LDML__f_calendarPatterns;
        var $$x3 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$13 = this.Llocales_cldr_LDML__f_currencies;
        var x$14 = $n(LDML$1).Llocales_cldr_LDML__f_currencies;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          var x$15 = this.Llocales_cldr_LDML__f_numberPatterns;
          var x$16 = $n(LDML$1).Llocales_cldr_LDML__f_numberPatterns;
          if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
            $n(LDML$1);
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_LDML(obj) {
  return (((obj instanceof $c_Llocales_cldr_LDML) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.LDML"))
}
function $isArrayOf_Llocales_cldr_LDML(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LDML)))
}
function $asArrayOf_Llocales_cldr_LDML(obj, depth) {
  return (($isArrayOf_Llocales_cldr_LDML(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.LDML;", depth))
}
var $d_Llocales_cldr_LDML = new $TypeData().initClass({
  Llocales_cldr_LDML: 0
}, false, "locales.cldr.LDML", {
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_LDML.prototype.$classData = $d_Llocales_cldr_LDML;
/** @constructor */
function $c_Llocales_cldr_LDMLLocale(language, territory, variant, script) {
  this.Llocales_cldr_LDMLLocale__f_language = null;
  this.Llocales_cldr_LDMLLocale__f_territory = null;
  this.Llocales_cldr_LDMLLocale__f_variant = null;
  this.Llocales_cldr_LDMLLocale__f_script = null;
  this.Llocales_cldr_LDMLLocale__f_language = language;
  this.Llocales_cldr_LDMLLocale__f_territory = territory;
  this.Llocales_cldr_LDMLLocale__f_variant = variant;
  this.Llocales_cldr_LDMLLocale__f_script = script
}
$c_Llocales_cldr_LDMLLocale.prototype = new $h_O();
$c_Llocales_cldr_LDMLLocale.prototype.constructor = $c_Llocales_cldr_LDMLLocale;
/** @constructor */
function $h_Llocales_cldr_LDMLLocale() {
  /*<skip>*/
}
$h_Llocales_cldr_LDMLLocale.prototype = $c_Llocales_cldr_LDMLLocale.prototype;
$c_Llocales_cldr_LDMLLocale.prototype.productPrefix__T = (function() {
  return "LDMLLocale"
});
$c_Llocales_cldr_LDMLLocale.prototype.productArity__I = (function() {
  return 4
});
$c_Llocales_cldr_LDMLLocale.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_LDMLLocale__f_language;
      break
    }
    case 1: {
      return this.Llocales_cldr_LDMLLocale__f_territory;
      break
    }
    case 2: {
      return this.Llocales_cldr_LDMLLocale__f_variant;
      break
    }
    case 3: {
      return this.Llocales_cldr_LDMLLocale__f_script;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_LDMLLocale.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_LDMLLocale.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_LDMLLocale.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_LDMLLocale.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_LDMLLocale)) {
    var LDMLLocale$1 = $as_Llocales_cldr_LDMLLocale(x$1);
    if ((this.Llocales_cldr_LDMLLocale__f_language === $n(LDMLLocale$1).Llocales_cldr_LDMLLocale__f_language)) {
      var x = this.Llocales_cldr_LDMLLocale__f_territory;
      var x$2 = $n(LDMLLocale$1).Llocales_cldr_LDMLLocale__f_territory;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Llocales_cldr_LDMLLocale__f_variant;
      var x$4 = $n(LDMLLocale$1).Llocales_cldr_LDMLLocale__f_variant;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Llocales_cldr_LDMLLocale__f_script;
        var x$6 = $n(LDMLLocale$1).Llocales_cldr_LDMLLocale__f_script;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          $n(LDMLLocale$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_LDMLLocale(obj) {
  return (((obj instanceof $c_Llocales_cldr_LDMLLocale) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.LDMLLocale"))
}
function $isArrayOf_Llocales_cldr_LDMLLocale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LDMLLocale)))
}
function $asArrayOf_Llocales_cldr_LDMLLocale(obj, depth) {
  return (($isArrayOf_Llocales_cldr_LDMLLocale(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.LDMLLocale;", depth))
}
var $d_Llocales_cldr_LDMLLocale = new $TypeData().initClass({
  Llocales_cldr_LDMLLocale: 0
}, false, "locales.cldr.LDMLLocale", {
  Llocales_cldr_LDMLLocale: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_LDMLLocale.prototype.$classData = $d_Llocales_cldr_LDMLLocale;
/** @constructor */
function $c_Llocales_cldr_NumberCurrency(currencyCode, symbols, displayNames) {
  this.Llocales_cldr_NumberCurrency__f_currencyCode = null;
  this.Llocales_cldr_NumberCurrency__f_symbols = null;
  this.Llocales_cldr_NumberCurrency__f_displayNames = null;
  this.Llocales_cldr_NumberCurrency__f_currencyCode = currencyCode;
  this.Llocales_cldr_NumberCurrency__f_symbols = symbols;
  this.Llocales_cldr_NumberCurrency__f_displayNames = displayNames
}
$c_Llocales_cldr_NumberCurrency.prototype = new $h_O();
$c_Llocales_cldr_NumberCurrency.prototype.constructor = $c_Llocales_cldr_NumberCurrency;
/** @constructor */
function $h_Llocales_cldr_NumberCurrency() {
  /*<skip>*/
}
$h_Llocales_cldr_NumberCurrency.prototype = $c_Llocales_cldr_NumberCurrency.prototype;
$c_Llocales_cldr_NumberCurrency.prototype.productPrefix__T = (function() {
  return "NumberCurrency"
});
$c_Llocales_cldr_NumberCurrency.prototype.productArity__I = (function() {
  return 3
});
$c_Llocales_cldr_NumberCurrency.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_NumberCurrency__f_currencyCode;
      break
    }
    case 1: {
      return this.Llocales_cldr_NumberCurrency__f_symbols;
      break
    }
    case 2: {
      return this.Llocales_cldr_NumberCurrency__f_displayNames;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_NumberCurrency.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_NumberCurrency.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_NumberCurrency.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_NumberCurrency.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_NumberCurrency)) {
    var NumberCurrency$1 = $as_Llocales_cldr_NumberCurrency(x$1);
    if ((this.Llocales_cldr_NumberCurrency__f_currencyCode === $n(NumberCurrency$1).Llocales_cldr_NumberCurrency__f_currencyCode)) {
      var x = this.Llocales_cldr_NumberCurrency__f_symbols;
      var x$2 = $n(NumberCurrency$1).Llocales_cldr_NumberCurrency__f_symbols;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Llocales_cldr_NumberCurrency__f_displayNames;
        var x$4 = $n(NumberCurrency$1).Llocales_cldr_NumberCurrency__f_displayNames;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_NumberCurrency(obj) {
  return (((obj instanceof $c_Llocales_cldr_NumberCurrency) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.NumberCurrency"))
}
function $isArrayOf_Llocales_cldr_NumberCurrency(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberCurrency)))
}
function $asArrayOf_Llocales_cldr_NumberCurrency(obj, depth) {
  return (($isArrayOf_Llocales_cldr_NumberCurrency(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.NumberCurrency;", depth))
}
var $d_Llocales_cldr_NumberCurrency = new $TypeData().initClass({
  Llocales_cldr_NumberCurrency: 0
}, false, "locales.cldr.NumberCurrency", {
  Llocales_cldr_NumberCurrency: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_NumberCurrency.prototype.$classData = $d_Llocales_cldr_NumberCurrency;
/** @constructor */
function $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat) {
  this.Llocales_cldr_NumberPatterns__f_decimalFormat = null;
  this.Llocales_cldr_NumberPatterns__f_percentFormat = null;
  this.Llocales_cldr_NumberPatterns__f_currencyFormat = null;
  this.Llocales_cldr_NumberPatterns__f_decimalFormat = decimalFormat;
  this.Llocales_cldr_NumberPatterns__f_percentFormat = percentFormat;
  this.Llocales_cldr_NumberPatterns__f_currencyFormat = currencyFormat
}
$c_Llocales_cldr_NumberPatterns.prototype = new $h_O();
$c_Llocales_cldr_NumberPatterns.prototype.constructor = $c_Llocales_cldr_NumberPatterns;
/** @constructor */
function $h_Llocales_cldr_NumberPatterns() {
  /*<skip>*/
}
$h_Llocales_cldr_NumberPatterns.prototype = $c_Llocales_cldr_NumberPatterns.prototype;
$c_Llocales_cldr_NumberPatterns.prototype.productPrefix__T = (function() {
  return "NumberPatterns"
});
$c_Llocales_cldr_NumberPatterns.prototype.productArity__I = (function() {
  return 3
});
$c_Llocales_cldr_NumberPatterns.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_NumberPatterns__f_decimalFormat;
      break
    }
    case 1: {
      return this.Llocales_cldr_NumberPatterns__f_percentFormat;
      break
    }
    case 2: {
      return this.Llocales_cldr_NumberPatterns__f_currencyFormat;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_NumberPatterns.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_NumberPatterns.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_NumberPatterns.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_NumberPatterns.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_NumberPatterns)) {
    var NumberPatterns$1 = $as_Llocales_cldr_NumberPatterns(x$1);
    var x = this.Llocales_cldr_NumberPatterns__f_decimalFormat;
    var x$2 = $n(NumberPatterns$1).Llocales_cldr_NumberPatterns__f_decimalFormat;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_NumberPatterns__f_percentFormat;
      var x$4 = $n(NumberPatterns$1).Llocales_cldr_NumberPatterns__f_percentFormat;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Llocales_cldr_NumberPatterns__f_currencyFormat;
      var x$6 = $n(NumberPatterns$1).Llocales_cldr_NumberPatterns__f_currencyFormat;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(NumberPatterns$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_NumberPatterns(obj) {
  return (((obj instanceof $c_Llocales_cldr_NumberPatterns) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.NumberPatterns"))
}
function $isArrayOf_Llocales_cldr_NumberPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberPatterns)))
}
function $asArrayOf_Llocales_cldr_NumberPatterns(obj, depth) {
  return (($isArrayOf_Llocales_cldr_NumberPatterns(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.NumberPatterns;", depth))
}
var $d_Llocales_cldr_NumberPatterns = new $TypeData().initClass({
  Llocales_cldr_NumberPatterns: 0
}, false, "locales.cldr.NumberPatterns", {
  Llocales_cldr_NumberPatterns: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_NumberPatterns.prototype.$classData = $d_Llocales_cldr_NumberPatterns;
/** @constructor */
function $c_Llocales_cldr_NumberingSystem(id, digits) {
  this.Llocales_cldr_NumberingSystem__f_id = null;
  this.Llocales_cldr_NumberingSystem__f_digits = null;
  this.Llocales_cldr_NumberingSystem__f_id = id;
  this.Llocales_cldr_NumberingSystem__f_digits = digits
}
$c_Llocales_cldr_NumberingSystem.prototype = new $h_O();
$c_Llocales_cldr_NumberingSystem.prototype.constructor = $c_Llocales_cldr_NumberingSystem;
/** @constructor */
function $h_Llocales_cldr_NumberingSystem() {
  /*<skip>*/
}
$h_Llocales_cldr_NumberingSystem.prototype = $c_Llocales_cldr_NumberingSystem.prototype;
$c_Llocales_cldr_NumberingSystem.prototype.productPrefix__T = (function() {
  return "NumberingSystem"
});
$c_Llocales_cldr_NumberingSystem.prototype.productArity__I = (function() {
  return 2
});
$c_Llocales_cldr_NumberingSystem.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_NumberingSystem__f_id;
      break
    }
    case 1: {
      return this.Llocales_cldr_NumberingSystem__f_digits;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_NumberingSystem.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_NumberingSystem.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_NumberingSystem.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_NumberingSystem.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_NumberingSystem)) {
    var NumberingSystem$1 = $as_Llocales_cldr_NumberingSystem(x$1);
    if ((this.Llocales_cldr_NumberingSystem__f_id === $n(NumberingSystem$1).Llocales_cldr_NumberingSystem__f_id)) {
      var x = this.Llocales_cldr_NumberingSystem__f_digits;
      var x$2 = $n(NumberingSystem$1).Llocales_cldr_NumberingSystem__f_digits;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        $n(NumberingSystem$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_NumberingSystem(obj) {
  return (((obj instanceof $c_Llocales_cldr_NumberingSystem) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.NumberingSystem"))
}
function $isArrayOf_Llocales_cldr_NumberingSystem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberingSystem)))
}
function $asArrayOf_Llocales_cldr_NumberingSystem(obj, depth) {
  return (($isArrayOf_Llocales_cldr_NumberingSystem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.NumberingSystem;", depth))
}
var $d_Llocales_cldr_NumberingSystem = new $TypeData().initClass({
  Llocales_cldr_NumberingSystem: 0
}, false, "locales.cldr.NumberingSystem", {
  Llocales_cldr_NumberingSystem: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_NumberingSystem.prototype.$classData = $d_Llocales_cldr_NumberingSystem;
/** @constructor */
function $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp) {
  this.Llocales_cldr_Symbols__f_ns = null;
  this.Llocales_cldr_Symbols__f_aliasOf = null;
  this.Llocales_cldr_Symbols__f_decimal = null;
  this.Llocales_cldr_Symbols__f_group = null;
  this.Llocales_cldr_Symbols__f_list = null;
  this.Llocales_cldr_Symbols__f_percent = null;
  this.Llocales_cldr_Symbols__f_minus = null;
  this.Llocales_cldr_Symbols__f_perMille = null;
  this.Llocales_cldr_Symbols__f_infinity = null;
  this.Llocales_cldr_Symbols__f_nan = null;
  this.Llocales_cldr_Symbols__f_exp = null;
  this.Llocales_cldr_Symbols__f_ns = ns;
  this.Llocales_cldr_Symbols__f_aliasOf = aliasOf;
  this.Llocales_cldr_Symbols__f_decimal = decimal;
  this.Llocales_cldr_Symbols__f_group = group;
  this.Llocales_cldr_Symbols__f_list = list;
  this.Llocales_cldr_Symbols__f_percent = percent;
  this.Llocales_cldr_Symbols__f_minus = minus;
  this.Llocales_cldr_Symbols__f_perMille = perMille;
  this.Llocales_cldr_Symbols__f_infinity = infinity;
  this.Llocales_cldr_Symbols__f_nan = nan;
  this.Llocales_cldr_Symbols__f_exp = exp
}
$c_Llocales_cldr_Symbols.prototype = new $h_O();
$c_Llocales_cldr_Symbols.prototype.constructor = $c_Llocales_cldr_Symbols;
/** @constructor */
function $h_Llocales_cldr_Symbols() {
  /*<skip>*/
}
$h_Llocales_cldr_Symbols.prototype = $c_Llocales_cldr_Symbols.prototype;
$c_Llocales_cldr_Symbols.prototype.productPrefix__T = (function() {
  return "Symbols"
});
$c_Llocales_cldr_Symbols.prototype.productArity__I = (function() {
  return 11
});
$c_Llocales_cldr_Symbols.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Llocales_cldr_Symbols__f_ns;
      break
    }
    case 1: {
      return this.Llocales_cldr_Symbols__f_aliasOf;
      break
    }
    case 2: {
      return this.Llocales_cldr_Symbols__f_decimal;
      break
    }
    case 3: {
      return this.Llocales_cldr_Symbols__f_group;
      break
    }
    case 4: {
      return this.Llocales_cldr_Symbols__f_list;
      break
    }
    case 5: {
      return this.Llocales_cldr_Symbols__f_percent;
      break
    }
    case 6: {
      return this.Llocales_cldr_Symbols__f_minus;
      break
    }
    case 7: {
      return this.Llocales_cldr_Symbols__f_perMille;
      break
    }
    case 8: {
      return this.Llocales_cldr_Symbols__f_infinity;
      break
    }
    case 9: {
      return this.Llocales_cldr_Symbols__f_nan;
      break
    }
    case 10: {
      return this.Llocales_cldr_Symbols__f_exp;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Llocales_cldr_Symbols.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Llocales_cldr_Symbols.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Llocales_cldr_Symbols.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Llocales_cldr_Symbols.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Llocales_cldr_Symbols)) {
    var Symbols$1 = $as_Llocales_cldr_Symbols(x$1);
    var x = this.Llocales_cldr_Symbols__f_ns;
    var x$2 = $n(Symbols$1).Llocales_cldr_Symbols__f_ns;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_Symbols__f_aliasOf;
      var x$4 = $n(Symbols$1).Llocales_cldr_Symbols__f_aliasOf;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Llocales_cldr_Symbols__f_decimal;
        var x$6 = $n(Symbols$1).Llocales_cldr_Symbols__f_decimal;
        var $$x2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Llocales_cldr_Symbols__f_group;
      var x$8 = $n(Symbols$1).Llocales_cldr_Symbols__f_group;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Llocales_cldr_Symbols__f_list;
        var x$10 = $n(Symbols$1).Llocales_cldr_Symbols__f_list;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Llocales_cldr_Symbols__f_percent;
          var x$12 = $n(Symbols$1).Llocales_cldr_Symbols__f_percent;
          var $$x1 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$13 = this.Llocales_cldr_Symbols__f_minus;
      var x$14 = $n(Symbols$1).Llocales_cldr_Symbols__f_minus;
      if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
        var x$15 = this.Llocales_cldr_Symbols__f_perMille;
        var x$16 = $n(Symbols$1).Llocales_cldr_Symbols__f_perMille;
        if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
          var x$17 = this.Llocales_cldr_Symbols__f_infinity;
          var x$18 = $n(Symbols$1).Llocales_cldr_Symbols__f_infinity;
          var $$x3 = ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))
        } else {
          var $$x3 = false
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$19 = this.Llocales_cldr_Symbols__f_nan;
        var x$20 = $n(Symbols$1).Llocales_cldr_Symbols__f_nan;
        if (((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))) {
          var x$21 = this.Llocales_cldr_Symbols__f_exp;
          var x$22 = $n(Symbols$1).Llocales_cldr_Symbols__f_exp;
          if (((x$21 === null) ? (x$22 === null) : $n(x$21).equals__O__Z(x$22))) {
            $n(Symbols$1);
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Llocales_cldr_Symbols(obj) {
  return (((obj instanceof $c_Llocales_cldr_Symbols) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.Symbols"))
}
function $isArrayOf_Llocales_cldr_Symbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_Symbols)))
}
function $asArrayOf_Llocales_cldr_Symbols(obj, depth) {
  return (($isArrayOf_Llocales_cldr_Symbols(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.Symbols;", depth))
}
var $d_Llocales_cldr_Symbols = new $TypeData().initClass({
  Llocales_cldr_Symbols: 0
}, false, "locales.cldr.Symbols", {
  Llocales_cldr_Symbols: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_Symbols.prototype.$classData = $d_Llocales_cldr_Symbols;
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListIterator(domList) {
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList = null;
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index = 0;
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList = domList;
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index = 0
}
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = new $h_O();
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListIterator;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListIterator() {
  /*<skip>*/
}
$h_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = $c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype;
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.hasNext__Z = (function() {
  return (this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index < $uI(this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList.length))
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.next__O = (function() {
  var res = this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList[this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index];
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index = ((1 + this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index) | 0);
  return res
});
var $d_Lorg_scalajs_dom_DOMList$DOMListIterator = new $TypeData().initClass({
  Lorg_scalajs_dom_DOMList$DOMListIterator: 0
}, false, "org.scalajs.dom.DOMList$DOMListIterator", {
  Lorg_scalajs_dom_DOMList$DOMListIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.$classData = $d_Lorg_scalajs_dom_DOMList$DOMListIterator;
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z($thiz) {
  if ((($as_T((typeof postMessage)) !== "undefined") && ($as_T((typeof importScripts)) === "undefined"))) {
    var postMessageIsAsynchronous = new $c_sr_BooleanRef(true);
    var oldOnMessage = onmessage;
    try {
      onmessage = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
        postMessageIsAsynchronous.sr_BooleanRef__f_elem = false
      })));
      postMessage("", "*");
      onmessage = oldOnMessage;
      return postMessageIsAsynchronous.sr_BooleanRef__f_elem
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      var o13 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(o13).isEmpty__Z())) {
        return false
      };
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
    }
  } else {
    return false
  }
}
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__I__sr_BooleanRef__scm_Map__V($thiz, handle, currentlyRunningATask$1, tasksByHandle$1) {
  if ($n(currentlyRunningATask$1).sr_BooleanRef__f_elem) {
    setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
      $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__I__sr_BooleanRef__scm_Map__V($thiz, handle, currentlyRunningATask$1, tasksByHandle$1)
    }))), 0)
  } else {
    var x1 = $n(tasksByHandle$1).get__O__s_Option(handle);
    if ((x1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x1);
      var task = $as_F0($n(x2).s_Some__f_value);
      $n(currentlyRunningATask$1).sr_BooleanRef__f_elem = true;
      try {
        var this$3 = $n(task);
        this$3.apply__O()
      } finally {
        var this$4 = $n(tasksByHandle$1);
        this$4.subtractOne__O__scm_Shrinkable(handle);
        $n(currentlyRunningATask$1).sr_BooleanRef__f_elem = false
      }
    } else {
      var x = $m_s_None$();
      if ((!(x === x1))) {
        throw new $c_s_MatchError(x1)
      }
    }
  }
}
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__sjs_js_Dynamic__T__sr_BooleanRef__scm_Map__V($thiz, event, messagePrefix$1, currentlyRunningATask$1, tasksByHandle$1) {
  if ((($as_T((typeof event.data)) === "string") && ($uI(event.data.indexOf(messagePrefix$1)) === 0))) {
    $m_sc_StringOps$();
    var this$3 = $n($dp_toString__T($n(event.data)));
    var this$2 = $n(messagePrefix$1);
    var beginIndex = this$2.length;
    if (((beginIndex < 0) || (beginIndex > this$3.length))) {
      $charAt(this$3, beginIndex)
    };
    var x = $as_T(this$3.substring(beginIndex));
    var this$6 = $m_jl_Integer$();
    $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__I__sr_BooleanRef__scm_Map__V($thiz, this$6.parseInt__T__I__I(x, 10), currentlyRunningATask$1, tasksByHandle$1)
  }
}
/** @constructor */
function $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = null;
  $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = this;
  if (($as_T((typeof setImmediate)) === "undefined")) {
    var nextHandle = new $c_sr_IntRef(1);
    var tasksByHandle = $as_scm_Map($m_scm_Map$().apply__sci_Seq__O($m_sci_Nil$()));
    var currentlyRunningATask = new $c_sr_BooleanRef(false);
    if ($p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z(this)) {
      var this$3 = $m_s_util_Random$();
      var this$4 = $n(this$3.s_util_Random__f_self);
      var messagePrefix = (("setImmediate$" + this$4.next__I__I(32)) + "$");
      if (($as_T((typeof addEventListener)) !== "undefined")) {
        addEventListener("message", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((event$2) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__sjs_js_Dynamic__T__sr_BooleanRef__scm_Map__V(this, event$2, messagePrefix, currentlyRunningATask, tasksByHandle)
        }))), false)
      } else {
        attachEvent("onmessage", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((event$3$2) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__sjs_js_Dynamic__T__sr_BooleanRef__scm_Map__V(this, event$3$2, messagePrefix, currentlyRunningATask, tasksByHandle)
        }))))
      };
      var $$x4 = new $c_sjsr_AnonFunction1(((k$2) => {
        var k = $as_F0(k$2);
        var handle = nextHandle.sr_IntRef__f_elem;
        nextHandle.sr_IntRef__f_elem = ((1 + nextHandle.sr_IntRef__f_elem) | 0);
        var this$11 = $n(tasksByHandle);
        var elem = $ct_T2__O__O__(new $c_T2(), handle, k);
        this$11.addOne__O__scm_Growable(elem);
        var $$x5 = postMessage;
        var s = (messagePrefix + handle);
        $$x5(s, "*")
      }))
    } else if (($as_T((typeof MessageChannel)) !== "undefined")) {
      var channel = new MessageChannel();
      channel.port1.onmessage = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((event$4$2) => {
        $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__I__sr_BooleanRef__scm_Map__V(this, $uI(event$4$2.data), currentlyRunningATask, tasksByHandle)
      })));
      var $$x4 = new $c_sjsr_AnonFunction1(((k$3$2) => {
        var k$3 = $as_F0(k$3$2);
        var handle$1 = nextHandle.sr_IntRef__f_elem;
        nextHandle.sr_IntRef__f_elem = ((1 + nextHandle.sr_IntRef__f_elem) | 0);
        var this$16 = $n(tasksByHandle);
        var elem$1 = $ct_T2__O__O__(new $c_T2(), handle$1, k$3);
        this$16.addOne__O__scm_Growable(elem$1);
        channel.port2.postMessage(handle$1)
      }))
    } else {
      if (($as_T((typeof navigator)) !== "undefined")) {
        var value = navigator.userAgent;
        if ((value !== (void 0))) {
          var x$1 = $as_T(value);
          var this$23 = $n(x$1);
          var $$x6 = ($uI(this$23.indexOf("jsdom")) !== (-1))
        } else {
          var $$x6 = false
        }
      } else {
        var $$x6 = false
      };
      if ($$x6) {
        var setImmediate$1 = Node.constructor("return setImmediate")();
        var $$x4 = new $c_sjsr_AnonFunction1(((k$4$2) => {
          var k$4 = $as_F0(k$4$2);
          setImmediate$1($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$4))
        }))
      } else {
        var $$x4 = new $c_sjsr_AnonFunction1(((k$5$2) => {
          var k$5 = $as_F0(k$5$2);
          setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$5), 0)
        }))
      }
    }
  } else {
    var $$x4 = new $c_sjsr_AnonFunction1(((k$6$2) => {
      var k$6 = $as_F0(k$6$2);
      setImmediate($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$6))
    }))
  };
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = $$x4
}
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = new $h_O();
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.constructor = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
/** @constructor */
function $h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  /*<skip>*/
}
$h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype;
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.execute__jl_Runnable__V = (function(runnable) {
  $n(this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate).apply__O__O(new $c_sjsr_AnonFunction0((() => {
    $n(runnable).run__V()
  })))
});
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.reportFailure__jl_Throwable__V = (function(cause) {
  var this$1 = $n(cause);
  this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
});
var $d_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $TypeData().initClass({
  Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$: 0
}, false, "org.scalajs.macrotaskexecutor.MacrotaskExecutor$", {
  Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$: 1,
  O: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1
});
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.$classData = $d_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
var $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
function $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  if ((!$n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$)) {
    $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()
  };
  return $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$
}
/** @constructor */
function $c_Lreactbuild_Loc$BusinessOpportunities$() {
  /*<skip>*/
}
$c_Lreactbuild_Loc$BusinessOpportunities$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_Loc$BusinessOpportunities$.prototype.constructor = $c_Lreactbuild_Loc$BusinessOpportunities$;
/** @constructor */
function $h_Lreactbuild_Loc$BusinessOpportunities$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$BusinessOpportunities$.prototype = $c_Lreactbuild_Loc$BusinessOpportunities$.prototype;
$c_Lreactbuild_Loc$BusinessOpportunities$.prototype.toString__T = (function() {
  return "BusinessOpportunities"
});
$c_Lreactbuild_Loc$BusinessOpportunities$.prototype.apply__O__O = (function(v1) {
  var view = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step(v1);
  return new $c_Lreactbuild_Loc$BusinessOpportunities(view)
});
var $d_Lreactbuild_Loc$BusinessOpportunities$ = new $TypeData().initClass({
  Lreactbuild_Loc$BusinessOpportunities$: 0
}, false, "reactbuild.Loc$BusinessOpportunities$", {
  Lreactbuild_Loc$BusinessOpportunities$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$BusinessOpportunities$.prototype.$classData = $d_Lreactbuild_Loc$BusinessOpportunities$;
var $n_Lreactbuild_Loc$BusinessOpportunities$;
function $m_Lreactbuild_Loc$BusinessOpportunities$() {
  if ((!$n_Lreactbuild_Loc$BusinessOpportunities$)) {
    $n_Lreactbuild_Loc$BusinessOpportunities$ = new $c_Lreactbuild_Loc$BusinessOpportunities$()
  };
  return $n_Lreactbuild_Loc$BusinessOpportunities$
}
/** @constructor */
function $c_Lreactbuild_Loc$Project$() {
  /*<skip>*/
}
$c_Lreactbuild_Loc$Project$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_Loc$Project$.prototype.constructor = $c_Lreactbuild_Loc$Project$;
/** @constructor */
function $h_Lreactbuild_Loc$Project$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Project$.prototype = $c_Lreactbuild_Loc$Project$.prototype;
$c_Lreactbuild_Loc$Project$.prototype.toString__T = (function() {
  return "Project"
});
$c_Lreactbuild_Loc$Project$.prototype.apply__O__O = (function(v1) {
  var page = $as_Lreactbuild_analyze_cost_modules_project_ProjectView(v1);
  return new $c_Lreactbuild_Loc$Project(page)
});
var $d_Lreactbuild_Loc$Project$ = new $TypeData().initClass({
  Lreactbuild_Loc$Project$: 0
}, false, "reactbuild.Loc$Project$", {
  Lreactbuild_Loc$Project$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Project$.prototype.$classData = $d_Lreactbuild_Loc$Project$;
var $n_Lreactbuild_Loc$Project$;
function $m_Lreactbuild_Loc$Project$() {
  if ((!$n_Lreactbuild_Loc$Project$)) {
    $n_Lreactbuild_Loc$Project$ = new $c_Lreactbuild_Loc$Project$()
  };
  return $n_Lreactbuild_Loc$Project$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area, handle) {
  this.Lreactbuild_analyze_cost_components_AreaWithHandle__f_area = null;
  this.Lreactbuild_analyze_cost_components_AreaWithHandle__f_handle = null;
  this.Lreactbuild_analyze_cost_components_AreaWithHandle__f_area = area;
  this.Lreactbuild_analyze_cost_components_AreaWithHandle__f_handle = handle
}
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype.constructor = $c_Lreactbuild_analyze_cost_components_AreaWithHandle;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_AreaWithHandle() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype = $c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype;
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype.productPrefix__T = (function() {
  return "AreaWithHandle"
});
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_AreaWithHandle__f_area;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_AreaWithHandle__f_handle;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_AreaWithHandle)) {
    var AreaWithHandle$1 = $as_Lreactbuild_analyze_cost_components_AreaWithHandle(x$1);
    var x = this.Lreactbuild_analyze_cost_components_AreaWithHandle__f_area;
    var x$2 = $n(AreaWithHandle$1).Lreactbuild_analyze_cost_components_AreaWithHandle__f_area;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_AreaWithHandle__f_handle;
      var x$4 = $n(AreaWithHandle$1).Lreactbuild_analyze_cost_components_AreaWithHandle__f_handle;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_AreaWithHandle(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_AreaWithHandle) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.AreaWithHandle"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_AreaWithHandle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_AreaWithHandle)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_AreaWithHandle(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_AreaWithHandle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.AreaWithHandle;", depth))
}
var $d_Lreactbuild_analyze_cost_components_AreaWithHandle = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_AreaWithHandle: 0
}, false, "reactbuild.analyze.cost.components.AreaWithHandle", {
  Lreactbuild_analyze_cost_components_AreaWithHandle: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_AreaWithHandle.prototype.$classData = $d_Lreactbuild_analyze_cost_components_AreaWithHandle;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps(state, updater, render, reusableT, keyMapper) {
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_state = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_updater = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_render = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_reusableT = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_keyMapper = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_key = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_state = state;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_updater = updater;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_render = render;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_reusableT = reusableT;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_keyMapper = keyMapper;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_key = $as_T($n(keyMapper).apply__O__O($n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))
}
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.isSameItem__O__Z = (function(value) {
  return $uZ($n($m_Lreactbuild_analyze_cost_components_AutomaticallySave$().Lreactbuild_analyze_cost_components_AutomaticallySave$__f_reusableKey).apply__O__O__O($n(this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_keyMapper).apply__O__O(value), this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_key))
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.deriveState__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState = (function() {
  return new $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState($n(this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, $n(this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_state;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_updater;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_render;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_state;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_state;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_updater;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_updater;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_render;
        var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_render;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.AutomaticallySave$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.AutomaticallySave$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps: 0
}, false, "reactbuild.analyze.cost.components.AutomaticallySave$TypedProps", {
  Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(current, original) {
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_current = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_original = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_current = current;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_original = original
}
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype;
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_current;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_original;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(x$1);
    var x = this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_current;
    var y = $n(TypedState$1).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_current;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_original;
      var y$1 = $n(TypedState$1).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_original;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.AutomaticallySave$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.AutomaticallySave$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState: 0
}, false, "reactbuild.analyze.cost.components.AutomaticallySave$TypedState", {
  Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Changelog$Event(title, path) {
  this.Lreactbuild_analyze_cost_components_Changelog$Event__f_title = null;
  this.Lreactbuild_analyze_cost_components_Changelog$Event__f_path = null;
  this.Lreactbuild_analyze_cost_components_Changelog$Event__f_title = title;
  this.Lreactbuild_analyze_cost_components_Changelog$Event__f_path = path
}
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Changelog$Event;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Changelog$Event() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Changelog$Event.prototype = $c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype;
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.render__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  var this$24 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = this.Lreactbuild_analyze_cost_components_Changelog$Event__f_title;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $as_sc_IterableOnce($n(this.Lreactbuild_analyze_cost_components_Changelog$Event__f_path).map__F1__O(new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_T(x$2$2);
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).fontWeight__Ljapgolly_scalajs_react_vdom_HtmlStyles$fontWeight$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("bold", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("margin")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0 0.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(x$2))];
    return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }))));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("[");
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" > ");
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("]");
  var this$20 = $m_s_$less$colon$less$();
  var array$1 = [$$x6, $n($$x5).mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, $$x3, $$x2, $$x1, this$20.s_$less$colon$less$__f_singleton)];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  return this$24.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
});
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.productPrefix__T = (function() {
  return "Event"
});
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_Changelog$Event__f_title;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_Changelog$Event__f_path;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Changelog$Event)) {
    var Event$1 = $as_Lreactbuild_analyze_cost_components_Changelog$Event(x$1);
    if ((this.Lreactbuild_analyze_cost_components_Changelog$Event__f_title === $n(Event$1).Lreactbuild_analyze_cost_components_Changelog$Event__f_title)) {
      var x = this.Lreactbuild_analyze_cost_components_Changelog$Event__f_path;
      var x$2 = $n(Event$1).Lreactbuild_analyze_cost_components_Changelog$Event__f_path;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_Changelog$Event(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Changelog$Event) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Changelog$Event"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Changelog$Event(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Changelog$Event)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Changelog$Event(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Changelog$Event(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Changelog$Event;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Changelog$Event = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Changelog$Event: 0
}, false, "reactbuild.analyze.cost.components.Changelog$Event", {
  Lreactbuild_analyze_cost_components_Changelog$Event: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Changelog$Event.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Changelog$Event;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(document, pageProps) {
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document = document;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_pageProps = pageProps
}
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype = $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype;
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_pageProps;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_document;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_pageProps;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$Props__f_pageProps;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.DocumentPageEditor$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_DocumentPageEditor$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.DocumentPageEditor$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DocumentPageEditor$Props: 0
}, false, "reactbuild.analyze.cost.components.DocumentPageEditor$Props", {
  Lreactbuild_analyze_cost_components_DocumentPageEditor$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DocumentPageEditor$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(newDetail, selectedDetails, pdfText, checkboxDragging) {
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail = newDetail;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails = selectedDetails;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText = pdfText;
  this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging = checkboxDragging
}
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DocumentPageEditor$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype = $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype;
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(x$1);
    var x = this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_newDetail;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails;
      var x$4 = $n(State$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_selectedDetails;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
      var x$6 = $n(State$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_pdfText;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging;
        var x$8 = $n(State$1).Lreactbuild_analyze_cost_components_DocumentPageEditor$State__f_checkboxDragging;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.DocumentPageEditor$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_DocumentPageEditor$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageEditor$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.DocumentPageEditor$State;", depth))
}
var $d_Lreactbuild_analyze_cost_components_DocumentPageEditor$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DocumentPageEditor$State: 0
}, false, "reactbuild.analyze.cost.components.DocumentPageEditor$State", {
  Lreactbuild_analyze_cost_components_DocumentPageEditor$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageEditor$State.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DocumentPageEditor$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props(invoicePageGroup, pageProps) {
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_invoicePageGroup = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_invoicePageGroup = invoicePageGroup;
  this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_pageProps = pageProps
}
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype = $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype;
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_invoicePageGroup : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_invoicePageGroup;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props__f_invoicePageGroup;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.DocumentPageGroupEditor$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.DocumentPageGroupEditor$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props: 0
}, false, "reactbuild.analyze.cost.components.DocumentPageGroupEditor$Props", {
  Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DocumentPageGroupEditor$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DocumentPageList$Props(invoicePageGroup, active) {
  this.Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_invoicePageGroup = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_active = null;
  this.Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_invoicePageGroup = invoicePageGroup;
  this.Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_active = active
}
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DocumentPageList$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DocumentPageList$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype = $c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype;
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_invoicePageGroup;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_active;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageList$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_DocumentPageList$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_invoicePageGroup;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_invoicePageGroup;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_active;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_components_DocumentPageList$Props__f_active;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_DocumentPageList$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_DocumentPageList$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.DocumentPageList$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageList$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_DocumentPageList$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_DocumentPageList$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_DocumentPageList$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.DocumentPageList$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_DocumentPageList$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DocumentPageList$Props: 0
}, false, "reactbuild.analyze.cost.components.DocumentPageList$Props", {
  Lreactbuild_analyze_cost_components_DocumentPageList$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_DocumentPageList$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DocumentPageList$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DropArea$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_DropArea$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_DropArea$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_components_DropArea$Backend.prototype = new $h_Lreactbuild_analyze_cost_components_DropArea$TypedBackend();
$c_Lreactbuild_analyze_cost_components_DropArea$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DropArea$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DropArea$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DropArea$Backend.prototype = $c_Lreactbuild_analyze_cost_components_DropArea$Backend.prototype;
var $d_Lreactbuild_analyze_cost_components_DropArea$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DropArea$Backend: 0
}, false, "reactbuild.analyze.cost.components.DropArea$Backend", {
  Lreactbuild_analyze_cost_components_DropArea$Backend: 1,
  Lreactbuild_analyze_cost_components_DropArea$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_DropArea$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DropArea$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DropArea$TypedProps(handler, render, preview, whenValid) {
  this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_handler = null;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_render = null;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_preview = null;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_whenValid = null;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_handler = handler;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_render = render;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_preview = preview;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_whenValid = whenValid
}
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DropArea$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DropArea$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype = $c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_handler;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_render;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_preview;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_whenValid;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_DropArea$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_components_DropArea$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_handler;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_handler;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_render;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_render;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_preview;
      var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_preview;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_whenValid;
        var x$8 = $n(TypedProps$1).Lreactbuild_analyze_cost_components_DropArea$TypedProps__f_whenValid;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_DropArea$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_DropArea$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.DropArea$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_DropArea$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_DropArea$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_DropArea$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_DropArea$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.DropArea$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_components_DropArea$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DropArea$TypedProps: 0
}, false, "reactbuild.analyze.cost.components.DropArea$TypedProps", {
  Lreactbuild_analyze_cost_components_DropArea$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DropArea$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_DropArea$TypedState(dragOver, result) {
  this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver = false;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result = null;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver = dragOver;
  this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result = result
}
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_components_DropArea$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_DropArea$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype = $c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype;
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedState");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_DropArea$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(x$1);
    if ((this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver === $n(TypedState$1).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_dragOver)) {
      var x = this.Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result;
      var x$2 = $n(TypedState$1).Lreactbuild_analyze_cost_components_DropArea$TypedState__f_result;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_DropArea$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_DropArea$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.DropArea$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_DropArea$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_DropArea$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_DropArea$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_DropArea$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.DropArea$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_components_DropArea$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_DropArea$TypedState: 0
}, false, "reactbuild.analyze.cost.components.DropArea$TypedState", {
  Lreactbuild_analyze_cost_components_DropArea$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_DropArea$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_components_DropArea$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_ExpandableCard$Props(title) {
  this.Lreactbuild_analyze_cost_components_ExpandableCard$Props__f_title = null;
  this.Lreactbuild_analyze_cost_components_ExpandableCard$Props__f_title = title
}
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_ExpandableCard$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_ExpandableCard$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype = $c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype;
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_ExpandableCard$Props__f_title : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_ExpandableCard$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_ExpandableCard$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_ExpandableCard$Props__f_title;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_ExpandableCard$Props__f_title;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_ExpandableCard$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_ExpandableCard$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.ExpandableCard$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_ExpandableCard$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_ExpandableCard$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_ExpandableCard$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_ExpandableCard$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.ExpandableCard$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_ExpandableCard$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_ExpandableCard$Props: 0
}, false, "reactbuild.analyze.cost.components.ExpandableCard$Props", {
  Lreactbuild_analyze_cost_components_ExpandableCard$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_ExpandableCard$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_ExpandableCard$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Feature$Props(state, program, fullSpace) {
  this.Lreactbuild_analyze_cost_components_Feature$Props__f_state = null;
  this.Lreactbuild_analyze_cost_components_Feature$Props__f_program = null;
  this.Lreactbuild_analyze_cost_components_Feature$Props__f_fullSpace = false;
  this.Lreactbuild_analyze_cost_components_Feature$Props__f_state = state;
  this.Lreactbuild_analyze_cost_components_Feature$Props__f_program = program;
  this.Lreactbuild_analyze_cost_components_Feature$Props__f_fullSpace = fullSpace
}
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Feature$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Feature$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Feature$Props.prototype = $c_Lreactbuild_analyze_cost_components_Feature$Props.prototype;
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_Feature$Props__f_state;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_Feature$Props__f_program;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_Feature$Props__f_fullSpace;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_components_Feature$Props__f_state;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_components_Feature$Props__f_program;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lreactbuild_analyze_cost_components_Feature$Props__f_fullSpace ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Feature$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_Feature$Props(x$1);
    if ((this.Lreactbuild_analyze_cost_components_Feature$Props__f_fullSpace === $n(Props$1).Lreactbuild_analyze_cost_components_Feature$Props__f_fullSpace)) {
      var x = this.Lreactbuild_analyze_cost_components_Feature$Props__f_state;
      var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_Feature$Props__f_state;
      if ((x === null)) {
        var $$x1 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === x$2)
      };
      if ($$x1) {
        var x$3 = this.Lreactbuild_analyze_cost_components_Feature$Props__f_program;
        var x$4 = $n(Props$1).Lreactbuild_analyze_cost_components_Feature$Props__f_program;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_Feature$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Feature$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Feature$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Feature$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Feature$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Feature$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Feature$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Feature$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Feature$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Feature$Props: 0
}, false, "reactbuild.analyze.cost.components.Feature$Props", {
  Lreactbuild_analyze_cost_components_Feature$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Feature$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Feature$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_LateralBar$Props(m, c, r) {
  this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_m = null;
  this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_c = null;
  this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_r = null;
  this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_m = m;
  this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_c = c;
  this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_r = r
}
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_LateralBar$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_LateralBar$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype = $c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype;
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_m;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_c;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_r;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_LateralBar$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_LateralBar$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_m;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_LateralBar$Props__f_m;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_c;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_components_LateralBar$Props__f_c;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_components_LateralBar$Props__f_r;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_components_LateralBar$Props__f_r;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_LateralBar$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_LateralBar$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.LateralBar$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_LateralBar$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_LateralBar$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_LateralBar$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_LateralBar$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.LateralBar$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_LateralBar$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_LateralBar$Props: 0
}, false, "reactbuild.analyze.cost.components.LateralBar$Props", {
  Lreactbuild_analyze_cost_components_LateralBar$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_LateralBar$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_LateralBar$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_LateralBar$State(opened) {
  this.Lreactbuild_analyze_cost_components_LateralBar$State__f_opened = false;
  this.Lreactbuild_analyze_cost_components_LateralBar$State__f_opened = opened
}
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype.constructor = $c_Lreactbuild_analyze_cost_components_LateralBar$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_LateralBar$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_LateralBar$State.prototype = $c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype;
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_LateralBar$State__f_opened : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_components_LateralBar$State__f_opened ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_LateralBar$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_components_LateralBar$State(x$1);
    return (this.Lreactbuild_analyze_cost_components_LateralBar$State__f_opened === $n(State$1).Lreactbuild_analyze_cost_components_LateralBar$State__f_opened)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_LateralBar$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_LateralBar$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.LateralBar$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_LateralBar$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_LateralBar$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_LateralBar$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_LateralBar$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.LateralBar$State;", depth))
}
var $d_Lreactbuild_analyze_cost_components_LateralBar$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_LateralBar$State: 0
}, false, "reactbuild.analyze.cost.components.LateralBar$State", {
  Lreactbuild_analyze_cost_components_LateralBar$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_LateralBar$State.prototype.$classData = $d_Lreactbuild_analyze_cost_components_LateralBar$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_MaybeRelated$Props(current, supplier, date, reference, pageIndex, pageCount, router, update) {
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_current = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_supplier = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_date = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_reference = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageIndex = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageCount = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_router = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_update = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_current = current;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_supplier = supplier;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_date = date;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_reference = reference;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageIndex = pageIndex;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageCount = pageCount;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_router = router;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_update = update
}
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_MaybeRelated$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_MaybeRelated$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype = $c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype;
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype.productArity__I = (function() {
  return 8
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_current;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_supplier;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_date;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_reference;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageIndex;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageCount;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_router;
      break
    }
    case 7: {
      return this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_update;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_MaybeRelated$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_MaybeRelated$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_current;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_current;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_supplier;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_supplier;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_date;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_date;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_reference;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_reference;
        var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageIndex;
      var x$10 = $n(Props$1).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageIndex;
      if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
        var x$11 = this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageCount;
        var x$12 = $n(Props$1).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_pageCount;
        var $$x3 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$13 = this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_router;
        var x$14 = $n(Props$1).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_router;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          var x$15 = this.Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_update;
          var x$16 = $n(Props$1).Lreactbuild_analyze_cost_components_MaybeRelated$Props__f_update;
          if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
            $n(Props$1);
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_MaybeRelated$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_MaybeRelated$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.MaybeRelated$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_MaybeRelated$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_MaybeRelated$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_MaybeRelated$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_MaybeRelated$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.MaybeRelated$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_MaybeRelated$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_MaybeRelated$Props: 0
}, false, "reactbuild.analyze.cost.components.MaybeRelated$Props", {
  Lreactbuild_analyze_cost_components_MaybeRelated$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_MaybeRelated$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_MaybeRelated$State(invoicePages) {
  this.Lreactbuild_analyze_cost_components_MaybeRelated$State__f_invoicePages = null;
  this.Lreactbuild_analyze_cost_components_MaybeRelated$State__f_invoicePages = invoicePages
}
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype.constructor = $c_Lreactbuild_analyze_cost_components_MaybeRelated$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_MaybeRelated$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype = $c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype;
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_MaybeRelated$State__f_invoicePages : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_MaybeRelated$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_components_MaybeRelated$State(x$1);
    var x = this.Lreactbuild_analyze_cost_components_MaybeRelated$State__f_invoicePages;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_components_MaybeRelated$State__f_invoicePages;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(State$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_MaybeRelated$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_MaybeRelated$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.MaybeRelated$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_MaybeRelated$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_MaybeRelated$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_MaybeRelated$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_MaybeRelated$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.MaybeRelated$State;", depth))
}
var $d_Lreactbuild_analyze_cost_components_MaybeRelated$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_MaybeRelated$State: 0
}, false, "reactbuild.analyze.cost.components.MaybeRelated$State", {
  Lreactbuild_analyze_cost_components_MaybeRelated$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_MaybeRelated$State.prototype.$classData = $d_Lreactbuild_analyze_cost_components_MaybeRelated$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFPage$Props(state, page) {
  this.Lreactbuild_analyze_cost_components_PDFPage$Props__f_state = null;
  this.Lreactbuild_analyze_cost_components_PDFPage$Props__f_page = null;
  this.Lreactbuild_analyze_cost_components_PDFPage$Props__f_state = state;
  this.Lreactbuild_analyze_cost_components_PDFPage$Props__f_page = page
}
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFPage$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFPage$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype = $c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype;
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_PDFPage$Props__f_state;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_PDFPage$Props__f_page;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFPage$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_PDFPage$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFPage$Props__f_state;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_PDFPage$Props__f_state;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_components_PDFPage$Props__f_page;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_components_PDFPage$Props__f_page;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFPage$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFPage$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFPage$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFPage$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFPage$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFPage$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFPage$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFPage$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFPage$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFPage$Props: 0
}, false, "reactbuild.analyze.cost.components.PDFPage$Props", {
  Lreactbuild_analyze_cost_components_PDFPage$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFPage$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$Point(x, y) {
  this.Lreactbuild_analyze_cost_components_PDFText$Point__f_x = 0.0;
  this.Lreactbuild_analyze_cost_components_PDFText$Point__f_y = 0.0;
  this.Lreactbuild_analyze_cost_components_PDFText$Point__f_x = x;
  this.Lreactbuild_analyze_cost_components_PDFText$Point__f_y = y
}
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$Point;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$Point() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$Point.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.$minus__Lreactbuild_analyze_cost_components_PDFText$Point__Lreactbuild_analyze_cost_components_PDFText$Point = (function(pt) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point((this.Lreactbuild_analyze_cost_components_PDFText$Point__f_x - $n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_x), (this.Lreactbuild_analyze_cost_components_PDFText$Point__f_y - $n(pt).Lreactbuild_analyze_cost_components_PDFText$Point__f_y))
});
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.productPrefix__T = (function() {
  return "Point"
});
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_PDFText$Point__f_x;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_PDFText$Point__f_y;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Point");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_analyze_cost_components_PDFText$Point__f_x;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_analyze_cost_components_PDFText$Point__f_y;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Point)) {
    var Point$1 = $as_Lreactbuild_analyze_cost_components_PDFText$Point(x$1);
    return ((this.Lreactbuild_analyze_cost_components_PDFText$Point__f_x === $n(Point$1).Lreactbuild_analyze_cost_components_PDFText$Point__f_x) && (this.Lreactbuild_analyze_cost_components_PDFText$Point__f_y === $n(Point$1).Lreactbuild_analyze_cost_components_PDFText$Point__f_y))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$Point(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Point) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$Point"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Point(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$Point)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$Point(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Point(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$Point;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$Point = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$Point: 0
}, false, "reactbuild.analyze.cost.components.PDFText$Point", {
  Lreactbuild_analyze_cost_components_PDFText$Point: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$Point.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$Point;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$Props(supplier, content) {
  this.Lreactbuild_analyze_cost_components_PDFText$Props__f_supplier = null;
  this.Lreactbuild_analyze_cost_components_PDFText$Props__f_content = null;
  this.Lreactbuild_analyze_cost_components_PDFText$Props__f_supplier = supplier;
  this.Lreactbuild_analyze_cost_components_PDFText$Props__f_content = content
}
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$Props.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_PDFText$Props__f_supplier;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_PDFText$Props__f_content;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_PDFText$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFText$Props__f_supplier;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_PDFText$Props__f_supplier;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_PDFText$Props__f_content;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_components_PDFText$Props__f_content;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$Props: 0
}, false, "reactbuild.analyze.cost.components.PDFText$Props", {
  Lreactbuild_analyze_cost_components_PDFText$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$RowResult(columns) {
  this.Lreactbuild_analyze_cost_components_PDFText$RowResult__f_columns = null;
  this.Lreactbuild_analyze_cost_components_PDFText$RowResult__f_columns = columns
}
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$RowResult;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$RowResult() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype.toString__T = (function() {
  var this$2 = $n($n($as_sc_IterableOnceOps($n(this.Lreactbuild_analyze_cost_components_PDFText$RowResult__f_columns).map__F1__O(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T2(x$2);
    return (($n($as_Lreactbuild_person_DocumentParserColumn($n(x)._1__O())).Lreactbuild_person_DocumentParserColumn__f_name + "=") + $n(x)._2__O())
  }))))).toList__sci_List());
  var ord = $m_s_math_Ordering$String$();
  var this$3 = $n($as_sc_IterableOnceOps($f_sc_SeqOps__sorted__s_math_Ordering__O(this$2, ord)));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ",", "")
});
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype.productPrefix__T = (function() {
  return "RowResult"
});
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_PDFText$RowResult__f_columns : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$RowResult)) {
    var RowResult$1 = $as_Lreactbuild_analyze_cost_components_PDFText$RowResult(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFText$RowResult__f_columns;
    var x$2 = $n(RowResult$1).Lreactbuild_analyze_cost_components_PDFText$RowResult__f_columns;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$RowResult(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$RowResult) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$RowResult"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$RowResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$RowResult)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$RowResult(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$RowResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$RowResult;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$RowResult = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$RowResult: 0
}, false, "reactbuild.analyze.cost.components.PDFText$RowResult", {
  Lreactbuild_analyze_cost_components_PDFText$RowResult: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$RowResult.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$RowResult;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$State(areas, selectedArea, editing) {
  this.Lreactbuild_analyze_cost_components_PDFText$State__f_areas = null;
  this.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea = null;
  this.Lreactbuild_analyze_cost_components_PDFText$State__f_editing = null;
  this.Lreactbuild_analyze_cost_components_PDFText$State__f_areas = areas;
  this.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea = selectedArea;
  this.Lreactbuild_analyze_cost_components_PDFText$State__f_editing = editing
}
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$State.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$State.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_PDFText$State__f_areas;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_components_PDFText$State(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFText$State__f_areas;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_components_PDFText$State__f_areas;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      var x$4 = $n(State$1).Lreactbuild_analyze_cost_components_PDFText$State__f_selectedArea;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
        var x$6 = $n(State$1).Lreactbuild_analyze_cost_components_PDFText$State__f_editing;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$State;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$State: 0
}, false, "reactbuild.analyze.cost.components.PDFText$State", {
  Lreactbuild_analyze_cost_components_PDFText$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$State.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFViewer$Props(ref) {
  this.Lreactbuild_analyze_cost_components_PDFViewer$Props__f_ref = null;
  this.Lreactbuild_analyze_cost_components_PDFViewer$Props__f_ref = ref
}
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFViewer$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFViewer$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype = $c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype;
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_PDFViewer$Props__f_ref : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFViewer$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_PDFViewer$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFViewer$Props__f_ref;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_PDFViewer$Props__f_ref;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Props$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFViewer$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFViewer$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFViewer$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFViewer$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFViewer$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFViewer$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFViewer$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFViewer$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFViewer$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFViewer$Props: 0
}, false, "reactbuild.analyze.cost.components.PDFViewer$Props", {
  Lreactbuild_analyze_cost_components_PDFViewer$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFViewer$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFViewer$State(page) {
  this.Lreactbuild_analyze_cost_components_PDFViewer$State__f_page = null;
  this.Lreactbuild_analyze_cost_components_PDFViewer$State__f_page = page
}
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFViewer$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFViewer$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype = $c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype;
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_PDFViewer$State__f_page : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFViewer$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_components_PDFViewer$State(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFViewer$State__f_page;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_components_PDFViewer$State__f_page;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(State$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFViewer$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFViewer$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFViewer$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFViewer$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFViewer$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFViewer$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFViewer$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFViewer$State;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFViewer$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFViewer$State: 0
}, false, "reactbuild.analyze.cost.components.PDFViewer$State", {
  Lreactbuild_analyze_cost_components_PDFViewer$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFViewer$State.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFViewer$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Period(from, to) {
  this.Lreactbuild_analyze_cost_components_Period__f_from = null;
  this.Lreactbuild_analyze_cost_components_Period__f_to = null;
  this.Lreactbuild_analyze_cost_components_Period__f_contains = null;
  this.Lreactbuild_analyze_cost_components_Period__f_from = from;
  this.Lreactbuild_analyze_cost_components_Period__f_to = to;
  var default$1 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Ljava_time_LocalDate(x$1$2);
    return true
  }));
  var this$2 = $n(from);
  if (this$2.isEmpty__Z()) {
    var fromPred = default$1
  } else {
    var arg1 = this$2.get__O();
    var from$2 = $as_Ljava_time_LocalDate(arg1);
    var fromPred = new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Ljava_time_LocalDate(x$2$2);
      return ($n(x$2).compareTo__Ljava_time_chrono_ChronoLocalDate__I(from$2) >= 0)
    }))
  };
  var this$4 = $n(to);
  if (this$4.isEmpty__Z()) {
    var toPred = default$1
  } else {
    var arg1$1 = this$4.get__O();
    var to$2 = $as_Ljava_time_LocalDate(arg1$1);
    var toPred = new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Ljava_time_LocalDate(x$3$2);
      return ($n(x$3).compareTo__Ljava_time_chrono_ChronoLocalDate__I(to$2) <= 0)
    }))
  };
  this.Lreactbuild_analyze_cost_components_Period__f_contains = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Ljava_time_LocalDate(v$2);
    return ($uZ($n(fromPred).apply__O__O(v)) && $uZ($n(toPred).apply__O__O(v)))
  }))
}
$c_Lreactbuild_analyze_cost_components_Period.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Period.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Period;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Period() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Period.prototype = $c_Lreactbuild_analyze_cost_components_Period.prototype;
$c_Lreactbuild_analyze_cost_components_Period.prototype.productPrefix__T = (function() {
  return "Period"
});
$c_Lreactbuild_analyze_cost_components_Period.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_Period.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_Period__f_from;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_Period__f_to;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_Period.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Period.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Period.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Period.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Period)) {
    var Period$1 = $as_Lreactbuild_analyze_cost_components_Period(x$1);
    var x = this.Lreactbuild_analyze_cost_components_Period__f_from;
    var x$2 = $n(Period$1).Lreactbuild_analyze_cost_components_Period__f_from;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_Period__f_to;
      var x$4 = $n(Period$1).Lreactbuild_analyze_cost_components_Period__f_to;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_Period(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Period) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Period"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Period(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Period)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Period(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Period(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Period;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Period = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Period: 0
}, false, "reactbuild.analyze.cost.components.Period", {
  Lreactbuild_analyze_cost_components_Period: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Period.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Period;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Period$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Period$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_analyze_cost_components_Period$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Period$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Period$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Period$.prototype = $c_Lreactbuild_analyze_cost_components_Period$.prototype;
$c_Lreactbuild_analyze_cost_components_Period$.prototype.toString__T = (function() {
  return "Period"
});
$c_Lreactbuild_analyze_cost_components_Period$.prototype.apply$default$1__s_Option = (function() {
  var this$1 = $m_Ljava_time_LocalDate$();
  return new $c_s_Some($n($n(this$1.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))).withDayOfMonth__I__Ljava_time_LocalDate(1)).withMonth__I__Ljava_time_LocalDate(1))
});
$c_Lreactbuild_analyze_cost_components_Period$.prototype.apply__O__O__O = (function(v1, v2) {
  var from = $as_s_Option(v1);
  var to = $as_s_Option(v2);
  return new $c_Lreactbuild_analyze_cost_components_Period(from, to)
});
var $d_Lreactbuild_analyze_cost_components_Period$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Period$: 0
}, false, "reactbuild.analyze.cost.components.Period$", {
  Lreactbuild_analyze_cost_components_Period$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Period$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Period$;
var $n_Lreactbuild_analyze_cost_components_Period$;
function $m_Lreactbuild_analyze_cost_components_Period$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Period$)) {
    $n_Lreactbuild_analyze_cost_components_Period$ = new $c_Lreactbuild_analyze_cost_components_Period$()
  };
  return $n_Lreactbuild_analyze_cost_components_Period$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PeriodProvider$Props(render, proxy) {
  this.Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_render = null;
  this.Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_render = render;
  this.Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PeriodProvider$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PeriodProvider$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype = $c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype;
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_render : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PeriodProvider$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_PeriodProvider$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_render;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_PeriodProvider$Props__f_render;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PeriodProvider$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PeriodProvider$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PeriodProvider$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PeriodProvider$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PeriodProvider$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PeriodProvider$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PeriodProvider$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PeriodProvider$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PeriodProvider$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PeriodProvider$Props: 0
}, false, "reactbuild.analyze.cost.components.PeriodProvider$Props", {
  Lreactbuild_analyze_cost_components_PeriodProvider$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PeriodProvider$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PeriodProvider$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Progress$Props(f) {
  this.Lreactbuild_analyze_cost_components_Progress$Props__f_f = null;
  this.Lreactbuild_analyze_cost_components_Progress$Props__f_f = f
}
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Progress$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Progress$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Progress$Props.prototype = $c_Lreactbuild_analyze_cost_components_Progress$Props.prototype;
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_Progress$Props__f_f : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Progress$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_Progress$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_Progress$Props__f_f;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_Progress$Props__f_f;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_Progress$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Progress$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Progress$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Progress$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Progress$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Progress$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Progress$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Progress$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Progress$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Progress$Props: 0
}, false, "reactbuild.analyze.cost.components.Progress$Props", {
  Lreactbuild_analyze_cost_components_Progress$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Progress$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Progress$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_ProgressContext(statusIcon, track) {
  this.Lreactbuild_analyze_cost_components_ProgressContext__f_statusIcon = null;
  this.Lreactbuild_analyze_cost_components_ProgressContext__f_track = null;
  this.Lreactbuild_analyze_cost_components_ProgressContext__f_statusIcon = statusIcon;
  this.Lreactbuild_analyze_cost_components_ProgressContext__f_track = track
}
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype.constructor = $c_Lreactbuild_analyze_cost_components_ProgressContext;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_ProgressContext() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_ProgressContext.prototype = $c_Lreactbuild_analyze_cost_components_ProgressContext.prototype;
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype.productPrefix__T = (function() {
  return "ProgressContext"
});
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_ProgressContext__f_statusIcon;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_ProgressContext__f_track;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_ProgressContext)) {
    var ProgressContext$1 = $as_Lreactbuild_analyze_cost_components_ProgressContext(x$1);
    var x = this.Lreactbuild_analyze_cost_components_ProgressContext__f_statusIcon;
    var x$2 = $n(ProgressContext$1).Lreactbuild_analyze_cost_components_ProgressContext__f_statusIcon;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_ProgressContext__f_track;
      var x$4 = $n(ProgressContext$1).Lreactbuild_analyze_cost_components_ProgressContext__f_track;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_ProgressContext(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_ProgressContext) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.ProgressContext"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_ProgressContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_ProgressContext)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_ProgressContext(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_ProgressContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.ProgressContext;", depth))
}
var $d_Lreactbuild_analyze_cost_components_ProgressContext = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_ProgressContext: 0
}, false, "reactbuild.analyze.cost.components.ProgressContext", {
  Lreactbuild_analyze_cost_components_ProgressContext: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_ProgressContext.prototype.$classData = $d_Lreactbuild_analyze_cost_components_ProgressContext;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Refine$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_Refine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_Refine$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_Refine$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_Refine$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_components_Refine$Backend.prototype = new $h_Lreactbuild_analyze_cost_components_Refine$TypedBackend();
$c_Lreactbuild_analyze_cost_components_Refine$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Refine$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Refine$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Refine$Backend.prototype = $c_Lreactbuild_analyze_cost_components_Refine$Backend.prototype;
var $d_Lreactbuild_analyze_cost_components_Refine$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Refine$Backend: 0
}, false, "reactbuild.analyze.cost.components.Refine$Backend", {
  Lreactbuild_analyze_cost_components_Refine$Backend: 1,
  Lreactbuild_analyze_cost_components_Refine$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_components_Refine$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Refine$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Refine$TypedProps(value, refiner, render) {
  this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_value = null;
  this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_refiner = null;
  this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_render = null;
  this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_value = value;
  this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_refiner = refiner;
  this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_render = render
}
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Refine$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Refine$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype = $c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_value;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_refiner;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_render;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Refine$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_components_Refine$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_value;
    var y = $n(TypedProps$1).Lreactbuild_analyze_cost_components_Refine$TypedProps__f_value;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_refiner;
      var x$2$1 = $n(TypedProps$1).Lreactbuild_analyze_cost_components_Refine$TypedProps__f_refiner;
      if (((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))) {
        var x$3 = this.Lreactbuild_analyze_cost_components_Refine$TypedProps__f_render;
        var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_components_Refine$TypedProps__f_render;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_Refine$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Refine$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Refine$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Refine$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Refine$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Refine$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Refine$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Refine$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Refine$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Refine$TypedProps: 0
}, false, "reactbuild.analyze.cost.components.Refine$TypedProps", {
  Lreactbuild_analyze_cost_components_Refine$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Refine$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Refine$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Root$Props(m, c, r) {
  this.Lreactbuild_analyze_cost_components_Root$Props__f_m = null;
  this.Lreactbuild_analyze_cost_components_Root$Props__f_c = null;
  this.Lreactbuild_analyze_cost_components_Root$Props__f_r = null;
  this.Lreactbuild_analyze_cost_components_Root$Props__f_m = m;
  this.Lreactbuild_analyze_cost_components_Root$Props__f_c = c;
  this.Lreactbuild_analyze_cost_components_Root$Props__f_r = r
}
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Root$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Root$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Root$Props.prototype = $c_Lreactbuild_analyze_cost_components_Root$Props.prototype;
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_Root$Props__f_m;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_Root$Props__f_c;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_Root$Props__f_r;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Root$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_Root$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_Root$Props__f_m;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_Root$Props__f_m;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_Root$Props__f_c;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_components_Root$Props__f_c;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_components_Root$Props__f_r;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_components_Root$Props__f_r;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_Root$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Root$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Root$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Root$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Root$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Root$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Root$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Root$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Root$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Root$Props: 0
}, false, "reactbuild.analyze.cost.components.Root$Props", {
  Lreactbuild_analyze_cost_components_Root$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Root$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Root$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Tab(name, link) {
  this.Lreactbuild_analyze_cost_components_Tab__f_name = null;
  this.Lreactbuild_analyze_cost_components_Tab__f_link = null;
  this.Lreactbuild_analyze_cost_components_Tab__f_name = name;
  this.Lreactbuild_analyze_cost_components_Tab__f_link = link
}
$c_Lreactbuild_analyze_cost_components_Tab.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Tab.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Tab;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Tab() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Tab.prototype = $c_Lreactbuild_analyze_cost_components_Tab.prototype;
$c_Lreactbuild_analyze_cost_components_Tab.prototype.productPrefix__T = (function() {
  return "Tab"
});
$c_Lreactbuild_analyze_cost_components_Tab.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_Tab.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_Tab__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_Tab__f_link;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_Tab.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Tab.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Tab.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Tab.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Tab)) {
    var Tab$1 = $as_Lreactbuild_analyze_cost_components_Tab(x$1);
    var x = this.Lreactbuild_analyze_cost_components_Tab__f_name;
    var x$2 = $n(Tab$1).Lreactbuild_analyze_cost_components_Tab__f_name;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_Tab__f_link;
      var x$4 = $n(Tab$1).Lreactbuild_analyze_cost_components_Tab__f_link;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      };
      if ($$x1) {
        $n(Tab$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_Tab(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Tab) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Tab"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Tab(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Tab)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Tab(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Tab(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Tab;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Tab = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Tab: 0
}, false, "reactbuild.analyze.cost.components.Tab", {
  Lreactbuild_analyze_cost_components_Tab: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Tab.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Tab;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_TouchableList$Props(ite, f) {
  this.Lreactbuild_analyze_cost_components_TouchableList$Props__f_ite = null;
  this.Lreactbuild_analyze_cost_components_TouchableList$Props__f_f = null;
  this.Lreactbuild_analyze_cost_components_TouchableList$Props__f_ite = ite;
  this.Lreactbuild_analyze_cost_components_TouchableList$Props__f_f = f
}
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_components_TouchableList$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_TouchableList$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype = $c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype;
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_TouchableList$Props__f_ite;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_TouchableList$Props__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_TouchableList$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_components_TouchableList$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_components_TouchableList$Props__f_ite;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_components_TouchableList$Props__f_ite;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_TouchableList$Props__f_f;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_components_TouchableList$Props__f_f;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_TouchableList$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_TouchableList$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.TouchableList$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_TouchableList$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_TouchableList$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_TouchableList$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_TouchableList$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.TouchableList$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_components_TouchableList$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_TouchableList$Props: 0
}, false, "reactbuild.analyze.cost.components.TouchableList$Props", {
  Lreactbuild_analyze_cost_components_TouchableList$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_TouchableList$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_components_TouchableList$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend.prototype = new $h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend();
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend.prototype;
var $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend: 0
}, false, "reactbuild.analyze.cost.modules.AccumulatingTable$Backend", {
  Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend: 1,
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(proxy, items, accumulatings, seeMore, rTextualizable, accTextualizable, accNumeric, from, to) {
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_items = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accumulatings = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_seeMore = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_rTextualizable = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accTextualizable = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_from = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_to = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_predicate = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_items = items;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accumulatings = accumulatings;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_seeMore = seeMore;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_rTextualizable = rTextualizable;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accTextualizable = accTextualizable;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric = accNumeric;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_from = from;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_to = to;
  var defaultPred = new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1(this);
  var x = $m_s_None$();
  if ((x === from)) {
    var fromPred = defaultPred
  } else {
    if ((!(from instanceof $c_s_Some))) {
      throw new $c_s_MatchError(from)
    };
    var x3 = $as_s_Some(from);
    var from$2 = $as_Ljava_time_LocalDate($n(x3).s_Some__f_value);
    var fromPred = new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2(this, from$2)
  };
  var x$3 = $m_s_None$();
  if ((x$3 === to)) {
    var toPred = defaultPred
  } else {
    if ((!(to instanceof $c_s_Some))) {
      throw new $c_s_MatchError(to)
    };
    var x3$2 = $as_s_Some(to);
    var to$2 = $as_Ljava_time_LocalDate($n(x3$2).s_Some__f_value);
    var toPred = new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3(this, to$2)
  };
  var pred = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Ljava_time_LocalDate(v$2);
    return ($uZ($n(fromPred).apply__O__O(v)) && $uZ($n(toPred).apply__O__O(v)))
  }));
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_predicate = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $as_T2(v$3$2);
    return $uZ(pred.apply__O__O($n(v$3)._1__O()))
  }))
}
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype.productArity__I = (function() {
  return 9
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_items;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accumulatings;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_seeMore;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_rTextualizable;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accTextualizable;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric;
      break
    }
    case 7: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_from;
      break
    }
    case 8: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_to;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_proxy;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_items;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_items;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accumulatings;
      var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accumulatings;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_seeMore;
        var x$8 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_seeMore;
        var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_rTextualizable;
      var x$10 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_rTextualizable;
      if ((x$9 === null)) {
        var $$x4 = (x$10 === null)
      } else {
        var this$1 = $n(x$9);
        var $$x4 = (this$1 === x$10)
      };
      if ($$x4) {
        var x$11 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accTextualizable;
        var x$12 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accTextualizable;
        if ((x$11 === null)) {
          var $$x3 = (x$12 === null)
        } else {
          var this$2 = $n(x$11);
          var $$x3 = (this$2 === x$12)
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$13 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric;
        var x$14 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric;
        if ((x$13 === null)) {
          var $$x5 = (x$14 === null)
        } else {
          var this$3 = $n(x$13);
          var $$x5 = (this$3 === x$14)
        };
        if ($$x5) {
          var x$15 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_from;
          var x$16 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_from;
          if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
            var x$17 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_to;
            var x$18 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_to;
            return ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.AccumulatingTable$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.AccumulatingTable$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.AccumulatingTable$TypedProps", {
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState(weekList, weekAccumulators, items, accumulate) {
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekAccumulators = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_items = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_accumulate = false;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_renderLine = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList = weekList;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekAccumulators = weekAccumulators;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_items = items;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_accumulate = accumulate;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_renderLine = (accumulate ? new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(p$2);
    return new $c_sjsr_AnonFunction1(((f$2) => {
      var f = $as_F1(f$2);
      return this.renderAccLine__Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__F1__Ljapgolly_scalajs_react_vdom_TagMod(p, f)
    }))
  })) : new $c_sjsr_AnonFunction1(((p$3$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(p$3$2);
    return new $c_sjsr_AnonFunction1(((f$2$1) => {
      var f$1 = $as_F1(f$2$1);
      return this.renderValLine__Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__F1__Ljapgolly_scalajs_react_vdom_TagMod(p$3, f$1)
    }))
  })))
}
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype;
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.renderValLine__Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__F1__Ljapgolly_scalajs_react_vdom_TagMod = (function(p, f) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList;
  return $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Ljava_time_LocalDate(v$2);
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$6 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x2 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = $n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accTextualizable).stringify__O__T($n(f).apply__O__O(v));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })))
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.renderAccLine__Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__F1__Ljapgolly_scalajs_react_vdom_TagMod = (function(p, f) {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $as_sc_IterableOnce($n($as_sc_IterableOps($n(this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList).scanLeft__O__F2__O($n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric).zero__O(), new $c_sjsr_AnonFunction2(((acc$2, date$2) => {
    var date = $as_Ljava_time_LocalDate(date$2);
    return $n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accNumeric).plus__O__O__O(acc$2, $n(f).apply__O__O(date))
  }))))).drop__I__O(1));
  return $n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((v$2) => {
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var this$6 = new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$TextAlign("textAlign");
    var $$x2 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("right", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n($n(p).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps__f_accTextualizable).stringify__O__T(v$2);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })))
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekAccumulators;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_items;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_accumulate;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedState");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekAccumulators;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_items;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_accumulate ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_accumulate === $n(TypedState$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_accumulate)) {
      var x = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList;
      var x$2 = $n(TypedState$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekList;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekAccumulators;
      var x$4 = $n(TypedState$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_weekAccumulators;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_items;
        var x$6 = $n(TypedState$1).Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState__f_items;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.AccumulatingTable$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.AccumulatingTable$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState: 0
}, false, "reactbuild.analyze.cost.modules.AccumulatingTable$TypedState", {
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props(step, ctl, proxy) {
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_step = null;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_ctl = null;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_step = step;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_ctl = ctl;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_step;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_ctl;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_proxy;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_step;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_step;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_ctl;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_ctl;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_proxy;
        var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props__f_proxy;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.BusinessOpportunities$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.BusinessOpportunities$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props: 0
}, false, "reactbuild.analyze.cost.modules.BusinessOpportunities$Props", {
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$.prototype = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$.prototype;
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$.prototype.toString__T = (function() {
  return "WithPositionAndZoom"
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$.prototype.apply__O__O = (function(v1) {
  var viewPoint = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(v1);
  return new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(viewPoint)
});
var $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$: 0
}, false, "reactbuild.analyze.cost.modules.BusinessOpportunities$WithPositionAndZoom$", {
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$;
var $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$;
function $m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$)) {
    $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$ = new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$()
  };
  return $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(viewPoint, ctl) {
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_viewPoint = null;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_ctl = null;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_viewPoint = viewPoint;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_ctl = ctl
}
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_viewPoint;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_ctl;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_viewPoint;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_viewPoint;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_ctl;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props__f_ctl;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.BusinessOpportunitiesWithPositionAndZoom$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.BusinessOpportunitiesWithPositionAndZoom$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props: 0
}, false, "reactbuild.analyze.cost.modules.BusinessOpportunitiesWithPositionAndZoom$Props", {
  Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_BusinessOpportunitiesWithPositionAndZoom$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props(controller, view) {
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_controller = null;
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_view = null;
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_controller = controller;
  this.Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_view = view
}
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ControllerAndView$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype = $c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_controller;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_view;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_ControllerAndView$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_controller;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_controller;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_view;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_ControllerAndView$Props__f_view;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ControllerAndView$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ControllerAndView$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ControllerAndView$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ControllerAndView$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ControllerAndView$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ControllerAndView$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ControllerAndView$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ControllerAndView$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ControllerAndView$Props: 0
}, false, "reactbuild.analyze.cost.modules.ControllerAndView$Props", {
  Lreactbuild_analyze_cost_modules_ControllerAndView$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ControllerAndView$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ControllerAndView$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossSpec(name, fromModel, label, _id, fromDetail, textualizable, ct) {
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_name = null;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_fromModel = null;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_label = null;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f__id = null;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_fromDetail = null;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_textualizable = null;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_name = name;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_fromModel = fromModel;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_label = label;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f__id = _id;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_fromDetail = fromDetail;
  this.Lreactbuild_analyze_cost_modules_CrossSpec__f_textualizable = textualizable
}
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossSpec;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossSpec() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossSpec.prototype = $c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype;
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype.productPrefix__T = (function() {
  return "CrossSpec"
});
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_CrossSpec__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_CrossSpec__f_fromModel;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_CrossSpec__f_label;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_CrossSpec__f__id;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_CrossSpec__f_fromDetail;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_CrossSpec__f_textualizable;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_CrossSpec)) {
    var CrossSpec$1 = $as_Lreactbuild_analyze_cost_modules_CrossSpec(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_CrossSpec__f_name === $n(CrossSpec$1).Lreactbuild_analyze_cost_modules_CrossSpec__f_name)) {
      var x = this.Lreactbuild_analyze_cost_modules_CrossSpec__f_fromModel;
      var x$2 = $n(CrossSpec$1).Lreactbuild_analyze_cost_modules_CrossSpec__f_fromModel;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_CrossSpec__f_label;
        var x$4 = $n(CrossSpec$1).Lreactbuild_analyze_cost_modules_CrossSpec__f_label;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_CrossSpec__f__id;
      var x$6 = $n(CrossSpec$1).Lreactbuild_analyze_cost_modules_CrossSpec__f__id;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_CrossSpec__f_fromDetail;
        var x$8 = $n(CrossSpec$1).Lreactbuild_analyze_cost_modules_CrossSpec__f_fromDetail;
        if ((x$7 === null)) {
          var $$x2 = (x$8 === null)
        } else {
          var this$1 = $n(x$7);
          var $$x2 = (this$1 === x$8)
        }
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_CrossSpec__f_textualizable;
        var x$10 = $n(CrossSpec$1).Lreactbuild_analyze_cost_modules_CrossSpec__f_textualizable;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          $n(CrossSpec$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_CrossSpec(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_CrossSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.CrossSpec"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_CrossSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_CrossSpec)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_CrossSpec(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_CrossSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.CrossSpec;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_CrossSpec = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossSpec: 0
}, false, "reactbuild.analyze.cost.modules.CrossSpec", {
  Lreactbuild_analyze_cost_modules_CrossSpec: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossSpec.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossSpec;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossType(getCrossedAmounts, getInvoiceDetails, row, column) {
  this.Lreactbuild_analyze_cost_modules_CrossType__f_getCrossedAmounts = null;
  this.Lreactbuild_analyze_cost_modules_CrossType__f_getInvoiceDetails = null;
  this.Lreactbuild_analyze_cost_modules_CrossType__f_row = null;
  this.Lreactbuild_analyze_cost_modules_CrossType__f_column = null;
  this.Lreactbuild_analyze_cost_modules_CrossType__f_getCrossedAmounts = getCrossedAmounts;
  this.Lreactbuild_analyze_cost_modules_CrossType__f_getInvoiceDetails = getInvoiceDetails;
  this.Lreactbuild_analyze_cost_modules_CrossType__f_row = row;
  this.Lreactbuild_analyze_cost_modules_CrossType__f_column = column
}
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossType;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossType() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossType.prototype = $c_Lreactbuild_analyze_cost_modules_CrossType.prototype;
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype.productPrefix__T = (function() {
  return "CrossType"
});
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_CrossType__f_getCrossedAmounts;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_CrossType__f_getInvoiceDetails;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_CrossType)) {
    var CrossType$1 = $as_Lreactbuild_analyze_cost_modules_CrossType(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_CrossType__f_getCrossedAmounts;
    var x$2 = $n(CrossType$1).Lreactbuild_analyze_cost_modules_CrossType__f_getCrossedAmounts;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_CrossType__f_getInvoiceDetails;
      var x$4 = $n(CrossType$1).Lreactbuild_analyze_cost_modules_CrossType__f_getInvoiceDetails;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x$4)
      };
      if ($$x2) {
        $n(CrossType$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_CrossType(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_CrossType) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.CrossType"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_CrossType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_CrossType)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_CrossType(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_CrossType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.CrossType;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_CrossType = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossType: 0
}, false, "reactbuild.analyze.cost.modules.CrossType", {
  Lreactbuild_analyze_cost_modules_CrossType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossType.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossType;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Crossed$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__f_reuseQuery = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$Backend__f_$ = \u03b4;
  $ct_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend__(this)
}
$c_Lreactbuild_analyze_cost_modules_Crossed$Backend.prototype = new $h_Lreactbuild_analyze_cost_modules_Crossed$TypedBackend();
$c_Lreactbuild_analyze_cost_modules_Crossed$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Crossed$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Crossed$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Crossed$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_Crossed$Backend.prototype;
var $d_Lreactbuild_analyze_cost_modules_Crossed$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Crossed$Backend: 0
}, false, "reactbuild.analyze.cost.modules.Crossed$Backend", {
  Lreactbuild_analyze_cost_modules_Crossed$Backend: 1,
  Lreactbuild_analyze_cost_modules_Crossed$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_Crossed$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Crossed$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps(router, proxy, crossType) {
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_router = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_router = router;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType = crossType
}
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Crossed$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_router;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_proxy;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_Crossed$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_router;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_router;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_proxy;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_proxy;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType;
      var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_Crossed$TypedProps__f_crossType;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(TypedProps$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_Crossed$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Crossed$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Crossed$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Crossed$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Crossed$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Crossed$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Crossed$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_Crossed$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Crossed$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.Crossed$TypedProps", {
  Lreactbuild_analyze_cost_modules_Crossed$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Crossed$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Crossed$TypedState(crossedAmounts, selectedPart) {
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_crossedAmounts = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart = null;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_crossedAmounts = crossedAmounts;
  this.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart = selectedPart
}
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Crossed$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Crossed$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype = $c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype;
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_crossedAmounts;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_Crossed$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_modules_Crossed$TypedState(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_crossedAmounts;
    var x$2 = $n(TypedState$1).Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_crossedAmounts;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart;
      var x$4 = $n(TypedState$1).Lreactbuild_analyze_cost_modules_Crossed$TypedState__f_selectedPart;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(TypedState$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_Crossed$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Crossed$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Crossed$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Crossed$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Crossed$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Crossed$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Crossed$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Crossed$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_Crossed$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Crossed$TypedState: 0
}, false, "reactbuild.analyze.cost.modules.Crossed$TypedState", {
  Lreactbuild_analyze_cost_modules_Crossed$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_Crossed$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Crossed$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend.prototype = new $h_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend();
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend.prototype;
var $d_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossedDetails$Backend: 0
}, false, "reactbuild.analyze.cost.modules.CrossedDetails$Backend", {
  Lreactbuild_analyze_cost_modules_CrossedDetails$Backend: 1,
  Lreactbuild_analyze_cost_modules_CrossedDetails$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossedDetails$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps(proxy, crossType, getRef, selection, index, router) {
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType = null;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_getRef = null;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection = null;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_index = 0;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_router = null;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType = crossType;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_getRef = getRef;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection = selection;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_index = index;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_router = router
}
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_getRef;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_index;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_router;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_proxy;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_getRef;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_router;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_index === $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_index)) {
      var x = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_proxy;
      var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_proxy;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType;
        var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_crossType;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_getRef;
      var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_getRef;
      if ((x$5 === null)) {
        var $$x3 = (x$6 === null)
      } else {
        var this$1 = $n(x$5);
        var $$x3 = (this$1 === x$6)
      };
      if ($$x3) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection;
        var x$8 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_selection;
        var $$x2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_router;
        var x$10 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps__f_router;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          $n(TypedProps$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.CrossedDetails$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.CrossedDetails$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.CrossedDetails$TypedProps", {
  Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(invoicePages, selectedInvoice) {
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages = null;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_selectedInvoice = null;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages = invoicePages;
  this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_selectedInvoice = selectedInvoice
}
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype;
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_selectedInvoice;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages;
    var x$2 = $n(TypedState$1).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_invoicePages;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_selectedInvoice;
      var x$4 = $n(TypedState$1).Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState__f_selectedInvoice;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(TypedState$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.CrossedDetails$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.CrossedDetails$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState: 0
}, false, "reactbuild.analyze.cost.modules.CrossedDetails$TypedState", {
  Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossedDetails$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedTable$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_CrossedTable$Backend.prototype = new $h_Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend();
$c_Lreactbuild_analyze_cost_modules_CrossedTable$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedTable$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedTable$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedTable$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedTable$Backend.prototype;
var $d_Lreactbuild_analyze_cost_modules_CrossedTable$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossedTable$Backend: 0
}, false, "reactbuild.analyze.cost.modules.CrossedTable$Backend", {
  Lreactbuild_analyze_cost_modules_CrossedTable$Backend: 1,
  Lreactbuild_analyze_cost_modules_CrossedTable$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossedTable$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps(proxy, crossType, rows, columns, amounts, selection, setSelection) {
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType = null;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_rows = null;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_columns = null;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_amounts = null;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_selection = null;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_setSelection = null;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType = crossType;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_rows = rows;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_columns = columns;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_amounts = amounts;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_selection = selection;
  this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_setSelection = setSelection
}
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_rows;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_columns;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_amounts;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_selection;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_setSelection;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_proxy;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_crossType;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_rows;
      var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_rows;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_columns;
        var x$8 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_columns;
        var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_amounts;
      var x$10 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_amounts;
      if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
        var x$11 = this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_selection;
        var x$12 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_selection;
        var $$x3 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$13 = this.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_setSelection;
        var x$14 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps__f_setSelection;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          $n(TypedProps$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.CrossedTable$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.CrossedTable$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.CrossedTable$TypedProps", {
  Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossedTable$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype = $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype;
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype.equals__O__Z = (function(x$1) {
  return ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState) && ($n($as_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState(x$1)), true))
});
function $as_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.CrossedTable$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_CrossedTable$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.CrossedTable$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_CrossedTable$TypedState: 0
}, false, "reactbuild.analyze.cost.modules.CrossedTable$TypedState", {
  Lreactbuild_analyze_cost_modules_CrossedTable$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_CrossedTable$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$Context(proxy, templates, project, termList, termMap, user) {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_templates = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_project = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termList = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termMap = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_user = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_templates = templates;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_project = project;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termList = termList;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termMap = termMap;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_user = user
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$Context;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$Context() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype.productPrefix__T = (function() {
  return "Context"
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_templates;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_project;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termList;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termMap;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_user;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$Context)) {
    var Context$1 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$Context(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_proxy;
    var x$2 = $n(Context$1).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_templates;
      var x$4 = $n(Context$1).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_templates;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_project;
        var x$6 = $n(Context$1).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_project;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termList;
      var x$8 = $n(Context$1).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termList;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termMap;
        var x$10 = $n(Context$1).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_termMap;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_user;
          var x$12 = $n(Context$1).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_user;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EditListEntry$Context(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$Context) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditListEntry$Context"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$Context(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$Context)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$Context(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$Context(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditListEntry$Context;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$Context = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$Context: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$Context", {
  Lreactbuild_analyze_cost_modules_EditListEntry$Context: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Context.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$Context;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$State(tpe, title, terms, created, template, customDate, validation) {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate = false;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe = tpe;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title = title;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms = terms;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created = created;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template = template;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate = customDate;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation = validation
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate === $n(State$1).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_customDate)) {
      var x = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
      var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_tpe;
      if ((x === null)) {
        var $$x2 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x2 = (this$1 === x$2)
      };
      if ($$x2) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
        var x$4 = $n(State$1).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_title;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
      var x$6 = $n(State$1).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_terms;
      if ((x$5 === null)) {
        var $$x4 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x4 = $f_sc_Set__equals__O__Z(this$2, x$6)
      };
      if ($$x4) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
        var x$8 = $n(State$1).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_created;
        var $$x3 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
        var x$10 = $n(State$1).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_template;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
          var x$12 = $n(State$1).Lreactbuild_analyze_cost_modules_EditListEntry$State__f_validation;
          if ((x$11 === null)) {
            return (x$12 === null)
          } else {
            var this$3 = $n(x$11);
            return (this$3 === x$12)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EditListEntry$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditListEntry$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditListEntry$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$State: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$State", {
  Lreactbuild_analyze_cost_modules_EditListEntry$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditPerson$Props(router, proxy, snapshot) {
  this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_router = null;
  this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot = null;
  this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_router = router;
  this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot = snapshot
}
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditPerson$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditPerson$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype = $c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.deriveState__Lreactbuild_analyze_cost_modules_EditPerson$State = (function() {
  $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
  var $$x3 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
  var $$x2 = $n($as_Lreactbuild_person_Person($n(this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_person_Person__f__id;
  $m_Lreactbuild_person_PersonAnnotation$();
  new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
  var $$x1 = $m_Ljava_time_Instant$();
  var this$7 = $m_RTLong$();
  var value = $uD(new Date().getTime());
  var lo = this$7.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_Lreactbuild_analyze_cost_modules_EditPerson$State(new $c_Lreactbuild_person_PersonAnnotation($$x3, $$x2, "", $n($$x1).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi)), ($m_Lreactbuild_person_PersonAnnotation$(), $m_s_None$())))
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_router;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_proxy;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditPerson$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_EditPerson$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_router;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_router;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_proxy;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_proxy;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_EditPerson$Props__f_snapshot;
      if ((x$5 === null)) {
        var $$x2 = (x$6 === null)
      } else {
        var this$1 = $n(x$5);
        var $$x2 = (this$1 === x$6)
      };
      if ($$x2) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EditPerson$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditPerson$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditPerson$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditPerson$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditPerson$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditPerson$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditPerson$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditPerson$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditPerson$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditPerson$Props: 0
}, false, "reactbuild.analyze.cost.modules.EditPerson$Props", {
  Lreactbuild_analyze_cost_modules_EditPerson$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditPerson$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditPerson$State(newPersonAnnotation) {
  this.Lreactbuild_analyze_cost_modules_EditPerson$State__f_newPersonAnnotation = null;
  this.Lreactbuild_analyze_cost_modules_EditPerson$State__f_newPersonAnnotation = newPersonAnnotation
}
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditPerson$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditPerson$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype = $c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype;
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_EditPerson$State__f_newPersonAnnotation : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditPerson$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_EditPerson$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EditPerson$State__f_newPersonAnnotation;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_EditPerson$State__f_newPersonAnnotation;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(State$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EditPerson$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditPerson$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditPerson$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditPerson$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditPerson$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditPerson$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditPerson$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditPerson$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditPerson$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditPerson$State: 0
}, false, "reactbuild.analyze.cost.modules.EditPerson$State", {
  Lreactbuild_analyze_cost_modules_EditPerson$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditPerson$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditProject$Props(pageProps, project) {
  this.Lreactbuild_analyze_cost_modules_EditProject$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_EditProject$Props__f_project = null;
  this.Lreactbuild_analyze_cost_modules_EditProject$Props__f_pageProps = pageProps;
  this.Lreactbuild_analyze_cost_modules_EditProject$Props__f_project = project
}
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditProject$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditProject$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype = $c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EditProject$Props__f_pageProps;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EditProject$Props__f_project;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditProject$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_EditProject$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EditProject$Props__f_pageProps;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_EditProject$Props__f_pageProps;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_EditProject$Props__f_project;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_EditProject$Props__f_project;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      };
      if ($$x1) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EditProject$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditProject$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditProject$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditProject$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditProject$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditProject$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditProject$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditProject$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditProject$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditProject$Props: 0
}, false, "reactbuild.analyze.cost.modules.EditProject$Props", {
  Lreactbuild_analyze_cost_modules_EditProject$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditProject$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditProject$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditProject$State(showMore) {
  this.Lreactbuild_analyze_cost_modules_EditProject$State__f_showMore = null;
  this.Lreactbuild_analyze_cost_modules_EditProject$State__f_showMore = showMore
}
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditProject$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditProject$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditProject$State.prototype = $c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype;
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_EditProject$State__f_showMore : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditProject$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_EditProject$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EditProject$State__f_showMore;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_EditProject$State__f_showMore;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(State$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EditProject$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditProject$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditProject$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditProject$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditProject$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditProject$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditProject$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditProject$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditProject$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditProject$State: 0
}, false, "reactbuild.analyze.cost.modules.EditProject$State", {
  Lreactbuild_analyze_cost_modules_EditProject$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditProject$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditProject$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditResource$Props(proxy, resource) {
  this.Lreactbuild_analyze_cost_modules_EditResource$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_EditResource$Props__f_resource = null;
  this.Lreactbuild_analyze_cost_modules_EditResource$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_EditResource$Props__f_resource = resource
}
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditResource$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditResource$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype = $c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EditResource$Props__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EditResource$Props__f_resource;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditResource$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_EditResource$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EditResource$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_EditResource$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_EditResource$Props__f_resource;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_EditResource$Props__f_resource;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      };
      if ($$x1) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EditResource$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditResource$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditResource$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditResource$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditResource$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditResource$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditResource$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditResource$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditResource$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditResource$Props: 0
}, false, "reactbuild.analyze.cost.modules.EditResource$Props", {
  Lreactbuild_analyze_cost_modules_EditResource$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditResource$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditResource$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditResource$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditResource$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditResource$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditResource$State.prototype = $c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype;
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype.equals__O__Z = (function(x$1) {
  return ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditResource$State) && ($n($as_Lreactbuild_analyze_cost_modules_EditResource$State(x$1)), true))
});
function $as_Lreactbuild_analyze_cost_modules_EditResource$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditResource$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditResource$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditResource$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditResource$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditResource$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditResource$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditResource$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditResource$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditResource$State: 0
}, false, "reactbuild.analyze.cost.modules.EditResource$State", {
  Lreactbuild_analyze_cost_modules_EditResource$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditResource$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditResource$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryList$Props(project, state, proxy, user) {
  this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_project = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_state = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_user = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_project = project;
  this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_state = state;
  this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_user = user
}
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryList$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryList$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype = $c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_state;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_proxy;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_user;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EntryList$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_EntryList$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_project;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_EntryList$Props__f_project;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_state;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_EntryList$Props__f_state;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_proxy;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_EntryList$Props__f_proxy;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_EntryList$Props__f_user;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_EntryList$Props__f_user;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EntryList$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EntryList$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EntryList$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EntryList$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EntryList$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EntryList$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EntryList$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EntryList$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EntryList$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryList$Props: 0
}, false, "reactbuild.analyze.cost.modules.EntryList$Props", {
  Lreactbuild_analyze_cost_modules_EntryList$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryList$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryList$State(expandedTerms, expandedNoTerms) {
  this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedTerms = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms = false;
  this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedTerms = expandedTerms;
  this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms = expandedNoTerms
}
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryList$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryList$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryList$State.prototype = $c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedTerms;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedTerms;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EntryList$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_EntryList$State(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms === $n(State$1).Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedNoTerms)) {
      var x = this.Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedTerms;
      var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_EntryList$State__f_expandedTerms;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EntryList$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EntryList$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EntryList$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EntryList$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EntryList$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EntryList$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EntryList$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EntryList$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EntryList$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryList$State: 0
}, false, "reactbuild.analyze.cost.modules.EntryList$State", {
  Lreactbuild_analyze_cost_modules_EntryList$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryList$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryList$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(progressContext, entry) {
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_progressContext = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_progressContext = progressContext;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry = entry
}
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryListEntry$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_progressContext;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_progressContext;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_progressContext;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_EntryListEntry$Props__f_entry;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EntryListEntry$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EntryListEntry$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EntryListEntry$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EntryListEntry$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EntryListEntry$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryListEntry$Props: 0
}, false, "reactbuild.analyze.cost.modules.EntryListEntry$Props", {
  Lreactbuild_analyze_cost_modules_EntryListEntry$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryListEntry$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryListEntry$State(expanded) {
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded = false;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded = expanded
}
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryListEntry$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EntryListEntry$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_EntryListEntry$State(x$1);
    return (this.Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded === $n(State$1).Lreactbuild_analyze_cost_modules_EntryListEntry$State__f_expanded)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_EntryListEntry$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EntryListEntry$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EntryListEntry$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EntryListEntry$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EntryListEntry$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EntryListEntry$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EntryListEntry$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EntryListEntry$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EntryListEntry$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryListEntry$State: 0
}, false, "reactbuild.analyze.cost.modules.EntryListEntry$State", {
  Lreactbuild_analyze_cost_modules_EntryListEntry$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryListEntry$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props(close, activateButton) {
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_close = null;
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_activateButton = null;
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_close = close;
  this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_activateButton = activateButton
}
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype = $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_close);
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_activateButton;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_close;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_close;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_activateButton;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_ExpandablePicker$Props__f_activateButton;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ExpandablePicker$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ExpandablePicker$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ExpandablePicker$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ExpandablePicker$Props: 0
}, false, "reactbuild.analyze.cost.modules.ExpandablePicker$Props", {
  Lreactbuild_analyze_cost_modules_ExpandablePicker$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ExpandablePicker$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_IndexedListEntry(templates, customEntries, templatedEntries, update) {
  this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templates = null;
  this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_customEntries = null;
  this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templatedEntries = null;
  this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update = null;
  this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templates = templates;
  this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_customEntries = customEntries;
  this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templatedEntries = templatedEntries;
  this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update = update
}
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_IndexedListEntry;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_IndexedListEntry() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype = $c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype;
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.filter__F1__Lreactbuild_analyze_cost_modules_IndexedListEntry = (function(f) {
  var this$5 = $n(this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templates);
  var f$2 = ((t$2) => {
    var t = $as_Lreactbuild_model_WithChildren(t$2);
    var this$2 = $n($n(t).Lreactbuild_model_WithChildren__f_children);
    var f$1 = ((e$2) => {
      var e = $as_Lreactbuild_model_ListTemplateEntry(e$2);
      return $uZ($n(f).apply__O__O($n(e).Lreactbuild_model_ListTemplateEntry__f_terms))
    });
    var l = this$2;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break
        } else {
          var h = $n(l).head__O();
          var t$1 = $as_sci_List($n(l).tail__O());
          if (($uZ(f$1(h)) === false)) {
            l = t$1;
            continue
          };
          var start = l;
          var remaining = t$1;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block
            } else {
              var x = $n(remaining).head__O();
              if (($uZ(f$1(x)) !== false)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue
              };
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O())
              };
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f$1(head)) !== false)) {
                  next = $as_sci_List($n(next).tail__O())
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                  };
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O())
                }
              };
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy
              };
              var result = newHead;
              break block
            }
          }
        }
      }
    };
    var this$3 = $n(t);
    var x$2 = $as_Lreactbuild_model_ListTemplate(this$3.Lreactbuild_model_WithChildren__f_item);
    $n(t);
    return new $c_Lreactbuild_model_WithChildren(x$2, result)
  });
  if ((this$5 === $m_sci_Nil$())) {
    var templates = $m_sci_Nil$()
  } else {
    var arg1 = this$5.head__O();
    var h$1 = new $c_sci_$colon$colon(f$2(arg1), $m_sci_Nil$());
    var t$3 = h$1;
    var rest = $as_sci_List(this$5.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f$2(arg1$1), $m_sci_Nil$());
      $n(t$3).sci_$colon$colon__f_next = nx;
      t$3 = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var templates = h$1
  };
  var this$6 = $n(this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_customEntries);
  var f$3 = ((e$2$1) => {
    var e$1 = $as_Lreactbuild_model_WithChildren(e$2$1);
    return $uZ($n(f).apply__O__O($n($as_Lreactbuild_model_CustomListEntry($n(e$1).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_CustomListEntry__f_terms))
  });
  var l$1 = this$6;
  block$2: {
    var result$1;
    while (true) {
      if ($n(l$1).isEmpty__Z()) {
        var result$1 = $m_sci_Nil$();
        break
      } else {
        var h$2 = $n(l$1).head__O();
        var t$4 = $as_sci_List($n(l$1).tail__O());
        if (($uZ(f$3(h$2)) === false)) {
          l$1 = t$4;
          continue
        };
        var start$1 = l$1;
        var remaining$1 = t$4;
        while (true) {
          if ($n(remaining$1).isEmpty__Z()) {
            var result$1 = start$1;
            break block$2
          } else {
            var x$1 = $n(remaining$1).head__O();
            if (($uZ(f$3(x$1)) !== false)) {
              remaining$1 = $as_sci_List($n(remaining$1).tail__O());
              continue
            };
            var firstMiss$1 = remaining$1;
            var newHead$1 = new $c_sci_$colon$colon($n(start$1).head__O(), $m_sci_Nil$());
            var toProcess$1 = $as_sci_List($n(start$1).tail__O());
            var currentLast$1 = newHead$1;
            while ((toProcess$1 !== firstMiss$1)) {
              var newElem$1 = new $c_sci_$colon$colon($n(toProcess$1).head__O(), $m_sci_Nil$());
              $n(currentLast$1).sci_$colon$colon__f_next = newElem$1;
              currentLast$1 = newElem$1;
              toProcess$1 = $as_sci_List($n(toProcess$1).tail__O())
            };
            var next$1 = $as_sci_List($n(firstMiss$1).tail__O());
            var nextToCopy$1 = next$1;
            while ((!$n(next$1).isEmpty__Z())) {
              var head$1 = $n(next$1).head__O();
              if (($uZ(f$3(head$1)) !== false)) {
                next$1 = $as_sci_List($n(next$1).tail__O())
              } else {
                while ((nextToCopy$1 !== next$1)) {
                  var newElem$2$1 = new $c_sci_$colon$colon($n(nextToCopy$1).head__O(), $m_sci_Nil$());
                  $n(currentLast$1).sci_$colon$colon__f_next = newElem$2$1;
                  currentLast$1 = newElem$2$1;
                  nextToCopy$1 = $as_sci_List($n(nextToCopy$1).tail__O())
                };
                nextToCopy$1 = $as_sci_List($n(next$1).tail__O());
                next$1 = $as_sci_List($n(next$1).tail__O())
              }
            };
            if ((!$n(nextToCopy$1).isEmpty__Z())) {
              $n(currentLast$1).sci_$colon$colon__f_next = nextToCopy$1
            };
            var result$1 = newHead$1;
            break block$2
          }
        }
      }
    }
  };
  var templatedEntries = $as_sci_Map($n(this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templatedEntries).filter__F1__O(new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_T2(p$2);
    return $uZ($n(f).apply__O__O($n($as_Lreactbuild_model_ListTemplateEntry($n(p)._1__O())).Lreactbuild_model_ListTemplateEntry__f_terms))
  }))));
  var update = this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update;
  return new $c_Lreactbuild_analyze_cost_modules_IndexedListEntry(templates, result$1, templatedEntries, update)
});
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.count__F1__I = (function(f) {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_customEntries);
  var res = 0;
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var arg1 = $n(it).next__O();
    var e = $as_Lreactbuild_model_WithChildren(arg1);
    if ($uZ($n(f).apply__O__O($n($as_Lreactbuild_model_CustomListEntry($n(e).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_CustomListEntry__f_terms))) {
      res = ((1 + res) | 0)
    }
  };
  var $$x1 = res;
  var this$2 = $n(this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templates);
  var acc = 0;
  var these = this$2;
  while ((!$n(these).isEmpty__Z())) {
    var arg1$1 = acc;
    var arg2 = $n(these).head__O();
    var acc$1 = $uI(arg1$1);
    var c = $as_Lreactbuild_model_WithChildren(arg2);
    var this$3 = $n($n(c).Lreactbuild_model_WithChildren__f_children);
    var res$1 = 0;
    var it$1 = this$3.iterator__sc_Iterator();
    while ($n(it$1).hasNext__Z()) {
      var arg1$2 = $n(it$1).next__O();
      var e$1 = $as_Lreactbuild_model_ListTemplateEntry(arg1$2);
      if ($uZ($n(f).apply__O__O($n(e$1).Lreactbuild_model_ListTemplateEntry__f_terms))) {
        res$1 = ((1 + res$1) | 0)
      }
    };
    acc = ((acc$1 + res$1) | 0);
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return (($$x1 + $uI(acc)) | 0)
});
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.productPrefix__T = (function() {
  return "IndexedListEntry"
});
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templates;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_customEntries;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templatedEntries;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_IndexedListEntry)) {
    var IndexedListEntry$1 = $as_Lreactbuild_analyze_cost_modules_IndexedListEntry(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templates;
    var x$2 = $n(IndexedListEntry$1).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templates;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_customEntries;
      var x$4 = $n(IndexedListEntry$1).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_customEntries;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templatedEntries;
      var x$6 = $n(IndexedListEntry$1).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_templatedEntries;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update;
        var x$8 = $n(IndexedListEntry$1).Lreactbuild_analyze_cost_modules_IndexedListEntry__f_update;
        if ((x$7 === null)) {
          return (x$8 === null)
        } else {
          var this$1 = $n(x$7);
          return (this$1 === x$8)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_IndexedListEntry(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_IndexedListEntry) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.IndexedListEntry"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_IndexedListEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_IndexedListEntry)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_IndexedListEntry(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_IndexedListEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.IndexedListEntry;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_IndexedListEntry = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_IndexedListEntry: 0
}, false, "reactbuild.analyze.cost.modules.IndexedListEntry", {
  Lreactbuild_analyze_cost_modules_IndexedListEntry: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_IndexedListEntry.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_IndexedListEntry;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(iconSource, color, name, lineDecoration, create) {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_iconSource = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_color = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_lineDecoration = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_create = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_iconSource = iconSource;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_color = color;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name = name;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_lineDecoration = lineDecoration;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_create = create
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.style__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  var this$4 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
  var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).color__Ljapgolly_scalajs_react_vdom_HtmlStyles$color$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_color).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), $n($m_Lreactbuild_analyze_cost_modules_EntryList$().Lreactbuild_analyze_cost_modules_EntryList$__f_fill).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_color).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return this$4.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.productPrefix__T = (function() {
  return "EventType"
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_iconSource;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_color;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_lineDecoration;
      break
    }
    case 4: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption(this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_create);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType)) {
    var EventType$1 = $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_iconSource;
    var x$2 = $n(EventType$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_iconSource;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_color;
      var x$4 = $n(EventType$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_color;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name === $n(EventType$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name)) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_lineDecoration;
        var x$6 = $n(EventType$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_lineDecoration;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var x$7 = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_create;
          var x$8 = $n(EventType$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_create;
          if ((x$7 === null)) {
            return (x$8 === null)
          } else {
            var this$2 = $n(x$7);
            return (this$2 === x$8)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ListEntryTypeSection$EventType"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ListEntryTypeSection$EventType;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$EventType", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary(state, status, myState) {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_state = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_status = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_myState = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_state = state;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_status = status;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_myState = myState
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype.productPrefix__T = (function() {
  return "HistorySummary"
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_state;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_status;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_myState;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary)) {
    var HistorySummary$1 = $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_state;
    var x$2 = $n(HistorySummary$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_state;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_status;
      var x$4 = $n(HistorySummary$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_status;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_myState;
      var x$6 = $n(HistorySummary$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary__f_myState;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(HistorySummary$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ListEntryTypeSection$HistorySummary"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ListEntryTypeSection$HistorySummary;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$HistorySummary", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_MapLogic$Init(layers, controls) {
  this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers = null;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_controls = null;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers = layers;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_controls = controls
}
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_MapLogic$Init;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_MapLogic$Init() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype = $c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype;
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.renderLayers__sci_List__Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__sci_List = (function(visibleLayers, additionalLayers) {
  var this$5 = $n(this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers);
  var f = ((p$2) => {
    var p = $as_T2(p$2);
    var u = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$().apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n(p)._2__O(), $n(visibleLayers).contains__O__Z($n(p)._1__O()), $m_sci_Nil$());
    var this$3 = $n(u);
    var n = this$3.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  });
  if ((this$5 === $m_sci_Nil$())) {
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = this$5.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$5.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x1 = h
  };
  var this$6 = $n($$x1);
  var suffix = $n(additionalLayers).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_layers;
  return this$6.appendedAll__sc_IterableOnce__sci_List(suffix)
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.getBuildingSource__s_Option = (function() {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers);
  var pf = new $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1(this);
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this$1, pf)
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.getParcelSource__s_Option = (function() {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers);
  var pf = new $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1(this);
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this$1, pf)
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.productPrefix__T = (function() {
  return "Init"
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_controls;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_MapLogic$Init)) {
    var Init$1 = $as_Lreactbuild_analyze_cost_modules_MapLogic$Init(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers;
    var x$2 = $n(Init$1).Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_MapLogic$Init__f_controls;
      var x$4 = $n(Init$1).Lreactbuild_analyze_cost_modules_MapLogic$Init__f_controls;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_MapLogic$Init(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_MapLogic$Init) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.MapLogic$Init"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_MapLogic$Init(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_MapLogic$Init)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_MapLogic$Init(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_MapLogic$Init(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.MapLogic$Init;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_MapLogic$Init = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_MapLogic$Init: 0
}, false, "reactbuild.analyze.cost.modules.MapLogic$Init", {
  Lreactbuild_analyze_cost_modules_MapLogic$Init: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_MapLogic$Init;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_MapLogic$Props(proxy, geolocation, mapInteractionLayers, f) {
  this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_geolocation = null;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_mapInteractionLayers = null;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_f = null;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_geolocation = geolocation;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_mapInteractionLayers = mapInteractionLayers;
  this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_f = f
}
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_MapLogic$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_MapLogic$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype = $c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_geolocation;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_mapInteractionLayers;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_MapLogic$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_MapLogic$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_MapLogic$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_geolocation;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_MapLogic$Props__f_geolocation;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_mapInteractionLayers;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_MapLogic$Props__f_mapInteractionLayers;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_MapLogic$Props__f_f;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_MapLogic$Props__f_f;
        if ((x$7 === null)) {
          return (x$8 === null)
        } else {
          var this$1 = $n(x$7);
          return (this$1 === x$8)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_MapLogic$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_MapLogic$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.MapLogic$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_MapLogic$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_MapLogic$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_MapLogic$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_MapLogic$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.MapLogic$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_MapLogic$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_MapLogic$Props: 0
}, false, "reactbuild.analyze.cost.modules.MapLogic$Props", {
  Lreactbuild_analyze_cost_modules_MapLogic$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_MapLogic$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PeriodRange(start) {
  this.Lreactbuild_analyze_cost_modules_PeriodRange__f_start = null;
  this.Lreactbuild_analyze_cost_modules_PeriodRange__f_end = null;
  this.Lreactbuild_analyze_cost_modules_PeriodRange__f_days = null;
  this.Lreactbuild_analyze_cost_modules_PeriodRange__f_start = start;
  this.Lreactbuild_analyze_cost_modules_PeriodRange__f_end = $n(start).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(6, 0));
  var b = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
  var it = new $c_sci_RangeIterator(0, 1, 6, false);
  while (it.sci_RangeIterator__f__hasNext) {
    var this$5 = $n(b);
    var arg1 = it.next__I();
    var $$x1 = $n(this.Lreactbuild_analyze_cost_modules_PeriodRange__f_start);
    var hi = (arg1 >> 31);
    var elem = $n($$x1).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(arg1, hi));
    this$5.addOne__O__scm_Growable(elem)
  };
  this.Lreactbuild_analyze_cost_modules_PeriodRange__f_days = $as_sci_IndexedSeq($n(b).result__O())
}
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PeriodRange;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PeriodRange() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PeriodRange.prototype = $c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype;
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype.productPrefix__T = (function() {
  return "PeriodRange"
});
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_PeriodRange__f_start : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_PeriodRange)) {
    var PeriodRange$1 = $as_Lreactbuild_analyze_cost_modules_PeriodRange(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_PeriodRange__f_start;
    var x$2 = $n(PeriodRange$1).Lreactbuild_analyze_cost_modules_PeriodRange__f_start;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PeriodRange$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_PeriodRange(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_PeriodRange) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.PeriodRange"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_PeriodRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_PeriodRange)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_PeriodRange(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_PeriodRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.PeriodRange;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_PeriodRange = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PeriodRange: 0
}, false, "reactbuild.analyze.cost.modules.PeriodRange", {
  Lreactbuild_analyze_cost_modules_PeriodRange: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PeriodRange.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PeriodRange;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$(outer) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$.prototype.toString__T = (function() {
  return "CommunicationList"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$.prototype.apply__s_Option__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList = (function(communication) {
  return new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$__f_$outer, communication)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$.prototype.apply__O__O = (function(v1) {
  return this.apply__s_Option__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList($as_s_Option(v1))
});
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$CommunicationList$", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$(outer) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$.prototype.toString__T = (function() {
  return "DocumentLineList"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$.prototype.apply__Z__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList = (function(allGroup) {
  return new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$__f_$outer, allGroup)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$.prototype.apply__O__O = (function(v1) {
  return this.apply__Z__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList($uZ(v1))
});
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$DocumentLineList$", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$(outer) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$.prototype = new $h_sr_AbstractFunction6();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$.prototype.toString__T = (function() {
  return "Products"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$.prototype.apply__Z__Z__Z__Z__Z__s_Option__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products = (function(allGroup, hideFixedPriceLines, hideDescendingPriceLines, showOnlyMovementInPeriod, showOnlyReferencePrice, invoicePage) {
  return new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$__f_$outer, allGroup, hideFixedPriceLines, hideDescendingPriceLines, showOnlyMovementInPeriod, showOnlyReferencePrice, invoicePage)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$.prototype.apply__O__O__O__O__O__O__O = (function(v1, v2, v3, v4, v5, v6) {
  return this.apply__Z__Z__Z__Z__Z__s_Option__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products($uZ(v1), $uZ(v2), $uZ(v3), $uZ(v4), $uZ(v5), $as_s_Option(v6))
});
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$Products$", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$: 1,
  sr_AbstractFunction6: 1,
  O: 1,
  F6: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$(outer) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$.prototype.toString__T = (function() {
  return "ReconciliationReport"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$.prototype.apply__Z__Lreactbuild_analyze_cost_ReconciliationReportOrder__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport = (function(allGroup, order) {
  return new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$__f_$outer, allGroup, order)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$.prototype.apply__O__O__O = (function(v1, v2) {
  return this.apply__Z__Lreactbuild_analyze_cost_ReconciliationReportOrder__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport($uZ(v1), $as_Lreactbuild_analyze_cost_ReconciliationReportOrder(v2))
});
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$ReconciliationReport$", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Processing$Props(pageProps, ref) {
  this.Lreactbuild_analyze_cost_modules_Processing$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_Processing$Props__f_ref = null;
  this.Lreactbuild_analyze_cost_modules_Processing$Props__f_pageProps = pageProps;
  this.Lreactbuild_analyze_cost_modules_Processing$Props__f_ref = ref
}
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Processing$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Processing$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Processing$Props.prototype = $c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_Processing$Props__f_pageProps;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_Processing$Props__f_ref;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_Processing$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_Processing$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_Processing$Props__f_pageProps;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_Processing$Props__f_pageProps;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_Processing$Props__f_ref;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_Processing$Props__f_ref;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_Processing$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Processing$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Processing$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Processing$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Processing$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Processing$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Processing$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Processing$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_Processing$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Processing$Props: 0
}, false, "reactbuild.analyze.cost.modules.Processing$Props", {
  Lreactbuild_analyze_cost_modules_Processing$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_Processing$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Processing$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Processing$State(invoicePage) {
  this.Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage = null;
  this.Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage = invoicePage
}
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Processing$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Processing$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Processing$State.prototype = $c_Lreactbuild_analyze_cost_modules_Processing$State.prototype;
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_Processing$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_Processing$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_Processing$State__f_invoicePage;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(State$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_Processing$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Processing$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Processing$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Processing$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Processing$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Processing$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Processing$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Processing$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_Processing$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Processing$State: 0
}, false, "reactbuild.analyze.cost.modules.Processing$State", {
  Lreactbuild_analyze_cost_modules_Processing$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_Processing$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Processing$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Projects$Props(pageProps, view) {
  this.Lreactbuild_analyze_cost_modules_Projects$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_Projects$Props__f_view = null;
  this.Lreactbuild_analyze_cost_modules_Projects$Props__f_pageProps = pageProps;
  this.Lreactbuild_analyze_cost_modules_Projects$Props__f_view = view
}
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Projects$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Projects$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Projects$Props.prototype = $c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_Projects$Props__f_pageProps;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_Projects$Props__f_view;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_Projects$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_Projects$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_Projects$Props__f_pageProps;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_Projects$Props__f_pageProps;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_Projects$Props__f_view;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_Projects$Props__f_view;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_Projects$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Projects$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Projects$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Projects$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Projects$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Projects$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Projects$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Projects$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_Projects$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Projects$Props: 0
}, false, "reactbuild.analyze.cost.modules.Projects$Props", {
  Lreactbuild_analyze_cost_modules_Projects$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_Projects$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Projects$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props(router, proxy) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_router = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_router = router;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_router;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_proxy;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_router;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_router;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_proxy;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props__f_proxy;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReconcileDeliveryForm$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReconcileDeliveryForm$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryForm$Props", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(date, reference, organization, active) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date = date;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference = reference;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization = organization;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active = active
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_date;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference;
      var x$4 = $n(State$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_reference;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization;
      var x$6 = $n(State$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_organization;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active;
        var x$8 = $n(State$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State__f_active;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          $n(State$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReconcileDeliveryForm$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReconcileDeliveryForm$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryForm$State", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryForm$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props(invoiceDetails, reconciliationLines, date, active, deliveryForms, proxy) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_invoiceDetails = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_reconciliationLines = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_date = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_active = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_deliveryForms = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_invoiceDetails = invoiceDetails;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_reconciliationLines = reconciliationLines;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_date = date;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_active = active;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_deliveryForms = deliveryForms;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_invoiceDetails;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_reconciliationLines;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_date;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_active;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_deliveryForms;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_proxy;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_invoiceDetails;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_invoiceDetails;
    if ((x === null)) {
      var $$x2 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x2 = (this$1 === x$2)
    };
    if ($$x2) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_reconciliationLines;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_reconciliationLines;
      if ((x$3 === null)) {
        var $$x3 = (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x3 = (this$2 === x$4)
      };
      if ($$x3) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_date;
        var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_date;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_active;
      var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_active;
      if ((x$7 === null)) {
        var $$x4 = (x$8 === null)
      } else {
        var this$3 = $n(x$7);
        var $$x4 = (this$3 === x$8)
      };
      if ($$x4) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_deliveryForms;
        var x$10 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_deliveryForms;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_proxy;
          var x$12 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_proxy;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$Props", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(newReconciliationLine) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State__f_newReconciliationLine = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State__f_newReconciliationLine = newReconciliationLine
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State__f_newReconciliationLine : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State__f_newReconciliationLine;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State__f_newReconciliationLine;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$State", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$.prototype.toString__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$.prototype.apply$default$1__Lreactbuild_model_MissingDeliveryFormDetails = (function() {
  return new $c_Lreactbuild_model_MissingDeliveryFormDetails(new $c_Lreactbuild_model_InvoiceDetail(($m_Lreactbuild_model_InvoiceDetail$(), $m_ju_UUID$().randomUUID__ju_UUID()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$()), ($m_Lreactbuild_model_InvoiceDetail$(), $m_s_None$())))
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$.prototype.apply__O__O = (function(v1) {
  var newReconciliationLine = $as_Lreactbuild_model_MissingDeliveryFormDetails(v1);
  return new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State(newReconciliationLine)
});
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$State$", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$;
var $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$;
function $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$)) {
    $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$ = new $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$State$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props(invoiceDetail, reconciliationLine, date, active, deliveryForms, proxy) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_invoiceDetail = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_reconciliationLine = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_date = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_active = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_deliveryForms = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_invoiceDetail = invoiceDetail;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_reconciliationLine = reconciliationLine;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_date = date;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_active = active;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_deliveryForms = deliveryForms;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_invoiceDetail;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_reconciliationLine;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_date;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_active;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_deliveryForms;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_proxy;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_invoiceDetail;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_invoiceDetail;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_reconciliationLine;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_reconciliationLine;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x2 = (this$1 === x$4)
      };
      if ($$x2) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_date;
        var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_date;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_active;
      var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_active;
      if ((x$7 === null)) {
        var $$x3 = (x$8 === null)
      } else {
        var this$2 = $n(x$7);
        var $$x3 = (this$2 === x$8)
      };
      if ($$x3) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_deliveryForms;
        var x$10 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_deliveryForms;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_proxy;
          var x$12 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props__f_proxy;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReconcileDeliveryLine$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReconcileDeliveryLine$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryLine$Props", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_RenderProject$Props(pageProps, viewState, project) {
  this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_viewState = null;
  this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_project = null;
  this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_pageProps = pageProps;
  this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_viewState = viewState;
  this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_project = project
}
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_RenderProject$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_RenderProject$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype = $c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_pageProps;
      break
    }
    case 1: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_viewState);
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_project;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_RenderProject$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_RenderProject$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_pageProps;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_pageProps;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_viewState;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_viewState;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      };
      if ($$x1) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_RenderProject$Props__f_project;
        var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_RenderProject$Props__f_project;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_RenderProject$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_RenderProject$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.RenderProject$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_RenderProject$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_RenderProject$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_RenderProject$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_RenderProject$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.RenderProject$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_RenderProject$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_RenderProject$Props: 0
}, false, "reactbuild.analyze.cost.modules.RenderProject$Props", {
  Lreactbuild_analyze_cost_modules_RenderProject$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_RenderProject$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_RenderProject$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Report$Props(router, proxy, periodRange) {
  this.Lreactbuild_analyze_cost_modules_Report$Props__f_router = null;
  this.Lreactbuild_analyze_cost_modules_Report$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_Report$Props__f_periodRange = null;
  this.Lreactbuild_analyze_cost_modules_Report$Props__f_router = router;
  this.Lreactbuild_analyze_cost_modules_Report$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_Report$Props__f_periodRange = periodRange
}
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Report$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Report$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Report$Props.prototype = $c_Lreactbuild_analyze_cost_modules_Report$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_Report$Props__f_router;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_Report$Props__f_proxy;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_Report$Props__f_periodRange;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_Report$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_Report$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_Report$Props__f_router;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_Report$Props__f_router;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_Report$Props__f_proxy;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_Report$Props__f_proxy;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_Report$Props__f_periodRange;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_Report$Props__f_periodRange;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_Report$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Report$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Report$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Report$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Report$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Report$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Report$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Report$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_Report$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Report$Props: 0
}, false, "reactbuild.analyze.cost.modules.Report$Props", {
  Lreactbuild_analyze_cost_modules_Report$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_Report$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Report$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Report$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Report$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Report$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Report$State.prototype = $c_Lreactbuild_analyze_cost_modules_Report$State.prototype;
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype.equals__O__Z = (function(x$1) {
  return ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_Report$State) && ($n($as_Lreactbuild_analyze_cost_modules_Report$State(x$1)), true))
});
function $as_Lreactbuild_analyze_cost_modules_Report$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_Report$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.Report$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_Report$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_Report$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_Report$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_Report$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.Report$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_Report$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Report$State: 0
}, false, "reactbuild.analyze.cost.modules.Report$State", {
  Lreactbuild_analyze_cost_modules_Report$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_Report$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Report$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend.prototype = new $h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend();
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend.prototype;
var $d_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReportAddLevelItem$Backend", {
  Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend: 1,
  Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps(proxy, fieldSpec, done) {
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_fieldSpec = null;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_done = null;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_fieldSpec = fieldSpec;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_done = done
}
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_fieldSpec;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_done;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_proxy;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_fieldSpec;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_fieldSpec;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_done;
      var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps__f_done;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(TypedProps$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportAddLevelItem$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportAddLevelItem$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.ReportAddLevelItem$TypedProps", {
  Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(active) {
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState__f_active = false;
  this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState__f_active = active
}
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype = $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState__f_active : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedState");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState__f_active ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(x$1);
    return ((this.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState__f_active === $n(TypedState$1).Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState__f_active) && ($n(TypedState$1), true))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportAddLevelItem$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportAddLevelItem$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState: 0
}, false, "reactbuild.analyze.cost.modules.ReportAddLevelItem$TypedState", {
  Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportAddLevelItem$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend.prototype = new $h_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend();
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend.prototype;
var $d_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReportExtractHeaders$Backend", {
  Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend: 1,
  Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragment$Props(proxy, periodRange, changeWeek) {
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_changeWeek = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange = periodRange;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_changeWeek = changeWeek
}
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragment$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragment$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_changeWeek;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragment$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragment$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_periodRange;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_changeWeek;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReportFragment$Props__f_changeWeek;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragment$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragment$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragment$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragment$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragment$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportFragment$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragment$Props: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragment$Props", {
  Lreactbuild_analyze_cost_modules_ReportFragment$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragment$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem(date, resource, buildingSite, buildingStage) {
  this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_date = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_resource = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingSite = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingStage = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_date = date;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_resource = resource;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingSite = buildingSite;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingStage = buildingStage
}
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype.productPrefix__T = (function() {
  return "SearchItem"
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_date;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_resource;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingSite;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingStage;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem)) {
    var SearchItem$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_date;
    var x$2 = $n(SearchItem$1).Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_date;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_resource;
      var x$4 = $n(SearchItem$1).Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_resource;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingSite;
      var x$6 = $n(SearchItem$1).Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingSite;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingStage;
        var x$8 = $n(SearchItem$1).Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem__f_buildingStage;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          $n(SearchItem$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragment$SearchItem"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragment$SearchItem;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragment$SearchItem", {
  Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragment$SearchItem;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragment$State(timeReports, searchItem) {
  this.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports = timeReports;
  this.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem = searchItem
}
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragment$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragment$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragment$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragment$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem;
      var x$4 = $n(State$1).Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(State$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragment$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragment$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragment$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragment$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragment$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragment$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportFragment$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragment$State: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragment$State", {
  Lreactbuild_analyze_cost_modules_ReportFragment$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragment$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend.prototype = new $h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend.prototype;
var $d_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragmentDetails$Backend", {
  Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend: 1,
  Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps(parents, proxy, periodRange, timeReports, fieldSpec, fieldValue, updateTimeReports) {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_parents = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_periodRange = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_timeReports = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldSpec = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldValue = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_updateTimeReports = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_parents = parents;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_periodRange = periodRange;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_timeReports = timeReports;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldSpec = fieldSpec;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldValue = fieldValue;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_updateTimeReports = updateTimeReports
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.deriveState__Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState = (function() {
  return new $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState($n(this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_timeReports).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$40$2) => {
    var x$40 = $as_Lreactbuild_model_TimeReport(x$40$2);
    var x = $n(this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldSpec).extract__Lreactbuild_model_TimeReport__O(x$40);
    var y = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldValue;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  }))))
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_parents;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_proxy;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_periodRange;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_timeReports;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldSpec;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldValue;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_updateTimeReports;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_parents;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_parents;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_proxy;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_proxy;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_periodRange;
      var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_periodRange;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_timeReports;
        var x$8 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_timeReports;
        var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldSpec;
      var x$10 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldSpec;
      if ((x$9 === null)) {
        var $$x4 = (x$10 === null)
      } else {
        var this$1 = $n(x$9);
        var $$x4 = (this$1 === x$10)
      };
      if ($$x4) {
        var x$11 = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldValue;
        var y = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_fieldValue;
        var $$x3 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$11, y)
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$11$1 = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_updateTimeReports;
        var x$12 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps__f_updateTimeReports;
        if ((x$11$1 === null)) {
          var $$x5 = (x$12 === null)
        } else {
          var this$2 = $n(x$11$1);
          var $$x5 = (this$2 === x$12)
        };
        if ($$x5) {
          $n(TypedProps$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragmentDetails$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragmentDetails$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragmentDetails$TypedProps", {
  Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(timeReport) {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport = timeReport
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport;
    var x$2 = $n(TypedState$1).Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState__f_timeReport;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(TypedState$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragmentDetails$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragmentDetails$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragmentDetails$TypedState", {
  Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragmentDetails$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__f_ctx = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend__f_$ = \u03b4;
  $ct_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend__(this)
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend.prototype = new $h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend.prototype;
var $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragmentGroup$Backend", {
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend: 1,
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState(selectedTimeReports) {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState__f_selectedTimeReports = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState__f_selectedTimeReports = selectedTimeReports
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState__f_selectedTimeReports : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState__f_selectedTimeReports;
    var x$2 = $n(TypedState$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState__f_selectedTimeReports;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(TypedState$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragmentGroup$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragmentGroup$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragmentGroup$TypedState", {
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps(proxy, periodRange, timeReports, fieldSpec, f) {
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_periodRange = null;
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_timeReports = null;
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_fieldSpec = null;
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_f = null;
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_periodRange = periodRange;
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_timeReports = timeReports;
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_fieldSpec = fieldSpec;
  this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_f = f
}
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_periodRange;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_timeReports;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_fieldSpec;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_proxy;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_periodRange;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_periodRange;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_timeReports;
      var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_timeReports;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_fieldSpec;
        var x$8 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_fieldSpec;
        if ((x$7 === null)) {
          var $$x2 = (x$8 === null)
        } else {
          var this$1 = $n(x$7);
          var $$x2 = (this$1 === x$8)
        };
        if ($$x2) {
          var x$9 = this.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_f;
          var x$10 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps__f_f;
          if ((x$9 === null)) {
            return (x$10 === null)
          } else {
            var this$2 = $n(x$9);
            return (this$2 === x$10)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportLevel$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportLevel$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.ReportLevel$TypedProps", {
  Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportLevel$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend.prototype = new $h_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend();
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend.prototype = $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend.prototype;
var $d_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend: 0
}, false, "reactbuild.analyze.cost.modules.ReportSelectAdditionalHeaders$Backend", {
  Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend: 1,
  Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps(f) {
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps__f_f = null;
  this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps__f_f = f
}
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps__f_f : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps__f_f;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps__f_f;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportSelectAdditionalHeaders$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportSelectAdditionalHeaders$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.ReportSelectAdditionalHeaders$TypedProps", {
  Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportSelectAdditionalHeaders$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportTotal$Props(proxy, periodRange, timeReports, changeWeek) {
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_periodRange = null;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_timeReports = null;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_changeWeek = null;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_periodRange = periodRange;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_timeReports = timeReports;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_changeWeek = changeWeek
}
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportTotal$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportTotal$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype = $c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.deriveState__Lreactbuild_analyze_cost_modules_ReportTotal$State = (function() {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_timeReports);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var tr = $as_Lreactbuild_model_TimeReport(elem);
    var $$x1 = $n(tr).Lreactbuild_model_TimeReport__f_resource;
    var this$2 = $n($n($n(this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_periodRange).Lreactbuild_analyze_cost_modules_PeriodRange__f_start).until__Ljava_time_chrono_ChronoLocalDate__Ljava_time_Period($n(tr).Lreactbuild_model_TimeReport__f_date));
    var key = $ct_T2__O__O__(new $c_T2(), $$x1, this$2.Ljava_time_Period__f_days);
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(this$1))));
    var this$3 = $n(bldr);
    this$3.addOne__O__scm_Growable(elem)
  };
  var this$4 = $m_sci_HashMap$();
  var result = this$4.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
  };
  var this$5 = $n(result);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$5.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1 = $n(it$1).next__O();
    var i = $as_T2(arg1);
    var self = $n(i)._1__O();
    var y = new $c_Lreactbuild_model_Duration($uD($n($as_sc_IterableOnceOps($n(i)._2__O())).foldLeft__O__F2__O(0.0, new $c_sjsr_AnonFunction2(((acc$2, c$2) => {
      var acc = $uD(acc$2);
      var c = $as_Lreactbuild_model_TimeReport(c$2);
      return (acc + $n($n(c).Lreactbuild_model_TimeReport__f_duration).Lreactbuild_model_Duration__f_value)
    })))));
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var h = $m_sr_Statics$().anyHash__O__I(self);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, self, y, h, im, 0)
  };
  var this$10 = $n(b.result__sci_HashMap());
  var m$1 = $as_scm_Map($m_scm_Map$().empty__O());
  var it$2 = this$10.iterator__sc_Iterator();
  while ($n(it$2).hasNext__Z()) {
    var elem$1 = $n(it$2).next__O();
    var tr$3 = $as_T2(elem$1);
    var key$1 = $as_Lreactbuild_common_model_RefTo($n($as_T2($n(tr$3)._1__O()))._1__O());
    var bldr$1 = $as_scm_Builder($n(m$1).getOrElseUpdate__O__F0__O(key$1, new $c_sjsr_AnonFunction0((() => {
      $m_sci_HashMap$();
      return new $c_sci_HashMapBuilder()
    }))));
    var this$12 = $n(bldr$1);
    this$12.addOne__O__scm_Growable(elem$1)
  };
  var this$13 = $m_sci_HashMap$();
  var result$1 = this$13.sci_HashMap$__f_EmptyMap;
  var mapIt$1 = $n(m$1).iterator__sc_Iterator();
  while ($n(mapIt$1).hasNext__Z()) {
    var x1$1 = $as_T2($n(mapIt$1).next__O());
    if ((x1$1 === null)) {
      throw new $c_s_MatchError(x1$1)
    };
    var k$1 = $n(x1$1)._1__O();
    var v$1 = $as_scm_Builder($n(x1$1)._2__O());
    result$1 = $n(result$1).updated__O__O__sci_HashMap(k$1, $n(v$1).result__O())
  };
  var this$14 = $n(result$1);
  $m_sci_HashMap$();
  var b$1 = new $c_sci_HashMapBuilder();
  var it$3 = this$14.iterator__sc_Iterator();
  while ($n(it$3).hasNext__Z()) {
    var arg1$1 = $n(it$3).next__O();
    var i$3 = $as_T2(arg1$1);
    var self$1 = $n(i$3)._1__O();
    var this$21 = $n($as_sci_Map($n($as_sc_MapOps($n(i$3)._2__O())).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((c$2$1) => {
      var c$1 = $as_T2(c$2$1);
      var self$2 = $n($as_T2($n(c$1)._1__O()))._2$mcI$sp__I();
      var y$1 = $n(c$1)._2__O();
      return $ct_T2__O__O__(new $c_T2(), self$2, y$1)
    })))));
    var this$20 = $m_s_$less$colon$less$();
    var y$2 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$21);
    $p_sci_HashMapBuilder__ensureUnaliased__V(b$1);
    var h$1 = $m_sr_Statics$().anyHash__O__I(self$1);
    var im$1 = $m_sc_Hashing$().improve__I__I(h$1);
    b$1.update__sci_MapNode__O__O__I__I__I__V(b$1.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, self$1, y$2, h$1, im$1, 0)
  };
  var this$23 = $n(b$1.result__sci_HashMap());
  return new $c_Lreactbuild_analyze_cost_modules_ReportTotal$State($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$23))
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_periodRange;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_timeReports;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_changeWeek;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportTotal$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_ReportTotal$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_periodRange;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_periodRange;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_timeReports;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_timeReports;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_changeWeek;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_ReportTotal$Props__f_changeWeek;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          $n(Props$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportTotal$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportTotal$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportTotal$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportTotal$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportTotal$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportTotal$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportTotal$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportTotal$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportTotal$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportTotal$Props: 0
}, false, "reactbuild.analyze.cost.modules.ReportTotal$Props", {
  Lreactbuild_analyze_cost_modules_ReportTotal$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportTotal$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportTotal$State(byResources) {
  this.Lreactbuild_analyze_cost_modules_ReportTotal$State__f_byResources = null;
  this.Lreactbuild_analyze_cost_modules_ReportTotal$State__f_byResources = byResources
}
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportTotal$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportTotal$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype = $c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_ReportTotal$State__f_byResources : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportTotal$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_ReportTotal$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportTotal$State__f_byResources;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_ReportTotal$State__f_byResources;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(State$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportTotal$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportTotal$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportTotal$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportTotal$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportTotal$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportTotal$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportTotal$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportTotal$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportTotal$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportTotal$State: 0
}, false, "reactbuild.analyze.cost.modules.ReportTotal$State", {
  Lreactbuild_analyze_cost_modules_ReportTotal$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportTotal$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportTotal$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype = $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props)
});
function $as_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.RetrieveSupplierDocuments$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.RetrieveSupplierDocuments$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props: 0
}, false, "reactbuild.analyze.cost.modules.RetrieveSupplierDocuments$Props", {
  Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype = $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype;
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State)
});
function $as_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.RetrieveSupplierDocuments$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.RetrieveSupplierDocuments$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State: 0
}, false, "reactbuild.analyze.cost.modules.RetrieveSupplierDocuments$State", {
  Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_RetrieveSupplierDocuments$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_SendReceipt$Props(pageProps, ref) {
  this.Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_ref = null;
  this.Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_pageProps = pageProps;
  this.Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_ref = ref
}
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_SendReceipt$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_SendReceipt$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype = $c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_pageProps;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_ref;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_SendReceipt$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_SendReceipt$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_pageProps;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_pageProps;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_ref;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_SendReceipt$Props__f_ref;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_SendReceipt$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_SendReceipt$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.SendReceipt$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_SendReceipt$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_SendReceipt$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_SendReceipt$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_SendReceipt$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.SendReceipt$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_SendReceipt$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_SendReceipt$Props: 0
}, false, "reactbuild.analyze.cost.modules.SendReceipt$Props", {
  Lreactbuild_analyze_cost_modules_SendReceipt$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_SendReceipt$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_SendReceipt$State(receipt) {
  this.Lreactbuild_analyze_cost_modules_SendReceipt$State__f_receipt = null;
  this.Lreactbuild_analyze_cost_modules_SendReceipt$State__f_receipt = receipt
}
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_SendReceipt$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_SendReceipt$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype = $c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype;
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_SendReceipt$State__f_receipt : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_SendReceipt$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_SendReceipt$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_SendReceipt$State__f_receipt;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_SendReceipt$State__f_receipt;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(State$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_SendReceipt$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_SendReceipt$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.SendReceipt$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_SendReceipt$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_SendReceipt$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_SendReceipt$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_SendReceipt$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.SendReceipt$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_SendReceipt$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_SendReceipt$State: 0
}, false, "reactbuild.analyze.cost.modules.SendReceipt$State", {
  Lreactbuild_analyze_cost_modules_SendReceipt$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_SendReceipt$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_SendReceipt$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_SupplyList$Props(project, state, proxy, user) {
  this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_project = null;
  this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_state = null;
  this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_user = null;
  this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_project = project;
  this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_state = state;
  this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_user = user
}
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_SupplyList$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_SupplyList$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype = $c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_state;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_proxy;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_user;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_SupplyList$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_SupplyList$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_project;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_SupplyList$Props__f_project;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_state;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_SupplyList$Props__f_state;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_proxy;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_SupplyList$Props__f_proxy;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_SupplyList$Props__f_user;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_SupplyList$Props__f_user;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_SupplyList$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_SupplyList$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.SupplyList$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_SupplyList$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_SupplyList$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_SupplyList$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_SupplyList$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.SupplyList$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_SupplyList$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_SupplyList$Props: 0
}, false, "reactbuild.analyze.cost.modules.SupplyList$Props", {
  Lreactbuild_analyze_cost_modules_SupplyList$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_SupplyList$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_SupplyList$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_SupplyList$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_SupplyList$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype = $c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype;
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_SupplyList$State)
});
function $as_Lreactbuild_analyze_cost_modules_SupplyList$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_SupplyList$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.SupplyList$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_SupplyList$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_SupplyList$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_SupplyList$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_SupplyList$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.SupplyList$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_SupplyList$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_SupplyList$State: 0
}, false, "reactbuild.analyze.cost.modules.SupplyList$State", {
  Lreactbuild_analyze_cost_modules_SupplyList$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_SupplyList$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_SupplyList$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermLevel$Props(context, term, level, expanded, data) {
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term = null;
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_level = 0;
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_expanded = null;
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_data = null;
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context = context;
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term = term;
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_level = level;
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_expanded = expanded;
  this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_data = data
}
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermLevel$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermLevel$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype = $c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_level;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_expanded;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_data;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_level;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_expanded;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_data;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_TermLevel$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_TermLevel$Props(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_level === $n(Props$1).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_level)) {
      var x = this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context;
      var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_context;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_term;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_expanded;
        var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_expanded;
        if ((x$5 === null)) {
          var $$x2 = (x$6 === null)
        } else {
          var this$1 = $n(x$5);
          var $$x2 = (this$1 === x$6)
        };
        if ($$x2) {
          var x$7 = this.Lreactbuild_analyze_cost_modules_TermLevel$Props__f_data;
          var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermLevel$Props__f_data;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_TermLevel$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_TermLevel$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.TermLevel$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_TermLevel$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_TermLevel$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_TermLevel$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_TermLevel$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.TermLevel$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_TermLevel$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermLevel$Props: 0
}, false, "reactbuild.analyze.cost.modules.TermLevel$Props", {
  Lreactbuild_analyze_cost_modules_TermLevel$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_TermLevel$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermLevel$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermListEntries$Props(context, data, level, term) {
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data = null;
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_level = 0;
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_term = null;
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_context = context;
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data = data;
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_level = level;
  this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_term = term
}
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermListEntries$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermListEntries$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype = $c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_context;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_level;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_term;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_context;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_level;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_term;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_TermListEntries$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_TermListEntries$Props(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_level === $n(Props$1).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_level)) {
      var x = this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_context;
      var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_context;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_data;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_term;
        var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermListEntries$Props__f_term;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_TermListEntries$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_TermListEntries$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.TermListEntries$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_TermListEntries$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_TermListEntries$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_TermListEntries$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_TermListEntries$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.TermListEntries$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_TermListEntries$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermListEntries$Props: 0
}, false, "reactbuild.analyze.cost.modules.TermListEntries$Props", {
  Lreactbuild_analyze_cost_modules_TermListEntries$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermListEntries$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermListEntries$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermListEntries$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermListEntries$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype = $c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype;
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_TermListEntries$State)
});
function $as_Lreactbuild_analyze_cost_modules_TermListEntries$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_TermListEntries$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.TermListEntries$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_TermListEntries$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_TermListEntries$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_TermListEntries$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_TermListEntries$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.TermListEntries$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_TermListEntries$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermListEntries$State: 0
}, false, "reactbuild.analyze.cost.modules.TermListEntries$State", {
  Lreactbuild_analyze_cost_modules_TermListEntries$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_TermListEntries$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermListEntries$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermTree$Props(context, terms, data, expanded) {
  this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_terms = null;
  this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_data = null;
  this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_expanded = null;
  this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_context = context;
  this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_terms = terms;
  this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_data = data;
  this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_expanded = expanded
}
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermTree$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermTree$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype = $c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_context;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_terms;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_data;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_expanded;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_TermTree$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_TermTree$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_context;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermTree$Props__f_context;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_terms;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermTree$Props__f_terms;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_data;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermTree$Props__f_data;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_TermTree$Props__f_expanded;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_TermTree$Props__f_expanded;
        if ((x$7 === null)) {
          return (x$8 === null)
        } else {
          var this$1 = $n(x$7);
          return (this$1 === x$8)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_TermTree$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_TermTree$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.TermTree$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_TermTree$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_TermTree$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_TermTree$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_TermTree$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.TermTree$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_TermTree$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermTree$Props: 0
}, false, "reactbuild.analyze.cost.modules.TermTree$Props", {
  Lreactbuild_analyze_cost_modules_TermTree$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_TermTree$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermTree$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_TermTree$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_TermTree$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_TermTree$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_TermTree$State.prototype = $c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype;
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_TermTree$State)
});
function $as_Lreactbuild_analyze_cost_modules_TermTree$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_TermTree$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.TermTree$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_TermTree$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_TermTree$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_TermTree$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_TermTree$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.TermTree$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_TermTree$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_TermTree$State: 0
}, false, "reactbuild.analyze.cost.modules.TermTree$State", {
  Lreactbuild_analyze_cost_modules_TermTree$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_TermTree$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_TermTree$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context(data, includeAllUsers, buildingSites, buildingStages, activeResources, inactiveResources) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_includeAllUsers = false;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingSites = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingStages = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_activeResources = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_inactiveResources = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_events = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data = data;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_includeAllUsers = includeAllUsers;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingSites = buildingSites;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingStages = buildingStages;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_activeResources = activeResources;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_inactiveResources = inactiveResources;
  var this$3 = $n(data);
  var g = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_sci_List(v$2);
    return new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_T2(x$2$2);
      $n(x$2);
      var _2 = $n(x$2).copy$default$2__O();
      return $ct_T2__O__O__(new $c_T2(), v, _2)
    }))
  }));
  var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var arg1 = this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x$1 = $as_T2(arg1);
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_events = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$3, $as_sci_List($n(x$1)._1__O()), new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
    var ot = $as_s_Option(ot$2);
    var $$x1 = $n($as_F2($n(this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$4 = $n(ot);
    return $n($$x1).apply__O__O__O((this$4.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$4.get__O()))), cb$2)
  })))
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.timeReports__sci_List = (function() {
  return $as_sci_List($n($as_T2($n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))._2__O())
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.updateTimeReport__Lreactbuild_model_TimeReport__Ljapgolly_scalajs_react_callback_Trampoline = (function(report) {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data);
  var callback = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var G = this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var arg1 = this$1.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var x0$1 = $as_T2(arg1);
  if ((x0$1 === null)) {
    throw new $c_s_MatchError(x0$1)
  };
  var events = $as_sci_List($n(x0$1)._1__O());
  var reports = $as_sci_List($n(x0$1)._2__O());
  var this$5 = $n(reports);
  _return: {
    var i = 0;
    var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$5, 0, this$5);
    while (true) {
      var this$8 = $n(these);
      if ((!this$8.isEmpty__Z())) {
        var arg1$1 = $n(these).head__O();
        var x$3 = $as_Lreactbuild_model_TimeReport(arg1$1);
        var x = $n(x$3).Lreactbuild_model_TimeReport__f__id;
        var x$2 = $n(report).Lreactbuild_model_TimeReport__f__id;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          var x1$2 = i;
          break _return
        };
        i = ((1 + i) | 0);
        these = $as_sc_LinearSeq($n(these).tail__O())
      } else {
        break
      }
    };
    var x1$2 = (-1)
  };
  if ((x1$2 === (-1))) {
    var this$9 = $n(reports);
    var updatedReports = this$9.prepended__O__sci_List(report)
  } else {
    var this$13 = $n(reports);
    var $$x1 = $n($m_s_package$().s_package$__f_Seq);
    var array = [report];
    var other = $n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var updatedReports = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$13, x1$2, other, 1))
  };
  var arg1$2 = $ct_T2__O__O__(new $c_T2(), events, updatedReports);
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$1.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$2), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.productPrefix__T = (function() {
  return "Context"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_includeAllUsers;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingSites;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingStages;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_activeResources;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_inactiveResources;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Context");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_includeAllUsers ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingSites;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingStages;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_activeResources;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_inactiveResources;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context)) {
    var Context$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_includeAllUsers === $n(Context$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_includeAllUsers)) {
      var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data;
      var x$2 = $n(Context$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_data;
      if ((x === null)) {
        var $$x2 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x2 = (this$1 === x$2)
      };
      if ($$x2) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingSites;
        var x$4 = $n(Context$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingSites;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingStages;
      var x$6 = $n(Context$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_buildingStages;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_activeResources;
        var x$8 = $n(Context$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_activeResources;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_inactiveResources;
          var x$10 = $n(Context$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context__f_inactiveResources;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Context"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Context;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Context", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Context;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props(proxy) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props__f_proxy : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props__f_proxy;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Props", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(date, includeAllUsers) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers = false;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date = date;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers = includeAllUsers
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers === $n(State$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_includeAllUsers)) {
      var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
      var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State__f_date;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$State", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props(proxy, resourceTimeReports, stack, context) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_resourceTimeReports = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_stack = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_resourceTimeReports = resourceTimeReports;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_stack = stack;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_context = context
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_resourceTimeReports;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_stack;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_resourceTimeReports;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_resourceTimeReports;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_stack;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_stack;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_context;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props__f_context;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$Props", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State(editing) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__f_editing = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__f_editing = editing
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__f_editing : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__f_editing;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State__f_editing;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCell$State", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCell$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props(proxy, resourceTimeReport, stack, context) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_resourceTimeReport = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_resourceTimeReport = resourceTimeReport;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack = stack;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_context = context
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_resourceTimeReport;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_resourceTimeReport;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_resourceTimeReport;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_stack;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_context;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props__f_context;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Props", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(events, resource, date, intervals) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_events = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_resource = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_date = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_intervals = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_events = events;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_resource = resource;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_date = date;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_intervals = intervals
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.updateEvent__Lreactbuild_model_TimeReportEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(event) {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_events);
  var callback = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var G = this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var arg1 = this$1.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
  var events = $as_sci_List(arg1);
  var this$5 = $n(events);
  _return: {
    var i = 0;
    var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$5, 0, this$5);
    while (true) {
      var this$8 = $n(these);
      if ((!this$8.isEmpty__Z())) {
        var arg1$1 = $n(these).head__O();
        var x$1 = $as_Lreactbuild_model_TimeReportEvent(arg1$1);
        var x = $n(x$1).Lreactbuild_model_TimeReportEvent__f__id;
        var x$2 = $n(event).Lreactbuild_model_TimeReportEvent__f__id;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          var x1 = i;
          break _return
        };
        i = ((1 + i) | 0);
        these = $as_sc_LinearSeq($n(these).tail__O())
      } else {
        break
      }
    };
    var x1 = (-1)
  };
  if ((x1 === (-1))) {
    var this$9 = $n(events);
    var arg1$2 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$9, event))
  } else {
    var this$13 = $n(events);
    var $$x1 = $n($m_s_package$().s_package$__f_Seq);
    var array = [event];
    var other = $n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var arg1$2 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$13, x1, other, 1))
  };
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$1.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$2), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_events;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_resource;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_date;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_intervals;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_events;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_events;
    if ((x === null)) {
      var $$x2 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x2 = (this$1 === x$2)
    };
    if ($$x2) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_resource;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_resource;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_date;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_date;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_intervals;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props__f_intervals;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$Props", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State)
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportDayIntervals$State", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportDayIntervals$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props(date, includeAllUsers, proxy, context) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_date = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_includeAllUsers = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_date = date;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_includeAllUsers = includeAllUsers;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_context = context
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_date;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_includeAllUsers;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_proxy;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_date;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_date;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_includeAllUsers;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_includeAllUsers;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_proxy;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_proxy;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_context;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props__f_context;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportResourceSummary$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportResourceSummary$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportResourceSummary$Props", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportResourceSummary$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props(proxy, context, resource, events, date) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_resource = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_events = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_date = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_context = context;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_resource = resource;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_events = events;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_date = date
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_context;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_resource;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_events;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_date;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_context;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_context;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_resource;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_resource;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_events;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_events;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_date;
          var x$10 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props__f_date;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$Props", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State)
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$State", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(start, end) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_end = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start = start;
  this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_end = end
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype.productPrefix__T = (function() {
  return "MonthRange"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_end;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange)) {
    var MonthRange$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start;
    var x$2 = $n(MonthRange$1).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_start;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_end;
      var x$4 = $n(MonthRange$1).Lreactbuild_analyze_cost_modules_hometimereport_MonthRange__f_end;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.MonthRange"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_MonthRange)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.MonthRange;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_MonthRange: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.MonthRange", {
  Lreactbuild_analyze_cost_modules_hometimereport_MonthRange: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell(date) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell__f_date = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell__f_date = date
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype.productPrefix__T = (function() {
  return "Cell"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell__f_date : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell)) {
    var Cell$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell__f_date;
    var x$2 = $n(Cell$1).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell__f_date;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$Cell"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.Multiweeks$Cell;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$Cell", {
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Cell;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props(date, weekBefore, weekAfter, notFuture, render) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_date = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekBefore = 0;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekAfter = 0;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_notFuture = false;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_render = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_date = date;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekBefore = weekBefore;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekAfter = weekAfter;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_notFuture = notFuture;
  this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_render = render
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_date;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekBefore;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekAfter;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_notFuture;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_render;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_date;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekBefore;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekAfter;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_notFuture ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_render;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props(x$1);
    if (((this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekBefore === $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekBefore) && (this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekAfter === $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_weekAfter))) {
      if ((this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_notFuture === $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_notFuture)) {
        var x = this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_date;
        var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_date;
        if ((x === null)) {
          var $$x1 = (x$2 === null)
        } else {
          var this$1 = $n(x);
          var $$x1 = (this$1 === x$2)
        };
        if ($$x1) {
          var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_render;
          var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props__f_render;
          return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.Multiweeks$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$Props", {
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State)
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.Multiweeks$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.Multiweeks$State", {
  Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_Multiweeks$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props(proxy) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props__f_proxy : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props__f_proxy;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$Props", {
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(range, resource) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range = range;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource = resource
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_range;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource;
      var x$4 = $n(State$1).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State__f_resource;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$State", {
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$.prototype.toString__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$.prototype.apply$default$1__Lreactbuild_analyze_cost_modules_hometimereport_MonthRange = (function() {
  var this$1 = $m_Ljava_time_LocalDate$();
  var now = this$1.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()));
  var value = ((8 - $n($n(now).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I()) | 0);
  var hi = (value >> 31);
  var this$4 = $n($n(now).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(value, hi)));
  var x = $m_Ljava_time_Month$().of__I__Ljava_time_Month($p_Ljava_time_LocalDate__month__S(this$4));
  var this$5 = $n(now);
  var x$2 = $m_Ljava_time_Month$().of__I__Ljava_time_Month($p_Ljava_time_LocalDate__month__S(this$5));
  if ((x === null)) {
    var $$x1 = (x$2 === null)
  } else {
    var this$6 = $n(x);
    var $$x1 = (this$6 === x$2)
  };
  if ((!$$x1)) {
    var month = 0
  } else {
    var month = (-1)
  };
  return $m_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange$().fromDate__Ljava_time_LocalDate__I__Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(now, month)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$.prototype.apply__O__O__O = (function(v1, v2) {
  var range = $as_Lreactbuild_analyze_cost_modules_hometimereport_MonthRange(v1);
  var resource = $as_s_Option(v2);
  return new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State(range, resource)
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummary$State$", {
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$;
var $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$;
function $m_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$)) {
    $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$ = new $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$()
  };
  return $n_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummary$State$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props(range, resource, events) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_range = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_resource = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_events = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_range = range;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_resource = resource;
  this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_events = events
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_range;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_resource;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_events;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_range;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_range;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_resource;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_resource;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_events;
        var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props__f_events;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$1 = $n(x$5);
          return (this$1 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$Props", {
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State)
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.TimeReportSummaryMonth$State", {
  Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_TimeReportSummaryMonth$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse(writingMaterials, archiveUrl) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_writingMaterials = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_archiveUrl = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_writingMaterials = writingMaterials;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_archiveUrl = archiveUrl
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype.productPrefix__T = (function() {
  return "DocumentResponse"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_writingMaterials;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_archiveUrl;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse)) {
    var DocumentResponse$1 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_writingMaterials;
    var x$2 = $n(DocumentResponse$1).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_writingMaterials;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_archiveUrl === $n(DocumentResponse$1).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_archiveUrl)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$DocumentResponse"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$DocumentResponse;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$DocumentResponse", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6(outer) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6__f_circeGenericDecoderForwritingMaterials = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6__f_circeGenericDecoderForarchiveUrl = null;
  $m_Lio_circe_Decoder$();
  var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
  var decodeV = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6__f_circeGenericDecoderForwritingMaterials = new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeV);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6__f_circeGenericDecoderForarchiveUrl = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6.prototype = new $h_Lio_circe_generic_decoding_ReprDecoder();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6__f_circeGenericDecoderForwritingMaterials).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("writingMaterials")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6__f_circeGenericDecoderForarchiveUrl).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("archiveUrl")), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$DocumentResponse$anon$lazy$macro$11$1$$anon$6", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6: 1,
  Lio_circe_generic_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$anon$lazy$macro$11$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest(features) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest__f_features = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest__f_features = features
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype.productPrefix__T = (function() {
  return "FeatureRequest"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest__f_features : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest)) {
    var FeatureRequest$1 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest__f_features;
    var x$2 = $n(FeatureRequest$1).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest__f_features;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequest"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequest;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequest", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3(outer) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3__f_circeGenericDecoderForfeatures = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$__f_decodeFeatureRequestEntry;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3__f_circeGenericDecoderForfeatures = new $c_Lio_circe_Decoder$$anon$44(decodeA)
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3.prototype = new $h_Lio_circe_generic_decoding_ReprDecoder();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3__f_circeGenericDecoderForfeatures).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("features")), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequest$anon$lazy$macro$7$1$$anon$3", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3: 1,
  Lio_circe_generic_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$anon$lazy$macro$7$1$$anon$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry(properties) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry__f_properties = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry__f_properties = properties
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype.productPrefix__T = (function() {
  return "FeatureRequestEntry"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry__f_properties : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry)) {
    var FeatureRequestEntry$1 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry__f_properties;
    var x$2 = $n(FeatureRequestEntry$1).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry__f_properties;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntry"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntry;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntry", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4(outer) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4__f_circeGenericDecoderForproperties = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4__f_circeGenericDecoderForproperties = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$__f_decodeFeatureRequestEntryProperties
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4.prototype = new $h_Lio_circe_generic_decoding_ReprDecoder();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4__f_circeGenericDecoderForproperties).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("properties")), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4: 1,
  Lio_circe_generic_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry$anon$lazy$macro$7$2$$anon$4;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties(id) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties__f_id = id
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype.productPrefix__T = (function() {
  return "FeatureRequestEntryProperties"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties__f_id : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties)) {
    var FeatureRequestEntryProperties$1 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties(x$1);
    return (this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties__f_id === $n(FeatureRequestEntryProperties$1).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties__f_id)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntryProperties"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntryProperties;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntryProperties", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5(outer) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5__f_circeGenericDecoderForid = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5.prototype = new $h_Lio_circe_generic_decoding_ReprDecoder();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5__f_circeGenericDecoderForid).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("id")), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5: 1,
  Lio_circe_generic_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties$anon$lazy$macro$7$3$$anon$5;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props(proxy, visibleLayers) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_visibleLayers = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_visibleLayers = visibleLayers
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_visibleLayers;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_visibleLayers;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props__f_visibleLayers;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.LayerSelection$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.LayerSelection$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerSelection$Props", {
  Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerSelection$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props(layer, visibleLayers) {
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_layer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_visibleLayers = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_layer = layer;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_visibleLayers = visibleLayers
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_layer;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_visibleLayers;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_layer;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_layer;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_visibleLayers;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props__f_visibleLayers;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.LayerSelectionLine$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.LayerSelectionLine$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerSelectionLine$Props", {
  Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerSelectionLine$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory(title) {
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapCategory__f_title = title
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapCategory() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype.productPrefix__T = (function() {
  return "MapCategory"
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_MapCategory__f_title : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory)) {
    var MapCategory$1 = $as_Lreactbuild_analyze_cost_modules_mapview_MapCategory(x$1);
    return (this.Lreactbuild_analyze_cost_modules_mapview_MapCategory__f_title === $n(MapCategory$1).Lreactbuild_analyze_cost_modules_mapview_MapCategory__f_title)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_MapCategory(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapCategory) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.MapCategory"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapCategory(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_MapCategory)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapCategory(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapCategory(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.MapCategory;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_MapCategory = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapCategory: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapCategory", {
  Lreactbuild_analyze_cost_modules_mapview_MapCategory: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapCategory.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapCategory;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props(f, geolocation) {
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_f = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_geolocation = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_f = f;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_geolocation = geolocation
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_f;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_geolocation;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_f;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_f;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_geolocation;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props__f_geolocation;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.MapInteractionLayerSource$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.MapInteractionLayerSource$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapInteractionLayerSource$Props", {
  Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayerSource$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers(geolocation, selected, hover, feature, modGeolocation) {
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_geolocation = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_selected = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_hover = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_modGeolocation = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_layers = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_geolocation = geolocation;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_selected = selected;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_hover = hover;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature = feature;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_modGeolocation = modGeolocation;
  $n($m_s_package$().s_package$__f_List);
  var u = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$().apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(geolocation, true, $m_sci_Nil$());
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  var u$1 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$().apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(selected, true, $m_sci_Nil$());
  var this$5 = $n(u$1);
  var n$1 = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x2 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
  var u$2 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$().apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(hover, true, $m_sci_Nil$());
  var this$8 = $n(u$2);
  var n$2 = this$8.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2);
  var u$3 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$().apply__Ltypings_ol_layerBaseMod$default__Z__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(feature, true, $m_sci_Nil$());
  var this$11 = $n(u$3);
  var n$3 = this$11.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [$$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_layers = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype.productPrefix__T = (function() {
  return "MapInteractionLayers"
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_geolocation;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_selected;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_hover;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_modGeolocation;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers)) {
    var MapInteractionLayers$1 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_geolocation;
    var y = $n(MapInteractionLayers$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_geolocation;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_selected;
      var y$1 = $n(MapInteractionLayers$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_selected;
      var $$x1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_hover;
      var y$2 = $n(MapInteractionLayers$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_hover;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y$2)) {
        var x$4 = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature;
        var y$3 = $n(MapInteractionLayers$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature;
        if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$4, y$3)) {
          var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_modGeolocation;
          var x$2$1 = $n(MapInteractionLayers$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_modGeolocation;
          return ((x$5 === null) ? (x$2$1 === null) : $n(x$5).equals__O__Z(x$2$1))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.MapInteractionLayers"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.MapInteractionLayers;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapInteractionLayers", {
  Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(sources, init, map, proxy) {
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_map = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources = sources;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init = init;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_map = map;
  this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_map;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_proxy;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_map;
      var y = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_map;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$5, y)) {
        var x$5$1 = this.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_proxy;
        var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_proxy;
        return ((x$5$1 === null) ? (x$6 === null) : $n(x$5$1).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.MapInteractions$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.MapInteractions$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapInteractions$Props", {
  Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch(input, result) {
  this.Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_input = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_result = null;
  this.Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_input = input;
  this.Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_result = result
}
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_MapSearch() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype.productPrefix__T = (function() {
  return "MapSearch"
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_input;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_result;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch)) {
    var MapSearch$1 = $as_Lreactbuild_analyze_cost_modules_mapview_MapSearch(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_input === $n(MapSearch$1).Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_input)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_result;
      var x$2 = $n(MapSearch$1).Lreactbuild_analyze_cost_modules_mapview_MapSearch__f_result;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_MapSearch(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_MapSearch) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.MapSearch"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapSearch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_MapSearch)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapSearch(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_MapSearch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.MapSearch;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_MapSearch = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_MapSearch: 0
}, false, "reactbuild.analyze.cost.modules.mapview.MapSearch", {
  Lreactbuild_analyze_cost_modules_mapview_MapSearch: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_MapSearch.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_MapSearch;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_Parcel(uniqueId, area, feature) {
  this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId = null;
  this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_area = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_feature = null;
  this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId = uniqueId;
  this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_area = area;
  this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_feature = feature
}
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_Parcel;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_Parcel() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype.productPrefix__T = (function() {
  return "Parcel"
});
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_area;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_feature;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Parcel");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_area;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_feature;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_Parcel)) {
    var Parcel$1 = $as_Lreactbuild_analyze_cost_modules_mapview_Parcel(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_area === $n(Parcel$1).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_area)) {
      if ((this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId === $n(Parcel$1).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId)) {
        var x = this.Lreactbuild_analyze_cost_modules_mapview_Parcel__f_feature;
        var y = $n(Parcel$1).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_feature;
        return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_Parcel(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_Parcel) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.Parcel"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_Parcel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_Parcel)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_Parcel(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_Parcel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.Parcel;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_Parcel = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_Parcel: 0
}, false, "reactbuild.analyze.cost.modules.mapview.Parcel", {
  Lreactbuild_analyze_cost_modules_mapview_Parcel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_Parcel.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_Parcel;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel(sheetNumber, division, parcelNumbers) {
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_sheetNumber = 0;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_division = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_parcelNumbers = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_sheetNumber = sheetNumber;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_division = division;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_parcelNumbers = parcelNumbers
}
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype.productPrefix__T = (function() {
  return "PartialParcel"
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_sheetNumber;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_division;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_parcelNumbers;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("PartialParcel");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_sheetNumber;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_division;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_parcelNumbers;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel)) {
    var PartialParcel$1 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_sheetNumber === $n(PartialParcel$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_sheetNumber)) {
      if ((this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_division === $n(PartialParcel$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_division)) {
        var x = this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_parcelNumbers;
        var x$2 = $n(PartialParcel$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel__f_parcelNumbers;
        return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$PartialParcel"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.ParsedMapQuery$PartialParcel;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel: 0
}, false, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$PartialParcel", {
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$.prototype = new $h_sr_AbstractFunction3();
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$.prototype.toString__T = (function() {
  return "PartialParcel"
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$.prototype.apply__O__O__O__O = (function(v1, v2, v3) {
  var sheetNumber = $uI(v1);
  var division = $as_T(v2);
  var parcelNumbers = $as_sci_Seq(v3);
  return new $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel(sheetNumber, division, parcelNumbers)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$PartialParcel$", {
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$: 1,
  sr_AbstractFunction3: 1,
  O: 1,
  F3: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$;
var $n_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$;
function $m_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$ = new $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PartialParcel$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props(searchOpt, f) {
  this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_searchOpt = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_f = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_searchOpt = searchOpt;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_f = f
}
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_searchOpt;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_searchOpt;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_searchOpt;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_f;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props__f_f;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.SearchBox$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.SearchBox$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props: 0
}, false, "reactbuild.analyze.cost.modules.mapview.SearchBox$Props", {
  Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_SearchBox$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(parsed, f) {
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_parsed = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_f = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_parsed = parsed;
  this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_f = f
}
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_parsed;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_parsed;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_parsed;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_f;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props__f_f;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.SearchResultList$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.SearchResultList$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props: 0
}, false, "reactbuild.analyze.cost.modules.mapview.SearchResultList$Props", {
  Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_SearchResultList$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$.prototype = new $h_sr_AbstractFunction6();
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$.prototype.toString__T = (function() {
  return "TiledWMTSLayer"
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$.prototype.apply$default$5__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$20$2) => (void 0)))
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$.prototype.apply$default$6__F3 = (function() {
  return new $c_sjsr_AnonFunction3(((x$21$2, x$22$2, opts$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer(x$21$2);
    return opts$2
  }))
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$.prototype.apply__O__O__O__O__O__O__O = (function(v1, v2, v3, v4, v5, v6) {
  var category = $as_Lreactbuild_analyze_cost_modules_mapview_MapCategory(v1);
  var title = $as_T(v2);
  var name = $as_T(v3);
  var url = $as_T(v4);
  var f = $as_F1(v5);
  var wmtsOptions = $as_F3(v6);
  return new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer(category, title, name, url, f, wmtsOptions)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.TiledWMTSLayer$", {
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$: 1,
  sr_AbstractFunction6: 1,
  O: 1,
  F6: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$;
var $n_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$;
function $m_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$ = new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$.prototype = new $h_sr_AbstractFunction7();
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$.prototype.toString__T = (function() {
  return "WFSLayer"
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$.prototype.apply$default$6__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$9$2) => {
    var a = [255.0, 255.0, 255.0, 0.0];
    x$9$2.color = a;
    return x$9$2
  }))
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$.prototype.apply$default$7__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$2) => x$2))
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$.prototype.apply__O__O__O__O__O__O__O__O = (function(v1, v2, v3, v4, v5, v6, v7) {
  var category = $as_Lreactbuild_analyze_cost_modules_mapview_MapCategory(v1);
  var url = $as_T(v2);
  var title = $as_T(v3);
  var name = $as_T(v4);
  var stroke = $as_F1(v5);
  var fill = $as_F1(v6);
  var options = $as_F1(v7);
  return new $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer(category, url, title, name, stroke, fill, options)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_WFSLayer$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.WFSLayer$", {
  Lreactbuild_analyze_cost_modules_mapview_WFSLayer$: 1,
  sr_AbstractFunction7: 1,
  O: 1,
  F7: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$;
var $n_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$;
function $m_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$ = new $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_WFSLayer$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database(database, schema) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_database = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_schema = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_database = database;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_schema = schema
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_Database() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype.productPrefix__T = (function() {
  return "Database"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_database;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_schema;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database)) {
    var Database$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_Database(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_database;
    var y = $n(Database$1).Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_database;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_schema;
      var x$2$1 = $n(Database$1).Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_schema;
      if ((x$2 === null)) {
        return (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$2$1)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_Database(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.Database"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_Database(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_Database)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_Database(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_Database(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.Database;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Database = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_Database: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.Database", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_Database: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Database.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Database;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(db, mutations) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_db = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_mutations = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_db = db;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_mutations = mutations
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.withTransaction__Lorg_scalajs_dom_IDBTransactionMode__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mode, f, dispatcher) {
  var $$x2 = $n(dispatcher);
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_db);
  var this$2 = $n(this$1.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_schema);
  var idb = this$1.Lreactbuild_analyze_cost_modules_mapview_interactions_Database__f_database;
  var $$x1 = $m_sjs_js_JSConverters$JSRichIterableOnce$();
  var coll = idb.objectStoreNames;
  var a = $n($$x1).toJSArray$extension__sc_IterableOnce__sjs_js_Array(new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(coll));
  var transaction = idb.transaction(a, mode);
  var map = $as_scm_Map($m_scm_Map$().empty__O());
  var tx = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SchemaBuilder$$anon$15$$anon$16(this$2, map, transaction);
  return $n($$x2).map__O__F1__O($n(f).apply__O__O(tx), new $c_sjsr_AnonFunction1(((r$2) => {
    var this$11 = $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_mutations);
    var callback = new $c_sjsr_AnonFunction0((() => {
      var this$12 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var this$13 = $n(this$12.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$13.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
    }));
    var this$14 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var G = this$14.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    var arg1 = this$11.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$1 = $uI(arg1);
    var arg1$1 = ((1 + x$1) | 0);
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$11.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$16 = $n(this$);
    $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$16);
    return r$2
  })))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.productPrefix__T = (function() {
  return "LocalDatabase"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_db;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_mutations;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase)) {
    var LocalDatabase$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_db;
    var x$2 = $n(LocalDatabase$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_db;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_mutations;
      var x$4 = $n(LocalDatabase$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase__f_mutations;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.LocalDatabase"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.LocalDatabase;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.LocalDatabase", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(parentProps, state) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_parentProps = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_parentProps = parentProps;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state = state
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype.productPrefix__T = (function() {
  return "ChildProps"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_parentProps;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps)) {
    var ChildProps$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_parentProps;
    var x$2 = $n(ChildProps$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_parentProps;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state;
      var x$4 = $n(ChildProps$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__f_state;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$ChildProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$ChildProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$ChildProps", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken(id, position, geolocation, orientation, instant, capture) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_position = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_geolocation = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_orientation = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_instant = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_capture = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id = id;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_position = position;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_geolocation = geolocation;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_orientation = orientation;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_instant = instant;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_capture = capture
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype.productPrefix__T = (function() {
  return "PictureTaken"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_position;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_geolocation;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_orientation;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_instant;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_capture;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken)) {
    var PictureTaken$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id;
    var x$2 = $n(PictureTaken$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_position;
      var x$4 = $n(PictureTaken$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_position;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_geolocation;
        var x$6 = $n(PictureTaken$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_geolocation;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_orientation;
      var x$8 = $n(PictureTaken$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_orientation;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_instant;
        var x$10 = $n(PictureTaken$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_instant;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_capture;
          var y = $n(PictureTaken$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_capture;
          return $m_sr_BoxesRunTime$().equals__O__O__Z(x$11, y)
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PictureTaken"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PictureTaken;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PictureTaken", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(projectOptions, yawOffset, pointSet, pictureTaken, showImage, cameraActive, uploadedImage) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive = false;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions = projectOptions;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset = yawOffset;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet = pointSet;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken = pictureTaken;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage = showImage;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive = cameraActive;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage = uploadedImage
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive === $n(State$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
        var x$4 = $n(State$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      var x$6 = $n(State$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken;
        var x$8 = $n(State$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken;
        var $$x2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
        var x$10 = $n(State$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
          var x$12 = $n(State$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$State", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(documents, uploading) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading = false;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents = documents;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading = uploading
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.ready__Z = (function() {
  if ((!this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading)) {
    var this$1 = $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents);
    return (!this$1.isEmpty__Z())
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading === $n(State$1).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents;
      var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$State", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props(parent, additionalSources, defaultSources) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_additionalSources = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_defaultSources = false;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent = parent;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_additionalSources = additionalSources;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_defaultSources = defaultSources
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.sources__sci_List = (function() {
  if (this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_defaultSources) {
    var rassoc$1 = $n($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature.getSource();
    $n($m_s_package$().s_package$__f_List);
    var array = [$n($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init).getBuildingSource__s_Option(), $n($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init).getParcelSource__s_Option()];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$7 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
    var this$6 = $m_s_$less$colon$less$();
    var toIterableOnce = this$6.s_$less$colon$less$__f_singleton;
    var this$8 = $n($as_sci_List($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$7, toIterableOnce)));
    var sourceBase = new $c_sci_$colon$colon(rassoc$1, this$8)
  } else {
    var sourceBase = $m_s_package$().s_package$__f_Nil
  };
  var this$9 = $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_additionalSources);
  return this$9.appendedAll__sc_IterableOnce__sci_List(sourceBase)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_additionalSources;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_defaultSources;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_additionalSources;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_defaultSources ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_defaultSources === $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_defaultSources)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent;
      var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_parent;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_additionalSources;
        var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props__f_additionalSources;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.WithSnap$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.WithSnap$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.WithSnap$Props", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$Props;
function $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__headingToNorth$lzycompute__D($thiz) {
  if ((!$thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_bitmap$0)) {
    var heading = (3.141592653589793 - $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_yaw);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_headingToNorth = ((180.0 * heading) / 3.141592653589793);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_bitmap$0 = true
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_headingToNorth
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(pitch, roll, yaw, alpha, beta, gamma) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_headingToNorth = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_pitch = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_roll = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_yaw = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_alpha = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_beta = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_gamma = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_bitmap$0 = false;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_pitch = pitch;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_roll = roll;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_yaw = yaw;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_alpha = alpha;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_beta = beta;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_gamma = gamma
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.headingToNorth__D = (function() {
  return ((!this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_bitmap$0) ? $p_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__headingToNorth$lzycompute__D(this) : this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_headingToNorth)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.productPrefix__T = (function() {
  return "DeviceOrientationData"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_pitch;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_roll;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_yaw;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_alpha;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_beta;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_gamma;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DeviceOrientationData");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_pitch;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_roll;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$2 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_yaw;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_alpha;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var dv$4 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_beta;
  var data$5 = $m_sr_Statics$().doubleHash__D__I(dv$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var dv$5 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_gamma;
  var data$6 = $m_sr_Statics$().doubleHash__D__I(dv$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData)) {
    var DeviceOrientationData$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(x$1);
    return (((this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_pitch === $n(DeviceOrientationData$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_pitch) && ((this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_roll === $n(DeviceOrientationData$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_roll) && (this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_yaw === $n(DeviceOrientationData$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_yaw))) && ((this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_alpha === $n(DeviceOrientationData$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_alpha) && ((this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_beta === $n(DeviceOrientationData$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_beta) && (this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_gamma === $n(DeviceOrientationData$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData__f_gamma))))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.DeviceOrientationData"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.takepicture.DeviceOrientationData;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.DeviceOrientationData", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(latitude, longitude, accuracy, altitude, altitudeAccuracy, heading, speed, timestamp) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_latitude = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_longitude = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_accuracy = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitude = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitudeAccuracy = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_heading = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_speed = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_timestamp = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_latitude = latitude;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_longitude = longitude;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_accuracy = accuracy;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitude = altitude;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitudeAccuracy = altitudeAccuracy;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_heading = heading;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_speed = speed;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_timestamp = timestamp
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype.productPrefix__T = (function() {
  return "GeolocationPosition"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype.productArity__I = (function() {
  return 8
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_latitude;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_longitude;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_accuracy;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitude;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitudeAccuracy;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_heading;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_speed;
      break
    }
    case 7: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_timestamp;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("GeolocationPosition");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_latitude;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_longitude;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$2 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_accuracy;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitude;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var dv$4 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitudeAccuracy;
  var data$5 = $m_sr_Statics$().doubleHash__D__I(dv$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var dv$5 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_heading;
  var data$6 = $m_sr_Statics$().doubleHash__D__I(dv$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var dv$6 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_speed;
  var data$7 = $m_sr_Statics$().doubleHash__D__I(dv$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var dv$7 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_timestamp;
  var data$8 = $m_sr_Statics$().doubleHash__D__I(dv$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$9, 8)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition)) {
    var GeolocationPosition$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(x$1);
    return ((((this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_latitude === $n(GeolocationPosition$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_latitude) && (this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_longitude === $n(GeolocationPosition$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_longitude)) && ((this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_accuracy === $n(GeolocationPosition$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_accuracy) && (this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitude === $n(GeolocationPosition$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitude))) && (((this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitudeAccuracy === $n(GeolocationPosition$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_altitudeAccuracy) && (this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_heading === $n(GeolocationPosition$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_heading)) && ((this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_speed === $n(GeolocationPosition$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_speed) && (this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_timestamp === $n(GeolocationPosition$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition__f_timestamp))))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.GeolocationPosition"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.takepicture.GeolocationPosition;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.GeolocationPosition", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result(layer, control, modGeolocation) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_layer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_control = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_modGeolocation = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_layer = layer;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_control = control;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_modGeolocation = modGeolocation
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype.productPrefix__T = (function() {
  return "Result"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_layer;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_control;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_modGeolocation;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result)) {
    var Result$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_layer;
    var y = $n(Result$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_layer;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_control;
      var x$2$1 = $n(Result$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_control;
      if ((x$2 === null)) {
        var $$x1 = (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        var $$x1 = (this$1 === x$2$1)
      };
      if ($$x1) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_modGeolocation;
        var x$4 = $n(Result$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result__f_modGeolocation;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.Geolocation$Result"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.Geolocation$Result;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Geolocation$Result", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Geolocation$Result;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(layer, visible) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_visible = false;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer = layer;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_visible = visible
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_visible;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_visible ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_visible === $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_visible)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer;
      var y = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props__f_layer;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.Layer$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.Layer$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Layer$Props", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layer$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(index) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index__f_index = 0;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index__f_index = index
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype.productPrefix__T = (function() {
  return "Index"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index__f_index : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Index");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index)) {
    var Index$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(x$1);
    return (this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index__f_index === $n(Index$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index__f_index)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.Layers$Index"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.Layers$Index;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Layers$Index", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Layers$Index;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(viewPoint) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint = viewPoint
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props__f_viewPoint;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.View$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.View$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.View$Props", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$.prototype.toString__T = (function() {
  return "MoveFromProps"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$.prototype.apply$default$2__D = (function() {
  return $uD(window.performance.now())
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$.prototype.apply__O__O__O = (function(v1, v2) {
  var viewPoint = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(v1);
  var when = $uD(v2);
  return new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps(viewPoint, when)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewAction$MoveFromProps$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$.prototype.toString__T = (function() {
  return "MoveFromView"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$.prototype.apply$default$2__D = (function() {
  return $uD(window.performance.now())
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$.prototype.apply__O__O__O = (function(v1, v2) {
  var viewPoint = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(v1);
  var when = $uD(v2);
  return new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView(viewPoint, when)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewAction$MoveFromView$", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$;
var $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$;
function $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$ = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(view, updateViewPoint) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_view = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_updateViewPoint = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_view = view;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_updateViewPoint = updateViewPoint
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype.productPrefix__T = (function() {
  return "ViewContext"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_view;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_updateViewPoint;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext)) {
    var ViewContext$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_view;
    var y = $n(ViewContext$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_view;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_updateViewPoint;
      var x$2$1 = $n(ViewContext$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext__f_updateViewPoint;
      if ((x$2 === null)) {
        return (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$2$1)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewContext"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.ViewContext;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewContext", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewContext;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(coords, zoom) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords = coords;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom = zoom
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype.productPrefix__T = (function() {
  return "ViewPoint"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ViewPoint");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint)) {
    var ViewPoint$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom === $n(ViewPoint$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_zoom)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords;
      var y = $n(ViewPoint$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint__f_coords;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewPoint"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.ViewPoint;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewPoint", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(lastAction, sendToProps, sendToView, history, lastActions) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastAction = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToProps = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToView = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_history = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastActions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastAction = lastAction;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToProps = sendToProps;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToView = sendToView;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_history = history;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastActions = lastActions
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype.productPrefix__T = (function() {
  return "ViewState"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastAction;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToProps;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToView;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_history;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastActions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState)) {
    var ViewState$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastAction;
    var x$2 = $n(ViewState$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastAction;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToProps;
      var x$4 = $n(ViewState$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToProps;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToView;
      var x$6 = $n(ViewState$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_sendToView;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_history;
        var x$8 = $n(ViewState$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_history;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          return (this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastActions === $n(ViewState$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState__f_lastActions)
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.ViewState;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewState", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_Planner$Props(proxy) {
  this.Lreactbuild_analyze_cost_modules_planner_Planner$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_Planner$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_Planner$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype = $c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_planner_Planner$Props__f_proxy : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_Planner$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_planner_Planner$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_planner_Planner$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_Planner$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Props$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_planner_Planner$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_Planner$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.Planner$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_Planner$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_Planner$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_Planner$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_Planner$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.Planner$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_Planner$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_Planner$Props: 0
}, false, "reactbuild.analyze.cost.modules.planner.Planner$Props", {
  Lreactbuild_analyze_cost_modules_planner_Planner$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_Planner$Props;
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__duration$lzycompute__Ljava_time_Duration($thiz) {
  if (((((1 & $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0)) {
    var startInclusive = $as_Ljava_time_temporal_Temporal($n($thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period).Lcom_iz2use_common_TypedRange__f_from);
    var endExclusive = $as_Ljava_time_temporal_Temporal($n($thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period).Lcom_iz2use_common_TypedRange__f_until);
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_duration = $m_Ljava_time_Duration$().between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration(startInclusive, endExclusive);
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0 = (((1 | $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_duration
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__durationMs$lzycompute__J($thiz) {
  if (((((2 & $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $n($thiz.duration__Ljava_time_Duration());
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_durationMs = this$1.Ljava_time_Duration__f_seconds;
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0 = (((2 | $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_durationMs
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__timeScale$lzycompute__Lreactbuild_analyze_cost_modules_planner_ChronoScale($thiz) {
  if (((((4 & $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $n($m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$().Lreactbuild_analyze_cost_modules_planner_ChronoScale$__f_list);
    _return: {
      var i = 0;
      var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$1, 0, this$1);
      while (true) {
        var this$4 = $n(these);
        if ((!this$4.isEmpty__Z())) {
          var arg1 = $n(these).head__O();
          var s = $as_Lreactbuild_analyze_cost_modules_planner_ChronoScale(arg1);
          var this$5 = $thiz.durationMs__J();
          var b = $n($n(s).Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_primary).Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_unit;
          var ahi = this$5.RTLong__f_hi;
          var bhi = b.RTLong__f_hi;
          if (((ahi === bhi) ? (((-2147483648) ^ this$5.RTLong__f_lo) <= ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))) {
            var x1 = i;
            break _return
          };
          i = ((1 + i) | 0);
          these = $as_sc_LinearSeq($n(these).tail__O())
        } else {
          break
        }
      };
      var x1 = (-1)
    };
    if ((x1 === (-1))) {
      var $$x1 = $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$()
    } else {
      var this$6 = $n($m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$().Lreactbuild_analyze_cost_modules_planner_ChronoScale$__f_list);
      var $$x1 = $as_Lreactbuild_analyze_cost_modules_planner_ChronoScale($f_sc_LinearSeqOps__apply__I__O(this$6, x1))
    };
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_timeScale = $$x1;
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0 = (((4 | $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_timeScale
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__leftColumn$lzycompute__s_Option($thiz) {
  if (((((8 & $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_leftColumn = ($thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_printMode ? new $c_s_Some(150.0) : (($thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth > 1000.0) ? new $c_s_Some(200.0) : $m_s_None$()));
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0 = (((8 | $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_leftColumn
}
function $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__mapped$lzycompute__Ldiode_data_Pot($thiz) {
  if (((((32 & $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0)) {
    if (($thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth <= 0.0)) {
      var $$x1 = $m_Ldiode_data_Empty$()
    } else {
      var this$5 = $n($thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period);
      var this$1 = $n($thiz.leftColumn__s_Option());
      var toRange = new $c_Lcom_iz2use_common_TypedRange((this$1.isEmpty__Z() ? 0.0 : this$1.get__O()), $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth, $m_s_math_Ordering$DeprecatedDoubleOrdering$());
      var doubleFromT = new $c_sjsr_AnonFunction1(((x$4$2) => {
        var x$4 = $as_Ljava_time_LocalDateTime(x$4$2);
        var this$3 = $n(x$4).toEpochSecond__Ljava_time_ZoneOffset__J($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$3.RTLong__f_lo, this$3.RTLong__f_hi)
      }));
      var doubleToU = new $c_sjsr_AnonFunction1(((x$2) => {
        var x = $uD(x$2);
        return x
      }));
      var numericU = $m_s_math_Numeric$DoubleIsFractional$();
      var $$x1 = new $c_Ldiode_data_Ready(new $c_Lcom_iz2use_common_MappedTypedRange(this$5, toRange, doubleFromT, doubleToU, numericU))
    };
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_mapped = $$x1;
    $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0 = (((32 | $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_mapped
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_Planner$State(period, availableWidth, printMode) {
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_duration = null;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_durationMs = $L0;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_timeScale = null;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_leftColumn = null;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_mapped = null;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period = null;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth = 0.0;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_printMode = false;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0 = 0;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period = period;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth = availableWidth;
  this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_printMode = printMode
}
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_Planner$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_Planner$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype = $c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.duration__Ljava_time_Duration = (function() {
  return (((((1 & this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__duration$lzycompute__Ljava_time_Duration(this) : this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_duration)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.durationMs__J = (function() {
  return (((((2 & this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__durationMs$lzycompute__J(this) : this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_durationMs)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.timeScale__Lreactbuild_analyze_cost_modules_planner_ChronoScale = (function() {
  return (((((4 & this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__timeScale$lzycompute__Lreactbuild_analyze_cost_modules_planner_ChronoScale(this) : this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_timeScale)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.leftColumn__s_Option = (function() {
  return (((((8 & this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__leftColumn$lzycompute__s_Option(this) : this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_leftColumn)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.mapped__Ldiode_data_Pot = (function() {
  return (((((32 & this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lreactbuild_analyze_cost_modules_planner_Planner$State__mapped$lzycompute__Ldiode_data_Pot(this) : this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_mapped)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_printMode;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_printMode ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_Planner$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_planner_Planner$State(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth === $n(State$1).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_availableWidth)) {
      if ((this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_printMode === $n(State$1).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_printMode)) {
        var x = this.Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period;
        var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_planner_Planner$State__f_period;
        return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_planner_Planner$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_Planner$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.Planner$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_Planner$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_Planner$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_Planner$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_Planner$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.Planner$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_Planner$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_Planner$State: 0
}, false, "reactbuild.analyze.cost.modules.planner.Planner$State", {
  Lreactbuild_analyze_cost_modules_planner_Planner$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_Planner$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_Planner$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props(proxy, context, event, modState) {
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_event = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_modState = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_context = context;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_event = event;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_modState = modState
}
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype = $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_context;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_event;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_modState;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_proxy;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_context;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_context;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_event;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_event;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_modState;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props__f_modState;
        if ((x$7 === null)) {
          return (x$8 === null)
        } else {
          var this$1 = $n(x$7);
          return (this$1 === x$8)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props: 0
}, false, "reactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$Props", {
  Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(organization, from, until, title, stage, participant, project) {
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization = organization;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from = from;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until = until;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title = title;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage = stage;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant = participant;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project = project
}
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype = $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_organization;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from;
      var x$4 = $n(State$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_from;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until;
        var x$6 = $n(State$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_until;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title;
      var x$8 = $n(State$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_title;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage;
        var x$10 = $n(State$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_stage;
        var $$x2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$11 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant;
        var x$12 = $n(State$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_participant;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project;
          var x$14 = $n(State$1).Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State__f_project;
          return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State: 0
}, false, "reactbuild.analyze.cost.modules.planner.PlannerAllocatedTimeEditor$State", {
  Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_PlannerAllocatedTimeEditor$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(mapped, period, leftColumn, source, group, renderItem, ordering, textualizable, proxy) {
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_mapped = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_period = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_leftColumn = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_source = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_group = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_renderItem = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_ordering = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_textualizable = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_mapped = mapped;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_period = period;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_leftColumn = leftColumn;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_source = source;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_group = group;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_renderItem = renderItem;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_ordering = ordering;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_textualizable = textualizable;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype = $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype.productArity__I = (function() {
  return 9
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_mapped;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_period;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_leftColumn;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_source;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_group;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_renderItem;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_ordering;
      break
    }
    case 7: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_textualizable;
      break
    }
    case 8: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_proxy;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_mapped;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_mapped;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_period;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_period;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x2 = (this$1 === x$4)
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_leftColumn;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_leftColumn;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_source;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_source;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_group;
          var x$10 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_group;
          var $$x1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_renderItem;
      var x$12 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_renderItem;
      if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
        var x$13 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_ordering;
        var x$14 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_ordering;
        var $$x3 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$15 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_textualizable;
        var x$16 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_textualizable;
        if ((x$15 === null)) {
          var $$x4 = (x$16 === null)
        } else {
          var this$2 = $n(x$15);
          var $$x4 = (this$2 === x$16)
        };
        if ($$x4) {
          var x$17 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_proxy;
          var x$18 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props__f_proxy;
          if (((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))) {
            $n(Props$1);
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.PlannerContent$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.PlannerContent$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props: 0
}, false, "reactbuild.analyze.cost.modules.planner.PlannerContent$Props", {
  Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_PlannerContent$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_PlannerContext(zoomAndTranslate, create, updateEvent) {
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_zoomAndTranslate = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_create = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_updateEvent = null;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_zoomAndTranslate = zoomAndTranslate;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_create = create;
  this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_updateEvent = updateEvent
}
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_PlannerContext;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_PlannerContext() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype = $c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype.productPrefix__T = (function() {
  return "PlannerContext"
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_zoomAndTranslate;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_create;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_updateEvent;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_PlannerContext)) {
    var PlannerContext$1 = $as_Lreactbuild_analyze_cost_modules_planner_PlannerContext(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_zoomAndTranslate;
    var x$2 = $n(PlannerContext$1).Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_zoomAndTranslate;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_create;
      var x$4 = $n(PlannerContext$1).Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_create;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_updateEvent;
        var x$6 = $n(PlannerContext$1).Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_updateEvent;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$2 = $n(x$5);
          return (this$2 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_planner_PlannerContext(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_PlannerContext) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.PlannerContext"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_PlannerContext)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerContext(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_PlannerContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.PlannerContext;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_PlannerContext = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_PlannerContext: 0
}, false, "reactbuild.analyze.cost.modules.planner.PlannerContext", {
  Lreactbuild_analyze_cost_modules_planner_PlannerContext: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_PlannerContext.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_PlannerContext;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_RangeSet(items, range, isRange) {
  this.Lreactbuild_analyze_cost_modules_planner_RangeSet__f_items = null;
  this.Lreactbuild_analyze_cost_modules_planner_RangeSet__f_range = null;
  this.Lreactbuild_analyze_cost_modules_planner_RangeSet__f_items = items;
  this.Lreactbuild_analyze_cost_modules_planner_RangeSet__f_range = range
}
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_RangeSet;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_RangeSet() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype = $c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype.productPrefix__T = (function() {
  return "RangeSet"
});
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_planner_RangeSet__f_items;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_planner_RangeSet__f_range;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_RangeSet)) {
    var RangeSet$1 = $as_Lreactbuild_analyze_cost_modules_planner_RangeSet(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_planner_RangeSet__f_items;
    var x$2 = $n(RangeSet$1).Lreactbuild_analyze_cost_modules_planner_RangeSet__f_items;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_planner_RangeSet__f_range;
      var x$4 = $n(RangeSet$1).Lreactbuild_analyze_cost_modules_planner_RangeSet__f_range;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_planner_RangeSet(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_RangeSet) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.RangeSet"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_RangeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_RangeSet)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_RangeSet(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_RangeSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.RangeSet;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_RangeSet = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_RangeSet: 0
}, false, "reactbuild.analyze.cost.modules.planner.RangeSet", {
  Lreactbuild_analyze_cost_modules_planner_RangeSet: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_RangeSet.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_RangeSet;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props(period, mapped, timeScale, leftColumn) {
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_period = null;
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped = null;
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_timeScale = null;
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_leftColumn = null;
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_period = period;
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped = mapped;
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_timeScale = timeScale;
  this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_leftColumn = leftColumn
}
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype = $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_period;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_timeScale;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_leftColumn;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_period;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_period;
    if ((x === null)) {
      var $$x2 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x2 = (this$1 === x$2)
    };
    if ($$x2) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_mapped;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_timeScale;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_timeScale;
      if ((x$5 === null)) {
        var $$x3 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x3 = (this$2 === x$6)
      };
      if ($$x3) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_leftColumn;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props__f_leftColumn;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.TimeRuler$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.TimeRuler$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props: 0
}, false, "reactbuild.analyze.cost.modules.planner.TimeRuler$Props", {
  Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_TimeRuler$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype = $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State)
});
function $as_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.TimeRuler$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_TimeRuler$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.TimeRuler$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_TimeRuler$State: 0
}, false, "reactbuild.analyze.cost.modules.planner.TimeRuler$State", {
  Lreactbuild_analyze_cost_modules_planner_TimeRuler$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_TimeRuler$State;
function $p_Lreactbuild_analyze_cost_modules_planner_UnitDescription__formatter$lzycompute__Ljava_time_format_DateTimeFormatter($thiz) {
  if ((!$thiz.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_bitmap$0)) {
    var pattern = $thiz.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_format;
    var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    $thiz.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_formatter = $m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__ju_Locale__Ljava_time_format_DateTimeFormatter(pattern, locale);
    $thiz.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_bitmap$0 = true
  };
  $thiz.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_format = null;
  return $thiz.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_formatter
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription(base, factor, format) {
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_formatter = null;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_base = null;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_factor = $L0;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_format = null;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_duration = null;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_unit = $L0;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_next = null;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_startOf = null;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_bitmap$0 = false;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_base = base;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_factor = factor;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_format = format;
  var this$1 = $n(base);
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_duration = this$1.Ljava_time_temporal_ChronoUnit__f_duration;
  var this$2 = $n(this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_duration);
  var this$3 = this$2.Ljava_time_Duration__f_seconds;
  var lo = this$3.RTLong__f_lo;
  var lo$1 = (lo << 2);
  var hi = (((lo >>> 30) | 0) | (this$3.RTLong__f_hi << 2));
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_unit = new $c_RTLong(lo$1, hi);
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_next = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljava_time_LocalDateTime(x$2);
    var x1 = this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_base;
    var x$2$1 = $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit();
    if ((x$2$1 === null)) {
      var $$x1 = (x1 === null)
    } else {
      var this$5 = $n(x$2$1);
      var $$x1 = (this$5 === x1)
    };
    if ($$x1) {
      return $n($n(x).plusYears__J__Ljava_time_LocalDateTime(new $c_RTLong(1, 0))).withDayOfYear__I__Ljava_time_LocalDateTime(1)
    } else {
      var x$4 = $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit();
      if ((x$4 === null)) {
        var $$x2 = (x1 === null)
      } else {
        var this$6 = $n(x$4);
        var $$x2 = (this$6 === x1)
      };
      if ($$x2) {
        return $n($n(x).plusMonths__J__Ljava_time_LocalDateTime(new $c_RTLong(1, 0))).withDayOfMonth__I__Ljava_time_LocalDateTime(1)
      } else {
        var x$6 = $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit();
        if ((x$6 === null)) {
          var $$x3 = (x1 === null)
        } else {
          var this$7 = $n(x$6);
          var $$x3 = (this$7 === x1)
        };
        if ($$x3) {
          var $$x4 = $n(x);
          var this$8 = $n(x);
          var value = ((8 - $n($n(this$8.Ljava_time_LocalDateTime__f_date).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I()) | 0);
          var hi$1 = (value >> 31);
          return $n($$x4).plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(value, hi$1))
        } else {
          var x$8 = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
          if ((x$8 === null)) {
            var $$x5 = (x1 === null)
          } else {
            var this$10 = $n(x$8);
            var $$x5 = (this$10 === x1)
          };
          if ($$x5) {
            return $n($n(x).plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(1, 0))).truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit())
          } else {
            var x$10 = $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit();
            if ((x$10 === null)) {
              var $$x6 = (x1 === null)
            } else {
              var this$11 = $n(x$10);
              var $$x6 = (this$11 === x1)
            };
            if ($$x6) {
              var this$12 = $n(x);
              return $n($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$12, this$12.Ljava_time_LocalDateTime__f_date, new $c_RTLong(1, 0), $L0, $L0, $L0, 1)).truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit())
            } else {
              var this$13 = $n(x);
              var amount = this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_duration;
              return $as_Ljava_time_LocalDateTime($n(amount).addTo__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this$13))
            }
          }
        }
      }
    }
  }));
  var this$14 = this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_unit;
  var ahi = this$14.RTLong__f_hi;
  this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_startOf = (((ahi === 0) ? (((-2147483648) ^ this$14.RTLong__f_lo) > (-2147397248)) : (ahi > 0)) ? new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljava_time_LocalDateTime(x$3$2);
    var dayBase = $n(x$3).truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit());
    var x1$1 = this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_base;
    var x$2$2 = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
    if ((x$2$2 === null)) {
      var $$x7 = (x1$1 === null)
    } else {
      var this$15 = $n(x$2$2);
      var $$x7 = (this$15 === x1$1)
    };
    if ($$x7) {
      return dayBase
    } else {
      var x$4$1 = $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit();
      if ((x$4$1 === null)) {
        var $$x8 = (x1$1 === null)
      } else {
        var this$16 = $n(x$4$1);
        var $$x8 = (this$16 === x1$1)
      };
      if ($$x8) {
        var $$x9 = $n(dayBase);
        var this$17 = $n(dayBase);
        var value$1 = (((-1) + $n($n(this$17.Ljava_time_LocalDateTime__f_date).getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I()) | 0);
        var hi$2 = (value$1 >> 31);
        return $n($$x9).minusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(value$1, hi$2))
      } else {
        var x$6$1 = $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit();
        if ((x$6$1 === null)) {
          var $$x10 = (x1$1 === null)
        } else {
          var this$19 = $n(x$6$1);
          var $$x10 = (this$19 === x1$1)
        };
        if ($$x10) {
          var $$x11 = $n(dayBase);
          var this$20 = $n(dayBase);
          var this$21 = $n(this$20.Ljava_time_LocalDateTime__f_date);
          var value$2 = (((-1) + $p_Ljava_time_LocalDate__day__S(this$21)) | 0);
          var hi$3 = (value$2 >> 31);
          return $n($$x11).minusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(value$2, hi$3))
        } else {
          var x$8$1 = $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit();
          if ((x$8$1 === null)) {
            var $$x12 = (x1$1 === null)
          } else {
            var this$23 = $n(x$8$1);
            var $$x12 = (this$23 === x1$1)
          };
          if ($$x12) {
            var $$x13 = $n(dayBase);
            var this$24 = $n(dayBase);
            var value$3 = (((-1) + $n(this$24.Ljava_time_LocalDateTime__f_date).getDayOfYear__I()) | 0);
            var hi$4 = (value$3 >> 31);
            return $n($$x13).minusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(value$3, hi$4))
          } else {
            throw new $c_s_MatchError(x1$1)
          }
        }
      }
    }
  })) : new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljava_time_LocalDateTime(x$1$2);
    return $n(x$1).truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_base)
  })))
}
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_UnitDescription() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype = $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.formatter__Ljava_time_format_DateTimeFormatter = (function() {
  return ((!this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_bitmap$0) ? $p_Lreactbuild_analyze_cost_modules_planner_UnitDescription__formatter$lzycompute__Ljava_time_format_DateTimeFormatter(this) : this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_formatter)
});
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.productPrefix__T = (function() {
  return "UnitDescription"
});
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_base;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_factor;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("UnitDescription");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_base;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t = this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_factor;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$2 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription)) {
    var UnitDescription$1 = $as_Lreactbuild_analyze_cost_modules_planner_UnitDescription(x$1);
    var this$1 = this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_factor;
    var b = $n(UnitDescription$1).Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_factor;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_base;
      var x$2 = $n(UnitDescription$1).Lreactbuild_analyze_cost_modules_planner_UnitDescription__f_base;
      if ((x === null)) {
        return (x$2 === null)
      } else {
        var this$2 = $n(x);
        return (this$2 === x$2)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_planner_UnitDescription(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.UnitDescription"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_UnitDescription(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_UnitDescription)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_UnitDescription(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_UnitDescription(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.UnitDescription;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_UnitDescription = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_UnitDescription: 0
}, false, "reactbuild.analyze.cost.modules.planner.UnitDescription", {
  Lreactbuild_analyze_cost_modules_planner_UnitDescription: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_UnitDescription.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_UnitDescription;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props(projects, resourceUsage, showDetails, pageProps) {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_projects = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_resourceUsage = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_showDetails = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_projects = projects;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_resourceUsage = resourceUsage;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_showDetails = showDetails;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_pageProps = pageProps
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_projects;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_resourceUsage;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_showDetails;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_pageProps;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_projects;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_projects;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_resourceUsage;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_resourceUsage;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_showDetails;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_showDetails;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_pageProps;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props__f_pageProps;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.CompareProjectTable$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.CompareProjectTable$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjectTable$Props", {
  Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State)
});
function $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.CompareProjectTable$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.CompareProjectTable$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjectTable$State", {
  Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTable$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props(projects, pageProps) {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_projects = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_projects = projects;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_pageProps = pageProps
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_projects;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_pageProps;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_projects;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_projects;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_pageProps;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props__f_pageProps;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.CompareProjectTableHeader$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.CompareProjectTableHeader$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjectTableHeader$Props", {
  Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjectTableHeader$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props(projects, pageProps) {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_projects = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_projects = projects;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_pageProps = pageProps
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_projects;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_pageProps;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_projects;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_projects;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_pageProps;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_CompareProjects$Props__f_pageProps;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.CompareProjects$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_CompareProjects$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.CompareProjects$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjects$Props: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjects$Props", {
  Lreactbuild_analyze_cost_modules_project_CompareProjects$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjects$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State(invoiceDetails) {
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$State__f_invoiceDetails = null;
  this.Lreactbuild_analyze_cost_modules_project_CompareProjects$State__f_invoiceDetails = invoiceDetails
}
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_CompareProjects$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype = $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype;
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_CompareProjects$State__f_invoiceDetails : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_project_CompareProjects$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_CompareProjects$State__f_invoiceDetails;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_project_CompareProjects$State__f_invoiceDetails;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_CompareProjects$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.CompareProjects$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjects$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_CompareProjects$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjects$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_CompareProjects$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.CompareProjects$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_CompareProjects$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_CompareProjects$State: 0
}, false, "reactbuild.analyze.cost.modules.project.CompareProjects$State", {
  Lreactbuild_analyze_cost_modules_project_CompareProjects$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_CompareProjects$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_CompareProjects$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props(projects, resourceUsage, showDetails, pageProps) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_projects = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_resourceUsage = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_showDetails = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_projects = projects;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_resourceUsage = resourceUsage;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_showDetails = showDetails;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_pageProps = pageProps
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_projects;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_resourceUsage;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_showDetails;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_pageProps;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_projects;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_projects;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_resourceUsage;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_resourceUsage;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_showDetails;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_showDetails;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_pageProps;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props__f_pageProps;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$Props", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State(groupByBuildingStage, hideDetails) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_groupByBuildingStage = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_groupByBuildingStage = groupByBuildingStage;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails = hideDetails
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_groupByBuildingStage;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_groupByBuildingStage;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_groupByBuildingStage;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails;
      var x$4 = $n(State$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State__f_hideDetails;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsBuildingStageGroups$State", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsBuildingStageGroups$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props(projects, resourceUsage, showDetails, pageProps) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_projects = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_resourceUsage = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_showDetails = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_projects = projects;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_resourceUsage = resourceUsage;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_showDetails = showDetails;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_pageProps = pageProps
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_projects;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_resourceUsage;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_showDetails;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_pageProps;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_projects;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_projects;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_resourceUsage;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_resourceUsage;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_showDetails;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_showDetails;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_pageProps;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props__f_pageProps;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$Props", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State(groupByRefOrDesc) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State__f_groupByRefOrDesc = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State__f_groupByRefOrDesc = groupByRefOrDesc
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State__f_groupByRefOrDesc : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State__f_groupByRefOrDesc;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State__f_groupByRefOrDesc;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsGroup$State", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsGroup$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props(label, projects, resourceUsage, showDetails, pageProps) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_label = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_projects = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_resourceUsage = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_showDetails = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_pageProps = null;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_label = label;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_projects = projects;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_resourceUsage = resourceUsage;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_showDetails = showDetails;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_pageProps = pageProps
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_label;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_projects;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_resourceUsage;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_showDetails;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_pageProps;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_label === $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_label)) {
      var x = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_projects;
      var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_projects;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_resourceUsage;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_resourceUsage;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_showDetails;
        var x$6 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_showDetails;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var x$7 = this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_pageProps;
          var x$8 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props__f_pageProps;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$Props", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State(showDetails) {
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__f_showDetails = false;
  this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__f_showDetails = showDetails
}
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype = $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__f_showDetails : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__f_showDetails ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State(x$1);
    return (this.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__f_showDetails === $n(State$1).Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State__f_showDetails)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State: 0
}, false, "reactbuild.analyze.cost.modules.project.ComputeCompareProjectsProductLine$State", {
  Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ComputeCompareProjectsProductLine$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(index, context) {
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_index = 0;
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_index = index;
  this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context = context
}
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype = $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_index;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_index === $n(Props$1).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_index)) {
      var x = this.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context;
      var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props__f_context;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.InsertionPoint$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.InsertionPoint$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props: 0
}, false, "reactbuild.analyze.cost.modules.project.InsertionPoint$Props", {
  Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_InsertionPoint$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props(image, context) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_image = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_context = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_image = image;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_context = context;
  $n($as_s_Option($n($n(context).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragSource).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).contains__O__Z(image)
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_image;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_image;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_image;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_context;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ProjectImage$Props__f_context;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectImage$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectImage$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectImage$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectImage$Props: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectImage$Props", {
  Lreactbuild_analyze_cost_modules_project_ProjectImage$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectImage$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext(dragSource, dragTarget, indexOf, update, resetDrag) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragSource = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragTarget = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_indexOf = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_update = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_resetDrag = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragSource = dragSource;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragTarget = dragTarget;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_indexOf = indexOf;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_update = update;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_resetDrag = resetDrag
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectImageContext() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype.productPrefix__T = (function() {
  return "ProjectImageContext"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragSource;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragTarget;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_indexOf;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_update;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_resetDrag;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext)) {
    var ProjectImageContext$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageContext(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragSource;
    var x$2 = $n(ProjectImageContext$1).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragSource;
    if ((x === null)) {
      var $$x2 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x2 = (this$1 === x$2)
    };
    if ($$x2) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragTarget;
      var x$4 = $n(ProjectImageContext$1).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_dragTarget;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x1 = (this$2 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_indexOf;
      var x$6 = $n(ProjectImageContext$1).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_indexOf;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_update;
        var x$8 = $n(ProjectImageContext$1).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_update;
        if ((x$7 === null)) {
          var $$x3 = (x$8 === null)
        } else {
          var this$3 = $n(x$7);
          var $$x3 = (this$3 === x$8)
        };
        if ($$x3) {
          var x$9 = this.Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_resetDrag;
          var x$10 = $n(ProjectImageContext$1).Lreactbuild_analyze_cost_modules_project_ProjectImageContext__f_resetDrag;
          if ((x$9 === null)) {
            return (x$10 === null)
          } else {
            var this$4 = $n(x$9);
            return (this$4 === x$10)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectImageContext(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectImageContext"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectImageContext)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageContext(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectImageContext;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectImageContext = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectImageContext: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectImageContext", {
  Lreactbuild_analyze_cost_modules_project_ProjectImageContext: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageContext.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectImageContext;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(images) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__f_images = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__f_images = images
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__f_images : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__f_images;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props__f_images;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectImageList$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectImageList$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectImageList$Props", {
  Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectImageList$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(dragSource, dragTarget) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragSource = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragTarget = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragSource = dragSource;
  this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragTarget = dragTarget
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragSource;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragTarget;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragSource;
    var x$2 = $n(State$1).Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragSource;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragTarget;
      var x$4 = $n(State$1).Lreactbuild_analyze_cost_modules_project_ProjectImageList$State__f_dragTarget;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectImageList$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectImageList$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectImageList$State;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectImageList$State: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectImageList$State", {
  Lreactbuild_analyze_cost_modules_project_ProjectImageList$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectImageList$State;
function $is_Lreactbuild_analyze_cost_modules_project_ProjectView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView)))
}
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView(obj) {
  return (($is_Lreactbuild_analyze_cost_modules_project_ProjectView(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$.prototype.toString__T = (function() {
  return "Project3DDrawingOverview"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$.prototype.apply__O__O = (function(v1) {
  var active = $as_s_Option(v1);
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview(active)
});
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$Project3DDrawingOverview$", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$;
var $n_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$;
function $m_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$ = new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$.prototype.toString__T = (function() {
  return "ProjectDrawingPreview"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$.prototype.apply__O__O = (function(v1) {
  var active = $as_s_Option(v1);
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview(active)
});
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectDrawingPreview$", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$;
var $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$;
function $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$ = new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$.prototype.toString__T = (function() {
  return "ProjectProcedures"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$.prototype.apply__O__O = (function(v1) {
  var active = $as_s_Option(v1);
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures(active)
});
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectProcedures$", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$;
var $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$;
function $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$ = new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$.prototype.toString__T = (function() {
  return "ProjectSummary"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$.prototype.apply__O__O = (function(v1) {
  var active = $as_s_Option(v1);
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary(active)
});
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectSummary$", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$;
var $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$;
function $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$ = new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$.prototype.toString__T = (function() {
  return "ProjectSupply"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$.prototype.apply__O__O = (function(v1) {
  var active = $as_s_Option(v1);
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply(active)
});
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectSupply$", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$;
var $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$;
function $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$ = new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$.prototype.toString__T = (function() {
  return "ProjectTaskList"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$.prototype.apply__O__O = (function(v1) {
  var active = $as_s_Option(v1);
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList(active)
});
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectTaskList$", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$;
var $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$;
function $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$ = new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$.prototype.toString__T = (function() {
  return "ProjectViewDetails"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$.prototype.apply__O__O = (function(v1) {
  var active = $as_s_Option(v1);
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails(active)
});
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectViewDetails$", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$;
var $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$;
function $m_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$)) {
    $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$ = new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$()
  };
  return $n_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AjaxClient$() {
  this.Lreactbuild_analyze_cost_services_AjaxClient$__f_strip = null;
  $n_Lreactbuild_analyze_cost_services_AjaxClient$ = this;
  var $$x6 = $m_s_package$().s_package$__f_Seq;
  var $$x5 = $m_s_package$().s_package$__f_Seq;
  var array = ["reactbuild", "analyze", "cost", "integrations"];
  var $$x4 = $as_sci_Seq($n($$x5).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  var $$x3 = $m_s_package$().s_package$__f_Seq;
  var array$1 = ["reactbuild"];
  var $$x2 = $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array$2 = ["ServiceIntegration", "Api"];
  var array$3 = [$$x4, $$x2, $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)))];
  this.Lreactbuild_analyze_cost_services_AjaxClient$__f_strip = $as_sci_Seq($n($$x6).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)))
}
$c_Lreactbuild_analyze_cost_services_AjaxClient$.prototype = new $h_Lreactbuild_common_services_AjaxClient();
$c_Lreactbuild_analyze_cost_services_AjaxClient$.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AjaxClient$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AjaxClient$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AjaxClient$.prototype = $c_Lreactbuild_analyze_cost_services_AjaxClient$.prototype;
var $d_Lreactbuild_analyze_cost_services_AjaxClient$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AjaxClient$: 0
}, false, "reactbuild.analyze.cost.services.AjaxClient$", {
  Lreactbuild_analyze_cost_services_AjaxClient$: 1,
  Lreactbuild_common_services_AjaxClient: 1,
  O: 1,
  Lautowire_Client: 1,
  Lautowire_Serializers: 1
});
$c_Lreactbuild_analyze_cost_services_AjaxClient$.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AjaxClient$;
var $n_Lreactbuild_analyze_cost_services_AjaxClient$;
function $m_Lreactbuild_analyze_cost_services_AjaxClient$() {
  if ((!$n_Lreactbuild_analyze_cost_services_AjaxClient$)) {
    $n_Lreactbuild_analyze_cost_services_AjaxClient$ = new $c_Lreactbuild_analyze_cost_services_AjaxClient$()
  };
  return $n_Lreactbuild_analyze_cost_services_AjaxClient$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_Model(logged, activeOrganization, commonData, period, library, serverConnection, serverConnectionState, permissionRequested) {
  this.Lreactbuild_analyze_cost_services_Model__f_logged = null;
  this.Lreactbuild_analyze_cost_services_Model__f_activeOrganization = null;
  this.Lreactbuild_analyze_cost_services_Model__f_commonData = null;
  this.Lreactbuild_analyze_cost_services_Model__f_period = null;
  this.Lreactbuild_analyze_cost_services_Model__f_library = null;
  this.Lreactbuild_analyze_cost_services_Model__f_serverConnection = null;
  this.Lreactbuild_analyze_cost_services_Model__f_serverConnectionState = null;
  this.Lreactbuild_analyze_cost_services_Model__f_permissionRequested = null;
  this.Lreactbuild_analyze_cost_services_Model__f_logged = logged;
  this.Lreactbuild_analyze_cost_services_Model__f_activeOrganization = activeOrganization;
  this.Lreactbuild_analyze_cost_services_Model__f_commonData = commonData;
  this.Lreactbuild_analyze_cost_services_Model__f_period = period;
  this.Lreactbuild_analyze_cost_services_Model__f_library = library;
  this.Lreactbuild_analyze_cost_services_Model__f_serverConnection = serverConnection;
  this.Lreactbuild_analyze_cost_services_Model__f_serverConnectionState = serverConnectionState;
  this.Lreactbuild_analyze_cost_services_Model__f_permissionRequested = permissionRequested
}
$c_Lreactbuild_analyze_cost_services_Model.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_services_Model.prototype.constructor = $c_Lreactbuild_analyze_cost_services_Model;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_Model() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_Model.prototype = $c_Lreactbuild_analyze_cost_services_Model.prototype;
$c_Lreactbuild_analyze_cost_services_Model.prototype.productPrefix__T = (function() {
  return "Model"
});
$c_Lreactbuild_analyze_cost_services_Model.prototype.productArity__I = (function() {
  return 8
});
$c_Lreactbuild_analyze_cost_services_Model.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_services_Model__f_logged;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_services_Model__f_activeOrganization;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_services_Model__f_commonData;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_services_Model__f_period;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_services_Model__f_library;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_services_Model__f_serverConnection;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_services_Model__f_serverConnectionState;
      break
    }
    case 7: {
      return this.Lreactbuild_analyze_cost_services_Model__f_permissionRequested;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_services_Model.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_services_Model.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_services_Model.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_services_Model.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_services_Model)) {
    var Model$1 = $as_Lreactbuild_analyze_cost_services_Model(x$1);
    var x = this.Lreactbuild_analyze_cost_services_Model__f_logged;
    var x$2 = $n(Model$1).Lreactbuild_analyze_cost_services_Model__f_logged;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_services_Model__f_activeOrganization;
      var x$4 = $n(Model$1).Lreactbuild_analyze_cost_services_Model__f_activeOrganization;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_analyze_cost_services_Model__f_commonData;
      var x$6 = $n(Model$1).Lreactbuild_analyze_cost_services_Model__f_commonData;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_services_Model__f_period;
        var x$8 = $n(Model$1).Lreactbuild_analyze_cost_services_Model__f_period;
        var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lreactbuild_analyze_cost_services_Model__f_library;
      var x$10 = $n(Model$1).Lreactbuild_analyze_cost_services_Model__f_library;
      if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
        var x$11 = this.Lreactbuild_analyze_cost_services_Model__f_serverConnection;
        var x$12 = $n(Model$1).Lreactbuild_analyze_cost_services_Model__f_serverConnection;
        var $$x3 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$13 = this.Lreactbuild_analyze_cost_services_Model__f_serverConnectionState;
        var x$14 = $n(Model$1).Lreactbuild_analyze_cost_services_Model__f_serverConnectionState;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          var x$15 = this.Lreactbuild_analyze_cost_services_Model__f_permissionRequested;
          var x$16 = $n(Model$1).Lreactbuild_analyze_cost_services_Model__f_permissionRequested;
          if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
            $n(Model$1);
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_services_Model(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_services_Model) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.services.Model"))
}
function $isArrayOf_Lreactbuild_analyze_cost_services_Model(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_services_Model)))
}
function $asArrayOf_Lreactbuild_analyze_cost_services_Model(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_services_Model(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.services.Model;", depth))
}
var $d_Lreactbuild_analyze_cost_services_Model = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_Model: 0
}, false, "reactbuild.analyze.cost.services.Model", {
  Lreactbuild_analyze_cost_services_Model: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_services_Model.prototype.$classData = $d_Lreactbuild_analyze_cost_services_Model;
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_PermissionRequested(notRequested) {
  this.Lreactbuild_analyze_cost_services_PermissionRequested__f_reactbuild$analyze$cost$services$PermissionRequested$$notRequested = null;
  this.Lreactbuild_analyze_cost_services_PermissionRequested__f_reactbuild$analyze$cost$services$PermissionRequested$$notRequested = notRequested
}
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype.constructor = $c_Lreactbuild_analyze_cost_services_PermissionRequested;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_PermissionRequested() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_PermissionRequested.prototype = $c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype;
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype.productPrefix__T = (function() {
  return "PermissionRequested"
});
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_services_PermissionRequested__f_reactbuild$analyze$cost$services$PermissionRequested$$notRequested : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_services_PermissionRequested)) {
    var PermissionRequested$1 = $as_Lreactbuild_analyze_cost_services_PermissionRequested(x$1);
    var x = this.Lreactbuild_analyze_cost_services_PermissionRequested__f_reactbuild$analyze$cost$services$PermissionRequested$$notRequested;
    var x$2 = $n(PermissionRequested$1).Lreactbuild_analyze_cost_services_PermissionRequested__f_reactbuild$analyze$cost$services$PermissionRequested$$notRequested;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_services_PermissionRequested(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_services_PermissionRequested) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.services.PermissionRequested"))
}
function $isArrayOf_Lreactbuild_analyze_cost_services_PermissionRequested(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_services_PermissionRequested)))
}
function $asArrayOf_Lreactbuild_analyze_cost_services_PermissionRequested(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_services_PermissionRequested(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.services.PermissionRequested;", depth))
}
var $d_Lreactbuild_analyze_cost_services_PermissionRequested = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_PermissionRequested: 0
}, false, "reactbuild.analyze.cost.services.PermissionRequested", {
  Lreactbuild_analyze_cost_services_PermissionRequested: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_services_PermissionRequested.prototype.$classData = $d_Lreactbuild_analyze_cost_services_PermissionRequested;
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_RootModel(model) {
  this.Lreactbuild_analyze_cost_services_RootModel__f_model = null;
  this.Lreactbuild_analyze_cost_services_RootModel__f_model = model
}
$c_Lreactbuild_analyze_cost_services_RootModel.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_services_RootModel.prototype.constructor = $c_Lreactbuild_analyze_cost_services_RootModel;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_RootModel() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_RootModel.prototype = $c_Lreactbuild_analyze_cost_services_RootModel.prototype;
$c_Lreactbuild_analyze_cost_services_RootModel.prototype.productPrefix__T = (function() {
  return "RootModel"
});
$c_Lreactbuild_analyze_cost_services_RootModel.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_services_RootModel.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_services_RootModel__f_model : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_services_RootModel.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_services_RootModel.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_services_RootModel.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_services_RootModel.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_services_RootModel)) {
    var RootModel$1 = $as_Lreactbuild_analyze_cost_services_RootModel(x$1);
    var x = this.Lreactbuild_analyze_cost_services_RootModel__f_model;
    var x$2 = $n(RootModel$1).Lreactbuild_analyze_cost_services_RootModel__f_model;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(RootModel$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_services_RootModel(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_services_RootModel) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.services.RootModel"))
}
function $isArrayOf_Lreactbuild_analyze_cost_services_RootModel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_services_RootModel)))
}
function $asArrayOf_Lreactbuild_analyze_cost_services_RootModel(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_services_RootModel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.services.RootModel;", depth))
}
var $d_Lreactbuild_analyze_cost_services_RootModel = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_RootModel: 0
}, false, "reactbuild.analyze.cost.services.RootModel", {
  Lreactbuild_analyze_cost_services_RootModel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_services_RootModel.prototype.$classData = $d_Lreactbuild_analyze_cost_services_RootModel;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend.prototype = new $h_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend();
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend.prototype = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend.prototype;
var $d_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_GraphOverTime$Backend: 0
}, false, "reactbuild.analyze.cost.ui.GraphOverTime$Backend", {
  Lreactbuild_analyze_cost_ui_GraphOverTime$Backend: 1,
  Lreactbuild_analyze_cost_ui_GraphOverTime$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_GraphOverTime$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps(width, height, rangeDate, values, getDate, getNumeric, wrapPoint, numericU) {
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_width = 0;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height = 0;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_rangeDate = null;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_values = null;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getDate = null;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getNumeric = null;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_wrapPoint = null;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_numericU = null;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_width = width;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height = height;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_rangeDate = rangeDate;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_values = values;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getDate = getDate;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getNumeric = getNumeric;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_wrapPoint = wrapPoint;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_numericU = numericU
}
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.deriveState__Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState = (function() {
  var usableHeight = (((-15) + this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height) | 0);
  var y0 = (usableHeight + 2.5);
  var x1 = (((-2) + this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_width) | 0);
  var this$2 = $n($n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_values).toSeq__sci_Seq());
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_Ljava_time_LocalDate($n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getDate).apply__O__O(x$1$2))).toEpochDay__J()));
  var ord = $m_s_math_Ordering$Long$();
  var sortedValues = $as_sci_Seq($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$2, f, ord));
  var valuesU = $as_sci_Seq($n(sortedValues).map__F1__O(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getNumeric));
  var rc8 = false;
  var x3 = null;
  var this$3 = $n($n(valuesU).toList__sci_List());
  var x1$2 = $as_sci_List($f_sc_SeqOps__distinct__O(this$3));
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (x1$2 === null) : $n(x).equals__O__Z(x1$2))) {
    return new $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState(new $c_s_util_Left("Aucune valeur \u00e0 afficher"))
  };
  if ((x1$2 instanceof $c_sci_$colon$colon)) {
    rc8 = true;
    x3 = $as_sci_$colon$colon(x1$2);
    var p4 = $n(x3).sci_$colon$colon__f_next;
    var x$3 = $m_s_package$().s_package$__f_Nil;
    if (((x$3 === null) ? (p4 === null) : $n(x$3).equals__O__Z(p4))) {
      return new $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState(new $c_s_util_Left("Une seule valeur \u00e0 afficher"))
    }
  };
  if (rc8) {
    var minU = $n(valuesU).min__s_math_Ordering__O(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_numericU);
    var maxU = $n(valuesU).max__s_math_Ordering__O(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_numericU);
    $n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_numericU).minus__O__O__O(maxU, minU);
    var this$10 = $n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_rangeDate);
    var toRange = new $c_Lcom_iz2use_common_TypedRange(50, x1, $m_s_math_Ordering$Int$());
    var doubleFromT = new $c_sjsr_AnonFunction1(((x$2$2$2) => {
      var x$2$2 = $as_Ljava_time_LocalDate(x$2$2$2);
      var this$4 = $n(x$2$2).toEpochDay__J();
      return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$4.RTLong__f_lo, this$4.RTLong__f_hi)
    }));
    var doubleToU = new $c_sjsr_AnonFunction1(((x$3$2$2) => {
      var x$3$2 = $uD(x$3$2$2);
      var this$9 = $m_RTLong$();
      var value = $uD(Math.round(x$3$2));
      var lo = this$9.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
      return lo
    }));
    var numericU = $m_s_math_Numeric$IntIsIntegral$();
    var mapDate = new $c_Lcom_iz2use_common_MappedTypedRange(this$10, toRange, doubleFromT, doubleToU, numericU);
    var this$16 = new $c_Lcom_iz2use_common_TypedRange(minU, maxU, this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_numericU);
    var toRange$1 = new $c_Lcom_iz2use_common_TypedRange(y0, 2.5, $m_s_math_Ordering$DeprecatedDoubleOrdering$());
    var doubleFromT$1 = new $c_sjsr_AnonFunction1(((x$4$2$2) => $n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_numericU).toDouble__O__D(x$4$2$2)));
    var doubleToU$1 = new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $uD(x$5$2);
      var this$15 = $m_RTLong$();
      var value$1 = $uD(Math.round(x$5));
      var lo$1 = this$15.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
      return lo$1
    }));
    var numericU$1 = $m_s_math_Numeric$DoubleIsFractional$();
    var mapT = new $c_Lcom_iz2use_common_MappedTypedRange(this$16, toRange$1, doubleFromT$1, doubleToU$1, numericU$1);
    $as_sci_Seq($n(sortedValues).map__F1__O(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getDate));
    var valuesWithPosition = $as_sci_Seq($n($as_sc_IterableOps($n(sortedValues).zip__sc_IterableOnce__O(valuesU))).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var v = $n(x0$1)._1__O();
        var date = $as_Ljava_time_LocalDate($n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getDate).apply__O__O(v));
        var t = $n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getNumeric).apply__O__O(v);
        var y = new $c_T2$mcID$sp($uI(mapDate.apply__O__O(date)), $uD(mapT.apply__O__O(t)));
        return $ct_T2__O__O__(new $c_T2(), v, y)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    }))));
    var this$131 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$22 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
    var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x33 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$22.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#bbb");
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$25 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
    var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x32 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$25.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$32 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
    var $$x31 = $m_s_package$().s_package$__f_Seq;
    var array = [y0, 2.5];
    var this$31 = $n($as_sc_IterableOnceOps($n($n($$x31).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))).map__F1__O(new $c_sjsr_AnonFunction1(((y$2) => {
      var y$1 = $uD(y$2);
      return ((((("M 50," + y$1) + " L ") + x1) + ",") + y$1)
    })))));
    var a = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$31, "", " ", "");
    var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array$1 = [$$x33, $$x32, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$32.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a)];
    var $$x30 = $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x29 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$39 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
    var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x28 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$39.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 48);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$42 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y");
    var t$5 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
    var $$x27 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$5, this$42.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 12.0);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$45 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
    var t$6 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x26 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$6, this$45.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "end");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$1 = $dp_toString__T($n(maxU));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$2 = [$$x28, $$x27, $$x26, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
    var $$x25 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$54 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
    var t$7 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x23 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$7, this$54.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 48);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$57 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y");
    var a$1 = (y0 + 0.5);
    var t$8 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
    var $$x22 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$8, this$57.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$60 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
    var t$9 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x21 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$9, this$60.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "end");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$2 = $dp_toString__T($n(minU));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$3 = [$$x23, $$x22, $$x21, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
    var $$x20 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var $$x19 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$69 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
    var t$10 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x18 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$10, this$69.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 50);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$72 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y");
    var a$2 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height;
    var t$11 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$11, this$72.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$3 = $n($as_Ljava_time_LocalDate($n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_rangeDate).Lcom_iz2use_common_TypedRange__f_from)).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$4 = [$$x18, $$x17, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
    var $$x16 = $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var $$x15 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$81 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
    var t$12 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x14 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$12, this$81.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, x1);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$84 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y");
    var a$3 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height;
    var t$13 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$13, this$84.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$3);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$87 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
    var t$14 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x12 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$14, this$87.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "end");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$4 = $n($as_Ljava_time_LocalDate($n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_rangeDate).Lcom_iz2use_common_TypedRange__f_until)).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$5 = [$$x14, $$x13, $$x12, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
    var $$x11 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
    var $$x10 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$96 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
    var t$15 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$15, this$96.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#06f");
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$99 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fillOpacity");
    var t$16 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$16, this$99.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 0);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$102 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "strokeWidth");
    var t$17 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$17, this$102.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "2");
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$106 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
    var this$105 = $n($as_sc_IterableOnceOps($n(valuesWithPosition).map__F1__O(new $c_sjsr_AnonFunction1(((x0$2$2) => {
      var x0$2 = $as_T2(x0$2$2);
      if ((x0$2 !== null)) {
        var p3 = $as_T2($n(x0$2)._2__O());
        if ((p3 !== null)) {
          var x$1 = $n(p3)._1$mcI$sp__I();
          var y$3 = $n(p3)._2$mcD$sp__D();
          return ((x$1 + ",") + y$3)
        }
      };
      throw new $c_s_MatchError(x0$2)
    })))));
    var a$4 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$105, "M", "L", "");
    var t$18 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array$6 = [$$x9, $$x8, $$x7, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$18, this$106.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$4)];
    var $$x6 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
    var this$127 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$126 = $n($as_sci_Seq($n(valuesWithPosition).map__F1__O(new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_T2(x0$3$2);
      if ((x0$3 !== null)) {
        var v$5 = $n(x0$3)._1__O();
        var p2 = $as_T2($n(x0$3)._2__O());
        if ((p2 !== null)) {
          var x$2 = $n(p2)._1$mcI$sp__I();
          var y$4 = $n(p2)._2$mcD$sp__D();
          var $$x5 = $as_F1($n(this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_wrapPoint).apply__O__O(v$5));
          var $$x4 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$113 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "cx");
          var t$19 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
          var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$19, this$113.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, x$2);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$116 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "cy");
          var t$20 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
          var $$x2 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$20, this$116.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, y$4);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$119 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "r");
          var t$21 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
          var $$x1 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$21, this$119.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 2);
          $m_Ljapgolly_scalajs_react_vdom_all$svg$();
          $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
          var this$122 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
          var t$22 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
          var array$7 = [$$x3, $$x2, $$x1, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$22, this$122.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#06F")];
          return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($$x5).apply__O__O($n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("circle", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))))
        }
      };
      throw new $c_s_MatchError(x0$3)
    })))));
    var array$8 = [$$x30, $$x25, $$x20, $$x16, $$x11, $$x6, $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$127, null, this$126)];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
    return new $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState(new $c_s_util_Right($p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$131, null, ns)))
  };
  throw new $c_s_MatchError(x1$2)
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_width;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_rangeDate;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_values;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getDate;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getNumeric;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_wrapPoint;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_width;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_rangeDate;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_values;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getDate;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$3 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getNumeric;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$4 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_wrapPoint;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps(x$1);
    if ((this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_width === $n(TypedProps$1).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_width)) {
      if ((this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height === $n(TypedProps$1).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_height)) {
        var x = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_rangeDate;
        var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_rangeDate;
        var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_values;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_values;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getDate;
        var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getDate;
        var $$x2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$7 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getNumeric;
        var x$8 = $n(TypedProps$1).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_getNumeric;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_wrapPoint;
          var x$10 = $n(TypedProps$1).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps__f_wrapPoint;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ui.GraphOverTime$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ui.GraphOverTime$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps: 0
}, false, "reactbuild.analyze.cost.ui.GraphOverTime$TypedProps", {
  Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState(result) {
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState__f_result = null;
  this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState__f_result = result
}
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype = $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype;
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState__f_result : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState(x$1);
    var x = this.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState__f_result;
    var x$2 = $n(TypedState$1).Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState__f_result;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ui.GraphOverTime$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ui.GraphOverTime$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState: 0
}, false, "reactbuild.analyze.cost.ui.GraphOverTime$TypedState", {
  Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_GraphOverTime$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__f_updateItem = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$Backend__f_$ = \u03b4;
  $ct_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend__(this)
}
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend.prototype = new $h_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend();
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend.prototype = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend.prototype;
var $d_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_ItemDetailView$Backend: 0
}, false, "reactbuild.analyze.cost.ui.ItemDetailView$Backend", {
  Lreactbuild_analyze_cost_ui_ItemDetailView$Backend: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_ItemDetailView$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(selected, detailState) {
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_selected = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_selected = selected;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState = detailState
}
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype;
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_selected;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(x$1);
    var x = this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_selected;
    var x$2 = $n(TypedState$1).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_selected;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState;
      var y = $n(TypedState$1).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ui.ItemDetailView$TypedState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ui.ItemDetailView$TypedState;", depth))
}
var $d_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState: 0
}, false, "reactbuild.analyze.cost.ui.ItemDetailView$TypedState", {
  Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_Admin$Props(m, definitions, ctl) {
  this.Lreactbuild_analyze_cost_views_Admin$Props__f_m = null;
  this.Lreactbuild_analyze_cost_views_Admin$Props__f_definitions = null;
  this.Lreactbuild_analyze_cost_views_Admin$Props__f_ctl = null;
  this.Lreactbuild_analyze_cost_views_Admin$Props__f_m = m;
  this.Lreactbuild_analyze_cost_views_Admin$Props__f_definitions = definitions;
  this.Lreactbuild_analyze_cost_views_Admin$Props__f_ctl = ctl
}
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_views_Admin$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_Admin$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_Admin$Props.prototype = $c_Lreactbuild_analyze_cost_views_Admin$Props.prototype;
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_views_Admin$Props__f_m;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_views_Admin$Props__f_definitions;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_views_Admin$Props__f_ctl;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_views_Admin$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_views_Admin$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_views_Admin$Props__f_m;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_views_Admin$Props__f_m;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_views_Admin$Props__f_definitions;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_views_Admin$Props__f_definitions;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_views_Admin$Props__f_ctl;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_views_Admin$Props__f_ctl;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_views_Admin$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_Admin$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.Admin$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_Admin$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_Admin$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_Admin$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_Admin$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.Admin$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_views_Admin$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_Admin$Props: 0
}, false, "reactbuild.analyze.cost.views.Admin$Props", {
  Lreactbuild_analyze_cost_views_Admin$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_views_Admin$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_views_Admin$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_Admin$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype.constructor = $c_Lreactbuild_analyze_cost_views_Admin$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_Admin$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_Admin$State.prototype = $c_Lreactbuild_analyze_cost_views_Admin$State.prototype;
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype.equals__O__Z = (function(x$1) {
  return ((x$1 instanceof $c_Lreactbuild_analyze_cost_views_Admin$State) && ($n($as_Lreactbuild_analyze_cost_views_Admin$State(x$1)), true))
});
function $as_Lreactbuild_analyze_cost_views_Admin$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_Admin$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.Admin$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_Admin$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_Admin$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_Admin$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_Admin$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.Admin$State;", depth))
}
var $d_Lreactbuild_analyze_cost_views_Admin$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_Admin$State: 0
}, false, "reactbuild.analyze.cost.views.Admin$State", {
  Lreactbuild_analyze_cost_views_Admin$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_views_Admin$State.prototype.$classData = $d_Lreactbuild_analyze_cost_views_Admin$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_FilePreview$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype.constructor = $c_Lreactbuild_analyze_cost_views_FilePreview$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_FilePreview$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_FilePreview$State.prototype = $c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype;
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_views_FilePreview$State)
});
function $as_Lreactbuild_analyze_cost_views_FilePreview$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_FilePreview$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.FilePreview$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_FilePreview$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_FilePreview$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_FilePreview$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_FilePreview$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.FilePreview$State;", depth))
}
var $d_Lreactbuild_analyze_cost_views_FilePreview$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_FilePreview$State: 0
}, false, "reactbuild.analyze.cost.views.FilePreview$State", {
  Lreactbuild_analyze_cost_views_FilePreview$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_views_FilePreview$State.prototype.$classData = $d_Lreactbuild_analyze_cost_views_FilePreview$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_Inbox$Props(router, proxy) {
  this.Lreactbuild_analyze_cost_views_Inbox$Props__f_router = null;
  this.Lreactbuild_analyze_cost_views_Inbox$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_views_Inbox$Props__f_router = router;
  this.Lreactbuild_analyze_cost_views_Inbox$Props__f_proxy = proxy
}
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_views_Inbox$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_Inbox$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_Inbox$Props.prototype = $c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype;
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_views_Inbox$Props__f_router;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_views_Inbox$Props__f_proxy;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_views_Inbox$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_views_Inbox$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_views_Inbox$Props__f_router;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_views_Inbox$Props__f_router;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_views_Inbox$Props__f_proxy;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_views_Inbox$Props__f_proxy;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_views_Inbox$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_Inbox$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.Inbox$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_Inbox$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_Inbox$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_Inbox$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_Inbox$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.Inbox$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_views_Inbox$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_Inbox$Props: 0
}, false, "reactbuild.analyze.cost.views.Inbox$Props", {
  Lreactbuild_analyze_cost_views_Inbox$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_views_Inbox$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_views_Inbox$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_ProcessTask$Props(router, proxy, task, next) {
  this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_router = null;
  this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_task = null;
  this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_next = null;
  this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_router = router;
  this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_task = task;
  this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_next = next
}
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_views_ProcessTask$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_ProcessTask$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype = $c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype;
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_router;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_proxy;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_task;
      break
    }
    case 3: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_next);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_views_ProcessTask$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_views_ProcessTask$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_router;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_views_ProcessTask$Props__f_router;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_proxy;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_views_ProcessTask$Props__f_proxy;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_task;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_views_ProcessTask$Props__f_task;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_views_ProcessTask$Props__f_next;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_views_ProcessTask$Props__f_next;
        if ((x$7 === null)) {
          return (x$8 === null)
        } else {
          var this$1 = $n(x$7);
          return (this$1 === x$8)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_views_ProcessTask$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_ProcessTask$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.ProcessTask$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_ProcessTask$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_ProcessTask$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_ProcessTask$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_ProcessTask$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.ProcessTask$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_views_ProcessTask$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_ProcessTask$Props: 0
}, false, "reactbuild.analyze.cost.views.ProcessTask$Props", {
  Lreactbuild_analyze_cost_views_ProcessTask$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_views_ProcessTask$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_ProcessTask$State() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype.constructor = $c_Lreactbuild_analyze_cost_views_ProcessTask$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_ProcessTask$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype = $c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype;
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_views_ProcessTask$State)
});
function $as_Lreactbuild_analyze_cost_views_ProcessTask$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_ProcessTask$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.ProcessTask$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_ProcessTask$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_ProcessTask$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_ProcessTask$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_ProcessTask$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.ProcessTask$State;", depth))
}
var $d_Lreactbuild_analyze_cost_views_ProcessTask$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_ProcessTask$State: 0
}, false, "reactbuild.analyze.cost.views.ProcessTask$State", {
  Lreactbuild_analyze_cost_views_ProcessTask$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_views_ProcessTask$State.prototype.$classData = $d_Lreactbuild_analyze_cost_views_ProcessTask$State;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props(router, proxy, communication, task, next) {
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_router = null;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_proxy = null;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication = null;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_task = null;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_next = null;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_router = router;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication = communication;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_task = task;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_next = next
}
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype.constructor = $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype = $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype;
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_router;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_proxy;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_task;
      break
    }
    case 4: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_next);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props)) {
    var Props$1 = $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props(x$1);
    var x = this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_router;
    var x$2 = $n(Props$1).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_router;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_proxy;
      var x$4 = $n(Props$1).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_proxy;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication;
      var x$6 = $n(Props$1).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_communication;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_task;
        var x$8 = $n(Props$1).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_task;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_next;
          var x$10 = $n(Props$1).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props__f_next;
          if ((x$9 === null)) {
            return (x$10 === null)
          } else {
            var this$1 = $n(x$9);
            return (this$1 === x$10)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.ProcessTaskCommunication$Props"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.ProcessTaskCommunication$Props;", depth))
}
var $d_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props: 0
}, false, "reactbuild.analyze.cost.views.ProcessTaskCommunication$Props", {
  Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props.prototype.$classData = $d_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$Props;
/** @constructor */
function $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(displayedBody) {
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__f_displayedBody = 0;
  this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__f_displayedBody = displayedBody
}
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype.constructor = $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State;
/** @constructor */
function $h_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype = $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype;
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__f_displayedBody : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__f_displayedBody;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State)) {
    var State$1 = $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(x$1);
    return (this.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__f_displayedBody === $n(State$1).Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State__f_displayedBody)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.views.ProcessTaskCommunication$State"))
}
function $isArrayOf_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State)))
}
function $asArrayOf_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.views.ProcessTaskCommunication$State;", depth))
}
var $d_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State = new $TypeData().initClass({
  Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State: 0
}, false, "reactbuild.analyze.cost.views.ProcessTaskCommunication$State", {
  Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State.prototype.$classData = $d_Lreactbuild_analyze_cost_views_ProcessTaskCommunication$State;
/** @constructor */
function $c_Lreactbuild_common_components_DrawingViewer$Props(library, modelSource) {
  this.Lreactbuild_common_components_DrawingViewer$Props__f_library = null;
  this.Lreactbuild_common_components_DrawingViewer$Props__f_modelSource = null;
  this.Lreactbuild_common_components_DrawingViewer$Props__f_library = library;
  this.Lreactbuild_common_components_DrawingViewer$Props__f_modelSource = modelSource
}
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype = new $h_O();
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype.constructor = $c_Lreactbuild_common_components_DrawingViewer$Props;
/** @constructor */
function $h_Lreactbuild_common_components_DrawingViewer$Props() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_DrawingViewer$Props.prototype = $c_Lreactbuild_common_components_DrawingViewer$Props.prototype;
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_DrawingViewer$Props__f_library;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_DrawingViewer$Props__f_modelSource;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_DrawingViewer$Props)) {
    var Props$1 = $as_Lreactbuild_common_components_DrawingViewer$Props(x$1);
    var x = this.Lreactbuild_common_components_DrawingViewer$Props__f_library;
    var x$2 = $n(Props$1).Lreactbuild_common_components_DrawingViewer$Props__f_library;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lreactbuild_common_components_DrawingViewer$Props__f_modelSource === $n(Props$1).Lreactbuild_common_components_DrawingViewer$Props__f_modelSource)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_DrawingViewer$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_DrawingViewer$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.DrawingViewer$Props"))
}
function $isArrayOf_Lreactbuild_common_components_DrawingViewer$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_DrawingViewer$Props)))
}
function $asArrayOf_Lreactbuild_common_components_DrawingViewer$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_DrawingViewer$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.DrawingViewer$Props;", depth))
}
var $d_Lreactbuild_common_components_DrawingViewer$Props = new $TypeData().initClass({
  Lreactbuild_common_components_DrawingViewer$Props: 0
}, false, "reactbuild.common.components.DrawingViewer$Props", {
  Lreactbuild_common_components_DrawingViewer$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_DrawingViewer$Props.prototype.$classData = $d_Lreactbuild_common_components_DrawingViewer$Props;
/** @constructor */
function $c_Lreactbuild_common_components_DrawingViewer$State(debugMode) {
  this.Lreactbuild_common_components_DrawingViewer$State__f_debugMode = false;
  this.Lreactbuild_common_components_DrawingViewer$State__f_debugMode = debugMode
}
$c_Lreactbuild_common_components_DrawingViewer$State.prototype = new $h_O();
$c_Lreactbuild_common_components_DrawingViewer$State.prototype.constructor = $c_Lreactbuild_common_components_DrawingViewer$State;
/** @constructor */
function $h_Lreactbuild_common_components_DrawingViewer$State() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_DrawingViewer$State.prototype = $c_Lreactbuild_common_components_DrawingViewer$State.prototype;
$c_Lreactbuild_common_components_DrawingViewer$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_common_components_DrawingViewer$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_components_DrawingViewer$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_components_DrawingViewer$State__f_debugMode : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_components_DrawingViewer$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_DrawingViewer$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_common_components_DrawingViewer$State__f_debugMode ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_common_components_DrawingViewer$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_DrawingViewer$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_DrawingViewer$State)) {
    var State$1 = $as_Lreactbuild_common_components_DrawingViewer$State(x$1);
    return (this.Lreactbuild_common_components_DrawingViewer$State__f_debugMode === $n(State$1).Lreactbuild_common_components_DrawingViewer$State__f_debugMode)
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_DrawingViewer$State(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_DrawingViewer$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.DrawingViewer$State"))
}
function $isArrayOf_Lreactbuild_common_components_DrawingViewer$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_DrawingViewer$State)))
}
function $asArrayOf_Lreactbuild_common_components_DrawingViewer$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_DrawingViewer$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.DrawingViewer$State;", depth))
}
var $d_Lreactbuild_common_components_DrawingViewer$State = new $TypeData().initClass({
  Lreactbuild_common_components_DrawingViewer$State: 0
}, false, "reactbuild.common.components.DrawingViewer$State", {
  Lreactbuild_common_components_DrawingViewer$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_DrawingViewer$State.prototype.$classData = $d_Lreactbuild_common_components_DrawingViewer$State;
/** @constructor */
function $c_Lreactbuild_common_components_InteractionController$Backend(\u03b4) {
  this.Lreactbuild_common_components_InteractionController$TypedBackend__f_ref = null;
  this.Lreactbuild_common_components_InteractionController$TypedBackend__f_eventHandlers = null;
  this.Lreactbuild_common_components_InteractionController$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_common_components_InteractionController$Backend__f_$ = null;
  this.Lreactbuild_common_components_InteractionController$Backend__f_$ = \u03b4;
  $ct_Lreactbuild_common_components_InteractionController$TypedBackend__(this)
}
$c_Lreactbuild_common_components_InteractionController$Backend.prototype = new $h_Lreactbuild_common_components_InteractionController$TypedBackend();
$c_Lreactbuild_common_components_InteractionController$Backend.prototype.constructor = $c_Lreactbuild_common_components_InteractionController$Backend;
/** @constructor */
function $h_Lreactbuild_common_components_InteractionController$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_InteractionController$Backend.prototype = $c_Lreactbuild_common_components_InteractionController$Backend.prototype;
var $d_Lreactbuild_common_components_InteractionController$Backend = new $TypeData().initClass({
  Lreactbuild_common_components_InteractionController$Backend: 0
}, false, "reactbuild.common.components.InteractionController$Backend", {
  Lreactbuild_common_components_InteractionController$Backend: 1,
  Lreactbuild_common_components_InteractionController$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1
});
$c_Lreactbuild_common_components_InteractionController$Backend.prototype.$classData = $d_Lreactbuild_common_components_InteractionController$Backend;
/** @constructor */
function $c_Lreactbuild_common_components_InteractionController$TypedProps(tagOf, context, interactions, interactionDone, interactionEmpty) {
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_tagOf = null;
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_context = null;
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactions = null;
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactionDone = null;
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactionEmpty = null;
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_tagOf = tagOf;
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_context = context;
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactions = interactions;
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactionDone = interactionDone;
  this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactionEmpty = interactionEmpty
}
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype = new $h_O();
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype.constructor = $c_Lreactbuild_common_components_InteractionController$TypedProps;
/** @constructor */
function $h_Lreactbuild_common_components_InteractionController$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_InteractionController$TypedProps.prototype = $c_Lreactbuild_common_components_InteractionController$TypedProps.prototype;
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_InteractionController$TypedProps__f_tagOf;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_InteractionController$TypedProps__f_context;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactions;
      break
    }
    case 3: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactionDone);
      break
    }
    case 4: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactionEmpty);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_InteractionController$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_common_components_InteractionController$TypedProps(x$1);
    var x = this.Lreactbuild_common_components_InteractionController$TypedProps__f_tagOf;
    var x$2 = $n(TypedProps$1).Lreactbuild_common_components_InteractionController$TypedProps__f_tagOf;
    if ((x === null)) {
      var $$x2 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x2 = (this$1 === x$2)
    };
    if ($$x2) {
      var x$3 = this.Lreactbuild_common_components_InteractionController$TypedProps__f_context;
      var y = $n(TypedProps$1).Lreactbuild_common_components_InteractionController$TypedProps__f_context;
      var $$x1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3$1 = this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactions;
      var x$4 = $n(TypedProps$1).Lreactbuild_common_components_InteractionController$TypedProps__f_interactions;
      if (((x$3$1 === null) ? (x$4 === null) : $n(x$3$1).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactionDone;
        var x$6 = $n(TypedProps$1).Lreactbuild_common_components_InteractionController$TypedProps__f_interactionDone;
        if ((x$5 === null)) {
          var $$x3 = (x$6 === null)
        } else {
          var this$2 = $n(x$5);
          var $$x3 = (this$2 === x$6)
        };
        if ($$x3) {
          var x$7 = this.Lreactbuild_common_components_InteractionController$TypedProps__f_interactionEmpty;
          var x$8 = $n(TypedProps$1).Lreactbuild_common_components_InteractionController$TypedProps__f_interactionEmpty;
          if ((x$7 === null)) {
            return (x$8 === null)
          } else {
            var this$3 = $n(x$7);
            return (this$3 === x$8)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_InteractionController$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_InteractionController$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.InteractionController$TypedProps"))
}
function $isArrayOf_Lreactbuild_common_components_InteractionController$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_InteractionController$TypedProps)))
}
function $asArrayOf_Lreactbuild_common_components_InteractionController$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_InteractionController$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.InteractionController$TypedProps;", depth))
}
var $d_Lreactbuild_common_components_InteractionController$TypedProps = new $TypeData().initClass({
  Lreactbuild_common_components_InteractionController$TypedProps: 0
}, false, "reactbuild.common.components.InteractionController$TypedProps", {
  Lreactbuild_common_components_InteractionController$TypedProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_InteractionController$TypedProps.prototype.$classData = $d_Lreactbuild_common_components_InteractionController$TypedProps;
/** @constructor */
function $c_Lreactbuild_common_components_InteractionController$TypedState(interactions, trackedPointers, lastEvents) {
  this.Lreactbuild_common_components_InteractionController$TypedState__f_interactions = null;
  this.Lreactbuild_common_components_InteractionController$TypedState__f_trackedPointers = null;
  this.Lreactbuild_common_components_InteractionController$TypedState__f_lastEvents = null;
  this.Lreactbuild_common_components_InteractionController$TypedState__f_interactions = interactions;
  this.Lreactbuild_common_components_InteractionController$TypedState__f_trackedPointers = trackedPointers;
  this.Lreactbuild_common_components_InteractionController$TypedState__f_lastEvents = lastEvents
}
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype = new $h_O();
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype.constructor = $c_Lreactbuild_common_components_InteractionController$TypedState;
/** @constructor */
function $h_Lreactbuild_common_components_InteractionController$TypedState() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_InteractionController$TypedState.prototype = $c_Lreactbuild_common_components_InteractionController$TypedState.prototype;
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype.productPrefix__T = (function() {
  return "TypedState"
});
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_InteractionController$TypedState__f_interactions;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_InteractionController$TypedState__f_trackedPointers;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_InteractionController$TypedState__f_lastEvents;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_InteractionController$TypedState)) {
    var TypedState$1 = $as_Lreactbuild_common_components_InteractionController$TypedState(x$1);
    var x = this.Lreactbuild_common_components_InteractionController$TypedState__f_interactions;
    var x$2 = $n(TypedState$1).Lreactbuild_common_components_InteractionController$TypedState__f_interactions;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_components_InteractionController$TypedState__f_trackedPointers;
      var x$4 = $n(TypedState$1).Lreactbuild_common_components_InteractionController$TypedState__f_trackedPointers;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_common_components_InteractionController$TypedState__f_lastEvents;
        var x$6 = $n(TypedState$1).Lreactbuild_common_components_InteractionController$TypedState__f_lastEvents;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_InteractionController$TypedState(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_InteractionController$TypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.InteractionController$TypedState"))
}
function $isArrayOf_Lreactbuild_common_components_InteractionController$TypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_InteractionController$TypedState)))
}
function $asArrayOf_Lreactbuild_common_components_InteractionController$TypedState(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_InteractionController$TypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.InteractionController$TypedState;", depth))
}
var $d_Lreactbuild_common_components_InteractionController$TypedState = new $TypeData().initClass({
  Lreactbuild_common_components_InteractionController$TypedState: 0
}, false, "reactbuild.common.components.InteractionController$TypedState", {
  Lreactbuild_common_components_InteractionController$TypedState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_InteractionController$TypedState.prototype.$classData = $d_Lreactbuild_common_components_InteractionController$TypedState;
function $p_Lreactbuild_common_components_Interactions__loop$1__I__sci_List__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult($thiz, index, rest, ev$1, trackedPointers$1, context$1) {
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      return $m_Lreactbuild_common_components_Skip$()
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var head = $as_Lreactbuild_common_components_Interaction($n(x3).sci_$colon$colon__f_head);
      var tl = $n(x3).sci_$colon$colon__f_next;
      var x1$2 = $n(head).handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult(ev$1, trackedPointers$1, context$1);
      var x$3 = $m_Lreactbuild_common_components_Skip$();
      if ((x$3 === x1$2)) {
        var temp$index = ((1 + index) | 0);
        index = temp$index;
        rest = tl
      } else if ($is_Lreactbuild_common_components_ProcessedInteractionResult(x1$2)) {
        var x3$2 = $as_Lreactbuild_common_components_ProcessedInteractionResult(x1$2);
        var $$x1 = $n(x3$2);
        var index$2 = index;
        return $n($$x1).map__F1__Lreactbuild_common_components_InteractionResult(new $c_sjsr_AnonFunction1(((index$1) => ((nextState$2) => {
          var arg1 = $thiz.Lreactbuild_common_components_Interactions__f_orderedList;
          var this$3 = $n(arg1);
          var this$2 = $n($m_s_package$().s_package$__f_Nil);
          var other = new $c_sci_$colon$colon(nextState$2, this$2);
          var orderedList = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$3, index$1, other, 1));
          return new $c_Lreactbuild_common_components_Interactions(orderedList)
        }))(index$2)))
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_common_components_Interactions(orderedList) {
  this.Lreactbuild_common_components_Interactions__f_orderedList = null;
  this.Lreactbuild_common_components_Interactions__f_orderedList = orderedList
}
$c_Lreactbuild_common_components_Interactions.prototype = new $h_O();
$c_Lreactbuild_common_components_Interactions.prototype.constructor = $c_Lreactbuild_common_components_Interactions;
/** @constructor */
function $h_Lreactbuild_common_components_Interactions() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Interactions.prototype = $c_Lreactbuild_common_components_Interactions.prototype;
$c_Lreactbuild_common_components_Interactions.prototype.productPrefix__T = (function() {
  return "Interactions"
});
$c_Lreactbuild_common_components_Interactions.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_components_Interactions.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_components_Interactions__f_orderedList : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_components_Interactions.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Interactions.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_components_Interactions.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_Interactions.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_Interactions)) {
    var Interactions$1 = $as_Lreactbuild_common_components_Interactions(x$1);
    var x = this.Lreactbuild_common_components_Interactions__f_orderedList;
    var x$2 = $n(Interactions$1).Lreactbuild_common_components_Interactions__f_orderedList;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_Interactions(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_Interactions) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Interactions"))
}
function $isArrayOf_Lreactbuild_common_components_Interactions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Interactions)))
}
function $asArrayOf_Lreactbuild_common_components_Interactions(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Interactions(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Interactions;", depth))
}
var $d_Lreactbuild_common_components_Interactions = new $TypeData().initClass({
  Lreactbuild_common_components_Interactions: 0
}, false, "reactbuild.common.components.Interactions", {
  Lreactbuild_common_components_Interactions: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Interactions.prototype.$classData = $d_Lreactbuild_common_components_Interactions;
/** @constructor */
function $c_Lreactbuild_common_components_SpaceBuilder(group, walls, wallMaterial) {
  this.Lreactbuild_common_components_SpaceBuilder__f_group = null;
  this.Lreactbuild_common_components_SpaceBuilder__f_walls = null;
  this.Lreactbuild_common_components_SpaceBuilder__f_wallMaterial = null;
  this.Lreactbuild_common_components_SpaceBuilder__f_group = group;
  this.Lreactbuild_common_components_SpaceBuilder__f_walls = walls;
  this.Lreactbuild_common_components_SpaceBuilder__f_wallMaterial = wallMaterial
}
$c_Lreactbuild_common_components_SpaceBuilder.prototype = new $h_O();
$c_Lreactbuild_common_components_SpaceBuilder.prototype.constructor = $c_Lreactbuild_common_components_SpaceBuilder;
/** @constructor */
function $h_Lreactbuild_common_components_SpaceBuilder() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_SpaceBuilder.prototype = $c_Lreactbuild_common_components_SpaceBuilder.prototype;
$c_Lreactbuild_common_components_SpaceBuilder.prototype.productPrefix__T = (function() {
  return "SpaceBuilder"
});
$c_Lreactbuild_common_components_SpaceBuilder.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_common_components_SpaceBuilder.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_SpaceBuilder__f_group;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_SpaceBuilder__f_walls;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_SpaceBuilder__f_wallMaterial;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_SpaceBuilder.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_SpaceBuilder.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_components_SpaceBuilder.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_SpaceBuilder.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_SpaceBuilder)) {
    var SpaceBuilder$1 = $as_Lreactbuild_common_components_SpaceBuilder(x$1);
    var x = this.Lreactbuild_common_components_SpaceBuilder__f_group;
    var y = $n(SpaceBuilder$1).Lreactbuild_common_components_SpaceBuilder__f_group;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_common_components_SpaceBuilder__f_walls;
      var x$2$1 = $n(SpaceBuilder$1).Lreactbuild_common_components_SpaceBuilder__f_walls;
      if (((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))) {
        var x$3 = this.Lreactbuild_common_components_SpaceBuilder__f_wallMaterial;
        var y$1 = $n(SpaceBuilder$1).Lreactbuild_common_components_SpaceBuilder__f_wallMaterial;
        return $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y$1)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_SpaceBuilder(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_SpaceBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.SpaceBuilder"))
}
function $isArrayOf_Lreactbuild_common_components_SpaceBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_SpaceBuilder)))
}
function $asArrayOf_Lreactbuild_common_components_SpaceBuilder(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_SpaceBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.SpaceBuilder;", depth))
}
var $d_Lreactbuild_common_components_SpaceBuilder = new $TypeData().initClass({
  Lreactbuild_common_components_SpaceBuilder: 0
}, false, "reactbuild.common.components.SpaceBuilder", {
  Lreactbuild_common_components_SpaceBuilder: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_SpaceBuilder.prototype.$classData = $d_Lreactbuild_common_components_SpaceBuilder;
function $p_Lreactbuild_common_components_TrackedPointers__loop$1__sci_List__Lreactbuild_geom_Vector2Based__I__Lreactbuild_common_components_Input$CursorType__Lreactbuild_geom_Vector2Based($thiz, rest, acc, count, pointerType$1) {
  while (true) {
    var x1 = rest;
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x2 = $as_sci_$colon$colon(x1);
      var p3 = $as_sci_List($n(x2).sci_$colon$colon__f_head);
      var tail = $n(x2).sci_$colon$colon__f_next;
      if ((p3 instanceof $c_sci_$colon$colon)) {
        var x4 = $as_sci_$colon$colon(p3);
        var head = $as_Lreactbuild_common_components_Input$PointerEvent($n(x4).sci_$colon$colon__f_head);
        var x = $n($n(head).Lreactbuild_common_components_Input$PointerEvent__f_coords).Lreactbuild_common_components_Input$Coords__f_cursor;
        if ((x === null)) {
          var $$x1 = (pointerType$1 === null)
        } else {
          var this$1 = $n(x);
          var $$x1 = (this$1 === pointerType$1)
        };
        if ((!$$x1)) {
          rest = tail;
          continue
        } else {
          var this$2 = $n(acc);
          var that = $n(head).Lreactbuild_common_components_Input$PointerEvent__f_coords;
          var temp$acc = new $c_Lreactbuild_geom_Point2((this$2.x__D() + $n(that).Lreactbuild_common_components_Input$Coords__f_x), (this$2.y__D() + $n(that).Lreactbuild_common_components_Input$Coords__f_y));
          var temp$count = ((1 + count) | 0);
          rest = tail;
          acc = temp$acc;
          count = temp$count;
          continue
        }
      }
    };
    if ((count === 0)) {
      return acc
    } else {
      var this$3 = $n(acc);
      var scalar = count;
      return new $c_Lreactbuild_geom_Vector2((this$3.x__D() / scalar), (this$3.y__D() / scalar))
    }
  }
}
/** @constructor */
function $c_Lreactbuild_common_components_TrackedPointers(underlying) {
  this.Lreactbuild_common_components_TrackedPointers__f_underlying = null;
  this.Lreactbuild_common_components_TrackedPointers__f_underlying = underlying
}
$c_Lreactbuild_common_components_TrackedPointers.prototype = new $h_O();
$c_Lreactbuild_common_components_TrackedPointers.prototype.constructor = $c_Lreactbuild_common_components_TrackedPointers;
/** @constructor */
function $h_Lreactbuild_common_components_TrackedPointers() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_TrackedPointers.prototype = $c_Lreactbuild_common_components_TrackedPointers.prototype;
$c_Lreactbuild_common_components_TrackedPointers.prototype.update__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers = (function(ev) {
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var x1$2 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var x = $m_Lreactbuild_common_components_Input$Start$();
    if ((x === x1$2)) {
      var $$x1 = true
    } else {
      var x$3 = $m_Lreactbuild_common_components_Input$Enter$();
      var $$x1 = (x$3 === x1$2)
    };
    if ($$x1) {
      return this.track__Lreactbuild_common_components_Input$PointerEvent__Lreactbuild_common_components_TrackedPointers(x2)
    } else {
      var x$5 = $m_Lreactbuild_common_components_Input$Move$();
      if ((x$5 === x1$2)) {
        return this.track__Lreactbuild_common_components_Input$PointerEvent__Lreactbuild_common_components_TrackedPointers(x2)
      } else {
        var x$7 = $m_Lreactbuild_common_components_Input$End$();
        if ((x$7 === x1$2)) {
          var $$x2 = true
        } else {
          var x$9 = $m_Lreactbuild_common_components_Input$Leave$();
          var $$x2 = (x$9 === x1$2)
        };
        if ($$x2) {
          return this.untrack__Lreactbuild_common_components_Input$PointerEvent__Lreactbuild_common_components_TrackedPointers(x2)
        } else {
          return this
        }
      }
    }
  } else {
    return this
  }
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.withId__Lreactbuild_common_components_Input$PointerEvent__I = (function(ev) {
  var this$1 = $n(this.Lreactbuild_common_components_TrackedPointers__f_underlying);
  var i = 0;
  var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$1, 0, this$1);
  while (true) {
    var this$4 = $n(these);
    if ((!this$4.isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x$1 = $as_sci_List(arg1);
      if (($n($as_Lreactbuild_common_components_Input$PointerEvent($n(x$1).head__O())).Lreactbuild_common_components_Input$PointerEvent__f_id === $n(ev).Lreactbuild_common_components_Input$PointerEvent__f_id)) {
        return i
      };
      i = ((1 + i) | 0);
      these = $as_sc_LinearSeq($n(these).tail__O())
    } else {
      break
    }
  };
  return (-1)
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.track__Lreactbuild_common_components_Input$PointerEvent__Lreactbuild_common_components_TrackedPointers = (function(ev) {
  var x1 = this.withId__Lreactbuild_common_components_Input$PointerEvent__I(ev);
  if ((x1 === (-1))) {
    $n($m_s_package$().s_package$__f_List);
    var array = [ev];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var rassoc$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    var this$5 = $n(this.Lreactbuild_common_components_TrackedPointers__f_underlying);
    var underlying = new $c_sci_$colon$colon(rassoc$1, this$5)
  } else {
    var this$6 = $n(this.Lreactbuild_common_components_TrackedPointers__f_underlying);
    var this$7 = $n($as_sci_List($f_sc_LinearSeqOps__apply__I__O(this$6, x1)));
    var rassoc$3 = new $c_sci_$colon$colon(ev, this$7);
    var this$8 = $n(this.Lreactbuild_common_components_TrackedPointers__f_underlying);
    var other = $m_s_package$().s_package$__f_Nil;
    var this$9 = $n($as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$8, x1, other, 1)));
    var underlying = new $c_sci_$colon$colon(rassoc$3, this$9)
  };
  return new $c_Lreactbuild_common_components_TrackedPointers(underlying)
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.untrack__Lreactbuild_common_components_Input$PointerEvent__Lreactbuild_common_components_TrackedPointers = (function(ev) {
  var x1 = this.withId__Lreactbuild_common_components_Input$PointerEvent__I(ev);
  if ((x1 === (-1))) {
    return this
  } else {
    var this$1 = $n(this.Lreactbuild_common_components_TrackedPointers__f_underlying);
    var other = $m_s_package$().s_package$__f_Nil;
    var underlying = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$1, x1, other, 1));
    return new $c_Lreactbuild_common_components_TrackedPointers(underlying)
  }
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.centroid__Lreactbuild_common_components_Input$CursorType__Lreactbuild_geom_Vector2Based = (function(pointerType) {
  return $p_Lreactbuild_common_components_TrackedPointers__loop$1__sci_List__Lreactbuild_geom_Vector2Based__I__Lreactbuild_common_components_Input$CursorType__Lreactbuild_geom_Vector2Based(this, $n(this.Lreactbuild_common_components_TrackedPointers__f_underlying), $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero, 0, pointerType)
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.count__Lreactbuild_common_components_Input$CursorType__I = (function(cursor) {
  var this$1 = $n(this.Lreactbuild_common_components_TrackedPointers__f_underlying);
  var res = 0;
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var arg1 = $n(it).next__O();
    var p = $as_sci_List(arg1);
    var x = $n($n($as_Lreactbuild_common_components_Input$PointerEvent($n(p).head__O())).Lreactbuild_common_components_Input$PointerEvent__f_coords).Lreactbuild_common_components_Input$Coords__f_cursor;
    if ((x === null)) {
      var $$x1 = (cursor === null)
    } else {
      var this$2 = $n(x);
      var $$x1 = (this$2 === cursor)
    };
    if ($$x1) {
      res = ((1 + res) | 0)
    }
  };
  return res
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.touchDistance__s_Option = (function() {
  var this$1 = $n(this.Lreactbuild_common_components_TrackedPointers__f_underlying);
  if ((this$1.length__I() < 2)) {
    return $m_s_None$()
  } else {
    var x1 = $n(this.Lreactbuild_common_components_TrackedPointers__f_underlying).collect__s_PartialFunction__sci_List(new $c_Lreactbuild_common_components_TrackedPointers$$anonfun$1(this));
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x2 = $as_sci_$colon$colon(x1);
      var a = $as_Lreactbuild_common_components_Input$Coords($n(x2).sci_$colon$colon__f_head);
      var p3 = $n(x2).sci_$colon$colon__f_next;
      if ((p3 instanceof $c_sci_$colon$colon)) {
        var x4 = $as_sci_$colon$colon(p3);
        var b = $as_Lreactbuild_common_components_Input$Coords($n(x4).sci_$colon$colon__f_head);
        var p5 = $n(x4).sci_$colon$colon__f_next;
        var x = $m_s_package$().s_package$__f_Nil;
        if (((x === null) ? (p5 === null) : $n(x).equals__O__Z(p5))) {
          var this$2 = $n(a);
          var sum = new $c_Lreactbuild_geom_Point2((this$2.Lreactbuild_common_components_Input$Coords__f_x + $n(b).Lreactbuild_common_components_Input$Coords__f_x), (this$2.Lreactbuild_common_components_Input$Coords__f_y + $n(b).Lreactbuild_common_components_Input$Coords__f_y));
          var this$3 = $n(a);
          var delta = new $c_Lreactbuild_geom_Vector2((this$3.Lreactbuild_common_components_Input$Coords__f_x - $n(b).Lreactbuild_common_components_Input$Coords__f_x), (this$3.Lreactbuild_common_components_Input$Coords__f_y - $n(b).Lreactbuild_common_components_Input$Coords__f_y));
          $m_Lreactbuild_math_package$SquareRoot$();
          if ((delta.Lreactbuild_geom_Vector2__f_x === 0.0)) {
            $m_Lreactbuild_math_package$SquareRoot$();
            var x$1 = delta.Lreactbuild_geom_Vector2__f_y;
            var length = $uD(Math.abs(x$1));
            var sq = (length * length);
            var sqrt = $uD(Math.abs(length));
            var sqrt$2 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt)
          } else if ((delta.Lreactbuild_geom_Vector2__f_y === 0.0)) {
            $m_Lreactbuild_math_package$SquareRoot$();
            var x$2 = delta.Lreactbuild_geom_Vector2__f_x;
            var length$1 = $uD(Math.abs(x$2));
            var sq$1 = (length$1 * length$1);
            var sqrt$1 = $uD(Math.abs(length$1));
            var sqrt$2 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$1, sqrt$1)
          } else {
            $m_Lreactbuild_math_package$SquareRoot$();
            var v = delta.Lreactbuild_geom_Vector2__f_x;
            var v$1 = delta.Lreactbuild_geom_Vector2__f_y;
            var value = ((v * v) + (v$1 * v$1));
            var sqrt$2 = new $c_Lreactbuild_math_package$LazySquareRoot(value)
          };
          return new $c_s_Some($ct_T2__O__O__(new $c_T2(), $n(sqrt$2).sqrt__D(), new $c_Lreactbuild_geom_Vector2((sum.Lreactbuild_geom_Point2__f_x / 2.0), (sum.Lreactbuild_geom_Point2__f_y / 2.0))))
        }
      }
    };
    return $m_s_None$()
  }
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.productPrefix__T = (function() {
  return "TrackedPointers"
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_components_TrackedPointers__f_underlying : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_TrackedPointers)) {
    var TrackedPointers$1 = $as_Lreactbuild_common_components_TrackedPointers(x$1);
    var x = this.Lreactbuild_common_components_TrackedPointers__f_underlying;
    var x$2 = $n(TrackedPointers$1).Lreactbuild_common_components_TrackedPointers__f_underlying;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_TrackedPointers(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_TrackedPointers) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.TrackedPointers"))
}
function $isArrayOf_Lreactbuild_common_components_TrackedPointers(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_TrackedPointers)))
}
function $asArrayOf_Lreactbuild_common_components_TrackedPointers(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_TrackedPointers(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.TrackedPointers;", depth))
}
var $d_Lreactbuild_common_components_TrackedPointers = new $TypeData().initClass({
  Lreactbuild_common_components_TrackedPointers: 0
}, false, "reactbuild.common.components.TrackedPointers", {
  Lreactbuild_common_components_TrackedPointers: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_TrackedPointers.prototype.$classData = $d_Lreactbuild_common_components_TrackedPointers;
/** @constructor */
function $c_Lreactbuild_common_components_WallBuilder(shape, parent, matrix, components) {
  this.Lreactbuild_common_components_WallBuilder__f_shape = null;
  this.Lreactbuild_common_components_WallBuilder__f_parent = null;
  this.Lreactbuild_common_components_WallBuilder__f_matrix = null;
  this.Lreactbuild_common_components_WallBuilder__f_components = null;
  this.Lreactbuild_common_components_WallBuilder__f_shape = shape;
  this.Lreactbuild_common_components_WallBuilder__f_parent = parent;
  this.Lreactbuild_common_components_WallBuilder__f_matrix = matrix;
  this.Lreactbuild_common_components_WallBuilder__f_components = components
}
$c_Lreactbuild_common_components_WallBuilder.prototype = new $h_O();
$c_Lreactbuild_common_components_WallBuilder.prototype.constructor = $c_Lreactbuild_common_components_WallBuilder;
/** @constructor */
function $h_Lreactbuild_common_components_WallBuilder() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_WallBuilder.prototype = $c_Lreactbuild_common_components_WallBuilder.prototype;
$c_Lreactbuild_common_components_WallBuilder.prototype.productPrefix__T = (function() {
  return "WallBuilder"
});
$c_Lreactbuild_common_components_WallBuilder.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_common_components_WallBuilder.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_WallBuilder__f_shape;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_WallBuilder__f_parent;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_WallBuilder__f_matrix;
      break
    }
    case 3: {
      return this.Lreactbuild_common_components_WallBuilder__f_components;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_WallBuilder.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_WallBuilder.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_components_WallBuilder.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_WallBuilder.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_WallBuilder)) {
    var WallBuilder$1 = $as_Lreactbuild_common_components_WallBuilder(x$1);
    var x = this.Lreactbuild_common_components_WallBuilder__f_shape;
    var y = $n(WallBuilder$1).Lreactbuild_common_components_WallBuilder__f_shape;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_common_components_WallBuilder__f_parent;
      var y$1 = $n(WallBuilder$1).Lreactbuild_common_components_WallBuilder__f_parent;
      var $$x1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_common_components_WallBuilder__f_matrix;
      var y$2 = $n(WallBuilder$1).Lreactbuild_common_components_WallBuilder__f_matrix;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y$2)) {
        var x$4 = this.Lreactbuild_common_components_WallBuilder__f_components;
        var x$2$1 = $n(WallBuilder$1).Lreactbuild_common_components_WallBuilder__f_components;
        return ((x$4 === null) ? (x$2$1 === null) : $n(x$4).equals__O__Z(x$2$1))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_WallBuilder(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_WallBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.WallBuilder"))
}
function $isArrayOf_Lreactbuild_common_components_WallBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_WallBuilder)))
}
function $asArrayOf_Lreactbuild_common_components_WallBuilder(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_WallBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.WallBuilder;", depth))
}
var $d_Lreactbuild_common_components_WallBuilder = new $TypeData().initClass({
  Lreactbuild_common_components_WallBuilder: 0
}, false, "reactbuild.common.components.WallBuilder", {
  Lreactbuild_common_components_WallBuilder: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_WallBuilder.prototype.$classData = $d_Lreactbuild_common_components_WallBuilder;
/** @constructor */
function $c_Lreactbuild_common_model_Area(name, area) {
  this.Lreactbuild_common_model_Area__f_name = null;
  this.Lreactbuild_common_model_Area__f_area = 0.0;
  this.Lreactbuild_common_model_Area__f_name = name;
  this.Lreactbuild_common_model_Area__f_area = area
}
$c_Lreactbuild_common_model_Area.prototype = new $h_O();
$c_Lreactbuild_common_model_Area.prototype.constructor = $c_Lreactbuild_common_model_Area;
/** @constructor */
function $h_Lreactbuild_common_model_Area() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Area.prototype = $c_Lreactbuild_common_model_Area.prototype;
$c_Lreactbuild_common_model_Area.prototype.productPrefix__T = (function() {
  return "Area"
});
$c_Lreactbuild_common_model_Area.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_model_Area.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_Area__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_Area__f_area;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_Area.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_Area.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Area");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_common_model_Area__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_common_model_Area__f_area;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_common_model_Area.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_Area.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_Area)) {
    var Area$1 = $as_Lreactbuild_common_model_Area(x$1);
    return ((this.Lreactbuild_common_model_Area__f_area === $n(Area$1).Lreactbuild_common_model_Area__f_area) && (this.Lreactbuild_common_model_Area__f_name === $n(Area$1).Lreactbuild_common_model_Area__f_name))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_Area(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Area) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Area"))
}
function $isArrayOf_Lreactbuild_common_model_Area(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Area)))
}
function $asArrayOf_Lreactbuild_common_model_Area(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Area(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Area;", depth))
}
var $d_Lreactbuild_common_model_Area = new $TypeData().initClass({
  Lreactbuild_common_model_Area: 0
}, false, "reactbuild.common.model.Area", {
  Lreactbuild_common_model_Area: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Area.prototype.$classData = $d_Lreactbuild_common_model_Area;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDefinition(_id, name, category, details) {
  this.Lreactbuild_common_model_AssetDefinition__f__id = null;
  this.Lreactbuild_common_model_AssetDefinition__f_name = null;
  this.Lreactbuild_common_model_AssetDefinition__f_category = null;
  this.Lreactbuild_common_model_AssetDefinition__f_details = null;
  this.Lreactbuild_common_model_AssetDefinition__f__id = _id;
  this.Lreactbuild_common_model_AssetDefinition__f_name = name;
  this.Lreactbuild_common_model_AssetDefinition__f_category = category;
  this.Lreactbuild_common_model_AssetDefinition__f_details = details
}
$c_Lreactbuild_common_model_AssetDefinition.prototype = new $h_O();
$c_Lreactbuild_common_model_AssetDefinition.prototype.constructor = $c_Lreactbuild_common_model_AssetDefinition;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDefinition() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDefinition.prototype = $c_Lreactbuild_common_model_AssetDefinition.prototype;
$c_Lreactbuild_common_model_AssetDefinition.prototype.productPrefix__T = (function() {
  return "AssetDefinition"
});
$c_Lreactbuild_common_model_AssetDefinition.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_common_model_AssetDefinition.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_AssetDefinition__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_AssetDefinition__f_name;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_AssetDefinition__f_category;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_AssetDefinition__f_details;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_AssetDefinition.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_AssetDefinition.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_AssetDefinition.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_AssetDefinition.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_AssetDefinition)) {
    var AssetDefinition$1 = $as_Lreactbuild_common_model_AssetDefinition(x$1);
    var x = this.Lreactbuild_common_model_AssetDefinition__f__id;
    var x$2 = $n(AssetDefinition$1).Lreactbuild_common_model_AssetDefinition__f__id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_common_model_AssetDefinition__f_name === $n(AssetDefinition$1).Lreactbuild_common_model_AssetDefinition__f_name))) {
      if ((this.Lreactbuild_common_model_AssetDefinition__f_category === $n(AssetDefinition$1).Lreactbuild_common_model_AssetDefinition__f_category)) {
        var x$3 = this.Lreactbuild_common_model_AssetDefinition__f_details;
        var x$4 = $n(AssetDefinition$1).Lreactbuild_common_model_AssetDefinition__f_details;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_AssetDefinition(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_AssetDefinition) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.AssetDefinition"))
}
function $isArrayOf_Lreactbuild_common_model_AssetDefinition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_AssetDefinition)))
}
function $asArrayOf_Lreactbuild_common_model_AssetDefinition(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_AssetDefinition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.AssetDefinition;", depth))
}
var $d_Lreactbuild_common_model_AssetDefinition = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDefinition: 0
}, false, "reactbuild.common.model.AssetDefinition", {
  Lreactbuild_common_model_AssetDefinition: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDefinition.prototype.$classData = $d_Lreactbuild_common_model_AssetDefinition;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28(outer) {
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28__f_circeGenericDecoderForfile = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28__f_circeGenericDecoderForfile = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28.prototype.constructor = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28.prototype = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28.prototype;
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("file"))), this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28__f_circeGenericDecoderForfile, "file", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28: 0
}, false, "reactbuild.common.model.AssetDetails$anon$lazy$macro$159$1$$anon$28", {
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28.prototype.$classData = $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$28;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29(outer) {
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderForbaseColor = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderForbumpScale = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderFormap = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderForbaseColor = $m_Lreactbuild_common_model_Color$().Lreactbuild_common_model_Color$__f_decodeColor;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderForbumpScale = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderFormap = new $c_Lio_circe_Decoder$$anon$39(d)
}
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29.prototype.constructor = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29.prototype = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29.prototype;
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("baseColor"))), this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderForbaseColor, "baseColor", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("roughness"))), this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderForbumpScale, "roughness", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("bumpMap"))), this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderFormap, "bumpMap", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("bumpScale"))), this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderForbumpScale, "bumpScale", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("map"))), this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29__f_circeGenericDecoderFormap, "map", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29: 0
}, false, "reactbuild.common.model.AssetDetails$anon$lazy$macro$159$1$$anon$29", {
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29.prototype.$classData = $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$29;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30(outer) {
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30__f_circeGenericDecoderForfiles2d = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30__f_circeGenericDecoderForloader = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30__f_circeGenericDecoderForfiles2d = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30__f_circeGenericDecoderForloader = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30.prototype.constructor = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30.prototype = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30.prototype;
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("files3d"))), this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30__f_circeGenericDecoderForfiles2d, "files3d", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("files2d"))), this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30__f_circeGenericDecoderForfiles2d, "files2d", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("loader"))), this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30__f_circeGenericDecoderForloader, "loader", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30: 0
}, false, "reactbuild.common.model.AssetDetails$anon$lazy$macro$159$1$$anon$30", {
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30.prototype.$classData = $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$30;
/** @constructor */
function $c_Lreactbuild_common_model_CityCode(country, code) {
  this.Lreactbuild_common_model_CityCode__f_country = null;
  this.Lreactbuild_common_model_CityCode__f_code = null;
  this.Lreactbuild_common_model_CityCode__f_country = country;
  this.Lreactbuild_common_model_CityCode__f_code = code
}
$c_Lreactbuild_common_model_CityCode.prototype = new $h_O();
$c_Lreactbuild_common_model_CityCode.prototype.constructor = $c_Lreactbuild_common_model_CityCode;
/** @constructor */
function $h_Lreactbuild_common_model_CityCode() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_CityCode.prototype = $c_Lreactbuild_common_model_CityCode.prototype;
$c_Lreactbuild_common_model_CityCode.prototype.productPrefix__T = (function() {
  return "CityCode"
});
$c_Lreactbuild_common_model_CityCode.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_model_CityCode.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_CityCode__f_country;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_CityCode__f_code;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_CityCode.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_CityCode.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_CityCode.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_CityCode.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_CityCode)) {
    var CityCode$1 = $as_Lreactbuild_common_model_CityCode(x$1);
    var x = this.Lreactbuild_common_model_CityCode__f_country;
    var x$2 = $n(CityCode$1).Lreactbuild_common_model_CityCode__f_country;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      return (this.Lreactbuild_common_model_CityCode__f_code === $n(CityCode$1).Lreactbuild_common_model_CityCode__f_code)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_CityCode(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_CityCode) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.CityCode"))
}
function $isArrayOf_Lreactbuild_common_model_CityCode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_CityCode)))
}
function $asArrayOf_Lreactbuild_common_model_CityCode(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_CityCode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.CityCode;", depth))
}
var $d_Lreactbuild_common_model_CityCode = new $TypeData().initClass({
  Lreactbuild_common_model_CityCode: 0
}, false, "reactbuild.common.model.CityCode", {
  Lreactbuild_common_model_CityCode: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_CityCode.prototype.$classData = $d_Lreactbuild_common_model_CityCode;
/** @constructor */
function $c_Lreactbuild_common_model_Color(color) {
  this.Lreactbuild_common_model_Color__f_color = 0.0;
  this.Lreactbuild_common_model_Color__f_color = color
}
$c_Lreactbuild_common_model_Color.prototype = new $h_O();
$c_Lreactbuild_common_model_Color.prototype.constructor = $c_Lreactbuild_common_model_Color;
/** @constructor */
function $h_Lreactbuild_common_model_Color() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Color.prototype = $c_Lreactbuild_common_model_Color.prototype;
$c_Lreactbuild_common_model_Color.prototype.productPrefix__T = (function() {
  $m_Lreactbuild_common_model_Color$();
  return "Color"
});
$c_Lreactbuild_common_model_Color.prototype.productArity__I = (function() {
  $m_Lreactbuild_common_model_Color$();
  return 1
});
$c_Lreactbuild_common_model_Color.prototype.productElement__I__O = (function(x$1) {
  return $m_Lreactbuild_common_model_Color$().productElement$extension__D__I__O(this.Lreactbuild_common_model_Color__f_color, x$1)
});
$c_Lreactbuild_common_model_Color.prototype.productIterator__sc_Iterator = (function() {
  return $m_Lreactbuild_common_model_Color$().productIterator$extension__D__sc_Iterator(this.Lreactbuild_common_model_Color__f_color)
});
$c_Lreactbuild_common_model_Color.prototype.hashCode__I = (function() {
  $m_Lreactbuild_common_model_Color$();
  var this$ = this.Lreactbuild_common_model_Color__f_color;
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(this$)
});
$c_Lreactbuild_common_model_Color.prototype.equals__O__Z = (function(x$1) {
  return $m_Lreactbuild_common_model_Color$().equals$extension__D__O__Z(this.Lreactbuild_common_model_Color__f_color, x$1)
});
$c_Lreactbuild_common_model_Color.prototype.toString__T = (function() {
  return $m_Lreactbuild_common_model_Color$().toString$extension__D__T(this.Lreactbuild_common_model_Color__f_color)
});
function $as_Lreactbuild_common_model_Color(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Color) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Color"))
}
function $isArrayOf_Lreactbuild_common_model_Color(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Color)))
}
function $asArrayOf_Lreactbuild_common_model_Color(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Color(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Color;", depth))
}
var $d_Lreactbuild_common_model_Color = new $TypeData().initClass({
  Lreactbuild_common_model_Color: 0
}, false, "reactbuild.common.model.Color", {
  Lreactbuild_common_model_Color: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Color.prototype.$classData = $d_Lreactbuild_common_model_Color;
/** @constructor */
function $c_Lreactbuild_common_model_ComponentDetails$() {
  /*<skip>*/
}
$c_Lreactbuild_common_model_ComponentDetails$.prototype = new $h_sr_AbstractFunction3();
$c_Lreactbuild_common_model_ComponentDetails$.prototype.constructor = $c_Lreactbuild_common_model_ComponentDetails$;
/** @constructor */
function $h_Lreactbuild_common_model_ComponentDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ComponentDetails$.prototype = $c_Lreactbuild_common_model_ComponentDetails$.prototype;
$c_Lreactbuild_common_model_ComponentDetails$.prototype.toString__T = (function() {
  return "ComponentDetails"
});
$c_Lreactbuild_common_model_ComponentDetails$.prototype.apply__O__O__O__O = (function(v1, v2, v3) {
  var files3d = $as_sci_List(v1);
  var files2d = $as_sci_List(v2);
  var loader = $as_T(v3);
  return new $c_Lreactbuild_common_model_ComponentDetails(files3d, files2d, loader)
});
var $d_Lreactbuild_common_model_ComponentDetails$ = new $TypeData().initClass({
  Lreactbuild_common_model_ComponentDetails$: 0
}, false, "reactbuild.common.model.ComponentDetails$", {
  Lreactbuild_common_model_ComponentDetails$: 1,
  sr_AbstractFunction3: 1,
  O: 1,
  F3: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ComponentDetails$.prototype.$classData = $d_Lreactbuild_common_model_ComponentDetails$;
var $n_Lreactbuild_common_model_ComponentDetails$;
function $m_Lreactbuild_common_model_ComponentDetails$() {
  if ((!$n_Lreactbuild_common_model_ComponentDetails$)) {
    $n_Lreactbuild_common_model_ComponentDetails$ = new $c_Lreactbuild_common_model_ComponentDetails$()
  };
  return $n_Lreactbuild_common_model_ComponentDetails$
}
/** @constructor */
function $c_Lreactbuild_common_model_Coordinates(lon, lat) {
  this.Lreactbuild_common_model_Coordinates__f_lon = 0.0;
  this.Lreactbuild_common_model_Coordinates__f_lat = 0.0;
  this.Lreactbuild_common_model_Coordinates__f_lon = lon;
  this.Lreactbuild_common_model_Coordinates__f_lat = lat
}
$c_Lreactbuild_common_model_Coordinates.prototype = new $h_O();
$c_Lreactbuild_common_model_Coordinates.prototype.constructor = $c_Lreactbuild_common_model_Coordinates;
/** @constructor */
function $h_Lreactbuild_common_model_Coordinates() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Coordinates.prototype = $c_Lreactbuild_common_model_Coordinates.prototype;
$c_Lreactbuild_common_model_Coordinates.prototype.productPrefix__T = (function() {
  return "Coordinates"
});
$c_Lreactbuild_common_model_Coordinates.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_model_Coordinates.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_Coordinates__f_lon;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_Coordinates__f_lat;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_Coordinates.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_Coordinates.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Coordinates");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_common_model_Coordinates__f_lon;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_common_model_Coordinates__f_lat;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_common_model_Coordinates.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_Coordinates.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_Coordinates)) {
    var Coordinates$1 = $as_Lreactbuild_common_model_Coordinates(x$1);
    return ((this.Lreactbuild_common_model_Coordinates__f_lon === $n(Coordinates$1).Lreactbuild_common_model_Coordinates__f_lon) && (this.Lreactbuild_common_model_Coordinates__f_lat === $n(Coordinates$1).Lreactbuild_common_model_Coordinates__f_lat))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_Coordinates(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Coordinates) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Coordinates"))
}
function $isArrayOf_Lreactbuild_common_model_Coordinates(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Coordinates)))
}
function $asArrayOf_Lreactbuild_common_model_Coordinates(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Coordinates(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Coordinates;", depth))
}
var $d_Lreactbuild_common_model_Coordinates = new $TypeData().initClass({
  Lreactbuild_common_model_Coordinates: 0
}, false, "reactbuild.common.model.Coordinates", {
  Lreactbuild_common_model_Coordinates: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Coordinates.prototype.$classData = $d_Lreactbuild_common_model_Coordinates;
/** @constructor */
function $c_Lreactbuild_common_model_Date(value) {
  this.Lreactbuild_common_model_Date__f_value = $L0;
  this.Lreactbuild_common_model_Date__f_value = value
}
$c_Lreactbuild_common_model_Date.prototype = new $h_O();
$c_Lreactbuild_common_model_Date.prototype.constructor = $c_Lreactbuild_common_model_Date;
/** @constructor */
function $h_Lreactbuild_common_model_Date() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Date.prototype = $c_Lreactbuild_common_model_Date.prototype;
$c_Lreactbuild_common_model_Date.prototype.toLocalDate__Ljava_time_LocalDate = (function() {
  var this$2 = this.Lreactbuild_common_model_Date__f_value;
  var value = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_reactbuild$common$model$Date$$dateDayConstant;
  var hi = (value >> 31);
  var this$3 = $m_RTLong$();
  var lo = this$3.divideImpl__I__I__I__I__I(this$2.RTLong__f_lo, this$2.RTLong__f_hi, value, hi);
  var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi$1))
});
$c_Lreactbuild_common_model_Date.prototype.productPrefix__T = (function() {
  return "Date"
});
$c_Lreactbuild_common_model_Date.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_model_Date.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_model_Date__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_model_Date.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_Date.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Date");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lreactbuild_common_model_Date__f_value;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_common_model_Date.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_Date.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_Date)) {
    var Date$1 = $as_Lreactbuild_common_model_Date(x$1);
    var this$1 = this.Lreactbuild_common_model_Date__f_value;
    var b = $n(Date$1).Lreactbuild_common_model_Date__f_value;
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_Date(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Date) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Date"))
}
function $isArrayOf_Lreactbuild_common_model_Date(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Date)))
}
function $asArrayOf_Lreactbuild_common_model_Date(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Date(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Date;", depth))
}
var $d_Lreactbuild_common_model_Date = new $TypeData().initClass({
  Lreactbuild_common_model_Date: 0
}, false, "reactbuild.common.model.Date", {
  Lreactbuild_common_model_Date: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Date.prototype.$classData = $d_Lreactbuild_common_model_Date;
/** @constructor */
function $c_Lreactbuild_common_model_DeployableWebsite(name, home, contact, username, password, url, head) {
  this.Lreactbuild_common_model_DeployableWebsite__f_name = null;
  this.Lreactbuild_common_model_DeployableWebsite__f_home = null;
  this.Lreactbuild_common_model_DeployableWebsite__f_contact = null;
  this.Lreactbuild_common_model_DeployableWebsite__f_username = null;
  this.Lreactbuild_common_model_DeployableWebsite__f_password = null;
  this.Lreactbuild_common_model_DeployableWebsite__f_url = null;
  this.Lreactbuild_common_model_DeployableWebsite__f_head = null;
  this.Lreactbuild_common_model_DeployableWebsite__f_name = name;
  this.Lreactbuild_common_model_DeployableWebsite__f_home = home;
  this.Lreactbuild_common_model_DeployableWebsite__f_contact = contact;
  this.Lreactbuild_common_model_DeployableWebsite__f_username = username;
  this.Lreactbuild_common_model_DeployableWebsite__f_password = password;
  this.Lreactbuild_common_model_DeployableWebsite__f_url = url;
  this.Lreactbuild_common_model_DeployableWebsite__f_head = head
}
$c_Lreactbuild_common_model_DeployableWebsite.prototype = new $h_O();
$c_Lreactbuild_common_model_DeployableWebsite.prototype.constructor = $c_Lreactbuild_common_model_DeployableWebsite;
/** @constructor */
function $h_Lreactbuild_common_model_DeployableWebsite() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_DeployableWebsite.prototype = $c_Lreactbuild_common_model_DeployableWebsite.prototype;
$c_Lreactbuild_common_model_DeployableWebsite.prototype.productPrefix__T = (function() {
  return "DeployableWebsite"
});
$c_Lreactbuild_common_model_DeployableWebsite.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_common_model_DeployableWebsite.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_DeployableWebsite__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_DeployableWebsite__f_home;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_DeployableWebsite__f_contact;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_DeployableWebsite__f_username;
      break
    }
    case 4: {
      return this.Lreactbuild_common_model_DeployableWebsite__f_password;
      break
    }
    case 5: {
      return this.Lreactbuild_common_model_DeployableWebsite__f_url;
      break
    }
    case 6: {
      return this.Lreactbuild_common_model_DeployableWebsite__f_head;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_DeployableWebsite.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_DeployableWebsite.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_DeployableWebsite.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_DeployableWebsite.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_DeployableWebsite)) {
    var DeployableWebsite$1 = $as_Lreactbuild_common_model_DeployableWebsite(x$1);
    if ((this.Lreactbuild_common_model_DeployableWebsite__f_name === $n(DeployableWebsite$1).Lreactbuild_common_model_DeployableWebsite__f_name)) {
      var x = this.Lreactbuild_common_model_DeployableWebsite__f_home;
      var x$2 = $n(DeployableWebsite$1).Lreactbuild_common_model_DeployableWebsite__f_home;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_common_model_DeployableWebsite__f_contact;
        var x$4 = $n(DeployableWebsite$1).Lreactbuild_common_model_DeployableWebsite__f_contact;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_common_model_DeployableWebsite__f_username;
      var x$6 = $n(DeployableWebsite$1).Lreactbuild_common_model_DeployableWebsite__f_username;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_common_model_DeployableWebsite__f_password;
        var x$8 = $n(DeployableWebsite$1).Lreactbuild_common_model_DeployableWebsite__f_password;
        var $$x2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$9 = this.Lreactbuild_common_model_DeployableWebsite__f_url;
        var x$10 = $n(DeployableWebsite$1).Lreactbuild_common_model_DeployableWebsite__f_url;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_common_model_DeployableWebsite__f_head;
          var x$12 = $n(DeployableWebsite$1).Lreactbuild_common_model_DeployableWebsite__f_head;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_DeployableWebsite(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_DeployableWebsite) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.DeployableWebsite"))
}
function $isArrayOf_Lreactbuild_common_model_DeployableWebsite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_DeployableWebsite)))
}
function $asArrayOf_Lreactbuild_common_model_DeployableWebsite(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_DeployableWebsite(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.DeployableWebsite;", depth))
}
var $d_Lreactbuild_common_model_DeployableWebsite = new $TypeData().initClass({
  Lreactbuild_common_model_DeployableWebsite: 0
}, false, "reactbuild.common.model.DeployableWebsite", {
  Lreactbuild_common_model_DeployableWebsite: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_DeployableWebsite.prototype.$classData = $d_Lreactbuild_common_model_DeployableWebsite;
/** @constructor */
function $c_Lreactbuild_common_model_Edge(_id, created, from, to, label, attributes) {
  this.Lreactbuild_common_model_Edge__f__id = null;
  this.Lreactbuild_common_model_Edge__f_created = null;
  this.Lreactbuild_common_model_Edge__f_from = null;
  this.Lreactbuild_common_model_Edge__f_to = null;
  this.Lreactbuild_common_model_Edge__f_label = null;
  this.Lreactbuild_common_model_Edge__f_attributes = null;
  this.Lreactbuild_common_model_Edge__f__id = _id;
  this.Lreactbuild_common_model_Edge__f_created = created;
  this.Lreactbuild_common_model_Edge__f_from = from;
  this.Lreactbuild_common_model_Edge__f_to = to;
  this.Lreactbuild_common_model_Edge__f_label = label;
  this.Lreactbuild_common_model_Edge__f_attributes = attributes
}
$c_Lreactbuild_common_model_Edge.prototype = new $h_O();
$c_Lreactbuild_common_model_Edge.prototype.constructor = $c_Lreactbuild_common_model_Edge;
/** @constructor */
function $h_Lreactbuild_common_model_Edge() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Edge.prototype = $c_Lreactbuild_common_model_Edge.prototype;
$c_Lreactbuild_common_model_Edge.prototype.productPrefix__T = (function() {
  return "Edge"
});
$c_Lreactbuild_common_model_Edge.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_common_model_Edge.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_Edge__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_Edge__f_created;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_Edge__f_from;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_Edge__f_to;
      break
    }
    case 4: {
      return this.Lreactbuild_common_model_Edge__f_label;
      break
    }
    case 5: {
      return this.Lreactbuild_common_model_Edge__f_attributes;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_Edge.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_Edge.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_Edge.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_Edge.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_Edge)) {
    var Edge$1 = $as_Lreactbuild_common_model_Edge(x$1);
    var x = this.Lreactbuild_common_model_Edge__f__id;
    var x$2 = $n(Edge$1).Lreactbuild_common_model_Edge__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_model_Edge__f_created;
      var x$4 = $n(Edge$1).Lreactbuild_common_model_Edge__f_created;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_common_model_Edge__f_from;
        var x$6 = $n(Edge$1).Lreactbuild_common_model_Edge__f_from;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_common_model_Edge__f_to;
      var x$8 = $n(Edge$1).Lreactbuild_common_model_Edge__f_to;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        if ((this.Lreactbuild_common_model_Edge__f_label === $n(Edge$1).Lreactbuild_common_model_Edge__f_label)) {
          var x$9 = this.Lreactbuild_common_model_Edge__f_attributes;
          var x$10 = $n(Edge$1).Lreactbuild_common_model_Edge__f_attributes;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_Edge(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Edge) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Edge"))
}
function $isArrayOf_Lreactbuild_common_model_Edge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Edge)))
}
function $asArrayOf_Lreactbuild_common_model_Edge(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Edge(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Edge;", depth))
}
var $d_Lreactbuild_common_model_Edge = new $TypeData().initClass({
  Lreactbuild_common_model_Edge: 0
}, false, "reactbuild.common.model.Edge", {
  Lreactbuild_common_model_Edge: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Edge.prototype.$classData = $d_Lreactbuild_common_model_Edge;
/** @constructor */
function $c_Lreactbuild_common_model_File(_id, organization, name, contentType, savedAt) {
  this.Lreactbuild_common_model_File__f__id = null;
  this.Lreactbuild_common_model_File__f_organization = null;
  this.Lreactbuild_common_model_File__f_name = null;
  this.Lreactbuild_common_model_File__f_contentType = null;
  this.Lreactbuild_common_model_File__f_savedAt = null;
  this.Lreactbuild_common_model_File__f__id = _id;
  this.Lreactbuild_common_model_File__f_organization = organization;
  this.Lreactbuild_common_model_File__f_name = name;
  this.Lreactbuild_common_model_File__f_contentType = contentType;
  this.Lreactbuild_common_model_File__f_savedAt = savedAt
}
$c_Lreactbuild_common_model_File.prototype = new $h_O();
$c_Lreactbuild_common_model_File.prototype.constructor = $c_Lreactbuild_common_model_File;
/** @constructor */
function $h_Lreactbuild_common_model_File() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_File.prototype = $c_Lreactbuild_common_model_File.prototype;
$c_Lreactbuild_common_model_File.prototype.productPrefix__T = (function() {
  return "File"
});
$c_Lreactbuild_common_model_File.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_common_model_File.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_File__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_File__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_File__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_File__f_contentType;
      break
    }
    case 4: {
      return this.Lreactbuild_common_model_File__f_savedAt;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_File.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_File.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_File.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_File.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_File)) {
    var File$1 = $as_Lreactbuild_common_model_File(x$1);
    var x = this.Lreactbuild_common_model_File__f__id;
    var x$2 = $n(File$1).Lreactbuild_common_model_File__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_model_File__f_organization;
      var x$4 = $n(File$1).Lreactbuild_common_model_File__f_organization;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_common_model_File__f_name === $n(File$1).Lreactbuild_common_model_File__f_name)) {
        var x$5 = this.Lreactbuild_common_model_File__f_contentType;
        var x$6 = $n(File$1).Lreactbuild_common_model_File__f_contentType;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var x$7 = this.Lreactbuild_common_model_File__f_savedAt;
          var x$8 = $n(File$1).Lreactbuild_common_model_File__f_savedAt;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_File(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_File) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.File"))
}
function $isArrayOf_Lreactbuild_common_model_File(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_File)))
}
function $asArrayOf_Lreactbuild_common_model_File(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_File(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.File;", depth))
}
var $d_Lreactbuild_common_model_File = new $TypeData().initClass({
  Lreactbuild_common_model_File: 0
}, false, "reactbuild.common.model.File", {
  Lreactbuild_common_model_File: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_File.prototype.$classData = $d_Lreactbuild_common_model_File;
/** @constructor */
function $c_Lreactbuild_common_model_Image(url, width, height, title, markers) {
  this.Lreactbuild_common_model_Image__f_url = null;
  this.Lreactbuild_common_model_Image__f_width = 0;
  this.Lreactbuild_common_model_Image__f_height = 0;
  this.Lreactbuild_common_model_Image__f_title = null;
  this.Lreactbuild_common_model_Image__f_markers = null;
  this.Lreactbuild_common_model_Image__f_url = url;
  this.Lreactbuild_common_model_Image__f_width = width;
  this.Lreactbuild_common_model_Image__f_height = height;
  this.Lreactbuild_common_model_Image__f_title = title;
  this.Lreactbuild_common_model_Image__f_markers = markers
}
$c_Lreactbuild_common_model_Image.prototype = new $h_O();
$c_Lreactbuild_common_model_Image.prototype.constructor = $c_Lreactbuild_common_model_Image;
/** @constructor */
function $h_Lreactbuild_common_model_Image() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Image.prototype = $c_Lreactbuild_common_model_Image.prototype;
$c_Lreactbuild_common_model_Image.prototype.fullPath__T__T = (function(scheme) {
  return ((scheme + "//cellar-c2.services.clever-cloud.com/cdn.reactbuild.com/") + this.Lreactbuild_common_model_Image__f_url)
});
$c_Lreactbuild_common_model_Image.prototype.productPrefix__T = (function() {
  return "Image"
});
$c_Lreactbuild_common_model_Image.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_common_model_Image.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_Image__f_url;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_Image__f_width;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_Image__f_height;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_Image__f_title;
      break
    }
    case 4: {
      return this.Lreactbuild_common_model_Image__f_markers;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_Image.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_Image.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Image");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_common_model_Image__f_url;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lreactbuild_common_model_Image__f_width;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lreactbuild_common_model_Image__f_height;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$1 = this.Lreactbuild_common_model_Image__f_title;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$2 = this.Lreactbuild_common_model_Image__f_markers;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_common_model_Image.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_Image.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_Image)) {
    var Image$1 = $as_Lreactbuild_common_model_Image(x$1);
    if (((this.Lreactbuild_common_model_Image__f_width === $n(Image$1).Lreactbuild_common_model_Image__f_width) && (this.Lreactbuild_common_model_Image__f_height === $n(Image$1).Lreactbuild_common_model_Image__f_height))) {
      if ((this.Lreactbuild_common_model_Image__f_url === $n(Image$1).Lreactbuild_common_model_Image__f_url)) {
        if ((this.Lreactbuild_common_model_Image__f_title === $n(Image$1).Lreactbuild_common_model_Image__f_title)) {
          var x = this.Lreactbuild_common_model_Image__f_markers;
          var x$2 = $n(Image$1).Lreactbuild_common_model_Image__f_markers;
          return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_Image(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Image) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Image"))
}
function $isArrayOf_Lreactbuild_common_model_Image(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Image)))
}
function $asArrayOf_Lreactbuild_common_model_Image(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Image(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Image;", depth))
}
var $d_Lreactbuild_common_model_Image = new $TypeData().initClass({
  Lreactbuild_common_model_Image: 0
}, false, "reactbuild.common.model.Image", {
  Lreactbuild_common_model_Image: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Image.prototype.$classData = $d_Lreactbuild_common_model_Image;
/** @constructor */
function $c_Lreactbuild_common_model_ListProjects(logged, projects) {
  this.Lreactbuild_common_model_ListProjects__f_logged = null;
  this.Lreactbuild_common_model_ListProjects__f_projects = null;
  this.Lreactbuild_common_model_ListProjects__f_logged = logged;
  this.Lreactbuild_common_model_ListProjects__f_projects = projects
}
$c_Lreactbuild_common_model_ListProjects.prototype = new $h_O();
$c_Lreactbuild_common_model_ListProjects.prototype.constructor = $c_Lreactbuild_common_model_ListProjects;
/** @constructor */
function $h_Lreactbuild_common_model_ListProjects() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ListProjects.prototype = $c_Lreactbuild_common_model_ListProjects.prototype;
$c_Lreactbuild_common_model_ListProjects.prototype.productPrefix__T = (function() {
  return "ListProjects"
});
$c_Lreactbuild_common_model_ListProjects.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_model_ListProjects.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_ListProjects__f_logged;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_ListProjects__f_projects;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_ListProjects.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_ListProjects.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_ListProjects.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_ListProjects.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_ListProjects)) {
    var ListProjects$1 = $as_Lreactbuild_common_model_ListProjects(x$1);
    var x = this.Lreactbuild_common_model_ListProjects__f_logged;
    var x$2 = $n(ListProjects$1).Lreactbuild_common_model_ListProjects__f_logged;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_model_ListProjects__f_projects;
      var x$4 = $n(ListProjects$1).Lreactbuild_common_model_ListProjects__f_projects;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_ListProjects(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_ListProjects) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.ListProjects"))
}
function $isArrayOf_Lreactbuild_common_model_ListProjects(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_ListProjects)))
}
function $asArrayOf_Lreactbuild_common_model_ListProjects(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_ListProjects(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.ListProjects;", depth))
}
var $d_Lreactbuild_common_model_ListProjects = new $TypeData().initClass({
  Lreactbuild_common_model_ListProjects: 0
}, false, "reactbuild.common.model.ListProjects", {
  Lreactbuild_common_model_ListProjects: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ListProjects.prototype.$classData = $d_Lreactbuild_common_model_ListProjects;
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUser(_id, email, name, avatar) {
  this.Lreactbuild_common_model_LoggedUser__f__id = null;
  this.Lreactbuild_common_model_LoggedUser__f_email = null;
  this.Lreactbuild_common_model_LoggedUser__f_name = null;
  this.Lreactbuild_common_model_LoggedUser__f_avatar = null;
  this.Lreactbuild_common_model_LoggedUser__f__id = _id;
  this.Lreactbuild_common_model_LoggedUser__f_email = email;
  this.Lreactbuild_common_model_LoggedUser__f_name = name;
  this.Lreactbuild_common_model_LoggedUser__f_avatar = avatar
}
$c_Lreactbuild_common_model_LoggedUser.prototype = new $h_O();
$c_Lreactbuild_common_model_LoggedUser.prototype.constructor = $c_Lreactbuild_common_model_LoggedUser;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUser() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUser.prototype = $c_Lreactbuild_common_model_LoggedUser.prototype;
$c_Lreactbuild_common_model_LoggedUser.prototype.productPrefix__T = (function() {
  return "LoggedUser"
});
$c_Lreactbuild_common_model_LoggedUser.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_common_model_LoggedUser.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_LoggedUser__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_LoggedUser__f_email;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_LoggedUser__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_LoggedUser__f_avatar;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_LoggedUser.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_LoggedUser.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_LoggedUser.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_LoggedUser.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_LoggedUser)) {
    var LoggedUser$1 = $as_Lreactbuild_common_model_LoggedUser(x$1);
    var x = this.Lreactbuild_common_model_LoggedUser__f__id;
    var x$2 = $n(LoggedUser$1).Lreactbuild_common_model_LoggedUser__f__id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_common_model_LoggedUser__f_email === $n(LoggedUser$1).Lreactbuild_common_model_LoggedUser__f_email))) {
      return ((this.Lreactbuild_common_model_LoggedUser__f_name === $n(LoggedUser$1).Lreactbuild_common_model_LoggedUser__f_name) && (this.Lreactbuild_common_model_LoggedUser__f_avatar === $n(LoggedUser$1).Lreactbuild_common_model_LoggedUser__f_avatar))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_LoggedUser(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_LoggedUser) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.LoggedUser"))
}
function $isArrayOf_Lreactbuild_common_model_LoggedUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_LoggedUser)))
}
function $asArrayOf_Lreactbuild_common_model_LoggedUser(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_LoggedUser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.LoggedUser;", depth))
}
var $d_Lreactbuild_common_model_LoggedUser = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUser: 0
}, false, "reactbuild.common.model.LoggedUser", {
  Lreactbuild_common_model_LoggedUser: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_LoggedUser.prototype.$classData = $d_Lreactbuild_common_model_LoggedUser;
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUserOrganization(_id, path, name, organizationUser) {
  this.Lreactbuild_common_model_LoggedUserOrganization__f__id = null;
  this.Lreactbuild_common_model_LoggedUserOrganization__f_path = null;
  this.Lreactbuild_common_model_LoggedUserOrganization__f_name = null;
  this.Lreactbuild_common_model_LoggedUserOrganization__f_organizationUser = null;
  this.Lreactbuild_common_model_LoggedUserOrganization__f__id = _id;
  this.Lreactbuild_common_model_LoggedUserOrganization__f_path = path;
  this.Lreactbuild_common_model_LoggedUserOrganization__f_name = name;
  this.Lreactbuild_common_model_LoggedUserOrganization__f_organizationUser = organizationUser
}
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype = new $h_O();
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype.constructor = $c_Lreactbuild_common_model_LoggedUserOrganization;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUserOrganization() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUserOrganization.prototype = $c_Lreactbuild_common_model_LoggedUserOrganization.prototype;
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype.productPrefix__T = (function() {
  return "LoggedUserOrganization"
});
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_LoggedUserOrganization__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_LoggedUserOrganization__f_path;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_LoggedUserOrganization__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_LoggedUserOrganization__f_organizationUser;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_LoggedUserOrganization)) {
    var LoggedUserOrganization$1 = $as_Lreactbuild_common_model_LoggedUserOrganization(x$1);
    var x = this.Lreactbuild_common_model_LoggedUserOrganization__f__id;
    var x$2 = $n(LoggedUserOrganization$1).Lreactbuild_common_model_LoggedUserOrganization__f__id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_common_model_LoggedUserOrganization__f_path === $n(LoggedUserOrganization$1).Lreactbuild_common_model_LoggedUserOrganization__f_path))) {
      var x$3 = this.Lreactbuild_common_model_LoggedUserOrganization__f_name;
      var x$4 = $n(LoggedUserOrganization$1).Lreactbuild_common_model_LoggedUserOrganization__f_name;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_common_model_LoggedUserOrganization__f_organizationUser;
        var x$6 = $n(LoggedUserOrganization$1).Lreactbuild_common_model_LoggedUserOrganization__f_organizationUser;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_LoggedUserOrganization(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_LoggedUserOrganization) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.LoggedUserOrganization"))
}
function $isArrayOf_Lreactbuild_common_model_LoggedUserOrganization(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_LoggedUserOrganization)))
}
function $asArrayOf_Lreactbuild_common_model_LoggedUserOrganization(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_LoggedUserOrganization(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.LoggedUserOrganization;", depth))
}
var $d_Lreactbuild_common_model_LoggedUserOrganization = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUserOrganization: 0
}, false, "reactbuild.common.model.LoggedUserOrganization", {
  Lreactbuild_common_model_LoggedUserOrganization: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_LoggedUserOrganization.prototype.$classData = $d_Lreactbuild_common_model_LoggedUserOrganization;
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUserWithOrganizations(user, organizations) {
  this.Lreactbuild_common_model_LoggedUserWithOrganizations__f_user = null;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations = null;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations__f_user = user;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations = organizations
}
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype = new $h_O();
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype.constructor = $c_Lreactbuild_common_model_LoggedUserWithOrganizations;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUserWithOrganizations() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype = $c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype;
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype.productPrefix__T = (function() {
  return "LoggedUserWithOrganizations"
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_LoggedUserWithOrganizations__f_user;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_LoggedUserWithOrganizations)) {
    var LoggedUserWithOrganizations$1 = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(x$1);
    var x = this.Lreactbuild_common_model_LoggedUserWithOrganizations__f_user;
    var x$2 = $n(LoggedUserWithOrganizations$1).Lreactbuild_common_model_LoggedUserWithOrganizations__f_user;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations;
      var x$4 = $n(LoggedUserWithOrganizations$1).Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_LoggedUserWithOrganizations(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_LoggedUserWithOrganizations) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.LoggedUserWithOrganizations"))
}
function $isArrayOf_Lreactbuild_common_model_LoggedUserWithOrganizations(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_LoggedUserWithOrganizations)))
}
function $asArrayOf_Lreactbuild_common_model_LoggedUserWithOrganizations(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_LoggedUserWithOrganizations(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.LoggedUserWithOrganizations;", depth))
}
var $d_Lreactbuild_common_model_LoggedUserWithOrganizations = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUserWithOrganizations: 0
}, false, "reactbuild.common.model.LoggedUserWithOrganizations", {
  Lreactbuild_common_model_LoggedUserWithOrganizations: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations.prototype.$classData = $d_Lreactbuild_common_model_LoggedUserWithOrganizations;
/** @constructor */
function $c_Lreactbuild_common_model_Organization(_id, path, name, settings) {
  this.Lreactbuild_common_model_Organization__f__id = null;
  this.Lreactbuild_common_model_Organization__f_path = null;
  this.Lreactbuild_common_model_Organization__f_name = null;
  this.Lreactbuild_common_model_Organization__f_settings = null;
  this.Lreactbuild_common_model_Organization__f__id = _id;
  this.Lreactbuild_common_model_Organization__f_path = path;
  this.Lreactbuild_common_model_Organization__f_name = name;
  this.Lreactbuild_common_model_Organization__f_settings = settings
}
$c_Lreactbuild_common_model_Organization.prototype = new $h_O();
$c_Lreactbuild_common_model_Organization.prototype.constructor = $c_Lreactbuild_common_model_Organization;
/** @constructor */
function $h_Lreactbuild_common_model_Organization() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Organization.prototype = $c_Lreactbuild_common_model_Organization.prototype;
$c_Lreactbuild_common_model_Organization.prototype.productPrefix__T = (function() {
  return "Organization"
});
$c_Lreactbuild_common_model_Organization.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_common_model_Organization.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_Organization__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_Organization__f_path;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_Organization__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_Organization__f_settings;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_Organization.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_Organization.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_Organization.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_Organization.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_Organization)) {
    var Organization$1 = $as_Lreactbuild_common_model_Organization(x$1);
    var x = this.Lreactbuild_common_model_Organization__f__id;
    var x$2 = $n(Organization$1).Lreactbuild_common_model_Organization__f__id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_common_model_Organization__f_path === $n(Organization$1).Lreactbuild_common_model_Organization__f_path))) {
      var x$3 = this.Lreactbuild_common_model_Organization__f_name;
      var x$4 = $n(Organization$1).Lreactbuild_common_model_Organization__f_name;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_common_model_Organization__f_settings;
        var x$6 = $n(Organization$1).Lreactbuild_common_model_Organization__f_settings;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_Organization(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Organization) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Organization"))
}
function $isArrayOf_Lreactbuild_common_model_Organization(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Organization)))
}
function $asArrayOf_Lreactbuild_common_model_Organization(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Organization(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Organization;", depth))
}
var $d_Lreactbuild_common_model_Organization = new $TypeData().initClass({
  Lreactbuild_common_model_Organization: 0
}, false, "reactbuild.common.model.Organization", {
  Lreactbuild_common_model_Organization: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Organization.prototype.$classData = $d_Lreactbuild_common_model_Organization;
/** @constructor */
function $c_Lreactbuild_common_model_OrganizationSettings(usersNotifiedByIncomingCommunication) {
  this.Lreactbuild_common_model_OrganizationSettings__f_usersNotifiedByIncomingCommunication = null;
  this.Lreactbuild_common_model_OrganizationSettings__f_usersNotifiedByIncomingCommunication = usersNotifiedByIncomingCommunication
}
$c_Lreactbuild_common_model_OrganizationSettings.prototype = new $h_O();
$c_Lreactbuild_common_model_OrganizationSettings.prototype.constructor = $c_Lreactbuild_common_model_OrganizationSettings;
/** @constructor */
function $h_Lreactbuild_common_model_OrganizationSettings() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_OrganizationSettings.prototype = $c_Lreactbuild_common_model_OrganizationSettings.prototype;
$c_Lreactbuild_common_model_OrganizationSettings.prototype.productPrefix__T = (function() {
  return "OrganizationSettings"
});
$c_Lreactbuild_common_model_OrganizationSettings.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_model_OrganizationSettings.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_model_OrganizationSettings__f_usersNotifiedByIncomingCommunication : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_model_OrganizationSettings.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_OrganizationSettings.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_OrganizationSettings.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_OrganizationSettings.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_OrganizationSettings)) {
    var OrganizationSettings$1 = $as_Lreactbuild_common_model_OrganizationSettings(x$1);
    var x = this.Lreactbuild_common_model_OrganizationSettings__f_usersNotifiedByIncomingCommunication;
    var x$2 = $n(OrganizationSettings$1).Lreactbuild_common_model_OrganizationSettings__f_usersNotifiedByIncomingCommunication;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_OrganizationSettings(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_OrganizationSettings) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.OrganizationSettings"))
}
function $isArrayOf_Lreactbuild_common_model_OrganizationSettings(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_OrganizationSettings)))
}
function $asArrayOf_Lreactbuild_common_model_OrganizationSettings(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_OrganizationSettings(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.OrganizationSettings;", depth))
}
var $d_Lreactbuild_common_model_OrganizationSettings = new $TypeData().initClass({
  Lreactbuild_common_model_OrganizationSettings: 0
}, false, "reactbuild.common.model.OrganizationSettings", {
  Lreactbuild_common_model_OrganizationSettings: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_OrganizationSettings.prototype.$classData = $d_Lreactbuild_common_model_OrganizationSettings;
/** @constructor */
function $c_Lreactbuild_common_model_OrganizationUser(_id, organization, email, name) {
  this.Lreactbuild_common_model_OrganizationUser__f__id = null;
  this.Lreactbuild_common_model_OrganizationUser__f_organization = null;
  this.Lreactbuild_common_model_OrganizationUser__f_email = null;
  this.Lreactbuild_common_model_OrganizationUser__f_name = null;
  this.Lreactbuild_common_model_OrganizationUser__f__id = _id;
  this.Lreactbuild_common_model_OrganizationUser__f_organization = organization;
  this.Lreactbuild_common_model_OrganizationUser__f_email = email;
  this.Lreactbuild_common_model_OrganizationUser__f_name = name
}
$c_Lreactbuild_common_model_OrganizationUser.prototype = new $h_O();
$c_Lreactbuild_common_model_OrganizationUser.prototype.constructor = $c_Lreactbuild_common_model_OrganizationUser;
/** @constructor */
function $h_Lreactbuild_common_model_OrganizationUser() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_OrganizationUser.prototype = $c_Lreactbuild_common_model_OrganizationUser.prototype;
$c_Lreactbuild_common_model_OrganizationUser.prototype.productPrefix__T = (function() {
  return "OrganizationUser"
});
$c_Lreactbuild_common_model_OrganizationUser.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_common_model_OrganizationUser.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_OrganizationUser__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_OrganizationUser__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_OrganizationUser__f_email;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_OrganizationUser__f_name;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_OrganizationUser.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_OrganizationUser.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_OrganizationUser.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_OrganizationUser.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_OrganizationUser)) {
    var OrganizationUser$1 = $as_Lreactbuild_common_model_OrganizationUser(x$1);
    var x = this.Lreactbuild_common_model_OrganizationUser__f__id;
    var x$2 = $n(OrganizationUser$1).Lreactbuild_common_model_OrganizationUser__f__id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_common_model_OrganizationUser__f_organization === $n(OrganizationUser$1).Lreactbuild_common_model_OrganizationUser__f_organization))) {
      if ((this.Lreactbuild_common_model_OrganizationUser__f_email === $n(OrganizationUser$1).Lreactbuild_common_model_OrganizationUser__f_email)) {
        var x$3 = this.Lreactbuild_common_model_OrganizationUser__f_name;
        var x$4 = $n(OrganizationUser$1).Lreactbuild_common_model_OrganizationUser__f_name;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_OrganizationUser(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_OrganizationUser) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.OrganizationUser"))
}
function $isArrayOf_Lreactbuild_common_model_OrganizationUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_OrganizationUser)))
}
function $asArrayOf_Lreactbuild_common_model_OrganizationUser(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_OrganizationUser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.OrganizationUser;", depth))
}
var $d_Lreactbuild_common_model_OrganizationUser = new $TypeData().initClass({
  Lreactbuild_common_model_OrganizationUser: 0
}, false, "reactbuild.common.model.OrganizationUser", {
  Lreactbuild_common_model_OrganizationUser: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_OrganizationUser.prototype.$classData = $d_Lreactbuild_common_model_OrganizationUser;
/** @constructor */
function $c_Lreactbuild_common_model_Project(_id, organizations, name, title, description, images, location, areas, price, soldOut, privacy, scenes, renderSettings, city, district, topic, modelSource, procedureState, summary, archived, parent, address, reference) {
  this.Lreactbuild_common_model_Project__f__id = null;
  this.Lreactbuild_common_model_Project__f_organizations = null;
  this.Lreactbuild_common_model_Project__f_name = null;
  this.Lreactbuild_common_model_Project__f_title = null;
  this.Lreactbuild_common_model_Project__f_description = null;
  this.Lreactbuild_common_model_Project__f_images = null;
  this.Lreactbuild_common_model_Project__f_location = null;
  this.Lreactbuild_common_model_Project__f_areas = null;
  this.Lreactbuild_common_model_Project__f_price = null;
  this.Lreactbuild_common_model_Project__f_soldOut = null;
  this.Lreactbuild_common_model_Project__f_privacy = null;
  this.Lreactbuild_common_model_Project__f_scenes = null;
  this.Lreactbuild_common_model_Project__f_renderSettings = null;
  this.Lreactbuild_common_model_Project__f_city = null;
  this.Lreactbuild_common_model_Project__f_district = null;
  this.Lreactbuild_common_model_Project__f_topic = null;
  this.Lreactbuild_common_model_Project__f_modelSource = null;
  this.Lreactbuild_common_model_Project__f_procedureState = null;
  this.Lreactbuild_common_model_Project__f_summary = null;
  this.Lreactbuild_common_model_Project__f_archived = null;
  this.Lreactbuild_common_model_Project__f_parent = null;
  this.Lreactbuild_common_model_Project__f_address = null;
  this.Lreactbuild_common_model_Project__f_reference = null;
  this.Lreactbuild_common_model_Project__f__id = _id;
  this.Lreactbuild_common_model_Project__f_organizations = organizations;
  this.Lreactbuild_common_model_Project__f_name = name;
  this.Lreactbuild_common_model_Project__f_title = title;
  this.Lreactbuild_common_model_Project__f_description = description;
  this.Lreactbuild_common_model_Project__f_images = images;
  this.Lreactbuild_common_model_Project__f_location = location;
  this.Lreactbuild_common_model_Project__f_areas = areas;
  this.Lreactbuild_common_model_Project__f_price = price;
  this.Lreactbuild_common_model_Project__f_soldOut = soldOut;
  this.Lreactbuild_common_model_Project__f_privacy = privacy;
  this.Lreactbuild_common_model_Project__f_scenes = scenes;
  this.Lreactbuild_common_model_Project__f_renderSettings = renderSettings;
  this.Lreactbuild_common_model_Project__f_city = city;
  this.Lreactbuild_common_model_Project__f_district = district;
  this.Lreactbuild_common_model_Project__f_topic = topic;
  this.Lreactbuild_common_model_Project__f_modelSource = modelSource;
  this.Lreactbuild_common_model_Project__f_procedureState = procedureState;
  this.Lreactbuild_common_model_Project__f_summary = summary;
  this.Lreactbuild_common_model_Project__f_archived = archived;
  this.Lreactbuild_common_model_Project__f_parent = parent;
  this.Lreactbuild_common_model_Project__f_address = address;
  this.Lreactbuild_common_model_Project__f_reference = reference
}
$c_Lreactbuild_common_model_Project.prototype = new $h_O();
$c_Lreactbuild_common_model_Project.prototype.constructor = $c_Lreactbuild_common_model_Project;
/** @constructor */
function $h_Lreactbuild_common_model_Project() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Project.prototype = $c_Lreactbuild_common_model_Project.prototype;
$c_Lreactbuild_common_model_Project.prototype.productPrefix__T = (function() {
  return "Project"
});
$c_Lreactbuild_common_model_Project.prototype.productArity__I = (function() {
  return 23
});
$c_Lreactbuild_common_model_Project.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_Project__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_Project__f_organizations;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_Project__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_Project__f_title;
      break
    }
    case 4: {
      return this.Lreactbuild_common_model_Project__f_description;
      break
    }
    case 5: {
      return this.Lreactbuild_common_model_Project__f_images;
      break
    }
    case 6: {
      return this.Lreactbuild_common_model_Project__f_location;
      break
    }
    case 7: {
      return this.Lreactbuild_common_model_Project__f_areas;
      break
    }
    case 8: {
      return this.Lreactbuild_common_model_Project__f_price;
      break
    }
    case 9: {
      return this.Lreactbuild_common_model_Project__f_soldOut;
      break
    }
    case 10: {
      return this.Lreactbuild_common_model_Project__f_privacy;
      break
    }
    case 11: {
      return this.Lreactbuild_common_model_Project__f_scenes;
      break
    }
    case 12: {
      return this.Lreactbuild_common_model_Project__f_renderSettings;
      break
    }
    case 13: {
      return this.Lreactbuild_common_model_Project__f_city;
      break
    }
    case 14: {
      return this.Lreactbuild_common_model_Project__f_district;
      break
    }
    case 15: {
      return this.Lreactbuild_common_model_Project__f_topic;
      break
    }
    case 16: {
      return this.Lreactbuild_common_model_Project__f_modelSource;
      break
    }
    case 17: {
      return this.Lreactbuild_common_model_Project__f_procedureState;
      break
    }
    case 18: {
      return this.Lreactbuild_common_model_Project__f_summary;
      break
    }
    case 19: {
      return this.Lreactbuild_common_model_Project__f_archived;
      break
    }
    case 20: {
      return this.Lreactbuild_common_model_Project__f_parent;
      break
    }
    case 21: {
      return this.Lreactbuild_common_model_Project__f_address;
      break
    }
    case 22: {
      return this.Lreactbuild_common_model_Project__f_reference;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_Project.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_Project.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_Project.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_Project.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_Project)) {
    var Project$1 = $as_Lreactbuild_common_model_Project(x$1);
    var x = this.Lreactbuild_common_model_Project__f__id;
    var x$2 = $n(Project$1).Lreactbuild_common_model_Project__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_model_Project__f_organizations;
      var x$4 = $n(Project$1).Lreactbuild_common_model_Project__f_organizations;
      var $$x3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      if ((this.Lreactbuild_common_model_Project__f_name === $n(Project$1).Lreactbuild_common_model_Project__f_name)) {
        if ((this.Lreactbuild_common_model_Project__f_title === $n(Project$1).Lreactbuild_common_model_Project__f_title)) {
          var x$5 = this.Lreactbuild_common_model_Project__f_description;
          var x$6 = $n(Project$1).Lreactbuild_common_model_Project__f_description;
          var $$x2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          var $$x2 = false
        }
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Lreactbuild_common_model_Project__f_images;
      var x$8 = $n(Project$1).Lreactbuild_common_model_Project__f_images;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_common_model_Project__f_location;
        var x$10 = $n(Project$1).Lreactbuild_common_model_Project__f_location;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_common_model_Project__f_areas;
          var x$12 = $n(Project$1).Lreactbuild_common_model_Project__f_areas;
          var $$x4 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          var $$x4 = false
        }
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var x$13 = this.Lreactbuild_common_model_Project__f_price;
        var x$14 = $n(Project$1).Lreactbuild_common_model_Project__f_price;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          var x$15 = this.Lreactbuild_common_model_Project__f_soldOut;
          var x$16 = $n(Project$1).Lreactbuild_common_model_Project__f_soldOut;
          if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
            var x$17 = this.Lreactbuild_common_model_Project__f_privacy;
            var x$18 = $n(Project$1).Lreactbuild_common_model_Project__f_privacy;
            var $$x1 = ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))
          } else {
            var $$x1 = false
          }
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$19 = this.Lreactbuild_common_model_Project__f_scenes;
      var x$20 = $n(Project$1).Lreactbuild_common_model_Project__f_scenes;
      if (((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))) {
        var x$21 = this.Lreactbuild_common_model_Project__f_renderSettings;
        var x$22 = $n(Project$1).Lreactbuild_common_model_Project__f_renderSettings;
        if (((x$21 === null) ? (x$22 === null) : $n(x$21).equals__O__Z(x$22))) {
          var x$23 = this.Lreactbuild_common_model_Project__f_city;
          var x$24 = $n(Project$1).Lreactbuild_common_model_Project__f_city;
          var $$x6 = ((x$23 === null) ? (x$24 === null) : $n(x$23).equals__O__Z(x$24))
        } else {
          var $$x6 = false
        }
      } else {
        var $$x6 = false
      };
      if ($$x6) {
        var x$25 = this.Lreactbuild_common_model_Project__f_district;
        var x$26 = $n(Project$1).Lreactbuild_common_model_Project__f_district;
        if (((x$25 === null) ? (x$26 === null) : $n(x$25).equals__O__Z(x$26))) {
          var x$27 = this.Lreactbuild_common_model_Project__f_topic;
          var x$28 = $n(Project$1).Lreactbuild_common_model_Project__f_topic;
          if (((x$27 === null) ? (x$28 === null) : $n(x$27).equals__O__Z(x$28))) {
            var x$29 = this.Lreactbuild_common_model_Project__f_modelSource;
            var x$30 = $n(Project$1).Lreactbuild_common_model_Project__f_modelSource;
            var $$x5 = ((x$29 === null) ? (x$30 === null) : $n(x$29).equals__O__Z(x$30))
          } else {
            var $$x5 = false
          }
        } else {
          var $$x5 = false
        }
      } else {
        var $$x5 = false
      };
      if ($$x5) {
        var x$31 = this.Lreactbuild_common_model_Project__f_procedureState;
        var x$32 = $n(Project$1).Lreactbuild_common_model_Project__f_procedureState;
        if (((x$31 === null) ? (x$32 === null) : $n(x$31).equals__O__Z(x$32))) {
          var x$33 = this.Lreactbuild_common_model_Project__f_summary;
          var x$34 = $n(Project$1).Lreactbuild_common_model_Project__f_summary;
          if (((x$33 === null) ? (x$34 === null) : $n(x$33).equals__O__Z(x$34))) {
            var x$35 = this.Lreactbuild_common_model_Project__f_archived;
            var x$36 = $n(Project$1).Lreactbuild_common_model_Project__f_archived;
            var $$x7 = ((x$35 === null) ? (x$36 === null) : $n(x$35).equals__O__Z(x$36))
          } else {
            var $$x7 = false
          }
        } else {
          var $$x7 = false
        };
        if ($$x7) {
          var x$37 = this.Lreactbuild_common_model_Project__f_parent;
          var x$38 = $n(Project$1).Lreactbuild_common_model_Project__f_parent;
          if (((x$37 === null) ? (x$38 === null) : $n(x$37).equals__O__Z(x$38))) {
            var x$39 = this.Lreactbuild_common_model_Project__f_address;
            var x$40 = $n(Project$1).Lreactbuild_common_model_Project__f_address;
            if (((x$39 === null) ? (x$40 === null) : $n(x$39).equals__O__Z(x$40))) {
              return (this.Lreactbuild_common_model_Project__f_reference === $n(Project$1).Lreactbuild_common_model_Project__f_reference)
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_Project(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Project) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Project"))
}
function $isArrayOf_Lreactbuild_common_model_Project(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Project)))
}
function $asArrayOf_Lreactbuild_common_model_Project(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Project(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Project;", depth))
}
var $d_Lreactbuild_common_model_Project = new $TypeData().initClass({
  Lreactbuild_common_model_Project: 0
}, false, "reactbuild.common.model.Project", {
  Lreactbuild_common_model_Project: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Project.prototype.$classData = $d_Lreactbuild_common_model_Project;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectAddress(country, raw, parcels, coordinates) {
  this.Lreactbuild_common_model_ProjectAddress__f_country = null;
  this.Lreactbuild_common_model_ProjectAddress__f_raw = null;
  this.Lreactbuild_common_model_ProjectAddress__f_parcels = null;
  this.Lreactbuild_common_model_ProjectAddress__f_coordinates = null;
  this.Lreactbuild_common_model_ProjectAddress__f_country = country;
  this.Lreactbuild_common_model_ProjectAddress__f_raw = raw;
  this.Lreactbuild_common_model_ProjectAddress__f_parcels = parcels;
  this.Lreactbuild_common_model_ProjectAddress__f_coordinates = coordinates
}
$c_Lreactbuild_common_model_ProjectAddress.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectAddress.prototype.constructor = $c_Lreactbuild_common_model_ProjectAddress;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectAddress() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectAddress.prototype = $c_Lreactbuild_common_model_ProjectAddress.prototype;
$c_Lreactbuild_common_model_ProjectAddress.prototype.productPrefix__T = (function() {
  return "ProjectAddress"
});
$c_Lreactbuild_common_model_ProjectAddress.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_common_model_ProjectAddress.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_ProjectAddress__f_country;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_ProjectAddress__f_raw;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_ProjectAddress__f_parcels;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_ProjectAddress__f_coordinates;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_ProjectAddress.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_ProjectAddress.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_ProjectAddress.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_ProjectAddress.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_ProjectAddress)) {
    var ProjectAddress$1 = $as_Lreactbuild_common_model_ProjectAddress(x$1);
    var x = this.Lreactbuild_common_model_ProjectAddress__f_country;
    var x$2 = $n(ProjectAddress$1).Lreactbuild_common_model_ProjectAddress__f_country;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_model_ProjectAddress__f_raw;
      var x$4 = $n(ProjectAddress$1).Lreactbuild_common_model_ProjectAddress__f_raw;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_common_model_ProjectAddress__f_parcels;
      var x$6 = $n(ProjectAddress$1).Lreactbuild_common_model_ProjectAddress__f_parcels;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_common_model_ProjectAddress__f_coordinates;
        var x$8 = $n(ProjectAddress$1).Lreactbuild_common_model_ProjectAddress__f_coordinates;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_ProjectAddress(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_ProjectAddress) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.ProjectAddress"))
}
function $isArrayOf_Lreactbuild_common_model_ProjectAddress(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_ProjectAddress)))
}
function $asArrayOf_Lreactbuild_common_model_ProjectAddress(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_ProjectAddress(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.ProjectAddress;", depth))
}
var $d_Lreactbuild_common_model_ProjectAddress = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectAddress: 0
}, false, "reactbuild.common.model.ProjectAddress", {
  Lreactbuild_common_model_ProjectAddress: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectAddress.prototype.$classData = $d_Lreactbuild_common_model_ProjectAddress;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24(outer) {
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForcountry = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForraw = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForparcels = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForcoordinates = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_Country$().Lreactbuild_common_model_Country$__f_codecForCountry;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForcountry = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForraw = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForparcels = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lreactbuild_common_model_Coordinates$().decodeCoordinates__Lio_circe_Decoder();
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForcoordinates = new $c_Lio_circe_Decoder$$anon$39(d$2)
}
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24.prototype.constructor = $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24.prototype = $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24.prototype;
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("country"))), this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForcountry, "country", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("raw"))), this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForraw, "raw", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("parcels"))), this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForparcels, "parcels", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("coordinates"))), this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24__f_circeGenericDecoderForcoordinates, "coordinates", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24: 0
}, false, "reactbuild.common.model.ProjectAddress$anon$lazy$macro$71$1$$anon$24", {
  Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24.prototype.$classData = $d_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$71$1$$anon$24;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectRelease(organization, name, version, date, assets) {
  this.Lreactbuild_common_model_ProjectRelease__f_organization = null;
  this.Lreactbuild_common_model_ProjectRelease__f_name = null;
  this.Lreactbuild_common_model_ProjectRelease__f_version = null;
  this.Lreactbuild_common_model_ProjectRelease__f_date = null;
  this.Lreactbuild_common_model_ProjectRelease__f_assets = null;
  this.Lreactbuild_common_model_ProjectRelease__f_organization = organization;
  this.Lreactbuild_common_model_ProjectRelease__f_name = name;
  this.Lreactbuild_common_model_ProjectRelease__f_version = version;
  this.Lreactbuild_common_model_ProjectRelease__f_date = date;
  this.Lreactbuild_common_model_ProjectRelease__f_assets = assets
}
$c_Lreactbuild_common_model_ProjectRelease.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectRelease.prototype.constructor = $c_Lreactbuild_common_model_ProjectRelease;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectRelease() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectRelease.prototype = $c_Lreactbuild_common_model_ProjectRelease.prototype;
$c_Lreactbuild_common_model_ProjectRelease.prototype.productPrefix__T = (function() {
  return "ProjectRelease"
});
$c_Lreactbuild_common_model_ProjectRelease.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_common_model_ProjectRelease.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_ProjectRelease__f_organization;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_ProjectRelease__f_name;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_ProjectRelease__f_version;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_ProjectRelease__f_date;
      break
    }
    case 4: {
      return this.Lreactbuild_common_model_ProjectRelease__f_assets;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_ProjectRelease.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_ProjectRelease.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_ProjectRelease.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_ProjectRelease.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_ProjectRelease)) {
    var ProjectRelease$1 = $as_Lreactbuild_common_model_ProjectRelease(x$1);
    if (((this.Lreactbuild_common_model_ProjectRelease__f_organization === $n(ProjectRelease$1).Lreactbuild_common_model_ProjectRelease__f_organization) && (this.Lreactbuild_common_model_ProjectRelease__f_name === $n(ProjectRelease$1).Lreactbuild_common_model_ProjectRelease__f_name))) {
      if ((this.Lreactbuild_common_model_ProjectRelease__f_version === $n(ProjectRelease$1).Lreactbuild_common_model_ProjectRelease__f_version)) {
        var x = this.Lreactbuild_common_model_ProjectRelease__f_date;
        var x$2 = $n(ProjectRelease$1).Lreactbuild_common_model_ProjectRelease__f_date;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          var x$3 = this.Lreactbuild_common_model_ProjectRelease__f_assets;
          var x$4 = $n(ProjectRelease$1).Lreactbuild_common_model_ProjectRelease__f_assets;
          return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_ProjectRelease(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_ProjectRelease) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.ProjectRelease"))
}
function $isArrayOf_Lreactbuild_common_model_ProjectRelease(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_ProjectRelease)))
}
function $asArrayOf_Lreactbuild_common_model_ProjectRelease(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_ProjectRelease(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.ProjectRelease;", depth))
}
var $d_Lreactbuild_common_model_ProjectRelease = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectRelease: 0
}, false, "reactbuild.common.model.ProjectRelease", {
  Lreactbuild_common_model_ProjectRelease: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectRelease.prototype.$classData = $d_Lreactbuild_common_model_ProjectRelease;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectSpecific(project, organization, title, description, price, publish, soldOut) {
  this.Lreactbuild_common_model_ProjectSpecific__f_project = null;
  this.Lreactbuild_common_model_ProjectSpecific__f_organization = null;
  this.Lreactbuild_common_model_ProjectSpecific__f_title = null;
  this.Lreactbuild_common_model_ProjectSpecific__f_description = null;
  this.Lreactbuild_common_model_ProjectSpecific__f_price = null;
  this.Lreactbuild_common_model_ProjectSpecific__f_publish = null;
  this.Lreactbuild_common_model_ProjectSpecific__f_soldOut = null;
  this.Lreactbuild_common_model_ProjectSpecific__f_project = project;
  this.Lreactbuild_common_model_ProjectSpecific__f_organization = organization;
  this.Lreactbuild_common_model_ProjectSpecific__f_title = title;
  this.Lreactbuild_common_model_ProjectSpecific__f_description = description;
  this.Lreactbuild_common_model_ProjectSpecific__f_price = price;
  this.Lreactbuild_common_model_ProjectSpecific__f_publish = publish;
  this.Lreactbuild_common_model_ProjectSpecific__f_soldOut = soldOut
}
$c_Lreactbuild_common_model_ProjectSpecific.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectSpecific.prototype.constructor = $c_Lreactbuild_common_model_ProjectSpecific;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectSpecific() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectSpecific.prototype = $c_Lreactbuild_common_model_ProjectSpecific.prototype;
$c_Lreactbuild_common_model_ProjectSpecific.prototype.productPrefix__T = (function() {
  return "ProjectSpecific"
});
$c_Lreactbuild_common_model_ProjectSpecific.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_common_model_ProjectSpecific.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_ProjectSpecific__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_ProjectSpecific__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_ProjectSpecific__f_title;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_ProjectSpecific__f_description;
      break
    }
    case 4: {
      return this.Lreactbuild_common_model_ProjectSpecific__f_price;
      break
    }
    case 5: {
      return this.Lreactbuild_common_model_ProjectSpecific__f_publish;
      break
    }
    case 6: {
      return this.Lreactbuild_common_model_ProjectSpecific__f_soldOut;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_ProjectSpecific.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_ProjectSpecific.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_ProjectSpecific.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_ProjectSpecific.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_ProjectSpecific)) {
    var ProjectSpecific$1 = $as_Lreactbuild_common_model_ProjectSpecific(x$1);
    var x = this.Lreactbuild_common_model_ProjectSpecific__f_project;
    var x$2 = $n(ProjectSpecific$1).Lreactbuild_common_model_ProjectSpecific__f_project;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_model_ProjectSpecific__f_organization;
      var x$4 = $n(ProjectSpecific$1).Lreactbuild_common_model_ProjectSpecific__f_organization;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_common_model_ProjectSpecific__f_title;
        var x$6 = $n(ProjectSpecific$1).Lreactbuild_common_model_ProjectSpecific__f_title;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_common_model_ProjectSpecific__f_description;
      var x$8 = $n(ProjectSpecific$1).Lreactbuild_common_model_ProjectSpecific__f_description;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_common_model_ProjectSpecific__f_price;
        var x$10 = $n(ProjectSpecific$1).Lreactbuild_common_model_ProjectSpecific__f_price;
        var $$x2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$11 = this.Lreactbuild_common_model_ProjectSpecific__f_publish;
        var x$12 = $n(ProjectSpecific$1).Lreactbuild_common_model_ProjectSpecific__f_publish;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_common_model_ProjectSpecific__f_soldOut;
          var x$14 = $n(ProjectSpecific$1).Lreactbuild_common_model_ProjectSpecific__f_soldOut;
          return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_ProjectSpecific(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_ProjectSpecific) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.ProjectSpecific"))
}
function $isArrayOf_Lreactbuild_common_model_ProjectSpecific(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_ProjectSpecific)))
}
function $asArrayOf_Lreactbuild_common_model_ProjectSpecific(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_ProjectSpecific(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.ProjectSpecific;", depth))
}
var $d_Lreactbuild_common_model_ProjectSpecific = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectSpecific: 0
}, false, "reactbuild.common.model.ProjectSpecific", {
  Lreactbuild_common_model_ProjectSpecific: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectSpecific.prototype.$classData = $d_Lreactbuild_common_model_ProjectSpecific;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectSpecifics(websites, organizations, projectsSpecific) {
  this.Lreactbuild_common_model_ProjectSpecifics__f_websites = null;
  this.Lreactbuild_common_model_ProjectSpecifics__f_organizations = null;
  this.Lreactbuild_common_model_ProjectSpecifics__f_projectsSpecific = null;
  this.Lreactbuild_common_model_ProjectSpecifics__f_websites = websites;
  this.Lreactbuild_common_model_ProjectSpecifics__f_organizations = organizations;
  this.Lreactbuild_common_model_ProjectSpecifics__f_projectsSpecific = projectsSpecific
}
$c_Lreactbuild_common_model_ProjectSpecifics.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectSpecifics.prototype.constructor = $c_Lreactbuild_common_model_ProjectSpecifics;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectSpecifics() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectSpecifics.prototype = $c_Lreactbuild_common_model_ProjectSpecifics.prototype;
$c_Lreactbuild_common_model_ProjectSpecifics.prototype.productPrefix__T = (function() {
  return "ProjectSpecifics"
});
$c_Lreactbuild_common_model_ProjectSpecifics.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_common_model_ProjectSpecifics.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_ProjectSpecifics__f_websites;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_ProjectSpecifics__f_organizations;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_ProjectSpecifics__f_projectsSpecific;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_ProjectSpecifics.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_ProjectSpecifics.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_ProjectSpecifics.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_ProjectSpecifics.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_ProjectSpecifics)) {
    var ProjectSpecifics$1 = $as_Lreactbuild_common_model_ProjectSpecifics(x$1);
    var x = this.Lreactbuild_common_model_ProjectSpecifics__f_websites;
    var x$2 = $n(ProjectSpecifics$1).Lreactbuild_common_model_ProjectSpecifics__f_websites;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_model_ProjectSpecifics__f_organizations;
      var x$4 = $n(ProjectSpecifics$1).Lreactbuild_common_model_ProjectSpecifics__f_organizations;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_common_model_ProjectSpecifics__f_projectsSpecific;
        var x$6 = $n(ProjectSpecifics$1).Lreactbuild_common_model_ProjectSpecifics__f_projectsSpecific;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_ProjectSpecifics(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_ProjectSpecifics) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.ProjectSpecifics"))
}
function $isArrayOf_Lreactbuild_common_model_ProjectSpecifics(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_ProjectSpecifics)))
}
function $asArrayOf_Lreactbuild_common_model_ProjectSpecifics(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_ProjectSpecifics(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.ProjectSpecifics;", depth))
}
var $d_Lreactbuild_common_model_ProjectSpecifics = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectSpecifics: 0
}, false, "reactbuild.common.model.ProjectSpecifics", {
  Lreactbuild_common_model_ProjectSpecifics: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectSpecifics.prototype.$classData = $d_Lreactbuild_common_model_ProjectSpecifics;
/** @constructor */
function $c_Lreactbuild_common_model_RefTo(id) {
  this.Lreactbuild_common_model_RefTo__f_id = null;
  this.Lreactbuild_common_model_RefTo__f_id = id
}
$c_Lreactbuild_common_model_RefTo.prototype = new $h_O();
$c_Lreactbuild_common_model_RefTo.prototype.constructor = $c_Lreactbuild_common_model_RefTo;
/** @constructor */
function $h_Lreactbuild_common_model_RefTo() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_RefTo.prototype = $c_Lreactbuild_common_model_RefTo.prototype;
$c_Lreactbuild_common_model_RefTo.prototype.productPrefix__T = (function() {
  return "RefTo"
});
$c_Lreactbuild_common_model_RefTo.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_model_RefTo.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_model_RefTo__f_id : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_model_RefTo.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_RefTo.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_RefTo.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_RefTo.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_RefTo)) {
    var RefTo$1 = $as_Lreactbuild_common_model_RefTo(x$1);
    var x = this.Lreactbuild_common_model_RefTo__f_id;
    var x$2 = $n(RefTo$1).Lreactbuild_common_model_RefTo__f_id;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_RefTo(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_RefTo) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.RefTo"))
}
function $isArrayOf_Lreactbuild_common_model_RefTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_RefTo)))
}
function $asArrayOf_Lreactbuild_common_model_RefTo(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_RefTo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.RefTo;", depth))
}
var $d_Lreactbuild_common_model_RefTo = new $TypeData().initClass({
  Lreactbuild_common_model_RefTo: 0
}, false, "reactbuild.common.model.RefTo", {
  Lreactbuild_common_model_RefTo: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_RefTo.prototype.$classData = $d_Lreactbuild_common_model_RefTo;
/** @constructor */
function $c_Lreactbuild_common_model_RenderSettings(settings) {
  this.Lreactbuild_common_model_RenderSettings__f_settings = null;
  this.Lreactbuild_common_model_RenderSettings__f_settings = settings
}
$c_Lreactbuild_common_model_RenderSettings.prototype = new $h_O();
$c_Lreactbuild_common_model_RenderSettings.prototype.constructor = $c_Lreactbuild_common_model_RenderSettings;
/** @constructor */
function $h_Lreactbuild_common_model_RenderSettings() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_RenderSettings.prototype = $c_Lreactbuild_common_model_RenderSettings.prototype;
$c_Lreactbuild_common_model_RenderSettings.prototype.productPrefix__T = (function() {
  return "RenderSettings"
});
$c_Lreactbuild_common_model_RenderSettings.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_model_RenderSettings.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_model_RenderSettings__f_settings : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_model_RenderSettings.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_RenderSettings.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_RenderSettings.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_RenderSettings.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_RenderSettings)) {
    var RenderSettings$1 = $as_Lreactbuild_common_model_RenderSettings(x$1);
    var x = this.Lreactbuild_common_model_RenderSettings__f_settings;
    var x$2 = $n(RenderSettings$1).Lreactbuild_common_model_RenderSettings__f_settings;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_RenderSettings(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_RenderSettings) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.RenderSettings"))
}
function $isArrayOf_Lreactbuild_common_model_RenderSettings(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_RenderSettings)))
}
function $asArrayOf_Lreactbuild_common_model_RenderSettings(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_RenderSettings(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.RenderSettings;", depth))
}
var $d_Lreactbuild_common_model_RenderSettings = new $TypeData().initClass({
  Lreactbuild_common_model_RenderSettings: 0
}, false, "reactbuild.common.model.RenderSettings", {
  Lreactbuild_common_model_RenderSettings: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_RenderSettings.prototype.$classData = $d_Lreactbuild_common_model_RenderSettings;
/** @constructor */
function $c_Lreactbuild_common_model_TypedRefTo(tpe, ref) {
  this.Lreactbuild_common_model_TypedRefTo__f_tpe = null;
  this.Lreactbuild_common_model_TypedRefTo__f_ref = null;
  this.Lreactbuild_common_model_TypedRefTo__f_tpe = tpe;
  this.Lreactbuild_common_model_TypedRefTo__f_ref = ref
}
$c_Lreactbuild_common_model_TypedRefTo.prototype = new $h_O();
$c_Lreactbuild_common_model_TypedRefTo.prototype.constructor = $c_Lreactbuild_common_model_TypedRefTo;
/** @constructor */
function $h_Lreactbuild_common_model_TypedRefTo() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_TypedRefTo.prototype = $c_Lreactbuild_common_model_TypedRefTo.prototype;
$c_Lreactbuild_common_model_TypedRefTo.prototype.productPrefix__T = (function() {
  return "TypedRefTo"
});
$c_Lreactbuild_common_model_TypedRefTo.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_model_TypedRefTo.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_TypedRefTo__f_tpe;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_TypedRefTo__f_ref;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_TypedRefTo.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_TypedRefTo.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_TypedRefTo.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_TypedRefTo.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_TypedRefTo)) {
    var TypedRefTo$1 = $as_Lreactbuild_common_model_TypedRefTo(x$1);
    if ((this.Lreactbuild_common_model_TypedRefTo__f_tpe === $n(TypedRefTo$1).Lreactbuild_common_model_TypedRefTo__f_tpe)) {
      var x = this.Lreactbuild_common_model_TypedRefTo__f_ref;
      var x$2 = $n(TypedRefTo$1).Lreactbuild_common_model_TypedRefTo__f_ref;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_TypedRefTo(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_TypedRefTo) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.TypedRefTo"))
}
function $isArrayOf_Lreactbuild_common_model_TypedRefTo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_TypedRefTo)))
}
function $asArrayOf_Lreactbuild_common_model_TypedRefTo(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_TypedRefTo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.TypedRefTo;", depth))
}
var $d_Lreactbuild_common_model_TypedRefTo = new $TypeData().initClass({
  Lreactbuild_common_model_TypedRefTo: 0
}, false, "reactbuild.common.model.TypedRefTo", {
  Lreactbuild_common_model_TypedRefTo: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_TypedRefTo.prototype.$classData = $d_Lreactbuild_common_model_TypedRefTo;
/** @constructor */
function $c_Lreactbuild_components_Form$State(context, pending, events) {
  this.Lreactbuild_components_Form$State__f_context = null;
  this.Lreactbuild_components_Form$State__f_pending = false;
  this.Lreactbuild_components_Form$State__f_events = null;
  this.Lreactbuild_components_Form$State__f_context = context;
  this.Lreactbuild_components_Form$State__f_pending = pending;
  this.Lreactbuild_components_Form$State__f_events = events
}
$c_Lreactbuild_components_Form$State.prototype = new $h_O();
$c_Lreactbuild_components_Form$State.prototype.constructor = $c_Lreactbuild_components_Form$State;
/** @constructor */
function $h_Lreactbuild_components_Form$State() {
  /*<skip>*/
}
$h_Lreactbuild_components_Form$State.prototype = $c_Lreactbuild_components_Form$State.prototype;
$c_Lreactbuild_components_Form$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_components_Form$State.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_components_Form$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_components_Form$State__f_context;
      break
    }
    case 1: {
      return this.Lreactbuild_components_Form$State__f_pending;
      break
    }
    case 2: {
      return this.Lreactbuild_components_Form$State__f_events;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_components_Form$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_components_Form$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_components_Form$State__f_context;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_components_Form$State__f_pending ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_components_Form$State__f_events;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_components_Form$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_components_Form$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_components_Form$State)) {
    var State$1 = $as_Lreactbuild_components_Form$State(x$1);
    if ((this.Lreactbuild_components_Form$State__f_pending === $n(State$1).Lreactbuild_components_Form$State__f_pending)) {
      var x = this.Lreactbuild_components_Form$State__f_context;
      var x$2 = $n(State$1).Lreactbuild_components_Form$State__f_context;
      if ((x === null)) {
        var $$x1 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === x$2)
      };
      if ($$x1) {
        var x$3 = this.Lreactbuild_components_Form$State__f_events;
        var x$4 = $n(State$1).Lreactbuild_components_Form$State__f_events;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_components_Form$State(obj) {
  return (((obj instanceof $c_Lreactbuild_components_Form$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.components.Form$State"))
}
function $isArrayOf_Lreactbuild_components_Form$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_components_Form$State)))
}
function $asArrayOf_Lreactbuild_components_Form$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_components_Form$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.components.Form$State;", depth))
}
var $d_Lreactbuild_components_Form$State = new $TypeData().initClass({
  Lreactbuild_components_Form$State: 0
}, false, "reactbuild.components.Form$State", {
  Lreactbuild_components_Form$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_components_Form$State.prototype.$classData = $d_Lreactbuild_components_Form$State;
/** @constructor */
function $c_Lreactbuild_components_ImageEditor$Props(urlOpt) {
  this.Lreactbuild_components_ImageEditor$Props__f_urlOpt = null;
  this.Lreactbuild_components_ImageEditor$Props__f_urlOpt = urlOpt
}
$c_Lreactbuild_components_ImageEditor$Props.prototype = new $h_O();
$c_Lreactbuild_components_ImageEditor$Props.prototype.constructor = $c_Lreactbuild_components_ImageEditor$Props;
/** @constructor */
function $h_Lreactbuild_components_ImageEditor$Props() {
  /*<skip>*/
}
$h_Lreactbuild_components_ImageEditor$Props.prototype = $c_Lreactbuild_components_ImageEditor$Props.prototype;
$c_Lreactbuild_components_ImageEditor$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_components_ImageEditor$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_components_ImageEditor$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_components_ImageEditor$Props__f_urlOpt : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_components_ImageEditor$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_components_ImageEditor$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_components_ImageEditor$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_components_ImageEditor$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_components_ImageEditor$Props)) {
    var Props$1 = $as_Lreactbuild_components_ImageEditor$Props(x$1);
    var x = this.Lreactbuild_components_ImageEditor$Props__f_urlOpt;
    var x$2 = $n(Props$1).Lreactbuild_components_ImageEditor$Props__f_urlOpt;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_components_ImageEditor$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_components_ImageEditor$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.components.ImageEditor$Props"))
}
function $isArrayOf_Lreactbuild_components_ImageEditor$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_components_ImageEditor$Props)))
}
function $asArrayOf_Lreactbuild_components_ImageEditor$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_components_ImageEditor$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.components.ImageEditor$Props;", depth))
}
var $d_Lreactbuild_components_ImageEditor$Props = new $TypeData().initClass({
  Lreactbuild_components_ImageEditor$Props: 0
}, false, "reactbuild.components.ImageEditor$Props", {
  Lreactbuild_components_ImageEditor$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_components_ImageEditor$Props.prototype.$classData = $d_Lreactbuild_components_ImageEditor$Props;
function $f_Lreactbuild_format_dxf_AccumulatingEncoderInstances__$init$__V($thiz) {
  $thiz.Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil = new $c_Lreactbuild_format_dxf_AccumulatingEncoderInstances$$anon$8($thiz)
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Block(layer, name, flags, base, name2, entries) {
  this.Lreactbuild_format_dxf_Block__f_layer = null;
  this.Lreactbuild_format_dxf_Block__f_name = null;
  this.Lreactbuild_format_dxf_Block__f_flags = null;
  this.Lreactbuild_format_dxf_Block__f_base = null;
  this.Lreactbuild_format_dxf_Block__f_name2 = null;
  this.Lreactbuild_format_dxf_Block__f_entries = null;
  this.Lreactbuild_format_dxf_Block__f_layer = layer;
  this.Lreactbuild_format_dxf_Block__f_name = name;
  this.Lreactbuild_format_dxf_Block__f_flags = flags;
  this.Lreactbuild_format_dxf_Block__f_base = base;
  this.Lreactbuild_format_dxf_Block__f_name2 = name2;
  this.Lreactbuild_format_dxf_Block__f_entries = entries
}
$c_Lreactbuild_format_dxf_Block.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Block.prototype.constructor = $c_Lreactbuild_format_dxf_Block;
/** @constructor */
function $h_Lreactbuild_format_dxf_Block() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Block.prototype = $c_Lreactbuild_format_dxf_Block.prototype;
$c_Lreactbuild_format_dxf_Block.prototype.productPrefix__T = (function() {
  return "Block"
});
$c_Lreactbuild_format_dxf_Block.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_format_dxf_Block.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Block__f_layer;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Block__f_name;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_Block__f_flags;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_Block__f_base;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_Block__f_name2;
      break
    }
    case 5: {
      return this.Lreactbuild_format_dxf_Block__f_entries;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Block.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Block.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Block.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Block.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Block)) {
    var Block$1 = $as_Lreactbuild_format_dxf_Block(x$1);
    var x = this.Lreactbuild_format_dxf_Block__f_layer;
    var x$2 = $n(Block$1).Lreactbuild_format_dxf_Block__f_layer;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_dxf_Block__f_name;
      var x$4 = $n(Block$1).Lreactbuild_format_dxf_Block__f_name;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_format_dxf_Block__f_flags;
        var x$6 = $n(Block$1).Lreactbuild_format_dxf_Block__f_flags;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_format_dxf_Block__f_base;
      var x$8 = $n(Block$1).Lreactbuild_format_dxf_Block__f_base;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_format_dxf_Block__f_name2;
        var x$10 = $n(Block$1).Lreactbuild_format_dxf_Block__f_name2;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_format_dxf_Block__f_entries;
          var x$12 = $n(Block$1).Lreactbuild_format_dxf_Block__f_entries;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Block(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Block) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Block"))
}
function $isArrayOf_Lreactbuild_format_dxf_Block(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Block)))
}
function $asArrayOf_Lreactbuild_format_dxf_Block(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Block(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Block;", depth))
}
var $d_Lreactbuild_format_dxf_Block = new $TypeData().initClass({
  Lreactbuild_format_dxf_Block: 0
}, false, "reactbuild.format.dxf.Block", {
  Lreactbuild_format_dxf_Block: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Block.prototype.$classData = $d_Lreactbuild_format_dxf_Block;
/** @constructor */
function $c_Lreactbuild_format_dxf_BlockFlags(referenced, dependentXrefResolved, dependentXref, xrefOverlay, isExternalXref, hasNonConstantAttribute, anonymous) {
  this.Lreactbuild_format_dxf_BlockFlags__f_referenced = false;
  this.Lreactbuild_format_dxf_BlockFlags__f_dependentXrefResolved = false;
  this.Lreactbuild_format_dxf_BlockFlags__f_dependentXref = false;
  this.Lreactbuild_format_dxf_BlockFlags__f_xrefOverlay = false;
  this.Lreactbuild_format_dxf_BlockFlags__f_isExternalXref = false;
  this.Lreactbuild_format_dxf_BlockFlags__f_hasNonConstantAttribute = false;
  this.Lreactbuild_format_dxf_BlockFlags__f_anonymous = false;
  this.Lreactbuild_format_dxf_BlockFlags__f_referenced = referenced;
  this.Lreactbuild_format_dxf_BlockFlags__f_dependentXrefResolved = dependentXrefResolved;
  this.Lreactbuild_format_dxf_BlockFlags__f_dependentXref = dependentXref;
  this.Lreactbuild_format_dxf_BlockFlags__f_xrefOverlay = xrefOverlay;
  this.Lreactbuild_format_dxf_BlockFlags__f_isExternalXref = isExternalXref;
  this.Lreactbuild_format_dxf_BlockFlags__f_hasNonConstantAttribute = hasNonConstantAttribute;
  this.Lreactbuild_format_dxf_BlockFlags__f_anonymous = anonymous
}
$c_Lreactbuild_format_dxf_BlockFlags.prototype = new $h_O();
$c_Lreactbuild_format_dxf_BlockFlags.prototype.constructor = $c_Lreactbuild_format_dxf_BlockFlags;
/** @constructor */
function $h_Lreactbuild_format_dxf_BlockFlags() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_BlockFlags.prototype = $c_Lreactbuild_format_dxf_BlockFlags.prototype;
$c_Lreactbuild_format_dxf_BlockFlags.prototype.productPrefix__T = (function() {
  return "BlockFlags"
});
$c_Lreactbuild_format_dxf_BlockFlags.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_format_dxf_BlockFlags.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_BlockFlags__f_referenced;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_BlockFlags__f_dependentXrefResolved;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_BlockFlags__f_dependentXref;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_BlockFlags__f_xrefOverlay;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_BlockFlags__f_isExternalXref;
      break
    }
    case 5: {
      return this.Lreactbuild_format_dxf_BlockFlags__f_hasNonConstantAttribute;
      break
    }
    case 6: {
      return this.Lreactbuild_format_dxf_BlockFlags__f_anonymous;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_BlockFlags.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_BlockFlags.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("BlockFlags");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_format_dxf_BlockFlags__f_referenced ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_format_dxf_BlockFlags__f_dependentXrefResolved ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lreactbuild_format_dxf_BlockFlags__f_dependentXref ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lreactbuild_format_dxf_BlockFlags__f_xrefOverlay ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lreactbuild_format_dxf_BlockFlags__f_isExternalXref ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lreactbuild_format_dxf_BlockFlags__f_hasNonConstantAttribute ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var data$7 = (this.Lreactbuild_format_dxf_BlockFlags__f_anonymous ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lreactbuild_format_dxf_BlockFlags.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_BlockFlags.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_BlockFlags)) {
    var BlockFlags$1 = $as_Lreactbuild_format_dxf_BlockFlags(x$1);
    return (((this.Lreactbuild_format_dxf_BlockFlags__f_referenced === $n(BlockFlags$1).Lreactbuild_format_dxf_BlockFlags__f_referenced) && ((this.Lreactbuild_format_dxf_BlockFlags__f_dependentXrefResolved === $n(BlockFlags$1).Lreactbuild_format_dxf_BlockFlags__f_dependentXrefResolved) && (this.Lreactbuild_format_dxf_BlockFlags__f_dependentXref === $n(BlockFlags$1).Lreactbuild_format_dxf_BlockFlags__f_dependentXref))) && (((this.Lreactbuild_format_dxf_BlockFlags__f_xrefOverlay === $n(BlockFlags$1).Lreactbuild_format_dxf_BlockFlags__f_xrefOverlay) && (this.Lreactbuild_format_dxf_BlockFlags__f_isExternalXref === $n(BlockFlags$1).Lreactbuild_format_dxf_BlockFlags__f_isExternalXref)) && ((this.Lreactbuild_format_dxf_BlockFlags__f_hasNonConstantAttribute === $n(BlockFlags$1).Lreactbuild_format_dxf_BlockFlags__f_hasNonConstantAttribute) && (this.Lreactbuild_format_dxf_BlockFlags__f_anonymous === $n(BlockFlags$1).Lreactbuild_format_dxf_BlockFlags__f_anonymous))))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_BlockFlags(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_BlockFlags) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.BlockFlags"))
}
function $isArrayOf_Lreactbuild_format_dxf_BlockFlags(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_BlockFlags)))
}
function $asArrayOf_Lreactbuild_format_dxf_BlockFlags(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_BlockFlags(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.BlockFlags;", depth))
}
var $d_Lreactbuild_format_dxf_BlockFlags = new $TypeData().initClass({
  Lreactbuild_format_dxf_BlockFlags: 0
}, false, "reactbuild.format.dxf.BlockFlags", {
  Lreactbuild_format_dxf_BlockFlags: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_BlockFlags.prototype.$classData = $d_Lreactbuild_format_dxf_BlockFlags;
/** @constructor */
function $c_Lreactbuild_format_dxf_Blocks(blockDefinitionEntities) {
  this.Lreactbuild_format_dxf_Blocks__f_blockDefinitionEntities = null;
  this.Lreactbuild_format_dxf_Blocks__f_blockDefinitionEntities = blockDefinitionEntities
}
$c_Lreactbuild_format_dxf_Blocks.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Blocks.prototype.constructor = $c_Lreactbuild_format_dxf_Blocks;
/** @constructor */
function $h_Lreactbuild_format_dxf_Blocks() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Blocks.prototype = $c_Lreactbuild_format_dxf_Blocks.prototype;
$c_Lreactbuild_format_dxf_Blocks.prototype.productPrefix__T = (function() {
  return "Blocks"
});
$c_Lreactbuild_format_dxf_Blocks.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_Blocks.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_Blocks__f_blockDefinitionEntities : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_Blocks.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Blocks.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Blocks.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Blocks.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Blocks)) {
    var Blocks$1 = $as_Lreactbuild_format_dxf_Blocks(x$1);
    var x = this.Lreactbuild_format_dxf_Blocks__f_blockDefinitionEntities;
    var x$2 = $n(Blocks$1).Lreactbuild_format_dxf_Blocks__f_blockDefinitionEntities;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Blocks(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Blocks) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Blocks"))
}
function $isArrayOf_Lreactbuild_format_dxf_Blocks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Blocks)))
}
function $asArrayOf_Lreactbuild_format_dxf_Blocks(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Blocks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Blocks;", depth))
}
var $d_Lreactbuild_format_dxf_Blocks = new $TypeData().initClass({
  Lreactbuild_format_dxf_Blocks: 0
}, false, "reactbuild.format.dxf.Blocks", {
  Lreactbuild_format_dxf_Blocks: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Blocks.prototype.$classData = $d_Lreactbuild_format_dxf_Blocks;
/** @constructor */
function $c_Lreactbuild_format_dxf_Classes() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Classes.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Classes.prototype.constructor = $c_Lreactbuild_format_dxf_Classes;
/** @constructor */
function $h_Lreactbuild_format_dxf_Classes() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Classes.prototype = $c_Lreactbuild_format_dxf_Classes.prototype;
$c_Lreactbuild_format_dxf_Classes.prototype.productPrefix__T = (function() {
  return "Classes"
});
$c_Lreactbuild_format_dxf_Classes.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_format_dxf_Classes.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_format_dxf_Classes.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Classes.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Classes.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Classes.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_format_dxf_Classes)
});
function $as_Lreactbuild_format_dxf_Classes(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Classes) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Classes"))
}
function $isArrayOf_Lreactbuild_format_dxf_Classes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Classes)))
}
function $asArrayOf_Lreactbuild_format_dxf_Classes(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Classes(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Classes;", depth))
}
var $d_Lreactbuild_format_dxf_Classes = new $TypeData().initClass({
  Lreactbuild_format_dxf_Classes: 0
}, false, "reactbuild.format.dxf.Classes", {
  Lreactbuild_format_dxf_Classes: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Classes.prototype.$classData = $d_Lreactbuild_format_dxf_Classes;
/** @constructor */
function $c_Lreactbuild_format_dxf_ColorIndex(index) {
  this.Lreactbuild_format_dxf_ColorIndex__f_index = 0;
  this.Lreactbuild_format_dxf_ColorIndex__f_index = index
}
$c_Lreactbuild_format_dxf_ColorIndex.prototype = new $h_O();
$c_Lreactbuild_format_dxf_ColorIndex.prototype.constructor = $c_Lreactbuild_format_dxf_ColorIndex;
/** @constructor */
function $h_Lreactbuild_format_dxf_ColorIndex() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_ColorIndex.prototype = $c_Lreactbuild_format_dxf_ColorIndex.prototype;
$c_Lreactbuild_format_dxf_ColorIndex.prototype.productPrefix__T = (function() {
  return "ColorIndex"
});
$c_Lreactbuild_format_dxf_ColorIndex.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_ColorIndex.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_ColorIndex__f_index : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_ColorIndex.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_ColorIndex.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ColorIndex");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_format_dxf_ColorIndex__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_format_dxf_ColorIndex.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_ColorIndex.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_ColorIndex)) {
    var ColorIndex$1 = $as_Lreactbuild_format_dxf_ColorIndex(x$1);
    return (this.Lreactbuild_format_dxf_ColorIndex__f_index === $n(ColorIndex$1).Lreactbuild_format_dxf_ColorIndex__f_index)
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_ColorIndex(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_ColorIndex) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.ColorIndex"))
}
function $isArrayOf_Lreactbuild_format_dxf_ColorIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_ColorIndex)))
}
function $asArrayOf_Lreactbuild_format_dxf_ColorIndex(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_ColorIndex(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.ColorIndex;", depth))
}
var $d_Lreactbuild_format_dxf_ColorIndex = new $TypeData().initClass({
  Lreactbuild_format_dxf_ColorIndex: 0
}, false, "reactbuild.format.dxf.ColorIndex", {
  Lreactbuild_format_dxf_ColorIndex: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_ColorIndex.prototype.$classData = $d_Lreactbuild_format_dxf_ColorIndex;
/** @constructor */
function $c_Lreactbuild_format_dxf_CursorResult(value, c) {
  this.Lreactbuild_format_dxf_CursorResult__f_value = null;
  this.Lreactbuild_format_dxf_CursorResult__f_c = null;
  this.Lreactbuild_format_dxf_CursorResult__f_value = value;
  this.Lreactbuild_format_dxf_CursorResult__f_c = c
}
$c_Lreactbuild_format_dxf_CursorResult.prototype = new $h_O();
$c_Lreactbuild_format_dxf_CursorResult.prototype.constructor = $c_Lreactbuild_format_dxf_CursorResult;
/** @constructor */
function $h_Lreactbuild_format_dxf_CursorResult() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_CursorResult.prototype = $c_Lreactbuild_format_dxf_CursorResult.prototype;
$c_Lreactbuild_format_dxf_CursorResult.prototype.map__F1__Lreactbuild_format_dxf_CursorResult = (function(f) {
  return new $c_Lreactbuild_format_dxf_CursorResult($n(f).apply__O__O(this.Lreactbuild_format_dxf_CursorResult__f_value), this.Lreactbuild_format_dxf_CursorResult__f_c)
});
$c_Lreactbuild_format_dxf_CursorResult.prototype.productPrefix__T = (function() {
  return "CursorResult"
});
$c_Lreactbuild_format_dxf_CursorResult.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_dxf_CursorResult.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_CursorResult__f_value;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_CursorResult__f_c;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_CursorResult.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_CursorResult.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_CursorResult.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_CursorResult.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_CursorResult)) {
    var CursorResult$1 = $as_Lreactbuild_format_dxf_CursorResult(x$1);
    var x = this.Lreactbuild_format_dxf_CursorResult__f_value;
    var y = $n(CursorResult$1).Lreactbuild_format_dxf_CursorResult__f_value;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_format_dxf_CursorResult__f_c;
      var x$2$1 = $n(CursorResult$1).Lreactbuild_format_dxf_CursorResult__f_c;
      return ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_CursorResult(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_CursorResult) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.CursorResult"))
}
function $isArrayOf_Lreactbuild_format_dxf_CursorResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_CursorResult)))
}
function $asArrayOf_Lreactbuild_format_dxf_CursorResult(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_CursorResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.CursorResult;", depth))
}
var $d_Lreactbuild_format_dxf_CursorResult = new $TypeData().initClass({
  Lreactbuild_format_dxf_CursorResult: 0
}, false, "reactbuild.format.dxf.CursorResult", {
  Lreactbuild_format_dxf_CursorResult: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_CursorResult.prototype.$classData = $d_Lreactbuild_format_dxf_CursorResult;
/** @constructor */
function $c_Lreactbuild_format_dxf_Entities(drawingEntities) {
  this.Lreactbuild_format_dxf_Entities__f_drawingEntities = null;
  this.Lreactbuild_format_dxf_Entities__f_drawingEntities = drawingEntities
}
$c_Lreactbuild_format_dxf_Entities.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Entities.prototype.constructor = $c_Lreactbuild_format_dxf_Entities;
/** @constructor */
function $h_Lreactbuild_format_dxf_Entities() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Entities.prototype = $c_Lreactbuild_format_dxf_Entities.prototype;
$c_Lreactbuild_format_dxf_Entities.prototype.productPrefix__T = (function() {
  return "Entities"
});
$c_Lreactbuild_format_dxf_Entities.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_Entities.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_Entities__f_drawingEntities : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_Entities.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Entities.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Entities.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Entities.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Entities)) {
    var Entities$1 = $as_Lreactbuild_format_dxf_Entities(x$1);
    var x = this.Lreactbuild_format_dxf_Entities__f_drawingEntities;
    var x$2 = $n(Entities$1).Lreactbuild_format_dxf_Entities__f_drawingEntities;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Entities(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Entities) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Entities"))
}
function $isArrayOf_Lreactbuild_format_dxf_Entities(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Entities)))
}
function $asArrayOf_Lreactbuild_format_dxf_Entities(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Entities(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Entities;", depth))
}
var $d_Lreactbuild_format_dxf_Entities = new $TypeData().initClass({
  Lreactbuild_format_dxf_Entities: 0
}, false, "reactbuild.format.dxf.Entities", {
  Lreactbuild_format_dxf_Entities: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Entities.prototype.$classData = $d_Lreactbuild_format_dxf_Entities;
/** @constructor */
function $c_Lreactbuild_format_dxf_FieldDecoder$() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_FieldDecoder$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_FieldDecoder$.prototype.constructor = $c_Lreactbuild_format_dxf_FieldDecoder$;
/** @constructor */
function $h_Lreactbuild_format_dxf_FieldDecoder$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_FieldDecoder$.prototype = $c_Lreactbuild_format_dxf_FieldDecoder$.prototype;
var $d_Lreactbuild_format_dxf_FieldDecoder$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_FieldDecoder$: 0
}, false, "reactbuild.format.dxf.FieldDecoder$", {
  Lreactbuild_format_dxf_FieldDecoder$: 1,
  O: 1,
  Lreactbuild_format_dxf_HighPriorityImplicitsFieldDecoderInstances: 1,
  Lreactbuild_format_dxf_MidPriorityImplicitsFieldDecoderInstances: 1,
  Lreactbuild_format_dxf_LowPriorityImplicitsFieldDecoderInstances: 1
});
$c_Lreactbuild_format_dxf_FieldDecoder$.prototype.$classData = $d_Lreactbuild_format_dxf_FieldDecoder$;
var $n_Lreactbuild_format_dxf_FieldDecoder$;
function $m_Lreactbuild_format_dxf_FieldDecoder$() {
  if ((!$n_Lreactbuild_format_dxf_FieldDecoder$)) {
    $n_Lreactbuild_format_dxf_FieldDecoder$ = new $c_Lreactbuild_format_dxf_FieldDecoder$()
  };
  return $n_Lreactbuild_format_dxf_FieldDecoder$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Header(parameters) {
  this.Lreactbuild_format_dxf_Header__f_parameters = null;
  this.Lreactbuild_format_dxf_Header__f_parameters = parameters
}
$c_Lreactbuild_format_dxf_Header.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Header.prototype.constructor = $c_Lreactbuild_format_dxf_Header;
/** @constructor */
function $h_Lreactbuild_format_dxf_Header() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Header.prototype = $c_Lreactbuild_format_dxf_Header.prototype;
$c_Lreactbuild_format_dxf_Header.prototype.productPrefix__T = (function() {
  return "Header"
});
$c_Lreactbuild_format_dxf_Header.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_Header.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_Header__f_parameters : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_Header.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Header.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Header.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Header.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Header)) {
    var Header$1 = $as_Lreactbuild_format_dxf_Header(x$1);
    var x = this.Lreactbuild_format_dxf_Header__f_parameters;
    var x$2 = $n(Header$1).Lreactbuild_format_dxf_Header__f_parameters;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Header(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Header) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Header"))
}
function $isArrayOf_Lreactbuild_format_dxf_Header(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Header)))
}
function $asArrayOf_Lreactbuild_format_dxf_Header(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Header(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Header;", depth))
}
var $d_Lreactbuild_format_dxf_Header = new $TypeData().initClass({
  Lreactbuild_format_dxf_Header: 0
}, false, "reactbuild.format.dxf.Header", {
  Lreactbuild_format_dxf_Header: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Header.prototype.$classData = $d_Lreactbuild_format_dxf_Header;
/** @constructor */
function $c_Lreactbuild_format_dxf_LType(name, flags, description, alignmentCode, numberOfLineTypeElements, totalPatternLength) {
  this.Lreactbuild_format_dxf_LType__f_name = null;
  this.Lreactbuild_format_dxf_LType__f_flags = null;
  this.Lreactbuild_format_dxf_LType__f_description = null;
  this.Lreactbuild_format_dxf_LType__f_alignmentCode = 0;
  this.Lreactbuild_format_dxf_LType__f_numberOfLineTypeElements = 0;
  this.Lreactbuild_format_dxf_LType__f_totalPatternLength = 0.0;
  this.Lreactbuild_format_dxf_LType__f_name = name;
  this.Lreactbuild_format_dxf_LType__f_flags = flags;
  this.Lreactbuild_format_dxf_LType__f_description = description;
  this.Lreactbuild_format_dxf_LType__f_alignmentCode = alignmentCode;
  this.Lreactbuild_format_dxf_LType__f_numberOfLineTypeElements = numberOfLineTypeElements;
  this.Lreactbuild_format_dxf_LType__f_totalPatternLength = totalPatternLength
}
$c_Lreactbuild_format_dxf_LType.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LType.prototype.constructor = $c_Lreactbuild_format_dxf_LType;
/** @constructor */
function $h_Lreactbuild_format_dxf_LType() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LType.prototype = $c_Lreactbuild_format_dxf_LType.prototype;
$c_Lreactbuild_format_dxf_LType.prototype.productPrefix__T = (function() {
  return "LType"
});
$c_Lreactbuild_format_dxf_LType.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_format_dxf_LType.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_LType__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_LType__f_flags;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_LType__f_description;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_LType__f_alignmentCode;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_LType__f_numberOfLineTypeElements;
      break
    }
    case 5: {
      return this.Lreactbuild_format_dxf_LType__f_totalPatternLength;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_LType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_LType.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LType");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_format_dxf_LType__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_format_dxf_LType__f_flags;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_format_dxf_LType__f_description;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Lreactbuild_format_dxf_LType__f_alignmentCode;
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = this.Lreactbuild_format_dxf_LType__f_numberOfLineTypeElements;
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var dv = this.Lreactbuild_format_dxf_LType__f_totalPatternLength;
  var data$6 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_format_dxf_LType.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_LType.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_LType)) {
    var LType$1 = $as_Lreactbuild_format_dxf_LType(x$1);
    if (((this.Lreactbuild_format_dxf_LType__f_alignmentCode === $n(LType$1).Lreactbuild_format_dxf_LType__f_alignmentCode) && ((this.Lreactbuild_format_dxf_LType__f_numberOfLineTypeElements === $n(LType$1).Lreactbuild_format_dxf_LType__f_numberOfLineTypeElements) && (this.Lreactbuild_format_dxf_LType__f_totalPatternLength === $n(LType$1).Lreactbuild_format_dxf_LType__f_totalPatternLength)))) {
      var x = this.Lreactbuild_format_dxf_LType__f_name;
      var x$2 = $n(LType$1).Lreactbuild_format_dxf_LType__f_name;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_format_dxf_LType__f_flags;
        var x$4 = $n(LType$1).Lreactbuild_format_dxf_LType__f_flags;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          return (this.Lreactbuild_format_dxf_LType__f_description === $n(LType$1).Lreactbuild_format_dxf_LType__f_description)
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_LType(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_LType) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.LType"))
}
function $isArrayOf_Lreactbuild_format_dxf_LType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_LType)))
}
function $asArrayOf_Lreactbuild_format_dxf_LType(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_LType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.LType;", depth))
}
var $d_Lreactbuild_format_dxf_LType = new $TypeData().initClass({
  Lreactbuild_format_dxf_LType: 0
}, false, "reactbuild.format.dxf.LType", {
  Lreactbuild_format_dxf_LType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LType.prototype.$classData = $d_Lreactbuild_format_dxf_LType;
/** @constructor */
function $c_Lreactbuild_format_dxf_Layer(name, flags, color, lineType) {
  this.Lreactbuild_format_dxf_Layer__f_name = null;
  this.Lreactbuild_format_dxf_Layer__f_flags = null;
  this.Lreactbuild_format_dxf_Layer__f_color = null;
  this.Lreactbuild_format_dxf_Layer__f_lineType = null;
  this.Lreactbuild_format_dxf_Layer__f_name = name;
  this.Lreactbuild_format_dxf_Layer__f_flags = flags;
  this.Lreactbuild_format_dxf_Layer__f_color = color;
  this.Lreactbuild_format_dxf_Layer__f_lineType = lineType
}
$c_Lreactbuild_format_dxf_Layer.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Layer.prototype.constructor = $c_Lreactbuild_format_dxf_Layer;
/** @constructor */
function $h_Lreactbuild_format_dxf_Layer() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Layer.prototype = $c_Lreactbuild_format_dxf_Layer.prototype;
$c_Lreactbuild_format_dxf_Layer.prototype.productPrefix__T = (function() {
  return "Layer"
});
$c_Lreactbuild_format_dxf_Layer.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_format_dxf_Layer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Layer__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Layer__f_flags;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_Layer__f_color;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_Layer__f_lineType;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Layer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Layer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Layer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Layer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Layer)) {
    var Layer$1 = $as_Lreactbuild_format_dxf_Layer(x$1);
    var x = this.Lreactbuild_format_dxf_Layer__f_name;
    var x$2 = $n(Layer$1).Lreactbuild_format_dxf_Layer__f_name;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_dxf_Layer__f_flags;
      var x$4 = $n(Layer$1).Lreactbuild_format_dxf_Layer__f_flags;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_format_dxf_Layer__f_color;
      var x$6 = $n(Layer$1).Lreactbuild_format_dxf_Layer__f_color;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_format_dxf_Layer__f_lineType;
        var x$8 = $n(Layer$1).Lreactbuild_format_dxf_Layer__f_lineType;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Layer(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Layer) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Layer"))
}
function $isArrayOf_Lreactbuild_format_dxf_Layer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Layer)))
}
function $asArrayOf_Lreactbuild_format_dxf_Layer(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Layer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Layer;", depth))
}
var $d_Lreactbuild_format_dxf_Layer = new $TypeData().initClass({
  Lreactbuild_format_dxf_Layer: 0
}, false, "reactbuild.format.dxf.Layer", {
  Lreactbuild_format_dxf_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Layer.prototype.$classData = $d_Lreactbuild_format_dxf_Layer;
/** @constructor */
function $c_Lreactbuild_format_dxf_LayerFlags(referenced, dependentXrefResolved, dependentXref, locked, frozenInNewViewports, frozen) {
  this.Lreactbuild_format_dxf_LayerFlags__f_referenced = false;
  this.Lreactbuild_format_dxf_LayerFlags__f_dependentXrefResolved = false;
  this.Lreactbuild_format_dxf_LayerFlags__f_dependentXref = false;
  this.Lreactbuild_format_dxf_LayerFlags__f_locked = false;
  this.Lreactbuild_format_dxf_LayerFlags__f_frozenInNewViewports = false;
  this.Lreactbuild_format_dxf_LayerFlags__f_frozen = false;
  this.Lreactbuild_format_dxf_LayerFlags__f_referenced = referenced;
  this.Lreactbuild_format_dxf_LayerFlags__f_dependentXrefResolved = dependentXrefResolved;
  this.Lreactbuild_format_dxf_LayerFlags__f_dependentXref = dependentXref;
  this.Lreactbuild_format_dxf_LayerFlags__f_locked = locked;
  this.Lreactbuild_format_dxf_LayerFlags__f_frozenInNewViewports = frozenInNewViewports;
  this.Lreactbuild_format_dxf_LayerFlags__f_frozen = frozen
}
$c_Lreactbuild_format_dxf_LayerFlags.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LayerFlags.prototype.constructor = $c_Lreactbuild_format_dxf_LayerFlags;
/** @constructor */
function $h_Lreactbuild_format_dxf_LayerFlags() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LayerFlags.prototype = $c_Lreactbuild_format_dxf_LayerFlags.prototype;
$c_Lreactbuild_format_dxf_LayerFlags.prototype.productPrefix__T = (function() {
  return "LayerFlags"
});
$c_Lreactbuild_format_dxf_LayerFlags.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_format_dxf_LayerFlags.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_LayerFlags__f_referenced;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_LayerFlags__f_dependentXrefResolved;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_LayerFlags__f_dependentXref;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_LayerFlags__f_locked;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_LayerFlags__f_frozenInNewViewports;
      break
    }
    case 5: {
      return this.Lreactbuild_format_dxf_LayerFlags__f_frozen;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_LayerFlags.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_LayerFlags.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LayerFlags");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_format_dxf_LayerFlags__f_referenced ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_format_dxf_LayerFlags__f_dependentXrefResolved ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lreactbuild_format_dxf_LayerFlags__f_dependentXref ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lreactbuild_format_dxf_LayerFlags__f_locked ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lreactbuild_format_dxf_LayerFlags__f_frozenInNewViewports ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lreactbuild_format_dxf_LayerFlags__f_frozen ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_format_dxf_LayerFlags.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_LayerFlags.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_LayerFlags)) {
    var LayerFlags$1 = $as_Lreactbuild_format_dxf_LayerFlags(x$1);
    return (((this.Lreactbuild_format_dxf_LayerFlags__f_referenced === $n(LayerFlags$1).Lreactbuild_format_dxf_LayerFlags__f_referenced) && ((this.Lreactbuild_format_dxf_LayerFlags__f_dependentXrefResolved === $n(LayerFlags$1).Lreactbuild_format_dxf_LayerFlags__f_dependentXrefResolved) && (this.Lreactbuild_format_dxf_LayerFlags__f_dependentXref === $n(LayerFlags$1).Lreactbuild_format_dxf_LayerFlags__f_dependentXref))) && ((this.Lreactbuild_format_dxf_LayerFlags__f_locked === $n(LayerFlags$1).Lreactbuild_format_dxf_LayerFlags__f_locked) && ((this.Lreactbuild_format_dxf_LayerFlags__f_frozenInNewViewports === $n(LayerFlags$1).Lreactbuild_format_dxf_LayerFlags__f_frozenInNewViewports) && (this.Lreactbuild_format_dxf_LayerFlags__f_frozen === $n(LayerFlags$1).Lreactbuild_format_dxf_LayerFlags__f_frozen))))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_LayerFlags(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_LayerFlags) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.LayerFlags"))
}
function $isArrayOf_Lreactbuild_format_dxf_LayerFlags(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_LayerFlags)))
}
function $asArrayOf_Lreactbuild_format_dxf_LayerFlags(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_LayerFlags(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.LayerFlags;", depth))
}
var $d_Lreactbuild_format_dxf_LayerFlags = new $TypeData().initClass({
  Lreactbuild_format_dxf_LayerFlags: 0
}, false, "reactbuild.format.dxf.LayerFlags", {
  Lreactbuild_format_dxf_LayerFlags: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LayerFlags.prototype.$classData = $d_Lreactbuild_format_dxf_LayerFlags;
/** @constructor */
function $c_Lreactbuild_format_dxf_LwPolylineFlags(plineGen, closed) {
  this.Lreactbuild_format_dxf_LwPolylineFlags__f_plineGen = false;
  this.Lreactbuild_format_dxf_LwPolylineFlags__f_closed = false;
  this.Lreactbuild_format_dxf_LwPolylineFlags__f_plineGen = plineGen;
  this.Lreactbuild_format_dxf_LwPolylineFlags__f_closed = closed
}
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype.constructor = $c_Lreactbuild_format_dxf_LwPolylineFlags;
/** @constructor */
function $h_Lreactbuild_format_dxf_LwPolylineFlags() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LwPolylineFlags.prototype = $c_Lreactbuild_format_dxf_LwPolylineFlags.prototype;
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype.productPrefix__T = (function() {
  return "LwPolylineFlags"
});
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_LwPolylineFlags__f_plineGen;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_LwPolylineFlags__f_closed;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LwPolylineFlags");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_format_dxf_LwPolylineFlags__f_plineGen ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_format_dxf_LwPolylineFlags__f_closed ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_LwPolylineFlags)) {
    var LwPolylineFlags$1 = $as_Lreactbuild_format_dxf_LwPolylineFlags(x$1);
    return ((this.Lreactbuild_format_dxf_LwPolylineFlags__f_plineGen === $n(LwPolylineFlags$1).Lreactbuild_format_dxf_LwPolylineFlags__f_plineGen) && (this.Lreactbuild_format_dxf_LwPolylineFlags__f_closed === $n(LwPolylineFlags$1).Lreactbuild_format_dxf_LwPolylineFlags__f_closed))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_LwPolylineFlags(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_LwPolylineFlags) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.LwPolylineFlags"))
}
function $isArrayOf_Lreactbuild_format_dxf_LwPolylineFlags(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_LwPolylineFlags)))
}
function $asArrayOf_Lreactbuild_format_dxf_LwPolylineFlags(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_LwPolylineFlags(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.LwPolylineFlags;", depth))
}
var $d_Lreactbuild_format_dxf_LwPolylineFlags = new $TypeData().initClass({
  Lreactbuild_format_dxf_LwPolylineFlags: 0
}, false, "reactbuild.format.dxf.LwPolylineFlags", {
  Lreactbuild_format_dxf_LwPolylineFlags: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LwPolylineFlags.prototype.$classData = $d_Lreactbuild_format_dxf_LwPolylineFlags;
/** @constructor */
function $c_Lreactbuild_format_dxf_NameOf(value) {
  this.Lreactbuild_format_dxf_NameOf__f_value = null;
  this.Lreactbuild_format_dxf_NameOf__f_value = value
}
$c_Lreactbuild_format_dxf_NameOf.prototype = new $h_O();
$c_Lreactbuild_format_dxf_NameOf.prototype.constructor = $c_Lreactbuild_format_dxf_NameOf;
/** @constructor */
function $h_Lreactbuild_format_dxf_NameOf() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_NameOf.prototype = $c_Lreactbuild_format_dxf_NameOf.prototype;
$c_Lreactbuild_format_dxf_NameOf.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_Lreactbuild_format_dxf_NameOf)) {
    var x2 = $as_Lreactbuild_format_dxf_NameOf(o);
    var o$2 = $n(x2).Lreactbuild_format_dxf_NameOf__f_value;
    var this$1 = $n(this.Lreactbuild_format_dxf_NameOf__f_value);
    var len = this$1.length;
    if ((o$2 === null)) {
      var $$x1 = true
    } else {
      var this$2 = $n(o$2);
      var $$x1 = (this$2.length !== len)
    };
    if ((!$$x1)) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = $charAt(this$1, index);
        var $$x2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
        var this$3 = $n(o$2);
        var index$1 = i;
        var c$1 = $charAt(this$3, index$1);
        if (($$x2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false
        };
        i = ((1 + i) | 0)
      };
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_format_dxf_NameOf.prototype.hashCode__I = (function() {
  var this$ = this.Lreactbuild_format_dxf_NameOf__f_value;
  return $f_T__hashCode__I($n(this$))
});
$c_Lreactbuild_format_dxf_NameOf.prototype.productPrefix__T = (function() {
  return "NameOf"
});
$c_Lreactbuild_format_dxf_NameOf.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_NameOf.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? new $c_Leu_timepit_refined_api_Refined(this.Lreactbuild_format_dxf_NameOf__f_value) : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_NameOf.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_NameOf.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
function $as_Lreactbuild_format_dxf_NameOf(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_NameOf) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.NameOf"))
}
function $isArrayOf_Lreactbuild_format_dxf_NameOf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_NameOf)))
}
function $asArrayOf_Lreactbuild_format_dxf_NameOf(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_NameOf(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.NameOf;", depth))
}
var $d_Lreactbuild_format_dxf_NameOf = new $TypeData().initClass({
  Lreactbuild_format_dxf_NameOf: 0
}, false, "reactbuild.format.dxf.NameOf", {
  Lreactbuild_format_dxf_NameOf: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_NameOf.prototype.$classData = $d_Lreactbuild_format_dxf_NameOf;
/** @constructor */
function $c_Lreactbuild_format_dxf_Objects() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_Objects.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Objects.prototype.constructor = $c_Lreactbuild_format_dxf_Objects;
/** @constructor */
function $h_Lreactbuild_format_dxf_Objects() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Objects.prototype = $c_Lreactbuild_format_dxf_Objects.prototype;
$c_Lreactbuild_format_dxf_Objects.prototype.productPrefix__T = (function() {
  return "Objects"
});
$c_Lreactbuild_format_dxf_Objects.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_format_dxf_Objects.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_format_dxf_Objects.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Objects.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Objects.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Objects.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_format_dxf_Objects)
});
function $as_Lreactbuild_format_dxf_Objects(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Objects) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Objects"))
}
function $isArrayOf_Lreactbuild_format_dxf_Objects(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Objects)))
}
function $asArrayOf_Lreactbuild_format_dxf_Objects(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Objects(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Objects;", depth))
}
var $d_Lreactbuild_format_dxf_Objects = new $TypeData().initClass({
  Lreactbuild_format_dxf_Objects: 0
}, false, "reactbuild.format.dxf.Objects", {
  Lreactbuild_format_dxf_Objects: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Objects.prototype.$classData = $d_Lreactbuild_format_dxf_Objects;
/** @constructor */
function $c_Lreactbuild_format_dxf_Point3D(x, y, z) {
  this.Lreactbuild_format_dxf_Point3D__f_x = 0.0;
  this.Lreactbuild_format_dxf_Point3D__f_y = 0.0;
  this.Lreactbuild_format_dxf_Point3D__f_z = 0.0;
  this.Lreactbuild_format_dxf_Point3D__f_x = x;
  this.Lreactbuild_format_dxf_Point3D__f_y = y;
  this.Lreactbuild_format_dxf_Point3D__f_z = z
}
$c_Lreactbuild_format_dxf_Point3D.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Point3D.prototype.constructor = $c_Lreactbuild_format_dxf_Point3D;
/** @constructor */
function $h_Lreactbuild_format_dxf_Point3D() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Point3D.prototype = $c_Lreactbuild_format_dxf_Point3D.prototype;
$c_Lreactbuild_format_dxf_Point3D.prototype.productPrefix__T = (function() {
  return "Point3D"
});
$c_Lreactbuild_format_dxf_Point3D.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_format_dxf_Point3D.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Point3D__f_x;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Point3D__f_y;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_Point3D__f_z;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Point3D.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Point3D.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Point3D");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_format_dxf_Point3D__f_x;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_format_dxf_Point3D__f_y;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$2 = this.Lreactbuild_format_dxf_Point3D__f_z;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_format_dxf_Point3D.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Point3D.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Point3D)) {
    var Point3D$1 = $as_Lreactbuild_format_dxf_Point3D(x$1);
    return ((this.Lreactbuild_format_dxf_Point3D__f_x === $n(Point3D$1).Lreactbuild_format_dxf_Point3D__f_x) && ((this.Lreactbuild_format_dxf_Point3D__f_y === $n(Point3D$1).Lreactbuild_format_dxf_Point3D__f_y) && (this.Lreactbuild_format_dxf_Point3D__f_z === $n(Point3D$1).Lreactbuild_format_dxf_Point3D__f_z)))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Point3D(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Point3D) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Point3D"))
}
function $isArrayOf_Lreactbuild_format_dxf_Point3D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Point3D)))
}
function $asArrayOf_Lreactbuild_format_dxf_Point3D(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Point3D(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Point3D;", depth))
}
var $d_Lreactbuild_format_dxf_Point3D = new $TypeData().initClass({
  Lreactbuild_format_dxf_Point3D: 0
}, false, "reactbuild.format.dxf.Point3D", {
  Lreactbuild_format_dxf_Point3D: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Point3D.prototype.$classData = $d_Lreactbuild_format_dxf_Point3D;
/** @constructor */
function $c_Lreactbuild_format_dxf_Record(groupCode, data) {
  this.Lreactbuild_format_dxf_Record__f_groupCode = null;
  this.Lreactbuild_format_dxf_Record__f_data = null;
  this.Lreactbuild_format_dxf_Record__f_groupCode = groupCode;
  this.Lreactbuild_format_dxf_Record__f_data = data
}
$c_Lreactbuild_format_dxf_Record.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Record.prototype.constructor = $c_Lreactbuild_format_dxf_Record;
/** @constructor */
function $h_Lreactbuild_format_dxf_Record() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Record.prototype = $c_Lreactbuild_format_dxf_Record.prototype;
$c_Lreactbuild_format_dxf_Record.prototype.productPrefix__T = (function() {
  return "Record"
});
$c_Lreactbuild_format_dxf_Record.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_dxf_Record.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Record__f_groupCode;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Record__f_data;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Record.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Record.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Record.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Record.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Record)) {
    var Record$1 = $as_Lreactbuild_format_dxf_Record(x$1);
    var x = this.Lreactbuild_format_dxf_Record__f_groupCode;
    var x$2 = $n(Record$1).Lreactbuild_format_dxf_Record__f_groupCode;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lreactbuild_format_dxf_Record__f_data === $n(Record$1).Lreactbuild_format_dxf_Record__f_data)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Record(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Record) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Record"))
}
function $isArrayOf_Lreactbuild_format_dxf_Record(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Record)))
}
function $asArrayOf_Lreactbuild_format_dxf_Record(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Record(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Record;", depth))
}
var $d_Lreactbuild_format_dxf_Record = new $TypeData().initClass({
  Lreactbuild_format_dxf_Record: 0
}, false, "reactbuild.format.dxf.Record", {
  Lreactbuild_format_dxf_Record: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Record.prototype.$classData = $d_Lreactbuild_format_dxf_Record;
/** @constructor */
function $c_Lreactbuild_format_dxf_RecordCursor(index, records) {
  this.Lreactbuild_format_dxf_RecordCursor__f_index = 0;
  this.Lreactbuild_format_dxf_RecordCursor__f_records = null;
  this.Lreactbuild_format_dxf_RecordCursor__f_index = index;
  this.Lreactbuild_format_dxf_RecordCursor__f_records = records
}
$c_Lreactbuild_format_dxf_RecordCursor.prototype = new $h_O();
$c_Lreactbuild_format_dxf_RecordCursor.prototype.constructor = $c_Lreactbuild_format_dxf_RecordCursor;
/** @constructor */
function $h_Lreactbuild_format_dxf_RecordCursor() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_RecordCursor.prototype = $c_Lreactbuild_format_dxf_RecordCursor.prototype;
$c_Lreactbuild_format_dxf_RecordCursor.prototype.value__Lreactbuild_format_dxf_Record = (function() {
  return $n(this.Lreactbuild_format_dxf_RecordCursor__f_records).get(this.Lreactbuild_format_dxf_RecordCursor__f_index)
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.down__Lreactbuild_format_dxf_RecordCursor = (function() {
  var index = ((1 + this.Lreactbuild_format_dxf_RecordCursor__f_index) | 0);
  var records = this.Lreactbuild_format_dxf_RecordCursor__f_records;
  return new $c_Lreactbuild_format_dxf_RecordCursor(index, records)
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.succeeded__Z = (function() {
  return (this.Lreactbuild_format_dxf_RecordCursor__f_index < $n(this.Lreactbuild_format_dxf_RecordCursor__f_records).u.length)
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.after__sci_Seq__s_Option = (function(records) {
  var x1 = $n(records).startsWith__sc_IterableOnce__I__Z(records, this.Lreactbuild_format_dxf_RecordCursor__f_index);
  if ((x1 === true)) {
    var index = ((this.Lreactbuild_format_dxf_RecordCursor__f_index + $n(records).length__I()) | 0);
    var records$1 = this.Lreactbuild_format_dxf_RecordCursor__f_records;
    return new $c_s_Some(new $c_Lreactbuild_format_dxf_RecordCursor(index, records$1))
  } else if ((x1 === false)) {
    return $m_s_None$()
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.productPrefix__T = (function() {
  return "RecordCursor"
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_RecordCursor__f_index;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_RecordCursor__f_records;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("RecordCursor");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_format_dxf_RecordCursor__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_format_dxf_RecordCursor__f_records;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_RecordCursor)) {
    var RecordCursor$1 = $as_Lreactbuild_format_dxf_RecordCursor(x$1);
    return ((this.Lreactbuild_format_dxf_RecordCursor__f_index === $n(RecordCursor$1).Lreactbuild_format_dxf_RecordCursor__f_index) && (this.Lreactbuild_format_dxf_RecordCursor__f_records === $n(RecordCursor$1).Lreactbuild_format_dxf_RecordCursor__f_records))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_RecordCursor(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_RecordCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.RecordCursor"))
}
function $isArrayOf_Lreactbuild_format_dxf_RecordCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_RecordCursor)))
}
function $asArrayOf_Lreactbuild_format_dxf_RecordCursor(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_RecordCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.RecordCursor;", depth))
}
var $d_Lreactbuild_format_dxf_RecordCursor = new $TypeData().initClass({
  Lreactbuild_format_dxf_RecordCursor: 0
}, false, "reactbuild.format.dxf.RecordCursor", {
  Lreactbuild_format_dxf_RecordCursor: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_RecordCursor.prototype.$classData = $d_Lreactbuild_format_dxf_RecordCursor;
/** @constructor */
function $c_Lreactbuild_format_dxf_Section(content) {
  this.Lreactbuild_format_dxf_Section__f_content = null;
  this.Lreactbuild_format_dxf_Section__f_content = content
}
$c_Lreactbuild_format_dxf_Section.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Section.prototype.constructor = $c_Lreactbuild_format_dxf_Section;
/** @constructor */
function $h_Lreactbuild_format_dxf_Section() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Section.prototype = $c_Lreactbuild_format_dxf_Section.prototype;
$c_Lreactbuild_format_dxf_Section.prototype.productPrefix__T = (function() {
  return "Section"
});
$c_Lreactbuild_format_dxf_Section.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_Section.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_Section__f_content : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_Section.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Section.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Section.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Section.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Section)) {
    var Section$1 = $as_Lreactbuild_format_dxf_Section(x$1);
    var x = this.Lreactbuild_format_dxf_Section__f_content;
    var y = $n(Section$1).Lreactbuild_format_dxf_Section__f_content;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Section(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Section) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Section"))
}
function $isArrayOf_Lreactbuild_format_dxf_Section(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Section)))
}
function $asArrayOf_Lreactbuild_format_dxf_Section(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Section(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Section;", depth))
}
var $d_Lreactbuild_format_dxf_Section = new $TypeData().initClass({
  Lreactbuild_format_dxf_Section: 0
}, false, "reactbuild.format.dxf.Section", {
  Lreactbuild_format_dxf_Section: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Section.prototype.$classData = $d_Lreactbuild_format_dxf_Section;
/** @constructor */
function $c_Lreactbuild_format_dxf_SectionList(headers, classes, tables, blocks, entities, objects, thumbnailImage) {
  this.Lreactbuild_format_dxf_SectionList__f_headers = null;
  this.Lreactbuild_format_dxf_SectionList__f_classes = null;
  this.Lreactbuild_format_dxf_SectionList__f_tables = null;
  this.Lreactbuild_format_dxf_SectionList__f_blocks = null;
  this.Lreactbuild_format_dxf_SectionList__f_entities = null;
  this.Lreactbuild_format_dxf_SectionList__f_objects = null;
  this.Lreactbuild_format_dxf_SectionList__f_thumbnailImage = null;
  this.Lreactbuild_format_dxf_SectionList__f_headers = headers;
  this.Lreactbuild_format_dxf_SectionList__f_classes = classes;
  this.Lreactbuild_format_dxf_SectionList__f_tables = tables;
  this.Lreactbuild_format_dxf_SectionList__f_blocks = blocks;
  this.Lreactbuild_format_dxf_SectionList__f_entities = entities;
  this.Lreactbuild_format_dxf_SectionList__f_objects = objects;
  this.Lreactbuild_format_dxf_SectionList__f_thumbnailImage = thumbnailImage
}
$c_Lreactbuild_format_dxf_SectionList.prototype = new $h_O();
$c_Lreactbuild_format_dxf_SectionList.prototype.constructor = $c_Lreactbuild_format_dxf_SectionList;
/** @constructor */
function $h_Lreactbuild_format_dxf_SectionList() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_SectionList.prototype = $c_Lreactbuild_format_dxf_SectionList.prototype;
$c_Lreactbuild_format_dxf_SectionList.prototype.productPrefix__T = (function() {
  return "SectionList"
});
$c_Lreactbuild_format_dxf_SectionList.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_format_dxf_SectionList.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_SectionList__f_headers;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_SectionList__f_classes;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_SectionList__f_tables;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_SectionList__f_blocks;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_SectionList__f_entities;
      break
    }
    case 5: {
      return this.Lreactbuild_format_dxf_SectionList__f_objects;
      break
    }
    case 6: {
      return this.Lreactbuild_format_dxf_SectionList__f_thumbnailImage;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_SectionList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_SectionList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_SectionList.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_SectionList.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_SectionList)) {
    var SectionList$1 = $as_Lreactbuild_format_dxf_SectionList(x$1);
    var x = this.Lreactbuild_format_dxf_SectionList__f_headers;
    var x$2 = $n(SectionList$1).Lreactbuild_format_dxf_SectionList__f_headers;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_dxf_SectionList__f_classes;
      var x$4 = $n(SectionList$1).Lreactbuild_format_dxf_SectionList__f_classes;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_format_dxf_SectionList__f_tables;
        var x$6 = $n(SectionList$1).Lreactbuild_format_dxf_SectionList__f_tables;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_format_dxf_SectionList__f_blocks;
      var x$8 = $n(SectionList$1).Lreactbuild_format_dxf_SectionList__f_blocks;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_format_dxf_SectionList__f_entities;
        var x$10 = $n(SectionList$1).Lreactbuild_format_dxf_SectionList__f_entities;
        var $$x2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$11 = this.Lreactbuild_format_dxf_SectionList__f_objects;
        var x$12 = $n(SectionList$1).Lreactbuild_format_dxf_SectionList__f_objects;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_format_dxf_SectionList__f_thumbnailImage;
          var x$14 = $n(SectionList$1).Lreactbuild_format_dxf_SectionList__f_thumbnailImage;
          return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_SectionList(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_SectionList) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.SectionList"))
}
function $isArrayOf_Lreactbuild_format_dxf_SectionList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_SectionList)))
}
function $asArrayOf_Lreactbuild_format_dxf_SectionList(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_SectionList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.SectionList;", depth))
}
var $d_Lreactbuild_format_dxf_SectionList = new $TypeData().initClass({
  Lreactbuild_format_dxf_SectionList: 0
}, false, "reactbuild.format.dxf.SectionList", {
  Lreactbuild_format_dxf_SectionList: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_SectionList.prototype.$classData = $d_Lreactbuild_format_dxf_SectionList;
/** @constructor */
function $c_Lreactbuild_format_dxf_Style(name, flags, fixedTextHeight, widthFactor, obliqueAngle, textGenerationFlags, lastHeightUsed, primaryFontFileName, bigfontFileName) {
  this.Lreactbuild_format_dxf_Style__f_name = null;
  this.Lreactbuild_format_dxf_Style__f_flags = null;
  this.Lreactbuild_format_dxf_Style__f_fixedTextHeight = 0.0;
  this.Lreactbuild_format_dxf_Style__f_widthFactor = 0.0;
  this.Lreactbuild_format_dxf_Style__f_obliqueAngle = 0.0;
  this.Lreactbuild_format_dxf_Style__f_textGenerationFlags = 0;
  this.Lreactbuild_format_dxf_Style__f_lastHeightUsed = 0.0;
  this.Lreactbuild_format_dxf_Style__f_primaryFontFileName = null;
  this.Lreactbuild_format_dxf_Style__f_bigfontFileName = null;
  this.Lreactbuild_format_dxf_Style__f_name = name;
  this.Lreactbuild_format_dxf_Style__f_flags = flags;
  this.Lreactbuild_format_dxf_Style__f_fixedTextHeight = fixedTextHeight;
  this.Lreactbuild_format_dxf_Style__f_widthFactor = widthFactor;
  this.Lreactbuild_format_dxf_Style__f_obliqueAngle = obliqueAngle;
  this.Lreactbuild_format_dxf_Style__f_textGenerationFlags = textGenerationFlags;
  this.Lreactbuild_format_dxf_Style__f_lastHeightUsed = lastHeightUsed;
  this.Lreactbuild_format_dxf_Style__f_primaryFontFileName = primaryFontFileName;
  this.Lreactbuild_format_dxf_Style__f_bigfontFileName = bigfontFileName
}
$c_Lreactbuild_format_dxf_Style.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Style.prototype.constructor = $c_Lreactbuild_format_dxf_Style;
/** @constructor */
function $h_Lreactbuild_format_dxf_Style() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Style.prototype = $c_Lreactbuild_format_dxf_Style.prototype;
$c_Lreactbuild_format_dxf_Style.prototype.productPrefix__T = (function() {
  return "Style"
});
$c_Lreactbuild_format_dxf_Style.prototype.productArity__I = (function() {
  return 9
});
$c_Lreactbuild_format_dxf_Style.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Style__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Style__f_flags;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_Style__f_fixedTextHeight;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_Style__f_widthFactor;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_Style__f_obliqueAngle;
      break
    }
    case 5: {
      return this.Lreactbuild_format_dxf_Style__f_textGenerationFlags;
      break
    }
    case 6: {
      return this.Lreactbuild_format_dxf_Style__f_lastHeightUsed;
      break
    }
    case 7: {
      return this.Lreactbuild_format_dxf_Style__f_primaryFontFileName;
      break
    }
    case 8: {
      return this.Lreactbuild_format_dxf_Style__f_bigfontFileName;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Style.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Style.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Style");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_format_dxf_Style__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_format_dxf_Style__f_flags;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv = this.Lreactbuild_format_dxf_Style__f_fixedTextHeight;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$1 = this.Lreactbuild_format_dxf_Style__f_widthFactor;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var dv$2 = this.Lreactbuild_format_dxf_Style__f_obliqueAngle;
  var data$5 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = this.Lreactbuild_format_dxf_Style__f_textGenerationFlags;
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var dv$3 = this.Lreactbuild_format_dxf_Style__f_lastHeightUsed;
  var data$7 = $m_sr_Statics$().doubleHash__D__I(dv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$2 = this.Lreactbuild_format_dxf_Style__f_primaryFontFileName;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$3 = this.Lreactbuild_format_dxf_Style__f_bigfontFileName;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$10, 9)
});
$c_Lreactbuild_format_dxf_Style.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Style.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Style)) {
    var Style$1 = $as_Lreactbuild_format_dxf_Style(x$1);
    if ((((this.Lreactbuild_format_dxf_Style__f_fixedTextHeight === $n(Style$1).Lreactbuild_format_dxf_Style__f_fixedTextHeight) && (this.Lreactbuild_format_dxf_Style__f_widthFactor === $n(Style$1).Lreactbuild_format_dxf_Style__f_widthFactor)) && ((this.Lreactbuild_format_dxf_Style__f_obliqueAngle === $n(Style$1).Lreactbuild_format_dxf_Style__f_obliqueAngle) && (this.Lreactbuild_format_dxf_Style__f_textGenerationFlags === $n(Style$1).Lreactbuild_format_dxf_Style__f_textGenerationFlags)))) {
      if ((this.Lreactbuild_format_dxf_Style__f_lastHeightUsed === $n(Style$1).Lreactbuild_format_dxf_Style__f_lastHeightUsed)) {
        var x = this.Lreactbuild_format_dxf_Style__f_name;
        var x$2 = $n(Style$1).Lreactbuild_format_dxf_Style__f_name;
        var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$3 = this.Lreactbuild_format_dxf_Style__f_flags;
        var x$4 = $n(Style$1).Lreactbuild_format_dxf_Style__f_flags;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          return ((this.Lreactbuild_format_dxf_Style__f_primaryFontFileName === $n(Style$1).Lreactbuild_format_dxf_Style__f_primaryFontFileName) && (this.Lreactbuild_format_dxf_Style__f_bigfontFileName === $n(Style$1).Lreactbuild_format_dxf_Style__f_bigfontFileName))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Style(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Style) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Style"))
}
function $isArrayOf_Lreactbuild_format_dxf_Style(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Style)))
}
function $asArrayOf_Lreactbuild_format_dxf_Style(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Style(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Style;", depth))
}
var $d_Lreactbuild_format_dxf_Style = new $TypeData().initClass({
  Lreactbuild_format_dxf_Style: 0
}, false, "reactbuild.format.dxf.Style", {
  Lreactbuild_format_dxf_Style: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Style.prototype.$classData = $d_Lreactbuild_format_dxf_Style;
/** @constructor */
function $c_Lreactbuild_format_dxf_Table(entries) {
  this.Lreactbuild_format_dxf_Table__f_entries = null;
  this.Lreactbuild_format_dxf_Table__f_entries = entries
}
$c_Lreactbuild_format_dxf_Table.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Table.prototype.constructor = $c_Lreactbuild_format_dxf_Table;
/** @constructor */
function $h_Lreactbuild_format_dxf_Table() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Table.prototype = $c_Lreactbuild_format_dxf_Table.prototype;
$c_Lreactbuild_format_dxf_Table.prototype.productPrefix__T = (function() {
  return "Table"
});
$c_Lreactbuild_format_dxf_Table.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_Table.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_Table__f_entries : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_Table.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Table.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Table.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Table.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Table)) {
    var Table$1 = $as_Lreactbuild_format_dxf_Table(x$1);
    var x = this.Lreactbuild_format_dxf_Table__f_entries;
    var x$2 = $n(Table$1).Lreactbuild_format_dxf_Table__f_entries;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Table(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Table) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Table"))
}
function $isArrayOf_Lreactbuild_format_dxf_Table(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Table)))
}
function $asArrayOf_Lreactbuild_format_dxf_Table(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Table(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Table;", depth))
}
var $d_Lreactbuild_format_dxf_Table = new $TypeData().initClass({
  Lreactbuild_format_dxf_Table: 0
}, false, "reactbuild.format.dxf.Table", {
  Lreactbuild_format_dxf_Table: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Table.prototype.$classData = $d_Lreactbuild_format_dxf_Table;
/** @constructor */
function $c_Lreactbuild_format_dxf_Tables(viewportConfigurationTable, lineTypeTable, layerTable, textStyleTable, viewTable) {
  this.Lreactbuild_format_dxf_Tables__f_viewportConfigurationTable = null;
  this.Lreactbuild_format_dxf_Tables__f_lineTypeTable = null;
  this.Lreactbuild_format_dxf_Tables__f_layerTable = null;
  this.Lreactbuild_format_dxf_Tables__f_textStyleTable = null;
  this.Lreactbuild_format_dxf_Tables__f_viewTable = null;
  this.Lreactbuild_format_dxf_Tables__f_viewportConfigurationTable = viewportConfigurationTable;
  this.Lreactbuild_format_dxf_Tables__f_lineTypeTable = lineTypeTable;
  this.Lreactbuild_format_dxf_Tables__f_layerTable = layerTable;
  this.Lreactbuild_format_dxf_Tables__f_textStyleTable = textStyleTable;
  this.Lreactbuild_format_dxf_Tables__f_viewTable = viewTable
}
$c_Lreactbuild_format_dxf_Tables.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Tables.prototype.constructor = $c_Lreactbuild_format_dxf_Tables;
/** @constructor */
function $h_Lreactbuild_format_dxf_Tables() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Tables.prototype = $c_Lreactbuild_format_dxf_Tables.prototype;
$c_Lreactbuild_format_dxf_Tables.prototype.productPrefix__T = (function() {
  return "Tables"
});
$c_Lreactbuild_format_dxf_Tables.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_format_dxf_Tables.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Tables__f_viewportConfigurationTable;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Tables__f_lineTypeTable;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_Tables__f_layerTable;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_Tables__f_textStyleTable;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_Tables__f_viewTable;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Tables.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Tables.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Tables.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Tables.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Tables)) {
    var Tables$1 = $as_Lreactbuild_format_dxf_Tables(x$1);
    var x = this.Lreactbuild_format_dxf_Tables__f_viewportConfigurationTable;
    var x$2 = $n(Tables$1).Lreactbuild_format_dxf_Tables__f_viewportConfigurationTable;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_dxf_Tables__f_lineTypeTable;
      var x$4 = $n(Tables$1).Lreactbuild_format_dxf_Tables__f_lineTypeTable;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_format_dxf_Tables__f_layerTable;
      var x$6 = $n(Tables$1).Lreactbuild_format_dxf_Tables__f_layerTable;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_format_dxf_Tables__f_textStyleTable;
        var x$8 = $n(Tables$1).Lreactbuild_format_dxf_Tables__f_textStyleTable;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_format_dxf_Tables__f_viewTable;
          var x$10 = $n(Tables$1).Lreactbuild_format_dxf_Tables__f_viewTable;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Tables(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Tables) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Tables"))
}
function $isArrayOf_Lreactbuild_format_dxf_Tables(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Tables)))
}
function $asArrayOf_Lreactbuild_format_dxf_Tables(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Tables(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Tables;", depth))
}
var $d_Lreactbuild_format_dxf_Tables = new $TypeData().initClass({
  Lreactbuild_format_dxf_Tables: 0
}, false, "reactbuild.format.dxf.Tables", {
  Lreactbuild_format_dxf_Tables: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Tables.prototype.$classData = $d_Lreactbuild_format_dxf_Tables;
/** @constructor */
function $c_Lreactbuild_format_dxf_ThumbnailImage() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype = new $h_O();
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype.constructor = $c_Lreactbuild_format_dxf_ThumbnailImage;
/** @constructor */
function $h_Lreactbuild_format_dxf_ThumbnailImage() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_ThumbnailImage.prototype = $c_Lreactbuild_format_dxf_ThumbnailImage.prototype;
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype.productPrefix__T = (function() {
  return "ThumbnailImage"
});
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_format_dxf_ThumbnailImage)
});
function $as_Lreactbuild_format_dxf_ThumbnailImage(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_ThumbnailImage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.ThumbnailImage"))
}
function $isArrayOf_Lreactbuild_format_dxf_ThumbnailImage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_ThumbnailImage)))
}
function $asArrayOf_Lreactbuild_format_dxf_ThumbnailImage(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_ThumbnailImage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.ThumbnailImage;", depth))
}
var $d_Lreactbuild_format_dxf_ThumbnailImage = new $TypeData().initClass({
  Lreactbuild_format_dxf_ThumbnailImage: 0
}, false, "reactbuild.format.dxf.ThumbnailImage", {
  Lreactbuild_format_dxf_ThumbnailImage: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_ThumbnailImage.prototype.$classData = $d_Lreactbuild_format_dxf_ThumbnailImage;
/** @constructor */
function $c_Lreactbuild_format_dxf_VPort(flags) {
  this.Lreactbuild_format_dxf_VPort__f_flags = null;
  this.Lreactbuild_format_dxf_VPort__f_flags = flags
}
$c_Lreactbuild_format_dxf_VPort.prototype = new $h_O();
$c_Lreactbuild_format_dxf_VPort.prototype.constructor = $c_Lreactbuild_format_dxf_VPort;
/** @constructor */
function $h_Lreactbuild_format_dxf_VPort() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_VPort.prototype = $c_Lreactbuild_format_dxf_VPort.prototype;
$c_Lreactbuild_format_dxf_VPort.prototype.productPrefix__T = (function() {
  return "VPort"
});
$c_Lreactbuild_format_dxf_VPort.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_VPort.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_VPort__f_flags : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_VPort.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_VPort.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_VPort.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_VPort.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_VPort)) {
    var VPort$1 = $as_Lreactbuild_format_dxf_VPort(x$1);
    var x = this.Lreactbuild_format_dxf_VPort__f_flags;
    var x$2 = $n(VPort$1).Lreactbuild_format_dxf_VPort__f_flags;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_VPort(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_VPort) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.VPort"))
}
function $isArrayOf_Lreactbuild_format_dxf_VPort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_VPort)))
}
function $asArrayOf_Lreactbuild_format_dxf_VPort(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_VPort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.VPort;", depth))
}
var $d_Lreactbuild_format_dxf_VPort = new $TypeData().initClass({
  Lreactbuild_format_dxf_VPort: 0
}, false, "reactbuild.format.dxf.VPort", {
  Lreactbuild_format_dxf_VPort: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_VPort.prototype.$classData = $d_Lreactbuild_format_dxf_VPort;
/** @constructor */
function $c_Lreactbuild_format_dxf_Vertex2D(x, y, z, startingWith, endWith, bulge) {
  this.Lreactbuild_format_dxf_Vertex2D__f_x = 0.0;
  this.Lreactbuild_format_dxf_Vertex2D__f_y = 0.0;
  this.Lreactbuild_format_dxf_Vertex2D__f_z = 0.0;
  this.Lreactbuild_format_dxf_Vertex2D__f_startingWith = null;
  this.Lreactbuild_format_dxf_Vertex2D__f_endWith = null;
  this.Lreactbuild_format_dxf_Vertex2D__f_bulge = null;
  this.Lreactbuild_format_dxf_Vertex2D__f_x = x;
  this.Lreactbuild_format_dxf_Vertex2D__f_y = y;
  this.Lreactbuild_format_dxf_Vertex2D__f_z = z;
  this.Lreactbuild_format_dxf_Vertex2D__f_startingWith = startingWith;
  this.Lreactbuild_format_dxf_Vertex2D__f_endWith = endWith;
  this.Lreactbuild_format_dxf_Vertex2D__f_bulge = bulge
}
$c_Lreactbuild_format_dxf_Vertex2D.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Vertex2D.prototype.constructor = $c_Lreactbuild_format_dxf_Vertex2D;
/** @constructor */
function $h_Lreactbuild_format_dxf_Vertex2D() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Vertex2D.prototype = $c_Lreactbuild_format_dxf_Vertex2D.prototype;
$c_Lreactbuild_format_dxf_Vertex2D.prototype.productPrefix__T = (function() {
  return "Vertex2D"
});
$c_Lreactbuild_format_dxf_Vertex2D.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_format_dxf_Vertex2D.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Vertex2D__f_x;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Vertex2D__f_y;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_Vertex2D__f_z;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_Vertex2D__f_startingWith;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_Vertex2D__f_endWith;
      break
    }
    case 5: {
      return this.Lreactbuild_format_dxf_Vertex2D__f_bulge;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Vertex2D.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Vertex2D.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Vertex2D");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_format_dxf_Vertex2D__f_x;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_format_dxf_Vertex2D__f_y;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$2 = this.Lreactbuild_format_dxf_Vertex2D__f_z;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x = this.Lreactbuild_format_dxf_Vertex2D__f_startingWith;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$1 = this.Lreactbuild_format_dxf_Vertex2D__f_endWith;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$2 = this.Lreactbuild_format_dxf_Vertex2D__f_bulge;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_format_dxf_Vertex2D.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Vertex2D.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Vertex2D)) {
    var Vertex2D$1 = $as_Lreactbuild_format_dxf_Vertex2D(x$1);
    if (((this.Lreactbuild_format_dxf_Vertex2D__f_x === $n(Vertex2D$1).Lreactbuild_format_dxf_Vertex2D__f_x) && ((this.Lreactbuild_format_dxf_Vertex2D__f_y === $n(Vertex2D$1).Lreactbuild_format_dxf_Vertex2D__f_y) && (this.Lreactbuild_format_dxf_Vertex2D__f_z === $n(Vertex2D$1).Lreactbuild_format_dxf_Vertex2D__f_z)))) {
      var x = this.Lreactbuild_format_dxf_Vertex2D__f_startingWith;
      var x$2 = $n(Vertex2D$1).Lreactbuild_format_dxf_Vertex2D__f_startingWith;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_format_dxf_Vertex2D__f_endWith;
        var x$4 = $n(Vertex2D$1).Lreactbuild_format_dxf_Vertex2D__f_endWith;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_format_dxf_Vertex2D__f_bulge;
          var x$6 = $n(Vertex2D$1).Lreactbuild_format_dxf_Vertex2D__f_bulge;
          return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Vertex2D(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Vertex2D) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Vertex2D"))
}
function $isArrayOf_Lreactbuild_format_dxf_Vertex2D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Vertex2D)))
}
function $asArrayOf_Lreactbuild_format_dxf_Vertex2D(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Vertex2D(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Vertex2D;", depth))
}
var $d_Lreactbuild_format_dxf_Vertex2D = new $TypeData().initClass({
  Lreactbuild_format_dxf_Vertex2D: 0
}, false, "reactbuild.format.dxf.Vertex2D", {
  Lreactbuild_format_dxf_Vertex2D: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Vertex2D.prototype.$classData = $d_Lreactbuild_format_dxf_Vertex2D;
/** @constructor */
function $c_Lreactbuild_format_dxf_View() {
  /*<skip>*/
}
$c_Lreactbuild_format_dxf_View.prototype = new $h_O();
$c_Lreactbuild_format_dxf_View.prototype.constructor = $c_Lreactbuild_format_dxf_View;
/** @constructor */
function $h_Lreactbuild_format_dxf_View() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_View.prototype = $c_Lreactbuild_format_dxf_View.prototype;
$c_Lreactbuild_format_dxf_View.prototype.productPrefix__T = (function() {
  return "View"
});
$c_Lreactbuild_format_dxf_View.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_format_dxf_View.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_format_dxf_View.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_View.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_View.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_View.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_format_dxf_View)
});
function $as_Lreactbuild_format_dxf_View(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_View) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.View"))
}
function $isArrayOf_Lreactbuild_format_dxf_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_View)))
}
function $asArrayOf_Lreactbuild_format_dxf_View(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_View(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.View;", depth))
}
var $d_Lreactbuild_format_dxf_View = new $TypeData().initClass({
  Lreactbuild_format_dxf_View: 0
}, false, "reactbuild.format.dxf.View", {
  Lreactbuild_format_dxf_View: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_View.prototype.$classData = $d_Lreactbuild_format_dxf_View;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Bacacier$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$Bacacier$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_format_iz2use_package$Bacacier$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Bacacier$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Bacacier$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Bacacier$.prototype = $c_Lreactbuild_format_iz2use_package$Bacacier$.prototype;
$c_Lreactbuild_format_iz2use_package$Bacacier$.prototype.toString__T = (function() {
  return "Bacacier"
});
$c_Lreactbuild_format_iz2use_package$Bacacier$.prototype.apply__O__O__O = (function(v1, v2) {
  var index = $as_s_Option(v1);
  var height = $as_s_Option(v2);
  return new $c_Lreactbuild_format_iz2use_package$Bacacier(index, height)
});
var $d_Lreactbuild_format_iz2use_package$Bacacier$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Bacacier$: 0
}, false, "reactbuild.format.iz2use.package$Bacacier$", {
  Lreactbuild_format_iz2use_package$Bacacier$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Bacacier$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Bacacier$;
var $n_Lreactbuild_format_iz2use_package$Bacacier$;
function $m_Lreactbuild_format_iz2use_package$Bacacier$() {
  if ((!$n_Lreactbuild_format_iz2use_package$Bacacier$)) {
    $n_Lreactbuild_format_iz2use_package$Bacacier$ = new $c_Lreactbuild_format_iz2use_package$Bacacier$()
  };
  return $n_Lreactbuild_format_iz2use_package$Bacacier$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Building(name, description, settings, storeys) {
  this.Lreactbuild_format_iz2use_package$Building__f_name = null;
  this.Lreactbuild_format_iz2use_package$Building__f_description = null;
  this.Lreactbuild_format_iz2use_package$Building__f_settings = null;
  this.Lreactbuild_format_iz2use_package$Building__f_storeys = null;
  this.Lreactbuild_format_iz2use_package$Building__f_name = name;
  this.Lreactbuild_format_iz2use_package$Building__f_description = description;
  this.Lreactbuild_format_iz2use_package$Building__f_settings = settings;
  this.Lreactbuild_format_iz2use_package$Building__f_storeys = storeys
}
$c_Lreactbuild_format_iz2use_package$Building.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Building.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Building;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Building() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Building.prototype = $c_Lreactbuild_format_iz2use_package$Building.prototype;
$c_Lreactbuild_format_iz2use_package$Building.prototype.productPrefix__T = (function() {
  return "Building"
});
$c_Lreactbuild_format_iz2use_package$Building.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_format_iz2use_package$Building.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$Building__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$Building__f_description;
      break
    }
    case 2: {
      return this.Lreactbuild_format_iz2use_package$Building__f_settings;
      break
    }
    case 3: {
      return this.Lreactbuild_format_iz2use_package$Building__f_storeys;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$Building.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$Building.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$Building.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$Building.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$Building)) {
    var Building$1 = $as_Lreactbuild_format_iz2use_package$Building(x$1);
    if (((this.Lreactbuild_format_iz2use_package$Building__f_name === $n(Building$1).Lreactbuild_format_iz2use_package$Building__f_name) && (this.Lreactbuild_format_iz2use_package$Building__f_description === $n(Building$1).Lreactbuild_format_iz2use_package$Building__f_description))) {
      var x = this.Lreactbuild_format_iz2use_package$Building__f_settings;
      var x$2 = $n(Building$1).Lreactbuild_format_iz2use_package$Building__f_settings;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_format_iz2use_package$Building__f_storeys;
        var x$4 = $n(Building$1).Lreactbuild_format_iz2use_package$Building__f_storeys;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$Building(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$Building) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$Building"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$Building(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$Building)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$Building(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$Building(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$Building;", depth))
}
var $d_Lreactbuild_format_iz2use_package$Building = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Building: 0
}, false, "reactbuild.format.iz2use.package$Building", {
  Lreactbuild_format_iz2use_package$Building: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Building.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Building;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Building$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$Building$.prototype = new $h_sr_AbstractFunction4();
$c_Lreactbuild_format_iz2use_package$Building$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Building$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Building$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Building$.prototype = $c_Lreactbuild_format_iz2use_package$Building$.prototype;
$c_Lreactbuild_format_iz2use_package$Building$.prototype.toString__T = (function() {
  return "Building"
});
$c_Lreactbuild_format_iz2use_package$Building$.prototype.apply__O__O__O__O__O = (function(v1, v2, v3, v4) {
  var name = $as_T(v1);
  var description = $as_T(v2);
  var settings = $as_sci_List(v3);
  var storeys = $as_sci_List(v4);
  return new $c_Lreactbuild_format_iz2use_package$Building(name, description, settings, storeys)
});
var $d_Lreactbuild_format_iz2use_package$Building$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Building$: 0
}, false, "reactbuild.format.iz2use.package$Building$", {
  Lreactbuild_format_iz2use_package$Building$: 1,
  sr_AbstractFunction4: 1,
  O: 1,
  F4: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Building$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Building$;
var $n_Lreactbuild_format_iz2use_package$Building$;
function $m_Lreactbuild_format_iz2use_package$Building$() {
  if ((!$n_Lreactbuild_format_iz2use_package$Building$)) {
    $n_Lreactbuild_format_iz2use_package$Building$ = new $c_Lreactbuild_format_iz2use_package$Building$()
  };
  return $n_Lreactbuild_format_iz2use_package$Building$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$ComponentColumn(components) {
  this.Lreactbuild_format_iz2use_package$ComponentColumn__f_components = null;
  this.Lreactbuild_format_iz2use_package$ComponentColumn__f_components = components
}
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype.constructor = $c_Lreactbuild_format_iz2use_package$ComponentColumn;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$ComponentColumn() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$ComponentColumn.prototype = $c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype;
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype.productPrefix__T = (function() {
  return "ComponentColumn"
});
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_iz2use_package$ComponentColumn__f_components : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$ComponentColumn)) {
    var ComponentColumn$1 = $as_Lreactbuild_format_iz2use_package$ComponentColumn(x$1);
    var x = this.Lreactbuild_format_iz2use_package$ComponentColumn__f_components;
    var x$2 = $n(ComponentColumn$1).Lreactbuild_format_iz2use_package$ComponentColumn__f_components;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$ComponentColumn(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$ComponentColumn) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$ComponentColumn"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$ComponentColumn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$ComponentColumn)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$ComponentColumn(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$ComponentColumn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$ComponentColumn;", depth))
}
var $d_Lreactbuild_format_iz2use_package$ComponentColumn = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$ComponentColumn: 0
}, false, "reactbuild.format.iz2use.package$ComponentColumn", {
  Lreactbuild_format_iz2use_package$ComponentColumn: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$ComponentColumn.prototype.$classData = $d_Lreactbuild_format_iz2use_package$ComponentColumn;
function $p_Lreactbuild_format_iz2use_package$ComponentGroup__loop$2__D__sci_List__sci_List__sci_List($thiz, acc, rest, results) {
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      return results
    };
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var p4 = $as_Lreactbuild_format_iz2use_package$ComponentColumn($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      if ((p4 !== null)) {
        var lst = $n(p4).Lreactbuild_format_iz2use_package$ComponentColumn__f_components;
        matchEnd9: {
          var columnWidth;
          if ((lst instanceof $c_sci_$colon$colon)) {
            var x2 = $as_sci_$colon$colon(lst);
            var p3 = $as_Lreactbuild_format_iz2use_package$ComponentInstance($n(x2).sci_$colon$colon__f_head);
            if ((p3 !== null)) {
              var p6 = $n(p3).Lreactbuild_format_iz2use_package$ComponentInstance__f_name;
              if ((p6 !== null)) {
                var o12 = $n($m_Lreactbuild_format_iz2use_package$().Lreactbuild_format_iz2use_package$__f_componentLengthPattern).unapplySeq__jl_CharSequence__s_Option(p6);
                if (((!$n(o12).isEmpty__Z()) && (($n(o12).get__O() !== null) && ($n($as_sci_List($n(o12).get__O())).lengthCompare__I__I(1) === 0)))) {
                  var length = $as_T($n($as_sc_LinearSeqOps($n(o12).get__O())).apply__I__O(0));
                  $m_sc_StringOps$();
                  var this$3 = $m_jl_Integer$();
                  var columnWidth = (10.0 * this$3.parseInt__T__I__I(length, 10));
                  break matchEnd9
                }
              }
            }
          };
          var columnWidth = 600.0
        };
        matchEnd7: {
          if ((lst instanceof $c_sci_$colon$colon)) {
            var x2$2 = $as_sci_$colon$colon(lst);
            var p3$2 = $as_Lreactbuild_format_iz2use_package$ComponentInstance($n(x2$2).sci_$colon$colon__f_head);
            if ((p3$2 !== null)) {
              var name = $n(p3$2).Lreactbuild_format_iz2use_package$ComponentInstance__f_name;
              $m_s_Option$().apply__O__s_Option(name);
              break matchEnd7
            }
          };
          $m_s_None$()
        };
        var x1$4 = $thiz.Lreactbuild_format_iz2use_package$ComponentGroup__f_offsets;
        var x$3 = $m_Lreactbuild_format_iz2use_package$NoOffset$();
        if ((x$3 === x1$4)) {
          var x1$5 = new $c_T3(0.0, 0.0, $m_s_None$())
        } else if ((x1$4 instanceof $c_Lreactbuild_format_iz2use_package$PositiveOffset)) {
          var x3$2 = $as_Lreactbuild_format_iz2use_package$PositiveOffset(x1$4);
          var length$2 = $n(x3$2).Lreactbuild_format_iz2use_package$PositiveOffset__f_from;
          var x1$5 = new $c_T3(0.0, (acc + $n(length$2).Lreactbuild_format_iz2use_package$Length__f_length), $m_s_None$())
        } else if ((x1$4 instanceof $c_Lreactbuild_format_iz2use_package$NegativeOffset)) {
          var x4 = $as_Lreactbuild_format_iz2use_package$NegativeOffset(x1$4);
          var length$3 = $n(x4).Lreactbuild_format_iz2use_package$NegativeOffset__f_to;
          var x1$5 = new $c_T3(1.0, (acc + $n(length$3).Lreactbuild_format_iz2use_package$Length__f_length), $m_s_None$())
        } else if ((x1$4 instanceof $c_Lreactbuild_format_iz2use_package$BothOffset)) {
          var x5 = $as_Lreactbuild_format_iz2use_package$BothOffset(x1$4);
          var positive = $n(x5).Lreactbuild_format_iz2use_package$BothOffset__f_from;
          var negative = $n(x5).Lreactbuild_format_iz2use_package$BothOffset__f_to;
          var x1$5 = new $c_T3(0.0, $n(positive).Lreactbuild_format_iz2use_package$Length__f_length, new $c_s_Some($n(negative).Lreactbuild_format_iz2use_package$Length__f_length))
        } else {
          var x1$5;
          throw new $c_s_MatchError(x1$4)
        };
        matchEnd6$2: {
          var x$2$2___1;
          var x$2$2___2;
          var x$2$2___3;
          if ((x1$5 !== null)) {
            var position = $uD($n(x1$5).T3__f__1);
            var offset0 = $n(x1$5).T3__f__2;
            var offset1 = $as_s_Option($n(x1$5).T3__f__3);
            if (((typeof offset0) === "number")) {
              var x3$3 = $uD(offset0);
              if ((offset1 !== null)) {
                var x$2$2___1 = position;
                var x$2$2___2 = x3$3;
                var x$2$2___3 = offset1;
                break matchEnd6$2
              }
            }
          };
          throw new $c_s_MatchError(x1$5)
        };
        var position$2 = $uD(x$2$2___1);
        var offset0$2 = $uD(x$2$2___2);
        var offset1$2 = $as_s_Option(x$2$2___3);
        var this$5 = $n(lst);
        var p = new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
          var check$ifrefutable$1 = $as_Lreactbuild_format_iz2use_package$ComponentInstance(check$ifrefutable$1$2);
          return (check$ifrefutable$1 !== null)
        }));
        var components = $as_sci_List($ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this$5, p).map__F1__O(new $c_sjsr_AnonFunction1(((position$2, offset0$2, offset1$2) => ((x$5$2) => {
          var x$5 = $as_Lreactbuild_format_iz2use_package$ComponentInstance(x$5$2);
          if ((x$5 !== null)) {
            var reverse = $n(x$5).Lreactbuild_format_iz2use_package$ComponentInstance__f_reverse;
            var definition = $n(x$5).Lreactbuild_format_iz2use_package$ComponentInstance__f_name;
            var this$6 = $n($thiz.Lreactbuild_format_iz2use_package$ComponentGroup__f_margin);
            if (this$6.isEmpty__Z()) {
              var $$x3 = $m_s_None$()
            } else {
              var arg1 = this$6.get__O();
              var x$3$1 = $as_Lreactbuild_format_iz2use_package$Length($n($as_Leu_timepit_refined_api_Refined(arg1)).Leu_timepit_refined_api_Refined__f_value);
              var $$x3 = new $c_s_Some($n(x$3$1).Lreactbuild_format_iz2use_package$Length__f_length)
            };
            var this$7 = $n($$x3);
            var $$x2 = $uD((this$7.isEmpty__Z() ? 0.0 : this$7.get__O()));
            var this$8 = $n($thiz.Lreactbuild_format_iz2use_package$ComponentGroup__f_z);
            if (this$8.isEmpty__Z()) {
              var $$x1 = $m_s_None$()
            } else {
              var arg1$1 = this$8.get__O();
              var x$4 = $as_Lreactbuild_format_iz2use_package$Length(arg1$1);
              var $$x1 = new $c_s_Some($n(x$4).Lreactbuild_format_iz2use_package$Length__f_length)
            };
            var this$9 = $n($$x1);
            return new $c_Lreactbuild_format_iz2use_package$ExpandedComponent(position$2, offset0$2, offset1$2, $$x2, $uD((this$9.isEmpty__Z() ? 0.0 : this$9.get__O())), reverse, definition)
          } else {
            throw new $c_s_MatchError(x$5)
          }
        }))(position$2, offset0$2, offset1$2))));
        var temp$acc = (acc + columnWidth);
        var this$10 = $n(results);
        var temp$results = this$10.appendedAll__sc_IterableOnce__sci_List(components);
        acc = temp$acc;
        rest = tail;
        results = temp$results;
        continue
      }
    };
    throw new $c_s_MatchError(x1)
  }
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$ComponentGroup(offsets, z, margin, columns) {
  this.Lreactbuild_format_iz2use_package$ComponentGroup__f_offsets = null;
  this.Lreactbuild_format_iz2use_package$ComponentGroup__f_z = null;
  this.Lreactbuild_format_iz2use_package$ComponentGroup__f_margin = null;
  this.Lreactbuild_format_iz2use_package$ComponentGroup__f_columns = null;
  this.Lreactbuild_format_iz2use_package$ComponentGroup__f_offsets = offsets;
  this.Lreactbuild_format_iz2use_package$ComponentGroup__f_z = z;
  this.Lreactbuild_format_iz2use_package$ComponentGroup__f_margin = margin;
  this.Lreactbuild_format_iz2use_package$ComponentGroup__f_columns = columns
}
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype.constructor = $c_Lreactbuild_format_iz2use_package$ComponentGroup;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$ComponentGroup() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$ComponentGroup.prototype = $c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype;
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype.productPrefix__T = (function() {
  return "ComponentGroup"
});
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$ComponentGroup__f_offsets;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$ComponentGroup__f_z;
      break
    }
    case 2: {
      return this.Lreactbuild_format_iz2use_package$ComponentGroup__f_margin;
      break
    }
    case 3: {
      return this.Lreactbuild_format_iz2use_package$ComponentGroup__f_columns;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$ComponentGroup)) {
    var ComponentGroup$1 = $as_Lreactbuild_format_iz2use_package$ComponentGroup(x$1);
    var x = this.Lreactbuild_format_iz2use_package$ComponentGroup__f_offsets;
    var x$2 = $n(ComponentGroup$1).Lreactbuild_format_iz2use_package$ComponentGroup__f_offsets;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_iz2use_package$ComponentGroup__f_z;
      var x$4 = $n(ComponentGroup$1).Lreactbuild_format_iz2use_package$ComponentGroup__f_z;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_format_iz2use_package$ComponentGroup__f_margin;
      var x$6 = $n(ComponentGroup$1).Lreactbuild_format_iz2use_package$ComponentGroup__f_margin;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_format_iz2use_package$ComponentGroup__f_columns;
        var x$8 = $n(ComponentGroup$1).Lreactbuild_format_iz2use_package$ComponentGroup__f_columns;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$ComponentGroup(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$ComponentGroup) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$ComponentGroup"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$ComponentGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$ComponentGroup)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$ComponentGroup(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$ComponentGroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$ComponentGroup;", depth))
}
var $d_Lreactbuild_format_iz2use_package$ComponentGroup = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$ComponentGroup: 0
}, false, "reactbuild.format.iz2use.package$ComponentGroup", {
  Lreactbuild_format_iz2use_package$ComponentGroup: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$ComponentGroup.prototype.$classData = $d_Lreactbuild_format_iz2use_package$ComponentGroup;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$ComponentGroup$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$ComponentGroup$.prototype = new $h_sr_AbstractFunction4();
$c_Lreactbuild_format_iz2use_package$ComponentGroup$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$ComponentGroup$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$ComponentGroup$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$ComponentGroup$.prototype = $c_Lreactbuild_format_iz2use_package$ComponentGroup$.prototype;
$c_Lreactbuild_format_iz2use_package$ComponentGroup$.prototype.toString__T = (function() {
  return "ComponentGroup"
});
$c_Lreactbuild_format_iz2use_package$ComponentGroup$.prototype.apply__O__O__O__O__O = (function(v1, v2, v3, v4) {
  var offsets = $as_Lreactbuild_format_iz2use_package$ComponentGroupOffset(v1);
  var z = $as_s_Option(v2);
  var margin = $as_s_Option(v3);
  var columns = $as_sci_List(v4);
  return new $c_Lreactbuild_format_iz2use_package$ComponentGroup(offsets, z, margin, columns)
});
var $d_Lreactbuild_format_iz2use_package$ComponentGroup$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$ComponentGroup$: 0
}, false, "reactbuild.format.iz2use.package$ComponentGroup$", {
  Lreactbuild_format_iz2use_package$ComponentGroup$: 1,
  sr_AbstractFunction4: 1,
  O: 1,
  F4: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$ComponentGroup$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$ComponentGroup$;
var $n_Lreactbuild_format_iz2use_package$ComponentGroup$;
function $m_Lreactbuild_format_iz2use_package$ComponentGroup$() {
  if ((!$n_Lreactbuild_format_iz2use_package$ComponentGroup$)) {
    $n_Lreactbuild_format_iz2use_package$ComponentGroup$ = new $c_Lreactbuild_format_iz2use_package$ComponentGroup$()
  };
  return $n_Lreactbuild_format_iz2use_package$ComponentGroup$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$ComponentInstance(reverse, name) {
  this.Lreactbuild_format_iz2use_package$ComponentInstance__f_reverse = false;
  this.Lreactbuild_format_iz2use_package$ComponentInstance__f_name = null;
  this.Lreactbuild_format_iz2use_package$ComponentInstance__f_reverse = reverse;
  this.Lreactbuild_format_iz2use_package$ComponentInstance__f_name = name
}
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype.constructor = $c_Lreactbuild_format_iz2use_package$ComponentInstance;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$ComponentInstance() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$ComponentInstance.prototype = $c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype;
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype.productPrefix__T = (function() {
  return "ComponentInstance"
});
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$ComponentInstance__f_reverse;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$ComponentInstance__f_name;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ComponentInstance");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_format_iz2use_package$ComponentInstance__f_reverse ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_format_iz2use_package$ComponentInstance__f_name;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$ComponentInstance)) {
    var ComponentInstance$1 = $as_Lreactbuild_format_iz2use_package$ComponentInstance(x$1);
    return ((this.Lreactbuild_format_iz2use_package$ComponentInstance__f_reverse === $n(ComponentInstance$1).Lreactbuild_format_iz2use_package$ComponentInstance__f_reverse) && (this.Lreactbuild_format_iz2use_package$ComponentInstance__f_name === $n(ComponentInstance$1).Lreactbuild_format_iz2use_package$ComponentInstance__f_name))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$ComponentInstance(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$ComponentInstance) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$ComponentInstance"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$ComponentInstance(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$ComponentInstance)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$ComponentInstance(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$ComponentInstance(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$ComponentInstance;", depth))
}
var $d_Lreactbuild_format_iz2use_package$ComponentInstance = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$ComponentInstance: 0
}, false, "reactbuild.format.iz2use.package$ComponentInstance", {
  Lreactbuild_format_iz2use_package$ComponentInstance: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$ComponentInstance.prototype.$classData = $d_Lreactbuild_format_iz2use_package$ComponentInstance;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$ComponentInstance$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$ComponentInstance$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_format_iz2use_package$ComponentInstance$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$ComponentInstance$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$ComponentInstance$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$ComponentInstance$.prototype = $c_Lreactbuild_format_iz2use_package$ComponentInstance$.prototype;
$c_Lreactbuild_format_iz2use_package$ComponentInstance$.prototype.toString__T = (function() {
  return "ComponentInstance"
});
$c_Lreactbuild_format_iz2use_package$ComponentInstance$.prototype.apply__O__O__O = (function(v1, v2) {
  var reverse = $uZ(v1);
  var name = $as_T(v2);
  return new $c_Lreactbuild_format_iz2use_package$ComponentInstance(reverse, name)
});
var $d_Lreactbuild_format_iz2use_package$ComponentInstance$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$ComponentInstance$: 0
}, false, "reactbuild.format.iz2use.package$ComponentInstance$", {
  Lreactbuild_format_iz2use_package$ComponentInstance$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$ComponentInstance$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$ComponentInstance$;
var $n_Lreactbuild_format_iz2use_package$ComponentInstance$;
function $m_Lreactbuild_format_iz2use_package$ComponentInstance$() {
  if ((!$n_Lreactbuild_format_iz2use_package$ComponentInstance$)) {
    $n_Lreactbuild_format_iz2use_package$ComponentInstance$ = new $c_Lreactbuild_format_iz2use_package$ComponentInstance$()
  };
  return $n_Lreactbuild_format_iz2use_package$ComponentInstance$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$ExpandedComponent(wallOffsetStart, offset0, offset1, distance, z, invertY, definition) {
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_wallOffsetStart = 0.0;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0 = 0.0;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset1 = null;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_distance = 0.0;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_z = 0.0;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_invertY = false;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_definition = null;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_wallOffsetStart = wallOffsetStart;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0 = offset0;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset1 = offset1;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_distance = distance;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_z = z;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_invertY = invertY;
  this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_definition = definition
}
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype.constructor = $c_Lreactbuild_format_iz2use_package$ExpandedComponent;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$ExpandedComponent() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype = $c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype;
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype.productPrefix__T = (function() {
  return "ExpandedComponent"
});
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_wallOffsetStart;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0;
      break
    }
    case 2: {
      return this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset1;
      break
    }
    case 3: {
      return this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_distance;
      break
    }
    case 4: {
      return this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_z;
      break
    }
    case 5: {
      return this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_invertY;
      break
    }
    case 6: {
      return this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_definition;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ExpandedComponent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_wallOffsetStart;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x = this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset1;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$2 = this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_distance;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var dv$3 = this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_z;
  var data$5 = $m_sr_Statics$().doubleHash__D__I(dv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_invertY ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$1 = this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_definition;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$ExpandedComponent)) {
    var ExpandedComponent$1 = $as_Lreactbuild_format_iz2use_package$ExpandedComponent(x$1);
    if (((this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_wallOffsetStart === $n(ExpandedComponent$1).Lreactbuild_format_iz2use_package$ExpandedComponent__f_wallOffsetStart) && ((this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0 === $n(ExpandedComponent$1).Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0) && (this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_distance === $n(ExpandedComponent$1).Lreactbuild_format_iz2use_package$ExpandedComponent__f_distance)))) {
      if (((this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_z === $n(ExpandedComponent$1).Lreactbuild_format_iz2use_package$ExpandedComponent__f_z) && (this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_invertY === $n(ExpandedComponent$1).Lreactbuild_format_iz2use_package$ExpandedComponent__f_invertY))) {
        var x = this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset1;
        var x$2 = $n(ExpandedComponent$1).Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset1;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          return (this.Lreactbuild_format_iz2use_package$ExpandedComponent__f_definition === $n(ExpandedComponent$1).Lreactbuild_format_iz2use_package$ExpandedComponent__f_definition)
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$ExpandedComponent(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$ExpandedComponent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$ExpandedComponent"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$ExpandedComponent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$ExpandedComponent)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$ExpandedComponent(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$ExpandedComponent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$ExpandedComponent;", depth))
}
var $d_Lreactbuild_format_iz2use_package$ExpandedComponent = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$ExpandedComponent: 0
}, false, "reactbuild.format.iz2use.package$ExpandedComponent", {
  Lreactbuild_format_iz2use_package$ExpandedComponent: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$ExpandedComponent.prototype.$classData = $d_Lreactbuild_format_iz2use_package$ExpandedComponent;
function $f_Lreactbuild_format_iz2use_package$GenerateGeometry__shape__sci_List($thiz) {
  var this$2 = $n($thiz.sides__sci_List());
  var this$1 = $n($m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2($thiz.origin__Lreactbuild_format_iz2use_package$Vector2D()));
  var z = new $c_Lreactbuild_geom_Point2(this$1.Lreactbuild_geom_Vector2__f_x, this$1.Lreactbuild_geom_Vector2__f_y);
  $m_sci_List$();
  var b = new $c_scm_ListBuffer();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, this$2, 0);
  var acc = z;
  var elem = acc;
  b.addOne__O__scm_ListBuffer(elem);
  var it = this$2.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var arg1 = acc;
    var arg2 = $n(it).next__O();
    var acc$1 = $as_Lreactbuild_geom_Point2(arg1);
    var side = $as_Lreactbuild_format_iz2use_package$Side(arg2);
    var this$4 = $n($m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2($n(side).Lreactbuild_format_iz2use_package$Side__f_edge));
    acc = new $c_Lreactbuild_geom_Point2((this$4.Lreactbuild_geom_Vector2__f_x + $n(acc$1).Lreactbuild_geom_Point2__f_x), (this$4.Lreactbuild_geom_Vector2__f_y + $n(acc$1).Lreactbuild_geom_Point2__f_y));
    var elem$1 = acc;
    b.addOne__O__scm_ListBuffer(elem$1)
  };
  return b.toList__sci_List()
}
function $f_Lreactbuild_format_iz2use_package$GenerateGeometry__buildComponentGroup__Lreactbuild_geom_Vector2__Lreactbuild_geom_Vector2__Lreactbuild_format_iz2use_package$ComponentGroup__Lreactbuild_format_iz2use_package$EdgeAndComponentBuilder__V($thiz, start, vector, group, builder) {
  var this$1 = $n(group);
  var this$2 = $n($p_Lreactbuild_format_iz2use_package$ComponentGroup__loop$2__D__sci_List__sci_List__sci_List(this$1, 0.0, this$1.Lreactbuild_format_iz2use_package$ComponentGroup__f_columns, $m_s_package$().s_package$__f_Nil));
  var these = this$2;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var x$1 = $as_Lreactbuild_format_iz2use_package$ExpandedComponent(arg1);
    $n(builder).emitComponent__Lreactbuild_geom_Vector2__Lreactbuild_geom_Vector2__Lreactbuild_format_iz2use_package$ExpandedComponent__V(start, vector, x$1);
    these = $as_sci_List($n(these).tail__O())
  }
}
function $f_Lreactbuild_format_iz2use_package$GenerateGeometry__buildEdgesAndComponents__Lreactbuild_format_iz2use_package$EdgeAndComponentBuilder__O($thiz, builder) {
  $n(builder).clear__V();
  return $p_Lreactbuild_format_iz2use_package$GenerateGeometry__loop$1__Lreactbuild_geom_Vector2__sci_List__Lreactbuild_format_iz2use_package$EdgeAndComponentBuilder__O($thiz, $m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2($m_Lreactbuild_format_iz2use_package$Vector2D$().Lreactbuild_format_iz2use_package$Vector2D$__f_Zero), $thiz.sides__sci_List(), builder)
}
function $p_Lreactbuild_format_iz2use_package$GenerateGeometry__loop$1__Lreactbuild_geom_Vector2__sci_List__Lreactbuild_format_iz2use_package$EdgeAndComponentBuilder__O($thiz, lastVertex, rest, builder$2) {
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      var this$1 = $n(builder$2);
      return this$1.result__Lorg_denigma_threejs_Group()
    };
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var p4 = $as_Lreactbuild_format_iz2use_package$Side($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      if ((p4 !== null)) {
        var vec = $n(p4).Lreactbuild_format_iz2use_package$Side__f_edge;
        var groups = $n(p4).Lreactbuild_format_iz2use_package$Side__f_componentGroups;
        var this$2 = $n(lastVertex);
        var other = $m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2(vec);
        var endVertex = new $c_Lreactbuild_geom_Vector2((this$2.Lreactbuild_geom_Vector2__f_x + $n(other).Lreactbuild_geom_Vector2__f_x), (this$2.Lreactbuild_geom_Vector2__f_y + $n(other).Lreactbuild_geom_Vector2__f_y));
        $n(builder$2).emitEdge__Lreactbuild_geom_Vector2__Lreactbuild_geom_Vector2__V(lastVertex, endVertex);
        var this$3 = $n(groups);
        var lastVertex$1 = lastVertex;
        var these = this$3;
        while ((!$n(these).isEmpty__Z())) {
          var arg1 = $n(these).head__O();
          var group = $as_Lreactbuild_format_iz2use_package$ComponentGroup(arg1);
          var vector = $m_Lreactbuild_format_iz2use_package$Vector2D$().asVector2__Lreactbuild_format_iz2use_package$Vector2D__Lreactbuild_geom_Vector2(vec);
          $f_Lreactbuild_format_iz2use_package$GenerateGeometry__buildComponentGroup__Lreactbuild_geom_Vector2__Lreactbuild_geom_Vector2__Lreactbuild_format_iz2use_package$ComponentGroup__Lreactbuild_format_iz2use_package$EdgeAndComponentBuilder__V($thiz, lastVertex$1, vector, group, builder$2);
          these = $as_sci_List($n(these).tail__O())
        };
        lastVertex = endVertex;
        rest = tail;
        continue
      }
    };
    throw new $c_s_MatchError(x1)
  }
}
function $is_Lreactbuild_format_iz2use_package$GenerateGeometry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_format_iz2use_package$GenerateGeometry)))
}
function $as_Lreactbuild_format_iz2use_package$GenerateGeometry(obj) {
  return (($is_Lreactbuild_format_iz2use_package$GenerateGeometry(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$GenerateGeometry"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$GenerateGeometry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$GenerateGeometry)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$GenerateGeometry(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$GenerateGeometry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$GenerateGeometry;", depth))
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Length(length) {
  this.Lreactbuild_format_iz2use_package$Length__f_length = 0;
  this.Lreactbuild_format_iz2use_package$Length__f_length = length
}
$c_Lreactbuild_format_iz2use_package$Length.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Length.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Length;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Length() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Length.prototype = $c_Lreactbuild_format_iz2use_package$Length.prototype;
$c_Lreactbuild_format_iz2use_package$Length.prototype.productPrefix__T = (function() {
  return "Length"
});
$c_Lreactbuild_format_iz2use_package$Length.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_iz2use_package$Length.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_iz2use_package$Length__f_length : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_iz2use_package$Length.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$Length.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Length");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_format_iz2use_package$Length__f_length;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_format_iz2use_package$Length.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$Length.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$Length)) {
    var Length$1 = $as_Lreactbuild_format_iz2use_package$Length(x$1);
    return (this.Lreactbuild_format_iz2use_package$Length__f_length === $n(Length$1).Lreactbuild_format_iz2use_package$Length__f_length)
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$Length(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$Length) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$Length"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$Length(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$Length)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$Length(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$Length(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$Length;", depth))
}
var $d_Lreactbuild_format_iz2use_package$Length = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Length: 0
}, false, "reactbuild.format.iz2use.package$Length", {
  Lreactbuild_format_iz2use_package$Length: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Length.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Length;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Roof(roofType, sides) {
  this.Lreactbuild_format_iz2use_package$Roof__f_roofType = null;
  this.Lreactbuild_format_iz2use_package$Roof__f_sides = null;
  this.Lreactbuild_format_iz2use_package$Roof__f_roofType = roofType;
  this.Lreactbuild_format_iz2use_package$Roof__f_sides = sides
}
$c_Lreactbuild_format_iz2use_package$Roof.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Roof.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Roof;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Roof() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Roof.prototype = $c_Lreactbuild_format_iz2use_package$Roof.prototype;
$c_Lreactbuild_format_iz2use_package$Roof.prototype.productPrefix__T = (function() {
  return "Roof"
});
$c_Lreactbuild_format_iz2use_package$Roof.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_iz2use_package$Roof.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$Roof__f_roofType;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$Roof__f_sides;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$Roof.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$Roof.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$Roof.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$Roof.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$Roof)) {
    var Roof$1 = $as_Lreactbuild_format_iz2use_package$Roof(x$1);
    var x = this.Lreactbuild_format_iz2use_package$Roof__f_roofType;
    var x$2 = $n(Roof$1).Lreactbuild_format_iz2use_package$Roof__f_roofType;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_iz2use_package$Roof__f_sides;
      var x$4 = $n(Roof$1).Lreactbuild_format_iz2use_package$Roof__f_sides;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$Roof(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$Roof) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$Roof"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$Roof(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$Roof)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$Roof(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$Roof(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$Roof;", depth))
}
var $d_Lreactbuild_format_iz2use_package$Roof = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Roof: 0
}, false, "reactbuild.format.iz2use.package$Roof", {
  Lreactbuild_format_iz2use_package$Roof: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Roof.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Roof;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Roof$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$Roof$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_format_iz2use_package$Roof$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Roof$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Roof$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Roof$.prototype = $c_Lreactbuild_format_iz2use_package$Roof$.prototype;
$c_Lreactbuild_format_iz2use_package$Roof$.prototype.toString__T = (function() {
  return "Roof"
});
$c_Lreactbuild_format_iz2use_package$Roof$.prototype.apply__O__O__O = (function(v1, v2) {
  var roofType = $as_Lreactbuild_format_iz2use_package$RoofType(v1);
  var sides = $as_sci_List(v2);
  return new $c_Lreactbuild_format_iz2use_package$Roof(roofType, sides)
});
var $d_Lreactbuild_format_iz2use_package$Roof$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Roof$: 0
}, false, "reactbuild.format.iz2use.package$Roof$", {
  Lreactbuild_format_iz2use_package$Roof$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Roof$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Roof$;
var $n_Lreactbuild_format_iz2use_package$Roof$;
function $m_Lreactbuild_format_iz2use_package$Roof$() {
  if ((!$n_Lreactbuild_format_iz2use_package$Roof$)) {
    $n_Lreactbuild_format_iz2use_package$Roof$ = new $c_Lreactbuild_format_iz2use_package$Roof$()
  };
  return $n_Lreactbuild_format_iz2use_package$Roof$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Room$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$Room$.prototype = new $h_sr_AbstractFunction3();
$c_Lreactbuild_format_iz2use_package$Room$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Room$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Room$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Room$.prototype = $c_Lreactbuild_format_iz2use_package$Room$.prototype;
$c_Lreactbuild_format_iz2use_package$Room$.prototype.toString__T = (function() {
  return "Room"
});
$c_Lreactbuild_format_iz2use_package$Room$.prototype.apply__O__O__O__O = (function(v1, v2, v3) {
  var name = $as_T(v1);
  var origin = $as_Lreactbuild_format_iz2use_package$Vector2D(v2);
  var sides = $as_sci_List(v3);
  return new $c_Lreactbuild_format_iz2use_package$Room(name, origin, sides)
});
var $d_Lreactbuild_format_iz2use_package$Room$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Room$: 0
}, false, "reactbuild.format.iz2use.package$Room$", {
  Lreactbuild_format_iz2use_package$Room$: 1,
  sr_AbstractFunction3: 1,
  O: 1,
  F3: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Room$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Room$;
var $n_Lreactbuild_format_iz2use_package$Room$;
function $m_Lreactbuild_format_iz2use_package$Room$() {
  if ((!$n_Lreactbuild_format_iz2use_package$Room$)) {
    $n_Lreactbuild_format_iz2use_package$Room$ = new $c_Lreactbuild_format_iz2use_package$Room$()
  };
  return $n_Lreactbuild_format_iz2use_package$Room$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Side(edge, componentGroups) {
  this.Lreactbuild_format_iz2use_package$Side__f_edge = null;
  this.Lreactbuild_format_iz2use_package$Side__f_componentGroups = null;
  this.Lreactbuild_format_iz2use_package$Side__f_edge = edge;
  this.Lreactbuild_format_iz2use_package$Side__f_componentGroups = componentGroups
}
$c_Lreactbuild_format_iz2use_package$Side.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Side.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Side;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Side() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Side.prototype = $c_Lreactbuild_format_iz2use_package$Side.prototype;
$c_Lreactbuild_format_iz2use_package$Side.prototype.productPrefix__T = (function() {
  return "Side"
});
$c_Lreactbuild_format_iz2use_package$Side.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_iz2use_package$Side.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$Side__f_edge;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$Side__f_componentGroups;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$Side.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$Side.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$Side.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$Side.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$Side)) {
    var Side$1 = $as_Lreactbuild_format_iz2use_package$Side(x$1);
    var x = this.Lreactbuild_format_iz2use_package$Side__f_edge;
    var x$2 = $n(Side$1).Lreactbuild_format_iz2use_package$Side__f_edge;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_iz2use_package$Side__f_componentGroups;
      var x$4 = $n(Side$1).Lreactbuild_format_iz2use_package$Side__f_componentGroups;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$Side(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$Side) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$Side"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$Side(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$Side)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$Side(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$Side(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$Side;", depth))
}
var $d_Lreactbuild_format_iz2use_package$Side = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Side: 0
}, false, "reactbuild.format.iz2use.package$Side", {
  Lreactbuild_format_iz2use_package$Side: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Side.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Side;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Storey$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$Storey$.prototype = new $h_sr_AbstractFunction3();
$c_Lreactbuild_format_iz2use_package$Storey$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Storey$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Storey$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Storey$.prototype = $c_Lreactbuild_format_iz2use_package$Storey$.prototype;
$c_Lreactbuild_format_iz2use_package$Storey$.prototype.toString__T = (function() {
  return "Storey"
});
$c_Lreactbuild_format_iz2use_package$Storey$.prototype.apply__O__O__O__O = (function(v1, v2, v3) {
  var sides = $as_sci_List(v1);
  var rooms = $as_sci_List(v2);
  var roofs = $as_sci_List(v3);
  return new $c_Lreactbuild_format_iz2use_package$Storey(sides, rooms, roofs)
});
var $d_Lreactbuild_format_iz2use_package$Storey$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Storey$: 0
}, false, "reactbuild.format.iz2use.package$Storey$", {
  Lreactbuild_format_iz2use_package$Storey$: 1,
  sr_AbstractFunction3: 1,
  O: 1,
  F3: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Storey$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Storey$;
var $n_Lreactbuild_format_iz2use_package$Storey$;
function $m_Lreactbuild_format_iz2use_package$Storey$() {
  if ((!$n_Lreactbuild_format_iz2use_package$Storey$)) {
    $n_Lreactbuild_format_iz2use_package$Storey$ = new $c_Lreactbuild_format_iz2use_package$Storey$()
  };
  return $n_Lreactbuild_format_iz2use_package$Storey$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Vector2D(x, y) {
  this.Lreactbuild_format_iz2use_package$Vector2D__f_x = null;
  this.Lreactbuild_format_iz2use_package$Vector2D__f_y = null;
  this.Lreactbuild_format_iz2use_package$Vector2D__f_x = x;
  this.Lreactbuild_format_iz2use_package$Vector2D__f_y = y
}
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Vector2D;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Vector2D() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Vector2D.prototype = $c_Lreactbuild_format_iz2use_package$Vector2D.prototype;
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.toPoint__Lreactbuild_geom_Point2 = (function() {
  return new $c_Lreactbuild_geom_Point2($n(this.Lreactbuild_format_iz2use_package$Vector2D__f_x).Lreactbuild_format_iz2use_package$Length__f_length, $n(this.Lreactbuild_format_iz2use_package$Vector2D__f_y).Lreactbuild_format_iz2use_package$Length__f_length)
});
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.productPrefix__T = (function() {
  return "Vector2D"
});
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$Vector2D__f_x;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$Vector2D__f_y;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$Vector2D)) {
    var Vector2D$1 = $as_Lreactbuild_format_iz2use_package$Vector2D(x$1);
    var x = this.Lreactbuild_format_iz2use_package$Vector2D__f_x;
    var x$2 = $n(Vector2D$1).Lreactbuild_format_iz2use_package$Vector2D__f_x;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_iz2use_package$Vector2D__f_y;
      var x$4 = $n(Vector2D$1).Lreactbuild_format_iz2use_package$Vector2D__f_y;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$Vector2D(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$Vector2D) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$Vector2D"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$Vector2D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$Vector2D)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$Vector2D(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$Vector2D(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$Vector2D;", depth))
}
var $d_Lreactbuild_format_iz2use_package$Vector2D = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Vector2D: 0
}, false, "reactbuild.format.iz2use.package$Vector2D", {
  Lreactbuild_format_iz2use_package$Vector2D: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Vector2D.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Vector2D;
/** @constructor */
function $c_Lreactbuild_geom_Quaternion(w, x, y, z) {
  this.Lreactbuild_geom_Quaternion__f_w = 0.0;
  this.Lreactbuild_geom_Quaternion__f_x = 0.0;
  this.Lreactbuild_geom_Quaternion__f_y = 0.0;
  this.Lreactbuild_geom_Quaternion__f_z = 0.0;
  this.Lreactbuild_geom_Quaternion__f_w = w;
  this.Lreactbuild_geom_Quaternion__f_x = x;
  this.Lreactbuild_geom_Quaternion__f_y = y;
  this.Lreactbuild_geom_Quaternion__f_z = z
}
$c_Lreactbuild_geom_Quaternion.prototype = new $h_O();
$c_Lreactbuild_geom_Quaternion.prototype.constructor = $c_Lreactbuild_geom_Quaternion;
/** @constructor */
function $h_Lreactbuild_geom_Quaternion() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Quaternion.prototype = $c_Lreactbuild_geom_Quaternion.prototype;
$c_Lreactbuild_geom_Quaternion.prototype.$times__Lreactbuild_geom_Quaternion__Lreactbuild_geom_Quaternion = (function(q) {
  return new $c_Lreactbuild_geom_Quaternion(((((this.Lreactbuild_geom_Quaternion__f_w * $n(q).Lreactbuild_geom_Quaternion__f_w) - (this.Lreactbuild_geom_Quaternion__f_x * $n(q).Lreactbuild_geom_Quaternion__f_x)) - (this.Lreactbuild_geom_Quaternion__f_y * $n(q).Lreactbuild_geom_Quaternion__f_y)) - (this.Lreactbuild_geom_Quaternion__f_z * $n(q).Lreactbuild_geom_Quaternion__f_z)), ((((this.Lreactbuild_geom_Quaternion__f_x * $n(q).Lreactbuild_geom_Quaternion__f_w) + (this.Lreactbuild_geom_Quaternion__f_w * $n(q).Lreactbuild_geom_Quaternion__f_x)) + (this.Lreactbuild_geom_Quaternion__f_y * $n(q).Lreactbuild_geom_Quaternion__f_z)) - (this.Lreactbuild_geom_Quaternion__f_z * $n(q).Lreactbuild_geom_Quaternion__f_y)), ((((this.Lreactbuild_geom_Quaternion__f_y * $n(q).Lreactbuild_geom_Quaternion__f_w) + (this.Lreactbuild_geom_Quaternion__f_w * $n(q).Lreactbuild_geom_Quaternion__f_y)) + (this.Lreactbuild_geom_Quaternion__f_y * $n(q).Lreactbuild_geom_Quaternion__f_x)) - (this.Lreactbuild_geom_Quaternion__f_x * $n(q).Lreactbuild_geom_Quaternion__f_z)), ((((this.Lreactbuild_geom_Quaternion__f_z * $n(q).Lreactbuild_geom_Quaternion__f_w) + (this.Lreactbuild_geom_Quaternion__f_w * $n(q).Lreactbuild_geom_Quaternion__f_z)) + (this.Lreactbuild_geom_Quaternion__f_y * $n(q).Lreactbuild_geom_Quaternion__f_y)) - (this.Lreactbuild_geom_Quaternion__f_y * $n(q).Lreactbuild_geom_Quaternion__f_x)))
});
$c_Lreactbuild_geom_Quaternion.prototype.toEulerAngles__T3 = (function() {
  var y = (2.0 * ((this.Lreactbuild_geom_Quaternion__f_w * this.Lreactbuild_geom_Quaternion__f_x) + (this.Lreactbuild_geom_Quaternion__f_y * this.Lreactbuild_geom_Quaternion__f_z)));
  var x = (1.0 - (2.0 * ((this.Lreactbuild_geom_Quaternion__f_x * this.Lreactbuild_geom_Quaternion__f_x) + (this.Lreactbuild_geom_Quaternion__f_y * this.Lreactbuild_geom_Quaternion__f_y))));
  var phi = $uD(Math.atan2(y, x));
  var a = (2.0 * ((this.Lreactbuild_geom_Quaternion__f_w * this.Lreactbuild_geom_Quaternion__f_y) - (this.Lreactbuild_geom_Quaternion__f_z * this.Lreactbuild_geom_Quaternion__f_x)));
  var theta = $uD(Math.asin(a));
  var y$1 = (2.0 * ((this.Lreactbuild_geom_Quaternion__f_w * this.Lreactbuild_geom_Quaternion__f_z) + (this.Lreactbuild_geom_Quaternion__f_x * this.Lreactbuild_geom_Quaternion__f_y)));
  var x$1 = (1.0 - (2.0 * ((this.Lreactbuild_geom_Quaternion__f_y * this.Lreactbuild_geom_Quaternion__f_y) + (this.Lreactbuild_geom_Quaternion__f_z * this.Lreactbuild_geom_Quaternion__f_z))));
  var psi = $uD(Math.atan2(y$1, x$1));
  return new $c_T3(phi, theta, psi)
});
$c_Lreactbuild_geom_Quaternion.prototype.productPrefix__T = (function() {
  return "Quaternion"
});
$c_Lreactbuild_geom_Quaternion.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_geom_Quaternion.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_geom_Quaternion__f_w;
      break
    }
    case 1: {
      return this.Lreactbuild_geom_Quaternion__f_x;
      break
    }
    case 2: {
      return this.Lreactbuild_geom_Quaternion__f_y;
      break
    }
    case 3: {
      return this.Lreactbuild_geom_Quaternion__f_z;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_geom_Quaternion.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_geom_Quaternion.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Quaternion");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_geom_Quaternion__f_w;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_geom_Quaternion__f_x;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$2 = this.Lreactbuild_geom_Quaternion__f_y;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$3 = this.Lreactbuild_geom_Quaternion__f_z;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lreactbuild_geom_Quaternion.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_geom_Quaternion.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_geom_Quaternion)) {
    var Quaternion$1 = $as_Lreactbuild_geom_Quaternion(x$1);
    return (((this.Lreactbuild_geom_Quaternion__f_w === $n(Quaternion$1).Lreactbuild_geom_Quaternion__f_w) && (this.Lreactbuild_geom_Quaternion__f_x === $n(Quaternion$1).Lreactbuild_geom_Quaternion__f_x)) && ((this.Lreactbuild_geom_Quaternion__f_y === $n(Quaternion$1).Lreactbuild_geom_Quaternion__f_y) && (this.Lreactbuild_geom_Quaternion__f_z === $n(Quaternion$1).Lreactbuild_geom_Quaternion__f_z)))
  } else {
    return false
  }
});
function $as_Lreactbuild_geom_Quaternion(obj) {
  return (((obj instanceof $c_Lreactbuild_geom_Quaternion) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.geom.Quaternion"))
}
function $isArrayOf_Lreactbuild_geom_Quaternion(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_geom_Quaternion)))
}
function $asArrayOf_Lreactbuild_geom_Quaternion(obj, depth) {
  return (($isArrayOf_Lreactbuild_geom_Quaternion(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.geom.Quaternion;", depth))
}
var $d_Lreactbuild_geom_Quaternion = new $TypeData().initClass({
  Lreactbuild_geom_Quaternion: 0
}, false, "reactbuild.geom.Quaternion", {
  Lreactbuild_geom_Quaternion: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_geom_Quaternion.prototype.$classData = $d_Lreactbuild_geom_Quaternion;
/** @constructor */
function $c_Lreactbuild_hooks_AcceptDrop(contentTypes, acceptFiles) {
  this.Lreactbuild_hooks_AcceptDrop__f_contentTypes = null;
  this.Lreactbuild_hooks_AcceptDrop__f_acceptFiles = false;
  this.Lreactbuild_hooks_AcceptDrop__f_contentTypes = contentTypes;
  this.Lreactbuild_hooks_AcceptDrop__f_acceptFiles = acceptFiles
}
$c_Lreactbuild_hooks_AcceptDrop.prototype = new $h_O();
$c_Lreactbuild_hooks_AcceptDrop.prototype.constructor = $c_Lreactbuild_hooks_AcceptDrop;
/** @constructor */
function $h_Lreactbuild_hooks_AcceptDrop() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_AcceptDrop.prototype = $c_Lreactbuild_hooks_AcceptDrop.prototype;
$c_Lreactbuild_hooks_AcceptDrop.prototype.productPrefix__T = (function() {
  return "AcceptDrop"
});
$c_Lreactbuild_hooks_AcceptDrop.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_hooks_AcceptDrop.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_hooks_AcceptDrop__f_contentTypes;
      break
    }
    case 1: {
      return this.Lreactbuild_hooks_AcceptDrop__f_acceptFiles;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_hooks_AcceptDrop.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_hooks_AcceptDrop.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("AcceptDrop");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_hooks_AcceptDrop__f_contentTypes;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_hooks_AcceptDrop__f_acceptFiles ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_hooks_AcceptDrop.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_hooks_AcceptDrop.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_hooks_AcceptDrop)) {
    var AcceptDrop$1 = $as_Lreactbuild_hooks_AcceptDrop(x$1);
    if ((this.Lreactbuild_hooks_AcceptDrop__f_acceptFiles === $n(AcceptDrop$1).Lreactbuild_hooks_AcceptDrop__f_acceptFiles)) {
      var x = this.Lreactbuild_hooks_AcceptDrop__f_contentTypes;
      var x$2 = $n(AcceptDrop$1).Lreactbuild_hooks_AcceptDrop__f_contentTypes;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_hooks_AcceptDrop(obj) {
  return (((obj instanceof $c_Lreactbuild_hooks_AcceptDrop) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.hooks.AcceptDrop"))
}
function $isArrayOf_Lreactbuild_hooks_AcceptDrop(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_hooks_AcceptDrop)))
}
function $asArrayOf_Lreactbuild_hooks_AcceptDrop(obj, depth) {
  return (($isArrayOf_Lreactbuild_hooks_AcceptDrop(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.hooks.AcceptDrop;", depth))
}
var $d_Lreactbuild_hooks_AcceptDrop = new $TypeData().initClass({
  Lreactbuild_hooks_AcceptDrop: 0
}, false, "reactbuild.hooks.AcceptDrop", {
  Lreactbuild_hooks_AcceptDrop: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_hooks_AcceptDrop.prototype.$classData = $d_Lreactbuild_hooks_AcceptDrop;
/** @constructor */
function $c_Lreactbuild_hooks_ClientSize(width, height) {
  this.Lreactbuild_hooks_ClientSize__f_width = 0.0;
  this.Lreactbuild_hooks_ClientSize__f_height = 0.0;
  this.Lreactbuild_hooks_ClientSize__f_width = width;
  this.Lreactbuild_hooks_ClientSize__f_height = height
}
$c_Lreactbuild_hooks_ClientSize.prototype = new $h_O();
$c_Lreactbuild_hooks_ClientSize.prototype.constructor = $c_Lreactbuild_hooks_ClientSize;
/** @constructor */
function $h_Lreactbuild_hooks_ClientSize() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_ClientSize.prototype = $c_Lreactbuild_hooks_ClientSize.prototype;
$c_Lreactbuild_hooks_ClientSize.prototype.productPrefix__T = (function() {
  return "ClientSize"
});
$c_Lreactbuild_hooks_ClientSize.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_hooks_ClientSize.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_hooks_ClientSize__f_width;
      break
    }
    case 1: {
      return this.Lreactbuild_hooks_ClientSize__f_height;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_hooks_ClientSize.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_hooks_ClientSize.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ClientSize");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_hooks_ClientSize__f_width;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_hooks_ClientSize__f_height;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_hooks_ClientSize.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_hooks_ClientSize.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_hooks_ClientSize)) {
    var ClientSize$1 = $as_Lreactbuild_hooks_ClientSize(x$1);
    return ((this.Lreactbuild_hooks_ClientSize__f_width === $n(ClientSize$1).Lreactbuild_hooks_ClientSize__f_width) && (this.Lreactbuild_hooks_ClientSize__f_height === $n(ClientSize$1).Lreactbuild_hooks_ClientSize__f_height))
  } else {
    return false
  }
});
function $as_Lreactbuild_hooks_ClientSize(obj) {
  return (((obj instanceof $c_Lreactbuild_hooks_ClientSize) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.hooks.ClientSize"))
}
function $isArrayOf_Lreactbuild_hooks_ClientSize(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_hooks_ClientSize)))
}
function $asArrayOf_Lreactbuild_hooks_ClientSize(obj, depth) {
  return (($isArrayOf_Lreactbuild_hooks_ClientSize(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.hooks.ClientSize;", depth))
}
var $d_Lreactbuild_hooks_ClientSize = new $TypeData().initClass({
  Lreactbuild_hooks_ClientSize: 0
}, false, "reactbuild.hooks.ClientSize", {
  Lreactbuild_hooks_ClientSize: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_hooks_ClientSize.prototype.$classData = $d_Lreactbuild_hooks_ClientSize;
/** @constructor */
function $c_Lreactbuild_hooks_Dnd$DragResult(isDragging, onStart, onEnd) {
  this.Lreactbuild_hooks_Dnd$DragResult__f_isDragging = false;
  this.Lreactbuild_hooks_Dnd$DragResult__f_onStart = null;
  this.Lreactbuild_hooks_Dnd$DragResult__f_onEnd = null;
  this.Lreactbuild_hooks_Dnd$DragResult__f_isDragging = isDragging;
  this.Lreactbuild_hooks_Dnd$DragResult__f_onStart = onStart;
  this.Lreactbuild_hooks_Dnd$DragResult__f_onEnd = onEnd
}
$c_Lreactbuild_hooks_Dnd$DragResult.prototype = new $h_O();
$c_Lreactbuild_hooks_Dnd$DragResult.prototype.constructor = $c_Lreactbuild_hooks_Dnd$DragResult;
/** @constructor */
function $h_Lreactbuild_hooks_Dnd$DragResult() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_Dnd$DragResult.prototype = $c_Lreactbuild_hooks_Dnd$DragResult.prototype;
$c_Lreactbuild_hooks_Dnd$DragResult.prototype.productPrefix__T = (function() {
  return "DragResult"
});
$c_Lreactbuild_hooks_Dnd$DragResult.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_hooks_Dnd$DragResult.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_hooks_Dnd$DragResult__f_isDragging;
      break
    }
    case 1: {
      return this.Lreactbuild_hooks_Dnd$DragResult__f_onStart;
      break
    }
    case 2: {
      return this.Lreactbuild_hooks_Dnd$DragResult__f_onEnd;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_hooks_Dnd$DragResult.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_hooks_Dnd$DragResult.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DragResult");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_hooks_Dnd$DragResult__f_isDragging ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_hooks_Dnd$DragResult__f_onStart;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_hooks_Dnd$DragResult__f_onEnd;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_hooks_Dnd$DragResult.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_hooks_Dnd$DragResult.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_hooks_Dnd$DragResult)) {
    var DragResult$1 = $as_Lreactbuild_hooks_Dnd$DragResult(x$1);
    if ((this.Lreactbuild_hooks_Dnd$DragResult__f_isDragging === $n(DragResult$1).Lreactbuild_hooks_Dnd$DragResult__f_isDragging)) {
      var x = this.Lreactbuild_hooks_Dnd$DragResult__f_onStart;
      var x$2 = $n(DragResult$1).Lreactbuild_hooks_Dnd$DragResult__f_onStart;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_hooks_Dnd$DragResult__f_onEnd;
        var x$4 = $n(DragResult$1).Lreactbuild_hooks_Dnd$DragResult__f_onEnd;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_hooks_Dnd$DragResult(obj) {
  return (((obj instanceof $c_Lreactbuild_hooks_Dnd$DragResult) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.hooks.Dnd$DragResult"))
}
function $isArrayOf_Lreactbuild_hooks_Dnd$DragResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_hooks_Dnd$DragResult)))
}
function $asArrayOf_Lreactbuild_hooks_Dnd$DragResult(obj, depth) {
  return (($isArrayOf_Lreactbuild_hooks_Dnd$DragResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.hooks.Dnd$DragResult;", depth))
}
var $d_Lreactbuild_hooks_Dnd$DragResult = new $TypeData().initClass({
  Lreactbuild_hooks_Dnd$DragResult: 0
}, false, "reactbuild.hooks.Dnd$DragResult", {
  Lreactbuild_hooks_Dnd$DragResult: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_hooks_Dnd$DragResult.prototype.$classData = $d_Lreactbuild_hooks_Dnd$DragResult;
/** @constructor */
function $c_Lreactbuild_hooks_Dnd$DropResult(isOver, onDrop) {
  this.Lreactbuild_hooks_Dnd$DropResult__f_isOver = false;
  this.Lreactbuild_hooks_Dnd$DropResult__f_onDrop = null;
  this.Lreactbuild_hooks_Dnd$DropResult__f_isOver = isOver;
  this.Lreactbuild_hooks_Dnd$DropResult__f_onDrop = onDrop
}
$c_Lreactbuild_hooks_Dnd$DropResult.prototype = new $h_O();
$c_Lreactbuild_hooks_Dnd$DropResult.prototype.constructor = $c_Lreactbuild_hooks_Dnd$DropResult;
/** @constructor */
function $h_Lreactbuild_hooks_Dnd$DropResult() {
  /*<skip>*/
}
$h_Lreactbuild_hooks_Dnd$DropResult.prototype = $c_Lreactbuild_hooks_Dnd$DropResult.prototype;
$c_Lreactbuild_hooks_Dnd$DropResult.prototype.productPrefix__T = (function() {
  return "DropResult"
});
$c_Lreactbuild_hooks_Dnd$DropResult.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_hooks_Dnd$DropResult.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_hooks_Dnd$DropResult__f_isOver;
      break
    }
    case 1: {
      return this.Lreactbuild_hooks_Dnd$DropResult__f_onDrop;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_hooks_Dnd$DropResult.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_hooks_Dnd$DropResult.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DropResult");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_hooks_Dnd$DropResult__f_isOver ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_hooks_Dnd$DropResult__f_onDrop;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_hooks_Dnd$DropResult.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_hooks_Dnd$DropResult.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_hooks_Dnd$DropResult)) {
    var DropResult$1 = $as_Lreactbuild_hooks_Dnd$DropResult(x$1);
    if ((this.Lreactbuild_hooks_Dnd$DropResult__f_isOver === $n(DropResult$1).Lreactbuild_hooks_Dnd$DropResult__f_isOver)) {
      var x = this.Lreactbuild_hooks_Dnd$DropResult__f_onDrop;
      var x$2 = $n(DropResult$1).Lreactbuild_hooks_Dnd$DropResult__f_onDrop;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_hooks_Dnd$DropResult(obj) {
  return (((obj instanceof $c_Lreactbuild_hooks_Dnd$DropResult) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.hooks.Dnd$DropResult"))
}
function $isArrayOf_Lreactbuild_hooks_Dnd$DropResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_hooks_Dnd$DropResult)))
}
function $asArrayOf_Lreactbuild_hooks_Dnd$DropResult(obj, depth) {
  return (($isArrayOf_Lreactbuild_hooks_Dnd$DropResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.hooks.Dnd$DropResult;", depth))
}
var $d_Lreactbuild_hooks_Dnd$DropResult = new $TypeData().initClass({
  Lreactbuild_hooks_Dnd$DropResult: 0
}, false, "reactbuild.hooks.Dnd$DropResult", {
  Lreactbuild_hooks_Dnd$DropResult: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_hooks_Dnd$DropResult.prototype.$classData = $d_Lreactbuild_hooks_Dnd$DropResult;
/** @constructor */
function $c_Lreactbuild_model_AllocatedTime(_id, organization, project, stage, title, from, until, participant) {
  this.Lreactbuild_model_AllocatedTime__f__id = null;
  this.Lreactbuild_model_AllocatedTime__f_organization = null;
  this.Lreactbuild_model_AllocatedTime__f_project = null;
  this.Lreactbuild_model_AllocatedTime__f_stage = null;
  this.Lreactbuild_model_AllocatedTime__f_title = null;
  this.Lreactbuild_model_AllocatedTime__f_from = null;
  this.Lreactbuild_model_AllocatedTime__f_until = null;
  this.Lreactbuild_model_AllocatedTime__f_participant = null;
  this.Lreactbuild_model_AllocatedTime__f__id = _id;
  this.Lreactbuild_model_AllocatedTime__f_organization = organization;
  this.Lreactbuild_model_AllocatedTime__f_project = project;
  this.Lreactbuild_model_AllocatedTime__f_stage = stage;
  this.Lreactbuild_model_AllocatedTime__f_title = title;
  this.Lreactbuild_model_AllocatedTime__f_from = from;
  this.Lreactbuild_model_AllocatedTime__f_until = until;
  this.Lreactbuild_model_AllocatedTime__f_participant = participant
}
$c_Lreactbuild_model_AllocatedTime.prototype = new $h_O();
$c_Lreactbuild_model_AllocatedTime.prototype.constructor = $c_Lreactbuild_model_AllocatedTime;
/** @constructor */
function $h_Lreactbuild_model_AllocatedTime() {
  /*<skip>*/
}
$h_Lreactbuild_model_AllocatedTime.prototype = $c_Lreactbuild_model_AllocatedTime.prototype;
$c_Lreactbuild_model_AllocatedTime.prototype.productPrefix__T = (function() {
  return "AllocatedTime"
});
$c_Lreactbuild_model_AllocatedTime.prototype.productArity__I = (function() {
  return 8
});
$c_Lreactbuild_model_AllocatedTime.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_AllocatedTime__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_AllocatedTime__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_AllocatedTime__f_project;
      break
    }
    case 3: {
      return this.Lreactbuild_model_AllocatedTime__f_stage;
      break
    }
    case 4: {
      return this.Lreactbuild_model_AllocatedTime__f_title;
      break
    }
    case 5: {
      return this.Lreactbuild_model_AllocatedTime__f_from;
      break
    }
    case 6: {
      return this.Lreactbuild_model_AllocatedTime__f_until;
      break
    }
    case 7: {
      return this.Lreactbuild_model_AllocatedTime__f_participant;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_AllocatedTime.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_AllocatedTime.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_AllocatedTime.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_AllocatedTime.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_AllocatedTime)) {
    var AllocatedTime$1 = $as_Lreactbuild_model_AllocatedTime(x$1);
    var x = this.Lreactbuild_model_AllocatedTime__f__id;
    var x$2 = $n(AllocatedTime$1).Lreactbuild_model_AllocatedTime__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_AllocatedTime__f_organization;
      var x$4 = $n(AllocatedTime$1).Lreactbuild_model_AllocatedTime__f_organization;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_model_AllocatedTime__f_project;
      var x$6 = $n(AllocatedTime$1).Lreactbuild_model_AllocatedTime__f_project;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_AllocatedTime__f_stage;
        var x$8 = $n(AllocatedTime$1).Lreactbuild_model_AllocatedTime__f_stage;
        var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_model_AllocatedTime__f_title === $n(AllocatedTime$1).Lreactbuild_model_AllocatedTime__f_title)) {
        var x$9 = this.Lreactbuild_model_AllocatedTime__f_from;
        var x$10 = $n(AllocatedTime$1).Lreactbuild_model_AllocatedTime__f_from;
        var $$x3 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$11 = this.Lreactbuild_model_AllocatedTime__f_until;
        var x$12 = $n(AllocatedTime$1).Lreactbuild_model_AllocatedTime__f_until;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_model_AllocatedTime__f_participant;
          var x$14 = $n(AllocatedTime$1).Lreactbuild_model_AllocatedTime__f_participant;
          return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_AllocatedTime(obj) {
  return (((obj instanceof $c_Lreactbuild_model_AllocatedTime) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.AllocatedTime"))
}
function $isArrayOf_Lreactbuild_model_AllocatedTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_AllocatedTime)))
}
function $asArrayOf_Lreactbuild_model_AllocatedTime(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_AllocatedTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.AllocatedTime;", depth))
}
var $d_Lreactbuild_model_AllocatedTime = new $TypeData().initClass({
  Lreactbuild_model_AllocatedTime: 0
}, false, "reactbuild.model.AllocatedTime", {
  Lreactbuild_model_AllocatedTime: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_AllocatedTime.prototype.$classData = $d_Lreactbuild_model_AllocatedTime;
/** @constructor */
function $c_Lreactbuild_model_BuildingPart(_id, organization, label, parent) {
  this.Lreactbuild_model_BuildingPart__f__id = null;
  this.Lreactbuild_model_BuildingPart__f_organization = null;
  this.Lreactbuild_model_BuildingPart__f_label = null;
  this.Lreactbuild_model_BuildingPart__f_parent = null;
  this.Lreactbuild_model_BuildingPart__f__id = _id;
  this.Lreactbuild_model_BuildingPart__f_organization = organization;
  this.Lreactbuild_model_BuildingPart__f_label = label;
  this.Lreactbuild_model_BuildingPart__f_parent = parent
}
$c_Lreactbuild_model_BuildingPart.prototype = new $h_O();
$c_Lreactbuild_model_BuildingPart.prototype.constructor = $c_Lreactbuild_model_BuildingPart;
/** @constructor */
function $h_Lreactbuild_model_BuildingPart() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingPart.prototype = $c_Lreactbuild_model_BuildingPart.prototype;
$c_Lreactbuild_model_BuildingPart.prototype.toString__T = (function() {
  return this.Lreactbuild_model_BuildingPart__f_label
});
$c_Lreactbuild_model_BuildingPart.prototype.productPrefix__T = (function() {
  return "BuildingPart"
});
$c_Lreactbuild_model_BuildingPart.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_model_BuildingPart.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_BuildingPart__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_BuildingPart__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_BuildingPart__f_label;
      break
    }
    case 3: {
      return this.Lreactbuild_model_BuildingPart__f_parent;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_BuildingPart.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_BuildingPart.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_BuildingPart.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_BuildingPart)) {
    var BuildingPart$1 = $as_Lreactbuild_model_BuildingPart(x$1);
    var x = this.Lreactbuild_model_BuildingPart__f__id;
    var x$2 = $n(BuildingPart$1).Lreactbuild_model_BuildingPart__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_BuildingPart__f_organization;
      var x$4 = $n(BuildingPart$1).Lreactbuild_model_BuildingPart__f_organization;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_model_BuildingPart__f_label === $n(BuildingPart$1).Lreactbuild_model_BuildingPart__f_label)) {
        var x$5 = this.Lreactbuild_model_BuildingPart__f_parent;
        var x$6 = $n(BuildingPart$1).Lreactbuild_model_BuildingPart__f_parent;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_BuildingPart(obj) {
  return (((obj instanceof $c_Lreactbuild_model_BuildingPart) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.BuildingPart"))
}
function $isArrayOf_Lreactbuild_model_BuildingPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_BuildingPart)))
}
function $asArrayOf_Lreactbuild_model_BuildingPart(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_BuildingPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.BuildingPart;", depth))
}
var $d_Lreactbuild_model_BuildingPart = new $TypeData().initClass({
  Lreactbuild_model_BuildingPart: 0
}, false, "reactbuild.model.BuildingPart", {
  Lreactbuild_model_BuildingPart: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingPart.prototype.$classData = $d_Lreactbuild_model_BuildingPart;
/** @constructor */
function $c_Lreactbuild_model_BuildingSiteStage(range, stage) {
  this.Lreactbuild_model_BuildingSiteStage__f_range = null;
  this.Lreactbuild_model_BuildingSiteStage__f_stage = null;
  this.Lreactbuild_model_BuildingSiteStage__f_range = range;
  this.Lreactbuild_model_BuildingSiteStage__f_stage = stage
}
$c_Lreactbuild_model_BuildingSiteStage.prototype = new $h_O();
$c_Lreactbuild_model_BuildingSiteStage.prototype.constructor = $c_Lreactbuild_model_BuildingSiteStage;
/** @constructor */
function $h_Lreactbuild_model_BuildingSiteStage() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingSiteStage.prototype = $c_Lreactbuild_model_BuildingSiteStage.prototype;
$c_Lreactbuild_model_BuildingSiteStage.prototype.productPrefix__T = (function() {
  return "BuildingSiteStage"
});
$c_Lreactbuild_model_BuildingSiteStage.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_BuildingSiteStage.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_BuildingSiteStage__f_range;
      break
    }
    case 1: {
      return this.Lreactbuild_model_BuildingSiteStage__f_stage;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_BuildingSiteStage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_BuildingSiteStage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_BuildingSiteStage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_BuildingSiteStage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_BuildingSiteStage)) {
    var BuildingSiteStage$1 = $as_Lreactbuild_model_BuildingSiteStage(x$1);
    var x = this.Lreactbuild_model_BuildingSiteStage__f_range;
    var x$2 = $n(BuildingSiteStage$1).Lreactbuild_model_BuildingSiteStage__f_range;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_BuildingSiteStage__f_stage;
      var x$4 = $n(BuildingSiteStage$1).Lreactbuild_model_BuildingSiteStage__f_stage;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_BuildingSiteStage(obj) {
  return (((obj instanceof $c_Lreactbuild_model_BuildingSiteStage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.BuildingSiteStage"))
}
function $isArrayOf_Lreactbuild_model_BuildingSiteStage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_BuildingSiteStage)))
}
function $asArrayOf_Lreactbuild_model_BuildingSiteStage(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_BuildingSiteStage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.BuildingSiteStage;", depth))
}
var $d_Lreactbuild_model_BuildingSiteStage = new $TypeData().initClass({
  Lreactbuild_model_BuildingSiteStage: 0
}, false, "reactbuild.model.BuildingSiteStage", {
  Lreactbuild_model_BuildingSiteStage: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingSiteStage.prototype.$classData = $d_Lreactbuild_model_BuildingSiteStage;
/** @constructor */
function $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27(outer) {
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27__f_circeGenericDecoderForrange = null;
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27__f_circeGenericDecoderForstage = null;
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27__f_circeGenericDecoderForrange = $m_Lreactbuild_model_BuildingSiteStage$().decodeTypedRange__Lio_circe_Decoder__s_math_Ordering__Lio_circe_Decoder($m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder(), $m_Lreactbuild_model_BuildingSiteStage$().Lreactbuild_model_BuildingSiteStage$__f_localDateOrdering);
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27__f_circeGenericDecoderForstage = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27.prototype.constructor = $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27;
/** @constructor */
function $h_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27.prototype = $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27.prototype;
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("range"))), this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27__f_circeGenericDecoderForrange, "range", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("stage"))), this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27__f_circeGenericDecoderForstage, "stage", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27 = new $TypeData().initClass({
  Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27: 0
}, false, "reactbuild.model.BuildingSiteStage$anon$lazy$macro$39$1$$anon$27", {
  Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27.prototype.$classData = $d_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$39$1$$anon$27;
/** @constructor */
function $c_Lreactbuild_model_BuildingStage(_id, organization, name, parent) {
  this.Lreactbuild_model_BuildingStage__f__id = null;
  this.Lreactbuild_model_BuildingStage__f_organization = null;
  this.Lreactbuild_model_BuildingStage__f_name = null;
  this.Lreactbuild_model_BuildingStage__f_parent = null;
  this.Lreactbuild_model_BuildingStage__f__id = _id;
  this.Lreactbuild_model_BuildingStage__f_organization = organization;
  this.Lreactbuild_model_BuildingStage__f_name = name;
  this.Lreactbuild_model_BuildingStage__f_parent = parent
}
$c_Lreactbuild_model_BuildingStage.prototype = new $h_O();
$c_Lreactbuild_model_BuildingStage.prototype.constructor = $c_Lreactbuild_model_BuildingStage;
/** @constructor */
function $h_Lreactbuild_model_BuildingStage() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingStage.prototype = $c_Lreactbuild_model_BuildingStage.prototype;
$c_Lreactbuild_model_BuildingStage.prototype.productPrefix__T = (function() {
  return "BuildingStage"
});
$c_Lreactbuild_model_BuildingStage.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_model_BuildingStage.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_BuildingStage__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_BuildingStage__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_BuildingStage__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_model_BuildingStage__f_parent;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_BuildingStage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_BuildingStage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_BuildingStage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_BuildingStage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_BuildingStage)) {
    var BuildingStage$1 = $as_Lreactbuild_model_BuildingStage(x$1);
    var x = this.Lreactbuild_model_BuildingStage__f__id;
    var x$2 = $n(BuildingStage$1).Lreactbuild_model_BuildingStage__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_BuildingStage__f_organization;
      var x$4 = $n(BuildingStage$1).Lreactbuild_model_BuildingStage__f_organization;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_model_BuildingStage__f_name === $n(BuildingStage$1).Lreactbuild_model_BuildingStage__f_name)) {
        var x$5 = this.Lreactbuild_model_BuildingStage__f_parent;
        var x$6 = $n(BuildingStage$1).Lreactbuild_model_BuildingStage__f_parent;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_BuildingStage(obj) {
  return (((obj instanceof $c_Lreactbuild_model_BuildingStage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.BuildingStage"))
}
function $isArrayOf_Lreactbuild_model_BuildingStage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_BuildingStage)))
}
function $asArrayOf_Lreactbuild_model_BuildingStage(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_BuildingStage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.BuildingStage;", depth))
}
var $d_Lreactbuild_model_BuildingStage = new $TypeData().initClass({
  Lreactbuild_model_BuildingStage: 0
}, false, "reactbuild.model.BuildingStage", {
  Lreactbuild_model_BuildingStage: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingStage.prototype.$classData = $d_Lreactbuild_model_BuildingStage;
/** @constructor */
function $c_Lreactbuild_model_CachedExpression(expression, calculatedValue) {
  this.Lreactbuild_model_CachedExpression__f_expression = null;
  this.Lreactbuild_model_CachedExpression__f_calculatedValue = null;
  this.Lreactbuild_model_CachedExpression__f_expression = expression;
  this.Lreactbuild_model_CachedExpression__f_calculatedValue = calculatedValue
}
$c_Lreactbuild_model_CachedExpression.prototype = new $h_O();
$c_Lreactbuild_model_CachedExpression.prototype.constructor = $c_Lreactbuild_model_CachedExpression;
/** @constructor */
function $h_Lreactbuild_model_CachedExpression() {
  /*<skip>*/
}
$h_Lreactbuild_model_CachedExpression.prototype = $c_Lreactbuild_model_CachedExpression.prototype;
$c_Lreactbuild_model_CachedExpression.prototype.productPrefix__T = (function() {
  return "CachedExpression"
});
$c_Lreactbuild_model_CachedExpression.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_CachedExpression.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_CachedExpression__f_expression;
      break
    }
    case 1: {
      return this.Lreactbuild_model_CachedExpression__f_calculatedValue;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_CachedExpression.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CachedExpression.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_CachedExpression.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_CachedExpression.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_CachedExpression)) {
    var CachedExpression$1 = $as_Lreactbuild_model_CachedExpression(x$1);
    var x = this.Lreactbuild_model_CachedExpression__f_expression;
    var x$2 = $n(CachedExpression$1).Lreactbuild_model_CachedExpression__f_expression;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_model_CachedExpression__f_calculatedValue;
      var y = $n(CachedExpression$1).Lreactbuild_model_CachedExpression__f_calculatedValue;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_CachedExpression(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CachedExpression) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CachedExpression"))
}
function $isArrayOf_Lreactbuild_model_CachedExpression(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CachedExpression)))
}
function $asArrayOf_Lreactbuild_model_CachedExpression(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CachedExpression(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CachedExpression;", depth))
}
var $d_Lreactbuild_model_CachedExpression = new $TypeData().initClass({
  Lreactbuild_model_CachedExpression: 0
}, false, "reactbuild.model.CachedExpression", {
  Lreactbuild_model_CachedExpression: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CachedExpression.prototype.$classData = $d_Lreactbuild_model_CachedExpression;
/** @constructor */
function $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81(outer) {
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81__f_circeGenericDecoderForexpression = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81__f_circeGenericDecoderForcalculatedValue = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81__f_circeGenericDecoderForexpression = $n(outer).Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_decExprA$1;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81__f_circeGenericDecoderForcalculatedValue = $n(outer).Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8__f_decOptB$1
}
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81.prototype.constructor = $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81;
/** @constructor */
function $h_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81() {
  /*<skip>*/
}
$h_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81.prototype = $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81.prototype;
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("expression"))), this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81__f_circeGenericDecoderForexpression, "expression", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("calculatedValue"))), this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81__f_circeGenericDecoderForcalculatedValue, "calculatedValue", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81 = new $TypeData().initClass({
  Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81: 0
}, false, "reactbuild.model.CachedExpression$anon$lazy$macro$19$8$$anon$81", {
  Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81.prototype.$classData = $d_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$8$$anon$81;
/** @constructor */
function $c_Lreactbuild_model_ChildWithParent(child, parent) {
  this.Lreactbuild_model_ChildWithParent__f_child = null;
  this.Lreactbuild_model_ChildWithParent__f_parent = null;
  this.Lreactbuild_model_ChildWithParent__f_child = child;
  this.Lreactbuild_model_ChildWithParent__f_parent = parent
}
$c_Lreactbuild_model_ChildWithParent.prototype = new $h_O();
$c_Lreactbuild_model_ChildWithParent.prototype.constructor = $c_Lreactbuild_model_ChildWithParent;
/** @constructor */
function $h_Lreactbuild_model_ChildWithParent() {
  /*<skip>*/
}
$h_Lreactbuild_model_ChildWithParent.prototype = $c_Lreactbuild_model_ChildWithParent.prototype;
$c_Lreactbuild_model_ChildWithParent.prototype.productPrefix__T = (function() {
  return "ChildWithParent"
});
$c_Lreactbuild_model_ChildWithParent.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_ChildWithParent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_ChildWithParent__f_child;
      break
    }
    case 1: {
      return this.Lreactbuild_model_ChildWithParent__f_parent;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_ChildWithParent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ChildWithParent.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ChildWithParent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ChildWithParent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ChildWithParent)) {
    var ChildWithParent$1 = $as_Lreactbuild_model_ChildWithParent(x$1);
    var x = this.Lreactbuild_model_ChildWithParent__f_child;
    var y = $n(ChildWithParent$1).Lreactbuild_model_ChildWithParent__f_child;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_model_ChildWithParent__f_parent;
      var y$1 = $n(ChildWithParent$1).Lreactbuild_model_ChildWithParent__f_parent;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ChildWithParent(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ChildWithParent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ChildWithParent"))
}
function $isArrayOf_Lreactbuild_model_ChildWithParent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ChildWithParent)))
}
function $asArrayOf_Lreactbuild_model_ChildWithParent(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ChildWithParent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ChildWithParent;", depth))
}
var $d_Lreactbuild_model_ChildWithParent = new $TypeData().initClass({
  Lreactbuild_model_ChildWithParent: 0
}, false, "reactbuild.model.ChildWithParent", {
  Lreactbuild_model_ChildWithParent: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ChildWithParent.prototype.$classData = $d_Lreactbuild_model_ChildWithParent;
/** @constructor */
function $c_Lreactbuild_model_CommonData(persons, personAnnotations, buildingParts, buildingSites, buildingStages, buildingSiteStages, resources, products, listTemplates, terms, organizationUsers) {
  this.Lreactbuild_model_CommonData__f_persons = null;
  this.Lreactbuild_model_CommonData__f_personAnnotations = null;
  this.Lreactbuild_model_CommonData__f_buildingParts = null;
  this.Lreactbuild_model_CommonData__f_buildingSites = null;
  this.Lreactbuild_model_CommonData__f_buildingStages = null;
  this.Lreactbuild_model_CommonData__f_buildingSiteStages = null;
  this.Lreactbuild_model_CommonData__f_resources = null;
  this.Lreactbuild_model_CommonData__f_products = null;
  this.Lreactbuild_model_CommonData__f_listTemplates = null;
  this.Lreactbuild_model_CommonData__f_terms = null;
  this.Lreactbuild_model_CommonData__f_organizationUsers = null;
  this.Lreactbuild_model_CommonData__f_persons = persons;
  this.Lreactbuild_model_CommonData__f_personAnnotations = personAnnotations;
  this.Lreactbuild_model_CommonData__f_buildingParts = buildingParts;
  this.Lreactbuild_model_CommonData__f_buildingSites = buildingSites;
  this.Lreactbuild_model_CommonData__f_buildingStages = buildingStages;
  this.Lreactbuild_model_CommonData__f_buildingSiteStages = buildingSiteStages;
  this.Lreactbuild_model_CommonData__f_resources = resources;
  this.Lreactbuild_model_CommonData__f_products = products;
  this.Lreactbuild_model_CommonData__f_listTemplates = listTemplates;
  this.Lreactbuild_model_CommonData__f_terms = terms;
  this.Lreactbuild_model_CommonData__f_organizationUsers = organizationUsers
}
$c_Lreactbuild_model_CommonData.prototype = new $h_O();
$c_Lreactbuild_model_CommonData.prototype.constructor = $c_Lreactbuild_model_CommonData;
/** @constructor */
function $h_Lreactbuild_model_CommonData() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommonData.prototype = $c_Lreactbuild_model_CommonData.prototype;
$c_Lreactbuild_model_CommonData.prototype.productPrefix__T = (function() {
  return "CommonData"
});
$c_Lreactbuild_model_CommonData.prototype.productArity__I = (function() {
  return 11
});
$c_Lreactbuild_model_CommonData.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_CommonData__f_persons;
      break
    }
    case 1: {
      return this.Lreactbuild_model_CommonData__f_personAnnotations;
      break
    }
    case 2: {
      return this.Lreactbuild_model_CommonData__f_buildingParts;
      break
    }
    case 3: {
      return this.Lreactbuild_model_CommonData__f_buildingSites;
      break
    }
    case 4: {
      return this.Lreactbuild_model_CommonData__f_buildingStages;
      break
    }
    case 5: {
      return this.Lreactbuild_model_CommonData__f_buildingSiteStages;
      break
    }
    case 6: {
      return this.Lreactbuild_model_CommonData__f_resources;
      break
    }
    case 7: {
      return this.Lreactbuild_model_CommonData__f_products;
      break
    }
    case 8: {
      return this.Lreactbuild_model_CommonData__f_listTemplates;
      break
    }
    case 9: {
      return this.Lreactbuild_model_CommonData__f_terms;
      break
    }
    case 10: {
      return this.Lreactbuild_model_CommonData__f_organizationUsers;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_CommonData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CommonData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_CommonData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_CommonData.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_CommonData)) {
    var CommonData$1 = $as_Lreactbuild_model_CommonData(x$1);
    var x = this.Lreactbuild_model_CommonData__f_persons;
    var x$2 = $n(CommonData$1).Lreactbuild_model_CommonData__f_persons;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_CommonData__f_personAnnotations;
      var x$4 = $n(CommonData$1).Lreactbuild_model_CommonData__f_personAnnotations;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_model_CommonData__f_buildingParts;
      var x$6 = $n(CommonData$1).Lreactbuild_model_CommonData__f_buildingParts;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_CommonData__f_buildingSites;
        var x$8 = $n(CommonData$1).Lreactbuild_model_CommonData__f_buildingSites;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_model_CommonData__f_buildingStages;
          var x$10 = $n(CommonData$1).Lreactbuild_model_CommonData__f_buildingStages;
          var $$x1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var x$12 = $n(CommonData$1).Lreactbuild_model_CommonData__f_buildingSiteStages;
      if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
        var x$13 = this.Lreactbuild_model_CommonData__f_resources;
        var x$14 = $n(CommonData$1).Lreactbuild_model_CommonData__f_resources;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          var x$15 = this.Lreactbuild_model_CommonData__f_products;
          var x$16 = $n(CommonData$1).Lreactbuild_model_CommonData__f_products;
          var $$x3 = ((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))
        } else {
          var $$x3 = false
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$17 = this.Lreactbuild_model_CommonData__f_listTemplates;
        var x$18 = $n(CommonData$1).Lreactbuild_model_CommonData__f_listTemplates;
        if (((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))) {
          var x$19 = this.Lreactbuild_model_CommonData__f_terms;
          var x$20 = $n(CommonData$1).Lreactbuild_model_CommonData__f_terms;
          if (((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))) {
            var x$21 = this.Lreactbuild_model_CommonData__f_organizationUsers;
            var x$22 = $n(CommonData$1).Lreactbuild_model_CommonData__f_organizationUsers;
            return ((x$21 === null) ? (x$22 === null) : $n(x$21).equals__O__Z(x$22))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_CommonData(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CommonData) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommonData"))
}
function $isArrayOf_Lreactbuild_model_CommonData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommonData)))
}
function $asArrayOf_Lreactbuild_model_CommonData(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommonData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommonData;", depth))
}
var $d_Lreactbuild_model_CommonData = new $TypeData().initClass({
  Lreactbuild_model_CommonData: 0
}, false, "reactbuild.model.CommonData", {
  Lreactbuild_model_CommonData: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommonData.prototype.$classData = $d_Lreactbuild_model_CommonData;
/** @constructor */
function $c_Lreactbuild_model_Communication(_id, organization, persons, senderAddress, receiverAddress, date, subject, bodies, attachments, headers) {
  this.Lreactbuild_model_Communication__f__id = null;
  this.Lreactbuild_model_Communication__f_organization = null;
  this.Lreactbuild_model_Communication__f_persons = null;
  this.Lreactbuild_model_Communication__f_senderAddress = null;
  this.Lreactbuild_model_Communication__f_receiverAddress = null;
  this.Lreactbuild_model_Communication__f_date = null;
  this.Lreactbuild_model_Communication__f_subject = null;
  this.Lreactbuild_model_Communication__f_bodies = null;
  this.Lreactbuild_model_Communication__f_attachments = null;
  this.Lreactbuild_model_Communication__f_headers = null;
  this.Lreactbuild_model_Communication__f__id = _id;
  this.Lreactbuild_model_Communication__f_organization = organization;
  this.Lreactbuild_model_Communication__f_persons = persons;
  this.Lreactbuild_model_Communication__f_senderAddress = senderAddress;
  this.Lreactbuild_model_Communication__f_receiverAddress = receiverAddress;
  this.Lreactbuild_model_Communication__f_date = date;
  this.Lreactbuild_model_Communication__f_subject = subject;
  this.Lreactbuild_model_Communication__f_bodies = bodies;
  this.Lreactbuild_model_Communication__f_attachments = attachments;
  this.Lreactbuild_model_Communication__f_headers = headers
}
$c_Lreactbuild_model_Communication.prototype = new $h_O();
$c_Lreactbuild_model_Communication.prototype.constructor = $c_Lreactbuild_model_Communication;
/** @constructor */
function $h_Lreactbuild_model_Communication() {
  /*<skip>*/
}
$h_Lreactbuild_model_Communication.prototype = $c_Lreactbuild_model_Communication.prototype;
$c_Lreactbuild_model_Communication.prototype.productPrefix__T = (function() {
  return "Communication"
});
$c_Lreactbuild_model_Communication.prototype.productArity__I = (function() {
  return 10
});
$c_Lreactbuild_model_Communication.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_Communication__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_Communication__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_Communication__f_persons;
      break
    }
    case 3: {
      return this.Lreactbuild_model_Communication__f_senderAddress;
      break
    }
    case 4: {
      return this.Lreactbuild_model_Communication__f_receiverAddress;
      break
    }
    case 5: {
      return this.Lreactbuild_model_Communication__f_date;
      break
    }
    case 6: {
      return this.Lreactbuild_model_Communication__f_subject;
      break
    }
    case 7: {
      return this.Lreactbuild_model_Communication__f_bodies;
      break
    }
    case 8: {
      return this.Lreactbuild_model_Communication__f_attachments;
      break
    }
    case 9: {
      return this.Lreactbuild_model_Communication__f_headers;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_Communication.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Communication.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_Communication.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Communication.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Communication)) {
    var Communication$1 = $as_Lreactbuild_model_Communication(x$1);
    var x = this.Lreactbuild_model_Communication__f__id;
    var x$2 = $n(Communication$1).Lreactbuild_model_Communication__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_Communication__f_organization;
      var x$4 = $n(Communication$1).Lreactbuild_model_Communication__f_organization;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_model_Communication__f_persons;
      var x$6 = $n(Communication$1).Lreactbuild_model_Communication__f_persons;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var $$x1 = ((this.Lreactbuild_model_Communication__f_senderAddress === $n(Communication$1).Lreactbuild_model_Communication__f_senderAddress) && (this.Lreactbuild_model_Communication__f_receiverAddress === $n(Communication$1).Lreactbuild_model_Communication__f_receiverAddress))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_model_Communication__f_date;
      var x$8 = $n(Communication$1).Lreactbuild_model_Communication__f_date;
      if ((((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8)) && (this.Lreactbuild_model_Communication__f_subject === $n(Communication$1).Lreactbuild_model_Communication__f_subject))) {
        var x$9 = this.Lreactbuild_model_Communication__f_bodies;
        var x$10 = $n(Communication$1).Lreactbuild_model_Communication__f_bodies;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_model_Communication__f_attachments;
          var x$12 = $n(Communication$1).Lreactbuild_model_Communication__f_attachments;
          if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
            var x$13 = this.Lreactbuild_model_Communication__f_headers;
            var x$14 = $n(Communication$1).Lreactbuild_model_Communication__f_headers;
            return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Communication(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Communication) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Communication"))
}
function $isArrayOf_Lreactbuild_model_Communication(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Communication)))
}
function $asArrayOf_Lreactbuild_model_Communication(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Communication(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Communication;", depth))
}
var $d_Lreactbuild_model_Communication = new $TypeData().initClass({
  Lreactbuild_model_Communication: 0
}, false, "reactbuild.model.Communication", {
  Lreactbuild_model_Communication: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Communication.prototype.$classData = $d_Lreactbuild_model_Communication;
/** @constructor */
function $c_Lreactbuild_model_CommunicationAttachment(id, file) {
  this.Lreactbuild_model_CommunicationAttachment__f_id = null;
  this.Lreactbuild_model_CommunicationAttachment__f_file = null;
  this.Lreactbuild_model_CommunicationAttachment__f_id = id;
  this.Lreactbuild_model_CommunicationAttachment__f_file = file
}
$c_Lreactbuild_model_CommunicationAttachment.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationAttachment.prototype.constructor = $c_Lreactbuild_model_CommunicationAttachment;
/** @constructor */
function $h_Lreactbuild_model_CommunicationAttachment() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationAttachment.prototype = $c_Lreactbuild_model_CommunicationAttachment.prototype;
$c_Lreactbuild_model_CommunicationAttachment.prototype.productPrefix__T = (function() {
  return "CommunicationAttachment"
});
$c_Lreactbuild_model_CommunicationAttachment.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_CommunicationAttachment.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_CommunicationAttachment__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_CommunicationAttachment__f_file;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_CommunicationAttachment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CommunicationAttachment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_CommunicationAttachment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_CommunicationAttachment.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_CommunicationAttachment)) {
    var CommunicationAttachment$1 = $as_Lreactbuild_model_CommunicationAttachment(x$1);
    var x = this.Lreactbuild_model_CommunicationAttachment__f_id;
    var x$2 = $n(CommunicationAttachment$1).Lreactbuild_model_CommunicationAttachment__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_CommunicationAttachment__f_file;
      var x$4 = $n(CommunicationAttachment$1).Lreactbuild_model_CommunicationAttachment__f_file;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_CommunicationAttachment(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CommunicationAttachment) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommunicationAttachment"))
}
function $isArrayOf_Lreactbuild_model_CommunicationAttachment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommunicationAttachment)))
}
function $asArrayOf_Lreactbuild_model_CommunicationAttachment(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommunicationAttachment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommunicationAttachment;", depth))
}
var $d_Lreactbuild_model_CommunicationAttachment = new $TypeData().initClass({
  Lreactbuild_model_CommunicationAttachment: 0
}, false, "reactbuild.model.CommunicationAttachment", {
  Lreactbuild_model_CommunicationAttachment: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationAttachment.prototype.$classData = $d_Lreactbuild_model_CommunicationAttachment;
/** @constructor */
function $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5(outer) {
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5__f_circeGenericDecoderFortextSource = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5__f_circeGenericDecoderFortextSource = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5.prototype.constructor = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5;
/** @constructor */
function $h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5.prototype = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5.prototype;
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("textSource"))), this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5__f_circeGenericDecoderFortextSource, "textSource", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5: 0
}, false, "reactbuild.model.CommunicationBody$anon$lazy$macro$79$1$$anon$5", {
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5.prototype.$classData = $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$5;
/** @constructor */
function $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6(outer) {
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6__f_circeGenericDecoderForpart = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6__f_circeGenericDecoderForpart = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6.prototype.constructor = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6.prototype = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6.prototype;
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("source"))), this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6__f_circeGenericDecoderForpart, "source", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("part"))), this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6__f_circeGenericDecoderForpart, "part", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6: 0
}, false, "reactbuild.model.CommunicationBody$anon$lazy$macro$79$1$$anon$6", {
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6.prototype.$classData = $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7(outer) {
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7__f_circeGenericDecoderForhtmlSource = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7__f_circeGenericDecoderForhtmlSource = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7.prototype.constructor = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7.prototype = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7.prototype;
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("htmlSource"))), this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7__f_circeGenericDecoderForhtmlSource, "htmlSource", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7: 0
}, false, "reactbuild.model.CommunicationBody$anon$lazy$macro$79$1$$anon$7", {
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7.prototype.$classData = $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_model_CommunicationPerson(role, person, address, added) {
  this.Lreactbuild_model_CommunicationPerson__f_role = null;
  this.Lreactbuild_model_CommunicationPerson__f_person = null;
  this.Lreactbuild_model_CommunicationPerson__f_address = null;
  this.Lreactbuild_model_CommunicationPerson__f_added = null;
  this.Lreactbuild_model_CommunicationPerson__f_role = role;
  this.Lreactbuild_model_CommunicationPerson__f_person = person;
  this.Lreactbuild_model_CommunicationPerson__f_address = address;
  this.Lreactbuild_model_CommunicationPerson__f_added = added
}
$c_Lreactbuild_model_CommunicationPerson.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationPerson.prototype.constructor = $c_Lreactbuild_model_CommunicationPerson;
/** @constructor */
function $h_Lreactbuild_model_CommunicationPerson() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationPerson.prototype = $c_Lreactbuild_model_CommunicationPerson.prototype;
$c_Lreactbuild_model_CommunicationPerson.prototype.productPrefix__T = (function() {
  return "CommunicationPerson"
});
$c_Lreactbuild_model_CommunicationPerson.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_model_CommunicationPerson.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_CommunicationPerson__f_role;
      break
    }
    case 1: {
      return this.Lreactbuild_model_CommunicationPerson__f_person;
      break
    }
    case 2: {
      return this.Lreactbuild_model_CommunicationPerson__f_address;
      break
    }
    case 3: {
      return this.Lreactbuild_model_CommunicationPerson__f_added;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_CommunicationPerson.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CommunicationPerson.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_CommunicationPerson.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_CommunicationPerson.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_CommunicationPerson)) {
    var CommunicationPerson$1 = $as_Lreactbuild_model_CommunicationPerson(x$1);
    var x = this.Lreactbuild_model_CommunicationPerson__f_role;
    var x$2 = $n(CommunicationPerson$1).Lreactbuild_model_CommunicationPerson__f_role;
    if ((x === null)) {
      var $$x2 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x2 = (this$1 === x$2)
    };
    if ($$x2) {
      var x$3 = this.Lreactbuild_model_CommunicationPerson__f_person;
      var x$4 = $n(CommunicationPerson$1).Lreactbuild_model_CommunicationPerson__f_person;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_model_CommunicationPerson__f_address;
      var x$6 = $n(CommunicationPerson$1).Lreactbuild_model_CommunicationPerson__f_address;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_CommunicationPerson__f_added;
        var x$8 = $n(CommunicationPerson$1).Lreactbuild_model_CommunicationPerson__f_added;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_CommunicationPerson(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CommunicationPerson) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommunicationPerson"))
}
function $isArrayOf_Lreactbuild_model_CommunicationPerson(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommunicationPerson)))
}
function $asArrayOf_Lreactbuild_model_CommunicationPerson(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommunicationPerson(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommunicationPerson;", depth))
}
var $d_Lreactbuild_model_CommunicationPerson = new $TypeData().initClass({
  Lreactbuild_model_CommunicationPerson: 0
}, false, "reactbuild.model.CommunicationPerson", {
  Lreactbuild_model_CommunicationPerson: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationPerson.prototype.$classData = $d_Lreactbuild_model_CommunicationPerson;
/** @constructor */
function $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37(outer) {
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderFordocument = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForsupplier = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForentryLine = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderFordeliveredQuantity = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForamount = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderFordocument = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForsupplier = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForentryLine = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderFordeliveredQuantity = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForamount = new $c_Lio_circe_Decoder$$anon$39(d$1)
}
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37.prototype.constructor = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37;
/** @constructor */
function $h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37() {
  /*<skip>*/
}
$h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37.prototype = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37.prototype;
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForentryLine, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("document"))), this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderFordocument, "document", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("supplier"))), this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForsupplier, "supplier", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("entryLine"))), this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForentryLine, "entryLine", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("deliveredQuantity"))), this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderFordeliveredQuantity, "deliveredQuantity", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("amount"))), this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37__f_circeGenericDecoderForamount, "amount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37 = new $TypeData().initClass({
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37: 0
}, false, "reactbuild.model.DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37", {
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37.prototype.$classData = $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$37;
/** @constructor */
function $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38(outer) {
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38__f_circeGenericDecoderForcontent = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38__f_circeGenericDecoderForcontent = $m_Lreactbuild_model_InvoiceDetail$().Lreactbuild_model_InvoiceDetail$__f_codecForInvoiceDetail
}
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38.prototype.constructor = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38;
/** @constructor */
function $h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38() {
  /*<skip>*/
}
$h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38.prototype = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38.prototype;
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("content"))), this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38__f_circeGenericDecoderForcontent, "content", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38 = new $TypeData().initClass({
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38: 0
}, false, "reactbuild.model.DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38", {
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38.prototype.$classData = $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$38;
/** @constructor */
function $c_Lreactbuild_model_Duration(value) {
  this.Lreactbuild_model_Duration__f_value = 0.0;
  this.Lreactbuild_model_Duration__f_value = value
}
$c_Lreactbuild_model_Duration.prototype = new $h_O();
$c_Lreactbuild_model_Duration.prototype.constructor = $c_Lreactbuild_model_Duration;
/** @constructor */
function $h_Lreactbuild_model_Duration() {
  /*<skip>*/
}
$h_Lreactbuild_model_Duration.prototype = $c_Lreactbuild_model_Duration.prototype;
$c_Lreactbuild_model_Duration.prototype.productPrefix__T = (function() {
  return "Duration"
});
$c_Lreactbuild_model_Duration.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_Duration.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_Duration__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_Duration.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Duration.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Duration");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_model_Duration__f_value;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_model_Duration.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Duration.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Duration)) {
    var Duration$1 = $as_Lreactbuild_model_Duration(x$1);
    return (this.Lreactbuild_model_Duration__f_value === $n(Duration$1).Lreactbuild_model_Duration__f_value)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Duration(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Duration"))
}
function $isArrayOf_Lreactbuild_model_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Duration)))
}
function $asArrayOf_Lreactbuild_model_Duration(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Duration;", depth))
}
var $d_Lreactbuild_model_Duration = new $TypeData().initClass({
  Lreactbuild_model_Duration: 0
}, false, "reactbuild.model.Duration", {
  Lreactbuild_model_Duration: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Duration.prototype.$classData = $d_Lreactbuild_model_Duration;
/** @constructor */
function $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2(outer) {
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2__f_circeGenericDecoderForprojectRef = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2__f_circeGenericDecoderFory = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2__f_circeGenericDecoderForprojectRef = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2__f_circeGenericDecoderFory = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble
}
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2.prototype = new $h_Lio_circe_generic_decoding_ReprDecoder();
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2.prototype.constructor = $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2.prototype = $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2.prototype;
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2__f_circeGenericDecoderForprojectRef).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("projectRef")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2__f_circeGenericDecoderFory).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("x")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2__f_circeGenericDecoderFory).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("y")), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2: 0
}, false, "reactbuild.model.FromClient$anon$lazy$macro$31$1$$anon$2", {
  Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2: 1,
  Lio_circe_generic_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2.prototype.$classData = $d_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_model_Implicits$$anon$24() {
  /*<skip>*/
}
$c_Lreactbuild_model_Implicits$$anon$24.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$$anon$24.prototype.constructor = $c_Lreactbuild_model_Implicits$$anon$24;
/** @constructor */
function $h_Lreactbuild_model_Implicits$$anon$24() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$$anon$24.prototype = $c_Lreactbuild_model_Implicits$$anon$24.prototype;
$c_Lreactbuild_model_Implicits$$anon$24.prototype.parse__T__s_util_Try = (function(in$1) {
  var $$x2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var $$x1 = $m_sc_StringOps$();
  var this$1 = $n($f_T__trim__T($n(in$1)));
  var x = $as_T(this$1.toLowerCase());
  return $n($n($$x2).parse__T__s_util_Try($f_T__trim__T($n($n($$x1).stripSuffix$extension__T__T__T(x, "h"))))).map__F1__s_util_Try(new $c_sjsr_AnonFunction1(((x$44$2) => {
    var x$44 = $uD(x$44$2);
    return new $c_Lreactbuild_model_Duration(x$44)
  })))
});
$c_Lreactbuild_model_Implicits$$anon$24.prototype.stringify__Lreactbuild_model_Duration__T = (function(value) {
  var $$x1 = $m_sc_StringOps$();
  var array = [$n(value).Lreactbuild_model_Duration__f_value];
  return $n($$x1).format$extension__T__sci_Seq__T("%.2f h", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_model_Implicits$$anon$24.prototype.stringify__O__T = (function(value) {
  return this.stringify__Lreactbuild_model_Duration__T($as_Lreactbuild_model_Duration(value))
});
var $d_Lreactbuild_model_Implicits$$anon$24 = new $TypeData().initClass({
  Lreactbuild_model_Implicits$$anon$24: 0
}, false, "reactbuild.model.Implicits$$anon$24", {
  Lreactbuild_model_Implicits$$anon$24: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Implicits$$anon$24.prototype.$classData = $d_Lreactbuild_model_Implicits$$anon$24;
/** @constructor */
function $c_Lreactbuild_model_Implicits$$anon$25() {
  /*<skip>*/
}
$c_Lreactbuild_model_Implicits$$anon$25.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$$anon$25.prototype.constructor = $c_Lreactbuild_model_Implicits$$anon$25;
/** @constructor */
function $h_Lreactbuild_model_Implicits$$anon$25() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$$anon$25.prototype = $c_Lreactbuild_model_Implicits$$anon$25.prototype;
$c_Lreactbuild_model_Implicits$$anon$25.prototype.parse__T__s_util_Try = (function(input) {
  return $n($n($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble).parse__T__s_util_Try(input)).map__F1__s_util_Try(new $c_sjsr_AnonFunction1(((x$47$2) => {
    var x$47 = $uD(x$47$2);
    return new $c_Lreactbuild_model_Price(x$47)
  })))
});
$c_Lreactbuild_model_Implicits$$anon$25.prototype.stringify__Lreactbuild_model_Price__T = (function(value) {
  var x = $n(value).Lreactbuild_model_Price__f_amount;
  var $$x1 = x.toFixed(2);
  return $as_T($$x1)
});
$c_Lreactbuild_model_Implicits$$anon$25.prototype.stringify__O__T = (function(value) {
  return this.stringify__Lreactbuild_model_Price__T($as_Lreactbuild_model_Price(value))
});
var $d_Lreactbuild_model_Implicits$$anon$25 = new $TypeData().initClass({
  Lreactbuild_model_Implicits$$anon$25: 0
}, false, "reactbuild.model.Implicits$$anon$25", {
  Lreactbuild_model_Implicits$$anon$25: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Implicits$$anon$25.prototype.$classData = $d_Lreactbuild_model_Implicits$$anon$25;
/** @constructor */
function $c_Lreactbuild_model_Implicits$$anon$26() {
  this.Lreactbuild_model_Implicits$$anon$26__f_re = null;
  this.Lreactbuild_model_Implicits$$anon$26__f_re = ($m_sc_StringOps$(), $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^\\s*([0-9]+)\\s*(?:J\\s*([0-9]+))?\\s*$", $m_sci_Nil$()))
}
$c_Lreactbuild_model_Implicits$$anon$26.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$$anon$26.prototype.constructor = $c_Lreactbuild_model_Implicits$$anon$26;
/** @constructor */
function $h_Lreactbuild_model_Implicits$$anon$26() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$$anon$26.prototype = $c_Lreactbuild_model_Implicits$$anon$26.prototype;
$c_Lreactbuild_model_Implicits$$anon$26.prototype.parse__T__s_util_Try = (function(input) {
  try {
    matchEnd4: {
      var $$x1;
      if ((input !== null)) {
        var o7 = $n(this.Lreactbuild_model_Implicits$$anon$26__f_re).unapplySeq__jl_CharSequence__s_Option(input);
        if (((!$n(o7).isEmpty__Z()) && (($n(o7).get__O() !== null) && ($n($as_sci_List($n(o7).get__O())).lengthCompare__I__I(2) === 0)))) {
          var period = $as_T($n($as_sc_LinearSeqOps($n(o7).get__O())).apply__I__O(0));
          var before = $as_T($n($as_sc_LinearSeqOps($n(o7).get__O())).apply__I__O(1));
          var this$2 = $n($m_s_Option$().apply__O__s_Option(period));
          if (this$2.isEmpty__Z()) {
            var x$1 = $m_s_None$()
          } else {
            var arg1 = this$2.get__O();
            var v = $as_T(arg1);
            $m_sc_StringOps$();
            var this$5 = $m_jl_Integer$();
            var x$1 = new $c_s_Some(new $c_Lreactbuild_model_Duration(this$5.parseInt__T__I__I(v, 10)))
          };
          var this$6 = $n($m_s_Option$().apply__O__s_Option(before));
          if (this$6.isEmpty__Z()) {
            var x$2 = $m_s_None$()
          } else {
            var arg1$1 = this$6.get__O();
            var v$3 = $as_T(arg1$1);
            $m_sc_StringOps$();
            var this$9 = $m_jl_Integer$();
            var x$2 = new $c_s_Some(this$9.parseInt__T__I__I(v$3, 10))
          };
          $m_Lreactbuild_person_PaymentTermAndConditions$();
          var x$3 = $m_s_None$();
          var $$x1 = new $c_Lreactbuild_person_PaymentTermAndConditions(x$3, x$1, x$2);
          break matchEnd4
        }
      };
      throw new $c_s_MatchError(input)
    };
    return new $c_s_util_Success($$x1)
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(o11).isEmpty__Z())) {
      var e$3 = $as_jl_Throwable($n(o11).get__O());
      return new $c_s_util_Failure(e$3)
    };
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
  }
});
$c_Lreactbuild_model_Implicits$$anon$26.prototype.stringify__Lreactbuild_person_PaymentTermAndConditions__T = (function(value) {
  var $$x2 = $m_s_Option$();
  var this$1 = $n($n(value).Lreactbuild_person_PaymentTermAndConditions__f_period);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var v = $as_Lreactbuild_model_Duration(arg1);
    var $$x1 = new $c_s_Some(($n(v).Lreactbuild_model_Duration__f_value + "J"))
  };
  var this$4 = $n($n($$x2).option2Iterable__s_Option__sc_Iterable($$x1));
  var this$2 = $n($n(value).Lreactbuild_person_PaymentTermAndConditions__f_before);
  if (this$2.isEmpty__Z()) {
    var suffix = $m_s_None$()
  } else {
    var arg1$1 = this$2.get__O();
    var x$51 = $uI(arg1$1);
    var suffix = new $c_s_Some(("" + x$51))
  };
  var this$5 = $n($as_sc_IterableOnceOps(this$4.concat__sc_IterableOnce__O(suffix)));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", "", "")
});
$c_Lreactbuild_model_Implicits$$anon$26.prototype.stringify__O__T = (function(value) {
  return this.stringify__Lreactbuild_person_PaymentTermAndConditions__T($as_Lreactbuild_person_PaymentTermAndConditions(value))
});
var $d_Lreactbuild_model_Implicits$$anon$26 = new $TypeData().initClass({
  Lreactbuild_model_Implicits$$anon$26: 0
}, false, "reactbuild.model.Implicits$$anon$26", {
  Lreactbuild_model_Implicits$$anon$26: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Implicits$$anon$26.prototype.$classData = $d_Lreactbuild_model_Implicits$$anon$26;
/** @constructor */
function $c_Lreactbuild_model_Implicits$$anon$27() {
  /*<skip>*/
}
$c_Lreactbuild_model_Implicits$$anon$27.prototype = new $h_O();
$c_Lreactbuild_model_Implicits$$anon$27.prototype.constructor = $c_Lreactbuild_model_Implicits$$anon$27;
/** @constructor */
function $h_Lreactbuild_model_Implicits$$anon$27() {
  /*<skip>*/
}
$h_Lreactbuild_model_Implicits$$anon$27.prototype = $c_Lreactbuild_model_Implicits$$anon$27.prototype;
$c_Lreactbuild_model_Implicits$$anon$27.prototype.parse__T__s_util_Try = (function(input) {
  try {
    $m_sc_StringOps$();
    var hourFormat = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(\\d+) *[h:] *(\\d+)?", $m_sci_Nil$());
    $m_sc_StringOps$();
    var decimalFormat = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(\\d+)(?:.(\\d*)|)", $m_sci_Nil$());
    var x1 = $f_T__trim__T($n(input));
    matchEnd5: {
      var $$x1;
      if ((x1 !== null)) {
        var o8 = hourFormat.unapplySeq__jl_CharSequence__s_Option(x1);
        if (((!$n(o8).isEmpty__Z()) && (($n(o8).get__O() !== null) && ($n($as_sci_List($n(o8).get__O())).lengthCompare__I__I(2) === 0)))) {
          var h = $as_T($n($as_sc_LinearSeqOps($n(o8).get__O())).apply__I__O(0));
          var m = $as_T($n($as_sc_LinearSeqOps($n(o8).get__O())).apply__I__O(1));
          $m_sc_StringOps$();
          var this$8 = $m_jl_Integer$();
          var hour = this$8.parseInt__T__I__I(h, 10);
          if ((m === null)) {
            var minute = 0
          } else {
            $m_sc_StringOps$();
            var this$11 = $m_jl_Integer$();
            var minute = this$11.parseInt__T__I__I(m, 10)
          };
          var $$x1 = $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(hour, minute);
          break matchEnd5
        }
      };
      if ((x1 !== null)) {
        var o10 = decimalFormat.unapplySeq__jl_CharSequence__s_Option(x1);
        if (((!$n(o10).isEmpty__Z()) && (($n(o10).get__O() !== null) && ($n($as_sci_List($n(o10).get__O())).lengthCompare__I__I(2) === 0)))) {
          var h$2 = $as_T($n($as_sc_LinearSeqOps($n(o10).get__O())).apply__I__O(0));
          var fh = $as_T($n($as_sc_LinearSeqOps($n(o10).get__O())).apply__I__O(1));
          $m_sc_StringOps$();
          var this$14 = $m_jl_Integer$();
          var $$x3 = this$14.parseInt__T__I__I(h$2, 10);
          if ((fh === null)) {
            var $$x2 = 0.0
          } else {
            $m_sc_StringOps$();
            var x = ("0." + fh);
            var $$x2 = $m_jl_Double$().parseDouble__T__D(x)
          };
          var value = $doubleToInt((3600.0 * ($$x3 + $$x2)));
          var hi = (value >> 31);
          var $$x1 = $m_Ljava_time_LocalTime$().ofSecondOfDay__J__Ljava_time_LocalTime(new $c_RTLong(value, hi));
          break matchEnd5
        }
      };
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Can not recognize " + input) + " as hour"))
    };
    return new $c_s_util_Success($$x1)
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(o11).isEmpty__Z())) {
      var e$3 = $as_jl_Throwable($n(o11).get__O());
      return new $c_s_util_Failure(e$3)
    };
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
  }
});
$c_Lreactbuild_model_Implicits$$anon$27.prototype.stringify__Ljava_time_LocalTime__T = (function(x) {
  var $$x2 = $m_sc_StringOps$();
  var this$1 = $n(x);
  var $$x1 = $p_Ljava_time_LocalTime__hour__B(this$1);
  var this$2 = $n(x);
  var array = [$$x1, $p_Ljava_time_LocalTime__minute__B(this$2)];
  return $n($$x2).format$extension__T__sci_Seq__T("%02.0fh%02.0f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_model_Implicits$$anon$27.prototype.stringify__O__T = (function(value) {
  return this.stringify__Ljava_time_LocalTime__T($as_Ljava_time_LocalTime(value))
});
var $d_Lreactbuild_model_Implicits$$anon$27 = new $TypeData().initClass({
  Lreactbuild_model_Implicits$$anon$27: 0
}, false, "reactbuild.model.Implicits$$anon$27", {
  Lreactbuild_model_Implicits$$anon$27: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Implicits$$anon$27.prototype.$classData = $d_Lreactbuild_model_Implicits$$anon$27;
/** @constructor */
function $c_Lreactbuild_model_InvoiceDetail(id, reference, description, quantity, unit, unitPrice, amount, tradeBody, buildingSite, deliveryDate) {
  this.Lreactbuild_model_InvoiceDetail__f_id = null;
  this.Lreactbuild_model_InvoiceDetail__f_reference = null;
  this.Lreactbuild_model_InvoiceDetail__f_description = null;
  this.Lreactbuild_model_InvoiceDetail__f_quantity = null;
  this.Lreactbuild_model_InvoiceDetail__f_unit = null;
  this.Lreactbuild_model_InvoiceDetail__f_unitPrice = null;
  this.Lreactbuild_model_InvoiceDetail__f_amount = null;
  this.Lreactbuild_model_InvoiceDetail__f_tradeBody = null;
  this.Lreactbuild_model_InvoiceDetail__f_buildingSite = null;
  this.Lreactbuild_model_InvoiceDetail__f_deliveryDate = null;
  this.Lreactbuild_model_InvoiceDetail__f_id = id;
  this.Lreactbuild_model_InvoiceDetail__f_reference = reference;
  this.Lreactbuild_model_InvoiceDetail__f_description = description;
  this.Lreactbuild_model_InvoiceDetail__f_quantity = quantity;
  this.Lreactbuild_model_InvoiceDetail__f_unit = unit;
  this.Lreactbuild_model_InvoiceDetail__f_unitPrice = unitPrice;
  this.Lreactbuild_model_InvoiceDetail__f_amount = amount;
  this.Lreactbuild_model_InvoiceDetail__f_tradeBody = tradeBody;
  this.Lreactbuild_model_InvoiceDetail__f_buildingSite = buildingSite;
  this.Lreactbuild_model_InvoiceDetail__f_deliveryDate = deliveryDate
}
$c_Lreactbuild_model_InvoiceDetail.prototype = new $h_O();
$c_Lreactbuild_model_InvoiceDetail.prototype.constructor = $c_Lreactbuild_model_InvoiceDetail;
/** @constructor */
function $h_Lreactbuild_model_InvoiceDetail() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoiceDetail.prototype = $c_Lreactbuild_model_InvoiceDetail.prototype;
$c_Lreactbuild_model_InvoiceDetail.prototype.productPrefix__T = (function() {
  return "InvoiceDetail"
});
$c_Lreactbuild_model_InvoiceDetail.prototype.productArity__I = (function() {
  return 10
});
$c_Lreactbuild_model_InvoiceDetail.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_InvoiceDetail__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_InvoiceDetail__f_reference;
      break
    }
    case 2: {
      return this.Lreactbuild_model_InvoiceDetail__f_description;
      break
    }
    case 3: {
      return this.Lreactbuild_model_InvoiceDetail__f_quantity;
      break
    }
    case 4: {
      return this.Lreactbuild_model_InvoiceDetail__f_unit;
      break
    }
    case 5: {
      return this.Lreactbuild_model_InvoiceDetail__f_unitPrice;
      break
    }
    case 6: {
      return this.Lreactbuild_model_InvoiceDetail__f_amount;
      break
    }
    case 7: {
      return this.Lreactbuild_model_InvoiceDetail__f_tradeBody;
      break
    }
    case 8: {
      return this.Lreactbuild_model_InvoiceDetail__f_buildingSite;
      break
    }
    case 9: {
      return this.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_InvoiceDetail.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_InvoiceDetail.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_InvoiceDetail.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_InvoiceDetail.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_InvoiceDetail)) {
    var InvoiceDetail$1 = $as_Lreactbuild_model_InvoiceDetail(x$1);
    var x = this.Lreactbuild_model_InvoiceDetail__f_id;
    var x$2 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_InvoiceDetail__f_reference;
      var x$4 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_reference;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_model_InvoiceDetail__f_description;
      var x$6 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_description;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_InvoiceDetail__f_quantity;
        var x$8 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_quantity;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_model_InvoiceDetail__f_unit;
          var x$10 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_unit;
          var $$x1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Lreactbuild_model_InvoiceDetail__f_unitPrice;
      var x$12 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_unitPrice;
      if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
        var x$13 = this.Lreactbuild_model_InvoiceDetail__f_amount;
        var x$14 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_amount;
        var $$x3 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$15 = this.Lreactbuild_model_InvoiceDetail__f_tradeBody;
        var x$16 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_tradeBody;
        if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
          var x$17 = this.Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var x$18 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_buildingSite;
          if (((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))) {
            var x$19 = this.Lreactbuild_model_InvoiceDetail__f_deliveryDate;
            var x$20 = $n(InvoiceDetail$1).Lreactbuild_model_InvoiceDetail__f_deliveryDate;
            return ((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_InvoiceDetail(obj) {
  return (((obj instanceof $c_Lreactbuild_model_InvoiceDetail) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.InvoiceDetail"))
}
function $isArrayOf_Lreactbuild_model_InvoiceDetail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_InvoiceDetail)))
}
function $asArrayOf_Lreactbuild_model_InvoiceDetail(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_InvoiceDetail(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.InvoiceDetail;", depth))
}
var $d_Lreactbuild_model_InvoiceDetail = new $TypeData().initClass({
  Lreactbuild_model_InvoiceDetail: 0
}, false, "reactbuild.model.InvoiceDetail", {
  Lreactbuild_model_InvoiceDetail: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoiceDetail.prototype.$classData = $d_Lreactbuild_model_InvoiceDetail;
/** @constructor */
function $c_Lreactbuild_model_InvoicePage(_id, organization, file, notDone, supplier, supplierOffice, date, reference, pageIndex, pageCount, amount, totalAmount, details, entryNumber, category, deletedAt) {
  this.Lreactbuild_model_InvoicePage__f__id = null;
  this.Lreactbuild_model_InvoicePage__f_organization = null;
  this.Lreactbuild_model_InvoicePage__f_file = null;
  this.Lreactbuild_model_InvoicePage__f_notDone = false;
  this.Lreactbuild_model_InvoicePage__f_supplier = null;
  this.Lreactbuild_model_InvoicePage__f_supplierOffice = null;
  this.Lreactbuild_model_InvoicePage__f_date = null;
  this.Lreactbuild_model_InvoicePage__f_reference = null;
  this.Lreactbuild_model_InvoicePage__f_pageIndex = null;
  this.Lreactbuild_model_InvoicePage__f_pageCount = null;
  this.Lreactbuild_model_InvoicePage__f_amount = null;
  this.Lreactbuild_model_InvoicePage__f_totalAmount = null;
  this.Lreactbuild_model_InvoicePage__f_details = null;
  this.Lreactbuild_model_InvoicePage__f_entryNumber = null;
  this.Lreactbuild_model_InvoicePage__f_category = null;
  this.Lreactbuild_model_InvoicePage__f_deletedAt = null;
  this.Lreactbuild_model_InvoicePage__f__id = _id;
  this.Lreactbuild_model_InvoicePage__f_organization = organization;
  this.Lreactbuild_model_InvoicePage__f_file = file;
  this.Lreactbuild_model_InvoicePage__f_notDone = notDone;
  this.Lreactbuild_model_InvoicePage__f_supplier = supplier;
  this.Lreactbuild_model_InvoicePage__f_supplierOffice = supplierOffice;
  this.Lreactbuild_model_InvoicePage__f_date = date;
  this.Lreactbuild_model_InvoicePage__f_reference = reference;
  this.Lreactbuild_model_InvoicePage__f_pageIndex = pageIndex;
  this.Lreactbuild_model_InvoicePage__f_pageCount = pageCount;
  this.Lreactbuild_model_InvoicePage__f_amount = amount;
  this.Lreactbuild_model_InvoicePage__f_totalAmount = totalAmount;
  this.Lreactbuild_model_InvoicePage__f_details = details;
  this.Lreactbuild_model_InvoicePage__f_entryNumber = entryNumber;
  this.Lreactbuild_model_InvoicePage__f_category = category;
  this.Lreactbuild_model_InvoicePage__f_deletedAt = deletedAt
}
$c_Lreactbuild_model_InvoicePage.prototype = new $h_O();
$c_Lreactbuild_model_InvoicePage.prototype.constructor = $c_Lreactbuild_model_InvoicePage;
/** @constructor */
function $h_Lreactbuild_model_InvoicePage() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePage.prototype = $c_Lreactbuild_model_InvoicePage.prototype;
$c_Lreactbuild_model_InvoicePage.prototype.productPrefix__T = (function() {
  return "InvoicePage"
});
$c_Lreactbuild_model_InvoicePage.prototype.productArity__I = (function() {
  return 16
});
$c_Lreactbuild_model_InvoicePage.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_InvoicePage__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_InvoicePage__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_InvoicePage__f_file;
      break
    }
    case 3: {
      return this.Lreactbuild_model_InvoicePage__f_notDone;
      break
    }
    case 4: {
      return this.Lreactbuild_model_InvoicePage__f_supplier;
      break
    }
    case 5: {
      return this.Lreactbuild_model_InvoicePage__f_supplierOffice;
      break
    }
    case 6: {
      return this.Lreactbuild_model_InvoicePage__f_date;
      break
    }
    case 7: {
      return this.Lreactbuild_model_InvoicePage__f_reference;
      break
    }
    case 8: {
      return this.Lreactbuild_model_InvoicePage__f_pageIndex;
      break
    }
    case 9: {
      return this.Lreactbuild_model_InvoicePage__f_pageCount;
      break
    }
    case 10: {
      return this.Lreactbuild_model_InvoicePage__f_amount;
      break
    }
    case 11: {
      return this.Lreactbuild_model_InvoicePage__f_totalAmount;
      break
    }
    case 12: {
      return this.Lreactbuild_model_InvoicePage__f_details;
      break
    }
    case 13: {
      return this.Lreactbuild_model_InvoicePage__f_entryNumber;
      break
    }
    case 14: {
      return this.Lreactbuild_model_InvoicePage__f_category;
      break
    }
    case 15: {
      return this.Lreactbuild_model_InvoicePage__f_deletedAt;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_InvoicePage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_InvoicePage.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("InvoicePage");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_model_InvoicePage__f__id;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_model_InvoicePage__f_organization;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_model_InvoicePage__f_file;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lreactbuild_model_InvoicePage__f_notDone ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lreactbuild_model_InvoicePage__f_supplier;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lreactbuild_model_InvoicePage__f_supplierOffice;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.Lreactbuild_model_InvoicePage__f_date;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.Lreactbuild_model_InvoicePage__f_reference;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$7 = this.Lreactbuild_model_InvoicePage__f_pageIndex;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$8 = this.Lreactbuild_model_InvoicePage__f_pageCount;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$8);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var x$9 = this.Lreactbuild_model_InvoicePage__f_amount;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$9);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  var x$10 = this.Lreactbuild_model_InvoicePage__f_totalAmount;
  var data$12 = $m_sr_Statics$().anyHash__O__I(x$10);
  acc = $m_sr_Statics$().mix__I__I__I(hash$12, data$12);
  var hash$13 = acc;
  var x$11 = this.Lreactbuild_model_InvoicePage__f_details;
  var data$13 = $m_sr_Statics$().anyHash__O__I(x$11);
  acc = $m_sr_Statics$().mix__I__I__I(hash$13, data$13);
  var hash$14 = acc;
  var x$12 = this.Lreactbuild_model_InvoicePage__f_entryNumber;
  var data$14 = $m_sr_Statics$().anyHash__O__I(x$12);
  acc = $m_sr_Statics$().mix__I__I__I(hash$14, data$14);
  var hash$15 = acc;
  var x$13 = this.Lreactbuild_model_InvoicePage__f_category;
  var data$15 = $m_sr_Statics$().anyHash__O__I(x$13);
  acc = $m_sr_Statics$().mix__I__I__I(hash$15, data$15);
  var hash$16 = acc;
  var x$14 = this.Lreactbuild_model_InvoicePage__f_deletedAt;
  var data$16 = $m_sr_Statics$().anyHash__O__I(x$14);
  acc = $m_sr_Statics$().mix__I__I__I(hash$16, data$16);
  var hash$17 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$17, 16)
});
$c_Lreactbuild_model_InvoicePage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_InvoicePage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_InvoicePage)) {
    var InvoicePage$1 = $as_Lreactbuild_model_InvoicePage(x$1);
    if ((this.Lreactbuild_model_InvoicePage__f_notDone === $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_notDone)) {
      var x = this.Lreactbuild_model_InvoicePage__f__id;
      var x$2 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f__id;
      var $$x3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$3 = this.Lreactbuild_model_InvoicePage__f_organization;
      var x$4 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_organization;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_model_InvoicePage__f_file;
        var x$6 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_file;
        var $$x2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Lreactbuild_model_InvoicePage__f_supplier;
      var x$8 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_supplier;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_model_InvoicePage__f_supplierOffice;
        var x$10 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_supplierOffice;
        var $$x4 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var x$11 = this.Lreactbuild_model_InvoicePage__f_date;
        var x$12 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_date;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_model_InvoicePage__f_reference;
          var x$14 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_reference;
          var $$x1 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$15 = this.Lreactbuild_model_InvoicePage__f_pageIndex;
      var x$16 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_pageIndex;
      if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
        var x$17 = this.Lreactbuild_model_InvoicePage__f_pageCount;
        var x$18 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_pageCount;
        var $$x6 = ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))
      } else {
        var $$x6 = false
      };
      if ($$x6) {
        var x$19 = this.Lreactbuild_model_InvoicePage__f_amount;
        var x$20 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_amount;
        if (((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))) {
          var x$21 = this.Lreactbuild_model_InvoicePage__f_totalAmount;
          var x$22 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_totalAmount;
          var $$x5 = ((x$21 === null) ? (x$22 === null) : $n(x$21).equals__O__Z(x$22))
        } else {
          var $$x5 = false
        }
      } else {
        var $$x5 = false
      };
      if ($$x5) {
        var x$23 = this.Lreactbuild_model_InvoicePage__f_details;
        var x$24 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_details;
        if (((x$23 === null) ? (x$24 === null) : $n(x$23).equals__O__Z(x$24))) {
          var x$25 = this.Lreactbuild_model_InvoicePage__f_entryNumber;
          var x$26 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_entryNumber;
          var $$x7 = ((x$25 === null) ? (x$26 === null) : $n(x$25).equals__O__Z(x$26))
        } else {
          var $$x7 = false
        };
        if ($$x7) {
          var x$27 = this.Lreactbuild_model_InvoicePage__f_category;
          var x$28 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_category;
          if (((x$27 === null) ? (x$28 === null) : $n(x$27).equals__O__Z(x$28))) {
            var x$29 = this.Lreactbuild_model_InvoicePage__f_deletedAt;
            var x$30 = $n(InvoicePage$1).Lreactbuild_model_InvoicePage__f_deletedAt;
            return ((x$29 === null) ? (x$30 === null) : $n(x$29).equals__O__Z(x$30))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_InvoicePage(obj) {
  return (((obj instanceof $c_Lreactbuild_model_InvoicePage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.InvoicePage"))
}
function $isArrayOf_Lreactbuild_model_InvoicePage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_InvoicePage)))
}
function $asArrayOf_Lreactbuild_model_InvoicePage(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_InvoicePage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.InvoicePage;", depth))
}
var $d_Lreactbuild_model_InvoicePage = new $TypeData().initClass({
  Lreactbuild_model_InvoicePage: 0
}, false, "reactbuild.model.InvoicePage", {
  Lreactbuild_model_InvoicePage: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoicePage.prototype.$classData = $d_Lreactbuild_model_InvoicePage;
/** @constructor */
function $c_Lreactbuild_model_InvoicePageFile(path) {
  this.Lreactbuild_model_InvoicePageFile__f_path = null;
  this.Lreactbuild_model_InvoicePageFile__f_path = path
}
$c_Lreactbuild_model_InvoicePageFile.prototype = new $h_O();
$c_Lreactbuild_model_InvoicePageFile.prototype.constructor = $c_Lreactbuild_model_InvoicePageFile;
/** @constructor */
function $h_Lreactbuild_model_InvoicePageFile() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePageFile.prototype = $c_Lreactbuild_model_InvoicePageFile.prototype;
$c_Lreactbuild_model_InvoicePageFile.prototype.productPrefix__T = (function() {
  return "InvoicePageFile"
});
$c_Lreactbuild_model_InvoicePageFile.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_InvoicePageFile.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_InvoicePageFile__f_path : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_InvoicePageFile.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_InvoicePageFile.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_InvoicePageFile.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_InvoicePageFile.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_InvoicePageFile)) {
    var InvoicePageFile$1 = $as_Lreactbuild_model_InvoicePageFile(x$1);
    return (this.Lreactbuild_model_InvoicePageFile__f_path === $n(InvoicePageFile$1).Lreactbuild_model_InvoicePageFile__f_path)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_InvoicePageFile(obj) {
  return (((obj instanceof $c_Lreactbuild_model_InvoicePageFile) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.InvoicePageFile"))
}
function $isArrayOf_Lreactbuild_model_InvoicePageFile(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_InvoicePageFile)))
}
function $asArrayOf_Lreactbuild_model_InvoicePageFile(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_InvoicePageFile(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.InvoicePageFile;", depth))
}
var $d_Lreactbuild_model_InvoicePageFile = new $TypeData().initClass({
  Lreactbuild_model_InvoicePageFile: 0
}, false, "reactbuild.model.InvoicePageFile", {
  Lreactbuild_model_InvoicePageFile: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoicePageFile.prototype.$classData = $d_Lreactbuild_model_InvoicePageFile;
/** @constructor */
function $c_Lreactbuild_model_InvoicePageGroup(organization, supplier, date, entryNumber, reference, pages, totalAmount, expectedAmount, received, category) {
  this.Lreactbuild_model_InvoicePageGroup__f_organization = null;
  this.Lreactbuild_model_InvoicePageGroup__f_supplier = null;
  this.Lreactbuild_model_InvoicePageGroup__f_date = null;
  this.Lreactbuild_model_InvoicePageGroup__f_entryNumber = null;
  this.Lreactbuild_model_InvoicePageGroup__f_reference = null;
  this.Lreactbuild_model_InvoicePageGroup__f_pages = null;
  this.Lreactbuild_model_InvoicePageGroup__f_totalAmount = null;
  this.Lreactbuild_model_InvoicePageGroup__f_expectedAmount = null;
  this.Lreactbuild_model_InvoicePageGroup__f_received = null;
  this.Lreactbuild_model_InvoicePageGroup__f_category = null;
  this.Lreactbuild_model_InvoicePageGroup__f_organization = organization;
  this.Lreactbuild_model_InvoicePageGroup__f_supplier = supplier;
  this.Lreactbuild_model_InvoicePageGroup__f_date = date;
  this.Lreactbuild_model_InvoicePageGroup__f_entryNumber = entryNumber;
  this.Lreactbuild_model_InvoicePageGroup__f_reference = reference;
  this.Lreactbuild_model_InvoicePageGroup__f_pages = pages;
  this.Lreactbuild_model_InvoicePageGroup__f_totalAmount = totalAmount;
  this.Lreactbuild_model_InvoicePageGroup__f_expectedAmount = expectedAmount;
  this.Lreactbuild_model_InvoicePageGroup__f_received = received;
  this.Lreactbuild_model_InvoicePageGroup__f_category = category
}
$c_Lreactbuild_model_InvoicePageGroup.prototype = new $h_O();
$c_Lreactbuild_model_InvoicePageGroup.prototype.constructor = $c_Lreactbuild_model_InvoicePageGroup;
/** @constructor */
function $h_Lreactbuild_model_InvoicePageGroup() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePageGroup.prototype = $c_Lreactbuild_model_InvoicePageGroup.prototype;
$c_Lreactbuild_model_InvoicePageGroup.prototype.productPrefix__T = (function() {
  return "InvoicePageGroup"
});
$c_Lreactbuild_model_InvoicePageGroup.prototype.productArity__I = (function() {
  return 10
});
$c_Lreactbuild_model_InvoicePageGroup.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_InvoicePageGroup__f_organization;
      break
    }
    case 1: {
      return this.Lreactbuild_model_InvoicePageGroup__f_supplier;
      break
    }
    case 2: {
      return this.Lreactbuild_model_InvoicePageGroup__f_date;
      break
    }
    case 3: {
      return this.Lreactbuild_model_InvoicePageGroup__f_entryNumber;
      break
    }
    case 4: {
      return this.Lreactbuild_model_InvoicePageGroup__f_reference;
      break
    }
    case 5: {
      return this.Lreactbuild_model_InvoicePageGroup__f_pages;
      break
    }
    case 6: {
      return this.Lreactbuild_model_InvoicePageGroup__f_totalAmount;
      break
    }
    case 7: {
      return this.Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
      break
    }
    case 8: {
      return this.Lreactbuild_model_InvoicePageGroup__f_received;
      break
    }
    case 9: {
      return this.Lreactbuild_model_InvoicePageGroup__f_category;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_InvoicePageGroup.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_InvoicePageGroup.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_InvoicePageGroup.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_InvoicePageGroup.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_InvoicePageGroup)) {
    var InvoicePageGroup$1 = $as_Lreactbuild_model_InvoicePageGroup(x$1);
    var x = this.Lreactbuild_model_InvoicePageGroup__f_organization;
    var x$2 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_organization;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_InvoicePageGroup__f_supplier;
      var x$4 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_supplier;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_model_InvoicePageGroup__f_date;
      var x$6 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_date;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_InvoicePageGroup__f_entryNumber;
        var x$8 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_model_InvoicePageGroup__f_reference;
          var x$10 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_reference;
          var $$x1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Lreactbuild_model_InvoicePageGroup__f_pages;
      var x$12 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_pages;
      if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
        var x$13 = this.Lreactbuild_model_InvoicePageGroup__f_totalAmount;
        var x$14 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
        var $$x3 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$15 = this.Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
        var x$16 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
        if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
          var x$17 = this.Lreactbuild_model_InvoicePageGroup__f_received;
          var x$18 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_received;
          if (((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))) {
            var x$19 = this.Lreactbuild_model_InvoicePageGroup__f_category;
            var x$20 = $n(InvoicePageGroup$1).Lreactbuild_model_InvoicePageGroup__f_category;
            return ((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_InvoicePageGroup(obj) {
  return (((obj instanceof $c_Lreactbuild_model_InvoicePageGroup) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.InvoicePageGroup"))
}
function $isArrayOf_Lreactbuild_model_InvoicePageGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_InvoicePageGroup)))
}
function $asArrayOf_Lreactbuild_model_InvoicePageGroup(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_InvoicePageGroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.InvoicePageGroup;", depth))
}
var $d_Lreactbuild_model_InvoicePageGroup = new $TypeData().initClass({
  Lreactbuild_model_InvoicePageGroup: 0
}, false, "reactbuild.model.InvoicePageGroup", {
  Lreactbuild_model_InvoicePageGroup: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InvoicePageGroup.prototype.$classData = $d_Lreactbuild_model_InvoicePageGroup;
/** @constructor */
function $c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79(outer) {
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForcreated = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForproject = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderFortitle = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForterms = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForduration = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForfrom = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderFortype = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForcreated = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForproject = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderFortitle = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$3 = $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  var this$1 = $m_sci_ListSet$();
  var factory = new $c_sc_IterableFactory$ToFactory(this$1);
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForterms = new $c_Lio_circe_CollectionDecoders$$anon$2(this$3, decodeA, factory);
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().decodeDuration__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForduration = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForfrom = new $c_Lio_circe_Decoder$$anon$39(d$1);
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderFortype = $m_Lreactbuild_model_ListEntryType$().Lreactbuild_model_ListEntryType$__f_codecForListEntryType
}
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79.prototype.constructor = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79;
/** @constructor */
function $h_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79.prototype = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79.prototype;
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("created"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForcreated, "created", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("project"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForproject, "project", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderFortitle, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("terms"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForterms, "terms", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("duration"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForduration, "duration", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("from"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderForfrom, "from", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("type"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79__f_circeGenericDecoderFortype, "type", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79 = new $TypeData().initClass({
  Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79: 0
}, false, "reactbuild.model.ListEntry$anon$lazy$macro$223$1$$anon$79", {
  Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79.prototype.$classData = $d_Lreactbuild_model_ListEntry$anon$lazy$macro$223$1$$anon$79;
/** @constructor */
function $c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77(outer) {
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderFortemplateEntry = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderForcreated = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderForproject = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderForduration = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderFortemplateEntry = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderForcreated = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderForproject = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_model_CachedExpression$().decodeCachedExpression__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_model_Expression$().decodeExpression__Lio_circe_Decoder(), $m_Lio_circe_Decoder$().decodeDuration__Lio_circe_Decoder());
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderForduration = new $c_Lio_circe_Decoder$$anon$39(d)
}
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77.prototype.constructor = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77;
/** @constructor */
function $h_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77.prototype = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77.prototype;
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("templateEntry"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderFortemplateEntry, "templateEntry", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("created"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderForcreated, "created", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("project"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderForproject, "project", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("duration"))), this.Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77__f_circeGenericDecoderForduration, "duration", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77 = new $TypeData().initClass({
  Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77: 0
}, false, "reactbuild.model.ListEntry$anon$lazy$macro$87$1$$anon$77", {
  Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77.prototype.$classData = $d_Lreactbuild_model_ListEntry$anon$lazy$macro$87$1$$anon$77;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEvent(_id, entry, created, user, body) {
  this.Lreactbuild_model_ListEntryEvent__f__id = null;
  this.Lreactbuild_model_ListEntryEvent__f_entry = null;
  this.Lreactbuild_model_ListEntryEvent__f_created = null;
  this.Lreactbuild_model_ListEntryEvent__f_user = null;
  this.Lreactbuild_model_ListEntryEvent__f_body = null;
  this.Lreactbuild_model_ListEntryEvent__f__id = _id;
  this.Lreactbuild_model_ListEntryEvent__f_entry = entry;
  this.Lreactbuild_model_ListEntryEvent__f_created = created;
  this.Lreactbuild_model_ListEntryEvent__f_user = user;
  this.Lreactbuild_model_ListEntryEvent__f_body = body
}
$c_Lreactbuild_model_ListEntryEvent.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEvent.prototype.constructor = $c_Lreactbuild_model_ListEntryEvent;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEvent() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEvent.prototype = $c_Lreactbuild_model_ListEntryEvent.prototype;
$c_Lreactbuild_model_ListEntryEvent.prototype.productPrefix__T = (function() {
  return "ListEntryEvent"
});
$c_Lreactbuild_model_ListEntryEvent.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_model_ListEntryEvent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_ListEntryEvent__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_ListEntryEvent__f_entry;
      break
    }
    case 2: {
      return this.Lreactbuild_model_ListEntryEvent__f_created;
      break
    }
    case 3: {
      return this.Lreactbuild_model_ListEntryEvent__f_user;
      break
    }
    case 4: {
      return this.Lreactbuild_model_ListEntryEvent__f_body;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_ListEntryEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEvent.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListEntryEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListEntryEvent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListEntryEvent)) {
    var ListEntryEvent$1 = $as_Lreactbuild_model_ListEntryEvent(x$1);
    var x = this.Lreactbuild_model_ListEntryEvent__f__id;
    var x$2 = $n(ListEntryEvent$1).Lreactbuild_model_ListEntryEvent__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_ListEntryEvent__f_entry;
      var x$4 = $n(ListEntryEvent$1).Lreactbuild_model_ListEntryEvent__f_entry;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_model_ListEntryEvent__f_created;
      var x$6 = $n(ListEntryEvent$1).Lreactbuild_model_ListEntryEvent__f_created;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_ListEntryEvent__f_user;
        var x$8 = $n(ListEntryEvent$1).Lreactbuild_model_ListEntryEvent__f_user;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_model_ListEntryEvent__f_body;
          var x$10 = $n(ListEntryEvent$1).Lreactbuild_model_ListEntryEvent__f_body;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListEntryEvent(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEvent"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEvent)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEvent(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEvent;", depth))
}
var $d_Lreactbuild_model_ListEntryEvent = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEvent: 0
}, false, "reactbuild.model.ListEntryEvent", {
  Lreactbuild_model_ListEntryEvent: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEvent.prototype.$classData = $d_Lreactbuild_model_ListEntryEvent;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Comment$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Comment$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_model_ListEntryEventBody$Comment$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Comment$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Comment$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Comment$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Comment$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Comment$.prototype.toString__T = (function() {
  return "Comment"
});
$c_Lreactbuild_model_ListEntryEventBody$Comment$.prototype.apply__O__O = (function(v1) {
  var comment = $as_T(v1);
  return new $c_Lreactbuild_model_ListEntryEventBody$Comment(comment)
});
var $d_Lreactbuild_model_ListEntryEventBody$Comment$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Comment$: 0
}, false, "reactbuild.model.ListEntryEventBody$Comment$", {
  Lreactbuild_model_ListEntryEventBody$Comment$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Comment$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Comment$;
var $n_Lreactbuild_model_ListEntryEventBody$Comment$;
function $m_Lreactbuild_model_ListEntryEventBody$Comment$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Comment$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Comment$ = new $c_Lreactbuild_model_ListEntryEventBody$Comment$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Comment$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$.prototype = $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$.prototype.toString__T = (function() {
  return "NeedMoreDetails"
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$.prototype.apply__O__O = (function(v1) {
  var comment = $as_T(v1);
  return new $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(comment)
});
var $d_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$: 0
}, false, "reactbuild.model.ListEntryEventBody$NeedMoreDetails$", {
  Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$;
var $n_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$;
function $m_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$)) {
    $n_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$ = new $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$NonCompliant$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$NonCompliant$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$NonCompliant$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$NonCompliant$.prototype = $c_Lreactbuild_model_ListEntryEventBody$NonCompliant$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant$.prototype.toString__T = (function() {
  return "NonCompliant"
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant$.prototype.apply__O__O = (function(v1) {
  var reason = $as_T(v1);
  return new $c_Lreactbuild_model_ListEntryEventBody$NonCompliant(reason)
});
var $d_Lreactbuild_model_ListEntryEventBody$NonCompliant$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$NonCompliant$: 0
}, false, "reactbuild.model.ListEntryEventBody$NonCompliant$", {
  Lreactbuild_model_ListEntryEventBody$NonCompliant$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$NonCompliant$;
var $n_Lreactbuild_model_ListEntryEventBody$NonCompliant$;
function $m_Lreactbuild_model_ListEntryEventBody$NonCompliant$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$NonCompliant$)) {
    $n_Lreactbuild_model_ListEntryEventBody$NonCompliant$ = new $c_Lreactbuild_model_ListEntryEventBody$NonCompliant$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$NonCompliant$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$NotApplicable$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$NotApplicable$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$NotApplicable$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$NotApplicable$.prototype = $c_Lreactbuild_model_ListEntryEventBody$NotApplicable$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable$.prototype.toString__T = (function() {
  return "NotApplicable"
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable$.prototype.apply__O__O = (function(v1) {
  var reason = $as_T(v1);
  return new $c_Lreactbuild_model_ListEntryEventBody$NotApplicable(reason)
});
var $d_Lreactbuild_model_ListEntryEventBody$NotApplicable$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$NotApplicable$: 0
}, false, "reactbuild.model.ListEntryEventBody$NotApplicable$", {
  Lreactbuild_model_ListEntryEventBody$NotApplicable$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$NotApplicable$;
var $n_Lreactbuild_model_ListEntryEventBody$NotApplicable$;
function $m_Lreactbuild_model_ListEntryEventBody$NotApplicable$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$NotApplicable$)) {
    $n_Lreactbuild_model_ListEntryEventBody$NotApplicable$ = new $c_Lreactbuild_model_ListEntryEventBody$NotApplicable$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$NotApplicable$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Rejected$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Rejected$.prototype = new $h_sr_AbstractFunction1();
$c_Lreactbuild_model_ListEntryEventBody$Rejected$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Rejected$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Rejected$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Rejected$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Rejected$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Rejected$.prototype.toString__T = (function() {
  return "Rejected"
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected$.prototype.apply__O__O = (function(v1) {
  var reason = $as_T(v1);
  return new $c_Lreactbuild_model_ListEntryEventBody$Rejected(reason)
});
var $d_Lreactbuild_model_ListEntryEventBody$Rejected$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Rejected$: 0
}, false, "reactbuild.model.ListEntryEventBody$Rejected$", {
  Lreactbuild_model_ListEntryEventBody$Rejected$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Rejected$;
var $n_Lreactbuild_model_ListEntryEventBody$Rejected$;
function $m_Lreactbuild_model_ListEntryEventBody$Rejected$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Rejected$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Rejected$ = new $c_Lreactbuild_model_ListEntryEventBody$Rejected$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Rejected$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65(outer) {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65__f_circeGenericDecoderForterm = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65__f_circeGenericDecoderForterm = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("term"))), this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65__f_circeGenericDecoderForterm, "term", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$65", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$65;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66(outer) {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66__f_circeGenericDecoderForreason = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66__f_circeGenericDecoderForreason = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reason"))), this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66__f_circeGenericDecoderForreason, "reason", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$66", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$66;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67(outer) {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67__f_circeGenericDecoderForcomment = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67__f_circeGenericDecoderForcomment = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("comment"))), this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67__f_circeGenericDecoderForcomment, "comment", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$67", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$67;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68(outer) {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68__f_circeGenericDecoderForpreviousTitle = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68__f_circeGenericDecoderForpreviousTitle = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("previousTitle"))), this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68__f_circeGenericDecoderForpreviousTitle, "previousTitle", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$68", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$68;
/** @constructor */
function $c_Lreactbuild_model_ListTemplate(_id, organization, title) {
  this.Lreactbuild_model_ListTemplate__f__id = null;
  this.Lreactbuild_model_ListTemplate__f_organization = null;
  this.Lreactbuild_model_ListTemplate__f_title = null;
  this.Lreactbuild_model_ListTemplate__f__id = _id;
  this.Lreactbuild_model_ListTemplate__f_organization = organization;
  this.Lreactbuild_model_ListTemplate__f_title = title
}
$c_Lreactbuild_model_ListTemplate.prototype = new $h_O();
$c_Lreactbuild_model_ListTemplate.prototype.constructor = $c_Lreactbuild_model_ListTemplate;
/** @constructor */
function $h_Lreactbuild_model_ListTemplate() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListTemplate.prototype = $c_Lreactbuild_model_ListTemplate.prototype;
$c_Lreactbuild_model_ListTemplate.prototype.productPrefix__T = (function() {
  return "ListTemplate"
});
$c_Lreactbuild_model_ListTemplate.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_model_ListTemplate.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_ListTemplate__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_ListTemplate__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_ListTemplate__f_title;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_ListTemplate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListTemplate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListTemplate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListTemplate.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListTemplate)) {
    var ListTemplate$1 = $as_Lreactbuild_model_ListTemplate(x$1);
    var x = this.Lreactbuild_model_ListTemplate__f__id;
    var x$2 = $n(ListTemplate$1).Lreactbuild_model_ListTemplate__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_ListTemplate__f_organization;
      var x$4 = $n(ListTemplate$1).Lreactbuild_model_ListTemplate__f_organization;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        return (this.Lreactbuild_model_ListTemplate__f_title === $n(ListTemplate$1).Lreactbuild_model_ListTemplate__f_title)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListTemplate(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListTemplate) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListTemplate"))
}
function $isArrayOf_Lreactbuild_model_ListTemplate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListTemplate)))
}
function $asArrayOf_Lreactbuild_model_ListTemplate(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListTemplate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListTemplate;", depth))
}
var $d_Lreactbuild_model_ListTemplate = new $TypeData().initClass({
  Lreactbuild_model_ListTemplate: 0
}, false, "reactbuild.model.ListTemplate", {
  Lreactbuild_model_ListTemplate: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListTemplate.prototype.$classData = $d_Lreactbuild_model_ListTemplate;
/** @constructor */
function $c_Lreactbuild_model_ListTemplateEntry(_id, template, title, type, terms, created, validation, duration) {
  this.Lreactbuild_model_ListTemplateEntry__f__id = null;
  this.Lreactbuild_model_ListTemplateEntry__f_template = null;
  this.Lreactbuild_model_ListTemplateEntry__f_title = null;
  this.Lreactbuild_model_ListTemplateEntry__f_type = null;
  this.Lreactbuild_model_ListTemplateEntry__f_terms = null;
  this.Lreactbuild_model_ListTemplateEntry__f_created = null;
  this.Lreactbuild_model_ListTemplateEntry__f_validation = null;
  this.Lreactbuild_model_ListTemplateEntry__f_duration = null;
  this.Lreactbuild_model_ListTemplateEntry__f__id = _id;
  this.Lreactbuild_model_ListTemplateEntry__f_template = template;
  this.Lreactbuild_model_ListTemplateEntry__f_title = title;
  this.Lreactbuild_model_ListTemplateEntry__f_type = type;
  this.Lreactbuild_model_ListTemplateEntry__f_terms = terms;
  this.Lreactbuild_model_ListTemplateEntry__f_created = created;
  this.Lreactbuild_model_ListTemplateEntry__f_validation = validation;
  this.Lreactbuild_model_ListTemplateEntry__f_duration = duration
}
$c_Lreactbuild_model_ListTemplateEntry.prototype = new $h_O();
$c_Lreactbuild_model_ListTemplateEntry.prototype.constructor = $c_Lreactbuild_model_ListTemplateEntry;
/** @constructor */
function $h_Lreactbuild_model_ListTemplateEntry() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListTemplateEntry.prototype = $c_Lreactbuild_model_ListTemplateEntry.prototype;
$c_Lreactbuild_model_ListTemplateEntry.prototype.productPrefix__T = (function() {
  return "ListTemplateEntry"
});
$c_Lreactbuild_model_ListTemplateEntry.prototype.productArity__I = (function() {
  return 8
});
$c_Lreactbuild_model_ListTemplateEntry.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_ListTemplateEntry__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_ListTemplateEntry__f_template;
      break
    }
    case 2: {
      return this.Lreactbuild_model_ListTemplateEntry__f_title;
      break
    }
    case 3: {
      return this.Lreactbuild_model_ListTemplateEntry__f_type;
      break
    }
    case 4: {
      return this.Lreactbuild_model_ListTemplateEntry__f_terms;
      break
    }
    case 5: {
      return this.Lreactbuild_model_ListTemplateEntry__f_created;
      break
    }
    case 6: {
      return this.Lreactbuild_model_ListTemplateEntry__f_validation;
      break
    }
    case 7: {
      return this.Lreactbuild_model_ListTemplateEntry__f_duration;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_ListTemplateEntry.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListTemplateEntry.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListTemplateEntry.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListTemplateEntry.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListTemplateEntry)) {
    var ListTemplateEntry$1 = $as_Lreactbuild_model_ListTemplateEntry(x$1);
    var x = this.Lreactbuild_model_ListTemplateEntry__f__id;
    var x$2 = $n(ListTemplateEntry$1).Lreactbuild_model_ListTemplateEntry__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_ListTemplateEntry__f_template;
      var x$4 = $n(ListTemplateEntry$1).Lreactbuild_model_ListTemplateEntry__f_template;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      if ((this.Lreactbuild_model_ListTemplateEntry__f_title === $n(ListTemplateEntry$1).Lreactbuild_model_ListTemplateEntry__f_title)) {
        var x$5 = this.Lreactbuild_model_ListTemplateEntry__f_type;
        var x$6 = $n(ListTemplateEntry$1).Lreactbuild_model_ListTemplateEntry__f_type;
        if ((x$5 === null)) {
          var $$x1 = (x$6 === null)
        } else {
          var this$1 = $n(x$5);
          var $$x1 = (this$1 === x$6)
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_model_ListTemplateEntry__f_terms;
      var x$8 = $n(ListTemplateEntry$1).Lreactbuild_model_ListTemplateEntry__f_terms;
      if ((x$7 === null)) {
        var $$x4 = (x$8 === null)
      } else {
        var this$2 = $n(x$7);
        var $$x4 = $f_sc_Set__equals__O__Z(this$2, x$8)
      };
      if ($$x4) {
        var x$9 = this.Lreactbuild_model_ListTemplateEntry__f_created;
        var x$10 = $n(ListTemplateEntry$1).Lreactbuild_model_ListTemplateEntry__f_created;
        var $$x3 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$11 = this.Lreactbuild_model_ListTemplateEntry__f_validation;
        var x$12 = $n(ListTemplateEntry$1).Lreactbuild_model_ListTemplateEntry__f_validation;
        if ((x$11 === null)) {
          var $$x5 = (x$12 === null)
        } else {
          var this$3 = $n(x$11);
          var $$x5 = (this$3 === x$12)
        };
        if ($$x5) {
          var x$13 = this.Lreactbuild_model_ListTemplateEntry__f_duration;
          var x$14 = $n(ListTemplateEntry$1).Lreactbuild_model_ListTemplateEntry__f_duration;
          return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListTemplateEntry(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListTemplateEntry) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListTemplateEntry"))
}
function $isArrayOf_Lreactbuild_model_ListTemplateEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListTemplateEntry)))
}
function $asArrayOf_Lreactbuild_model_ListTemplateEntry(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListTemplateEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListTemplateEntry;", depth))
}
var $d_Lreactbuild_model_ListTemplateEntry = new $TypeData().initClass({
  Lreactbuild_model_ListTemplateEntry: 0
}, false, "reactbuild.model.ListTemplateEntry", {
  Lreactbuild_model_ListTemplateEntry: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListTemplateEntry.prototype.$classData = $d_Lreactbuild_model_ListTemplateEntry;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$15(outer, proxy$7) {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$15__f_proxy$7 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$15__f_proxy$7 = proxy$7;
  $ct_Lreactbuild_model_BaseRefToResolver__(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype = new $h_Lreactbuild_model_BaseRefToResolver();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$15;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$15() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype.allItems__sci_List = (function() {
  var this$1 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$15__f_proxy$7);
  var this$2 = $n(this$1.Ldiode_react_ModelProxy__f_modelReader);
  var this$3 = $n($n($as_Lreactbuild_analyze_cost_services_Model(this$2.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged);
  if (this$3.isEmpty__Z()) {
    var $$x1 = $m_s_package$().s_package$__f_Nil
  } else {
    var arg1 = this$3.get__O();
    var x$25 = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(arg1);
    var $$x1 = $n($n(x$25).Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations)
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype.getTitle__Lreactbuild_common_model_LoggedUserOrganization__T = (function(in$1) {
  var this$1 = $n($n(in$1).Lreactbuild_common_model_LoggedUserOrganization__f_name);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $n(in$1).Lreactbuild_common_model_LoggedUserOrganization__f_path
  } else {
    var arg1 = this$1.get__O();
    var name = $as_T(arg1);
    var $$x1 = (((name + " (") + $n(in$1).Lreactbuild_common_model_LoggedUserOrganization__f_path) + ")")
  };
  return $as_T($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype.createItem__T__s_Option = (function(in$1) {
  return $m_s_None$()
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype.getRef__O__Lreactbuild_common_model_RefTo = (function(in$1) {
  var in$2 = $as_Lreactbuild_common_model_LoggedUserOrganization(in$1);
  return $n(in$2).Lreactbuild_common_model_LoggedUserOrganization__f__id
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype.getTitle__O__T = (function(in$1) {
  return this.getTitle__Lreactbuild_common_model_LoggedUserOrganization__T($as_Lreactbuild_common_model_LoggedUserOrganization(in$1))
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$15 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$15: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$15", {
  Lreactbuild_model_LowPriorityImplicits$$anon$15: 1,
  Lreactbuild_model_BaseRefToResolver: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$15.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$15;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$2(outer) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$2__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$2__f_$outer = outer
  }
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$2;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$2.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$2.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2.prototype.parse__T__s_util_Try = (function(input) {
  var search = $n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T(input);
  var x1 = $n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$2__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryFromName).collectFirst__s_PartialFunction__s_Option(new $c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1(this, search));
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $as_Lreactbuild_model_DocumentCategory($n(x2).s_Some__f_value);
    return new $c_s_util_Success(v)
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return new $c_s_util_Failure($ct_jl_Exception__T__(new $c_jl_Exception(), ("Not found " + input)))
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2.prototype.stringify__Lreactbuild_model_DocumentCategory__T = (function(input) {
  return $as_T($n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$2__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryMap).apply__O__O(input))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2.prototype.stringify__O__T = (function(value) {
  return this.stringify__Lreactbuild_model_DocumentCategory__T($as_Lreactbuild_model_DocumentCategory(value))
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$2 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$2: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$2", {
  Lreactbuild_model_LowPriorityImplicits$$anon$2: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$2;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$7(outer) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$7__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$7__f_$outer = outer
  }
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7.prototype = new $h_O();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$7;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$7.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$7.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7.prototype.parse__T__s_util_Try = (function(input) {
  var search = $n($m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter).prepare__T__T(input);
  var x1 = $n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$7__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportFromName).collectFirst__s_PartialFunction__s_Option(new $c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2(this, search));
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder($n(x2).s_Some__f_value);
    return new $c_s_util_Success(v)
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return new $c_s_util_Failure($ct_jl_Exception__T__(new $c_jl_Exception(), ("Not found " + input)))
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7.prototype.stringify__Lreactbuild_analyze_cost_ReconciliationReportOrder__T = (function(input) {
  return $as_T($n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$7__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderMap).apply__O__O(input))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7.prototype.stringify__O__T = (function(value) {
  return this.stringify__Lreactbuild_analyze_cost_ReconciliationReportOrder__T($as_Lreactbuild_analyze_cost_ReconciliationReportOrder(value))
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$7 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$7: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$7", {
  Lreactbuild_model_LowPriorityImplicits$$anon$7: 1,
  O: 1,
  Lcom_iz2use_common_Parsable: 1,
  Lcom_iz2use_common_Textualizable: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$7;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2(outer) {
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderForlevel = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderForaltitude = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderForlabel = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderForlevel = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderForaltitude = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderForlabel = new $c_Lio_circe_Decoder$$anon$39(d$2)
}
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2.prototype = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2.prototype;
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("level"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderForlevel, "level", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("altitude"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderForaltitude, "altitude", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("label"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2__f_circeGenericDecoderForlabel, "label", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2: 0
}, false, "reactbuild.model.MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2", {
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3(outer) {
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderForproject = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFororientation = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderForlevel = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderForfile = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFormetadata = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFormarkers = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderForproject = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFororientation = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderForlevel = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderForfile = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
  var decodeV = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJson;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFormetadata = new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeV);
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_MapFeature$MapFeatureMarker$().Lreactbuild_model_MapFeature$MapFeatureMarker$__f_codecForMapFeatureMarker;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFormarkers = new $c_Lio_circe_Decoder$$anon$44(decodeA)
}
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3.prototype = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3.prototype;
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("project"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderForproject, "project", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("orientation"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFororientation, "orientation", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("level"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderForlevel, "level", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("file"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderForfile, "file", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("metadata"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFormetadata, "metadata", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("markers"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3__f_circeGenericDecoderFormarkers, "markers", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3 = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3: 0
}, false, "reactbuild.model.MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3", {
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$3;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4(outer) {
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4__f_circeGenericDecoderForfile = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4__f_circeGenericDecoderForfile = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4.prototype = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4.prototype;
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("file"))), this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4__f_circeGenericDecoderForfile, "file", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4 = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4: 0
}, false, "reactbuild.model.MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4", {
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$4;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeatureMarker() {
  /*<skip>*/
}
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeatureMarker;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeatureMarker() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype = $c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype;
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype.productPrefix__T = (function() {
  return "MapFeatureMarker"
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_model_MapFeature$MapFeatureMarker)
});
function $as_Lreactbuild_model_MapFeature$MapFeatureMarker(obj) {
  return (((obj instanceof $c_Lreactbuild_model_MapFeature$MapFeatureMarker) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.MapFeature$MapFeatureMarker"))
}
function $isArrayOf_Lreactbuild_model_MapFeature$MapFeatureMarker(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_MapFeature$MapFeatureMarker)))
}
function $asArrayOf_Lreactbuild_model_MapFeature$MapFeatureMarker(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_MapFeature$MapFeatureMarker(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.MapFeature$MapFeatureMarker;", depth))
}
var $d_Lreactbuild_model_MapFeature$MapFeatureMarker = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeatureMarker: 0
}, false, "reactbuild.model.MapFeature$MapFeatureMarker", {
  Lreactbuild_model_MapFeature$MapFeatureMarker: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeatureMarker.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeatureMarker;
/** @constructor */
function $c_Lreactbuild_model_Password(value) {
  this.Lreactbuild_model_Password__f_value = null;
  this.Lreactbuild_model_Password__f_value = value
}
$c_Lreactbuild_model_Password.prototype = new $h_O();
$c_Lreactbuild_model_Password.prototype.constructor = $c_Lreactbuild_model_Password;
/** @constructor */
function $h_Lreactbuild_model_Password() {
  /*<skip>*/
}
$h_Lreactbuild_model_Password.prototype = $c_Lreactbuild_model_Password.prototype;
$c_Lreactbuild_model_Password.prototype.productPrefix__T = (function() {
  return "Password"
});
$c_Lreactbuild_model_Password.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_Password.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_Password__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_Password.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Password.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_Password.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Password.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Password)) {
    var Password$1 = $as_Lreactbuild_model_Password(x$1);
    return (this.Lreactbuild_model_Password__f_value === $n(Password$1).Lreactbuild_model_Password__f_value)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Password(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Password) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Password"))
}
function $isArrayOf_Lreactbuild_model_Password(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Password)))
}
function $asArrayOf_Lreactbuild_model_Password(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Password(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Password;", depth))
}
var $d_Lreactbuild_model_Password = new $TypeData().initClass({
  Lreactbuild_model_Password: 0
}, false, "reactbuild.model.Password", {
  Lreactbuild_model_Password: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Password.prototype.$classData = $d_Lreactbuild_model_Password;
/** @constructor */
function $c_Lreactbuild_model_PdfContent(pages) {
  this.Lreactbuild_model_PdfContent__f_pages = null;
  this.Lreactbuild_model_PdfContent__f_pages = pages
}
$c_Lreactbuild_model_PdfContent.prototype = new $h_O();
$c_Lreactbuild_model_PdfContent.prototype.constructor = $c_Lreactbuild_model_PdfContent;
/** @constructor */
function $h_Lreactbuild_model_PdfContent() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfContent.prototype = $c_Lreactbuild_model_PdfContent.prototype;
$c_Lreactbuild_model_PdfContent.prototype.productPrefix__T = (function() {
  return "PdfContent"
});
$c_Lreactbuild_model_PdfContent.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_PdfContent.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_PdfContent__f_pages : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_PdfContent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_PdfContent.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_PdfContent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_PdfContent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_PdfContent)) {
    var PdfContent$1 = $as_Lreactbuild_model_PdfContent(x$1);
    var x = this.Lreactbuild_model_PdfContent__f_pages;
    var x$2 = $n(PdfContent$1).Lreactbuild_model_PdfContent__f_pages;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_PdfContent(obj) {
  return (((obj instanceof $c_Lreactbuild_model_PdfContent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.PdfContent"))
}
function $isArrayOf_Lreactbuild_model_PdfContent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_PdfContent)))
}
function $asArrayOf_Lreactbuild_model_PdfContent(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_PdfContent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.PdfContent;", depth))
}
var $d_Lreactbuild_model_PdfContent = new $TypeData().initClass({
  Lreactbuild_model_PdfContent: 0
}, false, "reactbuild.model.PdfContent", {
  Lreactbuild_model_PdfContent: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfContent.prototype.$classData = $d_Lreactbuild_model_PdfContent;
/** @constructor */
function $c_Lreactbuild_model_PdfLine(words) {
  this.Lreactbuild_model_PdfLine__f_words = null;
  this.Lreactbuild_model_PdfLine__f_words = words
}
$c_Lreactbuild_model_PdfLine.prototype = new $h_O();
$c_Lreactbuild_model_PdfLine.prototype.constructor = $c_Lreactbuild_model_PdfLine;
/** @constructor */
function $h_Lreactbuild_model_PdfLine() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfLine.prototype = $c_Lreactbuild_model_PdfLine.prototype;
$c_Lreactbuild_model_PdfLine.prototype.productPrefix__T = (function() {
  return "PdfLine"
});
$c_Lreactbuild_model_PdfLine.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_PdfLine.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_PdfLine__f_words : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_PdfLine.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_PdfLine.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_PdfLine.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_PdfLine.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_PdfLine)) {
    var PdfLine$1 = $as_Lreactbuild_model_PdfLine(x$1);
    var x = this.Lreactbuild_model_PdfLine__f_words;
    var x$2 = $n(PdfLine$1).Lreactbuild_model_PdfLine__f_words;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_PdfLine(obj) {
  return (((obj instanceof $c_Lreactbuild_model_PdfLine) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.PdfLine"))
}
function $isArrayOf_Lreactbuild_model_PdfLine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_PdfLine)))
}
function $asArrayOf_Lreactbuild_model_PdfLine(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_PdfLine(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.PdfLine;", depth))
}
var $d_Lreactbuild_model_PdfLine = new $TypeData().initClass({
  Lreactbuild_model_PdfLine: 0
}, false, "reactbuild.model.PdfLine", {
  Lreactbuild_model_PdfLine: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfLine.prototype.$classData = $d_Lreactbuild_model_PdfLine;
function $p_Lreactbuild_model_PdfPage__parts$lzycompute__sci_List($thiz) {
  if ((!$thiz.Lreactbuild_model_PdfPage__f_bitmap$0)) {
    var this$1 = $n($thiz.Lreactbuild_model_PdfPage__f_paragraphs);
    var rest = this$1;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var x$20 = $as_Lreactbuild_model_PdfParagraph(arg1);
      var this$2 = $n($n(x$20).Lreactbuild_model_PdfParagraph__f_lines);
      var rest$1 = this$2;
      var h$1 = null;
      var t$1 = null;
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest$1).head__O();
        var x$21 = $as_Lreactbuild_model_PdfLine(arg1$1);
        var it = $n($n(x$21).Lreactbuild_model_PdfLine__f_words).iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
          if ((t$1 === null)) {
            h$1 = nx
          } else {
            $n(t$1).sci_$colon$colon__f_next = nx
          };
          t$1 = nx
        };
        rest$1 = $as_sci_List($n(rest$1).tail__O())
      };
      var it$1 = $n(((h$1 === null) ? $m_sci_Nil$() : h$1)).iterator__sc_Iterator();
      while ($n(it$1).hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon($n(it$1).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx$1
        } else {
          $n(t).sci_$colon$colon__f_next = nx$1
        };
        t = nx$1
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    $thiz.Lreactbuild_model_PdfPage__f_parts = ((h === null) ? $m_sci_Nil$() : h);
    $thiz.Lreactbuild_model_PdfPage__f_bitmap$0 = true
  };
  return $thiz.Lreactbuild_model_PdfPage__f_parts
}
/** @constructor */
function $c_Lreactbuild_model_PdfPage(paragraphs, width, height) {
  this.Lreactbuild_model_PdfPage__f_parts = null;
  this.Lreactbuild_model_PdfPage__f_paragraphs = null;
  this.Lreactbuild_model_PdfPage__f_width = 0.0;
  this.Lreactbuild_model_PdfPage__f_height = 0.0;
  this.Lreactbuild_model_PdfPage__f_bitmap$0 = false;
  this.Lreactbuild_model_PdfPage__f_paragraphs = paragraphs;
  this.Lreactbuild_model_PdfPage__f_width = width;
  this.Lreactbuild_model_PdfPage__f_height = height
}
$c_Lreactbuild_model_PdfPage.prototype = new $h_O();
$c_Lreactbuild_model_PdfPage.prototype.constructor = $c_Lreactbuild_model_PdfPage;
/** @constructor */
function $h_Lreactbuild_model_PdfPage() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfPage.prototype = $c_Lreactbuild_model_PdfPage.prototype;
$c_Lreactbuild_model_PdfPage.prototype.parts__sci_List = (function() {
  return ((!this.Lreactbuild_model_PdfPage__f_bitmap$0) ? $p_Lreactbuild_model_PdfPage__parts$lzycompute__sci_List(this) : this.Lreactbuild_model_PdfPage__f_parts)
});
$c_Lreactbuild_model_PdfPage.prototype.productPrefix__T = (function() {
  return "PdfPage"
});
$c_Lreactbuild_model_PdfPage.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_model_PdfPage.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_PdfPage__f_paragraphs;
      break
    }
    case 1: {
      return this.Lreactbuild_model_PdfPage__f_width;
      break
    }
    case 2: {
      return this.Lreactbuild_model_PdfPage__f_height;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_PdfPage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_PdfPage.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("PdfPage");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_model_PdfPage__f_paragraphs;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var fv = this.Lreactbuild_model_PdfPage__f_width;
  var this$1 = $m_sr_Statics$();
  var data$2 = this$1.doubleHash__D__I(fv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var fv$1 = this.Lreactbuild_model_PdfPage__f_height;
  var this$2 = $m_sr_Statics$();
  var data$3 = this$2.doubleHash__D__I(fv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_model_PdfPage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_PdfPage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_PdfPage)) {
    var PdfPage$1 = $as_Lreactbuild_model_PdfPage(x$1);
    if ((this.Lreactbuild_model_PdfPage__f_width === $n(PdfPage$1).Lreactbuild_model_PdfPage__f_width)) {
      if ((this.Lreactbuild_model_PdfPage__f_height === $n(PdfPage$1).Lreactbuild_model_PdfPage__f_height)) {
        var x = this.Lreactbuild_model_PdfPage__f_paragraphs;
        var x$2 = $n(PdfPage$1).Lreactbuild_model_PdfPage__f_paragraphs;
        return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_PdfPage(obj) {
  return (((obj instanceof $c_Lreactbuild_model_PdfPage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.PdfPage"))
}
function $isArrayOf_Lreactbuild_model_PdfPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_PdfPage)))
}
function $asArrayOf_Lreactbuild_model_PdfPage(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_PdfPage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.PdfPage;", depth))
}
var $d_Lreactbuild_model_PdfPage = new $TypeData().initClass({
  Lreactbuild_model_PdfPage: 0
}, false, "reactbuild.model.PdfPage", {
  Lreactbuild_model_PdfPage: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfPage.prototype.$classData = $d_Lreactbuild_model_PdfPage;
/** @constructor */
function $c_Lreactbuild_model_PdfParagraph(lines) {
  this.Lreactbuild_model_PdfParagraph__f_lines = null;
  this.Lreactbuild_model_PdfParagraph__f_lines = lines
}
$c_Lreactbuild_model_PdfParagraph.prototype = new $h_O();
$c_Lreactbuild_model_PdfParagraph.prototype.constructor = $c_Lreactbuild_model_PdfParagraph;
/** @constructor */
function $h_Lreactbuild_model_PdfParagraph() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfParagraph.prototype = $c_Lreactbuild_model_PdfParagraph.prototype;
$c_Lreactbuild_model_PdfParagraph.prototype.productPrefix__T = (function() {
  return "PdfParagraph"
});
$c_Lreactbuild_model_PdfParagraph.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_PdfParagraph.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_PdfParagraph__f_lines : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_PdfParagraph.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_PdfParagraph.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_PdfParagraph.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_PdfParagraph.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_PdfParagraph)) {
    var PdfParagraph$1 = $as_Lreactbuild_model_PdfParagraph(x$1);
    var x = this.Lreactbuild_model_PdfParagraph__f_lines;
    var x$2 = $n(PdfParagraph$1).Lreactbuild_model_PdfParagraph__f_lines;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_PdfParagraph(obj) {
  return (((obj instanceof $c_Lreactbuild_model_PdfParagraph) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.PdfParagraph"))
}
function $isArrayOf_Lreactbuild_model_PdfParagraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_PdfParagraph)))
}
function $asArrayOf_Lreactbuild_model_PdfParagraph(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_PdfParagraph(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.PdfParagraph;", depth))
}
var $d_Lreactbuild_model_PdfParagraph = new $TypeData().initClass({
  Lreactbuild_model_PdfParagraph: 0
}, false, "reactbuild.model.PdfParagraph", {
  Lreactbuild_model_PdfParagraph: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfParagraph.prototype.$classData = $d_Lreactbuild_model_PdfParagraph;
/** @constructor */
function $c_Lreactbuild_model_PdfTextPosition(x, y, width, height, size) {
  this.Lreactbuild_model_PdfTextPosition__f_x = 0.0;
  this.Lreactbuild_model_PdfTextPosition__f_y = 0.0;
  this.Lreactbuild_model_PdfTextPosition__f_width = 0.0;
  this.Lreactbuild_model_PdfTextPosition__f_height = 0.0;
  this.Lreactbuild_model_PdfTextPosition__f_size = 0.0;
  this.Lreactbuild_model_PdfTextPosition__f_x = x;
  this.Lreactbuild_model_PdfTextPosition__f_y = y;
  this.Lreactbuild_model_PdfTextPosition__f_width = width;
  this.Lreactbuild_model_PdfTextPosition__f_height = height;
  this.Lreactbuild_model_PdfTextPosition__f_size = size
}
$c_Lreactbuild_model_PdfTextPosition.prototype = new $h_O();
$c_Lreactbuild_model_PdfTextPosition.prototype.constructor = $c_Lreactbuild_model_PdfTextPosition;
/** @constructor */
function $h_Lreactbuild_model_PdfTextPosition() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfTextPosition.prototype = $c_Lreactbuild_model_PdfTextPosition.prototype;
$c_Lreactbuild_model_PdfTextPosition.prototype.productPrefix__T = (function() {
  return "PdfTextPosition"
});
$c_Lreactbuild_model_PdfTextPosition.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_model_PdfTextPosition.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_PdfTextPosition__f_x;
      break
    }
    case 1: {
      return this.Lreactbuild_model_PdfTextPosition__f_y;
      break
    }
    case 2: {
      return this.Lreactbuild_model_PdfTextPosition__f_width;
      break
    }
    case 3: {
      return this.Lreactbuild_model_PdfTextPosition__f_height;
      break
    }
    case 4: {
      return this.Lreactbuild_model_PdfTextPosition__f_size;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_PdfTextPosition.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_PdfTextPosition.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("PdfTextPosition");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var fv = this.Lreactbuild_model_PdfTextPosition__f_x;
  var this$1 = $m_sr_Statics$();
  var data$1 = this$1.doubleHash__D__I(fv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var fv$1 = this.Lreactbuild_model_PdfTextPosition__f_y;
  var this$2 = $m_sr_Statics$();
  var data$2 = this$2.doubleHash__D__I(fv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var fv$2 = this.Lreactbuild_model_PdfTextPosition__f_width;
  var this$3 = $m_sr_Statics$();
  var data$3 = this$3.doubleHash__D__I(fv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var fv$3 = this.Lreactbuild_model_PdfTextPosition__f_height;
  var this$4 = $m_sr_Statics$();
  var data$4 = this$4.doubleHash__D__I(fv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var fv$4 = this.Lreactbuild_model_PdfTextPosition__f_size;
  var this$5 = $m_sr_Statics$();
  var data$5 = this$5.doubleHash__D__I(fv$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_model_PdfTextPosition.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_PdfTextPosition.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_PdfTextPosition)) {
    var PdfTextPosition$1 = $as_Lreactbuild_model_PdfTextPosition(x$1);
    return (((this.Lreactbuild_model_PdfTextPosition__f_x === $n(PdfTextPosition$1).Lreactbuild_model_PdfTextPosition__f_x) && (this.Lreactbuild_model_PdfTextPosition__f_y === $n(PdfTextPosition$1).Lreactbuild_model_PdfTextPosition__f_y)) && ((this.Lreactbuild_model_PdfTextPosition__f_width === $n(PdfTextPosition$1).Lreactbuild_model_PdfTextPosition__f_width) && ((this.Lreactbuild_model_PdfTextPosition__f_height === $n(PdfTextPosition$1).Lreactbuild_model_PdfTextPosition__f_height) && (this.Lreactbuild_model_PdfTextPosition__f_size === $n(PdfTextPosition$1).Lreactbuild_model_PdfTextPosition__f_size))))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_PdfTextPosition(obj) {
  return (((obj instanceof $c_Lreactbuild_model_PdfTextPosition) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.PdfTextPosition"))
}
function $isArrayOf_Lreactbuild_model_PdfTextPosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_PdfTextPosition)))
}
function $asArrayOf_Lreactbuild_model_PdfTextPosition(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_PdfTextPosition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.PdfTextPosition;", depth))
}
var $d_Lreactbuild_model_PdfTextPosition = new $TypeData().initClass({
  Lreactbuild_model_PdfTextPosition: 0
}, false, "reactbuild.model.PdfTextPosition", {
  Lreactbuild_model_PdfTextPosition: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfTextPosition.prototype.$classData = $d_Lreactbuild_model_PdfTextPosition;
/** @constructor */
function $c_Lreactbuild_model_PdfWord(text, textPositions) {
  this.Lreactbuild_model_PdfWord__f_text = null;
  this.Lreactbuild_model_PdfWord__f_textPositions = null;
  this.Lreactbuild_model_PdfWord__f_text = text;
  this.Lreactbuild_model_PdfWord__f_textPositions = textPositions
}
$c_Lreactbuild_model_PdfWord.prototype = new $h_O();
$c_Lreactbuild_model_PdfWord.prototype.constructor = $c_Lreactbuild_model_PdfWord;
/** @constructor */
function $h_Lreactbuild_model_PdfWord() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfWord.prototype = $c_Lreactbuild_model_PdfWord.prototype;
$c_Lreactbuild_model_PdfWord.prototype.productPrefix__T = (function() {
  return "PdfWord"
});
$c_Lreactbuild_model_PdfWord.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_PdfWord.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_PdfWord__f_text;
      break
    }
    case 1: {
      return this.Lreactbuild_model_PdfWord__f_textPositions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_PdfWord.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_PdfWord.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_PdfWord.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_PdfWord.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_PdfWord)) {
    var PdfWord$1 = $as_Lreactbuild_model_PdfWord(x$1);
    if ((this.Lreactbuild_model_PdfWord__f_text === $n(PdfWord$1).Lreactbuild_model_PdfWord__f_text)) {
      var x = this.Lreactbuild_model_PdfWord__f_textPositions;
      var x$2 = $n(PdfWord$1).Lreactbuild_model_PdfWord__f_textPositions;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_PdfWord(obj) {
  return (((obj instanceof $c_Lreactbuild_model_PdfWord) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.PdfWord"))
}
function $isArrayOf_Lreactbuild_model_PdfWord(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_PdfWord)))
}
function $asArrayOf_Lreactbuild_model_PdfWord(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_PdfWord(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.PdfWord;", depth))
}
var $d_Lreactbuild_model_PdfWord = new $TypeData().initClass({
  Lreactbuild_model_PdfWord: 0
}, false, "reactbuild.model.PdfWord", {
  Lreactbuild_model_PdfWord: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PdfWord.prototype.$classData = $d_Lreactbuild_model_PdfWord;
/** @constructor */
function $c_Lreactbuild_model_Price(amount) {
  this.Lreactbuild_model_Price__f_amount = 0.0;
  this.Lreactbuild_model_Price__f_amount = amount
}
$c_Lreactbuild_model_Price.prototype = new $h_O();
$c_Lreactbuild_model_Price.prototype.constructor = $c_Lreactbuild_model_Price;
/** @constructor */
function $h_Lreactbuild_model_Price() {
  /*<skip>*/
}
$h_Lreactbuild_model_Price.prototype = $c_Lreactbuild_model_Price.prototype;
$c_Lreactbuild_model_Price.prototype.productPrefix__T = (function() {
  return "Price"
});
$c_Lreactbuild_model_Price.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_Price.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_Price__f_amount : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_Price.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Price.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Price");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_model_Price__f_amount;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_model_Price.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Price.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Price)) {
    var Price$1 = $as_Lreactbuild_model_Price(x$1);
    return (this.Lreactbuild_model_Price__f_amount === $n(Price$1).Lreactbuild_model_Price__f_amount)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Price(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Price) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Price"))
}
function $isArrayOf_Lreactbuild_model_Price(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Price)))
}
function $asArrayOf_Lreactbuild_model_Price(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Price(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Price;", depth))
}
var $d_Lreactbuild_model_Price = new $TypeData().initClass({
  Lreactbuild_model_Price: 0
}, false, "reactbuild.model.Price", {
  Lreactbuild_model_Price: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Price.prototype.$classData = $d_Lreactbuild_model_Price;
/** @constructor */
function $c_Lreactbuild_model_PriceEvolutionProduct(_id, description, buildingPart, unit, events) {
  this.Lreactbuild_model_PriceEvolutionProduct__f__id = null;
  this.Lreactbuild_model_PriceEvolutionProduct__f_description = null;
  this.Lreactbuild_model_PriceEvolutionProduct__f_buildingPart = null;
  this.Lreactbuild_model_PriceEvolutionProduct__f_unit = null;
  this.Lreactbuild_model_PriceEvolutionProduct__f_events = null;
  this.Lreactbuild_model_PriceEvolutionProduct__f__id = _id;
  this.Lreactbuild_model_PriceEvolutionProduct__f_description = description;
  this.Lreactbuild_model_PriceEvolutionProduct__f_buildingPart = buildingPart;
  this.Lreactbuild_model_PriceEvolutionProduct__f_unit = unit;
  this.Lreactbuild_model_PriceEvolutionProduct__f_events = events
}
$c_Lreactbuild_model_PriceEvolutionProduct.prototype = new $h_O();
$c_Lreactbuild_model_PriceEvolutionProduct.prototype.constructor = $c_Lreactbuild_model_PriceEvolutionProduct;
/** @constructor */
function $h_Lreactbuild_model_PriceEvolutionProduct() {
  /*<skip>*/
}
$h_Lreactbuild_model_PriceEvolutionProduct.prototype = $c_Lreactbuild_model_PriceEvolutionProduct.prototype;
$c_Lreactbuild_model_PriceEvolutionProduct.prototype.productPrefix__T = (function() {
  return "PriceEvolutionProduct"
});
$c_Lreactbuild_model_PriceEvolutionProduct.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_model_PriceEvolutionProduct.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_PriceEvolutionProduct__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_PriceEvolutionProduct__f_description;
      break
    }
    case 2: {
      return this.Lreactbuild_model_PriceEvolutionProduct__f_buildingPart;
      break
    }
    case 3: {
      return this.Lreactbuild_model_PriceEvolutionProduct__f_unit;
      break
    }
    case 4: {
      return this.Lreactbuild_model_PriceEvolutionProduct__f_events;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_PriceEvolutionProduct.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_PriceEvolutionProduct.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_PriceEvolutionProduct.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_PriceEvolutionProduct.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_PriceEvolutionProduct)) {
    var PriceEvolutionProduct$1 = $as_Lreactbuild_model_PriceEvolutionProduct(x$1);
    if (((this.Lreactbuild_model_PriceEvolutionProduct__f__id === $n(PriceEvolutionProduct$1).Lreactbuild_model_PriceEvolutionProduct__f__id) && (this.Lreactbuild_model_PriceEvolutionProduct__f_description === $n(PriceEvolutionProduct$1).Lreactbuild_model_PriceEvolutionProduct__f_description))) {
      var x = this.Lreactbuild_model_PriceEvolutionProduct__f_buildingPart;
      var x$2 = $n(PriceEvolutionProduct$1).Lreactbuild_model_PriceEvolutionProduct__f_buildingPart;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_model_PriceEvolutionProduct__f_unit;
        var x$4 = $n(PriceEvolutionProduct$1).Lreactbuild_model_PriceEvolutionProduct__f_unit;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_model_PriceEvolutionProduct__f_events;
          var x$6 = $n(PriceEvolutionProduct$1).Lreactbuild_model_PriceEvolutionProduct__f_events;
          return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_PriceEvolutionProduct(obj) {
  return (((obj instanceof $c_Lreactbuild_model_PriceEvolutionProduct) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.PriceEvolutionProduct"))
}
function $isArrayOf_Lreactbuild_model_PriceEvolutionProduct(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_PriceEvolutionProduct)))
}
function $asArrayOf_Lreactbuild_model_PriceEvolutionProduct(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_PriceEvolutionProduct(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.PriceEvolutionProduct;", depth))
}
var $d_Lreactbuild_model_PriceEvolutionProduct = new $TypeData().initClass({
  Lreactbuild_model_PriceEvolutionProduct: 0
}, false, "reactbuild.model.PriceEvolutionProduct", {
  Lreactbuild_model_PriceEvolutionProduct: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PriceEvolutionProduct.prototype.$classData = $d_Lreactbuild_model_PriceEvolutionProduct;
/** @constructor */
function $c_Lreactbuild_model_PriceEvolutionProductEntry(invoicePage, reference, category, date, unitPrice, amount, quantity, buildingPart, supplier) {
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_invoicePage = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_reference = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_category = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_date = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_amount = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_quantity = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_buildingPart = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_supplier = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_invoicePage = invoicePage;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_reference = reference;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_category = category;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_date = date;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice = unitPrice;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_amount = amount;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_quantity = quantity;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_buildingPart = buildingPart;
  this.Lreactbuild_model_PriceEvolutionProductEntry__f_supplier = supplier
}
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype = new $h_O();
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype.constructor = $c_Lreactbuild_model_PriceEvolutionProductEntry;
/** @constructor */
function $h_Lreactbuild_model_PriceEvolutionProductEntry() {
  /*<skip>*/
}
$h_Lreactbuild_model_PriceEvolutionProductEntry.prototype = $c_Lreactbuild_model_PriceEvolutionProductEntry.prototype;
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype.productPrefix__T = (function() {
  return "PriceEvolutionProductEntry"
});
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype.productArity__I = (function() {
  return 9
});
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_PriceEvolutionProductEntry__f_invoicePage;
      break
    }
    case 1: {
      return this.Lreactbuild_model_PriceEvolutionProductEntry__f_reference;
      break
    }
    case 2: {
      return this.Lreactbuild_model_PriceEvolutionProductEntry__f_category;
      break
    }
    case 3: {
      return this.Lreactbuild_model_PriceEvolutionProductEntry__f_date;
      break
    }
    case 4: {
      return this.Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice;
      break
    }
    case 5: {
      return this.Lreactbuild_model_PriceEvolutionProductEntry__f_amount;
      break
    }
    case 6: {
      return this.Lreactbuild_model_PriceEvolutionProductEntry__f_quantity;
      break
    }
    case 7: {
      return this.Lreactbuild_model_PriceEvolutionProductEntry__f_buildingPart;
      break
    }
    case 8: {
      return this.Lreactbuild_model_PriceEvolutionProductEntry__f_supplier;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_PriceEvolutionProductEntry)) {
    var PriceEvolutionProductEntry$1 = $as_Lreactbuild_model_PriceEvolutionProductEntry(x$1);
    var x = this.Lreactbuild_model_PriceEvolutionProductEntry__f_invoicePage;
    var x$2 = $n(PriceEvolutionProductEntry$1).Lreactbuild_model_PriceEvolutionProductEntry__f_invoicePage;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_PriceEvolutionProductEntry__f_reference;
      var x$4 = $n(PriceEvolutionProductEntry$1).Lreactbuild_model_PriceEvolutionProductEntry__f_reference;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_model_PriceEvolutionProductEntry__f_category;
      var x$6 = $n(PriceEvolutionProductEntry$1).Lreactbuild_model_PriceEvolutionProductEntry__f_category;
      if ((x$5 === null)) {
        var $$x3 = (x$6 === null)
      } else {
        var this$1 = $n(x$5);
        var $$x3 = (this$1 === x$6)
      };
      if ($$x3) {
        var x$7 = this.Lreactbuild_model_PriceEvolutionProductEntry__f_date;
        var x$8 = $n(PriceEvolutionProductEntry$1).Lreactbuild_model_PriceEvolutionProductEntry__f_date;
        var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice;
      var x$10 = $n(PriceEvolutionProductEntry$1).Lreactbuild_model_PriceEvolutionProductEntry__f_unitPrice;
      if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
        var x$11 = this.Lreactbuild_model_PriceEvolutionProductEntry__f_amount;
        var x$12 = $n(PriceEvolutionProductEntry$1).Lreactbuild_model_PriceEvolutionProductEntry__f_amount;
        var $$x4 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var x$13 = this.Lreactbuild_model_PriceEvolutionProductEntry__f_quantity;
        var x$14 = $n(PriceEvolutionProductEntry$1).Lreactbuild_model_PriceEvolutionProductEntry__f_quantity;
        if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
          var x$15 = this.Lreactbuild_model_PriceEvolutionProductEntry__f_buildingPart;
          var x$16 = $n(PriceEvolutionProductEntry$1).Lreactbuild_model_PriceEvolutionProductEntry__f_buildingPart;
          if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
            var x$17 = this.Lreactbuild_model_PriceEvolutionProductEntry__f_supplier;
            var x$18 = $n(PriceEvolutionProductEntry$1).Lreactbuild_model_PriceEvolutionProductEntry__f_supplier;
            return ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_PriceEvolutionProductEntry(obj) {
  return (((obj instanceof $c_Lreactbuild_model_PriceEvolutionProductEntry) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.PriceEvolutionProductEntry"))
}
function $isArrayOf_Lreactbuild_model_PriceEvolutionProductEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_PriceEvolutionProductEntry)))
}
function $asArrayOf_Lreactbuild_model_PriceEvolutionProductEntry(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_PriceEvolutionProductEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.PriceEvolutionProductEntry;", depth))
}
var $d_Lreactbuild_model_PriceEvolutionProductEntry = new $TypeData().initClass({
  Lreactbuild_model_PriceEvolutionProductEntry: 0
}, false, "reactbuild.model.PriceEvolutionProductEntry", {
  Lreactbuild_model_PriceEvolutionProductEntry: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_PriceEvolutionProductEntry.prototype.$classData = $d_Lreactbuild_model_PriceEvolutionProductEntry;
/** @constructor */
function $c_Lreactbuild_model_Product(_id, organization, reference, name, supplier, buildingPart) {
  this.Lreactbuild_model_Product__f__id = null;
  this.Lreactbuild_model_Product__f_organization = null;
  this.Lreactbuild_model_Product__f_reference = null;
  this.Lreactbuild_model_Product__f_name = null;
  this.Lreactbuild_model_Product__f_supplier = null;
  this.Lreactbuild_model_Product__f_buildingPart = null;
  this.Lreactbuild_model_Product__f__id = _id;
  this.Lreactbuild_model_Product__f_organization = organization;
  this.Lreactbuild_model_Product__f_reference = reference;
  this.Lreactbuild_model_Product__f_name = name;
  this.Lreactbuild_model_Product__f_supplier = supplier;
  this.Lreactbuild_model_Product__f_buildingPart = buildingPart
}
$c_Lreactbuild_model_Product.prototype = new $h_O();
$c_Lreactbuild_model_Product.prototype.constructor = $c_Lreactbuild_model_Product;
/** @constructor */
function $h_Lreactbuild_model_Product() {
  /*<skip>*/
}
$h_Lreactbuild_model_Product.prototype = $c_Lreactbuild_model_Product.prototype;
$c_Lreactbuild_model_Product.prototype.productPrefix__T = (function() {
  return "Product"
});
$c_Lreactbuild_model_Product.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_model_Product.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_Product__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_Product__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_Product__f_reference;
      break
    }
    case 3: {
      return this.Lreactbuild_model_Product__f_name;
      break
    }
    case 4: {
      return this.Lreactbuild_model_Product__f_supplier;
      break
    }
    case 5: {
      return this.Lreactbuild_model_Product__f_buildingPart;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_Product.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Product.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_Product.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Product.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Product)) {
    var Product$1 = $as_Lreactbuild_model_Product(x$1);
    var x = this.Lreactbuild_model_Product__f__id;
    var x$2 = $n(Product$1).Lreactbuild_model_Product__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_Product__f_organization;
      var x$4 = $n(Product$1).Lreactbuild_model_Product__f_organization;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var $$x1 = (this.Lreactbuild_model_Product__f_reference === $n(Product$1).Lreactbuild_model_Product__f_reference)
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_model_Product__f_name === $n(Product$1).Lreactbuild_model_Product__f_name)) {
        var x$5 = this.Lreactbuild_model_Product__f_supplier;
        var x$6 = $n(Product$1).Lreactbuild_model_Product__f_supplier;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var x$7 = this.Lreactbuild_model_Product__f_buildingPart;
          var x$8 = $n(Product$1).Lreactbuild_model_Product__f_buildingPart;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Product(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Product) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Product"))
}
function $isArrayOf_Lreactbuild_model_Product(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Product)))
}
function $asArrayOf_Lreactbuild_model_Product(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Product(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Product;", depth))
}
var $d_Lreactbuild_model_Product = new $TypeData().initClass({
  Lreactbuild_model_Product: 0
}, false, "reactbuild.model.Product", {
  Lreactbuild_model_Product: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Product.prototype.$classData = $d_Lreactbuild_model_Product;
/** @constructor */
function $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(_id, organization, date, reference, details) {
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_organization = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_date = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_details = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id = _id;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_organization = organization;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_date = date;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference = reference;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_details = details
}
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype = new $h_O();
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype.constructor = $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm;
/** @constructor */
function $h_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm() {
  /*<skip>*/
}
$h_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype = $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype;
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype.productPrefix__T = (function() {
  return "ReconcileInvoicePageWithDeliveryForm"
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_date;
      break
    }
    case 3: {
      return this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference;
      break
    }
    case 4: {
      return this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_details;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm)) {
    var ReconcileInvoicePageWithDeliveryForm$1 = $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(x$1);
    var x = this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id;
    var x$2 = $n(ReconcileInvoicePageWithDeliveryForm$1).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_organization;
      var x$4 = $n(ReconcileInvoicePageWithDeliveryForm$1).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_organization;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_date;
      var x$6 = $n(ReconcileInvoicePageWithDeliveryForm$1).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_date;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        if ((this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference === $n(ReconcileInvoicePageWithDeliveryForm$1).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_reference)) {
          var x$7 = this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_details;
          var x$8 = $n(ReconcileInvoicePageWithDeliveryForm$1).Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm__f_details;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ReconcileInvoicePageWithDeliveryForm"))
}
function $isArrayOf_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm)))
}
function $asArrayOf_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ReconcileInvoicePageWithDeliveryForm;", depth))
}
var $d_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm = new $TypeData().initClass({
  Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm: 0
}, false, "reactbuild.model.ReconcileInvoicePageWithDeliveryForm", {
  Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm.prototype.$classData = $d_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm;
/** @constructor */
function $c_Lreactbuild_model_RefToResolver() {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null
}
$c_Lreactbuild_model_RefToResolver.prototype = new $h_Lreactbuild_model_BaseRefToResolver();
$c_Lreactbuild_model_RefToResolver.prototype.constructor = $c_Lreactbuild_model_RefToResolver;
/** @constructor */
function $h_Lreactbuild_model_RefToResolver() {
  /*<skip>*/
}
$h_Lreactbuild_model_RefToResolver.prototype = $c_Lreactbuild_model_RefToResolver.prototype;
/** @constructor */
function $c_Lreactbuild_model_Resource(_id, organization, name, costByHour, category, entry, release) {
  this.Lreactbuild_model_Resource__f__id = null;
  this.Lreactbuild_model_Resource__f_organization = null;
  this.Lreactbuild_model_Resource__f_name = null;
  this.Lreactbuild_model_Resource__f_costByHour = null;
  this.Lreactbuild_model_Resource__f_category = null;
  this.Lreactbuild_model_Resource__f_entry = null;
  this.Lreactbuild_model_Resource__f_release = null;
  this.Lreactbuild_model_Resource__f__id = _id;
  this.Lreactbuild_model_Resource__f_organization = organization;
  this.Lreactbuild_model_Resource__f_name = name;
  this.Lreactbuild_model_Resource__f_costByHour = costByHour;
  this.Lreactbuild_model_Resource__f_category = category;
  this.Lreactbuild_model_Resource__f_entry = entry;
  this.Lreactbuild_model_Resource__f_release = release
}
$c_Lreactbuild_model_Resource.prototype = new $h_O();
$c_Lreactbuild_model_Resource.prototype.constructor = $c_Lreactbuild_model_Resource;
/** @constructor */
function $h_Lreactbuild_model_Resource() {
  /*<skip>*/
}
$h_Lreactbuild_model_Resource.prototype = $c_Lreactbuild_model_Resource.prototype;
$c_Lreactbuild_model_Resource.prototype.productPrefix__T = (function() {
  return "Resource"
});
$c_Lreactbuild_model_Resource.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_model_Resource.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_Resource__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_Resource__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_Resource__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_model_Resource__f_costByHour;
      break
    }
    case 4: {
      return this.Lreactbuild_model_Resource__f_category;
      break
    }
    case 5: {
      return this.Lreactbuild_model_Resource__f_entry;
      break
    }
    case 6: {
      return this.Lreactbuild_model_Resource__f_release;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_Resource.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Resource.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_Resource.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Resource.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Resource)) {
    var Resource$1 = $as_Lreactbuild_model_Resource(x$1);
    var x = this.Lreactbuild_model_Resource__f__id;
    var x$2 = $n(Resource$1).Lreactbuild_model_Resource__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_Resource__f_organization;
      var x$4 = $n(Resource$1).Lreactbuild_model_Resource__f_organization;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var $$x1 = (this.Lreactbuild_model_Resource__f_name === $n(Resource$1).Lreactbuild_model_Resource__f_name)
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_model_Resource__f_costByHour;
      var x$6 = $n(Resource$1).Lreactbuild_model_Resource__f_costByHour;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_Resource__f_category;
        var x$8 = $n(Resource$1).Lreactbuild_model_Resource__f_category;
        var $$x2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$9 = this.Lreactbuild_model_Resource__f_entry;
        var x$10 = $n(Resource$1).Lreactbuild_model_Resource__f_entry;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_model_Resource__f_release;
          var x$12 = $n(Resource$1).Lreactbuild_model_Resource__f_release;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Resource(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Resource) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Resource"))
}
function $isArrayOf_Lreactbuild_model_Resource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Resource)))
}
function $asArrayOf_Lreactbuild_model_Resource(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Resource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Resource;", depth))
}
var $d_Lreactbuild_model_Resource = new $TypeData().initClass({
  Lreactbuild_model_Resource: 0
}, false, "reactbuild.model.Resource", {
  Lreactbuild_model_Resource: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Resource.prototype.$classData = $d_Lreactbuild_model_Resource;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94(outer) {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94__f_circeGenericDecoderForref = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94__f_circeGenericDecoderForref = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("ref"))), this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94__f_circeGenericDecoderForref, "ref", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4$$anon$94", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$94;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95(outer) {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95__f_circeGenericDecoderForitem = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95__f_circeGenericDecoderForitem = $m_Lreactbuild_person_PersonReferenceEvent$().Lreactbuild_person_PersonReferenceEvent$__f_codecForPersonReferenceEvent
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("item"))), this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95__f_circeGenericDecoderForitem, "item", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4$$anon$95", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$95;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96(outer) {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96__f_circeGenericDecoderForref = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96__f_circeGenericDecoderForref = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("ref"))), this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96__f_circeGenericDecoderForref, "ref", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4$$anon$96", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$96;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97(outer) {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97__f_circeGenericDecoderForref = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97__f_circeGenericDecoderForref = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("ref"))), this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97__f_circeGenericDecoderForref, "ref", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4$$anon$97", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$97;
/** @constructor */
function $c_Lreactbuild_model_Task(_id, organization, persons, subject, attachments, created, done) {
  this.Lreactbuild_model_Task__f__id = null;
  this.Lreactbuild_model_Task__f_organization = null;
  this.Lreactbuild_model_Task__f_persons = null;
  this.Lreactbuild_model_Task__f_subject = null;
  this.Lreactbuild_model_Task__f_attachments = null;
  this.Lreactbuild_model_Task__f_created = null;
  this.Lreactbuild_model_Task__f_done = null;
  this.Lreactbuild_model_Task__f__id = _id;
  this.Lreactbuild_model_Task__f_organization = organization;
  this.Lreactbuild_model_Task__f_persons = persons;
  this.Lreactbuild_model_Task__f_subject = subject;
  this.Lreactbuild_model_Task__f_attachments = attachments;
  this.Lreactbuild_model_Task__f_created = created;
  this.Lreactbuild_model_Task__f_done = done
}
$c_Lreactbuild_model_Task.prototype = new $h_O();
$c_Lreactbuild_model_Task.prototype.constructor = $c_Lreactbuild_model_Task;
/** @constructor */
function $h_Lreactbuild_model_Task() {
  /*<skip>*/
}
$h_Lreactbuild_model_Task.prototype = $c_Lreactbuild_model_Task.prototype;
$c_Lreactbuild_model_Task.prototype.productPrefix__T = (function() {
  return "Task"
});
$c_Lreactbuild_model_Task.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_model_Task.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_Task__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_Task__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_Task__f_persons;
      break
    }
    case 3: {
      return new $c_Lcom_iz2use_common_Multiline(this.Lreactbuild_model_Task__f_subject);
      break
    }
    case 4: {
      return this.Lreactbuild_model_Task__f_attachments;
      break
    }
    case 5: {
      return this.Lreactbuild_model_Task__f_created;
      break
    }
    case 6: {
      return this.Lreactbuild_model_Task__f_done;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_Task.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Task.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_Task.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Task.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Task)) {
    var Task$1 = $as_Lreactbuild_model_Task(x$1);
    var x = this.Lreactbuild_model_Task__f__id;
    var x$2 = $n(Task$1).Lreactbuild_model_Task__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_Task__f_organization;
      var x$4 = $n(Task$1).Lreactbuild_model_Task__f_organization;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_model_Task__f_persons;
        var x$6 = $n(Task$1).Lreactbuild_model_Task__f_persons;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_model_Task__f_subject === $n(Task$1).Lreactbuild_model_Task__f_subject)) {
        var x$7 = this.Lreactbuild_model_Task__f_attachments;
        var x$8 = $n(Task$1).Lreactbuild_model_Task__f_attachments;
        var $$x2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$9 = this.Lreactbuild_model_Task__f_created;
        var x$10 = $n(Task$1).Lreactbuild_model_Task__f_created;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_model_Task__f_done;
          var x$12 = $n(Task$1).Lreactbuild_model_Task__f_done;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Task(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Task) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Task"))
}
function $isArrayOf_Lreactbuild_model_Task(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Task)))
}
function $asArrayOf_Lreactbuild_model_Task(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Task(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Task;", depth))
}
var $d_Lreactbuild_model_Task = new $TypeData().initClass({
  Lreactbuild_model_Task: 0
}, false, "reactbuild.model.Task", {
  Lreactbuild_model_Task: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Task.prototype.$classData = $d_Lreactbuild_model_Task;
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5(outer) {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5__f_circeGenericDecoderForid = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5__f_circeGenericDecoderFortarget = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5__f_circeGenericDecoderFortarget = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("target"))), this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5__f_circeGenericDecoderFortarget, "target", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1$$anon$5", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$5;
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6(outer) {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6__f_circeGenericDecoderForid = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6__f_circeGenericDecoderFortarget = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6__f_circeGenericDecoderFortarget = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("target"))), this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6__f_circeGenericDecoderFortarget, "target", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1$$anon$6", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7(outer) {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7__f_circeGenericDecoderForid = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7__f_circeGenericDecoderFortarget = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7__f_circeGenericDecoderFortarget = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("target"))), this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7__f_circeGenericDecoderFortarget, "target", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1$$anon$7", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8(outer) {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8__f_circeGenericDecoderForid = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8__f_circeGenericDecoderFortarget = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8__f_circeGenericDecoderFortarget = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("target"))), this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8__f_circeGenericDecoderFortarget, "target", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1$$anon$8", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$8;
/** @constructor */
function $c_Lreactbuild_model_TaskPerson(id, role, user, added) {
  this.Lreactbuild_model_TaskPerson__f_id = null;
  this.Lreactbuild_model_TaskPerson__f_role = null;
  this.Lreactbuild_model_TaskPerson__f_user = null;
  this.Lreactbuild_model_TaskPerson__f_added = null;
  this.Lreactbuild_model_TaskPerson__f_id = id;
  this.Lreactbuild_model_TaskPerson__f_role = role;
  this.Lreactbuild_model_TaskPerson__f_user = user;
  this.Lreactbuild_model_TaskPerson__f_added = added
}
$c_Lreactbuild_model_TaskPerson.prototype = new $h_O();
$c_Lreactbuild_model_TaskPerson.prototype.constructor = $c_Lreactbuild_model_TaskPerson;
/** @constructor */
function $h_Lreactbuild_model_TaskPerson() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskPerson.prototype = $c_Lreactbuild_model_TaskPerson.prototype;
$c_Lreactbuild_model_TaskPerson.prototype.productPrefix__T = (function() {
  return "TaskPerson"
});
$c_Lreactbuild_model_TaskPerson.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_model_TaskPerson.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_TaskPerson__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_TaskPerson__f_role;
      break
    }
    case 2: {
      return this.Lreactbuild_model_TaskPerson__f_user;
      break
    }
    case 3: {
      return this.Lreactbuild_model_TaskPerson__f_added;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_TaskPerson.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_TaskPerson.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_TaskPerson.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_TaskPerson.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_TaskPerson)) {
    var TaskPerson$1 = $as_Lreactbuild_model_TaskPerson(x$1);
    var x = this.Lreactbuild_model_TaskPerson__f_id;
    var x$2 = $n(TaskPerson$1).Lreactbuild_model_TaskPerson__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_TaskPerson__f_role;
      var x$4 = $n(TaskPerson$1).Lreactbuild_model_TaskPerson__f_role;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_model_TaskPerson__f_user;
      var x$6 = $n(TaskPerson$1).Lreactbuild_model_TaskPerson__f_user;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_TaskPerson__f_added;
        var x$8 = $n(TaskPerson$1).Lreactbuild_model_TaskPerson__f_added;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_TaskPerson(obj) {
  return (((obj instanceof $c_Lreactbuild_model_TaskPerson) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TaskPerson"))
}
function $isArrayOf_Lreactbuild_model_TaskPerson(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TaskPerson)))
}
function $asArrayOf_Lreactbuild_model_TaskPerson(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TaskPerson(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TaskPerson;", depth))
}
var $d_Lreactbuild_model_TaskPerson = new $TypeData().initClass({
  Lreactbuild_model_TaskPerson: 0
}, false, "reactbuild.model.TaskPerson", {
  Lreactbuild_model_TaskPerson: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskPerson.prototype.$classData = $d_Lreactbuild_model_TaskPerson;
/** @constructor */
function $c_Lreactbuild_model_Term(_id, organization, label, parent) {
  this.Lreactbuild_model_Term__f__id = null;
  this.Lreactbuild_model_Term__f_organization = null;
  this.Lreactbuild_model_Term__f_label = null;
  this.Lreactbuild_model_Term__f_parent = null;
  this.Lreactbuild_model_Term__f__id = _id;
  this.Lreactbuild_model_Term__f_organization = organization;
  this.Lreactbuild_model_Term__f_label = label;
  this.Lreactbuild_model_Term__f_parent = parent
}
$c_Lreactbuild_model_Term.prototype = new $h_O();
$c_Lreactbuild_model_Term.prototype.constructor = $c_Lreactbuild_model_Term;
/** @constructor */
function $h_Lreactbuild_model_Term() {
  /*<skip>*/
}
$h_Lreactbuild_model_Term.prototype = $c_Lreactbuild_model_Term.prototype;
$c_Lreactbuild_model_Term.prototype.productPrefix__T = (function() {
  return "Term"
});
$c_Lreactbuild_model_Term.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_model_Term.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_Term__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_Term__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_Term__f_label;
      break
    }
    case 3: {
      return this.Lreactbuild_model_Term__f_parent;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_Term.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Term.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_Term.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Term.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Term)) {
    var Term$1 = $as_Lreactbuild_model_Term(x$1);
    var x = this.Lreactbuild_model_Term__f__id;
    var x$2 = $n(Term$1).Lreactbuild_model_Term__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_Term__f_organization;
      var x$4 = $n(Term$1).Lreactbuild_model_Term__f_organization;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_model_Term__f_label === $n(Term$1).Lreactbuild_model_Term__f_label)) {
        var x$5 = this.Lreactbuild_model_Term__f_parent;
        var x$6 = $n(Term$1).Lreactbuild_model_Term__f_parent;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Term(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Term) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Term"))
}
function $isArrayOf_Lreactbuild_model_Term(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Term)))
}
function $asArrayOf_Lreactbuild_model_Term(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Term(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Term;", depth))
}
var $d_Lreactbuild_model_Term = new $TypeData().initClass({
  Lreactbuild_model_Term: 0
}, false, "reactbuild.model.Term", {
  Lreactbuild_model_Term: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Term.prototype.$classData = $d_Lreactbuild_model_Term;
/** @constructor */
function $c_Lreactbuild_model_TimeReport(_id, date, resource, buildingSite, buildingStage, duration, comments) {
  this.Lreactbuild_model_TimeReport__f__id = null;
  this.Lreactbuild_model_TimeReport__f_date = null;
  this.Lreactbuild_model_TimeReport__f_resource = null;
  this.Lreactbuild_model_TimeReport__f_buildingSite = null;
  this.Lreactbuild_model_TimeReport__f_buildingStage = null;
  this.Lreactbuild_model_TimeReport__f_duration = null;
  this.Lreactbuild_model_TimeReport__f_comments = null;
  this.Lreactbuild_model_TimeReport__f__id = _id;
  this.Lreactbuild_model_TimeReport__f_date = date;
  this.Lreactbuild_model_TimeReport__f_resource = resource;
  this.Lreactbuild_model_TimeReport__f_buildingSite = buildingSite;
  this.Lreactbuild_model_TimeReport__f_buildingStage = buildingStage;
  this.Lreactbuild_model_TimeReport__f_duration = duration;
  this.Lreactbuild_model_TimeReport__f_comments = comments
}
$c_Lreactbuild_model_TimeReport.prototype = new $h_O();
$c_Lreactbuild_model_TimeReport.prototype.constructor = $c_Lreactbuild_model_TimeReport;
/** @constructor */
function $h_Lreactbuild_model_TimeReport() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReport.prototype = $c_Lreactbuild_model_TimeReport.prototype;
$c_Lreactbuild_model_TimeReport.prototype.productPrefix__T = (function() {
  return "TimeReport"
});
$c_Lreactbuild_model_TimeReport.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_model_TimeReport.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_TimeReport__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_TimeReport__f_date;
      break
    }
    case 2: {
      return this.Lreactbuild_model_TimeReport__f_resource;
      break
    }
    case 3: {
      return this.Lreactbuild_model_TimeReport__f_buildingSite;
      break
    }
    case 4: {
      return this.Lreactbuild_model_TimeReport__f_buildingStage;
      break
    }
    case 5: {
      return this.Lreactbuild_model_TimeReport__f_duration;
      break
    }
    case 6: {
      return this.Lreactbuild_model_TimeReport__f_comments;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_TimeReport.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_TimeReport.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_TimeReport.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_TimeReport.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_TimeReport)) {
    var TimeReport$1 = $as_Lreactbuild_model_TimeReport(x$1);
    var x = this.Lreactbuild_model_TimeReport__f__id;
    var x$2 = $n(TimeReport$1).Lreactbuild_model_TimeReport__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_TimeReport__f_date;
      var x$4 = $n(TimeReport$1).Lreactbuild_model_TimeReport__f_date;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_model_TimeReport__f_resource;
        var x$6 = $n(TimeReport$1).Lreactbuild_model_TimeReport__f_resource;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_model_TimeReport__f_buildingSite;
      var x$8 = $n(TimeReport$1).Lreactbuild_model_TimeReport__f_buildingSite;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_model_TimeReport__f_buildingStage;
        var x$10 = $n(TimeReport$1).Lreactbuild_model_TimeReport__f_buildingStage;
        var $$x2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$11 = this.Lreactbuild_model_TimeReport__f_duration;
        var x$12 = $n(TimeReport$1).Lreactbuild_model_TimeReport__f_duration;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_model_TimeReport__f_comments;
          var x$14 = $n(TimeReport$1).Lreactbuild_model_TimeReport__f_comments;
          return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_TimeReport(obj) {
  return (((obj instanceof $c_Lreactbuild_model_TimeReport) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TimeReport"))
}
function $isArrayOf_Lreactbuild_model_TimeReport(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TimeReport)))
}
function $asArrayOf_Lreactbuild_model_TimeReport(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TimeReport(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TimeReport;", depth))
}
var $d_Lreactbuild_model_TimeReport = new $TypeData().initClass({
  Lreactbuild_model_TimeReport: 0
}, false, "reactbuild.model.TimeReport", {
  Lreactbuild_model_TimeReport: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TimeReport.prototype.$classData = $d_Lreactbuild_model_TimeReport;
/** @constructor */
function $c_Lreactbuild_model_TimeReportEvent(_id, resource, date, ignore, manuallyAdded) {
  this.Lreactbuild_model_TimeReportEvent__f__id = null;
  this.Lreactbuild_model_TimeReportEvent__f_resource = null;
  this.Lreactbuild_model_TimeReportEvent__f_date = null;
  this.Lreactbuild_model_TimeReportEvent__f_ignore = false;
  this.Lreactbuild_model_TimeReportEvent__f_manuallyAdded = false;
  this.Lreactbuild_model_TimeReportEvent__f__id = _id;
  this.Lreactbuild_model_TimeReportEvent__f_resource = resource;
  this.Lreactbuild_model_TimeReportEvent__f_date = date;
  this.Lreactbuild_model_TimeReportEvent__f_ignore = ignore;
  this.Lreactbuild_model_TimeReportEvent__f_manuallyAdded = manuallyAdded
}
$c_Lreactbuild_model_TimeReportEvent.prototype = new $h_O();
$c_Lreactbuild_model_TimeReportEvent.prototype.constructor = $c_Lreactbuild_model_TimeReportEvent;
/** @constructor */
function $h_Lreactbuild_model_TimeReportEvent() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReportEvent.prototype = $c_Lreactbuild_model_TimeReportEvent.prototype;
$c_Lreactbuild_model_TimeReportEvent.prototype.productPrefix__T = (function() {
  return "TimeReportEvent"
});
$c_Lreactbuild_model_TimeReportEvent.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_model_TimeReportEvent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_TimeReportEvent__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_TimeReportEvent__f_resource;
      break
    }
    case 2: {
      return this.Lreactbuild_model_TimeReportEvent__f_date;
      break
    }
    case 3: {
      return this.Lreactbuild_model_TimeReportEvent__f_ignore;
      break
    }
    case 4: {
      return this.Lreactbuild_model_TimeReportEvent__f_manuallyAdded;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_TimeReportEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_TimeReportEvent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TimeReportEvent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_model_TimeReportEvent__f__id;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_model_TimeReportEvent__f_resource;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_model_TimeReportEvent__f_date;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lreactbuild_model_TimeReportEvent__f_ignore ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lreactbuild_model_TimeReportEvent__f_manuallyAdded ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_model_TimeReportEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_TimeReportEvent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_TimeReportEvent)) {
    var TimeReportEvent$1 = $as_Lreactbuild_model_TimeReportEvent(x$1);
    if (((this.Lreactbuild_model_TimeReportEvent__f_ignore === $n(TimeReportEvent$1).Lreactbuild_model_TimeReportEvent__f_ignore) && (this.Lreactbuild_model_TimeReportEvent__f_manuallyAdded === $n(TimeReportEvent$1).Lreactbuild_model_TimeReportEvent__f_manuallyAdded))) {
      var x = this.Lreactbuild_model_TimeReportEvent__f__id;
      var x$2 = $n(TimeReportEvent$1).Lreactbuild_model_TimeReportEvent__f__id;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_model_TimeReportEvent__f_resource;
        var x$4 = $n(TimeReportEvent$1).Lreactbuild_model_TimeReportEvent__f_resource;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_model_TimeReportEvent__f_date;
          var x$6 = $n(TimeReportEvent$1).Lreactbuild_model_TimeReportEvent__f_date;
          return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_TimeReportEvent(obj) {
  return (((obj instanceof $c_Lreactbuild_model_TimeReportEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TimeReportEvent"))
}
function $isArrayOf_Lreactbuild_model_TimeReportEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TimeReportEvent)))
}
function $asArrayOf_Lreactbuild_model_TimeReportEvent(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TimeReportEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TimeReportEvent;", depth))
}
var $d_Lreactbuild_model_TimeReportEvent = new $TypeData().initClass({
  Lreactbuild_model_TimeReportEvent: 0
}, false, "reactbuild.model.TimeReportEvent", {
  Lreactbuild_model_TimeReportEvent: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TimeReportEvent.prototype.$classData = $d_Lreactbuild_model_TimeReportEvent;
/** @constructor */
function $c_Lreactbuild_model_TimeReportInterval(start, end, details) {
  this.Lreactbuild_model_TimeReportInterval__f_start = null;
  this.Lreactbuild_model_TimeReportInterval__f_end = null;
  this.Lreactbuild_model_TimeReportInterval__f_details = null;
  this.Lreactbuild_model_TimeReportInterval__f_start = start;
  this.Lreactbuild_model_TimeReportInterval__f_end = end;
  this.Lreactbuild_model_TimeReportInterval__f_details = details
}
$c_Lreactbuild_model_TimeReportInterval.prototype = new $h_O();
$c_Lreactbuild_model_TimeReportInterval.prototype.constructor = $c_Lreactbuild_model_TimeReportInterval;
/** @constructor */
function $h_Lreactbuild_model_TimeReportInterval() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReportInterval.prototype = $c_Lreactbuild_model_TimeReportInterval.prototype;
$c_Lreactbuild_model_TimeReportInterval.prototype.productPrefix__T = (function() {
  return "TimeReportInterval"
});
$c_Lreactbuild_model_TimeReportInterval.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_model_TimeReportInterval.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_TimeReportInterval__f_start;
      break
    }
    case 1: {
      return this.Lreactbuild_model_TimeReportInterval__f_end;
      break
    }
    case 2: {
      return this.Lreactbuild_model_TimeReportInterval__f_details;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_TimeReportInterval.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_TimeReportInterval.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_TimeReportInterval.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_TimeReportInterval.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_TimeReportInterval)) {
    var TimeReportInterval$1 = $as_Lreactbuild_model_TimeReportInterval(x$1);
    var x = this.Lreactbuild_model_TimeReportInterval__f_start;
    var x$2 = $n(TimeReportInterval$1).Lreactbuild_model_TimeReportInterval__f_start;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_TimeReportInterval__f_end;
      var x$4 = $n(TimeReportInterval$1).Lreactbuild_model_TimeReportInterval__f_end;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_model_TimeReportInterval__f_details;
        var x$6 = $n(TimeReportInterval$1).Lreactbuild_model_TimeReportInterval__f_details;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_TimeReportInterval(obj) {
  return (((obj instanceof $c_Lreactbuild_model_TimeReportInterval) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TimeReportInterval"))
}
function $isArrayOf_Lreactbuild_model_TimeReportInterval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TimeReportInterval)))
}
function $asArrayOf_Lreactbuild_model_TimeReportInterval(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TimeReportInterval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TimeReportInterval;", depth))
}
var $d_Lreactbuild_model_TimeReportInterval = new $TypeData().initClass({
  Lreactbuild_model_TimeReportInterval: 0
}, false, "reactbuild.model.TimeReportInterval", {
  Lreactbuild_model_TimeReportInterval: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TimeReportInterval.prototype.$classData = $d_Lreactbuild_model_TimeReportInterval;
/** @constructor */
function $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5(outer) {
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5__f_circeGenericDecoderFororigin = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5__f_circeGenericDecoderFororigin = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder()
}
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5.prototype = new $h_Lio_circe_generic_decoding_ReprDecoder();
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5.prototype.constructor = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5;
/** @constructor */
function $h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5.prototype = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5.prototype;
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5__f_circeGenericDecoderFororigin).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("origin")), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5 = new $TypeData().initClass({
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5: 0
}, false, "reactbuild.model.ToClient$anon$lazy$macro$59$1$$anon$5", {
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5: 1,
  Lio_circe_generic_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5.prototype.$classData = $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$5;
/** @constructor */
function $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6(outer) {
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderFororigin = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderForuser = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderForprojectRef = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderFory = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderFororigin = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderForuser = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderForprojectRef = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderFory = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble
}
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6.prototype = new $h_Lio_circe_generic_decoding_ReprDecoder();
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6.prototype.constructor = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6.prototype = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6.prototype;
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderFororigin).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("origin")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderForuser).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("user")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderForprojectRef).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("projectRef")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderFory).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("x")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6__f_circeGenericDecoderFory).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("y")), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6: 0
}, false, "reactbuild.model.ToClient$anon$lazy$macro$59$1$$anon$6", {
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6: 1,
  Lio_circe_generic_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6.prototype.$classData = $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_model_WithChildren(item, children) {
  this.Lreactbuild_model_WithChildren__f_item = null;
  this.Lreactbuild_model_WithChildren__f_children = null;
  this.Lreactbuild_model_WithChildren__f_item = item;
  this.Lreactbuild_model_WithChildren__f_children = children
}
$c_Lreactbuild_model_WithChildren.prototype = new $h_O();
$c_Lreactbuild_model_WithChildren.prototype.constructor = $c_Lreactbuild_model_WithChildren;
/** @constructor */
function $h_Lreactbuild_model_WithChildren() {
  /*<skip>*/
}
$h_Lreactbuild_model_WithChildren.prototype = $c_Lreactbuild_model_WithChildren.prototype;
$c_Lreactbuild_model_WithChildren.prototype.productPrefix__T = (function() {
  return "WithChildren"
});
$c_Lreactbuild_model_WithChildren.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_WithChildren.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_WithChildren__f_item;
      break
    }
    case 1: {
      return this.Lreactbuild_model_WithChildren__f_children;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_WithChildren.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_WithChildren.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_WithChildren.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_WithChildren.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_WithChildren)) {
    var WithChildren$1 = $as_Lreactbuild_model_WithChildren(x$1);
    var x = this.Lreactbuild_model_WithChildren__f_item;
    var y = $n(WithChildren$1).Lreactbuild_model_WithChildren__f_item;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_model_WithChildren__f_children;
      var x$2$1 = $n(WithChildren$1).Lreactbuild_model_WithChildren__f_children;
      return ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_WithChildren(obj) {
  return (((obj instanceof $c_Lreactbuild_model_WithChildren) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.WithChildren"))
}
function $isArrayOf_Lreactbuild_model_WithChildren(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_WithChildren)))
}
function $asArrayOf_Lreactbuild_model_WithChildren(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_WithChildren(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.WithChildren;", depth))
}
var $d_Lreactbuild_model_WithChildren = new $TypeData().initClass({
  Lreactbuild_model_WithChildren: 0
}, false, "reactbuild.model.WithChildren", {
  Lreactbuild_model_WithChildren: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_WithChildren.prototype.$classData = $d_Lreactbuild_model_WithChildren;
/** @constructor */
function $c_Lreactbuild_model_process_PartialDate(date) {
  this.Lreactbuild_model_process_PartialDate__f_date = null;
  this.Lreactbuild_model_process_PartialDate__f_date = date
}
$c_Lreactbuild_model_process_PartialDate.prototype = new $h_O();
$c_Lreactbuild_model_process_PartialDate.prototype.constructor = $c_Lreactbuild_model_process_PartialDate;
/** @constructor */
function $h_Lreactbuild_model_process_PartialDate() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_PartialDate.prototype = $c_Lreactbuild_model_process_PartialDate.prototype;
$c_Lreactbuild_model_process_PartialDate.prototype.productPrefix__T = (function() {
  return "PartialDate"
});
$c_Lreactbuild_model_process_PartialDate.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_process_PartialDate.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_process_PartialDate__f_date : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_process_PartialDate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_PartialDate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_PartialDate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_PartialDate.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_PartialDate)) {
    var PartialDate$1 = $as_Lreactbuild_model_process_PartialDate(x$1);
    var x = this.Lreactbuild_model_process_PartialDate__f_date;
    var x$2 = $n(PartialDate$1).Lreactbuild_model_process_PartialDate__f_date;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_PartialDate(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_PartialDate) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.PartialDate"))
}
function $isArrayOf_Lreactbuild_model_process_PartialDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_PartialDate)))
}
function $asArrayOf_Lreactbuild_model_process_PartialDate(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_PartialDate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.PartialDate;", depth))
}
var $d_Lreactbuild_model_process_PartialDate = new $TypeData().initClass({
  Lreactbuild_model_process_PartialDate: 0
}, false, "reactbuild.model.process.PartialDate", {
  Lreactbuild_model_process_PartialDate: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_PartialDate.prototype.$classData = $d_Lreactbuild_model_process_PartialDate;
/** @constructor */
function $c_Lreactbuild_model_process_Process(_id, organization, name, elements) {
  this.Lreactbuild_model_process_Process__f__id = null;
  this.Lreactbuild_model_process_Process__f_organization = null;
  this.Lreactbuild_model_process_Process__f_name = null;
  this.Lreactbuild_model_process_Process__f_elements = null;
  this.Lreactbuild_model_process_Process__f__id = _id;
  this.Lreactbuild_model_process_Process__f_organization = organization;
  this.Lreactbuild_model_process_Process__f_name = name;
  this.Lreactbuild_model_process_Process__f_elements = elements
}
$c_Lreactbuild_model_process_Process.prototype = new $h_O();
$c_Lreactbuild_model_process_Process.prototype.constructor = $c_Lreactbuild_model_process_Process;
/** @constructor */
function $h_Lreactbuild_model_process_Process() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_Process.prototype = $c_Lreactbuild_model_process_Process.prototype;
$c_Lreactbuild_model_process_Process.prototype.productPrefix__T = (function() {
  return "Process"
});
$c_Lreactbuild_model_process_Process.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_model_process_Process.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_process_Process__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_process_Process__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_model_process_Process__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_model_process_Process__f_elements;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_process_Process.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_Process.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_Process.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_Process.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_Process)) {
    var Process$1 = $as_Lreactbuild_model_process_Process(x$1);
    var x = this.Lreactbuild_model_process_Process__f__id;
    var x$2 = $n(Process$1).Lreactbuild_model_process_Process__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_process_Process__f_organization;
      var x$4 = $n(Process$1).Lreactbuild_model_process_Process__f_organization;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_model_process_Process__f_name === $n(Process$1).Lreactbuild_model_process_Process__f_name)) {
        var x$5 = this.Lreactbuild_model_process_Process__f_elements;
        var x$6 = $n(Process$1).Lreactbuild_model_process_Process__f_elements;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_Process(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_Process) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.Process"))
}
function $isArrayOf_Lreactbuild_model_process_Process(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_Process)))
}
function $asArrayOf_Lreactbuild_model_process_Process(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_Process(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.Process;", depth))
}
var $d_Lreactbuild_model_process_Process = new $TypeData().initClass({
  Lreactbuild_model_process_Process: 0
}, false, "reactbuild.model.process.Process", {
  Lreactbuild_model_process_Process: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_Process.prototype.$classData = $d_Lreactbuild_model_process_Process;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2(outer) {
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2__f_circeGenericDecoderForid = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2__f_circeGenericDecoderForname = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2__f_circeGenericDecoderFordetails = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2__f_circeGenericDecoderForid = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2__f_circeGenericDecoderFordetails = $m_Lreactbuild_model_process_ProcessNodeDetails$().Lreactbuild_model_process_ProcessNodeDetails$__f_codecForProcessNodeDetails
}
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2.prototype.constructor = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2.prototype = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2.prototype;
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("details"))), this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2__f_circeGenericDecoderFordetails, "details", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2: 0
}, false, "reactbuild.model.process.ProcessElement$anon$lazy$macro$123$1$$anon$2", {
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2.prototype.$classData = $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3(outer) {
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderForid = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderForname = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderFortargetRef = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderForid = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderFortargetRef = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3.prototype.constructor = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3.prototype = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3.prototype;
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("sourceRef"))), this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderFortargetRef, "sourceRef", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("targetRef"))), this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3__f_circeGenericDecoderFortargetRef, "targetRef", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3: 0
}, false, "reactbuild.model.process.ProcessElement$anon$lazy$macro$123$1$$anon$3", {
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3.prototype.$classData = $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$3;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEvent(_id, parents, user, date, details, instant) {
  this.Lreactbuild_model_process_ProcessInstanceEvent__f__id = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_parents = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_user = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_date = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_details = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_instant = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f__id = _id;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_parents = parents;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_user = user;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_date = date;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_details = details;
  this.Lreactbuild_model_process_ProcessInstanceEvent__f_instant = instant
}
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEvent;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEvent() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEvent.prototype = $c_Lreactbuild_model_process_ProcessInstanceEvent.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype.productPrefix__T = (function() {
  return "ProcessInstanceEvent"
});
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_process_ProcessInstanceEvent__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_process_ProcessInstanceEvent__f_parents;
      break
    }
    case 2: {
      return this.Lreactbuild_model_process_ProcessInstanceEvent__f_user;
      break
    }
    case 3: {
      return this.Lreactbuild_model_process_ProcessInstanceEvent__f_date;
      break
    }
    case 4: {
      return this.Lreactbuild_model_process_ProcessInstanceEvent__f_details;
      break
    }
    case 5: {
      return this.Lreactbuild_model_process_ProcessInstanceEvent__f_instant;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessInstanceEvent)) {
    var ProcessInstanceEvent$1 = $as_Lreactbuild_model_process_ProcessInstanceEvent(x$1);
    var x = this.Lreactbuild_model_process_ProcessInstanceEvent__f__id;
    var x$2 = $n(ProcessInstanceEvent$1).Lreactbuild_model_process_ProcessInstanceEvent__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_process_ProcessInstanceEvent__f_parents;
      var x$4 = $n(ProcessInstanceEvent$1).Lreactbuild_model_process_ProcessInstanceEvent__f_parents;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_model_process_ProcessInstanceEvent__f_user;
        var x$6 = $n(ProcessInstanceEvent$1).Lreactbuild_model_process_ProcessInstanceEvent__f_user;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_model_process_ProcessInstanceEvent__f_date;
      var x$8 = $n(ProcessInstanceEvent$1).Lreactbuild_model_process_ProcessInstanceEvent__f_date;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_model_process_ProcessInstanceEvent__f_details;
        var x$10 = $n(ProcessInstanceEvent$1).Lreactbuild_model_process_ProcessInstanceEvent__f_details;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_model_process_ProcessInstanceEvent__f_instant;
          var x$12 = $n(ProcessInstanceEvent$1).Lreactbuild_model_process_ProcessInstanceEvent__f_instant;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessInstanceEvent(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessInstanceEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessInstanceEvent"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessInstanceEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessInstanceEvent)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessInstanceEvent(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessInstanceEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessInstanceEvent;", depth))
}
var $d_Lreactbuild_model_process_ProcessInstanceEvent = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEvent: 0
}, false, "reactbuild.model.process.ProcessInstanceEvent", {
  Lreactbuild_model_process_ProcessInstanceEvent: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEvent.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEvent;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15__f_circeGenericDecoderForref = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15__f_circeGenericDecoderForvalue = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15__f_circeGenericDecoderForref = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15__f_circeGenericDecoderForvalue = $m_Lreactbuild_model_process_PartialDate$().decodePartialDate__Lio_circe_Decoder()
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("ref"))), this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15__f_circeGenericDecoderForref, "ref", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("value"))), this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15__f_circeGenericDecoderForvalue, "value", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$15;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16__f_circeGenericDecoderFordetails = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16__f_circeGenericDecoderFordetails = $m_Lreactbuild_model_process_ProcessLink$().Lreactbuild_model_process_ProcessLink$__f_codecForProcessLink
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("details"))), this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16__f_circeGenericDecoderFordetails, "details", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$16;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17__f_circeGenericDecoderForprocess = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17__f_circeGenericDecoderForcustomProcessName = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17__f_circeGenericDecoderForprocess = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17__f_circeGenericDecoderForcustomProcessName = new $c_Lio_circe_Decoder$$anon$39(d)
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("process"))), this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17__f_circeGenericDecoderForprocess, "process", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("customProcessName"))), this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17__f_circeGenericDecoderForcustomProcessName, "customProcessName", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$17;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18__f_circeGenericDecoderFornode = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18__f_circeGenericDecoderFornode = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("node"))), this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18__f_circeGenericDecoderFornode, "node", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$18;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19__f_circeGenericDecoderFormessage = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19__f_circeGenericDecoderFormessage = $m_Lcom_iz2use_common_Multiline$().decodeMultiline__Lio_circe_Decoder()
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("message"))), this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19__f_circeGenericDecoderFormessage, "message", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$19;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLink(ref, cls) {
  this.Lreactbuild_model_process_ProcessLink__f_ref = null;
  this.Lreactbuild_model_process_ProcessLink__f_cls = null;
  this.Lreactbuild_model_process_ProcessLink__f_ref = ref;
  this.Lreactbuild_model_process_ProcessLink__f_cls = cls
}
$c_Lreactbuild_model_process_ProcessLink.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessLink.prototype.constructor = $c_Lreactbuild_model_process_ProcessLink;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLink() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLink.prototype = $c_Lreactbuild_model_process_ProcessLink.prototype;
$c_Lreactbuild_model_process_ProcessLink.prototype.productPrefix__T = (function() {
  return "ProcessLink"
});
$c_Lreactbuild_model_process_ProcessLink.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_process_ProcessLink.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_process_ProcessLink__f_ref;
      break
    }
    case 1: {
      return this.Lreactbuild_model_process_ProcessLink__f_cls;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessLink.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessLink.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessLink.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessLink.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessLink)) {
    var ProcessLink$1 = $as_Lreactbuild_model_process_ProcessLink(x$1);
    var x = this.Lreactbuild_model_process_ProcessLink__f_ref;
    var x$2 = $n(ProcessLink$1).Lreactbuild_model_process_ProcessLink__f_ref;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_process_ProcessLink__f_cls;
      var x$4 = $n(ProcessLink$1).Lreactbuild_model_process_ProcessLink__f_cls;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessLink(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessLink) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessLink"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessLink)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessLink(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessLink(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessLink;", depth))
}
var $d_Lreactbuild_model_process_ProcessLink = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLink: 0
}, false, "reactbuild.model.process.ProcessLink", {
  Lreactbuild_model_process_ProcessLink: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessLink.prototype.$classData = $d_Lreactbuild_model_process_ProcessLink;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7(outer) {
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7__f_circeGenericDecoderForperiod = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7__f_circeGenericDecoderForperiod = $m_Lio_circe_Decoder$().decodePeriod__Lio_circe_Decoder()
}
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("period"))), this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7__f_circeGenericDecoderForperiod, "period", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7", {
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_package$PageProps(router, proxy) {
  this.Lreactbuild_package$PageProps__f_router = null;
  this.Lreactbuild_package$PageProps__f_proxy = null;
  this.Lreactbuild_package$PageProps__f_router = router;
  this.Lreactbuild_package$PageProps__f_proxy = proxy
}
$c_Lreactbuild_package$PageProps.prototype = new $h_O();
$c_Lreactbuild_package$PageProps.prototype.constructor = $c_Lreactbuild_package$PageProps;
/** @constructor */
function $h_Lreactbuild_package$PageProps() {
  /*<skip>*/
}
$h_Lreactbuild_package$PageProps.prototype = $c_Lreactbuild_package$PageProps.prototype;
$c_Lreactbuild_package$PageProps.prototype.productPrefix__T = (function() {
  return "PageProps"
});
$c_Lreactbuild_package$PageProps.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_package$PageProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_package$PageProps__f_router;
      break
    }
    case 1: {
      return this.Lreactbuild_package$PageProps__f_proxy;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_package$PageProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_package$PageProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_package$PageProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_package$PageProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_package$PageProps)) {
    var PageProps$1 = $as_Lreactbuild_package$PageProps(x$1);
    var x = this.Lreactbuild_package$PageProps__f_router;
    var x$2 = $n(PageProps$1).Lreactbuild_package$PageProps__f_router;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_package$PageProps__f_proxy;
      var x$4 = $n(PageProps$1).Lreactbuild_package$PageProps__f_proxy;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_package$PageProps(obj) {
  return (((obj instanceof $c_Lreactbuild_package$PageProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.package$PageProps"))
}
function $isArrayOf_Lreactbuild_package$PageProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_package$PageProps)))
}
function $asArrayOf_Lreactbuild_package$PageProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_package$PageProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.package$PageProps;", depth))
}
var $d_Lreactbuild_package$PageProps = new $TypeData().initClass({
  Lreactbuild_package$PageProps: 0
}, false, "reactbuild.package$PageProps", {
  Lreactbuild_package$PageProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_package$PageProps.prototype.$classData = $d_Lreactbuild_package$PageProps;
/** @constructor */
function $c_Lreactbuild_person_AddPersonReference$Props(targets, upsert) {
  this.Lreactbuild_person_AddPersonReference$Props__f_targets = null;
  this.Lreactbuild_person_AddPersonReference$Props__f_upsert = null;
  this.Lreactbuild_person_AddPersonReference$Props__f_targets = targets;
  this.Lreactbuild_person_AddPersonReference$Props__f_upsert = upsert
}
$c_Lreactbuild_person_AddPersonReference$Props.prototype = new $h_O();
$c_Lreactbuild_person_AddPersonReference$Props.prototype.constructor = $c_Lreactbuild_person_AddPersonReference$Props;
/** @constructor */
function $h_Lreactbuild_person_AddPersonReference$Props() {
  /*<skip>*/
}
$h_Lreactbuild_person_AddPersonReference$Props.prototype = $c_Lreactbuild_person_AddPersonReference$Props.prototype;
$c_Lreactbuild_person_AddPersonReference$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_person_AddPersonReference$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_AddPersonReference$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_AddPersonReference$Props__f_targets;
      break
    }
    case 1: {
      return this.Lreactbuild_person_AddPersonReference$Props__f_upsert;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_AddPersonReference$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_AddPersonReference$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_AddPersonReference$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_AddPersonReference$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_AddPersonReference$Props)) {
    var Props$1 = $as_Lreactbuild_person_AddPersonReference$Props(x$1);
    var x = this.Lreactbuild_person_AddPersonReference$Props__f_targets;
    var x$2 = $n(Props$1).Lreactbuild_person_AddPersonReference$Props__f_targets;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_AddPersonReference$Props__f_upsert;
      var x$4 = $n(Props$1).Lreactbuild_person_AddPersonReference$Props__f_upsert;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_AddPersonReference$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_person_AddPersonReference$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.AddPersonReference$Props"))
}
function $isArrayOf_Lreactbuild_person_AddPersonReference$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_AddPersonReference$Props)))
}
function $asArrayOf_Lreactbuild_person_AddPersonReference$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_AddPersonReference$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.AddPersonReference$Props;", depth))
}
var $d_Lreactbuild_person_AddPersonReference$Props = new $TypeData().initClass({
  Lreactbuild_person_AddPersonReference$Props: 0
}, false, "reactbuild.person.AddPersonReference$Props", {
  Lreactbuild_person_AddPersonReference$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_AddPersonReference$Props.prototype.$classData = $d_Lreactbuild_person_AddPersonReference$Props;
/** @constructor */
function $c_Lreactbuild_person_Address(id, details, usage) {
  this.Lreactbuild_person_Address__f_id = null;
  this.Lreactbuild_person_Address__f_details = null;
  this.Lreactbuild_person_Address__f_usage = null;
  this.Lreactbuild_person_Address__f_id = id;
  this.Lreactbuild_person_Address__f_details = details;
  this.Lreactbuild_person_Address__f_usage = usage
}
$c_Lreactbuild_person_Address.prototype = new $h_O();
$c_Lreactbuild_person_Address.prototype.constructor = $c_Lreactbuild_person_Address;
/** @constructor */
function $h_Lreactbuild_person_Address() {
  /*<skip>*/
}
$h_Lreactbuild_person_Address.prototype = $c_Lreactbuild_person_Address.prototype;
$c_Lreactbuild_person_Address.prototype.productPrefix__T = (function() {
  return "Address"
});
$c_Lreactbuild_person_Address.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_person_Address.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_Address__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_person_Address__f_details;
      break
    }
    case 2: {
      return this.Lreactbuild_person_Address__f_usage;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_Address.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Address.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_Address.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Address.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Address)) {
    var Address$1 = $as_Lreactbuild_person_Address(x$1);
    var x = this.Lreactbuild_person_Address__f_id;
    var x$2 = $n(Address$1).Lreactbuild_person_Address__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_Address__f_details;
      var x$4 = $n(Address$1).Lreactbuild_person_Address__f_details;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_person_Address__f_usage;
        var x$6 = $n(Address$1).Lreactbuild_person_Address__f_usage;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Address(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Address) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Address"))
}
function $isArrayOf_Lreactbuild_person_Address(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Address)))
}
function $asArrayOf_Lreactbuild_person_Address(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Address(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Address;", depth))
}
var $d_Lreactbuild_person_Address = new $TypeData().initClass({
  Lreactbuild_person_Address: 0
}, false, "reactbuild.person.Address", {
  Lreactbuild_person_Address: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Address.prototype.$classData = $d_Lreactbuild_person_Address;
/** @constructor */
function $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6(outer) {
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6__f_circeGenericDecoderForurl = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6__f_circeGenericDecoderForcredentials = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6__f_circeGenericDecoderForurl = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_person_Credential$().Lreactbuild_person_Credential$__f_codecForCredential;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6__f_circeGenericDecoderForcredentials = new $c_Lio_circe_Decoder$$anon$42(decodeA)
}
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6.prototype.constructor = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6.prototype = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6.prototype;
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("url"))), this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6__f_circeGenericDecoderForurl, "url", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("credentials"))), this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6__f_circeGenericDecoderForcredentials, "credentials", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6: 0
}, false, "reactbuild.person.AddressDetails$anon$lazy$macro$91$1$$anon$6", {
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6.prototype.$classData = $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7(outer) {
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7__f_circeGenericDecoderForcity = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7__f_circeGenericDecoderForcity = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7.prototype.constructor = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7.prototype = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7.prototype;
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("street"))), this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7__f_circeGenericDecoderForcity, "street", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("postalCode"))), this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7__f_circeGenericDecoderForcity, "postalCode", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("city"))), this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7__f_circeGenericDecoderForcity, "city", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7: 0
}, false, "reactbuild.person.AddressDetails$anon$lazy$macro$91$1$$anon$7", {
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7.prototype.$classData = $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_person_BoundedField(bounds) {
  this.Lreactbuild_person_BoundedField__f_bounds = null;
  this.Lreactbuild_person_BoundedField__f_bounds = bounds
}
$c_Lreactbuild_person_BoundedField.prototype = new $h_O();
$c_Lreactbuild_person_BoundedField.prototype.constructor = $c_Lreactbuild_person_BoundedField;
/** @constructor */
function $h_Lreactbuild_person_BoundedField() {
  /*<skip>*/
}
$h_Lreactbuild_person_BoundedField.prototype = $c_Lreactbuild_person_BoundedField.prototype;
$c_Lreactbuild_person_BoundedField.prototype.productPrefix__T = (function() {
  return "BoundedField"
});
$c_Lreactbuild_person_BoundedField.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_BoundedField.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_BoundedField__f_bounds : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_BoundedField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_BoundedField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_BoundedField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_BoundedField.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_BoundedField)) {
    var BoundedField$1 = $as_Lreactbuild_person_BoundedField(x$1);
    var x = this.Lreactbuild_person_BoundedField__f_bounds;
    var x$2 = $n(BoundedField$1).Lreactbuild_person_BoundedField__f_bounds;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_BoundedField(obj) {
  return (((obj instanceof $c_Lreactbuild_person_BoundedField) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.BoundedField"))
}
function $isArrayOf_Lreactbuild_person_BoundedField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_BoundedField)))
}
function $asArrayOf_Lreactbuild_person_BoundedField(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_BoundedField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.BoundedField;", depth))
}
var $d_Lreactbuild_person_BoundedField = new $TypeData().initClass({
  Lreactbuild_person_BoundedField: 0
}, false, "reactbuild.person.BoundedField", {
  Lreactbuild_person_BoundedField: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_BoundedField.prototype.$classData = $d_Lreactbuild_person_BoundedField;
/** @constructor */
function $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6(outer) {
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6__f_circeGenericDecoderForbounds = null;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6__f_circeGenericDecoderForbounds = $n(outer).Lreactbuild_person_BoundedField$anon$lazy$macro$11$3__f_decB$1
}
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6.prototype.constructor = $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6;
/** @constructor */
function $h_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6.prototype = $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6.prototype;
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("bounds"))), this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6__f_circeGenericDecoderForbounds, "bounds", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6 = new $TypeData().initClass({
  Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6: 0
}, false, "reactbuild.person.BoundedField$anon$lazy$macro$11$3$$anon$6", {
  Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6.prototype.$classData = $d_Lreactbuild_person_BoundedField$anon$lazy$macro$11$3$$anon$6;
/** @constructor */
function $c_Lreactbuild_person_CachedQuantifiedExpression(cache, expression) {
  this.Lreactbuild_person_CachedQuantifiedExpression__f_cache = 0.0;
  this.Lreactbuild_person_CachedQuantifiedExpression__f_expression = null;
  this.Lreactbuild_person_CachedQuantifiedExpression__f_cache = cache;
  this.Lreactbuild_person_CachedQuantifiedExpression__f_expression = expression
}
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype = new $h_O();
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype.constructor = $c_Lreactbuild_person_CachedQuantifiedExpression;
/** @constructor */
function $h_Lreactbuild_person_CachedQuantifiedExpression() {
  /*<skip>*/
}
$h_Lreactbuild_person_CachedQuantifiedExpression.prototype = $c_Lreactbuild_person_CachedQuantifiedExpression.prototype;
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype.productPrefix__T = (function() {
  return "CachedQuantifiedExpression"
});
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_CachedQuantifiedExpression__f_cache;
      break
    }
    case 1: {
      return this.Lreactbuild_person_CachedQuantifiedExpression__f_expression;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("CachedQuantifiedExpression");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_person_CachedQuantifiedExpression__f_cache;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_person_CachedQuantifiedExpression__f_expression;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_CachedQuantifiedExpression)) {
    var CachedQuantifiedExpression$1 = $as_Lreactbuild_person_CachedQuantifiedExpression(x$1);
    if ((this.Lreactbuild_person_CachedQuantifiedExpression__f_cache === $n(CachedQuantifiedExpression$1).Lreactbuild_person_CachedQuantifiedExpression__f_cache)) {
      var x = this.Lreactbuild_person_CachedQuantifiedExpression__f_expression;
      var x$2 = $n(CachedQuantifiedExpression$1).Lreactbuild_person_CachedQuantifiedExpression__f_expression;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_CachedQuantifiedExpression(obj) {
  return (((obj instanceof $c_Lreactbuild_person_CachedQuantifiedExpression) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.CachedQuantifiedExpression"))
}
function $isArrayOf_Lreactbuild_person_CachedQuantifiedExpression(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_CachedQuantifiedExpression)))
}
function $asArrayOf_Lreactbuild_person_CachedQuantifiedExpression(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_CachedQuantifiedExpression(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.CachedQuantifiedExpression;", depth))
}
var $d_Lreactbuild_person_CachedQuantifiedExpression = new $TypeData().initClass({
  Lreactbuild_person_CachedQuantifiedExpression: 0
}, false, "reactbuild.person.CachedQuantifiedExpression", {
  Lreactbuild_person_CachedQuantifiedExpression: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CachedQuantifiedExpression.prototype.$classData = $d_Lreactbuild_person_CachedQuantifiedExpression;
/** @constructor */
function $c_Lreactbuild_person_Credential(name, data) {
  this.Lreactbuild_person_Credential__f_name = null;
  this.Lreactbuild_person_Credential__f_data = null;
  this.Lreactbuild_person_Credential__f_name = name;
  this.Lreactbuild_person_Credential__f_data = data
}
$c_Lreactbuild_person_Credential.prototype = new $h_O();
$c_Lreactbuild_person_Credential.prototype.constructor = $c_Lreactbuild_person_Credential;
/** @constructor */
function $h_Lreactbuild_person_Credential() {
  /*<skip>*/
}
$h_Lreactbuild_person_Credential.prototype = $c_Lreactbuild_person_Credential.prototype;
$c_Lreactbuild_person_Credential.prototype.productPrefix__T = (function() {
  return "Credential"
});
$c_Lreactbuild_person_Credential.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_Credential.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_Credential__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_person_Credential__f_data;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_Credential.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Credential.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_Credential.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Credential.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Credential)) {
    var Credential$1 = $as_Lreactbuild_person_Credential(x$1);
    if ((this.Lreactbuild_person_Credential__f_name === $n(Credential$1).Lreactbuild_person_Credential__f_name)) {
      var x = this.Lreactbuild_person_Credential__f_data;
      var x$2 = $n(Credential$1).Lreactbuild_person_Credential__f_data;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Credential(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Credential) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Credential"))
}
function $isArrayOf_Lreactbuild_person_Credential(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Credential)))
}
function $asArrayOf_Lreactbuild_person_Credential(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Credential(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Credential;", depth))
}
var $d_Lreactbuild_person_Credential = new $TypeData().initClass({
  Lreactbuild_person_Credential: 0
}, false, "reactbuild.person.Credential", {
  Lreactbuild_person_Credential: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Credential.prototype.$classData = $d_Lreactbuild_person_Credential;
/** @constructor */
function $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2(outer) {
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2__f_circeGenericDecoderForpassword = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_model_PasswordCrossImpl$().decodePassword__Lio_circe_Decoder();
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2__f_circeGenericDecoderForpassword = new $c_Lio_circe_Decoder$$anon$39(d)
}
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2.prototype.constructor = $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2.prototype = $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2.prototype;
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("password"))), this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2__f_circeGenericDecoderForpassword, "password", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2: 0
}, false, "reactbuild.person.CredentialData$anon$lazy$macro$23$1$$anon$2", {
  Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2.prototype.$classData = $d_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_person_DeliveryHeaderFormat(date, supplierReference, reference) {
  this.Lreactbuild_person_DeliveryHeaderFormat__f_date = null;
  this.Lreactbuild_person_DeliveryHeaderFormat__f_supplierReference = null;
  this.Lreactbuild_person_DeliveryHeaderFormat__f_reference = null;
  this.Lreactbuild_person_DeliveryHeaderFormat__f_date = date;
  this.Lreactbuild_person_DeliveryHeaderFormat__f_supplierReference = supplierReference;
  this.Lreactbuild_person_DeliveryHeaderFormat__f_reference = reference
}
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype = new $h_O();
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype.constructor = $c_Lreactbuild_person_DeliveryHeaderFormat;
/** @constructor */
function $h_Lreactbuild_person_DeliveryHeaderFormat() {
  /*<skip>*/
}
$h_Lreactbuild_person_DeliveryHeaderFormat.prototype = $c_Lreactbuild_person_DeliveryHeaderFormat.prototype;
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype.productPrefix__T = (function() {
  return "DeliveryHeaderFormat"
});
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_DeliveryHeaderFormat__f_date;
      break
    }
    case 1: {
      return this.Lreactbuild_person_DeliveryHeaderFormat__f_supplierReference;
      break
    }
    case 2: {
      return this.Lreactbuild_person_DeliveryHeaderFormat__f_reference;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_DeliveryHeaderFormat)) {
    var DeliveryHeaderFormat$1 = $as_Lreactbuild_person_DeliveryHeaderFormat(x$1);
    var x = this.Lreactbuild_person_DeliveryHeaderFormat__f_date;
    var x$2 = $n(DeliveryHeaderFormat$1).Lreactbuild_person_DeliveryHeaderFormat__f_date;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_DeliveryHeaderFormat__f_supplierReference;
      var x$4 = $n(DeliveryHeaderFormat$1).Lreactbuild_person_DeliveryHeaderFormat__f_supplierReference;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_person_DeliveryHeaderFormat__f_reference;
        var x$6 = $n(DeliveryHeaderFormat$1).Lreactbuild_person_DeliveryHeaderFormat__f_reference;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_DeliveryHeaderFormat(obj) {
  return (((obj instanceof $c_Lreactbuild_person_DeliveryHeaderFormat) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.DeliveryHeaderFormat"))
}
function $isArrayOf_Lreactbuild_person_DeliveryHeaderFormat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_DeliveryHeaderFormat)))
}
function $asArrayOf_Lreactbuild_person_DeliveryHeaderFormat(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_DeliveryHeaderFormat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.DeliveryHeaderFormat;", depth))
}
var $d_Lreactbuild_person_DeliveryHeaderFormat = new $TypeData().initClass({
  Lreactbuild_person_DeliveryHeaderFormat: 0
}, false, "reactbuild.person.DeliveryHeaderFormat", {
  Lreactbuild_person_DeliveryHeaderFormat: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DeliveryHeaderFormat.prototype.$classData = $d_Lreactbuild_person_DeliveryHeaderFormat;
/** @constructor */
function $c_Lreactbuild_person_DocumentFieldLevel(reference, netAmount, taxAmount, totalAmount, date, target, category) {
  this.Lreactbuild_person_DocumentFieldLevel__f_reference = null;
  this.Lreactbuild_person_DocumentFieldLevel__f_netAmount = null;
  this.Lreactbuild_person_DocumentFieldLevel__f_taxAmount = null;
  this.Lreactbuild_person_DocumentFieldLevel__f_totalAmount = null;
  this.Lreactbuild_person_DocumentFieldLevel__f_date = null;
  this.Lreactbuild_person_DocumentFieldLevel__f_target = null;
  this.Lreactbuild_person_DocumentFieldLevel__f_category = null;
  this.Lreactbuild_person_DocumentFieldLevel__f_reference = reference;
  this.Lreactbuild_person_DocumentFieldLevel__f_netAmount = netAmount;
  this.Lreactbuild_person_DocumentFieldLevel__f_taxAmount = taxAmount;
  this.Lreactbuild_person_DocumentFieldLevel__f_totalAmount = totalAmount;
  this.Lreactbuild_person_DocumentFieldLevel__f_date = date;
  this.Lreactbuild_person_DocumentFieldLevel__f_target = target;
  this.Lreactbuild_person_DocumentFieldLevel__f_category = category
}
$c_Lreactbuild_person_DocumentFieldLevel.prototype = new $h_O();
$c_Lreactbuild_person_DocumentFieldLevel.prototype.constructor = $c_Lreactbuild_person_DocumentFieldLevel;
/** @constructor */
function $h_Lreactbuild_person_DocumentFieldLevel() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentFieldLevel.prototype = $c_Lreactbuild_person_DocumentFieldLevel.prototype;
$c_Lreactbuild_person_DocumentFieldLevel.prototype.productPrefix__T = (function() {
  return "DocumentFieldLevel"
});
$c_Lreactbuild_person_DocumentFieldLevel.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_person_DocumentFieldLevel.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_DocumentFieldLevel__f_reference;
      break
    }
    case 1: {
      return this.Lreactbuild_person_DocumentFieldLevel__f_netAmount;
      break
    }
    case 2: {
      return this.Lreactbuild_person_DocumentFieldLevel__f_taxAmount;
      break
    }
    case 3: {
      return this.Lreactbuild_person_DocumentFieldLevel__f_totalAmount;
      break
    }
    case 4: {
      return this.Lreactbuild_person_DocumentFieldLevel__f_date;
      break
    }
    case 5: {
      return this.Lreactbuild_person_DocumentFieldLevel__f_target;
      break
    }
    case 6: {
      return this.Lreactbuild_person_DocumentFieldLevel__f_category;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_DocumentFieldLevel.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_DocumentFieldLevel.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_DocumentFieldLevel.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_DocumentFieldLevel.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_DocumentFieldLevel)) {
    var DocumentFieldLevel$1 = $as_Lreactbuild_person_DocumentFieldLevel(x$1);
    var x = this.Lreactbuild_person_DocumentFieldLevel__f_reference;
    var x$2 = $n(DocumentFieldLevel$1).Lreactbuild_person_DocumentFieldLevel__f_reference;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_DocumentFieldLevel__f_netAmount;
      var x$4 = $n(DocumentFieldLevel$1).Lreactbuild_person_DocumentFieldLevel__f_netAmount;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_person_DocumentFieldLevel__f_taxAmount;
        var x$6 = $n(DocumentFieldLevel$1).Lreactbuild_person_DocumentFieldLevel__f_taxAmount;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_person_DocumentFieldLevel__f_totalAmount;
      var x$8 = $n(DocumentFieldLevel$1).Lreactbuild_person_DocumentFieldLevel__f_totalAmount;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_person_DocumentFieldLevel__f_date;
        var x$10 = $n(DocumentFieldLevel$1).Lreactbuild_person_DocumentFieldLevel__f_date;
        var $$x2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$11 = this.Lreactbuild_person_DocumentFieldLevel__f_target;
        var x$12 = $n(DocumentFieldLevel$1).Lreactbuild_person_DocumentFieldLevel__f_target;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_person_DocumentFieldLevel__f_category;
          var x$14 = $n(DocumentFieldLevel$1).Lreactbuild_person_DocumentFieldLevel__f_category;
          return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_DocumentFieldLevel(obj) {
  return (((obj instanceof $c_Lreactbuild_person_DocumentFieldLevel) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.DocumentFieldLevel"))
}
function $isArrayOf_Lreactbuild_person_DocumentFieldLevel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_DocumentFieldLevel)))
}
function $asArrayOf_Lreactbuild_person_DocumentFieldLevel(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_DocumentFieldLevel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.DocumentFieldLevel;", depth))
}
var $d_Lreactbuild_person_DocumentFieldLevel = new $TypeData().initClass({
  Lreactbuild_person_DocumentFieldLevel: 0
}, false, "reactbuild.person.DocumentFieldLevel", {
  Lreactbuild_person_DocumentFieldLevel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentFieldLevel.prototype.$classData = $d_Lreactbuild_person_DocumentFieldLevel;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserArea(left, top, width, height, id, name, columns) {
  this.Lreactbuild_person_DocumentParserArea__f_left = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_top = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_width = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_height = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_id = null;
  this.Lreactbuild_person_DocumentParserArea__f_name = null;
  this.Lreactbuild_person_DocumentParserArea__f_columns = null;
  this.Lreactbuild_person_DocumentParserArea__f_halfWidth = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_halfHeight = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_centerX = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_centerY = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_right = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_bottom = 0.0;
  this.Lreactbuild_person_DocumentParserArea__f_left = left;
  this.Lreactbuild_person_DocumentParserArea__f_top = top;
  this.Lreactbuild_person_DocumentParserArea__f_width = width;
  this.Lreactbuild_person_DocumentParserArea__f_height = height;
  this.Lreactbuild_person_DocumentParserArea__f_id = id;
  this.Lreactbuild_person_DocumentParserArea__f_name = name;
  this.Lreactbuild_person_DocumentParserArea__f_columns = columns;
  this.Lreactbuild_person_DocumentParserArea__f_halfWidth = (width / 2.0);
  this.Lreactbuild_person_DocumentParserArea__f_halfHeight = (height / 2.0);
  this.Lreactbuild_person_DocumentParserArea__f_centerX = (left + this.Lreactbuild_person_DocumentParserArea__f_halfWidth);
  this.Lreactbuild_person_DocumentParserArea__f_centerY = (top + this.Lreactbuild_person_DocumentParserArea__f_halfHeight);
  this.Lreactbuild_person_DocumentParserArea__f_right = (left + width);
  this.Lreactbuild_person_DocumentParserArea__f_bottom = (top + height)
}
$c_Lreactbuild_person_DocumentParserArea.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserArea.prototype.constructor = $c_Lreactbuild_person_DocumentParserArea;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserArea() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserArea.prototype = $c_Lreactbuild_person_DocumentParserArea.prototype;
$c_Lreactbuild_person_DocumentParserArea.prototype.productPrefix__T = (function() {
  return "DocumentParserArea"
});
$c_Lreactbuild_person_DocumentParserArea.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_person_DocumentParserArea.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_DocumentParserArea__f_left;
      break
    }
    case 1: {
      return this.Lreactbuild_person_DocumentParserArea__f_top;
      break
    }
    case 2: {
      return this.Lreactbuild_person_DocumentParserArea__f_width;
      break
    }
    case 3: {
      return this.Lreactbuild_person_DocumentParserArea__f_height;
      break
    }
    case 4: {
      return this.Lreactbuild_person_DocumentParserArea__f_id;
      break
    }
    case 5: {
      return this.Lreactbuild_person_DocumentParserArea__f_name;
      break
    }
    case 6: {
      return this.Lreactbuild_person_DocumentParserArea__f_columns;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_DocumentParserArea.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_DocumentParserArea.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DocumentParserArea");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_person_DocumentParserArea__f_left;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_person_DocumentParserArea__f_top;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$2 = this.Lreactbuild_person_DocumentParserArea__f_width;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$3 = this.Lreactbuild_person_DocumentParserArea__f_height;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x = this.Lreactbuild_person_DocumentParserArea__f_id;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$1 = this.Lreactbuild_person_DocumentParserArea__f_name;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$2 = this.Lreactbuild_person_DocumentParserArea__f_columns;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lreactbuild_person_DocumentParserArea.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_DocumentParserArea.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_DocumentParserArea)) {
    var DocumentParserArea$1 = $as_Lreactbuild_person_DocumentParserArea(x$1);
    if (((this.Lreactbuild_person_DocumentParserArea__f_left === $n(DocumentParserArea$1).Lreactbuild_person_DocumentParserArea__f_left) && ((this.Lreactbuild_person_DocumentParserArea__f_top === $n(DocumentParserArea$1).Lreactbuild_person_DocumentParserArea__f_top) && (this.Lreactbuild_person_DocumentParserArea__f_width === $n(DocumentParserArea$1).Lreactbuild_person_DocumentParserArea__f_width)))) {
      if ((this.Lreactbuild_person_DocumentParserArea__f_height === $n(DocumentParserArea$1).Lreactbuild_person_DocumentParserArea__f_height)) {
        var x = this.Lreactbuild_person_DocumentParserArea__f_id;
        var x$2 = $n(DocumentParserArea$1).Lreactbuild_person_DocumentParserArea__f_id;
        var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        if ((this.Lreactbuild_person_DocumentParserArea__f_name === $n(DocumentParserArea$1).Lreactbuild_person_DocumentParserArea__f_name)) {
          var x$3 = this.Lreactbuild_person_DocumentParserArea__f_columns;
          var x$4 = $n(DocumentParserArea$1).Lreactbuild_person_DocumentParserArea__f_columns;
          return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_DocumentParserArea(obj) {
  return (((obj instanceof $c_Lreactbuild_person_DocumentParserArea) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.DocumentParserArea"))
}
function $isArrayOf_Lreactbuild_person_DocumentParserArea(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_DocumentParserArea)))
}
function $asArrayOf_Lreactbuild_person_DocumentParserArea(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_DocumentParserArea(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.DocumentParserArea;", depth))
}
var $d_Lreactbuild_person_DocumentParserArea = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserArea: 0
}, false, "reactbuild.person.DocumentParserArea", {
  Lreactbuild_person_DocumentParserArea: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserArea.prototype.$classData = $d_Lreactbuild_person_DocumentParserArea;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserColumn(width, id, name) {
  this.Lreactbuild_person_DocumentParserColumn__f_width = 0.0;
  this.Lreactbuild_person_DocumentParserColumn__f_id = null;
  this.Lreactbuild_person_DocumentParserColumn__f_name = null;
  this.Lreactbuild_person_DocumentParserColumn__f_width = width;
  this.Lreactbuild_person_DocumentParserColumn__f_id = id;
  this.Lreactbuild_person_DocumentParserColumn__f_name = name
}
$c_Lreactbuild_person_DocumentParserColumn.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserColumn.prototype.constructor = $c_Lreactbuild_person_DocumentParserColumn;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserColumn() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserColumn.prototype = $c_Lreactbuild_person_DocumentParserColumn.prototype;
$c_Lreactbuild_person_DocumentParserColumn.prototype.productPrefix__T = (function() {
  return "DocumentParserColumn"
});
$c_Lreactbuild_person_DocumentParserColumn.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_person_DocumentParserColumn.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_DocumentParserColumn__f_width;
      break
    }
    case 1: {
      return this.Lreactbuild_person_DocumentParserColumn__f_id;
      break
    }
    case 2: {
      return this.Lreactbuild_person_DocumentParserColumn__f_name;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_DocumentParserColumn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_DocumentParserColumn.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DocumentParserColumn");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_person_DocumentParserColumn__f_width;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_person_DocumentParserColumn__f_id;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_person_DocumentParserColumn__f_name;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_person_DocumentParserColumn.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_DocumentParserColumn.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_DocumentParserColumn)) {
    var DocumentParserColumn$1 = $as_Lreactbuild_person_DocumentParserColumn(x$1);
    if ((this.Lreactbuild_person_DocumentParserColumn__f_width === $n(DocumentParserColumn$1).Lreactbuild_person_DocumentParserColumn__f_width)) {
      var x = this.Lreactbuild_person_DocumentParserColumn__f_id;
      var x$2 = $n(DocumentParserColumn$1).Lreactbuild_person_DocumentParserColumn__f_id;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        return (this.Lreactbuild_person_DocumentParserColumn__f_name === $n(DocumentParserColumn$1).Lreactbuild_person_DocumentParserColumn__f_name)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_DocumentParserColumn(obj) {
  return (((obj instanceof $c_Lreactbuild_person_DocumentParserColumn) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.DocumentParserColumn"))
}
function $isArrayOf_Lreactbuild_person_DocumentParserColumn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_DocumentParserColumn)))
}
function $asArrayOf_Lreactbuild_person_DocumentParserColumn(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_DocumentParserColumn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.DocumentParserColumn;", depth))
}
var $d_Lreactbuild_person_DocumentParserColumn = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserColumn: 0
}, false, "reactbuild.person.DocumentParserColumn", {
  Lreactbuild_person_DocumentParserColumn: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserColumn.prototype.$classData = $d_Lreactbuild_person_DocumentParserColumn;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11(outer) {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderFordocumentFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderFortable = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderFordeliveryHeader = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderForrowFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderFordocumentFieldLevel = $m_Lreactbuild_person_DocumentFieldLevel$().Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderFortable = $m_Lreactbuild_person_VerticalInterval$().Lreactbuild_person_VerticalInterval$__f_codecForVerticalInterval;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderFordeliveryHeader = $m_Lreactbuild_person_DeliveryHeaderFormat$().Lreactbuild_person_DeliveryHeaderFormat$__f_codecForDeliveryHeaderFormat;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderForrowFieldLevel = $m_Lreactbuild_person_RowFieldLevel$().Lreactbuild_person_RowFieldLevel$__f_codecForRowFieldLevel
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("documentFieldLevel"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderFordocumentFieldLevel, "documentFieldLevel", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("table"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderFortable, "table", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("deliveryHeader"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderFordeliveryHeader, "deliveryHeader", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("rowFieldLevel"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11__f_circeGenericDecoderForrowFieldLevel, "rowFieldLevel", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1$$anon$11", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$11;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12(outer) {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12__f_circeGenericDecoderFordocumentFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12__f_circeGenericDecoderFortable = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12__f_circeGenericDecoderForrowFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12__f_circeGenericDecoderFordocumentFieldLevel = $m_Lreactbuild_person_DocumentFieldLevel$().Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12__f_circeGenericDecoderFortable = $m_Lreactbuild_person_VerticalInterval$().Lreactbuild_person_VerticalInterval$__f_codecForVerticalInterval;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12__f_circeGenericDecoderForrowFieldLevel = $m_Lreactbuild_person_RowFieldLevel$().Lreactbuild_person_RowFieldLevel$__f_codecForRowFieldLevel
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("documentFieldLevel"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12__f_circeGenericDecoderFordocumentFieldLevel, "documentFieldLevel", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("table"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12__f_circeGenericDecoderFortable, "table", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("rowFieldLevel"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12__f_circeGenericDecoderForrowFieldLevel, "rowFieldLevel", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1$$anon$12", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$12;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13(outer) {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13__f_circeGenericDecoderFordocumentFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13__f_circeGenericDecoderForproject = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13__f_circeGenericDecoderFordocumentFieldLevel = $m_Lreactbuild_person_DocumentFieldLevel$().Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13__f_circeGenericDecoderForproject = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle)
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("documentFieldLevel"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13__f_circeGenericDecoderFordocumentFieldLevel, "documentFieldLevel", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("project"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13__f_circeGenericDecoderForproject, "project", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1$$anon$13", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$13;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14(outer) {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14__f_circeGenericDecoderFordocumentFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14__f_circeGenericDecoderFordocumentFieldLevel = $m_Lreactbuild_person_DocumentFieldLevel$().Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("documentFieldLevel"))), this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14__f_circeGenericDecoderFordocumentFieldLevel, "documentFieldLevel", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1$$anon$14", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$14;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserSettings(formats) {
  this.Lreactbuild_person_DocumentParserSettings__f_formats = null;
  this.Lreactbuild_person_DocumentParserSettings__f_formats = formats
}
$c_Lreactbuild_person_DocumentParserSettings.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserSettings.prototype.constructor = $c_Lreactbuild_person_DocumentParserSettings;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserSettings() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserSettings.prototype = $c_Lreactbuild_person_DocumentParserSettings.prototype;
$c_Lreactbuild_person_DocumentParserSettings.prototype.productPrefix__T = (function() {
  return "DocumentParserSettings"
});
$c_Lreactbuild_person_DocumentParserSettings.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_DocumentParserSettings.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_DocumentParserSettings__f_formats : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_DocumentParserSettings.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_DocumentParserSettings.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_DocumentParserSettings.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_DocumentParserSettings.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_DocumentParserSettings)) {
    var DocumentParserSettings$1 = $as_Lreactbuild_person_DocumentParserSettings(x$1);
    var x = this.Lreactbuild_person_DocumentParserSettings__f_formats;
    var x$2 = $n(DocumentParserSettings$1).Lreactbuild_person_DocumentParserSettings__f_formats;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_DocumentParserSettings(obj) {
  return (((obj instanceof $c_Lreactbuild_person_DocumentParserSettings) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.DocumentParserSettings"))
}
function $isArrayOf_Lreactbuild_person_DocumentParserSettings(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_DocumentParserSettings)))
}
function $asArrayOf_Lreactbuild_person_DocumentParserSettings(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_DocumentParserSettings(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.DocumentParserSettings;", depth))
}
var $d_Lreactbuild_person_DocumentParserSettings = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserSettings: 0
}, false, "reactbuild.person.DocumentParserSettings", {
  Lreactbuild_person_DocumentParserSettings: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserSettings.prototype.$classData = $d_Lreactbuild_person_DocumentParserSettings;
function $is_Lreactbuild_person_Facet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lreactbuild_person_Facet)))
}
function $as_Lreactbuild_person_Facet(obj) {
  return (($is_Lreactbuild_person_Facet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Facet"))
}
function $isArrayOf_Lreactbuild_person_Facet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Facet)))
}
function $asArrayOf_Lreactbuild_person_Facet(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Facet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Facet;", depth))
}
/** @constructor */
function $c_Lreactbuild_person_Facets(facets) {
  this.Lreactbuild_person_Facets__f_facets = null;
  this.Lreactbuild_person_Facets__f_facets = facets
}
$c_Lreactbuild_person_Facets.prototype = new $h_O();
$c_Lreactbuild_person_Facets.prototype.constructor = $c_Lreactbuild_person_Facets;
/** @constructor */
function $h_Lreactbuild_person_Facets() {
  /*<skip>*/
}
$h_Lreactbuild_person_Facets.prototype = $c_Lreactbuild_person_Facets.prototype;
$c_Lreactbuild_person_Facets.prototype.$plus__Lreactbuild_person_Facet__s_reflect_ClassTag__Lreactbuild_person_Facets = (function(facet, ev) {
  var $$x1 = this.Lreactbuild_person_Facets__f_facets;
  var self = $m_Lreactbuild_person_FacetRegistry$().nameOf__s_reflect_ClassTag__T(ev);
  var facets = $as_sci_Map($n($$x1).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self, facet)));
  return new $c_Lreactbuild_person_Facets(facets)
});
$c_Lreactbuild_person_Facets.prototype.updated__F1__s_reflect_ClassTag__Lreactbuild_person_Facets = (function(f, ev) {
  var facets = $as_sci_Map($n(this.Lreactbuild_person_Facets__f_facets).updated__O__O__sci_MapOps($m_Lreactbuild_person_FacetRegistry$().nameOf__s_reflect_ClassTag__T(ev), $n(f).apply__O__O($as_Lreactbuild_person_Facet($n(this.Lreactbuild_person_Facets__f_facets).apply__O__O($m_Lreactbuild_person_FacetRegistry$().nameOf__s_reflect_ClassTag__T(ev))))));
  return new $c_Lreactbuild_person_Facets(facets)
});
$c_Lreactbuild_person_Facets.prototype.get__s_reflect_ClassTag__s_Option = (function(ev) {
  return $n(this.Lreactbuild_person_Facets__f_facets).get__O__s_Option($m_Lreactbuild_person_FacetRegistry$().nameOf__s_reflect_ClassTag__T(ev))
});
$c_Lreactbuild_person_Facets.prototype.productPrefix__T = (function() {
  return "Facets"
});
$c_Lreactbuild_person_Facets.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_Facets.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_Facets__f_facets : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_Facets.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Facets.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_Facets.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Facets.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Facets)) {
    var Facets$1 = $as_Lreactbuild_person_Facets(x$1);
    var x = this.Lreactbuild_person_Facets__f_facets;
    var x$2 = $n(Facets$1).Lreactbuild_person_Facets__f_facets;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Facets(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Facets) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Facets"))
}
function $isArrayOf_Lreactbuild_person_Facets(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Facets)))
}
function $asArrayOf_Lreactbuild_person_Facets(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Facets(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Facets;", depth))
}
var $d_Lreactbuild_person_Facets = new $TypeData().initClass({
  Lreactbuild_person_Facets: 0
}, false, "reactbuild.person.Facets", {
  Lreactbuild_person_Facets: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Facets.prototype.$classData = $d_Lreactbuild_person_Facets;
/** @constructor */
function $c_Lreactbuild_person_IsFacet(cls, classTag, encoder, decoder) {
  this.Lreactbuild_person_IsFacet__f_cls = null;
  this.Lreactbuild_person_IsFacet__f_classTag = null;
  this.Lreactbuild_person_IsFacet__f_encoder = null;
  this.Lreactbuild_person_IsFacet__f_decoder = null;
  this.Lreactbuild_person_IsFacet__f_name = null;
  this.Lreactbuild_person_IsFacet__f_cls = cls;
  this.Lreactbuild_person_IsFacet__f_classTag = classTag;
  this.Lreactbuild_person_IsFacet__f_encoder = encoder;
  this.Lreactbuild_person_IsFacet__f_decoder = decoder;
  this.Lreactbuild_person_IsFacet__f_name = $n(cls).getSimpleName__T()
}
$c_Lreactbuild_person_IsFacet.prototype = new $h_O();
$c_Lreactbuild_person_IsFacet.prototype.constructor = $c_Lreactbuild_person_IsFacet;
/** @constructor */
function $h_Lreactbuild_person_IsFacet() {
  /*<skip>*/
}
$h_Lreactbuild_person_IsFacet.prototype = $c_Lreactbuild_person_IsFacet.prototype;
$c_Lreactbuild_person_IsFacet.prototype.productPrefix__T = (function() {
  return "IsFacet"
});
$c_Lreactbuild_person_IsFacet.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_IsFacet.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_IsFacet__f_cls : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_IsFacet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_IsFacet.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_IsFacet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_IsFacet.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_IsFacet)) {
    var IsFacet$1 = $as_Lreactbuild_person_IsFacet(x$1);
    var x = this.Lreactbuild_person_IsFacet__f_cls;
    var x$2 = $n(IsFacet$1).Lreactbuild_person_IsFacet__f_cls;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_IsFacet(obj) {
  return (((obj instanceof $c_Lreactbuild_person_IsFacet) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.IsFacet"))
}
function $isArrayOf_Lreactbuild_person_IsFacet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_IsFacet)))
}
function $asArrayOf_Lreactbuild_person_IsFacet(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_IsFacet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.IsFacet;", depth))
}
var $d_Lreactbuild_person_IsFacet = new $TypeData().initClass({
  Lreactbuild_person_IsFacet: 0
}, false, "reactbuild.person.IsFacet", {
  Lreactbuild_person_IsFacet: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_IsFacet.prototype.$classData = $d_Lreactbuild_person_IsFacet;
/** @constructor */
function $c_Lreactbuild_person_PaymentTermAndConditions(method, period, before) {
  this.Lreactbuild_person_PaymentTermAndConditions__f_method = null;
  this.Lreactbuild_person_PaymentTermAndConditions__f_period = null;
  this.Lreactbuild_person_PaymentTermAndConditions__f_before = null;
  this.Lreactbuild_person_PaymentTermAndConditions__f_method = method;
  this.Lreactbuild_person_PaymentTermAndConditions__f_period = period;
  this.Lreactbuild_person_PaymentTermAndConditions__f_before = before
}
$c_Lreactbuild_person_PaymentTermAndConditions.prototype = new $h_O();
$c_Lreactbuild_person_PaymentTermAndConditions.prototype.constructor = $c_Lreactbuild_person_PaymentTermAndConditions;
/** @constructor */
function $h_Lreactbuild_person_PaymentTermAndConditions() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentTermAndConditions.prototype = $c_Lreactbuild_person_PaymentTermAndConditions.prototype;
$c_Lreactbuild_person_PaymentTermAndConditions.prototype.productPrefix__T = (function() {
  return "PaymentTermAndConditions"
});
$c_Lreactbuild_person_PaymentTermAndConditions.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_person_PaymentTermAndConditions.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_PaymentTermAndConditions__f_method;
      break
    }
    case 1: {
      return this.Lreactbuild_person_PaymentTermAndConditions__f_period;
      break
    }
    case 2: {
      return this.Lreactbuild_person_PaymentTermAndConditions__f_before;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_PaymentTermAndConditions.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PaymentTermAndConditions.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_PaymentTermAndConditions.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_PaymentTermAndConditions.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_PaymentTermAndConditions)) {
    var PaymentTermAndConditions$1 = $as_Lreactbuild_person_PaymentTermAndConditions(x$1);
    var x = this.Lreactbuild_person_PaymentTermAndConditions__f_method;
    var x$2 = $n(PaymentTermAndConditions$1).Lreactbuild_person_PaymentTermAndConditions__f_method;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_PaymentTermAndConditions__f_period;
      var x$4 = $n(PaymentTermAndConditions$1).Lreactbuild_person_PaymentTermAndConditions__f_period;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_person_PaymentTermAndConditions__f_before;
        var x$6 = $n(PaymentTermAndConditions$1).Lreactbuild_person_PaymentTermAndConditions__f_before;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_PaymentTermAndConditions(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PaymentTermAndConditions) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PaymentTermAndConditions"))
}
function $isArrayOf_Lreactbuild_person_PaymentTermAndConditions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PaymentTermAndConditions)))
}
function $asArrayOf_Lreactbuild_person_PaymentTermAndConditions(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PaymentTermAndConditions(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PaymentTermAndConditions;", depth))
}
var $d_Lreactbuild_person_PaymentTermAndConditions = new $TypeData().initClass({
  Lreactbuild_person_PaymentTermAndConditions: 0
}, false, "reactbuild.person.PaymentTermAndConditions", {
  Lreactbuild_person_PaymentTermAndConditions: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PaymentTermAndConditions.prototype.$classData = $d_Lreactbuild_person_PaymentTermAndConditions;
/** @constructor */
function $c_Lreactbuild_person_Person(_id, organization, name, code, facets, addresses, parent, imageUrl) {
  this.Lreactbuild_person_Person__f__id = null;
  this.Lreactbuild_person_Person__f_organization = null;
  this.Lreactbuild_person_Person__f_name = null;
  this.Lreactbuild_person_Person__f_code = null;
  this.Lreactbuild_person_Person__f_facets = null;
  this.Lreactbuild_person_Person__f_addresses = null;
  this.Lreactbuild_person_Person__f_parent = null;
  this.Lreactbuild_person_Person__f_imageUrl = null;
  this.Lreactbuild_person_Person__f__id = _id;
  this.Lreactbuild_person_Person__f_organization = organization;
  this.Lreactbuild_person_Person__f_name = name;
  this.Lreactbuild_person_Person__f_code = code;
  this.Lreactbuild_person_Person__f_facets = facets;
  this.Lreactbuild_person_Person__f_addresses = addresses;
  this.Lreactbuild_person_Person__f_parent = parent;
  this.Lreactbuild_person_Person__f_imageUrl = imageUrl
}
$c_Lreactbuild_person_Person.prototype = new $h_O();
$c_Lreactbuild_person_Person.prototype.constructor = $c_Lreactbuild_person_Person;
/** @constructor */
function $h_Lreactbuild_person_Person() {
  /*<skip>*/
}
$h_Lreactbuild_person_Person.prototype = $c_Lreactbuild_person_Person.prototype;
$c_Lreactbuild_person_Person.prototype.addFacet__Lreactbuild_person_Facet__s_reflect_ClassTag__Lreactbuild_person_Person = (function(facet, ev) {
  var x$1 = $n(this.Lreactbuild_person_Person__f_facets).$plus__Lreactbuild_person_Facet__s_reflect_ClassTag__Lreactbuild_person_Facets(facet, ev);
  var x$2 = this.Lreactbuild_person_Person__f__id;
  var x$3 = this.Lreactbuild_person_Person__f_organization;
  var x$4 = this.Lreactbuild_person_Person__f_name;
  var x$5 = this.Lreactbuild_person_Person__f_code;
  var x$6 = this.Lreactbuild_person_Person__f_addresses;
  var x$7 = this.Lreactbuild_person_Person__f_parent;
  var x$8 = this.Lreactbuild_person_Person__f_imageUrl;
  return new $c_Lreactbuild_person_Person(x$2, x$3, x$4, x$5, x$1, x$6, x$7, x$8)
});
$c_Lreactbuild_person_Person.prototype.updateFacet__F1__s_reflect_ClassTag__Lreactbuild_person_Person = (function(f, ev) {
  var x$1 = $n(this.Lreactbuild_person_Person__f_facets).updated__F1__s_reflect_ClassTag__Lreactbuild_person_Facets(f, ev);
  var x$2 = this.Lreactbuild_person_Person__f__id;
  var x$3 = this.Lreactbuild_person_Person__f_organization;
  var x$4 = this.Lreactbuild_person_Person__f_name;
  var x$5 = this.Lreactbuild_person_Person__f_code;
  var x$6 = this.Lreactbuild_person_Person__f_addresses;
  var x$7 = this.Lreactbuild_person_Person__f_parent;
  var x$8 = this.Lreactbuild_person_Person__f_imageUrl;
  return new $c_Lreactbuild_person_Person(x$2, x$3, x$4, x$5, x$1, x$6, x$7, x$8)
});
$c_Lreactbuild_person_Person.prototype.productPrefix__T = (function() {
  return "Person"
});
$c_Lreactbuild_person_Person.prototype.productArity__I = (function() {
  return 8
});
$c_Lreactbuild_person_Person.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_Person__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_person_Person__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_person_Person__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_person_Person__f_code;
      break
    }
    case 4: {
      return this.Lreactbuild_person_Person__f_facets;
      break
    }
    case 5: {
      return this.Lreactbuild_person_Person__f_addresses;
      break
    }
    case 6: {
      return this.Lreactbuild_person_Person__f_parent;
      break
    }
    case 7: {
      return this.Lreactbuild_person_Person__f_imageUrl;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_Person.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Person.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_Person.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Person.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Person)) {
    var Person$1 = $as_Lreactbuild_person_Person(x$1);
    var x = this.Lreactbuild_person_Person__f__id;
    var x$2 = $n(Person$1).Lreactbuild_person_Person__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_Person__f_organization;
      var x$4 = $n(Person$1).Lreactbuild_person_Person__f_organization;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      if ((this.Lreactbuild_person_Person__f_name === $n(Person$1).Lreactbuild_person_Person__f_name)) {
        var x$5 = this.Lreactbuild_person_Person__f_code;
        var x$6 = $n(Person$1).Lreactbuild_person_Person__f_code;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_person_Person__f_facets;
      var x$8 = $n(Person$1).Lreactbuild_person_Person__f_facets;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_person_Person__f_addresses;
        var x$10 = $n(Person$1).Lreactbuild_person_Person__f_addresses;
        var $$x3 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$11 = this.Lreactbuild_person_Person__f_parent;
        var x$12 = $n(Person$1).Lreactbuild_person_Person__f_parent;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_person_Person__f_imageUrl;
          var x$14 = $n(Person$1).Lreactbuild_person_Person__f_imageUrl;
          return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Person(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Person) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Person"))
}
function $isArrayOf_Lreactbuild_person_Person(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Person)))
}
function $asArrayOf_Lreactbuild_person_Person(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Person(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Person;", depth))
}
var $d_Lreactbuild_person_Person = new $TypeData().initClass({
  Lreactbuild_person_Person: 0
}, false, "reactbuild.person.Person", {
  Lreactbuild_person_Person: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Person.prototype.$classData = $d_Lreactbuild_person_Person;
/** @constructor */
function $c_Lreactbuild_person_PersonAnnotation(_id, person, label, created, expired) {
  this.Lreactbuild_person_PersonAnnotation__f__id = null;
  this.Lreactbuild_person_PersonAnnotation__f_person = null;
  this.Lreactbuild_person_PersonAnnotation__f_label = null;
  this.Lreactbuild_person_PersonAnnotation__f_created = null;
  this.Lreactbuild_person_PersonAnnotation__f_expired = null;
  this.Lreactbuild_person_PersonAnnotation__f__id = _id;
  this.Lreactbuild_person_PersonAnnotation__f_person = person;
  this.Lreactbuild_person_PersonAnnotation__f_label = label;
  this.Lreactbuild_person_PersonAnnotation__f_created = created;
  this.Lreactbuild_person_PersonAnnotation__f_expired = expired
}
$c_Lreactbuild_person_PersonAnnotation.prototype = new $h_O();
$c_Lreactbuild_person_PersonAnnotation.prototype.constructor = $c_Lreactbuild_person_PersonAnnotation;
/** @constructor */
function $h_Lreactbuild_person_PersonAnnotation() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonAnnotation.prototype = $c_Lreactbuild_person_PersonAnnotation.prototype;
$c_Lreactbuild_person_PersonAnnotation.prototype.productPrefix__T = (function() {
  return "PersonAnnotation"
});
$c_Lreactbuild_person_PersonAnnotation.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_person_PersonAnnotation.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_PersonAnnotation__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_person_PersonAnnotation__f_person;
      break
    }
    case 2: {
      return this.Lreactbuild_person_PersonAnnotation__f_label;
      break
    }
    case 3: {
      return this.Lreactbuild_person_PersonAnnotation__f_created;
      break
    }
    case 4: {
      return this.Lreactbuild_person_PersonAnnotation__f_expired;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_PersonAnnotation.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PersonAnnotation.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_PersonAnnotation.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_PersonAnnotation.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_PersonAnnotation)) {
    var PersonAnnotation$1 = $as_Lreactbuild_person_PersonAnnotation(x$1);
    var x = this.Lreactbuild_person_PersonAnnotation__f__id;
    var x$2 = $n(PersonAnnotation$1).Lreactbuild_person_PersonAnnotation__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_PersonAnnotation__f_person;
      var x$4 = $n(PersonAnnotation$1).Lreactbuild_person_PersonAnnotation__f_person;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_person_PersonAnnotation__f_label === $n(PersonAnnotation$1).Lreactbuild_person_PersonAnnotation__f_label)) {
        var x$5 = this.Lreactbuild_person_PersonAnnotation__f_created;
        var x$6 = $n(PersonAnnotation$1).Lreactbuild_person_PersonAnnotation__f_created;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var x$7 = this.Lreactbuild_person_PersonAnnotation__f_expired;
          var x$8 = $n(PersonAnnotation$1).Lreactbuild_person_PersonAnnotation__f_expired;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_PersonAnnotation(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PersonAnnotation) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PersonAnnotation"))
}
function $isArrayOf_Lreactbuild_person_PersonAnnotation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PersonAnnotation)))
}
function $asArrayOf_Lreactbuild_person_PersonAnnotation(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PersonAnnotation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PersonAnnotation;", depth))
}
var $d_Lreactbuild_person_PersonAnnotation = new $TypeData().initClass({
  Lreactbuild_person_PersonAnnotation: 0
}, false, "reactbuild.person.PersonAnnotation", {
  Lreactbuild_person_PersonAnnotation: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonAnnotation.prototype.$classData = $d_Lreactbuild_person_PersonAnnotation;
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceDetails(model, value) {
  this.Lreactbuild_person_PersonReferenceDetails__f_model = null;
  this.Lreactbuild_person_PersonReferenceDetails__f_value = null;
  this.Lreactbuild_person_PersonReferenceDetails__f_model = model;
  this.Lreactbuild_person_PersonReferenceDetails__f_value = value;
  $m_sc_StringOps$().reverse$extension__T__T(value)
}
$c_Lreactbuild_person_PersonReferenceDetails.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceDetails.prototype.constructor = $c_Lreactbuild_person_PersonReferenceDetails;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceDetails() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceDetails.prototype = $c_Lreactbuild_person_PersonReferenceDetails.prototype;
$c_Lreactbuild_person_PersonReferenceDetails.prototype.productPrefix__T = (function() {
  return "PersonReferenceDetails"
});
$c_Lreactbuild_person_PersonReferenceDetails.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_PersonReferenceDetails.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return new $c_Lreactbuild_person_PersonReferenceModel(this.Lreactbuild_person_PersonReferenceDetails__f_model);
      break
    }
    case 1: {
      return this.Lreactbuild_person_PersonReferenceDetails__f_value;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_PersonReferenceDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PersonReferenceDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_PersonReferenceDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_PersonReferenceDetails.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_PersonReferenceDetails)) {
    var PersonReferenceDetails$1 = $as_Lreactbuild_person_PersonReferenceDetails(x$1);
    return ((this.Lreactbuild_person_PersonReferenceDetails__f_model === $n(PersonReferenceDetails$1).Lreactbuild_person_PersonReferenceDetails__f_model) && (this.Lreactbuild_person_PersonReferenceDetails__f_value === $n(PersonReferenceDetails$1).Lreactbuild_person_PersonReferenceDetails__f_value))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_PersonReferenceDetails(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PersonReferenceDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PersonReferenceDetails"))
}
function $isArrayOf_Lreactbuild_person_PersonReferenceDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PersonReferenceDetails)))
}
function $asArrayOf_Lreactbuild_person_PersonReferenceDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PersonReferenceDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PersonReferenceDetails;", depth))
}
var $d_Lreactbuild_person_PersonReferenceDetails = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceDetails: 0
}, false, "reactbuild.person.PersonReferenceDetails", {
  Lreactbuild_person_PersonReferenceDetails: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceDetails.prototype.$classData = $d_Lreactbuild_person_PersonReferenceDetails;
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22(outer) {
  this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22__f_circeGenericDecoderFormodel = null;
  this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22__f_circeGenericDecoderForvalue = null;
  this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22__f_circeGenericDecoderFormodel = $m_Lreactbuild_person_PersonReferenceModel$().decodePersonReferenceModel__Lio_circe_Decoder();
  this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22__f_circeGenericDecoderForvalue = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22.prototype.constructor = $c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22.prototype = $c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22.prototype;
$c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("model"))), this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22__f_circeGenericDecoderFormodel, "model", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("value"))), this.Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22__f_circeGenericDecoderForvalue, "value", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22 = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22: 0
}, false, "reactbuild.person.PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22", {
  Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22.prototype.$classData = $d_Lreactbuild_person_PersonReferenceDetails$anon$lazy$macro$19$2$$anon$22;
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceList$Props(targets, events) {
  this.Lreactbuild_person_PersonReferenceList$Props__f_targets = null;
  this.Lreactbuild_person_PersonReferenceList$Props__f_events = null;
  this.Lreactbuild_person_PersonReferenceList$Props__f_targets = targets;
  this.Lreactbuild_person_PersonReferenceList$Props__f_events = events
}
$c_Lreactbuild_person_PersonReferenceList$Props.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceList$Props.prototype.constructor = $c_Lreactbuild_person_PersonReferenceList$Props;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceList$Props() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceList$Props.prototype = $c_Lreactbuild_person_PersonReferenceList$Props.prototype;
$c_Lreactbuild_person_PersonReferenceList$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_person_PersonReferenceList$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_PersonReferenceList$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_PersonReferenceList$Props__f_targets;
      break
    }
    case 1: {
      return this.Lreactbuild_person_PersonReferenceList$Props__f_events;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_PersonReferenceList$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PersonReferenceList$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_PersonReferenceList$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_PersonReferenceList$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_PersonReferenceList$Props)) {
    var Props$1 = $as_Lreactbuild_person_PersonReferenceList$Props(x$1);
    var x = this.Lreactbuild_person_PersonReferenceList$Props__f_targets;
    var x$2 = $n(Props$1).Lreactbuild_person_PersonReferenceList$Props__f_targets;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_PersonReferenceList$Props__f_events;
      var x$4 = $n(Props$1).Lreactbuild_person_PersonReferenceList$Props__f_events;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_PersonReferenceList$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PersonReferenceList$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PersonReferenceList$Props"))
}
function $isArrayOf_Lreactbuild_person_PersonReferenceList$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PersonReferenceList$Props)))
}
function $asArrayOf_Lreactbuild_person_PersonReferenceList$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PersonReferenceList$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PersonReferenceList$Props;", depth))
}
var $d_Lreactbuild_person_PersonReferenceList$Props = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceList$Props: 0
}, false, "reactbuild.person.PersonReferenceList$Props", {
  Lreactbuild_person_PersonReferenceList$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceList$Props.prototype.$classData = $d_Lreactbuild_person_PersonReferenceList$Props;
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceList$Targets(personRefOpt, otherRefList) {
  this.Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt = null;
  this.Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList = null;
  this.Lreactbuild_person_PersonReferenceList$Targets__f_render = null;
  this.Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt = personRefOpt;
  this.Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList = otherRefList;
  var this$1 = $n(personRefOpt);
  this.Lreactbuild_person_PersonReferenceList$Targets__f_render = ((!this$1.isEmpty__Z()) ? $m_Lreactbuild_person_PersonReferenceListRender$PersonView$() : $m_Lreactbuild_person_PersonReferenceListRender$ProjectView$())
}
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype.constructor = $c_Lreactbuild_person_PersonReferenceList$Targets;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceList$Targets() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceList$Targets.prototype = $c_Lreactbuild_person_PersonReferenceList$Targets.prototype;
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype.productPrefix__T = (function() {
  return "Targets"
});
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt;
      break
    }
    case 1: {
      return this.Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_PersonReferenceList$Targets)) {
    var Targets$1 = $as_Lreactbuild_person_PersonReferenceList$Targets(x$1);
    var x = this.Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt;
    var x$2 = $n(Targets$1).Lreactbuild_person_PersonReferenceList$Targets__f_personRefOpt;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList;
      var x$4 = $n(Targets$1).Lreactbuild_person_PersonReferenceList$Targets__f_otherRefList;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_PersonReferenceList$Targets(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PersonReferenceList$Targets) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PersonReferenceList$Targets"))
}
function $isArrayOf_Lreactbuild_person_PersonReferenceList$Targets(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PersonReferenceList$Targets)))
}
function $asArrayOf_Lreactbuild_person_PersonReferenceList$Targets(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PersonReferenceList$Targets(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PersonReferenceList$Targets;", depth))
}
var $d_Lreactbuild_person_PersonReferenceList$Targets = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceList$Targets: 0
}, false, "reactbuild.person.PersonReferenceList$Targets", {
  Lreactbuild_person_PersonReferenceList$Targets: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceList$Targets.prototype.$classData = $d_Lreactbuild_person_PersonReferenceList$Targets;
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceModel(id) {
  this.Lreactbuild_person_PersonReferenceModel__f_id = null;
  this.Lreactbuild_person_PersonReferenceModel__f_id = id
}
$c_Lreactbuild_person_PersonReferenceModel.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceModel.prototype.constructor = $c_Lreactbuild_person_PersonReferenceModel;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceModel() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceModel.prototype = $c_Lreactbuild_person_PersonReferenceModel.prototype;
$c_Lreactbuild_person_PersonReferenceModel.prototype.productPrefix__T = (function() {
  return "PersonReferenceModel"
});
$c_Lreactbuild_person_PersonReferenceModel.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_PersonReferenceModel.prototype.productElement__I__O = (function(x$1) {
  return $m_Lreactbuild_person_PersonReferenceModel$().productElement$extension__T__I__O(this.Lreactbuild_person_PersonReferenceModel__f_id, x$1)
});
$c_Lreactbuild_person_PersonReferenceModel.prototype.productIterator__sc_Iterator = (function() {
  return $m_Lreactbuild_person_PersonReferenceModel$().productIterator$extension__T__sc_Iterator(this.Lreactbuild_person_PersonReferenceModel__f_id)
});
$c_Lreactbuild_person_PersonReferenceModel.prototype.hashCode__I = (function() {
  var this$ = this.Lreactbuild_person_PersonReferenceModel__f_id;
  return $f_T__hashCode__I($n(this$))
});
$c_Lreactbuild_person_PersonReferenceModel.prototype.equals__O__Z = (function(x$1) {
  return $m_Lreactbuild_person_PersonReferenceModel$().equals$extension__T__O__Z(this.Lreactbuild_person_PersonReferenceModel__f_id, x$1)
});
$c_Lreactbuild_person_PersonReferenceModel.prototype.toString__T = (function() {
  return $m_Lreactbuild_person_PersonReferenceModel$().toString$extension__T__T(this.Lreactbuild_person_PersonReferenceModel__f_id)
});
function $as_Lreactbuild_person_PersonReferenceModel(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PersonReferenceModel) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PersonReferenceModel"))
}
function $isArrayOf_Lreactbuild_person_PersonReferenceModel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PersonReferenceModel)))
}
function $asArrayOf_Lreactbuild_person_PersonReferenceModel(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PersonReferenceModel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PersonReferenceModel;", depth))
}
var $d_Lreactbuild_person_PersonReferenceModel = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceModel: 0
}, false, "reactbuild.person.PersonReferenceModel", {
  Lreactbuild_person_PersonReferenceModel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceModel.prototype.$classData = $d_Lreactbuild_person_PersonReferenceModel;
/** @constructor */
function $c_Lreactbuild_person_ProductGeneric(_id, organization, title) {
  this.Lreactbuild_person_ProductGeneric__f__id = null;
  this.Lreactbuild_person_ProductGeneric__f_organization = null;
  this.Lreactbuild_person_ProductGeneric__f_title = null;
  this.Lreactbuild_person_ProductGeneric__f__id = _id;
  this.Lreactbuild_person_ProductGeneric__f_organization = organization;
  this.Lreactbuild_person_ProductGeneric__f_title = title
}
$c_Lreactbuild_person_ProductGeneric.prototype = new $h_O();
$c_Lreactbuild_person_ProductGeneric.prototype.constructor = $c_Lreactbuild_person_ProductGeneric;
/** @constructor */
function $h_Lreactbuild_person_ProductGeneric() {
  /*<skip>*/
}
$h_Lreactbuild_person_ProductGeneric.prototype = $c_Lreactbuild_person_ProductGeneric.prototype;
$c_Lreactbuild_person_ProductGeneric.prototype.productPrefix__T = (function() {
  return "ProductGeneric"
});
$c_Lreactbuild_person_ProductGeneric.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_person_ProductGeneric.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_ProductGeneric__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_person_ProductGeneric__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_person_ProductGeneric__f_title;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_ProductGeneric.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_ProductGeneric.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_ProductGeneric.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_ProductGeneric.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_ProductGeneric)) {
    var ProductGeneric$1 = $as_Lreactbuild_person_ProductGeneric(x$1);
    var x = this.Lreactbuild_person_ProductGeneric__f__id;
    var x$2 = $n(ProductGeneric$1).Lreactbuild_person_ProductGeneric__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_ProductGeneric__f_organization;
      var x$4 = $n(ProductGeneric$1).Lreactbuild_person_ProductGeneric__f_organization;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        return (this.Lreactbuild_person_ProductGeneric__f_title === $n(ProductGeneric$1).Lreactbuild_person_ProductGeneric__f_title)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_ProductGeneric(obj) {
  return (((obj instanceof $c_Lreactbuild_person_ProductGeneric) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.ProductGeneric"))
}
function $isArrayOf_Lreactbuild_person_ProductGeneric(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_ProductGeneric)))
}
function $asArrayOf_Lreactbuild_person_ProductGeneric(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_ProductGeneric(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.ProductGeneric;", depth))
}
var $d_Lreactbuild_person_ProductGeneric = new $TypeData().initClass({
  Lreactbuild_person_ProductGeneric: 0
}, false, "reactbuild.person.ProductGeneric", {
  Lreactbuild_person_ProductGeneric: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_ProductGeneric.prototype.$classData = $d_Lreactbuild_person_ProductGeneric;
/** @constructor */
function $c_Lreactbuild_person_ProductProduct(_id, title, template, supplier, reference, unitPrice, unit, unitSize, packaging, unitPerPackaging) {
  this.Lreactbuild_person_ProductProduct__f__id = null;
  this.Lreactbuild_person_ProductProduct__f_title = null;
  this.Lreactbuild_person_ProductProduct__f_template = null;
  this.Lreactbuild_person_ProductProduct__f_supplier = null;
  this.Lreactbuild_person_ProductProduct__f_reference = null;
  this.Lreactbuild_person_ProductProduct__f_unitPrice = null;
  this.Lreactbuild_person_ProductProduct__f_unit = null;
  this.Lreactbuild_person_ProductProduct__f_unitSize = null;
  this.Lreactbuild_person_ProductProduct__f_packaging = null;
  this.Lreactbuild_person_ProductProduct__f_unitPerPackaging = null;
  this.Lreactbuild_person_ProductProduct__f__id = _id;
  this.Lreactbuild_person_ProductProduct__f_title = title;
  this.Lreactbuild_person_ProductProduct__f_template = template;
  this.Lreactbuild_person_ProductProduct__f_supplier = supplier;
  this.Lreactbuild_person_ProductProduct__f_reference = reference;
  this.Lreactbuild_person_ProductProduct__f_unitPrice = unitPrice;
  this.Lreactbuild_person_ProductProduct__f_unit = unit;
  this.Lreactbuild_person_ProductProduct__f_unitSize = unitSize;
  this.Lreactbuild_person_ProductProduct__f_packaging = packaging;
  this.Lreactbuild_person_ProductProduct__f_unitPerPackaging = unitPerPackaging
}
$c_Lreactbuild_person_ProductProduct.prototype = new $h_O();
$c_Lreactbuild_person_ProductProduct.prototype.constructor = $c_Lreactbuild_person_ProductProduct;
/** @constructor */
function $h_Lreactbuild_person_ProductProduct() {
  /*<skip>*/
}
$h_Lreactbuild_person_ProductProduct.prototype = $c_Lreactbuild_person_ProductProduct.prototype;
$c_Lreactbuild_person_ProductProduct.prototype.productPrefix__T = (function() {
  return "ProductProduct"
});
$c_Lreactbuild_person_ProductProduct.prototype.productArity__I = (function() {
  return 10
});
$c_Lreactbuild_person_ProductProduct.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_ProductProduct__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_person_ProductProduct__f_title;
      break
    }
    case 2: {
      return this.Lreactbuild_person_ProductProduct__f_template;
      break
    }
    case 3: {
      return this.Lreactbuild_person_ProductProduct__f_supplier;
      break
    }
    case 4: {
      return this.Lreactbuild_person_ProductProduct__f_reference;
      break
    }
    case 5: {
      return this.Lreactbuild_person_ProductProduct__f_unitPrice;
      break
    }
    case 6: {
      return this.Lreactbuild_person_ProductProduct__f_unit;
      break
    }
    case 7: {
      return this.Lreactbuild_person_ProductProduct__f_unitSize;
      break
    }
    case 8: {
      return this.Lreactbuild_person_ProductProduct__f_packaging;
      break
    }
    case 9: {
      return this.Lreactbuild_person_ProductProduct__f_unitPerPackaging;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_ProductProduct.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_ProductProduct.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_ProductProduct.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_ProductProduct.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_ProductProduct)) {
    var ProductProduct$1 = $as_Lreactbuild_person_ProductProduct(x$1);
    var x = this.Lreactbuild_person_ProductProduct__f__id;
    var x$2 = $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f__id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_person_ProductProduct__f_title === $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f_title))) {
      var x$3 = this.Lreactbuild_person_ProductProduct__f_template;
      var x$4 = $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f_template;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_person_ProductProduct__f_supplier;
        var x$6 = $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f_supplier;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var $$x1 = (this.Lreactbuild_person_ProductProduct__f_reference === $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f_reference)
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_person_ProductProduct__f_unitPrice;
      var x$8 = $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f_unitPrice;
      if ((((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8)) && (this.Lreactbuild_person_ProductProduct__f_unit === $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f_unit))) {
        var x$9 = this.Lreactbuild_person_ProductProduct__f_unitSize;
        var x$10 = $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f_unitSize;
        if ((x$9 === null)) {
          var $$x2 = (x$10 === null)
        } else {
          var this$1 = $n(x$9);
          var $$x2 = (this$1 === x$10)
        };
        if ($$x2) {
          return ((this.Lreactbuild_person_ProductProduct__f_packaging === $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f_packaging) && (this.Lreactbuild_person_ProductProduct__f_unitPerPackaging === $n(ProductProduct$1).Lreactbuild_person_ProductProduct__f_unitPerPackaging))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_ProductProduct(obj) {
  return (((obj instanceof $c_Lreactbuild_person_ProductProduct) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.ProductProduct"))
}
function $isArrayOf_Lreactbuild_person_ProductProduct(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_ProductProduct)))
}
function $asArrayOf_Lreactbuild_person_ProductProduct(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_ProductProduct(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.ProductProduct;", depth))
}
var $d_Lreactbuild_person_ProductProduct = new $TypeData().initClass({
  Lreactbuild_person_ProductProduct: 0
}, false, "reactbuild.person.ProductProduct", {
  Lreactbuild_person_ProductProduct: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_ProductProduct.prototype.$classData = $d_Lreactbuild_person_ProductProduct;
/** @constructor */
function $c_Lreactbuild_person_QuantifiedExpression(code) {
  this.Lreactbuild_person_QuantifiedExpression__f_code = null;
  this.Lreactbuild_person_QuantifiedExpression__f_code = code
}
$c_Lreactbuild_person_QuantifiedExpression.prototype = new $h_O();
$c_Lreactbuild_person_QuantifiedExpression.prototype.constructor = $c_Lreactbuild_person_QuantifiedExpression;
/** @constructor */
function $h_Lreactbuild_person_QuantifiedExpression() {
  /*<skip>*/
}
$h_Lreactbuild_person_QuantifiedExpression.prototype = $c_Lreactbuild_person_QuantifiedExpression.prototype;
$c_Lreactbuild_person_QuantifiedExpression.prototype.productPrefix__T = (function() {
  return "QuantifiedExpression"
});
$c_Lreactbuild_person_QuantifiedExpression.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_QuantifiedExpression.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_QuantifiedExpression__f_code : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_QuantifiedExpression.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_QuantifiedExpression.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_QuantifiedExpression.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_QuantifiedExpression.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_QuantifiedExpression)) {
    var QuantifiedExpression$1 = $as_Lreactbuild_person_QuantifiedExpression(x$1);
    return (this.Lreactbuild_person_QuantifiedExpression__f_code === $n(QuantifiedExpression$1).Lreactbuild_person_QuantifiedExpression__f_code)
  } else {
    return false
  }
});
function $as_Lreactbuild_person_QuantifiedExpression(obj) {
  return (((obj instanceof $c_Lreactbuild_person_QuantifiedExpression) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.QuantifiedExpression"))
}
function $isArrayOf_Lreactbuild_person_QuantifiedExpression(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_QuantifiedExpression)))
}
function $asArrayOf_Lreactbuild_person_QuantifiedExpression(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_QuantifiedExpression(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.QuantifiedExpression;", depth))
}
var $d_Lreactbuild_person_QuantifiedExpression = new $TypeData().initClass({
  Lreactbuild_person_QuantifiedExpression: 0
}, false, "reactbuild.person.QuantifiedExpression", {
  Lreactbuild_person_QuantifiedExpression: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_QuantifiedExpression.prototype.$classData = $d_Lreactbuild_person_QuantifiedExpression;
/** @constructor */
function $c_Lreactbuild_person_RowFieldLevel(reference, description, quantity, unit, unitPrice, amount) {
  this.Lreactbuild_person_RowFieldLevel__f_reference = null;
  this.Lreactbuild_person_RowFieldLevel__f_description = null;
  this.Lreactbuild_person_RowFieldLevel__f_quantity = null;
  this.Lreactbuild_person_RowFieldLevel__f_unit = null;
  this.Lreactbuild_person_RowFieldLevel__f_unitPrice = null;
  this.Lreactbuild_person_RowFieldLevel__f_amount = null;
  this.Lreactbuild_person_RowFieldLevel__f_reference = reference;
  this.Lreactbuild_person_RowFieldLevel__f_description = description;
  this.Lreactbuild_person_RowFieldLevel__f_quantity = quantity;
  this.Lreactbuild_person_RowFieldLevel__f_unit = unit;
  this.Lreactbuild_person_RowFieldLevel__f_unitPrice = unitPrice;
  this.Lreactbuild_person_RowFieldLevel__f_amount = amount
}
$c_Lreactbuild_person_RowFieldLevel.prototype = new $h_O();
$c_Lreactbuild_person_RowFieldLevel.prototype.constructor = $c_Lreactbuild_person_RowFieldLevel;
/** @constructor */
function $h_Lreactbuild_person_RowFieldLevel() {
  /*<skip>*/
}
$h_Lreactbuild_person_RowFieldLevel.prototype = $c_Lreactbuild_person_RowFieldLevel.prototype;
$c_Lreactbuild_person_RowFieldLevel.prototype.productPrefix__T = (function() {
  return "RowFieldLevel"
});
$c_Lreactbuild_person_RowFieldLevel.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_person_RowFieldLevel.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_RowFieldLevel__f_reference;
      break
    }
    case 1: {
      return this.Lreactbuild_person_RowFieldLevel__f_description;
      break
    }
    case 2: {
      return this.Lreactbuild_person_RowFieldLevel__f_quantity;
      break
    }
    case 3: {
      return this.Lreactbuild_person_RowFieldLevel__f_unit;
      break
    }
    case 4: {
      return this.Lreactbuild_person_RowFieldLevel__f_unitPrice;
      break
    }
    case 5: {
      return this.Lreactbuild_person_RowFieldLevel__f_amount;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_RowFieldLevel.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_RowFieldLevel.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_RowFieldLevel.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_RowFieldLevel.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_RowFieldLevel)) {
    var RowFieldLevel$1 = $as_Lreactbuild_person_RowFieldLevel(x$1);
    var x = this.Lreactbuild_person_RowFieldLevel__f_reference;
    var x$2 = $n(RowFieldLevel$1).Lreactbuild_person_RowFieldLevel__f_reference;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_RowFieldLevel__f_description;
      var x$4 = $n(RowFieldLevel$1).Lreactbuild_person_RowFieldLevel__f_description;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_person_RowFieldLevel__f_quantity;
        var x$6 = $n(RowFieldLevel$1).Lreactbuild_person_RowFieldLevel__f_quantity;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_person_RowFieldLevel__f_unit;
      var x$8 = $n(RowFieldLevel$1).Lreactbuild_person_RowFieldLevel__f_unit;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_person_RowFieldLevel__f_unitPrice;
        var x$10 = $n(RowFieldLevel$1).Lreactbuild_person_RowFieldLevel__f_unitPrice;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_person_RowFieldLevel__f_amount;
          var x$12 = $n(RowFieldLevel$1).Lreactbuild_person_RowFieldLevel__f_amount;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_RowFieldLevel(obj) {
  return (((obj instanceof $c_Lreactbuild_person_RowFieldLevel) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.RowFieldLevel"))
}
function $isArrayOf_Lreactbuild_person_RowFieldLevel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_RowFieldLevel)))
}
function $asArrayOf_Lreactbuild_person_RowFieldLevel(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_RowFieldLevel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.RowFieldLevel;", depth))
}
var $d_Lreactbuild_person_RowFieldLevel = new $TypeData().initClass({
  Lreactbuild_person_RowFieldLevel: 0
}, false, "reactbuild.person.RowFieldLevel", {
  Lreactbuild_person_RowFieldLevel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_RowFieldLevel.prototype.$classData = $d_Lreactbuild_person_RowFieldLevel;
/** @constructor */
function $c_Lreactbuild_person_RowListing(lists, rows, generics, products) {
  this.Lreactbuild_person_RowListing__f_lists = null;
  this.Lreactbuild_person_RowListing__f_rows = null;
  this.Lreactbuild_person_RowListing__f_generics = null;
  this.Lreactbuild_person_RowListing__f_products = null;
  this.Lreactbuild_person_RowListing__f_lists = lists;
  this.Lreactbuild_person_RowListing__f_rows = rows;
  this.Lreactbuild_person_RowListing__f_generics = generics;
  this.Lreactbuild_person_RowListing__f_products = products
}
$c_Lreactbuild_person_RowListing.prototype = new $h_O();
$c_Lreactbuild_person_RowListing.prototype.constructor = $c_Lreactbuild_person_RowListing;
/** @constructor */
function $h_Lreactbuild_person_RowListing() {
  /*<skip>*/
}
$h_Lreactbuild_person_RowListing.prototype = $c_Lreactbuild_person_RowListing.prototype;
$c_Lreactbuild_person_RowListing.prototype.productPrefix__T = (function() {
  return "RowListing"
});
$c_Lreactbuild_person_RowListing.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_person_RowListing.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_RowListing__f_lists;
      break
    }
    case 1: {
      return this.Lreactbuild_person_RowListing__f_rows;
      break
    }
    case 2: {
      return this.Lreactbuild_person_RowListing__f_generics;
      break
    }
    case 3: {
      return this.Lreactbuild_person_RowListing__f_products;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_RowListing.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_RowListing.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_RowListing.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_RowListing.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_RowListing)) {
    var RowListing$1 = $as_Lreactbuild_person_RowListing(x$1);
    var x = this.Lreactbuild_person_RowListing__f_lists;
    var x$2 = $n(RowListing$1).Lreactbuild_person_RowListing__f_lists;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_RowListing__f_rows;
      var x$4 = $n(RowListing$1).Lreactbuild_person_RowListing__f_rows;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_person_RowListing__f_generics;
      var x$6 = $n(RowListing$1).Lreactbuild_person_RowListing__f_generics;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_person_RowListing__f_products;
        var x$8 = $n(RowListing$1).Lreactbuild_person_RowListing__f_products;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_RowListing(obj) {
  return (((obj instanceof $c_Lreactbuild_person_RowListing) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.RowListing"))
}
function $isArrayOf_Lreactbuild_person_RowListing(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_RowListing)))
}
function $asArrayOf_Lreactbuild_person_RowListing(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_RowListing(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.RowListing;", depth))
}
var $d_Lreactbuild_person_RowListing = new $TypeData().initClass({
  Lreactbuild_person_RowListing: 0
}, false, "reactbuild.person.RowListing", {
  Lreactbuild_person_RowListing: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_RowListing.prototype.$classData = $d_Lreactbuild_person_RowListing;
/** @constructor */
function $c_Lreactbuild_person_SupplyRow(_id, list, project, target, quantity) {
  this.Lreactbuild_person_SupplyRow__f__id = null;
  this.Lreactbuild_person_SupplyRow__f_list = null;
  this.Lreactbuild_person_SupplyRow__f_project = null;
  this.Lreactbuild_person_SupplyRow__f_target = null;
  this.Lreactbuild_person_SupplyRow__f_quantity = null;
  this.Lreactbuild_person_SupplyRow__f__id = _id;
  this.Lreactbuild_person_SupplyRow__f_list = list;
  this.Lreactbuild_person_SupplyRow__f_project = project;
  this.Lreactbuild_person_SupplyRow__f_target = target;
  this.Lreactbuild_person_SupplyRow__f_quantity = quantity
}
$c_Lreactbuild_person_SupplyRow.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRow.prototype.constructor = $c_Lreactbuild_person_SupplyRow;
/** @constructor */
function $h_Lreactbuild_person_SupplyRow() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRow.prototype = $c_Lreactbuild_person_SupplyRow.prototype;
$c_Lreactbuild_person_SupplyRow.prototype.productPrefix__T = (function() {
  return "SupplyRow"
});
$c_Lreactbuild_person_SupplyRow.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_person_SupplyRow.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_SupplyRow__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_person_SupplyRow__f_list;
      break
    }
    case 2: {
      return this.Lreactbuild_person_SupplyRow__f_project;
      break
    }
    case 3: {
      return this.Lreactbuild_person_SupplyRow__f_target;
      break
    }
    case 4: {
      return this.Lreactbuild_person_SupplyRow__f_quantity;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_SupplyRow.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_SupplyRow.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_SupplyRow.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_SupplyRow.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_SupplyRow)) {
    var SupplyRow$1 = $as_Lreactbuild_person_SupplyRow(x$1);
    var x = this.Lreactbuild_person_SupplyRow__f__id;
    var x$2 = $n(SupplyRow$1).Lreactbuild_person_SupplyRow__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_SupplyRow__f_list;
      var x$4 = $n(SupplyRow$1).Lreactbuild_person_SupplyRow__f_list;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_person_SupplyRow__f_project;
      var x$6 = $n(SupplyRow$1).Lreactbuild_person_SupplyRow__f_project;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_person_SupplyRow__f_target;
        var x$8 = $n(SupplyRow$1).Lreactbuild_person_SupplyRow__f_target;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_person_SupplyRow__f_quantity;
          var x$10 = $n(SupplyRow$1).Lreactbuild_person_SupplyRow__f_quantity;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_SupplyRow(obj) {
  return (((obj instanceof $c_Lreactbuild_person_SupplyRow) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.SupplyRow"))
}
function $isArrayOf_Lreactbuild_person_SupplyRow(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_SupplyRow)))
}
function $asArrayOf_Lreactbuild_person_SupplyRow(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_SupplyRow(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.SupplyRow;", depth))
}
var $d_Lreactbuild_person_SupplyRow = new $TypeData().initClass({
  Lreactbuild_person_SupplyRow: 0
}, false, "reactbuild.person.SupplyRow", {
  Lreactbuild_person_SupplyRow: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRow.prototype.$classData = $d_Lreactbuild_person_SupplyRow;
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6(outer) {
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6__f_circeGenericDecoderForstage = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6__f_circeGenericDecoderFortitle = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6__f_circeGenericDecoderForstage = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6__f_circeGenericDecoderFortitle = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString
}
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6.prototype = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6.prototype;
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("stage"))), this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6__f_circeGenericDecoderForstage, "stage", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6__f_circeGenericDecoderFortitle, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6: 0
}, false, "reactbuild.person.SupplyRowTarget$anon$lazy$macro$95$1$$anon$6", {
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7(outer) {
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7__f_circeGenericDecoderForelement = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7__f_circeGenericDecoderForconcrete = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7__f_circeGenericDecoderForelement = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7__f_circeGenericDecoderForconcrete = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7.prototype = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7.prototype;
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("element"))), this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7__f_circeGenericDecoderForelement, "element", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("concrete"))), this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7__f_circeGenericDecoderForconcrete, "concrete", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7: 0
}, false, "reactbuild.person.SupplyRowTarget$anon$lazy$macro$95$1$$anon$7", {
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8(outer) {
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8__f_circeGenericDecoderForelement = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8__f_circeGenericDecoderForelement = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder()
}
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8.prototype = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8.prototype;
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("element"))), this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8__f_circeGenericDecoderForelement, "element", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8: 0
}, false, "reactbuild.person.SupplyRowTarget$anon$lazy$macro$95$1$$anon$8", {
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$8;
/** @constructor */
function $c_Lreactbuild_person_SupplyTemplateList(_id, organization, title) {
  this.Lreactbuild_person_SupplyTemplateList__f__id = null;
  this.Lreactbuild_person_SupplyTemplateList__f_organization = null;
  this.Lreactbuild_person_SupplyTemplateList__f_title = null;
  this.Lreactbuild_person_SupplyTemplateList__f__id = _id;
  this.Lreactbuild_person_SupplyTemplateList__f_organization = organization;
  this.Lreactbuild_person_SupplyTemplateList__f_title = title
}
$c_Lreactbuild_person_SupplyTemplateList.prototype = new $h_O();
$c_Lreactbuild_person_SupplyTemplateList.prototype.constructor = $c_Lreactbuild_person_SupplyTemplateList;
/** @constructor */
function $h_Lreactbuild_person_SupplyTemplateList() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyTemplateList.prototype = $c_Lreactbuild_person_SupplyTemplateList.prototype;
$c_Lreactbuild_person_SupplyTemplateList.prototype.productPrefix__T = (function() {
  return "SupplyTemplateList"
});
$c_Lreactbuild_person_SupplyTemplateList.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_person_SupplyTemplateList.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_SupplyTemplateList__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_person_SupplyTemplateList__f_organization;
      break
    }
    case 2: {
      return this.Lreactbuild_person_SupplyTemplateList__f_title;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_SupplyTemplateList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_SupplyTemplateList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_SupplyTemplateList.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_SupplyTemplateList.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_SupplyTemplateList)) {
    var SupplyTemplateList$1 = $as_Lreactbuild_person_SupplyTemplateList(x$1);
    var x = this.Lreactbuild_person_SupplyTemplateList__f__id;
    var x$2 = $n(SupplyTemplateList$1).Lreactbuild_person_SupplyTemplateList__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_SupplyTemplateList__f_organization;
      var x$4 = $n(SupplyTemplateList$1).Lreactbuild_person_SupplyTemplateList__f_organization;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        return (this.Lreactbuild_person_SupplyTemplateList__f_title === $n(SupplyTemplateList$1).Lreactbuild_person_SupplyTemplateList__f_title)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_SupplyTemplateList(obj) {
  return (((obj instanceof $c_Lreactbuild_person_SupplyTemplateList) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.SupplyTemplateList"))
}
function $isArrayOf_Lreactbuild_person_SupplyTemplateList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_SupplyTemplateList)))
}
function $asArrayOf_Lreactbuild_person_SupplyTemplateList(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_SupplyTemplateList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.SupplyTemplateList;", depth))
}
var $d_Lreactbuild_person_SupplyTemplateList = new $TypeData().initClass({
  Lreactbuild_person_SupplyTemplateList: 0
}, false, "reactbuild.person.SupplyTemplateList", {
  Lreactbuild_person_SupplyTemplateList: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyTemplateList.prototype.$classData = $d_Lreactbuild_person_SupplyTemplateList;
/** @constructor */
function $c_Lreactbuild_plugins_devices_DeviceMeasure$State(active, bleDevices, events) {
  this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_active = false;
  this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices = null;
  this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_events = null;
  this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_active = active;
  this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices = bleDevices;
  this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_events = events
}
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype.constructor = $c_Lreactbuild_plugins_devices_DeviceMeasure$State;
/** @constructor */
function $h_Lreactbuild_plugins_devices_DeviceMeasure$State() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype = $c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype;
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_active;
      break
    }
    case 1: {
      return this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices;
      break
    }
    case 2: {
      return this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_events;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_active ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_events;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_plugins_devices_DeviceMeasure$State)) {
    var State$1 = $as_Lreactbuild_plugins_devices_DeviceMeasure$State(x$1);
    if ((this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_active === $n(State$1).Lreactbuild_plugins_devices_DeviceMeasure$State__f_active)) {
      var x = this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices;
      var x$2 = $n(State$1).Lreactbuild_plugins_devices_DeviceMeasure$State__f_bleDevices;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_plugins_devices_DeviceMeasure$State__f_events;
        var x$4 = $n(State$1).Lreactbuild_plugins_devices_DeviceMeasure$State__f_events;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_plugins_devices_DeviceMeasure$State(obj) {
  return (((obj instanceof $c_Lreactbuild_plugins_devices_DeviceMeasure$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.plugins.devices.DeviceMeasure$State"))
}
function $isArrayOf_Lreactbuild_plugins_devices_DeviceMeasure$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_plugins_devices_DeviceMeasure$State)))
}
function $asArrayOf_Lreactbuild_plugins_devices_DeviceMeasure$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_plugins_devices_DeviceMeasure$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.plugins.devices.DeviceMeasure$State;", depth))
}
var $d_Lreactbuild_plugins_devices_DeviceMeasure$State = new $TypeData().initClass({
  Lreactbuild_plugins_devices_DeviceMeasure$State: 0
}, false, "reactbuild.plugins.devices.DeviceMeasure$State", {
  Lreactbuild_plugins_devices_DeviceMeasure$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$State.prototype.$classData = $d_Lreactbuild_plugins_devices_DeviceMeasure$State;
/** @constructor */
function $c_Lreactbuild_plugins_devices_MeasureEvent(device, timeStamp, details) {
  this.Lreactbuild_plugins_devices_MeasureEvent__f_device = null;
  this.Lreactbuild_plugins_devices_MeasureEvent__f_timeStamp = 0.0;
  this.Lreactbuild_plugins_devices_MeasureEvent__f_details = null;
  this.Lreactbuild_plugins_devices_MeasureEvent__f_device = device;
  this.Lreactbuild_plugins_devices_MeasureEvent__f_timeStamp = timeStamp;
  this.Lreactbuild_plugins_devices_MeasureEvent__f_details = details
}
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype.constructor = $c_Lreactbuild_plugins_devices_MeasureEvent;
/** @constructor */
function $h_Lreactbuild_plugins_devices_MeasureEvent() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_MeasureEvent.prototype = $c_Lreactbuild_plugins_devices_MeasureEvent.prototype;
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype.productPrefix__T = (function() {
  return "MeasureEvent"
});
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_plugins_devices_MeasureEvent__f_device;
      break
    }
    case 1: {
      return this.Lreactbuild_plugins_devices_MeasureEvent__f_timeStamp;
      break
    }
    case 2: {
      return this.Lreactbuild_plugins_devices_MeasureEvent__f_details;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("MeasureEvent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_plugins_devices_MeasureEvent__f_device;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_plugins_devices_MeasureEvent__f_timeStamp;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_plugins_devices_MeasureEvent__f_details;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_plugins_devices_MeasureEvent)) {
    var MeasureEvent$1 = $as_Lreactbuild_plugins_devices_MeasureEvent(x$1);
    if ((this.Lreactbuild_plugins_devices_MeasureEvent__f_timeStamp === $n(MeasureEvent$1).Lreactbuild_plugins_devices_MeasureEvent__f_timeStamp)) {
      var x = this.Lreactbuild_plugins_devices_MeasureEvent__f_device;
      var x$2 = $n(MeasureEvent$1).Lreactbuild_plugins_devices_MeasureEvent__f_device;
      if ((x === null)) {
        var $$x1 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === x$2)
      };
      if ($$x1) {
        var x$3 = this.Lreactbuild_plugins_devices_MeasureEvent__f_details;
        var x$4 = $n(MeasureEvent$1).Lreactbuild_plugins_devices_MeasureEvent__f_details;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_plugins_devices_MeasureEvent(obj) {
  return (((obj instanceof $c_Lreactbuild_plugins_devices_MeasureEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.plugins.devices.MeasureEvent"))
}
function $isArrayOf_Lreactbuild_plugins_devices_MeasureEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_plugins_devices_MeasureEvent)))
}
function $asArrayOf_Lreactbuild_plugins_devices_MeasureEvent(obj, depth) {
  return (($isArrayOf_Lreactbuild_plugins_devices_MeasureEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.plugins.devices.MeasureEvent;", depth))
}
var $d_Lreactbuild_plugins_devices_MeasureEvent = new $TypeData().initClass({
  Lreactbuild_plugins_devices_MeasureEvent: 0
}, false, "reactbuild.plugins.devices.MeasureEvent", {
  Lreactbuild_plugins_devices_MeasureEvent: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_plugins_devices_MeasureEvent.prototype.$classData = $d_Lreactbuild_plugins_devices_MeasureEvent;
/** @constructor */
function $c_Lreactbuild_process_AddProcess$Creation(orgOpt, dateOpt, processRef, links) {
  this.Lreactbuild_process_AddProcess$Creation__f_orgOpt = null;
  this.Lreactbuild_process_AddProcess$Creation__f_dateOpt = null;
  this.Lreactbuild_process_AddProcess$Creation__f_processRef = null;
  this.Lreactbuild_process_AddProcess$Creation__f_links = null;
  this.Lreactbuild_process_AddProcess$Creation__f_orgOpt = orgOpt;
  this.Lreactbuild_process_AddProcess$Creation__f_dateOpt = dateOpt;
  this.Lreactbuild_process_AddProcess$Creation__f_processRef = processRef;
  this.Lreactbuild_process_AddProcess$Creation__f_links = links
}
$c_Lreactbuild_process_AddProcess$Creation.prototype = new $h_O();
$c_Lreactbuild_process_AddProcess$Creation.prototype.constructor = $c_Lreactbuild_process_AddProcess$Creation;
/** @constructor */
function $h_Lreactbuild_process_AddProcess$Creation() {
  /*<skip>*/
}
$h_Lreactbuild_process_AddProcess$Creation.prototype = $c_Lreactbuild_process_AddProcess$Creation.prototype;
$c_Lreactbuild_process_AddProcess$Creation.prototype.productPrefix__T = (function() {
  return "Creation"
});
$c_Lreactbuild_process_AddProcess$Creation.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_process_AddProcess$Creation.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_process_AddProcess$Creation__f_orgOpt;
      break
    }
    case 1: {
      return this.Lreactbuild_process_AddProcess$Creation__f_dateOpt;
      break
    }
    case 2: {
      return this.Lreactbuild_process_AddProcess$Creation__f_processRef;
      break
    }
    case 3: {
      return this.Lreactbuild_process_AddProcess$Creation__f_links;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_process_AddProcess$Creation.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_AddProcess$Creation.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_AddProcess$Creation.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_AddProcess$Creation.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_AddProcess$Creation)) {
    var Creation$1 = $as_Lreactbuild_process_AddProcess$Creation(x$1);
    var x = this.Lreactbuild_process_AddProcess$Creation__f_orgOpt;
    var x$2 = $n(Creation$1).Lreactbuild_process_AddProcess$Creation__f_orgOpt;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_process_AddProcess$Creation__f_dateOpt;
      var x$4 = $n(Creation$1).Lreactbuild_process_AddProcess$Creation__f_dateOpt;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_process_AddProcess$Creation__f_processRef;
      var x$6 = $n(Creation$1).Lreactbuild_process_AddProcess$Creation__f_processRef;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_process_AddProcess$Creation__f_links;
        var x$8 = $n(Creation$1).Lreactbuild_process_AddProcess$Creation__f_links;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_process_AddProcess$Creation(obj) {
  return (((obj instanceof $c_Lreactbuild_process_AddProcess$Creation) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.AddProcess$Creation"))
}
function $isArrayOf_Lreactbuild_process_AddProcess$Creation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_AddProcess$Creation)))
}
function $asArrayOf_Lreactbuild_process_AddProcess$Creation(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_AddProcess$Creation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.AddProcess$Creation;", depth))
}
var $d_Lreactbuild_process_AddProcess$Creation = new $TypeData().initClass({
  Lreactbuild_process_AddProcess$Creation: 0
}, false, "reactbuild.process.AddProcess$Creation", {
  Lreactbuild_process_AddProcess$Creation: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_AddProcess$Creation.prototype.$classData = $d_Lreactbuild_process_AddProcess$Creation;
/** @constructor */
function $c_Lreactbuild_process_AddProcess$Props(parentState, defaultLink) {
  this.Lreactbuild_process_AddProcess$Props__f_parentState = null;
  this.Lreactbuild_process_AddProcess$Props__f_defaultLink = null;
  this.Lreactbuild_process_AddProcess$Props__f_parentState = parentState;
  this.Lreactbuild_process_AddProcess$Props__f_defaultLink = defaultLink
}
$c_Lreactbuild_process_AddProcess$Props.prototype = new $h_O();
$c_Lreactbuild_process_AddProcess$Props.prototype.constructor = $c_Lreactbuild_process_AddProcess$Props;
/** @constructor */
function $h_Lreactbuild_process_AddProcess$Props() {
  /*<skip>*/
}
$h_Lreactbuild_process_AddProcess$Props.prototype = $c_Lreactbuild_process_AddProcess$Props.prototype;
$c_Lreactbuild_process_AddProcess$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_process_AddProcess$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_process_AddProcess$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_process_AddProcess$Props__f_parentState;
      break
    }
    case 1: {
      return this.Lreactbuild_process_AddProcess$Props__f_defaultLink;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_process_AddProcess$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_AddProcess$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_AddProcess$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_AddProcess$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_AddProcess$Props)) {
    var Props$1 = $as_Lreactbuild_process_AddProcess$Props(x$1);
    var x = this.Lreactbuild_process_AddProcess$Props__f_parentState;
    var x$2 = $n(Props$1).Lreactbuild_process_AddProcess$Props__f_parentState;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_process_AddProcess$Props__f_defaultLink;
      var x$4 = $n(Props$1).Lreactbuild_process_AddProcess$Props__f_defaultLink;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_process_AddProcess$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_process_AddProcess$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.AddProcess$Props"))
}
function $isArrayOf_Lreactbuild_process_AddProcess$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_AddProcess$Props)))
}
function $asArrayOf_Lreactbuild_process_AddProcess$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_AddProcess$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.AddProcess$Props;", depth))
}
var $d_Lreactbuild_process_AddProcess$Props = new $TypeData().initClass({
  Lreactbuild_process_AddProcess$Props: 0
}, false, "reactbuild.process.AddProcess$Props", {
  Lreactbuild_process_AddProcess$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_AddProcess$Props.prototype.$classData = $d_Lreactbuild_process_AddProcess$Props;
/** @constructor */
function $c_Lreactbuild_process_ListProcessInstance$Props(events, process) {
  this.Lreactbuild_process_ListProcessInstance$Props__f_events = null;
  this.Lreactbuild_process_ListProcessInstance$Props__f_process = null;
  this.Lreactbuild_process_ListProcessInstance$Props__f_events = events;
  this.Lreactbuild_process_ListProcessInstance$Props__f_process = process
}
$c_Lreactbuild_process_ListProcessInstance$Props.prototype = new $h_O();
$c_Lreactbuild_process_ListProcessInstance$Props.prototype.constructor = $c_Lreactbuild_process_ListProcessInstance$Props;
/** @constructor */
function $h_Lreactbuild_process_ListProcessInstance$Props() {
  /*<skip>*/
}
$h_Lreactbuild_process_ListProcessInstance$Props.prototype = $c_Lreactbuild_process_ListProcessInstance$Props.prototype;
$c_Lreactbuild_process_ListProcessInstance$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_process_ListProcessInstance$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_process_ListProcessInstance$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_process_ListProcessInstance$Props__f_events;
      break
    }
    case 1: {
      return this.Lreactbuild_process_ListProcessInstance$Props__f_process;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_process_ListProcessInstance$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_ListProcessInstance$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_ListProcessInstance$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_ListProcessInstance$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_ListProcessInstance$Props)) {
    var Props$1 = $as_Lreactbuild_process_ListProcessInstance$Props(x$1);
    var x = this.Lreactbuild_process_ListProcessInstance$Props__f_events;
    var x$2 = $n(Props$1).Lreactbuild_process_ListProcessInstance$Props__f_events;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_process_ListProcessInstance$Props__f_process;
      var x$4 = $n(Props$1).Lreactbuild_process_ListProcessInstance$Props__f_process;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_process_ListProcessInstance$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_process_ListProcessInstance$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.ListProcessInstance$Props"))
}
function $isArrayOf_Lreactbuild_process_ListProcessInstance$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_ListProcessInstance$Props)))
}
function $asArrayOf_Lreactbuild_process_ListProcessInstance$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_ListProcessInstance$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.ListProcessInstance$Props;", depth))
}
var $d_Lreactbuild_process_ListProcessInstance$Props = new $TypeData().initClass({
  Lreactbuild_process_ListProcessInstance$Props: 0
}, false, "reactbuild.process.ListProcessInstance$Props", {
  Lreactbuild_process_ListProcessInstance$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_ListProcessInstance$Props.prototype.$classData = $d_Lreactbuild_process_ListProcessInstance$Props;
/** @constructor */
function $c_Lreactbuild_process_NewProcessInstanceEvent$Props(defaultLink, parentState, f) {
  this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_defaultLink = null;
  this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_parentState = null;
  this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_f = null;
  this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_defaultLink = defaultLink;
  this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_parentState = parentState;
  this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_f = f
}
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype = new $h_O();
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype.constructor = $c_Lreactbuild_process_NewProcessInstanceEvent$Props;
/** @constructor */
function $h_Lreactbuild_process_NewProcessInstanceEvent$Props() {
  /*<skip>*/
}
$h_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype = $c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype;
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_defaultLink;
      break
    }
    case 1: {
      return this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_parentState;
      break
    }
    case 2: {
      return this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_NewProcessInstanceEvent$Props)) {
    var Props$1 = $as_Lreactbuild_process_NewProcessInstanceEvent$Props(x$1);
    var x = this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_defaultLink;
    var x$2 = $n(Props$1).Lreactbuild_process_NewProcessInstanceEvent$Props__f_defaultLink;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_parentState;
      var x$4 = $n(Props$1).Lreactbuild_process_NewProcessInstanceEvent$Props__f_parentState;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_process_NewProcessInstanceEvent$Props__f_f;
        var x$6 = $n(Props$1).Lreactbuild_process_NewProcessInstanceEvent$Props__f_f;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_process_NewProcessInstanceEvent$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_process_NewProcessInstanceEvent$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.NewProcessInstanceEvent$Props"))
}
function $isArrayOf_Lreactbuild_process_NewProcessInstanceEvent$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_NewProcessInstanceEvent$Props)))
}
function $asArrayOf_Lreactbuild_process_NewProcessInstanceEvent$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_NewProcessInstanceEvent$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.NewProcessInstanceEvent$Props;", depth))
}
var $d_Lreactbuild_process_NewProcessInstanceEvent$Props = new $TypeData().initClass({
  Lreactbuild_process_NewProcessInstanceEvent$Props: 0
}, false, "reactbuild.process.NewProcessInstanceEvent$Props", {
  Lreactbuild_process_NewProcessInstanceEvent$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_NewProcessInstanceEvent$Props.prototype.$classData = $d_Lreactbuild_process_NewProcessInstanceEvent$Props;
/** @constructor */
function $c_Lreactbuild_process_ProcessLinkList$Props(items) {
  this.Lreactbuild_process_ProcessLinkList$Props__f_items = null;
  this.Lreactbuild_process_ProcessLinkList$Props__f_items = items
}
$c_Lreactbuild_process_ProcessLinkList$Props.prototype = new $h_O();
$c_Lreactbuild_process_ProcessLinkList$Props.prototype.constructor = $c_Lreactbuild_process_ProcessLinkList$Props;
/** @constructor */
function $h_Lreactbuild_process_ProcessLinkList$Props() {
  /*<skip>*/
}
$h_Lreactbuild_process_ProcessLinkList$Props.prototype = $c_Lreactbuild_process_ProcessLinkList$Props.prototype;
$c_Lreactbuild_process_ProcessLinkList$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_process_ProcessLinkList$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_process_ProcessLinkList$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_process_ProcessLinkList$Props__f_items : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_process_ProcessLinkList$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_ProcessLinkList$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_ProcessLinkList$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_ProcessLinkList$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_ProcessLinkList$Props)) {
    var Props$1 = $as_Lreactbuild_process_ProcessLinkList$Props(x$1);
    var x = this.Lreactbuild_process_ProcessLinkList$Props__f_items;
    var x$2 = $n(Props$1).Lreactbuild_process_ProcessLinkList$Props__f_items;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_process_ProcessLinkList$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_process_ProcessLinkList$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.ProcessLinkList$Props"))
}
function $isArrayOf_Lreactbuild_process_ProcessLinkList$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_ProcessLinkList$Props)))
}
function $asArrayOf_Lreactbuild_process_ProcessLinkList$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_ProcessLinkList$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.ProcessLinkList$Props;", depth))
}
var $d_Lreactbuild_process_ProcessLinkList$Props = new $TypeData().initClass({
  Lreactbuild_process_ProcessLinkList$Props: 0
}, false, "reactbuild.process.ProcessLinkList$Props", {
  Lreactbuild_process_ProcessLinkList$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_ProcessLinkList$Props.prototype.$classData = $d_Lreactbuild_process_ProcessLinkList$Props;
/** @constructor */
function $c_Lreactbuild_process_Processes$Props(target, process, useArg) {
  this.Lreactbuild_process_Processes$Props__f_target = null;
  this.Lreactbuild_process_Processes$Props__f_process = null;
  this.Lreactbuild_process_Processes$Props__f_useArg = null;
  this.Lreactbuild_process_Processes$Props__f_target = target;
  this.Lreactbuild_process_Processes$Props__f_process = process;
  this.Lreactbuild_process_Processes$Props__f_useArg = useArg
}
$c_Lreactbuild_process_Processes$Props.prototype = new $h_O();
$c_Lreactbuild_process_Processes$Props.prototype.constructor = $c_Lreactbuild_process_Processes$Props;
/** @constructor */
function $h_Lreactbuild_process_Processes$Props() {
  /*<skip>*/
}
$h_Lreactbuild_process_Processes$Props.prototype = $c_Lreactbuild_process_Processes$Props.prototype;
$c_Lreactbuild_process_Processes$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_process_Processes$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_process_Processes$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_process_Processes$Props__f_target;
      break
    }
    case 1: {
      return this.Lreactbuild_process_Processes$Props__f_process;
      break
    }
    case 2: {
      return this.Lreactbuild_process_Processes$Props__f_useArg;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_process_Processes$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_Processes$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_Processes$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_Processes$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_Processes$Props)) {
    var Props$1 = $as_Lreactbuild_process_Processes$Props(x$1);
    var x = this.Lreactbuild_process_Processes$Props__f_target;
    var x$2 = $n(Props$1).Lreactbuild_process_Processes$Props__f_target;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_process_Processes$Props__f_process;
      var x$4 = $n(Props$1).Lreactbuild_process_Processes$Props__f_process;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      };
      if ($$x1) {
        var x$5 = this.Lreactbuild_process_Processes$Props__f_useArg;
        var x$6 = $n(Props$1).Lreactbuild_process_Processes$Props__f_useArg;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$2 = $n(x$5);
          return (this$2 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_process_Processes$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_process_Processes$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.Processes$Props"))
}
function $isArrayOf_Lreactbuild_process_Processes$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_Processes$Props)))
}
function $asArrayOf_Lreactbuild_process_Processes$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_Processes$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.Processes$Props;", depth))
}
var $d_Lreactbuild_process_Processes$Props = new $TypeData().initClass({
  Lreactbuild_process_Processes$Props: 0
}, false, "reactbuild.process.Processes$Props", {
  Lreactbuild_process_Processes$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_Processes$Props.prototype.$classData = $d_Lreactbuild_process_Processes$Props;
/** @constructor */
function $c_Lreactbuild_process_Processes$State(process, events, item) {
  this.Lreactbuild_process_Processes$State__f_process = null;
  this.Lreactbuild_process_Processes$State__f_events = null;
  this.Lreactbuild_process_Processes$State__f_item = null;
  this.Lreactbuild_process_Processes$State__f_process = process;
  this.Lreactbuild_process_Processes$State__f_events = events;
  this.Lreactbuild_process_Processes$State__f_item = item
}
$c_Lreactbuild_process_Processes$State.prototype = new $h_O();
$c_Lreactbuild_process_Processes$State.prototype.constructor = $c_Lreactbuild_process_Processes$State;
/** @constructor */
function $h_Lreactbuild_process_Processes$State() {
  /*<skip>*/
}
$h_Lreactbuild_process_Processes$State.prototype = $c_Lreactbuild_process_Processes$State.prototype;
$c_Lreactbuild_process_Processes$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_process_Processes$State.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_process_Processes$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_process_Processes$State__f_process;
      break
    }
    case 1: {
      return this.Lreactbuild_process_Processes$State__f_events;
      break
    }
    case 2: {
      return this.Lreactbuild_process_Processes$State__f_item;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_process_Processes$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_Processes$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_Processes$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_Processes$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_Processes$State)) {
    var State$1 = $as_Lreactbuild_process_Processes$State(x$1);
    var x = this.Lreactbuild_process_Processes$State__f_process;
    var x$2 = $n(State$1).Lreactbuild_process_Processes$State__f_process;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_process_Processes$State__f_events;
      var x$4 = $n(State$1).Lreactbuild_process_Processes$State__f_events;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_process_Processes$State__f_item;
        var x$6 = $n(State$1).Lreactbuild_process_Processes$State__f_item;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_process_Processes$State(obj) {
  return (((obj instanceof $c_Lreactbuild_process_Processes$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.Processes$State"))
}
function $isArrayOf_Lreactbuild_process_Processes$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_Processes$State)))
}
function $asArrayOf_Lreactbuild_process_Processes$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_Processes$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.Processes$State;", depth))
}
var $d_Lreactbuild_process_Processes$State = new $TypeData().initClass({
  Lreactbuild_process_Processes$State: 0
}, false, "reactbuild.process.Processes$State", {
  Lreactbuild_process_Processes$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_Processes$State.prototype.$classData = $d_Lreactbuild_process_Processes$State;
/** @constructor */
function $c_Lreactbuild_project_Areas$Area(name, label, order) {
  this.Lreactbuild_project_Areas$Area__f_name = null;
  this.Lreactbuild_project_Areas$Area__f_label = null;
  this.Lreactbuild_project_Areas$Area__f_order = 0;
  this.Lreactbuild_project_Areas$Area__f_name = name;
  this.Lreactbuild_project_Areas$Area__f_label = label;
  this.Lreactbuild_project_Areas$Area__f_order = order
}
$c_Lreactbuild_project_Areas$Area.prototype = new $h_O();
$c_Lreactbuild_project_Areas$Area.prototype.constructor = $c_Lreactbuild_project_Areas$Area;
/** @constructor */
function $h_Lreactbuild_project_Areas$Area() {
  /*<skip>*/
}
$h_Lreactbuild_project_Areas$Area.prototype = $c_Lreactbuild_project_Areas$Area.prototype;
$c_Lreactbuild_project_Areas$Area.prototype.productPrefix__T = (function() {
  return "Area"
});
$c_Lreactbuild_project_Areas$Area.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_Areas$Area.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_Areas$Area__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_project_Areas$Area__f_label;
      break
    }
    case 2: {
      return this.Lreactbuild_project_Areas$Area__f_order;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_Areas$Area.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_Areas$Area.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Area");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_Areas$Area__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_Areas$Area__f_label;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lreactbuild_project_Areas$Area__f_order;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_project_Areas$Area.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_Areas$Area.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_Areas$Area)) {
    var Area$1 = $as_Lreactbuild_project_Areas$Area(x$1);
    return (((this.Lreactbuild_project_Areas$Area__f_order === $n(Area$1).Lreactbuild_project_Areas$Area__f_order) && (this.Lreactbuild_project_Areas$Area__f_name === $n(Area$1).Lreactbuild_project_Areas$Area__f_name)) && ((this.Lreactbuild_project_Areas$Area__f_label === $n(Area$1).Lreactbuild_project_Areas$Area__f_label) && ($n(Area$1), true)))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_Areas$Area(obj) {
  return (((obj instanceof $c_Lreactbuild_project_Areas$Area) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.Areas$Area"))
}
function $isArrayOf_Lreactbuild_project_Areas$Area(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_Areas$Area)))
}
function $asArrayOf_Lreactbuild_project_Areas$Area(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_Areas$Area(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.Areas$Area;", depth))
}
var $d_Lreactbuild_project_Areas$Area = new $TypeData().initClass({
  Lreactbuild_project_Areas$Area: 0
}, false, "reactbuild.project.Areas$Area", {
  Lreactbuild_project_Areas$Area: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Areas$Area.prototype.$classData = $d_Lreactbuild_project_Areas$Area;
/** @constructor */
function $c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props(target) {
  this.Lreactbuild_project_CreateOrSelectLocalizedProject$Props__f_target = null;
  this.Lreactbuild_project_CreateOrSelectLocalizedProject$Props__f_target = target
}
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype = new $h_O();
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype.constructor = $c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props;
/** @constructor */
function $h_Lreactbuild_project_CreateOrSelectLocalizedProject$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype = $c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype;
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_CreateOrSelectLocalizedProject$Props__f_target : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props)) {
    var Props$1 = $as_Lreactbuild_project_CreateOrSelectLocalizedProject$Props(x$1);
    var x = this.Lreactbuild_project_CreateOrSelectLocalizedProject$Props__f_target;
    var x$2 = $n(Props$1).Lreactbuild_project_CreateOrSelectLocalizedProject$Props__f_target;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_CreateOrSelectLocalizedProject$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.CreateOrSelectLocalizedProject$Props"))
}
function $isArrayOf_Lreactbuild_project_CreateOrSelectLocalizedProject$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_CreateOrSelectLocalizedProject$Props)))
}
function $asArrayOf_Lreactbuild_project_CreateOrSelectLocalizedProject$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_CreateOrSelectLocalizedProject$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.CreateOrSelectLocalizedProject$Props;", depth))
}
var $d_Lreactbuild_project_CreateOrSelectLocalizedProject$Props = new $TypeData().initClass({
  Lreactbuild_project_CreateOrSelectLocalizedProject$Props: 0
}, false, "reactbuild.project.CreateOrSelectLocalizedProject$Props", {
  Lreactbuild_project_CreateOrSelectLocalizedProject$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_CreateOrSelectLocalizedProject$Props.prototype.$classData = $d_Lreactbuild_project_CreateOrSelectLocalizedProject$Props;
/** @constructor */
function $c_Lreactbuild_project_Page$Props(children) {
  this.Lreactbuild_project_Page$Props__f_children = null;
  this.Lreactbuild_project_Page$Props__f_children = children
}
$c_Lreactbuild_project_Page$Props.prototype = new $h_O();
$c_Lreactbuild_project_Page$Props.prototype.constructor = $c_Lreactbuild_project_Page$Props;
/** @constructor */
function $h_Lreactbuild_project_Page$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_Page$Props.prototype = $c_Lreactbuild_project_Page$Props.prototype;
$c_Lreactbuild_project_Page$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_Page$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_Page$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_Page$Props__f_children : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_Page$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_Page$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_Page$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_Page$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_Page$Props)) {
    var Props$1 = $as_Lreactbuild_project_Page$Props(x$1);
    var x = this.Lreactbuild_project_Page$Props__f_children;
    var x$2 = $n(Props$1).Lreactbuild_project_Page$Props__f_children;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_Page$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_Page$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.Page$Props"))
}
function $isArrayOf_Lreactbuild_project_Page$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_Page$Props)))
}
function $asArrayOf_Lreactbuild_project_Page$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_Page$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.Page$Props;", depth))
}
var $d_Lreactbuild_project_Page$Props = new $TypeData().initClass({
  Lreactbuild_project_Page$Props: 0
}, false, "reactbuild.project.Page$Props", {
  Lreactbuild_project_Page$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Page$Props.prototype.$classData = $d_Lreactbuild_project_Page$Props;
/** @constructor */
function $c_Lreactbuild_project_Page$State(print) {
  this.Lreactbuild_project_Page$State__f_print = false;
  this.Lreactbuild_project_Page$State__f_print = print
}
$c_Lreactbuild_project_Page$State.prototype = new $h_O();
$c_Lreactbuild_project_Page$State.prototype.constructor = $c_Lreactbuild_project_Page$State;
/** @constructor */
function $h_Lreactbuild_project_Page$State() {
  /*<skip>*/
}
$h_Lreactbuild_project_Page$State.prototype = $c_Lreactbuild_project_Page$State.prototype;
$c_Lreactbuild_project_Page$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_project_Page$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_Page$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_Page$State__f_print : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_Page$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_Page$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_project_Page$State__f_print ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_project_Page$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_Page$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_Page$State)) {
    var State$1 = $as_Lreactbuild_project_Page$State(x$1);
    return (this.Lreactbuild_project_Page$State__f_print === $n(State$1).Lreactbuild_project_Page$State__f_print)
  } else {
    return false
  }
});
function $as_Lreactbuild_project_Page$State(obj) {
  return (((obj instanceof $c_Lreactbuild_project_Page$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.Page$State"))
}
function $isArrayOf_Lreactbuild_project_Page$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_Page$State)))
}
function $asArrayOf_Lreactbuild_project_Page$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_Page$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.Page$State;", depth))
}
var $d_Lreactbuild_project_Page$State = new $TypeData().initClass({
  Lreactbuild_project_Page$State: 0
}, false, "reactbuild.project.Page$State", {
  Lreactbuild_project_Page$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Page$State.prototype.$classData = $d_Lreactbuild_project_Page$State;
/** @constructor */
function $c_Lreactbuild_project_PreviewDrawing$Props(project, modelSource, serverConnection) {
  this.Lreactbuild_project_PreviewDrawing$Props__f_project = null;
  this.Lreactbuild_project_PreviewDrawing$Props__f_modelSource = null;
  this.Lreactbuild_project_PreviewDrawing$Props__f_serverConnection = null;
  this.Lreactbuild_project_PreviewDrawing$Props__f_project = project;
  this.Lreactbuild_project_PreviewDrawing$Props__f_modelSource = modelSource;
  this.Lreactbuild_project_PreviewDrawing$Props__f_serverConnection = serverConnection
}
$c_Lreactbuild_project_PreviewDrawing$Props.prototype = new $h_O();
$c_Lreactbuild_project_PreviewDrawing$Props.prototype.constructor = $c_Lreactbuild_project_PreviewDrawing$Props;
/** @constructor */
function $h_Lreactbuild_project_PreviewDrawing$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_PreviewDrawing$Props.prototype = $c_Lreactbuild_project_PreviewDrawing$Props.prototype;
$c_Lreactbuild_project_PreviewDrawing$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_PreviewDrawing$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_PreviewDrawing$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_PreviewDrawing$Props__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_project_PreviewDrawing$Props__f_modelSource;
      break
    }
    case 2: {
      return this.Lreactbuild_project_PreviewDrawing$Props__f_serverConnection;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_PreviewDrawing$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_PreviewDrawing$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_PreviewDrawing$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_PreviewDrawing$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_PreviewDrawing$Props)) {
    var Props$1 = $as_Lreactbuild_project_PreviewDrawing$Props(x$1);
    var x = this.Lreactbuild_project_PreviewDrawing$Props__f_project;
    var x$2 = $n(Props$1).Lreactbuild_project_PreviewDrawing$Props__f_project;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      if ((this.Lreactbuild_project_PreviewDrawing$Props__f_modelSource === $n(Props$1).Lreactbuild_project_PreviewDrawing$Props__f_modelSource)) {
        var x$3 = this.Lreactbuild_project_PreviewDrawing$Props__f_serverConnection;
        var x$4 = $n(Props$1).Lreactbuild_project_PreviewDrawing$Props__f_serverConnection;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_PreviewDrawing$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_PreviewDrawing$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.PreviewDrawing$Props"))
}
function $isArrayOf_Lreactbuild_project_PreviewDrawing$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_PreviewDrawing$Props)))
}
function $asArrayOf_Lreactbuild_project_PreviewDrawing$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_PreviewDrawing$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.PreviewDrawing$Props;", depth))
}
var $d_Lreactbuild_project_PreviewDrawing$Props = new $TypeData().initClass({
  Lreactbuild_project_PreviewDrawing$Props: 0
}, false, "reactbuild.project.PreviewDrawing$Props", {
  Lreactbuild_project_PreviewDrawing$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_PreviewDrawing$Props.prototype.$classData = $d_Lreactbuild_project_PreviewDrawing$Props;
/** @constructor */
function $c_Lreactbuild_project_PreviewDrawing$State(scale, hideControls) {
  this.Lreactbuild_project_PreviewDrawing$State__f_scale = 0.0;
  this.Lreactbuild_project_PreviewDrawing$State__f_hideControls = false;
  this.Lreactbuild_project_PreviewDrawing$State__f_scale = scale;
  this.Lreactbuild_project_PreviewDrawing$State__f_hideControls = hideControls
}
$c_Lreactbuild_project_PreviewDrawing$State.prototype = new $h_O();
$c_Lreactbuild_project_PreviewDrawing$State.prototype.constructor = $c_Lreactbuild_project_PreviewDrawing$State;
/** @constructor */
function $h_Lreactbuild_project_PreviewDrawing$State() {
  /*<skip>*/
}
$h_Lreactbuild_project_PreviewDrawing$State.prototype = $c_Lreactbuild_project_PreviewDrawing$State.prototype;
$c_Lreactbuild_project_PreviewDrawing$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_project_PreviewDrawing$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_PreviewDrawing$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_PreviewDrawing$State__f_scale;
      break
    }
    case 1: {
      return this.Lreactbuild_project_PreviewDrawing$State__f_hideControls;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_PreviewDrawing$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_PreviewDrawing$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_project_PreviewDrawing$State__f_scale;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_project_PreviewDrawing$State__f_hideControls ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_project_PreviewDrawing$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_PreviewDrawing$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_PreviewDrawing$State)) {
    var State$1 = $as_Lreactbuild_project_PreviewDrawing$State(x$1);
    return ((this.Lreactbuild_project_PreviewDrawing$State__f_scale === $n(State$1).Lreactbuild_project_PreviewDrawing$State__f_scale) && (this.Lreactbuild_project_PreviewDrawing$State__f_hideControls === $n(State$1).Lreactbuild_project_PreviewDrawing$State__f_hideControls))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_PreviewDrawing$State(obj) {
  return (((obj instanceof $c_Lreactbuild_project_PreviewDrawing$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.PreviewDrawing$State"))
}
function $isArrayOf_Lreactbuild_project_PreviewDrawing$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_PreviewDrawing$State)))
}
function $asArrayOf_Lreactbuild_project_PreviewDrawing$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_PreviewDrawing$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.PreviewDrawing$State;", depth))
}
var $d_Lreactbuild_project_PreviewDrawing$State = new $TypeData().initClass({
  Lreactbuild_project_PreviewDrawing$State: 0
}, false, "reactbuild.project.PreviewDrawing$State", {
  Lreactbuild_project_PreviewDrawing$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_PreviewDrawing$State.prototype.$classData = $d_Lreactbuild_project_PreviewDrawing$State;
/** @constructor */
function $c_Lreactbuild_project_RenderingSettings(withPrice, forgetPages, format) {
  this.Lreactbuild_project_RenderingSettings__f_withPrice = false;
  this.Lreactbuild_project_RenderingSettings__f_forgetPages = null;
  this.Lreactbuild_project_RenderingSettings__f_format = null;
  this.Lreactbuild_project_RenderingSettings__f_withPrice = withPrice;
  this.Lreactbuild_project_RenderingSettings__f_forgetPages = forgetPages;
  this.Lreactbuild_project_RenderingSettings__f_format = format
}
$c_Lreactbuild_project_RenderingSettings.prototype = new $h_O();
$c_Lreactbuild_project_RenderingSettings.prototype.constructor = $c_Lreactbuild_project_RenderingSettings;
/** @constructor */
function $h_Lreactbuild_project_RenderingSettings() {
  /*<skip>*/
}
$h_Lreactbuild_project_RenderingSettings.prototype = $c_Lreactbuild_project_RenderingSettings.prototype;
$c_Lreactbuild_project_RenderingSettings.prototype.productPrefix__T = (function() {
  return "RenderingSettings"
});
$c_Lreactbuild_project_RenderingSettings.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_RenderingSettings.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_RenderingSettings__f_withPrice;
      break
    }
    case 1: {
      return this.Lreactbuild_project_RenderingSettings__f_forgetPages;
      break
    }
    case 2: {
      return this.Lreactbuild_project_RenderingSettings__f_format;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_RenderingSettings.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_RenderingSettings.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("RenderingSettings");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_project_RenderingSettings__f_withPrice ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_project_RenderingSettings__f_forgetPages;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_project_RenderingSettings__f_format;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_project_RenderingSettings.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_RenderingSettings.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_RenderingSettings)) {
    var RenderingSettings$1 = $as_Lreactbuild_project_RenderingSettings(x$1);
    if ((this.Lreactbuild_project_RenderingSettings__f_withPrice === $n(RenderingSettings$1).Lreactbuild_project_RenderingSettings__f_withPrice)) {
      var x = this.Lreactbuild_project_RenderingSettings__f_forgetPages;
      var x$2 = $n(RenderingSettings$1).Lreactbuild_project_RenderingSettings__f_forgetPages;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_RenderingSettings__f_format;
      var x$4 = $n(RenderingSettings$1).Lreactbuild_project_RenderingSettings__f_format;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x2 = (this$1 === x$4)
      };
      if ($$x2) {
        $n(RenderingSettings$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_RenderingSettings(obj) {
  return (((obj instanceof $c_Lreactbuild_project_RenderingSettings) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.RenderingSettings"))
}
function $isArrayOf_Lreactbuild_project_RenderingSettings(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_RenderingSettings)))
}
function $asArrayOf_Lreactbuild_project_RenderingSettings(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_RenderingSettings(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.RenderingSettings;", depth))
}
var $d_Lreactbuild_project_RenderingSettings = new $TypeData().initClass({
  Lreactbuild_project_RenderingSettings: 0
}, false, "reactbuild.project.RenderingSettings", {
  Lreactbuild_project_RenderingSettings: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_RenderingSettings.prototype.$classData = $d_Lreactbuild_project_RenderingSettings;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7(outer) {
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForproject = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForsupplier = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFordescription = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForbuildingStage = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForunit = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForquantity = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFortotal = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForparent = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForproject = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFordate = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForsupplier = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFordescription = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForbuildingStage = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForunit = new $c_Lio_circe_Decoder$$anon$39(d$2);
  $m_Lio_circe_Decoder$();
  var d$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForquantity = new $c_Lio_circe_Decoder$$anon$39(d$3);
  $m_Lio_circe_Decoder$();
  var d$4 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFortotal = new $c_Lio_circe_Decoder$$anon$39(d$4);
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForparent = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage
}
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7.prototype.constructor = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7.prototype = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7.prototype;
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("project"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForproject, "project", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("supplier"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForsupplier, "supplier", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForunit, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("description"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFordescription, "description", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingStage"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForbuildingStage, "buildingStage", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unitPrice"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFortotal, "unitPrice", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unit"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForunit, "unit", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("quantity"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForquantity, "quantity", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("total"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderFortotal, "total", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("parent"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7__f_circeGenericDecoderForparent, "parent", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7: 0
}, false, "reactbuild.project.ResourceUsage$anon$lazy$macro$267$1$$anon$7", {
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7.prototype.$classData = $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8(outer) {
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderForproject = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderForperson = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderForbuildingStage = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderFortotal = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderForproject = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderFordate = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderForperson = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderForbuildingStage = new $c_Lio_circe_Decoder$$anon$39(d$1);
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderFortotal = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_decodeDuration
}
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8.prototype.constructor = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8.prototype = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8.prototype;
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("project"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderForproject, "project", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("person"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderForperson, "person", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingStage"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderForbuildingStage, "buildingStage", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("total"))), this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8__f_circeGenericDecoderFortotal, "total", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8: 0
}, false, "reactbuild.project.ResourceUsage$anon$lazy$macro$267$1$$anon$8", {
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8.prototype.$classData = $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$8;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17(outer) {
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17__f_circeGenericDecoderForselection = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17__f_circeGenericDecoderForselection = $m_Lreactbuild_project_Selection$().decodeSelection__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder())
}
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17.prototype.constructor = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17.prototype = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17.prototype;
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("selection"))), this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17__f_circeGenericDecoderForselection, "selection", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17: 0
}, false, "reactbuild.project.ResourceUsageClause$anon$lazy$macro$43$1$$anon$17", {
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17.prototype.$classData = $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$17;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18(outer) {
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18__f_circeGenericDecoderForselection = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18__f_circeGenericDecoderForselection = $m_Lreactbuild_project_Selection$().decodeSelection__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder())
}
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18.prototype.constructor = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18.prototype = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18.prototype;
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("selection"))), this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18__f_circeGenericDecoderForselection, "selection", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18: 0
}, false, "reactbuild.project.ResourceUsageClause$anon$lazy$macro$43$1$$anon$18", {
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18.prototype.$classData = $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$18;
/** @constructor */
function $c_Lreactbuild_project_RichContent$Line(part) {
  this.Lreactbuild_project_RichContent$Line__f_part = null;
  this.Lreactbuild_project_RichContent$Line__f_part = part
}
$c_Lreactbuild_project_RichContent$Line.prototype = new $h_O();
$c_Lreactbuild_project_RichContent$Line.prototype.constructor = $c_Lreactbuild_project_RichContent$Line;
/** @constructor */
function $h_Lreactbuild_project_RichContent$Line() {
  /*<skip>*/
}
$h_Lreactbuild_project_RichContent$Line.prototype = $c_Lreactbuild_project_RichContent$Line.prototype;
$c_Lreactbuild_project_RichContent$Line.prototype.productPrefix__T = (function() {
  return "Line"
});
$c_Lreactbuild_project_RichContent$Line.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_RichContent$Line.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_RichContent$Line__f_part : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_RichContent$Line.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_RichContent$Line.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_RichContent$Line.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_RichContent$Line.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_RichContent$Line)) {
    var Line$1 = $as_Lreactbuild_project_RichContent$Line(x$1);
    var x = this.Lreactbuild_project_RichContent$Line__f_part;
    var x$2 = $n(Line$1).Lreactbuild_project_RichContent$Line__f_part;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Line$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_RichContent$Line(obj) {
  return (((obj instanceof $c_Lreactbuild_project_RichContent$Line) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.RichContent$Line"))
}
function $isArrayOf_Lreactbuild_project_RichContent$Line(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_RichContent$Line)))
}
function $asArrayOf_Lreactbuild_project_RichContent$Line(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_RichContent$Line(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.RichContent$Line;", depth))
}
var $d_Lreactbuild_project_RichContent$Line = new $TypeData().initClass({
  Lreactbuild_project_RichContent$Line: 0
}, false, "reactbuild.project.RichContent$Line", {
  Lreactbuild_project_RichContent$Line: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_RichContent$Line.prototype.$classData = $d_Lreactbuild_project_RichContent$Line;
/** @constructor */
function $c_Lreactbuild_project_RichContent$State(dones, stack) {
  this.Lreactbuild_project_RichContent$State__f_dones = null;
  this.Lreactbuild_project_RichContent$State__f_stack = null;
  this.Lreactbuild_project_RichContent$State__f_dones = dones;
  this.Lreactbuild_project_RichContent$State__f_stack = stack
}
$c_Lreactbuild_project_RichContent$State.prototype = new $h_O();
$c_Lreactbuild_project_RichContent$State.prototype.constructor = $c_Lreactbuild_project_RichContent$State;
/** @constructor */
function $h_Lreactbuild_project_RichContent$State() {
  /*<skip>*/
}
$h_Lreactbuild_project_RichContent$State.prototype = $c_Lreactbuild_project_RichContent$State.prototype;
$c_Lreactbuild_project_RichContent$State.prototype.closeStack__sci_List = (function() {
  var x1 = this.Lreactbuild_project_RichContent$State__f_stack;
  if ((x1 instanceof $c_s_Some)) {
    var this$3 = $n(this.Lreactbuild_project_RichContent$State__f_dones);
    var this$1 = $n(this.Lreactbuild_project_RichContent$State__f_stack);
    if (this$1.isEmpty__Z()) {
      var suffix = $m_s_None$()
    } else {
      var arg1 = this$1.get__O();
      var x$1 = $as_Lreactbuild_project_RichContent$Block(arg1);
      var this$2 = $n(x$1);
      var suffix = new $c_s_Some(this$2.apply__Ljapgolly_scalajs_react_vdom_TagOf())
    };
    return this$3.appendedAll__sc_IterableOnce__sci_List(suffix)
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return this.Lreactbuild_project_RichContent$State__f_dones
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_project_RichContent$State.prototype.newStack__Lreactbuild_project_RichContent$Block__Lreactbuild_project_RichContent$State = (function(block) {
  var dones = this.closeStack__sci_List();
  var stack = new $c_s_Some(block);
  return new $c_Lreactbuild_project_RichContent$State(dones, stack)
});
$c_Lreactbuild_project_RichContent$State.prototype.updateStack__Lreactbuild_project_RichContent$Block__Lreactbuild_project_RichContent$State = (function(block) {
  var dones = this.Lreactbuild_project_RichContent$State__f_dones;
  var stack = new $c_s_Some(block);
  return new $c_Lreactbuild_project_RichContent$State(dones, stack)
});
$c_Lreactbuild_project_RichContent$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_project_RichContent$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_RichContent$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_RichContent$State__f_dones;
      break
    }
    case 1: {
      return this.Lreactbuild_project_RichContent$State__f_stack;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_RichContent$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_RichContent$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_RichContent$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_RichContent$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_RichContent$State)) {
    var State$1 = $as_Lreactbuild_project_RichContent$State(x$1);
    var x = this.Lreactbuild_project_RichContent$State__f_dones;
    var x$2 = $n(State$1).Lreactbuild_project_RichContent$State__f_dones;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_RichContent$State__f_stack;
      var x$4 = $n(State$1).Lreactbuild_project_RichContent$State__f_stack;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(State$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_RichContent$State(obj) {
  return (((obj instanceof $c_Lreactbuild_project_RichContent$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.RichContent$State"))
}
function $isArrayOf_Lreactbuild_project_RichContent$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_RichContent$State)))
}
function $asArrayOf_Lreactbuild_project_RichContent$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_RichContent$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.RichContent$State;", depth))
}
var $d_Lreactbuild_project_RichContent$State = new $TypeData().initClass({
  Lreactbuild_project_RichContent$State: 0
}, false, "reactbuild.project.RichContent$State", {
  Lreactbuild_project_RichContent$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_RichContent$State.prototype.$classData = $d_Lreactbuild_project_RichContent$State;
/** @constructor */
function $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11(outer) {
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_circeGenericDecoderForAll = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_circeGenericDecoderForList = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_circeGenericDecoderForNone = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_$outer).inst$macro$15__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_circeGenericDecoderForAll = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_circeGenericDecoderForList = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_circeGenericDecoderForNone = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O())
}
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11.prototype.constructor = $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11;
/** @constructor */
function $h_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11.prototype = $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11.prototype;
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_circeGenericDecoderForAll, c, $as_T($n(transformConstructorNames).apply__O__O("All")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_project_Selection$All($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_circeGenericDecoderForList, c, $as_T($n(transformConstructorNames).apply__O__O("List")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_project_Selection$List($n(x2$4).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11__f_circeGenericDecoderForNone, c, $as_T($n(transformConstructorNames).apply__O__O("None")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_project_Selection$None($n(x2$6).s_util_Right__f_value);
            var x1$8 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$8 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          $m_Lio_circe_DecodingFailure$();
          var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
          var x1$7 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
          var err$4 = $as_Lio_circe_DecodingFailure(x1$7.s_util_Left__f_value);
          var x1$8 = new $c_s_util_Left(err$4)
        };
        if ((x1$8 instanceof $c_s_util_Right)) {
          var x2$8 = $as_s_util_Right(x1$8);
          var v$5 = $as_Lshapeless_$colon$plus$colon($n(x2$8).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$5))
        } else {
          if ((!(x1$8 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$8)
          };
          var x3$5 = $as_s_util_Left(x1$8);
          var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$5)
        }
      };
      if ((x1$9 instanceof $c_s_util_Right)) {
        var x2$9 = $as_s_util_Right(x1$9);
        var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$9).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
      } else if ((x1$9 instanceof $c_s_util_Left)) {
        var x3$6 = $as_s_util_Left(x1$9);
        var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
        return new $c_s_util_Left(err$6)
      } else {
        throw new $c_s_MatchError(x1$9)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
var $d_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11 = new $TypeData().initClass({
  Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11: 0
}, false, "reactbuild.project.Selection$anon$lazy$macro$16$1$$anon$11", {
  Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11.prototype.$classData = $d_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$11;
/** @constructor */
function $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12(outer) {
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12__f_circeGenericDecoderForitems = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $n(outer).Lreactbuild_project_Selection$anon$lazy$macro$16$1__f_decode0$1;
  this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12__f_circeGenericDecoderForitems = new $c_Lio_circe_Decoder$$anon$44(decodeA)
}
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12.prototype.constructor = $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12;
/** @constructor */
function $h_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12.prototype = $c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12.prototype;
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("items"))), this.Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12__f_circeGenericDecoderForitems, "items", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
var $d_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12 = new $TypeData().initClass({
  Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12: 0
}, false, "reactbuild.project.Selection$anon$lazy$macro$16$1$$anon$12", {
  Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12.prototype.$classData = $d_Lreactbuild_project_Selection$anon$lazy$macro$16$1$$anon$12;
/** @constructor */
function $c_Lreactbuild_project_ShowProjectAddress$Props(project, f) {
  this.Lreactbuild_project_ShowProjectAddress$Props__f_project = null;
  this.Lreactbuild_project_ShowProjectAddress$Props__f_f = null;
  this.Lreactbuild_project_ShowProjectAddress$Props__f_project = project;
  this.Lreactbuild_project_ShowProjectAddress$Props__f_f = f
}
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype = new $h_O();
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype.constructor = $c_Lreactbuild_project_ShowProjectAddress$Props;
/** @constructor */
function $h_Lreactbuild_project_ShowProjectAddress$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_ShowProjectAddress$Props.prototype = $c_Lreactbuild_project_ShowProjectAddress$Props.prototype;
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_ShowProjectAddress$Props__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_project_ShowProjectAddress$Props__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_ShowProjectAddress$Props)) {
    var Props$1 = $as_Lreactbuild_project_ShowProjectAddress$Props(x$1);
    var x = this.Lreactbuild_project_ShowProjectAddress$Props__f_project;
    var x$2 = $n(Props$1).Lreactbuild_project_ShowProjectAddress$Props__f_project;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_ShowProjectAddress$Props__f_f;
      var x$4 = $n(Props$1).Lreactbuild_project_ShowProjectAddress$Props__f_f;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_ShowProjectAddress$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_ShowProjectAddress$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.ShowProjectAddress$Props"))
}
function $isArrayOf_Lreactbuild_project_ShowProjectAddress$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_ShowProjectAddress$Props)))
}
function $asArrayOf_Lreactbuild_project_ShowProjectAddress$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_ShowProjectAddress$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.ShowProjectAddress$Props;", depth))
}
var $d_Lreactbuild_project_ShowProjectAddress$Props = new $TypeData().initClass({
  Lreactbuild_project_ShowProjectAddress$Props: 0
}, false, "reactbuild.project.ShowProjectAddress$Props", {
  Lreactbuild_project_ShowProjectAddress$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ShowProjectAddress$Props.prototype.$classData = $d_Lreactbuild_project_ShowProjectAddress$Props;
/** @constructor */
function $c_Lreactbuild_project_Summary$Props(project, allProjects, pageProps) {
  this.Lreactbuild_project_Summary$Props__f_project = null;
  this.Lreactbuild_project_Summary$Props__f_allProjects = null;
  this.Lreactbuild_project_Summary$Props__f_pageProps = null;
  this.Lreactbuild_project_Summary$Props__f_project = project;
  this.Lreactbuild_project_Summary$Props__f_allProjects = allProjects;
  this.Lreactbuild_project_Summary$Props__f_pageProps = pageProps
}
$c_Lreactbuild_project_Summary$Props.prototype = new $h_O();
$c_Lreactbuild_project_Summary$Props.prototype.constructor = $c_Lreactbuild_project_Summary$Props;
/** @constructor */
function $h_Lreactbuild_project_Summary$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_Summary$Props.prototype = $c_Lreactbuild_project_Summary$Props.prototype;
$c_Lreactbuild_project_Summary$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_Summary$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_Summary$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_Summary$Props__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_project_Summary$Props__f_allProjects;
      break
    }
    case 2: {
      return this.Lreactbuild_project_Summary$Props__f_pageProps;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_Summary$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_Summary$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_Summary$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_Summary$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_Summary$Props)) {
    var Props$1 = $as_Lreactbuild_project_Summary$Props(x$1);
    var x = this.Lreactbuild_project_Summary$Props__f_project;
    var x$2 = $n(Props$1).Lreactbuild_project_Summary$Props__f_project;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_Summary$Props__f_allProjects;
      var x$4 = $n(Props$1).Lreactbuild_project_Summary$Props__f_allProjects;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_project_Summary$Props__f_pageProps;
        var x$6 = $n(Props$1).Lreactbuild_project_Summary$Props__f_pageProps;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_Summary$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_Summary$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.Summary$Props"))
}
function $isArrayOf_Lreactbuild_project_Summary$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_Summary$Props)))
}
function $asArrayOf_Lreactbuild_project_Summary$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_Summary$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.Summary$Props;", depth))
}
var $d_Lreactbuild_project_Summary$Props = new $TypeData().initClass({
  Lreactbuild_project_Summary$Props: 0
}, false, "reactbuild.project.Summary$Props", {
  Lreactbuild_project_Summary$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Summary$Props.prototype.$classData = $d_Lreactbuild_project_Summary$Props;
/** @constructor */
function $c_Lreactbuild_project_TestBluetoothMeazor$Props() {
  /*<skip>*/
}
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype = new $h_O();
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype.constructor = $c_Lreactbuild_project_TestBluetoothMeazor$Props;
/** @constructor */
function $h_Lreactbuild_project_TestBluetoothMeazor$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_TestBluetoothMeazor$Props.prototype = $c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype;
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_TestBluetoothMeazor$Props)
});
function $as_Lreactbuild_project_TestBluetoothMeazor$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_TestBluetoothMeazor$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.TestBluetoothMeazor$Props"))
}
function $isArrayOf_Lreactbuild_project_TestBluetoothMeazor$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_TestBluetoothMeazor$Props)))
}
function $asArrayOf_Lreactbuild_project_TestBluetoothMeazor$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_TestBluetoothMeazor$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.TestBluetoothMeazor$Props;", depth))
}
var $d_Lreactbuild_project_TestBluetoothMeazor$Props = new $TypeData().initClass({
  Lreactbuild_project_TestBluetoothMeazor$Props: 0
}, false, "reactbuild.project.TestBluetoothMeazor$Props", {
  Lreactbuild_project_TestBluetoothMeazor$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_TestBluetoothMeazor$Props.prototype.$classData = $d_Lreactbuild_project_TestBluetoothMeazor$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Props(axis, position, hide, alignment) {
  this.Lreactbuild_project_drawing_Area$Props__f_axis = null;
  this.Lreactbuild_project_drawing_Area$Props__f_position = null;
  this.Lreactbuild_project_drawing_Area$Props__f_hide = false;
  this.Lreactbuild_project_drawing_Area$Props__f_alignment = null;
  this.Lreactbuild_project_drawing_Area$Props__f_axis = axis;
  this.Lreactbuild_project_drawing_Area$Props__f_position = position;
  this.Lreactbuild_project_drawing_Area$Props__f_hide = hide;
  this.Lreactbuild_project_drawing_Area$Props__f_alignment = alignment
}
$c_Lreactbuild_project_drawing_Area$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Props.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Props.prototype = $c_Lreactbuild_project_drawing_Area$Props.prototype;
$c_Lreactbuild_project_drawing_Area$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_Area$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_drawing_Area$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_Area$Props__f_axis;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_Area$Props__f_position;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_Area$Props__f_hide;
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_Area$Props__f_alignment;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_Area$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Area$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_drawing_Area$Props__f_axis;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_drawing_Area$Props__f_position;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lreactbuild_project_drawing_Area$Props__f_hide ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lreactbuild_project_drawing_Area$Props__f_alignment;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lreactbuild_project_drawing_Area$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_Area$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_Area$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_Area$Props(x$1);
    if ((this.Lreactbuild_project_drawing_Area$Props__f_hide === $n(Props$1).Lreactbuild_project_drawing_Area$Props__f_hide)) {
      var x = this.Lreactbuild_project_drawing_Area$Props__f_axis;
      var x$2 = $n(Props$1).Lreactbuild_project_drawing_Area$Props__f_axis;
      if ((x === null)) {
        var $$x1 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === x$2)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_drawing_Area$Props__f_position;
      var x$4 = $n(Props$1).Lreactbuild_project_drawing_Area$Props__f_position;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x$4)
      };
      if ($$x2) {
        var x$5 = this.Lreactbuild_project_drawing_Area$Props__f_alignment;
        var x$6 = $n(Props$1).Lreactbuild_project_drawing_Area$Props__f_alignment;
        if ((x$5 === null)) {
          var $$x3 = (x$6 === null)
        } else {
          var this$3 = $n(x$5);
          var $$x3 = (this$3 === x$6)
        };
        if ($$x3) {
          $n(Props$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_Area$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_Area$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Area$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_Area$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Area$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_Area$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Area$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Area$Props;", depth))
}
var $d_Lreactbuild_project_drawing_Area$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Props: 0
}, false, "reactbuild.project.drawing.Area$Props", {
  Lreactbuild_project_drawing_Area$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Area$Props.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_BoxedDrawingContext(context, size) {
  this.Lreactbuild_project_drawing_BoxedDrawingContext__f_context = null;
  this.Lreactbuild_project_drawing_BoxedDrawingContext__f_size = null;
  this.Lreactbuild_project_drawing_BoxedDrawingContext__f_context = context;
  this.Lreactbuild_project_drawing_BoxedDrawingContext__f_size = size
}
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype = new $h_O();
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype.constructor = $c_Lreactbuild_project_drawing_BoxedDrawingContext;
/** @constructor */
function $h_Lreactbuild_project_drawing_BoxedDrawingContext() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_BoxedDrawingContext.prototype = $c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype;
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype.productPrefix__T = (function() {
  return "BoxedDrawingContext"
});
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_BoxedDrawingContext__f_context;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_BoxedDrawingContext__f_size;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_BoxedDrawingContext)) {
    var BoxedDrawingContext$1 = $as_Lreactbuild_project_drawing_BoxedDrawingContext(x$1);
    var x = this.Lreactbuild_project_drawing_BoxedDrawingContext__f_context;
    var x$2 = $n(BoxedDrawingContext$1).Lreactbuild_project_drawing_BoxedDrawingContext__f_context;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_drawing_BoxedDrawingContext__f_size;
      var x$4 = $n(BoxedDrawingContext$1).Lreactbuild_project_drawing_BoxedDrawingContext__f_size;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_BoxedDrawingContext(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_BoxedDrawingContext) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.BoxedDrawingContext"))
}
function $isArrayOf_Lreactbuild_project_drawing_BoxedDrawingContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_BoxedDrawingContext)))
}
function $asArrayOf_Lreactbuild_project_drawing_BoxedDrawingContext(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_BoxedDrawingContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.BoxedDrawingContext;", depth))
}
var $d_Lreactbuild_project_drawing_BoxedDrawingContext = new $TypeData().initClass({
  Lreactbuild_project_drawing_BoxedDrawingContext: 0
}, false, "reactbuild.project.drawing.BoxedDrawingContext", {
  Lreactbuild_project_drawing_BoxedDrawingContext: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_BoxedDrawingContext.prototype.$classData = $d_Lreactbuild_project_drawing_BoxedDrawingContext;
/** @constructor */
function $c_Lreactbuild_project_drawing_Button$Props(icon, text, action, modifiers) {
  this.Lreactbuild_project_drawing_Button$Props__f_icon = null;
  this.Lreactbuild_project_drawing_Button$Props__f_text = null;
  this.Lreactbuild_project_drawing_Button$Props__f_action = null;
  this.Lreactbuild_project_drawing_Button$Props__f_modifiers = null;
  this.Lreactbuild_project_drawing_Button$Props__f_icon = icon;
  this.Lreactbuild_project_drawing_Button$Props__f_text = text;
  this.Lreactbuild_project_drawing_Button$Props__f_action = action;
  this.Lreactbuild_project_drawing_Button$Props__f_modifiers = modifiers
}
$c_Lreactbuild_project_drawing_Button$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Button$Props.prototype.constructor = $c_Lreactbuild_project_drawing_Button$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_Button$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Button$Props.prototype = $c_Lreactbuild_project_drawing_Button$Props.prototype;
$c_Lreactbuild_project_drawing_Button$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_Button$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_drawing_Button$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_Button$Props__f_icon;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_Button$Props__f_text;
      break
    }
    case 2: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_project_drawing_Button$Props__f_action);
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_Button$Props__f_modifiers;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_Button$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Button$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_Button$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_Button$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_Button$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_Button$Props(x$1);
    if (((this.Lreactbuild_project_drawing_Button$Props__f_icon === $n(Props$1).Lreactbuild_project_drawing_Button$Props__f_icon) && (this.Lreactbuild_project_drawing_Button$Props__f_text === $n(Props$1).Lreactbuild_project_drawing_Button$Props__f_text))) {
      var x = this.Lreactbuild_project_drawing_Button$Props__f_action;
      var x$2 = $n(Props$1).Lreactbuild_project_drawing_Button$Props__f_action;
      if ((x === null)) {
        var $$x1 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === x$2)
      };
      if ($$x1) {
        var x$3 = this.Lreactbuild_project_drawing_Button$Props__f_modifiers;
        var x$4 = $n(Props$1).Lreactbuild_project_drawing_Button$Props__f_modifiers;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          $n(Props$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_Button$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_Button$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Button$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_Button$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Button$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_Button$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Button$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Button$Props;", depth))
}
var $d_Lreactbuild_project_drawing_Button$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_Button$Props: 0
}, false, "reactbuild.project.drawing.Button$Props", {
  Lreactbuild_project_drawing_Button$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Button$Props.prototype.$classData = $d_Lreactbuild_project_drawing_Button$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawBuilding$Props(lod, context) {
  this.Lreactbuild_project_drawing_DrawBuilding$Props__f_lod = null;
  this.Lreactbuild_project_drawing_DrawBuilding$Props__f_context = null;
  this.Lreactbuild_project_drawing_DrawBuilding$Props__f_lod = lod;
  this.Lreactbuild_project_drawing_DrawBuilding$Props__f_context = context
}
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype.constructor = $c_Lreactbuild_project_drawing_DrawBuilding$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawBuilding$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawBuilding$Props.prototype = $c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype;
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_DrawBuilding$Props__f_lod;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_DrawBuilding$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_DrawBuilding$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_DrawBuilding$Props(x$1);
    var x = this.Lreactbuild_project_drawing_DrawBuilding$Props__f_lod;
    var x$2 = $n(Props$1).Lreactbuild_project_drawing_DrawBuilding$Props__f_lod;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_drawing_DrawBuilding$Props__f_context;
      var x$4 = $n(Props$1).Lreactbuild_project_drawing_DrawBuilding$Props__f_context;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_DrawBuilding$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawBuilding$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawBuilding$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawBuilding$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawBuilding$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawBuilding$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawBuilding$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawBuilding$Props;", depth))
}
var $d_Lreactbuild_project_drawing_DrawBuilding$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawBuilding$Props: 0
}, false, "reactbuild.project.drawing.DrawBuilding$Props", {
  Lreactbuild_project_drawing_DrawBuilding$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_DrawBuilding$Props.prototype.$classData = $d_Lreactbuild_project_drawing_DrawBuilding$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawStorey$Props(storeySS, lod, context) {
  this.Lreactbuild_project_drawing_DrawStorey$Props__f_storeySS = null;
  this.Lreactbuild_project_drawing_DrawStorey$Props__f_lod = null;
  this.Lreactbuild_project_drawing_DrawStorey$Props__f_context = null;
  this.Lreactbuild_project_drawing_DrawStorey$Props__f_storeySS = storeySS;
  this.Lreactbuild_project_drawing_DrawStorey$Props__f_lod = lod;
  this.Lreactbuild_project_drawing_DrawStorey$Props__f_context = context
}
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype.constructor = $c_Lreactbuild_project_drawing_DrawStorey$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawStorey$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawStorey$Props.prototype = $c_Lreactbuild_project_drawing_DrawStorey$Props.prototype;
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_DrawStorey$Props__f_storeySS;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_DrawStorey$Props__f_lod;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_DrawStorey$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_DrawStorey$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_DrawStorey$Props(x$1);
    var x = this.Lreactbuild_project_drawing_DrawStorey$Props__f_storeySS;
    var x$2 = $n(Props$1).Lreactbuild_project_drawing_DrawStorey$Props__f_storeySS;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_drawing_DrawStorey$Props__f_lod;
      var x$4 = $n(Props$1).Lreactbuild_project_drawing_DrawStorey$Props__f_lod;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x$4)
      };
      if ($$x2) {
        var x$5 = this.Lreactbuild_project_drawing_DrawStorey$Props__f_context;
        var x$6 = $n(Props$1).Lreactbuild_project_drawing_DrawStorey$Props__f_context;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_DrawStorey$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawStorey$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawStorey$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawStorey$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawStorey$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawStorey$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawStorey$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawStorey$Props;", depth))
}
var $d_Lreactbuild_project_drawing_DrawStorey$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawStorey$Props: 0
}, false, "reactbuild.project.drawing.DrawStorey$Props", {
  Lreactbuild_project_drawing_DrawStorey$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_DrawStorey$Props.prototype.$classData = $d_Lreactbuild_project_drawing_DrawStorey$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingContext$Props(project, serverConnection, modelSource, scale, space, render) {
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_project = null;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_serverConnection = null;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_modelSource = null;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_scale = 0.0;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_space = null;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_render = null;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_project = project;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_serverConnection = serverConnection;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_modelSource = modelSource;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_scale = scale;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_space = space;
  this.Lreactbuild_project_drawing_DrawingContext$Props__f_render = render
}
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingContext$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingContext$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingContext$Props.prototype = $c_Lreactbuild_project_drawing_DrawingContext$Props.prototype;
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_DrawingContext$Props__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_DrawingContext$Props__f_serverConnection;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_DrawingContext$Props__f_modelSource;
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_DrawingContext$Props__f_scale;
      break
    }
    case 4: {
      return this.Lreactbuild_project_drawing_DrawingContext$Props__f_space;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_drawing_DrawingContext$Props__f_project;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_drawing_DrawingContext$Props__f_serverConnection;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_project_drawing_DrawingContext$Props__f_modelSource;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv = this.Lreactbuild_project_drawing_DrawingContext$Props__f_scale;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lreactbuild_project_drawing_DrawingContext$Props__f_space;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_DrawingContext$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_DrawingContext$Props(x$1);
    if ((this.Lreactbuild_project_drawing_DrawingContext$Props__f_scale === $n(Props$1).Lreactbuild_project_drawing_DrawingContext$Props__f_scale)) {
      var x = this.Lreactbuild_project_drawing_DrawingContext$Props__f_project;
      var x$2 = $n(Props$1).Lreactbuild_project_drawing_DrawingContext$Props__f_project;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_drawing_DrawingContext$Props__f_serverConnection;
      var x$4 = $n(Props$1).Lreactbuild_project_drawing_DrawingContext$Props__f_serverConnection;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        if ((this.Lreactbuild_project_drawing_DrawingContext$Props__f_modelSource === $n(Props$1).Lreactbuild_project_drawing_DrawingContext$Props__f_modelSource)) {
          var x$5 = this.Lreactbuild_project_drawing_DrawingContext$Props__f_space;
          var x$6 = $n(Props$1).Lreactbuild_project_drawing_DrawingContext$Props__f_space;
          return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_DrawingContext$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawingContext$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawingContext$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawingContext$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawingContext$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawingContext$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawingContext$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawingContext$Props;", depth))
}
var $d_Lreactbuild_project_drawing_DrawingContext$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingContext$Props: 0
}, false, "reactbuild.project.drawing.DrawingContext$Props", {
  Lreactbuild_project_drawing_DrawingContext$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_DrawingContext$Props.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingContext$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingContext$State(theme, layers, translation, zoomLevel, hideControls, debug, tool, cursors, showLightArea, showAccessibleArea, size) {
  this.Lreactbuild_project_drawing_DrawingContext$State__f_theme = null;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_layers = null;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_translation = null;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel = 0.0;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls = false;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_debug = false;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_tool = null;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_cursors = null;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea = false;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea = false;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_size = null;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_theme = theme;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_layers = layers;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_translation = translation;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel = zoomLevel;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls = hideControls;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_debug = debug;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_tool = tool;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_cursors = cursors;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea = showLightArea;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea = showAccessibleArea;
  this.Lreactbuild_project_drawing_DrawingContext$State__f_size = size
}
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingContext$State;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingContext$State() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingContext$State.prototype = $c_Lreactbuild_project_drawing_DrawingContext$State.prototype;
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.pushRemoteCursor__Lreactbuild_project_drawing_RemoteCursor__Lreactbuild_project_drawing_DrawingContext$State = (function(c) {
  var this$1 = $n(this.Lreactbuild_project_drawing_DrawingContext$State__f_cursors);
  _return: {
    var i = 0;
    var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$1, 0, this$1);
    while (true) {
      var this$4 = $n(these);
      if ((!this$4.isEmpty__Z())) {
        var arg1 = $n(these).head__O();
        var x$1 = $as_Lreactbuild_project_drawing_RemoteCursor(arg1);
        var x = $n(x$1).Lreactbuild_project_drawing_RemoteCursor__f_id;
        var x$2 = $n(c).Lreactbuild_project_drawing_RemoteCursor__f_id;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          var x1 = i;
          break _return
        };
        i = ((1 + i) | 0);
        these = $as_sc_LinearSeq($n(these).tail__O())
      } else {
        break
      }
    };
    var x1 = (-1)
  };
  if ((x1 === (-1))) {
    var this$5 = $n(this.Lreactbuild_project_drawing_DrawingContext$State__f_cursors);
    var x$1$3 = new $c_sci_$colon$colon(c, this$5)
  } else {
    var this$7 = $n(this.Lreactbuild_project_drawing_DrawingContext$State__f_cursors);
    var this$6 = $n($m_s_package$().s_package$__f_Nil);
    var other = new $c_sci_$colon$colon(c, this$6);
    var x$1$3 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$7, x1, other, 1))
  };
  var x$2$1 = this.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
  var x$3 = this.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
  var x$4 = this.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
  var x$5 = this.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
  var x$6 = this.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
  var x$7 = this.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
  var x$8 = this.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
  var x$9 = this.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
  var x$10 = this.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
  var x$11 = this.Lreactbuild_project_drawing_DrawingContext$State__f_size;
  return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$2$1, x$3, x$4, x$5, x$6, x$7, x$8, x$1$3, x$9, x$10, x$11)
});
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.productArity__I = (function() {
  return 11
});
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      break
    }
    case 4: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      break
    }
    case 5: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      break
    }
    case 6: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      break
    }
    case 7: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      break
    }
    case 8: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      break
    }
    case 9: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      break
    }
    case 10: {
      return this.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv = this.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lreactbuild_project_drawing_DrawingContext$State__f_debug ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$3 = this.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$4 = this.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var data$9 = (this.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var data$10 = (this.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var x$5 = this.Lreactbuild_project_drawing_DrawingContext$State__f_size;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$12, 11)
});
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_DrawingContext$State)) {
    var State$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$1);
    if ((((this.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel === $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel) && (this.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls === $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_hideControls)) && ((this.Lreactbuild_project_drawing_DrawingContext$State__f_debug === $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_debug) && ((this.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea === $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea) && (this.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea === $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea))))) {
      var x = this.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var x$2 = $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
        var x$4 = $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_layers;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
          var x$6 = $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_translation;
          var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$7 = this.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
        var x$8 = $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_tool;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
          var x$10 = $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
          if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
            var x$11 = this.Lreactbuild_project_drawing_DrawingContext$State__f_size;
            var x$12 = $n(State$1).Lreactbuild_project_drawing_DrawingContext$State__f_size;
            return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_DrawingContext$State(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawingContext$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawingContext$State"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawingContext$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawingContext$State)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawingContext$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawingContext$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawingContext$State;", depth))
}
var $d_Lreactbuild_project_drawing_DrawingContext$State = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingContext$State: 0
}, false, "reactbuild.project.drawing.DrawingContext$State", {
  Lreactbuild_project_drawing_DrawingContext$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_DrawingContext$State.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingContext$State;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingParser$Model(building, ids) {
  this.Lreactbuild_project_drawing_DrawingParser$Model__f_building = null;
  this.Lreactbuild_project_drawing_DrawingParser$Model__f_ids = null;
  this.Lreactbuild_project_drawing_DrawingParser$Model__f_building = building;
  this.Lreactbuild_project_drawing_DrawingParser$Model__f_ids = ids
}
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingParser$Model;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingParser$Model() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingParser$Model.prototype = $c_Lreactbuild_project_drawing_DrawingParser$Model.prototype;
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype.productPrefix__T = (function() {
  return "Model"
});
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_DrawingParser$Model__f_building;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_DrawingParser$Model__f_ids;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_DrawingParser$Model)) {
    var Model$1 = $as_Lreactbuild_project_drawing_DrawingParser$Model(x$1);
    var x = this.Lreactbuild_project_drawing_DrawingParser$Model__f_building;
    var x$2 = $n(Model$1).Lreactbuild_project_drawing_DrawingParser$Model__f_building;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_drawing_DrawingParser$Model__f_ids;
      var x$4 = $n(Model$1).Lreactbuild_project_drawing_DrawingParser$Model__f_ids;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_DrawingParser$Model(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawingParser$Model) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawingParser$Model"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawingParser$Model(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawingParser$Model)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawingParser$Model(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawingParser$Model(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawingParser$Model;", depth))
}
var $d_Lreactbuild_project_drawing_DrawingParser$Model = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingParser$Model: 0
}, false, "reactbuild.project.drawing.DrawingParser$Model", {
  Lreactbuild_project_drawing_DrawingParser$Model: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_DrawingParser$Model.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingParser$Model;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingParser$Props(modelSource, f) {
  this.Lreactbuild_project_drawing_DrawingParser$Props__f_modelSource = null;
  this.Lreactbuild_project_drawing_DrawingParser$Props__f_f = null;
  this.Lreactbuild_project_drawing_DrawingParser$Props__f_modelSource = modelSource;
  this.Lreactbuild_project_drawing_DrawingParser$Props__f_f = f
}
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingParser$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingParser$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingParser$Props.prototype = $c_Lreactbuild_project_drawing_DrawingParser$Props.prototype;
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_DrawingParser$Props__f_modelSource;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_DrawingParser$Props__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_DrawingParser$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_DrawingParser$Props(x$1);
    if ((this.Lreactbuild_project_drawing_DrawingParser$Props__f_modelSource === $n(Props$1).Lreactbuild_project_drawing_DrawingParser$Props__f_modelSource)) {
      var x = this.Lreactbuild_project_drawing_DrawingParser$Props__f_f;
      var x$2 = $n(Props$1).Lreactbuild_project_drawing_DrawingParser$Props__f_f;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_DrawingParser$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawingParser$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawingParser$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawingParser$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawingParser$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawingParser$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawingParser$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawingParser$Props;", depth))
}
var $d_Lreactbuild_project_drawing_DrawingParser$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingParser$Props: 0
}, false, "reactbuild.project.drawing.DrawingParser$Props", {
  Lreactbuild_project_drawing_DrawingParser$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_DrawingParser$Props.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingParser$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingParser$State(model) {
  this.Lreactbuild_project_drawing_DrawingParser$State__f_model = null;
  this.Lreactbuild_project_drawing_DrawingParser$State__f_model = model
}
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingParser$State;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingParser$State() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingParser$State.prototype = $c_Lreactbuild_project_drawing_DrawingParser$State.prototype;
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_drawing_DrawingParser$State__f_model : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_DrawingParser$State)) {
    var State$1 = $as_Lreactbuild_project_drawing_DrawingParser$State(x$1);
    var x = this.Lreactbuild_project_drawing_DrawingParser$State__f_model;
    var x$2 = $n(State$1).Lreactbuild_project_drawing_DrawingParser$State__f_model;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_DrawingParser$State(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawingParser$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawingParser$State"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawingParser$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawingParser$State)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawingParser$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawingParser$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawingParser$State;", depth))
}
var $d_Lreactbuild_project_drawing_DrawingParser$State = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingParser$State: 0
}, false, "reactbuild.project.drawing.DrawingParser$State", {
  Lreactbuild_project_drawing_DrawingParser$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_DrawingParser$State.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingParser$State;
/** @constructor */
function $c_Lreactbuild_project_drawing_Layers(layers) {
  this.Lreactbuild_project_drawing_Layers__f_layers = null;
  this.Lreactbuild_project_drawing_Layers__f_layers = layers
}
$c_Lreactbuild_project_drawing_Layers.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Layers.prototype.constructor = $c_Lreactbuild_project_drawing_Layers;
/** @constructor */
function $h_Lreactbuild_project_drawing_Layers() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Layers.prototype = $c_Lreactbuild_project_drawing_Layers.prototype;
$c_Lreactbuild_project_drawing_Layers.prototype.withLayer__Lreactbuild_project_drawing_BuildingPart__Z__Lreactbuild_project_drawing_Layers = (function(part, value) {
  if ((value === true)) {
    var this$1 = $n(this.Lreactbuild_project_drawing_Layers__f_layers);
    var $$x1 = $as_sci_Set(this$1.excl__O__sci_SetOps(part))
  } else if ((value === false)) {
    var this$2 = $n(this.Lreactbuild_project_drawing_Layers__f_layers);
    var $$x1 = $as_sci_Set(this$2.incl__O__sci_SetOps(part))
  } else {
    var $$x1;
    throw new $c_s_MatchError(value)
  };
  return new $c_Lreactbuild_project_drawing_Layers($$x1)
});
$c_Lreactbuild_project_drawing_Layers.prototype.productPrefix__T = (function() {
  return "Layers"
});
$c_Lreactbuild_project_drawing_Layers.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_drawing_Layers.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_drawing_Layers__f_layers : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_drawing_Layers.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Layers.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_Layers.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_Layers.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_Layers)) {
    var Layers$1 = $as_Lreactbuild_project_drawing_Layers(x$1);
    var x = this.Lreactbuild_project_drawing_Layers__f_layers;
    var x$2 = $n(Layers$1).Lreactbuild_project_drawing_Layers__f_layers;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_Layers(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_Layers) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Layers"))
}
function $isArrayOf_Lreactbuild_project_drawing_Layers(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Layers)))
}
function $asArrayOf_Lreactbuild_project_drawing_Layers(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Layers(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Layers;", depth))
}
var $d_Lreactbuild_project_drawing_Layers = new $TypeData().initClass({
  Lreactbuild_project_drawing_Layers: 0
}, false, "reactbuild.project.drawing.Layers", {
  Lreactbuild_project_drawing_Layers: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Layers.prototype.$classData = $d_Lreactbuild_project_drawing_Layers;
/** @constructor */
function $c_Lreactbuild_project_drawing_OrientedRulers(direction, positions) {
  this.Lreactbuild_project_drawing_OrientedRulers__f_direction = null;
  this.Lreactbuild_project_drawing_OrientedRulers__f_positions = null;
  this.Lreactbuild_project_drawing_OrientedRulers__f_positionLines = null;
  this.Lreactbuild_project_drawing_OrientedRulers__f_direction = direction;
  this.Lreactbuild_project_drawing_OrientedRulers__f_positions = positions;
  new $c_Lreactbuild_geom_Vector2($n(direction).Lreactbuild_geom_Vector2__f_y, (-$n(direction).Lreactbuild_geom_Vector2__f_x));
  this.Lreactbuild_project_drawing_OrientedRulers__f_positionLines = $as_sci_Seq($n(positions).map__F1__O(new $c_sjsr_AnonFunction1(((pt$2) => {
    var pt = $as_Lreactbuild_geom_Point2(pt$2);
    var y = new $c_Lreactbuild_geom_Line2(pt, this.Lreactbuild_project_drawing_OrientedRulers__f_direction);
    return $ct_T2__O__O__(new $c_T2(), pt, y)
  }))))
}
$c_Lreactbuild_project_drawing_OrientedRulers.prototype = new $h_O();
$c_Lreactbuild_project_drawing_OrientedRulers.prototype.constructor = $c_Lreactbuild_project_drawing_OrientedRulers;
/** @constructor */
function $h_Lreactbuild_project_drawing_OrientedRulers() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_OrientedRulers.prototype = $c_Lreactbuild_project_drawing_OrientedRulers.prototype;
$c_Lreactbuild_project_drawing_OrientedRulers.prototype.productPrefix__T = (function() {
  return "OrientedRulers"
});
$c_Lreactbuild_project_drawing_OrientedRulers.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_drawing_OrientedRulers.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_OrientedRulers__f_direction;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_OrientedRulers__f_positions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_OrientedRulers.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_OrientedRulers.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_OrientedRulers.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_OrientedRulers.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_OrientedRulers)) {
    var OrientedRulers$1 = $as_Lreactbuild_project_drawing_OrientedRulers(x$1);
    var x = this.Lreactbuild_project_drawing_OrientedRulers__f_direction;
    var x$2 = $n(OrientedRulers$1).Lreactbuild_project_drawing_OrientedRulers__f_direction;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_drawing_OrientedRulers__f_positions;
      var x$4 = $n(OrientedRulers$1).Lreactbuild_project_drawing_OrientedRulers__f_positions;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_OrientedRulers(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_OrientedRulers) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.OrientedRulers"))
}
function $isArrayOf_Lreactbuild_project_drawing_OrientedRulers(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_OrientedRulers)))
}
function $asArrayOf_Lreactbuild_project_drawing_OrientedRulers(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_OrientedRulers(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.OrientedRulers;", depth))
}
var $d_Lreactbuild_project_drawing_OrientedRulers = new $TypeData().initClass({
  Lreactbuild_project_drawing_OrientedRulers: 0
}, false, "reactbuild.project.drawing.OrientedRulers", {
  Lreactbuild_project_drawing_OrientedRulers: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_OrientedRulers.prototype.$classData = $d_Lreactbuild_project_drawing_OrientedRulers;
/** @constructor */
function $c_Lreactbuild_project_drawing_Theme(defaultColor, font, colorMapping) {
  this.Lreactbuild_project_drawing_Theme__f_defaultColor = null;
  this.Lreactbuild_project_drawing_Theme__f_font = null;
  this.Lreactbuild_project_drawing_Theme__f_colorMapping = null;
  this.Lreactbuild_project_drawing_Theme__f_defaultColor = defaultColor;
  this.Lreactbuild_project_drawing_Theme__f_font = font;
  this.Lreactbuild_project_drawing_Theme__f_colorMapping = colorMapping
}
$c_Lreactbuild_project_drawing_Theme.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Theme.prototype.constructor = $c_Lreactbuild_project_drawing_Theme;
/** @constructor */
function $h_Lreactbuild_project_drawing_Theme() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Theme.prototype = $c_Lreactbuild_project_drawing_Theme.prototype;
$c_Lreactbuild_project_drawing_Theme.prototype.apply__Lreactbuild_project_drawing_BuildingPart__T = (function(part) {
  return $as_T($n(this.Lreactbuild_project_drawing_Theme__f_colorMapping).getOrElse__O__F0__O(part, new $c_sjsr_AnonFunction0((() => this.Lreactbuild_project_drawing_Theme__f_defaultColor))))
});
$c_Lreactbuild_project_drawing_Theme.prototype.productPrefix__T = (function() {
  return "Theme"
});
$c_Lreactbuild_project_drawing_Theme.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_drawing_Theme.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_Theme__f_defaultColor;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_Theme__f_font;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_Theme__f_colorMapping;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_Theme.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Theme.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_Theme.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_Theme.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_Theme)) {
    var Theme$1 = $as_Lreactbuild_project_drawing_Theme(x$1);
    if ((this.Lreactbuild_project_drawing_Theme__f_defaultColor === $n(Theme$1).Lreactbuild_project_drawing_Theme__f_defaultColor)) {
      if ((this.Lreactbuild_project_drawing_Theme__f_font === $n(Theme$1).Lreactbuild_project_drawing_Theme__f_font)) {
        var x = this.Lreactbuild_project_drawing_Theme__f_colorMapping;
        var x$2 = $n(Theme$1).Lreactbuild_project_drawing_Theme__f_colorMapping;
        return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_Theme(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_Theme) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Theme"))
}
function $isArrayOf_Lreactbuild_project_drawing_Theme(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Theme)))
}
function $asArrayOf_Lreactbuild_project_drawing_Theme(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Theme(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Theme;", depth))
}
var $d_Lreactbuild_project_drawing_Theme = new $TypeData().initClass({
  Lreactbuild_project_drawing_Theme: 0
}, false, "reactbuild.project.drawing.Theme", {
  Lreactbuild_project_drawing_Theme: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Theme.prototype.$classData = $d_Lreactbuild_project_drawing_Theme;
/** @constructor */
function $c_Lreactbuild_project_drawing_ToolControls$Props(tool, context) {
  this.Lreactbuild_project_drawing_ToolControls$Props__f_tool = null;
  this.Lreactbuild_project_drawing_ToolControls$Props__f_context = null;
  this.Lreactbuild_project_drawing_ToolControls$Props__f_tool = tool;
  this.Lreactbuild_project_drawing_ToolControls$Props__f_context = context
}
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype.constructor = $c_Lreactbuild_project_drawing_ToolControls$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_ToolControls$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_ToolControls$Props.prototype = $c_Lreactbuild_project_drawing_ToolControls$Props.prototype;
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_ToolControls$Props__f_tool;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_ToolControls$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_ToolControls$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_ToolControls$Props(x$1);
    var x = this.Lreactbuild_project_drawing_ToolControls$Props__f_tool;
    var x$2 = $n(Props$1).Lreactbuild_project_drawing_ToolControls$Props__f_tool;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_drawing_ToolControls$Props__f_context;
      var x$4 = $n(Props$1).Lreactbuild_project_drawing_ToolControls$Props__f_context;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_ToolControls$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_ToolControls$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.ToolControls$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_ToolControls$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_ToolControls$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_ToolControls$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_ToolControls$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.ToolControls$Props;", depth))
}
var $d_Lreactbuild_project_drawing_ToolControls$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_ToolControls$Props: 0
}, false, "reactbuild.project.drawing.ToolControls$Props", {
  Lreactbuild_project_drawing_ToolControls$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_ToolControls$Props.prototype.$classData = $d_Lreactbuild_project_drawing_ToolControls$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_ToolSelector$Props(project, hidecontrols, fullScreen, context) {
  this.Lreactbuild_project_drawing_ToolSelector$Props__f_project = null;
  this.Lreactbuild_project_drawing_ToolSelector$Props__f_hidecontrols = false;
  this.Lreactbuild_project_drawing_ToolSelector$Props__f_fullScreen = null;
  this.Lreactbuild_project_drawing_ToolSelector$Props__f_context = null;
  this.Lreactbuild_project_drawing_ToolSelector$Props__f_project = project;
  this.Lreactbuild_project_drawing_ToolSelector$Props__f_hidecontrols = hidecontrols;
  this.Lreactbuild_project_drawing_ToolSelector$Props__f_fullScreen = fullScreen;
  this.Lreactbuild_project_drawing_ToolSelector$Props__f_context = context
}
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype.constructor = $c_Lreactbuild_project_drawing_ToolSelector$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_ToolSelector$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_ToolSelector$Props.prototype = $c_Lreactbuild_project_drawing_ToolSelector$Props.prototype;
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_ToolSelector$Props__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_ToolSelector$Props__f_hidecontrols;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_ToolSelector$Props__f_fullScreen;
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_ToolSelector$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_drawing_ToolSelector$Props__f_project;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_project_drawing_ToolSelector$Props__f_hidecontrols ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_project_drawing_ToolSelector$Props__f_fullScreen;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lreactbuild_project_drawing_ToolSelector$Props__f_context;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_ToolSelector$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_ToolSelector$Props(x$1);
    if ((this.Lreactbuild_project_drawing_ToolSelector$Props__f_hidecontrols === $n(Props$1).Lreactbuild_project_drawing_ToolSelector$Props__f_hidecontrols)) {
      var x = this.Lreactbuild_project_drawing_ToolSelector$Props__f_project;
      var x$2 = $n(Props$1).Lreactbuild_project_drawing_ToolSelector$Props__f_project;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_drawing_ToolSelector$Props__f_fullScreen;
      var x$4 = $n(Props$1).Lreactbuild_project_drawing_ToolSelector$Props__f_fullScreen;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x2 = (this$1 === x$4)
      };
      if ($$x2) {
        var x$5 = this.Lreactbuild_project_drawing_ToolSelector$Props__f_context;
        var x$6 = $n(Props$1).Lreactbuild_project_drawing_ToolSelector$Props__f_context;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_ToolSelector$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_ToolSelector$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.ToolSelector$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_ToolSelector$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_ToolSelector$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_ToolSelector$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_ToolSelector$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.ToolSelector$Props;", depth))
}
var $d_Lreactbuild_project_drawing_ToolSelector$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_ToolSelector$Props: 0
}, false, "reactbuild.project.drawing.ToolSelector$Props", {
  Lreactbuild_project_drawing_ToolSelector$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_ToolSelector$Props.prototype.$classData = $d_Lreactbuild_project_drawing_ToolSelector$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_ToolSelector$State() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype = new $h_O();
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype.constructor = $c_Lreactbuild_project_drawing_ToolSelector$State;
/** @constructor */
function $h_Lreactbuild_project_drawing_ToolSelector$State() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_ToolSelector$State.prototype = $c_Lreactbuild_project_drawing_ToolSelector$State.prototype;
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype.equals__O__Z = (function(x$1) {
  return ((x$1 instanceof $c_Lreactbuild_project_drawing_ToolSelector$State) && ($n($as_Lreactbuild_project_drawing_ToolSelector$State(x$1)), true))
});
function $as_Lreactbuild_project_drawing_ToolSelector$State(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_ToolSelector$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.ToolSelector$State"))
}
function $isArrayOf_Lreactbuild_project_drawing_ToolSelector$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_ToolSelector$State)))
}
function $asArrayOf_Lreactbuild_project_drawing_ToolSelector$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_ToolSelector$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.ToolSelector$State;", depth))
}
var $d_Lreactbuild_project_drawing_ToolSelector$State = new $TypeData().initClass({
  Lreactbuild_project_drawing_ToolSelector$State: 0
}, false, "reactbuild.project.drawing.ToolSelector$State", {
  Lreactbuild_project_drawing_ToolSelector$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_ToolSelector$State.prototype.$classData = $d_Lreactbuild_project_drawing_ToolSelector$State;
/** @constructor */
function $c_Lreactbuild_project_drawing_View$Props(project, hideControls, tool, context) {
  this.Lreactbuild_project_drawing_View$Props__f_project = null;
  this.Lreactbuild_project_drawing_View$Props__f_hideControls = false;
  this.Lreactbuild_project_drawing_View$Props__f_tool = null;
  this.Lreactbuild_project_drawing_View$Props__f_context = null;
  this.Lreactbuild_project_drawing_View$Props__f_project = project;
  this.Lreactbuild_project_drawing_View$Props__f_hideControls = hideControls;
  this.Lreactbuild_project_drawing_View$Props__f_tool = tool;
  this.Lreactbuild_project_drawing_View$Props__f_context = context
}
$c_Lreactbuild_project_drawing_View$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_View$Props.prototype.constructor = $c_Lreactbuild_project_drawing_View$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_View$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_View$Props.prototype = $c_Lreactbuild_project_drawing_View$Props.prototype;
$c_Lreactbuild_project_drawing_View$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_View$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_drawing_View$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_View$Props__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_View$Props__f_hideControls;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_View$Props__f_tool;
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_View$Props__f_context;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_View$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_View$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_drawing_View$Props__f_project;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_project_drawing_View$Props__f_hideControls ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_project_drawing_View$Props__f_tool;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lreactbuild_project_drawing_View$Props__f_context;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lreactbuild_project_drawing_View$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_View$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_View$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_View$Props(x$1);
    if ((this.Lreactbuild_project_drawing_View$Props__f_hideControls === $n(Props$1).Lreactbuild_project_drawing_View$Props__f_hideControls)) {
      var x = this.Lreactbuild_project_drawing_View$Props__f_project;
      var x$2 = $n(Props$1).Lreactbuild_project_drawing_View$Props__f_project;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_drawing_View$Props__f_tool;
      var x$4 = $n(Props$1).Lreactbuild_project_drawing_View$Props__f_tool;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_project_drawing_View$Props__f_context;
        var x$6 = $n(Props$1).Lreactbuild_project_drawing_View$Props__f_context;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_View$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_View$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.View$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_View$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_View$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_View$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_View$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.View$Props;", depth))
}
var $d_Lreactbuild_project_drawing_View$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_View$Props: 0
}, false, "reactbuild.project.drawing.View$Props", {
  Lreactbuild_project_drawing_View$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_View$Props.prototype.$classData = $d_Lreactbuild_project_drawing_View$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_View$State(fullScreen) {
  this.Lreactbuild_project_drawing_View$State__f_fullScreen = false;
  this.Lreactbuild_project_drawing_View$State__f_fullScreen = fullScreen
}
$c_Lreactbuild_project_drawing_View$State.prototype = new $h_O();
$c_Lreactbuild_project_drawing_View$State.prototype.constructor = $c_Lreactbuild_project_drawing_View$State;
/** @constructor */
function $h_Lreactbuild_project_drawing_View$State() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_View$State.prototype = $c_Lreactbuild_project_drawing_View$State.prototype;
$c_Lreactbuild_project_drawing_View$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_project_drawing_View$State.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_drawing_View$State.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_drawing_View$State__f_fullScreen : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_drawing_View$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_View$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_project_drawing_View$State__f_fullScreen ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_project_drawing_View$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_View$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_View$State)) {
    var State$1 = $as_Lreactbuild_project_drawing_View$State(x$1);
    return (this.Lreactbuild_project_drawing_View$State__f_fullScreen === $n(State$1).Lreactbuild_project_drawing_View$State__f_fullScreen)
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_View$State(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_View$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.View$State"))
}
function $isArrayOf_Lreactbuild_project_drawing_View$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_View$State)))
}
function $asArrayOf_Lreactbuild_project_drawing_View$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_View$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.View$State;", depth))
}
var $d_Lreactbuild_project_drawing_View$State = new $TypeData().initClass({
  Lreactbuild_project_drawing_View$State: 0
}, false, "reactbuild.project.drawing.View$State", {
  Lreactbuild_project_drawing_View$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_View$State.prototype.$classData = $d_Lreactbuild_project_drawing_View$State;
/** @constructor */
function $c_Lreactbuild_project_drawing_Viewport$Props(context) {
  this.Lreactbuild_project_drawing_Viewport$Props__f_context = null;
  this.Lreactbuild_project_drawing_Viewport$Props__f_context = context
}
$c_Lreactbuild_project_drawing_Viewport$Props.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Viewport$Props.prototype.constructor = $c_Lreactbuild_project_drawing_Viewport$Props;
/** @constructor */
function $h_Lreactbuild_project_drawing_Viewport$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Viewport$Props.prototype = $c_Lreactbuild_project_drawing_Viewport$Props.prototype;
$c_Lreactbuild_project_drawing_Viewport$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_drawing_Viewport$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_drawing_Viewport$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_drawing_Viewport$Props__f_context : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_drawing_Viewport$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Viewport$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_Viewport$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_Viewport$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_Viewport$Props)) {
    var Props$1 = $as_Lreactbuild_project_drawing_Viewport$Props(x$1);
    var x = this.Lreactbuild_project_drawing_Viewport$Props__f_context;
    var x$2 = $n(Props$1).Lreactbuild_project_drawing_Viewport$Props__f_context;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_Viewport$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_Viewport$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Viewport$Props"))
}
function $isArrayOf_Lreactbuild_project_drawing_Viewport$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Viewport$Props)))
}
function $asArrayOf_Lreactbuild_project_drawing_Viewport$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Viewport$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Viewport$Props;", depth))
}
var $d_Lreactbuild_project_drawing_Viewport$Props = new $TypeData().initClass({
  Lreactbuild_project_drawing_Viewport$Props: 0
}, false, "reactbuild.project.drawing.Viewport$Props", {
  Lreactbuild_project_drawing_Viewport$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Viewport$Props.prototype.$classData = $d_Lreactbuild_project_drawing_Viewport$Props;
/** @constructor */
function $c_Lreactbuild_project_drawing_Viewport$State() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Viewport$State.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Viewport$State.prototype.constructor = $c_Lreactbuild_project_drawing_Viewport$State;
/** @constructor */
function $h_Lreactbuild_project_drawing_Viewport$State() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Viewport$State.prototype = $c_Lreactbuild_project_drawing_Viewport$State.prototype;
$c_Lreactbuild_project_drawing_Viewport$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_project_drawing_Viewport$State.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Viewport$State.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Viewport$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Viewport$State.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_Viewport$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_Viewport$State.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_drawing_Viewport$State)
});
function $as_Lreactbuild_project_drawing_Viewport$State(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_Viewport$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.Viewport$State"))
}
function $isArrayOf_Lreactbuild_project_drawing_Viewport$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_Viewport$State)))
}
function $asArrayOf_Lreactbuild_project_drawing_Viewport$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_Viewport$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.Viewport$State;", depth))
}
var $d_Lreactbuild_project_drawing_Viewport$State = new $TypeData().initClass({
  Lreactbuild_project_drawing_Viewport$State: 0
}, false, "reactbuild.project.drawing.Viewport$State", {
  Lreactbuild_project_drawing_Viewport$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Viewport$State.prototype.$classData = $d_Lreactbuild_project_drawing_Viewport$State;
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(distance, projectedPoint, geometry, side, wallOrigin, wallEnd, wallVector, wallIndex, wallPosition) {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_distance = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_projectedPoint = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_geometry = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_side = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallOrigin = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallEnd = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallVector = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallIndex = 0;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallPosition = 0.0;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_distance = distance;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_projectedPoint = projectedPoint;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_geometry = geometry;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_side = side;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallOrigin = wallOrigin;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallEnd = wallEnd;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallVector = wallVector;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallIndex = wallIndex;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallPosition = wallPosition
}
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype.constructor = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype;
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype.productPrefix__T = (function() {
  return "FoundWall"
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype.productArity__I = (function() {
  return 9
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_distance;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_projectedPoint;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_geometry;
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_side;
      break
    }
    case 4: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallOrigin;
      break
    }
    case 5: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallEnd;
      break
    }
    case 6: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallVector;
      break
    }
    case 7: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallIndex;
      break
    }
    case 8: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallPosition;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("FoundWall");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_distance;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_projectedPoint;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_geometry;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_side;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallOrigin;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$5 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallEnd;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$6 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallVector;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var data$8 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallIndex;
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var dv = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallPosition;
  var data$9 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$10, 9)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall)) {
    var FoundWall$1 = $as_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(x$1);
    if (((this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallIndex === $n(FoundWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallIndex) && (this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallPosition === $n(FoundWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallPosition))) {
      var x = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_distance;
      var x$2 = $n(FoundWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_distance;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_projectedPoint;
        var x$4 = $n(FoundWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_projectedPoint;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_geometry;
      var x$6 = $n(FoundWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_geometry;
      if ((x$5 === null)) {
        var $$x3 = (x$6 === null)
      } else {
        var this$1 = $n(x$5);
        var $$x3 = (this$1 === x$6)
      };
      if ($$x3) {
        var x$7 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_side;
        var x$8 = $n(FoundWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_side;
        if ((x$7 === null)) {
          var $$x2 = (x$8 === null)
        } else {
          var this$2 = $n(x$7);
          var $$x2 = (this$2 === x$8)
        }
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$9 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallOrigin;
        var x$10 = $n(FoundWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallOrigin;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallEnd;
          var x$12 = $n(FoundWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallEnd;
          if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
            var x$13 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallVector;
            var x$14 = $n(FoundWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallVector;
            return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.tool.PlaceNetworkTerminal$FoundWall"))
}
function $isArrayOf_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall)))
}
function $asArrayOf_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.tool.PlaceNetworkTerminal$FoundWall;", depth))
}
var $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall: 0
}, false, "reactbuild.project.drawing.tool.PlaceNetworkTerminal$FoundWall", {
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall.prototype.$classData = $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall;
/** @constructor */
function $c_Lreactbuild_project_generator_Generator$Props(project, allProjects, documentType, pageProps) {
  this.Lreactbuild_project_generator_Generator$Props__f_project = null;
  this.Lreactbuild_project_generator_Generator$Props__f_allProjects = null;
  this.Lreactbuild_project_generator_Generator$Props__f_documentType = null;
  this.Lreactbuild_project_generator_Generator$Props__f_pageProps = null;
  this.Lreactbuild_project_generator_Generator$Props__f_project = project;
  this.Lreactbuild_project_generator_Generator$Props__f_allProjects = allProjects;
  this.Lreactbuild_project_generator_Generator$Props__f_documentType = documentType;
  this.Lreactbuild_project_generator_Generator$Props__f_pageProps = pageProps
}
$c_Lreactbuild_project_generator_Generator$Props.prototype = new $h_O();
$c_Lreactbuild_project_generator_Generator$Props.prototype.constructor = $c_Lreactbuild_project_generator_Generator$Props;
/** @constructor */
function $h_Lreactbuild_project_generator_Generator$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_Generator$Props.prototype = $c_Lreactbuild_project_generator_Generator$Props.prototype;
$c_Lreactbuild_project_generator_Generator$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_generator_Generator$Props.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_generator_Generator$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_Generator$Props__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_Generator$Props__f_allProjects;
      break
    }
    case 2: {
      return this.Lreactbuild_project_generator_Generator$Props__f_documentType;
      break
    }
    case 3: {
      return this.Lreactbuild_project_generator_Generator$Props__f_pageProps;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_Generator$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_Generator$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_Generator$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_Generator$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_Generator$Props)) {
    var Props$1 = $as_Lreactbuild_project_generator_Generator$Props(x$1);
    var x = this.Lreactbuild_project_generator_Generator$Props__f_project;
    var x$2 = $n(Props$1).Lreactbuild_project_generator_Generator$Props__f_project;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_generator_Generator$Props__f_allProjects;
      var x$4 = $n(Props$1).Lreactbuild_project_generator_Generator$Props__f_allProjects;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_project_generator_Generator$Props__f_documentType;
      var x$6 = $n(Props$1).Lreactbuild_project_generator_Generator$Props__f_documentType;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_project_generator_Generator$Props__f_pageProps;
        var x$8 = $n(Props$1).Lreactbuild_project_generator_Generator$Props__f_pageProps;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_Generator$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_Generator$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.Generator$Props"))
}
function $isArrayOf_Lreactbuild_project_generator_Generator$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_Generator$Props)))
}
function $asArrayOf_Lreactbuild_project_generator_Generator$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_Generator$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.Generator$Props;", depth))
}
var $d_Lreactbuild_project_generator_Generator$Props = new $TypeData().initClass({
  Lreactbuild_project_generator_Generator$Props: 0
}, false, "reactbuild.project.generator.Generator$Props", {
  Lreactbuild_project_generator_Generator$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_Generator$Props.prototype.$classData = $d_Lreactbuild_project_generator_Generator$Props;
/** @constructor */
function $c_Lreactbuild_project_generator_GeneratorPageContext(output) {
  this.Lreactbuild_project_generator_GeneratorPageContext__f_output = null;
  this.Lreactbuild_project_generator_GeneratorPageContext__f_output = output
}
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype = new $h_O();
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype.constructor = $c_Lreactbuild_project_generator_GeneratorPageContext;
/** @constructor */
function $h_Lreactbuild_project_generator_GeneratorPageContext() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_GeneratorPageContext.prototype = $c_Lreactbuild_project_generator_GeneratorPageContext.prototype;
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype.productPrefix__T = (function() {
  return "GeneratorPageContext"
});
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_generator_GeneratorPageContext__f_output : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_GeneratorPageContext)) {
    var GeneratorPageContext$1 = $as_Lreactbuild_project_generator_GeneratorPageContext(x$1);
    var x = this.Lreactbuild_project_generator_GeneratorPageContext__f_output;
    var x$2 = $n(GeneratorPageContext$1).Lreactbuild_project_generator_GeneratorPageContext__f_output;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_GeneratorPageContext(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_GeneratorPageContext) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.GeneratorPageContext"))
}
function $isArrayOf_Lreactbuild_project_generator_GeneratorPageContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_GeneratorPageContext)))
}
function $asArrayOf_Lreactbuild_project_generator_GeneratorPageContext(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_GeneratorPageContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.GeneratorPageContext;", depth))
}
var $d_Lreactbuild_project_generator_GeneratorPageContext = new $TypeData().initClass({
  Lreactbuild_project_generator_GeneratorPageContext: 0
}, false, "reactbuild.project.generator.GeneratorPageContext", {
  Lreactbuild_project_generator_GeneratorPageContext: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_GeneratorPageContext.prototype.$classData = $d_Lreactbuild_project_generator_GeneratorPageContext;
/** @constructor */
function $c_Lreactbuild_project_generator_MediaSize(size) {
  this.Lreactbuild_project_generator_MediaSize__f_size = null;
  this.Lreactbuild_project_generator_MediaSize__f_size = size
}
$c_Lreactbuild_project_generator_MediaSize.prototype = new $h_O();
$c_Lreactbuild_project_generator_MediaSize.prototype.constructor = $c_Lreactbuild_project_generator_MediaSize;
/** @constructor */
function $h_Lreactbuild_project_generator_MediaSize() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_MediaSize.prototype = $c_Lreactbuild_project_generator_MediaSize.prototype;
$c_Lreactbuild_project_generator_MediaSize.prototype.productPrefix__T = (function() {
  return "MediaSize"
});
$c_Lreactbuild_project_generator_MediaSize.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_generator_MediaSize.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_generator_MediaSize__f_size : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_generator_MediaSize.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_MediaSize.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_MediaSize.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_MediaSize.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_MediaSize)) {
    var MediaSize$1 = $as_Lreactbuild_project_generator_MediaSize(x$1);
    var x = this.Lreactbuild_project_generator_MediaSize__f_size;
    var x$2 = $n(MediaSize$1).Lreactbuild_project_generator_MediaSize__f_size;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_MediaSize(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_MediaSize) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.MediaSize"))
}
function $isArrayOf_Lreactbuild_project_generator_MediaSize(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_MediaSize)))
}
function $asArrayOf_Lreactbuild_project_generator_MediaSize(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_MediaSize(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.MediaSize;", depth))
}
var $d_Lreactbuild_project_generator_MediaSize = new $TypeData().initClass({
  Lreactbuild_project_generator_MediaSize: 0
}, false, "reactbuild.project.generator.MediaSize", {
  Lreactbuild_project_generator_MediaSize: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_MediaSize.prototype.$classData = $d_Lreactbuild_project_generator_MediaSize;
/** @constructor */
function $c_Lreactbuild_project_generator_Notice$Props(projectPot, subprojects) {
  this.Lreactbuild_project_generator_Notice$Props__f_projectPot = null;
  this.Lreactbuild_project_generator_Notice$Props__f_subprojects = null;
  this.Lreactbuild_project_generator_Notice$Props__f_projectPot = projectPot;
  this.Lreactbuild_project_generator_Notice$Props__f_subprojects = subprojects
}
$c_Lreactbuild_project_generator_Notice$Props.prototype = new $h_O();
$c_Lreactbuild_project_generator_Notice$Props.prototype.constructor = $c_Lreactbuild_project_generator_Notice$Props;
/** @constructor */
function $h_Lreactbuild_project_generator_Notice$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_Notice$Props.prototype = $c_Lreactbuild_project_generator_Notice$Props.prototype;
$c_Lreactbuild_project_generator_Notice$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_generator_Notice$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_generator_Notice$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_Notice$Props__f_projectPot;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_Notice$Props__f_subprojects;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_Notice$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_Notice$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_Notice$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_Notice$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_Notice$Props)) {
    var Props$1 = $as_Lreactbuild_project_generator_Notice$Props(x$1);
    var x = this.Lreactbuild_project_generator_Notice$Props__f_projectPot;
    var x$2 = $n(Props$1).Lreactbuild_project_generator_Notice$Props__f_projectPot;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_generator_Notice$Props__f_subprojects;
      var x$4 = $n(Props$1).Lreactbuild_project_generator_Notice$Props__f_subprojects;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_Notice$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_Notice$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.Notice$Props"))
}
function $isArrayOf_Lreactbuild_project_generator_Notice$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_Notice$Props)))
}
function $asArrayOf_Lreactbuild_project_generator_Notice$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_Notice$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.Notice$Props;", depth))
}
var $d_Lreactbuild_project_generator_Notice$Props = new $TypeData().initClass({
  Lreactbuild_project_generator_Notice$Props: 0
}, false, "reactbuild.project.generator.Notice$Props", {
  Lreactbuild_project_generator_Notice$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_Notice$Props.prototype.$classData = $d_Lreactbuild_project_generator_Notice$Props;
/** @constructor */
function $c_Lreactbuild_project_generator_PageContext(index, total) {
  this.Lreactbuild_project_generator_PageContext__f_index = 0;
  this.Lreactbuild_project_generator_PageContext__f_total = 0;
  this.Lreactbuild_project_generator_PageContext__f_index = index;
  this.Lreactbuild_project_generator_PageContext__f_total = total
}
$c_Lreactbuild_project_generator_PageContext.prototype = new $h_O();
$c_Lreactbuild_project_generator_PageContext.prototype.constructor = $c_Lreactbuild_project_generator_PageContext;
/** @constructor */
function $h_Lreactbuild_project_generator_PageContext() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_PageContext.prototype = $c_Lreactbuild_project_generator_PageContext.prototype;
$c_Lreactbuild_project_generator_PageContext.prototype.productPrefix__T = (function() {
  return "PageContext"
});
$c_Lreactbuild_project_generator_PageContext.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_generator_PageContext.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_PageContext__f_index;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_PageContext__f_total;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_PageContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_PageContext.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("PageContext");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_project_generator_PageContext__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lreactbuild_project_generator_PageContext__f_total;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_project_generator_PageContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_PageContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_PageContext)) {
    var PageContext$1 = $as_Lreactbuild_project_generator_PageContext(x$1);
    return ((this.Lreactbuild_project_generator_PageContext__f_index === $n(PageContext$1).Lreactbuild_project_generator_PageContext__f_index) && (this.Lreactbuild_project_generator_PageContext__f_total === $n(PageContext$1).Lreactbuild_project_generator_PageContext__f_total))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_PageContext(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_PageContext) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.PageContext"))
}
function $isArrayOf_Lreactbuild_project_generator_PageContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_PageContext)))
}
function $asArrayOf_Lreactbuild_project_generator_PageContext(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_PageContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.PageContext;", depth))
}
var $d_Lreactbuild_project_generator_PageContext = new $TypeData().initClass({
  Lreactbuild_project_generator_PageContext: 0
}, false, "reactbuild.project.generator.PageContext", {
  Lreactbuild_project_generator_PageContext: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_PageContext.prototype.$classData = $d_Lreactbuild_project_generator_PageContext;
/** @constructor */
function $c_Lreactbuild_project_generator_PlaceMapView$Props(position, zoom) {
  this.Lreactbuild_project_generator_PlaceMapView$Props__f_position = null;
  this.Lreactbuild_project_generator_PlaceMapView$Props__f_zoom = 0.0;
  this.Lreactbuild_project_generator_PlaceMapView$Props__f_position = position;
  this.Lreactbuild_project_generator_PlaceMapView$Props__f_zoom = zoom
}
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype = new $h_O();
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype.constructor = $c_Lreactbuild_project_generator_PlaceMapView$Props;
/** @constructor */
function $h_Lreactbuild_project_generator_PlaceMapView$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_PlaceMapView$Props.prototype = $c_Lreactbuild_project_generator_PlaceMapView$Props.prototype;
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_PlaceMapView$Props__f_position;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_PlaceMapView$Props__f_zoom;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_generator_PlaceMapView$Props__f_position;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_project_generator_PlaceMapView$Props__f_zoom;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_PlaceMapView$Props)) {
    var Props$1 = $as_Lreactbuild_project_generator_PlaceMapView$Props(x$1);
    if ((this.Lreactbuild_project_generator_PlaceMapView$Props__f_zoom === $n(Props$1).Lreactbuild_project_generator_PlaceMapView$Props__f_zoom)) {
      var x = this.Lreactbuild_project_generator_PlaceMapView$Props__f_position;
      var x$2 = $n(Props$1).Lreactbuild_project_generator_PlaceMapView$Props__f_position;
      if ((x === null)) {
        return (x$2 === null)
      } else {
        var this$1 = $n(x);
        return (this$1 === x$2)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_PlaceMapView$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_PlaceMapView$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.PlaceMapView$Props"))
}
function $isArrayOf_Lreactbuild_project_generator_PlaceMapView$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_PlaceMapView$Props)))
}
function $asArrayOf_Lreactbuild_project_generator_PlaceMapView$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_PlaceMapView$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.PlaceMapView$Props;", depth))
}
var $d_Lreactbuild_project_generator_PlaceMapView$Props = new $TypeData().initClass({
  Lreactbuild_project_generator_PlaceMapView$Props: 0
}, false, "reactbuild.project.generator.PlaceMapView$Props", {
  Lreactbuild_project_generator_PlaceMapView$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_PlaceMapView$Props.prototype.$classData = $d_Lreactbuild_project_generator_PlaceMapView$Props;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Cell$Props(state, moveCell, rowColumn) {
  this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state = null;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_moveCell = null;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_rowColumn = 0;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state = state;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_moveCell = moveCell;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_rowColumn = rowColumn
}
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Cell$Props;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Cell$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_moveCell;
      break
    }
    case 2: {
      return this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_rowColumn;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_moveCell;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_rowColumn;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_electricalboard_components_Cell$Props)) {
    var Props$1 = $as_Lreactbuild_project_generator_electricalboard_components_Cell$Props(x$1);
    if ((this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_rowColumn === $n(Props$1).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_rowColumn)) {
      var x = this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state;
      var x$2 = $n(Props$1).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state;
      if ((x === null)) {
        var $$x1 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === x$2)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_moveCell;
      var x$4 = $n(Props$1).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_moveCell;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x$4)
      };
      if ($$x2) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_electricalboard_components_Cell$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_components_Cell$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.components.Cell$Props"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_components_Cell$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_components_Cell$Props)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_components_Cell$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_components_Cell$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.components.Cell$Props;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_components_Cell$Props = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Cell$Props: 0
}, false, "reactbuild.project.generator.electricalboard.components.Cell$Props", {
  Lreactbuild_project_generator_electricalboard_components_Cell$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Props.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Cell$Props;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Line$Props(line, moveCell, index) {
  this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_line = null;
  this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_moveCell = null;
  this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_index = 0;
  this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_line = line;
  this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_moveCell = moveCell;
  this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_index = index
}
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Line$Props;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Line$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_line;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_moveCell;
      break
    }
    case 2: {
      return this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_index;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Props");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_line;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_moveCell;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_electricalboard_components_Line$Props)) {
    var Props$1 = $as_Lreactbuild_project_generator_electricalboard_components_Line$Props(x$1);
    if ((this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_index === $n(Props$1).Lreactbuild_project_generator_electricalboard_components_Line$Props__f_index)) {
      var x = this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_line;
      var x$2 = $n(Props$1).Lreactbuild_project_generator_electricalboard_components_Line$Props__f_line;
      if ((x === null)) {
        var $$x1 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === x$2)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_generator_electricalboard_components_Line$Props__f_moveCell;
      var x$4 = $n(Props$1).Lreactbuild_project_generator_electricalboard_components_Line$Props__f_moveCell;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x$4)
      };
      if ($$x2) {
        $n(Props$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_electricalboard_components_Line$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_components_Line$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.components.Line$Props"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_components_Line$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_components_Line$Props)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_components_Line$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_components_Line$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.components.Line$Props;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_components_Line$Props = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Line$Props: 0
}, false, "reactbuild.project.generator.electricalboard.components.Line$Props", {
  Lreactbuild_project_generator_electricalboard_components_Line$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Line$Props.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Line$Props;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State(focus, mouseOver, index) {
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus = false;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver = false;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index = 0;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_active = false;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus = focus;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver = mouseOver;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index = index;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_active = (focus || mouseOver)
}
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_WireColors$State() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver;
      break
    }
    case 2: {
      return this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State)) {
    var State$1 = $as_Lreactbuild_project_generator_electricalboard_components_WireColors$State(x$1);
    return ((this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus === $n(State$1).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_focus) && ((this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver === $n(State$1).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_mouseOver) && (this.Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index === $n(State$1).Lreactbuild_project_generator_electricalboard_components_WireColors$State__f_index)))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_electricalboard_components_WireColors$State(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_components_WireColors$State) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.components.WireColors$State"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_components_WireColors$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_components_WireColors$State)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_components_WireColors$State(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_components_WireColors$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.components.WireColors$State;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_components_WireColors$State = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_WireColors$State: 0
}, false, "reactbuild.project.generator.electricalboard.components.WireColors$State", {
  Lreactbuild_project_generator_electricalboard_components_WireColors$State: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$State.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_WireColors$State;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Cell(id, label1, label2, icon, span, targets, intensity) {
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_id = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_span = 0;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_id = id;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1 = label1;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2 = label2;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon = icon;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_span = span;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets = targets;
  this.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity = intensity
}
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Cell;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Cell() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Cell.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype.productPrefix__T = (function() {
  return "Cell"
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
      break
    }
    case 2: {
      return this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
      break
    }
    case 3: {
      return this.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
      break
    }
    case 4: {
      return this.Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
      break
    }
    case 5: {
      return this.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
      break
    }
    case 6: {
      return this.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Cell");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_electricalboard_model_Cell)) {
    var Cell$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$1);
    if ((this.Lreactbuild_project_generator_electricalboard_model_Cell__f_span === $n(Cell$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_span)) {
      var x = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      var x$2 = $n(Cell$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if (($$x1 && ((this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1 === $n(Cell$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_label1) && (this.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2 === $n(Cell$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_label2)))) {
      var x$3 = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
      var x$4 = $n(Cell$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
        var x$6 = $n(Cell$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
        var $$x2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$7 = this.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
        var x$8 = $n(Cell$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          $n(Cell$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_electricalboard_model_Cell(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_Cell) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.Cell"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_Cell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_Cell)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_Cell(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_Cell(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.Cell;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_Cell = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Cell: 0
}, false, "reactbuild.project.generator.electricalboard.model.Cell", {
  Lreactbuild_project_generator_electricalboard_model_Cell: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Cell;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Line(id, cells) {
  this.Lreactbuild_project_generator_electricalboard_model_Line__f_id = null;
  this.Lreactbuild_project_generator_electricalboard_model_Line__f_cells = null;
  this.Lreactbuild_project_generator_electricalboard_model_Line__f_id = id;
  this.Lreactbuild_project_generator_electricalboard_model_Line__f_cells = cells
}
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Line;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Line() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Line.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Line.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.update__Lreactbuild_project_generator_electricalboard_model_Cell__Lreactbuild_project_generator_electricalboard_model_Line = (function(cell) {
  var id = $n(cell).Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
  var x$1 = $as_sci_Seq($n(this.Lreactbuild_project_generator_electricalboard_model_Line__f_cells).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x0$1$2);
    var x = $n(x0$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
    if (((x === null) ? (id === null) : $n(x).equals__O__Z(id))) {
      return cell
    } else {
      return x0$1
    }
  }))));
  var x$2 = this.Lreactbuild_project_generator_electricalboard_model_Line__f_id;
  return new $c_Lreactbuild_project_generator_electricalboard_model_Line(x$2, x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.productPrefix__T = (function() {
  return "Line"
});
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_electricalboard_model_Line__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_electricalboard_model_Line__f_cells;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_electricalboard_model_Line)) {
    var Line$1 = $as_Lreactbuild_project_generator_electricalboard_model_Line(x$1);
    var x = this.Lreactbuild_project_generator_electricalboard_model_Line__f_id;
    var x$2 = $n(Line$1).Lreactbuild_project_generator_electricalboard_model_Line__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_generator_electricalboard_model_Line__f_cells;
      var x$4 = $n(Line$1).Lreactbuild_project_generator_electricalboard_model_Line__f_cells;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Line$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_electricalboard_model_Line(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_Line) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.Line"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_Line(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_Line)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_Line(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_Line(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.Line;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_Line = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Line: 0
}, false, "reactbuild.project.generator.electricalboard.model.Line", {
  Lreactbuild_project_generator_electricalboard_model_Line: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Line.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Line;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_LineSource(id, label, diameter, wireColors) {
  this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_id = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_id = id;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_label = label;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter = diameter;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors = wireColors
}
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_LineSource;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_LineSource() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype = $c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype.productPrefix__T = (function() {
  return "LineSource"
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_label;
      break
    }
    case 2: {
      return this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter;
      break
    }
    case 3: {
      return this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_electricalboard_model_LineSource)) {
    var LineSource$1 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(x$1);
    var x = this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_id;
    var x$2 = $n(LineSource$1).Lreactbuild_project_generator_electricalboard_model_LineSource__f_id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_label === $n(LineSource$1).Lreactbuild_project_generator_electricalboard_model_LineSource__f_label))) {
      var x$3 = this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter;
      var x$4 = $n(LineSource$1).Lreactbuild_project_generator_electricalboard_model_LineSource__f_diameter;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors;
        var x$6 = $n(LineSource$1).Lreactbuild_project_generator_electricalboard_model_LineSource__f_wireColors;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          $n(LineSource$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_electricalboard_model_LineSource(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_LineSource) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.LineSource"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_LineSource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_LineSource)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_LineSource(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_LineSource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.LineSource;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_LineSource = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_LineSource: 0
}, false, "reactbuild.project.generator.electricalboard.model.LineSource", {
  Lreactbuild_project_generator_electricalboard_model_LineSource: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_LineSource;
function $p_Lreactbuild_project_generator_electricalboard_model_Table__addTarget$1__sci_Seq__sci_Seq__s_Option__s_Option__ju_UUID__sci_Seq($thiz, cells, originCells, sourceCell, target$1, source$1) {
  var this$1 = $n(target$1);
  if (this$1.isEmpty__Z()) {
    return cells
  } else {
    var arg1 = this$1.get__O();
    var targetId = $as_ju_UUID(arg1);
    var this$3 = $n(originCells);
    var p = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$1$2);
      var x = $n(x$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      return ((x === null) ? (targetId === null) : $n(x).equals__O__Z(targetId))
    }));
    var targetIdx = this$3.indexWhere__F1__I__I(p, 0);
    if ((targetIdx === (-1))) {
      return cells
    } else {
      var this$4 = $n(sourceCell);
      var this$6 = $n((this$4.isEmpty__Z() ? $n($as_sc_IterableOps($n($thiz.Lreactbuild_project_generator_electricalboard_model_Table__f_lines).flatMap__F1__O(new $c_sjsr_AnonFunction1(((line$2) => {
        var line = $as_Lreactbuild_project_generator_electricalboard_model_Line(line$2);
        return $n($n(line).Lreactbuild_project_generator_electricalboard_model_Line__f_cells).collectFirst__s_PartialFunction__s_Option(new $c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1($thiz, source$1))
      }))))).headOption__s_Option() : this$4));
      if (this$6.isEmpty__Z()) {
        return cells
      } else {
        var arg1$1 = this$6.get__O();
        var source = $as_Lreactbuild_project_generator_electricalboard_model_Cell(arg1$1);
        var $$x1 = $m_s_package$().s_package$__f_Seq;
        var array = [source];
        return $as_sci_Seq($n(cells).patch__I__sc_IterableOnce__I__O(targetIdx, $n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)), 0))
      }
    }
  }
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Table(lines) {
  this.Lreactbuild_project_generator_electricalboard_model_Table__f_lines = null;
  this.Lreactbuild_project_generator_electricalboard_model_Table__f_lines = lines
}
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Table;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Table() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Table.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Table.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.update__Lreactbuild_project_generator_electricalboard_model_Line__Lreactbuild_project_generator_electricalboard_model_Table = (function(line) {
  var id = $n(line).Lreactbuild_project_generator_electricalboard_model_Line__f_id;
  var lines = $as_sci_Seq($n(this.Lreactbuild_project_generator_electricalboard_model_Table__f_lines).map__F1__O(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_project_generator_electricalboard_model_Line(x0$1$2);
    if ((x0$1 !== null)) {
      var p2 = $n(x0$1).Lreactbuild_project_generator_electricalboard_model_Line__f_id;
      if (((id === null) ? (p2 === null) : $n(id).equals__O__Z(p2))) {
        return line
      }
    };
    return x0$1
  }))));
  return new $c_Lreactbuild_project_generator_electricalboard_model_Table(lines)
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.move__ju_UUID__s_Option__Lreactbuild_project_generator_electricalboard_model_Table = (function(source, target) {
  if ($n(target).contains__O__Z(source)) {
    return this
  } else {
    var updated = $as_sci_Seq($n(this.Lreactbuild_project_generator_electricalboard_model_Table__f_lines).map__F1__O(new $c_sjsr_AnonFunction1(((line$2) => {
      var line = $as_Lreactbuild_project_generator_electricalboard_model_Line(line$2);
      var this$2 = $n($n(line).Lreactbuild_project_generator_electricalboard_model_Line__f_cells);
      var p = new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$2$2);
        var x = $n(x$2).Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
        return ((x === null) ? (source === null) : $n(x).equals__O__Z(source))
      }));
      var sourceIdx = this$2.indexWhere__F1__I__I(p, 0);
      if ((sourceIdx === (-1))) {
        var _1 = $n(line).Lreactbuild_project_generator_electricalboard_model_Line__f_cells;
        var _2 = $m_s_None$();
        var x1___1 = _1;
        var x1___2 = _2
      } else {
        var _1$1 = $n($n(line).Lreactbuild_project_generator_electricalboard_model_Line__f_cells).patch__I__sc_IterableOnce__I__O(sourceIdx, $m_s_package$().s_package$__f_Nil, 1);
        var _2$1 = new $c_s_Some($n($n(line).Lreactbuild_project_generator_electricalboard_model_Line__f_cells).apply__I__O(sourceIdx));
        var x1___1 = _1$1;
        var x1___2 = _2$1
      };
      var cells = $as_sci_Seq(x1___1);
      var sourceCell = $as_s_Option(x1___2);
      var x$1 = $p_Lreactbuild_project_generator_electricalboard_model_Table__addTarget$1__sci_Seq__sci_Seq__s_Option__s_Option__ju_UUID__sci_Seq(this, cells, $n(line).Lreactbuild_project_generator_electricalboard_model_Line__f_cells, sourceCell, target, source);
      var this$3 = $n(line);
      var x$2$3 = this$3.Lreactbuild_project_generator_electricalboard_model_Line__f_id;
      $n(line);
      return new $c_Lreactbuild_project_generator_electricalboard_model_Line(x$2$3, x$1)
    }))));
    return new $c_Lreactbuild_project_generator_electricalboard_model_Table(updated)
  }
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.addNew__Lreactbuild_project_generator_electricalboard_model_Table = (function() {
  var this$10 = $n(this.Lreactbuild_project_generator_electricalboard_model_Table__f_lines);
  var b = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
  var it = new $c_sci_RangeIterator(0, 1, 11, false);
  while (it.sci_RangeIterator__f__hasNext) {
    var this$8 = $n(b);
    var arg1 = it.next__I();
    var x$1 = ((arg1 === 0) ? 2 : 1);
    $m_Lreactbuild_project_generator_electricalboard_model_Cell$();
    var x$2 = $m_ju_UUID$().randomUUID__ju_UUID();
    $m_Lreactbuild_project_generator_electricalboard_model_Cell$();
    var x$3 = "";
    $m_Lreactbuild_project_generator_electricalboard_model_Cell$();
    var x$4 = "";
    $m_Lreactbuild_project_generator_electricalboard_model_Cell$();
    var x$5 = $m_s_None$();
    $m_Lreactbuild_project_generator_electricalboard_model_Cell$();
    var x$6 = $m_s_package$().s_package$__f_Nil;
    $m_Lreactbuild_project_generator_electricalboard_model_Cell$();
    var x$7 = $m_s_Option$().apply__O__s_Option(16);
    var elem = new $c_Lreactbuild_project_generator_electricalboard_model_Cell(x$2, x$3, x$4, x$5, x$1, x$6, x$7);
    this$8.addOne__O__scm_Growable(elem)
  };
  var x$8 = $as_sci_IndexedSeq($n(b).result__O());
  $m_Lreactbuild_project_generator_electricalboard_model_Line$();
  var x$9 = $m_ju_UUID$().randomUUID__ju_UUID();
  var elem$1 = new $c_Lreactbuild_project_generator_electricalboard_model_Line(x$9, x$8);
  var lines = $as_sci_Seq(this$10.appended__O__O(elem$1));
  return new $c_Lreactbuild_project_generator_electricalboard_model_Table(lines)
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.productPrefix__T = (function() {
  return "Table"
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_generator_electricalboard_model_Table__f_lines : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_electricalboard_model_Table)) {
    var Table$1 = $as_Lreactbuild_project_generator_electricalboard_model_Table(x$1);
    var x = this.Lreactbuild_project_generator_electricalboard_model_Table__f_lines;
    var x$2 = $n(Table$1).Lreactbuild_project_generator_electricalboard_model_Table__f_lines;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Table$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_electricalboard_model_Table(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_Table) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.Table"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_Table(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_Table)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_Table(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_Table(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.Table;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_Table = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Table: 0
}, false, "reactbuild.project.generator.electricalboard.model.Table", {
  Lreactbuild_project_generator_electricalboard_model_Table: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Table.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Table;
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_Header$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_markdown_Header$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_project_generator_markdown_Header$.prototype.constructor = $c_Lreactbuild_project_generator_markdown_Header$;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_Header$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_Header$.prototype = $c_Lreactbuild_project_generator_markdown_Header$.prototype;
$c_Lreactbuild_project_generator_markdown_Header$.prototype.toString__T = (function() {
  return "Header"
});
$c_Lreactbuild_project_generator_markdown_Header$.prototype.apply__O__O__O = (function(v1, v2) {
  var level = $uI(v1);
  var body = $as_Lreactbuild_project_generator_markdown_MarkdownText(v2);
  return new $c_Lreactbuild_project_generator_markdown_Header(level, body)
});
var $d_Lreactbuild_project_generator_markdown_Header$ = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_Header$: 0
}, false, "reactbuild.project.generator.markdown.Header$", {
  Lreactbuild_project_generator_markdown_Header$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_Header$.prototype.$classData = $d_Lreactbuild_project_generator_markdown_Header$;
var $n_Lreactbuild_project_generator_markdown_Header$;
function $m_Lreactbuild_project_generator_markdown_Header$() {
  if ((!$n_Lreactbuild_project_generator_markdown_Header$)) {
    $n_Lreactbuild_project_generator_markdown_Header$ = new $c_Lreactbuild_project_generator_markdown_Header$()
  };
  return $n_Lreactbuild_project_generator_markdown_Header$
}
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_MarkdownText(v) {
  this.Lreactbuild_project_generator_markdown_MarkdownText__f_v = null;
  this.Lreactbuild_project_generator_markdown_MarkdownText__f_v = v
}
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype = new $h_O();
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype.constructor = $c_Lreactbuild_project_generator_markdown_MarkdownText;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_MarkdownText() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_MarkdownText.prototype = $c_Lreactbuild_project_generator_markdown_MarkdownText.prototype;
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype.productPrefix__T = (function() {
  return "MarkdownText"
});
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_generator_markdown_MarkdownText__f_v : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_markdown_MarkdownText)) {
    var MarkdownText$1 = $as_Lreactbuild_project_generator_markdown_MarkdownText(x$1);
    return (this.Lreactbuild_project_generator_markdown_MarkdownText__f_v === $n(MarkdownText$1).Lreactbuild_project_generator_markdown_MarkdownText__f_v)
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_markdown_MarkdownText(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_markdown_MarkdownText) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.markdown.MarkdownText"))
}
function $isArrayOf_Lreactbuild_project_generator_markdown_MarkdownText(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_markdown_MarkdownText)))
}
function $asArrayOf_Lreactbuild_project_generator_markdown_MarkdownText(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_markdown_MarkdownText(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.markdown.MarkdownText;", depth))
}
var $d_Lreactbuild_project_generator_markdown_MarkdownText = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_MarkdownText: 0
}, false, "reactbuild.project.generator.markdown.MarkdownText", {
  Lreactbuild_project_generator_markdown_MarkdownText: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_MarkdownText.prototype.$classData = $d_Lreactbuild_project_generator_markdown_MarkdownText;
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_OL$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_markdown_OL$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_project_generator_markdown_OL$.prototype.constructor = $c_Lreactbuild_project_generator_markdown_OL$;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_OL$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_OL$.prototype = $c_Lreactbuild_project_generator_markdown_OL$.prototype;
$c_Lreactbuild_project_generator_markdown_OL$.prototype.toString__T = (function() {
  return "OL"
});
$c_Lreactbuild_project_generator_markdown_OL$.prototype.apply__O__O__O = (function(v1, v2) {
  var level = $uI(v1);
  var body = $as_Lreactbuild_project_generator_markdown_MarkdownText(v2);
  return new $c_Lreactbuild_project_generator_markdown_OL(level, body)
});
var $d_Lreactbuild_project_generator_markdown_OL$ = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_OL$: 0
}, false, "reactbuild.project.generator.markdown.OL$", {
  Lreactbuild_project_generator_markdown_OL$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_OL$.prototype.$classData = $d_Lreactbuild_project_generator_markdown_OL$;
var $n_Lreactbuild_project_generator_markdown_OL$;
function $m_Lreactbuild_project_generator_markdown_OL$() {
  if ((!$n_Lreactbuild_project_generator_markdown_OL$)) {
    $n_Lreactbuild_project_generator_markdown_OL$ = new $c_Lreactbuild_project_generator_markdown_OL$()
  };
  return $n_Lreactbuild_project_generator_markdown_OL$
}
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_UL$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_markdown_UL$.prototype = new $h_sr_AbstractFunction2();
$c_Lreactbuild_project_generator_markdown_UL$.prototype.constructor = $c_Lreactbuild_project_generator_markdown_UL$;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_UL$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_UL$.prototype = $c_Lreactbuild_project_generator_markdown_UL$.prototype;
$c_Lreactbuild_project_generator_markdown_UL$.prototype.toString__T = (function() {
  return "UL"
});
$c_Lreactbuild_project_generator_markdown_UL$.prototype.apply__O__O__O = (function(v1, v2) {
  var level = $uI(v1);
  var body = $as_Lreactbuild_project_generator_markdown_MarkdownText(v2);
  return new $c_Lreactbuild_project_generator_markdown_UL(level, body)
});
var $d_Lreactbuild_project_generator_markdown_UL$ = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_UL$: 0
}, false, "reactbuild.project.generator.markdown.UL$", {
  Lreactbuild_project_generator_markdown_UL$: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_UL$.prototype.$classData = $d_Lreactbuild_project_generator_markdown_UL$;
var $n_Lreactbuild_project_generator_markdown_UL$;
function $m_Lreactbuild_project_generator_markdown_UL$() {
  if ((!$n_Lreactbuild_project_generator_markdown_UL$)) {
    $n_Lreactbuild_project_generator_markdown_UL$ = new $c_Lreactbuild_project_generator_markdown_UL$()
  };
  return $n_Lreactbuild_project_generator_markdown_UL$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_Check(id, title) {
  this.Lreactbuild_project_notebook_Check__f_id = null;
  this.Lreactbuild_project_notebook_Check__f_title = null;
  this.Lreactbuild_project_notebook_Check__f_id = id;
  this.Lreactbuild_project_notebook_Check__f_title = title
}
$c_Lreactbuild_project_notebook_Check.prototype = new $h_O();
$c_Lreactbuild_project_notebook_Check.prototype.constructor = $c_Lreactbuild_project_notebook_Check;
/** @constructor */
function $h_Lreactbuild_project_notebook_Check() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_Check.prototype = $c_Lreactbuild_project_notebook_Check.prototype;
$c_Lreactbuild_project_notebook_Check.prototype.productPrefix__T = (function() {
  return "Check"
});
$c_Lreactbuild_project_notebook_Check.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_notebook_Check.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_Check__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_Check__f_title;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_Check.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_Check.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_Check.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_Check.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_Check)) {
    var Check$1 = $as_Lreactbuild_project_notebook_Check(x$1);
    var x = this.Lreactbuild_project_notebook_Check__f_id;
    var x$2 = $n(Check$1).Lreactbuild_project_notebook_Check__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lreactbuild_project_notebook_Check__f_title === $n(Check$1).Lreactbuild_project_notebook_Check__f_title)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_Check(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_Check) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.Check"))
}
function $isArrayOf_Lreactbuild_project_notebook_Check(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_Check)))
}
function $asArrayOf_Lreactbuild_project_notebook_Check(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_Check(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.Check;", depth))
}
var $d_Lreactbuild_project_notebook_Check = new $TypeData().initClass({
  Lreactbuild_project_notebook_Check: 0
}, false, "reactbuild.project.notebook.Check", {
  Lreactbuild_project_notebook_Check: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_Check.prototype.$classData = $d_Lreactbuild_project_notebook_Check;
/** @constructor */
function $c_Lreactbuild_project_notebook_Notebook$Props(pageProps, template, instance) {
  this.Lreactbuild_project_notebook_Notebook$Props__f_pageProps = null;
  this.Lreactbuild_project_notebook_Notebook$Props__f_template = null;
  this.Lreactbuild_project_notebook_Notebook$Props__f_instance = null;
  this.Lreactbuild_project_notebook_Notebook$Props__f_pageProps = pageProps;
  this.Lreactbuild_project_notebook_Notebook$Props__f_template = template;
  this.Lreactbuild_project_notebook_Notebook$Props__f_instance = instance
}
$c_Lreactbuild_project_notebook_Notebook$Props.prototype = new $h_O();
$c_Lreactbuild_project_notebook_Notebook$Props.prototype.constructor = $c_Lreactbuild_project_notebook_Notebook$Props;
/** @constructor */
function $h_Lreactbuild_project_notebook_Notebook$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_Notebook$Props.prototype = $c_Lreactbuild_project_notebook_Notebook$Props.prototype;
$c_Lreactbuild_project_notebook_Notebook$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_notebook_Notebook$Props.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_notebook_Notebook$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_Notebook$Props__f_pageProps;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_Notebook$Props__f_template;
      break
    }
    case 2: {
      return this.Lreactbuild_project_notebook_Notebook$Props__f_instance;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_Notebook$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_Notebook$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_Notebook$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_Notebook$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_Notebook$Props)) {
    var Props$1 = $as_Lreactbuild_project_notebook_Notebook$Props(x$1);
    var x = this.Lreactbuild_project_notebook_Notebook$Props__f_pageProps;
    var x$2 = $n(Props$1).Lreactbuild_project_notebook_Notebook$Props__f_pageProps;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_notebook_Notebook$Props__f_template;
      var x$4 = $n(Props$1).Lreactbuild_project_notebook_Notebook$Props__f_template;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_project_notebook_Notebook$Props__f_instance;
        var x$6 = $n(Props$1).Lreactbuild_project_notebook_Notebook$Props__f_instance;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_Notebook$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_Notebook$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.Notebook$Props"))
}
function $isArrayOf_Lreactbuild_project_notebook_Notebook$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_Notebook$Props)))
}
function $asArrayOf_Lreactbuild_project_notebook_Notebook$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_Notebook$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.Notebook$Props;", depth))
}
var $d_Lreactbuild_project_notebook_Notebook$Props = new $TypeData().initClass({
  Lreactbuild_project_notebook_Notebook$Props: 0
}, false, "reactbuild.project.notebook.Notebook$Props", {
  Lreactbuild_project_notebook_Notebook$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_Notebook$Props.prototype.$classData = $d_Lreactbuild_project_notebook_Notebook$Props;
/** @constructor */
function $c_Lreactbuild_project_notebook_NotebookLink$Props(id, title) {
  this.Lreactbuild_project_notebook_NotebookLink$Props__f_id = null;
  this.Lreactbuild_project_notebook_NotebookLink$Props__f_title = null;
  this.Lreactbuild_project_notebook_NotebookLink$Props__f_id = id;
  this.Lreactbuild_project_notebook_NotebookLink$Props__f_title = title
}
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype = new $h_O();
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype.constructor = $c_Lreactbuild_project_notebook_NotebookLink$Props;
/** @constructor */
function $h_Lreactbuild_project_notebook_NotebookLink$Props() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_NotebookLink$Props.prototype = $c_Lreactbuild_project_notebook_NotebookLink$Props.prototype;
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_NotebookLink$Props__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_NotebookLink$Props__f_title;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_NotebookLink$Props)) {
    var Props$1 = $as_Lreactbuild_project_notebook_NotebookLink$Props(x$1);
    var x = this.Lreactbuild_project_notebook_NotebookLink$Props__f_id;
    var x$2 = $n(Props$1).Lreactbuild_project_notebook_NotebookLink$Props__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lreactbuild_project_notebook_NotebookLink$Props__f_title === $n(Props$1).Lreactbuild_project_notebook_NotebookLink$Props__f_title)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_NotebookLink$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_NotebookLink$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.NotebookLink$Props"))
}
function $isArrayOf_Lreactbuild_project_notebook_NotebookLink$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_NotebookLink$Props)))
}
function $asArrayOf_Lreactbuild_project_notebook_NotebookLink$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_NotebookLink$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.NotebookLink$Props;", depth))
}
var $d_Lreactbuild_project_notebook_NotebookLink$Props = new $TypeData().initClass({
  Lreactbuild_project_notebook_NotebookLink$Props: 0
}, false, "reactbuild.project.notebook.NotebookLink$Props", {
  Lreactbuild_project_notebook_NotebookLink$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_NotebookLink$Props.prototype.$classData = $d_Lreactbuild_project_notebook_NotebookLink$Props;
/** @constructor */
function $c_Lreactbuild_project_notebook_NotebookTemplate(id, title, current) {
  this.Lreactbuild_project_notebook_NotebookTemplate__f_id = null;
  this.Lreactbuild_project_notebook_NotebookTemplate__f_title = null;
  this.Lreactbuild_project_notebook_NotebookTemplate__f_current = null;
  this.Lreactbuild_project_notebook_NotebookTemplate__f_id = id;
  this.Lreactbuild_project_notebook_NotebookTemplate__f_title = title;
  this.Lreactbuild_project_notebook_NotebookTemplate__f_current = current
}
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype = new $h_O();
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype.constructor = $c_Lreactbuild_project_notebook_NotebookTemplate;
/** @constructor */
function $h_Lreactbuild_project_notebook_NotebookTemplate() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_NotebookTemplate.prototype = $c_Lreactbuild_project_notebook_NotebookTemplate.prototype;
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype.productPrefix__T = (function() {
  return "NotebookTemplate"
});
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_NotebookTemplate__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_NotebookTemplate__f_title;
      break
    }
    case 2: {
      return this.Lreactbuild_project_notebook_NotebookTemplate__f_current;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_NotebookTemplate)) {
    var NotebookTemplate$1 = $as_Lreactbuild_project_notebook_NotebookTemplate(x$1);
    var x = this.Lreactbuild_project_notebook_NotebookTemplate__f_id;
    var x$2 = $n(NotebookTemplate$1).Lreactbuild_project_notebook_NotebookTemplate__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      if ((this.Lreactbuild_project_notebook_NotebookTemplate__f_title === $n(NotebookTemplate$1).Lreactbuild_project_notebook_NotebookTemplate__f_title)) {
        var x$3 = this.Lreactbuild_project_notebook_NotebookTemplate__f_current;
        var x$4 = $n(NotebookTemplate$1).Lreactbuild_project_notebook_NotebookTemplate__f_current;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_NotebookTemplate(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_NotebookTemplate) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.NotebookTemplate"))
}
function $isArrayOf_Lreactbuild_project_notebook_NotebookTemplate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_NotebookTemplate)))
}
function $asArrayOf_Lreactbuild_project_notebook_NotebookTemplate(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_NotebookTemplate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.NotebookTemplate;", depth))
}
var $d_Lreactbuild_project_notebook_NotebookTemplate = new $TypeData().initClass({
  Lreactbuild_project_notebook_NotebookTemplate: 0
}, false, "reactbuild.project.notebook.NotebookTemplate", {
  Lreactbuild_project_notebook_NotebookTemplate: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_NotebookTemplate.prototype.$classData = $d_Lreactbuild_project_notebook_NotebookTemplate;
/** @constructor */
function $c_Lreactbuild_project_notebook_NotebookTemplateVersion(id, cells, previous) {
  this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_id = null;
  this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_cells = null;
  this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_previous = null;
  this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_id = id;
  this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_cells = cells;
  this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_previous = previous
}
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype = new $h_O();
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype.constructor = $c_Lreactbuild_project_notebook_NotebookTemplateVersion;
/** @constructor */
function $h_Lreactbuild_project_notebook_NotebookTemplateVersion() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype = $c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype;
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype.productPrefix__T = (function() {
  return "NotebookTemplateVersion"
});
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_cells;
      break
    }
    case 2: {
      return this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_previous;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_NotebookTemplateVersion)) {
    var NotebookTemplateVersion$1 = $as_Lreactbuild_project_notebook_NotebookTemplateVersion(x$1);
    var x = this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_id;
    var x$2 = $n(NotebookTemplateVersion$1).Lreactbuild_project_notebook_NotebookTemplateVersion__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_cells;
      var x$4 = $n(NotebookTemplateVersion$1).Lreactbuild_project_notebook_NotebookTemplateVersion__f_cells;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_project_notebook_NotebookTemplateVersion__f_previous;
        var x$6 = $n(NotebookTemplateVersion$1).Lreactbuild_project_notebook_NotebookTemplateVersion__f_previous;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_NotebookTemplateVersion(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_NotebookTemplateVersion) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.NotebookTemplateVersion"))
}
function $isArrayOf_Lreactbuild_project_notebook_NotebookTemplateVersion(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_NotebookTemplateVersion)))
}
function $asArrayOf_Lreactbuild_project_notebook_NotebookTemplateVersion(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_NotebookTemplateVersion(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.NotebookTemplateVersion;", depth))
}
var $d_Lreactbuild_project_notebook_NotebookTemplateVersion = new $TypeData().initClass({
  Lreactbuild_project_notebook_NotebookTemplateVersion: 0
}, false, "reactbuild.project.notebook.NotebookTemplateVersion", {
  Lreactbuild_project_notebook_NotebookTemplateVersion: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_NotebookTemplateVersion.prototype.$classData = $d_Lreactbuild_project_notebook_NotebookTemplateVersion;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Activity(tpe, estimatedDuration, name) {
  this.Lreactbuild_task_TaskScheduler$Activity__f_tpe = null;
  this.Lreactbuild_task_TaskScheduler$Activity__f_estimatedDuration = null;
  this.Lreactbuild_task_TaskScheduler$Activity__f_name = null;
  this.Lreactbuild_task_TaskScheduler$Activity__f_tpe = tpe;
  this.Lreactbuild_task_TaskScheduler$Activity__f_estimatedDuration = estimatedDuration;
  this.Lreactbuild_task_TaskScheduler$Activity__f_name = name
}
$c_Lreactbuild_task_TaskScheduler$Activity.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Activity.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Activity;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Activity() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Activity.prototype = $c_Lreactbuild_task_TaskScheduler$Activity.prototype;
$c_Lreactbuild_task_TaskScheduler$Activity.prototype.productPrefix__T = (function() {
  return "Activity"
});
$c_Lreactbuild_task_TaskScheduler$Activity.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_task_TaskScheduler$Activity.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_task_TaskScheduler$Activity__f_tpe;
      break
    }
    case 1: {
      return this.Lreactbuild_task_TaskScheduler$Activity__f_estimatedDuration;
      break
    }
    case 2: {
      return this.Lreactbuild_task_TaskScheduler$Activity__f_name;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_task_TaskScheduler$Activity.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$Activity.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_task_TaskScheduler$Activity.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_task_TaskScheduler$Activity.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_task_TaskScheduler$Activity)) {
    var Activity$1 = $as_Lreactbuild_task_TaskScheduler$Activity(x$1);
    var x = this.Lreactbuild_task_TaskScheduler$Activity__f_tpe;
    var x$2 = $n(Activity$1).Lreactbuild_task_TaskScheduler$Activity__f_tpe;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_task_TaskScheduler$Activity__f_estimatedDuration;
      var x$4 = $n(Activity$1).Lreactbuild_task_TaskScheduler$Activity__f_estimatedDuration;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        return (this.Lreactbuild_task_TaskScheduler$Activity__f_name === $n(Activity$1).Lreactbuild_task_TaskScheduler$Activity__f_name)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_task_TaskScheduler$Activity(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$Activity) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$Activity"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$Activity(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$Activity)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$Activity(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$Activity(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$Activity;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$Activity = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Activity: 0
}, false, "reactbuild.task.TaskScheduler$Activity", {
  Lreactbuild_task_TaskScheduler$Activity: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$Activity.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Activity;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$ActivityTransition(from, to, estimatedDuration) {
  this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_from = null;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_to = null;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_estimatedDuration = null;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_from = from;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_to = to;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_estimatedDuration = estimatedDuration
}
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$ActivityTransition;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$ActivityTransition() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype = $c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype;
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype.productPrefix__T = (function() {
  return "ActivityTransition"
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_from;
      break
    }
    case 1: {
      return this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_to;
      break
    }
    case 2: {
      return this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_estimatedDuration;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_task_TaskScheduler$ActivityTransition)) {
    var ActivityTransition$1 = $as_Lreactbuild_task_TaskScheduler$ActivityTransition(x$1);
    var x = this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_from;
    var x$2 = $n(ActivityTransition$1).Lreactbuild_task_TaskScheduler$ActivityTransition__f_from;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_to;
      var x$4 = $n(ActivityTransition$1).Lreactbuild_task_TaskScheduler$ActivityTransition__f_to;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_task_TaskScheduler$ActivityTransition__f_estimatedDuration;
        var x$6 = $n(ActivityTransition$1).Lreactbuild_task_TaskScheduler$ActivityTransition__f_estimatedDuration;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_task_TaskScheduler$ActivityTransition(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$ActivityTransition) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$ActivityTransition"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$ActivityTransition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$ActivityTransition)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$ActivityTransition(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$ActivityTransition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$ActivityTransition;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$ActivityTransition = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$ActivityTransition: 0
}, false, "reactbuild.task.TaskScheduler$ActivityTransition", {
  Lreactbuild_task_TaskScheduler$ActivityTransition: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$ActivityTransition;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod(tpe, start, end) {
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_tpe = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_start = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_end = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_tpe = tpe;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_start = start;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_end = end
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriod() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype.productPrefix__T = (function() {
  return "AllocatablePeriod"
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_tpe;
      break
    }
    case 1: {
      return this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_start;
      break
    }
    case 2: {
      return this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_end;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod)) {
    var AllocatablePeriod$1 = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriod(x$1);
    var x = this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_tpe;
    var x$2 = $n(AllocatablePeriod$1).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_tpe;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_start;
      var x$4 = $n(AllocatablePeriod$1).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_start;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_end;
        var x$6 = $n(AllocatablePeriod$1).Lreactbuild_task_TaskScheduler$AllocatablePeriod__f_end;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_task_TaskScheduler$AllocatablePeriod(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$AllocatablePeriod"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriod(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$AllocatablePeriod)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriod(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriod(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$AllocatablePeriod;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriod = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriod: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriod", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriod: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriod;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Context(dayTypes, tasks, transitions) {
  this.Lreactbuild_task_TaskScheduler$Context__f_dayTypes = null;
  this.Lreactbuild_task_TaskScheduler$Context__f_tasks = null;
  this.Lreactbuild_task_TaskScheduler$Context__f_transitions = null;
  this.Lreactbuild_task_TaskScheduler$Context__f_dayTypes = dayTypes;
  this.Lreactbuild_task_TaskScheduler$Context__f_tasks = tasks;
  this.Lreactbuild_task_TaskScheduler$Context__f_transitions = transitions
}
$c_Lreactbuild_task_TaskScheduler$Context.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Context.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Context;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Context() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Context.prototype = $c_Lreactbuild_task_TaskScheduler$Context.prototype;
$c_Lreactbuild_task_TaskScheduler$Context.prototype.productPrefix__T = (function() {
  return "Context"
});
$c_Lreactbuild_task_TaskScheduler$Context.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_task_TaskScheduler$Context.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_task_TaskScheduler$Context__f_dayTypes;
      break
    }
    case 1: {
      return this.Lreactbuild_task_TaskScheduler$Context__f_tasks;
      break
    }
    case 2: {
      return this.Lreactbuild_task_TaskScheduler$Context__f_transitions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_task_TaskScheduler$Context.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$Context.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_task_TaskScheduler$Context.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_task_TaskScheduler$Context.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_task_TaskScheduler$Context)) {
    var Context$1 = $as_Lreactbuild_task_TaskScheduler$Context(x$1);
    var x = this.Lreactbuild_task_TaskScheduler$Context__f_dayTypes;
    var x$2 = $n(Context$1).Lreactbuild_task_TaskScheduler$Context__f_dayTypes;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_task_TaskScheduler$Context__f_tasks;
      var x$4 = $n(Context$1).Lreactbuild_task_TaskScheduler$Context__f_tasks;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_task_TaskScheduler$Context__f_transitions;
        var x$6 = $n(Context$1).Lreactbuild_task_TaskScheduler$Context__f_transitions;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_task_TaskScheduler$Context(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$Context) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$Context"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$Context(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$Context)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$Context(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$Context(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$Context;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$Context = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Context: 0
}, false, "reactbuild.task.TaskScheduler$Context", {
  Lreactbuild_task_TaskScheduler$Context: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$Context.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Context;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$DayType(dow, periods) {
  this.Lreactbuild_task_TaskScheduler$DayType__f_dow = null;
  this.Lreactbuild_task_TaskScheduler$DayType__f_periods = null;
  this.Lreactbuild_task_TaskScheduler$DayType__f_dow = dow;
  this.Lreactbuild_task_TaskScheduler$DayType__f_periods = periods
}
$c_Lreactbuild_task_TaskScheduler$DayType.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$DayType.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$DayType;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$DayType() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$DayType.prototype = $c_Lreactbuild_task_TaskScheduler$DayType.prototype;
$c_Lreactbuild_task_TaskScheduler$DayType.prototype.productPrefix__T = (function() {
  return "DayType"
});
$c_Lreactbuild_task_TaskScheduler$DayType.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_task_TaskScheduler$DayType.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_task_TaskScheduler$DayType__f_dow;
      break
    }
    case 1: {
      return this.Lreactbuild_task_TaskScheduler$DayType__f_periods;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_task_TaskScheduler$DayType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$DayType.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_task_TaskScheduler$DayType.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_task_TaskScheduler$DayType.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_task_TaskScheduler$DayType)) {
    var DayType$1 = $as_Lreactbuild_task_TaskScheduler$DayType(x$1);
    var x = this.Lreactbuild_task_TaskScheduler$DayType__f_dow;
    var x$2 = $n(DayType$1).Lreactbuild_task_TaskScheduler$DayType__f_dow;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_task_TaskScheduler$DayType__f_periods;
      var x$4 = $n(DayType$1).Lreactbuild_task_TaskScheduler$DayType__f_periods;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_task_TaskScheduler$DayType(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$DayType) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$DayType"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$DayType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$DayType)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$DayType(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$DayType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$DayType;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$DayType = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$DayType: 0
}, false, "reactbuild.task.TaskScheduler$DayType", {
  Lreactbuild_task_TaskScheduler$DayType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$DayType.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$DayType;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Period(from, end, details) {
  this.Lreactbuild_task_TaskScheduler$Period__f_from = null;
  this.Lreactbuild_task_TaskScheduler$Period__f_end = null;
  this.Lreactbuild_task_TaskScheduler$Period__f_details = null;
  this.Lreactbuild_task_TaskScheduler$Period__f_from = from;
  this.Lreactbuild_task_TaskScheduler$Period__f_end = end;
  this.Lreactbuild_task_TaskScheduler$Period__f_details = details
}
$c_Lreactbuild_task_TaskScheduler$Period.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Period.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Period;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Period() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Period.prototype = $c_Lreactbuild_task_TaskScheduler$Period.prototype;
$c_Lreactbuild_task_TaskScheduler$Period.prototype.productPrefix__T = (function() {
  return "Period"
});
$c_Lreactbuild_task_TaskScheduler$Period.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_task_TaskScheduler$Period.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_task_TaskScheduler$Period__f_from;
      break
    }
    case 1: {
      return this.Lreactbuild_task_TaskScheduler$Period__f_end;
      break
    }
    case 2: {
      return this.Lreactbuild_task_TaskScheduler$Period__f_details;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_task_TaskScheduler$Period.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$Period.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_task_TaskScheduler$Period.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_task_TaskScheduler$Period.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_task_TaskScheduler$Period)) {
    var Period$1 = $as_Lreactbuild_task_TaskScheduler$Period(x$1);
    var x = this.Lreactbuild_task_TaskScheduler$Period__f_from;
    var x$2 = $n(Period$1).Lreactbuild_task_TaskScheduler$Period__f_from;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_task_TaskScheduler$Period__f_end;
      var x$4 = $n(Period$1).Lreactbuild_task_TaskScheduler$Period__f_end;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_task_TaskScheduler$Period__f_details;
        var x$6 = $n(Period$1).Lreactbuild_task_TaskScheduler$Period__f_details;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_task_TaskScheduler$Period(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$Period) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$Period"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$Period(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$Period)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$Period(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$Period(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$Period;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$Period = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Period: 0
}, false, "reactbuild.task.TaskScheduler$Period", {
  Lreactbuild_task_TaskScheduler$Period: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$Period.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Period;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Props() {
  /*<skip>*/
}
$c_Lreactbuild_task_TaskScheduler$Props.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$Props.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Props;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Props() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Props.prototype = $c_Lreactbuild_task_TaskScheduler$Props.prototype;
$c_Lreactbuild_task_TaskScheduler$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lreactbuild_task_TaskScheduler$Props.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_task_TaskScheduler$Props.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_task_TaskScheduler$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_task_TaskScheduler$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_task_TaskScheduler$Props.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_task_TaskScheduler$Props)
});
function $as_Lreactbuild_task_TaskScheduler$Props(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$Props"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$Props)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$Props(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$Props;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$Props = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Props: 0
}, false, "reactbuild.task.TaskScheduler$Props", {
  Lreactbuild_task_TaskScheduler$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$Props.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Props;
/** @constructor */
function $c_s_$eq$colon$eq() {
  /*<skip>*/
}
$c_s_$eq$colon$eq.prototype = new $h_s_$less$colon$less();
$c_s_$eq$colon$eq.prototype.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
  /*<skip>*/
}
$h_s_$eq$colon$eq.prototype = $c_s_$eq$colon$eq.prototype;
class $c_s_NotImplementedError extends $c_jl_Error {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "an implementation is missing", null, true, true)
  };
}
var $d_s_NotImplementedError = new $TypeData().initClass({
  s_NotImplementedError: 0
}, false, "scala.NotImplementedError", {
  s_NotImplementedError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_NotImplementedError.prototype.$classData = $d_s_NotImplementedError;
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.s_PartialFunction$$anon$1__f_lift = null;
  this.s_PartialFunction$$anon$1__f_lift = new $c_sjsr_AnonFunction1(((x$2) => $m_s_None$()))
}
$c_s_PartialFunction$$anon$1.prototype = new $h_O();
$c_s_PartialFunction$$anon$1.prototype.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
  /*<skip>*/
}
$h_s_PartialFunction$$anon$1.prototype = $c_s_PartialFunction$$anon$1.prototype;
$c_s_PartialFunction$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_s_PartialFunction$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  this.apply__O__E(v1)
});
$c_s_PartialFunction$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_s_PartialFunction$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return false
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__E = (function(x) {
  throw new $c_s_MatchError(x)
});
$c_s_PartialFunction$$anon$1.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return that
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return this
});
$c_s_PartialFunction$$anon$1.prototype.lift__F1 = (function() {
  return this.s_PartialFunction$$anon$1__f_lift
});
$c_s_PartialFunction$$anon$1.prototype.runWith__F1__F1 = (function(action) {
  return $m_s_PartialFunction$().s_PartialFunction$__f_scala$PartialFunction$$constFalse
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return this
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__O = (function(v1) {
  this.apply__O__E(v1)
});
var $d_s_PartialFunction$$anon$1 = new $TypeData().initClass({
  s_PartialFunction$$anon$1: 0
}, false, "scala.PartialFunction$$anon$1", {
  s_PartialFunction$$anon$1: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$$anon$1.prototype.$classData = $d_s_PartialFunction$$anon$1;
/** @constructor */
function $c_s_PartialFunction$AndThen(pf, k) {
  this.s_PartialFunction$AndThen__f_pf = null;
  this.s_PartialFunction$AndThen__f_k = null;
  this.s_PartialFunction$AndThen__f_pf = pf;
  this.s_PartialFunction$AndThen__f_k = k
}
$c_s_PartialFunction$AndThen.prototype = new $h_O();
$c_s_PartialFunction$AndThen.prototype.constructor = $c_s_PartialFunction$AndThen;
/** @constructor */
function $h_s_PartialFunction$AndThen() {
  /*<skip>*/
}
$h_s_PartialFunction$AndThen.prototype = $c_s_PartialFunction$AndThen.prototype;
$c_s_PartialFunction$AndThen.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that)
});
$c_s_PartialFunction$AndThen.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_s_PartialFunction$AndThen.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this)
});
$c_s_PartialFunction$AndThen.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action)
});
$c_s_PartialFunction$AndThen.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1))
});
$c_s_PartialFunction$AndThen.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_s_PartialFunction$AndThen.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$AndThen.prototype.isDefinedAt__O__Z = (function(x) {
  return $n(this.s_PartialFunction$AndThen__f_pf).isDefinedAt__O__Z(x)
});
$c_s_PartialFunction$AndThen.prototype.apply__O__O = (function(x) {
  return $n(this.s_PartialFunction$AndThen__f_k).apply__O__O($n(this.s_PartialFunction$AndThen__f_pf).apply__O__O(x))
});
$c_s_PartialFunction$AndThen.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var z = $n(this.s_PartialFunction$AndThen__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? $n(this.s_PartialFunction$AndThen__f_k).apply__O__O(z) : $n(default$1).apply__O__O(x))
});
$c_s_PartialFunction$AndThen.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
var $d_s_PartialFunction$AndThen = new $TypeData().initClass({
  s_PartialFunction$AndThen: 0
}, false, "scala.PartialFunction$AndThen", {
  s_PartialFunction$AndThen: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$AndThen.prototype.$classData = $d_s_PartialFunction$AndThen;
/** @constructor */
function $c_s_PartialFunction$Combined(pf, k) {
  this.s_PartialFunction$Combined__f_pf = null;
  this.s_PartialFunction$Combined__f_k = null;
  this.s_PartialFunction$Combined__f_pf = pf;
  this.s_PartialFunction$Combined__f_k = k
}
$c_s_PartialFunction$Combined.prototype = new $h_O();
$c_s_PartialFunction$Combined.prototype.constructor = $c_s_PartialFunction$Combined;
/** @constructor */
function $h_s_PartialFunction$Combined() {
  /*<skip>*/
}
$h_s_PartialFunction$Combined.prototype = $c_s_PartialFunction$Combined.prototype;
$c_s_PartialFunction$Combined.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that)
});
$c_s_PartialFunction$Combined.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_s_PartialFunction$Combined.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this)
});
$c_s_PartialFunction$Combined.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action)
});
$c_s_PartialFunction$Combined.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1))
});
$c_s_PartialFunction$Combined.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_s_PartialFunction$Combined.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$Combined.prototype.isDefinedAt__O__Z = (function(x) {
  var b = $n(this.s_PartialFunction$Combined__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(b)) && $n(this.s_PartialFunction$Combined__f_k).isDefinedAt__O__Z(b))
});
$c_s_PartialFunction$Combined.prototype.apply__O__O = (function(x) {
  return $n(this.s_PartialFunction$Combined__f_k).apply__O__O($n(this.s_PartialFunction$Combined__f_pf).apply__O__O(x))
});
$c_s_PartialFunction$Combined.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var pfv = $n(this.s_PartialFunction$Combined__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(pfv)) ? $n(this.s_PartialFunction$Combined__f_k).applyOrElse__O__F1__O(pfv, new $c_sjsr_AnonFunction1(((x$1$2) => $n(default$1).apply__O__O(x)))) : $n(default$1).apply__O__O(x))
});
$c_s_PartialFunction$Combined.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
var $d_s_PartialFunction$Combined = new $TypeData().initClass({
  s_PartialFunction$Combined: 0
}, false, "scala.PartialFunction$Combined", {
  s_PartialFunction$Combined: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$Combined.prototype.$classData = $d_s_PartialFunction$Combined;
/** @constructor */
function $c_s_PartialFunction$Lifted(pf) {
  this.s_PartialFunction$Lifted__f_pf = null;
  this.s_PartialFunction$Lifted__f_pf = pf
}
$c_s_PartialFunction$Lifted.prototype = new $h_sr_AbstractFunction1();
$c_s_PartialFunction$Lifted.prototype.constructor = $c_s_PartialFunction$Lifted;
/** @constructor */
function $h_s_PartialFunction$Lifted() {
  /*<skip>*/
}
$h_s_PartialFunction$Lifted.prototype = $c_s_PartialFunction$Lifted.prototype;
$c_s_PartialFunction$Lifted.prototype.apply__O__s_Option = (function(x) {
  var z = $n(this.s_PartialFunction$Lifted__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? new $c_s_Some(z) : $m_s_None$())
});
$c_s_PartialFunction$Lifted.prototype.apply__O__O = (function(v1) {
  return this.apply__O__s_Option(v1)
});
var $d_s_PartialFunction$Lifted = new $TypeData().initClass({
  s_PartialFunction$Lifted: 0
}, false, "scala.PartialFunction$Lifted", {
  s_PartialFunction$Lifted: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$Lifted.prototype.$classData = $d_s_PartialFunction$Lifted;
/** @constructor */
function $c_sc_AbstractIterator() {
  /*<skip>*/
}
$c_sc_AbstractIterator.prototype = new $h_O();
$c_sc_AbstractIterator.prototype.constructor = $c_sc_AbstractIterator;
/** @constructor */
function $h_sc_AbstractIterator() {
  /*<skip>*/
}
$h_sc_AbstractIterator.prototype = $c_sc_AbstractIterator.prototype;
$c_sc_AbstractIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sc_AbstractIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sc_AbstractIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_sc_AbstractIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return this.sliceIterator__I__I__sc_Iterator(n, (-1))
});
$c_sc_AbstractIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sc_AbstractIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sc_AbstractIterator.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sc_AbstractIterator.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_AbstractIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_AbstractIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sc_AbstractIterator.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_sc_AbstractIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_AbstractIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_AbstractIterator.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_sc_AbstractIterator.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sc_AbstractIterator.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_sc_AbstractIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sc_AbstractIterator.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_sc_AbstractIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_AbstractIterator.prototype.knownSize__I = (function() {
  return (-1)
});
/** @constructor */
function $c_sc_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Iterable$())
}
$c_sc_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Iterable$.prototype.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
  /*<skip>*/
}
$h_sc_Iterable$.prototype = $c_sc_Iterable$.prototype;
var $d_sc_Iterable$ = new $TypeData().initClass({
  sc_Iterable$: 0
}, false, "scala.collection.Iterable$", {
  sc_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Iterable$.prototype.$classData = $d_sc_Iterable$;
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$()
  };
  return $n_sc_Iterable$
}
/** @constructor */
function $c_sc_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  this.sc_Map$__f_DefaultSentinel = null;
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_sci_Map$());
  $n_sc_Map$ = this;
  this.sc_Map$__f_DefaultSentinel = $ct_O__(new $c_O());
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = new $c_sjsr_AnonFunction0((() => $m_sc_Map$().sc_Map$__f_DefaultSentinel))
}
$c_sc_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_sc_Map$.prototype.constructor = $c_sc_Map$;
/** @constructor */
function $h_sc_Map$() {
  /*<skip>*/
}
$h_sc_Map$.prototype = $c_sc_Map$.prototype;
var $d_sc_Map$ = new $TypeData().initClass({
  sc_Map$: 0
}, false, "scala.collection.Map$", {
  sc_Map$: 1,
  sc_MapFactory$Delegate: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Map$.prototype.$classData = $d_sc_Map$;
var $n_sc_Map$;
function $m_sc_Map$() {
  if ((!$n_sc_Map$)) {
    $n_sc_Map$ = new $c_sc_Map$()
  };
  return $n_sc_Map$
}
function $ct_sc_MapOps$WithFilter__sc_MapOps__F1__($thiz, self, p) {
  $thiz.sc_MapOps$WithFilter__f_self = self;
  $thiz.sc_MapOps$WithFilter__f_p = p;
  $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__($thiz, self, p);
  return $thiz
}
/** @constructor */
function $c_sc_MapOps$WithFilter() {
  this.sc_IterableOps$WithFilter__f_self = null;
  this.sc_IterableOps$WithFilter__f_p = null;
  this.sc_MapOps$WithFilter__f_self = null;
  this.sc_MapOps$WithFilter__f_p = null
}
$c_sc_MapOps$WithFilter.prototype = new $h_sc_IterableOps$WithFilter();
$c_sc_MapOps$WithFilter.prototype.constructor = $c_sc_MapOps$WithFilter;
/** @constructor */
function $h_sc_MapOps$WithFilter() {
  /*<skip>*/
}
$h_sc_MapOps$WithFilter.prototype = $c_sc_MapOps$WithFilter.prototype;
$c_sc_MapOps$WithFilter.prototype.map__F1__sc_IterableOps = (function(f) {
  return $as_sc_IterableOps($n($n(this.sc_MapOps$WithFilter__f_self).mapFactory__sc_MapFactory()).from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), this.filtered__sc_Iterable(), f)))
});
$c_sc_MapOps$WithFilter.prototype.flatMap__F1__sc_IterableOps = (function(f) {
  return $as_sc_IterableOps($n($n(this.sc_MapOps$WithFilter__f_self).mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(new $c_sc_View$FlatMap(this.filtered__sc_Iterable(), f)))
});
$c_sc_MapOps$WithFilter.prototype.withFilter__F1__sc_MapOps$WithFilter = (function(q) {
  return $ct_sc_MapOps$WithFilter__sc_MapOps__F1__(new $c_sc_MapOps$WithFilter(), this.sc_MapOps$WithFilter__f_self, new $c_sjsr_AnonFunction1(((kv$2) => {
    var kv = $as_T2(kv$2);
    return ($uZ($n(this.sc_MapOps$WithFilter__f_p).apply__O__O(kv)) && $uZ($n(q).apply__O__O(kv)))
  })))
});
$c_sc_MapOps$WithFilter.prototype.withFilter__F1__sc_WithFilter = (function(q) {
  return this.withFilter__F1__sc_MapOps$WithFilter(q)
});
$c_sc_MapOps$WithFilter.prototype.withFilter__F1__sc_IterableOps$WithFilter = (function(q) {
  return this.withFilter__F1__sc_MapOps$WithFilter(q)
});
var $d_sc_MapOps$WithFilter = new $TypeData().initClass({
  sc_MapOps$WithFilter: 0
}, false, "scala.collection.MapOps$WithFilter", {
  sc_MapOps$WithFilter: 1,
  sc_IterableOps$WithFilter: 1,
  sc_WithFilter: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sc_MapOps$WithFilter.prototype.$classData = $d_sc_MapOps$WithFilter;
/** @constructor */
function $c_sc_MapView$() {
  this.sc_MapView$__f_EmptyMapView = null;
  $n_sc_MapView$ = this;
  this.sc_MapView$__f_EmptyMapView = new $c_sc_MapView$$anon$1()
}
$c_sc_MapView$.prototype = new $h_O();
$c_sc_MapView$.prototype.constructor = $c_sc_MapView$;
/** @constructor */
function $h_sc_MapView$() {
  /*<skip>*/
}
$h_sc_MapView$.prototype = $c_sc_MapView$.prototype;
$c_sc_MapView$.prototype.newBuilder__scm_Builder = (function() {
  var this$4 = new $c_scm_HashMap$$anon$6(16, 0.75);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_scm_HashMap(x$1$2);
    var this$3 = $n(x$1);
    return new $c_sc_MapView$Id(this$3)
  }));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_sc_MapView$.prototype.from__sc_MapOps__sc_MapView = (function(it) {
  if ($is_sc_MapView(it)) {
    var x2 = $as_sc_MapView(it);
    return x2
  } else {
    return new $c_sc_MapView$Id(it)
  }
});
$c_sc_MapView$.prototype.apply__sci_Seq__sc_MapView = (function(elems) {
  var this$2 = $n(elems);
  var this$1 = $m_s_$less$colon$less$();
  return this.from__sc_MapOps__sc_MapView($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$2))
});
$c_sc_MapView$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_MapView(elems)
});
$c_sc_MapView$.prototype.from__sc_IterableOnce__O = (function(it) {
  return $m_sc_View$().from__sc_IterableOnce__sc_View(it)
});
$c_sc_MapView$.prototype.empty__O = (function() {
  return this.sc_MapView$__f_EmptyMapView
});
var $d_sc_MapView$ = new $TypeData().initClass({
  sc_MapView$: 0
}, false, "scala.collection.MapView$", {
  sc_MapView$: 1,
  O: 1,
  sc_MapViewFactory: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_MapView$.prototype.$classData = $d_sc_MapView$;
var $n_sc_MapView$;
function $m_sc_MapView$() {
  if ((!$n_sc_MapView$)) {
    $n_sc_MapView$ = new $c_sc_MapView$()
  };
  return $n_sc_MapView$
}
function $ct_sc_SeqFactory$Delegate__sc_SeqFactory__($thiz, delegate) {
  $thiz.sc_SeqFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_SeqFactory$Delegate() {
  this.sc_SeqFactory$Delegate__f_delegate = null
}
$c_sc_SeqFactory$Delegate.prototype = new $h_O();
$c_sc_SeqFactory$Delegate.prototype.constructor = $c_sc_SeqFactory$Delegate;
/** @constructor */
function $h_sc_SeqFactory$Delegate() {
  /*<skip>*/
}
$h_sc_SeqFactory$Delegate.prototype = $c_sc_SeqFactory$Delegate.prototype;
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__sc_SeqOps = (function(elems) {
  return $as_sc_SeqOps($n(this.sc_SeqFactory$Delegate__f_delegate).apply__sci_Seq__O(elems))
});
$c_sc_SeqFactory$Delegate.prototype.empty__sc_SeqOps = (function() {
  return $as_sc_SeqOps($n(this.sc_SeqFactory$Delegate__f_delegate).empty__O())
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return $as_sc_SeqOps($n(this.sc_SeqFactory$Delegate__f_delegate).from__sc_IterableOnce__O(it))
});
$c_sc_SeqFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_SeqFactory$Delegate__f_delegate).newBuilder__scm_Builder()
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_SeqOps(source)
});
$c_sc_SeqFactory$Delegate.prototype.empty__O = (function() {
  return this.empty__sc_SeqOps()
});
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_SeqOps(elems)
});
function $f_sc_SeqOps__prepended__O__O($thiz, elem) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_View$Prepended__O__sc_IterableOps__(new $c_sc_View$Prepended(), elem, $thiz))
}
function $f_sc_SeqOps__appended__O__O($thiz, elem) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_View$Appended__sc_IterableOps__O__(new $c_sc_View$Appended(), $thiz, elem))
}
function $f_sc_SeqOps__distinct__O($thiz) {
  return $thiz.distinctBy__F1__O(new $c_sjsr_AnonFunction1(((x$2) => x$2)))
}
function $f_sc_SeqOps__distinctBy__F1__O($thiz, f) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$DistinctBy($thiz, f))
}
function $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z($thiz, that, offset) {
  var i = $n($thiz.iterator__sc_Iterator()).drop__I__sc_Iterator(offset);
  var j = $n(that).iterator__sc_Iterator();
  while (($n(j).hasNext__Z() && $n(i).hasNext__Z())) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($n(i).next__O(), $n(j).next__O()))) {
      return false
    }
  };
  return (!$n(j).hasNext__Z())
}
function $f_sc_SeqOps__isDefinedAt__I__Z($thiz, idx) {
  return ((idx >= 0) && ($thiz.lengthCompare__I__I(idx) > 0))
}
function $f_sc_SeqOps__indexOf__O__I__I($thiz, elem, from) {
  return $thiz.indexWhere__F1__I__I(new $c_sjsr_AnonFunction1(((x$1$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(elem, x$1$2))), from)
}
function $f_sc_SeqOps__lastIndexWhere__F1__I__I($thiz, p, end) {
  var i = (((-1) + $thiz.length__I()) | 0);
  var it = $thiz.reverseIterator__sc_Iterator();
  while (true) {
    if ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var $$x1 = ((i > end) || (!$uZ($n(p).apply__O__O(elem))))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      i = (((-1) + i) | 0)
    } else {
      break
    }
  };
  return i
}
function $f_sc_SeqOps__contains__O__Z($thiz, elem) {
  return $thiz.exists__F1__Z(new $c_sjsr_AnonFunction1(((x$3$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(x$3$2, elem))))
}
function $f_sc_SeqOps__sorted__s_math_Ordering__O($thiz, ord) {
  var len = $thiz.length__I();
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((len === 1)) {
    var this$1 = $n(b);
    var elem = $thiz.head__O();
    this$1.addOne__O__scm_Growable(elem)
  } else if ((len > 1)) {
    $n(b).sizeHint__I__V(len);
    var arr = new $ac_O(len);
    $thiz.copyToArray__O__I__I__I(arr, 0, 2147483647);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, ord);
    var i = 0;
    while ((i < len)) {
      var this$2 = $n(b);
      var elem$1 = $n(arr).get(i);
      this$2.addOne__O__scm_Growable(elem$1);
      i = ((1 + i) | 0)
    }
  };
  return $n(b).result__O()
}
function $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($thiz, f, ord) {
  var this$1 = $n(ord);
  return $thiz.sorted__s_math_Ordering__O(new $c_s_math_Ordering$$anon$1(this$1, f))
}
function $f_sc_SeqOps__isEmpty__Z($thiz) {
  return ($thiz.lengthCompare__I__I(0) === 0)
}
function $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  var thisKnownSize = $thiz.knownSize__I();
  if ((thisKnownSize !== (-1))) {
    var thatKnownSize = $n(that).knownSize__I();
    var knownSizeDifference = ((thatKnownSize !== (-1)) && (thisKnownSize !== thatKnownSize))
  } else {
    var knownSizeDifference = false
  };
  if ((!knownSizeDifference)) {
    var this$1 = $n($thiz.iterator__sc_Iterator());
    return $f_sc_Iterator__sameElements__sc_IterableOnce__Z(this$1, that)
  } else {
    return false
  }
}
function $f_sc_SeqOps__diff__sc_Seq__O($thiz, that) {
  var occ = $f_sc_SeqOps__occCounts__sc_Seq__scm_Map($thiz, that);
  var this$3 = $n($thiz.iterator__sc_Iterator());
  var p = new $c_sjsr_AnonFunction1(((x$2) => {
    var include = new $c_sr_BooleanRef(false);
    $n(occ).updateWith__O__F1__s_Option(x$2, new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var rc8 = false;
      var x3 = null;
      var x = $m_s_None$();
      if ((x === x0$1)) {
        include.sr_BooleanRef__f_elem = true;
        return $m_s_None$()
      };
      if ((x0$1 instanceof $c_s_Some)) {
        rc8 = true;
        x3 = $as_s_Some(x0$1);
        var p4 = $uI($n(x3).s_Some__f_value);
        if ((p4 === 1)) {
          return $m_s_None$()
        }
      };
      if (rc8) {
        var n = $uI($n(x3).s_Some__f_value);
        return new $c_s_Some((((-1) + n) | 0))
      };
      throw new $c_s_MatchError(x0$1)
    })));
    return include.sr_BooleanRef__f_elem
  }));
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_Iterator$$anon$6(this$3, p, false))
}
function $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O($thiz, from, other, replaced) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$Patched($thiz, from, other, replaced))
}
function $f_sc_SeqOps__updated__I__O__O($thiz, index, elem) {
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  };
  var k = $thiz.knownSize__I();
  if (((k >= 0) && (index >= k))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  };
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$Updated($thiz, index, elem))
}
function $f_sc_SeqOps__occCounts__sc_Seq__scm_Map($thiz, sq) {
  var occ = $ct_scm_HashMap__(new $c_scm_HashMap());
  $n(sq).foreach__F1__V(new $c_sjsr_AnonFunction1(((y$2) => {
    var originalHash = $m_sr_Statics$().anyHash__O__I(y$2);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var indexedHash = (hash & (((-1) + $n(occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
    var elem = null;
    elem = null;
    var elem$1 = null;
    elem$1 = null;
    var x1 = $n(occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(indexedHash);
    if ((x1 !== null)) {
      var prev = null;
      var nd = x1;
      while (true) {
        if (((hash === $n(nd).scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(y$2, $n(nd).scm_HashMap$Node__f__key))) {
          elem$1 = prev;
          elem = nd
        } else if ((!(($n(nd).scm_HashMap$Node__f__next === null) || ($n(nd).scm_HashMap$Node__f__hash > hash)))) {
          var temp$prev = nd;
          var temp$nd = $n(nd).scm_HashMap$Node__f__next;
          prev = temp$prev;
          nd = temp$nd;
          continue
        };
        break
      }
    };
    var x1$2 = $as_scm_HashMap$Node(elem);
    var previousValue = ((x1$2 === null) ? $m_s_None$() : new $c_s_Some($n(x1$2).scm_HashMap$Node__f__value));
    var x = $m_s_None$();
    if ((x === previousValue)) {
      var nextValue = new $c_s_Some(1)
    } else {
      if ((!(previousValue instanceof $c_s_Some))) {
        throw new $c_s_MatchError(previousValue)
      };
      var x3 = $as_s_Some(previousValue);
      var n = $uI($n(x3).s_Some__f_value);
      var nextValue = new $c_s_Some(((1 + n) | 0))
    };
    var x1$3 = $ct_T2__O__O__(new $c_T2(), previousValue, nextValue);
    matchEnd21: {
      var p2 = $as_s_Option(x1$3.T2__f__1);
      var p3 = $as_s_Option(x1$3.T2__f__2);
      var x$3 = $m_s_None$();
      if ((x$3 === p2)) {
        var x$5 = $m_s_None$();
        var $$x1 = (x$5 === p3)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        break matchEnd21
      };
      var p6 = $as_s_Option(x1$3.T2__f__1);
      var p7 = $as_s_Option(x1$3.T2__f__2);
      if ((p6 instanceof $c_s_Some)) {
        var x$7 = $m_s_None$();
        var $$x2 = (x$7 === p7)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        if (($as_scm_HashMap$Node(elem$1) !== null)) {
          $n($as_scm_HashMap$Node(elem$1)).scm_HashMap$Node__f__next = $n($as_scm_HashMap$Node(elem)).scm_HashMap$Node__f__next
        } else {
          $n(occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(indexedHash, $n($as_scm_HashMap$Node(elem)).scm_HashMap$Node__f__next)
        };
        occ.scm_HashMap__f_contentSize = (((-1) + occ.scm_HashMap__f_contentSize) | 0);
        break matchEnd21
      };
      var p11 = $as_s_Option(x1$3.T2__f__1);
      var p12 = $as_s_Option(x1$3.T2__f__2);
      var x$9 = $m_s_None$();
      if (((x$9 === p11) && (p12 instanceof $c_s_Some))) {
        var x13 = $as_s_Some(p12);
        var value = $n(x13).s_Some__f_value;
        var newIndexedHash = ((((1 + occ.scm_HashMap__f_contentSize) | 0) >= occ.scm_HashMap__f_threshold) ? ($p_scm_HashMap__growTable__I__V(occ, ($n(occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1)), (hash & (((-1) + $n(occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0))) : indexedHash);
        $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(occ, y$2, value, false, hash, newIndexedHash);
        break matchEnd21
      };
      var p15 = $as_s_Option(x1$3.T2__f__1);
      var p16 = $as_s_Option(x1$3.T2__f__2);
      if (((p15 instanceof $c_s_Some) && (p16 instanceof $c_s_Some))) {
        var x19 = $as_s_Some(p16);
        var newValue = $n(x19).s_Some__f_value;
        $n($as_scm_HashMap$Node(elem)).scm_HashMap$Node__f__value = newValue;
        break matchEnd21
      };
      throw new $c_s_MatchError(x1$3)
    };
    return nextValue
  })));
  return occ
}
function $is_sc_SeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SeqOps)))
}
function $as_sc_SeqOps(obj) {
  return (($is_sc_SeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SeqOps"))
}
function $isArrayOf_sc_SeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SeqOps)))
}
function $asArrayOf_sc_SeqOps(obj, depth) {
  return (($isArrayOf_sc_SeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SeqOps;", depth))
}
/** @constructor */
function $c_sc_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Set$())
}
$c_sc_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Set$.prototype.constructor = $c_sc_Set$;
/** @constructor */
function $h_sc_Set$() {
  /*<skip>*/
}
$h_sc_Set$.prototype = $c_sc_Set$.prototype;
var $d_sc_Set$ = new $TypeData().initClass({
  sc_Set$: 0
}, false, "scala.collection.Set$", {
  sc_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Set$.prototype.$classData = $d_sc_Set$;
var $n_sc_Set$;
function $m_sc_Set$() {
  if ((!$n_sc_Set$)) {
    $n_sc_Set$ = new $c_sc_Set$()
  };
  return $n_sc_Set$
}
/** @constructor */
function $c_sc_SortedSetOps$WithFilter(self, p) {
  this.sc_IterableOps$WithFilter__f_self = null;
  this.sc_IterableOps$WithFilter__f_p = null;
  this.sc_SortedSetOps$WithFilter__f_self = null;
  this.sc_SortedSetOps$WithFilter__f_p = null;
  this.sc_SortedSetOps$WithFilter__f_self = self;
  this.sc_SortedSetOps$WithFilter__f_p = p;
  $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(this, self, p)
}
$c_sc_SortedSetOps$WithFilter.prototype = new $h_sc_IterableOps$WithFilter();
$c_sc_SortedSetOps$WithFilter.prototype.constructor = $c_sc_SortedSetOps$WithFilter;
/** @constructor */
function $h_sc_SortedSetOps$WithFilter() {
  /*<skip>*/
}
$h_sc_SortedSetOps$WithFilter.prototype = $c_sc_SortedSetOps$WithFilter.prototype;
$c_sc_SortedSetOps$WithFilter.prototype.withFilter__F1__sc_SortedSetOps$WithFilter = (function(q) {
  return new $c_sc_SortedSetOps$WithFilter(this.sc_SortedSetOps$WithFilter__f_self, new $c_sjsr_AnonFunction1(((a$2) => ($uZ($n(this.sc_SortedSetOps$WithFilter__f_p).apply__O__O(a$2)) && $uZ($n(q).apply__O__O(a$2))))))
});
$c_sc_SortedSetOps$WithFilter.prototype.withFilter__F1__sc_WithFilter = (function(q) {
  return this.withFilter__F1__sc_SortedSetOps$WithFilter(q)
});
$c_sc_SortedSetOps$WithFilter.prototype.withFilter__F1__sc_IterableOps$WithFilter = (function(q) {
  return this.withFilter__F1__sc_SortedSetOps$WithFilter(q)
});
var $d_sc_SortedSetOps$WithFilter = new $TypeData().initClass({
  sc_SortedSetOps$WithFilter: 0
}, false, "scala.collection.SortedSetOps$WithFilter", {
  sc_SortedSetOps$WithFilter: 1,
  sc_IterableOps$WithFilter: 1,
  sc_WithFilter: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sc_SortedSetOps$WithFilter.prototype.$classData = $d_sc_SortedSetOps$WithFilter;
function $f_sc_StrictOptimizedIterableOps__map__F1__O($thiz, f) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $n(f).apply__O__O($n(it).next__O());
    this$1.addOne__O__scm_Growable(elem)
  };
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($thiz, f) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var xs = $as_sc_IterableOnce($n(f).apply__O__O($n(it).next__O()));
    this$1.addAll__sc_IterableOnce__scm_Growable(xs)
  };
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($thiz, pf) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var v = $n(pf).applyOrElse__O__F1__O(elem, new $c_sjsr_AnonFunction1(((marker) => ((x$2) => marker))(marker)));
    if ((marker !== v)) {
      var this$3 = $n(b);
      this$3.addOne__O__scm_Growable(v)
    }
  };
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedIterableOps__flatten__F1__O($thiz, toIterableOnce) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var xs = $as_sc_IterableOnce($n(toIterableOnce).apply__O__O($n(it).next__O()));
    this$1.addAll__sc_IterableOnce__scm_Growable(xs)
  };
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O($thiz, that) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it1 = $thiz.iterator__sc_Iterator();
  var it2 = $n(that).iterator__sc_Iterator();
  while (($n(it1).hasNext__Z() && $n(it2).hasNext__Z())) {
    var this$1 = $n(b);
    var elem = $ct_T2__O__O__(new $c_T2(), $n(it1).next__O(), $n(it2).next__O());
    this$1.addOne__O__scm_Growable(elem)
  };
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedIterableOps__zipWithIndex__O($thiz) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var i = 0;
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $ct_T2__O__O__(new $c_T2(), $n(it).next__O(), i);
    this$1.addOne__O__scm_Growable(elem);
    i = ((1 + i) | 0)
  };
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O($thiz, z, op) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var this$1 = $n(b);
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this$1, $thiz, 0);
  var acc = z;
  var this$2 = $n(b);
  var elem = acc;
  this$2.addOne__O__scm_Growable(elem);
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    acc = $n(op).apply__O__O__O(acc, $n(it).next__O());
    var this$3 = $n(b);
    var elem$1 = acc;
    this$3.addOne__O__scm_Growable(elem$1)
  };
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O($thiz, pred, isFlipped) {
  var b = $thiz.newSpecificBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    if (($uZ($n(pred).apply__O__O(elem)) !== isFlipped)) {
      var this$1 = $n(b);
      this$1.addOne__O__scm_Growable(elem)
    }
  };
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedIterableOps__dropRight__I__O($thiz, n) {
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((n >= 0)) {
    var this$1 = $n(b);
    var delta = ((-n) | 0);
    $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this$1, $thiz, delta)
  };
  var lead = $n($thiz.iterator__sc_Iterator()).drop__I__sc_Iterator(n);
  var it = $thiz.iterator__sc_Iterator();
  while ($n(lead).hasNext__Z()) {
    var this$2 = $n(b);
    var elem = $n(it).next__O();
    this$2.addOne__O__scm_Growable(elem);
    $n(lead).next__O()
  };
  return $n(b).result__O()
}
function $is_sc_StrictOptimizedIterableOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_StrictOptimizedIterableOps)))
}
function $as_sc_StrictOptimizedIterableOps(obj) {
  return (($is_sc_StrictOptimizedIterableOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StrictOptimizedIterableOps"))
}
function $isArrayOf_sc_StrictOptimizedIterableOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StrictOptimizedIterableOps)))
}
function $asArrayOf_sc_StrictOptimizedIterableOps(obj, depth) {
  return (($isArrayOf_sc_StrictOptimizedIterableOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StrictOptimizedIterableOps;", depth))
}
class $c_sc_convert_JavaCollectionWrappers$$anon$7 extends $c_s_util_control_ControlThrowable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, false, false)
  };
}
var $d_sc_convert_JavaCollectionWrappers$$anon$7 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$$anon$7: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$$anon$7", {
  sc_convert_JavaCollectionWrappers$$anon$7: 1,
  s_util_control_ControlThrowable: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sc_convert_JavaCollectionWrappers$$anon$7.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$$anon$7;
function $as_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$IteratorWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$IteratorWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$IteratorWrapper;", depth))
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$MapWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$MapWrapper__f_scala$collection$convert$JavaCollectionWrappers$MapWrapper$$underlying = null;
  this.sc_convert_JavaCollectionWrappers$MapWrapper__f_scala$collection$convert$JavaCollectionWrappers$MapWrapper$$underlying = underlying
}
$c_sc_convert_JavaCollectionWrappers$MapWrapper.prototype = new $h_ju_AbstractMap();
$c_sc_convert_JavaCollectionWrappers$MapWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$MapWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$MapWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$MapWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$MapWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$MapWrapper.prototype.size__I = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$MapWrapper__f_scala$collection$convert$JavaCollectionWrappers$MapWrapper$$underlying).size__I()
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper.prototype.get__O__O = (function(key) {
  try {
    var x1 = $n(this.sc_convert_JavaCollectionWrappers$MapWrapper__f_scala$collection$convert$JavaCollectionWrappers$MapWrapper$$underlying).get__O__s_Option(key);
    var x = $m_s_None$();
    if ((x === x1)) {
      return null
    } else if ((x1 instanceof $c_s_Some)) {
      var x3 = $as_s_Some(x1);
      var v = $n(x3).s_Some__f_value;
      return v
    } else {
      throw new $c_s_MatchError(x1)
    }
  } catch (e) {
    if ((e instanceof $c_jl_ClassCastException)) {
      $as_jl_ClassCastException(e);
      return null
    } else {
      throw e
    }
  }
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper.prototype.entrySet__ju_Set = (function() {
  return new $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2(this)
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper.prototype.containsKey__O__Z = (function(key) {
  try {
    return $n(this.sc_convert_JavaCollectionWrappers$MapWrapper__f_scala$collection$convert$JavaCollectionWrappers$MapWrapper$$underlying).contains__O__Z(key)
  } catch (e) {
    if ((e instanceof $c_jl_ClassCastException)) {
      $as_jl_ClassCastException(e);
      return false
    } else {
      throw e
    }
  }
});
var $d_sc_convert_JavaCollectionWrappers$MapWrapper = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$MapWrapper: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$MapWrapper", {
  sc_convert_JavaCollectionWrappers$MapWrapper: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$MapWrapper;
/** @constructor */
function $c_sci_BitSet$() {
  this.sci_BitSet$__f_empty = null;
  $n_sci_BitSet$ = this;
  this.sci_BitSet$__f_empty = new $c_sci_BitSet$BitSet1($L0)
}
$c_sci_BitSet$.prototype = new $h_O();
$c_sci_BitSet$.prototype.constructor = $c_sci_BitSet$;
/** @constructor */
function $h_sci_BitSet$() {
  /*<skip>*/
}
$h_sci_BitSet$.prototype = $c_sci_BitSet$.prototype;
$c_sci_BitSet$.prototype.fromSpecific__sc_IterableOnce__sci_BitSet = (function(it) {
  if ((it instanceof $c_sci_BitSet)) {
    var x2 = $as_sci_BitSet(it);
    return x2
  } else {
    var this$1 = $n(this.newBuilder__scm_Builder());
    return $as_sci_BitSet($n($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(it))).result__O())
  }
});
$c_sci_BitSet$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  var f = new $c_sjsr_AnonFunction1(((bs$2) => {
    var bs = $as_scm_BitSet(bs$2);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet($n(bs).scm_BitSet__f_elems)
  }));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_BitSet$.prototype.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet = (function(a, b) {
  return (((b.RTLong__f_lo === 0) && (b.RTLong__f_hi === 0)) ? new $c_sci_BitSet$BitSet1(a) : new $c_sci_BitSet$BitSet2(a, b))
});
$c_sci_BitSet$.prototype.fromBitMaskNoCopy__AJ__sci_BitSet = (function(elems) {
  var len = $n(elems).u.length;
  return ((len === 0) ? this.sci_BitSet$__f_empty : ((len === 1) ? new $c_sci_BitSet$BitSet1($n(elems).get(0)) : ((len === 2) ? this.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet($n(elems).get(0), $n(elems).get(1)) : new $c_sci_BitSet$BitSetN(elems))))
});
$c_sci_BitSet$.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return this.fromSpecific__sc_IterableOnce__sci_BitSet(it)
});
var $d_sci_BitSet$ = new $TypeData().initClass({
  sci_BitSet$: 0
}, false, "scala.collection.immutable.BitSet$", {
  sci_BitSet$: 1,
  O: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$.prototype.$classData = $d_sci_BitSet$;
var $n_sci_BitSet$;
function $m_sci_BitSet$() {
  if ((!$n_sci_BitSet$)) {
    $n_sci_BitSet$ = new $c_sci_BitSet$()
  };
  return $n_sci_BitSet$
}
/** @constructor */
function $c_sci_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_List$())
}
$c_sci_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sci_Iterable$.prototype.constructor = $c_sci_Iterable$;
/** @constructor */
function $h_sci_Iterable$() {
  /*<skip>*/
}
$h_sci_Iterable$.prototype = $c_sci_Iterable$.prototype;
$c_sci_Iterable$.prototype.from__sc_IterableOnce__sci_Iterable = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    return x2
  } else {
    return $as_sci_Iterable($c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O.call(this, it))
  }
});
$c_sci_Iterable$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Iterable(it)
});
var $d_sci_Iterable$ = new $TypeData().initClass({
  sci_Iterable$: 0
}, false, "scala.collection.immutable.Iterable$", {
  sci_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Iterable$.prototype.$classData = $d_sci_Iterable$;
var $n_sci_Iterable$;
function $m_sci_Iterable$() {
  if ((!$n_sci_Iterable$)) {
    $n_sci_Iterable$ = new $c_sci_Iterable$()
  };
  return $n_sci_Iterable$
}
/** @constructor */
function $c_sci_LazyList$() {
  this.sci_LazyList$__f__empty = null;
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = null;
  $n_sci_LazyList$ = this;
  var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$State$Empty$()));
  this.sci_LazyList$__f__empty = new $c_sci_LazyList(state).force__sci_LazyList();
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = new $c_sjsr_AnonFunction1(((x$10$2) => $m_sr_Statics$PFMarker$()))
}
$c_sci_LazyList$.prototype = new $h_O();
$c_sci_LazyList$.prototype.constructor = $c_sci_LazyList$;
/** @constructor */
function $h_sci_LazyList$() {
  /*<skip>*/
}
$h_sci_LazyList$.prototype = $c_sci_LazyList$.prototype;
$c_sci_LazyList$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_LazyList(elems)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList = (function(ll, p, isFlipped) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state = new $c_sjsr_AnonFunction0((() => {
    var elem = null;
    var found = false;
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    while (((!found) && (!$n(rest).isEmpty__Z()))) {
      var this$3 = $n(rest);
      elem = $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      found = ($uZ($n(p).apply__O__O(elem)) !== isFlipped);
      var this$4 = $n(rest);
      rest = $n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = rest
    };
    if (found) {
      $m_sci_LazyList$();
      var hd = elem;
      var tl = $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(rest, p, isFlipped);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    } else {
      return $m_sci_LazyList$State$Empty$()
    }
  }));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$collectImpl__sci_LazyList__s_PartialFunction__sci_LazyList = (function(ll, pf) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state = new $c_sjsr_AnonFunction0((() => {
    var marker = $m_sr_Statics$PFMarker$();
    var toMarker = $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker;
    var res = marker;
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    while (((res === marker) && (!$n(rest).isEmpty__Z()))) {
      var $$x1 = $n(pf);
      var this$4 = $n(rest);
      res = $n($$x1).applyOrElse__O__F1__O($n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O(), toMarker);
      var this$5 = $n(rest);
      rest = $n(this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = rest
    };
    if ((res === marker)) {
      return $m_sci_LazyList$State$Empty$()
    } else {
      $m_sci_LazyList$();
      var hd = res;
      var tl = $m_sci_LazyList$().scala$collection$immutable$LazyList$$collectImpl__sci_LazyList__s_PartialFunction__sci_LazyList(rest, pf);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    }
  }));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList = (function(ll, f) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state$1 = new $c_sjsr_AnonFunction0((() => {
    var it = new $c_sr_ObjectRef(null);
    var itHasNext = false;
    var elem = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    var rest = new $c_sr_ObjectRef(elem);
    while (((!itHasNext) && (!$n($as_sci_LazyList(rest.sr_ObjectRef__f_elem)).isEmpty__Z()))) {
      var this$5 = $n($as_sci_LazyList(rest.sr_ObjectRef__f_elem));
      it.sr_ObjectRef__f_elem = $n($as_sc_IterableOnce($n(f).apply__O__O($n(this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()))).iterator__sc_Iterator();
      itHasNext = $n($as_sc_Iterator(it.sr_ObjectRef__f_elem)).hasNext__Z();
      if ((!itHasNext)) {
        var this$6 = $n($as_sci_LazyList(rest.sr_ObjectRef__f_elem));
        rest.sr_ObjectRef__f_elem = $n(this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
        restRef.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem)
      }
    };
    if (itHasNext) {
      var head = $n($as_sc_Iterator(it.sr_ObjectRef__f_elem)).next__O();
      var this$7 = $n($as_sci_LazyList(rest.sr_ObjectRef__f_elem));
      rest.sr_ObjectRef__f_elem = $n(this$7.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      $m_sci_LazyList$();
      $m_sci_LazyList$();
      var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State($as_sc_Iterator(it.sr_ObjectRef__f_elem), new $c_sjsr_AnonFunction0((() => $n($m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList($as_sci_LazyList(rest.sr_ObjectRef__f_elem), f)).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))));
      var tl = new $c_sci_LazyList(state);
      return new $c_sci_LazyList$State$Cons(head, tl)
    } else {
      return $m_sci_LazyList$State$Empty$()
    }
  }));
  return new $c_sci_LazyList(state$1)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList = (function(ll, n) {
  var restRef = new $c_sr_ObjectRef(ll);
  var iRef = new $c_sr_IntRef(n);
  var state = new $c_sjsr_AnonFunction0((() => {
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    var i = iRef.sr_IntRef__f_elem;
    while (((i > 0) && (!$n(rest).isEmpty__Z()))) {
      var this$4 = $n(rest);
      rest = $n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = rest;
      i = (((-1) + i) | 0);
      iRef.sr_IntRef__f_elem = i
    };
    return $n(rest).scala$collection$immutable$LazyList$$state__sci_LazyList$State()
  }));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$dropWhileImpl__sci_LazyList__F1__sci_LazyList = (function(ll, p) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state = new $c_sjsr_AnonFunction0((() => {
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    while (true) {
      if ((!$n(rest).isEmpty__Z())) {
        var this$3 = $n(rest);
        var $$x1 = $uZ($n(p).apply__O__O($n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var this$4 = $n(rest);
        rest = $n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
        restRef.sr_ObjectRef__f_elem = rest
      } else {
        break
      }
    };
    return $n(rest).scala$collection$immutable$LazyList$$state__sci_LazyList$State()
  }));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__sci_LazyList = (function(coll) {
  if ((coll instanceof $c_sci_LazyList)) {
    var x2 = $as_sci_LazyList(coll);
    return x2
  } else if (($n(coll).knownSize__I() === 0)) {
    return this.sci_LazyList$__f__empty
  } else {
    var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State($n(coll).iterator__sc_Iterator())));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State = (function(it, suffix) {
  if ($n(it).hasNext__Z()) {
    var hd = $n(it).next__O();
    var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State(it, suffix)));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  } else {
    return $as_sci_LazyList$State($n(suffix).apply__O())
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State = (function(it) {
  if ($n(it).hasNext__Z()) {
    var hd = $n(it).next__O();
    var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(it)));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  } else {
    return $m_sci_LazyList$State$Empty$()
  }
});
$c_sci_LazyList$.prototype.iterate__F0__F1__sci_LazyList = (function(start, f) {
  var state = new $c_sjsr_AnonFunction0((() => {
    var head = $n(start).apply__O();
    $m_sci_LazyList$();
    var tl = $m_sci_LazyList$().iterate__F0__F1__sci_LazyList(new $c_sjsr_AnonFunction0((() => $n(f).apply__O__O(head))), f);
    return new $c_sci_LazyList$State$Cons(head, tl)
  }));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.from__I__I__sci_LazyList = (function(start, step) {
  var state = new $c_sjsr_AnonFunction0((() => {
    $m_sci_LazyList$();
    var tl = $m_sci_LazyList$().from__I__I__sci_LazyList(((start + step) | 0), step);
    return new $c_sci_LazyList$State$Cons(start, tl)
  }));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_LazyList$LazyBuilder()
});
$c_sci_LazyList$.prototype.empty__O = (function() {
  return this.sci_LazyList$__f__empty
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_LazyList(source)
});
var $d_sci_LazyList$ = new $TypeData().initClass({
  sci_LazyList$: 0
}, false, "scala.collection.immutable.LazyList$", {
  sci_LazyList$: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$.prototype.$classData = $d_sci_LazyList$;
var $n_sci_LazyList$;
function $m_sci_LazyList$() {
  if ((!$n_sci_LazyList$)) {
    $n_sci_LazyList$ = new $c_sci_LazyList$()
  };
  return $n_sci_LazyList$
}
/** @constructor */
function $c_sci_SortedMap$() {
  this.sc_SortedMapFactory$Delegate__f_delegate = null;
  $ct_sc_SortedMapFactory$Delegate__sc_SortedMapFactory__(this, $m_sci_TreeMap$())
}
$c_sci_SortedMap$.prototype = new $h_sc_SortedMapFactory$Delegate();
$c_sci_SortedMap$.prototype.constructor = $c_sci_SortedMap$;
/** @constructor */
function $h_sci_SortedMap$() {
  /*<skip>*/
}
$h_sci_SortedMap$.prototype = $c_sci_SortedMap$.prototype;
$c_sci_SortedMap$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_SortedMap = (function(it, evidence$1) {
  if ($is_sci_SortedMap(it)) {
    var x2 = $as_sci_SortedMap(it);
    $n($m_s_package$().s_package$__f_Ordering);
    var x$2 = $n(x2).ordering__s_math_Ordering();
    if (((evidence$1 === null) ? (x$2 === null) : $n(evidence$1).equals__O__Z(x$2))) {
      return x2
    }
  };
  return $as_sci_SortedMap($c_sc_SortedMapFactory$Delegate.prototype.from__sc_IterableOnce__s_math_Ordering__O.call(this, it, evidence$1))
});
$c_sci_SortedMap$.prototype.from__sc_IterableOnce__s_math_Ordering__O = (function(it, evidence$46) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_SortedMap(it, evidence$46)
});
var $d_sci_SortedMap$ = new $TypeData().initClass({
  sci_SortedMap$: 0
}, false, "scala.collection.immutable.SortedMap$", {
  sci_SortedMap$: 1,
  sc_SortedMapFactory$Delegate: 1,
  O: 1,
  sc_SortedMapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_SortedMap$.prototype.$classData = $d_sci_SortedMap$;
var $n_sci_SortedMap$;
function $m_sci_SortedMap$() {
  if ((!$n_sci_SortedMap$)) {
    $n_sci_SortedMap$ = new $c_sci_SortedMap$()
  };
  return $n_sci_SortedMap$
}
/** @constructor */
function $c_sci_Stream$() {
  /*<skip>*/
}
$c_sci_Stream$.prototype = new $h_O();
$c_sci_Stream$.prototype.constructor = $c_sci_Stream$;
/** @constructor */
function $h_sci_Stream$() {
  /*<skip>*/
}
$h_sci_Stream$.prototype = $c_sci_Stream$.prototype;
$c_sci_Stream$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Stream(elems)
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__sci_Stream = (function(coll) {
  if ((coll instanceof $c_sci_Stream)) {
    var x2 = $as_sci_Stream(coll);
    return x2
  } else {
    return this.fromIterator__sc_Iterator__sci_Stream($n(coll).iterator__sc_Iterator())
  }
});
$c_sci_Stream$.prototype.fromIterator__sc_Iterator__sci_Stream = (function(it) {
  return ($n(it).hasNext__Z() ? new $c_sci_Stream$Cons($n(it).next__O(), new $c_sjsr_AnonFunction0((() => $m_sci_Stream$().fromIterator__sc_Iterator__sci_Stream(it)))) : $m_sci_Stream$Empty$())
});
$c_sci_Stream$.prototype.newBuilder__scm_Builder = (function() {
  $m_scm_ArrayBuffer$();
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((array$2) => {
    var array = $as_scm_ArrayBuffer(array$2);
    return $m_sci_Stream$().from__sc_IterableOnce__sci_Stream(array)
  }));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_Stream$.prototype.filteredTail__sci_Stream__F1__Z__sci_Stream = (function(stream, p, isFlipped) {
  var hd = $n(stream).head__O();
  var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream($n(stream).tail__O())).filterImpl__F1__Z__sci_Stream(p, isFlipped)));
  return new $c_sci_Stream$Cons(hd, tl)
});
$c_sci_Stream$.prototype.collectedTail__O__sci_Stream__s_PartialFunction__sci_Stream = (function(head, stream, pf) {
  var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream($n(stream).tail__O())).collect__s_PartialFunction__sci_Stream(pf)));
  return new $c_sci_Stream$Cons(head, tl)
});
$c_sci_Stream$.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$()
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Stream(source)
});
var $d_sci_Stream$ = new $TypeData().initClass({
  sci_Stream$: 0
}, false, "scala.collection.immutable.Stream$", {
  sci_Stream$: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$.prototype.$classData = $d_sci_Stream$;
var $n_sci_Stream$;
function $m_sci_Stream$() {
  if ((!$n_sci_Stream$)) {
    $n_sci_Stream$ = new $c_sci_Stream$()
  };
  return $n_sci_Stream$
}
/** @constructor */
function $c_sci_TreeMap$Adder(outer) {
  this.sci_RedBlackTree$Helper__f_ordering = null;
  this.sci_TreeMap$Adder__f_currentMutableTree = null;
  var ordering = $n(outer).sci_TreeMap__f_ordering;
  $ct_sci_RedBlackTree$Helper__s_math_Ordering__(this, ordering);
  var this$1 = $n(outer);
  this.sci_TreeMap$Adder__f_currentMutableTree = this$1.sci_TreeMap__f_tree
}
$c_sci_TreeMap$Adder.prototype = new $h_sci_RedBlackTree$MapHelper();
$c_sci_TreeMap$Adder.prototype.constructor = $c_sci_TreeMap$Adder;
/** @constructor */
function $h_sci_TreeMap$Adder() {
  /*<skip>*/
}
$h_sci_TreeMap$Adder.prototype = $c_sci_TreeMap$Adder.prototype;
$c_sci_TreeMap$Adder.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ((this.apply__T2__V($as_T2(v1)), (void 0)))
});
$c_sci_TreeMap$Adder.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sci_TreeMap$Adder.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sci_TreeMap$Adder.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sci_TreeMap$Adder.prototype.apply__T2__V = (function(kv) {
  this.sci_TreeMap$Adder__f_currentMutableTree = this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this.sci_TreeMap$Adder__f_currentMutableTree, $n(kv)._1__O(), $n(kv)._2__O())
});
$c_sci_TreeMap$Adder.prototype.addAll__sci_LinearSeq__V = (function(ls) {
  while ((!$n(ls).isEmpty__Z())) {
    var kv = $as_T2($n(ls).head__O());
    this.sci_TreeMap$Adder__f_currentMutableTree = this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this.sci_TreeMap$Adder__f_currentMutableTree, $n(kv)._1__O(), $n(kv)._2__O());
    ls = $as_sci_LinearSeq($n(ls).tail__O())
  }
});
$c_sci_TreeMap$Adder.prototype.apply__O__O = (function(v1) {
  this.apply__T2__V($as_T2(v1))
});
var $d_sci_TreeMap$Adder = new $TypeData().initClass({
  sci_TreeMap$Adder: 0
}, false, "scala.collection.immutable.TreeMap$Adder", {
  sci_TreeMap$Adder: 1,
  sci_RedBlackTree$MapHelper: 1,
  sci_RedBlackTree$Helper: 1,
  O: 1,
  F1: 1
});
$c_sci_TreeMap$Adder.prototype.$classData = $d_sci_TreeMap$Adder;
/** @constructor */
function $c_sci_TreeSet$() {
  /*<skip>*/
}
$c_sci_TreeSet$.prototype = new $h_O();
$c_sci_TreeSet$.prototype.constructor = $c_sci_TreeSet$;
/** @constructor */
function $h_sci_TreeSet$() {
  /*<skip>*/
}
$h_sci_TreeSet$.prototype = $c_sci_TreeSet$.prototype;
$c_sci_TreeSet$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(xs, $as_s_math_Ordering(evidence$7))
});
$c_sci_TreeSet$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet = (function(it, ordering) {
  if ((it instanceof $c_sci_TreeSet)) {
    var x2 = $as_sci_TreeSet(it);
    var x$2 = $n(x2).sci_TreeSet__f_ordering;
    if (((ordering === null) ? (x$2 === null) : $n(ordering).equals__O__Z(x$2))) {
      return x2
    }
  };
  if ($is_sc_SortedSet(it)) {
    var x3 = $as_sc_SortedSet(it);
    var x$4 = $n(x3).ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : $n(ordering).equals__O__Z(x$4))) {
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree($n(x3).iterator__sc_Iterator(), $n(x3).size__I()), ordering)
    }
  };
  if ((it instanceof $c_sci_Range)) {
    var x4 = $as_sci_Range(it);
    if ((ordering === $m_s_math_Ordering$Int$())) {
      var $$x1 = true
    } else {
      var this$1 = $m_s_math_Ordering$Int$();
      var $$x1 = $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$1, ordering)
    };
    if ($$x1) {
      if (((ordering === $m_s_math_Ordering$Int$()) === ($n(x4).sci_Range__f_step > 0))) {
        var it$2 = $n(x4).iterator__sc_Iterator()
      } else {
        var this$2 = $n(x4);
        var this$3 = new $c_sc_IndexedSeqView$Id(this$2);
        var it$2 = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$3)
      };
      var $$x2 = $m_sci_RedBlackTree$();
      var this$4 = $n(x4);
      var tree = $n($$x2).fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree(it$2, this$4.length__I());
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), tree, ordering)
    }
  };
  var t = null;
  var i = $n(it).iterator__sc_Iterator();
  while ($n(i).hasNext__Z()) {
    t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, $n(i).next__O(), null, false, ordering)
  };
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, ordering)
});
$c_sci_TreeSet$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  var ordering = $as_s_math_Ordering(evidence$12);
  return new $c_sci_TreeSet$TreeSetBuilder(ordering)
});
$c_sci_TreeSet$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(it, $as_s_math_Ordering(evidence$5))
});
$c_sci_TreeSet$.prototype.empty__O__O = (function(evidence$6) {
  var evidence$1 = $as_s_math_Ordering(evidence$6);
  return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$1)
});
var $d_sci_TreeSet$ = new $TypeData().initClass({
  sci_TreeSet$: 0
}, false, "scala.collection.immutable.TreeSet$", {
  sci_TreeSet$: 1,
  O: 1,
  sc_SortedIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_TreeSet$.prototype.$classData = $d_sci_TreeSet$;
var $n_sci_TreeSet$;
function $m_sci_TreeSet$() {
  if ((!$n_sci_TreeSet$)) {
    $n_sci_TreeSet$ = new $c_sci_TreeSet$()
  };
  return $n_sci_TreeSet$
}
/** @constructor */
function $c_sci_WrappedString$() {
  this.sci_WrappedString$__f_empty = null;
  $n_sci_WrappedString$ = this;
  this.sci_WrappedString$__f_empty = new $c_sci_WrappedString("")
}
$c_sci_WrappedString$.prototype = new $h_O();
$c_sci_WrappedString$.prototype.constructor = $c_sci_WrappedString$;
/** @constructor */
function $h_sci_WrappedString$() {
  /*<skip>*/
}
$h_sci_WrappedString$.prototype = $c_sci_WrappedString$.prototype;
$c_sci_WrappedString$.prototype.fromSpecific__sc_IterableOnce__sci_WrappedString = (function(it) {
  var b = this.newBuilder__scm_Builder();
  var s = $n(it).knownSize__I();
  if ((s >= 0)) {
    $n(b).sizeHint__I__V(s)
  };
  var this$1 = $n(b);
  this$1.addAll__sc_IterableOnce__scm_Growable(it);
  return $as_sci_WrappedString($n(b).result__O())
});
$c_sci_WrappedString$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return new $c_sci_WrappedString(x)
  }));
  return new $c_scm_Builder$$anon$1(this$2, f)
});
$c_sci_WrappedString$.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return this.fromSpecific__sc_IterableOnce__sci_WrappedString(it)
});
var $d_sci_WrappedString$ = new $TypeData().initClass({
  sci_WrappedString$: 0
}, false, "scala.collection.immutable.WrappedString$", {
  sci_WrappedString$: 1,
  O: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_WrappedString$.prototype.$classData = $d_sci_WrappedString$;
var $n_sci_WrappedString$;
function $m_sci_WrappedString$() {
  if ((!$n_sci_WrappedString$)) {
    $n_sci_WrappedString$ = new $c_sci_WrappedString$()
  };
  return $n_sci_WrappedString$
}
/** @constructor */
function $c_scm_Builder$$anon$1(outer, f$1) {
  this.scm_Builder$$anon$1__f_$outer = null;
  this.scm_Builder$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.scm_Builder$$anon$1__f_$outer = outer
  };
  this.scm_Builder$$anon$1__f_f$1 = f$1
}
$c_scm_Builder$$anon$1.prototype = new $h_O();
$c_scm_Builder$$anon$1.prototype.constructor = $c_scm_Builder$$anon$1;
/** @constructor */
function $h_scm_Builder$$anon$1() {
  /*<skip>*/
}
$h_scm_Builder$$anon$1.prototype = $c_scm_Builder$$anon$1.prototype;
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Builder$$anon$1 = (function(x) {
  var this$1 = $n(this.scm_Builder$$anon$1__f_$outer);
  this$1.addOne__O__scm_Growable(x);
  return this
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Builder$$anon$1 = (function(xs) {
  var this$1 = $n(this.scm_Builder$$anon$1__f_$outer);
  this$1.addAll__sc_IterableOnce__scm_Growable(xs);
  return this
});
$c_scm_Builder$$anon$1.prototype.sizeHint__I__V = (function(size) {
  $n(this.scm_Builder$$anon$1__f_$outer).sizeHint__I__V(size)
});
$c_scm_Builder$$anon$1.prototype.result__O = (function() {
  return $n(this.scm_Builder$$anon$1__f_f$1).apply__O__O($n(this.scm_Builder$$anon$1__f_$outer).result__O())
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_Builder$$anon$1(xs)
});
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_Builder$$anon$1(elem)
});
var $d_scm_Builder$$anon$1 = new $TypeData().initClass({
  scm_Builder$$anon$1: 0
}, false, "scala.collection.mutable.Builder$$anon$1", {
  scm_Builder$$anon$1: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_Builder$$anon$1.prototype.$classData = $d_scm_Builder$$anon$1;
function $ct_scm_GrowableBuilder__scm_Growable__($thiz, elems) {
  $thiz.scm_GrowableBuilder__f_elems = elems;
  return $thiz
}
/** @constructor */
function $c_scm_GrowableBuilder() {
  this.scm_GrowableBuilder__f_elems = null
}
$c_scm_GrowableBuilder.prototype = new $h_O();
$c_scm_GrowableBuilder.prototype.constructor = $c_scm_GrowableBuilder;
/** @constructor */
function $h_scm_GrowableBuilder() {
  /*<skip>*/
}
$h_scm_GrowableBuilder.prototype = $c_scm_GrowableBuilder.prototype;
$c_scm_GrowableBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_GrowableBuilder = (function(elem) {
  var this$1 = $n(this.scm_GrowableBuilder__f_elems);
  this$1.addOne__O__scm_Growable(elem);
  return this
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_GrowableBuilder = (function(xs) {
  $n(this.scm_GrowableBuilder__f_elems).addAll__sc_IterableOnce__scm_Growable(xs);
  return this
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_GrowableBuilder(xs)
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_GrowableBuilder(elem)
});
$c_scm_GrowableBuilder.prototype.result__O = (function() {
  return this.scm_GrowableBuilder__f_elems
});
var $d_scm_GrowableBuilder = new $TypeData().initClass({
  scm_GrowableBuilder: 0
}, false, "scala.collection.mutable.GrowableBuilder", {
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_GrowableBuilder.prototype.$classData = $d_scm_GrowableBuilder;
/** @constructor */
function $c_scm_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_ArrayBuffer$())
}
$c_scm_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Iterable$.prototype.constructor = $c_scm_Iterable$;
/** @constructor */
function $h_scm_Iterable$() {
  /*<skip>*/
}
$h_scm_Iterable$.prototype = $c_scm_Iterable$.prototype;
var $d_scm_Iterable$ = new $TypeData().initClass({
  scm_Iterable$: 0
}, false, "scala.collection.mutable.Iterable$", {
  scm_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Iterable$.prototype.$classData = $d_scm_Iterable$;
var $n_scm_Iterable$;
function $m_scm_Iterable$() {
  if ((!$n_scm_Iterable$)) {
    $n_scm_Iterable$ = new $c_scm_Iterable$()
  };
  return $n_scm_Iterable$
}
/** @constructor */
function $c_scm_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_scm_HashMap$())
}
$c_scm_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_scm_Map$.prototype.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
  /*<skip>*/
}
$h_scm_Map$.prototype = $c_scm_Map$.prototype;
var $d_scm_Map$ = new $TypeData().initClass({
  scm_Map$: 0
}, false, "scala.collection.mutable.Map$", {
  scm_Map$: 1,
  sc_MapFactory$Delegate: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Map$.prototype.$classData = $d_scm_Map$;
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$()
  };
  return $n_scm_Map$
}
/** @constructor */
function $c_scm_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_HashSet$())
}
$c_scm_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Set$.prototype.constructor = $c_scm_Set$;
/** @constructor */
function $h_scm_Set$() {
  /*<skip>*/
}
$h_scm_Set$.prototype = $c_scm_Set$.prototype;
var $d_scm_Set$ = new $TypeData().initClass({
  scm_Set$: 0
}, false, "scala.collection.mutable.Set$", {
  scm_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Set$.prototype.$classData = $d_scm_Set$;
var $n_scm_Set$;
function $m_scm_Set$() {
  if ((!$n_scm_Set$)) {
    $n_scm_Set$ = new $c_scm_Set$()
  };
  return $n_scm_Set$
}
/** @constructor */
function $c_scm_TreeSet$() {
  /*<skip>*/
}
$c_scm_TreeSet$.prototype = new $h_O();
$c_scm_TreeSet$.prototype.constructor = $c_scm_TreeSet$;
/** @constructor */
function $h_scm_TreeSet$() {
  /*<skip>*/
}
$h_scm_TreeSet$.prototype = $c_scm_TreeSet$.prototype;
$c_scm_TreeSet$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(xs, $as_s_math_Ordering(evidence$7))
});
$c_scm_TreeSet$.prototype.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet = (function(it, ordering) {
  if ((it instanceof $c_scm_TreeSet)) {
    var x2 = $as_scm_TreeSet(it);
    var x$2 = $n(x2).scm_TreeSet__f_ordering;
    if (((ordering === null) ? (x$2 === null) : $n(ordering).equals__O__Z(x$2))) {
      return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), $n($n(x2).scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree).treeCopy__scm_RedBlackTree$Tree(), ordering)
    }
  };
  if ($is_sc_SortedSet(it)) {
    var x3 = $as_sc_SortedSet(it);
    var x$4 = $n(x3).ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : $n(ordering).equals__O__Z(x$4))) {
      return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), $m_scm_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree($n(x3).iterator__sc_Iterator(), $n(x3).size__I()), ordering)
    }
  };
  if ((it instanceof $c_sci_Range)) {
    var x4 = $as_sci_Range(it);
    if ((ordering === $m_s_math_Ordering$Int$())) {
      var $$x1 = true
    } else {
      var this$1 = $m_s_math_Ordering$Int$();
      var $$x1 = (ordering === this$1.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)
    };
    if ($$x1) {
      if (((ordering === $m_s_math_Ordering$Int$()) === ($n(x4).sci_Range__f_step > 0))) {
        var it$2 = $n(x4).iterator__sc_Iterator()
      } else {
        var this$2 = $n(x4);
        var this$3 = new $c_sc_IndexedSeqView$Id(this$2);
        var it$2 = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$3)
      };
      var $$x2 = $m_scm_RedBlackTree$();
      var this$4 = $n(x4);
      return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), $n($$x2).fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree(it$2, this$4.length__I()), ordering)
    }
  };
  var t = new $c_scm_RedBlackTree$Tree(null, 0);
  var i = $n(it).iterator__sc_Iterator();
  while ($n(i).hasNext__Z()) {
    $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(t, $n(i).next__O(), null, ordering)
  };
  return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), t, ordering)
});
$c_scm_TreeSet$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  var ordering = $as_s_math_Ordering(evidence$12);
  return new $c_scm_TreeSet$$anon$1(ordering)
});
$c_scm_TreeSet$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(it, $as_s_math_Ordering(evidence$5))
});
$c_scm_TreeSet$.prototype.empty__O__O = (function(evidence$6) {
  var evidence$1 = $as_s_math_Ordering(evidence$6);
  return $ct_scm_TreeSet__s_math_Ordering__(new $c_scm_TreeSet(), evidence$1)
});
var $d_scm_TreeSet$ = new $TypeData().initClass({
  scm_TreeSet$: 0
}, false, "scala.collection.mutable.TreeSet$", {
  scm_TreeSet$: 1,
  O: 1,
  sc_SortedIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_TreeSet$.prototype.$classData = $d_scm_TreeSet$;
var $n_scm_TreeSet$;
function $m_scm_TreeSet$() {
  if ((!$n_scm_TreeSet$)) {
    $n_scm_TreeSet$ = new $c_scm_TreeSet$()
  };
  return $n_scm_TreeSet$
}
class $c_s_concurrent_Future$$anon$4 extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
  };
}
var $d_s_concurrent_Future$$anon$4 = new $TypeData().initClass({
  s_concurrent_Future$$anon$4: 0
}, false, "scala.concurrent.Future$$anon$4", {
  s_concurrent_Future$$anon$4: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$4.prototype.$classData = $d_s_concurrent_Future$$anon$4;
/** @constructor */
function $c_s_concurrent_duration_Duration() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration.prototype = new $h_O();
$c_s_concurrent_duration_Duration.prototype.constructor = $c_s_concurrent_duration_Duration;
/** @constructor */
function $h_s_concurrent_duration_Duration() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration.prototype = $c_s_concurrent_duration_Duration.prototype;
$c_s_concurrent_duration_Duration.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
function $as_s_concurrent_duration_Duration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration"))
}
function $isArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration)))
}
function $asArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration;", depth))
}
/** @constructor */
function $c_s_math_Equiv$DeprecatedDoubleEquiv$() {
  /*<skip>*/
}
$c_s_math_Equiv$DeprecatedDoubleEquiv$.prototype = new $h_O();
$c_s_math_Equiv$DeprecatedDoubleEquiv$.prototype.constructor = $c_s_math_Equiv$DeprecatedDoubleEquiv$;
/** @constructor */
function $h_s_math_Equiv$DeprecatedDoubleEquiv$() {
  /*<skip>*/
}
$h_s_math_Equiv$DeprecatedDoubleEquiv$.prototype = $c_s_math_Equiv$DeprecatedDoubleEquiv$.prototype;
$c_s_math_Equiv$DeprecatedDoubleEquiv$.prototype.equiv__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Equiv$Double$StrictEquiv__equiv__D__D__Z(this, x$1, y$1)
});
var $d_s_math_Equiv$DeprecatedDoubleEquiv$ = new $TypeData().initClass({
  s_math_Equiv$DeprecatedDoubleEquiv$: 0
}, false, "scala.math.Equiv$DeprecatedDoubleEquiv$", {
  s_math_Equiv$DeprecatedDoubleEquiv$: 1,
  O: 1,
  s_math_Equiv$Double$StrictEquiv: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$DeprecatedDoubleEquiv$.prototype.$classData = $d_s_math_Equiv$DeprecatedDoubleEquiv$;
var $n_s_math_Equiv$DeprecatedDoubleEquiv$;
function $m_s_math_Equiv$DeprecatedDoubleEquiv$() {
  if ((!$n_s_math_Equiv$DeprecatedDoubleEquiv$)) {
    $n_s_math_Equiv$DeprecatedDoubleEquiv$ = new $c_s_math_Equiv$DeprecatedDoubleEquiv$()
  };
  return $n_s_math_Equiv$DeprecatedDoubleEquiv$
}
function $ct_sr_NonLocalReturnControl__O__O__($thiz, key, value) {
  $thiz.sr_NonLocalReturnControl__f_key = key;
  $thiz.sr_NonLocalReturnControl__f_value = value;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, false, false);
  return $thiz
}
class $c_sr_NonLocalReturnControl extends $c_s_util_control_ControlThrowable {
  constructor() {
    super();
    this.sr_NonLocalReturnControl__f_key = null;
    this.sr_NonLocalReturnControl__f_value = null
  };
  value__O() {
    return this.sr_NonLocalReturnControl__f_value
  };
  fillInStackTrace__jl_Throwable() {
    return this
  };
  value$mcZ$sp__Z() {
    return $uZ(this.value__O())
  };
  value$mcI$sp__I() {
    return $uI(this.value__O())
  };
}
function $as_sr_NonLocalReturnControl(obj) {
  return (((obj instanceof $c_sr_NonLocalReturnControl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.NonLocalReturnControl"))
}
function $isArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_NonLocalReturnControl)))
}
function $asArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (($isArrayOf_sr_NonLocalReturnControl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.NonLocalReturnControl;", depth))
}
var $d_sr_NonLocalReturnControl = new $TypeData().initClass({
  sr_NonLocalReturnControl: 0
}, false, "scala.runtime.NonLocalReturnControl", {
  sr_NonLocalReturnControl: 1,
  s_util_control_ControlThrowable: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_NonLocalReturnControl.prototype.$classData = $d_sr_NonLocalReturnControl;
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
  this.sjs_concurrent_QueueExecutionContext$PromisesExecutionContext__f_resolvedUnitPromise = null;
  this.sjs_concurrent_QueueExecutionContext$PromisesExecutionContext__f_resolvedUnitPromise = Promise.resolve((void 0))
}
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = new $h_O();
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.constructor = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
  /*<skip>*/
}
$h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype;
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.execute__jl_Runnable__V = (function(runnable) {
  this.sjs_concurrent_QueueExecutionContext$PromisesExecutionContext__f_resolvedUnitPromise.then(((arg1$2) => {
    var arg1 = $as_jl_Void(arg1$2);
    return this.scala$scalajs$concurrent$QueueExecutionContext$PromisesExecutionContext$$$anonfun$execute$2__jl_Void__jl_Runnable__sjs_js_$bar(arg1, runnable)
  }))
});
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.reportFailure__jl_Throwable__V = (function(t) {
  var this$1 = $n(t);
  this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
});
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.scala$scalajs$concurrent$QueueExecutionContext$PromisesExecutionContext$$$anonfun$execute$2__jl_Void__jl_Runnable__sjs_js_$bar = (function(x$1, runnable$2) {
  try {
    $n(runnable$2).run__V()
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    e$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
  }
});
var $d_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext = new $TypeData().initClass({
  sjs_concurrent_QueueExecutionContext$PromisesExecutionContext: 0
}, false, "scala.scalajs.concurrent.QueueExecutionContext$PromisesExecutionContext", {
  sjs_concurrent_QueueExecutionContext$PromisesExecutionContext: 1,
  O: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1
});
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.$classData = $d_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext;
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
  /*<skip>*/
}
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = new $h_O();
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.constructor = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
  /*<skip>*/
}
$h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype;
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.execute__jl_Runnable__V = (function(runnable) {
  setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
    try {
      $n(runnable).run__V()
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      e$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
    }
  }))), 0)
});
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.reportFailure__jl_Throwable__V = (function(t) {
  var this$1 = $n(t);
  this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
});
var $d_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext = new $TypeData().initClass({
  sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext: 0
}, false, "scala.scalajs.concurrent.QueueExecutionContext$TimeoutsExecutionContext", {
  sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext: 1,
  O: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1
});
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.$classData = $d_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext;
/** @constructor */
function $c_sjs_js_WrappedDictionary$DictionaryIterator(dict) {
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = dict;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = Object.keys(dict);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0
}
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.constructor = $c_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $h_sjs_js_WrappedDictionary$DictionaryIterator() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$DictionaryIterator.prototype = $c_sjs_js_WrappedDictionary$DictionaryIterator.prototype;
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.hasNext__Z = (function() {
  return (this.sjs_js_WrappedDictionary$DictionaryIterator__f_index < $uI(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys.length))
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__T2 = (function() {
  var key = $as_T(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys[this.sjs_js_WrappedDictionary$DictionaryIterator__f_index]);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = ((1 + this.sjs_js_WrappedDictionary$DictionaryIterator__f_index) | 0);
  var dict = this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    var $$x1 = dict[key]
  } else {
    var $$x1;
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  };
  return $ct_T2__O__O__(new $c_T2(), key, $$x1)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sjs_js_WrappedDictionary$DictionaryIterator = new $TypeData().initClass({
  sjs_js_WrappedDictionary$DictionaryIterator: 0
}, false, "scala.scalajs.js.WrappedDictionary$DictionaryIterator", {
  sjs_js_WrappedDictionary$DictionaryIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.$classData = $d_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = null;
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = {}
}
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.constructor = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder;
/** @constructor */
function $h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype;
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder = (function(elem) {
  var dict = this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict;
  var key = $as_T($n(elem)._1__O());
  var value = $n(elem)._2__O();
  dict[key] = value;
  return this
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__sjs_js_WrappedDictionary = (function() {
  return new $c_sjs_js_WrappedDictionary(this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict)
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__O = (function() {
  return this.result__sjs_js_WrappedDictionary()
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder($as_T2(elem))
});
var $d_sjs_js_WrappedDictionary$WrappedDictionaryBuilder = new $TypeData().initClass({
  sjs_js_WrappedDictionary$WrappedDictionaryBuilder: 0
}, false, "scala.scalajs.js.WrappedDictionary$WrappedDictionaryBuilder", {
  sjs_js_WrappedDictionary$WrappedDictionaryBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.$classData = $d_sjs_js_WrappedDictionary$WrappedDictionaryBuilder;
/** @constructor */
function $c_s_util_Either() {
  /*<skip>*/
}
$c_s_util_Either.prototype = new $h_O();
$c_s_util_Either.prototype.constructor = $c_s_util_Either;
/** @constructor */
function $h_s_util_Either() {
  /*<skip>*/
}
$h_s_util_Either.prototype = $c_s_util_Either.prototype;
$c_s_util_Either.prototype.fold__F1__F1__O = (function(fa, fb) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return $n(fb).apply__O__O(b)
  } else if ((this instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(this);
    var a = $n(x3).s_util_Left__f_value;
    return $n(fa).apply__O__O(a)
  } else {
    throw new $c_s_MatchError(this)
  }
});
$c_s_util_Either.prototype.getOrElse__F0__O = (function(or) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return b
  } else {
    return $n(or).apply__O()
  }
});
$c_s_util_Either.prototype.flatMap__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return $as_s_util_Either($n(f).apply__O__O(b))
  } else {
    return this
  }
});
$c_s_util_Either.prototype.map__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return new $c_s_util_Right($n(f).apply__O__O(b))
  } else {
    return this
  }
});
$c_s_util_Either.prototype.toOption__s_Option = (function() {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return new $c_s_Some(b)
  } else {
    return $m_s_None$()
  }
});
$c_s_util_Either.prototype.toTry__s_$less$colon$less__s_util_Try = (function(ev) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return new $c_s_util_Success(b)
  } else if ((this instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(this);
    var a = $n(x3).s_util_Left__f_value;
    return new $c_s_util_Failure($as_jl_Throwable(($n(ev), a)))
  } else {
    throw new $c_s_MatchError(this)
  }
});
function $as_s_util_Either(obj) {
  return (((obj instanceof $c_s_util_Either) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Either"))
}
function $isArrayOf_s_util_Either(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Either)))
}
function $asArrayOf_s_util_Either(obj, depth) {
  return (($isArrayOf_s_util_Either(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Either;", depth))
}
/** @constructor */
function $c_s_util_Either$LeftProjection(e) {
  this.s_util_Either$LeftProjection__f_e = null;
  this.s_util_Either$LeftProjection__f_e = e
}
$c_s_util_Either$LeftProjection.prototype = new $h_O();
$c_s_util_Either$LeftProjection.prototype.constructor = $c_s_util_Either$LeftProjection;
/** @constructor */
function $h_s_util_Either$LeftProjection() {
  /*<skip>*/
}
$h_s_util_Either$LeftProjection.prototype = $c_s_util_Either$LeftProjection.prototype;
$c_s_util_Either$LeftProjection.prototype.toOption__s_Option = (function() {
  var x1 = this.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(x1);
    var a = $n(x2).s_util_Left__f_value;
    return new $c_s_Some(a)
  } else {
    return $m_s_None$()
  }
});
$c_s_util_Either$LeftProjection.prototype.productPrefix__T = (function() {
  return "LeftProjection"
});
$c_s_util_Either$LeftProjection.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Either$LeftProjection.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Either$LeftProjection__f_e : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Either$LeftProjection.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Either$LeftProjection.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Either$LeftProjection.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Either$LeftProjection.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Either$LeftProjection)) {
    var LeftProjection$1 = $as_s_util_Either$LeftProjection(x$1);
    var x = this.s_util_Either$LeftProjection__f_e;
    var x$2 = $n(LeftProjection$1).s_util_Either$LeftProjection__f_e;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_s_util_Either$LeftProjection(obj) {
  return (((obj instanceof $c_s_util_Either$LeftProjection) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Either$LeftProjection"))
}
function $isArrayOf_s_util_Either$LeftProjection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Either$LeftProjection)))
}
function $asArrayOf_s_util_Either$LeftProjection(obj, depth) {
  return (($isArrayOf_s_util_Either$LeftProjection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Either$LeftProjection;", depth))
}
var $d_s_util_Either$LeftProjection = new $TypeData().initClass({
  s_util_Either$LeftProjection: 0
}, false, "scala.util.Either$LeftProjection", {
  s_util_Either$LeftProjection: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Either$LeftProjection.prototype.$classData = $d_s_util_Either$LeftProjection;
/** @constructor */
function $c_s_util_Either$RightProjection(e) {
  this.s_util_Either$RightProjection__f_e = null;
  this.s_util_Either$RightProjection__f_e = e
}
$c_s_util_Either$RightProjection.prototype = new $h_O();
$c_s_util_Either$RightProjection.prototype.constructor = $c_s_util_Either$RightProjection;
/** @constructor */
function $h_s_util_Either$RightProjection() {
  /*<skip>*/
}
$h_s_util_Either$RightProjection.prototype = $c_s_util_Either$RightProjection.prototype;
$c_s_util_Either$RightProjection.prototype.get__O = (function() {
  var x1 = this.s_util_Either$RightProjection__f_e;
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var b = $n(x2).s_util_Right__f_value;
    return b
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Either.right.get on Left")
  }
});
$c_s_util_Either$RightProjection.prototype.toOption__s_Option = (function() {
  var x1 = this.s_util_Either$RightProjection__f_e;
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var b = $n(x2).s_util_Right__f_value;
    return new $c_s_Some(b)
  } else {
    return $m_s_None$()
  }
});
$c_s_util_Either$RightProjection.prototype.productPrefix__T = (function() {
  return "RightProjection"
});
$c_s_util_Either$RightProjection.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Either$RightProjection.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Either$RightProjection__f_e : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Either$RightProjection.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Either$RightProjection.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Either$RightProjection.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Either$RightProjection.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Either$RightProjection)) {
    var RightProjection$1 = $as_s_util_Either$RightProjection(x$1);
    var x = this.s_util_Either$RightProjection__f_e;
    var x$2 = $n(RightProjection$1).s_util_Either$RightProjection__f_e;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_s_util_Either$RightProjection(obj) {
  return (((obj instanceof $c_s_util_Either$RightProjection) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Either$RightProjection"))
}
function $isArrayOf_s_util_Either$RightProjection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Either$RightProjection)))
}
function $asArrayOf_s_util_Either$RightProjection(obj, depth) {
  return (($isArrayOf_s_util_Either$RightProjection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Either$RightProjection;", depth))
}
var $d_s_util_Either$RightProjection = new $TypeData().initClass({
  s_util_Either$RightProjection: 0
}, false, "scala.util.Either$RightProjection", {
  s_util_Either$RightProjection: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Either$RightProjection.prototype.$classData = $d_s_util_Either$RightProjection;
/** @constructor */
function $c_s_util_Try() {
  /*<skip>*/
}
$c_s_util_Try.prototype = new $h_O();
$c_s_util_Try.prototype.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
  /*<skip>*/
}
$h_s_util_Try.prototype = $c_s_util_Try.prototype;
function $as_s_util_Try(obj) {
  return (((obj instanceof $c_s_util_Try) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Try"))
}
function $isArrayOf_s_util_Try(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Try)))
}
function $asArrayOf_s_util_Try(obj, depth) {
  return (($isArrayOf_s_util_Try(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Try;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_AV(attr, value) {
  this.Lscalacss_internal_AV__f_attr = null;
  this.Lscalacss_internal_AV__f_value = null;
  this.Lscalacss_internal_AV__f_attr = attr;
  this.Lscalacss_internal_AV__f_value = value
}
$c_Lscalacss_internal_AV.prototype = new $h_O();
$c_Lscalacss_internal_AV.prototype.constructor = $c_Lscalacss_internal_AV;
/** @constructor */
function $h_Lscalacss_internal_AV() {
  /*<skip>*/
}
$h_Lscalacss_internal_AV.prototype = $c_Lscalacss_internal_AV.prototype;
$c_Lscalacss_internal_AV.prototype.important__Lscalacss_internal_AV = (function() {
  if ($f_T__endsWith__T__Z($n(this.Lscalacss_internal_AV__f_value), $m_Lscalacss_internal_package$().Lscalacss_internal_package$__f__important)) {
    return this
  } else {
    var x$1 = (("" + this.Lscalacss_internal_AV__f_value) + $m_Lscalacss_internal_package$().Lscalacss_internal_package$__f__important);
    var x$2 = this.Lscalacss_internal_AV__f_attr;
    return new $c_Lscalacss_internal_AV(x$2, x$1)
  }
});
$c_Lscalacss_internal_AV.prototype.apply__Lscalacss_internal_Env__sci_Vector = (function(env) {
  return $as_sci_Vector($n($as_F1($n($n(this.Lscalacss_internal_AV__f_attr).Lscalacss_internal_Attr__f_gen).apply__O__O(env))).apply__O__O(this.Lscalacss_internal_AV__f_value))
});
$c_Lscalacss_internal_AV.prototype.productPrefix__T = (function() {
  return "AV"
});
$c_Lscalacss_internal_AV.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_AV.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_AV__f_attr;
      break
    }
    case 1: {
      return this.Lscalacss_internal_AV__f_value;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_AV.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_AV.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_AV.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_AV.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_AV)) {
    var AV$1 = $as_Lscalacss_internal_AV(x$1);
    var x = this.Lscalacss_internal_AV__f_attr;
    var x$2 = $n(AV$1).Lscalacss_internal_AV__f_attr;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lscalacss_internal_AV__f_value === $n(AV$1).Lscalacss_internal_AV__f_value)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_AV(obj) {
  return (((obj instanceof $c_Lscalacss_internal_AV) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.AV"))
}
function $isArrayOf_Lscalacss_internal_AV(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_AV)))
}
function $asArrayOf_Lscalacss_internal_AV(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_AV(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.AV;", depth))
}
var $d_Lscalacss_internal_AV = new $TypeData().initClass({
  Lscalacss_internal_AV: 0
}, false, "scalacss.internal.AV", {
  Lscalacss_internal_AV: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_AV.prototype.$classData = $d_Lscalacss_internal_AV;
/** @constructor */
function $c_Lscalacss_internal_Attrs$backgroundRepeat$() {
  this.Lscalacss_internal_Attrs$backgroundRepeat$__f_attr = null;
  $n_Lscalacss_internal_Attrs$backgroundRepeat$ = this;
  this.Lscalacss_internal_Attrs$backgroundRepeat$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-repeat")
}
$c_Lscalacss_internal_Attrs$backgroundRepeat$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT2();
$c_Lscalacss_internal_Attrs$backgroundRepeat$.prototype.constructor = $c_Lscalacss_internal_Attrs$backgroundRepeat$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$backgroundRepeat$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$backgroundRepeat$.prototype = $c_Lscalacss_internal_Attrs$backgroundRepeat$.prototype;
$c_Lscalacss_internal_Attrs$backgroundRepeat$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$backgroundRepeat$__f_attr
});
var $d_Lscalacss_internal_Attrs$backgroundRepeat$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$backgroundRepeat$: 0
}, false, "scalacss.internal.Attrs$backgroundRepeat$", {
  Lscalacss_internal_Attrs$backgroundRepeat$: 1,
  Lscalacss_internal_ValueT$TypedAttrT2: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$RepeatStyleOps: 1
});
$c_Lscalacss_internal_Attrs$backgroundRepeat$.prototype.$classData = $d_Lscalacss_internal_Attrs$backgroundRepeat$;
var $n_Lscalacss_internal_Attrs$backgroundRepeat$;
function $m_Lscalacss_internal_Attrs$backgroundRepeat$() {
  if ((!$n_Lscalacss_internal_Attrs$backgroundRepeat$)) {
    $n_Lscalacss_internal_Attrs$backgroundRepeat$ = new $c_Lscalacss_internal_Attrs$backgroundRepeat$()
  };
  return $n_Lscalacss_internal_Attrs$backgroundRepeat$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderBottomLeftRadius$() {
  this.Lscalacss_internal_Attrs$borderBottomLeftRadius$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderBottomLeftRadius$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_borderRadius;
  this.Lscalacss_internal_Attrs$borderBottomLeftRadius$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("border-bottom-left-radius", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$borderBottomLeftRadius$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT2();
$c_Lscalacss_internal_Attrs$borderBottomLeftRadius$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderBottomLeftRadius$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderBottomLeftRadius$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderBottomLeftRadius$.prototype = $c_Lscalacss_internal_Attrs$borderBottomLeftRadius$.prototype;
$c_Lscalacss_internal_Attrs$borderBottomLeftRadius$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderBottomLeftRadius$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderBottomLeftRadius$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderBottomLeftRadius$: 0
}, false, "scalacss.internal.Attrs$borderBottomLeftRadius$", {
  Lscalacss_internal_Attrs$borderBottomLeftRadius$: 1,
  Lscalacss_internal_ValueT$TypedAttrT2: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderBottomLeftRadius$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderBottomLeftRadius$;
var $n_Lscalacss_internal_Attrs$borderBottomLeftRadius$;
function $m_Lscalacss_internal_Attrs$borderBottomLeftRadius$() {
  if ((!$n_Lscalacss_internal_Attrs$borderBottomLeftRadius$)) {
    $n_Lscalacss_internal_Attrs$borderBottomLeftRadius$ = new $c_Lscalacss_internal_Attrs$borderBottomLeftRadius$()
  };
  return $n_Lscalacss_internal_Attrs$borderBottomLeftRadius$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderBottomRightRadius$() {
  this.Lscalacss_internal_Attrs$borderBottomRightRadius$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderBottomRightRadius$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_borderRadius;
  this.Lscalacss_internal_Attrs$borderBottomRightRadius$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("border-bottom-right-radius", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$borderBottomRightRadius$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT2();
$c_Lscalacss_internal_Attrs$borderBottomRightRadius$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderBottomRightRadius$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderBottomRightRadius$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderBottomRightRadius$.prototype = $c_Lscalacss_internal_Attrs$borderBottomRightRadius$.prototype;
$c_Lscalacss_internal_Attrs$borderBottomRightRadius$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderBottomRightRadius$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderBottomRightRadius$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderBottomRightRadius$: 0
}, false, "scalacss.internal.Attrs$borderBottomRightRadius$", {
  Lscalacss_internal_Attrs$borderBottomRightRadius$: 1,
  Lscalacss_internal_ValueT$TypedAttrT2: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderBottomRightRadius$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderBottomRightRadius$;
var $n_Lscalacss_internal_Attrs$borderBottomRightRadius$;
function $m_Lscalacss_internal_Attrs$borderBottomRightRadius$() {
  if ((!$n_Lscalacss_internal_Attrs$borderBottomRightRadius$)) {
    $n_Lscalacss_internal_Attrs$borderBottomRightRadius$ = new $c_Lscalacss_internal_Attrs$borderBottomRightRadius$()
  };
  return $n_Lscalacss_internal_Attrs$borderBottomRightRadius$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderBottomStyle$() {
  this.Lscalacss_internal_Attrs$borderBottomStyle$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderBottomStyle$ = this;
  this.Lscalacss_internal_Attrs$borderBottomStyle$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-bottom-style")
}
$c_Lscalacss_internal_Attrs$borderBottomStyle$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle();
$c_Lscalacss_internal_Attrs$borderBottomStyle$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderBottomStyle$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderBottomStyle$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderBottomStyle$.prototype = $c_Lscalacss_internal_Attrs$borderBottomStyle$.prototype;
$c_Lscalacss_internal_Attrs$borderBottomStyle$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderBottomStyle$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderBottomStyle$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderBottomStyle$: 0
}, false, "scalacss.internal.Attrs$borderBottomStyle$", {
  Lscalacss_internal_Attrs$borderBottomStyle$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1
});
$c_Lscalacss_internal_Attrs$borderBottomStyle$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderBottomStyle$;
var $n_Lscalacss_internal_Attrs$borderBottomStyle$;
function $m_Lscalacss_internal_Attrs$borderBottomStyle$() {
  if ((!$n_Lscalacss_internal_Attrs$borderBottomStyle$)) {
    $n_Lscalacss_internal_Attrs$borderBottomStyle$ = new $c_Lscalacss_internal_Attrs$borderBottomStyle$()
  };
  return $n_Lscalacss_internal_Attrs$borderBottomStyle$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderLeftStyle$() {
  this.Lscalacss_internal_Attrs$borderLeftStyle$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderLeftStyle$ = this;
  this.Lscalacss_internal_Attrs$borderLeftStyle$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-left-style")
}
$c_Lscalacss_internal_Attrs$borderLeftStyle$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle();
$c_Lscalacss_internal_Attrs$borderLeftStyle$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderLeftStyle$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderLeftStyle$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderLeftStyle$.prototype = $c_Lscalacss_internal_Attrs$borderLeftStyle$.prototype;
$c_Lscalacss_internal_Attrs$borderLeftStyle$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderLeftStyle$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderLeftStyle$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderLeftStyle$: 0
}, false, "scalacss.internal.Attrs$borderLeftStyle$", {
  Lscalacss_internal_Attrs$borderLeftStyle$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1
});
$c_Lscalacss_internal_Attrs$borderLeftStyle$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderLeftStyle$;
var $n_Lscalacss_internal_Attrs$borderLeftStyle$;
function $m_Lscalacss_internal_Attrs$borderLeftStyle$() {
  if ((!$n_Lscalacss_internal_Attrs$borderLeftStyle$)) {
    $n_Lscalacss_internal_Attrs$borderLeftStyle$ = new $c_Lscalacss_internal_Attrs$borderLeftStyle$()
  };
  return $n_Lscalacss_internal_Attrs$borderLeftStyle$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderRadius$() {
  this.Lscalacss_internal_Attrs$borderRadius$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderRadius$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_borderRadius;
  this.Lscalacss_internal_Attrs$borderRadius$__f_attr = $as_Lscalacss_internal_Attr($n($n($$x1).alias__T__Lscalacss_internal_Transform__F1("border-radius", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))).apply__O__O(new $c_sjsr_AnonFunction1(((x$33$2) => {
    var x$33 = $as_Lscalacss_internal_Attr$AliasB$(x$33$2);
    $n(x$33);
    var t = $m_Lscalacss_internal_Attrs$borderTopLeftRadius$();
    var h = t.Lscalacss_internal_Attrs$borderTopLeftRadius$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$borderTopRightRadius$();
    var $$x3 = t$1.Lscalacss_internal_Attrs$borderTopRightRadius$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$borderBottomRightRadius$();
    var $$x2 = t$2.Lscalacss_internal_Attrs$borderBottomRightRadius$__f_attr;
    var t$3 = $m_Lscalacss_internal_Attrs$borderBottomLeftRadius$();
    var array = [$$x3, $$x2, t$3.Lscalacss_internal_Attrs$borderBottomLeftRadius$__f_attr];
    var t$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$5 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$4);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$5)
  }))))
}
$c_Lscalacss_internal_Attrs$borderRadius$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$borderRadius$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderRadius$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderRadius$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderRadius$.prototype = $c_Lscalacss_internal_Attrs$borderRadius$.prototype;
$c_Lscalacss_internal_Attrs$borderRadius$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderRadius$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderRadius$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderRadius$: 0
}, false, "scalacss.internal.Attrs$borderRadius$", {
  Lscalacss_internal_Attrs$borderRadius$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_Attrs$RorderRadiusOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderRadius$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderRadius$;
var $n_Lscalacss_internal_Attrs$borderRadius$;
function $m_Lscalacss_internal_Attrs$borderRadius$() {
  if ((!$n_Lscalacss_internal_Attrs$borderRadius$)) {
    $n_Lscalacss_internal_Attrs$borderRadius$ = new $c_Lscalacss_internal_Attrs$borderRadius$()
  };
  return $n_Lscalacss_internal_Attrs$borderRadius$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderRightStyle$() {
  this.Lscalacss_internal_Attrs$borderRightStyle$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderRightStyle$ = this;
  this.Lscalacss_internal_Attrs$borderRightStyle$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-right-style")
}
$c_Lscalacss_internal_Attrs$borderRightStyle$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle();
$c_Lscalacss_internal_Attrs$borderRightStyle$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderRightStyle$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderRightStyle$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderRightStyle$.prototype = $c_Lscalacss_internal_Attrs$borderRightStyle$.prototype;
$c_Lscalacss_internal_Attrs$borderRightStyle$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderRightStyle$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderRightStyle$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderRightStyle$: 0
}, false, "scalacss.internal.Attrs$borderRightStyle$", {
  Lscalacss_internal_Attrs$borderRightStyle$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1
});
$c_Lscalacss_internal_Attrs$borderRightStyle$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderRightStyle$;
var $n_Lscalacss_internal_Attrs$borderRightStyle$;
function $m_Lscalacss_internal_Attrs$borderRightStyle$() {
  if ((!$n_Lscalacss_internal_Attrs$borderRightStyle$)) {
    $n_Lscalacss_internal_Attrs$borderRightStyle$ = new $c_Lscalacss_internal_Attrs$borderRightStyle$()
  };
  return $n_Lscalacss_internal_Attrs$borderRightStyle$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderStyle$() {
  this.Lscalacss_internal_ValueT$TypedAttrT4Edges__f_sep = null;
  this.Lscalacss_internal_Attrs$borderStyle$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttrT4Edges__T__(this, " ");
  $n_Lscalacss_internal_Attrs$borderStyle$ = this;
  this.Lscalacss_internal_Attrs$borderStyle$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("border-style")).apply__O__O(new $c_sjsr_AnonFunction1(((x$35$2) => {
    var x$35 = $as_Lscalacss_internal_Attr$AliasB$(x$35$2);
    $n(x$35);
    var t = $m_Lscalacss_internal_Attrs$borderTopStyle$();
    var h = t.Lscalacss_internal_Attrs$borderTopStyle$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$borderRightStyle$();
    var $$x2 = t$1.Lscalacss_internal_Attrs$borderRightStyle$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$borderBottomStyle$();
    var $$x1 = t$2.Lscalacss_internal_Attrs$borderBottomStyle$__f_attr;
    var t$3 = $m_Lscalacss_internal_Attrs$borderLeftStyle$();
    var array = [$$x2, $$x1, t$3.Lscalacss_internal_Attrs$borderLeftStyle$__f_attr];
    var t$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$5 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$4);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$5)
  }))))
}
$c_Lscalacss_internal_Attrs$borderStyle$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT4Edges();
$c_Lscalacss_internal_Attrs$borderStyle$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderStyle$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderStyle$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderStyle$.prototype = $c_Lscalacss_internal_Attrs$borderStyle$.prototype;
$c_Lscalacss_internal_Attrs$borderStyle$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderStyle$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderStyle$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderStyle$: 0
}, false, "scalacss.internal.Attrs$borderStyle$", {
  Lscalacss_internal_Attrs$borderStyle$: 1,
  Lscalacss_internal_ValueT$TypedAttrT4Edges: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1
});
$c_Lscalacss_internal_Attrs$borderStyle$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderStyle$;
var $n_Lscalacss_internal_Attrs$borderStyle$;
function $m_Lscalacss_internal_Attrs$borderStyle$() {
  if ((!$n_Lscalacss_internal_Attrs$borderStyle$)) {
    $n_Lscalacss_internal_Attrs$borderStyle$ = new $c_Lscalacss_internal_Attrs$borderStyle$()
  };
  return $n_Lscalacss_internal_Attrs$borderStyle$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderTopLeftRadius$() {
  this.Lscalacss_internal_Attrs$borderTopLeftRadius$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderTopLeftRadius$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_borderRadius;
  this.Lscalacss_internal_Attrs$borderTopLeftRadius$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("border-top-left-radius", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$borderTopLeftRadius$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT2();
$c_Lscalacss_internal_Attrs$borderTopLeftRadius$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderTopLeftRadius$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderTopLeftRadius$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderTopLeftRadius$.prototype = $c_Lscalacss_internal_Attrs$borderTopLeftRadius$.prototype;
$c_Lscalacss_internal_Attrs$borderTopLeftRadius$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderTopLeftRadius$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderTopLeftRadius$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderTopLeftRadius$: 0
}, false, "scalacss.internal.Attrs$borderTopLeftRadius$", {
  Lscalacss_internal_Attrs$borderTopLeftRadius$: 1,
  Lscalacss_internal_ValueT$TypedAttrT2: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderTopLeftRadius$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderTopLeftRadius$;
var $n_Lscalacss_internal_Attrs$borderTopLeftRadius$;
function $m_Lscalacss_internal_Attrs$borderTopLeftRadius$() {
  if ((!$n_Lscalacss_internal_Attrs$borderTopLeftRadius$)) {
    $n_Lscalacss_internal_Attrs$borderTopLeftRadius$ = new $c_Lscalacss_internal_Attrs$borderTopLeftRadius$()
  };
  return $n_Lscalacss_internal_Attrs$borderTopLeftRadius$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderTopRightRadius$() {
  this.Lscalacss_internal_Attrs$borderTopRightRadius$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderTopRightRadius$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_borderRadius;
  this.Lscalacss_internal_Attrs$borderTopRightRadius$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("border-top-right-radius", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$borderTopRightRadius$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT2();
$c_Lscalacss_internal_Attrs$borderTopRightRadius$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderTopRightRadius$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderTopRightRadius$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderTopRightRadius$.prototype = $c_Lscalacss_internal_Attrs$borderTopRightRadius$.prototype;
$c_Lscalacss_internal_Attrs$borderTopRightRadius$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderTopRightRadius$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderTopRightRadius$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderTopRightRadius$: 0
}, false, "scalacss.internal.Attrs$borderTopRightRadius$", {
  Lscalacss_internal_Attrs$borderTopRightRadius$: 1,
  Lscalacss_internal_ValueT$TypedAttrT2: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderTopRightRadius$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderTopRightRadius$;
var $n_Lscalacss_internal_Attrs$borderTopRightRadius$;
function $m_Lscalacss_internal_Attrs$borderTopRightRadius$() {
  if ((!$n_Lscalacss_internal_Attrs$borderTopRightRadius$)) {
    $n_Lscalacss_internal_Attrs$borderTopRightRadius$ = new $c_Lscalacss_internal_Attrs$borderTopRightRadius$()
  };
  return $n_Lscalacss_internal_Attrs$borderTopRightRadius$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderTopStyle$() {
  this.Lscalacss_internal_Attrs$borderTopStyle$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderTopStyle$ = this;
  this.Lscalacss_internal_Attrs$borderTopStyle$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-top-style")
}
$c_Lscalacss_internal_Attrs$borderTopStyle$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle();
$c_Lscalacss_internal_Attrs$borderTopStyle$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderTopStyle$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderTopStyle$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderTopStyle$.prototype = $c_Lscalacss_internal_Attrs$borderTopStyle$.prototype;
$c_Lscalacss_internal_Attrs$borderTopStyle$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderTopStyle$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderTopStyle$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderTopStyle$: 0
}, false, "scalacss.internal.Attrs$borderTopStyle$", {
  Lscalacss_internal_Attrs$borderTopStyle$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1
});
$c_Lscalacss_internal_Attrs$borderTopStyle$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderTopStyle$;
var $n_Lscalacss_internal_Attrs$borderTopStyle$;
function $m_Lscalacss_internal_Attrs$borderTopStyle$() {
  if ((!$n_Lscalacss_internal_Attrs$borderTopStyle$)) {
    $n_Lscalacss_internal_Attrs$borderTopStyle$ = new $c_Lscalacss_internal_Attrs$borderTopStyle$()
  };
  return $n_Lscalacss_internal_Attrs$borderTopStyle$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$columnWidth$() {
  this.Lscalacss_internal_Attrs$columnWidth$__f_attr = null;
  $n_Lscalacss_internal_Attrs$columnWidth$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_multicolumn;
  this.Lscalacss_internal_Attrs$columnWidth$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("column-width", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$columnWidth$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$columnWidth$.prototype.constructor = $c_Lscalacss_internal_Attrs$columnWidth$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$columnWidth$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$columnWidth$.prototype = $c_Lscalacss_internal_Attrs$columnWidth$.prototype;
$c_Lscalacss_internal_Attrs$columnWidth$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$columnWidth$__f_attr
});
var $d_Lscalacss_internal_Attrs$columnWidth$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$columnWidth$: 0
}, false, "scalacss.internal.Attrs$columnWidth$", {
  Lscalacss_internal_Attrs$columnWidth$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$columnWidth$.prototype.$classData = $d_Lscalacss_internal_Attrs$columnWidth$;
var $n_Lscalacss_internal_Attrs$columnWidth$;
function $m_Lscalacss_internal_Attrs$columnWidth$() {
  if ((!$n_Lscalacss_internal_Attrs$columnWidth$)) {
    $n_Lscalacss_internal_Attrs$columnWidth$ = new $c_Lscalacss_internal_Attrs$columnWidth$()
  };
  return $n_Lscalacss_internal_Attrs$columnWidth$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$fontSize$() {
  this.Lscalacss_internal_Attrs$fontSize$__f_attr = null;
  $n_Lscalacss_internal_Attrs$fontSize$ = this;
  this.Lscalacss_internal_Attrs$fontSize$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("font-size")
}
$c_Lscalacss_internal_Attrs$fontSize$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$fontSize$.prototype.constructor = $c_Lscalacss_internal_Attrs$fontSize$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$fontSize$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$fontSize$.prototype = $c_Lscalacss_internal_Attrs$fontSize$.prototype;
$c_Lscalacss_internal_Attrs$fontSize$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$fontSize$__f_attr
});
var $d_Lscalacss_internal_Attrs$fontSize$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$fontSize$: 0
}, false, "scalacss.internal.Attrs$fontSize$", {
  Lscalacss_internal_Attrs$fontSize$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$fontSize$.prototype.$classData = $d_Lscalacss_internal_Attrs$fontSize$;
var $n_Lscalacss_internal_Attrs$fontSize$;
function $m_Lscalacss_internal_Attrs$fontSize$() {
  if ((!$n_Lscalacss_internal_Attrs$fontSize$)) {
    $n_Lscalacss_internal_Attrs$fontSize$ = new $c_Lscalacss_internal_Attrs$fontSize$()
  };
  return $n_Lscalacss_internal_Attrs$fontSize$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$gap$() {
  this.Lscalacss_internal_Attrs$gap$__f_attr = null;
  $n_Lscalacss_internal_Attrs$gap$ = this;
  this.Lscalacss_internal_Attrs$gap$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("gap")).apply__O__O(new $c_sjsr_AnonFunction1(((x$44$2) => {
    var x$44 = $as_Lscalacss_internal_Attr$AliasB$(x$44$2);
    $n(x$44);
    var t = $m_Lscalacss_internal_Attrs$columnGap$();
    var h = t.Lscalacss_internal_Attrs$columnGap$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$rowGap$();
    var array = [t$1.Lscalacss_internal_Attrs$rowGap$__f_attr];
    var t$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$3 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$2);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$3)
  }))))
}
$c_Lscalacss_internal_Attrs$gap$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrBase();
$c_Lscalacss_internal_Attrs$gap$.prototype.constructor = $c_Lscalacss_internal_Attrs$gap$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$gap$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$gap$.prototype = $c_Lscalacss_internal_Attrs$gap$.prototype;
$c_Lscalacss_internal_Attrs$gap$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$gap$__f_attr
});
var $d_Lscalacss_internal_Attrs$gap$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$gap$: 0
}, false, "scalacss.internal.Attrs$gap$", {
  Lscalacss_internal_Attrs$gap$: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$GapStyleOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$gap$.prototype.$classData = $d_Lscalacss_internal_Attrs$gap$;
var $n_Lscalacss_internal_Attrs$gap$;
function $m_Lscalacss_internal_Attrs$gap$() {
  if ((!$n_Lscalacss_internal_Attrs$gap$)) {
    $n_Lscalacss_internal_Attrs$gap$ = new $c_Lscalacss_internal_Attrs$gap$()
  };
  return $n_Lscalacss_internal_Attrs$gap$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$lineHeight$() {
  this.Lscalacss_internal_Attrs$lineHeight$__f_attr = null;
  $n_Lscalacss_internal_Attrs$lineHeight$ = this;
  this.Lscalacss_internal_Attrs$lineHeight$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("line-height")
}
$c_Lscalacss_internal_Attrs$lineHeight$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$lineHeight$.prototype.constructor = $c_Lscalacss_internal_Attrs$lineHeight$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$lineHeight$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$lineHeight$.prototype = $c_Lscalacss_internal_Attrs$lineHeight$.prototype;
$c_Lscalacss_internal_Attrs$lineHeight$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$lineHeight$__f_attr
});
var $d_Lscalacss_internal_Attrs$lineHeight$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$lineHeight$: 0
}, false, "scalacss.internal.Attrs$lineHeight$", {
  Lscalacss_internal_Attrs$lineHeight$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$lineHeight$.prototype.$classData = $d_Lscalacss_internal_Attrs$lineHeight$;
var $n_Lscalacss_internal_Attrs$lineHeight$;
function $m_Lscalacss_internal_Attrs$lineHeight$() {
  if ((!$n_Lscalacss_internal_Attrs$lineHeight$)) {
    $n_Lscalacss_internal_Attrs$lineHeight$ = new $c_Lscalacss_internal_Attrs$lineHeight$()
  };
  return $n_Lscalacss_internal_Attrs$lineHeight$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$margin$() {
  this.Lscalacss_internal_ValueT$TypedAttrT4Edges__f_sep = null;
  this.Lscalacss_internal_Attrs$margin$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttrT4Edges__T__(this, " ");
  $n_Lscalacss_internal_Attrs$margin$ = this;
  this.Lscalacss_internal_Attrs$margin$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("margin")).apply__O__O(new $c_sjsr_AnonFunction1(((x$53$2) => {
    var x$53 = $as_Lscalacss_internal_Attr$AliasB$(x$53$2);
    $n(x$53);
    var t = $m_Lscalacss_internal_Attrs$marginTop$();
    var h = t.Lscalacss_internal_Attrs$marginTop$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$marginRight$();
    var $$x2 = t$1.Lscalacss_internal_Attrs$marginRight$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$marginBottom$();
    var $$x1 = t$2.Lscalacss_internal_Attrs$marginBottom$__f_attr;
    var t$3 = $m_Lscalacss_internal_Attrs$marginLeft$();
    var array = [$$x2, $$x1, t$3.Lscalacss_internal_Attrs$marginLeft$__f_attr];
    var t$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$5 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$4);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$5)
  }))))
}
$c_Lscalacss_internal_Attrs$margin$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT4Edges();
$c_Lscalacss_internal_Attrs$margin$.prototype.constructor = $c_Lscalacss_internal_Attrs$margin$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$margin$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$margin$.prototype = $c_Lscalacss_internal_Attrs$margin$.prototype;
$c_Lscalacss_internal_Attrs$margin$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$margin$__f_attr
});
var $d_Lscalacss_internal_Attrs$margin$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$margin$: 0
}, false, "scalacss.internal.Attrs$margin$", {
  Lscalacss_internal_Attrs$margin$: 1,
  Lscalacss_internal_ValueT$TypedAttrT4Edges: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$margin$.prototype.$classData = $d_Lscalacss_internal_Attrs$margin$;
var $n_Lscalacss_internal_Attrs$margin$;
function $m_Lscalacss_internal_Attrs$margin$() {
  if ((!$n_Lscalacss_internal_Attrs$margin$)) {
    $n_Lscalacss_internal_Attrs$margin$ = new $c_Lscalacss_internal_Attrs$margin$()
  };
  return $n_Lscalacss_internal_Attrs$margin$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$outlineStyle$() {
  this.Lscalacss_internal_Attrs$outlineStyle$__f_attr = null;
  $n_Lscalacss_internal_Attrs$outlineStyle$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_outline;
  this.Lscalacss_internal_Attrs$outlineStyle$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("outline-style", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$outlineStyle$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle();
$c_Lscalacss_internal_Attrs$outlineStyle$.prototype.constructor = $c_Lscalacss_internal_Attrs$outlineStyle$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$outlineStyle$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$outlineStyle$.prototype = $c_Lscalacss_internal_Attrs$outlineStyle$.prototype;
$c_Lscalacss_internal_Attrs$outlineStyle$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$outlineStyle$__f_attr
});
var $d_Lscalacss_internal_Attrs$outlineStyle$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$outlineStyle$: 0
}, false, "scalacss.internal.Attrs$outlineStyle$", {
  Lscalacss_internal_Attrs$outlineStyle$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrStyle: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1
});
$c_Lscalacss_internal_Attrs$outlineStyle$.prototype.$classData = $d_Lscalacss_internal_Attrs$outlineStyle$;
var $n_Lscalacss_internal_Attrs$outlineStyle$;
function $m_Lscalacss_internal_Attrs$outlineStyle$() {
  if ((!$n_Lscalacss_internal_Attrs$outlineStyle$)) {
    $n_Lscalacss_internal_Attrs$outlineStyle$ = new $c_Lscalacss_internal_Attrs$outlineStyle$()
  };
  return $n_Lscalacss_internal_Attrs$outlineStyle$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$padding$() {
  this.Lscalacss_internal_ValueT$TypedAttrT4Edges__f_sep = null;
  this.Lscalacss_internal_Attrs$padding$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttrT4Edges__T__(this, " ");
  $n_Lscalacss_internal_Attrs$padding$ = this;
  this.Lscalacss_internal_Attrs$padding$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("padding")).apply__O__O(new $c_sjsr_AnonFunction1(((x$71$2) => {
    var x$71 = $as_Lscalacss_internal_Attr$AliasB$(x$71$2);
    $n(x$71);
    var t = $m_Lscalacss_internal_Attrs$paddingLeft$();
    var h = t.Lscalacss_internal_Attrs$paddingLeft$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$paddingRight$();
    var $$x2 = t$1.Lscalacss_internal_Attrs$paddingRight$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$paddingTop$();
    var $$x1 = t$2.Lscalacss_internal_Attrs$paddingTop$__f_attr;
    var t$3 = $m_Lscalacss_internal_Attrs$paddingBottom$();
    var array = [$$x2, $$x1, t$3.Lscalacss_internal_Attrs$paddingBottom$__f_attr];
    var t$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$5 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$4);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$5)
  }))))
}
$c_Lscalacss_internal_Attrs$padding$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT4Edges();
$c_Lscalacss_internal_Attrs$padding$.prototype.constructor = $c_Lscalacss_internal_Attrs$padding$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$padding$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$padding$.prototype = $c_Lscalacss_internal_Attrs$padding$.prototype;
$c_Lscalacss_internal_Attrs$padding$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$padding$__f_attr
});
var $d_Lscalacss_internal_Attrs$padding$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$padding$: 0
}, false, "scalacss.internal.Attrs$padding$", {
  Lscalacss_internal_Attrs$padding$: 1,
  Lscalacss_internal_ValueT$TypedAttrT4Edges: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$padding$.prototype.$classData = $d_Lscalacss_internal_Attrs$padding$;
var $n_Lscalacss_internal_Attrs$padding$;
function $m_Lscalacss_internal_Attrs$padding$() {
  if ((!$n_Lscalacss_internal_Attrs$padding$)) {
    $n_Lscalacss_internal_Attrs$padding$ = new $c_Lscalacss_internal_Attrs$padding$()
  };
  return $n_Lscalacss_internal_Attrs$padding$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$paddingBottom$() {
  this.Lscalacss_internal_Attrs$paddingBottom$__f_attr = null;
  $n_Lscalacss_internal_Attrs$paddingBottom$ = this;
  this.Lscalacss_internal_Attrs$paddingBottom$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("padding-bottom")
}
$c_Lscalacss_internal_Attrs$paddingBottom$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$paddingBottom$.prototype.constructor = $c_Lscalacss_internal_Attrs$paddingBottom$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$paddingBottom$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$paddingBottom$.prototype = $c_Lscalacss_internal_Attrs$paddingBottom$.prototype;
$c_Lscalacss_internal_Attrs$paddingBottom$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$paddingBottom$__f_attr
});
var $d_Lscalacss_internal_Attrs$paddingBottom$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$paddingBottom$: 0
}, false, "scalacss.internal.Attrs$paddingBottom$", {
  Lscalacss_internal_Attrs$paddingBottom$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$paddingBottom$.prototype.$classData = $d_Lscalacss_internal_Attrs$paddingBottom$;
var $n_Lscalacss_internal_Attrs$paddingBottom$;
function $m_Lscalacss_internal_Attrs$paddingBottom$() {
  if ((!$n_Lscalacss_internal_Attrs$paddingBottom$)) {
    $n_Lscalacss_internal_Attrs$paddingBottom$ = new $c_Lscalacss_internal_Attrs$paddingBottom$()
  };
  return $n_Lscalacss_internal_Attrs$paddingBottom$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$paddingLeft$() {
  this.Lscalacss_internal_Attrs$paddingLeft$__f_attr = null;
  $n_Lscalacss_internal_Attrs$paddingLeft$ = this;
  this.Lscalacss_internal_Attrs$paddingLeft$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("padding-left")
}
$c_Lscalacss_internal_Attrs$paddingLeft$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$paddingLeft$.prototype.constructor = $c_Lscalacss_internal_Attrs$paddingLeft$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$paddingLeft$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$paddingLeft$.prototype = $c_Lscalacss_internal_Attrs$paddingLeft$.prototype;
$c_Lscalacss_internal_Attrs$paddingLeft$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$paddingLeft$__f_attr
});
var $d_Lscalacss_internal_Attrs$paddingLeft$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$paddingLeft$: 0
}, false, "scalacss.internal.Attrs$paddingLeft$", {
  Lscalacss_internal_Attrs$paddingLeft$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$paddingLeft$.prototype.$classData = $d_Lscalacss_internal_Attrs$paddingLeft$;
var $n_Lscalacss_internal_Attrs$paddingLeft$;
function $m_Lscalacss_internal_Attrs$paddingLeft$() {
  if ((!$n_Lscalacss_internal_Attrs$paddingLeft$)) {
    $n_Lscalacss_internal_Attrs$paddingLeft$ = new $c_Lscalacss_internal_Attrs$paddingLeft$()
  };
  return $n_Lscalacss_internal_Attrs$paddingLeft$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$paddingRight$() {
  this.Lscalacss_internal_Attrs$paddingRight$__f_attr = null;
  $n_Lscalacss_internal_Attrs$paddingRight$ = this;
  this.Lscalacss_internal_Attrs$paddingRight$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("padding-right")
}
$c_Lscalacss_internal_Attrs$paddingRight$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$paddingRight$.prototype.constructor = $c_Lscalacss_internal_Attrs$paddingRight$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$paddingRight$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$paddingRight$.prototype = $c_Lscalacss_internal_Attrs$paddingRight$.prototype;
$c_Lscalacss_internal_Attrs$paddingRight$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$paddingRight$__f_attr
});
var $d_Lscalacss_internal_Attrs$paddingRight$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$paddingRight$: 0
}, false, "scalacss.internal.Attrs$paddingRight$", {
  Lscalacss_internal_Attrs$paddingRight$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$paddingRight$.prototype.$classData = $d_Lscalacss_internal_Attrs$paddingRight$;
var $n_Lscalacss_internal_Attrs$paddingRight$;
function $m_Lscalacss_internal_Attrs$paddingRight$() {
  if ((!$n_Lscalacss_internal_Attrs$paddingRight$)) {
    $n_Lscalacss_internal_Attrs$paddingRight$ = new $c_Lscalacss_internal_Attrs$paddingRight$()
  };
  return $n_Lscalacss_internal_Attrs$paddingRight$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$paddingTop$() {
  this.Lscalacss_internal_Attrs$paddingTop$__f_attr = null;
  $n_Lscalacss_internal_Attrs$paddingTop$ = this;
  this.Lscalacss_internal_Attrs$paddingTop$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("padding-top")
}
$c_Lscalacss_internal_Attrs$paddingTop$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$paddingTop$.prototype.constructor = $c_Lscalacss_internal_Attrs$paddingTop$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$paddingTop$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$paddingTop$.prototype = $c_Lscalacss_internal_Attrs$paddingTop$.prototype;
$c_Lscalacss_internal_Attrs$paddingTop$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$paddingTop$__f_attr
});
var $d_Lscalacss_internal_Attrs$paddingTop$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$paddingTop$: 0
}, false, "scalacss.internal.Attrs$paddingTop$", {
  Lscalacss_internal_Attrs$paddingTop$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$paddingTop$.prototype.$classData = $d_Lscalacss_internal_Attrs$paddingTop$;
var $n_Lscalacss_internal_Attrs$paddingTop$;
function $m_Lscalacss_internal_Attrs$paddingTop$() {
  if ((!$n_Lscalacss_internal_Attrs$paddingTop$)) {
    $n_Lscalacss_internal_Attrs$paddingTop$ = new $c_Lscalacss_internal_Attrs$paddingTop$()
  };
  return $n_Lscalacss_internal_Attrs$paddingTop$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$verticalAlign$() {
  this.Lscalacss_internal_Attrs$verticalAlign$__f_attr = null;
  $n_Lscalacss_internal_Attrs$verticalAlign$ = this;
  this.Lscalacss_internal_Attrs$verticalAlign$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("vertical-align")
}
$c_Lscalacss_internal_Attrs$verticalAlign$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$verticalAlign$.prototype.constructor = $c_Lscalacss_internal_Attrs$verticalAlign$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$verticalAlign$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$verticalAlign$.prototype = $c_Lscalacss_internal_Attrs$verticalAlign$.prototype;
$c_Lscalacss_internal_Attrs$verticalAlign$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$verticalAlign$__f_attr
});
var $d_Lscalacss_internal_Attrs$verticalAlign$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$verticalAlign$: 0
}, false, "scalacss.internal.Attrs$verticalAlign$", {
  Lscalacss_internal_Attrs$verticalAlign$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$verticalAlign$.prototype.$classData = $d_Lscalacss_internal_Attrs$verticalAlign$;
var $n_Lscalacss_internal_Attrs$verticalAlign$;
function $m_Lscalacss_internal_Attrs$verticalAlign$() {
  if ((!$n_Lscalacss_internal_Attrs$verticalAlign$)) {
    $n_Lscalacss_internal_Attrs$verticalAlign$ = new $c_Lscalacss_internal_Attrs$verticalAlign$()
  };
  return $n_Lscalacss_internal_Attrs$verticalAlign$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Agent(prefix, prefixExceptions) {
  this.Lscalacss_internal_CanIUse$Agent__f_prefix = null;
  this.Lscalacss_internal_CanIUse$Agent__f_prefixExceptions = null;
  this.Lscalacss_internal_CanIUse$Agent__f_prefix = prefix;
  this.Lscalacss_internal_CanIUse$Agent__f_prefixExceptions = prefixExceptions
}
$c_Lscalacss_internal_CanIUse$Agent.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Agent.prototype.constructor = $c_Lscalacss_internal_CanIUse$Agent;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Agent() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Agent.prototype = $c_Lscalacss_internal_CanIUse$Agent.prototype;
$c_Lscalacss_internal_CanIUse$Agent.prototype.productPrefix__T = (function() {
  return "Agent"
});
$c_Lscalacss_internal_CanIUse$Agent.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_CanIUse$Agent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_CanIUse$Agent__f_prefix;
      break
    }
    case 1: {
      return this.Lscalacss_internal_CanIUse$Agent__f_prefixExceptions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_CanIUse$Agent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Agent.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_CanIUse$Agent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_CanIUse$Agent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_CanIUse$Agent)) {
    var Agent$1 = $as_Lscalacss_internal_CanIUse$Agent(x$1);
    var x = this.Lscalacss_internal_CanIUse$Agent__f_prefix;
    var x$2 = $n(Agent$1).Lscalacss_internal_CanIUse$Agent__f_prefix;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lscalacss_internal_CanIUse$Agent__f_prefixExceptions;
      var x$4 = $n(Agent$1).Lscalacss_internal_CanIUse$Agent__f_prefixExceptions;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_CanIUse$Agent(obj) {
  return (((obj instanceof $c_Lscalacss_internal_CanIUse$Agent) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.CanIUse$Agent"))
}
function $isArrayOf_Lscalacss_internal_CanIUse$Agent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_CanIUse$Agent)))
}
function $asArrayOf_Lscalacss_internal_CanIUse$Agent(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_CanIUse$Agent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.CanIUse$Agent;", depth))
}
var $d_Lscalacss_internal_CanIUse$Agent = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Agent: 0
}, false, "scalacss.internal.CanIUse$Agent", {
  Lscalacss_internal_CanIUse$Agent: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Agent.prototype.$classData = $d_Lscalacss_internal_CanIUse$Agent;
/** @constructor */
function $c_Lscalacss_internal_ClassName(value) {
  this.Lscalacss_internal_ClassName__f_value = null;
  this.Lscalacss_internal_ClassName__f_value = value
}
$c_Lscalacss_internal_ClassName.prototype = new $h_O();
$c_Lscalacss_internal_ClassName.prototype.constructor = $c_Lscalacss_internal_ClassName;
/** @constructor */
function $h_Lscalacss_internal_ClassName() {
  /*<skip>*/
}
$h_Lscalacss_internal_ClassName.prototype = $c_Lscalacss_internal_ClassName.prototype;
$c_Lscalacss_internal_ClassName.prototype.productPrefix__T = (function() {
  return "ClassName"
});
$c_Lscalacss_internal_ClassName.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_ClassName.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_ClassName__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_ClassName.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_ClassName.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_ClassName.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_ClassName.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_ClassName)) {
    var ClassName$1 = $as_Lscalacss_internal_ClassName(x$1);
    return (this.Lscalacss_internal_ClassName__f_value === $n(ClassName$1).Lscalacss_internal_ClassName__f_value)
  } else {
    return false
  }
});
function $as_Lscalacss_internal_ClassName(obj) {
  return (((obj instanceof $c_Lscalacss_internal_ClassName) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.ClassName"))
}
function $isArrayOf_Lscalacss_internal_ClassName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_ClassName)))
}
function $asArrayOf_Lscalacss_internal_ClassName(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_ClassName(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.ClassName;", depth))
}
var $d_Lscalacss_internal_ClassName = new $TypeData().initClass({
  Lscalacss_internal_ClassName: 0
}, false, "scalacss.internal.ClassName", {
  Lscalacss_internal_ClassName: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_ClassName.prototype.$classData = $d_Lscalacss_internal_ClassName;
/** @constructor */
function $c_Lscalacss_internal_ClassNameHint(value) {
  this.Lscalacss_internal_ClassNameHint__f_value = null;
  this.Lscalacss_internal_ClassNameHint__f_value = value
}
$c_Lscalacss_internal_ClassNameHint.prototype = new $h_O();
$c_Lscalacss_internal_ClassNameHint.prototype.constructor = $c_Lscalacss_internal_ClassNameHint;
/** @constructor */
function $h_Lscalacss_internal_ClassNameHint() {
  /*<skip>*/
}
$h_Lscalacss_internal_ClassNameHint.prototype = $c_Lscalacss_internal_ClassNameHint.prototype;
$c_Lscalacss_internal_ClassNameHint.prototype.productPrefix__T = (function() {
  return "ClassNameHint"
});
$c_Lscalacss_internal_ClassNameHint.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_ClassNameHint.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_ClassNameHint__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_ClassNameHint.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_ClassNameHint.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_ClassNameHint.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_ClassNameHint.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_ClassNameHint)) {
    var ClassNameHint$1 = $as_Lscalacss_internal_ClassNameHint(x$1);
    return (this.Lscalacss_internal_ClassNameHint__f_value === $n(ClassNameHint$1).Lscalacss_internal_ClassNameHint__f_value)
  } else {
    return false
  }
});
function $as_Lscalacss_internal_ClassNameHint(obj) {
  return (((obj instanceof $c_Lscalacss_internal_ClassNameHint) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.ClassNameHint"))
}
function $isArrayOf_Lscalacss_internal_ClassNameHint(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_ClassNameHint)))
}
function $asArrayOf_Lscalacss_internal_ClassNameHint(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_ClassNameHint(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.ClassNameHint;", depth))
}
var $d_Lscalacss_internal_ClassNameHint = new $TypeData().initClass({
  Lscalacss_internal_ClassNameHint: 0
}, false, "scalacss.internal.ClassNameHint", {
  Lscalacss_internal_ClassNameHint: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_ClassNameHint.prototype.$classData = $d_Lscalacss_internal_ClassNameHint;
function $p_Lscalacss_internal_Compose__absorbWarning$1__Lscalacss_internal_Cond__T2__sr_ObjectRef__O($thiz, c, t, warnings$1) {
  $n($as_sci_Vector($n(t)._2__O())).foreach__F1__V(new $c_sjsr_AnonFunction1(((w$2) => {
    var w = $as_T(w$2);
    var $$x1 = $n(warnings$1);
    var this$2 = $n($as_sci_Vector($n(warnings$1).sr_ObjectRef__f_elem));
    var elem = new $c_Lscalacss_internal_package$Warning(c, w);
    $$x1.sr_ObjectRef__f_elem = $as_sci_Vector(this$2.appended__O__O(elem))
  })));
  return $n(t)._1__O()
}
function $p_Lscalacss_internal_Compose__mergeAVs$1__Lscalacss_internal_Cond__Lscalacss_internal_AVs__Lscalacss_internal_AVs__sr_ObjectRef__Lscalacss_internal_AVs($thiz, c, newAVs, into, warnings$1) {
  var elem = $n(newAVs).Lscalacss_internal_AVs__f_data;
  var newData = new $c_sr_ObjectRef(elem);
  var this$12 = $n($n($as_sci_Map(newData.sr_ObjectRef__f_elem)).withFilter__F1__sc_MapOps$WithFilter(new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
    var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
    return (check$ifrefutable$1 !== null)
  }))));
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_T2(x$1$2);
    if ((x$1 !== null)) {
      var a = $as_Lscalacss_internal_Attr($n(x$1)._1__O());
      var nvs = $as_Lscalacss_internal_NonEmptyVector($n(x$1)._2__O());
      var this$3 = $n(into);
      var this$4 = $n($n(this$3.Lscalacss_internal_AVs__f_data).get__O__s_Option(a));
      if ((!this$4.isEmpty__Z())) {
        var arg1 = this$4.get__O();
        var ovs = $as_Lscalacss_internal_NonEmptyVector(arg1);
        var this$5 = $n(ovs);
        var this$6 = $n(this$5.whole__sci_Vector());
        var o = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$6);
        var this$7 = $n($n(nvs).whole__sci_Vector());
        var pred = new $c_sjsr_AnonFunction1(((elem$2) => {
          var elem$1 = $as_T(elem$2);
          return $n(o).contains__O__Z(elem$1)
        }));
        var newVals = this$7.filterImpl__F1__Z__sci_Vector(pred, true);
        var this$9 = $n(newVals);
        if ($f_sc_SeqOps__isEmpty__Z(this$9)) {
          var this$10 = $n($as_sci_Map(newData.sr_ObjectRef__f_elem));
          newData.sr_ObjectRef__f_elem = $as_sci_Map(this$10.removed__O__sci_MapOps(a))
        } else {
          var h = $n(newVals).head__O();
          var t = $n(newVals).tail__sci_Vector();
          var arg1$1 = new $c_Lscalacss_internal_NonEmptyVector(h, t);
          newData.sr_ObjectRef__f_elem = $as_sci_Map($n($as_sci_Map(newData.sr_ObjectRef__f_elem)).updated__O__O__sci_MapOps(a, arg1$1))
        }
      }
    } else {
      throw new $c_s_MatchError(x$1)
    }
  }));
  $n(this$12.filtered__sc_Iterable()).foreach__F1__V(f);
  var this$18 = $n($as_sci_Map(newData.sr_ObjectRef__f_elem));
  var f$2 = ((x0$1$2, x1$1$2) => {
    var x0$1 = $as_Lscalacss_internal_AVs(x0$1$2);
    var x1$1 = $as_T2(x1$1$2);
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
    var results = $as_Lscalacss_internal_AVs(x1.T2__f__1);
    var p2 = $as_T2(x1.T2__f__2);
    if ((p2 !== null)) {
      var a$1 = $as_Lscalacss_internal_Attr($n(p2)._1__O());
      var nvs$1 = $as_Lscalacss_internal_NonEmptyVector($n(p2)._2__O());
      var x1$2 = $n(results).filterKeys__F1__s_Option(new $c_sjsr_AnonFunction1(((k$2) => {
        var k = $as_Lscalacss_internal_Attr(k$2);
        var this$13 = $n(a$1);
        return $n($as_Lscalacss_internal_AttrCmp($n($m_Lscalacss_internal_AttrCmp$().Lscalacss_internal_AttrCmp$__f_default).apply__O__O__O(this$13, k))).conflict__Z()
      })));
      var x = $m_s_None$();
      if ((x === x1$2)) {
        return $n(results).addAll__Lscalacss_internal_Attr__Lscalacss_internal_NonEmptyVector__Lscalacss_internal_AVs(a$1, nvs$1)
      } else if ((x1$2 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(x1$2);
        var conflicts = $as_Lscalacss_internal_AVs($n(x3).s_Some__f_value);
        var r = $as_Lscalacss_internal_AVs($p_Lscalacss_internal_Compose__absorbWarning$1__Lscalacss_internal_Cond__T2__sr_ObjectRef__O($thiz, c, $n($thiz.Lscalacss_internal_Compose__f_rules).mergeAVs__Lscalacss_internal_AVs__Lscalacss_internal_AVs__T2(conflicts, $m_Lscalacss_internal_AVs$().apply__Lscalacss_internal_Attr__Lscalacss_internal_NonEmptyVector__Lscalacss_internal_AVs(a$1, nvs$1)), warnings$1));
        var this$14 = $n($n($n(conflicts).Lscalacss_internal_AVs__f_data).keySet__sci_Set());
        var that = $n($n(r).Lscalacss_internal_AVs__f_order).whole__sci_Vector();
        var delete$1 = $as_sci_Set(this$14.removedAll__sc_IterableOnce__sci_SetOps(that));
        var x1$3 = $n(results).filterKeys__F1__s_Option(new $c_sjsr_AnonFunction1(((x$2$2$2) => {
          var x$2$2 = $as_Lscalacss_internal_Attr(x$2$2$2);
          return (!$n(delete$1).contains__O__Z(x$2$2))
        })));
        var x$3 = $m_s_None$();
        if ((x$3 === x1$3)) {
          return r
        } else if ((x1$3 instanceof $c_s_Some)) {
          var x3$2 = $as_s_Some(x1$3);
          var o$1 = $as_Lscalacss_internal_AVs($n(x3$2).s_Some__f_value);
          var this$17 = $n($n(r).Lscalacss_internal_AVs__f_data);
          var f$1 = ((o$2$2, b$2) => {
            var o$2 = $as_Lscalacss_internal_AVs(o$2$2);
            var b = $as_T2(b$2);
            var this$15 = $n(o$2);
            var a$2 = $as_Lscalacss_internal_Attr($n(b)._1__O());
            var existing = this$15.getv__Lscalacss_internal_Attr__sci_Vector(a$2);
            var this$16 = $n(existing);
            if ($f_sc_SeqOps__isEmpty__Z(this$16)) {
              var newOrder = $n(this$15.Lscalacss_internal_AVs__f_order).$colon$plus__O__Lscalacss_internal_NonEmptyVector(a$2)
            } else {
              var newOrder = this$15.Lscalacss_internal_AVs__f_order
            };
            var newData$1 = $as_sci_Map($n(this$15.Lscalacss_internal_AVs__f_data).updated__O__O__sci_MapOps(a$2, $as_Lscalacss_internal_NonEmptyVector($n(b)._2__O())));
            return new $c_Lscalacss_internal_AVs(newOrder, newData$1)
          });
          if ($is_sc_IndexedSeq(this$17)) {
            var x2 = $as_sc_IndexedSeq(this$17);
            var at = 0;
            var end = $n(x2).length__I();
            var acc = o$1;
            var $$x1;
            while (true) {
              if ((at !== end)) {
                var temp$at = ((1 + at) | 0);
                var arg1$2 = acc;
                var arg2 = $n(x2).apply__I__O(at);
                var temp$acc = f$1(arg1$2, arg2);
                at = temp$at;
                acc = temp$acc;
                continue
              };
              var $$x1 = acc;
              break
            }
          } else {
            var result = o$1;
            var it = this$17.iterator__sc_Iterator();
            while ($n(it).hasNext__Z()) {
              var arg1$3 = result;
              var arg2$1 = $n(it).next__O();
              result = f$1(arg1$3, arg2$1)
            };
            var $$x1 = result
          };
          return $as_Lscalacss_internal_AVs($$x1)
        } else {
          throw new $c_s_MatchError(x1$3)
        }
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    };
    throw new $c_s_MatchError(x1)
  });
  if ($is_sc_IndexedSeq(this$18)) {
    var x2$1 = $as_sc_IndexedSeq(this$18);
    var at$1 = 0;
    var end$1 = $n(x2$1).length__I();
    var acc$1 = into;
    var $$x2;
    while (true) {
      if ((at$1 !== end$1)) {
        var temp$at$1 = ((1 + at$1) | 0);
        var arg1$4 = acc$1;
        var arg2$2 = $n(x2$1).apply__I__O(at$1);
        var temp$acc$1 = f$2(arg1$4, arg2$2);
        at$1 = temp$at$1;
        acc$1 = temp$acc$1;
        continue
      };
      var $$x2 = acc$1;
      break
    }
  } else {
    var result$1 = into;
    var it$1 = this$18.iterator__sc_Iterator();
    while ($n(it$1).hasNext__Z()) {
      var arg1$5 = result$1;
      var arg2$3 = $n(it$1).next__O();
      result$1 = f$2(arg1$5, arg2$3)
    };
    var $$x2 = result$1
  };
  return $as_Lscalacss_internal_AVs($$x2)
}
/** @constructor */
function $c_Lscalacss_internal_Compose(rules) {
  this.Lscalacss_internal_Compose__f_rules = null;
  this.Lscalacss_internal_Compose__f_rules = rules
}
$c_Lscalacss_internal_Compose.prototype = new $h_O();
$c_Lscalacss_internal_Compose.prototype.constructor = $c_Lscalacss_internal_Compose;
/** @constructor */
function $h_Lscalacss_internal_Compose() {
  /*<skip>*/
}
$h_Lscalacss_internal_Compose.prototype = $c_Lscalacss_internal_Compose.prototype;
$c_Lscalacss_internal_Compose.prototype.apply__Lscalacss_internal_StyleS__Lscalacss_internal_StyleS__Lscalacss_internal_StyleS = (function(a, b) {
  var this$1 = $n($n(a).Lscalacss_internal_StyleS__f_warnings);
  var suffix = $n(b).Lscalacss_internal_StyleS__f_warnings;
  var elem = this$1.appendedAll__sc_IterableOnce__sci_Vector(suffix);
  var warnings = new $c_sr_ObjectRef(elem);
  var this$5 = $n($n(b).Lscalacss_internal_StyleS__f_data);
  var z = $n(a).Lscalacss_internal_StyleS__f_data;
  var f = ((x0$1$2, x1$1$2) => {
    var x0$1 = $as_sci_SortedMap(x0$1$2);
    var x1$1 = $as_T2(x1$1$2);
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
    var data = $as_sci_SortedMap(x1.T2__f__1);
    var p2 = $as_T2(x1.T2__f__2);
    if ((p2 !== null)) {
      var cond = $as_Lscalacss_internal_Cond($n(p2)._1__O());
      var newAVs = $as_Lscalacss_internal_AVs($n(p2)._2__O());
      var this$4 = $n($n(data).get__O__s_Option(cond));
      if (this$4.isEmpty__Z()) {
        var $$x1 = newAVs
      } else {
        var arg1 = this$4.get__O();
        var oldAVs = $as_Lscalacss_internal_AVs(arg1);
        var $$x1 = $p_Lscalacss_internal_Compose__mergeAVs$1__Lscalacss_internal_Cond__Lscalacss_internal_AVs__Lscalacss_internal_AVs__sr_ObjectRef__Lscalacss_internal_AVs(this, cond, newAVs, oldAVs, warnings)
      };
      return $as_sci_SortedMap($n(data).updated__O__O__sci_Map(cond, $$x1))
    };
    throw new $c_s_MatchError(x1)
  });
  if ($is_sc_IndexedSeq(this$5)) {
    var x2 = $as_sc_IndexedSeq(this$5);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = z;
    var $$x2;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1$1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f(arg1$1, arg2);
        at = temp$at;
        acc = temp$acc;
        continue
      };
      var $$x2 = acc;
      break
    }
  } else {
    var result = z;
    var it = this$5.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1$2 = result;
      var arg2$1 = $n(it).next__O();
      result = f(arg1$2, arg2$1)
    };
    var $$x2 = result
  };
  var newData = $as_sci_SortedMap($$x2);
  var this$6 = $n($n(a).Lscalacss_internal_StyleS__f_unsafeExts);
  var suffix$1 = $n(b).Lscalacss_internal_StyleS__f_unsafeExts;
  var exts = this$6.appendedAll__sc_IterableOnce__sci_Vector(suffix$1);
  var this$7 = $n($n(a).Lscalacss_internal_StyleS__f_addClassNames);
  var suffix$2 = $n(b).Lscalacss_internal_StyleS__f_addClassNames;
  var cns = this$7.appendedAll__sc_IterableOnce__sci_Vector(suffix$2);
  return new $c_Lscalacss_internal_StyleS(newData, exts, $m_s_None$(), cns, $as_sci_Vector(warnings.sr_ObjectRef__f_elem))
});
$c_Lscalacss_internal_Compose.prototype.productPrefix__T = (function() {
  return "Compose"
});
$c_Lscalacss_internal_Compose.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_Compose.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_Compose__f_rules : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_Compose.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Compose.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Compose.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Compose.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Compose)) {
    var Compose$1 = $as_Lscalacss_internal_Compose(x$1);
    var x = this.Lscalacss_internal_Compose__f_rules;
    var x$2 = $n(Compose$1).Lscalacss_internal_Compose__f_rules;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Compose(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Compose) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Compose"))
}
function $isArrayOf_Lscalacss_internal_Compose(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Compose)))
}
function $asArrayOf_Lscalacss_internal_Compose(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Compose(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Compose;", depth))
}
var $d_Lscalacss_internal_Compose = new $TypeData().initClass({
  Lscalacss_internal_Compose: 0
}, false, "scalacss.internal.Compose", {
  Lscalacss_internal_Compose: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Compose.prototype.$classData = $d_Lscalacss_internal_Compose;
/** @constructor */
function $c_Lscalacss_internal_CssKV(key, value) {
  this.Lscalacss_internal_CssKV__f_key = null;
  this.Lscalacss_internal_CssKV__f_value = null;
  this.Lscalacss_internal_CssKV__f_key = key;
  this.Lscalacss_internal_CssKV__f_value = value
}
$c_Lscalacss_internal_CssKV.prototype = new $h_O();
$c_Lscalacss_internal_CssKV.prototype.constructor = $c_Lscalacss_internal_CssKV;
/** @constructor */
function $h_Lscalacss_internal_CssKV() {
  /*<skip>*/
}
$h_Lscalacss_internal_CssKV.prototype = $c_Lscalacss_internal_CssKV.prototype;
$c_Lscalacss_internal_CssKV.prototype.productPrefix__T = (function() {
  return "CssKV"
});
$c_Lscalacss_internal_CssKV.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_CssKV.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_CssKV__f_key;
      break
    }
    case 1: {
      return this.Lscalacss_internal_CssKV__f_value;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_CssKV.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CssKV.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_CssKV.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_CssKV.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_CssKV)) {
    var CssKV$1 = $as_Lscalacss_internal_CssKV(x$1);
    return ((this.Lscalacss_internal_CssKV__f_key === $n(CssKV$1).Lscalacss_internal_CssKV__f_key) && (this.Lscalacss_internal_CssKV__f_value === $n(CssKV$1).Lscalacss_internal_CssKV__f_value))
  } else {
    return false
  }
});
function $as_Lscalacss_internal_CssKV(obj) {
  return (((obj instanceof $c_Lscalacss_internal_CssKV) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.CssKV"))
}
function $isArrayOf_Lscalacss_internal_CssKV(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_CssKV)))
}
function $asArrayOf_Lscalacss_internal_CssKV(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_CssKV(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.CssKV;", depth))
}
var $d_Lscalacss_internal_CssKV = new $TypeData().initClass({
  Lscalacss_internal_CssKV: 0
}, false, "scalacss.internal.CssKV", {
  Lscalacss_internal_CssKV: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CssKV.prototype.$classData = $d_Lscalacss_internal_CssKV;
/** @constructor */
function $c_Lscalacss_internal_Env(platform, media) {
  this.Lscalacss_internal_Env__f_platform = null;
  this.Lscalacss_internal_Env__f_media = null;
  this.Lscalacss_internal_Env__f_prefixWhitelist = null;
  this.Lscalacss_internal_Env__f_platform = platform;
  this.Lscalacss_internal_Env__f_media = media;
  this.Lscalacss_internal_Env__f_prefixWhitelist = $m_Lscalacss_internal_CanIUse2$().prefixesForPlatform__Lscalacss_internal_Env$Platform__sci_SortedSet(platform)
}
$c_Lscalacss_internal_Env.prototype = new $h_O();
$c_Lscalacss_internal_Env.prototype.constructor = $c_Lscalacss_internal_Env;
/** @constructor */
function $h_Lscalacss_internal_Env() {
  /*<skip>*/
}
$h_Lscalacss_internal_Env.prototype = $c_Lscalacss_internal_Env.prototype;
$c_Lscalacss_internal_Env.prototype.productPrefix__T = (function() {
  return "Env"
});
$c_Lscalacss_internal_Env.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_Env.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_Env__f_platform;
      break
    }
    case 1: {
      return this.Lscalacss_internal_Env__f_media;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_Env.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Env.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Env.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Env.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Env)) {
    var Env$1 = $as_Lscalacss_internal_Env(x$1);
    var x = this.Lscalacss_internal_Env__f_platform;
    var x$2 = $n(Env$1).Lscalacss_internal_Env__f_platform;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalacss_internal_Env__f_media;
      var x$4 = $n(Env$1).Lscalacss_internal_Env__f_media;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Env(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Env) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Env"))
}
function $isArrayOf_Lscalacss_internal_Env(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Env)))
}
function $asArrayOf_Lscalacss_internal_Env(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Env(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Env;", depth))
}
var $d_Lscalacss_internal_Env = new $TypeData().initClass({
  Lscalacss_internal_Env: 0
}, false, "scalacss.internal.Env", {
  Lscalacss_internal_Env: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Env.prototype.$classData = $d_Lscalacss_internal_Env;
/** @constructor */
function $c_Lscalacss_internal_Env$Media(width, height, aspectRatio, deviceWidth, deviceHeight, deviceAspectRatio, monochrome, color, colorIndex, orientation, resolution, scan, grid) {
  this.Lscalacss_internal_Env$Media__f_width = null;
  this.Lscalacss_internal_Env$Media__f_height = null;
  this.Lscalacss_internal_Env$Media__f_aspectRatio = null;
  this.Lscalacss_internal_Env$Media__f_deviceWidth = null;
  this.Lscalacss_internal_Env$Media__f_deviceHeight = null;
  this.Lscalacss_internal_Env$Media__f_deviceAspectRatio = null;
  this.Lscalacss_internal_Env$Media__f_monochrome = null;
  this.Lscalacss_internal_Env$Media__f_color = null;
  this.Lscalacss_internal_Env$Media__f_colorIndex = null;
  this.Lscalacss_internal_Env$Media__f_orientation = null;
  this.Lscalacss_internal_Env$Media__f_resolution = null;
  this.Lscalacss_internal_Env$Media__f_scan = null;
  this.Lscalacss_internal_Env$Media__f_grid = null;
  this.Lscalacss_internal_Env$Media__f_width = width;
  this.Lscalacss_internal_Env$Media__f_height = height;
  this.Lscalacss_internal_Env$Media__f_aspectRatio = aspectRatio;
  this.Lscalacss_internal_Env$Media__f_deviceWidth = deviceWidth;
  this.Lscalacss_internal_Env$Media__f_deviceHeight = deviceHeight;
  this.Lscalacss_internal_Env$Media__f_deviceAspectRatio = deviceAspectRatio;
  this.Lscalacss_internal_Env$Media__f_monochrome = monochrome;
  this.Lscalacss_internal_Env$Media__f_color = color;
  this.Lscalacss_internal_Env$Media__f_colorIndex = colorIndex;
  this.Lscalacss_internal_Env$Media__f_orientation = orientation;
  this.Lscalacss_internal_Env$Media__f_resolution = resolution;
  this.Lscalacss_internal_Env$Media__f_scan = scan;
  this.Lscalacss_internal_Env$Media__f_grid = grid
}
$c_Lscalacss_internal_Env$Media.prototype = new $h_O();
$c_Lscalacss_internal_Env$Media.prototype.constructor = $c_Lscalacss_internal_Env$Media;
/** @constructor */
function $h_Lscalacss_internal_Env$Media() {
  /*<skip>*/
}
$h_Lscalacss_internal_Env$Media.prototype = $c_Lscalacss_internal_Env$Media.prototype;
$c_Lscalacss_internal_Env$Media.prototype.productPrefix__T = (function() {
  return "Media"
});
$c_Lscalacss_internal_Env$Media.prototype.productArity__I = (function() {
  return 13
});
$c_Lscalacss_internal_Env$Media.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_Env$Media__f_width;
      break
    }
    case 1: {
      return this.Lscalacss_internal_Env$Media__f_height;
      break
    }
    case 2: {
      return this.Lscalacss_internal_Env$Media__f_aspectRatio;
      break
    }
    case 3: {
      return this.Lscalacss_internal_Env$Media__f_deviceWidth;
      break
    }
    case 4: {
      return this.Lscalacss_internal_Env$Media__f_deviceHeight;
      break
    }
    case 5: {
      return this.Lscalacss_internal_Env$Media__f_deviceAspectRatio;
      break
    }
    case 6: {
      return this.Lscalacss_internal_Env$Media__f_monochrome;
      break
    }
    case 7: {
      return this.Lscalacss_internal_Env$Media__f_color;
      break
    }
    case 8: {
      return this.Lscalacss_internal_Env$Media__f_colorIndex;
      break
    }
    case 9: {
      return this.Lscalacss_internal_Env$Media__f_orientation;
      break
    }
    case 10: {
      return this.Lscalacss_internal_Env$Media__f_resolution;
      break
    }
    case 11: {
      return this.Lscalacss_internal_Env$Media__f_scan;
      break
    }
    case 12: {
      return this.Lscalacss_internal_Env$Media__f_grid;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_Env$Media.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Env$Media.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Env$Media.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Env$Media.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Env$Media)) {
    var Media$1 = $as_Lscalacss_internal_Env$Media(x$1);
    var x = this.Lscalacss_internal_Env$Media__f_width;
    var y = $n(Media$1).Lscalacss_internal_Env$Media__f_width;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lscalacss_internal_Env$Media__f_height;
      var y$1 = $n(Media$1).Lscalacss_internal_Env$Media__f_height;
      var $$x11 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      var $$x11 = false
    };
    if ($$x11) {
      var x$3 = this.Lscalacss_internal_Env$Media__f_aspectRatio;
      var y$2 = $n(Media$1).Lscalacss_internal_Env$Media__f_aspectRatio;
      var $$x10 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y$2)
    } else {
      var $$x10 = false
    };
    if ($$x10) {
      var x$4 = this.Lscalacss_internal_Env$Media__f_deviceWidth;
      var y$3 = $n(Media$1).Lscalacss_internal_Env$Media__f_deviceWidth;
      var $$x9 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$4, y$3)
    } else {
      var $$x9 = false
    };
    if ($$x9) {
      var x$5 = this.Lscalacss_internal_Env$Media__f_deviceHeight;
      var y$4 = $n(Media$1).Lscalacss_internal_Env$Media__f_deviceHeight;
      var $$x8 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$5, y$4)
    } else {
      var $$x8 = false
    };
    if ($$x8) {
      var x$6 = this.Lscalacss_internal_Env$Media__f_deviceAspectRatio;
      var y$5 = $n(Media$1).Lscalacss_internal_Env$Media__f_deviceAspectRatio;
      var $$x7 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$6, y$5)
    } else {
      var $$x7 = false
    };
    if ($$x7) {
      var x$7 = this.Lscalacss_internal_Env$Media__f_monochrome;
      var y$6 = $n(Media$1).Lscalacss_internal_Env$Media__f_monochrome;
      var $$x6 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$7, y$6)
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$8 = this.Lscalacss_internal_Env$Media__f_color;
      var y$7 = $n(Media$1).Lscalacss_internal_Env$Media__f_color;
      var $$x5 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$8, y$7)
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$9 = this.Lscalacss_internal_Env$Media__f_colorIndex;
      var y$8 = $n(Media$1).Lscalacss_internal_Env$Media__f_colorIndex;
      var $$x4 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$9, y$8)
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$10 = this.Lscalacss_internal_Env$Media__f_orientation;
      var y$9 = $n(Media$1).Lscalacss_internal_Env$Media__f_orientation;
      var $$x3 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$10, y$9)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$11 = this.Lscalacss_internal_Env$Media__f_resolution;
      var y$10 = $n(Media$1).Lscalacss_internal_Env$Media__f_resolution;
      var $$x2 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$11, y$10)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$12 = this.Lscalacss_internal_Env$Media__f_scan;
      var y$11 = $n(Media$1).Lscalacss_internal_Env$Media__f_scan;
      var $$x1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$12, y$11)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$13 = this.Lscalacss_internal_Env$Media__f_grid;
      var y$12 = $n(Media$1).Lscalacss_internal_Env$Media__f_grid;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$13, y$12)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Env$Media(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Env$Media) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Env$Media"))
}
function $isArrayOf_Lscalacss_internal_Env$Media(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Env$Media)))
}
function $asArrayOf_Lscalacss_internal_Env$Media(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Env$Media(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Env$Media;", depth))
}
var $d_Lscalacss_internal_Env$Media = new $TypeData().initClass({
  Lscalacss_internal_Env$Media: 0
}, false, "scalacss.internal.Env$Media", {
  Lscalacss_internal_Env$Media: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Env$Media.prototype.$classData = $d_Lscalacss_internal_Env$Media;
/** @constructor */
function $c_Lscalacss_internal_Env$Platform(name, layout, version, desc, manufacturer, product, userAgent, os) {
  this.Lscalacss_internal_Env$Platform__f_name = null;
  this.Lscalacss_internal_Env$Platform__f_layout = null;
  this.Lscalacss_internal_Env$Platform__f_version = null;
  this.Lscalacss_internal_Env$Platform__f_desc = null;
  this.Lscalacss_internal_Env$Platform__f_manufacturer = null;
  this.Lscalacss_internal_Env$Platform__f_product = null;
  this.Lscalacss_internal_Env$Platform__f_userAgent = null;
  this.Lscalacss_internal_Env$Platform__f_os = null;
  this.Lscalacss_internal_Env$Platform__f_name = name;
  this.Lscalacss_internal_Env$Platform__f_layout = layout;
  this.Lscalacss_internal_Env$Platform__f_version = version;
  this.Lscalacss_internal_Env$Platform__f_desc = desc;
  this.Lscalacss_internal_Env$Platform__f_manufacturer = manufacturer;
  this.Lscalacss_internal_Env$Platform__f_product = product;
  this.Lscalacss_internal_Env$Platform__f_userAgent = userAgent;
  this.Lscalacss_internal_Env$Platform__f_os = os
}
$c_Lscalacss_internal_Env$Platform.prototype = new $h_O();
$c_Lscalacss_internal_Env$Platform.prototype.constructor = $c_Lscalacss_internal_Env$Platform;
/** @constructor */
function $h_Lscalacss_internal_Env$Platform() {
  /*<skip>*/
}
$h_Lscalacss_internal_Env$Platform.prototype = $c_Lscalacss_internal_Env$Platform.prototype;
$c_Lscalacss_internal_Env$Platform.prototype.productPrefix__T = (function() {
  return "Platform"
});
$c_Lscalacss_internal_Env$Platform.prototype.productArity__I = (function() {
  return 8
});
$c_Lscalacss_internal_Env$Platform.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_Env$Platform__f_name;
      break
    }
    case 1: {
      return this.Lscalacss_internal_Env$Platform__f_layout;
      break
    }
    case 2: {
      return this.Lscalacss_internal_Env$Platform__f_version;
      break
    }
    case 3: {
      return this.Lscalacss_internal_Env$Platform__f_desc;
      break
    }
    case 4: {
      return this.Lscalacss_internal_Env$Platform__f_manufacturer;
      break
    }
    case 5: {
      return this.Lscalacss_internal_Env$Platform__f_product;
      break
    }
    case 6: {
      return this.Lscalacss_internal_Env$Platform__f_userAgent;
      break
    }
    case 7: {
      return this.Lscalacss_internal_Env$Platform__f_os;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_Env$Platform.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Env$Platform.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Env$Platform.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Env$Platform.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Env$Platform)) {
    var Platform$1 = $as_Lscalacss_internal_Env$Platform(x$1);
    var x = this.Lscalacss_internal_Env$Platform__f_name;
    var y = $n(Platform$1).Lscalacss_internal_Env$Platform__f_name;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lscalacss_internal_Env$Platform__f_layout;
      var y$1 = $n(Platform$1).Lscalacss_internal_Env$Platform__f_layout;
      var $$x6 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$3 = this.Lscalacss_internal_Env$Platform__f_version;
      var y$2 = $n(Platform$1).Lscalacss_internal_Env$Platform__f_version;
      var $$x5 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y$2)
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$4 = this.Lscalacss_internal_Env$Platform__f_desc;
      var y$3 = $n(Platform$1).Lscalacss_internal_Env$Platform__f_desc;
      var $$x4 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$4, y$3)
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$5 = this.Lscalacss_internal_Env$Platform__f_manufacturer;
      var y$4 = $n(Platform$1).Lscalacss_internal_Env$Platform__f_manufacturer;
      var $$x3 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$5, y$4)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$6 = this.Lscalacss_internal_Env$Platform__f_product;
      var y$5 = $n(Platform$1).Lscalacss_internal_Env$Platform__f_product;
      var $$x2 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$6, y$5)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Lscalacss_internal_Env$Platform__f_userAgent;
      var y$6 = $n(Platform$1).Lscalacss_internal_Env$Platform__f_userAgent;
      var $$x1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$7, y$6)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$8 = this.Lscalacss_internal_Env$Platform__f_os;
      var y$7 = $n(Platform$1).Lscalacss_internal_Env$Platform__f_os;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$8, y$7)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Env$Platform(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Env$Platform) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Env$Platform"))
}
function $isArrayOf_Lscalacss_internal_Env$Platform(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Env$Platform)))
}
function $asArrayOf_Lscalacss_internal_Env$Platform(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Env$Platform(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Env$Platform;", depth))
}
var $d_Lscalacss_internal_Env$Platform = new $TypeData().initClass({
  Lscalacss_internal_Env$Platform: 0
}, false, "scalacss.internal.Env$Platform", {
  Lscalacss_internal_Env$Platform: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Env$Platform.prototype.$classData = $d_Lscalacss_internal_Env$Platform;
function $as_Lscalacss_internal_FontFace(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.FontFace"))
}
function $isArrayOf_Lscalacss_internal_FontFace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_FontFace)))
}
function $asArrayOf_Lscalacss_internal_FontFace(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_FontFace(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.FontFace;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_Keyframes(name, frames) {
  this.Lscalacss_internal_Keyframes__f_name = null;
  this.Lscalacss_internal_Keyframes__f_frames = null;
  this.Lscalacss_internal_Keyframes__f_name = name;
  this.Lscalacss_internal_Keyframes__f_frames = frames
}
$c_Lscalacss_internal_Keyframes.prototype = new $h_O();
$c_Lscalacss_internal_Keyframes.prototype.constructor = $c_Lscalacss_internal_Keyframes;
/** @constructor */
function $h_Lscalacss_internal_Keyframes() {
  /*<skip>*/
}
$h_Lscalacss_internal_Keyframes.prototype = $c_Lscalacss_internal_Keyframes.prototype;
$c_Lscalacss_internal_Keyframes.prototype.productPrefix__T = (function() {
  return "Keyframes"
});
$c_Lscalacss_internal_Keyframes.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_Keyframes.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_Keyframes__f_name;
      break
    }
    case 1: {
      return this.Lscalacss_internal_Keyframes__f_frames;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_Keyframes.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Keyframes.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Keyframes.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Keyframes.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Keyframes)) {
    var Keyframes$1 = $as_Lscalacss_internal_Keyframes(x$1);
    var x = this.Lscalacss_internal_Keyframes__f_name;
    var x$2 = $n(Keyframes$1).Lscalacss_internal_Keyframes__f_name;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalacss_internal_Keyframes__f_frames;
      var x$4 = $n(Keyframes$1).Lscalacss_internal_Keyframes__f_frames;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Keyframes(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Keyframes) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Keyframes"))
}
function $isArrayOf_Lscalacss_internal_Keyframes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Keyframes)))
}
function $asArrayOf_Lscalacss_internal_Keyframes(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Keyframes(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Keyframes;", depth))
}
var $d_Lscalacss_internal_Keyframes = new $TypeData().initClass({
  Lscalacss_internal_Keyframes: 0
}, false, "scalacss.internal.Keyframes", {
  Lscalacss_internal_Keyframes: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Keyframes.prototype.$classData = $d_Lscalacss_internal_Keyframes;
/** @constructor */
function $c_Lscalacss_internal_Length(n, u) {
  this.Lscalacss_internal_Length__f_n = null;
  this.Lscalacss_internal_Length__f_u = null;
  this.Lscalacss_internal_Length__f_n = n;
  this.Lscalacss_internal_Length__f_u = u
}
$c_Lscalacss_internal_Length.prototype = new $h_O();
$c_Lscalacss_internal_Length.prototype.constructor = $c_Lscalacss_internal_Length;
/** @constructor */
function $h_Lscalacss_internal_Length() {
  /*<skip>*/
}
$h_Lscalacss_internal_Length.prototype = $c_Lscalacss_internal_Length.prototype;
$c_Lscalacss_internal_Length.prototype.value__T = (function() {
  var s = $dp_toString__T($n(this.Lscalacss_internal_Length__f_n));
  return ((s === "0") ? "0" : (("" + s) + $n(this.Lscalacss_internal_Length__f_u).Lscalacss_internal_LengthUnit__f_value))
});
$c_Lscalacss_internal_Length.prototype.$times__O__s_math_Numeric__Lscalacss_internal_Length = (function(m, N) {
  var n = $n(N).times__O__O__O(this.Lscalacss_internal_Length__f_n, m);
  var u = this.Lscalacss_internal_Length__f_u;
  return new $c_Lscalacss_internal_Length(n, u)
});
$c_Lscalacss_internal_Length.prototype.productPrefix__T = (function() {
  return "Length"
});
$c_Lscalacss_internal_Length.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_Length.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_Length__f_n;
      break
    }
    case 1: {
      return this.Lscalacss_internal_Length__f_u;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_Length.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Length.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Length.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Length.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Length)) {
    var Length$1 = $as_Lscalacss_internal_Length(x$1);
    var x = this.Lscalacss_internal_Length__f_n;
    var y = $n(Length$1).Lscalacss_internal_Length__f_n;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lscalacss_internal_Length__f_u;
      var x$2$1 = $n(Length$1).Lscalacss_internal_Length__f_u;
      if ((x$2 === null)) {
        return (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$2$1)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Length(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Length) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Length"))
}
function $isArrayOf_Lscalacss_internal_Length(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Length)))
}
function $asArrayOf_Lscalacss_internal_Length(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Length(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Length;", depth))
}
var $d_Lscalacss_internal_Length = new $TypeData().initClass({
  Lscalacss_internal_Length: 0
}, false, "scalacss.internal.Length", {
  Lscalacss_internal_Length: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Length.prototype.$classData = $d_Lscalacss_internal_Length;
/** @constructor */
function $c_Lscalacss_internal_Literal$Typed$none$() {
  this.Lscalacss_internal_Literal__f_value = null;
  $ct_Lscalacss_internal_Literal__T__(this, "none")
}
$c_Lscalacss_internal_Literal$Typed$none$.prototype = new $h_Lscalacss_internal_Literal();
$c_Lscalacss_internal_Literal$Typed$none$.prototype.constructor = $c_Lscalacss_internal_Literal$Typed$none$;
/** @constructor */
function $h_Lscalacss_internal_Literal$Typed$none$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Literal$Typed$none$.prototype = $c_Lscalacss_internal_Literal$Typed$none$.prototype;
var $d_Lscalacss_internal_Literal$Typed$none$ = new $TypeData().initClass({
  Lscalacss_internal_Literal$Typed$none$: 0
}, false, "scalacss.internal.Literal$Typed$none$", {
  Lscalacss_internal_Literal$Typed$none$: 1,
  Lscalacss_internal_Literal: 1,
  O: 1,
  Lscalacss_internal_Literal$Typed$BrStyle: 1,
  Lscalacss_internal_Literal$Typed$OverflowBehaviour: 1
});
$c_Lscalacss_internal_Literal$Typed$none$.prototype.$classData = $d_Lscalacss_internal_Literal$Typed$none$;
var $n_Lscalacss_internal_Literal$Typed$none$;
function $m_Lscalacss_internal_Literal$Typed$none$() {
  if ((!$n_Lscalacss_internal_Literal$Typed$none$)) {
    $n_Lscalacss_internal_Literal$Typed$none$ = new $c_Lscalacss_internal_Literal$Typed$none$()
  };
  return $n_Lscalacss_internal_Literal$Typed$none$
}
/** @constructor */
function $c_Lscalacss_internal_Media$Not$() {
  /*<skip>*/
}
$c_Lscalacss_internal_Media$Not$.prototype = new $h_sr_AbstractFunction1();
$c_Lscalacss_internal_Media$Not$.prototype.constructor = $c_Lscalacss_internal_Media$Not$;
/** @constructor */
function $h_Lscalacss_internal_Media$Not$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Not$.prototype = $c_Lscalacss_internal_Media$Not$.prototype;
$c_Lscalacss_internal_Media$Not$.prototype.toString__T = (function() {
  return "Not"
});
$c_Lscalacss_internal_Media$Not$.prototype.apply__O__O = (function(v1) {
  var t = $as_Lscalacss_internal_Media$TypeA(v1);
  return new $c_Lscalacss_internal_Media$Not(t)
});
var $d_Lscalacss_internal_Media$Not$ = new $TypeData().initClass({
  Lscalacss_internal_Media$Not$: 0
}, false, "scalacss.internal.Media$Not$", {
  Lscalacss_internal_Media$Not$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Not$.prototype.$classData = $d_Lscalacss_internal_Media$Not$;
var $n_Lscalacss_internal_Media$Not$;
function $m_Lscalacss_internal_Media$Not$() {
  if ((!$n_Lscalacss_internal_Media$Not$)) {
    $n_Lscalacss_internal_Media$Not$ = new $c_Lscalacss_internal_Media$Not$()
  };
  return $n_Lscalacss_internal_Media$Not$
}
function $ct_Lscalacss_internal_Percentage__O__($thiz, n) {
  $thiz.Lscalacss_internal_Percentage__f_n = n;
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_Percentage() {
  this.Lscalacss_internal_Percentage__f_n = null
}
$c_Lscalacss_internal_Percentage.prototype = new $h_O();
$c_Lscalacss_internal_Percentage.prototype.constructor = $c_Lscalacss_internal_Percentage;
/** @constructor */
function $h_Lscalacss_internal_Percentage() {
  /*<skip>*/
}
$h_Lscalacss_internal_Percentage.prototype = $c_Lscalacss_internal_Percentage.prototype;
$c_Lscalacss_internal_Percentage.prototype.n__O = (function() {
  return this.Lscalacss_internal_Percentage__f_n
});
$c_Lscalacss_internal_Percentage.prototype.value__T = (function() {
  return ($dp_toString__T($n(this.n__O())) + "%")
});
$c_Lscalacss_internal_Percentage.prototype.productPrefix__T = (function() {
  return "Percentage"
});
$c_Lscalacss_internal_Percentage.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_Percentage.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.n__O() : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_Percentage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Percentage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Percentage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Percentage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Percentage)) {
    var Percentage$1 = $as_Lscalacss_internal_Percentage(x$1);
    var x = this.n__O();
    var y = $n(Percentage$1).n__O();
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Percentage(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Percentage) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Percentage"))
}
function $isArrayOf_Lscalacss_internal_Percentage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Percentage)))
}
function $asArrayOf_Lscalacss_internal_Percentage(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Percentage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Percentage;", depth))
}
var $d_Lscalacss_internal_Percentage = new $TypeData().initClass({
  Lscalacss_internal_Percentage: 0
}, false, "scalacss.internal.Percentage", {
  Lscalacss_internal_Percentage: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Percentage.prototype.$classData = $d_Lscalacss_internal_Percentage;
function $as_Lscalacss_internal_Ratio(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Ratio"))
}
function $isArrayOf_Lscalacss_internal_Ratio(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Ratio)))
}
function $asArrayOf_Lscalacss_internal_Ratio(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Ratio(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Ratio;", depth))
}
function $as_Lscalacss_internal_Resolution(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Resolution"))
}
function $isArrayOf_Lscalacss_internal_Resolution(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Resolution)))
}
function $asArrayOf_Lscalacss_internal_Resolution(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Resolution(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Resolution;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_StringRenderer$FormatSB(kfStart, kfsStart, mqStart, selStart, kv1, kvn, selEnd, mqEnd, kfsEnd, kfEnd, ff, done) {
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kfStart = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsStart = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_mqStart = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_selStart = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kv1 = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kvn = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_selEnd = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_mqEnd = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsEnd = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kfEnd = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_ff = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_done = null;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kfStart = kfStart;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsStart = kfsStart;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_mqStart = mqStart;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_selStart = selStart;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kv1 = kv1;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kvn = kvn;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_selEnd = selEnd;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_mqEnd = mqEnd;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsEnd = kfsEnd;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_kfEnd = kfEnd;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_ff = ff;
  this.Lscalacss_internal_StringRenderer$FormatSB__f_done = done
}
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype = new $h_O();
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.constructor = $c_Lscalacss_internal_StringRenderer$FormatSB;
/** @constructor */
function $h_Lscalacss_internal_StringRenderer$FormatSB() {
  /*<skip>*/
}
$h_Lscalacss_internal_StringRenderer$FormatSB.prototype = $c_Lscalacss_internal_StringRenderer$FormatSB.prototype;
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.apply__s_Option__Lscalacss_internal_NonEmptyVector__V = (function(mq, data) {
  var this$1 = $n(mq);
  var f = this.Lscalacss_internal_StringRenderer$FormatSB__f_mqStart;
  if ((!this$1.isEmpty__Z())) {
    $n(f).apply__O__O(this$1.get__O())
  };
  var this$3 = $n($n(data).whole__sci_Vector());
  var p = new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
    var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
    return (check$ifrefutable$1 !== null)
  }));
  var this$4 = $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this$3, p);
  var f$1 = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_T2(x$5$2);
    if ((x$5 !== null)) {
      var sel = $as_T($n(x$5)._1__O());
      var kvs = $as_Lscalacss_internal_NonEmptyVector($n(x$5)._2__O());
      this.apply__s_Option__s_Option__T__Lscalacss_internal_NonEmptyVector__V($m_s_None$(), mq, sel, kvs)
    } else {
      throw new $c_s_MatchError(x$5)
    }
  }));
  $n(this$4.filtered__sc_Iterable()).foreach__F1__V(f$1);
  var this$5 = $n(mq);
  var f$2 = this.Lscalacss_internal_StringRenderer$FormatSB__f_mqEnd;
  if ((!this$5.isEmpty__Z())) {
    $n(f$2).apply__O__O(this$5.get__O())
  }
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.apply__Lscalacss_internal_CssEntry__V = (function(cssEntry) {
  if ((cssEntry instanceof $c_Lscalacss_internal_CssEntry$Style)) {
    var x2 = $as_Lscalacss_internal_CssEntry$Style(cssEntry);
    var this$1 = $n($n(x2).Lscalacss_internal_CssEntry$Style__f_mq);
    var f = this.Lscalacss_internal_StringRenderer$FormatSB__f_mqStart;
    if ((!this$1.isEmpty__Z())) {
      $n(f).apply__O__O(this$1.get__O())
    };
    this.apply__s_Option__s_Option__T__Lscalacss_internal_NonEmptyVector__V($m_s_None$(), $n(x2).Lscalacss_internal_CssEntry$Style__f_mq, $n(x2).Lscalacss_internal_CssEntry$Style__f_sel, $n(x2).Lscalacss_internal_CssEntry$Style__f_content);
    var this$2 = $n($n(x2).Lscalacss_internal_CssEntry$Style__f_mq);
    var f$1 = this.Lscalacss_internal_StringRenderer$FormatSB__f_mqEnd;
    if ((!this$2.isEmpty__Z())) {
      $n(f$1).apply__O__O(this$2.get__O())
    }
  } else if ((cssEntry instanceof $c_Lscalacss_internal_CssEntry$Keyframes)) {
    var x3 = $as_Lscalacss_internal_CssEntry$Keyframes(cssEntry);
    $n(this.Lscalacss_internal_StringRenderer$FormatSB__f_kfStart).apply__O__O($n($n(x3).Lscalacss_internal_CssEntry$Keyframes__f_name).Lscalacss_internal_ClassName__f_value);
    var this$4 = $n($n(x3).Lscalacss_internal_CssEntry$Keyframes__f_frames);
    var p = new $c_sjsr_AnonFunction1(((check$ifrefutable$2$2) => {
      var check$ifrefutable$2 = $as_T2(check$ifrefutable$2$2);
      return (check$ifrefutable$2 !== null)
    }));
    var this$5 = $ct_sc_MapOps$WithFilter__sc_MapOps__F1__(new $c_sc_MapOps$WithFilter(), this$4, p);
    var f$2 = new $c_sjsr_AnonFunction1(((x$6$2) => {
      var x$6 = $as_T2(x$6$2);
      if ((x$6 !== null)) {
        var sel = $as_Lscalacss_internal_Percentage($n(x$6)._1__O());
        var styles = $as_sci_Vector($n(x$6)._2__O());
        $n(this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsStart).apply__O__O($n(sel).value__T());
        var selO = new $c_s_Some(sel);
        $n(styles).foreach__F1__V(new $c_sjsr_AnonFunction1(((s$2) => {
          var s = $as_Lscalacss_internal_CssEntry$Style(s$2);
          this.printCssKV__s_Option__s_Option__Lscalacss_internal_NonEmptyVector__V(selO, $n(s).Lscalacss_internal_CssEntry$Style__f_mq, $n(s).Lscalacss_internal_CssEntry$Style__f_content)
        })));
        $as_jl_Void($n(this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsEnd).apply__O__O(sel))
      } else {
        throw new $c_s_MatchError(x$6)
      }
    }));
    $n(this$5.filtered__sc_Iterable()).foreach__F1__V(f$2);
    $as_jl_Void($n(this.Lscalacss_internal_StringRenderer$FormatSB__f_kfEnd).apply__O__O($n(x3).Lscalacss_internal_CssEntry$Keyframes__f_name))
  } else if ((cssEntry instanceof $c_Lscalacss_internal_CssEntry$FontFace)) {
    var x4 = $as_Lscalacss_internal_CssEntry$FontFace(cssEntry);
    $as_jl_Void($n(this.Lscalacss_internal_StringRenderer$FormatSB__f_ff).apply__O__O(x4))
  } else {
    throw new $c_s_MatchError(cssEntry)
  }
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.apply__s_Option__s_Option__T__Lscalacss_internal_NonEmptyVector__V = (function(kf, mq, sel, kvs) {
  $n(this.Lscalacss_internal_StringRenderer$FormatSB__f_selStart).apply__O__O__O(mq, sel);
  this.printCssKV__s_Option__s_Option__Lscalacss_internal_NonEmptyVector__V(kf, mq, kvs);
  $n(this.Lscalacss_internal_StringRenderer$FormatSB__f_selEnd).apply__O__O__O(mq, sel)
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.printCssKV__s_Option__s_Option__Lscalacss_internal_NonEmptyVector__V = (function(kf, mq, kvs) {
  $n(this.Lscalacss_internal_StringRenderer$FormatSB__f_kv1).apply__O__O__O__O(kf, mq, $n(kvs).Lscalacss_internal_NonEmptyVector__f_head);
  $n($n(kvs).Lscalacss_internal_NonEmptyVector__f_tail).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Lscalacss_internal_CssKV(x$7$2);
    $n(this.Lscalacss_internal_StringRenderer$FormatSB__f_kvn).apply__O__O__O__O(kf, mq, x$7)
  })))
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.productPrefix__T = (function() {
  return "FormatSB"
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.productArity__I = (function() {
  return 12
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_kfStart;
      break
    }
    case 1: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsStart;
      break
    }
    case 2: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_mqStart;
      break
    }
    case 3: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_selStart;
      break
    }
    case 4: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_kv1;
      break
    }
    case 5: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_kvn;
      break
    }
    case 6: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_selEnd;
      break
    }
    case 7: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_mqEnd;
      break
    }
    case 8: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsEnd;
      break
    }
    case 9: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_kfEnd;
      break
    }
    case 10: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_ff;
      break
    }
    case 11: {
      return this.Lscalacss_internal_StringRenderer$FormatSB__f_done;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_StringRenderer$FormatSB)) {
    var FormatSB$1 = $as_Lscalacss_internal_StringRenderer$FormatSB(x$1);
    var x = this.Lscalacss_internal_StringRenderer$FormatSB__f_kfStart;
    var x$2 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_kfStart;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsStart;
      var x$4 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_kfsStart;
      var $$x11 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x11 = false
    };
    if ($$x11) {
      var x$5 = this.Lscalacss_internal_StringRenderer$FormatSB__f_mqStart;
      var x$6 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_mqStart;
      var $$x10 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
    } else {
      var $$x10 = false
    };
    if ($$x10) {
      var x$7 = this.Lscalacss_internal_StringRenderer$FormatSB__f_selStart;
      var x$8 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_selStart;
      if ((x$7 === null)) {
        var $$x9 = (x$8 === null)
      } else {
        var this$1 = $n(x$7);
        var $$x9 = (this$1 === x$8)
      }
    } else {
      var $$x9 = false
    };
    if ($$x9) {
      var x$9 = this.Lscalacss_internal_StringRenderer$FormatSB__f_kv1;
      var x$10 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_kv1;
      if ((x$9 === null)) {
        var $$x8 = (x$10 === null)
      } else {
        var this$2 = $n(x$9);
        var $$x8 = (this$2 === x$10)
      }
    } else {
      var $$x8 = false
    };
    if ($$x8) {
      var x$11 = this.Lscalacss_internal_StringRenderer$FormatSB__f_kvn;
      var x$12 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_kvn;
      if ((x$11 === null)) {
        var $$x7 = (x$12 === null)
      } else {
        var this$3 = $n(x$11);
        var $$x7 = (this$3 === x$12)
      }
    } else {
      var $$x7 = false
    };
    if ($$x7) {
      var x$13 = this.Lscalacss_internal_StringRenderer$FormatSB__f_selEnd;
      var x$14 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_selEnd;
      if ((x$13 === null)) {
        var $$x6 = (x$14 === null)
      } else {
        var this$4 = $n(x$13);
        var $$x6 = (this$4 === x$14)
      }
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$15 = this.Lscalacss_internal_StringRenderer$FormatSB__f_mqEnd;
      var x$16 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_mqEnd;
      var $$x5 = ((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$17 = this.Lscalacss_internal_StringRenderer$FormatSB__f_kfsEnd;
      var x$18 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_kfsEnd;
      var $$x4 = ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$19 = this.Lscalacss_internal_StringRenderer$FormatSB__f_kfEnd;
      var x$20 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_kfEnd;
      var $$x3 = ((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$21 = this.Lscalacss_internal_StringRenderer$FormatSB__f_ff;
      var x$22 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_ff;
      var $$x2 = ((x$21 === null) ? (x$22 === null) : $n(x$21).equals__O__Z(x$22))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$23 = this.Lscalacss_internal_StringRenderer$FormatSB__f_done;
      var x$24 = $n(FormatSB$1).Lscalacss_internal_StringRenderer$FormatSB__f_done;
      if ((x$23 === null)) {
        var $$x1 = (x$24 === null)
      } else {
        var this$5 = $n(x$23);
        var $$x1 = (this$5 === x$24)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(FormatSB$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_StringRenderer$FormatSB(obj) {
  return (((obj instanceof $c_Lscalacss_internal_StringRenderer$FormatSB) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.StringRenderer$FormatSB"))
}
function $isArrayOf_Lscalacss_internal_StringRenderer$FormatSB(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_StringRenderer$FormatSB)))
}
function $asArrayOf_Lscalacss_internal_StringRenderer$FormatSB(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_StringRenderer$FormatSB(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.StringRenderer$FormatSB;", depth))
}
var $d_Lscalacss_internal_StringRenderer$FormatSB = new $TypeData().initClass({
  Lscalacss_internal_StringRenderer$FormatSB: 0
}, false, "scalacss.internal.StringRenderer$FormatSB", {
  Lscalacss_internal_StringRenderer$FormatSB: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_StringRenderer$FormatSB.prototype.$classData = $d_Lscalacss_internal_StringRenderer$FormatSB;
/** @constructor */
function $c_Lscalacss_internal_Style$UnsafeExt(sel, cond, style) {
  this.Lscalacss_internal_Style$UnsafeExt__f_sel = null;
  this.Lscalacss_internal_Style$UnsafeExt__f_cond = null;
  this.Lscalacss_internal_Style$UnsafeExt__f_style = null;
  this.Lscalacss_internal_Style$UnsafeExt__f_sel = sel;
  this.Lscalacss_internal_Style$UnsafeExt__f_cond = cond;
  this.Lscalacss_internal_Style$UnsafeExt__f_style = style
}
$c_Lscalacss_internal_Style$UnsafeExt.prototype = new $h_O();
$c_Lscalacss_internal_Style$UnsafeExt.prototype.constructor = $c_Lscalacss_internal_Style$UnsafeExt;
/** @constructor */
function $h_Lscalacss_internal_Style$UnsafeExt() {
  /*<skip>*/
}
$h_Lscalacss_internal_Style$UnsafeExt.prototype = $c_Lscalacss_internal_Style$UnsafeExt.prototype;
$c_Lscalacss_internal_Style$UnsafeExt.prototype.productPrefix__T = (function() {
  return "UnsafeExt"
});
$c_Lscalacss_internal_Style$UnsafeExt.prototype.productArity__I = (function() {
  return 3
});
$c_Lscalacss_internal_Style$UnsafeExt.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_Style$UnsafeExt__f_sel;
      break
    }
    case 1: {
      return this.Lscalacss_internal_Style$UnsafeExt__f_cond;
      break
    }
    case 2: {
      return this.Lscalacss_internal_Style$UnsafeExt__f_style;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_Style$UnsafeExt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Style$UnsafeExt.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Style$UnsafeExt.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Style$UnsafeExt.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Style$UnsafeExt)) {
    var UnsafeExt$1 = $as_Lscalacss_internal_Style$UnsafeExt(x$1);
    var x = this.Lscalacss_internal_Style$UnsafeExt__f_sel;
    var x$2 = $n(UnsafeExt$1).Lscalacss_internal_Style$UnsafeExt__f_sel;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalacss_internal_Style$UnsafeExt__f_cond;
      var x$4 = $n(UnsafeExt$1).Lscalacss_internal_Style$UnsafeExt__f_cond;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lscalacss_internal_Style$UnsafeExt__f_style;
      var x$6 = $n(UnsafeExt$1).Lscalacss_internal_Style$UnsafeExt__f_style;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Style$UnsafeExt(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Style$UnsafeExt) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Style$UnsafeExt"))
}
function $isArrayOf_Lscalacss_internal_Style$UnsafeExt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Style$UnsafeExt)))
}
function $asArrayOf_Lscalacss_internal_Style$UnsafeExt(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Style$UnsafeExt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Style$UnsafeExt;", depth))
}
var $d_Lscalacss_internal_Style$UnsafeExt = new $TypeData().initClass({
  Lscalacss_internal_Style$UnsafeExt: 0
}, false, "scalacss.internal.Style$UnsafeExt", {
  Lscalacss_internal_Style$UnsafeExt: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Style$UnsafeExt.prototype.$classData = $d_Lscalacss_internal_Style$UnsafeExt;
/** @constructor */
function $c_Lscalacss_internal_StyleA(className, addClassNames, style) {
  this.Lscalacss_internal_StyleA__f_className = null;
  this.Lscalacss_internal_StyleA__f_addClassNames = null;
  this.Lscalacss_internal_StyleA__f_style = null;
  this.Lscalacss_internal_StyleA__f_htmlClass = null;
  this.Lscalacss_internal_StyleA__f_className = className;
  this.Lscalacss_internal_StyleA__f_addClassNames = addClassNames;
  this.Lscalacss_internal_StyleA__f_style = style;
  var this$2 = $n(this.classNameIterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lscalacss_internal_ClassName(x$1$2);
    return $n(x$1).Lscalacss_internal_ClassName__f_value
  }));
  var this$3 = new $c_sc_Iterator$$anon$9(this$2, f);
  this.Lscalacss_internal_StyleA__f_htmlClass = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", " ", "")
}
$c_Lscalacss_internal_StyleA.prototype = new $h_O();
$c_Lscalacss_internal_StyleA.prototype.constructor = $c_Lscalacss_internal_StyleA;
/** @constructor */
function $h_Lscalacss_internal_StyleA() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleA.prototype = $c_Lscalacss_internal_StyleA.prototype;
$c_Lscalacss_internal_StyleA.prototype.classNameIterator__sc_Iterator = (function() {
  $n($m_s_package$().s_package$__f_Iterator);
  var a = this.Lscalacss_internal_StyleA__f_className;
  var this$3 = new $c_sc_Iterator$$anon$20(a);
  var xs = new $c_sjsr_AnonFunction0((() => this.Lscalacss_internal_StyleA__f_addClassNames));
  return $f_sc_Iterator__concat__F0__sc_Iterator(this$3, xs)
});
$c_Lscalacss_internal_StyleA.prototype.productPrefix__T = (function() {
  return "StyleA"
});
$c_Lscalacss_internal_StyleA.prototype.productArity__I = (function() {
  return 3
});
$c_Lscalacss_internal_StyleA.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_StyleA__f_className;
      break
    }
    case 1: {
      return this.Lscalacss_internal_StyleA__f_addClassNames;
      break
    }
    case 2: {
      return this.Lscalacss_internal_StyleA__f_style;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_StyleA.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_StyleA.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_StyleA.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_StyleA.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_StyleA)) {
    var StyleA$1 = $as_Lscalacss_internal_StyleA(x$1);
    var x = this.Lscalacss_internal_StyleA__f_className;
    var x$2 = $n(StyleA$1).Lscalacss_internal_StyleA__f_className;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalacss_internal_StyleA__f_addClassNames;
      var x$4 = $n(StyleA$1).Lscalacss_internal_StyleA__f_addClassNames;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lscalacss_internal_StyleA__f_style;
      var x$6 = $n(StyleA$1).Lscalacss_internal_StyleA__f_style;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_StyleA(obj) {
  return (((obj instanceof $c_Lscalacss_internal_StyleA) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.StyleA"))
}
function $isArrayOf_Lscalacss_internal_StyleA(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_StyleA)))
}
function $asArrayOf_Lscalacss_internal_StyleA(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_StyleA(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.StyleA;", depth))
}
var $d_Lscalacss_internal_StyleA = new $TypeData().initClass({
  Lscalacss_internal_StyleA: 0
}, false, "scalacss.internal.StyleA", {
  Lscalacss_internal_StyleA: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_StyleA.prototype.$classData = $d_Lscalacss_internal_StyleA;
/** @constructor */
function $c_Lscalacss_internal_StyleA$() {
  /*<skip>*/
}
$c_Lscalacss_internal_StyleA$.prototype = new $h_sr_AbstractFunction3();
$c_Lscalacss_internal_StyleA$.prototype.constructor = $c_Lscalacss_internal_StyleA$;
/** @constructor */
function $h_Lscalacss_internal_StyleA$() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleA$.prototype = $c_Lscalacss_internal_StyleA$.prototype;
$c_Lscalacss_internal_StyleA$.prototype.toString__T = (function() {
  return "StyleA"
});
$c_Lscalacss_internal_StyleA$.prototype.apply__O__O__O__O = (function(v1, v2, v3) {
  var className = $as_Lscalacss_internal_ClassName(v1);
  var addClassNames = $as_sci_Vector(v2);
  var style = $as_Lscalacss_internal_StyleS(v3);
  return new $c_Lscalacss_internal_StyleA(className, addClassNames, style)
});
var $d_Lscalacss_internal_StyleA$ = new $TypeData().initClass({
  Lscalacss_internal_StyleA$: 0
}, false, "scalacss.internal.StyleA$", {
  Lscalacss_internal_StyleA$: 1,
  sr_AbstractFunction3: 1,
  O: 1,
  F3: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_StyleA$.prototype.$classData = $d_Lscalacss_internal_StyleA$;
var $n_Lscalacss_internal_StyleA$;
function $m_Lscalacss_internal_StyleA$() {
  if ((!$n_Lscalacss_internal_StyleA$)) {
    $n_Lscalacss_internal_StyleA$ = new $c_Lscalacss_internal_StyleA$()
  };
  return $n_Lscalacss_internal_StyleA$
}
/** @constructor */
function $c_Lscalacss_internal_StyleF$$anon$1(f$2) {
  this.Lscalacss_internal_StyleF$$anon$1__f_f$2 = null;
  this.Lscalacss_internal_StyleF$$anon$1__f_f$2 = f$2
}
$c_Lscalacss_internal_StyleF$$anon$1.prototype = new $h_sr_AbstractFunction1();
$c_Lscalacss_internal_StyleF$$anon$1.prototype.constructor = $c_Lscalacss_internal_StyleF$$anon$1;
/** @constructor */
function $h_Lscalacss_internal_StyleF$$anon$1() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleF$$anon$1.prototype = $c_Lscalacss_internal_StyleF$$anon$1.prototype;
$c_Lscalacss_internal_StyleF$$anon$1.prototype.apply__Lscalacss_internal_Domain__Lscalacss_internal_StyleF = (function(d) {
  return $as_Lscalacss_internal_StyleF($n(this.Lscalacss_internal_StyleF$$anon$1__f_f$2).apply__O__O(d))
});
$c_Lscalacss_internal_StyleF$$anon$1.prototype.apply__O__O = (function(v1) {
  return this.apply__Lscalacss_internal_Domain__Lscalacss_internal_StyleF($as_Lscalacss_internal_Domain(v1))
});
var $d_Lscalacss_internal_StyleF$$anon$1 = new $TypeData().initClass({
  Lscalacss_internal_StyleF$$anon$1: 0
}, false, "scalacss.internal.StyleF$$anon$1", {
  Lscalacss_internal_StyleF$$anon$1: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Lscalacss_internal_StyleF$P: 1
});
$c_Lscalacss_internal_StyleF$$anon$1.prototype.$classData = $d_Lscalacss_internal_StyleF$$anon$1;
function $as_Lscalacss_internal_UnicodeRange(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.UnicodeRange"))
}
function $isArrayOf_Lscalacss_internal_UnicodeRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_UnicodeRange)))
}
function $asArrayOf_Lscalacss_internal_UnicodeRange(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_UnicodeRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.UnicodeRange;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_ValueT(value) {
  this.Lscalacss_internal_ValueT__f_value = null;
  this.Lscalacss_internal_ValueT__f_value = value
}
$c_Lscalacss_internal_ValueT.prototype = new $h_O();
$c_Lscalacss_internal_ValueT.prototype.constructor = $c_Lscalacss_internal_ValueT;
/** @constructor */
function $h_Lscalacss_internal_ValueT() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT.prototype = $c_Lscalacss_internal_ValueT.prototype;
$c_Lscalacss_internal_ValueT.prototype.productPrefix__T = (function() {
  return "ValueT"
});
$c_Lscalacss_internal_ValueT.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_ValueT.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_ValueT__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_ValueT.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_ValueT.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_ValueT.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_ValueT.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_ValueT)) {
    var ValueT$1 = $as_Lscalacss_internal_ValueT(x$1);
    return (this.Lscalacss_internal_ValueT__f_value === $n(ValueT$1).Lscalacss_internal_ValueT__f_value)
  } else {
    return false
  }
});
function $as_Lscalacss_internal_ValueT(obj) {
  return (((obj instanceof $c_Lscalacss_internal_ValueT) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.ValueT"))
}
function $isArrayOf_Lscalacss_internal_ValueT(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_ValueT)))
}
function $asArrayOf_Lscalacss_internal_ValueT(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_ValueT(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.ValueT;", depth))
}
var $d_Lscalacss_internal_ValueT = new $TypeData().initClass({
  Lscalacss_internal_ValueT: 0
}, false, "scalacss.internal.ValueT", {
  Lscalacss_internal_ValueT: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_ValueT.prototype.$classData = $d_Lscalacss_internal_ValueT;
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto.prototype = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto.prototype;
function $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fLength__($thiz) {
  $thiz.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr = $as_Lscalacss_internal_Attr($n($thiz.attr2__F1()).apply__O__O($m_Lscalacss_internal_CanIUse2$().intrinsicWidthTransforms__Lscalacss_internal_Transform()));
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttr\uff3fLength() {
  this.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr = null
}
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fLength.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fLength.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fLength;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLength() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttr\uff3fLength.prototype = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fLength.prototype;
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fLength.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr
});
function $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__($thiz) {
  $thiz.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr = $as_Lscalacss_internal_Attr($n($thiz.attr2__F1()).apply__O__O($m_Lscalacss_internal_CanIUse2$().intrinsicWidthTransforms__Lscalacss_internal_Transform()));
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength() {
  this.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr = null
}
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength.prototype = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength.prototype;
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr
});
function $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__($thiz) {
  $thiz.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr = $as_Lscalacss_internal_Attr($n($thiz.attr2__F1()).apply__O__O($m_Lscalacss_internal_CanIUse2$().intrinsicWidthTransforms__Lscalacss_internal_Transform()));
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength() {
  this.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr = null
}
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength.prototype = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength.prototype;
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr
});
/** @constructor */
function $c_Lscalacss_internal_package$Warning(cond, msg) {
  this.Lscalacss_internal_package$Warning__f_cond = null;
  this.Lscalacss_internal_package$Warning__f_msg = null;
  this.Lscalacss_internal_package$Warning__f_cond = cond;
  this.Lscalacss_internal_package$Warning__f_msg = msg
}
$c_Lscalacss_internal_package$Warning.prototype = new $h_O();
$c_Lscalacss_internal_package$Warning.prototype.constructor = $c_Lscalacss_internal_package$Warning;
/** @constructor */
function $h_Lscalacss_internal_package$Warning() {
  /*<skip>*/
}
$h_Lscalacss_internal_package$Warning.prototype = $c_Lscalacss_internal_package$Warning.prototype;
$c_Lscalacss_internal_package$Warning.prototype.productPrefix__T = (function() {
  return "Warning"
});
$c_Lscalacss_internal_package$Warning.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_package$Warning.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_package$Warning__f_cond;
      break
    }
    case 1: {
      return this.Lscalacss_internal_package$Warning__f_msg;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_package$Warning.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_package$Warning.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_package$Warning.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_package$Warning.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_package$Warning)) {
    var Warning$1 = $as_Lscalacss_internal_package$Warning(x$1);
    var x = this.Lscalacss_internal_package$Warning__f_cond;
    var x$2 = $n(Warning$1).Lscalacss_internal_package$Warning__f_cond;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lscalacss_internal_package$Warning__f_msg === $n(Warning$1).Lscalacss_internal_package$Warning__f_msg)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_package$Warning(obj) {
  return (((obj instanceof $c_Lscalacss_internal_package$Warning) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.package$Warning"))
}
function $isArrayOf_Lscalacss_internal_package$Warning(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_package$Warning)))
}
function $asArrayOf_Lscalacss_internal_package$Warning(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_package$Warning(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.package$Warning;", depth))
}
var $d_Lscalacss_internal_package$Warning = new $TypeData().initClass({
  Lscalacss_internal_package$Warning: 0
}, false, "scalacss.internal.package$Warning", {
  Lscalacss_internal_package$Warning: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_package$Warning.prototype.$classData = $d_Lscalacss_internal_package$Warning;
/** @constructor */
function $c_Lscalatags_generic_Attr(name, namespace, raw) {
  this.Lscalatags_generic_Attr__f_name = null;
  this.Lscalatags_generic_Attr__f_namespace = null;
  this.Lscalatags_generic_Attr__f_raw = false;
  this.Lscalatags_generic_Attr__f_name = name;
  this.Lscalatags_generic_Attr__f_namespace = namespace;
  this.Lscalatags_generic_Attr__f_raw = raw;
  if (((!raw) && (!$m_Lscalatags_Escaping$().validAttrName__T__Z(name)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("Illegal attribute name: " + name) + " is not a valid XML attribute name"))
  }
}
$c_Lscalatags_generic_Attr.prototype = new $h_O();
$c_Lscalatags_generic_Attr.prototype.constructor = $c_Lscalatags_generic_Attr;
/** @constructor */
function $h_Lscalatags_generic_Attr() {
  /*<skip>*/
}
$h_Lscalatags_generic_Attr.prototype = $c_Lscalatags_generic_Attr.prototype;
$c_Lscalatags_generic_Attr.prototype.$colon$eq__O__Lscalatags_generic_AttrValue__Lscalatags_generic_AttrPair = (function(v, ev) {
  if ((v === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return new $c_Lscalatags_generic_AttrPair(this, v, ev)
});
$c_Lscalatags_generic_Attr.prototype.productPrefix__T = (function() {
  return "Attr"
});
$c_Lscalatags_generic_Attr.prototype.productArity__I = (function() {
  return 3
});
$c_Lscalatags_generic_Attr.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalatags_generic_Attr__f_name;
      break
    }
    case 1: {
      return this.Lscalatags_generic_Attr__f_namespace;
      break
    }
    case 2: {
      return this.Lscalatags_generic_Attr__f_raw;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalatags_generic_Attr.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalatags_generic_Attr.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Attr");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lscalatags_generic_Attr__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lscalatags_generic_Attr__f_namespace;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lscalatags_generic_Attr__f_raw ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lscalatags_generic_Attr.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalatags_generic_Attr.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalatags_generic_Attr)) {
    var Attr$1 = $as_Lscalatags_generic_Attr(x$1);
    if (((this.Lscalatags_generic_Attr__f_raw === $n(Attr$1).Lscalatags_generic_Attr__f_raw) && (this.Lscalatags_generic_Attr__f_name === $n(Attr$1).Lscalatags_generic_Attr__f_name))) {
      var x = this.Lscalatags_generic_Attr__f_namespace;
      var x$2 = $n(Attr$1).Lscalatags_generic_Attr__f_namespace;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(Attr$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalatags_generic_Attr(obj) {
  return (((obj instanceof $c_Lscalatags_generic_Attr) || (obj === null)) ? obj : $throwClassCastException(obj, "scalatags.generic.Attr"))
}
function $isArrayOf_Lscalatags_generic_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalatags_generic_Attr)))
}
function $asArrayOf_Lscalatags_generic_Attr(obj, depth) {
  return (($isArrayOf_Lscalatags_generic_Attr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalatags.generic.Attr;", depth))
}
var $d_Lscalatags_generic_Attr = new $TypeData().initClass({
  Lscalatags_generic_Attr: 0
}, false, "scalatags.generic.Attr", {
  Lscalatags_generic_Attr: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalatags_generic_Attr.prototype.$classData = $d_Lscalatags_generic_Attr;
/** @constructor */
function $c_Lshapeless_Annotations$$anon$2(annotations$1) {
  this.Lshapeless_Annotations$$anon$2__f_annotations$1 = null;
  this.Lshapeless_Annotations$$anon$2__f_annotations$1 = annotations$1
}
$c_Lshapeless_Annotations$$anon$2.prototype = new $h_O();
$c_Lshapeless_Annotations$$anon$2.prototype.constructor = $c_Lshapeless_Annotations$$anon$2;
/** @constructor */
function $h_Lshapeless_Annotations$$anon$2() {
  /*<skip>*/
}
$h_Lshapeless_Annotations$$anon$2.prototype = $c_Lshapeless_Annotations$$anon$2.prototype;
$c_Lshapeless_Annotations$$anon$2.prototype.apply__Lshapeless_HList = (function() {
  return $as_Lshapeless_HList($n(this.Lshapeless_Annotations$$anon$2__f_annotations$1).apply__O())
});
var $d_Lshapeless_Annotations$$anon$2 = new $TypeData().initClass({
  Lshapeless_Annotations$$anon$2: 0
}, false, "shapeless.Annotations$$anon$2", {
  Lshapeless_Annotations$$anon$2: 1,
  O: 1,
  Lshapeless_Annotations: 1,
  Lshapeless_package$DepFn0: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Annotations$$anon$2.prototype.$classData = $d_Lshapeless_Annotations$$anon$2;
function $is_Lshapeless_Coproduct(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lshapeless_Coproduct)))
}
function $as_Lshapeless_Coproduct(obj) {
  return (($is_Lshapeless_Coproduct(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.Coproduct"))
}
function $isArrayOf_Lshapeless_Coproduct(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_Coproduct)))
}
function $asArrayOf_Lshapeless_Coproduct(obj, depth) {
  return (($isArrayOf_Lshapeless_Coproduct(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.Coproduct;", depth))
}
/** @constructor */
function $c_Lshapeless_Default$$anon$1(defaults$1) {
  this.Lshapeless_Default$$anon$1__f_defaults$1 = null;
  this.Lshapeless_Default$$anon$1__f_defaults$1 = defaults$1
}
$c_Lshapeless_Default$$anon$1.prototype = new $h_O();
$c_Lshapeless_Default$$anon$1.prototype.constructor = $c_Lshapeless_Default$$anon$1;
/** @constructor */
function $h_Lshapeless_Default$$anon$1() {
  /*<skip>*/
}
$h_Lshapeless_Default$$anon$1.prototype = $c_Lshapeless_Default$$anon$1.prototype;
var $d_Lshapeless_Default$$anon$1 = new $TypeData().initClass({
  Lshapeless_Default$$anon$1: 0
}, false, "shapeless.Default$$anon$1", {
  Lshapeless_Default$$anon$1: 1,
  O: 1,
  Lshapeless_Default: 1,
  Lshapeless_package$DepFn0: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Default$$anon$1.prototype.$classData = $d_Lshapeless_Default$$anon$1;
/** @constructor */
function $c_Lshapeless_Default$AsRecord$$anon$5(helper$1, default$1) {
  this.Lshapeless_Default$AsRecord$$anon$5__f_helper$1 = null;
  this.Lshapeless_Default$AsRecord$$anon$5__f_default$1 = null;
  this.Lshapeless_Default$AsRecord$$anon$5__f_helper$1 = helper$1;
  this.Lshapeless_Default$AsRecord$$anon$5__f_default$1 = default$1
}
$c_Lshapeless_Default$AsRecord$$anon$5.prototype = new $h_O();
$c_Lshapeless_Default$AsRecord$$anon$5.prototype.constructor = $c_Lshapeless_Default$AsRecord$$anon$5;
/** @constructor */
function $h_Lshapeless_Default$AsRecord$$anon$5() {
  /*<skip>*/
}
$h_Lshapeless_Default$AsRecord$$anon$5.prototype = $c_Lshapeless_Default$AsRecord$$anon$5.prototype;
$c_Lshapeless_Default$AsRecord$$anon$5.prototype.apply__Lshapeless_HList = (function() {
  var $$x1 = this.Lshapeless_Default$AsRecord$$anon$5__f_helper$1;
  var this$1 = $n(this.Lshapeless_Default$AsRecord$$anon$5__f_default$1);
  return $as_Lshapeless_HList($n($$x1).apply__O__O(this$1.Lshapeless_Default$$anon$1__f_defaults$1))
});
var $d_Lshapeless_Default$AsRecord$$anon$5 = new $TypeData().initClass({
  Lshapeless_Default$AsRecord$$anon$5: 0
}, false, "shapeless.Default$AsRecord$$anon$5", {
  Lshapeless_Default$AsRecord$$anon$5: 1,
  O: 1,
  Lshapeless_Default$AsRecord: 1,
  Lshapeless_package$DepFn0: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Default$AsRecord$$anon$5.prototype.$classData = $d_Lshapeless_Default$AsRecord$$anon$5;
/** @constructor */
function $c_Lshapeless_Default$AsRecord$Helper$$anon$2() {
  /*<skip>*/
}
$c_Lshapeless_Default$AsRecord$Helper$$anon$2.prototype = new $h_O();
$c_Lshapeless_Default$AsRecord$Helper$$anon$2.prototype.constructor = $c_Lshapeless_Default$AsRecord$Helper$$anon$2;
/** @constructor */
function $h_Lshapeless_Default$AsRecord$Helper$$anon$2() {
  /*<skip>*/
}
$h_Lshapeless_Default$AsRecord$Helper$$anon$2.prototype = $c_Lshapeless_Default$AsRecord$Helper$$anon$2.prototype;
$c_Lshapeless_Default$AsRecord$Helper$$anon$2.prototype.apply__O__O = (function(t) {
  $as_Lshapeless_HNil(t);
  return $m_Lshapeless_HNil$()
});
var $d_Lshapeless_Default$AsRecord$Helper$$anon$2 = new $TypeData().initClass({
  Lshapeless_Default$AsRecord$Helper$$anon$2: 0
}, false, "shapeless.Default$AsRecord$Helper$$anon$2", {
  Lshapeless_Default$AsRecord$Helper$$anon$2: 1,
  O: 1,
  Lshapeless_Default$AsRecord$Helper: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Default$AsRecord$Helper$$anon$2.prototype.$classData = $d_Lshapeless_Default$AsRecord$Helper$$anon$2;
/** @constructor */
function $c_Lshapeless_Default$AsRecord$Helper$$anon$3(tailHelper$1) {
  this.Lshapeless_Default$AsRecord$Helper$$anon$3__f_tailHelper$1 = null;
  this.Lshapeless_Default$AsRecord$Helper$$anon$3__f_tailHelper$1 = tailHelper$1
}
$c_Lshapeless_Default$AsRecord$Helper$$anon$3.prototype = new $h_O();
$c_Lshapeless_Default$AsRecord$Helper$$anon$3.prototype.constructor = $c_Lshapeless_Default$AsRecord$Helper$$anon$3;
/** @constructor */
function $h_Lshapeless_Default$AsRecord$Helper$$anon$3() {
  /*<skip>*/
}
$h_Lshapeless_Default$AsRecord$Helper$$anon$3.prototype = $c_Lshapeless_Default$AsRecord$Helper$$anon$3.prototype;
$c_Lshapeless_Default$AsRecord$Helper$$anon$3.prototype.apply__Lshapeless_$colon$colon__Lshapeless_$colon$colon = (function(l) {
  new $c_Lshapeless_labelled$FieldBuilder();
  var this$2 = $n($as_s_Some($n(l).Lshapeless_$colon$colon__f_head));
  var v = this$2.s_Some__f_value;
  var l$1 = $as_Lshapeless_HList($n(this.Lshapeless_Default$AsRecord$Helper$$anon$3__f_tailHelper$1).apply__O__O($n(l).Lshapeless_$colon$colon__f_tail));
  return new $c_Lshapeless_syntax_HListOps(l$1).$colon$colon__O__Lshapeless_$colon$colon(v)
});
$c_Lshapeless_Default$AsRecord$Helper$$anon$3.prototype.apply__O__O = (function(t) {
  return this.apply__Lshapeless_$colon$colon__Lshapeless_$colon$colon($as_Lshapeless_$colon$colon(t))
});
var $d_Lshapeless_Default$AsRecord$Helper$$anon$3 = new $TypeData().initClass({
  Lshapeless_Default$AsRecord$Helper$$anon$3: 0
}, false, "shapeless.Default$AsRecord$Helper$$anon$3", {
  Lshapeless_Default$AsRecord$Helper$$anon$3: 1,
  O: 1,
  Lshapeless_Default$AsRecord$Helper: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Default$AsRecord$Helper$$anon$3.prototype.$classData = $d_Lshapeless_Default$AsRecord$Helper$$anon$3;
/** @constructor */
function $c_Lshapeless_Default$AsRecord$Helper$$anon$4(tailHelper$2) {
  this.Lshapeless_Default$AsRecord$Helper$$anon$4__f_tailHelper$2 = null;
  this.Lshapeless_Default$AsRecord$Helper$$anon$4__f_tailHelper$2 = tailHelper$2
}
$c_Lshapeless_Default$AsRecord$Helper$$anon$4.prototype = new $h_O();
$c_Lshapeless_Default$AsRecord$Helper$$anon$4.prototype.constructor = $c_Lshapeless_Default$AsRecord$Helper$$anon$4;
/** @constructor */
function $h_Lshapeless_Default$AsRecord$Helper$$anon$4() {
  /*<skip>*/
}
$h_Lshapeless_Default$AsRecord$Helper$$anon$4.prototype = $c_Lshapeless_Default$AsRecord$Helper$$anon$4.prototype;
$c_Lshapeless_Default$AsRecord$Helper$$anon$4.prototype.apply__Lshapeless_$colon$colon__Lshapeless_HList = (function(l) {
  return $as_Lshapeless_HList($n(this.Lshapeless_Default$AsRecord$Helper$$anon$4__f_tailHelper$2).apply__O__O($n(l).Lshapeless_$colon$colon__f_tail))
});
$c_Lshapeless_Default$AsRecord$Helper$$anon$4.prototype.apply__O__O = (function(t) {
  return this.apply__Lshapeless_$colon$colon__Lshapeless_HList($as_Lshapeless_$colon$colon(t))
});
var $d_Lshapeless_Default$AsRecord$Helper$$anon$4 = new $TypeData().initClass({
  Lshapeless_Default$AsRecord$Helper$$anon$4: 0
}, false, "shapeless.Default$AsRecord$Helper$$anon$4", {
  Lshapeless_Default$AsRecord$Helper$$anon$4: 1,
  O: 1,
  Lshapeless_Default$AsRecord$Helper: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Default$AsRecord$Helper$$anon$4.prototype.$classData = $d_Lshapeless_Default$AsRecord$Helper$$anon$4;
/** @constructor */
function $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1) {
  /*<skip>*/
}
$c_Lshapeless_DefaultSymbolicLabelling$$anon$1.prototype = new $h_O();
$c_Lshapeless_DefaultSymbolicLabelling$$anon$1.prototype.constructor = $c_Lshapeless_DefaultSymbolicLabelling$$anon$1;
/** @constructor */
function $h_Lshapeless_DefaultSymbolicLabelling$$anon$1() {
  /*<skip>*/
}
$h_Lshapeless_DefaultSymbolicLabelling$$anon$1.prototype = $c_Lshapeless_DefaultSymbolicLabelling$$anon$1.prototype;
var $d_Lshapeless_DefaultSymbolicLabelling$$anon$1 = new $TypeData().initClass({
  Lshapeless_DefaultSymbolicLabelling$$anon$1: 0
}, false, "shapeless.DefaultSymbolicLabelling$$anon$1", {
  Lshapeless_DefaultSymbolicLabelling$$anon$1: 1,
  O: 1,
  Lshapeless_DefaultSymbolicLabelling: 1,
  Lshapeless_package$DepFn0: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_DefaultSymbolicLabelling$$anon$1.prototype.$classData = $d_Lshapeless_DefaultSymbolicLabelling$$anon$1;
function $is_Lshapeless_HList(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lshapeless_HList)))
}
function $as_Lshapeless_HList(obj) {
  return (($is_Lshapeless_HList(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.HList"))
}
function $isArrayOf_Lshapeless_HList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_HList)))
}
function $asArrayOf_Lshapeless_HList(obj, depth) {
  return (($isArrayOf_Lshapeless_HList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.HList;", depth))
}
function $p_Lshapeless_Typeable$__safeSimpleName__jl_Class__T($thiz, erased) {
  try {
    return $n(erased).getSimpleName__T()
  } catch (e) {
    if (false) {
      return $n(erased).getName__T()
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_Lshapeless_Typeable$() {
  this.Lshapeless_Typeable$__f_intTypeable = null;
  this.Lshapeless_Typeable$__f_doubleTypeable = null;
  this.Lshapeless_Typeable$__f_booleanTypeable = null;
  $n_Lshapeless_Typeable$ = this;
  new $c_Lshapeless_Typeable$ValueTypeable($d_jl_Byte.getClassOf(), "Byte");
  new $c_Lshapeless_Typeable$ValueTypeable($d_jl_Short.getClassOf(), "Short");
  new $c_Lshapeless_Typeable$ValueTypeable($d_jl_Character.getClassOf(), "Char");
  this.Lshapeless_Typeable$__f_intTypeable = new $c_Lshapeless_Typeable$ValueTypeable($d_jl_Integer.getClassOf(), "Int");
  new $c_Lshapeless_Typeable$ValueTypeable($d_jl_Long.getClassOf(), "Long");
  new $c_Lshapeless_Typeable$ValueTypeable($d_jl_Float.getClassOf(), "Float");
  this.Lshapeless_Typeable$__f_doubleTypeable = new $c_Lshapeless_Typeable$ValueTypeable($d_jl_Double.getClassOf(), "Double");
  this.Lshapeless_Typeable$__f_booleanTypeable = new $c_Lshapeless_Typeable$ValueTypeable($d_jl_Boolean.getClassOf(), "Boolean");
  new $c_Lshapeless_Typeable$ValueTypeable($d_jl_Void.getClassOf(), "Unit");
  var description = new $c_sjsr_AnonFunction0((() => "Any"));
  var f = new $c_sjsr_AnonFunction1(((value$2) => new $c_s_Some(value$2)));
  new $c_Lshapeless_Typeable$$anon$1(description, f);
  var description$1 = new $c_sjsr_AnonFunction0((() => "AnyVal"));
  var f$1 = new $c_sjsr_AnonFunction1(((t$2) => {
    if ((t$2 !== null)) {
      var $$x2 = $m_Lshapeless_Typeable$();
      var this$5 = $n(t$2);
      var $$x1 = $n($$x2).isValClass__jl_Class__Z($objectGetClass(this$5))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return new $c_s_Some(t$2)
    } else {
      return $m_s_None$()
    }
  }));
  new $c_Lshapeless_Typeable$$anon$1(description$1, f$1);
  var description$2 = new $c_sjsr_AnonFunction0((() => "AnyRef"));
  var f$2 = new $c_sjsr_AnonFunction1(((t$3$2) => {
    if ((t$3$2 === null)) {
      var $$x3 = true
    } else {
      var $$x4 = $m_Lshapeless_Typeable$();
      var this$7 = $n(t$3$2);
      var $$x3 = $n($$x4).isValClass__jl_Class__Z($objectGetClass(this$7))
    };
    if ($$x3) {
      return $m_s_None$()
    } else {
      return new $c_s_Some(t$3$2)
    }
  }));
  new $c_Lshapeless_Typeable$$anon$1(description$2, f$2);
  var description$3 = new $c_sjsr_AnonFunction0((() => "HNil"));
  var f$3 = new $c_sjsr_AnonFunction1(((t$4$2) => (((t$4$2 !== null) && $is_Lshapeless_HNil(t$4$2)) ? new $c_s_Some($as_Lshapeless_HNil(t$4$2)) : $m_s_None$())));
  new $c_Lshapeless_Typeable$$anon$1(description$3, f$3);
  var description$4 = new $c_sjsr_AnonFunction0((() => "CNil"));
  var f$4 = new $c_sjsr_AnonFunction1(((x$11$2) => $m_s_None$()));
  new $c_Lshapeless_Typeable$$anon$1(description$4, f$4)
}
$c_Lshapeless_Typeable$.prototype = new $h_O();
$c_Lshapeless_Typeable$.prototype.constructor = $c_Lshapeless_Typeable$;
/** @constructor */
function $h_Lshapeless_Typeable$() {
  /*<skip>*/
}
$h_Lshapeless_Typeable$.prototype = $c_Lshapeless_Typeable$.prototype;
$c_Lshapeless_Typeable$.prototype.isValClass__jl_Class__Z = (function(clazz) {
  if ((clazz !== null)) {
    var this$1 = $n(clazz);
    var $$x8 = (this$1 === $d_jl_Byte.getClassOf())
  } else {
    var $$x8 = false
  };
  if ($$x8) {
    var $$x7 = true
  } else if ((clazz !== null)) {
    var this$2 = $n(clazz);
    var $$x7 = (this$2 === $d_jl_Short.getClassOf())
  } else {
    var $$x7 = false
  };
  if ($$x7) {
    var $$x6 = true
  } else if ((clazz !== null)) {
    var this$3 = $n(clazz);
    var $$x6 = (this$3 === $d_jl_Integer.getClassOf())
  } else {
    var $$x6 = false
  };
  if ($$x6) {
    var $$x5 = true
  } else if ((clazz !== null)) {
    var this$4 = $n(clazz);
    var $$x5 = (this$4 === $d_jl_Long.getClassOf())
  } else {
    var $$x5 = false
  };
  if ($$x5) {
    var $$x4 = true
  } else if ((clazz !== null)) {
    var this$5 = $n(clazz);
    var $$x4 = (this$5 === $d_jl_Float.getClassOf())
  } else {
    var $$x4 = false
  };
  if ($$x4) {
    var $$x3 = true
  } else if ((clazz !== null)) {
    var this$6 = $n(clazz);
    var $$x3 = (this$6 === $d_jl_Double.getClassOf())
  } else {
    var $$x3 = false
  };
  if ($$x3) {
    var $$x2 = true
  } else if ((clazz !== null)) {
    var this$7 = $n(clazz);
    var $$x2 = (this$7 === $d_jl_Boolean.getClassOf())
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var $$x1 = true
  } else if ((clazz !== null)) {
    var this$8 = $n(clazz);
    var $$x1 = (this$8 === $d_jl_Character.getClassOf())
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return true
  } else if ((clazz !== null)) {
    var this$9 = $n(clazz);
    return (this$9 === $d_jl_Void.getClassOf())
  } else {
    return false
  }
});
$c_Lshapeless_Typeable$.prototype.namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable = (function(erased, name) {
  var f = new $c_sjsr_AnonFunction1(((t$2) => (((t$2 !== null) && $n(erased).isInstance__O__Z(t$2)) ? new $c_s_Some(t$2) : $m_s_None$())));
  return new $c_Lshapeless_Typeable$$anon$1(name, f)
});
$c_Lshapeless_Typeable$.prototype.optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable = (function(castT) {
  var description = new $c_sjsr_AnonFunction0((() => (("Option[" + $n(castT).describe__T()) + "]")));
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    if ((x0$1$2 instanceof $c_s_Option)) {
      var x2 = $as_s_Option(x0$1$2);
      if ($n(x2).isEmpty__Z()) {
        return new $c_s_Some(x2)
      } else {
        var this$3 = $n(x2);
        if (this$3.isEmpty__Z()) {
          return $m_s_None$()
        } else {
          var arg1 = this$3.get__O();
          var this$6 = $n($n(castT).cast__O__s_Option(arg1));
          return (this$6.isEmpty__Z() ? $m_s_None$() : new $c_s_Some((this$6.get__O(), x2)))
        }
      }
    } else {
      return $m_s_None$()
    }
  }));
  return new $c_Lshapeless_Typeable$$anon$1(description, f)
});
$c_Lshapeless_Typeable$.prototype.genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable = (function(mCC, castT) {
  var description = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lshapeless_Typeable$();
    return ((($p_Lshapeless_Typeable$__safeSimpleName__jl_Class__T(this$2, $n(mCC).runtimeClass__jl_Class()) + "[") + $n(castT).describe__T()) + "]")
  }));
  var f = new $c_sjsr_AnonFunction1(((t$2) => {
    if ((t$2 === null)) {
      return $m_s_None$()
    } else if ($n($n(mCC).runtimeClass__jl_Class()).isInstance__O__Z(t$2)) {
      var cc = $as_sc_Iterable(t$2);
      return ($n(cc).forall__F1__Z(new $c_sjsr_AnonFunction1(((x$6$2) => {
        var this$5 = $n($n(castT).cast__O__s_Option(x$6$2));
        return (!this$5.isEmpty__Z())
      }))) ? new $c_s_Some($as_sc_Iterable(t$2)) : $m_s_None$())
    } else {
      return $m_s_None$()
    }
  }));
  return new $c_Lshapeless_Typeable$$anon$1(description, f)
});
$c_Lshapeless_Typeable$.prototype.genMapTypeable__s_$less$colon$less__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable__Lshapeless_Typeable = (function(ev, mM, castK, castV) {
  var description = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lshapeless_Typeable$();
    return ((((($p_Lshapeless_Typeable$__safeSimpleName__jl_Class__T(this$2, $n(mM).runtimeClass__jl_Class()) + "[") + $n(castK).describe__T()) + ", ") + $n(castV).describe__T()) + "]")
  }));
  var f = new $c_sjsr_AnonFunction1(((t$2) => {
    if ((t$2 === null)) {
      return $m_s_None$()
    } else if ($n($n(mM).runtimeClass__jl_Class()).isInstance__O__Z(t$2)) {
      var m = $as_sci_Map(t$2);
      return ($n(m).forall__F1__Z(new $c_sjsr_AnonFunction1(((x$7$2) => {
        var x$7 = $as_T2(x$7$2);
        var this$4 = $m_Lshapeless_Typeable$();
        var castU = $f_Lshapeless_TupleTypeableInstances__tuple2Typeable__Lshapeless_Typeable__Lshapeless_Typeable__Lshapeless_Typeable(this$4, castK, castV);
        var this$6 = $n($n(castU).cast__O__s_Option(x$7));
        return (!this$6.isEmpty__Z())
      }))) ? new $c_s_Some(t$2) : $m_s_None$())
    } else {
      return $m_s_None$()
    }
  }));
  return new $c_Lshapeless_Typeable$$anon$1(description, f)
});
$c_Lshapeless_Typeable$.prototype.namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable = (function(erased, fields, name) {
  var description = new $c_sjsr_AnonFunction0((() => {
    var $$x11 = $n(name).apply__O();
    var $$x10 = $m_s_Predef$();
    $m_sc_ArrayOps$();
    var f = ((x$8$2) => {
      var x$8 = $as_Lshapeless_Typeable(x$8$2);
      return $n(x$8).describe__T()
    });
    var len = $n(fields).u.length;
    var ys = new ($d_T.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((fields !== null)) {
        while ((i < len)) {
          var $$x1 = i;
          var arg1 = $n(fields).get(i);
          ys.set($$x1, f(arg1));
          i = ((1 + i) | 0)
        }
      } else if ((fields instanceof $ac_I)) {
        var x3 = $asArrayOf_I(fields, 1);
        while ((i < len)) {
          var $$x2 = i;
          var arg1$1 = $n(x3).get(i);
          ys.set($$x2, f(arg1$1));
          i = ((1 + i) | 0)
        }
      } else if ((fields instanceof $ac_D)) {
        var x4 = $asArrayOf_D(fields, 1);
        while ((i < len)) {
          var $$x3 = i;
          var arg1$2 = $n(x4).get(i);
          ys.set($$x3, f(arg1$2));
          i = ((1 + i) | 0)
        }
      } else if ((fields instanceof $ac_J)) {
        var x5 = $asArrayOf_J(fields, 1);
        while ((i < len)) {
          var $$x4 = i;
          var t = $n(x5).get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.set($$x4, f(new $c_RTLong(lo, hi)));
          i = ((1 + i) | 0)
        }
      } else if ((fields instanceof $ac_F)) {
        var x6 = $asArrayOf_F(fields, 1);
        while ((i < len)) {
          var $$x5 = i;
          var arg1$3 = $n(x6).get(i);
          ys.set($$x5, f(arg1$3));
          i = ((1 + i) | 0)
        }
      } else if ((fields instanceof $ac_C)) {
        var x7 = $asArrayOf_C(fields, 1);
        while ((i < len)) {
          var $$x6 = i;
          var arg1$4 = $n(x7).get(i);
          ys.set($$x6, f($bC(arg1$4)));
          i = ((1 + i) | 0)
        }
      } else if ((fields instanceof $ac_B)) {
        var x8 = $asArrayOf_B(fields, 1);
        while ((i < len)) {
          var $$x7 = i;
          var arg1$5 = $n(x8).get(i);
          ys.set($$x7, f(arg1$5));
          i = ((1 + i) | 0)
        }
      } else if ((fields instanceof $ac_S)) {
        var x9 = $asArrayOf_S(fields, 1);
        while ((i < len)) {
          var $$x8 = i;
          var arg1$6 = $n(x9).get(i);
          ys.set($$x8, f(arg1$6));
          i = ((1 + i) | 0)
        }
      } else if ((fields instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(fields, 1);
        while ((i < len)) {
          var $$x9 = i;
          var arg1$7 = $n(x10).get(i);
          ys.set($$x9, f(arg1$7));
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(fields)
      }
    };
    var this$5 = $n($n($$x10).wrapRefArray__AO__scm_ArraySeq$ofRef(ys));
    return ((($$x11 + "[") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", ",", "")) + "]")
  }));
  var f$3 = new $c_sjsr_AnonFunction1(((t$2) => {
    if (($d_s_Product.getClassOf().isAssignableFrom__jl_Class__Z(erased) && $n(erased).isInstance__O__Z(t$2))) {
      var c = $as_s_Product(t$2);
      var this$6 = $n($n(c).productIterator__sc_Iterator());
      $m_sci_List$();
      var f$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$6);
      var this$8 = $n(f$1);
      var that = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(fields);
      var this$9 = $n($as_sci_List($f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this$8, that)));
      _return: {
        var these = this$9;
        while ((!$n(these).isEmpty__Z())) {
          var arg1$8 = $n(these).head__O();
          var x0$1 = $as_T2(arg1$8);
          if ((x0$1 === null)) {
            throw new $c_s_MatchError(x0$1)
          };
          var f$2 = $n(x0$1)._1__O();
          var castF = $as_Lshapeless_Typeable($n(x0$1)._2__O());
          var this$10 = $n($n(castF).cast__O__s_Option(f$2));
          if ((!(!this$10.isEmpty__Z()))) {
            var $$x12 = false;
            break _return
          };
          these = $as_sci_List($n(these).tail__O())
        };
        var $$x12 = true
      };
      if ($$x12) {
        return new $c_s_Some(c)
      } else {
        return $m_s_None$()
      }
    } else {
      return $m_s_None$()
    }
  }));
  return new $c_Lshapeless_Typeable$$anon$1(description, f$3)
});
var $d_Lshapeless_Typeable$ = new $TypeData().initClass({
  Lshapeless_Typeable$: 0
}, false, "shapeless.Typeable$", {
  Lshapeless_Typeable$: 1,
  O: 1,
  Lshapeless_TupleTypeableInstances: 1,
  Lshapeless_LowPriorityTypeable: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Typeable$.prototype.$classData = $d_Lshapeless_Typeable$;
var $n_Lshapeless_Typeable$;
function $m_Lshapeless_Typeable$() {
  if ((!$n_Lshapeless_Typeable$)) {
    $n_Lshapeless_Typeable$ = new $c_Lshapeless_Typeable$()
  };
  return $n_Lshapeless_Typeable$
}
/** @constructor */
function $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27() {
  /*<skip>*/
}
$c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27.prototype = new $h_O();
$c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27.prototype.constructor = $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27;
/** @constructor */
function $h_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27() {
  /*<skip>*/
}
$h_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27.prototype = $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27.prototype;
$c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27.prototype.apply__O__O = (function(t) {
  var v = $as_Lshapeless_CNil(t);
  return v
});
var $d_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27 = new $TypeData().initClass({
  Lshapeless_ops_coproduct$ZipWithKeys$$anon$27: 0
}, false, "shapeless.ops.coproduct$ZipWithKeys$$anon$27", {
  Lshapeless_ops_coproduct$ZipWithKeys$$anon$27: 1,
  O: 1,
  Lshapeless_ops_coproduct$ZipWithKeys: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27.prototype.$classData = $d_Lshapeless_ops_coproduct$ZipWithKeys$$anon$27;
/** @constructor */
function $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28(zipWithKeys$1) {
  this.Lshapeless_ops_coproduct$ZipWithKeys$$anon$28__f_zipWithKeys$1 = null;
  this.Lshapeless_ops_coproduct$ZipWithKeys$$anon$28__f_zipWithKeys$1 = zipWithKeys$1
}
$c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28.prototype = new $h_O();
$c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28.prototype.constructor = $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28;
/** @constructor */
function $h_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28() {
  /*<skip>*/
}
$h_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28.prototype = $c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28.prototype;
$c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28.prototype.apply__Lshapeless_$colon$plus$colon__Lshapeless_$colon$plus$colon = (function(v) {
  if ((v instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(v);
    var vh = $n(x2).Lshapeless_Inl__f_head;
    return new $c_Lshapeless_Inl((new $c_Lshapeless_labelled$FieldBuilder(), vh))
  } else if ((v instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(v);
    var vt = $n(x3).Lshapeless_Inr__f_tail;
    return new $c_Lshapeless_Inr($as_Lshapeless_Coproduct($n(this.Lshapeless_ops_coproduct$ZipWithKeys$$anon$28__f_zipWithKeys$1).apply__O__O(vt)))
  } else {
    throw new $c_s_MatchError(v)
  }
});
$c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28.prototype.apply__O__O = (function(t) {
  return this.apply__Lshapeless_$colon$plus$colon__Lshapeless_$colon$plus$colon($as_Lshapeless_$colon$plus$colon(t))
});
var $d_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28 = new $TypeData().initClass({
  Lshapeless_ops_coproduct$ZipWithKeys$$anon$28: 0
}, false, "shapeless.ops.coproduct$ZipWithKeys$$anon$28", {
  Lshapeless_ops_coproduct$ZipWithKeys$$anon$28: 1,
  O: 1,
  Lshapeless_ops_coproduct$ZipWithKeys: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28.prototype.$classData = $d_Lshapeless_ops_coproduct$ZipWithKeys$$anon$28;
/** @constructor */
function $c_Lshapeless_ops_hlist$Selector$$anon$62() {
  /*<skip>*/
}
$c_Lshapeless_ops_hlist$Selector$$anon$62.prototype = new $h_O();
$c_Lshapeless_ops_hlist$Selector$$anon$62.prototype.constructor = $c_Lshapeless_ops_hlist$Selector$$anon$62;
/** @constructor */
function $h_Lshapeless_ops_hlist$Selector$$anon$62() {
  /*<skip>*/
}
$h_Lshapeless_ops_hlist$Selector$$anon$62.prototype = $c_Lshapeless_ops_hlist$Selector$$anon$62.prototype;
$c_Lshapeless_ops_hlist$Selector$$anon$62.prototype.apply__Lshapeless_$colon$colon__O = (function(l) {
  return $n(l).Lshapeless_$colon$colon__f_head
});
var $d_Lshapeless_ops_hlist$Selector$$anon$62 = new $TypeData().initClass({
  Lshapeless_ops_hlist$Selector$$anon$62: 0
}, false, "shapeless.ops.hlist$Selector$$anon$62", {
  Lshapeless_ops_hlist$Selector$$anon$62: 1,
  O: 1,
  Lshapeless_ops_hlist$Selector: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_hlist$Selector$$anon$62.prototype.$classData = $d_Lshapeless_ops_hlist$Selector$$anon$62;
/** @constructor */
function $c_Lshapeless_ops_hlist$Selector$$anon$63(st$2) {
  this.Lshapeless_ops_hlist$Selector$$anon$63__f_st$2 = null;
  this.Lshapeless_ops_hlist$Selector$$anon$63__f_st$2 = st$2
}
$c_Lshapeless_ops_hlist$Selector$$anon$63.prototype = new $h_O();
$c_Lshapeless_ops_hlist$Selector$$anon$63.prototype.constructor = $c_Lshapeless_ops_hlist$Selector$$anon$63;
/** @constructor */
function $h_Lshapeless_ops_hlist$Selector$$anon$63() {
  /*<skip>*/
}
$h_Lshapeless_ops_hlist$Selector$$anon$63.prototype = $c_Lshapeless_ops_hlist$Selector$$anon$63.prototype;
$c_Lshapeless_ops_hlist$Selector$$anon$63.prototype.apply__Lshapeless_$colon$colon__O = (function(l) {
  var this$1 = $n(this.Lshapeless_ops_hlist$Selector$$anon$63__f_st$2);
  var t = $n(l).Lshapeless_$colon$colon__f_tail;
  return this$1.apply__Lshapeless_$colon$colon__O($as_Lshapeless_$colon$colon(t))
});
var $d_Lshapeless_ops_hlist$Selector$$anon$63 = new $TypeData().initClass({
  Lshapeless_ops_hlist$Selector$$anon$63: 0
}, false, "shapeless.ops.hlist$Selector$$anon$63", {
  Lshapeless_ops_hlist$Selector$$anon$63: 1,
  O: 1,
  Lshapeless_ops_hlist$Selector: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_hlist$Selector$$anon$63.prototype.$classData = $d_Lshapeless_ops_hlist$Selector$$anon$63;
/** @constructor */
function $c_Lshapeless_ops_hlist$ToTraversable$$anon$47(cbf$1) {
  this.Lshapeless_ops_hlist$ToTraversable$$anon$47__f_cbf$1 = null;
  this.Lshapeless_ops_hlist$ToTraversable$$anon$47__f_cbf$1 = cbf$1
}
$c_Lshapeless_ops_hlist$ToTraversable$$anon$47.prototype = new $h_O();
$c_Lshapeless_ops_hlist$ToTraversable$$anon$47.prototype.constructor = $c_Lshapeless_ops_hlist$ToTraversable$$anon$47;
/** @constructor */
function $h_Lshapeless_ops_hlist$ToTraversable$$anon$47() {
  /*<skip>*/
}
$h_Lshapeless_ops_hlist$ToTraversable$$anon$47.prototype = $c_Lshapeless_ops_hlist$ToTraversable$$anon$47.prototype;
$c_Lshapeless_ops_hlist$ToTraversable$$anon$47.prototype.builder__scm_Builder = (function() {
  return $n(this.Lshapeless_ops_hlist$ToTraversable$$anon$47__f_cbf$1).newBuilder__scm_Builder()
});
$c_Lshapeless_ops_hlist$ToTraversable$$anon$47.prototype.append__Lshapeless_HList__scm_Builder__F1__V = (function(l, b, f) {
  $as_Lshapeless_HNil(l)
});
var $d_Lshapeless_ops_hlist$ToTraversable$$anon$47 = new $TypeData().initClass({
  Lshapeless_ops_hlist$ToTraversable$$anon$47: 0
}, false, "shapeless.ops.hlist$ToTraversable$$anon$47", {
  Lshapeless_ops_hlist$ToTraversable$$anon$47: 1,
  O: 1,
  Lshapeless_ops_hlist$ToTraversable: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_hlist$ToTraversable$$anon$47.prototype.$classData = $d_Lshapeless_ops_hlist$ToTraversable$$anon$47;
/** @constructor */
function $c_Lshapeless_ops_hlist$ToTraversable$$anon$48(cbf$2, ev$1) {
  this.Lshapeless_ops_hlist$ToTraversable$$anon$48__f_cbf$2 = null;
  this.Lshapeless_ops_hlist$ToTraversable$$anon$48__f_ev$1 = null;
  this.Lshapeless_ops_hlist$ToTraversable$$anon$48__f_cbf$2 = cbf$2;
  this.Lshapeless_ops_hlist$ToTraversable$$anon$48__f_ev$1 = ev$1
}
$c_Lshapeless_ops_hlist$ToTraversable$$anon$48.prototype = new $h_O();
$c_Lshapeless_ops_hlist$ToTraversable$$anon$48.prototype.constructor = $c_Lshapeless_ops_hlist$ToTraversable$$anon$48;
/** @constructor */
function $h_Lshapeless_ops_hlist$ToTraversable$$anon$48() {
  /*<skip>*/
}
$h_Lshapeless_ops_hlist$ToTraversable$$anon$48.prototype = $c_Lshapeless_ops_hlist$ToTraversable$$anon$48.prototype;
$c_Lshapeless_ops_hlist$ToTraversable$$anon$48.prototype.builder__scm_Builder = (function() {
  return $n(this.Lshapeless_ops_hlist$ToTraversable$$anon$48__f_cbf$2).newBuilder__scm_Builder()
});
$c_Lshapeless_ops_hlist$ToTraversable$$anon$48.prototype.append__Lshapeless_$colon$colon__scm_Builder__F1__V = (function(l, b, f) {
  var this$2 = $n(b);
  var $$x1 = $n(f);
  $n(this.Lshapeless_ops_hlist$ToTraversable$$anon$48__f_ev$1);
  var x = $n(l).Lshapeless_$colon$colon__f_head;
  var elem = $n($$x1).apply__O__O(x);
  this$2.addOne__O__scm_Growable(elem)
});
$c_Lshapeless_ops_hlist$ToTraversable$$anon$48.prototype.append__Lshapeless_HList__scm_Builder__F1__V = (function(l, b, f) {
  this.append__Lshapeless_$colon$colon__scm_Builder__F1__V($as_Lshapeless_$colon$colon(l), b, f)
});
var $d_Lshapeless_ops_hlist$ToTraversable$$anon$48 = new $TypeData().initClass({
  Lshapeless_ops_hlist$ToTraversable$$anon$48: 0
}, false, "shapeless.ops.hlist$ToTraversable$$anon$48", {
  Lshapeless_ops_hlist$ToTraversable$$anon$48: 1,
  O: 1,
  Lshapeless_ops_hlist$ToTraversable: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_hlist$ToTraversable$$anon$48.prototype.$classData = $d_Lshapeless_ops_hlist$ToTraversable$$anon$48;
/** @constructor */
function $c_Lshapeless_ops_hlist$ToTraversable$$anon$49(cbf$3, u$2, tttvs$1) {
  this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_cbf$3 = null;
  this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_u$2 = null;
  this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_tttvs$1 = null;
  this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_cbf$3 = cbf$3;
  this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_u$2 = u$2;
  this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_tttvs$1 = tttvs$1
}
$c_Lshapeless_ops_hlist$ToTraversable$$anon$49.prototype = new $h_O();
$c_Lshapeless_ops_hlist$ToTraversable$$anon$49.prototype.constructor = $c_Lshapeless_ops_hlist$ToTraversable$$anon$49;
/** @constructor */
function $h_Lshapeless_ops_hlist$ToTraversable$$anon$49() {
  /*<skip>*/
}
$h_Lshapeless_ops_hlist$ToTraversable$$anon$49.prototype = $c_Lshapeless_ops_hlist$ToTraversable$$anon$49.prototype;
$c_Lshapeless_ops_hlist$ToTraversable$$anon$49.prototype.builder__scm_Builder = (function() {
  return $n(this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_cbf$3).newBuilder__scm_Builder()
});
$c_Lshapeless_ops_hlist$ToTraversable$$anon$49.prototype.append__Lshapeless_$colon$colon__scm_Builder__F1__V = (function(l, b, f) {
  var this$2 = $n(b);
  var $$x1 = $n(f);
  $n(this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_u$2);
  var a = $n(l).Lshapeless_$colon$colon__f_head;
  var elem = $n($$x1).apply__O__O(a);
  this$2.addOne__O__scm_Growable(elem);
  $n(this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_tttvs$1).append__Lshapeless_HList__scm_Builder__F1__V($n(l).Lshapeless_$colon$colon__f_tail, b, $n(f).compose__F1__F1(new $c_sjsr_AnonFunction1(((b$2$2) => {
    $n(this.Lshapeless_ops_hlist$ToTraversable$$anon$49__f_u$2);
    return b$2$2
  }))))
});
$c_Lshapeless_ops_hlist$ToTraversable$$anon$49.prototype.append__Lshapeless_HList__scm_Builder__F1__V = (function(l, b, f) {
  this.append__Lshapeless_$colon$colon__scm_Builder__F1__V($as_Lshapeless_$colon$colon(l), b, f)
});
var $d_Lshapeless_ops_hlist$ToTraversable$$anon$49 = new $TypeData().initClass({
  Lshapeless_ops_hlist$ToTraversable$$anon$49: 0
}, false, "shapeless.ops.hlist$ToTraversable$$anon$49", {
  Lshapeless_ops_hlist$ToTraversable$$anon$49: 1,
  O: 1,
  Lshapeless_ops_hlist$ToTraversable: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_hlist$ToTraversable$$anon$49.prototype.$classData = $d_Lshapeless_ops_hlist$ToTraversable$$anon$49;
/** @constructor */
function $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$160() {
  /*<skip>*/
}
$c_Lshapeless_ops_hlist$ZipWithKeys$$anon$160.prototype = new $h_O();
$c_Lshapeless_ops_hlist$ZipWithKeys$$anon$160.prototype.constructor = $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$160;
/** @constructor */
function $h_Lshapeless_ops_hlist$ZipWithKeys$$anon$160() {
  /*<skip>*/
}
$h_Lshapeless_ops_hlist$ZipWithKeys$$anon$160.prototype = $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$160.prototype;
$c_Lshapeless_ops_hlist$ZipWithKeys$$anon$160.prototype.apply__O__O = (function(t) {
  $as_Lshapeless_HNil(t);
  return $m_Lshapeless_HNil$()
});
var $d_Lshapeless_ops_hlist$ZipWithKeys$$anon$160 = new $TypeData().initClass({
  Lshapeless_ops_hlist$ZipWithKeys$$anon$160: 0
}, false, "shapeless.ops.hlist$ZipWithKeys$$anon$160", {
  Lshapeless_ops_hlist$ZipWithKeys$$anon$160: 1,
  O: 1,
  Lshapeless_ops_hlist$ZipWithKeys: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_hlist$ZipWithKeys$$anon$160.prototype.$classData = $d_Lshapeless_ops_hlist$ZipWithKeys$$anon$160;
/** @constructor */
function $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1) {
  this.Lshapeless_ops_hlist$ZipWithKeys$$anon$161__f_zipWithKeys$1 = null;
  this.Lshapeless_ops_hlist$ZipWithKeys$$anon$161__f_zipWithKeys$1 = zipWithKeys$1
}
$c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161.prototype = new $h_O();
$c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161.prototype.constructor = $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161;
/** @constructor */
function $h_Lshapeless_ops_hlist$ZipWithKeys$$anon$161() {
  /*<skip>*/
}
$h_Lshapeless_ops_hlist$ZipWithKeys$$anon$161.prototype = $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161.prototype;
$c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161.prototype.apply__Lshapeless_$colon$colon__Lshapeless_$colon$colon = (function(v) {
  new $c_Lshapeless_labelled$FieldBuilder();
  var v$1 = $n(v).Lshapeless_$colon$colon__f_head;
  var l = $as_Lshapeless_HList($n(this.Lshapeless_ops_hlist$ZipWithKeys$$anon$161__f_zipWithKeys$1).apply__O__O($n(v).Lshapeless_$colon$colon__f_tail));
  return new $c_Lshapeless_syntax_HListOps(l).$colon$colon__O__Lshapeless_$colon$colon(v$1)
});
$c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161.prototype.apply__O__O = (function(t) {
  return this.apply__Lshapeless_$colon$colon__Lshapeless_$colon$colon($as_Lshapeless_$colon$colon(t))
});
var $d_Lshapeless_ops_hlist$ZipWithKeys$$anon$161 = new $TypeData().initClass({
  Lshapeless_ops_hlist$ZipWithKeys$$anon$161: 0
}, false, "shapeless.ops.hlist$ZipWithKeys$$anon$161", {
  Lshapeless_ops_hlist$ZipWithKeys$$anon$161: 1,
  O: 1,
  Lshapeless_ops_hlist$ZipWithKeys: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161.prototype.$classData = $d_Lshapeless_ops_hlist$ZipWithKeys$$anon$161;
/** @constructor */
function $c_Lshapeless_ops_record_Keys$$anon$28() {
  /*<skip>*/
}
$c_Lshapeless_ops_record_Keys$$anon$28.prototype = new $h_O();
$c_Lshapeless_ops_record_Keys$$anon$28.prototype.constructor = $c_Lshapeless_ops_record_Keys$$anon$28;
/** @constructor */
function $h_Lshapeless_ops_record_Keys$$anon$28() {
  /*<skip>*/
}
$h_Lshapeless_ops_record_Keys$$anon$28.prototype = $c_Lshapeless_ops_record_Keys$$anon$28.prototype;
$c_Lshapeless_ops_record_Keys$$anon$28.prototype.apply__O = (function() {
  return $m_Lshapeless_HNil$()
});
var $d_Lshapeless_ops_record_Keys$$anon$28 = new $TypeData().initClass({
  Lshapeless_ops_record_Keys$$anon$28: 0
}, false, "shapeless.ops.record.Keys$$anon$28", {
  Lshapeless_ops_record_Keys$$anon$28: 1,
  O: 1,
  Lshapeless_ops_record_Keys: 1,
  Lshapeless_package$DepFn0: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_record_Keys$$anon$28.prototype.$classData = $d_Lshapeless_ops_record_Keys$$anon$28;
/** @constructor */
function $c_Lshapeless_ops_record_Keys$$anon$29(wk$1, kt$1) {
  this.Lshapeless_ops_record_Keys$$anon$29__f_wk$1 = null;
  this.Lshapeless_ops_record_Keys$$anon$29__f_kt$1 = null;
  this.Lshapeless_ops_record_Keys$$anon$29__f_wk$1 = wk$1;
  this.Lshapeless_ops_record_Keys$$anon$29__f_kt$1 = kt$1
}
$c_Lshapeless_ops_record_Keys$$anon$29.prototype = new $h_O();
$c_Lshapeless_ops_record_Keys$$anon$29.prototype.constructor = $c_Lshapeless_ops_record_Keys$$anon$29;
/** @constructor */
function $h_Lshapeless_ops_record_Keys$$anon$29() {
  /*<skip>*/
}
$h_Lshapeless_ops_record_Keys$$anon$29.prototype = $c_Lshapeless_ops_record_Keys$$anon$29.prototype;
$c_Lshapeless_ops_record_Keys$$anon$29.prototype.apply__Lshapeless_$colon$colon = (function() {
  var rassoc$22 = $n(this.Lshapeless_ops_record_Keys$$anon$29__f_wk$1).value__O();
  var l = $as_Lshapeless_HList($n(this.Lshapeless_ops_record_Keys$$anon$29__f_kt$1).apply__O());
  return new $c_Lshapeless_syntax_HListOps(l).$colon$colon__O__Lshapeless_$colon$colon(rassoc$22)
});
$c_Lshapeless_ops_record_Keys$$anon$29.prototype.apply__O = (function() {
  return this.apply__Lshapeless_$colon$colon()
});
var $d_Lshapeless_ops_record_Keys$$anon$29 = new $TypeData().initClass({
  Lshapeless_ops_record_Keys$$anon$29: 0
}, false, "shapeless.ops.record.Keys$$anon$29", {
  Lshapeless_ops_record_Keys$$anon$29: 1,
  O: 1,
  Lshapeless_ops_record_Keys: 1,
  Lshapeless_package$DepFn0: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_record_Keys$$anon$29.prototype.$classData = $d_Lshapeless_ops_record_Keys$$anon$29;
/** @constructor */
function $c_Lshapeless_ops_record_ToMap$$anon$39(wk$3) {
  this.Lshapeless_ops_record_ToMap$$anon$39__f_wk$3 = null;
  this.Lshapeless_ops_record_ToMap$$anon$39__f_wk$3 = wk$3
}
$c_Lshapeless_ops_record_ToMap$$anon$39.prototype = new $h_O();
$c_Lshapeless_ops_record_ToMap$$anon$39.prototype.constructor = $c_Lshapeless_ops_record_ToMap$$anon$39;
/** @constructor */
function $h_Lshapeless_ops_record_ToMap$$anon$39() {
  /*<skip>*/
}
$h_Lshapeless_ops_record_ToMap$$anon$39.prototype = $c_Lshapeless_ops_record_ToMap$$anon$39.prototype;
$c_Lshapeless_ops_record_ToMap$$anon$39.prototype.apply__Lshapeless_$colon$colon__sci_Map = (function(l) {
  var this$6 = $n($m_s_Predef$().s_Predef$__f_Map);
  var self = $n(this.Lshapeless_ops_record_ToMap$$anon$39__f_wk$3).value__O();
  var y = $n(l).Lshapeless_$colon$colon__f_head;
  var array = [$ct_T2__O__O__(new $c_T2(), self, y)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return this$6.from__sc_IterableOnce__sci_Map(elems)
});
var $d_Lshapeless_ops_record_ToMap$$anon$39 = new $TypeData().initClass({
  Lshapeless_ops_record_ToMap$$anon$39: 0
}, false, "shapeless.ops.record.ToMap$$anon$39", {
  Lshapeless_ops_record_ToMap$$anon$39: 1,
  O: 1,
  Lshapeless_ops_record_ToMap: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_record_ToMap$$anon$39.prototype.$classData = $d_Lshapeless_ops_record_ToMap$$anon$39;
/** @constructor */
function $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$4) {
  this.Lshapeless_ops_record_ToMap$$anon$40__f_tailToMap$1 = null;
  this.Lshapeless_ops_record_ToMap$$anon$40__f_keyLub$1 = null;
  this.Lshapeless_ops_record_ToMap$$anon$40__f_valueLub$1 = null;
  this.Lshapeless_ops_record_ToMap$$anon$40__f_wk$4 = null;
  this.Lshapeless_ops_record_ToMap$$anon$40__f_tailToMap$1 = tailToMap$1;
  this.Lshapeless_ops_record_ToMap$$anon$40__f_keyLub$1 = keyLub$1;
  this.Lshapeless_ops_record_ToMap$$anon$40__f_valueLub$1 = valueLub$1;
  this.Lshapeless_ops_record_ToMap$$anon$40__f_wk$4 = wk$4
}
$c_Lshapeless_ops_record_ToMap$$anon$40.prototype = new $h_O();
$c_Lshapeless_ops_record_ToMap$$anon$40.prototype.constructor = $c_Lshapeless_ops_record_ToMap$$anon$40;
/** @constructor */
function $h_Lshapeless_ops_record_ToMap$$anon$40() {
  /*<skip>*/
}
$h_Lshapeless_ops_record_ToMap$$anon$40.prototype = $c_Lshapeless_ops_record_ToMap$$anon$40.prototype;
$c_Lshapeless_ops_record_ToMap$$anon$40.prototype.apply__Lshapeless_$colon$colon__sci_Map = (function(l) {
  var this$1 = $n(this.Lshapeless_ops_record_ToMap$$anon$40__f_tailToMap$1);
  var t = $n(l).Lshapeless_$colon$colon__f_tail;
  var $$x1 = $as_sci_MapOps($n(this$1.apply__Lshapeless_$colon$colon__sci_Map($as_Lshapeless_$colon$colon(t))).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = $n(x0$1)._1__O();
      var v = $n(x0$1)._2__O();
      $n(this.Lshapeless_ops_record_ToMap$$anon$40__f_keyLub$1);
      $n(this.Lshapeless_ops_record_ToMap$$anon$40__f_valueLub$1);
      return $ct_T2__O__O__(new $c_T2(), k, v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))));
  $n(this.Lshapeless_ops_record_ToMap$$anon$40__f_keyLub$1);
  var a = $n(this.Lshapeless_ops_record_ToMap$$anon$40__f_wk$4).value__O();
  $n(this.Lshapeless_ops_record_ToMap$$anon$40__f_valueLub$1);
  var a$1 = $n(l).Lshapeless_$colon$colon__f_head;
  return $as_sci_Map($n($$x1).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), a, a$1)))
});
var $d_Lshapeless_ops_record_ToMap$$anon$40 = new $TypeData().initClass({
  Lshapeless_ops_record_ToMap$$anon$40: 0
}, false, "shapeless.ops.record.ToMap$$anon$40", {
  Lshapeless_ops_record_ToMap$$anon$40: 1,
  O: 1,
  Lshapeless_ops_record_ToMap: 1,
  Lshapeless_package$DepFn1: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_ops_record_ToMap$$anon$40.prototype.$classData = $d_Lshapeless_ops_record_ToMap$$anon$40;
/** @constructor */
function $c_Lcats_Eval$() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
  this.Lcats_Eval$__f_True = null;
  this.Lcats_Eval$__f_False = null;
  $ct_Lcats_EvalInstances__(this);
  $n_Lcats_Eval$ = this;
  new $c_Lcats_Now((void 0));
  this.Lcats_Eval$__f_True = new $c_Lcats_Now(true);
  this.Lcats_Eval$__f_False = new $c_Lcats_Now(false);
  new $c_Lcats_Now(0);
  new $c_Lcats_Now(1)
}
$c_Lcats_Eval$.prototype = new $h_Lcats_EvalInstances();
$c_Lcats_Eval$.prototype.constructor = $c_Lcats_Eval$;
/** @constructor */
function $h_Lcats_Eval$() {
  /*<skip>*/
}
$h_Lcats_Eval$.prototype = $c_Lcats_Eval$.prototype;
var $d_Lcats_Eval$ = new $TypeData().initClass({
  Lcats_Eval$: 0
}, false, "cats.Eval$", {
  Lcats_Eval$: 1,
  Lcats_EvalInstances: 1,
  Lcats_EvalInstances0: 1,
  Lcats_EvalInstances1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$.prototype.$classData = $d_Lcats_Eval$;
var $n_Lcats_Eval$;
function $m_Lcats_Eval$() {
  if ((!$n_Lcats_Eval$)) {
    $n_Lcats_Eval$ = new $c_Lcats_Eval$()
  };
  return $n_Lcats_Eval$
}
/** @constructor */
function $c_Lcats_EvalInstances$$anon$8(outer) {
  /*<skip>*/
}
$c_Lcats_EvalInstances$$anon$8.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$8.prototype.constructor = $c_Lcats_EvalInstances$$anon$8;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$8() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$8.prototype = $c_Lcats_EvalInstances$$anon$8.prototype;
var $d_Lcats_EvalInstances$$anon$8 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$8: 0
}, false, "cats.EvalInstances$$anon$8", {
  Lcats_EvalInstances$$anon$8: 1,
  O: 1,
  Lcats_Reducible: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_EvalInstances$$anon$8.prototype.$classData = $d_Lcats_EvalInstances$$anon$8;
function $ct_Lcats_NonEmptyReducible__Lcats_Foldable__($thiz, G) {
  return $thiz
}
/** @constructor */
function $c_Lcats_NonEmptyReducible() {
  /*<skip>*/
}
$c_Lcats_NonEmptyReducible.prototype = new $h_O();
$c_Lcats_NonEmptyReducible.prototype.constructor = $c_Lcats_NonEmptyReducible;
/** @constructor */
function $h_Lcats_NonEmptyReducible() {
  /*<skip>*/
}
$h_Lcats_NonEmptyReducible.prototype = $c_Lcats_NonEmptyReducible.prototype;
function $p_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O($thiz, self, current) {
  while (true) {
    var rc13 = false;
    var x4 = null;
    var x1 = self;
    if ((x1 instanceof $c_Lcats_data_AndThen$Single)) {
      var x2 = $as_Lcats_data_AndThen$Single(x1);
      var f = $n(x2).Lcats_data_AndThen$Single__f_f;
      return $n(f).apply__O__O(current)
    };
    if ((x1 instanceof $c_Lcats_data_AndThen$Concat)) {
      rc13 = true;
      x4 = $as_Lcats_data_AndThen$Concat(x1);
      var p5 = $n(x4).Lcats_data_AndThen$Concat__f_left;
      var right = $n(x4).Lcats_data_AndThen$Concat__f_right;
      if ((p5 instanceof $c_Lcats_data_AndThen$Single)) {
        var x6 = $as_Lcats_data_AndThen$Single(p5);
        var f$2 = $n(x6).Lcats_data_AndThen$Single__f_f;
        var temp$current = $n(f$2).apply__O__O(current);
        self = right;
        current = temp$current;
        continue
      }
    };
    if (rc13) {
      var left = $n(x4).Lcats_data_AndThen$Concat__f_left;
      var right$2 = $n(x4).Lcats_data_AndThen$Concat__f_right;
      if ((left instanceof $c_Lcats_data_AndThen$Concat)) {
        var x9 = $as_Lcats_data_AndThen$Concat(left);
        var this$1 = $n(x9);
        self = $p_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(this$1, this$1, right$2);
        continue
      }
    };
    throw new $c_s_MatchError(x1)
  }
}
function $p_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen($thiz, left, right) {
  while (true) {
    var x1 = left;
    if ((x1 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x2 = $as_Lcats_data_AndThen$Concat(x1);
      var left1 = $n(x2).Lcats_data_AndThen$Concat__f_left;
      var right1 = $n(x2).Lcats_data_AndThen$Concat__f_right;
      var temp$right = new $c_Lcats_data_AndThen$Concat(right1, right);
      left = left1;
      right = temp$right
    } else {
      return new $c_Lcats_data_AndThen$Concat(x1, right)
    }
  }
}
/** @constructor */
function $c_Lcats_data_AndThen() {
  /*<skip>*/
}
$c_Lcats_data_AndThen.prototype = new $h_O();
$c_Lcats_data_AndThen.prototype.constructor = $c_Lcats_data_AndThen;
/** @constructor */
function $h_Lcats_data_AndThen() {
  /*<skip>*/
}
$h_Lcats_data_AndThen.prototype = $c_Lcats_data_AndThen.prototype;
$c_Lcats_data_AndThen.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($p_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(this, this, v1))
});
$c_Lcats_data_AndThen.prototype.apply__O__O = (function(a) {
  return $p_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(this, this, a)
});
$c_Lcats_data_AndThen.prototype.andThen__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    var x2 = $as_Lcats_data_AndThen(g);
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(this, x2)
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x2$2 = $as_Lcats_data_AndThen$Single(this);
      var f = $n(x2$2).Lcats_data_AndThen$Single__f_f;
      var index = $n(x2$2).Lcats_data_AndThen$Single__f_index;
      if ((index < 128)) {
        return new $c_Lcats_data_AndThen$Single($n(f).andThen__F1__F1(g), ((1 + index) | 0))
      }
    };
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x3 = $as_Lcats_data_AndThen$Concat(this);
      var left = $n(x3).Lcats_data_AndThen$Concat__f_left;
      var p4 = $n(x3).Lcats_data_AndThen$Concat__f_right;
      if ((p4 instanceof $c_Lcats_data_AndThen$Single)) {
        var x5 = $as_Lcats_data_AndThen$Single(p4);
        var f$2 = $n(x5).Lcats_data_AndThen$Single__f_f;
        var index$2 = $n(x5).Lcats_data_AndThen$Single__f_index;
        if ((index$2 < 128)) {
          return new $c_Lcats_data_AndThen$Concat(left, new $c_Lcats_data_AndThen$Single($n(f$2).andThen__F1__F1(g), ((1 + index$2) | 0)))
        }
      }
    };
    return new $c_Lcats_data_AndThen$Concat(this, new $c_Lcats_data_AndThen$Single(g, 0))
  }
});
$c_Lcats_data_AndThen.prototype.compose__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    var x2 = $as_Lcats_data_AndThen(g);
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(x2, this)
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x2$2 = $as_Lcats_data_AndThen$Single(this);
      var f = $n(x2$2).Lcats_data_AndThen$Single__f_f;
      var index = $n(x2$2).Lcats_data_AndThen$Single__f_index;
      if ((index < 128)) {
        return new $c_Lcats_data_AndThen$Single($n(f).compose__F1__F1(g), ((1 + index) | 0))
      }
    };
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x3 = $as_Lcats_data_AndThen$Concat(this);
      var p4 = $n(x3).Lcats_data_AndThen$Concat__f_left;
      var right = $n(x3).Lcats_data_AndThen$Concat__f_right;
      if ((p4 instanceof $c_Lcats_data_AndThen$Single)) {
        var x5 = $as_Lcats_data_AndThen$Single(p4);
        var f$2 = $n(x5).Lcats_data_AndThen$Single__f_f;
        var index$2 = $n(x5).Lcats_data_AndThen$Single__f_index;
        if ((index$2 < 128)) {
          return new $c_Lcats_data_AndThen$Concat(new $c_Lcats_data_AndThen$Single($n(f$2).compose__F1__F1(g), ((1 + index$2) | 0)), right)
        }
      }
    };
    return new $c_Lcats_data_AndThen$Concat(new $c_Lcats_data_AndThen$Single(g, 0), this)
  }
});
$c_Lcats_data_AndThen.prototype.toString__T = (function() {
  return ("AndThen$" + $systemIdentityHashCode(this))
});
$c_Lcats_data_AndThen.prototype.compose__F1__F1 = (function(g) {
  return this.compose__F1__Lcats_data_AndThen(g)
});
$c_Lcats_data_AndThen.prototype.andThen__F1__F1 = (function(g) {
  return this.andThen__F1__Lcats_data_AndThen(g)
});
function $as_Lcats_data_AndThen(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen"))
}
function $isArrayOf_Lcats_data_AndThen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen)))
}
function $asArrayOf_Lcats_data_AndThen(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen;", depth))
}
/** @constructor */
function $c_Lcats_data_NonEmptyList(head, tail) {
  this.Lcats_data_NonEmptyList__f_head = null;
  this.Lcats_data_NonEmptyList__f_tail = null;
  this.Lcats_data_NonEmptyList__f_head = head;
  this.Lcats_data_NonEmptyList__f_tail = tail
}
$c_Lcats_data_NonEmptyList.prototype = new $h_O();
$c_Lcats_data_NonEmptyList.prototype.constructor = $c_Lcats_data_NonEmptyList;
/** @constructor */
function $h_Lcats_data_NonEmptyList() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyList.prototype = $c_Lcats_data_NonEmptyList.prototype;
$c_Lcats_data_NonEmptyList.prototype.toList__sci_List = (function() {
  var rassoc$1 = this.Lcats_data_NonEmptyList__f_head;
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_sci_$colon$colon(rassoc$1, this$1)
});
$c_Lcats_data_NonEmptyList.prototype.map__F1__Lcats_data_NonEmptyList = (function(f) {
  return new $c_Lcats_data_NonEmptyList($n(f).apply__O__O(this.Lcats_data_NonEmptyList__f_head), $n(this.Lcats_data_NonEmptyList__f_tail).map__F1__sci_List(f))
});
$c_Lcats_data_NonEmptyList.prototype.concat__sci_List__Lcats_data_NonEmptyList = (function(other) {
  var $$x1 = this.Lcats_data_NonEmptyList__f_head;
  var rassoc$3 = this.Lcats_data_NonEmptyList__f_tail;
  return new $c_Lcats_data_NonEmptyList($$x1, $n(other).$colon$colon$colon__sci_List__sci_List(rassoc$3))
});
$c_Lcats_data_NonEmptyList.prototype.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList = (function(other) {
  var $$x1 = this.Lcats_data_NonEmptyList__f_head;
  var rassoc$4 = this.Lcats_data_NonEmptyList__f_tail;
  return new $c_Lcats_data_NonEmptyList($$x1, $n($n(other).toList__sci_List()).$colon$colon$colon__sci_List__sci_List(rassoc$4))
});
$c_Lcats_data_NonEmptyList.prototype.flatMap__F1__Lcats_data_NonEmptyList = (function(f) {
  var this$2 = $n($as_Lcats_data_NonEmptyList($n(f).apply__O__O(this.Lcats_data_NonEmptyList__f_head)));
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = $n(rest).head__O();
    var it = $n($n($as_Lcats_data_NonEmptyList($n(f).apply__O__O(arg1))).toList__sci_List()).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        $n(t).sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest = $as_sci_List($n(rest).tail__O())
  };
  var l = ((h === null) ? $m_sci_Nil$() : h);
  return this$2.concat__sci_List__Lcats_data_NonEmptyList(l)
});
$c_Lcats_data_NonEmptyList.prototype.toString__T = (function() {
  return ("NonEmpty" + this.toList__sci_List())
});
$c_Lcats_data_NonEmptyList.prototype.productPrefix__T = (function() {
  return "NonEmptyList"
});
$c_Lcats_data_NonEmptyList.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_data_NonEmptyList.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcats_data_NonEmptyList__f_head;
      break
    }
    case 1: {
      return this.Lcats_data_NonEmptyList__f_tail;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcats_data_NonEmptyList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcats_data_NonEmptyList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_NonEmptyList.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcats_data_NonEmptyList)) {
    var NonEmptyList$1 = $as_Lcats_data_NonEmptyList(x$1);
    var x = this.Lcats_data_NonEmptyList__f_head;
    var y = $n(NonEmptyList$1).Lcats_data_NonEmptyList__f_head;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lcats_data_NonEmptyList__f_tail;
      var x$2$1 = $n(NonEmptyList$1).Lcats_data_NonEmptyList__f_tail;
      return ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcats_data_NonEmptyList(obj) {
  return (((obj instanceof $c_Lcats_data_NonEmptyList) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.NonEmptyList"))
}
function $isArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_NonEmptyList)))
}
function $asArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (($isArrayOf_Lcats_data_NonEmptyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.NonEmptyList;", depth))
}
var $d_Lcats_data_NonEmptyList = new $TypeData().initClass({
  Lcats_data_NonEmptyList: 0
}, false, "cats.data.NonEmptyList", {
  Lcats_data_NonEmptyList: 1,
  O: 1,
  Lcats_data_NonEmptyCollection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_NonEmptyList.prototype.$classData = $d_Lcats_data_NonEmptyList;
/** @constructor */
function $c_Lcats_data_NonEmptyList$() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList = null;
  $ct_Lcats_data_NonEmptyListInstances__(this)
}
$c_Lcats_data_NonEmptyList$.prototype = new $h_Lcats_data_NonEmptyListInstances();
$c_Lcats_data_NonEmptyList$.prototype.constructor = $c_Lcats_data_NonEmptyList$;
/** @constructor */
function $h_Lcats_data_NonEmptyList$() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyList$.prototype = $c_Lcats_data_NonEmptyList$.prototype;
var $d_Lcats_data_NonEmptyList$ = new $TypeData().initClass({
  Lcats_data_NonEmptyList$: 0
}, false, "cats.data.NonEmptyList$", {
  Lcats_data_NonEmptyList$: 1,
  Lcats_data_NonEmptyListInstances: 1,
  Lcats_data_NonEmptyListInstances0: 1,
  Lcats_data_NonEmptyListInstances1: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_NonEmptyList$.prototype.$classData = $d_Lcats_data_NonEmptyList$;
var $n_Lcats_data_NonEmptyList$;
function $m_Lcats_data_NonEmptyList$() {
  if ((!$n_Lcats_data_NonEmptyList$)) {
    $n_Lcats_data_NonEmptyList$ = new $c_Lcats_data_NonEmptyList$()
  };
  return $n_Lcats_data_NonEmptyList$
}
/** @constructor */
function $c_Lcats_data_Validated$Invalid(e) {
  this.Lcats_data_Validated$Invalid__f_e = null;
  this.Lcats_data_Validated$Invalid__f_e = e
}
$c_Lcats_data_Validated$Invalid.prototype = new $h_Lcats_data_Validated();
$c_Lcats_data_Validated$Invalid.prototype.constructor = $c_Lcats_data_Validated$Invalid;
/** @constructor */
function $h_Lcats_data_Validated$Invalid() {
  /*<skip>*/
}
$h_Lcats_data_Validated$Invalid.prototype = $c_Lcats_data_Validated$Invalid.prototype;
$c_Lcats_data_Validated$Invalid.prototype.productPrefix__T = (function() {
  return "Invalid"
});
$c_Lcats_data_Validated$Invalid.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_Validated$Invalid.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcats_data_Validated$Invalid__f_e : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcats_data_Validated$Invalid.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcats_data_Validated$Invalid.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_Validated$Invalid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_data_Validated$Invalid.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcats_data_Validated$Invalid)) {
    var Invalid$1 = $as_Lcats_data_Validated$Invalid(x$1);
    var x = this.Lcats_data_Validated$Invalid__f_e;
    var y = $n(Invalid$1).Lcats_data_Validated$Invalid__f_e;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lcats_data_Validated$Invalid(obj) {
  return (((obj instanceof $c_Lcats_data_Validated$Invalid) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated$Invalid"))
}
function $isArrayOf_Lcats_data_Validated$Invalid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated$Invalid)))
}
function $asArrayOf_Lcats_data_Validated$Invalid(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated$Invalid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated$Invalid;", depth))
}
var $d_Lcats_data_Validated$Invalid = new $TypeData().initClass({
  Lcats_data_Validated$Invalid: 0
}, false, "cats.data.Validated$Invalid", {
  Lcats_data_Validated$Invalid: 1,
  Lcats_data_Validated: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Validated$Invalid.prototype.$classData = $d_Lcats_data_Validated$Invalid;
/** @constructor */
function $c_Lcats_data_Validated$Valid(a) {
  this.Lcats_data_Validated$Valid__f_a = null;
  this.Lcats_data_Validated$Valid__f_a = a
}
$c_Lcats_data_Validated$Valid.prototype = new $h_Lcats_data_Validated();
$c_Lcats_data_Validated$Valid.prototype.constructor = $c_Lcats_data_Validated$Valid;
/** @constructor */
function $h_Lcats_data_Validated$Valid() {
  /*<skip>*/
}
$h_Lcats_data_Validated$Valid.prototype = $c_Lcats_data_Validated$Valid.prototype;
$c_Lcats_data_Validated$Valid.prototype.productPrefix__T = (function() {
  return "Valid"
});
$c_Lcats_data_Validated$Valid.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_Validated$Valid.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcats_data_Validated$Valid__f_a : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcats_data_Validated$Valid.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcats_data_Validated$Valid.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_Validated$Valid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_data_Validated$Valid.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcats_data_Validated$Valid)) {
    var Valid$1 = $as_Lcats_data_Validated$Valid(x$1);
    var x = this.Lcats_data_Validated$Valid__f_a;
    var y = $n(Valid$1).Lcats_data_Validated$Valid__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lcats_data_Validated$Valid(obj) {
  return (((obj instanceof $c_Lcats_data_Validated$Valid) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated$Valid"))
}
function $isArrayOf_Lcats_data_Validated$Valid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated$Valid)))
}
function $asArrayOf_Lcats_data_Validated$Valid(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated$Valid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated$Valid;", depth))
}
var $d_Lcats_data_Validated$Valid = new $TypeData().initClass({
  Lcats_data_Validated$Valid: 0
}, false, "cats.data.Validated$Valid", {
  Lcats_data_Validated$Valid: 1,
  Lcats_data_Validated: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Validated$Valid.prototype.$classData = $d_Lcats_data_Validated$Valid;
/** @constructor */
function $c_Lcats_data_ValidatedInstances$$anon$6(outer) {
  /*<skip>*/
}
$c_Lcats_data_ValidatedInstances$$anon$6.prototype = new $h_O();
$c_Lcats_data_ValidatedInstances$$anon$6.prototype.constructor = $c_Lcats_data_ValidatedInstances$$anon$6;
/** @constructor */
function $h_Lcats_data_ValidatedInstances$$anon$6() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances$$anon$6.prototype = $c_Lcats_data_ValidatedInstances$$anon$6.prototype;
var $d_Lcats_data_ValidatedInstances$$anon$6 = new $TypeData().initClass({
  Lcats_data_ValidatedInstances$$anon$6: 0
}, false, "cats.data.ValidatedInstances$$anon$6", {
  Lcats_data_ValidatedInstances$$anon$6: 1,
  O: 1,
  Lcats_Bitraverse: 1,
  Lcats_Bifoldable: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifunctor: 1
});
$c_Lcats_data_ValidatedInstances$$anon$6.prototype.$classData = $d_Lcats_data_ValidatedInstances$$anon$6;
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_EitherInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_EitherInstances$$anon$1.prototype = $c_Lcats_instances_EitherInstances$$anon$1.prototype;
var $d_Lcats_instances_EitherInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_EitherInstances$$anon$1: 0
}, false, "cats.instances.EitherInstances$$anon$1", {
  Lcats_instances_EitherInstances$$anon$1: 1,
  O: 1,
  Lcats_Bitraverse: 1,
  Lcats_Bifoldable: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifunctor: 1
});
$c_Lcats_instances_EitherInstances$$anon$1.prototype.$classData = $d_Lcats_instances_EitherInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_kernel_Monoid(fa);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$3(this, f, fa$1, g)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Monoid(fa);
  var fb$1 = $as_Lcats_kernel_Monoid(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$1$$anon$2(this, fa$1, fb$1)
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$1: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$1", {
  Lcats_instances_InvariantMonoidalInstances$$anon$1: 1,
  O: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$1;
function $f_Lcats_instances_OptionInstances__$init$__V($thiz) {
  $thiz.cats$instances$OptionInstances$_setter_$catsStdInstancesForOption_$eq__Lcats_Traverse__V(new $c_Lcats_instances_OptionInstances$$anon$1($thiz))
}
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$1$$anon$2(outer, fa$1, fb$1) {
  this.Lcats_instances_OrderInstances$$anon$1$$anon$2__f_fa$1 = null;
  this.Lcats_instances_OrderInstances$$anon$1$$anon$2__f_fb$1 = null;
  this.Lcats_instances_OrderInstances$$anon$1$$anon$2__f_fa$1 = fa$1;
  this.Lcats_instances_OrderInstances$$anon$1$$anon$2__f_fb$1 = fb$1
}
$c_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$1$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$1$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype = $c_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype;
$c_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var z = $n(this.Lcats_instances_OrderInstances$$anon$1$$anon$2__f_fa$1).compare__O__O__I($n(x)._1__O(), $n(y)._1__O());
  return ((z === 0) ? $n(this.Lcats_instances_OrderInstances$$anon$1$$anon$2__f_fb$1).compare__O__O__I($n(x)._2__O(), $n(y)._2__O()) : z)
});
$c_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_OrderInstances$$anon$1$$anon$2 = new $TypeData().initClass({
  Lcats_instances_OrderInstances$$anon$1$$anon$2: 0
}, false, "cats.instances.OrderInstances$$anon$1$$anon$2", {
  Lcats_instances_OrderInstances$$anon$1$$anon$2: 1,
  O: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_OrderInstances$$anon$1$$anon$2.prototype.$classData = $d_Lcats_instances_OrderInstances$$anon$1$$anon$2;
/** @constructor */
function $c_Lcats_instances_SortedSetInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SortedSetInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SortedSetInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SortedSetInstances$$anon$1.prototype = $c_Lcats_instances_SortedSetInstances$$anon$1.prototype;
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this)
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_SortedSet(x);
  var y$1 = $as_sci_SortedSet(y);
  var this$1 = $n(x$1);
  return $as_sci_SortedSet(this$1.concat__sc_IterableOnce__sc_SetOps(y$1))
});
var $d_Lcats_instances_SortedSetInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SortedSetInstances$$anon$1: 0
}, false, "cats.instances.SortedSetInstances$$anon$1", {
  Lcats_instances_SortedSetInstances$$anon$1: 1,
  O: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.$classData = $d_Lcats_instances_SortedSetInstances$$anon$1;
function $f_Lcats_instances_Tuple2Instances__$init$__V($thiz) {
  $thiz.cats$instances$Tuple2Instances$_setter_$catsStdBitraverseForTuple2_$eq__Lcats_Bitraverse__V(new $c_Lcats_instances_Tuple2Instances$$anon$3($thiz))
}
/** @constructor */
function $c_Lcats_instances_Tuple2Instances$$anon$3(outer) {
  /*<skip>*/
}
$c_Lcats_instances_Tuple2Instances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_Tuple2Instances$$anon$3.prototype.constructor = $c_Lcats_instances_Tuple2Instances$$anon$3;
/** @constructor */
function $h_Lcats_instances_Tuple2Instances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_Tuple2Instances$$anon$3.prototype = $c_Lcats_instances_Tuple2Instances$$anon$3.prototype;
var $d_Lcats_instances_Tuple2Instances$$anon$3 = new $TypeData().initClass({
  Lcats_instances_Tuple2Instances$$anon$3: 0
}, false, "cats.instances.Tuple2Instances$$anon$3", {
  Lcats_instances_Tuple2Instances$$anon$3: 1,
  O: 1,
  Lcats_Bitraverse: 1,
  Lcats_Bifoldable: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifunctor: 1
});
$c_Lcats_instances_Tuple2Instances$$anon$3.prototype.$classData = $d_Lcats_instances_Tuple2Instances$$anon$3;
/** @constructor */
function $c_Lcats_instances_package$either$() {
  $n_Lcats_instances_package$either$ = this;
  $f_Lcats_instances_EitherInstances__$init$__V(this)
}
$c_Lcats_instances_package$either$.prototype = new $h_O();
$c_Lcats_instances_package$either$.prototype.constructor = $c_Lcats_instances_package$either$;
/** @constructor */
function $h_Lcats_instances_package$either$() {
  /*<skip>*/
}
$h_Lcats_instances_package$either$.prototype = $c_Lcats_instances_package$either$.prototype;
$c_Lcats_instances_package$either$.prototype.cats$instances$EitherInstances$_setter_$catsStdBitraverseForEither_$eq__Lcats_Bitraverse__V = (function(x$1) {
  /*<skip>*/
});
var $d_Lcats_instances_package$either$ = new $TypeData().initClass({
  Lcats_instances_package$either$: 0
}, false, "cats.instances.package$either$", {
  Lcats_instances_package$either$: 1,
  O: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances1: 1
});
$c_Lcats_instances_package$either$.prototype.$classData = $d_Lcats_instances_package$either$;
var $n_Lcats_instances_package$either$;
function $m_Lcats_instances_package$either$() {
  if ((!$n_Lcats_instances_package$either$)) {
    $n_Lcats_instances_package$either$ = new $c_Lcats_instances_package$either$()
  };
  return $n_Lcats_instances_package$either$
}
/** @constructor */
function $c_Lcats_instances_package$seq$() {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = null;
  $n_Lcats_instances_package$seq$ = this;
  $f_Lcats_instances_SeqInstances__$init$__V(this)
}
$c_Lcats_instances_package$seq$.prototype = new $h_O();
$c_Lcats_instances_package$seq$.prototype.constructor = $c_Lcats_instances_package$seq$;
/** @constructor */
function $h_Lcats_instances_package$seq$() {
  /*<skip>*/
}
$h_Lcats_instances_package$seq$.prototype = $c_Lcats_instances_package$seq$.prototype;
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Traverse__V = (function(x$1) {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = x$1
});
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
var $d_Lcats_instances_package$seq$ = new $TypeData().initClass({
  Lcats_instances_package$seq$: 0
}, false, "cats.instances.package$seq$", {
  Lcats_instances_package$seq$: 1,
  O: 1,
  Lcats_instances_SeqInstances: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances2: 1
});
$c_Lcats_instances_package$seq$.prototype.$classData = $d_Lcats_instances_package$seq$;
var $n_Lcats_instances_package$seq$;
function $m_Lcats_instances_package$seq$() {
  if ((!$n_Lcats_instances_package$seq$)) {
    $n_Lcats_instances_package$seq$ = new $c_Lcats_instances_package$seq$()
  };
  return $n_Lcats_instances_package$seq$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$EqualTo$() {
  $ct_Lcats_kernel_Comparison__I__D__(this, 0, 0.0)
}
$c_Lcats_kernel_Comparison$EqualTo$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$EqualTo$.prototype.constructor = $c_Lcats_kernel_Comparison$EqualTo$;
/** @constructor */
function $h_Lcats_kernel_Comparison$EqualTo$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$EqualTo$.prototype = $c_Lcats_kernel_Comparison$EqualTo$.prototype;
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productPrefix__T = (function() {
  return "EqualTo"
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.hashCode__I = (function() {
  return 159386799
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.toString__T = (function() {
  return "EqualTo"
});
var $d_Lcats_kernel_Comparison$EqualTo$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$EqualTo$: 0
}, false, "cats.kernel.Comparison$EqualTo$", {
  Lcats_kernel_Comparison$EqualTo$: 1,
  Lcats_kernel_Comparison: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.$classData = $d_Lcats_kernel_Comparison$EqualTo$;
var $n_Lcats_kernel_Comparison$EqualTo$;
function $m_Lcats_kernel_Comparison$EqualTo$() {
  if ((!$n_Lcats_kernel_Comparison$EqualTo$)) {
    $n_Lcats_kernel_Comparison$EqualTo$ = new $c_Lcats_kernel_Comparison$EqualTo$()
  };
  return $n_Lcats_kernel_Comparison$EqualTo$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$GreaterThan$() {
  $ct_Lcats_kernel_Comparison__I__D__(this, 1, 1.0)
}
$c_Lcats_kernel_Comparison$GreaterThan$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.constructor = $c_Lcats_kernel_Comparison$GreaterThan$;
/** @constructor */
function $h_Lcats_kernel_Comparison$GreaterThan$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$GreaterThan$.prototype = $c_Lcats_kernel_Comparison$GreaterThan$.prototype;
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productPrefix__T = (function() {
  return "GreaterThan"
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.hashCode__I = (function() {
  return (-1701951333)
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.toString__T = (function() {
  return "GreaterThan"
});
var $d_Lcats_kernel_Comparison$GreaterThan$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$GreaterThan$: 0
}, false, "cats.kernel.Comparison$GreaterThan$", {
  Lcats_kernel_Comparison$GreaterThan$: 1,
  Lcats_kernel_Comparison: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.$classData = $d_Lcats_kernel_Comparison$GreaterThan$;
var $n_Lcats_kernel_Comparison$GreaterThan$;
function $m_Lcats_kernel_Comparison$GreaterThan$() {
  if ((!$n_Lcats_kernel_Comparison$GreaterThan$)) {
    $n_Lcats_kernel_Comparison$GreaterThan$ = new $c_Lcats_kernel_Comparison$GreaterThan$()
  };
  return $n_Lcats_kernel_Comparison$GreaterThan$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$LessThan$() {
  $ct_Lcats_kernel_Comparison__I__D__(this, (-1), (-1.0))
}
$c_Lcats_kernel_Comparison$LessThan$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$LessThan$.prototype.constructor = $c_Lcats_kernel_Comparison$LessThan$;
/** @constructor */
function $h_Lcats_kernel_Comparison$LessThan$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$LessThan$.prototype = $c_Lcats_kernel_Comparison$LessThan$.prototype;
$c_Lcats_kernel_Comparison$LessThan$.prototype.productPrefix__T = (function() {
  return "LessThan"
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.hashCode__I = (function() {
  return (-2140646662)
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.toString__T = (function() {
  return "LessThan"
});
var $d_Lcats_kernel_Comparison$LessThan$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$LessThan$: 0
}, false, "cats.kernel.Comparison$LessThan$", {
  Lcats_kernel_Comparison$LessThan$: 1,
  Lcats_kernel_Comparison: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.$classData = $d_Lcats_kernel_Comparison$LessThan$;
var $n_Lcats_kernel_Comparison$LessThan$;
function $m_Lcats_kernel_Comparison$LessThan$() {
  if ((!$n_Lcats_kernel_Comparison$LessThan$)) {
    $n_Lcats_kernel_Comparison$LessThan$ = new $c_Lcats_kernel_Comparison$LessThan$()
  };
  return $n_Lcats_kernel_Comparison$LessThan$
}
/** @constructor */
function $c_Lcats_kernel_Order$$anon$2(ev$1, f$1) {
  this.Lcats_kernel_Order$$anon$2__f_ev$1 = null;
  this.Lcats_kernel_Order$$anon$2__f_f$1 = null;
  this.Lcats_kernel_Order$$anon$2__f_ev$1 = ev$1;
  this.Lcats_kernel_Order$$anon$2__f_f$1 = f$1
}
$c_Lcats_kernel_Order$$anon$2.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$2.prototype.constructor = $c_Lcats_kernel_Order$$anon$2;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$2() {
  /*<skip>*/
}
$h_Lcats_kernel_Order$$anon$2.prototype = $c_Lcats_kernel_Order$$anon$2.prototype;
$c_Lcats_kernel_Order$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_Order$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Order$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Order$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.Lcats_kernel_Order$$anon$2__f_ev$1).compare__O__O__I($n(this.Lcats_kernel_Order$$anon$2__f_f$1).apply__O__O(x), $n(this.Lcats_kernel_Order$$anon$2__f_f$1).apply__O__O(y))
});
var $d_Lcats_kernel_Order$$anon$2 = new $TypeData().initClass({
  Lcats_kernel_Order$$anon$2: 0
}, false, "cats.kernel.Order$$anon$2", {
  Lcats_kernel_Order$$anon$2: 1,
  O: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Order$$anon$2.prototype.$classData = $d_Lcats_kernel_Order$$anon$2;
/** @constructor */
function $c_Lcats_kernel_PartialOrder$() {
  /*<skip>*/
}
$c_Lcats_kernel_PartialOrder$.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_PartialOrder$.prototype.constructor = $c_Lcats_kernel_PartialOrder$;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$() {
  /*<skip>*/
}
$h_Lcats_kernel_PartialOrder$.prototype = $c_Lcats_kernel_PartialOrder$.prototype;
var $d_Lcats_kernel_PartialOrder$ = new $TypeData().initClass({
  Lcats_kernel_PartialOrder$: 0
}, false, "cats.kernel.PartialOrder$", {
  Lcats_kernel_PartialOrder$: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_PartialOrder$.prototype.$classData = $d_Lcats_kernel_PartialOrder$;
var $n_Lcats_kernel_PartialOrder$;
function $m_Lcats_kernel_PartialOrder$() {
  if ((!$n_Lcats_kernel_PartialOrder$)) {
    $n_Lcats_kernel_PartialOrder$ = new $c_Lcats_kernel_PartialOrder$()
  };
  return $n_Lcats_kernel_PartialOrder$
}
/** @constructor */
function $c_Lcats_kernel_instances_BitSetPartialOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.constructor = $c_Lcats_kernel_instances_BitSetPartialOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetPartialOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BitSetPartialOrder.prototype = $c_Lcats_kernel_instances_BitSetPartialOrder.prototype;
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__sci_BitSet__sci_BitSet__D = (function(x, y) {
  if ((x === y)) {
    return 0.0
  } else {
    var this$1 = $n(x);
    var $$x1 = $f_sc_BitSetOps__size__I(this$1);
    var this$2 = $n(y);
    if (($$x1 < $f_sc_BitSetOps__size__I(this$2))) {
      var this$3 = $n(x);
      if ($f_sc_IterableOnceOps__forall__F1__Z(this$3, y)) {
        return (-1.0)
      } else {
        return (NaN)
      }
    } else {
      var this$4 = $n(y);
      var $$x2 = $f_sc_BitSetOps__size__I(this$4);
      var this$5 = $n(x);
      if (($$x2 < $f_sc_BitSetOps__size__I(this$5))) {
        var this$6 = $n(y);
        if ($f_sc_IterableOnceOps__forall__F1__Z(this$6, x)) {
          return 1.0
        } else {
          return (NaN)
        }
      } else {
        if ((x === null)) {
          var $$x3 = (y === null)
        } else {
          var this$7 = $n(x);
          var $$x3 = $f_sc_SortedSet__equals__O__Z(this$7, y)
        };
        if ($$x3) {
          return 0.0
        } else {
          return (NaN)
        }
      }
    }
  }
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__sci_BitSet__sci_BitSet__Z = (function(x, y) {
  if ((x === null)) {
    return (y === null)
  } else {
    var this$1 = $n(x);
    return $f_sc_SortedSet__equals__O__Z(this$1, y)
  }
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_BitSet__sci_BitSet__Z($as_sci_BitSet(x), $as_sci_BitSet(y))
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__sci_BitSet__sci_BitSet__D($as_sci_BitSet(x), $as_sci_BitSet(y))
});
var $d_Lcats_kernel_instances_BitSetPartialOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BitSetPartialOrder: 0
}, false, "cats.kernel.instances.BitSetPartialOrder", {
  Lcats_kernel_instances_BitSetPartialOrder: 1,
  O: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.$classData = $d_Lcats_kernel_instances_BitSetPartialOrder;
/** @constructor */
function $c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1(outer) {
  /*<skip>*/
}
$c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1.prototype.constructor = $c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1;
/** @constructor */
function $h_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1.prototype = $c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1.prototype;
$c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1.prototype.applyOrElse__T__F1__O = (function(x1, default$1) {
  return new $c_s_util_Failure($ct_jl_Error__T__(new $c_jl_Error(), ("Format de date non reconnu " + x1)))
});
$c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1.prototype.isDefinedAt__T__Z = (function(x1) {
  return true
});
$c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T__Z($as_T(x))
});
$c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T__F1__O($as_T(x), default$1)
});
var $d_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1 = new $TypeData().initClass({
  Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1: 0
}, false, "com.iz2use.common.Parsable$$anon$4$$anonfun$1", {
  Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1.prototype.$classData = $d_Lcom_iz2use_common_Parsable$$anon$4$$anonfun$1;
/** @constructor */
function $c_Lcom_iz2use_common_ParsingReference$Simple(f) {
  this.Lcom_iz2use_common_ParsingReference$Simple__f_f = null;
  this.Lcom_iz2use_common_ParsingReference$Simple__f_f = f
}
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype = new $h_O();
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.constructor = $c_Lcom_iz2use_common_ParsingReference$Simple;
/** @constructor */
function $h_Lcom_iz2use_common_ParsingReference$Simple() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_ParsingReference$Simple.prototype = $c_Lcom_iz2use_common_ParsingReference$Simple.prototype;
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.apply__O = (function() {
  return $n(this.Lcom_iz2use_common_ParsingReference$Simple__f_f).apply__O()
});
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.productPrefix__T = (function() {
  return "Simple"
});
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_common_ParsingReference$Simple__f_f : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_ParsingReference$Simple)) {
    var Simple$1 = $as_Lcom_iz2use_common_ParsingReference$Simple(x$1);
    var x = this.Lcom_iz2use_common_ParsingReference$Simple__f_f;
    var x$2 = $n(Simple$1).Lcom_iz2use_common_ParsingReference$Simple__f_f;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_ParsingReference$Simple(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_ParsingReference$Simple) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.ParsingReference$Simple"))
}
function $isArrayOf_Lcom_iz2use_common_ParsingReference$Simple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_ParsingReference$Simple)))
}
function $asArrayOf_Lcom_iz2use_common_ParsingReference$Simple(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_ParsingReference$Simple(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.ParsingReference$Simple;", depth))
}
var $d_Lcom_iz2use_common_ParsingReference$Simple = new $TypeData().initClass({
  Lcom_iz2use_common_ParsingReference$Simple: 0
}, false, "com.iz2use.common.ParsingReference$Simple", {
  Lcom_iz2use_common_ParsingReference$Simple: 1,
  O: 1,
  Lcom_iz2use_common_ParsingReference: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_ParsingReference$Simple.prototype.$classData = $d_Lcom_iz2use_common_ParsingReference$Simple;
/** @constructor */
function $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$(outer) {
  /*<skip>*/
}
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype = new $h_O();
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype.constructor = $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$;
/** @constructor */
function $h_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype = $c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype;
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype.productPrefix__T = (function() {
  return "NFD"
});
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype.hashCode__I = (function() {
  return 77196
});
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype.toString__T = (function() {
  return "NFD"
});
var $d_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$ = new $TypeData().initClass({
  Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$: 0
}, false, "com.iz2use.common.PlatformSpecifics$Normalizer$Form$NFD$", {
  Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$: 1,
  O: 1,
  Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$.prototype.$classData = $d_Lcom_iz2use_common_PlatformSpecifics$Normalizer$Form$NFD$;
/** @constructor */
function $c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1(outer, reference$3) {
  this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer = null;
  this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_reference$3 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer = outer
  };
  this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_reference$3 = reference$3
}
$c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1.prototype.constructor = $c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1;
/** @constructor */
function $h_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1.prototype = $c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1.prototype;
$c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1.prototype.applyOrElse__T__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var o16 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_ddmmyy).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o16).isEmpty__Z()) && (($n(o16).get__O() !== null) && ($n($as_sci_List($n(o16).get__O())).lengthCompare__I__I(3) === 0)))) {
      var d = $as_T($n($as_sc_LinearSeqOps($n(o16).get__O())).apply__I__O(0));
      var m = $as_T($n($as_sc_LinearSeqOps($n(o16).get__O())).apply__I__O(1));
      var y = $as_T($n($as_sc_LinearSeqOps($n(o16).get__O())).apply__I__O(2));
      var this$12 = $n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer);
      var reference = this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_reference$3;
      $m_sc_StringOps$();
      var this$3 = $m_jl_Integer$();
      var d$1 = this$3.parseInt__T__I__I(d, 10);
      $m_sc_StringOps$();
      var this$6 = $m_jl_Integer$();
      var m$1 = new $c_s_Some(this$6.parseInt__T__I__I(m, 10));
      var this$7 = $n(y);
      if ((this$7 === "")) {
        var y$1 = $m_s_None$()
      } else {
        var $$x1 = $m_s_Option$();
        $m_sc_StringOps$();
        var this$11 = $m_jl_Integer$();
        var y$1 = $n($$x1).apply__O__s_Option(this$11.parseInt__T__I__I(y, 10))
      };
      return $f_Lcom_iz2use_common_TimeParser__fromReference__Ljava_time_LocalDate__I__s_Option__s_Option__Ljava_time_LocalDate(this$12, reference, d$1, m$1, y$1)
    }
  };
  if ((x1 !== null)) {
    var o18 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_dmy).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o18).isEmpty__Z()) && (($n(o18).get__O() !== null) && ($n($as_sci_List($n(o18).get__O())).lengthCompare__I__I(4) === 0)))) {
      var d$2 = $as_T($n($as_sc_LinearSeqOps($n(o18).get__O())).apply__I__O(0));
      var m$2 = $as_T($n($as_sc_LinearSeqOps($n(o18).get__O())).apply__I__O(2));
      var y$2 = $as_T($n($as_sc_LinearSeqOps($n(o18).get__O())).apply__I__O(3));
      var this$22 = $n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer);
      var reference$1 = this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_reference$3;
      $m_sc_StringOps$();
      var this$15 = $m_jl_Integer$();
      var d$3 = this$15.parseInt__T__I__I(d$2, 10);
      $m_sc_StringOps$();
      var this$18 = $m_jl_Integer$();
      var m$3 = new $c_s_Some(this$18.parseInt__T__I__I(m$2, 10));
      $m_sc_StringOps$();
      var this$21 = $m_jl_Integer$();
      var y$3 = new $c_s_Some(this$21.parseInt__T__I__I(y$2, 10));
      return $f_Lcom_iz2use_common_TimeParser__fromReference__Ljava_time_LocalDate__I__s_Option__s_Option__Ljava_time_LocalDate(this$22, reference$1, d$3, m$3, y$3)
    }
  };
  if ((x1 !== null)) {
    var o20 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_dmy).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o20).isEmpty__Z()) && (($n(o20).get__O() !== null) && ($n($as_sci_List($n(o20).get__O())).lengthCompare__I__I(3) === 0)))) {
      var d$3$1 = $as_T($n($as_sc_LinearSeqOps($n(o20).get__O())).apply__I__O(0));
      var m$3$1 = $as_T($n($as_sc_LinearSeqOps($n(o20).get__O())).apply__I__O(2));
      var this$30 = $n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer);
      var reference$2 = this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_reference$3;
      $m_sc_StringOps$();
      var this$25 = $m_jl_Integer$();
      var d$4 = this$25.parseInt__T__I__I(d$3$1, 10);
      $m_sc_StringOps$();
      var this$28 = $m_jl_Integer$();
      var m$4 = new $c_s_Some(this$28.parseInt__T__I__I(m$3$1, 10));
      $n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer);
      var y$4 = $m_s_None$();
      return $f_Lcom_iz2use_common_TimeParser__fromReference__Ljava_time_LocalDate__I__s_Option__s_Option__Ljava_time_LocalDate(this$30, reference$2, d$4, m$4, y$4)
    }
  };
  if ((x1 !== null)) {
    var o22 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_my).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o22).isEmpty__Z()) && (($n(o22).get__O() !== null) && ($n($as_sci_List($n(o22).get__O())).lengthCompare__I__I(3) === 0)))) {
      var m$4$1 = $as_T($n($as_sc_LinearSeqOps($n(o22).get__O())).apply__I__O(0));
      var y$3$1 = $as_T($n($as_sc_LinearSeqOps($n(o22).get__O())).apply__I__O(2));
      var this$37 = $n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer);
      var reference$3 = this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_reference$3;
      $m_sc_StringOps$();
      var this$33 = $m_jl_Integer$();
      var m$5 = new $c_s_Some(this$33.parseInt__T__I__I(m$4$1, 10));
      $m_sc_StringOps$();
      var this$36 = $m_jl_Integer$();
      var y$5 = new $c_s_Some(this$36.parseInt__T__I__I(y$3$1, 10));
      return $f_Lcom_iz2use_common_TimeParser__fromReference__Ljava_time_LocalDate__I__s_Option__s_Option__Ljava_time_LocalDate(this$37, reference$3, 1, m$5, y$5)
    }
  };
  if ((x1 !== null)) {
    var o24 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_d).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o24).isEmpty__Z()) && (($n(o24).get__O() !== null) && ($n($as_sci_List($n(o24).get__O())).lengthCompare__I__I(1) === 0)))) {
      var d$4$1 = $as_T($n($as_sc_LinearSeqOps($n(o24).get__O())).apply__I__O(0));
      var this$43 = $n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer);
      var reference$4 = this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_reference$3;
      $m_sc_StringOps$();
      var this$40 = $m_jl_Integer$();
      var d$5 = this$40.parseInt__T__I__I(d$4$1, 10);
      $n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer);
      var m$6 = $m_s_None$();
      $n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer);
      var y$6 = $m_s_None$();
      return $f_Lcom_iz2use_common_TimeParser__fromReference__Ljava_time_LocalDate__I__s_Option__s_Option__Ljava_time_LocalDate(this$43, reference$4, d$5, m$6, y$6)
    }
  };
  if ((x1 !== null)) {
    var o26 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_relative).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o26).isEmpty__Z()) && (($n(o26).get__O() !== null) && ($n($as_sci_List($n(o26).get__O())).lengthCompare__I__I(1) === 0)))) {
      var days = $as_T($n($as_sc_LinearSeqOps($n(o26).get__O())).apply__I__O(0));
      var $$x2 = $n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_reference$3);
      $m_sc_StringOps$();
      var this$46 = $m_jl_Integer$();
      var value = this$46.parseInt__T__I__I(days, 10);
      var hi = (value >> 31);
      return $n($$x2).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(value, hi))
    }
  };
  if ((x1 !== null)) {
    var o28 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).PossibleDays__Lcom_iz2use_common_TimeParser$PossibleDays$()).unapply__T__s_Option(x1);
    if ((!$n(o28).isEmpty__Z())) {
      var days$2 = $uI($n(o28).get__O());
      var this$48 = $m_Ljava_time_LocalDate$();
      var $$x3 = $n(this$48.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId())));
      var hi$1 = (days$2 >> 31);
      return $n($$x3).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(days$2, hi$1))
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1.prototype.isDefinedAt__T__Z = (function(x1) {
  if ((x1 !== null)) {
    var o16 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_ddmmyy).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o16).isEmpty__Z()) && (($n(o16).get__O() !== null) && ($n($as_sci_List($n(o16).get__O())).lengthCompare__I__I(3) === 0)))) {
      return true
    }
  };
  if ((x1 !== null)) {
    var o18 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_dmy).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o18).isEmpty__Z()) && (($n(o18).get__O() !== null) && ($n($as_sci_List($n(o18).get__O())).lengthCompare__I__I(4) === 0)))) {
      return true
    }
  };
  if ((x1 !== null)) {
    var o20 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_dmy).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o20).isEmpty__Z()) && (($n(o20).get__O() !== null) && ($n($as_sci_List($n(o20).get__O())).lengthCompare__I__I(3) === 0)))) {
      return true
    }
  };
  if ((x1 !== null)) {
    var o22 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_my).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o22).isEmpty__Z()) && (($n(o22).get__O() !== null) && ($n($as_sci_List($n(o22).get__O())).lengthCompare__I__I(3) === 0)))) {
      return true
    }
  };
  if ((x1 !== null)) {
    var o24 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_d).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o24).isEmpty__Z()) && (($n(o24).get__O() !== null) && ($n($as_sci_List($n(o24).get__O())).lengthCompare__I__I(1) === 0)))) {
      return true
    }
  };
  if ((x1 !== null)) {
    var o26 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).Lcom_iz2use_common_TimeParser$__f_relative).unapplySeq__jl_CharSequence__s_Option(x1);
    if (((!$n(o26).isEmpty__Z()) && (($n(o26).get__O() !== null) && ($n($as_sci_List($n(o26).get__O())).lengthCompare__I__I(1) === 0)))) {
      return true
    }
  };
  if ((x1 !== null)) {
    var o28 = $n($n(this.Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1__f_$outer).PossibleDays__Lcom_iz2use_common_TimeParser$PossibleDays$()).unapply__T__s_Option(x1);
    if ((!$n(o28).isEmpty__Z())) {
      return true
    }
  };
  return false
});
$c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T__Z($as_T(x))
});
$c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T__F1__O($as_T(x), default$1)
});
var $d_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1 = new $TypeData().initClass({
  Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1: 0
}, false, "com.iz2use.common.TimeParser$$anonfun$parsePartialDate$1", {
  Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1.prototype.$classData = $d_Lcom_iz2use_common_TimeParser$$anonfun$parsePartialDate$1;
/** @constructor */
function $c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1(outer, find$1) {
  this.Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1__f_find$1 = null;
  this.Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1__f_find$1 = find$1
}
$c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1.prototype.constructor = $c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1;
/** @constructor */
function $h_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1.prototype = $c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1.prototype;
$c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var k = $as_T($n(x1)._1__O());
    var v = $n(x1)._2$mcI$sp__I();
    var this$1 = $n(k);
    var prefix = this.Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1__f_find$1;
    if ((this$1.length >= 0)) {
      var this$2 = $n(prefix);
      var $$x2 = this$1.substring(0, this$2.length);
      var $$x1 = ($as_T($$x2) === prefix)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return v
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var k = $as_T($n(x1)._1__O());
    var this$1 = $n(k);
    var prefix = this.Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1__f_find$1;
    if ((this$1.length >= 0)) {
      var this$2 = $n(prefix);
      var $$x2 = this$1.substring(0, this$2.length);
      var $$x1 = ($as_T($$x2) === prefix)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return true
    }
  };
  return false
});
$c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1 = new $TypeData().initClass({
  Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1: 0
}, false, "com.iz2use.common.TimeParser$PossibleDays$$anonfun$unapply$1", {
  Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1.prototype.$classData = $d_Lcom_iz2use_common_TimeParser$PossibleDays$$anonfun$unapply$1;
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized(result, processor) {
  this.Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_result = null;
  this.Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_processor = null;
  this.Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_result = result;
  this.Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_processor = processor
}
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_MappedTokenized() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype = $c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype;
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.process__F1__Z = (function(f) {
  return $uZ($n(this.Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_processor).apply__O__O__O(f, this.Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_result))
});
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.productPrefix__T = (function() {
  return "MappedTokenized"
});
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_result : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized)) {
    var MappedTokenized$1 = $as_Lcom_iz2use_common_internal_tokenizer_MappedTokenized(x$1);
    var x = this.Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_result;
    var y = $n(MappedTokenized$1).Lcom_iz2use_common_internal_tokenizer_MappedTokenized__f_result;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_internal_tokenizer_MappedTokenized(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.internal.tokenizer.MappedTokenized"))
}
function $isArrayOf_Lcom_iz2use_common_internal_tokenizer_MappedTokenized(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_internal_tokenizer_MappedTokenized)))
}
function $asArrayOf_Lcom_iz2use_common_internal_tokenizer_MappedTokenized(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_internal_tokenizer_MappedTokenized(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.internal.tokenizer.MappedTokenized;", depth))
}
var $d_Lcom_iz2use_common_internal_tokenizer_MappedTokenized = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_MappedTokenized: 0
}, false, "com.iz2use.common.internal.tokenizer.MappedTokenized", {
  Lcom_iz2use_common_internal_tokenizer_MappedTokenized: 1,
  O: 1,
  Lcom_iz2use_common_internal_tokenizer_Tokenized: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_MappedTokenized.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_MappedTokenized;
/** @constructor */
function $c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(source, tokens) {
  this.Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_source = null;
  this.Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens = null;
  this.Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_source = source;
  this.Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens = tokens
}
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype = new $h_O();
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.constructor = $c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized;
/** @constructor */
function $h_Lcom_iz2use_common_internal_tokenizer_SeqTokenized() {
  /*<skip>*/
}
$h_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype = $c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype;
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.process__F1__Z = (function(f) {
  var result = true;
  var ite = $n(this.Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens).iterator__sc_Iterator();
  while ((result && $n(ite).hasNext__Z())) {
    result = $uZ($n(f).apply__O__O($n(ite).next__O()))
  };
  return result
});
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.productPrefix__T = (function() {
  return "SeqTokenized"
});
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_source;
      break
    }
    case 1: {
      return this.Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized)) {
    var SeqTokenized$1 = $as_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(x$1);
    var x = this.Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_source;
    var y = $n(SeqTokenized$1).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_source;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens;
      var x$2$1 = $n(SeqTokenized$1).Lcom_iz2use_common_internal_tokenizer_SeqTokenized__f_tokens;
      return ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(obj) {
  return (((obj instanceof $c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.common.internal.tokenizer.SeqTokenized"))
}
function $isArrayOf_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_common_internal_tokenizer_SeqTokenized)))
}
function $asArrayOf_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_common_internal_tokenizer_SeqTokenized(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.common.internal.tokenizer.SeqTokenized;", depth))
}
var $d_Lcom_iz2use_common_internal_tokenizer_SeqTokenized = new $TypeData().initClass({
  Lcom_iz2use_common_internal_tokenizer_SeqTokenized: 0
}, false, "com.iz2use.common.internal.tokenizer.SeqTokenized", {
  Lcom_iz2use_common_internal_tokenizer_SeqTokenized: 1,
  O: 1,
  Lcom_iz2use_common_internal_tokenizer_Tokenized: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_common_internal_tokenizer_SeqTokenized.prototype.$classData = $d_Lcom_iz2use_common_internal_tokenizer_SeqTokenized;
/** @constructor */
function $c_Lcom_iz2use_react_components_ConcreteIsItemCollection() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype = new $h_O();
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype.constructor = $c_Lcom_iz2use_react_components_ConcreteIsItemCollection;
/** @constructor */
function $h_Lcom_iz2use_react_components_ConcreteIsItemCollection() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype = $c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype;
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype.productPrefix__T = (function() {
  return "ConcreteIsItemCollection"
});
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lcom_iz2use_react_components_ConcreteIsItemCollection)
});
function $as_Lcom_iz2use_react_components_ConcreteIsItemCollection(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_ConcreteIsItemCollection) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.ConcreteIsItemCollection"))
}
function $isArrayOf_Lcom_iz2use_react_components_ConcreteIsItemCollection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_ConcreteIsItemCollection)))
}
function $asArrayOf_Lcom_iz2use_react_components_ConcreteIsItemCollection(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_ConcreteIsItemCollection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.ConcreteIsItemCollection;", depth))
}
var $d_Lcom_iz2use_react_components_ConcreteIsItemCollection = new $TypeData().initClass({
  Lcom_iz2use_react_components_ConcreteIsItemCollection: 0
}, false, "com.iz2use.react.components.ConcreteIsItemCollection", {
  Lcom_iz2use_react_components_ConcreteIsItemCollection: 1,
  O: 1,
  Lcom_iz2use_react_components_IsItemCollection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_ConcreteIsItemCollection.prototype.$classData = $d_Lcom_iz2use_react_components_ConcreteIsItemCollection;
function $f_Lcom_iz2use_react_components_DebounceSupport__debounceReset__T__Ljapgolly_scalajs_react_callback_Trampoline($thiz, key) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
  var f = new $c_sjsr_AnonFunction0((() => {
    var handle = $n($thiz.com$iz2use$react$components$DebounceSupport$$debounceHandlers__sci_Map()).get__O__s_Option(key);
    var this$2 = $n(handle);
    if ((!this$2.isEmpty__Z())) {
      var arg1 = this$2.get__O();
      var h = $as_T2(arg1);
      clearTimeout($n(h)._1__O())
    };
    $thiz.com$iz2use$react$components$DebounceSupport$$debounceHandlers_$eq__sci_Map__V($as_sci_Map($n($thiz.com$iz2use$react$components$DebounceSupport$$debounceHandlers__sci_Map()).filter__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_T2(x$1$2);
      return ($n(x$1)._1__O() !== key)
    })))));
    return handle
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f)
}
function $f_Lcom_iz2use_react_components_DebounceSupport__debounceSet__T__Ljapgolly_scalajs_react_callback_Trampoline__D__Ljapgolly_scalajs_react_callback_Trampoline($thiz, key, cb, ms) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    var $$x1 = $thiz.com$iz2use$react$components$DebounceSupport$$debounceHandlers__sci_Map();
    var self = setTimeout($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toJsFn$extension__Ljapgolly_scalajs_react_callback_Trampoline__sjs_js_Function0(cb), ms);
    var y = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb);
    var y$1 = $ct_T2__O__O__(new $c_T2(), self, y);
    $thiz.com$iz2use$react$components$DebounceSupport$$debounceHandlers_$eq__sci_Map__V($as_sci_Map($n($$x1).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), key, y$1))))
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var this$ = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1);
  var runBefore = $f_Lcom_iz2use_react_components_DebounceSupport__debounceReset__T__Ljapgolly_scalajs_react_callback_Trampoline($thiz, key);
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(runBefore, this$)
}
function $f_Lcom_iz2use_react_components_DebounceSupport__debounceFlush__T__Ljapgolly_scalajs_react_callback_Trampoline($thiz, key) {
  var this$$1 = $f_Lcom_iz2use_react_components_DebounceSupport__debounceReset__T__Ljapgolly_scalajs_react_callback_Trampoline($thiz, key);
  var f$2 = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_s_Option(v$2);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var f = new $c_sjsr_AnonFunction0((() => {
      var this$2 = $n(v);
      if ((!this$2.isEmpty__Z())) {
        var arg1 = this$2.get__O();
        var h = $as_T2(arg1);
        var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(h)._2__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var this$4 = $n(this$);
        $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$4)
      }
    }));
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      f.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$2)
}
function $f_Lcom_iz2use_react_components_DebounceSupport__debounce__T__D__F0__Ljapgolly_scalajs_react_callback_Trampoline($thiz, key, ms, later) {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var f = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Lcom_iz2use_react_components_DebounceSupport__debounceFlush__T__Ljapgolly_scalajs_react_callback_Trampoline($thiz, key))));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  return $n($$x1).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_extra_OnUnmountF__onUnmount__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, f, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$5$2) => {
    $as_jl_Void(x$5$2);
    var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(later).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$ = $f_Lcom_iz2use_react_components_DebounceSupport__debounceSet__T__Ljapgolly_scalajs_react_callback_Trampoline__D__Ljapgolly_scalajs_react_callback_Trampoline($thiz, key, cb, ms);
    var f$1 = new $c_sjsr_AnonFunction1(((x$4$2) => {
      $as_jl_Void(x$4$2)
    }));
    var this$4 = $n(this$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$4, f$1))
  })))
}
function $f_Lcom_iz2use_react_components_DebounceSupport__$init$__V($thiz) {
  var this$1 = $m_sci_Map$();
  var elems = $m_sci_Nil$();
  $thiz.com$iz2use$react$components$DebounceSupport$$debounceHandlers_$eq__sci_Map__V(this$1.from__sc_IterableOnce__sci_Map(elems))
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Dialog$Broadcaster$() {
  this.Lcom_iz2use_react_components_Dialog$Broadcaster$__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  $n_Lcom_iz2use_react_components_Dialog$Broadcaster$ = this;
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this)
}
$c_Lcom_iz2use_react_components_Dialog$Broadcaster$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Dialog$Broadcaster$.prototype.constructor = $c_Lcom_iz2use_react_components_Dialog$Broadcaster$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Dialog$Broadcaster$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Dialog$Broadcaster$.prototype = $c_Lcom_iz2use_react_components_Dialog$Broadcaster$.prototype;
$c_Lcom_iz2use_react_components_Dialog$Broadcaster$.prototype.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_Dialog$Broadcaster$.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners__sci_List = (function() {
  return this.Lcom_iz2use_react_components_Dialog$Broadcaster$__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners
});
$c_Lcom_iz2use_react_components_Dialog$Broadcaster$.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_Dialog$Broadcaster$__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = x$1
});
$c_Lcom_iz2use_react_components_Dialog$Broadcaster$.prototype.dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_extra_BroadcasterF__broadcast__O__O(this, f))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
var $d_Lcom_iz2use_react_components_Dialog$Broadcaster$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Dialog$Broadcaster$: 0
}, false, "com.iz2use.react.components.Dialog$Broadcaster$", {
  Lcom_iz2use_react_components_Dialog$Broadcaster$: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_Broadcaster: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1,
  Ljapgolly_scalajs_react_extra_Listenable: 1
});
$c_Lcom_iz2use_react_components_Dialog$Broadcaster$.prototype.$classData = $d_Lcom_iz2use_react_components_Dialog$Broadcaster$;
var $n_Lcom_iz2use_react_components_Dialog$Broadcaster$;
function $m_Lcom_iz2use_react_components_Dialog$Broadcaster$() {
  if ((!$n_Lcom_iz2use_react_components_Dialog$Broadcaster$)) {
    $n_Lcom_iz2use_react_components_Dialog$Broadcaster$ = new $c_Lcom_iz2use_react_components_Dialog$Broadcaster$()
  };
  return $n_Lcom_iz2use_react_components_Dialog$Broadcaster$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Dialog$Pop$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Dialog$Pop$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Dialog$Pop$.prototype.constructor = $c_Lcom_iz2use_react_components_Dialog$Pop$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Dialog$Pop$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Dialog$Pop$.prototype = $c_Lcom_iz2use_react_components_Dialog$Pop$.prototype;
$c_Lcom_iz2use_react_components_Dialog$Pop$.prototype.productPrefix__T = (function() {
  return "Pop"
});
$c_Lcom_iz2use_react_components_Dialog$Pop$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_Dialog$Pop$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_Dialog$Pop$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Dialog$Pop$.prototype.hashCode__I = (function() {
  return 80433
});
$c_Lcom_iz2use_react_components_Dialog$Pop$.prototype.toString__T = (function() {
  return "Pop"
});
var $d_Lcom_iz2use_react_components_Dialog$Pop$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Dialog$Pop$: 0
}, false, "com.iz2use.react.components.Dialog$Pop$", {
  Lcom_iz2use_react_components_Dialog$Pop$: 1,
  O: 1,
  Lcom_iz2use_react_components_Dialog$Event: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Dialog$Pop$.prototype.$classData = $d_Lcom_iz2use_react_components_Dialog$Pop$;
var $n_Lcom_iz2use_react_components_Dialog$Pop$;
function $m_Lcom_iz2use_react_components_Dialog$Pop$() {
  if ((!$n_Lcom_iz2use_react_components_Dialog$Pop$)) {
    $n_Lcom_iz2use_react_components_Dialog$Pop$ = new $c_Lcom_iz2use_react_components_Dialog$Pop$()
  };
  return $n_Lcom_iz2use_react_components_Dialog$Pop$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Dialog$Push(f) {
  this.Lcom_iz2use_react_components_Dialog$Push__f_f = null;
  this.Lcom_iz2use_react_components_Dialog$Push__f_f = f
}
$c_Lcom_iz2use_react_components_Dialog$Push.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Dialog$Push.prototype.constructor = $c_Lcom_iz2use_react_components_Dialog$Push;
/** @constructor */
function $h_Lcom_iz2use_react_components_Dialog$Push() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Dialog$Push.prototype = $c_Lcom_iz2use_react_components_Dialog$Push.prototype;
$c_Lcom_iz2use_react_components_Dialog$Push.prototype.productPrefix__T = (function() {
  return "Push"
});
$c_Lcom_iz2use_react_components_Dialog$Push.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_Dialog$Push.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_Dialog$Push__f_f : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_Dialog$Push.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Dialog$Push.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_Dialog$Push.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_Dialog$Push.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_Dialog$Push)) {
    var Push$1 = $as_Lcom_iz2use_react_components_Dialog$Push(x$1);
    var x = this.Lcom_iz2use_react_components_Dialog$Push__f_f;
    var x$2 = $n(Push$1).Lcom_iz2use_react_components_Dialog$Push__f_f;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_Dialog$Push(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Dialog$Push) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Dialog$Push"))
}
function $isArrayOf_Lcom_iz2use_react_components_Dialog$Push(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Dialog$Push)))
}
function $asArrayOf_Lcom_iz2use_react_components_Dialog$Push(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Dialog$Push(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Dialog$Push;", depth))
}
var $d_Lcom_iz2use_react_components_Dialog$Push = new $TypeData().initClass({
  Lcom_iz2use_react_components_Dialog$Push: 0
}, false, "com.iz2use.react.components.Dialog$Push", {
  Lcom_iz2use_react_components_Dialog$Push: 1,
  O: 1,
  Lcom_iz2use_react_components_Dialog$Event: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Dialog$Push.prototype.$classData = $d_Lcom_iz2use_react_components_Dialog$Push;
/** @constructor */
function $c_Lcom_iz2use_react_components_Dialog$PushWithKey(key, f) {
  this.Lcom_iz2use_react_components_Dialog$PushWithKey__f_key = null;
  this.Lcom_iz2use_react_components_Dialog$PushWithKey__f_f = null;
  this.Lcom_iz2use_react_components_Dialog$PushWithKey__f_key = key;
  this.Lcom_iz2use_react_components_Dialog$PushWithKey__f_f = f
}
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype.constructor = $c_Lcom_iz2use_react_components_Dialog$PushWithKey;
/** @constructor */
function $h_Lcom_iz2use_react_components_Dialog$PushWithKey() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype = $c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype;
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype.productPrefix__T = (function() {
  return "PushWithKey"
});
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_Dialog$PushWithKey__f_key;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_Dialog$PushWithKey__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_Dialog$PushWithKey)) {
    var PushWithKey$1 = $as_Lcom_iz2use_react_components_Dialog$PushWithKey(x$1);
    var x = this.Lcom_iz2use_react_components_Dialog$PushWithKey__f_key;
    var x$2 = $n(PushWithKey$1).Lcom_iz2use_react_components_Dialog$PushWithKey__f_key;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_Dialog$PushWithKey__f_f;
      var x$4 = $n(PushWithKey$1).Lcom_iz2use_react_components_Dialog$PushWithKey__f_f;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_Dialog$PushWithKey(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_Dialog$PushWithKey) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.Dialog$PushWithKey"))
}
function $isArrayOf_Lcom_iz2use_react_components_Dialog$PushWithKey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_Dialog$PushWithKey)))
}
function $asArrayOf_Lcom_iz2use_react_components_Dialog$PushWithKey(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_Dialog$PushWithKey(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.Dialog$PushWithKey;", depth))
}
var $d_Lcom_iz2use_react_components_Dialog$PushWithKey = new $TypeData().initClass({
  Lcom_iz2use_react_components_Dialog$PushWithKey: 0
}, false, "com.iz2use.react.components.Dialog$PushWithKey", {
  Lcom_iz2use_react_components_Dialog$PushWithKey: 1,
  O: 1,
  Lcom_iz2use_react_components_Dialog$Event: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Dialog$PushWithKey.prototype.$classData = $d_Lcom_iz2use_react_components_Dialog$PushWithKey;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1(dispatch$1, criterion$1) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1__f_dispatch$1 = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1__f_criterion$1 = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1__f_dispatch$1 = dispatch$1;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1__f_criterion$1 = criterion$1
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(x1)) {
    $m_Ljapgolly_scalajs_react_Reusable$();
    var r = this.Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1__f_dispatch$1;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Lcom_iz2use_react_components_FetchCacheAndRender$QueryDispatcher($n(r).value__O())).failed__O__jl_Throwable__Ljapgolly_scalajs_react_callback_Trampoline(this.Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1__f_criterion$1, x1))
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return $m_s_util_control_NonFatal$().apply__jl_Throwable__Z(x1)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1", {
  Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$$anonfun$$nestedInanonfun$fetch$1$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed(criterion, throwable) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_criterion = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_throwable = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_criterion = criterion;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_throwable = throwable
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$Failed() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype.productPrefix__T = (function() {
  return "Failed"
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_criterion;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_throwable;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed)) {
    var Failed$1 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Failed(x$1);
    var x = this.Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_criterion;
    var y = $n(Failed$1).Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_criterion;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_throwable;
      var x$2$1 = $n(Failed$1).Lcom_iz2use_react_components_FetchCacheAndRender$Failed__f_throwable;
      return ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$Failed(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$Failed"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Failed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$Failed)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Failed(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Failed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$Failed;", depth))
}
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$Failed = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$Failed: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$Failed", {
  Lcom_iz2use_react_components_FetchCacheAndRender$Failed: 1,
  O: 1,
  Lcom_iz2use_react_components_FetchCacheAndRender$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Failed.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$Failed;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion(nextCriterion) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion__f_nextCriterion = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion__f_nextCriterion = nextCriterion
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype.productPrefix__T = (function() {
  return "NewCriterion"
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion__f_nextCriterion : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion)) {
    var NewCriterion$1 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion(x$1);
    var x = this.Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion__f_nextCriterion;
    var y = $n(NewCriterion$1).Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion__f_nextCriterion;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$NewCriterion"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$NewCriterion;", depth))
}
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$NewCriterion", {
  Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion: 1,
  O: 1,
  Lcom_iz2use_react_components_FetchCacheAndRender$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$NewCriterion;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache(nextUpdateCache) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache__f_nextUpdateCache = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache__f_nextUpdateCache = nextUpdateCache
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype.productPrefix__T = (function() {
  return "NewUpdateCache"
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache__f_nextUpdateCache : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache)) {
    var NewUpdateCache$1 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache(x$1);
    var x = this.Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache__f_nextUpdateCache;
    var x$2 = $n(NewUpdateCache$1).Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache__f_nextUpdateCache;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$NewUpdateCache"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$NewUpdateCache;", depth))
}
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$NewUpdateCache", {
  Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache: 1,
  O: 1,
  Lcom_iz2use_react_components_FetchCacheAndRender$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$NewUpdateCache;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending(criterion) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Pending__f_criterion = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Pending__f_criterion = criterion
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$Pending() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype.productPrefix__T = (function() {
  return "Pending"
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_FetchCacheAndRender$Pending__f_criterion : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending)) {
    var Pending$1 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Pending(x$1);
    var x = this.Lcom_iz2use_react_components_FetchCacheAndRender$Pending__f_criterion;
    var y = $n(Pending$1).Lcom_iz2use_react_components_FetchCacheAndRender$Pending__f_criterion;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$Pending(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$Pending"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Pending(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$Pending)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Pending(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Pending(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$Pending;", depth))
}
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$Pending = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$Pending: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$Pending", {
  Lcom_iz2use_react_components_FetchCacheAndRender$Pending: 1,
  O: 1,
  Lcom_iz2use_react_components_FetchCacheAndRender$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Pending.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$Pending;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$Success(criterion, data) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_criterion = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_data = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_criterion = criterion;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_data = data
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$Success;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$Success() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype.productPrefix__T = (function() {
  return "Success"
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_criterion;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_data;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Success)) {
    var Success$1 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$Success(x$1);
    var x = this.Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_criterion;
    var y = $n(Success$1).Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_criterion;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_data;
      var y$1 = $n(Success$1).Lcom_iz2use_react_components_FetchCacheAndRender$Success__f_data;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$Success(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$Success) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$Success"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$Success)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Success(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$Success;", depth))
}
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$Success = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$Success: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$Success", {
  Lcom_iz2use_react_components_FetchCacheAndRender$Success: 1,
  O: 1,
  Lcom_iz2use_react_components_FetchCacheAndRender$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$Success.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$Success;
/** @constructor */
function $c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache(value) {
  this.Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache__f_value = null;
  this.Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache__f_value = value
}
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype.constructor = $c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache;
/** @constructor */
function $h_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype = $c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype;
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype.productPrefix__T = (function() {
  return "UpdateCache"
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache)) {
    var UpdateCache$1 = $as_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache(x$1);
    var x = this.Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache__f_value;
    var y = $n(UpdateCache$1).Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.FetchCacheAndRender$UpdateCache"))
}
function $isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache)))
}
function $asArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.FetchCacheAndRender$UpdateCache;", depth))
}
var $d_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache = new $TypeData().initClass({
  Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache: 0
}, false, "com.iz2use.react.components.FetchCacheAndRender$UpdateCache", {
  Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache: 1,
  O: 1,
  Lcom_iz2use_react_components_FetchCacheAndRender$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache.prototype.$classData = $d_Lcom_iz2use_react_components_FetchCacheAndRender$UpdateCache;
/** @constructor */
function $c_Lcom_iz2use_react_components_FormContext$Empty$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.constructor = $c_Lcom_iz2use_react_components_FormContext$Empty$;
/** @constructor */
function $h_Lcom_iz2use_react_components_FormContext$Empty$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_FormContext$Empty$.prototype = $c_Lcom_iz2use_react_components_FormContext$Empty$.prototype;
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.registerOnSubmit__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
});
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.unregisterOnSubmit__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(f) {
  return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty
});
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.hashCode__I = (function() {
  return 67081517
});
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.toString__T = (function() {
  return "Empty"
});
var $d_Lcom_iz2use_react_components_FormContext$Empty$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_FormContext$Empty$: 0
}, false, "com.iz2use.react.components.FormContext$Empty$", {
  Lcom_iz2use_react_components_FormContext$Empty$: 1,
  O: 1,
  Lcom_iz2use_react_components_FormContext: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_FormContext$Empty$.prototype.$classData = $d_Lcom_iz2use_react_components_FormContext$Empty$;
var $n_Lcom_iz2use_react_components_FormContext$Empty$;
function $m_Lcom_iz2use_react_components_FormContext$Empty$() {
  if ((!$n_Lcom_iz2use_react_components_FormContext$Empty$)) {
    $n_Lcom_iz2use_react_components_FormContext$Empty$ = new $c_Lcom_iz2use_react_components_FormContext$Empty$()
  };
  return $n_Lcom_iz2use_react_components_FormContext$Empty$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_IconSourceShape(shapePath) {
  this.Lcom_iz2use_react_components_IconSourceShape__f_shapePath = null;
  this.Lcom_iz2use_react_components_IconSourceShape__f_shapePath = shapePath
}
$c_Lcom_iz2use_react_components_IconSourceShape.prototype = new $h_O();
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.constructor = $c_Lcom_iz2use_react_components_IconSourceShape;
/** @constructor */
function $h_Lcom_iz2use_react_components_IconSourceShape() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_IconSourceShape.prototype = $c_Lcom_iz2use_react_components_IconSourceShape.prototype;
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.renderWithoutStyling__Ljapgolly_scalajs_react_vdom_TagOf = (function() {
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$4 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "viewBox");
  var t = $m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$4.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0 0 24 24");
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$8 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$8.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "M0 0h24v24H0z");
  $n($m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$11 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
  var t$2 = $m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$11.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "none");
  $n($m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$14 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "opacity");
  var t$3 = $m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array = [$$x4, $$x3, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$14.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0")];
  var $$x2 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$21 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
  var a = this.Lcom_iz2use_react_components_IconSourceShape__f_shapePath;
  var t$4 = $m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var array$1 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$21.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a)];
  var array$2 = [$$x6, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
  return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("svg", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.render__Ljapgolly_scalajs_react_vdom_TagOf = (function() {
  var this$1 = $m_Lcom_iz2use_react_components_StyleConsumer$();
  var arg1 = this$1.Lcom_iz2use_react_components_StyleConsumer$__f_style;
  var $$x1 = $n(this.renderWithoutStyling__Ljapgolly_scalajs_react_vdom_TagOf());
  var this$2 = $m_Lscalacss_ScalaCssReact$();
  var s = $n(arg1).Lcom_iz2use_react_style_Style__f_icon;
  var array = [$f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$2, s)];
  return $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.productPrefix__T = (function() {
  return "IconSourceShape"
});
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_IconSourceShape__f_shapePath : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_IconSourceShape)) {
    var IconSourceShape$1 = $as_Lcom_iz2use_react_components_IconSourceShape(x$1);
    return (this.Lcom_iz2use_react_components_IconSourceShape__f_shapePath === $n(IconSourceShape$1).Lcom_iz2use_react_components_IconSourceShape__f_shapePath)
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_IconSourceShape(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_IconSourceShape) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.IconSourceShape"))
}
function $isArrayOf_Lcom_iz2use_react_components_IconSourceShape(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_IconSourceShape)))
}
function $asArrayOf_Lcom_iz2use_react_components_IconSourceShape(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_IconSourceShape(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.IconSourceShape;", depth))
}
var $d_Lcom_iz2use_react_components_IconSourceShape = new $TypeData().initClass({
  Lcom_iz2use_react_components_IconSourceShape: 0
}, false, "com.iz2use.react.components.IconSourceShape", {
  Lcom_iz2use_react_components_IconSourceShape: 1,
  O: 1,
  Lcom_iz2use_react_components_IconSource: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_IconSourceShape.prototype.$classData = $d_Lcom_iz2use_react_components_IconSourceShape;
/** @constructor */
function $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent(refiner, nextRenderer, iterable, reusabilityT, reusabilityC) {
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_refiner = null;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_nextRenderer = null;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_com$iz2use$react$components$MultiviewRefinerReactComponent$$iterable = null;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_component = null;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_refiner = refiner;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_nextRenderer = nextRenderer;
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_com$iz2use$react$components$MultiviewRefinerReactComponent$$iterable = iterable;
  $n(refiner).reusabilityState__F2__F1__F2(reusabilityT, reusabilityC);
  var this$9 = $n($n($n($m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().initialStateFromProps$extension__T__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step2("MultiviewRefiner", new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState(p$2);
    return $n($n(this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_refiner).handleNext__Lcom_iz2use_react_components_internal_multiview_MultiviewState__s_Option__s_Option__Lcom_iz2use_react_components_internal_multiview_HasIterator__s_Option(p, $m_s_None$(), $m_s_None$(), this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_com$iz2use$react$components$MultiviewRefinerReactComponent$$iterable)).get__O()
  })))).backend__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step3(new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(x$2);
    return new $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$Backend(this, x)
  })))).renderWith__F1__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(x$3$2);
    var $$x2 = $n($as_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend($n(x$3).backend__O()));
    var this$4 = $n(x$3);
    var $$x1 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState($n(this$4.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var this$5 = $n(x$3);
    return $n($$x2).render__Lcom_iz2use_react_components_internal_multiview_MultiviewState__O__Ljapgolly_scalajs_react_vdom_VdomElement($$x1, $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$5))
  }))));
  var f = new $c_sjsr_AnonFunction1(((c$2) => {
    var c = $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(c$2);
    var $$x5 = $as_Lcom_iz2use_react_components_MultiviewRefinerReactComponent$TypedBackend($n(c).backend__O());
    var this$6 = $n(c);
    var $$x4 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState($n(this$6.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O());
    var $$x3 = $as_Lcom_iz2use_react_components_internal_multiview_MultiviewState($n(c).Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps);
    var this$7 = $n(c);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x5).onPropsChange__Lcom_iz2use_react_components_internal_multiview_MultiviewState__Lcom_iz2use_react_components_internal_multiview_MultiviewState__O__Ljapgolly_scalajs_react_callback_Trampoline($$x4, $$x3, $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this$7)))
  }));
  var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_component = $n($p_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep__lcAppendDispatch__Ljapgolly_scalajs_react_internal_Lens__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_component_builder_ComponentBuilder$LastStep(this$9, $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().componentWillReceiveProps__Ljapgolly_scalajs_react_internal_Lens(), f, G)).build__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null)))
}
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype = new $h_O();
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.constructor = $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent;
/** @constructor */
function $h_Lcom_iz2use_react_components_MultiviewRefinerReactComponent() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype = $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype;
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.apply__Lcom_iz2use_react_components_internal_multiview_MultiviewState__Ljapgolly_scalajs_react_vdom_VdomElement = (function(in$1) {
  var c = this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(in$1, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.productPrefix__T = (function() {
  return "MultiviewRefinerReactComponent"
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_refiner;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_nextRenderer;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent)) {
    var MultiviewRefinerReactComponent$1 = $as_Lcom_iz2use_react_components_MultiviewRefinerReactComponent(x$1);
    var x = this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_refiner;
    var x$2 = $n(MultiviewRefinerReactComponent$1).Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_refiner;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_nextRenderer;
      var x$4 = $n(MultiviewRefinerReactComponent$1).Lcom_iz2use_react_components_MultiviewRefinerReactComponent__f_nextRenderer;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_MultiviewRefinerReactComponent(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.MultiviewRefinerReactComponent"))
}
function $isArrayOf_Lcom_iz2use_react_components_MultiviewRefinerReactComponent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_MultiviewRefinerReactComponent)))
}
function $asArrayOf_Lcom_iz2use_react_components_MultiviewRefinerReactComponent(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_MultiviewRefinerReactComponent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.MultiviewRefinerReactComponent;", depth))
}
var $d_Lcom_iz2use_react_components_MultiviewRefinerReactComponent = new $TypeData().initClass({
  Lcom_iz2use_react_components_MultiviewRefinerReactComponent: 0
}, false, "com.iz2use.react.components.MultiviewRefinerReactComponent", {
  Lcom_iz2use_react_components_MultiviewRefinerReactComponent: 1,
  O: 1,
  Lcom_iz2use_react_components_NextRefinerRenderer: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_MultiviewRefinerReactComponent.prototype.$classData = $d_Lcom_iz2use_react_components_MultiviewRefinerReactComponent;
/** @constructor */
function $c_Lcom_iz2use_react_components_NoIconSource$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_NoIconSource$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_NoIconSource$.prototype.constructor = $c_Lcom_iz2use_react_components_NoIconSource$;
/** @constructor */
function $h_Lcom_iz2use_react_components_NoIconSource$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_NoIconSource$.prototype = $c_Lcom_iz2use_react_components_NoIconSource$.prototype;
$c_Lcom_iz2use_react_components_NoIconSource$.prototype.render__Ljapgolly_scalajs_react_vdom_TagOf = (function() {
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
  var array = [this$3.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("none", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_NoIconSource$.prototype.productPrefix__T = (function() {
  return "NoIconSource"
});
$c_Lcom_iz2use_react_components_NoIconSource$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_NoIconSource$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_NoIconSource$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_NoIconSource$.prototype.hashCode__I = (function() {
  return 1077367477
});
$c_Lcom_iz2use_react_components_NoIconSource$.prototype.toString__T = (function() {
  return "NoIconSource"
});
var $d_Lcom_iz2use_react_components_NoIconSource$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_NoIconSource$: 0
}, false, "com.iz2use.react.components.NoIconSource$", {
  Lcom_iz2use_react_components_NoIconSource$: 1,
  O: 1,
  Lcom_iz2use_react_components_IconSource: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_NoIconSource$.prototype.$classData = $d_Lcom_iz2use_react_components_NoIconSource$;
var $n_Lcom_iz2use_react_components_NoIconSource$;
function $m_Lcom_iz2use_react_components_NoIconSource$() {
  if ((!$n_Lcom_iz2use_react_components_NoIconSource$)) {
    $n_Lcom_iz2use_react_components_NoIconSource$ = new $c_Lcom_iz2use_react_components_NoIconSource$()
  };
  return $n_Lcom_iz2use_react_components_NoIconSource$
}
function $p_Lcom_iz2use_react_components_Platform$__isMobile$lzycompute__Z($thiz) {
  if ((!$thiz.Lcom_iz2use_react_components_Platform$__f_bitmap$0)) {
    $thiz.Lcom_iz2use_react_components_Platform$__f_isMobile = $f_Lcom_iz2use_react_components_Platform__isMobile__Z($thiz);
    $thiz.Lcom_iz2use_react_components_Platform$__f_bitmap$0 = true
  };
  return $thiz.Lcom_iz2use_react_components_Platform$__f_isMobile
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Platform$() {
  this.Lcom_iz2use_react_components_Platform$__f_isMobile = false;
  this.Lcom_iz2use_react_components_Platform$__f_bitmap$0 = false
}
$c_Lcom_iz2use_react_components_Platform$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Platform$.prototype.constructor = $c_Lcom_iz2use_react_components_Platform$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Platform$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Platform$.prototype = $c_Lcom_iz2use_react_components_Platform$.prototype;
$c_Lcom_iz2use_react_components_Platform$.prototype.isMobile__Z = (function() {
  return ((!this.Lcom_iz2use_react_components_Platform$__f_bitmap$0) ? $p_Lcom_iz2use_react_components_Platform$__isMobile$lzycompute__Z(this) : this.Lcom_iz2use_react_components_Platform$__f_isMobile)
});
$c_Lcom_iz2use_react_components_Platform$.prototype.productPrefix__T = (function() {
  return "Platform"
});
$c_Lcom_iz2use_react_components_Platform$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_Platform$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_Platform$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Platform$.prototype.hashCode__I = (function() {
  return 1939328147
});
$c_Lcom_iz2use_react_components_Platform$.prototype.toString__T = (function() {
  return "Platform"
});
var $d_Lcom_iz2use_react_components_Platform$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Platform$: 0
}, false, "com.iz2use.react.components.Platform$", {
  Lcom_iz2use_react_components_Platform$: 1,
  O: 1,
  Lcom_iz2use_react_components_Platform: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Platform$.prototype.$classData = $d_Lcom_iz2use_react_components_Platform$;
var $n_Lcom_iz2use_react_components_Platform$;
function $m_Lcom_iz2use_react_components_Platform$() {
  if ((!$n_Lcom_iz2use_react_components_Platform$)) {
    $n_Lcom_iz2use_react_components_Platform$ = new $c_Lcom_iz2use_react_components_Platform$()
  };
  return $n_Lcom_iz2use_react_components_Platform$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1(outer, key$2, p$1) {
  this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_$outer = null;
  this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_key$2 = null;
  this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_p$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_$outer = outer
  };
  this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_key$2 = key$2;
  this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_p$1 = p$1
}
$c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1.prototype = $c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1.prototype;
$c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  switch (x1) {
    case 37: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_$outer).com$iz2use$react$components$Selector$$nestedInanon$1$$moveItem$1__T__I__Lcom_iz2use_react_components_Selector$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline(this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_key$2, (-1), this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_p$1));
      break
    }
    case 39: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_$outer).com$iz2use$react$components$Selector$$nestedInanon$1$$moveItem$1__T__I__Lcom_iz2use_react_components_Selector$TypedProps__Ljapgolly_scalajs_react_callback_Trampoline(this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_key$2, 1, this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_p$1));
      break
    }
    case 46:
    case 8: {
      if ($n(this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_p$1).Lcom_iz2use_react_components_Selector$TypedProps__f_deleteable) {
        var this$1 = $n($n(this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_p$1).Lcom_iz2use_react_components_Selector$TypedProps__f_active);
        var callback = new $c_sjsr_AnonFunction0((() => {
          var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
        }));
        var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var G = this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
        var arg1 = this$1.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
        var x$2 = $as_sci_List(arg1);
        var this$6 = $n(x$2);
        var f = ((x$3$2) => {
          var x = $n($n(this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_p$1).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(x$3$2);
          var x$2$1 = this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_key$2;
          return (!((x === null) ? (x$2$1 === null) : $dp_equals__O__Z($n(x), x$2$1)))
        });
        var l = this$6;
        block: {
          var result;
          while (true) {
            if ($n(l).isEmpty__Z()) {
              var result = $m_sci_Nil$();
              break
            } else {
              var h = $n(l).head__O();
              var t = $as_sci_List($n(l).tail__O());
              if (($uZ(f(h)) === false)) {
                l = t;
                continue
              };
              var start = l;
              var remaining = t;
              while (true) {
                if ($n(remaining).isEmpty__Z()) {
                  var result = start;
                  break block
                } else {
                  var x$1 = $n(remaining).head__O();
                  if (($uZ(f(x$1)) !== false)) {
                    remaining = $as_sci_List($n(remaining).tail__O());
                    continue
                  };
                  var firstMiss = remaining;
                  var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                  var toProcess = $as_sci_List($n(start).tail__O());
                  var currentLast = newHead;
                  while ((toProcess !== firstMiss)) {
                    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem;
                    currentLast = newElem;
                    toProcess = $as_sci_List($n(toProcess).tail__O())
                  };
                  var next = $as_sci_List($n(firstMiss).tail__O());
                  var nextToCopy = next;
                  while ((!$n(next).isEmpty__Z())) {
                    var head = $n(next).head__O();
                    if (($uZ(f(head)) !== false)) {
                      next = $as_sci_List($n(next).tail__O())
                    } else {
                      while ((nextToCopy !== next)) {
                        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                        currentLast = newElem$2;
                        nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                      };
                      nextToCopy = $as_sci_List($n(next).tail__O());
                      next = $as_sci_List($n(next).tail__O())
                    }
                  };
                  if ((!$n(nextToCopy).isEmpty__Z())) {
                    $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                  };
                  var result = newHead;
                  break block
                }
              }
            }
          }
        };
        return this$1.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(result), callback, G)
      };
      break
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1.prototype.isDefinedAt__I__Z = (function(x1) {
  switch (x1) {
    case 37: {
      return true;
      break
    }
    case 39: {
      return true;
      break
    }
    case 46:
    case 8: {
      if ($n(this.Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1__f_p$1).Lcom_iz2use_react_components_Selector$TypedProps__f_deleteable) {
        return true
      };
      break
    }
  };
  return false
});
$c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1: 0
}, false, "com.iz2use.react.components.Selector$$anon$1$$anonfun$1", {
  Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$$anon$1$$anonfun$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2(outer, p$4, s$2, reset$1, modState$2) {
  this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_$outer = null;
  this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4 = null;
  this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_s$2 = null;
  this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_reset$1 = null;
  this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_modState$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_$outer = outer
  };
  this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4 = p$4;
  this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_s$2 = s$2;
  this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_reset$1 = reset$1;
  this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_modState$2 = modState$2
}
$c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2.prototype = $c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2.prototype;
$c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  switch (x1) {
    case 37: {
      $n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_$outer);
      var s$2 = this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_s$2;
      var p$4 = this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4;
      var modState$2 = this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_modState$2;
      var x = $m_s_None$();
      if ((x === s$2)) {
        var this$2 = $n($n(p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_items);
        var elem = $n(p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_active;
        var idx = this$2.indexOf__O__I__I(elem, 0)
      } else {
        if ((!(s$2 instanceof $c_s_Some))) {
          throw new $c_s_MatchError(s$2)
        };
        var x3 = $as_s_Some(s$2);
        var key = $as_T($n(x3).s_Some__f_value);
        var this$3 = $n($n(p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_items);
        var p = new $c_sjsr_AnonFunction1(((x$10$2) => {
          var x$1 = $n($n(p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(x$10$2);
          return ((x$1 === null) ? (key === null) : $dp_equals__O__Z($n(x$1), key))
        }));
        var idx = this$3.indexWhere__F1__I__I(p, 0)
      };
      var nView = ((idx <= 0) ? $n($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_items).last__O() : $n($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_items).apply__I__O((((-1) + idx) | 0)));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(modState$2).apply__O__O(new $c_sjsr_AnonFunction1(((x$11$2) => {
        $as_s_Option(x$11$2);
        return new $c_s_Some($n($n(p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(nView))
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
      break
    }
    case 39: {
      $n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_$outer);
      var s$2$1 = this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_s$2;
      var p$4$1 = this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4;
      var modState$2$1 = this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_modState$2;
      var x$2 = $m_s_None$();
      if ((x$2 === s$2$1)) {
        var this$5 = $n($n(p$4$1).Lcom_iz2use_react_components_Selector$TypedProps__f_items);
        var elem$1 = $n(p$4$1).Lcom_iz2use_react_components_Selector$TypedProps__f_active;
        var idx$1 = this$5.indexOf__O__I__I(elem$1, 0)
      } else {
        if ((!(s$2$1 instanceof $c_s_Some))) {
          throw new $c_s_MatchError(s$2$1)
        };
        var x3$1 = $as_s_Some(s$2$1);
        var key$1 = $as_T($n(x3$1).s_Some__f_value);
        var this$6 = $n($n(p$4$1).Lcom_iz2use_react_components_Selector$TypedProps__f_items);
        var p$1 = new $c_sjsr_AnonFunction1(((x$10$2$1) => {
          var x$3 = $n($n(p$4$1).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(x$10$2$1);
          return ((x$3 === null) ? (key$1 === null) : $dp_equals__O__Z($n(x$3), key$1))
        }));
        var idx$1 = this$6.indexWhere__F1__I__I(p$1, 0)
      };
      var nView$1 = ((idx$1 >= (((-1) + $n($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_items).length__I()) | 0)) ? $n($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_items).head__O() : $n($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_items).apply__I__O(((1 + idx$1) | 0)));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(modState$2$1).apply__O__O(new $c_sjsr_AnonFunction1(((x$11$2$1) => {
        $as_s_Option(x$11$2$1);
        return new $c_s_Some($n($n(p$4$1).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(nView$1))
      }))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
      break
    }
    case 32:
    case 13: {
      var this$7 = $n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_s$2);
      if (this$7.isEmpty__Z()) {
        var newActive = $m_s_None$()
      } else {
        var arg1 = this$7.get__O();
        var key$2 = $as_T(arg1);
        var this$9 = $n($n($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_items).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$12$2) => {
          var x$4 = $n($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_keyMapper).apply__O__O(x$12$2);
          return ((x$4 === null) ? (key$2 === null) : $dp_equals__O__Z($n(x$4), key$2))
        }))));
        if (this$9.isEmpty__Z()) {
          var newActive = $m_s_None$()
        } else {
          var arg1$1 = this$9.get__O();
          var newActive = new $c_s_Some(arg1$1)
        }
      };
      var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      var this$11 = $n($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_active);
      var this$10 = $n(newActive);
      var newState = (this$10.isEmpty__Z() ? $n($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_p$4).Lcom_iz2use_react_components_Selector$TypedProps__f_active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value : this$10.get__O());
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__O(this$11, newState))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_reset$1).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
      break
    }
    case 27: {
      return $n(this.Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2__f_reset$1).apply__O();
      break
    }
    default: {
      return $n(default$1).apply__O__O(x1)
    }
  }
});
$c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2.prototype.isDefinedAt__I__Z = (function(x1) {
  switch (x1) {
    case 37: {
      return true;
      break
    }
    case 39: {
      return true;
      break
    }
    case 32:
    case 13: {
      return true;
      break
    }
    case 27: {
      return true;
      break
    }
    default: {
      return false
    }
  }
});
$c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2: 0
}, false, "com.iz2use.react.components.Selector$$anon$2$$anonfun$2", {
  Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$$anon$2$$anonfun$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$Active$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Selector$Active$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$Active$.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$Active$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$Active$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$Active$.prototype = $c_Lcom_iz2use_react_components_Selector$Active$.prototype;
$c_Lcom_iz2use_react_components_Selector$Active$.prototype.productPrefix__T = (function() {
  return "Active"
});
$c_Lcom_iz2use_react_components_Selector$Active$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_Selector$Active$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_Selector$Active$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Selector$Active$.prototype.hashCode__I = (function() {
  return 1955883814
});
$c_Lcom_iz2use_react_components_Selector$Active$.prototype.toString__T = (function() {
  return "Active"
});
var $d_Lcom_iz2use_react_components_Selector$Active$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$Active$: 0
}, false, "com.iz2use.react.components.Selector$Active$", {
  Lcom_iz2use_react_components_Selector$Active$: 1,
  O: 1,
  Lcom_iz2use_react_components_Selector$ItemState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Selector$Active$.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$Active$;
var $n_Lcom_iz2use_react_components_Selector$Active$;
function $m_Lcom_iz2use_react_components_Selector$Active$() {
  if ((!$n_Lcom_iz2use_react_components_Selector$Active$)) {
    $n_Lcom_iz2use_react_components_Selector$Active$ = new $c_Lcom_iz2use_react_components_Selector$Active$()
  };
  return $n_Lcom_iz2use_react_components_Selector$Active$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$Focused$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Selector$Focused$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$Focused$.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$Focused$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$Focused$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$Focused$.prototype = $c_Lcom_iz2use_react_components_Selector$Focused$.prototype;
$c_Lcom_iz2use_react_components_Selector$Focused$.prototype.productPrefix__T = (function() {
  return "Focused"
});
$c_Lcom_iz2use_react_components_Selector$Focused$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_Selector$Focused$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_Selector$Focused$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Selector$Focused$.prototype.hashCode__I = (function() {
  return 973611863
});
$c_Lcom_iz2use_react_components_Selector$Focused$.prototype.toString__T = (function() {
  return "Focused"
});
var $d_Lcom_iz2use_react_components_Selector$Focused$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$Focused$: 0
}, false, "com.iz2use.react.components.Selector$Focused$", {
  Lcom_iz2use_react_components_Selector$Focused$: 1,
  O: 1,
  Lcom_iz2use_react_components_Selector$ItemState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Selector$Focused$.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$Focused$;
var $n_Lcom_iz2use_react_components_Selector$Focused$;
function $m_Lcom_iz2use_react_components_Selector$Focused$() {
  if ((!$n_Lcom_iz2use_react_components_Selector$Focused$)) {
    $n_Lcom_iz2use_react_components_Selector$Focused$ = new $c_Lcom_iz2use_react_components_Selector$Focused$()
  };
  return $n_Lcom_iz2use_react_components_Selector$Focused$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Selector$Idle$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Selector$Idle$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Selector$Idle$.prototype.constructor = $c_Lcom_iz2use_react_components_Selector$Idle$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Selector$Idle$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Selector$Idle$.prototype = $c_Lcom_iz2use_react_components_Selector$Idle$.prototype;
$c_Lcom_iz2use_react_components_Selector$Idle$.prototype.productPrefix__T = (function() {
  return "Idle"
});
$c_Lcom_iz2use_react_components_Selector$Idle$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_Selector$Idle$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_Selector$Idle$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Selector$Idle$.prototype.hashCode__I = (function() {
  return 2274292
});
$c_Lcom_iz2use_react_components_Selector$Idle$.prototype.toString__T = (function() {
  return "Idle"
});
var $d_Lcom_iz2use_react_components_Selector$Idle$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Selector$Idle$: 0
}, false, "com.iz2use.react.components.Selector$Idle$", {
  Lcom_iz2use_react_components_Selector$Idle$: 1,
  O: 1,
  Lcom_iz2use_react_components_Selector$ItemState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Selector$Idle$.prototype.$classData = $d_Lcom_iz2use_react_components_Selector$Idle$;
var $n_Lcom_iz2use_react_components_Selector$Idle$;
function $m_Lcom_iz2use_react_components_Selector$Idle$() {
  if ((!$n_Lcom_iz2use_react_components_Selector$Idle$)) {
    $n_Lcom_iz2use_react_components_Selector$Idle$ = new $c_Lcom_iz2use_react_components_Selector$Idle$()
  };
  return $n_Lcom_iz2use_react_components_Selector$Idle$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster() {
  this.Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this)
}
$c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster.prototype.constructor = $c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster.prototype = $c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster.prototype;
$c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster.prototype.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = x$1
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster.prototype.broadcast__Ljapgolly_scalajs_react_facade_SyntheticKeyboardEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(e) {
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_extra_BroadcasterF__broadcast__O__O(this, e))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
var $d_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster: 0
}, false, "com.iz2use.react.components.internal.TextEditorContext$KeyDownBroadcaster", {
  Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_Broadcaster: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1,
  Ljapgolly_scalajs_react_extra_Listenable: 1
});
$c_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster.prototype.$classData = $d_Lcom_iz2use_react_components_internal_TextEditorContext$KeyDownBroadcaster;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1(outer, p$6, s$3) {
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1__f_$outer = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1__f_p$6 = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1__f_s$3 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1__f_$outer = outer
  };
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1__f_p$6 = p$6;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1__f_s$3 = s$3
}
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1.prototype = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1.prototype;
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  return ((x1 === 13) ? new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1__f_$outer).update__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1__f_p$6, this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1__f_s$3)) : $n(default$1).apply__O__O(x1))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1.prototype.isDefinedAt__I__Z = (function(x1) {
  return (x1 === 13)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1: 0
}, false, "com.iz2use.react.components.internal.editor.TextComponent$TypedBackend$$anonfun$1", {
  Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2(outer, p$6) {
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2__f_$outer = null;
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2__f_p$6 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2__f_$outer = outer
  };
  this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2__f_p$6 = p$6
}
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2.prototype = $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2.prototype;
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2.prototype.applyOrElse__I__F1__O = (function(x2, default$1) {
  if ((x2 === 27)) {
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$9 = $n($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2__f_$outer).Lcom_iz2use_react_components_internal_editor_TextComponent$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(s$2);
      $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_value);
      var value = $n($n(this.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2__f_p$6).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedProps__f_optioner).none__O();
      var x$1 = new $c_Ldiode_data_Ready(value);
      $n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text);
      var x$2 = new $c_Ldiode_data_Ready("");
      var x$3 = (!$n($n(s).Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_text).contains__O__Z(""));
      var this$4 = $n(s);
      var x$4 = this$4.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_lastText;
      var this$5 = $n(s);
      var x$5 = this$5.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_focused;
      var this$6 = $n(s);
      var x$6 = this$6.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_collapsed;
      var this$7 = $n(s);
      var x$7 = this$7.Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState__f_loaded;
      $n(s);
      return new $c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedState(x$1, x$4, x$2, x$3, x$5, x$6, x$7)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).when$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$9, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction0((() => true))))
  } else {
    return $n(default$1).apply__O__O(x2)
  }
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2.prototype.isDefinedAt__I__Z = (function(x2) {
  return (x2 === 27)
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2: 0
}, false, "com.iz2use.react.components.internal.editor.TextComponent$TypedBackend$$anonfun$2", {
  Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_editor_TextComponent$TypedBackend$$anonfun$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1(outer, axesContext$1) {
  this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1__f_axesContext$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1__f_axesContext$1 = axesContext$1
}
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  return ((((x1 === 13) || (x1 === 32)) && $n($n(this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1__f_axesContext$1).activateFocused__s_PartialFunction()).isDefinedAt__O__Z((void 0))) ? $n($n(this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1__f_axesContext$1).activateFocused__s_PartialFunction()).apply__O__O((void 0)) : $n(default$1).apply__O__O(x1))
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1.prototype.isDefinedAt__I__Z = (function(x1) {
  return (((x1 === 13) || (x1 === 32)) && $n($n(this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1__f_axesContext$1).activateFocused__s_PartialFunction()).isDefinedAt__O__Z((void 0)))
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1: 0
}, false, "com.iz2use.react.components.internal.multiview.Axes$$anonfun$activateKey$1", {
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$activateKey$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  switch (x1) {
    case 36: {
      return $m_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$();
      break
    }
    case 35: {
      return $m_Lcom_iz2use_react_components_internal_multiview_Direction$Next$();
      break
    }
    default: {
      return $n(default$1).apply__O__O(x1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1.prototype.isDefinedAt__I__Z = (function(x1) {
  switch (x1) {
    case 36: {
      return true;
      break
    }
    case 35: {
      return true;
      break
    }
    default: {
      return false
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1: 0
}, false, "com.iz2use.react.components.internal.multiview.Axes$$anonfun$boundKeys$1", {
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$boundKeys$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  switch (x1) {
    case 37: {
      return $m_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$();
      break
    }
    case 39: {
      return $m_Lcom_iz2use_react_components_internal_multiview_Direction$Next$();
      break
    }
    default: {
      return $n(default$1).apply__O__O(x1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1.prototype.isDefinedAt__I__Z = (function(x1) {
  switch (x1) {
    case 37: {
      return true;
      break
    }
    case 39: {
      return true;
      break
    }
    default: {
      return false
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1: 0
}, false, "com.iz2use.react.components.internal.multiview.Axes$$anonfun$horizontalKeys$1", {
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1(outer, axesContext$2) {
  this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1__f_axesContext$2 = null;
  this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1__f_axesContext$2 = axesContext$2
}
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  return (((x1 === 32) && $n($n(this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1__f_axesContext$2).toggleSelectionState__s_PartialFunction()).isDefinedAt__O__Z((void 0))) ? $n($n(this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1__f_axesContext$2).toggleSelectionState__s_PartialFunction()).apply__O__O((void 0)) : $n(default$1).apply__O__O(x1))
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1.prototype.isDefinedAt__I__Z = (function(x1) {
  return ((x1 === 32) && $n($n(this.Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1__f_axesContext$2).toggleSelectionState__s_PartialFunction()).isDefinedAt__O__Z((void 0)))
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1: 0
}, false, "com.iz2use.react.components.internal.multiview.Axes$$anonfun$selectKey$1", {
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$selectKey$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  switch (x1) {
    case 38: {
      return $m_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$();
      break
    }
    case 40: {
      return $m_Lcom_iz2use_react_components_internal_multiview_Direction$Next$();
      break
    }
    default: {
      return $n(default$1).apply__O__O(x1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1.prototype.isDefinedAt__I__Z = (function(x1) {
  switch (x1) {
    case 38: {
      return true;
      break
    }
    case 40: {
      return true;
      break
    }
    default: {
      return false
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1: 0
}, false, "com.iz2use.react.components.internal.multiview.Axes$$anonfun$verticalKeys$1", {
  Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$() {
  this.Lcom_iz2use_react_components_internal_multiview_Axes__f_primaryAxis = null;
  this.Lcom_iz2use_react_components_internal_multiview_Axes__f_secondaryAxis = null;
  $ct_Lcom_iz2use_react_components_internal_multiview_Axes__s_PartialFunction__s_PartialFunction__(this, new $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$horizontalKeys$1(), $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf)
}
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_Axes();
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype.productPrefix__T = (function() {
  return "Horizontal"
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype.hashCode__I = (function() {
  return (-913872828)
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype.toString__T = (function() {
  return "Horizontal"
});
var $d_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$: 0
}, false, "com.iz2use.react.components.internal.multiview.Axes$Horizontal$", {
  Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$: 1,
  Lcom_iz2use_react_components_internal_multiview_Axes: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$;
var $n_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$;
function $m_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$ = new $c_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_Axes$Horizontal$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$() {
  this.Lcom_iz2use_react_components_internal_multiview_Axes__f_primaryAxis = null;
  this.Lcom_iz2use_react_components_internal_multiview_Axes__f_secondaryAxis = null;
  $ct_Lcom_iz2use_react_components_internal_multiview_Axes__s_PartialFunction__s_PartialFunction__(this, new $c_Lcom_iz2use_react_components_internal_multiview_Axes$$anonfun$verticalKeys$1(), $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf)
}
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_Axes();
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype.productPrefix__T = (function() {
  return "Vertical"
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype.hashCode__I = (function() {
  return (-1919497322)
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype.toString__T = (function() {
  return "Vertical"
});
var $d_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$: 0
}, false, "com.iz2use.react.components.internal.multiview.Axes$Vertical$", {
  Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$: 1,
  Lcom_iz2use_react_components_internal_multiview_Axes: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$;
var $n_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$;
function $m_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$ = new $c_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_Axes$Vertical$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$() {
  $ct_Lcom_iz2use_react_components_internal_multiview_Direction__I__(this, 1)
}
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_Direction();
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Direction$Next$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype.fold__F0__F0__O = (function(before, after) {
  return $n(after).apply__O()
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype.productPrefix__T = (function() {
  return "Next"
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype.hashCode__I = (function() {
  return 2424595
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype.toString__T = (function() {
  return "Next"
});
var $d_Lcom_iz2use_react_components_internal_multiview_Direction$Next$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Direction$Next$: 0
}, false, "com.iz2use.react.components.internal.multiview.Direction$Next$", {
  Lcom_iz2use_react_components_internal_multiview_Direction$Next$: 1,
  Lcom_iz2use_react_components_internal_multiview_Direction: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Direction$Next$;
var $n_Lcom_iz2use_react_components_internal_multiview_Direction$Next$;
function $m_Lcom_iz2use_react_components_internal_multiview_Direction$Next$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_Direction$Next$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_Direction$Next$ = new $c_Lcom_iz2use_react_components_internal_multiview_Direction$Next$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_Direction$Next$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$() {
  $ct_Lcom_iz2use_react_components_internal_multiview_Direction__I__(this, (-1))
}
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype = new $h_Lcom_iz2use_react_components_internal_multiview_Direction();
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype = $c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype.fold__F0__F0__O = (function(before, after) {
  return $n(before).apply__O()
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype.productPrefix__T = (function() {
  return "Previous"
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype.hashCode__I = (function() {
  return (-1209131241)
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype.toString__T = (function() {
  return "Previous"
});
var $d_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_Direction$Previous$: 0
}, false, "com.iz2use.react.components.internal.multiview.Direction$Previous$", {
  Lcom_iz2use_react_components_internal_multiview_Direction$Previous$: 1,
  Lcom_iz2use_react_components_internal_multiview_Direction: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$;
var $n_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$;
function $m_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$() {
  if ((!$n_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$)) {
    $n_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$ = new $c_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$()
  };
  return $n_Lcom_iz2use_react_components_internal_multiview_Direction$Previous$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1(outer) {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1.prototype.applyOrElse__Lcom_iz2use_react_components_internal_multiview_MatchingField__F1__O = (function(x1, default$1) {
  var this$1 = $n($n($n($n(x1).Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_ordering);
  if ((!this$1.isEmpty__Z())) {
    return $n(x1).apply__F1()
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1.prototype.isDefinedAt__Lcom_iz2use_react_components_internal_multiview_MatchingField__Z = (function(x1) {
  var this$1 = $n($n($n($n(x1).Lcom_iz2use_react_components_internal_multiview_MatchingField__f_field).Lcom_iz2use_react_components_internal_multiview_FieldRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_FieldRenderable__f_ordering);
  return (!this$1.isEmpty__Z())
});
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lcom_iz2use_react_components_internal_multiview_MatchingField__Z($as_Lcom_iz2use_react_components_internal_multiview_MatchingField(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lcom_iz2use_react_components_internal_multiview_MatchingField__F1__O($as_Lcom_iz2use_react_components_internal_multiview_MatchingField(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1: 0
}, false, "com.iz2use.react.components.internal.multiview.FilterRefiner$$anonfun$1", {
  Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_FilterRefiner$$anonfun$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1(search$1) {
  this.Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1__f_search$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1__f_search$1 = search$1
}
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  var this$1 = $n($as_T($n(x1)._1__O()));
  var prefix = this.Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1__f_search$1;
  if ((this$1.length >= 0)) {
    var this$2 = $n(prefix);
    var $$x2 = this$1.substring(0, this$2.length);
    var $$x1 = ($as_T($$x2) === prefix)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $n(x1)._2__O()
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  var this$1 = $n($as_T($n(x1)._1__O()));
  var prefix = this.Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1__f_search$1;
  if ((this$1.length >= 0)) {
    var this$2 = $n(prefix);
    var $$x1 = this$1.substring(0, this$2.length);
    return ($as_T($$x1) === prefix)
  } else {
    return false
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1: 0
}, false, "com.iz2use.react.components.internal.multiview.QueryParser$$anonfun$1", {
  Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_QueryParser$$anonfun$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError(fieldName, message) {
  this.Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_fieldName = null;
  this.Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_message = null;
  this.Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_fieldName = fieldName;
  this.Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_message = message
}
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype = $c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype.productPrefix__T = (function() {
  return "QueryParserFieldError"
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_fieldName;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_message;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError)) {
    var QueryParserFieldError$1 = $as_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError(x$1);
    return ((this.Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_fieldName === $n(QueryParserFieldError$1).Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_fieldName) && (this.Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_message === $n(QueryParserFieldError$1).Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError__f_message))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.QueryParserFieldError"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.QueryParserFieldError;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError: 0
}, false, "com.iz2use.react.components.internal.multiview.QueryParserFieldError", {
  Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_QueryParserError: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_QueryParserFieldError;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError(message) {
  this.Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError__f_message = null;
  this.Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError__f_message = message
}
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype = $c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype.productPrefix__T = (function() {
  return "QueryParserOtherError"
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError__f_message : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError)) {
    var QueryParserOtherError$1 = $as_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError(x$1);
    return (this.Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError__f_message === $n(QueryParserOtherError$1).Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError__f_message)
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.QueryParserOtherError"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.QueryParserOtherError;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError: 0
}, false, "com.iz2use.react.components.internal.multiview.QueryParserOtherError", {
  Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_QueryParserError: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_QueryParserOtherError;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState(outer, results, filtered) {
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_results = null;
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_filtered = null;
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_$outer = null;
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_results = results;
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_filtered = filtered;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.noMatched__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$NotMatchedTypedState = (function(iterable) {
  return new $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState(this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_$outer, $n(this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_results).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((results$2) => $n(iterable).map__O__F1__O(results$2, new $c_sjsr_AnonFunction1(((i$2) => {
    var i = $as_T3(i$2);
    return $ct_T2__O__O__(new $c_T2(), $n(i).T3__f__1, $n(i).T3__f__2)
  })))))))
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.matched__s_Option__F1__F1__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState = (function(lastState, tokenizer, matching, iterable, keyMapper) {
  window.performance.mark("SearchResults.matching.start");
  var r = $n($n(this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_$outer).MatchedTypedState__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$()).from__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState($n(this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_results).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((results$2) => $n(iterable).map__O__F1__O(results$2, new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_T3(in$2);
    var v = $as_Lcom_iz2use_common_TokenMatches($n(matching).apply__O__O($n(in$1).T3__f__2));
    return new $c_T3($n(in$1).T3__f__1, $n(in$1).T3__f__2, v)
  })))))), iterable);
  window.performance.mark("SearchResults.matching.end");
  window.performance.measure("SearchResults.matching", "SearchResults.matching.start", "SearchResults.matching.end");
  return r
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.productPrefix__T = (function() {
  return "MatchedTypedState"
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_results;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_filtered;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState)) {
    var MatchedTypedState$1 = $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_results;
    var x$2 = $n(MatchedTypedState$1).Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_results;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_filtered;
      var x$4 = $n(MatchedTypedState$1).Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState__f_filtered;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.SearchRefiner$MatchedTypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.SearchRefiner$MatchedTypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState: 0
}, false, "com.iz2use.react.components.internal.multiview.SearchRefiner$MatchedTypedState", {
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1(outer) {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1.prototype.applyOrElse__T3__F1__O = (function(x1, default$1) {
  var this$1 = $n($n($as_Lcom_iz2use_common_TokenMatches($n(x1).T3__f__3)).Lcom_iz2use_common_TokenMatches__f_matches);
  if ((!this$1.isEmpty__Z())) {
    return $n(x1).T3__f__1
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1.prototype.isDefinedAt__T3__Z = (function(x1) {
  var this$1 = $n($n($as_Lcom_iz2use_common_TokenMatches($n(x1).T3__f__3)).Lcom_iz2use_common_TokenMatches__f_matches);
  return (!this$1.isEmpty__Z())
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T3__Z($as_T3(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T3__F1__O($as_T3(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1: 0
}, false, "com.iz2use.react.components.internal.multiview.SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1", {
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$$anonfun$$nestedInanonfun$from$1$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1(outer, order$1) {
  this.Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1__f_order$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1__f_order$1 = order$1
}
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  var this$1 = $n($as_T($n(x1)._1__O()));
  var anotherString = $n(this.Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1__f_order$1).Lcom_iz2use_react_components_internal_multiview_Order__f_field;
  _return: {
    var len = this$1.length;
    if ((anotherString === null)) {
      var $$x2 = true
    } else {
      var this$2 = $n(anotherString);
      var $$x2 = (this$2.length !== len)
    };
    if ((!$$x2)) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = $charAt(this$1, index);
        var $$x3 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
        var this$3 = $n(anotherString);
        var index$1 = i;
        var c$1 = $charAt(this$3, index$1);
        if (($$x3 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
          var $$x1 = false;
          break _return
        };
        i = ((1 + i) | 0)
      };
      var $$x1 = true
    } else {
      var $$x1 = false
    }
  };
  if ($$x1) {
    return $as_Lcom_iz2use_react_components_internal_multiview_FieldRenderer($n(x1)._2__O())
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  var this$1 = $n($as_T($n(x1)._1__O()));
  var anotherString = $n(this.Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1__f_order$1).Lcom_iz2use_react_components_internal_multiview_Order__f_field;
  var len = this$1.length;
  if ((anotherString === null)) {
    var $$x1 = true
  } else {
    var this$2 = $n(anotherString);
    var $$x1 = (this$2.length !== len)
  };
  if ((!$$x1)) {
    var i = 0;
    while ((i !== len)) {
      var index = i;
      var c = $charAt(this$1, index);
      var $$x2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
      var this$3 = $n(anotherString);
      var index$1 = i;
      var c$1 = $charAt(this$3, index$1);
      if (($$x2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
        return false
      };
      i = ((1 + i) | 0)
    };
    return true
  } else {
    return false
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1: 0
}, false, "com.iz2use.react.components.internal.multiview.SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1", {
  Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anonfun$$nestedInanonfun$generateOrdering$1$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1(outer) {
  this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.applyOrElse__Lcom_iz2use_react_components_internal_multiview_Direction__F1__O = (function(x1, default$1) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1__f_$outer).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
      var this$2 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_items);
      return ((!this$2.isEmpty__Z()) ? new $c_s_Some(this$2.get__O()) : $m_s_None$())
    }))), new $c_sjsr_AnonFunction1(((items$2) => {
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1__f_$outer).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_internal_multiview_grid_GridView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var f = new $c_sjsr_AnonFunction1(((p$2$1) => {
        var p$1 = $as_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps(p$2$1);
        var this$3 = $n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_active);
        if (this$3.isEmpty__Z()) {
          var $$x1 = $m_s_None$()
        } else {
          var arg1 = this$3.get__O();
          var active = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
          var activeKey = $as_T($n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper).apply__O__O($n(active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
          var x$2 = new $c_sjsr_AnonFunction1(((item$2) => {
            var item = $as_T2(item$2);
            var x = $n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_keyMapper).apply__O__O($n(item)._1__O());
            return ((x === null) ? (activeKey === null) : $dp_equals__O__Z($n(x), activeKey))
          }));
          $n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_hasIterator);
          var x$3 = 0;
          var $$x1 = new $c_s_Some($n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_hasIterator).indexWhere__O__F1__I__I(items$2, x$2, x$3))
        };
        var this$5 = $n($$x1);
        var idx = $uI((this$5.isEmpty__Z() ? (-1) : this$5.get__O()));
        if ($n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_hasIterator).isEmpty__O__Z(items$2)) {
          var nextIdx$2 = $m_s_None$()
        } else {
          var nextIdx = ((idx + $uI($n(x1).fold__F0__F0__O(new $c_sjsr_AnonFunction0((() => (-1))), new $c_sjsr_AnonFunction0((() => 1))))) | 0);
          var len = $n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_hasIterator).length__O__I(items$2);
          var nextIdx$2 = new $c_s_Some(((nextIdx < 0) ? 0 : ((nextIdx < len) ? nextIdx : (((-1) + len) | 0))))
        };
        var this$6 = $n(nextIdx$2);
        if (this$6.isEmpty__Z()) {
          var next = $m_s_None$()
        } else {
          var arg1$1 = this$6.get__O();
          var x$2$1 = $uI(arg1$1);
          var next = new $c_s_Some($n($as_T2($n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_hasIterator).apply__O__I__O(items$2, x$2$1)))._1__O())
        };
        $n($n(this.Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1__f_$outer).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend__f_scrollDirection = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).pure__O__F0(x1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p$1).Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedProps__f_context).setActive__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(next))
      }));
      var this$$1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f);
      var f$1 = new $c_sjsr_AnonFunction1(((cb$2) => {
        $as_jl_Void(cb$2)
      }));
      var this$9 = $n(this$$1);
      var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$9, f$1);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    }))))
  })));
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$12 = $m_s_$less$colon$less$();
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$12.s_$less$colon$less$__f_singleton))
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.isDefinedAt__Lcom_iz2use_react_components_internal_multiview_Direction__Z = (function(x1) {
  return true
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lcom_iz2use_react_components_internal_multiview_Direction__Z($as_Lcom_iz2use_react_components_internal_multiview_Direction(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lcom_iz2use_react_components_internal_multiview_Direction__F1__O($as_Lcom_iz2use_react_components_internal_multiview_Direction(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1: 0
}, false, "com.iz2use.react.components.internal.multiview.grid.GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1", {
  Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_grid_GridView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1;
function $p_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__children$lzycompute__sci_List($thiz) {
  if (((((1 & $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0) << 24) >> 24) === 0)) {
    $n($m_s_package$().s_package$__f_List);
    var array = [$thiz];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0 = (((1 | $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_children
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__maxLevel$lzycompute__I($thiz) {
  if (((((2 & $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_maxLevel = 0;
    $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0 = (((2 | $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_maxLevel
}
function $p_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__childrenCount$lzycompute__I($thiz) {
  if (((((4 & $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_childrenCount = 1;
    $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0 = (((4 | $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_childrenCount
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer(title, f, renderable) {
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_children = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_maxLevel = 0;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_childrenCount = 0;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_title = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_f = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable = null;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0 = 0;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_title = title;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_f = f;
  this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable = renderable
}
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.newLevel__Z = (function() {
  return false
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.children__sci_List = (function() {
  return (((((1 & this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__children$lzycompute__sci_List(this) : this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_children)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.maxLevel__I = (function() {
  return (((((2 & this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__maxLevel$lzycompute__I(this) : this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_maxLevel)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.childrenCount__I = (function() {
  return (((((4 & this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__childrenCount$lzycompute__I(this) : this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_childrenCount)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.renderCells__sci_Map__s_Option__Ljapgolly_scalajs_react_vdom_VdomNode = (function(in$1, editing) {
  var x1 = $as_s_Option($n(this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_f).apply__O__O(in$1));
  var x = $m_s_None$();
  if ((x === x1)) {
    var content = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  } else {
    if ((!(x1 instanceof $c_s_Some))) {
      throw new $c_s_MatchError(x1)
    };
    var x3 = $as_s_Some(x1);
    var value = $n(x3).s_Some__f_value;
    var x$3 = $m_s_None$();
    if ((x$3 === editing)) {
      var content = $n($n(this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_viewable).apply__O__Ljapgolly_scalajs_react_vdom_TagMod(value)
    } else {
      if ((!(editing instanceof $c_s_Some))) {
        throw new $c_s_MatchError(editing)
      };
      var $$x1 = $n($n(this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_editable);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_title;
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var content = $n($$x1).apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagMod(new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v), $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), value), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
        var x0$1 = $as_s_Option(x0$1$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1$2 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        matchEnd7: {
          var $$x2;
          var p2 = $as_s_Option(x1$2.T2__f__1);
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x$1 = $m_s_None$();
          if ((x$1 === p2)) {
            var $$x2 = cb;
            break matchEnd7
          };
          var p4 = $as_s_Option(x1$2.T2__f__1);
          var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          if ((p4 instanceof $c_s_Some)) {
            var $$x2 = cb$2;
            break matchEnd7
          };
          throw new $c_s_MatchError(x1$2)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
      }))))
    }
  };
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array = [$n($n(this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_format).alignment__Ljapgolly_scalajs_react_vdom_TagMod(), content];
  return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("td", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.renderHeaders__I__Lcom_iz2use_react_components_internal_multiview_MultiviewContext__sci_List = (function(level, context) {
  $n($m_s_package$().s_package$__f_List);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_title;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => {
    var this$6 = $n(context);
    var order = new $c_Lcom_iz2use_react_components_internal_multiview_Order(this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_title, true);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Lcom_iz2use_react_components_internal_multiview_MultiviewContext__toggleOrAddOrder__Lcom_iz2use_react_components_internal_multiview_Order__Ljapgolly_scalajs_react_callback_Trampoline(this$6, order))
  })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync), $n($n($n(this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_format).sizing__Lcom_iz2use_react_components_internal_multiview_Sizing()).Lcom_iz2use_react_components_internal_multiview_Sizing__f_whenTable, $n($n(this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_format).alignment__Ljapgolly_scalajs_react_vdom_TagMod(), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((($n(this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_format + "\r\n") + $n(this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable__f_ordering), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  var array$1 = [$n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("th", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.productPrefix__T = (function() {
  return "ColumnRenderer"
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.productArity__I = (function() {
  return 3
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_title;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_f;
      break
    }
    case 2: {
      return this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer)) {
    var ColumnRenderer$1 = $as_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer(x$1);
    if ((this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_title === $n(ColumnRenderer$1).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_title)) {
      var x = this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_f;
      var x$2 = $n(ColumnRenderer$1).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_f;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable;
        var x$4 = $n(ColumnRenderer$1).Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer__f_renderable;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.table.ColumnRenderer"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.table.ColumnRenderer;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer: 0
}, false, "com.iz2use.react.components.internal.multiview.table.ColumnRenderer", {
  Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_ColumnFragment: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderer;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1(outer) {
  this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.applyOrElse__Lcom_iz2use_react_components_internal_multiview_Direction__F1__O = (function(x1, default$1) {
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(this.Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1__f_$outer).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1__f_$outer).Lcom_iz2use_react_components_internal_multiview_table_TabularView$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps(p$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => {
      var this$2 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_items);
      return ((!this$2.isEmpty__Z()) ? new $c_s_Some(this$2.get__O()) : $m_s_None$())
    }))), new $c_sjsr_AnonFunction1(((items$2) => {
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$3 = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_active);
      if (this$3.isEmpty__Z()) {
        var $$x1 = $m_s_None$()
      } else {
        var arg1 = this$3.get__O();
        var active = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
        var activeKey = $as_T($n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper).apply__O__O($n(active).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
        var x$2 = new $c_sjsr_AnonFunction1(((item$2) => {
          var item = $as_T2(item$2);
          var x = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_keyMapper).apply__O__O($n(item)._1__O());
          return ((x === null) ? (activeKey === null) : $dp_equals__O__Z($n(x), activeKey))
        }));
        $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_hasIterator);
        var x$3 = 0;
        var $$x1 = new $c_s_Some($n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_hasIterator).indexWhere__O__F1__I__I(items$2, x$2, x$3))
      };
      var this$5 = $n($$x1);
      var idx = $uI((this$5.isEmpty__Z() ? (-1) : this$5.get__O()));
      if ($n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_hasIterator).isEmpty__O__Z(items$2)) {
        var nextIdx$2 = $m_s_None$()
      } else {
        var nextIdx = ((idx + $uI($n(x1).fold__F0__F0__O(new $c_sjsr_AnonFunction0((() => (-1))), new $c_sjsr_AnonFunction0((() => 1))))) | 0);
        var len = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_hasIterator).length__O__I(items$2);
        var nextIdx$2 = new $c_s_Some(((nextIdx < 0) ? 0 : ((nextIdx < len) ? nextIdx : (((-1) + len) | 0))))
      };
      var this$6 = $n(nextIdx$2);
      if (this$6.isEmpty__Z()) {
        var next = $m_s_None$()
      } else {
        var arg1$1 = this$6.get__O();
        var x$2$1 = $uI(arg1$1);
        var next = new $c_s_Some($n($as_T2($n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_hasIterator).apply__O__I__O(items$2, x$2$1)))._1__O())
      };
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).pure__O__F0(x1);
      var this$ = $n($n(p).Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedProps__f_context).setActive__s_Option__Ljapgolly_scalajs_react_callback_Trampoline(next);
      var f = new $c_sjsr_AnonFunction1(((cb$2) => {
        $as_jl_Void(cb$2)
      }));
      var this$8 = $n(this$);
      var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$8, f);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    }))))
  })));
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$11 = $m_s_$less$colon$less$();
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$11.s_$less$colon$less$__f_singleton))
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.isDefinedAt__Lcom_iz2use_react_components_internal_multiview_Direction__Z = (function(x1) {
  return true
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lcom_iz2use_react_components_internal_multiview_Direction__Z($as_Lcom_iz2use_react_components_internal_multiview_Direction(x))
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lcom_iz2use_react_components_internal_multiview_Direction__F1__O($as_Lcom_iz2use_react_components_internal_multiview_Direction(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1: 0
}, false, "com.iz2use.react.components.internal.multiview.table.TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1", {
  Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_table_TabularView$TypedBackend$$anon$1$$anonfun$changePrimarySelection$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher.prototype.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners__sci_List = (function() {
  return this.Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners_$eq__sci_List__V = (function(x$1) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = x$1
});
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1(outer) {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  return ((x1 === 13) ? new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty) : $n(default$1).apply__O__O(x1))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1.prototype.isDefinedAt__I__Z = (function(x1) {
  return (x1 === 13)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedBackend$$anonfun$1", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2(outer, p$2) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2__f_p$2 = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2__f_p$2 = p$2
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2.prototype.applyOrElse__I__F1__O = (function(x2, default$1) {
  return ((x2 === 27) ? new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2__f_p$2).Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedProps__f_context).Lcom_iz2use_react_components_internal_TextEditorContext__f_cancel) : $n(default$1).apply__O__O(x2))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2.prototype.isDefinedAt__I__Z = (function(x2) {
  return (x2 === 27)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionHelper$TypedBackend$$anonfun$2", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$TypedBackend$$anonfun$2;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1(outer) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  var this$3 = $n($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1__f_$outer).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(x$11$2);
    var this$2 = $n(x$11);
    var arg1 = this$2.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems;
    var loadedItems = $n(arg1).fail__jl_Throwable__Ldiode_data_Pot(x1);
    var arg1$1 = this$2.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems;
    var showedItems = $n(arg1$1).fail__jl_Throwable__Ldiode_data_Pot(x1);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(loadedItems, showedItems)
  }));
  return $f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return true
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$onMount$8$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1(outer) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  var this$3 = $n($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1__f_$outer).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$20$2) => {
    var x$20 = $as_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(x$20$2);
    var x$2 = $n(x$20).updating$default$1__F1();
    var this$2 = $n(x$20);
    var loadedItems = $as_Ldiode_data_Pot($n(x$2).apply__O__O(this$2.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_loadedItems));
    var arg1 = this$2.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState__f_showedItems;
    var showedItems = $n(arg1).fail__jl_Throwable__Ldiode_data_Pot(x1);
    return new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedState(loadedItems, showedItems)
  }));
  return $f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return true
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFetcher$TypedBackend$$anonfun$$nestedInanonfun$wrapFutureAndHandleTokenizedItems$4$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1(outer, s$2, p$2, v$1) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_s$2 = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_p$2 = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_v$1 = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_s$2 = s$2;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_p$2 = p$2;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_v$1 = v$1
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  if ((x1 === 13)) {
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x7 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f = new $c_sjsr_AnonFunction0((() => {
      var this$2 = $n($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_s$2).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__f_selected);
      return (!this$2.isEmpty__Z())
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var $$x4 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
    var $$x3 = $n($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_p$2).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_context).Lcom_iz2use_react_components_internal_TextEditorContext__f_isModified;
    var this$5 = $m_s_$less$colon$less$();
    var $$x2 = $n($$x5).$bar$bar$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline($$x4, $$x3, this$5.s_$less$colon$less$__f_singleton);
    var this$6 = $m_s_$less$colon$less$();
    var $$x1 = $n($$x6).requireCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x2, this$6.s_$less$colon$less$__f_singleton);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var c = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_p$2).Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__f_context).Lcom_iz2use_react_components_internal_TextEditorContext__f_select).apply__O__O(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1__f_v$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var co = $n($$x7).$greater$greater$extension__F0__F0__F0($$x1, $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c));
    var $$x8 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$9 = $m_s_$less$colon$less$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x8).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$9.s_$less$colon$less$__f_singleton))
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1.prototype.isDefinedAt__I__Z = (function(x1) {
  return (x1 === 13)
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedBackend$$anonfun$1", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2(outer, p$2, s$2) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_$outer = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_p$2 = null;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_s$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_$outer = outer
  };
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_p$2 = p$2;
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_s$2 = s$2
}
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2.prototype;
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2.prototype.applyOrElse__I__F1__O = (function(x2, default$1) {
  switch (x2) {
    case 40: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_$outer).com$iz2use$react$components$internal$suggestion$SuggestionListFocuser$TypedBackend$$updateCursor$1__I__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(1, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_p$2, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_s$2));
      break
    }
    case 38: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_$outer).com$iz2use$react$components$internal$suggestion$SuggestionListFocuser$TypedBackend$$updateCursor$1__I__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedProps__Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedState__Ljapgolly_scalajs_react_callback_Trampoline((-1), this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_p$2, this.Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2__f_s$2));
      break
    }
    default: {
      return $n(default$1).apply__O__O(x2)
    }
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2.prototype.isDefinedAt__I__Z = (function(x2) {
  switch (x2) {
    case 40: {
      return true;
      break
    }
    case 38: {
      return true;
      break
    }
    default: {
      return false
    }
  }
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2: 0
}, false, "com.iz2use.react.components.internal.suggestion.SuggestionListFocuser$TypedBackend$$anonfun$2", {
  Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2.prototype.$classData = $d_Lcom_iz2use_react_components_internal_suggestion_SuggestionListFocuser$TypedBackend$$anonfun$2;
function $p_Lcom_iz2use_react_style_MaterialDesign__Elevation$lzycompute$1__V($thiz) {
  if (($thiz.Lcom_iz2use_react_style_MaterialDesign__f_Elevation$module === null)) {
    $thiz.Lcom_iz2use_react_style_MaterialDesign__f_Elevation$module = new $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$($thiz)
  }
}
/** @constructor */
function $c_Lcom_iz2use_react_style_MaterialDesign(r, c) {
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module = null;
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister = null;
  this.Lcom_iz2use_react_style_MaterialDesign__f_Elevation$module = null;
  this.Lcom_iz2use_react_style_MaterialDesign__f_com$iz2use$react$style$MaterialDesign$$c = null;
  this.Lcom_iz2use_react_style_MaterialDesign__f_com$iz2use$react$style$MaterialDesign$$c = c;
  $ct_Lscalacss_internal_mutable_StyleSheet$Inline__Lscalacss_internal_mutable_Register__(this, r);
  this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$ = 8;
  var u = $m_Lscalacss_internal_LengthUnit$px$();
  new $c_Lscalacss_internal_Length(this$, u)
}
$c_Lcom_iz2use_react_style_MaterialDesign.prototype = new $h_Lscalacss_internal_mutable_StyleSheet$Inline();
$c_Lcom_iz2use_react_style_MaterialDesign.prototype.constructor = $c_Lcom_iz2use_react_style_MaterialDesign;
/** @constructor */
function $h_Lcom_iz2use_react_style_MaterialDesign() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_MaterialDesign.prototype = $c_Lcom_iz2use_react_style_MaterialDesign.prototype;
$c_Lcom_iz2use_react_style_MaterialDesign.prototype.Elevation__Lcom_iz2use_react_style_MaterialDesign$Elevation$ = (function() {
  if ((this.Lcom_iz2use_react_style_MaterialDesign__f_Elevation$module === null)) {
    $p_Lcom_iz2use_react_style_MaterialDesign__Elevation$lzycompute$1__V(this)
  };
  return this.Lcom_iz2use_react_style_MaterialDesign__f_Elevation$module
});
$c_Lcom_iz2use_react_style_MaterialDesign.prototype.pureWhiteframe__J__Lscalacss_internal_StyleS = (function(dpi) {
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var this$17 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v);
  var f = new $c_sjsr_AnonFunction1(((color$2) => {
    var color = $as_T(color$2);
    return new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lscalacss_internal_Attr(x$1$2);
      $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var this$4 = $m_RTLong$();
      var lo = this$4.divideImpl__I__I__I__I__I(dpi.RTLong__f_lo, dpi.RTLong__f_hi, 2, 0);
      var hi = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x3 = new $c_RTLong(lo, hi);
      var this$5 = $m_RTLong$();
      var lo$1 = this$5.divideImpl__I__I__I__I__I(dpi.RTLong__f_lo, dpi.RTLong__f_hi, 2, 0);
      var hi$1 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x2 = new $c_RTLong(lo$1, hi$1);
      var x = (0.333 * ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(dpi.RTLong__f_lo, dpi.RTLong__f_hi) + 1.0));
      var this$10 = $m_RTLong$();
      var value = $uD(Math.round(x));
      var lo$2 = this$10.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
      var hi$2 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x1 = new $c_RTLong(lo$2, hi$2);
      var x$2 = (2.0 + (1.5 * $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(dpi.RTLong__f_lo, dpi.RTLong__f_hi)));
      var this$15 = $m_RTLong$();
      var value$1 = $uD(Math.round(x$2));
      var lo$3 = this$15.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
      var hi$3 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var value$2 = (((((((((((((((((("0 " + $$x3) + "px ") + $$x2) + "px -2px rgba(") + color) + ",.2), 0 ") + dpi) + "px ") + dpi) + "px 0 rgba(") + color) + ",.14), 0 ") + $$x1) + "px ") + new $c_RTLong(lo$3, hi$3)) + "px 0 rgba(") + color) + ",.12)");
      return new $c_Lscalacss_internal_AV(x$1, value$2)
    }))
  }));
  var array = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4(this$17, f, "255,255,255", "0,0,0")];
  var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var c = this.Lcom_iz2use_react_style_MaterialDesign__f_com$iz2use$react$style$MaterialDesign$$c;
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var b = $m_sjsr_WrappedVarArgs$().newBuilder__scm_Builder();
  var this$21 = new $c_sc_IndexedSeqView$Id(t);
  var it = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$21);
  while ((it.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)) {
    var this$22 = $n(b);
    var arg1 = it.next__O();
    var x$1$1 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(arg1);
    var elem = new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$1).light__Lscalacss_internal_AV()));
    this$22.addOne__O__scm_Growable(elem)
  };
  var t$1 = $as_sci_Seq($n(b).result__O());
  var x$3 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$1, c);
  var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle(x$3);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$28 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$26 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$27 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$26.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var x$4 = $f_Lscalacss_internal_Media$FeatureOps__dark__O(this$27);
  var x$5 = $as_Lscalacss_internal_Media$Query(x$4);
  var $$x4 = new $c_Lscalacss_internal_DslBase$DslCond($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$5), this$28);
  var b$1 = $m_sjsr_WrappedVarArgs$().newBuilder__scm_Builder();
  var this$29 = new $c_sc_IndexedSeqView$Id(t);
  var it$1 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$29);
  while ((it$1.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)) {
    var this$30 = $n(b$1);
    var arg1$1 = it$1.next__O();
    var x$2$2 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(arg1$1);
    var elem$1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2).dark__Lscalacss_internal_AV()));
    this$30.addOne__O__scm_Growable(elem$1)
  };
  var x$6 = $$x4.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($n(b$1).result__O()), c);
  var array$1 = [$$x5, new $c_Lscalacss_internal_DslBase$ToStyle(x$6)];
  var t$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var x$7 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$2, c);
  var array$2 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$7)];
  var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var c$1 = this.Lcom_iz2use_react_style_MaterialDesign__f_com$iz2use$react$style$MaterialDesign$$c;
  return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$3, c$1)
});
$c_Lcom_iz2use_react_style_MaterialDesign.prototype.icon__Lscalacss_internal_StyleS = (function() {
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x7 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$10 = $m_Lscalacss_internal_Attrs$lineHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$ = 24;
  var u = $m_Lscalacss_internal_LengthUnit$px$();
  var f$1 = new $c_Lscalacss_internal_Length(this$, u);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lscalacss_internal_Length(x$3$2);
    return $n(x$3).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lscalacss_internal_ValueT(x$1$2);
    return $n(x$1)
  }));
  var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
  var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
  var v = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
  var v$1 = $n(v).Lscalacss_internal_ValueT__f_value;
  var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x7).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$10.Lscalacss_internal_Attrs$lineHeight$__f_attr, v$1)));
  var $$x5 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$12 = $m_Lscalacss_internal_Attrs$display$();
  var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$12.Lscalacss_internal_Attrs$display$__f_attr, "inline-block")));
  var $$x3 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$14 = $m_Lscalacss_internal_Attrs$verticalAlign$();
  var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$14.Lscalacss_internal_Attrs$verticalAlign$__f_attr, "text-bottom")));
  var $$x1 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $m_Lscalacss_internal_Attrs$userSelect$();
  var array = [$$x6, $$x4, $$x2, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a.Lscalacss_internal_Attrs$userSelect$__f_attr, "none")))];
  var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var c = this.Lcom_iz2use_react_style_MaterialDesign__f_com$iz2use$react$style$MaterialDesign$$c;
  return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c)
});
var $d_Lcom_iz2use_react_style_MaterialDesign = new $TypeData().initClass({
  Lcom_iz2use_react_style_MaterialDesign: 0
}, false, "com.iz2use.react.style.MaterialDesign", {
  Lcom_iz2use_react_style_MaterialDesign: 1,
  Lscalacss_internal_mutable_StyleSheet$Inline: 1,
  Lscalacss_internal_mutable_StyleSheet$Base: 1,
  O: 1,
  Lscalacss_internal_Macros$Dsl$Mixin: 1,
  Lcom_iz2use_react_style_package$WithThemedSupport: 1
});
$c_Lcom_iz2use_react_style_MaterialDesign.prototype.$classData = $d_Lcom_iz2use_react_style_MaterialDesign;
/** @constructor */
function $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$(outer) {
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_dpi = $L0;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_$outer = null;
  $ct_Lcom_iz2use_react_style_MaterialDesign$Elevation__Lcom_iz2use_react_style_MaterialDesign__J__(this, $n(outer).Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_$outer, new $c_RTLong(16, 0))
}
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype = new $h_Lcom_iz2use_react_style_MaterialDesign$Elevation();
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype.constructor = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$;
/** @constructor */
function $h_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype;
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype.productPrefix__T = (function() {
  return "ModalBottomSheet"
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype.hashCode__I = (function() {
  return (-424941273)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype.toString__T = (function() {
  return "ModalBottomSheet"
});
var $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$: 0
}, false, "com.iz2use.react.style.MaterialDesign$Elevation$ModalBottomSheet$", {
  Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$: 1,
  Lcom_iz2use_react_style_MaterialDesign$Elevation: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$.prototype.$classData = $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$;
/** @constructor */
function $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$(outer) {
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_dpi = $L0;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_$outer = null;
  $ct_Lcom_iz2use_react_style_MaterialDesign$Elevation__Lcom_iz2use_react_style_MaterialDesign__J__(this, $n(outer).Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_$outer, new $c_RTLong(24, 0))
}
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype = new $h_Lcom_iz2use_react_style_MaterialDesign$Elevation();
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype.constructor = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$;
/** @constructor */
function $h_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype;
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype.productPrefix__T = (function() {
  return "Picker"
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype.hashCode__I = (function() {
  return (-1904610130)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype.toString__T = (function() {
  return "Picker"
});
var $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$: 0
}, false, "com.iz2use.react.style.MaterialDesign$Elevation$Picker$", {
  Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$: 1,
  Lcom_iz2use_react_style_MaterialDesign$Elevation: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$.prototype.$classData = $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$;
/** @constructor */
function $c_Lcom_iz2use_react_style_OpacityLevel$full$() {
  this.Lcom_iz2use_react_style_OpacityLevel__f_level = 0.0;
  $ct_Lcom_iz2use_react_style_OpacityLevel__D__(this, 1.0)
}
$c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype = new $h_Lcom_iz2use_react_style_OpacityLevel();
$c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype.constructor = $c_Lcom_iz2use_react_style_OpacityLevel$full$;
/** @constructor */
function $h_Lcom_iz2use_react_style_OpacityLevel$full$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_OpacityLevel$full$.prototype = $c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype;
$c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype.productPrefix__T = (function() {
  return "full"
});
$c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype.hashCode__I = (function() {
  return 3154575
});
$c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype.toString__T = (function() {
  return "full"
});
var $d_Lcom_iz2use_react_style_OpacityLevel$full$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_OpacityLevel$full$: 0
}, false, "com.iz2use.react.style.OpacityLevel$full$", {
  Lcom_iz2use_react_style_OpacityLevel$full$: 1,
  Lcom_iz2use_react_style_OpacityLevel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_OpacityLevel$full$.prototype.$classData = $d_Lcom_iz2use_react_style_OpacityLevel$full$;
var $n_Lcom_iz2use_react_style_OpacityLevel$full$;
function $m_Lcom_iz2use_react_style_OpacityLevel$full$() {
  if ((!$n_Lcom_iz2use_react_style_OpacityLevel$full$)) {
    $n_Lcom_iz2use_react_style_OpacityLevel$full$ = new $c_Lcom_iz2use_react_style_OpacityLevel$full$()
  };
  return $n_Lcom_iz2use_react_style_OpacityLevel$full$
}
/** @constructor */
function $c_Lcom_iz2use_react_style_OpacityLevel$high$() {
  this.Lcom_iz2use_react_style_OpacityLevel__f_level = 0.0;
  $ct_Lcom_iz2use_react_style_OpacityLevel__D__(this, 0.76)
}
$c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype = new $h_Lcom_iz2use_react_style_OpacityLevel();
$c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype.constructor = $c_Lcom_iz2use_react_style_OpacityLevel$high$;
/** @constructor */
function $h_Lcom_iz2use_react_style_OpacityLevel$high$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_OpacityLevel$high$.prototype = $c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype;
$c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype.productPrefix__T = (function() {
  return "high"
});
$c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype.hashCode__I = (function() {
  return 3202466
});
$c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype.toString__T = (function() {
  return "high"
});
var $d_Lcom_iz2use_react_style_OpacityLevel$high$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_OpacityLevel$high$: 0
}, false, "com.iz2use.react.style.OpacityLevel$high$", {
  Lcom_iz2use_react_style_OpacityLevel$high$: 1,
  Lcom_iz2use_react_style_OpacityLevel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_OpacityLevel$high$.prototype.$classData = $d_Lcom_iz2use_react_style_OpacityLevel$high$;
var $n_Lcom_iz2use_react_style_OpacityLevel$high$;
function $m_Lcom_iz2use_react_style_OpacityLevel$high$() {
  if ((!$n_Lcom_iz2use_react_style_OpacityLevel$high$)) {
    $n_Lcom_iz2use_react_style_OpacityLevel$high$ = new $c_Lcom_iz2use_react_style_OpacityLevel$high$()
  };
  return $n_Lcom_iz2use_react_style_OpacityLevel$high$
}
/** @constructor */
function $c_Lcom_iz2use_react_style_OpacityLevel$low$() {
  this.Lcom_iz2use_react_style_OpacityLevel__f_level = 0.0;
  $ct_Lcom_iz2use_react_style_OpacityLevel__D__(this, 0.12)
}
$c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype = new $h_Lcom_iz2use_react_style_OpacityLevel();
$c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype.constructor = $c_Lcom_iz2use_react_style_OpacityLevel$low$;
/** @constructor */
function $h_Lcom_iz2use_react_style_OpacityLevel$low$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_OpacityLevel$low$.prototype = $c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype;
$c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype.productPrefix__T = (function() {
  return "low"
});
$c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype.hashCode__I = (function() {
  return 107348
});
$c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype.toString__T = (function() {
  return "low"
});
var $d_Lcom_iz2use_react_style_OpacityLevel$low$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_OpacityLevel$low$: 0
}, false, "com.iz2use.react.style.OpacityLevel$low$", {
  Lcom_iz2use_react_style_OpacityLevel$low$: 1,
  Lcom_iz2use_react_style_OpacityLevel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_OpacityLevel$low$.prototype.$classData = $d_Lcom_iz2use_react_style_OpacityLevel$low$;
var $n_Lcom_iz2use_react_style_OpacityLevel$low$;
function $m_Lcom_iz2use_react_style_OpacityLevel$low$() {
  if ((!$n_Lcom_iz2use_react_style_OpacityLevel$low$)) {
    $n_Lcom_iz2use_react_style_OpacityLevel$low$ = new $c_Lcom_iz2use_react_style_OpacityLevel$low$()
  };
  return $n_Lcom_iz2use_react_style_OpacityLevel$low$
}
/** @constructor */
function $c_Lcom_iz2use_react_style_OpacityLevel$medium$() {
  this.Lcom_iz2use_react_style_OpacityLevel__f_level = 0.0;
  $ct_Lcom_iz2use_react_style_OpacityLevel__D__(this, 0.42)
}
$c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype = new $h_Lcom_iz2use_react_style_OpacityLevel();
$c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype.constructor = $c_Lcom_iz2use_react_style_OpacityLevel$medium$;
/** @constructor */
function $h_Lcom_iz2use_react_style_OpacityLevel$medium$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype = $c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype;
$c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype.productPrefix__T = (function() {
  return "medium"
});
$c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype.hashCode__I = (function() {
  return (-1078030475)
});
$c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype.toString__T = (function() {
  return "medium"
});
var $d_Lcom_iz2use_react_style_OpacityLevel$medium$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_OpacityLevel$medium$: 0
}, false, "com.iz2use.react.style.OpacityLevel$medium$", {
  Lcom_iz2use_react_style_OpacityLevel$medium$: 1,
  Lcom_iz2use_react_style_OpacityLevel: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_OpacityLevel$medium$.prototype.$classData = $d_Lcom_iz2use_react_style_OpacityLevel$medium$;
var $n_Lcom_iz2use_react_style_OpacityLevel$medium$;
function $m_Lcom_iz2use_react_style_OpacityLevel$medium$() {
  if ((!$n_Lcom_iz2use_react_style_OpacityLevel$medium$)) {
    $n_Lcom_iz2use_react_style_OpacityLevel$medium$ = new $c_Lcom_iz2use_react_style_OpacityLevel$medium$()
  };
  return $n_Lcom_iz2use_react_style_OpacityLevel$medium$
}
/** @constructor */
function $c_Lcom_iz2use_react_style_Style(md, withBackground, theme, r, c) {
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module = null;
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister = null;
  this.Lcom_iz2use_react_style_Style__f_c = null;
  this.Lcom_iz2use_react_style_Style__f_printableOnly = null;
  this.Lcom_iz2use_react_style_Style__f_notPrintable = null;
  this.Lcom_iz2use_react_style_Style__f_paperPage = null;
  this.Lcom_iz2use_react_style_Style__f_paperPageContent = null;
  this.Lcom_iz2use_react_style_Style__f_flex1 = null;
  this.Lcom_iz2use_react_style_Style__f_flexRow = null;
  this.Lcom_iz2use_react_style_Style__f_flexColumn = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldLabelShouldFloat = null;
  this.Lcom_iz2use_react_style_Style__f_editor = null;
  this.Lcom_iz2use_react_style_Style__f_checkboxField = null;
  this.Lcom_iz2use_react_style_Style__f_checkboxFieldLabel = null;
  this.Lcom_iz2use_react_style_Style__f_formField = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldLabelWrapper = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldLabel = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldInputWrapper = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldUnderline = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldUnderlineRipple = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldSubscript = null;
  this.Lcom_iz2use_react_style_Style__f_autocompleteContainer = null;
  this.Lcom_iz2use_react_style_Style__f_autocompleteScoreWrapper = null;
  this.Lcom_iz2use_react_style_Style__f_autocompleteScore = null;
  this.Lcom_iz2use_react_style_Style__f_autocompleteContainerError = null;
  this.Lcom_iz2use_react_style_Style__f_autocompleteContainerPending = null;
  this.Lcom_iz2use_react_style_Style__f_autocompleteItemActive = null;
  this.Lcom_iz2use_react_style_Style__f_textEditor = null;
  this.Lcom_iz2use_react_style_Style__f_multilineTextEditor = null;
  this.Lcom_iz2use_react_style_Style__f_checkboxFieldHasFocus = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldHasFocus = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldNotEmpty = null;
  this.Lcom_iz2use_react_style_Style__f_formFieldInvalid = null;
  this.Lcom_iz2use_react_style_Style__f_commonSelectorItemActive = null;
  this.Lcom_iz2use_react_style_Style__f_commonSelectorItemFocused = null;
  this.Lcom_iz2use_react_style_Style__f_calendarContainer = null;
  this.Lcom_iz2use_react_style_Style__f_calendarMonthContainer = null;
  this.Lcom_iz2use_react_style_Style__f_calendarMonthWrapper = null;
  this.Lcom_iz2use_react_style_Style__f_calendarTable = null;
  this.Lcom_iz2use_react_style_Style__f_calendarOther = null;
  this.Lcom_iz2use_react_style_Style__f_calendarNow = null;
  this.Lcom_iz2use_react_style_Style__f_calendarActive = null;
  this.Lcom_iz2use_react_style_Style__f_commonSelectorItem = null;
  this.Lcom_iz2use_react_style_Style__f_commonSelector = null;
  this.Lcom_iz2use_react_style_Style__f_selector = null;
  this.Lcom_iz2use_react_style_Style__f_reorderableSelector = null;
  this.Lcom_iz2use_react_style_Style__f_icon = null;
  this.Lcom_iz2use_react_style_Style__f_stickyMixin = null;
  this.Lcom_iz2use_react_style_Style__f_stickyLeft = null;
  this.Lcom_iz2use_react_style_Style__f_stickyTop = null;
  this.Lcom_iz2use_react_style_Style__f_fixedHeadersTable = null;
  this.Lcom_iz2use_react_style_Style__f_multiviewSelected = null;
  this.Lcom_iz2use_react_style_Style__f_multiviewFocused = null;
  this.Lcom_iz2use_react_style_Style__f_tabularView = null;
  this.Lcom_iz2use_react_style_Style__f_multiviewContainer = null;
  this.Lcom_iz2use_react_style_Style__f_multiviewSettings = null;
  this.Lcom_iz2use_react_style_Style__f_multiviewSearch = null;
  this.Lcom_iz2use_react_style_Style__f_multiviewRender = null;
  this.Lcom_iz2use_react_style_Style__f_selectorLabelContainer = null;
  this.Lcom_iz2use_react_style_Style__f_linkedViewContainer = null;
  this.Lcom_iz2use_react_style_Style__f_linkedView = null;
  this.Lcom_iz2use_react_style_Style__f_linkedViewReducer = null;
  this.Lcom_iz2use_react_style_Style__f_linkedViewReducedSize = null;
  this.Lcom_iz2use_react_style_Style__f_linkedViewReducedContainer = null;
  this.Lcom_iz2use_react_style_Style__f_linkedViewClose = null;
  this.Lcom_iz2use_react_style_Style__f_linkedViewCloseIcon = null;
  this.Lcom_iz2use_react_style_Style__f_linkedViewContent = null;
  this.Lcom_iz2use_react_style_Style__f_linkedViewActiveContainer = null;
  this.Lcom_iz2use_react_style_Style__f_tabularViewContainer = null;
  this.Lcom_iz2use_react_style_Style__f_gridListContainer = null;
  this.Lcom_iz2use_react_style_Style__f_gridItem = null;
  this.Lcom_iz2use_react_style_Style__f_gridItemImage = null;
  this.Lcom_iz2use_react_style_Style__f_gridItemTitle = null;
  this.Lcom_iz2use_react_style_Style__f_gridItemContent = null;
  this.Lcom_iz2use_react_style_Style__f_listView = null;
  this.Lcom_iz2use_react_style_Style__f_listItem = null;
  this.Lcom_iz2use_react_style_Style__f_listItemField = null;
  this.Lcom_iz2use_react_style_Style__f_slideshowViewContainer = null;
  this.Lcom_iz2use_react_style_Style__f_slideshowViewNavigationBar = null;
  this.Lcom_iz2use_react_style_Style__f_slideshowButton = null;
  this.Lcom_iz2use_react_style_Style__f_slideshowActiveItem = null;
  this.Lcom_iz2use_react_style_Style__f_sideBySideLayoutContainer = null;
  this.Lcom_iz2use_react_style_Style__f_cardContainer = null;
  this.Lcom_iz2use_react_style_Style__f_cardHeader = null;
  this.Lcom_iz2use_react_style_Style__f_cardTitle = null;
  this.Lcom_iz2use_react_style_Style__f_verticalLayout = null;
  this.Lcom_iz2use_react_style_Style__f_horizontalLayout = null;
  this.Lcom_iz2use_react_style_Style__f_button = null;
  this.Lcom_iz2use_react_style_Style__f_dialogContainerWrapper = null;
  this.Lcom_iz2use_react_style_Style__f_dialogContainer = null;
  this.Lcom_iz2use_react_style_Style__f_dialogHeader = null;
  this.Lcom_iz2use_react_style_Style__f_dialogClose = null;
  this.Lcom_iz2use_react_style_Style__f_skeletonPulses = null;
  this.Lcom_iz2use_react_style_Style__f_skeletonPulseAnimationMixin = null;
  this.Lcom_iz2use_react_style_Style__f_skeletonText = null;
  this.Lcom_iz2use_react_style_Style__f_c = c;
  $ct_Lscalacss_internal_mutable_StyleSheet$Inline__Lscalacss_internal_mutable_Register__(this, r);
  this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x4 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "printableOnly");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x3 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x2 = $n($n($$x3).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Lscalacss_internal_Media$Query(x$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x)
  }))));
  var $$x1 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$5 = $m_Lscalacss_internal_Attrs$display$();
  var v = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$1 = v.Lscalacss_internal_Literal__f_value;
  var array = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$5.Lscalacss_internal_Attrs$display$__f_attr, v$1)))];
  var x$1 = $n($$x2).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), c);
  var array$1 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$1)];
  this.Lcom_iz2use_react_style_Style__f_printableOnly = $n($$x4).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), c);
  var $$x8 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "notPrintable");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x7 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$14 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x6 = $n($n($$x7).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$14.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lscalacss_internal_Media$Query(x$3$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$3)
  }))));
  var $$x5 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$16 = $m_Lscalacss_internal_Attrs$display$();
  var v$2 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$3 = v$2.Lscalacss_internal_Literal__f_value;
  var array$2 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$16.Lscalacss_internal_Attrs$display$__f_attr, v$3).important__Lscalacss_internal_AV()))];
  var x$4 = $n($$x6).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), c);
  var array$3 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$4)];
  this.Lcom_iz2use_react_style_Style__f_notPrintable = $n($$x8).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), c);
  var $$x12 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "page");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x11 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$25 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x10 = $n($n($$x11).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$25.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4$1 = $as_Lscalacss_internal_Media$Query(x$4$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$4$1)
  }))));
  var $$x9 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$27 = $m_Lscalacss_internal_Attrs$display$();
  var v$4 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$5 = v$4.Lscalacss_internal_Literal__f_value;
  var array$4 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x9).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$27.Lscalacss_internal_Attrs$display$__f_attr, v$5)))];
  var x$5 = $n($$x10).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), c);
  var array$5 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$5)];
  $n($$x12).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5), c);
  var $$x25 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperPage");
  var $$x24 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$43 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$ = 100;
  var f$1 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$1) => {
    var x$4$3 = $as_Lscalacss_internal_Percentage(x$4$2$1);
    return $n(x$4$3).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2);
    return $n(x$1$1)
  }));
  var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
  var r$1 = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
  var v$6 = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$1);
  var v$7 = $n(v$6).Lscalacss_internal_ValueT__f_value;
  var $$x23 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x24).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$43.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$7)));
  var $$x22 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$52 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$1 = 100;
  var f$3 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$1);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$2) => {
    var x$4$4 = $as_Lscalacss_internal_Percentage(x$4$2$2);
    return $n(x$4$4).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
    var x$1$3 = $as_Lscalacss_internal_ValueT(x$1$2$1);
    return $n(x$1$3)
  }));
  var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
  var r$2 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
  var v$8 = $n(r$2).apply__O__Lscalacss_internal_ValueT(f$3);
  var v$9 = $n(v$8).Lscalacss_internal_ValueT__f_value;
  var $$x21 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x22).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$52.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$9)));
  var $$x20 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$54 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$10 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$11 = v$10.Lscalacss_internal_Literal__f_value;
  var $$x19 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x20).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$54.Lscalacss_internal_Attrs$overflow$__f_attr, v$11)));
  var $$x18 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$56 = $m_Lscalacss_internal_Attrs$pageBreakInside$();
  var $$x17 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x18).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$56.Lscalacss_internal_Attrs$pageBreakInside$__f_attr, "avoid")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x16 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$57 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p = $m_Lscalacss_internal_Pseudo$FirstChild$();
  var $$x15 = this$57.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p);
  var this$59 = $m_s_$less$colon$less$();
  var $$x14 = $n($n($$x16).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x15, this$59.s_$less$colon$less$__f_singleton));
  var $$x13 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$61 = $m_Lscalacss_internal_Attrs$pageBreakBefore$();
  var array$6 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x13).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$61.Lscalacss_internal_Attrs$pageBreakBefore$__f_attr, "avoid")))];
  var x$6 = $n($$x14).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6), c);
  var array$7 = [$$x23, $$x21, $$x19, $$x17, new $c_Lscalacss_internal_DslBase$ToStyle(x$6)];
  this.Lcom_iz2use_react_style_Style__f_paperPage = $n($$x25).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7), c);
  var $$x33 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperPageContent");
  var $$x32 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$78 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$2 = 0;
  var u = $m_Lscalacss_internal_LengthUnit$px$();
  var f$5 = new $c_Lscalacss_internal_Length(this$$2, u);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
    var x$3$1 = $as_Lscalacss_internal_Length(x$3$2$1);
    return $n(x$3$1).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
    var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$2);
    return $n(x$1$4)
  }));
  var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
  var r$3 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
  var v$12 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$5);
  var v$13 = $n(v$12).Lscalacss_internal_ValueT__f_value;
  var $$x31 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x32).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$78.Lscalacss_internal_Attrs$top$__f_attr, v$13)));
  var $$x30 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$88 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$3 = 0;
  var u$1 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$7 = new $c_Lscalacss_internal_Length(this$$3, u$1);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$3 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$2) => {
    var x$3$3 = $as_Lscalacss_internal_Length(x$3$2$2);
    return $n(x$3$3).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
    var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$3);
    return $n(x$1$5)
  }));
  var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
  var r$4 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
  var v$14 = $n(r$4).apply__O__Lscalacss_internal_ValueT(f$7);
  var v$15 = $n(v$14).Lscalacss_internal_ValueT__f_value;
  var $$x29 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x30).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$88.Lscalacss_internal_Attrs$left$__f_attr, v$15)));
  var $$x28 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$97 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$4 = 100;
  var f$9 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$4);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$4 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$3) => {
    var x$4$5 = $as_Lscalacss_internal_Percentage(x$4$2$3);
    return $n(x$4$5).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$8 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
    var x$1$6 = $as_Lscalacss_internal_ValueT(x$1$2$4);
    return $n(x$1$6)
  }));
  var bc$4 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$8);
  var r$5 = $n(ab$4).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$4);
  var v$16 = $n(r$5).apply__O__Lscalacss_internal_ValueT(f$9);
  var v$17 = $n(v$16).Lscalacss_internal_ValueT__f_value;
  var $$x27 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x28).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$97.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$17)));
  var $$x26 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$106 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$5 = 100;
  var f$11 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$5);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$5 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$4) => {
    var x$4$6 = $as_Lscalacss_internal_Percentage(x$4$2$4);
    return $n(x$4$6).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$10 = new $c_sjsr_AnonFunction1(((x$1$2$5) => {
    var x$1$7 = $as_Lscalacss_internal_ValueT(x$1$2$5);
    return $n(x$1$7)
  }));
  var bc$5 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$10);
  var r$6 = $n(ab$5).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$5);
  var v$18 = $n(r$6).apply__O__Lscalacss_internal_ValueT(f$11);
  var v$19 = $n(v$18).Lscalacss_internal_ValueT__f_value;
  var array$8 = [$$x31, $$x29, $$x27, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x26).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$106.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$19)))];
  this.Lcom_iz2use_react_style_Style__f_paperPageContent = $n($$x33).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8), c);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x35 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "flex1");
  var $$x34 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$9 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x34).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1")))];
  var x$7 = $n($$x35).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9), c);
  var array$10 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$7).Lscalacss_internal_StyleA__f_style)];
  var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  this.Lcom_iz2use_react_style_Style__f_flex1 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c);
  var $$x40 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "flexRow");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x39 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "flexRow");
  var $$x38 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$122 = $m_Lscalacss_internal_Attrs$display$();
  var $$x37 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x38).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$122.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x36 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$124 = $m_Lscalacss_internal_Attrs$flexDirection$();
  var array$11 = [$$x37, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x36).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$124.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")))];
  var x$8 = $n($$x39).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11), c);
  var array$12 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$8).Lscalacss_internal_StyleA__f_style)];
  this.Lcom_iz2use_react_style_Style__f_flexRow = $n($$x40).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12), c);
  var $$x45 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "flexColumn");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x44 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "flexColumn");
  var $$x43 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$133 = $m_Lscalacss_internal_Attrs$display$();
  var $$x42 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x43).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$133.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x41 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$135 = $m_Lscalacss_internal_Attrs$flexDirection$();
  var array$13 = [$$x42, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x41).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$135.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")))];
  var x$9 = $n($$x44).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13), c);
  var array$14 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$9).Lscalacss_internal_StyleA__f_style)];
  this.Lcom_iz2use_react_style_Style__f_flexColumn = $n($$x45).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14), c);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x48 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$1 = $m_Lscalacss_internal_Attrs$().transform__Lscalacss_internal_Attr();
  var $$x47 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x48).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, "translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.001px)")));
  var $$x46 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$154 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$6 = 133.33333333;
  var f$13 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$6);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$6 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$5) => {
    var x$4$7 = $as_Lscalacss_internal_Percentage(x$4$2$5);
    return $n(x$4$7).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$12 = new $c_sjsr_AnonFunction1(((x$1$2$6) => {
    var x$1$8 = $as_Lscalacss_internal_ValueT(x$1$2$6);
    return $n(x$1$8)
  }));
  var bc$6 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$12);
  var r$7 = $n(ab$6).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$6);
  var v$20 = $n(r$7).apply__O__Lscalacss_internal_ValueT(f$13);
  var v$21 = $n(v$20).Lscalacss_internal_ValueT__f_value;
  var array$15 = [$$x47, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x46).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$154.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$21)))];
  var t$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  this.Lcom_iz2use_react_style_Style__f_formFieldLabelShouldFloat = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$1, c);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$10 = this.Lcom_iz2use_react_style_Style__f_flex1;
  var $$x58 = new $c_Lscalacss_internal_DslBase$ToStyle(x$10);
  var $$x57 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$161 = $m_Lscalacss_internal_Attrs$border$();
  var $$x56 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x57).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$161.Lscalacss_internal_Attrs$border$__f_attr, "0")));
  var $$x55 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$163 = $m_Lscalacss_internal_Attrs$outline$();
  var $$x54 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x55).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$163.Lscalacss_internal_Attrs$outline$__f_attr, "0")));
  var $$x53 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$172 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$7 = 100;
  var f$15 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$7);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$7 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$6) => {
    var x$4$8 = $as_Lscalacss_internal_Percentage(x$4$2$6);
    return $n(x$4$8).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$14 = new $c_sjsr_AnonFunction1(((x$1$2$7) => {
    var x$1$9 = $as_Lscalacss_internal_ValueT(x$1$2$7);
    return $n(x$1$9)
  }));
  var bc$7 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$14);
  var r$8 = $n(ab$7).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$7);
  var v$22 = $n(r$8).apply__O__Lscalacss_internal_ValueT(f$15);
  var v$23 = $n(v$22).Lscalacss_internal_ValueT__f_value;
  var $$x52 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x53).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$172.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$23)));
  var $$x51 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$2 = $m_Lscalacss_internal_Attrs$().background__Lscalacss_internal_Attr();
  var $$x50 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x51).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2, "none")));
  var $$x49 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$177 = $m_Lscalacss_internal_Attrs$color$();
  var v$24 = $m_Lscalacss_internal_Literal$Typed$inherit$();
  var v$25 = v$24.Lscalacss_internal_Literal__f_value;
  var array$16 = [$$x58, $$x56, $$x54, $$x52, $$x50, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x49).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$177.Lscalacss_internal_Attrs$color$__f_attr, v$25)))];
  var t$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  this.Lcom_iz2use_react_style_Style__f_editor = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$2, c);
  var $$x69 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "checkboxField");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$11 = this.Lcom_iz2use_react_style_Style__f_flex1;
  var $$x68 = new $c_Lscalacss_internal_DslBase$ToStyle(x$11);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x67 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$185 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x66 = $n($n($$x67).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$185.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5$1 = $as_Lscalacss_internal_Media$Query(x$5$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$5$1)
  }))));
  var $$x65 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$187 = $m_Lscalacss_internal_Attrs$position$();
  var $$x64 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x65).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$187.Lscalacss_internal_Attrs$position$__f_attr, "relative")));
  var $$x63 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$197 = $m_Lscalacss_internal_Attrs$paddingBottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$8 = 1.25;
  var u$2 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$17 = new $c_Lscalacss_internal_Length(this$$8, u$2);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$8 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$3) => {
    var x$3$4 = $as_Lscalacss_internal_Length(x$3$2$3);
    return $n(x$3$4).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$16 = new $c_sjsr_AnonFunction1(((x$1$2$8) => {
    var x$1$10 = $as_Lscalacss_internal_ValueT(x$1$2$8);
    return $n(x$1$10)
  }));
  var bc$8 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$16);
  var r$9 = $n(ab$8).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$8);
  var v$26 = $n(r$9).apply__O__Lscalacss_internal_ValueT(f$17);
  var v$27 = $n(v$26).Lscalacss_internal_ValueT__f_value;
  var $$x62 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x63).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$197.Lscalacss_internal_Attrs$paddingBottom$__f_attr, v$27)));
  var $$x61 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x60 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$9 = 0;
  var u$3 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$19 = new $c_Lscalacss_internal_Length(this$$9, u$3);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$9 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$4) => {
    var x$3$5 = $as_Lscalacss_internal_Length(x$3$2$4);
    return $n(x$3$5).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$18 = new $c_sjsr_AnonFunction1(((x$1$2$9) => {
    var x$1$11 = $as_Lscalacss_internal_ValueT(x$1$2$9);
    return $n(x$1$11)
  }));
  var bc$9 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$18);
  var r$10 = $n(ab$9).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$9);
  var $$x59 = $n(r$10).apply__O__Lscalacss_internal_ValueT(f$19);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$10 = 0.5;
  var u$4 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$21 = new $c_Lscalacss_internal_Length(this$$10, u$4);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$10 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$5) => {
    var x$3$6 = $as_Lscalacss_internal_Length(x$3$2$5);
    return $n(x$3$6).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$20 = new $c_sjsr_AnonFunction1(((x$1$2$10) => {
    var x$1$12 = $as_Lscalacss_internal_ValueT(x$1$2$10);
    return $n(x$1$12)
  }));
  var bc$10 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$20);
  var r$11 = $n(ab$10).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$10);
  var array$17 = [$$x64, $$x62, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x61).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x60.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x59, $n(r$11).apply__O__Lscalacss_internal_ValueT(f$21))))];
  var x$12 = $n($$x66).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17), c);
  var array$18 = [$$x68, new $c_Lscalacss_internal_DslBase$ToStyle(x$12)];
  this.Lcom_iz2use_react_style_Style__f_checkboxField = $n($$x69).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18), c);
  var $$x75 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "checkboxFieldLabel");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$28 = $m_Lscalacss_internal_Attrs$color$();
  var this$223 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$28);
  var colors = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity = $m_Lcom_iz2use_react_style_OpacityLevel$medium$();
  var array$19 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$223, colors, opacity)];
  var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$22 = new $c_sjsr_AnonFunction1(((x$1$2$11) => {
    var x$1$13 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$11);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$13).light__Lscalacss_internal_AV()))
  }));
  var t$4 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$3, f$22));
  var x$13 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$4, c);
  var $$x74 = new $c_Lscalacss_internal_DslBase$ToStyle(x$13);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x73 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$231 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$232 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$231.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x72 = $n($n($$x73).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$232), new $c_sjsr_AnonFunction1(((x$2$1) => {
    var x$14 = $as_Lscalacss_internal_Media$Query(x$2$1);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$14)
  }))));
  var f$23 = new $c_sjsr_AnonFunction1(((x$2$2$2) => {
    var x$2$2 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2).dark__Lscalacss_internal_AV()))
  }));
  var x$15 = $n($$x72).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$3, f$23)), c);
  var array$20 = [$$x74, new $c_Lscalacss_internal_DslBase$ToStyle(x$15)];
  var t$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20);
  var x$16 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$5, c);
  var $$x71 = new $c_Lscalacss_internal_DslBase$ToStyle(x$16);
  var $$x70 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$3 = $m_Lscalacss_internal_Attrs$().font__Lscalacss_internal_Attr();
  var array$21 = [$$x71, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x70).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$3, "inherit")))];
  this.Lcom_iz2use_react_style_Style__f_checkboxFieldLabel = $n($$x75).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21), c);
  var $$x86 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formField");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$17 = this.Lcom_iz2use_react_style_Style__f_flex1;
  var $$x85 = new $c_Lscalacss_internal_DslBase$ToStyle(x$17);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x84 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$247 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x83 = $n($n($$x84).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$247.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6$1 = $as_Lscalacss_internal_Media$Query(x$6$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$6$1)
  }))));
  var $$x82 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$249 = $m_Lscalacss_internal_Attrs$position$();
  var $$x81 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x82).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$249.Lscalacss_internal_Attrs$position$__f_attr, "relative")));
  var $$x80 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$259 = $m_Lscalacss_internal_Attrs$paddingBottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$11 = 1.25;
  var u$5 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$25 = new $c_Lscalacss_internal_Length(this$$11, u$5);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$11 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$6) => {
    var x$3$7 = $as_Lscalacss_internal_Length(x$3$2$6);
    return $n(x$3$7).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$24 = new $c_sjsr_AnonFunction1(((x$1$2$12) => {
    var x$1$14 = $as_Lscalacss_internal_ValueT(x$1$2$12);
    return $n(x$1$14)
  }));
  var bc$11 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$24);
  var r$12 = $n(ab$11).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$11);
  var v$29 = $n(r$12).apply__O__Lscalacss_internal_ValueT(f$25);
  var v$30 = $n(v$29).Lscalacss_internal_ValueT__f_value;
  var $$x79 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x80).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$259.Lscalacss_internal_Attrs$paddingBottom$__f_attr, v$30)));
  var $$x78 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x77 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$12 = 0;
  var u$6 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$27 = new $c_Lscalacss_internal_Length(this$$12, u$6);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$12 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$7) => {
    var x$3$8 = $as_Lscalacss_internal_Length(x$3$2$7);
    return $n(x$3$8).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$26 = new $c_sjsr_AnonFunction1(((x$1$2$13) => {
    var x$1$15 = $as_Lscalacss_internal_ValueT(x$1$2$13);
    return $n(x$1$15)
  }));
  var bc$12 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$26);
  var r$13 = $n(ab$12).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$12);
  var $$x76 = $n(r$13).apply__O__Lscalacss_internal_ValueT(f$27);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$13 = 0.5;
  var u$7 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$29 = new $c_Lscalacss_internal_Length(this$$13, u$7);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$13 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$8) => {
    var x$3$9 = $as_Lscalacss_internal_Length(x$3$2$8);
    return $n(x$3$9).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$28 = new $c_sjsr_AnonFunction1(((x$1$2$14) => {
    var x$1$16 = $as_Lscalacss_internal_ValueT(x$1$2$14);
    return $n(x$1$16)
  }));
  var bc$13 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$28);
  var r$14 = $n(ab$13).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$13);
  var array$22 = [$$x81, $$x79, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x78).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x77.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x76, $n(r$14).apply__O__Lscalacss_internal_ValueT(f$29))))];
  var x$18 = $n($$x83).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22), c);
  var array$23 = [$$x85, new $c_Lscalacss_internal_DslBase$ToStyle(x$18)];
  this.Lcom_iz2use_react_style_Style__f_formField = $n($$x86).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23), c);
  var $$x110 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formFieldLabelWrapper");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x109 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$285 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x108 = $n($n($$x109).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$285.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7$1 = $as_Lscalacss_internal_Media$Query(x$7$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$7$1)
  }))));
  var $$x107 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$295 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$14 = (-0.84375);
  var u$8 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$31 = new $c_Lscalacss_internal_Length(this$$14, u$8);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$14 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$9) => {
    var x$3$10 = $as_Lscalacss_internal_Length(x$3$2$9);
    return $n(x$3$10).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$30 = new $c_sjsr_AnonFunction1(((x$1$2$15) => {
    var x$1$17 = $as_Lscalacss_internal_ValueT(x$1$2$15);
    return $n(x$1$17)
  }));
  var bc$14 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$30);
  var r$15 = $n(ab$14).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$14);
  var v$31 = $n(r$15).apply__O__Lscalacss_internal_ValueT(f$31);
  var v$32 = $n(v$31).Lscalacss_internal_ValueT__f_value;
  var $$x106 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x107).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$295.Lscalacss_internal_Attrs$top$__f_attr, v$32)));
  var $$x105 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$305 = $m_Lscalacss_internal_Attrs$paddingTop$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$15 = 0.84375;
  var u$9 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$33 = new $c_Lscalacss_internal_Length(this$$15, u$9);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$15 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$10) => {
    var x$3$11 = $as_Lscalacss_internal_Length(x$3$2$10);
    return $n(x$3$11).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$32 = new $c_sjsr_AnonFunction1(((x$1$2$16) => {
    var x$1$18 = $as_Lscalacss_internal_ValueT(x$1$2$16);
    return $n(x$1$18)
  }));
  var bc$15 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$32);
  var r$16 = $n(ab$15).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$15);
  var v$33 = $n(r$16).apply__O__Lscalacss_internal_ValueT(f$33);
  var v$34 = $n(v$33).Lscalacss_internal_ValueT__f_value;
  var $$x104 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x105).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$305.Lscalacss_internal_Attrs$paddingTop$__f_attr, v$34)));
  var $$x103 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$307 = $m_Lscalacss_internal_Attrs$position$();
  var $$x102 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x103).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$307.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x101 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$317 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$16 = 0;
  var u$10 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$35 = new $c_Lscalacss_internal_Length(this$$16, u$10);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$16 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$11) => {
    var x$3$12 = $as_Lscalacss_internal_Length(x$3$2$11);
    return $n(x$3$12).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$34 = new $c_sjsr_AnonFunction1(((x$1$2$17) => {
    var x$1$19 = $as_Lscalacss_internal_ValueT(x$1$2$17);
    return $n(x$1$19)
  }));
  var bc$16 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$34);
  var r$17 = $n(ab$16).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$16);
  var v$35 = $n(r$17).apply__O__Lscalacss_internal_ValueT(f$35);
  var v$36 = $n(v$35).Lscalacss_internal_ValueT__f_value;
  var $$x100 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x101).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$317.Lscalacss_internal_Attrs$left$__f_attr, v$36)));
  var $$x99 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$319 = $m_Lscalacss_internal_Attrs$boxSizing$();
  var $$x98 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x99).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$319.Lscalacss_internal_Attrs$boxSizing$__f_attr, "content-box")));
  var $$x97 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$328 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$17 = 100;
  var f$37 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$17);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$17 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$7) => {
    var x$4$9 = $as_Lscalacss_internal_Percentage(x$4$2$7);
    return $n(x$4$9).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$36 = new $c_sjsr_AnonFunction1(((x$1$2$18) => {
    var x$1$20 = $as_Lscalacss_internal_ValueT(x$1$2$18);
    return $n(x$1$20)
  }));
  var bc$17 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$36);
  var r$18 = $n(ab$17).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$17);
  var v$37 = $n(r$18).apply__O__Lscalacss_internal_ValueT(f$37);
  var v$38 = $n(v$37).Lscalacss_internal_ValueT__f_value;
  var $$x96 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x97).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$328.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$38)));
  var $$x95 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$337 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$18 = 100;
  var f$39 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$18);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$18 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$8) => {
    var x$4$10 = $as_Lscalacss_internal_Percentage(x$4$2$8);
    return $n(x$4$10).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$38 = new $c_sjsr_AnonFunction1(((x$1$2$19) => {
    var x$1$21 = $as_Lscalacss_internal_ValueT(x$1$2$19);
    return $n(x$1$21)
  }));
  var bc$18 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$38);
  var r$19 = $n(ab$18).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$18);
  var v$39 = $n(r$19).apply__O__Lscalacss_internal_ValueT(f$39);
  var v$40 = $n(v$39).Lscalacss_internal_ValueT__f_value;
  var $$x94 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x95).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$337.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$40)));
  var $$x93 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$339 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$41 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$42 = v$41.Lscalacss_internal_Literal__f_value;
  var $$x92 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x93).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$339.Lscalacss_internal_Attrs$overflow$__f_attr, v$42)));
  var $$x91 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$4 = $m_Lscalacss_internal_Attrs$pointerEvents$();
  var array$24 = [$$x106, $$x104, $$x102, $$x100, $$x98, $$x96, $$x94, $$x92, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x91).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$4.Lscalacss_internal_Attrs$pointerEvents$__f_attr, "none")))];
  var x$19 = $n($$x108).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24), c);
  var $$x90 = new $c_Lscalacss_internal_DslBase$ToStyle(x$19);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x89 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$349 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x88 = $n($n($$x89).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$349.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8$1 = $as_Lscalacss_internal_Media$Query(x$8$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$8$1)
  }))));
  var $$x87 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$358 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$19 = 75;
  var f$41 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$19);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$19 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$9) => {
    var x$4$11 = $as_Lscalacss_internal_Percentage(x$4$2$9);
    return $n(x$4$11).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$40 = new $c_sjsr_AnonFunction1(((x$1$2$20) => {
    var x$1$22 = $as_Lscalacss_internal_ValueT(x$1$2$20);
    return $n(x$1$22)
  }));
  var bc$19 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$40);
  var r$20 = $n(ab$19).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$19);
  var v$43 = $n(r$20).apply__O__Lscalacss_internal_ValueT(f$41);
  var v$44 = $n(v$43).Lscalacss_internal_ValueT__f_value;
  var array$25 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x87).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$358.Lscalacss_internal_Attrs$fontSize$__f_attr, v$44)))];
  var x$20 = $n($$x88).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25), c);
  var array$26 = [$$x90, new $c_Lscalacss_internal_DslBase$ToStyle(x$20)];
  this.Lcom_iz2use_react_style_Style__f_formFieldLabelWrapper = $n($$x110).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$26), c);
  var $$x140 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formFieldLabel");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$45 = $m_Lscalacss_internal_Attrs$color$();
  var this$369 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$45);
  var lightVersion = new $c_Lscalacss_internal_ValueT("rgba(0,0,0,0.54)");
  var darkVersion = new $c_Lscalacss_internal_ValueT("rgba(255,255,255,0.80)");
  var array$27 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2(this$369, darkVersion, lightVersion)];
  var t$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$27);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$42 = new $c_sjsr_AnonFunction1(((x$1$2$21) => {
    var x$1$23 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$21);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$23).light__Lscalacss_internal_AV()))
  }));
  var t$7 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$6, f$42));
  var x$21 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$7, c);
  var $$x139 = new $c_Lscalacss_internal_DslBase$ToStyle(x$21);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x138 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$377 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$378 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$377.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x137 = $n($n($$x138).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$378), new $c_sjsr_AnonFunction1(((x$2$3) => {
    var x$22 = $as_Lscalacss_internal_Media$Query(x$2$3);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$22)
  }))));
  var f$43 = new $c_sjsr_AnonFunction1(((x$2$2$2$1) => {
    var x$2$2$1 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$1);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$1).dark__Lscalacss_internal_AV()))
  }));
  var x$23 = $n($$x137).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$6, f$43)), c);
  var array$28 = [$$x139, new $c_Lscalacss_internal_DslBase$ToStyle(x$23)];
  var t$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$28);
  var x$24 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$8, c);
  var $$x136 = new $c_Lscalacss_internal_DslBase$ToStyle(x$24);
  var $$x135 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$5 = $m_Lscalacss_internal_Attrs$().font__Lscalacss_internal_Attr();
  var $$x134 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x135).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$5, "inherit")));
  var $$x133 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$396 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$20 = 100;
  var f$45 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$20);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$20 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$10) => {
    var x$4$12 = $as_Lscalacss_internal_Percentage(x$4$2$10);
    return $n(x$4$12).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$44 = new $c_sjsr_AnonFunction1(((x$1$2$22) => {
    var x$1$24 = $as_Lscalacss_internal_ValueT(x$1$2$22);
    return $n(x$1$24)
  }));
  var bc$20 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$44);
  var r$21 = $n(ab$20).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$20);
  var v$46 = $n(r$21).apply__O__Lscalacss_internal_ValueT(f$45);
  var v$47 = $n(v$46).Lscalacss_internal_ValueT__f_value;
  var $$x132 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x133).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$396.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$47)));
  var $$x131 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$398 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var $$x130 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x131).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$398.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")));
  var $$x129 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$6 = $m_Lscalacss_internal_Attrs$().textOverflow__Lscalacss_internal_Attr();
  var $$x128 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x129).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$6, "ellipsis")));
  var $$x127 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$403 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$48 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$49 = v$48.Lscalacss_internal_Literal__f_value;
  var $$x126 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x127).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$403.Lscalacss_internal_Attrs$overflow$__f_attr, v$49)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x125 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$405 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x124 = $n($n($$x125).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$405.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9$1 = $as_Lscalacss_internal_Media$Query(x$9$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$9$1)
  }))));
  var $$x123 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$415 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$21 = 1.28125;
  var u$11 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$47 = new $c_Lscalacss_internal_Length(this$$21, u$11);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$21 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$12) => {
    var x$3$13 = $as_Lscalacss_internal_Length(x$3$2$12);
    return $n(x$3$13).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$46 = new $c_sjsr_AnonFunction1(((x$1$2$23) => {
    var x$1$25 = $as_Lscalacss_internal_ValueT(x$1$2$23);
    return $n(x$1$25)
  }));
  var bc$21 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$46);
  var r$22 = $n(ab$21).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$21);
  var v$50 = $n(r$22).apply__O__Lscalacss_internal_ValueT(f$47);
  var v$51 = $n(v$50).Lscalacss_internal_ValueT__f_value;
  var $$x122 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x123).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$415.Lscalacss_internal_Attrs$top$__f_attr, v$51)));
  var $$x121 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$417 = $m_Lscalacss_internal_Attrs$position$();
  var $$x120 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x121).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$417.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x119 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$427 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$22 = 0;
  var u$12 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$49 = new $c_Lscalacss_internal_Length(this$$22, u$12);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$22 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$13) => {
    var x$3$14 = $as_Lscalacss_internal_Length(x$3$2$13);
    return $n(x$3$14).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$48 = new $c_sjsr_AnonFunction1(((x$1$2$24) => {
    var x$1$26 = $as_Lscalacss_internal_ValueT(x$1$2$24);
    return $n(x$1$26)
  }));
  var bc$22 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$48);
  var r$23 = $n(ab$22).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$22);
  var v$52 = $n(r$23).apply__O__Lscalacss_internal_ValueT(f$49);
  var v$53 = $n(v$52).Lscalacss_internal_ValueT__f_value;
  var $$x118 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x119).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$427.Lscalacss_internal_Attrs$left$__f_attr, v$53)));
  var $$x117 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$7 = $m_Lscalacss_internal_Attrs$().transition__Lscalacss_internal_Attr();
  var $$x116 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x117).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$7, "transform .4s cubic-bezier(.25,.8,.25,1),color .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1)")));
  var $$x115 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$432 = $m_Lscalacss_internal_Attrs$display$();
  var $$x114 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x115).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$432.Lscalacss_internal_Attrs$display$__f_attr, "block")));
  var $$x113 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$8 = $m_Lscalacss_internal_Attrs$().transform__Lscalacss_internal_Attr();
  var $$x112 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x113).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$8, "perspective(100px)")));
  var $$x111 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$9 = $m_Lscalacss_internal_Attrs$().transformOrigin__Lscalacss_internal_Attr();
  var array$29 = [$$x122, $$x120, $$x118, $$x116, $$x114, $$x112, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x111).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$9, "0 0")))];
  var x$25 = $n($$x124).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$29), c);
  var array$30 = [$$x136, $$x134, $$x132, $$x130, $$x128, $$x126, new $c_Lscalacss_internal_DslBase$ToStyle(x$25)];
  this.Lcom_iz2use_react_style_Style__f_formFieldLabel = $n($$x140).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$30), c);
  var $$x158 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formFieldInputWrapper");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$26 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x157 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$26).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x156 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$448 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x155 = $n($n($$x156).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$448.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10$1 = $as_Lscalacss_internal_Media$Query(x$10$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$10$1)
  }))));
  var $$x154 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x153 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$23 = 0.4375;
  var u$13 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$51 = new $c_Lscalacss_internal_Length(this$$23, u$13);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$23 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$14) => {
    var x$3$15 = $as_Lscalacss_internal_Length(x$3$2$14);
    return $n(x$3$15).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$50 = new $c_sjsr_AnonFunction1(((x$1$2$25) => {
    var x$1$27 = $as_Lscalacss_internal_ValueT(x$1$2$25);
    return $n(x$1$27)
  }));
  var bc$23 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$50);
  var r$24 = $n(ab$23).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$23);
  var $$x152 = $n(r$24).apply__O__Lscalacss_internal_ValueT(f$51);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$24 = 0;
  var u$14 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$53 = new $c_Lscalacss_internal_Length(this$$24, u$14);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$24 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$15) => {
    var x$3$16 = $as_Lscalacss_internal_Length(x$3$2$15);
    return $n(x$3$16).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$52 = new $c_sjsr_AnonFunction1(((x$1$2$26) => {
    var x$1$28 = $as_Lscalacss_internal_ValueT(x$1$2$26);
    return $n(x$1$28)
  }));
  var bc$24 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$52);
  var r$25 = $n(ab$24).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$24);
  var $$x151 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x154).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x153.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x152, $n(r$25).apply__O__Lscalacss_internal_ValueT(f$53))));
  var $$x150 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x149 = $m_Lscalacss_internal_Attrs$borderTop$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$25 = 0.84375;
  var u$15 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$55 = new $c_Lscalacss_internal_Length(this$$25, u$15);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$25 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$16) => {
    var x$3$17 = $as_Lscalacss_internal_Length(x$3$2$16);
    return $n(x$3$17).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$54 = new $c_sjsr_AnonFunction1(((x$1$2$27) => {
    var x$1$29 = $as_Lscalacss_internal_ValueT(x$1$2$27);
    return $n(x$1$29)
  }));
  var bc$25 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$54);
  var r$26 = $n(ab$25).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$25);
  var $$x148 = $n(r$26).apply__O__Lscalacss_internal_ValueT(f$55);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$57 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$477 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$26 = this$477.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$3) => {
    var x$2$4 = $as_Lscalacss_internal_Literal(x$2$2$3);
    return $n(x$2$4).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$56 = new $c_sjsr_AnonFunction1(((x$1$2$28) => {
    var x$1$30 = $as_Lscalacss_internal_ValueT(x$1$2$28);
    return $n(x$1$30)
  }));
  var bc$26 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$56);
  var r$27 = $n(ab$26).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$26);
  var $$x147 = $n(r$27).apply__O__Lscalacss_internal_ValueT(f$57);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$59 = new $c_Lscalacss_internal_ValueT("rgba(0,0,0,0)");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$58 = new $c_sjsr_AnonFunction1(((x$1$2$29) => {
    var x$1$31 = $as_Lscalacss_internal_ValueT(x$1$2$29);
    return $n(x$1$31)
  }));
  var r$28 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$58);
  var $$x146 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x150).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x149.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x148, $$x147, r$28.apply__O__Lscalacss_internal_ValueT(f$59))));
  var $$x145 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$487 = $m_Lscalacss_internal_Attrs$position$();
  var array$31 = [$$x151, $$x146, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x145).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$487.Lscalacss_internal_Attrs$position$__f_attr, "relative")))];
  var x$27 = $n($$x155).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$31), c);
  var $$x144 = new $c_Lscalacss_internal_DslBase$ToStyle(x$27);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x143 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$493 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x142 = $n($n($$x143).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$493.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11$1 = $as_Lscalacss_internal_Media$Query(x$11$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$11$1)
  }))));
  var $$x141 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$495 = $m_Lscalacss_internal_Attrs$flexDirection$();
  var array$32 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x141).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$495.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column-reverse")))];
  var x$28 = $n($$x142).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$32), c);
  var array$33 = [$$x157, $$x144, new $c_Lscalacss_internal_DslBase$ToStyle(x$28)];
  this.Lcom_iz2use_react_style_Style__f_formFieldInputWrapper = $n($$x158).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$33), c);
  var $$x176 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formFieldUnderline");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x175 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$504 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x174 = $n($n($$x175).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$504.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12$1 = $as_Lscalacss_internal_Media$Query(x$12$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$12$1)
  }))));
  var $$x173 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$514 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$26 = 1;
  var u$16 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$61 = new $c_Lscalacss_internal_Length(this$$26, u$16);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$27 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$17) => {
    var x$3$18 = $as_Lscalacss_internal_Length(x$3$2$17);
    return $n(x$3$18).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$60 = new $c_sjsr_AnonFunction1(((x$1$2$30) => {
    var x$1$32 = $as_Lscalacss_internal_ValueT(x$1$2$30);
    return $n(x$1$32)
  }));
  var bc$27 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$60);
  var r$29 = $n(ab$27).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$27);
  var v$54 = $n(r$29).apply__O__Lscalacss_internal_ValueT(f$61);
  var v$55 = $n(v$54).Lscalacss_internal_ValueT__f_value;
  var $$x172 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x173).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$514.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$55)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$56 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$516 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$56);
  var colors$1 = $n(theme).Lcom_iz2use_react_style_Theme__f_lineBorder;
  var opacity$1 = $m_Lcom_iz2use_react_style_OpacityLevel$medium$();
  var array$34 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$516, colors$1, opacity$1)];
  var t$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$34);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$62 = new $c_sjsr_AnonFunction1(((x$1$2$31) => {
    var x$1$33 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$31);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$33).light__Lscalacss_internal_AV()))
  }));
  var t$10 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$9, f$62));
  var x$29 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$10, c);
  var $$x171 = new $c_Lscalacss_internal_DslBase$ToStyle(x$29);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x170 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$524 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$525 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$524.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x169 = $n($n($$x170).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$525), new $c_sjsr_AnonFunction1(((x$2$5) => {
    var x$30 = $as_Lscalacss_internal_Media$Query(x$2$5);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$30)
  }))));
  var f$63 = new $c_sjsr_AnonFunction1(((x$2$2$2$2) => {
    var x$2$2$4 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$2);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$4).dark__Lscalacss_internal_AV()))
  }));
  var x$31 = $n($$x169).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$9, f$63)), c);
  var array$35 = [$$x171, new $c_Lscalacss_internal_DslBase$ToStyle(x$31)];
  var t$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$35);
  var x$32 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$11, c);
  var $$x168 = new $c_Lscalacss_internal_DslBase$ToStyle(x$32);
  var $$x167 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$533 = $m_Lscalacss_internal_Attrs$position$();
  var $$x166 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x167).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$533.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x165 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$543 = $m_Lscalacss_internal_Attrs$bottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$27 = 1.25;
  var u$17 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$65 = new $c_Lscalacss_internal_Length(this$$27, u$17);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$28 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$18) => {
    var x$3$19 = $as_Lscalacss_internal_Length(x$3$2$18);
    return $n(x$3$19).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$64 = new $c_sjsr_AnonFunction1(((x$1$2$32) => {
    var x$1$34 = $as_Lscalacss_internal_ValueT(x$1$2$32);
    return $n(x$1$34)
  }));
  var bc$28 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$64);
  var r$30 = $n(ab$28).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$28);
  var v$57 = $n(r$30).apply__O__Lscalacss_internal_ValueT(f$65);
  var v$58 = $n(v$57).Lscalacss_internal_ValueT__f_value;
  var $$x164 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x165).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$543.Lscalacss_internal_Attrs$bottom$__f_attr, v$58)));
  var $$x163 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$552 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$28 = 100;
  var f$67 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$28);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$29 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$11) => {
    var x$4$13 = $as_Lscalacss_internal_Percentage(x$4$2$11);
    return $n(x$4$13).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$66 = new $c_sjsr_AnonFunction1(((x$1$2$33) => {
    var x$1$35 = $as_Lscalacss_internal_ValueT(x$1$2$33);
    return $n(x$1$35)
  }));
  var bc$29 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$66);
  var r$31 = $n(ab$29).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$29);
  var v$59 = $n(r$31).apply__O__Lscalacss_internal_ValueT(f$67);
  var v$60 = $n(v$59).Lscalacss_internal_ValueT__f_value;
  var array$36 = [$$x172, $$x168, $$x166, $$x164, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x163).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$552.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$60)))];
  var x$33 = $n($$x174).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$36), c);
  var $$x162 = new $c_Lscalacss_internal_DslBase$ToStyle(x$33);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x161 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$558 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x160 = $n($n($$x161).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$558.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13$1 = $as_Lscalacss_internal_Media$Query(x$13$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$13$1)
  }))));
  var $$x159 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$560 = $m_Lscalacss_internal_Attrs$display$();
  var v$61 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$62 = v$61.Lscalacss_internal_Literal__f_value;
  var array$37 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x159).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$560.Lscalacss_internal_Attrs$display$__f_attr, v$62)))];
  var x$34 = $n($$x160).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$37), c);
  var array$38 = [$$x162, new $c_Lscalacss_internal_DslBase$ToStyle(x$34)];
  this.Lcom_iz2use_react_style_Style__f_formFieldUnderline = $n($$x176).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$38), c);
  var $$x206 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formFieldUnderlineRipple");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x205 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$569 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x204 = $n($n($$x205).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$569.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$14$2) => {
    var x$14$1 = $as_Lscalacss_internal_Media$Query(x$14$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$14$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$63 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$571 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$63);
  var colors$2 = $n(theme).Lcom_iz2use_react_style_Theme__f_focused;
  var opacity$2 = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var array$39 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$571, colors$2, opacity$2)];
  var t$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$39);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$68 = new $c_sjsr_AnonFunction1(((x$1$2$34) => {
    var x$1$36 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$34);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$36).light__Lscalacss_internal_AV()))
  }));
  var t$13 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$12, f$68));
  var x$35 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$13, c);
  var $$x203 = new $c_Lscalacss_internal_DslBase$ToStyle(x$35);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x202 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$579 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$580 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$579.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x201 = $n($n($$x202).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$580), new $c_sjsr_AnonFunction1(((x$2$6) => {
    var x$36 = $as_Lscalacss_internal_Media$Query(x$2$6);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$36)
  }))));
  var f$69 = new $c_sjsr_AnonFunction1(((x$2$2$2$3) => {
    var x$2$2$5 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$3);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$5).dark__Lscalacss_internal_AV()))
  }));
  var x$37 = $n($$x201).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$12, f$69)), c);
  var array$40 = [$$x203, new $c_Lscalacss_internal_DslBase$ToStyle(x$37)];
  var t$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$40);
  var x$38 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$14, c);
  var $$x200 = new $c_Lscalacss_internal_DslBase$ToStyle(x$38);
  var $$x199 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$588 = $m_Lscalacss_internal_Attrs$position$();
  var $$x198 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x199).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$588.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x197 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$598 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$29 = 0;
  var u$18 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$71 = new $c_Lscalacss_internal_Length(this$$29, u$18);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$30 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$19) => {
    var x$3$20 = $as_Lscalacss_internal_Length(x$3$2$19);
    return $n(x$3$20).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$70 = new $c_sjsr_AnonFunction1(((x$1$2$35) => {
    var x$1$37 = $as_Lscalacss_internal_ValueT(x$1$2$35);
    return $n(x$1$37)
  }));
  var bc$30 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$70);
  var r$32 = $n(ab$30).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$30);
  var v$64 = $n(r$32).apply__O__Lscalacss_internal_ValueT(f$71);
  var v$65 = $n(v$64).Lscalacss_internal_ValueT__f_value;
  var $$x196 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x197).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$598.Lscalacss_internal_Attrs$top$__f_attr, v$65)));
  var $$x195 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$608 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$30 = 0;
  var u$19 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$73 = new $c_Lscalacss_internal_Length(this$$30, u$19);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$31 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$20) => {
    var x$3$21 = $as_Lscalacss_internal_Length(x$3$2$20);
    return $n(x$3$21).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$72 = new $c_sjsr_AnonFunction1(((x$1$2$36) => {
    var x$1$38 = $as_Lscalacss_internal_ValueT(x$1$2$36);
    return $n(x$1$38)
  }));
  var bc$31 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$72);
  var r$33 = $n(ab$31).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$31);
  var v$66 = $n(r$33).apply__O__Lscalacss_internal_ValueT(f$73);
  var v$67 = $n(v$66).Lscalacss_internal_ValueT__f_value;
  var $$x194 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x195).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$608.Lscalacss_internal_Attrs$left$__f_attr, v$67)));
  var $$x193 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$617 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$31 = 100;
  var f$75 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$31);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$32 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$12) => {
    var x$4$14 = $as_Lscalacss_internal_Percentage(x$4$2$12);
    return $n(x$4$14).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$74 = new $c_sjsr_AnonFunction1(((x$1$2$37) => {
    var x$1$39 = $as_Lscalacss_internal_ValueT(x$1$2$37);
    return $n(x$1$39)
  }));
  var bc$32 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$74);
  var r$34 = $n(ab$32).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$32);
  var v$68 = $n(r$34).apply__O__Lscalacss_internal_ValueT(f$75);
  var v$69 = $n(v$68).Lscalacss_internal_ValueT__f_value;
  var $$x192 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x193).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$617.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$69)));
  var $$x191 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$627 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$32 = 2;
  var u$20 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$77 = new $c_Lscalacss_internal_Length(this$$32, u$20);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$33 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$21) => {
    var x$3$22 = $as_Lscalacss_internal_Length(x$3$2$21);
    return $n(x$3$22).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$76 = new $c_sjsr_AnonFunction1(((x$1$2$38) => {
    var x$1$40 = $as_Lscalacss_internal_ValueT(x$1$2$38);
    return $n(x$1$40)
  }));
  var bc$33 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$76);
  var r$35 = $n(ab$33).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$33);
  var v$70 = $n(r$35).apply__O__Lscalacss_internal_ValueT(f$77);
  var v$71 = $n(v$70).Lscalacss_internal_ValueT__f_value;
  var $$x190 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x191).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$627.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$71)));
  var $$x189 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$10 = $m_Lscalacss_internal_Attrs$().transformOrigin__Lscalacss_internal_Attr();
  var $$x188 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x189).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$10, "50%")));
  var $$x187 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$11 = $m_Lscalacss_internal_Attrs$().transform__Lscalacss_internal_Attr();
  var $$x186 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x187).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$11, "scaleX(.5)")));
  var $$x185 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$635 = $m_Lscalacss_internal_Attrs$visibility$();
  var v$72 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$73 = v$72.Lscalacss_internal_Literal__f_value;
  var $$x184 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x185).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$635.Lscalacss_internal_Attrs$visibility$__f_attr, v$73)));
  var $$x183 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$640 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$36 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$1) => {
    var x$6$3 = $uI(x$6$2$1);
    return ("" + x$6$3)
  })));
  var v$74 = $n(r$36).apply__O__Lscalacss_internal_ValueT(0);
  var v$75 = $n(v$74).Lscalacss_internal_ValueT__f_value;
  var $$x182 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x183).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$640.Lscalacss_internal_Attrs$opacity$__f_attr, v$75)));
  var $$x181 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$12 = $m_Lscalacss_internal_Attrs$().transition__Lscalacss_internal_Attr();
  var array$41 = [$$x200, $$x198, $$x196, $$x194, $$x192, $$x190, $$x188, $$x186, $$x184, $$x182, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x181).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$12, "background-color .3s cubic-bezier(.55,0,.55,.2)")))];
  var x$39 = $n($$x204).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$41), c);
  var $$x180 = new $c_Lscalacss_internal_DslBase$ToStyle(x$39);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x179 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$649 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x178 = $n($n($$x179).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$649.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$15$2) => {
    var x$15$1 = $as_Lscalacss_internal_Media$Query(x$15$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$15$1)
  }))));
  var $$x177 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$651 = $m_Lscalacss_internal_Attrs$display$();
  var v$76 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$77 = v$76.Lscalacss_internal_Literal__f_value;
  var array$42 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x177).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$651.Lscalacss_internal_Attrs$display$__f_attr, v$77)))];
  var x$40 = $n($$x178).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$42), c);
  var array$43 = [$$x180, new $c_Lscalacss_internal_DslBase$ToStyle(x$40)];
  this.Lcom_iz2use_react_style_Style__f_formFieldUnderlineRipple = $n($$x206).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$43), c);
  var $$x227 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formFieldSubscript");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x226 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$660 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x225 = $n($n($$x226).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$660.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$16$2) => {
    var x$16$1 = $as_Lscalacss_internal_Media$Query(x$16$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$16$1)
  }))));
  var $$x224 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$662 = $m_Lscalacss_internal_Attrs$position$();
  var $$x223 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x224).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$662.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x222 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$671 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$33 = 100;
  var f$79 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$33);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$34 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$13) => {
    var x$4$15 = $as_Lscalacss_internal_Percentage(x$4$2$13);
    return $n(x$4$15).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$78 = new $c_sjsr_AnonFunction1(((x$1$2$39) => {
    var x$1$41 = $as_Lscalacss_internal_ValueT(x$1$2$39);
    return $n(x$1$41)
  }));
  var bc$34 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$78);
  var r$37 = $n(ab$34).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$34);
  var v$78 = $n(r$37).apply__O__Lscalacss_internal_ValueT(f$79);
  var v$79 = $n(v$78).Lscalacss_internal_ValueT__f_value;
  var $$x221 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x222).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$671.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$79)));
  var $$x220 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$673 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$80 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$81 = v$80.Lscalacss_internal_Literal__f_value;
  var $$x219 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x220).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$673.Lscalacss_internal_Attrs$overflow$__f_attr, v$81)));
  var $$x218 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$682 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$34 = 75;
  var f$81 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$34);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$35 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$14) => {
    var x$4$16 = $as_Lscalacss_internal_Percentage(x$4$2$14);
    return $n(x$4$16).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$80 = new $c_sjsr_AnonFunction1(((x$1$2$40) => {
    var x$1$42 = $as_Lscalacss_internal_ValueT(x$1$2$40);
    return $n(x$1$42)
  }));
  var bc$35 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$80);
  var r$38 = $n(ab$35).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$35);
  var v$82 = $n(r$38).apply__O__Lscalacss_internal_ValueT(f$81);
  var v$83 = $n(v$82).Lscalacss_internal_ValueT__f_value;
  var $$x217 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x218).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$682.Lscalacss_internal_Attrs$fontSize$__f_attr, v$83)));
  var $$x216 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$692 = $m_Lscalacss_internal_Attrs$marginTop$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$35 = 0.54166667;
  var u$21 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$83 = new $c_Lscalacss_internal_Length(this$$35, u$21);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$36 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$22) => {
    var x$3$23 = $as_Lscalacss_internal_Length(x$3$2$22);
    return $n(x$3$23).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$82 = new $c_sjsr_AnonFunction1(((x$1$2$41) => {
    var x$1$43 = $as_Lscalacss_internal_ValueT(x$1$2$41);
    return $n(x$1$43)
  }));
  var bc$36 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$82);
  var r$39 = $n(ab$36).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$36);
  var v$84 = $n(r$39).apply__O__Lscalacss_internal_ValueT(f$83);
  var v$85 = $n(v$84).Lscalacss_internal_ValueT__f_value;
  var $$x215 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x216).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$692.Lscalacss_internal_Attrs$marginTop$__f_attr, v$85)));
  var $$x214 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x213 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$13 = $m_Lscalacss_internal_Attrs$top$();
  var $$x212 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x214).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x213).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$13, "calc(100% - 1.66666667em)")));
  var $$x211 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$697 = $m_Lscalacss_internal_Attrs$color$();
  var v$86 = new $c_Lscalacss_internal_ValueT("#ddd");
  var v$87 = v$86.Lscalacss_internal_ValueT__f_value;
  var array$44 = [$$x223, $$x221, $$x219, $$x217, $$x215, $$x212, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x211).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$697.Lscalacss_internal_Attrs$color$__f_attr, v$87)))];
  var x$41 = $n($$x225).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$44), c);
  var $$x210 = new $c_Lscalacss_internal_DslBase$ToStyle(x$41);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x209 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$703 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x208 = $n($n($$x209).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$703.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$17$2) => {
    var x$17$1 = $as_Lscalacss_internal_Media$Query(x$17$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$17$1)
  }))));
  var $$x207 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$705 = $m_Lscalacss_internal_Attrs$display$();
  var v$88 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$89 = v$88.Lscalacss_internal_Literal__f_value;
  var array$45 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x207).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$705.Lscalacss_internal_Attrs$display$__f_attr, v$89)))];
  var x$42 = $n($$x208).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$45), c);
  var array$46 = [$$x210, new $c_Lscalacss_internal_DslBase$ToStyle(x$42)];
  this.Lcom_iz2use_react_style_Style__f_formFieldSubscript = $n($$x227).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$46), c);
  var $$x274 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "autocompleteContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$43 = $n($n($n(md).Elevation__Lcom_iz2use_react_style_MaterialDesign$Elevation$()).ModalBottomSheet__Lcom_iz2use_react_style_MaterialDesign$Elevation$ModalBottomSheet$()).style__Lscalacss_internal_StyleS();
  var $$x273 = new $c_Lscalacss_internal_DslBase$ToStyle(x$43);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x272 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$715 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x271 = $n($n($$x272).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$715.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$18$2) => {
    var x$18$1 = $as_Lscalacss_internal_Media$Query(x$18$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$18$1)
  }))));
  var $$x270 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$725 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$36 = 256;
  var u$22 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$85 = new $c_Lscalacss_internal_Length(this$$36, u$22);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$37 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$23) => {
    var x$3$24 = $as_Lscalacss_internal_Length(x$3$2$23);
    return $n(x$3$24).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$84 = new $c_sjsr_AnonFunction1(((x$1$2$42) => {
    var x$1$44 = $as_Lscalacss_internal_ValueT(x$1$2$42);
    return $n(x$1$44)
  }));
  var bc$37 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$84);
  var r$40 = $n(ab$37).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$37);
  var v$90 = $n(r$40).apply__O__Lscalacss_internal_ValueT(f$85);
  var v$91 = $n(v$90).Lscalacss_internal_ValueT__f_value;
  var $$x269 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x270).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$725.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$91)));
  var $$x268 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$727 = $m_Lscalacss_internal_Attrs$position$();
  var $$x267 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x268).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$727.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x266 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$737 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$37 = 0;
  var u$23 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$87 = new $c_Lscalacss_internal_Length(this$$37, u$23);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$38 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$24) => {
    var x$3$25 = $as_Lscalacss_internal_Length(x$3$2$24);
    return $n(x$3$25).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$86 = new $c_sjsr_AnonFunction1(((x$1$2$43) => {
    var x$1$45 = $as_Lscalacss_internal_ValueT(x$1$2$43);
    return $n(x$1$45)
  }));
  var bc$38 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$86);
  var r$41 = $n(ab$38).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$38);
  var v$92 = $n(r$41).apply__O__Lscalacss_internal_ValueT(f$87);
  var v$93 = $n(v$92).Lscalacss_internal_ValueT__f_value;
  var $$x265 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x266).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$737.Lscalacss_internal_Attrs$left$__f_attr, v$93)));
  var $$x264 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$747 = $m_Lscalacss_internal_Attrs$right$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$38 = 0;
  var u$24 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$89 = new $c_Lscalacss_internal_Length(this$$38, u$24);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$39 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$25) => {
    var x$3$26 = $as_Lscalacss_internal_Length(x$3$2$25);
    return $n(x$3$26).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$88 = new $c_sjsr_AnonFunction1(((x$1$2$44) => {
    var x$1$46 = $as_Lscalacss_internal_ValueT(x$1$2$44);
    return $n(x$1$46)
  }));
  var bc$39 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$88);
  var r$42 = $n(ab$39).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$39);
  var v$94 = $n(r$42).apply__O__Lscalacss_internal_ValueT(f$89);
  var v$95 = $n(v$94).Lscalacss_internal_ValueT__f_value;
  var $$x263 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x264).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$747.Lscalacss_internal_Attrs$right$__f_attr, v$95)));
  var $$x262 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$757 = $m_Lscalacss_internal_Attrs$minWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$39 = 10;
  var u$25 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$91 = new $c_Lscalacss_internal_Length(this$$39, u$25);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$40 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$26) => {
    var x$3$27 = $as_Lscalacss_internal_Length(x$3$2$26);
    return $n(x$3$27).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$90 = new $c_sjsr_AnonFunction1(((x$1$2$45) => {
    var x$1$47 = $as_Lscalacss_internal_ValueT(x$1$2$45);
    return $n(x$1$47)
  }));
  var bc$40 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$90);
  var r$43 = $n(ab$40).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$40);
  var v$96 = $n(r$43).apply__O__Lscalacss_internal_ValueT(f$91);
  var v$97 = $n(v$96).Lscalacss_internal_ValueT__f_value;
  var $$x261 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x262).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$757.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$97)));
  var $$x260 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x259 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$14 = $m_Lscalacss_internal_Attrs$top$();
  var $$x258 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x260).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x259).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$14, "calc(0.84375rem + 18px)")));
  var $$x257 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$764 = $m_Lscalacss_internal_Attrs$zIndex$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$44 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$5$2$1) => {
    var x$5$3 = $uI(x$5$2$1);
    return ("" + x$5$3)
  })));
  var v$98 = $n(r$44).apply__O__Lscalacss_internal_ValueT(1);
  var v$99 = $n(v$98).Lscalacss_internal_ValueT__f_value;
  var $$x256 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x257).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$764.Lscalacss_internal_Attrs$zIndex$__f_attr, v$99)));
  var $$x255 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$766 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x254 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x255).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$766.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "white")));
  var $$x253 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$768 = $m_Lscalacss_internal_Attrs$color$();
  var $$x252 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x253).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$768.Lscalacss_internal_Attrs$color$__f_attr, "black")));
  var $$x251 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$770 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$100 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$101 = v$100.Lscalacss_internal_Literal__f_value;
  var $$x250 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x251).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$770.Lscalacss_internal_Attrs$overflowX$__f_attr, v$101)));
  var $$x249 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$772 = $m_Lscalacss_internal_Attrs$overflowY$();
  var v$102 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$103 = v$102.Lscalacss_internal_Literal__f_value;
  var $$x248 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x249).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$772.Lscalacss_internal_Attrs$overflowY$__f_attr, v$103)));
  var $$x247 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x246 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x245 = new $c_sjsr_AnonFunction1(((x$3$3$2) => {
    var x$3$3$1 = $as_T(x$3$3$2);
    return (x$3$3$1 + ">*")
  }));
  var $$x244 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$774 = $m_Lscalacss_internal_Attrs$display$();
  var $$x243 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x244).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$774.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x242 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x241 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$40 = 0;
  var u$26 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$93 = new $c_Lscalacss_internal_Length(this$$40, u$26);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$41 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$27) => {
    var x$3$28 = $as_Lscalacss_internal_Length(x$3$2$27);
    return $n(x$3$28).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$92 = new $c_sjsr_AnonFunction1(((x$1$2$46) => {
    var x$1$48 = $as_Lscalacss_internal_ValueT(x$1$2$46);
    return $n(x$1$48)
  }));
  var bc$41 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$92);
  var r$45 = $n(ab$41).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$41);
  var $$x240 = $n(r$45).apply__O__Lscalacss_internal_ValueT(f$93);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$41 = 16;
  var u$27 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$95 = new $c_Lscalacss_internal_Length(this$$41, u$27);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$42 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$28) => {
    var x$3$29 = $as_Lscalacss_internal_Length(x$3$2$28);
    return $n(x$3$29).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$94 = new $c_sjsr_AnonFunction1(((x$1$2$47) => {
    var x$1$49 = $as_Lscalacss_internal_ValueT(x$1$2$47);
    return $n(x$1$49)
  }));
  var bc$42 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$94);
  var r$46 = $n(ab$42).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$42);
  var $$x239 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x242).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x241.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x240, $n(r$46).apply__O__Lscalacss_internal_ValueT(f$95))));
  var $$x238 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$801 = $m_Lscalacss_internal_Attrs$lineHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$42 = 48;
  var u$28 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$97 = new $c_Lscalacss_internal_Length(this$$42, u$28);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$43 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$29) => {
    var x$3$30 = $as_Lscalacss_internal_Length(x$3$2$29);
    return $n(x$3$30).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$96 = new $c_sjsr_AnonFunction1(((x$1$2$48) => {
    var x$1$50 = $as_Lscalacss_internal_ValueT(x$1$2$48);
    return $n(x$1$50)
  }));
  var bc$43 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$96);
  var r$47 = $n(ab$43).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$43);
  var v$104 = $n(r$47).apply__O__Lscalacss_internal_ValueT(f$97);
  var v$105 = $n(v$104).Lscalacss_internal_ValueT__f_value;
  var $$x237 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x238).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$801.Lscalacss_internal_Attrs$lineHeight$__f_attr, v$105)));
  var $$x236 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$15 = $m_Lscalacss_internal_Attrs$().textOverflow__Lscalacss_internal_Attr();
  var $$x235 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x236).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$15, "ellipsis")));
  var $$x234 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$806 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var $$x233 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x234).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$806.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")));
  var $$x232 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$808 = $m_Lscalacss_internal_Attrs$alignItems$();
  var array$47 = [$$x243, $$x239, $$x237, $$x235, $$x233, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x232).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$808.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")))];
  var array$48 = [$$x269, $$x267, $$x265, $$x263, $$x261, $$x258, $$x256, $$x254, $$x252, $$x250, $$x248, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x247).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x246).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x245, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$47), c)))];
  var x$44 = $n($$x271).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$48), c);
  var $$x231 = new $c_Lscalacss_internal_DslBase$ToStyle(x$44);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x230 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$817 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x229 = $n($n($$x230).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$817.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$19$2) => {
    var x$19$1 = $as_Lscalacss_internal_Media$Query(x$19$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$19$1)
  }))));
  var $$x228 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$819 = $m_Lscalacss_internal_Attrs$display$();
  var v$106 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$107 = v$106.Lscalacss_internal_Literal__f_value;
  var array$49 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x228).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$819.Lscalacss_internal_Attrs$display$__f_attr, v$107)))];
  var x$45 = $n($$x229).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$49), c);
  var array$50 = [$$x273, $$x231, new $c_Lscalacss_internal_DslBase$ToStyle(x$45)];
  this.Lcom_iz2use_react_style_Style__f_autocompleteContainer = $n($$x274).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$50), c);
  var $$x287 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "autocompleteScoreWrapper");
  var $$x286 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$836 = $m_Lscalacss_internal_Attrs$minWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$43 = 8;
  var u$29 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$99 = new $c_Lscalacss_internal_Length(this$$43, u$29);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$44 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$30) => {
    var x$3$31 = $as_Lscalacss_internal_Length(x$3$2$30);
    return $n(x$3$31).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$98 = new $c_sjsr_AnonFunction1(((x$1$2$49) => {
    var x$1$51 = $as_Lscalacss_internal_ValueT(x$1$2$49);
    return $n(x$1$51)
  }));
  var bc$44 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$98);
  var r$48 = $n(ab$44).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$44);
  var v$108 = $n(r$48).apply__O__Lscalacss_internal_ValueT(f$99);
  var v$109 = $n(v$108).Lscalacss_internal_ValueT__f_value;
  var $$x285 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x286).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$836.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$109)));
  var $$x284 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$846 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$44 = 8;
  var u$30 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$101 = new $c_Lscalacss_internal_Length(this$$44, u$30);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$45 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$31) => {
    var x$3$32 = $as_Lscalacss_internal_Length(x$3$2$31);
    return $n(x$3$32).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$100 = new $c_sjsr_AnonFunction1(((x$1$2$50) => {
    var x$1$52 = $as_Lscalacss_internal_ValueT(x$1$2$50);
    return $n(x$1$52)
  }));
  var bc$45 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$100);
  var r$49 = $n(ab$45).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$45);
  var v$110 = $n(r$49).apply__O__Lscalacss_internal_ValueT(f$101);
  var v$111 = $n(v$110).Lscalacss_internal_ValueT__f_value;
  var $$x283 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x284).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$846.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$111)));
  var $$x282 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$856 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$45 = 8;
  var u$31 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$103 = new $c_Lscalacss_internal_Length(this$$45, u$31);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$46 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$32) => {
    var x$3$33 = $as_Lscalacss_internal_Length(x$3$2$32);
    return $n(x$3$33).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$102 = new $c_sjsr_AnonFunction1(((x$1$2$51) => {
    var x$1$53 = $as_Lscalacss_internal_ValueT(x$1$2$51);
    return $n(x$1$53)
  }));
  var bc$46 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$102);
  var r$50 = $n(ab$46).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$46);
  var v$112 = $n(r$50).apply__O__Lscalacss_internal_ValueT(f$103);
  var v$113 = $n(v$112).Lscalacss_internal_ValueT__f_value;
  var $$x281 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x282).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$856.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$113)));
  var $$x280 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$866 = $m_Lscalacss_internal_Attrs$marginRight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$46 = 2;
  var u$32 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$105 = new $c_Lscalacss_internal_Length(this$$46, u$32);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$47 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$33) => {
    var x$3$34 = $as_Lscalacss_internal_Length(x$3$2$33);
    return $n(x$3$34).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$104 = new $c_sjsr_AnonFunction1(((x$1$2$52) => {
    var x$1$54 = $as_Lscalacss_internal_ValueT(x$1$2$52);
    return $n(x$1$54)
  }));
  var bc$47 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$104);
  var r$51 = $n(ab$47).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$47);
  var v$114 = $n(r$51).apply__O__Lscalacss_internal_ValueT(f$105);
  var v$115 = $n(v$114).Lscalacss_internal_ValueT__f_value;
  var $$x279 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x280).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$866.Lscalacss_internal_Attrs$marginRight$__f_attr, v$115)));
  var $$x278 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$868 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$116 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$117 = v$116.Lscalacss_internal_Literal__f_value;
  var $$x277 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x278).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$868.Lscalacss_internal_Attrs$overflow$__f_attr, v$117)));
  var this$879 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$47 = 8;
  var u$33 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$107 = new $c_Lscalacss_internal_Length(this$$47, u$33);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$48 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$34) => {
    var x$3$35 = $as_Lscalacss_internal_Length(x$3$2$34);
    return $n(x$3$35).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$106 = new $c_sjsr_AnonFunction1(((x$1$2$53) => {
    var x$1$55 = $as_Lscalacss_internal_ValueT(x$1$2$53);
    return $n(x$1$55)
  }));
  var bc$48 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$106);
  var r$52 = $n(ab$48).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$48);
  var radius = $n(r$52).apply__O__Lscalacss_internal_ValueT(f$107);
  var v$118 = $n(radius).Lscalacss_internal_ValueT__f_value;
  var x$46 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$118);
  var $$x276 = new $c_Lscalacss_internal_DslBase$ToStyle(this$879.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$46.av__Lscalacss_internal_AV()));
  var $$x275 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$881 = $m_Lscalacss_internal_Attrs$position$();
  var array$51 = [$$x285, $$x283, $$x281, $$x279, $$x277, $$x276, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x275).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$881.Lscalacss_internal_Attrs$position$__f_attr, "relative")))];
  this.Lcom_iz2use_react_style_Style__f_autocompleteScoreWrapper = $n($$x287).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$51), c);
  var $$x299 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "autocompleteScore");
  var $$x298 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$886 = $m_Lscalacss_internal_Attrs$position$();
  var $$x297 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x298).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$886.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x296 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$896 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$48 = 0;
  var u$34 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$109 = new $c_Lscalacss_internal_Length(this$$48, u$34);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$49 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$35) => {
    var x$3$36 = $as_Lscalacss_internal_Length(x$3$2$35);
    return $n(x$3$36).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$108 = new $c_sjsr_AnonFunction1(((x$1$2$54) => {
    var x$1$56 = $as_Lscalacss_internal_ValueT(x$1$2$54);
    return $n(x$1$56)
  }));
  var bc$49 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$108);
  var r$53 = $n(ab$49).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$49);
  var v$119 = $n(r$53).apply__O__Lscalacss_internal_ValueT(f$109);
  var v$120 = $n(v$119).Lscalacss_internal_ValueT__f_value;
  var $$x295 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x296).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$896.Lscalacss_internal_Attrs$top$__f_attr, v$120)));
  var $$x294 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$906 = $m_Lscalacss_internal_Attrs$right$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$49 = 0;
  var u$35 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$111 = new $c_Lscalacss_internal_Length(this$$49, u$35);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$50 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$36) => {
    var x$3$37 = $as_Lscalacss_internal_Length(x$3$2$36);
    return $n(x$3$37).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$110 = new $c_sjsr_AnonFunction1(((x$1$2$55) => {
    var x$1$57 = $as_Lscalacss_internal_ValueT(x$1$2$55);
    return $n(x$1$57)
  }));
  var bc$50 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$110);
  var r$54 = $n(ab$50).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$50);
  var v$121 = $n(r$54).apply__O__Lscalacss_internal_ValueT(f$111);
  var v$122 = $n(v$121).Lscalacss_internal_ValueT__f_value;
  var $$x293 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x294).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$906.Lscalacss_internal_Attrs$right$__f_attr, v$122)));
  var $$x292 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$915 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$50 = 100;
  var f$113 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$50);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$51 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$15) => {
    var x$4$17 = $as_Lscalacss_internal_Percentage(x$4$2$15);
    return $n(x$4$17).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$112 = new $c_sjsr_AnonFunction1(((x$1$2$56) => {
    var x$1$58 = $as_Lscalacss_internal_ValueT(x$1$2$56);
    return $n(x$1$58)
  }));
  var bc$51 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$112);
  var r$55 = $n(ab$51).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$51);
  var v$123 = $n(r$55).apply__O__Lscalacss_internal_ValueT(f$113);
  var v$124 = $n(v$123).Lscalacss_internal_ValueT__f_value;
  var $$x291 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x292).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$915.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$124)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$125 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$917 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$125);
  var colors$3 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$3 = $m_Lcom_iz2use_react_style_OpacityLevel$medium$();
  var array$52 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$917, colors$3, opacity$3)];
  var t$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$52);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$114 = new $c_sjsr_AnonFunction1(((x$1$2$57) => {
    var x$1$59 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$57);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$59).light__Lscalacss_internal_AV()))
  }));
  var t$16 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$15, f$114));
  var x$47 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$16, c);
  var $$x290 = new $c_Lscalacss_internal_DslBase$ToStyle(x$47);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x289 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$925 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$926 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$925.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x288 = $n($n($$x289).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$926), new $c_sjsr_AnonFunction1(((x$2$7) => {
    var x$48 = $as_Lscalacss_internal_Media$Query(x$2$7);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$48)
  }))));
  var f$115 = new $c_sjsr_AnonFunction1(((x$2$2$2$4) => {
    var x$2$2$6 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$4);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$6).dark__Lscalacss_internal_AV()))
  }));
  var x$49 = $n($$x288).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$15, f$115)), c);
  var array$53 = [$$x290, new $c_Lscalacss_internal_DslBase$ToStyle(x$49)];
  var t$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$53);
  var x$50 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$17, c);
  var array$54 = [$$x297, $$x295, $$x293, $$x291, new $c_Lscalacss_internal_DslBase$ToStyle(x$50)];
  this.Lcom_iz2use_react_style_Style__f_autocompleteScore = $n($$x299).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$54), c);
  var $$x304 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "autocompleteContainerError");
  var $$x303 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x302 = $m_Lscalacss_internal_Attrs$borderTop$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$51 = 3;
  var u$36 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$117 = new $c_Lscalacss_internal_Length(this$$51, u$36);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$52 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$37) => {
    var x$3$38 = $as_Lscalacss_internal_Length(x$3$2$37);
    return $n(x$3$38).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$116 = new $c_sjsr_AnonFunction1(((x$1$2$58) => {
    var x$1$60 = $as_Lscalacss_internal_ValueT(x$1$2$58);
    return $n(x$1$60)
  }));
  var bc$52 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$116);
  var r$56 = $n(ab$52).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$52);
  var $$x301 = $n(r$56).apply__O__Lscalacss_internal_ValueT(f$117);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$119 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$947 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$53 = this$947.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$7) => {
    var x$2$8 = $as_Lscalacss_internal_Literal(x$2$2$7);
    return $n(x$2$8).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$118 = new $c_sjsr_AnonFunction1(((x$1$2$59) => {
    var x$1$61 = $as_Lscalacss_internal_ValueT(x$1$2$59);
    return $n(x$1$61)
  }));
  var bc$53 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$118);
  var r$57 = $n(ab$53).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$53);
  var $$x300 = $n(r$57).apply__O__Lscalacss_internal_ValueT(f$119);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$121 = new $c_Lscalacss_internal_ValueT("red");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$120 = new $c_sjsr_AnonFunction1(((x$1$2$60) => {
    var x$1$62 = $as_Lscalacss_internal_ValueT(x$1$2$60);
    return $n(x$1$62)
  }));
  var r$58 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$120);
  var array$55 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x303).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x302.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x301, $$x300, r$58.apply__O__Lscalacss_internal_ValueT(f$121))))];
  this.Lcom_iz2use_react_style_Style__f_autocompleteContainerError = $n($$x304).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$55), c);
  var $$x309 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "autocompleteContainerPending");
  var $$x308 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x307 = $m_Lscalacss_internal_Attrs$borderTop$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$52 = 3;
  var u$37 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$123 = new $c_Lscalacss_internal_Length(this$$52, u$37);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$54 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$38) => {
    var x$3$39 = $as_Lscalacss_internal_Length(x$3$2$38);
    return $n(x$3$39).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$122 = new $c_sjsr_AnonFunction1(((x$1$2$61) => {
    var x$1$63 = $as_Lscalacss_internal_ValueT(x$1$2$61);
    return $n(x$1$63)
  }));
  var bc$54 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$122);
  var r$59 = $n(ab$54).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$54);
  var $$x306 = $n(r$59).apply__O__Lscalacss_internal_ValueT(f$123);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$125 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$971 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$55 = this$971.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$8) => {
    var x$2$9 = $as_Lscalacss_internal_Literal(x$2$2$8);
    return $n(x$2$9).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$124 = new $c_sjsr_AnonFunction1(((x$1$2$62) => {
    var x$1$64 = $as_Lscalacss_internal_ValueT(x$1$2$62);
    return $n(x$1$64)
  }));
  var bc$55 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$124);
  var r$60 = $n(ab$55).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$55);
  var $$x305 = $n(r$60).apply__O__Lscalacss_internal_ValueT(f$125);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$127 = new $c_Lscalacss_internal_ValueT("blue");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$126 = new $c_sjsr_AnonFunction1(((x$1$2$63) => {
    var x$1$65 = $as_Lscalacss_internal_ValueT(x$1$2$63);
    return $n(x$1$65)
  }));
  var r$61 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$126);
  var array$56 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x308).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x307.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x306, $$x305, r$61.apply__O__Lscalacss_internal_ValueT(f$127))))];
  this.Lcom_iz2use_react_style_Style__f_autocompleteContainerPending = $n($$x309).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$56), c);
  var $$x311 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "autocompleteItemActive");
  var $$x310 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$986 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$126 = new $c_Lscalacss_internal_ValueT("rgba(0,0,0,0.04)");
  var v$127 = v$126.Lscalacss_internal_ValueT__f_value;
  var array$57 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x310).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$986.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$127)))];
  this.Lcom_iz2use_react_style_Style__f_autocompleteItemActive = $n($$x311).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$57), c);
  var $$x312 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "selectEditor");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$51 = this.Lcom_iz2use_react_style_Style__f_editor;
  var array$58 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$51)];
  $n($$x312).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$58), c);
  var $$x313 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "textEditor");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$52 = this.Lcom_iz2use_react_style_Style__f_editor;
  var array$59 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$52)];
  this.Lcom_iz2use_react_style_Style__f_textEditor = $n($$x313).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$59), c);
  var $$x318 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "multilineTextEditor");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$53 = this.Lcom_iz2use_react_style_Style__f_editor;
  var $$x317 = new $c_Lscalacss_internal_DslBase$ToStyle(x$53);
  var $$x316 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1007 = $m_Lscalacss_internal_Attrs$minWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$53 = 100;
  var f$129 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$53);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$56 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$16) => {
    var x$4$18 = $as_Lscalacss_internal_Percentage(x$4$2$16);
    return $n(x$4$18).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$128 = new $c_sjsr_AnonFunction1(((x$1$2$64) => {
    var x$1$66 = $as_Lscalacss_internal_ValueT(x$1$2$64);
    return $n(x$1$66)
  }));
  var bc$56 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$128);
  var r$62 = $n(ab$56).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$56);
  var v$128 = $n(r$62).apply__O__Lscalacss_internal_ValueT(f$129);
  var v$129 = $n(v$128).Lscalacss_internal_ValueT__f_value;
  var $$x315 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x316).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1007.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$129)));
  var $$x314 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1016 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$54 = 100;
  var f$131 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$54);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$57 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$17) => {
    var x$4$19 = $as_Lscalacss_internal_Percentage(x$4$2$17);
    return $n(x$4$19).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$130 = new $c_sjsr_AnonFunction1(((x$1$2$65) => {
    var x$1$67 = $as_Lscalacss_internal_ValueT(x$1$2$65);
    return $n(x$1$67)
  }));
  var bc$57 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$130);
  var r$63 = $n(ab$57).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$57);
  var v$130 = $n(r$63).apply__O__Lscalacss_internal_ValueT(f$131);
  var v$131 = $n(v$130).Lscalacss_internal_ValueT__f_value;
  var array$60 = [$$x317, $$x315, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x314).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1016.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$131)))];
  this.Lcom_iz2use_react_style_Style__f_multilineTextEditor = $n($$x318).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$60), c);
  var $$x322 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "checkboxFieldHasFocus");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x321 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1021 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x320 = $n($n($$x321).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1021.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$20$2) => {
    var x$20$1 = $as_Lscalacss_internal_Media$Query(x$20$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$20$1)
  }))));
  var $$x319 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1024 = $m_Lscalacss_internal_Attrs$color$();
  var v$132 = new $c_Lscalacss_internal_ValueT("#3f51b5");
  var v$133 = v$132.Lscalacss_internal_ValueT__f_value;
  var array$61 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x319).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1024.Lscalacss_internal_Attrs$color$__f_attr, v$133)))];
  var x$54 = $n($$x320).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$61), c);
  var array$62 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$54)];
  this.Lcom_iz2use_react_style_Style__f_checkboxFieldHasFocus = $n($$x322).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$62), c);
  var $$x350 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formFieldHasFocus");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x349 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1033 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x348 = $n($n($$x349).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1033.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$21$2) => {
    var x$21$1 = $as_Lscalacss_internal_Media$Query(x$21$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$21$1)
  }))));
  var $$x347 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x346 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x345 = $n(this.Lcom_iz2use_react_style_Style__f_formFieldUnderlineRipple).Lscalacss_internal_StyleA__f_htmlClass;
  var $$x344 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1035 = $m_Lscalacss_internal_Attrs$visibility$();
  var $$x343 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x344).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1035.Lscalacss_internal_Attrs$visibility$__f_attr, "visible")));
  var $$x342 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1040 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$64 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$2) => {
    var x$6$4 = $uI(x$6$2$2);
    return ("" + x$6$4)
  })));
  var v$134 = $n(r$64).apply__O__Lscalacss_internal_ValueT(1);
  var v$135 = $n(v$134).Lscalacss_internal_ValueT__f_value;
  var $$x341 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x342).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1040.Lscalacss_internal_Attrs$opacity$__f_attr, v$135)));
  var $$x340 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$16 = $m_Lscalacss_internal_Attrs$().transform__Lscalacss_internal_Attr();
  var $$x339 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x340).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$16, "scaleX(1)")));
  var $$x338 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$17 = $m_Lscalacss_internal_Attrs$().transition__Lscalacss_internal_Attr();
  var array$63 = [$$x343, $$x341, $$x339, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x338).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$17, "transform .3s cubic-bezier(.25,.8,.25,1), opacity .1s cubic-bezier(.25,.8,.25,1), background-color .3s cubic-bezier(.25,.8,.25,1)")))];
  var $$x337 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x347).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x346).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(("." + $$x345), $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$63), c)));
  var $$x336 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x335 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x334 = $n(this.Lcom_iz2use_react_style_Style__f_formFieldLabel).Lscalacss_internal_StyleA__f_htmlClass;
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$55 = this.Lcom_iz2use_react_style_Style__f_formFieldLabelShouldFloat;
  var $$x333 = new $c_Lscalacss_internal_DslBase$ToStyle(x$55);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$136 = $m_Lscalacss_internal_Attrs$color$();
  var qual$9 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$136);
  var x$19$3 = $n(theme).Lcom_iz2use_react_style_Theme__f_focused;
  var x$20$3 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$64 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$9, x$19$3, x$20$3)];
  var t$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$64);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$132 = new $c_sjsr_AnonFunction1(((x$1$2$66) => {
    var x$1$68 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$66);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$68).light__Lscalacss_internal_AV()))
  }));
  var t$19 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$18, f$132));
  var x$56 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$19, c);
  var $$x332 = new $c_Lscalacss_internal_DslBase$ToStyle(x$56);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x331 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1059 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1060 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1059.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x330 = $n($n($$x331).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1060), new $c_sjsr_AnonFunction1(((x$2$10) => {
    var x$57 = $as_Lscalacss_internal_Media$Query(x$2$10);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$57)
  }))));
  var f$133 = new $c_sjsr_AnonFunction1(((x$2$2$2$5) => {
    var x$2$2$9 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$5);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$9).dark__Lscalacss_internal_AV()))
  }));
  var x$58 = $n($$x330).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$18, f$133)), c);
  var array$65 = [$$x332, new $c_Lscalacss_internal_DslBase$ToStyle(x$58)];
  var t$20 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$65);
  var x$59 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$20, c);
  var array$66 = [$$x333, new $c_Lscalacss_internal_DslBase$ToStyle(x$59)];
  var $$x329 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x336).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x335).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(("." + $$x334), $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$66), c)));
  var $$x328 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x327 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x326 = $n(this.Lcom_iz2use_react_style_Style__f_formFieldSubscript).Lscalacss_internal_StyleA__f_htmlClass;
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$137 = $m_Lscalacss_internal_Attrs$color$();
  var qual$10 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$137);
  var x$21$3 = $n(theme).Lcom_iz2use_react_style_Theme__f_focused;
  var x$22$1 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$67 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$10, x$21$3, x$22$1)];
  var t$21 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$67);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$134 = new $c_sjsr_AnonFunction1(((x$1$2$67) => {
    var x$1$69 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$67);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$69).light__Lscalacss_internal_AV()))
  }));
  var t$22 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$21, f$134));
  var x$60 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$22, c);
  var $$x325 = new $c_Lscalacss_internal_DslBase$ToStyle(x$60);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x324 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1078 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1079 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1078.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x323 = $n($n($$x324).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1079), new $c_sjsr_AnonFunction1(((x$2$11) => {
    var x$61 = $as_Lscalacss_internal_Media$Query(x$2$11);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$61)
  }))));
  var f$135 = new $c_sjsr_AnonFunction1(((x$2$2$2$6) => {
    var x$2$2$10 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$6);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$10).dark__Lscalacss_internal_AV()))
  }));
  var x$62 = $n($$x323).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$21, f$135)), c);
  var array$68 = [$$x325, new $c_Lscalacss_internal_DslBase$ToStyle(x$62)];
  var t$23 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$68);
  var x$63 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$23, c);
  var array$69 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$63)];
  var array$70 = [$$x337, $$x329, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x328).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x327).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(("." + $$x326), $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$69), c)))];
  var x$64 = $n($$x348).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$70), c);
  var array$71 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$64)];
  this.Lcom_iz2use_react_style_Style__f_formFieldHasFocus = $n($$x350).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$71), c);
  var $$x356 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formFieldNotEmpty");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x355 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1097 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x354 = $n($n($$x355).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1097.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$23$2) => {
    var x$23$1 = $as_Lscalacss_internal_Media$Query(x$23$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$23$1)
  }))));
  var $$x353 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x352 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x351 = $n(this.Lcom_iz2use_react_style_Style__f_formFieldLabel).Lscalacss_internal_StyleA__f_htmlClass;
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$65 = this.Lcom_iz2use_react_style_Style__f_formFieldLabelShouldFloat;
  var array$72 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$65)];
  var array$73 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x353).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x352).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(("." + $$x351), $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$72), c)))];
  var x$66 = $n($$x354).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$73), c);
  var array$74 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$66)];
  this.Lcom_iz2use_react_style_Style__f_formFieldNotEmpty = $n($$x356).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$74), c);
  var $$x368 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "formFieldInvalid");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x367 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1110 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x366 = $n($n($$x367).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1110.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$24$2) => {
    var x$24$1 = $as_Lscalacss_internal_Media$Query(x$24$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$24$1)
  }))));
  var $$x365 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x364 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x363 = $n(this.Lcom_iz2use_react_style_Style__f_formFieldLabel).Lscalacss_internal_StyleA__f_htmlClass;
  var $$x362 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1112 = $m_Lscalacss_internal_Attrs$color$();
  var array$75 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x362).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1112.Lscalacss_internal_Attrs$color$__f_attr, "red")))];
  var $$x361 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x365).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x364).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(("." + $$x363), $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$75), c)));
  var $$x360 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x359 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x358 = $n(this.Lcom_iz2use_react_style_Style__f_formFieldSubscript).Lscalacss_internal_StyleA__f_htmlClass;
  var $$x357 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1117 = $m_Lscalacss_internal_Attrs$color$();
  var array$76 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x357).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1117.Lscalacss_internal_Attrs$color$__f_attr, "red")))];
  var array$77 = [$$x361, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x360).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x359).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(("." + $$x358), $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$76), c)))];
  var x$67 = $n($$x366).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$77), c);
  var array$78 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$67)];
  this.Lcom_iz2use_react_style_Style__f_formFieldInvalid = $n($$x368).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$78), c);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$138 = $m_Lscalacss_internal_Attrs$color$();
  var this$1129 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$138);
  var colors$4 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$4 = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var array$79 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1129, colors$4, opacity$4)];
  var t$24 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$79);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$136 = new $c_sjsr_AnonFunction1(((x$1$2$68) => {
    var x$1$70 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$68);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$70).light__Lscalacss_internal_AV()))
  }));
  var t$25 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$24, f$136));
  var x$68 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$25, c);
  var $$x378 = new $c_Lscalacss_internal_DslBase$ToStyle(x$68);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x377 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1137 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1138 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1137.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x376 = $n($n($$x377).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1138), new $c_sjsr_AnonFunction1(((x$2$12) => {
    var x$69 = $as_Lscalacss_internal_Media$Query(x$2$12);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$69)
  }))));
  var f$137 = new $c_sjsr_AnonFunction1(((x$2$2$2$7) => {
    var x$2$2$11 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$7);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$11).dark__Lscalacss_internal_AV()))
  }));
  var x$70 = $n($$x376).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$24, f$137)), c);
  var array$80 = [$$x378, new $c_Lscalacss_internal_DslBase$ToStyle(x$70)];
  var t$26 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$80);
  var x$71 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$26, c);
  var $$x375 = new $c_Lscalacss_internal_DslBase$ToStyle(x$71);
  var $$x374 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x373 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x372 = new $c_sjsr_AnonFunction1(((x$4$3$2) => {
    var x$4$3$1 = $as_T(x$4$3$2);
    return (x$4$3$1 + ">svg")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$139 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var this$1147 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$139);
  var colors$5 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$5 = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var array$81 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6(this$1147, colors$5, opacity$5)];
  var t$27 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$81);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$138 = new $c_sjsr_AnonFunction1(((x$1$2$69) => {
    var x$1$71 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$69);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$71).light__Lscalacss_internal_AV()))
  }));
  var t$28 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$27, f$138));
  var x$72 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$28, c);
  var $$x371 = new $c_Lscalacss_internal_DslBase$ToStyle(x$72);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x370 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1155 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1156 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1155.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x369 = $n($n($$x370).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1156), new $c_sjsr_AnonFunction1(((x$2$13) => {
    var x$73 = $as_Lscalacss_internal_Media$Query(x$2$13);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$73)
  }))));
  var f$139 = new $c_sjsr_AnonFunction1(((x$2$2$2$8) => {
    var x$2$2$12 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$8);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$12).dark__Lscalacss_internal_AV()))
  }));
  var x$74 = $n($$x369).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$27, f$139)), c);
  var array$82 = [$$x371, new $c_Lscalacss_internal_DslBase$ToStyle(x$74)];
  var t$29 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$82);
  var x$75 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$29, c);
  var array$83 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$75)];
  var array$84 = [$$x375, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x374).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x373).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x372, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$83), c)))];
  var t$30 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$84);
  this.Lcom_iz2use_react_style_Style__f_commonSelectorItemActive = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$30, c);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$140 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$1171 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$140);
  var colors$6 = $n(theme).Lcom_iz2use_react_style_Theme__f_focused;
  var opacity$6 = $m_Lcom_iz2use_react_style_OpacityLevel$low$();
  var $$x387 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1171, colors$6, opacity$6);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$141 = $m_Lscalacss_internal_Attrs$color$();
  var qual$6 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$141);
  var x$13$3 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var x$14$3 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var $$x386 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$6, x$13$3, x$14$3);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$142 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var this$1176 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$142);
  var colors$7 = $n(theme).Lcom_iz2use_react_style_Theme__f_background;
  var opacity$7 = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var f$140 = new $c_sjsr_AnonFunction1(((color$2) => {
    var color = $as_Lscalacss_internal_ValueT(color$2);
    return new $c_sjsr_AnonFunction1(((x$5$2$2) => {
      var x$5$4 = $as_Lscalacss_internal_Attr(x$5$2$2);
      $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value = ("0em 0em 0.25em " + $n(color).Lscalacss_internal_ValueT__f_value);
      return new $c_Lscalacss_internal_AV(x$5$4, value)
    }))
  }));
  var array$85 = [$$x387, $$x386, new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(this$1176, f$140, colors$7, opacity$7)];
  var t$31 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$85);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$141 = new $c_sjsr_AnonFunction1(((x$1$2$70) => {
    var x$1$72 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$70);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$72).light__Lscalacss_internal_AV()))
  }));
  var t$32 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$31, f$141));
  var x$76 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$32, c);
  var $$x390 = new $c_Lscalacss_internal_DslBase$ToStyle(x$76);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x389 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1184 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1185 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1184.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x388 = $n($n($$x389).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1185), new $c_sjsr_AnonFunction1(((x$2$14) => {
    var x$77 = $as_Lscalacss_internal_Media$Query(x$2$14);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$77)
  }))));
  var f$142 = new $c_sjsr_AnonFunction1(((x$2$2$2$9) => {
    var x$2$2$13 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$9);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$13).dark__Lscalacss_internal_AV()))
  }));
  var x$78 = $n($$x388).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$31, f$142)), c);
  var array$86 = [$$x390, new $c_Lscalacss_internal_DslBase$ToStyle(x$78)];
  var t$33 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$86);
  var x$79 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$33, c);
  var $$x385 = new $c_Lscalacss_internal_DslBase$ToStyle(x$79);
  var $$x384 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x383 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x382 = new $c_sjsr_AnonFunction1(((x$6$3$2) => {
    var x$6$3$1 = $as_T(x$6$3$2);
    return (x$6$3$1 + ">svg")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$143 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var qual$7 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$143);
  var x$15$3 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var x$16$3 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$87 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6(qual$7, x$15$3, x$16$3)];
  var t$34 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$87);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$143 = new $c_sjsr_AnonFunction1(((x$1$2$71) => {
    var x$1$73 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$71);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$73).light__Lscalacss_internal_AV()))
  }));
  var t$35 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$34, f$143));
  var x$80 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$35, c);
  var $$x381 = new $c_Lscalacss_internal_DslBase$ToStyle(x$80);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x380 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1201 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1202 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1201.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x379 = $n($n($$x380).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1202), new $c_sjsr_AnonFunction1(((x$2$15) => {
    var x$81 = $as_Lscalacss_internal_Media$Query(x$2$15);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$81)
  }))));
  var f$144 = new $c_sjsr_AnonFunction1(((x$2$2$2$10) => {
    var x$2$2$14 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$10);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$14).dark__Lscalacss_internal_AV()))
  }));
  var x$82 = $n($$x379).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$34, f$144)), c);
  var array$88 = [$$x381, new $c_Lscalacss_internal_DslBase$ToStyle(x$82)];
  var t$36 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$88);
  var x$83 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$36, c);
  var array$89 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$83)];
  var array$90 = [$$x385, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x384).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x383).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x382, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$89), c)))];
  var t$37 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$90);
  this.Lcom_iz2use_react_style_Style__f_commonSelectorItemFocused = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$37, c);
  var $$x392 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "calendarContainer");
  var $$x391 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1217 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$91 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x391).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1217.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "transparent")))];
  this.Lcom_iz2use_react_style_Style__f_calendarContainer = $n($$x392).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$91), c);
  var $$x394 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "calendarMonthContainer");
  var $$x393 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1222 = $m_Lscalacss_internal_Attrs$position$();
  var array$92 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x393).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1222.Lscalacss_internal_Attrs$position$__f_attr, "relative")))];
  this.Lcom_iz2use_react_style_Style__f_calendarMonthContainer = $n($$x394).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$92), c);
  var $$x412 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "calendarMonthWrapper");
  var $$x411 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1227 = $m_Lscalacss_internal_Attrs$position$();
  var $$x410 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x411).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1227.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$144 = $m_Lscalacss_internal_Attrs$color$();
  var this$1229 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$144);
  var colors$8 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$8 = $m_Lcom_iz2use_react_style_OpacityLevel$low$();
  var array$93 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1229, colors$8, opacity$8)];
  var t$38 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$93);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$145 = new $c_sjsr_AnonFunction1(((x$1$2$72) => {
    var x$1$74 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$72);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$74).light__Lscalacss_internal_AV()))
  }));
  var t$39 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$38, f$145));
  var x$84 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$39, c);
  var $$x409 = new $c_Lscalacss_internal_DslBase$ToStyle(x$84);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x408 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1237 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1238 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1237.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x407 = $n($n($$x408).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1238), new $c_sjsr_AnonFunction1(((x$2$16) => {
    var x$85 = $as_Lscalacss_internal_Media$Query(x$2$16);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$85)
  }))));
  var f$146 = new $c_sjsr_AnonFunction1(((x$2$2$2$11) => {
    var x$2$2$15 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$11);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$15).dark__Lscalacss_internal_AV()))
  }));
  var x$86 = $n($$x407).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$38, f$146)), c);
  var array$94 = [$$x409, new $c_Lscalacss_internal_DslBase$ToStyle(x$86)];
  var t$40 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$94);
  var x$87 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$40, c);
  var $$x406 = new $c_Lscalacss_internal_DslBase$ToStyle(x$87);
  var $$x405 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1254 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$55 = 5;
  var u$38 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$148 = new $c_Lscalacss_internal_Length(this$$55, u$38);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$58 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$39) => {
    var x$3$40 = $as_Lscalacss_internal_Length(x$3$2$39);
    return $n(x$3$40).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$147 = new $c_sjsr_AnonFunction1(((x$1$2$73) => {
    var x$1$75 = $as_Lscalacss_internal_ValueT(x$1$2$73);
    return $n(x$1$75)
  }));
  var bc$58 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$147);
  var r$65 = $n(ab$58).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$58);
  var v$145 = $n(r$65).apply__O__Lscalacss_internal_ValueT(f$148);
  var v$146 = $n(v$145).Lscalacss_internal_ValueT__f_value;
  var $$x404 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x405).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1254.Lscalacss_internal_Attrs$fontSize$__f_attr, v$146)));
  var $$x403 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1256 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var $$x402 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x403).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1256.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")));
  var $$x401 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1266 = $m_Lscalacss_internal_Attrs$bottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$56 = 0;
  var u$39 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$150 = new $c_Lscalacss_internal_Length(this$$56, u$39);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$59 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$40) => {
    var x$3$41 = $as_Lscalacss_internal_Length(x$3$2$40);
    return $n(x$3$41).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$149 = new $c_sjsr_AnonFunction1(((x$1$2$74) => {
    var x$1$76 = $as_Lscalacss_internal_ValueT(x$1$2$74);
    return $n(x$1$76)
  }));
  var bc$59 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$149);
  var r$66 = $n(ab$59).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$59);
  var v$147 = $n(r$66).apply__O__Lscalacss_internal_ValueT(f$150);
  var v$148 = $n(v$147).Lscalacss_internal_ValueT__f_value;
  var $$x400 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x401).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1266.Lscalacss_internal_Attrs$bottom$__f_attr, v$148)));
  var $$x399 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1276 = $m_Lscalacss_internal_Attrs$right$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$57 = 0;
  var u$40 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$152 = new $c_Lscalacss_internal_Length(this$$57, u$40);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$60 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$41) => {
    var x$3$42 = $as_Lscalacss_internal_Length(x$3$2$41);
    return $n(x$3$42).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$151 = new $c_sjsr_AnonFunction1(((x$1$2$75) => {
    var x$1$77 = $as_Lscalacss_internal_ValueT(x$1$2$75);
    return $n(x$1$77)
  }));
  var bc$60 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$151);
  var r$67 = $n(ab$60).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$60);
  var v$149 = $n(r$67).apply__O__Lscalacss_internal_ValueT(f$152);
  var v$150 = $n(v$149).Lscalacss_internal_ValueT__f_value;
  var $$x398 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x399).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1276.Lscalacss_internal_Attrs$right$__f_attr, v$150)));
  var $$x397 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1278 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var $$x396 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x397).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1278.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")));
  var $$x395 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1280 = $m_Lscalacss_internal_Attrs$userSelect$();
  var v$151 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$152 = v$151.Lscalacss_internal_Literal__f_value;
  var array$95 = [$$x410, $$x406, $$x404, $$x402, $$x400, $$x398, $$x396, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x395).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1280.Lscalacss_internal_Attrs$userSelect$__f_attr, v$152)))];
  this.Lcom_iz2use_react_style_Style__f_calendarMonthWrapper = $n($$x412).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$95), c);
  var $$x437 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "calendarTable");
  var $$x436 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1285 = $m_Lscalacss_internal_Attrs$tableLayout$();
  var $$x435 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x436).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1285.Lscalacss_internal_Attrs$tableLayout$__f_attr, "fixed")));
  var $$x434 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1294 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$58 = 100;
  var f$154 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$58);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$61 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$18) => {
    var x$4$20 = $as_Lscalacss_internal_Percentage(x$4$2$18);
    return $n(x$4$20).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$153 = new $c_sjsr_AnonFunction1(((x$1$2$76) => {
    var x$1$78 = $as_Lscalacss_internal_ValueT(x$1$2$76);
    return $n(x$1$78)
  }));
  var bc$61 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$153);
  var r$68 = $n(ab$61).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$61);
  var v$153 = $n(r$68).apply__O__Lscalacss_internal_ValueT(f$154);
  var v$154 = $n(v$153).Lscalacss_internal_ValueT__f_value;
  var $$x433 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x434).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1294.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$154)));
  var $$x432 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1299 = $m_Lscalacss_internal_Attrs$zIndex$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$69 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$5$2$3) => {
    var x$5$5 = $uI(x$5$2$3);
    return ("" + x$5$5)
  })));
  var v$155 = $n(r$69).apply__O__Lscalacss_internal_ValueT(1);
  var v$156 = $n(v$155).Lscalacss_internal_ValueT__f_value;
  var $$x431 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x432).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1299.Lscalacss_internal_Attrs$zIndex$__f_attr, v$156)));
  var $$x430 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1301 = $m_Lscalacss_internal_Attrs$position$();
  var $$x429 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x430).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1301.Lscalacss_internal_Attrs$position$__f_attr, "relative")));
  var $$x428 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x427 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x426 = new $c_sjsr_AnonFunction1(((x$7$3$2) => {
    var x$7$3 = $as_T(x$7$3$2);
    return (x$7$3 + ">THEAD>TR>TH")
  }));
  var $$x425 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1310 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$59 = 12.5;
  var f$156 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$59);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$62 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$19) => {
    var x$4$21 = $as_Lscalacss_internal_Percentage(x$4$2$19);
    return $n(x$4$21).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$155 = new $c_sjsr_AnonFunction1(((x$1$2$77) => {
    var x$1$79 = $as_Lscalacss_internal_ValueT(x$1$2$77);
    return $n(x$1$79)
  }));
  var bc$62 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$155);
  var r$70 = $n(ab$62).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$62);
  var v$157 = $n(r$70).apply__O__Lscalacss_internal_ValueT(f$156);
  var v$158 = $n(v$157).Lscalacss_internal_ValueT__f_value;
  var $$x424 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x425).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1310.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$158)));
  var $$x423 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x422 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x421 = new $c_sjsr_AnonFunction1(((x$8$3$2) => {
    var x$8$3 = $as_T(x$8$3$2);
    return (x$8$3 + ">DIV")
  }));
  var $$x420 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1312 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$159 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$160 = v$159.Lscalacss_internal_Literal__f_value;
  var $$x419 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x420).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1312.Lscalacss_internal_Attrs$overflow$__f_attr, v$160)));
  var $$x418 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$18 = $m_Lscalacss_internal_Attrs$().textOverflow__Lscalacss_internal_Attr();
  var array$96 = [$$x419, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x418).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$18, "ellipsis")))];
  var array$97 = [$$x424, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x423).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x422).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x421, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$96), c)))];
  var $$x417 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x428).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x427).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x426, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$97), c)));
  var $$x416 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x415 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x414 = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    return (s + ">TBODY>TR>TD")
  }));
  var $$x413 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1323 = $m_Lscalacss_internal_Attrs$textAlign$();
  var array$98 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x413).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1323.Lscalacss_internal_Attrs$textAlign$__f_attr, "center")))];
  var array$99 = [$$x435, $$x433, $$x431, $$x429, $$x417, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x416).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x415).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x414, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$98), c)))];
  this.Lcom_iz2use_react_style_Style__f_calendarTable = $n($$x437).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$99), c);
  var $$x441 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "calendarOther");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$161 = $m_Lscalacss_internal_Attrs$color$();
  var this$1331 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$161);
  var colors$9 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$9 = $m_Lcom_iz2use_react_style_OpacityLevel$low$();
  var array$100 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1331, colors$9, opacity$9)];
  var t$41 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$100);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$157 = new $c_sjsr_AnonFunction1(((x$1$2$78) => {
    var x$1$80 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$78);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$80).light__Lscalacss_internal_AV()))
  }));
  var t$42 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$41, f$157));
  var x$88 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$42, c);
  var $$x440 = new $c_Lscalacss_internal_DslBase$ToStyle(x$88);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x439 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1339 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1340 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1339.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x438 = $n($n($$x439).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1340), new $c_sjsr_AnonFunction1(((x$2$17) => {
    var x$89 = $as_Lscalacss_internal_Media$Query(x$2$17);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$89)
  }))));
  var f$158 = new $c_sjsr_AnonFunction1(((x$2$2$2$12) => {
    var x$2$2$16 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$12);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$16).dark__Lscalacss_internal_AV()))
  }));
  var x$90 = $n($$x438).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$41, f$158)), c);
  var array$101 = [$$x440, new $c_Lscalacss_internal_DslBase$ToStyle(x$90)];
  var t$43 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$101);
  var x$91 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$43, c);
  var array$102 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$91)];
  this.Lcom_iz2use_react_style_Style__f_calendarOther = $n($$x441).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$102), c);
  var $$x446 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "calendarNow");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$162 = $m_Lscalacss_internal_Attrs$color$();
  var qual$11 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$162);
  var x$23$3 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var x$24$3 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var $$x442 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$11, x$23$3, x$24$3);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$163 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$1352 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$163);
  var colors$10 = $n(theme).Lcom_iz2use_react_style_Theme__f_focused;
  var opacity$10 = $m_Lcom_iz2use_react_style_OpacityLevel$low$();
  var array$103 = [$$x442, new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1352, colors$10, opacity$10)];
  var t$44 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$103);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$159 = new $c_sjsr_AnonFunction1(((x$1$2$79) => {
    var x$1$81 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$79);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$81).light__Lscalacss_internal_AV()))
  }));
  var t$45 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$44, f$159));
  var x$92 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$45, c);
  var $$x445 = new $c_Lscalacss_internal_DslBase$ToStyle(x$92);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x444 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1360 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1361 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1360.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x443 = $n($n($$x444).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1361), new $c_sjsr_AnonFunction1(((x$2$18) => {
    var x$93 = $as_Lscalacss_internal_Media$Query(x$2$18);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$93)
  }))));
  var f$160 = new $c_sjsr_AnonFunction1(((x$2$2$2$13) => {
    var x$2$2$17 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$13);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$17).dark__Lscalacss_internal_AV()))
  }));
  var x$94 = $n($$x443).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$44, f$160)), c);
  var array$104 = [$$x445, new $c_Lscalacss_internal_DslBase$ToStyle(x$94)];
  var t$46 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$104);
  var x$95 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$46, c);
  var array$105 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$95)];
  this.Lcom_iz2use_react_style_Style__f_calendarNow = $n($$x446).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$105), c);
  var $$x452 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "calendarActive");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$164 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var this$1376 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$164);
  var lightVersion$1 = new $c_Lscalacss_internal_ValueT("#ccc");
  var darkVersion$1 = new $c_Lscalacss_internal_ValueT("#333");
  var f$161 = new $c_sjsr_AnonFunction1(((color$3$2) => {
    var color$3 = $as_Lscalacss_internal_ValueT(color$3$2);
    return new $c_sjsr_AnonFunction1(((x$9$2$1) => {
      var x$9$3 = $as_Lscalacss_internal_Attr(x$9$2$1);
      $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value$1 = ("0em 0em 0.25em " + $n(color$3).Lscalacss_internal_ValueT__f_value);
      return new $c_Lscalacss_internal_AV(x$9$3, value$1)
    }))
  }));
  var $$x448 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$4(this$1376, f$161, darkVersion$1, lightVersion$1);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$165 = $m_Lscalacss_internal_Attrs$color$();
  var this$1378 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$165);
  var colors$11 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$11 = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var $$x447 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1378, colors$11, opacity$11);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$166 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var qual$12 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$166);
  var x$25$1 = $n(theme).Lcom_iz2use_react_style_Theme__f_focused;
  var x$26$1 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$106 = [$$x448, $$x447, new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$12, x$25$1, x$26$1)];
  var t$47 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$106);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$162 = new $c_sjsr_AnonFunction1(((x$1$2$80) => {
    var x$1$82 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$80);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$82).light__Lscalacss_internal_AV()))
  }));
  var t$48 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$47, f$162));
  var x$96 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$48, c);
  var $$x451 = new $c_Lscalacss_internal_DslBase$ToStyle(x$96);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x450 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1387 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1388 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1387.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x449 = $n($n($$x450).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1388), new $c_sjsr_AnonFunction1(((x$2$19) => {
    var x$97 = $as_Lscalacss_internal_Media$Query(x$2$19);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$97)
  }))));
  var f$163 = new $c_sjsr_AnonFunction1(((x$2$2$2$14) => {
    var x$2$2$18 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$14);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$18).dark__Lscalacss_internal_AV()))
  }));
  var x$98 = $n($$x449).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$47, f$163)), c);
  var array$107 = [$$x451, new $c_Lscalacss_internal_DslBase$ToStyle(x$98)];
  var t$49 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$107);
  var x$99 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$49, c);
  var array$108 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$99)];
  this.Lcom_iz2use_react_style_Style__f_calendarActive = $n($$x452).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$108), c);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x477 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1399 = $m_Lscalacss_internal_Attrs$cursor$();
  var $$x476 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x477).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1399.Lscalacss_internal_Attrs$cursor$__f_attr, "pointer")));
  var this$1410 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$60 = 0.25;
  var u$41 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$165 = new $c_Lscalacss_internal_Length(this$$60, u$41);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$63 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$42) => {
    var x$3$43 = $as_Lscalacss_internal_Length(x$3$2$42);
    return $n(x$3$43).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$164 = new $c_sjsr_AnonFunction1(((x$1$2$81) => {
    var x$1$83 = $as_Lscalacss_internal_ValueT(x$1$2$81);
    return $n(x$1$83)
  }));
  var bc$63 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$164);
  var r$71 = $n(ab$63).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$63);
  var radius$1 = $n(r$71).apply__O__Lscalacss_internal_ValueT(f$165);
  var v$167 = $n(radius$1).Lscalacss_internal_ValueT__f_value;
  var x$100 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$167);
  var $$x475 = new $c_Lscalacss_internal_DslBase$ToStyle(this$1410.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$100.av__Lscalacss_internal_AV()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$168 = $m_Lscalacss_internal_Attrs$color$();
  var this$1412 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$168);
  var colors$12 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$12 = $m_Lcom_iz2use_react_style_OpacityLevel$low$();
  var array$109 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1412, colors$12, opacity$12)];
  var t$50 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$109);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$166 = new $c_sjsr_AnonFunction1(((x$1$2$82) => {
    var x$1$84 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$82);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$84).light__Lscalacss_internal_AV()))
  }));
  var t$51 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$50, f$166));
  var x$101 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$51, c);
  var $$x474 = new $c_Lscalacss_internal_DslBase$ToStyle(x$101);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x473 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1420 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1421 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1420.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x472 = $n($n($$x473).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1421), new $c_sjsr_AnonFunction1(((x$2$20) => {
    var x$102 = $as_Lscalacss_internal_Media$Query(x$2$20);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$102)
  }))));
  var f$167 = new $c_sjsr_AnonFunction1(((x$2$2$2$15) => {
    var x$2$2$19 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$15);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$19).dark__Lscalacss_internal_AV()))
  }));
  var x$103 = $n($$x472).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$50, f$167)), c);
  var array$110 = [$$x474, new $c_Lscalacss_internal_DslBase$ToStyle(x$103)];
  var t$52 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$110);
  var x$104 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$52, c);
  var $$x471 = new $c_Lscalacss_internal_DslBase$ToStyle(x$104);
  var $$x470 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x469 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x468 = new $c_sjsr_AnonFunction1(((x$10$3$2) => {
    var x$10$3 = $as_T(x$10$3$2);
    return (x$10$3 + ">svg")
  }));
  var $$x467 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1429 = $m_Lscalacss_internal_Attrs$display$();
  var $$x466 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x467).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1429.Lscalacss_internal_Attrs$display$__f_attr, "inline")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$169 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var this$1432 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$169);
  var colors$13 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$13 = $m_Lcom_iz2use_react_style_OpacityLevel$low$();
  var array$111 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6(this$1432, colors$13, opacity$13)];
  var t$53 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$111);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$168 = new $c_sjsr_AnonFunction1(((x$1$2$83) => {
    var x$1$85 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$83);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$85).light__Lscalacss_internal_AV()))
  }));
  var t$54 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$53, f$168));
  var x$105 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$54, c);
  var $$x465 = new $c_Lscalacss_internal_DslBase$ToStyle(x$105);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x464 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1440 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1441 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1440.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x463 = $n($n($$x464).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1441), new $c_sjsr_AnonFunction1(((x$2$21) => {
    var x$106 = $as_Lscalacss_internal_Media$Query(x$2$21);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$106)
  }))));
  var f$169 = new $c_sjsr_AnonFunction1(((x$2$2$2$16) => {
    var x$2$2$20 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$16);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$20).dark__Lscalacss_internal_AV()))
  }));
  var x$107 = $n($$x463).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$53, f$169)), c);
  var array$112 = [$$x465, new $c_Lscalacss_internal_DslBase$ToStyle(x$107)];
  var t$55 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$112);
  var x$108 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$55, c);
  var array$113 = [$$x466, new $c_Lscalacss_internal_DslBase$ToStyle(x$108)];
  var $$x462 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x470).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x469).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x468, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$113), c)));
  var $$x461 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1460 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$61 = 0.1;
  var u$42 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$171 = new $c_Lscalacss_internal_Length(this$$61, u$42);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$64 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$43) => {
    var x$3$44 = $as_Lscalacss_internal_Length(x$3$2$43);
    return $n(x$3$44).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$170 = new $c_sjsr_AnonFunction1(((x$1$2$84) => {
    var x$1$86 = $as_Lscalacss_internal_ValueT(x$1$2$84);
    return $n(x$1$86)
  }));
  var bc$64 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$170);
  var r$72 = $n(ab$64).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$64);
  var all = $n(r$72).apply__O__Lscalacss_internal_ValueT(f$171);
  var v$170 = $n(all).Lscalacss_internal_ValueT__f_value;
  var $$x460 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x461).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1460.Lscalacss_internal_Attrs$padding$__f_attr, v$170)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x459 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$1461 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p$1 = $m_Lscalacss_internal_Pseudo$Hover$();
  var $$x458 = this$1461.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p$1);
  var this$1463 = $m_s_$less$colon$less$();
  var $$x457 = $n($n($$x459).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x458, this$1463.s_$less$colon$less$__f_singleton));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$109 = this.Lcom_iz2use_react_style_Style__f_commonSelectorItemFocused;
  var $$x456 = new $c_Lscalacss_internal_DslBase$ToStyle(x$109);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$171 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var qual$8 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$171);
  var x$17$3 = $n(theme).Lcom_iz2use_react_style_Theme__f_focused;
  var x$18$3 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$114 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$8, x$17$3, x$18$3)];
  var t$56 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$114);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$172 = new $c_sjsr_AnonFunction1(((x$1$2$85) => {
    var x$1$87 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$85);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$87).light__Lscalacss_internal_AV()))
  }));
  var t$57 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$56, f$172));
  var x$110 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$57, c);
  var $$x455 = new $c_Lscalacss_internal_DslBase$ToStyle(x$110);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x454 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1473 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1474 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1473.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x453 = $n($n($$x454).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1474), new $c_sjsr_AnonFunction1(((x$2$22) => {
    var x$111 = $as_Lscalacss_internal_Media$Query(x$2$22);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$111)
  }))));
  var f$173 = new $c_sjsr_AnonFunction1(((x$2$2$2$17) => {
    var x$2$2$21 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$17);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$21).dark__Lscalacss_internal_AV()))
  }));
  var x$112 = $n($$x453).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$56, f$173)), c);
  var array$115 = [$$x455, new $c_Lscalacss_internal_DslBase$ToStyle(x$112)];
  var t$58 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$115);
  var x$113 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$58, c);
  var array$116 = [$$x456, new $c_Lscalacss_internal_DslBase$ToStyle(x$113)];
  var x$114 = $n($$x457).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$116), c);
  var array$117 = [$$x476, $$x475, $$x471, $$x462, $$x460, new $c_Lscalacss_internal_DslBase$ToStyle(x$114)];
  var t$59 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$117);
  this.Lcom_iz2use_react_style_Style__f_commonSelectorItem = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$59, c);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$115 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x504 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$115).Lscalacss_internal_StyleA__f_style);
  var $$x503 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1491 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x502 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x503).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1491.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x501 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1493 = $m_Lscalacss_internal_Attrs$margin$();
  var $$x500 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x501).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1493.Lscalacss_internal_Attrs$margin$__f_attr, "0")));
  var $$x499 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x498 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$62 = 0;
  var u$43 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$175 = new $c_Lscalacss_internal_Length(this$$62, u$43);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$65 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$44) => {
    var x$3$45 = $as_Lscalacss_internal_Length(x$3$2$44);
    return $n(x$3$45).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$174 = new $c_sjsr_AnonFunction1(((x$1$2$86) => {
    var x$1$88 = $as_Lscalacss_internal_ValueT(x$1$2$86);
    return $n(x$1$88)
  }));
  var bc$65 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$174);
  var r$73 = $n(ab$65).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$65);
  var $$x497 = $n(r$73).apply__O__Lscalacss_internal_ValueT(f$175);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$63 = 0.25;
  var u$44 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$177 = new $c_Lscalacss_internal_Length(this$$63, u$44);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$66 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$45) => {
    var x$3$46 = $as_Lscalacss_internal_Length(x$3$2$45);
    return $n(x$3$46).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$176 = new $c_sjsr_AnonFunction1(((x$1$2$87) => {
    var x$1$89 = $as_Lscalacss_internal_ValueT(x$1$2$87);
    return $n(x$1$89)
  }));
  var bc$66 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$176);
  var r$74 = $n(ab$66).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$66);
  var $$x496 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x499).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x498.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x497, $n(r$74).apply__O__Lscalacss_internal_ValueT(f$177))));
  var this$1521 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$64 = 0.3;
  var u$45 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$179 = new $c_Lscalacss_internal_Length(this$$64, u$45);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$67 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$46) => {
    var x$3$47 = $as_Lscalacss_internal_Length(x$3$2$46);
    return $n(x$3$47).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$178 = new $c_sjsr_AnonFunction1(((x$1$2$88) => {
    var x$1$90 = $as_Lscalacss_internal_ValueT(x$1$2$88);
    return $n(x$1$90)
  }));
  var bc$67 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$178);
  var r$75 = $n(ab$67).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$67);
  var radius$2 = $n(r$75).apply__O__Lscalacss_internal_ValueT(f$179);
  var v$172 = $n(radius$2).Lscalacss_internal_ValueT__f_value;
  var x$116 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$172);
  var $$x495 = new $c_Lscalacss_internal_DslBase$ToStyle(this$1521.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$116.av__Lscalacss_internal_AV()));
  var $$x494 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1523 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x493 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x494).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1523.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "transparent")));
  var $$x492 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$19 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("list-style-type");
  var $$x491 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x492).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$19, "none")));
  var $$x490 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1529 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x489 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x490).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1529.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
  var $$x488 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x487 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x486 = new $c_sjsr_AnonFunction1(((x$11$3$2) => {
    var x$11$3 = $as_T(x$11$3$2);
    return (x$11$3 + ">li")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$117 = this.Lcom_iz2use_react_style_Style__f_commonSelectorItem;
  var array$118 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$117)];
  var $$x485 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x488).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x487).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x486, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$118), c)));
  var $$x484 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x483 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x482 = new $c_sjsr_AnonFunction1(((x$12$3$2) => {
    var x$12$3 = $as_T(x$12$3$2);
    return (x$12$3 + ">li.active")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$118 = this.Lcom_iz2use_react_style_Style__f_commonSelectorItemActive;
  var array$119 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$118)];
  var $$x481 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x484).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x483).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x482, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$119), c)));
  var $$x480 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x479 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x478 = new $c_sjsr_AnonFunction1(((x$13$4$2) => {
    var x$13$4 = $as_T(x$13$4$2);
    return (x$13$4 + ">li.focused")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$119 = this.Lcom_iz2use_react_style_Style__f_commonSelectorItemFocused;
  var array$120 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$119)];
  var array$121 = [$$x504, $$x502, $$x500, $$x496, $$x495, $$x493, $$x491, $$x489, $$x485, $$x481, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x480).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x479).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x478, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$120), c)))];
  var t$60 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$121);
  this.Lcom_iz2use_react_style_Style__f_commonSelector = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$60, c);
  var $$x505 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "selector");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$120 = this.Lcom_iz2use_react_style_Style__f_commonSelector;
  var array$122 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$120)];
  this.Lcom_iz2use_react_style_Style__f_selector = $n($$x505).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$122), c);
  var $$x513 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "reorderableSelector");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$121 = this.Lcom_iz2use_react_style_Style__f_commonSelector;
  var $$x512 = new $c_Lscalacss_internal_DslBase$ToStyle(x$121);
  var $$x511 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x510 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x509 = new $c_sjsr_AnonFunction1(((x$14$4$2) => {
    var x$14$4 = $as_T(x$14$4$2);
    return (x$14$4 + ">li.active")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$173 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$1552 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$173);
  var colors$14 = $n(theme).Lcom_iz2use_react_style_Theme__f_highlight;
  var opacity$14 = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var array$123 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1552, colors$14, opacity$14)];
  var t$61 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$123);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$180 = new $c_sjsr_AnonFunction1(((x$1$2$89) => {
    var x$1$91 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$89);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$91).light__Lscalacss_internal_AV()))
  }));
  var t$62 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$61, f$180));
  var x$122 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$62, c);
  var $$x508 = new $c_Lscalacss_internal_DslBase$ToStyle(x$122);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x507 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1560 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1561 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1560.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x506 = $n($n($$x507).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1561), new $c_sjsr_AnonFunction1(((x$2$23) => {
    var x$123 = $as_Lscalacss_internal_Media$Query(x$2$23);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$123)
  }))));
  var f$181 = new $c_sjsr_AnonFunction1(((x$2$2$2$18) => {
    var x$2$2$22 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$18);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$22).dark__Lscalacss_internal_AV()))
  }));
  var x$124 = $n($$x506).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$61, f$181)), c);
  var array$124 = [$$x508, new $c_Lscalacss_internal_DslBase$ToStyle(x$124)];
  var t$63 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$124);
  var x$125 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$63, c);
  var array$125 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$125)];
  var array$126 = [$$x512, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x511).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x510).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x509, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$125), c)))];
  this.Lcom_iz2use_react_style_Style__f_reorderableSelector = $n($$x513).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$126), c);
  var $$x524 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "icon");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$126 = $n(md).icon__Lscalacss_internal_StyleS();
  var $$x523 = new $c_Lscalacss_internal_DslBase$ToStyle(x$126);
  var $$x522 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1576 = $m_Lscalacss_internal_Attrs$position$();
  var $$x521 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x522).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1576.Lscalacss_internal_Attrs$position$__f_attr, "relative")));
  var $$x520 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1586 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$65 = 0.5;
  var u$46 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$183 = new $c_Lscalacss_internal_Length(this$$65, u$46);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$68 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$47) => {
    var x$3$48 = $as_Lscalacss_internal_Length(x$3$2$47);
    return $n(x$3$48).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$182 = new $c_sjsr_AnonFunction1(((x$1$2$90) => {
    var x$1$92 = $as_Lscalacss_internal_ValueT(x$1$2$90);
    return $n(x$1$92)
  }));
  var bc$68 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$182);
  var r$76 = $n(ab$68).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$68);
  var v$174 = $n(r$76).apply__O__Lscalacss_internal_ValueT(f$183);
  var v$175 = $n(v$174).Lscalacss_internal_ValueT__f_value;
  var $$x519 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x520).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1586.Lscalacss_internal_Attrs$top$__f_attr, v$175)));
  var $$x518 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1596 = $m_Lscalacss_internal_Attrs$marginBottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$66 = 0.5;
  var u$47 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$185 = new $c_Lscalacss_internal_Length(this$$66, u$47);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$69 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$48) => {
    var x$3$49 = $as_Lscalacss_internal_Length(x$3$2$48);
    return $n(x$3$49).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$184 = new $c_sjsr_AnonFunction1(((x$1$2$91) => {
    var x$1$93 = $as_Lscalacss_internal_ValueT(x$1$2$91);
    return $n(x$1$93)
  }));
  var bc$69 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$184);
  var r$77 = $n(ab$69).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$69);
  var v$176 = $n(r$77).apply__O__Lscalacss_internal_ValueT(f$185);
  var v$177 = $n(v$176).Lscalacss_internal_ValueT__f_value;
  var $$x517 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x518).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1596.Lscalacss_internal_Attrs$marginBottom$__f_attr, v$177)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$178 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var this$1599 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$178);
  var colors$15 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$15 = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var array$127 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6(this$1599, colors$15, opacity$15)];
  var t$64 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$127);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$186 = new $c_sjsr_AnonFunction1(((x$1$2$92) => {
    var x$1$94 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$92);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$94).light__Lscalacss_internal_AV()))
  }));
  var t$65 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$64, f$186));
  var x$127 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$65, c);
  var $$x516 = new $c_Lscalacss_internal_DslBase$ToStyle(x$127);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x515 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1607 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1608 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1607.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x514 = $n($n($$x515).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1608), new $c_sjsr_AnonFunction1(((x$2$24) => {
    var x$128 = $as_Lscalacss_internal_Media$Query(x$2$24);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$128)
  }))));
  var f$187 = new $c_sjsr_AnonFunction1(((x$2$2$2$19) => {
    var x$2$2$23 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$19);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$23).dark__Lscalacss_internal_AV()))
  }));
  var x$129 = $n($$x514).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$64, f$187)), c);
  var array$128 = [$$x516, new $c_Lscalacss_internal_DslBase$ToStyle(x$129)];
  var t$66 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$128);
  var x$130 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$66, c);
  var array$129 = [$$x523, $$x521, $$x519, $$x517, new $c_Lscalacss_internal_DslBase$ToStyle(x$130)];
  this.Lcom_iz2use_react_style_Style__f_icon = $n($$x524).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$129), c);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x527 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1619 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$179 = $m_Lscalacss_internal_Literal$Typed$inherit$();
  var v$180 = v$179.Lscalacss_internal_Literal__f_value;
  var $$x526 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x527).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1619.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$180)));
  var $$x525 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1622 = $m_Lscalacss_internal_Attrs$position$();
  var array$130 = [$$x526, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x525).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1622.Lscalacss_internal_Attrs$position$__f_attr, "sticky")))];
  var t$67 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$130);
  this.Lcom_iz2use_react_style_Style__f_stickyMixin = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$67, c);
  var $$x532 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "stickyLeft");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x531 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1628 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x530 = $n($n($$x531).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1628.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$27$2) => {
    var x$27$1 = $as_Lscalacss_internal_Media$Query(x$27$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$27$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$131 = this.Lcom_iz2use_react_style_Style__f_stickyMixin;
  var $$x529 = new $c_Lscalacss_internal_DslBase$ToStyle(x$131);
  var $$x528 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1639 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$67 = 0;
  var u$48 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$189 = new $c_Lscalacss_internal_Length(this$$67, u$48);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$70 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$49) => {
    var x$3$50 = $as_Lscalacss_internal_Length(x$3$2$49);
    return $n(x$3$50).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$188 = new $c_sjsr_AnonFunction1(((x$1$2$93) => {
    var x$1$95 = $as_Lscalacss_internal_ValueT(x$1$2$93);
    return $n(x$1$95)
  }));
  var bc$70 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$188);
  var r$78 = $n(ab$70).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$70);
  var v$181 = $n(r$78).apply__O__Lscalacss_internal_ValueT(f$189);
  var v$182 = $n(v$181).Lscalacss_internal_ValueT__f_value;
  var array$131 = [$$x529, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x528).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1639.Lscalacss_internal_Attrs$left$__f_attr, v$182)))];
  var x$132 = $n($$x530).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$131), c);
  var array$132 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$132)];
  this.Lcom_iz2use_react_style_Style__f_stickyLeft = $n($$x532).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$132), c);
  var $$x537 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "stickyTop");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x536 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1648 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x535 = $n($n($$x536).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1648.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$28$2) => {
    var x$28$1 = $as_Lscalacss_internal_Media$Query(x$28$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$28$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$133 = this.Lcom_iz2use_react_style_Style__f_stickyMixin;
  var $$x534 = new $c_Lscalacss_internal_DslBase$ToStyle(x$133);
  var $$x533 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1659 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$68 = 0;
  var u$49 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$191 = new $c_Lscalacss_internal_Length(this$$68, u$49);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$71 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$50) => {
    var x$3$51 = $as_Lscalacss_internal_Length(x$3$2$50);
    return $n(x$3$51).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$190 = new $c_sjsr_AnonFunction1(((x$1$2$94) => {
    var x$1$96 = $as_Lscalacss_internal_ValueT(x$1$2$94);
    return $n(x$1$96)
  }));
  var bc$71 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$190);
  var r$79 = $n(ab$71).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$71);
  var v$183 = $n(r$79).apply__O__Lscalacss_internal_ValueT(f$191);
  var v$184 = $n(v$183).Lscalacss_internal_ValueT__f_value;
  var array$133 = [$$x534, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x533).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1659.Lscalacss_internal_Attrs$top$__f_attr, v$184)))];
  var x$134 = $n($$x535).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$133), c);
  var array$134 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$134)];
  this.Lcom_iz2use_react_style_Style__f_stickyTop = $n($$x537).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$134), c);
  var $$x565 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "fixedHeadersTable");
  var $$x564 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x563 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x562 = new $c_sjsr_AnonFunction1(((s$3$2) => {
    var s$3 = $as_T(s$3$2);
    return (((((((((((((((s$3 + ", ") + s$3) + ">*, ") + s$3) + ">THEAD>TR, ") + s$3) + ">TBODY>TR, ") + s$3) + ">TFOOT>TR, ") + s$3) + ">THEAD>TR>*, ") + s$3) + ">TBODY>TR>*, ") + s$3) + ">TFOOT>TR>*")
  }));
  var $$x561 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1668 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$185 = $m_Lscalacss_internal_Literal$Typed$inherit$();
  var v$186 = v$185.Lscalacss_internal_Literal__f_value;
  var array$135 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x561).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1668.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$186)))];
  var $$x560 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x564).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x563).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x562, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$135), c)));
  var $$x559 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x558 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x557 = new $c_sjsr_AnonFunction1(((s$4$2) => {
    var s$4 = $as_T(s$4$2);
    return (((((s$4 + ">THEAD>TR>TH:first-child, ") + s$4) + ">TBODY>TR>TH:first-child, ") + s$4) + ">TFOOT>TR>TH:first-child")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x556 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1674 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x555 = $n($n($$x556).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1674.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$29$2) => {
    var x$29$1 = $as_Lscalacss_internal_Media$Query(x$29$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$29$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$135 = this.Lcom_iz2use_react_style_Style__f_stickyLeft;
  var $$x554 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$135).Lscalacss_internal_StyleA__f_style);
  var $$x553 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1680 = $m_Lscalacss_internal_Attrs$zIndex$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$80 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$5$2$4) => {
    var x$5$6 = $uI(x$5$2$4);
    return ("" + x$5$6)
  })));
  var v$187 = $n(r$80).apply__O__Lscalacss_internal_ValueT(2);
  var v$188 = $n(v$187).Lscalacss_internal_ValueT__f_value;
  var array$136 = [$$x554, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x553).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1680.Lscalacss_internal_Attrs$zIndex$__f_attr, v$188))), new $c_Lscalacss_internal_DslBase$ToStyle(($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $n(withBackground).Lscalacss_internal_StyleA__f_style))];
  var x$136 = $n($$x555).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$136), c);
  var array$137 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$136)];
  var $$x552 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x559).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x558).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x557, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$137), c)));
  var $$x551 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x550 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x549 = new $c_sjsr_AnonFunction1(((s$5$2) => {
    var s$5 = $as_T(s$5$2);
    return (s$5 + ">THEAD>TR:last-child>TH")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x548 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1690 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x547 = $n($n($$x548).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1690.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$30$2) => {
    var x$30$1 = $as_Lscalacss_internal_Media$Query(x$30$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$30$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$137 = this.Lcom_iz2use_react_style_Style__f_stickyTop;
  var $$x546 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$137).Lscalacss_internal_StyleA__f_style);
  var $$x545 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1696 = $m_Lscalacss_internal_Attrs$zIndex$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$81 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$5$2$5) => {
    var x$5$7 = $uI(x$5$2$5);
    return ("" + x$5$7)
  })));
  var v$189 = $n(r$81).apply__O__Lscalacss_internal_ValueT(4);
  var v$190 = $n(v$189).Lscalacss_internal_ValueT__f_value;
  var array$138 = [$$x546, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x545).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1696.Lscalacss_internal_Attrs$zIndex$__f_attr, v$190))), new $c_Lscalacss_internal_DslBase$ToStyle(($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $n(withBackground).Lscalacss_internal_StyleA__f_style))];
  var x$138 = $n($$x547).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$138), c);
  var array$139 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$138)];
  var $$x544 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x551).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x550).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x549, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$139), c)));
  var $$x543 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x542 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x541 = new $c_sjsr_AnonFunction1(((s$6$2) => {
    var s$6 = $as_T(s$6$2);
    return (s$6 + ">THEAD>TR:first-child>TH:first-child")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x540 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1706 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x539 = $n($n($$x540).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1706.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$31$2) => {
    var x$31$1 = $as_Lscalacss_internal_Media$Query(x$31$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$31$1)
  }))));
  var $$x538 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1711 = $m_Lscalacss_internal_Attrs$zIndex$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$82 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$5$2$6) => {
    var x$5$8 = $uI(x$5$2$6);
    return ("" + x$5$8)
  })));
  var v$191 = $n(r$82).apply__O__Lscalacss_internal_ValueT(6);
  var v$192 = $n(v$191).Lscalacss_internal_ValueT__f_value;
  var array$140 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x538).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1711.Lscalacss_internal_Attrs$zIndex$__f_attr, v$192))), new $c_Lscalacss_internal_DslBase$ToStyle(($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $n(withBackground).Lscalacss_internal_StyleA__f_style))];
  var x$139 = $n($$x539).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$140), c);
  var array$141 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$139)];
  var array$142 = [$$x560, $$x552, $$x544, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x543).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x542).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x541, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$141), c)))];
  this.Lcom_iz2use_react_style_Style__f_fixedHeadersTable = $n($$x565).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$142), c);
  var $$x569 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "multiviewSelected");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lcom_iz2use_react_style_package$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$193 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$1724 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$193);
  var colors$16 = $n(theme).Lcom_iz2use_react_style_Theme__f_highlight;
  var opacity$16 = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var v$194 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1724, colors$16, opacity$16);
  var this$1726 = new $c_Lcom_iz2use_react_style_package$RichToThemedStyle(v$194);
  var array$143 = [new $c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1(this$1726)];
  var t$68 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$143);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$192 = new $c_sjsr_AnonFunction1(((x$1$2$95) => {
    var x$1$97 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$95);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$97).light__Lscalacss_internal_AV()))
  }));
  var t$69 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$68, f$192));
  var x$140 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$69, c);
  var $$x568 = new $c_Lscalacss_internal_DslBase$ToStyle(x$140);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x567 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1734 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1735 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1734.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x566 = $n($n($$x567).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1735), new $c_sjsr_AnonFunction1(((x$2$25) => {
    var x$141 = $as_Lscalacss_internal_Media$Query(x$2$25);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$141)
  }))));
  var f$193 = new $c_sjsr_AnonFunction1(((x$2$2$2$20) => {
    var x$2$2$24 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$20);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$24).dark__Lscalacss_internal_AV()))
  }));
  var x$142 = $n($$x566).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$68, f$193)), c);
  var array$144 = [$$x568, new $c_Lscalacss_internal_DslBase$ToStyle(x$142)];
  var t$70 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$144);
  var x$143 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$70, c);
  var array$145 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$143)];
  this.Lcom_iz2use_react_style_Style__f_multiviewSelected = $n($$x569).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$145), c);
  var $$x573 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "multiviewFocused");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lcom_iz2use_react_style_package$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$195 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$1746 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$195);
  var colors$17 = $n(theme).Lcom_iz2use_react_style_Theme__f_focused;
  var opacity$17 = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var v$196 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$1746, colors$17, opacity$17);
  var this$1748 = new $c_Lcom_iz2use_react_style_package$RichToThemedStyle(v$196);
  var array$146 = [new $c_Lcom_iz2use_react_style_package$RichToThemedStyle$$anon$1(this$1748)];
  var t$71 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$146);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$194 = new $c_sjsr_AnonFunction1(((x$1$2$96) => {
    var x$1$98 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$96);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$98).light__Lscalacss_internal_AV()))
  }));
  var t$72 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$71, f$194));
  var x$144 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$72, c);
  var $$x572 = new $c_Lscalacss_internal_DslBase$ToStyle(x$144);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x571 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1756 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1757 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1756.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x570 = $n($n($$x571).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1757), new $c_sjsr_AnonFunction1(((x$2$26) => {
    var x$145 = $as_Lscalacss_internal_Media$Query(x$2$26);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$145)
  }))));
  var f$195 = new $c_sjsr_AnonFunction1(((x$2$2$2$21) => {
    var x$2$2$25 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$21);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$25).dark__Lscalacss_internal_AV()))
  }));
  var x$146 = $n($$x570).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$71, f$195)), c);
  var array$147 = [$$x572, new $c_Lscalacss_internal_DslBase$ToStyle(x$146)];
  var t$73 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$147);
  var x$147 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$73, c);
  var array$148 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$147)];
  this.Lcom_iz2use_react_style_Style__f_multiviewFocused = $n($$x573).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$148), c);
  var $$x583 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "tabularView");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$148 = this.Lcom_iz2use_react_style_Style__f_fixedHeadersTable;
  var $$x582 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$148).Lscalacss_internal_StyleA__f_style);
  var $$x581 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1769 = $m_Lscalacss_internal_Attrs$borderCollapse$();
  var $$x580 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x581).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1769.Lscalacss_internal_Attrs$borderCollapse$__f_attr, "collapse")));
  var $$x579 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x578 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x577 = new $c_sjsr_AnonFunction1(((c$2$2) => {
    var c$2 = $as_T(c$2$2);
    return (((((((c$2 + ", ") + c$2) + ">*>TR, ") + c$2) + ">*>TR>TH, ") + c$2) + ">*>TR>TD")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$197 = ($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $m_Lscalacss_internal_Attrs$border$()).Lscalacss_internal_Attrs$border$__f_attr;
  var this$1773 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$197);
  var colors$18 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$18 = $m_Lcom_iz2use_react_style_OpacityLevel$low$();
  var f$196 = new $c_sjsr_AnonFunction1(((color$4$2) => {
    var color$4 = $as_Lscalacss_internal_ValueT(color$4$2);
    return new $c_sjsr_AnonFunction1(((x$15$2$1) => {
      var x$15$4 = $as_Lscalacss_internal_Attr(x$15$2$1);
      $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value$2 = ("1px solid " + $n(color$4).Lscalacss_internal_ValueT__f_value);
      return new $c_Lscalacss_internal_AV(x$15$4, value$2)
    }))
  }));
  var array$149 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(this$1773, f$196, colors$18, opacity$18)];
  var t$74 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$149);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$197 = new $c_sjsr_AnonFunction1(((x$1$2$97) => {
    var x$1$99 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$97);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$99).light__Lscalacss_internal_AV()))
  }));
  var t$75 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$74, f$197));
  var x$149 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$75, c);
  var $$x576 = new $c_Lscalacss_internal_DslBase$ToStyle(x$149);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x575 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1781 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1782 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1781.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x574 = $n($n($$x575).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1782), new $c_sjsr_AnonFunction1(((x$2$27) => {
    var x$150 = $as_Lscalacss_internal_Media$Query(x$2$27);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$150)
  }))));
  var f$198 = new $c_sjsr_AnonFunction1(((x$2$2$2$22) => {
    var x$2$2$26 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$22);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$26).dark__Lscalacss_internal_AV()))
  }));
  var x$151 = $n($$x574).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$74, f$198)), c);
  var array$150 = [$$x576, new $c_Lscalacss_internal_DslBase$ToStyle(x$151)];
  var t$76 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$150);
  var x$152 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$76, c);
  var array$151 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$152)];
  var array$152 = [$$x582, $$x580, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x579).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x578).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x577, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$151), c)))];
  this.Lcom_iz2use_react_style_Style__f_tabularView = $n($$x583).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$152), c);
  var $$x587 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "multiviewContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$153 = this.Lcom_iz2use_react_style_Style__f_flex1;
  var $$x586 = new $c_Lscalacss_internal_DslBase$ToStyle(x$153);
  var $$x585 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1797 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$198 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$199 = v$198.Lscalacss_internal_Literal__f_value;
  var $$x584 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x585).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1797.Lscalacss_internal_Attrs$overflow$__f_attr, v$199)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$154 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var array$153 = [$$x586, $$x584, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$154).Lscalacss_internal_StyleA__f_style)];
  this.Lcom_iz2use_react_style_Style__f_multiviewContainer = $n($$x587).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$153), c);
  var $$x595 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "multiviewSettings");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$155 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x594 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$155).Lscalacss_internal_StyleA__f_style);
  var $$x593 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1804 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x592 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x593).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1804.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
  var $$x591 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1806 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x590 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x591).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1806.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x589 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1808 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var $$x588 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x589).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1808.Lscalacss_internal_Attrs$justifyContent$__f_attr, "flex-end")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$156 = this.Lcom_iz2use_react_style_Style__f_notPrintable;
  var array$154 = [$$x594, $$x592, $$x590, $$x588, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$156).Lscalacss_internal_StyleA__f_style)];
  this.Lcom_iz2use_react_style_Style__f_multiviewSettings = $n($$x595).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$154), c);
  var $$x601 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "multiviewSettingsHidden");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$157 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x600 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$157).Lscalacss_internal_StyleA__f_style);
  var $$x599 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1815 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x598 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x599).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1815.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$158 = this.Lcom_iz2use_react_style_Style__f_notPrintable;
  var $$x597 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$158).Lscalacss_internal_StyleA__f_style);
  var $$x596 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1818 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var array$155 = [$$x600, $$x598, $$x597, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x596).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1818.Lscalacss_internal_Attrs$justifyContent$__f_attr, "flex-end")))];
  $n($$x601).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$155), c);
  var $$x605 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "multiviewSearch");
  var $$x604 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$20 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x603 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x604).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$20, "2 2 25%")));
  var $$x602 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1833 = $m_Lscalacss_internal_Attrs$minWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$69 = 50;
  var f$200 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$69);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$72 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$20) => {
    var x$4$22 = $as_Lscalacss_internal_Percentage(x$4$2$20);
    return $n(x$4$22).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$199 = new $c_sjsr_AnonFunction1(((x$1$2$98) => {
    var x$1$100 = $as_Lscalacss_internal_ValueT(x$1$2$98);
    return $n(x$1$100)
  }));
  var bc$72 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$199);
  var r$83 = $n(ab$72).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$72);
  var v$200 = $n(r$83).apply__O__Lscalacss_internal_ValueT(f$200);
  var v$201 = $n(v$200).Lscalacss_internal_ValueT__f_value;
  var array$156 = [$$x603, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x602).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1833.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$201)))];
  this.Lcom_iz2use_react_style_Style__f_multiviewSearch = $n($$x605).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$156), c);
  var $$x610 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "multiviewRender");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$159 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x609 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$159).Lscalacss_internal_StyleA__f_style);
  var $$x608 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1839 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x607 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x608).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1839.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x606 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1841 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var array$157 = [$$x609, $$x607, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x606).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1841.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")))];
  this.Lcom_iz2use_react_style_Style__f_multiviewRender = $n($$x610).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$157), c);
  var $$x613 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "selectorLabelContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$160 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x612 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$160).Lscalacss_internal_StyleA__f_style);
  var $$x611 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1847 = $m_Lscalacss_internal_Attrs$alignItems$();
  var array$158 = [$$x612, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x611).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1847.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")))];
  this.Lcom_iz2use_react_style_Style__f_selectorLabelContainer = $n($$x613).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$158), c);
  var $$x628 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "linkedViewContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$161 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x627 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$161).Lscalacss_internal_StyleA__f_style);
  var $$x626 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1860 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$70 = 100;
  var f$202 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$70);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$73 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$21) => {
    var x$4$23 = $as_Lscalacss_internal_Percentage(x$4$2$21);
    return $n(x$4$23).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$201 = new $c_sjsr_AnonFunction1(((x$1$2$99) => {
    var x$1$101 = $as_Lscalacss_internal_ValueT(x$1$2$99);
    return $n(x$1$101)
  }));
  var bc$73 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$201);
  var r$84 = $n(ab$73).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$73);
  var v$202 = $n(r$84).apply__O__Lscalacss_internal_ValueT(f$202);
  var v$203 = $n(v$202).Lscalacss_internal_ValueT__f_value;
  var $$x625 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x626).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1860.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$203)));
  var $$x624 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1862 = $m_Lscalacss_internal_Attrs$width$();
  var v$204 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$205 = v$204.Lscalacss_internal_Literal__f_value;
  var $$x623 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x624).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1862.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$205)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x622 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1864 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x621 = $n($n($$x622).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1864.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$32$2) => {
    var x$32$1 = $as_Lscalacss_internal_Media$Query(x$32$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$32$1)
  }))));
  var $$x620 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1873 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$71 = 100;
  var f$204 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$71);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$74 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$22) => {
    var x$4$24 = $as_Lscalacss_internal_Percentage(x$4$2$22);
    return $n(x$4$24).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$203 = new $c_sjsr_AnonFunction1(((x$1$2$100) => {
    var x$1$102 = $as_Lscalacss_internal_ValueT(x$1$2$100);
    return $n(x$1$102)
  }));
  var bc$74 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$203);
  var r$85 = $n(ab$74).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$74);
  var v$206 = $n(r$85).apply__O__Lscalacss_internal_ValueT(f$204);
  var v$207 = $n(v$206).Lscalacss_internal_ValueT__f_value;
  var $$x619 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x620).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1873.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$207)));
  var $$x618 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1875 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$208 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$209 = v$208.Lscalacss_internal_Literal__f_value;
  var array$159 = [$$x619, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x618).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1875.Lscalacss_internal_Attrs$overflow$__f_attr, v$209)))];
  var x$162 = $n($$x621).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$159), c);
  var $$x617 = new $c_Lscalacss_internal_DslBase$ToStyle(x$162);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x616 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1881 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1885 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1881.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$72 = 1200;
  var u$50 = $m_Lscalacss_internal_LengthUnit$px$();
  var v$210 = new $c_Lscalacss_internal_Length(this$$72, u$50);
  var $$x615 = $n($n($$x616).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__maxWidth__Lscalacss_internal_Length__O(this$1885, v$210), new $c_sjsr_AnonFunction1(((x$33$2) => {
    var x$33$1 = $as_Lscalacss_internal_Media$Query(x$33$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$33$1)
  }))));
  var $$x614 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1887 = $m_Lscalacss_internal_Attrs$width$();
  var v$211 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$212 = v$211.Lscalacss_internal_Literal__f_value;
  var array$160 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x614).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1887.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$212)))];
  var x$163 = $n($$x615).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$160), c);
  var array$161 = [$$x627, $$x625, $$x623, $$x617, new $c_Lscalacss_internal_DslBase$ToStyle(x$163)];
  this.Lcom_iz2use_react_style_Style__f_linkedViewContainer = $n($$x628).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$161), c);
  var $$x637 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "linkedView");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$164 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x636 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$164).Lscalacss_internal_StyleA__f_style);
  var $$x635 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$21 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x634 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x635).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$21, "1")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x633 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1900 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x632 = $n($n($$x633).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1900.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$34$2) => {
    var x$34$1 = $as_Lscalacss_internal_Media$Query(x$34$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$34$1)
  }))));
  var $$x631 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1909 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$73 = 100;
  var f$206 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$73);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$75 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$23) => {
    var x$4$25 = $as_Lscalacss_internal_Percentage(x$4$2$23);
    return $n(x$4$25).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$205 = new $c_sjsr_AnonFunction1(((x$1$2$101) => {
    var x$1$103 = $as_Lscalacss_internal_ValueT(x$1$2$101);
    return $n(x$1$103)
  }));
  var bc$75 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$205);
  var r$86 = $n(ab$75).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$75);
  var v$213 = $n(r$86).apply__O__Lscalacss_internal_ValueT(f$206);
  var v$214 = $n(v$213).Lscalacss_internal_ValueT__f_value;
  var $$x630 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x631).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1909.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$214)));
  var $$x629 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1911 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$215 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$216 = v$215.Lscalacss_internal_Literal__f_value;
  var array$162 = [$$x630, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x629).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1911.Lscalacss_internal_Attrs$overflow$__f_attr, v$216)))];
  var x$165 = $n($$x632).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$162), c);
  var array$163 = [$$x636, $$x634, new $c_Lscalacss_internal_DslBase$ToStyle(x$165)];
  this.Lcom_iz2use_react_style_Style__f_linkedView = $n($$x637).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$163), c);
  var $$x645 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "linkedViewReducer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$217 = ($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $m_Lscalacss_internal_Attrs$borderRight$()).Lscalacss_internal_Attrs$borderRight$__f_attr;
  var this$1922 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$217);
  var colors$19 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$19 = $m_Lcom_iz2use_react_style_OpacityLevel$low$();
  var f$207 = new $c_sjsr_AnonFunction1(((color$5$2) => {
    var color$5 = $as_Lscalacss_internal_ValueT(color$5$2);
    return new $c_sjsr_AnonFunction1(((x$16$2$1) => {
      var x$16$4 = $as_Lscalacss_internal_Attr(x$16$2$1);
      $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value$3 = ("0.5em solid " + $n(color$5).Lscalacss_internal_ValueT__f_value);
      return new $c_Lscalacss_internal_AV(x$16$4, value$3)
    }))
  }));
  var array$164 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(this$1922, f$207, colors$19, opacity$19)];
  var t$77 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$164);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$208 = new $c_sjsr_AnonFunction1(((x$1$2$102) => {
    var x$1$104 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$102);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$104).light__Lscalacss_internal_AV()))
  }));
  var t$78 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$77, f$208));
  var x$166 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$78, c);
  var $$x644 = new $c_Lscalacss_internal_DslBase$ToStyle(x$166);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x643 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1930 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1931 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1930.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x642 = $n($n($$x643).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$1931), new $c_sjsr_AnonFunction1(((x$2$28) => {
    var x$167 = $as_Lscalacss_internal_Media$Query(x$2$28);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$167)
  }))));
  var f$209 = new $c_sjsr_AnonFunction1(((x$2$2$2$23) => {
    var x$2$2$27 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$23);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$27).dark__Lscalacss_internal_AV()))
  }));
  var x$168 = $n($$x642).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$77, f$209)), c);
  var array$165 = [$$x644, new $c_Lscalacss_internal_DslBase$ToStyle(x$168)];
  var t$79 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$165);
  var x$169 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$79, c);
  var $$x641 = new $c_Lscalacss_internal_DslBase$ToStyle(x$169);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x640 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1939 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x639 = $n($n($$x640).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1939.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$35$2) => {
    var x$35$1 = $as_Lscalacss_internal_Media$Query(x$35$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$35$1)
  }))));
  var $$x638 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1941 = $m_Lscalacss_internal_Attrs$cursor$();
  var array$166 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x638).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1941.Lscalacss_internal_Attrs$cursor$__f_attr, "pointer")))];
  var x$170 = $n($$x639).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$166), c);
  var array$167 = [$$x641, new $c_Lscalacss_internal_DslBase$ToStyle(x$170)];
  this.Lcom_iz2use_react_style_Style__f_linkedViewReducer = $n($$x645).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$167), c);
  var $$x649 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "linkedViewReducedSize");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x648 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1950 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x647 = $n($n($$x648).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1950.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$36$2) => {
    var x$36$1 = $as_Lscalacss_internal_Media$Query(x$36$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$36$1)
  }))));
  var $$x646 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1960 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$74 = 12;
  var u$51 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$211 = new $c_Lscalacss_internal_Length(this$$74, u$51);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$76 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$51) => {
    var x$3$52 = $as_Lscalacss_internal_Length(x$3$2$51);
    return $n(x$3$52).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$210 = new $c_sjsr_AnonFunction1(((x$1$2$103) => {
    var x$1$105 = $as_Lscalacss_internal_ValueT(x$1$2$103);
    return $n(x$1$105)
  }));
  var bc$76 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$210);
  var r$87 = $n(ab$76).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$76);
  var v$218 = $n(r$87).apply__O__Lscalacss_internal_ValueT(f$211);
  var v$219 = $n(v$218).Lscalacss_internal_ValueT__f_value;
  var array$168 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x646).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1960.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$219)))];
  var x$171 = $n($$x647).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$168), c);
  var array$169 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$171)];
  this.Lcom_iz2use_react_style_Style__f_linkedViewReducedSize = $n($$x649).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$169), c);
  var $$x659 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "linkedViewReducedContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x658 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1969 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x657 = $n($n($$x658).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1969.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$37$2) => {
    var x$37$1 = $as_Lscalacss_internal_Media$Query(x$37$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$37$1)
  }))));
  var $$x656 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1971 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$220 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$221 = v$220.Lscalacss_internal_Literal__f_value;
  var array$170 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x656).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1971.Lscalacss_internal_Attrs$overflow$__f_attr, v$221)))];
  var x$172 = $n($$x657).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$170), c);
  var $$x655 = new $c_Lscalacss_internal_DslBase$ToStyle(x$172);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x654 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1977 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$1981 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$1977.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$75 = 1200;
  var u$52 = $m_Lscalacss_internal_LengthUnit$px$();
  var v$222 = new $c_Lscalacss_internal_Length(this$$75, u$52);
  var $$x653 = $n($as_Lscalacss_internal_Media$Query($f_Lscalacss_internal_Media$FeatureOps__maxWidth__Lscalacss_internal_Length__O(this$1981, v$222)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1983 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x652 = $n($$x653).$amp__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond($as_Lscalacss_internal_Media$Query($n(this$1983.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$())));
  var this$1985 = $m_s_$less$colon$less$();
  var $$x651 = $n($n($$x654).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x652, this$1985.s_$less$colon$less$__f_singleton));
  var $$x650 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1987 = $m_Lscalacss_internal_Attrs$display$();
  var v$223 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$224 = v$223.Lscalacss_internal_Literal__f_value;
  var array$171 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x650).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1987.Lscalacss_internal_Attrs$display$__f_attr, v$224)))];
  var x$173 = $n($$x651).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$171), c);
  var array$172 = [$$x655, new $c_Lscalacss_internal_DslBase$ToStyle(x$173)];
  this.Lcom_iz2use_react_style_Style__f_linkedViewReducedContainer = $n($$x659).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$172), c);
  var $$x667 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "linkedViewClose");
  var $$x666 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2004 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$76 = 1;
  var u$53 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$213 = new $c_Lscalacss_internal_Length(this$$76, u$53);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$77 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$52) => {
    var x$3$53 = $as_Lscalacss_internal_Length(x$3$2$52);
    return $n(x$3$53).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$212 = new $c_sjsr_AnonFunction1(((x$1$2$104) => {
    var x$1$106 = $as_Lscalacss_internal_ValueT(x$1$2$104);
    return $n(x$1$106)
  }));
  var bc$77 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$212);
  var r$88 = $n(ab$77).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$77);
  var all$1 = $n(r$88).apply__O__Lscalacss_internal_ValueT(f$213);
  var v$225 = $n(all$1).Lscalacss_internal_ValueT__f_value;
  var $$x665 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x666).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2004.Lscalacss_internal_Attrs$padding$__f_attr, v$225)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x664 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2006 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x663 = $n($n($$x664).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2006.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$38$2) => {
    var x$38$1 = $as_Lscalacss_internal_Media$Query(x$38$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$38$1)
  }))));
  var $$x662 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2008 = $m_Lscalacss_internal_Attrs$display$();
  var v$226 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$227 = v$226.Lscalacss_internal_Literal__f_value;
  var array$173 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x662).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2008.Lscalacss_internal_Attrs$display$__f_attr, v$227)))];
  var x$174 = $n($$x663).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$173), c);
  var $$x661 = new $c_Lscalacss_internal_DslBase$ToStyle(x$174);
  var $$x660 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2014 = $m_Lscalacss_internal_Attrs$cursor$();
  var array$174 = [$$x665, $$x661, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x660).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2014.Lscalacss_internal_Attrs$cursor$__f_attr, "pointer")))];
  this.Lcom_iz2use_react_style_Style__f_linkedViewClose = $n($$x667).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$174), c);
  var $$x671 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "linkedViewCloseIcon");
  var $$x670 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2027 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$77 = 2.5;
  var u$54 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$215 = new $c_Lscalacss_internal_Length(this$$77, u$54);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$78 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$53) => {
    var x$3$54 = $as_Lscalacss_internal_Length(x$3$2$53);
    return $n(x$3$54).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$214 = new $c_sjsr_AnonFunction1(((x$1$2$105) => {
    var x$1$107 = $as_Lscalacss_internal_ValueT(x$1$2$105);
    return $n(x$1$107)
  }));
  var bc$78 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$214);
  var r$89 = $n(ab$78).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$78);
  var v$228 = $n(r$89).apply__O__Lscalacss_internal_ValueT(f$215);
  var v$229 = $n(v$228).Lscalacss_internal_ValueT__f_value;
  var $$x669 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x670).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2027.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$229)));
  var $$x668 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2037 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$78 = 2.5;
  var u$55 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$217 = new $c_Lscalacss_internal_Length(this$$78, u$55);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$79 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$54) => {
    var x$3$55 = $as_Lscalacss_internal_Length(x$3$2$54);
    return $n(x$3$55).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$216 = new $c_sjsr_AnonFunction1(((x$1$2$106) => {
    var x$1$108 = $as_Lscalacss_internal_ValueT(x$1$2$106);
    return $n(x$1$108)
  }));
  var bc$79 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$216);
  var r$90 = $n(ab$79).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$79);
  var v$230 = $n(r$90).apply__O__Lscalacss_internal_ValueT(f$217);
  var v$231 = $n(v$230).Lscalacss_internal_ValueT__f_value;
  var array$175 = [$$x669, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x668).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2037.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$231)))];
  this.Lcom_iz2use_react_style_Style__f_linkedViewCloseIcon = $n($$x671).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$175), c);
  var $$x686 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "linkedViewContent");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x685 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2042 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x684 = $n($n($$x685).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2042.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$39$2) => {
    var x$39$1 = $as_Lscalacss_internal_Media$Query(x$39$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$39$1)
  }))));
  var $$x683 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$22 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x682 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x683).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$22, "1")));
  var $$x681 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2054 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$79 = 100;
  var f$219 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$79);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$80 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$24) => {
    var x$4$26 = $as_Lscalacss_internal_Percentage(x$4$2$24);
    return $n(x$4$26).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$218 = new $c_sjsr_AnonFunction1(((x$1$2$107) => {
    var x$1$109 = $as_Lscalacss_internal_ValueT(x$1$2$107);
    return $n(x$1$109)
  }));
  var bc$80 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$218);
  var r$91 = $n(ab$80).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$80);
  var v$232 = $n(r$91).apply__O__Lscalacss_internal_ValueT(f$219);
  var v$233 = $n(v$232).Lscalacss_internal_ValueT__f_value;
  var $$x680 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x681).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2054.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$233)));
  var $$x679 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2056 = $m_Lscalacss_internal_Attrs$overflowY$();
  var v$234 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$235 = v$234.Lscalacss_internal_Literal__f_value;
  var $$x678 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x679).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2056.Lscalacss_internal_Attrs$overflowY$__f_attr, v$235)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$175 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var array$176 = [$$x682, $$x680, $$x678, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$175).Lscalacss_internal_StyleA__f_style)];
  var x$176 = $n($$x684).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$176), c);
  var $$x677 = new $c_Lscalacss_internal_DslBase$ToStyle(x$176);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x676 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2063 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x675 = $n($n($$x676).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2063.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$40$2) => {
    var x$40$1 = $as_Lscalacss_internal_Media$Query(x$40$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$40$1)
  }))));
  var $$x674 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2065 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$236 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$237 = v$236.Lscalacss_internal_Literal__f_value;
  var $$x673 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x674).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2065.Lscalacss_internal_Attrs$overflowX$__f_attr, v$237)));
  var $$x672 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2074 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$80 = 100;
  var f$221 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$80);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$81 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$25) => {
    var x$4$27 = $as_Lscalacss_internal_Percentage(x$4$2$25);
    return $n(x$4$27).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$220 = new $c_sjsr_AnonFunction1(((x$1$2$108) => {
    var x$1$110 = $as_Lscalacss_internal_ValueT(x$1$2$108);
    return $n(x$1$110)
  }));
  var bc$81 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$220);
  var r$92 = $n(ab$81).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$81);
  var v$238 = $n(r$92).apply__O__Lscalacss_internal_ValueT(f$221);
  var v$239 = $n(v$238).Lscalacss_internal_ValueT__f_value;
  var array$177 = [$$x673, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x672).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2074.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$239)))];
  var x$177 = $n($$x675).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$177), c);
  var array$178 = [$$x677, new $c_Lscalacss_internal_DslBase$ToStyle(x$177)];
  this.Lcom_iz2use_react_style_Style__f_linkedViewContent = $n($$x686).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$178), c);
  var $$x701 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "linkedViewActiveContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x700 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2083 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2087 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2083.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$81 = 1200;
  var u$56 = $m_Lscalacss_internal_LengthUnit$px$();
  var v$240 = new $c_Lscalacss_internal_Length(this$$81, u$56);
  var $$x699 = $n($n($$x700).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__maxWidth__Lscalacss_internal_Length__O(this$2087, v$240), new $c_sjsr_AnonFunction1(((x$41$2) => {
    var x$41$1 = $as_Lscalacss_internal_Media$Query(x$41$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$41$1)
  }))));
  var $$x698 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2089 = $m_Lscalacss_internal_Attrs$minWidth$();
  var v$241 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$242 = v$241.Lscalacss_internal_Literal__f_value;
  var $$x697 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x698).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2089.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$242)));
  var $$x696 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$23 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x695 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x696).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$23, "1")));
  var $$x694 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2094 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$243 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$244 = v$243.Lscalacss_internal_Literal__f_value;
  var array$179 = [$$x697, $$x695, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x694).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2094.Lscalacss_internal_Attrs$overflow$__f_attr, v$244)))];
  var x$178 = $n($$x699).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$179), c);
  var $$x693 = new $c_Lscalacss_internal_DslBase$ToStyle(x$178);
  var $$x692 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x691 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x690 = $n(this.Lcom_iz2use_react_style_Style__f_linkedViewContent).Lscalacss_internal_StyleA__f_htmlClass;
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x689 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2100 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x688 = $n($n($$x689).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2100.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$42$2) => {
    var x$42$1 = $as_Lscalacss_internal_Media$Query(x$42$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$42$1)
  }))));
  var $$x687 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2102 = $m_Lscalacss_internal_Attrs$width$();
  var array$180 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x687).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2102.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "min-content")))];
  var x$179 = $n($$x688).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$180), c);
  var array$181 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$179)];
  var array$182 = [$$x693, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x692).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x691).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt((">." + $$x690), $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$181), c)))];
  this.Lcom_iz2use_react_style_Style__f_linkedViewActiveContainer = $n($$x701).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$182), c);
  var $$x705 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "tabularViewContainer");
  var $$x704 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2121 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$82 = 100;
  var f$223 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$82);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$82 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$26) => {
    var x$4$28 = $as_Lscalacss_internal_Percentage(x$4$2$26);
    return $n(x$4$28).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$222 = new $c_sjsr_AnonFunction1(((x$1$2$109) => {
    var x$1$111 = $as_Lscalacss_internal_ValueT(x$1$2$109);
    return $n(x$1$111)
  }));
  var bc$82 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$222);
  var r$93 = $n(ab$82).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$82);
  var v$245 = $n(r$93).apply__O__Lscalacss_internal_ValueT(f$223);
  var v$246 = $n(v$245).Lscalacss_internal_ValueT__f_value;
  var $$x703 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x704).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2121.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$246)));
  var $$x702 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2123 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$247 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$248 = v$247.Lscalacss_internal_Literal__f_value;
  var array$183 = [$$x703, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x702).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2123.Lscalacss_internal_Attrs$overflowX$__f_attr, v$248)))];
  this.Lcom_iz2use_react_style_Style__f_tabularViewContainer = $n($$x705).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$183), c);
  var $$x714 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "gridListContainer");
  var $$x713 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2135 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$83 = 100;
  var f$225 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$83);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$83 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$27) => {
    var x$4$29 = $as_Lscalacss_internal_Percentage(x$4$2$27);
    return $n(x$4$29).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$224 = new $c_sjsr_AnonFunction1(((x$1$2$110) => {
    var x$1$112 = $as_Lscalacss_internal_ValueT(x$1$2$110);
    return $n(x$1$112)
  }));
  var bc$83 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$224);
  var r$94 = $n(ab$83).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$83);
  var v$249 = $n(r$94).apply__O__Lscalacss_internal_ValueT(f$225);
  var v$250 = $n(v$249).Lscalacss_internal_ValueT__f_value;
  var $$x712 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x713).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2135.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$250)));
  var $$x711 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2137 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$251 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$252 = v$251.Lscalacss_internal_Literal__f_value;
  var $$x710 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x711).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2137.Lscalacss_internal_Attrs$overflowX$__f_attr, v$252)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$180 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x709 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$180).Lscalacss_internal_StyleA__f_style);
  var $$x708 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2140 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x707 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x708).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2140.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
  var $$x706 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2142 = $m_Lscalacss_internal_Attrs$alignContent$();
  var array$184 = [$$x712, $$x710, $$x709, $$x707, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x706).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2142.Lscalacss_internal_Attrs$alignContent$__f_attr, "flex-start")))];
  this.Lcom_iz2use_react_style_Style__f_gridListContainer = $n($$x714).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$184), c);
  var $$x722 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "gridItem");
  var $$x721 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2147 = $m_Lscalacss_internal_Attrs$wordWrap$();
  var $$x720 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x721).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2147.Lscalacss_internal_Attrs$wordWrap$__f_attr, "break-word")));
  var $$x719 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2149 = $m_Lscalacss_internal_Attrs$wordBreak$();
  var $$x718 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x719).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2149.Lscalacss_internal_Attrs$wordBreak$__f_attr, "break-all")));
  var $$x716 = new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS(this.columnSize__sci_Range__F1__Lscalacss_internal_Style$UnsafeExt(new $c_sci_Range$Inclusive(1, 4, 1), new $c_sjsr_AnonFunction1(((c$3$2) => {
    var c$3 = $uI(c$3$2);
    var $$x717 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var a$24 = $m_Lscalacss_internal_Attrs$width$();
    $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var a$25 = (100.0 / c$3);
    var f$226 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), a$25);
    $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var r$95 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$28) => {
      var x$4$30 = $as_Lscalacss_internal_Percentage(x$4$2$28);
      return $n(x$4$30).value__T()
    })));
    var value$4 = $n(r$95).apply__O__Lscalacss_internal_ValueT(f$226);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n($$x717).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$24.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, $n(value$4).Lscalacss_internal_ValueT__f_value)))
  })))));
  var $$x715 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2162 = $m_Lscalacss_internal_Attrs$boxSizing$();
  var array$185 = [$$x720, $$x718, $$x716, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x715).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2162.Lscalacss_internal_Attrs$boxSizing$__f_attr, "border-box")))];
  this.Lcom_iz2use_react_style_Style__f_gridItem = $n($$x722).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$185), c);
  var $$x730 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "gridItemImage");
  var $$x729 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2175 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$84 = 8;
  var u$57 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$228 = new $c_Lscalacss_internal_Length(this$$84, u$57);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$84 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$55) => {
    var x$3$56 = $as_Lscalacss_internal_Length(x$3$2$55);
    return $n(x$3$56).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$227 = new $c_sjsr_AnonFunction1(((x$1$2$111) => {
    var x$1$113 = $as_Lscalacss_internal_ValueT(x$1$2$111);
    return $n(x$1$113)
  }));
  var bc$84 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$227);
  var r$96 = $n(ab$84).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$84);
  var v$253 = $n(r$96).apply__O__Lscalacss_internal_ValueT(f$228);
  var v$254 = $n(v$253).Lscalacss_internal_ValueT__f_value;
  var $$x728 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x729).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2175.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$254)));
  var $$x727 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$26 = $m_Lscalacss_internal_Attrs$().transition__Lscalacss_internal_Attr();
  var $$x726 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x727).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$26, "border-radius 0.3s ease")));
  var this$2189 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$85 = 0;
  var u$58 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$230 = new $c_Lscalacss_internal_Length(this$$85, u$58);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$85 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$56) => {
    var x$3$57 = $as_Lscalacss_internal_Length(x$3$2$56);
    return $n(x$3$57).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$229 = new $c_sjsr_AnonFunction1(((x$1$2$112) => {
    var x$1$114 = $as_Lscalacss_internal_ValueT(x$1$2$112);
    return $n(x$1$114)
  }));
  var bc$85 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$229);
  var r$97 = $n(ab$85).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$85);
  var radius$3 = $n(r$97).apply__O__Lscalacss_internal_ValueT(f$230);
  var v$255 = $n(radius$3).Lscalacss_internal_ValueT__f_value;
  var x$181 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$255);
  var $$x725 = new $c_Lscalacss_internal_DslBase$ToStyle(this$2189.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$181.av__Lscalacss_internal_AV()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$182 = this.image__Z__Lscalacss_internal_StyleS(true);
  var $$x724 = new $c_Lscalacss_internal_DslBase$ToStyle(x$182);
  var $$x723 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2192 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$256 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$257 = v$256.Lscalacss_internal_Literal__f_value;
  var array$186 = [$$x728, $$x726, $$x725, $$x724, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x723).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2192.Lscalacss_internal_Attrs$overflow$__f_attr, v$257)))];
  this.Lcom_iz2use_react_style_Style__f_gridItemImage = $n($$x730).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$186), c);
  var $$x752 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "gridItemTitle");
  var $$x751 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2198 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$258 = new $c_Lscalacss_internal_ValueT("#231f1c");
  var v$259 = v$258.Lscalacss_internal_ValueT__f_value;
  var $$x750 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x751).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2198.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$259)));
  var $$x749 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2200 = $m_Lscalacss_internal_Attrs$color$();
  var $$x748 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x749).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2200.Lscalacss_internal_Attrs$color$__f_attr, "white")));
  var $$x747 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2210 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$86 = 0.5;
  var u$59 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$232 = new $c_Lscalacss_internal_Length(this$$86, u$59);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$86 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$57) => {
    var x$3$58 = $as_Lscalacss_internal_Length(x$3$2$57);
    return $n(x$3$58).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$231 = new $c_sjsr_AnonFunction1(((x$1$2$113) => {
    var x$1$115 = $as_Lscalacss_internal_ValueT(x$1$2$113);
    return $n(x$1$115)
  }));
  var bc$86 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$231);
  var r$98 = $n(ab$86).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$86);
  var all$2 = $n(r$98).apply__O__Lscalacss_internal_ValueT(f$232);
  var v$260 = $n(all$2).Lscalacss_internal_ValueT__f_value;
  var $$x746 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x747).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2210.Lscalacss_internal_Attrs$padding$__f_attr, v$260)));
  var $$x745 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$27 = $m_Lscalacss_internal_Attrs$().transition__Lscalacss_internal_Attr();
  var $$x744 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x745).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$27, "border-radius 0.3s ease")));
  var this$2224 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$87 = 0;
  var u$60 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$234 = new $c_Lscalacss_internal_Length(this$$87, u$60);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$87 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$58) => {
    var x$3$59 = $as_Lscalacss_internal_Length(x$3$2$58);
    return $n(x$3$59).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$233 = new $c_sjsr_AnonFunction1(((x$1$2$114) => {
    var x$1$116 = $as_Lscalacss_internal_ValueT(x$1$2$114);
    return $n(x$1$116)
  }));
  var bc$87 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$233);
  var r$99 = $n(ab$87).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$87);
  var radius$4 = $n(r$99).apply__O__Lscalacss_internal_ValueT(f$234);
  var v$261 = $n(radius$4).Lscalacss_internal_ValueT__f_value;
  var x$183 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$261);
  var $$x743 = new $c_Lscalacss_internal_DslBase$ToStyle(this$2224.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$183.av__Lscalacss_internal_AV()));
  var $$x742 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x741 = $m_Lscalacss_internal_Attrs$borderTop$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$88 = 1;
  var u$61 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$236 = new $c_Lscalacss_internal_Length(this$$88, u$61);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$88 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$59) => {
    var x$3$60 = $as_Lscalacss_internal_Length(x$3$2$59);
    return $n(x$3$60).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$235 = new $c_sjsr_AnonFunction1(((x$1$2$115) => {
    var x$1$117 = $as_Lscalacss_internal_ValueT(x$1$2$115);
    return $n(x$1$117)
  }));
  var bc$88 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$235);
  var r$100 = $n(ab$88).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$88);
  var $$x740 = $n(r$100).apply__O__Lscalacss_internal_ValueT(f$236);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$238 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2236 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$89 = this$2236.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$28) => {
    var x$2$29 = $as_Lscalacss_internal_Literal(x$2$2$28);
    return $n(x$2$29).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$237 = new $c_sjsr_AnonFunction1(((x$1$2$116) => {
    var x$1$118 = $as_Lscalacss_internal_ValueT(x$1$2$116);
    return $n(x$1$118)
  }));
  var bc$89 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$237);
  var r$101 = $n(ab$89).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$89);
  var $$x739 = $n(r$101).apply__O__Lscalacss_internal_ValueT(f$238);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$240 = new $c_Lscalacss_internal_ValueT("white");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$239 = new $c_sjsr_AnonFunction1(((x$1$2$117) => {
    var x$1$119 = $as_Lscalacss_internal_ValueT(x$1$2$117);
    return $n(x$1$119)
  }));
  var r$102 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$239);
  var $$x738 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x742).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x741.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x740, $$x739, r$102.apply__O__Lscalacss_internal_ValueT(f$240))));
  var $$x737 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x736 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x735 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2255 = $m_Lscalacss_internal_Attrs$lineHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$89 = 1.1;
  var u$62 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$242 = new $c_Lscalacss_internal_Length(this$$89, u$62);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$90 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$60) => {
    var x$3$61 = $as_Lscalacss_internal_Length(x$3$2$60);
    return $n(x$3$61).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$241 = new $c_sjsr_AnonFunction1(((x$1$2$118) => {
    var x$1$120 = $as_Lscalacss_internal_ValueT(x$1$2$118);
    return $n(x$1$120)
  }));
  var bc$90 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$241);
  var r$103 = $n(ab$90).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$90);
  var v$262 = $n(r$103).apply__O__Lscalacss_internal_ValueT(f$242);
  var v$263 = $n(v$262).Lscalacss_internal_ValueT__f_value;
  var $$x734 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x735).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2255.Lscalacss_internal_Attrs$lineHeight$__f_attr, v$263)));
  var $$x733 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2265 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$90 = 1.1;
  var u$63 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$244 = new $c_Lscalacss_internal_Length(this$$90, u$63);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$91 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$61) => {
    var x$3$62 = $as_Lscalacss_internal_Length(x$3$2$61);
    return $n(x$3$62).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$243 = new $c_sjsr_AnonFunction1(((x$1$2$119) => {
    var x$1$121 = $as_Lscalacss_internal_ValueT(x$1$2$119);
    return $n(x$1$121)
  }));
  var bc$91 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$243);
  var r$104 = $n(ab$91).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$91);
  var v$264 = $n(r$104).apply__O__Lscalacss_internal_ValueT(f$244);
  var v$265 = $n(v$264).Lscalacss_internal_ValueT__f_value;
  var $$x732 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x733).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2265.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$265)));
  var $$x731 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2267 = $m_Lscalacss_internal_Attrs$overflowY$();
  var v$266 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$267 = v$266.Lscalacss_internal_Literal__f_value;
  var array$187 = [$$x734, $$x732, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x731).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2267.Lscalacss_internal_Attrs$overflowY$__f_attr, v$267)))];
  var array$188 = [$$x750, $$x748, $$x746, $$x744, $$x743, $$x738, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x737).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x736).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("> *", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$187), c)))];
  this.Lcom_iz2use_react_style_Style__f_gridItemTitle = $n($$x752).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$188), c);
  var $$x790 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "gridItemContent");
  var $$x789 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2283 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$91 = 0.5;
  var u$64 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$246 = new $c_Lscalacss_internal_Length(this$$91, u$64);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$92 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$62) => {
    var x$3$63 = $as_Lscalacss_internal_Length(x$3$2$62);
    return $n(x$3$63).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$245 = new $c_sjsr_AnonFunction1(((x$1$2$120) => {
    var x$1$122 = $as_Lscalacss_internal_ValueT(x$1$2$120);
    return $n(x$1$122)
  }));
  var bc$92 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$245);
  var r$105 = $n(ab$92).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$92);
  var all$3 = $n(r$105).apply__O__Lscalacss_internal_ValueT(f$246);
  var v$268 = $n(all$3).Lscalacss_internal_ValueT__f_value;
  var $$x788 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x789).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2283.Lscalacss_internal_Attrs$margin$__f_attr, v$268)));
  var $$x787 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2285 = $m_Lscalacss_internal_Attrs$cursor$();
  var $$x786 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x787).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2285.Lscalacss_internal_Attrs$cursor$__f_attr, "pointer")));
  var $$x785 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2287 = $m_Lscalacss_internal_Attrs$color$();
  var $$x784 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x785).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2287.Lscalacss_internal_Attrs$color$__f_attr, "white")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$184 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var $$x783 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$184).Lscalacss_internal_StyleA__f_style);
  var $$x782 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2290 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var $$x781 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x782).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2290.Lscalacss_internal_Attrs$justifyContent$__f_attr, "space-between")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x780 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2293 = new $c_Lscalacss_internal_DslBase$MediaQueryNeedType($m_Lscalacss_internal_Media$Not$());
  var $$x779 = $n($n($$x780).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2293.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Handheld$()), new $c_sjsr_AnonFunction1(((x$43$2) => {
    var x$43$1 = $as_Lscalacss_internal_Media$Query(x$43$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$43$1)
  }))));
  var this$2304 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$92 = 0;
  var u$65 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$248 = new $c_Lscalacss_internal_Length(this$$92, u$65);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$93 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$63) => {
    var x$3$64 = $as_Lscalacss_internal_Length(x$3$2$63);
    return $n(x$3$64).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$247 = new $c_sjsr_AnonFunction1(((x$1$2$121) => {
    var x$1$123 = $as_Lscalacss_internal_ValueT(x$1$2$121);
    return $n(x$1$123)
  }));
  var bc$93 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$247);
  var r$106 = $n(ab$93).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$93);
  var radius$5 = $n(r$106).apply__O__Lscalacss_internal_ValueT(f$248);
  var v$269 = $n(radius$5).Lscalacss_internal_ValueT__f_value;
  var x$185 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$269);
  var $$x778 = new $c_Lscalacss_internal_DslBase$ToStyle(this$2304.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$185.av__Lscalacss_internal_AV()));
  var $$x777 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$28 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var $$x776 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x777).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$28, "#aaa 0 0 0")));
  var $$x775 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$29 = $m_Lscalacss_internal_Attrs$().transition__Lscalacss_internal_Attr();
  var $$x774 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x775).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$29, "box-shadow 0.3s ease, border-radius 0.3s ease")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x773 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$2311 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p$2 = $m_Lscalacss_internal_Pseudo$Hover$();
  var $$x772 = this$2311.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p$2);
  var this$2313 = $m_s_$less$colon$less$();
  var $$x771 = $n($n($$x773).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x772, this$2313.s_$less$colon$less$__f_singleton));
  var $$x770 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$30 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var $$x769 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x770).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$30, "#aaa 3pt 3pt 3pt")));
  var this$2327 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$93 = 1;
  var u$66 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$250 = new $c_Lscalacss_internal_Length(this$$93, u$66);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$94 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$64) => {
    var x$3$65 = $as_Lscalacss_internal_Length(x$3$2$64);
    return $n(x$3$65).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$249 = new $c_sjsr_AnonFunction1(((x$1$2$122) => {
    var x$1$124 = $as_Lscalacss_internal_ValueT(x$1$2$122);
    return $n(x$1$124)
  }));
  var bc$94 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$249);
  var r$107 = $n(ab$94).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$94);
  var radius$6 = $n(r$107).apply__O__Lscalacss_internal_ValueT(f$250);
  var v$270 = $n(radius$6).Lscalacss_internal_ValueT__f_value;
  var x$186 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$270);
  var $$x768 = new $c_Lscalacss_internal_DslBase$ToStyle(this$2327.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$186.av__Lscalacss_internal_AV()));
  var $$x767 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x766 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x765 = $n($n(this.Lcom_iz2use_react_style_Style__f_gridItemImage).Lscalacss_internal_StyleA__f_className).Lscalacss_internal_ClassName__f_value;
  var $$x764 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2337 = $m_Lscalacss_internal_Attrs$borderTopLeftRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$94 = 1;
  var u$67 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$252 = new $c_Lscalacss_internal_Length(this$$94, u$67);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$95 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$65) => {
    var x$3$66 = $as_Lscalacss_internal_Length(x$3$2$65);
    return $n(x$3$66).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$251 = new $c_sjsr_AnonFunction1(((x$1$2$123) => {
    var x$1$125 = $as_Lscalacss_internal_ValueT(x$1$2$123);
    return $n(x$1$125)
  }));
  var bc$95 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$251);
  var r$108 = $n(ab$95).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$95);
  var both = $n(r$108).apply__O__Lscalacss_internal_ValueT(f$252);
  var v$271 = $n(both).Lscalacss_internal_ValueT__f_value;
  var $$x763 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x764).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2337.Lscalacss_internal_Attrs$borderTopLeftRadius$__f_attr, v$271)));
  var $$x762 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2347 = $m_Lscalacss_internal_Attrs$borderTopRightRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$95 = 1;
  var u$68 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$254 = new $c_Lscalacss_internal_Length(this$$95, u$68);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$96 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$66) => {
    var x$3$67 = $as_Lscalacss_internal_Length(x$3$2$66);
    return $n(x$3$67).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$253 = new $c_sjsr_AnonFunction1(((x$1$2$124) => {
    var x$1$126 = $as_Lscalacss_internal_ValueT(x$1$2$124);
    return $n(x$1$126)
  }));
  var bc$96 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$253);
  var r$109 = $n(ab$96).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$96);
  var both$1 = $n(r$109).apply__O__Lscalacss_internal_ValueT(f$254);
  var v$272 = $n(both$1).Lscalacss_internal_ValueT__f_value;
  var array$189 = [$$x763, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x762).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2347.Lscalacss_internal_Attrs$borderTopRightRadius$__f_attr, v$272)))];
  var $$x761 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x767).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x766).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(("." + $$x765), $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$189), c)));
  var $$x760 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x759 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x758 = $n($n(this.Lcom_iz2use_react_style_Style__f_gridItemTitle).Lscalacss_internal_StyleA__f_className).Lscalacss_internal_ClassName__f_value;
  var $$x757 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2360 = $m_Lscalacss_internal_Attrs$borderBottomLeftRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$96 = 1;
  var u$69 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$256 = new $c_Lscalacss_internal_Length(this$$96, u$69);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$97 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$67) => {
    var x$3$68 = $as_Lscalacss_internal_Length(x$3$2$67);
    return $n(x$3$68).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$255 = new $c_sjsr_AnonFunction1(((x$1$2$125) => {
    var x$1$127 = $as_Lscalacss_internal_ValueT(x$1$2$125);
    return $n(x$1$127)
  }));
  var bc$97 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$255);
  var r$110 = $n(ab$97).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$97);
  var both$2 = $n(r$110).apply__O__Lscalacss_internal_ValueT(f$256);
  var v$273 = $n(both$2).Lscalacss_internal_ValueT__f_value;
  var $$x756 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x757).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2360.Lscalacss_internal_Attrs$borderBottomLeftRadius$__f_attr, v$273)));
  var $$x755 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2370 = $m_Lscalacss_internal_Attrs$borderBottomRightRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$97 = 1;
  var u$70 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$258 = new $c_Lscalacss_internal_Length(this$$97, u$70);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$98 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$68) => {
    var x$3$69 = $as_Lscalacss_internal_Length(x$3$2$68);
    return $n(x$3$69).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$257 = new $c_sjsr_AnonFunction1(((x$1$2$126) => {
    var x$1$128 = $as_Lscalacss_internal_ValueT(x$1$2$126);
    return $n(x$1$128)
  }));
  var bc$98 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$257);
  var r$111 = $n(ab$98).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$98);
  var both$3 = $n(r$111).apply__O__Lscalacss_internal_ValueT(f$258);
  var v$274 = $n(both$3).Lscalacss_internal_ValueT__f_value;
  var $$x754 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x755).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2370.Lscalacss_internal_Attrs$borderBottomRightRadius$__f_attr, v$274)));
  var $$x753 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2372 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$190 = [$$x756, $$x754, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x753).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2372.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "black")))];
  var array$191 = [$$x769, $$x768, $$x761, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x760).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x759).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(("." + $$x758), $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$190), c)))];
  var x$187 = $n($$x771).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$191), c);
  var array$192 = [$$x778, $$x776, $$x774, new $c_Lscalacss_internal_DslBase$ToStyle(x$187)];
  var x$188 = $n($$x779).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$192), c);
  var array$193 = [$$x788, $$x786, $$x784, $$x783, $$x781, new $c_Lscalacss_internal_DslBase$ToStyle(x$188)];
  this.Lcom_iz2use_react_style_Style__f_gridItemContent = $n($$x790).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$193), c);
  var $$x795 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "listView");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$189 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var $$x794 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$189).Lscalacss_internal_StyleA__f_style);
  var $$x793 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2389 = $m_Lscalacss_internal_Attrs$maxWidth$();
  var $$x792 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x793).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2389.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, "fit-content")));
  var $$x791 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2398 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$98 = 100;
  var f$260 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$98);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$99 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$29) => {
    var x$4$31 = $as_Lscalacss_internal_Percentage(x$4$2$29);
    return $n(x$4$31).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$259 = new $c_sjsr_AnonFunction1(((x$1$2$127) => {
    var x$1$129 = $as_Lscalacss_internal_ValueT(x$1$2$127);
    return $n(x$1$129)
  }));
  var bc$99 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$259);
  var r$112 = $n(ab$99).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$99);
  var v$275 = $n(r$112).apply__O__Lscalacss_internal_ValueT(f$260);
  var v$276 = $n(v$275).Lscalacss_internal_ValueT__f_value;
  var array$194 = [$$x794, $$x792, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x791).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2398.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$276)))];
  this.Lcom_iz2use_react_style_Style__f_listView = $n($$x795).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$194), c);
  var $$x803 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "listItem");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$190 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x802 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$190).Lscalacss_internal_StyleA__f_style);
  var $$x801 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x800 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$99 = 0.5;
  var u$71 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$262 = new $c_Lscalacss_internal_Length(this$$99, u$71);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$100 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$69) => {
    var x$3$70 = $as_Lscalacss_internal_Length(x$3$2$69);
    return $n(x$3$70).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$261 = new $c_sjsr_AnonFunction1(((x$1$2$128) => {
    var x$1$130 = $as_Lscalacss_internal_ValueT(x$1$2$128);
    return $n(x$1$130)
  }));
  var bc$100 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$261);
  var r$113 = $n(ab$100).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$100);
  var $$x799 = $n(r$113).apply__O__Lscalacss_internal_ValueT(f$262);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$100 = 0.25;
  var u$72 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$264 = new $c_Lscalacss_internal_Length(this$$100, u$72);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$101 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$70) => {
    var x$3$71 = $as_Lscalacss_internal_Length(x$3$2$70);
    return $n(x$3$71).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$263 = new $c_sjsr_AnonFunction1(((x$1$2$129) => {
    var x$1$131 = $as_Lscalacss_internal_ValueT(x$1$2$129);
    return $n(x$1$131)
  }));
  var bc$101 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$263);
  var r$114 = $n(ab$101).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$101);
  var $$x798 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x801).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x800.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x799, $n(r$114).apply__O__Lscalacss_internal_ValueT(f$264))));
  var $$x797 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2421 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x796 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x797).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2421.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$191 = $n($n($n(md).Elevation__Lcom_iz2use_react_style_MaterialDesign$Elevation$()).Card__Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$()).style__Lscalacss_internal_StyleS();
  var array$195 = [$$x802, $$x798, $$x796, new $c_Lscalacss_internal_DslBase$ToStyle(x$191)];
  this.Lcom_iz2use_react_style_Style__f_listItem = $n($$x803).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$195), c);
  var $$x827 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "listItemField");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$277 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var this$2429 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$277);
  var colors$20 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$20 = $m_Lcom_iz2use_react_style_OpacityLevel$low$();
  var f$265 = new $c_sjsr_AnonFunction1(((color$6$2) => {
    var color$6 = $as_Lscalacss_internal_ValueT(color$6$2);
    return new $c_sjsr_AnonFunction1(((x$17$2$1) => {
      var x$17$4 = $as_Lscalacss_internal_Attr(x$17$2$1);
      $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value$5 = ("1px 1px 2px " + $n(color$6).Lscalacss_internal_ValueT__f_value);
      return new $c_Lscalacss_internal_AV(x$17$4, value$5)
    }))
  }));
  var array$196 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(this$2429, f$265, colors$20, opacity$20)];
  var t$80 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$196);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$266 = new $c_sjsr_AnonFunction1(((x$1$2$130) => {
    var x$1$132 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$130);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$132).light__Lscalacss_internal_AV()))
  }));
  var t$81 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$80, f$266));
  var x$192 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$81, c);
  var $$x826 = new $c_Lscalacss_internal_DslBase$ToStyle(x$192);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x825 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2437 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2438 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2437.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x824 = $n($n($$x825).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$2438), new $c_sjsr_AnonFunction1(((x$2$30) => {
    var x$193 = $as_Lscalacss_internal_Media$Query(x$2$30);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$193)
  }))));
  var f$267 = new $c_sjsr_AnonFunction1(((x$2$2$2$24) => {
    var x$2$2$29 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$24);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$29).dark__Lscalacss_internal_AV()))
  }));
  var x$194 = $n($$x824).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$80, f$267)), c);
  var array$197 = [$$x826, new $c_Lscalacss_internal_DslBase$ToStyle(x$194)];
  var t$82 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$197);
  var x$195 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$82, c);
  var $$x823 = new $c_Lscalacss_internal_DslBase$ToStyle(x$195);
  var $$x822 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x821 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x820 = new $c_sjsr_AnonFunction1(((x$18$4$2) => {
    var x$18$4 = $as_T(x$18$4$2);
    return (x$18$4 + ">label")
  }));
  var $$x819 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2446 = $m_Lscalacss_internal_Attrs$display$();
  var v$278 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$279 = v$278.Lscalacss_internal_Literal__f_value;
  var array$198 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x819).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2446.Lscalacss_internal_Attrs$display$__f_attr, v$279)))];
  var $$x818 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x822).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x821).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x820, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$198), c)));
  var $$x817 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2451 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$280 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$281 = v$280.Lscalacss_internal_Literal__f_value;
  var $$x816 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x817).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2451.Lscalacss_internal_Attrs$overflow$__f_attr, v$281)));
  var $$x815 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$31 = $m_Lscalacss_internal_Attrs$().textOverflow__Lscalacss_internal_Attr();
  var $$x814 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x815).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$31, "ellipsis")));
  var $$x813 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2456 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var $$x812 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x813).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2456.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")));
  var $$x811 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2466 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$101 = 2;
  var u$73 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$269 = new $c_Lscalacss_internal_Length(this$$101, u$73);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$102 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$71) => {
    var x$3$72 = $as_Lscalacss_internal_Length(x$3$2$71);
    return $n(x$3$72).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$268 = new $c_sjsr_AnonFunction1(((x$1$2$131) => {
    var x$1$133 = $as_Lscalacss_internal_ValueT(x$1$2$131);
    return $n(x$1$133)
  }));
  var bc$102 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$268);
  var r$115 = $n(ab$102).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$102);
  var all$4 = $n(r$115).apply__O__Lscalacss_internal_ValueT(f$269);
  var v$282 = $n(all$4).Lscalacss_internal_ValueT__f_value;
  var $$x810 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x811).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2466.Lscalacss_internal_Attrs$padding$__f_attr, v$282)));
  var $$x809 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2476 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$102 = 2;
  var u$74 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$271 = new $c_Lscalacss_internal_Length(this$$102, u$74);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$103 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$72) => {
    var x$3$73 = $as_Lscalacss_internal_Length(x$3$2$72);
    return $n(x$3$73).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$270 = new $c_sjsr_AnonFunction1(((x$1$2$132) => {
    var x$1$134 = $as_Lscalacss_internal_ValueT(x$1$2$132);
    return $n(x$1$134)
  }));
  var bc$103 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$270);
  var r$116 = $n(ab$103).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$103);
  var all$5 = $n(r$116).apply__O__Lscalacss_internal_ValueT(f$271);
  var v$283 = $n(all$5).Lscalacss_internal_ValueT__f_value;
  var $$x808 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x809).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2476.Lscalacss_internal_Attrs$margin$__f_attr, v$283)));
  var $$x807 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2478 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x806 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x807).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2478.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var this$2489 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$103 = 0.25;
  var u$75 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$273 = new $c_Lscalacss_internal_Length(this$$103, u$75);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$104 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$73) => {
    var x$3$74 = $as_Lscalacss_internal_Length(x$3$2$73);
    return $n(x$3$74).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$272 = new $c_sjsr_AnonFunction1(((x$1$2$133) => {
    var x$1$135 = $as_Lscalacss_internal_ValueT(x$1$2$133);
    return $n(x$1$135)
  }));
  var bc$104 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$272);
  var r$117 = $n(ab$104).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$104);
  var radius$7 = $n(r$117).apply__O__Lscalacss_internal_ValueT(f$273);
  var v$284 = $n(radius$7).Lscalacss_internal_ValueT__f_value;
  var x$196 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$284);
  var $$x805 = new $c_Lscalacss_internal_DslBase$ToStyle(this$2489.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$196.av__Lscalacss_internal_AV()));
  var $$x804 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2499 = $m_Lscalacss_internal_Attrs$minHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$104 = 1;
  var u$76 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$275 = new $c_Lscalacss_internal_Length(this$$104, u$76);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$105 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$74) => {
    var x$3$75 = $as_Lscalacss_internal_Length(x$3$2$74);
    return $n(x$3$75).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$274 = new $c_sjsr_AnonFunction1(((x$1$2$134) => {
    var x$1$136 = $as_Lscalacss_internal_ValueT(x$1$2$134);
    return $n(x$1$136)
  }));
  var bc$105 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$274);
  var r$118 = $n(ab$105).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$105);
  var v$285 = $n(r$118).apply__O__Lscalacss_internal_ValueT(f$275);
  var v$286 = $n(v$285).Lscalacss_internal_ValueT__f_value;
  var array$199 = [$$x823, $$x818, $$x816, $$x814, $$x812, $$x810, $$x808, $$x806, $$x805, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x804).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2499.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$286)))];
  this.Lcom_iz2use_react_style_Style__f_listItemField = $n($$x827).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$199), c);
  var $$x837 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "slideshowViewContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x836 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2504 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x835 = $n($n($$x836).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2504.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$44$2) => {
    var x$44$1 = $as_Lscalacss_internal_Media$Query(x$44$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$44$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$197 = this.Lcom_iz2use_react_style_Style__f_flex1;
  var $$x834 = new $c_Lscalacss_internal_DslBase$ToStyle(x$197);
  var $$x833 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2507 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$287 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$288 = v$287.Lscalacss_internal_Literal__f_value;
  var $$x832 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x833).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2507.Lscalacss_internal_Attrs$overflow$__f_attr, v$288)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$198 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var $$x831 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$198).Lscalacss_internal_StyleA__f_style);
  var $$x830 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2510 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$289 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$290 = v$289.Lscalacss_internal_Literal__f_value;
  var $$x829 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x830).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2510.Lscalacss_internal_Attrs$overflow$__f_attr, v$290)));
  var $$x828 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2512 = $m_Lscalacss_internal_Attrs$alignItems$();
  var array$200 = [$$x834, $$x832, $$x831, $$x829, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x828).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2512.Lscalacss_internal_Attrs$alignItems$__f_attr, "center")))];
  var x$199 = $n($$x835).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$200), c);
  var array$201 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$199)];
  this.Lcom_iz2use_react_style_Style__f_slideshowViewContainer = $n($$x837).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$201), c);
  var $$x845 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "slideshowViewNavigationBar");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$200 = this.Lcom_iz2use_react_style_Style__f_notPrintable;
  var $$x844 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$200).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$201 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x843 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$201).Lscalacss_internal_StyleA__f_style);
  var $$x842 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2523 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var $$x841 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x842).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2523.Lscalacss_internal_Attrs$justifyContent$__f_attr, "stretch")));
  var $$x840 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2525 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x839 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x840).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2525.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x838 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2527 = $m_Lscalacss_internal_Attrs$alignSelf$();
  var array$202 = [$$x844, $$x843, $$x841, $$x839, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x838).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2527.Lscalacss_internal_Attrs$alignSelf$__f_attr, "stretch")))];
  this.Lcom_iz2use_react_style_Style__f_slideshowViewNavigationBar = $n($$x845).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$202), c);
  var $$x847 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "slideshowButton");
  var $$x846 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$32 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$203 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x846).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$32, "1")))];
  this.Lcom_iz2use_react_style_Style__f_slideshowButton = $n($$x847).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$203), c);
  var $$x848 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "slideshowPreviousItem");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$202 = this.Lcom_iz2use_react_style_Style__f_notPrintable;
  var array$204 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$202).Lscalacss_internal_StyleA__f_style)];
  $n($$x848).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$204), c);
  var $$x855 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "slideshowActiveItem");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x854 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2542 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x853 = $n($n($$x854).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2542.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$45$2) => {
    var x$45$1 = $as_Lscalacss_internal_Media$Query(x$45$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$45$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$203 = this.Lcom_iz2use_react_style_Style__f_flex1;
  var $$x852 = new $c_Lscalacss_internal_DslBase$ToStyle(x$203);
  var $$x851 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$33 = $m_Lscalacss_internal_Attrs$alignSelf$();
  var $$x850 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x851).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$33.Lscalacss_internal_Attrs$alignSelf$__f_attr, "normal")));
  var $$x849 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2549 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$291 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$292 = v$291.Lscalacss_internal_Literal__f_value;
  var array$205 = [$$x852, $$x850, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x849).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2549.Lscalacss_internal_Attrs$overflowX$__f_attr, v$292)))];
  var x$204 = $n($$x853).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$205), c);
  var array$206 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$204)];
  this.Lcom_iz2use_react_style_Style__f_slideshowActiveItem = $n($$x855).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$206), c);
  var $$x856 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "slideshowNextItem");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$205 = this.Lcom_iz2use_react_style_Style__f_notPrintable;
  var array$207 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$205).Lscalacss_internal_StyleA__f_style)];
  $n($$x856).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$207), c);
  var $$x882 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "sideBySideLayoutContainer");
  var $$x881 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$34 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x880 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x881).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$34, "1")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$206 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x879 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$206).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x878 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2566 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x877 = $n($n($$x878).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2566.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$46$2) => {
    var x$46$1 = $as_Lscalacss_internal_Media$Query(x$46$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$46$1)
  }))));
  var $$x876 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2575 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$105 = 100;
  var f$277 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$105);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$106 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$30) => {
    var x$4$32 = $as_Lscalacss_internal_Percentage(x$4$2$30);
    return $n(x$4$32).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$276 = new $c_sjsr_AnonFunction1(((x$1$2$135) => {
    var x$1$137 = $as_Lscalacss_internal_ValueT(x$1$2$135);
    return $n(x$1$137)
  }));
  var bc$106 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$276);
  var r$119 = $n(ab$106).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$106);
  var v$293 = $n(r$119).apply__O__Lscalacss_internal_ValueT(f$277);
  var v$294 = $n(v$293).Lscalacss_internal_ValueT__f_value;
  var array$208 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x876).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2575.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$294)))];
  var x$207 = $n($$x877).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$208), c);
  var $$x875 = new $c_Lscalacss_internal_DslBase$ToStyle(x$207);
  var $$x874 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2581 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x873 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x874).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2581.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
  var $$x872 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2583 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x871 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x872).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2583.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x870 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2585 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2589 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2585.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$106 = 800;
  var u$77 = $m_Lscalacss_internal_LengthUnit$px$();
  var v$295 = new $c_Lscalacss_internal_Length(this$$106, u$77);
  var $$x869 = $n($n($$x870).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__maxWidth__Lscalacss_internal_Length__O(this$2589, v$295), new $c_sjsr_AnonFunction1(((x$47$2) => {
    var x$47$1 = $as_Lscalacss_internal_Media$Query(x$47$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$47$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$208 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var $$x868 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$208).Lscalacss_internal_StyleA__f_style);
  var $$x867 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2592 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x866 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x867).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2592.Lscalacss_internal_Attrs$flexWrap$__f_attr, "nowrap")));
  var $$x865 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2594 = $m_Lscalacss_internal_Attrs$alignItems$();
  var array$209 = [$$x868, $$x866, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x865).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2594.Lscalacss_internal_Attrs$alignItems$__f_attr, "stretch")))];
  var x$209 = $n($$x869).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$209), c);
  var $$x864 = new $c_Lscalacss_internal_DslBase$ToStyle(x$209);
  var $$x863 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x862 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x861 = new $c_sjsr_AnonFunction1(((x$19$4$2) => {
    var x$19$4 = $as_T(x$19$4$2);
    return (x$19$4 + ">*")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$210 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var $$x860 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$210).Lscalacss_internal_StyleA__f_style);
  var $$x859 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$35 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x858 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x859).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$35, "1")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x857 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2604 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var x$211 = $n($n($$x857).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2604.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$48$2) => {
    var x$48$1 = $as_Lscalacss_internal_Media$Query(x$48$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$48$1)
  })))).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($m_sci_Nil$(), c);
  var array$210 = [$$x860, $$x858, new $c_Lscalacss_internal_DslBase$ToStyle(x$211)];
  var array$211 = [$$x880, $$x879, $$x875, $$x873, $$x871, $$x864, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x863).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x862).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x861, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$210), c)))];
  this.Lcom_iz2use_react_style_Style__f_sideBySideLayoutContainer = $n($$x882).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$211), c);
  var $$x898 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "cardContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$212 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var $$x897 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$212).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$213 = $n($n($n(md).Elevation__Lcom_iz2use_react_style_MaterialDesign$Elevation$()).Card__Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$()).style__Lscalacss_internal_StyleS();
  var $$x896 = new $c_Lscalacss_internal_DslBase$ToStyle(x$213);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$296 = ($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $m_Lscalacss_internal_Attrs$backgroundColor$()).Lscalacss_internal_Attrs$backgroundColor$__f_attr;
  var qual$3 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$296);
  var x$5$3$1 = $n(theme).Lcom_iz2use_react_style_Theme__f_background;
  var x$6$4$1 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var x$7$4 = new $c_sjsr_AnonFunction1(((color$7$2) => {
    var color$7 = $as_Lscalacss_internal_ValueT(color$7$2);
    return new $c_sjsr_AnonFunction1(((x$20$2$1) => {
      var x$20$4 = $as_Lscalacss_internal_Attr(x$20$2$1);
      $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value$6 = $n(color$7).Lscalacss_internal_ValueT__f_value;
      return new $c_Lscalacss_internal_AV(x$20$4, value$6)
    }))
  }));
  var array$212 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(qual$3, x$7$4, x$5$3$1, x$6$4$1)];
  var t$83 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$212);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$278 = new $c_sjsr_AnonFunction1(((x$1$2$136) => {
    var x$1$138 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$136);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$138).light__Lscalacss_internal_AV()))
  }));
  var t$84 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$83, f$278));
  var x$214 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$84, c);
  var $$x895 = new $c_Lscalacss_internal_DslBase$ToStyle(x$214);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x894 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2624 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2625 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2624.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x893 = $n($n($$x894).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$2625), new $c_sjsr_AnonFunction1(((x$2$31) => {
    var x$215 = $as_Lscalacss_internal_Media$Query(x$2$31);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$215)
  }))));
  var f$279 = new $c_sjsr_AnonFunction1(((x$2$2$2$25) => {
    var x$2$2$30 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$25);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$30).dark__Lscalacss_internal_AV()))
  }));
  var x$216 = $n($$x893).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$83, f$279)), c);
  var array$213 = [$$x895, new $c_Lscalacss_internal_DslBase$ToStyle(x$216)];
  var t$85 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$213);
  var x$217 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$85, c);
  var $$x892 = new $c_Lscalacss_internal_DslBase$ToStyle(x$217);
  var $$x891 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2641 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$107 = 1;
  var u$78 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$281 = new $c_Lscalacss_internal_Length(this$$107, u$78);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$107 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$75) => {
    var x$3$76 = $as_Lscalacss_internal_Length(x$3$2$75);
    return $n(x$3$76).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$280 = new $c_sjsr_AnonFunction1(((x$1$2$137) => {
    var x$1$139 = $as_Lscalacss_internal_ValueT(x$1$2$137);
    return $n(x$1$139)
  }));
  var bc$107 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$280);
  var r$120 = $n(ab$107).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$107);
  var all$6 = $n(r$120).apply__O__Lscalacss_internal_ValueT(f$281);
  var v$297 = $n(all$6).Lscalacss_internal_ValueT__f_value;
  var $$x890 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x891).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2641.Lscalacss_internal_Attrs$margin$__f_attr, v$297)));
  var $$x889 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x888 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$298 = ($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $m_Lscalacss_internal_Attrs$borderTop$()).Lscalacss_internal_Attrs$borderTop$__f_attr;
  var qual$4 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$298);
  var x$8$4 = $n(theme).Lcom_iz2use_react_style_Theme__f_lineBorder;
  var x$9$3$1 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var x$10$4 = new $c_sjsr_AnonFunction1(((color$8$2) => {
    var color$8 = $as_Lscalacss_internal_ValueT(color$8$2);
    return new $c_sjsr_AnonFunction1(((x$21$2$1) => {
      var x$21$4 = $as_Lscalacss_internal_Attr(x$21$2$1);
      $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value$7 = ("1px solid " + $n(color$8).Lscalacss_internal_ValueT__f_value);
      return new $c_Lscalacss_internal_AV(x$21$4, value$7)
    }))
  }));
  var array$214 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(qual$4, x$10$4, x$8$4, x$9$3$1)];
  var t$86 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$214);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$282 = new $c_sjsr_AnonFunction1(((x$1$2$138) => {
    var x$1$140 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$138);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$140).light__Lscalacss_internal_AV()))
  }));
  var t$87 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$86, f$282));
  var x$218 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$87, c);
  var $$x887 = new $c_Lscalacss_internal_DslBase$ToStyle(x$218);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x886 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2652 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2653 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2652.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x885 = $n($n($$x886).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$2653), new $c_sjsr_AnonFunction1(((x$2$32) => {
    var x$219 = $as_Lscalacss_internal_Media$Query(x$2$32);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$219)
  }))));
  var f$283 = new $c_sjsr_AnonFunction1(((x$2$2$2$26) => {
    var x$2$2$31 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$26);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$31).dark__Lscalacss_internal_AV()))
  }));
  var x$220 = $n($$x885).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$86, f$283)), c);
  var array$215 = [$$x887, new $c_Lscalacss_internal_DslBase$ToStyle(x$220)];
  var t$88 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$215);
  var x$221 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$88, c);
  var $$x884 = new $c_Lscalacss_internal_DslBase$ToStyle(x$221);
  var $$x883 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2669 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$108 = 8;
  var u$79 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$285 = new $c_Lscalacss_internal_Length(this$$108, u$79);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$108 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$76) => {
    var x$3$77 = $as_Lscalacss_internal_Length(x$3$2$76);
    return $n(x$3$77).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$284 = new $c_sjsr_AnonFunction1(((x$1$2$139) => {
    var x$1$141 = $as_Lscalacss_internal_ValueT(x$1$2$139);
    return $n(x$1$141)
  }));
  var bc$108 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$284);
  var r$121 = $n(ab$108).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$108);
  var all$7 = $n(r$121).apply__O__Lscalacss_internal_ValueT(f$285);
  var v$299 = $n(all$7).Lscalacss_internal_ValueT__f_value;
  var array$216 = [$$x884, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x883).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2669.Lscalacss_internal_Attrs$padding$__f_attr, v$299)))];
  var array$217 = [$$x897, $$x896, $$x892, $$x890, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x889).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x888).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(">*", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$216), c)))];
  this.Lcom_iz2use_react_style_Style__f_cardContainer = $n($$x898).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$217), c);
  var $$x905 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "cardHeader");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$222 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x904 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$222).Lscalacss_internal_StyleA__f_style);
  var $$x903 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x902 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$109 = 0;
  var u$80 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$287 = new $c_Lscalacss_internal_Length(this$$109, u$80);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$109 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$77) => {
    var x$3$78 = $as_Lscalacss_internal_Length(x$3$2$77);
    return $n(x$3$78).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$286 = new $c_sjsr_AnonFunction1(((x$1$2$140) => {
    var x$1$142 = $as_Lscalacss_internal_ValueT(x$1$2$140);
    return $n(x$1$142)
  }));
  var bc$109 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$286);
  var r$122 = $n(ab$109).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$109);
  var $$x901 = $n(r$122).apply__O__Lscalacss_internal_ValueT(f$287);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$110 = 24;
  var u$81 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$289 = new $c_Lscalacss_internal_Length(this$$110, u$81);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$110 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$78) => {
    var x$3$79 = $as_Lscalacss_internal_Length(x$3$2$78);
    return $n(x$3$79).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$288 = new $c_sjsr_AnonFunction1(((x$1$2$141) => {
    var x$1$143 = $as_Lscalacss_internal_ValueT(x$1$2$141);
    return $n(x$1$143)
  }));
  var bc$110 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$288);
  var r$123 = $n(ab$110).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$110);
  var $$x900 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x903).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x902.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x901, $n(r$123).apply__O__Lscalacss_internal_ValueT(f$289))));
  var $$x899 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2695 = $m_Lscalacss_internal_Attrs$alignItems$();
  var array$218 = [$$x904, $$x900, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x899).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2695.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")))];
  this.Lcom_iz2use_react_style_Style__f_cardHeader = $n($$x905).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$218), c);
  var $$x916 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "cardTitle");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$223 = this.Lcom_iz2use_react_style_Style__f_flex1;
  var $$x915 = new $c_Lscalacss_internal_DslBase$ToStyle(x$223);
  var $$x914 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2701 = $m_Lscalacss_internal_Attrs$fontSize$();
  var $$x913 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x914).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2701.Lscalacss_internal_Attrs$fontSize$__f_attr, "large")));
  var $$x912 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2703 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var $$x911 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x912).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2703.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")));
  var $$x910 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x909 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$111 = 8;
  var u$82 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$291 = new $c_Lscalacss_internal_Length(this$$111, u$82);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$111 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$79) => {
    var x$3$80 = $as_Lscalacss_internal_Length(x$3$2$79);
    return $n(x$3$80).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$290 = new $c_sjsr_AnonFunction1(((x$1$2$142) => {
    var x$1$144 = $as_Lscalacss_internal_ValueT(x$1$2$142);
    return $n(x$1$144)
  }));
  var bc$111 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$290);
  var r$124 = $n(ab$111).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$111);
  var $$x908 = $n(r$124).apply__O__Lscalacss_internal_ValueT(f$291);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$112 = 0;
  var u$83 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$293 = new $c_Lscalacss_internal_Length(this$$112, u$83);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$112 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$80) => {
    var x$3$81 = $as_Lscalacss_internal_Length(x$3$2$80);
    return $n(x$3$81).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$292 = new $c_sjsr_AnonFunction1(((x$1$2$143) => {
    var x$1$145 = $as_Lscalacss_internal_ValueT(x$1$2$143);
    return $n(x$1$145)
  }));
  var bc$112 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$292);
  var r$125 = $n(ab$112).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$112);
  var $$x907 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x910).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x909.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x908, $n(r$125).apply__O__Lscalacss_internal_ValueT(f$293))));
  var $$x906 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$36 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$219 = [$$x915, $$x913, $$x911, $$x907, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x906).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$36, "2")))];
  this.Lcom_iz2use_react_style_Style__f_cardTitle = $n($$x916).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$219), c);
  var $$x922 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "verticalLayout");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$224 = this.Lcom_iz2use_react_style_Style__f_flex1;
  var $$x921 = new $c_Lscalacss_internal_DslBase$ToStyle(x$224);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$225 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var $$x920 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$225).Lscalacss_internal_StyleA__f_style);
  var $$x919 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2737 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$113 = 100;
  var f$295 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$113);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$113 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$31) => {
    var x$4$33 = $as_Lscalacss_internal_Percentage(x$4$2$31);
    return $n(x$4$33).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$294 = new $c_sjsr_AnonFunction1(((x$1$2$144) => {
    var x$1$146 = $as_Lscalacss_internal_ValueT(x$1$2$144);
    return $n(x$1$146)
  }));
  var bc$113 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$294);
  var r$126 = $n(ab$113).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$113);
  var v$300 = $n(r$126).apply__O__Lscalacss_internal_ValueT(f$295);
  var v$301 = $n(v$300).Lscalacss_internal_ValueT__f_value;
  var $$x918 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x919).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2737.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$301)));
  var $$x917 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2739 = $m_Lscalacss_internal_Attrs$overflowY$();
  var v$302 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$303 = v$302.Lscalacss_internal_Literal__f_value;
  var array$220 = [$$x921, $$x920, $$x918, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x917).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2739.Lscalacss_internal_Attrs$overflowY$__f_attr, v$303)))];
  this.Lcom_iz2use_react_style_Style__f_verticalLayout = $n($$x922).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$220), c);
  var $$x930 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "horizontalLayout");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$226 = this.Lcom_iz2use_react_style_Style__f_flex1;
  var $$x929 = new $c_Lscalacss_internal_DslBase$ToStyle(x$226);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$227 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x928 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$227).Lscalacss_internal_StyleA__f_style);
  var $$x927 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2746 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x926 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x927).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2746.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x925 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2755 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$114 = 100;
  var f$297 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$114);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$114 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$32) => {
    var x$4$34 = $as_Lscalacss_internal_Percentage(x$4$2$32);
    return $n(x$4$34).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$296 = new $c_sjsr_AnonFunction1(((x$1$2$145) => {
    var x$1$147 = $as_Lscalacss_internal_ValueT(x$1$2$145);
    return $n(x$1$147)
  }));
  var bc$114 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$296);
  var r$127 = $n(ab$114).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$114);
  var v$304 = $n(r$127).apply__O__Lscalacss_internal_ValueT(f$297);
  var v$305 = $n(v$304).Lscalacss_internal_ValueT__f_value;
  var $$x924 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x925).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2755.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$305)));
  var $$x923 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2757 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$306 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$307 = v$306.Lscalacss_internal_Literal__f_value;
  var array$221 = [$$x929, $$x928, $$x926, $$x924, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x923).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2757.Lscalacss_internal_Attrs$overflowX$__f_attr, v$307)))];
  this.Lcom_iz2use_react_style_Style__f_horizontalLayout = $n($$x930).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$221), c);
  var $$x968 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "button");
  var $$x967 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2762 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var $$x966 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x967).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2762.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")));
  var $$x965 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x964 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$115 = 0.5;
  var u$84 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$299 = new $c_Lscalacss_internal_Length(this$$115, u$84);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$115 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$81) => {
    var x$3$82 = $as_Lscalacss_internal_Length(x$3$2$81);
    return $n(x$3$82).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$298 = new $c_sjsr_AnonFunction1(((x$1$2$146) => {
    var x$1$148 = $as_Lscalacss_internal_ValueT(x$1$2$146);
    return $n(x$1$148)
  }));
  var bc$115 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$298);
  var r$128 = $n(ab$115).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$115);
  var $$x963 = $n(r$128).apply__O__Lscalacss_internal_ValueT(f$299);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$116 = 0.25;
  var u$85 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$301 = new $c_Lscalacss_internal_Length(this$$116, u$85);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$116 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$82) => {
    var x$3$83 = $as_Lscalacss_internal_Length(x$3$2$82);
    return $n(x$3$83).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$300 = new $c_sjsr_AnonFunction1(((x$1$2$147) => {
    var x$1$149 = $as_Lscalacss_internal_ValueT(x$1$2$147);
    return $n(x$1$149)
  }));
  var bc$116 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$300);
  var r$129 = $n(ab$116).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$116);
  var $$x962 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x965).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x964.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x963, $n(r$129).apply__O__Lscalacss_internal_ValueT(f$301))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$308 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var this$2780 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$308);
  var colors$21 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$21 = $m_Lcom_iz2use_react_style_OpacityLevel$medium$();
  var $$x958 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6(this$2780, colors$21, opacity$21);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$309 = $m_Lscalacss_internal_Attrs$color$();
  var this$2782 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$309);
  var colors$22 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$22 = $m_Lcom_iz2use_react_style_OpacityLevel$medium$();
  var array$222 = [$$x958, new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$2782, colors$22, opacity$22)];
  var t$89 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$222);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$302 = new $c_sjsr_AnonFunction1(((x$1$2$148) => {
    var x$1$150 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$148);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$150).light__Lscalacss_internal_AV()))
  }));
  var t$90 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$89, f$302));
  var x$228 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$90, c);
  var $$x961 = new $c_Lscalacss_internal_DslBase$ToStyle(x$228);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x960 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2790 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2791 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2790.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x959 = $n($n($$x960).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$2791), new $c_sjsr_AnonFunction1(((x$2$33) => {
    var x$229 = $as_Lscalacss_internal_Media$Query(x$2$33);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$229)
  }))));
  var f$303 = new $c_sjsr_AnonFunction1(((x$2$2$2$27) => {
    var x$2$2$32 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$27);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$32).dark__Lscalacss_internal_AV()))
  }));
  var x$230 = $n($$x959).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$89, f$303)), c);
  var array$223 = [$$x961, new $c_Lscalacss_internal_DslBase$ToStyle(x$230)];
  var t$91 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$223);
  var x$231 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$91, c);
  var $$x957 = new $c_Lscalacss_internal_DslBase$ToStyle(x$231);
  var $$x956 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2799 = $m_Lscalacss_internal_Attrs$border$();
  var $$x955 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x956).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2799.Lscalacss_internal_Attrs$border$__f_attr, "0")));
  var this$2810 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$117 = 0.5;
  var u$86 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$305 = new $c_Lscalacss_internal_Length(this$$117, u$86);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$117 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$83) => {
    var x$3$84 = $as_Lscalacss_internal_Length(x$3$2$83);
    return $n(x$3$84).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$304 = new $c_sjsr_AnonFunction1(((x$1$2$149) => {
    var x$1$151 = $as_Lscalacss_internal_ValueT(x$1$2$149);
    return $n(x$1$151)
  }));
  var bc$117 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$304);
  var r$130 = $n(ab$117).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$117);
  var radius$8 = $n(r$130).apply__O__Lscalacss_internal_ValueT(f$305);
  var v$310 = $n(radius$8).Lscalacss_internal_ValueT__f_value;
  var x$232 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$310);
  var $$x954 = new $c_Lscalacss_internal_DslBase$ToStyle(this$2810.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$232.av__Lscalacss_internal_AV()));
  var $$x953 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2812 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x952 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x953).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2812.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "transparent")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$233 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x951 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$233).Lscalacss_internal_StyleA__f_style);
  var $$x950 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2815 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x949 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x950).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2815.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x948 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2817 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var $$x947 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x948).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2817.Lscalacss_internal_Attrs$justifyContent$__f_attr, "center")));
  var $$x946 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2819 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x945 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x946).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2819.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
  var $$x944 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$37 = $m_Lscalacss_internal_Attrs$().transition__Lscalacss_internal_Attr();
  var $$x943 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x944).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$37, "background-color 0.3s ease")));
  var $$x942 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2824 = $m_Lscalacss_internal_Attrs$cursor$();
  var $$x941 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x942).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2824.Lscalacss_internal_Attrs$cursor$__f_attr, "pointer")));
  var $$x940 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2826 = $m_Lscalacss_internal_Attrs$userSelect$();
  var v$311 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$312 = v$311.Lscalacss_internal_Literal__f_value;
  var $$x939 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x940).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2826.Lscalacss_internal_Attrs$userSelect$__f_attr, v$312)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x938 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$2827 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p$3 = $m_Lscalacss_internal_Pseudo$Hover$();
  var $$x937 = this$2827.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p$3);
  var this$2829 = $m_s_$less$colon$less$();
  var $$x936 = $n($n($$x938).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x937, this$2829.s_$less$colon$less$__f_singleton));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$313 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var qual$1 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$313);
  var x$1$152 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var x$2$2$33 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var $$x932 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$6(qual$1, x$1$152, x$2$2$33);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$314 = $m_Lscalacss_internal_Attrs$color$();
  var qual$2 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$314);
  var x$3$4$1 = $n(theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var x$4$4$1 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$224 = [$$x932, new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$2, x$3$4$1, x$4$4$1)];
  var t$92 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$224);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$306 = new $c_sjsr_AnonFunction1(((x$1$2$150) => {
    var x$1$153 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$150);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$153).light__Lscalacss_internal_AV()))
  }));
  var t$93 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$92, f$306));
  var x$234 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$93, c);
  var $$x935 = new $c_Lscalacss_internal_DslBase$ToStyle(x$234);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x934 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2838 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2839 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2838.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x933 = $n($n($$x934).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$2839), new $c_sjsr_AnonFunction1(((x$2$34) => {
    var x$235 = $as_Lscalacss_internal_Media$Query(x$2$34);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$235)
  }))));
  var f$307 = new $c_sjsr_AnonFunction1(((x$2$2$2$28) => {
    var x$2$2$34 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$28);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$34).dark__Lscalacss_internal_AV()))
  }));
  var x$236 = $n($$x933).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$92, f$307)), c);
  var array$225 = [$$x935, new $c_Lscalacss_internal_DslBase$ToStyle(x$236)];
  var t$94 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$225);
  var x$237 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$94, c);
  var $$x931 = new $c_Lscalacss_internal_DslBase$ToStyle(x$237);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$238 = $n($n($n(md).Elevation__Lcom_iz2use_react_style_MaterialDesign$Elevation$()).Button__Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$()).pressedStyle__Lscalacss_internal_StyleS();
  var array$226 = [$$x931, new $c_Lscalacss_internal_DslBase$ToStyle(x$238)];
  var x$239 = $n($$x936).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$226), c);
  var array$227 = [$$x966, $$x962, $$x957, $$x955, $$x954, $$x952, $$x951, $$x949, $$x947, $$x945, $$x943, $$x941, $$x939, new $c_Lscalacss_internal_DslBase$ToStyle(x$239)];
  this.Lcom_iz2use_react_style_Style__f_button = $n($$x968).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$227), c);
  var $$x994 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "dialogContainerWrapper");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x993 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2855 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x992 = $n($n($$x993).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2855.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$49$2) => {
    var x$49$1 = $as_Lscalacss_internal_Media$Query(x$49$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$49$1)
  }))));
  var $$x991 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2857 = $m_Lscalacss_internal_Attrs$position$();
  var $$x990 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x991).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2857.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x989 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2867 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$118 = 0;
  var u$87 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$309 = new $c_Lscalacss_internal_Length(this$$118, u$87);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$118 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$84) => {
    var x$3$85 = $as_Lscalacss_internal_Length(x$3$2$84);
    return $n(x$3$85).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$308 = new $c_sjsr_AnonFunction1(((x$1$2$151) => {
    var x$1$154 = $as_Lscalacss_internal_ValueT(x$1$2$151);
    return $n(x$1$154)
  }));
  var bc$118 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$308);
  var r$131 = $n(ab$118).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$118);
  var v$315 = $n(r$131).apply__O__Lscalacss_internal_ValueT(f$309);
  var v$316 = $n(v$315).Lscalacss_internal_ValueT__f_value;
  var $$x988 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x989).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2867.Lscalacss_internal_Attrs$left$__f_attr, v$316)));
  var $$x987 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2877 = $m_Lscalacss_internal_Attrs$right$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$119 = 0;
  var u$88 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$311 = new $c_Lscalacss_internal_Length(this$$119, u$88);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$119 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$85) => {
    var x$3$86 = $as_Lscalacss_internal_Length(x$3$2$85);
    return $n(x$3$86).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$310 = new $c_sjsr_AnonFunction1(((x$1$2$152) => {
    var x$1$155 = $as_Lscalacss_internal_ValueT(x$1$2$152);
    return $n(x$1$155)
  }));
  var bc$119 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$310);
  var r$132 = $n(ab$119).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$119);
  var v$317 = $n(r$132).apply__O__Lscalacss_internal_ValueT(f$311);
  var v$318 = $n(v$317).Lscalacss_internal_ValueT__f_value;
  var $$x986 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x987).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2877.Lscalacss_internal_Attrs$right$__f_attr, v$318)));
  var $$x985 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2887 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$120 = 0;
  var u$89 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$313 = new $c_Lscalacss_internal_Length(this$$120, u$89);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$120 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$86) => {
    var x$3$87 = $as_Lscalacss_internal_Length(x$3$2$86);
    return $n(x$3$87).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$312 = new $c_sjsr_AnonFunction1(((x$1$2$153) => {
    var x$1$156 = $as_Lscalacss_internal_ValueT(x$1$2$153);
    return $n(x$1$156)
  }));
  var bc$120 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$312);
  var r$133 = $n(ab$120).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$120);
  var v$319 = $n(r$133).apply__O__Lscalacss_internal_ValueT(f$313);
  var v$320 = $n(v$319).Lscalacss_internal_ValueT__f_value;
  var $$x984 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x985).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2887.Lscalacss_internal_Attrs$top$__f_attr, v$320)));
  var $$x983 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2897 = $m_Lscalacss_internal_Attrs$bottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$121 = 0;
  var u$90 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$315 = new $c_Lscalacss_internal_Length(this$$121, u$90);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$121 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$87) => {
    var x$3$88 = $as_Lscalacss_internal_Length(x$3$2$87);
    return $n(x$3$88).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$314 = new $c_sjsr_AnonFunction1(((x$1$2$154) => {
    var x$1$157 = $as_Lscalacss_internal_ValueT(x$1$2$154);
    return $n(x$1$157)
  }));
  var bc$121 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$314);
  var r$134 = $n(ab$121).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$121);
  var v$321 = $n(r$134).apply__O__Lscalacss_internal_ValueT(f$315);
  var v$322 = $n(v$321).Lscalacss_internal_ValueT__f_value;
  var $$x982 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x983).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2897.Lscalacss_internal_Attrs$bottom$__f_attr, v$322)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$240 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x981 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$240).Lscalacss_internal_StyleA__f_style);
  var $$x980 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2900 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var $$x979 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x980).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2900.Lscalacss_internal_Attrs$justifyContent$__f_attr, "center")));
  var $$x978 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2902 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x977 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x978).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2902.Lscalacss_internal_Attrs$alignItems$__f_attr, "center")));
  var $$x976 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2907 = $m_Lscalacss_internal_Attrs$zIndex$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$135 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$5$2$7) => {
    var x$5$9 = $uI(x$5$2$7);
    return ("" + x$5$9)
  })));
  var v$323 = $n(r$135).apply__O__Lscalacss_internal_ValueT(999);
  var v$324 = $n(v$323).Lscalacss_internal_ValueT__f_value;
  var $$x975 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x976).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2907.Lscalacss_internal_Attrs$zIndex$__f_attr, v$324)));
  var $$x974 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x973 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$38 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$228 = [$$x990, $$x988, $$x986, $$x984, $$x982, $$x981, $$x979, $$x977, $$x975, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x974).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x973).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$38, "#000000aa")))];
  var x$241 = $n($$x992).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$228), c);
  var $$x972 = new $c_Lscalacss_internal_DslBase$ToStyle(x$241);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x971 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2915 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x970 = $n($n($$x971).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2915.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$50$2) => {
    var x$50$1 = $as_Lscalacss_internal_Media$Query(x$50$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$50$1)
  }))));
  var $$x969 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2917 = $m_Lscalacss_internal_Attrs$display$();
  var v$325 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$326 = v$325.Lscalacss_internal_Literal__f_value;
  var array$229 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x969).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2917.Lscalacss_internal_Attrs$display$__f_attr, v$326)))];
  var x$242 = $n($$x970).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$229), c);
  var array$230 = [$$x972, new $c_Lscalacss_internal_DslBase$ToStyle(x$242)];
  this.Lcom_iz2use_react_style_Style__f_dialogContainerWrapper = $n($$x994).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$230), c);
  var $$x1017 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "dialogContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$327 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var qual$5 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$327);
  var x$11$4 = $n(theme).Lcom_iz2use_react_style_Theme__f_background;
  var x$12$4 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$231 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$5, x$11$4, x$12$4)];
  var t$95 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$231);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$316 = new $c_sjsr_AnonFunction1(((x$1$2$155) => {
    var x$1$158 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$155);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$158).light__Lscalacss_internal_AV()))
  }));
  var t$96 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$95, f$316));
  var x$243 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$96, c);
  var $$x1016 = new $c_Lscalacss_internal_DslBase$ToStyle(x$243);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1015 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2933 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2934 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2933.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x1014 = $n($n($$x1015).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$2934), new $c_sjsr_AnonFunction1(((x$2$35) => {
    var x$244 = $as_Lscalacss_internal_Media$Query(x$2$35);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$244)
  }))));
  var f$317 = new $c_sjsr_AnonFunction1(((x$2$2$2$29) => {
    var x$2$2$35 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$29);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$35).dark__Lscalacss_internal_AV()))
  }));
  var x$245 = $n($$x1014).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$95, f$317)), c);
  var array$232 = [$$x1016, new $c_Lscalacss_internal_DslBase$ToStyle(x$245)];
  var t$97 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$232);
  var x$246 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$97, c);
  var $$x1013 = new $c_Lscalacss_internal_DslBase$ToStyle(x$246);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1012 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2942 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x1011 = $n($n($$x1012).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2942.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$51$2) => {
    var x$51$1 = $as_Lscalacss_internal_Media$Query(x$51$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$51$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$247 = this.Lcom_iz2use_react_style_Style__f_flexColumn;
  var $$x1010 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$247).Lscalacss_internal_StyleA__f_style);
  var $$x1009 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2952 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$122 = 100;
  var f$319 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$122);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$122 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$33) => {
    var x$4$35 = $as_Lscalacss_internal_Percentage(x$4$2$33);
    return $n(x$4$35).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$318 = new $c_sjsr_AnonFunction1(((x$1$2$156) => {
    var x$1$159 = $as_Lscalacss_internal_ValueT(x$1$2$156);
    return $n(x$1$159)
  }));
  var bc$122 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$318);
  var r$136 = $n(ab$122).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$122);
  var v$328 = $n(r$136).apply__O__Lscalacss_internal_ValueT(f$319);
  var v$329 = $n(v$328).Lscalacss_internal_ValueT__f_value;
  var $$x1008 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1009).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2952.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$329)));
  var $$x1007 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2961 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$123 = 80;
  var f$321 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$123);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$123 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$34) => {
    var x$4$36 = $as_Lscalacss_internal_Percentage(x$4$2$34);
    return $n(x$4$36).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$320 = new $c_sjsr_AnonFunction1(((x$1$2$157) => {
    var x$1$160 = $as_Lscalacss_internal_ValueT(x$1$2$157);
    return $n(x$1$160)
  }));
  var bc$123 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$320);
  var r$137 = $n(ab$123).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$123);
  var v$330 = $n(r$137).apply__O__Lscalacss_internal_ValueT(f$321);
  var v$331 = $n(v$330).Lscalacss_internal_ValueT__f_value;
  var $$x1006 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1007).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2961.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$331)));
  var $$x1005 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2970 = $m_Lscalacss_internal_Attrs$minWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$124 = 50;
  var f$323 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$124);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$124 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$35) => {
    var x$4$37 = $as_Lscalacss_internal_Percentage(x$4$2$35);
    return $n(x$4$37).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$322 = new $c_sjsr_AnonFunction1(((x$1$2$158) => {
    var x$1$161 = $as_Lscalacss_internal_ValueT(x$1$2$158);
    return $n(x$1$161)
  }));
  var bc$124 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$322);
  var r$138 = $n(ab$124).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$124);
  var v$332 = $n(r$138).apply__O__Lscalacss_internal_ValueT(f$323);
  var v$333 = $n(v$332).Lscalacss_internal_ValueT__f_value;
  var $$x1004 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1005).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2970.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$333)));
  var $$x1003 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2972 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$334 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$335 = v$334.Lscalacss_internal_Literal__f_value;
  var $$x1002 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1003).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2972.Lscalacss_internal_Attrs$overflow$__f_attr, v$335)));
  var $$x1001 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2982 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$125 = 1;
  var u$91 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$325 = new $c_Lscalacss_internal_Length(this$$125, u$91);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$125 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$88) => {
    var x$3$89 = $as_Lscalacss_internal_Length(x$3$2$88);
    return $n(x$3$89).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$324 = new $c_sjsr_AnonFunction1(((x$1$2$159) => {
    var x$1$162 = $as_Lscalacss_internal_ValueT(x$1$2$159);
    return $n(x$1$162)
  }));
  var bc$125 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$324);
  var r$139 = $n(ab$125).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$125);
  var all$8 = $n(r$139).apply__O__Lscalacss_internal_ValueT(f$325);
  var v$336 = $n(all$8).Lscalacss_internal_ValueT__f_value;
  var $$x1000 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1001).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2982.Lscalacss_internal_Attrs$padding$__f_attr, v$336)));
  var $$x999 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2984 = $m_Lscalacss_internal_Attrs$boxSizing$();
  var array$233 = [$$x1010, $$x1008, $$x1006, $$x1004, $$x1002, $$x1000, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x999).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2984.Lscalacss_internal_Attrs$boxSizing$__f_attr, "border-box")))];
  var x$248 = $n($$x1011).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$233), c);
  var $$x998 = new $c_Lscalacss_internal_DslBase$ToStyle(x$248);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x997 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2990 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2991 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2990.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x996 = $n($n($$x997).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__portrait__O(this$2991), new $c_sjsr_AnonFunction1(((x$52$2) => {
    var x$52$1 = $as_Lscalacss_internal_Media$Query(x$52$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$52$1)
  }))));
  var $$x995 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3000 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$126 = 100;
  var f$327 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$126);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$126 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$36) => {
    var x$4$38 = $as_Lscalacss_internal_Percentage(x$4$2$36);
    return $n(x$4$38).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$326 = new $c_sjsr_AnonFunction1(((x$1$2$160) => {
    var x$1$163 = $as_Lscalacss_internal_ValueT(x$1$2$160);
    return $n(x$1$163)
  }));
  var bc$126 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$326);
  var r$140 = $n(ab$126).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$126);
  var v$337 = $n(r$140).apply__O__Lscalacss_internal_ValueT(f$327);
  var v$338 = $n(v$337).Lscalacss_internal_ValueT__f_value;
  var array$234 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x995).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3000.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$338)))];
  var x$249 = $n($$x996).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$234), c);
  var array$235 = [$$x1013, $$x998, new $c_Lscalacss_internal_DslBase$ToStyle(x$249)];
  this.Lcom_iz2use_react_style_Style__f_dialogContainer = $n($$x1017).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$235), c);
  var $$x1026 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "dialogHeader");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$250 = this.Lcom_iz2use_react_style_Style__f_flexRow;
  var $$x1025 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$250).Lscalacss_internal_StyleA__f_style);
  var $$x1024 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3017 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$127 = 120;
  var f$329 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$127);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$127 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$37) => {
    var x$4$39 = $as_Lscalacss_internal_Percentage(x$4$2$37);
    return $n(x$4$39).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$328 = new $c_sjsr_AnonFunction1(((x$1$2$161) => {
    var x$1$164 = $as_Lscalacss_internal_ValueT(x$1$2$161);
    return $n(x$1$164)
  }));
  var bc$127 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$328);
  var r$141 = $n(ab$127).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$127);
  var v$339 = $n(r$141).apply__O__Lscalacss_internal_ValueT(f$329);
  var v$340 = $n(v$339).Lscalacss_internal_ValueT__f_value;
  var $$x1023 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1024).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3017.Lscalacss_internal_Attrs$fontSize$__f_attr, v$340)));
  var $$x1022 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3019 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var $$x1021 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1022).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3019.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bolder")));
  var $$x1020 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3021 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x1019 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1020).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3021.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x1018 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3023 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var array$236 = [$$x1025, $$x1023, $$x1021, $$x1019, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1018).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3023.Lscalacss_internal_Attrs$justifyContent$__f_attr, "space-between")))];
  this.Lcom_iz2use_react_style_Style__f_dialogHeader = $n($$x1026).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$236), c);
  this.Lcom_iz2use_react_style_Style__f_dialogClose = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "dialogClose").apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($m_sci_Nil$(), c);
  var $$x1030 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1029 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3028 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x1028 = $n($n($$x1029).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$3028.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$53$2) => {
    var x$53$1 = $as_Lscalacss_internal_Media$Query(x$53$2);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$53$1)
  }))));
  var $$x1027 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3030 = $m_Lscalacss_internal_Attrs$outline$();
  var array$237 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1027).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3030.Lscalacss_internal_Attrs$outline$__f_attr, "0")))];
  var x$251 = $n($$x1028).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$237), c);
  var array$238 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$251)];
  $n($$x1030).unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("*:focus", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$238), c);
  var $$x1039 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes(this, "skeletonPulses");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$128 = 0;
  var self = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$128);
  var $$x1037 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle(this);
  var $$x1036 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3045 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$142 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$7$2$1) => {
    var x$7$5 = $uD(x$7$2$1);
    return ("" + x$7$5)
  })));
  var v$341 = $n(r$142).apply__O__Lscalacss_internal_ValueT(0.6);
  var v$342 = $n(v$341).Lscalacss_internal_ValueT__f_value;
  var array$239 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1036).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3045.Lscalacss_internal_Attrs$opacity$__f_attr, v$342)))];
  var y = $n($$x1037).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$239), c);
  var $$x1038 = $ct_T2__O__O__(new $c_T2(), self, y);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$129 = 50;
  var self$1 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$129);
  var $$x1034 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle(this);
  var $$x1033 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3057 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$143 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$7$2$2) => {
    var x$7$6 = $uD(x$7$2$2);
    return ("" + x$7$6)
  })));
  var v$343 = $n(r$143).apply__O__Lscalacss_internal_ValueT(1.0);
  var v$344 = $n(v$343).Lscalacss_internal_ValueT__f_value;
  var array$240 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1033).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3057.Lscalacss_internal_Attrs$opacity$__f_attr, v$344)))];
  var y$1 = $n($$x1034).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$240), c);
  var $$x1035 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$130 = 100;
  var self$2 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$130);
  var $$x1032 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle(this);
  var $$x1031 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3069 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$144 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$7$2$3) => {
    var x$7$7 = $uD(x$7$2$3);
    return ("" + x$7$7)
  })));
  var v$345 = $n(r$144).apply__O__Lscalacss_internal_ValueT(0.6);
  var v$346 = $n(v$345).Lscalacss_internal_ValueT__f_value;
  var array$241 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1031).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3069.Lscalacss_internal_Attrs$opacity$__f_attr, v$346)))];
  var y$2 = $n($$x1032).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$241), c);
  var array$242 = [$$x1038, $$x1035, $ct_T2__O__O__(new $c_T2(), self$2, y$2)];
  this.Lcom_iz2use_react_style_Style__f_skeletonPulses = $n($$x1039).apply__sci_Seq__Lscalacss_internal_Keyframes($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$242));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1057 = new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $m_Lscalacss_internal_Attrs$animationName$()).apply__Lscalacss_internal_Keyframes__Lscalacss_internal_AV(this.Lcom_iz2use_react_style_Style__f_skeletonPulses)));
  var $$x1056 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1055 = $m_Lscalacss_internal_Attrs$animationDelay$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3080 = new $c_s_concurrent_duration_package$DurationInt(0);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$$131 = this$3080.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var length = new $c_RTLong(this$$131, (this$$131 >> 31));
  var f$330 = new $c_s_concurrent_duration_FiniteDuration(length, unit);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$145 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((d$2) => {
    var d = $as_s_concurrent_duration_FiniteDuration(d$2);
    var x1 = $n(d).s_concurrent_duration_FiniteDuration__f_unit;
    var x$252 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$252 === null)) {
      var $$x1053 = (x1 === null)
    } else {
      var this$3085 = $n(x$252);
      var $$x1053 = (this$3085 === x1)
    };
    if ($$x1053) {
      var $$x1052 = true
    } else {
      var x$3$90 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$3$90 === null)) {
        var $$x1054 = (x1 === null)
      } else {
        var this$3086 = $n(x$3$90);
        var $$x1054 = (this$3086 === x1)
      };
      if ($$x1054) {
        var $$x1052 = true
      } else {
        var x$5$10 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
        if ((x$5$10 === null)) {
          var $$x1052 = (x1 === null)
        } else {
          var this$3087 = $n(x$5$10);
          var $$x1052 = (this$3087 === x1)
        }
      }
    };
    if ($$x1052) {
      var this$3088 = $n(d);
      var this$3089 = $n(this$3088.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$3088.s_concurrent_duration_FiniteDuration__f_length);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$3089.RTLong__f_lo, this$3089.RTLong__f_hi) + "ms")
    } else {
      var this$3090 = $n(d);
      var this$3091 = $n(this$3090.s_concurrent_duration_FiniteDuration__f_unit).toSeconds__J__J(this$3090.s_concurrent_duration_FiniteDuration__f_length);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$3091.RTLong__f_lo, this$3091.RTLong__f_hi) + "s")
    }
  })));
  var $$x1051 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1056).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x1055.apply__Lscalacss_internal_ValueT__sci_Seq__Lscalacss_internal_AV($n(r$145).apply__O__Lscalacss_internal_ValueT(f$330), $m_sci_Nil$())));
  var $$x1050 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3094 = $m_Lscalacss_internal_Attrs$animationTimingFunction$();
  var v$347 = $m_Lscalacss_internal_Literal$Typed$easeOut$();
  var v$348 = v$347.Lscalacss_internal_Literal__f_value;
  var $$x1049 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1050).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3094.Lscalacss_internal_Attrs$animationTimingFunction$__f_attr, v$348)));
  var $$x1048 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1047 = $m_Lscalacss_internal_Attrs$animationDuration$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3097 = new $c_s_concurrent_duration_package$DurationDouble(1.5);
  var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var f$331 = $m_s_concurrent_duration_package$DurationDouble$().durationIn$extension__D__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this$3097.s_concurrent_duration_package$DurationDouble__f_scala$concurrent$duration$DurationDouble$$d, unit$1);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$146 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((d$2$1) => {
    var d$1 = $as_s_concurrent_duration_FiniteDuration(d$2$1);
    var x1$1 = $n(d$1).s_concurrent_duration_FiniteDuration__f_unit;
    var x$253 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$253 === null)) {
      var $$x1045 = (x1$1 === null)
    } else {
      var this$3099 = $n(x$253);
      var $$x1045 = (this$3099 === x1$1)
    };
    if ($$x1045) {
      var $$x1044 = true
    } else {
      var x$3$91 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$3$91 === null)) {
        var $$x1046 = (x1$1 === null)
      } else {
        var this$3100 = $n(x$3$91);
        var $$x1046 = (this$3100 === x1$1)
      };
      if ($$x1046) {
        var $$x1044 = true
      } else {
        var x$5$11 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
        if ((x$5$11 === null)) {
          var $$x1044 = (x1$1 === null)
        } else {
          var this$3101 = $n(x$5$11);
          var $$x1044 = (this$3101 === x1$1)
        }
      }
    };
    if ($$x1044) {
      var this$3102 = $n(d$1);
      var this$3103 = $n(this$3102.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$3102.s_concurrent_duration_FiniteDuration__f_length);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$3103.RTLong__f_lo, this$3103.RTLong__f_hi) + "ms")
    } else {
      var this$3104 = $n(d$1);
      var this$3105 = $n(this$3104.s_concurrent_duration_FiniteDuration__f_unit).toSeconds__J__J(this$3104.s_concurrent_duration_FiniteDuration__f_length);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$3105.RTLong__f_lo, this$3105.RTLong__f_hi) + "s")
    }
  })));
  var $$x1043 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1048).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x1047.apply__Lscalacss_internal_ValueT__sci_Seq__Lscalacss_internal_AV($n(r$146).apply__O__Lscalacss_internal_ValueT(f$331), $m_sci_Nil$())));
  var $$x1042 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3108 = $m_Lscalacss_internal_Attrs$animationIterationCount$();
  var $$x1041 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1042).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3108.Lscalacss_internal_Attrs$animationIterationCount$__f_attr, "infinite")));
  var $$x1040 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3110 = $m_Lscalacss_internal_Attrs$animationDirection$();
  var array$243 = [$$x1057, $$x1051, $$x1049, $$x1043, $$x1041, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1040).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3110.Lscalacss_internal_Attrs$animationDirection$__f_attr, "alternate")))];
  var t$98 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$243);
  this.Lcom_iz2use_react_style_Style__f_skeletonPulseAnimationMixin = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$98, c);
  var $$x1064 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "skeletonText");
  var $$x1063 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3116 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x1062 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1063).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3116.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "grey")));
  var $$x1061 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3126 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$132 = 0.5;
  var u$92 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$333 = new $c_Lscalacss_internal_Length(this$$132, u$92);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$128 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$89) => {
    var x$3$92 = $as_Lscalacss_internal_Length(x$3$2$89);
    return $n(x$3$92).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$332 = new $c_sjsr_AnonFunction1(((x$1$2$162) => {
    var x$1$165 = $as_Lscalacss_internal_ValueT(x$1$2$162);
    return $n(x$1$165)
  }));
  var bc$128 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$332);
  var r$147 = $n(ab$128).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$128);
  var v$349 = $n(r$147).apply__O__Lscalacss_internal_ValueT(f$333);
  var v$350 = $n(v$349).Lscalacss_internal_ValueT__f_value;
  var $$x1060 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1061).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3126.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$350)));
  var $$x1059 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3136 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$133 = 0.25;
  var u$93 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$335 = new $c_Lscalacss_internal_Length(this$$133, u$93);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$129 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$90) => {
    var x$3$93 = $as_Lscalacss_internal_Length(x$3$2$90);
    return $n(x$3$93).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$334 = new $c_sjsr_AnonFunction1(((x$1$2$163) => {
    var x$1$166 = $as_Lscalacss_internal_ValueT(x$1$2$163);
    return $n(x$1$166)
  }));
  var bc$129 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$334);
  var r$148 = $n(ab$129).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$129);
  var all$9 = $n(r$148).apply__O__Lscalacss_internal_ValueT(f$335);
  var v$351 = $n(all$9).Lscalacss_internal_ValueT__f_value;
  var $$x1058 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1059).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3136.Lscalacss_internal_Attrs$margin$__f_attr, v$351)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$254 = this.Lcom_iz2use_react_style_Style__f_skeletonPulseAnimationMixin;
  var array$244 = [$$x1062, $$x1060, $$x1058, new $c_Lscalacss_internal_DslBase$ToStyle(x$254)];
  this.Lcom_iz2use_react_style_Style__f_skeletonText = $n($$x1064).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$244), c)
}
$c_Lcom_iz2use_react_style_Style.prototype = new $h_Lscalacss_internal_mutable_StyleSheet$Inline();
$c_Lcom_iz2use_react_style_Style.prototype.constructor = $c_Lcom_iz2use_react_style_Style;
/** @constructor */
function $h_Lcom_iz2use_react_style_Style() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_Style.prototype = $c_Lcom_iz2use_react_style_Style.prototype;
$c_Lcom_iz2use_react_style_Style.prototype.columnSize__sci_Range__F1__Lscalacss_internal_Style$UnsafeExt = (function(range, f) {
  var $$x1 = $m_s_Predef$();
  var this$1 = $n(range);
  $n($$x1).require__Z__V((!this$1.sci_Range__f_isEmpty));
  var this$4 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var x = $n(this$3.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$());
  var x$1 = $as_Lscalacss_internal_Media$Query(x);
  var $$x2 = new $c_Lscalacss_internal_DslBase$DslCond($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$1), this$4);
  var array = [$as_Lscalacss_internal_DslBase$ToStyle($n(f).apply__O__O($n(range).head__I()))];
  var head = $$x2.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), this.Lcom_iz2use_react_style_Style__f_c);
  var this$8 = $n($n(range).tail__sci_Range());
  this$8.scala$collection$immutable$Range$$validateMaxLength__V();
  var b = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
  var it = this$8.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$19 = $n(b);
    var arg1 = $n(it).next__O();
    var column = $uI(arg1);
    var this$15 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$10 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var this$14 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$10.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
    $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var a = Math.imul(18, column);
    var u = $m_Lscalacss_internal_LengthUnit$em$();
    var v = new $c_Lscalacss_internal_Length(a, u);
    var x$2 = $f_Lscalacss_internal_Media$FeatureOps__minWidth__Lscalacss_internal_Length__O(this$14, v);
    var x$3 = $as_Lscalacss_internal_Media$Query(x$2);
    var $$x3 = new $c_Lscalacss_internal_DslBase$DslCond($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$3), this$15);
    var array$1 = [$as_Lscalacss_internal_DslBase$ToStyle($n(f).apply__O__O(column))];
    var elem = $$x3.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), this.Lcom_iz2use_react_style_Style__f_c);
    this$19.addOne__O__scm_Growable(elem)
  };
  var tail = $as_sci_IndexedSeq($n(b).result__O());
  var this$20 = $n(tail);
  var lst = $as_sci_IndexedSeq(this$20.prepended__O__O(head));
  var this$27 = $n(lst);
  var this$23 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$22 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var x$4 = $n(this$22.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$());
  var x$3$1 = $as_Lscalacss_internal_Media$Query(x$4);
  var $$x4 = new $c_Lscalacss_internal_DslBase$DslCond($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$3$1), this$23);
  var array$2 = [$as_Lscalacss_internal_DslBase$ToStyle($n(f).apply__O__O($n(range).last__I()))];
  var elem$1 = $$x4.apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), this.Lcom_iz2use_react_style_Style__f_c);
  var lstWithPrint = $as_sci_IndexedSeq(this$27.appended__O__O(elem$1));
  var this$29 = $n(lstWithPrint);
  var f$1 = ((x$1$2, x$2$2$2) => {
    var x$1$1 = $as_Lscalacss_internal_StyleS(x$1$2);
    var x$2$2 = $as_Lscalacss_internal_StyleS(x$2$2$2);
    var this$28 = $n(x$1$1);
    var c = this.Lcom_iz2use_react_style_Style__f_c;
    return $n(c).apply__Lscalacss_internal_StyleS__Lscalacss_internal_StyleS__Lscalacss_internal_StyleS(this$28, x$2$2)
  });
  if ((this$29.length__I() > 0)) {
    var z = this$29.apply__I__O(0);
    var at = 1;
    var end = this$29.length__I();
    var acc = z;
    var $$x5;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1$1 = acc;
        var arg2 = this$29.apply__I__O(at);
        var temp$acc = f$1(arg1$1, arg2);
        at = temp$at;
        acc = temp$acc;
        continue
      };
      var $$x5 = acc;
      break
    }
  } else if ((this$29.length__I() === 0)) {
    var $$x5;
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
  } else {
    var it$1 = this$29.iterator__sc_Iterator();
    if ((!$n(it$1).hasNext__Z())) {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
    };
    var acc$1 = $n(it$1).next__O();
    while ($n(it$1).hasNext__Z()) {
      var arg1$2 = acc$1;
      var arg2$1 = $n(it$1).next__O();
      acc$1 = f$1(arg1$2, arg2$1)
    };
    var $$x5 = acc$1
  };
  var r = $as_Lscalacss_internal_StyleS($$x5);
  var $$x7 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x6 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4$1 = $as_T(x$4$2);
    return x$4$1
  }));
  var array$3 = [new $c_Lscalacss_internal_DslBase$ToStyle(($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), r))];
  return $n($$x7).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), this.Lcom_iz2use_react_style_Style__f_c)
});
$c_Lcom_iz2use_react_style_Style.prototype.image__Z__Lscalacss_internal_StyleS = (function(full) {
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x5 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-position");
  var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x5).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "50% 50%")));
  var $$x3 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$1 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-size");
  var value = (full ? "cover" : "contain");
  var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x3).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, value)));
  var $$x1 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$2 = $m_Lscalacss_internal_Attrs$backgroundRepeat$();
  var array = [$$x4, $$x2, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$2.Lscalacss_internal_Attrs$backgroundRepeat$__f_attr, "no-repeat")))];
  var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var c = this.Lcom_iz2use_react_style_Style__f_c;
  return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c)
});
function $as_Lcom_iz2use_react_style_Style(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_style_Style) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.style.Style"))
}
function $isArrayOf_Lcom_iz2use_react_style_Style(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_style_Style)))
}
function $asArrayOf_Lcom_iz2use_react_style_Style(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_style_Style(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.style.Style;", depth))
}
var $d_Lcom_iz2use_react_style_Style = new $TypeData().initClass({
  Lcom_iz2use_react_style_Style: 0
}, false, "com.iz2use.react.style.Style", {
  Lcom_iz2use_react_style_Style: 1,
  Lscalacss_internal_mutable_StyleSheet$Inline: 1,
  Lscalacss_internal_mutable_StyleSheet$Base: 1,
  O: 1,
  Lscalacss_internal_Macros$Dsl$Mixin: 1,
  Lcom_iz2use_react_style_package$WithThemedSupport: 1
});
$c_Lcom_iz2use_react_style_Style.prototype.$classData = $d_Lcom_iz2use_react_style_Style;
/** @constructor */
function $c_Ldiode_ActionResult$NoChange$() {
  /*<skip>*/
}
$c_Ldiode_ActionResult$NoChange$.prototype = new $h_O();
$c_Ldiode_ActionResult$NoChange$.prototype.constructor = $c_Ldiode_ActionResult$NoChange$;
/** @constructor */
function $h_Ldiode_ActionResult$NoChange$() {
  /*<skip>*/
}
$h_Ldiode_ActionResult$NoChange$.prototype = $c_Ldiode_ActionResult$NoChange$.prototype;
$c_Ldiode_ActionResult$NoChange$.prototype.newModelOpt__s_Option = (function() {
  return $m_s_None$()
});
$c_Ldiode_ActionResult$NoChange$.prototype.effectOpt__s_Option = (function() {
  return $m_s_None$()
});
$c_Ldiode_ActionResult$NoChange$.prototype.productPrefix__T = (function() {
  return "NoChange"
});
$c_Ldiode_ActionResult$NoChange$.prototype.productArity__I = (function() {
  return 0
});
$c_Ldiode_ActionResult$NoChange$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ldiode_ActionResult$NoChange$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_ActionResult$NoChange$.prototype.hashCode__I = (function() {
  return 246111473
});
$c_Ldiode_ActionResult$NoChange$.prototype.toString__T = (function() {
  return "NoChange"
});
var $d_Ldiode_ActionResult$NoChange$ = new $TypeData().initClass({
  Ldiode_ActionResult$NoChange$: 0
}, false, "diode.ActionResult$NoChange$", {
  Ldiode_ActionResult$NoChange$: 1,
  O: 1,
  Ldiode_ActionResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_ActionResult$NoChange$.prototype.$classData = $d_Ldiode_ActionResult$NoChange$;
var $n_Ldiode_ActionResult$NoChange$;
function $m_Ldiode_ActionResult$NoChange$() {
  if ((!$n_Ldiode_ActionResult$NoChange$)) {
    $n_Ldiode_ActionResult$NoChange$ = new $c_Ldiode_ActionResult$NoChange$()
  };
  return $n_Ldiode_ActionResult$NoChange$
}
/** @constructor */
function $c_Ldiode_Circuit$$anonfun$dispatchBase$2(outer, action$5) {
  this.Ldiode_Circuit$$anonfun$dispatchBase$2__f_$outer = null;
  this.Ldiode_Circuit$$anonfun$dispatchBase$2__f_action$5 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ldiode_Circuit$$anonfun$dispatchBase$2__f_$outer = outer
  };
  this.Ldiode_Circuit$$anonfun$dispatchBase$2__f_action$5 = action$5
}
$c_Ldiode_Circuit$$anonfun$dispatchBase$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Ldiode_Circuit$$anonfun$dispatchBase$2.prototype.constructor = $c_Ldiode_Circuit$$anonfun$dispatchBase$2;
/** @constructor */
function $h_Ldiode_Circuit$$anonfun$dispatchBase$2() {
  /*<skip>*/
}
$h_Ldiode_Circuit$$anonfun$dispatchBase$2.prototype = $c_Ldiode_Circuit$$anonfun$dispatchBase$2.prototype;
$c_Ldiode_Circuit$$anonfun$dispatchBase$2.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var this$1 = $n(this.Ldiode_Circuit$$anonfun$dispatchBase$2__f_$outer);
    var action = this.Ldiode_Circuit$$anonfun$dispatchBase$2__f_action$5;
    $f_Ldiode_Circuit__handleEffectProcessingError__O__jl_Throwable__V(this$1, action, x1);
    return (void 0)
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$2.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return (x1 !== null)
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Ldiode_Circuit$$anonfun$dispatchBase$2 = new $TypeData().initClass({
  Ldiode_Circuit$$anonfun$dispatchBase$2: 0
}, false, "diode.Circuit$$anonfun$dispatchBase$2", {
  Ldiode_Circuit$$anonfun$dispatchBase$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$2.prototype.$classData = $d_Ldiode_Circuit$$anonfun$dispatchBase$2;
/** @constructor */
function $c_Ldiode_Circuit$$anonfun$dispatchBase$4(outer, action$5) {
  this.Ldiode_Circuit$$anonfun$dispatchBase$4__f_$outer = null;
  this.Ldiode_Circuit$$anonfun$dispatchBase$4__f_action$5 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ldiode_Circuit$$anonfun$dispatchBase$4__f_$outer = outer
  };
  this.Ldiode_Circuit$$anonfun$dispatchBase$4__f_action$5 = action$5
}
$c_Ldiode_Circuit$$anonfun$dispatchBase$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Ldiode_Circuit$$anonfun$dispatchBase$4.prototype.constructor = $c_Ldiode_Circuit$$anonfun$dispatchBase$4;
/** @constructor */
function $h_Ldiode_Circuit$$anonfun$dispatchBase$4() {
  /*<skip>*/
}
$h_Ldiode_Circuit$$anonfun$dispatchBase$4.prototype = $c_Ldiode_Circuit$$anonfun$dispatchBase$4.prototype;
$c_Ldiode_Circuit$$anonfun$dispatchBase$4.prototype.applyOrElse__jl_Throwable__F1__O = (function(x2, default$1) {
  if ((x2 !== null)) {
    var this$1 = $n(this.Ldiode_Circuit$$anonfun$dispatchBase$4__f_$outer);
    var action = this.Ldiode_Circuit$$anonfun$dispatchBase$4__f_action$5;
    $f_Ldiode_Circuit__handleEffectProcessingError__O__jl_Throwable__V(this$1, action, x2);
    return (void 0)
  } else {
    return $n(default$1).apply__O__O(x2)
  }
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$4.prototype.isDefinedAt__jl_Throwable__Z = (function(x2) {
  return (x2 !== null)
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Ldiode_Circuit$$anonfun$dispatchBase$4 = new $TypeData().initClass({
  Ldiode_Circuit$$anonfun$dispatchBase$4: 0
}, false, "diode.Circuit$$anonfun$dispatchBase$4", {
  Ldiode_Circuit$$anonfun$dispatchBase$4: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$4.prototype.$classData = $d_Ldiode_Circuit$$anonfun$dispatchBase$4;
/** @constructor */
function $c_Ldiode_Circuit$$anonfun$dispatchBase$6(outer, action$5) {
  this.Ldiode_Circuit$$anonfun$dispatchBase$6__f_$outer = null;
  this.Ldiode_Circuit$$anonfun$dispatchBase$6__f_action$5 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ldiode_Circuit$$anonfun$dispatchBase$6__f_$outer = outer
  };
  this.Ldiode_Circuit$$anonfun$dispatchBase$6__f_action$5 = action$5
}
$c_Ldiode_Circuit$$anonfun$dispatchBase$6.prototype = new $h_sr_AbstractPartialFunction();
$c_Ldiode_Circuit$$anonfun$dispatchBase$6.prototype.constructor = $c_Ldiode_Circuit$$anonfun$dispatchBase$6;
/** @constructor */
function $h_Ldiode_Circuit$$anonfun$dispatchBase$6() {
  /*<skip>*/
}
$h_Ldiode_Circuit$$anonfun$dispatchBase$6.prototype = $c_Ldiode_Circuit$$anonfun$dispatchBase$6.prototype;
$c_Ldiode_Circuit$$anonfun$dispatchBase$6.prototype.applyOrElse__jl_Throwable__F1__O = (function(x3, default$1) {
  if ((x3 !== null)) {
    var this$1 = $n(this.Ldiode_Circuit$$anonfun$dispatchBase$6__f_$outer);
    var action = this.Ldiode_Circuit$$anonfun$dispatchBase$6__f_action$5;
    $f_Ldiode_Circuit__handleEffectProcessingError__O__jl_Throwable__V(this$1, action, x3);
    return (void 0)
  } else {
    return $n(default$1).apply__O__O(x3)
  }
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$6.prototype.isDefinedAt__jl_Throwable__Z = (function(x3) {
  return (x3 !== null)
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$6.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$6.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Ldiode_Circuit$$anonfun$dispatchBase$6 = new $TypeData().initClass({
  Ldiode_Circuit$$anonfun$dispatchBase$6: 0
}, false, "diode.Circuit$$anonfun$dispatchBase$6", {
  Ldiode_Circuit$$anonfun$dispatchBase$6: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_Circuit$$anonfun$dispatchBase$6.prototype.$classData = $d_Ldiode_Circuit$$anonfun$dispatchBase$6;
/** @constructor */
function $c_Ldiode_NoAction$() {
  /*<skip>*/
}
$c_Ldiode_NoAction$.prototype = new $h_O();
$c_Ldiode_NoAction$.prototype.constructor = $c_Ldiode_NoAction$;
/** @constructor */
function $h_Ldiode_NoAction$() {
  /*<skip>*/
}
$h_Ldiode_NoAction$.prototype = $c_Ldiode_NoAction$.prototype;
$c_Ldiode_NoAction$.prototype.productPrefix__T = (function() {
  return "NoAction"
});
$c_Ldiode_NoAction$.prototype.productArity__I = (function() {
  return 0
});
$c_Ldiode_NoAction$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ldiode_NoAction$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_NoAction$.prototype.hashCode__I = (function() {
  return 184797047
});
$c_Ldiode_NoAction$.prototype.toString__T = (function() {
  return "NoAction"
});
var $d_Ldiode_NoAction$ = new $TypeData().initClass({
  Ldiode_NoAction$: 0
}, false, "diode.NoAction$", {
  Ldiode_NoAction$: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_NoAction$.prototype.$classData = $d_Ldiode_NoAction$;
var $n_Ldiode_NoAction$;
function $m_Ldiode_NoAction$() {
  if ((!$n_Ldiode_NoAction$)) {
    $n_Ldiode_NoAction$ = new $c_Ldiode_NoAction$()
  };
  return $n_Ldiode_NoAction$
}
/** @constructor */
function $c_Ldiode_data_Empty$() {
  /*<skip>*/
}
$c_Ldiode_data_Empty$.prototype = new $h_Ldiode_data_Pot();
$c_Ldiode_data_Empty$.prototype.constructor = $c_Ldiode_data_Empty$;
/** @constructor */
function $h_Ldiode_data_Empty$() {
  /*<skip>*/
}
$h_Ldiode_data_Empty$.prototype = $c_Ldiode_data_Empty$.prototype;
$c_Ldiode_data_Empty$.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Empty.get")
});
$c_Ldiode_data_Empty$.prototype.isEmpty__Z = (function() {
  return true
});
$c_Ldiode_data_Empty$.prototype.isPending__Z = (function() {
  return false
});
$c_Ldiode_data_Empty$.prototype.isFailed__Z = (function() {
  return false
});
$c_Ldiode_data_Empty$.prototype.isStale__Z = (function() {
  return false
});
$c_Ldiode_data_Empty$.prototype.pending$default$1__J = (function() {
  var this$2 = $ct_ju_Date__(new $c_ju_Date());
  return this$2.ju_Date__f_java$util$Date$$millis
});
$c_Ldiode_data_Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_Ldiode_data_Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_Ldiode_data_Empty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ldiode_data_Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_Empty$.prototype.hashCode__I = (function() {
  return 67081517
});
$c_Ldiode_data_Empty$.prototype.toString__T = (function() {
  return "Empty"
});
$c_Ldiode_data_Empty$.prototype.fail__jl_Throwable__Ldiode_data_Pot = (function(exception) {
  return new $c_Ldiode_data_Failed(exception)
});
$c_Ldiode_data_Empty$.prototype.pending__J__Ldiode_data_Pot = (function(startTime) {
  return new $c_Ldiode_data_Pending(startTime)
});
$c_Ldiode_data_Empty$.prototype.state__Ldiode_data_PotState = (function() {
  return $m_Ldiode_data_PotState$PotEmpty$()
});
$c_Ldiode_data_Empty$.prototype.get__O = (function() {
  this.get__E()
});
var $d_Ldiode_data_Empty$ = new $TypeData().initClass({
  Ldiode_data_Empty$: 0
}, false, "diode.data.Empty$", {
  Ldiode_data_Empty$: 1,
  Ldiode_data_Pot: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_data_Empty$.prototype.$classData = $d_Ldiode_data_Empty$;
var $n_Ldiode_data_Empty$;
function $m_Ldiode_data_Empty$() {
  if ((!$n_Ldiode_data_Empty$)) {
    $n_Ldiode_data_Empty$ = new $c_Ldiode_data_Empty$()
  };
  return $n_Ldiode_data_Empty$
}
/** @constructor */
function $c_Ldiode_data_PotState$PotEmpty$() {
  /*<skip>*/
}
$c_Ldiode_data_PotState$PotEmpty$.prototype = new $h_O();
$c_Ldiode_data_PotState$PotEmpty$.prototype.constructor = $c_Ldiode_data_PotState$PotEmpty$;
/** @constructor */
function $h_Ldiode_data_PotState$PotEmpty$() {
  /*<skip>*/
}
$h_Ldiode_data_PotState$PotEmpty$.prototype = $c_Ldiode_data_PotState$PotEmpty$.prototype;
$c_Ldiode_data_PotState$PotEmpty$.prototype.productPrefix__T = (function() {
  return "PotEmpty"
});
$c_Ldiode_data_PotState$PotEmpty$.prototype.productArity__I = (function() {
  return 0
});
$c_Ldiode_data_PotState$PotEmpty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ldiode_data_PotState$PotEmpty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_PotState$PotEmpty$.prototype.hashCode__I = (function() {
  return 807629848
});
$c_Ldiode_data_PotState$PotEmpty$.prototype.toString__T = (function() {
  return "PotEmpty"
});
var $d_Ldiode_data_PotState$PotEmpty$ = new $TypeData().initClass({
  Ldiode_data_PotState$PotEmpty$: 0
}, false, "diode.data.PotState$PotEmpty$", {
  Ldiode_data_PotState$PotEmpty$: 1,
  O: 1,
  Ldiode_data_PotState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_data_PotState$PotEmpty$.prototype.$classData = $d_Ldiode_data_PotState$PotEmpty$;
var $n_Ldiode_data_PotState$PotEmpty$;
function $m_Ldiode_data_PotState$PotEmpty$() {
  if ((!$n_Ldiode_data_PotState$PotEmpty$)) {
    $n_Ldiode_data_PotState$PotEmpty$ = new $c_Ldiode_data_PotState$PotEmpty$()
  };
  return $n_Ldiode_data_PotState$PotEmpty$
}
/** @constructor */
function $c_Ldiode_data_PotState$PotFailed$() {
  /*<skip>*/
}
$c_Ldiode_data_PotState$PotFailed$.prototype = new $h_O();
$c_Ldiode_data_PotState$PotFailed$.prototype.constructor = $c_Ldiode_data_PotState$PotFailed$;
/** @constructor */
function $h_Ldiode_data_PotState$PotFailed$() {
  /*<skip>*/
}
$h_Ldiode_data_PotState$PotFailed$.prototype = $c_Ldiode_data_PotState$PotFailed$.prototype;
$c_Ldiode_data_PotState$PotFailed$.prototype.productPrefix__T = (function() {
  return "PotFailed"
});
$c_Ldiode_data_PotState$PotFailed$.prototype.productArity__I = (function() {
  return 0
});
$c_Ldiode_data_PotState$PotFailed$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ldiode_data_PotState$PotFailed$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_PotState$PotFailed$.prototype.hashCode__I = (function() {
  return (-715948334)
});
$c_Ldiode_data_PotState$PotFailed$.prototype.toString__T = (function() {
  return "PotFailed"
});
var $d_Ldiode_data_PotState$PotFailed$ = new $TypeData().initClass({
  Ldiode_data_PotState$PotFailed$: 0
}, false, "diode.data.PotState$PotFailed$", {
  Ldiode_data_PotState$PotFailed$: 1,
  O: 1,
  Ldiode_data_PotState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_data_PotState$PotFailed$.prototype.$classData = $d_Ldiode_data_PotState$PotFailed$;
var $n_Ldiode_data_PotState$PotFailed$;
function $m_Ldiode_data_PotState$PotFailed$() {
  if ((!$n_Ldiode_data_PotState$PotFailed$)) {
    $n_Ldiode_data_PotState$PotFailed$ = new $c_Ldiode_data_PotState$PotFailed$()
  };
  return $n_Ldiode_data_PotState$PotFailed$
}
/** @constructor */
function $c_Ldiode_data_PotState$PotPending$() {
  /*<skip>*/
}
$c_Ldiode_data_PotState$PotPending$.prototype = new $h_O();
$c_Ldiode_data_PotState$PotPending$.prototype.constructor = $c_Ldiode_data_PotState$PotPending$;
/** @constructor */
function $h_Ldiode_data_PotState$PotPending$() {
  /*<skip>*/
}
$h_Ldiode_data_PotState$PotPending$.prototype = $c_Ldiode_data_PotState$PotPending$.prototype;
$c_Ldiode_data_PotState$PotPending$.prototype.productPrefix__T = (function() {
  return "PotPending"
});
$c_Ldiode_data_PotState$PotPending$.prototype.productArity__I = (function() {
  return 0
});
$c_Ldiode_data_PotState$PotPending$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ldiode_data_PotState$PotPending$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_PotState$PotPending$.prototype.hashCode__I = (function() {
  return (-315559518)
});
$c_Ldiode_data_PotState$PotPending$.prototype.toString__T = (function() {
  return "PotPending"
});
var $d_Ldiode_data_PotState$PotPending$ = new $TypeData().initClass({
  Ldiode_data_PotState$PotPending$: 0
}, false, "diode.data.PotState$PotPending$", {
  Ldiode_data_PotState$PotPending$: 1,
  O: 1,
  Ldiode_data_PotState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_data_PotState$PotPending$.prototype.$classData = $d_Ldiode_data_PotState$PotPending$;
var $n_Ldiode_data_PotState$PotPending$;
function $m_Ldiode_data_PotState$PotPending$() {
  if ((!$n_Ldiode_data_PotState$PotPending$)) {
    $n_Ldiode_data_PotState$PotPending$ = new $c_Ldiode_data_PotState$PotPending$()
  };
  return $n_Ldiode_data_PotState$PotPending$
}
/** @constructor */
function $c_Ldiode_data_PotState$PotReady$() {
  /*<skip>*/
}
$c_Ldiode_data_PotState$PotReady$.prototype = new $h_O();
$c_Ldiode_data_PotState$PotReady$.prototype.constructor = $c_Ldiode_data_PotState$PotReady$;
/** @constructor */
function $h_Ldiode_data_PotState$PotReady$() {
  /*<skip>*/
}
$h_Ldiode_data_PotState$PotReady$.prototype = $c_Ldiode_data_PotState$PotReady$.prototype;
$c_Ldiode_data_PotState$PotReady$.prototype.productPrefix__T = (function() {
  return "PotReady"
});
$c_Ldiode_data_PotState$PotReady$.prototype.productArity__I = (function() {
  return 0
});
$c_Ldiode_data_PotState$PotReady$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ldiode_data_PotState$PotReady$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_PotState$PotReady$.prototype.hashCode__I = (function() {
  return 819382382
});
$c_Ldiode_data_PotState$PotReady$.prototype.toString__T = (function() {
  return "PotReady"
});
var $d_Ldiode_data_PotState$PotReady$ = new $TypeData().initClass({
  Ldiode_data_PotState$PotReady$: 0
}, false, "diode.data.PotState$PotReady$", {
  Ldiode_data_PotState$PotReady$: 1,
  O: 1,
  Ldiode_data_PotState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_data_PotState$PotReady$.prototype.$classData = $d_Ldiode_data_PotState$PotReady$;
var $n_Ldiode_data_PotState$PotReady$;
function $m_Ldiode_data_PotState$PotReady$() {
  if ((!$n_Ldiode_data_PotState$PotReady$)) {
    $n_Ldiode_data_PotState$PotReady$ = new $c_Ldiode_data_PotState$PotReady$()
  };
  return $n_Ldiode_data_PotState$PotReady$
}
/** @constructor */
function $c_Ldiode_data_PotState$PotUnavailable$() {
  /*<skip>*/
}
$c_Ldiode_data_PotState$PotUnavailable$.prototype = new $h_O();
$c_Ldiode_data_PotState$PotUnavailable$.prototype.constructor = $c_Ldiode_data_PotState$PotUnavailable$;
/** @constructor */
function $h_Ldiode_data_PotState$PotUnavailable$() {
  /*<skip>*/
}
$h_Ldiode_data_PotState$PotUnavailable$.prototype = $c_Ldiode_data_PotState$PotUnavailable$.prototype;
$c_Ldiode_data_PotState$PotUnavailable$.prototype.productPrefix__T = (function() {
  return "PotUnavailable"
});
$c_Ldiode_data_PotState$PotUnavailable$.prototype.productArity__I = (function() {
  return 0
});
$c_Ldiode_data_PotState$PotUnavailable$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ldiode_data_PotState$PotUnavailable$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_PotState$PotUnavailable$.prototype.hashCode__I = (function() {
  return (-1201847589)
});
$c_Ldiode_data_PotState$PotUnavailable$.prototype.toString__T = (function() {
  return "PotUnavailable"
});
var $d_Ldiode_data_PotState$PotUnavailable$ = new $TypeData().initClass({
  Ldiode_data_PotState$PotUnavailable$: 0
}, false, "diode.data.PotState$PotUnavailable$", {
  Ldiode_data_PotState$PotUnavailable$: 1,
  O: 1,
  Ldiode_data_PotState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_data_PotState$PotUnavailable$.prototype.$classData = $d_Ldiode_data_PotState$PotUnavailable$;
var $n_Ldiode_data_PotState$PotUnavailable$;
function $m_Ldiode_data_PotState$PotUnavailable$() {
  if ((!$n_Ldiode_data_PotState$PotUnavailable$)) {
    $n_Ldiode_data_PotState$PotUnavailable$ = new $c_Ldiode_data_PotState$PotUnavailable$()
  };
  return $n_Ldiode_data_PotState$PotUnavailable$
}
/** @constructor */
function $c_Ldiode_data_Ready(x) {
  this.Ldiode_data_Ready__f_x = null;
  this.Ldiode_data_Ready__f_x = x
}
$c_Ldiode_data_Ready.prototype = new $h_Ldiode_data_Pot();
$c_Ldiode_data_Ready.prototype.constructor = $c_Ldiode_data_Ready;
/** @constructor */
function $h_Ldiode_data_Ready() {
  /*<skip>*/
}
$h_Ldiode_data_Ready.prototype = $c_Ldiode_data_Ready.prototype;
$c_Ldiode_data_Ready.prototype.get__O = (function() {
  return this.Ldiode_data_Ready__f_x
});
$c_Ldiode_data_Ready.prototype.isEmpty__Z = (function() {
  return false
});
$c_Ldiode_data_Ready.prototype.isPending__Z = (function() {
  return false
});
$c_Ldiode_data_Ready.prototype.isFailed__Z = (function() {
  return false
});
$c_Ldiode_data_Ready.prototype.isStale__Z = (function() {
  return false
});
$c_Ldiode_data_Ready.prototype.pending$default$1__J = (function() {
  var this$2 = $ct_ju_Date__(new $c_ju_Date());
  return this$2.ju_Date__f_java$util$Date$$millis
});
$c_Ldiode_data_Ready.prototype.productPrefix__T = (function() {
  return "Ready"
});
$c_Ldiode_data_Ready.prototype.productArity__I = (function() {
  return 1
});
$c_Ldiode_data_Ready.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ldiode_data_Ready__f_x : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ldiode_data_Ready.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_Ready.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiode_data_Ready.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_data_Ready.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ldiode_data_Ready)) {
    var Ready$1 = $as_Ldiode_data_Ready(x$1);
    var x = this.Ldiode_data_Ready__f_x;
    var y = $n(Ready$1).Ldiode_data_Ready__f_x;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Ldiode_data_Ready.prototype.fail__jl_Throwable__Ldiode_data_Pot = (function(exception) {
  return new $c_Ldiode_data_FailedStale(this.Ldiode_data_Ready__f_x, exception)
});
$c_Ldiode_data_Ready.prototype.pending__J__Ldiode_data_Pot = (function(startTime) {
  return new $c_Ldiode_data_PendingStale(this.Ldiode_data_Ready__f_x, startTime)
});
$c_Ldiode_data_Ready.prototype.state__Ldiode_data_PotState = (function() {
  return $m_Ldiode_data_PotState$PotReady$()
});
function $as_Ldiode_data_Ready(obj) {
  return (((obj instanceof $c_Ldiode_data_Ready) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.data.Ready"))
}
function $isArrayOf_Ldiode_data_Ready(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_data_Ready)))
}
function $asArrayOf_Ldiode_data_Ready(obj, depth) {
  return (($isArrayOf_Ldiode_data_Ready(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.data.Ready;", depth))
}
var $d_Ldiode_data_Ready = new $TypeData().initClass({
  Ldiode_data_Ready: 0
}, false, "diode.data.Ready", {
  Ldiode_data_Ready: 1,
  Ldiode_data_Pot: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_data_Ready.prototype.$classData = $d_Ldiode_data_Ready;
/** @constructor */
function $c_Ldiode_data_Unavailable$() {
  /*<skip>*/
}
$c_Ldiode_data_Unavailable$.prototype = new $h_Ldiode_data_Pot();
$c_Ldiode_data_Unavailable$.prototype.constructor = $c_Ldiode_data_Unavailable$;
/** @constructor */
function $h_Ldiode_data_Unavailable$() {
  /*<skip>*/
}
$h_Ldiode_data_Unavailable$.prototype = $c_Ldiode_data_Unavailable$.prototype;
$c_Ldiode_data_Unavailable$.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Unavailable.get")
});
$c_Ldiode_data_Unavailable$.prototype.isEmpty__Z = (function() {
  return true
});
$c_Ldiode_data_Unavailable$.prototype.isPending__Z = (function() {
  return false
});
$c_Ldiode_data_Unavailable$.prototype.isFailed__Z = (function() {
  return true
});
$c_Ldiode_data_Unavailable$.prototype.isStale__Z = (function() {
  return false
});
$c_Ldiode_data_Unavailable$.prototype.pending$default$1__J = (function() {
  var this$2 = $ct_ju_Date__(new $c_ju_Date());
  return this$2.ju_Date__f_java$util$Date$$millis
});
$c_Ldiode_data_Unavailable$.prototype.productPrefix__T = (function() {
  return "Unavailable"
});
$c_Ldiode_data_Unavailable$.prototype.productArity__I = (function() {
  return 0
});
$c_Ldiode_data_Unavailable$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ldiode_data_Unavailable$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_Unavailable$.prototype.hashCode__I = (function() {
  return 1002405936
});
$c_Ldiode_data_Unavailable$.prototype.toString__T = (function() {
  return "Unavailable"
});
$c_Ldiode_data_Unavailable$.prototype.fail__jl_Throwable__Ldiode_data_Pot = (function(exception) {
  return new $c_Ldiode_data_Failed(exception)
});
$c_Ldiode_data_Unavailable$.prototype.pending__J__Ldiode_data_Pot = (function(startTime) {
  return new $c_Ldiode_data_Pending(startTime)
});
$c_Ldiode_data_Unavailable$.prototype.state__Ldiode_data_PotState = (function() {
  return $m_Ldiode_data_PotState$PotUnavailable$()
});
$c_Ldiode_data_Unavailable$.prototype.get__O = (function() {
  this.get__E()
});
var $d_Ldiode_data_Unavailable$ = new $TypeData().initClass({
  Ldiode_data_Unavailable$: 0
}, false, "diode.data.Unavailable$", {
  Ldiode_data_Unavailable$: 1,
  Ldiode_data_Pot: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_data_Unavailable$.prototype.$classData = $d_Ldiode_data_Unavailable$;
var $n_Ldiode_data_Unavailable$;
function $m_Ldiode_data_Unavailable$() {
  if ((!$n_Ldiode_data_Unavailable$)) {
    $n_Ldiode_data_Unavailable$ = new $c_Ldiode_data_Unavailable$()
  };
  return $n_Ldiode_data_Unavailable$
}
/** @constructor */
function $c_Leu_timepit_refined_api_Failed(detail) {
  this.Leu_timepit_refined_api_Failed__f_detail = null;
  this.Leu_timepit_refined_api_Failed__f_detail = detail
}
$c_Leu_timepit_refined_api_Failed.prototype = new $h_Leu_timepit_refined_api_Result();
$c_Leu_timepit_refined_api_Failed.prototype.constructor = $c_Leu_timepit_refined_api_Failed;
/** @constructor */
function $h_Leu_timepit_refined_api_Failed() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_Failed.prototype = $c_Leu_timepit_refined_api_Failed.prototype;
$c_Leu_timepit_refined_api_Failed.prototype.detail__O = (function() {
  return this.Leu_timepit_refined_api_Failed__f_detail
});
$c_Leu_timepit_refined_api_Failed.prototype.productPrefix__T = (function() {
  return "Failed"
});
$c_Leu_timepit_refined_api_Failed.prototype.productArity__I = (function() {
  return 1
});
$c_Leu_timepit_refined_api_Failed.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Leu_timepit_refined_api_Failed__f_detail : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Leu_timepit_refined_api_Failed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Leu_timepit_refined_api_Failed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Leu_timepit_refined_api_Failed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Leu_timepit_refined_api_Failed.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Leu_timepit_refined_api_Failed)) {
    var Failed$1 = $as_Leu_timepit_refined_api_Failed(x$1);
    var x = this.Leu_timepit_refined_api_Failed__f_detail;
    var y = $n(Failed$1).Leu_timepit_refined_api_Failed__f_detail;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Leu_timepit_refined_api_Failed(obj) {
  return (((obj instanceof $c_Leu_timepit_refined_api_Failed) || (obj === null)) ? obj : $throwClassCastException(obj, "eu.timepit.refined.api.Failed"))
}
function $isArrayOf_Leu_timepit_refined_api_Failed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Leu_timepit_refined_api_Failed)))
}
function $asArrayOf_Leu_timepit_refined_api_Failed(obj, depth) {
  return (($isArrayOf_Leu_timepit_refined_api_Failed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Leu.timepit.refined.api.Failed;", depth))
}
var $d_Leu_timepit_refined_api_Failed = new $TypeData().initClass({
  Leu_timepit_refined_api_Failed: 0
}, false, "eu.timepit.refined.api.Failed", {
  Leu_timepit_refined_api_Failed: 1,
  Leu_timepit_refined_api_Result: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_Failed.prototype.$classData = $d_Leu_timepit_refined_api_Failed;
/** @constructor */
function $c_Leu_timepit_refined_api_Passed(detail) {
  this.Leu_timepit_refined_api_Passed__f_detail = null;
  this.Leu_timepit_refined_api_Passed__f_detail = detail
}
$c_Leu_timepit_refined_api_Passed.prototype = new $h_Leu_timepit_refined_api_Result();
$c_Leu_timepit_refined_api_Passed.prototype.constructor = $c_Leu_timepit_refined_api_Passed;
/** @constructor */
function $h_Leu_timepit_refined_api_Passed() {
  /*<skip>*/
}
$h_Leu_timepit_refined_api_Passed.prototype = $c_Leu_timepit_refined_api_Passed.prototype;
$c_Leu_timepit_refined_api_Passed.prototype.detail__O = (function() {
  return this.Leu_timepit_refined_api_Passed__f_detail
});
$c_Leu_timepit_refined_api_Passed.prototype.productPrefix__T = (function() {
  return "Passed"
});
$c_Leu_timepit_refined_api_Passed.prototype.productArity__I = (function() {
  return 1
});
$c_Leu_timepit_refined_api_Passed.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Leu_timepit_refined_api_Passed__f_detail : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Leu_timepit_refined_api_Passed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Leu_timepit_refined_api_Passed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Leu_timepit_refined_api_Passed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Leu_timepit_refined_api_Passed.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Leu_timepit_refined_api_Passed)) {
    var Passed$1 = $as_Leu_timepit_refined_api_Passed(x$1);
    var x = this.Leu_timepit_refined_api_Passed__f_detail;
    var y = $n(Passed$1).Leu_timepit_refined_api_Passed__f_detail;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Leu_timepit_refined_api_Passed(obj) {
  return (((obj instanceof $c_Leu_timepit_refined_api_Passed) || (obj === null)) ? obj : $throwClassCastException(obj, "eu.timepit.refined.api.Passed"))
}
function $isArrayOf_Leu_timepit_refined_api_Passed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Leu_timepit_refined_api_Passed)))
}
function $asArrayOf_Leu_timepit_refined_api_Passed(obj, depth) {
  return (($isArrayOf_Leu_timepit_refined_api_Passed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Leu.timepit.refined.api.Passed;", depth))
}
var $d_Leu_timepit_refined_api_Passed = new $TypeData().initClass({
  Leu_timepit_refined_api_Passed: 0
}, false, "eu.timepit.refined.api.Passed", {
  Leu_timepit_refined_api_Passed: 1,
  Leu_timepit_refined_api_Result: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Leu_timepit_refined_api_Passed.prototype.$classData = $d_Leu_timepit_refined_api_Passed;
function $p_Lfastparse_Implicits$Sequencer$__UnitSequencer0$lzycompute$1__V($thiz) {
  if (($m_Lfastparse_Implicits$Sequencer$().Lfastparse_Implicits$Sequencer$__f_UnitSequencer0$module === null)) {
    $m_Lfastparse_Implicits$Sequencer$().Lfastparse_Implicits$Sequencer$__f_UnitSequencer0$module = new $c_Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$($thiz)
  }
}
/** @constructor */
function $c_Lfastparse_Implicits$Sequencer$() {
  this.Lfastparse_Implicits$Sequencer$__f_UnitSequencer0$module = null;
  this.Lfastparse_Implicits$Sequencer$__f_BaseSequencer2 = null;
  this.Lfastparse_Implicits$Sequencer$__f_BaseSequencer3 = null;
  this.Lfastparse_Implicits$Sequencer$__f_BaseSequencer4 = null;
  this.Lfastparse_Implicits$Sequencer$__f_BaseSequencer5 = null;
  this.Lfastparse_Implicits$Sequencer$__f_BaseSequencer6 = null;
  $n_Lfastparse_Implicits$Sequencer$ = this;
  $f_Lfastparse_SequencerGen__$init$__V(this)
}
$c_Lfastparse_Implicits$Sequencer$.prototype = new $h_O();
$c_Lfastparse_Implicits$Sequencer$.prototype.constructor = $c_Lfastparse_Implicits$Sequencer$;
/** @constructor */
function $h_Lfastparse_Implicits$Sequencer$() {
  /*<skip>*/
}
$h_Lfastparse_Implicits$Sequencer$.prototype = $c_Lfastparse_Implicits$Sequencer$.prototype;
$c_Lfastparse_Implicits$Sequencer$.prototype.UnitSequencer0__Lfastparse_Implicits$LowPriSequencer$UnitSequencer0$ = (function() {
  if (($m_Lfastparse_Implicits$Sequencer$().Lfastparse_Implicits$Sequencer$__f_UnitSequencer0$module === null)) {
    $p_Lfastparse_Implicits$Sequencer$__UnitSequencer0$lzycompute$1__V(this)
  };
  return $m_Lfastparse_Implicits$Sequencer$().Lfastparse_Implicits$Sequencer$__f_UnitSequencer0$module
});
var $d_Lfastparse_Implicits$Sequencer$ = new $TypeData().initClass({
  Lfastparse_Implicits$Sequencer$: 0
}, false, "fastparse.Implicits$Sequencer$", {
  Lfastparse_Implicits$Sequencer$: 1,
  O: 1,
  Lfastparse_Implicits$LowPriSequencer: 1,
  Lfastparse_Implicits$LowerPriSequencer: 1,
  Lfastparse_SequencerGen: 1,
  Lfastparse_LowestPriSequencer: 1
});
$c_Lfastparse_Implicits$Sequencer$.prototype.$classData = $d_Lfastparse_Implicits$Sequencer$;
var $n_Lfastparse_Implicits$Sequencer$;
function $m_Lfastparse_Implicits$Sequencer$() {
  if ((!$n_Lfastparse_Implicits$Sequencer$)) {
    $n_Lfastparse_Implicits$Sequencer$ = new $c_Lfastparse_Implicits$Sequencer$()
  };
  return $n_Lfastparse_Implicits$Sequencer$
}
/** @constructor */
function $c_Lfastparse_Parsed$Success(value, index) {
  this.Lfastparse_Parsed$Success__f_value = null;
  this.Lfastparse_Parsed$Success__f_index = 0;
  this.Lfastparse_Parsed$Success__f_value = value;
  this.Lfastparse_Parsed$Success__f_index = index;
  $ct_Lfastparse_Parsed__Z__(this, true)
}
$c_Lfastparse_Parsed$Success.prototype = new $h_Lfastparse_Parsed();
$c_Lfastparse_Parsed$Success.prototype.constructor = $c_Lfastparse_Parsed$Success;
/** @constructor */
function $h_Lfastparse_Parsed$Success() {
  /*<skip>*/
}
$h_Lfastparse_Parsed$Success.prototype = $c_Lfastparse_Parsed$Success.prototype;
$c_Lfastparse_Parsed$Success.prototype.toString__T = (function() {
  return (((("Parsed.Success(" + this.Lfastparse_Parsed$Success__f_value) + ", ") + this.Lfastparse_Parsed$Success__f_index) + ")")
});
$c_Lfastparse_Parsed$Success.prototype.productPrefix__T = (function() {
  return "Success"
});
$c_Lfastparse_Parsed$Success.prototype.productArity__I = (function() {
  return 2
});
$c_Lfastparse_Parsed$Success.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lfastparse_Parsed$Success__f_value;
      break
    }
    case 1: {
      return this.Lfastparse_Parsed$Success__f_index;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lfastparse_Parsed$Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lfastparse_Parsed$Success.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Success");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lfastparse_Parsed$Success__f_value;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lfastparse_Parsed$Success__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lfastparse_Parsed$Success.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lfastparse_Parsed$Success)) {
    var Success$1 = $as_Lfastparse_Parsed$Success(x$1);
    if ((this.Lfastparse_Parsed$Success__f_index === $n(Success$1).Lfastparse_Parsed$Success__f_index)) {
      var x = this.Lfastparse_Parsed$Success__f_value;
      var y = $n(Success$1).Lfastparse_Parsed$Success__f_value;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lfastparse_Parsed$Success(obj) {
  return (((obj instanceof $c_Lfastparse_Parsed$Success) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.Parsed$Success"))
}
function $isArrayOf_Lfastparse_Parsed$Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_Parsed$Success)))
}
function $asArrayOf_Lfastparse_Parsed$Success(obj, depth) {
  return (($isArrayOf_Lfastparse_Parsed$Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.Parsed$Success;", depth))
}
var $d_Lfastparse_Parsed$Success = new $TypeData().initClass({
  Lfastparse_Parsed$Success: 0
}, false, "fastparse.Parsed$Success", {
  Lfastparse_Parsed$Success: 1,
  Lfastparse_Parsed: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lfastparse_Parsed$Success.prototype.$classData = $d_Lfastparse_Parsed$Success;
/** @constructor */
function $c_Lio_circe_CursorOp$ArrayOp() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$ArrayOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$ArrayOp.prototype.constructor = $c_Lio_circe_CursorOp$ArrayOp;
/** @constructor */
function $h_Lio_circe_CursorOp$ArrayOp() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$ArrayOp.prototype = $c_Lio_circe_CursorOp$ArrayOp.prototype;
$c_Lio_circe_CursorOp$ArrayOp.prototype.requiresObject__Z = (function() {
  return false
});
$c_Lio_circe_CursorOp$ArrayOp.prototype.requiresArray__Z = (function() {
  return true
});
/** @constructor */
function $c_Lio_circe_CursorOp$ObjectOp() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$ObjectOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$ObjectOp.prototype.constructor = $c_Lio_circe_CursorOp$ObjectOp;
/** @constructor */
function $h_Lio_circe_CursorOp$ObjectOp() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$ObjectOp.prototype = $c_Lio_circe_CursorOp$ObjectOp.prototype;
$c_Lio_circe_CursorOp$ObjectOp.prototype.requiresObject__Z = (function() {
  return true
});
$c_Lio_circe_CursorOp$ObjectOp.prototype.requiresArray__Z = (function() {
  return false
});
/** @constructor */
function $c_Lio_circe_CursorOp$Op(op) {
  this.Lio_circe_CursorOp$Op__f_op = null;
  this.Lio_circe_CursorOp$Op__f_op = op
}
$c_Lio_circe_CursorOp$Op.prototype = new $h_O();
$c_Lio_circe_CursorOp$Op.prototype.constructor = $c_Lio_circe_CursorOp$Op;
/** @constructor */
function $h_Lio_circe_CursorOp$Op() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$Op.prototype = $c_Lio_circe_CursorOp$Op.prototype;
$c_Lio_circe_CursorOp$Op.prototype.productPrefix__T = (function() {
  return "Op"
});
$c_Lio_circe_CursorOp$Op.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_CursorOp$Op.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_CursorOp$Op__f_op : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_CursorOp$Op.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$Op.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_CursorOp$Op.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_CursorOp$Op.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_circe_CursorOp$Op)) {
    var Op$1 = $as_Lio_circe_CursorOp$Op(x$1);
    var x = this.Lio_circe_CursorOp$Op__f_op;
    var x$2 = $n(Op$1).Lio_circe_CursorOp$Op__f_op;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Op$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lio_circe_CursorOp$Op(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$Op) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$Op"))
}
function $isArrayOf_Lio_circe_CursorOp$Op(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$Op)))
}
function $asArrayOf_Lio_circe_CursorOp$Op(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$Op(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$Op;", depth))
}
var $d_Lio_circe_CursorOp$Op = new $TypeData().initClass({
  Lio_circe_CursorOp$Op: 0
}, false, "io.circe.CursorOp$Op", {
  Lio_circe_CursorOp$Op: 1,
  O: 1,
  Lio_circe_CursorOp$Selection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$Op.prototype.$classData = $d_Lio_circe_CursorOp$Op;
/** @constructor */
function $c_Lio_circe_CursorOp$SelectField(field) {
  this.Lio_circe_CursorOp$SelectField__f_field = null;
  this.Lio_circe_CursorOp$SelectField__f_field = field
}
$c_Lio_circe_CursorOp$SelectField.prototype = new $h_O();
$c_Lio_circe_CursorOp$SelectField.prototype.constructor = $c_Lio_circe_CursorOp$SelectField;
/** @constructor */
function $h_Lio_circe_CursorOp$SelectField() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$SelectField.prototype = $c_Lio_circe_CursorOp$SelectField.prototype;
$c_Lio_circe_CursorOp$SelectField.prototype.productPrefix__T = (function() {
  return "SelectField"
});
$c_Lio_circe_CursorOp$SelectField.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_CursorOp$SelectField.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_CursorOp$SelectField__f_field : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_CursorOp$SelectField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$SelectField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_CursorOp$SelectField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_CursorOp$SelectField.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_circe_CursorOp$SelectField)) {
    var SelectField$1 = $as_Lio_circe_CursorOp$SelectField(x$1);
    return ((this.Lio_circe_CursorOp$SelectField__f_field === $n(SelectField$1).Lio_circe_CursorOp$SelectField__f_field) && ($n(SelectField$1), true))
  } else {
    return false
  }
});
function $as_Lio_circe_CursorOp$SelectField(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$SelectField) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$SelectField"))
}
function $isArrayOf_Lio_circe_CursorOp$SelectField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$SelectField)))
}
function $asArrayOf_Lio_circe_CursorOp$SelectField(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$SelectField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$SelectField;", depth))
}
var $d_Lio_circe_CursorOp$SelectField = new $TypeData().initClass({
  Lio_circe_CursorOp$SelectField: 0
}, false, "io.circe.CursorOp$SelectField", {
  Lio_circe_CursorOp$SelectField: 1,
  O: 1,
  Lio_circe_CursorOp$Selection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$SelectField.prototype.$classData = $d_Lio_circe_CursorOp$SelectField;
/** @constructor */
function $c_Lio_circe_CursorOp$SelectIndex(index) {
  this.Lio_circe_CursorOp$SelectIndex__f_index = 0;
  this.Lio_circe_CursorOp$SelectIndex__f_index = index
}
$c_Lio_circe_CursorOp$SelectIndex.prototype = new $h_O();
$c_Lio_circe_CursorOp$SelectIndex.prototype.constructor = $c_Lio_circe_CursorOp$SelectIndex;
/** @constructor */
function $h_Lio_circe_CursorOp$SelectIndex() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$SelectIndex.prototype = $c_Lio_circe_CursorOp$SelectIndex.prototype;
$c_Lio_circe_CursorOp$SelectIndex.prototype.productPrefix__T = (function() {
  return "SelectIndex"
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_CursorOp$SelectIndex__f_index : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("SelectIndex");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lio_circe_CursorOp$SelectIndex__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
    var SelectIndex$1 = $as_Lio_circe_CursorOp$SelectIndex(x$1);
    return ((this.Lio_circe_CursorOp$SelectIndex__f_index === $n(SelectIndex$1).Lio_circe_CursorOp$SelectIndex__f_index) && ($n(SelectIndex$1), true))
  } else {
    return false
  }
});
function $as_Lio_circe_CursorOp$SelectIndex(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$SelectIndex) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$SelectIndex"))
}
function $isArrayOf_Lio_circe_CursorOp$SelectIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$SelectIndex)))
}
function $asArrayOf_Lio_circe_CursorOp$SelectIndex(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$SelectIndex(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$SelectIndex;", depth))
}
var $d_Lio_circe_CursorOp$SelectIndex = new $TypeData().initClass({
  Lio_circe_CursorOp$SelectIndex: 0
}, false, "io.circe.CursorOp$SelectIndex", {
  Lio_circe_CursorOp$SelectIndex: 1,
  O: 1,
  Lio_circe_CursorOp$Selection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.$classData = $d_Lio_circe_CursorOp$SelectIndex;
/** @constructor */
function $c_Lio_circe_CursorOp$UnconstrainedOp() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.constructor = $c_Lio_circe_CursorOp$UnconstrainedOp;
/** @constructor */
function $h_Lio_circe_CursorOp$UnconstrainedOp() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$UnconstrainedOp.prototype = $c_Lio_circe_CursorOp$UnconstrainedOp.prototype;
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.requiresObject__Z = (function() {
  return false
});
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.requiresArray__Z = (function() {
  return false
});
/** @constructor */
function $c_Lio_circe_Decoder$$anon$54() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null;
  $ct_Lio_circe_Decoder$JavaTimeDecoder__T__(this, "Instant")
}
$c_Lio_circe_Decoder$$anon$54.prototype = new $h_Lio_circe_Decoder$StandardJavaTimeDecoder();
$c_Lio_circe_Decoder$$anon$54.prototype.constructor = $c_Lio_circe_Decoder$$anon$54;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$54() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$54.prototype = $c_Lio_circe_Decoder$$anon$54.prototype;
$c_Lio_circe_Decoder$$anon$54.prototype.parseUnsafe__T__O = (function(input) {
  return $as_Ljava_time_Instant($n($m_Ljava_time_format_DateTimeFormatter$().ISO_INSTANT__Ljava_time_format_DateTimeFormatter()).parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O(input, new $c_Ljava_time_Instant$$anon$1()))
});
var $d_Lio_circe_Decoder$$anon$54 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$54: 0
}, false, "io.circe.Decoder$$anon$54", {
  Lio_circe_Decoder$$anon$54: 1,
  Lio_circe_Decoder$StandardJavaTimeDecoder: 1,
  Lio_circe_Decoder$JavaTimeDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$54.prototype.$classData = $d_Lio_circe_Decoder$$anon$54;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$67() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null;
  $ct_Lio_circe_Decoder$JavaTimeDecoder__T__(this, "LocalDate")
}
$c_Lio_circe_Decoder$$anon$67.prototype = new $h_Lio_circe_Decoder$StandardJavaTimeDecoder();
$c_Lio_circe_Decoder$$anon$67.prototype.constructor = $c_Lio_circe_Decoder$$anon$67;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$67() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$67.prototype = $c_Lio_circe_Decoder$$anon$67.prototype;
$c_Lio_circe_Decoder$$anon$67.prototype.parseUnsafe__T__O = (function(input) {
  var this$1 = $m_Ljava_time_LocalDate$();
  return this$1.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_LocalDate(input, $m_Ljava_time_format_DateTimeFormatter$().ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter())
});
var $d_Lio_circe_Decoder$$anon$67 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$67: 0
}, false, "io.circe.Decoder$$anon$67", {
  Lio_circe_Decoder$$anon$67: 1,
  Lio_circe_Decoder$StandardJavaTimeDecoder: 1,
  Lio_circe_Decoder$JavaTimeDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$67.prototype.$classData = $d_Lio_circe_Decoder$$anon$67;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$68() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null;
  $ct_Lio_circe_Decoder$JavaTimeDecoder__T__(this, "LocalTime")
}
$c_Lio_circe_Decoder$$anon$68.prototype = new $h_Lio_circe_Decoder$StandardJavaTimeDecoder();
$c_Lio_circe_Decoder$$anon$68.prototype.constructor = $c_Lio_circe_Decoder$$anon$68;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$68() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$68.prototype = $c_Lio_circe_Decoder$$anon$68.prototype;
$c_Lio_circe_Decoder$$anon$68.prototype.parseUnsafe__T__O = (function(input) {
  var this$1 = $m_Ljava_time_LocalTime$();
  return this$1.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_LocalTime(input, $m_Ljava_time_format_DateTimeFormatter$().ISO_LOCAL_TIME__Ljava_time_format_DateTimeFormatter())
});
var $d_Lio_circe_Decoder$$anon$68 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$68: 0
}, false, "io.circe.Decoder$$anon$68", {
  Lio_circe_Decoder$$anon$68: 1,
  Lio_circe_Decoder$StandardJavaTimeDecoder: 1,
  Lio_circe_Decoder$JavaTimeDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$68.prototype.$classData = $d_Lio_circe_Decoder$$anon$68;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$69() {
  this.Lio_circe_Decoder$JavaTimeDecoder__f_name = null;
  $ct_Lio_circe_Decoder$JavaTimeDecoder__T__(this, "LocalDateTime")
}
$c_Lio_circe_Decoder$$anon$69.prototype = new $h_Lio_circe_Decoder$StandardJavaTimeDecoder();
$c_Lio_circe_Decoder$$anon$69.prototype.constructor = $c_Lio_circe_Decoder$$anon$69;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$69() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$69.prototype = $c_Lio_circe_Decoder$$anon$69.prototype;
$c_Lio_circe_Decoder$$anon$69.prototype.parseUnsafe__T__O = (function(input) {
  var this$1 = $m_Ljava_time_LocalDateTime$();
  return this$1.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_LocalDateTime(input, $m_Ljava_time_format_DateTimeFormatter$().ISO_LOCAL_DATE_TIME__Ljava_time_format_DateTimeFormatter())
});
var $d_Lio_circe_Decoder$$anon$69 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$69: 0
}, false, "io.circe.Decoder$$anon$69", {
  Lio_circe_Decoder$$anon$69: 1,
  Lio_circe_Decoder$StandardJavaTimeDecoder: 1,
  Lio_circe_Decoder$JavaTimeDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$$anon$69.prototype.$classData = $d_Lio_circe_Decoder$$anon$69;
function $ct_Lio_circe_DecodingFailure__T__($thiz, message) {
  $thiz.Lio_circe_DecodingFailure__f_message = message;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_Lio_circe_DecodingFailure extends $c_Lio_circe_Error {
  constructor() {
    super();
    this.Lio_circe_DecodingFailure__f_message = null
  };
  getMessage__T() {
    if ($n(this.history__sci_List()).isEmpty__Z()) {
      return this.Lio_circe_DecodingFailure__f_message
    } else {
      var $$x1 = this.Lio_circe_DecodingFailure__f_message;
      var this$1 = $n(this.history__sci_List());
      return (($$x1 + ": ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", ",", ""))
    }
  };
  toString__T() {
    return (((("DecodingFailure(" + this.Lio_circe_DecodingFailure__f_message) + ", ") + this.history__sci_List()) + ")")
  };
  equals__O__Z(that) {
    if ((that instanceof $c_Lio_circe_DecodingFailure)) {
      var x2 = $as_Lio_circe_DecodingFailure(that);
      return $n($m_Lio_circe_DecodingFailure$().Lio_circe_DecodingFailure$__f_eqDecodingFailure).eqv__O__O__Z(this, x2)
    } else {
      return false
    }
  };
  hashCode__I() {
    return $f_T__hashCode__I($n(this.Lio_circe_DecodingFailure__f_message))
  };
}
function $as_Lio_circe_DecodingFailure(obj) {
  return (((obj instanceof $c_Lio_circe_DecodingFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.DecodingFailure"))
}
function $isArrayOf_Lio_circe_DecodingFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_DecodingFailure)))
}
function $asArrayOf_Lio_circe_DecodingFailure(obj, depth) {
  return (($isArrayOf_Lio_circe_DecodingFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.DecodingFailure;", depth))
}
/** @constructor */
function $c_Lio_circe_Encoder$$anon$6() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$6.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$6.prototype.constructor = $c_Lio_circe_Encoder$$anon$6;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$6() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$6.prototype = $c_Lio_circe_Encoder$$anon$6.prototype;
$c_Lio_circe_Encoder$$anon$6.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_Encoder$$anon$6.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  var a$1 = $as_Lio_circe_JsonObject(a);
  return a$1
});
var $d_Lio_circe_Encoder$$anon$6 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$6: 0
}, false, "io.circe.Encoder$$anon$6", {
  Lio_circe_Encoder$$anon$6: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$6.prototype.$classData = $d_Lio_circe_Encoder$$anon$6;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$9() {
  /*<skip>*/
}
$c_Lio_circe_Encoder$$anon$9.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$9.prototype.constructor = $c_Lio_circe_Encoder$$anon$9;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$9() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$9.prototype = $c_Lio_circe_Encoder$$anon$9.prototype;
$c_Lio_circe_Encoder$$anon$9.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_Encoder$$anon$9.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  $as_jl_Void(a);
  return $m_Lio_circe_JsonObject$().Lio_circe_JsonObject$__f_empty
});
var $d_Lio_circe_Encoder$$anon$9 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$9: 0
}, false, "io.circe.Encoder$$anon$9", {
  Lio_circe_Encoder$$anon$9: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$9.prototype.$classData = $d_Lio_circe_Encoder$$anon$9;
/** @constructor */
function $c_Lio_circe_Encoder$AsObject$$anon$65(outer, f$7) {
  this.Lio_circe_Encoder$AsObject$$anon$65__f_$outer = null;
  this.Lio_circe_Encoder$AsObject$$anon$65__f_f$7 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_Encoder$AsObject$$anon$65__f_$outer = outer
  };
  this.Lio_circe_Encoder$AsObject$$anon$65__f_f$7 = f$7
}
$c_Lio_circe_Encoder$AsObject$$anon$65.prototype = new $h_O();
$c_Lio_circe_Encoder$AsObject$$anon$65.prototype.constructor = $c_Lio_circe_Encoder$AsObject$$anon$65;
/** @constructor */
function $h_Lio_circe_Encoder$AsObject$$anon$65() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$AsObject$$anon$65.prototype = $c_Lio_circe_Encoder$AsObject$$anon$65.prototype;
$c_Lio_circe_Encoder$AsObject$$anon$65.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_Encoder$AsObject$$anon$65.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $n(this.Lio_circe_Encoder$AsObject$$anon$65__f_$outer).encodeObject__O__Lio_circe_JsonObject($n(this.Lio_circe_Encoder$AsObject$$anon$65__f_f$7).apply__O__O(a))
});
var $d_Lio_circe_Encoder$AsObject$$anon$65 = new $TypeData().initClass({
  Lio_circe_Encoder$AsObject$$anon$65: 0
}, false, "io.circe.Encoder$AsObject$$anon$65", {
  Lio_circe_Encoder$AsObject$$anon$65: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$AsObject$$anon$65.prototype.$classData = $d_Lio_circe_Encoder$AsObject$$anon$65;
/** @constructor */
function $c_Lio_circe_Encoder$AsObject$$anon$67(f$9) {
  this.Lio_circe_Encoder$AsObject$$anon$67__f_f$9 = null;
  this.Lio_circe_Encoder$AsObject$$anon$67__f_f$9 = f$9
}
$c_Lio_circe_Encoder$AsObject$$anon$67.prototype = new $h_O();
$c_Lio_circe_Encoder$AsObject$$anon$67.prototype.constructor = $c_Lio_circe_Encoder$AsObject$$anon$67;
/** @constructor */
function $h_Lio_circe_Encoder$AsObject$$anon$67() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$AsObject$$anon$67.prototype = $c_Lio_circe_Encoder$AsObject$$anon$67.prototype;
$c_Lio_circe_Encoder$AsObject$$anon$67.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_Encoder$AsObject$$anon$67.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $as_Lio_circe_JsonObject($n(this.Lio_circe_Encoder$AsObject$$anon$67__f_f$9).apply__O__O(a))
});
var $d_Lio_circe_Encoder$AsObject$$anon$67 = new $TypeData().initClass({
  Lio_circe_Encoder$AsObject$$anon$67: 0
}, false, "io.circe.Encoder$AsObject$$anon$67", {
  Lio_circe_Encoder$AsObject$$anon$67: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$AsObject$$anon$67.prototype.$classData = $d_Lio_circe_Encoder$AsObject$$anon$67;
function $ct_Lio_circe_Encoder$IterableAsObjectEncoder__Lio_circe_KeyEncoder__Lio_circe_Encoder__($thiz, encodeK, encodeV) {
  $thiz.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeK = encodeK;
  $thiz.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeV = encodeV;
  return $thiz
}
/** @constructor */
function $c_Lio_circe_Encoder$IterableAsObjectEncoder() {
  this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeK = null;
  this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeV = null
}
$c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype = new $h_O();
$c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype.constructor = $c_Lio_circe_Encoder$IterableAsObjectEncoder;
/** @constructor */
function $h_Lio_circe_Encoder$IterableAsObjectEncoder() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$IterableAsObjectEncoder.prototype = $c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype;
$c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  var builder = new $c_sci_MapBuilderImpl();
  $n($m_s_package$().s_package$__f_Vector);
  var keysBuilder = new $c_sci_VectorBuilder();
  var iterator = this.toIterator__sc_Map__sc_Iterator($as_sc_Map(a));
  while ($n(iterator).hasNext__Z()) {
    var next = $as_T2($n(iterator).next__O());
    var key = $n(this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeK).apply__O__T($n(next)._1__O());
    var _2 = $n(this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeV).apply__O__Lio_circe_Json($n(next)._2__O());
    builder.addOne__O__O__sci_MapBuilderImpl(key, _2);
    keysBuilder.addOne__O__sci_VectorBuilder(key)
  };
  $m_Lio_circe_JsonObject$();
  var map = builder.result__sci_Map();
  var keys = keysBuilder.result__sci_Vector();
  return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject(map, keys)
});
/** @constructor */
function $c_Lio_circe_Json$JArray(value) {
  this.Lio_circe_Json$JArray__f_value = null;
  this.Lio_circe_Json$JArray__f_value = value
}
$c_Lio_circe_Json$JArray.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JArray.prototype.constructor = $c_Lio_circe_Json$JArray;
/** @constructor */
function $h_Lio_circe_Json$JArray() {
  /*<skip>*/
}
$h_Lio_circe_Json$JArray.prototype = $c_Lio_circe_Json$JArray.prototype;
$c_Lio_circe_Json$JArray.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onArray__sci_Vector__O(this.Lio_circe_Json$JArray__f_value)
});
$c_Lio_circe_Json$JArray.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JArray.prototype.isArray__Z = (function() {
  return true
});
$c_Lio_circe_Json$JArray.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JArray.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JArray.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JArray.prototype.productPrefix__T = (function() {
  return "JArray"
});
$c_Lio_circe_Json$JArray.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JArray.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_Json$JArray__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_Json$JArray.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_Json$JArray.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
function $as_Lio_circe_Json$JArray(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JArray) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JArray"))
}
function $isArrayOf_Lio_circe_Json$JArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JArray)))
}
function $asArrayOf_Lio_circe_Json$JArray(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JArray;", depth))
}
var $d_Lio_circe_Json$JArray = new $TypeData().initClass({
  Lio_circe_Json$JArray: 0
}, false, "io.circe.Json$JArray", {
  Lio_circe_Json$JArray: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JArray.prototype.$classData = $d_Lio_circe_Json$JArray;
/** @constructor */
function $c_Lio_circe_Json$JBoolean(value) {
  this.Lio_circe_Json$JBoolean__f_value = false;
  this.Lio_circe_Json$JBoolean__f_value = value
}
$c_Lio_circe_Json$JBoolean.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JBoolean.prototype.constructor = $c_Lio_circe_Json$JBoolean;
/** @constructor */
function $h_Lio_circe_Json$JBoolean() {
  /*<skip>*/
}
$h_Lio_circe_Json$JBoolean.prototype = $c_Lio_circe_Json$JBoolean.prototype;
$c_Lio_circe_Json$JBoolean.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onBoolean__Z__O(this.Lio_circe_Json$JBoolean__f_value)
});
$c_Lio_circe_Json$JBoolean.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JBoolean.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JBoolean.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JBoolean.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JBoolean.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JBoolean.prototype.productPrefix__T = (function() {
  return "JBoolean"
});
$c_Lio_circe_Json$JBoolean.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JBoolean.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_Json$JBoolean__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_Json$JBoolean.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_Json$JBoolean.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("JBoolean");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lio_circe_Json$JBoolean__f_value ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
function $as_Lio_circe_Json$JBoolean(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JBoolean"))
}
function $isArrayOf_Lio_circe_Json$JBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JBoolean)))
}
function $asArrayOf_Lio_circe_Json$JBoolean(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JBoolean;", depth))
}
var $d_Lio_circe_Json$JBoolean = new $TypeData().initClass({
  Lio_circe_Json$JBoolean: 0
}, false, "io.circe.Json$JBoolean", {
  Lio_circe_Json$JBoolean: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JBoolean.prototype.$classData = $d_Lio_circe_Json$JBoolean;
/** @constructor */
function $c_Lio_circe_Json$JNull$() {
  /*<skip>*/
}
$c_Lio_circe_Json$JNull$.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JNull$.prototype.constructor = $c_Lio_circe_Json$JNull$;
/** @constructor */
function $h_Lio_circe_Json$JNull$() {
  /*<skip>*/
}
$h_Lio_circe_Json$JNull$.prototype = $c_Lio_circe_Json$JNull$.prototype;
$c_Lio_circe_Json$JNull$.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onNull__O()
});
$c_Lio_circe_Json$JNull$.prototype.isNull__Z = (function() {
  return true
});
$c_Lio_circe_Json$JNull$.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNull$.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNull$.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JNull$.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JNull$.prototype.productPrefix__T = (function() {
  return "JNull"
});
$c_Lio_circe_Json$JNull$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_Json$JNull$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_circe_Json$JNull$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_Json$JNull$.prototype.hashCode__I = (function() {
  return 70780145
});
var $d_Lio_circe_Json$JNull$ = new $TypeData().initClass({
  Lio_circe_Json$JNull$: 0
}, false, "io.circe.Json$JNull$", {
  Lio_circe_Json$JNull$: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JNull$.prototype.$classData = $d_Lio_circe_Json$JNull$;
var $n_Lio_circe_Json$JNull$;
function $m_Lio_circe_Json$JNull$() {
  if ((!$n_Lio_circe_Json$JNull$)) {
    $n_Lio_circe_Json$JNull$ = new $c_Lio_circe_Json$JNull$()
  };
  return $n_Lio_circe_Json$JNull$
}
/** @constructor */
function $c_Lio_circe_Json$JNumber(value) {
  this.Lio_circe_Json$JNumber__f_value = null;
  this.Lio_circe_Json$JNumber__f_value = value
}
$c_Lio_circe_Json$JNumber.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JNumber.prototype.constructor = $c_Lio_circe_Json$JNumber;
/** @constructor */
function $h_Lio_circe_Json$JNumber() {
  /*<skip>*/
}
$h_Lio_circe_Json$JNumber.prototype = $c_Lio_circe_Json$JNumber.prototype;
$c_Lio_circe_Json$JNumber.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onNumber__Lio_circe_JsonNumber__O(this.Lio_circe_Json$JNumber__f_value)
});
$c_Lio_circe_Json$JNumber.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNumber.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNumber.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JNumber.prototype.asNumber__s_Option = (function() {
  return new $c_s_Some(this.Lio_circe_Json$JNumber__f_value)
});
$c_Lio_circe_Json$JNumber.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JNumber.prototype.productPrefix__T = (function() {
  return "JNumber"
});
$c_Lio_circe_Json$JNumber.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JNumber.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_Json$JNumber__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_Json$JNumber.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_Json$JNumber.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
function $as_Lio_circe_Json$JNumber(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JNumber"))
}
function $isArrayOf_Lio_circe_Json$JNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JNumber)))
}
function $asArrayOf_Lio_circe_Json$JNumber(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JNumber;", depth))
}
var $d_Lio_circe_Json$JNumber = new $TypeData().initClass({
  Lio_circe_Json$JNumber: 0
}, false, "io.circe.Json$JNumber", {
  Lio_circe_Json$JNumber: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JNumber.prototype.$classData = $d_Lio_circe_Json$JNumber;
/** @constructor */
function $c_Lio_circe_Json$JObject(value) {
  this.Lio_circe_Json$JObject__f_value = null;
  this.Lio_circe_Json$JObject__f_value = value
}
$c_Lio_circe_Json$JObject.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JObject.prototype.constructor = $c_Lio_circe_Json$JObject;
/** @constructor */
function $h_Lio_circe_Json$JObject() {
  /*<skip>*/
}
$h_Lio_circe_Json$JObject.prototype = $c_Lio_circe_Json$JObject.prototype;
$c_Lio_circe_Json$JObject.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onObject__Lio_circe_JsonObject__O(this.Lio_circe_Json$JObject__f_value)
});
$c_Lio_circe_Json$JObject.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JObject.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JObject.prototype.isObject__Z = (function() {
  return true
});
$c_Lio_circe_Json$JObject.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JObject.prototype.asObject__s_Option = (function() {
  return new $c_s_Some(this.Lio_circe_Json$JObject__f_value)
});
$c_Lio_circe_Json$JObject.prototype.productPrefix__T = (function() {
  return "JObject"
});
$c_Lio_circe_Json$JObject.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JObject.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_Json$JObject__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_Json$JObject.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_Json$JObject.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
function $as_Lio_circe_Json$JObject(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JObject) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JObject"))
}
function $isArrayOf_Lio_circe_Json$JObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JObject)))
}
function $asArrayOf_Lio_circe_Json$JObject(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JObject;", depth))
}
var $d_Lio_circe_Json$JObject = new $TypeData().initClass({
  Lio_circe_Json$JObject: 0
}, false, "io.circe.Json$JObject", {
  Lio_circe_Json$JObject: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JObject.prototype.$classData = $d_Lio_circe_Json$JObject;
/** @constructor */
function $c_Lio_circe_Json$JString(value) {
  this.Lio_circe_Json$JString__f_value = null;
  this.Lio_circe_Json$JString__f_value = value
}
$c_Lio_circe_Json$JString.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JString.prototype.constructor = $c_Lio_circe_Json$JString;
/** @constructor */
function $h_Lio_circe_Json$JString() {
  /*<skip>*/
}
$h_Lio_circe_Json$JString.prototype = $c_Lio_circe_Json$JString.prototype;
$c_Lio_circe_Json$JString.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onString__T__O(this.Lio_circe_Json$JString__f_value)
});
$c_Lio_circe_Json$JString.prototype.isNull__Z = (function() {
  return false
});
$c_Lio_circe_Json$JString.prototype.isArray__Z = (function() {
  return false
});
$c_Lio_circe_Json$JString.prototype.isObject__Z = (function() {
  return false
});
$c_Lio_circe_Json$JString.prototype.asNumber__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JString.prototype.asObject__s_Option = (function() {
  return $m_s_None$()
});
$c_Lio_circe_Json$JString.prototype.productPrefix__T = (function() {
  return "JString"
});
$c_Lio_circe_Json$JString.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_Json$JString.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_Json$JString__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_Json$JString.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_Json$JString.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
function $as_Lio_circe_Json$JString(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JString) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JString"))
}
function $isArrayOf_Lio_circe_Json$JString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JString)))
}
function $asArrayOf_Lio_circe_Json$JString(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JString;", depth))
}
var $d_Lio_circe_Json$JString = new $TypeData().initClass({
  Lio_circe_Json$JString: 0
}, false, "io.circe.Json$JString", {
  Lio_circe_Json$JString: 1,
  Lio_circe_Json: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Json$JString.prototype.$classData = $d_Lio_circe_Json$JString;
/** @constructor */
function $c_Lio_circe_JsonBigDecimal(value) {
  this.Lio_circe_JsonBigDecimal__f_value = null;
  this.Lio_circe_JsonBigDecimal__f_value = value
}
$c_Lio_circe_JsonBigDecimal.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonBigDecimal.prototype.constructor = $c_Lio_circe_JsonBigDecimal;
/** @constructor */
function $h_Lio_circe_JsonBigDecimal() {
  /*<skip>*/
}
$h_Lio_circe_JsonBigDecimal.prototype = $c_Lio_circe_JsonBigDecimal.prototype;
$c_Lio_circe_JsonBigDecimal.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  var this$1 = $m_Lio_circe_numbers_BiggerDecimal$();
  var d = this.Lio_circe_JsonBigDecimal__f_value;
  var this$2 = $n(d);
  var $$x1 = this$2.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var this$3 = $n(d);
  var value = this$3.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this$1, $$x1, new $c_RTLong(value, hi))
});
$c_Lio_circe_JsonBigDecimal.prototype.toBigDecimal__s_Option = (function() {
  return new $c_s_Some($ct_s_math_BigDecimal__Ljava_math_BigDecimal__(new $c_s_math_BigDecimal(), this.Lio_circe_JsonBigDecimal__f_value))
});
$c_Lio_circe_JsonBigDecimal.prototype.toBigInt__s_Option = (function() {
  var this$1 = $m_Lio_circe_numbers_BiggerDecimal$();
  var d = this.Lio_circe_JsonBigDecimal__f_value;
  var this$2 = $n(d);
  var $$x1 = this$2.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var this$3 = $n(d);
  var value = this$3.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var this$5 = $n($p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this$1, $$x1, new $c_RTLong(value, hi)));
  var this$6 = $n(this$5.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits));
  if (this$6.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$6.get__O();
    var x$2 = $as_Ljava_math_BigInteger(arg1);
    return new $c_s_Some($n($m_s_package$().BigInt__s_math_BigInt$()).apply__Ljava_math_BigInteger__s_math_BigInt(x$2))
  }
});
$c_Lio_circe_JsonBigDecimal.prototype.toDouble__D = (function() {
  return $n(this.Lio_circe_JsonBigDecimal__f_value).doubleValue__D()
});
$c_Lio_circe_JsonBigDecimal.prototype.toFloat__F = (function() {
  return $n(this.Lio_circe_JsonBigDecimal__f_value).floatValue__F()
});
$c_Lio_circe_JsonBigDecimal.prototype.toLong__s_Option = (function() {
  var this$1 = $m_Lio_circe_numbers_BiggerDecimal$();
  var d = this.Lio_circe_JsonBigDecimal__f_value;
  var this$2 = $n(d);
  var $$x1 = this$2.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var this$3 = $n(d);
  var value = this$3.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  return $n($p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this$1, $$x1, new $c_RTLong(value, hi))).toLong__s_Option()
});
$c_Lio_circe_JsonBigDecimal.prototype.toString__T = (function() {
  return $n(this.Lio_circe_JsonBigDecimal__f_value).toString__T()
});
$c_Lio_circe_JsonBigDecimal.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var this$1 = $n(builder);
  var str = $n(this.Lio_circe_JsonBigDecimal__f_value).toString__T();
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
});
$c_Lio_circe_JsonBigDecimal.prototype.productPrefix__T = (function() {
  return "JsonBigDecimal"
});
$c_Lio_circe_JsonBigDecimal.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_JsonBigDecimal.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_JsonBigDecimal__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_JsonBigDecimal.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
function $as_Lio_circe_JsonBigDecimal(obj) {
  return (((obj instanceof $c_Lio_circe_JsonBigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonBigDecimal"))
}
function $isArrayOf_Lio_circe_JsonBigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonBigDecimal)))
}
function $asArrayOf_Lio_circe_JsonBigDecimal(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonBigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonBigDecimal;", depth))
}
var $d_Lio_circe_JsonBigDecimal = new $TypeData().initClass({
  Lio_circe_JsonBigDecimal: 0
}, false, "io.circe.JsonBigDecimal", {
  Lio_circe_JsonBigDecimal: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lio_circe_JsonBigDecimal.prototype.$classData = $d_Lio_circe_JsonBigDecimal;
/** @constructor */
function $c_Lio_circe_JsonDouble(value) {
  this.Lio_circe_JsonDouble__f_value = 0.0;
  this.Lio_circe_JsonDouble__f_value = value
}
$c_Lio_circe_JsonDouble.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonDouble.prototype.constructor = $c_Lio_circe_JsonDouble;
/** @constructor */
function $h_Lio_circe_JsonDouble() {
  /*<skip>*/
}
$h_Lio_circe_JsonDouble.prototype = $c_Lio_circe_JsonDouble.prototype;
$c_Lio_circe_JsonDouble.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromDoubleUnsafe__D__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonDouble__f_value)
});
$c_Lio_circe_JsonDouble.prototype.toBigDecimal__s_Option = (function() {
  var $$x1 = $m_s_math_BigDecimal$();
  var d = this.Lio_circe_JsonDouble__f_value;
  return new $c_s_Some($n($$x1).javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal($m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d)))
});
$c_Lio_circe_JsonDouble.prototype.toBigInt__s_Option = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  var asBigDecimal = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
  return ($m_Lio_circe_JsonNumber$().bigDecimalIsWhole__Ljava_math_BigDecimal__Z(asBigDecimal) ? new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), $n(asBigDecimal).toBigInteger__Ljava_math_BigInteger())) : $m_s_None$())
});
$c_Lio_circe_JsonDouble.prototype.toDouble__D = (function() {
  return this.Lio_circe_JsonDouble__f_value
});
$c_Lio_circe_JsonDouble.prototype.toFloat__F = (function() {
  return Math.fround(this.Lio_circe_JsonDouble__f_value)
});
$c_Lio_circe_JsonDouble.prototype.toLong__s_Option = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  var asBigDecimal = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
  return ($m_Lio_circe_JsonNumber$().bigDecimalIsValidLong__Ljava_math_BigDecimal__Z(asBigDecimal) ? new $c_s_Some($n(asBigDecimal).longValue__J()) : $m_s_None$())
});
$c_Lio_circe_JsonDouble.prototype.toString__T = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  return ("" + d)
});
$c_Lio_circe_JsonDouble.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var this$1 = $n(builder);
  var d = this.Lio_circe_JsonDouble__f_value;
  var str = ("" + d);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str)
});
$c_Lio_circe_JsonDouble.prototype.productPrefix__T = (function() {
  return "JsonDouble"
});
$c_Lio_circe_JsonDouble.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_JsonDouble.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_JsonDouble__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_JsonDouble.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
function $as_Lio_circe_JsonDouble(obj) {
  return (((obj instanceof $c_Lio_circe_JsonDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonDouble"))
}
function $isArrayOf_Lio_circe_JsonDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonDouble)))
}
function $asArrayOf_Lio_circe_JsonDouble(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonDouble;", depth))
}
var $d_Lio_circe_JsonDouble = new $TypeData().initClass({
  Lio_circe_JsonDouble: 0
}, false, "io.circe.JsonDouble", {
  Lio_circe_JsonDouble: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lio_circe_JsonDouble.prototype.$classData = $d_Lio_circe_JsonDouble;
function $p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal($thiz) {
  var f = $thiz.Lio_circe_JsonFloat__f_value;
  return $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), ("" + f))
}
/** @constructor */
function $c_Lio_circe_JsonFloat(value) {
  this.Lio_circe_JsonFloat__f_value = 0.0;
  this.Lio_circe_JsonFloat__f_value = value
}
$c_Lio_circe_JsonFloat.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonFloat.prototype.constructor = $c_Lio_circe_JsonFloat;
/** @constructor */
function $h_Lio_circe_JsonFloat() {
  /*<skip>*/
}
$h_Lio_circe_JsonFloat.prototype = $c_Lio_circe_JsonFloat.prototype;
$c_Lio_circe_JsonFloat.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromFloat__F__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonFloat__f_value)
});
$c_Lio_circe_JsonFloat.prototype.toBigDecimal__s_Option = (function() {
  return new $c_s_Some($m_s_math_BigDecimal$().javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal($p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal(this)))
});
$c_Lio_circe_JsonFloat.prototype.toBigInt__s_Option = (function() {
  var asBigDecimal = $p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal(this);
  return ($m_Lio_circe_JsonNumber$().bigDecimalIsWhole__Ljava_math_BigDecimal__Z(asBigDecimal) ? new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), $n(asBigDecimal).toBigInteger__Ljava_math_BigInteger())) : $m_s_None$())
});
$c_Lio_circe_JsonFloat.prototype.toDouble__D = (function() {
  return $n($p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal(this)).doubleValue__D()
});
$c_Lio_circe_JsonFloat.prototype.toFloat__F = (function() {
  return this.Lio_circe_JsonFloat__f_value
});
$c_Lio_circe_JsonFloat.prototype.toLong__s_Option = (function() {
  var asBigDecimal = $p_Lio_circe_JsonFloat__toJavaBigDecimal__Ljava_math_BigDecimal(this);
  return ($m_Lio_circe_JsonNumber$().bigDecimalIsValidLong__Ljava_math_BigDecimal__Z(asBigDecimal) ? new $c_s_Some($n(asBigDecimal).longValue__J()) : $m_s_None$())
});
$c_Lio_circe_JsonFloat.prototype.toString__T = (function() {
  var f = this.Lio_circe_JsonFloat__f_value;
  return ("" + f)
});
$c_Lio_circe_JsonFloat.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var this$1 = $n(builder);
  var f = this.Lio_circe_JsonFloat__f_value;
  var str = ("" + f);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str)
});
$c_Lio_circe_JsonFloat.prototype.productPrefix__T = (function() {
  return "JsonFloat"
});
$c_Lio_circe_JsonFloat.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_JsonFloat.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_JsonFloat__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_JsonFloat.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
function $as_Lio_circe_JsonFloat(obj) {
  return (((obj instanceof $c_Lio_circe_JsonFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonFloat"))
}
function $isArrayOf_Lio_circe_JsonFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonFloat)))
}
function $asArrayOf_Lio_circe_JsonFloat(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonFloat;", depth))
}
var $d_Lio_circe_JsonFloat = new $TypeData().initClass({
  Lio_circe_JsonFloat: 0
}, false, "io.circe.JsonFloat", {
  Lio_circe_JsonFloat: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lio_circe_JsonFloat.prototype.$classData = $d_Lio_circe_JsonFloat;
/** @constructor */
function $c_Lio_circe_JsonLong(value) {
  this.Lio_circe_JsonLong__f_value = $L0;
  this.Lio_circe_JsonLong__f_value = value
}
$c_Lio_circe_JsonLong.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonLong.prototype.constructor = $c_Lio_circe_JsonLong;
/** @constructor */
function $h_Lio_circe_JsonLong() {
  /*<skip>*/
}
$h_Lio_circe_JsonLong.prototype = $c_Lio_circe_JsonLong.prototype;
$c_Lio_circe_JsonLong.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromLong__J__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonLong__f_value)
});
$c_Lio_circe_JsonLong.prototype.toBigDecimal__s_Option = (function() {
  return new $c_s_Some($n($m_s_package$().BigDecimal__s_math_BigDecimal$()).apply__J__s_math_BigDecimal(this.Lio_circe_JsonLong__f_value))
});
$c_Lio_circe_JsonLong.prototype.toBigInt__s_Option = (function() {
  return new $c_s_Some($n($m_s_package$().BigInt__s_math_BigInt$()).apply__J__s_math_BigInt(this.Lio_circe_JsonLong__f_value))
});
$c_Lio_circe_JsonLong.prototype.toDouble__D = (function() {
  var this$1 = this.Lio_circe_JsonLong__f_value;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$1.RTLong__f_lo, this$1.RTLong__f_hi)
});
$c_Lio_circe_JsonLong.prototype.toFloat__F = (function() {
  var this$1 = this.Lio_circe_JsonLong__f_value;
  return Math.fround($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$1.RTLong__f_lo, this$1.RTLong__f_hi))
});
$c_Lio_circe_JsonLong.prototype.toLong__s_Option = (function() {
  return new $c_s_Some(this.Lio_circe_JsonLong__f_value)
});
$c_Lio_circe_JsonLong.prototype.toString__T = (function() {
  var t = this.Lio_circe_JsonLong__f_value;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi)
});
$c_Lio_circe_JsonLong.prototype.appendToStringBuilder__jl_StringBuilder__V = (function(builder) {
  var this$1 = $n(builder);
  var t = this.Lio_circe_JsonLong__f_value;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var str = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
});
$c_Lio_circe_JsonLong.prototype.productPrefix__T = (function() {
  return "JsonLong"
});
$c_Lio_circe_JsonLong.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_JsonLong.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_JsonLong__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_JsonLong.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
function $as_Lio_circe_JsonLong(obj) {
  return (((obj instanceof $c_Lio_circe_JsonLong) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonLong"))
}
function $isArrayOf_Lio_circe_JsonLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonLong)))
}
function $asArrayOf_Lio_circe_JsonLong(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonLong;", depth))
}
var $d_Lio_circe_JsonLong = new $TypeData().initClass({
  Lio_circe_JsonLong: 0
}, false, "io.circe.JsonLong", {
  Lio_circe_JsonLong: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lio_circe_JsonLong.prototype.$classData = $d_Lio_circe_JsonLong;
function $ct_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__Lio_circe_MidPriorityEncoders__Lio_circe_Encoder__($thiz, outer, encodeA) {
  $thiz.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = encodeA;
  if ((outer === null)) {
    $n(null)
  };
  return $thiz
}
/** @constructor */
function $c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder() {
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = null
}
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype = new $h_O();
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype.constructor = $c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder;
/** @constructor */
function $h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder() {
  /*<skip>*/
}
$h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype = $c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype;
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype.encodeArray__O__sci_Vector = (function(a) {
  $n($m_s_package$().s_package$__f_Vector);
  var builder = new $c_sci_VectorBuilder();
  var iterator = this.toIterator__O__sc_Iterator(a);
  while ($n(iterator).hasNext__Z()) {
    var elem = $n(this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA).apply__O__Lio_circe_Json($n(iterator).next__O());
    builder.addOne__O__sci_VectorBuilder(elem)
  };
  return builder.result__sci_Vector()
});
/** @constructor */
function $c_Lio_circe_TupleEncoders$$anon$2(outer, encodeA0$2, encodeA1$1) {
  this.Lio_circe_TupleEncoders$$anon$2__f_encodeA0$2 = null;
  this.Lio_circe_TupleEncoders$$anon$2__f_encodeA1$1 = null;
  this.Lio_circe_TupleEncoders$$anon$2__f_encodeA0$2 = encodeA0$2;
  this.Lio_circe_TupleEncoders$$anon$2__f_encodeA1$1 = encodeA1$1
}
$c_Lio_circe_TupleEncoders$$anon$2.prototype = new $h_O();
$c_Lio_circe_TupleEncoders$$anon$2.prototype.constructor = $c_Lio_circe_TupleEncoders$$anon$2;
/** @constructor */
function $h_Lio_circe_TupleEncoders$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_TupleEncoders$$anon$2.prototype = $c_Lio_circe_TupleEncoders$$anon$2.prototype;
$c_Lio_circe_TupleEncoders$$anon$2.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_TupleEncoders$$anon$2.prototype.encodeArray__T2__sci_Vector = (function(a) {
  var this$4 = $n($m_s_package$().s_package$__f_Vector);
  var array = [$n(this.Lio_circe_TupleEncoders$$anon$2__f_encodeA0$2).apply__O__Lio_circe_Json($n(a)._1__O()), $n(this.Lio_circe_TupleEncoders$$anon$2__f_encodeA1$1).apply__O__Lio_circe_Json($n(a)._2__O())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return this$4.from__sc_IterableOnce__sci_Vector(elems)
});
$c_Lio_circe_TupleEncoders$$anon$2.prototype.encodeArray__O__sci_Vector = (function(a) {
  return this.encodeArray__T2__sci_Vector($as_T2(a))
});
var $d_Lio_circe_TupleEncoders$$anon$2 = new $TypeData().initClass({
  Lio_circe_TupleEncoders$$anon$2: 0
}, false, "io.circe.TupleEncoders$$anon$2", {
  Lio_circe_TupleEncoders$$anon$2: 1,
  O: 1,
  Lio_circe_Encoder$AsArray: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_TupleEncoders$$anon$2.prototype.$classData = $d_Lio_circe_TupleEncoders$$anon$2;
/** @constructor */
function $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder() {
  /*<skip>*/
}
$c_Lio_circe_generic_encoding_DerivedAsObjectEncoder.prototype = new $h_O();
$c_Lio_circe_generic_encoding_DerivedAsObjectEncoder.prototype.constructor = $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder;
/** @constructor */
function $h_Lio_circe_generic_encoding_DerivedAsObjectEncoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_encoding_DerivedAsObjectEncoder.prototype = $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder.prototype;
$c_Lio_circe_generic_encoding_DerivedAsObjectEncoder.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
function $as_Lio_circe_generic_encoding_DerivedAsObjectEncoder(obj) {
  return (((obj instanceof $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.generic.encoding.DerivedAsObjectEncoder"))
}
function $isArrayOf_Lio_circe_generic_encoding_DerivedAsObjectEncoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_generic_encoding_DerivedAsObjectEncoder)))
}
function $asArrayOf_Lio_circe_generic_encoding_DerivedAsObjectEncoder(obj, depth) {
  return (($isArrayOf_Lio_circe_generic_encoding_DerivedAsObjectEncoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.generic.encoding.DerivedAsObjectEncoder;", depth))
}
/** @constructor */
function $c_Lio_circe_generic_encoding_ReprAsObjectEncoder() {
  /*<skip>*/
}
$c_Lio_circe_generic_encoding_ReprAsObjectEncoder.prototype = new $h_O();
$c_Lio_circe_generic_encoding_ReprAsObjectEncoder.prototype.constructor = $c_Lio_circe_generic_encoding_ReprAsObjectEncoder;
/** @constructor */
function $h_Lio_circe_generic_encoding_ReprAsObjectEncoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_encoding_ReprAsObjectEncoder.prototype = $c_Lio_circe_generic_encoding_ReprAsObjectEncoder.prototype;
$c_Lio_circe_generic_encoding_ReprAsObjectEncoder.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1() {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1.prototype = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1.prototype;
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var field = $as_T($n(x1)._1__O());
    var p2 = $as_s_Option($n(x1)._2__O());
    if ((p2 instanceof $c_s_Some)) {
      var x3 = $as_s_Some(p2);
      var keyAnnotation = $as_Lio_circe_generic_extras_JsonKey($n(x3).s_Some__f_value);
      return $ct_T2__O__O__(new $c_T2(), field, $n(keyAnnotation).value__T())
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var p2 = $as_s_Option($n(x1)._2__O());
    if ((p2 instanceof $c_s_Some)) {
      return true
    }
  };
  return false
});
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1 = new $TypeData().initClass({
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1: 0
}, false, "io.circe.generic.extras.decoding.ConfiguredDecoder$$anonfun$1", {
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1.prototype.$classData = $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$$anonfun$1;
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder(gen, decodeR, config) {
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_config = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_constructorNameCache = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder__f_gen = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder__f_decodeR = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder__f_config = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder__f_gen = gen;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder__f_decodeR = decodeR;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder__f_config = config;
  $ct_Lio_circe_generic_extras_decoding_ConfiguredDecoder__Lio_circe_generic_extras_Configuration__(this, config)
}
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder.prototype = new $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder();
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder.prototype = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder.prototype;
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n($as_Lio_circe_generic_extras_decoding_ReprDecoder($n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder__f_decodeR).value__O())).configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either(c, new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return x
  })), new $c_sjsr_AnonFunction1(((value$2) => {
    var value = $as_T(value$2);
    return this.constructorNameTransformer__T__T(value)
  })), $m_sci_Map$EmptyMap$(), $n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder__f_config).Lio_circe_generic_extras_Configuration__f_discriminator);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var r = $as_Lshapeless_Coproduct($n(x2).s_util_Right__f_value);
    $n($m_s_package$().s_package$__f_Right);
    var value$1 = $n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder__f_gen).from__O__O(r);
    return new $c_s_util_Right(value$1)
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder = new $TypeData().initClass({
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder: 0
}, false, "io.circe.generic.extras.decoding.ConfiguredDecoder$AdtConfiguredDecoder", {
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder: 1,
  Lio_circe_generic_extras_decoding_ConfiguredDecoder: 1,
  Lio_circe_generic_decoding_DerivedDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder.prototype.$classData = $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder;
function $ct_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__Lio_circe_generic_extras_Configuration__sci_Map__($thiz, config, keyAnnotationMap) {
  $thiz.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_config = config;
  $thiz.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_keyAnnotationMap = keyAnnotationMap;
  $ct_Lio_circe_generic_extras_decoding_ConfiguredDecoder__Lio_circe_generic_extras_Configuration__($thiz, config);
  $thiz.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_memberNameCache = $ct_ju_concurrent_ConcurrentHashMap__(new $c_ju_concurrent_ConcurrentHashMap());
  return $thiz
}
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder() {
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_config = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_constructorNameCache = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_config = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_keyAnnotationMap = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_memberNameCache = null
}
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder.prototype = new $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder();
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder.prototype = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder.prototype;
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder.prototype.memberNameTransformer__T__T = (function(value) {
  var current = $as_T($n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_memberNameCache).get__O__O(value));
  if ((current === null)) {
    var this$1 = $n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_keyAnnotationMap);
    if ((!this$1.isEmpty__Z())) {
      var transformed = $as_T($n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_keyAnnotationMap).getOrElse__O__F0__O(value, new $c_sjsr_AnonFunction0((() => $as_T($n($n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_config).Lio_circe_generic_extras_Configuration__f_transformMemberNames).apply__O__O(value))))))
    } else {
      var transformed = $as_T($n($n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_config).Lio_circe_generic_extras_Configuration__f_transformMemberNames).apply__O__O(value))
    };
    $n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_memberNameCache).put__O__O__O(value, transformed);
    return transformed
  } else {
    return current
  }
});
/** @constructor */
function $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1(outer) {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1.prototype.constructor = $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1;
/** @constructor */
function $h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1.prototype = $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1.prototype;
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var field = $as_T($n(x1)._1__O());
    var p2 = $as_s_Option($n(x1)._2__O());
    if ((p2 instanceof $c_s_Some)) {
      var x3 = $as_s_Some(p2);
      var keyAnnotation = $as_Lio_circe_generic_extras_JsonKey($n(x3).s_Some__f_value);
      return $ct_T2__O__O__(new $c_T2(), field, $n(keyAnnotation).value__T())
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var p2 = $as_s_Option($n(x1)._2__O());
    if ((p2 instanceof $c_s_Some)) {
      return true
    }
  };
  return false
});
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1 = new $TypeData().initClass({
  Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1: 0
}, false, "io.circe.generic.extras.encoding.ConfiguredAsObjectEncoder$$anon$1$$anonfun$1", {
  Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1.prototype.$classData = $d_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1;
function $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject($thiz, encode, value, name, discriminator) {
  var x = $m_s_None$();
  if ((x === discriminator)) {
    return $m_Lio_circe_JsonObject$().singleton__T__Lio_circe_Json__Lio_circe_JsonObject(name, $n(encode).apply__O__Lio_circe_Json(value))
  } else if ((discriminator instanceof $c_s_Some)) {
    var x2 = $as_s_Some(discriminator);
    var disc = $as_T($n(x2).s_Some__f_value);
    if ($is_Lio_circe_Encoder$AsObject(encode)) {
      var x2$2 = $as_Lio_circe_Encoder$AsObject(encode);
      return $n($n(x2$2).encodeObject__O__Lio_circe_JsonObject(value)).add__T__Lio_circe_Json__Lio_circe_JsonObject(disc, ($m_Lio_circe_Json$(), new $c_Lio_circe_Json$JString(name)))
    } else {
      return $m_Lio_circe_JsonObject$().singleton__T__Lio_circe_Json__Lio_circe_JsonObject(name, $n(encode).apply__O__Lio_circe_Json(value))
    }
  } else {
    throw new $c_s_MatchError(discriminator)
  }
}
function $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject($thiz, a) {
  return $thiz.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject(a, new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return x
  })), new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_T(x$3$2);
    return x$3
  })), $m_s_None$())
}
function $is_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_generic_extras_encoding_ReprAsObjectEncoder)))
}
function $as_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(obj) {
  return (($is_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.generic.extras.encoding.ReprAsObjectEncoder"))
}
function $isArrayOf_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_generic_extras_encoding_ReprAsObjectEncoder)))
}
function $asArrayOf_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(obj, depth) {
  return (($isArrayOf_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.generic.extras.encoding.ReprAsObjectEncoder;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype.constructor = $c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ComponentDom$Unmounted$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype = $c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype;
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype.productPrefix__T = (function() {
  return "Unmounted"
});
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype.productArity__I = (function() {
  return 0
});
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype.hashCode__I = (function() {
  return 663734687
});
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype.toString__T = (function() {
  return "Unmounted"
});
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype.toElement__s_Option = (function() {
  return $m_s_None$()
});
var $d_Ljapgolly_scalajs_react_ComponentDom$Unmounted$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ComponentDom$Unmounted$: 0
}, false, "japgolly.scalajs.react.ComponentDom$Unmounted$", {
  Ljapgolly_scalajs_react_ComponentDom$Unmounted$: 1,
  O: 1,
  Ljapgolly_scalajs_react_ComponentDom: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$.prototype.$classData = $d_Ljapgolly_scalajs_react_ComponentDom$Unmounted$;
var $n_Ljapgolly_scalajs_react_ComponentDom$Unmounted$;
function $m_Ljapgolly_scalajs_react_ComponentDom$Unmounted$() {
  if ((!$n_Ljapgolly_scalajs_react_ComponentDom$Unmounted$)) {
    $n_Ljapgolly_scalajs_react_ComponentDom$Unmounted$ = new $c_Ljapgolly_scalajs_react_ComponentDom$Unmounted$()
  };
  return $n_Ljapgolly_scalajs_react_ComponentDom$Unmounted$
}
function $p_Ljapgolly_scalajs_react_Ref$$anon$1__rawSetFn$lzycompute__sjs_js_Function1($thiz) {
  if ((!$thiz.Ljapgolly_scalajs_react_Ref$$anon$1__f_bitmap$0)) {
    $thiz.Ljapgolly_scalajs_react_Ref$$anon$1__f_rawSetFn = $f_Ljapgolly_scalajs_react_Ref$SetF__rawSetFn__sjs_js_Function1($thiz);
    $thiz.Ljapgolly_scalajs_react_Ref$$anon$1__f_bitmap$0 = true
  };
  return $thiz.Ljapgolly_scalajs_react_Ref$$anon$1__f_rawSetFn
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_Ref$$anon$1(FF$1, l$1, r$1, _raw$1) {
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_raw = null;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_get = null;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_rawSetFn = null;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_bitmap$0 = false;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_FF$1 = null;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_l$1 = null;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_r$1 = null;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_FF$1 = FF$1;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_l$1 = l$1;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_r$1 = r$1;
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_raw = _raw$1;
  $n(this.Ljapgolly_scalajs_react_Ref$$anon$1__f_FF$1);
  var a = new $c_sjsr_AnonFunction0((() => {
    var an = this.Ljapgolly_scalajs_react_Ref$$anon$1__f_raw.current;
    var this$3 = $n($m_s_Option$().apply__O__s_Option(an));
    var f = this.Ljapgolly_scalajs_react_Ref$$anon$1__f_r$1;
    return (this$3.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(f).apply__O__O(this$3.get__O())))
  }));
  this.Ljapgolly_scalajs_react_Ref$$anon$1__f_get = new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
}
$c_Ljapgolly_scalajs_react_Ref$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_Ref$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_Ref$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_Ref$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_Ref$$anon$1.prototype = $c_Ljapgolly_scalajs_react_Ref$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_Ref$$anon$1.prototype.rawSetFn__sjs_js_Function1 = (function() {
  return ((!this.Ljapgolly_scalajs_react_Ref$$anon$1__f_bitmap$0) ? $p_Ljapgolly_scalajs_react_Ref$$anon$1__rawSetFn$lzycompute__sjs_js_Function1(this) : this.Ljapgolly_scalajs_react_Ref$$anon$1__f_rawSetFn)
});
$c_Ljapgolly_scalajs_react_Ref$$anon$1.prototype.set__s_Option__O = (function(newValue) {
  $n(this.Ljapgolly_scalajs_react_Ref$$anon$1__f_FF$1);
  var a$1 = new $c_sjsr_AnonFunction0((() => {
    var $$x2 = this.Ljapgolly_scalajs_react_Ref$$anon$1__f_raw;
    if ((newValue instanceof $c_s_Some)) {
      var x2 = $as_s_Some(newValue);
      var i = $n(x2).s_Some__f_value;
      var a = $n(this.Ljapgolly_scalajs_react_Ref$$anon$1__f_l$1).apply__O__O(i);
      var $$x1 = a
    } else {
      var x = $m_s_None$();
      if ((!(x === newValue))) {
        throw new $c_s_MatchError(newValue)
      };
      var $$x1 = null
    };
    $$x2.current = $$x1
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$1)))
});
$c_Ljapgolly_scalajs_react_Ref$$anon$1.prototype.mapOption__F1__Ljapgolly_scalajs_react_Ref$FullF = (function(f) {
  var _raw = this.Ljapgolly_scalajs_react_Ref$$anon$1__f_raw;
  var l = this.Ljapgolly_scalajs_react_Ref$$anon$1__f_l$1;
  var r = $n(this.Ljapgolly_scalajs_react_Ref$$anon$1__f_r$1).andThen__F1__F1(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_s_Option(x$3$2);
    var this$2 = $n(x$3);
    return (this$2.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(f).apply__O__O(this$2.get__O())))
  })));
  var FF = this.Ljapgolly_scalajs_react_Ref$$anon$1__f_FF$1;
  return new $c_Ljapgolly_scalajs_react_Ref$$anon$1(FF, l, r, _raw)
});
var $d_Ljapgolly_scalajs_react_Ref$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_Ref$$anon$1: 0
}, false, "japgolly.scalajs.react.Ref$$anon$1", {
  Ljapgolly_scalajs_react_Ref$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_Ref$FullF: 1,
  Ljapgolly_scalajs_react_Ref$HandleF: 1,
  Ljapgolly_scalajs_react_Ref$SetF: 1,
  Ljapgolly_scalajs_react_Ref$GetF: 1
});
$c_Ljapgolly_scalajs_react_Ref$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_Ref$$anon$1;
function $is_Ljapgolly_scalajs_react_StateAccess(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_StateAccess)))
}
function $as_Ljapgolly_scalajs_react_StateAccess(obj) {
  return (($is_Ljapgolly_scalajs_react_StateAccess(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.StateAccess"))
}
function $isArrayOf_Ljapgolly_scalajs_react_StateAccess(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_StateAccess)))
}
function $asArrayOf_Ljapgolly_scalajs_react_StateAccess(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_StateAccess(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.StateAccess;", depth))
}
function $is_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot)))
}
function $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(obj) {
  return (($is_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.Js$UnmountedWithRoot"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.Js$UnmountedWithRoot;", depth))
}
function $is_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot)))
}
function $as_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(obj) {
  return (($is_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.JsFn$UnmountedWithRoot"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.JsFn$UnmountedWithRoot;", depth))
}
function $as_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromProps(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.InitState$DerivedFromProps"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromProps)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromProps(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.InitState$DerivedFromProps;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState(fn) {
  this.Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState__f_fn = null;
  this.Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState__f_fn = fn
}
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype = $c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype;
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype.productPrefix__T = (function() {
  return "DerivedFromPropsAndState"
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState__f_fn : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState)) {
    var DerivedFromPropsAndState$1 = $as_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState(x$1);
    var x = this.Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState__f_fn;
    var x$2 = $n(DerivedFromPropsAndState$1).Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState__f_fn;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.InitState$DerivedFromPropsAndState"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.InitState$DerivedFromPropsAndState;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState: 0
}, false, "japgolly.scalajs.react.component.builder.InitState$DerivedFromPropsAndState", {
  Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_builder_InitState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_InitState$DerivedFromPropsAndState;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState(fn) {
  this.Ljapgolly_scalajs_react_component_builder_InitState$InitialState__f_fn = null;
  this.Ljapgolly_scalajs_react_component_builder_InitState$InitialState__f_fn = fn
}
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_InitState$InitialState() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype = $c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype;
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype.productPrefix__T = (function() {
  return "InitialState"
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_component_builder_InitState$InitialState__f_fn : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState)) {
    var InitialState$1 = $as_Ljapgolly_scalajs_react_component_builder_InitState$InitialState(x$1);
    var x = this.Ljapgolly_scalajs_react_component_builder_InitState$InitialState__f_fn;
    var x$2 = $n(InitialState$1).Ljapgolly_scalajs_react_component_builder_InitState$InitialState__f_fn;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_component_builder_InitState$InitialState(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.InitState$InitialState"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_InitState$InitialState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_InitState$InitialState)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_InitState$InitialState(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_InitState$InitialState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.InitState$InitialState;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_InitState$InitialState = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_InitState$InitialState: 0
}, false, "japgolly.scalajs.react.component.builder.InitState$InitialState", {
  Ljapgolly_scalajs_react_component_builder_InitState$InitialState: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_builder_InitState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$InitialState.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_InitState$InitialState;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype = $c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype;
$c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype.productPrefix__T = (function() {
  return "Stateless"
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype.productArity__I = (function() {
  return 0
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype.hashCode__I = (function() {
  return (-81209974)
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype.toString__T = (function() {
  return "Stateless"
});
var $d_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_InitState$Stateless$: 0
}, false, "japgolly.scalajs.react.component.builder.InitState$Stateless$", {
  Ljapgolly_scalajs_react_component_builder_InitState$Stateless$: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_builder_InitState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$;
var $n_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$;
function $m_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$() {
  if ((!$n_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$)) {
    $n_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$ = new $c_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$()
  };
  return $n_Ljapgolly_scalajs_react_component_builder_InitState$Stateless$
}
function $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($thiz, value, set) {
  return new $c_Ljapgolly_scalajs_react_extra_StateSnapshotF(value, $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(set), $m_Ljapgolly_scalajs_react_Reusability$().never__F2(), $thiz.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_FF, $thiz.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_AA)
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_StateSnapshotF(value, underlyingSetFn, reusability, FF, AA) {
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value = null;
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn = null;
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_reusability = null;
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_FF = null;
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_AA = null;
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value = value;
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn = underlyingSetFn;
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_reusability = reusability;
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_FF = FF;
  this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_AA = AA
}
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_StateSnapshotF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_StateSnapshotF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype = $c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype;
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_extra_StateSnapshotF = (function(G) {
  var this$1 = $n(G);
  var g = this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_FF;
  if ((this$1 === g)) {
    return this
  } else {
    var setFn2 = $n(this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).map__F1__Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction1(((f$2) => {
      var f = $as_F2(f$2);
      return new $c_sjsr_AnonFunction2(((a$2, c$2) => {
        var a = $as_s_Option(a$2);
        var this$4 = $n(G);
        var ga$1 = new $c_sjsr_AnonFunction0((() => {
          var $$x1 = $n(f);
          var this$3 = $n(this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_FF);
          var ga = new $c_sjsr_AnonFunction0((() => c$2));
          return $n($$x1).apply__O__O__O(a, $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$3, ga, G))
        }));
        var g$1 = this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_FF;
        return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$4, ga$1, g$1)
      }))
    })));
    return new $c_Ljapgolly_scalajs_react_extra_StateSnapshotF(this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value, setFn2, this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_reusability, G, this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_AA)
  }
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.F__Ljapgolly_scalajs_react_util_Effect$UnsafeSync = (function() {
  return this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_FF
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.A__Ljapgolly_scalajs_react_util_Effect$Async = (function() {
  return this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_AA
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.toString__T = (function() {
  return (("StateSnapshot(" + this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value) + ")")
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  $m_Ljapgolly_scalajs_react_Reusable$();
  var r = this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn;
  var $$x1 = $n($as_F2($n(r).value__O()));
  var this$2 = $n(this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_FF);
  return $n($$x1).apply__O__O__O(newState, $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transDispatch__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this$2, callback, G))
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return this.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($as_s_Option($n(mod).apply__O__O(this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)), callback, G)
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.xmapState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF = (function(f, g) {
  return $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this, $n(f).apply__O__O(this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
    var ot = $as_s_Option(ot$2);
    var $$x1 = $n($as_F2($n(this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
    var this$2 = $n(ot);
    return $n($$x1).apply__O__O__O((this$2.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(g).apply__O__O(this$2.get__O()))), cb$2)
  })))
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF = (function(f, g) {
  return this.xmapState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(f, new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1($n(g).apply__O__O(x$1$2))).apply__O__O(this.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value))))
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_extra_StateSnapshotF(G)
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_StateAccess$SetState__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
function $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_StateSnapshotF) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.StateSnapshotF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_StateSnapshotF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_StateSnapshotF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_StateSnapshotF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_StateSnapshotF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.StateSnapshotF;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_StateSnapshotF = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_StateSnapshotF: 0
}, false, "japgolly.scalajs.react.extra.StateSnapshotF", {
  Ljapgolly_scalajs_react_extra_StateSnapshotF: 1,
  O: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1
});
$c_Ljapgolly_scalajs_react_extra_StateSnapshotF.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_StateSnapshotF;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_AbsUrl(value) {
  this.Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value = null;
  this.Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value = value;
  $m_Ljapgolly_scalajs_react_util_Util$();
  var this$3 = $n(this.Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value);
  if ((!($uI(this$3.indexOf("://")) !== (-1)))) {
    console.warn((this + " doesn't seem to be a valid URL. It's missing '://'. Consider using AbsUrl.fromWindow."))
  }
}
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype = new $h_Ljapgolly_scalajs_react_extra_router_PathLike();
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_AbsUrl;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_AbsUrl() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype = $c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype;
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.productPrefix__T = (function() {
  return "AbsUrl"
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_AbsUrl)) {
    var AbsUrl$1 = $as_Ljapgolly_scalajs_react_extra_router_AbsUrl(x$1);
    return (this.Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value === $n(AbsUrl$1).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value)
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.str__Ljapgolly_scalajs_react_extra_router_PathLike__T = (function(s) {
  var s$1 = $as_Ljapgolly_scalajs_react_extra_router_AbsUrl(s);
  return $n(s$1).Ljapgolly_scalajs_react_extra_router_AbsUrl__f_value
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.make__T__Ljapgolly_scalajs_react_extra_router_PathLike = (function(s) {
  return new $c_Ljapgolly_scalajs_react_extra_router_AbsUrl(s)
});
function $as_Ljapgolly_scalajs_react_extra_router_AbsUrl(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_AbsUrl) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.AbsUrl"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_AbsUrl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_AbsUrl)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_AbsUrl(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_AbsUrl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.AbsUrl;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_AbsUrl = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_AbsUrl: 0
}, false, "japgolly.scalajs.react.extra.router.AbsUrl", {
  Ljapgolly_scalajs_react_extra_router_AbsUrl: 1,
  Ljapgolly_scalajs_react_extra_router_PathLike: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_AbsUrl.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_AbsUrl;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_BaseUrl(value) {
  this.Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value = null;
  this.Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value = value;
  $m_Ljapgolly_scalajs_react_util_Util$();
  var this$3 = $n(this.Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value);
  if ((!($uI(this$3.indexOf("://")) !== (-1)))) {
    console.warn((this + " doesn't seem to be a valid URL. It's missing '://'. Consider using BaseUrl.fromWindowOrigin."))
  }
}
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype = new $h_Ljapgolly_scalajs_react_extra_router_PathLike();
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_BaseUrl;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_BaseUrl() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype = $c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype;
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.apply__Ljapgolly_scalajs_react_extra_router_Path__Ljapgolly_scalajs_react_extra_router_AbsUrl = (function(p) {
  return new $c_Ljapgolly_scalajs_react_extra_router_AbsUrl((("" + this.Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value) + $n(p).Ljapgolly_scalajs_react_extra_router_Path__f_value))
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.productPrefix__T = (function() {
  return "BaseUrl"
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_BaseUrl)) {
    var BaseUrl$1 = $as_Ljapgolly_scalajs_react_extra_router_BaseUrl(x$1);
    return (this.Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value === $n(BaseUrl$1).Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value)
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.str__Ljapgolly_scalajs_react_extra_router_PathLike__T = (function(s) {
  var s$1 = $as_Ljapgolly_scalajs_react_extra_router_BaseUrl(s);
  return $n(s$1).Ljapgolly_scalajs_react_extra_router_BaseUrl__f_value
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.make__T__Ljapgolly_scalajs_react_extra_router_PathLike = (function(s) {
  return new $c_Ljapgolly_scalajs_react_extra_router_BaseUrl(s)
});
function $as_Ljapgolly_scalajs_react_extra_router_BaseUrl(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_BaseUrl) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.BaseUrl"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_BaseUrl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_BaseUrl)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_BaseUrl(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_BaseUrl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.BaseUrl;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_BaseUrl = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_BaseUrl: 0
}, false, "japgolly.scalajs.react.extra.router.BaseUrl", {
  Ljapgolly_scalajs_react_extra_router_BaseUrl: 1,
  Ljapgolly_scalajs_react_extra_router_PathLike: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_BaseUrl.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_BaseUrl;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_Path(value) {
  this.Ljapgolly_scalajs_react_extra_router_Path__f_value = null;
  this.Ljapgolly_scalajs_react_extra_router_Path__f_value = value
}
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype = new $h_Ljapgolly_scalajs_react_extra_router_PathLike();
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_Path;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_Path() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_Path.prototype = $c_Ljapgolly_scalajs_react_extra_router_Path.prototype;
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.removePrefix__T__s_Option = (function(prefix) {
  var this$1 = $n(prefix);
  var l = this$1.length;
  var this$2 = $n(this.Ljapgolly_scalajs_react_extra_router_Path__f_value);
  if ((this$2.length > l)) {
    var this$3 = $n(this.Ljapgolly_scalajs_react_extra_router_Path__f_value);
    if ((this$3.length >= 0)) {
      var this$4 = $n(prefix);
      var $$x2 = this$3.substring(0, this$4.length);
      var $$x1 = ($as_T($$x2) === prefix)
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var this$5 = $n(this.Ljapgolly_scalajs_react_extra_router_Path__f_value);
    if (((l < 0) || (l > this$5.length))) {
      $charAt(this$5, l)
    };
    return new $c_s_Some(new $c_Ljapgolly_scalajs_react_extra_router_Path($as_T(this$5.substring(l))))
  } else {
    return $m_s_None$()
  }
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.productPrefix__T = (function() {
  return "Path"
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_Path__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_Path)) {
    var Path$1 = $as_Ljapgolly_scalajs_react_extra_router_Path(x$1);
    return (this.Ljapgolly_scalajs_react_extra_router_Path__f_value === $n(Path$1).Ljapgolly_scalajs_react_extra_router_Path__f_value)
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.str__Ljapgolly_scalajs_react_extra_router_PathLike__T = (function(s) {
  var s$1 = $as_Ljapgolly_scalajs_react_extra_router_Path(s);
  return $n(s$1).Ljapgolly_scalajs_react_extra_router_Path__f_value
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.make__T__Ljapgolly_scalajs_react_extra_router_PathLike = (function(s) {
  return new $c_Ljapgolly_scalajs_react_extra_router_Path(s)
});
function $as_Ljapgolly_scalajs_react_extra_router_Path(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_Path) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.Path"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_Path(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_Path)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_Path(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_Path(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.Path;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_Path = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_Path: 0
}, false, "japgolly.scalajs.react.extra.router.Path", {
  Ljapgolly_scalajs_react_extra_router_Path: 1,
  Ljapgolly_scalajs_react_extra_router_PathLike: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_Path.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_Path;
function $is_Ljapgolly_scalajs_react_extra_router_Redirect(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_extra_router_Redirect)))
}
function $as_Ljapgolly_scalajs_react_extra_router_Redirect(obj) {
  return (($is_Ljapgolly_scalajs_react_extra_router_Redirect(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.Redirect"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_Redirect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_Redirect)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_Redirect(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_Redirect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.Redirect;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RendererF(render, sync) {
  this.Ljapgolly_scalajs_react_extra_router_RendererF__f_render = null;
  this.Ljapgolly_scalajs_react_extra_router_RendererF__f_sync = null;
  this.Ljapgolly_scalajs_react_extra_router_RendererF__f_render = render;
  this.Ljapgolly_scalajs_react_extra_router_RendererF__f_sync = sync
}
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RendererF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RendererF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RendererF.prototype = $c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.toString__T = (function() {
  return (("Renderer(" + this.Ljapgolly_scalajs_react_extra_router_RendererF__f_render) + ")")
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.map__F1__Ljapgolly_scalajs_react_extra_router_RendererF = (function(g) {
  return new $c_Ljapgolly_scalajs_react_extra_router_RendererF(new $c_sjsr_AnonFunction1(((rc$2) => {
    var rc = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(rc$2);
    var $$x1 = this.Ljapgolly_scalajs_react_extra_router_RendererF__f_render;
    var this$2 = $n(rc);
    return $as_F1($n($$x1).apply__O__O(new $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(this$2, g, this$2.F__Ljapgolly_scalajs_react_util_Effect$Sync())))
  })), this.Ljapgolly_scalajs_react_extra_router_RendererF__f_sync)
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RendererF = (function(G) {
  var this$1 = $n(G);
  var g = this.Ljapgolly_scalajs_react_extra_router_RendererF__f_sync;
  return ((this$1 === g) ? this : new $c_Ljapgolly_scalajs_react_extra_router_RendererF(new $c_sjsr_AnonFunction1(((rc$2) => {
    var rc = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(rc$2);
    return $as_F1($n(this.Ljapgolly_scalajs_react_extra_router_RendererF__f_render).apply__O__O($n(rc).withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RouterCtlF(this.Ljapgolly_scalajs_react_extra_router_RendererF__f_sync)))
  })), G))
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.productPrefix__T = (function() {
  return "RendererF"
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_RendererF__f_render : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RendererF)) {
    var RendererF$1 = $as_Ljapgolly_scalajs_react_extra_router_RendererF(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RendererF__f_render;
    var x$2 = $n(RendererF$1).Ljapgolly_scalajs_react_extra_router_RendererF__f_render;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_ActionF = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RendererF(G)
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.map__F1__Ljapgolly_scalajs_react_extra_router_ActionF = (function(f) {
  return this.map__F1__Ljapgolly_scalajs_react_extra_router_RendererF(f)
});
function $as_Ljapgolly_scalajs_react_extra_router_RendererF(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RendererF) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RendererF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RendererF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RendererF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RendererF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RendererF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RendererF;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RendererF = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RendererF: 0
}, false, "japgolly.scalajs.react.extra.router.RendererF", {
  Ljapgolly_scalajs_react_extra_router_RendererF: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_ActionF: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RendererF.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RendererF;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouteCmd();
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype.productPrefix__T = (function() {
  return "BroadcastSync"
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype.productArity__I = (function() {
  return 0
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype.hashCode__I = (function() {
  return (-155951396)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype.toString__T = (function() {
  return "BroadcastSync"
});
var $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$: 0
}, false, "japgolly.scalajs.react.extra.router.RouteCmd$BroadcastSync$", {
  Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$: 1,
  Ljapgolly_scalajs_react_extra_router_RouteCmd: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$;
var $n_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$;
function $m_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$)) {
    $n_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$ = new $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_RouteCmd$BroadcastSync$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(msg) {
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Log__f_msg = null;
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Log__f_msg = msg
}
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouteCmd();
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype.productPrefix__T = (function() {
  return "Log"
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Log__f_msg : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log)) {
    var Log$1 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Log__f_msg;
    var x$2 = $n(Log$1).Ljapgolly_scalajs_react_extra_router_RouteCmd$Log__f_msg;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouteCmd$Log"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouteCmd$Log)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouteCmd$Log;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouteCmd$Log: 0
}, false, "japgolly.scalajs.react.extra.router.RouteCmd$Log", {
  Ljapgolly_scalajs_react_extra_router_RouteCmd$Log: 1,
  Ljapgolly_scalajs_react_extra_router_RouteCmd: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$Log;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState(url) {
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState__f_url = null;
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState__f_url = url
}
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouteCmd();
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype.productPrefix__T = (function() {
  return "PushState"
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState__f_url : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState)) {
    var PushState$1 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState__f_url;
    var x$2 = $n(PushState$1).Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState__f_url;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouteCmd$PushState"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouteCmd$PushState;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState: 0
}, false, "japgolly.scalajs.react.extra.router.RouteCmd$PushState", {
  Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState: 1,
  Ljapgolly_scalajs_react_extra_router_RouteCmd: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$PushState;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState(url) {
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState__f_url = null;
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState__f_url = url
}
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouteCmd();
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype.productPrefix__T = (function() {
  return "ReplaceState"
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState__f_url : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState)) {
    var ReplaceState$1 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState__f_url;
    var x$2 = $n(ReplaceState$1).Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState__f_url;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouteCmd$ReplaceState"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouteCmd$ReplaceState;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState: 0
}, false, "japgolly.scalajs.react.extra.router.RouteCmd$ReplaceState", {
  Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState: 1,
  Ljapgolly_scalajs_react_extra_router_RouteCmd: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$ReplaceState;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return(a) {
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Return__f_a = null;
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Return__f_a = a
}
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouteCmd();
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype.productPrefix__T = (function() {
  return "Return"
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Return__f_a : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return)) {
    var Return$1 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Return__f_a;
    var y = $n(Return$1).Ljapgolly_scalajs_react_extra_router_RouteCmd$Return__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouteCmd$Return"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouteCmd$Return)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouteCmd$Return;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouteCmd$Return: 0
}, false, "japgolly.scalajs.react.extra.router.RouteCmd$Return", {
  Ljapgolly_scalajs_react_extra_router_RouteCmd$Return: 1,
  Ljapgolly_scalajs_react_extra_router_RouteCmd: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$Return;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence(init, last) {
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_init = null;
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_last = null;
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_init = init;
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_last = last
}
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouteCmd();
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype.productPrefix__T = (function() {
  return "Sequence"
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype.productArity__I = (function() {
  return 2
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_init;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_last;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence)) {
    var Sequence$1 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_init;
    var x$2 = $n(Sequence$1).Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_init;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_last;
      var x$4 = $n(Sequence$1).Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence__f_last;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouteCmd$Sequence"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouteCmd$Sequence;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence: 0
}, false, "japgolly.scalajs.react.extra.router.RouteCmd$Sequence", {
  Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence: 1,
  Ljapgolly_scalajs_react_extra_router_RouteCmd: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$Sequence;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation(url) {
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation__f_url = null;
  this.Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation__f_url = url
}
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouteCmd();
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype.productPrefix__T = (function() {
  return "SetWindowLocation"
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation__f_url : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation)) {
    var SetWindowLocation$1 = $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation__f_url;
    var x$2 = $n(SetWindowLocation$1).Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation__f_url;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouteCmd$SetWindowLocation"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouteCmd$SetWindowLocation;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation: 0
}, false, "japgolly.scalajs.react.extra.router.RouteCmd$SetWindowLocation", {
  Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation: 1,
  Ljapgolly_scalajs_react_extra_router_RouteCmd: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouteCmd$SetWindowLocation;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1(outer, page$1) {
  this.Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1__f_page$1 = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1__f_page$1 = page$1
}
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x1, default$1) {
  var x = this.Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1__f_page$1;
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, x1)) {
    return x1
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x1) {
  var x = this.Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1__f_page$1;
  return $m_sr_BoxesRunTime$().equals__O__O__Z(x, x1)
});
var $d_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1: 0
}, false, "japgolly.scalajs.react.extra.router.RouterConfigDsl$$anonfun$1", {
  Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterConfigDsl$$anonfun$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect(u, G) {
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_G = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u = u;
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_G = G
}
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouterCtlF();
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.F__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  return this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_G
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.baseUrl__Ljapgolly_scalajs_react_extra_router_BaseUrl = (function() {
  return $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u).baseUrl__Ljapgolly_scalajs_react_extra_router_BaseUrl()
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.refresh__O = (function() {
  var this$2 = $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_G);
  var ga = new $c_sjsr_AnonFunction0((() => $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u).refresh__O()));
  var g = $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u).F__Ljapgolly_scalajs_react_util_Effect$Sync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.pathFor__O__Ljapgolly_scalajs_react_extra_router_Path = (function(a) {
  return $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u).pathFor__O__Ljapgolly_scalajs_react_extra_router_Path(a)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O = (function(a, v) {
  var this$2 = $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_G);
  var ga = new $c_sjsr_AnonFunction0((() => $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u).set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(a, v)));
  var g = $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u).F__Ljapgolly_scalajs_react_util_Effect$Sync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_RouterCtlF = (function(H) {
  var this$1 = $n(H);
  var g = this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_G;
  if ((this$1 === g)) {
    var $$x1 = this
  } else {
    var this$2 = $n(H);
    var xg = this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u;
    var g$1 = $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u).F__Ljapgolly_scalajs_react_util_Effect$Sync();
    var $$x1 = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF(((this$2 === g$1) ? xg : new $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u, H)))
  };
  return $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF($$x1)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.productPrefix__T = (function() {
  return "AltEffect"
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect)) {
    var AltEffect$1 = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u;
    var x$2 = $n(AltEffect$1).Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect__f_u;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouterCtlF$AltEffect"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouterCtlF$AltEffect;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect: 0
}, false, "japgolly.scalajs.react.extra.router.RouterCtlF$AltEffect", {
  Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect: 1,
  Ljapgolly_scalajs_react_extra_router_RouterCtlF: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterCtlF$AltEffect;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(u, f, x) {
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_f = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_x = null;
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u = u;
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_f = f;
  this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_x = x
}
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype = new $h_Ljapgolly_scalajs_react_extra_router_RouterCtlF();
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype = $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.F__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  return this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_x
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.baseUrl__Ljapgolly_scalajs_react_extra_router_BaseUrl = (function() {
  return $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u).baseUrl__Ljapgolly_scalajs_react_extra_router_BaseUrl()
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.refresh__O = (function() {
  return $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u).refresh__O()
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.pathFor__O__Ljapgolly_scalajs_react_extra_router_Path = (function(b) {
  return $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u).pathFor__O__Ljapgolly_scalajs_react_extra_router_Path($n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_f).apply__O__O(b))
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O = (function(b, v) {
  return $n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u).set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O($n(this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_f).apply__O__O(b), v)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.productPrefix__T = (function() {
  return "Contramap"
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.productArity__I = (function() {
  return 2
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap)) {
    var Contramap$1 = $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u;
    var x$2 = $n(Contramap$1).Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_u;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_f;
      var x$4 = $n(Contramap$1).Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap__f_f;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RouterCtlF$Contramap"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RouterCtlF$Contramap;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap: 0
}, false, "japgolly.scalajs.react.extra.router.RouterCtlF$Contramap", {
  Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap: 1,
  Ljapgolly_scalajs_react_extra_router_RouterCtlF: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RouterCtlF$Contramap;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(parse, path, action) {
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_parse = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_path = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_action = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_parse = parse;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_path = path;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_action = action
}
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.pmapF__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule = (function(f, g) {
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11 = $as_Ljapgolly_scalajs_react_extra_router_Path(x$11$2);
    var this$2 = $n($as_s_Option($n(this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_parse).apply__O__O(x$11)));
    if (this$2.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      var x$12 = $as_s_util_Either(arg1);
      if ((x$12 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(x$12);
        var b = $n(x2).s_util_Right__f_value;
        $n($m_s_package$().s_package$__f_Right);
        var value = $n(f).apply__O__O(b);
        var $$x1 = new $c_s_util_Right(value)
      } else if ((x$12 instanceof $c_s_util_Left)) {
        var x3 = $as_s_util_Left(x$12);
        var a = $n(x3).s_util_Left__f_value;
        $n($m_s_package$().s_package$__f_Left);
        var x$13 = $as_Ljapgolly_scalajs_react_extra_router_Redirect(a);
        var value$1 = $n(x$13).map__F1__Ljapgolly_scalajs_react_extra_router_Redirect(f);
        var $$x1 = new $c_s_util_Left(value$1)
      } else {
        var $$x1;
        throw new $c_s_MatchError(x$12)
      };
      return new $c_s_Some($$x1)
    }
  })), new $c_sjsr_AnonFunction1(((x$14$2) => {
    var this$7 = $n($as_s_Option($n(g).apply__O__O(x$14$2)));
    var f$1 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_path;
    return (this$7.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(f$1).apply__O__O(this$7.get__O())))
  })), new $c_sjsr_AnonFunction2(((path$2, w$2) => {
    var path = $as_Ljapgolly_scalajs_react_extra_router_Path(path$2);
    var this$8 = $n($as_s_Option($n(g).apply__O__O(w$2)));
    if (this$8.isEmpty__Z()) {
      var $$x2 = $m_s_None$()
    } else {
      var arg1$1 = this$8.get__O();
      var $$x2 = $as_s_Option($n(this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_action).apply__O__O__O(path, arg1$1))
    };
    var this$9 = $n($$x2);
    if (this$9.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1$2 = this$9.get__O();
      var x$16 = $as_Ljapgolly_scalajs_react_extra_router_ActionF(arg1$2);
      return new $c_s_Some($n(x$16).map__F1__Ljapgolly_scalajs_react_extra_router_ActionF(f))
    }
  })))
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.modPath__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule = (function(onCreate, onParse) {
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(new $c_sjsr_AnonFunction1(((x$17$2) => {
    var x$17 = $as_Ljapgolly_scalajs_react_extra_router_Path(x$17$2);
    var this$2 = $n($as_s_Option($n(onParse).apply__O__O(x$17)));
    var f = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_parse;
    return (this$2.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(f).apply__O__O(this$2.get__O())))
  })), new $c_sjsr_AnonFunction1(((x$18$2) => {
    var this$3 = $n($as_s_Option($n(this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_path).apply__O__O(x$18$2)));
    return (this$3.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(onCreate).apply__O__O(this$3.get__O())))
  })), this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_action)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.productPrefix__T = (function() {
  return "Atom"
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.productArity__I = (function() {
  return 3
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_parse;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_path;
      break
    }
    case 2: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_action;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom)) {
    var Atom$1 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_parse;
    var x$2 = $n(Atom$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_parse;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_path;
      var x$4 = $n(Atom$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_path;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_action;
        var x$6 = $n(Atom$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom__f_action;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$1 = $n(x$5);
          return (this$1 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RoutingRule$Atom"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RoutingRule$Atom;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRule$Atom", {
  Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_RoutingRule: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$Atom;
function $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$AutoCorrect(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RoutingRule$AutoCorrect"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$AutoCorrect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RoutingRule$AutoCorrect)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$AutoCorrect(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$AutoCorrect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RoutingRule$AutoCorrect;", depth))
}
function $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Conditional(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RoutingRule$Conditional"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$Conditional(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RoutingRule$Conditional)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$Conditional(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$Conditional(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RoutingRule$Conditional;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(condition, underlying, otherwise) {
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_condition = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_otherwise = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_condition = condition;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying = underlying;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_otherwise = otherwise
}
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.pmapF__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule = (function(f, g) {
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(new $c_sjsr_AnonFunction1(((x$24$2) => {
    var this$2 = $n($as_s_Option($n(g).apply__O__O(x$24$2)));
    var f$1 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_condition;
    return (this$2.isEmpty__Z() ? (() => false) : $n(f$1).apply__O__O(this$2.get__O()))
  })), $n(this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying).pmapF__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule(f, g), new $c_sjsr_AnonFunction1(((x$25$2) => {
    var this$3 = $n($as_s_Option($n(g).apply__O__O(x$25$2)));
    if (this$3.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$3.get__O();
      var this$4 = $n($as_s_Option($n(this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_otherwise).apply__O__O(arg1)));
      if (this$4.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1$1 = this$4.get__O();
        var x$27 = $as_Ljapgolly_scalajs_react_extra_router_ActionF(arg1$1);
        return new $c_s_Some($n(x$27).map__F1__Ljapgolly_scalajs_react_extra_router_ActionF(f))
      }
    }
  })))
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.modPath__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule = (function(onCreate, onParse) {
  var x$1 = $n(this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying).modPath__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule(onCreate, onParse);
  var x$2 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_condition;
  var x$3 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_otherwise;
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(x$2, x$1, x$3)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.productPrefix__T = (function() {
  return "ConditionalP"
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.productArity__I = (function() {
  return 3
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_condition;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying;
      break
    }
    case 2: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_otherwise;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP)) {
    var ConditionalP$1 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_condition;
    var x$2 = $n(ConditionalP$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_condition;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying;
      var x$4 = $n(ConditionalP$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_underlying;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_otherwise;
        var x$6 = $n(ConditionalP$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP__f_otherwise;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RoutingRule$ConditionalP"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RoutingRule$ConditionalP;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRule$ConditionalP", {
  Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_RoutingRule: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$ConditionalP;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(lhs, rhs) {
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs = null;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs = lhs;
  this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs = rhs
}
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype = $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.pmapF__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule = (function(f, g) {
  var f$1 = ((x$29$2) => {
    var x$29 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule(x$29$2);
    return $n(x$29).pmapF__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule(f, g)
  });
  var arg1 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs;
  var $$x1 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule(f$1(arg1));
  var arg1$1 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs;
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or($$x1, $as_Ljapgolly_scalajs_react_extra_router_RoutingRule(f$1(arg1$1)))
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.modPath__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule = (function(onCreate, onParse) {
  var f = ((x$30$2) => {
    var x$30 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule(x$30$2);
    return $n(x$30).modPath__F1__F1__Ljapgolly_scalajs_react_extra_router_RoutingRule(onCreate, onParse)
  });
  var arg1 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs;
  var $$x1 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule(f(arg1));
  var arg1$1 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs;
  return new $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or($$x1, $as_Ljapgolly_scalajs_react_extra_router_RoutingRule(f(arg1$1)))
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.productPrefix__T = (function() {
  return "Or"
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.productArity__I = (function() {
  return 2
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or)) {
    var Or$1 = $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs;
    var x$2 = $n(Or$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_lhs;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs;
      var x$4 = $n(Or$1).Ljapgolly_scalajs_react_extra_router_RoutingRule$Or__f_rhs;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RoutingRule$Or"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RoutingRule$Or)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RoutingRule$Or;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRule$Or: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRule$Or", {
  Ljapgolly_scalajs_react_extra_router_RoutingRule$Or: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_RoutingRule: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRule$Or;
class $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$Exception extends $c_jl_RuntimeException {
  constructor(msg) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true)
  };
}
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$Exception = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF$Exception: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRulesF$Exception", {
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF$Exception: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$Exception.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$Exception;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1.prototype = $c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1.prototype.applyOrElse__s_Option__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var a = $n(x2).s_Some__f_value;
    return a
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1.prototype.isDefinedAt__s_Option__Z = (function(x1) {
  return (x1 instanceof $c_s_Some)
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z($as_s_Option(x))
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O($as_s_Option(x), default$1)
});
var $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1: 0
}, false, "japgolly.scalajs.react.extra.router.RoutingRulesF$SharedLogic$$anonfun$1", {
  Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RoutingRulesF$SharedLogic$$anonfun$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype = $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype.productPrefix__T = (function() {
  return "HistoryPush"
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype.productArity__I = (function() {
  return 0
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype.hashCode__I = (function() {
  return 2019771822
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype.toString__T = (function() {
  return "HistoryPush"
});
var $d_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$: 0
}, false, "japgolly.scalajs.react.extra.router.SetRouteVia$HistoryPush$", {
  Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_SetRouteVia: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$;
var $n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$;
function $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$)) {
    $n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$ = new $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype = $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype.productPrefix__T = (function() {
  return "HistoryReplace"
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype.productArity__I = (function() {
  return 0
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype.hashCode__I = (function() {
  return (-155081824)
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype.toString__T = (function() {
  return "HistoryReplace"
});
var $d_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$: 0
}, false, "japgolly.scalajs.react.extra.router.SetRouteVia$HistoryReplace$", {
  Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_SetRouteVia: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$;
var $n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$;
function $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$)) {
    $n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$ = new $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryReplace$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype = $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype;
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype.productPrefix__T = (function() {
  return "WindowLocation"
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype.productArity__I = (function() {
  return 0
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype.hashCode__I = (function() {
  return 1520024549
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype.toString__T = (function() {
  return "WindowLocation"
});
var $d_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$: 0
}, false, "japgolly.scalajs.react.extra.router.SetRouteVia$WindowLocation$", {
  Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_SetRouteVia: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$;
var $n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$;
function $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$() {
  if ((!$n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$)) {
    $n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$ = new $c_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$()
  };
  return $n_Ljapgolly_scalajs_react_extra_router_SetRouteVia$WindowLocation$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(renderFn) {
  this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent__f_renderFn = null;
  this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent__f_renderFn = renderFn
}
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype.self__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent = (function(f, step) {
  var this$1 = $n(step);
  return $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent($n($f_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep__self__F2(this$1)).apply__O__O__O(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent__f_renderFn, f))
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype.next__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep__O = (function(f, step) {
  return $n($n(step).next__F2()).apply__O__O__O(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent__f_renderFn, f)
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype.render__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(f, s) {
  return $m_Ljapgolly_scalajs_react_component_ScalaFn$().apply__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($as_F1($n(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent__f_renderFn).apply__O__O(f)), s)
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.next__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep__O(f, $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep(step))
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.self__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(f, $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep(step))
});
function $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$Subsequent"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$Subsequent;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent: 0
}, false, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentP$Subsequent", {
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender: 1,
  Ljapgolly_scalajs_react_hooks_Api$PrimaryWithRender: 1,
  Ljapgolly_scalajs_react_hooks_Api$Primary: 1,
  Ljapgolly_scalajs_react_hooks_Api$Secondary: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$Subsequent;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(renderFn) {
  this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent__f_renderFn = null;
  this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent__f_renderFn = renderFn
}
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype = $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype.self__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent = (function(f, step) {
  var this$1 = $n(step);
  return $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent($n($f_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep__self__F2(this$1)).apply__O__O__O(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent__f_renderFn, f))
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype.next__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep__O = (function(f, step) {
  return $n($n(step).next__F2()).apply__O__O__O(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent__f_renderFn, f)
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype.render__F1__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(f, s) {
  return $m_Ljapgolly_scalajs_react_component_ScalaFn$().withChildren__F2__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($as_F2($n(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent__f_renderFn).apply__O__O(f)), s)
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype.renderWithReuseBy__F1__F1__Ljapgolly_scalajs_react_CtorType$Summoner__F2__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(reusableInputs, f, s, r) {
  var hook = $m_Ljapgolly_scalajs_react_hooks_CustomHook$().shouldComponentUpdate__F1__F2__F1(f, r);
  return $m_Ljapgolly_scalajs_react_component_ScalaFn$().withChildren__F2__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot($as_F2($n(this.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent__f_renderFn).apply__O__O(new $c_sjsr_AnonFunction1(((ctx$2) => $as_Ljapgolly_scalajs_react_vdom_VdomNode($n(hook).apply__O__O(new $c_sjsr_AnonFunction0((() => $n(reusableInputs).apply__O__O(ctx$2))))))))), s)
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype.next__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.next__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep__O(f, $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep(step))
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype.self__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O = (function(f, step) {
  return this.self__F1__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(f, $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$SubsequentStep(step))
});
function $as_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$Subsequent"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$Subsequent;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent: 0
}, false, "japgolly.scalajs.react.hooks.HookComponentBuilder$ComponentPC$Subsequent", {
  Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent: 1,
  O: 1,
  Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender: 1,
  Ljapgolly_scalajs_react_hooks_Api$PrimaryWithRender: 1,
  Ljapgolly_scalajs_react_hooks_Api$Primary: 1,
  Ljapgolly_scalajs_react_hooks_Api$Secondary: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentPC$Subsequent;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I4__O__O__O__O__O__($thiz, input, hook1, hook2, hook3, hook4) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4 = hook4;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I3__O__O__O__O__($thiz, input, hook1, hook2, hook3);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$I4() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I4.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$I3();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I4.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I4;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$I4() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$I4.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I4.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I4.prototype.toString__T = (function() {
  return (((((((((("HookCtx.withInput(\n  input = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$I4(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$I4) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$I4"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$I4)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I4(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$I4;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$I4 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$I4: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$I4", {
  Ljapgolly_scalajs_react_hooks_HookCtx$I4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I4.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$I4;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P4__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = hook4;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P3__O__O__O__O__($thiz, props, hook1, hook2, hook3);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P4() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P4.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P3();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P4.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P4;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P4() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P4.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P4.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P4.prototype.toString__T = (function() {
  return (((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P4(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P4) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P4"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P4)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P4(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P4;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P4 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P4", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P4.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P4;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC3__O__sjs_js_Any__O__O__O__($thiz, props, propsChildren, hook1, hook2, hook3) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$PC3__f_hook3 = hook3;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC2__O__sjs_js_Any__O__O__($thiz, props, propsChildren, hook1, hook2);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC3__f_hook3 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$PC2();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$PC3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$PC3.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3.prototype.toString__T = (function() {
  return (((((((((("HookCtx.withChildren(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  propsChildren = ") + new $c_Ljapgolly_scalajs_react_PropsChildren(this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren)) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC3__f_hook3) + ")")
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3.prototype.apply3__F5__O = (function(f) {
  return $n(f).apply__O__O__O__O__O__O(this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props, new $c_Ljapgolly_scalajs_react_PropsChildren(this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren), this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1, this.Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2, this.Ljapgolly_scalajs_react_hooks_HookCtx$PC3__f_hook3)
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$PC3(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$PC3"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$PC3)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC3(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$PC3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$PC3;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$PC3: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$PC3", {
  Ljapgolly_scalajs_react_hooks_HookCtx$PC3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC0: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC3.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC3;
function $f_Ljapgolly_scalajs_react_internal_CoreGeneral__$init$__V($thiz) {
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$GenericComponent_$eq__Ljapgolly_scalajs_react_component_Generic$__V($m_Ljapgolly_scalajs_react_component_Generic$());
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$JsComponent_$eq__Ljapgolly_scalajs_react_component_Js$__V($m_Ljapgolly_scalajs_react_component_Js$());
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$JsFnComponent_$eq__Ljapgolly_scalajs_react_component_JsFn$__V($m_Ljapgolly_scalajs_react_component_JsFn$());
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$JsForwardRefComponent_$eq__Ljapgolly_scalajs_react_component_JsForwardRef$__V($m_Ljapgolly_scalajs_react_component_JsForwardRef$());
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$ScalaFnComponent_$eq__Ljapgolly_scalajs_react_component_ScalaFn$__V($m_Ljapgolly_scalajs_react_component_ScalaFn$());
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$ScalaForwardRefComponent_$eq__Ljapgolly_scalajs_react_component_ScalaForwardRef$__V($m_Ljapgolly_scalajs_react_component_ScalaForwardRef$());
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$CustomHook_$eq__Ljapgolly_scalajs_react_hooks_CustomHook$__V($m_Ljapgolly_scalajs_react_hooks_CustomHook$());
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$Hooks_$eq__Ljapgolly_scalajs_react_hooks_Hooks$__V($m_Ljapgolly_scalajs_react_hooks_Hooks$());
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$HooksApi_$eq__Ljapgolly_scalajs_react_hooks_Api$__V($m_Ljapgolly_scalajs_react_hooks_Api$());
  $thiz.japgolly$scalajs$react$internal$CoreGeneral$_setter_$ReactEffect_$eq__Ljapgolly_scalajs_react_util_Effect$__V($m_Ljapgolly_scalajs_react_util_Effect$())
}
function $f_Ljapgolly_scalajs_react_util_Effect$Dispatch$WithDefaults__dispatchFn__F0__sjs_js_Function0($thiz, fa) {
  return (() => {
    $thiz.dispatch__O__V($n(fa).apply__O())
  })
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_EffectFallbacks2() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_EffectFallbacks2.prototype = new $h_Ljapgolly_scalajs_react_util_EffectFallbacks3();
$c_Ljapgolly_scalajs_react_util_EffectFallbacks2.prototype.constructor = $c_Ljapgolly_scalajs_react_util_EffectFallbacks2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_EffectFallbacks2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_EffectFallbacks2.prototype = $c_Ljapgolly_scalajs_react_util_EffectFallbacks2.prototype;
function $p_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__reusableDefaultSync$lzycompute__F1($thiz) {
  if ((!$thiz.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_bitmap$0)) {
    var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var F = this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
    $thiz.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_reusableDefaultSync = $f_Ljapgolly_scalajs_react_vdom_Attr$EventCallback1__reusableDispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($thiz, F);
    $thiz.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_bitmap$0 = true
  };
  return $thiz.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_reusableDefaultSync
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$() {
  this.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync = null;
  this.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_reusableDefaultSync = null;
  this.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_bitmap$0 = false;
  $n_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$ = this;
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var F = this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  this.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync = $f_Ljapgolly_scalajs_react_vdom_Attr$EventCallback2__dispatch__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1(this, F)
}
$c_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$.prototype = $c_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$.prototype;
$c_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$.prototype.reusableDefaultSync__F1 = (function() {
  return ((!this.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_bitmap$0) ? $p_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__reusableDefaultSync$lzycompute__F1(this) : this.Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_reusableDefaultSync)
});
var $d_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_Attr$EventCallback$: 0
}, false, "japgolly.scalajs.react.vdom.Attr$EventCallback$", {
  Ljapgolly_scalajs_react_vdom_Attr$EventCallback$: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_Attr$EventCallback3: 1,
  Ljapgolly_scalajs_react_vdom_Attr$EventCallback2: 1,
  Ljapgolly_scalajs_react_vdom_Attr$EventCallback1: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$;
var $n_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$;
function $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$)) {
    $n_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$ = new $c_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlTags$a$(outer) {
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_rawElement = null;
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_tag = null;
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_modifiers = null;
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_bitmap$0 = false;
  $ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(this, "a", $m_s_package$().s_package$__f_Nil)
}
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$a$.prototype = new $h_Ljapgolly_scalajs_react_vdom_TagOf();
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$a$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlTags$a$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlTags$a$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlTags$a$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlTags$a$.prototype;
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$a$.prototype.toNewWindow__T__Z__Z__Ljapgolly_scalajs_react_vdom_TagOf = (function(href, noopener, noreferrer) {
  var this$1 = $n($m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$().target__Ljapgolly_scalajs_react_vdom_HtmlAttrs$target$());
  var t = $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$1.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "_blank");
  $m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$4 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "href");
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_string;
  var array = [$$x1, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$4.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, href)];
  var a = this.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var x1 = new $c_T2$mcZZ$sp(noopener, noreferrer);
  var p2 = x1.T2$mcZZ$sp__f__1$mcZ$sp;
  var p3 = x1.T2$mcZZ$sp__f__2$mcZ$sp;
  if (((p2 === true) && (p3 === false))) {
    var $$x2 = $n(a);
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$10 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rel");
    var t$2 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_string;
    var array$1 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$10.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "noopener")];
    return $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  };
  var p6 = x1.T2$mcZZ$sp__f__1$mcZ$sp;
  var p7 = x1.T2$mcZZ$sp__f__2$mcZ$sp;
  if (((p6 === true) && (p7 === true))) {
    var $$x3 = $n(a);
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$16 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rel");
    var t$3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_string;
    var array$2 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$16.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "noopener noreferrer")];
    return $n($$x3).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  };
  var p10 = x1.T2$mcZZ$sp__f__1$mcZ$sp;
  var p11 = x1.T2$mcZZ$sp__f__2$mcZ$sp;
  if (((p10 === false) && (p11 === true))) {
    var $$x4 = $n(a);
    $m_Ljapgolly_scalajs_react_vdom_HtmlAttrs$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$22 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "rel");
    var t$4 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_string;
    var array$3 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$22.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "noreferrer")];
    return $n($$x4).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  };
  var p14 = x1.T2$mcZZ$sp__f__1$mcZ$sp;
  var p15 = x1.T2$mcZZ$sp__f__2$mcZ$sp;
  if (((p14 === false) && (p15 === false))) {
    return a
  };
  throw new $c_s_MatchError(x1)
});
var $d_Ljapgolly_scalajs_react_vdom_HtmlTags$a$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlTags$a$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlTags$a$", {
  Ljapgolly_scalajs_react_vdom_HtmlTags$a$: 1,
  Ljapgolly_scalajs_react_vdom_TagOf: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_VdomElement: 1,
  Ljapgolly_scalajs_react_vdom_VdomNode: 1,
  Ljapgolly_scalajs_react_vdom_TagMod: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$a$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlTags$a$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_HtmlTags$input$(outer) {
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_rawElement = null;
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_tag = null;
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_modifiers = null;
  this.Ljapgolly_scalajs_react_vdom_TagOf__f_bitmap$0 = false;
  this.Ljapgolly_scalajs_react_vdom_HtmlTags$input$__f_type = null;
  this.Ljapgolly_scalajs_react_vdom_HtmlTags$input$__f_checkbox = null;
  $ct_Ljapgolly_scalajs_react_vdom_TagOf__T__sci_List__(this, "input", $m_s_package$().s_package$__f_Nil);
  this.Ljapgolly_scalajs_react_vdom_HtmlTags$input$__f_type = ($n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr), $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "type"));
  this.Ljapgolly_scalajs_react_vdom_HtmlTags$input$__f_checkbox = this.withType__T__Ljapgolly_scalajs_react_vdom_TagOf("checkbox");
  this.withType__T__Ljapgolly_scalajs_react_vdom_TagOf("text")
}
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$input$.prototype = new $h_Ljapgolly_scalajs_react_vdom_TagOf();
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$input$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_HtmlTags$input$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_HtmlTags$input$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_HtmlTags$input$.prototype = $c_Ljapgolly_scalajs_react_vdom_HtmlTags$input$.prototype;
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$input$.prototype.withType__T__Ljapgolly_scalajs_react_vdom_TagOf = (function(t) {
  var array = [$n(this.Ljapgolly_scalajs_react_vdom_HtmlTags$input$__f_type).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(t, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().Ljapgolly_scalajs_react_vdom_Attr$ValueType$__f_string)];
  return this.apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
var $d_Ljapgolly_scalajs_react_vdom_HtmlTags$input$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_HtmlTags$input$: 0
}, false, "japgolly.scalajs.react.vdom.HtmlTags$input$", {
  Ljapgolly_scalajs_react_vdom_HtmlTags$input$: 1,
  Ljapgolly_scalajs_react_vdom_TagOf: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_VdomElement: 1,
  Ljapgolly_scalajs_react_vdom_VdomNode: 1,
  Ljapgolly_scalajs_react_vdom_TagMod: 1
});
$c_Ljapgolly_scalajs_react_vdom_HtmlTags$input$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_HtmlTags$input$;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_TagMod$Composite(mods) {
  this.Ljapgolly_scalajs_react_vdom_TagMod$Composite__f_mods = null;
  this.Ljapgolly_scalajs_react_vdom_TagMod$Composite__f_mods = mods
}
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_TagMod$Composite;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_TagMod$Composite() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype = $c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype;
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.applyTo__Ljapgolly_scalajs_react_vdom_VdomBuilder__V = (function(b) {
  $n(this.Ljapgolly_scalajs_react_vdom_TagMod$Composite__f_mods).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Ljapgolly_scalajs_react_vdom_TagMod(x$1$2);
    $n(x$1).applyTo__Ljapgolly_scalajs_react_vdom_VdomBuilder__V(b)
  })))
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.productPrefix__T = (function() {
  return "Composite"
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_vdom_TagMod$Composite__f_mods : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_vdom_TagMod$Composite)) {
    var Composite$1 = $as_Ljapgolly_scalajs_react_vdom_TagMod$Composite(x$1);
    var x = this.Ljapgolly_scalajs_react_vdom_TagMod$Composite__f_mods;
    var x$2 = $n(Composite$1).Ljapgolly_scalajs_react_vdom_TagMod$Composite__f_mods;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_vdom_TagMod$Composite(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_vdom_TagMod$Composite) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.vdom.TagMod$Composite"))
}
function $isArrayOf_Ljapgolly_scalajs_react_vdom_TagMod$Composite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_vdom_TagMod$Composite)))
}
function $asArrayOf_Ljapgolly_scalajs_react_vdom_TagMod$Composite(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_vdom_TagMod$Composite(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.vdom.TagMod$Composite;", depth))
}
var $d_Ljapgolly_scalajs_react_vdom_TagMod$Composite = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_TagMod$Composite: 0
}, false, "japgolly.scalajs.react.vdom.TagMod$Composite", {
  Ljapgolly_scalajs_react_vdom_TagMod$Composite: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_TagMod: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_vdom_TagMod$Composite.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_TagMod$Composite;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_all$svg$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_vdom_all$svg$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_vdom_all$svg$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_all$svg$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_all$svg$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_all$svg$.prototype = $c_Ljapgolly_scalajs_react_vdom_all$svg$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_all$svg$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_all$svg$: 0
}, false, "japgolly.scalajs.react.vdom.all$svg$", {
  Ljapgolly_scalajs_react_vdom_all$svg$: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_SvgTags: 1,
  Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles: 1,
  Ljapgolly_scalajs_react_vdom_SvgAttrs: 1,
  Ljapgolly_scalajs_react_vdom_SvgStyles: 1
});
$c_Ljapgolly_scalajs_react_vdom_all$svg$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_all$svg$;
var $n_Ljapgolly_scalajs_react_vdom_all$svg$;
function $m_Ljapgolly_scalajs_react_vdom_all$svg$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_all$svg$)) {
    $n_Ljapgolly_scalajs_react_vdom_all$svg$ = new $c_Ljapgolly_scalajs_react_vdom_all$svg$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_all$svg$
}
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  return $thiz
}
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
  /*<skip>*/
}
$c_Ljava_io_FilterOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_Ljava_io_FilterOutputStream.prototype.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
  /*<skip>*/
}
$h_Ljava_io_FilterOutputStream.prototype = $c_Ljava_io_FilterOutputStream.prototype;
class $c_jl_ArithmeticException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
function $as_jl_ArithmeticException(obj) {
  return (((obj instanceof $c_jl_ArithmeticException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ArithmeticException"))
}
function $isArrayOf_jl_ArithmeticException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArithmeticException)))
}
function $asArrayOf_jl_ArithmeticException(obj, depth) {
  return (($isArrayOf_jl_ArithmeticException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ArithmeticException;", depth))
}
var $d_jl_ArithmeticException = new $TypeData().initClass({
  jl_ArithmeticException: 0
}, false, "java.lang.ArithmeticException", {
  jl_ArithmeticException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ArithmeticException.prototype.$classData = $d_jl_ArithmeticException;
class $c_jl_ArrayStoreException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_jl_ArrayStoreException = new $TypeData().initClass({
  jl_ArrayStoreException: 0
}, false, "java.lang.ArrayStoreException", {
  jl_ArrayStoreException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ArrayStoreException.prototype.$classData = $d_jl_ArrayStoreException;
function $f_jl_Byte__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Byte__hashCode__I($thiz) {
  return $thiz
}
function $f_jl_Byte__toString__T($thiz) {
  return ("" + $thiz)
}
function $f_jl_Byte__compareTo__O__I($thiz, o) {
  var that = $as_jl_Byte(o);
  var this$1 = $n(that);
  return (($thiz - this$1) | 0)
}
function $as_jl_Byte(obj) {
  return (($isByte(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Byte"))
}
function $isArrayOf_jl_Byte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Byte)))
}
function $asArrayOf_jl_Byte(obj, depth) {
  return (($isArrayOf_jl_Byte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Byte;", depth))
}
var $d_jl_Byte = new $TypeData().initClass({
  jl_Byte: 0
}, false, "java.lang.Byte", {
  jl_Byte: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => $isByte(x)));
function $ct_jl_ClassCastException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_ClassCastException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_ClassCastException extends $c_jl_RuntimeException {
}
function $as_jl_ClassCastException(obj) {
  return (((obj instanceof $c_jl_ClassCastException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ClassCastException"))
}
function $isArrayOf_jl_ClassCastException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ClassCastException)))
}
function $asArrayOf_jl_ClassCastException(obj, depth) {
  return (($isArrayOf_jl_ClassCastException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ClassCastException;", depth))
}
var $d_jl_ClassCastException = new $TypeData().initClass({
  jl_ClassCastException: 0
}, false, "java.lang.ClassCastException", {
  jl_ClassCastException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ClassCastException.prototype.$classData = $d_jl_ClassCastException;
function $ct_jl_IllegalArgumentException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IllegalArgumentException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_IllegalArgumentException extends $c_jl_RuntimeException {
}
function $as_jl_IllegalArgumentException(obj) {
  return (((obj instanceof $c_jl_IllegalArgumentException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.IllegalArgumentException"))
}
function $isArrayOf_jl_IllegalArgumentException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_IllegalArgumentException)))
}
function $asArrayOf_jl_IllegalArgumentException(obj, depth) {
  return (($isArrayOf_jl_IllegalArgumentException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.IllegalArgumentException;", depth))
}
var $d_jl_IllegalArgumentException = new $TypeData().initClass({
  jl_IllegalArgumentException: 0
}, false, "java.lang.IllegalArgumentException", {
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IllegalArgumentException.prototype.$classData = $d_jl_IllegalArgumentException;
function $ct_jl_IllegalStateException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IllegalStateException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_IllegalStateException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalStateException = new $TypeData().initClass({
  jl_IllegalStateException: 0
}, false, "java.lang.IllegalStateException", {
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IllegalStateException.prototype.$classData = $d_jl_IllegalStateException;
function $ct_jl_IndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_IndexOutOfBoundsException extends $c_jl_RuntimeException {
}
var $d_jl_IndexOutOfBoundsException = new $TypeData().initClass({
  jl_IndexOutOfBoundsException: 0
}, false, "java.lang.IndexOutOfBoundsException", {
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IndexOutOfBoundsException.prototype.$classData = $d_jl_IndexOutOfBoundsException;
class $c_jl_InstantiationException extends $c_jl_ReflectiveOperationException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_jl_InstantiationException = new $TypeData().initClass({
  jl_InstantiationException: 0
}, false, "java.lang.InstantiationException", {
  jl_InstantiationException: 1,
  jl_ReflectiveOperationException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_InstantiationException.prototype.$classData = $d_jl_InstantiationException;
function $as_jl_InternalError(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.InternalError"))
}
function $isArrayOf_jl_InternalError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_InternalError)))
}
function $asArrayOf_jl_InternalError(obj, depth) {
  return (($isArrayOf_jl_InternalError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.InternalError;", depth))
}
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
  /*<skip>*/
}
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
  /*<skip>*/
}
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype;
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $TypeData().initClass({
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 0
}, false, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", {
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 1,
  Ljava_io_OutputStream: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
});
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.$classData = $d_jl_JSConsoleBasedPrintStream$DummyOutputStream;
class $c_jl_NegativeArraySizeException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
}
var $d_jl_NegativeArraySizeException = new $TypeData().initClass({
  jl_NegativeArraySizeException: 0
}, false, "java.lang.NegativeArraySizeException", {
  jl_NegativeArraySizeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NegativeArraySizeException.prototype.$classData = $d_jl_NegativeArraySizeException;
class $c_jl_NoSuchMethodException extends $c_jl_ReflectiveOperationException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_jl_NoSuchMethodException = new $TypeData().initClass({
  jl_NoSuchMethodException: 0
}, false, "java.lang.NoSuchMethodException", {
  jl_NoSuchMethodException: 1,
  jl_ReflectiveOperationException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NoSuchMethodException.prototype.$classData = $d_jl_NoSuchMethodException;
function $ct_jl_NullPointerException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_NullPointerException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_NullPointerException extends $c_jl_RuntimeException {
}
var $d_jl_NullPointerException = new $TypeData().initClass({
  jl_NullPointerException: 0
}, false, "java.lang.NullPointerException", {
  jl_NullPointerException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NullPointerException.prototype.$classData = $d_jl_NullPointerException;
function $as_jl_SecurityException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.SecurityException"))
}
function $isArrayOf_jl_SecurityException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_SecurityException)))
}
function $asArrayOf_jl_SecurityException(obj, depth) {
  return (($isArrayOf_jl_SecurityException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.SecurityException;", depth))
}
function $f_jl_Short__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Short__hashCode__I($thiz) {
  return $thiz
}
function $f_jl_Short__toString__T($thiz) {
  return ("" + $thiz)
}
function $f_jl_Short__compareTo__O__I($thiz, o) {
  var that = $as_jl_Short(o);
  var this$1 = $n(that);
  return (($thiz - this$1) | 0)
}
function $as_jl_Short(obj) {
  return (($isShort(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Short"))
}
function $isArrayOf_jl_Short(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Short)))
}
function $asArrayOf_jl_Short(obj, depth) {
  return (($isArrayOf_jl_Short(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Short;", depth))
}
var $d_jl_Short = new $TypeData().initClass({
  jl_Short: 0
}, false, "java.lang.Short", {
  jl_Short: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => $isShort(x)));
class $c_jl_StackOverflowError extends $c_jl_VirtualMachineError {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_jl_StackOverflowError = new $TypeData().initClass({
  jl_StackOverflowError: 0
}, false, "java.lang.StackOverflowError", {
  jl_StackOverflowError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StackOverflowError.prototype.$classData = $d_jl_StackOverflowError;
function $ct_jl_UnsupportedOperationException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
function $ct_jl_UnsupportedOperationException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_UnsupportedOperationException extends $c_jl_RuntimeException {
}
var $d_jl_UnsupportedOperationException = new $TypeData().initClass({
  jl_UnsupportedOperationException: 0
}, false, "java.lang.UnsupportedOperationException", {
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_UnsupportedOperationException.prototype.$classData = $d_jl_UnsupportedOperationException;
function $ct_Ljava_time_DateTimeException__T__jl_Throwable__($thiz, message, cause) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz
}
function $ct_Ljava_time_DateTimeException__T__($thiz, message) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, null, true, true);
  return $thiz
}
class $c_Ljava_time_DateTimeException extends $c_jl_RuntimeException {
}
function $as_Ljava_time_DateTimeException(obj) {
  return (((obj instanceof $c_Ljava_time_DateTimeException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.DateTimeException"))
}
function $isArrayOf_Ljava_time_DateTimeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_DateTimeException)))
}
function $asArrayOf_Ljava_time_DateTimeException(obj, depth) {
  return (($isArrayOf_Ljava_time_DateTimeException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.DateTimeException;", depth))
}
var $d_Ljava_time_DateTimeException = new $TypeData().initClass({
  Ljava_time_DateTimeException: 0
}, false, "java.time.DateTimeException", {
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_DateTimeException.prototype.$classData = $d_Ljava_time_DateTimeException;
function $p_Ljava_time_Duration__plus__J__J__Ljava_time_Duration($thiz, secondsToAdd, nanosToAdd) {
  var lo = nanosToAdd.RTLong__f_lo;
  var hi = nanosToAdd.RTLong__f_hi;
  var _nanosToAdd__lo = lo;
  var _nanosToAdd__hi = hi;
  var b__lo = _nanosToAdd__lo;
  var b__hi = _nanosToAdd__hi;
  var lo$1 = (secondsToAdd.RTLong__f_lo | b__lo);
  var hi$1 = (secondsToAdd.RTLong__f_hi | b__hi);
  if (((lo$1 === 0) && (hi$1 === 0))) {
    return $thiz
  };
  var t = $thiz.Ljava_time_Duration__f_seconds;
  var lo$2 = t.RTLong__f_lo;
  var hi$2 = t.RTLong__f_hi;
  var t$1 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$2, hi$2), secondsToAdd);
  var lo$3 = t$1.RTLong__f_lo;
  var hi$3 = t$1.RTLong__f_hi;
  var epochSec__lo = lo$3;
  var epochSec__hi = hi$3;
  var a__lo = epochSec__lo;
  var a__hi = epochSec__hi;
  var this$1__lo = _nanosToAdd__lo;
  var this$1__hi = _nanosToAdd__hi;
  var this$2 = $m_RTLong$();
  var lo$4 = this$2.divideImpl__I__I__I__I__I(this$1__lo, this$1__hi, 1000000000, 0);
  var hi$4 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var t$2 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a__lo, a__hi), new $c_RTLong(lo$4, hi$4));
  var lo$5 = t$2.RTLong__f_lo;
  var hi$5 = t$2.RTLong__f_hi;
  var $$x1__lo = lo$5;
  var $$x1__hi = hi$5;
  epochSec__lo = $$x1__lo;
  epochSec__hi = $$x1__hi;
  var this$3__lo = _nanosToAdd__lo;
  var this$3__hi = _nanosToAdd__hi;
  var this$4 = $m_RTLong$();
  var lo$6 = this$4.remainderImpl__I__I__I__I__I(this$3__lo, this$3__hi, 1000000000, 0);
  var hi$6 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var $$x2__lo = lo$6;
  var $$x2__hi = hi$6;
  _nanosToAdd__lo = $$x2__lo;
  _nanosToAdd__hi = $$x2__hi;
  var value = $thiz.Ljava_time_Duration__f_nanos;
  var hi$7 = (value >> 31);
  var b$1__lo = _nanosToAdd__lo;
  var b$1__hi = _nanosToAdd__hi;
  var bhi = b$1__hi;
  var lo$7 = ((value + b$1__lo) | 0);
  var hi$8 = ((((-2147483648) ^ lo$7) < ((-2147483648) ^ value)) ? ((1 + ((hi$7 + bhi) | 0)) | 0) : ((hi$7 + bhi) | 0));
  return $m_Ljava_time_Duration$().ofSeconds__J__J__Ljava_time_Duration(new $c_RTLong(epochSec__lo, epochSec__hi), new $c_RTLong(lo$7, hi$8))
}
function $p_Ljava_time_Duration__toSeconds__Ljava_math_BigDecimal($thiz) {
  var t = $thiz.Ljava_time_Duration__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var $$x1 = $n($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi)));
  var value = $thiz.Ljava_time_Duration__f_nanos;
  var hi$1 = (value >> 31);
  return $n($$x1).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(value, hi$1), 9))
}
/** @constructor */
function $c_Ljava_time_Duration(seconds, nanos) {
  this.Ljava_time_Duration__f_seconds = $L0;
  this.Ljava_time_Duration__f_nanos = 0;
  this.Ljava_time_Duration__f_seconds = seconds;
  this.Ljava_time_Duration__f_nanos = nanos
}
$c_Ljava_time_Duration.prototype = new $h_O();
$c_Ljava_time_Duration.prototype.constructor = $c_Ljava_time_Duration;
/** @constructor */
function $h_Ljava_time_Duration() {
  /*<skip>*/
}
$h_Ljava_time_Duration.prototype = $c_Ljava_time_Duration.prototype;
$c_Ljava_time_Duration.prototype.isNegative__Z = (function() {
  var this$1 = this.Ljava_time_Duration__f_seconds;
  var ahi = this$1.RTLong__f_hi;
  return (ahi < 0)
});
$c_Ljava_time_Duration.prototype.multipliedBy__J__Ljava_time_Duration = (function(multiplicand) {
  return (((multiplicand.RTLong__f_lo === 0) && (multiplicand.RTLong__f_hi === 0)) ? $m_Ljava_time_Duration$().ZERO__Ljava_time_Duration() : (((multiplicand.RTLong__f_lo === 1) && (multiplicand.RTLong__f_hi === 0)) ? this : $m_Ljava_time_Duration$().java$time$Duration$$create__Ljava_math_BigDecimal__Ljava_time_Duration($n($p_Ljava_time_Duration__toSeconds__Ljava_math_BigDecimal(this)).multiply__Ljava_math_BigDecimal__Ljava_math_BigDecimal($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(multiplicand)))))
});
$c_Ljava_time_Duration.prototype.addTo__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var _temporal = temporal;
  var this$1 = this.Ljava_time_Duration__f_seconds;
  if ((!((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0)))) {
    _temporal = $n(_temporal).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(this.Ljava_time_Duration__f_seconds, $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit())
  };
  if ((this.Ljava_time_Duration__f_nanos !== 0)) {
    var $$x1 = $n(_temporal);
    var value = this.Ljava_time_Duration__f_nanos;
    var hi = (value >> 31);
    _temporal = $n($$x1).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value, hi), $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit())
  };
  return _temporal
});
$c_Ljava_time_Duration.prototype.subtractFrom__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var _temporal = temporal;
  var this$1 = this.Ljava_time_Duration__f_seconds;
  if ((!((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0)))) {
    _temporal = $n(_temporal).minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(this.Ljava_time_Duration__f_seconds, $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit())
  };
  if ((this.Ljava_time_Duration__f_nanos !== 0)) {
    var $$x1 = $n(_temporal);
    var value = this.Ljava_time_Duration__f_nanos;
    var hi = (value >> 31);
    _temporal = $n($$x1).minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value, hi), $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit())
  };
  return _temporal
});
$c_Ljava_time_Duration.prototype.toHours__J = (function() {
  var this$2 = this.Ljava_time_Duration__f_seconds;
  var value = $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I();
  var hi = (value >> 31);
  var this$3 = $m_RTLong$();
  var lo = this$3.divideImpl__I__I__I__I__I(this$2.RTLong__f_lo, this$2.RTLong__f_hi, value, hi);
  var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi$1)
});
$c_Ljava_time_Duration.prototype.toMinutes__J = (function() {
  var this$2 = this.Ljava_time_Duration__f_seconds;
  var value = $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I();
  var hi = (value >> 31);
  var this$3 = $m_RTLong$();
  var lo = this$3.divideImpl__I__I__I__I__I(this$2.RTLong__f_lo, this$2.RTLong__f_hi, value, hi);
  var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi$1)
});
$c_Ljava_time_Duration.prototype.toNanos__J = (function() {
  var t = this.Ljava_time_Duration__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo, hi), new $c_RTLong(1000000000, 0));
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var value = this.Ljava_time_Duration__f_nanos;
  var hi$2 = (value >> 31);
  return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$1, hi$1), new $c_RTLong(value, hi$2))
});
$c_Ljava_time_Duration.prototype.compare__Ljava_time_Duration__I = (function(otherDuration) {
  var t = this.Ljava_time_Duration__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $n(otherDuration).Ljava_time_Duration__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  return ((cmp !== 0) ? cmp : ((this.Ljava_time_Duration__f_nanos - $n(otherDuration).Ljava_time_Duration__f_nanos) | 0))
});
$c_Ljava_time_Duration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_Duration)) {
    var x2 = $as_Ljava_time_Duration(other);
    if ((this === x2)) {
      return true
    } else {
      var this$1 = this.Ljava_time_Duration__f_seconds;
      var b = $n(x2).Ljava_time_Duration__f_seconds;
      if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
        return (this.Ljava_time_Duration__f_nanos === $n(x2).Ljava_time_Duration__f_nanos)
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_Duration.prototype.hashCode__I = (function() {
  var this$2 = this.Ljava_time_Duration__f_seconds;
  var this$1 = this.Ljava_time_Duration__f_seconds;
  var hi = this$1.RTLong__f_hi;
  var lo = (this$2.RTLong__f_lo ^ hi);
  return ((lo + Math.imul(51, this.Ljava_time_Duration__f_nanos)) | 0)
});
$c_Ljava_time_Duration.prototype.toString__T = (function() {
  if ((this === $m_Ljava_time_Duration$().ZERO__Ljava_time_Duration())) {
    return "PT0S"
  };
  var this$2 = this.Ljava_time_Duration__f_seconds;
  var value = $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I();
  var hi = (value >> 31);
  var this$3 = $m_RTLong$();
  var lo = this$3.divideImpl__I__I__I__I__I(this$2.RTLong__f_lo, this$2.RTLong__f_hi, value, hi);
  var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$5 = this.Ljava_time_Duration__f_seconds;
  var value$1 = $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I();
  var hi$2 = (value$1 >> 31);
  var this$6 = $m_RTLong$();
  var lo$1 = this$6.remainderImpl__I__I__I__I__I(this$5.RTLong__f_lo, this$5.RTLong__f_hi, value$1, hi$2);
  var hi$3 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value$2 = $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I();
  var hi$4 = (value$2 >> 31);
  var this$8 = $m_RTLong$();
  var lo$2 = this$8.divideImpl__I__I__I__I__I(lo$1, hi$3, value$2, hi$4);
  var this$10 = this.Ljava_time_Duration__f_seconds;
  var value$3 = $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I();
  var hi$6 = (value$3 >> 31);
  var this$11 = $m_RTLong$();
  var lo$3 = this$11.remainderImpl__I__I__I__I__I(this$10.RTLong__f_lo, this$10.RTLong__f_hi, value$3, hi$6);
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 24);
  buf.append__T__scm_StringBuilder("PT");
  if ((!((lo === 0) && (hi$1 === 0)))) {
    $n(buf.append__J__scm_StringBuilder(new $c_RTLong(lo, hi$1))).append__C__scm_StringBuilder(72)
  };
  if ((lo$2 !== 0)) {
    $n(buf.append__I__scm_StringBuilder(lo$2)).append__C__scm_StringBuilder(77)
  };
  if ((((lo$3 === 0) && (this.Ljava_time_Duration__f_nanos === 0)) && ($n(buf.scm_StringBuilder__f_underlying).length__I() > 2))) {
    return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
  };
  if (((lo$3 < 0) && (this.Ljava_time_Duration__f_nanos > 0))) {
    if ((lo$3 === (-1))) {
      buf.append__T__scm_StringBuilder("-0")
    } else {
      buf.append__I__scm_StringBuilder(((1 + lo$3) | 0))
    }
  } else {
    buf.append__I__scm_StringBuilder(lo$3)
  };
  if ((this.Ljava_time_Duration__f_nanos > 0)) {
    var pos = $n(buf.scm_StringBuilder__f_underlying).length__I();
    if ((lo$3 < 0)) {
      buf.append__I__scm_StringBuilder(((2000000000 - this.Ljava_time_Duration__f_nanos) | 0))
    } else {
      buf.append__I__scm_StringBuilder(((1000000000 + this.Ljava_time_Duration__f_nanos) | 0))
    };
    while (true) {
      var index = (((-1) + $n(buf.scm_StringBuilder__f_underlying).length__I()) | 0);
      if (($n(buf.scm_StringBuilder__f_underlying).charAt__I__C(index) === 48)) {
        var len = (((-1) + $n(buf.scm_StringBuilder__f_underlying).length__I()) | 0);
        $n(buf.scm_StringBuilder__f_underlying).setLength__I__V(len)
      } else {
        break
      }
    };
    buf.setCharAt__I__C__scm_StringBuilder(pos, 46)
  };
  buf.append__C__scm_StringBuilder(83);
  return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_Duration.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_Duration(that);
  return this.compare__Ljava_time_Duration__I(other)
});
function $as_Ljava_time_Duration(obj) {
  return (((obj instanceof $c_Ljava_time_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Duration"))
}
function $isArrayOf_Ljava_time_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Duration)))
}
function $asArrayOf_Ljava_time_Duration(obj, depth) {
  return (($isArrayOf_Ljava_time_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Duration;", depth))
}
var $d_Ljava_time_Duration = new $TypeData().initClass({
  Ljava_time_Duration: 0
}, false, "java.time.Duration", {
  Ljava_time_Duration: 1,
  O: 1,
  Ljava_time_temporal_TemporalAmount: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Duration.prototype.$classData = $d_Ljava_time_Duration;
function $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  var x = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
  if ((x === null)) {
    var $$x1 = (field === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = (this$1 === field)
  };
  if ($$x1) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Field too large for an int: " + field))
  } else {
    var x$3 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $$x2 = (field === null)
    } else {
      var this$2 = $n(x$3);
      var $$x2 = (this$2 === field)
    };
    if ($$x2) {
      var this$3 = $n($thiz.Ljava_time_ZonedDateTime__f_offset);
      return this$3.Ljava_time_ZoneOffset__f_totalSeconds
    } else {
      return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? $n($thiz.Ljava_time_ZonedDateTime__f_dateTime).get__Ljava_time_temporal_TemporalField__I(field) : $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field))
    }
  }
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $$x2 = (query === null)
  } else {
    var this$1 = $n(x);
    var $$x2 = (this$1 === query)
  };
  if ($$x2) {
    var $$x1 = true
  } else {
    var x$3 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
    if ((x$3 === null)) {
      var $$x1 = (query === null)
    } else {
      var this$2 = $n(x$3);
      var $$x1 = (this$2 === query)
    }
  };
  if ($$x1) {
    return $thiz.Ljava_time_ZonedDateTime__f_zone
  } else {
    var x$5 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
    if ((x$5 === null)) {
      var $$x3 = (query === null)
    } else {
      var this$3 = $n(x$5);
      var $$x3 = (this$3 === query)
    };
    if ($$x3) {
      var this$4 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
      $n(this$4.Ljava_time_LocalDateTime__f_date);
      return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
    } else {
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === null)) {
        var $$x4 = (query === null)
      } else {
        var this$6 = $n(x$7);
        var $$x4 = (this$6 === query)
      };
      if ($$x4) {
        return $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit()
      } else {
        var x$9 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
        if ((x$9 === null)) {
          var $$x5 = (query === null)
        } else {
          var this$7 = $n(x$9);
          var $$x5 = (this$7 === query)
        };
        if ($$x5) {
          return $thiz.Ljava_time_ZonedDateTime__f_offset
        } else {
          var x$11 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
          if ((x$11 === null)) {
            var $$x6 = (query === null)
          } else {
            var this$8 = $n(x$11);
            var $$x6 = (this$8 === query)
          };
          if ($$x6) {
            var $$x7 = $m_Ljava_time_LocalDate$();
            var this$9 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
            return $n($$x7).ofEpochDay__J__Ljava_time_LocalDate($n(this$9.Ljava_time_LocalDateTime__f_date).toEpochDay__J())
          } else {
            var x$13 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
            if ((x$13 === null)) {
              var $$x8 = (query === null)
            } else {
              var this$10 = $n(x$13);
              var $$x8 = (this$10 === query)
            };
            if ($$x8) {
              var this$11 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
              return this$11.Ljava_time_LocalDateTime__f_time
            } else {
              return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query)
            }
          }
        }
      }
    }
  }
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz) {
  var this$1 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
  var t = $n(this$1.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo$1 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((Math.imul(86400, hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var this$2 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
  var value = $n(this$2.Ljava_time_LocalDateTime__f_time).toSecondOfDay__I();
  var hi$2 = (value >> 31);
  var lo$2 = ((lo$1 + value) | 0);
  var hi$3 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  var secs__lo = lo$2;
  var secs__hi = hi$3;
  var this$7__lo = secs__lo;
  var this$7__hi = secs__hi;
  var this$5 = $n($thiz.Ljava_time_ZonedDateTime__f_offset);
  var value$1 = this$5.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$4 = (value$1 >> 31);
  var alo = this$7__lo;
  var ahi = this$7__hi;
  var lo$3 = ((alo - value$1) | 0);
  var hi$5 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$4) | 0)) | 0) : ((ahi - hi$4) | 0));
  var $$x1__lo = lo$3;
  var $$x1__hi = hi$5;
  secs__lo = $$x1__lo;
  secs__hi = $$x1__hi;
  return new $c_RTLong(secs__lo, secs__hi)
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I($thiz, other) {
  var t = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$1 = $n(other);
  var t$1 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(this$1);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  if ((cmp === 0)) {
    var this$2 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
    var this$3 = $n(this$2.Ljava_time_LocalDateTime__f_time);
    var $$x1 = this$3.Ljava_time_LocalTime__f_nano;
    var this$4 = $n(other);
    var this$5 = $n(this$4.Ljava_time_ZonedDateTime__f_dateTime);
    var this$6 = $n(this$5.Ljava_time_LocalDateTime__f_time);
    cmp = (($$x1 - this$6.Ljava_time_LocalTime__f_nano) | 0);
    if ((cmp === 0)) {
      var this$8 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
      var this$7 = $n(other);
      var that = this$7.Ljava_time_ZonedDateTime__f_dateTime;
      cmp = this$8.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(that);
      if ((cmp === 0)) {
        var $$x2 = $n($n($thiz.Ljava_time_ZonedDateTime__f_zone).getId__T());
        var this$9 = $n(other);
        cmp = $f_T__compareTo__T__I($n($$x2), $n(this$9.Ljava_time_ZonedDateTime__f_zone).getId__T());
        if ((cmp === 0)) {
          var this$10 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
          $n(this$10.Ljava_time_LocalDateTime__f_date);
          $n($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
          var this$12 = $n(other);
          var this$13 = $n(this$12.Ljava_time_ZonedDateTime__f_dateTime);
          $n(this$13.Ljava_time_LocalDateTime__f_date);
          var that$1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
          cmp = $f_T__compareTo__T__I("ISO", ($n(that$1), "ISO"))
        }
      }
    }
  };
  return cmp
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__isBefore__Ljava_time_chrono_ChronoZonedDateTime__Z($thiz, other) {
  var t = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$1 = $n(other);
  var t$1 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(this$1);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? (((-2147483648) ^ lo) < ((-2147483648) ^ lo$1)) : (hi < hi$1))) {
    return true
  } else if (((lo === lo$1) && (hi === hi$1))) {
    var this$2 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
    var this$3 = $n(this$2.Ljava_time_LocalDateTime__f_time);
    var $$x1 = this$3.Ljava_time_LocalTime__f_nano;
    var this$4 = $n(other);
    var this$5 = $n(this$4.Ljava_time_ZonedDateTime__f_dateTime);
    var this$6 = $n(this$5.Ljava_time_LocalDateTime__f_time);
    return ($$x1 < this$6.Ljava_time_LocalTime__f_nano)
  } else {
    return false
  }
}
function $is_Ljava_time_chrono_ChronoZonedDateTime(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_ChronoZonedDateTime)))
}
function $as_Ljava_time_chrono_ChronoZonedDateTime(obj) {
  return (($is_Ljava_time_chrono_ChronoZonedDateTime(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.ChronoZonedDateTime"))
}
function $isArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoZonedDateTime)))
}
function $asArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.ChronoZonedDateTime;", depth))
}
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology() {
  /*<skip>*/
}
$c_Ljava_time_chrono_IsoChronology.prototype = new $h_O();
$c_Ljava_time_chrono_IsoChronology.prototype.constructor = $c_Ljava_time_chrono_IsoChronology;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology() {
  /*<skip>*/
}
$h_Ljava_time_chrono_IsoChronology.prototype = $c_Ljava_time_chrono_IsoChronology.prototype;
$c_Ljava_time_chrono_IsoChronology.prototype.equals__O__Z = (function(obj) {
  return $f_Ljava_time_chrono_Chronology__equals__O__Z(this, obj)
});
$c_Ljava_time_chrono_IsoChronology.prototype.hashCode__I = (function() {
  return $f_Ljava_time_chrono_Chronology__hashCode__I(this)
});
$c_Ljava_time_chrono_IsoChronology.prototype.toString__T = (function() {
  return "ISO"
});
$c_Ljava_time_chrono_IsoChronology.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_chrono_Chronology(that);
  return $f_T__compareTo__T__I("ISO", ($n(other), "ISO"))
});
$c_Ljava_time_chrono_IsoChronology.prototype.isLeapYear__J__Z = (function(prolepticYear) {
  var lo = (3 & prolepticYear.RTLong__f_lo);
  if ((lo === 0)) {
    var this$1 = $m_RTLong$();
    var lo$1 = this$1.remainderImpl__I__I__I__I__I(prolepticYear.RTLong__f_lo, prolepticYear.RTLong__f_hi, 100, 0);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if ((!((lo$1 === 0) && (hi === 0)))) {
      return true
    } else {
      var this$2 = $m_RTLong$();
      var lo$2 = this$2.remainderImpl__I__I__I__I__I(prolepticYear.RTLong__f_lo, prolepticYear.RTLong__f_hi, 400, 0);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return ((lo$2 === 0) && (hi$1 === 0))
    }
  } else {
    return false
  }
});
$c_Ljava_time_chrono_IsoChronology.prototype.resolveDate__ju_Map__Ljava_time_format_ResolverStyle__Ljava_time_LocalDate = (function(fieldValues, resolverStyle) {
  if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $$x1 = $m_Ljava_time_LocalDate$();
    var x = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField()));
    return $n($$x1).ofEpochDay__J__Ljava_time_LocalDate($uJ(x))
  };
  var prolepticMonth = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField()));
  if ((prolepticMonth !== null)) {
    if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$3 = $n($m_Ljava_time_temporal_ChronoField$().PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField());
      var t = $uJ(prolepticMonth);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      $n(this$3.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo, hi), this$3)
    };
    var field = $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var t$1 = $uJ(prolepticMonth);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var b = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo$1, hi$1), new $c_RTLong(12, 0));
    var bhi = b.RTLong__f_hi;
    var lo$2 = ((1 + b.RTLong__f_lo) | 0);
    var hi$2 = ((lo$2 === 0) ? ((1 + bhi) | 0) : bhi);
    $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field, new $c_RTLong(lo$2, hi$2));
    var field$1 = $m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField();
    var t$2 = $uJ(prolepticMonth);
    var lo$3 = t$2.RTLong__f_lo;
    var hi$3 = t$2.RTLong__f_hi;
    var t$3 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo$3, hi$3), new $c_RTLong(12, 0));
    var lo$4 = t$3.RTLong__f_lo;
    var hi$4 = t$3.RTLong__f_hi;
    $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$1, new $c_RTLong(lo$4, hi$4))
  };
  var yoeLong = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().YEAR_OF_ERA__Ljava_time_temporal_ChronoField()));
  if ((yoeLong !== null)) {
    if ((resolverStyle !== $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$8 = $n($m_Ljava_time_temporal_ChronoField$().YEAR_OF_ERA__Ljava_time_temporal_ChronoField());
      var t$4 = $uJ(yoeLong);
      var lo$5 = t$4.RTLong__f_lo;
      var hi$5 = t$4.RTLong__f_hi;
      $n(this$8.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$5, hi$5), this$8)
    };
    var era = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField()));
    if ((era === null)) {
      var year = $as_jl_Long($n(fieldValues).get__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()));
      if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle())) {
        if ((year !== null)) {
          var field$2 = $m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField();
          var this$10 = $uJ(year);
          var ahi = this$10.RTLong__f_hi;
          if (((ahi === 0) ? (this$10.RTLong__f_lo !== 0) : (ahi > 0))) {
            var t$6 = $uJ(yoeLong)
          } else {
            var t$5 = $uJ(yoeLong);
            var lo$6 = t$5.RTLong__f_lo;
            var hi$6 = t$5.RTLong__f_hi;
            var t$6 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(1, 0), new $c_RTLong(lo$6, hi$6))
          };
          var lo$7 = t$6.RTLong__f_lo;
          var hi$7 = t$6.RTLong__f_hi;
          $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$2, new $c_RTLong(lo$7, hi$7))
        } else {
          $n(fieldValues).put__O__O__O($m_Ljava_time_temporal_ChronoField$().YEAR_OF_ERA__Ljava_time_temporal_ChronoField(), yoeLong)
        }
      } else {
        var field$3 = $m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField();
        if ((year === null)) {
          var $$x2 = true
        } else {
          var this$14 = $uJ(year);
          var ahi$1 = this$14.RTLong__f_hi;
          var $$x2 = ((ahi$1 === 0) ? (this$14.RTLong__f_lo !== 0) : (ahi$1 > 0))
        };
        if ($$x2) {
          var t$8 = $uJ(yoeLong)
        } else {
          var t$7 = $uJ(yoeLong);
          var lo$8 = t$7.RTLong__f_lo;
          var hi$8 = t$7.RTLong__f_hi;
          var t$8 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(1, 0), new $c_RTLong(lo$8, hi$8))
        };
        var lo$9 = t$8.RTLong__f_lo;
        var hi$9 = t$8.RTLong__f_hi;
        $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$3, new $c_RTLong(lo$9, hi$9))
      }
    } else {
      var this$17 = $n(era);
      var this$18 = $uJ(this$17);
      if (((this$18.RTLong__f_lo === 1) && (this$18.RTLong__f_hi === 0))) {
        var field$4 = $m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField();
        var t$9 = $uJ(yoeLong);
        var lo$10 = t$9.RTLong__f_lo;
        var hi$10 = t$9.RTLong__f_hi;
        $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$4, new $c_RTLong(lo$10, hi$10))
      } else {
        var this$20 = $n(era);
        var this$21 = $uJ(this$20);
        if (((this$21.RTLong__f_lo === 0) && (this$21.RTLong__f_hi === 0))) {
          var field$5 = $m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField();
          var t$10 = $uJ(yoeLong);
          var lo$11 = t$10.RTLong__f_lo;
          var hi$11 = t$10.RTLong__f_hi;
          var t$11 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(1, 0), new $c_RTLong(lo$11, hi$11));
          var lo$12 = t$11.RTLong__f_lo;
          var hi$12 = t$11.RTLong__f_hi;
          $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$5, new $c_RTLong(lo$12, hi$12))
        } else {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for era: " + era))
        }
      }
    }
  } else if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField())) {
    var this$24 = $n($m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField());
    var x$1 = $as_jl_Long($n(fieldValues).get__O__O($m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField()));
    var t$12 = $uJ(x$1);
    var lo$13 = t$12.RTLong__f_lo;
    var hi$13 = t$12.RTLong__f_hi;
    $n(this$24.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$13, hi$13), this$24)
  };
  if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField())) {
    if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField())) {
        var this$26 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
        var x$2 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()));
        var t$13 = $uJ(x$2);
        var lo$14 = t$13.RTLong__f_lo;
        var hi$14 = t$13.RTLong__f_hi;
        var y = $n(this$26.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$14, hi$14), this$26);
        var x$3 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var t$14 = $uJ(x$3);
        var lo$15 = t$14.RTLong__f_lo;
        var hi$15 = t$14.RTLong__f_hi;
        var moy = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo$15, hi$15));
        var x$4 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField()));
        var t$15 = $uJ(x$4);
        var lo$16 = t$15.RTLong__f_lo;
        var hi$16 = t$15.RTLong__f_hi;
        var dom = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo$16, hi$16));
        if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
          var hi$17 = (moy >> 31);
          var t$16 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(moy, hi$17), new $c_RTLong(1, 0));
          var lo$17 = t$16.RTLong__f_lo;
          var hi$18 = t$16.RTLong__f_hi;
          var value = dom;
          var hi$19 = (value >> 31);
          var t$17 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(value, hi$19), new $c_RTLong(1, 0));
          var lo$18 = t$17.RTLong__f_lo;
          var hi$20 = t$17.RTLong__f_hi;
          return $n($n($m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, 1, 1)).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$17, hi$18))).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$18, hi$20))
        } else if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().SMART__Ljava_time_format_ResolverStyle())) {
          var this$32 = $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
          var value$1 = dom;
          var hi$21 = (value$1 >> 31);
          $n(this$32.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value$1, hi$21), this$32);
          if (((((moy === 4) || (moy === 6)) || (moy === 9)) || (moy === 11))) {
            var a = dom;
            dom = ((a < 30) ? a : 30)
          } else if ((moy === 2)) {
            var a$1 = dom;
            var $$x4 = $n($m_Ljava_time_Month$().FEBRUARY__Ljava_time_Month());
            var $$x3 = $m_Ljava_time_Year$();
            var hi$22 = (y >> 31);
            var b$1 = $n($$x4).length__Z__I($n($$x3).isLeap__J__Z(new $c_RTLong(y, hi$22)));
            dom = ((a$1 < b$1) ? a$1 : b$1)
          };
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, moy, dom)
        } else {
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, moy, dom)
        }
      };
      if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField())) {
        if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField())) {
          var this$37 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
          var x$5 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()));
          var t$18 = $uJ(x$5);
          var lo$19 = t$18.RTLong__f_lo;
          var hi$23 = t$18.RTLong__f_hi;
          var y$2 = $n(this$37.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$19, hi$23), this$37);
          if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
            var x$6 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
            var t$19 = $uJ(x$6);
            var lo$20 = t$19.RTLong__f_lo;
            var hi$24 = t$19.RTLong__f_hi;
            var t$20 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$20, hi$24), new $c_RTLong(1, 0));
            var lo$21 = t$20.RTLong__f_lo;
            var hi$25 = t$20.RTLong__f_hi;
            var x$7 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
            var t$21 = $uJ(x$7);
            var lo$22 = t$21.RTLong__f_lo;
            var hi$26 = t$21.RTLong__f_hi;
            var t$22 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$22, hi$26), new $c_RTLong(1, 0));
            var lo$23 = t$22.RTLong__f_lo;
            var hi$27 = t$22.RTLong__f_hi;
            var x$8 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField()));
            var t$23 = $uJ(x$8);
            var lo$24 = t$23.RTLong__f_lo;
            var hi$28 = t$23.RTLong__f_hi;
            var t$24 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$24, hi$28), new $c_RTLong(1, 0));
            var lo$25 = t$24.RTLong__f_lo;
            var hi$29 = t$24.RTLong__f_hi;
            return $n($n($n($m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$2, 1, 1)).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$21, hi$25))).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$23, hi$27))).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$25, hi$29))
          };
          var this$42 = $n($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
          var x$9 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var t$25 = $uJ(x$9);
          var lo$26 = t$25.RTLong__f_lo;
          var hi$30 = t$25.RTLong__f_hi;
          var moy$2 = $n(this$42.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$26, hi$30), this$42);
          var this$44 = $n($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
          var x$10 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
          var t$26 = $uJ(x$10);
          var lo$27 = t$26.RTLong__f_lo;
          var hi$31 = t$26.RTLong__f_hi;
          var aw = $n(this$44.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$27, hi$31), this$44);
          var this$46 = $n($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField());
          var x$11 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField()));
          var t$27 = $uJ(x$11);
          var lo$28 = t$27.RTLong__f_lo;
          var hi$32 = t$27.RTLong__f_hi;
          var ad = $n(this$46.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$28, hi$32), this$46);
          var $$x5 = $n($m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$2, moy$2, 1));
          var hi$33 = (aw >> 31);
          var lo$29 = (((-1) + aw) | 0);
          var hi$34 = ((lo$29 !== (-1)) ? hi$33 : (((-1) + hi$33) | 0));
          var b0 = (65535 & lo$29);
          var b1 = ((lo$29 >>> 16) | 0);
          var a0b0 = Math.imul(7, b0);
          var a0b1 = Math.imul(7, b1);
          var lo$30 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$35 = ((Math.imul(7, hi$34) + ((c1part >>> 16) | 0)) | 0);
          var hi$36 = (ad >> 31);
          var lo$31 = (((-1) + ad) | 0);
          var hi$37 = ((lo$31 !== (-1)) ? hi$36 : (((-1) + hi$36) | 0));
          var lo$32 = ((lo$30 + lo$31) | 0);
          var hi$38 = ((((-2147483648) ^ lo$32) < ((-2147483648) ^ lo$30)) ? ((1 + ((hi$35 + hi$37) | 0)) | 0) : ((hi$35 + hi$37) | 0));
          var date = $n($$x5).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$32, hi$38));
          if (((resolverStyle === $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle()) && ($n(date).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) !== moy$2))) {
            throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month")
          };
          return date
        };
        if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
          var this$53 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
          var x$12 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()));
          var t$28 = $uJ(x$12);
          var lo$33 = t$28.RTLong__f_lo;
          var hi$39 = t$28.RTLong__f_hi;
          var y$3 = $n(this$53.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$33, hi$39), this$53);
          if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
            var x$13 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
            var t$29 = $uJ(x$13);
            var lo$34 = t$29.RTLong__f_lo;
            var hi$40 = t$29.RTLong__f_hi;
            var t$30 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$34, hi$40), new $c_RTLong(1, 0));
            var lo$35 = t$30.RTLong__f_lo;
            var hi$41 = t$30.RTLong__f_hi;
            var x$14 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
            var t$31 = $uJ(x$14);
            var lo$36 = t$31.RTLong__f_lo;
            var hi$42 = t$31.RTLong__f_hi;
            var t$32 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$36, hi$42), new $c_RTLong(1, 0));
            var lo$37 = t$32.RTLong__f_lo;
            var hi$43 = t$32.RTLong__f_hi;
            var x$15 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
            var t$33 = $uJ(x$15);
            var lo$38 = t$33.RTLong__f_lo;
            var hi$44 = t$33.RTLong__f_hi;
            var t$34 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$38, hi$44), new $c_RTLong(1, 0));
            var lo$39 = t$34.RTLong__f_lo;
            var hi$45 = t$34.RTLong__f_hi;
            return $n($n($n($m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$3, 1, 1)).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$35, hi$41))).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$37, hi$43))).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$39, hi$45))
          };
          var this$58 = $n($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
          var x$16 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var t$35 = $uJ(x$16);
          var lo$40 = t$35.RTLong__f_lo;
          var hi$46 = t$35.RTLong__f_hi;
          var moy$3 = $n(this$58.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$40, hi$46), this$58);
          var this$60 = $n($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
          var x$17 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
          var t$36 = $uJ(x$17);
          var lo$41 = t$36.RTLong__f_lo;
          var hi$47 = t$36.RTLong__f_hi;
          var aw$2 = $n(this$60.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$41, hi$47), this$60);
          var this$62 = $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
          var x$18 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
          var t$37 = $uJ(x$18);
          var lo$42 = t$37.RTLong__f_lo;
          var hi$48 = t$37.RTLong__f_hi;
          var dow = $n(this$62.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$42, hi$48), this$62);
          var $$x7 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$3, moy$3, 1);
          var hi$49 = (aw$2 >> 31);
          var lo$43 = (((-1) + aw$2) | 0);
          var hi$50 = ((lo$43 !== (-1)) ? hi$49 : (((-1) + hi$49) | 0));
          var $$x6 = $n($n($$x7).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$43, hi$50)));
          var dayOfWeek = $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(dow);
          var date$2 = $n($$x6).with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, dayOfWeek));
          if (((resolverStyle === $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle()) && ($n(date$2).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) !== moy$3))) {
            throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month")
          };
          return date$2
        }
      }
    };
    if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      var this$67 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
      var x$19 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()));
      var t$38 = $uJ(x$19);
      var lo$44 = t$38.RTLong__f_lo;
      var hi$51 = t$38.RTLong__f_hi;
      var y$4 = $n(this$67.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$44, hi$51), this$67);
      if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
        var x$20 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var t$39 = $uJ(x$20);
        var lo$45 = t$39.RTLong__f_lo;
        var hi$52 = t$39.RTLong__f_hi;
        var t$40 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$45, hi$52), new $c_RTLong(1, 0));
        var lo$46 = t$40.RTLong__f_lo;
        var hi$53 = t$40.RTLong__f_hi;
        return $n($m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(y$4, 1)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$46, hi$53))
      };
      var this$70 = $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
      var x$21 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField()));
      var t$41 = $uJ(x$21);
      var lo$47 = t$41.RTLong__f_lo;
      var hi$54 = t$41.RTLong__f_hi;
      var doy = $n(this$70.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$47, hi$54), this$70);
      return $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(y$4, doy)
    };
    if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField())) {
        var this$72 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
        var x$22 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()));
        var t$42 = $uJ(x$22);
        var lo$48 = t$42.RTLong__f_lo;
        var hi$55 = t$42.RTLong__f_hi;
        var y$5 = $n(this$72.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$48, hi$55), this$72);
        if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
          var x$23 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var t$43 = $uJ(x$23);
          var lo$49 = t$43.RTLong__f_lo;
          var hi$56 = t$43.RTLong__f_hi;
          var t$44 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$49, hi$56), new $c_RTLong(1, 0));
          var lo$50 = t$44.RTLong__f_lo;
          var hi$57 = t$44.RTLong__f_hi;
          var x$24 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField()));
          var t$45 = $uJ(x$24);
          var lo$51 = t$45.RTLong__f_lo;
          var hi$58 = t$45.RTLong__f_hi;
          var t$46 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$51, hi$58), new $c_RTLong(1, 0));
          var lo$52 = t$46.RTLong__f_lo;
          var hi$59 = t$46.RTLong__f_hi;
          return $n($n($m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$5, 1, 1)).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$50, hi$57))).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$52, hi$59))
        };
        var this$76 = $n($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
        var x$25 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var t$47 = $uJ(x$25);
        var lo$53 = t$47.RTLong__f_lo;
        var hi$60 = t$47.RTLong__f_hi;
        var aw$3 = $n(this$76.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$53, hi$60), this$76);
        var this$78 = $n($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField());
        var x$26 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField()));
        var t$48 = $uJ(x$26);
        var lo$54 = t$48.RTLong__f_lo;
        var hi$61 = t$48.RTLong__f_hi;
        var ad$2 = $n(this$78.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$54, hi$61), this$78);
        var $$x8 = $n($m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$5, 1, 1));
        var hi$62 = (aw$3 >> 31);
        var lo$55 = (((-1) + aw$3) | 0);
        var hi$63 = ((lo$55 !== (-1)) ? hi$62 : (((-1) + hi$62) | 0));
        var b0$1 = (65535 & lo$55);
        var b1$1 = ((lo$55 >>> 16) | 0);
        var a0b0$1 = Math.imul(7, b0$1);
        var a0b1$1 = Math.imul(7, b1$1);
        var lo$56 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$64 = ((Math.imul(7, hi$63) + ((c1part$1 >>> 16) | 0)) | 0);
        var value$2 = (((-1) + ad$2) | 0);
        var hi$65 = (value$2 >> 31);
        var lo$57 = ((lo$56 + value$2) | 0);
        var hi$66 = ((((-2147483648) ^ lo$57) < ((-2147483648) ^ lo$56)) ? ((1 + ((hi$64 + hi$65) | 0)) | 0) : ((hi$64 + hi$65) | 0));
        var date$3 = $n($$x8).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$57, hi$66));
        if (((resolverStyle === $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle()) && ($n(date$3).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()) !== y$5))) {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different year")
        };
        return date$3
      };
      if ($n(fieldValues).containsKey__O__Z($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
        var this$84 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
        var x$27 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()));
        var t$49 = $uJ(x$27);
        var lo$58 = t$49.RTLong__f_lo;
        var hi$67 = t$49.RTLong__f_hi;
        var y$6 = $n(this$84.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$58, hi$67), this$84);
        if ((resolverStyle === $m_Ljava_time_format_ResolverStyle$().LENIENT__Ljava_time_format_ResolverStyle())) {
          var x$28 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var t$50 = $uJ(x$28);
          var lo$59 = t$50.RTLong__f_lo;
          var hi$68 = t$50.RTLong__f_hi;
          var t$51 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$59, hi$68), new $c_RTLong(1, 0));
          var lo$60 = t$51.RTLong__f_lo;
          var hi$69 = t$51.RTLong__f_hi;
          var x$29 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
          var t$52 = $uJ(x$29);
          var lo$61 = t$52.RTLong__f_lo;
          var hi$70 = t$52.RTLong__f_hi;
          var t$53 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$61, hi$70), new $c_RTLong(1, 0));
          var lo$62 = t$53.RTLong__f_lo;
          var hi$71 = t$53.RTLong__f_hi;
          return $n($n($m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$6, 1, 1)).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$60, hi$69))).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$62, hi$71))
        };
        var this$88 = $n($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
        var x$30 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var t$54 = $uJ(x$30);
        var lo$63 = t$54.RTLong__f_lo;
        var hi$72 = t$54.RTLong__f_hi;
        var aw$4 = $n(this$88.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$63, hi$72), this$88);
        var this$90 = $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
        var x$31 = $as_jl_Long($n(fieldValues).remove__O__O($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
        var t$55 = $uJ(x$31);
        var lo$64 = t$55.RTLong__f_lo;
        var hi$73 = t$55.RTLong__f_hi;
        var dow$2 = $n(this$90.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$64, hi$73), this$90);
        var $$x10 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$6, 1, 1);
        var hi$74 = (aw$4 >> 31);
        var lo$65 = (((-1) + aw$4) | 0);
        var hi$75 = ((lo$65 !== (-1)) ? hi$74 : (((-1) + hi$74) | 0));
        var $$x9 = $n($n($$x10).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$65, hi$75)));
        var dayOfWeek$1 = $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(dow$2);
        var date$4 = $n($$x9).with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, dayOfWeek$1));
        if (((resolverStyle === $m_Ljava_time_format_ResolverStyle$().STRICT__Ljava_time_format_ResolverStyle()) && ($n(date$4).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField()) !== y$6))) {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month")
        };
        return date$4
      }
    }
  };
  return null
});
function $as_Ljava_time_chrono_IsoChronology(obj) {
  return (((obj instanceof $c_Ljava_time_chrono_IsoChronology) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.IsoChronology"))
}
function $isArrayOf_Ljava_time_chrono_IsoChronology(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_IsoChronology)))
}
function $asArrayOf_Ljava_time_chrono_IsoChronology(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_IsoChronology(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.IsoChronology;", depth))
}
var $d_Ljava_time_chrono_IsoChronology = new $TypeData().initClass({
  Ljava_time_chrono_IsoChronology: 0
}, false, "java.time.chrono.IsoChronology", {
  Ljava_time_chrono_IsoChronology: 1,
  O: 1,
  Ljava_time_chrono_Chronology: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_chrono_IsoChronology.prototype.$classData = $d_Ljava_time_chrono_IsoChronology;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = new $h_jl_Enum();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  return true
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var x1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal;
  switch (x1) {
    case 0: {
      var this$1 = $n(context);
      this$1.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = true;
      break
    }
    case 1: {
      var this$2 = $n(context);
      this$2.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = false;
      break
    }
    case 2: {
      var this$3 = $n(context);
      this$3.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = true;
      break
    }
    case 3: {
      var this$4 = $n(context);
      this$4.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = false;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  return position
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.toString__T = (function() {
  var x1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal;
  switch (x1) {
    case 0: {
      return "ParseCaseSensitive(true)";
      break
    }
    case 1: {
      return "ParseCaseSensitive(false)";
      break
    }
    case 2: {
      return "ParseStrict(true)";
      break
    }
    case 3: {
      return "ParseStrict(false)";
      break
    }
    default: {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Unreachable")
    }
  }
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$DateTimePrinterParser: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser;
/** @constructor */
function $c_Ljava_time_temporal_ChronoField(name, ordinal, baseUnit, rangeUnit, _range) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  this.Ljava_time_temporal_ChronoField__f_name = name;
  this.Ljava_time_temporal_ChronoField__f_ordinal = ordinal;
  this.Ljava_time_temporal_ChronoField__f__range = _range;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_temporal_ChronoField.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_ChronoField.prototype.constructor = $c_Ljava_time_temporal_ChronoField;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoField.prototype = $c_Ljava_time_temporal_ChronoField.prototype;
$c_Ljava_time_temporal_ChronoField.prototype.range__Ljava_time_temporal_ValueRange = (function() {
  return this.Ljava_time_temporal_ChronoField__f__range
});
$c_Ljava_time_temporal_ChronoField.prototype.isDateBased__Z = (function() {
  return ((this.Ljava_time_temporal_ChronoField__f_ordinal >= $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()).jl_Enum__f__ordinal) && (this.Ljava_time_temporal_ChronoField__f_ordinal <= $n($m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField()).jl_Enum__f__ordinal))
});
$c_Ljava_time_temporal_ChronoField.prototype.isTimeBased__Z = (function() {
  return (this.Ljava_time_temporal_ChronoField__f_ordinal < $n($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()).jl_Enum__f__ordinal)
});
$c_Ljava_time_temporal_ChronoField.prototype.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z = (function(temporal) {
  return $n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z(this)
});
$c_Ljava_time_temporal_ChronoField.prototype.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange = (function(temporal) {
  return $n(temporal).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this)
});
$c_Ljava_time_temporal_ChronoField.prototype.getFrom__Ljava_time_temporal_TemporalAccessor__J = (function(temporal) {
  return $n(temporal).getLong__Ljava_time_temporal_TemporalField__J(this)
});
$c_Ljava_time_temporal_ChronoField.prototype.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(temporal, newValue) {
  return $n(temporal).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal(this, newValue)
});
$c_Ljava_time_temporal_ChronoField.prototype.resolve__ju_Map__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_ResolverStyle__Ljava_time_temporal_TemporalAccessor = (function(fieldValues, partialTemporal, resolverStyle) {
  return null
});
$c_Ljava_time_temporal_ChronoField.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_ChronoField__f_name
});
function $as_Ljava_time_temporal_ChronoField(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_ChronoField) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.ChronoField"))
}
function $isArrayOf_Ljava_time_temporal_ChronoField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ChronoField)))
}
function $asArrayOf_Ljava_time_temporal_ChronoField(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_ChronoField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.ChronoField;", depth))
}
var $d_Ljava_time_temporal_ChronoField = new $TypeData().initClass({
  Ljava_time_temporal_ChronoField: 0
}, false, "java.time.temporal.ChronoField", {
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1
});
$c_Ljava_time_temporal_ChronoField.prototype.$classData = $d_Ljava_time_temporal_ChronoField;
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit(name, ordinal, duration) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  this.Ljava_time_temporal_ChronoUnit__f_name = name;
  this.Ljava_time_temporal_ChronoUnit__f_duration = duration;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_temporal_ChronoUnit.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_ChronoUnit.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit() {
  /*<skip>*/
}
$h_Ljava_time_temporal_ChronoUnit.prototype = $c_Ljava_time_temporal_ChronoUnit.prototype;
$c_Ljava_time_temporal_ChronoUnit.prototype.getDuration__Ljava_time_Duration = (function() {
  return this.Ljava_time_temporal_ChronoUnit__f_duration
});
$c_Ljava_time_temporal_ChronoUnit.prototype.isDateBased__Z = (function() {
  return ((this.compareTo__jl_Enum__I($m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit()) >= 0) && (this !== $m_Ljava_time_temporal_ChronoUnit$().FOREVER__Ljava_time_temporal_ChronoUnit()))
});
$c_Ljava_time_temporal_ChronoUnit.prototype.isTimeBased__Z = (function() {
  return (this.compareTo__jl_Enum__I($m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit()) < 0)
});
$c_Ljava_time_temporal_ChronoUnit.prototype.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(dateTime, periodToAdd) {
  return $n(dateTime).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(periodToAdd, this)
});
$c_Ljava_time_temporal_ChronoUnit.prototype.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J = (function(temporal1, temporal2) {
  return $n(temporal1).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(temporal2, this)
});
$c_Ljava_time_temporal_ChronoUnit.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_ChronoUnit__f_name
});
function $as_Ljava_time_temporal_ChronoUnit(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_ChronoUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.ChronoUnit"))
}
function $isArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ChronoUnit)))
}
function $asArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.ChronoUnit;", depth))
}
var $d_Ljava_time_temporal_ChronoUnit = new $TypeData().initClass({
  Ljava_time_temporal_ChronoUnit: 0
}, false, "java.time.temporal.ChronoUnit", {
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1
});
$c_Ljava_time_temporal_ChronoUnit.prototype.$classData = $d_Ljava_time_temporal_ChronoUnit;
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_Ljava_time_temporal_IsoFields$Field.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_IsoFields$Field.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field() {
  /*<skip>*/
}
$h_Ljava_time_temporal_IsoFields$Field.prototype = $c_Ljava_time_temporal_IsoFields$Field.prototype;
$c_Ljava_time_temporal_IsoFields$Field.prototype.resolve__ju_Map__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_ResolverStyle__Ljava_time_temporal_TemporalAccessor = (function(fieldValues, partialTemporal, resolverStyle) {
  return null
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.isDateBased__Z = (function() {
  return true
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.isTimeBased__Z = (function() {
  return false
});
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Unit(name, ordinal, duration) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_IsoFields$Unit__f_name = null;
  this.Ljava_time_temporal_IsoFields$Unit__f_duration = null;
  this.Ljava_time_temporal_IsoFields$Unit__f_name = name;
  this.Ljava_time_temporal_IsoFields$Unit__f_duration = duration;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_temporal_IsoFields$Unit.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_IsoFields$Unit.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Unit;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Unit() {
  /*<skip>*/
}
$h_Ljava_time_temporal_IsoFields$Unit.prototype = $c_Ljava_time_temporal_IsoFields$Unit.prototype;
$c_Ljava_time_temporal_IsoFields$Unit.prototype.getDuration__Ljava_time_Duration = (function() {
  return this.Ljava_time_temporal_IsoFields$Unit__f_duration
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.isDateBased__Z = (function() {
  return true
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(temporal, periodToAdd) {
  var x = $m_Ljava_time_temporal_IsoFields$Unit$().WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $$x1 = (this$1 === this)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var value = $n(temporal).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField());
    var hi = (value >> 31);
    var t = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(value, hi), periodToAdd);
    var lo = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    return $n(temporal).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField(), new $c_RTLong(lo, hi$1))
  } else {
    var x$3 = $m_Ljava_time_temporal_IsoFields$Unit$().QUARTER_YEARS__Ljava_time_temporal_IsoFields$Unit();
    if ((x$3 !== null)) {
      var this$3 = $n(x$3);
      var $$x2 = (this$3 === this)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var this$4 = $m_RTLong$();
      var lo$1 = this$4.divideImpl__I__I__I__I__I(periodToAdd.RTLong__f_lo, periodToAdd.RTLong__f_hi, 256, 0);
      var hi$2 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x3 = $n($n(temporal).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(lo$1, hi$2), $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit()));
      var this$5 = $m_RTLong$();
      var lo$2 = this$5.remainderImpl__I__I__I__I__I(periodToAdd.RTLong__f_lo, periodToAdd.RTLong__f_hi, 256, 0);
      var hi$3 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var b0 = (65535 & lo$2);
      var b1 = ((lo$2 >>> 16) | 0);
      var a0b0 = Math.imul(3, b0);
      var a0b1 = Math.imul(3, b1);
      var lo$3 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((Math.imul(3, hi$3) + ((c1part >>> 16) | 0)) | 0);
      return $n($$x3).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(lo$3, hi$4), $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit())
    } else {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Unreachable")
    }
  }
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J = (function(temporal1, temporal2) {
  var x = $m_Ljava_time_temporal_IsoFields$Unit$().WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $$x1 = (this$1 === this)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var t = $n(temporal2).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = $n(temporal1).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField());
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    return $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1))
  } else {
    var x$3 = $m_Ljava_time_temporal_IsoFields$Unit$().QUARTER_YEARS__Ljava_time_temporal_IsoFields$Unit();
    if ((x$3 !== null)) {
      var this$2 = $n(x$3);
      var $$x2 = (this$2 === this)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var this$3 = $n(temporal1).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(temporal2, $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit());
      var this$4 = $m_RTLong$();
      var lo$2 = this$4.divideImpl__I__I__I__I__I(this$3.RTLong__f_lo, this$3.RTLong__f_hi, 3, 0);
      var hi$2 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$2, hi$2)
    } else {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Unreachable")
    }
  }
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_IsoFields$Unit__f_name
});
var $d_Ljava_time_temporal_IsoFields$Unit = new $TypeData().initClass({
  Ljava_time_temporal_IsoFields$Unit: 0
}, false, "java.time.temporal.IsoFields$Unit", {
  Ljava_time_temporal_IsoFields$Unit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.$classData = $d_Ljava_time_temporal_IsoFields$Unit;
/** @constructor */
function $c_ju_AbstractList() {
  /*<skip>*/
}
$c_ju_AbstractList.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractList.prototype.constructor = $c_ju_AbstractList;
/** @constructor */
function $h_ju_AbstractList() {
  /*<skip>*/
}
$h_ju_AbstractList.prototype = $c_ju_AbstractList.prototype;
$c_ju_AbstractList.prototype.add__O__Z = (function(element) {
  this.add__I__O__V(this.size__I(), element);
  return true
});
$c_ju_AbstractList.prototype.set__I__O__O = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_AbstractList.prototype.add__I__O__V = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_AbstractList.prototype.remove__I__O = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_AbstractList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0)
});
$c_ju_AbstractList.prototype.listIterator__ju_ListIterator = (function() {
  return this.listIterator__I__ju_ListIterator(0)
});
$c_ju_AbstractList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  return new $c_ju_RandomAccessListIterator(this, index, 0, this.size__I())
});
$c_ju_AbstractList.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true
  } else if ($is_ju_List(o)) {
    var x2 = $as_ju_List(o);
    var oIter = $n(x2).listIterator__ju_ListIterator();
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while ($n(_\uff3fself).hasNext__Z()) {
        var x$2 = $n(_\uff3fself).next__O();
        if ($n(oIter).hasNext__Z()) {
          var b = $n(oIter).next__O();
          var $$x2 = ((x$2 === null) ? (b === null) : $dp_equals__O__Z($n(x$2), b))
        } else {
          var $$x2 = false
        };
        if ((!$$x2)) {
          var $$x1 = true;
          break _return
        }
      };
      var $$x1 = false
    };
    if ((!$$x1)) {
      return (!$n(oIter).hasNext__Z())
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_AbstractList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while ($n(_\uff3fself).hasNext__Z()) {
    var prev$2 = result;
    var elem$2 = $n(_\uff3fself).next__O();
    var prev = $uI(prev$2);
    result = ((Math.imul(31, prev) + ((elem$2 === null) ? 0 : $dp_hashCode__I($n(elem$2)))) | 0)
  };
  return $uI(result)
});
$c_ju_AbstractList.prototype.checkIndexInBounds__I__V = (function(index) {
  if (((index < 0) || (index >= this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
$c_ju_AbstractList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if (((index < 0) || (index > this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
/** @constructor */
function $c_ju_AbstractSet() {
  /*<skip>*/
}
$c_ju_AbstractSet.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractSet.prototype.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
  /*<skip>*/
}
$h_ju_AbstractSet.prototype = $c_ju_AbstractSet.prototype;
$c_ju_AbstractSet.prototype.equals__O__Z = (function(that) {
  if ((that === this)) {
    return true
  } else if ($is_ju_Collection(that)) {
    var x2 = $as_ju_Collection(that);
    return (($n(x2).size__I() === this.size__I()) && this.containsAll__ju_Collection__Z(x2))
  } else {
    return false
  }
});
$c_ju_AbstractSet.prototype.hashCode__I = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = 0;
  while ($n(_\uff3fself).hasNext__Z()) {
    var prev$2 = result;
    var item$2 = $n(_\uff3fself).next__O();
    var prev = $uI(prev$2);
    result = (($dp_hashCode__I($n(item$2)) + prev) | 0)
  };
  return $uI(result)
});
function $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner) {
  $thiz.ju_Collections$UnmodifiableCollection__f_inner = inner;
  $thiz.ju_Collections$UnmodifiableCollection__f_eagerThrow = true;
  return $thiz
}
/** @constructor */
function $c_ju_Collections$UnmodifiableCollection() {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false
}
$c_ju_Collections$UnmodifiableCollection.prototype = new $h_O();
$c_ju_Collections$UnmodifiableCollection.prototype.constructor = $c_ju_Collections$UnmodifiableCollection;
/** @constructor */
function $h_ju_Collections$UnmodifiableCollection() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableCollection.prototype = $c_ju_Collections$UnmodifiableCollection.prototype;
$c_ju_Collections$UnmodifiableCollection.prototype.size__I = (function() {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).size__I()
});
$c_ju_Collections$UnmodifiableCollection.prototype.isEmpty__Z = (function() {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).isEmpty__Z()
});
$c_ju_Collections$UnmodifiableCollection.prototype.contains__O__Z = (function(o) {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).contains__O__Z(o)
});
$c_ju_Collections$UnmodifiableCollection.prototype.toArray__AO = (function() {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).toArray__AO()
});
$c_ju_Collections$UnmodifiableCollection.prototype.toArray__AO__AO = (function(a) {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).toArray__AO__AO(a)
});
$c_ju_Collections$UnmodifiableCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).containsAll__ju_Collection__Z(c)
});
$c_ju_Collections$UnmodifiableCollection.prototype.toString__T = (function() {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).toString__T()
});
$c_ju_Collections$UnmodifiableCollection.prototype.eagerThrow__Z = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_eagerThrow
});
$c_ju_Collections$UnmodifiableCollection.prototype.iterator__ju_Iterator = (function() {
  return $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(new $c_ju_Collections$UnmodifiableIterator(), $n(this.ju_Collections$UnmodifiableCollection__f_inner).iterator__ju_Iterator())
});
$c_ju_Collections$UnmodifiableCollection.prototype.add__O__Z = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_Collections$UnmodifiableCollection.prototype.remove__O__Z = (function(o) {
  if ((this.eagerThrow__Z() || $n(this.ju_Collections$UnmodifiableCollection__f_inner).contains__O__Z(o))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  } else {
    return false
  }
});
$c_ju_Collections$UnmodifiableCollection.prototype.retainAll__ju_Collection__Z = (function(c) {
  if (this.eagerThrow__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  } else {
    var _\uff3fself = this.iterator__ju_Iterator();
    while ($n(_\uff3fself).hasNext__Z()) {
      var item$2 = $n(_\uff3fself).next__O();
      if ((!$n(c).contains__O__Z(item$2))) {
        throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
      }
    };
    return false
  }
});
class $c_ju_ConcurrentModificationException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_ju_ConcurrentModificationException = new $TypeData().initClass({
  ju_ConcurrentModificationException: 0
}, false, "java.util.ConcurrentModificationException", {
  ju_ConcurrentModificationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_ConcurrentModificationException.prototype.$classData = $d_ju_ConcurrentModificationException;
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var node = $thiz.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + $n($thiz.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0)));
  return ((node === null) ? defaultValue : ($thiz.nodeWasAccessed__ju_HashMap$Node__V(node), $n(node).ju_HashMap$Node__f_value))
}
function $p_ju_HashMap__putOrRemove0__O__I__I__ju_HashMap$Node__O__O($thiz, key, hash, idx, node, newValue) {
  if ((newValue !== null)) {
    $p_ju_HashMap__put0__O__O__I__ju_HashMap$Node__V($thiz, key, newValue, hash, node)
  } else if ((node !== null)) {
    $thiz.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx)
  };
  return newValue
}
function $p_ju_HashMap__put0__O__O__I__ju_HashMap$Node__V($thiz, key, value, hash, node) {
  if ((node !== null)) {
    $n(node).ju_HashMap$Node__f_value = value
  } else {
    var newContentSize = ((1 + $thiz.ju_HashMap__f_contentSize) | 0);
    if ((newContentSize >= $thiz.ju_HashMap__f_threshold)) {
      $p_ju_HashMap__growTable__V($thiz)
    };
    var idx = (hash & (((-1) + $n($thiz.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0));
    var x1 = $n($thiz.ju_HashMap__f_java$util$HashMap$$table).get(idx);
    if ((x1 === null)) {
      var newNode = $thiz.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, null, null);
      $n($thiz.ju_HashMap__f_java$util$HashMap$$table).set(idx, newNode);
      var newNode$3 = newNode
    } else {
      var prev = null;
      var n = x1;
      while (((n !== null) && ($n(n).ju_HashMap$Node__f_hash < hash))) {
        prev = n;
        n = $n(n).ju_HashMap$Node__f_next
      };
      var newNode$2 = $thiz.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, prev, n);
      if ((prev === null)) {
        $n($thiz.ju_HashMap__f_java$util$HashMap$$table).set(idx, newNode$2)
      } else {
        $n(prev).ju_HashMap$Node__f_next = newNode$2
      };
      if ((n !== null)) {
        $n(n).ju_HashMap$Node__f_previous = newNode$2
      };
      var newNode$3 = newNode$2
    };
    $thiz.ju_HashMap__f_contentSize = newContentSize;
    $thiz.nodeWasAdded__ju_HashMap$Node__V(newNode$3)
  }
}
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.ju_HashMap__f_java$util$HashMap$$table;
  var oldlen = $n(oldTable).u.length;
  var newlen = (oldlen << 1);
  var newTable = new ($d_ju_HashMap$Node.getArrayOf().constr)(newlen);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = newTable;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((newlen * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = $n(oldTable).get(i);
    while ((node !== null)) {
      if ((($n(node).ju_HashMap$Node__f_hash & oldlen) === 0)) {
        $n(node).ju_HashMap$Node__f_previous = lastLow;
        if ((lastLow === null)) {
          $n(newTable).set(i, node)
        } else {
          $n(lastLow).ju_HashMap$Node__f_next = node
        };
        lastLow = node
      } else {
        $n(node).ju_HashMap$Node__f_previous = lastHigh;
        if ((lastHigh === null)) {
          $n(newTable).set(((oldlen + i) | 0), node)
        } else {
          $n(lastHigh).ju_HashMap$Node__f_next = node
        };
        lastHigh = node
      };
      node = $n(node).ju_HashMap$Node__f_next
    };
    if ((lastLow !== null)) {
      $n(lastLow).ju_HashMap$Node__f_next = null
    };
    if ((lastHigh !== null)) {
      $n(lastHigh).ju_HashMap$Node__f_next = null
    };
    i = ((1 + i) | 0)
  }
}
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor = loadFactor;
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "initialCapacity < 0")
  };
  if ((loadFactor <= 0.0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "loadFactor <= 0.0")
  };
  var a = (((-1) + initialCapacity) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> $uI(Math.clz32(i))) & i) << 1);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = new ($d_ju_HashMap$Node.getArrayOf().constr)(((a$1 < 1073741824) ? a$1 : 1073741824));
  var size = $n($thiz.ju_HashMap__f_java$util$HashMap$$table).u.length;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((size * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  $thiz.ju_HashMap__f_contentSize = 0;
  return $thiz
}
function $ct_ju_HashMap__($thiz) {
  $ct_ju_HashMap__I__F__($thiz, 16, 0.75);
  return $thiz
}
function $ct_ju_HashMap__I__($thiz, initialCapacity) {
  $ct_ju_HashMap__I__F__($thiz, initialCapacity, 0.75);
  return $thiz
}
/** @constructor */
function $c_ju_HashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0
}
$c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$c_ju_HashMap.prototype.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
  /*<skip>*/
}
$h_ju_HashMap.prototype = $c_ju_HashMap.prototype;
$c_ju_HashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(new $c_ju_HashMap$Node(), key, hash, value, previous, next)
});
$c_ju_HashMap.prototype.nodeWasAccessed__ju_HashMap$Node__V = (function(node) {
  /*<skip>*/
});
$c_ju_HashMap.prototype.nodeWasAdded__ju_HashMap$Node__V = (function(node) {
  /*<skip>*/
});
$c_ju_HashMap.prototype.nodeWasRemoved__ju_HashMap$Node__V = (function(node) {
  /*<skip>*/
});
$c_ju_HashMap.prototype.size__I = (function() {
  return this.ju_HashMap__f_contentSize
});
$c_ju_HashMap.prototype.isEmpty__Z = (function() {
  return (this.ju_HashMap__f_contentSize === 0)
});
$c_ju_HashMap.prototype.get__O__O = (function(key) {
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this, key, null)
});
$c_ju_HashMap.prototype.containsKey__O__Z = (function(key) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  return (this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + $n(this.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0))) !== null)
});
$c_ju_HashMap.prototype.put__O__O__O = (function(key, value) {
  if ((key === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  return this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $$x1, false)
});
$c_ju_HashMap.prototype.putAll__ju_Map__V = (function(m) {
  if ((m instanceof $c_ju_HashMap)) {
    var x2 = $as_ju_HashMap(m);
    var iter = $n(x2).nodeIterator__ju_Iterator();
    while ($n(iter).hasNext__Z()) {
      var next = $as_ju_HashMap$Node($n(iter).next__O());
      this.java$util$HashMap$$put0__O__O__I__Z__O($n(next).ju_HashMap$Node__f_key, $n(next).ju_HashMap$Node__f_value, $n(next).ju_HashMap$Node__f_hash, false)
    }
  } else {
    $c_ju_AbstractMap.prototype.putAll__ju_Map__V.call(this, m)
  }
});
$c_ju_HashMap.prototype.remove__O__O = (function(key) {
  var node = this.java$util$HashMap$$remove0__O__ju_HashMap$Node(key);
  return ((node === null) ? null : $n(node).ju_HashMap$Node__f_value)
});
$c_ju_HashMap.prototype.keySet__ju_Set = (function() {
  return new $c_ju_HashMap$KeySet(this)
});
$c_ju_HashMap.prototype.entrySet__ju_Set = (function() {
  return new $c_ju_HashMap$EntrySet(this)
});
$c_ju_HashMap.prototype.computeIfAbsent__O__ju_function_Function__O = (function(key, mappingFunction) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var idx = (hash & (((-1) + $n(this.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0));
  var node = this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
  var value = ((node === null) ? null : (this.nodeWasAccessed__ju_HashMap$Node__V(node), $n(node).ju_HashMap$Node__f_value));
  if ((value !== null)) {
    return value
  } else {
    var newValue = $n(mappingFunction).apply__O__O(key);
    if ((newValue !== null)) {
      $p_ju_HashMap__put0__O__O__I__ju_HashMap$Node__V(this, key, newValue, hash, node)
    };
    return newValue
  }
});
$c_ju_HashMap.prototype.compute__O__ju_function_BiFunction__O = (function(key, remappingFunction) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var idx = (hash & (((-1) + $n(this.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0));
  var node = this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
  var value = ((node === null) ? null : (this.nodeWasAccessed__ju_HashMap$Node__V(node), $n(node).ju_HashMap$Node__f_value));
  var newValue = $n(remappingFunction).apply__O__O__O(key, value);
  return $p_ju_HashMap__putOrRemove0__O__I__I__ju_HashMap$Node__O__O(this, key, hash, idx, node, newValue)
});
$c_ju_HashMap.prototype.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node = (function(key, hash, idx) {
  var node = $n(this.ju_HashMap__f_java$util$HashMap$$table).get(idx);
  while (true) {
    if ((node === null)) {
      return null
    } else {
      if ((hash === $n(node).ju_HashMap$Node__f_hash)) {
        var b = $n(node).ju_HashMap$Node__f_key;
        var $$x1 = ((key === null) ? (b === null) : $dp_equals__O__Z($n(key), b))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        return node
      } else if ((hash < $n(node).ju_HashMap$Node__f_hash)) {
        return null
      } else {
        node = $n(node).ju_HashMap$Node__f_next
      }
    }
  }
});
$c_ju_HashMap.prototype.java$util$HashMap$$put0__O__O__I__Z__O = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.ju_HashMap__f_contentSize) | 0);
  if ((newContentSize >= this.ju_HashMap__f_threshold)) {
    $p_ju_HashMap__growTable__V(this)
  };
  var idx = (hash & (((-1) + $n(this.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0));
  var x1 = $n(this.ju_HashMap__f_java$util$HashMap$$table).get(idx);
  if ((x1 === null)) {
    var newNode = this.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, null, null);
    $n(this.ju_HashMap__f_java$util$HashMap$$table).set(idx, newNode);
    var newNode$3 = newNode
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && ($n(n).ju_HashMap$Node__f_hash <= hash))) {
      if (($n(n).ju_HashMap$Node__f_hash === hash)) {
        var b = $n(n).ju_HashMap$Node__f_key;
        var $$x1 = ((key === null) ? (b === null) : $dp_equals__O__Z($n(key), b))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        this.nodeWasAccessed__ju_HashMap$Node__V(n);
        var old = $n(n).ju_HashMap$Node__f_value;
        if (((!ifAbsent) || (old === null))) {
          $n(n).ju_HashMap$Node__f_value = value
        };
        return old
      };
      prev = n;
      n = $n(n).ju_HashMap$Node__f_next
    };
    var newNode$2 = this.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, prev, n);
    if ((prev === null)) {
      $n(this.ju_HashMap__f_java$util$HashMap$$table).set(idx, newNode$2)
    } else {
      $n(prev).ju_HashMap$Node__f_next = newNode$2
    };
    if ((n !== null)) {
      $n(n).ju_HashMap$Node__f_previous = newNode$2
    };
    var newNode$3 = newNode$2
  };
  this.ju_HashMap__f_contentSize = newContentSize;
  this.nodeWasAdded__ju_HashMap$Node__V(newNode$3);
  return null
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__O__ju_HashMap$Node = (function(key) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var idx = (hash & (((-1) + $n(this.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0));
  var node = this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
  if ((node !== null)) {
    this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx)
  };
  return node
});
$c_ju_HashMap.prototype.removeNode__ju_HashMap$Node__V = (function(node) {
  var hash = $n(node).ju_HashMap$Node__f_hash;
  this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, (hash & (((-1) + $n(this.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0)))
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__ju_HashMap$Node__I__V = (function(node, idx) {
  var previous = $n(node).ju_HashMap$Node__f_previous;
  var next = $n(node).ju_HashMap$Node__f_next;
  if ((previous === null)) {
    $n(this.ju_HashMap__f_java$util$HashMap$$table).set(idx, next)
  } else {
    $n(previous).ju_HashMap$Node__f_next = next
  };
  if ((next !== null)) {
    $n(next).ju_HashMap$Node__f_previous = previous
  };
  this.ju_HashMap__f_contentSize = (((-1) + this.ju_HashMap__f_contentSize) | 0);
  this.nodeWasRemoved__ju_HashMap$Node__V(node)
});
$c_ju_HashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_HashMap$NodeIterator(this)
});
$c_ju_HashMap.prototype.keyIterator__ju_Iterator = (function() {
  return new $c_ju_HashMap$KeyIterator(this)
});
function $as_ju_HashMap(obj) {
  return (((obj instanceof $c_ju_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.HashMap"))
}
function $isArrayOf_ju_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_HashMap)))
}
function $asArrayOf_ju_HashMap(obj, depth) {
  return (($isArrayOf_ju_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.HashMap;", depth))
}
var $d_ju_HashMap = new $TypeData().initClass({
  ju_HashMap: 0
}, false, "java.util.HashMap", {
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
});
$c_ju_HashMap.prototype.$classData = $d_ju_HashMap;
function $ct_ju_IllformedLocaleException__T__I__($thiz, s, errorIndex) {
  var s$1 = (s + ((errorIndex < 0) ? "" : ((" [at index " + errorIndex) + "]")));
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s$1, null, true, true);
  return $thiz
}
function $ct_ju_IllformedLocaleException__T__($thiz, s) {
  $ct_ju_IllformedLocaleException__T__I__($thiz, s, (-1));
  return $thiz
}
class $c_ju_IllformedLocaleException extends $c_jl_RuntimeException {
}
var $d_ju_IllformedLocaleException = new $TypeData().initClass({
  ju_IllformedLocaleException: 0
}, false, "java.util.IllformedLocaleException", {
  ju_IllformedLocaleException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllformedLocaleException.prototype.$classData = $d_ju_IllformedLocaleException;
/** @constructor */
function $c_ju_Locale$$anonfun$getExtension$1(outer) {
  /*<skip>*/
}
$c_ju_Locale$$anonfun$getExtension$1.prototype = new $h_sr_AbstractPartialFunction();
$c_ju_Locale$$anonfun$getExtension$1.prototype.constructor = $c_ju_Locale$$anonfun$getExtension$1;
/** @constructor */
function $h_ju_Locale$$anonfun$getExtension$1() {
  /*<skip>*/
}
$h_ju_Locale$$anonfun$getExtension$1.prototype = $c_ju_Locale$$anonfun$getExtension$1.prototype;
$c_ju_Locale$$anonfun$getExtension$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var k = $as_T($n(x1)._1__O());
    var v = $as_T($n(x1)._2__O());
    var this$1 = $n(v);
    if ((this$1 === "")) {
      return k
    }
  };
  if ((x1 !== null)) {
    var k$2 = $as_T($n(x1)._1__O());
    var v$2 = $as_T($n(x1)._2__O());
    return ((k$2 + "-") + v$2)
  };
  return $n(default$1).apply__O__O(x1)
});
$c_ju_Locale$$anonfun$getExtension$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var v = $as_T($n(x1)._2__O());
    var this$1 = $n(v);
    if ((this$1 === "")) {
      return true
    }
  };
  if ((x1 !== null)) {
    return true
  };
  return false
});
$c_ju_Locale$$anonfun$getExtension$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_ju_Locale$$anonfun$getExtension$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_ju_Locale$$anonfun$getExtension$1 = new $TypeData().initClass({
  ju_Locale$$anonfun$getExtension$1: 0
}, false, "java.util.Locale$$anonfun$getExtension$1", {
  ju_Locale$$anonfun$getExtension$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Locale$$anonfun$getExtension$1.prototype.$classData = $d_ju_Locale$$anonfun$getExtension$1;
function $ct_ju_NoSuchElementException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_ju_NoSuchElementException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_ju_NoSuchElementException extends $c_jl_RuntimeException {
}
var $d_ju_NoSuchElementException = new $TypeData().initClass({
  ju_NoSuchElementException: 0
}, false, "java.util.NoSuchElementException", {
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_NoSuchElementException.prototype.$classData = $d_ju_NoSuchElementException;
/** @constructor */
function $c_ju_RandomAccessListIterator(list, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_RandomAccessListIterator__f_list = null;
  this.ju_RandomAccessListIterator__f_list = list;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end)
}
$c_ju_RandomAccessListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_RandomAccessListIterator.prototype.constructor = $c_ju_RandomAccessListIterator;
/** @constructor */
function $h_ju_RandomAccessListIterator() {
  /*<skip>*/
}
$h_ju_RandomAccessListIterator.prototype = $c_ju_RandomAccessListIterator.prototype;
$c_ju_RandomAccessListIterator.prototype.get__I__O = (function(index) {
  return $n(this.ju_RandomAccessListIterator__f_list).get__I__O(index)
});
$c_ju_RandomAccessListIterator.prototype.set__I__O__V = (function(index, e) {
  $n(this.ju_RandomAccessListIterator__f_list).set__I__O__O(index, e)
});
$c_ju_RandomAccessListIterator.prototype.remove__I__V = (function(index) {
  $n(this.ju_RandomAccessListIterator__f_list).remove__I__O(index)
});
var $d_ju_RandomAccessListIterator = new $TypeData().initClass({
  ju_RandomAccessListIterator: 0
}, false, "java.util.RandomAccessListIterator", {
  ju_RandomAccessListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  O: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
});
$c_ju_RandomAccessListIterator.prototype.$classData = $d_ju_RandomAccessListIterator;
function $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_concurrent_ConcurrentHashMap__f_inner = new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor);
  return $thiz
}
function $ct_ju_concurrent_ConcurrentHashMap__($thiz) {
  $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap() {
  this.ju_concurrent_ConcurrentHashMap__f_inner = null
}
$c_ju_concurrent_ConcurrentHashMap.prototype = new $h_ju_AbstractMap();
$c_ju_concurrent_ConcurrentHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap.prototype.size__I = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).ju_HashMap__f_contentSize
});
$c_ju_concurrent_ConcurrentHashMap.prototype.isEmpty__Z = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).isEmpty__Z()
});
$c_ju_concurrent_ConcurrentHashMap.prototype.get__O__O = (function(key) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).get__O__O(key)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.containsKey__O__Z = (function(key) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).containsKey__O__Z(key)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.put__O__O__O = (function(key, value) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).put__O__O__O(key, value)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.remove__O__O = (function(key) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).remove__O__O(key)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.keySet__ju_concurrent_ConcurrentHashMap$KeySetView = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$KeySetView(this.ju_concurrent_ConcurrentHashMap__f_inner, null)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.entrySet__ju_Set = (function() {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap__f_inner);
  return new $c_ju_HashMap$EntrySet(this$1)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.hashCode__I = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).hashCode__I()
});
$c_ju_concurrent_ConcurrentHashMap.prototype.toString__T = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).toString__T()
});
$c_ju_concurrent_ConcurrentHashMap.prototype.equals__O__Z = (function(o) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).equals__O__Z(o)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.keySet__ju_Set = (function() {
  return this.keySet__ju_concurrent_ConcurrentHashMap$KeySetView()
});
var $d_ju_concurrent_ConcurrentHashMap = new $TypeData().initClass({
  ju_concurrent_ConcurrentHashMap: 0
}, false, "java.util.concurrent.ConcurrentHashMap", {
  ju_concurrent_ConcurrentHashMap: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  ju_concurrent_ConcurrentMap: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_ConcurrentHashMap.prototype.$classData = $d_ju_concurrent_ConcurrentHashMap;
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$KeySetView(innerMap, defaultValue) {
  this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap = null;
  this.ju_concurrent_ConcurrentHashMap$KeySetView__f_defaultValue = null;
  this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap = innerMap;
  this.ju_concurrent_ConcurrentHashMap$KeySetView__f_defaultValue = defaultValue
}
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype = new $h_O();
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$KeySetView;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$KeySetView() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap$KeySetView.prototype = $c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype;
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.contains__O__Z = (function(o) {
  return $n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap).containsKey__O__Z(o)
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.remove__O__Z = (function(o) {
  return ($n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap).remove__O__O(o) !== null)
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.iterator__ju_Iterator = (function() {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap);
  return new $c_ju_HashMap$KeySet(this$1).iterator__ju_Iterator()
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.size__I = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap).ju_HashMap__f_contentSize
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.isEmpty__Z = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap).isEmpty__Z()
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.toArray__AO = (function() {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap);
  return new $c_ju_HashMap$KeySet(this$1).toArray__AO()
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.toArray__AO__AO = (function(a) {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap);
  return new $c_ju_HashMap$KeySet(this$1).toArray__AO__AO(a)
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.add__O__Z = (function(e) {
  if ((this.ju_concurrent_ConcurrentHashMap$KeySetView__f_defaultValue === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  };
  return ($n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap).putIfAbsent__O__O__O(e, this.ju_concurrent_ConcurrentHashMap$KeySetView__f_defaultValue) === null)
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.toString__T = (function() {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap);
  return new $c_ju_HashMap$KeySet(this$1).toString__T()
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.containsAll__ju_Collection__Z = (function(c) {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap);
  return new $c_ju_HashMap$KeySet(this$1).containsAll__ju_Collection__Z(c)
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.retainAll__ju_Collection__Z = (function(c) {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap);
  return new $c_ju_HashMap$KeySet(this$1).retainAll__ju_Collection__Z(c)
});
var $d_ju_concurrent_ConcurrentHashMap$KeySetView = new $TypeData().initClass({
  ju_concurrent_ConcurrentHashMap$KeySetView: 0
}, false, "java.util.concurrent.ConcurrentHashMap$KeySetView", {
  ju_concurrent_ConcurrentHashMap$KeySetView: 1,
  O: 1,
  ju_Set: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.$classData = $d_ju_concurrent_ConcurrentHashMap$KeySetView;
/** @constructor */
function $c_ju_concurrent_CopyOnWriteArrayListIterator(arraySnapshot, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot = null;
  this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot = arraySnapshot;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end)
}
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.constructor = $c_ju_concurrent_CopyOnWriteArrayListIterator;
/** @constructor */
function $h_ju_concurrent_CopyOnWriteArrayListIterator() {
  /*<skip>*/
}
$h_ju_concurrent_CopyOnWriteArrayListIterator.prototype = $c_ju_concurrent_CopyOnWriteArrayListIterator.prototype;
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.remove__V = (function() {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.set__O__V = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.get__I__O = (function(index) {
  return this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot[index]
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.remove__I__V = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.set__I__O__V = (function(index, e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
var $d_ju_concurrent_CopyOnWriteArrayListIterator = new $TypeData().initClass({
  ju_concurrent_CopyOnWriteArrayListIterator: 0
}, false, "java.util.concurrent.CopyOnWriteArrayListIterator", {
  ju_concurrent_CopyOnWriteArrayListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  O: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.$classData = $d_ju_concurrent_CopyOnWriteArrayListIterator;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "NANOSECONDS", 0)
}
$c_ju_concurrent_TimeUnit$$anon$1.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$1.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$1() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$1.prototype = $c_ju_concurrent_TimeUnit$$anon$1.prototype;
$c_ju_concurrent_TimeUnit$$anon$1.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toNanos__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toNanos__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMicros__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-129542144), 13);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 817405952, 838);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$1 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$1: 0
}, false, "java.util.concurrent.TimeUnit$$anon$1", {
  ju_concurrent_TimeUnit$$anon$1: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MICROSECONDS", 1)
}
$c_ju_concurrent_TimeUnit$$anon$2.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$2.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$2() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$2.prototype = $c_ju_concurrent_TimeUnit$$anon$2.prototype;
$c_ju_concurrent_TimeUnit$$anon$2.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toMicros__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMicros__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-694967296), 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 500654080, 20);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$2 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$2: 0
}, false, "java.util.concurrent.TimeUnit$$anon$2", {
  ju_concurrent_TimeUnit$$anon$2: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MILLISECONDS", 2)
}
$c_ju_concurrent_TimeUnit$$anon$3.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$3.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$3() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$3.prototype = $c_ju_concurrent_TimeUnit$$anon$3.prototype;
$c_ju_concurrent_TimeUnit$$anon$3.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toMillis__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147))
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMillis__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$3 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$3: 0
}, false, "java.util.concurrent.TimeUnit$$anon$3", {
  ju_concurrent_TimeUnit$$anon$3: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SECONDS", 3)
}
$c_ju_concurrent_TimeUnit$$anon$4.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$4.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$4() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$4.prototype = $c_ju_concurrent_TimeUnit$$anon$4.prototype;
$c_ju_concurrent_TimeUnit$$anon$4.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toSeconds__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000000, 0), new $c_RTLong(633437444, 2))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toSeconds__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$4 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$4: 0
}, false, "java.util.concurrent.TimeUnit$$anon$4", {
  ju_concurrent_TimeUnit$$anon$4: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MINUTES", 4)
}
$c_ju_concurrent_TimeUnit$$anon$5.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$5.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$5() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$5.prototype = $c_ju_concurrent_TimeUnit$$anon$5.prototype;
$c_ju_concurrent_TimeUnit$$anon$5.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toMinutes__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-129542144), 13), new $c_RTLong(153722867, 0))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000000, 0), new $c_RTLong((-895955376), 35))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000, 0), new $c_RTLong(1692789776, 35791))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMinutes__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1440, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$5 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$5: 0
}, false, "java.util.concurrent.TimeUnit$$anon$5", {
  ju_concurrent_TimeUnit$$anon$5: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "HOURS", 5)
}
$c_ju_concurrent_TimeUnit$$anon$6.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$6.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$6() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$6.prototype = $c_ju_concurrent_TimeUnit$$anon$6.prototype;
$c_ju_concurrent_TimeUnit$$anon$6.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toHours__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(817405952, 838), new $c_RTLong(2562047, 0))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-694967296), 0), new $c_RTLong((-1732919508), 0))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600000, 0), new $c_RTLong((-2047687697), 596))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600, 0), new $c_RTLong(1011703407, 596523))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toHours__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 24, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$6 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$6: 0
}, false, "java.util.concurrent.TimeUnit$$anon$6", {
  ju_concurrent_TimeUnit$$anon$6: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DAYS", 6)
}
$c_ju_concurrent_TimeUnit$$anon$7.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$7.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$7() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$7.prototype = $c_ju_concurrent_TimeUnit$$anon$7.prototype;
$c_ju_concurrent_TimeUnit$$anon$7.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toDays__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-1857093632), 20116), new $c_RTLong(106751, 0))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(500654080, 20), new $c_RTLong(106751991, 0))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400000, 0), new $c_RTLong((-622191233), 24))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400, 0), new $c_RTLong(579025220, 24855))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1440, 0), new $c_RTLong(381774870, 1491308))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toHours__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(24, 0), new $c_RTLong(1431655765, 89478485))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toDays__J__J = (function(a) {
  return a
});
var $d_ju_concurrent_TimeUnit$$anon$7 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$7: 0
}, false, "java.util.concurrent.TimeUnit$$anon$7", {
  ju_concurrent_TimeUnit$$anon$7: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $c_Llocales_cldr_data_\uff3fen$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  var $$x11 = new $c_s_Some($m_Llocales_cldr_data_\uff3froot$());
  var $$x10 = new $c_Llocales_cldr_LDMLLocale("en", $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $$x9 = $m_s_None$();
  var $$x8 = $m_Llocales_cldr_data_\uff3fen\uff3fdata$().symbols__sci_List();
  $n($m_s_package$().s_package$__f_List);
  var array = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $n($m_s_package$().s_package$__f_List);
  var array$1 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var $$x6 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  $n($m_s_package$().s_package$__f_List);
  var array$2 = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var $$x5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  $n($m_s_package$().s_package$__f_List);
  var array$3 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var $$x4 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  $n($m_s_package$().s_package$__f_List);
  var array$4 = ["AM", "PM"];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var $$x3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  $n($m_s_package$().s_package$__f_List);
  var array$5 = ["BC", "AD"];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var $$x2 = new $c_s_Some(new $c_Llocales_cldr_CalendarSymbols($$x7, $$x6, $$x5, $$x4, $$x3, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5)));
  var this$28 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$6 = [$ct_T2__O__O__(new $c_T2(), 0, "EEEE, MMMM d, y"), $ct_T2__O__O__(new $c_T2(), 1, "MMMM d, y"), $ct_T2__O__O__(new $c_T2(), 2, "MMM d, y"), $ct_T2__O__O__(new $c_T2(), 3, "M/d/yy")];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var $$x1 = this$28.from__sc_IterableOnce__sci_Map(elems$6);
  var this$32 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$7 = [$ct_T2__O__O__(new $c_T2(), 0, "h:mm:ss a zzzz"), $ct_T2__O__O__(new $c_T2(), 1, "h:mm:ss a z"), $ct_T2__O__O__(new $c_T2(), 2, "h:mm:ss a"), $ct_T2__O__O__(new $c_T2(), 3, "h:mm a")];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $$x11, $$x10, $$x9, $$x8, $$x2, new $c_s_Some(new $c_Llocales_cldr_CalendarPatterns($$x1, this$32.from__sc_IterableOnce__sci_Map(elems$7))), $m_Llocales_cldr_data_\uff3fen\uff3fdata$().currencies__sci_List(), new $c_Llocales_cldr_NumberPatterns(new $c_s_Some("#,##0.###"), new $c_s_Some("#,##0%"), new $c_s_Some("\u00a4#,##0.00;(\u00a4#,##0.00)")))
}
$c_Llocales_cldr_data_\uff3fen$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_data_\uff3fen$.prototype.constructor = $c_Llocales_cldr_data_\uff3fen$;
/** @constructor */
function $h_Llocales_cldr_data_\uff3fen$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_\uff3fen$.prototype = $c_Llocales_cldr_data_\uff3fen$.prototype;
var $d_Llocales_cldr_data_\uff3fen$ = new $TypeData().initClass({
  Llocales_cldr_data_\uff3fen$: 0
}, false, "locales.cldr.data._en$", {
  Llocales_cldr_data_\uff3fen$: 1,
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_data_\uff3fen$.prototype.$classData = $d_Llocales_cldr_data_\uff3fen$;
var $n_Llocales_cldr_data_\uff3fen$;
function $m_Llocales_cldr_data_\uff3fen$() {
  if ((!$n_Llocales_cldr_data_\uff3fen$)) {
    $n_Llocales_cldr_data_\uff3fen$ = new $c_Llocales_cldr_data_\uff3fen$()
  };
  return $n_Llocales_cldr_data_\uff3fen$
}
/** @constructor */
function $c_Llocales_cldr_data_\uff3ffr$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  var $$x11 = new $c_s_Some($m_Llocales_cldr_data_\uff3froot$());
  var $$x10 = new $c_Llocales_cldr_LDMLLocale("fr", $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $$x9 = new $c_s_Some($m_Llocales_cldr_data_numericsystems$().latn__Llocales_cldr_NumberingSystem());
  var $$x8 = $m_Llocales_cldr_data_\uff3ffr\uff3fdata$().symbols__sci_List();
  $n($m_s_package$().s_package$__f_List);
  var array = ["janvier", "f\u00e9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\u00fbt", "septembre", "octobre", "novembre", "d\u00e9cembre"];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $n($m_s_package$().s_package$__f_List);
  var array$1 = ["janv.", "f\u00e9vr.", "mars", "avr.", "mai", "juin", "juil.", "ao\u00fbt", "sept.", "oct.", "nov.", "d\u00e9c."];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var $$x6 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  $n($m_s_package$().s_package$__f_List);
  var array$2 = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var $$x5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  $n($m_s_package$().s_package$__f_List);
  var array$3 = ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var $$x4 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  $n($m_s_package$().s_package$__f_List);
  var array$4 = ["AM", "PM"];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var $$x3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  $n($m_s_package$().s_package$__f_List);
  var array$5 = ["av. J.-C.", "ap. J.-C."];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var $$x2 = new $c_s_Some(new $c_Llocales_cldr_CalendarSymbols($$x7, $$x6, $$x5, $$x4, $$x3, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5)));
  var this$28 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$6 = [$ct_T2__O__O__(new $c_T2(), 0, "EEEE d MMMM y"), $ct_T2__O__O__(new $c_T2(), 1, "d MMMM y"), $ct_T2__O__O__(new $c_T2(), 2, "d MMM y"), $ct_T2__O__O__(new $c_T2(), 3, "dd/MM/y")];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var $$x1 = this$28.from__sc_IterableOnce__sci_Map(elems$6);
  var this$32 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$7 = [$ct_T2__O__O__(new $c_T2(), 0, "HH:mm:ss zzzz"), $ct_T2__O__O__(new $c_T2(), 1, "HH:mm:ss z"), $ct_T2__O__O__(new $c_T2(), 2, "HH:mm:ss"), $ct_T2__O__O__(new $c_T2(), 3, "HH:mm")];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $$x11, $$x10, $$x9, $$x8, $$x2, new $c_s_Some(new $c_Llocales_cldr_CalendarPatterns($$x1, this$32.from__sc_IterableOnce__sci_Map(elems$7))), $m_Llocales_cldr_data_\uff3ffr\uff3fdata$().currencies__sci_List(), new $c_Llocales_cldr_NumberPatterns(new $c_s_Some("#,##0.###"), new $c_s_Some("#,##0\u00a0%"), new $c_s_Some("#,##0.00\u00a0\u00a4;(#,##0.00\u00a0\u00a4)")))
}
$c_Llocales_cldr_data_\uff3ffr$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_data_\uff3ffr$.prototype.constructor = $c_Llocales_cldr_data_\uff3ffr$;
/** @constructor */
function $h_Llocales_cldr_data_\uff3ffr$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_\uff3ffr$.prototype = $c_Llocales_cldr_data_\uff3ffr$.prototype;
var $d_Llocales_cldr_data_\uff3ffr$ = new $TypeData().initClass({
  Llocales_cldr_data_\uff3ffr$: 0
}, false, "locales.cldr.data._fr$", {
  Llocales_cldr_data_\uff3ffr$: 1,
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_data_\uff3ffr$.prototype.$classData = $d_Llocales_cldr_data_\uff3ffr$;
var $n_Llocales_cldr_data_\uff3ffr$;
function $m_Llocales_cldr_data_\uff3ffr$() {
  if ((!$n_Llocales_cldr_data_\uff3ffr$)) {
    $n_Llocales_cldr_data_\uff3ffr$ = new $c_Llocales_cldr_data_\uff3ffr$()
  };
  return $n_Llocales_cldr_data_\uff3ffr$
}
/** @constructor */
function $c_Llocales_cldr_data_\uff3ffr\uff3fFR$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, new $c_s_Some($m_Llocales_cldr_data_\uff3ffr$()), new $c_Llocales_cldr_LDMLLocale("fr", new $c_s_Some("FR"), $m_s_None$(), $m_s_None$()), $m_s_None$(), $m_sci_Nil$(), $m_s_None$(), $m_s_None$(), $m_sci_Nil$(), new $c_Llocales_cldr_NumberPatterns($m_s_None$(), $m_s_None$(), $m_s_None$()))
}
$c_Llocales_cldr_data_\uff3ffr\uff3fFR$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_data_\uff3ffr\uff3fFR$.prototype.constructor = $c_Llocales_cldr_data_\uff3ffr\uff3fFR$;
/** @constructor */
function $h_Llocales_cldr_data_\uff3ffr\uff3fFR$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_\uff3ffr\uff3fFR$.prototype = $c_Llocales_cldr_data_\uff3ffr\uff3fFR$.prototype;
var $d_Llocales_cldr_data_\uff3ffr\uff3fFR$ = new $TypeData().initClass({
  Llocales_cldr_data_\uff3ffr\uff3fFR$: 0
}, false, "locales.cldr.data._fr_FR$", {
  Llocales_cldr_data_\uff3ffr\uff3fFR$: 1,
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_data_\uff3ffr\uff3fFR$.prototype.$classData = $d_Llocales_cldr_data_\uff3ffr\uff3fFR$;
var $n_Llocales_cldr_data_\uff3ffr\uff3fFR$;
function $m_Llocales_cldr_data_\uff3ffr\uff3fFR$() {
  if ((!$n_Llocales_cldr_data_\uff3ffr\uff3fFR$)) {
    $n_Llocales_cldr_data_\uff3ffr\uff3fFR$ = new $c_Llocales_cldr_data_\uff3ffr\uff3fFR$()
  };
  return $n_Llocales_cldr_data_\uff3ffr\uff3fFR$
}
/** @constructor */
function $c_Llocales_cldr_data_\uff3froot$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  var $$x11 = $m_s_None$();
  var $$x10 = new $c_Llocales_cldr_LDMLLocale("root", $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $$x9 = new $c_s_Some($m_Llocales_cldr_data_numericsystems$().latn__Llocales_cldr_NumberingSystem());
  var $$x8 = $m_Llocales_cldr_data_\uff3froot\uff3fdata$().symbols__sci_List();
  $n($m_s_package$().s_package$__f_List);
  var array = ["M01", "M02", "M03", "M04", "M05", "M06", "M07", "M08", "M09", "M10", "M11", "M12"];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var $$x6 = $m_sci_Nil$();
  $n($m_s_package$().s_package$__f_List);
  var array$1 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var $$x5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  var $$x4 = $m_sci_Nil$();
  var $$x3 = $m_sci_Nil$();
  $n($m_s_package$().s_package$__f_List);
  var array$2 = ["BCE", "CE"];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var $$x2 = new $c_s_Some(new $c_Llocales_cldr_CalendarSymbols($$x7, $$x6, $$x5, $$x4, $$x3, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2)));
  var this$16 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$3 = [$ct_T2__O__O__(new $c_T2(), 0, "y MMMM d, EEEE"), $ct_T2__O__O__(new $c_T2(), 1, "y MMMM d"), $ct_T2__O__O__(new $c_T2(), 2, "y MMM d"), $ct_T2__O__O__(new $c_T2(), 3, "y-MM-dd")];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var $$x1 = this$16.from__sc_IterableOnce__sci_Map(elems$3);
  var this$20 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$4 = [$ct_T2__O__O__(new $c_T2(), 0, "HH:mm:ss zzzz"), $ct_T2__O__O__(new $c_T2(), 1, "HH:mm:ss z"), $ct_T2__O__O__(new $c_T2(), 2, "HH:mm:ss"), $ct_T2__O__O__(new $c_T2(), 3, "HH:mm")];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $$x11, $$x10, $$x9, $$x8, $$x2, new $c_s_Some(new $c_Llocales_cldr_CalendarPatterns($$x1, this$20.from__sc_IterableOnce__sci_Map(elems$4))), $m_Llocales_cldr_data_\uff3froot\uff3fdata$().currencies__sci_List(), new $c_Llocales_cldr_NumberPatterns(new $c_s_Some("#,##0.###"), new $c_s_Some("#,##0%"), new $c_s_Some("\u00a4\u00a0#,##0.00")))
}
$c_Llocales_cldr_data_\uff3froot$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_data_\uff3froot$.prototype.constructor = $c_Llocales_cldr_data_\uff3froot$;
/** @constructor */
function $h_Llocales_cldr_data_\uff3froot$() {
  /*<skip>*/
}
$h_Llocales_cldr_data_\uff3froot$.prototype = $c_Llocales_cldr_data_\uff3froot$.prototype;
var $d_Llocales_cldr_data_\uff3froot$ = new $TypeData().initClass({
  Llocales_cldr_data_\uff3froot$: 0
}, false, "locales.cldr.data._root$", {
  Llocales_cldr_data_\uff3froot$: 1,
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_data_\uff3froot$.prototype.$classData = $d_Llocales_cldr_data_\uff3froot$;
var $n_Llocales_cldr_data_\uff3froot$;
function $m_Llocales_cldr_data_\uff3froot$() {
  if ((!$n_Llocales_cldr_data_\uff3froot$)) {
    $n_Llocales_cldr_data_\uff3froot$ = new $c_Llocales_cldr_data_\uff3froot$()
  };
  return $n_Llocales_cldr_data_\uff3froot$
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fen$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  var $$x11 = new $c_s_Some($m_Llocales_cldr_fallback_data_\uff3froot$());
  var $$x10 = new $c_Llocales_cldr_LDMLLocale("en", $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $$x9 = $m_s_None$();
  $m_sci_List$();
  var array = [new $c_Llocales_cldr_Symbols($m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem(), $m_s_None$(), new $c_s_Some($bC(46)), new $c_s_Some($bC(44)), new $c_s_Some($bC(59)), new $c_s_Some($bC(37)), new $c_s_Some($bC(45)), new $c_s_Some($bC(8240)), new $c_s_Some("\u221e"), new $c_s_Some("NaN"), new $c_s_Some("E"))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x8 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $m_sci_List$();
  var array$1 = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var $$x7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  $m_sci_List$();
  var array$2 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var $$x6 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  $m_sci_List$();
  var array$3 = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var $$x5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  $m_sci_List$();
  var array$4 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var $$x4 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  $m_sci_List$();
  var array$5 = ["AM", "PM"];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var $$x3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5);
  $m_sci_List$();
  var array$6 = ["BC", "AD"];
  var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var $$x2 = new $c_s_Some(new $c_Llocales_cldr_CalendarSymbols($$x7, $$x6, $$x5, $$x4, $$x3, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$6)));
  var this$32 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$7 = [$ct_T2__O__O__(new $c_T2(), 0, "EEEE, MMMM d, y"), $ct_T2__O__O__(new $c_T2(), 1, "MMMM d, y"), $ct_T2__O__O__(new $c_T2(), 2, "MMM d, y"), $ct_T2__O__O__(new $c_T2(), 3, "M/d/yy")];
  var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var $$x1 = this$32.from__sc_IterableOnce__sci_Map(elems$7);
  var this$36 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$8 = [$ct_T2__O__O__(new $c_T2(), 0, "h:mm:ss a zzzz"), $ct_T2__O__O__(new $c_T2(), 1, "h:mm:ss a z"), $ct_T2__O__O__(new $c_T2(), 2, "h:mm:ss a"), $ct_T2__O__O__(new $c_T2(), 3, "h:mm a")];
  var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $$x11, $$x10, $$x9, $$x8, $$x2, new $c_s_Some(new $c_Llocales_cldr_CalendarPatterns($$x1, this$36.from__sc_IterableOnce__sci_Map(elems$8))), $m_sci_Nil$(), new $c_Llocales_cldr_NumberPatterns(new $c_s_Some("#,##0.###"), new $c_s_Some("#,##0%"), new $c_s_Some("\u00a4#,##0.00;(\u00a4#,##0.00)")))
}
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3fen$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fen$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_data_\uff3fen$.prototype = $c_Llocales_cldr_fallback_data_\uff3fen$.prototype;
var $d_Llocales_cldr_fallback_data_\uff3fen$ = new $TypeData().initClass({
  Llocales_cldr_fallback_data_\uff3fen$: 0
}, false, "locales.cldr.fallback.data._en$", {
  Llocales_cldr_fallback_data_\uff3fen$: 1,
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype.$classData = $d_Llocales_cldr_fallback_data_\uff3fen$;
var $n_Llocales_cldr_fallback_data_\uff3fen$;
function $m_Llocales_cldr_fallback_data_\uff3fen$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fen$)) {
    $n_Llocales_cldr_fallback_data_\uff3fen$ = new $c_Llocales_cldr_fallback_data_\uff3fen$()
  };
  return $n_Llocales_cldr_fallback_data_\uff3fen$
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3froot$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  var $$x11 = $m_s_None$();
  var $$x10 = new $c_Llocales_cldr_LDMLLocale("root", $m_s_None$(), $m_s_None$(), $m_s_None$());
  var $$x9 = new $c_s_Some($m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem());
  $m_sci_List$();
  var array = [new $c_Llocales_cldr_Symbols($m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem(), $m_s_None$(), new $c_s_Some($bC(46)), new $c_s_Some($bC(44)), new $c_s_Some($bC(59)), new $c_s_Some($bC(37)), new $c_s_Some($bC(45)), new $c_s_Some($bC(8240)), new $c_s_Some("\u221e"), new $c_s_Some("NaN"), new $c_s_Some("E"))];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x8 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $m_sci_List$();
  var array$1 = ["M01", "M02", "M03", "M04", "M05", "M06", "M07", "M08", "M09", "M10", "M11", "M12"];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var $$x7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  var $$x6 = $m_sci_Nil$();
  $m_sci_List$();
  var array$2 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var $$x5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  var $$x4 = $m_sci_Nil$();
  var $$x3 = $m_sci_Nil$();
  $m_sci_List$();
  var array$3 = ["BCE", "CE"];
  var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var $$x2 = new $c_s_Some(new $c_Llocales_cldr_CalendarSymbols($$x7, $$x6, $$x5, $$x4, $$x3, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3)));
  var this$20 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$4 = [$ct_T2__O__O__(new $c_T2(), 0, "y MMMM d, EEEE"), $ct_T2__O__O__(new $c_T2(), 1, "y MMMM d"), $ct_T2__O__O__(new $c_T2(), 2, "y MMM d"), $ct_T2__O__O__(new $c_T2(), 3, "y-MM-dd")];
  var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var $$x1 = this$20.from__sc_IterableOnce__sci_Map(elems$4);
  var this$24 = $n($m_s_Predef$().s_Predef$__f_Map);
  var array$5 = [$ct_T2__O__O__(new $c_T2(), 0, "HH:mm:ss zzzz"), $ct_T2__O__O__(new $c_T2(), 1, "HH:mm:ss z"), $ct_T2__O__O__(new $c_T2(), 2, "HH:mm:ss"), $ct_T2__O__O__(new $c_T2(), 3, "HH:mm")];
  var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $$x11, $$x10, $$x9, $$x8, $$x2, new $c_s_Some(new $c_Llocales_cldr_CalendarPatterns($$x1, this$24.from__sc_IterableOnce__sci_Map(elems$5))), $m_sci_Nil$(), new $c_Llocales_cldr_NumberPatterns(new $c_s_Some("#,##0.###"), new $c_s_Some("#,##0%"), new $c_s_Some("\u00a4\u00a0#,##0.00")))
}
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3froot$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3froot$() {
  /*<skip>*/
}
$h_Llocales_cldr_fallback_data_\uff3froot$.prototype = $c_Llocales_cldr_fallback_data_\uff3froot$.prototype;
var $d_Llocales_cldr_fallback_data_\uff3froot$ = new $TypeData().initClass({
  Llocales_cldr_fallback_data_\uff3froot$: 0
}, false, "locales.cldr.fallback.data._root$", {
  Llocales_cldr_fallback_data_\uff3froot$: 1,
  Llocales_cldr_LDML: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype.$classData = $d_Llocales_cldr_fallback_data_\uff3froot$;
var $n_Llocales_cldr_fallback_data_\uff3froot$;
function $m_Llocales_cldr_fallback_data_\uff3froot$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3froot$)) {
    $n_Llocales_cldr_fallback_data_\uff3froot$ = new $c_Llocales_cldr_fallback_data_\uff3froot$()
  };
  return $n_Llocales_cldr_fallback_data_\uff3froot$
}
class $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError extends $c_jl_VirtualMachineError {
  constructor(cause) {
    super();
    var message = ((cause === null) ? null : $n(cause).toString__T());
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
  };
}
var $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError = new $TypeData().initClass({
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 0
}, false, "org.scalajs.linker.runtime.UndefinedBehaviorError", {
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError.prototype.$classData = $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError;
/** @constructor */
function $c_Lreactbuild_Loc$BusinessOpportunities(view) {
  this.Lreactbuild_Loc$BusinessOpportunities__f_view = null;
  this.Lreactbuild_Loc$BusinessOpportunities__f_view = view
}
$c_Lreactbuild_Loc$BusinessOpportunities.prototype = new $h_O();
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.constructor = $c_Lreactbuild_Loc$BusinessOpportunities;
/** @constructor */
function $h_Lreactbuild_Loc$BusinessOpportunities() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$BusinessOpportunities.prototype = $c_Lreactbuild_Loc$BusinessOpportunities.prototype;
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.title__T = (function() {
  return "Opportunit\u00e9s"
});
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.productPrefix__T = (function() {
  return "BusinessOpportunities"
});
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_Loc$BusinessOpportunities__f_view : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_Loc$BusinessOpportunities)) {
    var BusinessOpportunities$1 = $as_Lreactbuild_Loc$BusinessOpportunities(x$1);
    var x = this.Lreactbuild_Loc$BusinessOpportunities__f_view;
    var x$2 = $n(BusinessOpportunities$1).Lreactbuild_Loc$BusinessOpportunities__f_view;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(BusinessOpportunities$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_Loc$BusinessOpportunities(obj) {
  return (((obj instanceof $c_Lreactbuild_Loc$BusinessOpportunities) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc$BusinessOpportunities"))
}
function $isArrayOf_Lreactbuild_Loc$BusinessOpportunities(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc$BusinessOpportunities)))
}
function $asArrayOf_Lreactbuild_Loc$BusinessOpportunities(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc$BusinessOpportunities(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc$BusinessOpportunities;", depth))
}
var $d_Lreactbuild_Loc$BusinessOpportunities = new $TypeData().initClass({
  Lreactbuild_Loc$BusinessOpportunities: 0
}, false, "reactbuild.Loc$BusinessOpportunities", {
  Lreactbuild_Loc$BusinessOpportunities: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$BusinessOpportunities.prototype.$classData = $d_Lreactbuild_Loc$BusinessOpportunities;
/** @constructor */
function $c_Lreactbuild_Loc$Crossed(index) {
  this.Lreactbuild_Loc$Crossed__f_index = null;
  this.Lreactbuild_Loc$Crossed__f_index = index
}
$c_Lreactbuild_Loc$Crossed.prototype = new $h_O();
$c_Lreactbuild_Loc$Crossed.prototype.constructor = $c_Lreactbuild_Loc$Crossed;
/** @constructor */
function $h_Lreactbuild_Loc$Crossed() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Crossed.prototype = $c_Lreactbuild_Loc$Crossed.prototype;
$c_Lreactbuild_Loc$Crossed.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$Crossed.prototype.title__T = (function() {
  return "Tableau crois\u00e9"
});
$c_Lreactbuild_Loc$Crossed.prototype.productPrefix__T = (function() {
  return "Crossed"
});
$c_Lreactbuild_Loc$Crossed.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_Loc$Crossed.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_Loc$Crossed__f_index : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_Loc$Crossed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Crossed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_Loc$Crossed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_Loc$Crossed.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_Loc$Crossed)) {
    var Crossed$1 = $as_Lreactbuild_Loc$Crossed(x$1);
    var x = this.Lreactbuild_Loc$Crossed__f_index;
    var x$2 = $n(Crossed$1).Lreactbuild_Loc$Crossed__f_index;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Crossed$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_Loc$Crossed(obj) {
  return (((obj instanceof $c_Lreactbuild_Loc$Crossed) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc$Crossed"))
}
function $isArrayOf_Lreactbuild_Loc$Crossed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc$Crossed)))
}
function $asArrayOf_Lreactbuild_Loc$Crossed(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc$Crossed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc$Crossed;", depth))
}
var $d_Lreactbuild_Loc$Crossed = new $TypeData().initClass({
  Lreactbuild_Loc$Crossed: 0
}, false, "reactbuild.Loc$Crossed", {
  Lreactbuild_Loc$Crossed: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Crossed.prototype.$classData = $d_Lreactbuild_Loc$Crossed;
/** @constructor */
function $c_Lreactbuild_Loc$Dashboard$() {
  /*<skip>*/
}
$c_Lreactbuild_Loc$Dashboard$.prototype = new $h_O();
$c_Lreactbuild_Loc$Dashboard$.prototype.constructor = $c_Lreactbuild_Loc$Dashboard$;
/** @constructor */
function $h_Lreactbuild_Loc$Dashboard$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Dashboard$.prototype = $c_Lreactbuild_Loc$Dashboard$.prototype;
$c_Lreactbuild_Loc$Dashboard$.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$Dashboard$.prototype.title__T = (function() {
  return "Tableau de bord"
});
$c_Lreactbuild_Loc$Dashboard$.prototype.productPrefix__T = (function() {
  return "Dashboard"
});
$c_Lreactbuild_Loc$Dashboard$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_Loc$Dashboard$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_Loc$Dashboard$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Dashboard$.prototype.hashCode__I = (function() {
  return 956107380
});
$c_Lreactbuild_Loc$Dashboard$.prototype.toString__T = (function() {
  return "Dashboard"
});
var $d_Lreactbuild_Loc$Dashboard$ = new $TypeData().initClass({
  Lreactbuild_Loc$Dashboard$: 0
}, false, "reactbuild.Loc$Dashboard$", {
  Lreactbuild_Loc$Dashboard$: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Dashboard$.prototype.$classData = $d_Lreactbuild_Loc$Dashboard$;
var $n_Lreactbuild_Loc$Dashboard$;
function $m_Lreactbuild_Loc$Dashboard$() {
  if ((!$n_Lreactbuild_Loc$Dashboard$)) {
    $n_Lreactbuild_Loc$Dashboard$ = new $c_Lreactbuild_Loc$Dashboard$()
  };
  return $n_Lreactbuild_Loc$Dashboard$
}
/** @constructor */
function $c_Lreactbuild_Loc$DocumentList$() {
  /*<skip>*/
}
$c_Lreactbuild_Loc$DocumentList$.prototype = new $h_O();
$c_Lreactbuild_Loc$DocumentList$.prototype.constructor = $c_Lreactbuild_Loc$DocumentList$;
/** @constructor */
function $h_Lreactbuild_Loc$DocumentList$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$DocumentList$.prototype = $c_Lreactbuild_Loc$DocumentList$.prototype;
$c_Lreactbuild_Loc$DocumentList$.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$DocumentList$.prototype.title__T = (function() {
  return "Documents"
});
$c_Lreactbuild_Loc$DocumentList$.prototype.productPrefix__T = (function() {
  return "DocumentList"
});
$c_Lreactbuild_Loc$DocumentList$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_Loc$DocumentList$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_Loc$DocumentList$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$DocumentList$.prototype.hashCode__I = (function() {
  return (-1309129607)
});
$c_Lreactbuild_Loc$DocumentList$.prototype.toString__T = (function() {
  return "DocumentList"
});
var $d_Lreactbuild_Loc$DocumentList$ = new $TypeData().initClass({
  Lreactbuild_Loc$DocumentList$: 0
}, false, "reactbuild.Loc$DocumentList$", {
  Lreactbuild_Loc$DocumentList$: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$DocumentList$.prototype.$classData = $d_Lreactbuild_Loc$DocumentList$;
var $n_Lreactbuild_Loc$DocumentList$;
function $m_Lreactbuild_Loc$DocumentList$() {
  if ((!$n_Lreactbuild_Loc$DocumentList$)) {
    $n_Lreactbuild_Loc$DocumentList$ = new $c_Lreactbuild_Loc$DocumentList$()
  };
  return $n_Lreactbuild_Loc$DocumentList$
}
/** @constructor */
function $c_Lreactbuild_Loc$Home$() {
  this.Lreactbuild_Loc$Home$__f_isPubliclyAvailable = false;
  this.Lreactbuild_Loc$Home$__f_isPubliclyAvailable = true
}
$c_Lreactbuild_Loc$Home$.prototype = new $h_O();
$c_Lreactbuild_Loc$Home$.prototype.constructor = $c_Lreactbuild_Loc$Home$;
/** @constructor */
function $h_Lreactbuild_Loc$Home$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Home$.prototype = $c_Lreactbuild_Loc$Home$.prototype;
$c_Lreactbuild_Loc$Home$.prototype.title__T = (function() {
  return "Accueil"
});
$c_Lreactbuild_Loc$Home$.prototype.isPubliclyAvailable__Z = (function() {
  return this.Lreactbuild_Loc$Home$__f_isPubliclyAvailable
});
$c_Lreactbuild_Loc$Home$.prototype.productPrefix__T = (function() {
  return "Home"
});
$c_Lreactbuild_Loc$Home$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_Loc$Home$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_Loc$Home$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Home$.prototype.hashCode__I = (function() {
  return 2255103
});
$c_Lreactbuild_Loc$Home$.prototype.toString__T = (function() {
  return "Home"
});
var $d_Lreactbuild_Loc$Home$ = new $TypeData().initClass({
  Lreactbuild_Loc$Home$: 0
}, false, "reactbuild.Loc$Home$", {
  Lreactbuild_Loc$Home$: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Home$.prototype.$classData = $d_Lreactbuild_Loc$Home$;
var $n_Lreactbuild_Loc$Home$;
function $m_Lreactbuild_Loc$Home$() {
  if ((!$n_Lreactbuild_Loc$Home$)) {
    $n_Lreactbuild_Loc$Home$ = new $c_Lreactbuild_Loc$Home$()
  };
  return $n_Lreactbuild_Loc$Home$
}
/** @constructor */
function $c_Lreactbuild_Loc$Inbox$() {
  /*<skip>*/
}
$c_Lreactbuild_Loc$Inbox$.prototype = new $h_O();
$c_Lreactbuild_Loc$Inbox$.prototype.constructor = $c_Lreactbuild_Loc$Inbox$;
/** @constructor */
function $h_Lreactbuild_Loc$Inbox$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Inbox$.prototype = $c_Lreactbuild_Loc$Inbox$.prototype;
$c_Lreactbuild_Loc$Inbox$.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$Inbox$.prototype.title__T = (function() {
  return "Bo\u00eete de r\u00e9ception"
});
$c_Lreactbuild_Loc$Inbox$.prototype.productPrefix__T = (function() {
  return "Inbox"
});
$c_Lreactbuild_Loc$Inbox$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_Loc$Inbox$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_Loc$Inbox$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Inbox$.prototype.hashCode__I = (function() {
  return 70791782
});
$c_Lreactbuild_Loc$Inbox$.prototype.toString__T = (function() {
  return "Inbox"
});
var $d_Lreactbuild_Loc$Inbox$ = new $TypeData().initClass({
  Lreactbuild_Loc$Inbox$: 0
}, false, "reactbuild.Loc$Inbox$", {
  Lreactbuild_Loc$Inbox$: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Inbox$.prototype.$classData = $d_Lreactbuild_Loc$Inbox$;
var $n_Lreactbuild_Loc$Inbox$;
function $m_Lreactbuild_Loc$Inbox$() {
  if ((!$n_Lreactbuild_Loc$Inbox$)) {
    $n_Lreactbuild_Loc$Inbox$ = new $c_Lreactbuild_Loc$Inbox$()
  };
  return $n_Lreactbuild_Loc$Inbox$
}
/** @constructor */
function $c_Lreactbuild_Loc$Notebook(templateRef, ref) {
  this.Lreactbuild_Loc$Notebook__f_templateRef = null;
  this.Lreactbuild_Loc$Notebook__f_ref = null;
  this.Lreactbuild_Loc$Notebook__f_isPubliclyAvailable = false;
  this.Lreactbuild_Loc$Notebook__f_templateRef = templateRef;
  this.Lreactbuild_Loc$Notebook__f_ref = ref;
  this.Lreactbuild_Loc$Notebook__f_isPubliclyAvailable = true
}
$c_Lreactbuild_Loc$Notebook.prototype = new $h_O();
$c_Lreactbuild_Loc$Notebook.prototype.constructor = $c_Lreactbuild_Loc$Notebook;
/** @constructor */
function $h_Lreactbuild_Loc$Notebook() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Notebook.prototype = $c_Lreactbuild_Loc$Notebook.prototype;
$c_Lreactbuild_Loc$Notebook.prototype.title__T = (function() {
  return "Notebook"
});
$c_Lreactbuild_Loc$Notebook.prototype.isPubliclyAvailable__Z = (function() {
  return this.Lreactbuild_Loc$Notebook__f_isPubliclyAvailable
});
$c_Lreactbuild_Loc$Notebook.prototype.productPrefix__T = (function() {
  return "Notebook"
});
$c_Lreactbuild_Loc$Notebook.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_Loc$Notebook.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_Loc$Notebook__f_templateRef;
      break
    }
    case 1: {
      return this.Lreactbuild_Loc$Notebook__f_ref;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_Loc$Notebook.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Notebook.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_Loc$Notebook.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_Loc$Notebook.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_Loc$Notebook)) {
    var Notebook$1 = $as_Lreactbuild_Loc$Notebook(x$1);
    var x = this.Lreactbuild_Loc$Notebook__f_templateRef;
    var x$2 = $n(Notebook$1).Lreactbuild_Loc$Notebook__f_templateRef;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_Loc$Notebook__f_ref;
      var x$4 = $n(Notebook$1).Lreactbuild_Loc$Notebook__f_ref;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Notebook$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_Loc$Notebook(obj) {
  return (((obj instanceof $c_Lreactbuild_Loc$Notebook) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc$Notebook"))
}
function $isArrayOf_Lreactbuild_Loc$Notebook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc$Notebook)))
}
function $asArrayOf_Lreactbuild_Loc$Notebook(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc$Notebook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc$Notebook;", depth))
}
var $d_Lreactbuild_Loc$Notebook = new $TypeData().initClass({
  Lreactbuild_Loc$Notebook: 0
}, false, "reactbuild.Loc$Notebook", {
  Lreactbuild_Loc$Notebook: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Notebook.prototype.$classData = $d_Lreactbuild_Loc$Notebook;
/** @constructor */
function $c_Lreactbuild_Loc$Person(ref) {
  this.Lreactbuild_Loc$Person__f_ref = null;
  this.Lreactbuild_Loc$Person__f_ref = ref
}
$c_Lreactbuild_Loc$Person.prototype = new $h_O();
$c_Lreactbuild_Loc$Person.prototype.constructor = $c_Lreactbuild_Loc$Person;
/** @constructor */
function $h_Lreactbuild_Loc$Person() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Person.prototype = $c_Lreactbuild_Loc$Person.prototype;
$c_Lreactbuild_Loc$Person.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$Person.prototype.title__T = (function() {
  return "Personnes"
});
$c_Lreactbuild_Loc$Person.prototype.productPrefix__T = (function() {
  return "Person"
});
$c_Lreactbuild_Loc$Person.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_Loc$Person.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_Loc$Person__f_ref : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_Loc$Person.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Person.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_Loc$Person.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_Loc$Person.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_Loc$Person)) {
    var Person$1 = $as_Lreactbuild_Loc$Person(x$1);
    var x = this.Lreactbuild_Loc$Person__f_ref;
    var x$2 = $n(Person$1).Lreactbuild_Loc$Person__f_ref;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Person$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_Loc$Person(obj) {
  return (((obj instanceof $c_Lreactbuild_Loc$Person) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc$Person"))
}
function $isArrayOf_Lreactbuild_Loc$Person(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc$Person)))
}
function $asArrayOf_Lreactbuild_Loc$Person(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc$Person(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc$Person;", depth))
}
var $d_Lreactbuild_Loc$Person = new $TypeData().initClass({
  Lreactbuild_Loc$Person: 0
}, false, "reactbuild.Loc$Person", {
  Lreactbuild_Loc$Person: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Person.prototype.$classData = $d_Lreactbuild_Loc$Person;
/** @constructor */
function $c_Lreactbuild_Loc$Processing(ref) {
  this.Lreactbuild_Loc$Processing__f_ref = null;
  this.Lreactbuild_Loc$Processing__f_ref = ref
}
$c_Lreactbuild_Loc$Processing.prototype = new $h_O();
$c_Lreactbuild_Loc$Processing.prototype.constructor = $c_Lreactbuild_Loc$Processing;
/** @constructor */
function $h_Lreactbuild_Loc$Processing() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Processing.prototype = $c_Lreactbuild_Loc$Processing.prototype;
$c_Lreactbuild_Loc$Processing.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$Processing.prototype.title__T = (function() {
  return "A faire"
});
$c_Lreactbuild_Loc$Processing.prototype.productPrefix__T = (function() {
  return "Processing"
});
$c_Lreactbuild_Loc$Processing.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_Loc$Processing.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_Loc$Processing__f_ref : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_Loc$Processing.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Processing.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_Loc$Processing.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_Loc$Processing.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_Loc$Processing)) {
    var Processing$1 = $as_Lreactbuild_Loc$Processing(x$1);
    var x = this.Lreactbuild_Loc$Processing__f_ref;
    var x$2 = $n(Processing$1).Lreactbuild_Loc$Processing__f_ref;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Processing$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_Loc$Processing(obj) {
  return (((obj instanceof $c_Lreactbuild_Loc$Processing) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc$Processing"))
}
function $isArrayOf_Lreactbuild_Loc$Processing(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc$Processing)))
}
function $asArrayOf_Lreactbuild_Loc$Processing(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc$Processing(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc$Processing;", depth))
}
var $d_Lreactbuild_Loc$Processing = new $TypeData().initClass({
  Lreactbuild_Loc$Processing: 0
}, false, "reactbuild.Loc$Processing", {
  Lreactbuild_Loc$Processing: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Processing.prototype.$classData = $d_Lreactbuild_Loc$Processing;
/** @constructor */
function $c_Lreactbuild_Loc$Project(page) {
  this.Lreactbuild_Loc$Project__f_page = null;
  this.Lreactbuild_Loc$Project__f_page = page
}
$c_Lreactbuild_Loc$Project.prototype = new $h_O();
$c_Lreactbuild_Loc$Project.prototype.constructor = $c_Lreactbuild_Loc$Project;
/** @constructor */
function $h_Lreactbuild_Loc$Project() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Project.prototype = $c_Lreactbuild_Loc$Project.prototype;
$c_Lreactbuild_Loc$Project.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$Project.prototype.title__T = (function() {
  return "Projets"
});
$c_Lreactbuild_Loc$Project.prototype.productPrefix__T = (function() {
  return "Project"
});
$c_Lreactbuild_Loc$Project.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_Loc$Project.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_Loc$Project__f_page : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_Loc$Project.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Project.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_Loc$Project.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_Loc$Project.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_Loc$Project)) {
    var Project$1 = $as_Lreactbuild_Loc$Project(x$1);
    var x = this.Lreactbuild_Loc$Project__f_page;
    var x$2 = $n(Project$1).Lreactbuild_Loc$Project__f_page;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Project$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_Loc$Project(obj) {
  return (((obj instanceof $c_Lreactbuild_Loc$Project) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc$Project"))
}
function $isArrayOf_Lreactbuild_Loc$Project(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc$Project)))
}
function $asArrayOf_Lreactbuild_Loc$Project(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc$Project(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc$Project;", depth))
}
var $d_Lreactbuild_Loc$Project = new $TypeData().initClass({
  Lreactbuild_Loc$Project: 0
}, false, "reactbuild.Loc$Project", {
  Lreactbuild_Loc$Project: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Project.prototype.$classData = $d_Lreactbuild_Loc$Project;
/** @constructor */
function $c_Lreactbuild_Loc$Reconcile$() {
  /*<skip>*/
}
$c_Lreactbuild_Loc$Reconcile$.prototype = new $h_O();
$c_Lreactbuild_Loc$Reconcile$.prototype.constructor = $c_Lreactbuild_Loc$Reconcile$;
/** @constructor */
function $h_Lreactbuild_Loc$Reconcile$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Reconcile$.prototype = $c_Lreactbuild_Loc$Reconcile$.prototype;
$c_Lreactbuild_Loc$Reconcile$.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$Reconcile$.prototype.title__T = (function() {
  return "Rapprochements"
});
$c_Lreactbuild_Loc$Reconcile$.prototype.productPrefix__T = (function() {
  return "Reconcile"
});
$c_Lreactbuild_Loc$Reconcile$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_Loc$Reconcile$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_Loc$Reconcile$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Reconcile$.prototype.hashCode__I = (function() {
  return (-1301165266)
});
$c_Lreactbuild_Loc$Reconcile$.prototype.toString__T = (function() {
  return "Reconcile"
});
var $d_Lreactbuild_Loc$Reconcile$ = new $TypeData().initClass({
  Lreactbuild_Loc$Reconcile$: 0
}, false, "reactbuild.Loc$Reconcile$", {
  Lreactbuild_Loc$Reconcile$: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Reconcile$.prototype.$classData = $d_Lreactbuild_Loc$Reconcile$;
var $n_Lreactbuild_Loc$Reconcile$;
function $m_Lreactbuild_Loc$Reconcile$() {
  if ((!$n_Lreactbuild_Loc$Reconcile$)) {
    $n_Lreactbuild_Loc$Reconcile$ = new $c_Lreactbuild_Loc$Reconcile$()
  };
  return $n_Lreactbuild_Loc$Reconcile$
}
/** @constructor */
function $c_Lreactbuild_Loc$Render$() {
  /*<skip>*/
}
$c_Lreactbuild_Loc$Render$.prototype = new $h_O();
$c_Lreactbuild_Loc$Render$.prototype.constructor = $c_Lreactbuild_Loc$Render$;
/** @constructor */
function $h_Lreactbuild_Loc$Render$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Render$.prototype = $c_Lreactbuild_Loc$Render$.prototype;
$c_Lreactbuild_Loc$Render$.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$Render$.prototype.title__T = (function() {
  return "Fabrique"
});
$c_Lreactbuild_Loc$Render$.prototype.productPrefix__T = (function() {
  return "Render"
});
$c_Lreactbuild_Loc$Render$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_Loc$Render$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_Loc$Render$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Render$.prototype.hashCode__I = (function() {
  return (-1850724938)
});
$c_Lreactbuild_Loc$Render$.prototype.toString__T = (function() {
  return "Render"
});
var $d_Lreactbuild_Loc$Render$ = new $TypeData().initClass({
  Lreactbuild_Loc$Render$: 0
}, false, "reactbuild.Loc$Render$", {
  Lreactbuild_Loc$Render$: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Render$.prototype.$classData = $d_Lreactbuild_Loc$Render$;
var $n_Lreactbuild_Loc$Render$;
function $m_Lreactbuild_Loc$Render$() {
  if ((!$n_Lreactbuild_Loc$Render$)) {
    $n_Lreactbuild_Loc$Render$ = new $c_Lreactbuild_Loc$Render$()
  };
  return $n_Lreactbuild_Loc$Render$
}
/** @constructor */
function $c_Lreactbuild_Loc$Resource(ref) {
  this.Lreactbuild_Loc$Resource__f_ref = null;
  this.Lreactbuild_Loc$Resource__f_ref = ref
}
$c_Lreactbuild_Loc$Resource.prototype = new $h_O();
$c_Lreactbuild_Loc$Resource.prototype.constructor = $c_Lreactbuild_Loc$Resource;
/** @constructor */
function $h_Lreactbuild_Loc$Resource() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$Resource.prototype = $c_Lreactbuild_Loc$Resource.prototype;
$c_Lreactbuild_Loc$Resource.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$Resource.prototype.title__T = (function() {
  return "Ressources"
});
$c_Lreactbuild_Loc$Resource.prototype.productPrefix__T = (function() {
  return "Resource"
});
$c_Lreactbuild_Loc$Resource.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_Loc$Resource.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_Loc$Resource__f_ref : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_Loc$Resource.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$Resource.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_Loc$Resource.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_Loc$Resource.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_Loc$Resource)) {
    var Resource$1 = $as_Lreactbuild_Loc$Resource(x$1);
    var x = this.Lreactbuild_Loc$Resource__f_ref;
    var x$2 = $n(Resource$1).Lreactbuild_Loc$Resource__f_ref;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Resource$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_Loc$Resource(obj) {
  return (((obj instanceof $c_Lreactbuild_Loc$Resource) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc$Resource"))
}
function $isArrayOf_Lreactbuild_Loc$Resource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc$Resource)))
}
function $asArrayOf_Lreactbuild_Loc$Resource(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc$Resource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc$Resource;", depth))
}
var $d_Lreactbuild_Loc$Resource = new $TypeData().initClass({
  Lreactbuild_Loc$Resource: 0
}, false, "reactbuild.Loc$Resource", {
  Lreactbuild_Loc$Resource: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$Resource.prototype.$classData = $d_Lreactbuild_Loc$Resource;
/** @constructor */
function $c_Lreactbuild_Loc$SendReceipt(ref) {
  this.Lreactbuild_Loc$SendReceipt__f_ref = null;
  this.Lreactbuild_Loc$SendReceipt__f_ref = ref
}
$c_Lreactbuild_Loc$SendReceipt.prototype = new $h_O();
$c_Lreactbuild_Loc$SendReceipt.prototype.constructor = $c_Lreactbuild_Loc$SendReceipt;
/** @constructor */
function $h_Lreactbuild_Loc$SendReceipt() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$SendReceipt.prototype = $c_Lreactbuild_Loc$SendReceipt.prototype;
$c_Lreactbuild_Loc$SendReceipt.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$SendReceipt.prototype.title__T = (function() {
  return "Re\u00e7u"
});
$c_Lreactbuild_Loc$SendReceipt.prototype.productPrefix__T = (function() {
  return "SendReceipt"
});
$c_Lreactbuild_Loc$SendReceipt.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_Loc$SendReceipt.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_Loc$SendReceipt__f_ref : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_Loc$SendReceipt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$SendReceipt.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_Loc$SendReceipt.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_Loc$SendReceipt.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_Loc$SendReceipt)) {
    var SendReceipt$1 = $as_Lreactbuild_Loc$SendReceipt(x$1);
    var x = this.Lreactbuild_Loc$SendReceipt__f_ref;
    var x$2 = $n(SendReceipt$1).Lreactbuild_Loc$SendReceipt__f_ref;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(SendReceipt$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_Loc$SendReceipt(obj) {
  return (((obj instanceof $c_Lreactbuild_Loc$SendReceipt) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc$SendReceipt"))
}
function $isArrayOf_Lreactbuild_Loc$SendReceipt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc$SendReceipt)))
}
function $asArrayOf_Lreactbuild_Loc$SendReceipt(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc$SendReceipt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc$SendReceipt;", depth))
}
var $d_Lreactbuild_Loc$SendReceipt = new $TypeData().initClass({
  Lreactbuild_Loc$SendReceipt: 0
}, false, "reactbuild.Loc$SendReceipt", {
  Lreactbuild_Loc$SendReceipt: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$SendReceipt.prototype.$classData = $d_Lreactbuild_Loc$SendReceipt;
/** @constructor */
function $c_Lreactbuild_Loc$TaskScheduler$() {
  /*<skip>*/
}
$c_Lreactbuild_Loc$TaskScheduler$.prototype = new $h_O();
$c_Lreactbuild_Loc$TaskScheduler$.prototype.constructor = $c_Lreactbuild_Loc$TaskScheduler$;
/** @constructor */
function $h_Lreactbuild_Loc$TaskScheduler$() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$TaskScheduler$.prototype = $c_Lreactbuild_Loc$TaskScheduler$.prototype;
$c_Lreactbuild_Loc$TaskScheduler$.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$TaskScheduler$.prototype.title__T = (function() {
  return "Planif"
});
$c_Lreactbuild_Loc$TaskScheduler$.prototype.productPrefix__T = (function() {
  return "TaskScheduler"
});
$c_Lreactbuild_Loc$TaskScheduler$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_Loc$TaskScheduler$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_Loc$TaskScheduler$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$TaskScheduler$.prototype.hashCode__I = (function() {
  return (-1734721386)
});
$c_Lreactbuild_Loc$TaskScheduler$.prototype.toString__T = (function() {
  return "TaskScheduler"
});
var $d_Lreactbuild_Loc$TaskScheduler$ = new $TypeData().initClass({
  Lreactbuild_Loc$TaskScheduler$: 0
}, false, "reactbuild.Loc$TaskScheduler$", {
  Lreactbuild_Loc$TaskScheduler$: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$TaskScheduler$.prototype.$classData = $d_Lreactbuild_Loc$TaskScheduler$;
var $n_Lreactbuild_Loc$TaskScheduler$;
function $m_Lreactbuild_Loc$TaskScheduler$() {
  if ((!$n_Lreactbuild_Loc$TaskScheduler$)) {
    $n_Lreactbuild_Loc$TaskScheduler$ = new $c_Lreactbuild_Loc$TaskScheduler$()
  };
  return $n_Lreactbuild_Loc$TaskScheduler$
}
/** @constructor */
function $c_Lreactbuild_Loc$TimeReport(date) {
  this.Lreactbuild_Loc$TimeReport__f_date = null;
  this.Lreactbuild_Loc$TimeReport__f_date = date
}
$c_Lreactbuild_Loc$TimeReport.prototype = new $h_O();
$c_Lreactbuild_Loc$TimeReport.prototype.constructor = $c_Lreactbuild_Loc$TimeReport;
/** @constructor */
function $h_Lreactbuild_Loc$TimeReport() {
  /*<skip>*/
}
$h_Lreactbuild_Loc$TimeReport.prototype = $c_Lreactbuild_Loc$TimeReport.prototype;
$c_Lreactbuild_Loc$TimeReport.prototype.isPubliclyAvailable__Z = (function() {
  return false
});
$c_Lreactbuild_Loc$TimeReport.prototype.title__T = (function() {
  return "Relev\u00e9 d'heures"
});
$c_Lreactbuild_Loc$TimeReport.prototype.productPrefix__T = (function() {
  return "TimeReport"
});
$c_Lreactbuild_Loc$TimeReport.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_Loc$TimeReport.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_Loc$TimeReport__f_date : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_Loc$TimeReport.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_Loc$TimeReport.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_Loc$TimeReport.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_Loc$TimeReport.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_Loc$TimeReport)) {
    var TimeReport$1 = $as_Lreactbuild_Loc$TimeReport(x$1);
    var x = this.Lreactbuild_Loc$TimeReport__f_date;
    var x$2 = $n(TimeReport$1).Lreactbuild_Loc$TimeReport__f_date;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(TimeReport$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_Loc$TimeReport(obj) {
  return (((obj instanceof $c_Lreactbuild_Loc$TimeReport) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.Loc$TimeReport"))
}
function $isArrayOf_Lreactbuild_Loc$TimeReport(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_Loc$TimeReport)))
}
function $asArrayOf_Lreactbuild_Loc$TimeReport(obj, depth) {
  return (($isArrayOf_Lreactbuild_Loc$TimeReport(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.Loc$TimeReport;", depth))
}
var $d_Lreactbuild_Loc$TimeReport = new $TypeData().initClass({
  Lreactbuild_Loc$TimeReport: 0
}, false, "reactbuild.Loc$TimeReport", {
  Lreactbuild_Loc$TimeReport: 1,
  O: 1,
  Lreactbuild_Loc: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_Loc$TimeReport.prototype.$classData = $d_Lreactbuild_Loc$TimeReport;
function $p_Lreactbuild_Style$__withLight$1__I__Lscalacss_internal_StyleS($thiz, l) {
  $n($thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x11 = $thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x10 = $thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x9 = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8 = $as_T(x$8$2);
    return (x$8 + ">TR:nth-child(3n+0)")
  }));
  $n($thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x = $thiz.strippedCells__I__I__Lscalacss_internal_StyleS(262, l);
  var array = [new $c_Lscalacss_internal_DslBase$ToStyle(x)];
  var $$x8 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x11).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x10).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x9, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x7 = $thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x6 = $thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x5 = new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9 = $as_T(x$9$2);
    return (x$9 + ">TR:nth-child(3n+1)")
  }));
  $n($thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$1 = $thiz.strippedCells__I__I__Lscalacss_internal_StyleS(199, l);
  var array$1 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$1)];
  var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x7).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x6).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x3 = $thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x2 = $thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x1 = new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_T(x$10$2);
    return (x$10 + ">TR:nth-child(3n+2)")
  }));
  $n($thiz.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$2 = $thiz.strippedCells__I__I__Lscalacss_internal_StyleS(4, l);
  var array$2 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$2)];
  var array$3 = [$$x8, $$x4, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x3).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x2).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  $m_Lreactbuild_package$CssSettings$();
  var c = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c)
}
/** @constructor */
function $c_Lreactbuild_Style$() {
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module = null;
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister = null;
  this.Lreactbuild_Style$__f_theme = null;
  this.Lreactbuild_Style$__f_withBackground = null;
  this.Lreactbuild_Style$__f_md = null;
  this.Lreactbuild_Style$__f_reactComponents = null;
  this.Lreactbuild_Style$__f_notPrintable = null;
  this.Lreactbuild_Style$__f_flexRow = null;
  this.Lreactbuild_Style$__f_flexColumn = null;
  this.Lreactbuild_Style$__f_full = null;
  this.Lreactbuild_Style$__f_withRoundedCorner = null;
  this.Lreactbuild_Style$__f_withLittlePadding = null;
  this.Lreactbuild_Style$__f_dontOverflow = null;
  this.Lreactbuild_Style$__f_rootContainer = null;
  this.Lreactbuild_Style$__f_autoScrollContainer = null;
  this.Lreactbuild_Style$__f_toolbar = null;
  this.Lreactbuild_Style$__f_toolbarMain = null;
  this.Lreactbuild_Style$__f_tabs = null;
  this.Lreactbuild_Style$__f_tab = null;
  this.Lreactbuild_Style$__f_tabSelected = null;
  this.Lreactbuild_Style$__f_fixedHeadersTable = null;
  this.Lreactbuild_Style$__f_crossedTable = null;
  this.Lreactbuild_Style$__f_reportTable = null;
  this.Lreactbuild_Style$__f_processingSameReferenceInvoicePage = null;
  this.Lreactbuild_Style$__f_processingActualInvoicePage = null;
  this.Lreactbuild_Style$__f_darkColors = null;
  this.Lreactbuild_Style$__f_colors = null;
  this.Lreactbuild_Style$__f_crossedTableActiveCell = null;
  this.Lreactbuild_Style$__f_strippedRows = null;
  this.Lreactbuild_Style$__f_strippedLinesTable = null;
  this.Lreactbuild_Style$__f_maybeRelated = null;
  this.Lreactbuild_Style$__f_crossDetails = null;
  this.Lreactbuild_Style$__f_textCenter = null;
  this.Lreactbuild_Style$__f_textRight = null;
  this.Lreactbuild_Style$__f_pdfViewerContainer = null;
  this.Lreactbuild_Style$__f_pdfViewerAsImageContainer = null;
  this.Lreactbuild_Style$__f_pdfViewerAsImageTools = null;
  this.Lreactbuild_Style$__f_fullArea = null;
  this.Lreactbuild_Style$__f_autoScrollAreaContainerWrapper = null;
  this.Lreactbuild_Style$__f_autoScrollAreaContainer = null;
  this.Lreactbuild_Style$__f_scrollBlockContainer = null;
  this.Lreactbuild_Style$__f_ribbonWrapper = null;
  this.Lreactbuild_Style$__f_ribbon = null;
  this.Lreactbuild_Style$__f_documentPaperPageContent = null;
  this.Lreactbuild_Style$__f_paperMainTitleMixin = null;
  this.Lreactbuild_Style$__f_paperMainTitle1 = null;
  this.Lreactbuild_Style$__f_paperMainTitle2 = null;
  this.Lreactbuild_Style$__f_paperMainTitle3 = null;
  this.Lreactbuild_Style$__f_paperTitle = null;
  this.Lreactbuild_Style$__f_paperDescription = null;
  this.Lreactbuild_Style$__f_documentPaperPage = null;
  this.Lreactbuild_Style$__f_paperFullPart = null;
  this.Lreactbuild_Style$__f_paperEmptyRow = null;
  this.Lreactbuild_Style$__f_paperEmptyCol = null;
  this.Lreactbuild_Style$__f_paperRow = null;
  this.Lreactbuild_Style$__f_paperCol = null;
  this.Lreactbuild_Style$__f_paperImageContainer = null;
  this.Lreactbuild_Style$__f_areaLargerBorder = null;
  this.Lreactbuild_Style$__f_defaultTableBorder = null;
  this.Lreactbuild_Style$__f_tableElements = null;
  this.Lreactbuild_Style$__f_fullBorderTable = null;
  this.Lreactbuild_Style$__f_areaMixin = null;
  this.Lreactbuild_Style$__f_areaTable = null;
  this.Lreactbuild_Style$__f_areaLabel = null;
  this.Lreactbuild_Style$__f_areaValue = null;
  this.Lreactbuild_Style$__f_skipPaperPage = null;
  this.Lreactbuild_Style$__f_drawingControlsMixin = null;
  this.Lreactbuild_Style$__f_drawingArea = null;
  this.Lreactbuild_Style$__f_drawingAreaHidden = null;
  this.Lreactbuild_Style$__f_drawingAreaGap = null;
  this.Lreactbuild_Style$__f_drawingAreaAxis = null;
  this.Lreactbuild_Style$__f_drawingAreaPosition = null;
  this.Lreactbuild_Style$__f_drawingAreaAlignment = null;
  this.Lreactbuild_Style$__f_touch = null;
  this.Lreactbuild_Style$__f_drawingButton = null;
  this.Lreactbuild_Style$__f_drawingButtonActive = null;
  this.Lreactbuild_Style$__f_drawingView = null;
  this.Lreactbuild_Style$__f_drawingViewFullScreen = null;
  this.Lreactbuild_Style$__f_drawingViewport = null;
  this.Lreactbuild_Style$__f_drawingToolbar = null;
  this.Lreactbuild_Style$__f_cursorBreath = null;
  this.Lreactbuild_Style$__f_drawingRemoteCursor = null;
  this.Lreactbuild_Style$__f_containerWrapper = null;
  this.Lreactbuild_Style$__f_container = null;
  this.Lreactbuild_Style$__f_plannerContainerWrapper = null;
  this.Lreactbuild_Style$__f_plannerContainer = null;
  this.Lreactbuild_Style$__f_plannerFixPositions = null;
  this.Lreactbuild_Style$__f_plannerContentWrapper = null;
  this.Lreactbuild_Style$__f_plannerContent = null;
  this.Lreactbuild_Style$__f_plannerTimeRulerMixin = null;
  this.Lreactbuild_Style$__f_plannerTimeRulerLine = null;
  this.Lreactbuild_Style$__f_plannerTimeRulerNow = null;
  this.Lreactbuild_Style$__f_plannerTimeRulerText = null;
  this.Lreactbuild_Style$__f_plannerHorizontalLine = null;
  this.Lreactbuild_Style$__f_plannerLineTopHeader = null;
  this.Lreactbuild_Style$__f_plannerLineSideHeader = null;
  this.Lreactbuild_Style$__f_plannerEventLines = null;
  this.Lreactbuild_Style$__f_plannerEventLine = null;
  this.Lreactbuild_Style$__f_plannerEvent = null;
  this.Lreactbuild_Style$__f_plannerEventSelected = null;
  this.Lreactbuild_Style$__f_plannerEventProgress = null;
  this.Lreactbuild_Style$__f_entryListHeader = null;
  this.Lreactbuild_Style$__f_entryStageLevel = null;
  this.Lreactbuild_Style$__f_entryListEntryTitle = null;
  this.Lreactbuild_Style$__f_entryListEntry = null;
  this.Lreactbuild_Style$__f_strike = null;
  this.Lreactbuild_Style$__f_progressIdle = null;
  this.Lreactbuild_Style$__f_progressPending = null;
  this.Lreactbuild_Style$__f_progressCompleted = null;
  this.Lreactbuild_Style$__f_progressFailed = null;
  this.Lreactbuild_Style$__f_expandableSelectorMixin = null;
  this.Lreactbuild_Style$__f_expandableSelectorStart = null;
  this.Lreactbuild_Style$__f_expandableSelectorEnd = null;
  this.Lreactbuild_Style$__f_mapContainer = null;
  this.Lreactbuild_Style$__f_mapWrapper = null;
  this.Lreactbuild_Style$__f_mapViewControlOverlay = null;
  this.Lreactbuild_Style$__f_responsiveColumnLayout = null;
  this.Lreactbuild_Style$__f_searchBoxContainer = null;
  this.Lreactbuild_Style$__f_responsiveColumnLayoutBody = null;
  this.Lreactbuild_Style$__f_homeLayout = null;
  this.Lreactbuild_Style$__f_homeLayoutBody = null;
  this.Lreactbuild_Style$__f_homeProjectList = null;
  this.Lreactbuild_Style$__f_homeProjectListItem = null;
  this.Lreactbuild_Style$__f_homeProjectListItemImage = null;
  this.Lreactbuild_Style$__f_homeProjectListItemImageAbsent = null;
  this.Lreactbuild_Style$__f_homeProjectListItemTitle = null;
  this.Lreactbuild_Style$__f_homeOtherActionListItemLink = null;
  this.Lreactbuild_Style$__f_projectImageListInsertionPoint = null;
  this.Lreactbuild_Style$__f_projectImageListInsertionPointDragging = null;
  this.Lreactbuild_Style$__f_projectImageListInsertionPointDragOver = null;
  this.Lreactbuild_Style$__f_projectImageListSpace = null;
  this.Lreactbuild_Style$__f_projectImageListEntry = null;
  this.Lreactbuild_Style$__f_projectImageListEntryDragged = null;
  this.Lreactbuild_Style$__f_featureStateNotYetImplemented = null;
  this.Lreactbuild_Style$__f_featureStateWorkInProgress = null;
  this.Lreactbuild_Style$__f_featureStateTitle = null;
  this.Lreactbuild_Style$__f_featureStateDescription = null;
  this.Lreactbuild_Style$__f_featureStateContainer = null;
  this.Lreactbuild_Style$__f_featureStateContainerParentFullSpace = null;
  this.Lreactbuild_Style$__f_featureStateContainerFullSpace = null;
  this.Lreactbuild_Style$__f_featureStateWrapper = null;
  this.Lreactbuild_Style$__f_featureStateWrapperFullSpace = null;
  var this$1 = $m_Lreactbuild_package$CssSettings$();
  $ct_Lscalacss_internal_mutable_StyleSheet$Inline__Lscalacss_internal_mutable_Register__(this, new $c_Lscalacss_internal_mutable_Register(this$1.Lreactbuild_package$CssSettings$__f_cssRegisterNameGen, $m_Lscalacss_internal_mutable_Register$MacroName$Use$(), this$1.Lreactbuild_package$CssSettings$__f_cssRegisterErrorHandler, $m_Lscalacss_internal_mutable_Mutex$().Lscalacss_internal_mutable_Mutex$__f_mutex));
  $n_Lreactbuild_Style$ = this;
  this.Lreactbuild_Style$__f_theme = new $c_Lcom_iz2use_react_style_Theme($m_Lcom_iz2use_react_style_ThemeColorWithInverse$().apply__I__I__I__I__I__I__Lcom_iz2use_react_style_ThemeColor(0, 0, 95, 0, 0, 0), $m_Lcom_iz2use_react_style_ThemeColorWithInverse$().apply__I__I__I__I__I__I__Lcom_iz2use_react_style_ThemeColor(0, 0, 0, 60, 100, 95), $m_Lcom_iz2use_react_style_ThemeColorWithInverse$().apply__I__I__I__I__I__I__Lcom_iz2use_react_style_ThemeColor(45, 100, 75, 45, 100, 25), $m_Lcom_iz2use_react_style_ThemeColorWithInverse$().apply__I__I__I__I__I__I__Lcom_iz2use_react_style_ThemeColor(225, 100, 75, 225, 50, 25), $m_Lcom_iz2use_react_style_ThemeColorWithInverse$().apply__I__I__I__I__I__I__Lcom_iz2use_react_style_ThemeColor(0, 0, 88, 0, 0, 12));
  var $$x9 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "withBackground");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x8 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$8 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x7 = $n($n($$x8).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$8.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_Lscalacss_internal_Media$Query(x$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x)
  }))));
  var $$x6 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$11 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x6).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$11.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "white")))];
  var x$1 = $n($$x7).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x5 = new $c_Lscalacss_internal_DslBase$ToStyle(x$1);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v = $m_Lscalacss_internal_Attrs$color$();
  var qual$1 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v);
  var x$1$1 = $n(this.Lreactbuild_Style$__f_theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var x$2$2 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var $$x1 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$1, x$1$1, x$2$2);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$1 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var qual$2 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$1);
  var x$3 = $n(this.Lreactbuild_Style$__f_theme).Lcom_iz2use_react_style_Theme__f_background;
  var x$4 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$1 = [$$x1, new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$2, x$3, x$4)];
  var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  $m_Lreactbuild_package$CssSettings$();
  var c = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$3).light__Lscalacss_internal_AV()))
  }));
  var t$1 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t, f));
  var x$5 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$1, c);
  var $$x4 = new $c_Lscalacss_internal_DslBase$ToStyle(x$5);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x3 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$27 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$28 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$27.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x2 = $n($n($$x3).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$28), new $c_sjsr_AnonFunction1(((x$2$1) => {
    var x$6 = $as_Lscalacss_internal_Media$Query(x$2$1);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$6)
  }))));
  var f$1 = new $c_sjsr_AnonFunction1(((x$2$2$2) => {
    var x$2$2$1 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$1).dark__Lscalacss_internal_AV()))
  }));
  var x$7 = $n($$x2).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t, f$1)), c);
  var array$2 = [$$x4, new $c_Lscalacss_internal_DslBase$ToStyle(x$7)];
  var t$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var x$8 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$2, c);
  var array$3 = [$$x5, new $c_Lscalacss_internal_DslBase$ToStyle(x$8)];
  this.Lreactbuild_Style$__f_withBackground = $n($$x9).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  this.Lreactbuild_Style$__f_md = new $c_Lcom_iz2use_react_style_MaterialDesign(this.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister, ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  this.Lreactbuild_Style$__f_reactComponents = new $c_Lcom_iz2use_react_style_Style(this.Lreactbuild_Style$__f_md, this.Lreactbuild_Style$__f_withBackground, this.Lreactbuild_Style$__f_theme, this.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister, ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x10 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "notPrintable");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$9 = $n(this.Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_notPrintable;
  var array$4 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$9).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_notPrintable = $n($$x10).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x11 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "printableOnly");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$10 = $n(this.Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_printableOnly;
  var array$5 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$10).Lscalacss_internal_StyleA__f_style)];
  $n($$x11).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x15 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "flexRow");
  var $$x14 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$52 = $m_Lscalacss_internal_Attrs$display$();
  var $$x13 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x14).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$52.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x12 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$54 = $m_Lscalacss_internal_Attrs$flexDirection$();
  var array$6 = [$$x13, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x12).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$54.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")))];
  this.Lreactbuild_Style$__f_flexRow = $n($$x15).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x19 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "flexColumn");
  var $$x18 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$60 = $m_Lscalacss_internal_Attrs$display$();
  var $$x17 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x18).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$60.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x16 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$62 = $m_Lscalacss_internal_Attrs$flexDirection$();
  var array$7 = [$$x17, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x16).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$62.Lscalacss_internal_Attrs$flexDirection$__f_attr, "column")))];
  this.Lreactbuild_Style$__f_flexColumn = $n($$x19).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x21 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "full");
  var $$x20 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$8 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x20).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a, "1")))];
  this.Lreactbuild_Style$__f_full = $n($$x21).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x22 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "withRoundedCorner");
  var this$84 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$ = 4;
  var u = $m_Lscalacss_internal_LengthUnit$px$();
  var f$3 = new $c_Lscalacss_internal_Length(this$, u);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3$1 = $as_Lscalacss_internal_Length(x$3$2);
    return $n(x$3$1).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
    var x$1$4 = $as_Lscalacss_internal_ValueT(x$1$2$1);
    return $n(x$1$4)
  }));
  var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$2);
  var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
  var radius = $n(r).apply__O__Lscalacss_internal_ValueT(f$3);
  var v$2 = $n(radius).Lscalacss_internal_ValueT__f_value;
  var x$11 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$2);
  var array$9 = [new $c_Lscalacss_internal_DslBase$ToStyle(this$84.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$11.av__Lscalacss_internal_AV()))];
  this.Lreactbuild_Style$__f_withRoundedCorner = $n($$x22).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x24 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "withLittlePadding");
  var $$x23 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$98 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$1 = 2;
  var u$1 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$5 = new $c_Lscalacss_internal_Length(this$$1, u$1);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$1 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$1) => {
    var x$3$3 = $as_Lscalacss_internal_Length(x$3$2$1);
    return $n(x$3$3).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
    var x$1$5 = $as_Lscalacss_internal_ValueT(x$1$2$2);
    return $n(x$1$5)
  }));
  var bc$1 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$4);
  var r$1 = $n(ab$1).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$1);
  var all = $n(r$1).apply__O__Lscalacss_internal_ValueT(f$5);
  var v$3 = $n(all).Lscalacss_internal_ValueT__f_value;
  var array$10 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x23).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$98.Lscalacss_internal_Attrs$padding$__f_attr, v$3)))];
  this.Lreactbuild_Style$__f_withLittlePadding = $n($$x24).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x30 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "dontOverflow");
  var $$x29 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$104 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$4 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$5 = v$4.Lscalacss_internal_Literal__f_value;
  var $$x28 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x29).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$104.Lscalacss_internal_Attrs$overflow$__f_attr, v$5)));
  var $$x27 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$1 = $m_Lscalacss_internal_Attrs$().textOverflow__Lscalacss_internal_Attr();
  var $$x26 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x27).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$1, "ellipsis")));
  var $$x25 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$109 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var array$11 = [$$x28, $$x26, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x25).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$109.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")))];
  this.Lreactbuild_Style$__f_dontOverflow = $n($$x30).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x81 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "unsafe");
  var $$x80 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x79 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x78 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$122 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$2 = 100;
  var f$7 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$2);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$2 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4$1 = $as_Lscalacss_internal_Percentage(x$4$2);
    return $n(x$4$1).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
    var x$1$6 = $as_Lscalacss_internal_ValueT(x$1$2$3);
    return $n(x$1$6)
  }));
  var bc$2 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$6);
  var r$2 = $n(ab$2).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$2);
  var v$6 = $n(r$2).apply__O__Lscalacss_internal_ValueT(f$7);
  var v$7 = $n(v$6).Lscalacss_internal_ValueT__f_value;
  var $$x77 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x78).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$122.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$7)));
  var $$x76 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$124 = $m_Lscalacss_internal_Attrs$margin$();
  var $$x75 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x76).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$124.Lscalacss_internal_Attrs$margin$__f_attr, "0")));
  var $$x74 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$126 = $m_Lscalacss_internal_Attrs$padding$();
  var $$x73 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x74).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$126.Lscalacss_internal_Attrs$padding$__f_attr, "0")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$12 = this.Lreactbuild_Style$__f_flexRow;
  var array$12 = [$$x77, $$x75, $$x73, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$12).Lscalacss_internal_StyleA__f_style)];
  var $$x72 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x80).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x79).unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("html", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x71 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x70 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x69 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$133 = $m_Lscalacss_internal_Attrs$margin$();
  var $$x68 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x69).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$133.Lscalacss_internal_Attrs$margin$__f_attr, "0")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x67 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$135 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x66 = $n($n($$x67).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$135.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5$1 = $as_Lscalacss_internal_Media$Query(x$5$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$5$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$13 = this.Lreactbuild_Style$__f_flexColumn;
  var $$x65 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$13).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$14 = this.Lreactbuild_Style$__f_full;
  var $$x64 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$14).Lscalacss_internal_StyleA__f_style);
  var $$x63 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$146 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$3 = 100;
  var f$9 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$3);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$3 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$1) => {
    var x$4$3 = $as_Lscalacss_internal_Percentage(x$4$2$1);
    return $n(x$4$3).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$8 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
    var x$1$7 = $as_Lscalacss_internal_ValueT(x$1$2$4);
    return $n(x$1$7)
  }));
  var bc$3 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$8);
  var r$3 = $n(ab$3).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$3);
  var v$8 = $n(r$3).apply__O__Lscalacss_internal_ValueT(f$9);
  var v$9 = $n(v$8).Lscalacss_internal_ValueT__f_value;
  var $$x62 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x63).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$146.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$9)));
  var $$x61 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$148 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$10 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$11 = v$10.Lscalacss_internal_Literal__f_value;
  var array$13 = [$$x65, $$x64, $$x62, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x61).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$148.Lscalacss_internal_Attrs$overflow$__f_attr, v$11)))];
  var x$15 = $n($$x66).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$14 = [$$x68, new $c_Lscalacss_internal_DslBase$ToStyle(x$15)];
  var $$x60 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x71).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x70).unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("body", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x59 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x58 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x57 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$167 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$4 = 9;
  var u$2 = $m_Lscalacss_internal_LengthUnit$pt$();
  var f$11 = new $c_Lscalacss_internal_Length(this$$4, u$2);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$4 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$2) => {
    var x$3$4 = $as_Lscalacss_internal_Length(x$3$2$2);
    return $n(x$3$4).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$10 = new $c_sjsr_AnonFunction1(((x$1$2$5) => {
    var x$1$8 = $as_Lscalacss_internal_ValueT(x$1$2$5);
    return $n(x$1$8)
  }));
  var bc$4 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$10);
  var r$4 = $n(ab$4).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$4);
  var v$12 = $n(r$4).apply__O__Lscalacss_internal_ValueT(f$11);
  var v$13 = $n(v$12).Lscalacss_internal_ValueT__f_value;
  var array$15 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x57).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$167.Lscalacss_internal_Attrs$fontSize$__f_attr, v$13)))];
  var $$x56 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x59).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x58).unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("BODY, TABLE, INPUT, BUTTON, TD, TH", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x55 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x54 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x53 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x52 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$2 = $m_Lscalacss_internal_Attrs$fontFamily$();
  var array$16 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x53).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x52).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$2, "Roboto")))];
  var $$x51 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x55).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x54).unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("BODY, BUTTON", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x50 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x49 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$16 = this.Lreactbuild_Style$__f_withBackground;
  var array$17 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$16).Lscalacss_internal_StyleA__f_style)];
  var $$x48 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x50).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x49).unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("BODY", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x47 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x46 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x45 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$184 = $m_Lscalacss_internal_Attrs$border$();
  var v$14 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$15 = v$14.Lscalacss_internal_Literal__f_value;
  var array$18 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x45).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$184.Lscalacss_internal_Attrs$border$__f_attr, v$15)))];
  var $$x44 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x47).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x46).unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("INPUT", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x43 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x42 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x41 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$3 = $m_Lscalacss_internal_Attrs$().textDecoration__Lscalacss_internal_Attr();
  var $$x40 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x41).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$3, "none")));
  var $$x39 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$194 = $m_Lscalacss_internal_Attrs$color$();
  var v$16 = new $c_Lscalacss_internal_ValueT("hsl(225,80%,50%)");
  var v$17 = v$16.Lscalacss_internal_ValueT__f_value;
  var $$x38 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x39).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$194.Lscalacss_internal_Attrs$color$__f_attr, v$17)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x37 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$196 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$197 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$196.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x36 = $n($n($$x37).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$197), new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6$1 = $as_Lscalacss_internal_Media$Query(x$6$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$6$1)
  }))));
  var $$x35 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$200 = $m_Lscalacss_internal_Attrs$color$();
  var v$18 = new $c_Lscalacss_internal_ValueT("hsl(225,100%,75%)");
  var v$19 = v$18.Lscalacss_internal_ValueT__f_value;
  var array$19 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x35).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$200.Lscalacss_internal_Attrs$color$__f_attr, v$19)))];
  var x$17 = $n($$x36).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$20 = [$$x40, $$x38, new $c_Lscalacss_internal_DslBase$ToStyle(x$17)];
  var $$x34 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x43).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x42).unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("A", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x33 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x32 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x31 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$211 = $m_Lscalacss_internal_Attrs$display$();
  var array$21 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x31).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$211.Lscalacss_internal_Attrs$display$__f_attr, "table-row-group")))];
  var array$22 = [$$x72, $$x60, $$x56, $$x51, $$x48, $$x44, $$x34, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x33).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x32).unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("THEAD, TFOOT", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  $n($$x81).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x89 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "rootContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x88 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$221 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x87 = $n($n($$x88).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$221.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7$1 = $as_Lscalacss_internal_Media$Query(x$7$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$7$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$18 = this.Lreactbuild_Style$__f_flexColumn;
  var $$x86 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$18).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$19 = this.Lreactbuild_Style$__f_full;
  var $$x85 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$19).Lscalacss_internal_StyleA__f_style);
  var $$x84 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$225 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$20 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$21 = v$20.Lscalacss_internal_Literal__f_value;
  var $$x83 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x84).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$225.Lscalacss_internal_Attrs$overflow$__f_attr, v$21)));
  var $$x82 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$234 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$5 = 100;
  var f$13 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$5);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$5 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$2) => {
    var x$4$4 = $as_Lscalacss_internal_Percentage(x$4$2$2);
    return $n(x$4$4).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$12 = new $c_sjsr_AnonFunction1(((x$1$2$6) => {
    var x$1$9 = $as_Lscalacss_internal_ValueT(x$1$2$6);
    return $n(x$1$9)
  }));
  var bc$5 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$12);
  var r$5 = $n(ab$5).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$5);
  var v$22 = $n(r$5).apply__O__Lscalacss_internal_ValueT(f$13);
  var v$23 = $n(v$22).Lscalacss_internal_ValueT__f_value;
  var array$23 = [$$x86, $$x85, $$x83, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x82).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$234.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$23)))];
  var x$20 = $n($$x87).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$24 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$20)];
  this.Lreactbuild_Style$__f_rootContainer = $n($$x89).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x94 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "autoScrollContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x93 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$245 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x92 = $n($n($$x93).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$245.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8$1 = $as_Lscalacss_internal_Media$Query(x$8$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$8$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$21 = this.Lreactbuild_Style$__f_full;
  var $$x91 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$21).Lscalacss_internal_StyleA__f_style);
  var $$x90 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$248 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$24 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$25 = v$24.Lscalacss_internal_Literal__f_value;
  var array$25 = [$$x91, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x90).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$248.Lscalacss_internal_Attrs$overflow$__f_attr, v$25)))];
  var x$22 = $n($$x92).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$26 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$22)];
  this.Lreactbuild_Style$__f_autoScrollContainer = $n($$x94).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$26), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x104 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "toolbar");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$23 = this.Lreactbuild_Style$__f_flexRow;
  var $$x103 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$23).Lscalacss_internal_StyleA__f_style);
  var $$x102 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$260 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x101 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x102).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$260.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x100 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$262 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var $$x99 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x100).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$262.Lscalacss_internal_Attrs$justifyContent$__f_attr, "space-between")));
  var $$x98 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$264 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x97 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x98).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$264.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
  var $$x96 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$266 = $m_Lscalacss_internal_Attrs$userSelect$();
  var v$26 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$27 = v$26.Lscalacss_internal_Literal__f_value;
  var $$x95 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x96).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$266.Lscalacss_internal_Attrs$userSelect$__f_attr, v$27)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$24 = this.Lreactbuild_Style$__f_notPrintable;
  var array$27 = [$$x103, $$x101, $$x99, $$x97, $$x95, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$24).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_toolbar = $n($$x104).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$27), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x108 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "toolbarMain");
  var $$x107 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$273 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x106 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x107).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$273.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "black")));
  var $$x105 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$275 = $m_Lscalacss_internal_Attrs$color$();
  var array$28 = [$$x106, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x105).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$275.Lscalacss_internal_Attrs$color$__f_attr, "white")))];
  this.Lreactbuild_Style$__f_toolbarMain = $n($$x108).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$28), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x115 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "tabs");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$25 = this.Lreactbuild_Style$__f_flexRow;
  var $$x114 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$25).Lscalacss_internal_StyleA__f_style);
  var $$x113 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$282 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x112 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x113).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$282.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x111 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$291 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$6 = 100;
  var f$15 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$6);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$6 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$3) => {
    var x$4$5 = $as_Lscalacss_internal_Percentage(x$4$2$3);
    return $n(x$4$5).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$14 = new $c_sjsr_AnonFunction1(((x$1$2$7) => {
    var x$1$10 = $as_Lscalacss_internal_ValueT(x$1$2$7);
    return $n(x$1$10)
  }));
  var bc$6 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$14);
  var r$6 = $n(ab$6).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$6);
  var v$28 = $n(r$6).apply__O__Lscalacss_internal_ValueT(f$15);
  var v$29 = $n(v$28).Lscalacss_internal_ValueT__f_value;
  var $$x110 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x111).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$291.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$29)));
  var $$x109 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$293 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$30 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$31 = v$30.Lscalacss_internal_Literal__f_value;
  var array$29 = [$$x114, $$x112, $$x110, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x109).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$293.Lscalacss_internal_Attrs$overflowX$__f_attr, v$31)))];
  this.Lreactbuild_Style$__f_tabs = $n($$x115).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$29), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x130 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "tab");
  var $$x129 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$307 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$7 = 0.5;
  var u$3 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$17 = new $c_Lscalacss_internal_Length(this$$7, u$3);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$7 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$3) => {
    var x$3$5 = $as_Lscalacss_internal_Length(x$3$2$3);
    return $n(x$3$5).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$16 = new $c_sjsr_AnonFunction1(((x$1$2$8) => {
    var x$1$11 = $as_Lscalacss_internal_ValueT(x$1$2$8);
    return $n(x$1$11)
  }));
  var bc$7 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$16);
  var r$7 = $n(ab$7).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$7);
  var all$1 = $n(r$7).apply__O__Lscalacss_internal_ValueT(f$17);
  var v$32 = $n(all$1).Lscalacss_internal_ValueT__f_value;
  var $$x128 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x129).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$307.Lscalacss_internal_Attrs$padding$__f_attr, v$32)));
  var $$x127 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$309 = $m_Lscalacss_internal_Attrs$color$();
  var v$33 = $m_Lscalacss_internal_Literal$Typed$inherit$();
  var v$34 = v$33.Lscalacss_internal_Literal__f_value;
  var $$x126 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x127).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$309.Lscalacss_internal_Attrs$color$__f_attr, v$34)));
  var $$x125 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$312 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var $$x124 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x125).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$312.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")));
  var $$x123 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$314 = $m_Lscalacss_internal_Attrs$fontSize$();
  var $$x122 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x123).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$314.Lscalacss_internal_Attrs$fontSize$__f_attr, "larger")));
  var $$x121 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$316 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var $$x120 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x121).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$316.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")));
  var $$x119 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x118 = $m_Lscalacss_internal_Attrs$borderBottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$8 = 0.25;
  var u$4 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$19 = new $c_Lscalacss_internal_Length(this$$8, u$4);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$8 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$4) => {
    var x$3$6 = $as_Lscalacss_internal_Length(x$3$2$4);
    return $n(x$3$6).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$18 = new $c_sjsr_AnonFunction1(((x$1$2$9) => {
    var x$1$12 = $as_Lscalacss_internal_ValueT(x$1$2$9);
    return $n(x$1$12)
  }));
  var bc$8 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$18);
  var r$8 = $n(ab$8).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$8);
  var $$x117 = $n(r$8).apply__O__Lscalacss_internal_ValueT(f$19);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$21 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$328 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$9 = this$328.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$3) => {
    var x$2$3 = $as_Lscalacss_internal_Literal(x$2$2$3);
    return $n(x$2$3).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$20 = new $c_sjsr_AnonFunction1(((x$1$2$10) => {
    var x$1$13 = $as_Lscalacss_internal_ValueT(x$1$2$10);
    return $n(x$1$13)
  }));
  var bc$9 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$20);
  var r$9 = $n(ab$9).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$9);
  var $$x116 = $n(r$9).apply__O__Lscalacss_internal_ValueT(f$21);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$23 = new $c_Lscalacss_internal_ValueT("transparent");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$22 = new $c_sjsr_AnonFunction1(((x$1$2$11) => {
    var x$1$14 = $as_Lscalacss_internal_ValueT(x$1$2$11);
    return $n(x$1$14)
  }));
  var r$10 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$22);
  var array$30 = [$$x128, $$x126, $$x124, $$x122, $$x120, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x119).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x118.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x117, $$x116, r$10.apply__O__Lscalacss_internal_ValueT(f$23))))];
  this.Lreactbuild_Style$__f_tab = $n($$x130).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$30), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x132 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "tabSelected");
  var $$x131 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$343 = $m_Lscalacss_internal_Attrs$borderBottomColor$();
  var array$31 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x131).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$343.Lscalacss_internal_Attrs$borderBottomColor$__f_attr, "orange")))];
  this.Lreactbuild_Style$__f_tabSelected = $n($$x132).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$31), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x133 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "fixedHeadersTable");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$26 = $n(this.Lreactbuild_Style$__f_reactComponents).Lcom_iz2use_react_style_Style__f_fixedHeadersTable;
  var array$32 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$26).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_fixedHeadersTable = $n($$x133).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$32), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x190 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "crossedTable");
  var $$x189 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$354 = $m_Lscalacss_internal_Attrs$borderCollapse$();
  var $$x188 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x189).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$354.Lscalacss_internal_Attrs$borderCollapse$__f_attr, "collapse")));
  var $$x187 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x186 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x185 = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    return (((s + ">*>TR>TD, ") + s) + ">*>TR>TH")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$35 = ($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $m_Lscalacss_internal_Attrs$border$()).Lscalacss_internal_Attrs$border$__f_attr;
  var qual$3 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$35);
  var x$5$3 = $n(this.Lreactbuild_Style$__f_theme).Lcom_iz2use_react_style_Theme__f_lineBorder;
  var x$6$3 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var x$7$3 = new $c_sjsr_AnonFunction1(((color$2) => {
    var color = $as_Lscalacss_internal_ValueT(color$2);
    return new $c_sjsr_AnonFunction1(((x$1$2$12) => {
      var x$1$15 = $as_Lscalacss_internal_Attr(x$1$2$12);
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value = ("1px solid " + $n(color).Lscalacss_internal_ValueT__f_value);
      return new $c_Lscalacss_internal_AV(x$1$15, value)
    }))
  }));
  var array$33 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(qual$3, x$7$3, x$5$3, x$6$3)];
  var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$33);
  $m_Lreactbuild_package$CssSettings$();
  var c$1 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$24 = new $c_sjsr_AnonFunction1(((x$1$2$13) => {
    var x$1$16 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$13);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$16).light__Lscalacss_internal_AV()))
  }));
  var t$4 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$3, f$24));
  var x$27 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$4, c$1);
  var $$x184 = new $c_Lscalacss_internal_DslBase$ToStyle(x$27);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x183 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$366 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$367 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$366.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x182 = $n($n($$x183).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$367), new $c_sjsr_AnonFunction1(((x$2$4) => {
    var x$28 = $as_Lscalacss_internal_Media$Query(x$2$4);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$28)
  }))));
  var f$25 = new $c_sjsr_AnonFunction1(((x$2$2$2$1) => {
    var x$2$2$4 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$1);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$4).dark__Lscalacss_internal_AV()))
  }));
  var x$29 = $n($$x182).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$3, f$25)), c$1);
  var array$34 = [$$x184, new $c_Lscalacss_internal_DslBase$ToStyle(x$29)];
  var t$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$34);
  var x$30 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$5, c$1);
  var array$35 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$30)];
  var $$x181 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x187).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x186).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x185, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$35), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x180 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x179 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x178 = new $c_sjsr_AnonFunction1(((x$2$3$2) => {
    var x$2$3$1 = $as_T(x$2$3$2);
    return (x$2$3$1 + ">TBODY>TR:nth-child(3n+3)")
  }));
  var $$x177 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$380 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$36 = new $c_Lscalacss_internal_ValueT("#efefef");
  var v$37 = v$36.Lscalacss_internal_ValueT__f_value;
  var $$x176 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x177).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$380.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$37)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x175 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$382 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$383 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$382.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x174 = $n($n($$x175).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$383), new $c_sjsr_AnonFunction1(((x$9$2) => {
    var x$9$1 = $as_Lscalacss_internal_Media$Query(x$9$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$9$1)
  }))));
  var $$x173 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$386 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$38 = new $c_Lscalacss_internal_ValueT("#1e1e1e");
  var v$39 = v$38.Lscalacss_internal_ValueT__f_value;
  var array$36 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x173).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$386.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$39)))];
  var x$31 = $n($$x174).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$36), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$37 = [$$x176, new $c_Lscalacss_internal_DslBase$ToStyle(x$31)];
  var $$x172 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x180).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x179).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x178, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$37), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x171 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x170 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x169 = new $c_sjsr_AnonFunction1(((s$3$2) => {
    var s$3 = $as_T(s$3$2);
    return (s$3 + ">TBODY>TR>TD:nth-child(3n+3)")
  }));
  var $$x168 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$398 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$40 = new $c_Lscalacss_internal_ValueT("#efefe0");
  var v$41 = v$40.Lscalacss_internal_ValueT__f_value;
  var $$x167 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x168).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$398.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$41)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x166 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$400 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$401 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$400.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x165 = $n($n($$x166).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$401), new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10$1 = $as_Lscalacss_internal_Media$Query(x$10$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$10$1)
  }))));
  var $$x164 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$404 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$42 = new $c_Lscalacss_internal_ValueT("#1e1e10");
  var v$43 = v$42.Lscalacss_internal_ValueT__f_value;
  var array$38 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x164).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$404.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$43)))];
  var x$32 = $n($$x165).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$38), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$39 = [$$x167, new $c_Lscalacss_internal_DslBase$ToStyle(x$32)];
  var $$x163 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x171).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x170).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x169, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$39), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x162 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x161 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x160 = new $c_sjsr_AnonFunction1(((s$4$2) => {
    var s$4 = $as_T(s$4$2);
    return (((s$4 + ">TBODY>TR>TD,") + s$4) + ">TBODY>TR>TH")
  }));
  var $$x159 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$415 = $m_Lscalacss_internal_Attrs$pageBreakInside$();
  var array$40 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x159).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$415.Lscalacss_internal_Attrs$pageBreakInside$__f_attr, "avoid")))];
  var $$x158 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x162).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x161).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x160, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$40), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x157 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x156 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x155 = new $c_sjsr_AnonFunction1(((s$5$2) => {
    var s$5 = $as_T(s$5$2);
    return (s$5 + ">*")
  }));
  var $$x154 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$421 = $m_Lscalacss_internal_Attrs$pageBreakBefore$();
  var v$44 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$45 = v$44.Lscalacss_internal_Literal__f_value;
  var array$41 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x154).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$421.Lscalacss_internal_Attrs$pageBreakBefore$__f_attr, v$45)))];
  var $$x153 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x157).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x156).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x155, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$41), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x152 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x151 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x150 = new $c_sjsr_AnonFunction1(((s$6$2) => {
    var s$6 = $as_T(s$6$2);
    return (s$6 + ">TBODY>TR")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x149 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$426 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p = $m_Lscalacss_internal_Pseudo$Hover$();
  var $$x148 = this$426.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p);
  var this$428 = $m_s_$less$colon$less$();
  var $$x147 = $n($n($$x149).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x148, this$428.s_$less$colon$less$__f_singleton));
  var $$x146 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x145 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x144 = new $c_sjsr_AnonFunction1(((s$7$2) => {
    var s$7 = $as_T(s$7$2);
    return (((s$7 + ">TD, ") + s$7) + ">TH")
  }));
  var $$x143 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$431 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$46 = new $c_Lscalacss_internal_ValueT("#ffa000");
  var v$47 = v$46.Lscalacss_internal_ValueT__f_value;
  var $$x142 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x143).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$431.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$47).important__Lscalacss_internal_AV()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x141 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$433 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$434 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$433.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x140 = $n($n($$x141).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$434), new $c_sjsr_AnonFunction1(((x$11$2) => {
    var x$11$1 = $as_Lscalacss_internal_Media$Query(x$11$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$11$1)
  }))));
  var $$x139 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$437 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$48 = new $c_Lscalacss_internal_ValueT("#804000");
  var v$49 = v$48.Lscalacss_internal_ValueT__f_value;
  var array$42 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x139).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$437.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$49).important__Lscalacss_internal_AV()))];
  var x$33 = $n($$x140).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$42), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$43 = [$$x142, new $c_Lscalacss_internal_DslBase$ToStyle(x$33)];
  var array$44 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x146).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x145).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x144, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$43), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  var x$34 = $n($$x147).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$44), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$45 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$34)];
  var $$x138 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x152).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x151).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x150, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$45), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x137 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x136 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x135 = new $c_sjsr_AnonFunction1(((x$3$2$2$1) => {
    var x$3$2$5 = $as_T(x$3$2$2$1);
    return (x$3$2$5 + ">TBODY>TR>TD")
  }));
  var $$x134 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$457 = $m_Lscalacss_internal_Attrs$textAlign$();
  var array$46 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x134).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$457.Lscalacss_internal_Attrs$textAlign$__f_attr, "right")))];
  var array$47 = [$$x188, $$x181, $$x172, $$x163, $$x158, $$x153, $$x138, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x137).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x136).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x135, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$46), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_crossedTable = $n($$x190).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$47), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x232 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "reportTable");
  var $$x231 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$467 = $m_Lscalacss_internal_Attrs$borderCollapse$();
  var $$x230 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x231).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$467.Lscalacss_internal_Attrs$borderCollapse$__f_attr, "collapse")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$35 = this.Lreactbuild_Style$__f_withBackground;
  var $$x229 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$35).Lscalacss_internal_StyleA__f_style);
  var $$x228 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$477 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$9 = 100;
  var f$27 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$9);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$10 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$4) => {
    var x$4$6 = $as_Lscalacss_internal_Percentage(x$4$2$4);
    return $n(x$4$6).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$26 = new $c_sjsr_AnonFunction1(((x$1$2$14) => {
    var x$1$17 = $as_Lscalacss_internal_ValueT(x$1$2$14);
    return $n(x$1$17)
  }));
  var bc$10 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$26);
  var r$11 = $n(ab$10).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$10);
  var v$50 = $n(r$11).apply__O__Lscalacss_internal_ValueT(f$27);
  var v$51 = $n(v$50).Lscalacss_internal_ValueT__f_value;
  var $$x227 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x228).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$477.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$51)));
  var $$x226 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x225 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x224 = new $c_sjsr_AnonFunction1(((s$8$2) => {
    var s$8 = $as_T(s$8$2);
    return (((((s$8 + ">*>TR, ") + s$8) + ">*>TR>TD, ") + s$8) + ">*>TR>TH")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$52 = ($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $m_Lscalacss_internal_Attrs$border$()).Lscalacss_internal_Attrs$border$__f_attr;
  var qual$4 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$52);
  var x$8$3 = $n(this.Lreactbuild_Style$__f_theme).Lcom_iz2use_react_style_Theme__f_lineBorder;
  var x$9$3 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var x$10$3 = new $c_sjsr_AnonFunction1(((color$3$2) => {
    var color$3 = $as_Lscalacss_internal_ValueT(color$3$2);
    return new $c_sjsr_AnonFunction1(((x$4$2$5) => {
      var x$4$7 = $as_Lscalacss_internal_Attr(x$4$2$5);
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value$1 = ("1px solid " + $n(color$3).Lscalacss_internal_ValueT__f_value);
      return new $c_Lscalacss_internal_AV(x$4$7, value$1)
    }))
  }));
  var array$48 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(qual$4, x$10$3, x$8$3, x$9$3)];
  var t$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$48);
  $m_Lreactbuild_package$CssSettings$();
  var c$2 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$28 = new $c_sjsr_AnonFunction1(((x$1$2$15) => {
    var x$1$18 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$15);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$18).light__Lscalacss_internal_AV()))
  }));
  var t$7 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$6, f$28));
  var x$36 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$7, c$2);
  var $$x223 = new $c_Lscalacss_internal_DslBase$ToStyle(x$36);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x222 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$489 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$490 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$489.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x221 = $n($n($$x222).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$490), new $c_sjsr_AnonFunction1(((x$2$5) => {
    var x$37 = $as_Lscalacss_internal_Media$Query(x$2$5);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$37)
  }))));
  var f$29 = new $c_sjsr_AnonFunction1(((x$2$2$2$2) => {
    var x$2$2$5 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$2);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$5).dark__Lscalacss_internal_AV()))
  }));
  var x$38 = $n($$x221).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$6, f$29)), c$2);
  var array$49 = [$$x223, new $c_Lscalacss_internal_DslBase$ToStyle(x$38)];
  var t$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$49);
  var x$39 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$8, c$2);
  var array$50 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$39)];
  var $$x220 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x226).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x225).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x224, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$50), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x219 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x218 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x217 = new $c_sjsr_AnonFunction1(((s$9$2) => {
    var s$9 = $as_T(s$9$2);
    return (s$9 + ">*>TR>TH")
  }));
  var $$x216 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$502 = $m_Lscalacss_internal_Attrs$textAlign$();
  var $$x215 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x216).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$502.Lscalacss_internal_Attrs$textAlign$__f_attr, "left")));
  var $$x214 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$512 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$10 = 10;
  var u$5 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$31 = new $c_Lscalacss_internal_Length(this$$10, u$5);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$11 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$6) => {
    var x$3$7 = $as_Lscalacss_internal_Length(x$3$2$6);
    return $n(x$3$7).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$30 = new $c_sjsr_AnonFunction1(((x$1$2$16) => {
    var x$1$19 = $as_Lscalacss_internal_ValueT(x$1$2$16);
    return $n(x$1$19)
  }));
  var bc$11 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$30);
  var r$12 = $n(ab$11).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$11);
  var v$53 = $n(r$12).apply__O__Lscalacss_internal_ValueT(f$31);
  var v$54 = $n(v$53).Lscalacss_internal_ValueT__f_value;
  var $$x213 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x214).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$512.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$54)));
  var $$x212 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$514 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$55 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$56 = v$55.Lscalacss_internal_Literal__f_value;
  var $$x211 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x212).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$514.Lscalacss_internal_Attrs$overflow$__f_attr, v$56)));
  var $$x210 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$4 = $m_Lscalacss_internal_Attrs$().textOverflow__Lscalacss_internal_Attr();
  var array$51 = [$$x215, $$x213, $$x211, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x210).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$4, "ellipsis")))];
  var $$x209 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x219).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x218).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x217, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$51), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x208 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x207 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x206 = new $c_sjsr_AnonFunction1(((s$10$2) => {
    var s$10 = $as_T(s$10$2);
    return (((((s$10 + ">THEAD>TR>TD LABEL,") + s$10) + ">TBOODY>TR>TD LABEL,") + s$10) + ">TFOOT>TR>TD LABEL")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$40 = this.Lreactbuild_Style$__f_notPrintable;
  var array$52 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$40).Lscalacss_internal_StyleA__f_style)];
  var $$x205 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x208).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x207).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x206, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$52), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x204 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x203 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x202 = new $c_sjsr_AnonFunction1(((s$11$2) => {
    var s$11 = $as_T(s$11$2);
    return (((((s$11 + ">THEAD>TR>TD>DIV,") + s$11) + ">TBODY>TR>TD>DIV,") + s$11) + ">TFOOT>TR>TD>DIV")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x201 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$528 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x200 = $n($n($$x201).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$528.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12$1 = $as_Lscalacss_internal_Media$Query(x$12$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$12$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$41 = this.Lreactbuild_Style$__f_flexRow;
  var $$x199 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$41).Lscalacss_internal_StyleA__f_style);
  var $$x198 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$531 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var array$53 = [$$x199, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x198).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$531.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")))];
  var x$42 = $n($$x200).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$53), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$54 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$42)];
  var $$x197 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x204).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x203).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x202, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$54), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x196 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x195 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x194 = new $c_sjsr_AnonFunction1(((s$12$2) => {
    var s$12 = $as_T(s$12$2);
    return (s$12 + ">TBODY>TR:hover")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x193 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$542 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x192 = $n($n($$x193).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$542.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$13$2) => {
    var x$13$1 = $as_Lscalacss_internal_Media$Query(x$13$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$13$1)
  }))));
  var $$x191 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$544 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$55 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x191).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$544.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "orange")))];
  var x$43 = $n($$x192).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$55), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$56 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$43)];
  var array$57 = [$$x230, $$x229, $$x227, $$x220, $$x209, $$x205, $$x197, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x196).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x195).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x194, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$56), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_reportTable = $n($$x232).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$57), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x234 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "processingSameReferenceInvoicePage");
  var $$x233 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$560 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$57 = new $c_Lscalacss_internal_ValueT("#ffc");
  var v$58 = v$57.Lscalacss_internal_ValueT__f_value;
  var array$58 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x233).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$560.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$58)))];
  this.Lreactbuild_Style$__f_processingSameReferenceInvoicePage = $n($$x234).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$58), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x236 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "processingActualInvoicePage");
  var $$x235 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$567 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$59 = new $c_Lscalacss_internal_ValueT("#fc8");
  var v$60 = v$59.Lscalacss_internal_ValueT__f_value;
  var array$59 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x235).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$567.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$60)))];
  this.Lreactbuild_Style$__f_processingActualInvoicePage = $n($$x236).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$59), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x237 = $m_s_package$().s_package$__f_Seq;
  var array$60 = [new $c_Lscalacss_internal_ValueT("#b71c1c"), new $c_Lscalacss_internal_ValueT("#880e4f"), new $c_Lscalacss_internal_ValueT("#4a148c"), new $c_Lscalacss_internal_ValueT("#311b92"), new $c_Lscalacss_internal_ValueT("#1a237e"), new $c_Lscalacss_internal_ValueT("#0d47a1"), new $c_Lscalacss_internal_ValueT("#01579b"), new $c_Lscalacss_internal_ValueT("#006064"), new $c_Lscalacss_internal_ValueT("#004d40"), new $c_Lscalacss_internal_ValueT("#1b5e20"), new $c_Lscalacss_internal_ValueT("#33691e"), new $c_Lscalacss_internal_ValueT("#827717"), new $c_Lscalacss_internal_ValueT("#f57f17"), new $c_Lscalacss_internal_ValueT("#ff6f00"), new $c_Lscalacss_internal_ValueT("#e65100"), new $c_Lscalacss_internal_ValueT("#bf360c"), new $c_Lscalacss_internal_ValueT("#3e2723"), new $c_Lscalacss_internal_ValueT("#212121"), new $c_Lscalacss_internal_ValueT("#263238")];
  this.Lreactbuild_Style$__f_darkColors = $as_sci_Seq($n($$x237).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$60)));
  var $$x238 = $m_s_package$().s_package$__f_Seq;
  var array$61 = [new $c_Lscalacss_internal_ValueT("#f44336"), new $c_Lscalacss_internal_ValueT("#673ab7"), new $c_Lscalacss_internal_ValueT("#03a9f4"), new $c_Lscalacss_internal_ValueT("#4caf50"), new $c_Lscalacss_internal_ValueT("#ffeb3b"), new $c_Lscalacss_internal_ValueT("#ff5722"), new $c_Lscalacss_internal_ValueT("#e91e63"), new $c_Lscalacss_internal_ValueT("#3f51b5"), new $c_Lscalacss_internal_ValueT("#00bcd4"), new $c_Lscalacss_internal_ValueT("#8bc34a"), new $c_Lscalacss_internal_ValueT("#ffc107"), new $c_Lscalacss_internal_ValueT("#795548"), new $c_Lscalacss_internal_ValueT("#9c27b0"), new $c_Lscalacss_internal_ValueT("#2196f3"), new $c_Lscalacss_internal_ValueT("#009688"), new $c_Lscalacss_internal_ValueT("#cddc39"), new $c_Lscalacss_internal_ValueT("#ff9800"), new $c_Lscalacss_internal_ValueT("#9e9e9e")];
  this.Lreactbuild_Style$__f_colors = $as_sci_Seq($n($$x238).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$61)));
  var this$635 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF(this, "crossedTableActiveCell");
  var end = (((-1) + $n(this.Lreactbuild_Style$__f_colors).length__I()) | 0);
  var r$13 = new $c_sci_Range$Exclusive((-1), end, 1);
  var f$32 = new $c_sjsr_AnonFunction1(((i$2) => {
    var i = $uI(i$2);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var $$x243 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$619 = $m_Lscalacss_internal_Attrs$backgroundColor$();
    var v$61 = $as_Lscalacss_internal_ValueT($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_colors).apply__I__O(((1 + i) | 0)));
    var v$62 = $n(v$61).Lscalacss_internal_ValueT__f_value;
    var $$x242 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x243).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$619.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$62).important__Lscalacss_internal_AV()));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var $$x241 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$621 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var this$622 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$621.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
    var $$x240 = $n($n($$x241).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$622), new $c_sjsr_AnonFunction1(((x$2$6) => {
      var x$44 = $as_Lscalacss_internal_Media$Query(x$2$6);
      return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$44)
    }))));
    var $$x239 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$624 = $m_Lscalacss_internal_Attrs$backgroundColor$();
    var v$63 = $as_Lscalacss_internal_ValueT($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_darkColors).apply__I__O(((1 + i) | 0)));
    var v$64 = $n(v$63).Lscalacss_internal_ValueT__f_value;
    var array$62 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x239).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$624.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$64).important__Lscalacss_internal_AV()))];
    var x$45 = $n($$x240).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$62), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$63 = [$$x242, new $c_Lscalacss_internal_DslBase$ToStyle(x$45)];
    var t$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$63);
    $m_Lreactbuild_package$CssSettings$();
    var c$3 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
    return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$9, c$3)
  }));
  this.Lreactbuild_Style$__f_crossedTableActiveCell = $f_Lscalacss_internal_DslMacros$MStyleF2__int__sci_Range__F1__F1(this$635, r$13, f$32);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$46 = $p_Lreactbuild_Style$__withLight$1__I__Lscalacss_internal_StyleS(this, 92);
  var $$x246 = new $c_Lscalacss_internal_DslBase$ToStyle(x$46);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x245 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$638 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$639 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$638.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x244 = $n($n($$x245).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$639), new $c_sjsr_AnonFunction1(((x$14$2) => {
    var x$14$1 = $as_Lscalacss_internal_Media$Query(x$14$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$14$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$47 = $p_Lreactbuild_Style$__withLight$1__I__Lscalacss_internal_StyleS(this, 18);
  var array$64 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$47)];
  var x$48 = $n($$x244).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$64), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$65 = [$$x246, new $c_Lscalacss_internal_DslBase$ToStyle(x$48)];
  var t$10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$65);
  $m_Lreactbuild_package$CssSettings$();
  var c$4 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_strippedRows = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$10, c$4);
  var $$x258 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "strippedLinesTable");
  var $$x257 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x256 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x255 = new $c_sjsr_AnonFunction1(((x$11$3$2) => {
    var x$11$3 = $as_T(x$11$3$2);
    return (x$11$3 + ">THEAD")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$49 = this.Lreactbuild_Style$__f_strippedRows;
  var array$66 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$49)];
  var $$x254 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x257).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x256).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x255, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$66), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x253 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x252 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x251 = new $c_sjsr_AnonFunction1(((x$12$3$2) => {
    var x$12$3 = $as_T(x$12$3$2);
    return (x$12$3 + ">TBODY")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$50 = this.Lreactbuild_Style$__f_strippedRows;
  var array$67 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$50)];
  var $$x250 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x253).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x252).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x251, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$67), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x249 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x248 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x247 = new $c_sjsr_AnonFunction1(((x$13$3$2) => {
    var x$13$3 = $as_T(x$13$3$2);
    return (x$13$3 + ">TFOOT")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$51 = this.Lreactbuild_Style$__f_strippedRows;
  var array$68 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$51)];
  var array$69 = [$$x254, $$x250, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x249).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x248).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x247, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$68), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_strippedLinesTable = $n($$x258).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$69), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x266 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "maybeRelated");
  var $$x265 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$679 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$11 = 12;
  var u$6 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$34 = new $c_Lscalacss_internal_Length(this$$11, u$6);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$12 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$7) => {
    var x$3$8 = $as_Lscalacss_internal_Length(x$3$2$7);
    return $n(x$3$8).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$33 = new $c_sjsr_AnonFunction1(((x$1$2$17) => {
    var x$1$20 = $as_Lscalacss_internal_ValueT(x$1$2$17);
    return $n(x$1$20)
  }));
  var bc$12 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$33);
  var r$14 = $n(ab$12).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$12);
  var v$65 = $n(r$14).apply__O__Lscalacss_internal_ValueT(f$34);
  var v$66 = $n(v$65).Lscalacss_internal_ValueT__f_value;
  var $$x264 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x265).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$679.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$66)));
  var $$x263 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$681 = $m_Lscalacss_internal_Attrs$overflowY$();
  var v$67 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$68 = v$67.Lscalacss_internal_Literal__f_value;
  var $$x262 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x263).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$681.Lscalacss_internal_Attrs$overflowY$__f_attr, v$68)));
  var $$x261 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$5 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x260 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x261).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$5, "1")));
  var $$x259 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$686 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$69 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$70 = v$69.Lscalacss_internal_Literal__f_value;
  var array$70 = [$$x264, $$x262, $$x260, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x259).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$686.Lscalacss_internal_Attrs$overflowX$__f_attr, v$70))), new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(new $c_sjsr_AnonFunction1(((x$14$3$2) => {
    var x$14$3 = $as_T(x$14$3$2);
    return (x$14$3 + ">TABLE")
  })), $m_sci_Nil$(), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_maybeRelated = $n($$x266).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$70), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var this$745 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF(this, "crossDetails");
  var end$1 = (((-1) + $n(this.Lreactbuild_Style$__f_colors).length__I()) | 0);
  var r$21 = new $c_sci_Range$Exclusive((-1), end$1, 1);
  var f$47 = new $c_sjsr_AnonFunction1(((i$3$2) => {
    var i$3 = $uI(i$3$2);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var $$x277 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var $$x276 = $m_Lscalacss_internal_Attrs$borderTop$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$$12 = 5;
    var u$7 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$36 = new $c_Lscalacss_internal_Length(this$$12, u$7);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var ab$13 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$8) => {
      var x$3$9 = $as_Lscalacss_internal_Length(x$3$2$8);
      return $n(x$3$9).value__T()
    })));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$35 = new $c_sjsr_AnonFunction1(((x$1$2$18) => {
      var x$1$21 = $as_Lscalacss_internal_ValueT(x$1$2$18);
      return $n(x$1$21)
    }));
    var bc$13 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$35);
    var r$15 = $n(ab$13).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$13);
    var $$x275 = $n(r$15).apply__O__Lscalacss_internal_ValueT(f$36);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$38 = $m_Lscalacss_internal_Literal$Typed$solid$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$706 = $m_Lscalacss_internal_ValueT$Rule$();
    var ab$14 = this$706.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$6) => {
      var x$2$7 = $as_Lscalacss_internal_Literal(x$2$2$6);
      return $n(x$2$7).Lscalacss_internal_Literal__f_value
    })));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$37 = new $c_sjsr_AnonFunction1(((x$1$2$19) => {
      var x$1$22 = $as_Lscalacss_internal_ValueT(x$1$2$19);
      return $n(x$1$22)
    }));
    var bc$14 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$37);
    var r$16 = $n(ab$14).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$14);
    var $$x274 = $n(r$16).apply__O__Lscalacss_internal_ValueT(f$38);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$40 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_colors).apply__I__O($intMod(((1 + i$3) | 0), $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_colors).length__I()));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$39 = new $c_sjsr_AnonFunction1(((x$1$2$20) => {
      var x$1$23 = $as_Lscalacss_internal_ValueT(x$1$2$20);
      return $n(x$1$23)
    }));
    var r$17 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$39);
    var $$x273 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x277).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x276.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x275, $$x274, r$17.apply__O__Lscalacss_internal_ValueT(f$40))));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var $$x272 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$715 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var $$x271 = $n($n($$x272).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$715), new $c_sjsr_AnonFunction1(((x$2$8) => {
      var x$52 = $as_Lscalacss_internal_Media$Query(x$2$8);
      return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$52)
    }))));
    var $$x270 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var $$x269 = $m_Lscalacss_internal_Attrs$borderTop$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$$13 = 5;
    var u$8 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$42 = new $c_Lscalacss_internal_Length(this$$13, u$8);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var ab$15 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$9) => {
      var x$3$10 = $as_Lscalacss_internal_Length(x$3$2$9);
      return $n(x$3$10).value__T()
    })));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$41 = new $c_sjsr_AnonFunction1(((x$1$2$21) => {
      var x$1$24 = $as_Lscalacss_internal_ValueT(x$1$2$21);
      return $n(x$1$24)
    }));
    var bc$15 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$41);
    var r$18 = $n(ab$15).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$15);
    var $$x268 = $n(r$18).apply__O__Lscalacss_internal_ValueT(f$42);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$44 = $m_Lscalacss_internal_Literal$Typed$solid$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$727 = $m_Lscalacss_internal_ValueT$Rule$();
    var ab$16 = this$727.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$7) => {
      var x$2$9 = $as_Lscalacss_internal_Literal(x$2$2$7);
      return $n(x$2$9).Lscalacss_internal_Literal__f_value
    })));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$43 = new $c_sjsr_AnonFunction1(((x$1$2$22) => {
      var x$1$25 = $as_Lscalacss_internal_ValueT(x$1$2$22);
      return $n(x$1$25)
    }));
    var bc$16 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$43);
    var r$19 = $n(ab$16).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$16);
    var $$x267 = $n(r$19).apply__O__Lscalacss_internal_ValueT(f$44);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$46 = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_colors).apply__I__O($intMod(((1 + i$3) | 0), $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_darkColors).length__I()));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$45 = new $c_sjsr_AnonFunction1(((x$1$2$23) => {
      var x$1$26 = $as_Lscalacss_internal_ValueT(x$1$2$23);
      return $n(x$1$26)
    }));
    var r$20 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$45);
    var array$71 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x270).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x269.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x268, $$x267, r$20.apply__O__Lscalacss_internal_ValueT(f$46))))];
    var x$53 = $n($$x271).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$71), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$72 = [$$x273, new $c_Lscalacss_internal_DslBase$ToStyle(x$53)];
    var t$11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$72);
    $m_Lreactbuild_package$CssSettings$();
    var c$5 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
    return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$11, c$5)
  }));
  this.Lreactbuild_Style$__f_crossDetails = $f_Lscalacss_internal_DslMacros$MStyleF2__int__sci_Range__F1__F1(this$745, r$21, f$47);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x278 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$747 = $m_Lscalacss_internal_Attrs$textAlign$();
  var array$73 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x278).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$747.Lscalacss_internal_Attrs$textAlign$__f_attr, "center")))];
  var t$12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$73);
  $m_Lreactbuild_package$CssSettings$();
  var c$6 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_textCenter = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$12, c$6);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x279 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$754 = $m_Lscalacss_internal_Attrs$textAlign$();
  var array$74 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x279).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$754.Lscalacss_internal_Attrs$textAlign$__f_attr, "right")))];
  var t$13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$74);
  $m_Lreactbuild_package$CssSettings$();
  var c$7 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_textRight = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$13, c$7);
  var $$x280 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "dateCell");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$54 = this.Lreactbuild_Style$__f_textCenter;
  var array$75 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$54)];
  $n($$x280).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$75), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x281 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "amountCell");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$55 = this.Lreactbuild_Style$__f_textRight;
  var array$76 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$55)];
  $n($$x281).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$76), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x282 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "numberCell");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$56 = this.Lreactbuild_Style$__f_textRight;
  var array$77 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$56)];
  $n($$x282).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$77), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x300 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "pdfViewerContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x299 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$776 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$780 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$776.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$14 = 800;
  var u$9 = $m_Lscalacss_internal_LengthUnit$px$();
  var v$71 = new $c_Lscalacss_internal_Length(this$$14, u$9);
  var $$x298 = $n($n($$x299).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__maxWidth__Lscalacss_internal_Length__O(this$780, v$71), new $c_sjsr_AnonFunction1(((x$15$2) => {
    var x$15$1 = $as_Lscalacss_internal_Media$Query(x$15$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$15$1)
  }))));
  var $$x297 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$790 = $m_Lscalacss_internal_Attrs$minWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$15 = 73;
  var u$10 = $m_Lscalacss_internal_LengthUnit$vh$();
  var f$49 = new $c_Lscalacss_internal_Length(this$$15, u$10);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$17 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$10) => {
    var x$3$11 = $as_Lscalacss_internal_Length(x$3$2$10);
    return $n(x$3$11).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$48 = new $c_sjsr_AnonFunction1(((x$1$2$24) => {
    var x$1$27 = $as_Lscalacss_internal_ValueT(x$1$2$24);
    return $n(x$1$27)
  }));
  var bc$17 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$48);
  var r$22 = $n(ab$17).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$17);
  var v$72 = $n(r$22).apply__O__Lscalacss_internal_ValueT(f$49);
  var v$73 = $n(v$72).Lscalacss_internal_ValueT__f_value;
  var array$78 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x297).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$790.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$73)))];
  var x$57 = $n($$x298).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$78), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x296 = new $c_Lscalacss_internal_DslBase$ToStyle(x$57);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$58 = this.Lreactbuild_Style$__f_flexColumn;
  var $$x295 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$58).Lscalacss_internal_StyleA__f_style);
  var $$x294 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$805 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$16 = 100;
  var f$51 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$16);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$18 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$6) => {
    var x$4$8 = $as_Lscalacss_internal_Percentage(x$4$2$6);
    return $n(x$4$8).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$50 = new $c_sjsr_AnonFunction1(((x$1$2$25) => {
    var x$1$28 = $as_Lscalacss_internal_ValueT(x$1$2$25);
    return $n(x$1$28)
  }));
  var bc$18 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$50);
  var r$23 = $n(ab$18).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$18);
  var v$74 = $n(r$23).apply__O__Lscalacss_internal_ValueT(f$51);
  var v$75 = $n(v$74).Lscalacss_internal_ValueT__f_value;
  var $$x293 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x294).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$805.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$75)));
  var $$x292 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$807 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$76 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$77 = v$76.Lscalacss_internal_Literal__f_value;
  var $$x291 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x292).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$807.Lscalacss_internal_Attrs$overflow$__f_attr, v$77)));
  var $$x290 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x289 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x288 = new $c_sjsr_AnonFunction1(((x$15$3$2) => {
    var x$15$3 = $as_T(x$15$3$2);
    return (x$15$3 + ">IFRAME")
  }));
  var $$x287 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$816 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$17 = 100;
  var f$53 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$17);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$19 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$7) => {
    var x$4$9 = $as_Lscalacss_internal_Percentage(x$4$2$7);
    return $n(x$4$9).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$52 = new $c_sjsr_AnonFunction1(((x$1$2$26) => {
    var x$1$29 = $as_Lscalacss_internal_ValueT(x$1$2$26);
    return $n(x$1$29)
  }));
  var bc$19 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$52);
  var r$24 = $n(ab$19).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$19);
  var v$78 = $n(r$24).apply__O__Lscalacss_internal_ValueT(f$53);
  var v$79 = $n(v$78).Lscalacss_internal_ValueT__f_value;
  var $$x286 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x287).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$816.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$79)));
  var $$x285 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$825 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$18 = 100;
  var f$55 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$18);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$20 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$8) => {
    var x$4$10 = $as_Lscalacss_internal_Percentage(x$4$2$8);
    return $n(x$4$10).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$54 = new $c_sjsr_AnonFunction1(((x$1$2$27) => {
    var x$1$30 = $as_Lscalacss_internal_ValueT(x$1$2$27);
    return $n(x$1$30)
  }));
  var bc$20 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$54);
  var r$25 = $n(ab$20).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$20);
  var v$80 = $n(r$25).apply__O__Lscalacss_internal_ValueT(f$55);
  var v$81 = $n(v$80).Lscalacss_internal_ValueT__f_value;
  var $$x284 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x285).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$825.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$81)));
  var $$x283 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$827 = $m_Lscalacss_internal_Attrs$boxSizing$();
  var array$79 = [$$x286, $$x284, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x283).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$827.Lscalacss_internal_Attrs$boxSizing$__f_attr, "border-box")))];
  var array$80 = [$$x296, $$x295, $$x293, $$x291, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x290).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x289).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x288, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$79), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_pdfViewerContainer = $n($$x300).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$80), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x311 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "pdfViewerAsImageContainer");
  var $$x310 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$837 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$82 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$83 = v$82.Lscalacss_internal_Literal__f_value;
  var $$x309 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x310).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$837.Lscalacss_internal_Attrs$overflow$__f_attr, v$83)));
  var $$x308 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x307 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x306 = new $c_sjsr_AnonFunction1(((x$16$2) => {
    var x$16$1 = $as_T(x$16$2);
    return (x$16$1 + ">IMG")
  }));
  var $$x305 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$846 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$19 = 100;
  var f$57 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$19);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$21 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$9) => {
    var x$4$11 = $as_Lscalacss_internal_Percentage(x$4$2$9);
    return $n(x$4$11).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$56 = new $c_sjsr_AnonFunction1(((x$1$2$28) => {
    var x$1$31 = $as_Lscalacss_internal_ValueT(x$1$2$28);
    return $n(x$1$31)
  }));
  var bc$21 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$56);
  var r$26 = $n(ab$21).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$21);
  var v$84 = $n(r$26).apply__O__Lscalacss_internal_ValueT(f$57);
  var v$85 = $n(v$84).Lscalacss_internal_ValueT__f_value;
  var $$x304 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x305).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$846.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$85)));
  var $$x303 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$848 = $m_Lscalacss_internal_Attrs$height$();
  var v$86 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$87 = v$86.Lscalacss_internal_Literal__f_value;
  var $$x302 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x303).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$848.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$87)));
  var $$x301 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$6 = $m_Lscalacss_internal_Attrs$().touchAction__Lscalacss_internal_Attr();
  var array$81 = [$$x304, $$x302, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x301).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$6, "auto")))];
  var array$82 = [$$x309, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x308).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x307).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x306, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$81), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_pdfViewerAsImageContainer = $n($$x311).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$82), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x315 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "pdfViewerAsImageTools");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$59 = this.Lreactbuild_Style$__f_flexRow;
  var $$x314 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$59).Lscalacss_internal_StyleA__f_style);
  var $$x313 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x312 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$7 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var array$83 = [$$x314, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x313).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x312).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$7, "space-evenly")))];
  this.Lreactbuild_Style$__f_pdfViewerAsImageTools = $n($$x315).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$83), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x320 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$875 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$20 = 100;
  var f$59 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$20);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$22 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$10) => {
    var x$4$12 = $as_Lscalacss_internal_Percentage(x$4$2$10);
    return $n(x$4$12).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$58 = new $c_sjsr_AnonFunction1(((x$1$2$29) => {
    var x$1$32 = $as_Lscalacss_internal_ValueT(x$1$2$29);
    return $n(x$1$32)
  }));
  var bc$22 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$58);
  var r$27 = $n(ab$22).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$22);
  var v$88 = $n(r$27).apply__O__Lscalacss_internal_ValueT(f$59);
  var v$89 = $n(v$88).Lscalacss_internal_ValueT__f_value;
  var $$x319 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x320).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$875.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$89)));
  var $$x318 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$884 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$21 = 100;
  var f$61 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$21);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$23 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$11) => {
    var x$4$13 = $as_Lscalacss_internal_Percentage(x$4$2$11);
    return $n(x$4$13).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$60 = new $c_sjsr_AnonFunction1(((x$1$2$30) => {
    var x$1$33 = $as_Lscalacss_internal_ValueT(x$1$2$30);
    return $n(x$1$33)
  }));
  var bc$23 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$60);
  var r$28 = $n(ab$23).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$23);
  var v$90 = $n(r$28).apply__O__Lscalacss_internal_ValueT(f$61);
  var v$91 = $n(v$90).Lscalacss_internal_ValueT__f_value;
  var $$x317 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x318).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$884.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$91)));
  var $$x316 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$886 = $m_Lscalacss_internal_Attrs$boxSizing$();
  var array$84 = [$$x319, $$x317, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x316).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$886.Lscalacss_internal_Attrs$boxSizing$__f_attr, "border-box")))];
  var t$14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$84);
  $m_Lreactbuild_package$CssSettings$();
  var c$8 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_fullArea = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$14, c$8);
  var $$x323 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "autoScrollAreaContainerWrapper");
  var $$x322 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$893 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$92 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$93 = v$92.Lscalacss_internal_Literal__f_value;
  var $$x321 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x322).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$893.Lscalacss_internal_Attrs$overflow$__f_attr, v$93)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$60 = this.Lreactbuild_Style$__f_fullArea;
  var array$85 = [$$x321, new $c_Lscalacss_internal_DslBase$ToStyle(x$60)];
  this.Lreactbuild_Style$__f_autoScrollAreaContainerWrapper = $n($$x323).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$85), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  this.Lreactbuild_Style$__f_autoScrollAreaContainer = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "autoScrollAreaContainer").apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($m_sci_Nil$(), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x340 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "scrollBlockContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x339 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$901 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x338 = $n($n($$x339).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$901.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$17$2) => {
    var x$17$1 = $as_Lscalacss_internal_Media$Query(x$17$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$17$1)
  }))));
  var $$x337 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$910 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$22 = 100;
  var f$63 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$22);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$24 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$12) => {
    var x$4$14 = $as_Lscalacss_internal_Percentage(x$4$2$12);
    return $n(x$4$14).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$62 = new $c_sjsr_AnonFunction1(((x$1$2$31) => {
    var x$1$34 = $as_Lscalacss_internal_ValueT(x$1$2$31);
    return $n(x$1$34)
  }));
  var bc$24 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$62);
  var r$29 = $n(ab$24).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$24);
  var v$94 = $n(r$29).apply__O__Lscalacss_internal_ValueT(f$63);
  var v$95 = $n(v$94).Lscalacss_internal_ValueT__f_value;
  var $$x336 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x337).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$910.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$95)));
  var $$x335 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$912 = $m_Lscalacss_internal_Attrs$overflowY$();
  var v$96 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$97 = v$96.Lscalacss_internal_Literal__f_value;
  var $$x334 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x335).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$912.Lscalacss_internal_Attrs$overflowY$__f_attr, v$97)));
  var $$x333 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$914 = $m_Lscalacss_internal_Attrs$scrollBehavior$();
  var $$x332 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x333).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$914.Lscalacss_internal_Attrs$scrollBehavior$__f_attr, "smooth")));
  var $$x331 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$8 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x330 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x331).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$8, "1")));
  var $$x329 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x328 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x327 = new $c_sjsr_AnonFunction1(((x$17$3$2) => {
    var x$17$3 = $as_T(x$17$3$2);
    return (x$17$3 + ">*")
  }));
  var $$x326 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$926 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$23 = 100;
  var f$65 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$23);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$25 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$13) => {
    var x$4$15 = $as_Lscalacss_internal_Percentage(x$4$2$13);
    return $n(x$4$15).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$64 = new $c_sjsr_AnonFunction1(((x$1$2$32) => {
    var x$1$35 = $as_Lscalacss_internal_ValueT(x$1$2$32);
    return $n(x$1$35)
  }));
  var bc$25 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$64);
  var r$30 = $n(ab$25).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$25);
  var v$98 = $n(r$30).apply__O__Lscalacss_internal_ValueT(f$65);
  var v$99 = $n(v$98).Lscalacss_internal_ValueT__f_value;
  var $$x325 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x326).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$926.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$99)));
  var $$x324 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$928 = $m_Lscalacss_internal_Attrs$boxSizing$();
  var array$86 = [$$x325, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x324).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$928.Lscalacss_internal_Attrs$boxSizing$__f_attr, "border-box")))];
  var array$87 = [$$x336, $$x334, $$x332, $$x330, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x329).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x328).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x327, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$86), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  var x$61 = $n($$x338).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$87), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$88 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$61)];
  this.Lreactbuild_Style$__f_scrollBlockContainer = $n($$x340).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$88), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x344 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "ribbonWrapper");
  var $$x343 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$951 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$24 = 24;
  var u$11 = $m_Lscalacss_internal_LengthUnit$pt$();
  var f$67 = new $c_Lscalacss_internal_Length(this$$24, u$11);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$26 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$11) => {
    var x$3$12 = $as_Lscalacss_internal_Length(x$3$2$11);
    return $n(x$3$12).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$66 = new $c_sjsr_AnonFunction1(((x$1$2$33) => {
    var x$1$36 = $as_Lscalacss_internal_ValueT(x$1$2$33);
    return $n(x$1$36)
  }));
  var bc$26 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$66);
  var r$31 = $n(ab$26).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$26);
  var v$100 = $n(r$31).apply__O__Lscalacss_internal_ValueT(f$67);
  var v$101 = $n(v$100).Lscalacss_internal_ValueT__f_value;
  var $$x342 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x343).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$951.Lscalacss_internal_Attrs$fontSize$__f_attr, v$101)));
  var $$x341 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$9 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$89 = [$$x342, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x341).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$9, "1")))];
  this.Lreactbuild_Style$__f_ribbonWrapper = $n($$x344).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$89), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x360 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "ribbon");
  var $$x359 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$10 = $m_Lscalacss_internal_Attrs$().transform__Lscalacss_internal_Attr();
  var $$x358 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x359).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$10, "rotate(-30deg) translate(-2cm, 0)")));
  var $$x357 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$971 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$25 = 8;
  var u$12 = $m_Lscalacss_internal_LengthUnit$cm$();
  var f$69 = new $c_Lscalacss_internal_Length(this$$25, u$12);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$27 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$12) => {
    var x$3$13 = $as_Lscalacss_internal_Length(x$3$2$12);
    return $n(x$3$13).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$68 = new $c_sjsr_AnonFunction1(((x$1$2$34) => {
    var x$1$37 = $as_Lscalacss_internal_ValueT(x$1$2$34);
    return $n(x$1$37)
  }));
  var bc$27 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$68);
  var r$32 = $n(ab$27).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$27);
  var v$102 = $n(r$32).apply__O__Lscalacss_internal_ValueT(f$69);
  var v$103 = $n(v$102).Lscalacss_internal_ValueT__f_value;
  var $$x356 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x357).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$971.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$103)));
  var $$x355 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$973 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x354 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x355).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$973.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "red")));
  var $$x353 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$975 = $m_Lscalacss_internal_Attrs$color$();
  var $$x352 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x353).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$975.Lscalacss_internal_Attrs$color$__f_attr, "white")));
  var $$x351 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$977 = $m_Lscalacss_internal_Attrs$textAlign$();
  var $$x350 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x351).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$977.Lscalacss_internal_Attrs$textAlign$__f_attr, "center")));
  var $$x349 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$979 = $m_Lscalacss_internal_Attrs$display$();
  var $$x348 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x349).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$979.Lscalacss_internal_Attrs$display$__f_attr, "inline-block")));
  var $$x347 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$11 = $m_Lscalacss_internal_Attrs$().textShadow__Lscalacss_internal_Attr();
  var $$x346 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x347).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$11, "1pt 1pt 3pt white")));
  var $$x345 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$12 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var array$90 = [$$x358, $$x356, $$x354, $$x352, $$x350, $$x348, $$x346, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x345).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$12, "0pt 0pt 4pt 2pt white")))];
  this.Lreactbuild_Style$__f_ribbon = $n($$x360).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$90), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x378 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "documentPaperPageContent");
  var $$x377 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$999 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$26 = 0;
  var u$13 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$71 = new $c_Lscalacss_internal_Length(this$$26, u$13);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$28 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$13) => {
    var x$3$14 = $as_Lscalacss_internal_Length(x$3$2$13);
    return $n(x$3$14).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$70 = new $c_sjsr_AnonFunction1(((x$1$2$35) => {
    var x$1$38 = $as_Lscalacss_internal_ValueT(x$1$2$35);
    return $n(x$1$38)
  }));
  var bc$28 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$70);
  var r$33 = $n(ab$28).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$28);
  var v$104 = $n(r$33).apply__O__Lscalacss_internal_ValueT(f$71);
  var v$105 = $n(v$104).Lscalacss_internal_ValueT__f_value;
  var $$x376 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x377).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$999.Lscalacss_internal_Attrs$top$__f_attr, v$105)));
  var $$x375 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1009 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$27 = 0;
  var u$14 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$73 = new $c_Lscalacss_internal_Length(this$$27, u$14);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$29 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$14) => {
    var x$3$15 = $as_Lscalacss_internal_Length(x$3$2$14);
    return $n(x$3$15).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$72 = new $c_sjsr_AnonFunction1(((x$1$2$36) => {
    var x$1$39 = $as_Lscalacss_internal_ValueT(x$1$2$36);
    return $n(x$1$39)
  }));
  var bc$29 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$72);
  var r$34 = $n(ab$29).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$29);
  var v$106 = $n(r$34).apply__O__Lscalacss_internal_ValueT(f$73);
  var v$107 = $n(v$106).Lscalacss_internal_ValueT__f_value;
  var $$x374 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x375).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1009.Lscalacss_internal_Attrs$left$__f_attr, v$107)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x373 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1011 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x372 = $n($n($$x373).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1011.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$18$2) => {
    var x$18$1 = $as_Lscalacss_internal_Media$Query(x$18$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$18$1)
  }))));
  var $$x371 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1020 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$28 = 100;
  var f$75 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$28);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$30 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$14) => {
    var x$4$16 = $as_Lscalacss_internal_Percentage(x$4$2$14);
    return $n(x$4$16).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$74 = new $c_sjsr_AnonFunction1(((x$1$2$37) => {
    var x$1$40 = $as_Lscalacss_internal_ValueT(x$1$2$37);
    return $n(x$1$40)
  }));
  var bc$30 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$74);
  var r$35 = $n(ab$30).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$30);
  var v$108 = $n(r$35).apply__O__Lscalacss_internal_ValueT(f$75);
  var v$109 = $n(v$108).Lscalacss_internal_ValueT__f_value;
  var $$x370 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x371).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1020.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$109)));
  var $$x369 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1029 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$29 = 100;
  var f$77 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$29);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$31 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$15) => {
    var x$4$17 = $as_Lscalacss_internal_Percentage(x$4$2$15);
    return $n(x$4$17).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$76 = new $c_sjsr_AnonFunction1(((x$1$2$38) => {
    var x$1$41 = $as_Lscalacss_internal_ValueT(x$1$2$38);
    return $n(x$1$41)
  }));
  var bc$31 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$76);
  var r$36 = $n(ab$31).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$31);
  var v$110 = $n(r$36).apply__O__Lscalacss_internal_ValueT(f$77);
  var v$111 = $n(v$110).Lscalacss_internal_ValueT__f_value;
  var array$91 = [$$x370, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x369).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1029.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$111)))];
  var x$62 = $n($$x372).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$91), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x368 = new $c_Lscalacss_internal_DslBase$ToStyle(x$62);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x367 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1036 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x366 = $n($n($$x367).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1036.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$19$2) => {
    var x$19$1 = $as_Lscalacss_internal_Media$Query(x$19$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$19$1)
  }))));
  var $$x365 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1046 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$30 = 100;
  var u$15 = $m_Lscalacss_internal_LengthUnit$vw$();
  var f$79 = new $c_Lscalacss_internal_Length(this$$30, u$15);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$32 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$15) => {
    var x$3$16 = $as_Lscalacss_internal_Length(x$3$2$15);
    return $n(x$3$16).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$78 = new $c_sjsr_AnonFunction1(((x$1$2$39) => {
    var x$1$42 = $as_Lscalacss_internal_ValueT(x$1$2$39);
    return $n(x$1$42)
  }));
  var bc$32 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$78);
  var r$37 = $n(ab$32).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$32);
  var v$112 = $n(r$37).apply__O__Lscalacss_internal_ValueT(f$79);
  var v$113 = $n(v$112).Lscalacss_internal_ValueT__f_value;
  var $$x364 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x365).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1046.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$113)));
  var $$x363 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1056 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$31 = 100;
  var u$16 = $m_Lscalacss_internal_LengthUnit$vh$();
  var f$81 = new $c_Lscalacss_internal_Length(this$$31, u$16);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$33 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$16) => {
    var x$3$17 = $as_Lscalacss_internal_Length(x$3$2$16);
    return $n(x$3$17).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$80 = new $c_sjsr_AnonFunction1(((x$1$2$40) => {
    var x$1$43 = $as_Lscalacss_internal_ValueT(x$1$2$40);
    return $n(x$1$43)
  }));
  var bc$33 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$80);
  var r$38 = $n(ab$33).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$33);
  var v$114 = $n(r$38).apply__O__Lscalacss_internal_ValueT(f$81);
  var v$115 = $n(v$114).Lscalacss_internal_ValueT__f_value;
  var array$92 = [$$x364, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x363).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1056.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$115)))];
  var x$63 = $n($$x366).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$92), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x362 = new $c_Lscalacss_internal_DslBase$ToStyle(x$63);
  var $$x361 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1063 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$116 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$117 = v$116.Lscalacss_internal_Literal__f_value;
  var array$93 = [$$x376, $$x374, $$x368, $$x362, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x361).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1063.Lscalacss_internal_Attrs$overflow$__f_attr, v$117)))];
  this.Lreactbuild_Style$__f_documentPaperPageContent = $n($$x378).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$93), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x381 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1069 = $m_Lscalacss_internal_Attrs$margin$();
  var $$x380 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x381).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1069.Lscalacss_internal_Attrs$margin$__f_attr, "0")));
  var $$x379 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1077 = $m_Lscalacss_internal_Attrs$lineHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$34 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$7$2$1) => {
    var x$7$4 = $uD(x$7$2$1);
    return ("" + x$7$4)
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$82 = new $c_sjsr_AnonFunction1(((x$1$2$41) => {
    var x$1$44 = $as_Lscalacss_internal_ValueT(x$1$2$41);
    return $n(x$1$44)
  }));
  var bc$34 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$82);
  var r$39 = $n(ab$34).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$34);
  var v$118 = $n(r$39).apply__O__Lscalacss_internal_ValueT(1.5);
  var v$119 = $n(v$118).Lscalacss_internal_ValueT__f_value;
  var array$94 = [$$x380, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x379).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1077.Lscalacss_internal_Attrs$lineHeight$__f_attr, v$119)))];
  var t$15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$94);
  $m_Lreactbuild_package$CssSettings$();
  var c$9 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_paperMainTitleMixin = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$15, c$9);
  var $$x384 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperMainTitle1");
  var $$x383 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1091 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$32 = 350;
  var f$84 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$32);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$35 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$16) => {
    var x$4$18 = $as_Lscalacss_internal_Percentage(x$4$2$16);
    return $n(x$4$18).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$83 = new $c_sjsr_AnonFunction1(((x$1$2$42) => {
    var x$1$45 = $as_Lscalacss_internal_ValueT(x$1$2$42);
    return $n(x$1$45)
  }));
  var bc$35 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$83);
  var r$40 = $n(ab$35).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$35);
  var v$120 = $n(r$40).apply__O__Lscalacss_internal_ValueT(f$84);
  var v$121 = $n(v$120).Lscalacss_internal_ValueT__f_value;
  var $$x382 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x383).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1091.Lscalacss_internal_Attrs$fontSize$__f_attr, v$121)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$64 = this.Lreactbuild_Style$__f_paperMainTitleMixin;
  var array$95 = [$$x382, new $c_Lscalacss_internal_DslBase$ToStyle(x$64)];
  this.Lreactbuild_Style$__f_paperMainTitle1 = $n($$x384).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$95), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x389 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperMainTitle2");
  var $$x388 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1105 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$33 = 240;
  var f$86 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$33);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$36 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$17) => {
    var x$4$19 = $as_Lscalacss_internal_Percentage(x$4$2$17);
    return $n(x$4$19).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$85 = new $c_sjsr_AnonFunction1(((x$1$2$43) => {
    var x$1$46 = $as_Lscalacss_internal_ValueT(x$1$2$43);
    return $n(x$1$46)
  }));
  var bc$36 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$85);
  var r$41 = $n(ab$36).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$36);
  var v$122 = $n(r$41).apply__O__Lscalacss_internal_ValueT(f$86);
  var v$123 = $n(v$122).Lscalacss_internal_ValueT__f_value;
  var $$x387 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x388).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1105.Lscalacss_internal_Attrs$fontSize$__f_attr, v$123)));
  var $$x386 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1108 = $m_Lscalacss_internal_Attrs$color$();
  var v$124 = new $c_Lscalacss_internal_ValueT("#555");
  var v$125 = v$124.Lscalacss_internal_ValueT__f_value;
  var $$x385 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x386).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1108.Lscalacss_internal_Attrs$color$__f_attr, v$125)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$65 = this.Lreactbuild_Style$__f_paperMainTitleMixin;
  var array$96 = [$$x387, $$x385, new $c_Lscalacss_internal_DslBase$ToStyle(x$65)];
  this.Lreactbuild_Style$__f_paperMainTitle2 = $n($$x389).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$96), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x394 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperMainTitle3");
  var $$x393 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1122 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$34 = 130;
  var f$88 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$34);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$37 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$18) => {
    var x$4$20 = $as_Lscalacss_internal_Percentage(x$4$2$18);
    return $n(x$4$20).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$87 = new $c_sjsr_AnonFunction1(((x$1$2$44) => {
    var x$1$47 = $as_Lscalacss_internal_ValueT(x$1$2$44);
    return $n(x$1$47)
  }));
  var bc$37 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$87);
  var r$42 = $n(ab$37).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$37);
  var v$126 = $n(r$42).apply__O__Lscalacss_internal_ValueT(f$88);
  var v$127 = $n(v$126).Lscalacss_internal_ValueT__f_value;
  var $$x392 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x393).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1122.Lscalacss_internal_Attrs$fontSize$__f_attr, v$127)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$66 = this.Lreactbuild_Style$__f_paperMainTitleMixin;
  var $$x391 = new $c_Lscalacss_internal_DslBase$ToStyle(x$66);
  var $$x390 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1133 = $m_Lscalacss_internal_Attrs$marginTop$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$35 = 1;
  var u$17 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$90 = new $c_Lscalacss_internal_Length(this$$35, u$17);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$38 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$17) => {
    var x$3$18 = $as_Lscalacss_internal_Length(x$3$2$17);
    return $n(x$3$18).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$89 = new $c_sjsr_AnonFunction1(((x$1$2$45) => {
    var x$1$48 = $as_Lscalacss_internal_ValueT(x$1$2$45);
    return $n(x$1$48)
  }));
  var bc$38 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$89);
  var r$43 = $n(ab$38).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$38);
  var v$128 = $n(r$43).apply__O__Lscalacss_internal_ValueT(f$90);
  var v$129 = $n(v$128).Lscalacss_internal_ValueT__f_value;
  var array$97 = [$$x392, $$x391, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x390).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1133.Lscalacss_internal_Attrs$marginTop$__f_attr, v$129)))];
  this.Lreactbuild_Style$__f_paperMainTitle3 = $n($$x394).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$97), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x396 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperTitle");
  var $$x395 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1146 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$36 = 170;
  var f$92 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$36);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$39 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$19) => {
    var x$4$21 = $as_Lscalacss_internal_Percentage(x$4$2$19);
    return $n(x$4$21).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$91 = new $c_sjsr_AnonFunction1(((x$1$2$46) => {
    var x$1$49 = $as_Lscalacss_internal_ValueT(x$1$2$46);
    return $n(x$1$49)
  }));
  var bc$39 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$91);
  var r$44 = $n(ab$39).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$39);
  var v$130 = $n(r$44).apply__O__Lscalacss_internal_ValueT(f$92);
  var v$131 = $n(v$130).Lscalacss_internal_ValueT__f_value;
  var array$98 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x395).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1146.Lscalacss_internal_Attrs$fontSize$__f_attr, v$131)))];
  this.Lreactbuild_Style$__f_paperTitle = $n($$x396).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$98), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x398 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperDescription");
  var $$x397 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1159 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$37 = 80;
  var f$94 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$37);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$40 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$20) => {
    var x$4$22 = $as_Lscalacss_internal_Percentage(x$4$2$20);
    return $n(x$4$22).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$93 = new $c_sjsr_AnonFunction1(((x$1$2$47) => {
    var x$1$50 = $as_Lscalacss_internal_ValueT(x$1$2$47);
    return $n(x$1$50)
  }));
  var bc$40 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$93);
  var r$45 = $n(ab$40).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$40);
  var v$132 = $n(r$45).apply__O__Lscalacss_internal_ValueT(f$94);
  var v$133 = $n(v$132).Lscalacss_internal_ValueT__f_value;
  var array$99 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x397).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1159.Lscalacss_internal_Attrs$fontSize$__f_attr, v$133)))];
  this.Lreactbuild_Style$__f_paperDescription = $n($$x398).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$99), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x431 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "documentPaperPage");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x430 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1165 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x429 = $n($n($$x430).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1165.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$20$2) => {
    var x$20$1 = $as_Lscalacss_internal_Media$Query(x$20$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$20$1)
  }))));
  var $$x428 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$13 = $m_Lscalacss_internal_Attrs$width$();
  var $$x427 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x428).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$13.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "var(--paper-width)")));
  var $$x426 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$14 = $m_Lscalacss_internal_Attrs$height$();
  var $$x425 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x426).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$14.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "var(--paper-height)")));
  var $$x424 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$15 = $m_Lcom_iz2use_react_style_package$().zoom__Lcom_iz2use_react_style_ExtendedStyles$zoom$();
  var $$x423 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x424).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV($n(a$15).Lcom_iz2use_react_style_ExtendedStyles$zoom$__f_attr, "var(--paper-zoom)")));
  var $$x422 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1178 = $m_Lscalacss_internal_Attrs$display$();
  var $$x421 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x422).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1178.Lscalacss_internal_Attrs$display$__f_attr, "inline-block")));
  var $$x420 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1188 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$38 = 4;
  var u$18 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$96 = new $c_Lscalacss_internal_Length(this$$38, u$18);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$41 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$18) => {
    var x$3$19 = $as_Lscalacss_internal_Length(x$3$2$18);
    return $n(x$3$19).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$95 = new $c_sjsr_AnonFunction1(((x$1$2$48) => {
    var x$1$51 = $as_Lscalacss_internal_ValueT(x$1$2$48);
    return $n(x$1$51)
  }));
  var bc$41 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$95);
  var r$46 = $n(ab$41).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$41);
  var all$2 = $n(r$46).apply__O__Lscalacss_internal_ValueT(f$96);
  var v$134 = $n(all$2).Lscalacss_internal_ValueT__f_value;
  var $$x419 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x420).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1188.Lscalacss_internal_Attrs$margin$__f_attr, v$134)));
  var $$x418 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$16 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var $$x417 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x418).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$16, "1em 1em 2em #555")));
  var $$x416 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1193 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x415 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x416).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1193.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "white")));
  var $$x414 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1195 = $m_Lscalacss_internal_Attrs$color$();
  var array$100 = [$$x427, $$x425, $$x423, $$x421, $$x419, $$x417, $$x415, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x414).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1195.Lscalacss_internal_Attrs$color$__f_attr, "black")))];
  var x$67 = $n($$x429).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$100), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x413 = new $c_Lscalacss_internal_DslBase$ToStyle(x$67);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x412 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1202 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x411 = $n($n($$x412).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1202.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$21$2) => {
    var x$21$1 = $as_Lscalacss_internal_Media$Query(x$21$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$21$1)
  }))));
  var $$x410 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1211 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$39 = 100;
  var f$98 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$39);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$42 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$21) => {
    var x$4$23 = $as_Lscalacss_internal_Percentage(x$4$2$21);
    return $n(x$4$23).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$97 = new $c_sjsr_AnonFunction1(((x$1$2$49) => {
    var x$1$52 = $as_Lscalacss_internal_ValueT(x$1$2$49);
    return $n(x$1$52)
  }));
  var bc$42 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$97);
  var r$47 = $n(ab$42).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$42);
  var v$135 = $n(r$47).apply__O__Lscalacss_internal_ValueT(f$98);
  var v$136 = $n(v$135).Lscalacss_internal_ValueT__f_value;
  var $$x409 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x410).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1211.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$136)));
  var $$x408 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1220 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$40 = 100;
  var f$100 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$40);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$43 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$22) => {
    var x$4$24 = $as_Lscalacss_internal_Percentage(x$4$2$22);
    return $n(x$4$24).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$99 = new $c_sjsr_AnonFunction1(((x$1$2$50) => {
    var x$1$53 = $as_Lscalacss_internal_ValueT(x$1$2$50);
    return $n(x$1$53)
  }));
  var bc$43 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$99);
  var r$48 = $n(ab$43).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$43);
  var v$137 = $n(r$48).apply__O__Lscalacss_internal_ValueT(f$100);
  var v$138 = $n(v$137).Lscalacss_internal_ValueT__f_value;
  var array$101 = [$$x409, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x408).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1220.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$138)))];
  var x$68 = $n($$x411).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$101), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x407 = new $c_Lscalacss_internal_DslBase$ToStyle(x$68);
  var $$x406 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1227 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$139 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$140 = v$139.Lscalacss_internal_Literal__f_value;
  var $$x405 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x406).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1227.Lscalacss_internal_Attrs$overflow$__f_attr, v$140)));
  var $$x404 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1229 = $m_Lscalacss_internal_Attrs$pageBreakInside$();
  var $$x403 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x404).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1229.Lscalacss_internal_Attrs$pageBreakInside$__f_attr, "avoid")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x402 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$1230 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p$1 = $m_Lscalacss_internal_Pseudo$FirstChild$();
  var $$x401 = this$1230.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p$1);
  var this$1232 = $m_s_$less$colon$less$();
  var $$x400 = $n($n($$x402).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x401, this$1232.s_$less$colon$less$__f_singleton));
  var $$x399 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1234 = $m_Lscalacss_internal_Attrs$pageBreakBefore$();
  var array$102 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x399).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1234.Lscalacss_internal_Attrs$pageBreakBefore$__f_attr, "avoid")))];
  var x$69 = $n($$x400).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$102), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$103 = [$$x413, $$x407, $$x405, $$x403, new $c_Lscalacss_internal_DslBase$ToStyle(x$69)];
  this.Lreactbuild_Style$__f_documentPaperPage = $n($$x431).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$103), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x432 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperFullPart");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$70 = this.Lreactbuild_Style$__f_full;
  var array$104 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$70).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_paperFullPart = $n($$x432).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$104), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x438 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperEmptyRow");
  var $$x437 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1258 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$41 = 0.5;
  var u$19 = $m_Lscalacss_internal_LengthUnit$cm$();
  var f$102 = new $c_Lscalacss_internal_Length(this$$41, u$19);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$44 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$19) => {
    var x$3$20 = $as_Lscalacss_internal_Length(x$3$2$19);
    return $n(x$3$20).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$101 = new $c_sjsr_AnonFunction1(((x$1$2$51) => {
    var x$1$54 = $as_Lscalacss_internal_ValueT(x$1$2$51);
    return $n(x$1$54)
  }));
  var bc$44 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$101);
  var r$49 = $n(ab$44).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$44);
  var v$141 = $n(r$49).apply__O__Lscalacss_internal_ValueT(f$102);
  var v$142 = $n(v$141).Lscalacss_internal_ValueT__f_value;
  var $$x436 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x437).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1258.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$142)));
  var $$x435 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1260 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$143 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$144 = v$143.Lscalacss_internal_Literal__f_value;
  var $$x434 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x435).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1260.Lscalacss_internal_Attrs$overflow$__f_attr, v$144)));
  var $$x433 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1270 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$42 = 1;
  var u$20 = $m_Lscalacss_internal_LengthUnit$pt$();
  var f$104 = new $c_Lscalacss_internal_Length(this$$42, u$20);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$45 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$20) => {
    var x$3$21 = $as_Lscalacss_internal_Length(x$3$2$20);
    return $n(x$3$21).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$103 = new $c_sjsr_AnonFunction1(((x$1$2$52) => {
    var x$1$55 = $as_Lscalacss_internal_ValueT(x$1$2$52);
    return $n(x$1$55)
  }));
  var bc$45 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$103);
  var r$50 = $n(ab$45).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$45);
  var v$145 = $n(r$50).apply__O__Lscalacss_internal_ValueT(f$104);
  var v$146 = $n(v$145).Lscalacss_internal_ValueT__f_value;
  var array$105 = [$$x436, $$x434, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x433).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1270.Lscalacss_internal_Attrs$fontSize$__f_attr, v$146)))];
  this.Lreactbuild_Style$__f_paperEmptyRow = $n($$x438).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$105), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x444 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperEmptyCol");
  var $$x443 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1284 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$43 = 0.5;
  var u$21 = $m_Lscalacss_internal_LengthUnit$cm$();
  var f$106 = new $c_Lscalacss_internal_Length(this$$43, u$21);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$46 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$21) => {
    var x$3$22 = $as_Lscalacss_internal_Length(x$3$2$21);
    return $n(x$3$22).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$105 = new $c_sjsr_AnonFunction1(((x$1$2$53) => {
    var x$1$56 = $as_Lscalacss_internal_ValueT(x$1$2$53);
    return $n(x$1$56)
  }));
  var bc$46 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$105);
  var r$51 = $n(ab$46).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$46);
  var v$147 = $n(r$51).apply__O__Lscalacss_internal_ValueT(f$106);
  var v$148 = $n(v$147).Lscalacss_internal_ValueT__f_value;
  var $$x442 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x443).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1284.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$148)));
  var $$x441 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1286 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$149 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$150 = v$149.Lscalacss_internal_Literal__f_value;
  var $$x440 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x441).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1286.Lscalacss_internal_Attrs$overflow$__f_attr, v$150)));
  var $$x439 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1296 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$44 = 1;
  var u$22 = $m_Lscalacss_internal_LengthUnit$pt$();
  var f$108 = new $c_Lscalacss_internal_Length(this$$44, u$22);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$47 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$22) => {
    var x$3$23 = $as_Lscalacss_internal_Length(x$3$2$22);
    return $n(x$3$23).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$107 = new $c_sjsr_AnonFunction1(((x$1$2$54) => {
    var x$1$57 = $as_Lscalacss_internal_ValueT(x$1$2$54);
    return $n(x$1$57)
  }));
  var bc$47 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$107);
  var r$52 = $n(ab$47).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$47);
  var v$151 = $n(r$52).apply__O__Lscalacss_internal_ValueT(f$108);
  var v$152 = $n(v$151).Lscalacss_internal_ValueT__f_value;
  var array$106 = [$$x442, $$x440, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x439).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1296.Lscalacss_internal_Attrs$fontSize$__f_attr, v$152)))];
  this.Lreactbuild_Style$__f_paperEmptyCol = $n($$x444).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$106), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x446 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperRow");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$71 = this.Lreactbuild_Style$__f_flexRow;
  var $$x445 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$71).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$72 = this.Lreactbuild_Style$__f_full;
  var array$107 = [$$x445, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$72).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_paperRow = $n($$x446).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$107), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x448 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperCol");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$73 = this.Lreactbuild_Style$__f_flexColumn;
  var $$x447 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$73).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$74 = this.Lreactbuild_Style$__f_full;
  var array$108 = [$$x447, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$74).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_paperCol = $n($$x448).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$108), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x450 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperImage");
  var $$x449 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1314 = $m_Lscalacss_internal_Attrs$objectFit$();
  var array$109 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x449).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1314.Lscalacss_internal_Attrs$objectFit$__f_attr, "cover")))];
  $n($$x450).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$109), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x459 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "paperImageContainer");
  var $$x458 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x457 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x456 = new $c_sjsr_AnonFunction1(((x$18$3$2) => {
    var x$18$3 = $as_T(x$18$3$2);
    return (x$18$3 + ">img")
  }));
  var $$x455 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1327 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$45 = 100;
  var f$110 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$45);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$48 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$23) => {
    var x$4$25 = $as_Lscalacss_internal_Percentage(x$4$2$23);
    return $n(x$4$25).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$109 = new $c_sjsr_AnonFunction1(((x$1$2$55) => {
    var x$1$58 = $as_Lscalacss_internal_ValueT(x$1$2$55);
    return $n(x$1$58)
  }));
  var bc$48 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$109);
  var r$53 = $n(ab$48).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$48);
  var v$153 = $n(r$53).apply__O__Lscalacss_internal_ValueT(f$110);
  var v$154 = $n(v$153).Lscalacss_internal_ValueT__f_value;
  var $$x454 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x455).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1327.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$154)));
  var $$x453 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1336 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$46 = 100;
  var f$112 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$46);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$49 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$24) => {
    var x$4$26 = $as_Lscalacss_internal_Percentage(x$4$2$24);
    return $n(x$4$26).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$111 = new $c_sjsr_AnonFunction1(((x$1$2$56) => {
    var x$1$59 = $as_Lscalacss_internal_ValueT(x$1$2$56);
    return $n(x$1$59)
  }));
  var bc$49 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$111);
  var r$54 = $n(ab$49).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$49);
  var v$155 = $n(r$54).apply__O__Lscalacss_internal_ValueT(f$112);
  var v$156 = $n(v$155).Lscalacss_internal_ValueT__f_value;
  var $$x452 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x453).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1336.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$156)));
  var $$x451 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1338 = $m_Lscalacss_internal_Attrs$objectFit$();
  var array$110 = [$$x454, $$x452, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x451).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1338.Lscalacss_internal_Attrs$objectFit$__f_attr, "cover")))];
  var array$111 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x458).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x457).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x456, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$110), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_paperImageContainer = $n($$x459).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$111), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$47 = 2;
  var u$23 = $m_Lscalacss_internal_LengthUnit$pt$();
  this.Lreactbuild_Style$__f_areaLargerBorder = new $c_Lscalacss_internal_Length(this$$47, u$23);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x463 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x462 = $m_Lscalacss_internal_Attrs$border$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$48 = 1;
  var u$24 = $m_Lscalacss_internal_LengthUnit$pt$();
  var f$114 = new $c_Lscalacss_internal_Length(this$$48, u$24);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$50 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$23) => {
    var x$3$24 = $as_Lscalacss_internal_Length(x$3$2$23);
    return $n(x$3$24).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$113 = new $c_sjsr_AnonFunction1(((x$1$2$57) => {
    var x$1$60 = $as_Lscalacss_internal_ValueT(x$1$2$57);
    return $n(x$1$60)
  }));
  var bc$50 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$113);
  var r$55 = $n(ab$50).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$50);
  var $$x461 = $n(r$55).apply__O__Lscalacss_internal_ValueT(f$114);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$116 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1361 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$51 = this$1361.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$8) => {
    var x$2$10 = $as_Lscalacss_internal_Literal(x$2$2$8);
    return $n(x$2$10).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$115 = new $c_sjsr_AnonFunction1(((x$1$2$58) => {
    var x$1$61 = $as_Lscalacss_internal_ValueT(x$1$2$58);
    return $n(x$1$61)
  }));
  var bc$51 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$115);
  var r$56 = $n(ab$51).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$51);
  var $$x460 = $n(r$56).apply__O__Lscalacss_internal_ValueT(f$116);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$118 = new $c_Lscalacss_internal_ValueT("#ccc");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$117 = new $c_sjsr_AnonFunction1(((x$1$2$59) => {
    var x$1$62 = $as_Lscalacss_internal_ValueT(x$1$2$59);
    return $n(x$1$62)
  }));
  var r$57 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$117);
  var array$112 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x463).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x462.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x461, $$x460, r$57.apply__O__Lscalacss_internal_ValueT(f$118))))];
  var t$16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$112);
  $m_Lreactbuild_package$CssSettings$();
  var c$10 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_defaultTableBorder = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$16, c$10);
  var $$x464 = $m_s_package$().s_package$__f_Seq;
  var array$113 = ["THEAD", "TBODY", "TFOOT"];
  this.Lreactbuild_Style$__f_tableElements = $as_sci_Seq($n($n($$x464).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$113))).flatMap__F1__O(new $c_sjsr_AnonFunction1(((sec$2) => {
    var sec = $as_T(sec$2);
    var rassoc$1 = (sec + ">TR");
    var $$x465 = $m_s_package$().s_package$__f_Seq;
    var array$114 = ["TD", "TH"];
    var this$1381 = $n($as_sc_SeqOps($n($n($$x465).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$114))).map__F1__O(new $c_sjsr_AnonFunction1(((part$2) => {
      var part = $as_T(part$2);
      return ((sec + ">TR>") + part)
    })))));
    var this$1382 = $n($as_sc_SeqOps(this$1381.prepended__O__O(rassoc$1)));
    return $as_sci_Seq(this$1382.prepended__O__O(sec))
  }))));
  var $$x469 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "fullBorderTable");
  var $$x468 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x467 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x466 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p$3 = $as_T(p$2);
    var this$1383 = $n($as_sc_SeqOps($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_tableElements).map__F1__O(new $c_sjsr_AnonFunction1(((e$2) => {
      var e = $as_T(e$2);
      return ((p$3 + ">") + e)
    })))));
    var this$1384 = $n($as_sc_IterableOnceOps(this$1383.prepended__O__O(p$3)));
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1384, "", ",", "")
  }));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$75 = this.Lreactbuild_Style$__f_defaultTableBorder;
  var array$115 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$75)];
  var array$116 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x468).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x467).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x466, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$115), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_fullBorderTable = $n($$x469).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$116), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x479 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "areaMixin");
  var $$x478 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x477 = $m_Lscalacss_internal_Attrs$border$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$49 = 1;
  var u$25 = $m_Lscalacss_internal_LengthUnit$pt$();
  var f$120 = new $c_Lscalacss_internal_Length(this$$49, u$25);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$52 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$24) => {
    var x$3$25 = $as_Lscalacss_internal_Length(x$3$2$24);
    return $n(x$3$25).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$119 = new $c_sjsr_AnonFunction1(((x$1$2$60) => {
    var x$1$63 = $as_Lscalacss_internal_ValueT(x$1$2$60);
    return $n(x$1$63)
  }));
  var bc$52 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$119);
  var r$58 = $n(ab$52).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$52);
  var $$x476 = $n(r$58).apply__O__Lscalacss_internal_ValueT(f$120);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$122 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1405 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$53 = this$1405.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$9) => {
    var x$2$11 = $as_Lscalacss_internal_Literal(x$2$2$9);
    return $n(x$2$11).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$121 = new $c_sjsr_AnonFunction1(((x$1$2$61) => {
    var x$1$64 = $as_Lscalacss_internal_ValueT(x$1$2$61);
    return $n(x$1$64)
  }));
  var bc$53 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$121);
  var r$59 = $n(ab$53).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$53);
  var $$x475 = $n(r$59).apply__O__Lscalacss_internal_ValueT(f$122);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$124 = new $c_Lscalacss_internal_ValueT("black");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$123 = new $c_sjsr_AnonFunction1(((x$1$2$62) => {
    var x$1$65 = $as_Lscalacss_internal_ValueT(x$1$2$62);
    return $n(x$1$65)
  }));
  var r$60 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$123);
  var $$x474 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x478).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x477.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x476, $$x475, r$60.apply__O__Lscalacss_internal_ValueT(f$124))));
  var $$x473 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1416 = $m_Lscalacss_internal_Attrs$borderLeft$();
  var $$x472 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x473).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1416.Lscalacss_internal_Attrs$borderLeft$__f_attr, "0")));
  var $$x471 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1418 = $m_Lscalacss_internal_Attrs$borderRight$();
  var $$x470 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x471).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1418.Lscalacss_internal_Attrs$borderRight$__f_attr, "0")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$76 = this.Lreactbuild_Style$__f_withLittlePadding;
  var array$117 = [$$x474, $$x472, $$x470, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$76).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_areaMixin = $n($$x479).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$117), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x493 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "areaTable");
  var $$x492 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1425 = $m_Lscalacss_internal_Attrs$borderCollapse$();
  var $$x491 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x492).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1425.Lscalacss_internal_Attrs$borderCollapse$__f_attr, "collapse")));
  var $$x490 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1427 = $m_Lscalacss_internal_Attrs$display$();
  var $$x489 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x490).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1427.Lscalacss_internal_Attrs$display$__f_attr, "inline-table")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$77 = this.Lreactbuild_Style$__f_areaMixin;
  var $$x488 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$77).Lscalacss_internal_StyleA__f_style);
  var $$x487 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x486 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$78 = this.Lreactbuild_Style$__f_areaMixin;
  var $$x485 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$78).Lscalacss_internal_StyleA__f_style);
  var $$x484 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1436 = $m_Lscalacss_internal_Attrs$borderBottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$126 = this.Lreactbuild_Style$__f_areaLargerBorder;
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$54 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$25) => {
    var x$3$26 = $as_Lscalacss_internal_Length(x$3$2$25);
    return $n(x$3$26).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$125 = new $c_sjsr_AnonFunction1(((x$1$2$63) => {
    var x$1$66 = $as_Lscalacss_internal_ValueT(x$1$2$63);
    return $n(x$1$66)
  }));
  var bc$54 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$125);
  var r$61 = $n(ab$54).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$54);
  var a$17 = $n(r$61).apply__O__Lscalacss_internal_ValueT(f$126);
  var v$157 = $n(a$17).Lscalacss_internal_ValueT__f_value;
  var array$118 = [$$x485, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x484).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1436.Lscalacss_internal_Attrs$borderBottom$__f_attr, v$157)))];
  var $$x483 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x487).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x486).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(">THEAD>TR>TH", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$118), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x482 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1447 = $m_Lscalacss_internal_Attrs$borderTop$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$128 = this.Lreactbuild_Style$__f_areaLargerBorder;
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$55 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$26) => {
    var x$3$27 = $as_Lscalacss_internal_Length(x$3$2$26);
    return $n(x$3$27).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$127 = new $c_sjsr_AnonFunction1(((x$1$2$64) => {
    var x$1$67 = $as_Lscalacss_internal_ValueT(x$1$2$64);
    return $n(x$1$67)
  }));
  var bc$55 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$127);
  var r$62 = $n(ab$55).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$55);
  var a$18 = $n(r$62).apply__O__Lscalacss_internal_ValueT(f$128);
  var v$158 = $n(a$18).Lscalacss_internal_ValueT__f_value;
  var $$x481 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x482).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1447.Lscalacss_internal_Attrs$borderTop$__f_attr, v$158)));
  var $$x480 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1454 = $m_Lscalacss_internal_Attrs$borderBottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$130 = this.Lreactbuild_Style$__f_areaLargerBorder;
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$56 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$27) => {
    var x$3$28 = $as_Lscalacss_internal_Length(x$3$2$27);
    return $n(x$3$28).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$129 = new $c_sjsr_AnonFunction1(((x$1$2$65) => {
    var x$1$68 = $as_Lscalacss_internal_ValueT(x$1$2$65);
    return $n(x$1$68)
  }));
  var bc$56 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$129);
  var r$63 = $n(ab$56).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$56);
  var a$19 = $n(r$63).apply__O__Lscalacss_internal_ValueT(f$130);
  var v$159 = $n(a$19).Lscalacss_internal_ValueT__f_value;
  var array$119 = [$$x491, $$x489, $$x488, $$x483, $$x481, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x480).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1454.Lscalacss_internal_Attrs$borderBottom$__f_attr, v$159)))];
  this.Lreactbuild_Style$__f_areaTable = $n($$x493).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$119), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x498 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "areaLabel");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$79 = this.Lreactbuild_Style$__f_areaMixin;
  var $$x497 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$79).Lscalacss_internal_StyleA__f_style);
  var $$x496 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1461 = $m_Lscalacss_internal_Attrs$textAlign$();
  var $$x495 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x496).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1461.Lscalacss_internal_Attrs$textAlign$__f_attr, "left")));
  var $$x494 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1463 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var array$120 = [$$x497, $$x495, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x494).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1463.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")))];
  this.Lreactbuild_Style$__f_areaLabel = $n($$x498).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$120), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x503 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "areaValue");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$80 = this.Lreactbuild_Style$__f_areaMixin;
  var $$x502 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$80).Lscalacss_internal_StyleA__f_style);
  var $$x501 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1470 = $m_Lscalacss_internal_Attrs$textAlign$();
  var $$x500 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x501).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1470.Lscalacss_internal_Attrs$textAlign$__f_attr, "right")));
  var $$x499 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1472 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var array$121 = [$$x502, $$x500, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x499).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1472.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")))];
  this.Lreactbuild_Style$__f_areaValue = $n($$x503).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$121), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "printableDocument").apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($m_sci_Nil$(), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x513 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "skipPaperPage");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x512 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1479 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x511 = $n($n($$x512).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1479.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Print$()), new $c_sjsr_AnonFunction1(((x$22$2) => {
    var x$22$1 = $as_Lscalacss_internal_Media$Query(x$22$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$22$1)
  }))));
  var $$x510 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1481 = $m_Lscalacss_internal_Attrs$display$();
  var v$160 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$161 = v$160.Lscalacss_internal_Literal__f_value;
  var $$x509 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x510).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1481.Lscalacss_internal_Attrs$display$__f_attr, v$161).important__Lscalacss_internal_AV()));
  var $$x508 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1483 = $m_Lscalacss_internal_Attrs$pageBreakBefore$();
  var v$162 = $m_Lscalacss_internal_Literal$Typed$inherit$();
  var v$163 = v$162.Lscalacss_internal_Literal__f_value;
  var array$122 = [$$x509, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x508).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1483.Lscalacss_internal_Attrs$pageBreakBefore$__f_attr, v$163)))];
  var x$81 = $n($$x511).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$122), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x507 = new $c_Lscalacss_internal_DslBase$ToStyle(x$81);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x506 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1491 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x505 = $n($n($$x506).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$1491.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$23$2) => {
    var x$23$1 = $as_Lscalacss_internal_Media$Query(x$23$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$23$1)
  }))));
  var $$x504 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1496 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$64 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$7$2$2) => {
    var x$7$5 = $uD(x$7$2$2);
    return ("" + x$7$5)
  })));
  var v$164 = $n(r$64).apply__O__Lscalacss_internal_ValueT(0.2);
  var v$165 = $n(v$164).Lscalacss_internal_ValueT__f_value;
  var array$123 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x504).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1496.Lscalacss_internal_Attrs$opacity$__f_attr, v$165)))];
  var x$82 = $n($$x505).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$123), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$124 = [$$x507, new $c_Lscalacss_internal_DslBase$ToStyle(x$82)];
  this.Lreactbuild_Style$__f_skipPaperPage = $n($$x513).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$124), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x515 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "panel");
  var $$x514 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1507 = $m_Lscalacss_internal_Attrs$display$();
  var v$166 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$167 = v$166.Lscalacss_internal_Literal__f_value;
  var array$125 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x514).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1507.Lscalacss_internal_Attrs$display$__f_attr, v$167)))];
  $n($$x515).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$125), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x517 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "panelOpened");
  var $$x516 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1513 = $m_Lscalacss_internal_Attrs$display$();
  var v$168 = $m_Lscalacss_internal_Literal$Typed$inherit$();
  var v$169 = v$168.Lscalacss_internal_Literal__f_value;
  var array$126 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x516).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1513.Lscalacss_internal_Attrs$display$__f_attr, v$169)))];
  $n($$x517).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$126), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x519 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "lateralBar");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$83 = this.Lreactbuild_Style$__f_notPrintable;
  var $$x518 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$83).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$84 = this.Lreactbuild_Style$__f_full;
  var array$127 = [$$x518, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$84).Lscalacss_internal_StyleA__f_style)];
  $n($$x519).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$127), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x522 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "headline");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$85 = this.Lreactbuild_Style$__f_flexRow;
  var $$x521 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$85).Lscalacss_internal_StyleA__f_style);
  var $$x520 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1527 = $m_Lscalacss_internal_Attrs$alignItems$();
  var array$128 = [$$x521, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x520).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1527.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")))];
  $n($$x522).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$128), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x523 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "menuButton");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$86 = this.Lreactbuild_Style$__f_notPrintable;
  var array$129 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$86).Lscalacss_internal_StyleA__f_style)];
  $n($$x523).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$129), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x526 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "navigation");
  var $$x525 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1546 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$50 = 100;
  var u$26 = $m_Lscalacss_internal_LengthUnit$vh$();
  var f$132 = new $c_Lscalacss_internal_Length(this$$50, u$26);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$57 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$28) => {
    var x$3$29 = $as_Lscalacss_internal_Length(x$3$2$28);
    return $n(x$3$29).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$131 = new $c_sjsr_AnonFunction1(((x$1$2$66) => {
    var x$1$69 = $as_Lscalacss_internal_ValueT(x$1$2$66);
    return $n(x$1$69)
  }));
  var bc$57 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$131);
  var r$65 = $n(ab$57).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$57);
  var v$170 = $n(r$65).apply__O__Lscalacss_internal_ValueT(f$132);
  var v$171 = $n(v$170).Lscalacss_internal_ValueT__f_value;
  var $$x524 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x525).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1546.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$171)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$87 = this.Lreactbuild_Style$__f_flexColumn;
  var array$130 = [$$x524, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$87).Lscalacss_internal_StyleA__f_style)];
  $n($$x526).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$130), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x531 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingControlsMixin");
  var $$x530 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1553 = $m_Lscalacss_internal_Attrs$position$();
  var $$x529 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x530).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1553.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x528 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1555 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x527 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x528).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1555.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$88 = this.Lreactbuild_Style$__f_notPrintable;
  var array$131 = [$$x529, $$x527, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$88).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_drawingControlsMixin = $n($$x531).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$131), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x553 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingArea");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$89 = this.Lreactbuild_Style$__f_drawingControlsMixin;
  var $$x552 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$89).Lscalacss_internal_StyleA__f_style);
  var $$x551 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1563 = $m_Lscalacss_internal_Attrs$display$();
  var $$x550 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x551).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1563.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x549 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1565 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$172 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$173 = v$172.Lscalacss_internal_Literal__f_value;
  var $$x548 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x549).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1565.Lscalacss_internal_Attrs$overflow$__f_attr, v$173)));
  var $$x547 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1567 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x546 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x547).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1567.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "transparent")));
  var $$x545 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1572 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$66 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$1) => {
    var x$6$4 = $uI(x$6$2$1);
    return ("" + x$6$4)
  })));
  var v$174 = $n(r$66).apply__O__Lscalacss_internal_ValueT(1);
  var v$175 = $n(v$174).Lscalacss_internal_ValueT__f_value;
  var $$x544 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x545).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1572.Lscalacss_internal_Attrs$opacity$__f_attr, v$175)));
  var $$x543 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$20 = $m_Lscalacss_internal_Attrs$().transition__Lscalacss_internal_Attr();
  var $$x542 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x543).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$20, "opacity .3s ease")));
  var $$x541 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$21 = $m_Lscalacss_internal_Attrs$().touchAction__Lscalacss_internal_Attr();
  var $$x540 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x541).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$21, "none")));
  var $$x539 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1580 = $m_Lscalacss_internal_Attrs$pointerEvents$();
  var v$176 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$177 = v$176.Lscalacss_internal_Literal__f_value;
  var $$x538 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x539).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1580.Lscalacss_internal_Attrs$pointerEvents$__f_attr, v$177)));
  var $$x537 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x536 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x535 = new $c_sjsr_AnonFunction1(((x$19$3$2) => {
    var x$19$3 = $as_T(x$19$3$2);
    return (x$19$3 + ">*")
  }));
  var $$x534 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$22 = $m_Lscalacss_internal_Attrs$().touchAction__Lscalacss_internal_Attr();
  var $$x533 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x534).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$22, "initial")));
  var $$x532 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1585 = $m_Lscalacss_internal_Attrs$pointerEvents$();
  var v$178 = $m_Lscalacss_internal_Literal$Typed$initial$();
  var v$179 = v$178.Lscalacss_internal_Literal__f_value;
  var array$132 = [$$x533, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x532).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1585.Lscalacss_internal_Attrs$pointerEvents$__f_attr, v$179)))];
  var array$133 = [$$x552, $$x550, $$x548, $$x546, $$x544, $$x542, $$x540, $$x538, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x537).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x536).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x535, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$132), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_drawingArea = $n($$x553).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$133), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x562 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingAreaHidden");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$90 = this.Lreactbuild_Style$__f_drawingControlsMixin;
  var $$x561 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$90).Lscalacss_internal_StyleA__f_style);
  var $$x560 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1597 = $m_Lscalacss_internal_Attrs$display$();
  var $$x559 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x560).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1597.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x558 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1599 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$180 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$181 = v$180.Lscalacss_internal_Literal__f_value;
  var $$x557 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x558).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1599.Lscalacss_internal_Attrs$overflow$__f_attr, v$181)));
  var $$x556 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1601 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x555 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x556).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1601.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "transparent")));
  var $$x554 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1606 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$67 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$2) => {
    var x$6$5 = $uI(x$6$2$2);
    return ("" + x$6$5)
  })));
  var v$182 = $n(r$67).apply__O__Lscalacss_internal_ValueT(0);
  var v$183 = $n(v$182).Lscalacss_internal_ValueT__f_value;
  var array$134 = [$$x561, $$x559, $$x557, $$x555, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x554).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1606.Lscalacss_internal_Attrs$opacity$__f_attr, v$183)))];
  this.Lreactbuild_Style$__f_drawingAreaHidden = $n($$x562).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$134), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$51 = 16;
  var u$27 = $m_Lscalacss_internal_LengthUnit$px$();
  this.Lreactbuild_Style$__f_drawingAreaGap = new $c_Lscalacss_internal_Length(this$$51, u$27);
  var qual$5 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF(this, "drawingAreaAxis");
  var x$11$4 = $m_Lreactbuild_project_drawing_Area$Axis$().Lreactbuild_project_drawing_Area$Axis$__f_domain;
  var x$12$4 = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_project_drawing_Area$Axis(x0$1$2);
    var x$91 = $m_Lreactbuild_project_drawing_Area$Axis$Horizontal$();
    if ((x$91 === x0$1)) {
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var $$x563 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var this$1622 = $m_Lscalacss_internal_Attrs$maxHeight$();
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var this$$52 = 25;
      var f$134 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$52);
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var ab$58 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$25) => {
        var x$4$27 = $as_Lscalacss_internal_Percentage(x$4$2$25);
        return $n(x$4$27).value__T()
      })));
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var f$133 = new $c_sjsr_AnonFunction1(((x$1$2$67) => {
        var x$1$70 = $as_Lscalacss_internal_ValueT(x$1$2$67);
        return $n(x$1$70)
      }));
      var bc$58 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$133);
      var r$68 = $n(ab$58).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$58);
      var v$184 = $n(r$68).apply__O__Lscalacss_internal_ValueT(f$134);
      var v$185 = $n(v$184).Lscalacss_internal_ValueT__f_value;
      var array$135 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x563).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1622.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$185)))];
      var t$17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$135);
      $m_Lreactbuild_package$CssSettings$();
      var c$11 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
      return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$17, c$11)
    } else {
      var x$3$30 = $m_Lreactbuild_project_drawing_Area$Axis$Vertical$();
      if ((x$3$30 === x0$1)) {
        $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
        var $$x564 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
        $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
        var this$1636 = $m_Lscalacss_internal_Attrs$maxWidth$();
        $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
        $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
        var this$$53 = 50;
        var f$136 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$53);
        $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
        $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
        var ab$59 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$26) => {
          var x$4$28 = $as_Lscalacss_internal_Percentage(x$4$2$26);
          return $n(x$4$28).value__T()
        })));
        $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
        var f$135 = new $c_sjsr_AnonFunction1(((x$1$2$68) => {
          var x$1$71 = $as_Lscalacss_internal_ValueT(x$1$2$68);
          return $n(x$1$71)
        }));
        var bc$59 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$135);
        var r$69 = $n(ab$59).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$59);
        var v$186 = $n(r$69).apply__O__Lscalacss_internal_ValueT(f$136);
        var v$187 = $n(v$186).Lscalacss_internal_ValueT__f_value;
        var array$136 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x564).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1636.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$187)))];
        var t$18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$136);
        $m_Lreactbuild_package$CssSettings$();
        var c$12 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
        return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$18, c$12)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    }
  }));
  var x$13$4 = $m_Lscalacss_internal_DslMacros$().Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffix;
  $m_Lscalacss_internal_StyleLookup$();
  $m_Lreactbuild_project_drawing_Area$Axis$();
  var this$1643 = $m_Ljapgolly_univeq_UnivEq$();
  var evidence$3 = new $c_Lscalacss_internal_StyleLookup$$anon$2();
  this.Lreactbuild_Style$__f_drawingAreaAxis = qual$5.create__s_Option__Lscalacss_internal_Domain__F1__F2__Lscalacss_internal_StyleLookup__F1($m_s_None$(), x$11$4, x$12$4, x$13$4, evidence$3);
  var qual$6 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF(this, "drawingAreaPosition");
  var this$1645 = $n($m_Lreactbuild_project_drawing_Area$Axis$().Lreactbuild_project_drawing_Area$Axis$__f_domain);
  var b = $m_Lreactbuild_project_drawing_Area$Position$().Lreactbuild_project_drawing_Area$Position$__f_domain;
  var x$14$4 = new $c_Lscalacss_internal_Domain$Pair(this$1645, b);
  var x$15$4 = new $c_sjsr_AnonFunction1(((x0$2$2) => {
    var x0$2 = $as_T2(x0$2$2);
    if ((x0$2 !== null)) {
      var p2 = $as_Lreactbuild_project_drawing_Area$Axis($n(x0$2)._1__O());
      var pos = $as_Lreactbuild_project_drawing_Area$Position($n(x0$2)._2__O());
      var x$92 = $m_Lreactbuild_project_drawing_Area$Axis$Horizontal$();
      if ((x$92 === p2)) {
        var x$3$31 = $m_Lreactbuild_project_drawing_Area$Position$Start$();
        if ((x$3$31 === pos)) {
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var $$x565 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$1652 = $m_Lscalacss_internal_Attrs$top$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$138 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var ab$60 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$29) => {
            var x$3$32 = $as_Lscalacss_internal_Length(x$3$2$29);
            return $n(x$3$32).value__T()
          })));
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$137 = new $c_sjsr_AnonFunction1(((x$1$2$69) => {
            var x$1$72 = $as_Lscalacss_internal_ValueT(x$1$2$69);
            return $n(x$1$72)
          }));
          var bc$60 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$137);
          var r$70 = $n(ab$60).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$60);
          var v$188 = $n(r$70).apply__O__Lscalacss_internal_ValueT(f$138);
          var v$189 = $n(v$188).Lscalacss_internal_ValueT__f_value;
          var array$137 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x565).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1652.Lscalacss_internal_Attrs$top$__f_attr, v$189)))];
          var t$19 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$137);
          $m_Lreactbuild_package$CssSettings$();
          var c$13 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
          return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$19, c$13)
        } else {
          var x$5$4 = $m_Lreactbuild_project_drawing_Area$Position$End$();
          if ((x$5$4 === pos)) {
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var $$x566 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1664 = $m_Lscalacss_internal_Attrs$bottom$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$140 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$61 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$30) => {
              var x$3$33 = $as_Lscalacss_internal_Length(x$3$2$30);
              return $n(x$3$33).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$139 = new $c_sjsr_AnonFunction1(((x$1$2$70) => {
              var x$1$73 = $as_Lscalacss_internal_ValueT(x$1$2$70);
              return $n(x$1$73)
            }));
            var bc$61 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$139);
            var r$71 = $n(ab$61).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$61);
            var v$190 = $n(r$71).apply__O__Lscalacss_internal_ValueT(f$140);
            var v$191 = $n(v$190).Lscalacss_internal_ValueT__f_value;
            var array$138 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x566).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1664.Lscalacss_internal_Attrs$bottom$__f_attr, v$191)))];
            var t$20 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$138);
            $m_Lreactbuild_package$CssSettings$();
            var c$14 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
            return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$20, c$14)
          } else {
            throw new $c_s_MatchError(pos)
          }
        }
      }
    };
    if ((x0$2 !== null)) {
      var p4 = $as_Lreactbuild_project_drawing_Area$Axis($n(x0$2)._1__O());
      var pos$2 = $as_Lreactbuild_project_drawing_Area$Position($n(x0$2)._2__O());
      var x$7$6 = $m_Lreactbuild_project_drawing_Area$Axis$Vertical$();
      if ((x$7$6 === p4)) {
        var x$9$4 = $m_Lreactbuild_project_drawing_Area$Position$Start$();
        if ((x$9$4 === pos$2)) {
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var $$x567 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$1676 = $m_Lscalacss_internal_Attrs$left$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$142 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var ab$62 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$31) => {
            var x$3$34 = $as_Lscalacss_internal_Length(x$3$2$31);
            return $n(x$3$34).value__T()
          })));
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$141 = new $c_sjsr_AnonFunction1(((x$1$2$71) => {
            var x$1$74 = $as_Lscalacss_internal_ValueT(x$1$2$71);
            return $n(x$1$74)
          }));
          var bc$62 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$141);
          var r$72 = $n(ab$62).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$62);
          var v$192 = $n(r$72).apply__O__Lscalacss_internal_ValueT(f$142);
          var v$193 = $n(v$192).Lscalacss_internal_ValueT__f_value;
          var array$139 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x567).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1676.Lscalacss_internal_Attrs$left$__f_attr, v$193)))];
          var t$21 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$139);
          $m_Lreactbuild_package$CssSettings$();
          var c$15 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
          return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$21, c$15)
        } else {
          var x$11$5 = $m_Lreactbuild_project_drawing_Area$Position$End$();
          if ((x$11$5 === pos$2)) {
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var $$x568 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1688 = $m_Lscalacss_internal_Attrs$right$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$144 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$63 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$32) => {
              var x$3$35 = $as_Lscalacss_internal_Length(x$3$2$32);
              return $n(x$3$35).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$143 = new $c_sjsr_AnonFunction1(((x$1$2$72) => {
              var x$1$75 = $as_Lscalacss_internal_ValueT(x$1$2$72);
              return $n(x$1$75)
            }));
            var bc$63 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$143);
            var r$73 = $n(ab$63).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$63);
            var v$194 = $n(r$73).apply__O__Lscalacss_internal_ValueT(f$144);
            var v$195 = $n(v$194).Lscalacss_internal_ValueT__f_value;
            var array$140 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x568).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1688.Lscalacss_internal_Attrs$right$__f_attr, v$195)))];
            var t$22 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$140);
            $m_Lreactbuild_package$CssSettings$();
            var c$16 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
            return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$22, c$16)
          } else {
            throw new $c_s_MatchError(pos$2)
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$2)
  }));
  var x$16$3 = $m_Lscalacss_internal_DslMacros$().Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffix;
  $m_Lscalacss_internal_StyleLookup$();
  var this$1698 = $m_Ljapgolly_univeq_UnivEq$();
  $m_Lreactbuild_project_drawing_Area$Axis$();
  var this$1695 = $m_Ljapgolly_univeq_UnivEq$();
  $m_Lreactbuild_project_drawing_Area$Position$();
  var this$1697 = $m_Ljapgolly_univeq_UnivEq$();
  var evidence$3$1 = new $c_Lscalacss_internal_StyleLookup$$anon$2();
  this.Lreactbuild_Style$__f_drawingAreaPosition = qual$6.create__s_Option__Lscalacss_internal_Domain__F1__F2__Lscalacss_internal_StyleLookup__F1($m_s_None$(), x$14$4, x$15$4, x$16$3, evidence$3$1);
  var qual$7 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF(this, "drawingAreaAlignment");
  var this$1700 = $n($m_Lreactbuild_project_drawing_Area$Axis$().Lreactbuild_project_drawing_Area$Axis$__f_domain);
  var b$1 = $m_Lreactbuild_project_drawing_Area$Alignment$().Lreactbuild_project_drawing_Area$Alignment$__f_domain;
  var x$17$4 = new $c_Lscalacss_internal_Domain$Pair(this$1700, b$1);
  var x$18$4 = new $c_sjsr_AnonFunction1(((x0$3$2) => {
    var x0$3 = $as_T2(x0$3$2);
    if ((x0$3 !== null)) {
      var p2$1 = $as_Lreactbuild_project_drawing_Area$Axis($n(x0$3)._1__O());
      var pos$1 = $as_Lreactbuild_project_drawing_Area$Alignment($n(x0$3)._2__O());
      var x$93 = $m_Lreactbuild_project_drawing_Area$Axis$Horizontal$();
      if ((x$93 === p2$1)) {
        var x$3$36 = $m_Lreactbuild_project_drawing_Area$Alignment$Start$();
        if ((x$3$36 === pos$1)) {
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var $$x573 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$1707 = $m_Lscalacss_internal_Attrs$left$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$146 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var ab$64 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$33) => {
            var x$3$37 = $as_Lscalacss_internal_Length(x$3$2$33);
            return $n(x$3$37).value__T()
          })));
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$145 = new $c_sjsr_AnonFunction1(((x$1$2$73) => {
            var x$1$76 = $as_Lscalacss_internal_ValueT(x$1$2$73);
            return $n(x$1$76)
          }));
          var bc$64 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$145);
          var r$74 = $n(ab$64).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$64);
          var v$196 = $n(r$74).apply__O__Lscalacss_internal_ValueT(f$146);
          var v$197 = $n(v$196).Lscalacss_internal_ValueT__f_value;
          var $$x572 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x573).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1707.Lscalacss_internal_Attrs$left$__f_attr, v$197)));
          var $$x571 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$1716 = $m_Lscalacss_internal_Attrs$right$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$$54 = 75;
          var f$148 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$54);
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var ab$65 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$27) => {
            var x$4$29 = $as_Lscalacss_internal_Percentage(x$4$2$27);
            return $n(x$4$29).value__T()
          })));
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$147 = new $c_sjsr_AnonFunction1(((x$1$2$74) => {
            var x$1$77 = $as_Lscalacss_internal_ValueT(x$1$2$74);
            return $n(x$1$77)
          }));
          var bc$65 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$147);
          var r$75 = $n(ab$65).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$65);
          var v$198 = $n(r$75).apply__O__Lscalacss_internal_ValueT(f$148);
          var v$199 = $n(v$198).Lscalacss_internal_ValueT__f_value;
          var $$x570 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x571).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1716.Lscalacss_internal_Attrs$right$__f_attr, v$199)));
          var $$x569 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$1718 = $m_Lscalacss_internal_Attrs$justifyContent$();
          var array$141 = [$$x572, $$x570, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x569).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1718.Lscalacss_internal_Attrs$justifyContent$__f_attr, "flex-start")))];
          var t$23 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$141);
          $m_Lreactbuild_package$CssSettings$();
          var c$17 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
          return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$23, c$17)
        } else {
          var x$5$5 = $m_Lreactbuild_project_drawing_Area$Alignment$Middle$();
          if ((x$5$5 === pos$1)) {
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var $$x586 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1732 = $m_Lscalacss_internal_Attrs$left$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$$55 = 25;
            var f$150 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$55);
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$66 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$28) => {
              var x$4$30 = $as_Lscalacss_internal_Percentage(x$4$2$28);
              return $n(x$4$30).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$149 = new $c_sjsr_AnonFunction1(((x$1$2$75) => {
              var x$1$78 = $as_Lscalacss_internal_ValueT(x$1$2$75);
              return $n(x$1$78)
            }));
            var bc$66 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$149);
            var r$76 = $n(ab$66).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$66);
            var v$200 = $n(r$76).apply__O__Lscalacss_internal_ValueT(f$150);
            var v$201 = $n(v$200).Lscalacss_internal_ValueT__f_value;
            var $$x585 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x586).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1732.Lscalacss_internal_Attrs$left$__f_attr, v$201)));
            var $$x584 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1741 = $m_Lscalacss_internal_Attrs$right$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$$56 = 25;
            var f$152 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$56);
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$67 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$29) => {
              var x$4$31 = $as_Lscalacss_internal_Percentage(x$4$2$29);
              return $n(x$4$31).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$151 = new $c_sjsr_AnonFunction1(((x$1$2$76) => {
              var x$1$79 = $as_Lscalacss_internal_ValueT(x$1$2$76);
              return $n(x$1$79)
            }));
            var bc$67 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$151);
            var r$77 = $n(ab$67).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$67);
            var v$202 = $n(r$77).apply__O__Lscalacss_internal_ValueT(f$152);
            var v$203 = $n(v$202).Lscalacss_internal_ValueT__f_value;
            var $$x583 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x584).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1741.Lscalacss_internal_Attrs$right$__f_attr, v$203)));
            var $$x582 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1743 = $m_Lscalacss_internal_Attrs$justifyContent$();
            var $$x581 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x582).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1743.Lscalacss_internal_Attrs$justifyContent$__f_attr, "center")));
            var $$x580 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            var $$x579 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            var $$x578 = new $c_sjsr_AnonFunction1(((x$20$2$1) => {
              var x$20$3 = $as_T(x$20$2$1);
              return ("BODY.portrait " + x$20$3)
            }));
            var $$x577 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1750 = $m_Lscalacss_internal_Attrs$left$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$154 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$68 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$34) => {
              var x$3$38 = $as_Lscalacss_internal_Length(x$3$2$34);
              return $n(x$3$38).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$153 = new $c_sjsr_AnonFunction1(((x$1$2$77) => {
              var x$1$80 = $as_Lscalacss_internal_ValueT(x$1$2$77);
              return $n(x$1$80)
            }));
            var bc$68 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$153);
            var r$78 = $n(ab$68).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$68);
            var v$204 = $n(r$78).apply__O__Lscalacss_internal_ValueT(f$154);
            var v$205 = $n(v$204).Lscalacss_internal_ValueT__f_value;
            var $$x576 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x577).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1750.Lscalacss_internal_Attrs$left$__f_attr, v$205)));
            var $$x575 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1757 = $m_Lscalacss_internal_Attrs$right$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$156 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$69 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$35) => {
              var x$3$39 = $as_Lscalacss_internal_Length(x$3$2$35);
              return $n(x$3$39).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$155 = new $c_sjsr_AnonFunction1(((x$1$2$78) => {
              var x$1$81 = $as_Lscalacss_internal_ValueT(x$1$2$78);
              return $n(x$1$81)
            }));
            var bc$69 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$155);
            var r$79 = $n(ab$69).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$69);
            var v$206 = $n(r$79).apply__O__Lscalacss_internal_ValueT(f$156);
            var v$207 = $n(v$206).Lscalacss_internal_ValueT__f_value;
            var array$142 = [$$x576, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x575).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1757.Lscalacss_internal_Attrs$right$__f_attr, v$207)))];
            var $$x574 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x580).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x579).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x578, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$142), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var x$94 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexRow;
            var array$143 = [$$x585, $$x583, $$x581, $$x574, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$94).Lscalacss_internal_StyleA__f_style)];
            var t$24 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$143);
            $m_Lreactbuild_package$CssSettings$();
            var c$18 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
            return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$24, c$18)
          } else {
            var x$7$7 = $m_Lreactbuild_project_drawing_Area$Alignment$End$();
            if ((x$7$7 === pos$1)) {
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var $$x591 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var this$1774 = $m_Lscalacss_internal_Attrs$right$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var f$158 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var ab$70 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$36) => {
                var x$3$40 = $as_Lscalacss_internal_Length(x$3$2$36);
                return $n(x$3$40).value__T()
              })));
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var f$157 = new $c_sjsr_AnonFunction1(((x$1$2$79) => {
                var x$1$82 = $as_Lscalacss_internal_ValueT(x$1$2$79);
                return $n(x$1$82)
              }));
              var bc$70 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$157);
              var r$80 = $n(ab$70).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$70);
              var v$208 = $n(r$80).apply__O__Lscalacss_internal_ValueT(f$158);
              var v$209 = $n(v$208).Lscalacss_internal_ValueT__f_value;
              var $$x590 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x591).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1774.Lscalacss_internal_Attrs$right$__f_attr, v$209)));
              var $$x589 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var this$1783 = $m_Lscalacss_internal_Attrs$left$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var this$$57 = 75;
              var f$160 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$57);
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var ab$71 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$30) => {
                var x$4$32 = $as_Lscalacss_internal_Percentage(x$4$2$30);
                return $n(x$4$32).value__T()
              })));
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var f$159 = new $c_sjsr_AnonFunction1(((x$1$2$80) => {
                var x$1$83 = $as_Lscalacss_internal_ValueT(x$1$2$80);
                return $n(x$1$83)
              }));
              var bc$71 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$159);
              var r$81 = $n(ab$71).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$71);
              var v$210 = $n(r$81).apply__O__Lscalacss_internal_ValueT(f$160);
              var v$211 = $n(v$210).Lscalacss_internal_ValueT__f_value;
              var $$x588 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x589).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1783.Lscalacss_internal_Attrs$left$__f_attr, v$211)));
              var $$x587 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var this$1785 = $m_Lscalacss_internal_Attrs$justifyContent$();
              var array$144 = [$$x590, $$x588, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x587).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1785.Lscalacss_internal_Attrs$justifyContent$__f_attr, "flex-end")))];
              var t$25 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$144);
              $m_Lreactbuild_package$CssSettings$();
              var c$19 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
              return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$25, c$19)
            } else {
              throw new $c_s_MatchError(pos$1)
            }
          }
        }
      }
    };
    if ((x0$3 !== null)) {
      var p4$1 = $as_Lreactbuild_project_drawing_Area$Axis($n(x0$3)._1__O());
      var pos$2$1 = $as_Lreactbuild_project_drawing_Area$Alignment($n(x0$3)._2__O());
      var x$9$5 = $m_Lreactbuild_project_drawing_Area$Axis$Vertical$();
      if ((x$9$5 === p4$1)) {
        var x$11$6 = $m_Lreactbuild_project_drawing_Area$Alignment$Start$();
        if ((x$11$6 === pos$2$1)) {
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var $$x596 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$1797 = $m_Lscalacss_internal_Attrs$top$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$162 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var ab$72 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$37) => {
            var x$3$41 = $as_Lscalacss_internal_Length(x$3$2$37);
            return $n(x$3$41).value__T()
          })));
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$161 = new $c_sjsr_AnonFunction1(((x$1$2$81) => {
            var x$1$84 = $as_Lscalacss_internal_ValueT(x$1$2$81);
            return $n(x$1$84)
          }));
          var bc$72 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$161);
          var r$82 = $n(ab$72).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$72);
          var v$212 = $n(r$82).apply__O__Lscalacss_internal_ValueT(f$162);
          var v$213 = $n(v$212).Lscalacss_internal_ValueT__f_value;
          var $$x595 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x596).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1797.Lscalacss_internal_Attrs$top$__f_attr, v$213)));
          var $$x594 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$1806 = $m_Lscalacss_internal_Attrs$bottom$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$$58 = 75;
          var f$164 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$58);
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var ab$73 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$31) => {
            var x$4$33 = $as_Lscalacss_internal_Percentage(x$4$2$31);
            return $n(x$4$33).value__T()
          })));
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var f$163 = new $c_sjsr_AnonFunction1(((x$1$2$82) => {
            var x$1$85 = $as_Lscalacss_internal_ValueT(x$1$2$82);
            return $n(x$1$85)
          }));
          var bc$73 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$163);
          var r$83 = $n(ab$73).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$73);
          var v$214 = $n(r$83).apply__O__Lscalacss_internal_ValueT(f$164);
          var v$215 = $n(v$214).Lscalacss_internal_ValueT__f_value;
          var $$x593 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x594).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1806.Lscalacss_internal_Attrs$bottom$__f_attr, v$215)));
          var $$x592 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
          $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
          var this$1808 = $m_Lscalacss_internal_Attrs$justifyContent$();
          var array$145 = [$$x595, $$x593, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x592).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1808.Lscalacss_internal_Attrs$justifyContent$__f_attr, "flex-start")))];
          var t$26 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$145);
          $m_Lreactbuild_package$CssSettings$();
          var c$20 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
          return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$26, c$20)
        } else {
          var x$13$5 = $m_Lreactbuild_project_drawing_Area$Alignment$Middle$();
          if ((x$13$5 === pos$2$1)) {
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var $$x609 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1822 = $m_Lscalacss_internal_Attrs$top$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$$59 = 25;
            var f$166 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$59);
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$74 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$32) => {
              var x$4$34 = $as_Lscalacss_internal_Percentage(x$4$2$32);
              return $n(x$4$34).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$165 = new $c_sjsr_AnonFunction1(((x$1$2$83) => {
              var x$1$86 = $as_Lscalacss_internal_ValueT(x$1$2$83);
              return $n(x$1$86)
            }));
            var bc$74 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$165);
            var r$84 = $n(ab$74).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$74);
            var v$216 = $n(r$84).apply__O__Lscalacss_internal_ValueT(f$166);
            var v$217 = $n(v$216).Lscalacss_internal_ValueT__f_value;
            var $$x608 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x609).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1822.Lscalacss_internal_Attrs$top$__f_attr, v$217)));
            var $$x607 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1831 = $m_Lscalacss_internal_Attrs$bottom$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$$60 = 25;
            var f$168 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$60);
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$75 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$33) => {
              var x$4$35 = $as_Lscalacss_internal_Percentage(x$4$2$33);
              return $n(x$4$35).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$167 = new $c_sjsr_AnonFunction1(((x$1$2$84) => {
              var x$1$87 = $as_Lscalacss_internal_ValueT(x$1$2$84);
              return $n(x$1$87)
            }));
            var bc$75 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$167);
            var r$85 = $n(ab$75).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$75);
            var v$218 = $n(r$85).apply__O__Lscalacss_internal_ValueT(f$168);
            var v$219 = $n(v$218).Lscalacss_internal_ValueT__f_value;
            var $$x606 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x607).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1831.Lscalacss_internal_Attrs$bottom$__f_attr, v$219)));
            var $$x605 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1833 = $m_Lscalacss_internal_Attrs$justifyContent$();
            var $$x604 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x605).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1833.Lscalacss_internal_Attrs$justifyContent$__f_attr, "center")));
            var $$x603 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            var $$x602 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            var $$x601 = new $c_sjsr_AnonFunction1(((x$21$2$1) => {
              var x$21$3 = $as_T(x$21$2$1);
              return ("BODY.portrait " + x$21$3)
            }));
            var $$x600 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1840 = $m_Lscalacss_internal_Attrs$top$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$170 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$76 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$38) => {
              var x$3$42 = $as_Lscalacss_internal_Length(x$3$2$38);
              return $n(x$3$42).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$169 = new $c_sjsr_AnonFunction1(((x$1$2$85) => {
              var x$1$88 = $as_Lscalacss_internal_ValueT(x$1$2$85);
              return $n(x$1$88)
            }));
            var bc$76 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$169);
            var r$86 = $n(ab$76).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$76);
            var v$220 = $n(r$86).apply__O__Lscalacss_internal_ValueT(f$170);
            var v$221 = $n(v$220).Lscalacss_internal_ValueT__f_value;
            var $$x599 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x600).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1840.Lscalacss_internal_Attrs$top$__f_attr, v$221)));
            var $$x598 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var this$1847 = $m_Lscalacss_internal_Attrs$bottom$();
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$172 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var ab$77 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$39) => {
              var x$3$43 = $as_Lscalacss_internal_Length(x$3$2$39);
              return $n(x$3$43).value__T()
            })));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var f$171 = new $c_sjsr_AnonFunction1(((x$1$2$86) => {
              var x$1$89 = $as_Lscalacss_internal_ValueT(x$1$2$86);
              return $n(x$1$89)
            }));
            var bc$77 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$171);
            var r$87 = $n(ab$77).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$77);
            var v$222 = $n(r$87).apply__O__Lscalacss_internal_ValueT(f$172);
            var v$223 = $n(v$222).Lscalacss_internal_ValueT__f_value;
            var array$146 = [$$x599, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x598).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1847.Lscalacss_internal_Attrs$bottom$__f_attr, v$223)))];
            var $$x597 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x603).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x602).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x601, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$146), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
            $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
            var x$95 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_flexColumn;
            var array$147 = [$$x608, $$x606, $$x604, $$x597, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$95).Lscalacss_internal_StyleA__f_style)];
            var t$27 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$147);
            $m_Lreactbuild_package$CssSettings$();
            var c$21 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
            return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$27, c$21)
          } else {
            var x$15$5 = $m_Lreactbuild_project_drawing_Area$Alignment$End$();
            if ((x$15$5 === pos$2$1)) {
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var $$x614 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var this$1864 = $m_Lscalacss_internal_Attrs$bottom$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var f$174 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingAreaGap;
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var ab$78 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$40) => {
                var x$3$44 = $as_Lscalacss_internal_Length(x$3$2$40);
                return $n(x$3$44).value__T()
              })));
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var f$173 = new $c_sjsr_AnonFunction1(((x$1$2$87) => {
                var x$1$90 = $as_Lscalacss_internal_ValueT(x$1$2$87);
                return $n(x$1$90)
              }));
              var bc$78 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$173);
              var r$88 = $n(ab$78).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$78);
              var v$224 = $n(r$88).apply__O__Lscalacss_internal_ValueT(f$174);
              var v$225 = $n(v$224).Lscalacss_internal_ValueT__f_value;
              var $$x613 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x614).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1864.Lscalacss_internal_Attrs$bottom$__f_attr, v$225)));
              var $$x612 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var this$1873 = $m_Lscalacss_internal_Attrs$top$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var this$$61 = 75;
              var f$176 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$61);
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var ab$79 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$34) => {
                var x$4$36 = $as_Lscalacss_internal_Percentage(x$4$2$34);
                return $n(x$4$36).value__T()
              })));
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var f$175 = new $c_sjsr_AnonFunction1(((x$1$2$88) => {
                var x$1$91 = $as_Lscalacss_internal_ValueT(x$1$2$88);
                return $n(x$1$91)
              }));
              var bc$79 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$175);
              var r$89 = $n(ab$79).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$79);
              var v$226 = $n(r$89).apply__O__Lscalacss_internal_ValueT(f$176);
              var v$227 = $n(v$226).Lscalacss_internal_ValueT__f_value;
              var $$x611 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x612).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1873.Lscalacss_internal_Attrs$top$__f_attr, v$227)));
              var $$x610 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
              $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
              var this$1875 = $m_Lscalacss_internal_Attrs$justifyContent$();
              var array$148 = [$$x613, $$x611, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x610).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1875.Lscalacss_internal_Attrs$justifyContent$__f_attr, "flex-end")))];
              var t$28 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$148);
              $m_Lreactbuild_package$CssSettings$();
              var c$22 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
              return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$28, c$22)
            } else {
              throw new $c_s_MatchError(pos$2$1)
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$3)
  }));
  var x$19$4 = $m_Lscalacss_internal_DslMacros$().Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffix;
  $m_Lscalacss_internal_StyleLookup$();
  var this$1885 = $m_Ljapgolly_univeq_UnivEq$();
  $m_Lreactbuild_project_drawing_Area$Axis$();
  var this$1882 = $m_Ljapgolly_univeq_UnivEq$();
  $m_Lreactbuild_project_drawing_Area$Alignment$();
  var this$1884 = $m_Ljapgolly_univeq_UnivEq$();
  var evidence$3$2 = new $c_Lscalacss_internal_StyleLookup$$anon$2();
  this.Lreactbuild_Style$__f_drawingAreaAlignment = qual$7.create__s_Option__Lscalacss_internal_Domain__F1__F2__Lscalacss_internal_StyleLookup__F1($m_s_None$(), x$17$4, x$18$4, x$19$4, evidence$3$2);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x618 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x617 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x616 = new $c_sjsr_AnonFunction1(((x$22$3$2) => {
    var x$22$3 = $as_T(x$22$3$2);
    return ("BODY " + x$22$3)
  }));
  var $$x615 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1896 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$62 = 24;
  var u$28 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$178 = new $c_Lscalacss_internal_Length(this$$62, u$28);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$80 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$41) => {
    var x$3$45 = $as_Lscalacss_internal_Length(x$3$2$41);
    return $n(x$3$45).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$177 = new $c_sjsr_AnonFunction1(((x$1$2$89) => {
    var x$1$92 = $as_Lscalacss_internal_ValueT(x$1$2$89);
    return $n(x$1$92)
  }));
  var bc$80 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$177);
  var r$90 = $n(ab$80).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$80);
  var all$3 = $n(r$90).apply__O__Lscalacss_internal_ValueT(f$178);
  var v$228 = $n(all$3).Lscalacss_internal_ValueT__f_value;
  var array$149 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x615).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1896.Lscalacss_internal_Attrs$margin$__f_attr, v$228)))];
  var array$150 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x618).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x617).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x616, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$149), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  var t$29 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$150);
  $m_Lreactbuild_package$CssSettings$();
  var c$23 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_touch = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$29, c$23);
  var $$x629 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingToolControls");
  var $$x628 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1914 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$63 = 100;
  var f$180 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$63);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$81 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$35) => {
    var x$4$37 = $as_Lscalacss_internal_Percentage(x$4$2$35);
    return $n(x$4$37).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$179 = new $c_sjsr_AnonFunction1(((x$1$2$90) => {
    var x$1$93 = $as_Lscalacss_internal_ValueT(x$1$2$90);
    return $n(x$1$93)
  }));
  var bc$81 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$179);
  var r$91 = $n(ab$81).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$81);
  var v$229 = $n(r$91).apply__O__Lscalacss_internal_ValueT(f$180);
  var v$230 = $n(v$229).Lscalacss_internal_ValueT__f_value;
  var $$x627 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x628).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1914.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$230)));
  var $$x626 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1923 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$64 = 100;
  var f$182 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$64);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$82 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$36) => {
    var x$4$38 = $as_Lscalacss_internal_Percentage(x$4$2$36);
    return $n(x$4$38).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$181 = new $c_sjsr_AnonFunction1(((x$1$2$91) => {
    var x$1$94 = $as_Lscalacss_internal_ValueT(x$1$2$91);
    return $n(x$1$94)
  }));
  var bc$82 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$181);
  var r$92 = $n(ab$82).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$82);
  var v$231 = $n(r$92).apply__O__Lscalacss_internal_ValueT(f$182);
  var v$232 = $n(v$231).Lscalacss_internal_ValueT__f_value;
  var $$x625 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x626).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1923.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$232)));
  var $$x624 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1925 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$233 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$234 = v$233.Lscalacss_internal_Literal__f_value;
  var $$x623 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x624).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1925.Lscalacss_internal_Attrs$overflow$__f_attr, v$234)));
  var $$x622 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1935 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$65 = 1;
  var u$29 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$184 = new $c_Lscalacss_internal_Length(this$$65, u$29);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$83 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$42) => {
    var x$3$46 = $as_Lscalacss_internal_Length(x$3$2$42);
    return $n(x$3$46).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$183 = new $c_sjsr_AnonFunction1(((x$1$2$92) => {
    var x$1$95 = $as_Lscalacss_internal_ValueT(x$1$2$92);
    return $n(x$1$95)
  }));
  var bc$83 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$183);
  var r$93 = $n(ab$83).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$83);
  var all$4 = $n(r$93).apply__O__Lscalacss_internal_ValueT(f$184);
  var v$235 = $n(all$4).Lscalacss_internal_ValueT__f_value;
  var $$x621 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x622).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1935.Lscalacss_internal_Attrs$padding$__f_attr, v$235)));
  var $$x620 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1938 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$236 = new $c_Lscalacss_internal_ValueT("rgba(255,255,255,.90)");
  var v$237 = v$236.Lscalacss_internal_ValueT__f_value;
  var $$x619 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x620).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1938.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$237)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$96 = this.Lreactbuild_Style$__f_notPrintable;
  var array$151 = [$$x627, $$x625, $$x623, $$x621, $$x619, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$96).Lscalacss_internal_StyleA__f_style)];
  $n($$x629).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$151), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x640 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingToolControlsHeader");
  var $$x639 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1952 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$66 = 100;
  var f$186 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$66);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$84 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$37) => {
    var x$4$39 = $as_Lscalacss_internal_Percentage(x$4$2$37);
    return $n(x$4$39).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$185 = new $c_sjsr_AnonFunction1(((x$1$2$93) => {
    var x$1$96 = $as_Lscalacss_internal_ValueT(x$1$2$93);
    return $n(x$1$96)
  }));
  var bc$84 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$185);
  var r$94 = $n(ab$84).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$84);
  var v$238 = $n(r$94).apply__O__Lscalacss_internal_ValueT(f$186);
  var v$239 = $n(v$238).Lscalacss_internal_ValueT__f_value;
  var $$x638 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x639).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1952.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$239)));
  var $$x637 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1961 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$67 = 100;
  var f$188 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$67);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$85 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$38) => {
    var x$4$40 = $as_Lscalacss_internal_Percentage(x$4$2$38);
    return $n(x$4$40).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$187 = new $c_sjsr_AnonFunction1(((x$1$2$94) => {
    var x$1$97 = $as_Lscalacss_internal_ValueT(x$1$2$94);
    return $n(x$1$97)
  }));
  var bc$85 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$187);
  var r$95 = $n(ab$85).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$85);
  var v$240 = $n(r$95).apply__O__Lscalacss_internal_ValueT(f$188);
  var v$241 = $n(v$240).Lscalacss_internal_ValueT__f_value;
  var $$x636 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x637).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1961.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$241)));
  var $$x635 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1963 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$242 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$243 = v$242.Lscalacss_internal_Literal__f_value;
  var $$x634 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x635).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1963.Lscalacss_internal_Attrs$overflow$__f_attr, v$243)));
  var $$x633 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1973 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$68 = 1;
  var u$30 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$190 = new $c_Lscalacss_internal_Length(this$$68, u$30);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$86 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$43) => {
    var x$3$47 = $as_Lscalacss_internal_Length(x$3$2$43);
    return $n(x$3$47).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$189 = new $c_sjsr_AnonFunction1(((x$1$2$95) => {
    var x$1$98 = $as_Lscalacss_internal_ValueT(x$1$2$95);
    return $n(x$1$98)
  }));
  var bc$86 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$189);
  var r$96 = $n(ab$86).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$86);
  var all$5 = $n(r$96).apply__O__Lscalacss_internal_ValueT(f$190);
  var v$244 = $n(all$5).Lscalacss_internal_ValueT__f_value;
  var $$x632 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x633).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1973.Lscalacss_internal_Attrs$padding$__f_attr, v$244)));
  var $$x631 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1976 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$245 = new $c_Lscalacss_internal_ValueT("rgba(255,255,255,.90)");
  var v$246 = v$245.Lscalacss_internal_ValueT__f_value;
  var $$x630 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x631).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1976.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$246)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$97 = this.Lreactbuild_Style$__f_notPrintable;
  var array$152 = [$$x638, $$x636, $$x634, $$x632, $$x630, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$97).Lscalacss_internal_StyleA__f_style)];
  $n($$x640).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$152), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x657 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingButton");
  var $$x656 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$23 = $m_Lscalacss_internal_Attrs$().background__Lscalacss_internal_Attr();
  var $$x655 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x656).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$23, "none")));
  var $$x654 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1986 = $m_Lscalacss_internal_Attrs$border$();
  var $$x653 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x654).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1986.Lscalacss_internal_Attrs$border$__f_attr, "0")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$98 = this.Lreactbuild_Style$__f_touch;
  var $$x652 = new $c_Lscalacss_internal_DslBase$ToStyle(x$98);
  var $$x651 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1989 = $m_Lscalacss_internal_Attrs$cursor$();
  var $$x650 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x651).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1989.Lscalacss_internal_Attrs$cursor$__f_attr, "pointer")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x649 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$1990 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p$4 = $m_Lscalacss_internal_Pseudo$Hover$();
  var $$x648 = this$1990.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p$4);
  var this$1992 = $m_s_$less$colon$less$();
  var $$x647 = $n($n($$x649).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x648, this$1992.s_$less$colon$less$__f_singleton));
  var $$x646 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$1994 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$153 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x646).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$1994.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "gray")))];
  var x$99 = $n($$x647).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$153), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x645 = new $c_Lscalacss_internal_DslBase$ToStyle(x$99);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x644 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$2000 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p$5 = $m_Lscalacss_internal_Pseudo$Disabled$();
  var $$x643 = this$2000.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p$5);
  var this$2002 = $m_s_$less$colon$less$();
  var $$x642 = $n($n($$x644).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x643, this$2002.s_$less$colon$less$__f_singleton));
  var $$x641 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$24 = $m_Lscalacss_internal_Attrs$().background__Lscalacss_internal_Attr();
  var array$154 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x641).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$24, "none")))];
  var x$100 = $n($$x642).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$154), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$155 = [$$x655, $$x653, $$x652, $$x650, $$x645, new $c_Lscalacss_internal_DslBase$ToStyle(x$100)];
  this.Lreactbuild_Style$__f_drawingButton = $n($$x657).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$155), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x659 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingButtonActive");
  var $$x658 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2016 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$156 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x658).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2016.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "gray")))];
  this.Lreactbuild_Style$__f_drawingButtonActive = $n($$x659).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$156), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x662 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingView");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$101 = this.Lreactbuild_Style$__f_full;
  var $$x661 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$101).Lscalacss_internal_StyleA__f_style);
  var $$x660 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2023 = $m_Lscalacss_internal_Attrs$position$();
  var array$157 = [$$x661, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x660).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2023.Lscalacss_internal_Attrs$position$__f_attr, "relative")))];
  this.Lreactbuild_Style$__f_drawingView = $n($$x662).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$157), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x674 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingViewFullScreen");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x673 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2029 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x672 = $n($n($$x673).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2029.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$24$2) => {
    var x$24$1 = $as_Lscalacss_internal_Media$Query(x$24$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$24$1)
  }))));
  var $$x671 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2031 = $m_Lscalacss_internal_Attrs$position$();
  var $$x670 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x671).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2031.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x669 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2041 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$69 = 0;
  var u$31 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$192 = new $c_Lscalacss_internal_Length(this$$69, u$31);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$87 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$44) => {
    var x$3$48 = $as_Lscalacss_internal_Length(x$3$2$44);
    return $n(x$3$48).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$191 = new $c_sjsr_AnonFunction1(((x$1$2$96) => {
    var x$1$99 = $as_Lscalacss_internal_ValueT(x$1$2$96);
    return $n(x$1$99)
  }));
  var bc$87 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$191);
  var r$97 = $n(ab$87).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$87);
  var v$247 = $n(r$97).apply__O__Lscalacss_internal_ValueT(f$192);
  var v$248 = $n(v$247).Lscalacss_internal_ValueT__f_value;
  var $$x668 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x669).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2041.Lscalacss_internal_Attrs$top$__f_attr, v$248)));
  var $$x667 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2051 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$70 = 0;
  var u$32 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$194 = new $c_Lscalacss_internal_Length(this$$70, u$32);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$88 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$45) => {
    var x$3$49 = $as_Lscalacss_internal_Length(x$3$2$45);
    return $n(x$3$49).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$193 = new $c_sjsr_AnonFunction1(((x$1$2$97) => {
    var x$1$100 = $as_Lscalacss_internal_ValueT(x$1$2$97);
    return $n(x$1$100)
  }));
  var bc$88 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$193);
  var r$98 = $n(ab$88).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$88);
  var v$249 = $n(r$98).apply__O__Lscalacss_internal_ValueT(f$194);
  var v$250 = $n(v$249).Lscalacss_internal_ValueT__f_value;
  var $$x666 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x667).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2051.Lscalacss_internal_Attrs$left$__f_attr, v$250)));
  var $$x665 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2061 = $m_Lscalacss_internal_Attrs$right$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$71 = 0;
  var u$33 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$196 = new $c_Lscalacss_internal_Length(this$$71, u$33);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$89 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$46) => {
    var x$3$50 = $as_Lscalacss_internal_Length(x$3$2$46);
    return $n(x$3$50).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$195 = new $c_sjsr_AnonFunction1(((x$1$2$98) => {
    var x$1$101 = $as_Lscalacss_internal_ValueT(x$1$2$98);
    return $n(x$1$101)
  }));
  var bc$89 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$195);
  var r$99 = $n(ab$89).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$89);
  var v$251 = $n(r$99).apply__O__Lscalacss_internal_ValueT(f$196);
  var v$252 = $n(v$251).Lscalacss_internal_ValueT__f_value;
  var $$x664 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x665).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2061.Lscalacss_internal_Attrs$right$__f_attr, v$252)));
  var $$x663 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2071 = $m_Lscalacss_internal_Attrs$bottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$72 = 0;
  var u$34 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$198 = new $c_Lscalacss_internal_Length(this$$72, u$34);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$90 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$47) => {
    var x$3$51 = $as_Lscalacss_internal_Length(x$3$2$47);
    return $n(x$3$51).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$197 = new $c_sjsr_AnonFunction1(((x$1$2$99) => {
    var x$1$102 = $as_Lscalacss_internal_ValueT(x$1$2$99);
    return $n(x$1$102)
  }));
  var bc$90 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$197);
  var r$100 = $n(ab$90).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$90);
  var v$253 = $n(r$100).apply__O__Lscalacss_internal_ValueT(f$198);
  var v$254 = $n(v$253).Lscalacss_internal_ValueT__f_value;
  var array$158 = [$$x670, $$x668, $$x666, $$x664, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x663).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2071.Lscalacss_internal_Attrs$bottom$__f_attr, v$254)))];
  var x$102 = $n($$x672).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$158), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$159 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$102)];
  this.Lreactbuild_Style$__f_drawingViewFullScreen = $n($$x674).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$159), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x682 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingViewport");
  var $$x681 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2089 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$73 = 100;
  var f$200 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$73);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$91 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$39) => {
    var x$4$41 = $as_Lscalacss_internal_Percentage(x$4$2$39);
    return $n(x$4$41).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$199 = new $c_sjsr_AnonFunction1(((x$1$2$100) => {
    var x$1$103 = $as_Lscalacss_internal_ValueT(x$1$2$100);
    return $n(x$1$103)
  }));
  var bc$91 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$199);
  var r$101 = $n(ab$91).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$91);
  var v$255 = $n(r$101).apply__O__Lscalacss_internal_ValueT(f$200);
  var v$256 = $n(v$255).Lscalacss_internal_ValueT__f_value;
  var $$x680 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x681).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2089.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$256)));
  var $$x679 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2098 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$74 = 100;
  var f$202 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$74);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$92 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$40) => {
    var x$4$42 = $as_Lscalacss_internal_Percentage(x$4$2$40);
    return $n(x$4$42).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$201 = new $c_sjsr_AnonFunction1(((x$1$2$101) => {
    var x$1$104 = $as_Lscalacss_internal_ValueT(x$1$2$101);
    return $n(x$1$104)
  }));
  var bc$92 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$201);
  var r$102 = $n(ab$92).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$92);
  var v$257 = $n(r$102).apply__O__Lscalacss_internal_ValueT(f$202);
  var v$258 = $n(v$257).Lscalacss_internal_ValueT__f_value;
  var $$x678 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x679).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2098.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$258)));
  var $$x677 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2100 = $m_Lscalacss_internal_Attrs$userSelect$();
  var v$259 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$260 = v$259.Lscalacss_internal_Literal__f_value;
  var $$x676 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x677).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2100.Lscalacss_internal_Attrs$userSelect$__f_attr, v$260)));
  var $$x675 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$25 = $m_Lscalacss_internal_Attrs$().touchAction__Lscalacss_internal_Attr();
  var array$160 = [$$x680, $$x678, $$x676, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x675).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$25, "none")))];
  this.Lreactbuild_Style$__f_drawingViewport = $n($$x682).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$160), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x724 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingToolbar");
  var $$x723 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2109 = $m_Lscalacss_internal_Attrs$display$();
  var $$x722 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x723).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2109.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x721 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2111 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x720 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x721).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2111.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
  var $$x719 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2113 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var $$x718 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x719).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2113.Lscalacss_internal_Attrs$justifyContent$__f_attr, "space-between")));
  var $$x717 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2117 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$261 = new $c_Lscalacss_internal_ValueT("white");
  var v$262 = v$261.Lscalacss_internal_ValueT__f_value;
  var $$x716 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x717).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2117.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$262)));
  var $$x715 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2119 = $m_Lscalacss_internal_Attrs$padding$();
  var $$x714 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x715).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2119.Lscalacss_internal_Attrs$padding$__f_attr, "0")));
  var $$x713 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$26 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("list-style-type");
  var $$x712 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x713).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$26, "none")));
  var $$x711 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$27 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var $$x710 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x711).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$27, "0px 0px 2px 0px #00000040, 1px 3px 4px 0px #00000040")));
  var $$x709 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x708 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$75 = 4;
  var u$35 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$204 = new $c_Lscalacss_internal_Length(this$$75, u$35);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$93 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$48) => {
    var x$3$52 = $as_Lscalacss_internal_Length(x$3$2$48);
    return $n(x$3$52).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$203 = new $c_sjsr_AnonFunction1(((x$1$2$102) => {
    var x$1$105 = $as_Lscalacss_internal_ValueT(x$1$2$102);
    return $n(x$1$105)
  }));
  var bc$93 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$203);
  var r$103 = $n(ab$93).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$93);
  var $$x707 = $n(r$103).apply__O__Lscalacss_internal_ValueT(f$204);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$76 = 4;
  var u$36 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$206 = new $c_Lscalacss_internal_Length(this$$76, u$36);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$94 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$49) => {
    var x$3$53 = $as_Lscalacss_internal_Length(x$3$2$49);
    return $n(x$3$53).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$205 = new $c_sjsr_AnonFunction1(((x$1$2$103) => {
    var x$1$106 = $as_Lscalacss_internal_ValueT(x$1$2$103);
    return $n(x$1$106)
  }));
  var bc$94 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$205);
  var r$104 = $n(ab$94).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$94);
  var $$x706 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x709).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x708.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x707, $n(r$104).apply__O__Lscalacss_internal_ValueT(f$206))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$103 = this.Lreactbuild_Style$__f_withRoundedCorner;
  var $$x705 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$103).Lscalacss_internal_StyleA__f_style);
  var $$x704 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2146 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$263 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$264 = v$263.Lscalacss_internal_Literal__f_value;
  var $$x703 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x704).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2146.Lscalacss_internal_Attrs$overflow$__f_attr, v$264)));
  var $$x702 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x701 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x700 = new $c_sjsr_AnonFunction1(((x$23$3$2) => {
    var x$23$3 = $as_T(x$23$3$2);
    return (x$23$3 + ">LI")
  }));
  var $$x699 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2148 = $m_Lscalacss_internal_Attrs$margin$();
  var $$x698 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x699).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2148.Lscalacss_internal_Attrs$margin$__f_attr, "0")));
  var $$x697 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2150 = $m_Lscalacss_internal_Attrs$padding$();
  var $$x696 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x697).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2150.Lscalacss_internal_Attrs$padding$__f_attr, "0")));
  var $$x695 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x694 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x693 = new $c_sjsr_AnonFunction1(((x$24$3$2) => {
    var x$24$3 = $as_T(x$24$3$2);
    return (x$24$3 + ">SVG")
  }));
  var $$x692 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$28 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var value$2 = new $c_Lscalacss_internal_ValueT("rgba(0,0,0,0.54)");
  var $$x691 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x692).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$28, value$2.Lscalacss_internal_ValueT__f_value)));
  var $$x690 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2165 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$77 = 24;
  var u$37 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$208 = new $c_Lscalacss_internal_Length(this$$77, u$37);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$95 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$50) => {
    var x$3$54 = $as_Lscalacss_internal_Length(x$3$2$50);
    return $n(x$3$54).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$207 = new $c_sjsr_AnonFunction1(((x$1$2$104) => {
    var x$1$107 = $as_Lscalacss_internal_ValueT(x$1$2$104);
    return $n(x$1$107)
  }));
  var bc$95 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$207);
  var r$105 = $n(ab$95).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$95);
  var v$265 = $n(r$105).apply__O__Lscalacss_internal_ValueT(f$208);
  var v$266 = $n(v$265).Lscalacss_internal_ValueT__f_value;
  var $$x689 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x690).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2165.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$266)));
  var $$x688 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2175 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$78 = 24;
  var u$38 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$210 = new $c_Lscalacss_internal_Length(this$$78, u$38);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$96 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$51) => {
    var x$3$55 = $as_Lscalacss_internal_Length(x$3$2$51);
    return $n(x$3$55).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$209 = new $c_sjsr_AnonFunction1(((x$1$2$105) => {
    var x$1$108 = $as_Lscalacss_internal_ValueT(x$1$2$105);
    return $n(x$1$108)
  }));
  var bc$96 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$209);
  var r$106 = $n(ab$96).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$96);
  var v$267 = $n(r$106).apply__O__Lscalacss_internal_ValueT(f$210);
  var v$268 = $n(v$267).Lscalacss_internal_ValueT__f_value;
  var $$x687 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x688).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2175.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$268)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x686 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$2176 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p$6 = $m_Lscalacss_internal_Pseudo$Hover$();
  var $$x685 = this$2176.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p$6);
  var this$2178 = $m_s_$less$colon$less$();
  var $$x684 = $n($n($$x686).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x685, this$2178.s_$less$colon$less$__f_singleton));
  var $$x683 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$29 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var value$3 = new $c_Lscalacss_internal_ValueT("#fff");
  var array$161 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x683).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$29, value$3.Lscalacss_internal_ValueT__f_value)))];
  var x$104 = $n($$x684).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$161), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$162 = [$$x691, $$x689, $$x687, new $c_Lscalacss_internal_DslBase$ToStyle(x$104)];
  var array$163 = [$$x698, $$x696, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x695).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x694).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x693, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$162), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  var array$164 = [$$x722, $$x720, $$x718, $$x716, $$x714, $$x712, $$x710, $$x706, $$x705, $$x703, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x702).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x701).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x700, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$163), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_drawingToolbar = $n($$x724).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$164), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x730 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes(this, "cursorBreath");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$79 = 0;
  var self = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$79);
  var $$x728 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle(this);
  var $$x727 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$2207 = $n($m_Lcom_iz2use_react_style_package$().svgR__Lcom_iz2use_react_style_ExtendedStyles$svgR$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$107 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$3) => {
    var x$6$6 = $uI(x$6$2$3);
    return ("" + x$6$6)
  })));
  var v$269 = $n(r$107).apply__O__Lscalacss_internal_ValueT(5);
  var v$270 = $n(v$269).Lscalacss_internal_ValueT__f_value;
  var array$165 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x727).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2207.Lcom_iz2use_react_style_ExtendedStyles$svgR$__f_attr, v$270)))];
  var y = $n($$x728).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$165), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x729 = $ct_T2__O__O__(new $c_T2(), self, y);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$80 = 100;
  var self$1 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$80);
  var $$x726 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle(this);
  var $$x725 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$2219 = $n($m_Lcom_iz2use_react_style_package$().svgR__Lcom_iz2use_react_style_ExtendedStyles$svgR$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$108 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$4) => {
    var x$6$7 = $uI(x$6$2$4);
    return ("" + x$6$7)
  })));
  var v$271 = $n(r$108).apply__O__Lscalacss_internal_ValueT(10);
  var v$272 = $n(v$271).Lscalacss_internal_ValueT__f_value;
  var array$166 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x725).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2219.Lcom_iz2use_react_style_ExtendedStyles$svgR$__f_attr, v$272)))];
  var y$1 = $n($$x726).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$166), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$167 = [$$x729, $ct_T2__O__O__(new $c_T2(), self$1, y$1)];
  this.Lreactbuild_Style$__f_cursorBreath = $n($$x730).apply__sci_Seq__Lscalacss_internal_Keyframes($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$167));
  var $$x755 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "drawingRemoteCursor");
  var $$x754 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$30 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var value$4 = new $c_Lscalacss_internal_ValueT("hsla(0,100%,50%,.5)");
  var $$x753 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x754).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$30, value$4.Lscalacss_internal_ValueT__f_value)));
  var $$x752 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$2236 = $n($m_Lcom_iz2use_react_style_package$().svgR__Lcom_iz2use_react_style_ExtendedStyles$svgR$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$109 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$5) => {
    var x$6$8 = $uI(x$6$2$5);
    return ("" + x$6$8)
  })));
  var v$273 = $n(r$109).apply__O__Lscalacss_internal_ValueT(5);
  var v$274 = $n(v$273).Lscalacss_internal_ValueT__f_value;
  var $$x751 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x752).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2236.Lcom_iz2use_react_style_ExtendedStyles$svgR$__f_attr, v$274)));
  var $$x750 = new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $m_Lscalacss_internal_Attrs$animationName$()).apply__Lscalacss_internal_Keyframes__Lscalacss_internal_AV(this.Lreactbuild_Style$__f_cursorBreath)));
  var $$x749 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x748 = $m_Lscalacss_internal_Attrs$animationDelay$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2240 = new $c_s_concurrent_duration_package$DurationInt(0);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$$81 = this$2240.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var length = new $c_RTLong(this$$81, (this$$81 >> 31));
  var f$211 = new $c_s_concurrent_duration_FiniteDuration(length, unit);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$110 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((d$2) => {
    var d = $as_s_concurrent_duration_FiniteDuration(d$2);
    var x1 = $n(d).s_concurrent_duration_FiniteDuration__f_unit;
    var x$105 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$105 === null)) {
      var $$x746 = (x1 === null)
    } else {
      var this$2245 = $n(x$105);
      var $$x746 = (this$2245 === x1)
    };
    if ($$x746) {
      var $$x745 = true
    } else {
      var x$3$56 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$3$56 === null)) {
        var $$x747 = (x1 === null)
      } else {
        var this$2246 = $n(x$3$56);
        var $$x747 = (this$2246 === x1)
      };
      if ($$x747) {
        var $$x745 = true
      } else {
        var x$5$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
        if ((x$5$6 === null)) {
          var $$x745 = (x1 === null)
        } else {
          var this$2247 = $n(x$5$6);
          var $$x745 = (this$2247 === x1)
        }
      }
    };
    if ($$x745) {
      var this$2248 = $n(d);
      var this$2249 = $n(this$2248.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$2248.s_concurrent_duration_FiniteDuration__f_length);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$2249.RTLong__f_lo, this$2249.RTLong__f_hi) + "ms")
    } else {
      var this$2250 = $n(d);
      var this$2251 = $n(this$2250.s_concurrent_duration_FiniteDuration__f_unit).toSeconds__J__J(this$2250.s_concurrent_duration_FiniteDuration__f_length);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$2251.RTLong__f_lo, this$2251.RTLong__f_hi) + "s")
    }
  })));
  var $$x744 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x749).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x748.apply__Lscalacss_internal_ValueT__sci_Seq__Lscalacss_internal_AV($n(r$110).apply__O__Lscalacss_internal_ValueT(f$211), $m_sci_Nil$())));
  var $$x743 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2254 = $m_Lscalacss_internal_Attrs$animationTimingFunction$();
  var v$275 = $m_Lscalacss_internal_Literal$Typed$easeOut$();
  var v$276 = v$275.Lscalacss_internal_Literal__f_value;
  var $$x742 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x743).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2254.Lscalacss_internal_Attrs$animationTimingFunction$__f_attr, v$276)));
  var $$x741 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x740 = $m_Lscalacss_internal_Attrs$animationDuration$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2257 = new $c_s_concurrent_duration_package$DurationInt(1);
  var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$$82 = this$2257.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var length$1 = new $c_RTLong(this$$82, (this$$82 >> 31));
  var f$212 = new $c_s_concurrent_duration_FiniteDuration(length$1, unit$1);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$111 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((d$2$1) => {
    var d$1 = $as_s_concurrent_duration_FiniteDuration(d$2$1);
    var x1$1 = $n(d$1).s_concurrent_duration_FiniteDuration__f_unit;
    var x$106 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$106 === null)) {
      var $$x738 = (x1$1 === null)
    } else {
      var this$2262 = $n(x$106);
      var $$x738 = (this$2262 === x1$1)
    };
    if ($$x738) {
      var $$x737 = true
    } else {
      var x$3$57 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$3$57 === null)) {
        var $$x739 = (x1$1 === null)
      } else {
        var this$2263 = $n(x$3$57);
        var $$x739 = (this$2263 === x1$1)
      };
      if ($$x739) {
        var $$x737 = true
      } else {
        var x$5$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
        if ((x$5$7 === null)) {
          var $$x737 = (x1$1 === null)
        } else {
          var this$2264 = $n(x$5$7);
          var $$x737 = (this$2264 === x1$1)
        }
      }
    };
    if ($$x737) {
      var this$2265 = $n(d$1);
      var this$2266 = $n(this$2265.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$2265.s_concurrent_duration_FiniteDuration__f_length);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$2266.RTLong__f_lo, this$2266.RTLong__f_hi) + "ms")
    } else {
      var this$2267 = $n(d$1);
      var this$2268 = $n(this$2267.s_concurrent_duration_FiniteDuration__f_unit).toSeconds__J__J(this$2267.s_concurrent_duration_FiniteDuration__f_length);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$2268.RTLong__f_lo, this$2268.RTLong__f_hi) + "s")
    }
  })));
  var $$x736 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x741).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x740.apply__Lscalacss_internal_ValueT__sci_Seq__Lscalacss_internal_AV($n(r$111).apply__O__Lscalacss_internal_ValueT(f$212), $m_sci_Nil$())));
  var $$x735 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2271 = $m_Lscalacss_internal_Attrs$animationIterationCount$();
  var $$x734 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x735).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2271.Lscalacss_internal_Attrs$animationIterationCount$__f_attr, "infinite")));
  var $$x733 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2273 = $m_Lscalacss_internal_Attrs$animationDirection$();
  var $$x732 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x733).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2273.Lscalacss_internal_Attrs$animationDirection$__f_attr, "alternate")));
  var $$x731 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$31 = $m_Lscalacss_internal_Attrs$().transition__Lscalacss_internal_Attr();
  var array$168 = [$$x753, $$x751, $$x750, $$x744, $$x742, $$x736, $$x734, $$x732, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x731).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$31, "cx .5s ease, cy .5s ease")))];
  this.Lreactbuild_Style$__f_drawingRemoteCursor = $n($$x755).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$168), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x762 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2282 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x761 = $n($n($$x762).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2282.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$25$2) => {
    var x$25$1 = $as_Lscalacss_internal_Media$Query(x$25$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$25$1)
  }))));
  var $$x760 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2291 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$83 = 100;
  var f$214 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$83);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$97 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$41) => {
    var x$4$43 = $as_Lscalacss_internal_Percentage(x$4$2$41);
    return $n(x$4$43).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$213 = new $c_sjsr_AnonFunction1(((x$1$2$106) => {
    var x$1$109 = $as_Lscalacss_internal_ValueT(x$1$2$106);
    return $n(x$1$109)
  }));
  var bc$97 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$213);
  var r$112 = $n(ab$97).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$97);
  var v$277 = $n(r$112).apply__O__Lscalacss_internal_ValueT(f$214);
  var v$278 = $n(v$277).Lscalacss_internal_ValueT__f_value;
  var $$x759 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x760).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2291.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$278)));
  var $$x758 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2293 = $m_Lscalacss_internal_Attrs$userSelect$();
  var v$279 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$280 = v$279.Lscalacss_internal_Literal__f_value;
  var array$169 = [$$x759, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x758).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2293.Lscalacss_internal_Attrs$userSelect$__f_attr, v$280)))];
  var x$107 = $n($$x761).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$169), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x757 = new $c_Lscalacss_internal_DslBase$ToStyle(x$107);
  var $$x756 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2307 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$84 = 100;
  var f$216 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$84);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$98 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$42) => {
    var x$4$44 = $as_Lscalacss_internal_Percentage(x$4$2$42);
    return $n(x$4$44).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$215 = new $c_sjsr_AnonFunction1(((x$1$2$107) => {
    var x$1$110 = $as_Lscalacss_internal_ValueT(x$1$2$107);
    return $n(x$1$110)
  }));
  var bc$98 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$215);
  var r$113 = $n(ab$98).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$98);
  var v$281 = $n(r$113).apply__O__Lscalacss_internal_ValueT(f$216);
  var v$282 = $n(v$281).Lscalacss_internal_ValueT__f_value;
  var array$170 = [$$x757, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x756).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2307.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$282)))];
  var t$30 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$170);
  $m_Lreactbuild_package$CssSettings$();
  var c$24 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_containerWrapper = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$30, c$24);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x767 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2321 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$85 = 100;
  var f$218 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$85);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$99 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$43) => {
    var x$4$45 = $as_Lscalacss_internal_Percentage(x$4$2$43);
    return $n(x$4$45).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$217 = new $c_sjsr_AnonFunction1(((x$1$2$108) => {
    var x$1$111 = $as_Lscalacss_internal_ValueT(x$1$2$108);
    return $n(x$1$111)
  }));
  var bc$99 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$217);
  var r$114 = $n(ab$99).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$99);
  var v$283 = $n(r$114).apply__O__Lscalacss_internal_ValueT(f$218);
  var v$284 = $n(v$283).Lscalacss_internal_ValueT__f_value;
  var $$x766 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x767).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2321.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$284)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x765 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2323 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x764 = $n($n($$x765).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2323.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$26$2) => {
    var x$26$1 = $as_Lscalacss_internal_Media$Query(x$26$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$26$1)
  }))));
  var $$x763 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2332 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$86 = 100;
  var f$220 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$86);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$100 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$44) => {
    var x$4$46 = $as_Lscalacss_internal_Percentage(x$4$2$44);
    return $n(x$4$46).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$219 = new $c_sjsr_AnonFunction1(((x$1$2$109) => {
    var x$1$112 = $as_Lscalacss_internal_ValueT(x$1$2$109);
    return $n(x$1$112)
  }));
  var bc$100 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$219);
  var r$115 = $n(ab$100).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$100);
  var v$285 = $n(r$115).apply__O__Lscalacss_internal_ValueT(f$220);
  var v$286 = $n(v$285).Lscalacss_internal_ValueT__f_value;
  var array$171 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x763).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2332.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$286)))];
  var x$108 = $n($$x764).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$171), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$172 = [$$x766, new $c_Lscalacss_internal_DslBase$ToStyle(x$108)];
  var t$31 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$172);
  $m_Lreactbuild_package$CssSettings$();
  var c$25 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_container = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$31, c$25);
  var $$x768 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerContainerWrapper");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$109 = this.Lreactbuild_Style$__f_containerWrapper;
  var array$173 = [new $c_Lscalacss_internal_DslBase$ToStyle(x$109)];
  this.Lreactbuild_Style$__f_plannerContainerWrapper = $n($$x768).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$173), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x775 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$110 = this.Lreactbuild_Style$__f_container;
  var $$x774 = new $c_Lscalacss_internal_DslBase$ToStyle(x$110);
  var $$x773 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$32 = $m_Lscalacss_internal_Attrs$().background__Lscalacss_internal_Attr();
  var $$x772 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x773).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$32, "none")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x771 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2353 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x770 = $n($n($$x771).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2353.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$27$2) => {
    var x$27$1 = $as_Lscalacss_internal_Media$Query(x$27$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$27$1)
  }))));
  var $$x769 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2355 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$287 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$288 = v$287.Lscalacss_internal_Literal__f_value;
  var array$174 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x769).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2355.Lscalacss_internal_Attrs$overflow$__f_attr, v$288)))];
  var x$111 = $n($$x770).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$174), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$175 = [$$x774, $$x772, new $c_Lscalacss_internal_DslBase$ToStyle(x$111)];
  this.Lreactbuild_Style$__f_plannerContainer = $n($$x775).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$175), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x778 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerFixPositions");
  var $$x777 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2366 = $m_Lscalacss_internal_Attrs$position$();
  var $$x776 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x777).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2366.Lscalacss_internal_Attrs$position$__f_attr, "relative")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$112 = this.Lreactbuild_Style$__f_fullArea;
  var array$176 = [$$x776, new $c_Lscalacss_internal_DslBase$ToStyle(x$112)];
  this.Lreactbuild_Style$__f_plannerFixPositions = $n($$x778).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$176), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x790 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerContentWrapper");
  var $$x789 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2373 = $m_Lscalacss_internal_Attrs$position$();
  var $$x788 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x789).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2373.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x787 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2383 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$87 = 4;
  var u$39 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$222 = new $c_Lscalacss_internal_Length(this$$87, u$39);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$101 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$52) => {
    var x$3$58 = $as_Lscalacss_internal_Length(x$3$2$52);
    return $n(x$3$58).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$221 = new $c_sjsr_AnonFunction1(((x$1$2$110) => {
    var x$1$113 = $as_Lscalacss_internal_ValueT(x$1$2$110);
    return $n(x$1$113)
  }));
  var bc$101 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$221);
  var r$116 = $n(ab$101).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$101);
  var v$289 = $n(r$116).apply__O__Lscalacss_internal_ValueT(f$222);
  var v$290 = $n(v$289).Lscalacss_internal_ValueT__f_value;
  var $$x786 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x787).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2383.Lscalacss_internal_Attrs$top$__f_attr, v$290)));
  var $$x785 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2393 = $m_Lscalacss_internal_Attrs$bottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$88 = 0;
  var u$40 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$224 = new $c_Lscalacss_internal_Length(this$$88, u$40);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$102 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$53) => {
    var x$3$59 = $as_Lscalacss_internal_Length(x$3$2$53);
    return $n(x$3$59).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$223 = new $c_sjsr_AnonFunction1(((x$1$2$111) => {
    var x$1$114 = $as_Lscalacss_internal_ValueT(x$1$2$111);
    return $n(x$1$114)
  }));
  var bc$102 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$223);
  var r$117 = $n(ab$102).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$102);
  var v$291 = $n(r$117).apply__O__Lscalacss_internal_ValueT(f$224);
  var v$292 = $n(v$291).Lscalacss_internal_ValueT__f_value;
  var $$x784 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x785).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2393.Lscalacss_internal_Attrs$bottom$__f_attr, v$292)));
  var $$x783 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2403 = $m_Lscalacss_internal_Attrs$right$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$89 = 0;
  var u$41 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$226 = new $c_Lscalacss_internal_Length(this$$89, u$41);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$103 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$54) => {
    var x$3$60 = $as_Lscalacss_internal_Length(x$3$2$54);
    return $n(x$3$60).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$225 = new $c_sjsr_AnonFunction1(((x$1$2$112) => {
    var x$1$115 = $as_Lscalacss_internal_ValueT(x$1$2$112);
    return $n(x$1$115)
  }));
  var bc$103 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$225);
  var r$118 = $n(ab$103).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$103);
  var v$293 = $n(r$118).apply__O__Lscalacss_internal_ValueT(f$226);
  var v$294 = $n(v$293).Lscalacss_internal_ValueT__f_value;
  var $$x782 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x783).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2403.Lscalacss_internal_Attrs$right$__f_attr, v$294)));
  var $$x781 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2413 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$90 = 0;
  var u$42 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$228 = new $c_Lscalacss_internal_Length(this$$90, u$42);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$104 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$55) => {
    var x$3$61 = $as_Lscalacss_internal_Length(x$3$2$55);
    return $n(x$3$61).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$227 = new $c_sjsr_AnonFunction1(((x$1$2$113) => {
    var x$1$116 = $as_Lscalacss_internal_ValueT(x$1$2$113);
    return $n(x$1$116)
  }));
  var bc$104 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$227);
  var r$119 = $n(ab$104).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$104);
  var v$295 = $n(r$119).apply__O__Lscalacss_internal_ValueT(f$228);
  var v$296 = $n(v$295).Lscalacss_internal_ValueT__f_value;
  var $$x780 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x781).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2413.Lscalacss_internal_Attrs$left$__f_attr, v$296)));
  var $$x779 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2415 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$297 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$298 = v$297.Lscalacss_internal_Literal__f_value;
  var array$177 = [$$x788, $$x786, $$x784, $$x782, $$x780, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x779).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2415.Lscalacss_internal_Attrs$overflow$__f_attr, v$298)))];
  this.Lreactbuild_Style$__f_plannerContentWrapper = $n($$x790).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$177), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x797 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerContent");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x796 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2421 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x795 = $n($n($$x796).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2421.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$28$2) => {
    var x$28$1 = $as_Lscalacss_internal_Media$Query(x$28$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$28$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$113 = this.Lreactbuild_Style$__f_fullArea;
  var $$x794 = new $c_Lscalacss_internal_DslBase$ToStyle(x$113);
  var $$x793 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2424 = $m_Lscalacss_internal_Attrs$overflowY$();
  var v$299 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$300 = v$299.Lscalacss_internal_Literal__f_value;
  var array$178 = [$$x794, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x793).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2424.Lscalacss_internal_Attrs$overflowY$__f_attr, v$300)))];
  var x$114 = $n($$x795).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$178), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x792 = new $c_Lscalacss_internal_DslBase$ToStyle(x$114);
  var $$x791 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2431 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$301 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$302 = v$301.Lscalacss_internal_Literal__f_value;
  var array$179 = [$$x792, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x791).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2431.Lscalacss_internal_Attrs$overflowX$__f_attr, v$302)))];
  this.Lreactbuild_Style$__f_plannerContent = $n($$x797).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$179), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x800 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2437 = $m_Lscalacss_internal_Attrs$position$();
  var $$x799 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x800).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2437.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x798 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2439 = $m_Lscalacss_internal_Attrs$boxSizing$();
  var array$180 = [$$x799, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x798).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2439.Lscalacss_internal_Attrs$boxSizing$__f_attr, "border-box")))];
  var t$32 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$180);
  $m_Lreactbuild_package$CssSettings$();
  var c$26 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_plannerTimeRulerMixin = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$32, c$26);
  var $$x808 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerTimeRulerLine");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$115 = this.Lreactbuild_Style$__f_plannerTimeRulerMixin;
  var $$x807 = new $c_Lscalacss_internal_DslBase$ToStyle(x$115);
  var $$x806 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2455 = $m_Lscalacss_internal_Attrs$bottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$91 = 0;
  var u$43 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$230 = new $c_Lscalacss_internal_Length(this$$91, u$43);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$105 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$56) => {
    var x$3$62 = $as_Lscalacss_internal_Length(x$3$2$56);
    return $n(x$3$62).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$229 = new $c_sjsr_AnonFunction1(((x$1$2$114) => {
    var x$1$117 = $as_Lscalacss_internal_ValueT(x$1$2$114);
    return $n(x$1$117)
  }));
  var bc$105 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$229);
  var r$120 = $n(ab$105).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$105);
  var v$303 = $n(r$120).apply__O__Lscalacss_internal_ValueT(f$230);
  var v$304 = $n(v$303).Lscalacss_internal_ValueT__f_value;
  var $$x805 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x806).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2455.Lscalacss_internal_Attrs$bottom$__f_attr, v$304)));
  var $$x804 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x803 = $m_Lscalacss_internal_Attrs$borderLeft$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$92 = 1;
  var u$44 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$232 = new $c_Lscalacss_internal_Length(this$$92, u$44);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$106 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$57) => {
    var x$3$63 = $as_Lscalacss_internal_Length(x$3$2$57);
    return $n(x$3$63).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$231 = new $c_sjsr_AnonFunction1(((x$1$2$115) => {
    var x$1$118 = $as_Lscalacss_internal_ValueT(x$1$2$115);
    return $n(x$1$118)
  }));
  var bc$106 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$231);
  var r$121 = $n(ab$106).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$106);
  var $$x802 = $n(r$121).apply__O__Lscalacss_internal_ValueT(f$232);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$234 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2467 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$107 = this$2467.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$10) => {
    var x$2$12 = $as_Lscalacss_internal_Literal(x$2$2$10);
    return $n(x$2$12).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$233 = new $c_sjsr_AnonFunction1(((x$1$2$116) => {
    var x$1$119 = $as_Lscalacss_internal_ValueT(x$1$2$116);
    return $n(x$1$119)
  }));
  var bc$107 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$233);
  var r$122 = $n(ab$107).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$107);
  var $$x801 = $n(r$122).apply__O__Lscalacss_internal_ValueT(f$234);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$236 = new $c_Lscalacss_internal_ValueT("grey");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$235 = new $c_sjsr_AnonFunction1(((x$1$2$117) => {
    var x$1$120 = $as_Lscalacss_internal_ValueT(x$1$2$117);
    return $n(x$1$120)
  }));
  var r$123 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$235);
  var array$181 = [$$x807, $$x805, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x804).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x803.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x802, $$x801, r$123.apply__O__Lscalacss_internal_ValueT(f$236))))];
  this.Lreactbuild_Style$__f_plannerTimeRulerLine = $n($$x808).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$181), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x820 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerTimeRulerNow");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$116 = this.Lreactbuild_Style$__f_plannerTimeRulerMixin;
  var $$x819 = new $c_Lscalacss_internal_DslBase$ToStyle(x$116);
  var $$x818 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2491 = $m_Lscalacss_internal_Attrs$bottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$93 = 0;
  var u$45 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$238 = new $c_Lscalacss_internal_Length(this$$93, u$45);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$108 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$58) => {
    var x$3$64 = $as_Lscalacss_internal_Length(x$3$2$58);
    return $n(x$3$64).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$237 = new $c_sjsr_AnonFunction1(((x$1$2$118) => {
    var x$1$121 = $as_Lscalacss_internal_ValueT(x$1$2$118);
    return $n(x$1$121)
  }));
  var bc$108 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$237);
  var r$124 = $n(ab$108).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$108);
  var v$305 = $n(r$124).apply__O__Lscalacss_internal_ValueT(f$238);
  var v$306 = $n(v$305).Lscalacss_internal_ValueT__f_value;
  var $$x817 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x818).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2491.Lscalacss_internal_Attrs$bottom$__f_attr, v$306)));
  var $$x816 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2501 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$94 = 0;
  var u$46 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$240 = new $c_Lscalacss_internal_Length(this$$94, u$46);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$109 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$59) => {
    var x$3$65 = $as_Lscalacss_internal_Length(x$3$2$59);
    return $n(x$3$65).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$239 = new $c_sjsr_AnonFunction1(((x$1$2$119) => {
    var x$1$122 = $as_Lscalacss_internal_ValueT(x$1$2$119);
    return $n(x$1$122)
  }));
  var bc$109 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$239);
  var r$125 = $n(ab$109).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$109);
  var v$307 = $n(r$125).apply__O__Lscalacss_internal_ValueT(f$240);
  var v$308 = $n(v$307).Lscalacss_internal_ValueT__f_value;
  var $$x815 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x816).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2501.Lscalacss_internal_Attrs$top$__f_attr, v$308)));
  var $$x814 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x813 = $m_Lscalacss_internal_Attrs$borderLeft$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$95 = 1;
  var u$47 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$242 = new $c_Lscalacss_internal_Length(this$$95, u$47);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$110 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$60) => {
    var x$3$66 = $as_Lscalacss_internal_Length(x$3$2$60);
    return $n(x$3$66).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$241 = new $c_sjsr_AnonFunction1(((x$1$2$120) => {
    var x$1$123 = $as_Lscalacss_internal_ValueT(x$1$2$120);
    return $n(x$1$123)
  }));
  var bc$110 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$241);
  var r$126 = $n(ab$110).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$110);
  var $$x812 = $n(r$126).apply__O__Lscalacss_internal_ValueT(f$242);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$244 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2513 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$111 = this$2513.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$11) => {
    var x$2$13 = $as_Lscalacss_internal_Literal(x$2$2$11);
    return $n(x$2$13).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$243 = new $c_sjsr_AnonFunction1(((x$1$2$121) => {
    var x$1$124 = $as_Lscalacss_internal_ValueT(x$1$2$121);
    return $n(x$1$124)
  }));
  var bc$111 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$243);
  var r$127 = $n(ab$111).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$111);
  var $$x811 = $n(r$127).apply__O__Lscalacss_internal_ValueT(f$244);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$246 = new $c_Lscalacss_internal_ValueT("#2196f3");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$245 = new $c_sjsr_AnonFunction1(((x$1$2$122) => {
    var x$1$125 = $as_Lscalacss_internal_ValueT(x$1$2$122);
    return $n(x$1$125)
  }));
  var r$128 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$245);
  var $$x810 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x814).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x813.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x812, $$x811, r$128.apply__O__Lscalacss_internal_ValueT(f$246))));
  var $$x809 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$33 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var array$182 = [$$x819, $$x817, $$x815, $$x810, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x809).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$33, "-1px 0px 2px 0px #2196f3")))];
  this.Lreactbuild_Style$__f_plannerTimeRulerNow = $n($$x820).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$182), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x827 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerTimeRulerText");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$117 = this.Lreactbuild_Style$__f_plannerTimeRulerMixin;
  var $$x826 = new $c_Lscalacss_internal_DslBase$ToStyle(x$117);
  var $$x825 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2531 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$309 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$310 = v$309.Lscalacss_internal_Literal__f_value;
  var $$x824 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x825).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2531.Lscalacss_internal_Attrs$overflow$__f_attr, v$310)));
  var $$x823 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2533 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var $$x822 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x823).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2533.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")));
  var $$x821 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2543 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$96 = 0.5;
  var u$48 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$248 = new $c_Lscalacss_internal_Length(this$$96, u$48);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$112 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$61) => {
    var x$3$67 = $as_Lscalacss_internal_Length(x$3$2$61);
    return $n(x$3$67).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$247 = new $c_sjsr_AnonFunction1(((x$1$2$123) => {
    var x$1$126 = $as_Lscalacss_internal_ValueT(x$1$2$123);
    return $n(x$1$126)
  }));
  var bc$112 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$247);
  var r$129 = $n(ab$112).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$112);
  var all$6 = $n(r$129).apply__O__Lscalacss_internal_ValueT(f$248);
  var v$311 = $n(all$6).Lscalacss_internal_ValueT__f_value;
  var array$183 = [$$x826, $$x824, $$x822, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x821).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2543.Lscalacss_internal_Attrs$padding$__f_attr, v$311)))];
  this.Lreactbuild_Style$__f_plannerTimeRulerText = $n($$x827).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$183), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x838 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerHorizontalLine");
  var $$x837 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2549 = $m_Lscalacss_internal_Attrs$position$();
  var $$x836 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x837).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2549.Lscalacss_internal_Attrs$position$__f_attr, "relative")));
  var $$x835 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2559 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$97 = 0;
  var u$49 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$250 = new $c_Lscalacss_internal_Length(this$$97, u$49);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$113 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$62) => {
    var x$3$68 = $as_Lscalacss_internal_Length(x$3$2$62);
    return $n(x$3$68).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$249 = new $c_sjsr_AnonFunction1(((x$1$2$124) => {
    var x$1$127 = $as_Lscalacss_internal_ValueT(x$1$2$124);
    return $n(x$1$127)
  }));
  var bc$113 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$249);
  var r$130 = $n(ab$113).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$113);
  var v$312 = $n(r$130).apply__O__Lscalacss_internal_ValueT(f$250);
  var v$313 = $n(v$312).Lscalacss_internal_ValueT__f_value;
  var $$x834 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x835).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2559.Lscalacss_internal_Attrs$left$__f_attr, v$313)));
  var $$x833 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2569 = $m_Lscalacss_internal_Attrs$right$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$98 = 0;
  var u$50 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$252 = new $c_Lscalacss_internal_Length(this$$98, u$50);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$114 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$63) => {
    var x$3$69 = $as_Lscalacss_internal_Length(x$3$2$63);
    return $n(x$3$69).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$251 = new $c_sjsr_AnonFunction1(((x$1$2$125) => {
    var x$1$128 = $as_Lscalacss_internal_ValueT(x$1$2$125);
    return $n(x$1$128)
  }));
  var bc$114 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$251);
  var r$131 = $n(ab$114).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$114);
  var v$314 = $n(r$131).apply__O__Lscalacss_internal_ValueT(f$252);
  var v$315 = $n(v$314).Lscalacss_internal_ValueT__f_value;
  var $$x832 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x833).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2569.Lscalacss_internal_Attrs$right$__f_attr, v$315)));
  var $$x831 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x830 = $m_Lscalacss_internal_Attrs$borderTop$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$99 = 1;
  var u$51 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$254 = new $c_Lscalacss_internal_Length(this$$99, u$51);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$115 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$64) => {
    var x$3$70 = $as_Lscalacss_internal_Length(x$3$2$64);
    return $n(x$3$70).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$253 = new $c_sjsr_AnonFunction1(((x$1$2$126) => {
    var x$1$129 = $as_Lscalacss_internal_ValueT(x$1$2$126);
    return $n(x$1$129)
  }));
  var bc$115 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$253);
  var r$132 = $n(ab$115).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$115);
  var $$x829 = $n(r$132).apply__O__Lscalacss_internal_ValueT(f$254);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$256 = $m_Lscalacss_internal_Literal$Typed$solid$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2581 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$116 = this$2581.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$12) => {
    var x$2$14 = $as_Lscalacss_internal_Literal(x$2$2$12);
    return $n(x$2$14).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$255 = new $c_sjsr_AnonFunction1(((x$1$2$127) => {
    var x$1$130 = $as_Lscalacss_internal_ValueT(x$1$2$127);
    return $n(x$1$130)
  }));
  var bc$116 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$255);
  var r$133 = $n(ab$116).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$116);
  var $$x828 = $n(r$133).apply__O__Lscalacss_internal_ValueT(f$256);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$258 = new $c_Lscalacss_internal_ValueT("grey");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$257 = new $c_sjsr_AnonFunction1(((x$1$2$128) => {
    var x$1$131 = $as_Lscalacss_internal_ValueT(x$1$2$128);
    return $n(x$1$131)
  }));
  var r$134 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$257);
  var array$184 = [$$x836, $$x834, $$x832, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x831).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x830.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x829, $$x828, r$134.apply__O__Lscalacss_internal_ValueT(f$258))))];
  this.Lreactbuild_Style$__f_plannerHorizontalLine = $n($$x838).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$184), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x842 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerLineTopHeader");
  var $$x841 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x840 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$100 = 0.25;
  var u$52 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$260 = new $c_Lscalacss_internal_Length(this$$100, u$52);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$117 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$65) => {
    var x$3$71 = $as_Lscalacss_internal_Length(x$3$2$65);
    return $n(x$3$71).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$259 = new $c_sjsr_AnonFunction1(((x$1$2$129) => {
    var x$1$132 = $as_Lscalacss_internal_ValueT(x$1$2$129);
    return $n(x$1$132)
  }));
  var bc$117 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$259);
  var r$135 = $n(ab$117).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$117);
  var $$x839 = $n(r$135).apply__O__Lscalacss_internal_ValueT(f$260);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$101 = 0.5;
  var u$53 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$262 = new $c_Lscalacss_internal_Length(this$$101, u$53);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$118 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$66) => {
    var x$3$72 = $as_Lscalacss_internal_Length(x$3$2$66);
    return $n(x$3$72).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$261 = new $c_sjsr_AnonFunction1(((x$1$2$130) => {
    var x$1$133 = $as_Lscalacss_internal_ValueT(x$1$2$130);
    return $n(x$1$133)
  }));
  var bc$118 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$261);
  var r$136 = $n(ab$118).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$118);
  var array$185 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x841).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x840.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x839, $n(r$136).apply__O__Lscalacss_internal_ValueT(f$262))))];
  this.Lreactbuild_Style$__f_plannerLineTopHeader = $n($$x842).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$185), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x846 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerLineSideHeader");
  var $$x845 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2617 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$316 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$317 = v$316.Lscalacss_internal_Literal__f_value;
  var $$x844 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x845).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2617.Lscalacss_internal_Attrs$overflow$__f_attr, v$317)));
  var $$x843 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2619 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var array$186 = [$$x844, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x843).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2619.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")))];
  this.Lreactbuild_Style$__f_plannerLineSideHeader = $n($$x846).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$186), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x852 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerEventLines");
  var $$x851 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2625 = $m_Lscalacss_internal_Attrs$position$();
  var $$x850 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x851).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2625.Lscalacss_internal_Attrs$position$__f_attr, "relative")));
  var $$x849 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x848 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$102 = 0.25;
  var u$54 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$264 = new $c_Lscalacss_internal_Length(this$$102, u$54);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$119 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$67) => {
    var x$3$73 = $as_Lscalacss_internal_Length(x$3$2$67);
    return $n(x$3$73).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$263 = new $c_sjsr_AnonFunction1(((x$1$2$131) => {
    var x$1$134 = $as_Lscalacss_internal_ValueT(x$1$2$131);
    return $n(x$1$134)
  }));
  var bc$119 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$263);
  var r$137 = $n(ab$119).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$119);
  var $$x847 = $n(r$137).apply__O__Lscalacss_internal_ValueT(f$264);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$103 = 0.5;
  var u$55 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$266 = new $c_Lscalacss_internal_Length(this$$103, u$55);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$120 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$68) => {
    var x$3$74 = $as_Lscalacss_internal_Length(x$3$2$68);
    return $n(x$3$74).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$265 = new $c_sjsr_AnonFunction1(((x$1$2$132) => {
    var x$1$135 = $as_Lscalacss_internal_ValueT(x$1$2$132);
    return $n(x$1$135)
  }));
  var bc$120 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$265);
  var r$138 = $n(ab$120).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$120);
  var array$187 = [$$x850, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x849).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x848.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x847, $n(r$138).apply__O__Lscalacss_internal_ValueT(f$266))))];
  this.Lreactbuild_Style$__f_plannerEventLines = $n($$x852).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$187), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x856 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerEventLine");
  var $$x855 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2656 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$104 = 0;
  var u$56 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$268 = new $c_Lscalacss_internal_Length(this$$104, u$56);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$121 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$69) => {
    var x$3$75 = $as_Lscalacss_internal_Length(x$3$2$69);
    return $n(x$3$75).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$267 = new $c_sjsr_AnonFunction1(((x$1$2$133) => {
    var x$1$136 = $as_Lscalacss_internal_ValueT(x$1$2$133);
    return $n(x$1$136)
  }));
  var bc$121 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$267);
  var r$139 = $n(ab$121).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$121);
  var v$318 = $n(r$139).apply__O__Lscalacss_internal_ValueT(f$268);
  var v$319 = $n(v$318).Lscalacss_internal_ValueT__f_value;
  var $$x854 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x855).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2656.Lscalacss_internal_Attrs$left$__f_attr, v$319)));
  var $$x853 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2666 = $m_Lscalacss_internal_Attrs$right$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$105 = 0;
  var u$57 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$270 = new $c_Lscalacss_internal_Length(this$$105, u$57);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$122 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$70) => {
    var x$3$76 = $as_Lscalacss_internal_Length(x$3$2$70);
    return $n(x$3$76).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$269 = new $c_sjsr_AnonFunction1(((x$1$2$134) => {
    var x$1$137 = $as_Lscalacss_internal_ValueT(x$1$2$134);
    return $n(x$1$137)
  }));
  var bc$122 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$269);
  var r$140 = $n(ab$122).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$122);
  var v$320 = $n(r$140).apply__O__Lscalacss_internal_ValueT(f$270);
  var v$321 = $n(v$320).Lscalacss_internal_ValueT__f_value;
  var array$188 = [$$x854, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x853).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2666.Lscalacss_internal_Attrs$right$__f_attr, v$321)))];
  this.Lreactbuild_Style$__f_plannerEventLine = $n($$x856).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$188), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x881 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerEvent");
  var $$x880 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2673 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var v$322 = new $c_Lscalacss_internal_ValueT("#ffffff");
  var v$323 = v$322.Lscalacss_internal_ValueT__f_value;
  var $$x879 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x880).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2673.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$323)));
  var $$x878 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2676 = $m_Lscalacss_internal_Attrs$color$();
  var v$324 = new $c_Lscalacss_internal_ValueT("#000000");
  var v$325 = v$324.Lscalacss_internal_ValueT__f_value;
  var $$x877 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x878).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2676.Lscalacss_internal_Attrs$color$__f_attr, v$325)));
  var $$x876 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$34 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var $$x875 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x876).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$34, "2px 2px 4px 0px #888888")));
  var this$2690 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$106 = 0.25;
  var u$58 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$272 = new $c_Lscalacss_internal_Length(this$$106, u$58);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$123 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$71) => {
    var x$3$77 = $as_Lscalacss_internal_Length(x$3$2$71);
    return $n(x$3$77).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$271 = new $c_sjsr_AnonFunction1(((x$1$2$135) => {
    var x$1$138 = $as_Lscalacss_internal_ValueT(x$1$2$135);
    return $n(x$1$138)
  }));
  var bc$123 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$271);
  var r$141 = $n(ab$123).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$123);
  var radius$1 = $n(r$141).apply__O__Lscalacss_internal_ValueT(f$272);
  var v$326 = $n(radius$1).Lscalacss_internal_ValueT__f_value;
  var x$118 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$326);
  var $$x874 = new $c_Lscalacss_internal_DslBase$ToStyle(this$2690.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$118.av__Lscalacss_internal_AV()));
  var $$x873 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2700 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$107 = 0;
  var u$59 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$274 = new $c_Lscalacss_internal_Length(this$$107, u$59);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$124 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$72) => {
    var x$3$78 = $as_Lscalacss_internal_Length(x$3$2$72);
    return $n(x$3$78).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$273 = new $c_sjsr_AnonFunction1(((x$1$2$136) => {
    var x$1$139 = $as_Lscalacss_internal_ValueT(x$1$2$136);
    return $n(x$1$139)
  }));
  var bc$124 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$273);
  var r$142 = $n(ab$124).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$124);
  var v$327 = $n(r$142).apply__O__Lscalacss_internal_ValueT(f$274);
  var v$328 = $n(v$327).Lscalacss_internal_ValueT__f_value;
  var $$x872 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x873).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2700.Lscalacss_internal_Attrs$top$__f_attr, v$328)));
  var $$x871 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x870 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$108 = 0.1;
  var u$60 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$276 = new $c_Lscalacss_internal_Length(this$$108, u$60);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$125 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$73) => {
    var x$3$79 = $as_Lscalacss_internal_Length(x$3$2$73);
    return $n(x$3$79).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$275 = new $c_sjsr_AnonFunction1(((x$1$2$137) => {
    var x$1$140 = $as_Lscalacss_internal_ValueT(x$1$2$137);
    return $n(x$1$140)
  }));
  var bc$125 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$275);
  var r$143 = $n(ab$125).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$125);
  var $$x869 = $n(r$143).apply__O__Lscalacss_internal_ValueT(f$276);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$109 = 0.25;
  var u$61 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$278 = new $c_Lscalacss_internal_Length(this$$109, u$61);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$126 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$74) => {
    var x$3$80 = $as_Lscalacss_internal_Length(x$3$2$74);
    return $n(x$3$80).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$277 = new $c_sjsr_AnonFunction1(((x$1$2$138) => {
    var x$1$141 = $as_Lscalacss_internal_ValueT(x$1$2$138);
    return $n(x$1$141)
  }));
  var bc$126 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$277);
  var r$144 = $n(ab$126).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$126);
  var $$x868 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x871).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x870.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x869, $n(r$144).apply__O__Lscalacss_internal_ValueT(f$278))));
  var $$x867 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x866 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$110 = 0.15;
  var u$62 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$280 = new $c_Lscalacss_internal_Length(this$$110, u$62);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$127 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$75) => {
    var x$3$81 = $as_Lscalacss_internal_Length(x$3$2$75);
    return $n(x$3$81).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$279 = new $c_sjsr_AnonFunction1(((x$1$2$139) => {
    var x$1$142 = $as_Lscalacss_internal_ValueT(x$1$2$139);
    return $n(x$1$142)
  }));
  var bc$127 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$279);
  var r$145 = $n(ab$127).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$127);
  var $$x865 = $n(r$145).apply__O__Lscalacss_internal_ValueT(f$280);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$111 = 0.1;
  var u$63 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$282 = new $c_Lscalacss_internal_Length(this$$111, u$63);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$128 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$76) => {
    var x$3$82 = $as_Lscalacss_internal_Length(x$3$2$76);
    return $n(x$3$82).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$281 = new $c_sjsr_AnonFunction1(((x$1$2$140) => {
    var x$1$143 = $as_Lscalacss_internal_ValueT(x$1$2$140);
    return $n(x$1$143)
  }));
  var bc$128 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$281);
  var r$146 = $n(ab$128).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$128);
  var $$x864 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x867).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x866.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x865, $n(r$146).apply__O__Lscalacss_internal_ValueT(f$282))));
  var $$x863 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2736 = $m_Lscalacss_internal_Attrs$position$();
  var $$x862 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x863).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2736.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x861 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2738 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$329 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$330 = v$329.Lscalacss_internal_Literal__f_value;
  var $$x860 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x861).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2738.Lscalacss_internal_Attrs$overflow$__f_attr, v$330)));
  var $$x859 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2740 = $m_Lscalacss_internal_Attrs$whiteSpace$();
  var $$x858 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x859).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2740.Lscalacss_internal_Attrs$whiteSpace$__f_attr, "nowrap")));
  var $$x857 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$35 = $m_Lscalacss_internal_Attrs$().touchAction__Lscalacss_internal_Attr();
  var array$189 = [$$x879, $$x877, $$x875, $$x874, $$x872, $$x868, $$x864, $$x862, $$x860, $$x858, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x857).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$35, "none")))];
  this.Lreactbuild_Style$__f_plannerEvent = $n($$x881).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$189), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x883 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerEventSelected");
  var $$x882 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2749 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$190 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x882).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2749.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "orange")))];
  this.Lreactbuild_Style$__f_plannerEventSelected = $n($$x883).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$190), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x889 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "plannerEventProgress");
  var $$x888 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2763 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$112 = 0.2;
  var u$64 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$284 = new $c_Lscalacss_internal_Length(this$$112, u$64);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$129 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$77) => {
    var x$3$83 = $as_Lscalacss_internal_Length(x$3$2$77);
    return $n(x$3$83).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$283 = new $c_sjsr_AnonFunction1(((x$1$2$141) => {
    var x$1$144 = $as_Lscalacss_internal_ValueT(x$1$2$141);
    return $n(x$1$144)
  }));
  var bc$129 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$283);
  var r$147 = $n(ab$129).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$129);
  var v$331 = $n(r$147).apply__O__Lscalacss_internal_ValueT(f$284);
  var v$332 = $n(v$331).Lscalacss_internal_ValueT__f_value;
  var $$x887 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x888).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2763.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$332)));
  var $$x886 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2765 = $m_Lscalacss_internal_Attrs$position$();
  var $$x885 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x886).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2765.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x884 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2775 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$113 = 0;
  var u$65 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$286 = new $c_Lscalacss_internal_Length(this$$113, u$65);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$130 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$78) => {
    var x$3$84 = $as_Lscalacss_internal_Length(x$3$2$78);
    return $n(x$3$84).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$285 = new $c_sjsr_AnonFunction1(((x$1$2$142) => {
    var x$1$145 = $as_Lscalacss_internal_ValueT(x$1$2$142);
    return $n(x$1$145)
  }));
  var bc$130 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$285);
  var r$148 = $n(ab$130).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$130);
  var v$333 = $n(r$148).apply__O__Lscalacss_internal_ValueT(f$286);
  var v$334 = $n(v$333).Lscalacss_internal_ValueT__f_value;
  var array$191 = [$$x887, $$x885, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x884).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2775.Lscalacss_internal_Attrs$left$__f_attr, v$334)))];
  this.Lreactbuild_Style$__f_plannerEventProgress = $n($$x889).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$191), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x894 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "entryListContainerWrapper");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$119 = this.Lreactbuild_Style$__f_containerWrapper;
  var $$x893 = new $c_Lscalacss_internal_DslBase$ToStyle(x$119);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x892 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2782 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x891 = $n($n($$x892).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2782.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$29$2) => {
    var x$29$1 = $as_Lscalacss_internal_Media$Query(x$29$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$29$1)
  }))));
  var $$x890 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2784 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$335 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$336 = v$335.Lscalacss_internal_Literal__f_value;
  var array$192 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x890).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2784.Lscalacss_internal_Attrs$overflow$__f_attr, v$336)))];
  var x$120 = $n($$x891).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$192), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$193 = [$$x893, new $c_Lscalacss_internal_DslBase$ToStyle(x$120)];
  $n($$x894).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$193), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x899 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "entryListContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$121 = this.Lreactbuild_Style$__f_container;
  var $$x898 = new $c_Lscalacss_internal_DslBase$ToStyle(x$121);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x897 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2796 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x896 = $n($n($$x897).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2796.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$30$2) => {
    var x$30$1 = $as_Lscalacss_internal_Media$Query(x$30$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$30$1)
  }))));
  var $$x895 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2798 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$337 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$338 = v$337.Lscalacss_internal_Literal__f_value;
  var array$194 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x895).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2798.Lscalacss_internal_Attrs$overflow$__f_attr, v$338)))];
  var x$122 = $n($$x896).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$194), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$195 = [$$x898, new $c_Lscalacss_internal_DslBase$ToStyle(x$122)];
  $n($$x899).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$195), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x919 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "entryListHeader");
  var $$x918 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2816 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$114 = 133;
  var f$288 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$114);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$131 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$45) => {
    var x$4$47 = $as_Lscalacss_internal_Percentage(x$4$2$45);
    return $n(x$4$47).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$287 = new $c_sjsr_AnonFunction1(((x$1$2$143) => {
    var x$1$146 = $as_Lscalacss_internal_ValueT(x$1$2$143);
    return $n(x$1$146)
  }));
  var bc$131 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$287);
  var r$149 = $n(ab$131).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$131);
  var v$339 = $n(r$149).apply__O__Lscalacss_internal_ValueT(f$288);
  var v$340 = $n(v$339).Lscalacss_internal_ValueT__f_value;
  var $$x917 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x918).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2816.Lscalacss_internal_Attrs$fontSize$__f_attr, v$340)));
  var $$x916 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2818 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var $$x915 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x916).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2818.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$341 = $m_Lcom_iz2use_react_style_package$().svgFillColor__Lcom_iz2use_react_style_ExtendedStyles$svgFillColor$();
  var this$2821 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$341);
  var lightVersion = new $c_Lscalacss_internal_ValueT("#000000");
  var darkVersion = new $c_Lscalacss_internal_ValueT("#ffffff");
  var array$196 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$2(this$2821, darkVersion, lightVersion)];
  var t$33 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$196);
  $m_Lreactbuild_package$CssSettings$();
  var c$27 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$289 = new $c_sjsr_AnonFunction1(((x$1$2$144) => {
    var x$1$147 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$144);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$147).light__Lscalacss_internal_AV()))
  }));
  var t$34 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$33, f$289));
  var x$123 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$34, c$27);
  var $$x914 = new $c_Lscalacss_internal_DslBase$ToStyle(x$123);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x913 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2830 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2831 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2830.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x912 = $n($n($$x913).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$2831), new $c_sjsr_AnonFunction1(((x$2$15) => {
    var x$124 = $as_Lscalacss_internal_Media$Query(x$2$15);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$124)
  }))));
  var f$290 = new $c_sjsr_AnonFunction1(((x$2$2$2$3) => {
    var x$2$2$13 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$3);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$13).dark__Lscalacss_internal_AV()))
  }));
  var x$125 = $n($$x912).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$33, f$290)), c$27);
  var array$197 = [$$x914, new $c_Lscalacss_internal_DslBase$ToStyle(x$125)];
  var t$35 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$197);
  var x$126 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$35, c$27);
  var $$x911 = new $c_Lscalacss_internal_DslBase$ToStyle(x$126);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$127 = this.Lreactbuild_Style$__f_flexRow;
  var $$x910 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$127).Lscalacss_internal_StyleA__f_style);
  var $$x909 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2840 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x908 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x909).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2840.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")));
  var $$x907 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x906 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x905 = new $c_sjsr_AnonFunction1(((x$25$3$2) => {
    var x$25$3 = $as_T(x$25$3$2);
    return (x$25$3 + ">DIV")
  }));
  var $$x904 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2842 = $m_Lscalacss_internal_Attrs$display$();
  var $$x903 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x904).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2842.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x902 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2844 = $m_Lscalacss_internal_Attrs$flexDirection$();
  var $$x901 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x902).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2844.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")));
  var $$x900 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2846 = $m_Lscalacss_internal_Attrs$alignItems$();
  var array$198 = [$$x903, $$x901, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x900).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2846.Lscalacss_internal_Attrs$alignItems$__f_attr, "baseline")))];
  var array$199 = [$$x917, $$x915, $$x911, $$x910, $$x908, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x907).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x906).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x905, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$198), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_entryListHeader = $n($$x919).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$199), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x932 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "entryStageLevel");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$342 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var qual$8 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$342);
  var x$20$3$1 = $n(this.Lreactbuild_Style$__f_theme).Lcom_iz2use_react_style_Theme__f_background;
  var x$21$3$1 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var $$x928 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$8, x$20$3$1, x$21$3$1);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$343 = $m_Lscalacss_internal_Attrs$color$();
  var qual$9 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$343);
  var x$22$4 = $n(this.Lreactbuild_Style$__f_theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var x$23$4 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$200 = [$$x928, new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(qual$9, x$22$4, x$23$4)];
  var t$36 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$200);
  $m_Lreactbuild_package$CssSettings$();
  var c$28 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$291 = new $c_sjsr_AnonFunction1(((x$1$2$145) => {
    var x$1$148 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$145);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$148).light__Lscalacss_internal_AV()))
  }));
  var t$37 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$36, f$291));
  var x$128 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$37, c$28);
  var $$x931 = new $c_Lscalacss_internal_DslBase$ToStyle(x$128);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x930 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2865 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$2866 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$2865.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x929 = $n($n($$x930).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$2866), new $c_sjsr_AnonFunction1(((x$2$16) => {
    var x$129 = $as_Lscalacss_internal_Media$Query(x$2$16);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$129)
  }))));
  var f$292 = new $c_sjsr_AnonFunction1(((x$2$2$2$4) => {
    var x$2$2$14 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$4);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$14).dark__Lscalacss_internal_AV()))
  }));
  var x$130 = $n($$x929).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$36, f$292)), c$28);
  var array$201 = [$$x931, new $c_Lscalacss_internal_DslBase$ToStyle(x$130)];
  var t$38 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$201);
  var x$131 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$38, c$28);
  var $$x927 = new $c_Lscalacss_internal_DslBase$ToStyle(x$131);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x926 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2874 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x925 = $n($n($$x926).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($n(this$2874.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$()), new $c_sjsr_AnonFunction1(((x$31$2) => {
    var x$31$1 = $as_Lscalacss_internal_Media$Query(x$31$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$31$1)
  }))));
  var $$x924 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2876 = $m_Lscalacss_internal_Attrs$position$();
  var $$x923 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x924).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2876.Lscalacss_internal_Attrs$position$__f_attr, "sticky")));
  var $$x922 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2886 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$115 = 0;
  var u$66 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$294 = new $c_Lscalacss_internal_Length(this$$115, u$66);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$132 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$79) => {
    var x$3$85 = $as_Lscalacss_internal_Length(x$3$2$79);
    return $n(x$3$85).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$293 = new $c_sjsr_AnonFunction1(((x$1$2$146) => {
    var x$1$149 = $as_Lscalacss_internal_ValueT(x$1$2$146);
    return $n(x$1$149)
  }));
  var bc$132 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$293);
  var r$150 = $n(ab$132).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$132);
  var v$344 = $n(r$150).apply__O__Lscalacss_internal_ValueT(f$294);
  var v$345 = $n(v$344).Lscalacss_internal_ValueT__f_value;
  var $$x921 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x922).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2886.Lscalacss_internal_Attrs$top$__f_attr, v$345)));
  var $$x920 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2891 = $m_Lscalacss_internal_Attrs$zIndex$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$151 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$5$2$1) => {
    var x$5$8 = $uI(x$5$2$1);
    return ("" + x$5$8)
  })));
  var v$346 = $n(r$151).apply__O__Lscalacss_internal_ValueT(1);
  var v$347 = $n(v$346).Lscalacss_internal_ValueT__f_value;
  var array$202 = [$$x923, $$x921, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x920).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2891.Lscalacss_internal_Attrs$zIndex$__f_attr, v$347)))];
  var x$132 = $n($$x925).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$202), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$203 = [$$x927, new $c_Lscalacss_internal_DslBase$ToStyle(x$132)];
  this.Lreactbuild_Style$__f_entryStageLevel = $n($$x932).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$203), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x934 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "entryListEntryTitle");
  var $$x933 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2909 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$116 = 120;
  var f$296 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$116);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$133 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$46) => {
    var x$4$48 = $as_Lscalacss_internal_Percentage(x$4$2$46);
    return $n(x$4$48).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$295 = new $c_sjsr_AnonFunction1(((x$1$2$147) => {
    var x$1$150 = $as_Lscalacss_internal_ValueT(x$1$2$147);
    return $n(x$1$150)
  }));
  var bc$133 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$295);
  var r$152 = $n(ab$133).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$133);
  var v$348 = $n(r$152).apply__O__Lscalacss_internal_ValueT(f$296);
  var v$349 = $n(v$348).Lscalacss_internal_ValueT__f_value;
  var array$204 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x933).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2909.Lscalacss_internal_Attrs$fontSize$__f_attr, v$349)))];
  this.Lreactbuild_Style$__f_entryListEntryTitle = $n($$x934).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$204), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x939 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "entryListEntry");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$133 = this.Lreactbuild_Style$__f_flexColumn;
  var $$x938 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$133).Lscalacss_internal_StyleA__f_style);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x937 = $n($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond(this.portrait__Lscalacss_internal_Media$Query(), new $c_sjsr_AnonFunction1(((x$32$2) => {
    var x$32$1 = $as_Lscalacss_internal_Media$Query(x$32$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$32$1)
  }))));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$134 = this.Lreactbuild_Style$__f_flexColumn;
  var array$205 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$134).Lscalacss_internal_StyleA__f_style)];
  var x$135 = $n($$x937).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$205), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x936 = new $c_Lscalacss_internal_DslBase$ToStyle(x$135);
  var $$x935 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2922 = $m_Lscalacss_internal_Attrs$alignItems$();
  var array$206 = [$$x938, $$x936, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x935).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2922.Lscalacss_internal_Attrs$alignItems$__f_attr, "stretch")))];
  this.Lreactbuild_Style$__f_entryListEntry = $n($$x939).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$206), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x944 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "entryListEntryLabel");
  var $$x943 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$36 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x942 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x943).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$36, "1 75%")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x941 = $n($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond(this.portrait__Lscalacss_internal_Media$Query(), new $c_sjsr_AnonFunction1(((x$33$2) => {
    var x$33$1 = $as_Lscalacss_internal_Media$Query(x$33$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$33$1)
  }))));
  var $$x940 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$37 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$207 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x940).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$37, "inherit")))];
  var x$136 = $n($$x941).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$207), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$208 = [$$x942, new $c_Lscalacss_internal_DslBase$ToStyle(x$136)];
  $n($$x944).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$208), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x948 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "strike");
  var $$x947 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$38 = $m_Lscalacss_internal_Attrs$().textDecoration__Lscalacss_internal_Attr();
  var $$x946 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x947).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$38, "line-through")));
  var $$x945 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2947 = $m_Lscalacss_internal_Attrs$textDecorationColor$();
  var v$350 = new $c_Lscalacss_internal_ValueT("hsla(0,0%,0%,0.4)");
  var v$351 = v$350.Lscalacss_internal_ValueT__f_value;
  var array$209 = [$$x946, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x945).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2947.Lscalacss_internal_Attrs$textDecorationColor$__f_attr, v$351)))];
  this.Lreactbuild_Style$__f_strike = $n($$x948).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$209), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var t$39 = $m_sci_Nil$();
  $m_Lreactbuild_package$CssSettings$();
  var c$29 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$39, c$29);
  var $$x950 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "progressIdle");
  var $$x949 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2958 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$153 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$6) => {
    var x$6$9 = $uI(x$6$2$6);
    return ("" + x$6$9)
  })));
  var v$352 = $n(r$153).apply__O__Lscalacss_internal_ValueT(0);
  var v$353 = $n(v$352).Lscalacss_internal_ValueT__f_value;
  var array$210 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x949).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2958.Lscalacss_internal_Attrs$opacity$__f_attr, v$353)))];
  this.Lreactbuild_Style$__f_progressIdle = $n($$x950).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$210), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x956 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKeyframes(this, "appearing");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$117 = 0;
  var self$2 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$117);
  var $$x954 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle(this);
  var $$x953 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2970 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$154 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$7) => {
    var x$6$10 = $uI(x$6$2$7);
    return ("" + x$6$10)
  })));
  var v$354 = $n(r$154).apply__O__Lscalacss_internal_ValueT(0);
  var v$355 = $n(v$354).Lscalacss_internal_ValueT__f_value;
  var array$211 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x953).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2970.Lscalacss_internal_Attrs$opacity$__f_attr, v$355)))];
  var y$2 = $n($$x954).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$211), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x955 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$118 = 100;
  var self$3 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$118);
  var $$x952 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MKStyle(this);
  var $$x951 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2983 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$155 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$6$2$8) => {
    var x$6$11 = $uI(x$6$2$8);
    return ("" + x$6$11)
  })));
  var v$356 = $n(r$155).apply__O__Lscalacss_internal_ValueT(100);
  var v$357 = $n(v$356).Lscalacss_internal_ValueT__f_value;
  var array$212 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x951).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2983.Lscalacss_internal_Attrs$opacity$__f_attr, v$357)))];
  var y$3 = $n($$x952).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$212), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$213 = [$$x955, $ct_T2__O__O__(new $c_T2(), self$3, y$3)];
  $n($$x956).apply__sci_Seq__Lscalacss_internal_Keyframes($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$213));
  this.Lreactbuild_Style$__f_progressPending = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "progressPending").apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($m_sci_Nil$(), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  this.Lreactbuild_Style$__f_progressCompleted = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "progressCompleted").apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($m_sci_Nil$(), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x958 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "progressFailed");
  var $$x957 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$39 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("fill");
  var value$5 = new $c_Lscalacss_internal_ValueT("#ff0000");
  var array$214 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x957).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$39, value$5.Lscalacss_internal_ValueT__f_value)))];
  this.Lreactbuild_Style$__f_progressFailed = $n($$x958).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$214), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x962 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "textSizeIcon");
  var $$x961 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3012 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$119 = 1;
  var u$67 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$298 = new $c_Lscalacss_internal_Length(this$$119, u$67);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$134 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$80) => {
    var x$3$86 = $as_Lscalacss_internal_Length(x$3$2$80);
    return $n(x$3$86).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$297 = new $c_sjsr_AnonFunction1(((x$1$2$148) => {
    var x$1$151 = $as_Lscalacss_internal_ValueT(x$1$2$148);
    return $n(x$1$151)
  }));
  var bc$134 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$297);
  var r$156 = $n(ab$134).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$134);
  var v$358 = $n(r$156).apply__O__Lscalacss_internal_ValueT(f$298);
  var v$359 = $n(v$358).Lscalacss_internal_ValueT__f_value;
  var $$x960 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x961).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3012.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$359)));
  var $$x959 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3022 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$120 = 1;
  var u$68 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$300 = new $c_Lscalacss_internal_Length(this$$120, u$68);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$135 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$81) => {
    var x$3$87 = $as_Lscalacss_internal_Length(x$3$2$81);
    return $n(x$3$87).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$299 = new $c_sjsr_AnonFunction1(((x$1$2$149) => {
    var x$1$152 = $as_Lscalacss_internal_ValueT(x$1$2$149);
    return $n(x$1$152)
  }));
  var bc$135 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$299);
  var r$157 = $n(ab$135).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$135);
  var v$360 = $n(r$157).apply__O__Lscalacss_internal_ValueT(f$300);
  var v$361 = $n(v$360).Lscalacss_internal_ValueT__f_value;
  var array$215 = [$$x960, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x959).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3022.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$361)))];
  $n($$x962).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$215), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$137 = this.Lreactbuild_Style$__f_withRoundedCorner;
  var array$216 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$137).Lscalacss_internal_StyleA__f_style)];
  var t$40 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$216);
  $m_Lreactbuild_package$CssSettings$();
  var c$30 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  this.Lreactbuild_Style$__f_expandableSelectorMixin = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$40, c$30);
  var this$3045 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF(this, "expandableSelectorStart");
  var f$301 = new $c_sjsr_AnonFunction1(((v$2$1) => {
    $uZ(v$2$1);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var x$138 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_expandableSelectorMixin;
    var $$x966 = new $c_Lscalacss_internal_DslBase$ToStyle(x$138);
    var $$x965 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$3035 = $m_Lscalacss_internal_Attrs$borderTopRightRadius$();
    var v$363 = $m_Lscalacss_internal_Literal$Typed$unset$();
    var v$364 = v$363.Lscalacss_internal_Literal__f_value;
    var $$x964 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x965).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3035.Lscalacss_internal_Attrs$borderTopRightRadius$__f_attr, v$364)));
    var $$x963 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$3038 = $m_Lscalacss_internal_Attrs$borderBottomRightRadius$();
    var v$365 = $m_Lscalacss_internal_Literal$Typed$unset$();
    var v$366 = v$365.Lscalacss_internal_Literal__f_value;
    var array$217 = [$$x966, $$x964, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x963).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3038.Lscalacss_internal_Attrs$borderBottomRightRadius$__f_attr, v$366)))];
    var t$41 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$217);
    $m_Lreactbuild_package$CssSettings$();
    var c$31 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
    return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$41, c$31)
  }));
  this.Lreactbuild_Style$__f_expandableSelectorStart = this$3045.create__s_Option__Lscalacss_internal_Domain__F1__F2__Lscalacss_internal_StyleLookup__F1($m_s_None$(), $m_Lscalacss_internal_Domain$().Lscalacss_internal_Domain$__f_boolean, f$301, $m_Lscalacss_internal_DslMacros$().Lscalacss_internal_DslMacros$__f_defaultStyleFClassNameSuffixB, $m_Lscalacss_internal_StyleLookup$().Lscalacss_internal_StyleLookup$__f_boolean);
  var $$x972 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "expandableSelectorEnd");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$139 = this.Lreactbuild_Style$__f_expandableSelectorMixin;
  var $$x971 = new $c_Lscalacss_internal_DslBase$ToStyle(x$139);
  var $$x970 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3048 = $m_Lscalacss_internal_Attrs$alignSelf$();
  var v$367 = $m_Lscalacss_internal_Literal$Typed$start$();
  var v$368 = v$367.Lscalacss_internal_Literal__f_value;
  var $$x969 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x970).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3048.Lscalacss_internal_Attrs$alignSelf$__f_attr, v$368)));
  var $$x968 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3053 = $m_Lscalacss_internal_Attrs$zIndex$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$158 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$5$2$2) => {
    var x$5$9 = $uI(x$5$2$2);
    return ("" + x$5$9)
  })));
  var v$369 = $n(r$158).apply__O__Lscalacss_internal_ValueT(1);
  var v$370 = $n(v$369).Lscalacss_internal_ValueT__f_value;
  var $$x967 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x968).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3053.Lscalacss_internal_Attrs$zIndex$__f_attr, v$370)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$140 = $n($n($n(this.Lreactbuild_Style$__f_md).Elevation__Lcom_iz2use_react_style_MaterialDesign$Elevation$()).Picker__Lcom_iz2use_react_style_MaterialDesign$Elevation$Picker$()).style__Lscalacss_internal_StyleS();
  var array$218 = [$$x971, $$x969, $$x967, new $c_Lscalacss_internal_DslBase$ToStyle(x$140)];
  this.Lreactbuild_Style$__f_expandableSelectorEnd = $n($$x972).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$218), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x988 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "mapContainer");
  var $$x987 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3060 = $m_Lscalacss_internal_Attrs$position$();
  var $$x986 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x987).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3060.Lscalacss_internal_Attrs$position$__f_attr, "relative")));
  var $$x985 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3069 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$121 = 100;
  var f$303 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$121);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$136 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$47) => {
    var x$4$49 = $as_Lscalacss_internal_Percentage(x$4$2$47);
    return $n(x$4$49).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$302 = new $c_sjsr_AnonFunction1(((x$1$2$150) => {
    var x$1$153 = $as_Lscalacss_internal_ValueT(x$1$2$150);
    return $n(x$1$153)
  }));
  var bc$136 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$302);
  var r$159 = $n(ab$136).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$136);
  var v$371 = $n(r$159).apply__O__Lscalacss_internal_ValueT(f$303);
  var v$372 = $n(v$371).Lscalacss_internal_ValueT__f_value;
  var $$x984 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x985).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3069.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$372)));
  var $$x983 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3078 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$122 = 100;
  var f$305 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$122);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$137 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$48) => {
    var x$4$50 = $as_Lscalacss_internal_Percentage(x$4$2$48);
    return $n(x$4$50).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$304 = new $c_sjsr_AnonFunction1(((x$1$2$151) => {
    var x$1$154 = $as_Lscalacss_internal_ValueT(x$1$2$151);
    return $n(x$1$154)
  }));
  var bc$137 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$304);
  var r$160 = $n(ab$137).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$137);
  var v$373 = $n(r$160).apply__O__Lscalacss_internal_ValueT(f$305);
  var v$374 = $n(v$373).Lscalacss_internal_ValueT__f_value;
  var $$x982 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x983).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3078.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$374)));
  var $$x981 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x980 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x979 = new $c_sjsr_AnonFunction1(((x$26$3$2) => {
    var x$26$3 = $as_T(x$26$3$2);
    return (x$26$3 + " .ol-scale-line")
  }));
  var $$x978 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3081 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$3080 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$375 = $as_Lscalacss_internal_ValueT($f_Lscalacss_internal_ColorOps__rgba__I__I__I__D__O(this$3080, 0, 0, 0, 0.6));
  var v$376 = $n(v$375).Lscalacss_internal_ValueT__f_value;
  var array$219 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x978).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3081.Lscalacss_internal_Attrs$backgroundColor$__f_attr, v$376)))];
  var $$x977 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x981).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x980).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x979, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$219), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x976 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x975 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x974 = new $c_sjsr_AnonFunction1(((x$27$3$2) => {
    var x$27$3 = $as_T(x$27$3$2);
    return (x$27$3 + " .ol-overviewmap")
  }));
  var $$x973 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3095 = $m_Lscalacss_internal_Attrs$bottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$123 = 3;
  var u$69 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$307 = new $c_Lscalacss_internal_Length(this$$123, u$69);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$138 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$82) => {
    var x$3$88 = $as_Lscalacss_internal_Length(x$3$2$82);
    return $n(x$3$88).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$306 = new $c_sjsr_AnonFunction1(((x$1$2$152) => {
    var x$1$155 = $as_Lscalacss_internal_ValueT(x$1$2$152);
    return $n(x$1$155)
  }));
  var bc$138 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$306);
  var r$161 = $n(ab$138).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$138);
  var v$377 = $n(r$161).apply__O__Lscalacss_internal_ValueT(f$307);
  var v$378 = $n(v$377).Lscalacss_internal_ValueT__f_value;
  var array$220 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x973).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3095.Lscalacss_internal_Attrs$bottom$__f_attr, v$378)))];
  var array$221 = [$$x986, $$x984, $$x982, $$x977, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x976).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x975).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x974, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$220), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  this.Lreactbuild_Style$__f_mapContainer = $n($$x988).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$221), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x992 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "mapWrapper");
  var $$x991 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3112 = $m_Lscalacss_internal_Attrs$width$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$124 = 100;
  var f$309 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$124);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$139 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$49) => {
    var x$4$51 = $as_Lscalacss_internal_Percentage(x$4$2$49);
    return $n(x$4$51).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$308 = new $c_sjsr_AnonFunction1(((x$1$2$153) => {
    var x$1$156 = $as_Lscalacss_internal_ValueT(x$1$2$153);
    return $n(x$1$156)
  }));
  var bc$139 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$308);
  var r$162 = $n(ab$139).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$139);
  var v$379 = $n(r$162).apply__O__Lscalacss_internal_ValueT(f$309);
  var v$380 = $n(v$379).Lscalacss_internal_ValueT__f_value;
  var $$x990 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x991).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3112.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$380)));
  var $$x989 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3121 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$125 = 100;
  var f$311 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$125);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$140 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$50) => {
    var x$4$52 = $as_Lscalacss_internal_Percentage(x$4$2$50);
    return $n(x$4$52).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$310 = new $c_sjsr_AnonFunction1(((x$1$2$154) => {
    var x$1$157 = $as_Lscalacss_internal_ValueT(x$1$2$154);
    return $n(x$1$157)
  }));
  var bc$140 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$310);
  var r$163 = $n(ab$140).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$140);
  var v$381 = $n(r$163).apply__O__Lscalacss_internal_ValueT(f$311);
  var v$382 = $n(v$381).Lscalacss_internal_ValueT__f_value;
  var array$222 = [$$x990, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x989).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3121.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$382)))];
  this.Lreactbuild_Style$__f_mapWrapper = $n($$x992).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$222), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1020 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "mapContainerPanel");
  var $$x1019 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3127 = $m_Lscalacss_internal_Attrs$position$();
  var $$x1018 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1019).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3127.Lscalacss_internal_Attrs$position$__f_attr, "absolute")));
  var $$x1017 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3137 = $m_Lscalacss_internal_Attrs$bottom$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$126 = 3;
  var u$70 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$313 = new $c_Lscalacss_internal_Length(this$$126, u$70);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$141 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$83) => {
    var x$3$89 = $as_Lscalacss_internal_Length(x$3$2$83);
    return $n(x$3$89).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$312 = new $c_sjsr_AnonFunction1(((x$1$2$155) => {
    var x$1$158 = $as_Lscalacss_internal_ValueT(x$1$2$155);
    return $n(x$1$158)
  }));
  var bc$141 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$312);
  var r$164 = $n(ab$141).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$141);
  var v$383 = $n(r$164).apply__O__Lscalacss_internal_ValueT(f$313);
  var v$384 = $n(v$383).Lscalacss_internal_ValueT__f_value;
  var $$x1016 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1017).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3137.Lscalacss_internal_Attrs$bottom$__f_attr, v$384)));
  var $$x1015 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3147 = $m_Lscalacss_internal_Attrs$right$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$127 = 1;
  var u$71 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$315 = new $c_Lscalacss_internal_Length(this$$127, u$71);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$142 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$84) => {
    var x$3$90 = $as_Lscalacss_internal_Length(x$3$2$84);
    return $n(x$3$90).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$314 = new $c_sjsr_AnonFunction1(((x$1$2$156) => {
    var x$1$159 = $as_Lscalacss_internal_ValueT(x$1$2$156);
    return $n(x$1$159)
  }));
  var bc$142 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$314);
  var r$165 = $n(ab$142).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$142);
  var v$385 = $n(r$165).apply__O__Lscalacss_internal_ValueT(f$315);
  var v$386 = $n(v$385).Lscalacss_internal_ValueT__f_value;
  var $$x1014 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1015).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3147.Lscalacss_internal_Attrs$right$__f_attr, v$386)));
  var $$x1013 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3157 = $m_Lscalacss_internal_Attrs$left$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$128 = 3;
  var u$72 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$317 = new $c_Lscalacss_internal_Length(this$$128, u$72);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$143 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$85) => {
    var x$3$91 = $as_Lscalacss_internal_Length(x$3$2$85);
    return $n(x$3$91).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$316 = new $c_sjsr_AnonFunction1(((x$1$2$157) => {
    var x$1$160 = $as_Lscalacss_internal_ValueT(x$1$2$157);
    return $n(x$1$160)
  }));
  var bc$143 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$316);
  var r$166 = $n(ab$143).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$143);
  var v$387 = $n(r$166).apply__O__Lscalacss_internal_ValueT(f$317);
  var v$388 = $n(v$387).Lscalacss_internal_ValueT__f_value;
  var $$x1012 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1013).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3157.Lscalacss_internal_Attrs$left$__f_attr, v$388)));
  var $$x1011 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3167 = $m_Lscalacss_internal_Attrs$top$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$129 = 3;
  var u$73 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$319 = new $c_Lscalacss_internal_Length(this$$129, u$73);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$144 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$86) => {
    var x$3$92 = $as_Lscalacss_internal_Length(x$3$2$86);
    return $n(x$3$92).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$318 = new $c_sjsr_AnonFunction1(((x$1$2$158) => {
    var x$1$161 = $as_Lscalacss_internal_ValueT(x$1$2$158);
    return $n(x$1$161)
  }));
  var bc$144 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$318);
  var r$167 = $n(ab$144).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$144);
  var v$389 = $n(r$167).apply__O__Lscalacss_internal_ValueT(f$319);
  var v$390 = $n(v$389).Lscalacss_internal_ValueT__f_value;
  var $$x1010 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1011).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3167.Lscalacss_internal_Attrs$top$__f_attr, v$390)));
  var $$x1009 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3169 = $m_Lscalacss_internal_Attrs$overflow$();
  var v$391 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$392 = v$391.Lscalacss_internal_Literal__f_value;
  var $$x1008 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1009).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3169.Lscalacss_internal_Attrs$overflow$__f_attr, v$392)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$141 = this.Lreactbuild_Style$__f_flexColumn;
  var $$x1007 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$141).Lscalacss_internal_StyleA__f_style);
  var $$x1006 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3172 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var $$x1005 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1006).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3172.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "transparent")));
  var $$x1004 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3174 = $m_Lscalacss_internal_Attrs$pointerEvents$();
  var v$393 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$394 = v$393.Lscalacss_internal_Literal__f_value;
  var $$x1003 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1004).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3174.Lscalacss_internal_Attrs$pointerEvents$__f_attr, v$394)));
  var $$x1002 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3176 = $m_Lscalacss_internal_Attrs$alignItems$();
  var $$x1001 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1002).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3176.Lscalacss_internal_Attrs$alignItems$__f_attr, "flex-end")));
  var $$x1000 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x999 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x998 = new $c_sjsr_AnonFunction1(((x$28$3$2) => {
    var x$28$3 = $as_T(x$28$3$2);
    return (x$28$3 + ">*")
  }));
  var $$x997 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3178 = $m_Lscalacss_internal_Attrs$pointerEvents$();
  var v$395 = $m_Lscalacss_internal_Literal$Typed$initial$();
  var v$396 = v$395.Lscalacss_internal_Literal__f_value;
  var $$x996 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x997).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3178.Lscalacss_internal_Attrs$pointerEvents$__f_attr, v$396)));
  var $$x995 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x994 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$130 = 5;
  var u$74 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$321 = new $c_Lscalacss_internal_Length(this$$130, u$74);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$145 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$87) => {
    var x$3$93 = $as_Lscalacss_internal_Length(x$3$2$87);
    return $n(x$3$93).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$320 = new $c_sjsr_AnonFunction1(((x$1$2$159) => {
    var x$1$162 = $as_Lscalacss_internal_ValueT(x$1$2$159);
    return $n(x$1$162)
  }));
  var bc$145 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$320);
  var r$168 = $n(ab$145).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$145);
  var $$x993 = $n(r$168).apply__O__Lscalacss_internal_ValueT(f$321);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$131 = 0;
  var u$75 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$323 = new $c_Lscalacss_internal_Length(this$$131, u$75);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$146 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$88) => {
    var x$3$94 = $as_Lscalacss_internal_Length(x$3$2$88);
    return $n(x$3$94).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$322 = new $c_sjsr_AnonFunction1(((x$1$2$160) => {
    var x$1$163 = $as_Lscalacss_internal_ValueT(x$1$2$160);
    return $n(x$1$163)
  }));
  var bc$146 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$322);
  var r$169 = $n(ab$146).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$146);
  var array$223 = [$$x996, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x995).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x994.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x993, $n(r$169).apply__O__Lscalacss_internal_ValueT(f$323))))];
  var array$224 = [$$x1018, $$x1016, $$x1014, $$x1012, $$x1010, $$x1008, $$x1007, $$x1005, $$x1003, $$x1001, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1000).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x999).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x998, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$223), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  $n($$x1020).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$224), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1028 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "mapLegend");
  var $$x1027 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3213 = $m_Lscalacss_internal_Attrs$maxHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$132 = 50;
  var f$325 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$132);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$147 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$51) => {
    var x$4$53 = $as_Lscalacss_internal_Percentage(x$4$2$51);
    return $n(x$4$53).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$324 = new $c_sjsr_AnonFunction1(((x$1$2$161) => {
    var x$1$164 = $as_Lscalacss_internal_ValueT(x$1$2$161);
    return $n(x$1$164)
  }));
  var bc$147 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$324);
  var r$170 = $n(ab$147).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$147);
  var v$397 = $n(r$170).apply__O__Lscalacss_internal_ValueT(f$325);
  var v$398 = $n(v$397).Lscalacss_internal_ValueT__f_value;
  var $$x1026 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1027).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3213.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$398)));
  var $$x1025 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3215 = $m_Lscalacss_internal_Attrs$overflowY$();
  var v$399 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$400 = v$399.Lscalacss_internal_Literal__f_value;
  var $$x1024 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1025).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3215.Lscalacss_internal_Attrs$overflowY$__f_attr, v$400)));
  var $$x1023 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3217 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$401 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$402 = v$401.Lscalacss_internal_Literal__f_value;
  var $$x1022 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1023).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3217.Lscalacss_internal_Attrs$overflowX$__f_attr, v$402)));
  var $$x1021 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3226 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$133 = 100;
  var f$327 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$133);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$148 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$52) => {
    var x$4$54 = $as_Lscalacss_internal_Percentage(x$4$2$52);
    return $n(x$4$54).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$326 = new $c_sjsr_AnonFunction1(((x$1$2$162) => {
    var x$1$165 = $as_Lscalacss_internal_ValueT(x$1$2$162);
    return $n(x$1$165)
  }));
  var bc$148 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$326);
  var r$171 = $n(ab$148).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$148);
  var v$403 = $n(r$171).apply__O__Lscalacss_internal_ValueT(f$327);
  var v$404 = $n(v$403).Lscalacss_internal_ValueT__f_value;
  var array$225 = [$$x1026, $$x1024, $$x1022, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1021).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3226.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$404)))];
  $n($$x1028).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$225), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1045 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "mapViewControlOverlay");
  var $$x1044 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3232 = $m_Lscalacss_internal_Attrs$position$();
  var v$405 = $m_Lscalacss_internal_Literal$Typed$initial$();
  var v$406 = v$405.Lscalacss_internal_Literal__f_value;
  var $$x1043 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1044).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3232.Lscalacss_internal_Attrs$position$__f_attr, v$406)));
  var $$x1042 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3235 = $m_Lscalacss_internal_Attrs$overflowX$();
  var v$407 = $m_Lscalacss_internal_Literal$Typed$hidden$();
  var v$408 = v$407.Lscalacss_internal_Literal__f_value;
  var $$x1041 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1042).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3235.Lscalacss_internal_Attrs$overflowX$__f_attr, v$408)));
  var $$x1040 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3237 = $m_Lscalacss_internal_Attrs$overflowY$();
  var v$409 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$410 = v$409.Lscalacss_internal_Literal__f_value;
  var $$x1039 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1040).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3237.Lscalacss_internal_Attrs$overflowY$__f_attr, v$410)));
  var $$x1038 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$40 = $m_Lscalacss_internal_Attrs$().boxShadow__Lscalacss_internal_Attr();
  var $$x1037 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1038).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$40, "2pt 2pt 4pt rgba(0,0,0,.5)")));
  var $$x1036 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3250 = $m_Lscalacss_internal_Attrs$minHeight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$134 = 3;
  var u$76 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$329 = new $c_Lscalacss_internal_Length(this$$134, u$76);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$149 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$89) => {
    var x$3$95 = $as_Lscalacss_internal_Length(x$3$2$89);
    return $n(x$3$95).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$328 = new $c_sjsr_AnonFunction1(((x$1$2$163) => {
    var x$1$166 = $as_Lscalacss_internal_ValueT(x$1$2$163);
    return $n(x$1$166)
  }));
  var bc$149 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$328);
  var r$172 = $n(ab$149).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$149);
  var v$411 = $n(r$172).apply__O__Lscalacss_internal_ValueT(f$329);
  var v$412 = $n(v$411).Lscalacss_internal_ValueT__f_value;
  var $$x1035 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1036).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3250.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$412)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$142 = this.Lreactbuild_Style$__f_withBackground;
  var $$x1034 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$142).Lscalacss_internal_StyleA__f_style);
  var $$x1033 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3260 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$135 = 100;
  var f$331 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$135);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$150 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$53) => {
    var x$4$55 = $as_Lscalacss_internal_Percentage(x$4$2$53);
    return $n(x$4$55).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$330 = new $c_sjsr_AnonFunction1(((x$1$2$164) => {
    var x$1$167 = $as_Lscalacss_internal_ValueT(x$1$2$164);
    return $n(x$1$167)
  }));
  var bc$150 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$330);
  var r$173 = $n(ab$150).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$150);
  var v$413 = $n(r$173).apply__O__Lscalacss_internal_ValueT(f$331);
  var v$414 = $n(v$413).Lscalacss_internal_ValueT__f_value;
  var $$x1032 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1033).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3260.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$414)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1031 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$3261 = $n($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty);
  var p$7 = $m_Lscalacss_internal_Pseudo$Hover$();
  var $$x1030 = this$3261.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond(p$7);
  var this$3263 = $m_s_$less$colon$less$();
  var $$x1029 = $n($n($$x1031).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($$x1030, this$3263.s_$less$colon$less$__f_singleton));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$143 = this.Lreactbuild_Style$__f_withBackground;
  var array$226 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$143).Lscalacss_internal_StyleA__f_style)];
  var x$144 = $n($$x1029).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$226), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$227 = [$$x1043, $$x1041, $$x1039, $$x1037, $$x1035, $$x1034, $$x1032, new $c_Lscalacss_internal_DslBase$ToStyle(x$144)];
  this.Lreactbuild_Style$__f_mapViewControlOverlay = $n($$x1045).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$227), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1049 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "responsiveColumnLayout");
  var $$x1048 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3275 = $m_Lscalacss_internal_Attrs$display$();
  var $$x1047 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1048).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3275.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x1046 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3277 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var array$228 = [$$x1047, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1046).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3277.Lscalacss_internal_Attrs$justifyContent$__f_attr, "space-around")))];
  this.Lreactbuild_Style$__f_responsiveColumnLayout = $n($$x1049).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$228), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1051 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "searchBoxContainer");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$145 = $n($n($n(this.Lreactbuild_Style$__f_md).Elevation__Lcom_iz2use_react_style_MaterialDesign$Elevation$()).Card__Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$()).style__Lscalacss_internal_StyleS();
  var $$x1050 = new $c_Lscalacss_internal_DslBase$ToStyle(x$145);
  var this$3293 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$136 = 0.5;
  var u$77 = $m_Lscalacss_internal_LengthUnit$rem$();
  var f$333 = new $c_Lscalacss_internal_Length(this$$136, u$77);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$151 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$90) => {
    var x$3$96 = $as_Lscalacss_internal_Length(x$3$2$90);
    return $n(x$3$96).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$332 = new $c_sjsr_AnonFunction1(((x$1$2$165) => {
    var x$1$168 = $as_Lscalacss_internal_ValueT(x$1$2$165);
    return $n(x$1$168)
  }));
  var bc$151 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$332);
  var r$174 = $n(ab$151).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$151);
  var radius$2 = $n(r$174).apply__O__Lscalacss_internal_ValueT(f$333);
  var v$415 = $n(radius$2).Lscalacss_internal_ValueT__f_value;
  var x$146 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$415);
  var array$229 = [$$x1050, new $c_Lscalacss_internal_DslBase$ToStyle(this$3293.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$146.av__Lscalacss_internal_AV()))];
  this.Lreactbuild_Style$__f_searchBoxContainer = $n($$x1051).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$229), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var this$3357 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyleF(this, "responsiveColumnLayoutBody");
  var r$176 = new $c_sci_Range$Exclusive(1, 3, 1);
  var f$336 = new $c_sjsr_AnonFunction1(((i$4$2) => {
    var i$4 = $uI(i$4$2);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var $$x1066 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var a$41 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
    var $$x1065 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1066).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$41, "1")));
    var $$x1064 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$3305 = $m_Lscalacss_internal_Attrs$display$();
    var $$x1063 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1064).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3305.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
    var $$x1062 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var a$42 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
    var $$x1061 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1062).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$42, "1fr")));
    var $$x1060 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var a$43 = $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_gridGap;
    var $$x1059 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1060).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$43, "1em")));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var $$x1058 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$3312 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
    var $$x1057 = $n($n($$x1058).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__landscape__O(this$3312), new $c_sjsr_AnonFunction1(((x$2$17) => {
      var x$147 = $as_Lscalacss_internal_Media$Query(x$2$17);
      return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$147)
    }))));
    var $$x1056 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$3322 = $m_Lscalacss_internal_Attrs$maxWidth$();
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$$137 = 1280;
    var u$78 = $m_Lscalacss_internal_LengthUnit$px$();
    var f$335 = new $c_Lscalacss_internal_Length(this$$137, u$78);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var ab$152 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$91) => {
      var x$3$97 = $as_Lscalacss_internal_Length(x$3$2$91);
      return $n(x$3$97).value__T()
    })));
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var f$334 = new $c_sjsr_AnonFunction1(((x$1$2$166) => {
      var x$1$169 = $as_Lscalacss_internal_ValueT(x$1$2$166);
      return $n(x$1$169)
    }));
    var bc$152 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$334);
    var r$175 = $n(ab$152).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$152);
    var v$416 = $n(r$175).apply__O__Lscalacss_internal_ValueT(f$335);
    var v$417 = $n(v$416).Lscalacss_internal_ValueT__f_value;
    var array$230 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1056).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3322.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$417)))];
    var x$148 = $n($$x1057).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$230), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var $$x1055 = new $c_Lscalacss_internal_DslBase$ToStyle(x$148);
    $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
    var this$3328 = $m_Lreactbuild_Style$();
    var x$151 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this$3328, "$anonfun").apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA(new $c_sci_Range$Inclusive(2, i$4, 1).map__F1__sci_IndexedSeq(new $c_sjsr_AnonFunction1(((i$2$2) => {
      var i$2$1 = $uI(i$2$2);
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var $$x1054 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var this$3337 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var this$$138 = 25;
      var u$79 = $m_Lscalacss_internal_LengthUnit$em$();
      var this$3336 = new $c_Lscalacss_internal_Length(this$$138, u$79);
      var m = (((-1) + i$2$1) | 0);
      var N = $m_s_math_Numeric$IntIsIntegral$();
      var v$418 = this$3336.$times__O__s_math_Numeric__Lscalacss_internal_Length(m, N);
      var $$x1053 = $n($n($$x1054).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__minWidth__Lscalacss_internal_Length__O(this$3337, v$418), new $c_sjsr_AnonFunction1(((x$2$18) => {
        var x$149 = $as_Lscalacss_internal_Media$Query(x$2$18);
        return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$149)
      }))));
      var $$x1052 = $m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var a$44 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
      var this$3343 = $n(new $c_sci_Range$Inclusive(1, i$2$1, 1).map__F1__sci_IndexedSeq(new $c_sjsr_AnonFunction1(((x$29$2$1) => {
        $uI(x$29$2$1);
        return "1fr"
      }))));
      var value$6 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3343, "", " ", "");
      var array$231 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1052).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$44, value$6)))];
      var x$150 = $n($$x1053).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$231), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
      return new $c_Lscalacss_internal_DslBase$ToStyle(x$150)
    }))), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
    var array$232 = [$$x1065, $$x1063, $$x1061, $$x1059, $$x1055, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$151).Lscalacss_internal_StyleA__f_style)];
    var t$42 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$232);
    $m_Lreactbuild_package$CssSettings$();
    var c$32 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
    return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$42, c$32)
  }));
  this.Lreactbuild_Style$__f_responsiveColumnLayoutBody = $f_Lscalacss_internal_DslMacros$MStyleF2__int__sci_Range__F1__F1(this$3357, r$176, f$336);
  var $$x1070 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "homeLayout");
  var $$x1069 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3359 = $m_Lscalacss_internal_Attrs$display$();
  var $$x1068 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1069).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3359.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x1067 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3361 = $m_Lscalacss_internal_Attrs$justifyContent$();
  var array$233 = [$$x1068, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1067).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3361.Lscalacss_internal_Attrs$justifyContent$__f_attr, "space-around")))];
  this.Lreactbuild_Style$__f_homeLayout = $n($$x1070).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$233), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1086 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "homeLayoutBody");
  var $$x1085 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$45 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x1084 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1085).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$45, "1")));
  var $$x1083 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3370 = $m_Lscalacss_internal_Attrs$display$();
  var $$x1082 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1083).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3370.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
  var $$x1081 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$46 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
  var $$x1080 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1081).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$46, "1fr")));
  var $$x1079 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$47 = $m_Lcom_iz2use_react_style_package$().Lcom_iz2use_react_style_package$__f_gridGap;
  var $$x1078 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1079).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$47, "1em")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1077 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3377 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var $$x1076 = $n($n($$x1077).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__landscape__O(this$3377), new $c_sjsr_AnonFunction1(((x$34$2) => {
    var x$34$1 = $as_Lscalacss_internal_Media$Query(x$34$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$34$1)
  }))));
  var $$x1075 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3387 = $m_Lscalacss_internal_Attrs$maxWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$139 = 1280;
  var u$80 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$338 = new $c_Lscalacss_internal_Length(this$$139, u$80);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$153 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$92) => {
    var x$3$98 = $as_Lscalacss_internal_Length(x$3$2$92);
    return $n(x$3$98).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$337 = new $c_sjsr_AnonFunction1(((x$1$2$167) => {
    var x$1$170 = $as_Lscalacss_internal_ValueT(x$1$2$167);
    return $n(x$1$170)
  }));
  var bc$153 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$337);
  var r$177 = $n(ab$153).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$153);
  var v$419 = $n(r$177).apply__O__Lscalacss_internal_ValueT(f$338);
  var v$420 = $n(v$419).Lscalacss_internal_ValueT__f_value;
  var array$234 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1075).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3387.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr, v$420)))];
  var x$152 = $n($$x1076).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$234), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1074 = new $c_Lscalacss_internal_DslBase$ToStyle(x$152);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1073 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3397 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$140 = 40;
  var u$81 = $m_Lscalacss_internal_LengthUnit$em$();
  var v$421 = new $c_Lscalacss_internal_Length(this$$140, u$81);
  var $$x1072 = $n($n($$x1073).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__minWidth__Lscalacss_internal_Length__O(this$3397, v$421), new $c_sjsr_AnonFunction1(((x$35$2) => {
    var x$35$1 = $as_Lscalacss_internal_Media$Query(x$35$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$35$1)
  }))));
  var $$x1071 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$48 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
  var array$235 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1071).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$48, "1fr 1fr")))];
  var x$153 = $n($$x1072).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$235), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$236 = [$$x1084, $$x1082, $$x1080, $$x1078, $$x1074, new $c_Lscalacss_internal_DslBase$ToStyle(x$153)];
  this.Lreactbuild_Style$__f_homeLayoutBody = $n($$x1086).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$236), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1096 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "homeProjectList");
  var $$x1095 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3411 = $m_Lscalacss_internal_Attrs$display$();
  var $$x1094 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1095).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3411.Lscalacss_internal_Attrs$display$__f_attr, "grid")));
  var $$x1093 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$49 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
  var $$x1092 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1093).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$49, "1fr")));
  var $$x1091 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$50 = $m_Lscalacss_internal_Attrs$().gridAutoRows__Lscalacss_internal_Attr();
  var $$x1090 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1091).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$50, "auto")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1089 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3422 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$141 = 30;
  var u$82 = $m_Lscalacss_internal_LengthUnit$em$();
  var v$422 = new $c_Lscalacss_internal_Length(this$$141, u$82);
  var $$x1088 = $n($n($$x1089).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__minWidth__Lscalacss_internal_Length__O(this$3422, v$422), new $c_sjsr_AnonFunction1(((x$36$2) => {
    var x$36$1 = $as_Lscalacss_internal_Media$Query(x$36$2);
    return $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$36$1)
  }))));
  var $$x1087 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$51 = $m_Lscalacss_internal_Attrs$().gridTemplateColumns__Lscalacss_internal_Attr();
  var array$237 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1087).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$51, "1fr 1fr")))];
  var x$154 = $n($$x1088).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$237), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$238 = [$$x1094, $$x1092, $$x1090, new $c_Lscalacss_internal_DslBase$ToStyle(x$154)];
  this.Lreactbuild_Style$__f_homeProjectList = $n($$x1096).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$238), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1099 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "homeProjectListItem");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$155 = this.Lreactbuild_Style$__f_flexColumn;
  var $$x1098 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$155).Lscalacss_internal_StyleA__f_style);
  var $$x1097 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3445 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$142 = 0.5;
  var u$83 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$340 = new $c_Lscalacss_internal_Length(this$$142, u$83);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$154 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$93) => {
    var x$3$99 = $as_Lscalacss_internal_Length(x$3$2$93);
    return $n(x$3$99).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$339 = new $c_sjsr_AnonFunction1(((x$1$2$168) => {
    var x$1$171 = $as_Lscalacss_internal_ValueT(x$1$2$168);
    return $n(x$1$171)
  }));
  var bc$154 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$339);
  var r$178 = $n(ab$154).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$154);
  var all$7 = $n(r$178).apply__O__Lscalacss_internal_ValueT(f$340);
  var v$423 = $n(all$7).Lscalacss_internal_ValueT__f_value;
  var array$239 = [$$x1098, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1097).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3445.Lscalacss_internal_Attrs$margin$__f_attr, v$423)))];
  this.Lreactbuild_Style$__f_homeProjectListItem = $n($$x1099).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$239), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1111 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "homeProjectListItemImage");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$156 = this.Lreactbuild_Style$__f_flexRow;
  var $$x1110 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$156).Lscalacss_internal_StyleA__f_style);
  var $$x1109 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3460 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$143 = 0.5;
  var u$84 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$342 = new $c_Lscalacss_internal_Length(this$$143, u$84);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$155 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$94) => {
    var x$3$100 = $as_Lscalacss_internal_Length(x$3$2$94);
    return $n(x$3$100).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$341 = new $c_sjsr_AnonFunction1(((x$1$2$169) => {
    var x$1$172 = $as_Lscalacss_internal_ValueT(x$1$2$169);
    return $n(x$1$172)
  }));
  var bc$155 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$341);
  var r$179 = $n(ab$155).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$155);
  var all$8 = $n(r$179).apply__O__Lscalacss_internal_ValueT(f$342);
  var v$424 = $n(all$8).Lscalacss_internal_ValueT__f_value;
  var $$x1108 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1109).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3460.Lscalacss_internal_Attrs$padding$__f_attr, v$424)));
  var this$3471 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$144 = 0.25;
  var u$85 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$344 = new $c_Lscalacss_internal_Length(this$$144, u$85);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$156 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$95) => {
    var x$3$101 = $as_Lscalacss_internal_Length(x$3$2$95);
    return $n(x$3$101).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$343 = new $c_sjsr_AnonFunction1(((x$1$2$170) => {
    var x$1$173 = $as_Lscalacss_internal_ValueT(x$1$2$170);
    return $n(x$1$173)
  }));
  var bc$156 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$343);
  var r$180 = $n(ab$156).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$156);
  var radius$3 = $n(r$180).apply__O__Lscalacss_internal_ValueT(f$344);
  var v$425 = $n(radius$3).Lscalacss_internal_ValueT__f_value;
  var x$157 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$425);
  var $$x1107 = new $c_Lscalacss_internal_DslBase$ToStyle(this$3471.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$157.av__Lscalacss_internal_AV()));
  var $$x1106 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$52 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-position");
  var $$x1105 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1106).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$52, "50% 50%")));
  var $$x1104 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$53 = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-size");
  var $$x1103 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1104).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$53, "cover")));
  var $$x1102 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$54 = $m_Lscalacss_internal_Attrs$backgroundRepeat$();
  var $$x1101 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1102).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$54.Lscalacss_internal_Attrs$backgroundRepeat$__f_attr, "no-repeat")));
  var $$x1100 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3493 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$145 = 8;
  var u$86 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$346 = new $c_Lscalacss_internal_Length(this$$145, u$86);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$157 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$96) => {
    var x$3$102 = $as_Lscalacss_internal_Length(x$3$2$96);
    return $n(x$3$102).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$345 = new $c_sjsr_AnonFunction1(((x$1$2$171) => {
    var x$1$174 = $as_Lscalacss_internal_ValueT(x$1$2$171);
    return $n(x$1$174)
  }));
  var bc$157 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$345);
  var r$181 = $n(ab$157).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$157);
  var v$426 = $n(r$181).apply__O__Lscalacss_internal_ValueT(f$346);
  var v$427 = $n(v$426).Lscalacss_internal_ValueT__f_value;
  var array$240 = [$$x1110, $$x1108, $$x1107, $$x1105, $$x1103, $$x1101, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1100).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3493.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$427)))];
  this.Lreactbuild_Style$__f_homeProjectListItemImage = $n($$x1111).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$240), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1113 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "homeProjectListItemImageAbsent");
  var $$x1112 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3499 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$241 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1112).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3499.Lscalacss_internal_Attrs$backgroundColor$__f_attr, "gray")))];
  this.Lreactbuild_Style$__f_homeProjectListItemImageAbsent = $n($$x1113).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$241), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1130 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "homeProjectListItemTitle");
  var $$x1129 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3505 = $m_Lscalacss_internal_Attrs$alignSelf$();
  var $$x1128 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1129).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3505.Lscalacss_internal_Attrs$alignSelf$__f_attr, "flex-end")));
  var this$3516 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $m_Lscalacss_internal_Attrs$borderRadius$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$146 = 0.25;
  var u$87 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$348 = new $c_Lscalacss_internal_Length(this$$146, u$87);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$158 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$97) => {
    var x$3$103 = $as_Lscalacss_internal_Length(x$3$2$97);
    return $n(x$3$103).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$347 = new $c_sjsr_AnonFunction1(((x$1$2$172) => {
    var x$1$175 = $as_Lscalacss_internal_ValueT(x$1$2$172);
    return $n(x$1$175)
  }));
  var bc$158 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$347);
  var r$182 = $n(ab$158).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$158);
  var radius$4 = $n(r$182).apply__O__Lscalacss_internal_ValueT(f$348);
  var v$428 = $n(radius$4).Lscalacss_internal_ValueT__f_value;
  var x$158 = new $c_Lscalacss_internal_Attrs$BorderRadiusNext(v$428);
  var $$x1127 = new $c_Lscalacss_internal_DslBase$ToStyle(this$3516.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(x$158.av__Lscalacss_internal_AV()));
  var $$x1126 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3525 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$147 = 110;
  var f$350 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$147);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$159 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$54) => {
    var x$4$56 = $as_Lscalacss_internal_Percentage(x$4$2$54);
    return $n(x$4$56).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$349 = new $c_sjsr_AnonFunction1(((x$1$2$173) => {
    var x$1$176 = $as_Lscalacss_internal_ValueT(x$1$2$173);
    return $n(x$1$176)
  }));
  var bc$159 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$349);
  var r$183 = $n(ab$159).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$159);
  var v$429 = $n(r$183).apply__O__Lscalacss_internal_ValueT(f$350);
  var v$430 = $n(v$429).Lscalacss_internal_ValueT__f_value;
  var $$x1125 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1126).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3525.Lscalacss_internal_Attrs$fontSize$__f_attr, v$430)));
  var $$x1124 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$55 = $m_Lscalacss_internal_Attrs$padding$();
  var $$x1123 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1124).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$55.Lscalacss_internal_Attrs$padding$__f_attr, ".1em .25em")));
  var $$x1122 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3531 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var $$x1121 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1122).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3531.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bolder")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$431 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var this$3533 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$431);
  var colors = $n(this.Lreactbuild_Style$__f_theme).Lcom_iz2use_react_style_Theme__f_background;
  var opacity = $m_Lcom_iz2use_react_style_OpacityLevel$high$();
  var array$242 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$3533, colors, opacity)];
  var t$43 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$242);
  $m_Lreactbuild_package$CssSettings$();
  var c$33 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$351 = new $c_sjsr_AnonFunction1(((x$1$2$174) => {
    var x$1$177 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$174);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$177).light__Lscalacss_internal_AV()))
  }));
  var t$44 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$43, f$351));
  var x$159 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$44, c$33);
  var $$x1120 = new $c_Lscalacss_internal_DslBase$ToStyle(x$159);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1119 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3542 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$3543 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$3542.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x1118 = $n($n($$x1119).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$3543), new $c_sjsr_AnonFunction1(((x$2$19) => {
    var x$160 = $as_Lscalacss_internal_Media$Query(x$2$19);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$160)
  }))));
  var f$352 = new $c_sjsr_AnonFunction1(((x$2$2$2$5) => {
    var x$2$2$15 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$5);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$15).dark__Lscalacss_internal_AV()))
  }));
  var x$161 = $n($$x1118).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$43, f$352)), c$33);
  var array$243 = [$$x1120, new $c_Lscalacss_internal_DslBase$ToStyle(x$161)];
  var t$45 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$243);
  var x$162 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$45, c$33);
  var $$x1117 = new $c_Lscalacss_internal_DslBase$ToStyle(x$162);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$432 = $m_Lscalacss_internal_Attrs$color$();
  var this$3551 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase(this, v$432);
  var colors$1 = $n(this.Lreactbuild_Style$__f_theme).Lcom_iz2use_react_style_Theme__f_foreground;
  var opacity$1 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var array$244 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichTypedAttrBase$$anon$3(this$3551, colors$1, opacity$1)];
  var t$46 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$244);
  $m_Lreactbuild_package$CssSettings$();
  var c$34 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$353 = new $c_sjsr_AnonFunction1(((x$1$2$175) => {
    var x$1$178 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$175);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$178).light__Lscalacss_internal_AV()))
  }));
  var t$47 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$46, f$353));
  var x$163 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$47, c$34);
  var $$x1116 = new $c_Lscalacss_internal_DslBase$ToStyle(x$163);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1115 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3560 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$3561 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$3560.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x1114 = $n($n($$x1115).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$3561), new $c_sjsr_AnonFunction1(((x$2$20) => {
    var x$164 = $as_Lscalacss_internal_Media$Query(x$2$20);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$164)
  }))));
  var f$354 = new $c_sjsr_AnonFunction1(((x$2$2$2$6) => {
    var x$2$2$16 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$6);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$16).dark__Lscalacss_internal_AV()))
  }));
  var x$165 = $n($$x1114).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$46, f$354)), c$34);
  var array$245 = [$$x1116, new $c_Lscalacss_internal_DslBase$ToStyle(x$165)];
  var t$48 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$245);
  var x$166 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$48, c$34);
  var array$246 = [$$x1128, $$x1127, $$x1125, $$x1123, $$x1121, $$x1117, new $c_Lscalacss_internal_DslBase$ToStyle(x$166)];
  this.Lreactbuild_Style$__f_homeProjectListItemTitle = $n($$x1130).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$246), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1132 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "homeOtherActionListItemLink");
  var $$x1131 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$56 = $m_Lscalacss_internal_Attrs$lineHeight$();
  var array$247 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1131).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$56.Lscalacss_internal_Attrs$lineHeight$__f_attr, "2.5em")))];
  this.Lreactbuild_Style$__f_homeOtherActionListItemLink = $n($$x1132).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$247), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1147 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "projectImageListInsertionPoint");
  var $$x1146 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3589 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$148 = 5;
  var u$88 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$356 = new $c_Lscalacss_internal_Length(this$$148, u$88);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$160 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$98) => {
    var x$3$104 = $as_Lscalacss_internal_Length(x$3$2$98);
    return $n(x$3$104).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$355 = new $c_sjsr_AnonFunction1(((x$1$2$176) => {
    var x$1$179 = $as_Lscalacss_internal_ValueT(x$1$2$176);
    return $n(x$1$179)
  }));
  var bc$160 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$355);
  var r$184 = $n(ab$160).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$160);
  var v$433 = $n(r$184).apply__O__Lscalacss_internal_ValueT(f$356);
  var v$434 = $n(v$433).Lscalacss_internal_ValueT__f_value;
  var $$x1145 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1146).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3589.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$434)));
  var $$x1144 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$57 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var $$x1143 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1144).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$57, "1")));
  var $$x1142 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3602 = $m_Lscalacss_internal_Attrs$minWidth$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$149 = 5;
  var u$89 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$358 = new $c_Lscalacss_internal_Length(this$$149, u$89);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$161 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$99) => {
    var x$3$105 = $as_Lscalacss_internal_Length(x$3$2$99);
    return $n(x$3$105).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$357 = new $c_sjsr_AnonFunction1(((x$1$2$177) => {
    var x$1$180 = $as_Lscalacss_internal_ValueT(x$1$2$177);
    return $n(x$1$180)
  }));
  var bc$161 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$357);
  var r$185 = $n(ab$161).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$161);
  var v$435 = $n(r$185).apply__O__Lscalacss_internal_ValueT(f$358);
  var v$436 = $n(v$435).Lscalacss_internal_ValueT__f_value;
  var $$x1141 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1142).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3602.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr, v$436)));
  var $$x1140 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1139 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$150 = 0.5;
  var u$90 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$360 = new $c_Lscalacss_internal_Length(this$$150, u$90);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$162 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$100) => {
    var x$3$106 = $as_Lscalacss_internal_Length(x$3$2$100);
    return $n(x$3$106).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$359 = new $c_sjsr_AnonFunction1(((x$1$2$178) => {
    var x$1$181 = $as_Lscalacss_internal_ValueT(x$1$2$178);
    return $n(x$1$181)
  }));
  var bc$162 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$359);
  var r$186 = $n(ab$162).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$162);
  var $$x1138 = $n(r$186).apply__O__Lscalacss_internal_ValueT(f$360);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$151 = 0.2;
  var u$91 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$362 = new $c_Lscalacss_internal_Length(this$$151, u$91);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$163 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$101) => {
    var x$3$107 = $as_Lscalacss_internal_Length(x$3$2$101);
    return $n(x$3$107).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$361 = new $c_sjsr_AnonFunction1(((x$1$2$179) => {
    var x$1$182 = $as_Lscalacss_internal_ValueT(x$1$2$179);
    return $n(x$1$182)
  }));
  var bc$163 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$361);
  var r$187 = $n(ab$163).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$163);
  var $$x1137 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1140).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x1139.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x1138, $n(r$187).apply__O__Lscalacss_internal_ValueT(f$362))));
  var $$x1136 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1135 = $m_Lscalacss_internal_Attrs$border$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$152 = 2;
  var u$92 = $m_Lscalacss_internal_LengthUnit$px$();
  var f$364 = new $c_Lscalacss_internal_Length(this$$152, u$92);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$164 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$102) => {
    var x$3$108 = $as_Lscalacss_internal_Length(x$3$2$102);
    return $n(x$3$108).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$363 = new $c_sjsr_AnonFunction1(((x$1$2$180) => {
    var x$1$183 = $as_Lscalacss_internal_ValueT(x$1$2$180);
    return $n(x$1$183)
  }));
  var bc$164 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$363);
  var r$188 = $n(ab$164).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$164);
  var $$x1134 = $n(r$188).apply__O__Lscalacss_internal_ValueT(f$364);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$366 = $m_Lscalacss_internal_Literal$Typed$dashed$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3631 = $m_Lscalacss_internal_ValueT$Rule$();
  var ab$165 = this$3631.apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$2$2$17) => {
    var x$2$21 = $as_Lscalacss_internal_Literal(x$2$2$17);
    return $n(x$2$21).Lscalacss_internal_Literal__f_value
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$365 = new $c_sjsr_AnonFunction1(((x$1$2$181) => {
    var x$1$184 = $as_Lscalacss_internal_ValueT(x$1$2$181);
    return $n(x$1$184)
  }));
  var bc$165 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$365);
  var r$189 = $n(ab$165).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$165);
  var $$x1133 = $n(r$189).apply__O__Lscalacss_internal_ValueT(f$366);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$368 = new $c_Lscalacss_internal_ValueT("transparent");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$367 = new $c_sjsr_AnonFunction1(((x$1$2$182) => {
    var x$1$185 = $as_Lscalacss_internal_ValueT(x$1$2$182);
    return $n(x$1$185)
  }));
  var r$190 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$367);
  var array$248 = [$$x1145, $$x1143, $$x1141, $$x1137, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1136).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x1135.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x1134, $$x1133, r$190.apply__O__Lscalacss_internal_ValueT(f$368))))];
  this.Lreactbuild_Style$__f_projectImageListInsertionPoint = $n($$x1147).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$248), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1149 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "projectImageListInsertionPointDragging");
  var $$x1148 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3646 = $m_Lscalacss_internal_Attrs$borderColor$();
  var array$249 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1148).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3646.Lscalacss_internal_Attrs$borderColor$__f_attr, "gray")))];
  this.Lreactbuild_Style$__f_projectImageListInsertionPointDragging = $n($$x1149).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$249), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1151 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "projectImageListInsertionPointDragOver");
  var $$x1150 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3652 = $m_Lscalacss_internal_Attrs$borderColor$();
  var array$250 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1150).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3652.Lscalacss_internal_Attrs$borderColor$__f_attr, "orange")))];
  this.Lreactbuild_Style$__f_projectImageListInsertionPointDragOver = $n($$x1151).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$250), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1153 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "projectImageListSpace");
  var $$x1152 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$58 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$251 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1152).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$58, "1 100%")))];
  this.Lreactbuild_Style$__f_projectImageListSpace = $n($$x1153).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$251), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1162 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "projectImageListEntry");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1161 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "projectImageListEntry");
  var $$x1160 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3673 = $m_Lscalacss_internal_Attrs$height$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$153 = 5;
  var u$93 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$370 = new $c_Lscalacss_internal_Length(this$$153, u$93);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$166 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$103) => {
    var x$3$109 = $as_Lscalacss_internal_Length(x$3$2$103);
    return $n(x$3$109).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$369 = new $c_sjsr_AnonFunction1(((x$1$2$183) => {
    var x$1$186 = $as_Lscalacss_internal_ValueT(x$1$2$183);
    return $n(x$1$186)
  }));
  var bc$166 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$369);
  var r$191 = $n(ab$166).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$166);
  var v$437 = $n(r$191).apply__O__Lscalacss_internal_ValueT(f$370);
  var v$438 = $n(v$437).Lscalacss_internal_ValueT__f_value;
  var $$x1159 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1160).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3673.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$438)));
  var $$x1158 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1157 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$154 = 0.5;
  var u$94 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$372 = new $c_Lscalacss_internal_Length(this$$154, u$94);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$167 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$104) => {
    var x$3$110 = $as_Lscalacss_internal_Length(x$3$2$104);
    return $n(x$3$110).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$371 = new $c_sjsr_AnonFunction1(((x$1$2$184) => {
    var x$1$187 = $as_Lscalacss_internal_ValueT(x$1$2$184);
    return $n(x$1$187)
  }));
  var bc$167 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$371);
  var r$192 = $n(ab$167).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$167);
  var $$x1156 = $n(r$192).apply__O__Lscalacss_internal_ValueT(f$372);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$155 = 0;
  var u$95 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$374 = new $c_Lscalacss_internal_Length(this$$155, u$95);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$168 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$105) => {
    var x$3$111 = $as_Lscalacss_internal_Length(x$3$2$105);
    return $n(x$3$111).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$373 = new $c_sjsr_AnonFunction1(((x$1$2$185) => {
    var x$1$188 = $as_Lscalacss_internal_ValueT(x$1$2$185);
    return $n(x$1$188)
  }));
  var bc$168 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$373);
  var r$193 = $n(ab$168).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$168);
  var $$x1155 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1158).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($$x1157.apply__Lscalacss_internal_ValueT__Lscalacss_internal_ValueT__Lscalacss_internal_AV($$x1156, $n(r$193).apply__O__Lscalacss_internal_ValueT(f$374))));
  var $$x1154 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3692 = $m_Lscalacss_internal_Attrs$userSelect$();
  var v$439 = $m_Lscalacss_internal_Literal$Typed$none$();
  var v$440 = v$439.Lscalacss_internal_Literal__f_value;
  var array$252 = [$$x1159, $$x1155, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1154).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3692.Lscalacss_internal_Attrs$userSelect$__f_attr, v$440)))];
  var x$167 = $n($$x1161).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$252), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var array$253 = [new $c_Lscalacss_internal_DslBase$ToStyle($n(x$167).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_projectImageListEntry = $n($$x1162).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$253), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1166 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "projectImageListEntryDragged");
  var $$x1165 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$59 = $m_Lscalacss_internal_Attrs$().transform__Lscalacss_internal_Attr();
  var $$x1164 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1165).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$59, "scale(.9)")));
  var $$x1163 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3709 = $m_Lscalacss_internal_Attrs$opacity$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var r$194 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$7$2$3) => {
    var x$7$8 = $uD(x$7$2$3);
    return ("" + x$7$8)
  })));
  var v$441 = $n(r$194).apply__O__Lscalacss_internal_ValueT(0.5);
  var v$442 = $n(v$441).Lscalacss_internal_ValueT__f_value;
  var array$254 = [$$x1164, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1163).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3709.Lscalacss_internal_Attrs$opacity$__f_attr, v$442)))];
  this.Lreactbuild_Style$__f_projectImageListEntryDragged = $n($$x1166).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$254), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "projectImageListEntryDragOver").apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($m_sci_Nil$(), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1183 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "breadcrumb");
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$168 = this.Lreactbuild_Style$__f_flexRow;
  var $$x1182 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$168).Lscalacss_internal_StyleA__f_style);
  var $$x1181 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3717 = $m_Lscalacss_internal_Attrs$flexWrap$();
  var $$x1180 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1181).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3717.Lscalacss_internal_Attrs$flexWrap$__f_attr, "wrap")));
  var $$x1179 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3726 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$156 = 125;
  var f$376 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$156);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$169 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$55) => {
    var x$4$57 = $as_Lscalacss_internal_Percentage(x$4$2$55);
    return $n(x$4$57).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$375 = new $c_sjsr_AnonFunction1(((x$1$2$186) => {
    var x$1$189 = $as_Lscalacss_internal_ValueT(x$1$2$186);
    return $n(x$1$189)
  }));
  var bc$169 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$375);
  var r$195 = $n(ab$169).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$169);
  var v$443 = $n(r$195).apply__O__Lscalacss_internal_ValueT(f$376);
  var v$444 = $n(v$443).Lscalacss_internal_ValueT__f_value;
  var $$x1178 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1179).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3726.Lscalacss_internal_Attrs$fontSize$__f_attr, v$444)));
  var $$x1177 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x1176 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x1175 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3736 = $m_Lscalacss_internal_Attrs$marginLeft$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$157 = 1;
  var u$96 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$378 = new $c_Lscalacss_internal_Length(this$$157, u$96);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$170 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$106) => {
    var x$3$112 = $as_Lscalacss_internal_Length(x$3$2$106);
    return $n(x$3$112).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$377 = new $c_sjsr_AnonFunction1(((x$1$2$187) => {
    var x$1$190 = $as_Lscalacss_internal_ValueT(x$1$2$187);
    return $n(x$1$190)
  }));
  var bc$170 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$377);
  var r$196 = $n(ab$170).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$170);
  var v$445 = $n(r$196).apply__O__Lscalacss_internal_ValueT(f$378);
  var v$446 = $n(v$445).Lscalacss_internal_ValueT__f_value;
  var $$x1174 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1175).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3736.Lscalacss_internal_Attrs$marginLeft$__f_attr, v$446)));
  var $$x1173 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3746 = $m_Lscalacss_internal_Attrs$paddingLeft$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$158 = 1;
  var u$97 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$380 = new $c_Lscalacss_internal_Length(this$$158, u$97);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$171 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$107) => {
    var x$3$113 = $as_Lscalacss_internal_Length(x$3$2$107);
    return $n(x$3$113).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$379 = new $c_sjsr_AnonFunction1(((x$1$2$188) => {
    var x$1$191 = $as_Lscalacss_internal_ValueT(x$1$2$188);
    return $n(x$1$191)
  }));
  var bc$171 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$379);
  var r$197 = $n(ab$171).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$171);
  var v$447 = $n(r$197).apply__O__Lscalacss_internal_ValueT(f$380);
  var v$448 = $n(v$447).Lscalacss_internal_ValueT__f_value;
  var $$x1172 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1173).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3746.Lscalacss_internal_Attrs$paddingLeft$__f_attr, v$448)));
  var $$x1171 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3756 = $m_Lscalacss_internal_Attrs$marginRight$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$159 = 1;
  var u$98 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$382 = new $c_Lscalacss_internal_Length(this$$159, u$98);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$172 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$108) => {
    var x$3$114 = $as_Lscalacss_internal_Length(x$3$2$108);
    return $n(x$3$114).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$381 = new $c_sjsr_AnonFunction1(((x$1$2$189) => {
    var x$1$192 = $as_Lscalacss_internal_ValueT(x$1$2$189);
    return $n(x$1$192)
  }));
  var bc$172 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$381);
  var r$198 = $n(ab$172).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$172);
  var v$449 = $n(r$198).apply__O__Lscalacss_internal_ValueT(f$382);
  var v$450 = $n(v$449).Lscalacss_internal_ValueT__f_value;
  var $$x1170 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1171).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3756.Lscalacss_internal_Attrs$marginRight$__f_attr, v$450)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v$451 = ($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()), $m_Lscalacss_internal_Attrs$borderLeft$()).Lscalacss_internal_Attrs$borderLeft$__f_attr;
  var qual$10 = new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr(this, v$451);
  var x$24$4 = $n(this.Lreactbuild_Style$__f_theme).Lcom_iz2use_react_style_Theme__f_lineBorder;
  var x$25$4 = $m_Lcom_iz2use_react_style_OpacityLevel$full$();
  var x$26$4 = new $c_sjsr_AnonFunction1(((color$4$2) => {
    var color$4 = $as_Lscalacss_internal_ValueT(color$4$2);
    return new $c_sjsr_AnonFunction1(((x$30$2$1) => {
      var x$30$3 = $as_Lscalacss_internal_Attr(x$30$2$1);
      $n($m_Lreactbuild_Style$().dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
      var value$7 = ("4px solid " + $n(color$4).Lscalacss_internal_ValueT__f_value);
      return new $c_Lscalacss_internal_AV(x$30$3, value$7)
    }))
  }));
  var array$255 = [new $c_Lcom_iz2use_react_style_package$WithThemedSupport$RichAttr$$anon$7(qual$10, x$26$4, x$24$4, x$25$4)];
  var t$49 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$255);
  $m_Lreactbuild_package$CssSettings$();
  var c$35 = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$383 = new $c_sjsr_AnonFunction1(((x$1$2$190) => {
    var x$1$193 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$1$2$190);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$1$193).light__Lscalacss_internal_AV()))
  }));
  var t$50 = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$49, f$383));
  var x$169 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$50, c$35);
  var $$x1169 = new $c_Lscalacss_internal_DslBase$ToStyle(x$169);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x1168 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3768 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  var this$3769 = $n($as_Lscalacss_internal_Media$FeatureOps($n(this$3768.T__F1()).apply__O__O($m_Lscalacss_internal_Media$Screen$())));
  var $$x1167 = $n($n($$x1168).DslCond__O__F1__Lscalacss_internal_DslBase$DslCond($f_Lscalacss_internal_Media$FeatureOps__dark__O(this$3769), new $c_sjsr_AnonFunction1(((x$2$22) => {
    var x$170 = $as_Lscalacss_internal_Media$Query(x$2$22);
    return $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond(x$170)
  }))));
  var f$384 = new $c_sjsr_AnonFunction1(((x$2$2$2$7) => {
    var x$2$2$18 = $as_Lcom_iz2use_react_style_package$ToThemedStyle(x$2$2$2$7);
    return new $c_Lscalacss_internal_DslBase$ToStyle($n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$()).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n(x$2$2$18).dark__Lscalacss_internal_AV()))
  }));
  var x$171 = $n($$x1167).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS($as_sci_Seq($f_sc_StrictOptimizedIterableOps__map__F1__O(t$49, f$384)), c$35);
  var array$256 = [$$x1169, new $c_Lscalacss_internal_DslBase$ToStyle(x$171)];
  var t$51 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$256);
  var x$172 = $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t$51, c$35);
  var array$257 = [$$x1174, $$x1172, $$x1170, new $c_Lscalacss_internal_DslBase$ToStyle(x$172)];
  var array$258 = [$$x1182, $$x1180, $$x1178, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1177).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x1176).unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt("*", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$257), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  $n($$x1183).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$258), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1185 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "breadcrumbSeparator");
  var $$x1184 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3785 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var array$259 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1184).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3785.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")))];
  $n($$x1185).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$259), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  this.Lreactbuild_Style$__f_featureStateNotYetImplemented = this.featureState__I__I__I__Lscalacss_internal_StyleA(255, 152, 0);
  this.Lreactbuild_Style$__f_featureStateWorkInProgress = this.featureState__I__I__I__Lscalacss_internal_StyleA(255, 0, 0);
  var $$x1192 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "featureStateTitle");
  var $$x1191 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3791 = $m_Lscalacss_internal_Attrs$fontWeight$();
  var $$x1190 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1191).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3791.Lscalacss_internal_Attrs$fontWeight$__f_attr, "bold")));
  var $$x1189 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3800 = $m_Lscalacss_internal_Attrs$fontSize$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$160 = 135;
  var f$386 = $ct_Lscalacss_internal_Percentage__O__(new $c_Lscalacss_internal_Percentage(), this$$160);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$173 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$4$2$56) => {
    var x$4$58 = $as_Lscalacss_internal_Percentage(x$4$2$56);
    return $n(x$4$58).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$385 = new $c_sjsr_AnonFunction1(((x$1$2$191) => {
    var x$1$194 = $as_Lscalacss_internal_ValueT(x$1$2$191);
    return $n(x$1$194)
  }));
  var bc$173 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$385);
  var r$199 = $n(ab$173).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$173);
  var v$452 = $n(r$199).apply__O__Lscalacss_internal_ValueT(f$386);
  var v$453 = $n(v$452).Lscalacss_internal_ValueT__f_value;
  var $$x1188 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1189).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3800.Lscalacss_internal_Attrs$fontSize$__f_attr, v$453)));
  var $$x1187 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x1186 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$60 = $m_Lscalacss_internal_Attrs$color$();
  var array$260 = [$$x1190, $$x1188, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1187).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x1186).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$60, (("var(" + $n($n($m_Lcom_iz2use_react_style_package$().featureStateColor__Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$()).Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$__f_attr).Lscalacss_internal_Attr__f_id) + ")"))))];
  this.Lreactbuild_Style$__f_featureStateTitle = $n($$x1192).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$260), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  this.Lreactbuild_Style$__f_featureStateDescription = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "featureStateDescription").apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($m_sci_Nil$(), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1202 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "featureStateContainer");
  var $$x1201 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3817 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$161 = 0.5;
  var u$99 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$388 = new $c_Lscalacss_internal_Length(this$$161, u$99);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$174 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$109) => {
    var x$3$115 = $as_Lscalacss_internal_Length(x$3$2$109);
    return $n(x$3$115).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$387 = new $c_sjsr_AnonFunction1(((x$1$2$192) => {
    var x$1$195 = $as_Lscalacss_internal_ValueT(x$1$2$192);
    return $n(x$1$195)
  }));
  var bc$174 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$387);
  var r$200 = $n(ab$174).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$174);
  var all$9 = $n(r$200).apply__O__Lscalacss_internal_ValueT(f$388);
  var v$454 = $n(all$9).Lscalacss_internal_ValueT__f_value;
  var $$x1200 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1201).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3817.Lscalacss_internal_Attrs$margin$__f_attr, v$454)));
  var $$x1199 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3827 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$162 = 0.5;
  var u$100 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$390 = new $c_Lscalacss_internal_Length(this$$162, u$100);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$175 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$110) => {
    var x$3$116 = $as_Lscalacss_internal_Length(x$3$2$110);
    return $n(x$3$116).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$389 = new $c_sjsr_AnonFunction1(((x$1$2$193) => {
    var x$1$196 = $as_Lscalacss_internal_ValueT(x$1$2$193);
    return $n(x$1$196)
  }));
  var bc$175 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$389);
  var r$201 = $n(ab$175).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$175);
  var all$10 = $n(r$201).apply__O__Lscalacss_internal_ValueT(f$390);
  var v$455 = $n(all$10).Lscalacss_internal_ValueT__f_value;
  var $$x1198 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1199).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3827.Lscalacss_internal_Attrs$padding$__f_attr, v$455)));
  var $$x1197 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3829 = $m_Lscalacss_internal_Attrs$width$();
  var $$x1196 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1197).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3829.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, "fit-content")));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$173 = this.Lreactbuild_Style$__f_flexColumn;
  var $$x1195 = new $c_Lscalacss_internal_DslBase$ToStyle($n(x$173).Lscalacss_internal_StyleA__f_style);
  var $$x1194 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x1193 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$61 = $m_Lscalacss_internal_Attrs$border$();
  var array$261 = [$$x1200, $$x1198, $$x1196, $$x1195, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1194).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x1193).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$61, (("1px solid var(" + $n($n($m_Lcom_iz2use_react_style_package$().featureStateColor__Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$()).Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$__f_attr).Lscalacss_internal_Attr__f_id) + ")"))))];
  this.Lreactbuild_Style$__f_featureStateContainer = $n($$x1202).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$261), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1206 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "featureStateContainerParentFullSpace");
  var $$x1205 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3838 = $m_Lscalacss_internal_Attrs$display$();
  var $$x1204 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1205).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3838.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
  var $$x1203 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$62 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$262 = [$$x1204, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1203).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$62, "1")))];
  this.Lreactbuild_Style$__f_featureStateContainerParentFullSpace = $n($$x1206).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$262), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1210 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "featureStateContainerFullSpace");
  var $$x1209 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3847 = $m_Lscalacss_internal_Attrs$width$();
  var v$456 = $m_Lscalacss_internal_Literal$Typed$auto$();
  var v$457 = v$456.Lscalacss_internal_Literal__f_value;
  var $$x1208 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1209).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3847.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr, v$457)));
  var $$x1207 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$63 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$263 = [$$x1208, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1207).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$63, "1")))];
  this.Lreactbuild_Style$__f_featureStateContainerFullSpace = $n($$x1210).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$263), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1215 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "featureStateWrapper");
  var $$x1214 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3864 = $m_Lscalacss_internal_Attrs$margin$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$163 = 0.5;
  var u$101 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$392 = new $c_Lscalacss_internal_Length(this$$163, u$101);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$176 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$111) => {
    var x$3$117 = $as_Lscalacss_internal_Length(x$3$2$111);
    return $n(x$3$117).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$391 = new $c_sjsr_AnonFunction1(((x$1$2$194) => {
    var x$1$197 = $as_Lscalacss_internal_ValueT(x$1$2$194);
    return $n(x$1$197)
  }));
  var bc$176 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$391);
  var r$202 = $n(ab$176).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$176);
  var all$11 = $n(r$202).apply__O__Lscalacss_internal_ValueT(f$392);
  var v$458 = $n(all$11).Lscalacss_internal_ValueT__f_value;
  var $$x1213 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1214).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3864.Lscalacss_internal_Attrs$margin$__f_attr, v$458)));
  var $$x1212 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$3874 = $m_Lscalacss_internal_Attrs$padding$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$$164 = 0.5;
  var u$102 = $m_Lscalacss_internal_LengthUnit$em$();
  var f$394 = new $c_Lscalacss_internal_Length(this$$164, u$102);
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var ab$177 = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2$112) => {
    var x$3$118 = $as_Lscalacss_internal_Length(x$3$2$112);
    return $n(x$3$118).value__T()
  })));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var f$393 = new $c_sjsr_AnonFunction1(((x$1$2$195) => {
    var x$1$198 = $as_Lscalacss_internal_ValueT(x$1$2$195);
    return $n(x$1$198)
  }));
  var bc$177 = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f$393);
  var r$203 = $n(ab$177).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc$177);
  var all$12 = $n(r$203).apply__O__Lscalacss_internal_ValueT(f$394);
  var v$459 = $n(all$12).Lscalacss_internal_ValueT__f_value;
  var $$x1211 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1212).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$3874.Lscalacss_internal_Attrs$padding$__f_attr, v$459)));
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var x$174 = this.Lreactbuild_Style$__f_withBackground;
  var array$264 = [$$x1213, $$x1211, new $c_Lscalacss_internal_DslBase$ToStyle($n(x$174).Lscalacss_internal_StyleA__f_style)];
  this.Lreactbuild_Style$__f_featureStateWrapper = $n($$x1215).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$264), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()));
  var $$x1217 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "featureStateWrapperFullSpace");
  var $$x1216 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$64 = $m_Lscalacss_internal_Attrs$().flex__Lscalacss_internal_Attr();
  var array$265 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1216).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(a$64, "1")))];
  this.Lreactbuild_Style$__f_featureStateWrapperFullSpace = $n($$x1217).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$265), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))
}
$c_Lreactbuild_Style$.prototype = new $h_Lscalacss_internal_mutable_StyleSheet$Inline();
$c_Lreactbuild_Style$.prototype.constructor = $c_Lreactbuild_Style$;
/** @constructor */
function $h_Lreactbuild_Style$() {
  /*<skip>*/
}
$h_Lreactbuild_Style$.prototype = $c_Lreactbuild_Style$.prototype;
$c_Lreactbuild_Style$.prototype.strippedCells__I__I__Lscalacss_internal_StyleS = (function(h, l) {
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var $$x17 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x16 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x15 = new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_T(x$5$2);
    return (x$5 + ">*:nth-child(3n+0)")
  }));
  var $$x14 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x13 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x14).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x13).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a, (((("hsla(" + h) + ",50%,") + l) + "%,1)"))))];
  var $$x12 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x17).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x16).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x15, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x11 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x10 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x9 = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_T(x$6$2);
    return (x$6 + ">*:nth-child(3n+1)")
  }));
  var $$x8 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x7 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$1 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$1 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x8).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x7).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$1, (((("hsla(" + h) + ",50%,") + l) + "%,1)"))))];
  var $$x6 = new $c_Lscalacss_internal_DslBase$ToStyle($n($$x11).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x10).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x9, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))));
  var $$x5 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x4 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x3 = new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_T(x$7$2);
    return (x$7 + ">*:nth-child(3n+2)")
  }));
  var $$x2 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var $$x1 = $m_Lscalacss_internal_DslBase$DslAttrT$();
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var a$2 = $m_Lscalacss_internal_Attrs$backgroundColor$();
  var array$2 = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x2).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS($n($$x1).$colon$eq$bang$extension__Lscalacss_internal_ValueT$TypedAttrBase__T__Lscalacss_internal_AV(a$2, (((("hsla(" + h) + ",50%,") + (((-4) + l) | 0)) + "%,1)"))))];
  var array$3 = [$$x12, $$x6, new $c_Lscalacss_internal_DslBase$ToStyle($n($$x5).ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS($n($$x4).unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))))];
  var t = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  $m_Lreactbuild_package$CssSettings$();
  var c = $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose();
  return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c)
});
$c_Lreactbuild_Style$.prototype.portrait__Lscalacss_internal_Media$Query = (function() {
  $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var this$2 = $m_Lscalacss_internal_DslBase$MediaQueryEmpty$();
  return $as_Lscalacss_internal_Media$Query($f_Lscalacss_internal_Media$FeatureOps__portrait__O(this$2))
});
$c_Lreactbuild_Style$.prototype.featureState__I__I__I__Lscalacss_internal_StyleA = (function(r, g, b) {
  var $$x2 = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "featureState");
  var $$x1 = this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$();
  var this$2 = $n($m_Lcom_iz2use_react_style_package$().featureStateColor__Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$());
  var this$1 = $n(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$());
  var v = $as_Lscalacss_internal_ValueT($f_Lscalacss_internal_ColorOps__rgb__I__I__I__O(this$1, r, g, b));
  var v$1 = $n(v).Lscalacss_internal_ValueT__f_value;
  var array = [new $c_Lscalacss_internal_DslBase$ToStyle($n($$x1).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$2.Lcom_iz2use_react_style_ExtendedStyles$featureStateColor$__f_attr, v$1)))];
  return $n($$x2).apply__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), ($m_Lreactbuild_package$CssSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))
});
var $d_Lreactbuild_Style$ = new $TypeData().initClass({
  Lreactbuild_Style$: 0
}, false, "reactbuild.Style$", {
  Lreactbuild_Style$: 1,
  Lscalacss_internal_mutable_StyleSheet$Inline: 1,
  Lscalacss_internal_mutable_StyleSheet$Base: 1,
  O: 1,
  Lscalacss_internal_Macros$Dsl$Mixin: 1,
  Lcom_iz2use_react_style_package$WithThemedSupport: 1
});
$c_Lreactbuild_Style$.prototype.$classData = $d_Lreactbuild_Style$;
var $n_Lreactbuild_Style$;
function $m_Lreactbuild_Style$() {
  if ((!$n_Lreactbuild_Style$)) {
    $n_Lreactbuild_Style$ = new $c_Lreactbuild_Style$()
  };
  return $n_Lreactbuild_Style$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype.constructor = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype;
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype.productPrefix__T = (function() {
  return "DeliveryDate"
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype.hashCode__I = (function() {
  return 845789666
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype.toString__T = (function() {
  return "DeliveryDate"
});
function $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ReconciliationReportOrder$DeliveryDate$"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ReconciliationReportOrder$DeliveryDate$;", depth))
}
var $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$: 0
}, false, "reactbuild.analyze.cost.ReconciliationReportOrder$DeliveryDate$", {
  Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$: 1,
  O: 1,
  Lreactbuild_analyze_cost_ReconciliationReportOrder: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$.prototype.$classData = $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$;
var $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$;
function $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$() {
  if ((!$n_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$)) {
    $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$ = new $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$()
  };
  return $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype.constructor = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype;
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype.productPrefix__T = (function() {
  return "DeliveryFormReference"
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype.hashCode__I = (function() {
  return 819519283
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype.toString__T = (function() {
  return "DeliveryFormReference"
});
function $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ReconciliationReportOrder$DeliveryFormReference$"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ReconciliationReportOrder$DeliveryFormReference$;", depth))
}
var $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$: 0
}, false, "reactbuild.analyze.cost.ReconciliationReportOrder$DeliveryFormReference$", {
  Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$: 1,
  O: 1,
  Lreactbuild_analyze_cost_ReconciliationReportOrder: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$.prototype.$classData = $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$;
var $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$;
function $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$() {
  if ((!$n_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$)) {
    $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$ = new $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$()
  };
  return $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype.constructor = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype;
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype.productPrefix__T = (function() {
  return "InvoiceReference"
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype.hashCode__I = (function() {
  return (-746609986)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype.toString__T = (function() {
  return "InvoiceReference"
});
function $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ReconciliationReportOrder$InvoiceReference$"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ReconciliationReportOrder$InvoiceReference$;", depth))
}
var $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$: 0
}, false, "reactbuild.analyze.cost.ReconciliationReportOrder$InvoiceReference$", {
  Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$: 1,
  O: 1,
  Lreactbuild_analyze_cost_ReconciliationReportOrder: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$.prototype.$classData = $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$;
var $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$;
function $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$() {
  if ((!$n_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$)) {
    $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$ = new $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$()
  };
  return $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype.constructor = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype;
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype.productPrefix__T = (function() {
  return "ProductReference"
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype.hashCode__I = (function() {
  return (-1512443076)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype.toString__T = (function() {
  return "ProductReference"
});
function $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ReconciliationReportOrder$ProductReference$"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ReconciliationReportOrder$ProductReference$;", depth))
}
var $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$: 0
}, false, "reactbuild.analyze.cost.ReconciliationReportOrder$ProductReference$", {
  Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$: 1,
  O: 1,
  Lreactbuild_analyze_cost_ReconciliationReportOrder: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$.prototype.$classData = $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$;
var $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$;
function $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$() {
  if ((!$n_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$)) {
    $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$ = new $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$()
  };
  return $n_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1.prototype.constructor = $c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1.prototype = $c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1.prototype;
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1.prototype.applyOrElse__Lreactbuild_Loc__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_Lreactbuild_Loc$Project)) {
    var x2 = $as_Lreactbuild_Loc$Project(x1);
    var page = $n(x2).Lreactbuild_Loc$Project__f_page;
    return page
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1.prototype.isDefinedAt__Lreactbuild_Loc__Z = (function(x1) {
  return (x1 instanceof $c_Lreactbuild_Loc$Project)
});
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_Loc__Z($as_Lreactbuild_Loc(x))
});
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_Loc__F1__O($as_Lreactbuild_Loc(x), default$1)
});
var $d_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1: 0
}, false, "reactbuild.analyze.cost.RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1", {
  Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1.prototype.$classData = $d_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2.prototype.constructor = $c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2.prototype = $c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2.prototype;
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2.prototype.applyOrElse__Lreactbuild_Loc__F1__O = (function(x2, default$1) {
  if ((x2 instanceof $c_Lreactbuild_Loc$BusinessOpportunities)) {
    var x2$2 = $as_Lreactbuild_Loc$BusinessOpportunities(x2);
    var m = $n(x2$2).Lreactbuild_Loc$BusinessOpportunities__f_view;
    return m
  } else {
    return $n(default$1).apply__O__O(x2)
  }
});
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2.prototype.isDefinedAt__Lreactbuild_Loc__Z = (function(x2) {
  return (x2 instanceof $c_Lreactbuild_Loc$BusinessOpportunities)
});
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_Loc__Z($as_Lreactbuild_Loc(x))
});
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_Loc__F1__O($as_Lreactbuild_Loc(x), default$1)
});
var $d_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2: 0
}, false, "reactbuild.analyze.cost.RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2", {
  Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2.prototype.$classData = $d_Lreactbuild_analyze_cost_RouterConfig$$anonfun$$nestedInanonfun$routerConfig$1$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_ApplicationStarted$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_ApplicationStarted$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_ApplicationStarted$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype = $c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype;
$c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype.productPrefix__T = (function() {
  return "ApplicationStarted"
});
$c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype.hashCode__I = (function() {
  return 520222001
});
$c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype.toString__T = (function() {
  return "ApplicationStarted"
});
var $d_Lreactbuild_analyze_cost_actions_ApplicationStarted$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_ApplicationStarted$: 0
}, false, "reactbuild.analyze.cost.actions.ApplicationStarted$", {
  Lreactbuild_analyze_cost_actions_ApplicationStarted$: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_ApplicationStarted$.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_ApplicationStarted$;
var $n_Lreactbuild_analyze_cost_actions_ApplicationStarted$;
function $m_Lreactbuild_analyze_cost_actions_ApplicationStarted$() {
  if ((!$n_Lreactbuild_analyze_cost_actions_ApplicationStarted$)) {
    $n_Lreactbuild_analyze_cost_actions_ApplicationStarted$ = new $c_Lreactbuild_analyze_cost_actions_ApplicationStarted$()
  };
  return $n_Lreactbuild_analyze_cost_actions_ApplicationStarted$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_ConnectToServer$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_ConnectToServer$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_ConnectToServer$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype = $c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype;
$c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype.productPrefix__T = (function() {
  return "ConnectToServer"
});
$c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype.hashCode__I = (function() {
  return 1023028360
});
$c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype.toString__T = (function() {
  return "ConnectToServer"
});
var $d_Lreactbuild_analyze_cost_actions_ConnectToServer$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_ConnectToServer$: 0
}, false, "reactbuild.analyze.cost.actions.ConnectToServer$", {
  Lreactbuild_analyze_cost_actions_ConnectToServer$: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_ConnectToServer$.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_ConnectToServer$;
var $n_Lreactbuild_analyze_cost_actions_ConnectToServer$;
function $m_Lreactbuild_analyze_cost_actions_ConnectToServer$() {
  if ((!$n_Lreactbuild_analyze_cost_actions_ConnectToServer$)) {
    $n_Lreactbuild_analyze_cost_actions_ConnectToServer$ = new $c_Lreactbuild_analyze_cost_actions_ConnectToServer$()
  };
  return $n_Lreactbuild_analyze_cost_actions_ConnectToServer$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_ConnectedToServer(ws) {
  this.Lreactbuild_analyze_cost_actions_ConnectedToServer__f_ws = null;
  this.Lreactbuild_analyze_cost_actions_ConnectedToServer__f_ws = ws
}
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_ConnectedToServer;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_ConnectedToServer() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype = $c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype;
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype.productPrefix__T = (function() {
  return "ConnectedToServer"
});
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_ConnectedToServer__f_ws : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectedToServer)) {
    var ConnectedToServer$1 = $as_Lreactbuild_analyze_cost_actions_ConnectedToServer(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_ConnectedToServer__f_ws;
    var y = $n(ConnectedToServer$1).Lreactbuild_analyze_cost_actions_ConnectedToServer__f_ws;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(ConnectedToServer$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_ConnectedToServer(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_ConnectedToServer) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.ConnectedToServer"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_ConnectedToServer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_ConnectedToServer)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_ConnectedToServer(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_ConnectedToServer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.ConnectedToServer;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_ConnectedToServer = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_ConnectedToServer: 0
}, false, "reactbuild.analyze.cost.actions.ConnectedToServer", {
  Lreactbuild_analyze_cost_actions_ConnectedToServer: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_ConnectedToServer.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_ConnectedToServer;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed(e) {
  this.Lreactbuild_analyze_cost_actions_ConnectionToServerFailed__f_e = null;
  this.Lreactbuild_analyze_cost_actions_ConnectionToServerFailed__f_e = e
}
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype = $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype;
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype.productPrefix__T = (function() {
  return "ConnectionToServerFailed"
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_ConnectionToServerFailed__f_e : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed)) {
    var ConnectionToServerFailed$1 = $as_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_ConnectionToServerFailed__f_e;
    var x$2 = $n(ConnectionToServerFailed$1).Lreactbuild_analyze_cost_actions_ConnectionToServerFailed__f_e;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(ConnectionToServerFailed$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.ConnectionToServerFailed"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_ConnectionToServerFailed)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.ConnectionToServerFailed;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_ConnectionToServerFailed: 0
}, false, "reactbuild.analyze.cost.actions.ConnectionToServerFailed", {
  Lreactbuild_analyze_cost_actions_ConnectionToServerFailed: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost(code, reason, wasClean) {
  this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_code = 0;
  this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_reason = null;
  this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_wasClean = false;
  this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_code = code;
  this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_reason = reason;
  this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_wasClean = wasClean
}
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_ConnectionToServerLost() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype = $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype;
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype.productPrefix__T = (function() {
  return "ConnectionToServerLost"
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_code;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_reason;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_wasClean;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ConnectionToServerLost");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_code;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_reason;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_wasClean ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost)) {
    var ConnectionToServerLost$1 = $as_Lreactbuild_analyze_cost_actions_ConnectionToServerLost(x$1);
    return (((this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_code === $n(ConnectionToServerLost$1).Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_code) && (this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_wasClean === $n(ConnectionToServerLost$1).Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_wasClean)) && ((this.Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_reason === $n(ConnectionToServerLost$1).Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_reason) && ($n(ConnectionToServerLost$1), true)))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_ConnectionToServerLost(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.ConnectionToServerLost"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_ConnectionToServerLost(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_ConnectionToServerLost)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_ConnectionToServerLost(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_ConnectionToServerLost(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.ConnectionToServerLost;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_ConnectionToServerLost = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_ConnectionToServerLost: 0
}, false, "reactbuild.analyze.cost.actions.ConnectionToServerLost", {
  Lreactbuild_analyze_cost_actions_ConnectionToServerLost: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_ConnectionToServerLost;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_InitAction$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_actions_InitAction$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_InitAction$.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_InitAction$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_InitAction$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_InitAction$.prototype = $c_Lreactbuild_analyze_cost_actions_InitAction$.prototype;
$c_Lreactbuild_analyze_cost_actions_InitAction$.prototype.productPrefix__T = (function() {
  return "InitAction"
});
$c_Lreactbuild_analyze_cost_actions_InitAction$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_actions_InitAction$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_actions_InitAction$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_InitAction$.prototype.hashCode__I = (function() {
  return 1721474950
});
$c_Lreactbuild_analyze_cost_actions_InitAction$.prototype.toString__T = (function() {
  return "InitAction"
});
var $d_Lreactbuild_analyze_cost_actions_InitAction$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_InitAction$: 0
}, false, "reactbuild.analyze.cost.actions.InitAction$", {
  Lreactbuild_analyze_cost_actions_InitAction$: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_InitAction$.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_InitAction$;
var $n_Lreactbuild_analyze_cost_actions_InitAction$;
function $m_Lreactbuild_analyze_cost_actions_InitAction$() {
  if ((!$n_Lreactbuild_analyze_cost_actions_InitAction$)) {
    $n_Lreactbuild_analyze_cost_actions_InitAction$ = new $c_Lreactbuild_analyze_cost_actions_InitAction$()
  };
  return $n_Lreactbuild_analyze_cost_actions_InitAction$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_LoadCommonData(cd) {
  this.Lreactbuild_analyze_cost_actions_LoadCommonData__f_cd = null;
  this.Lreactbuild_analyze_cost_actions_LoadCommonData__f_cd = cd
}
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_LoadCommonData;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_LoadCommonData() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype = $c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype;
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype.productPrefix__T = (function() {
  return "LoadCommonData"
});
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_LoadCommonData__f_cd : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_LoadCommonData)) {
    var LoadCommonData$1 = $as_Lreactbuild_analyze_cost_actions_LoadCommonData(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_LoadCommonData__f_cd;
    var x$2 = $n(LoadCommonData$1).Lreactbuild_analyze_cost_actions_LoadCommonData__f_cd;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(LoadCommonData$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_LoadCommonData(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_LoadCommonData) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.LoadCommonData"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_LoadCommonData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_LoadCommonData)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_LoadCommonData(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_LoadCommonData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.LoadCommonData;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_LoadCommonData = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_LoadCommonData: 0
}, false, "reactbuild.analyze.cost.actions.LoadCommonData", {
  Lreactbuild_analyze_cost_actions_LoadCommonData: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_LoadCommonData.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_LoadCommonData;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistBuildingPart(item) {
  this.Lreactbuild_analyze_cost_actions_PersistBuildingPart__f_item = null;
  this.Lreactbuild_analyze_cost_actions_PersistBuildingPart__f_item = item
}
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistBuildingPart;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistBuildingPart() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype = $c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype.productPrefix__T = (function() {
  return "PersistBuildingPart"
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_PersistBuildingPart__f_item : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingPart)) {
    var PersistBuildingPart$1 = $as_Lreactbuild_analyze_cost_actions_PersistBuildingPart(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_PersistBuildingPart__f_item;
    var x$2 = $n(PersistBuildingPart$1).Lreactbuild_analyze_cost_actions_PersistBuildingPart__f_item;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PersistBuildingPart$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistBuildingPart(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingPart) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistBuildingPart"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistBuildingPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistBuildingPart)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistBuildingPart(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistBuildingPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistBuildingPart;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistBuildingPart = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistBuildingPart: 0
}, false, "reactbuild.analyze.cost.actions.PersistBuildingPart", {
  Lreactbuild_analyze_cost_actions_PersistBuildingPart: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingPart.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistBuildingPart;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistBuildingSite(item) {
  this.Lreactbuild_analyze_cost_actions_PersistBuildingSite__f_item = null;
  this.Lreactbuild_analyze_cost_actions_PersistBuildingSite__f_item = item
}
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistBuildingSite;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistBuildingSite() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype = $c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype.productPrefix__T = (function() {
  return "PersistBuildingSite"
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_PersistBuildingSite__f_item : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingSite)) {
    var PersistBuildingSite$1 = $as_Lreactbuild_analyze_cost_actions_PersistBuildingSite(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_PersistBuildingSite__f_item;
    var x$2 = $n(PersistBuildingSite$1).Lreactbuild_analyze_cost_actions_PersistBuildingSite__f_item;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PersistBuildingSite$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistBuildingSite(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingSite) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistBuildingSite"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistBuildingSite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistBuildingSite)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistBuildingSite(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistBuildingSite(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistBuildingSite;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistBuildingSite = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistBuildingSite: 0
}, false, "reactbuild.analyze.cost.actions.PersistBuildingSite", {
  Lreactbuild_analyze_cost_actions_PersistBuildingSite: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingSite.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistBuildingSite;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistBuildingStage(item) {
  this.Lreactbuild_analyze_cost_actions_PersistBuildingStage__f_item = null;
  this.Lreactbuild_analyze_cost_actions_PersistBuildingStage__f_item = item
}
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistBuildingStage;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistBuildingStage() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype = $c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype.productPrefix__T = (function() {
  return "PersistBuildingStage"
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_PersistBuildingStage__f_item : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingStage)) {
    var PersistBuildingStage$1 = $as_Lreactbuild_analyze_cost_actions_PersistBuildingStage(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_PersistBuildingStage__f_item;
    var x$2 = $n(PersistBuildingStage$1).Lreactbuild_analyze_cost_actions_PersistBuildingStage__f_item;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PersistBuildingStage$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistBuildingStage(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingStage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistBuildingStage"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistBuildingStage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistBuildingStage)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistBuildingStage(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistBuildingStage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistBuildingStage;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistBuildingStage = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistBuildingStage: 0
}, false, "reactbuild.analyze.cost.actions.PersistBuildingStage", {
  Lreactbuild_analyze_cost_actions_PersistBuildingStage: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistBuildingStage.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistBuildingStage;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistListTemplate(item) {
  this.Lreactbuild_analyze_cost_actions_PersistListTemplate__f_item = null;
  this.Lreactbuild_analyze_cost_actions_PersistListTemplate__f_item = item
}
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistListTemplate;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistListTemplate() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype = $c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype.productPrefix__T = (function() {
  return "PersistListTemplate"
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_PersistListTemplate__f_item : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistListTemplate)) {
    var PersistListTemplate$1 = $as_Lreactbuild_analyze_cost_actions_PersistListTemplate(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_PersistListTemplate__f_item;
    var x$2 = $n(PersistListTemplate$1).Lreactbuild_analyze_cost_actions_PersistListTemplate__f_item;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PersistListTemplate$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistListTemplate(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistListTemplate) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistListTemplate"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistListTemplate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistListTemplate)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistListTemplate(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistListTemplate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistListTemplate;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistListTemplate = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistListTemplate: 0
}, false, "reactbuild.analyze.cost.actions.PersistListTemplate", {
  Lreactbuild_analyze_cost_actions_PersistListTemplate: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplate.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistListTemplate;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry(item) {
  this.Lreactbuild_analyze_cost_actions_PersistListTemplateEntry__f_item = null;
  this.Lreactbuild_analyze_cost_actions_PersistListTemplateEntry__f_item = item
}
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype = $c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype.productPrefix__T = (function() {
  return "PersistListTemplateEntry"
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_PersistListTemplateEntry__f_item : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry)) {
    var PersistListTemplateEntry$1 = $as_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_PersistListTemplateEntry__f_item;
    var x$2 = $n(PersistListTemplateEntry$1).Lreactbuild_analyze_cost_actions_PersistListTemplateEntry__f_item;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PersistListTemplateEntry$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistListTemplateEntry"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistListTemplateEntry)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistListTemplateEntry;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistListTemplateEntry: 0
}, false, "reactbuild.analyze.cost.actions.PersistListTemplateEntry", {
  Lreactbuild_analyze_cost_actions_PersistListTemplateEntry: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistPerson(item) {
  this.Lreactbuild_analyze_cost_actions_PersistPerson__f_item = null;
  this.Lreactbuild_analyze_cost_actions_PersistPerson__f_item = item
}
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistPerson;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistPerson() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistPerson.prototype = $c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype.productPrefix__T = (function() {
  return "PersistPerson"
});
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_PersistPerson__f_item : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistPerson)) {
    var PersistPerson$1 = $as_Lreactbuild_analyze_cost_actions_PersistPerson(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_PersistPerson__f_item;
    var x$2 = $n(PersistPerson$1).Lreactbuild_analyze_cost_actions_PersistPerson__f_item;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PersistPerson$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistPerson(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistPerson) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistPerson"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistPerson(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistPerson)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistPerson(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistPerson(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistPerson;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistPerson = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistPerson: 0
}, false, "reactbuild.analyze.cost.actions.PersistPerson", {
  Lreactbuild_analyze_cost_actions_PersistPerson: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistPerson.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistPerson;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation(annotation) {
  this.Lreactbuild_analyze_cost_actions_PersistPersonAnnotation__f_annotation = null;
  this.Lreactbuild_analyze_cost_actions_PersistPersonAnnotation__f_annotation = annotation
}
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype = $c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype.productPrefix__T = (function() {
  return "PersistPersonAnnotation"
});
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_PersistPersonAnnotation__f_annotation : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation)) {
    var PersistPersonAnnotation$1 = $as_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_PersistPersonAnnotation__f_annotation;
    var x$2 = $n(PersistPersonAnnotation$1).Lreactbuild_analyze_cost_actions_PersistPersonAnnotation__f_annotation;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PersistPersonAnnotation$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistPersonAnnotation"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistPersonAnnotation)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistPersonAnnotation;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistPersonAnnotation: 0
}, false, "reactbuild.analyze.cost.actions.PersistPersonAnnotation", {
  Lreactbuild_analyze_cost_actions_PersistPersonAnnotation: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistProduct(updateInvoiceDetail, item) {
  this.Lreactbuild_analyze_cost_actions_PersistProduct__f_updateInvoiceDetail = false;
  this.Lreactbuild_analyze_cost_actions_PersistProduct__f_item = null;
  this.Lreactbuild_analyze_cost_actions_PersistProduct__f_updateInvoiceDetail = updateInvoiceDetail;
  this.Lreactbuild_analyze_cost_actions_PersistProduct__f_item = item
}
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistProduct;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistProduct() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistProduct.prototype = $c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype.productPrefix__T = (function() {
  return "PersistProduct"
});
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_actions_PersistProduct__f_updateInvoiceDetail;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_actions_PersistProduct__f_item;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("PersistProduct");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_actions_PersistProduct__f_updateInvoiceDetail ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_analyze_cost_actions_PersistProduct__f_item;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistProduct)) {
    var PersistProduct$1 = $as_Lreactbuild_analyze_cost_actions_PersistProduct(x$1);
    if ((this.Lreactbuild_analyze_cost_actions_PersistProduct__f_updateInvoiceDetail === $n(PersistProduct$1).Lreactbuild_analyze_cost_actions_PersistProduct__f_updateInvoiceDetail)) {
      var x = this.Lreactbuild_analyze_cost_actions_PersistProduct__f_item;
      var x$2 = $n(PersistProduct$1).Lreactbuild_analyze_cost_actions_PersistProduct__f_item;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        $n(PersistProduct$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistProduct(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistProduct) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistProduct"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistProduct(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistProduct)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistProduct(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistProduct(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistProduct;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistProduct = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistProduct: 0
}, false, "reactbuild.analyze.cost.actions.PersistProduct", {
  Lreactbuild_analyze_cost_actions_PersistProduct: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistProduct.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistProduct;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistResource(item) {
  this.Lreactbuild_analyze_cost_actions_PersistResource__f_item = null;
  this.Lreactbuild_analyze_cost_actions_PersistResource__f_item = item
}
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistResource;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistResource() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistResource.prototype = $c_Lreactbuild_analyze_cost_actions_PersistResource.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype.productPrefix__T = (function() {
  return "PersistResource"
});
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_PersistResource__f_item : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistResource)) {
    var PersistResource$1 = $as_Lreactbuild_analyze_cost_actions_PersistResource(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_PersistResource__f_item;
    var x$2 = $n(PersistResource$1).Lreactbuild_analyze_cost_actions_PersistResource__f_item;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PersistResource$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistResource(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistResource) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistResource"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistResource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistResource)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistResource(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistResource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistResource;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistResource = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistResource: 0
}, false, "reactbuild.analyze.cost.actions.PersistResource", {
  Lreactbuild_analyze_cost_actions_PersistResource: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistResource.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistResource;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_PersistTerm(item) {
  this.Lreactbuild_analyze_cost_actions_PersistTerm__f_item = null;
  this.Lreactbuild_analyze_cost_actions_PersistTerm__f_item = item
}
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_PersistTerm;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_PersistTerm() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_PersistTerm.prototype = $c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype;
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype.productPrefix__T = (function() {
  return "PersistTerm"
});
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_PersistTerm__f_item : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistTerm)) {
    var PersistTerm$1 = $as_Lreactbuild_analyze_cost_actions_PersistTerm(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_PersistTerm__f_item;
    var x$2 = $n(PersistTerm$1).Lreactbuild_analyze_cost_actions_PersistTerm__f_item;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(PersistTerm$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_PersistTerm(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_PersistTerm) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.PersistTerm"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_PersistTerm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_PersistTerm)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_PersistTerm(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_PersistTerm(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.PersistTerm;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_PersistTerm = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_PersistTerm: 0
}, false, "reactbuild.analyze.cost.actions.PersistTerm", {
  Lreactbuild_analyze_cost_actions_PersistTerm: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_PersistTerm.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_PersistTerm;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_SelectPeriod(period) {
  this.Lreactbuild_analyze_cost_actions_SelectPeriod__f_period = null;
  this.Lreactbuild_analyze_cost_actions_SelectPeriod__f_period = period
}
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_SelectPeriod;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_SelectPeriod() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype = $c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype;
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype.productPrefix__T = (function() {
  return "SelectPeriod"
});
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_SelectPeriod__f_period : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_SelectPeriod)) {
    var SelectPeriod$1 = $as_Lreactbuild_analyze_cost_actions_SelectPeriod(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_SelectPeriod__f_period;
    var x$2 = $n(SelectPeriod$1).Lreactbuild_analyze_cost_actions_SelectPeriod__f_period;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(SelectPeriod$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_SelectPeriod(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_SelectPeriod) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.SelectPeriod"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_SelectPeriod(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_SelectPeriod)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_SelectPeriod(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_SelectPeriod(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.SelectPeriod;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_SelectPeriod = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_SelectPeriod: 0
}, false, "reactbuild.analyze.cost.actions.SelectPeriod", {
  Lreactbuild_analyze_cost_actions_SelectPeriod: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_SelectPeriod.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_SelectPeriod;
/** @constructor */
function $c_Lreactbuild_analyze_cost_actions_ServerRawMessage(msg) {
  this.Lreactbuild_analyze_cost_actions_ServerRawMessage__f_msg = null;
  this.Lreactbuild_analyze_cost_actions_ServerRawMessage__f_msg = msg
}
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype.constructor = $c_Lreactbuild_analyze_cost_actions_ServerRawMessage;
/** @constructor */
function $h_Lreactbuild_analyze_cost_actions_ServerRawMessage() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype = $c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype;
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype.productPrefix__T = (function() {
  return "ServerRawMessage"
});
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_actions_ServerRawMessage__f_msg : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_actions_ServerRawMessage)) {
    var ServerRawMessage$1 = $as_Lreactbuild_analyze_cost_actions_ServerRawMessage(x$1);
    var x = this.Lreactbuild_analyze_cost_actions_ServerRawMessage__f_msg;
    var y = $n(ServerRawMessage$1).Lreactbuild_analyze_cost_actions_ServerRawMessage__f_msg;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(ServerRawMessage$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_actions_ServerRawMessage(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_actions_ServerRawMessage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.actions.ServerRawMessage"))
}
function $isArrayOf_Lreactbuild_analyze_cost_actions_ServerRawMessage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_actions_ServerRawMessage)))
}
function $asArrayOf_Lreactbuild_analyze_cost_actions_ServerRawMessage(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_actions_ServerRawMessage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.actions.ServerRawMessage;", depth))
}
var $d_Lreactbuild_analyze_cost_actions_ServerRawMessage = new $TypeData().initClass({
  Lreactbuild_analyze_cost_actions_ServerRawMessage: 0
}, false, "reactbuild.analyze.cost.actions.ServerRawMessage", {
  Lreactbuild_analyze_cost_actions_ServerRawMessage: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_actions_ServerRawMessage.prototype.$classData = $d_Lreactbuild_analyze_cost_actions_ServerRawMessage;
function $ct_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__($thiz) {
  $thiz.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(x$1$2);
    return $n(x$1).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_current
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(x$2$2);
    $n(x$2);
    var this$3 = $n(x$2);
    var original = this$3.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_original;
    return new $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(v$2, original)
  }))));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x2 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var $$x1 = $thiz.Lreactbuild_analyze_cost_components_AutomaticallySave$Backend__f_$;
  var this$7 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$7.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  $thiz.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__f_stateSnapshot = $n($$x3).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x2, $$x1, w);
  return $thiz
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend() {
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__f_stateSnapshot = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null
}
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype;
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype.render__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_render).apply__O__O($n(this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__f_stateSnapshot).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $n(p).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_reusableT)))
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype.persistState__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(p, s) {
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var this$1 = $n($n(p).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_state);
  var callback = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    var this$3 = $n(this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  var G = this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
  var arg1$1 = $n(s).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_current;
  var this$ = $n($$x2).unless$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline($n($$x1).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$1.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$1), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_updater).apply__O__O($n(s).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_current))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction0((() => {
    var this$5 = $n(s);
    var reusableT = $n(p).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__f_reusableT;
    return $uZ($n(reusableT).apply__O__O__O(this$5.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_current, this$5.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_original))
  })));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype.onUnmount__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().zip$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_AutomaticallySave$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_AutomaticallySave$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var p = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps($n(x0$1)._1__O());
      var s = $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState($n(x0$1)._2__O());
      var $$x1 = this.persistState__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(p, s)
    } else {
      var $$x1;
      throw new $c_s_MatchError(x0$1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype.onPropsChange__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__Ljapgolly_scalajs_react_callback_Trampoline = (function(prev, next, state) {
  var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().unless$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_AutomaticallySave$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$4$2) => {
    $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState(x$4$2);
    return $n(next).deriveState__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState()
  })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.persistState__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedProps__Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__Ljapgolly_scalajs_react_callback_Trampoline(prev, state)))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction0((() => $n(next).isSameItem__O__Z($n(state).Lreactbuild_analyze_cost_components_AutomaticallySave$TypedState__f_original))));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(this$, $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty)
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend.prototype.onUnload__Lorg_scalajs_dom_BeforeUnloadEvent__Ljapgolly_scalajs_react_callback_Trampoline = (function(ev) {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  $m_Ljapgolly_scalajs_react_package$();
  var this$2 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return $n($$x1).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fDomEvent(ev, this$2.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((x$6$2) => {
    $as_jl_Void(x$6$2);
    var this$ = this.onUnmount__Ljapgolly_scalajs_react_callback_Trampoline();
    var f = new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_jl_Void(x$5$2)
    }));
    var this$5 = $n(this$);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$5, f))
  })))
});
function $as_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.AutomaticallySave$TypedBackend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.AutomaticallySave$TypedBackend;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$() {
  this.Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$__f_title = null;
  this.Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$__f_style = null;
  $n_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$ = this;
  this.Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$__f_title = ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Fonctionnalit\u00e9 \u00e0 venir"));
  this.Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$__f_style = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_featureStateNotYetImplemented
}
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype = $c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype;
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.initiallyExpanded__Z = (function() {
  return false
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.globallyExpanded__Z = (function() {
  return true
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.title__Ljapgolly_scalajs_react_vdom_VdomNode = (function() {
  return this.Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$__f_title
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.description__Lsourcecode_Enclosing__sci_Seq = (function(program) {
  var $$x4 = $m_s_package$().s_package$__f_Seq;
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cette fonctionnalit\u00e9 n'est pas encore commenc\u00e9e.");
  var $$x2 = $m_Lcom_iz2use_react_components_Link$();
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    var qual$1 = window.navigator;
    var x$1 = (("/api/feature/" + $n(program).Lsourcecode_Enclosing__f_value) + "/vote");
    return $uZ(qual$1.sendBeacon(x$1))
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  var $$x1 = $n($$x2).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1));
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Si vous souhaitez qu'elle soit mise en place en priorit\u00e9, vous pouvez voter en cliquant ici."))];
  var array$1 = [$$x3, $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  return $as_sci_Seq($n($$x4).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.style__Lscalacss_internal_StyleA = (function() {
  return this.Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$__f_style
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.productPrefix__T = (function() {
  return "NotYetImplemented"
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.hashCode__I = (function() {
  return (-37954931)
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.toString__T = (function() {
  return "NotYetImplemented"
});
var $d_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$: 0
}, false, "reactbuild.analyze.cost.components.FeatureState$NotYetImplemented$", {
  Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_FeatureState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$;
var $n_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$;
function $m_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$() {
  if ((!$n_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$)) {
    $n_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$ = new $c_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$()
  };
  return $n_Lreactbuild_analyze_cost_components_FeatureState$NotYetImplemented$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$() {
  this.Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$__f_title = null;
  this.Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$__f_style = null;
  $n_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$ = this;
  this.Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$__f_title = ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Fonctionnalit\u00e9 exp\u00e9rimentale [en cours d'impl\u00e9mentation]"));
  this.Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$__f_style = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_featureStateWorkInProgress
}
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype = $c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype;
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.initiallyExpanded__Z = (function() {
  return true
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.globallyExpanded__Z = (function() {
  return false
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.title__Ljapgolly_scalajs_react_vdom_VdomNode = (function() {
  return this.Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$__f_title
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.description__Lsourcecode_Enclosing__sci_Seq = (function(program) {
  var $$x9 = $m_s_package$().s_package$__f_Seq;
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cette fonctionnalit\u00e9 vous est propos\u00e9e \u00e0 titre exp\u00e9rimentale.");
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x7 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Il est possible que le travail fait \u00e0 l'int\u00e9rieur puisse \u00eatre perdu ou que certaines choses ne se comportent pas comme pr\u00e9vu.");
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Certaines de vos donn\u00e9es utilis\u00e9es dans cette fonction peuvent \u00eatre amen\u00e9es \u00e0 \u00eatre transmises \u00e0 ReactBuild afin d'am\u00e9liorer la fonctionnalit\u00e9 et permettre de corriger des probl\u00e8mes.");
  var $$x5 = $m_Lcom_iz2use_react_components_Link$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var $$x2 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).prompt__T__Ljapgolly_scalajs_react_callback_Trampoline("D\u00e9crivez le probl\u00e8me ou l'am\u00e9lioration pour cette fonctionnalit\u00e9 :");
  var this$7 = $m_s_$less$colon$less$();
  var this$ = $n($$x3).asCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__F0($$x2, this$7.s_$less$colon$less$__f_singleton);
  var f$2 = new $c_sjsr_AnonFunction1(((comment$2) => {
    var comment = $as_T(comment$2);
    var data = new FormData();
    data.append("comment", comment);
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var f = new $c_sjsr_AnonFunction0((() => $uZ(window.navigator.sendBeacon((("/api/feature/" + $n(program).Lsourcecode_Enclosing__f_value) + "/comment"), data))));
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      f.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var c = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
  }));
  var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0(this$, f$2);
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var this$22 = $m_s_$less$colon$less$();
  var $$x1 = $n($$x5).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($$x4).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$22.s_$less$colon$less$__f_singleton));
  var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Si vous rencontrez des probl\u00e8mes ou souhaitez proposer des am\u00e9liorations pour cette fonctionnalit\u00e9, veuillez le signaler en cliquant ici."))];
  var array$1 = [$$x8, $$x7, $$x6, $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  return $as_sci_Seq($n($$x9).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.style__Lscalacss_internal_StyleA = (function() {
  return this.Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$__f_style
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.productPrefix__T = (function() {
  return "WorkInProgress"
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.hashCode__I = (function() {
  return (-60175229)
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.toString__T = (function() {
  return "WorkInProgress"
});
var $d_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$: 0
}, false, "reactbuild.analyze.cost.components.FeatureState$WorkInProgress$", {
  Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_FeatureState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$;
var $n_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$;
function $m_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$() {
  if ((!$n_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$)) {
    $n_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$ = new $c_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$()
  };
  return $n_Lreactbuild_analyze_cost_components_FeatureState$WorkInProgress$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$Center$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$Center$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$Center$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$Center$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.order__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($n(area).Lreactbuild_person_DocumentParserArea__f_centerX, $n(area).Lreactbuild_person_DocumentParserArea__f_centerY)
});
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$8 = $m_Lreactbuild_analyze_cost_components_Handle$Center$();
    $n(area);
    var left = ($n(area).Lreactbuild_person_DocumentParserArea__f_left + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var top = ($n(area).Lreactbuild_person_DocumentParserArea__f_top + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var this$2 = $n(area);
    var width = this$2.Lreactbuild_person_DocumentParserArea__f_width;
    var this$3 = $n(area);
    var height = this$3.Lreactbuild_person_DocumentParserArea__f_height;
    var this$4 = $n(area);
    var id = this$4.Lreactbuild_person_DocumentParserArea__f_id;
    var this$5 = $n(area);
    var name = this$5.Lreactbuild_person_DocumentParserArea__f_name;
    var this$6 = $n(area);
    var columns = this$6.Lreactbuild_person_DocumentParserArea__f_columns;
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(left, top, width, height, id, name, columns);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this$8)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.productPrefix__T = (function() {
  return "Center"
});
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.hashCode__I = (function() {
  return 2014820469
});
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.toString__T = (function() {
  return "Center"
});
var $d_Lreactbuild_analyze_cost_components_Handle$Center$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$Center$: 0
}, false, "reactbuild.analyze.cost.components.Handle$Center$", {
  Lreactbuild_analyze_cost_components_Handle$Center$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$Center$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$Center$;
var $n_Lreactbuild_analyze_cost_components_Handle$Center$;
function $m_Lreactbuild_analyze_cost_components_Handle$Center$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$Center$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$Center$ = new $c_Lreactbuild_analyze_cost_components_Handle$Center$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$Center$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1.prototype = $c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1.prototype;
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var area = $as_Lreactbuild_person_DocumentParserArea($n(x1)._1__O());
    var p2 = $as_s_Option($n(x1)._2__O());
    if ((p2 instanceof $c_s_Some)) {
      var x3 = $as_s_Some(p2);
      var handle = $as_Lreactbuild_analyze_cost_components_Handle($n(x3).s_Some__f_value);
      return $ct_T2__O__O__(new $c_T2(), area, handle)
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var p2 = $as_s_Option($n(x1)._2__O());
    if ((p2 instanceof $c_s_Some)) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1: 0
}, false, "reactbuild.analyze.cost.components.PDFPage$Backend$$anonfun$1", {
  Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFPage$Backend$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(value, handle, initialPoint) {
  this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_value = null;
  this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_handle = null;
  this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_initialPoint = null;
  this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_value = value;
  this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_handle = handle;
  this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_initialPoint = initialPoint
}
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype.productPrefix__T = (function() {
  return "DraggingHandle"
});
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_value;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_handle;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_initialPoint;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle)) {
    var DraggingHandle$1 = $as_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_value;
    var x$2 = $n(DraggingHandle$1).Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_value;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_handle;
      var x$4 = $n(DraggingHandle$1).Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_handle;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_initialPoint;
      var x$6 = $n(DraggingHandle$1).Lreactbuild_analyze_cost_components_PDFText$DraggingHandle__f_initialPoint;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        $n(DraggingHandle$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$DraggingHandle"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$DraggingHandle)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$DraggingHandle;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$DraggingHandle: 0
}, false, "reactbuild.analyze.cost.components.PDFText$DraggingHandle", {
  Lreactbuild_analyze_cost_components_PDFText$DraggingHandle: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_PDFText$ActionState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$DraggingHandle;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$FieldResult(area, result) {
  this.Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_area = null;
  this.Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_result = null;
  this.Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_area = area;
  this.Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_result = result
}
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$FieldResult;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$FieldResult() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype.productPrefix__T = (function() {
  return "FieldResult"
});
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_area;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_result;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$FieldResult)) {
    var FieldResult$1 = $as_Lreactbuild_analyze_cost_components_PDFText$FieldResult(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_area;
    var x$2 = $n(FieldResult$1).Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_area;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_result === $n(FieldResult$1).Lreactbuild_analyze_cost_components_PDFText$FieldResult__f_result)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$FieldResult(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$FieldResult) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$FieldResult"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$FieldResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$FieldResult)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$FieldResult(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$FieldResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$FieldResult;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$FieldResult = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$FieldResult: 0
}, false, "reactbuild.analyze.cost.components.PDFText$FieldResult", {
  Lreactbuild_analyze_cost_components_PDFText$FieldResult: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_PDFText$Result: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$FieldResult.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$FieldResult;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$Hover(value, handle) {
  this.Lreactbuild_analyze_cost_components_PDFText$Hover__f_value = null;
  this.Lreactbuild_analyze_cost_components_PDFText$Hover__f_handle = null;
  this.Lreactbuild_analyze_cost_components_PDFText$Hover__f_value = value;
  this.Lreactbuild_analyze_cost_components_PDFText$Hover__f_handle = handle
}
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$Hover;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$Hover() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype.productPrefix__T = (function() {
  return "Hover"
});
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_PDFText$Hover__f_value;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_PDFText$Hover__f_handle;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Hover)) {
    var Hover$1 = $as_Lreactbuild_analyze_cost_components_PDFText$Hover(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFText$Hover__f_value;
    var x$2 = $n(Hover$1).Lreactbuild_analyze_cost_components_PDFText$Hover__f_value;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_PDFText$Hover__f_handle;
      var x$4 = $n(Hover$1).Lreactbuild_analyze_cost_components_PDFText$Hover__f_handle;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Hover$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$Hover(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$Hover) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$Hover"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Hover(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$Hover)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$Hover(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$Hover(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$Hover;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$Hover = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$Hover: 0
}, false, "reactbuild.analyze.cost.components.PDFText$Hover", {
  Lreactbuild_analyze_cost_components_PDFText$Hover: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_PDFText$ActionState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$Hover.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$Hover;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$Idle$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$Idle$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$Idle$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype.productPrefix__T = (function() {
  return "Idle"
});
$c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype.hashCode__I = (function() {
  return 2274292
});
$c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype.toString__T = (function() {
  return "Idle"
});
var $d_Lreactbuild_analyze_cost_components_PDFText$Idle$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$Idle$: 0
}, false, "reactbuild.analyze.cost.components.PDFText$Idle$", {
  Lreactbuild_analyze_cost_components_PDFText$Idle$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_PDFText$ActionState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$Idle$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$Idle$;
var $n_Lreactbuild_analyze_cost_components_PDFText$Idle$;
function $m_Lreactbuild_analyze_cost_components_PDFText$Idle$() {
  if ((!$n_Lreactbuild_analyze_cost_components_PDFText$Idle$)) {
    $n_Lreactbuild_analyze_cost_components_PDFText$Idle$ = new $c_Lreactbuild_analyze_cost_components_PDFText$Idle$()
  };
  return $n_Lreactbuild_analyze_cost_components_PDFText$Idle$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea(area) {
  this.Lreactbuild_analyze_cost_components_PDFText$SelectedArea__f_area = null;
  this.Lreactbuild_analyze_cost_components_PDFText$SelectedArea__f_area = area
}
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$SelectedArea() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.area__ju_UUID = (function() {
  return this.Lreactbuild_analyze_cost_components_PDFText$SelectedArea__f_area
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.fields__sci_List = (function() {
  $n($m_s_package$().s_package$__f_List);
  var array = ["reference", "date", "amount"];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.update__Lreactbuild_person_DocumentParserArea__T__Lreactbuild_person_DocumentParserArea = (function(in$1, name) {
  var this$1 = $n(in$1);
  var x$2 = this$1.Lreactbuild_person_DocumentParserArea__f_left;
  var this$2 = $n(in$1);
  var x$3 = this$2.Lreactbuild_person_DocumentParserArea__f_top;
  var this$3 = $n(in$1);
  var x$4 = this$3.Lreactbuild_person_DocumentParserArea__f_width;
  var this$4 = $n(in$1);
  var x$5 = this$4.Lreactbuild_person_DocumentParserArea__f_height;
  var this$5 = $n(in$1);
  var x$6 = this$5.Lreactbuild_person_DocumentParserArea__f_id;
  var this$6 = $n(in$1);
  var x$7 = this$6.Lreactbuild_person_DocumentParserArea__f_columns;
  $n(in$1);
  return new $c_Lreactbuild_person_DocumentParserArea(x$2, x$3, x$4, x$5, x$6, name, x$7)
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.productPrefix__T = (function() {
  return "SelectedArea"
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_PDFText$SelectedArea__f_area : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea)) {
    var SelectedArea$1 = $as_Lreactbuild_analyze_cost_components_PDFText$SelectedArea(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFText$SelectedArea__f_area;
    var x$2 = $n(SelectedArea$1).Lreactbuild_analyze_cost_components_PDFText$SelectedArea__f_area;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$SelectedArea(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$SelectedArea"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$SelectedArea(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$SelectedArea)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$SelectedArea(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$SelectedArea(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$SelectedArea;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$SelectedArea = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$SelectedArea: 0
}, false, "reactbuild.analyze.cost.components.PDFText$SelectedArea", {
  Lreactbuild_analyze_cost_components_PDFText$SelectedArea: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_PDFText$Selectable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedArea.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$SelectedArea;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn(area, column) {
  this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_area = null;
  this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_column = null;
  this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_area = area;
  this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_column = column
}
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.area__ju_UUID = (function() {
  return this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_area
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.fields__sci_List = (function() {
  $n($m_s_package$().s_package$__f_List);
  var array = ["reference", "description", "quantity", "unit", "unitPrice", "amount"];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.update__Lreactbuild_person_DocumentParserArea__T__Lreactbuild_person_DocumentParserArea = (function(in$1, name) {
  var this$1 = $n($n(in$1).Lreactbuild_person_DocumentParserArea__f_columns);
  _return: {
    var i = 0;
    var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$1, 0, this$1);
    while (true) {
      var this$4 = $n(these);
      if ((!this$4.isEmpty__Z())) {
        var arg1 = $n(these).head__O();
        var x$14 = $as_Lreactbuild_person_DocumentParserColumn(arg1);
        var x = $n(x$14).Lreactbuild_person_DocumentParserColumn__f_id;
        var x$2 = this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_column;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          var x1 = i;
          break _return
        };
        i = ((1 + i) | 0);
        these = $as_sc_LinearSeq($n(these).tail__O())
      } else {
        break
      }
    };
    var x1 = (-1)
  };
  if ((x1 === (-1))) {
    return in$1
  } else {
    var this$12 = $n($n(in$1).Lreactbuild_person_DocumentParserArea__f_columns);
    var $$x1 = $n($m_s_package$().s_package$__f_Seq);
    var this$5 = $n($n(in$1).Lreactbuild_person_DocumentParserArea__f_columns);
    var qual$1 = $as_Lreactbuild_person_DocumentParserColumn($f_sc_LinearSeqOps__apply__I__O(this$5, x1));
    var this$6 = $n(qual$1);
    var x$2$1 = this$6.Lreactbuild_person_DocumentParserColumn__f_width;
    var this$7 = $n(qual$1);
    var x$3 = this$7.Lreactbuild_person_DocumentParserColumn__f_id;
    $n(qual$1);
    var array = [new $c_Lreactbuild_person_DocumentParserColumn(x$2$1, x$3, name)];
    var other = $n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var x$4 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$12, x1, other, 1));
    var this$13 = $n(in$1);
    var x$5 = this$13.Lreactbuild_person_DocumentParserArea__f_left;
    var this$14 = $n(in$1);
    var x$6 = this$14.Lreactbuild_person_DocumentParserArea__f_top;
    var this$15 = $n(in$1);
    var x$7 = this$15.Lreactbuild_person_DocumentParserArea__f_width;
    var this$16 = $n(in$1);
    var x$8 = this$16.Lreactbuild_person_DocumentParserArea__f_height;
    var this$17 = $n(in$1);
    var x$9 = this$17.Lreactbuild_person_DocumentParserArea__f_id;
    var this$18 = $n(in$1);
    var x$10 = this$18.Lreactbuild_person_DocumentParserArea__f_name;
    $n(in$1);
    return new $c_Lreactbuild_person_DocumentParserArea(x$5, x$6, x$7, x$8, x$9, x$10, x$4)
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.productPrefix__T = (function() {
  return "SelectedColumn"
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_area;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_column;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn)) {
    var SelectedColumn$1 = $as_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_area;
    var x$2 = $n(SelectedColumn$1).Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_area;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_column;
      var x$4 = $n(SelectedColumn$1).Lreactbuild_analyze_cost_components_PDFText$SelectedColumn__f_column;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$SelectedColumn"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$SelectedColumn)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$SelectedColumn;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$SelectedColumn: 0
}, false, "reactbuild.analyze.cost.components.PDFText$SelectedColumn", {
  Lreactbuild_analyze_cost_components_PDFText$SelectedColumn: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_PDFText$Selectable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$SelectedColumn;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_PDFText$TableResult(area, rows) {
  this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_area = null;
  this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_rows = null;
  this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_area = area;
  this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_rows = rows
}
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype.constructor = $c_Lreactbuild_analyze_cost_components_PDFText$TableResult;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_PDFText$TableResult() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype = $c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype;
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype.toString__T = (function() {
  var $$x1 = this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_area;
  var this$1 = $n(this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_rows);
  return (($$x1 + "\n") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", "\n", ""))
});
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype.productPrefix__T = (function() {
  return "TableResult"
});
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_area;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_rows;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_PDFText$TableResult)) {
    var TableResult$1 = $as_Lreactbuild_analyze_cost_components_PDFText$TableResult(x$1);
    var x = this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_area;
    var x$2 = $n(TableResult$1).Lreactbuild_analyze_cost_components_PDFText$TableResult__f_area;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_PDFText$TableResult__f_rows;
      var x$4 = $n(TableResult$1).Lreactbuild_analyze_cost_components_PDFText$TableResult__f_rows;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_PDFText$TableResult(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_PDFText$TableResult) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.PDFText$TableResult"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_PDFText$TableResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_PDFText$TableResult)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_PDFText$TableResult(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_PDFText$TableResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.PDFText$TableResult;", depth))
}
var $d_Lreactbuild_analyze_cost_components_PDFText$TableResult = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_PDFText$TableResult: 0
}, false, "reactbuild.analyze.cost.components.PDFText$TableResult", {
  Lreactbuild_analyze_cost_components_PDFText$TableResult: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_PDFText$Result: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_PDFText$TableResult.prototype.$classData = $d_Lreactbuild_analyze_cost_components_PDFText$TableResult;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Progress$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_Progress$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_Progress$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_Progress$Backend__f_$ = \u03b4;
  this.Lreactbuild_analyze_cost_components_Progress$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Progress$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Progress$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Progress$Backend.prototype = $c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype;
$c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_components_Progress$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_components_Progress$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype.reset__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$2 = $n(this.Lreactbuild_analyze_cost_components_Progress$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$1$2) => {
    $as_Lreactbuild_analyze_cost_components_Progress$State(x$1$2);
    return $m_Lreactbuild_analyze_cost_components_Progress$Idle$()
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$2, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype.track__F1__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline = (function(acb, ifDone) {
  var acc = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().completeWith$extension__F1__F1__Ljapgolly_scalajs_react_callback_Trampoline(acb, new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_s_util_Try(x0$1$2);
    if ((x0$1 instanceof $c_s_util_Failure)) {
      var x2 = $as_s_util_Failure(x0$1);
      var ex = $n(x2).s_util_Failure__f_exception;
      var this$8 = $n(this.Lreactbuild_analyze_cost_components_Progress$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$2$2) => {
        $as_Lreactbuild_analyze_cost_components_Progress$State(x$2$2);
        new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        var $$x2 = $m_Ljava_time_Instant$();
        var this$7 = $m_RTLong$();
        var value = $uD(new Date().getTime());
        var lo = this$7.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
        var hi = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return new $c_Lreactbuild_analyze_cost_components_Progress$Failed(ex, $n($$x2).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi)))
      }));
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$8, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else if ((x0$1 instanceof $c_s_util_Success)) {
      var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_Progress$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$3$2) => {
        $as_Lreactbuild_analyze_cost_components_Progress$State(x$3$2);
        new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        var $$x3 = $m_Ljava_time_Instant$();
        var this$14 = $m_RTLong$();
        var value$1 = $uD(new Date().getTime());
        var lo$1 = this$14.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
        var hi$1 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return new $c_Lreactbuild_analyze_cost_components_Progress$Completed($n($$x3).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo$1, hi$1)))
      })), new $c_sjsr_AnonFunction0((() => {
        var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
        var f = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.reset__Ljapgolly_scalajs_react_callback_Trampoline())));
        var G = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x4).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_extra_TimerSupportF__setTimeoutMs__F0__D__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, f, 1500.0, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, ifDone))
      })), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
    } else {
      var $$x1;
      throw new $c_s_MatchError(x0$1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  })));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_components_Progress$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((x$4$2) => {
    $as_Lreactbuild_analyze_cost_components_Progress$State(x$4$2);
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x5 = $m_Ljava_time_Instant$();
    var this$22 = $m_RTLong$();
    var value$2 = $uD(new Date().getTime());
    var lo$2 = this$22.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$2);
    var hi$2 = this$22.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_Lreactbuild_analyze_cost_components_Progress$Pending($n($$x5).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo$2, hi$2)))
  })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(acc))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype.render__Lreactbuild_analyze_cost_components_Progress$Props__Lreactbuild_analyze_cost_components_Progress$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode($n($n(p).Lreactbuild_analyze_cost_components_Progress$Props__f_f).apply__O__O(new $c_Lreactbuild_analyze_cost_components_ProgressContext(s, new $c_sjsr_AnonFunction2(((acb$2, ifDone$2) => {
    var acb = $n($as_Ljapgolly_scalajs_react_callback_AsyncCallback(acb$2)).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr;
    var ifDone = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(ifDone$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.track__F1__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(acb, ifDone))
  })))))
});
function $as_Lreactbuild_analyze_cost_components_Progress$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Progress$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Progress$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Progress$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Progress$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Progress$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Progress$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Progress$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Progress$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Progress$Backend: 0
}, false, "reactbuild.analyze.cost.components.Progress$Backend", {
  Lreactbuild_analyze_cost_components_Progress$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_TimerSupport: 1,
  Ljapgolly_scalajs_react_extra_TimerSupportF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1
});
$c_Lreactbuild_analyze_cost_components_Progress$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Progress$Backend;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Progress$Completed(time) {
  this.Lreactbuild_analyze_cost_components_Progress$Completed__f_time = null;
  this.Lreactbuild_analyze_cost_components_Progress$Completed__f_icon = null;
  this.Lreactbuild_analyze_cost_components_Progress$Completed__f_style = null;
  this.Lreactbuild_analyze_cost_components_Progress$Completed__f_time = time;
  this.Lreactbuild_analyze_cost_components_Progress$Completed__f_icon = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_cloudDone;
  var this$1 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_progressCompleted;
  this.Lreactbuild_analyze_cost_components_Progress$Completed__f_style = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$1, s)
}
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Progress$Completed;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Progress$Completed() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Progress$Completed.prototype = $c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype;
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.getOrElse__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_VdomNode = (function(v) {
  return $f_Lreactbuild_analyze_cost_components_Progress$State__render__Ljapgolly_scalajs_react_vdom_VdomNode(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.style__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lreactbuild_analyze_cost_components_Progress$Completed__f_style
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.productPrefix__T = (function() {
  return "Completed"
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_Progress$Completed__f_time : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Progress$Completed)) {
    var Completed$1 = $as_Lreactbuild_analyze_cost_components_Progress$Completed(x$1);
    var x = this.Lreactbuild_analyze_cost_components_Progress$Completed__f_time;
    var x$2 = $n(Completed$1).Lreactbuild_analyze_cost_components_Progress$Completed__f_time;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.icon__Lcom_iz2use_react_components_IconSource = (function() {
  return this.Lreactbuild_analyze_cost_components_Progress$Completed__f_icon
});
function $as_Lreactbuild_analyze_cost_components_Progress$Completed(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Progress$Completed) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Progress$Completed"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Progress$Completed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Progress$Completed)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Progress$Completed(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Progress$Completed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Progress$Completed;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Progress$Completed = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Progress$Completed: 0
}, false, "reactbuild.analyze.cost.components.Progress$Completed", {
  Lreactbuild_analyze_cost_components_Progress$Completed: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_Progress$State: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Progress$Completed.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Progress$Completed;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Progress$Failed(ex, time) {
  this.Lreactbuild_analyze_cost_components_Progress$Failed__f_ex = null;
  this.Lreactbuild_analyze_cost_components_Progress$Failed__f_time = null;
  this.Lreactbuild_analyze_cost_components_Progress$Failed__f_icon = null;
  this.Lreactbuild_analyze_cost_components_Progress$Failed__f_style = null;
  this.Lreactbuild_analyze_cost_components_Progress$Failed__f_ex = ex;
  this.Lreactbuild_analyze_cost_components_Progress$Failed__f_time = time;
  this.Lreactbuild_analyze_cost_components_Progress$Failed__f_icon = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_cloudOff;
  var this$1 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_progressFailed;
  this.Lreactbuild_analyze_cost_components_Progress$Failed__f_style = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$1, s)
}
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Progress$Failed;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Progress$Failed() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Progress$Failed.prototype = $c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype;
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.getOrElse__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_VdomNode = (function(v) {
  return $f_Lreactbuild_analyze_cost_components_Progress$State__render__Ljapgolly_scalajs_react_vdom_VdomNode(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.style__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lreactbuild_analyze_cost_components_Progress$Failed__f_style
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.productPrefix__T = (function() {
  return "Failed"
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_components_Progress$Failed__f_ex;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_components_Progress$Failed__f_time;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Progress$Failed)) {
    var Failed$1 = $as_Lreactbuild_analyze_cost_components_Progress$Failed(x$1);
    var x = this.Lreactbuild_analyze_cost_components_Progress$Failed__f_ex;
    var x$2 = $n(Failed$1).Lreactbuild_analyze_cost_components_Progress$Failed__f_ex;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_components_Progress$Failed__f_time;
      var x$4 = $n(Failed$1).Lreactbuild_analyze_cost_components_Progress$Failed__f_time;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.icon__Lcom_iz2use_react_components_IconSource = (function() {
  return this.Lreactbuild_analyze_cost_components_Progress$Failed__f_icon
});
function $as_Lreactbuild_analyze_cost_components_Progress$Failed(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Progress$Failed) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Progress$Failed"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Progress$Failed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Progress$Failed)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Progress$Failed(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Progress$Failed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Progress$Failed;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Progress$Failed = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Progress$Failed: 0
}, false, "reactbuild.analyze.cost.components.Progress$Failed", {
  Lreactbuild_analyze_cost_components_Progress$Failed: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_Progress$State: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Progress$Failed.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Progress$Failed;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Progress$Idle$() {
  this.Lreactbuild_analyze_cost_components_Progress$Idle$__f_icon = null;
  this.Lreactbuild_analyze_cost_components_Progress$Idle$__f_style = null;
  $n_Lreactbuild_analyze_cost_components_Progress$Idle$ = this;
  this.Lreactbuild_analyze_cost_components_Progress$Idle$__f_icon = $m_Lcom_iz2use_react_components_NoIconSource$();
  var this$1 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_progressIdle;
  this.Lreactbuild_analyze_cost_components_Progress$Idle$__f_style = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$1, s)
}
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Progress$Idle$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Progress$Idle$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype = $c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype;
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.style__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lreactbuild_analyze_cost_components_Progress$Idle$__f_style
});
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.getOrElse__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_VdomNode = (function(v) {
  return v
});
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.productPrefix__T = (function() {
  return "Idle"
});
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.hashCode__I = (function() {
  return 2274292
});
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.toString__T = (function() {
  return "Idle"
});
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.icon__Lcom_iz2use_react_components_IconSource = (function() {
  return this.Lreactbuild_analyze_cost_components_Progress$Idle$__f_icon
});
var $d_Lreactbuild_analyze_cost_components_Progress$Idle$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Progress$Idle$: 0
}, false, "reactbuild.analyze.cost.components.Progress$Idle$", {
  Lreactbuild_analyze_cost_components_Progress$Idle$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_Progress$State: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Progress$Idle$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Progress$Idle$;
var $n_Lreactbuild_analyze_cost_components_Progress$Idle$;
function $m_Lreactbuild_analyze_cost_components_Progress$Idle$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Progress$Idle$)) {
    $n_Lreactbuild_analyze_cost_components_Progress$Idle$ = new $c_Lreactbuild_analyze_cost_components_Progress$Idle$()
  };
  return $n_Lreactbuild_analyze_cost_components_Progress$Idle$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Progress$Pending(time) {
  this.Lreactbuild_analyze_cost_components_Progress$Pending__f_time = null;
  this.Lreactbuild_analyze_cost_components_Progress$Pending__f_icon = null;
  this.Lreactbuild_analyze_cost_components_Progress$Pending__f_style = null;
  this.Lreactbuild_analyze_cost_components_Progress$Pending__f_time = time;
  this.Lreactbuild_analyze_cost_components_Progress$Pending__f_icon = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_cloudQueue;
  var this$1 = $m_Lscalacss_ScalaCssReact$();
  var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_progressPending;
  this.Lreactbuild_analyze_cost_components_Progress$Pending__f_style = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$1, s)
}
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Progress$Pending;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Progress$Pending() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Progress$Pending.prototype = $c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype;
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.getOrElse__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_VdomNode = (function(v) {
  return $f_Lreactbuild_analyze_cost_components_Progress$State__render__Ljapgolly_scalajs_react_vdom_VdomNode(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.style__Ljapgolly_scalajs_react_vdom_TagMod = (function() {
  return this.Lreactbuild_analyze_cost_components_Progress$Pending__f_style
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.productPrefix__T = (function() {
  return "Pending"
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_Progress$Pending__f_time : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Progress$Pending)) {
    var Pending$1 = $as_Lreactbuild_analyze_cost_components_Progress$Pending(x$1);
    var x = this.Lreactbuild_analyze_cost_components_Progress$Pending__f_time;
    var x$2 = $n(Pending$1).Lreactbuild_analyze_cost_components_Progress$Pending__f_time;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.icon__Lcom_iz2use_react_components_IconSource = (function() {
  return this.Lreactbuild_analyze_cost_components_Progress$Pending__f_icon
});
function $as_Lreactbuild_analyze_cost_components_Progress$Pending(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Progress$Pending) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Progress$Pending"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Progress$Pending(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Progress$Pending)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Progress$Pending(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Progress$Pending(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Progress$Pending;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Progress$Pending = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Progress$Pending: 0
}, false, "reactbuild.analyze.cost.components.Progress$Pending", {
  Lreactbuild_analyze_cost_components_Progress$Pending: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_Progress$State: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Progress$Pending.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Progress$Pending;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Root$$anonfun$1() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$1.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Root$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Root$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Root$$anonfun$1.prototype = $c_Lreactbuild_analyze_cost_components_Root$$anonfun$1.prototype;
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$1.prototype.applyOrElse__Lorg_scalajs_dom_KeyboardEvent__F1__O = (function(x1, default$1) {
  var this$1 = $n($m_s_Option$().apply__O__s_Option($as_T(x1.target.nodeName)));
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var x$2 = $as_T(arg1);
    var $$x1 = $n($m_Lreactbuild_analyze_cost_components_Root$().Lreactbuild_analyze_cost_components_Root$__f_reactbuild$analyze$cost$components$Root$$inputs).contains__O__Z(x$2)
  } else {
    var $$x1 = false
  };
  if (((!$$x1) && ((($as_T(x1.key) === "Divide") || ($as_T(x1.key) === "/")) || ($uI(x1.charCode) === 47)))) {
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Lreactbuild_components_SearchBox$().show__Ljapgolly_scalajs_react_callback_Trampoline())
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$1.prototype.isDefinedAt__Lorg_scalajs_dom_KeyboardEvent__Z = (function(x1) {
  var this$1 = $n($m_s_Option$().apply__O__s_Option($as_T(x1.target.nodeName)));
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var x$2 = $as_T(arg1);
    var $$x1 = $n($m_Lreactbuild_analyze_cost_components_Root$().Lreactbuild_analyze_cost_components_Root$__f_reactbuild$analyze$cost$components$Root$$inputs).contains__O__Z(x$2)
  } else {
    var $$x1 = false
  };
  if ((!$$x1)) {
    return ((($as_T(x1.key) === "Divide") || ($as_T(x1.key) === "/")) || ($uI(x1.charCode) === 47))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lorg_scalajs_dom_KeyboardEvent__Z(x)
});
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lorg_scalajs_dom_KeyboardEvent__F1__O(x, default$1)
});
var $d_Lreactbuild_analyze_cost_components_Root$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Root$$anonfun$1: 0
}, false, "reactbuild.analyze.cost.components.Root$$anonfun$1", {
  Lreactbuild_analyze_cost_components_Root$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$1.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Root$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Root$$anonfun$2() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$2.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Root$$anonfun$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Root$$anonfun$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Root$$anonfun$2.prototype = $c_Lreactbuild_analyze_cost_components_Root$$anonfun$2.prototype;
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$2.prototype.applyOrElse__Lorg_scalajs_dom_KeyboardEvent__F1__O = (function(x2, default$1) {
  return (((($as_T(x2.key) === "Escape") || ($as_T(x2.key) === "Esc")) || ($uI(x2.keyCode) === 27)) ? new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Lcom_iz2use_react_components_Dialog$Broadcaster$().dispatch__Lcom_iz2use_react_components_Dialog$Event__Ljapgolly_scalajs_react_callback_Trampoline($m_Lcom_iz2use_react_components_Dialog$Pop$())) : $n(default$1).apply__O__O(x2))
});
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$2.prototype.isDefinedAt__Lorg_scalajs_dom_KeyboardEvent__Z = (function(x2) {
  return ((($as_T(x2.key) === "Escape") || ($as_T(x2.key) === "Esc")) || ($uI(x2.keyCode) === 27))
});
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lorg_scalajs_dom_KeyboardEvent__Z(x)
});
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lorg_scalajs_dom_KeyboardEvent__F1__O(x, default$1)
});
var $d_Lreactbuild_analyze_cost_components_Root$$anonfun$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Root$$anonfun$2: 0
}, false, "reactbuild.analyze.cost.components.Root$$anonfun$2", {
  Lreactbuild_analyze_cost_components_Root$$anonfun$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Root$$anonfun$2.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Root$$anonfun$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1.prototype = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1.prototype;
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1.prototype.applyOrElse__Ljava_time_LocalDate__F1__O = (function(x1, default$1) {
  return true
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1.prototype.isDefinedAt__Ljava_time_LocalDate__Z = (function(x1) {
  return true
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ljava_time_LocalDate__Z($as_Ljava_time_LocalDate(x))
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ljava_time_LocalDate__F1__O($as_Ljava_time_LocalDate(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1: 0
}, false, "reactbuild.analyze.cost.modules.AccumulatingTable$TypedProps$$anonfun$1", {
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2(outer, from$1) {
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2__f_from$1 = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2__f_from$1 = from$1
}
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2.prototype = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2.prototype;
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2.prototype.applyOrElse__Ljava_time_LocalDate__F1__O = (function(x2, default$1) {
  return ($n(x2).compareTo__Ljava_time_chrono_ChronoLocalDate__I(this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2__f_from$1) >= 0)
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2.prototype.isDefinedAt__Ljava_time_LocalDate__Z = (function(x2) {
  return true
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ljava_time_LocalDate__Z($as_Ljava_time_LocalDate(x))
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ljava_time_LocalDate__F1__O($as_Ljava_time_LocalDate(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2: 0
}, false, "reactbuild.analyze.cost.modules.AccumulatingTable$TypedProps$$anonfun$2", {
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3(outer, to$1) {
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3__f_to$1 = null;
  this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3__f_to$1 = to$1
}
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3.prototype = $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3.prototype;
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3.prototype.applyOrElse__Ljava_time_LocalDate__F1__O = (function(x3, default$1) {
  return ($n(x3).compareTo__Ljava_time_chrono_ChronoLocalDate__I(this.Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3__f_to$1) <= 0)
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3.prototype.isDefinedAt__Ljava_time_LocalDate__Z = (function(x3) {
  return true
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ljava_time_LocalDate__Z($as_Ljava_time_LocalDate(x))
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ljava_time_LocalDate__F1__O($as_Ljava_time_LocalDate(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3: 0
}, false, "reactbuild.analyze.cost.modules.AccumulatingTable$TypedProps$$anonfun$3", {
  Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps$$anonfun$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype;
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype.productPrefix__T = (function() {
  return "InitialStep"
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype.hashCode__I = (function() {
  return (-1393739760)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype.toString__T = (function() {
  return "InitialStep"
});
var $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$: 0
}, false, "reactbuild.analyze.cost.modules.BusinessOpportunities$InitialStep$", {
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$;
var $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$;
function $m_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$)) {
    $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$ = new $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$()
  };
  return $n_Lreactbuild_analyze_cost_modules_BusinessOpportunities$InitialStep$
}
function $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithParcels(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.BusinessOpportunities$WithParcels"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithParcels(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithParcels)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithParcels(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithParcels(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.BusinessOpportunities$WithParcels;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(viewPoint) {
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom__f_viewPoint = null;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom__f_viewPoint = viewPoint
}
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype;
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype.productPrefix__T = (function() {
  return "WithPositionAndZoom"
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom__f_viewPoint : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom)) {
    var WithPositionAndZoom$1 = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom__f_viewPoint;
    var x$2 = $n(WithPositionAndZoom$1).Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom__f_viewPoint;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.BusinessOpportunities$WithPositionAndZoom"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.BusinessOpportunities$WithPositionAndZoom;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom: 0
}, false, "reactbuild.analyze.cost.modules.BusinessOpportunities$WithPositionAndZoom", {
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithPositionAndZoom;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(project) {
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject__f_project = null;
  this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject__f_project = project
}
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype = $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype;
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype.productPrefix__T = (function() {
  return "WithProject"
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject__f_project : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject)) {
    var WithProject$1 = $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject__f_project;
    var x$2 = $n(WithProject$1).Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject__f_project;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.BusinessOpportunities$WithProject"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.BusinessOpportunities$WithProject;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject: 0
}, false, "reactbuild.analyze.cost.modules.BusinessOpportunities$WithProject", {
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_BusinessOpportunities$Step: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_BusinessOpportunities$WithProject;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1(outer, v$11) {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1__f_v$11 = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1__f_v$11 = v$11
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1.prototype.applyOrElse__Ljava_time_Instant__F1__O = (function(x1, default$1) {
  var this$1 = $n(x1);
  var offset = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
  var this$2 = $n($m_Ljava_time_OffsetDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime(this$1, offset));
  var this$3 = $n(this$2.Ljava_time_OffsetDateTime__f_dateTime);
  var x = this$3.Ljava_time_LocalDateTime__f_date;
  var x$2 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1__f_v$11;
  if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
    return x1
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1.prototype.isDefinedAt__Ljava_time_Instant__Z = (function(x1) {
  var this$1 = $n(x1);
  var offset = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
  var this$2 = $n($m_Ljava_time_OffsetDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime(this$1, offset));
  var this$3 = $n(this$2.Ljava_time_OffsetDateTime__f_dateTime);
  var x = this$3.Ljava_time_LocalDateTime__f_date;
  var x$2 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1__f_v$11;
  return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ljava_time_Instant__Z($as_Ljava_time_Instant(x))
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ljava_time_Instant__F1__O($as_Ljava_time_Instant(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1", {
  Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$$nestedInanonfun$update$9$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2(outer, p$6, nextDate$1, terms$2, duration$1, from$1, tpe$1) {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_p$6 = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_nextDate$1 = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_terms$2 = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_duration$1 = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_from$1 = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_tpe$1 = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_p$6 = p$6;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_nextDate$1 = nextDate$1;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_terms$2 = terms$2;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_duration$1 = duration$1;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_from$1 = from$1;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_tpe$1 = tpe$1
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var title = $as_T($n(x1)._2__O());
    $m_sc_StringOps$();
    var x = $f_T__trim__T($n(title));
    var this$3 = $n(x);
    if ((!(this$3 === ""))) {
      var this$4 = $n($n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_p$6).entryOpt__s_Option());
      if (this$4.isEmpty__Z()) {
        var $$x3 = $m_s_None$()
      } else {
        var arg1 = this$4.get__O();
        var x$60 = $as_Lreactbuild_model_ListEntry(arg1);
        var $$x3 = new $c_s_Some($n(x$60)._id__Lreactbuild_common_model_RefTo())
      };
      var this$5 = $n($$x3);
      var $$x2 = $as_Lreactbuild_common_model_RefTo((this$5.isEmpty__Z() ? ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())) : this$5.get__O()));
      var $$x1 = this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_nextDate$1;
      var this$7 = $n(this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_p$6);
      return new $c_Lreactbuild_model_CustomListEntry($$x2, $$x1, $n($n(this$7.context__Lreactbuild_analyze_cost_modules_EditListEntry$Context()).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_project).Lreactbuild_common_model_Project__f__id, title, this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_terms$2, this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_duration$1, this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_from$1, this.Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2__f_tpe$1)
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var title = $as_T($n(x1)._2__O());
    $m_sc_StringOps$();
    var x = $f_T__trim__T($n(title));
    var this$3 = $n(x);
    if ((!(this$3 === ""))) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$Backend$$anonfun$2", {
  Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$Backend$$anonfun$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps(context, update, initialType, term) {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_context = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_update = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_initialType = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_term = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_created = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_entryOpt = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_template = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_terms = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_title = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_tpe = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_context = context;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_update = update;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_initialType = initialType;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_term = term;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_created = $m_s_None$();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_entryOpt = $m_s_None$();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_template = $m_s_None$();
  var this$2 = $m_sci_ListSet$EmptyListSet$();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_terms = $as_sci_ListSet($f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps(this$2, term));
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_title = "";
  var this$3 = $n(initialType);
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_tpe = $as_Lreactbuild_model_ListEntryType((this$3.isEmpty__Z() ? $m_Lreactbuild_model_ListEntryType$TaskList$() : this$3.get__O()))
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.foldInstance__F0__F1__O = (function(ifEmpty, ifExisting) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.validation__Lreactbuild_model_ListEntryValidation = (function() {
  $m_Lreactbuild_model_ListEntryValidation$();
  return $m_Lreactbuild_model_ListEntryValidation$NoValidation$()
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.context__Lreactbuild_analyze_cost_modules_EditListEntry$Context = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_context
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.update__Lreactbuild_analyze_cost_modules_EntryList$Updater = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_update
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.entryOpt__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_entryOpt
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.foldExisting__F0__F1__O = (function(ifEmpty, f) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.terms__sci_ListSet = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_terms
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_title
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.tpe__Lreactbuild_model_ListEntryType = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_tpe
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.productPrefix__T = (function() {
  return "CreationProps"
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_context;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_update;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_initialType;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_term;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps)) {
    var CreationProps$1 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_context;
    var x$2 = $n(CreationProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_context;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_update;
      var x$4 = $n(CreationProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_update;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_initialType;
      var x$6 = $n(CreationProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_initialType;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_term;
        var x$8 = $n(CreationProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_term;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.template__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_template
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.created__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps__f_created
});
function $as_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditListEntry$CreationProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditListEntry$CreationProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$CreationProps", {
  Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_EditListEntry$Props: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$CreationProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1(outer, x3$1) {
  this.Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1__f_x3$1 = null;
  this.Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1__f_x3$1 = x3$1
}
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1.prototype = $c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1.prototype;
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1.prototype.applyOrElse__Lreactbuild_person_Address__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var p3 = $n(x1).Lreactbuild_person_Address__f_details;
    if ((p3 !== null)) {
      var o10 = $n($n(this.Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1__f_x3$1).Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_classTag).unapply__O__s_Option(p3);
      if ((!$n(o10).isEmpty__Z())) {
        return x1
      }
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1.prototype.isDefinedAt__Lreactbuild_person_Address__Z = (function(x1) {
  if ((x1 !== null)) {
    var p3 = $n(x1).Lreactbuild_person_Address__f_details;
    if ((p3 !== null)) {
      var o10 = $n($n(this.Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1__f_x3$1).Lreactbuild_analyze_cost_modules_person_package$AddressDetailsModifier__f_classTag).unapply__O__s_Option(p3);
      if ((!$n(o10).isEmpty__Z())) {
        return true
      }
    }
  };
  return false
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_person_Address__Z($as_Lreactbuild_person_Address(x))
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_person_Address__F1__O($as_Lreactbuild_person_Address(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1: 0
}, false, "reactbuild.analyze.cost.modules.EditPerson$Backend$$anonfun$1", {
  Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditPerson$Backend$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1(outer, x2$1) {
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1__f_x2$1 = null;
  this.Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1__f_x2$1 = x2$1
}
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1.prototype = $c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1.prototype.applyOrElse__Lreactbuild_model_ListTemplateEntry__F1__O = (function(x1, default$1) {
  var x = $n(x1).Lreactbuild_model_ListTemplateEntry__f__id;
  var x$2 = $n(this.Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1__f_x2$1).Lreactbuild_model_InstanceListEntry__f_templateEntry;
  if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
    return x1
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1.prototype.isDefinedAt__Lreactbuild_model_ListTemplateEntry__Z = (function(x1) {
  var x = $n(x1).Lreactbuild_model_ListTemplateEntry__f__id;
  var x$2 = $n(this.Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1__f_x2$1).Lreactbuild_model_InstanceListEntry__f_templateEntry;
  return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_ListTemplateEntry__Z($as_Lreactbuild_model_ListTemplateEntry(x))
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_ListTemplateEntry__F1__O($as_Lreactbuild_model_ListTemplateEntry(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1: 0
}, false, "reactbuild.analyze.cost.modules.EntryList$Backend$$anonfun$1", {
  Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryList$Backend$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1(outer, entry$1) {
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1__f_entry$1 = null;
  this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1__f_entry$1 = entry$1
}
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1.prototype = $c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1.prototype;
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1.prototype.applyOrElse__Lreactbuild_model_WithChildren__F1__O = (function(x1, default$1) {
  var this$1 = $n($n(x1).Lreactbuild_model_WithChildren__f_children);
  _return: {
    var these = this$1;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x$26 = $as_Lreactbuild_model_ListTemplateEntry(arg1);
      var x = $n(x$26).Lreactbuild_model_ListTemplateEntry__f__id;
      var x$2 = $n($n(this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1__f_entry$1).Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_templateEntry).Lreactbuild_model_ListTemplateEntry__f__id;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var $$x1 = true;
        break _return
      };
      these = $as_sci_List($n(these).tail__O())
    };
    var $$x1 = false
  };
  if ($$x1) {
    var this$7 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
    var x$1 = $m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_dynamicFeed;
    var $$x2 = $m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf(x$1, "", "1em");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = (("Multi-projets [" + $n($as_Lreactbuild_model_ListTemplate($n(x1).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_ListTemplate__f_title) + "]");
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x2, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return this$7.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1.prototype.isDefinedAt__Lreactbuild_model_WithChildren__Z = (function(x1) {
  var this$1 = $n($n(x1).Lreactbuild_model_WithChildren__f_children);
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var x$26 = $as_Lreactbuild_model_ListTemplateEntry(arg1);
    var x = $n(x$26).Lreactbuild_model_ListTemplateEntry__f__id;
    var x$2 = $n($n(this.Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1__f_entry$1).Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_templateEntry).Lreactbuild_model_ListTemplateEntry__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return true
    };
    these = $as_sci_List($n(these).tail__O())
  };
  return false
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_WithChildren__Z($as_Lreactbuild_model_WithChildren(x))
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_WithChildren__F1__O($as_Lreactbuild_model_WithChildren(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1: 0
}, false, "reactbuild.analyze.cost.modules.EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1", {
  Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EntryListEntry$Backend$$anonfun$$nestedInanonfun$render$22$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1.prototype.applyOrElse__Lreactbuild_model_ListEntryEventBody__F1__O = (function(x1, default$1) {
  if ($is_Lreactbuild_model_ListEntryEventCheck(x1)) {
    var x2 = $as_Lreactbuild_model_ListEntryEventCheck(x1);
    return x2
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1.prototype.isDefinedAt__Lreactbuild_model_ListEntryEventBody__Z = (function(x1) {
  return $is_Lreactbuild_model_ListEntryEventCheck(x1)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_ListEntryEventBody__Z($as_Lreactbuild_model_ListEntryEventBody(x))
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_ListEntryEventBody__F1__O($as_Lreactbuild_model_ListEntryEventBody(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2.prototype.applyOrElse__Lreactbuild_model_ListEntryEventBody__F1__O = (function(x2, default$1) {
  if ($is_Lreactbuild_model_ListEntryEventSupply(x2)) {
    var x2$2 = $as_Lreactbuild_model_ListEntryEventSupply(x2);
    return x2$2
  } else {
    return $n(default$1).apply__O__O(x2)
  }
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2.prototype.isDefinedAt__Lreactbuild_model_ListEntryEventBody__Z = (function(x2) {
  return $is_Lreactbuild_model_ListEntryEventSupply(x2)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_ListEntryEventBody__Z($as_Lreactbuild_model_ListEntryEventBody(x))
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_ListEntryEventBody__F1__O($as_Lreactbuild_model_ListEntryEventBody(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3.prototype.applyOrElse__Lreactbuild_model_ListEntryEventBody__F1__O = (function(x3, default$1) {
  if ($is_Lreactbuild_model_ListEntryEventGuideline(x3)) {
    var x2 = $as_Lreactbuild_model_ListEntryEventGuideline(x3);
    return x2
  } else {
    return $n(default$1).apply__O__O(x3)
  }
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3.prototype.isDefinedAt__Lreactbuild_model_ListEntryEventBody__Z = (function(x3) {
  return $is_Lreactbuild_model_ListEntryEventGuideline(x3)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_ListEntryEventBody__Z($as_Lreactbuild_model_ListEntryEventBody(x))
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_ListEntryEventBody__F1__O($as_Lreactbuild_model_ListEntryEventBody(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4.prototype.applyOrElse__Lreactbuild_model_ListEntryEventBody__F1__O = (function(x4, default$1) {
  if ($is_Lreactbuild_model_ListEntryEventTask(x4)) {
    var x2 = $as_Lreactbuild_model_ListEntryEventTask(x4);
    return x2
  } else {
    return $n(default$1).apply__O__O(x4)
  }
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4.prototype.isDefinedAt__Lreactbuild_model_ListEntryEventBody__Z = (function(x4) {
  return $is_Lreactbuild_model_ListEntryEventTask(x4)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_ListEntryEventBody__Z($as_Lreactbuild_model_ListEntryEventBody(x))
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_ListEntryEventBody__F1__O($as_Lreactbuild_model_ListEntryEventBody(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$$anonfun$$nestedInanonfun$headers$1$4;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$() {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value = null;
  $ct_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__(this, "#ff9800")
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype = new $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype.productPrefix__T = (function() {
  return "Alternative"
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype.hashCode__I = (function() {
  return 1471074189
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype.toString__T = (function() {
  return "Alternative"
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$Alternative$", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$: 1,
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$;
var $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$;
function $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$)) {
    $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$ = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Alternative$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$() {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value = null;
  $ct_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__(this, "inherit")
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype = new $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype.hashCode__I = (function() {
  return 67081517
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype.toString__T = (function() {
  return "Empty"
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$Empty$", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$: 1,
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$;
var $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$;
function $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$)) {
    $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$ = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Empty$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(tpe, iconSource, title, historySummary, defaultState) {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_tpe = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_iconSource = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_title = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_historySummary = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_defaultState = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_render = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_tpe = tpe;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_iconSource = iconSource;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_title = title;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_historySummary = historySummary;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_defaultState = defaultState;
  var this$6 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var array = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf(iconSource, "", "24px"), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(title))];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_render = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$6, null, ns)
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype = new $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype.productPrefix__T = (function() {
  return "Header"
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_tpe;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_iconSource;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_title;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_historySummary;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_defaultState;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header)) {
    var Header$1 = $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_tpe;
    var x$2 = $n(Header$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_tpe;
    if ((x === null)) {
      var $$x2 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x2 = (this$1 === x$2)
    };
    if ($$x2) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_iconSource;
      var x$4 = $n(Header$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_iconSource;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      if ((this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_title === $n(Header$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_title)) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_historySummary;
        var x$6 = $n(Header$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_historySummary;
        if ((x$5 === null)) {
          var $$x3 = (x$6 === null)
        } else {
          var this$2 = $n(x$5);
          var $$x3 = (this$2 === x$6)
        };
        if ($$x3) {
          var x$7 = this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_defaultState;
          var x$8 = $n(Header$1).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header__f_defaultState;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ListEntryTypeSection$Header"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ListEntryTypeSection$Header;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$Header", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header: 1,
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$AbstractHeader: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Header;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1(pf$1) {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1__f_pf$1 = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1__f_pf$1 = pf$1
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1.prototype.applyOrElse__Lreactbuild_model_ListEntryEvent__F1__O = (function(x1, default$1) {
  return ($n(this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1__f_pf$1).isDefinedAt__O__Z($n(x1).Lreactbuild_model_ListEntryEvent__f_body) ? $n(this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1__f_pf$1).apply__O__O($n(x1).Lreactbuild_model_ListEntryEvent__f_body) : $n(default$1).apply__O__O(x1))
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1.prototype.isDefinedAt__Lreactbuild_model_ListEntryEvent__Z = (function(x1) {
  return $n(this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1__f_pf$1).isDefinedAt__O__Z($n(x1).Lreactbuild_model_ListEntryEvent__f_body)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_ListEntryEvent__Z($as_Lreactbuild_model_ListEntryEvent(x))
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_ListEntryEvent__F1__O($as_Lreactbuild_model_ListEntryEvent(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2(pf$1) {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2__f_pf$1 = null;
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2__f_pf$1 = pf$1
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2.prototype.applyOrElse__Lreactbuild_model_ListEntryEvent__F1__O = (function(x2, default$1) {
  if ($n(this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2__f_pf$1).isDefinedAt__O__Z($n(x2).Lreactbuild_model_ListEntryEvent__f_body)) {
    var $$x2 = $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$().Lreactbuild_analyze_cost_modules_ListEntryTypeSection$__f_eventTypes;
    var this$1 = $n($n(x2).Lreactbuild_model_ListEntryEvent__f_body);
    var $$x1 = $n($as_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType($n($$x2).apply__O__O($objectGetClass(this$1)))).Lreactbuild_analyze_cost_modules_ListEntryTypeSection$EventType__f_name;
    $m_Lcom_iz2use_common_Textualizable$();
    var v = $n(x2).Lreactbuild_model_ListEntryEvent__f_created;
    var this$2 = $m_Lreactbuild_model_Implicits$();
    var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var ev = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$2, locale);
    return (($$x1 + " le ") + $n(ev).stringify__O__T(v))
  } else {
    return $n(default$1).apply__O__O(x2)
  }
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2.prototype.isDefinedAt__Lreactbuild_model_ListEntryEvent__Z = (function(x2) {
  return $n(this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2__f_pf$1).isDefinedAt__O__Z($n(x2).Lreactbuild_model_ListEntryEvent__f_body)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_ListEntryEvent__Z($as_Lreactbuild_model_ListEntryEvent(x))
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_ListEntryEvent__F1__O($as_Lreactbuild_model_ListEntryEvent(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$HistorySummary$$anonfun$$nestedInanonfun$fromEvents$1$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$() {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value = null;
  $ct_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__(this, "#2e89ff")
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype = new $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype.productPrefix__T = (function() {
  return "Ignore"
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype.hashCode__I = (function() {
  return (-2106529294)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype.toString__T = (function() {
  return "Ignore"
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$Ignore$", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$: 1,
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$;
var $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$;
function $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$)) {
    $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$ = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ignore$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$() {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value = null;
  $ct_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__(this, "#ccc")
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype = new $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype.productPrefix__T = (function() {
  return "No"
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype.hashCode__I = (function() {
  return 2529
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype.toString__T = (function() {
  return "No"
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$No$", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$: 1,
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$;
var $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$;
function $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$)) {
    $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$ = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$No$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$() {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value = null;
  $ct_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__(this, "#aa0000")
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype = new $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype.productPrefix__T = (function() {
  return "NotOk"
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype.hashCode__I = (function() {
  return 75455471
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype.toString__T = (function() {
  return "NotOk"
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$NotOk$", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$: 1,
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$;
var $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$;
function $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$)) {
    $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$ = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$NotOk$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$() {
  this.Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__f_value = null;
  $ct_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor__T__(this, "#00aa00")
}
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype = new $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor();
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype = $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype;
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype.productPrefix__T = (function() {
  return "Ok"
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype.hashCode__I = (function() {
  return 2556
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype.toString__T = (function() {
  return "Ok"
});
var $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$: 0
}, false, "reactbuild.analyze.cost.modules.ListEntryTypeSection$Ok$", {
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$: 1,
  Lreactbuild_analyze_cost_modules_ListEntryTypeSection$DecorationColor: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$;
var $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$;
function $m_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$)) {
    $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$ = new $c_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$()
  };
  return $n_Lreactbuild_analyze_cost_modules_ListEntryTypeSection$Ok$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1.prototype = $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1.prototype;
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  var x = $n(x1)._1__O();
  var x$2 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Building;
  if (((x === null) ? (x$2 === null) : $dp_equals__O__Z($n(x), x$2))) {
    return $n(x1)._2__O().getSource()
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  var x = $n(x1)._1__O();
  var x$2 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Building;
  return ((x === null) ? (x$2 === null) : $dp_equals__O__Z($n(x), x$2))
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1: 0
}, false, "reactbuild.analyze.cost.modules.MapLogic$Init$$anonfun$getBuildingSource$1", {
  Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getBuildingSource$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1.prototype = $c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1.prototype;
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  var x = $n(x1)._1__O();
  var x$2 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Site;
  if (((x === null) ? (x$2 === null) : $dp_equals__O__Z($n(x), x$2))) {
    return $n(x1)._2__O().getSource()
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  var x = $n(x1)._1__O();
  var x$2 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Site;
  return ((x === null) ? (x$2 === null) : $dp_equals__O__Z($n(x), x$2))
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1: 0
}, false, "reactbuild.analyze.cost.modules.MapLogic$Init$$anonfun$getParcelSource$1", {
  Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_MapLogic$Init$$anonfun$getParcelSource$1;
function $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__PersonDetails$lzycompute$1__V($thiz) {
  if (($thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_PersonDetails$module === null)) {
    $thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_PersonDetails$module = new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$($thiz)
  }
}
function $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__ReconciliationReport$lzycompute$1__V($thiz) {
  if (($thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_ReconciliationReport$module === null)) {
    $thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_ReconciliationReport$module = new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$($thiz)
  }
}
function $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__DocumentList$lzycompute$1__V($thiz) {
  if (($thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentList$module === null)) {
    $thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentList$module = new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$($thiz)
  }
}
function $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__DocumentLineList$lzycompute$1__V($thiz) {
  if (($thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentLineList$module === null)) {
    $thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentLineList$module = new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$($thiz)
  }
}
function $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__CommunicationList$lzycompute$1__V($thiz) {
  if (($thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_CommunicationList$module === null)) {
    $thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_CommunicationList$module = new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$($thiz)
  }
}
function $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__Products$lzycompute$1__V($thiz) {
  if (($thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_Products$module === null)) {
    $thiz.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_Products$module = new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$($thiz)
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler(router) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_PersonDetails$module = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_ReconciliationReport$module = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentList$module = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentLineList$module = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_CommunicationList$module = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_Products$module = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_router = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_getTabList = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_router = router;
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array = [this.PersonDetails__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$(), new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList(this, ($n(this.CommunicationList__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$()), $m_s_None$())), this.DocumentList__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$(), new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(this, ($n(this.Products__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$()), true), ($n(this.Products__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$()), true), ($n(this.Products__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$()), false), ($n(this.Products__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$()), true), ($n(this.Products__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$()), false), ($n(this.Products__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$()), $m_s_None$())), new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(this, ($n(this.DocumentLineList__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$()), false)), new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(this, ($n(this.ReconciliationReport__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$()), false), ($n(this.ReconciliationReport__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$()), $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$()))];
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_getTabList = $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.PersonDetails__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$ = (function() {
  if ((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_PersonDetails$module === null)) {
    $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__PersonDetails$lzycompute$1__V(this)
  };
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_PersonDetails$module
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.ReconciliationReport__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport$ = (function() {
  if ((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_ReconciliationReport$module === null)) {
    $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__ReconciliationReport$lzycompute$1__V(this)
  };
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_ReconciliationReport$module
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.DocumentList__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$ = (function() {
  if ((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentList$module === null)) {
    $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__DocumentList$lzycompute$1__V(this)
  };
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentList$module
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.DocumentLineList__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$ = (function() {
  if ((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentLineList$module === null)) {
    $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__DocumentLineList$lzycompute$1__V(this)
  };
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_DocumentLineList$module
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.CommunicationList__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList$ = (function() {
  if ((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_CommunicationList$module === null)) {
    $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__CommunicationList$lzycompute$1__V(this)
  };
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_CommunicationList$module
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.Products__Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$ = (function() {
  if ((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_Products$module === null)) {
    $p_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__Products$lzycompute$1__V(this)
  };
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_Products$module
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.getTabList__sci_Seq = (function() {
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_getTabList
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.closeItem__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_callback_Trampoline = (function(context, state) {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_router);
  var route = new $c_Lreactbuild_Loc$Person($m_s_None$());
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$1.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.getItemList__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List = (function(context, state) {
  $m_Lreactbuild_package$();
  var proxy = $n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$1 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$1).Lreactbuild_model_CommonData__f_persons
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.openItem__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagOf = (function(ref, context, state) {
  return $n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$Person(new $c_s_Some(ref)))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.getTitleOf__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_vdom_TagMod = (function(item, context) {
  var proxy = $n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy;
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$1 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$1, proxy);
  var v = $n(ev).stringify__O__T(item);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.getDetailsView__sci_List__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_Seq = (function(items, context, state) {
  return $as_sci_Seq($n($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_active)).toSeq__sci_Seq()).flatMap__F1__O(new $c_sjsr_AnonFunction1(((personRef$2) => {
    var personRef = $as_Lreactbuild_common_model_RefTo(personRef$2);
    var $$x2 = $m_s_Option$();
    var this$2 = $n(items);
    _return: {
      var these = this$2;
      while ((!$n(these).isEmpty__Z())) {
        var arg1 = $n(these).head__O();
        var x$2 = $as_Lreactbuild_person_Person(arg1);
        var x = $n(x$2).Lreactbuild_person_Person__f__id;
        if (((x === null) ? (personRef === null) : $n(x).equals__O__Z(personRef))) {
          var $$x1 = new $c_s_Some($n(these).head__O());
          break _return
        };
        these = $as_sci_List($n(these).tail__O())
      };
      var $$x1 = $m_s_None$()
    };
    return $as_sci_Seq($n($n($n($$x2).option2Iterable__s_Option__sc_Iterable($$x1)).toSeq__sci_Seq()).flatMap__F1__O(new $c_sjsr_AnonFunction1(((person$2) => {
      var person = $as_Lreactbuild_person_Person(person$2);
      return $as_sci_Seq($n($n($as_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase($n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_router, $n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy, person, new $c_sjsr_AnonFunction1(((newState$2) => {
        var newState = $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState(newState$2);
        var this$3 = $n(state);
        var callback = new $c_sjsr_AnonFunction0((() => {
          var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var this$5 = $n(this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$5.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
        }));
        var this$6 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var G = this$6.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
        var arg1$1 = this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
        $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState(arg1$1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(newState), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      })))).map__F1__O(new $c_sjsr_AnonFunction1(((r$2) => {
        var r = $as_Ljapgolly_scalajs_react_vdom_VdomNode(r$2);
        return r
      }))))
    }))))
  }))))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.getMasterView__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomNode = (function(items, context, state) {
  var proxy = $n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy;
  var $$x126 = $m_Lcom_iz2use_react_components_Multiview$();
  var $$x125 = new $c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler();
  var this$2 = $m_s_Symbol$();
  var $$x123 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "_id"));
  var this$3 = $m_s_Symbol$();
  var $$x122 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "organization"));
  var this$4 = $m_s_Symbol$();
  var $$x121 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "name"));
  var this$5 = $m_s_Symbol$();
  var $$x120 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "code"));
  var this$6 = $m_s_Symbol$();
  var $$x119 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "facets"));
  var this$7 = $m_s_Symbol$();
  var $$x118 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "addresses"));
  var this$8 = $m_s_Symbol$();
  var $$x117 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "parent"));
  var this$9 = $m_s_Symbol$();
  var labels = new $c_Lshapeless_$colon$colon($$x123, new $c_Lshapeless_$colon$colon($$x122, new $c_Lshapeless_$colon$colon($$x121, new $c_Lshapeless_$colon$colon($$x120, new $c_Lshapeless_$colon$colon($$x119, new $c_Lshapeless_$colon$colon($$x118, new $c_Lshapeless_$colon$colon($$x117, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$9, "imageUrl")), $m_Lshapeless_HNil$()))))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
  var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
    var x0$3 = $as_Lreactbuild_person_Person(x0$3$2);
    if ((x0$3 !== null)) {
      var _id$macro$25 = $n(x0$3).Lreactbuild_person_Person__f__id;
      var organization$macro$26 = $n(x0$3).Lreactbuild_person_Person__f_organization;
      var name$macro$27 = $n(x0$3).Lreactbuild_person_Person__f_name;
      var code$macro$28 = $n(x0$3).Lreactbuild_person_Person__f_code;
      var facets$macro$29 = $n(x0$3).Lreactbuild_person_Person__f_facets;
      var addresses$macro$30 = $n(x0$3).Lreactbuild_person_Person__f_addresses;
      var parent$macro$31 = $n(x0$3).Lreactbuild_person_Person__f_parent;
      var imageUrl$macro$32 = $n(x0$3).Lreactbuild_person_Person__f_imageUrl;
      return new $c_Lshapeless_$colon$colon(_id$macro$25, new $c_Lshapeless_$colon$colon(organization$macro$26, new $c_Lshapeless_$colon$colon(name$macro$27, new $c_Lshapeless_$colon$colon(code$macro$28, new $c_Lshapeless_$colon$colon(facets$macro$29, new $c_Lshapeless_$colon$colon(addresses$macro$30, new $c_Lshapeless_$colon$colon(parent$macro$31, new $c_Lshapeless_$colon$colon(imageUrl$macro$32, $m_Lshapeless_HNil$()))))))))
    } else {
      throw new $c_s_MatchError(x0$3)
    }
  }));
  var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
    var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
    if ((x0$4 !== null)) {
      var _id$macro$17 = $as_Lreactbuild_common_model_RefTo($n(x0$4).Lshapeless_$colon$colon__f_head);
      var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
      if ((p2 !== null)) {
        var organization$macro$18 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
        var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
        if ((p3 !== null)) {
          var name$macro$19 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
          var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
          if ((p4 !== null)) {
            var code$macro$20 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
            var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
            if ((p5 !== null)) {
              var facets$macro$21 = $as_Lreactbuild_person_Facets($n(p5).Lshapeless_$colon$colon__f_head);
              var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
              if ((p6 !== null)) {
                var addresses$macro$22 = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
                var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                if ((p7 !== null)) {
                  var parent$macro$23 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                  var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                  if ((p8 !== null)) {
                    var imageUrl$macro$24 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                    var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p9)) {
                      return new $c_Lreactbuild_person_Person(_id$macro$17, organization$macro$18, name$macro$19, code$macro$20, facets$macro$21, addresses$macro$22, parent$macro$23, imageUrl$macro$24)
                    }
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$4)
  }));
  var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$13 = $m_s_Symbol$();
  var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$13, "imageUrl"));
  new $c_Lshapeless_Witness$$anon$1(value0);
  var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
  $m_Lshapeless_Witness$();
  var this$16 = $m_s_Symbol$();
  var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$16, "parent"));
  new $c_Lshapeless_Witness$$anon$1(value0$1);
  var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
  $m_Lshapeless_Witness$();
  var this$19 = $m_s_Symbol$();
  var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "addresses"));
  new $c_Lshapeless_Witness$$anon$1(value0$2);
  var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
  $m_Lshapeless_Witness$();
  var this$22 = $m_s_Symbol$();
  var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "facets"));
  new $c_Lshapeless_Witness$$anon$1(value0$3);
  var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
  $m_Lshapeless_Witness$();
  var this$25 = $m_s_Symbol$();
  var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "code"));
  new $c_Lshapeless_Witness$$anon$1(value0$4);
  var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
  $m_Lshapeless_Witness$();
  var this$28 = $m_s_Symbol$();
  var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$5);
  var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
  $m_Lshapeless_Witness$();
  var this$31 = $m_s_Symbol$();
  var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$6);
  var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
  $m_Lshapeless_Witness$();
  var this$34 = $m_s_Symbol$();
  var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$7);
  var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
  var this$37 = $m_s_$less$colon$less$();
  var ev = this$37.s_$less$colon$less$__f_singleton;
  var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
  $m_Lshapeless_Witness$();
  var this$39 = $m_s_Symbol$();
  var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$39, "imageUrl"));
  var wk = new $c_Lshapeless_Witness$$anon$1(value0$8);
  var tailToMap = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk);
  var keyLub = new $c_Lshapeless_Lub$$anon$4();
  var valueLub = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$44 = $m_s_Symbol$();
  var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "parent"));
  var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$9);
  var tailToMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap, keyLub, valueLub, wk$1);
  var keyLub$1 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$1 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$49 = $m_s_Symbol$();
  var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "addresses"));
  var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$10);
  var tailToMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$2);
  var keyLub$2 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$2 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$54 = $m_s_Symbol$();
  var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "facets"));
  var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$11);
  var tailToMap$3 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$2, keyLub$2, valueLub$2, wk$3);
  var keyLub$3 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$3 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$59 = $m_s_Symbol$();
  var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "code"));
  var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$12);
  var tailToMap$4 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$3, keyLub$3, valueLub$3, wk$4);
  var keyLub$4 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$4 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$64 = $m_s_Symbol$();
  var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "name"));
  var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$13);
  var tailToMap$5 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$4, keyLub$4, valueLub$4, wk$5);
  var keyLub$5 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$5 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$69 = $m_s_Symbol$();
  var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$69, "organization"));
  var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$14);
  var tailToMap$6 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$5, keyLub$5, valueLub$5, wk$6);
  var keyLub$6 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$6 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$74 = $m_s_Symbol$();
  var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "_id"));
  var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$15);
  var toMap = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$6, keyLub$6, valueLub$6, wk$7);
  $m_Lshapeless_Witness$();
  var this$77 = $m_s_Symbol$();
  var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$77, "_id"));
  var wk$15 = new $c_Lshapeless_Witness$$anon$1(value0$16);
  var tv$7 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
  $m_Lshapeless_Witness$();
  var this$79 = $m_s_Symbol$();
  var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$79, "organization"));
  var wk$14 = new $c_Lshapeless_Witness$$anon$1(value0$17);
  var tv$6 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
  $m_Lshapeless_Witness$();
  var this$81 = $m_s_Symbol$();
  var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$81, "name"));
  var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$18);
  var tv$5 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")));
  $m_Lshapeless_Witness$();
  var this$83 = $m_s_Symbol$();
  var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "code"));
  var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$19);
  var tv$4 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
  $m_Lshapeless_Witness$();
  var this$85 = $m_s_Symbol$();
  var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$85, "facets"));
  var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$20);
  var tv$3 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_person_Facets.getClassOf(), new $c_sjsr_AnonFunction0((() => "Facets")));
  $m_Lshapeless_Witness$();
  var this$87 = $m_s_Symbol$();
  var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$87, "addresses"));
  var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$21);
  var tv$2 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_person_Address.getClassOf(), new $c_sjsr_AnonFunction0((() => "Address"))));
  $m_Lshapeless_Witness$();
  var this$90 = $m_s_Symbol$();
  var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "parent"));
  var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$22);
  var tv$1 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
  $m_Lshapeless_Witness$();
  var this$92 = $m_s_Symbol$();
  var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "imageUrl"));
  var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$23);
  var tv = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
  var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
  var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$8, tv, fmt);
  var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$9, tv$1, fmt$1);
  var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$10, tv$2, fmt$2);
  var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$11, tv$3, fmt$3);
  var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$12, tv$4, fmt$4);
  var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$13, tv$5, fmt$5);
  var fmt$7 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$14, tv$6, fmt$6);
  var fromMap = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$15, tv$7, fmt$7);
  var $$x124 = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap, gen$1, fromMap);
  $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$();
  var this$339 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$338 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$337 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$336 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$104 = $m_s_Symbol$();
  var $$x58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$104, "_id"));
  var this$105 = $m_s_Symbol$();
  var $$x57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$105, "organization"));
  var this$106 = $m_s_Symbol$();
  var $$x56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$106, "name"));
  var this$107 = $m_s_Symbol$();
  var $$x55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$107, "code"));
  var this$108 = $m_s_Symbol$();
  var $$x54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$108, "facets"));
  var this$109 = $m_s_Symbol$();
  var $$x53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$109, "addresses"));
  var this$110 = $m_s_Symbol$();
  var $$x52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$110, "parent"));
  var this$111 = $m_s_Symbol$();
  var labels$1 = new $c_Lshapeless_$colon$colon($$x58, new $c_Lshapeless_$colon$colon($$x57, new $c_Lshapeless_$colon$colon($$x56, new $c_Lshapeless_$colon$colon($$x55, new $c_Lshapeless_$colon$colon($$x54, new $c_Lshapeless_$colon$colon($$x53, new $c_Lshapeless_$colon$colon($$x52, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$111, "imageUrl")), $m_Lshapeless_HNil$()))))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
  var f$1 = new $c_sjsr_AnonFunction1(((x0$7$2) => {
    var x0$7 = $as_Lreactbuild_person_Person(x0$7$2);
    if ((x0$7 !== null)) {
      var _id$macro$57 = $n(x0$7).Lreactbuild_person_Person__f__id;
      var organization$macro$58 = $n(x0$7).Lreactbuild_person_Person__f_organization;
      var name$macro$59 = $n(x0$7).Lreactbuild_person_Person__f_name;
      var code$macro$60 = $n(x0$7).Lreactbuild_person_Person__f_code;
      var facets$macro$61 = $n(x0$7).Lreactbuild_person_Person__f_facets;
      var addresses$macro$62 = $n(x0$7).Lreactbuild_person_Person__f_addresses;
      var parent$macro$63 = $n(x0$7).Lreactbuild_person_Person__f_parent;
      var imageUrl$macro$64 = $n(x0$7).Lreactbuild_person_Person__f_imageUrl;
      return new $c_Lshapeless_$colon$colon(_id$macro$57, new $c_Lshapeless_$colon$colon(organization$macro$58, new $c_Lshapeless_$colon$colon(name$macro$59, new $c_Lshapeless_$colon$colon(code$macro$60, new $c_Lshapeless_$colon$colon(facets$macro$61, new $c_Lshapeless_$colon$colon(addresses$macro$62, new $c_Lshapeless_$colon$colon(parent$macro$63, new $c_Lshapeless_$colon$colon(imageUrl$macro$64, $m_Lshapeless_HNil$()))))))))
    } else {
      throw new $c_s_MatchError(x0$7)
    }
  }));
  var g$1 = new $c_sjsr_AnonFunction1(((x0$8$2) => {
    var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
    if ((x0$8 !== null)) {
      var _id$macro$49 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
      var p2$1 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
      if ((p2$1 !== null)) {
        var organization$macro$50 = $as_Lreactbuild_common_model_RefTo($n(p2$1).Lshapeless_$colon$colon__f_head);
        var p3$1 = $as_Lshapeless_$colon$colon($n(p2$1).Lshapeless_$colon$colon__f_tail);
        if ((p3$1 !== null)) {
          var name$macro$51 = $as_T($n(p3$1).Lshapeless_$colon$colon__f_head);
          var p4$1 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
          if ((p4$1 !== null)) {
            var code$macro$52 = $as_s_Option($n(p4$1).Lshapeless_$colon$colon__f_head);
            var p5$1 = $as_Lshapeless_$colon$colon($n(p4$1).Lshapeless_$colon$colon__f_tail);
            if ((p5$1 !== null)) {
              var facets$macro$53 = $as_Lreactbuild_person_Facets($n(p5$1).Lshapeless_$colon$colon__f_head);
              var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
              if ((p6$1 !== null)) {
                var addresses$macro$54 = $as_sci_Seq($n(p6$1).Lshapeless_$colon$colon__f_head);
                var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                if ((p7$1 !== null)) {
                  var parent$macro$55 = $as_s_Option($n(p7$1).Lshapeless_$colon$colon__f_head);
                  var p8$1 = $as_Lshapeless_$colon$colon($n(p7$1).Lshapeless_$colon$colon__f_tail);
                  if ((p8$1 !== null)) {
                    var imageUrl$macro$56 = $as_s_Option($n(p8$1).Lshapeless_$colon$colon__f_head);
                    var p9$1 = $as_Lshapeless_HNil($n(p8$1).Lshapeless_$colon$colon__f_tail);
                    var x$1 = $m_Lshapeless_HNil$();
                    if ((x$1 === p9$1)) {
                      return new $c_Lreactbuild_person_Person(_id$macro$49, organization$macro$50, name$macro$51, code$macro$52, facets$macro$53, addresses$macro$54, parent$macro$55, imageUrl$macro$56)
                    }
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$8)
  }));
  var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys$8 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$114 = $m_s_Symbol$();
  var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$114, "imageUrl"));
  new $c_Lshapeless_Witness$$anon$1(value0$24);
  var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
  $m_Lshapeless_Witness$();
  var this$117 = $m_s_Symbol$();
  var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$117, "parent"));
  new $c_Lshapeless_Witness$$anon$1(value0$25);
  var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
  $m_Lshapeless_Witness$();
  var this$120 = $m_s_Symbol$();
  var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$120, "addresses"));
  new $c_Lshapeless_Witness$$anon$1(value0$26);
  var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
  $m_Lshapeless_Witness$();
  var this$123 = $m_s_Symbol$();
  var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$123, "facets"));
  new $c_Lshapeless_Witness$$anon$1(value0$27);
  var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
  $m_Lshapeless_Witness$();
  var this$126 = $m_s_Symbol$();
  var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$126, "code"));
  new $c_Lshapeless_Witness$$anon$1(value0$28);
  var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
  $m_Lshapeless_Witness$();
  var this$129 = $m_s_Symbol$();
  var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$129, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$29);
  var zipWithKeys$14 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
  $m_Lshapeless_Witness$();
  var this$132 = $m_s_Symbol$();
  var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$132, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$30);
  var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
  $m_Lshapeless_Witness$();
  var this$135 = $m_s_Symbol$();
  var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$135, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$31);
  var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
  var this$138 = $m_s_$less$colon$less$();
  var ev$1 = this$138.s_$less$colon$less$__f_singleton;
  new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$1);
  var this$215 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$140 = $m_s_Symbol$();
  var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$140, "_id"));
  var witness$5 = new $c_Lshapeless_Witness$$anon$1(value0$32);
  var $$x62 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var this$142 = $m_Lreactbuild_model_Implicits$();
  var format = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$142);
  var $$x61 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format);
  var this$145 = $m_Lreactbuild_model_Implicits$();
  var this$144 = $m_Lreactbuild_model_Implicits$();
  var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$144, proxy);
  var $$x60 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$145, ev$2)));
  var $$x59 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$147 = $m_Lreactbuild_model_Implicits$();
  var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$147, proxy);
  var fieldRenderable$5 = $n($$x62).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x61, $$x60, $$x59, new $c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1(this, context, state, textualizable), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  var this$214 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$148 = $m_s_Symbol$();
  var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$148, "organization"));
  var witness$4 = new $c_Lshapeless_Witness$$anon$1(value0$33);
  var $$x66 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var this$150 = $m_Lreactbuild_model_Implicits$();
  var format$1 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$150);
  var $$x65 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$1);
  var this$153 = $m_Lreactbuild_model_Implicits$();
  var this$152 = $m_Lreactbuild_model_Implicits$();
  var ev$3 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$152, proxy);
  var $$x64 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$153, ev$3)));
  var $$x63 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$155 = $m_Lreactbuild_model_Implicits$();
  var textualizable$1 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$155, proxy);
  var fieldRenderable$4 = $n($$x66).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x65, $$x64, $$x63, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$1), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  var this$213 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$157 = $m_s_Symbol$();
  var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$157, "name"));
  var witness$3 = new $c_Lshapeless_Witness$$anon$1(value0$34);
  var $$x70 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var format$2 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var $$x69 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$2);
  var $$x68 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
  $m_Lcom_iz2use_common_Parsable$();
  var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var resolver = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  var $$x67 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner, resolver);
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable$3 = $n($$x70).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x69, $$x68, $$x67, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$1), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
  var this$212 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$165 = $m_s_Symbol$();
  var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$165, "code"));
  var witness$2 = new $c_Lshapeless_Witness$$anon$1(value0$35);
  var $$x75 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$3 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var format$4 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$3);
  var $$x74 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$4);
  var ord = $m_s_math_Ordering$String$();
  var $$x73 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$4);
  var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$5);
  var resolver$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  var $$x72 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$1, resolver$1);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$3);
  var $$x71 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$2);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable$2 = $n($$x75).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x74, $$x73, $$x72, $$x71, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$6))));
  var this$211 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.person.Person", "reactbuild.person.Facets");
  var this$210 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.person.Person", "Seq[reactbuild.person.Address]");
  var this$209 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$180 = $m_s_Symbol$();
  var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$180, "parent"));
  var witness$1 = new $c_Lshapeless_Witness$$anon$1(value0$36);
  var $$x79 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var this$182 = $m_Lreactbuild_model_Implicits$();
  var format$5 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$182);
  var format$6 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$5);
  var $$x78 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$6);
  var this$186 = $m_Lreactbuild_model_Implicits$();
  var this$185 = $m_Lreactbuild_model_Implicits$();
  var ev$7 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$185, proxy);
  var ord$1 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$186, ev$7);
  var $$x77 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$1)));
  var $$x76 = new $c_Lcom_iz2use_react_components_NotEditable();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$189 = $m_Lreactbuild_model_Implicits$();
  var textualizable$3 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$189, proxy);
  var textualizable$4 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$3);
  var fieldRenderable$1 = $n($$x79).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x78, $$x77, $$x76, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$4), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  var this$208 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$192 = $m_s_Symbol$();
  var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$192, "imageUrl"));
  var witness = new $c_Lshapeless_Witness$$anon$1(value0$37);
  var $$x84 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$7 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var format$8 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$7);
  var $$x83 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$8);
  var ord$2 = $m_s_math_Ordering$String$();
  var $$x82 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$2)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$8);
  var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$9);
  var resolver$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
  var $$x81 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$2, resolver$2);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$5);
  var $$x80 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$5);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable = $n($$x84).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x83, $$x82, $$x81, $$x80, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$10))));
  var tail = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4();
  var tail$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$208, fieldRenderable, witness, tail);
  var tail$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$209, fieldRenderable$1, witness$1, tail$1);
  var tail$3 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$210, tail$2);
  var tail$4 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$211, tail$3);
  var tail$5 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$212, fieldRenderable$2, witness$2, tail$4);
  var tail$6 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$213, fieldRenderable$3, witness$3, tail$5);
  var tail$7 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$214, fieldRenderable$4, witness$4, tail$6);
  var renderer = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$215, fieldRenderable$5, witness$5, tail$7);
  $m_s_DummyImplicit$();
  new $c_Lshapeless_Refute$$anon$2();
  var view$1 = new $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1(renderer);
  var this$334 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$333 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$218 = $m_s_Symbol$();
  var $$x91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$218, "_id"));
  var this$219 = $m_s_Symbol$();
  var $$x90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$219, "organization"));
  var this$220 = $m_s_Symbol$();
  var $$x89 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$220, "name"));
  var this$221 = $m_s_Symbol$();
  var $$x88 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$221, "code"));
  var this$222 = $m_s_Symbol$();
  var $$x87 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$222, "facets"));
  var this$223 = $m_s_Symbol$();
  var $$x86 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$223, "addresses"));
  var this$224 = $m_s_Symbol$();
  var $$x85 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$224, "parent"));
  var this$225 = $m_s_Symbol$();
  var labels$2 = new $c_Lshapeless_$colon$colon($$x91, new $c_Lshapeless_$colon$colon($$x90, new $c_Lshapeless_$colon$colon($$x89, new $c_Lshapeless_$colon$colon($$x88, new $c_Lshapeless_$colon$colon($$x87, new $c_Lshapeless_$colon$colon($$x86, new $c_Lshapeless_$colon$colon($$x85, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$225, "imageUrl")), $m_Lshapeless_HNil$()))))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
  var f$2 = new $c_sjsr_AnonFunction1(((x0$11$2) => {
    var x0$11 = $as_Lreactbuild_person_Person(x0$11$2);
    if ((x0$11 !== null)) {
      var _id$macro$89 = $n(x0$11).Lreactbuild_person_Person__f__id;
      var organization$macro$90 = $n(x0$11).Lreactbuild_person_Person__f_organization;
      var name$macro$91 = $n(x0$11).Lreactbuild_person_Person__f_name;
      var code$macro$92 = $n(x0$11).Lreactbuild_person_Person__f_code;
      var facets$macro$93 = $n(x0$11).Lreactbuild_person_Person__f_facets;
      var addresses$macro$94 = $n(x0$11).Lreactbuild_person_Person__f_addresses;
      var parent$macro$95 = $n(x0$11).Lreactbuild_person_Person__f_parent;
      var imageUrl$macro$96 = $n(x0$11).Lreactbuild_person_Person__f_imageUrl;
      return new $c_Lshapeless_$colon$colon(_id$macro$89, new $c_Lshapeless_$colon$colon(organization$macro$90, new $c_Lshapeless_$colon$colon(name$macro$91, new $c_Lshapeless_$colon$colon(code$macro$92, new $c_Lshapeless_$colon$colon(facets$macro$93, new $c_Lshapeless_$colon$colon(addresses$macro$94, new $c_Lshapeless_$colon$colon(parent$macro$95, new $c_Lshapeless_$colon$colon(imageUrl$macro$96, $m_Lshapeless_HNil$()))))))))
    } else {
      throw new $c_s_MatchError(x0$11)
    }
  }));
  var g$2 = new $c_sjsr_AnonFunction1(((x0$12$2) => {
    var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
    if ((x0$12 !== null)) {
      var _id$macro$81 = $as_Lreactbuild_common_model_RefTo($n(x0$12).Lshapeless_$colon$colon__f_head);
      var p2$2 = $as_Lshapeless_$colon$colon($n(x0$12).Lshapeless_$colon$colon__f_tail);
      if ((p2$2 !== null)) {
        var organization$macro$82 = $as_Lreactbuild_common_model_RefTo($n(p2$2).Lshapeless_$colon$colon__f_head);
        var p3$2 = $as_Lshapeless_$colon$colon($n(p2$2).Lshapeless_$colon$colon__f_tail);
        if ((p3$2 !== null)) {
          var name$macro$83 = $as_T($n(p3$2).Lshapeless_$colon$colon__f_head);
          var p4$2 = $as_Lshapeless_$colon$colon($n(p3$2).Lshapeless_$colon$colon__f_tail);
          if ((p4$2 !== null)) {
            var code$macro$84 = $as_s_Option($n(p4$2).Lshapeless_$colon$colon__f_head);
            var p5$2 = $as_Lshapeless_$colon$colon($n(p4$2).Lshapeless_$colon$colon__f_tail);
            if ((p5$2 !== null)) {
              var facets$macro$85 = $as_Lreactbuild_person_Facets($n(p5$2).Lshapeless_$colon$colon__f_head);
              var p6$2 = $as_Lshapeless_$colon$colon($n(p5$2).Lshapeless_$colon$colon__f_tail);
              if ((p6$2 !== null)) {
                var addresses$macro$86 = $as_sci_Seq($n(p6$2).Lshapeless_$colon$colon__f_head);
                var p7$2 = $as_Lshapeless_$colon$colon($n(p6$2).Lshapeless_$colon$colon__f_tail);
                if ((p7$2 !== null)) {
                  var parent$macro$87 = $as_s_Option($n(p7$2).Lshapeless_$colon$colon__f_head);
                  var p8$2 = $as_Lshapeless_$colon$colon($n(p7$2).Lshapeless_$colon$colon__f_tail);
                  if ((p8$2 !== null)) {
                    var imageUrl$macro$88 = $as_s_Option($n(p8$2).Lshapeless_$colon$colon__f_head);
                    var p9$2 = $as_Lshapeless_HNil($n(p8$2).Lshapeless_$colon$colon__f_tail);
                    var x$2 = $m_Lshapeless_HNil$();
                    if ((x$2 === p9$2)) {
                      return new $c_Lreactbuild_person_Person(_id$macro$81, organization$macro$82, name$macro$83, code$macro$84, facets$macro$85, addresses$macro$86, parent$macro$87, imageUrl$macro$88)
                    }
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$12)
  }));
  var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys$16 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$228 = $m_s_Symbol$();
  var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$228, "imageUrl"));
  new $c_Lshapeless_Witness$$anon$1(value0$38);
  var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
  $m_Lshapeless_Witness$();
  var this$231 = $m_s_Symbol$();
  var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$231, "parent"));
  new $c_Lshapeless_Witness$$anon$1(value0$39);
  var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
  $m_Lshapeless_Witness$();
  var this$234 = $m_s_Symbol$();
  var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$234, "addresses"));
  new $c_Lshapeless_Witness$$anon$1(value0$40);
  var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
  $m_Lshapeless_Witness$();
  var this$237 = $m_s_Symbol$();
  var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$237, "facets"));
  new $c_Lshapeless_Witness$$anon$1(value0$41);
  var zipWithKeys$20 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
  $m_Lshapeless_Witness$();
  var this$240 = $m_s_Symbol$();
  var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$240, "code"));
  new $c_Lshapeless_Witness$$anon$1(value0$42);
  var zipWithKeys$21 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
  $m_Lshapeless_Witness$();
  var this$243 = $m_s_Symbol$();
  var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$243, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$43);
  var zipWithKeys$22 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
  $m_Lshapeless_Witness$();
  var this$246 = $m_s_Symbol$();
  var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$246, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$44);
  var zipWithKeys$23 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
  $m_Lshapeless_Witness$();
  var this$249 = $m_s_Symbol$();
  var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$249, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$45);
  var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$23);
  var this$252 = $m_s_$less$colon$less$();
  var ev$11 = this$252.s_$less$colon$less$__f_singleton;
  new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$11);
  var this$327 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$254 = $m_s_Symbol$();
  var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$254, "_id"));
  var witness$11 = new $c_Lshapeless_Witness$$anon$1(value0$46);
  var $$x95 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  var this$256 = $m_Lreactbuild_model_Implicits$();
  var format$9 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$256);
  var $$x94 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$9);
  var this$259 = $m_Lreactbuild_model_Implicits$();
  var this$258 = $m_Lreactbuild_model_Implicits$();
  var ev$12 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$258, proxy);
  var $$x93 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$259, ev$12)));
  var $$x92 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$261 = $m_Lreactbuild_model_Implicits$();
  var textualizable$6 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$261, proxy);
  var columnRenderable$5 = $n($$x95).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x94, $$x93, $$x92, new $c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1(this, context, state, textualizable$6));
  var this$326 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$262 = $m_s_Symbol$();
  var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$262, "organization"));
  var witness$10 = new $c_Lshapeless_Witness$$anon$1(value0$47);
  var $$x99 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  var this$264 = $m_Lreactbuild_model_Implicits$();
  var format$10 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$264);
  var $$x98 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$10);
  var this$267 = $m_Lreactbuild_model_Implicits$();
  var this$266 = $m_Lreactbuild_model_Implicits$();
  var ev$13 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$266, proxy);
  var $$x97 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$267, ev$13)));
  var $$x96 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$269 = $m_Lreactbuild_model_Implicits$();
  var textualizable$7 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$269, proxy);
  var columnRenderable$4 = $n($$x99).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x98, $$x97, $$x96, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$7));
  var this$325 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$271 = $m_s_Symbol$();
  var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$271, "name"));
  var witness$9 = new $c_Lshapeless_Witness$$anon$1(value0$48);
  var $$x103 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  var format$11 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var $$x102 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$11);
  var $$x101 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
  $m_Lcom_iz2use_common_Parsable$();
  var evDefault$3 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
  var parser$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var resolver$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
  var $$x100 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$3, resolver$3);
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var columnRenderable$3 = $n($$x103).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x102, $$x101, $$x100, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$7));
  var this$324 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$279 = $m_s_Symbol$();
  var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$279, "code"));
  var witness$8 = new $c_Lshapeless_Witness$$anon$1(value0$49);
  var $$x107 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$12 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var format$13 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$12);
  var $$x106 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$13);
  var ord$3 = $m_s_math_Ordering$String$();
  var $$x105 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$3)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$14 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$14);
  var evDefault$4 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$4);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$4 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$15);
  var resolver$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
  var $$x104 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$4, resolver$4);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$8 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$9);
  var columnRenderable$2 = $n($$x107).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x106, $$x105, $$x104, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$8));
  var this$323 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.person.Person", "reactbuild.person.Facets");
  var this$322 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.person.Person", "Seq[reactbuild.person.Address]");
  var this$321 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$293 = $m_s_Symbol$();
  var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$293, "parent"));
  var witness$7 = new $c_Lshapeless_Witness$$anon$1(value0$50);
  var $$x111 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var this$295 = $m_Lreactbuild_model_Implicits$();
  var format$14 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$295);
  var format$15 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$14);
  var $$x110 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$15);
  var this$299 = $m_Lreactbuild_model_Implicits$();
  var this$298 = $m_Lreactbuild_model_Implicits$();
  var ev$16 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$298, proxy);
  var ord$4 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$299, ev$16);
  var $$x109 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$4)));
  var $$x108 = new $c_Lcom_iz2use_react_components_NotEditable();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$302 = $m_Lreactbuild_model_Implicits$();
  var textualizable$9 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$302, proxy);
  var textualizable$10 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$9);
  var columnRenderable$1 = $n($$x111).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x110, $$x109, $$x108, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$10));
  var this$320 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$305 = $m_s_Symbol$();
  var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$305, "imageUrl"));
  var witness$6 = new $c_Lshapeless_Witness$$anon$1(value0$51);
  var $$x115 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$16 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var format$17 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$16);
  var $$x114 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$17);
  var ord$5 = $m_s_math_Ordering$String$();
  var $$x113 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$5)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$17);
  var evDefault$5 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$5 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$5);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$18 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$5 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$18);
  var resolver$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
  var $$x112 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$5, resolver$5);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$11 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$11 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$11);
  var columnRenderable = $n($$x115).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x114, $$x113, $$x112, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$11));
  var tail$8 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
  var tail$9 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$320, columnRenderable, witness$6, tail$8);
  var tail$10 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$321, columnRenderable$1, witness$7, tail$9);
  var tail$11 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$322, tail$10);
  var tail$12 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$323, tail$11);
  var tail$13 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$324, columnRenderable$2, witness$8, tail$12);
  var tail$14 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$325, columnRenderable$3, witness$9, tail$13);
  var tail$15 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$326, columnRenderable$4, witness$10, tail$14);
  var renderer$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$327, columnRenderable$5, witness$11, tail$15);
  $m_s_DummyImplicit$();
  new $c_Lshapeless_Refute$$anon$2();
  var columnFragment = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$1);
  var view = new $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment);
  var tail$16 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2();
  var tail$17 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view, tail$16);
  var tail$18 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$333, tail$17);
  var tail$19 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$334, tail$18);
  var tail$20 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$1, tail$19);
  var tail$21 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$336, tail$20);
  var tail$22 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$337, tail$21);
  var tail$23 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$338, tail$22);
  var mat = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$339, tail$23);
  $m_s_DummyImplicit$();
  new $c_Lshapeless_Refute$$anon$2();
  var $$x116 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViews(mat.apply__sci_List());
  var $$x51 = $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$().Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable;
  var this$342 = $m_s_Symbol$();
  var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$342, "_id"));
  var this$343 = $m_s_Symbol$();
  var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$343, "organization"));
  var this$344 = $m_s_Symbol$();
  var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$344, "name"));
  var this$345 = $m_s_Symbol$();
  var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$345, "code"));
  var this$346 = $m_s_Symbol$();
  var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$346, "facets"));
  var this$347 = $m_s_Symbol$();
  var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$347, "addresses"));
  var this$348 = $m_s_Symbol$();
  var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$348, "parent"));
  var this$349 = $m_s_Symbol$();
  var labels$3 = new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$349, "imageUrl")), $m_Lshapeless_HNil$()))))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
  var f$3 = new $c_sjsr_AnonFunction1(((x0$15$2) => {
    var x0$15 = $as_Lreactbuild_person_Person(x0$15$2);
    if ((x0$15 !== null)) {
      var _id$macro$121 = $n(x0$15).Lreactbuild_person_Person__f__id;
      var organization$macro$122 = $n(x0$15).Lreactbuild_person_Person__f_organization;
      var name$macro$123 = $n(x0$15).Lreactbuild_person_Person__f_name;
      var code$macro$124 = $n(x0$15).Lreactbuild_person_Person__f_code;
      var facets$macro$125 = $n(x0$15).Lreactbuild_person_Person__f_facets;
      var addresses$macro$126 = $n(x0$15).Lreactbuild_person_Person__f_addresses;
      var parent$macro$127 = $n(x0$15).Lreactbuild_person_Person__f_parent;
      var imageUrl$macro$128 = $n(x0$15).Lreactbuild_person_Person__f_imageUrl;
      return new $c_Lshapeless_$colon$colon(_id$macro$121, new $c_Lshapeless_$colon$colon(organization$macro$122, new $c_Lshapeless_$colon$colon(name$macro$123, new $c_Lshapeless_$colon$colon(code$macro$124, new $c_Lshapeless_$colon$colon(facets$macro$125, new $c_Lshapeless_$colon$colon(addresses$macro$126, new $c_Lshapeless_$colon$colon(parent$macro$127, new $c_Lshapeless_$colon$colon(imageUrl$macro$128, $m_Lshapeless_HNil$()))))))))
    } else {
      throw new $c_s_MatchError(x0$15)
    }
  }));
  var g$3 = new $c_sjsr_AnonFunction1(((x0$16$2) => {
    var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
    if ((x0$16 !== null)) {
      var _id$macro$113 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
      var p2$3 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
      if ((p2$3 !== null)) {
        var organization$macro$114 = $as_Lreactbuild_common_model_RefTo($n(p2$3).Lshapeless_$colon$colon__f_head);
        var p3$3 = $as_Lshapeless_$colon$colon($n(p2$3).Lshapeless_$colon$colon__f_tail);
        if ((p3$3 !== null)) {
          var name$macro$115 = $as_T($n(p3$3).Lshapeless_$colon$colon__f_head);
          var p4$3 = $as_Lshapeless_$colon$colon($n(p3$3).Lshapeless_$colon$colon__f_tail);
          if ((p4$3 !== null)) {
            var code$macro$116 = $as_s_Option($n(p4$3).Lshapeless_$colon$colon__f_head);
            var p5$3 = $as_Lshapeless_$colon$colon($n(p4$3).Lshapeless_$colon$colon__f_tail);
            if ((p5$3 !== null)) {
              var facets$macro$117 = $as_Lreactbuild_person_Facets($n(p5$3).Lshapeless_$colon$colon__f_head);
              var p6$3 = $as_Lshapeless_$colon$colon($n(p5$3).Lshapeless_$colon$colon__f_tail);
              if ((p6$3 !== null)) {
                var addresses$macro$118 = $as_sci_Seq($n(p6$3).Lshapeless_$colon$colon__f_head);
                var p7$3 = $as_Lshapeless_$colon$colon($n(p6$3).Lshapeless_$colon$colon__f_tail);
                if ((p7$3 !== null)) {
                  var parent$macro$119 = $as_s_Option($n(p7$3).Lshapeless_$colon$colon__f_head);
                  var p8$3 = $as_Lshapeless_$colon$colon($n(p7$3).Lshapeless_$colon$colon__f_tail);
                  if ((p8$3 !== null)) {
                    var imageUrl$macro$120 = $as_s_Option($n(p8$3).Lshapeless_$colon$colon__f_head);
                    var p9$3 = $as_Lshapeless_HNil($n(p8$3).Lshapeless_$colon$colon__f_tail);
                    var x$3 = $m_Lshapeless_HNil$();
                    if ((x$3 === p9$3)) {
                      return new $c_Lreactbuild_person_Person(_id$macro$113, organization$macro$114, name$macro$115, code$macro$116, facets$macro$117, addresses$macro$118, parent$macro$119, imageUrl$macro$120)
                    }
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$16)
  }));
  var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys$24 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$352 = $m_s_Symbol$();
  var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$352, "imageUrl"));
  new $c_Lshapeless_Witness$$anon$1(value0$52);
  var zipWithKeys$25 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$24);
  $m_Lshapeless_Witness$();
  var this$355 = $m_s_Symbol$();
  var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$355, "parent"));
  new $c_Lshapeless_Witness$$anon$1(value0$53);
  var zipWithKeys$26 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$25);
  $m_Lshapeless_Witness$();
  var this$358 = $m_s_Symbol$();
  var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$358, "addresses"));
  new $c_Lshapeless_Witness$$anon$1(value0$54);
  var zipWithKeys$27 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$26);
  $m_Lshapeless_Witness$();
  var this$361 = $m_s_Symbol$();
  var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$361, "facets"));
  new $c_Lshapeless_Witness$$anon$1(value0$55);
  var zipWithKeys$28 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$27);
  $m_Lshapeless_Witness$();
  var this$364 = $m_s_Symbol$();
  var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$364, "code"));
  new $c_Lshapeless_Witness$$anon$1(value0$56);
  var zipWithKeys$29 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$28);
  $m_Lshapeless_Witness$();
  var this$367 = $m_s_Symbol$();
  var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$367, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$57);
  var zipWithKeys$30 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$29);
  $m_Lshapeless_Witness$();
  var this$370 = $m_s_Symbol$();
  var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$370, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$58);
  var zipWithKeys$31 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$30);
  $m_Lshapeless_Witness$();
  var this$373 = $m_s_Symbol$();
  var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$373, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$59);
  var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$31);
  var this$376 = $m_s_$less$colon$less$();
  var ev$19 = this$376.s_$less$colon$less$__f_singleton;
  new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$19);
  $m_Lshapeless_Witness$();
  var this$378 = $m_s_Symbol$();
  var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$378, "_id"));
  var witness$17 = new $c_Lshapeless_Witness$$anon$1(value0$60);
  var $$x27 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var this$380 = $m_Lreactbuild_model_Implicits$();
  var format$18 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$380);
  var $$x26 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$18);
  var this$383 = $m_Lreactbuild_model_Implicits$();
  var this$382 = $m_Lreactbuild_model_Implicits$();
  var ev$20 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$382, proxy);
  var $$x25 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$383, ev$20)));
  var $$x24 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$385 = $m_Lreactbuild_model_Implicits$();
  var textualizable$12 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$385, proxy);
  var fieldRenderable$11 = $n($$x27).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x26, $$x25, $$x24, new $c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1(this, context, state, textualizable$12), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  $m_Lshapeless_Witness$();
  var this$386 = $m_s_Symbol$();
  var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$386, "organization"));
  var witness$16 = new $c_Lshapeless_Witness$$anon$1(value0$61);
  var $$x31 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var this$388 = $m_Lreactbuild_model_Implicits$();
  var format$19 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$388);
  var $$x30 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$19);
  var this$391 = $m_Lreactbuild_model_Implicits$();
  var this$390 = $m_Lreactbuild_model_Implicits$();
  var ev$21 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$390, proxy);
  var $$x29 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$391, ev$21)));
  var $$x28 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$393 = $m_Lreactbuild_model_Implicits$();
  var textualizable$13 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$393, proxy);
  var fieldRenderable$10 = $n($$x31).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x30, $$x29, $$x28, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$13), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  $m_Lshapeless_Witness$();
  var this$395 = $m_s_Symbol$();
  var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$395, "name"));
  var witness$15 = new $c_Lshapeless_Witness$$anon$1(value0$62);
  var $$x35 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var format$20 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var $$x34 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$20);
  var $$x33 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
  $m_Lcom_iz2use_common_Parsable$();
  var evDefault$6 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner$6 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$6);
  var parser$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var resolver$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
  var $$x32 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$6, resolver$6);
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$13 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable$9 = $n($$x35).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x34, $$x33, $$x32, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$13), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
  $m_Lshapeless_Witness$();
  var this$403 = $m_s_Symbol$();
  var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$403, "code"));
  var witness$14 = new $c_Lshapeless_Witness$$anon$1(value0$63);
  var $$x40 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$21 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var format$22 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$21);
  var $$x39 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$22);
  var ord$6 = $m_s_math_Ordering$String$();
  var $$x38 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$6)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$22 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$22);
  var evDefault$7 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$7 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$7);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$23 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$7 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$23);
  var resolver$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
  var $$x37 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$7, resolver$7);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$14 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$15);
  var $$x36 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$14);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$24 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable$8 = $n($$x40).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x39, $$x38, $$x37, $$x36, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$24))));
  var this$449 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
  var this$448 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
  $m_Lshapeless_Witness$();
  var this$418 = $m_s_Symbol$();
  var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$418, "parent"));
  var witness$13 = new $c_Lshapeless_Witness$$anon$1(value0$64);
  var $$x44 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var this$420 = $m_Lreactbuild_model_Implicits$();
  var format$23 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$420);
  var format$24 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$23);
  var $$x43 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$24);
  var this$424 = $m_Lreactbuild_model_Implicits$();
  var this$423 = $m_Lreactbuild_model_Implicits$();
  var ev$25 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$423, proxy);
  var ord$7 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$424, ev$25);
  var $$x42 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$7)));
  var $$x41 = new $c_Lcom_iz2use_react_components_NotEditable();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$427 = $m_Lreactbuild_model_Implicits$();
  var textualizable$15 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$427, proxy);
  var textualizable$16 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$15);
  var fieldRenderable$7 = $n($$x44).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x43, $$x42, $$x41, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$16), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  $m_Lshapeless_Witness$();
  var this$430 = $m_s_Symbol$();
  var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$430, "imageUrl"));
  var witness$12 = new $c_Lshapeless_Witness$$anon$1(value0$65);
  var $$x49 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$25 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var format$26 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$25);
  var $$x48 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$26);
  var ord$8 = $m_s_math_Ordering$String$();
  var $$x47 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$8)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$26 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$26);
  var evDefault$8 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$8 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$8);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$27 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$8 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$27);
  var resolver$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$8);
  var $$x46 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$8, resolver$8);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$17 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$17);
  var $$x45 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$17);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$28 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable$6 = $n($$x49).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x48, $$x47, $$x46, $$x45, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$28))));
  var tail$24 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3();
  var tail$25 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$6, witness$12, tail$24);
  var tail$26 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$7, witness$13, tail$25);
  var tail$27 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$448, tail$26);
  var tail$28 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$449, tail$27);
  var tail$29 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$8, witness$14, tail$28);
  var tail$30 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$9, witness$15, tail$29);
  var tail$31 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$10, witness$16, tail$30);
  var renderer$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$11, witness$17, tail$31);
  var $$x50 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$2);
  var $$x16 = $m_Lreactbuild_person_Person$().keyMapper__Lcom_iz2use_common_KeyMapper();
  var $$x15 = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
  var $$x14 = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
  var this$455 = $m_s_Symbol$();
  var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$455, "_id"));
  var this$456 = $m_s_Symbol$();
  var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$456, "organization"));
  var this$457 = $m_s_Symbol$();
  var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$457, "name"));
  var this$458 = $m_s_Symbol$();
  var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$458, "code"));
  var this$459 = $m_s_Symbol$();
  var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$459, "facets"));
  var this$460 = $m_s_Symbol$();
  var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$460, "addresses"));
  var this$461 = $m_s_Symbol$();
  var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$461, "parent"));
  var this$462 = $m_s_Symbol$();
  var labels$4 = new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$462, "imageUrl")), $m_Lshapeless_HNil$()))))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$4);
  var f$4 = new $c_sjsr_AnonFunction1(((x0$19$2) => {
    var x0$19 = $as_Lreactbuild_person_Person(x0$19$2);
    if ((x0$19 !== null)) {
      var _id$macro$153 = $n(x0$19).Lreactbuild_person_Person__f__id;
      var organization$macro$154 = $n(x0$19).Lreactbuild_person_Person__f_organization;
      var name$macro$155 = $n(x0$19).Lreactbuild_person_Person__f_name;
      var code$macro$156 = $n(x0$19).Lreactbuild_person_Person__f_code;
      var facets$macro$157 = $n(x0$19).Lreactbuild_person_Person__f_facets;
      var addresses$macro$158 = $n(x0$19).Lreactbuild_person_Person__f_addresses;
      var parent$macro$159 = $n(x0$19).Lreactbuild_person_Person__f_parent;
      var imageUrl$macro$160 = $n(x0$19).Lreactbuild_person_Person__f_imageUrl;
      return new $c_Lshapeless_$colon$colon(_id$macro$153, new $c_Lshapeless_$colon$colon(organization$macro$154, new $c_Lshapeless_$colon$colon(name$macro$155, new $c_Lshapeless_$colon$colon(code$macro$156, new $c_Lshapeless_$colon$colon(facets$macro$157, new $c_Lshapeless_$colon$colon(addresses$macro$158, new $c_Lshapeless_$colon$colon(parent$macro$159, new $c_Lshapeless_$colon$colon(imageUrl$macro$160, $m_Lshapeless_HNil$()))))))))
    } else {
      throw new $c_s_MatchError(x0$19)
    }
  }));
  var g$4 = new $c_sjsr_AnonFunction1(((x0$20$2) => {
    var x0$20 = $as_Lshapeless_$colon$colon(x0$20$2);
    if ((x0$20 !== null)) {
      var _id$macro$145 = $as_Lreactbuild_common_model_RefTo($n(x0$20).Lshapeless_$colon$colon__f_head);
      var p2$4 = $as_Lshapeless_$colon$colon($n(x0$20).Lshapeless_$colon$colon__f_tail);
      if ((p2$4 !== null)) {
        var organization$macro$146 = $as_Lreactbuild_common_model_RefTo($n(p2$4).Lshapeless_$colon$colon__f_head);
        var p3$4 = $as_Lshapeless_$colon$colon($n(p2$4).Lshapeless_$colon$colon__f_tail);
        if ((p3$4 !== null)) {
          var name$macro$147 = $as_T($n(p3$4).Lshapeless_$colon$colon__f_head);
          var p4$4 = $as_Lshapeless_$colon$colon($n(p3$4).Lshapeless_$colon$colon__f_tail);
          if ((p4$4 !== null)) {
            var code$macro$148 = $as_s_Option($n(p4$4).Lshapeless_$colon$colon__f_head);
            var p5$4 = $as_Lshapeless_$colon$colon($n(p4$4).Lshapeless_$colon$colon__f_tail);
            if ((p5$4 !== null)) {
              var facets$macro$149 = $as_Lreactbuild_person_Facets($n(p5$4).Lshapeless_$colon$colon__f_head);
              var p6$4 = $as_Lshapeless_$colon$colon($n(p5$4).Lshapeless_$colon$colon__f_tail);
              if ((p6$4 !== null)) {
                var addresses$macro$150 = $as_sci_Seq($n(p6$4).Lshapeless_$colon$colon__f_head);
                var p7$4 = $as_Lshapeless_$colon$colon($n(p6$4).Lshapeless_$colon$colon__f_tail);
                if ((p7$4 !== null)) {
                  var parent$macro$151 = $as_s_Option($n(p7$4).Lshapeless_$colon$colon__f_head);
                  var p8$4 = $as_Lshapeless_$colon$colon($n(p7$4).Lshapeless_$colon$colon__f_tail);
                  if ((p8$4 !== null)) {
                    var imageUrl$macro$152 = $as_s_Option($n(p8$4).Lshapeless_$colon$colon__f_head);
                    var p9$4 = $as_Lshapeless_HNil($n(p8$4).Lshapeless_$colon$colon__f_tail);
                    var x$4 = $m_Lshapeless_HNil$();
                    if ((x$4 === p9$4)) {
                      return new $c_Lreactbuild_person_Person(_id$macro$145, organization$macro$146, name$macro$147, code$macro$148, facets$macro$149, addresses$macro$150, parent$macro$151, imageUrl$macro$152)
                    }
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$20)
  }));
  var gen$8 = new $c_Lshapeless_Generic$$anon$1(f$4, g$4);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys$32 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$465 = $m_s_Symbol$();
  var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$465, "imageUrl"));
  new $c_Lshapeless_Witness$$anon$1(value0$66);
  var zipWithKeys$33 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$32);
  $m_Lshapeless_Witness$();
  var this$468 = $m_s_Symbol$();
  var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$468, "parent"));
  new $c_Lshapeless_Witness$$anon$1(value0$67);
  var zipWithKeys$34 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$33);
  $m_Lshapeless_Witness$();
  var this$471 = $m_s_Symbol$();
  var value0$68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$471, "addresses"));
  new $c_Lshapeless_Witness$$anon$1(value0$68);
  var zipWithKeys$35 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$34);
  $m_Lshapeless_Witness$();
  var this$474 = $m_s_Symbol$();
  var value0$69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$474, "facets"));
  new $c_Lshapeless_Witness$$anon$1(value0$69);
  var zipWithKeys$36 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$35);
  $m_Lshapeless_Witness$();
  var this$477 = $m_s_Symbol$();
  var value0$70 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$477, "code"));
  new $c_Lshapeless_Witness$$anon$1(value0$70);
  var zipWithKeys$37 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$36);
  $m_Lshapeless_Witness$();
  var this$480 = $m_s_Symbol$();
  var value0$71 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$480, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$71);
  var zipWithKeys$38 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$37);
  $m_Lshapeless_Witness$();
  var this$483 = $m_s_Symbol$();
  var value0$72 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$483, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$72);
  var zipWithKeys$39 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$38);
  $m_Lshapeless_Witness$();
  var this$486 = $m_s_Symbol$();
  var value0$73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$486, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$73);
  var zip$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$39);
  var this$489 = $m_s_$less$colon$less$();
  var ev$29 = this$489.s_$less$colon$less$__f_singleton;
  var gen$9 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$4, gen$8, ev$29);
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$491 = $m_s_Symbol$();
  var value0$74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$491, "_id"));
  var witness$25 = new $c_Lshapeless_Witness$$anon$1(value0$74);
  var this$494 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  var this$493 = $m_Lreactbuild_model_Implicits$();
  var textualizable$18 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$493, proxy);
  var ev$30 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht$7 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$494, textualizable$18, ev$30)));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$495 = $m_s_Symbol$();
  var value0$75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$495, "organization"));
  var witness$24 = new $c_Lshapeless_Witness$$anon$1(value0$75);
  var this$498 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  var this$497 = $m_Lreactbuild_model_Implicits$();
  var textualizable$19 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$497, proxy);
  var ev$31 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht$6 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$498, textualizable$19, ev$31)));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$499 = $m_s_Symbol$();
  var value0$76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$499, "name"));
  var witness$23 = new $c_Lshapeless_Witness$$anon$1(value0$76);
  var ht$5 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$()));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$501 = $m_s_Symbol$();
  var value0$77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$501, "code"));
  var witness$22 = new $c_Lshapeless_Witness$$anon$1(value0$77);
  var this$505 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$18 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$20 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$18);
  var ev$32 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht$4 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$505, textualizable$20, ev$32)));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$506 = $m_s_Symbol$();
  var value0$78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$506, "facets"));
  var witness$21 = new $c_Lshapeless_Witness$$anon$1(value0$78);
  var ht$3 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$508 = $m_s_Symbol$();
  var value0$79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$508, "addresses"));
  var witness$20 = new $c_Lshapeless_Witness$$anon$1(value0$79);
  var ht$2 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$510 = $m_s_Symbol$();
  var value0$80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$510, "parent"));
  var witness$19 = new $c_Lshapeless_Witness$$anon$1(value0$80);
  var this$514 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$512 = $m_Lreactbuild_model_Implicits$();
  var textualizable$21 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$512, proxy);
  var textualizable$22 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$21);
  var ev$33 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht$1 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$514, textualizable$22, ev$33)));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$515 = $m_s_Symbol$();
  var value0$81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$515, "imageUrl"));
  var witness$18 = new $c_Lshapeless_Witness$$anon$1(value0$81);
  var this$519 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$19 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$23 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$19);
  var ev$34 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$519, textualizable$23, ev$34)));
  var tt = $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$().Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil;
  var tt$1 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt, ht, witness$18);
  var tt$2 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$19);
  var tt$3 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$2, ht$2, witness$20);
  var tt$4 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$3, ht$3, witness$21);
  var tt$5 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$4, ht$4, witness$22);
  var tt$6 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$5, ht$5, witness$23);
  var tt$7 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$6, ht$6, witness$24);
  var tokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$7, ht$7, witness$25);
  var $$x13 = new $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer, gen$9);
  var $$x5 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
  var $$x4 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
  var $$x3 = new $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1();
  var $$x2 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
  var $$x1 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
  $m_Lreactbuild_model_Implicits$();
  var this$531 = $m_Ljapgolly_scalajs_react_Reusability$();
  var u = $n($$x126).noExternalStateNorActive__O__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(items, $$x125, $$x124, $$x116, $$x51, $$x50, $$x16, $$x15, $$x14, $$x13, $$x5, $$x4, $$x3, $$x2, $$x1, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$531.byRef__F2(), this$531.by_$eq$eq__F2()), new $c_sjsr_AnonFunction1(((evT$2) => {
    var evT = $n($as_Ljapgolly_scalajs_react_Reusability(evT$2)).Ljapgolly_scalajs_react_Reusability__f_test;
    return new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityMultiviewItemColl__F2__F2(evT))
  })), $m_Lcom_iz2use_react_components_internal_multiview_View$().defaultViewOrdering__s_math_Ordering());
  var this$533 = $n(u);
  var n = this$533.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.productPrefix__T = (function() {
  return "PersonDetailViewHandler"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_router : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler)) {
    var PersonDetailViewHandler$1 = $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_router;
    var x$2 = $n(PersonDetailViewHandler$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_router;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.initialState__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase = (function(context) {
  return $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState($n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler__f_getTabList).head__O())
});
function $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.PersonDetailViewHandler"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.PersonDetailViewHandler;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler: 1,
  O: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1(outer) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  if ((x1 === 2)) {
    var x$1 = $m_s_None$();
    var this$1 = $n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1__f_$outer);
    var x$2 = this$1.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup;
    var this$2 = $n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1__f_$outer);
    var x$3 = this$2.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines;
    var this$3 = $n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1__f_$outer);
    var x$4 = this$3.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines;
    var this$4 = $n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1__f_$outer);
    var x$5 = this$4.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod;
    var this$5 = $n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1__f_$outer);
    var x$6 = this$5.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice;
    var this$6 = $n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1__f_$outer);
    return new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(this$6.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer, x$2, x$3, x$4, x$5, x$6, x$1)
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1.prototype.isDefinedAt__I__Z = (function(x1) {
  return (x1 === 2)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$Products$$anonfun$handleClose$1", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1(outer) {
  this.Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1.prototype = $c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1.prototype;
$c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  return ((x1 === 13) ? new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1__f_$outer).save__I__Ljapgolly_scalajs_react_callback_Trampoline(1)) : $n(default$1).apply__O__O(x1))
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1.prototype.isDefinedAt__I__Z = (function(x1) {
  return (x1 === 13)
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1: 0
}, false, "reactbuild.analyze.cost.modules.Processing$Backend$$anonfun$1", {
  Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_Processing$Backend$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1(from$2) {
  this.Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1__f_from$2 = null;
  this.Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1__f_from$2 = from$2
}
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1.prototype = $c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1.prototype;
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1.prototype.applyOrElse__Lreactbuild_model_PriceEvolutionProductEntry__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var p4 = $n(x1).Lreactbuild_model_PriceEvolutionProductEntry__f_category;
    var d = $n(x1).Lreactbuild_model_PriceEvolutionProductEntry__f_date;
    var x = $m_Lreactbuild_model_DocumentCategory$Quote$();
    if ((x === p4)) {
      var $$x1 = true
    } else {
      var x$3 = $m_Lreactbuild_model_DocumentCategory$PriceOffer$();
      var $$x1 = (x$3 === p4)
    };
    if (($$x1 && ($n(this.Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1__f_from$2).compareTo__Ljava_time_chrono_ChronoLocalDate__I(d) <= 0))) {
      return x1
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1.prototype.isDefinedAt__Lreactbuild_model_PriceEvolutionProductEntry__Z = (function(x1) {
  if ((x1 !== null)) {
    var p4 = $n(x1).Lreactbuild_model_PriceEvolutionProductEntry__f_category;
    var d = $n(x1).Lreactbuild_model_PriceEvolutionProductEntry__f_date;
    var x = $m_Lreactbuild_model_DocumentCategory$Quote$();
    if ((x === p4)) {
      var $$x1 = true
    } else {
      var x$3 = $m_Lreactbuild_model_DocumentCategory$PriceOffer$();
      var $$x1 = (x$3 === p4)
    };
    if (($$x1 && ($n(this.Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1__f_from$2).compareTo__Ljava_time_chrono_ChronoLocalDate__I(d) <= 0))) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_PriceEvolutionProductEntry__Z($as_Lreactbuild_model_PriceEvolutionProductEntry(x))
});
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_PriceEvolutionProductEntry__F1__O($as_Lreactbuild_model_PriceEvolutionProductEntry(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1: 0
}, false, "reactbuild.analyze.cost.modules.ProductPriceEvolutions$$anonfun$bestPrice$1", {
  Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$$anonfun$bestPrice$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39(outer, p$1) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39__f_p$1 = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39__f_p$1 = p$1
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39.prototype.applyOrElse__Lreactbuild_model_DeliveryFormDetails__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_Lreactbuild_model_MissingDeliveryFormDetails)) {
    var x2 = $as_Lreactbuild_model_MissingDeliveryFormDetails(x1);
    var $$x3 = $m_Lreactbuild_analyze_cost_modules_ReconcileDeliveryLine$();
    var $$x2 = $m_s_None$();
    var $$x1 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value = $m_s_Option$().apply__O__s_Option(x2);
    return $n($$x3).apply__s_Option__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_common_model_Date__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x2, $n($$x1).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$2 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x4;
        var p2 = $as_s_Option(x1$2.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x = $m_s_None$();
        if ((x === p2)) {
          var $$x4 = cb;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1$2.T2__f__1);
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var c = $as_s_Option($n(x5).s_Some__f_value);
          var this$3 = $n($n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39__f_p$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_reconciliationLines);
          var callback = new $c_sjsr_AnonFunction0((() => {
            var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
            var this$5 = $n(this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$5.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
          }));
          var this$6 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var G = this$6.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
          var arg1 = this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
          var lst = $as_sci_List(arg1);
          var this$7 = $n(lst);
          _return: {
            var i = 0;
            var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$7, 0, this$7);
            while (true) {
              var this$10 = $n(these);
              if ((!this$10.isEmpty__Z())) {
                var arg1$1 = $n(these).head__O();
                var x0$2 = $as_Lreactbuild_model_DeliveryFormDetails(arg1$1);
                matchEnd4: {
                  var $$x5;
                  if ((x0$2 instanceof $c_Lreactbuild_model_MissingDeliveryFormDetails)) {
                    var x2$1 = $as_Lreactbuild_model_MissingDeliveryFormDetails(x0$2);
                    var c$1 = $n(x2$1).Lreactbuild_model_MissingDeliveryFormDetails__f_content;
                    var x$1 = $n(c$1).Lreactbuild_model_InvoiceDetail__f_id;
                    var x$2 = $n($n(x2).Lreactbuild_model_MissingDeliveryFormDetails__f_content).Lreactbuild_model_InvoiceDetail__f_id;
                    if (((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2))) {
                      var $$x5 = true;
                      break matchEnd4
                    }
                  };
                  var $$x5 = false
                };
                if ($$x5) {
                  var x1$3 = i;
                  break _return
                };
                i = ((1 + i) | 0);
                these = $as_sc_LinearSeq($n(these).tail__O())
              } else {
                break
              }
            };
            var x1$3 = (-1)
          };
          if ((x1$3 === (-1))) {
            var this$11 = $n(c);
            if (this$11.isEmpty__Z()) {
              var arg1$3 = lst
            } else {
              var arg1$2 = this$11.get__O();
              var x$20 = $as_Lreactbuild_model_DeliveryFormDetails(arg1$2);
              var this$12 = $n(lst);
              var arg1$3 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$12, x$20))
            }
          } else {
            var this$13 = $n(lst);
            var other = $n(c).toList__sci_List();
            var arg1$3 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$13, x1$3, other, 1))
          };
          var $$x4 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$3), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          break matchEnd7
        };
        throw new $c_s_MatchError(x1$2)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x4)
    }))), $n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39__f_p$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_date, $n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39__f_p$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_active, $n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39__f_p$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_deliveryForms, $n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39__f_p$1).Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Props__f_proxy)
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39.prototype.isDefinedAt__Lreactbuild_model_DeliveryFormDetails__Z = (function(x1) {
  return (x1 instanceof $c_Lreactbuild_model_MissingDeliveryFormDetails)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_DeliveryFormDetails__Z($as_Lreactbuild_model_DeliveryFormDetails(x))
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_DeliveryFormDetails__F1__O($as_Lreactbuild_model_DeliveryFormDetails(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$Backend$$anonfun$render$39", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$render$39;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1(outer, invoiceDetail$1) {
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1__f_invoiceDetail$1 = null;
  this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1__f_invoiceDetail$1 = invoiceDetail$1
}
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1.prototype = $c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1.prototype.applyOrElse__Lreactbuild_model_DeliveryFormDetails__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_Lreactbuild_model_ReconciliedDeliveryFormDetails)) {
    var x2 = $as_Lreactbuild_model_ReconciliedDeliveryFormDetails(x1);
    var docId = $n(x2).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
    var lineId = $n(x2).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
    var x$2 = $n($as_Lreactbuild_model_InvoicePage($n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1__f_invoiceDetail$1).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f__id;
    if (((docId === null) ? (x$2 === null) : $n(docId).equals__O__Z(x$2))) {
      var x$4 = $n($as_Lreactbuild_model_InvoiceDetail($n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1__f_invoiceDetail$1).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_id;
      var $$x1 = ((lineId === null) ? (x$4 === null) : $n(lineId).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return x2
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1.prototype.isDefinedAt__Lreactbuild_model_DeliveryFormDetails__Z = (function(x1) {
  if ((x1 instanceof $c_Lreactbuild_model_ReconciliedDeliveryFormDetails)) {
    var x2 = $as_Lreactbuild_model_ReconciliedDeliveryFormDetails(x1);
    var docId = $n(x2).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
    var lineId = $n(x2).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
    var x$2 = $n($as_Lreactbuild_model_InvoicePage($n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1__f_invoiceDetail$1).Lreactbuild_model_ChildWithParent__f_parent)).Lreactbuild_model_InvoicePage__f__id;
    if (((docId === null) ? (x$2 === null) : $n(docId).equals__O__Z(x$2))) {
      var x$4 = $n($as_Lreactbuild_model_InvoiceDetail($n(this.Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1__f_invoiceDetail$1).Lreactbuild_model_ChildWithParent__f_child)).Lreactbuild_model_InvoiceDetail__f_id;
      var $$x1 = ((lineId === null) ? (x$4 === null) : $n(lineId).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_DeliveryFormDetails__Z($as_Lreactbuild_model_DeliveryFormDetails(x))
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_DeliveryFormDetails__F1__O($as_Lreactbuild_model_DeliveryFormDetails(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1: 0
}, false, "reactbuild.analyze.cost.modules.ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1", {
  Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconcileDeliveryFormEditor$Backend$$anonfun$sameInvoiceDetailLine$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1.prototype = $c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1.prototype;
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1.prototype.applyOrElse__Lreactbuild_model_ChildWithParent__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var p2 = $as_Lreactbuild_model_DeliveryFormDetails($n(x1).Lreactbuild_model_ChildWithParent__f_child);
    if ((p2 instanceof $c_Lreactbuild_model_MissingDeliveryFormDetails)) {
      var x4 = $as_Lreactbuild_model_MissingDeliveryFormDetails(p2);
      var x = $n(x4).Lreactbuild_model_MissingDeliveryFormDetails__f_content;
      return x
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1.prototype.isDefinedAt__Lreactbuild_model_ChildWithParent__Z = (function(x1) {
  if ((x1 !== null)) {
    var p2 = $as_Lreactbuild_model_DeliveryFormDetails($n(x1).Lreactbuild_model_ChildWithParent__f_child);
    if ((p2 instanceof $c_Lreactbuild_model_MissingDeliveryFormDetails)) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_ChildWithParent__Z($as_Lreactbuild_model_ChildWithParent(x))
});
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_ChildWithParent__F1__O($as_Lreactbuild_model_ChildWithParent(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1: 0
}, false, "reactbuild.analyze.cost.modules.ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1", {
  Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$$anonfun$$nestedInanonfun$renderRow$8$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps(proxy, periodRange, timeReports, fieldSpec, f) {
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_periodRange = null;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_timeReports = null;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_fieldSpec = null;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_f = null;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_periodRange = periodRange;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_timeReports = timeReports;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_fieldSpec = fieldSpec;
  this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_f = f
}
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.proxy__Ldiode_react_ModelProxy = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_proxy
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.periodRange__Lreactbuild_analyze_cost_modules_PeriodRange = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_periodRange
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.timeReports__sci_Seq = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_timeReports
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_periodRange;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_timeReports;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_fieldSpec;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_f;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_proxy;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_periodRange;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_periodRange;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_timeReports;
      var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_timeReports;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_fieldSpec;
        var x$8 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_fieldSpec;
        if ((x$7 === null)) {
          var $$x2 = (x$8 === null)
        } else {
          var this$1 = $n(x$7);
          var $$x2 = (this$1 === x$8)
        };
        if ($$x2) {
          var x$9 = this.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_f;
          var x$10 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps__f_f;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportExtractHeaders$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportExtractHeaders$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.ReportExtractHeaders$TypedProps", {
  Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ReportContext: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportExtractHeaders$TypedProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1(outer) {
  this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  var $$x1 = $m_s_concurrent_Future$();
  var this$4 = $n($n(this.Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1__f_$outer).Lreactbuild_analyze_cost_modules_ReportFragment$Backend__f_reactbuild$analyze$cost$modules$ReportFragment$Backend$$$);
  var mod = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_analyze_cost_modules_ReportFragment$State(s$2);
    $n(s);
    var timeReports = $n($n(s).Lreactbuild_analyze_cost_modules_ReportFragment$State__f_timeReports).fail__jl_Throwable__Ldiode_data_Pot(x1);
    var this$2 = $n(s);
    var searchItem = this$2.Lreactbuild_analyze_cost_modules_ReportFragment$State__f_searchItem;
    return new $c_Lreactbuild_analyze_cost_modules_ReportFragment$State(timeReports, searchItem)
  }));
  return $n($$x1).successful__O__s_concurrent_Future($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$4, mod))
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return true
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1", {
  Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragment$Backend$$anonfun$$nestedInanonfun$refresh$3$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps(parents, proxy, periodRange, timeReports, fieldOrder, fieldOrderTail, fieldValue, level, levels, updateTimeReports) {
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_parents = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_periodRange = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_timeReports = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrder = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrderTail = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldValue = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level = 0;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_levels = 0;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_updateTimeReports = null;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_parents = parents;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_periodRange = periodRange;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_timeReports = timeReports;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrder = fieldOrder;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrderTail = fieldOrderTail;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldValue = fieldValue;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level = level;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_levels = levels;
  this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_updateTimeReports = updateTimeReports
}
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype = $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.proxy__Ldiode_react_ModelProxy = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_proxy
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.periodRange__Lreactbuild_analyze_cost_modules_PeriodRange = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_periodRange
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.timeReports__sci_Seq = (function() {
  return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_timeReports
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.deriveState__Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState = (function() {
  var selectedTimeReports = $as_sci_Seq($n(this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_timeReports).filter__F1__O(new $c_sjsr_AnonFunction1(((x$46$2) => {
    var x$46 = $as_Lreactbuild_model_TimeReport(x$46$2);
    var x = $n(this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrder).extract__Lreactbuild_model_TimeReport__O(x$46);
    var y = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldValue;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  }))));
  return new $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedState(selectedTimeReports)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.productArity__I = (function() {
  return 10
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_parents;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_proxy;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_periodRange;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_timeReports;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrder;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrderTail;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldValue;
      break
    }
    case 7: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level;
      break
    }
    case 8: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_levels;
      break
    }
    case 9: {
      return this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_updateTimeReports;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_parents;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_proxy;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_periodRange;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_timeReports;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrder;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$5 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrderTail;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$6 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldValue;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var data$8 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level;
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var data$9 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_levels;
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$7 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_updateTimeReports;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$11, 10)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps(x$1);
    if (((this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level === $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_level) && (this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_levels === $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_levels))) {
      var x = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_parents;
      var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_parents;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_proxy;
        var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_proxy;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_periodRange;
          var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_periodRange;
          var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_timeReports;
      var x$8 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_timeReports;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrder;
        var x$10 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrder;
        if ((x$9 === null)) {
          var $$x3 = (x$10 === null)
        } else {
          var this$1 = $n(x$9);
          var $$x3 = (this$1 === x$10)
        };
        if ($$x3) {
          var x$11 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrderTail;
          var x$12 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldOrderTail;
          var $$x2 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          var $$x2 = false
        }
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$13 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldValue;
        var y = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_fieldValue;
        if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$13, y)) {
          var x$13$1 = this.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_updateTimeReports;
          var x$14 = $n(TypedProps$1).Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps__f_updateTimeReports;
          if ((x$13$1 === null)) {
            var $$x4 = (x$14 === null)
          } else {
            var this$2 = $n(x$13$1);
            var $$x4 = (this$2 === x$14)
          };
          if ($$x4) {
            $n(TypedProps$1);
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ReportFragmentGroup$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ReportFragmentGroup$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps: 0
}, false, "reactbuild.analyze.cost.modules.ReportFragmentGroup$TypedProps", {
  Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ReportContext: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ReportFragmentGroup$TypedProps;
function $p_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__ResourceDetails$lzycompute$1__V($thiz) {
  if (($thiz.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_ResourceDetails$module === null)) {
    $thiz.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_ResourceDetails$module = new $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$($thiz)
  }
}
function $p_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__UsageReports$lzycompute$1__V($thiz) {
  if (($thiz.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_UsageReports$module === null)) {
    $thiz.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_UsageReports$module = new $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$($thiz)
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler(router) {
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_ResourceDetails$module = null;
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_UsageReports$module = null;
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_router = null;
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_getTabList = null;
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_router = router;
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array = [this.ResourceDetails__Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$(), this.UsageReports__Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$()];
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_getTabList = $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
}
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype = $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype;
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.ResourceDetails__Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$ = (function() {
  if ((this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_ResourceDetails$module === null)) {
    $p_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__ResourceDetails$lzycompute$1__V(this)
  };
  return this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_ResourceDetails$module
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.UsageReports__Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$ = (function() {
  if ((this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_UsageReports$module === null)) {
    $p_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__UsageReports$lzycompute$1__V(this)
  };
  return this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_UsageReports$module
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.getTabList__sci_Seq = (function() {
  return this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_getTabList
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.closeItem__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_callback_Trampoline = (function(context, state) {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_router);
  var route = new $c_Lreactbuild_Loc$Resource($m_s_None$());
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$1.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.getItemList__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List = (function(context, state) {
  $m_Lreactbuild_package$();
  var proxy = $n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$11 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$11).Lreactbuild_model_CommonData__f_resources
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.openItem__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_TagOf = (function(ref, context, state) {
  return $n(this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$Resource(new $c_s_Some(ref)))
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.getDetailsView__sci_List__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_Seq = (function(items, context, state) {
  return $as_sci_Seq($n($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_active)).toSeq__sci_Seq()).flatMap__F1__O(new $c_sjsr_AnonFunction1(((ref$2) => {
    var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
    var $$x2 = $m_s_Option$();
    var this$2 = $n(items);
    _return: {
      var these = this$2;
      while ((!$n(these).isEmpty__Z())) {
        var arg1 = $n(these).head__O();
        var x$12 = $as_Lreactbuild_model_Resource(arg1);
        var x = $n(x$12).Lreactbuild_model_Resource__f__id;
        if (((x === null) ? (ref === null) : $n(x).equals__O__Z(ref))) {
          var $$x1 = new $c_s_Some($n(these).head__O());
          break _return
        };
        these = $as_sci_List($n(these).tail__O())
      };
      var $$x1 = $m_s_None$()
    };
    return $as_sci_Seq($n($n($n($$x2).option2Iterable__s_Option__sc_Iterable($$x1)).toSeq__sci_Seq()).flatMap__F1__O(new $c_sjsr_AnonFunction1(((found$2) => {
      var found = $as_Lreactbuild_model_Resource(found$2);
      return $as_sci_Seq($n($n($as_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase($n(state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq(this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_router, $n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy, found, new $c_sjsr_AnonFunction1(((newState$2) => {
        var newState = $as_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState(newState$2);
        var this$3 = $n(state);
        var callback = new $c_sjsr_AnonFunction0((() => {
          var this$4 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var this$5 = $n(this$4.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$5.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
        }));
        var this$6 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var G = this$6.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
        var arg1$1 = this$3.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
        $as_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState(arg1$1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$3.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(newState), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      })))).map__F1__O(new $c_sjsr_AnonFunction1(((r$2) => {
        var r = $as_Ljapgolly_scalajs_react_vdom_VdomNode(r$2);
        return r
      }))))
    }))))
  }))))
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.getMasterView__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement = (function(items, context, state) {
  var proxy = $n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy;
  var $$x133 = $m_Lcom_iz2use_react_components_Multiview$();
  var $$x132 = new $c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler();
  var this$2 = $m_s_Symbol$();
  var $$x130 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$2, "_id"));
  var this$3 = $m_s_Symbol$();
  var $$x129 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$3, "organization"));
  var this$4 = $m_s_Symbol$();
  var $$x128 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$4, "name"));
  var this$5 = $m_s_Symbol$();
  var $$x127 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$5, "costByHour"));
  var this$6 = $m_s_Symbol$();
  var $$x126 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$6, "category"));
  var this$7 = $m_s_Symbol$();
  var $$x125 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$7, "entry"));
  var this$8 = $m_s_Symbol$();
  var labels = new $c_Lshapeless_$colon$colon($$x130, new $c_Lshapeless_$colon$colon($$x129, new $c_Lshapeless_$colon$colon($$x128, new $c_Lshapeless_$colon$colon($$x127, new $c_Lshapeless_$colon$colon($$x126, new $c_Lshapeless_$colon$colon($$x125, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$8, "release")), $m_Lshapeless_HNil$())))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
  var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
    var x0$3 = $as_Lreactbuild_model_Resource(x0$3$2);
    if ((x0$3 !== null)) {
      var _id$macro$22 = $n(x0$3).Lreactbuild_model_Resource__f__id;
      var organization$macro$23 = $n(x0$3).Lreactbuild_model_Resource__f_organization;
      var name$macro$24 = $n(x0$3).Lreactbuild_model_Resource__f_name;
      var costByHour$macro$25 = $n(x0$3).Lreactbuild_model_Resource__f_costByHour;
      var category$macro$26 = $n(x0$3).Lreactbuild_model_Resource__f_category;
      var entry$macro$27 = $n(x0$3).Lreactbuild_model_Resource__f_entry;
      var release$macro$28 = $n(x0$3).Lreactbuild_model_Resource__f_release;
      return new $c_Lshapeless_$colon$colon(_id$macro$22, new $c_Lshapeless_$colon$colon(organization$macro$23, new $c_Lshapeless_$colon$colon(name$macro$24, new $c_Lshapeless_$colon$colon(costByHour$macro$25, new $c_Lshapeless_$colon$colon(category$macro$26, new $c_Lshapeless_$colon$colon(entry$macro$27, new $c_Lshapeless_$colon$colon(release$macro$28, $m_Lshapeless_HNil$())))))))
    } else {
      throw new $c_s_MatchError(x0$3)
    }
  }));
  var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
    var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
    if ((x0$4 !== null)) {
      var _id$macro$15 = $as_Lreactbuild_common_model_RefTo($n(x0$4).Lshapeless_$colon$colon__f_head);
      var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
      if ((p2 !== null)) {
        var organization$macro$16 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
        var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
        if ((p3 !== null)) {
          var name$macro$17 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
          var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
          if ((p4 !== null)) {
            var costByHour$macro$18 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
            var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
            if ((p5 !== null)) {
              var category$macro$19 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
              var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
              if ((p6 !== null)) {
                var entry$macro$20 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                if ((p7 !== null)) {
                  var release$macro$21 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                  var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p8)) {
                    return new $c_Lreactbuild_model_Resource(_id$macro$15, organization$macro$16, name$macro$17, costByHour$macro$18, category$macro$19, entry$macro$20, release$macro$21)
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$4)
  }));
  var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$12 = $m_s_Symbol$();
  var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$12, "release"));
  new $c_Lshapeless_Witness$$anon$1(value0);
  var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
  $m_Lshapeless_Witness$();
  var this$15 = $m_s_Symbol$();
  var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$15, "entry"));
  new $c_Lshapeless_Witness$$anon$1(value0$1);
  var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
  $m_Lshapeless_Witness$();
  var this$18 = $m_s_Symbol$();
  var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$18, "category"));
  new $c_Lshapeless_Witness$$anon$1(value0$2);
  var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
  $m_Lshapeless_Witness$();
  var this$21 = $m_s_Symbol$();
  var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "costByHour"));
  new $c_Lshapeless_Witness$$anon$1(value0$3);
  var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
  $m_Lshapeless_Witness$();
  var this$24 = $m_s_Symbol$();
  var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$4);
  var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
  $m_Lshapeless_Witness$();
  var this$27 = $m_s_Symbol$();
  var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$5);
  var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
  $m_Lshapeless_Witness$();
  var this$30 = $m_s_Symbol$();
  var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$6);
  var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
  var this$33 = $m_s_$less$colon$less$();
  var ev = this$33.s_$less$colon$less$__f_singleton;
  var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
  $m_Lshapeless_Witness$();
  var this$35 = $m_s_Symbol$();
  var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "release"));
  var wk = new $c_Lshapeless_Witness$$anon$1(value0$7);
  var tailToMap = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk);
  var keyLub = new $c_Lshapeless_Lub$$anon$4();
  var valueLub = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$40 = $m_s_Symbol$();
  var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "entry"));
  var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$8);
  var tailToMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap, keyLub, valueLub, wk$1);
  var keyLub$1 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$1 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$45 = $m_s_Symbol$();
  var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$45, "category"));
  var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$9);
  var tailToMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$2);
  var keyLub$2 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$2 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$50 = $m_s_Symbol$();
  var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "costByHour"));
  var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$10);
  var tailToMap$3 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$2, keyLub$2, valueLub$2, wk$3);
  var keyLub$3 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$3 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$55 = $m_s_Symbol$();
  var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "name"));
  var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$11);
  var tailToMap$4 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$3, keyLub$3, valueLub$3, wk$4);
  var keyLub$4 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$4 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$60 = $m_s_Symbol$();
  var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "organization"));
  var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$12);
  var tailToMap$5 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$4, keyLub$4, valueLub$4, wk$5);
  var keyLub$5 = new $c_Lshapeless_Lub$$anon$4();
  var valueLub$5 = new $c_Lshapeless_Lub$$anon$4();
  $m_Lshapeless_Witness$();
  var this$65 = $m_s_Symbol$();
  var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "_id"));
  var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$13);
  var toMap = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$5, keyLub$5, valueLub$5, wk$6);
  $m_Lshapeless_Witness$();
  var this$68 = $m_s_Symbol$();
  var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "_id"));
  var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$14);
  var tv$6 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
  $m_Lshapeless_Witness$();
  var this$70 = $m_s_Symbol$();
  var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$70, "organization"));
  var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$15);
  var tv$5 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
  $m_Lshapeless_Witness$();
  var this$72 = $m_s_Symbol$();
  var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$72, "name"));
  var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$16);
  var tv$4 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")));
  $m_Lshapeless_Witness$();
  var this$74 = $m_s_Symbol$();
  var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "costByHour"));
  var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$17);
  var tv$3 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_doubleTypeable);
  $m_Lshapeless_Witness$();
  var this$76 = $m_s_Symbol$();
  var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$76, "category"));
  var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$18);
  var tv$2 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
  $m_Lshapeless_Witness$();
  var this$78 = $m_s_Symbol$();
  var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "entry"));
  var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$19);
  var tv$1 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_LocalDate.getClassOf(), new $c_sjsr_AnonFunction0((() => "LocalDate"))));
  $m_Lshapeless_Witness$();
  var this$80 = $m_s_Symbol$();
  var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "release"));
  var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$20);
  var tv = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_LocalDate.getClassOf(), new $c_sjsr_AnonFunction0((() => "LocalDate"))));
  var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
  var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$7, tv, fmt);
  var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$8, tv$1, fmt$1);
  var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$9, tv$2, fmt$2);
  var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$10, tv$3, fmt$3);
  var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$11, tv$4, fmt$4);
  var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$12, tv$5, fmt$5);
  var fromMap = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$13, tv$6, fmt$6);
  var $$x131 = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap, gen$1, fromMap);
  $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$();
  var this$324 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$323 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$322 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$321 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$91 = $m_s_Symbol$();
  var $$x59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$91, "_id"));
  var this$92 = $m_s_Symbol$();
  var $$x58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "organization"));
  var this$93 = $m_s_Symbol$();
  var $$x57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "name"));
  var this$94 = $m_s_Symbol$();
  var $$x56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$94, "costByHour"));
  var this$95 = $m_s_Symbol$();
  var $$x55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$95, "category"));
  var this$96 = $m_s_Symbol$();
  var $$x54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$96, "entry"));
  var this$97 = $m_s_Symbol$();
  var labels$1 = new $c_Lshapeless_$colon$colon($$x59, new $c_Lshapeless_$colon$colon($$x58, new $c_Lshapeless_$colon$colon($$x57, new $c_Lshapeless_$colon$colon($$x56, new $c_Lshapeless_$colon$colon($$x55, new $c_Lshapeless_$colon$colon($$x54, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$97, "release")), $m_Lshapeless_HNil$())))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
  var f$1 = new $c_sjsr_AnonFunction1(((x0$7$2) => {
    var x0$7 = $as_Lreactbuild_model_Resource(x0$7$2);
    if ((x0$7 !== null)) {
      var _id$macro$50 = $n(x0$7).Lreactbuild_model_Resource__f__id;
      var organization$macro$51 = $n(x0$7).Lreactbuild_model_Resource__f_organization;
      var name$macro$52 = $n(x0$7).Lreactbuild_model_Resource__f_name;
      var costByHour$macro$53 = $n(x0$7).Lreactbuild_model_Resource__f_costByHour;
      var category$macro$54 = $n(x0$7).Lreactbuild_model_Resource__f_category;
      var entry$macro$55 = $n(x0$7).Lreactbuild_model_Resource__f_entry;
      var release$macro$56 = $n(x0$7).Lreactbuild_model_Resource__f_release;
      return new $c_Lshapeless_$colon$colon(_id$macro$50, new $c_Lshapeless_$colon$colon(organization$macro$51, new $c_Lshapeless_$colon$colon(name$macro$52, new $c_Lshapeless_$colon$colon(costByHour$macro$53, new $c_Lshapeless_$colon$colon(category$macro$54, new $c_Lshapeless_$colon$colon(entry$macro$55, new $c_Lshapeless_$colon$colon(release$macro$56, $m_Lshapeless_HNil$())))))))
    } else {
      throw new $c_s_MatchError(x0$7)
    }
  }));
  var g$1 = new $c_sjsr_AnonFunction1(((x0$8$2) => {
    var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
    if ((x0$8 !== null)) {
      var _id$macro$43 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
      var p2$1 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
      if ((p2$1 !== null)) {
        var organization$macro$44 = $as_Lreactbuild_common_model_RefTo($n(p2$1).Lshapeless_$colon$colon__f_head);
        var p3$1 = $as_Lshapeless_$colon$colon($n(p2$1).Lshapeless_$colon$colon__f_tail);
        if ((p3$1 !== null)) {
          var name$macro$45 = $as_T($n(p3$1).Lshapeless_$colon$colon__f_head);
          var p4$1 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
          if ((p4$1 !== null)) {
            var costByHour$macro$46 = $as_s_Option($n(p4$1).Lshapeless_$colon$colon__f_head);
            var p5$1 = $as_Lshapeless_$colon$colon($n(p4$1).Lshapeless_$colon$colon__f_tail);
            if ((p5$1 !== null)) {
              var category$macro$47 = $as_s_Option($n(p5$1).Lshapeless_$colon$colon__f_head);
              var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
              if ((p6$1 !== null)) {
                var entry$macro$48 = $as_s_Option($n(p6$1).Lshapeless_$colon$colon__f_head);
                var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                if ((p7$1 !== null)) {
                  var release$macro$49 = $as_s_Option($n(p7$1).Lshapeless_$colon$colon__f_head);
                  var p8$1 = $as_Lshapeless_HNil($n(p7$1).Lshapeless_$colon$colon__f_tail);
                  var x$1 = $m_Lshapeless_HNil$();
                  if ((x$1 === p8$1)) {
                    return new $c_Lreactbuild_model_Resource(_id$macro$43, organization$macro$44, name$macro$45, costByHour$macro$46, category$macro$47, entry$macro$48, release$macro$49)
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$8)
  }));
  var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys$7 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$100 = $m_s_Symbol$();
  var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$100, "release"));
  new $c_Lshapeless_Witness$$anon$1(value0$21);
  var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
  $m_Lshapeless_Witness$();
  var this$103 = $m_s_Symbol$();
  var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$103, "entry"));
  new $c_Lshapeless_Witness$$anon$1(value0$22);
  var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
  $m_Lshapeless_Witness$();
  var this$106 = $m_s_Symbol$();
  var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$106, "category"));
  new $c_Lshapeless_Witness$$anon$1(value0$23);
  var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
  $m_Lshapeless_Witness$();
  var this$109 = $m_s_Symbol$();
  var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$109, "costByHour"));
  new $c_Lshapeless_Witness$$anon$1(value0$24);
  var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
  $m_Lshapeless_Witness$();
  var this$112 = $m_s_Symbol$();
  var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$112, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$25);
  var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
  $m_Lshapeless_Witness$();
  var this$115 = $m_s_Symbol$();
  var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$115, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$26);
  var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
  $m_Lshapeless_Witness$();
  var this$118 = $m_s_Symbol$();
  var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$118, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$27);
  var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
  var this$121 = $m_s_$less$colon$less$();
  var ev$1 = this$121.s_$less$colon$less$__f_singleton;
  new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$1);
  var this$201 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$123 = $m_s_Symbol$();
  var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$123, "_id"));
  var witness$6 = new $c_Lshapeless_Witness$$anon$1(value0$28);
  var $$x63 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var this$125 = $m_Lreactbuild_model_Implicits$();
  var format = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$125);
  var $$x62 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format);
  var this$128 = $m_Lreactbuild_model_Implicits$();
  var this$127 = $m_Lreactbuild_model_Implicits$();
  var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$127, proxy);
  var $$x61 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$128, ev$2)));
  var $$x60 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$130 = $m_Lreactbuild_model_Implicits$();
  var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$130, proxy);
  var fieldRenderable$6 = $n($$x63).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x62, $$x61, $$x60, new $c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1(this, context, state, textualizable), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  var this$200 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$131 = $m_s_Symbol$();
  var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$131, "organization"));
  var witness$5 = new $c_Lshapeless_Witness$$anon$1(value0$29);
  var $$x67 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var this$133 = $m_Lreactbuild_model_Implicits$();
  var format$1 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$133);
  var $$x66 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$1);
  var this$136 = $m_Lreactbuild_model_Implicits$();
  var this$135 = $m_Lreactbuild_model_Implicits$();
  var ev$3 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$135, proxy);
  var $$x65 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$136, ev$3)));
  var $$x64 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$138 = $m_Lreactbuild_model_Implicits$();
  var textualizable$1 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$138, proxy);
  var fieldRenderable$5 = $n($$x67).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x66, $$x65, $$x64, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$1), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  var this$199 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$140 = $m_s_Symbol$();
  var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$140, "name"));
  var witness$4 = new $c_Lshapeless_Witness$$anon$1(value0$30);
  var $$x71 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var format$2 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var $$x70 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$2);
  var $$x69 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
  $m_Lcom_iz2use_common_Parsable$();
  var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var resolver = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  var $$x68 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner, resolver);
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable$4 = $n($$x71).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x70, $$x69, $$x68, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$1), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
  var this$198 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$148 = $m_s_Symbol$();
  var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$148, "costByHour"));
  var witness$3 = new $c_Lshapeless_Witness$$anon$1(value0$31);
  var $$x76 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$3 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_double;
  var format$4 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$3);
  var $$x75 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$4);
  var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var $$x74 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$4);
  var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$5);
  var resolver$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  var $$x73 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$1, resolver$1);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var textualizable$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$3);
  var $$x72 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$2);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var fieldRenderable$3 = $n($$x76).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x75, $$x74, $$x73, $$x72, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$6))));
  var this$197 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$163 = $m_s_Symbol$();
  var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$163, "category"));
  var witness$2 = new $c_Lshapeless_Witness$$anon$1(value0$32);
  var $$x81 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$5 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var format$6 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$5);
  var $$x80 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$6);
  var ord$1 = $m_s_math_Ordering$String$();
  var $$x79 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$1)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$7);
  var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$8);
  var resolver$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
  var $$x78 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$2, resolver$2);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$3 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$5);
  var $$x77 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$3);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable$2 = $n($$x81).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x80, $$x79, $$x78, $$x77, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$9))));
  var this$196 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$178 = $m_s_Symbol$();
  var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$178, "entry"));
  var witness$1 = new $c_Lshapeless_Witness$$anon$1(value0$33);
  var $$x85 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateFormat;
  var format$8 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$7);
  var $$x84 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$8);
  var ord$2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var $$x83 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$2)));
  var $$x82 = new $c_Lcom_iz2use_react_components_NotEditable();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable$4 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var textualizable$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$4);
  var fieldRenderable$1 = $n($$x85).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x84, $$x83, $$x82, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$5), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  var this$195 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
  $m_Lshapeless_Witness$();
  var this$186 = $m_s_Symbol$();
  var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$186, "release"));
  var witness = new $c_Lshapeless_Witness$$anon$1(value0$34);
  var $$x89 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateFormat;
  var format$10 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$9);
  var $$x88 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$10);
  var ord$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var $$x87 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$3)));
  var $$x86 = new $c_Lcom_iz2use_react_components_NotEditable();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable$6 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var textualizable$7 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$6);
  var fieldRenderable = $n($$x89).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x88, $$x87, $$x86, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$7), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  var tail = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4();
  var tail$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$195, fieldRenderable, witness, tail);
  var tail$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$196, fieldRenderable$1, witness$1, tail$1);
  var tail$3 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$197, fieldRenderable$2, witness$2, tail$2);
  var tail$4 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$198, fieldRenderable$3, witness$3, tail$3);
  var tail$5 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$199, fieldRenderable$4, witness$4, tail$4);
  var tail$6 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$200, fieldRenderable$5, witness$5, tail$5);
  var renderer = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$201, fieldRenderable$6, witness$6, tail$6);
  $m_s_DummyImplicit$();
  new $c_Lshapeless_Refute$$anon$2();
  var view$1 = new $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1(renderer);
  var this$319 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$318 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
  var this$204 = $m_s_Symbol$();
  var $$x95 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$204, "_id"));
  var this$205 = $m_s_Symbol$();
  var $$x94 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$205, "organization"));
  var this$206 = $m_s_Symbol$();
  var $$x93 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$206, "name"));
  var this$207 = $m_s_Symbol$();
  var $$x92 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$207, "costByHour"));
  var this$208 = $m_s_Symbol$();
  var $$x91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$208, "category"));
  var this$209 = $m_s_Symbol$();
  var $$x90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$209, "entry"));
  var this$210 = $m_s_Symbol$();
  var labels$2 = new $c_Lshapeless_$colon$colon($$x95, new $c_Lshapeless_$colon$colon($$x94, new $c_Lshapeless_$colon$colon($$x93, new $c_Lshapeless_$colon$colon($$x92, new $c_Lshapeless_$colon$colon($$x91, new $c_Lshapeless_$colon$colon($$x90, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$210, "release")), $m_Lshapeless_HNil$())))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
  var f$2 = new $c_sjsr_AnonFunction1(((x0$11$2) => {
    var x0$11 = $as_Lreactbuild_model_Resource(x0$11$2);
    if ((x0$11 !== null)) {
      var _id$macro$78 = $n(x0$11).Lreactbuild_model_Resource__f__id;
      var organization$macro$79 = $n(x0$11).Lreactbuild_model_Resource__f_organization;
      var name$macro$80 = $n(x0$11).Lreactbuild_model_Resource__f_name;
      var costByHour$macro$81 = $n(x0$11).Lreactbuild_model_Resource__f_costByHour;
      var category$macro$82 = $n(x0$11).Lreactbuild_model_Resource__f_category;
      var entry$macro$83 = $n(x0$11).Lreactbuild_model_Resource__f_entry;
      var release$macro$84 = $n(x0$11).Lreactbuild_model_Resource__f_release;
      return new $c_Lshapeless_$colon$colon(_id$macro$78, new $c_Lshapeless_$colon$colon(organization$macro$79, new $c_Lshapeless_$colon$colon(name$macro$80, new $c_Lshapeless_$colon$colon(costByHour$macro$81, new $c_Lshapeless_$colon$colon(category$macro$82, new $c_Lshapeless_$colon$colon(entry$macro$83, new $c_Lshapeless_$colon$colon(release$macro$84, $m_Lshapeless_HNil$())))))))
    } else {
      throw new $c_s_MatchError(x0$11)
    }
  }));
  var g$2 = new $c_sjsr_AnonFunction1(((x0$12$2) => {
    var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
    if ((x0$12 !== null)) {
      var _id$macro$71 = $as_Lreactbuild_common_model_RefTo($n(x0$12).Lshapeless_$colon$colon__f_head);
      var p2$2 = $as_Lshapeless_$colon$colon($n(x0$12).Lshapeless_$colon$colon__f_tail);
      if ((p2$2 !== null)) {
        var organization$macro$72 = $as_Lreactbuild_common_model_RefTo($n(p2$2).Lshapeless_$colon$colon__f_head);
        var p3$2 = $as_Lshapeless_$colon$colon($n(p2$2).Lshapeless_$colon$colon__f_tail);
        if ((p3$2 !== null)) {
          var name$macro$73 = $as_T($n(p3$2).Lshapeless_$colon$colon__f_head);
          var p4$2 = $as_Lshapeless_$colon$colon($n(p3$2).Lshapeless_$colon$colon__f_tail);
          if ((p4$2 !== null)) {
            var costByHour$macro$74 = $as_s_Option($n(p4$2).Lshapeless_$colon$colon__f_head);
            var p5$2 = $as_Lshapeless_$colon$colon($n(p4$2).Lshapeless_$colon$colon__f_tail);
            if ((p5$2 !== null)) {
              var category$macro$75 = $as_s_Option($n(p5$2).Lshapeless_$colon$colon__f_head);
              var p6$2 = $as_Lshapeless_$colon$colon($n(p5$2).Lshapeless_$colon$colon__f_tail);
              if ((p6$2 !== null)) {
                var entry$macro$76 = $as_s_Option($n(p6$2).Lshapeless_$colon$colon__f_head);
                var p7$2 = $as_Lshapeless_$colon$colon($n(p6$2).Lshapeless_$colon$colon__f_tail);
                if ((p7$2 !== null)) {
                  var release$macro$77 = $as_s_Option($n(p7$2).Lshapeless_$colon$colon__f_head);
                  var p8$2 = $as_Lshapeless_HNil($n(p7$2).Lshapeless_$colon$colon__f_tail);
                  var x$2 = $m_Lshapeless_HNil$();
                  if ((x$2 === p8$2)) {
                    return new $c_Lreactbuild_model_Resource(_id$macro$71, organization$macro$72, name$macro$73, costByHour$macro$74, category$macro$75, entry$macro$76, release$macro$77)
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$12)
  }));
  var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys$14 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$213 = $m_s_Symbol$();
  var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$213, "release"));
  new $c_Lshapeless_Witness$$anon$1(value0$35);
  var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
  $m_Lshapeless_Witness$();
  var this$216 = $m_s_Symbol$();
  var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$216, "entry"));
  new $c_Lshapeless_Witness$$anon$1(value0$36);
  var zipWithKeys$16 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
  $m_Lshapeless_Witness$();
  var this$219 = $m_s_Symbol$();
  var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$219, "category"));
  new $c_Lshapeless_Witness$$anon$1(value0$37);
  var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
  $m_Lshapeless_Witness$();
  var this$222 = $m_s_Symbol$();
  var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$222, "costByHour"));
  new $c_Lshapeless_Witness$$anon$1(value0$38);
  var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
  $m_Lshapeless_Witness$();
  var this$225 = $m_s_Symbol$();
  var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$225, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$39);
  var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
  $m_Lshapeless_Witness$();
  var this$228 = $m_s_Symbol$();
  var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$228, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$40);
  var zipWithKeys$20 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
  $m_Lshapeless_Witness$();
  var this$231 = $m_s_Symbol$();
  var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$231, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$41);
  var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
  var this$234 = $m_s_$less$colon$less$();
  var ev$10 = this$234.s_$less$colon$less$__f_singleton;
  new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$10);
  var this$312 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$236 = $m_s_Symbol$();
  var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$236, "_id"));
  var witness$13 = new $c_Lshapeless_Witness$$anon$1(value0$42);
  var $$x99 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  var this$238 = $m_Lreactbuild_model_Implicits$();
  var format$11 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$238);
  var $$x98 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$11);
  var this$241 = $m_Lreactbuild_model_Implicits$();
  var this$240 = $m_Lreactbuild_model_Implicits$();
  var ev$11 = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$240, proxy);
  var $$x97 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$241, ev$11)));
  var $$x96 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$243 = $m_Lreactbuild_model_Implicits$();
  var textualizable$8 = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$243, proxy);
  var columnRenderable$6 = $n($$x99).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x98, $$x97, $$x96, new $c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1(this, context, state, textualizable$8));
  var this$311 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$244 = $m_s_Symbol$();
  var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$244, "organization"));
  var witness$12 = new $c_Lshapeless_Witness$$anon$1(value0$43);
  var $$x103 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  var this$246 = $m_Lreactbuild_model_Implicits$();
  var format$12 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$246);
  var $$x102 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$12);
  var this$249 = $m_Lreactbuild_model_Implicits$();
  var this$248 = $m_Lreactbuild_model_Implicits$();
  var ev$12 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$248, proxy);
  var $$x101 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$249, ev$12)));
  var $$x100 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$251 = $m_Lreactbuild_model_Implicits$();
  var textualizable$9 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$251, proxy);
  var columnRenderable$5 = $n($$x103).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x102, $$x101, $$x100, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$9));
  var this$310 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$253 = $m_s_Symbol$();
  var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$253, "name"));
  var witness$11 = new $c_Lshapeless_Witness$$anon$1(value0$44);
  var $$x107 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  var format$13 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var $$x106 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$13);
  var $$x105 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
  $m_Lcom_iz2use_common_Parsable$();
  var evDefault$3 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
  var parser$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var resolver$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
  var $$x104 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$3, resolver$3);
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var columnRenderable$4 = $n($$x107).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x106, $$x105, $$x104, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$7));
  var this$309 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$261 = $m_s_Symbol$();
  var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$261, "costByHour"));
  var witness$10 = new $c_Lshapeless_Witness$$anon$1(value0$45);
  var $$x111 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$14 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_double;
  var format$15 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$14);
  var $$x110 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$15);
  var ord$4 = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var $$x109 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$4)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$13 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$13);
  var evDefault$4 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$4);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$14 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var parser$4 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$14);
  var resolver$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
  var $$x108 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$4, resolver$4);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var textualizable$10 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$9);
  var columnRenderable$3 = $n($$x111).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x110, $$x109, $$x108, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$10));
  var this$308 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$275 = $m_s_Symbol$();
  var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$275, "category"));
  var witness$9 = new $c_Lshapeless_Witness$$anon$1(value0$46);
  var $$x115 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$16 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var format$17 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$16);
  var $$x114 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$17);
  var ord$5 = $m_s_math_Ordering$String$();
  var $$x113 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$5)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$15);
  var evDefault$5 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$5 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$5);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$16 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$5 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$16);
  var resolver$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
  var $$x112 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$5, resolver$5);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$11 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$11 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$11);
  var columnRenderable$2 = $n($$x115).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x114, $$x113, $$x112, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$11));
  var this$307 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$289 = $m_s_Symbol$();
  var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$289, "entry"));
  var witness$8 = new $c_Lshapeless_Witness$$anon$1(value0$47);
  var $$x119 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$18 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateFormat;
  var format$19 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$18);
  var $$x118 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$19);
  var ord$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var $$x117 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$6)));
  var $$x116 = new $c_Lcom_iz2use_react_components_NotEditable();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable$12 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var textualizable$13 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$12);
  var columnRenderable$1 = $n($$x119).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x118, $$x117, $$x116, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$13));
  var this$306 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
  $m_Lshapeless_Witness$();
  var this$297 = $m_s_Symbol$();
  var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$297, "release"));
  var witness$7 = new $c_Lshapeless_Witness$$anon$1(value0$48);
  var $$x123 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$20 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateFormat;
  var format$21 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$20);
  var $$x122 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$21);
  var ord$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var $$x121 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$7)));
  var $$x120 = new $c_Lcom_iz2use_react_components_NotEditable();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable$14 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var textualizable$15 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$14);
  var columnRenderable = $n($$x123).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x122, $$x121, $$x120, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$15));
  var tail$7 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
  var tail$8 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$306, columnRenderable, witness$7, tail$7);
  var tail$9 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$307, columnRenderable$1, witness$8, tail$8);
  var tail$10 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$308, columnRenderable$2, witness$9, tail$9);
  var tail$11 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$309, columnRenderable$3, witness$10, tail$10);
  var tail$12 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$310, columnRenderable$4, witness$11, tail$11);
  var tail$13 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$311, columnRenderable$5, witness$12, tail$12);
  var renderer$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$312, columnRenderable$6, witness$13, tail$13);
  $m_s_DummyImplicit$();
  new $c_Lshapeless_Refute$$anon$2();
  var columnFragment = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$1);
  var view = new $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment);
  var tail$14 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2();
  var tail$15 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view, tail$14);
  var tail$16 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$318, tail$15);
  var tail$17 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$319, tail$16);
  var tail$18 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$1, tail$17);
  var tail$19 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$321, tail$18);
  var tail$20 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$322, tail$19);
  var tail$21 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$323, tail$20);
  var mat = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$324, tail$21);
  $m_s_DummyImplicit$();
  new $c_Lshapeless_Refute$$anon$2();
  var $$x124 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViews(mat.apply__sci_List());
  var $$x53 = $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$().Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable;
  var this$327 = $m_s_Symbol$();
  var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$327, "_id"));
  var this$328 = $m_s_Symbol$();
  var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$328, "organization"));
  var this$329 = $m_s_Symbol$();
  var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$329, "name"));
  var this$330 = $m_s_Symbol$();
  var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$330, "costByHour"));
  var this$331 = $m_s_Symbol$();
  var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$331, "category"));
  var this$332 = $m_s_Symbol$();
  var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$332, "entry"));
  var this$333 = $m_s_Symbol$();
  var labels$3 = new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$333, "release")), $m_Lshapeless_HNil$())))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
  var f$3 = new $c_sjsr_AnonFunction1(((x0$15$2) => {
    var x0$15 = $as_Lreactbuild_model_Resource(x0$15$2);
    if ((x0$15 !== null)) {
      var _id$macro$106 = $n(x0$15).Lreactbuild_model_Resource__f__id;
      var organization$macro$107 = $n(x0$15).Lreactbuild_model_Resource__f_organization;
      var name$macro$108 = $n(x0$15).Lreactbuild_model_Resource__f_name;
      var costByHour$macro$109 = $n(x0$15).Lreactbuild_model_Resource__f_costByHour;
      var category$macro$110 = $n(x0$15).Lreactbuild_model_Resource__f_category;
      var entry$macro$111 = $n(x0$15).Lreactbuild_model_Resource__f_entry;
      var release$macro$112 = $n(x0$15).Lreactbuild_model_Resource__f_release;
      return new $c_Lshapeless_$colon$colon(_id$macro$106, new $c_Lshapeless_$colon$colon(organization$macro$107, new $c_Lshapeless_$colon$colon(name$macro$108, new $c_Lshapeless_$colon$colon(costByHour$macro$109, new $c_Lshapeless_$colon$colon(category$macro$110, new $c_Lshapeless_$colon$colon(entry$macro$111, new $c_Lshapeless_$colon$colon(release$macro$112, $m_Lshapeless_HNil$())))))))
    } else {
      throw new $c_s_MatchError(x0$15)
    }
  }));
  var g$3 = new $c_sjsr_AnonFunction1(((x0$16$2) => {
    var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
    if ((x0$16 !== null)) {
      var _id$macro$99 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
      var p2$3 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
      if ((p2$3 !== null)) {
        var organization$macro$100 = $as_Lreactbuild_common_model_RefTo($n(p2$3).Lshapeless_$colon$colon__f_head);
        var p3$3 = $as_Lshapeless_$colon$colon($n(p2$3).Lshapeless_$colon$colon__f_tail);
        if ((p3$3 !== null)) {
          var name$macro$101 = $as_T($n(p3$3).Lshapeless_$colon$colon__f_head);
          var p4$3 = $as_Lshapeless_$colon$colon($n(p3$3).Lshapeless_$colon$colon__f_tail);
          if ((p4$3 !== null)) {
            var costByHour$macro$102 = $as_s_Option($n(p4$3).Lshapeless_$colon$colon__f_head);
            var p5$3 = $as_Lshapeless_$colon$colon($n(p4$3).Lshapeless_$colon$colon__f_tail);
            if ((p5$3 !== null)) {
              var category$macro$103 = $as_s_Option($n(p5$3).Lshapeless_$colon$colon__f_head);
              var p6$3 = $as_Lshapeless_$colon$colon($n(p5$3).Lshapeless_$colon$colon__f_tail);
              if ((p6$3 !== null)) {
                var entry$macro$104 = $as_s_Option($n(p6$3).Lshapeless_$colon$colon__f_head);
                var p7$3 = $as_Lshapeless_$colon$colon($n(p6$3).Lshapeless_$colon$colon__f_tail);
                if ((p7$3 !== null)) {
                  var release$macro$105 = $as_s_Option($n(p7$3).Lshapeless_$colon$colon__f_head);
                  var p8$3 = $as_Lshapeless_HNil($n(p7$3).Lshapeless_$colon$colon__f_tail);
                  var x$3 = $m_Lshapeless_HNil$();
                  if ((x$3 === p8$3)) {
                    return new $c_Lreactbuild_model_Resource(_id$macro$99, organization$macro$100, name$macro$101, costByHour$macro$102, category$macro$103, entry$macro$104, release$macro$105)
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$16)
  }));
  var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys$21 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$336 = $m_s_Symbol$();
  var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$336, "release"));
  new $c_Lshapeless_Witness$$anon$1(value0$49);
  var zipWithKeys$22 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
  $m_Lshapeless_Witness$();
  var this$339 = $m_s_Symbol$();
  var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$339, "entry"));
  new $c_Lshapeless_Witness$$anon$1(value0$50);
  var zipWithKeys$23 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
  $m_Lshapeless_Witness$();
  var this$342 = $m_s_Symbol$();
  var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$342, "category"));
  new $c_Lshapeless_Witness$$anon$1(value0$51);
  var zipWithKeys$24 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$23);
  $m_Lshapeless_Witness$();
  var this$345 = $m_s_Symbol$();
  var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$345, "costByHour"));
  new $c_Lshapeless_Witness$$anon$1(value0$52);
  var zipWithKeys$25 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$24);
  $m_Lshapeless_Witness$();
  var this$348 = $m_s_Symbol$();
  var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$348, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$53);
  var zipWithKeys$26 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$25);
  $m_Lshapeless_Witness$();
  var this$351 = $m_s_Symbol$();
  var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$351, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$54);
  var zipWithKeys$27 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$26);
  $m_Lshapeless_Witness$();
  var this$354 = $m_s_Symbol$();
  var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$354, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$55);
  var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$27);
  var this$357 = $m_s_$less$colon$less$();
  var ev$17 = this$357.s_$less$colon$less$__f_singleton;
  new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$17);
  $m_Lshapeless_Witness$();
  var this$359 = $m_s_Symbol$();
  var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$359, "_id"));
  var witness$20 = new $c_Lshapeless_Witness$$anon$1(value0$56);
  var $$x25 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var this$361 = $m_Lreactbuild_model_Implicits$();
  var format$22 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$361);
  var $$x24 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$22);
  var this$364 = $m_Lreactbuild_model_Implicits$();
  var this$363 = $m_Lreactbuild_model_Implicits$();
  var ev$18 = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$363, proxy);
  var $$x23 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$364, ev$18)));
  var $$x22 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$366 = $m_Lreactbuild_model_Implicits$();
  var textualizable$16 = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$366, proxy);
  var fieldRenderable$13 = $n($$x25).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x24, $$x23, $$x22, new $c_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$$anon$1(this, context, state, textualizable$16), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  $m_Lshapeless_Witness$();
  var this$367 = $m_s_Symbol$();
  var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$367, "organization"));
  var witness$19 = new $c_Lshapeless_Witness$$anon$1(value0$57);
  var $$x29 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var this$369 = $m_Lreactbuild_model_Implicits$();
  var format$23 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$369);
  var $$x28 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$23);
  var this$372 = $m_Lreactbuild_model_Implicits$();
  var this$371 = $m_Lreactbuild_model_Implicits$();
  var ev$19 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$371, proxy);
  var $$x27 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$372, ev$19)));
  var $$x26 = new $c_Lcom_iz2use_react_components_NotEditable();
  var this$374 = $m_Lreactbuild_model_Implicits$();
  var textualizable$17 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$374, proxy);
  var fieldRenderable$12 = $n($$x29).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x28, $$x27, $$x26, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$17), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  $m_Lshapeless_Witness$();
  var this$376 = $m_s_Symbol$();
  var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$376, "name"));
  var witness$18 = new $c_Lshapeless_Witness$$anon$1(value0$58);
  var $$x33 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  var format$24 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var $$x32 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$24);
  var $$x31 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
  $m_Lcom_iz2use_common_Parsable$();
  var evDefault$6 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner$6 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$6);
  var parser$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var resolver$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
  var $$x30 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$6, resolver$6);
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$13 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable$11 = $n($$x33).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x32, $$x31, $$x30, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$13), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
  $m_Lshapeless_Witness$();
  var this$384 = $m_s_Symbol$();
  var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$384, "costByHour"));
  var witness$17 = new $c_Lshapeless_Witness$$anon$1(value0$59);
  var $$x38 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$25 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_double;
  var format$26 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$25);
  var $$x37 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$26);
  var ord$8 = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var $$x36 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$8)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$20 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$20);
  var evDefault$7 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$7 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$7);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$21 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var parser$7 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$21);
  var resolver$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
  var $$x35 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$7, resolver$7);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var textualizable$18 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$15);
  var $$x34 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$18);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$22 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var fieldRenderable$10 = $n($$x38).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x37, $$x36, $$x35, $$x34, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$22))));
  $m_Lshapeless_Witness$();
  var this$399 = $m_s_Symbol$();
  var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$399, "category"));
  var witness$16 = new $c_Lshapeless_Witness$$anon$1(value0$60);
  var $$x43 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$27 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
  var format$28 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$27);
  var $$x42 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$28);
  var ord$9 = $m_s_math_Ordering$String$();
  var $$x41 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$9)));
  $m_Lcom_iz2use_common_Parsable$();
  var ev$23 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$23);
  var evDefault$8 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
  var optioner$8 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$8);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$24 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var parser$8 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$24);
  var resolver$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$8);
  var $$x40 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$8, resolver$8);
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$19 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$17);
  var $$x39 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$19);
  $m_Lcom_iz2use_common_Parsable$();
  var ev$25 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var fieldRenderable$9 = $n($$x43).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x42, $$x41, $$x40, $$x39, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$25))));
  $m_Lshapeless_Witness$();
  var this$414 = $m_s_Symbol$();
  var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$414, "entry"));
  var witness$15 = new $c_Lshapeless_Witness$$anon$1(value0$61);
  var $$x47 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$29 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateFormat;
  var format$30 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$29);
  var $$x46 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$30);
  var ord$10 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var $$x45 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$10)));
  var $$x44 = new $c_Lcom_iz2use_react_components_NotEditable();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable$20 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var textualizable$21 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$20);
  var fieldRenderable$8 = $n($$x47).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x46, $$x45, $$x44, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$21), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  $m_Lshapeless_Witness$();
  var this$422 = $m_s_Symbol$();
  var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$422, "release"));
  var witness$14 = new $c_Lshapeless_Witness$$anon$1(value0$62);
  var $$x51 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
  $m_Lcom_iz2use_react_components_internal_multiview_Format$();
  var format$31 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateFormat;
  var format$32 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$31);
  var $$x50 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$32);
  var ord$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
  var $$x49 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$11)));
  var $$x48 = new $c_Lcom_iz2use_react_components_NotEditable();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable$22 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var textualizable$23 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$22);
  var fieldRenderable$7 = $n($$x51).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x50, $$x49, $$x48, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$23), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
  var tail$22 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3();
  var tail$23 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$7, witness$14, tail$22);
  var tail$24 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$8, witness$15, tail$23);
  var tail$25 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$9, witness$16, tail$24);
  var tail$26 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$10, witness$17, tail$25);
  var tail$27 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$11, witness$18, tail$26);
  var tail$28 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$12, witness$19, tail$27);
  var renderer$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$13, witness$20, tail$28);
  var $$x52 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$2);
  var $$x15 = $m_Lreactbuild_model_Resource$().keyMapper__Lcom_iz2use_common_KeyMapper();
  var $$x14 = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
  var $$x13 = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
  var this$439 = $m_s_Symbol$();
  var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$439, "_id"));
  var this$440 = $m_s_Symbol$();
  var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$440, "organization"));
  var this$441 = $m_s_Symbol$();
  var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$441, "name"));
  var this$442 = $m_s_Symbol$();
  var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$442, "costByHour"));
  var this$443 = $m_s_Symbol$();
  var $$x7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$443, "category"));
  var this$444 = $m_s_Symbol$();
  var $$x6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$444, "entry"));
  var this$445 = $m_s_Symbol$();
  var labels$4 = new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($$x7, new $c_Lshapeless_$colon$colon($$x6, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$445, "release")), $m_Lshapeless_HNil$())))))));
  new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$4);
  var f$4 = new $c_sjsr_AnonFunction1(((x0$19$2) => {
    var x0$19 = $as_Lreactbuild_model_Resource(x0$19$2);
    if ((x0$19 !== null)) {
      var _id$macro$134 = $n(x0$19).Lreactbuild_model_Resource__f__id;
      var organization$macro$135 = $n(x0$19).Lreactbuild_model_Resource__f_organization;
      var name$macro$136 = $n(x0$19).Lreactbuild_model_Resource__f_name;
      var costByHour$macro$137 = $n(x0$19).Lreactbuild_model_Resource__f_costByHour;
      var category$macro$138 = $n(x0$19).Lreactbuild_model_Resource__f_category;
      var entry$macro$139 = $n(x0$19).Lreactbuild_model_Resource__f_entry;
      var release$macro$140 = $n(x0$19).Lreactbuild_model_Resource__f_release;
      return new $c_Lshapeless_$colon$colon(_id$macro$134, new $c_Lshapeless_$colon$colon(organization$macro$135, new $c_Lshapeless_$colon$colon(name$macro$136, new $c_Lshapeless_$colon$colon(costByHour$macro$137, new $c_Lshapeless_$colon$colon(category$macro$138, new $c_Lshapeless_$colon$colon(entry$macro$139, new $c_Lshapeless_$colon$colon(release$macro$140, $m_Lshapeless_HNil$())))))))
    } else {
      throw new $c_s_MatchError(x0$19)
    }
  }));
  var g$4 = new $c_sjsr_AnonFunction1(((x0$20$2) => {
    var x0$20 = $as_Lshapeless_$colon$colon(x0$20$2);
    if ((x0$20 !== null)) {
      var _id$macro$127 = $as_Lreactbuild_common_model_RefTo($n(x0$20).Lshapeless_$colon$colon__f_head);
      var p2$4 = $as_Lshapeless_$colon$colon($n(x0$20).Lshapeless_$colon$colon__f_tail);
      if ((p2$4 !== null)) {
        var organization$macro$128 = $as_Lreactbuild_common_model_RefTo($n(p2$4).Lshapeless_$colon$colon__f_head);
        var p3$4 = $as_Lshapeless_$colon$colon($n(p2$4).Lshapeless_$colon$colon__f_tail);
        if ((p3$4 !== null)) {
          var name$macro$129 = $as_T($n(p3$4).Lshapeless_$colon$colon__f_head);
          var p4$4 = $as_Lshapeless_$colon$colon($n(p3$4).Lshapeless_$colon$colon__f_tail);
          if ((p4$4 !== null)) {
            var costByHour$macro$130 = $as_s_Option($n(p4$4).Lshapeless_$colon$colon__f_head);
            var p5$4 = $as_Lshapeless_$colon$colon($n(p4$4).Lshapeless_$colon$colon__f_tail);
            if ((p5$4 !== null)) {
              var category$macro$131 = $as_s_Option($n(p5$4).Lshapeless_$colon$colon__f_head);
              var p6$4 = $as_Lshapeless_$colon$colon($n(p5$4).Lshapeless_$colon$colon__f_tail);
              if ((p6$4 !== null)) {
                var entry$macro$132 = $as_s_Option($n(p6$4).Lshapeless_$colon$colon__f_head);
                var p7$4 = $as_Lshapeless_$colon$colon($n(p6$4).Lshapeless_$colon$colon__f_tail);
                if ((p7$4 !== null)) {
                  var release$macro$133 = $as_s_Option($n(p7$4).Lshapeless_$colon$colon__f_head);
                  var p8$4 = $as_Lshapeless_HNil($n(p7$4).Lshapeless_$colon$colon__f_tail);
                  var x$4 = $m_Lshapeless_HNil$();
                  if ((x$4 === p8$4)) {
                    return new $c_Lreactbuild_model_Resource(_id$macro$127, organization$macro$128, name$macro$129, costByHour$macro$130, category$macro$131, entry$macro$132, release$macro$133)
                  }
                }
              }
            }
          }
        }
      }
    };
    throw new $c_s_MatchError(x0$20)
  }));
  var gen$8 = new $c_Lshapeless_Generic$$anon$1(f$4, g$4);
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  $m_Lshapeless_ops_hlist$ZipWithKeys$();
  var zipWithKeys$28 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
  $m_Lshapeless_Witness$();
  var this$448 = $m_s_Symbol$();
  var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$448, "release"));
  new $c_Lshapeless_Witness$$anon$1(value0$63);
  var zipWithKeys$29 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$28);
  $m_Lshapeless_Witness$();
  var this$451 = $m_s_Symbol$();
  var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$451, "entry"));
  new $c_Lshapeless_Witness$$anon$1(value0$64);
  var zipWithKeys$30 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$29);
  $m_Lshapeless_Witness$();
  var this$454 = $m_s_Symbol$();
  var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$454, "category"));
  new $c_Lshapeless_Witness$$anon$1(value0$65);
  var zipWithKeys$31 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$30);
  $m_Lshapeless_Witness$();
  var this$457 = $m_s_Symbol$();
  var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$457, "costByHour"));
  new $c_Lshapeless_Witness$$anon$1(value0$66);
  var zipWithKeys$32 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$31);
  $m_Lshapeless_Witness$();
  var this$460 = $m_s_Symbol$();
  var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$460, "name"));
  new $c_Lshapeless_Witness$$anon$1(value0$67);
  var zipWithKeys$33 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$32);
  $m_Lshapeless_Witness$();
  var this$463 = $m_s_Symbol$();
  var value0$68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$463, "organization"));
  new $c_Lshapeless_Witness$$anon$1(value0$68);
  var zipWithKeys$34 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$33);
  $m_Lshapeless_Witness$();
  var this$466 = $m_s_Symbol$();
  var value0$69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$466, "_id"));
  new $c_Lshapeless_Witness$$anon$1(value0$69);
  var zip$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$34);
  var this$469 = $m_s_$less$colon$less$();
  var ev$26 = this$469.s_$less$colon$less$__f_singleton;
  var gen$9 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$4, gen$8, ev$26);
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$471 = $m_s_Symbol$();
  var value0$70 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$471, "_id"));
  var witness$27 = new $c_Lshapeless_Witness$$anon$1(value0$70);
  var this$474 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  var this$473 = $m_Lreactbuild_model_Implicits$();
  var textualizable$24 = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$473, proxy);
  var ev$27 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht$6 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$474, textualizable$24, ev$27)));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$475 = $m_s_Symbol$();
  var value0$71 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$475, "organization"));
  var witness$26 = new $c_Lshapeless_Witness$$anon$1(value0$71);
  var this$478 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  var this$477 = $m_Lreactbuild_model_Implicits$();
  var textualizable$25 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$477, proxy);
  var ev$28 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht$5 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$478, textualizable$25, ev$28)));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$479 = $m_s_Symbol$();
  var value0$72 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$479, "name"));
  var witness$25 = new $c_Lshapeless_Witness$$anon$1(value0$72);
  var ht$4 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$()));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$481 = $m_s_Symbol$();
  var value0$73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$481, "costByHour"));
  var witness$24 = new $c_Lshapeless_Witness$$anon$1(value0$73);
  var this$485 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$18 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
  var textualizable$26 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$18);
  var ev$29 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht$3 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$485, textualizable$26, ev$29)));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$486 = $m_s_Symbol$();
  var value0$74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$486, "category"));
  var witness$23 = new $c_Lshapeless_Witness$$anon$1(value0$74);
  var this$490 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  $m_Lcom_iz2use_common_Textualizable$();
  $m_Lcom_iz2use_common_Textualizable$();
  var parsable$19 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var textualizable$27 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$19);
  var ev$30 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht$2 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$490, textualizable$27, ev$30)));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$491 = $m_s_Symbol$();
  var value0$75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$491, "entry"));
  var witness$22 = new $c_Lshapeless_Witness$$anon$1(value0$75);
  var this$494 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable$28 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var textualizable$29 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$28);
  var ev$31 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht$1 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$494, textualizable$29, ev$31)));
  $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
  $m_Lshapeless_Witness$();
  var this$495 = $m_s_Symbol$();
  var value0$76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$495, "release"));
  var witness$21 = new $c_Lshapeless_Witness$$anon$1(value0$76);
  var this$498 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
  $m_Lcom_iz2use_common_Textualizable$();
  var textualizable$30 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
  var textualizable$31 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$30);
  var ev$32 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
  var ht = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$498, textualizable$31, ev$32)));
  var tt = $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$().Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil;
  var tt$1 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt, ht, witness$21);
  var tt$2 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$22);
  var tt$3 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$2, ht$2, witness$23);
  var tt$4 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$3, ht$3, witness$24);
  var tt$5 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$4, ht$4, witness$25);
  var tt$6 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$5, ht$5, witness$26);
  var tokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$6, ht$6, witness$27);
  var $$x12 = new $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer, gen$9);
  var $$x5 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
  var $$x4 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
  var $$x3 = new $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1();
  var $$x2 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
  var $$x1 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
  $m_Lreactbuild_model_Implicits$();
  var this$509 = $m_Ljapgolly_scalajs_react_Reusability$();
  var u = $n($$x133).noExternalStateNorActive__O__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(items, $$x132, $$x131, $$x124, $$x53, $$x52, $$x15, $$x14, $$x13, $$x12, $$x5, $$x4, $$x3, $$x2, $$x1, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$509.byRef__F2(), this$509.by_$eq$eq__F2()), new $c_sjsr_AnonFunction1(((evT$2) => {
    var evT = $n($as_Ljapgolly_scalajs_react_Reusability(evT$2)).Ljapgolly_scalajs_react_Reusability__f_test;
    return new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityMultiviewItemColl__F2__F2(evT))
  })), $m_Lcom_iz2use_react_components_internal_multiview_View$().defaultViewOrdering__s_math_Ordering());
  var this$511 = $n(u);
  var n = this$511.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.getTitleOf__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(item, context) {
  var proxy = $n(context).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy;
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Lcom_iz2use_common_Textualizable$();
  var this$1 = $m_Lreactbuild_model_Implicits$();
  var ev = $f_Lreactbuild_model_LowPriorityImplicits__resourcesTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$1, proxy);
  var v = $n(ev).stringify__O__T(item);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.productPrefix__T = (function() {
  return "ResourceDetailViewHandler"
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_router : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler)) {
    var ResourceDetailViewHandler$1 = $as_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_router;
    var x$2 = $n(ResourceDetailViewHandler$1).Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_router;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.getTitleOf__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_vdom_TagMod = (function(item, context) {
  return this.getTitleOf__Lreactbuild_common_model_RefTo__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_vdom_VdomNode(item, context)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.getMasterView__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomNode = (function(items, context, state) {
  return this.getMasterView__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement(items, context, state)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.initialState__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase = (function(context) {
  return $as_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState($n(this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler__f_getTabList).head__O())
});
function $as_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ResourceDetailViewHandler"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ResourceDetailViewHandler;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler: 0
}, false, "reactbuild.analyze.cost.modules.ResourceDetailViewHandler", {
  Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler: 1,
  O: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1.prototype.applyOrElse__Lreactbuild_common_model_Project__F1__O = (function(x1, default$1) {
  return ($n($n(x1).Lreactbuild_common_model_Project__f_archived).isEmpty__Z() ? $n(x1).Lreactbuild_common_model_Project__f__id : $n(default$1).apply__O__O(x1))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1.prototype.isDefinedAt__Lreactbuild_common_model_Project__Z = (function(x1) {
  return $n($n(x1).Lreactbuild_common_model_Project__f_archived).isEmpty__Z()
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_common_model_Project__Z($as_Lreactbuild_common_model_Project(x))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_common_model_Project__F1__O($as_Lreactbuild_common_model_Project(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReport$Backend$$anonfun$1", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReport$Backend$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle(value) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle__f_value = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle__f_value = value
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.value__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle__f_value
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.isIdle__Z = (function() {
  return true
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.productPrefix__T = (function() {
  return "Idle"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle)) {
    var Idle$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle__f_value;
    var x$2 = $n(Idle$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle__f_value;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Idle"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Idle;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Idle", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Idle;
function $p_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__value$lzycompute__s_Option($thiz) {
  if ((!$thiz.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_bitmap$0)) {
    var $$x2 = $m_s_Option$();
    var $$x1 = $thiz.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_initial;
    var x = ($thiz.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_diff / 4.0);
    var this$5 = $m_RTLong$();
    var value = $uD(Math.round(x));
    var lo = this$5.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$6 = $n($n($$x2).apply__O__s_Option(($$x1 + ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi) / 4.0))));
    if (this$6.isEmpty__Z()) {
      var $$x3 = true
    } else {
      var arg1 = this$6.get__O();
      var x$1 = $uD(arg1);
      var $$x3 = (x$1 > 0.0)
    };
    $thiz.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_value = ($$x3 ? this$6 : $m_s_None$());
    $thiz.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_bitmap$0 = true
  };
  return $thiz.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_value
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(initial, origin, diff) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_value = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_initial = 0.0;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin = 0.0;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_diff = 0.0;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_bitmap$0 = false;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_initial = initial;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin = origin;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_diff = diff
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.isIdle__Z = (function() {
  return false
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.value__s_Option = (function() {
  return ((!this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_bitmap$0) ? $p_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__value$lzycompute__s_Option(this) : this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_value)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.productPrefix__T = (function() {
  return "Moving"
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_initial;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_diff;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Moving");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_initial;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$2 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_diff;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving)) {
    var Moving$1 = $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(x$1);
    return ((this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_initial === $n(Moving$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_initial) && ((this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin === $n(Moving$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_origin) && (this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_diff === $n(Moving$1).Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving__f_diff)))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Moving"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Moving;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportCellResource$Moving", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$State: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportCellResource$Moving;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3(outer, res$1, proxy$1) {
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3__f_res$1 = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3__f_proxy$1 = null;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3__f_res$1 = res$1;
  this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3__f_proxy$1 = proxy$1
}
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3.prototype = $c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3.prototype;
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3.prototype.applyOrElse__Lreactbuild_model_TimeReport__F1__O = (function(x1, default$1) {
  var x = $n(x1).Lreactbuild_model_TimeReport__f_resource;
  var x$2 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3__f_res$1;
  if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
    $m_Lcom_iz2use_common_Textualizable$();
    var v = $n(x1).Lreactbuild_model_TimeReport__f_duration;
    var ev = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
    var $$x2 = $n(ev).stringify__O__T(v);
    $m_Lcom_iz2use_common_Textualizable$();
    var v$1 = $n(x1).Lreactbuild_model_TimeReport__f_buildingSite;
    var this$2 = $m_Lreactbuild_model_Implicits$();
    var proxy = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3__f_proxy$1;
    var ev$1 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$2, proxy);
    var $$x1 = $n(ev$1).stringify__O__T(v$1);
    $m_Lcom_iz2use_common_Textualizable$();
    var v$2 = $n(x1).Lreactbuild_model_TimeReport__f_buildingStage;
    $m_Lcom_iz2use_common_Textualizable$();
    var this$4 = $m_Lreactbuild_model_Implicits$();
    var proxy$1 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3__f_proxy$1;
    var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$4, proxy$1);
    var ev$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable);
    return (((($$x2 + " ") + $$x1) + " ") + ev$2.stringify__s_Option__T(v$2))
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3.prototype.isDefinedAt__Lreactbuild_model_TimeReport__Z = (function(x1) {
  var x = $n(x1).Lreactbuild_model_TimeReport__f_resource;
  var x$2 = this.Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3__f_res$1;
  return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_model_TimeReport__Z($as_Lreactbuild_model_TimeReport(x))
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_model_TimeReport__F1__O($as_Lreactbuild_model_TimeReport(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3: 0
}, false, "reactbuild.analyze.cost.modules.hometimereport.HomeTimeReportSummaryLine$Backend$$anonfun$render$3", {
  Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_hometimereport_HomeTimeReportSummaryLine$Backend$$anonfun$render$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data(feature) {
  this.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data__f_feature = null;
  this.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data__f_feature = feature
}
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype.productPrefix__T = (function() {
  return "Data"
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data__f_feature : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data)) {
    var Data$1 = $as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data__f_feature;
    var x$2 = $n(Data$1).Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data__f_feature;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.FeatureInfo$Data"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.FeatureInfo$Data;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data: 0
}, false, "reactbuild.analyze.cost.modules.mapview.FeatureInfo$Data", {
  Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_FeatureInfo: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links(links) {
  this.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links__f_links = null;
  this.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links__f_links = links
}
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype.productPrefix__T = (function() {
  return "Links"
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links__f_links : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links)) {
    var Links$1 = $as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links__f_links;
    var x$2 = $n(Links$1).Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links__f_links;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.FeatureInfo$Links"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.FeatureInfo$Links;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links: 0
}, false, "reactbuild.analyze.cost.modules.mapview.FeatureInfo$Links", {
  Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_FeatureInfo: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme(title, name, zoom, inspire) {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_name = null;
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_zoom = null;
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_inspire = false;
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_title = title;
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_name = name;
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_zoom = zoom;
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_inspire = inspire;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this);
  this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_category = $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_AdministrativeDivision
}
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageLayerOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x1 = $i_ol$002fsource.ImageWMS;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageWMSOptions);
  var y = this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_name;
  var array = [$ct_T2__O__O__(new $c_T2(), "LAYERS", y)];
  var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var params = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "params", params), $ct_T2__O__O__(new $c_T2(), "url", "/api/geo/wms/geoportail-urbanisme")];
  var fields$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  _\uff3fobj$1.ratio = 1.0;
  var a = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_WMSServerType.MAPSERVER);
  _\uff3fobj$1.serverType = a;
  var a$1 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj;
  _\uff3fobj$1.projection = a$1;
  var value = new $$x1(_\uff3fobj$1);
  _\uff3fobj.source = value;
  return new ($moduleDefault($i_ol$002flayer$002fImage))(_\uff3fobj)
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.productPrefix__T = (function() {
  return "GeportailUrbanisme"
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_title;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_name;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_zoom;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_inspire;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("GeportailUrbanisme");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_title;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_name;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_zoom;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_inspire ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme)) {
    var GeportailUrbanisme$1 = $as_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme(x$1);
    if (((this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_inspire === $n(GeportailUrbanisme$1).Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_inspire) && (this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_title === $n(GeportailUrbanisme$1).Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_title))) {
      if ((this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_name === $n(GeportailUrbanisme$1).Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_name)) {
        var x = this.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_zoom;
        var x$2 = $n(GeportailUrbanisme$1).Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme__f_zoom;
        return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.GeportailUrbanisme"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.GeportailUrbanisme;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme: 0
}, false, "reactbuild.analyze.cost.modules.mapview.GeportailUrbanisme", {
  Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_GeportailUrbanisme;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer(category, title, name, url, resolutions) {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_name = null;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_url = null;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_resolutions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_category = category;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_title = title;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_name = name;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_url = url;
  this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_resolutions = resolutions;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this)
}
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  var $$x2 = $i_ol$002fsource.ImageWMS;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageWMSOptions);
  var y = this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_name;
  var array = [$ct_T2__O__O__(new $c_T2(), "LAYERS", y), $ct_T2__O__O__(new $c_T2(), "FORMAT", "image/png")];
  var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var params = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
  var url = this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_url;
  var array$1 = [$ct_T2__O__O__(new $c_T2(), "params", params), $ct_T2__O__O__(new $c_T2(), "url", url)];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var a = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj;
  _\uff3fobj.projection = a;
  _\uff3fobj.hidpi = false;
  _\uff3fobj.ratio = 1.0;
  var $$x1 = $m_sjs_js_JSConverters$JSRichIterableOnce$();
  var col = $as_sc_IterableOnce($n($as_sc_SeqOps($n(this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_resolutions).sorted__s_math_Ordering__O($m_s_math_Ordering$DeprecatedDoubleOrdering$()))).reverse__O());
  var value = $n($$x1).toJSArray$extension__sc_IterableOnce__sjs_js_Array(col);
  _\uff3fobj.resolutions = value;
  var opts = new $$x2(_\uff3fobj);
  var $$x3 = $moduleDefault($i_ol$002flayer$002fImage);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageLayerOptions);
  var fields$1 = $m_sci_Nil$();
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  _\uff3fobj$1.source = opts;
  return new $$x3(_\uff3fobj$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.productPrefix__T = (function() {
  return "HazardWMSLayer"
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_category;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_title;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_url;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_resolutions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer)) {
    var HazardWMSLayer$1 = $as_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_category;
    var x$2 = $n(HazardWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_category;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_title === $n(HazardWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_title))) {
      if ((this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_name === $n(HazardWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_name)) {
        if ((this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_url === $n(HazardWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_url)) {
          var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_resolutions;
          var x$4 = $n(HazardWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer__f_resolutions;
          return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.HazardWMSLayer"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.HazardWMSLayer;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer: 0
}, false, "reactbuild.analyze.cost.modules.mapview.HazardWMSLayer", {
  Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_HazardWMSLayer;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_value = null;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this);
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_category = $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_title = "Debug";
  var $$x3 = $moduleDefault($i_ol$002flayer$002fTile);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileLayerOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var $$x2 = $i_ol$002fsource.TileDebug;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileDebugOptions);
  var fields$1 = $m_sci_Nil$();
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var value = new $$x2(_\uff3fobj$1);
  _\uff3fobj.source = value;
  var $$x1 = new $$x3(_\uff3fobj);
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_value = $$x1
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_value
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.productPrefix__T = (function() {
  return "Debug"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.hashCode__I = (function() {
  return 65906227
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.toString__T = (function() {
  return "Debug"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$Debug$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$__f_title = null;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this);
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$__f_category = $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$__f_title = "OpenStreetMap"
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  var $$x1 = $moduleDefault($i_ol$002fsource$002fOSM);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OSMOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var osmSource = new $$x1(_\uff3fobj);
  var $$x2 = $moduleDefault($i_ol$002flayer$002fTile);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileLayerOptions);
  var fields$1 = $m_sci_Nil$();
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  _\uff3fobj$1.source = osmSource;
  return new $$x2(_\uff3fobj$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.productPrefix__T = (function() {
  return "OpenStreetMap"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.hashCode__I = (function() {
  return 315479823
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.toString__T = (function() {
  return "OpenStreetMap"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$OpenStreetMap$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$OpenStreetMap$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$__f_title = null;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this);
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$__f_category = $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_RiskAndHazard;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$__f_title = "Potentiel radon"
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  var prefixUrl = new URL("/api/geo/xyz/radon", $as_T(window.location.href));
  var $$x1 = $moduleDefault($i_ol$002fsource$002fXYZ);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_XYZOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  _\uff3fobj.maxZoom = 11.0;
  var value = (prefixUrl + "/{z}/{x}/{-y}.png");
  _\uff3fobj.url = value;
  var source = new $$x1(_\uff3fobj);
  var $$x2 = $moduleDefault($i_ol$002flayer$002fTile);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileLayerOptions);
  var fields$1 = $m_sci_Nil$();
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  _\uff3fobj$1.source = source;
  var layer = new $$x2(_\uff3fobj$1);
  layer.setOpacity(0.5);
  return layer
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.productPrefix__T = (function() {
  return "Radon"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.hashCode__I = (function() {
  return 78718100
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.toString__T = (function() {
  return "Radon"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$Radon$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Radon$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates(coords) {
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates__f_coords = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates__f_coords = coords
}
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype.productPrefix__T = (function() {
  return "Coordinates"
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates__f_coords : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates)) {
    var Coordinates$1 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates__f_coords;
    var x$2 = $n(Coordinates$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates__f_coords;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$Coordinates"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.ParsedMapQuery$Coordinates;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates: 0
}, false, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$Coordinates", {
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Coordinates;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other(rawSearch, failure) {
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_rawSearch = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_failure = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_rawSearch = rawSearch;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_failure = failure
}
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype.productPrefix__T = (function() {
  return "Other"
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_rawSearch;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_failure;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other)) {
    var Other$1 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_rawSearch === $n(Other$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_rawSearch)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_failure;
      var x$2 = $n(Other$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other__f_failure;
      if ((x === null)) {
        return (x$2 === null)
      } else {
        var this$1 = $n(x);
        return (this$1 === x$2)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$Other"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.ParsedMapQuery$Other;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other: 0
}, false, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$Other", {
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$Other;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress(cityArea, parcelList) {
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_cityArea = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_parcelList = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_cityArea = cityArea;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_parcelList = parcelList
}
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype.productPrefix__T = (function() {
  return "ParcelAddress"
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_cityArea;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_parcelList;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress)) {
    var ParcelAddress$1 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_cityArea;
    var x$2 = $n(ParcelAddress$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_cityArea;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_parcelList;
      var x$4 = $n(ParcelAddress$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress__f_parcelList;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$ParcelAddress"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.ParsedMapQuery$ParcelAddress;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress: 0
}, false, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$ParcelAddress", {
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$ParcelAddress;
function $p_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__imageWMS$lzycompute__Ltypings_ol_sourceMod$ImageWMS($thiz) {
  if ((!$thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_bitmap$0)) {
    var $$x4 = $m_s_Option$().option2Iterable__s_Option__sc_Iterable($thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_update);
    var $$x3 = $i_ol$002fsource.ImageWMS;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageWMSOptions);
    var y = $thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_name;
    var $$x2 = $ct_T2__O__O__(new $c_T2(), "LAYERS", y);
    var this$4 = $n($thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_format);
    var y$1 = (this$4.isEmpty__Z() ? "image/png" : this$4.get__O());
    var array = [$$x2, $ct_T2__O__O__(new $c_T2(), "FORMAT", y$1)];
    var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var params = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
    var url = $thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_url;
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "params", params), $ct_T2__O__O__(new $c_T2(), "url", url)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    _\uff3fobj.hidpi = false;
    _\uff3fobj.ratio = 1.0;
    var a = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj;
    _\uff3fobj.projection = a;
    var $$x1 = new $$x3(_\uff3fobj);
    $thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_imageWMS = $n($$x4).foldLeft__O__F2__O($$x1, new $c_sjsr_AnonFunction2(((acc$2, f$2) => {
      var f = $as_F1(f$2);
      return $n(f).apply__O__O(acc$2)
    })));
    $thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_bitmap$0 = true
  };
  return $thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_imageWMS
}
function $p_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__imageWMS__Ltypings_ol_sourceMod$ImageWMS($thiz) {
  return ((!$thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_bitmap$0) ? $p_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__imageWMS$lzycompute__Ltypings_ol_sourceMod$ImageWMS($thiz) : $thiz.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_imageWMS)
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer(category, title, name, url, format, update) {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_imageWMS = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_name = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_url = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_format = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_update = null;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_bitmap$0 = false;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_category = category;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_title = title;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_name = name;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_url = url;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_format = format;
  this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_update = update;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this)
}
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  var $$x1 = $moduleDefault($i_ol$002flayer$002fImage);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ImageLayerOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var value = $p_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__imageWMS__Ltypings_ol_sourceMod$ImageWMS(this);
  _\uff3fobj.source = value;
  return new $$x1(_\uff3fobj)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.getDocuments__sjs_js_Array__D__T__F1 = (function(coordinates, resolution, projection) {
  var $$x1 = $p_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__imageWMS__Ltypings_ol_sourceMod$ImageWMS(this);
  var array = [$ct_T2__O__O__(new $c_T2(), "INFO_FORMAT", "application/vnd.ogc.gml")];
  var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var urlOpt = $$x1.getFeatureInfoUrl(coordinates, resolution, projection, $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties));
  var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var ifEmpty = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).throwException__F0__F1(new $c_sjsr_AnonFunction0((() => $ct_jl_Exception__T__(new $c_jl_Exception(), "No url !")))))));
  var f = new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10 = $as_T(x$10$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(x$10))
  }));
  return $n($$x2).flatMap$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback(((urlOpt === (void 0)) ? ifEmpty.apply__O() : f.apply__O__O(urlOpt)))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, new $c_sjsr_AnonFunction1(((url$2) => {
    var url = $as_T(url$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
      var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
      var p = fetch(url);
      return $n($$x3).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((res$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
      var $$x4 = $m_sjs_js_Thenable$ThenableOps$();
      var p$1 = res$2.text();
      return $n($$x4).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((text$2) => {
      var text = $as_T(text$2);
      var parser = new DOMParser();
      var document = parser.parseFromString(text, $m_Lorg_scalajs_dom_MIMEType$().Lorg_scalajs_dom_MIMEType$__f_text$divxml);
      var nodes = document.documentElement.querySelectorAll(":scope>*>*");
      var this$24 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(nodes);
      var pf = new $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1(this);
      var features = $as_sc_Seq($f_sc_IterableOps__collect__s_PartialFunction__O(this$24, pf));
      return $n(features).toList__sci_List()
    }))))))))
  })))
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.productPrefix__T = (function() {
  return "SimpleWMSLayer"
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_category;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_title;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_url;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_format;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_update;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer)) {
    var SimpleWMSLayer$1 = $as_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_category;
    var x$2 = $n(SimpleWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_category;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && ((this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_title === $n(SimpleWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_title) && (this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_name === $n(SimpleWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_name)))) {
      if ((this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_url === $n(SimpleWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_url)) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_format;
        var x$4 = $n(SimpleWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_format;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_update;
          var x$6 = $n(SimpleWMSLayer$1).Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer__f_update;
          return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.SimpleWMSLayer"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.SimpleWMSLayer;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer: 0
}, false, "reactbuild.analyze.cost.modules.mapview.SimpleWMSLayer", {
  Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1.prototype.applyOrElse__Lorg_scalajs_dom_Element__F1__O = (function(x1, default$1) {
  if ($f_T__endsWith__T__Z($n($as_T(x1.nodeName)), "_feature")) {
    var domList = x1.childNodes;
    var this$5 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList);
    var f = new $c_sjsr_AnonFunction1(((entry$2) => {
      var self = $as_T(entry$2.nodeName);
      var y = $as_T(entry$2.nodeValue);
      return $ct_T2__O__O__(new $c_T2(), self, y)
    }));
    var data = $as_sc_Seq($f_sc_IterableOps__map__F1__O(this$5, f));
    return new $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data($n(data).toSeq__sci_Seq())
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1.prototype.isDefinedAt__Lorg_scalajs_dom_Element__Z = (function(x1) {
  return $f_T__endsWith__T__Z($n($as_T(x1.nodeName)), "_feature")
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lorg_scalajs_dom_Element__Z(x)
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lorg_scalajs_dom_Element__F1__O(x, default$1)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.SimpleWMSLayer$$anonfun$1", {
  Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_SimpleWMSLayer$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer(category, title, name, url, f, wmtsOptions) {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_name = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_url = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_f = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_wmtsOptions = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_category = category;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_title = title;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_name = name;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_url = url;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_f = f;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_wmtsOptions = wmtsOptions;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this)
}
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  var prefixedUrl = new URL(this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_url, $as_T(window.location.href));
  var capabilitiesUrl = new URL(this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_url, $as_T(window.location.href));
  $n($m_s_package$().s_package$__f_List);
  var array = [$ct_T2__O__O__(new $c_T2(), "SERVICE", "WMTS"), $ct_T2__O__O__(new $c_T2(), "VERSION", "1.0.0"), $ct_T2__O__O__(new $c_T2(), "REQUEST", "GetCapabilities")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$11 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var these = this$11;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var p = $as_T2(arg1);
    capabilitiesUrl.searchParams.append($as_T($n(p)._1__O()), $as_T($n(p)._2__O()));
    these = $as_sci_List($n(these).tail__O())
  };
  var parser = new ($moduleDefault($i_ol$002fformat$002fWMTSCapabilities))();
  var $$x1 = $moduleDefault($i_ol$002flayer$002fTile);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileLayerOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var tileLayer = new $$x1(_\uff3fobj);
  var initialized = new $c_sr_BooleanRef(false);
  tileLayer.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "change:visible"), ((arg1$2) => {
    this.reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$anonfun$render$8__Ltypings_ol_objectMod$ObjectEvent__Ltypings_ol_layerTileMod$default__sr_BooleanRef__Lorg_scalajs_dom_URL__Ltypings_ol_formatWmtscapabilitiesMod$default__Lorg_scalajs_dom_URL__V(arg1$2, tileLayer, initialized, capabilitiesUrl, parser, prefixedUrl)
  }));
  return tileLayer
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.productPrefix__T = (function() {
  return "TiledWMTSLayer"
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_category;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_title;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_url;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_f;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_wmtsOptions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer)) {
    var TiledWMTSLayer$1 = $as_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_category;
    var x$2 = $n(TiledWMTSLayer$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_category;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && ((this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_title === $n(TiledWMTSLayer$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_title) && (this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_name === $n(TiledWMTSLayer$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_name)))) {
      if ((this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_url === $n(TiledWMTSLayer$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_url)) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_f;
        var x$4 = $n(TiledWMTSLayer$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_f;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_wmtsOptions;
          var x$6 = $n(TiledWMTSLayer$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_wmtsOptions;
          if ((x$5 === null)) {
            return (x$6 === null)
          } else {
            var this$1 = $n(x$5);
            return (this$1 === x$6)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$anonfun$render$8__Ltypings_ol_objectMod$ObjectEvent__Ltypings_ol_layerTileMod$default__sr_BooleanRef__Lorg_scalajs_dom_URL__Ltypings_ol_formatWmtscapabilitiesMod$default__Lorg_scalajs_dom_URL__V = (function(ev, tileLayer$1, initialized$1, capabilitiesUrl$1, parser$1, prefixedUrl$1) {
  if (($uZ(tileLayer$1.getVisible()) && (!$n(initialized$1).sr_BooleanRef__f_elem))) {
    $n(initialized$1).sr_BooleanRef__f_elem = true;
    var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
    var $$x1 = fetch;
    var a = $dp_toString__T($n(capabilitiesUrl$1));
    var p = $$x1(a);
    var future = $n($n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((response$2) => {
      var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
      var p$1 = response$2.text();
      return $n($n($$x3).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((text$2) => {
        var text = $as_T(text$2);
        return $n($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => parser$1.read(text))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((result$2) => {
          console.log(">", result$2);
          $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$();
          var y = this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_name;
          var $$x4 = $ct_T2__O__O__(new $c_T2(), "layer", y);
          var y$1 = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj.getCode());
          var array = [$$x4, $ct_T2__O__O__(new $c_T2(), "matrixSet", y$1)];
          var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          var config = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
          var initialOptions = $i_ol$002fsource$002fWMTS.optionsFromCapabilities(result$2, config);
          var options = $n(this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_wmtsOptions).apply__O__O__O__O(this, result$2, initialOptions);
          var x = options.tileGrid;
          x.fullTileRanges_ = (void 0);
          var x$1 = options.tileGrid;
          x$1.extent_ = (void 0);
          var x$2 = options.tileGrid;
          var $$x5 = $m_sjs_js_ArrayOps$();
          var array$1 = options.tileGrid.getMatrixIds();
          var this$26 = $n($n($$x5).lastOption$extension__sjs_js_Array__s_Option(array$1));
          if (this$26.isEmpty__Z()) {
            var value = 19.0
          } else {
            var arg1 = this$26.get__O();
            var x$23 = $as_T(arg1);
            $m_sc_StringOps$();
            var value = $m_jl_Double$().parseDouble__T__D(x$23)
          };
          x$2.maxZoom = value;
          var x$3 = options.tileGrid;
          var $$x6 = $m_sjs_js_ArrayOps$();
          var array$2 = options.tileGrid.getMatrixIds();
          var this$33 = $n($n($$x6).headOption$extension__sjs_js_Array__s_Option(array$2));
          if (this$33.isEmpty__Z()) {
            var value$1 = 0.0
          } else {
            var arg1$1 = this$33.get__O();
            var x$24 = $as_T(arg1$1);
            $m_sc_StringOps$();
            var value$1 = $m_jl_Double$().parseDouble__T__D(x$24)
          };
          x$3.minZoom = value$1;
          $n(this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer__f_f).apply__O__O(options.tileGrid);
          options.projection = (void 0);
          options.wrapX = (void 0);
          var a$1 = [$dp_toString__T($n(prefixedUrl$1))];
          options.urls = a$1;
          console.log("options", options, tileLayer$1);
          var wmts = new $i_ol$002fsource.WMTS(options);
          tileLayer$1.setSource(wmts)
        })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
    $n(future).recoverWith__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1(this), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.TiledWMTSLayer"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.TiledWMTSLayer;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer: 0
}, false, "reactbuild.analyze.cost.modules.mapview.TiledWMTSLayer", {
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  var this$1 = $n(x1);
  this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
  throw ((x1 instanceof $c_sjs_js_JavaScriptException) ? x1.sjs_js_JavaScriptException__f_exception : $n(x1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return true
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1", {
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayer$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayer$$$nestedInanonfun$render$8$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil(category, title, name, url) {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_name = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_url = null;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_category = category;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_title = title;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_name = name;
  this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_url = url;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this)
}
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  var prefixedUrl = new URL(this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_url, $as_T(window.location.href));
  var capabilitiesUrl = new URL(this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_url, $as_T(window.location.href));
  $n($m_s_package$().s_package$__f_List);
  var array = [$ct_T2__O__O__(new $c_T2(), "SERVICE", "WMTS"), $ct_T2__O__O__(new $c_T2(), "VERSION", "1.0.0"), $ct_T2__O__O__(new $c_T2(), "REQUEST", "GetCapabilities")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$11 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var these = this$11;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var p = $as_T2(arg1);
    capabilitiesUrl.searchParams.append($as_T($n(p)._1__O()), $as_T($n(p)._2__O()));
    these = $as_sci_List($n(these).tail__O())
  };
  var parser = new ($moduleDefault($i_ol$002fformat$002fWMTSCapabilities))();
  var $$x1 = $moduleDefault($i_ol$002flayer$002fTile);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TileLayerOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var tileLayer = new $$x1(_\uff3fobj);
  var initialized = new $c_sr_BooleanRef(false);
  tileLayer.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "change:visible"), ((arg1$2) => {
    this.reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$anonfun$render$19__Ltypings_ol_objectMod$ObjectEvent__Ltypings_ol_layerTileMod$default__sr_BooleanRef__Lorg_scalajs_dom_URL__Ltypings_ol_formatWmtscapabilitiesMod$default__Lorg_scalajs_dom_URL__V(arg1$2, tileLayer, initialized, capabilitiesUrl, parser, prefixedUrl)
  }));
  return tileLayer
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.productPrefix__T = (function() {
  return "TiledWMTSLayerXBil"
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_category;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_title;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_name;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_url;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil)) {
    var TiledWMTSLayerXBil$1 = $as_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_category;
    var x$2 = $n(TiledWMTSLayerXBil$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_category;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_title === $n(TiledWMTSLayerXBil$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_title))) {
      return ((this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_name === $n(TiledWMTSLayerXBil$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_name) && (this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_url === $n(TiledWMTSLayerXBil$1).Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_url))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$anonfun$render$19__Ltypings_ol_objectMod$ObjectEvent__Ltypings_ol_layerTileMod$default__sr_BooleanRef__Lorg_scalajs_dom_URL__Ltypings_ol_formatWmtscapabilitiesMod$default__Lorg_scalajs_dom_URL__V = (function(ev, tileLayer$2, initialized$2, capabilitiesUrl$2, parser$2, prefixedUrl$2) {
  if (($uZ(tileLayer$2.getVisible()) && (!$n(initialized$2).sr_BooleanRef__f_elem))) {
    $n(initialized$2).sr_BooleanRef__f_elem = true;
    var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
    var $$x1 = fetch;
    var a = $dp_toString__T($n(capabilitiesUrl$2));
    var p = $$x1(a);
    var future = $n($n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((response$2) => {
      var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
      var p$1 = response$2.text();
      return $n($n($$x3).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((text$2) => {
        var text = $as_T(text$2);
        return $n($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => parser$2.read(text))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((result$2) => {
          console.log(">", result$2);
          $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$();
          var y = this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_name;
          var array = [$ct_T2__O__O__(new $c_T2(), "layer", y)];
          var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          var config = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
          var serverOptions = $i_ol$002fsource$002fWMTS.optionsFromCapabilities(result$2, config);
          console.log("Server options", serverOptions);
          var array$1 = result$2.Contents.TileMatrixSet;
          _return: {
            var len = $uI(array$1.length);
            var i = 0;
            while ((i < len)) {
              var arg1 = array$1[i];
              if (($as_T(arg1.Identifier) === $as_T(serverOptions.matrixSet))) {
                var idx = i;
                break _return
              };
              i = ((1 + i) | 0)
            };
            var idx = (-1)
          };
          var extractedMatrixSet = $n(((idx === (-1)) ? $m_s_None$() : new $c_s_Some(array$1[idx]))).get__O();
          $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_WMTSOptions);
          var layer = this.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil__f_name;
          var matrixSet = $as_T(serverOptions.matrixSet);
          var style = $as_T(serverOptions.style);
          var tileGrid = $i_ol$002ftilegrid$002fWMTS.createFromCapabilitiesMatrixSet(extractedMatrixSet);
          var array$2 = [$ct_T2__O__O__(new $c_T2(), "layer", layer), $ct_T2__O__O__(new $c_T2(), "matrixSet", matrixSet), $ct_T2__O__O__(new $c_T2(), "style", style), $ct_T2__O__O__(new $c_T2(), "tileGrid", tileGrid)];
          var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
          var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
          var x = _\uff3fobj.tileGrid;
          x.fullTileRanges_ = (void 0);
          $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Debug$__f_value.getSource().tileGrid = _\uff3fobj.tileGrid;
          var value = serverOptions.format;
          if ((value !== (void 0))) {
            var value$1 = $as_T(value);
            _\uff3fobj.format = value$1
          };
          var a$1 = [$dp_toString__T($n(prefixedUrl$2))];
          _\uff3fobj.urls = a$1;
          console.log("options", _\uff3fobj, tileLayer$2);
          tileLayer$2.setSource(new $i_ol$002fsource.WMTS(_\uff3fobj))
        })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$());
    $n(future).recoverWith__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1(this), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.TiledWMTSLayerXBil"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.TiledWMTSLayerXBil;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil: 0
}, false, "reactbuild.analyze.cost.modules.mapview.TiledWMTSLayerXBil", {
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  var this$1 = $n(x1);
  this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
  throw ((x1 instanceof $c_sjs_js_JavaScriptException) ? x1.sjs_js_JavaScriptException__f_exception : $n(x1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return true
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1", {
  Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_TiledWMTSLayerXBil$$anonfun$reactbuild$analyze$cost$modules$mapview$TiledWMTSLayerXBil$$$nestedInanonfun$render$19$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer(category, url, title, name, stroke, fill, options) {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_url = null;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_name = null;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_stroke = null;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_fill = null;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_options = null;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_category = category;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_url = url;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_title = title;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_name = name;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_stroke = stroke;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_fill = fill;
  this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_options = options;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this)
}
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_Layer();
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_WFSLayer() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.buildUrl__T__sjs_js_Tuple4__T = (function(projection, extent) {
  $n($m_s_package$().s_package$__f_List);
  var $$x6 = $ct_T2__O__O__(new $c_T2(), "SERVICE", "WFS");
  var $$x5 = $ct_T2__O__O__(new $c_T2(), "version", "2.0.0");
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "request", "GetFeature");
  var y = this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_name;
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "typename", y);
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "outputFormat", "application/json");
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "srsname", projection);
  var this$15 = new $c_T4(extent[0], extent[1], extent[2], extent[3]);
  var this$17 = new $c_sr_ScalaRunTime$$anon$1(this$15);
  var end = ("," + projection);
  var y$1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$17, "", ",", end);
  var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "bbox", y$1)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var this$24 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var f = ((p$2) => {
    var p = $as_T2(p$2);
    return (($n(p)._1__O() + "=") + $n(p)._2__O())
  });
  if ((this$24 === $m_sci_Nil$())) {
    var $$x7 = $m_sci_Nil$()
  } else {
    var arg1 = this$24.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$24.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x7 = h
  };
  var this$25 = $n($$x7);
  var start = (this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_url + "?");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$25, start, "&", "")
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorSourceOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var value = new $c_sjsr_AnonFunction2(((extent$2, resolution$2) => {
    var resolution = $uD(resolution$2);
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_LoadingStrategy);
    return $i_ol$002floadingstrategy.bbox(extent$2, resolution)
  }));
  var value$1 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value);
  _\uff3fobj.strategy = value$1;
  var value$2 = new $c_sjsr_AnonFunction3(((extent$3$2, res$2, proj$2) => {
    $uD(res$2);
    return this.buildUrl__T__sjs_js_Tuple4__T($as_T(proj$2.getCode()), extent$3$2)
  }));
  var value$3 = $m_sjs_js_Any$().fromFunction3__F3__sjs_js_Function3(value$2);
  _\uff3fobj.url = value$3;
  var value$4 = new $i_ol$002fformat.GeoJSON();
  _\uff3fobj.format = value$4;
  var source = new ($moduleDefault($i_ol$002fsource$002fVector))(_\uff3fobj);
  var textStyle = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().defaultTextStyleOptions__F1__Ltypings_ol_styleTextMod$default($m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().defaultTextStyleOptions$default$1__F1());
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
  var fields$1 = $m_sci_Nil$();
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var $$x2 = $moduleDefault($i_ol$002fstyle$002fStroke);
  var $$x1 = this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_stroke;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StrokeOptions);
  var fields$2 = $m_sci_Nil$();
  var _\uff3fobj$2 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$2);
  var value$5 = new $$x2($n($$x1).apply__O__O(_\uff3fobj$2));
  _\uff3fobj$1.stroke = value$5;
  var $$x4 = $moduleDefault($i_ol$002fstyle$002fFill);
  var $$x3 = this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_fill;
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_FillOptions);
  var fields$3 = $m_sci_Nil$();
  var _\uff3fobj$3 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$3);
  var value$6 = new $$x4($n($$x3).apply__O__O(_\uff3fobj$3));
  _\uff3fobj$1.fill = value$6;
  _\uff3fobj$1.text = textStyle;
  var style = new $i_ol$002fstyle.Style(_\uff3fobj$1);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions);
  var fields$4 = $m_sci_Nil$();
  var _\uff3fobj$4 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$4);
  var value$10 = new $c_sjsr_AnonFunction2(((feature$2, res$3$2) => {
    $uD(res$3$2);
    var value$7 = $m_Lreactbuild_analyze_cost_modules_mapview_Layer$().getAndStripZero__Ltypings_ol_featureMod$default__T__sjs_js_$bar(feature$2, "section");
    if ((value$7 === (void 0))) {
      var value$9 = (void 0)
    } else {
      var section = $as_T(value$7);
      var value$8 = $m_Lreactbuild_analyze_cost_modules_mapview_Layer$().getAndStripZero__Ltypings_ol_featureMod$default__T__sjs_js_$bar(feature$2, "numero");
      if ((value$8 === (void 0))) {
        var value$9 = (void 0)
      } else {
        var numero = $as_T(value$8);
        style.getText().setText(((section + " ") + numero));
        var a = [style];
        var value$9 = a
      }
    };
    var r = ((value$9 === (void 0)) ? [] : value$9);
    return r
  }));
  var value$11 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$10);
  _\uff3fobj$4.style = value$11;
  _\uff3fobj$4.source = source;
  _\uff3fobj$4.minZoom = 17.0;
  return new ($moduleDefault($i_ol$002flayer$002fVector))(_\uff3fobj$4)
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.productPrefix__T = (function() {
  return "WFSLayer"
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_category;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_url;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_title;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_name;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_stroke;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_fill;
      break
    }
    case 6: {
      return this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_options;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer)) {
    var WFSLayer$1 = $as_Lreactbuild_analyze_cost_modules_mapview_WFSLayer(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_category;
    var x$2 = $n(WFSLayer$1).Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_category;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && ((this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_url === $n(WFSLayer$1).Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_url) && (this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_title === $n(WFSLayer$1).Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_title)))) {
      if ((this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_name === $n(WFSLayer$1).Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_name)) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_stroke;
        var x$4 = $n(WFSLayer$1).Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_stroke;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_fill;
        var x$6 = $n(WFSLayer$1).Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_fill;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var x$7 = this.Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_options;
          var x$8 = $n(WFSLayer$1).Lreactbuild_analyze_cost_modules_mapview_WFSLayer__f_options;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_WFSLayer(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.WFSLayer"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_WFSLayer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_WFSLayer)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_WFSLayer(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_WFSLayer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.WFSLayer;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_WFSLayer = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_WFSLayer: 0
}, false, "reactbuild.analyze.cost.modules.mapview.WFSLayer", {
  Lreactbuild_analyze_cost_modules_mapview_WFSLayer: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_WFSLayer.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_WFSLayer;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_reducer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_reusePot = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_title = "Documents associ\u00e9s";
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_reducer = new $c_sjsr_AnonFunction2(((state$2, action$2) => {
    var state = $as_Ldiode_data_Pot(state$2);
    var action = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action(action$2);
    var x = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$();
    if ((x === action)) {
      return $m_Ldiode_data_Empty$()
    } else {
      var x$3 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$();
      if ((x$3 === action)) {
        return $n(state).pending__J__Ldiode_data_Pot($n(state).pending$default$1__J())
      } else if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults)) {
        var x4 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults(action);
        var features = $n(x4).Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults__f_features;
        return ($n(state).isReady__Z() ? $n(state).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1 = $as_sci_List(x$1$2);
          return $n(features).$colon$colon$colon__sci_List__sci_List(x$1)
        }))) : ($n(state), new $c_Ldiode_data_Ready(features)))
      } else {
        throw new $c_s_MatchError(action)
      }
    }
  }));
  var this$4 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_reusePot = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$4.byRef__F2(), this$4.by_$eq$eq__F2());
  var this$90 = $m_Lcom_iz2use_react_hooks_package$();
  var this$9 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$2);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$().apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__sci_List__Z__F1(props, $m_s_package$().s_package$__f_Nil, true))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$8);
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$9, hook, step, d));
  var $$x7 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x6 = new $c_sjsr_AnonFunction2(((p$2, x$2$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$2);
    return $n($n(p).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init).Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers
  }));
  var $$x5 = new $c_sjsr_AnonFunction2(((p$3$2, x$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$3$2);
    return new $c_sjsr_AnonFunction1(((a$2) => {
      var a = $as_sci_List(a$2);
      return a
    }))
  }));
  var $$x4 = $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().tuple2__F2__F2__F2($m_Lreactbuild_analyze_cost_modules_mapview_Layer$().Lreactbuild_analyze_cost_modules_mapview_Layer$__f_reusabilityLayer, $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseLayer));
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$14 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($$x7.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x6, $$x5, $$x4, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$11))));
  var reducer = this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_reducer;
  var initialState = new $c_sjsr_AnonFunction0((() => $m_Ldiode_data_Empty$()));
  var this$13 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$13);
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducer__F2__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$14, reducer, initialState, step$1));
  var $$x8 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var $$x3 = new $c_sjsr_AnonFunction4(((x$4$2, x$5$2, x$6$2, state$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$6$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$3$2);
    return state$3
  }));
  var $$x2 = new $c_sjsr_AnonFunction4(((x$7$2, x$8$2, x$9$2, x$10$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$7$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$9$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$10$2);
    return new $c_sjsr_AnonFunction1(((a$2$1) => {
      var a$1 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(a$2$1);
      return a$1
    }))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$().reusability__F2__F2(this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_reusePot);
  var this$16 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$58 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x8.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$16))));
  var initialState$1 = new $c_sjsr_AnonFunction5(((p$4$2, snap$2, layerSelRef$2, x$11$2, stateRef$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$4$2);
    var layerSelRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(layerSelRef$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$11$2);
    var stateRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(stateRef$2);
    var $$x15 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$();
    $n($m_s_package$().s_package$__f_List);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var $$x13 = $i_ol$002finteraction.Interaction;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_InteractionOptions);
    var handleEvent = new $c_sjsr_AnonFunction1(((ev$2) => {
      var this$17 = $n(stateRef);
      var state$1 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(this$17.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current);
      if (($as_T(ev$2.type) !== $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_MapBrowserEventType.SINGLECLICK))) {
        return true
      } else {
        var this$18 = $n(state$1);
        var this$19 = $n($as_Ldiode_data_Pot(this$18.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0]));
        if ((!this$19.isEmpty__Z())) {
          $m_Ljapgolly_scalajs_react_Reusable$();
          var r = $n(state$1).dispatch__O__Ljapgolly_scalajs_react_Reusable($m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$());
          var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var this$22 = $n(this$);
          $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$22)
        } else {
          $m_Ljapgolly_scalajs_react_Reusable$();
          var r$1 = $n(state$1).dispatch__O__Ljapgolly_scalajs_react_Reusable($m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$());
          var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$1).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var this$25 = $n(this$$1);
          $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$25);
          var this$26 = $n(layerSelRef);
          $n($as_sci_List(this$26.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).map__F1__sci_List(new $c_sjsr_AnonFunction1(((x0$1$2) => {
            var x0$1 = $as_T2(x0$1$2);
            if ((x0$1 !== null)) {
              var layer = $as_Lreactbuild_analyze_cost_modules_mapview_Layer($n(x0$1)._1__O());
              var $$x12 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
              var $$x11 = ev$2.coordinate;
              var value = ev$2.map.getView().getResolution();
              if ((value === (void 0))) {
                var $$x10;
                throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
              } else {
                var $$x10 = value
              };
              $n($n($$x12).unsafeToFuture$extension__F1__s_concurrent_Future($n(layer).getDocuments__sjs_js_Array__D__T__F1($$x11, $uD($$x10), $as_T(ev$2.map.getView().getProjection().getCode())))).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1(((x0$2$2) => {
                var x0$2 = $as_s_util_Try(x0$2$2);
                if ((x0$2 instanceof $c_s_util_Failure)) {
                  var x2 = $as_s_util_Failure(x0$2);
                  var t = $n(x2).s_util_Failure__f_exception;
                  var this$31 = $n(t);
                  this$31.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
                } else if ((x0$2 instanceof $c_s_util_Success)) {
                  var x3 = $as_s_util_Success(x0$2);
                  var results = $as_sci_List($n(x3).s_util_Success__f_value);
                  $m_Ljapgolly_scalajs_react_Reusable$();
                  var r$2 = $n(state$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults(results));
                  var this$$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$2).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
                  var this$35 = $n(this$$2);
                  $as_jl_Void($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$35))
                } else {
                  throw new $c_s_MatchError(x0$2)
                }
              })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
            } else {
              throw new $c_s_MatchError(x0$1)
            }
          })))
        };
        return false
      }
    }));
    var array = [$ct_T2__O__O__(new $c_T2(), "handleEvent", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(handleEvent))];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var interaction = new $$x13(_\uff3fobj);
    var $$x14 = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction, true);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var $$x9 = $i_ol$002finteraction.Draw;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_DrawOptions);
    var type = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.POINT);
    var fields$1 = $m_sci_Nil$();
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    _\uff3fobj$1.type = type;
    var value$1 = new $c_sjsr_AnonFunction2(((feature$2, res$2) => {
      var res = $uD(res$2);
      var a$3 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature$2, res, false);
      return a$3
    }));
    var value$2 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$1);
    _\uff3fobj$1.style = value$2;
    var interaction$1 = new $$x9(_\uff3fobj$1);
    var array$1 = [$$x14, new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction$1, true), ($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$(), new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(snap$2, true))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($$x15).apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems))
  }));
  var this$57 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$57);
  var this$89 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$58, initialState$1, step$2)));
  var f = new $c_sjsr_AnonFunction6(((x$12$2, x$13$2, x$14$2, state$4$2, x$15$2, memo$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$12$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$14$2);
    var state$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$15$2);
    var memo = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(memo$2);
    var this$87 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$59 = $n(memo);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(this$59.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    var this$61 = $n(u);
    var n = this$61.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x19 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var $$x18 = $m_Ldiode_react_ReactPot$potWithReact$();
    var this$63 = $n(state$4);
    var pot = $as_Ldiode_data_Pot(this$63.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0]);
    var $$x17 = $n($$x18).render$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot, new $c_sjsr_AnonFunction1(((details$2) => {
      var details = $as_sci_List(details$2);
      var u$1 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$().apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(details);
      var this$66 = $n(u$1);
      var n$1 = this$66.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    })));
    var $$x16 = $m_Ldiode_react_ReactPot$potWithReact$();
    var this$68 = $n(state$4);
    var pot$1 = $as_Ldiode_data_Pot(this$68.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0]);
    var array$3 = [$$x19, $$x17, $n($$x16).renderPending$extension__Ldiode_data_Pot__F1__Ljapgolly_scalajs_react_vdom_VdomNode(pot$1, new $c_sjsr_AnonFunction1(((x$16$2) => {
      $uI(x$16$2);
      var $$x22 = $m_Lcom_iz2use_react_components_Skeleton$();
      var u$2 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(20);
      var this$71 = $n(u$2);
      var n$2 = this$71.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var $$x21 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x20 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(" : ");
      var u$3 = $m_Lcom_iz2use_react_components_Skeleton$().text__I__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(20);
      var this$76 = $n(u$3);
      var n$3 = this$76.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$2 = [$$x21, $$x20, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)];
      var u$4 = $n($$x22).list__I__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var this$82 = $n(u$4);
      var n$4 = this$82.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4)
    })))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$87, null, ns)
  }));
  var this$88 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(this$88);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$3 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$89, f, step$3, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$90, ev$3).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.GetDocuments.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement = (function(props) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.productPrefix__T = (function() {
  return "GetDocuments"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.hashCode__I = (function() {
  return 1098258466
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.toString__T = (function() {
  return "GetDocuments"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomNode = (function(props) {
  return this.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement(props)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.GetDocuments$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype.productPrefix__T = (function() {
  return "Clear"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype.hashCode__I = (function() {
  return 65193517
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype.toString__T = (function() {
  return "Clear"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.GetDocuments$Clear$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Clear$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults(features) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults__f_features = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults__f_features = features
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype.productPrefix__T = (function() {
  return "NewResults"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults__f_features : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults)) {
    var NewResults$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults__f_features;
    var x$2 = $n(NewResults$1).Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults__f_features;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.GetDocuments$NewResults"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.GetDocuments$NewResults;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.GetDocuments$NewResults", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$NewResults;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype.productPrefix__T = (function() {
  return "Pending"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype.hashCode__I = (function() {
  return 982065527
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype.toString__T = (function() {
  return "Pending"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.GetDocuments$Pending$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocuments$Pending$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1.prototype.applyOrElse__Lreactbuild_analyze_cost_modules_mapview_FeatureInfo__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data)) {
    var x2 = $as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data(x1);
    var feature = $n(x2).Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data__f_feature;
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$4 = $n(feature);
    var f = new $c_sjsr_AnonFunction1(((x$17$2) => {
      var x$17 = $as_T2(x$17$2);
      return $as_T($n(x$17)._1__O())
    }));
    var ord = $m_s_math_Ordering$String$();
    var as = $as_sc_IterableOnce($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$4, f, ord));
    var array$3 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_T2(v$2);
      var this$23 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$1 = $as_T($n(v)._1__O());
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
      var $$x3 = $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("dt", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v$3 = $as_T($n(v)._2__O());
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
      var array$2 = [$$x3, $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("dd", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
      var ms = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return this$23.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
    })))];
    return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("dl", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links)) {
    var x3 = $as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links(x1);
    var links = $n(x3).Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links__f_links;
    var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x6 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$29 = $n(links);
    var f$1 = new $c_sjsr_AnonFunction1(((x$18$2) => {
      var x$18 = $as_T2(x$18$2);
      return $as_T($n(x$18)._1__O())
    }));
    var ord$1 = $m_s_math_Ordering$String$();
    var as$1 = $as_sc_IterableOnce($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$29, f$1, ord$1));
    var array$6 = [$n($$x6).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((link$2) => {
      var link = $as_T2(link$2);
      var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$()).toNewWindow__T__Z__Z__Ljapgolly_scalajs_react_vdom_TagOf($as_T($n(link)._2__O()), ($n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$()), true), ($n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less).a__Ljapgolly_scalajs_react_vdom_HtmlTags$a$()), false));
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var this$33 = $n($as_T($n(link)._1__O()));
      var v$4 = ("" + $as_T(this$33.split("_").join(" ")));
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
      var array$5 = [$n($$x7).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
      return $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
    })))];
    return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1.prototype.isDefinedAt__Lreactbuild_analyze_cost_modules_mapview_FeatureInfo__Z = (function(x1) {
  return ((x1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Data) || (x1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_analyze_cost_modules_mapview_FeatureInfo__Z($as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo(x))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_analyze_cost_modules_mapview_FeatureInfo__F1__O($as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetDocumentsDetails$$anonfun$$nestedInanonfun$component$17$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$__f_title = "Cliquer pour plus d'infos";
  var this$50 = $m_Lcom_iz2use_react_hooks_package$();
  var this$6 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$2);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$().apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__sci_List__Z__F1(props, $m_s_package$().s_package$__f_Nil, true))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$5 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$5);
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$6, hook, step, d));
  var $$x4 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x3 = new $c_sjsr_AnonFunction2(((p$2, x$1$2) => {
    var p = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$2);
    return $n($n(p).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init).Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers
  }));
  var $$x2 = new $c_sjsr_AnonFunction2(((p$3$2, x$2$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$3$2);
    return new $c_sjsr_AnonFunction1(((a$2) => {
      var a = $as_sci_List(a$2);
      return a
    }))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().tuple2__F2__F2__F2($m_Lreactbuild_analyze_cost_modules_mapview_Layer$().Lreactbuild_analyze_cost_modules_mapview_Layer$__f_reusabilityLayer, $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseLayer));
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$43 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x4.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$8))));
  var initialState = new $c_sjsr_AnonFunction3(((p$4$2, snap$2, layerSelRef$2) => {
    var p$4 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$4$2);
    var layerSelRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(layerSelRef$2);
    var $$x10 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$();
    $n($m_s_package$().s_package$__f_List);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var $$x8 = $i_ol$002finteraction.Interaction;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_InteractionOptions);
    var handleEvent = new $c_sjsr_AnonFunction1(((ev$2) => {
      if (($as_T(ev$2.type) !== $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_MapBrowserEventType.SINGLECLICK))) {
        return true
      } else {
        var featureSource = $n($n(p$4).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature.getSource();
        var array = featureSource.getFeaturesAtCoordinate(ev$2.coordinate);
        if (($uI(array.length) !== 0)) {
          console.error("features to remove :", array);
          $m_sjs_js_ArrayOps$().foreach$extension__sjs_js_Array__F1__V(array, new $c_sjsr_AnonFunction1(((feature$2) => {
            featureSource.removeFeature(feature$2)
          })))
        } else {
          var this$12 = $n(layerSelRef);
          $n($as_sci_List(this$12.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).map__F1__sci_List(new $c_sjsr_AnonFunction1(((x0$1$2) => {
            var x0$1 = $as_T2(x0$1$2);
            if ((x0$1 !== null)) {
              var layer = $as_Lreactbuild_analyze_cost_modules_mapview_Layer($n(x0$1)._1__O());
              var $$x7 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
              $n(layer);
              ev$2.coordinate;
              var value = ev$2.map.getView().getResolution();
              if ((value === (void 0))) {
                var $$x6;
                throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
              } else {
                var $$x6 = value
              };
              $uD($$x6);
              $as_T(ev$2.map.getView().getProjection().getCode());
              $n($n($$x7).unsafeToFuture$extension__F1__s_concurrent_Future($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1($m_s_package$().s_package$__f_Nil))).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1(((x0$2$2) => {
                var x0$2 = $as_s_util_Try(x0$2$2);
                if ((x0$2 instanceof $c_s_util_Failure)) {
                  var x2 = $as_s_util_Failure(x0$2);
                  var t = $n(x2).s_util_Failure__f_exception;
                  var this$18 = $n(t);
                  this$18.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
                } else if ((x0$2 instanceof $c_s_util_Success)) {
                  var x3 = $as_s_util_Success(x0$2);
                  var results = $as_sci_List($n(x3).s_util_Success__f_value);
                  featureSource.addFeatures($m_sjs_js_JSConverters$JSRichIterableOnce$().toJSArray$extension__sc_IterableOnce__sjs_js_Array(results))
                } else {
                  throw new $c_s_MatchError(x0$2)
                }
              })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
            } else {
              throw new $c_s_MatchError(x0$1)
            }
          })))
        };
        return false
      }
    }));
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "handleEvent", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(handleEvent))];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var interaction = new $$x8(_\uff3fobj);
    var $$x9 = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction, true);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var $$x5 = $i_ol$002finteraction.Draw;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_DrawOptions);
    var type = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.POINT);
    var fields$1 = $m_sci_Nil$();
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    _\uff3fobj$1.type = type;
    var value$1 = new $c_sjsr_AnonFunction2(((feature$2$1, res$2) => {
      var res = $uD(res$2);
      var a$1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature$2$1, res, false);
      return a$1
    }));
    var value$2 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$1);
    _\uff3fobj$1.style = value$2;
    var interaction$1 = new $$x5(_\uff3fobj$1);
    var array$2 = [$$x9, new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction$1, true), ($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$(), new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(snap$2, true))];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    return $n($$x10).apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems))
  }));
  var this$42 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$42);
  var this$49 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$43, initialState, step$1)));
  var f = new $c_sjsr_AnonFunction4(((x$3$2, x$4$2, x$5$2, memo$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$3$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$5$2);
    var memo = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(memo$2);
    var this$44 = $n(memo);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw(this$44.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    var this$46 = $n(u);
    var n = this$46.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$48 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$48);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$3 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$49, f, step$2, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$50, ev$3).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.GetFeatureInfo.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement = (function(props) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.productPrefix__T = (function() {
  return "GetFeatureInfo"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.hashCode__I = (function() {
  return (-2019558482)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.toString__T = (function() {
  return "GetFeatureInfo"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomNode = (function(props) {
  return this.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement(props)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.GetFeatureInfo$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_GetFeatureInfo$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(_id, file, position, geolocation, orientation, instant) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f__id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_file = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_position = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_geolocation = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_orientation = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_instant = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f__id = _id;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_file = file;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_position = position;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_geolocation = geolocation;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_orientation = orientation;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_instant = instant
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype.productPrefix__T = (function() {
  return "Feature"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_file;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_position;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_geolocation;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_orientation;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_instant;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature)) {
    var Feature$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f__id;
    var x$2 = $n(Feature$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_file;
      var x$4 = $n(Feature$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_file;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_position;
        var x$6 = $n(Feature$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_position;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_geolocation;
      var x$8 = $n(Feature$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_geolocation;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_orientation;
        var x$10 = $n(Feature$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_orientation;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_instant;
          var x$12 = $n(Feature$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature__f_instant;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.LocalData$Feature"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.LocalData$Feature;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.LocalData$Feature", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File(_id, type, buffer) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f__id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_type = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_buffer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f__id = _id;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_type = type;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_buffer = buffer
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype.productPrefix__T = (function() {
  return "File"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_type;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_buffer;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File)) {
    var File$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f__id;
    var x$2 = $n(File$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      if ((this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_type === $n(File$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_type)) {
        var x$3 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_buffer;
        var y = $n(File$1).Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f_buffer;
        return $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.LocalData$File"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.LocalData$File;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.LocalData$File", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$StoredData: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_format = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_title = "Mesurer des longueurs et surfaces";
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_format = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_format;
  var this$154 = $m_Lcom_iz2use_react_hooks_package$();
  var this$9 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$2);
    var $$x17 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$();
    $n($m_s_package$().s_package$__f_List);
    var array = [$m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default()];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($n($$x17).apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__sci_List__Z__F1(props, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), true))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$8);
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$9, hook, step, d));
  var $$x18 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api);
  var $$x16 = new $c_sjsr_AnonFunction0((() => $m_s_Option$().apply__O__s_Option(0)));
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x18.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x16, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$11)));
  var $$x19 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var $$x15 = new $c_sjsr_AnonFunction3(((x$1$2, x$2$2, level$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$1$2);
    var level = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$2);
    return level
  }));
  var $$x14 = new $c_sjsr_AnonFunction3(((x$3$2, x$4$2, level$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$3$2);
    var level$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$3$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$5$2);
      return level$3
    }))
  }));
  var $$x13 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$13 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$2 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x19.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x15, $$x14, $$x13, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$13)));
  var $$x20 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$2);
  var $$x12 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$16 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$3 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x20.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x12, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$16)));
  var $$x21 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$3);
  var $$x11 = new $c_sjsr_AnonFunction5(((x$6$2, x$7$2, x$8$2, x$9$2, altitude$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$6$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$8$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$9$2);
    var altitude = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(altitude$2);
    return altitude
  }));
  var $$x10 = new $c_sjsr_AnonFunction5(((x$10$2, x$11$2, x$12$2, x$13$2, altitude$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$10$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$12$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$13$2);
    var altitude$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(altitude$3$2);
    return new $c_sjsr_AnonFunction1(((x$14$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$14$2);
      return altitude$3
    }))
  }));
  var $$x9 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$18 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$4 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x21.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x11, $$x10, $$x9, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$18)));
  var $$x22 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$4);
  var $$x8 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$21 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$5 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x22.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x8, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(this$21)));
  var $$x23 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$5);
  var $$x7 = new $c_sjsr_AnonFunction7(((x$15$2, x$16$2, x$17$2, x$18$2, x$19$2, x$20$2, length$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$15$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$17$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$18$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$19$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$20$2);
    var length = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(length$2);
    return length
  }));
  var $$x6 = new $c_sjsr_AnonFunction7(((x$21$2, x$22$2, x$23$2, x$24$2, x$25$2, x$26$2, length$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$21$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$23$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$24$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$25$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$26$2);
    var length$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(length$3$2);
    return new $c_sjsr_AnonFunction1(((x$27$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$27$2);
      return length$3
    }))
  }));
  var $$x5 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$23 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$6 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x23.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x7, $$x6, $$x5, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6(this$23)));
  var $$x24 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$6);
  var $$x4 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$26 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$7 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x24.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x4, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7(this$26)));
  var $$x25 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$7);
  var $$x3 = new $c_sjsr_AnonFunction9(((x$28$2, x$29$2, x$30$2, x$31$2, x$32$2, x$33$2, x$34$2, x$35$2, label$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$28$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$30$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$31$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$32$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$33$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$34$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$35$2);
    var label = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(label$2);
    return label
  }));
  var $$x2 = new $c_sjsr_AnonFunction9(((x$36$2, x$37$2, x$38$2, x$39$2, x$40$2, x$41$2, x$42$2, x$43$2, label$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$36$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$38$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$39$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$40$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$41$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$42$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$43$2);
    var label$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(label$3$2);
    return new $c_sjsr_AnonFunction1(((x$44$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$44$2);
      return label$3
    }))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$28 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$35 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x25.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8(this$28))));
  var initialState = new $c_sjsr_AnonFunction10(((p$2, snap$2, x$45$2, x$46$2, x$47$2, x$48$2, x$49$2, x$50$2, x$51$2, x$52$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$45$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$46$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$47$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$48$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$49$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$50$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$51$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$52$2);
    var $$x26 = $i_ol$002finteraction.Modify;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ModifyOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var value = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default();
    _\uff3fobj.source = value;
    return new $$x26(_\uff3fobj)
  }));
  var this$34 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9(this$34);
  var this$48 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$35, initialState, step$1)));
  var initialState$1 = new $c_sjsr_AnonFunction11(((p$3$2, snap$3$2, x$53$2, x$54$2, x$55$2, x$56$2, x$57$2, x$58$2, x$59$2, x$60$2, x$61$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$53$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$54$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$55$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$56$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$57$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$58$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$59$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$60$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$61$2);
    var $$x27 = $i_ol$002finteraction.Draw;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_DrawOptions);
    var type = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.POLYGON);
    var fields$1 = $m_sci_Nil$();
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    _\uff3fobj$1.type = type;
    var value$1 = $n($n(p$3).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature.getSource();
    _\uff3fobj$1.source = value$1;
    var value$2 = new $c_sjsr_AnonFunction2(((feature$2, res$2) => {
      var res = $uD(res$2);
      var a = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature$2, res, true);
      return a
    }));
    var value$3 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$2);
    _\uff3fobj$1.style = value$3;
    return new $$x27(_\uff3fobj$1)
  }));
  var this$47 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10(this$47);
  var this$62 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$48, initialState$1, step$2)));
  var initialState$2 = new $c_sjsr_AnonFunction12(((p$4$2, snap$4$2, x$62$2, x$63$2, x$64$2, x$65$2, x$66$2, x$67$2, x$68$2, x$69$2, modifyInteraction$2, drawInteraction$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$4$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$62$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$63$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$64$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$65$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$66$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$67$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$68$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$69$2);
    var modifyInteraction = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(modifyInteraction$2);
    var drawInteraction = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(drawInteraction$2);
    var $$x29 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$();
    $n($m_s_package$().s_package$__f_List);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var this$49 = $n(modifyInteraction);
    var interaction = this$49.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var $$x28 = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction, true);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var this$51 = $n(drawInteraction);
    var interaction$1 = this$51.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var array$1 = [$$x28, new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction$1, true), ($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$(), new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(snap$4$2, true))];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var u = $n($$x29).apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1));
    var this$59 = $n(u);
    var n = this$59.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$61 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11(this$61);
  var this$82 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$62, initialState$2, step$3)));
  var deps = new $c_sjsr_AnonFunction13(((x$70$2, x$71$2, level$4$2, x$72$2, x$73$2, x$74$2, x$75$2, x$76$2, x$77$2, x$78$2, x$79$2, x$80$2, x$81$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$70$2);
    var level$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$72$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$73$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$74$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$75$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$76$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$77$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$78$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$79$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$80$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$81$2);
    return level$4
  }));
  var effect = new $c_sjsr_AnonFunction13(((p$5$2, x$82$2, level$5$2, x$83$2, x$84$2, x$85$2, x$86$2, x$87$2, x$88$2, x$89$2, x$90$2, x$91$2, x$92$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$5$2);
    var level$5 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$5$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$83$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$84$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$85$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$86$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$87$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$88$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$89$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$90$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$91$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$92$2);
    return new $c_sjsr_AnonFunction1(((x$93$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$93$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        var target = $as_s_Option($n(level$5).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
        var $$x30 = $m_sjs_js_ArrayOps$();
        var array$2 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default().getFeatures();
        $n($$x30).foreach$extension__sjs_js_Array__F1__V(array$2, new $c_sjsr_AnonFunction1(((feature$2$1) => {
          var value$4 = feature$2$1.get("level");
          var f = new $c_sjsr_AnonFunction1(((level$2$1) => {
            var level$1 = $uI(level$2$1);
            var this$65 = $n(target);
            var p$1 = new $c_sjsr_AnonFunction1(((x$94$2) => {
              var x$94 = $uI(x$94$2);
              return (level$1 === x$94)
            }));
            if (((!this$65.isEmpty__Z()) && $uZ(p$1.apply__O__O(this$65.get__O())))) {
              var a$1 = ((arg1$2, arg2$2) => {
                var arg2 = $uD(arg2$2);
                return $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$().reactbuild$analyze$cost$modules$mapview$interactions$Measure$$$anonfun$component$29__sjs_js_$bar__D__sjs_js_$bar(arg1$2, arg2)
              });
              feature$2$1.setStyle(a$1)
            } else {
              var a$2 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().hidden__Ltypings_ol_styleMod$Style();
              feature$2$1.setStyle(a$2)
            }
          }));
          if ((value$4 !== (void 0))) {
            f.apply__O__O(value$4)
          }
        })))
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    }))
  }));
  var a$3 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$81 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12(this$81);
  var this$100 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$82, deps, effect, a$3, r, step$4)));
  var effect$1 = new $c_sjsr_AnonFunction13(((p$6$2, x$95$2, x$96$2, levelRef$2, x$97$2, altitudeRef$2, x$98$2, lengthRef$2, x$99$2, labelRef$2, modifyInteractionState$2, drawInteractionState$2, x$100$2) => {
    var p$6 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$6$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$96$2);
    var levelRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(levelRef$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$97$2);
    var altitudeRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(altitudeRef$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$98$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(lengthRef$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$99$2);
    var labelRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(labelRef$2);
    var modifyInteractionState = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(modifyInteractionState$2);
    var drawInteractionState = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(drawInteractionState$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$100$2);
    var this$83 = $n(drawInteractionState);
    var drawInteraction$1 = this$83.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var this$84 = $n(modifyInteractionState);
    var modifyInteraction$1 = this$84.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f$3 = new $c_sjsr_AnonFunction0((() => {
      $n($m_s_package$().s_package$__f_List);
      var array$3 = [modifyInteraction$1.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "modifyend"), ((arg1$2$1) => {
        $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$().reactbuild$analyze$cost$modules$mapview$interactions$Measure$$$anonfun$component$32__Ltypings_ol_interactionModifyMod$ModifyEvent__V(arg1$2$1)
      })), drawInteraction$1.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "drawend"), ((arg1$2$2) => {
        $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$().reactbuild$analyze$cost$modules$mapview$interactions$Measure$$$anonfun$component$37__Ltypings_ol_interactionDrawMod$DrawEvent__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ltypings_ol_interactionMod$Draw__V(arg1$2$2, levelRef, altitudeRef, labelRef, p$6, drawInteraction$1)
      }))];
      var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
      return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2)
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var this$ = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3);
    var f$7 = new $c_sjsr_AnonFunction1(((registered$2) => {
      var registered = $as_sci_List(registered$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$5 = new $c_sjsr_AnonFunction0((() => {
        var this$92 = $n(registered);
        var f$4 = new $c_sjsr_AnonFunction1(((key$2) => {
          $i_ol$002fObservable.unByKey(key$2)
        }));
        var these = this$92;
        while ((!$n(these).isEmpty__Z())) {
          f$4.apply__O__O($n(these).head__O());
          these = $as_sci_List($n(these).tail__O())
        }
      }));
      var f$6 = new $c_sjsr_AnonFunction0((() => {
        f$5.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$6))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$7))
  }));
  var a$4 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$99 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$5 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12(this$99);
  var this$153 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$100, effect$1, a$4, step$5)));
  var f$8 = new $c_sjsr_AnonFunction13(((x$103$2, x$104$2, level$6$2, x$105$2, altitude$4$2, x$106$2, length$4$2, x$107$2, label$4$2, x$108$2, x$109$2, _\uff3f$2, result$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$103$2);
    var level$6 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$6$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$105$2);
    var altitude$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(altitude$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$106$2);
    var length$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(length$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$107$2);
    var label$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(label$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$108$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$109$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(_\uff3f$2);
    var result = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(result$2);
    var this$151 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$101 = $n(result);
    var $$x35 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(this$101.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Niveau");
    var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var ev$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$108 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$108);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv = $m_s_math_Equiv$Int$();
    var $$x33 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, level$6, optioner, ev$7, explainError, equiv);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Altitude");
    var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$8);
    var ev$9 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$118 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$118);
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
    var equiv$1 = new $c_s_math_Equiv$OptionEquiv(eqv);
    var $$x32 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$5, altitude$4, optioner$1, ev$9, explainError$1, equiv$1);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Longueur");
    var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$10);
    var ev$11 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$129 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$129);
    var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
    var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv$1 = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
    var equiv$2 = new $c_s_math_Equiv$OptionEquiv(eqv$1);
    var $$x31 = editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$6, length$4, optioner$2, ev$11, explainError$2, equiv$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$7 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Libell\u00e9");
    var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$12 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$3 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$12);
    var ev$13 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$140 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$140);
    var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
    var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv$2 = $m_s_math_Equiv$String$();
    var equiv$3 = new $c_s_math_Equiv$OptionEquiv(eqv$2);
    var array$4 = [$$x33, $$x32, $$x31, editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$7, label$4, optioner$3, ev$13, explainError$3, equiv$3)];
    var array$5 = [$$x35, $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$151, null, ns)
  }));
  var this$152 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$6 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12(this$152);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$14 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$153, f$8, step$6, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$154, ev$14).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.Measure.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement = (function(props) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.uploadFeature__Ltypings_ol_featureMod$default__s_concurrent_Future = (function(feature) {
  var toPersist = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().cloneObject__O__O(feature);
  var $$x1 = $m_Lio_circe_scalajs_package$EncoderJsOps$();
  $m_Lio_circe_scalajs_package$();
  var value = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().getData__sjs_js_$bar__O(toPersist);
  toPersist.set("data", $n($$x1).asJsAny$extension__O__Lio_circe_Encoder__sjs_js_Any(value, $m_Lreactbuild_model_MapFeature$MapFeature$().Lreactbuild_model_MapFeature$MapFeature$__f_codecForMapFeature));
  var data = this.Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_format.writeFeatureObject(toPersist);
  var fetchHeaders = new Headers();
  fetchHeaders.append("Content-Type", "application/json");
  var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
  var p = fetch("/api/mapFeatures/", (() => {
    var data$1 = null;
    var fetchHeaders$1 = null;
    data$1 = data;
    fetchHeaders$1 = fetchHeaders;
    var this$8 = {};
    var a = $m_Lorg_scalajs_dom_HttpMethod$().Lorg_scalajs_dom_HttpMethod$__f_POST;
    this$8.method = a;
    var a$1 = $as_T(JSON.stringify(data$1));
    this$8.body = a$1;
    var a$2 = fetchHeaders$1;
    this$8.headers = a$2;
    var a$3 = $m_Lorg_scalajs_dom_RequestCredentials$().Lorg_scalajs_dom_RequestCredentials$__f_include;
    this$8.credentials = a$3;
    return this$8
  })());
  return $n($n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((res$2) => {
    var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
    var p$1 = res$2.text();
    return $n($n($$x3).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((text$2) => {
      var text = $as_T(text$2);
      var $$x4 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$();
      var a$4 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$().Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$__f_format.readFeature(text);
      return $n($$x4).convertFeature__sjs_js_$bar__Ltypings_ol_featureMod$default(a$4)
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.productPrefix__T = (function() {
  return "Measure"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.hashCode__I = (function() {
  return (-1691992770)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.toString__T = (function() {
  return "Measure"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomNode = (function(props) {
  return this.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement(props)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$Measure$$$anonfun$component$29__sjs_js_$bar__D__sjs_js_$bar = (function(feature, res) {
  var a = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature, res, true);
  return a
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$Measure$$$anonfun$component$32__Ltypings_ol_interactionModifyMod$ModifyEvent__V = (function(e) {
  var features = e.features;
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var $$x3 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
  var $$x2 = new $c_sjsr_AnonFunction0((() => {
    var array = features.getArray();
    return $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array))
  }));
  var $$x1 = new $c_sjsr_AnonFunction1(((feature$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$().uploadFeature__Ltypings_ol_featureMod$default__s_concurrent_Future(feature$2))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))));
  var this$7 = $m_sc_BuildFrom$();
  var cb = $n($$x4).map$extension__F1__F1__F1($n($$x3).traverse__F0__F1__sc_BuildFrom__F1($$x2, $$x1, new $c_sc_BuildFromLowPriority2$$anon$11(this$7)), new $c_sjsr_AnonFunction1(((x$101$2) => {
    $as_sci_Seq(x$101$2)
  })));
  var this$ = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(cb);
  var this$9 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$9)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$Measure$$$anonfun$component$37__Ltypings_ol_interactionDrawMod$DrawEvent__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ltypings_ol_interactionMod$Draw__V = (function(e, levelRef$1, altitudeRef$1, labelRef$1, p$1, drawInteraction$1) {
  var feature = e.feature;
  var $$x4 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$();
  $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
  var $$x3 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
  var this$5 = $n(levelRef$1);
  var $$x2 = $as_s_Option($n($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(this$5.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var this$6 = $n(altitudeRef$1);
  var $$x1 = $as_s_Option($n($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(this$6.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var this$7 = $n(labelRef$1);
  $n($$x4).setData__sjs_js_$bar__O__V(feature, new $c_Lreactbuild_model_MapFeature$Measure($$x3, $$x2, $$x1, $as_s_Option($n($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(this$7.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var cb = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(($n($n(p$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature.getSource().removeFeature(feature), (void 0))), new $c_sjsr_AnonFunction1(((x$102$2) => {
    $as_jl_Void(x$102$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$().uploadFeature__Ltypings_ol_featureMod$default__s_concurrent_Future(feature))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((result$2) => {
      $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default().addFeature(result$2)
    }))))
  })));
  var this$ = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(cb);
  var this$11 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$11);
  drawInteraction$1.abortDrawing()
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.Measure$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var feature = $n(x1)._1__O();
    var data = $as_Lreactbuild_model_MapFeature$MapFeature($n(x1)._2__O());
    if ((data instanceof $c_Lreactbuild_model_MapFeature$Image)) {
      var x2 = $as_Lreactbuild_model_MapFeature$Image(data);
      return $ct_T2__O__O__(new $c_T2(), feature, x2)
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var data = $as_Lreactbuild_model_MapFeature$MapFeature($n(x1)._2__O());
    if ((data instanceof $c_Lreactbuild_model_MapFeature$Image)) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.PositionOnMap$$anonfun$$nestedInanonfun$component$69$1", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$$anonfun$$nestedInanonfun$component$69$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$__f_title = "Tourner des \u00e9l\u00e9ments";
  var this$154 = $m_Lcom_iz2use_react_hooks_package$();
  var this$9 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$2);
    var $$x17 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$();
    $n($m_s_package$().s_package$__f_List);
    var array = [$m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default()];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($n($$x17).apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__sci_List__Z__F1(props, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), true))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$8);
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$9, hook, step, d));
  var $$x18 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api);
  var $$x16 = new $c_sjsr_AnonFunction0((() => $m_s_Option$().apply__O__s_Option(0)));
  var this$11 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x18.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x16, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$11)));
  var $$x19 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var $$x15 = new $c_sjsr_AnonFunction3(((x$1$2, x$2$2, level$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$1$2);
    var level = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$2);
    return level
  }));
  var $$x14 = new $c_sjsr_AnonFunction3(((x$3$2, x$4$2, level$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$3$2);
    var level$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$3$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$5$2);
      return level$3
    }))
  }));
  var $$x13 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$13 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$2 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x19.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x15, $$x14, $$x13, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$13)));
  var $$x20 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$2);
  var $$x12 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$16 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$3 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x20.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x12, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$16)));
  var $$x21 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$3);
  var $$x11 = new $c_sjsr_AnonFunction5(((x$6$2, x$7$2, x$8$2, x$9$2, altitude$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$6$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$8$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$9$2);
    var altitude = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(altitude$2);
    return altitude
  }));
  var $$x10 = new $c_sjsr_AnonFunction5(((x$10$2, x$11$2, x$12$2, x$13$2, altitude$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$10$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$12$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$13$2);
    var altitude$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(altitude$3$2);
    return new $c_sjsr_AnonFunction1(((x$14$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$14$2);
      return altitude$3
    }))
  }));
  var $$x9 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$18 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$4 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x21.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x11, $$x10, $$x9, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$18)));
  var $$x22 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$4);
  var $$x8 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$21 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$5 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x22.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x8, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(this$21)));
  var $$x23 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$5);
  var $$x7 = new $c_sjsr_AnonFunction7(((x$15$2, x$16$2, x$17$2, x$18$2, x$19$2, x$20$2, length$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$15$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$17$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$18$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$19$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$20$2);
    var length = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(length$2);
    return length
  }));
  var $$x6 = new $c_sjsr_AnonFunction7(((x$21$2, x$22$2, x$23$2, x$24$2, x$25$2, x$26$2, length$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$21$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$23$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$24$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$25$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$26$2);
    var length$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(length$3$2);
    return new $c_sjsr_AnonFunction1(((x$27$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$27$2);
      return length$3
    }))
  }));
  var $$x5 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$23 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$6 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x23.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x7, $$x6, $$x5, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6(this$23)));
  var $$x24 = new $c_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$HooksApiExt$Secondary(api$6);
  var $$x4 = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$26 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var api$7 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x24.useStateSnapshot__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O($$x4, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$7(this$26)));
  var $$x25 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$7);
  var $$x3 = new $c_sjsr_AnonFunction9(((x$28$2, x$29$2, x$30$2, x$31$2, x$32$2, x$33$2, x$34$2, x$35$2, label$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$28$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$30$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$31$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$32$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$33$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$34$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$35$2);
    var label = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(label$2);
    return label
  }));
  var $$x2 = new $c_sjsr_AnonFunction9(((x$36$2, x$37$2, x$38$2, x$39$2, x$40$2, x$41$2, x$42$2, x$43$2, label$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$36$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$38$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$39$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$40$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$41$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$42$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$43$2);
    var label$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(label$3$2);
    return new $c_sjsr_AnonFunction1(((x$44$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$44$2);
      return label$3
    }))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$28 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$35 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x25.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$8(this$28))));
  var initialState = new $c_sjsr_AnonFunction10(((p$2, snap$2, x$45$2, x$46$2, x$47$2, x$48$2, x$49$2, x$50$2, x$51$2, x$52$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$45$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$46$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$47$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$48$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$49$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$50$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$51$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$52$2);
    var $$x26 = $i_ol$002finteraction.Modify;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ModifyOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var value = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default();
    _\uff3fobj.source = value;
    return new $$x26(_\uff3fobj)
  }));
  var this$34 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$9(this$34);
  var this$48 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$35, initialState, step$1)));
  var initialState$1 = new $c_sjsr_AnonFunction11(((p$3$2, snap$3$2, x$53$2, x$54$2, x$55$2, x$56$2, x$57$2, x$58$2, x$59$2, x$60$2, x$61$2) => {
    var p$3 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$53$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$54$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$55$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$56$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$57$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$58$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$59$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$60$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$61$2);
    var $$x27 = $i_ol$002finteraction.Draw;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_DrawOptions);
    var type = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.POLYGON);
    var fields$1 = $m_sci_Nil$();
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    _\uff3fobj$1.type = type;
    var value$1 = $n($n(p$3).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature.getSource();
    _\uff3fobj$1.source = value$1;
    var value$2 = new $c_sjsr_AnonFunction2(((feature$2, res$2) => {
      var res = $uD(res$2);
      var a = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature$2, res, true);
      return a
    }));
    var value$3 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$2);
    _\uff3fobj$1.style = value$3;
    return new $$x27(_\uff3fobj$1)
  }));
  var this$47 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$10(this$47);
  var this$62 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$48, initialState$1, step$2)));
  var initialState$2 = new $c_sjsr_AnonFunction12(((p$4$2, snap$4$2, x$62$2, x$63$2, x$64$2, x$65$2, x$66$2, x$67$2, x$68$2, x$69$2, modifyInteraction$2, drawInteraction$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$4$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$62$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$63$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$64$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$65$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$66$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$67$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$68$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$69$2);
    var modifyInteraction = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(modifyInteraction$2);
    var drawInteraction = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(drawInteraction$2);
    var $$x29 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$();
    $n($m_s_package$().s_package$__f_List);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var this$49 = $n(modifyInteraction);
    var interaction = this$49.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var $$x28 = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction, true);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var this$51 = $n(drawInteraction);
    var interaction$1 = this$51.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var array$1 = [$$x28, new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction$1, true), ($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$(), new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(snap$4$2, true))];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var u = $n($$x29).apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1));
    var this$59 = $n(u);
    var n = this$59.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$61 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$11(this$61);
  var this$82 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$62, initialState$2, step$3)));
  var deps = new $c_sjsr_AnonFunction13(((x$70$2, x$71$2, level$4$2, x$72$2, x$73$2, x$74$2, x$75$2, x$76$2, x$77$2, x$78$2, x$79$2, x$80$2, x$81$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$70$2);
    var level$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$72$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$73$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$74$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$75$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$76$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$77$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$78$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$79$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$80$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$81$2);
    return level$4
  }));
  var effect = new $c_sjsr_AnonFunction13(((p$5$2, x$82$2, level$5$2, x$83$2, x$84$2, x$85$2, x$86$2, x$87$2, x$88$2, x$89$2, x$90$2, x$91$2, x$92$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$5$2);
    var level$5 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$5$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$83$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$84$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$85$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$86$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$87$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$88$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$89$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$90$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$91$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$92$2);
    return new $c_sjsr_AnonFunction1(((x$93$2) => {
      $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$93$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        var target = $as_s_Option($n(level$5).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
        var $$x30 = $m_sjs_js_ArrayOps$();
        var array$2 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default().getFeatures();
        $n($$x30).foreach$extension__sjs_js_Array__F1__V(array$2, new $c_sjsr_AnonFunction1(((feature$2$1) => {
          var value$4 = feature$2$1.get("level");
          var f = new $c_sjsr_AnonFunction1(((level$2$1) => {
            var level$1 = $uI(level$2$1);
            var this$65 = $n(target);
            var p$1 = new $c_sjsr_AnonFunction1(((x$94$2) => {
              var x$94 = $uI(x$94$2);
              return (level$1 === x$94)
            }));
            if (((!this$65.isEmpty__Z()) && $uZ(p$1.apply__O__O(this$65.get__O())))) {
              var a$1 = ((arg1$2, arg2$2) => {
                var arg2 = $uD(arg2$2);
                return $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$().reactbuild$analyze$cost$modules$mapview$interactions$Rotate$$$anonfun$component$29__sjs_js_$bar__D__sjs_js_$bar(arg1$2, arg2)
              });
              feature$2$1.setStyle(a$1)
            } else {
              var a$2 = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().hidden__Ltypings_ol_styleMod$Style();
              feature$2$1.setStyle(a$2)
            }
          }));
          if ((value$4 !== (void 0))) {
            f.apply__O__O(value$4)
          }
        })))
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    }))
  }));
  var a$3 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var r = $m_Ljapgolly_scalajs_react_extra_StateSnapshotF$().reusability__F2();
  var this$81 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12(this$81);
  var this$100 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$82, deps, effect, a$3, r, step$4)));
  var effect$1 = new $c_sjsr_AnonFunction13(((p$6$2, x$95$2, x$96$2, levelRef$2, x$97$2, altitudeRef$2, x$98$2, lengthRef$2, x$99$2, labelRef$2, modifyInteractionState$2, drawInteractionState$2, x$100$2) => {
    var p$6 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$6$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$96$2);
    var levelRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(levelRef$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$97$2);
    var altitudeRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(altitudeRef$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$98$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(lengthRef$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$99$2);
    var labelRef = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(labelRef$2);
    var modifyInteractionState = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(modifyInteractionState$2);
    var drawInteractionState = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(drawInteractionState$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$100$2);
    var this$83 = $n(drawInteractionState);
    var drawInteraction$1 = this$83.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var this$84 = $n(modifyInteractionState);
    var modifyInteraction$1 = this$84.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f$3 = new $c_sjsr_AnonFunction0((() => {
      $n($m_s_package$().s_package$__f_List);
      var array$3 = [modifyInteraction$1.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "modifyend"), ((arg1$2$1) => {
        $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$().reactbuild$analyze$cost$modules$mapview$interactions$Rotate$$$anonfun$component$32__Ltypings_ol_interactionModifyMod$ModifyEvent__V(arg1$2$1)
      })), drawInteraction$1.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "drawend"), ((arg1$2$2) => {
        $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$().reactbuild$analyze$cost$modules$mapview$interactions$Rotate$$$anonfun$component$37__Ltypings_ol_interactionDrawMod$DrawEvent__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ltypings_ol_interactionMod$Draw__V(arg1$2$2, levelRef, altitudeRef, labelRef, p$6, drawInteraction$1)
      }))];
      var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
      return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2)
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var this$ = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3);
    var f$7 = new $c_sjsr_AnonFunction1(((registered$2) => {
      var registered = $as_sci_List(registered$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$5 = new $c_sjsr_AnonFunction0((() => {
        var this$92 = $n(registered);
        var f$4 = new $c_sjsr_AnonFunction1(((key$2) => {
          $i_ol$002fObservable.unByKey(key$2)
        }));
        var these = this$92;
        while ((!$n(these).isEmpty__Z())) {
          f$4.apply__O__O($n(these).head__O());
          these = $as_sci_List($n(these).tail__O())
        }
      }));
      var f$6 = new $c_sjsr_AnonFunction0((() => {
        f$5.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$6))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$7))
  }));
  var a$4 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$99 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$5 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12(this$99);
  var this$153 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$100, effect$1, a$4, step$5)));
  var f$8 = new $c_sjsr_AnonFunction13(((x$103$2, x$104$2, level$6$2, x$105$2, altitude$4$2, x$106$2, length$4$2, x$107$2, label$4$2, x$108$2, x$109$2, _\uff3f$2, result$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$103$2);
    var level$6 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(level$6$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$105$2);
    var altitude$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(altitude$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$106$2);
    var length$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(length$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$107$2);
    var label$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(label$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$108$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$109$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(_\uff3f$2);
    var result = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(result$2);
    var this$151 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var this$101 = $n(result);
    var $$x35 = $as_Ljapgolly_scalajs_react_vdom_VdomNode(this$101.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0]);
    var $$x34 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Niveau");
    var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var ev$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$108 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$108);
    var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv = $m_s_math_Equiv$Int$();
    var $$x33 = editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, level$6, optioner, ev$7, explainError, equiv);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$5 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Altitude");
    var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$8);
    var ev$9 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$118 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$118);
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
    var equiv$1 = new $c_s_math_Equiv$OptionEquiv(eqv);
    var $$x32 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$5, altitude$4, optioner$1, ev$9, explainError$1, equiv$1);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Longueur");
    var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
    var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$10);
    var ev$11 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$129 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$129);
    var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
    var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv$1 = $m_s_math_Equiv$DeprecatedDoubleEquiv$();
    var equiv$2 = new $c_s_math_Equiv$OptionEquiv(eqv$1);
    var $$x31 = editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$6, length$4, optioner$2, ev$11, explainError$2, equiv$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$7 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Libell\u00e9");
    var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$12 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$3 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$12);
    var ev$13 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var this$140 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
    var helper$3 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$140);
    var editorComponent$3 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$3);
    var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var eqv$2 = $m_s_math_Equiv$String$();
    var equiv$3 = new $c_s_math_Equiv$OptionEquiv(eqv$2);
    var array$4 = [$$x33, $$x32, $$x31, editorComponent$3.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$7, label$4, optioner$3, ev$13, explainError$3, equiv$3)];
    var array$5 = [$$x35, $n($$x34).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$151, null, ns)
  }));
  var this$152 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$6 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$12(this$152);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$14 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$153, f$8, step$6, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$154, ev$14).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.Rotate.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement = (function(props) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.productPrefix__T = (function() {
  return "Rotate"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.hashCode__I = (function() {
  return (-1841313413)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.toString__T = (function() {
  return "Rotate"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomNode = (function(props) {
  return this.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement(props)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$Rotate$$$anonfun$component$29__sjs_js_$bar__D__sjs_js_$bar = (function(feature, res) {
  var a = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature, res, true);
  return a
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$Rotate$$$anonfun$component$32__Ltypings_ol_interactionModifyMod$ModifyEvent__V = (function(e) {
  var features = e.features;
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var $$x3 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
  var $$x2 = new $c_sjsr_AnonFunction0((() => {
    var array = features.getArray();
    return $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array))
  }));
  var $$x1 = new $c_sjsr_AnonFunction1(((feature$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$().uploadFeature__Ltypings_ol_featureMod$default__s_concurrent_Future(feature$2))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))));
  var this$7 = $m_sc_BuildFrom$();
  var cb = $n($$x4).map$extension__F1__F1__F1($n($$x3).traverse__F0__F1__sc_BuildFrom__F1($$x2, $$x1, new $c_sc_BuildFromLowPriority2$$anon$11(this$7)), new $c_sjsr_AnonFunction1(((x$101$2) => {
    $as_sci_Seq(x$101$2)
  })));
  var this$ = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(cb);
  var this$9 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$9)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$Rotate$$$anonfun$component$37__Ltypings_ol_interactionDrawMod$DrawEvent__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ltypings_ol_interactionMod$Draw__V = (function(e, levelRef$1, altitudeRef$1, labelRef$1, p$1, drawInteraction$1) {
  var feature = e.feature;
  var $$x4 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$();
  $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
  var $$x3 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
  var this$5 = $n(levelRef$1);
  var $$x2 = $as_s_Option($n($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(this$5.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var this$6 = $n(altitudeRef$1);
  var $$x1 = $as_s_Option($n($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(this$6.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var this$7 = $n(labelRef$1);
  $n($$x4).setData__sjs_js_$bar__O__V(feature, new $c_Lreactbuild_model_MapFeature$Measure($$x3, $$x2, $$x1, $as_s_Option($n($as_Ljapgolly_scalajs_react_extra_StateSnapshotF(this$7.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
  var cb = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(($n($n(p$1).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_feature.getSource().removeFeature(feature), (void 0))), new $c_sjsr_AnonFunction1(((x$102$2) => {
    $as_jl_Void(x$102$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$().uploadFeature__Ltypings_ol_featureMod$default__s_concurrent_Future(feature))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((result$2) => {
      $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default().addFeature(result$2)
    }))))
  })));
  var this$ = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(cb);
  var this$11 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$11);
  drawInteraction$1.abortDrawing()
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.Rotate$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Rotate$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$__f_title = "S\u00e9lectionner des parcelles";
  var this$61 = $m_Lcom_iz2use_react_hooks_package$();
  var this$3 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$().Lreactbuild_analyze_cost_modules_mapview_openlayers_Map$__f_context;
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$5 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$3, ctx, step)));
  var ctx$1 = $m_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$().Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$__f_context;
  var this$4 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$4);
  var this$20 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$5, ctx$1, step$1)));
  var deps = new $c_sjsr_AnonFunction3(((props$2, x$4$2, parcelSelection$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$2);
    $as_s_Option(x$4$2);
    var parcelSelection = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(parcelSelection$2);
    return $ct_T2__O__O__(new $c_T2(), $n(props).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init, $n(parcelSelection).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
  }));
  var callback = new $c_sjsr_AnonFunction3(((props$3$2, mapCtx$2, parcelSelection$3$2) => {
    var props$3 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$3$2);
    $as_s_Option(mapCtx$2);
    var parcelSelection$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(parcelSelection$3$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      $as_T2(x$5$2);
      return new $c_sjsr_AnonFunction1(((ev$2) => {
        var $$x3 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev$2.dragging)))), new $c_sjsr_AnonFunction1(((x$9$2) => {
          $as_jl_Void(x$9$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => $n($n(props$3).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init).getParcelSource__s_Option()))), new $c_sjsr_AnonFunction1(((parcelSource$2) => new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$().getParcelAtPixel__s_Option__sjs_js_Array__F0($n($n(props$3).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init).getParcelSource__s_Option(), ev$2.coordinate), new $c_sjsr_AnonFunction1(((f$2) => {
            var f = $as_sci_List(f$2);
            $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
            var this$12 = $n(parcelSelection$3);
            var mod = new $c_sjsr_AnonFunction1(((x$6$2) => {
              var x$6 = $as_sci_List(x$6$2);
              var this$7 = $m_Lcom_iz2use_common_package$();
              var $$x2 = new $c_Lcom_iz2use_common_TraversableImplicits$RichCollection(this$7, x$6);
              $m_Lreactbuild_model_Implicits$();
              var reuse = $m_Lreactbuild_analyze_cost_modules_mapview_Parcel$().Lreactbuild_analyze_cost_modules_mapview_Parcel$__f_reusabilityParcel;
              var this$9 = $m_sci_List$();
              var this$11 = $n($$x2.toggleTraversable__sci_List__F2__sc_Factory__sci_Seq(f, reuse, new $c_sc_IterableFactory$ToFactory(this$9)));
              var f$1 = new $c_sjsr_AnonFunction1(((x$7$2) => {
                var x$7 = $as_Lreactbuild_analyze_cost_modules_mapview_Parcel(x$7$2);
                return $n(x$7).Lreactbuild_analyze_cost_modules_mapview_Parcel__f_uniqueId
              }));
              var ord = $m_s_math_Ordering$String$();
              return $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$11, f$1, ord))
            }));
            var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$12, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
            var f$3 = new $c_sjsr_AnonFunction1(((x$8$2) => {
              $as_jl_Void(x$8$2)
            }));
            var this$14 = $n(this$);
            var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$14, f$3);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
          }))))))))
        })));
        var this$16 = $m_s_$less$colon$less$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x3).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline($$x1, this$16.s_$less$colon$less$__f_singleton))
      }))
    }))
  }));
  var this$18 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var a = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$18, Z);
  var r = $m_Ljapgolly_scalajs_react_Reusability$().tuple2__F2__F2__F2($m_Lreactbuild_analyze_cost_modules_MapLogic$Init$().Lreactbuild_analyze_cost_modules_MapLogic$Init$__f_reuseInit, $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Lreactbuild_analyze_cost_modules_mapview_Parcel$().Lreactbuild_analyze_cost_modules_mapview_Parcel$__f_reusabilityParcel));
  var this$19 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$19);
  var this$37 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackWithDepsBy__O__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$20, deps, callback, a, r, step$2)));
  var deps$1 = new $c_sjsr_AnonFunction4(((props$4$2, x$10$2, x$11$2, x$12$2) => {
    var props$4 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$4$2);
    $as_s_Option(x$10$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$11$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$12$2);
    return $n(props$4).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init
  }));
  var callback$1 = new $c_sjsr_AnonFunction4(((props$5$2, mapCtx$3$2, x$13$2, x$14$2) => {
    var props$5 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$5$2);
    $as_s_Option(mapCtx$3$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$13$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$14$2);
    return new $c_sjsr_AnonFunction1(((x$15$2) => {
      $as_Lreactbuild_analyze_cost_modules_MapLogic$Init(x$15$2);
      return new $c_sjsr_AnonFunction1(((ev$2$1) => {
        var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).unless__F0__F0(new $c_sjsr_AnonFunction0((() => $uZ(ev$2$1.dragging)))), new $c_sjsr_AnonFunction1(((x$18$2) => {
          $as_jl_Void(x$18$2);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().map$extension__F0__F1__Ljapgolly_scalajs_react_callback_CallbackTo$MapGuard__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => $n($n(props$5).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init).getParcelSource__s_Option()))), new $c_sjsr_AnonFunction1(((parcelSource$2$1) => {
            var map = ev$2$1.map;
            var array = parcelSource$2$1.getFeaturesAtCoordinate(map.getCoordinateFromPixel(ev$2$1.pixel));
            var this$22 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
            $m_sci_List$();
            var features = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$22);
            var source = $n($n(props$5).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_sources).Lreactbuild_analyze_cost_modules_mapview_MapInteractionLayers__f_hover.getSource();
            return new $c_T4(parcelSource$2$1, map, features, source)
          })), null), new $c_sjsr_AnonFunction1(((x$17$2) => {
            var x$17 = $as_T4(x$17$2);
            if ((x$17 !== null)) {
              var features$1 = $as_sci_List($n(x$17).T4__f__3);
              var source$1 = $n(x$17).T4__f__4;
              $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
              $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
              var f$4 = new $c_sjsr_AnonFunction0((() => {
                $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().updateFeatureList__Ltypings_ol_sourceVectorMod$default__sci_Seq__V(source$1, features$1)
              }));
              var f$5 = new $c_sjsr_AnonFunction0((() => {
                f$4.apply__O()
              }));
              $m_Ljapgolly_scalajs_react_callback_Trampoline$();
              var this$$1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$5);
              var f$6 = new $c_sjsr_AnonFunction1(((x$16$2) => {
                $as_jl_Void(x$16$2)
              }));
              var c$1 = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$$1, f$6);
              var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c$1)
            } else {
              var $$x5;
              throw new $c_s_MatchError(x$17)
            };
            return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($$x5)
          }))))
        })));
        var this$33 = $m_s_$less$colon$less$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x6).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline($$x4, this$33.s_$less$colon$less$__f_singleton))
      }))
    }))
  }));
  var this$35 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg$();
  var Z$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
  var a$1 = $f_Ljapgolly_scalajs_react_hooks_UseCallbackArgInstances__c1__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg(this$35, Z$1);
  var r$1 = $m_Lreactbuild_analyze_cost_modules_MapLogic$Init$().Lreactbuild_analyze_cost_modules_MapLogic$Init$__f_reuseInit;
  var this$36 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$36);
  var this$48 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useCallbackWithDepsBy__O__O__Ljapgolly_scalajs_react_hooks_Hooks$UseCallbackArg__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$37, deps$1, callback$1, a$1, r$1, step$3)));
  var deps$2 = new $c_sjsr_AnonFunction5(((x$19$2, mapCtx$4$2, x$20$2, clickCallback$2, x$21$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$19$2);
    var mapCtx$4 = $as_s_Option(mapCtx$4$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$20$2);
    var clickCallback = $as_Ljapgolly_scalajs_react_Reusable(clickCallback$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$21$2);
    return $ct_T2__O__O__(new $c_T2(), mapCtx$4, clickCallback)
  }));
  var effect = new $c_sjsr_AnonFunction5(((x$22$2, mapCtx$5$2, x$23$2, clickCallback$3$2, x$24$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$22$2);
    var mapCtx$5 = $as_s_Option(mapCtx$5$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$23$2);
    var clickCallback$3 = $as_Ljapgolly_scalajs_react_Reusable(clickCallback$3$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$24$2);
    return new $c_sjsr_AnonFunction1(((x$25$2) => {
      $as_T2(x$25$2);
      var cb = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => mapCtx$5)), new $c_sjsr_AnonFunction1(((map$2) => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
        var f$9 = new $c_sjsr_AnonFunction0((() => {
          var key = map$2.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "click"), ((arg1$2) => {
            $m_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$().reactbuild$analyze$cost$modules$mapview$interactions$SelectParcels$$$anonfun$component$30__Ltypings_ol_mapBrowserEventMod$default__Ljapgolly_scalajs_react_Reusable__V(arg1$2, clickCallback$3)
          }));
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f$7 = new $c_sjsr_AnonFunction0((() => {
            $i_ol$002fObservable.unByKey(key)
          }));
          var f$8 = new $c_sjsr_AnonFunction0((() => {
            f$7.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$8))
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$9))
      })));
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)
    }))
  }));
  var a$2 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().optionalCallback__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__Ljapgolly_scalajs_react_util_OptionLike__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance);
  var $$x7 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$46 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableMap;
  var r$2 = $n($$x7).tuple2__F2__F2__F2(this$46.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3), $m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2());
  var this$47 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$47);
  var this$58 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$48, deps$2, effect, a$2, r$2, step$4)));
  var deps$3 = new $c_sjsr_AnonFunction5(((x$26$2, mapCtx$6$2, x$27$2, x$28$2, moveCallback$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$26$2);
    var mapCtx$6 = $as_s_Option(mapCtx$6$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$27$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$28$2);
    var moveCallback = $as_Ljapgolly_scalajs_react_Reusable(moveCallback$2);
    return $ct_T2__O__O__(new $c_T2(), mapCtx$6, moveCallback)
  }));
  var effect$1 = new $c_sjsr_AnonFunction5(((props$6$2, mapCtx$7$2, x$29$2, x$30$2, moveCallback$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$6$2);
    var mapCtx$7 = $as_s_Option(mapCtx$7$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$29$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$30$2);
    var moveCallback$3 = $as_Ljapgolly_scalajs_react_Reusable(moveCallback$3$2);
    return new $c_sjsr_AnonFunction1(((x$31$2) => {
      $as_T2(x$31$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo).traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => mapCtx$7)), new $c_sjsr_AnonFunction1(((map$2$1) => {
        $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
        var f$12 = new $c_sjsr_AnonFunction0((() => {
          var key$1 = map$2$1.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "pointermove"), ((arg1$2$1) => {
            $m_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$().reactbuild$analyze$cost$modules$mapview$interactions$SelectParcels$$$anonfun$component$38__Ltypings_ol_mapBrowserEventMod$default__Ljapgolly_scalajs_react_Reusable__V(arg1$2$1, moveCallback$3)
          }));
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f$10 = new $c_sjsr_AnonFunction0((() => {
            $i_ol$002fObservable.unByKey(key$1)
          }));
          var f$11 = new $c_sjsr_AnonFunction0((() => {
            f$10.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$11))
        }));
        $m_Ljapgolly_scalajs_react_callback_Trampoline$();
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$12))
      }))), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty))
    }))
  }));
  var a$3 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var $$x8 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$56 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3$1 = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableMap;
  var r$3 = $n($$x8).tuple2__F2__F2__F2(this$56.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3$1), $m_Ljapgolly_scalajs_react_Reusable$().reusableReusability__F2());
  var this$57 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$5 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$57);
  var this$60 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$58, deps$3, effect$1, a$3, r$3, step$5)));
  var f$13 = new $c_sjsr_AnonFunction5(((x$32$2, x$33$2, x$34$2, x$35$2, x$36$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$32$2);
    $as_s_Option(x$33$2);
    $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$34$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$35$2);
    $as_Ljapgolly_scalajs_react_Reusable(x$36$2);
    return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  }));
  var this$59 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$6 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$59);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev$4 = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$60, f$13, step$6, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$61, ev$4).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.SelectParcels.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.getParcelAtPixel__s_Option__sjs_js_Array__F0 = (function(parcelSource, coords) {
  var $$x5 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
  var $$x4 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption;
  var this$1 = $n($n(parcelSource).toList__sci_List());
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = $n(rest).head__O();
    var array = arg1.getFeaturesAtCoordinate(coords);
    var this$3 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
    $m_sci_List$();
    var this$5 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$3));
    var rest$1 = this$5;
    var h$1 = null;
    var t$1 = null;
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest$1).head__O();
      var value = arg1$1.getGeometry();
      var this$12 = $n(((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value)));
      var p = new $c_sjsr_AnonFunction1(((originalGeom$2) => {
        var x = originalGeom$2.getType();
        var y = $as_T($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeometryType.MULTI_POLYGON);
        return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
      }));
      var this$13 = new $c_s_Option$WithFilter(this$12, p);
      var this$14 = $n(this$13.s_Option$WithFilter__f_$outer);
      var p$1 = this$13.s_Option$WithFilter__f_p;
      var this$15 = $n(((this$14.isEmpty__Z() || $uZ($n(p$1).apply__O__O(this$14.get__O()))) ? this$14 : $m_s_None$()));
      if (this$15.isEmpty__Z()) {
        var $$x1 = $m_s_None$()
      } else {
        var arg1$2 = this$15.get__O();
        var g = $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().cloneObject__O__O(arg1$2);
        var a = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_MercatorProj;
        var a$1 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_Lambert93Proj;
        g.transform(a, a$1);
        var $$x1 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), arg1$2, g))
      };
      var this$22 = $n($$x1);
      if (this$22.isEmpty__Z()) {
        var $$x2 = $m_s_None$()
      } else {
        var arg1$3 = this$22.get__O();
        var x$2 = $as_T2(arg1$3);
        if ((x$2 === null)) {
          throw new $c_s_MatchError(x$2)
        };
        var realGeom = $n(x$2)._2__O();
        var value$1 = arg1$1.get("idu");
        var this$28 = $n(((value$1 === (void 0)) ? $m_s_None$() : new $c_s_Some(value$1)));
        if (this$28.isEmpty__Z()) {
          var $$x3 = $m_s_None$()
        } else {
          var arg1$4 = this$28.get__O();
          var idu = $as_T(arg1$4);
          var area = $uD(realGeom.getArea());
          var $$x3 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), idu, area))
        };
        var this$29 = $n($$x3);
        if (this$29.isEmpty__Z()) {
          var $$x2 = $m_s_None$()
        } else {
          var arg1$5 = this$29.get__O();
          var x$1 = $as_T2(arg1$5);
          if ((x$1 === null)) {
            throw new $c_s_MatchError(x$1)
          };
          var idu$1 = $as_T($n(x$1)._1__O());
          var area$1 = $n(x$1)._2$mcD$sp__D();
          var $$x2 = new $c_s_Some(new $c_Lreactbuild_analyze_cost_modules_mapview_Parcel(idu$1, area$1, arg1$1))
        }
      };
      var it = $n($$x2).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t$1 === null)) {
          h$1 = nx
        } else {
          $n(t$1).sci_$colon$colon__f_next = nx
        };
        t$1 = nx
      };
      rest$1 = $as_sci_List($n(rest$1).tail__O())
    };
    var it$1 = $n(((h$1 === null) ? $m_sci_Nil$() : h$1)).iterator__sc_Iterator();
    while ($n(it$1).hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon($n(it$1).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1
      } else {
        $n(t).sci_$colon$colon__f_next = nx$1
      };
      t = nx$1
    };
    rest = $as_sci_List($n(rest).tail__O())
  };
  return $n($$x5).filterNot$extension__F0__F1__F0($n($$x4).pure__O__F0(((h === null) ? $m_sci_Nil$() : h)), new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_sci_List(x$3$2);
    return $n(x$3).isEmpty__Z()
  })))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement = (function(props) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.productPrefix__T = (function() {
  return "SelectParcels"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.hashCode__I = (function() {
  return 728973518
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.toString__T = (function() {
  return "SelectParcels"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomNode = (function(props) {
  return this.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement(props)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$SelectParcels$$$anonfun$component$30__Ltypings_ol_mapBrowserEventMod$default__Ljapgolly_scalajs_react_Reusable__V = (function(ev, clickCallback$1) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(clickCallback$1).value__O())).apply__O__O(ev))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$SelectParcels$$$anonfun$component$38__Ltypings_ol_mapBrowserEventMod$default__Ljapgolly_scalajs_react_Reusable__V = (function(ev, moveCallback$1) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(moveCallback$1).value__O())).apply__O__O(ev))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.SelectParcels$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_SelectParcels$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_state = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_chooseUploadOrTakePicture = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_reusePictureTaken = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_title = "Prendre des photos";
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_state = new $c_sjsr_AnonFunction2(((state$2, action$2) => {
    var state = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(state$2);
    var action = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action(action$2);
    if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture)) {
      var x2 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture(action);
      var pictureTaken = $n(x2).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture__f_pictureTaken;
      var rassoc$1 = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved(pictureTaken);
      var this$2 = $n($n(state).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken);
      var x$1 = new $c_sci_$colon$colon(rassoc$1, this$2);
      var this$3 = $n(state);
      var x$2 = this$3.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      var this$4 = $n(state);
      var x$3 = this$4.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
      var this$5 = $n(state);
      var x$4 = this$5.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      var this$6 = $n(state);
      var x$5 = this$6.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
      var this$7 = $n(state);
      var x$6 = this$7.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive;
      var this$8 = $n(state);
      var x$7 = this$8.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
      $n(state);
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(x$2, x$3, x$4, x$1, x$5, x$6, x$7)
    } else if (false) {
      var x3 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$RemovePicture(action);
      var id = $n(x3).id__ju_UUID();
      var this$10 = $n($n(state).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken);
      var p = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
        var x$1$2 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(x$1$2$2);
        var x = $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken($n(x$1$2).value__O())).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id;
        return ((x === null) ? (id === null) : $n(x).equals__O__Z(id))
      }));
      var x$8 = $p_sci_List__filterCommon__F1__Z__sci_List(this$10, p, true);
      var this$11 = $n(state);
      var x$9 = this$11.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      var this$12 = $n(state);
      var x$10 = this$12.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
      var this$13 = $n(state);
      var x$11 = this$13.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      var this$14 = $n(state);
      var x$12 = this$14.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
      var this$15 = $n(state);
      var x$13 = this$15.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive;
      var this$16 = $n(state);
      var x$14 = this$16.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
      $n(state);
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(x$9, x$10, x$11, x$8, x$12, x$13, x$14)
    } else if (false) {
      var x4 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetProject(action);
      var project = $n(x4).project__s_Option();
      $n(state);
      var this$18 = $n(state);
      var yawOffset = this$18.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
      var this$19 = $n(state);
      var pointSet = this$19.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      var this$20 = $n(state);
      var pictureTaken$1 = this$20.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken;
      var this$21 = $n(state);
      var showImage = this$21.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
      var this$22 = $n(state);
      var cameraActive = this$22.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive;
      var this$23 = $n(state);
      var uploadedImage = this$23.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(project, yawOffset, pointSet, pictureTaken$1, showImage, cameraActive, uploadedImage)
    } else if (false) {
      var x5 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetYawOffset(action);
      var yawOffsetOpt = $n(x5).yawOffsetOpt__s_Option();
      var this$25 = $n(state);
      var x$16 = this$25.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      var this$26 = $n(state);
      var x$17 = this$26.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      var this$27 = $n(state);
      var x$18 = this$27.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken;
      var this$28 = $n(state);
      var x$19 = this$28.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
      var this$29 = $n(state);
      var x$20 = this$29.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive;
      var this$30 = $n(state);
      var x$21 = this$30.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
      $n(state);
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(x$16, yawOffsetOpt, x$17, x$18, x$19, x$20, x$21)
    } else if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint)) {
      var x6 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint(action);
      var point = $n(x6).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint__f_point;
      var this$32 = $n(state);
      var x$23 = this$32.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      var this$33 = $n(state);
      var x$24 = this$33.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
      var this$34 = $n(state);
      var x$25 = this$34.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken;
      var this$35 = $n(state);
      var x$26 = this$35.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
      var this$36 = $n(state);
      var x$27 = this$36.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive;
      var this$37 = $n(state);
      var x$28 = this$37.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
      $n(state);
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(x$23, x$24, point, x$25, x$26, x$27, x$28)
    } else if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage)) {
      var x7 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage(action);
      var image = $n(x7).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage__f_image;
      var this$39 = $n(state);
      var x$30 = this$39.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      var this$40 = $n(state);
      var x$31 = this$40.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
      var this$41 = $n(state);
      var x$32 = this$41.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      var this$42 = $n(state);
      var x$33 = this$42.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken;
      var this$43 = $n(state);
      var x$34 = this$43.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive;
      var this$44 = $n(state);
      var x$35 = this$44.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
      $n(state);
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(x$30, x$31, x$32, x$33, image, x$34, x$35)
    } else if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera)) {
      var x8 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera(action);
      var active = $n(x8).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera__f_active;
      var this$46 = $n(state);
      var x$37 = this$46.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      var this$47 = $n(state);
      var x$38 = this$47.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
      var this$48 = $n(state);
      var x$39 = this$48.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      var this$49 = $n(state);
      var x$40 = this$49.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken;
      var this$50 = $n(state);
      var x$41 = this$50.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
      var this$51 = $n(state);
      var x$42 = this$51.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
      $n(state);
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(x$37, x$38, x$39, x$40, x$41, active, x$42)
    } else if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState)) {
      var x9 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState(action);
      var v = $n(x9).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState__f_pictureTaken;
      var this$53 = $n($n(state).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken);
      var p$1 = new $c_sjsr_AnonFunction1(((x$2$2$2) => {
        var x$2$2 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(x$2$2$2);
        var x$15 = $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken($n(x$2$2).value__O())).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id;
        var x$3$1 = $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken($n(v).value__O())).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id;
        return ((x$15 === null) ? (x$3$1 === null) : $n(x$15).equals__O__Z(x$3$1))
      }));
      var x1$2 = $f_sc_LinearSeqOps__indexWhere__F1__I__I(this$53, p$1, 0);
      if ((x1$2 === (-1))) {
        var this$54 = $n($n(state).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken);
        var nextList = new $c_sci_$colon$colon(v, this$54)
      } else {
        var this$56 = $n($n(state).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken);
        var this$55 = $n($m_s_package$().s_package$__f_Nil);
        var other = new $c_sci_$colon$colon(v, this$55);
        var nextList = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$56, x1$2, other, 1))
      };
      var this$57 = $n(state);
      var x$44 = this$57.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_projectOptions;
      var this$58 = $n(state);
      var x$45 = this$58.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_yawOffset;
      var this$59 = $n(state);
      var x$46 = this$59.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pointSet;
      var this$60 = $n(state);
      var x$47 = this$60.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
      var this$61 = $n(state);
      var x$48 = this$61.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive;
      var this$62 = $n(state);
      var x$49 = this$62.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_uploadedImage;
      $n(state);
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(x$44, x$45, x$46, nextList, x$47, x$48, x$49)
    } else {
      throw new $c_s_MatchError(action)
    }
  }));
  var this$66 = $m_Lcom_iz2use_react_hooks_package$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var v$1 = "div";
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_chooseUploadOrTakePicture = $n($f_Lcom_iz2use_react_hooks_HooksApiExt__richerHtmlTagOf__T__Lcom_iz2use_react_hooks_StyledComponent$RichTagOf(this$66, v$1)).styled__F1__Lsourcecode_Name__Ljapgolly_scalajs_react_vdom_TagOf(new $c_sjsr_AnonFunction1(((dsl$2) => {
    var dsl = $as_Lscalacss_internal_DslBase(dsl$2);
    var $$x3 = $m_s_package$().s_package$__f_Seq;
    $n(dsl);
    var this$68 = $m_Lscalacss_internal_Attrs$display$();
    var $$x2 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$68.Lscalacss_internal_Attrs$display$__f_attr, "flex")));
    $n(dsl);
    var this$70 = $m_Lscalacss_internal_Attrs$flexDirection$();
    var $$x1 = new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$70.Lscalacss_internal_Attrs$flexDirection$__f_attr, "row")));
    $n(dsl);
    var this$80 = $m_Lscalacss_internal_Attrs$gap$();
    $n(dsl);
    $n(dsl);
    var this$ = 1;
    var u = $m_Lscalacss_internal_LengthUnit$em$();
    var f$1 = new $c_Lscalacss_internal_Length(this$, u);
    $n(dsl);
    $n(dsl);
    var ab = $m_Lscalacss_internal_ValueT$Rule$().apply__F1__Lscalacss_internal_ValueT$Rule(new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3$3 = $as_Lscalacss_internal_Length(x$3$2);
      return $n(x$3$3).value__T()
    })));
    $n(dsl);
    var f = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$1 = $as_Lscalacss_internal_ValueT(x$1$2$1);
      return $n(x$1$1)
    }));
    var bc = new $c_Lscalacss_internal_ValueT$Rule$$anon$1(f);
    var r = $n(ab).$greater$greater__Lscalacss_internal_ValueT$Rule__Lscalacss_internal_ValueT$Rule(bc);
    var both = $n(r).apply__O__Lscalacss_internal_ValueT(f$1);
    var v$2 = $n(both).Lscalacss_internal_ValueT__f_value;
    var array = [$$x2, $$x1, new $c_Lscalacss_internal_DslBase$ToStyle($n(dsl).ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS(new $c_Lscalacss_internal_AV(this$80.Lscalacss_internal_Attrs$gap$__f_attr, v$2)))];
    return $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
  })), new $c_Lsourcecode_Name("chooseUploadOrTakePicture"));
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f$2 = new $c_sjsr_AnonFunction1(((x$3$2$1) => {
    var x$3$4 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken(x$3$2$1);
    return $n(x$3$4).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id
  }));
  var this$84 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r$1 = this$84.by_$eq$eq__F2();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_reusePictureTaken = $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r$1, f$2);
  var this$167 = $m_Lcom_iz2use_react_hooks_package$();
  var this$94 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var reducer = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_state;
  var initialState = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State($m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_package$().s_package$__f_Nil, $m_s_None$(), false, $m_s_None$())));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$96 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducer__F2__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$94, reducer, initialState, step)));
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$().Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$__f_Context;
  var this$95 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$95);
  var this$110 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$96, ctx, step$1)));
  var deps = new $c_sjsr_AnonFunction3(((p$2, state$3$2, x$4$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$3$2);
    $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(x$4$2);
    var this$97 = $n(state$3);
    return $n($n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(this$97.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_pictureTaken).find__F1__s_Option(new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(x$5$2);
      var x$22 = $n(x$5$1).state__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState();
      var x$2$1 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$();
      if ((x$22 !== null)) {
        var this$98 = $n(x$22);
        return (this$98 === x$2$1)
      } else {
        return false
      }
    })))
  }));
  var effect = new $c_sjsr_AnonFunction3(((p$3$2, state$4$2, dbCtx$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$3$2);
    var state$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$4$2);
    var dbCtx = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(dbCtx$2);
    return new $c_sjsr_AnonFunction1(((opt$2) => {
      var opt = $as_s_Option(opt$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).traverseOption__F0__F1__Ljapgolly_scalajs_react_callback_Trampoline(new $c_sjsr_AnonFunction0((() => opt)), new $c_sjsr_AnonFunction1(((v$2$1) => {
        var v$3 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(v$2$1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(dbCtx).withTransaction__Lorg_scalajs_dom_IDBTransactionMode__F1__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($m_Lorg_scalajs_dom_IDBTransactionMode$().Lorg_scalajs_dom_IDBTransactionMode$__f_readwrite, new $c_sjsr_AnonFunction1(((tx$2) => {
          var tx = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_DataStoreTransaction(tx$2);
          var item = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken($n(v$3).value__O());
          var file = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File(new $c_Lreactbuild_common_model_RefTo($n(item).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_id), $as_T($n(item).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_capture.type), $n(item).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_capture);
          var feature = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())), $m_s_Option$().apply__O__s_Option(file.Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File__f__id), $n(item).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_position, $n(item).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_geolocation, $n(item).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_orientation, $n(item).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PictureTaken__f_instant);
          var $$x5 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
          var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          $m_Ljapgolly_scalajs_react_Reusable$();
          var r$2 = $n(state$4).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending(item)));
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x5).flatMap$extension__F1__F1__F1($n($$x4).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$2).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$9$2) => {
            $as_jl_Void(x$9$2);
            return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $n(tx).put__O__s_reflect_ClassTag__s_concurrent_Future(file, new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$File.getClassOf())))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((x$8$2) => {
              $as_jl_Void(x$8$2);
              return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $n(tx).put__O__s_reflect_ClassTag__s_concurrent_Future(feature, new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$Feature.getClassOf())))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((x$7$2) => {
                $as_jl_Void(x$7$2);
                var $$x7 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
                var $$x6 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
                $m_Ljapgolly_scalajs_react_Reusable$();
                var r$3 = $n(state$4).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved(item)));
                return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x7).map$extension__F1__F1__F1($n($$x6).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$3).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$6$2) => {
                  $as_jl_Void(x$6$2)
                }))))
              }))))
            }))))
          }))))
        })), $m_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$()))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr))
      }))))
    }))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().unit__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$108 = $m_Ljapgolly_scalajs_react_Reusability$();
  var evidence$3 = this.reusablePotUpload__F2__F2(this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_reusePictureTaken);
  var r$4 = this$108.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3);
  var this$109 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$109);
  var this$166 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectWithDepsBy__O__O__F1__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$110, deps, effect, a, r$4, step$2)));
  var f$3 = new $c_sjsr_AnonFunction3(((p$4$2, state$5$2, x$10$2) => {
    var p$4 = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$4$2);
    var state$5 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$5$2);
    $as_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalDatabase(x$10$2);
    var childProps = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps(p$4, state$5);
    var this$164 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var u$1 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_PositionOnMap$().apply__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(childProps);
    var this$112 = $n(u$1);
    var n = this$112.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x20 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var this$114 = $n(state$5);
    var x1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(this$114.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0]);
    matchEnd18$1: {
      var $$x10;
      if ((x1 !== null)) {
        var p6 = $n(x1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_showImage;
        if ((p6 instanceof $c_s_Some)) {
          var x9$1 = $as_s_Some(p6);
          var showImage$1 = $as_Lreactbuild_model_MapFeature$Image($n(x9$1).s_Some__f_value);
          var this$129 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
          var $$x15 = $m_Lcom_iz2use_react_components_Button$();
          $m_Ljapgolly_scalajs_react_Reusable$();
          var r$5 = $n(state$5).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage($m_s_None$()));
          var $$x14 = $n($n($$x15).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$5).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline));
          var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("fermer"))];
          var $$x13 = $n($$x14).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
          var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          var this$121 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          var $$x11 = $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T(this$121);
          var array$2 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("/api/file/" + $n($n(showImage$1).Lreactbuild_model_MapFeature$Image__f_file).Lreactbuild_common_model_RefTo__f_id), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("100%", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
          var array$3 = [$$x13, $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
          var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
          var $$x10 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$129, null, ns);
          break matchEnd18$1
        }
      };
      if ((x1 !== null)) {
        var p15 = $n(x1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State__f_cameraActive;
        if ((p15 === false)) {
          var $$x19 = $n($m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$().Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_chooseUploadOrTakePicture);
          var u$2 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadImage$().apply__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(childProps);
          var this$131 = $n(u$2);
          var n$1 = this$131.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
          var $$x18 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
          var $$x17 = $m_Lcom_iz2use_react_components_Button$();
          $m_Ljapgolly_scalajs_react_Reusable$();
          var r$6 = $n(state$5).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera(true));
          var $$x16 = $n($$x17).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r$6).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
          var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Utiliser la cam\u00e9ra, le GPS et l'orientation du t\u00e9l\u00e9phone"))];
          var array$5 = [$$x18, $n($$x16).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
          var $$x10 = $n($$x19).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
          break matchEnd18$1
        }
      };
      var this$148 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var u$3 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_CaptureArea$().apply__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(childProps);
      var this$143 = $n(u$3);
      var n$2 = this$143.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
      var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
      var $$x10 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$148, null, ns$1)
    };
    var u$4 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_PendingImages$().apply__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ChildProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(childProps);
    var this$150 = $n(u$4);
    var n$3 = this$150.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x9 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3);
    var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$154 = $n(state$5);
    var this$155 = $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$State(this$154.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0]));
    var v$4 = $m_sr_ScalaRunTime$()._toString__s_Product__T(this$155);
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$7 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
    var array$8 = [$$x20, $$x10, $$x9, $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("code", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
    var ns$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$164, null, ns$2)
  }));
  var this$165 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$165);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$166, f$3, step$3, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$167, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.reusablePotUpload__F2__F2 = (function(reusableA) {
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload(v$2);
    return $ct_T2__O__O__(new $c_T2(), $n($n(v).state__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState()).order__I(), $n(v).value__O())
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$();
  var this$2 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = $n($$x1).tuple2__F2__F2__F2(this$2.by_$eq$eq__F2(), reusableA);
  return $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomNode = (function(props) {
  var $$x2 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_RequestPermissions$();
  var $$x1 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_LocalData$();
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var u$1 = $n($$x1).apply__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n));
  var this$7 = $n(u$1);
  var n$1 = this$7.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  var u$2 = $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var this$13 = $n(u$2);
  var n$2 = this$13.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.productPrefix__T = (function() {
  return "TakePicture2"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.hashCode__I = (function() {
  return 1660532923
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.toString__T = (function() {
  return "TakePicture2"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved(value) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved__f_value = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved__f_value = value
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.value__O = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved__f_value
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.productPrefix__T = (function() {
  return "NotSaved"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved)) {
    var NotSaved$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved__f_value;
    var y = $n(NotSaved$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.state__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState = (function() {
  return $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$()
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$NotSaved"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$NotSaved;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$NotSaved", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$NotSaved;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending(value) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending__f_value = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending__f_value = value
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.value__O = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending__f_value
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.productPrefix__T = (function() {
  return "Pending"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending)) {
    var Pending$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending__f_value;
    var y = $n(Pending$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.state__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState = (function() {
  return $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$()
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$Pending"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$Pending;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$Pending", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Pending;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$__f_order = 0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$__f_order = 2
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype.order__I = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$__f_order
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype.productPrefix__T = (function() {
  return "NotSaved"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype.hashCode__I = (function() {
  return 1629553556
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype.toString__T = (function() {
  return "NotSaved"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PotUploadState$NotSaved$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$NotSaved$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$__f_order = 0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$__f_order = 1
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype.order__I = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$__f_order
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype.productPrefix__T = (function() {
  return "Pending"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype.hashCode__I = (function() {
  return 982065527
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype.toString__T = (function() {
  return "Pending"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PotUploadState$Pending$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Pending$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$__f_order = 0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$__f_order = 3
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype.order__I = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$__f_order
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype.productPrefix__T = (function() {
  return "Saved"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype.hashCode__I = (function() {
  return 79658599
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype.toString__T = (function() {
  return "Saved"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PotUploadState$Saved$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture(pictureTaken) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture__f_pictureTaken = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture__f_pictureTaken = pictureTaken
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype.productPrefix__T = (function() {
  return "PushPicture"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture__f_pictureTaken : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture)) {
    var PushPicture$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture__f_pictureTaken;
    var x$2 = $n(PushPicture$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture__f_pictureTaken;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PushPicture"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PushPicture;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$PushPicture", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PushPicture;
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$RemovePicture(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$RemovePicture"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$RemovePicture(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$RemovePicture)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$RemovePicture(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$RemovePicture(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$RemovePicture;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved(value) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved__f_value = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved__f_value = value
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.value__O = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved__f_value
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.productPrefix__T = (function() {
  return "Saved"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved)) {
    var Saved$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved__f_value;
    var y = $n(Saved$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.state__Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState = (function() {
  return $m_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUploadState$Saved$()
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$Saved"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$Saved;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$Saved", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$PotUpload: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Saved;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint(point) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint__f_point = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint__f_point = point
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype.productPrefix__T = (function() {
  return "SetPoint"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint__f_point : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint)) {
    var SetPoint$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint__f_point;
    var x$2 = $n(SetPoint$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint__f_point;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$SetPoint"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$SetPoint;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$SetPoint", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetPoint;
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetProject(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$SetProject"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetProject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetProject)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetProject(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetProject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$SetProject;", depth))
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetYawOffset(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$SetYawOffset"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetYawOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetYawOffset)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetYawOffset(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$SetYawOffset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$SetYawOffset;", depth))
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage(image) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage__f_image = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage__f_image = image
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype.productPrefix__T = (function() {
  return "ShowImage"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage__f_image : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage)) {
    var ShowImage$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage__f_image;
    var x$2 = $n(ShowImage$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage__f_image;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$ShowImage"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$ShowImage;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$ShowImage", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$ShowImage;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState(pictureTaken) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState__f_pictureTaken = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState__f_pictureTaken = pictureTaken
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype.productPrefix__T = (function() {
  return "UpdateState"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState__f_pictureTaken : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState)) {
    var UpdateState$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState__f_pictureTaken;
    var x$2 = $n(UpdateState$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState__f_pictureTaken;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$UpdateState"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$UpdateState;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$UpdateState", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UpdateState;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera(active) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera__f_active = false;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera__f_active = active
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype.productPrefix__T = (function() {
  return "UseCamera"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera__f_active : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("UseCamera");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera__f_active ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera)) {
    var UseCamera$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera(x$1);
    return (this.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera__f_active === $n(UseCamera$1).Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera__f_active)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$UseCamera"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$UseCamera;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.TakePicture2$UseCamera", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_TakePicture2$UseCamera;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$__f_title = "D\u00e9placer des \u00e9l\u00e9ments";
  var this$56 = $m_Lcom_iz2use_react_hooks_package$();
  var this$9 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$2);
    var $$x1 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$();
    $n($m_s_package$().s_package$__f_List);
    var array = [$m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default()];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($n($$x1).apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__sci_List__Z__F1(props, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), true))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$8 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$8);
  var this$13 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$9, hook, step, d)));
  var initialState = new $c_sjsr_AnonFunction2(((p$2, x$1$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$2);
    var $$x2 = $i_ol$002finteraction.Translate;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_TranslateOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    return new $$x2(_\uff3fobj)
  }));
  var this$12 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$12);
  var this$20 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$13, initialState, step$1)));
  var initialState$1 = new $c_sjsr_AnonFunction3(((p$3$2, x$2$2, x$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$3$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$3$2);
    var $$x3 = $i_ol$002finteraction.Modify;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_ModifyOptions);
    var fields$1 = $m_sci_Nil$();
    var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
    var value = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().source__Ltypings_ol_sourceVectorMod$default();
    _\uff3fobj$1.source = value;
    return new $$x3(_\uff3fobj$1)
  }));
  var this$19 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$19);
  var this$34 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$20, initialState$1, step$2)));
  var initialState$2 = new $c_sjsr_AnonFunction4(((p$4$2, snap$2, interaction$2, modifyInteraction$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$4$2);
    var interaction = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(interaction$2);
    var modifyInteraction = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(modifyInteraction$2);
    var $$x5 = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$();
    $n($m_s_package$().s_package$__f_List);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var this$21 = $n(interaction);
    var interaction$1 = this$21.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var $$x4 = new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction$1, true);
    $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$();
    var this$23 = $n(modifyInteraction);
    var interaction$3 = this$23.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var array$1 = [$$x4, new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction$3, true), ($m_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child$(), new $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(snap$2, true))];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var u = $n($$x5).apply__sci_List__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1));
    var this$31 = $n(u);
    var n = this$31.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var this$33 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$33);
  var this$52 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$34, initialState$2, step$3)));
  var effect = new $c_sjsr_AnonFunction5(((p$5$2, x$4$2, interactionState$2, modifyInteractionState$2, x$5$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$5$2);
    var interactionState = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(interactionState$2);
    var modifyInteractionState = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(modifyInteractionState$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$5$2);
    var this$35 = $n(interactionState);
    this$35.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    var this$36 = $n(modifyInteractionState);
    var modifyInteraction$1 = this$36.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0];
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackTo);
    var f = new $c_sjsr_AnonFunction0((() => {
      $n($m_s_package$().s_package$__f_List);
      var array$2 = [modifyInteraction$1.on(($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_OlStrings), "modifyend"), ((arg1$2) => {
        $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$().reactbuild$analyze$cost$modules$mapview$interactions$Translate$$$anonfun$component$7__Ltypings_ol_interactionModifyMod$ModifyEvent__V(arg1$2)
      }))];
      var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2)
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    var this$ = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f);
    var f$3 = new $c_sjsr_AnonFunction1(((registered$2) => {
      var registered = $as_sci_List(registered$2);
      $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        var this$43 = $n(registered);
        var these = this$43;
        while ((!$n(these).isEmpty__Z())) {
          var arg1 = $n(these).head__O();
          $i_ol$002fObservable.unByKey(arg1);
          these = $as_sci_List($n(these).tail__O())
        }
      }));
      var f$2 = new $c_sjsr_AnonFunction0((() => {
        f$1.apply__O()
      }));
      $m_Ljapgolly_scalajs_react_callback_Trampoline$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$3))
  }));
  var a = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseEffectArg$().cleanup__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_util_Effect$Dispatch__F1($m_Ljapgolly_scalajs_react_util_EffectCallback$callback$(), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$());
  var this$51 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$51);
  var this$55 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useEffectOnMountBy__O__F1__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$52, effect, a, step$4)));
  var f$4 = new $c_sjsr_AnonFunction5(((x$7$2, x$8$2, x$9$2, x$10$2, result$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$7$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$9$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(x$10$2);
    var result = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(result$2);
    var this$53 = $n(result);
    return $as_Ljapgolly_scalajs_react_vdom_VdomNode(this$53.Ljapgolly_scalajs_react_hooks_Hooks$UseStateF$$anon$2__f_raw[0])
  }));
  var this$54 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$5 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$54);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$55, f$4, step$5, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$56, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.Translate.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement = (function(props) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.productPrefix__T = (function() {
  return "Translate"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.hashCode__I = (function() {
  return (-1238167250)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.toString__T = (function() {
  return "Translate"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomNode = (function(props) {
  return this.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement(props)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.reactbuild$analyze$cost$modules$mapview$interactions$Translate$$$anonfun$component$7__Ltypings_ol_interactionModifyMod$ModifyEvent__V = (function(e) {
  var features = e.features;
  var $$x4 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
  var $$x3 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
  var $$x2 = new $c_sjsr_AnonFunction0((() => {
    var array = features.getArray();
    return $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array))
  }));
  var $$x1 = new $c_sjsr_AnonFunction1(((feature$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Measure$().uploadFeature__Ltypings_ol_featureMod$default__s_concurrent_Future(feature$2))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))));
  var this$7 = $m_sc_BuildFrom$();
  var cb = $n($$x4).map$extension__F1__F1__F1($n($$x3).traverse__F0__F1__sc_BuildFrom__F1($$x2, $$x1, new $c_sc_BuildFromLowPriority2$$anon$11(this$7)), new $c_sjsr_AnonFunction1(((x$6$2) => {
    $as_sci_Seq(x$6$2)
  })));
  var this$ = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().toCallback$extension__F1__Ljapgolly_scalajs_react_callback_Trampoline(cb);
  var this$9 = $n(this$);
  $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$9)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.Translate$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_Translate$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$() {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_reducer = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_reuseState = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_component = null;
  $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_title = "Ajouter un plan";
  $m_Ljapgolly_scalajs_react_Reusability$();
  var f = new $c_sjsr_AnonFunction1(((geometry$2) => {
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Util);
    return $as_T($i_ol$002futil.getUid(geometry$2))
  }));
  var this$3 = $m_Ljapgolly_scalajs_react_Reusability$();
  var r = this$3.by_$eq$eq__F2();
  $m_Ljapgolly_scalajs_react_Reusability$().contramap$extension__F2__F1__F2(r, f);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_reducer = new $c_sjsr_AnonFunction2(((state$2, action$2) => {
    var state = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(state$2);
    var action = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action(action$2);
    var x = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$();
    if ((x === action)) {
      var this$5 = $n(state);
      var x$2$2 = this$5.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents;
      $n(state);
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(x$2$2, false)
    } else if ($n(state).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading) {
      return state
    } else if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments)) {
      var x3 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments(action);
      var docs = $n(x3).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments__f_documents;
      $n(state);
      var this$7 = $n($n(state).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents);
      var documents = $as_sci_Seq($n($as_sc_SeqOps(this$7.appendedAll__sc_IterableOnce__O(docs))).distinctBy__F1__O(new $c_sjsr_AnonFunction1(((x$1$2$2) => $as_T(x$1$2$2.name)))));
      var this$8 = $n(state);
      var uploading = this$8.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading;
      return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(documents, uploading)
    } else {
      var x$3 = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$();
      if ((x$3 === action)) {
        var this$10 = $n(state);
        var x$4$2 = this$10.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents;
        $n(state);
        return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(x$4$2, true)
      } else if ((action instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument)) {
        var x5 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument(action);
        var index = $n(x5).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument__f_index;
        $n(state);
        var documents$1 = $as_sci_Seq($n($n(state).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents).patch__I__sc_IterableOnce__I__O(index, $m_s_package$().s_package$__f_Nil, 1));
        var this$12 = $n(state);
        var uploading$1 = this$12.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_uploading;
        return new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(documents$1, uploading$1)
      } else {
        throw new $c_s_MatchError(action)
      }
    }
  }));
  var this$14 = $m_Ljapgolly_scalajs_react_Reusability$();
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_reuseState = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$14.byRef__F2(), this$14.by_$eq$eq__F2());
  var this$87 = $m_Lcom_iz2use_react_hooks_package$();
  var this$19 = $n(($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent), $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$().apply__Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$First()));
  var hook = new $c_sjsr_AnonFunction1(((props$2) => {
    var props = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(props$2);
    return new $c_Ljapgolly_scalajs_react_hooks_CustomHook($m_Lreactbuild_analyze_cost_modules_mapview_interactions_WithSnap$().apply__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__sci_List__Z__F1(props, $m_s_package$().s_package$__f_Nil, true))
  }));
  var step = new $c_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$FirstStep();
  var this$18 = $m_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep$();
  var d = new $c_Ljapgolly_scalajs_react_hooks_Api$DynamicNextStepLowPri$$anon$1(this$18);
  var api = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__customBy__F1__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__Ljapgolly_scalajs_react_hooks_Api$DynamicNextStep__O(this$19, hook, step, d));
  var $$x7 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api);
  var $$x6 = new $c_sjsr_AnonFunction2(((p$2, x$2$2$1) => {
    var p = $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$2);
    return $n($n(p).Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__f_init).Lreactbuild_analyze_cost_modules_MapLogic$Init__f_layers
  }));
  var $$x5 = new $c_sjsr_AnonFunction2(((p$3$2, x$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$3$2);
    return new $c_sjsr_AnonFunction1(((a$2) => {
      var a = $as_sci_List(a$2);
      return a
    }))
  }));
  var $$x4 = $m_Ljapgolly_scalajs_react_Reusability$().list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().tuple2__F2__F2__F2($m_Lreactbuild_analyze_cost_modules_mapview_Layer$().Lreactbuild_analyze_cost_modules_mapview_Layer$__f_reusabilityLayer, $m_Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$().Lreactbuild_analyze_cost_modules_mapview_MapImports$Implicits$__f_reusableBaseLayer));
  var this$21 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$24 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($$x7.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x6, $$x5, $$x4, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$1(this$21))));
  var reducer = this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_reducer;
  var initialState = new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State($m_s_package$().s_package$__f_Nil, false)));
  var this$23 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$1 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$2(this$23);
  var api$1 = $as_Ljapgolly_scalajs_react_hooks_Api$Secondary($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useReducer__F2__F0__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$24, reducer, initialState, step$1));
  var $$x8 = new $c_Lreactbuild_hooks_HooksApiExt$Secondary(api$1);
  var $$x3 = new $c_sjsr_AnonFunction4(((x$4$2$1, x$5$2, x$6$2, state$3$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$4$2$1);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$6$2);
    var state$3 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$3$2);
    return state$3
  }));
  var $$x2 = new $c_sjsr_AnonFunction4(((x$7$2, x$8$2, x$9$2, x$10$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(x$7$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$9$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$10$2);
    return new $c_sjsr_AnonFunction1(((a$2$1) => {
      var a$1 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(a$2$1);
      return a$1
    }))
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer$().reusability__F2__F2(this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_reuseState);
  var this$26 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var this$28 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Secondary($$x8.useDerivedRefBy__O__O__F2__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O($$x3, $$x2, $$x1, new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$3(this$26))));
  var initialState$1 = new $c_sjsr_AnonFunction5(((p$4$2, snap$2, layerSelRef$2, x$11$2, stateRef$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(layerSelRef$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(x$11$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(stateRef$2)
  }));
  var this$27 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$2 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$4(this$27);
  var this$30 = $n($as_Ljapgolly_scalajs_react_hooks_Api$Primary($f_Ljapgolly_scalajs_react_hooks_Api$Secondary__useStateBy__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__O(this$28, initialState$1, step$2)));
  var ctx = $m_Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$().Lreactbuild_analyze_cost_modules_mapview_ParcelSelection$__f_context;
  var this$29 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$3 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$5(this$29);
  var this$86 = $n($as_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender($f_Ljapgolly_scalajs_react_hooks_Api$Primary__useContext__Ljapgolly_scalajs_react_feature_Context__Ljapgolly_scalajs_react_hooks_Api$AbstractStep__O(this$30, ctx, step$3)));
  var f$1 = new $c_sjsr_AnonFunction7(((p$5$2, x$12$2, x$13$2, state$4$2, x$14$2, memo$2, parcelSelection$2) => {
    $as_Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props(p$5$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$13$2);
    var state$4 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseReducer(state$4$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$14$2);
    $as_Ljapgolly_scalajs_react_hooks_Hooks$UseStateF(memo$2);
    var parcelSelection = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(parcelSelection$2);
    var submit = new $c_sjsr_AnonFunction1(((ev$2) => {
      var $$x12 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x11 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
      var $$x10 = new $c_sjsr_AnonFunction0((() => {
        var this$31 = $n(state$4);
        return $n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(this$31.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents
      }));
      var $$x9 = new $c_sjsr_AnonFunction1(((file$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$().processFile__Lorg_scalajs_dom_File__F1(file$2))));
      var this$32 = $m_sc_BuildFrom$();
      $n($$x12).map$extension__F1__F1__F1($n($$x11).traverse__F0__F1__sc_BuildFrom__F1($$x10, $$x9, new $c_sc_BuildFromLowPriority2$$anon$11(this$32)), new $c_sjsr_AnonFunction1(((doc$2) => {
        $as_sci_Seq(doc$2)
      })));
      $m_Ljapgolly_scalajs_react_package$();
      var this$34 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$34.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    }));
    var reusable = $m_Ljapgolly_scalajs_react_Reusable$fn$().apply__F1__Ljapgolly_scalajs_react_Reusable(new $c_sjsr_AnonFunction1(((fileOpt$2) => {
      var fileOpt = $as_sci_Seq(fileOpt$2);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(state$4).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments(fileOpt))).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
    })));
    var this$84 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x25 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onSubmit");
    var $$x23 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(submit, $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
    var x1 = $as_sci_List($n(parcelSelection).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var x$1 = $m_s_package$().s_package$__f_Nil;
    if (((x$1 === null) ? (x1 === null) : $n(x$1).equals__O__Z(x1))) {
      var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Utiliser 'S\u00e9lectionner des parcelles' pour pouvoir leur attacher des documents"))];
      var $$x21 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    } else {
      var this$48 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_TagMod);
      var ms = $m_sci_Nil$();
      var $$x21 = this$48.fromTraversableOnce__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod(ms)
    };
    var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x17 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var this$51 = $n(state$4);
    var as = $as_sc_IterableOnce($n($n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(this$51.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State__f_documents).zipWithIndex__O());
    var array$2 = [$n($$x17).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var file = $n(x0$1)._1__O();
        var index$1 = $n(x0$1)._2$mcI$sp__I();
        var $$x19 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var $$x18 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => $n(state$4).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument(index$1)))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().reusableDefaultSync__F1());
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v = $as_T(file.name);
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$1 = [$$x18, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
        return $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })))];
    var $$x16 = $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
    var u = $m_Lreactbuild_analyze_cost_modules_mapview_interactions_Uploader$().apply__Ljapgolly_scalajs_react_Reusable__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(reusable);
    var this$64 = $n(u);
    var n = this$64.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x15 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var $$x14 = $m_Lcom_iz2use_react_components_Button$().submit__Ljapgolly_scalajs_react_vdom_TagOf();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x13 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Envoyer");
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$71 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "disabled");
    var this$70 = $n(state$4);
    var a$3 = (!$n($as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$State(this$70.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).ready__Z());
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
    var array$3 = [$$x13, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$71.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$3)];
    var array$4 = [$$x23, $$x21, $$x16, $$x15, $n($$x14).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    var array$5 = [$n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("form", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var array$6 = [$n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$84, null, ns)
  }));
  var this$85 = $m_Ljapgolly_scalajs_react_hooks_HookComponentBuilder$ComponentP$SubsequentStep$();
  var step$4 = new $c_Ljapgolly_scalajs_react_hooks_ComponentP\uff3fSubsequentSteps$$anon$6(this$85);
  var s = $m_Ljapgolly_scalajs_react_CtorType$Summoner$().summonP__Ljapgolly_scalajs_react_internal_Singleton$Not__Ljapgolly_scalajs_react_CtorType$Summoner(($m_Ljapgolly_scalajs_react_internal_Singleton$(), null));
  var ev = $f_Ljapgolly_scalajs_react_hooks_Api$SecondaryWithRender__render__O__Ljapgolly_scalajs_react_hooks_Api$SubsequentStep__Ljapgolly_scalajs_react_CtorType$Summoner__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(this$86, f$1, step$4, s);
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_component = new $c_Lcom_iz2use_react_hooks_HooksApiExt$RichJsComponentWithRoot(this$87, ev).withDisplayName__Lsourcecode_Enclosing__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot(new $c_Lsourcecode_Enclosing("reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing.component"))
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.choosePlanProcessor__Lorg_scalajs_dom_File__T__F1 = (function(file, text) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_format_dxf_RecordCursor$().fromText__T__Lreactbuild_format_dxf_RecordCursor(text))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((cursor$2) => {
    var cursor = $as_Lreactbuild_format_dxf_RecordCursor(cursor$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => $m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => $n($m_Lreactbuild_format_dxf_File$().Lreactbuild_format_dxf_File$__f_decodeFile).apply__Lreactbuild_format_dxf_RecordCursor__s_util_Either(cursor))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((result$2) => {
      var result = $as_s_util_Either(result$2);
      var $$x2 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      if ((result instanceof $c_s_util_Left)) {
        var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).throwException__F0__F1(new $c_sjsr_AnonFunction0((() => $ct_jl_Exception__(new $c_jl_Exception()))))
      } else if ((result instanceof $c_s_util_Right)) {
        var x3 = $as_s_util_Right(result);
        var value = $as_Lreactbuild_format_dxf_CursorResult($n(x3).s_util_Right__f_value);
        var $$x1 = $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1(value)
      } else {
        var $$x1;
        throw new $c_s_MatchError(result)
      };
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x2).map$extension__F1__F1__F1($$x1, new $c_sjsr_AnonFunction1(((value$2$2) => {
        $as_Lreactbuild_format_dxf_CursorResult(value$2$2);
        $m_s_Predef$().$qmark$qmark$qmark__E()
      }))))
    }))))
  })))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.processFile__Lorg_scalajs_dom_File__F1 = (function(file) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
    var $$x1 = $m_sjs_js_Thenable$ThenableOps$();
    var p = file.text();
    return $n($$x1).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((text$2) => {
    var text = $as_T(text$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$().choosePlanProcessor__Lorg_scalajs_dom_File__T__F1(file, text), new $c_sjsr_AnonFunction1(((result$2) => {
      var result = $as_T(result$2);
      return result
    }))))
  })))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement = (function(props) {
  var c = this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$__f_component;
  var this$2 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$2.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$2.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
  var this$4 = $n(u);
  var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.productPrefix__T = (function() {
  return "UploadDrawing"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.hashCode__I = (function() {
  return (-491824451)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.toString__T = (function() {
  return "UploadDrawing"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomNode = (function(props) {
  return this.interactions__Lreactbuild_analyze_cost_modules_mapview_MapInteractions$Props__Ljapgolly_scalajs_react_vdom_VdomElement(props)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_MapInteraction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments(documents) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments__f_documents = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments__f_documents = documents
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype.productPrefix__T = (function() {
  return "AddDocuments"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments__f_documents : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments)) {
    var AddDocuments$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments__f_documents;
    var x$2 = $n(AddDocuments$1).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments__f_documents;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$AddDocuments"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$AddDocuments;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$AddDocuments", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$AddDocuments;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument(index) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument__f_index = 0;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument__f_index = index
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype.productPrefix__T = (function() {
  return "RemoveDocument"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument__f_index : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("RemoveDocument");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument)) {
    var RemoveDocument$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument(x$1);
    return (this.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument__f_index === $n(RemoveDocument$1).Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument__f_index)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$RemoveDocument"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$RemoveDocument;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$RemoveDocument", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$RemoveDocument;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype.productPrefix__T = (function() {
  return "Uploaded"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype.hashCode__I = (function() {
  return 1628635776
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype.toString__T = (function() {
  return "Uploaded"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$Uploaded$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploaded$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype.productPrefix__T = (function() {
  return "Uploading"
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype.hashCode__I = (function() {
  return (-1051894239)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype.toString__T = (function() {
  return "Uploading"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.UploadDrawing$Uploading$", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$;
var $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$;
function $m_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$ = new $c_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_interactions_UploadDrawing$Uploading$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(interaction, active) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active = false;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction = interaction;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active = active
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype.productPrefix__T = (function() {
  return "ChildProps"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ChildProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps)) {
    var ChildProps$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active === $n(ChildProps$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_active)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction;
      var y = $n(ChildProps$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps__f_interaction;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.Interactions$ChildProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.Interactions$ChildProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.Interactions$ChildProps", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$Child: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_Interactions$ChildProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps(viewPoint, when) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_viewPoint = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_when = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_origin = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_viewPoint = viewPoint;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_when = when;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_origin = "P"
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.viewPoint__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_viewPoint
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.when__D = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_when
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.origin__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_origin
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.productPrefix__T = (function() {
  return "MoveFromProps"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_viewPoint;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_when;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("MoveFromProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_viewPoint;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_when;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps)) {
    var MoveFromProps$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_when === $n(MoveFromProps$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_when)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_viewPoint;
      var x$2 = $n(MoveFromProps$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps__f_viewPoint;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewAction$MoveFromProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.ViewAction$MoveFromProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewAction$MoveFromProps", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView(viewPoint, when) {
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_viewPoint = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_when = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_origin = null;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_viewPoint = viewPoint;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_when = when;
  this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_origin = "V"
}
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.viewPoint__Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewPoint = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_viewPoint
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.when__D = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_when
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.origin__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_origin
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.productPrefix__T = (function() {
  return "MoveFromView"
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_viewPoint;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_when;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("MoveFromView");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_viewPoint;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_when;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView)) {
    var MoveFromView$1 = $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_when === $n(MoveFromView$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_when)) {
      var x = this.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_viewPoint;
      var x$2 = $n(MoveFromView$1).Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView__f_viewPoint;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewAction$MoveFromView"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.openlayers.ViewAction$MoveFromView;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView: 0
}, false, "reactbuild.analyze.cost.modules.mapview.openlayers.ViewAction$MoveFromView", {
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_openlayers_ViewAction$MoveFromView;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$() {
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_primary = null;
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_secondary = null;
  $ct_Lreactbuild_analyze_cost_modules_planner_ChronoScale__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Lreactbuild_analyze_cost_modules_planner_UnitDescription__(this, new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(1, 0), "EEEE dd LLL yyyy"), new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(1, 0), "HH'h'"))
}
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype = new $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale();
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype.productPrefix__T = (function() {
  return "Day"
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype.hashCode__I = (function() {
  return 68476
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype.toString__T = (function() {
  return "Day"
});
var $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$: 0
}, false, "reactbuild.analyze.cost.modules.planner.ChronoScale$Day$", {
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$: 1,
  Lreactbuild_analyze_cost_modules_planner_ChronoScale: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$;
var $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$;
function $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$ = new $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Day$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$() {
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_primary = null;
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_secondary = null;
  $ct_Lreactbuild_analyze_cost_modules_planner_ChronoScale__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Lreactbuild_analyze_cost_modules_planner_UnitDescription__(this, new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(1, 0), "HH'h' EEEE dd LLL yyyy"), new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(15, 0), "':'mm"))
}
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype = new $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale();
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype.productPrefix__T = (function() {
  return "Hour"
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype.hashCode__I = (function() {
  return 2255364
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype.toString__T = (function() {
  return "Hour"
});
var $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$: 0
}, false, "reactbuild.analyze.cost.modules.planner.ChronoScale$Hour$", {
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$: 1,
  Lreactbuild_analyze_cost_modules_planner_ChronoScale: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$;
var $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$;
function $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$ = new $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Hour$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$() {
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_primary = null;
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_secondary = null;
  $ct_Lreactbuild_analyze_cost_modules_planner_ChronoScale__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Lreactbuild_analyze_cost_modules_planner_UnitDescription__(this, new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(1, 0), "LLLL yyyy"), new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(1, 0), "dd E"))
}
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype = new $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale();
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype.productPrefix__T = (function() {
  return "Month"
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype.hashCode__I = (function() {
  return 74527328
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype.toString__T = (function() {
  return "Month"
});
var $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$: 0
}, false, "reactbuild.analyze.cost.modules.planner.ChronoScale$Month$", {
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$: 1,
  Lreactbuild_analyze_cost_modules_planner_ChronoScale: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$;
var $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$;
function $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$ = new $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Month$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$() {
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_primary = null;
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_secondary = null;
  $ct_Lreactbuild_analyze_cost_modules_planner_ChronoScale__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Lreactbuild_analyze_cost_modules_planner_UnitDescription__(this, new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(1, 0), "yyyy 'S'ww"), new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(1, 0), "EEE dd/MM"))
}
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype = new $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale();
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype.productPrefix__T = (function() {
  return "Week"
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype.hashCode__I = (function() {
  return 2692116
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype.toString__T = (function() {
  return "Week"
});
var $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$: 0
}, false, "reactbuild.analyze.cost.modules.planner.ChronoScale$Week$", {
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$: 1,
  Lreactbuild_analyze_cost_modules_planner_ChronoScale: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$;
var $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$;
function $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$ = new $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Week$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$() {
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_primary = null;
  this.Lreactbuild_analyze_cost_modules_planner_ChronoScale__f_secondary = null;
  $ct_Lreactbuild_analyze_cost_modules_planner_ChronoScale__Lreactbuild_analyze_cost_modules_planner_UnitDescription__Lreactbuild_analyze_cost_modules_planner_UnitDescription__(this, new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(1, 0), "yyyy"), new $c_Lreactbuild_analyze_cost_modules_planner_UnitDescription($m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit(), new $c_RTLong(1, 0), "LLL"))
}
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype = new $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale();
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype.productPrefix__T = (function() {
  return "Year"
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype.hashCode__I = (function() {
  return 2751581
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype.toString__T = (function() {
  return "Year"
});
var $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$: 0
}, false, "reactbuild.analyze.cost.modules.planner.ChronoScale$Year$", {
  Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$: 1,
  Lreactbuild_analyze_cost_modules_planner_ChronoScale: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$;
var $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$;
function $m_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$ = new $c_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_ChronoScale$Year$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_PlannerContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  if ((ev instanceof $c_Lreactbuild_common_components_Input$WheelEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$WheelEvent(ev);
    var coords = $n(x2).Lreactbuild_common_components_Input$WheelEvent__f_coords;
    var deltaY = $n(x2).Lreactbuild_common_components_Input$WheelEvent__f_deltaY;
    var deltaMode = $n(x2).Lreactbuild_common_components_Input$WheelEvent__f_deltaMode;
    var delta = ((deltaMode === $uI(WheelEvent.DOM_DELTA_LINE)) ? (40.0 * deltaY) : deltaY);
    var f = (delta / 300.0);
    var factor = ((f === 0.0) ? 1.0 : ((f < 0.0) ? (1.0 / (1.0 - f)) : (1.0 + f)));
    return new $c_Lreactbuild_common_components_Done(this, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(context).Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_zoomAndTranslate).apply__O__O__O__O__O($n(coords).Lreactbuild_common_components_Input$Coords__f_x, factor, 0.0, 0.0))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  } else {
    return $m_Lreactbuild_common_components_Skip$()
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.productPrefix__T = (function() {
  return "MouseWheelZoom"
});
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.hashCode__I = (function() {
  return 1249068745
});
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.toString__T = (function() {
  return "MouseWheelZoom"
});
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return this.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_PlannerContext__Lreactbuild_common_components_InteractionResult(ev, trackedPointers, $as_Lreactbuild_analyze_cost_modules_planner_PlannerContext(context))
});
var $d_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$: 0
}, false, "reactbuild.analyze.cost.modules.planner.MouseWheelZoom$", {
  Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$;
var $n_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$;
function $m_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$ = new $c_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_MouseWheelZoom$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(active, withSubprojects) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects = false;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_title = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_active = active;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects = withSubprojects;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_title = "Prix de revient"
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_title
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply__Ldiode_data_Pot__F0__F1__Ljapgolly_scalajs_react_vdom_VdomNode(projectPot, new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode())), new $c_sjsr_AnonFunction1(((project$2) => {
    var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(project$2);
    var u$7 = $m_Lreactbuild_analyze_cost_components_PeriodProvider$().apply__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((period$2) => {
      var period = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(period$2);
      var $$x78 = $m_Lreactbuild_analyze_cost_components_ScrollBlockContainer$();
      var $$x77 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x76 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
      var $$x75 = this$7.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var this$8 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
      var $$x74 = this$8.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x73 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x72 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Inclure tous les sous-projets");
      var $$x69 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
      $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
      var value = this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects;
      var state = $n($$x69).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
        var x0$1 = $as_s_Option(x0$1$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        matchEnd7: {
          var $$x70;
          var p2 = $as_s_Option(x1.T2__f__1);
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x = $m_s_None$();
          if ((x === p2)) {
            var $$x70 = cb;
            break matchEnd7
          };
          var p4 = $as_s_Option(x1.T2__f__1);
          var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          if ((p4 instanceof $c_s_Some)) {
            var x5 = $as_s_Some(p4);
            var v = $uZ($n(x5).s_Some__f_value);
            var $$x71 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var this$14 = $n($n(pageProps).Lreactbuild_package$PageProps__f_router);
            var active = new $c_s_Some($n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id);
            var route = new $c_Lreactbuild_Loc$Project(new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(active, v));
            var $$x70 = $n($$x71).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$14.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2);
            break matchEnd7
          };
          throw new $c_s_MatchError(x1)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x70)
      })));
      var evDefault = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
      var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
      var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
      var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
      var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
      var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var equiv = $m_s_math_Equiv$Boolean$();
      var this$19 = $n(editorComponent);
      var array = [this$19.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv)];
      var $$x68 = $n($$x72).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      var u = $m_Lreactbuild_analyze_cost_components_PeriodSelector$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(period);
      var this$24 = $n(u);
      var n = this$24.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$1 = [$$x75, $$x74, $$x73, $$x68, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
      var $$x67 = $n($$x76).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var $$x66 = $m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment;
      var a = (("" + $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id) + this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects);
      var $$x65 = $m_Lcom_iz2use_react_components_Media$();
      var this$79 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var $$x64 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Co\u00fbt du travail"))];
      var $$x63 = $n($$x64).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h3", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var $$x62 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
      var $$x57 = new $c_sjsr_AnonFunction0((() => {
        var this$39 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x61 = new $c_Lautowire_ClientProxy(this$39).Lautowire_ClientProxy__f_self;
        var $$x60 = $m_s_package$().s_package$__f_Seq;
        var array$3 = ["reactbuild", "project", "ProjectApi", "listPriceByDateAndBuildingStageForBuildingSite"];
        var $$x59 = $as_sci_Seq($n($$x60).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)));
        var this$54 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$44 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$45 = $n(new $c_Lautowire_ClientProxy(this$44).Lautowire_ClientProxy__f_self);
        var r = $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id;
        var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
        var y = this$45.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
        var $$x58 = $ct_T2__O__O__(new $c_T2(), "project", y);
        var this$48 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$49 = $n(new $c_Lautowire_ClientProxy(this$48).Lautowire_ClientProxy__f_self);
        var r$1 = this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects;
        var evidence$2$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
        var y$1 = this$49.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
        var array$4 = [$$x58, $ct_T2__O__O__(new $c_T2(), "withSubprojects", y$1)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
        return $n($n($$x61).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x59, this$54.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1 = $as_Lio_circe_Json(x$1$2);
          var this$55 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$60 = $n(new $c_Lautowire_ClientProxy(this$55).Lautowire_ClientProxy__f_self);
          var this$59 = $m_Lreactbuild_model_package$();
          $m_s_DummyImplicit$();
          var ev$3 = new $c_Lshapeless_Refute$$anon$2();
          var this$58 = $m_Lio_circe_Decoder$();
          var decodeA0 = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
          $m_Lio_circe_Decoder$();
          var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
          var decodeA1 = new $c_Lio_circe_Decoder$$anon$39(d);
          var decodeK = new $c_Lio_circe_TupleDecoders$$anon$2(this$58, decodeA0, decodeA1);
          var decodeV = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
          var evidence$1 = $f_Lreactbuild_common_CirceExtendedImplicits__decodeOtherMap__Lshapeless_Refute__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder(this$59, ev$3, decodeK, decodeV);
          return $as_sci_Map(this$60.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      }));
      var $$x46 = new $c_sjsr_AnonFunction1(((r$2) => {
        var r$3 = $as_Ldiode_data_Pot(r$2);
        var $$x56 = $m_Lreactbuild_analyze_cost_modules_AccumulatingTable$();
        var $$x55 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var $$x54 = $m_sci_SortedSet$();
        var $$x53 = $n($as_sci_List($m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O($n(pageProps).Lreactbuild_package$PageProps__f_proxy, new $c_sjsr_AnonFunction1(((x$5$2) => {
          var x$5 = $as_Lreactbuild_model_CommonData(x$5$2);
          return $n(x$5).Lreactbuild_model_CommonData__f_buildingStages
        })), new $c_Lreactbuild_package$DefaultCommonData$$anon$1()))).map__F1__sci_List(new $c_sjsr_AnonFunction1(((x$6$2) => {
          var x$6 = $as_Lreactbuild_model_BuildingStage(x$6$2);
          return $n(x$6).Lreactbuild_model_BuildingStage__f__id
        })));
        var $$x52 = $m_Lreactbuild_model_Implicits$();
        var this$63 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var $$x51 = $as_sci_SortedSet($n($$x54).apply__sci_Seq__O__O($$x53, $n($$x52).buildingStageRefOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering($f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$63, proxy))));
        var this$65 = $n($n(r$3).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$7$2) => {
          var x$7 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$7$2);
          return $as_sci_Map($n(x$7).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
        }))));
        var default$1 = new $c_sjsr_AnonFunction0((() => {
          $n($m_s_Predef$().s_Predef$__f_Map);
          return $m_sci_Map$EmptyMap$()
        }));
        var $$x50 = $as_sci_Map((this$65.isEmpty__Z() ? default$1.apply__O() : this$65.get__O()));
        var $$x49 = new $c_sjsr_AnonFunction1(((d$2) => {
          var d$1 = $as_Ljava_time_LocalDate(d$2);
          return $n($n(pageProps).Lreactbuild_package$PageProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$TimeReport(new $c_s_Some(d$1)))
        }));
        var $$x48 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from;
        var $$x47 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_to;
        var this$67 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var u$1 = $n($$x56).apply__Ldiode_react_ModelProxy__sci_SortedSet__sci_Map__F1__s_Option__s_Option__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_Textualizable__s_math_Numeric__s_reflect_ClassTag__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x55, $$x51, $$x50, $$x49, $$x48, $$x47, $f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$67, proxy$1), $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable, $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_numericPrice, new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_model_Price.getClassOf()));
        var this$70 = $n(u$1);
        var n$1 = this$70.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
      }));
      var this$72 = $m_Ljapgolly_scalajs_react_Reusability$();
      var u$2 = $n($$x62).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x57, $$x46, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$72.byRef__F2(), this$72.by_$eq$eq__F2()), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
      var this$74 = $n(u$2);
      var n$2 = this$74.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$5 = [$$x63, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
      var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
      var $$x45 = $n($$x65).page__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_TagOf($p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$79, null, ns));
      var $$x44 = $m_Lcom_iz2use_react_components_Media$();
      var this$127 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var $$x43 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Temps pass\u00e9"))];
      var $$x42 = $n($$x43).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h3", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
      var $$x41 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
      var $$x36 = new $c_sjsr_AnonFunction0((() => {
        var this$87 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x40 = new $c_Lautowire_ClientProxy(this$87).Lautowire_ClientProxy__f_self;
        var $$x39 = $m_s_package$().s_package$__f_Seq;
        var array$7 = ["reactbuild", "project", "ProjectApi", "listDurationByDateAndBuildingStageForBuildingSite"];
        var $$x38 = $as_sci_Seq($n($$x39).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)));
        var this$102 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$92 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$93 = $n(new $c_Lautowire_ClientProxy(this$92).Lautowire_ClientProxy__f_self);
        var r$4 = $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id;
        var evidence$2$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
        var y$2 = this$93.write__O__Lio_circe_Encoder__Lio_circe_Json(r$4, evidence$2$2);
        var $$x37 = $ct_T2__O__O__(new $c_T2(), "project", y$2);
        var this$96 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$97 = $n(new $c_Lautowire_ClientProxy(this$96).Lautowire_ClientProxy__f_self);
        var r$5 = this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects;
        var evidence$2$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
        var y$3 = this$97.write__O__Lio_circe_Encoder__Lio_circe_Json(r$5, evidence$2$3);
        var array$8 = [$$x37, $ct_T2__O__O__(new $c_T2(), "withSubprojects", y$3)];
        var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
        return $n($n($$x40).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x38, this$102.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
          var x$2 = $as_Lio_circe_Json(x$2$2);
          var this$103 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$108 = $n(new $c_Lautowire_ClientProxy(this$103).Lautowire_ClientProxy__f_self);
          var this$107 = $m_Lreactbuild_model_package$();
          $m_s_DummyImplicit$();
          var ev$4 = new $c_Lshapeless_Refute$$anon$2();
          var this$106 = $m_Lio_circe_Decoder$();
          var decodeA0$1 = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
          $m_Lio_circe_Decoder$();
          var d$3 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
          var decodeA1$1 = new $c_Lio_circe_Decoder$$anon$39(d$3);
          var decodeK$1 = new $c_Lio_circe_TupleDecoders$$anon$2(this$106, decodeA0$1, decodeA1$1);
          var decodeV$1 = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_decodeDuration;
          var evidence$1$1 = $f_Lreactbuild_common_CirceExtendedImplicits__decodeOtherMap__Lshapeless_Refute__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder(this$107, ev$4, decodeK$1, decodeV$1);
          return $as_sci_Map(this$108.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2, evidence$1$1))
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      }));
      var $$x25 = new $c_sjsr_AnonFunction1(((r$3$2) => {
        var r$3$1 = $as_Ldiode_data_Pot(r$3$2);
        var $$x35 = $m_Lreactbuild_analyze_cost_modules_AccumulatingTable$();
        var $$x34 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var $$x33 = $m_sci_SortedSet$();
        var $$x32 = $n($as_sci_List($m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O($n(pageProps).Lreactbuild_package$PageProps__f_proxy, new $c_sjsr_AnonFunction1(((x$8$2) => {
          var x$8 = $as_Lreactbuild_model_CommonData(x$8$2);
          return $n(x$8).Lreactbuild_model_CommonData__f_buildingStages
        })), new $c_Lreactbuild_package$DefaultCommonData$$anon$1()))).map__F1__sci_List(new $c_sjsr_AnonFunction1(((x$9$2) => {
          var x$9 = $as_Lreactbuild_model_BuildingStage(x$9$2);
          return $n(x$9).Lreactbuild_model_BuildingStage__f__id
        })));
        var $$x31 = $m_Lreactbuild_model_Implicits$();
        var this$111 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var $$x30 = $as_sci_SortedSet($n($$x33).apply__sci_Seq__O__O($$x32, $n($$x31).buildingStageRefOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering($f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$111, proxy$2))));
        var this$113 = $n($n(r$3$1).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$10$2) => {
          var x$10 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$10$2);
          return $as_sci_Map($n(x$10).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
        }))));
        var default$2 = new $c_sjsr_AnonFunction0((() => {
          $n($m_s_Predef$().s_Predef$__f_Map);
          return $m_sci_Map$EmptyMap$()
        }));
        var $$x29 = $as_sci_Map((this$113.isEmpty__Z() ? default$2.apply__O() : this$113.get__O()));
        var $$x28 = new $c_sjsr_AnonFunction1(((d$2$1) => {
          var d$4 = $as_Ljava_time_LocalDate(d$2$1);
          return $n($n(pageProps).Lreactbuild_package$PageProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$TimeReport(new $c_s_Some(d$4)))
        }));
        var $$x27 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from;
        var $$x26 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_to;
        var this$115 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$3 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var u$3 = $n($$x35).apply__Ldiode_react_ModelProxy__sci_SortedSet__sci_Map__F1__s_Option__s_Option__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_Textualizable__s_math_Numeric__s_reflect_ClassTag__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x34, $$x30, $$x29, $$x28, $$x27, $$x26, $f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$115, proxy$3), $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration, $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_numericDuration, new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_model_Duration.getClassOf()));
        var this$118 = $n(u$3);
        var n$3 = this$118.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)
      }));
      var this$120 = $m_Ljapgolly_scalajs_react_Reusability$();
      var u$4 = $n($$x41).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x36, $$x25, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$120.byRef__F2(), this$120.by_$eq$eq__F2()), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
      var this$122 = $n(u$4);
      var n$4 = this$122.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$9 = [$$x42, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4)];
      var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
      var $$x24 = $n($$x44).page__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_TagOf($p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$127, null, ns$1));
      var $$x23 = $m_Lcom_iz2use_react_components_Media$();
      var this$190 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$10 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Remarques"))];
      var $$x21 = $n($$x22).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h3", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
      var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$11 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ne tient compte que des donn\u00e9es du projet. Ne tient pas compte des autres frais de gestion, administratif, achats d'outils et mat\u00e9riels support\u00e9s de fa\u00e7on globale par l'entreprise."))];
      var $$x19 = $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
      var $$x18 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$12 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Co\u00fbt des achats"))];
      var $$x17 = $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h3", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
      var $$x16 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
      var $$x11 = new $c_sjsr_AnonFunction0((() => {
        var this$149 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x15 = new $c_Lautowire_ClientProxy(this$149).Lautowire_ClientProxy__f_self;
        var $$x14 = $m_s_package$().s_package$__f_Seq;
        var array$13 = ["reactbuild", "project", "ProjectApi", "listInvoicebyDateAndBuildingPart"];
        var $$x13 = $as_sci_Seq($n($$x14).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13)));
        var this$164 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$154 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$155 = $n(new $c_Lautowire_ClientProxy(this$154).Lautowire_ClientProxy__f_self);
        var r$6 = $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id;
        var evidence$2$4 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
        var y$4 = this$155.write__O__Lio_circe_Encoder__Lio_circe_Json(r$6, evidence$2$4);
        var $$x12 = $ct_T2__O__O__(new $c_T2(), "project", y$4);
        var this$158 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$159 = $n(new $c_Lautowire_ClientProxy(this$158).Lautowire_ClientProxy__f_self);
        var r$7 = this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects;
        var evidence$2$5 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
        var y$5 = this$159.write__O__Lio_circe_Encoder__Lio_circe_Json(r$7, evidence$2$5);
        var array$14 = [$$x12, $ct_T2__O__O__(new $c_T2(), "withSubprojects", y$5)];
        var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
        return $n($n($$x15).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x13, this$164.from__sc_IterableOnce__sci_Map(elems$2)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$3$2) => {
          var x$3 = $as_Lio_circe_Json(x$3$2);
          var this$165 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$170 = $n(new $c_Lautowire_ClientProxy(this$165).Lautowire_ClientProxy__f_self);
          var this$169 = $m_Lreactbuild_model_package$();
          $m_s_DummyImplicit$();
          var ev$5 = new $c_Lshapeless_Refute$$anon$2();
          var this$168 = $m_Lio_circe_Decoder$();
          var decodeA0$2 = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
          $m_Lio_circe_Decoder$();
          var d$5 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
          var decodeA1$2 = new $c_Lio_circe_Decoder$$anon$39(d$5);
          var decodeK$2 = new $c_Lio_circe_TupleDecoders$$anon$2(this$168, decodeA0$2, decodeA1$2);
          var decodeV$2 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
          var evidence$1$2 = $f_Lreactbuild_common_CirceExtendedImplicits__decodeOtherMap__Lshapeless_Refute__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder(this$169, ev$5, decodeK$2, decodeV$2);
          return $as_sci_Map(this$170.read__Lio_circe_Json__Lio_circe_Decoder__O(x$3, evidence$1$2))
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      }));
      var $$x1 = new $c_sjsr_AnonFunction1(((r$4$2) => {
        var r$4$1 = $as_Ldiode_data_Pot(r$4$2);
        var $$x10 = $m_Lreactbuild_analyze_cost_modules_AccumulatingTable$();
        var $$x9 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var $$x8 = $m_sci_SortedSet$();
        var $$x7 = $n($as_sci_List($m_Lreactbuild_package$().getListFromCommonData__Ldiode_react_ModelProxy__F1__Lreactbuild_package$DefaultCommonData__O($n(pageProps).Lreactbuild_package$PageProps__f_proxy, new $c_sjsr_AnonFunction1(((x$11$2) => {
          var x$11 = $as_Lreactbuild_model_CommonData(x$11$2);
          return $n(x$11).Lreactbuild_model_CommonData__f_buildingParts
        })), new $c_Lreactbuild_package$DefaultCommonData$$anon$1()))).map__F1__sci_List(new $c_sjsr_AnonFunction1(((x$12$2) => {
          var x$12 = $as_Lreactbuild_model_BuildingPart(x$12$2);
          return $n(x$12).Lreactbuild_model_BuildingPart__f__id
        })));
        var this$174 = $m_Lreactbuild_model_Implicits$();
        var this$173 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$4 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var ev$6 = $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$173, proxy$4);
        var $$x6 = $as_sci_SortedSet($n($$x8).apply__sci_Seq__O__O($$x7, $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$174, ev$6)));
        var this$176 = $n($n(r$4$1).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$13$2) => {
          var x$13 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$13$2);
          return $as_sci_Map($n(x$13).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
        }))));
        var default$3 = new $c_sjsr_AnonFunction0((() => {
          $n($m_s_Predef$().s_Predef$__f_Map);
          return $m_sci_Map$EmptyMap$()
        }));
        var $$x5 = $as_sci_Map((this$176.isEmpty__Z() ? default$3.apply__O() : this$176.get__O()));
        var $$x4 = new $c_sjsr_AnonFunction1(((d$2$2) => {
          var d$6 = $as_Ljava_time_LocalDate(d$2$2);
          return $n($n(pageProps).Lreactbuild_package$PageProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$TimeReport(new $c_s_Some(d$6)))
        }));
        var $$x3 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from;
        var $$x2 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_to;
        var this$178 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$5 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var u$5 = $n($$x10).apply__Ldiode_react_ModelProxy__sci_SortedSet__sci_Map__F1__s_Option__s_Option__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_Textualizable__s_math_Numeric__s_reflect_ClassTag__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x9, $$x6, $$x5, $$x4, $$x3, $$x2, $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$178, proxy$5), $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable, $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_numericPrice, new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_model_Price.getClassOf()));
        var this$181 = $n(u$5);
        var n$5 = this$181.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$5)
      }));
      var this$183 = $m_Ljapgolly_scalajs_react_Reusability$();
      var u$6 = $n($$x16).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x11, $$x1, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$183.byRef__F2(), this$183.by_$eq$eq__F2()), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
      var this$185 = $n(u$6);
      var n$6 = this$185.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$15 = [$$x21, $$x19, $$x17, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$6)];
      var ns$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
      var array$16 = [$$x45, $$x24, $n($$x23).page__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_TagOf($p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$190, null, ns$2))];
      var array$17 = [$$x67, $n($$x66).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
      var array$18 = [$n($$x77).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))];
      return $n($$x78).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))
    })), ($m_Lreactbuild_model_Implicits$(), $n(pageProps).Lreactbuild_package$PageProps__f_proxy));
    var this$202 = $n(u$7);
    var n$7 = this$202.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$7)
  })))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.productPrefix__T = (function() {
  return "CostAnalyze"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_active;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("CostAnalyze");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_active;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze)) {
    var CostAnalyze$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects === $n(CostAnalyze$1).Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects)) {
      var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_active;
      var x$2 = $n(CostAnalyze$1).Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_active;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  var withSubprojects = this.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze__f_withSubprojects;
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(newActive, withSubprojects)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$CostAnalyze"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$CostAnalyze;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$CostAnalyze", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$CostAnalyze;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview(active) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview__f_title = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview__f_active = active;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview__f_title = "3D"
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview__f_title
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  if ($n(projectPot).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(projectPot);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(projectPot).get__O();
      var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
      var x1 = $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_modelSource;
      var x = $m_s_None$();
      if ((x === x1)) {
        var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu \u00e0 afficher, veuillez copier le mod\u00e8le sur le site d'abord."))];
        return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      } else {
        if ((!(x1 instanceof $c_s_Some))) {
          throw new $c_s_MatchError(x1)
        };
        var x3 = $as_s_Some(x1);
        var s = $n($as_Lcom_iz2use_common_Multiline($n(x3).s_Some__f_value)).Lcom_iz2use_common_Multiline__f_underlying;
        var this$19 = $n($n(pageProps).Lreactbuild_package$PageProps__f_proxy);
        var this$20 = $n(this$19.Ldiode_react_ModelProxy__f_modelReader);
        var libraryPot = $n($as_Lreactbuild_analyze_cost_services_Model(this$20.value__O())).Lreactbuild_analyze_cost_services_Model__f_library;
        var $$x12 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
        var a = ("DrawingViewerContainer." + $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id);
        if ($n(libraryPot).isEmpty__Z()) {
          var $$x11 = $n($m_Lcom_iz2use_react_components_Link$().apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($n(pageProps).Lreactbuild_package$PageProps__f_proxy).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline($m_Lreactbuild_common_actions_PleaseLoadLibrary$(), $m_Ldiode_Action$aType$())));
          var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cliquez ici pour t\u00e9l\u00e9charger la librairie (permettant d'afficher le mod\u00e8le)"))];
          var $$x10 = $n($$x11).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
        } else {
          var $$x10 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
        };
        if ($n(libraryPot).isPending__Z()) {
          var qual$1 = $as_Ldiode_data_PendingBase(libraryPot);
          $n(qual$1);
          var this$35 = $ct_ju_Date__(new $c_ju_Date());
          var t = this$35.ju_Date__f_java$util$Date$$millis;
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var this$36 = $n(qual$1);
          var duration = $f_Ldiode_data_PendingBase__duration__J__I(this$36, new $c_RTLong(lo, hi));
          if ((duration > 500)) {
            var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
            $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
            $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
            var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("loading"))];
            var $$x8 = $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
          } else {
            var $$x8 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
          }
        } else {
          var $$x8 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
        };
        var this$46 = $n($n(libraryPot).exceptionOption__s_Option());
        if (this$46.isEmpty__Z()) {
          var $$x6 = $m_s_None$()
        } else {
          var arg1$1 = this$46.get__O();
          var t$1 = $as_jl_Throwable(arg1$1);
          var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
          var v$1 = ("Failure : " + t$1);
          $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
          var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
          var $$x6 = new $c_s_Some($n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)))
        };
        var this$54 = $n($$x6);
        var $$x5 = $as_Ljapgolly_scalajs_react_vdom_VdomNode((this$54.isEmpty__Z() ? $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom : this$54.get__O()));
        var this$57 = $n(libraryPot);
        if ((!this$57.isEmpty__Z())) {
          var arg1$2 = $n(libraryPot).get__O();
          var library = $as_sci_Seq(arg1$2);
          var u = $m_Lreactbuild_common_components_DrawingViewer$().withKey__T__sci_Seq__T__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot("viewer", library, s);
          var this$59 = $n(u);
          var n = this$59.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
          var $$x4 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
        } else {
          var $$x4 = $m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
        };
        var array$5 = [$$x10, $$x8, $$x5, $$x4];
        return $n($$x12).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
      }
    } else if ($n(projectPot).isPending__Z()) {
      return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$6 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.productPrefix__T = (function() {
  return "Project3DDrawingOverview"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview__f_active : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview)) {
    var Project3DDrawingOverview$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview__f_active;
    var x$2 = $n(Project3DDrawingOverview$1).Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview__f_active;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview(newActive)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$Project3DDrawingOverview"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$Project3DDrawingOverview;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$Project3DDrawingOverview", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$Project3DDrawingOverview;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(active, documentType) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_documentType = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_active = active;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_documentType = documentType
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.title__T = (function() {
  return "G\u00e9n\u00e9rateur de documents"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  var $$x1 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var u = $m_Lreactbuild_project_generator_Generator$().apply__Ldiode_data_Pot__sci_List__s_Option__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(projectPot, allProjects, this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_documentType, pageProps);
  var this$5 = $n(u);
  var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  return $n($$x1).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("generator", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.productPrefix__T = (function() {
  return "ProjectDocumentGenerator"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_active;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_documentType;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator)) {
    var ProjectDocumentGenerator$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_active;
    var x$2 = $n(ProjectDocumentGenerator$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_active;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_documentType;
      var x$4 = $n(ProjectDocumentGenerator$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_documentType;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  var documentType = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator__f_documentType;
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(newActive, documentType)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectDocumentGenerator"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$ProjectDocumentGenerator;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectDocumentGenerator", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocumentGenerator;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(active, withSubprojects) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects = false;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_title = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_active = active;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects = withSubprojects;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_title = "Documents fournisseur"
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_title
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  if ($n(projectPot).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(projectPot);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(projectPot).get__O();
      var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
      var $$x194 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
      var a = (("" + $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id) + this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects);
      var $$x193 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Inclure tous les sous-projets");
      var $$x190 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
      $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
      var value = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects;
      var state = $n($$x190).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
        var x0$1 = $as_s_Option(x0$1$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        matchEnd7: {
          var $$x191;
          var p2 = $as_s_Option(x1.T2__f__1);
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x = $m_s_None$();
          if ((x === p2)) {
            var $$x191 = cb;
            break matchEnd7
          };
          var p4 = $as_s_Option(x1.T2__f__1);
          var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          if ((p4 instanceof $c_s_Some)) {
            var x5 = $as_s_Some(p4);
            var v$1 = $uZ($n(x5).s_Some__f_value);
            var $$x192 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
            var this$21 = $n($n(pageProps).Lreactbuild_package$PageProps__f_router);
            var active = new $c_s_Some($n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id);
            var route = new $c_Lreactbuild_Loc$Project(new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(active, v$1));
            var $$x191 = $n($$x192).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$21.set__O__Ljapgolly_scalajs_react_extra_router_SetRouteVia__O(route, $m_Ljapgolly_scalajs_react_extra_router_SetRouteVia$HistoryPush$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2);
            break matchEnd7
          };
          throw new $c_s_MatchError(x1)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x191)
      })));
      var evDefault = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
      var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
      var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
      var ev$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
      var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
      var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var equiv = $m_s_math_Equiv$Boolean$();
      var this$26 = $n(editorComponent);
      var array$1 = [this$26.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev$2, explainError, equiv)];
      var $$x189 = $n($$x193).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var $$x188 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
      var $$x183 = new $c_sjsr_AnonFunction0((() => {
        var this$30 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var $$x187 = new $c_Lautowire_ClientProxy(this$30).Lautowire_ClientProxy__f_self;
        var $$x186 = $m_s_package$().s_package$__f_Seq;
        var array$2 = ["reactbuild", "project", "ProjectApi", "listDocumentsForBuildingSite"];
        var $$x185 = $as_sci_Seq($n($$x186).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
        var this$45 = $n($m_s_Predef$().s_Predef$__f_Map);
        var this$35 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$36 = $n(new $c_Lautowire_ClientProxy(this$35).Lautowire_ClientProxy__f_self);
        var r = $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id;
        var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
        var y = this$36.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
        var $$x184 = $ct_T2__O__O__(new $c_T2(), "project", y);
        var this$39 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$40 = $n(new $c_Lautowire_ClientProxy(this$39).Lautowire_ClientProxy__f_self);
        var r$1 = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects;
        var evidence$2$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
        var y$1 = this$40.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
        var array$3 = [$$x184, $ct_T2__O__O__(new $c_T2(), "withSubprojects", y$1)];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        return $n($n($$x187).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x185, this$45.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1 = $as_Lio_circe_Json(x$1$2);
          var this$46 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
          var this$48 = $n(new $c_Lautowire_ClientProxy(this$46).Lautowire_ClientProxy__f_self);
          $m_Lio_circe_Decoder$();
          var decodeA = $m_Lreactbuild_model_InvoicePageGroup$().Lreactbuild_model_InvoicePageGroup$__f_codecForInvoicePageGroup;
          var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
          return $as_sci_List(this$48.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
      }));
      var $$x4 = new $c_sjsr_AnonFunction1(((r$2) => {
        var r$3 = $as_Ldiode_data_Pot(r$2);
        var $$x182 = $m_Lcom_iz2use_react_components_Multiview$();
        var $$x181 = new $c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler();
        var this$50 = $m_s_Symbol$();
        var $$x179 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "organization"));
        var this$51 = $m_s_Symbol$();
        var $$x178 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$51, "supplier"));
        var this$52 = $m_s_Symbol$();
        var $$x177 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "date"));
        var this$53 = $m_s_Symbol$();
        var $$x176 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "entryNumber"));
        var this$54 = $m_s_Symbol$();
        var $$x175 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$54, "reference"));
        var this$55 = $m_s_Symbol$();
        var $$x174 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "pages"));
        var this$56 = $m_s_Symbol$();
        var $$x173 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "totalAmount"));
        var this$57 = $m_s_Symbol$();
        var $$x172 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$57, "expectedAmount"));
        var this$58 = $m_s_Symbol$();
        var $$x171 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "received"));
        var this$59 = $m_s_Symbol$();
        var labels = new $c_Lshapeless_$colon$colon($$x179, new $c_Lshapeless_$colon$colon($$x178, new $c_Lshapeless_$colon$colon($$x177, new $c_Lshapeless_$colon$colon($$x176, new $c_Lshapeless_$colon$colon($$x175, new $c_Lshapeless_$colon$colon($$x174, new $c_Lshapeless_$colon$colon($$x173, new $c_Lshapeless_$colon$colon($$x172, new $c_Lshapeless_$colon$colon($$x171, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "category")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
        var f = new $c_sjsr_AnonFunction1(((x0$4$2) => {
          var x0$4 = $as_Lreactbuild_model_InvoicePageGroup(x0$4$2);
          if ((x0$4 !== null)) {
            var organization$macro$31 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_organization;
            var supplier$macro$32 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_supplier;
            var date$macro$33 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_date;
            var entryNumber$macro$34 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
            var reference$macro$35 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_reference;
            var pages$macro$36 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_pages;
            var totalAmount$macro$37 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
            var expectedAmount$macro$38 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
            var received$macro$39 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_received;
            var category$macro$40 = $n(x0$4).Lreactbuild_model_InvoicePageGroup__f_category;
            return new $c_Lshapeless_$colon$colon(organization$macro$31, new $c_Lshapeless_$colon$colon(supplier$macro$32, new $c_Lshapeless_$colon$colon(date$macro$33, new $c_Lshapeless_$colon$colon(entryNumber$macro$34, new $c_Lshapeless_$colon$colon(reference$macro$35, new $c_Lshapeless_$colon$colon(pages$macro$36, new $c_Lshapeless_$colon$colon(totalAmount$macro$37, new $c_Lshapeless_$colon$colon(expectedAmount$macro$38, new $c_Lshapeless_$colon$colon(received$macro$39, new $c_Lshapeless_$colon$colon(category$macro$40, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$4)
          }
        }));
        var g = new $c_sjsr_AnonFunction1(((x0$5$2) => {
          var x0$5 = $as_Lshapeless_$colon$colon(x0$5$2);
          if ((x0$5 !== null)) {
            var organization$macro$21 = $as_Lreactbuild_common_model_RefTo($n(x0$5).Lshapeless_$colon$colon__f_head);
            var p2$1 = $as_Lshapeless_$colon$colon($n(x0$5).Lshapeless_$colon$colon__f_tail);
            if ((p2$1 !== null)) {
              var supplier$macro$22 = $as_s_Option($n(p2$1).Lshapeless_$colon$colon__f_head);
              var p3 = $as_Lshapeless_$colon$colon($n(p2$1).Lshapeless_$colon$colon__f_tail);
              if ((p3 !== null)) {
                var date$macro$23 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
                var p4$1 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
                if ((p4$1 !== null)) {
                  var entryNumber$macro$24 = $as_s_Option($n(p4$1).Lshapeless_$colon$colon__f_head);
                  var p5 = $as_Lshapeless_$colon$colon($n(p4$1).Lshapeless_$colon$colon__f_tail);
                  if ((p5 !== null)) {
                    var reference$macro$25 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                    var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                    if ((p6 !== null)) {
                      var pages$macro$26 = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
                      var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                      if ((p7 !== null)) {
                        var totalAmount$macro$27 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                        var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                        if ((p8 !== null)) {
                          var expectedAmount$macro$28 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                          var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                          if ((p9 !== null)) {
                            var received$macro$29 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                            var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                            if ((p10 !== null)) {
                              var category$macro$30 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                              var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                              var x$2 = $m_Lshapeless_HNil$();
                              if ((x$2 === p11)) {
                                return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$21, supplier$macro$22, date$macro$23, entryNumber$macro$24, reference$macro$25, pages$macro$26, totalAmount$macro$27, expectedAmount$macro$28, received$macro$29, category$macro$30)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$5)
        }));
        var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$62 = $m_s_Symbol$();
        var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "category"));
        new $c_Lshapeless_Witness$$anon$1(value0);
        var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
        $m_Lshapeless_Witness$();
        var this$65 = $m_s_Symbol$();
        var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "received"));
        new $c_Lshapeless_Witness$$anon$1(value0$1);
        var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
        $m_Lshapeless_Witness$();
        var this$68 = $m_s_Symbol$();
        var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "expectedAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$2);
        var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
        $m_Lshapeless_Witness$();
        var this$71 = $m_s_Symbol$();
        var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$71, "totalAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$3);
        var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
        $m_Lshapeless_Witness$();
        var this$74 = $m_s_Symbol$();
        var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$74, "pages"));
        new $c_Lshapeless_Witness$$anon$1(value0$4);
        var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
        $m_Lshapeless_Witness$();
        var this$77 = $m_s_Symbol$();
        var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$77, "reference"));
        new $c_Lshapeless_Witness$$anon$1(value0$5);
        var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
        $m_Lshapeless_Witness$();
        var this$80 = $m_s_Symbol$();
        var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "entryNumber"));
        new $c_Lshapeless_Witness$$anon$1(value0$6);
        var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
        $m_Lshapeless_Witness$();
        var this$83 = $m_s_Symbol$();
        var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$7);
        var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
        $m_Lshapeless_Witness$();
        var this$86 = $m_s_Symbol$();
        var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$86, "supplier"));
        new $c_Lshapeless_Witness$$anon$1(value0$8);
        var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
        $m_Lshapeless_Witness$();
        var this$89 = $m_s_Symbol$();
        var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$89, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$9);
        var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
        var this$92 = $m_s_$less$colon$less$();
        var ev$3 = this$92.s_$less$colon$less$__f_singleton;
        var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev$3);
        $m_Lshapeless_Witness$();
        var this$94 = $m_s_Symbol$();
        var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$94, "category"));
        var wk = new $c_Lshapeless_Witness$$anon$1(value0$10);
        var tailToMap = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk);
        var keyLub = new $c_Lshapeless_Lub$$anon$4();
        var valueLub = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$99 = $m_s_Symbol$();
        var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$99, "received"));
        var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
        var tailToMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap, keyLub, valueLub, wk$1);
        var keyLub$1 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$1 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$104 = $m_s_Symbol$();
        var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$104, "expectedAmount"));
        var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$12);
        var tailToMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$2);
        var keyLub$2 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$2 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$109 = $m_s_Symbol$();
        var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$109, "totalAmount"));
        var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$13);
        var tailToMap$3 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$2, keyLub$2, valueLub$2, wk$3);
        var keyLub$3 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$3 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$114 = $m_s_Symbol$();
        var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$114, "pages"));
        var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$14);
        var tailToMap$4 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$3, keyLub$3, valueLub$3, wk$4);
        var keyLub$4 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$4 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$119 = $m_s_Symbol$();
        var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$119, "reference"));
        var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$15);
        var tailToMap$5 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$4, keyLub$4, valueLub$4, wk$5);
        var keyLub$5 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$5 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$124 = $m_s_Symbol$();
        var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$124, "entryNumber"));
        var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$16);
        var tailToMap$6 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$5, keyLub$5, valueLub$5, wk$6);
        var keyLub$6 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$6 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$129 = $m_s_Symbol$();
        var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$129, "date"));
        var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$17);
        var tailToMap$7 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$6, keyLub$6, valueLub$6, wk$7);
        var keyLub$7 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$7 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$134 = $m_s_Symbol$();
        var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$134, "supplier"));
        var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$18);
        var tailToMap$8 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$7, keyLub$7, valueLub$7, wk$8);
        var keyLub$8 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$8 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$139 = $m_s_Symbol$();
        var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$139, "organization"));
        var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$19);
        var toMap = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$8, keyLub$8, valueLub$8, wk$9);
        $m_Lshapeless_Witness$();
        var this$142 = $m_s_Symbol$();
        var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$142, "organization"));
        var wk$19 = new $c_Lshapeless_Witness$$anon$1(value0$20);
        var tv$9 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
        $m_Lshapeless_Witness$();
        var this$144 = $m_s_Symbol$();
        var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$144, "supplier"));
        var wk$18 = new $c_Lshapeless_Witness$$anon$1(value0$21);
        var tv$8 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
        $m_Lshapeless_Witness$();
        var this$146 = $m_s_Symbol$();
        var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$146, "date"));
        var wk$17 = new $c_Lshapeless_Witness$$anon$1(value0$22);
        var tv$7 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_Date.getClassOf(), new $c_sjsr_AnonFunction0((() => "Date"))));
        $m_Lshapeless_Witness$();
        var this$148 = $m_s_Symbol$();
        var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$148, "entryNumber"));
        var wk$16 = new $c_Lshapeless_Witness$$anon$1(value0$23);
        var tv$6 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_intTypeable);
        $m_Lshapeless_Witness$();
        var this$150 = $m_s_Symbol$();
        var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$150, "reference"));
        var wk$15 = new $c_Lshapeless_Witness$$anon$1(value0$24);
        var tv$5 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
        $m_Lshapeless_Witness$();
        var this$152 = $m_s_Symbol$();
        var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$152, "pages"));
        var wk$14 = new $c_Lshapeless_Witness$$anon$1(value0$25);
        var tv$4 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_InvoicePage.getClassOf(), new $c_sjsr_AnonFunction0((() => "InvoicePage"))));
        $m_Lshapeless_Witness$();
        var this$155 = $m_s_Symbol$();
        var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$155, "totalAmount"));
        var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$26);
        var tv$3 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
        $m_Lshapeless_Witness$();
        var this$157 = $m_s_Symbol$();
        var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$157, "expectedAmount"));
        var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$27);
        var tv$2 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
        $m_Lshapeless_Witness$();
        var this$159 = $m_s_Symbol$();
        var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$159, "received"));
        var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$28);
        var tv$1 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_Instant.getClassOf(), new $c_sjsr_AnonFunction0((() => "Instant"))));
        $m_Lshapeless_Witness$();
        var this$161 = $m_s_Symbol$();
        var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$161, "category"));
        var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$29);
        var tv = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_DocumentCategory.getClassOf(), new $c_sjsr_AnonFunction0((() => "DocumentCategory"))));
        var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
        var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$10, tv, fmt);
        var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$11, tv$1, fmt$1);
        var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$12, tv$2, fmt$2);
        var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$13, tv$3, fmt$3);
        var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$14, tv$4, fmt$4);
        var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$15, tv$5, fmt$5);
        var fmt$7 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$16, tv$6, fmt$6);
        var fmt$8 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$17, tv$7, fmt$7);
        var fmt$9 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$18, tv$8, fmt$8);
        var fromMap = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$19, tv$9, fmt$9);
        var $$x180 = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap, gen$1, fromMap);
        $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$();
        var this$505 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$504 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$503 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$502 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$175 = $m_s_Symbol$();
        var $$x83 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$175, "organization"));
        var this$176 = $m_s_Symbol$();
        var $$x82 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$176, "supplier"));
        var this$177 = $m_s_Symbol$();
        var $$x81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$177, "date"));
        var this$178 = $m_s_Symbol$();
        var $$x80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$178, "entryNumber"));
        var this$179 = $m_s_Symbol$();
        var $$x79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$179, "reference"));
        var this$180 = $m_s_Symbol$();
        var $$x78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$180, "pages"));
        var this$181 = $m_s_Symbol$();
        var $$x77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$181, "totalAmount"));
        var this$182 = $m_s_Symbol$();
        var $$x76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$182, "expectedAmount"));
        var this$183 = $m_s_Symbol$();
        var $$x75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$183, "received"));
        var this$184 = $m_s_Symbol$();
        var labels$1 = new $c_Lshapeless_$colon$colon($$x83, new $c_Lshapeless_$colon$colon($$x82, new $c_Lshapeless_$colon$colon($$x81, new $c_Lshapeless_$colon$colon($$x80, new $c_Lshapeless_$colon$colon($$x79, new $c_Lshapeless_$colon$colon($$x78, new $c_Lshapeless_$colon$colon($$x77, new $c_Lshapeless_$colon$colon($$x76, new $c_Lshapeless_$colon$colon($$x75, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$184, "category")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
        var f$1 = new $c_sjsr_AnonFunction1(((x0$8$2) => {
          var x0$8 = $as_Lreactbuild_model_InvoicePageGroup(x0$8$2);
          if ((x0$8 !== null)) {
            var organization$macro$71 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_organization;
            var supplier$macro$72 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_supplier;
            var date$macro$73 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_date;
            var entryNumber$macro$74 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
            var reference$macro$75 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_reference;
            var pages$macro$76 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_pages;
            var totalAmount$macro$77 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
            var expectedAmount$macro$78 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
            var received$macro$79 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_received;
            var category$macro$80 = $n(x0$8).Lreactbuild_model_InvoicePageGroup__f_category;
            return new $c_Lshapeless_$colon$colon(organization$macro$71, new $c_Lshapeless_$colon$colon(supplier$macro$72, new $c_Lshapeless_$colon$colon(date$macro$73, new $c_Lshapeless_$colon$colon(entryNumber$macro$74, new $c_Lshapeless_$colon$colon(reference$macro$75, new $c_Lshapeless_$colon$colon(pages$macro$76, new $c_Lshapeless_$colon$colon(totalAmount$macro$77, new $c_Lshapeless_$colon$colon(expectedAmount$macro$78, new $c_Lshapeless_$colon$colon(received$macro$79, new $c_Lshapeless_$colon$colon(category$macro$80, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$8)
          }
        }));
        var g$1 = new $c_sjsr_AnonFunction1(((x0$9$2) => {
          var x0$9 = $as_Lshapeless_$colon$colon(x0$9$2);
          if ((x0$9 !== null)) {
            var organization$macro$61 = $as_Lreactbuild_common_model_RefTo($n(x0$9).Lshapeless_$colon$colon__f_head);
            var p2$2 = $as_Lshapeless_$colon$colon($n(x0$9).Lshapeless_$colon$colon__f_tail);
            if ((p2$2 !== null)) {
              var supplier$macro$62 = $as_s_Option($n(p2$2).Lshapeless_$colon$colon__f_head);
              var p3$1 = $as_Lshapeless_$colon$colon($n(p2$2).Lshapeless_$colon$colon__f_tail);
              if ((p3$1 !== null)) {
                var date$macro$63 = $as_s_Option($n(p3$1).Lshapeless_$colon$colon__f_head);
                var p4$2 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
                if ((p4$2 !== null)) {
                  var entryNumber$macro$64 = $as_s_Option($n(p4$2).Lshapeless_$colon$colon__f_head);
                  var p5$1 = $as_Lshapeless_$colon$colon($n(p4$2).Lshapeless_$colon$colon__f_tail);
                  if ((p5$1 !== null)) {
                    var reference$macro$65 = $as_s_Option($n(p5$1).Lshapeless_$colon$colon__f_head);
                    var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
                    if ((p6$1 !== null)) {
                      var pages$macro$66 = $as_sci_Seq($n(p6$1).Lshapeless_$colon$colon__f_head);
                      var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                      if ((p7$1 !== null)) {
                        var totalAmount$macro$67 = $as_s_Option($n(p7$1).Lshapeless_$colon$colon__f_head);
                        var p8$1 = $as_Lshapeless_$colon$colon($n(p7$1).Lshapeless_$colon$colon__f_tail);
                        if ((p8$1 !== null)) {
                          var expectedAmount$macro$68 = $as_s_Option($n(p8$1).Lshapeless_$colon$colon__f_head);
                          var p9$1 = $as_Lshapeless_$colon$colon($n(p8$1).Lshapeless_$colon$colon__f_tail);
                          if ((p9$1 !== null)) {
                            var received$macro$69 = $as_s_Option($n(p9$1).Lshapeless_$colon$colon__f_head);
                            var p10$1 = $as_Lshapeless_$colon$colon($n(p9$1).Lshapeless_$colon$colon__f_tail);
                            if ((p10$1 !== null)) {
                              var category$macro$70 = $as_s_Option($n(p10$1).Lshapeless_$colon$colon__f_head);
                              var p11$1 = $as_Lshapeless_HNil($n(p10$1).Lshapeless_$colon$colon__f_tail);
                              var x$3 = $m_Lshapeless_HNil$();
                              if ((x$3 === p11$1)) {
                                return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$61, supplier$macro$62, date$macro$63, entryNumber$macro$64, reference$macro$65, pages$macro$66, totalAmount$macro$67, expectedAmount$macro$68, received$macro$69, category$macro$70)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$9)
        }));
        var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys$10 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$187 = $m_s_Symbol$();
        var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$187, "category"));
        new $c_Lshapeless_Witness$$anon$1(value0$30);
        var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
        $m_Lshapeless_Witness$();
        var this$190 = $m_s_Symbol$();
        var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$190, "received"));
        new $c_Lshapeless_Witness$$anon$1(value0$31);
        var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
        $m_Lshapeless_Witness$();
        var this$193 = $m_s_Symbol$();
        var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$193, "expectedAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$32);
        var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
        $m_Lshapeless_Witness$();
        var this$196 = $m_s_Symbol$();
        var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$196, "totalAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$33);
        var zipWithKeys$14 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
        $m_Lshapeless_Witness$();
        var this$199 = $m_s_Symbol$();
        var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$199, "pages"));
        new $c_Lshapeless_Witness$$anon$1(value0$34);
        var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
        $m_Lshapeless_Witness$();
        var this$202 = $m_s_Symbol$();
        var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$202, "reference"));
        new $c_Lshapeless_Witness$$anon$1(value0$35);
        var zipWithKeys$16 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
        $m_Lshapeless_Witness$();
        var this$205 = $m_s_Symbol$();
        var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$205, "entryNumber"));
        new $c_Lshapeless_Witness$$anon$1(value0$36);
        var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
        $m_Lshapeless_Witness$();
        var this$208 = $m_s_Symbol$();
        var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$208, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$37);
        var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
        $m_Lshapeless_Witness$();
        var this$211 = $m_s_Symbol$();
        var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$211, "supplier"));
        new $c_Lshapeless_Witness$$anon$1(value0$38);
        var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
        $m_Lshapeless_Witness$();
        var this$214 = $m_s_Symbol$();
        var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$214, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$39);
        var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
        var this$217 = $m_s_$less$colon$less$();
        var ev$4 = this$217.s_$less$colon$less$__f_singleton;
        new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$4);
        var this$334 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$219 = $m_s_Symbol$();
        var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$219, "organization"));
        var witness$8 = new $c_Lshapeless_Witness$$anon$1(value0$40);
        var $$x87 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var this$221 = $m_Lreactbuild_model_Implicits$();
        var format = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$221);
        var $$x86 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format);
        var this$225 = $m_Lreactbuild_model_Implicits$();
        var this$224 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var ev$5 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$224, proxy);
        var $$x85 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$225, ev$5)));
        var $$x84 = new $c_Lcom_iz2use_react_components_NotEditable();
        var this$228 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$228, proxy$1);
        var fieldRenderable$8 = $n($$x87).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x86, $$x85, $$x84, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        var this$333 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$230 = $m_s_Symbol$();
        var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$230, "supplier"));
        var witness$7 = new $c_Lshapeless_Witness$$anon$1(value0$41);
        var $$x91 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var this$232 = $m_Lreactbuild_model_Implicits$();
        var format$1 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$232);
        var format$2 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$1);
        var $$x90 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$2);
        var this$237 = $m_Lreactbuild_model_Implicits$();
        var this$236 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$2 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var ev$6 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$236, proxy$2);
        var ord = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$237, ev$6);
        var $$x89 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord)));
        var $$x88 = new $c_Lcom_iz2use_react_components_NotEditable();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$241 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$3 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var textualizable$1 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$241, proxy$3);
        var textualizable$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1);
        var fieldRenderable$7 = $n($$x91).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x90, $$x89, $$x88, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$2), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        var this$332 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$244 = $m_s_Symbol$();
        var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$244, "date"));
        var witness$6 = new $c_Lshapeless_Witness$$anon$1(value0$42);
        var $$x95 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
        var format$4 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$3);
        var $$x94 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$4);
        var ord$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
        var $$x93 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$1)));
        var $$x92 = new $c_Lcom_iz2use_react_components_NotEditable();
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
        var textualizable$4 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$3);
        var fieldRenderable$6 = $n($$x95).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x94, $$x93, $$x92, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$4), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        var this$331 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$252 = $m_s_Symbol$();
        var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$252, "entryNumber"));
        var witness$5 = new $c_Lshapeless_Witness$$anon$1(value0$43);
        var $$x100 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$5 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
        var format$6 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$5);
        var $$x99 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$6);
        var ord$2 = $m_s_math_Ordering$Int$();
        var $$x98 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$2)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$7);
        var optioner$1 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var parser$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var resolver = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
        var $$x97 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$1, resolver);
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var textualizable$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
        var $$x96 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$5);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var fieldRenderable$5 = $n($$x100).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x99, $$x98, $$x97, $$x96, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$8))));
        var this$330 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$265 = $m_s_Symbol$();
        var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$265, "reference"));
        var witness$4 = new $c_Lshapeless_Witness$$anon$1(value0$44);
        var $$x105 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$7 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var format$8 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$7);
        var $$x104 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$8);
        var ord$3 = $m_s_math_Ordering$String$();
        var $$x103 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$3)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$9);
        var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
        var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$10);
        var resolver$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
        var $$x102 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$2, resolver$1);
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var textualizable$6 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$3);
        var $$x101 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$6);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$11 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var fieldRenderable$4 = $n($$x105).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x104, $$x103, $$x102, $$x101, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$11))));
        var this$329 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.InvoicePageGroup", "Seq[reactbuild.model.InvoicePage]");
        var this$328 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$280 = $m_s_Symbol$();
        var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$280, "totalAmount"));
        var witness$3 = new $c_Lshapeless_Witness$$anon$1(value0$45);
        var $$x110 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
        var format$10 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$9);
        var $$x109 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$10);
        var ord$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
        var $$x108 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$4)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$12);
        var optioner$3 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var parser$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var resolver$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
        var $$x107 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$3, resolver$2);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var textualizable$8 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$7);
        var $$x106 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$8);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var fieldRenderable$3 = $n($$x110).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x109, $$x108, $$x107, $$x106, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$13))));
        var this$327 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$292 = $m_s_Symbol$();
        var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$292, "expectedAmount"));
        var witness$2 = new $c_Lshapeless_Witness$$anon$1(value0$46);
        var $$x115 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
        var format$12 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$11);
        var $$x114 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$12);
        var ord$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
        var $$x113 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$5)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$14 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$14);
        var optioner$4 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var parser$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var resolver$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
        var $$x112 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$4, resolver$3);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var textualizable$10 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$9);
        var $$x111 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$10);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$15 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var fieldRenderable$2 = $n($$x115).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x114, $$x113, $$x112, $$x111, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$15))));
        var this$326 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$304 = $m_s_Symbol$();
        var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$304, "received"));
        var witness$1 = new $c_Lshapeless_Witness$$anon$1(value0$47);
        var $$x119 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$13 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
        var format$14 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$13);
        var $$x118 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$14);
        var ord$6 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
        var $$x117 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$6)));
        var $$x116 = new $c_Lcom_iz2use_react_components_NotEditable();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$310 = $m_Lreactbuild_model_Implicits$();
        var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
        var textualizable$11 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$310, locale);
        var textualizable$12 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$11);
        var fieldRenderable$1 = $n($$x119).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x118, $$x117, $$x116, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$12), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        var this$325 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$313 = $m_s_Symbol$();
        var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$313, "category"));
        var witness = new $c_Lshapeless_Witness$$anon$1(value0$48);
        var $$x124 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$15 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
        var format$16 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$15);
        var $$x123 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$16);
        var ord$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
        var $$x122 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$7)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$16 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$16);
        var optioner$5 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var resolver$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
        var $$x121 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$5, resolver$4);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
        var textualizable$14 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$13);
        var $$x120 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$14);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$17 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
        var fieldRenderable = $n($$x124).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x123, $$x122, $$x121, $$x120, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$17))));
        var tail = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4();
        var tail$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$325, fieldRenderable, witness, tail);
        var tail$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$326, fieldRenderable$1, witness$1, tail$1);
        var tail$3 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$327, fieldRenderable$2, witness$2, tail$2);
        var tail$4 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$328, fieldRenderable$3, witness$3, tail$3);
        var tail$5 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$329, tail$4);
        var tail$6 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$330, fieldRenderable$4, witness$4, tail$5);
        var tail$7 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$331, fieldRenderable$5, witness$5, tail$6);
        var tail$8 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$332, fieldRenderable$6, witness$6, tail$7);
        var tail$9 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$333, fieldRenderable$7, witness$7, tail$8);
        var renderer = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$334, fieldRenderable$8, witness$8, tail$9);
        $m_s_DummyImplicit$();
        new $c_Lshapeless_Refute$$anon$2();
        var view$2 = new $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1(renderer);
        var this$500 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        $m_Lreactbuild_model_Implicits$();
        var renderItem = new $c_Lreactbuild_model_Implicits$$anon$29(pageProps);
        var view$1 = new $c_Lcom_iz2use_react_components_internal_multiview_Slideshow$$anon$1(renderItem);
        var this$339 = $m_s_Symbol$();
        var $$x133 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$339, "organization"));
        var this$340 = $m_s_Symbol$();
        var $$x132 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$340, "supplier"));
        var this$341 = $m_s_Symbol$();
        var $$x131 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$341, "date"));
        var this$342 = $m_s_Symbol$();
        var $$x130 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$342, "entryNumber"));
        var this$343 = $m_s_Symbol$();
        var $$x129 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$343, "reference"));
        var this$344 = $m_s_Symbol$();
        var $$x128 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$344, "pages"));
        var this$345 = $m_s_Symbol$();
        var $$x127 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$345, "totalAmount"));
        var this$346 = $m_s_Symbol$();
        var $$x126 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$346, "expectedAmount"));
        var this$347 = $m_s_Symbol$();
        var $$x125 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$347, "received"));
        var this$348 = $m_s_Symbol$();
        var labels$2 = new $c_Lshapeless_$colon$colon($$x133, new $c_Lshapeless_$colon$colon($$x132, new $c_Lshapeless_$colon$colon($$x131, new $c_Lshapeless_$colon$colon($$x130, new $c_Lshapeless_$colon$colon($$x129, new $c_Lshapeless_$colon$colon($$x128, new $c_Lshapeless_$colon$colon($$x127, new $c_Lshapeless_$colon$colon($$x126, new $c_Lshapeless_$colon$colon($$x125, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$348, "category")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
        var f$2 = new $c_sjsr_AnonFunction1(((x0$12$2) => {
          var x0$12 = $as_Lreactbuild_model_InvoicePageGroup(x0$12$2);
          if ((x0$12 !== null)) {
            var organization$macro$111 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_organization;
            var supplier$macro$112 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_supplier;
            var date$macro$113 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_date;
            var entryNumber$macro$114 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
            var reference$macro$115 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_reference;
            var pages$macro$116 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_pages;
            var totalAmount$macro$117 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
            var expectedAmount$macro$118 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
            var received$macro$119 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_received;
            var category$macro$120 = $n(x0$12).Lreactbuild_model_InvoicePageGroup__f_category;
            return new $c_Lshapeless_$colon$colon(organization$macro$111, new $c_Lshapeless_$colon$colon(supplier$macro$112, new $c_Lshapeless_$colon$colon(date$macro$113, new $c_Lshapeless_$colon$colon(entryNumber$macro$114, new $c_Lshapeless_$colon$colon(reference$macro$115, new $c_Lshapeless_$colon$colon(pages$macro$116, new $c_Lshapeless_$colon$colon(totalAmount$macro$117, new $c_Lshapeless_$colon$colon(expectedAmount$macro$118, new $c_Lshapeless_$colon$colon(received$macro$119, new $c_Lshapeless_$colon$colon(category$macro$120, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$12)
          }
        }));
        var g$2 = new $c_sjsr_AnonFunction1(((x0$13$2) => {
          var x0$13 = $as_Lshapeless_$colon$colon(x0$13$2);
          if ((x0$13 !== null)) {
            var organization$macro$101 = $as_Lreactbuild_common_model_RefTo($n(x0$13).Lshapeless_$colon$colon__f_head);
            var p2$3 = $as_Lshapeless_$colon$colon($n(x0$13).Lshapeless_$colon$colon__f_tail);
            if ((p2$3 !== null)) {
              var supplier$macro$102 = $as_s_Option($n(p2$3).Lshapeless_$colon$colon__f_head);
              var p3$2 = $as_Lshapeless_$colon$colon($n(p2$3).Lshapeless_$colon$colon__f_tail);
              if ((p3$2 !== null)) {
                var date$macro$103 = $as_s_Option($n(p3$2).Lshapeless_$colon$colon__f_head);
                var p4$3 = $as_Lshapeless_$colon$colon($n(p3$2).Lshapeless_$colon$colon__f_tail);
                if ((p4$3 !== null)) {
                  var entryNumber$macro$104 = $as_s_Option($n(p4$3).Lshapeless_$colon$colon__f_head);
                  var p5$2 = $as_Lshapeless_$colon$colon($n(p4$3).Lshapeless_$colon$colon__f_tail);
                  if ((p5$2 !== null)) {
                    var reference$macro$105 = $as_s_Option($n(p5$2).Lshapeless_$colon$colon__f_head);
                    var p6$2 = $as_Lshapeless_$colon$colon($n(p5$2).Lshapeless_$colon$colon__f_tail);
                    if ((p6$2 !== null)) {
                      var pages$macro$106 = $as_sci_Seq($n(p6$2).Lshapeless_$colon$colon__f_head);
                      var p7$2 = $as_Lshapeless_$colon$colon($n(p6$2).Lshapeless_$colon$colon__f_tail);
                      if ((p7$2 !== null)) {
                        var totalAmount$macro$107 = $as_s_Option($n(p7$2).Lshapeless_$colon$colon__f_head);
                        var p8$2 = $as_Lshapeless_$colon$colon($n(p7$2).Lshapeless_$colon$colon__f_tail);
                        if ((p8$2 !== null)) {
                          var expectedAmount$macro$108 = $as_s_Option($n(p8$2).Lshapeless_$colon$colon__f_head);
                          var p9$2 = $as_Lshapeless_$colon$colon($n(p8$2).Lshapeless_$colon$colon__f_tail);
                          if ((p9$2 !== null)) {
                            var received$macro$109 = $as_s_Option($n(p9$2).Lshapeless_$colon$colon__f_head);
                            var p10$2 = $as_Lshapeless_$colon$colon($n(p9$2).Lshapeless_$colon$colon__f_tail);
                            if ((p10$2 !== null)) {
                              var category$macro$110 = $as_s_Option($n(p10$2).Lshapeless_$colon$colon__f_head);
                              var p11$2 = $as_Lshapeless_HNil($n(p10$2).Lshapeless_$colon$colon__f_tail);
                              var x$4 = $m_Lshapeless_HNil$();
                              if ((x$4 === p11$2)) {
                                return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$101, supplier$macro$102, date$macro$103, entryNumber$macro$104, reference$macro$105, pages$macro$106, totalAmount$macro$107, expectedAmount$macro$108, received$macro$109, category$macro$110)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$13)
        }));
        var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys$20 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$351 = $m_s_Symbol$();
        var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$351, "category"));
        new $c_Lshapeless_Witness$$anon$1(value0$49);
        var zipWithKeys$21 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
        $m_Lshapeless_Witness$();
        var this$354 = $m_s_Symbol$();
        var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$354, "received"));
        new $c_Lshapeless_Witness$$anon$1(value0$50);
        var zipWithKeys$22 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
        $m_Lshapeless_Witness$();
        var this$357 = $m_s_Symbol$();
        var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$357, "expectedAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$51);
        var zipWithKeys$23 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
        $m_Lshapeless_Witness$();
        var this$360 = $m_s_Symbol$();
        var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$360, "totalAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$52);
        var zipWithKeys$24 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$23);
        $m_Lshapeless_Witness$();
        var this$363 = $m_s_Symbol$();
        var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$363, "pages"));
        new $c_Lshapeless_Witness$$anon$1(value0$53);
        var zipWithKeys$25 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$24);
        $m_Lshapeless_Witness$();
        var this$366 = $m_s_Symbol$();
        var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$366, "reference"));
        new $c_Lshapeless_Witness$$anon$1(value0$54);
        var zipWithKeys$26 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$25);
        $m_Lshapeless_Witness$();
        var this$369 = $m_s_Symbol$();
        var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$369, "entryNumber"));
        new $c_Lshapeless_Witness$$anon$1(value0$55);
        var zipWithKeys$27 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$26);
        $m_Lshapeless_Witness$();
        var this$372 = $m_s_Symbol$();
        var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$372, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$56);
        var zipWithKeys$28 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$27);
        $m_Lshapeless_Witness$();
        var this$375 = $m_s_Symbol$();
        var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$375, "supplier"));
        new $c_Lshapeless_Witness$$anon$1(value0$57);
        var zipWithKeys$29 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$28);
        $m_Lshapeless_Witness$();
        var this$378 = $m_s_Symbol$();
        var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$378, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$58);
        var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$29);
        var this$381 = $m_s_$less$colon$less$();
        var ev$18 = this$381.s_$less$colon$less$__f_singleton;
        new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$18);
        var this$493 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$383 = $m_s_Symbol$();
        var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$383, "organization"));
        var witness$17 = new $c_Lshapeless_Witness$$anon$1(value0$59);
        var $$x137 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        var this$385 = $m_Lreactbuild_model_Implicits$();
        var format$17 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$385);
        var $$x136 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$17);
        var this$389 = $m_Lreactbuild_model_Implicits$();
        var this$388 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$4 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var ev$19 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$388, proxy$4);
        var $$x135 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$389, ev$19)));
        var $$x134 = new $c_Lcom_iz2use_react_components_NotEditable();
        var this$392 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$5 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var textualizable$15 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$392, proxy$5);
        var columnRenderable$8 = $n($$x137).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x136, $$x135, $$x134, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$15));
        var this$492 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$394 = $m_s_Symbol$();
        var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$394, "supplier"));
        var witness$16 = new $c_Lshapeless_Witness$$anon$1(value0$60);
        var $$x141 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var this$396 = $m_Lreactbuild_model_Implicits$();
        var format$18 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$396);
        var format$19 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$18);
        var $$x140 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$19);
        var this$401 = $m_Lreactbuild_model_Implicits$();
        var this$400 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$6 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var ev$20 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$400, proxy$6);
        var ord$8 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$401, ev$20);
        var $$x139 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$8)));
        var $$x138 = new $c_Lcom_iz2use_react_components_NotEditable();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$405 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$7 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var textualizable$16 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$405, proxy$7);
        var textualizable$17 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$16);
        var columnRenderable$7 = $n($$x141).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x140, $$x139, $$x138, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$17));
        var this$491 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$408 = $m_s_Symbol$();
        var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$408, "date"));
        var witness$15 = new $c_Lshapeless_Witness$$anon$1(value0$61);
        var $$x145 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$20 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
        var format$21 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$20);
        var $$x144 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$21);
        var ord$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
        var $$x143 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$9)));
        var $$x142 = new $c_Lcom_iz2use_react_components_NotEditable();
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$18 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
        var textualizable$19 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$18);
        var columnRenderable$6 = $n($$x145).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x144, $$x143, $$x142, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$19));
        var this$490 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$416 = $m_s_Symbol$();
        var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$416, "entryNumber"));
        var witness$14 = new $c_Lshapeless_Witness$$anon$1(value0$62);
        var $$x149 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$22 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
        var format$23 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$22);
        var $$x148 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$23);
        var ord$10 = $m_s_math_Ordering$Int$();
        var $$x147 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$10)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$21 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$21);
        var optioner$6 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var parser$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var resolver$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
        var $$x146 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$6, resolver$5);
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var textualizable$20 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$8);
        var columnRenderable$5 = $n($$x149).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x148, $$x147, $$x146, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$20));
        var this$489 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$428 = $m_s_Symbol$();
        var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$428, "reference"));
        var witness$13 = new $c_Lshapeless_Witness$$anon$1(value0$63);
        var $$x153 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$24 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var format$25 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$24);
        var $$x152 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$25);
        var ord$11 = $m_s_math_Ordering$String$();
        var $$x151 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$11)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$22 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$22);
        var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
        var optioner$7 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$23 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var parser$6 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$23);
        var resolver$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
        var $$x150 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$7, resolver$6);
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var textualizable$21 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$10);
        var columnRenderable$4 = $n($$x153).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x152, $$x151, $$x150, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$21));
        var this$488 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.InvoicePageGroup", "Seq[reactbuild.model.InvoicePage]");
        var this$487 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$442 = $m_s_Symbol$();
        var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$442, "totalAmount"));
        var witness$12 = new $c_Lshapeless_Witness$$anon$1(value0$64);
        var $$x157 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$26 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
        var format$27 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$26);
        var $$x156 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$27);
        var ord$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
        var $$x155 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$12)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$24 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$24);
        var optioner$8 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var parser$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var resolver$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
        var $$x154 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$8, resolver$7);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$22 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var textualizable$23 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$22);
        var columnRenderable$3 = $n($$x157).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x156, $$x155, $$x154, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$23));
        var this$486 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$453 = $m_s_Symbol$();
        var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$453, "expectedAmount"));
        var witness$11 = new $c_Lshapeless_Witness$$anon$1(value0$65);
        var $$x161 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$28 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
        var format$29 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$28);
        var $$x160 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$29);
        var ord$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
        var $$x159 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$13)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$25 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$25);
        var optioner$9 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var parser$8 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var resolver$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$8);
        var $$x158 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$9, resolver$8);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$24 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var textualizable$25 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$24);
        var columnRenderable$2 = $n($$x161).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x160, $$x159, $$x158, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$25));
        var this$485 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$464 = $m_s_Symbol$();
        var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$464, "received"));
        var witness$10 = new $c_Lshapeless_Witness$$anon$1(value0$66);
        var $$x165 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$30 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
        var format$31 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$30);
        var $$x164 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$31);
        var ord$14 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
        var $$x163 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$14)));
        var $$x162 = new $c_Lcom_iz2use_react_components_NotEditable();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$470 = $m_Lreactbuild_model_Implicits$();
        var locale$1 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
        var textualizable$26 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$470, locale$1);
        var textualizable$27 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$26);
        var columnRenderable$1 = $n($$x165).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x164, $$x163, $$x162, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$27));
        var this$484 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$473 = $m_s_Symbol$();
        var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$473, "category"));
        var witness$9 = new $c_Lshapeless_Witness$$anon$1(value0$67);
        var $$x169 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$32 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
        var format$33 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$32);
        var $$x168 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$33);
        var ord$15 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
        var $$x167 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$15)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$26 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$26);
        var optioner$10 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var resolver$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
        var $$x166 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$10, resolver$9);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$28 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
        var textualizable$29 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$28);
        var columnRenderable = $n($$x169).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x168, $$x167, $$x166, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$29));
        var tail$10 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
        var tail$11 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$484, columnRenderable, witness$9, tail$10);
        var tail$12 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$485, columnRenderable$1, witness$10, tail$11);
        var tail$13 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$486, columnRenderable$2, witness$11, tail$12);
        var tail$14 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$487, columnRenderable$3, witness$12, tail$13);
        var tail$15 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$488, tail$14);
        var tail$16 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$489, columnRenderable$4, witness$13, tail$15);
        var tail$17 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$490, columnRenderable$5, witness$14, tail$16);
        var tail$18 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$491, columnRenderable$6, witness$15, tail$17);
        var tail$19 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$492, columnRenderable$7, witness$16, tail$18);
        var renderer$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$493, columnRenderable$8, witness$17, tail$19);
        $m_s_DummyImplicit$();
        new $c_Lshapeless_Refute$$anon$2();
        var columnFragment = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$1);
        var view = new $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment);
        var tail$20 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2();
        var tail$21 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view, tail$20);
        var tail$22 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$1, tail$21);
        var tail$23 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$500, tail$22);
        var tail$24 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$2, tail$23);
        var tail$25 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$502, tail$24);
        var tail$26 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$503, tail$25);
        var tail$27 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$504, tail$26);
        var mat = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$505, tail$27);
        $m_s_DummyImplicit$();
        new $c_Lshapeless_Refute$$anon$2();
        var $$x170 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViews(mat.apply__sci_List());
        var $$x74 = $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$().Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable;
        var this$508 = $m_s_Symbol$();
        var $$x31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$508, "organization"));
        var this$509 = $m_s_Symbol$();
        var $$x30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$509, "supplier"));
        var this$510 = $m_s_Symbol$();
        var $$x29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$510, "date"));
        var this$511 = $m_s_Symbol$();
        var $$x28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$511, "entryNumber"));
        var this$512 = $m_s_Symbol$();
        var $$x27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$512, "reference"));
        var this$513 = $m_s_Symbol$();
        var $$x26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$513, "pages"));
        var this$514 = $m_s_Symbol$();
        var $$x25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$514, "totalAmount"));
        var this$515 = $m_s_Symbol$();
        var $$x24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$515, "expectedAmount"));
        var this$516 = $m_s_Symbol$();
        var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$516, "received"));
        var this$517 = $m_s_Symbol$();
        var labels$3 = new $c_Lshapeless_$colon$colon($$x31, new $c_Lshapeless_$colon$colon($$x30, new $c_Lshapeless_$colon$colon($$x29, new $c_Lshapeless_$colon$colon($$x28, new $c_Lshapeless_$colon$colon($$x27, new $c_Lshapeless_$colon$colon($$x26, new $c_Lshapeless_$colon$colon($$x25, new $c_Lshapeless_$colon$colon($$x24, new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$517, "category")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
        var f$3 = new $c_sjsr_AnonFunction1(((x0$16$2) => {
          var x0$16 = $as_Lreactbuild_model_InvoicePageGroup(x0$16$2);
          if ((x0$16 !== null)) {
            var organization$macro$151 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_organization;
            var supplier$macro$152 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_supplier;
            var date$macro$153 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_date;
            var entryNumber$macro$154 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
            var reference$macro$155 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_reference;
            var pages$macro$156 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_pages;
            var totalAmount$macro$157 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
            var expectedAmount$macro$158 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
            var received$macro$159 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_received;
            var category$macro$160 = $n(x0$16).Lreactbuild_model_InvoicePageGroup__f_category;
            return new $c_Lshapeless_$colon$colon(organization$macro$151, new $c_Lshapeless_$colon$colon(supplier$macro$152, new $c_Lshapeless_$colon$colon(date$macro$153, new $c_Lshapeless_$colon$colon(entryNumber$macro$154, new $c_Lshapeless_$colon$colon(reference$macro$155, new $c_Lshapeless_$colon$colon(pages$macro$156, new $c_Lshapeless_$colon$colon(totalAmount$macro$157, new $c_Lshapeless_$colon$colon(expectedAmount$macro$158, new $c_Lshapeless_$colon$colon(received$macro$159, new $c_Lshapeless_$colon$colon(category$macro$160, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$16)
          }
        }));
        var g$3 = new $c_sjsr_AnonFunction1(((x0$17$2) => {
          var x0$17 = $as_Lshapeless_$colon$colon(x0$17$2);
          if ((x0$17 !== null)) {
            var organization$macro$141 = $as_Lreactbuild_common_model_RefTo($n(x0$17).Lshapeless_$colon$colon__f_head);
            var p2$4 = $as_Lshapeless_$colon$colon($n(x0$17).Lshapeless_$colon$colon__f_tail);
            if ((p2$4 !== null)) {
              var supplier$macro$142 = $as_s_Option($n(p2$4).Lshapeless_$colon$colon__f_head);
              var p3$3 = $as_Lshapeless_$colon$colon($n(p2$4).Lshapeless_$colon$colon__f_tail);
              if ((p3$3 !== null)) {
                var date$macro$143 = $as_s_Option($n(p3$3).Lshapeless_$colon$colon__f_head);
                var p4$4 = $as_Lshapeless_$colon$colon($n(p3$3).Lshapeless_$colon$colon__f_tail);
                if ((p4$4 !== null)) {
                  var entryNumber$macro$144 = $as_s_Option($n(p4$4).Lshapeless_$colon$colon__f_head);
                  var p5$3 = $as_Lshapeless_$colon$colon($n(p4$4).Lshapeless_$colon$colon__f_tail);
                  if ((p5$3 !== null)) {
                    var reference$macro$145 = $as_s_Option($n(p5$3).Lshapeless_$colon$colon__f_head);
                    var p6$3 = $as_Lshapeless_$colon$colon($n(p5$3).Lshapeless_$colon$colon__f_tail);
                    if ((p6$3 !== null)) {
                      var pages$macro$146 = $as_sci_Seq($n(p6$3).Lshapeless_$colon$colon__f_head);
                      var p7$3 = $as_Lshapeless_$colon$colon($n(p6$3).Lshapeless_$colon$colon__f_tail);
                      if ((p7$3 !== null)) {
                        var totalAmount$macro$147 = $as_s_Option($n(p7$3).Lshapeless_$colon$colon__f_head);
                        var p8$3 = $as_Lshapeless_$colon$colon($n(p7$3).Lshapeless_$colon$colon__f_tail);
                        if ((p8$3 !== null)) {
                          var expectedAmount$macro$148 = $as_s_Option($n(p8$3).Lshapeless_$colon$colon__f_head);
                          var p9$3 = $as_Lshapeless_$colon$colon($n(p8$3).Lshapeless_$colon$colon__f_tail);
                          if ((p9$3 !== null)) {
                            var received$macro$149 = $as_s_Option($n(p9$3).Lshapeless_$colon$colon__f_head);
                            var p10$3 = $as_Lshapeless_$colon$colon($n(p9$3).Lshapeless_$colon$colon__f_tail);
                            if ((p10$3 !== null)) {
                              var category$macro$150 = $as_s_Option($n(p10$3).Lshapeless_$colon$colon__f_head);
                              var p11$3 = $as_Lshapeless_HNil($n(p10$3).Lshapeless_$colon$colon__f_tail);
                              var x$5 = $m_Lshapeless_HNil$();
                              if ((x$5 === p11$3)) {
                                return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$141, supplier$macro$142, date$macro$143, entryNumber$macro$144, reference$macro$145, pages$macro$146, totalAmount$macro$147, expectedAmount$macro$148, received$macro$149, category$macro$150)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$17)
        }));
        var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys$30 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$520 = $m_s_Symbol$();
        var value0$68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$520, "category"));
        new $c_Lshapeless_Witness$$anon$1(value0$68);
        var zipWithKeys$31 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$30);
        $m_Lshapeless_Witness$();
        var this$523 = $m_s_Symbol$();
        var value0$69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$523, "received"));
        new $c_Lshapeless_Witness$$anon$1(value0$69);
        var zipWithKeys$32 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$31);
        $m_Lshapeless_Witness$();
        var this$526 = $m_s_Symbol$();
        var value0$70 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$526, "expectedAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$70);
        var zipWithKeys$33 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$32);
        $m_Lshapeless_Witness$();
        var this$529 = $m_s_Symbol$();
        var value0$71 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$529, "totalAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$71);
        var zipWithKeys$34 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$33);
        $m_Lshapeless_Witness$();
        var this$532 = $m_s_Symbol$();
        var value0$72 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$532, "pages"));
        new $c_Lshapeless_Witness$$anon$1(value0$72);
        var zipWithKeys$35 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$34);
        $m_Lshapeless_Witness$();
        var this$535 = $m_s_Symbol$();
        var value0$73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$535, "reference"));
        new $c_Lshapeless_Witness$$anon$1(value0$73);
        var zipWithKeys$36 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$35);
        $m_Lshapeless_Witness$();
        var this$538 = $m_s_Symbol$();
        var value0$74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$538, "entryNumber"));
        new $c_Lshapeless_Witness$$anon$1(value0$74);
        var zipWithKeys$37 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$36);
        $m_Lshapeless_Witness$();
        var this$541 = $m_s_Symbol$();
        var value0$75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$541, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$75);
        var zipWithKeys$38 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$37);
        $m_Lshapeless_Witness$();
        var this$544 = $m_s_Symbol$();
        var value0$76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$544, "supplier"));
        new $c_Lshapeless_Witness$$anon$1(value0$76);
        var zipWithKeys$39 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$38);
        $m_Lshapeless_Witness$();
        var this$547 = $m_s_Symbol$();
        var value0$77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$547, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$77);
        var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$39);
        var this$550 = $m_s_$less$colon$less$();
        var ev$27 = this$550.s_$less$colon$less$__f_singleton;
        new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$27);
        $m_Lshapeless_Witness$();
        var this$552 = $m_s_Symbol$();
        var value0$78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$552, "organization"));
        var witness$26 = new $c_Lshapeless_Witness$$anon$1(value0$78);
        var $$x35 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var this$554 = $m_Lreactbuild_model_Implicits$();
        var format$34 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$554);
        var $$x34 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$34);
        var this$558 = $m_Lreactbuild_model_Implicits$();
        var this$557 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$8 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var ev$28 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$557, proxy$8);
        var $$x33 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$558, ev$28)));
        var $$x32 = new $c_Lcom_iz2use_react_components_NotEditable();
        var this$561 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$9 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var textualizable$30 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$561, proxy$9);
        var fieldRenderable$17 = $n($$x35).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x34, $$x33, $$x32, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$30), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        $m_Lshapeless_Witness$();
        var this$563 = $m_s_Symbol$();
        var value0$79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$563, "supplier"));
        var witness$25 = new $c_Lshapeless_Witness$$anon$1(value0$79);
        var $$x39 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var this$565 = $m_Lreactbuild_model_Implicits$();
        var format$35 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$565);
        var format$36 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$35);
        var $$x38 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$36);
        var this$570 = $m_Lreactbuild_model_Implicits$();
        var this$569 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$10 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var ev$29 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$569, proxy$10);
        var ord$16 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$570, ev$29);
        var $$x37 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$16)));
        var $$x36 = new $c_Lcom_iz2use_react_components_NotEditable();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$574 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$11 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var textualizable$31 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$574, proxy$11);
        var textualizable$32 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$31);
        var fieldRenderable$16 = $n($$x39).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x38, $$x37, $$x36, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$32), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        $m_Lshapeless_Witness$();
        var this$577 = $m_s_Symbol$();
        var value0$80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$577, "date"));
        var witness$24 = new $c_Lshapeless_Witness$$anon$1(value0$80);
        var $$x43 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$37 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
        var format$38 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$37);
        var $$x42 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$38);
        var ord$17 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
        var $$x41 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$17)));
        var $$x40 = new $c_Lcom_iz2use_react_components_NotEditable();
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$33 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
        var textualizable$34 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$33);
        var fieldRenderable$15 = $n($$x43).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x42, $$x41, $$x40, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$34), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        $m_Lshapeless_Witness$();
        var this$585 = $m_s_Symbol$();
        var value0$81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$585, "entryNumber"));
        var witness$23 = new $c_Lshapeless_Witness$$anon$1(value0$81);
        var $$x48 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$39 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
        var format$40 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$39);
        var $$x47 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$40);
        var ord$18 = $m_s_math_Ordering$Int$();
        var $$x46 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$18)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$30 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$30);
        var optioner$11 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var parser$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var resolver$10 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$9);
        var $$x45 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$11, resolver$10);
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var textualizable$35 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$15);
        var $$x44 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$35);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$31 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var fieldRenderable$14 = $n($$x48).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x47, $$x46, $$x45, $$x44, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$31))));
        $m_Lshapeless_Witness$();
        var this$598 = $m_s_Symbol$();
        var value0$82 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$598, "reference"));
        var witness$22 = new $c_Lshapeless_Witness$$anon$1(value0$82);
        var $$x53 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$41 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var format$42 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$41);
        var $$x52 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$42);
        var ord$19 = $m_s_math_Ordering$String$();
        var $$x51 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$19)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$32 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$32);
        var evDefault$3 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
        var optioner$12 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$33 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var parser$10 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$33);
        var resolver$11 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$10);
        var $$x50 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$12, resolver$11);
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var textualizable$36 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$17);
        var $$x49 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$36);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$34 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var fieldRenderable$13 = $n($$x53).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x52, $$x51, $$x50, $$x49, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$34))));
        var this$662 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
        $m_Lshapeless_Witness$();
        var this$613 = $m_s_Symbol$();
        var value0$83 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$613, "totalAmount"));
        var witness$21 = new $c_Lshapeless_Witness$$anon$1(value0$83);
        var $$x58 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$43 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
        var format$44 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$43);
        var $$x57 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$44);
        var ord$20 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
        var $$x56 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$20)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$35 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$35);
        var optioner$13 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var parser$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var resolver$12 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$11);
        var $$x55 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$13, resolver$12);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$37 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var textualizable$38 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$37);
        var $$x54 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$38);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$36 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var fieldRenderable$12 = $n($$x58).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x57, $$x56, $$x55, $$x54, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$36))));
        $m_Lshapeless_Witness$();
        var this$625 = $m_s_Symbol$();
        var value0$84 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$625, "expectedAmount"));
        var witness$20 = new $c_Lshapeless_Witness$$anon$1(value0$84);
        var $$x63 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$45 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
        var format$46 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$45);
        var $$x62 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$46);
        var ord$21 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
        var $$x61 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$21)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$37 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$37);
        var optioner$14 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var parser$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var resolver$13 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$12);
        var $$x60 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$14, resolver$13);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$39 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var textualizable$40 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$39);
        var $$x59 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$40);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$38 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var fieldRenderable$11 = $n($$x63).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x62, $$x61, $$x60, $$x59, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$38))));
        $m_Lshapeless_Witness$();
        var this$637 = $m_s_Symbol$();
        var value0$85 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$637, "received"));
        var witness$19 = new $c_Lshapeless_Witness$$anon$1(value0$85);
        var $$x67 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$47 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
        var format$48 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$47);
        var $$x66 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$48);
        var ord$22 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
        var $$x65 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$22)));
        var $$x64 = new $c_Lcom_iz2use_react_components_NotEditable();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$643 = $m_Lreactbuild_model_Implicits$();
        var locale$2 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
        var textualizable$41 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$643, locale$2);
        var textualizable$42 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$41);
        var fieldRenderable$10 = $n($$x67).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x66, $$x65, $$x64, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$42), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        $m_Lshapeless_Witness$();
        var this$646 = $m_s_Symbol$();
        var value0$86 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$646, "category"));
        var witness$18 = new $c_Lshapeless_Witness$$anon$1(value0$86);
        var $$x72 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        $m_Lcom_iz2use_react_components_internal_multiview_Format$();
        var format$49 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
        var format$50 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$49);
        var $$x71 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$50);
        var ord$23 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
        var $$x70 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$23)));
        $m_Lcom_iz2use_common_Parsable$();
        var ev$39 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
        new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$39);
        var optioner$15 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
        var resolver$14 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
        var $$x69 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$15, resolver$14);
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$43 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
        var textualizable$44 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$43);
        var $$x68 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$44);
        $m_Lcom_iz2use_common_Parsable$();
        var ev$40 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
        var fieldRenderable$9 = $n($$x72).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x71, $$x70, $$x69, $$x68, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$40))));
        var tail$28 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3();
        var tail$29 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$9, witness$18, tail$28);
        var tail$30 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$10, witness$19, tail$29);
        var tail$31 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$11, witness$20, tail$30);
        var tail$32 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$12, witness$21, tail$31);
        var tail$33 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$662, tail$32);
        var tail$34 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$13, witness$22, tail$33);
        var tail$35 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$14, witness$23, tail$34);
        var tail$36 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$15, witness$24, tail$35);
        var tail$37 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$16, witness$25, tail$36);
        var renderer$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$17, witness$26, tail$37);
        var $$x73 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$2);
        var $$x22 = $m_Lreactbuild_model_InvoicePageGroup$().keyMapperInvoicePageGroup__Lcom_iz2use_common_KeyMapper();
        var $$x21 = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
        var $$x20 = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
        var this$669 = $m_s_Symbol$();
        var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$669, "organization"));
        var this$670 = $m_s_Symbol$();
        var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$670, "supplier"));
        var this$671 = $m_s_Symbol$();
        var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$671, "date"));
        var this$672 = $m_s_Symbol$();
        var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$672, "entryNumber"));
        var this$673 = $m_s_Symbol$();
        var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$673, "reference"));
        var this$674 = $m_s_Symbol$();
        var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$674, "pages"));
        var this$675 = $m_s_Symbol$();
        var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$675, "totalAmount"));
        var this$676 = $m_s_Symbol$();
        var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$676, "expectedAmount"));
        var this$677 = $m_s_Symbol$();
        var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$677, "received"));
        var this$678 = $m_s_Symbol$();
        var labels$4 = new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$678, "category")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$4);
        var f$4 = new $c_sjsr_AnonFunction1(((x0$20$2) => {
          var x0$20 = $as_Lreactbuild_model_InvoicePageGroup(x0$20$2);
          if ((x0$20 !== null)) {
            var organization$macro$191 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_organization;
            var supplier$macro$192 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_supplier;
            var date$macro$193 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_date;
            var entryNumber$macro$194 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
            var reference$macro$195 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_reference;
            var pages$macro$196 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_pages;
            var totalAmount$macro$197 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
            var expectedAmount$macro$198 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
            var received$macro$199 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_received;
            var category$macro$200 = $n(x0$20).Lreactbuild_model_InvoicePageGroup__f_category;
            return new $c_Lshapeless_$colon$colon(organization$macro$191, new $c_Lshapeless_$colon$colon(supplier$macro$192, new $c_Lshapeless_$colon$colon(date$macro$193, new $c_Lshapeless_$colon$colon(entryNumber$macro$194, new $c_Lshapeless_$colon$colon(reference$macro$195, new $c_Lshapeless_$colon$colon(pages$macro$196, new $c_Lshapeless_$colon$colon(totalAmount$macro$197, new $c_Lshapeless_$colon$colon(expectedAmount$macro$198, new $c_Lshapeless_$colon$colon(received$macro$199, new $c_Lshapeless_$colon$colon(category$macro$200, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$20)
          }
        }));
        var g$4 = new $c_sjsr_AnonFunction1(((x0$21$2) => {
          var x0$21 = $as_Lshapeless_$colon$colon(x0$21$2);
          if ((x0$21 !== null)) {
            var organization$macro$181 = $as_Lreactbuild_common_model_RefTo($n(x0$21).Lshapeless_$colon$colon__f_head);
            var p2$5 = $as_Lshapeless_$colon$colon($n(x0$21).Lshapeless_$colon$colon__f_tail);
            if ((p2$5 !== null)) {
              var supplier$macro$182 = $as_s_Option($n(p2$5).Lshapeless_$colon$colon__f_head);
              var p3$4 = $as_Lshapeless_$colon$colon($n(p2$5).Lshapeless_$colon$colon__f_tail);
              if ((p3$4 !== null)) {
                var date$macro$183 = $as_s_Option($n(p3$4).Lshapeless_$colon$colon__f_head);
                var p4$5 = $as_Lshapeless_$colon$colon($n(p3$4).Lshapeless_$colon$colon__f_tail);
                if ((p4$5 !== null)) {
                  var entryNumber$macro$184 = $as_s_Option($n(p4$5).Lshapeless_$colon$colon__f_head);
                  var p5$4 = $as_Lshapeless_$colon$colon($n(p4$5).Lshapeless_$colon$colon__f_tail);
                  if ((p5$4 !== null)) {
                    var reference$macro$185 = $as_s_Option($n(p5$4).Lshapeless_$colon$colon__f_head);
                    var p6$4 = $as_Lshapeless_$colon$colon($n(p5$4).Lshapeless_$colon$colon__f_tail);
                    if ((p6$4 !== null)) {
                      var pages$macro$186 = $as_sci_Seq($n(p6$4).Lshapeless_$colon$colon__f_head);
                      var p7$4 = $as_Lshapeless_$colon$colon($n(p6$4).Lshapeless_$colon$colon__f_tail);
                      if ((p7$4 !== null)) {
                        var totalAmount$macro$187 = $as_s_Option($n(p7$4).Lshapeless_$colon$colon__f_head);
                        var p8$4 = $as_Lshapeless_$colon$colon($n(p7$4).Lshapeless_$colon$colon__f_tail);
                        if ((p8$4 !== null)) {
                          var expectedAmount$macro$188 = $as_s_Option($n(p8$4).Lshapeless_$colon$colon__f_head);
                          var p9$4 = $as_Lshapeless_$colon$colon($n(p8$4).Lshapeless_$colon$colon__f_tail);
                          if ((p9$4 !== null)) {
                            var received$macro$189 = $as_s_Option($n(p9$4).Lshapeless_$colon$colon__f_head);
                            var p10$4 = $as_Lshapeless_$colon$colon($n(p9$4).Lshapeless_$colon$colon__f_tail);
                            if ((p10$4 !== null)) {
                              var category$macro$190 = $as_s_Option($n(p10$4).Lshapeless_$colon$colon__f_head);
                              var p11$4 = $as_Lshapeless_HNil($n(p10$4).Lshapeless_$colon$colon__f_tail);
                              var x$6 = $m_Lshapeless_HNil$();
                              if ((x$6 === p11$4)) {
                                return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$181, supplier$macro$182, date$macro$183, entryNumber$macro$184, reference$macro$185, pages$macro$186, totalAmount$macro$187, expectedAmount$macro$188, received$macro$189, category$macro$190)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$21)
        }));
        var gen$8 = new $c_Lshapeless_Generic$$anon$1(f$4, g$4);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys$40 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$681 = $m_s_Symbol$();
        var value0$87 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$681, "category"));
        new $c_Lshapeless_Witness$$anon$1(value0$87);
        var zipWithKeys$41 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$40);
        $m_Lshapeless_Witness$();
        var this$684 = $m_s_Symbol$();
        var value0$88 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$684, "received"));
        new $c_Lshapeless_Witness$$anon$1(value0$88);
        var zipWithKeys$42 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$41);
        $m_Lshapeless_Witness$();
        var this$687 = $m_s_Symbol$();
        var value0$89 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$687, "expectedAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$89);
        var zipWithKeys$43 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$42);
        $m_Lshapeless_Witness$();
        var this$690 = $m_s_Symbol$();
        var value0$90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$690, "totalAmount"));
        new $c_Lshapeless_Witness$$anon$1(value0$90);
        var zipWithKeys$44 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$43);
        $m_Lshapeless_Witness$();
        var this$693 = $m_s_Symbol$();
        var value0$91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$693, "pages"));
        new $c_Lshapeless_Witness$$anon$1(value0$91);
        var zipWithKeys$45 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$44);
        $m_Lshapeless_Witness$();
        var this$696 = $m_s_Symbol$();
        var value0$92 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$696, "reference"));
        new $c_Lshapeless_Witness$$anon$1(value0$92);
        var zipWithKeys$46 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$45);
        $m_Lshapeless_Witness$();
        var this$699 = $m_s_Symbol$();
        var value0$93 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$699, "entryNumber"));
        new $c_Lshapeless_Witness$$anon$1(value0$93);
        var zipWithKeys$47 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$46);
        $m_Lshapeless_Witness$();
        var this$702 = $m_s_Symbol$();
        var value0$94 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$702, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$94);
        var zipWithKeys$48 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$47);
        $m_Lshapeless_Witness$();
        var this$705 = $m_s_Symbol$();
        var value0$95 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$705, "supplier"));
        new $c_Lshapeless_Witness$$anon$1(value0$95);
        var zipWithKeys$49 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$48);
        $m_Lshapeless_Witness$();
        var this$708 = $m_s_Symbol$();
        var value0$96 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$708, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$96);
        var zip$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$49);
        var this$711 = $m_s_$less$colon$less$();
        var ev$41 = this$711.s_$less$colon$less$__f_singleton;
        var gen$9 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$4, gen$8, ev$41);
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$713 = $m_s_Symbol$();
        var value0$97 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$713, "organization"));
        var witness$36 = new $c_Lshapeless_Witness$$anon$1(value0$97);
        var this$717 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        var this$716 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$12 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var textualizable$45 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$716, proxy$12);
        var ev$42 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$9 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$717, textualizable$45, ev$42)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$718 = $m_s_Symbol$();
        var value0$98 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$718, "supplier"));
        var witness$35 = new $c_Lshapeless_Witness$$anon$1(value0$98);
        var this$723 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$721 = $m_Lreactbuild_model_Implicits$();
        $m_Lreactbuild_model_Implicits$();
        var proxy$13 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
        var textualizable$46 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$721, proxy$13);
        var textualizable$47 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$46);
        var ev$43 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$8 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$723, textualizable$47, ev$43)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$724 = $m_s_Symbol$();
        var value0$99 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$724, "date"));
        var witness$34 = new $c_Lshapeless_Witness$$anon$1(value0$99);
        var this$727 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$48 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
        var textualizable$49 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$48);
        var ev$44 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$7 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$727, textualizable$49, ev$44)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$728 = $m_s_Symbol$();
        var value0$100 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$728, "entryNumber"));
        var witness$33 = new $c_Lshapeless_Witness$$anon$1(value0$100);
        var this$732 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$21 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
        var textualizable$50 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$21);
        var ev$45 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$6 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$732, textualizable$50, ev$45)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$733 = $m_s_Symbol$();
        var value0$101 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$733, "reference"));
        var witness$32 = new $c_Lshapeless_Witness$$anon$1(value0$101);
        var this$737 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        $m_Lcom_iz2use_common_Textualizable$();
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$22 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var textualizable$51 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$22);
        var ev$46 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$5 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$737, textualizable$51, ev$46)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$738 = $m_s_Symbol$();
        var value0$102 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$738, "pages"));
        var witness$31 = new $c_Lshapeless_Witness$$anon$1(value0$102);
        var ht$4 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$740 = $m_s_Symbol$();
        var value0$103 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$740, "totalAmount"));
        var witness$30 = new $c_Lshapeless_Witness$$anon$1(value0$103);
        var this$743 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$52 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var textualizable$53 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$52);
        var ev$47 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$3 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$743, textualizable$53, ev$47)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$744 = $m_s_Symbol$();
        var value0$104 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$744, "expectedAmount"));
        var witness$29 = new $c_Lshapeless_Witness$$anon$1(value0$104);
        var this$747 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$54 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
        var textualizable$55 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$54);
        var ev$48 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$2 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$747, textualizable$55, ev$48)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$748 = $m_s_Symbol$();
        var value0$105 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$748, "received"));
        var witness$28 = new $c_Lshapeless_Witness$$anon$1(value0$105);
        var this$752 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        $m_Lcom_iz2use_common_Textualizable$();
        var this$750 = $m_Lreactbuild_model_Implicits$();
        var locale$3 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
        var textualizable$56 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$750, locale$3);
        var textualizable$57 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$56);
        var ev$49 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$1 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$752, textualizable$57, ev$49)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$753 = $m_s_Symbol$();
        var value0$106 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$753, "category"));
        var witness$27 = new $c_Lshapeless_Witness$$anon$1(value0$106);
        var this$756 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        $m_Lcom_iz2use_common_Textualizable$();
        var textualizable$58 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
        var textualizable$59 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$58);
        var ev$50 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$756, textualizable$59, ev$50)));
        var tt = $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$().Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil;
        var tt$1 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt, ht, witness$27);
        var tt$2 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$28);
        var tt$3 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$2, ht$2, witness$29);
        var tt$4 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$3, ht$3, witness$30);
        var tt$5 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$4, ht$4, witness$31);
        var tt$6 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$5, ht$5, witness$32);
        var tt$7 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$6, ht$6, witness$33);
        var tt$8 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$7, ht$7, witness$34);
        var tt$9 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$8, ht$8, witness$35);
        var tokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$9, ht$9, witness$36);
        var $$x19 = new $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer, gen$9);
        var $$x9 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
        var $$x8 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
        var $$x7 = new $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1();
        var $$x6 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
        var $$x5 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
        $m_Lreactbuild_model_Implicits$();
        var this$770 = $m_Ljapgolly_scalajs_react_Reusability$();
        var u = $n($$x182).noExternalStateNorActive__O__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(r$3, $$x181, $$x180, $$x170, $$x74, $$x73, $$x22, $$x21, $$x20, $$x19, $$x9, $$x8, $$x7, $$x6, $$x5, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$770.byRef__F2(), this$770.by_$eq$eq__F2()), new $c_sjsr_AnonFunction1(((evT$2) => {
          var evT = $n($as_Ljapgolly_scalajs_react_Reusability(evT$2)).Ljapgolly_scalajs_react_Reusability__f_test;
          return new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityMultiviewItemColl__F2__F2(evT))
        })), $m_Lcom_iz2use_react_components_internal_multiview_View$().defaultViewOrdering__s_math_Ordering());
        var this$772 = $n(u);
        var n = this$772.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      }));
      var $$x3 = $m_Ljapgolly_scalajs_react_Reusability$();
      $m_Lreactbuild_model_Implicits$();
      var this$775 = $m_Ljapgolly_scalajs_react_Reusability$();
      var u$1 = $n($$x188).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x183, $$x4, $n($$x3).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$775.byRef__F2(), this$775.by_$eq$eq__F2())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
      var this$777 = $n(u$1);
      var n$1 = this$777.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$4 = [$$x189, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
      return $n($$x194).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
    } else if ($n(projectPot).isPending__Z()) {
      return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x195 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x195).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.productPrefix__T = (function() {
  return "ProjectDocuments"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_active;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ProjectDocuments");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_active;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments)) {
    var ProjectDocuments$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects === $n(ProjectDocuments$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects)) {
      var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_active;
      var x$2 = $n(ProjectDocuments$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_active;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  var withSubprojects = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments__f_withSubprojects;
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(newActive, withSubprojects)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectDocuments"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$ProjectDocuments;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectDocuments", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDocuments;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview(active) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview__f_title = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview__f_active = active;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview__f_title = "Aper\u00e7u plan"
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview__f_title
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  if ($n(projectPot).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(projectPot);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(projectPot).get__O();
      var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
      var x1 = $n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_modelSource;
      var x = $m_s_None$();
      if ((x === x1)) {
        var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu \u00e0 afficher, veuillez copier le mod\u00e8le sur le site d'abord."))];
        return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
      } else {
        if ((!(x1 instanceof $c_s_Some))) {
          throw new $c_s_MatchError(x1)
        };
        var x3 = $as_s_Some(x1);
        var s = $n($as_Lcom_iz2use_common_Multiline($n(x3).s_Some__f_value)).Lcom_iz2use_common_Multiline__f_underlying;
        var $$x5 = $m_Lreactbuild_project_PreviewDrawing$();
        var $$x4 = $as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
        var this$19 = $n($n(pageProps).Lreactbuild_package$PageProps__f_proxy);
        var this$20 = $n(this$19.Ldiode_react_ModelProxy__f_modelReader);
        var u = $n($$x5).apply__Lreactbuild_common_model_Project__T__s_Option__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x4, s, new $c_s_Some($n($as_Lreactbuild_analyze_cost_services_Model(this$20.value__O())).Lreactbuild_analyze_cost_services_Model__f_serverConnection));
        var this$22 = $n(u);
        var n = this$22.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      }
    } else if ($n(projectPot).isPending__Z()) {
      return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x6 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.productPrefix__T = (function() {
  return "ProjectDrawingPreview"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview__f_active : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview)) {
    var ProjectDrawingPreview$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview__f_active;
    var x$2 = $n(ProjectDrawingPreview$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview__f_active;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview(newActive)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectDrawingPreview"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$ProjectDrawingPreview;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectDrawingPreview", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectDrawingPreview;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures(active) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures__f_active = active
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.title__T = (function() {
  return "Proc\u00e9dures"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  var $$x1 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var array = [$m_Lreactbuild_process_Processes$().apply__Ldiode_data_Pot__Lreactbuild_process_Processes$UseProcessArg__Ljapgolly_scalajs_react_vdom_TagOf($n(projectPot).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$4$2);
    return $n($as_Lreactbuild_common_model_Project($n(x$4).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id
  }))), $m_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$())];
  return $n($$x1).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("processes", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.productPrefix__T = (function() {
  return "ProjectProcedures"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures__f_active : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures)) {
    var ProjectProcedures$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures__f_active;
    var x$2 = $n(ProjectProcedures$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures__f_active;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures(newActive)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectProcedures"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$ProjectProcedures;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectProcedures", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectProcedures;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary(active) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary__f_active = active
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.title__T = (function() {
  return "Synth\u00e8se"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  var $$x1 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var u = $m_Lreactbuild_project_Summary$().apply__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(projectPot, allProjects, pageProps);
  var this$5 = $n(u);
  var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  return $n($$x1).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("summary", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.productPrefix__T = (function() {
  return "ProjectSummary"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary__f_active : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary)) {
    var ProjectSummary$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary__f_active;
    var x$2 = $n(ProjectSummary$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary__f_active;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary(newActive)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectSummary"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$ProjectSummary;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectSummary", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply(active) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply__f_title = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply__f_active = active;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply__f_title = "Approvisionnements"
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply__f_title
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  if ($n(projectPot).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(projectPot);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(projectPot).get__O();
      var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
      var this$12 = $n($n(pageProps).Lreactbuild_package$PageProps__f_proxy);
      var this$13 = $n(this$12.Ldiode_react_ModelProxy__f_modelReader);
      var this$14 = $n($n($n($as_Lreactbuild_analyze_cost_services_Model(this$13.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged).toList__sci_List());
      var rest = this$14;
      var h = null;
      var t = null;
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var logged = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(arg1$1);
        var this$16 = $n($n(logged).Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations);
        var p = new $c_sjsr_AnonFunction1(((project) => ((org$2) => {
          var org = $as_Lreactbuild_common_model_LoggedUserOrganization(org$2);
          return $n($n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_organizations).contains__O__Z($n(org).Lreactbuild_common_model_LoggedUserOrganization__f__id)
        }))(project));
        var it = $n($as_sci_List($ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this$16, p).map__F1__O(new $c_sjsr_AnonFunction1(((org$3$2) => {
          var org$3 = $as_Lreactbuild_common_model_LoggedUserOrganization(org$3$2);
          return org$3
        }))))).iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
          if ((t === null)) {
            h = nx
          } else {
            $n(t).sci_$colon$colon__f_next = nx
          };
          t = nx
        };
        rest = $as_sci_List($n(rest).tail__O())
      };
      var organizations = ((h === null) ? $m_sci_Nil$() : h);
      if ((organizations instanceof $c_sci_$colon$colon)) {
        var x2 = $as_sci_$colon$colon(organizations);
        var org$1 = $as_Lreactbuild_common_model_LoggedUserOrganization($n(x2).sci_$colon$colon__f_head);
        var p3 = $n(x2).sci_$colon$colon__f_next;
        var x = $m_s_package$().s_package$__f_Nil;
        if (((x === null) ? (p3 === null) : $n(x).equals__O__Z(p3))) {
          var $$x3 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
          var u = $m_Lreactbuild_analyze_cost_modules_SupplyList$().apply__s_Option__Lreactbuild_common_model_RefTo__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($m_s_Option$().apply__O__s_Option($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $n(org$1).Lreactbuild_common_model_LoggedUserOrganization__f_organizationUser, ($m_Lreactbuild_model_Implicits$(), $n(pageProps).Lreactbuild_package$PageProps__f_proxy));
          var this$22 = $n(u);
          var n = this$22.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
          var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
          return $n($$x3).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("listSupplies", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
        }
      };
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9sol\u00e9, les projets multi-organisations ne sont pas encore g\u00e9r\u00e9es pour les listes de travail."))];
      return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    } else if ($n(projectPot).isPending__Z()) {
      return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.productPrefix__T = (function() {
  return "ProjectSupply"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply__f_active : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply)) {
    var ProjectSupply$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply__f_active;
    var x$2 = $n(ProjectSupply$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply__f_active;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply(newActive)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectSupply"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$ProjectSupply;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectSupply", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSupply;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList(active) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList__f_title = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList__f_active = active;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList__f_title = "Liste de travail"
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList__f_title
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  if ($n(projectPot).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(projectPot);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(projectPot).get__O();
      var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
      var this$12 = $n($n(pageProps).Lreactbuild_package$PageProps__f_proxy);
      var this$13 = $n(this$12.Ldiode_react_ModelProxy__f_modelReader);
      var this$14 = $n($n($n($as_Lreactbuild_analyze_cost_services_Model(this$13.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged).toList__sci_List());
      var rest = this$14;
      var h = null;
      var t = null;
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var logged = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(arg1$1);
        var this$16 = $n($n(logged).Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations);
        var p = new $c_sjsr_AnonFunction1(((project) => ((org$2) => {
          var org = $as_Lreactbuild_common_model_LoggedUserOrganization(org$2);
          return $n($n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f_organizations).contains__O__Z($n(org).Lreactbuild_common_model_LoggedUserOrganization__f__id)
        }))(project));
        var it = $n($as_sci_List($ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this$16, p).map__F1__O(new $c_sjsr_AnonFunction1(((org$3$2) => {
          var org$3 = $as_Lreactbuild_common_model_LoggedUserOrganization(org$3$2);
          return org$3
        }))))).iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
          if ((t === null)) {
            h = nx
          } else {
            $n(t).sci_$colon$colon__f_next = nx
          };
          t = nx
        };
        rest = $as_sci_List($n(rest).tail__O())
      };
      var organizations = ((h === null) ? $m_sci_Nil$() : h);
      if ((organizations instanceof $c_sci_$colon$colon)) {
        var x2 = $as_sci_$colon$colon(organizations);
        var org$1 = $as_Lreactbuild_common_model_LoggedUserOrganization($n(x2).sci_$colon$colon__f_head);
        var p3 = $n(x2).sci_$colon$colon__f_next;
        var x = $m_s_package$().s_package$__f_Nil;
        if (((x === null) ? (p3 === null) : $n(x).equals__O__Z(p3))) {
          var $$x3 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
          var u = $m_Lreactbuild_analyze_cost_modules_EntryList$().apply__Lreactbuild_common_model_Project__Lreactbuild_common_model_RefTo__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), $n(org$1).Lreactbuild_common_model_LoggedUserOrganization__f_organizationUser, ($m_Lreactbuild_model_Implicits$(), $n(pageProps).Lreactbuild_package$PageProps__f_proxy));
          var this$22 = $n(u);
          var n = this$22.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
          var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
          return $n($$x3).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement("listEntries", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
        }
      };
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$2 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("D\u00e9sol\u00e9, les projets multi-organisations ne sont pas encore g\u00e9r\u00e9es pour les listes de travail."))];
      return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    } else if ($n(projectPot).isPending__Z()) {
      return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.productPrefix__T = (function() {
  return "ProjectTaskList"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList__f_active : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList)) {
    var ProjectTaskList$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList__f_active;
    var x$2 = $n(ProjectTaskList$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList__f_active;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList(newActive)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectTaskList"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$ProjectTaskList;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectTaskList", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectTaskList;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails(active) {
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails__f_active = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails__f_title = null;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails__f_active = active;
  this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails__f_title = "D\u00e9tails"
}
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype = $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype;
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.active__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails__f_active
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails__f_title
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.render__Ldiode_data_Pot__sci_List__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_vdom_VdomNode = (function(projectPot, allProjects, pageProps) {
  if ($n(projectPot).isFailed__Z()) {
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var $$x1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v = $n(projectPot).toString__T();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array = [$$x1, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    var this$11 = $n(projectPot);
    if ((!this$11.isEmpty__Z())) {
      var arg1 = $n(projectPot).get__O();
      var project = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
      var $$x3 = $m_Lreactbuild_analyze_cost_modules_EditProject$();
      var this$12 = $n($n($as_Lreactbuild_common_model_Project($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_common_model_Project__f__id);
      var u = $n($$x3).withKey__T__Lreactbuild_package$PageProps__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($m_sr_ScalaRunTime$()._toString__s_Product__T(this$12), pageProps, project);
      var this$14 = $n(u);
      var n = this$14.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    } else if ($n(projectPot).isPending__Z()) {
      return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
    } else {
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
      return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.productPrefix__T = (function() {
  return "ProjectViewDetails"
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails__f_active : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails)) {
    var ProjectViewDetails$1 = $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails__f_active;
    var x$2 = $n(ProjectViewDetails$1).Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails__f_active;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.withProject__s_Option__Lreactbuild_analyze_cost_modules_project_ProjectView = (function(newActive) {
  return new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails(newActive)
});
function $as_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectViewDetails"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.project.ProjectView$ProjectViewDetails;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails: 0
}, false, "reactbuild.analyze.cost.modules.project.ProjectView$ProjectViewDetails", {
  Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_project_ProjectView: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectViewDetails;
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$() {
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_reactbuild$analyze$cost$services$AppCircuit$$id = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_connectionToServerState = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_connectionToServer = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_libraryHandler = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_commonDataHandler = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_globalHandler = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_connectedUserHandler = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_actionHandler = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_model = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$modelRW = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$isDispatching = false;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$dispatchQueue = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listenerId = 0;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$listeners = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$processors = null;
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$processChain = null;
  $n_Lreactbuild_analyze_cost_services_AppCircuit$ = this;
  $f_Ldiode_Circuit__$init$__V(this);
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_reactbuild$analyze$cost$services$AppCircuit$$id = $m_ju_UUID$().randomUUID__ju_UUID();
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_connectionToServerState = new $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1();
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_connectionToServer = new $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2();
  var get = new $c_sjsr_AnonFunction1(((x$41$2) => {
    var x$41 = $as_Lreactbuild_analyze_cost_services_RootModel(x$41$2);
    return $n(x$41).Lreactbuild_analyze_cost_services_RootModel__f_model
  }));
  var set = new $c_sjsr_AnonFunction2(((m$2, t$2) => {
    var m = $as_Lreactbuild_analyze_cost_services_RootModel(m$2);
    var t = $as_Lreactbuild_analyze_cost_services_Model(t$2);
    $n(m);
    return new $c_Lreactbuild_analyze_cost_services_RootModel(t)
  }));
  var feq = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  var this$4 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$modelRW);
  var this$13 = new $c_Ldiode_ZoomModelRW(this$4, get, set, feq);
  var get$1 = new $c_sjsr_AnonFunction1(((x$42$2) => {
    var x$42 = $as_Lreactbuild_analyze_cost_services_Model(x$42$2);
    return $n(x$42).Lreactbuild_analyze_cost_services_Model__f_library
  }));
  var set$1 = new $c_sjsr_AnonFunction2(((m$3$2, t$3$2) => {
    var m$3 = $as_Lreactbuild_analyze_cost_services_Model(m$3$2);
    var t$3 = $as_Ldiode_data_Pot(t$3$2);
    var this$5 = $n(m$3);
    var x$44 = this$5.Lreactbuild_analyze_cost_services_Model__f_logged;
    var this$6 = $n(m$3);
    var x$45 = this$6.Lreactbuild_analyze_cost_services_Model__f_activeOrganization;
    var this$7 = $n(m$3);
    var x$46 = this$7.Lreactbuild_analyze_cost_services_Model__f_commonData;
    var this$8 = $n(m$3);
    var x$47 = this$8.Lreactbuild_analyze_cost_services_Model__f_period;
    var this$9 = $n(m$3);
    var x$48 = this$9.Lreactbuild_analyze_cost_services_Model__f_serverConnection;
    var this$10 = $n(m$3);
    var x$49 = this$10.Lreactbuild_analyze_cost_services_Model__f_serverConnectionState;
    var this$11 = $n(m$3);
    var x$50 = this$11.Lreactbuild_analyze_cost_services_Model__f_permissionRequested;
    $n(m$3);
    return new $c_Lreactbuild_analyze_cost_services_Model(x$44, x$45, x$46, x$47, t$3, x$48, x$49, x$50)
  }));
  var feq$1 = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_libraryHandler = new $c_Lreactbuild_common_handlers_LibraryHandler($f_Ldiode_BaseModelRW__zoomRW__F1__F2__Ldiode_FastEq__Ldiode_ZoomModelRW(this$13, get$1, set$1, feq$1), new $c_sjsr_AnonFunction0((() => {
    var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x3 = new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self;
    var $$x2 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "common", "CommonApi", "getLibrary"];
    var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$18 = $n($m_s_Predef$().s_Predef$__f_Map);
    var elems = $m_sci_Nil$();
    return $n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$18.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$51$2) => {
      var x$51 = $as_Lio_circe_Json(x$51$2);
      var this$19 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$21 = $n(new $c_Lautowire_ClientProxy(this$19).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_common_model_AssetDefinition$().Lreactbuild_common_model_AssetDefinition$__f_codecForAssetDefinition;
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$21.read__Lio_circe_Json__Lio_circe_Decoder__O(x$51, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  })));
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_commonDataHandler = new $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3();
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_globalHandler = new $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4();
  var get$2 = new $c_sjsr_AnonFunction1(((x$74$2) => {
    var x$74 = $as_Lreactbuild_analyze_cost_services_RootModel(x$74$2);
    return $n(x$74).Lreactbuild_analyze_cost_services_RootModel__f_model
  }));
  var set$2 = new $c_sjsr_AnonFunction2(((m$4$2, t$4$2) => {
    var m$4 = $as_Lreactbuild_analyze_cost_services_RootModel(m$4$2);
    var t$4 = $as_Lreactbuild_analyze_cost_services_Model(t$4$2);
    $n(m$4);
    return new $c_Lreactbuild_analyze_cost_services_RootModel(t$4)
  }));
  var feq$2 = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  var this$23 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$__f_diode$Circuit$$modelRW);
  var this$32 = new $c_Ldiode_ZoomModelRW(this$23, get$2, set$2, feq$2);
  var get$3 = new $c_sjsr_AnonFunction1(((x$75$2) => {
    var x$75 = $as_Lreactbuild_analyze_cost_services_Model(x$75$2);
    return $n(x$75).Lreactbuild_analyze_cost_services_Model__f_logged
  }));
  var set$3 = new $c_sjsr_AnonFunction2(((m$5$2, t$5$2) => {
    var m$5 = $as_Lreactbuild_analyze_cost_services_Model(m$5$2);
    var t$5 = $as_s_Option(t$5$2);
    $n(m$5);
    var this$24 = $n(m$5);
    var activeOrganization = this$24.Lreactbuild_analyze_cost_services_Model__f_activeOrganization;
    var this$25 = $n(m$5);
    var commonData = this$25.Lreactbuild_analyze_cost_services_Model__f_commonData;
    var this$26 = $n(m$5);
    var period = this$26.Lreactbuild_analyze_cost_services_Model__f_period;
    var this$27 = $n(m$5);
    var library = this$27.Lreactbuild_analyze_cost_services_Model__f_library;
    var this$28 = $n(m$5);
    var serverConnection = this$28.Lreactbuild_analyze_cost_services_Model__f_serverConnection;
    var this$29 = $n(m$5);
    var serverConnectionState = this$29.Lreactbuild_analyze_cost_services_Model__f_serverConnectionState;
    var this$30 = $n(m$5);
    var permissionRequested = this$30.Lreactbuild_analyze_cost_services_Model__f_permissionRequested;
    return new $c_Lreactbuild_analyze_cost_services_Model(t$5, activeOrganization, commonData, period, library, serverConnection, serverConnectionState, permissionRequested)
  }));
  var feq$3 = $m_Ldiode_FastEq$().AnyRefEq__Ldiode_FastEqLowPri$AnyRefEq$();
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_connectedUserHandler = new $c_Lreactbuild_common_handlers_UserHandler($f_Ldiode_BaseModelRW__zoomRW__F1__F2__Ldiode_FastEq__Ldiode_ZoomModelRW(this$32, get$3, set$3, feq$3));
  var array$1 = [$m_Ldiode_ActionHandler$().extractHandler__Ldiode_ActionHandler__F2(this.Lreactbuild_analyze_cost_services_AppCircuit$__f_commonDataHandler), $m_Ldiode_ActionHandler$().extractHandler__Ldiode_ActionHandler__F2(this.Lreactbuild_analyze_cost_services_AppCircuit$__f_connectedUserHandler), $m_Ldiode_ActionHandler$().extractHandler__Ldiode_ActionHandler__F2(this.Lreactbuild_analyze_cost_services_AppCircuit$__f_globalHandler), $m_Ldiode_ActionHandler$().extractHandler__Ldiode_ActionHandler__F2(this.Lreactbuild_analyze_cost_services_AppCircuit$__f_libraryHandler), $m_Ldiode_ActionHandler$().extractHandler__Ldiode_ActionHandler__F2(this.Lreactbuild_analyze_cost_services_AppCircuit$__f_connectionToServer), $m_Ldiode_ActionHandler$().extractHandler__Ldiode_ActionHandler__F2(this.Lreactbuild_analyze_cost_services_AppCircuit$__f_connectionToServerState)];
  var handlers = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lreactbuild_analyze_cost_services_AppCircuit$__f_actionHandler = $f_Ldiode_Circuit__foldHandlers__sci_Seq__F2(this, handlers)
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_services_AppCircuit$.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$.prototype.initialModel__Lreactbuild_analyze_cost_services_RootModel = (function() {
  return new $c_Lreactbuild_analyze_cost_services_RootModel(new $c_Lreactbuild_analyze_cost_services_Model($m_s_None$(), $m_s_None$(), $m_Ldiode_data_Unavailable$(), new $c_Lreactbuild_analyze_cost_components_Period($m_Lreactbuild_analyze_cost_components_Period$().apply$default$1__s_Option(), $m_s_None$()), $m_Ldiode_data_Unavailable$(), new $c_Lreactbuild_analyze_cost_services_ServerConnection(), $m_Ldiode_data_Empty$(), new $c_Lreactbuild_analyze_cost_services_PermissionRequested($m_s_package$().s_package$__f_Nil)))
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$", {
  Lreactbuild_analyze_cost_services_AppCircuit$: 1,
  O: 1,
  Ldiode_Circuit: 1,
  Ldiode_Dispatcher: 1,
  Ldiode_ZoomTo: 1,
  Ldiode_react_ReactConnector: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$;
var $n_Lreactbuild_analyze_cost_services_AppCircuit$;
function $m_Lreactbuild_analyze_cost_services_AppCircuit$() {
  if ((!$n_Lreactbuild_analyze_cost_services_AppCircuit$)) {
    $n_Lreactbuild_analyze_cost_services_AppCircuit$ = new $c_Lreactbuild_analyze_cost_services_AppCircuit$()
  };
  return $n_Lreactbuild_analyze_cost_services_AppCircuit$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1(outer) {
  this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1.prototype.applyOrElse__O__F1__O = (function(x1, default$1) {
  var x = $m_Lreactbuild_analyze_cost_actions_ConnectToServer$();
  if ((x === x1)) {
    var $$x1 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer);
    var this$1 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer);
    var qual$1 = $as_Ldiode_data_Pot($n(this$1.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$1.Ldiode_ActionHandler__f_currentModel));
    var t = $n(qual$1).pending$default$1__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return $n($$x1).updated__O__Ldiode_ActionResult($n(qual$1).pending__J__Ldiode_data_Pot(new $c_RTLong(lo, hi)))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectedToServer)) {
    var $$x2 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer);
    var this$2 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer);
    $n($as_Ldiode_data_Pot($n(this$2.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$2.Ldiode_ActionHandler__f_currentModel)));
    return $n($$x2).updated__O__Ldiode_ActionResult(new $c_Ldiode_data_Ready((void 0)))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed)) {
    var x5 = $as_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed(x1);
    var e = $n(x5).Lreactbuild_analyze_cost_actions_ConnectionToServerFailed__f_e;
    var $$x3 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer);
    var this$4 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer);
    return $n($$x3).updated__O__Ldiode_ActionResult($n($as_Ldiode_data_Pot($n(this$4.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$4.Ldiode_ActionHandler__f_currentModel))).fail__jl_Throwable__Ldiode_data_Pot(e))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost)) {
    var $$x4 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer);
    var this$5 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1__f_$outer);
    $n($as_Ldiode_data_Pot($n(this$5.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$5.Ldiode_ActionHandler__f_currentModel)));
    return $n($$x4).updated__O__Ldiode_ActionResult($m_Ldiode_data_Unavailable$())
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1.prototype.isDefinedAt__O__Z = (function(x1) {
  var x = $m_Lreactbuild_analyze_cost_actions_ConnectToServer$();
  if ((x === x1)) {
    return true
  } else {
    return ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectedToServer) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed) || (x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost)))
  }
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$$anon$1$$anonfun$handle$1", {
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$1$$anonfun$handle$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2(outer) {
  this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2.prototype.applyOrElse__O__F1__O = (function(x1, default$1) {
  var rc11 = false;
  var x7 = null;
  var x = $m_Lreactbuild_analyze_cost_actions_InitAction$();
  if ((x === x1)) {
    $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
    var effect = $m_Ldiode_Effect$().action__F0__Ldiode_ActionType__s_concurrent_ExecutionContext__Ldiode_EffectSingle(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_actions_ConnectToServer$())), $m_Ldiode_Action$aType$(), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    return new $c_Ldiode_ActionResult$EffectOnly(effect)
  };
  var x$3 = $m_Lreactbuild_analyze_cost_actions_ConnectToServer$();
  if ((x$3 === x1)) {
    $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
    var f = new $c_sjsr_AnonFunction0((() => $m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer).reactbuild$analyze$cost$services$AppCircuit$$anon$$connectToServer__Ldiode_NoAction$())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)));
    var ec = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    var effect$1 = new $c_Ldiode_EffectSingle(f, ec);
    return new $c_Ldiode_ActionResult$EffectOnly(effect$1)
  };
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectedToServer)) {
    var x4 = $as_Lreactbuild_analyze_cost_actions_ConnectedToServer(x1);
    var ws = $n(x4).Lreactbuild_analyze_cost_actions_ConnectedToServer__f_ws;
    var this$5 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
    $n($as_Lreactbuild_analyze_cost_services_ServerConnection($n(this$5.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$5.Ldiode_ActionHandler__f_currentModel))).Lreactbuild_analyze_cost_services_ServerConnection__f_ws = new $c_s_Some(ws);
    $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
    return $m_Ldiode_ActionResult$NoChange$()
  };
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed)) {
    var this$7 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
    $n($as_Lreactbuild_analyze_cost_services_ServerConnection($n(this$7.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$7.Ldiode_ActionHandler__f_currentModel))).Lreactbuild_analyze_cost_services_ServerConnection__f_ws = $m_s_None$();
    $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
    return $m_Ldiode_ActionResult$NoChange$()
  };
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost)) {
    var x6 = $as_Lreactbuild_analyze_cost_actions_ConnectionToServerLost(x1);
    var code = $n(x6).Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_code;
    var reason = $n(x6).Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_reason;
    var wasClean = $n(x6).Lreactbuild_analyze_cost_actions_ConnectionToServerLost__f_wasClean;
    switch (code) {
      case 1000:
      case 1001:
      case 1002:
      case 1006:
      case 1011: {
        var t = new $c_RTLong(30000, 0);
        break
      }
      case 1003:
      case 1007:
      case 1008:
      case 1009: {
        var t = new $c_RTLong(500, 0);
        break
      }
      case 1010:
      case 1012:
      case 1013:
      case 1014:
      case 1015: {
        var t = new $c_RTLong(60000, 0);
        break
      }
      default: {
        var t = new $c_RTLong(120000, 0)
      }
    };
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    console.error("WebSocket connection was closed", code, reason, wasClean);
    var this$9 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
    $n($as_Lreactbuild_analyze_cost_services_ServerConnection($n(this$9.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$9.Ldiode_ActionHandler__f_currentModel))).Lreactbuild_analyze_cost_services_ServerConnection__f_ws = $m_s_None$();
    $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
    var this$14 = $n($m_Ldiode_Effect$().action__F0__Ldiode_ActionType__s_concurrent_ExecutionContext__Ldiode_EffectSingle(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_actions_ConnectToServer$())), $m_Ldiode_Action$aType$(), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue));
    var this$11 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo, hi));
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
    var t$1 = this$11.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    $m_s_concurrent_duration_Duration$();
    var delay = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit);
    var runner = $m_Ldiode_Implicits$runAfterImpl$();
    var effect$2 = new $c_Ldiode_EffectBase$$anon$1(this$14, runner, delay);
    return new $c_Ldiode_ActionResult$EffectOnly(effect$2)
  };
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ServerRawMessage)) {
    rc11 = true;
    x7 = $as_Lreactbuild_analyze_cost_actions_ServerRawMessage(x1);
    var msg = $n(x7).Lreactbuild_analyze_cost_actions_ServerRawMessage__f_msg;
    if (((typeof msg) === "string")) {
      var x8 = $as_T(msg);
      var x1$4 = $m_Lio_circe_parser_package$().parse__T__s_util_Either(x8);
      if ((x1$4 instanceof $c_s_util_Left)) {
        var x2 = $as_s_util_Left(x1$4);
        var failure = $as_Lio_circe_ParsingFailure($n(x2).s_util_Left__f_value);
        console.error("Failing to parse JSON websocket message :", $n(failure).toString__T())
      } else if ((x1$4 instanceof $c_s_util_Right)) {
        var x3 = $as_s_util_Right(x1$4);
        var json = $as_Lio_circe_Json($n(x3).s_util_Right__f_value);
        var this$16 = $n(json);
        var d = $m_Lreactbuild_model_ToClient$().Lreactbuild_model_ToClient$__f_codecForToClient;
        var x1$5 = $n(d).apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(this$16, null, null));
        if ((x1$5 instanceof $c_s_util_Left)) {
          var x2$2 = $as_s_util_Left(x1$5);
          var e = $as_Lio_circe_DecodingFailure($n(x2$2).s_util_Left__f_value);
          console.error("Failing to parse ToClient message :", $n(e).toString__T())
        } else if ((x1$5 instanceof $c_s_util_Right)) {
          var x3$2 = $as_s_util_Right(x1$5);
          var toClient = $as_Lreactbuild_model_ToClient($n(x3$2).s_util_Right__f_value);
          var this$18 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
          var this$ = $n($as_Lreactbuild_analyze_cost_services_ServerConnection($n(this$18.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$18.Ldiode_ActionHandler__f_currentModel))).dispatchMessage__Lreactbuild_model_ToClient__Ljapgolly_scalajs_react_callback_Trampoline(toClient);
          var this$20 = $n(this$);
          $as_jl_Void($m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$20))
        } else {
          throw new $c_s_MatchError(x1$5)
        }
      } else {
        throw new $c_s_MatchError(x1$4)
      };
      $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
      return $m_Ldiode_ActionResult$NoChange$()
    }
  };
  if (rc11) {
    var other = $n(x7).Lreactbuild_analyze_cost_actions_ServerRawMessage__f_msg;
    console.error("Don't know how to handle message :", $dp_toString__T($n(other)));
    $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2__f_$outer);
    return $m_Ldiode_ActionResult$NoChange$()
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2.prototype.isDefinedAt__O__Z = (function(x1) {
  var rc11 = false;
  var x7 = null;
  var x = $m_Lreactbuild_analyze_cost_actions_InitAction$();
  if ((x === x1)) {
    return true
  };
  var x$3 = $m_Lreactbuild_analyze_cost_actions_ConnectToServer$();
  if ((x$3 === x1)) {
    return true
  };
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectedToServer)) {
    return true
  };
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerFailed)) {
    return true
  };
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ConnectionToServerLost)) {
    return true
  };
  if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_ServerRawMessage)) {
    rc11 = true;
    x7 = $as_Lreactbuild_analyze_cost_actions_ServerRawMessage(x1);
    var msg = $n(x7).Lreactbuild_analyze_cost_actions_ServerRawMessage__f_msg;
    if (((typeof msg) === "string")) {
      return true
    }
  };
  if (rc11) {
    return true
  };
  return false
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$$anon$2$$anonfun$handle$2", {
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$2$$anonfun$handle$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3(outer) {
  this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3.prototype.applyOrElse__O__F1__O = (function(x1, default$1) {
  var x = $m_Lreactbuild_analyze_cost_actions_InitAction$();
  if ((x === x1)) {
    var $$x5 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$1 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var qual$1 = $as_Ldiode_data_Pot($n(this$1.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$1.Ldiode_ActionHandler__f_currentModel));
    var t = $n(qual$1).pending$default$1__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var $$x4 = $n(qual$1).pending__J__Ldiode_data_Pot(new $c_RTLong(lo, hi));
    var f = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x3 = new $c_Lautowire_ClientProxy(this$3).Lautowire_ClientProxy__f_self;
      var $$x2 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "getCommonData"];
      var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$7 = $n($m_s_Predef$().s_Predef$__f_Map);
      var elems = $m_sci_Nil$();
      return $n($n($n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$7.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2 = $as_Lio_circe_Json(x$2$2);
        var this$8 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$9 = $n(new $c_Lautowire_ClientProxy(this$8).Lautowire_ClientProxy__f_self);
        var evidence$1 = $m_Lreactbuild_model_CommonData$().Lreactbuild_model_CommonData$__f_codecForCommonData;
        return $as_Lreactbuild_model_CommonData(this$9.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$7$2) => {
        var x$7 = $as_Lreactbuild_model_CommonData(x$7$2);
        return new $c_Lreactbuild_analyze_cost_actions_LoadCommonData(x$7)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).recoverWith__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1(this), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x5).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x4, new $c_Ldiode_EffectSingle(f, ec))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_LoadCommonData)) {
    var x3 = $as_Lreactbuild_analyze_cost_actions_LoadCommonData(x1);
    var commonData = $n(x3).Lreactbuild_analyze_cost_actions_LoadCommonData__f_cd;
    var this$11 = $n($n(commonData).Lreactbuild_model_CommonData__f_buildingStages);
    var ord = $m_Lreactbuild_model_Implicits$().buildingStageOrdering__s_math_Ordering();
    var x$3 = $as_sci_List($f_sc_SeqOps__sorted__s_math_Ordering__O(this$11, ord));
    var this$12 = $n(commonData);
    var x$4 = this$12.Lreactbuild_model_CommonData__f_persons;
    var this$13 = $n(commonData);
    var x$5 = this$13.Lreactbuild_model_CommonData__f_personAnnotations;
    var this$14 = $n(commonData);
    var x$6 = this$14.Lreactbuild_model_CommonData__f_buildingParts;
    var this$15 = $n(commonData);
    var x$7$1 = this$15.Lreactbuild_model_CommonData__f_buildingSites;
    var this$16 = $n(commonData);
    var x$8 = this$16.Lreactbuild_model_CommonData__f_buildingSiteStages;
    var this$17 = $n(commonData);
    var x$9 = this$17.Lreactbuild_model_CommonData__f_resources;
    var this$18 = $n(commonData);
    var x$10 = this$18.Lreactbuild_model_CommonData__f_products;
    var this$19 = $n(commonData);
    var x$11 = this$19.Lreactbuild_model_CommonData__f_listTemplates;
    var this$20 = $n(commonData);
    var x$12 = this$20.Lreactbuild_model_CommonData__f_terms;
    var this$21 = $n(commonData);
    var x$13 = this$21.Lreactbuild_model_CommonData__f_organizationUsers;
    $n(commonData);
    var orderedCommonData = new $c_Lreactbuild_model_CommonData(x$4, x$5, x$6, x$7$1, x$3, x$8, x$9, x$10, x$11, x$12, x$13);
    var $$x6 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$23 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    $n($as_Ldiode_data_Pot($n(this$23.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$23.Ldiode_ActionHandler__f_currentModel)));
    return $n($$x6).updated__O__Ldiode_ActionResult(new $c_Ldiode_data_Ready(orderedCommonData))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistPerson)) {
    var x4 = $as_Lreactbuild_analyze_cost_actions_PersistPerson(x1);
    var person = $n(x4).Lreactbuild_analyze_cost_actions_PersistPerson__f_item;
    var $$x11 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$25 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var $$x10 = $n($as_Ldiode_data_Pot($n(this$25.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$25.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$2) => {
      var cd = $as_Lreactbuild_model_CommonData(cd$2);
      $n(cd);
      var this$26 = $n($n(cd).Lreactbuild_model_CommonData__f_persons);
      var f$1 = ((x$8$2) => {
        var x$8$1 = $as_Lreactbuild_person_Person(x$8$2);
        var x$1 = $n(x$8$1).Lreactbuild_person_Person__f__id;
        var x$2$1 = $n(person).Lreactbuild_person_Person__f__id;
        return (!((x$1 === null) ? (x$2$1 === null) : $n(x$1).equals__O__Z(x$2$1)))
      });
      var l = this$26;
      block: {
        var result;
        while (true) {
          if ($n(l).isEmpty__Z()) {
            var result = $m_sci_Nil$();
            break
          } else {
            var h = $n(l).head__O();
            var t$1 = $as_sci_List($n(l).tail__O());
            if (($uZ(f$1(h)) === false)) {
              l = t$1;
              continue
            };
            var start = l;
            var remaining = t$1;
            while (true) {
              if ($n(remaining).isEmpty__Z()) {
                var result = start;
                break block
              } else {
                var x$14 = $n(remaining).head__O();
                if (($uZ(f$1(x$14)) !== false)) {
                  remaining = $as_sci_List($n(remaining).tail__O());
                  continue
                };
                var firstMiss = remaining;
                var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                var toProcess = $as_sci_List($n(start).tail__O());
                var currentLast = newHead;
                while ((toProcess !== firstMiss)) {
                  var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem;
                  currentLast = newElem;
                  toProcess = $as_sci_List($n(toProcess).tail__O())
                };
                var next = $as_sci_List($n(firstMiss).tail__O());
                var nextToCopy = next;
                while ((!$n(next).isEmpty__Z())) {
                  var head = $n(next).head__O();
                  if (($uZ(f$1(head)) !== false)) {
                    next = $as_sci_List($n(next).tail__O())
                  } else {
                    while ((nextToCopy !== next)) {
                      var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                      $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                      currentLast = newElem$2;
                      nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                    };
                    nextToCopy = $as_sci_List($n(next).tail__O());
                    next = $as_sci_List($n(next).tail__O())
                  }
                };
                if ((!$n(nextToCopy).isEmpty__Z())) {
                  $n(currentLast).sci_$colon$colon__f_next = nextToCopy
                };
                var result = newHead;
                break block
              }
            }
          }
        }
      };
      var this$27 = $n(result);
      var this$28 = new $c_sci_$colon$colon(person, this$27);
      var ord$1 = $m_Lreactbuild_model_Implicits$().personOrdering__s_math_Ordering();
      var persons = $as_sci_List($f_sc_SeqOps__sorted__s_math_Ordering__O(this$28, ord$1));
      var this$29 = $n(cd);
      var personAnnotations = this$29.Lreactbuild_model_CommonData__f_personAnnotations;
      var this$30 = $n(cd);
      var buildingParts = this$30.Lreactbuild_model_CommonData__f_buildingParts;
      var this$31 = $n(cd);
      var buildingSites = this$31.Lreactbuild_model_CommonData__f_buildingSites;
      var this$32 = $n(cd);
      var buildingStages = this$32.Lreactbuild_model_CommonData__f_buildingStages;
      var this$33 = $n(cd);
      var buildingSiteStages = this$33.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var this$34 = $n(cd);
      var resources = this$34.Lreactbuild_model_CommonData__f_resources;
      var this$35 = $n(cd);
      var products = this$35.Lreactbuild_model_CommonData__f_products;
      var this$36 = $n(cd);
      var listTemplates = this$36.Lreactbuild_model_CommonData__f_listTemplates;
      var this$37 = $n(cd);
      var terms = this$37.Lreactbuild_model_CommonData__f_terms;
      var this$38 = $n(cd);
      var organizationUsers = this$38.Lreactbuild_model_CommonData__f_organizationUsers;
      return new $c_Lreactbuild_model_CommonData(persons, personAnnotations, buildingParts, buildingSites, buildingStages, buildingSiteStages, resources, products, listTemplates, terms, organizationUsers)
    })));
    var f$2 = new $c_sjsr_AnonFunction0((() => {
      var this$40 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x9 = new $c_Lautowire_ClientProxy(this$40).Lautowire_ClientProxy__f_self;
      var $$x8 = $m_s_package$().s_package$__f_Seq;
      var array$1 = ["reactbuild", "person", "PersonApi", "persistPerson"];
      var $$x7 = $as_sci_Seq($n($$x8).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
      var this$51 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$45 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$46 = $n(new $c_Lautowire_ClientProxy(this$45).Lautowire_ClientProxy__f_self);
      var evidence$2 = $m_Lreactbuild_person_Person$().Lreactbuild_person_Person$__f_codecForPerson;
      var y = this$46.write__O__Lio_circe_Encoder__Lio_circe_Json(person, evidence$2);
      var array$2 = [$ct_T2__O__O__(new $c_T2(), "x", y)];
      var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return $n($n($n($$x9).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x7, this$51.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$14$2) => {
        var x$14$1 = $as_Lio_circe_Json(x$14$2);
        var this$52 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$53 = $n(new $c_Lautowire_ClientProxy(this$52).Lautowire_ClientProxy__f_self);
        var evidence$1$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$53.read__Lio_circe_Json__Lio_circe_Decoder__O(x$14$1, evidence$1$1)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$9$2) => {
        $as_jl_Void(x$9$2);
        return $m_Ldiode_NoAction$()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec$1 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x11).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x10, new $c_Ldiode_EffectSingle(f$2, ec$1))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistTerm)) {
    var x5 = $as_Lreactbuild_analyze_cost_actions_PersistTerm(x1);
    var term = $n(x5).Lreactbuild_analyze_cost_actions_PersistTerm__f_item;
    var $$x16 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$55 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var $$x15 = $n($as_Ldiode_data_Pot($n(this$55.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$55.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$3$2) => {
      var cd$3 = $as_Lreactbuild_model_CommonData(cd$3$2);
      var this$56 = $n($n(cd$3).Lreactbuild_model_CommonData__f_terms);
      var f$3 = ((x$10$2) => {
        var x$10$1 = $as_Lreactbuild_model_Term(x$10$2);
        var x$15 = $n(x$10$1).Lreactbuild_model_Term__f__id;
        var x$2$3 = $n(term).Lreactbuild_model_Term__f__id;
        return (!((x$15 === null) ? (x$2$3 === null) : $n(x$15).equals__O__Z(x$2$3)))
      });
      var l$1 = this$56;
      block$2: {
        var result$1;
        while (true) {
          if ($n(l$1).isEmpty__Z()) {
            var result$1 = $m_sci_Nil$();
            break
          } else {
            var h$1 = $n(l$1).head__O();
            var t$2 = $as_sci_List($n(l$1).tail__O());
            if (($uZ(f$3(h$1)) === false)) {
              l$1 = t$2;
              continue
            };
            var start$1 = l$1;
            var remaining$1 = t$2;
            while (true) {
              if ($n(remaining$1).isEmpty__Z()) {
                var result$1 = start$1;
                break block$2
              } else {
                var x$16 = $n(remaining$1).head__O();
                if (($uZ(f$3(x$16)) !== false)) {
                  remaining$1 = $as_sci_List($n(remaining$1).tail__O());
                  continue
                };
                var firstMiss$1 = remaining$1;
                var newHead$1 = new $c_sci_$colon$colon($n(start$1).head__O(), $m_sci_Nil$());
                var toProcess$1 = $as_sci_List($n(start$1).tail__O());
                var currentLast$1 = newHead$1;
                while ((toProcess$1 !== firstMiss$1)) {
                  var newElem$1 = new $c_sci_$colon$colon($n(toProcess$1).head__O(), $m_sci_Nil$());
                  $n(currentLast$1).sci_$colon$colon__f_next = newElem$1;
                  currentLast$1 = newElem$1;
                  toProcess$1 = $as_sci_List($n(toProcess$1).tail__O())
                };
                var next$1 = $as_sci_List($n(firstMiss$1).tail__O());
                var nextToCopy$1 = next$1;
                while ((!$n(next$1).isEmpty__Z())) {
                  var head$1 = $n(next$1).head__O();
                  if (($uZ(f$3(head$1)) !== false)) {
                    next$1 = $as_sci_List($n(next$1).tail__O())
                  } else {
                    while ((nextToCopy$1 !== next$1)) {
                      var newElem$2$1 = new $c_sci_$colon$colon($n(nextToCopy$1).head__O(), $m_sci_Nil$());
                      $n(currentLast$1).sci_$colon$colon__f_next = newElem$2$1;
                      currentLast$1 = newElem$2$1;
                      nextToCopy$1 = $as_sci_List($n(nextToCopy$1).tail__O())
                    };
                    nextToCopy$1 = $as_sci_List($n(next$1).tail__O());
                    next$1 = $as_sci_List($n(next$1).tail__O())
                  }
                };
                if ((!$n(nextToCopy$1).isEmpty__Z())) {
                  $n(currentLast$1).sci_$colon$colon__f_next = nextToCopy$1
                };
                var result$1 = newHead$1;
                break block$2
              }
            }
          }
        }
      };
      var this$57 = $n(result$1);
      var this$58 = new $c_sci_$colon$colon(term, this$57);
      var ord$2 = $m_Lreactbuild_model_Implicits$().termOrdering__s_math_Ordering();
      var x$15$1 = $as_sci_List($f_sc_SeqOps__sorted__s_math_Ordering__O(this$58, ord$2));
      var this$59 = $n(cd$3);
      var x$16$1 = this$59.Lreactbuild_model_CommonData__f_persons;
      var this$60 = $n(cd$3);
      var x$17 = this$60.Lreactbuild_model_CommonData__f_personAnnotations;
      var this$61 = $n(cd$3);
      var x$18 = this$61.Lreactbuild_model_CommonData__f_buildingParts;
      var this$62 = $n(cd$3);
      var x$19 = this$62.Lreactbuild_model_CommonData__f_buildingSites;
      var this$63 = $n(cd$3);
      var x$20 = this$63.Lreactbuild_model_CommonData__f_buildingStages;
      var this$64 = $n(cd$3);
      var x$21 = this$64.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var this$65 = $n(cd$3);
      var x$22 = this$65.Lreactbuild_model_CommonData__f_resources;
      var this$66 = $n(cd$3);
      var x$23 = this$66.Lreactbuild_model_CommonData__f_products;
      var this$67 = $n(cd$3);
      var x$24 = this$67.Lreactbuild_model_CommonData__f_listTemplates;
      var this$68 = $n(cd$3);
      var x$25 = this$68.Lreactbuild_model_CommonData__f_organizationUsers;
      $n(cd$3);
      return new $c_Lreactbuild_model_CommonData(x$16$1, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$15$1, x$25)
    })));
    var f$4 = new $c_sjsr_AnonFunction0((() => {
      var this$70 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x14 = new $c_Lautowire_ClientProxy(this$70).Lautowire_ClientProxy__f_self;
      var $$x13 = $m_s_package$().s_package$__f_Seq;
      var array$3 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistTerm"];
      var $$x12 = $as_sci_Seq($n($$x13).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)));
      var this$81 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$75 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$76 = $n(new $c_Lautowire_ClientProxy(this$75).Lautowire_ClientProxy__f_self);
      var evidence$2$1 = $m_Lreactbuild_model_Term$().Lreactbuild_model_Term$__f_codecForTerm;
      var y$1 = this$76.write__O__Lio_circe_Encoder__Lio_circe_Json(term, evidence$2$1);
      var array$4 = [$ct_T2__O__O__(new $c_T2(), "x", y$1)];
      var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
      return $n($n($n($$x14).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x12, this$81.from__sc_IterableOnce__sci_Map(elems$2)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$26$2) => {
        var x$26 = $as_Lio_circe_Json(x$26$2);
        var this$82 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$83 = $n(new $c_Lautowire_ClientProxy(this$82).Lautowire_ClientProxy__f_self);
        var evidence$1$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$83.read__Lio_circe_Json__Lio_circe_Decoder__O(x$26, evidence$1$2)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$11$2) => {
        $as_jl_Void(x$11$2);
        return $m_Ldiode_NoAction$()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec$2 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x16).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x15, new $c_Ldiode_EffectSingle(f$4, ec$2))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistListTemplate)) {
    var x6 = $as_Lreactbuild_analyze_cost_actions_PersistListTemplate(x1);
    var template = $n(x6).Lreactbuild_analyze_cost_actions_PersistListTemplate__f_item;
    window.console.log(("Attempte to persist " + template));
    var $$x21 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$85 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var $$x20 = $n($as_Ldiode_data_Pot($n(this$85.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$85.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$4$2) => {
      var cd$4 = $as_Lreactbuild_model_CommonData(cd$4$2);
      var this$86 = $n($n(cd$4).Lreactbuild_model_CommonData__f_listTemplates);
      _return: {
        var i = 0;
        var these = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$86, 0, this$86);
        while (true) {
          var this$89 = $n(these);
          if ((!this$89.isEmpty__Z())) {
            var arg1 = $n(these).head__O();
            var x$12$1 = $as_Lreactbuild_model_WithChildren(arg1);
            var x$27 = $n($as_Lreactbuild_model_ListTemplate($n(x$12$1).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_ListTemplate__f__id;
            var x$2$4 = $n(template).Lreactbuild_model_ListTemplate__f__id;
            if (((x$27 === null) ? (x$2$4 === null) : $n(x$27).equals__O__Z(x$2$4))) {
              var x1$1 = i;
              break _return
            };
            i = ((1 + i) | 0);
            these = $as_sc_LinearSeq($n(these).tail__O())
          } else {
            break
          }
        };
        var x1$1 = (-1)
      };
      if ((x1$1 === (-1))) {
        var this$90 = $n($n(cd$4).Lreactbuild_model_CommonData__f_listTemplates);
        var elem = new $c_Lreactbuild_model_WithChildren(template, $m_s_package$().s_package$__f_Nil);
        var nextListTemplate = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$90, elem))
      } else {
        var this$91 = $n($n(cd$4).Lreactbuild_model_CommonData__f_listTemplates);
        var existing = $as_Lreactbuild_model_WithChildren($f_sc_LinearSeqOps__apply__I__O(this$91, x1$1));
        var this$95 = $n($n(cd$4).Lreactbuild_model_CommonData__f_listTemplates);
        $n(existing);
        var this$92 = $n(existing);
        var children = this$92.Lreactbuild_model_WithChildren__f_children;
        var rassoc$3 = new $c_Lreactbuild_model_WithChildren(template, children);
        var this$94 = $n($m_s_package$().s_package$__f_Nil);
        var other = new $c_sci_$colon$colon(rassoc$3, this$94);
        var nextListTemplate = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$95, x1$1, other, 1))
      };
      var this$96 = $n(cd$4);
      var x$28 = this$96.Lreactbuild_model_CommonData__f_persons;
      var this$97 = $n(cd$4);
      var x$29 = this$97.Lreactbuild_model_CommonData__f_personAnnotations;
      var this$98 = $n(cd$4);
      var x$30 = this$98.Lreactbuild_model_CommonData__f_buildingParts;
      var this$99 = $n(cd$4);
      var x$31 = this$99.Lreactbuild_model_CommonData__f_buildingSites;
      var this$100 = $n(cd$4);
      var x$32 = this$100.Lreactbuild_model_CommonData__f_buildingStages;
      var this$101 = $n(cd$4);
      var x$33 = this$101.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var this$102 = $n(cd$4);
      var x$34 = this$102.Lreactbuild_model_CommonData__f_resources;
      var this$103 = $n(cd$4);
      var x$35 = this$103.Lreactbuild_model_CommonData__f_products;
      var this$104 = $n(cd$4);
      var x$36 = this$104.Lreactbuild_model_CommonData__f_terms;
      var this$105 = $n(cd$4);
      var x$37 = this$105.Lreactbuild_model_CommonData__f_organizationUsers;
      $n(cd$4);
      return new $c_Lreactbuild_model_CommonData(x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$35, nextListTemplate, x$36, x$37)
    })));
    var f$5 = new $c_sjsr_AnonFunction0((() => {
      var this$107 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x19 = new $c_Lautowire_ClientProxy(this$107).Lautowire_ClientProxy__f_self;
      var $$x18 = $m_s_package$().s_package$__f_Seq;
      var array$5 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistListTemplate"];
      var $$x17 = $as_sci_Seq($n($$x18).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)));
      var this$118 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$112 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$113 = $n(new $c_Lautowire_ClientProxy(this$112).Lautowire_ClientProxy__f_self);
      var evidence$2$2 = $m_Lreactbuild_model_ListTemplate$().Lreactbuild_model_ListTemplate$__f_codecForListTemplate;
      var y$2 = this$113.write__O__Lio_circe_Encoder__Lio_circe_Json(template, evidence$2$2);
      var array$6 = [$ct_T2__O__O__(new $c_T2(), "x", y$2)];
      var elems$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
      return $n($n($n($$x19).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x17, this$118.from__sc_IterableOnce__sci_Map(elems$3)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$38$2) => {
        var x$38 = $as_Lio_circe_Json(x$38$2);
        var this$119 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$120 = $n(new $c_Lautowire_ClientProxy(this$119).Lautowire_ClientProxy__f_self);
        var evidence$1$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$120.read__Lio_circe_Json__Lio_circe_Decoder__O(x$38, evidence$1$3)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$13$2) => {
        $as_jl_Void(x$13$2);
        return $m_Ldiode_NoAction$()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec$3 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x21).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x20, new $c_Ldiode_EffectSingle(f$5, ec$3))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry)) {
    var x7 = $as_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry(x1);
    var templateEntry = $n(x7).Lreactbuild_analyze_cost_actions_PersistListTemplateEntry__f_item;
    window.console.log(("Attempte to persist " + templateEntry));
    var $$x22 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$122 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    return $n($$x22).updated__O__Ldiode_ActionResult($n($as_Ldiode_data_Pot($n(this$122.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$122.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$5$2) => {
      var cd$5 = $as_Lreactbuild_model_CommonData(cd$5$2);
      var this$123 = $n($n(cd$5).Lreactbuild_model_CommonData__f_listTemplates);
      _return$1: {
        var i$1 = 0;
        var these$1 = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$123, 0, this$123);
        while (true) {
          var this$126 = $n(these$1);
          if ((!this$126.isEmpty__Z())) {
            var arg1$1 = $n(these$1).head__O();
            var x$14$3 = $as_Lreactbuild_model_WithChildren(arg1$1);
            var this$127 = $n($n(x$14$3).Lreactbuild_model_WithChildren__f_children);
            _return$2: {
              var these$2 = this$127;
              while ((!$n(these$2).isEmpty__Z())) {
                var arg1$2 = $n(these$2).head__O();
                var x$15$2 = $as_Lreactbuild_model_ListTemplateEntry(arg1$2);
                var x$39 = $n(x$15$2).Lreactbuild_model_ListTemplateEntry__f__id;
                var x$2$5 = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f__id;
                if (((x$39 === null) ? (x$2$5 === null) : $n(x$39).equals__O__Z(x$2$5))) {
                  var $$x23 = true;
                  break _return$2
                };
                these$2 = $as_sci_List($n(these$2).tail__O())
              };
              var $$x23 = false
            };
            if ($$x23) {
              var x1$2 = i$1;
              break _return$1
            };
            i$1 = ((1 + i$1) | 0);
            these$1 = $as_sc_LinearSeq($n(these$1).tail__O())
          } else {
            break
          }
        };
        var x1$2 = (-1)
      };
      if ((x1$2 === (-1))) {
        var x$39$1 = $n(cd$5).Lreactbuild_model_CommonData__f_listTemplates;
        var this$128 = $n(cd$5);
        var x$40 = this$128.Lreactbuild_model_CommonData__f_persons;
        var this$129 = $n(cd$5);
        var x$41 = this$129.Lreactbuild_model_CommonData__f_personAnnotations;
        var this$130 = $n(cd$5);
        var x$42 = this$130.Lreactbuild_model_CommonData__f_buildingParts;
        var this$131 = $n(cd$5);
        var x$43 = this$131.Lreactbuild_model_CommonData__f_buildingSites;
        var this$132 = $n(cd$5);
        var x$44 = this$132.Lreactbuild_model_CommonData__f_buildingStages;
        var this$133 = $n(cd$5);
        var x$45 = this$133.Lreactbuild_model_CommonData__f_buildingSiteStages;
        var this$134 = $n(cd$5);
        var x$46 = this$134.Lreactbuild_model_CommonData__f_resources;
        var this$135 = $n(cd$5);
        var x$47 = this$135.Lreactbuild_model_CommonData__f_products;
        var this$136 = $n(cd$5);
        var x$48 = this$136.Lreactbuild_model_CommonData__f_terms;
        var this$137 = $n(cd$5);
        var x$49 = this$137.Lreactbuild_model_CommonData__f_organizationUsers;
        $n(cd$5);
        return new $c_Lreactbuild_model_CommonData(x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, x$39$1, x$48, x$49)
      } else {
        var this$139 = $n($n(cd$5).Lreactbuild_model_CommonData__f_listTemplates);
        var listTemplate = $as_Lreactbuild_model_WithChildren($f_sc_LinearSeqOps__apply__I__O(this$139, x1$2));
        var x$50 = $n($as_Lreactbuild_model_ListTemplate($n(listTemplate).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_ListTemplate__f__id;
        var x$2$6 = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f_template;
        if (((x$50 === null) ? (x$2$6 === null) : $n(x$50).equals__O__Z(x$2$6))) {
          var this$140 = $n($n(listTemplate).Lreactbuild_model_WithChildren__f_children);
          _return$3: {
            var i$2 = 0;
            var these$3 = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$140, 0, this$140);
            while (true) {
              var this$143 = $n(these$3);
              if ((!this$143.isEmpty__Z())) {
                var arg1$3 = $n(these$3).head__O();
                var x$16$2 = $as_Lreactbuild_model_ListTemplateEntry(arg1$3);
                var x$51 = $n(x$16$2).Lreactbuild_model_ListTemplateEntry__f__id;
                var x$2$7 = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f__id;
                if (((x$51 === null) ? (x$2$7 === null) : $n(x$51).equals__O__Z(x$2$7))) {
                  var x1$2$1 = i$2;
                  break _return$3
                };
                i$2 = ((1 + i$2) | 0);
                these$3 = $as_sc_LinearSeq($n(these$3).tail__O())
              } else {
                break
              }
            };
            var x1$2$1 = (-1)
          };
          if ((x1$2$1 === (-1))) {
            var this$144 = $n($n(listTemplate).Lreactbuild_model_WithChildren__f_children);
            var x$50$1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$144, templateEntry))
          } else {
            var this$146 = $n($n(listTemplate).Lreactbuild_model_WithChildren__f_children);
            var this$145 = $n($m_s_package$().s_package$__f_Nil);
            var other$1 = new $c_sci_$colon$colon(templateEntry, this$145);
            var x$50$1 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$146, x1$2$1, other$1, 1))
          };
          var this$147 = $n(listTemplate);
          var x$51$1 = $as_Lreactbuild_model_ListTemplate(this$147.Lreactbuild_model_WithChildren__f_item);
          $n(listTemplate);
          var next$2 = new $c_Lreactbuild_model_WithChildren(x$51$1, x$50$1);
          var this$150 = $n($n(cd$5).Lreactbuild_model_CommonData__f_listTemplates);
          var this$149 = $n($m_s_package$().s_package$__f_Nil);
          var other$2 = new $c_sci_$colon$colon(next$2, this$149);
          var x$52 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$150, x1$2, other$2, 1));
          var this$151 = $n(cd$5);
          var x$53 = this$151.Lreactbuild_model_CommonData__f_persons;
          var this$152 = $n(cd$5);
          var x$54 = this$152.Lreactbuild_model_CommonData__f_personAnnotations;
          var this$153 = $n(cd$5);
          var x$55 = this$153.Lreactbuild_model_CommonData__f_buildingParts;
          var this$154 = $n(cd$5);
          var x$56 = this$154.Lreactbuild_model_CommonData__f_buildingSites;
          var this$155 = $n(cd$5);
          var x$57 = this$155.Lreactbuild_model_CommonData__f_buildingStages;
          var this$156 = $n(cd$5);
          var x$58 = this$156.Lreactbuild_model_CommonData__f_buildingSiteStages;
          var this$157 = $n(cd$5);
          var x$59 = this$157.Lreactbuild_model_CommonData__f_resources;
          var this$158 = $n(cd$5);
          var x$60 = this$158.Lreactbuild_model_CommonData__f_products;
          var this$159 = $n(cd$5);
          var x$61 = this$159.Lreactbuild_model_CommonData__f_terms;
          var this$160 = $n(cd$5);
          var x$62 = this$160.Lreactbuild_model_CommonData__f_organizationUsers;
          $n(cd$5);
          return new $c_Lreactbuild_model_CommonData(x$53, x$54, x$55, x$56, x$57, x$58, x$59, x$60, x$52, x$61, x$62)
        } else {
          var this$166 = $n($n(cd$5).Lreactbuild_model_CommonData__f_listTemplates);
          var this$162 = $n($n(listTemplate).Lreactbuild_model_WithChildren__f_children);
          var f$6 = ((x$17$2) => {
            var x$17$1 = $as_Lreactbuild_model_ListTemplateEntry(x$17$2);
            var x$63 = $n(x$17$1).Lreactbuild_model_ListTemplateEntry__f__id;
            var x$2$8 = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f__id;
            return ((x$63 === null) ? (x$2$8 === null) : $n(x$63).equals__O__Z(x$2$8))
          });
          var l$2 = this$162;
          block$4: {
            var result$2;
            while (true) {
              if ($n(l$2).isEmpty__Z()) {
                var result$2 = $m_sci_Nil$();
                break
              } else {
                var h$2 = $n(l$2).head__O();
                var t$3 = $as_sci_List($n(l$2).tail__O());
                if (($uZ(f$6(h$2)) === true)) {
                  l$2 = t$3;
                  continue
                };
                var start$2 = l$2;
                var remaining$2 = t$3;
                while (true) {
                  if ($n(remaining$2).isEmpty__Z()) {
                    var result$2 = start$2;
                    break block$4
                  } else {
                    var x$64 = $n(remaining$2).head__O();
                    if (($uZ(f$6(x$64)) !== true)) {
                      remaining$2 = $as_sci_List($n(remaining$2).tail__O());
                      continue
                    };
                    var firstMiss$2 = remaining$2;
                    var newHead$2 = new $c_sci_$colon$colon($n(start$2).head__O(), $m_sci_Nil$());
                    var toProcess$2 = $as_sci_List($n(start$2).tail__O());
                    var currentLast$2 = newHead$2;
                    while ((toProcess$2 !== firstMiss$2)) {
                      var newElem$3 = new $c_sci_$colon$colon($n(toProcess$2).head__O(), $m_sci_Nil$());
                      $n(currentLast$2).sci_$colon$colon__f_next = newElem$3;
                      currentLast$2 = newElem$3;
                      toProcess$2 = $as_sci_List($n(toProcess$2).tail__O())
                    };
                    var next$3 = $as_sci_List($n(firstMiss$2).tail__O());
                    var nextToCopy$2 = next$3;
                    while ((!$n(next$3).isEmpty__Z())) {
                      var head$2 = $n(next$3).head__O();
                      if (($uZ(f$6(head$2)) !== true)) {
                        next$3 = $as_sci_List($n(next$3).tail__O())
                      } else {
                        while ((nextToCopy$2 !== next$3)) {
                          var newElem$2$2 = new $c_sci_$colon$colon($n(nextToCopy$2).head__O(), $m_sci_Nil$());
                          $n(currentLast$2).sci_$colon$colon__f_next = newElem$2$2;
                          currentLast$2 = newElem$2$2;
                          nextToCopy$2 = $as_sci_List($n(nextToCopy$2).tail__O())
                        };
                        nextToCopy$2 = $as_sci_List($n(next$3).tail__O());
                        next$3 = $as_sci_List($n(next$3).tail__O())
                      }
                    };
                    if ((!$n(nextToCopy$2).isEmpty__Z())) {
                      $n(currentLast$2).sci_$colon$colon__f_next = nextToCopy$2
                    };
                    var result$2 = newHead$2;
                    break block$4
                  }
                }
              }
            }
          };
          var this$163 = $n(listTemplate);
          var x$64$1 = $as_Lreactbuild_model_ListTemplate(this$163.Lreactbuild_model_WithChildren__f_item);
          $n(listTemplate);
          var rassoc$6 = new $c_Lreactbuild_model_WithChildren(x$64$1, result$2);
          var this$165 = $n($m_s_package$().s_package$__f_Nil);
          var other$3 = new $c_sci_$colon$colon(rassoc$6, this$165);
          var deleted = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$166, x1$2, other$3, 1));
          var this$167 = $n(deleted);
          _return$4: {
            var i$3 = 0;
            var these$4 = $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$167, 0, this$167);
            while (true) {
              var this$170 = $n(these$4);
              if ((!this$170.isEmpty__Z())) {
                var arg1$4 = $n(these$4).head__O();
                var x$18$1 = $as_Lreactbuild_model_WithChildren(arg1$4);
                var x$65 = $n($as_Lreactbuild_model_ListTemplate($n(x$18$1).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_ListTemplate__f__id;
                var x$2$9 = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f_template;
                if (((x$65 === null) ? (x$2$9 === null) : $n(x$65).equals__O__Z(x$2$9))) {
                  var x1$3 = i$3;
                  break _return$4
                };
                i$3 = ((1 + i$3) | 0);
                these$4 = $as_sc_LinearSeq($n(these$4).tail__O())
              } else {
                break
              }
            };
            var x1$3 = (-1)
          };
          if ((x1$3 === (-1))) {
            $m_s_Predef$().$qmark$qmark$qmark__E()
          } else {
            var this$171 = $n(deleted);
            var prev = $as_Lreactbuild_model_WithChildren($f_sc_LinearSeqOps__apply__I__O(this$171, x1$3));
            var this$172 = $n($n(prev).Lreactbuild_model_WithChildren__f_children);
            var x$65$1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$172, templateEntry));
            var this$173 = $n(prev);
            var x$66 = $as_Lreactbuild_model_ListTemplate(this$173.Lreactbuild_model_WithChildren__f_item);
            $n(prev);
            var next$2$1 = new $c_Lreactbuild_model_WithChildren(x$66, x$65$1);
            var this$176 = $n(deleted);
            var this$175 = $n($m_s_package$().s_package$__f_Nil);
            var other$4 = new $c_sci_$colon$colon(next$2$1, this$175);
            var x$67 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$176, x1$3, other$4, 1));
            var this$177 = $n(cd$5);
            var x$68 = this$177.Lreactbuild_model_CommonData__f_persons;
            var this$178 = $n(cd$5);
            var x$69 = this$178.Lreactbuild_model_CommonData__f_personAnnotations;
            var this$179 = $n(cd$5);
            var x$70 = this$179.Lreactbuild_model_CommonData__f_buildingParts;
            var this$180 = $n(cd$5);
            var x$71 = this$180.Lreactbuild_model_CommonData__f_buildingSites;
            var this$181 = $n(cd$5);
            var x$72 = this$181.Lreactbuild_model_CommonData__f_buildingStages;
            var this$182 = $n(cd$5);
            var x$73 = this$182.Lreactbuild_model_CommonData__f_buildingSiteStages;
            var this$183 = $n(cd$5);
            var x$74 = this$183.Lreactbuild_model_CommonData__f_resources;
            var this$184 = $n(cd$5);
            var x$75 = this$184.Lreactbuild_model_CommonData__f_products;
            var this$185 = $n(cd$5);
            var x$76 = this$185.Lreactbuild_model_CommonData__f_terms;
            var this$186 = $n(cd$5);
            var x$77 = this$186.Lreactbuild_model_CommonData__f_organizationUsers;
            $n(cd$5);
            return new $c_Lreactbuild_model_CommonData(x$68, x$69, x$70, x$71, x$72, x$73, x$74, x$75, x$67, x$76, x$77)
          }
        }
      }
    }))))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation)) {
    var x8 = $as_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation(x1);
    var annotation = $n(x8).Lreactbuild_analyze_cost_actions_PersistPersonAnnotation__f_annotation;
    var $$x29 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$188 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var $$x27 = $n($as_Ldiode_data_Pot($n(this$188.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$188.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$6$2) => {
      var cd$6 = $as_Lreactbuild_model_CommonData(cd$6$2);
      var this$189 = $n($n(cd$6).Lreactbuild_model_CommonData__f_personAnnotations);
      var x$78 = $n(annotation).Lreactbuild_person_PersonAnnotation__f_person;
      var default$2 = new $c_sjsr_AnonFunction1(((x$19$2) => {
        $as_Lreactbuild_common_model_RefTo(x$19$2);
        return $m_s_package$().s_package$__f_Nil
      }));
      var this$190 = $n($as_sc_SeqOps($n($as_sc_IterableOps($f_sc_MapOps__applyOrElse__O__F1__O(this$189, x$78, default$2))).filter__F1__O(new $c_sjsr_AnonFunction1(((x$20$2) => {
        var x$20$1 = $as_Lreactbuild_person_PersonAnnotation(x$20$2);
        var x$79 = $n(x$20$1).Lreactbuild_person_PersonAnnotation__f__id;
        var x$2$10 = $n(annotation).Lreactbuild_person_PersonAnnotation__f__id;
        return (!((x$79 === null) ? (x$2$10 === null) : $n(x$79).equals__O__Z(x$2$10)))
      })))));
      var annotations = $as_sci_Seq(this$190.appended__O__O(annotation));
      var $$x28 = $n(cd$6).Lreactbuild_model_CommonData__f_personAnnotations;
      var self = $n(annotation).Lreactbuild_person_PersonAnnotation__f_person;
      var result$3 = $as_sci_Map($n($$x28).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self, annotations)));
      var this$193 = $n(cd$6);
      var x$79$1 = this$193.Lreactbuild_model_CommonData__f_persons;
      var this$194 = $n(cd$6);
      var x$80 = this$194.Lreactbuild_model_CommonData__f_buildingParts;
      var this$195 = $n(cd$6);
      var x$81 = this$195.Lreactbuild_model_CommonData__f_buildingSites;
      var this$196 = $n(cd$6);
      var x$82 = this$196.Lreactbuild_model_CommonData__f_buildingStages;
      var this$197 = $n(cd$6);
      var x$83 = this$197.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var this$198 = $n(cd$6);
      var x$84 = this$198.Lreactbuild_model_CommonData__f_resources;
      var this$199 = $n(cd$6);
      var x$85 = this$199.Lreactbuild_model_CommonData__f_products;
      var this$200 = $n(cd$6);
      var x$86 = this$200.Lreactbuild_model_CommonData__f_listTemplates;
      var this$201 = $n(cd$6);
      var x$87 = this$201.Lreactbuild_model_CommonData__f_terms;
      var this$202 = $n(cd$6);
      var x$88 = this$202.Lreactbuild_model_CommonData__f_organizationUsers;
      $n(cd$6);
      return new $c_Lreactbuild_model_CommonData(x$79$1, result$3, x$80, x$81, x$82, x$83, x$84, x$85, x$86, x$87, x$88)
    })));
    var f$7 = new $c_sjsr_AnonFunction0((() => {
      var this$204 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x26 = new $c_Lautowire_ClientProxy(this$204).Lautowire_ClientProxy__f_self;
      var $$x25 = $m_s_package$().s_package$__f_Seq;
      var array$7 = ["reactbuild", "person", "PersonApi", "persistPersonAnnotation"];
      var $$x24 = $as_sci_Seq($n($$x25).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)));
      var this$215 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$209 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$210 = $n(new $c_Lautowire_ClientProxy(this$209).Lautowire_ClientProxy__f_self);
      var evidence$2$3 = $m_Lreactbuild_person_PersonAnnotation$().Lreactbuild_person_PersonAnnotation$__f_codecForPersonAnnotation;
      var y$3 = this$210.write__O__Lio_circe_Encoder__Lio_circe_Json(annotation, evidence$2$3);
      var array$8 = [$ct_T2__O__O__(new $c_T2(), "x", y$3)];
      var elems$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
      return $n($n($n($$x26).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x24, this$215.from__sc_IterableOnce__sci_Map(elems$4)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$89$2) => {
        var x$89 = $as_Lio_circe_Json(x$89$2);
        var this$216 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$217 = $n(new $c_Lautowire_ClientProxy(this$216).Lautowire_ClientProxy__f_self);
        var evidence$1$4 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$217.read__Lio_circe_Json__Lio_circe_Decoder__O(x$89, evidence$1$4)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$21$2) => {
        $as_jl_Void(x$21$2);
        return $m_Ldiode_NoAction$()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec$4 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x29).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x27, new $c_Ldiode_EffectSingle(f$7, ec$4))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingSite)) {
    var x9 = $as_Lreactbuild_analyze_cost_actions_PersistBuildingSite(x1);
    var site = $n(x9).Lreactbuild_analyze_cost_actions_PersistBuildingSite__f_item;
    var $$x34 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$219 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var $$x33 = $n($as_Ldiode_data_Pot($n(this$219.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$219.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$7$2) => {
      var cd$7 = $as_Lreactbuild_model_CommonData(cd$7$2);
      var this$220 = $n($n(cd$7).Lreactbuild_model_CommonData__f_buildingSites);
      var f$8 = ((x$22$2) => {
        var x$22$1 = $as_Lreactbuild_common_model_Project(x$22$2);
        var x$90 = $n(x$22$1).Lreactbuild_common_model_Project__f__id;
        var x$2$11 = $n(site).Lreactbuild_common_model_Project__f__id;
        return (!((x$90 === null) ? (x$2$11 === null) : $n(x$90).equals__O__Z(x$2$11)))
      });
      var l$3 = this$220;
      block$6: {
        var result$4;
        while (true) {
          if ($n(l$3).isEmpty__Z()) {
            var result$4 = $m_sci_Nil$();
            break
          } else {
            var h$3 = $n(l$3).head__O();
            var t$4 = $as_sci_List($n(l$3).tail__O());
            if (($uZ(f$8(h$3)) === false)) {
              l$3 = t$4;
              continue
            };
            var start$3 = l$3;
            var remaining$3 = t$4;
            while (true) {
              if ($n(remaining$3).isEmpty__Z()) {
                var result$4 = start$3;
                break block$6
              } else {
                var x$91 = $n(remaining$3).head__O();
                if (($uZ(f$8(x$91)) !== false)) {
                  remaining$3 = $as_sci_List($n(remaining$3).tail__O());
                  continue
                };
                var firstMiss$3 = remaining$3;
                var newHead$3 = new $c_sci_$colon$colon($n(start$3).head__O(), $m_sci_Nil$());
                var toProcess$3 = $as_sci_List($n(start$3).tail__O());
                var currentLast$3 = newHead$3;
                while ((toProcess$3 !== firstMiss$3)) {
                  var newElem$4 = new $c_sci_$colon$colon($n(toProcess$3).head__O(), $m_sci_Nil$());
                  $n(currentLast$3).sci_$colon$colon__f_next = newElem$4;
                  currentLast$3 = newElem$4;
                  toProcess$3 = $as_sci_List($n(toProcess$3).tail__O())
                };
                var next$4 = $as_sci_List($n(firstMiss$3).tail__O());
                var nextToCopy$3 = next$4;
                while ((!$n(next$4).isEmpty__Z())) {
                  var head$3 = $n(next$4).head__O();
                  if (($uZ(f$8(head$3)) !== false)) {
                    next$4 = $as_sci_List($n(next$4).tail__O())
                  } else {
                    while ((nextToCopy$3 !== next$4)) {
                      var newElem$2$3 = new $c_sci_$colon$colon($n(nextToCopy$3).head__O(), $m_sci_Nil$());
                      $n(currentLast$3).sci_$colon$colon__f_next = newElem$2$3;
                      currentLast$3 = newElem$2$3;
                      nextToCopy$3 = $as_sci_List($n(nextToCopy$3).tail__O())
                    };
                    nextToCopy$3 = $as_sci_List($n(next$4).tail__O());
                    next$4 = $as_sci_List($n(next$4).tail__O())
                  }
                };
                if ((!$n(nextToCopy$3).isEmpty__Z())) {
                  $n(currentLast$3).sci_$colon$colon__f_next = nextToCopy$3
                };
                var result$4 = newHead$3;
                break block$6
              }
            }
          }
        }
      };
      var this$221 = $n(result$4);
      var x$90$1 = $as_sci_List($n($as_sci_StrictOptimizedSeqOps($f_sc_StrictOptimizedSeqOps__appended__O__O(this$221, site))).sorted__s_math_Ordering__O($m_Lreactbuild_model_Implicits$().projectOrdering__s_math_Ordering()));
      var this$222 = $n(cd$7);
      var x$91$1 = this$222.Lreactbuild_model_CommonData__f_persons;
      var this$223 = $n(cd$7);
      var x$92 = this$223.Lreactbuild_model_CommonData__f_personAnnotations;
      var this$224 = $n(cd$7);
      var x$93 = this$224.Lreactbuild_model_CommonData__f_buildingParts;
      var this$225 = $n(cd$7);
      var x$94 = this$225.Lreactbuild_model_CommonData__f_buildingStages;
      var this$226 = $n(cd$7);
      var x$95 = this$226.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var this$227 = $n(cd$7);
      var x$96 = this$227.Lreactbuild_model_CommonData__f_resources;
      var this$228 = $n(cd$7);
      var x$97 = this$228.Lreactbuild_model_CommonData__f_products;
      var this$229 = $n(cd$7);
      var x$98 = this$229.Lreactbuild_model_CommonData__f_listTemplates;
      var this$230 = $n(cd$7);
      var x$99 = this$230.Lreactbuild_model_CommonData__f_terms;
      var this$231 = $n(cd$7);
      var x$100 = this$231.Lreactbuild_model_CommonData__f_organizationUsers;
      $n(cd$7);
      return new $c_Lreactbuild_model_CommonData(x$91$1, x$92, x$93, x$90$1, x$94, x$95, x$96, x$97, x$98, x$99, x$100)
    })));
    var f$9 = new $c_sjsr_AnonFunction0((() => {
      var this$233 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x32 = new $c_Lautowire_ClientProxy(this$233).Lautowire_ClientProxy__f_self;
      var $$x31 = $m_s_package$().s_package$__f_Seq;
      var array$9 = ["reactbuild", "project", "ProjectApi", "persistBuildingSite"];
      var $$x30 = $as_sci_Seq($n($$x31).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9)));
      var this$244 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$238 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$239 = $n(new $c_Lautowire_ClientProxy(this$238).Lautowire_ClientProxy__f_self);
      var evidence$2$4 = $m_Lreactbuild_common_model_Project$().Lreactbuild_common_model_Project$__f_codecForProject;
      var y$4 = this$239.write__O__Lio_circe_Encoder__Lio_circe_Json(site, evidence$2$4);
      var array$10 = [$ct_T2__O__O__(new $c_T2(), "x", y$4)];
      var elems$5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
      return $n($n($n($$x32).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x30, this$244.from__sc_IterableOnce__sci_Map(elems$5)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$101$2) => {
        var x$101 = $as_Lio_circe_Json(x$101$2);
        var this$245 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$246 = $n(new $c_Lautowire_ClientProxy(this$245).Lautowire_ClientProxy__f_self);
        var evidence$1$5 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$246.read__Lio_circe_Json__Lio_circe_Decoder__O(x$101, evidence$1$5)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$23$2) => {
        $as_jl_Void(x$23$2);
        return $m_Ldiode_NoAction$()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec$5 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x34).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x33, new $c_Ldiode_EffectSingle(f$9, ec$5))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingPart)) {
    var x10 = $as_Lreactbuild_analyze_cost_actions_PersistBuildingPart(x1);
    var part = $n(x10).Lreactbuild_analyze_cost_actions_PersistBuildingPart__f_item;
    var $$x39 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$248 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var $$x38 = $n($as_Ldiode_data_Pot($n(this$248.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$248.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$8$2) => {
      var cd$8 = $as_Lreactbuild_model_CommonData(cd$8$2);
      var this$249 = $n($n(cd$8).Lreactbuild_model_CommonData__f_buildingParts);
      var f$10 = ((x$24$2) => {
        var x$24$1 = $as_Lreactbuild_model_BuildingPart(x$24$2);
        var x$102 = $n(x$24$1).Lreactbuild_model_BuildingPart__f__id;
        var x$2$12 = $n(part).Lreactbuild_model_BuildingPart__f__id;
        return (!((x$102 === null) ? (x$2$12 === null) : $n(x$102).equals__O__Z(x$2$12)))
      });
      var l$4 = this$249;
      block$8: {
        var result$5;
        while (true) {
          if ($n(l$4).isEmpty__Z()) {
            var result$5 = $m_sci_Nil$();
            break
          } else {
            var h$4 = $n(l$4).head__O();
            var t$5 = $as_sci_List($n(l$4).tail__O());
            if (($uZ(f$10(h$4)) === false)) {
              l$4 = t$5;
              continue
            };
            var start$4 = l$4;
            var remaining$4 = t$5;
            while (true) {
              if ($n(remaining$4).isEmpty__Z()) {
                var result$5 = start$4;
                break block$8
              } else {
                var x$103 = $n(remaining$4).head__O();
                if (($uZ(f$10(x$103)) !== false)) {
                  remaining$4 = $as_sci_List($n(remaining$4).tail__O());
                  continue
                };
                var firstMiss$4 = remaining$4;
                var newHead$4 = new $c_sci_$colon$colon($n(start$4).head__O(), $m_sci_Nil$());
                var toProcess$4 = $as_sci_List($n(start$4).tail__O());
                var currentLast$4 = newHead$4;
                while ((toProcess$4 !== firstMiss$4)) {
                  var newElem$5 = new $c_sci_$colon$colon($n(toProcess$4).head__O(), $m_sci_Nil$());
                  $n(currentLast$4).sci_$colon$colon__f_next = newElem$5;
                  currentLast$4 = newElem$5;
                  toProcess$4 = $as_sci_List($n(toProcess$4).tail__O())
                };
                var next$5 = $as_sci_List($n(firstMiss$4).tail__O());
                var nextToCopy$4 = next$5;
                while ((!$n(next$5).isEmpty__Z())) {
                  var head$4 = $n(next$5).head__O();
                  if (($uZ(f$10(head$4)) !== false)) {
                    next$5 = $as_sci_List($n(next$5).tail__O())
                  } else {
                    while ((nextToCopy$4 !== next$5)) {
                      var newElem$2$4 = new $c_sci_$colon$colon($n(nextToCopy$4).head__O(), $m_sci_Nil$());
                      $n(currentLast$4).sci_$colon$colon__f_next = newElem$2$4;
                      currentLast$4 = newElem$2$4;
                      nextToCopy$4 = $as_sci_List($n(nextToCopy$4).tail__O())
                    };
                    nextToCopy$4 = $as_sci_List($n(next$5).tail__O());
                    next$5 = $as_sci_List($n(next$5).tail__O())
                  }
                };
                if ((!$n(nextToCopy$4).isEmpty__Z())) {
                  $n(currentLast$4).sci_$colon$colon__f_next = nextToCopy$4
                };
                var result$5 = newHead$4;
                break block$8
              }
            }
          }
        }
      };
      var this$250 = $n(result$5);
      var x$102$1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$250, part));
      var this$251 = $n(cd$8);
      var x$103$1 = this$251.Lreactbuild_model_CommonData__f_persons;
      var this$252 = $n(cd$8);
      var x$104 = this$252.Lreactbuild_model_CommonData__f_personAnnotations;
      var this$253 = $n(cd$8);
      var x$105 = this$253.Lreactbuild_model_CommonData__f_buildingSites;
      var this$254 = $n(cd$8);
      var x$106 = this$254.Lreactbuild_model_CommonData__f_buildingStages;
      var this$255 = $n(cd$8);
      var x$107 = this$255.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var this$256 = $n(cd$8);
      var x$108 = this$256.Lreactbuild_model_CommonData__f_resources;
      var this$257 = $n(cd$8);
      var x$109 = this$257.Lreactbuild_model_CommonData__f_products;
      var this$258 = $n(cd$8);
      var x$110 = this$258.Lreactbuild_model_CommonData__f_listTemplates;
      var this$259 = $n(cd$8);
      var x$111 = this$259.Lreactbuild_model_CommonData__f_terms;
      var this$260 = $n(cd$8);
      var x$112 = this$260.Lreactbuild_model_CommonData__f_organizationUsers;
      $n(cd$8);
      return new $c_Lreactbuild_model_CommonData(x$103$1, x$104, x$102$1, x$105, x$106, x$107, x$108, x$109, x$110, x$111, x$112)
    })));
    var f$11 = new $c_sjsr_AnonFunction0((() => {
      var this$262 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x37 = new $c_Lautowire_ClientProxy(this$262).Lautowire_ClientProxy__f_self;
      var $$x36 = $m_s_package$().s_package$__f_Seq;
      var array$11 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistBuildingPart"];
      var $$x35 = $as_sci_Seq($n($$x36).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11)));
      var this$273 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$267 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$268 = $n(new $c_Lautowire_ClientProxy(this$267).Lautowire_ClientProxy__f_self);
      var evidence$2$5 = $m_Lreactbuild_model_BuildingPart$().Lreactbuild_model_BuildingPart$__f_codecForBuildingPart;
      var y$5 = this$268.write__O__Lio_circe_Encoder__Lio_circe_Json(part, evidence$2$5);
      var array$12 = [$ct_T2__O__O__(new $c_T2(), "x", y$5)];
      var elems$6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
      return $n($n($n($$x37).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x35, this$273.from__sc_IterableOnce__sci_Map(elems$6)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$113$2) => {
        var x$113 = $as_Lio_circe_Json(x$113$2);
        var this$274 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$275 = $n(new $c_Lautowire_ClientProxy(this$274).Lautowire_ClientProxy__f_self);
        var evidence$1$6 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$275.read__Lio_circe_Json__Lio_circe_Decoder__O(x$113, evidence$1$6)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$25$2) => {
        $as_jl_Void(x$25$2);
        return $m_Ldiode_NoAction$()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec$6 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x39).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x38, new $c_Ldiode_EffectSingle(f$11, ec$6))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingStage)) {
    var x11 = $as_Lreactbuild_analyze_cost_actions_PersistBuildingStage(x1);
    var stage = $n(x11).Lreactbuild_analyze_cost_actions_PersistBuildingStage__f_item;
    var $$x44 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$277 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var $$x43 = $n($as_Ldiode_data_Pot($n(this$277.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$277.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$9$2) => {
      var cd$9 = $as_Lreactbuild_model_CommonData(cd$9$2);
      var this$278 = $n($n(cd$9).Lreactbuild_model_CommonData__f_buildingStages);
      var f$12 = ((x$26$2$1) => {
        var x$26$1 = $as_Lreactbuild_model_BuildingStage(x$26$2$1);
        var x$114 = $n(x$26$1).Lreactbuild_model_BuildingStage__f__id;
        var x$2$13 = $n(stage).Lreactbuild_model_BuildingStage__f__id;
        return (!((x$114 === null) ? (x$2$13 === null) : $n(x$114).equals__O__Z(x$2$13)))
      });
      var l$5 = this$278;
      block$10: {
        var result$6;
        while (true) {
          if ($n(l$5).isEmpty__Z()) {
            var result$6 = $m_sci_Nil$();
            break
          } else {
            var h$5 = $n(l$5).head__O();
            var t$6 = $as_sci_List($n(l$5).tail__O());
            if (($uZ(f$12(h$5)) === false)) {
              l$5 = t$6;
              continue
            };
            var start$5 = l$5;
            var remaining$5 = t$6;
            while (true) {
              if ($n(remaining$5).isEmpty__Z()) {
                var result$6 = start$5;
                break block$10
              } else {
                var x$115 = $n(remaining$5).head__O();
                if (($uZ(f$12(x$115)) !== false)) {
                  remaining$5 = $as_sci_List($n(remaining$5).tail__O());
                  continue
                };
                var firstMiss$5 = remaining$5;
                var newHead$5 = new $c_sci_$colon$colon($n(start$5).head__O(), $m_sci_Nil$());
                var toProcess$5 = $as_sci_List($n(start$5).tail__O());
                var currentLast$5 = newHead$5;
                while ((toProcess$5 !== firstMiss$5)) {
                  var newElem$6 = new $c_sci_$colon$colon($n(toProcess$5).head__O(), $m_sci_Nil$());
                  $n(currentLast$5).sci_$colon$colon__f_next = newElem$6;
                  currentLast$5 = newElem$6;
                  toProcess$5 = $as_sci_List($n(toProcess$5).tail__O())
                };
                var next$6 = $as_sci_List($n(firstMiss$5).tail__O());
                var nextToCopy$5 = next$6;
                while ((!$n(next$6).isEmpty__Z())) {
                  var head$5 = $n(next$6).head__O();
                  if (($uZ(f$12(head$5)) !== false)) {
                    next$6 = $as_sci_List($n(next$6).tail__O())
                  } else {
                    while ((nextToCopy$5 !== next$6)) {
                      var newElem$2$5 = new $c_sci_$colon$colon($n(nextToCopy$5).head__O(), $m_sci_Nil$());
                      $n(currentLast$5).sci_$colon$colon__f_next = newElem$2$5;
                      currentLast$5 = newElem$2$5;
                      nextToCopy$5 = $as_sci_List($n(nextToCopy$5).tail__O())
                    };
                    nextToCopy$5 = $as_sci_List($n(next$6).tail__O());
                    next$6 = $as_sci_List($n(next$6).tail__O())
                  }
                };
                if ((!$n(nextToCopy$5).isEmpty__Z())) {
                  $n(currentLast$5).sci_$colon$colon__f_next = nextToCopy$5
                };
                var result$6 = newHead$5;
                break block$10
              }
            }
          }
        }
      };
      var this$279 = $n(result$6);
      var x$114$1 = $as_sci_List($n($as_sci_StrictOptimizedSeqOps($f_sc_StrictOptimizedSeqOps__appended__O__O(this$279, stage))).sorted__s_math_Ordering__O($m_Lreactbuild_model_Implicits$().buildingStageOrdering__s_math_Ordering()));
      var this$280 = $n(cd$9);
      var x$115$1 = this$280.Lreactbuild_model_CommonData__f_persons;
      var this$281 = $n(cd$9);
      var x$116 = this$281.Lreactbuild_model_CommonData__f_personAnnotations;
      var this$282 = $n(cd$9);
      var x$117 = this$282.Lreactbuild_model_CommonData__f_buildingParts;
      var this$283 = $n(cd$9);
      var x$118 = this$283.Lreactbuild_model_CommonData__f_buildingSites;
      var this$284 = $n(cd$9);
      var x$119 = this$284.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var this$285 = $n(cd$9);
      var x$120 = this$285.Lreactbuild_model_CommonData__f_resources;
      var this$286 = $n(cd$9);
      var x$121 = this$286.Lreactbuild_model_CommonData__f_products;
      var this$287 = $n(cd$9);
      var x$122 = this$287.Lreactbuild_model_CommonData__f_listTemplates;
      var this$288 = $n(cd$9);
      var x$123 = this$288.Lreactbuild_model_CommonData__f_terms;
      var this$289 = $n(cd$9);
      var x$124 = this$289.Lreactbuild_model_CommonData__f_organizationUsers;
      $n(cd$9);
      return new $c_Lreactbuild_model_CommonData(x$115$1, x$116, x$117, x$118, x$114$1, x$119, x$120, x$121, x$122, x$123, x$124)
    })));
    var f$13 = new $c_sjsr_AnonFunction0((() => {
      var this$291 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x42 = new $c_Lautowire_ClientProxy(this$291).Lautowire_ClientProxy__f_self;
      var $$x41 = $m_s_package$().s_package$__f_Seq;
      var array$13 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistBuildingStage"];
      var $$x40 = $as_sci_Seq($n($$x41).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13)));
      var this$302 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$296 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$297 = $n(new $c_Lautowire_ClientProxy(this$296).Lautowire_ClientProxy__f_self);
      var evidence$2$6 = $m_Lreactbuild_model_BuildingStage$().Lreactbuild_model_BuildingStage$__f_codecForBuildingStage;
      var y$6 = this$297.write__O__Lio_circe_Encoder__Lio_circe_Json(stage, evidence$2$6);
      var array$14 = [$ct_T2__O__O__(new $c_T2(), "x", y$6)];
      var elems$7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14);
      return $n($n($n($$x42).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x40, this$302.from__sc_IterableOnce__sci_Map(elems$7)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$125$2) => {
        var x$125 = $as_Lio_circe_Json(x$125$2);
        var this$303 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$304 = $n(new $c_Lautowire_ClientProxy(this$303).Lautowire_ClientProxy__f_self);
        var evidence$1$7 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$304.read__Lio_circe_Json__Lio_circe_Decoder__O(x$125, evidence$1$7)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$27$2) => {
        $as_jl_Void(x$27$2);
        return $m_Ldiode_NoAction$()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec$7 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x44).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x43, new $c_Ldiode_EffectSingle(f$13, ec$7))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistResource)) {
    var x12 = $as_Lreactbuild_analyze_cost_actions_PersistResource(x1);
    var resource = $n(x12).Lreactbuild_analyze_cost_actions_PersistResource__f_item;
    var $$x49 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$306 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var $$x48 = $n($as_Ldiode_data_Pot($n(this$306.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$306.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$10$2) => {
      var cd$10 = $as_Lreactbuild_model_CommonData(cd$10$2);
      var this$307 = $n($n(cd$10).Lreactbuild_model_CommonData__f_resources);
      var f$14 = ((x$28$2) => {
        var x$28$1 = $as_Lreactbuild_model_Resource(x$28$2);
        var x$126 = $n(x$28$1).Lreactbuild_model_Resource__f__id;
        var x$2$14 = $n(resource).Lreactbuild_model_Resource__f__id;
        return (!((x$126 === null) ? (x$2$14 === null) : $n(x$126).equals__O__Z(x$2$14)))
      });
      var l$6 = this$307;
      block$12: {
        var result$7;
        while (true) {
          if ($n(l$6).isEmpty__Z()) {
            var result$7 = $m_sci_Nil$();
            break
          } else {
            var h$6 = $n(l$6).head__O();
            var t$7 = $as_sci_List($n(l$6).tail__O());
            if (($uZ(f$14(h$6)) === false)) {
              l$6 = t$7;
              continue
            };
            var start$6 = l$6;
            var remaining$6 = t$7;
            while (true) {
              if ($n(remaining$6).isEmpty__Z()) {
                var result$7 = start$6;
                break block$12
              } else {
                var x$127 = $n(remaining$6).head__O();
                if (($uZ(f$14(x$127)) !== false)) {
                  remaining$6 = $as_sci_List($n(remaining$6).tail__O());
                  continue
                };
                var firstMiss$6 = remaining$6;
                var newHead$6 = new $c_sci_$colon$colon($n(start$6).head__O(), $m_sci_Nil$());
                var toProcess$6 = $as_sci_List($n(start$6).tail__O());
                var currentLast$6 = newHead$6;
                while ((toProcess$6 !== firstMiss$6)) {
                  var newElem$7 = new $c_sci_$colon$colon($n(toProcess$6).head__O(), $m_sci_Nil$());
                  $n(currentLast$6).sci_$colon$colon__f_next = newElem$7;
                  currentLast$6 = newElem$7;
                  toProcess$6 = $as_sci_List($n(toProcess$6).tail__O())
                };
                var next$7 = $as_sci_List($n(firstMiss$6).tail__O());
                var nextToCopy$6 = next$7;
                while ((!$n(next$7).isEmpty__Z())) {
                  var head$6 = $n(next$7).head__O();
                  if (($uZ(f$14(head$6)) !== false)) {
                    next$7 = $as_sci_List($n(next$7).tail__O())
                  } else {
                    while ((nextToCopy$6 !== next$7)) {
                      var newElem$2$6 = new $c_sci_$colon$colon($n(nextToCopy$6).head__O(), $m_sci_Nil$());
                      $n(currentLast$6).sci_$colon$colon__f_next = newElem$2$6;
                      currentLast$6 = newElem$2$6;
                      nextToCopy$6 = $as_sci_List($n(nextToCopy$6).tail__O())
                    };
                    nextToCopy$6 = $as_sci_List($n(next$7).tail__O());
                    next$7 = $as_sci_List($n(next$7).tail__O())
                  }
                };
                if ((!$n(nextToCopy$6).isEmpty__Z())) {
                  $n(currentLast$6).sci_$colon$colon__f_next = nextToCopy$6
                };
                var result$7 = newHead$6;
                break block$12
              }
            }
          }
        }
      };
      var this$308 = $n(result$7);
      var x$126$1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$308, resource));
      var this$309 = $n(cd$10);
      var x$127$1 = this$309.Lreactbuild_model_CommonData__f_persons;
      var this$310 = $n(cd$10);
      var x$128 = this$310.Lreactbuild_model_CommonData__f_personAnnotations;
      var this$311 = $n(cd$10);
      var x$129 = this$311.Lreactbuild_model_CommonData__f_buildingParts;
      var this$312 = $n(cd$10);
      var x$130 = this$312.Lreactbuild_model_CommonData__f_buildingSites;
      var this$313 = $n(cd$10);
      var x$131 = this$313.Lreactbuild_model_CommonData__f_buildingStages;
      var this$314 = $n(cd$10);
      var x$132 = this$314.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var this$315 = $n(cd$10);
      var x$133 = this$315.Lreactbuild_model_CommonData__f_products;
      var this$316 = $n(cd$10);
      var x$134 = this$316.Lreactbuild_model_CommonData__f_listTemplates;
      var this$317 = $n(cd$10);
      var x$135 = this$317.Lreactbuild_model_CommonData__f_terms;
      var this$318 = $n(cd$10);
      var x$136 = this$318.Lreactbuild_model_CommonData__f_organizationUsers;
      $n(cd$10);
      return new $c_Lreactbuild_model_CommonData(x$127$1, x$128, x$129, x$130, x$131, x$132, x$126$1, x$133, x$134, x$135, x$136)
    })));
    var f$15 = new $c_sjsr_AnonFunction0((() => {
      var this$320 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x47 = new $c_Lautowire_ClientProxy(this$320).Lautowire_ClientProxy__f_self;
      var $$x46 = $m_s_package$().s_package$__f_Seq;
      var array$15 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistResource"];
      var $$x45 = $as_sci_Seq($n($$x46).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15)));
      var this$331 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$325 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$326 = $n(new $c_Lautowire_ClientProxy(this$325).Lautowire_ClientProxy__f_self);
      var evidence$2$7 = $m_Lreactbuild_model_Resource$().Lreactbuild_model_Resource$__f_codecForResource;
      var y$7 = this$326.write__O__Lio_circe_Encoder__Lio_circe_Json(resource, evidence$2$7);
      var array$16 = [$ct_T2__O__O__(new $c_T2(), "x", y$7)];
      var elems$8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
      return $n($n($n($$x47).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x45, this$331.from__sc_IterableOnce__sci_Map(elems$8)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$137$2) => {
        var x$137 = $as_Lio_circe_Json(x$137$2);
        var this$332 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$333 = $n(new $c_Lautowire_ClientProxy(this$332).Lautowire_ClientProxy__f_self);
        var evidence$1$8 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$333.read__Lio_circe_Json__Lio_circe_Decoder__O(x$137, evidence$1$8)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$29$2) => {
        $as_jl_Void(x$29$2);
        return $m_Ldiode_NoAction$()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec$8 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x49).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x48, new $c_Ldiode_EffectSingle(f$15, ec$8))
  } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistProduct)) {
    var x13 = $as_Lreactbuild_analyze_cost_actions_PersistProduct(x1);
    var updateInvoiceDetail = $n(x13).Lreactbuild_analyze_cost_actions_PersistProduct__f_updateInvoiceDetail;
    var product = $n(x13).Lreactbuild_analyze_cost_actions_PersistProduct__f_item;
    var $$x55 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var this$335 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3__f_$outer);
    var $$x54 = $n($as_Ldiode_data_Pot($n(this$335.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$335.Ldiode_ActionHandler__f_currentModel))).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((cd$11$2) => {
      var cd$11 = $as_Lreactbuild_model_CommonData(cd$11$2);
      var this$336 = $n($n(cd$11).Lreactbuild_model_CommonData__f_products);
      var f$16 = ((x$30$2) => {
        var x$30$1 = $as_Lreactbuild_model_Product(x$30$2);
        var x$138 = $n(x$30$1).Lreactbuild_model_Product__f__id;
        var x$2$15 = $n(product).Lreactbuild_model_Product__f__id;
        return (!((x$138 === null) ? (x$2$15 === null) : $n(x$138).equals__O__Z(x$2$15)))
      });
      var l$7 = this$336;
      block$14: {
        var result$8;
        while (true) {
          if ($n(l$7).isEmpty__Z()) {
            var result$8 = $m_sci_Nil$();
            break
          } else {
            var h$7 = $n(l$7).head__O();
            var t$8 = $as_sci_List($n(l$7).tail__O());
            if (($uZ(f$16(h$7)) === false)) {
              l$7 = t$8;
              continue
            };
            var start$7 = l$7;
            var remaining$7 = t$8;
            while (true) {
              if ($n(remaining$7).isEmpty__Z()) {
                var result$8 = start$7;
                break block$14
              } else {
                var x$139 = $n(remaining$7).head__O();
                if (($uZ(f$16(x$139)) !== false)) {
                  remaining$7 = $as_sci_List($n(remaining$7).tail__O());
                  continue
                };
                var firstMiss$7 = remaining$7;
                var newHead$7 = new $c_sci_$colon$colon($n(start$7).head__O(), $m_sci_Nil$());
                var toProcess$7 = $as_sci_List($n(start$7).tail__O());
                var currentLast$7 = newHead$7;
                while ((toProcess$7 !== firstMiss$7)) {
                  var newElem$8 = new $c_sci_$colon$colon($n(toProcess$7).head__O(), $m_sci_Nil$());
                  $n(currentLast$7).sci_$colon$colon__f_next = newElem$8;
                  currentLast$7 = newElem$8;
                  toProcess$7 = $as_sci_List($n(toProcess$7).tail__O())
                };
                var next$8 = $as_sci_List($n(firstMiss$7).tail__O());
                var nextToCopy$7 = next$8;
                while ((!$n(next$8).isEmpty__Z())) {
                  var head$7 = $n(next$8).head__O();
                  if (($uZ(f$16(head$7)) !== false)) {
                    next$8 = $as_sci_List($n(next$8).tail__O())
                  } else {
                    while ((nextToCopy$7 !== next$8)) {
                      var newElem$2$7 = new $c_sci_$colon$colon($n(nextToCopy$7).head__O(), $m_sci_Nil$());
                      $n(currentLast$7).sci_$colon$colon__f_next = newElem$2$7;
                      currentLast$7 = newElem$2$7;
                      nextToCopy$7 = $as_sci_List($n(nextToCopy$7).tail__O())
                    };
                    nextToCopy$7 = $as_sci_List($n(next$8).tail__O());
                    next$8 = $as_sci_List($n(next$8).tail__O())
                  }
                };
                if ((!$n(nextToCopy$7).isEmpty__Z())) {
                  $n(currentLast$7).sci_$colon$colon__f_next = nextToCopy$7
                };
                var result$8 = newHead$7;
                break block$14
              }
            }
          }
        }
      };
      var this$337 = $n(result$8);
      var x$138$1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$337, product));
      var this$338 = $n(cd$11);
      var x$139$1 = this$338.Lreactbuild_model_CommonData__f_persons;
      var this$339 = $n(cd$11);
      var x$140 = this$339.Lreactbuild_model_CommonData__f_personAnnotations;
      var this$340 = $n(cd$11);
      var x$141 = this$340.Lreactbuild_model_CommonData__f_buildingParts;
      var this$341 = $n(cd$11);
      var x$142 = this$341.Lreactbuild_model_CommonData__f_buildingSites;
      var this$342 = $n(cd$11);
      var x$143 = this$342.Lreactbuild_model_CommonData__f_buildingStages;
      var this$343 = $n(cd$11);
      var x$144 = this$343.Lreactbuild_model_CommonData__f_buildingSiteStages;
      var this$344 = $n(cd$11);
      var x$145 = this$344.Lreactbuild_model_CommonData__f_resources;
      var this$345 = $n(cd$11);
      var x$146 = this$345.Lreactbuild_model_CommonData__f_listTemplates;
      var this$346 = $n(cd$11);
      var x$147 = this$346.Lreactbuild_model_CommonData__f_terms;
      var this$347 = $n(cd$11);
      var x$148 = this$347.Lreactbuild_model_CommonData__f_organizationUsers;
      $n(cd$11);
      return new $c_Lreactbuild_model_CommonData(x$139$1, x$140, x$141, x$142, x$143, x$144, x$145, x$138$1, x$146, x$147, x$148)
    })));
    var f$17 = new $c_sjsr_AnonFunction0((() => {
      var this$349 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x53 = new $c_Lautowire_ClientProxy(this$349).Lautowire_ClientProxy__f_self;
      var $$x52 = $m_s_package$().s_package$__f_Seq;
      var array$17 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "persistProduct"];
      var $$x51 = $as_sci_Seq($n($$x52).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17)));
      var this$364 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$354 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$355 = $n(new $c_Lautowire_ClientProxy(this$354).Lautowire_ClientProxy__f_self);
      var evidence$2$8 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
      var y$8 = this$355.write__O__Lio_circe_Encoder__Lio_circe_Json(updateInvoiceDetail, evidence$2$8);
      var $$x50 = $ct_T2__O__O__(new $c_T2(), "updateInvoiceDetail", y$8);
      var this$358 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$359 = $n(new $c_Lautowire_ClientProxy(this$358).Lautowire_ClientProxy__f_self);
      var evidence$2$9 = $m_Lreactbuild_model_Product$().Lreactbuild_model_Product$__f_codecForProduct;
      var y$9 = this$359.write__O__Lio_circe_Encoder__Lio_circe_Json(product, evidence$2$9);
      var array$18 = [$$x50, $ct_T2__O__O__(new $c_T2(), "x", y$9)];
      var elems$9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18);
      return $n($n($n($$x53).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x51, this$364.from__sc_IterableOnce__sci_Map(elems$9)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$149$2) => {
        var x$149 = $as_Lio_circe_Json(x$149$2);
        var this$365 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$366 = $n(new $c_Lautowire_ClientProxy(this$365).Lautowire_ClientProxy__f_self);
        var evidence$1$9 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$366.read__Lio_circe_Json__Lio_circe_Decoder__O(x$149, evidence$1$9)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$31$2) => {
        $as_jl_Void(x$31$2);
        return $m_Ldiode_NoAction$()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var ec$9 = $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue;
    return $n($$x55).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x54, new $c_Ldiode_EffectSingle(f$17, ec$9))
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3.prototype.isDefinedAt__O__Z = (function(x1) {
  var x = $m_Lreactbuild_analyze_cost_actions_InitAction$();
  if ((x === x1)) {
    return true
  } else {
    return ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_LoadCommonData) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistPerson) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistTerm) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistListTemplate) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistListTemplateEntry) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistPersonAnnotation) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingSite) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingPart) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistBuildingStage) || ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistResource) || (x1 instanceof $c_Lreactbuild_analyze_cost_actions_PersistProduct)))))))))))
  }
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$$anon$3$$anonfun$handle$3", {
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3;
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(e, default$1) {
  throw ((e instanceof $c_sjs_js_JavaScriptException) ? e.sjs_js_JavaScriptException__f_exception : $n(e))
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1.prototype.isDefinedAt__jl_Throwable__Z = (function(e) {
  return true
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1", {
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$3$$anonfun$handle$3$$anonfun$$nestedInanonfun$applyOrElse$5$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4(outer) {
  this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4__f_$outer = outer
  }
}
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4.prototype.constructor = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4.prototype = $c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4.prototype;
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4.prototype.applyOrElse__O__F1__O = (function(x1, default$1) {
  var x = $m_Lreactbuild_analyze_cost_actions_ApplicationStarted$();
  if ((x === x1)) {
    $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4__f_$outer);
    var effect = $m_Ldiode_Effect$().action__F0__Ldiode_ActionType__s_concurrent_ExecutionContext__Ldiode_EffectSingle(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_common_actions_AskConnectionState$())), $m_Ldiode_Action$aType$(), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    return new $c_Ldiode_ActionResult$EffectOnly(effect)
  } else if ((x1 instanceof $c_Lreactbuild_common_actions_Logged)) {
    $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4__f_$outer);
    var effect$1 = $m_Ldiode_Effect$().action__F0__Ldiode_ActionType__s_concurrent_ExecutionContext__Ldiode_EffectSingle(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_analyze_cost_actions_InitAction$())), $m_Ldiode_Action$aType$(), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    return new $c_Ldiode_ActionResult$EffectOnly(effect$1)
  } else {
    var x$3 = $m_Lreactbuild_common_actions_Logout$();
    if ((x$3 === x1)) {
      return $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4__f_$outer).updated__O__Ldiode_ActionResult(new $c_Lreactbuild_analyze_cost_services_Model($m_s_None$(), $m_s_None$(), $m_Ldiode_data_Unavailable$(), new $c_Lreactbuild_analyze_cost_components_Period($m_Lreactbuild_analyze_cost_components_Period$().apply$default$1__s_Option(), $m_s_None$()), $m_Ldiode_data_Unavailable$(), new $c_Lreactbuild_analyze_cost_services_ServerConnection(), $m_Ldiode_data_Empty$(), new $c_Lreactbuild_analyze_cost_services_PermissionRequested($m_s_package$().s_package$__f_Nil)))
    } else if ((x1 instanceof $c_Lreactbuild_analyze_cost_actions_SelectPeriod)) {
      var x6 = $as_Lreactbuild_analyze_cost_actions_SelectPeriod(x1);
      var newPeriod = $n(x6).Lreactbuild_analyze_cost_actions_SelectPeriod__f_period;
      var $$x1 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4__f_$outer);
      var this$14 = $n(this.Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4__f_$outer);
      var qual$1 = $as_Lreactbuild_analyze_cost_services_Model($n(this$14.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$14.Ldiode_ActionHandler__f_currentModel));
      var this$15 = $n(qual$1);
      var x$2$2 = this$15.Lreactbuild_analyze_cost_services_Model__f_logged;
      var this$16 = $n(qual$1);
      var x$3$2 = this$16.Lreactbuild_analyze_cost_services_Model__f_activeOrganization;
      var this$17 = $n(qual$1);
      var x$4$2 = this$17.Lreactbuild_analyze_cost_services_Model__f_commonData;
      var this$18 = $n(qual$1);
      var x$5 = this$18.Lreactbuild_analyze_cost_services_Model__f_library;
      var this$19 = $n(qual$1);
      var x$6 = this$19.Lreactbuild_analyze_cost_services_Model__f_serverConnection;
      var this$20 = $n(qual$1);
      var x$7 = this$20.Lreactbuild_analyze_cost_services_Model__f_serverConnectionState;
      var this$21 = $n(qual$1);
      var x$8 = this$21.Lreactbuild_analyze_cost_services_Model__f_permissionRequested;
      $n(qual$1);
      return $n($$x1).updated__O__Ldiode_ActionResult(new $c_Lreactbuild_analyze_cost_services_Model(x$2$2, x$3$2, x$4$2, newPeriod, x$5, x$6, x$7, x$8))
    } else {
      return $n(default$1).apply__O__O(x1)
    }
  }
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4.prototype.isDefinedAt__O__Z = (function(x1) {
  var x = $m_Lreactbuild_analyze_cost_actions_ApplicationStarted$();
  if ((x === x1)) {
    return true
  } else if ((x1 instanceof $c_Lreactbuild_common_actions_Logged)) {
    return true
  } else {
    var x$3 = $m_Lreactbuild_common_actions_Logout$();
    if ((x$3 === x1)) {
      return true
    } else {
      return (x1 instanceof $c_Lreactbuild_analyze_cost_actions_SelectPeriod)
    }
  }
});
var $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4: 0
}, false, "reactbuild.analyze.cost.services.AppCircuit$$anon$4$$anonfun$handle$4", {
  Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4.prototype.$classData = $d_Lreactbuild_analyze_cost_services_AppCircuit$$anon$4$$anonfun$handle$4;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11(outer, p$1, _p$1, ss$1, s$1) {
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_$outer = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_p$1 = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f__p$1 = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_ss$1 = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_s$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_$outer = outer
  };
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_p$1 = p$1;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f__p$1 = _p$1;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_ss$1 = ss$1;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_s$1 = s$1
}
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11.prototype = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11.prototype;
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  if ((x1 === 1)) {
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_p$1).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler).closeItem__Lreactbuild_analyze_cost_ui_ItemDetailViewContext__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_callback_Trampoline(this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f__p$1, this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_ss$1))
  } else if ($n($n($as_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase($n(this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_s$1).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState)).handleClose__s_PartialFunction()).isDefinedAt__O__Z(x1)) {
    var this$4 = $n($n(this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_$outer).Lreactbuild_analyze_cost_ui_ItemDetailView$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(s$2);
      var x$1 = $as_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase($n($n($as_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase($n(s).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState)).handleClose__s_PartialFunction()).apply__O__O(x1));
      var this$2 = $n(s);
      var x$2 = this$2.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_selected;
      $n(s);
      return new $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState(x$2, x$1)
    }));
    return $f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$4, mod)
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11.prototype.isDefinedAt__I__Z = (function(x1) {
  return ((x1 === 1) || $n($n($as_Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase($n(this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11__f_s$1).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedState__f_detailState)).handleClose__s_PartialFunction()).isDefinedAt__O__Z(x1))
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11: 0
}, false, "reactbuild.analyze.cost.ui.ItemDetailView$TypedBackend$$anonfun$render$11", {
  Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedBackend$$anonfun$render$11;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps(proxy, active, handler, reusability) {
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_active = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_reusability = null;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy = proxy;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_active = active;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler = handler;
  this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_reusability = reusability
}
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype.constructor = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype = $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype;
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype.productPrefix__T = (function() {
  return "TypedProps"
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_active;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps)) {
    var TypedProps$1 = $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps(x$1);
    var x = this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy;
    var x$2 = $n(TypedProps$1).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_proxy;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_active;
      var x$4 = $n(TypedProps$1).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_active;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler;
        var x$6 = $n(TypedProps$1).Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps__f_handler;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.ui.ItemDetailView$TypedProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.ui.ItemDetailView$TypedProps;", depth))
}
var $d_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps: 0
}, false, "reactbuild.analyze.cost.ui.ItemDetailView$TypedProps", {
  Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps: 1,
  O: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewContext: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps.prototype.$classData = $d_Lreactbuild_analyze_cost_ui_ItemDetailView$TypedProps;
/** @constructor */
function $c_Lreactbuild_common_actions_AskConnectionState$() {
  /*<skip>*/
}
$c_Lreactbuild_common_actions_AskConnectionState$.prototype = new $h_O();
$c_Lreactbuild_common_actions_AskConnectionState$.prototype.constructor = $c_Lreactbuild_common_actions_AskConnectionState$;
/** @constructor */
function $h_Lreactbuild_common_actions_AskConnectionState$() {
  /*<skip>*/
}
$h_Lreactbuild_common_actions_AskConnectionState$.prototype = $c_Lreactbuild_common_actions_AskConnectionState$.prototype;
$c_Lreactbuild_common_actions_AskConnectionState$.prototype.productPrefix__T = (function() {
  return "AskConnectionState"
});
$c_Lreactbuild_common_actions_AskConnectionState$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_actions_AskConnectionState$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_actions_AskConnectionState$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_actions_AskConnectionState$.prototype.hashCode__I = (function() {
  return 1557760186
});
$c_Lreactbuild_common_actions_AskConnectionState$.prototype.toString__T = (function() {
  return "AskConnectionState"
});
var $d_Lreactbuild_common_actions_AskConnectionState$ = new $TypeData().initClass({
  Lreactbuild_common_actions_AskConnectionState$: 0
}, false, "reactbuild.common.actions.AskConnectionState$", {
  Lreactbuild_common_actions_AskConnectionState$: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_actions_AskConnectionState$.prototype.$classData = $d_Lreactbuild_common_actions_AskConnectionState$;
var $n_Lreactbuild_common_actions_AskConnectionState$;
function $m_Lreactbuild_common_actions_AskConnectionState$() {
  if ((!$n_Lreactbuild_common_actions_AskConnectionState$)) {
    $n_Lreactbuild_common_actions_AskConnectionState$ = new $c_Lreactbuild_common_actions_AskConnectionState$()
  };
  return $n_Lreactbuild_common_actions_AskConnectionState$
}
/** @constructor */
function $c_Lreactbuild_common_actions_LoadLibrary(definitions) {
  this.Lreactbuild_common_actions_LoadLibrary__f_definitions = null;
  this.Lreactbuild_common_actions_LoadLibrary__f_definitions = definitions
}
$c_Lreactbuild_common_actions_LoadLibrary.prototype = new $h_O();
$c_Lreactbuild_common_actions_LoadLibrary.prototype.constructor = $c_Lreactbuild_common_actions_LoadLibrary;
/** @constructor */
function $h_Lreactbuild_common_actions_LoadLibrary() {
  /*<skip>*/
}
$h_Lreactbuild_common_actions_LoadLibrary.prototype = $c_Lreactbuild_common_actions_LoadLibrary.prototype;
$c_Lreactbuild_common_actions_LoadLibrary.prototype.productPrefix__T = (function() {
  return "LoadLibrary"
});
$c_Lreactbuild_common_actions_LoadLibrary.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_actions_LoadLibrary.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_actions_LoadLibrary__f_definitions : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_actions_LoadLibrary.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_actions_LoadLibrary.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_actions_LoadLibrary.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_actions_LoadLibrary.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_actions_LoadLibrary)) {
    var LoadLibrary$1 = $as_Lreactbuild_common_actions_LoadLibrary(x$1);
    var x = this.Lreactbuild_common_actions_LoadLibrary__f_definitions;
    var x$2 = $n(LoadLibrary$1).Lreactbuild_common_actions_LoadLibrary__f_definitions;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(LoadLibrary$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_actions_LoadLibrary(obj) {
  return (((obj instanceof $c_Lreactbuild_common_actions_LoadLibrary) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.actions.LoadLibrary"))
}
function $isArrayOf_Lreactbuild_common_actions_LoadLibrary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_actions_LoadLibrary)))
}
function $asArrayOf_Lreactbuild_common_actions_LoadLibrary(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_actions_LoadLibrary(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.actions.LoadLibrary;", depth))
}
var $d_Lreactbuild_common_actions_LoadLibrary = new $TypeData().initClass({
  Lreactbuild_common_actions_LoadLibrary: 0
}, false, "reactbuild.common.actions.LoadLibrary", {
  Lreactbuild_common_actions_LoadLibrary: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_actions_LoadLibrary.prototype.$classData = $d_Lreactbuild_common_actions_LoadLibrary;
/** @constructor */
function $c_Lreactbuild_common_actions_LoadLibraryFailed(error) {
  this.Lreactbuild_common_actions_LoadLibraryFailed__f_error = null;
  this.Lreactbuild_common_actions_LoadLibraryFailed__f_error = error
}
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype = new $h_O();
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype.constructor = $c_Lreactbuild_common_actions_LoadLibraryFailed;
/** @constructor */
function $h_Lreactbuild_common_actions_LoadLibraryFailed() {
  /*<skip>*/
}
$h_Lreactbuild_common_actions_LoadLibraryFailed.prototype = $c_Lreactbuild_common_actions_LoadLibraryFailed.prototype;
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype.productPrefix__T = (function() {
  return "LoadLibraryFailed"
});
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_actions_LoadLibraryFailed__f_error : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_actions_LoadLibraryFailed)) {
    var LoadLibraryFailed$1 = $as_Lreactbuild_common_actions_LoadLibraryFailed(x$1);
    var x = this.Lreactbuild_common_actions_LoadLibraryFailed__f_error;
    var x$2 = $n(LoadLibraryFailed$1).Lreactbuild_common_actions_LoadLibraryFailed__f_error;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(LoadLibraryFailed$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_actions_LoadLibraryFailed(obj) {
  return (((obj instanceof $c_Lreactbuild_common_actions_LoadLibraryFailed) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.actions.LoadLibraryFailed"))
}
function $isArrayOf_Lreactbuild_common_actions_LoadLibraryFailed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_actions_LoadLibraryFailed)))
}
function $asArrayOf_Lreactbuild_common_actions_LoadLibraryFailed(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_actions_LoadLibraryFailed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.actions.LoadLibraryFailed;", depth))
}
var $d_Lreactbuild_common_actions_LoadLibraryFailed = new $TypeData().initClass({
  Lreactbuild_common_actions_LoadLibraryFailed: 0
}, false, "reactbuild.common.actions.LoadLibraryFailed", {
  Lreactbuild_common_actions_LoadLibraryFailed: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_actions_LoadLibraryFailed.prototype.$classData = $d_Lreactbuild_common_actions_LoadLibraryFailed;
/** @constructor */
function $c_Lreactbuild_common_actions_Logged(user) {
  this.Lreactbuild_common_actions_Logged__f_user = null;
  this.Lreactbuild_common_actions_Logged__f_user = user
}
$c_Lreactbuild_common_actions_Logged.prototype = new $h_O();
$c_Lreactbuild_common_actions_Logged.prototype.constructor = $c_Lreactbuild_common_actions_Logged;
/** @constructor */
function $h_Lreactbuild_common_actions_Logged() {
  /*<skip>*/
}
$h_Lreactbuild_common_actions_Logged.prototype = $c_Lreactbuild_common_actions_Logged.prototype;
$c_Lreactbuild_common_actions_Logged.prototype.productPrefix__T = (function() {
  return "Logged"
});
$c_Lreactbuild_common_actions_Logged.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_actions_Logged.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_actions_Logged__f_user : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_actions_Logged.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_actions_Logged.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_actions_Logged.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_actions_Logged.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_actions_Logged)) {
    var Logged$1 = $as_Lreactbuild_common_actions_Logged(x$1);
    var x = this.Lreactbuild_common_actions_Logged__f_user;
    var x$2 = $n(Logged$1).Lreactbuild_common_actions_Logged__f_user;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Logged$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_actions_Logged(obj) {
  return (((obj instanceof $c_Lreactbuild_common_actions_Logged) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.actions.Logged"))
}
function $isArrayOf_Lreactbuild_common_actions_Logged(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_actions_Logged)))
}
function $asArrayOf_Lreactbuild_common_actions_Logged(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_actions_Logged(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.actions.Logged;", depth))
}
var $d_Lreactbuild_common_actions_Logged = new $TypeData().initClass({
  Lreactbuild_common_actions_Logged: 0
}, false, "reactbuild.common.actions.Logged", {
  Lreactbuild_common_actions_Logged: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_actions_Logged.prototype.$classData = $d_Lreactbuild_common_actions_Logged;
/** @constructor */
function $c_Lreactbuild_common_actions_Logout$() {
  /*<skip>*/
}
$c_Lreactbuild_common_actions_Logout$.prototype = new $h_O();
$c_Lreactbuild_common_actions_Logout$.prototype.constructor = $c_Lreactbuild_common_actions_Logout$;
/** @constructor */
function $h_Lreactbuild_common_actions_Logout$() {
  /*<skip>*/
}
$h_Lreactbuild_common_actions_Logout$.prototype = $c_Lreactbuild_common_actions_Logout$.prototype;
$c_Lreactbuild_common_actions_Logout$.prototype.productPrefix__T = (function() {
  return "Logout"
});
$c_Lreactbuild_common_actions_Logout$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_actions_Logout$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_actions_Logout$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_actions_Logout$.prototype.hashCode__I = (function() {
  return (-2013462102)
});
$c_Lreactbuild_common_actions_Logout$.prototype.toString__T = (function() {
  return "Logout"
});
var $d_Lreactbuild_common_actions_Logout$ = new $TypeData().initClass({
  Lreactbuild_common_actions_Logout$: 0
}, false, "reactbuild.common.actions.Logout$", {
  Lreactbuild_common_actions_Logout$: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_actions_Logout$.prototype.$classData = $d_Lreactbuild_common_actions_Logout$;
var $n_Lreactbuild_common_actions_Logout$;
function $m_Lreactbuild_common_actions_Logout$() {
  if ((!$n_Lreactbuild_common_actions_Logout$)) {
    $n_Lreactbuild_common_actions_Logout$ = new $c_Lreactbuild_common_actions_Logout$()
  };
  return $n_Lreactbuild_common_actions_Logout$
}
/** @constructor */
function $c_Lreactbuild_common_actions_NotConnected$() {
  /*<skip>*/
}
$c_Lreactbuild_common_actions_NotConnected$.prototype = new $h_O();
$c_Lreactbuild_common_actions_NotConnected$.prototype.constructor = $c_Lreactbuild_common_actions_NotConnected$;
/** @constructor */
function $h_Lreactbuild_common_actions_NotConnected$() {
  /*<skip>*/
}
$h_Lreactbuild_common_actions_NotConnected$.prototype = $c_Lreactbuild_common_actions_NotConnected$.prototype;
$c_Lreactbuild_common_actions_NotConnected$.prototype.productPrefix__T = (function() {
  return "NotConnected"
});
$c_Lreactbuild_common_actions_NotConnected$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_actions_NotConnected$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_actions_NotConnected$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_actions_NotConnected$.prototype.hashCode__I = (function() {
  return (-310560362)
});
$c_Lreactbuild_common_actions_NotConnected$.prototype.toString__T = (function() {
  return "NotConnected"
});
var $d_Lreactbuild_common_actions_NotConnected$ = new $TypeData().initClass({
  Lreactbuild_common_actions_NotConnected$: 0
}, false, "reactbuild.common.actions.NotConnected$", {
  Lreactbuild_common_actions_NotConnected$: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_actions_NotConnected$.prototype.$classData = $d_Lreactbuild_common_actions_NotConnected$;
var $n_Lreactbuild_common_actions_NotConnected$;
function $m_Lreactbuild_common_actions_NotConnected$() {
  if ((!$n_Lreactbuild_common_actions_NotConnected$)) {
    $n_Lreactbuild_common_actions_NotConnected$ = new $c_Lreactbuild_common_actions_NotConnected$()
  };
  return $n_Lreactbuild_common_actions_NotConnected$
}
/** @constructor */
function $c_Lreactbuild_common_actions_PleaseLoadLibrary$() {
  /*<skip>*/
}
$c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype = new $h_O();
$c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype.constructor = $c_Lreactbuild_common_actions_PleaseLoadLibrary$;
/** @constructor */
function $h_Lreactbuild_common_actions_PleaseLoadLibrary$() {
  /*<skip>*/
}
$h_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype = $c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype;
$c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype.productPrefix__T = (function() {
  return "PleaseLoadLibrary"
});
$c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype.hashCode__I = (function() {
  return (-471013749)
});
$c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype.toString__T = (function() {
  return "PleaseLoadLibrary"
});
var $d_Lreactbuild_common_actions_PleaseLoadLibrary$ = new $TypeData().initClass({
  Lreactbuild_common_actions_PleaseLoadLibrary$: 0
}, false, "reactbuild.common.actions.PleaseLoadLibrary$", {
  Lreactbuild_common_actions_PleaseLoadLibrary$: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_actions_PleaseLoadLibrary$.prototype.$classData = $d_Lreactbuild_common_actions_PleaseLoadLibrary$;
var $n_Lreactbuild_common_actions_PleaseLoadLibrary$;
function $m_Lreactbuild_common_actions_PleaseLoadLibrary$() {
  if ((!$n_Lreactbuild_common_actions_PleaseLoadLibrary$)) {
    $n_Lreactbuild_common_actions_PleaseLoadLibrary$ = new $c_Lreactbuild_common_actions_PleaseLoadLibrary$()
  };
  return $n_Lreactbuild_common_actions_PleaseLoadLibrary$
}
/** @constructor */
function $c_Lreactbuild_common_actions_PleaseLogout$() {
  /*<skip>*/
}
$c_Lreactbuild_common_actions_PleaseLogout$.prototype = new $h_O();
$c_Lreactbuild_common_actions_PleaseLogout$.prototype.constructor = $c_Lreactbuild_common_actions_PleaseLogout$;
/** @constructor */
function $h_Lreactbuild_common_actions_PleaseLogout$() {
  /*<skip>*/
}
$h_Lreactbuild_common_actions_PleaseLogout$.prototype = $c_Lreactbuild_common_actions_PleaseLogout$.prototype;
$c_Lreactbuild_common_actions_PleaseLogout$.prototype.productPrefix__T = (function() {
  return "PleaseLogout"
});
$c_Lreactbuild_common_actions_PleaseLogout$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_actions_PleaseLogout$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_actions_PleaseLogout$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_actions_PleaseLogout$.prototype.hashCode__I = (function() {
  return (-673164748)
});
$c_Lreactbuild_common_actions_PleaseLogout$.prototype.toString__T = (function() {
  return "PleaseLogout"
});
var $d_Lreactbuild_common_actions_PleaseLogout$ = new $TypeData().initClass({
  Lreactbuild_common_actions_PleaseLogout$: 0
}, false, "reactbuild.common.actions.PleaseLogout$", {
  Lreactbuild_common_actions_PleaseLogout$: 1,
  O: 1,
  Ldiode_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_actions_PleaseLogout$.prototype.$classData = $d_Lreactbuild_common_actions_PleaseLogout$;
var $n_Lreactbuild_common_actions_PleaseLogout$;
function $m_Lreactbuild_common_actions_PleaseLogout$() {
  if ((!$n_Lreactbuild_common_actions_PleaseLogout$)) {
    $n_Lreactbuild_common_actions_PleaseLogout$ = new $c_Lreactbuild_common_actions_PleaseLogout$()
  };
  return $n_Lreactbuild_common_actions_PleaseLogout$
}
/** @constructor */
function $c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1(definition$1) {
  this.Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1__f_definition$1 = null;
  this.Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1__f_definition$1 = definition$1
}
$c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1.prototype.constructor = $c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1;
/** @constructor */
function $h_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1.prototype = $c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1.prototype;
$c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1.prototype.applyOrElse__Lreactbuild_common_model_AssetDefinition__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var name = $n(x1).Lreactbuild_common_model_AssetDefinition__f_name;
    var p4 = $n(x1).Lreactbuild_common_model_AssetDefinition__f_details;
    if ((p4 instanceof $c_Lreactbuild_common_model_ComponentDetails)) {
      var x5 = $as_Lreactbuild_common_model_ComponentDetails(p4);
      var p6 = $n(x5).Lreactbuild_common_model_ComponentDetails__f_files3d;
      if ((p6 instanceof $c_sci_$colon$colon)) {
        var x9 = $as_sci_$colon$colon(p6);
        var head = $as_Lreactbuild_common_model_RefTo($n(x9).sci_$colon$colon__f_head);
        if ((name === this.Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1__f_definition$1)) {
          return $ct_T2__O__O__(new $c_T2(), x1, head)
        }
      }
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1.prototype.isDefinedAt__Lreactbuild_common_model_AssetDefinition__Z = (function(x1) {
  if ((x1 !== null)) {
    var name = $n(x1).Lreactbuild_common_model_AssetDefinition__f_name;
    var p4 = $n(x1).Lreactbuild_common_model_AssetDefinition__f_details;
    if ((p4 instanceof $c_Lreactbuild_common_model_ComponentDetails)) {
      var x5 = $as_Lreactbuild_common_model_ComponentDetails(p4);
      var p6 = $n(x5).Lreactbuild_common_model_ComponentDetails__f_files3d;
      if (((p6 instanceof $c_sci_$colon$colon) && (name === this.Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1__f_definition$1))) {
        return true
      }
    }
  };
  return false
});
$c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_common_model_AssetDefinition__Z($as_Lreactbuild_common_model_AssetDefinition(x))
});
$c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_common_model_AssetDefinition__F1__O($as_Lreactbuild_common_model_AssetDefinition(x), default$1)
});
var $d_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1 = new $TypeData().initClass({
  Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1: 0
}, false, "reactbuild.common.components.ContextLoader$$anonfun$$nestedInanonfun$apply$1$1", {
  Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1.prototype.$classData = $d_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1;
/** @constructor */
function $c_Lreactbuild_common_components_Input$DoubleTap$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$DoubleTap$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$DoubleTap$.prototype.constructor = $c_Lreactbuild_common_components_Input$DoubleTap$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$DoubleTap$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$DoubleTap$.prototype = $c_Lreactbuild_common_components_Input$DoubleTap$.prototype;
$c_Lreactbuild_common_components_Input$DoubleTap$.prototype.productPrefix__T = (function() {
  return "DoubleTap"
});
$c_Lreactbuild_common_components_Input$DoubleTap$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$DoubleTap$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$DoubleTap$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$DoubleTap$.prototype.hashCode__I = (function() {
  return 1197805042
});
$c_Lreactbuild_common_components_Input$DoubleTap$.prototype.toString__T = (function() {
  return "DoubleTap"
});
var $d_Lreactbuild_common_components_Input$DoubleTap$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$DoubleTap$: 0
}, false, "reactbuild.common.components.Input$DoubleTap$", {
  Lreactbuild_common_components_Input$DoubleTap$: 1,
  O: 1,
  Lreactbuild_common_components_Input$MouseWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$DoubleTap$.prototype.$classData = $d_Lreactbuild_common_components_Input$DoubleTap$;
var $n_Lreactbuild_common_components_Input$DoubleTap$;
function $m_Lreactbuild_common_components_Input$DoubleTap$() {
  if ((!$n_Lreactbuild_common_components_Input$DoubleTap$)) {
    $n_Lreactbuild_common_components_Input$DoubleTap$ = new $c_Lreactbuild_common_components_Input$DoubleTap$()
  };
  return $n_Lreactbuild_common_components_Input$DoubleTap$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$ModifierKey$None$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype.constructor = $c_Lreactbuild_common_components_Input$ModifierKey$None$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$ModifierKey$None$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$ModifierKey$None$.prototype = $c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype;
$c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype.productPrefix__T = (function() {
  return "None"
});
$c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype.hashCode__I = (function() {
  return 2433880
});
$c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype.toString__T = (function() {
  return "None"
});
var $d_Lreactbuild_common_components_Input$ModifierKey$None$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$ModifierKey$None$: 0
}, false, "reactbuild.common.components.Input$ModifierKey$None$", {
  Lreactbuild_common_components_Input$ModifierKey$None$: 1,
  O: 1,
  Lreactbuild_common_components_Input$ModifierKey: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$ModifierKey$None$.prototype.$classData = $d_Lreactbuild_common_components_Input$ModifierKey$None$;
var $n_Lreactbuild_common_components_Input$ModifierKey$None$;
function $m_Lreactbuild_common_components_Input$ModifierKey$None$() {
  if ((!$n_Lreactbuild_common_components_Input$ModifierKey$None$)) {
    $n_Lreactbuild_common_components_Input$ModifierKey$None$ = new $c_Lreactbuild_common_components_Input$ModifierKey$None$()
  };
  return $n_Lreactbuild_common_components_Input$ModifierKey$None$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Mouse$() {
  this.Lreactbuild_common_components_Input$CursorType__f_precision = 0.0;
  $ct_Lreactbuild_common_components_Input$CursorType__D__(this, 12.0)
}
$c_Lreactbuild_common_components_Input$Mouse$.prototype = new $h_Lreactbuild_common_components_Input$CursorType();
$c_Lreactbuild_common_components_Input$Mouse$.prototype.constructor = $c_Lreactbuild_common_components_Input$Mouse$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Mouse$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Mouse$.prototype = $c_Lreactbuild_common_components_Input$Mouse$.prototype;
$c_Lreactbuild_common_components_Input$Mouse$.prototype.productPrefix__T = (function() {
  return "Mouse"
});
$c_Lreactbuild_common_components_Input$Mouse$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Mouse$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Mouse$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Mouse$.prototype.hashCode__I = (function() {
  return 74534021
});
$c_Lreactbuild_common_components_Input$Mouse$.prototype.toString__T = (function() {
  return "Mouse"
});
var $d_Lreactbuild_common_components_Input$Mouse$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Mouse$: 0
}, false, "reactbuild.common.components.Input$Mouse$", {
  Lreactbuild_common_components_Input$Mouse$: 1,
  Lreactbuild_common_components_Input$CursorType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Mouse$.prototype.$classData = $d_Lreactbuild_common_components_Input$Mouse$;
var $n_Lreactbuild_common_components_Input$Mouse$;
function $m_Lreactbuild_common_components_Input$Mouse$() {
  if ((!$n_Lreactbuild_common_components_Input$Mouse$)) {
    $n_Lreactbuild_common_components_Input$Mouse$ = new $c_Lreactbuild_common_components_Input$Mouse$()
  };
  return $n_Lreactbuild_common_components_Input$Mouse$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1(buttons$1) {
  this.Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1__f_buttons$1 = 0;
  this.Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1__f_buttons$1 = buttons$1
}
$c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1.prototype.constructor = $c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1;
/** @constructor */
function $h_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1.prototype = $c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1.prototype;
$c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var button = $as_s_Product($n(x1)._1__O());
    var v = $n(x1)._2$mcI$sp__I();
    if (((this.Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1__f_buttons$1 & v) === v)) {
      return button
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var v = $n(x1)._2$mcI$sp__I();
    if (((this.Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1__f_buttons$1 & v) === v)) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1 = new $TypeData().initClass({
  Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1: 0
}, false, "reactbuild.common.components.Input$MouseButton$$anonfun$fromMultiple$1", {
  Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1.prototype.$classData = $d_Lreactbuild_common_components_Input$MouseButton$$anonfun$fromMultiple$1;
/** @constructor */
function $c_Lreactbuild_common_components_Input$NoChange$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$NoChange$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$NoChange$.prototype.constructor = $c_Lreactbuild_common_components_Input$NoChange$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$NoChange$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$NoChange$.prototype = $c_Lreactbuild_common_components_Input$NoChange$.prototype;
$c_Lreactbuild_common_components_Input$NoChange$.prototype.productPrefix__T = (function() {
  return "NoChange"
});
$c_Lreactbuild_common_components_Input$NoChange$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$NoChange$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$NoChange$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$NoChange$.prototype.hashCode__I = (function() {
  return 246111473
});
$c_Lreactbuild_common_components_Input$NoChange$.prototype.toString__T = (function() {
  return "NoChange"
});
var $d_Lreactbuild_common_components_Input$NoChange$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$NoChange$: 0
}, false, "reactbuild.common.components.Input$NoChange$", {
  Lreactbuild_common_components_Input$NoChange$: 1,
  O: 1,
  Lreactbuild_common_components_Input$PointerButton: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$NoChange$.prototype.$classData = $d_Lreactbuild_common_components_Input$NoChange$;
var $n_Lreactbuild_common_components_Input$NoChange$;
function $m_Lreactbuild_common_components_Input$NoChange$() {
  if ((!$n_Lreactbuild_common_components_Input$NoChange$)) {
    $n_Lreactbuild_common_components_Input$NoChange$ = new $c_Lreactbuild_common_components_Input$NoChange$()
  };
  return $n_Lreactbuild_common_components_Input$NoChange$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Numpad$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Numpad$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Numpad$.prototype.constructor = $c_Lreactbuild_common_components_Input$Numpad$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Numpad$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Numpad$.prototype = $c_Lreactbuild_common_components_Input$Numpad$.prototype;
$c_Lreactbuild_common_components_Input$Numpad$.prototype.productPrefix__T = (function() {
  return "Numpad"
});
$c_Lreactbuild_common_components_Input$Numpad$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Numpad$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Numpad$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Numpad$.prototype.hashCode__I = (function() {
  return (-1950483603)
});
$c_Lreactbuild_common_components_Input$Numpad$.prototype.toString__T = (function() {
  return "Numpad"
});
var $d_Lreactbuild_common_components_Input$Numpad$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Numpad$: 0
}, false, "reactbuild.common.components.Input$Numpad$", {
  Lreactbuild_common_components_Input$Numpad$: 1,
  O: 1,
  Lreactbuild_common_components_Input$KeyboardLocation: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Numpad$.prototype.$classData = $d_Lreactbuild_common_components_Input$Numpad$;
var $n_Lreactbuild_common_components_Input$Numpad$;
function $m_Lreactbuild_common_components_Input$Numpad$() {
  if ((!$n_Lreactbuild_common_components_Input$Numpad$)) {
    $n_Lreactbuild_common_components_Input$Numpad$ = new $c_Lreactbuild_common_components_Input$Numpad$()
  };
  return $n_Lreactbuild_common_components_Input$Numpad$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Out$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Out$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Out$.prototype.constructor = $c_Lreactbuild_common_components_Input$Out$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Out$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Out$.prototype = $c_Lreactbuild_common_components_Input$Out$.prototype;
$c_Lreactbuild_common_components_Input$Out$.prototype.productPrefix__T = (function() {
  return "Out"
});
$c_Lreactbuild_common_components_Input$Out$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Out$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Out$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Out$.prototype.hashCode__I = (function() {
  return 79662
});
$c_Lreactbuild_common_components_Input$Out$.prototype.toString__T = (function() {
  return "Out"
});
var $d_Lreactbuild_common_components_Input$Out$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Out$: 0
}, false, "reactbuild.common.components.Input$Out$", {
  Lreactbuild_common_components_Input$Out$: 1,
  O: 1,
  Lreactbuild_common_components_Input$PointerWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Out$.prototype.$classData = $d_Lreactbuild_common_components_Input$Out$;
var $n_Lreactbuild_common_components_Input$Out$;
function $m_Lreactbuild_common_components_Input$Out$() {
  if ((!$n_Lreactbuild_common_components_Input$Out$)) {
    $n_Lreactbuild_common_components_Input$Out$ = new $c_Lreactbuild_common_components_Input$Out$()
  };
  return $n_Lreactbuild_common_components_Input$Out$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Over$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Over$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Over$.prototype.constructor = $c_Lreactbuild_common_components_Input$Over$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Over$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Over$.prototype = $c_Lreactbuild_common_components_Input$Over$.prototype;
$c_Lreactbuild_common_components_Input$Over$.prototype.productPrefix__T = (function() {
  return "Over"
});
$c_Lreactbuild_common_components_Input$Over$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Over$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Over$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Over$.prototype.hashCode__I = (function() {
  return 2470132
});
$c_Lreactbuild_common_components_Input$Over$.prototype.toString__T = (function() {
  return "Over"
});
var $d_Lreactbuild_common_components_Input$Over$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Over$: 0
}, false, "reactbuild.common.components.Input$Over$", {
  Lreactbuild_common_components_Input$Over$: 1,
  O: 1,
  Lreactbuild_common_components_Input$PointerWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Over$.prototype.$classData = $d_Lreactbuild_common_components_Input$Over$;
var $n_Lreactbuild_common_components_Input$Over$;
function $m_Lreactbuild_common_components_Input$Over$() {
  if ((!$n_Lreactbuild_common_components_Input$Over$)) {
    $n_Lreactbuild_common_components_Input$Over$ = new $c_Lreactbuild_common_components_Input$Over$()
  };
  return $n_Lreactbuild_common_components_Input$Over$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Pen$() {
  this.Lreactbuild_common_components_Input$CursorType__f_precision = 0.0;
  $ct_Lreactbuild_common_components_Input$CursorType__D__(this, 5.0)
}
$c_Lreactbuild_common_components_Input$Pen$.prototype = new $h_Lreactbuild_common_components_Input$CursorType();
$c_Lreactbuild_common_components_Input$Pen$.prototype.constructor = $c_Lreactbuild_common_components_Input$Pen$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Pen$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Pen$.prototype = $c_Lreactbuild_common_components_Input$Pen$.prototype;
$c_Lreactbuild_common_components_Input$Pen$.prototype.productPrefix__T = (function() {
  return "Pen"
});
$c_Lreactbuild_common_components_Input$Pen$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Pen$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Pen$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Pen$.prototype.hashCode__I = (function() {
  return 80121
});
$c_Lreactbuild_common_components_Input$Pen$.prototype.toString__T = (function() {
  return "Pen"
});
var $d_Lreactbuild_common_components_Input$Pen$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Pen$: 0
}, false, "reactbuild.common.components.Input$Pen$", {
  Lreactbuild_common_components_Input$Pen$: 1,
  Lreactbuild_common_components_Input$CursorType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Pen$.prototype.$classData = $d_Lreactbuild_common_components_Input$Pen$;
var $n_Lreactbuild_common_components_Input$Pen$;
function $m_Lreactbuild_common_components_Input$Pen$() {
  if ((!$n_Lreactbuild_common_components_Input$Pen$)) {
    $n_Lreactbuild_common_components_Input$Pen$ = new $c_Lreactbuild_common_components_Input$Pen$()
  };
  return $n_Lreactbuild_common_components_Input$Pen$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2(buttons$2) {
  this.Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2__f_buttons$2 = 0;
  this.Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2__f_buttons$2 = buttons$2
}
$c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2.prototype.constructor = $c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2;
/** @constructor */
function $h_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2.prototype = $c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2.prototype;
$c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var button = $as_s_Product($n(x1)._1__O());
    var v = $n(x1)._2$mcI$sp__I();
    if (((this.Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2__f_buttons$2 & v) === v)) {
      return button
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var v = $n(x1)._2$mcI$sp__I();
    if (((this.Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2__f_buttons$2 & v) === v)) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2 = new $TypeData().initClass({
  Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2: 0
}, false, "reactbuild.common.components.Input$PointerButton$$anonfun$fromMultiple$2", {
  Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2.prototype.$classData = $d_Lreactbuild_common_components_Input$PointerButton$$anonfun$fromMultiple$2;
/** @constructor */
function $c_Lreactbuild_common_components_Input$PointerTypeUnknown$() {
  this.Lreactbuild_common_components_Input$CursorType__f_precision = 0.0;
  $ct_Lreactbuild_common_components_Input$CursorType__D__(this, 50.0)
}
$c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype = new $h_Lreactbuild_common_components_Input$CursorType();
$c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype.constructor = $c_Lreactbuild_common_components_Input$PointerTypeUnknown$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$PointerTypeUnknown$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype = $c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype;
$c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype.productPrefix__T = (function() {
  return "PointerTypeUnknown"
});
$c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype.hashCode__I = (function() {
  return (-445854381)
});
$c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype.toString__T = (function() {
  return "PointerTypeUnknown"
});
var $d_Lreactbuild_common_components_Input$PointerTypeUnknown$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$PointerTypeUnknown$: 0
}, false, "reactbuild.common.components.Input$PointerTypeUnknown$", {
  Lreactbuild_common_components_Input$PointerTypeUnknown$: 1,
  Lreactbuild_common_components_Input$CursorType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$PointerTypeUnknown$.prototype.$classData = $d_Lreactbuild_common_components_Input$PointerTypeUnknown$;
var $n_Lreactbuild_common_components_Input$PointerTypeUnknown$;
function $m_Lreactbuild_common_components_Input$PointerTypeUnknown$() {
  if ((!$n_Lreactbuild_common_components_Input$PointerTypeUnknown$)) {
    $n_Lreactbuild_common_components_Input$PointerTypeUnknown$ = new $c_Lreactbuild_common_components_Input$PointerTypeUnknown$()
  };
  return $n_Lreactbuild_common_components_Input$PointerTypeUnknown$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Standard$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Standard$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Standard$.prototype.constructor = $c_Lreactbuild_common_components_Input$Standard$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Standard$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Standard$.prototype = $c_Lreactbuild_common_components_Input$Standard$.prototype;
$c_Lreactbuild_common_components_Input$Standard$.prototype.productPrefix__T = (function() {
  return "Standard"
});
$c_Lreactbuild_common_components_Input$Standard$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Standard$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Standard$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Standard$.prototype.hashCode__I = (function() {
  return 1377272541
});
$c_Lreactbuild_common_components_Input$Standard$.prototype.toString__T = (function() {
  return "Standard"
});
var $d_Lreactbuild_common_components_Input$Standard$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Standard$: 0
}, false, "reactbuild.common.components.Input$Standard$", {
  Lreactbuild_common_components_Input$Standard$: 1,
  O: 1,
  Lreactbuild_common_components_Input$KeyboardLocation: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Standard$.prototype.$classData = $d_Lreactbuild_common_components_Input$Standard$;
var $n_Lreactbuild_common_components_Input$Standard$;
function $m_Lreactbuild_common_components_Input$Standard$() {
  if ((!$n_Lreactbuild_common_components_Input$Standard$)) {
    $n_Lreactbuild_common_components_Input$Standard$ = new $c_Lreactbuild_common_components_Input$Standard$()
  };
  return $n_Lreactbuild_common_components_Input$Standard$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Touch$() {
  this.Lreactbuild_common_components_Input$CursorType__f_precision = 0.0;
  $ct_Lreactbuild_common_components_Input$CursorType__D__(this, 40.0)
}
$c_Lreactbuild_common_components_Input$Touch$.prototype = new $h_Lreactbuild_common_components_Input$CursorType();
$c_Lreactbuild_common_components_Input$Touch$.prototype.constructor = $c_Lreactbuild_common_components_Input$Touch$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Touch$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Touch$.prototype = $c_Lreactbuild_common_components_Input$Touch$.prototype;
$c_Lreactbuild_common_components_Input$Touch$.prototype.productPrefix__T = (function() {
  return "Touch"
});
$c_Lreactbuild_common_components_Input$Touch$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Touch$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Touch$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Touch$.prototype.hashCode__I = (function() {
  return 80998175
});
$c_Lreactbuild_common_components_Input$Touch$.prototype.toString__T = (function() {
  return "Touch"
});
var $d_Lreactbuild_common_components_Input$Touch$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Touch$: 0
}, false, "reactbuild.common.components.Input$Touch$", {
  Lreactbuild_common_components_Input$Touch$: 1,
  Lreactbuild_common_components_Input$CursorType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Touch$.prototype.$classData = $d_Lreactbuild_common_components_Input$Touch$;
var $n_Lreactbuild_common_components_Input$Touch$;
function $m_Lreactbuild_common_components_Input$Touch$() {
  if ((!$n_Lreactbuild_common_components_Input$Touch$)) {
    $n_Lreactbuild_common_components_Input$Touch$ = new $c_Lreactbuild_common_components_Input$Touch$()
  };
  return $n_Lreactbuild_common_components_Input$Touch$
}
/** @constructor */
function $c_Lreactbuild_common_components_LocalBuilder(outsideHeight, insideHeight, outsideWallMaterial, insideWallMaterial, floorMaterial, ceilMaterial, library, componentMaterial) {
  this.Lreactbuild_common_components_LocalBuilder__f_outsideHeight = 0.0;
  this.Lreactbuild_common_components_LocalBuilder__f_insideHeight = 0.0;
  this.Lreactbuild_common_components_LocalBuilder__f_outsideWallMaterial = null;
  this.Lreactbuild_common_components_LocalBuilder__f_insideWallMaterial = null;
  this.Lreactbuild_common_components_LocalBuilder__f_floorMaterial = null;
  this.Lreactbuild_common_components_LocalBuilder__f_ceilMaterial = null;
  this.Lreactbuild_common_components_LocalBuilder__f_library = null;
  this.Lreactbuild_common_components_LocalBuilder__f_componentMaterial = null;
  this.Lreactbuild_common_components_LocalBuilder__f_local = null;
  this.Lreactbuild_common_components_LocalBuilder__f_shape = null;
  this.Lreactbuild_common_components_LocalBuilder__f_shapeMtx = null;
  this.Lreactbuild_common_components_LocalBuilder__f_floor = null;
  this.Lreactbuild_common_components_LocalBuilder__f_ceil = null;
  this.Lreactbuild_common_components_LocalBuilder__f_first = false;
  this.Lreactbuild_common_components_LocalBuilder__f_spaces = null;
  this.Lreactbuild_common_components_LocalBuilder__f_walls = null;
  this.Lreactbuild_common_components_LocalBuilder__f_components = null;
  this.Lreactbuild_common_components_LocalBuilder__f_outsideHeight = outsideHeight;
  this.Lreactbuild_common_components_LocalBuilder__f_insideHeight = insideHeight;
  this.Lreactbuild_common_components_LocalBuilder__f_outsideWallMaterial = outsideWallMaterial;
  this.Lreactbuild_common_components_LocalBuilder__f_insideWallMaterial = insideWallMaterial;
  this.Lreactbuild_common_components_LocalBuilder__f_floorMaterial = floorMaterial;
  this.Lreactbuild_common_components_LocalBuilder__f_ceilMaterial = ceilMaterial;
  this.Lreactbuild_common_components_LocalBuilder__f_library = library;
  this.Lreactbuild_common_components_LocalBuilder__f_componentMaterial = componentMaterial;
  this.Lreactbuild_common_components_LocalBuilder__f_spaces = $m_s_package$().s_package$__f_Nil;
  this.Lreactbuild_common_components_LocalBuilder__f_walls = $m_s_package$().s_package$__f_Nil;
  this.Lreactbuild_common_components_LocalBuilder__f_components = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_common_components_LocalBuilder.prototype = new $h_O();
$c_Lreactbuild_common_components_LocalBuilder.prototype.constructor = $c_Lreactbuild_common_components_LocalBuilder;
/** @constructor */
function $h_Lreactbuild_common_components_LocalBuilder() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_LocalBuilder.prototype = $c_Lreactbuild_common_components_LocalBuilder.prototype;
$c_Lreactbuild_common_components_LocalBuilder.prototype.setPathAsRect__Lorg_denigma_threejs_Path__D__D__D__D__V = (function(path, x0, x1, y0, y1) {
  path.moveTo(x0, y0);
  path.lineTo(x0, y1);
  path.lineTo(x1, y1);
  path.lineTo(x1, y0);
  path.lineTo(x0, y0)
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.makeHole__D__D__D__D__Lorg_denigma_threejs_Path = (function(x0, x1, y0, y1) {
  var path = new $i_three.Path();
  this.setPathAsRect__Lorg_denigma_threejs_Path__D__D__D__D__V(path, x0, x1, y0, y1);
  return path
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.endWall__V = (function() {
  if ((this.Lreactbuild_common_components_LocalBuilder__f_shape !== null)) {
    var this$1 = $n(this.Lreactbuild_common_components_LocalBuilder__f_walls);
    var elem = new $c_Lreactbuild_common_components_WallBuilder(this.Lreactbuild_common_components_LocalBuilder__f_shape, this.Lreactbuild_common_components_LocalBuilder__f_local, this.Lreactbuild_common_components_LocalBuilder__f_shapeMtx, this.Lreactbuild_common_components_LocalBuilder__f_components);
    this.Lreactbuild_common_components_LocalBuilder__f_walls = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$1, elem));
    this.Lreactbuild_common_components_LocalBuilder__f_components = $m_s_package$().s_package$__f_Nil;
    this.Lreactbuild_common_components_LocalBuilder__f_shape = null
  }
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.endSpace__V = (function() {
  var this$1 = $n(this.Lreactbuild_common_components_LocalBuilder__f_spaces);
  var elem = new $c_Lreactbuild_common_components_SpaceBuilder(this.Lreactbuild_common_components_LocalBuilder__f_local, this.Lreactbuild_common_components_LocalBuilder__f_walls, ($n(this.Lreactbuild_common_components_LocalBuilder__f_spaces).isEmpty__Z() ? this.Lreactbuild_common_components_LocalBuilder__f_outsideWallMaterial : this.Lreactbuild_common_components_LocalBuilder__f_insideWallMaterial));
  this.Lreactbuild_common_components_LocalBuilder__f_spaces = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$1, elem));
  this.Lreactbuild_common_components_LocalBuilder__f_walls = $m_s_package$().s_package$__f_Nil
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.finalBuild__V = (function() {
  var this$1 = $n(this.Lreactbuild_common_components_LocalBuilder__f_spaces);
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var space = $as_Lreactbuild_common_components_SpaceBuilder(arg1);
    var roomWalls = [];
    var this$2 = $n($n(space).Lreactbuild_common_components_SpaceBuilder__f_walls);
    var these$1 = this$2;
    while ((!$n(these$1).isEmpty__Z())) {
      var arg1$1 = $n(these$1).head__O();
      var wall = $as_Lreactbuild_common_components_WallBuilder(arg1$1);
      var geometry = new $i_three.ShapeGeometry($n(wall).Lreactbuild_common_components_WallBuilder__f_shape);
      geometry.applyMatrix($n(wall).Lreactbuild_common_components_WallBuilder__f_matrix);
      $uI(roomWalls.push(geometry));
      these$1 = $as_sci_List($n(these$1).tail__O())
    };
    var bufferedGeometry = $i_three$002fexamples$002fjsm$002futils$002fBufferGeometryUtils.mergeBufferGeometries(Array.from(roomWalls));
    var mesh = new $i_three.Mesh(bufferedGeometry, $n(space).Lreactbuild_common_components_SpaceBuilder__f_wallMaterial);
    mesh.castShadow = true;
    mesh.receiveShadow = true;
    $n(space).Lreactbuild_common_components_SpaceBuilder__f_group.add(mesh);
    these = $as_sci_List($n(these).tail__O())
  }
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.result__Lorg_denigma_threejs_Group = (function() {
  this.endWall__V();
  var this$1 = $n(this.Lreactbuild_common_components_LocalBuilder__f_spaces);
  if ((!this$1.isEmpty__Z())) {
    var mat = this.Lreactbuild_common_components_LocalBuilder__f_floorMaterial;
    var bufferedFloor = new $i_three.ShapeBufferGeometry(this.Lreactbuild_common_components_LocalBuilder__f_floor);
    bufferedFloor.rotateX((-1.5707963267948966));
    var floorMesh = new $i_three.Mesh(bufferedFloor, mat);
    floorMesh.castShadow = true;
    floorMesh.receiveShadow = true;
    this.Lreactbuild_common_components_LocalBuilder__f_local.add(floorMesh);
    var mat$2 = this.Lreactbuild_common_components_LocalBuilder__f_ceilMaterial;
    var bufferedFloor$2 = new $i_three.ShapeBufferGeometry(this.Lreactbuild_common_components_LocalBuilder__f_ceil);
    bufferedFloor$2.rotateX((-1.5707963267948966));
    bufferedFloor$2.translate(0.0, ($n(this.Lreactbuild_common_components_LocalBuilder__f_spaces).isEmpty__Z() ? this.Lreactbuild_common_components_LocalBuilder__f_outsideHeight : this.Lreactbuild_common_components_LocalBuilder__f_insideHeight), 0.0);
    var floorMesh$2 = new $i_three.Mesh(bufferedFloor$2, mat$2);
    floorMesh$2.castShadow = true;
    floorMesh$2.receiveShadow = true;
    this.Lreactbuild_common_components_LocalBuilder__f_local.add(floorMesh$2)
  };
  this.endSpace__V();
  return this.Lreactbuild_common_components_LocalBuilder__f_local
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.emitEdge__Lreactbuild_geom_Vector2__Lreactbuild_geom_Vector2__V = (function(start, end) {
  this.endWall__V();
  this.Lreactbuild_common_components_LocalBuilder__f_shape = new $i_three.Shape();
  var this$1 = $n(end);
  var vec = new $c_Lreactbuild_geom_Vector2((this$1.Lreactbuild_geom_Vector2__f_x - $n(start).Lreactbuild_geom_Vector2__f_x), (this$1.Lreactbuild_geom_Vector2__f_y - $n(start).Lreactbuild_geom_Vector2__f_y));
  if ((vec.Lreactbuild_geom_Vector2__f_x === 0.0)) {
    $m_Lreactbuild_math_package$SquareRoot$();
    var x = vec.Lreactbuild_geom_Vector2__f_y;
    var length = $uD(Math.abs(x));
    var sq = (length * length);
    var sqrt = $uD(Math.abs(length));
    var $$x1 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt)
  } else if ((vec.Lreactbuild_geom_Vector2__f_y === 0.0)) {
    $m_Lreactbuild_math_package$SquareRoot$();
    var x$1 = vec.Lreactbuild_geom_Vector2__f_x;
    var length$1 = $uD(Math.abs(x$1));
    var sq$1 = (length$1 * length$1);
    var sqrt$1 = $uD(Math.abs(length$1));
    var $$x1 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$1, sqrt$1)
  } else {
    $m_Lreactbuild_math_package$SquareRoot$();
    var v = vec.Lreactbuild_geom_Vector2__f_x;
    var v$1 = vec.Lreactbuild_geom_Vector2__f_y;
    var value = ((v * v) + (v$1 * v$1));
    var $$x1 = new $c_Lreactbuild_math_package$LazySquareRoot(value)
  };
  var this$27 = $n($$x1);
  var len = (this$27.sqrt__D() / 1000.0);
  this.setPathAsRect__Lorg_denigma_threejs_Path__D__D__D__D__V(this.Lreactbuild_common_components_LocalBuilder__f_shape, 0.0, len, 0.0, ($n(this.Lreactbuild_common_components_LocalBuilder__f_spaces).isEmpty__Z() ? this.Lreactbuild_common_components_LocalBuilder__f_outsideHeight : this.Lreactbuild_common_components_LocalBuilder__f_insideHeight));
  this.Lreactbuild_common_components_LocalBuilder__f_shapeMtx = new $i_three.Matrix4().makeScale(1.0, 1.0, (-1.0));
  var $$x4 = this.Lreactbuild_common_components_LocalBuilder__f_shapeMtx;
  var $$x3 = new $i_three.Matrix4();
  var y = vec.Lreactbuild_geom_Vector2__f_y;
  var x$2 = vec.Lreactbuild_geom_Vector2__f_x;
  var $$x2 = $$x3.makeRotationY($uD(Math.atan2(y, x$2)));
  $$x4.premultiply($$x2);
  this.Lreactbuild_common_components_LocalBuilder__f_shapeMtx.premultiply(new $i_three.Matrix4().makeTranslation(($n(start).Lreactbuild_geom_Vector2__f_x / 1000.0), 0.0, ((-$n(start).Lreactbuild_geom_Vector2__f_y) / 1000.0)));
  if (this.Lreactbuild_common_components_LocalBuilder__f_first) {
    this.Lreactbuild_common_components_LocalBuilder__f_first = false;
    this.Lreactbuild_common_components_LocalBuilder__f_floor.moveTo(($n(start).Lreactbuild_geom_Vector2__f_x / 1000.0), ($n(start).Lreactbuild_geom_Vector2__f_y / 1000.0));
    this.Lreactbuild_common_components_LocalBuilder__f_ceil.moveTo(($n(start).Lreactbuild_geom_Vector2__f_x / 1000.0), ($n(start).Lreactbuild_geom_Vector2__f_y / 1000.0))
  };
  this.Lreactbuild_common_components_LocalBuilder__f_floor.lineTo(($n(end).Lreactbuild_geom_Vector2__f_x / 1000.0), ($n(end).Lreactbuild_geom_Vector2__f_y / 1000.0));
  this.Lreactbuild_common_components_LocalBuilder__f_ceil.lineTo(($n(end).Lreactbuild_geom_Vector2__f_x / 1000.0), ($n(end).Lreactbuild_geom_Vector2__f_y / 1000.0))
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.emitComponent__Lreactbuild_geom_Vector2__Lreactbuild_geom_Vector2__Lreactbuild_format_iz2use_package$ExpandedComponent__V = (function(wallStart, wallVector, component) {
  if ((component === null)) {
    throw new $c_s_MatchError(component)
  };
  var wallOffsetStart = $n(component).Lreactbuild_format_iz2use_package$ExpandedComponent__f_wallOffsetStart;
  var offset0 = $n(component).Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset0;
  var offset1 = $n(component).Lreactbuild_format_iz2use_package$ExpandedComponent__f_offset1;
  var distance = $n(component).Lreactbuild_format_iz2use_package$ExpandedComponent__f_distance;
  var z = $n(component).Lreactbuild_format_iz2use_package$ExpandedComponent__f_z;
  var invertY = $n(component).Lreactbuild_format_iz2use_package$ExpandedComponent__f_invertY;
  var definition = $n(component).Lreactbuild_format_iz2use_package$ExpandedComponent__f_definition;
  var this$1 = $m_Lreactbuild_common_components_ContextLoader$();
  var library = this.Lreactbuild_common_components_LocalBuilder__f_library;
  var componentMaterial = this.Lreactbuild_common_components_LocalBuilder__f_componentMaterial;
  var this$10 = $n(this$1.Lreactbuild_common_components_ContextLoader$__f_loaders);
  var default$1 = new $c_sjsr_AnonFunction1(((definition$2$2) => {
    var definition$2 = $as_T(definition$2$2);
    var this$2 = $n($n(library).collectFirst__s_PartialFunction__s_Option(new $c_Lreactbuild_common_components_ContextLoader$$anonfun$$nestedInanonfun$apply$1$1(definition$2)));
    var p = new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
      var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
      return (check$ifrefutable$1 !== null)
    }));
    var this$3 = new $c_s_Option$WithFilter(this$2, p);
    var this$4 = $n(this$3.s_Option$WithFilter__f_$outer);
    var p$1 = this$3.s_Option$WithFilter__f_p;
    var this$5 = $n(((this$4.isEmpty__Z() || $uZ($n(p$1).apply__O__O(this$4.get__O()))) ? this$4 : $m_s_None$()));
    if (this$5.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$5.get__O();
      var x$1 = $as_T2(arg1);
      if ((x$1 !== null)) {
        var cd = $as_Lreactbuild_common_model_AssetDefinition($n(x$1)._1__O());
        var head = $as_Lreactbuild_common_model_RefTo($n(x$1)._2__O());
        var p$2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
        var x$1$2 = ("/api/file/" + $n(head).Lreactbuild_common_model_RefTo__f_id);
        var x$2 = ((arg1$2) => {
          $m_Lreactbuild_common_components_ContextLoader$();
          $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p$2, arg1$2)
        });
        var x$3 = ((arg1$2$1) => {
          $m_Lreactbuild_common_components_ContextLoader$().reactbuild$common$components$ContextLoader$$$anonfun$apply$5__sjs_js_Any__s_concurrent_Promise__T__V(arg1$2$1, p$2, definition$2)
        });
        $m_Lreactbuild_common_components_ContextLoader$().Lreactbuild_common_components_ContextLoader$__f_objLoader.load(x$1$2, x$2, (void 0), x$3);
        var y = p$2.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((obj$2) => {
          obj$2.traverse(((arg1$2$2) => $m_Lreactbuild_common_components_ContextLoader$().reactbuild$common$components$ContextLoader$$$anonfun$apply$7__Lorg_denigma_threejs_Object3D__Lorg_denigma_threejs_Material__O(arg1$2$2, componentMaterial)));
          return obj$2
        })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
        var $$x1 = $ct_T2__O__O__(new $c_T2(), cd, y)
      } else {
        var $$x1;
        throw new $c_s_MatchError(x$1)
      };
      return new $c_s_Some($$x1)
    }
  }));
  var loader = $as_s_Option($f_sc_MapOps__applyOrElse__O__F1__O(this$10, definition, default$1));
  var this$11 = $n(loader);
  if (this$11.isEmpty__Z()) {
    var next = $m_s_None$()
  } else {
    var arg1$1 = this$11.get__O();
    var v = $as_T2(arg1$1);
    var arg1$3 = $n(v)._1__O();
    var cd$1 = $as_Lreactbuild_common_model_AssetDefinition(arg1$3);
    matchEnd4: {
      var width;
      if ((definition !== null)) {
        var o7 = $n($m_Lreactbuild_format_iz2use_package$().Lreactbuild_format_iz2use_package$__f_componentLengthPattern).unapplySeq__jl_CharSequence__s_Option(definition);
        if (((!$n(o7).isEmpty__Z()) && (($n(o7).get__O() !== null) && ($n($as_sci_List($n(o7).get__O())).lengthCompare__I__I(1) === 0)))) {
          var w = $as_T($n($as_sc_LinearSeqOps($n(o7).get__O())).apply__I__O(0));
          var this$14 = $n(wallVector);
          var magnitude = (10.0 * ($m_sc_StringOps$(), $m_jl_Double$().parseDouble__T__D(w)));
          if ((magnitude === 0.0)) {
            var width = $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero;
            break matchEnd4
          } else {
            var x$2$1 = $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero;
            if (this$14.equals__O__Z(x$2$1)) {
              var width = $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero;
              break matchEnd4
            } else if ((this$14.Lreactbuild_geom_Vector2__f_x === 0.0)) {
              var x$1$1 = ((this$14.Lreactbuild_geom_Vector2__f_y < 0.0) ? (-magnitude) : magnitude);
              var x$2$2 = this$14.Lreactbuild_geom_Vector2__f_x;
              var width = new $c_Lreactbuild_geom_Vector2(x$2$2, x$1$1);
              break matchEnd4
            } else if ((this$14.Lreactbuild_geom_Vector2__f_y === 0.0)) {
              var x = ((this$14.Lreactbuild_geom_Vector2__f_x < 0.0) ? (-magnitude) : magnitude);
              var y$1 = this$14.Lreactbuild_geom_Vector2__f_y;
              var width = new $c_Lreactbuild_geom_Vector2(x, y$1);
              break matchEnd4
            } else {
              var this$41 = $n(((magnitude === 1.0) ? this$14 : new $c_Lreactbuild_geom_Vector2((this$14.Lreactbuild_geom_Vector2__f_x * magnitude), (this$14.Lreactbuild_geom_Vector2__f_y * magnitude))));
              $m_Lreactbuild_math_package$SquareRoot$();
              if ((this$14.Lreactbuild_geom_Vector2__f_x === 0.0)) {
                $m_Lreactbuild_math_package$SquareRoot$();
                var x$4 = this$14.Lreactbuild_geom_Vector2__f_y;
                var length = $uD(Math.abs(x$4));
                var sq = (length * length);
                var sqrt = $uD(Math.abs(length));
                var sqrt$2 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt)
              } else if ((this$14.Lreactbuild_geom_Vector2__f_y === 0.0)) {
                $m_Lreactbuild_math_package$SquareRoot$();
                var x$5 = this$14.Lreactbuild_geom_Vector2__f_x;
                var length$1 = $uD(Math.abs(x$5));
                var sq$1 = (length$1 * length$1);
                var sqrt$1 = $uD(Math.abs(length$1));
                var sqrt$2 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$1, sqrt$1)
              } else {
                $m_Lreactbuild_math_package$SquareRoot$();
                var v$1 = this$14.Lreactbuild_geom_Vector2__f_x;
                var v$2 = this$14.Lreactbuild_geom_Vector2__f_y;
                var value = ((v$1 * v$1) + (v$2 * v$2));
                var sqrt$2 = new $c_Lreactbuild_math_package$LazySquareRoot(value)
              };
              var scalar = $n(sqrt$2).sqrt__D();
              var width = new $c_Lreactbuild_geom_Vector2((this$41.Lreactbuild_geom_Vector2__f_x / scalar), (this$41.Lreactbuild_geom_Vector2__f_y / scalar));
              break matchEnd4
            }
          }
        }
      };
      var width = $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero
    };
    var this$42 = $n(wallVector);
    if ((offset0 === 0.0)) {
      var vecOffset = $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero
    } else {
      var x$2$3 = $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero;
      if (this$42.equals__O__Z(x$2$3)) {
        var vecOffset = $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_zero
      } else if ((this$42.Lreactbuild_geom_Vector2__f_x === 0.0)) {
        var x$1$3 = ((this$42.Lreactbuild_geom_Vector2__f_y < 0.0) ? (-offset0) : offset0);
        var x$2$2$1 = this$42.Lreactbuild_geom_Vector2__f_x;
        var vecOffset = new $c_Lreactbuild_geom_Vector2(x$2$2$1, x$1$3)
      } else if ((this$42.Lreactbuild_geom_Vector2__f_y === 0.0)) {
        var x$6 = ((this$42.Lreactbuild_geom_Vector2__f_x < 0.0) ? (-offset0) : offset0);
        var y$2 = this$42.Lreactbuild_geom_Vector2__f_y;
        var vecOffset = new $c_Lreactbuild_geom_Vector2(x$6, y$2)
      } else {
        var this$69 = $n(((offset0 === 1.0) ? this$42 : new $c_Lreactbuild_geom_Vector2((this$42.Lreactbuild_geom_Vector2__f_x * offset0), (this$42.Lreactbuild_geom_Vector2__f_y * offset0))));
        $m_Lreactbuild_math_package$SquareRoot$();
        if ((this$42.Lreactbuild_geom_Vector2__f_x === 0.0)) {
          $m_Lreactbuild_math_package$SquareRoot$();
          var x$7 = this$42.Lreactbuild_geom_Vector2__f_y;
          var length$2 = $uD(Math.abs(x$7));
          var sq$2 = (length$2 * length$2);
          var sqrt$3 = $uD(Math.abs(length$2));
          var sqrt$5 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$2, sqrt$3)
        } else if ((this$42.Lreactbuild_geom_Vector2__f_y === 0.0)) {
          $m_Lreactbuild_math_package$SquareRoot$();
          var x$8 = this$42.Lreactbuild_geom_Vector2__f_x;
          var length$3 = $uD(Math.abs(x$8));
          var sq$3 = (length$3 * length$3);
          var sqrt$4 = $uD(Math.abs(length$3));
          var sqrt$5 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$3, sqrt$4)
        } else {
          $m_Lreactbuild_math_package$SquareRoot$();
          var v$3 = this$42.Lreactbuild_geom_Vector2__f_x;
          var v$4 = this$42.Lreactbuild_geom_Vector2__f_y;
          var value$1 = ((v$3 * v$3) + (v$4 * v$4));
          var sqrt$5 = new $c_Lreactbuild_math_package$LazySquareRoot(value$1)
        };
        var scalar$1 = $n(sqrt$5).sqrt__D();
        var vecOffset = new $c_Lreactbuild_geom_Vector2((this$69.Lreactbuild_geom_Vector2__f_x / scalar$1), (this$69.Lreactbuild_geom_Vector2__f_y / scalar$1))
      }
    };
    if ((wallOffsetStart === 1.0)) {
      var this$70 = $n(wallVector);
      var this$71 = new $c_Lreactbuild_geom_Vector2((this$70.Lreactbuild_geom_Vector2__f_x - $n(vecOffset).Lreactbuild_geom_Vector2__f_x), (this$70.Lreactbuild_geom_Vector2__f_y - $n(vecOffset).Lreactbuild_geom_Vector2__f_y));
      var x0 = new $c_Lreactbuild_geom_Vector2((this$71.Lreactbuild_geom_Vector2__f_x - $n(width).Lreactbuild_geom_Vector2__f_x), (this$71.Lreactbuild_geom_Vector2__f_y - $n(width).Lreactbuild_geom_Vector2__f_y))
    } else {
      var x0 = vecOffset
    };
    var this$72 = $n(x0);
    var x1$2 = new $c_Lreactbuild_geom_Vector2((this$72.Lreactbuild_geom_Vector2__f_x + $n(width).Lreactbuild_geom_Vector2__f_x), (this$72.Lreactbuild_geom_Vector2__f_y + $n(width).Lreactbuild_geom_Vector2__f_y));
    var mtx = new $i_three.Matrix4();
    var Y_AXIS = new $i_three.Vector3(0.0, 1.0, 0.0);
    var direction = new $i_three.Vector3($n(wallVector).Lreactbuild_geom_Vector2__f_x, 0.0, (-$n(wallVector).Lreactbuild_geom_Vector2__f_y)).normalize();
    var this$73 = $n($n(cd$1).Lreactbuild_common_model_AssetDefinition__f_category);
    if (($uI(this$73.indexOf("joinery")) !== (-1))) {
      var this$74 = $n(x0);
      if ((this$74.Lreactbuild_geom_Vector2__f_x === 0.0)) {
        $m_Lreactbuild_math_package$SquareRoot$();
        var x$9 = this$74.Lreactbuild_geom_Vector2__f_y;
        var length$4 = $uD(Math.abs(x$9));
        var sq$4 = (length$4 * length$4);
        var sqrt$6 = $uD(Math.abs(length$4));
        var $$x3 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$4, sqrt$6)
      } else if ((this$74.Lreactbuild_geom_Vector2__f_y === 0.0)) {
        $m_Lreactbuild_math_package$SquareRoot$();
        var x$10 = this$74.Lreactbuild_geom_Vector2__f_x;
        var length$5 = $uD(Math.abs(x$10));
        var sq$5 = (length$5 * length$5);
        var sqrt$7 = $uD(Math.abs(length$5));
        var $$x3 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$5, sqrt$7)
      } else {
        $m_Lreactbuild_math_package$SquareRoot$();
        var v$5 = this$74.Lreactbuild_geom_Vector2__f_x;
        var v$6 = this$74.Lreactbuild_geom_Vector2__f_y;
        var value$2 = ((v$5 * v$5) + (v$6 * v$6));
        var $$x3 = new $c_Lreactbuild_math_package$LazySquareRoot(value$2)
      };
      var this$100 = $n($$x3);
      var $$x4 = this$100.sqrt__D();
      if ((x1$2.Lreactbuild_geom_Vector2__f_x === 0.0)) {
        $m_Lreactbuild_math_package$SquareRoot$();
        var x$11 = x1$2.Lreactbuild_geom_Vector2__f_y;
        var length$6 = $uD(Math.abs(x$11));
        var sq$6 = (length$6 * length$6);
        var sqrt$8 = $uD(Math.abs(length$6));
        var $$x2 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$6, sqrt$8)
      } else if ((x1$2.Lreactbuild_geom_Vector2__f_y === 0.0)) {
        $m_Lreactbuild_math_package$SquareRoot$();
        var x$12 = x1$2.Lreactbuild_geom_Vector2__f_x;
        var length$7 = $uD(Math.abs(x$12));
        var sq$7 = (length$7 * length$7);
        var sqrt$9 = $uD(Math.abs(length$7));
        var $$x2 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$7, sqrt$9)
      } else {
        $m_Lreactbuild_math_package$SquareRoot$();
        var v$7 = x1$2.Lreactbuild_geom_Vector2__f_x;
        var v$8 = x1$2.Lreactbuild_geom_Vector2__f_y;
        var value$3 = ((v$7 * v$7) + (v$8 * v$8));
        var $$x2 = new $c_Lreactbuild_math_package$LazySquareRoot(value$3)
      };
      var this$126 = $n($$x2);
      var path = this.makeHole__D__D__D__D__Lorg_denigma_threejs_Path(($$x4 / 1000.0), (this$126.sqrt__D() / 1000.0), ((z / 1000.0) + 0.001), 2.15);
      this.Lreactbuild_common_components_LocalBuilder__f_shape.holes.push(path);
      console.log(("" + cd$1), path, this.Lreactbuild_common_components_LocalBuilder__f_shape)
    };
    mtx.premultiply(new $i_three.Matrix4().makeScale(1.0, 1.0, (-1.0)));
    if (invertY) {
      mtx.premultiply(new $i_three.Matrix4().makeScale((-1.0), 1.0, 1.0))
    };
    mtx.premultiply(new $i_three.Matrix4().makeBasis(direction, Y_AXIS, Y_AXIS.clone().cross(direction)));
    var margin = direction.clone().cross(Y_AXIS);
    margin.setLength((distance / 1000.0));
    var this$127 = $n(wallStart);
    var other = ((!invertY) ? x0 : x1$2);
    var start = new $c_Lreactbuild_geom_Vector2((this$127.Lreactbuild_geom_Vector2__f_x + $n(other).Lreactbuild_geom_Vector2__f_x), (this$127.Lreactbuild_geom_Vector2__f_y + $n(other).Lreactbuild_geom_Vector2__f_y));
    mtx.premultiply(new $i_three.Matrix4().makeTranslation((start.Lreactbuild_geom_Vector2__f_x / 1000.0), (z / 1000.0), ((-start.Lreactbuild_geom_Vector2__f_y) / 1000.0)));
    mtx.premultiply(new $i_three.Matrix4().makeTranslation($uD(margin.x), $uD(margin.y), $uD(margin.z)));
    var localParent = this.Lreactbuild_common_components_LocalBuilder__f_local;
    var appHandler = new $c_sjsr_AnonFunction1(((obj$2$1) => {
      var instance = obj$2$1.clone();
      var $$x15 = $ct_T2__O__O__(new $c_T2(), "wallOffsetStart", wallOffsetStart);
      var $$x14 = $ct_T2__O__O__(new $c_T2(), "offset0", offset0);
      var s = $n(offset1).toString__T();
      var $$x13 = $ct_T2__O__O__(new $c_T2(), "offset1", s);
      var $$x12 = $ct_T2__O__O__(new $c_T2(), "distance", distance);
      var $$x11 = $ct_T2__O__O__(new $c_T2(), "invertY", invertY);
      var $$x10 = $ct_T2__O__O__(new $c_T2(), "definition", definition);
      var s$1 = $n(width).toString__T();
      var $$x9 = $ct_T2__O__O__(new $c_T2(), "width", s$1);
      var s$2 = $n(x0).toString__T();
      var $$x8 = $ct_T2__O__O__(new $c_T2(), "x0", s$2);
      var s$3 = x1$2.toString__T();
      var $$x7 = $ct_T2__O__O__(new $c_T2(), "x1", s$3);
      var s$4 = $n(wallStart).toString__T();
      var $$x6 = $ct_T2__O__O__(new $c_T2(), "wallStart", s$4);
      var s$5 = $n(wallVector).toString__T();
      var $$x5 = $ct_T2__O__O__(new $c_T2(), "wallVector", s$5);
      var s$6 = start.toString__T();
      var array = [$$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $ct_T2__O__O__(new $c_T2(), "start", s$6), $ct_T2__O__O__(new $c_T2(), "margin", margin)];
      var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      instance.userData = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
      instance.applyMatrix(mtx);
      localParent.add(instance)
    }));
    var self = $n(v)._1__O();
    var y$3 = $n($as_s_concurrent_Future($n(v)._2__O())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((obj$2$2) => {
      appHandler.apply__O__O(obj$2$2);
      return obj$2$2
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var next = new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, y$3))
  };
  this$1.Lreactbuild_common_components_ContextLoader$__f_loaders = $as_sci_Map($n(this$1.Lreactbuild_common_components_ContextLoader$__f_loaders).$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), definition, next)))
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.clear__V = (function() {
  this.Lreactbuild_common_components_LocalBuilder__f_local = new $i_three.Group();
  this.Lreactbuild_common_components_LocalBuilder__f_floor = new $i_three.Shape();
  this.Lreactbuild_common_components_LocalBuilder__f_ceil = new $i_three.Shape();
  this.Lreactbuild_common_components_LocalBuilder__f_first = true
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.productPrefix__T = (function() {
  return "LocalBuilder"
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_LocalBuilder__f_outsideHeight;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_LocalBuilder__f_insideHeight;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_LocalBuilder__f_outsideWallMaterial;
      break
    }
    case 3: {
      return this.Lreactbuild_common_components_LocalBuilder__f_insideWallMaterial;
      break
    }
    case 4: {
      return this.Lreactbuild_common_components_LocalBuilder__f_floorMaterial;
      break
    }
    case 5: {
      return this.Lreactbuild_common_components_LocalBuilder__f_ceilMaterial;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LocalBuilder");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_common_components_LocalBuilder__f_outsideHeight;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_common_components_LocalBuilder__f_insideHeight;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x = this.Lreactbuild_common_components_LocalBuilder__f_outsideWallMaterial;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$1 = this.Lreactbuild_common_components_LocalBuilder__f_insideWallMaterial;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$2 = this.Lreactbuild_common_components_LocalBuilder__f_floorMaterial;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$3 = this.Lreactbuild_common_components_LocalBuilder__f_ceilMaterial;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_LocalBuilder)) {
    var LocalBuilder$1 = $as_Lreactbuild_common_components_LocalBuilder(x$1);
    if ((this.Lreactbuild_common_components_LocalBuilder__f_outsideHeight === $n(LocalBuilder$1).Lreactbuild_common_components_LocalBuilder__f_outsideHeight)) {
      if ((this.Lreactbuild_common_components_LocalBuilder__f_insideHeight === $n(LocalBuilder$1).Lreactbuild_common_components_LocalBuilder__f_insideHeight)) {
        var x = this.Lreactbuild_common_components_LocalBuilder__f_outsideWallMaterial;
        var y = $n(LocalBuilder$1).Lreactbuild_common_components_LocalBuilder__f_outsideWallMaterial;
        var $$x1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$2 = this.Lreactbuild_common_components_LocalBuilder__f_insideWallMaterial;
      var y$1 = $n(LocalBuilder$1).Lreactbuild_common_components_LocalBuilder__f_insideWallMaterial;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)) {
        var x$3 = this.Lreactbuild_common_components_LocalBuilder__f_floorMaterial;
        var y$2 = $n(LocalBuilder$1).Lreactbuild_common_components_LocalBuilder__f_floorMaterial;
        var $$x2 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y$2)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$4 = this.Lreactbuild_common_components_LocalBuilder__f_ceilMaterial;
        var y$3 = $n(LocalBuilder$1).Lreactbuild_common_components_LocalBuilder__f_ceilMaterial;
        if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$4, y$3)) {
          $n(LocalBuilder$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_LocalBuilder(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_LocalBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.LocalBuilder"))
}
function $isArrayOf_Lreactbuild_common_components_LocalBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_LocalBuilder)))
}
function $asArrayOf_Lreactbuild_common_components_LocalBuilder(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_LocalBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.LocalBuilder;", depth))
}
var $d_Lreactbuild_common_components_LocalBuilder = new $TypeData().initClass({
  Lreactbuild_common_components_LocalBuilder: 0
}, false, "reactbuild.common.components.LocalBuilder", {
  Lreactbuild_common_components_LocalBuilder: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$EdgeAndComponentBuilder: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_LocalBuilder.prototype.$classData = $d_Lreactbuild_common_components_LocalBuilder;
/** @constructor */
function $c_Lreactbuild_common_components_Skip$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Skip$.prototype = new $h_O();
$c_Lreactbuild_common_components_Skip$.prototype.constructor = $c_Lreactbuild_common_components_Skip$;
/** @constructor */
function $h_Lreactbuild_common_components_Skip$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Skip$.prototype = $c_Lreactbuild_common_components_Skip$.prototype;
$c_Lreactbuild_common_components_Skip$.prototype.transformValueToCB__F0__F1__Lreactbuild_common_components_InteractionResult = (function(newState, f) {
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_common_components_Skip$.prototype.productPrefix__T = (function() {
  return "Skip"
});
$c_Lreactbuild_common_components_Skip$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Skip$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Skip$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Skip$.prototype.hashCode__I = (function() {
  return 2578847
});
$c_Lreactbuild_common_components_Skip$.prototype.toString__T = (function() {
  return "Skip"
});
var $d_Lreactbuild_common_components_Skip$ = new $TypeData().initClass({
  Lreactbuild_common_components_Skip$: 0
}, false, "reactbuild.common.components.Skip$", {
  Lreactbuild_common_components_Skip$: 1,
  O: 1,
  Lreactbuild_common_components_InteractionResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Skip$.prototype.$classData = $d_Lreactbuild_common_components_Skip$;
var $n_Lreactbuild_common_components_Skip$;
function $m_Lreactbuild_common_components_Skip$() {
  if ((!$n_Lreactbuild_common_components_Skip$)) {
    $n_Lreactbuild_common_components_Skip$ = new $c_Lreactbuild_common_components_Skip$()
  };
  return $n_Lreactbuild_common_components_Skip$
}
/** @constructor */
function $c_Lreactbuild_common_components_TrackedPointers$$anonfun$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_common_components_TrackedPointers$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_common_components_TrackedPointers$$anonfun$1.prototype.constructor = $c_Lreactbuild_common_components_TrackedPointers$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_common_components_TrackedPointers$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_TrackedPointers$$anonfun$1.prototype = $c_Lreactbuild_common_components_TrackedPointers$$anonfun$1.prototype;
$c_Lreactbuild_common_components_TrackedPointers$$anonfun$1.prototype.applyOrElse__sci_List__F1__O = (function(x1, default$1) {
  var x = $n($n($as_Lreactbuild_common_components_Input$PointerEvent($n(x1).head__O())).Lreactbuild_common_components_Input$PointerEvent__f_coords).Lreactbuild_common_components_Input$Coords__f_cursor;
  var x$2 = $m_Lreactbuild_common_components_Input$Touch$();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $$x1 = (this$1 === x$2)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $n($as_Lreactbuild_common_components_Input$PointerEvent($n(x1).head__O())).Lreactbuild_common_components_Input$PointerEvent__f_coords
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_common_components_TrackedPointers$$anonfun$1.prototype.isDefinedAt__sci_List__Z = (function(x1) {
  var x = $n($n($as_Lreactbuild_common_components_Input$PointerEvent($n(x1).head__O())).Lreactbuild_common_components_Input$PointerEvent__f_coords).Lreactbuild_common_components_Input$Coords__f_cursor;
  var x$2 = $m_Lreactbuild_common_components_Input$Touch$();
  if ((x !== null)) {
    var this$1 = $n(x);
    return (this$1 === x$2)
  } else {
    return false
  }
});
$c_Lreactbuild_common_components_TrackedPointers$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__sci_List__Z($as_sci_List(x))
});
$c_Lreactbuild_common_components_TrackedPointers$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__sci_List__F1__O($as_sci_List(x), default$1)
});
var $d_Lreactbuild_common_components_TrackedPointers$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_common_components_TrackedPointers$$anonfun$1: 0
}, false, "reactbuild.common.components.TrackedPointers$$anonfun$1", {
  Lreactbuild_common_components_TrackedPointers$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_TrackedPointers$$anonfun$1.prototype.$classData = $d_Lreactbuild_common_components_TrackedPointers$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1(outer) {
  this.Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1__f_$outer = outer
  }
}
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1.prototype.constructor = $c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1;
/** @constructor */
function $h_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1.prototype = $c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1.prototype;
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1.prototype.applyOrElse__O__F1__O = (function(x1, default$1) {
  var x = $m_Lreactbuild_common_actions_PleaseLoadLibrary$();
  if ((x === x1)) {
    var $$x2 = $n(this.Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1__f_$outer);
    var this$1 = $n(this.Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1__f_$outer);
    var qual$1 = $as_Ldiode_data_Pot($n(this$1.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$1.Ldiode_ActionHandler__f_currentModel));
    var t = $n(qual$1).pending$default$1__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var $$x1 = $n(qual$1).pending__J__Ldiode_data_Pot(new $c_RTLong(lo, hi));
    var f = new $c_sjsr_AnonFunction0((() => $n($n($as_s_concurrent_Future($n($n(this.Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1__f_$outer).Lreactbuild_common_handlers_LibraryHandler__f_reactbuild$common$handlers$LibraryHandler$$ajaxClient).apply__O())).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_sci_List(x$1$2);
      return new $c_Lreactbuild_common_actions_LoadLibrary(x$1)
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1(this), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())));
    var ec = $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$();
    return $n($$x2).updated__O__Ldiode_Effect__Ldiode_ActionResult($$x1, new $c_Ldiode_EffectSingle(f, ec))
  } else if ((x1 instanceof $c_Lreactbuild_common_actions_LoadLibrary)) {
    var x3 = $as_Lreactbuild_common_actions_LoadLibrary(x1);
    var lib = $n(x3).Lreactbuild_common_actions_LoadLibrary__f_definitions;
    var $$x3 = $n(this.Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1__f_$outer);
    var this$7 = $n(this.Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1__f_$outer);
    $n($as_Ldiode_data_Pot($n(this$7.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$7.Ldiode_ActionHandler__f_currentModel)));
    return $n($$x3).updated__O__Ldiode_ActionResult(new $c_Ldiode_data_Ready(lib))
  } else if ((x1 instanceof $c_Lreactbuild_common_actions_LoadLibraryFailed)) {
    var x4 = $as_Lreactbuild_common_actions_LoadLibraryFailed(x1);
    var e = $n(x4).Lreactbuild_common_actions_LoadLibraryFailed__f_error;
    var $$x4 = $n(this.Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1__f_$outer);
    var this$9 = $n(this.Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1__f_$outer);
    return $n($$x4).updated__O__Ldiode_ActionResult($n($as_Ldiode_data_Pot($n(this$9.Ldiode_ActionHandler__f_modelRW).eval__O__O(this$9.Ldiode_ActionHandler__f_currentModel))).fail__jl_Throwable__Ldiode_data_Pot(e))
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1.prototype.isDefinedAt__O__Z = (function(x1) {
  var x = $m_Lreactbuild_common_actions_PleaseLoadLibrary$();
  if ((x === x1)) {
    return true
  } else {
    return ((x1 instanceof $c_Lreactbuild_common_actions_LoadLibrary) || (x1 instanceof $c_Lreactbuild_common_actions_LoadLibraryFailed))
  }
});
var $d_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1 = new $TypeData().initClass({
  Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1: 0
}, false, "reactbuild.common.handlers.LibraryHandler$$anonfun$handle$1", {
  Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1.prototype.$classData = $d_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1;
/** @constructor */
function $c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1.prototype.constructor = $c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1;
/** @constructor */
function $h_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1.prototype = $c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1.prototype;
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  return new $c_Lreactbuild_common_actions_LoadLibraryFailed(x1)
});
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return true
});
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1 = new $TypeData().initClass({
  Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1: 0
}, false, "reactbuild.common.handlers.LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1", {
  Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1.prototype.$classData = $d_Lreactbuild_common_handlers_LibraryHandler$$anonfun$handle$1$$anonfun$$nestedInanonfun$applyOrElse$1$1;
/** @constructor */
function $c_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1(outer) {
  this.Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1__f_$outer = outer
  }
}
$c_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1.prototype.constructor = $c_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1;
/** @constructor */
function $h_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1.prototype = $c_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1.prototype;
$c_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1.prototype.applyOrElse__O__F1__O = (function(x1, default$1) {
  var x = $m_Lreactbuild_common_actions_AskConnectionState$();
  if ((x === x1)) {
    $n(this.Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1__f_$outer);
    var f = new $c_sjsr_AnonFunction0((() => {
      var $$x1 = $m_sjs_js_Thenable$ThenableOps$();
      var p = fetch("/api/user", (() => {
        var outer = null;
        outer = this;
        var this$5 = {};
        var a = $m_Lorg_scalajs_dom_RequestCache$().Lorg_scalajs_dom_RequestCache$__f_no$minusstore;
        this$5.cache = a;
        var a$1 = $m_Lorg_scalajs_dom_RequestCredentials$().Lorg_scalajs_dom_RequestCredentials$__f_include;
        this$5.credentials = a$1;
        return this$5
      })());
      var this$14 = $n($n($$x1).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p));
      var p$1 = new $c_sjsr_AnonFunction1(((response$2) => ($uI(response$2.status) === 200)));
      var executor = $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$();
      return $n(this$14.filter__F1__s_concurrent_ExecutionContext__s_concurrent_Future(p$1, executor)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((response$3$2) => {
        var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
        var p$2 = response$3$2.text();
        return $n($n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$2)).flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((response$2$2) => {
          var response$2$1 = $as_T(response$2$2);
          var x1$1 = $m_Lio_circe_parser_package$().parse__T__s_util_Either(response$2$1);
          if ((x1$1 instanceof $c_s_util_Left)) {
            var x2 = $as_s_util_Left(x1$1);
            var err = $as_Lio_circe_ParsingFailure($n(x2).s_util_Left__f_value);
            var $$x3 = $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_RuntimeException__jl_Throwable__(new $c_jl_RuntimeException(), err))
          } else {
            if ((!(x1$1 instanceof $c_s_util_Right))) {
              throw new $c_s_MatchError(x1$1)
            };
            var x3 = $as_s_util_Right(x1$1);
            var parsed = $as_Lio_circe_Json($n(x3).s_util_Right__f_value);
            var this$16 = $n(parsed);
            var d = $m_Lreactbuild_common_model_LoggedUserWithOrganizations$().Lreactbuild_common_model_LoggedUserWithOrganizations$__f_codecForLoggedUserWithOrganizations;
            var x1$2 = $n(d).apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(this$16, null, null));
            if ((x1$2 instanceof $c_s_util_Left)) {
              var x2$2 = $as_s_util_Left(x1$2);
              var err$2 = $as_Lio_circe_DecodingFailure($n(x2$2).s_util_Left__f_value);
              var $$x3 = $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_RuntimeException__jl_Throwable__(new $c_jl_RuntimeException(), err$2))
            } else {
              if ((!(x1$2 instanceof $c_s_util_Right))) {
                throw new $c_s_MatchError(x1$2)
              };
              var x3$2 = $as_s_util_Right(x1$2);
              var logged = $as_Lreactbuild_common_model_LoggedUserWithOrganizations($n(x3$2).s_util_Right__f_value);
              var $$x3 = $m_s_concurrent_Future$().successful__O__s_concurrent_Future(new $c_Lreactbuild_common_actions_Logged(logged))
            }
          };
          return $n($$x3).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((result$2) => {
            var result = $as_Lreactbuild_common_actions_Logged(result$2);
            return result
          })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
        })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
      })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
    }));
    var ec = $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$();
    var effect = new $c_Ldiode_EffectSingle(f, ec);
    return new $c_Ldiode_ActionResult$EffectOnly(effect)
  } else if ((x1 instanceof $c_Lreactbuild_common_actions_Logged)) {
    var x3$1 = $as_Lreactbuild_common_actions_Logged(x1);
    var user = $n(x3$1).Lreactbuild_common_actions_Logged__f_user;
    return $n(this.Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1__f_$outer).updated__O__Ldiode_ActionResult(new $c_s_Some(user))
  } else {
    var x$3 = $m_Lreactbuild_common_actions_PleaseLogout$();
    if ((x$3 === x1)) {
      $n(this.Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1__f_$outer);
      var f$1 = new $c_sjsr_AnonFunction0((() => {
        var $$x4 = $m_sjs_js_Thenable$ThenableOps$();
        var p$3 = fetch("/api/logoff", (() => {
          var outer$1 = null;
          outer$1 = this;
          var this$27 = {};
          var a$2 = $m_Lorg_scalajs_dom_HttpMethod$().Lorg_scalajs_dom_HttpMethod$__f_POST;
          this$27.method = a$2;
          var a$3 = $m_Lorg_scalajs_dom_RequestCache$().Lorg_scalajs_dom_RequestCache$__f_no$minusstore;
          this$27.cache = a$3;
          var a$4 = $m_Lorg_scalajs_dom_RequestCredentials$().Lorg_scalajs_dom_RequestCredentials$__f_include;
          this$27.credentials = a$4;
          return this$27
        })());
        return $n($n($$x4).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$3)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((response$2$3) => (($uI(response$2$3.status) === 200) ? $m_Lreactbuild_common_actions_Logout$() : $m_Ldiode_NoAction$()))), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
      }));
      var ec$1 = $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$();
      var effect$1 = new $c_Ldiode_EffectSingle(f$1, ec$1);
      return new $c_Ldiode_ActionResult$EffectOnly(effect$1)
    } else {
      var x$5 = $m_Lreactbuild_common_actions_Logout$();
      if ((x$5 === x1)) {
        return $n(this.Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1__f_$outer).updated__O__Ldiode_ActionResult($m_s_None$())
      } else {
        return $n(default$1).apply__O__O(x1)
      }
    }
  }
});
$c_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1.prototype.isDefinedAt__O__Z = (function(x1) {
  var x = $m_Lreactbuild_common_actions_AskConnectionState$();
  if ((x === x1)) {
    return true
  } else if ((x1 instanceof $c_Lreactbuild_common_actions_Logged)) {
    return true
  } else {
    var x$3 = $m_Lreactbuild_common_actions_PleaseLogout$();
    if ((x$3 === x1)) {
      return true
    } else {
      var x$5 = $m_Lreactbuild_common_actions_Logout$();
      return (x$5 === x1)
    }
  }
});
var $d_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1 = new $TypeData().initClass({
  Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1: 0
}, false, "reactbuild.common.handlers.UserHandler$$anonfun$handle$1", {
  Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1.prototype.$classData = $d_Lreactbuild_common_handlers_UserHandler$$anonfun$handle$1;
/** @constructor */
function $c_Lreactbuild_common_model_ComponentDetails(files3d, files2d, loader) {
  this.Lreactbuild_common_model_ComponentDetails__f_files3d = null;
  this.Lreactbuild_common_model_ComponentDetails__f_files2d = null;
  this.Lreactbuild_common_model_ComponentDetails__f_loader = null;
  this.Lreactbuild_common_model_ComponentDetails__f_files3d = files3d;
  this.Lreactbuild_common_model_ComponentDetails__f_files2d = files2d;
  this.Lreactbuild_common_model_ComponentDetails__f_loader = loader
}
$c_Lreactbuild_common_model_ComponentDetails.prototype = new $h_O();
$c_Lreactbuild_common_model_ComponentDetails.prototype.constructor = $c_Lreactbuild_common_model_ComponentDetails;
/** @constructor */
function $h_Lreactbuild_common_model_ComponentDetails() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ComponentDetails.prototype = $c_Lreactbuild_common_model_ComponentDetails.prototype;
$c_Lreactbuild_common_model_ComponentDetails.prototype.productPrefix__T = (function() {
  return "ComponentDetails"
});
$c_Lreactbuild_common_model_ComponentDetails.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_common_model_ComponentDetails.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_ComponentDetails__f_files3d;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_ComponentDetails__f_files2d;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_ComponentDetails__f_loader;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_ComponentDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_ComponentDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_ComponentDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_ComponentDetails.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_ComponentDetails)) {
    var ComponentDetails$1 = $as_Lreactbuild_common_model_ComponentDetails(x$1);
    var x = this.Lreactbuild_common_model_ComponentDetails__f_files3d;
    var x$2 = $n(ComponentDetails$1).Lreactbuild_common_model_ComponentDetails__f_files3d;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_common_model_ComponentDetails__f_files2d;
      var x$4 = $n(ComponentDetails$1).Lreactbuild_common_model_ComponentDetails__f_files2d;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        return (this.Lreactbuild_common_model_ComponentDetails__f_loader === $n(ComponentDetails$1).Lreactbuild_common_model_ComponentDetails__f_loader)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_ComponentDetails(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_ComponentDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.ComponentDetails"))
}
function $isArrayOf_Lreactbuild_common_model_ComponentDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_ComponentDetails)))
}
function $asArrayOf_Lreactbuild_common_model_ComponentDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_ComponentDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.ComponentDetails;", depth))
}
var $d_Lreactbuild_common_model_ComponentDetails = new $TypeData().initClass({
  Lreactbuild_common_model_ComponentDetails: 0
}, false, "reactbuild.common.model.ComponentDetails", {
  Lreactbuild_common_model_ComponentDetails: 1,
  O: 1,
  Lreactbuild_common_model_AssetDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ComponentDetails.prototype.$classData = $d_Lreactbuild_common_model_ComponentDetails;
/** @constructor */
function $c_Lreactbuild_common_model_Country$France$() {
  this.Lreactbuild_common_model_Country__f_code = null;
  $ct_Lreactbuild_common_model_Country__T__T__(this, "FR", "France")
}
$c_Lreactbuild_common_model_Country$France$.prototype = new $h_Lreactbuild_common_model_Country();
$c_Lreactbuild_common_model_Country$France$.prototype.constructor = $c_Lreactbuild_common_model_Country$France$;
/** @constructor */
function $h_Lreactbuild_common_model_Country$France$() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Country$France$.prototype = $c_Lreactbuild_common_model_Country$France$.prototype;
$c_Lreactbuild_common_model_Country$France$.prototype.productPrefix__T = (function() {
  return "France"
});
$c_Lreactbuild_common_model_Country$France$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_model_Country$France$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_model_Country$France$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_Country$France$.prototype.hashCode__I = (function() {
  return 2112320571
});
$c_Lreactbuild_common_model_Country$France$.prototype.toString__T = (function() {
  return "France"
});
function $as_Lreactbuild_common_model_Country$France$(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Country$France$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Country$France$"))
}
function $isArrayOf_Lreactbuild_common_model_Country$France$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Country$France$)))
}
function $asArrayOf_Lreactbuild_common_model_Country$France$(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Country$France$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Country$France$;", depth))
}
var $d_Lreactbuild_common_model_Country$France$ = new $TypeData().initClass({
  Lreactbuild_common_model_Country$France$: 0
}, false, "reactbuild.common.model.Country$France$", {
  Lreactbuild_common_model_Country$France$: 1,
  Lreactbuild_common_model_Country: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Country$France$.prototype.$classData = $d_Lreactbuild_common_model_Country$France$;
var $n_Lreactbuild_common_model_Country$France$;
function $m_Lreactbuild_common_model_Country$France$() {
  if ((!$n_Lreactbuild_common_model_Country$France$)) {
    $n_Lreactbuild_common_model_Country$France$ = new $c_Lreactbuild_common_model_Country$France$()
  };
  return $n_Lreactbuild_common_model_Country$France$
}
/** @constructor */
function $c_Lreactbuild_common_model_ImageCoordinates(x, y) {
  this.Lreactbuild_common_model_ImageCoordinates__f_x = 0.0;
  this.Lreactbuild_common_model_ImageCoordinates__f_y = 0.0;
  this.Lreactbuild_common_model_ImageCoordinates__f_x = x;
  this.Lreactbuild_common_model_ImageCoordinates__f_y = y
}
$c_Lreactbuild_common_model_ImageCoordinates.prototype = new $h_O();
$c_Lreactbuild_common_model_ImageCoordinates.prototype.constructor = $c_Lreactbuild_common_model_ImageCoordinates;
/** @constructor */
function $h_Lreactbuild_common_model_ImageCoordinates() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ImageCoordinates.prototype = $c_Lreactbuild_common_model_ImageCoordinates.prototype;
$c_Lreactbuild_common_model_ImageCoordinates.prototype.productPrefix__T = (function() {
  return "ImageCoordinates"
});
$c_Lreactbuild_common_model_ImageCoordinates.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_model_ImageCoordinates.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_ImageCoordinates__f_x;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_ImageCoordinates__f_y;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_ImageCoordinates.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_ImageCoordinates.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ImageCoordinates");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_common_model_ImageCoordinates__f_x;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_common_model_ImageCoordinates__f_y;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_common_model_ImageCoordinates.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_ImageCoordinates.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_ImageCoordinates)) {
    var ImageCoordinates$1 = $as_Lreactbuild_common_model_ImageCoordinates(x$1);
    return ((this.Lreactbuild_common_model_ImageCoordinates__f_x === $n(ImageCoordinates$1).Lreactbuild_common_model_ImageCoordinates__f_x) && (this.Lreactbuild_common_model_ImageCoordinates__f_y === $n(ImageCoordinates$1).Lreactbuild_common_model_ImageCoordinates__f_y))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_ImageCoordinates(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_ImageCoordinates) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.ImageCoordinates"))
}
function $isArrayOf_Lreactbuild_common_model_ImageCoordinates(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_ImageCoordinates)))
}
function $asArrayOf_Lreactbuild_common_model_ImageCoordinates(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_ImageCoordinates(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.ImageCoordinates;", depth))
}
var $d_Lreactbuild_common_model_ImageCoordinates = new $TypeData().initClass({
  Lreactbuild_common_model_ImageCoordinates: 0
}, false, "reactbuild.common.model.ImageCoordinates", {
  Lreactbuild_common_model_ImageCoordinates: 1,
  O: 1,
  Lreactbuild_common_model_AbstractCoordinates: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ImageCoordinates.prototype.$classData = $d_Lreactbuild_common_model_ImageCoordinates;
/** @constructor */
function $c_Lreactbuild_common_model_Marker(label, x, y) {
  this.Lreactbuild_common_model_Marker__f_label = null;
  this.Lreactbuild_common_model_Marker__f_x = 0.0;
  this.Lreactbuild_common_model_Marker__f_y = 0.0;
  this.Lreactbuild_common_model_Marker__f_label = label;
  this.Lreactbuild_common_model_Marker__f_x = x;
  this.Lreactbuild_common_model_Marker__f_y = y
}
$c_Lreactbuild_common_model_Marker.prototype = new $h_O();
$c_Lreactbuild_common_model_Marker.prototype.constructor = $c_Lreactbuild_common_model_Marker;
/** @constructor */
function $h_Lreactbuild_common_model_Marker() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Marker.prototype = $c_Lreactbuild_common_model_Marker.prototype;
$c_Lreactbuild_common_model_Marker.prototype.productPrefix__T = (function() {
  return "Marker"
});
$c_Lreactbuild_common_model_Marker.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_common_model_Marker.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_model_Marker__f_label;
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_Marker__f_x;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_Marker__f_y;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_Marker.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_Marker.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Marker");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_common_model_Marker__f_label;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_common_model_Marker__f_x;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$1 = this.Lreactbuild_common_model_Marker__f_y;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_common_model_Marker.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_Marker.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_Marker)) {
    var Marker$1 = $as_Lreactbuild_common_model_Marker(x$1);
    return ((this.Lreactbuild_common_model_Marker__f_x === $n(Marker$1).Lreactbuild_common_model_Marker__f_x) && ((this.Lreactbuild_common_model_Marker__f_y === $n(Marker$1).Lreactbuild_common_model_Marker__f_y) && (this.Lreactbuild_common_model_Marker__f_label === $n(Marker$1).Lreactbuild_common_model_Marker__f_label)))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_Marker(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_Marker) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.Marker"))
}
function $isArrayOf_Lreactbuild_common_model_Marker(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_Marker)))
}
function $asArrayOf_Lreactbuild_common_model_Marker(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_Marker(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.Marker;", depth))
}
var $d_Lreactbuild_common_model_Marker = new $TypeData().initClass({
  Lreactbuild_common_model_Marker: 0
}, false, "reactbuild.common.model.Marker", {
  Lreactbuild_common_model_Marker: 1,
  O: 1,
  Lreactbuild_common_model_AbstractCoordinates: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Marker.prototype.$classData = $d_Lreactbuild_common_model_Marker;
/** @constructor */
function $c_Lreactbuild_common_model_MaterialDetails(baseColor, roughness, bumpMap, bumpScale, map) {
  this.Lreactbuild_common_model_MaterialDetails__f_baseColor = 0.0;
  this.Lreactbuild_common_model_MaterialDetails__f_roughness = 0.0;
  this.Lreactbuild_common_model_MaterialDetails__f_bumpMap = null;
  this.Lreactbuild_common_model_MaterialDetails__f_bumpScale = 0.0;
  this.Lreactbuild_common_model_MaterialDetails__f_map = null;
  this.Lreactbuild_common_model_MaterialDetails__f_baseColor = baseColor;
  this.Lreactbuild_common_model_MaterialDetails__f_roughness = roughness;
  this.Lreactbuild_common_model_MaterialDetails__f_bumpMap = bumpMap;
  this.Lreactbuild_common_model_MaterialDetails__f_bumpScale = bumpScale;
  this.Lreactbuild_common_model_MaterialDetails__f_map = map
}
$c_Lreactbuild_common_model_MaterialDetails.prototype = new $h_O();
$c_Lreactbuild_common_model_MaterialDetails.prototype.constructor = $c_Lreactbuild_common_model_MaterialDetails;
/** @constructor */
function $h_Lreactbuild_common_model_MaterialDetails() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_MaterialDetails.prototype = $c_Lreactbuild_common_model_MaterialDetails.prototype;
$c_Lreactbuild_common_model_MaterialDetails.prototype.productPrefix__T = (function() {
  return "MaterialDetails"
});
$c_Lreactbuild_common_model_MaterialDetails.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_common_model_MaterialDetails.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return new $c_Lreactbuild_common_model_Color(this.Lreactbuild_common_model_MaterialDetails__f_baseColor);
      break
    }
    case 1: {
      return this.Lreactbuild_common_model_MaterialDetails__f_roughness;
      break
    }
    case 2: {
      return this.Lreactbuild_common_model_MaterialDetails__f_bumpMap;
      break
    }
    case 3: {
      return this.Lreactbuild_common_model_MaterialDetails__f_bumpScale;
      break
    }
    case 4: {
      return this.Lreactbuild_common_model_MaterialDetails__f_map;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_model_MaterialDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_MaterialDetails.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("MaterialDetails");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = new $c_Lreactbuild_common_model_Color(this.Lreactbuild_common_model_MaterialDetails__f_baseColor);
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_common_model_MaterialDetails__f_roughness;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_common_model_MaterialDetails__f_bumpMap;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$1 = this.Lreactbuild_common_model_MaterialDetails__f_bumpScale;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$2 = this.Lreactbuild_common_model_MaterialDetails__f_map;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_common_model_MaterialDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_MaterialDetails.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_MaterialDetails)) {
    var MaterialDetails$1 = $as_Lreactbuild_common_model_MaterialDetails(x$1);
    if (((this.Lreactbuild_common_model_MaterialDetails__f_roughness === $n(MaterialDetails$1).Lreactbuild_common_model_MaterialDetails__f_roughness) && (this.Lreactbuild_common_model_MaterialDetails__f_bumpScale === $n(MaterialDetails$1).Lreactbuild_common_model_MaterialDetails__f_bumpScale))) {
      if ((this.Lreactbuild_common_model_MaterialDetails__f_baseColor === $n(MaterialDetails$1).Lreactbuild_common_model_MaterialDetails__f_baseColor)) {
        var x = this.Lreactbuild_common_model_MaterialDetails__f_bumpMap;
        var x$2 = $n(MaterialDetails$1).Lreactbuild_common_model_MaterialDetails__f_bumpMap;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          var x$3 = this.Lreactbuild_common_model_MaterialDetails__f_map;
          var x$4 = $n(MaterialDetails$1).Lreactbuild_common_model_MaterialDetails__f_map;
          return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_MaterialDetails(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_MaterialDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.MaterialDetails"))
}
function $isArrayOf_Lreactbuild_common_model_MaterialDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_MaterialDetails)))
}
function $asArrayOf_Lreactbuild_common_model_MaterialDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_MaterialDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.MaterialDetails;", depth))
}
var $d_Lreactbuild_common_model_MaterialDetails = new $TypeData().initClass({
  Lreactbuild_common_model_MaterialDetails: 0
}, false, "reactbuild.common.model.MaterialDetails", {
  Lreactbuild_common_model_MaterialDetails: 1,
  O: 1,
  Lreactbuild_common_model_AssetDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_MaterialDetails.prototype.$classData = $d_Lreactbuild_common_model_MaterialDetails;
/** @constructor */
function $c_Lreactbuild_common_model_TextureDetails(file) {
  this.Lreactbuild_common_model_TextureDetails__f_file = null;
  this.Lreactbuild_common_model_TextureDetails__f_file = file
}
$c_Lreactbuild_common_model_TextureDetails.prototype = new $h_O();
$c_Lreactbuild_common_model_TextureDetails.prototype.constructor = $c_Lreactbuild_common_model_TextureDetails;
/** @constructor */
function $h_Lreactbuild_common_model_TextureDetails() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_TextureDetails.prototype = $c_Lreactbuild_common_model_TextureDetails.prototype;
$c_Lreactbuild_common_model_TextureDetails.prototype.productPrefix__T = (function() {
  return "TextureDetails"
});
$c_Lreactbuild_common_model_TextureDetails.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_common_model_TextureDetails.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_common_model_TextureDetails__f_file : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_common_model_TextureDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_model_TextureDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_model_TextureDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_model_TextureDetails.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_model_TextureDetails)) {
    var TextureDetails$1 = $as_Lreactbuild_common_model_TextureDetails(x$1);
    var x = this.Lreactbuild_common_model_TextureDetails__f_file;
    var x$2 = $n(TextureDetails$1).Lreactbuild_common_model_TextureDetails__f_file;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_common_model_TextureDetails(obj) {
  return (((obj instanceof $c_Lreactbuild_common_model_TextureDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.model.TextureDetails"))
}
function $isArrayOf_Lreactbuild_common_model_TextureDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_model_TextureDetails)))
}
function $asArrayOf_Lreactbuild_common_model_TextureDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_model_TextureDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.model.TextureDetails;", depth))
}
var $d_Lreactbuild_common_model_TextureDetails = new $TypeData().initClass({
  Lreactbuild_common_model_TextureDetails: 0
}, false, "reactbuild.common.model.TextureDetails", {
  Lreactbuild_common_model_TextureDetails: 1,
  O: 1,
  Lreactbuild_common_model_AssetDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_TextureDetails.prototype.$classData = $d_Lreactbuild_common_model_TextureDetails;
/** @constructor */
function $c_Lreactbuild_common_services_AjaxClient$$anonfun$1(outer, x1$1) {
  this.Lreactbuild_common_services_AjaxClient$$anonfun$1__f_x1$1 = null;
  this.Lreactbuild_common_services_AjaxClient$$anonfun$1__f_x1$1 = x1$1
}
$c_Lreactbuild_common_services_AjaxClient$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_common_services_AjaxClient$$anonfun$1.prototype.constructor = $c_Lreactbuild_common_services_AjaxClient$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_common_services_AjaxClient$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_services_AjaxClient$$anonfun$1.prototype = $c_Lreactbuild_common_services_AjaxClient$$anonfun$1.prototype;
$c_Lreactbuild_common_services_AjaxClient$$anonfun$1.prototype.applyOrElse__sci_Seq__F1__O = (function(x1, default$1) {
  return ($n(this.Lreactbuild_common_services_AjaxClient$$anonfun$1__f_x1$1).startsWith__sc_IterableOnce__I__Z(x1, $n(this.Lreactbuild_common_services_AjaxClient$$anonfun$1__f_x1$1).startsWith$default$2__I()) ? x1 : $n(default$1).apply__O__O(x1))
});
$c_Lreactbuild_common_services_AjaxClient$$anonfun$1.prototype.isDefinedAt__sci_Seq__Z = (function(x1) {
  return $n(this.Lreactbuild_common_services_AjaxClient$$anonfun$1__f_x1$1).startsWith__sc_IterableOnce__I__Z(x1, $n(this.Lreactbuild_common_services_AjaxClient$$anonfun$1__f_x1$1).startsWith$default$2__I())
});
$c_Lreactbuild_common_services_AjaxClient$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__sci_Seq__Z($as_sci_Seq(x))
});
$c_Lreactbuild_common_services_AjaxClient$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__sci_Seq__F1__O($as_sci_Seq(x), default$1)
});
var $d_Lreactbuild_common_services_AjaxClient$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_common_services_AjaxClient$$anonfun$1: 0
}, false, "reactbuild.common.services.AjaxClient$$anonfun$1", {
  Lreactbuild_common_services_AjaxClient$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_services_AjaxClient$$anonfun$1.prototype.$classData = $d_Lreactbuild_common_services_AjaxClient$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_components_Form$Done$() {
  /*<skip>*/
}
$c_Lreactbuild_components_Form$Done$.prototype = new $h_O();
$c_Lreactbuild_components_Form$Done$.prototype.constructor = $c_Lreactbuild_components_Form$Done$;
/** @constructor */
function $h_Lreactbuild_components_Form$Done$() {
  /*<skip>*/
}
$h_Lreactbuild_components_Form$Done$.prototype = $c_Lreactbuild_components_Form$Done$.prototype;
$c_Lreactbuild_components_Form$Done$.prototype.productPrefix__T = (function() {
  return "Done"
});
$c_Lreactbuild_components_Form$Done$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_components_Form$Done$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_components_Form$Done$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_components_Form$Done$.prototype.hashCode__I = (function() {
  return 2135970
});
$c_Lreactbuild_components_Form$Done$.prototype.toString__T = (function() {
  return "Done"
});
var $d_Lreactbuild_components_Form$Done$ = new $TypeData().initClass({
  Lreactbuild_components_Form$Done$: 0
}, false, "reactbuild.components.Form$Done$", {
  Lreactbuild_components_Form$Done$: 1,
  O: 1,
  Lreactbuild_components_Form$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_components_Form$Done$.prototype.$classData = $d_Lreactbuild_components_Form$Done$;
var $n_Lreactbuild_components_Form$Done$;
function $m_Lreactbuild_components_Form$Done$() {
  if ((!$n_Lreactbuild_components_Form$Done$)) {
    $n_Lreactbuild_components_Form$Done$ = new $c_Lreactbuild_components_Form$Done$()
  };
  return $n_Lreactbuild_components_Form$Done$
}
/** @constructor */
function $c_Lreactbuild_components_Form$Pending$() {
  /*<skip>*/
}
$c_Lreactbuild_components_Form$Pending$.prototype = new $h_O();
$c_Lreactbuild_components_Form$Pending$.prototype.constructor = $c_Lreactbuild_components_Form$Pending$;
/** @constructor */
function $h_Lreactbuild_components_Form$Pending$() {
  /*<skip>*/
}
$h_Lreactbuild_components_Form$Pending$.prototype = $c_Lreactbuild_components_Form$Pending$.prototype;
$c_Lreactbuild_components_Form$Pending$.prototype.productPrefix__T = (function() {
  return "Pending"
});
$c_Lreactbuild_components_Form$Pending$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_components_Form$Pending$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_components_Form$Pending$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_components_Form$Pending$.prototype.hashCode__I = (function() {
  return 982065527
});
$c_Lreactbuild_components_Form$Pending$.prototype.toString__T = (function() {
  return "Pending"
});
var $d_Lreactbuild_components_Form$Pending$ = new $TypeData().initClass({
  Lreactbuild_components_Form$Pending$: 0
}, false, "reactbuild.components.Form$Pending$", {
  Lreactbuild_components_Form$Pending$: 1,
  O: 1,
  Lreactbuild_components_Form$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_components_Form$Pending$.prototype.$classData = $d_Lreactbuild_components_Form$Pending$;
var $n_Lreactbuild_components_Form$Pending$;
function $m_Lreactbuild_components_Form$Pending$() {
  if ((!$n_Lreactbuild_components_Form$Pending$)) {
    $n_Lreactbuild_components_Form$Pending$ = new $c_Lreactbuild_components_Form$Pending$()
  };
  return $n_Lreactbuild_components_Form$Pending$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_ACADVER(version) {
  this.Lreactbuild_format_dxf_ACADVER__f_version = null;
  this.Lreactbuild_format_dxf_ACADVER__f_version = version
}
$c_Lreactbuild_format_dxf_ACADVER.prototype = new $h_O();
$c_Lreactbuild_format_dxf_ACADVER.prototype.constructor = $c_Lreactbuild_format_dxf_ACADVER;
/** @constructor */
function $h_Lreactbuild_format_dxf_ACADVER() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_ACADVER.prototype = $c_Lreactbuild_format_dxf_ACADVER.prototype;
$c_Lreactbuild_format_dxf_ACADVER.prototype.productPrefix__T = (function() {
  return "ACADVER"
});
$c_Lreactbuild_format_dxf_ACADVER.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_ACADVER.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_ACADVER__f_version : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_ACADVER.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_ACADVER.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_ACADVER.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_ACADVER.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_ACADVER)) {
    var ACADVER$1 = $as_Lreactbuild_format_dxf_ACADVER(x$1);
    return (this.Lreactbuild_format_dxf_ACADVER__f_version === $n(ACADVER$1).Lreactbuild_format_dxf_ACADVER__f_version)
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_ACADVER(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_ACADVER) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.ACADVER"))
}
function $isArrayOf_Lreactbuild_format_dxf_ACADVER(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_ACADVER)))
}
function $asArrayOf_Lreactbuild_format_dxf_ACADVER(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_ACADVER(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.ACADVER;", depth))
}
var $d_Lreactbuild_format_dxf_ACADVER = new $TypeData().initClass({
  Lreactbuild_format_dxf_ACADVER: 0
}, false, "reactbuild.format.dxf.ACADVER", {
  Lreactbuild_format_dxf_ACADVER: 1,
  O: 1,
  Lreactbuild_format_dxf_Parameter: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_ACADVER.prototype.$classData = $d_Lreactbuild_format_dxf_ACADVER;
/** @constructor */
function $c_Lreactbuild_format_dxf_AccumulatingEncoder$() {
  this.Lreactbuild_format_dxf_AccumulatingEncoder$__f_encodeHNil = null;
  $n_Lreactbuild_format_dxf_AccumulatingEncoder$ = this;
  $f_Lreactbuild_format_dxf_AccumulatingEncoderInstances__$init$__V(this)
}
$c_Lreactbuild_format_dxf_AccumulatingEncoder$.prototype = new $h_O();
$c_Lreactbuild_format_dxf_AccumulatingEncoder$.prototype.constructor = $c_Lreactbuild_format_dxf_AccumulatingEncoder$;
/** @constructor */
function $h_Lreactbuild_format_dxf_AccumulatingEncoder$() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_AccumulatingEncoder$.prototype = $c_Lreactbuild_format_dxf_AccumulatingEncoder$.prototype;
var $d_Lreactbuild_format_dxf_AccumulatingEncoder$ = new $TypeData().initClass({
  Lreactbuild_format_dxf_AccumulatingEncoder$: 0
}, false, "reactbuild.format.dxf.AccumulatingEncoder$", {
  Lreactbuild_format_dxf_AccumulatingEncoder$: 1,
  O: 1,
  Lreactbuild_format_dxf_AccumulatingEncoderInstances: 1,
  Lreactbuild_format_dxf_HighPriorityImplicitsAccumulatingEncoderInstances: 1,
  Lreactbuild_format_dxf_MidPriorityImplicitsAccumulatingEncoderInstances: 1,
  Lreactbuild_format_dxf_LowPriorityImplicitsAccumulatingEncoderInstances: 1
});
$c_Lreactbuild_format_dxf_AccumulatingEncoder$.prototype.$classData = $d_Lreactbuild_format_dxf_AccumulatingEncoder$;
var $n_Lreactbuild_format_dxf_AccumulatingEncoder$;
function $m_Lreactbuild_format_dxf_AccumulatingEncoder$() {
  if ((!$n_Lreactbuild_format_dxf_AccumulatingEncoder$)) {
    $n_Lreactbuild_format_dxf_AccumulatingEncoder$ = new $c_Lreactbuild_format_dxf_AccumulatingEncoder$()
  };
  return $n_Lreactbuild_format_dxf_AccumulatingEncoder$
}
/** @constructor */
function $c_Lreactbuild_format_dxf_Circle(layer, color, center, radius, thickness) {
  this.Lreactbuild_format_dxf_Circle__f_layer = null;
  this.Lreactbuild_format_dxf_Circle__f_color = null;
  this.Lreactbuild_format_dxf_Circle__f_center = null;
  this.Lreactbuild_format_dxf_Circle__f_radius = 0.0;
  this.Lreactbuild_format_dxf_Circle__f_thickness = null;
  this.Lreactbuild_format_dxf_Circle__f_layer = layer;
  this.Lreactbuild_format_dxf_Circle__f_color = color;
  this.Lreactbuild_format_dxf_Circle__f_center = center;
  this.Lreactbuild_format_dxf_Circle__f_radius = radius;
  this.Lreactbuild_format_dxf_Circle__f_thickness = thickness
}
$c_Lreactbuild_format_dxf_Circle.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Circle.prototype.constructor = $c_Lreactbuild_format_dxf_Circle;
/** @constructor */
function $h_Lreactbuild_format_dxf_Circle() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Circle.prototype = $c_Lreactbuild_format_dxf_Circle.prototype;
$c_Lreactbuild_format_dxf_Circle.prototype.productPrefix__T = (function() {
  return "Circle"
});
$c_Lreactbuild_format_dxf_Circle.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_format_dxf_Circle.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Circle__f_layer;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Circle__f_color;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_Circle__f_center;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_Circle__f_radius;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_Circle__f_thickness;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Circle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Circle.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Circle");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_format_dxf_Circle__f_layer;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_format_dxf_Circle__f_color;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_format_dxf_Circle__f_center;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv = this.Lreactbuild_format_dxf_Circle__f_radius;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lreactbuild_format_dxf_Circle__f_thickness;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_format_dxf_Circle.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Circle.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Circle)) {
    var Circle$1 = $as_Lreactbuild_format_dxf_Circle(x$1);
    if ((this.Lreactbuild_format_dxf_Circle__f_radius === $n(Circle$1).Lreactbuild_format_dxf_Circle__f_radius)) {
      var x = this.Lreactbuild_format_dxf_Circle__f_layer;
      var x$2 = $n(Circle$1).Lreactbuild_format_dxf_Circle__f_layer;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_format_dxf_Circle__f_color;
      var x$4 = $n(Circle$1).Lreactbuild_format_dxf_Circle__f_color;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_format_dxf_Circle__f_center;
        var x$6 = $n(Circle$1).Lreactbuild_format_dxf_Circle__f_center;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var x$7 = this.Lreactbuild_format_dxf_Circle__f_thickness;
          var x$8 = $n(Circle$1).Lreactbuild_format_dxf_Circle__f_thickness;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Circle(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Circle) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Circle"))
}
function $isArrayOf_Lreactbuild_format_dxf_Circle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Circle)))
}
function $asArrayOf_Lreactbuild_format_dxf_Circle(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Circle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Circle;", depth))
}
var $d_Lreactbuild_format_dxf_Circle = new $TypeData().initClass({
  Lreactbuild_format_dxf_Circle: 0
}, false, "reactbuild.format.dxf.Circle", {
  Lreactbuild_format_dxf_Circle: 1,
  O: 1,
  Lreactbuild_format_dxf_Entity: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Circle.prototype.$classData = $d_Lreactbuild_format_dxf_Circle;
/** @constructor */
function $c_Lreactbuild_format_dxf_EXTMAX(point) {
  this.Lreactbuild_format_dxf_EXTMAX__f_point = null;
  this.Lreactbuild_format_dxf_EXTMAX__f_point = point
}
$c_Lreactbuild_format_dxf_EXTMAX.prototype = new $h_O();
$c_Lreactbuild_format_dxf_EXTMAX.prototype.constructor = $c_Lreactbuild_format_dxf_EXTMAX;
/** @constructor */
function $h_Lreactbuild_format_dxf_EXTMAX() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_EXTMAX.prototype = $c_Lreactbuild_format_dxf_EXTMAX.prototype;
$c_Lreactbuild_format_dxf_EXTMAX.prototype.productPrefix__T = (function() {
  return "EXTMAX"
});
$c_Lreactbuild_format_dxf_EXTMAX.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_EXTMAX.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_EXTMAX__f_point : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_EXTMAX.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_EXTMAX.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_EXTMAX.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_EXTMAX.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_EXTMAX)) {
    var EXTMAX$1 = $as_Lreactbuild_format_dxf_EXTMAX(x$1);
    var x = this.Lreactbuild_format_dxf_EXTMAX__f_point;
    var x$2 = $n(EXTMAX$1).Lreactbuild_format_dxf_EXTMAX__f_point;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_EXTMAX(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_EXTMAX) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.EXTMAX"))
}
function $isArrayOf_Lreactbuild_format_dxf_EXTMAX(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_EXTMAX)))
}
function $asArrayOf_Lreactbuild_format_dxf_EXTMAX(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_EXTMAX(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.EXTMAX;", depth))
}
var $d_Lreactbuild_format_dxf_EXTMAX = new $TypeData().initClass({
  Lreactbuild_format_dxf_EXTMAX: 0
}, false, "reactbuild.format.dxf.EXTMAX", {
  Lreactbuild_format_dxf_EXTMAX: 1,
  O: 1,
  Lreactbuild_format_dxf_Parameter: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_EXTMAX.prototype.$classData = $d_Lreactbuild_format_dxf_EXTMAX;
/** @constructor */
function $c_Lreactbuild_format_dxf_EXTMIN(point) {
  this.Lreactbuild_format_dxf_EXTMIN__f_point = null;
  this.Lreactbuild_format_dxf_EXTMIN__f_point = point
}
$c_Lreactbuild_format_dxf_EXTMIN.prototype = new $h_O();
$c_Lreactbuild_format_dxf_EXTMIN.prototype.constructor = $c_Lreactbuild_format_dxf_EXTMIN;
/** @constructor */
function $h_Lreactbuild_format_dxf_EXTMIN() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_EXTMIN.prototype = $c_Lreactbuild_format_dxf_EXTMIN.prototype;
$c_Lreactbuild_format_dxf_EXTMIN.prototype.productPrefix__T = (function() {
  return "EXTMIN"
});
$c_Lreactbuild_format_dxf_EXTMIN.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_EXTMIN.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_EXTMIN__f_point : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_EXTMIN.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_EXTMIN.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_EXTMIN.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_EXTMIN.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_EXTMIN)) {
    var EXTMIN$1 = $as_Lreactbuild_format_dxf_EXTMIN(x$1);
    var x = this.Lreactbuild_format_dxf_EXTMIN__f_point;
    var x$2 = $n(EXTMIN$1).Lreactbuild_format_dxf_EXTMIN__f_point;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_EXTMIN(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_EXTMIN) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.EXTMIN"))
}
function $isArrayOf_Lreactbuild_format_dxf_EXTMIN(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_EXTMIN)))
}
function $asArrayOf_Lreactbuild_format_dxf_EXTMIN(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_EXTMIN(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.EXTMIN;", depth))
}
var $d_Lreactbuild_format_dxf_EXTMIN = new $TypeData().initClass({
  Lreactbuild_format_dxf_EXTMIN: 0
}, false, "reactbuild.format.dxf.EXTMIN", {
  Lreactbuild_format_dxf_EXTMIN: 1,
  O: 1,
  Lreactbuild_format_dxf_Parameter: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_EXTMIN.prototype.$classData = $d_Lreactbuild_format_dxf_EXTMIN;
/** @constructor */
function $c_Lreactbuild_format_dxf_File(sectionList) {
  this.Lreactbuild_format_dxf_File__f_sectionList = null;
  this.Lreactbuild_format_dxf_File__f_sectionList = sectionList
}
$c_Lreactbuild_format_dxf_File.prototype = new $h_O();
$c_Lreactbuild_format_dxf_File.prototype.constructor = $c_Lreactbuild_format_dxf_File;
/** @constructor */
function $h_Lreactbuild_format_dxf_File() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_File.prototype = $c_Lreactbuild_format_dxf_File.prototype;
$c_Lreactbuild_format_dxf_File.prototype.productPrefix__T = (function() {
  return "File"
});
$c_Lreactbuild_format_dxf_File.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_File.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_File__f_sectionList : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_File.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_File.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_File.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_File.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_File)) {
    var File$1 = $as_Lreactbuild_format_dxf_File(x$1);
    var x = this.Lreactbuild_format_dxf_File__f_sectionList;
    var x$2 = $n(File$1).Lreactbuild_format_dxf_File__f_sectionList;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_File(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_File) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.File"))
}
function $isArrayOf_Lreactbuild_format_dxf_File(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_File)))
}
function $asArrayOf_Lreactbuild_format_dxf_File(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_File(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.File;", depth))
}
var $d_Lreactbuild_format_dxf_File = new $TypeData().initClass({
  Lreactbuild_format_dxf_File: 0
}, false, "reactbuild.format.dxf.File", {
  Lreactbuild_format_dxf_File: 1,
  O: 1,
  Lreactbuild_format_dxf_Root: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_File.prototype.$classData = $d_Lreactbuild_format_dxf_File;
/** @constructor */
function $c_Lreactbuild_format_dxf_INSBASE(point) {
  this.Lreactbuild_format_dxf_INSBASE__f_point = null;
  this.Lreactbuild_format_dxf_INSBASE__f_point = point
}
$c_Lreactbuild_format_dxf_INSBASE.prototype = new $h_O();
$c_Lreactbuild_format_dxf_INSBASE.prototype.constructor = $c_Lreactbuild_format_dxf_INSBASE;
/** @constructor */
function $h_Lreactbuild_format_dxf_INSBASE() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_INSBASE.prototype = $c_Lreactbuild_format_dxf_INSBASE.prototype;
$c_Lreactbuild_format_dxf_INSBASE.prototype.productPrefix__T = (function() {
  return "INSBASE"
});
$c_Lreactbuild_format_dxf_INSBASE.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_INSBASE.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_INSBASE__f_point : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_INSBASE.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_INSBASE.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_INSBASE.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_INSBASE.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_INSBASE)) {
    var INSBASE$1 = $as_Lreactbuild_format_dxf_INSBASE(x$1);
    var x = this.Lreactbuild_format_dxf_INSBASE__f_point;
    var x$2 = $n(INSBASE$1).Lreactbuild_format_dxf_INSBASE__f_point;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_INSBASE(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_INSBASE) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.INSBASE"))
}
function $isArrayOf_Lreactbuild_format_dxf_INSBASE(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_INSBASE)))
}
function $asArrayOf_Lreactbuild_format_dxf_INSBASE(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_INSBASE(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.INSBASE;", depth))
}
var $d_Lreactbuild_format_dxf_INSBASE = new $TypeData().initClass({
  Lreactbuild_format_dxf_INSBASE: 0
}, false, "reactbuild.format.dxf.INSBASE", {
  Lreactbuild_format_dxf_INSBASE: 1,
  O: 1,
  Lreactbuild_format_dxf_Parameter: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_INSBASE.prototype.$classData = $d_Lreactbuild_format_dxf_INSBASE;
/** @constructor */
function $c_Lreactbuild_format_dxf_Insert(name, layer, color, insertionPoint, scaleX, scaleY, scaleZ, rotation, columns, rows, columnSpacing, rowSpacing) {
  this.Lreactbuild_format_dxf_Insert__f_name = null;
  this.Lreactbuild_format_dxf_Insert__f_layer = null;
  this.Lreactbuild_format_dxf_Insert__f_color = null;
  this.Lreactbuild_format_dxf_Insert__f_insertionPoint = null;
  this.Lreactbuild_format_dxf_Insert__f_scaleX = null;
  this.Lreactbuild_format_dxf_Insert__f_scaleY = null;
  this.Lreactbuild_format_dxf_Insert__f_scaleZ = null;
  this.Lreactbuild_format_dxf_Insert__f_rotation = null;
  this.Lreactbuild_format_dxf_Insert__f_columns = null;
  this.Lreactbuild_format_dxf_Insert__f_rows = null;
  this.Lreactbuild_format_dxf_Insert__f_columnSpacing = null;
  this.Lreactbuild_format_dxf_Insert__f_rowSpacing = null;
  this.Lreactbuild_format_dxf_Insert__f_name = name;
  this.Lreactbuild_format_dxf_Insert__f_layer = layer;
  this.Lreactbuild_format_dxf_Insert__f_color = color;
  this.Lreactbuild_format_dxf_Insert__f_insertionPoint = insertionPoint;
  this.Lreactbuild_format_dxf_Insert__f_scaleX = scaleX;
  this.Lreactbuild_format_dxf_Insert__f_scaleY = scaleY;
  this.Lreactbuild_format_dxf_Insert__f_scaleZ = scaleZ;
  this.Lreactbuild_format_dxf_Insert__f_rotation = rotation;
  this.Lreactbuild_format_dxf_Insert__f_columns = columns;
  this.Lreactbuild_format_dxf_Insert__f_rows = rows;
  this.Lreactbuild_format_dxf_Insert__f_columnSpacing = columnSpacing;
  this.Lreactbuild_format_dxf_Insert__f_rowSpacing = rowSpacing
}
$c_Lreactbuild_format_dxf_Insert.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Insert.prototype.constructor = $c_Lreactbuild_format_dxf_Insert;
/** @constructor */
function $h_Lreactbuild_format_dxf_Insert() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Insert.prototype = $c_Lreactbuild_format_dxf_Insert.prototype;
$c_Lreactbuild_format_dxf_Insert.prototype.productPrefix__T = (function() {
  return "Insert"
});
$c_Lreactbuild_format_dxf_Insert.prototype.productArity__I = (function() {
  return 12
});
$c_Lreactbuild_format_dxf_Insert.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Insert__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Insert__f_layer;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_Insert__f_color;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_Insert__f_insertionPoint;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_Insert__f_scaleX;
      break
    }
    case 5: {
      return this.Lreactbuild_format_dxf_Insert__f_scaleY;
      break
    }
    case 6: {
      return this.Lreactbuild_format_dxf_Insert__f_scaleZ;
      break
    }
    case 7: {
      return this.Lreactbuild_format_dxf_Insert__f_rotation;
      break
    }
    case 8: {
      return this.Lreactbuild_format_dxf_Insert__f_columns;
      break
    }
    case 9: {
      return this.Lreactbuild_format_dxf_Insert__f_rows;
      break
    }
    case 10: {
      return this.Lreactbuild_format_dxf_Insert__f_columnSpacing;
      break
    }
    case 11: {
      return this.Lreactbuild_format_dxf_Insert__f_rowSpacing;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Insert.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Insert.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Insert.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Insert.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Insert)) {
    var Insert$1 = $as_Lreactbuild_format_dxf_Insert(x$1);
    var x = this.Lreactbuild_format_dxf_Insert__f_name;
    var x$2 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_name;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_dxf_Insert__f_layer;
      var x$4 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_layer;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_format_dxf_Insert__f_color;
        var x$6 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_color;
        var $$x2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Lreactbuild_format_dxf_Insert__f_insertionPoint;
      var x$8 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_insertionPoint;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_format_dxf_Insert__f_scaleX;
        var x$10 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_scaleX;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_format_dxf_Insert__f_scaleY;
          var x$12 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_scaleY;
          var $$x1 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$13 = this.Lreactbuild_format_dxf_Insert__f_scaleZ;
      var x$14 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_scaleZ;
      if (((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))) {
        var x$15 = this.Lreactbuild_format_dxf_Insert__f_rotation;
        var x$16 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_rotation;
        if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
          var x$17 = this.Lreactbuild_format_dxf_Insert__f_columns;
          var x$18 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_columns;
          var $$x3 = ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))
        } else {
          var $$x3 = false
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$19 = this.Lreactbuild_format_dxf_Insert__f_rows;
        var x$20 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_rows;
        if (((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))) {
          var x$21 = this.Lreactbuild_format_dxf_Insert__f_columnSpacing;
          var x$22 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_columnSpacing;
          if (((x$21 === null) ? (x$22 === null) : $n(x$21).equals__O__Z(x$22))) {
            var x$23 = this.Lreactbuild_format_dxf_Insert__f_rowSpacing;
            var x$24 = $n(Insert$1).Lreactbuild_format_dxf_Insert__f_rowSpacing;
            return ((x$23 === null) ? (x$24 === null) : $n(x$23).equals__O__Z(x$24))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Insert(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Insert) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Insert"))
}
function $isArrayOf_Lreactbuild_format_dxf_Insert(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Insert)))
}
function $asArrayOf_Lreactbuild_format_dxf_Insert(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Insert(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Insert;", depth))
}
var $d_Lreactbuild_format_dxf_Insert = new $TypeData().initClass({
  Lreactbuild_format_dxf_Insert: 0
}, false, "reactbuild.format.dxf.Insert", {
  Lreactbuild_format_dxf_Insert: 1,
  O: 1,
  Lreactbuild_format_dxf_Entity: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Insert.prototype.$classData = $d_Lreactbuild_format_dxf_Insert;
/** @constructor */
function $c_Lreactbuild_format_dxf_Line(layer, color, start, end) {
  this.Lreactbuild_format_dxf_Line__f_layer = null;
  this.Lreactbuild_format_dxf_Line__f_color = null;
  this.Lreactbuild_format_dxf_Line__f_start = null;
  this.Lreactbuild_format_dxf_Line__f_end = null;
  this.Lreactbuild_format_dxf_Line__f_layer = layer;
  this.Lreactbuild_format_dxf_Line__f_color = color;
  this.Lreactbuild_format_dxf_Line__f_start = start;
  this.Lreactbuild_format_dxf_Line__f_end = end
}
$c_Lreactbuild_format_dxf_Line.prototype = new $h_O();
$c_Lreactbuild_format_dxf_Line.prototype.constructor = $c_Lreactbuild_format_dxf_Line;
/** @constructor */
function $h_Lreactbuild_format_dxf_Line() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_Line.prototype = $c_Lreactbuild_format_dxf_Line.prototype;
$c_Lreactbuild_format_dxf_Line.prototype.productPrefix__T = (function() {
  return "Line"
});
$c_Lreactbuild_format_dxf_Line.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_format_dxf_Line.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_Line__f_layer;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_Line__f_color;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_Line__f_start;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_Line__f_end;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_Line.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_Line.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_Line.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_Line.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_Line)) {
    var Line$1 = $as_Lreactbuild_format_dxf_Line(x$1);
    var x = this.Lreactbuild_format_dxf_Line__f_layer;
    var x$2 = $n(Line$1).Lreactbuild_format_dxf_Line__f_layer;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_dxf_Line__f_color;
      var x$4 = $n(Line$1).Lreactbuild_format_dxf_Line__f_color;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_format_dxf_Line__f_start;
      var x$6 = $n(Line$1).Lreactbuild_format_dxf_Line__f_start;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_format_dxf_Line__f_end;
        var x$8 = $n(Line$1).Lreactbuild_format_dxf_Line__f_end;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_Line(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_Line) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.Line"))
}
function $isArrayOf_Lreactbuild_format_dxf_Line(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_Line)))
}
function $asArrayOf_Lreactbuild_format_dxf_Line(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_Line(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.Line;", depth))
}
var $d_Lreactbuild_format_dxf_Line = new $TypeData().initClass({
  Lreactbuild_format_dxf_Line: 0
}, false, "reactbuild.format.dxf.Line", {
  Lreactbuild_format_dxf_Line: 1,
  O: 1,
  Lreactbuild_format_dxf_Entity: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_Line.prototype.$classData = $d_Lreactbuild_format_dxf_Line;
/** @constructor */
function $c_Lreactbuild_format_dxf_LwPolyline(layer, color, numberOfVertices, flags, vertices) {
  this.Lreactbuild_format_dxf_LwPolyline__f_layer = null;
  this.Lreactbuild_format_dxf_LwPolyline__f_color = null;
  this.Lreactbuild_format_dxf_LwPolyline__f_numberOfVertices = null;
  this.Lreactbuild_format_dxf_LwPolyline__f_flags = null;
  this.Lreactbuild_format_dxf_LwPolyline__f_vertices = null;
  this.Lreactbuild_format_dxf_LwPolyline__f_layer = layer;
  this.Lreactbuild_format_dxf_LwPolyline__f_color = color;
  this.Lreactbuild_format_dxf_LwPolyline__f_numberOfVertices = numberOfVertices;
  this.Lreactbuild_format_dxf_LwPolyline__f_flags = flags;
  this.Lreactbuild_format_dxf_LwPolyline__f_vertices = vertices
}
$c_Lreactbuild_format_dxf_LwPolyline.prototype = new $h_O();
$c_Lreactbuild_format_dxf_LwPolyline.prototype.constructor = $c_Lreactbuild_format_dxf_LwPolyline;
/** @constructor */
function $h_Lreactbuild_format_dxf_LwPolyline() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_LwPolyline.prototype = $c_Lreactbuild_format_dxf_LwPolyline.prototype;
$c_Lreactbuild_format_dxf_LwPolyline.prototype.productPrefix__T = (function() {
  return "LwPolyline"
});
$c_Lreactbuild_format_dxf_LwPolyline.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_format_dxf_LwPolyline.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_dxf_LwPolyline__f_layer;
      break
    }
    case 1: {
      return this.Lreactbuild_format_dxf_LwPolyline__f_color;
      break
    }
    case 2: {
      return this.Lreactbuild_format_dxf_LwPolyline__f_numberOfVertices;
      break
    }
    case 3: {
      return this.Lreactbuild_format_dxf_LwPolyline__f_flags;
      break
    }
    case 4: {
      return this.Lreactbuild_format_dxf_LwPolyline__f_vertices;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_dxf_LwPolyline.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_LwPolyline.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_dxf_LwPolyline.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_LwPolyline.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_LwPolyline)) {
    var LwPolyline$1 = $as_Lreactbuild_format_dxf_LwPolyline(x$1);
    var x = this.Lreactbuild_format_dxf_LwPolyline__f_layer;
    var x$2 = $n(LwPolyline$1).Lreactbuild_format_dxf_LwPolyline__f_layer;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_dxf_LwPolyline__f_color;
      var x$4 = $n(LwPolyline$1).Lreactbuild_format_dxf_LwPolyline__f_color;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_format_dxf_LwPolyline__f_numberOfVertices;
      var x$6 = $n(LwPolyline$1).Lreactbuild_format_dxf_LwPolyline__f_numberOfVertices;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_format_dxf_LwPolyline__f_flags;
        var x$8 = $n(LwPolyline$1).Lreactbuild_format_dxf_LwPolyline__f_flags;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_format_dxf_LwPolyline__f_vertices;
          var x$10 = $n(LwPolyline$1).Lreactbuild_format_dxf_LwPolyline__f_vertices;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_LwPolyline(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_LwPolyline) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.LwPolyline"))
}
function $isArrayOf_Lreactbuild_format_dxf_LwPolyline(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_LwPolyline)))
}
function $asArrayOf_Lreactbuild_format_dxf_LwPolyline(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_LwPolyline(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.LwPolyline;", depth))
}
var $d_Lreactbuild_format_dxf_LwPolyline = new $TypeData().initClass({
  Lreactbuild_format_dxf_LwPolyline: 0
}, false, "reactbuild.format.dxf.LwPolyline", {
  Lreactbuild_format_dxf_LwPolyline: 1,
  O: 1,
  Lreactbuild_format_dxf_Entity: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_LwPolyline.prototype.$classData = $d_Lreactbuild_format_dxf_LwPolyline;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$AbsentRoof$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$AbsentRoof$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$AbsentRoof$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype = $c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype;
$c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype.productPrefix__T = (function() {
  return "AbsentRoof"
});
$c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype.hashCode__I = (function() {
  return 336818125
});
$c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype.toString__T = (function() {
  return "AbsentRoof"
});
var $d_Lreactbuild_format_iz2use_package$AbsentRoof$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$AbsentRoof$: 0
}, false, "reactbuild.format.iz2use.package$AbsentRoof$", {
  Lreactbuild_format_iz2use_package$AbsentRoof$: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$RoofType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$AbsentRoof$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$AbsentRoof$;
var $n_Lreactbuild_format_iz2use_package$AbsentRoof$;
function $m_Lreactbuild_format_iz2use_package$AbsentRoof$() {
  if ((!$n_Lreactbuild_format_iz2use_package$AbsentRoof$)) {
    $n_Lreactbuild_format_iz2use_package$AbsentRoof$ = new $c_Lreactbuild_format_iz2use_package$AbsentRoof$()
  };
  return $n_Lreactbuild_format_iz2use_package$AbsentRoof$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Bacacier(index, height) {
  this.Lreactbuild_format_iz2use_package$Bacacier__f_index = null;
  this.Lreactbuild_format_iz2use_package$Bacacier__f_height = null;
  this.Lreactbuild_format_iz2use_package$Bacacier__f_index = index;
  this.Lreactbuild_format_iz2use_package$Bacacier__f_height = height
}
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Bacacier;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Bacacier() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Bacacier.prototype = $c_Lreactbuild_format_iz2use_package$Bacacier.prototype;
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype.productPrefix__T = (function() {
  return "Bacacier"
});
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$Bacacier__f_index;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$Bacacier__f_height;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$Bacacier)) {
    var Bacacier$1 = $as_Lreactbuild_format_iz2use_package$Bacacier(x$1);
    var x = this.Lreactbuild_format_iz2use_package$Bacacier__f_index;
    var x$2 = $n(Bacacier$1).Lreactbuild_format_iz2use_package$Bacacier__f_index;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_iz2use_package$Bacacier__f_height;
      var x$4 = $n(Bacacier$1).Lreactbuild_format_iz2use_package$Bacacier__f_height;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Bacacier$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$Bacacier(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$Bacacier) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$Bacacier"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$Bacacier(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$Bacacier)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$Bacacier(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$Bacacier(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$Bacacier;", depth))
}
var $d_Lreactbuild_format_iz2use_package$Bacacier = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Bacacier: 0
}, false, "reactbuild.format.iz2use.package$Bacacier", {
  Lreactbuild_format_iz2use_package$Bacacier: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$RoofType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Bacacier.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Bacacier;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$BothOffset(from, to) {
  this.Lreactbuild_format_iz2use_package$BothOffset__f_from = null;
  this.Lreactbuild_format_iz2use_package$BothOffset__f_to = null;
  this.Lreactbuild_format_iz2use_package$BothOffset__f_from = from;
  this.Lreactbuild_format_iz2use_package$BothOffset__f_to = to
}
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype.constructor = $c_Lreactbuild_format_iz2use_package$BothOffset;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$BothOffset() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$BothOffset.prototype = $c_Lreactbuild_format_iz2use_package$BothOffset.prototype;
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype.productPrefix__T = (function() {
  return "BothOffset"
});
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$BothOffset__f_from;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$BothOffset__f_to;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$BothOffset)) {
    var BothOffset$1 = $as_Lreactbuild_format_iz2use_package$BothOffset(x$1);
    var x = this.Lreactbuild_format_iz2use_package$BothOffset__f_from;
    var x$2 = $n(BothOffset$1).Lreactbuild_format_iz2use_package$BothOffset__f_from;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_iz2use_package$BothOffset__f_to;
      var x$4 = $n(BothOffset$1).Lreactbuild_format_iz2use_package$BothOffset__f_to;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$BothOffset(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$BothOffset) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$BothOffset"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$BothOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$BothOffset)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$BothOffset(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$BothOffset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$BothOffset;", depth))
}
var $d_Lreactbuild_format_iz2use_package$BothOffset = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$BothOffset: 0
}, false, "reactbuild.format.iz2use.package$BothOffset", {
  Lreactbuild_format_iz2use_package$BothOffset: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$ComponentGroupOffset: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$BothOffset.prototype.$classData = $d_Lreactbuild_format_iz2use_package$BothOffset;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$CanalTile35Percent(secondaryAxis) {
  this.Lreactbuild_format_iz2use_package$CanalTile35Percent__f_secondaryAxis = false;
  this.Lreactbuild_format_iz2use_package$CanalTile35Percent__f_secondaryAxis = secondaryAxis
}
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype.constructor = $c_Lreactbuild_format_iz2use_package$CanalTile35Percent;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$CanalTile35Percent() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype = $c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype;
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype.productPrefix__T = (function() {
  return "CanalTile35Percent"
});
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_iz2use_package$CanalTile35Percent__f_secondaryAxis : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("CanalTile35Percent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_format_iz2use_package$CanalTile35Percent__f_secondaryAxis ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$CanalTile35Percent)) {
    var CanalTile35Percent$1 = $as_Lreactbuild_format_iz2use_package$CanalTile35Percent(x$1);
    return ((this.Lreactbuild_format_iz2use_package$CanalTile35Percent__f_secondaryAxis === $n(CanalTile35Percent$1).Lreactbuild_format_iz2use_package$CanalTile35Percent__f_secondaryAxis) && ($n(CanalTile35Percent$1), true))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$CanalTile35Percent(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$CanalTile35Percent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$CanalTile35Percent"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$CanalTile35Percent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$CanalTile35Percent)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$CanalTile35Percent(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$CanalTile35Percent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$CanalTile35Percent;", depth))
}
var $d_Lreactbuild_format_iz2use_package$CanalTile35Percent = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$CanalTile35Percent: 0
}, false, "reactbuild.format.iz2use.package$CanalTile35Percent", {
  Lreactbuild_format_iz2use_package$CanalTile35Percent: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$RoofType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$CanalTile35Percent.prototype.$classData = $d_Lreactbuild_format_iz2use_package$CanalTile35Percent;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$NegativeOffset(to) {
  this.Lreactbuild_format_iz2use_package$NegativeOffset__f_to = null;
  this.Lreactbuild_format_iz2use_package$NegativeOffset__f_to = to
}
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype.constructor = $c_Lreactbuild_format_iz2use_package$NegativeOffset;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$NegativeOffset() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$NegativeOffset.prototype = $c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype;
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype.productPrefix__T = (function() {
  return "NegativeOffset"
});
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_iz2use_package$NegativeOffset__f_to : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$NegativeOffset)) {
    var NegativeOffset$1 = $as_Lreactbuild_format_iz2use_package$NegativeOffset(x$1);
    var x = this.Lreactbuild_format_iz2use_package$NegativeOffset__f_to;
    var x$2 = $n(NegativeOffset$1).Lreactbuild_format_iz2use_package$NegativeOffset__f_to;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$NegativeOffset(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$NegativeOffset) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$NegativeOffset"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$NegativeOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$NegativeOffset)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$NegativeOffset(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$NegativeOffset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$NegativeOffset;", depth))
}
var $d_Lreactbuild_format_iz2use_package$NegativeOffset = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$NegativeOffset: 0
}, false, "reactbuild.format.iz2use.package$NegativeOffset", {
  Lreactbuild_format_iz2use_package$NegativeOffset: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$ComponentGroupOffset: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$NegativeOffset.prototype.$classData = $d_Lreactbuild_format_iz2use_package$NegativeOffset;
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$NoOffset$() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$NoOffset$.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$NoOffset$.prototype.constructor = $c_Lreactbuild_format_iz2use_package$NoOffset$;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$NoOffset$() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$NoOffset$.prototype = $c_Lreactbuild_format_iz2use_package$NoOffset$.prototype;
$c_Lreactbuild_format_iz2use_package$NoOffset$.prototype.productPrefix__T = (function() {
  return "NoOffset"
});
$c_Lreactbuild_format_iz2use_package$NoOffset$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_format_iz2use_package$NoOffset$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_format_iz2use_package$NoOffset$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$NoOffset$.prototype.hashCode__I = (function() {
  return 587967956
});
$c_Lreactbuild_format_iz2use_package$NoOffset$.prototype.toString__T = (function() {
  return "NoOffset"
});
var $d_Lreactbuild_format_iz2use_package$NoOffset$ = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$NoOffset$: 0
}, false, "reactbuild.format.iz2use.package$NoOffset$", {
  Lreactbuild_format_iz2use_package$NoOffset$: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$ComponentGroupOffset: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$NoOffset$.prototype.$classData = $d_Lreactbuild_format_iz2use_package$NoOffset$;
var $n_Lreactbuild_format_iz2use_package$NoOffset$;
function $m_Lreactbuild_format_iz2use_package$NoOffset$() {
  if ((!$n_Lreactbuild_format_iz2use_package$NoOffset$)) {
    $n_Lreactbuild_format_iz2use_package$NoOffset$ = new $c_Lreactbuild_format_iz2use_package$NoOffset$()
  };
  return $n_Lreactbuild_format_iz2use_package$NoOffset$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$PositiveOffset(from) {
  this.Lreactbuild_format_iz2use_package$PositiveOffset__f_from = null;
  this.Lreactbuild_format_iz2use_package$PositiveOffset__f_from = from
}
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype.constructor = $c_Lreactbuild_format_iz2use_package$PositiveOffset;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$PositiveOffset() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$PositiveOffset.prototype = $c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype;
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype.productPrefix__T = (function() {
  return "PositiveOffset"
});
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_iz2use_package$PositiveOffset__f_from : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$PositiveOffset)) {
    var PositiveOffset$1 = $as_Lreactbuild_format_iz2use_package$PositiveOffset(x$1);
    var x = this.Lreactbuild_format_iz2use_package$PositiveOffset__f_from;
    var x$2 = $n(PositiveOffset$1).Lreactbuild_format_iz2use_package$PositiveOffset__f_from;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_format_iz2use_package$PositiveOffset(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$PositiveOffset) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$PositiveOffset"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$PositiveOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$PositiveOffset)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$PositiveOffset(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$PositiveOffset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$PositiveOffset;", depth))
}
var $d_Lreactbuild_format_iz2use_package$PositiveOffset = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$PositiveOffset: 0
}, false, "reactbuild.format.iz2use.package$PositiveOffset", {
  Lreactbuild_format_iz2use_package$PositiveOffset: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$ComponentGroupOffset: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$PositiveOffset.prototype.$classData = $d_Lreactbuild_format_iz2use_package$PositiveOffset;
function $p_Lreactbuild_format_iz2use_package$Room__shape$lzycompute__sci_List($thiz) {
  if ((!$thiz.Lreactbuild_format_iz2use_package$Room__f_bitmap$0)) {
    $thiz.Lreactbuild_format_iz2use_package$Room__f_shape = $f_Lreactbuild_format_iz2use_package$GenerateGeometry__shape__sci_List($thiz);
    $thiz.Lreactbuild_format_iz2use_package$Room__f_bitmap$0 = true
  };
  return $thiz.Lreactbuild_format_iz2use_package$Room__f_shape
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Room(name, origin, sides) {
  this.Lreactbuild_format_iz2use_package$Room__f_name = null;
  this.Lreactbuild_format_iz2use_package$Room__f_origin = null;
  this.Lreactbuild_format_iz2use_package$Room__f_sides = null;
  this.Lreactbuild_format_iz2use_package$Room__f_shape = null;
  this.Lreactbuild_format_iz2use_package$Room__f_bitmap$0 = false;
  this.Lreactbuild_format_iz2use_package$Room__f_name = name;
  this.Lreactbuild_format_iz2use_package$Room__f_origin = origin;
  this.Lreactbuild_format_iz2use_package$Room__f_sides = sides
}
$c_Lreactbuild_format_iz2use_package$Room.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Room.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Room;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Room() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Room.prototype = $c_Lreactbuild_format_iz2use_package$Room.prototype;
$c_Lreactbuild_format_iz2use_package$Room.prototype.shape__sci_List = (function() {
  return ((!this.Lreactbuild_format_iz2use_package$Room__f_bitmap$0) ? $p_Lreactbuild_format_iz2use_package$Room__shape$lzycompute__sci_List(this) : this.Lreactbuild_format_iz2use_package$Room__f_shape)
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.origin__Lreactbuild_format_iz2use_package$Vector2D = (function() {
  return this.Lreactbuild_format_iz2use_package$Room__f_origin
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.sides__sci_List = (function() {
  return this.Lreactbuild_format_iz2use_package$Room__f_sides
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.withSides__sci_List__Lreactbuild_format_iz2use_package$Room = (function(newSides) {
  var x$2 = this.Lreactbuild_format_iz2use_package$Room__f_name;
  var x$3 = this.Lreactbuild_format_iz2use_package$Room__f_origin;
  return new $c_Lreactbuild_format_iz2use_package$Room(x$2, x$3, newSides)
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.fold__F1__F1__O = (function(f, g) {
  return $n(g).apply__O__O(this)
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.productPrefix__T = (function() {
  return "Room"
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$Room__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$Room__f_origin;
      break
    }
    case 2: {
      return this.Lreactbuild_format_iz2use_package$Room__f_sides;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$Room)) {
    var Room$1 = $as_Lreactbuild_format_iz2use_package$Room(x$1);
    if ((this.Lreactbuild_format_iz2use_package$Room__f_name === $n(Room$1).Lreactbuild_format_iz2use_package$Room__f_name)) {
      var x = this.Lreactbuild_format_iz2use_package$Room__f_origin;
      var x$2 = $n(Room$1).Lreactbuild_format_iz2use_package$Room__f_origin;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_format_iz2use_package$Room__f_sides;
        var x$4 = $n(Room$1).Lreactbuild_format_iz2use_package$Room__f_sides;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.withSides__sci_List__Lreactbuild_format_iz2use_package$GenerateGeometry = (function(newSides) {
  return this.withSides__sci_List__Lreactbuild_format_iz2use_package$Room(newSides)
});
function $as_Lreactbuild_format_iz2use_package$Room(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$Room) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$Room"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$Room(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$Room)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$Room(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$Room(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$Room;", depth))
}
var $d_Lreactbuild_format_iz2use_package$Room = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Room: 0
}, false, "reactbuild.format.iz2use.package$Room", {
  Lreactbuild_format_iz2use_package$Room: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$GenerateGeometry: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Room.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Room;
function $p_Lreactbuild_format_iz2use_package$Storey__shape$lzycompute__sci_List($thiz) {
  if ((!$thiz.Lreactbuild_format_iz2use_package$Storey__f_bitmap$0)) {
    $thiz.Lreactbuild_format_iz2use_package$Storey__f_shape = $f_Lreactbuild_format_iz2use_package$GenerateGeometry__shape__sci_List($thiz);
    $thiz.Lreactbuild_format_iz2use_package$Storey__f_bitmap$0 = true
  };
  return $thiz.Lreactbuild_format_iz2use_package$Storey__f_shape
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Storey(sides, rooms, roofs) {
  this.Lreactbuild_format_iz2use_package$Storey__f_sides = null;
  this.Lreactbuild_format_iz2use_package$Storey__f_rooms = null;
  this.Lreactbuild_format_iz2use_package$Storey__f_roofs = null;
  this.Lreactbuild_format_iz2use_package$Storey__f_origin = null;
  this.Lreactbuild_format_iz2use_package$Storey__f_shape = null;
  this.Lreactbuild_format_iz2use_package$Storey__f_bitmap$0 = false;
  this.Lreactbuild_format_iz2use_package$Storey__f_sides = sides;
  this.Lreactbuild_format_iz2use_package$Storey__f_rooms = rooms;
  this.Lreactbuild_format_iz2use_package$Storey__f_roofs = roofs;
  this.Lreactbuild_format_iz2use_package$Storey__f_origin = $m_Lreactbuild_format_iz2use_package$Vector2D$().Lreactbuild_format_iz2use_package$Vector2D$__f_Zero
}
$c_Lreactbuild_format_iz2use_package$Storey.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Storey.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Storey;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Storey() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Storey.prototype = $c_Lreactbuild_format_iz2use_package$Storey.prototype;
$c_Lreactbuild_format_iz2use_package$Storey.prototype.shape__sci_List = (function() {
  return ((!this.Lreactbuild_format_iz2use_package$Storey__f_bitmap$0) ? $p_Lreactbuild_format_iz2use_package$Storey__shape$lzycompute__sci_List(this) : this.Lreactbuild_format_iz2use_package$Storey__f_shape)
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.sides__sci_List = (function() {
  return this.Lreactbuild_format_iz2use_package$Storey__f_sides
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.origin__Lreactbuild_format_iz2use_package$Vector2D = (function() {
  return this.Lreactbuild_format_iz2use_package$Storey__f_origin
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.fold__F1__F1__O = (function(f, g) {
  return $n(f).apply__O__O(this)
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.productPrefix__T = (function() {
  return "Storey"
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_format_iz2use_package$Storey__f_sides;
      break
    }
    case 1: {
      return this.Lreactbuild_format_iz2use_package$Storey__f_rooms;
      break
    }
    case 2: {
      return this.Lreactbuild_format_iz2use_package$Storey__f_roofs;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_iz2use_package$Storey)) {
    var Storey$1 = $as_Lreactbuild_format_iz2use_package$Storey(x$1);
    var x = this.Lreactbuild_format_iz2use_package$Storey__f_sides;
    var x$2 = $n(Storey$1).Lreactbuild_format_iz2use_package$Storey__f_sides;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_format_iz2use_package$Storey__f_rooms;
      var x$4 = $n(Storey$1).Lreactbuild_format_iz2use_package$Storey__f_rooms;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_format_iz2use_package$Storey__f_roofs;
        var x$6 = $n(Storey$1).Lreactbuild_format_iz2use_package$Storey__f_roofs;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.withSides__sci_List__Lreactbuild_format_iz2use_package$GenerateGeometry = (function(newSides) {
  var rooms = this.Lreactbuild_format_iz2use_package$Storey__f_rooms;
  var roofs = this.Lreactbuild_format_iz2use_package$Storey__f_roofs;
  return new $c_Lreactbuild_format_iz2use_package$Storey(newSides, rooms, roofs)
});
function $as_Lreactbuild_format_iz2use_package$Storey(obj) {
  return (((obj instanceof $c_Lreactbuild_format_iz2use_package$Storey) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.iz2use.package$Storey"))
}
function $isArrayOf_Lreactbuild_format_iz2use_package$Storey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_iz2use_package$Storey)))
}
function $asArrayOf_Lreactbuild_format_iz2use_package$Storey(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_iz2use_package$Storey(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.iz2use.package$Storey;", depth))
}
var $d_Lreactbuild_format_iz2use_package$Storey = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Storey: 0
}, false, "reactbuild.format.iz2use.package$Storey", {
  Lreactbuild_format_iz2use_package$Storey: 1,
  O: 1,
  Lreactbuild_format_iz2use_package$GenerateGeometry: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Storey.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Storey;
/** @constructor */
function $c_Lreactbuild_geom_Line2(origin, vector) {
  this.Lreactbuild_geom_Line2__f_origin = null;
  this.Lreactbuild_geom_Line2__f_vector = null;
  this.Lreactbuild_geom_Line2__f_origin = origin;
  this.Lreactbuild_geom_Line2__f_vector = vector
}
$c_Lreactbuild_geom_Line2.prototype = new $h_O();
$c_Lreactbuild_geom_Line2.prototype.constructor = $c_Lreactbuild_geom_Line2;
/** @constructor */
function $h_Lreactbuild_geom_Line2() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Line2.prototype = $c_Lreactbuild_geom_Line2.prototype;
$c_Lreactbuild_geom_Line2.prototype.productPrefix__T = (function() {
  return "Line2"
});
$c_Lreactbuild_geom_Line2.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_geom_Line2.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_geom_Line2__f_origin;
      break
    }
    case 1: {
      return this.Lreactbuild_geom_Line2__f_vector;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_geom_Line2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_geom_Line2.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_geom_Line2.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_geom_Line2.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_geom_Line2)) {
    var Line2$1 = $as_Lreactbuild_geom_Line2(x$1);
    var x = this.Lreactbuild_geom_Line2__f_origin;
    var x$2 = $n(Line2$1).Lreactbuild_geom_Line2__f_origin;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_geom_Line2__f_vector;
      var x$4 = $n(Line2$1).Lreactbuild_geom_Line2__f_vector;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        $n(Line2$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_geom_Line2(obj) {
  return (((obj instanceof $c_Lreactbuild_geom_Line2) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.geom.Line2"))
}
function $isArrayOf_Lreactbuild_geom_Line2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_geom_Line2)))
}
function $asArrayOf_Lreactbuild_geom_Line2(obj, depth) {
  return (($isArrayOf_Lreactbuild_geom_Line2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.geom.Line2;", depth))
}
var $d_Lreactbuild_geom_Line2 = new $TypeData().initClass({
  Lreactbuild_geom_Line2: 0
}, false, "reactbuild.geom.Line2", {
  Lreactbuild_geom_Line2: 1,
  O: 1,
  Lreactbuild_geom_Line2Based: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_geom_Line2.prototype.$classData = $d_Lreactbuild_geom_Line2;
/** @constructor */
function $c_Lreactbuild_geom_Vector2(x, y) {
  this.Lreactbuild_geom_Vector2__f_x = 0.0;
  this.Lreactbuild_geom_Vector2__f_y = 0.0;
  this.Lreactbuild_geom_Vector2__f_x = x;
  this.Lreactbuild_geom_Vector2__f_y = y
}
$c_Lreactbuild_geom_Vector2.prototype = new $h_O();
$c_Lreactbuild_geom_Vector2.prototype.constructor = $c_Lreactbuild_geom_Vector2;
/** @constructor */
function $h_Lreactbuild_geom_Vector2() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Vector2.prototype = $c_Lreactbuild_geom_Vector2.prototype;
$c_Lreactbuild_geom_Vector2.prototype.x__D = (function() {
  return this.Lreactbuild_geom_Vector2__f_x
});
$c_Lreactbuild_geom_Vector2.prototype.y__D = (function() {
  return this.Lreactbuild_geom_Vector2__f_y
});
$c_Lreactbuild_geom_Vector2.prototype.toString__T = (function() {
  return (((("v(" + this.Lreactbuild_geom_Vector2__f_x) + ",") + this.Lreactbuild_geom_Vector2__f_y) + ")")
});
$c_Lreactbuild_geom_Vector2.prototype.productPrefix__T = (function() {
  return "Vector2"
});
$c_Lreactbuild_geom_Vector2.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_geom_Vector2.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_geom_Vector2__f_x;
      break
    }
    case 1: {
      return this.Lreactbuild_geom_Vector2__f_y;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_geom_Vector2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_geom_Vector2.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Vector2");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_geom_Vector2__f_x;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_geom_Vector2__f_y;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_geom_Vector2.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_geom_Vector2)) {
    var Vector2$1 = $as_Lreactbuild_geom_Vector2(x$1);
    return ((this.Lreactbuild_geom_Vector2__f_x === $n(Vector2$1).Lreactbuild_geom_Vector2__f_x) && (this.Lreactbuild_geom_Vector2__f_y === $n(Vector2$1).Lreactbuild_geom_Vector2__f_y))
  } else {
    return false
  }
});
function $as_Lreactbuild_geom_Vector2(obj) {
  return (((obj instanceof $c_Lreactbuild_geom_Vector2) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.geom.Vector2"))
}
function $isArrayOf_Lreactbuild_geom_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_geom_Vector2)))
}
function $asArrayOf_Lreactbuild_geom_Vector2(obj, depth) {
  return (($isArrayOf_Lreactbuild_geom_Vector2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.geom.Vector2;", depth))
}
var $d_Lreactbuild_geom_Vector2 = new $TypeData().initClass({
  Lreactbuild_geom_Vector2: 0
}, false, "reactbuild.geom.Vector2", {
  Lreactbuild_geom_Vector2: 1,
  O: 1,
  Lreactbuild_geom_Vector2Based: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_geom_Vector2.prototype.$classData = $d_Lreactbuild_geom_Vector2;
/** @constructor */
function $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt) {
  this.Lreactbuild_math_package$EagerSquareRoot__f_sq = 0.0;
  this.Lreactbuild_math_package$EagerSquareRoot__f_sqrt = 0.0;
  this.Lreactbuild_math_package$EagerSquareRoot__f_sq = sq;
  this.Lreactbuild_math_package$EagerSquareRoot__f_sqrt = sqrt
}
$c_Lreactbuild_math_package$EagerSquareRoot.prototype = new $h_O();
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.constructor = $c_Lreactbuild_math_package$EagerSquareRoot;
/** @constructor */
function $h_Lreactbuild_math_package$EagerSquareRoot() {
  /*<skip>*/
}
$h_Lreactbuild_math_package$EagerSquareRoot.prototype = $c_Lreactbuild_math_package$EagerSquareRoot.prototype;
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.sq__D = (function() {
  return this.Lreactbuild_math_package$EagerSquareRoot__f_sq
});
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.sqrt__D = (function() {
  return this.Lreactbuild_math_package$EagerSquareRoot__f_sqrt
});
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.productPrefix__T = (function() {
  return "EagerSquareRoot"
});
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_math_package$EagerSquareRoot__f_sq;
      break
    }
    case 1: {
      return this.Lreactbuild_math_package$EagerSquareRoot__f_sqrt;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("EagerSquareRoot");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_math_package$EagerSquareRoot__f_sq;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_math_package$EagerSquareRoot__f_sqrt;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_math_package$EagerSquareRoot)) {
    var EagerSquareRoot$1 = $as_Lreactbuild_math_package$EagerSquareRoot(x$1);
    return ((this.Lreactbuild_math_package$EagerSquareRoot__f_sq === $n(EagerSquareRoot$1).Lreactbuild_math_package$EagerSquareRoot__f_sq) && (this.Lreactbuild_math_package$EagerSquareRoot__f_sqrt === $n(EagerSquareRoot$1).Lreactbuild_math_package$EagerSquareRoot__f_sqrt))
  } else {
    return false
  }
});
function $as_Lreactbuild_math_package$EagerSquareRoot(obj) {
  return (((obj instanceof $c_Lreactbuild_math_package$EagerSquareRoot) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.math.package$EagerSquareRoot"))
}
function $isArrayOf_Lreactbuild_math_package$EagerSquareRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_math_package$EagerSquareRoot)))
}
function $asArrayOf_Lreactbuild_math_package$EagerSquareRoot(obj, depth) {
  return (($isArrayOf_Lreactbuild_math_package$EagerSquareRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.math.package$EagerSquareRoot;", depth))
}
var $d_Lreactbuild_math_package$EagerSquareRoot = new $TypeData().initClass({
  Lreactbuild_math_package$EagerSquareRoot: 0
}, false, "reactbuild.math.package$EagerSquareRoot", {
  Lreactbuild_math_package$EagerSquareRoot: 1,
  O: 1,
  Lreactbuild_math_package$SquareRoot: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_math_package$EagerSquareRoot.prototype.$classData = $d_Lreactbuild_math_package$EagerSquareRoot;
/** @constructor */
function $c_Lreactbuild_math_package$LazySquareRoot(sq) {
  this.Lreactbuild_math_package$LazySquareRoot__f_sq = 0.0;
  this.Lreactbuild_math_package$LazySquareRoot__f_sq = sq
}
$c_Lreactbuild_math_package$LazySquareRoot.prototype = new $h_O();
$c_Lreactbuild_math_package$LazySquareRoot.prototype.constructor = $c_Lreactbuild_math_package$LazySquareRoot;
/** @constructor */
function $h_Lreactbuild_math_package$LazySquareRoot() {
  /*<skip>*/
}
$h_Lreactbuild_math_package$LazySquareRoot.prototype = $c_Lreactbuild_math_package$LazySquareRoot.prototype;
$c_Lreactbuild_math_package$LazySquareRoot.prototype.sq__D = (function() {
  return this.Lreactbuild_math_package$LazySquareRoot__f_sq
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.reactbuild$math$LazySquareRoot$$matImpl__D = (function() {
  var this$1 = $n($m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_cache);
  var this$2 = $n($n(this$1.view__scm_ArrayBufferView()).iterator__sc_Iterator());
  _return: {
    var i = 0;
    var dropped = this$2.drop__I__sc_Iterator(0);
    while ($n(dropped).hasNext__Z()) {
      var arg1 = $n(dropped).next__O();
      var x$1 = $as_T2(arg1);
      if (($n(x$1)._1$mcD$sp__D() === this.Lreactbuild_math_package$LazySquareRoot__f_sq)) {
        var x1 = i;
        break _return
      };
      i = ((1 + i) | 0)
    };
    var x1 = (-1)
  };
  if ((x1 === (-1))) {
    var a = this.Lreactbuild_math_package$LazySquareRoot__f_sq;
    var r = $uD(Math.sqrt(a));
    var this$6 = $n($m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_cache);
    if ((this$6.scm_ArrayBuffer__f_size0 > 10)) {
      $n($m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_cache).remove__I__O(0)
    };
    var this$9 = $n($m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_cache);
    var self = this.Lreactbuild_math_package$LazySquareRoot__f_sq;
    var elem = $ct_T2__O__O__(new $c_T2(), self, r);
    this$9.addOne__O__scm_ArrayBuffer(elem);
    return r
  } else {
    var r$2 = $as_T2($n($m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_cache).apply__I__O(x1));
    var this$10 = $n($m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_cache);
    if ((x1 !== (((-1) + this$10.scm_ArrayBuffer__f_size0) | 0))) {
      $n($m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_cache).remove__I__O(x1);
      var this$11 = $n($m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_cache);
      this$11.addOne__O__scm_ArrayBuffer(r$2)
    };
    return $n(r$2)._2$mcD$sp__D()
  }
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.sqrt__D = (function() {
  var x1 = this.Lreactbuild_math_package$LazySquareRoot__f_sq;
  return ((0.0 === x1) ? $m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_zero : ((1.0 === x1) ? $m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_one : ((2.0 === x1) ? $m_Lreactbuild_math_package$SquareRoot$().Lreactbuild_math_package$SquareRoot$__f_two : this.reactbuild$math$LazySquareRoot$$matImpl__D())))
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.productPrefix__T = (function() {
  return "LazySquareRoot"
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_math_package$LazySquareRoot__f_sq : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LazySquareRoot");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_math_package$LazySquareRoot__f_sq;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_math_package$LazySquareRoot)) {
    var LazySquareRoot$1 = $as_Lreactbuild_math_package$LazySquareRoot(x$1);
    return (this.Lreactbuild_math_package$LazySquareRoot__f_sq === $n(LazySquareRoot$1).Lreactbuild_math_package$LazySquareRoot__f_sq)
  } else {
    return false
  }
});
function $as_Lreactbuild_math_package$LazySquareRoot(obj) {
  return (((obj instanceof $c_Lreactbuild_math_package$LazySquareRoot) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.math.package$LazySquareRoot"))
}
function $isArrayOf_Lreactbuild_math_package$LazySquareRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_math_package$LazySquareRoot)))
}
function $asArrayOf_Lreactbuild_math_package$LazySquareRoot(obj, depth) {
  return (($isArrayOf_Lreactbuild_math_package$LazySquareRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.math.package$LazySquareRoot;", depth))
}
var $d_Lreactbuild_math_package$LazySquareRoot = new $TypeData().initClass({
  Lreactbuild_math_package$LazySquareRoot: 0
}, false, "reactbuild.math.package$LazySquareRoot", {
  Lreactbuild_math_package$LazySquareRoot: 1,
  O: 1,
  Lreactbuild_math_package$SquareRoot: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_math_package$LazySquareRoot.prototype.$classData = $d_Lreactbuild_math_package$LazySquareRoot;
/** @constructor */
function $c_Lreactbuild_model_CommunicationTaskAttachment(id, target) {
  this.Lreactbuild_model_CommunicationTaskAttachment__f_id = null;
  this.Lreactbuild_model_CommunicationTaskAttachment__f_target = null;
  this.Lreactbuild_model_CommunicationTaskAttachment__f_id = id;
  this.Lreactbuild_model_CommunicationTaskAttachment__f_target = target
}
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype.constructor = $c_Lreactbuild_model_CommunicationTaskAttachment;
/** @constructor */
function $h_Lreactbuild_model_CommunicationTaskAttachment() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationTaskAttachment.prototype = $c_Lreactbuild_model_CommunicationTaskAttachment.prototype;
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype.productPrefix__T = (function() {
  return "CommunicationTaskAttachment"
});
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_CommunicationTaskAttachment__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_CommunicationTaskAttachment__f_target;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_CommunicationTaskAttachment)) {
    var CommunicationTaskAttachment$1 = $as_Lreactbuild_model_CommunicationTaskAttachment(x$1);
    var x = this.Lreactbuild_model_CommunicationTaskAttachment__f_id;
    var x$2 = $n(CommunicationTaskAttachment$1).Lreactbuild_model_CommunicationTaskAttachment__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_CommunicationTaskAttachment__f_target;
      var x$4 = $n(CommunicationTaskAttachment$1).Lreactbuild_model_CommunicationTaskAttachment__f_target;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_CommunicationTaskAttachment(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CommunicationTaskAttachment) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommunicationTaskAttachment"))
}
function $isArrayOf_Lreactbuild_model_CommunicationTaskAttachment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommunicationTaskAttachment)))
}
function $asArrayOf_Lreactbuild_model_CommunicationTaskAttachment(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommunicationTaskAttachment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommunicationTaskAttachment;", depth))
}
var $d_Lreactbuild_model_CommunicationTaskAttachment = new $TypeData().initClass({
  Lreactbuild_model_CommunicationTaskAttachment: 0
}, false, "reactbuild.model.CommunicationTaskAttachment", {
  Lreactbuild_model_CommunicationTaskAttachment: 1,
  O: 1,
  Lreactbuild_model_TaskAttachment: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationTaskAttachment.prototype.$classData = $d_Lreactbuild_model_CommunicationTaskAttachment;
/** @constructor */
function $c_Lreactbuild_model_CursorLocationUpdate(origin, user, projectRef, x, y) {
  this.Lreactbuild_model_CursorLocationUpdate__f_origin = null;
  this.Lreactbuild_model_CursorLocationUpdate__f_user = null;
  this.Lreactbuild_model_CursorLocationUpdate__f_projectRef = null;
  this.Lreactbuild_model_CursorLocationUpdate__f_x = 0.0;
  this.Lreactbuild_model_CursorLocationUpdate__f_y = 0.0;
  this.Lreactbuild_model_CursorLocationUpdate__f_origin = origin;
  this.Lreactbuild_model_CursorLocationUpdate__f_user = user;
  this.Lreactbuild_model_CursorLocationUpdate__f_projectRef = projectRef;
  this.Lreactbuild_model_CursorLocationUpdate__f_x = x;
  this.Lreactbuild_model_CursorLocationUpdate__f_y = y
}
$c_Lreactbuild_model_CursorLocationUpdate.prototype = new $h_O();
$c_Lreactbuild_model_CursorLocationUpdate.prototype.constructor = $c_Lreactbuild_model_CursorLocationUpdate;
/** @constructor */
function $h_Lreactbuild_model_CursorLocationUpdate() {
  /*<skip>*/
}
$h_Lreactbuild_model_CursorLocationUpdate.prototype = $c_Lreactbuild_model_CursorLocationUpdate.prototype;
$c_Lreactbuild_model_CursorLocationUpdate.prototype.productPrefix__T = (function() {
  return "CursorLocationUpdate"
});
$c_Lreactbuild_model_CursorLocationUpdate.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_model_CursorLocationUpdate.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_CursorLocationUpdate__f_origin;
      break
    }
    case 1: {
      return this.Lreactbuild_model_CursorLocationUpdate__f_user;
      break
    }
    case 2: {
      return this.Lreactbuild_model_CursorLocationUpdate__f_projectRef;
      break
    }
    case 3: {
      return this.Lreactbuild_model_CursorLocationUpdate__f_x;
      break
    }
    case 4: {
      return this.Lreactbuild_model_CursorLocationUpdate__f_y;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_CursorLocationUpdate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CursorLocationUpdate.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("CursorLocationUpdate");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_model_CursorLocationUpdate__f_origin;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_model_CursorLocationUpdate__f_user;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_model_CursorLocationUpdate__f_projectRef;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv = this.Lreactbuild_model_CursorLocationUpdate__f_x;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var dv$1 = this.Lreactbuild_model_CursorLocationUpdate__f_y;
  var data$5 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_model_CursorLocationUpdate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_CursorLocationUpdate.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_CursorLocationUpdate)) {
    var CursorLocationUpdate$1 = $as_Lreactbuild_model_CursorLocationUpdate(x$1);
    if (((this.Lreactbuild_model_CursorLocationUpdate__f_x === $n(CursorLocationUpdate$1).Lreactbuild_model_CursorLocationUpdate__f_x) && (this.Lreactbuild_model_CursorLocationUpdate__f_y === $n(CursorLocationUpdate$1).Lreactbuild_model_CursorLocationUpdate__f_y))) {
      var x = this.Lreactbuild_model_CursorLocationUpdate__f_origin;
      var x$2 = $n(CursorLocationUpdate$1).Lreactbuild_model_CursorLocationUpdate__f_origin;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_model_CursorLocationUpdate__f_user;
        var x$4 = $n(CursorLocationUpdate$1).Lreactbuild_model_CursorLocationUpdate__f_user;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_model_CursorLocationUpdate__f_projectRef;
          var x$6 = $n(CursorLocationUpdate$1).Lreactbuild_model_CursorLocationUpdate__f_projectRef;
          return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_CursorLocationUpdate(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CursorLocationUpdate) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CursorLocationUpdate"))
}
function $isArrayOf_Lreactbuild_model_CursorLocationUpdate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CursorLocationUpdate)))
}
function $asArrayOf_Lreactbuild_model_CursorLocationUpdate(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CursorLocationUpdate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CursorLocationUpdate;", depth))
}
var $d_Lreactbuild_model_CursorLocationUpdate = new $TypeData().initClass({
  Lreactbuild_model_CursorLocationUpdate: 0
}, false, "reactbuild.model.CursorLocationUpdate", {
  Lreactbuild_model_CursorLocationUpdate: 1,
  O: 1,
  Lreactbuild_model_ToClient: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CursorLocationUpdate.prototype.$classData = $d_Lreactbuild_model_CursorLocationUpdate;
/** @constructor */
function $c_Lreactbuild_model_CustomListEntry(_id, created, project, title, terms, duration, from, type) {
  this.Lreactbuild_model_CustomListEntry__f__id = null;
  this.Lreactbuild_model_CustomListEntry__f_created = null;
  this.Lreactbuild_model_CustomListEntry__f_project = null;
  this.Lreactbuild_model_CustomListEntry__f_title = null;
  this.Lreactbuild_model_CustomListEntry__f_terms = null;
  this.Lreactbuild_model_CustomListEntry__f_duration = null;
  this.Lreactbuild_model_CustomListEntry__f_from = null;
  this.Lreactbuild_model_CustomListEntry__f_type = null;
  this.Lreactbuild_model_CustomListEntry__f__id = _id;
  this.Lreactbuild_model_CustomListEntry__f_created = created;
  this.Lreactbuild_model_CustomListEntry__f_project = project;
  this.Lreactbuild_model_CustomListEntry__f_title = title;
  this.Lreactbuild_model_CustomListEntry__f_terms = terms;
  this.Lreactbuild_model_CustomListEntry__f_duration = duration;
  this.Lreactbuild_model_CustomListEntry__f_from = from;
  this.Lreactbuild_model_CustomListEntry__f_type = type
}
$c_Lreactbuild_model_CustomListEntry.prototype = new $h_O();
$c_Lreactbuild_model_CustomListEntry.prototype.constructor = $c_Lreactbuild_model_CustomListEntry;
/** @constructor */
function $h_Lreactbuild_model_CustomListEntry() {
  /*<skip>*/
}
$h_Lreactbuild_model_CustomListEntry.prototype = $c_Lreactbuild_model_CustomListEntry.prototype;
$c_Lreactbuild_model_CustomListEntry.prototype._id__Lreactbuild_common_model_RefTo = (function() {
  return this.Lreactbuild_model_CustomListEntry__f__id
});
$c_Lreactbuild_model_CustomListEntry.prototype.productPrefix__T = (function() {
  return "CustomListEntry"
});
$c_Lreactbuild_model_CustomListEntry.prototype.productArity__I = (function() {
  return 8
});
$c_Lreactbuild_model_CustomListEntry.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_CustomListEntry__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_CustomListEntry__f_created;
      break
    }
    case 2: {
      return this.Lreactbuild_model_CustomListEntry__f_project;
      break
    }
    case 3: {
      return this.Lreactbuild_model_CustomListEntry__f_title;
      break
    }
    case 4: {
      return this.Lreactbuild_model_CustomListEntry__f_terms;
      break
    }
    case 5: {
      return this.Lreactbuild_model_CustomListEntry__f_duration;
      break
    }
    case 6: {
      return this.Lreactbuild_model_CustomListEntry__f_from;
      break
    }
    case 7: {
      return this.Lreactbuild_model_CustomListEntry__f_type;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_CustomListEntry.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CustomListEntry.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_CustomListEntry.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_CustomListEntry.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_CustomListEntry)) {
    var CustomListEntry$1 = $as_Lreactbuild_model_CustomListEntry(x$1);
    var x = this.Lreactbuild_model_CustomListEntry__f__id;
    var x$2 = $n(CustomListEntry$1).Lreactbuild_model_CustomListEntry__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_CustomListEntry__f_created;
      var x$4 = $n(CustomListEntry$1).Lreactbuild_model_CustomListEntry__f_created;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_model_CustomListEntry__f_project;
      var x$6 = $n(CustomListEntry$1).Lreactbuild_model_CustomListEntry__f_project;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var $$x1 = (this.Lreactbuild_model_CustomListEntry__f_title === $n(CustomListEntry$1).Lreactbuild_model_CustomListEntry__f_title)
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_model_CustomListEntry__f_terms;
      var x$8 = $n(CustomListEntry$1).Lreactbuild_model_CustomListEntry__f_terms;
      if ((x$7 === null)) {
        var $$x4 = (x$8 === null)
      } else {
        var this$1 = $n(x$7);
        var $$x4 = $f_sc_Set__equals__O__Z(this$1, x$8)
      };
      if ($$x4) {
        var x$9 = this.Lreactbuild_model_CustomListEntry__f_duration;
        var x$10 = $n(CustomListEntry$1).Lreactbuild_model_CustomListEntry__f_duration;
        var $$x3 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$11 = this.Lreactbuild_model_CustomListEntry__f_from;
        var x$12 = $n(CustomListEntry$1).Lreactbuild_model_CustomListEntry__f_from;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_model_CustomListEntry__f_type;
          var x$14 = $n(CustomListEntry$1).Lreactbuild_model_CustomListEntry__f_type;
          if ((x$13 === null)) {
            return (x$14 === null)
          } else {
            var this$2 = $n(x$13);
            return (this$2 === x$14)
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_CustomListEntry(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CustomListEntry) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CustomListEntry"))
}
function $isArrayOf_Lreactbuild_model_CustomListEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CustomListEntry)))
}
function $asArrayOf_Lreactbuild_model_CustomListEntry(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CustomListEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CustomListEntry;", depth))
}
var $d_Lreactbuild_model_CustomListEntry = new $TypeData().initClass({
  Lreactbuild_model_CustomListEntry: 0
}, false, "reactbuild.model.CustomListEntry", {
  Lreactbuild_model_CustomListEntry: 1,
  O: 1,
  Lreactbuild_model_ListEntry: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CustomListEntry.prototype.$classData = $d_Lreactbuild_model_CustomListEntry;
/** @constructor */
function $c_Lreactbuild_model_DocumentCategory$Certificate$() {
  this.Lreactbuild_model_DocumentCategory__f_code = null;
  $ct_Lreactbuild_model_DocumentCategory__T__(this, "C")
}
$c_Lreactbuild_model_DocumentCategory$Certificate$.prototype = new $h_Lreactbuild_model_DocumentCategory();
$c_Lreactbuild_model_DocumentCategory$Certificate$.prototype.constructor = $c_Lreactbuild_model_DocumentCategory$Certificate$;
/** @constructor */
function $h_Lreactbuild_model_DocumentCategory$Certificate$() {
  /*<skip>*/
}
$h_Lreactbuild_model_DocumentCategory$Certificate$.prototype = $c_Lreactbuild_model_DocumentCategory$Certificate$.prototype;
$c_Lreactbuild_model_DocumentCategory$Certificate$.prototype.productPrefix__T = (function() {
  return "Certificate"
});
$c_Lreactbuild_model_DocumentCategory$Certificate$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_DocumentCategory$Certificate$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_DocumentCategory$Certificate$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_DocumentCategory$Certificate$.prototype.hashCode__I = (function() {
  return (-674698889)
});
$c_Lreactbuild_model_DocumentCategory$Certificate$.prototype.toString__T = (function() {
  return "Certificate"
});
var $d_Lreactbuild_model_DocumentCategory$Certificate$ = new $TypeData().initClass({
  Lreactbuild_model_DocumentCategory$Certificate$: 0
}, false, "reactbuild.model.DocumentCategory$Certificate$", {
  Lreactbuild_model_DocumentCategory$Certificate$: 1,
  Lreactbuild_model_DocumentCategory: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DocumentCategory$Certificate$.prototype.$classData = $d_Lreactbuild_model_DocumentCategory$Certificate$;
var $n_Lreactbuild_model_DocumentCategory$Certificate$;
function $m_Lreactbuild_model_DocumentCategory$Certificate$() {
  if ((!$n_Lreactbuild_model_DocumentCategory$Certificate$)) {
    $n_Lreactbuild_model_DocumentCategory$Certificate$ = new $c_Lreactbuild_model_DocumentCategory$Certificate$()
  };
  return $n_Lreactbuild_model_DocumentCategory$Certificate$
}
/** @constructor */
function $c_Lreactbuild_model_DocumentCategory$DeliveryForm$() {
  this.Lreactbuild_model_DocumentCategory__f_code = null;
  $ct_Lreactbuild_model_DocumentCategory__T__(this, "D")
}
$c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype = new $h_Lreactbuild_model_DocumentCategory();
$c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype.constructor = $c_Lreactbuild_model_DocumentCategory$DeliveryForm$;
/** @constructor */
function $h_Lreactbuild_model_DocumentCategory$DeliveryForm$() {
  /*<skip>*/
}
$h_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype = $c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype;
$c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype.productPrefix__T = (function() {
  return "DeliveryForm"
});
$c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype.hashCode__I = (function() {
  return 845862648
});
$c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype.toString__T = (function() {
  return "DeliveryForm"
});
var $d_Lreactbuild_model_DocumentCategory$DeliveryForm$ = new $TypeData().initClass({
  Lreactbuild_model_DocumentCategory$DeliveryForm$: 0
}, false, "reactbuild.model.DocumentCategory$DeliveryForm$", {
  Lreactbuild_model_DocumentCategory$DeliveryForm$: 1,
  Lreactbuild_model_DocumentCategory: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DocumentCategory$DeliveryForm$.prototype.$classData = $d_Lreactbuild_model_DocumentCategory$DeliveryForm$;
var $n_Lreactbuild_model_DocumentCategory$DeliveryForm$;
function $m_Lreactbuild_model_DocumentCategory$DeliveryForm$() {
  if ((!$n_Lreactbuild_model_DocumentCategory$DeliveryForm$)) {
    $n_Lreactbuild_model_DocumentCategory$DeliveryForm$ = new $c_Lreactbuild_model_DocumentCategory$DeliveryForm$()
  };
  return $n_Lreactbuild_model_DocumentCategory$DeliveryForm$
}
/** @constructor */
function $c_Lreactbuild_model_DocumentCategory$Invoice$() {
  this.Lreactbuild_model_DocumentCategory__f_code = null;
  $ct_Lreactbuild_model_DocumentCategory__T__(this, "I")
}
$c_Lreactbuild_model_DocumentCategory$Invoice$.prototype = new $h_Lreactbuild_model_DocumentCategory();
$c_Lreactbuild_model_DocumentCategory$Invoice$.prototype.constructor = $c_Lreactbuild_model_DocumentCategory$Invoice$;
/** @constructor */
function $h_Lreactbuild_model_DocumentCategory$Invoice$() {
  /*<skip>*/
}
$h_Lreactbuild_model_DocumentCategory$Invoice$.prototype = $c_Lreactbuild_model_DocumentCategory$Invoice$.prototype;
$c_Lreactbuild_model_DocumentCategory$Invoice$.prototype.productPrefix__T = (function() {
  return "Invoice"
});
$c_Lreactbuild_model_DocumentCategory$Invoice$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_DocumentCategory$Invoice$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_DocumentCategory$Invoice$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_DocumentCategory$Invoice$.prototype.hashCode__I = (function() {
  return (-670115059)
});
$c_Lreactbuild_model_DocumentCategory$Invoice$.prototype.toString__T = (function() {
  return "Invoice"
});
var $d_Lreactbuild_model_DocumentCategory$Invoice$ = new $TypeData().initClass({
  Lreactbuild_model_DocumentCategory$Invoice$: 0
}, false, "reactbuild.model.DocumentCategory$Invoice$", {
  Lreactbuild_model_DocumentCategory$Invoice$: 1,
  Lreactbuild_model_DocumentCategory: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DocumentCategory$Invoice$.prototype.$classData = $d_Lreactbuild_model_DocumentCategory$Invoice$;
var $n_Lreactbuild_model_DocumentCategory$Invoice$;
function $m_Lreactbuild_model_DocumentCategory$Invoice$() {
  if ((!$n_Lreactbuild_model_DocumentCategory$Invoice$)) {
    $n_Lreactbuild_model_DocumentCategory$Invoice$ = new $c_Lreactbuild_model_DocumentCategory$Invoice$()
  };
  return $n_Lreactbuild_model_DocumentCategory$Invoice$
}
/** @constructor */
function $c_Lreactbuild_model_DocumentCategory$Order$() {
  this.Lreactbuild_model_DocumentCategory__f_code = null;
  $ct_Lreactbuild_model_DocumentCategory__T__(this, "O")
}
$c_Lreactbuild_model_DocumentCategory$Order$.prototype = new $h_Lreactbuild_model_DocumentCategory();
$c_Lreactbuild_model_DocumentCategory$Order$.prototype.constructor = $c_Lreactbuild_model_DocumentCategory$Order$;
/** @constructor */
function $h_Lreactbuild_model_DocumentCategory$Order$() {
  /*<skip>*/
}
$h_Lreactbuild_model_DocumentCategory$Order$.prototype = $c_Lreactbuild_model_DocumentCategory$Order$.prototype;
$c_Lreactbuild_model_DocumentCategory$Order$.prototype.productPrefix__T = (function() {
  return "Order"
});
$c_Lreactbuild_model_DocumentCategory$Order$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_DocumentCategory$Order$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_DocumentCategory$Order$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_DocumentCategory$Order$.prototype.hashCode__I = (function() {
  return 76453678
});
$c_Lreactbuild_model_DocumentCategory$Order$.prototype.toString__T = (function() {
  return "Order"
});
var $d_Lreactbuild_model_DocumentCategory$Order$ = new $TypeData().initClass({
  Lreactbuild_model_DocumentCategory$Order$: 0
}, false, "reactbuild.model.DocumentCategory$Order$", {
  Lreactbuild_model_DocumentCategory$Order$: 1,
  Lreactbuild_model_DocumentCategory: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DocumentCategory$Order$.prototype.$classData = $d_Lreactbuild_model_DocumentCategory$Order$;
var $n_Lreactbuild_model_DocumentCategory$Order$;
function $m_Lreactbuild_model_DocumentCategory$Order$() {
  if ((!$n_Lreactbuild_model_DocumentCategory$Order$)) {
    $n_Lreactbuild_model_DocumentCategory$Order$ = new $c_Lreactbuild_model_DocumentCategory$Order$()
  };
  return $n_Lreactbuild_model_DocumentCategory$Order$
}
/** @constructor */
function $c_Lreactbuild_model_DocumentCategory$PriceOffer$() {
  this.Lreactbuild_model_DocumentCategory__f_code = null;
  $ct_Lreactbuild_model_DocumentCategory__T__(this, "P")
}
$c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype = new $h_Lreactbuild_model_DocumentCategory();
$c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype.constructor = $c_Lreactbuild_model_DocumentCategory$PriceOffer$;
/** @constructor */
function $h_Lreactbuild_model_DocumentCategory$PriceOffer$() {
  /*<skip>*/
}
$h_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype = $c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype;
$c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype.productPrefix__T = (function() {
  return "PriceOffer"
});
$c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype.hashCode__I = (function() {
  return 515095219
});
$c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype.toString__T = (function() {
  return "PriceOffer"
});
var $d_Lreactbuild_model_DocumentCategory$PriceOffer$ = new $TypeData().initClass({
  Lreactbuild_model_DocumentCategory$PriceOffer$: 0
}, false, "reactbuild.model.DocumentCategory$PriceOffer$", {
  Lreactbuild_model_DocumentCategory$PriceOffer$: 1,
  Lreactbuild_model_DocumentCategory: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DocumentCategory$PriceOffer$.prototype.$classData = $d_Lreactbuild_model_DocumentCategory$PriceOffer$;
var $n_Lreactbuild_model_DocumentCategory$PriceOffer$;
function $m_Lreactbuild_model_DocumentCategory$PriceOffer$() {
  if ((!$n_Lreactbuild_model_DocumentCategory$PriceOffer$)) {
    $n_Lreactbuild_model_DocumentCategory$PriceOffer$ = new $c_Lreactbuild_model_DocumentCategory$PriceOffer$()
  };
  return $n_Lreactbuild_model_DocumentCategory$PriceOffer$
}
/** @constructor */
function $c_Lreactbuild_model_DocumentCategory$Quote$() {
  this.Lreactbuild_model_DocumentCategory__f_code = null;
  $ct_Lreactbuild_model_DocumentCategory__T__(this, "Q")
}
$c_Lreactbuild_model_DocumentCategory$Quote$.prototype = new $h_Lreactbuild_model_DocumentCategory();
$c_Lreactbuild_model_DocumentCategory$Quote$.prototype.constructor = $c_Lreactbuild_model_DocumentCategory$Quote$;
/** @constructor */
function $h_Lreactbuild_model_DocumentCategory$Quote$() {
  /*<skip>*/
}
$h_Lreactbuild_model_DocumentCategory$Quote$.prototype = $c_Lreactbuild_model_DocumentCategory$Quote$.prototype;
$c_Lreactbuild_model_DocumentCategory$Quote$.prototype.productPrefix__T = (function() {
  return "Quote"
});
$c_Lreactbuild_model_DocumentCategory$Quote$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_DocumentCategory$Quote$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_DocumentCategory$Quote$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_DocumentCategory$Quote$.prototype.hashCode__I = (function() {
  return 78401116
});
$c_Lreactbuild_model_DocumentCategory$Quote$.prototype.toString__T = (function() {
  return "Quote"
});
var $d_Lreactbuild_model_DocumentCategory$Quote$ = new $TypeData().initClass({
  Lreactbuild_model_DocumentCategory$Quote$: 0
}, false, "reactbuild.model.DocumentCategory$Quote$", {
  Lreactbuild_model_DocumentCategory$Quote$: 1,
  Lreactbuild_model_DocumentCategory: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DocumentCategory$Quote$.prototype.$classData = $d_Lreactbuild_model_DocumentCategory$Quote$;
var $n_Lreactbuild_model_DocumentCategory$Quote$;
function $m_Lreactbuild_model_DocumentCategory$Quote$() {
  if ((!$n_Lreactbuild_model_DocumentCategory$Quote$)) {
    $n_Lreactbuild_model_DocumentCategory$Quote$ = new $c_Lreactbuild_model_DocumentCategory$Quote$()
  };
  return $n_Lreactbuild_model_DocumentCategory$Quote$
}
/** @constructor */
function $c_Lreactbuild_model_DocumentCategory$Statement$() {
  this.Lreactbuild_model_DocumentCategory__f_code = null;
  $ct_Lreactbuild_model_DocumentCategory__T__(this, "S")
}
$c_Lreactbuild_model_DocumentCategory$Statement$.prototype = new $h_Lreactbuild_model_DocumentCategory();
$c_Lreactbuild_model_DocumentCategory$Statement$.prototype.constructor = $c_Lreactbuild_model_DocumentCategory$Statement$;
/** @constructor */
function $h_Lreactbuild_model_DocumentCategory$Statement$() {
  /*<skip>*/
}
$h_Lreactbuild_model_DocumentCategory$Statement$.prototype = $c_Lreactbuild_model_DocumentCategory$Statement$.prototype;
$c_Lreactbuild_model_DocumentCategory$Statement$.prototype.productPrefix__T = (function() {
  return "Statement"
});
$c_Lreactbuild_model_DocumentCategory$Statement$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_DocumentCategory$Statement$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_DocumentCategory$Statement$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_DocumentCategory$Statement$.prototype.hashCode__I = (function() {
  return (-81180337)
});
$c_Lreactbuild_model_DocumentCategory$Statement$.prototype.toString__T = (function() {
  return "Statement"
});
var $d_Lreactbuild_model_DocumentCategory$Statement$ = new $TypeData().initClass({
  Lreactbuild_model_DocumentCategory$Statement$: 0
}, false, "reactbuild.model.DocumentCategory$Statement$", {
  Lreactbuild_model_DocumentCategory$Statement$: 1,
  Lreactbuild_model_DocumentCategory: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DocumentCategory$Statement$.prototype.$classData = $d_Lreactbuild_model_DocumentCategory$Statement$;
var $n_Lreactbuild_model_DocumentCategory$Statement$;
function $m_Lreactbuild_model_DocumentCategory$Statement$() {
  if ((!$n_Lreactbuild_model_DocumentCategory$Statement$)) {
    $n_Lreactbuild_model_DocumentCategory$Statement$ = new $c_Lreactbuild_model_DocumentCategory$Statement$()
  };
  return $n_Lreactbuild_model_DocumentCategory$Statement$
}
/** @constructor */
function $c_Lreactbuild_model_FileTaskAttachment(id, target) {
  this.Lreactbuild_model_FileTaskAttachment__f_id = null;
  this.Lreactbuild_model_FileTaskAttachment__f_target = null;
  this.Lreactbuild_model_FileTaskAttachment__f_id = id;
  this.Lreactbuild_model_FileTaskAttachment__f_target = target
}
$c_Lreactbuild_model_FileTaskAttachment.prototype = new $h_O();
$c_Lreactbuild_model_FileTaskAttachment.prototype.constructor = $c_Lreactbuild_model_FileTaskAttachment;
/** @constructor */
function $h_Lreactbuild_model_FileTaskAttachment() {
  /*<skip>*/
}
$h_Lreactbuild_model_FileTaskAttachment.prototype = $c_Lreactbuild_model_FileTaskAttachment.prototype;
$c_Lreactbuild_model_FileTaskAttachment.prototype.productPrefix__T = (function() {
  return "FileTaskAttachment"
});
$c_Lreactbuild_model_FileTaskAttachment.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_FileTaskAttachment.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_FileTaskAttachment__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_FileTaskAttachment__f_target;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_FileTaskAttachment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_FileTaskAttachment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_FileTaskAttachment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_FileTaskAttachment.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_FileTaskAttachment)) {
    var FileTaskAttachment$1 = $as_Lreactbuild_model_FileTaskAttachment(x$1);
    var x = this.Lreactbuild_model_FileTaskAttachment__f_id;
    var x$2 = $n(FileTaskAttachment$1).Lreactbuild_model_FileTaskAttachment__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_FileTaskAttachment__f_target;
      var x$4 = $n(FileTaskAttachment$1).Lreactbuild_model_FileTaskAttachment__f_target;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_FileTaskAttachment(obj) {
  return (((obj instanceof $c_Lreactbuild_model_FileTaskAttachment) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.FileTaskAttachment"))
}
function $isArrayOf_Lreactbuild_model_FileTaskAttachment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_FileTaskAttachment)))
}
function $asArrayOf_Lreactbuild_model_FileTaskAttachment(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_FileTaskAttachment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.FileTaskAttachment;", depth))
}
var $d_Lreactbuild_model_FileTaskAttachment = new $TypeData().initClass({
  Lreactbuild_model_FileTaskAttachment: 0
}, false, "reactbuild.model.FileTaskAttachment", {
  Lreactbuild_model_FileTaskAttachment: 1,
  O: 1,
  Lreactbuild_model_TaskAttachment: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_FileTaskAttachment.prototype.$classData = $d_Lreactbuild_model_FileTaskAttachment;
/** @constructor */
function $c_Lreactbuild_model_HtmlCommunicationBody(htmlSource) {
  this.Lreactbuild_model_HtmlCommunicationBody__f_htmlSource = null;
  this.Lreactbuild_model_HtmlCommunicationBody__f_htmlSource = htmlSource
}
$c_Lreactbuild_model_HtmlCommunicationBody.prototype = new $h_O();
$c_Lreactbuild_model_HtmlCommunicationBody.prototype.constructor = $c_Lreactbuild_model_HtmlCommunicationBody;
/** @constructor */
function $h_Lreactbuild_model_HtmlCommunicationBody() {
  /*<skip>*/
}
$h_Lreactbuild_model_HtmlCommunicationBody.prototype = $c_Lreactbuild_model_HtmlCommunicationBody.prototype;
$c_Lreactbuild_model_HtmlCommunicationBody.prototype.productPrefix__T = (function() {
  return "HtmlCommunicationBody"
});
$c_Lreactbuild_model_HtmlCommunicationBody.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_HtmlCommunicationBody.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_HtmlCommunicationBody__f_htmlSource : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_HtmlCommunicationBody.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_HtmlCommunicationBody.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_HtmlCommunicationBody.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_HtmlCommunicationBody.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_HtmlCommunicationBody)) {
    var HtmlCommunicationBody$1 = $as_Lreactbuild_model_HtmlCommunicationBody(x$1);
    return (this.Lreactbuild_model_HtmlCommunicationBody__f_htmlSource === $n(HtmlCommunicationBody$1).Lreactbuild_model_HtmlCommunicationBody__f_htmlSource)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_HtmlCommunicationBody(obj) {
  return (((obj instanceof $c_Lreactbuild_model_HtmlCommunicationBody) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.HtmlCommunicationBody"))
}
function $isArrayOf_Lreactbuild_model_HtmlCommunicationBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_HtmlCommunicationBody)))
}
function $asArrayOf_Lreactbuild_model_HtmlCommunicationBody(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_HtmlCommunicationBody(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.HtmlCommunicationBody;", depth))
}
var $d_Lreactbuild_model_HtmlCommunicationBody = new $TypeData().initClass({
  Lreactbuild_model_HtmlCommunicationBody: 0
}, false, "reactbuild.model.HtmlCommunicationBody", {
  Lreactbuild_model_HtmlCommunicationBody: 1,
  O: 1,
  Lreactbuild_model_CommunicationBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_HtmlCommunicationBody.prototype.$classData = $d_Lreactbuild_model_HtmlCommunicationBody;
/** @constructor */
function $c_Lreactbuild_model_InstanceListEntry(templateEntry, _id, created, project, duration) {
  this.Lreactbuild_model_InstanceListEntry__f_templateEntry = null;
  this.Lreactbuild_model_InstanceListEntry__f__id = null;
  this.Lreactbuild_model_InstanceListEntry__f_created = null;
  this.Lreactbuild_model_InstanceListEntry__f_project = null;
  this.Lreactbuild_model_InstanceListEntry__f_duration = null;
  this.Lreactbuild_model_InstanceListEntry__f_templateEntry = templateEntry;
  this.Lreactbuild_model_InstanceListEntry__f__id = _id;
  this.Lreactbuild_model_InstanceListEntry__f_created = created;
  this.Lreactbuild_model_InstanceListEntry__f_project = project;
  this.Lreactbuild_model_InstanceListEntry__f_duration = duration
}
$c_Lreactbuild_model_InstanceListEntry.prototype = new $h_O();
$c_Lreactbuild_model_InstanceListEntry.prototype.constructor = $c_Lreactbuild_model_InstanceListEntry;
/** @constructor */
function $h_Lreactbuild_model_InstanceListEntry() {
  /*<skip>*/
}
$h_Lreactbuild_model_InstanceListEntry.prototype = $c_Lreactbuild_model_InstanceListEntry.prototype;
$c_Lreactbuild_model_InstanceListEntry.prototype._id__Lreactbuild_common_model_RefTo = (function() {
  return this.Lreactbuild_model_InstanceListEntry__f__id
});
$c_Lreactbuild_model_InstanceListEntry.prototype.productPrefix__T = (function() {
  return "InstanceListEntry"
});
$c_Lreactbuild_model_InstanceListEntry.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_model_InstanceListEntry.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_InstanceListEntry__f_templateEntry;
      break
    }
    case 1: {
      return this.Lreactbuild_model_InstanceListEntry__f__id;
      break
    }
    case 2: {
      return this.Lreactbuild_model_InstanceListEntry__f_created;
      break
    }
    case 3: {
      return this.Lreactbuild_model_InstanceListEntry__f_project;
      break
    }
    case 4: {
      return this.Lreactbuild_model_InstanceListEntry__f_duration;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_InstanceListEntry.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_InstanceListEntry.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_InstanceListEntry.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_InstanceListEntry.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_InstanceListEntry)) {
    var InstanceListEntry$1 = $as_Lreactbuild_model_InstanceListEntry(x$1);
    var x = this.Lreactbuild_model_InstanceListEntry__f_templateEntry;
    var x$2 = $n(InstanceListEntry$1).Lreactbuild_model_InstanceListEntry__f_templateEntry;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_InstanceListEntry__f__id;
      var x$4 = $n(InstanceListEntry$1).Lreactbuild_model_InstanceListEntry__f__id;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_model_InstanceListEntry__f_created;
      var x$6 = $n(InstanceListEntry$1).Lreactbuild_model_InstanceListEntry__f_created;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_InstanceListEntry__f_project;
        var x$8 = $n(InstanceListEntry$1).Lreactbuild_model_InstanceListEntry__f_project;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_model_InstanceListEntry__f_duration;
          var x$10 = $n(InstanceListEntry$1).Lreactbuild_model_InstanceListEntry__f_duration;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_InstanceListEntry(obj) {
  return (((obj instanceof $c_Lreactbuild_model_InstanceListEntry) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.InstanceListEntry"))
}
function $isArrayOf_Lreactbuild_model_InstanceListEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_InstanceListEntry)))
}
function $asArrayOf_Lreactbuild_model_InstanceListEntry(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_InstanceListEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.InstanceListEntry;", depth))
}
var $d_Lreactbuild_model_InstanceListEntry = new $TypeData().initClass({
  Lreactbuild_model_InstanceListEntry: 0
}, false, "reactbuild.model.InstanceListEntry", {
  Lreactbuild_model_InstanceListEntry: 1,
  O: 1,
  Lreactbuild_model_ListEntry: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_InstanceListEntry.prototype.$classData = $d_Lreactbuild_model_InstanceListEntry;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$ChangeTitle(previousTitle) {
  this.Lreactbuild_model_ListEntryEventBody$ChangeTitle__f_previousTitle = null;
  this.Lreactbuild_model_ListEntryEventBody$ChangeTitle__f_previousTitle = previousTitle
}
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$ChangeTitle;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$ChangeTitle() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype = $c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype;
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifFound).apply__O__O(this.Lreactbuild_model_ListEntryEventBody$ChangeTitle__f_previousTitle)
});
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.productPrefix__T = (function() {
  return "ChangeTitle"
});
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_ListEntryEventBody$ChangeTitle__f_previousTitle : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListEntryEventBody$ChangeTitle)) {
    var ChangeTitle$1 = $as_Lreactbuild_model_ListEntryEventBody$ChangeTitle(x$1);
    return (this.Lreactbuild_model_ListEntryEventBody$ChangeTitle__f_previousTitle === $n(ChangeTitle$1).Lreactbuild_model_ListEntryEventBody$ChangeTitle__f_previousTitle)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListEntryEventBody$ChangeTitle(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$ChangeTitle) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$ChangeTitle"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$ChangeTitle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$ChangeTitle)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$ChangeTitle(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$ChangeTitle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$ChangeTitle;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$ChangeTitle = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$ChangeTitle: 0
}, false, "reactbuild.model.ListEntryEventBody$ChangeTitle", {
  Lreactbuild_model_ListEntryEventBody$ChangeTitle: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$ChangeTitle.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$ChangeTitle;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Comment(comment) {
  this.Lreactbuild_model_ListEntryEventBody$Comment__f_comment = null;
  this.Lreactbuild_model_ListEntryEventBody$Comment__f_comment = comment
}
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Comment;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Comment() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Comment.prototype = $c_Lreactbuild_model_ListEntryEventBody$Comment.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifFound).apply__O__O(this.Lreactbuild_model_ListEntryEventBody$Comment__f_comment)
});
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.productPrefix__T = (function() {
  return "Comment"
});
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_ListEntryEventBody$Comment__f_comment : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListEntryEventBody$Comment)) {
    var Comment$1 = $as_Lreactbuild_model_ListEntryEventBody$Comment(x$1);
    return (this.Lreactbuild_model_ListEntryEventBody$Comment__f_comment === $n(Comment$1).Lreactbuild_model_ListEntryEventBody$Comment__f_comment)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListEntryEventBody$Comment(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Comment) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Comment"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Comment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Comment)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Comment(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Comment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Comment;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Comment = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Comment: 0
}, false, "reactbuild.model.ListEntryEventBody$Comment", {
  Lreactbuild_model_ListEntryEventBody$Comment: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Comment.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Comment;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(comment) {
  this.Lreactbuild_model_ListEntryEventBody$NeedMoreDetails__f_comment = null;
  this.Lreactbuild_model_ListEntryEventBody$NeedMoreDetails__f_comment = comment
}
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype = $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype;
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifFound).apply__O__O(this.Lreactbuild_model_ListEntryEventBody$NeedMoreDetails__f_comment)
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.productPrefix__T = (function() {
  return "NeedMoreDetails"
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_ListEntryEventBody$NeedMoreDetails__f_comment : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails)) {
    var NeedMoreDetails$1 = $as_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(x$1);
    return (this.Lreactbuild_model_ListEntryEventBody$NeedMoreDetails__f_comment === $n(NeedMoreDetails$1).Lreactbuild_model_ListEntryEventBody$NeedMoreDetails__f_comment)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$NeedMoreDetails"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$NeedMoreDetails)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$NeedMoreDetails;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$NeedMoreDetails: 0
}, false, "reactbuild.model.ListEntryEventBody$NeedMoreDetails", {
  Lreactbuild_model_ListEntryEventBody$NeedMoreDetails: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$TermAdded(term) {
  this.Lreactbuild_model_ListEntryEventBody$TermAdded__f_term = null;
  this.Lreactbuild_model_ListEntryEventBody$TermAdded__f_term = term
}
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$TermAdded;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$TermAdded() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype = $c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype;
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.productPrefix__T = (function() {
  return "TermAdded"
});
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_ListEntryEventBody$TermAdded__f_term : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListEntryEventBody$TermAdded)) {
    var TermAdded$1 = $as_Lreactbuild_model_ListEntryEventBody$TermAdded(x$1);
    var x = this.Lreactbuild_model_ListEntryEventBody$TermAdded__f_term;
    var x$2 = $n(TermAdded$1).Lreactbuild_model_ListEntryEventBody$TermAdded__f_term;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListEntryEventBody$TermAdded(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$TermAdded) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$TermAdded"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$TermAdded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$TermAdded)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$TermAdded(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$TermAdded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$TermAdded;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$TermAdded = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$TermAdded: 0
}, false, "reactbuild.model.ListEntryEventBody$TermAdded", {
  Lreactbuild_model_ListEntryEventBody$TermAdded: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$TermAdded.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$TermAdded;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$TermRemoved(term) {
  this.Lreactbuild_model_ListEntryEventBody$TermRemoved__f_term = null;
  this.Lreactbuild_model_ListEntryEventBody$TermRemoved__f_term = term
}
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$TermRemoved;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$TermRemoved() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype = $c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype;
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.productPrefix__T = (function() {
  return "TermRemoved"
});
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_ListEntryEventBody$TermRemoved__f_term : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListEntryEventBody$TermRemoved)) {
    var TermRemoved$1 = $as_Lreactbuild_model_ListEntryEventBody$TermRemoved(x$1);
    var x = this.Lreactbuild_model_ListEntryEventBody$TermRemoved__f_term;
    var x$2 = $n(TermRemoved$1).Lreactbuild_model_ListEntryEventBody$TermRemoved__f_term;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListEntryEventBody$TermRemoved(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$TermRemoved) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$TermRemoved"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$TermRemoved(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$TermRemoved)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$TermRemoved(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$TermRemoved(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$TermRemoved;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$TermRemoved = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$TermRemoved: 0
}, false, "reactbuild.model.ListEntryEventBody$TermRemoved", {
  Lreactbuild_model_ListEntryEventBody$TermRemoved: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$TermRemoved.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$TermRemoved;
/** @constructor */
function $c_Lreactbuild_model_ListEntryType$CheckList$() {
  this.Lreactbuild_model_ListEntryType$CheckList$__f_actions = null;
  $n_Lreactbuild_model_ListEntryType$CheckList$ = this;
  var this$5 = $m_sci_ListSet$();
  var array = [$d_Lreactbuild_model_ListEntryEventBody$NonCompliant.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$NotApplicable.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$Compliant$.getClassOf()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_model_ListEntryType$CheckList$__f_actions = this$5.from__sc_IterableOnce__sci_ListSet(elems)
}
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype.constructor = $c_Lreactbuild_model_ListEntryType$CheckList$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryType$CheckList$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryType$CheckList$.prototype = $c_Lreactbuild_model_ListEntryType$CheckList$.prototype;
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype.actions__sci_ListSet = (function() {
  return this.Lreactbuild_model_ListEntryType$CheckList$__f_actions
});
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype.productPrefix__T = (function() {
  return "CheckList"
});
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype.hashCode__I = (function() {
  return (-1892653658)
});
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype.toString__T = (function() {
  return "CheckList"
});
function $as_Lreactbuild_model_ListEntryType$CheckList$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryType$CheckList$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryType$CheckList$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryType$CheckList$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryType$CheckList$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryType$CheckList$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryType$CheckList$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryType$CheckList$;", depth))
}
var $d_Lreactbuild_model_ListEntryType$CheckList$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryType$CheckList$: 0
}, false, "reactbuild.model.ListEntryType$CheckList$", {
  Lreactbuild_model_ListEntryType$CheckList$: 1,
  O: 1,
  Lreactbuild_model_ListEntryType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryType$CheckList$.prototype.$classData = $d_Lreactbuild_model_ListEntryType$CheckList$;
var $n_Lreactbuild_model_ListEntryType$CheckList$;
function $m_Lreactbuild_model_ListEntryType$CheckList$() {
  if ((!$n_Lreactbuild_model_ListEntryType$CheckList$)) {
    $n_Lreactbuild_model_ListEntryType$CheckList$ = new $c_Lreactbuild_model_ListEntryType$CheckList$()
  };
  return $n_Lreactbuild_model_ListEntryType$CheckList$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryType$Guideline$() {
  this.Lreactbuild_model_ListEntryType$Guideline$__f_actions = null;
  $n_Lreactbuild_model_ListEntryType$Guideline$ = this;
  var this$6 = $m_sci_ListSet$();
  var array = [$d_Lreactbuild_model_ListEntryEventBody$Ignored$.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$NotApplicable.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$Followed$.getClassOf()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_model_ListEntryType$Guideline$__f_actions = this$6.from__sc_IterableOnce__sci_ListSet(elems)
}
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype.constructor = $c_Lreactbuild_model_ListEntryType$Guideline$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryType$Guideline$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryType$Guideline$.prototype = $c_Lreactbuild_model_ListEntryType$Guideline$.prototype;
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype.actions__sci_ListSet = (function() {
  return this.Lreactbuild_model_ListEntryType$Guideline$__f_actions
});
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype.productPrefix__T = (function() {
  return "Guideline"
});
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype.hashCode__I = (function() {
  return (-71750448)
});
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype.toString__T = (function() {
  return "Guideline"
});
function $as_Lreactbuild_model_ListEntryType$Guideline$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryType$Guideline$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryType$Guideline$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryType$Guideline$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryType$Guideline$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryType$Guideline$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryType$Guideline$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryType$Guideline$;", depth))
}
var $d_Lreactbuild_model_ListEntryType$Guideline$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryType$Guideline$: 0
}, false, "reactbuild.model.ListEntryType$Guideline$", {
  Lreactbuild_model_ListEntryType$Guideline$: 1,
  O: 1,
  Lreactbuild_model_ListEntryType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryType$Guideline$.prototype.$classData = $d_Lreactbuild_model_ListEntryType$Guideline$;
var $n_Lreactbuild_model_ListEntryType$Guideline$;
function $m_Lreactbuild_model_ListEntryType$Guideline$() {
  if ((!$n_Lreactbuild_model_ListEntryType$Guideline$)) {
    $n_Lreactbuild_model_ListEntryType$Guideline$ = new $c_Lreactbuild_model_ListEntryType$Guideline$()
  };
  return $n_Lreactbuild_model_ListEntryType$Guideline$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryType$Issue$() {
  this.Lreactbuild_model_ListEntryType$Issue$__f_actions = null;
  $n_Lreactbuild_model_ListEntryType$Issue$ = this;
  var this$6 = $m_sci_ListSet$();
  var array = [$d_Lreactbuild_model_ListEntryEventBody$Read$.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$Approved$.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$Rejected.getClassOf()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_model_ListEntryType$Issue$__f_actions = this$6.from__sc_IterableOnce__sci_ListSet(elems)
}
$c_Lreactbuild_model_ListEntryType$Issue$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryType$Issue$.prototype.constructor = $c_Lreactbuild_model_ListEntryType$Issue$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryType$Issue$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryType$Issue$.prototype = $c_Lreactbuild_model_ListEntryType$Issue$.prototype;
$c_Lreactbuild_model_ListEntryType$Issue$.prototype.actions__sci_ListSet = (function() {
  return this.Lreactbuild_model_ListEntryType$Issue$__f_actions
});
$c_Lreactbuild_model_ListEntryType$Issue$.prototype.productPrefix__T = (function() {
  return "Issue"
});
$c_Lreactbuild_model_ListEntryType$Issue$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryType$Issue$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryType$Issue$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryType$Issue$.prototype.hashCode__I = (function() {
  return 70957241
});
$c_Lreactbuild_model_ListEntryType$Issue$.prototype.toString__T = (function() {
  return "Issue"
});
function $as_Lreactbuild_model_ListEntryType$Issue$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryType$Issue$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryType$Issue$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryType$Issue$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryType$Issue$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryType$Issue$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryType$Issue$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryType$Issue$;", depth))
}
var $d_Lreactbuild_model_ListEntryType$Issue$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryType$Issue$: 0
}, false, "reactbuild.model.ListEntryType$Issue$", {
  Lreactbuild_model_ListEntryType$Issue$: 1,
  O: 1,
  Lreactbuild_model_ListEntryType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryType$Issue$.prototype.$classData = $d_Lreactbuild_model_ListEntryType$Issue$;
var $n_Lreactbuild_model_ListEntryType$Issue$;
function $m_Lreactbuild_model_ListEntryType$Issue$() {
  if ((!$n_Lreactbuild_model_ListEntryType$Issue$)) {
    $n_Lreactbuild_model_ListEntryType$Issue$ = new $c_Lreactbuild_model_ListEntryType$Issue$()
  };
  return $n_Lreactbuild_model_ListEntryType$Issue$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryType$Supply$() {
  this.Lreactbuild_model_ListEntryType$Supply$__f_actions = null;
  $n_Lreactbuild_model_ListEntryType$Supply$ = this;
  var this$9 = $m_sci_ListSet$();
  var array = [$d_Lreactbuild_model_ListEntryEventBody$Ordered$.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$Shipped$.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$Received$.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$Pickup$.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$InStock$.getClassOf()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_model_ListEntryType$Supply$__f_actions = this$9.from__sc_IterableOnce__sci_ListSet(elems)
}
$c_Lreactbuild_model_ListEntryType$Supply$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryType$Supply$.prototype.constructor = $c_Lreactbuild_model_ListEntryType$Supply$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryType$Supply$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryType$Supply$.prototype = $c_Lreactbuild_model_ListEntryType$Supply$.prototype;
$c_Lreactbuild_model_ListEntryType$Supply$.prototype.actions__sci_ListSet = (function() {
  return this.Lreactbuild_model_ListEntryType$Supply$__f_actions
});
$c_Lreactbuild_model_ListEntryType$Supply$.prototype.productPrefix__T = (function() {
  return "Supply"
});
$c_Lreactbuild_model_ListEntryType$Supply$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryType$Supply$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryType$Supply$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryType$Supply$.prototype.hashCode__I = (function() {
  return (-1807248113)
});
$c_Lreactbuild_model_ListEntryType$Supply$.prototype.toString__T = (function() {
  return "Supply"
});
function $as_Lreactbuild_model_ListEntryType$Supply$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryType$Supply$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryType$Supply$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryType$Supply$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryType$Supply$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryType$Supply$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryType$Supply$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryType$Supply$;", depth))
}
var $d_Lreactbuild_model_ListEntryType$Supply$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryType$Supply$: 0
}, false, "reactbuild.model.ListEntryType$Supply$", {
  Lreactbuild_model_ListEntryType$Supply$: 1,
  O: 1,
  Lreactbuild_model_ListEntryType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryType$Supply$.prototype.$classData = $d_Lreactbuild_model_ListEntryType$Supply$;
var $n_Lreactbuild_model_ListEntryType$Supply$;
function $m_Lreactbuild_model_ListEntryType$Supply$() {
  if ((!$n_Lreactbuild_model_ListEntryType$Supply$)) {
    $n_Lreactbuild_model_ListEntryType$Supply$ = new $c_Lreactbuild_model_ListEntryType$Supply$()
  };
  return $n_Lreactbuild_model_ListEntryType$Supply$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryType$TaskList$() {
  this.Lreactbuild_model_ListEntryType$TaskList$__f_actions = null;
  $n_Lreactbuild_model_ListEntryType$TaskList$ = this;
  var this$6 = $m_sci_ListSet$();
  var array = [$d_Lreactbuild_model_ListEntryEventBody$Pending$.getClassOf(), $d_Lreactbuild_model_ListEntryEventBody$Done$.getClassOf()];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_model_ListEntryType$TaskList$__f_actions = this$6.from__sc_IterableOnce__sci_ListSet(elems)
}
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype.constructor = $c_Lreactbuild_model_ListEntryType$TaskList$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryType$TaskList$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryType$TaskList$.prototype = $c_Lreactbuild_model_ListEntryType$TaskList$.prototype;
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype.actions__sci_ListSet = (function() {
  return this.Lreactbuild_model_ListEntryType$TaskList$__f_actions
});
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype.productPrefix__T = (function() {
  return "TaskList"
});
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype.hashCode__I = (function() {
  return (-345738269)
});
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype.toString__T = (function() {
  return "TaskList"
});
function $as_Lreactbuild_model_ListEntryType$TaskList$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryType$TaskList$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryType$TaskList$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryType$TaskList$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryType$TaskList$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryType$TaskList$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryType$TaskList$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryType$TaskList$;", depth))
}
var $d_Lreactbuild_model_ListEntryType$TaskList$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryType$TaskList$: 0
}, false, "reactbuild.model.ListEntryType$TaskList$", {
  Lreactbuild_model_ListEntryType$TaskList$: 1,
  O: 1,
  Lreactbuild_model_ListEntryType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryType$TaskList$.prototype.$classData = $d_Lreactbuild_model_ListEntryType$TaskList$;
var $n_Lreactbuild_model_ListEntryType$TaskList$;
function $m_Lreactbuild_model_ListEntryType$TaskList$() {
  if ((!$n_Lreactbuild_model_ListEntryType$TaskList$)) {
    $n_Lreactbuild_model_ListEntryType$TaskList$ = new $c_Lreactbuild_model_ListEntryType$TaskList$()
  };
  return $n_Lreactbuild_model_ListEntryType$TaskList$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryValidation$MediaMandatory$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype.constructor = $c_Lreactbuild_model_ListEntryValidation$MediaMandatory$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryValidation$MediaMandatory$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype = $c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype;
$c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype.productPrefix__T = (function() {
  return "MediaMandatory"
});
$c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype.hashCode__I = (function() {
  return 208914037
});
$c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype.toString__T = (function() {
  return "MediaMandatory"
});
function $as_Lreactbuild_model_ListEntryValidation$MediaMandatory$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryValidation$MediaMandatory$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryValidation$MediaMandatory$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryValidation$MediaMandatory$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryValidation$MediaMandatory$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryValidation$MediaMandatory$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryValidation$MediaMandatory$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryValidation$MediaMandatory$;", depth))
}
var $d_Lreactbuild_model_ListEntryValidation$MediaMandatory$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryValidation$MediaMandatory$: 0
}, false, "reactbuild.model.ListEntryValidation$MediaMandatory$", {
  Lreactbuild_model_ListEntryValidation$MediaMandatory$: 1,
  O: 1,
  Lreactbuild_model_ListEntryValidation: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryValidation$MediaMandatory$.prototype.$classData = $d_Lreactbuild_model_ListEntryValidation$MediaMandatory$;
var $n_Lreactbuild_model_ListEntryValidation$MediaMandatory$;
function $m_Lreactbuild_model_ListEntryValidation$MediaMandatory$() {
  if ((!$n_Lreactbuild_model_ListEntryValidation$MediaMandatory$)) {
    $n_Lreactbuild_model_ListEntryValidation$MediaMandatory$ = new $c_Lreactbuild_model_ListEntryValidation$MediaMandatory$()
  };
  return $n_Lreactbuild_model_ListEntryValidation$MediaMandatory$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryValidation$NoValidation$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype.constructor = $c_Lreactbuild_model_ListEntryValidation$NoValidation$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryValidation$NoValidation$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype = $c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype;
$c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype.productPrefix__T = (function() {
  return "NoValidation"
});
$c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype.hashCode__I = (function() {
  return 1535314234
});
$c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype.toString__T = (function() {
  return "NoValidation"
});
function $as_Lreactbuild_model_ListEntryValidation$NoValidation$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryValidation$NoValidation$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryValidation$NoValidation$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryValidation$NoValidation$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryValidation$NoValidation$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryValidation$NoValidation$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryValidation$NoValidation$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryValidation$NoValidation$;", depth))
}
var $d_Lreactbuild_model_ListEntryValidation$NoValidation$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryValidation$NoValidation$: 0
}, false, "reactbuild.model.ListEntryValidation$NoValidation$", {
  Lreactbuild_model_ListEntryValidation$NoValidation$: 1,
  O: 1,
  Lreactbuild_model_ListEntryValidation: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryValidation$NoValidation$.prototype.$classData = $d_Lreactbuild_model_ListEntryValidation$NoValidation$;
var $n_Lreactbuild_model_ListEntryValidation$NoValidation$;
function $m_Lreactbuild_model_ListEntryValidation$NoValidation$() {
  if ((!$n_Lreactbuild_model_ListEntryValidation$NoValidation$)) {
    $n_Lreactbuild_model_ListEntryValidation$NoValidation$ = new $c_Lreactbuild_model_ListEntryValidation$NoValidation$()
  };
  return $n_Lreactbuild_model_ListEntryValidation$NoValidation$
}
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$16(outer, proxy$8, organization$1) {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$16__f_proxy$8 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$16__f_organization$1 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$16__f_proxy$8 = proxy$8;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$16__f_organization$1 = organization$1;
  $ct_Lreactbuild_model_BaseRefToResolver__(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype = new $h_Lreactbuild_model_RefToResolver();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$16;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$16() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype.allItems__sci_List = (function() {
  $m_Lreactbuild_package$();
  var proxy = this.Lreactbuild_model_LowPriorityImplicits$$anon$16__f_proxy$8;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$26 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$26).Lreactbuild_model_CommonData__f_buildingParts
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype.getTitle__Lreactbuild_model_BuildingPart__T = (function(in$1) {
  return ("" + $n(in$1).Lreactbuild_model_BuildingPart__f_label)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype.createItem__T__s_Option = (function(in$1) {
  var this$1 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$16__f_organization$1);
  if (this$1.isEmpty__Z()) {
    var this$2 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$16__f_proxy$8);
    var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
    var $$x1 = $n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_activeOrganization
  } else {
    var $$x1 = this$1
  };
  var this$4 = $n($$x1);
  if (this$4.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$4.get__O();
    var orgRef = $as_Lreactbuild_common_model_RefTo(arg1);
    return new $c_s_Some($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
      var item = new $c_Lreactbuild_model_BuildingPart(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())), orgRef, in$1, $m_s_None$());
      var this$7 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$16__f_proxy$8);
      var action = new $c_Lreactbuild_analyze_cost_actions_PersistBuildingPart(item);
      $n(this$7.Ldiode_react_ModelProxy__f_theDispatch).apply__O__O(action);
      return item
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype.getRef__O__Lreactbuild_common_model_RefTo = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_BuildingPart(in$1);
  return $n(in$2).Lreactbuild_model_BuildingPart__f__id
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype.getTitle__O__T = (function(in$1) {
  return this.getTitle__Lreactbuild_model_BuildingPart__T($as_Lreactbuild_model_BuildingPart(in$1))
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$16 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$16: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$16", {
  Lreactbuild_model_LowPriorityImplicits$$anon$16: 1,
  Lreactbuild_model_RefToResolver: 1,
  Lreactbuild_model_BaseRefToResolver: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$16.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$16;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$17(outer, proxy$9, organization$2) {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$17__f_proxy$9 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$17__f_organization$2 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$17__f_proxy$9 = proxy$9;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$17__f_organization$2 = organization$2;
  $ct_Lreactbuild_model_BaseRefToResolver__(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$17.prototype = new $h_Lreactbuild_model_RefToResolver();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$17.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$17;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$17() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$17.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$17.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$17.prototype.allItems__sci_List = (function() {
  $m_Lreactbuild_package$();
  var proxy = this.Lreactbuild_model_LowPriorityImplicits$$anon$17__f_proxy$9;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$27 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$27).Lreactbuild_model_CommonData__f_buildingStages
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$17.prototype.createItem__T__s_Option = (function(in$1) {
  var this$1 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$17__f_organization$2);
  if (this$1.isEmpty__Z()) {
    var this$2 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$17__f_proxy$9);
    var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
    var $$x1 = $n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_activeOrganization
  } else {
    var $$x1 = this$1
  };
  var this$4 = $n($$x1);
  if (this$4.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$4.get__O();
    var orgRef = $as_Lreactbuild_common_model_RefTo(arg1);
    return new $c_s_Some($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
      var item = new $c_Lreactbuild_model_BuildingStage(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())), orgRef, in$1, $m_s_None$());
      var this$7 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$17__f_proxy$9);
      var action = new $c_Lreactbuild_analyze_cost_actions_PersistBuildingStage(item);
      $n(this$7.Ldiode_react_ModelProxy__f_theDispatch).apply__O__O(action);
      return item
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$17.prototype.getRef__O__Lreactbuild_common_model_RefTo = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_BuildingStage(in$1);
  return $n(in$2).Lreactbuild_model_BuildingStage__f__id
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$17.prototype.getTitle__O__T = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_BuildingStage(in$1);
  return $n(in$2).Lreactbuild_model_BuildingStage__f_name
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$17 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$17: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$17", {
  Lreactbuild_model_LowPriorityImplicits$$anon$17: 1,
  Lreactbuild_model_RefToResolver: 1,
  Lreactbuild_model_BaseRefToResolver: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$17.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$17;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$18(outer, proxy$10, organization$3) {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$18__f_proxy$10 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$18__f_organization$3 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$18__f_proxy$10 = proxy$10;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$18__f_organization$3 = organization$3;
  $ct_Lreactbuild_model_BaseRefToResolver__(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$18.prototype = new $h_Lreactbuild_model_RefToResolver();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$18.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$18;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$18() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$18.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$18.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$18.prototype.allItems__sci_List = (function() {
  $m_Lreactbuild_package$();
  var proxy = this.Lreactbuild_model_LowPriorityImplicits$$anon$18__f_proxy$10;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$28 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$28).Lreactbuild_model_CommonData__f_terms
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$18.prototype.createItem__T__s_Option = (function(in$1) {
  var this$1 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$18__f_organization$3);
  if (this$1.isEmpty__Z()) {
    var this$2 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$18__f_proxy$10);
    var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
    var $$x1 = $n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_activeOrganization
  } else {
    var $$x1 = this$1
  };
  var this$4 = $n($$x1);
  if (this$4.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$4.get__O();
    var orgRef = $as_Lreactbuild_common_model_RefTo(arg1);
    return new $c_s_Some($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
      var item = new $c_Lreactbuild_model_Term(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())), orgRef, in$1, $m_s_None$());
      var this$7 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$18__f_proxy$10);
      var action = new $c_Lreactbuild_analyze_cost_actions_PersistTerm(item);
      $n(this$7.Ldiode_react_ModelProxy__f_theDispatch).apply__O__O(action);
      return item
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$18.prototype.getRef__O__Lreactbuild_common_model_RefTo = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_Term(in$1);
  return $n(in$2).Lreactbuild_model_Term__f__id
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$18.prototype.getTitle__O__T = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_Term(in$1);
  return $n(in$2).Lreactbuild_model_Term__f_label
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$18 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$18: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$18", {
  Lreactbuild_model_LowPriorityImplicits$$anon$18: 1,
  Lreactbuild_model_RefToResolver: 1,
  Lreactbuild_model_BaseRefToResolver: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$18.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$18;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$19(outer, proxy$11, organization$4) {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$19__f_proxy$11 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$19__f_organization$4 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$19__f_proxy$11 = proxy$11;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$19__f_organization$4 = organization$4;
  $ct_Lreactbuild_model_BaseRefToResolver__(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$19.prototype = new $h_Lreactbuild_model_RefToResolver();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$19.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$19;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$19() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$19.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$19.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$19.prototype.allItems__sci_List = (function() {
  $m_Lreactbuild_package$();
  var proxy = this.Lreactbuild_model_LowPriorityImplicits$$anon$19__f_proxy$11;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$29 = $as_Lreactbuild_model_CommonData(arg1);
    var this$7 = $n($n(x$29).Lreactbuild_model_CommonData__f_listTemplates);
    var f = ((x$30$2) => {
      var x$30 = $as_Lreactbuild_model_WithChildren(x$30$2);
      return $as_Lreactbuild_model_ListTemplate($n(x$30).Lreactbuild_model_WithChildren__f_item)
    });
    if ((this$7 === $m_sci_Nil$())) {
      var $$x1 = $m_sci_Nil$()
    } else {
      var arg1$1 = this$7.head__O();
      var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$7.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$2 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var $$x1 = h
    }
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$19.prototype.createItem__T__s_Option = (function(in$1) {
  var this$1 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$19__f_organization$4);
  if (this$1.isEmpty__Z()) {
    var this$2 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$19__f_proxy$11);
    var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
    var $$x1 = $n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_activeOrganization
  } else {
    var $$x1 = this$1
  };
  var this$4 = $n($$x1);
  if (this$4.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$4.get__O();
    var orgRef = $as_Lreactbuild_common_model_RefTo(arg1);
    return new $c_s_Some($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
      var item = new $c_Lreactbuild_model_ListTemplate(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())), orgRef, in$1);
      var this$7 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$19__f_proxy$11);
      var action = new $c_Lreactbuild_analyze_cost_actions_PersistListTemplate(item);
      $n(this$7.Ldiode_react_ModelProxy__f_theDispatch).apply__O__O(action);
      return item
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$19.prototype.getRef__O__Lreactbuild_common_model_RefTo = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_ListTemplate(in$1);
  return $n(in$2).Lreactbuild_model_ListTemplate__f__id
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$19.prototype.getTitle__O__T = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_ListTemplate(in$1);
  return $n(in$2).Lreactbuild_model_ListTemplate__f_title
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$19 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$19: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$19", {
  Lreactbuild_model_LowPriorityImplicits$$anon$19: 1,
  Lreactbuild_model_RefToResolver: 1,
  Lreactbuild_model_BaseRefToResolver: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$19.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$19;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1(outer, search$1) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1__f_search$1 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1__f_search$1 = search$1
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var k = $as_T($n(x1)._1__O());
    var v = $as_Lreactbuild_model_DocumentCategory($n(x1)._2__O());
    var this$1 = $n(k);
    var prefix = this.Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1__f_search$1;
    if ((this$1.length >= 0)) {
      var this$2 = $n(prefix);
      var $$x2 = this$1.substring(0, this$2.length);
      var $$x1 = ($as_T($$x2) === prefix)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return v
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var k = $as_T($n(x1)._1__O());
    var this$1 = $n(k);
    var prefix = this.Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1__f_search$1;
    if ((this$1.length >= 0)) {
      var this$2 = $n(prefix);
      var $$x2 = this$1.substring(0, this$2.length);
      var $$x1 = ($as_T($$x2) === prefix)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$2$$anonfun$1", {
  Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$2$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$20(outer, proxy$12) {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_$outer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_proxy$12 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_$outer = outer
  };
  this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_proxy$12 = proxy$12;
  $ct_Lreactbuild_model_BaseRefToResolver__(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype = new $h_Lreactbuild_model_RefToResolver();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$20;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$20() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype.allItems__sci_List = (function() {
  $m_Lreactbuild_package$();
  var proxy = this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_proxy$12;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$31 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$31).Lreactbuild_model_CommonData__f_buildingSites
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype.getTitle__Lreactbuild_common_model_Project__T = (function(in$1) {
  return (((($n(in$1).Lreactbuild_common_model_Project__f_reference + " - ") + $n(in$1).Lreactbuild_common_model_Project__f_name) + ", ") + $n(in$1).Lreactbuild_common_model_Project__f_address)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype.createItem__T__s_Option = (function(in$1) {
  var this$1 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_proxy$12);
  var this$2 = $n(this$1.Ldiode_react_ModelProxy__f_modelReader);
  var this$3 = $n($n($as_Lreactbuild_analyze_cost_services_Model(this$2.value__O())).Lreactbuild_analyze_cost_services_Model__f_logged);
  if (this$3.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$3.get__O();
    var logged = $as_Lreactbuild_common_model_LoggedUserWithOrganizations(arg1);
    return new $c_s_Some($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
      var $$x2 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
      var this$6 = $n($n(logged).Lreactbuild_common_model_LoggedUserWithOrganizations__f_organizations);
      var f = ((x$32$2) => {
        var x$32 = $as_Lreactbuild_common_model_LoggedUserOrganization(x$32$2);
        return $n(x$32).Lreactbuild_common_model_LoggedUserOrganization__f__id
      });
      if ((this$6 === $m_sci_Nil$())) {
        var $$x1 = $m_sci_Nil$()
      } else {
        var arg1$1 = this$6.head__O();
        var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$6.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O())
        };
        var $$x1 = h
      };
      var item = new $c_Lreactbuild_common_model_Project($$x2, $$x1, in$1, "", $m_s_None$(), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_package$().s_package$__f_Nil), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), $m_s_None$()), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), new $c_Lreactbuild_common_model_ProjectAddress(($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$()), ($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$()), ($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_package$().s_package$__f_Nil), ($m_Lreactbuild_common_model_ProjectAddress$(), $m_s_None$()))), ($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_Project), ""));
      var this$28 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_proxy$12);
      var action = new $c_Lreactbuild_analyze_cost_actions_PersistBuildingSite(item);
      $n(this$28.Ldiode_react_ModelProxy__f_theDispatch).apply__O__O(action);
      return item
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype.renderContainer__T__Z__Lcom_iz2use_react_components_internal_TextEditorContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(text, open, context) {
  $m_Lreactbuild_package$();
  var proxy = this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_proxy$12;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$2();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_Predef$().s_Predef$__f_Map);
    var $$x1 = $m_sci_Map$EmptyMap$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$33 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$33).Lreactbuild_model_CommonData__f_buildingSiteStages
  };
  var stages = $as_sci_Map($$x1);
  $m_Lreactbuild_package$();
  var proxy$1 = this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_proxy$12;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$8 = $n(proxy$1);
  var this$9 = $n(this$8.Ldiode_react_ModelProxy__f_modelReader);
  var m$1 = $as_Lreactbuild_analyze_cost_services_Model(this$9.value__O());
  if ($n($n(m$1).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x3 = $m_sci_Nil$()
  } else {
    var arg1$1 = $n($n(m$1).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$34 = $as_Lreactbuild_model_CommonData(arg1$1);
    var $$x3 = $n(x$34).Lreactbuild_model_CommonData__f_buildingStages
  };
  var this$11 = $n($as_sci_List($$x3));
  var f = ((x$35$2) => {
    var x$35 = $as_Lreactbuild_model_BuildingStage(x$35$2);
    return $n(x$35).Lreactbuild_model_BuildingStage__f__id
  });
  if ((this$11 === $m_sci_Nil$())) {
    var $$x4 = $m_sci_Nil$()
  } else {
    var arg1$2 = this$11.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$11.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$3 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x4 = h
  };
  var this$12 = $n($$x4);
  var $$x2 = $n($as_sc_IterableOnceOps($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$12)));
  var this$13 = $m_s_$less$colon$less$();
  var buildingStages = $n($$x2).toMap__s_$less$colon$less__sci_Map(this$13.s_$less$colon$less$__f_singleton);
  var colorLength = $n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_colors).length__I();
  var this$18 = $n(stages);
  var this$14 = $m_Ljava_time_LocalDate$();
  var $$x5 = this$14.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()));
  var this$16 = $m_Ljava_time_LocalDate$();
  var z = new $c_Lcom_iz2use_common_TypedRange($$x5, this$16.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId())), $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_$outer).Lreactbuild_model_Implicits$__f_localDateOrdering);
  var f$1 = ((acc$2, c$2) => {
    var acc = $as_Lcom_iz2use_common_TypedRange(acc$2);
    var c = $as_T2(c$2);
    return $as_Lcom_iz2use_common_TypedRange($n($as_sc_LinearSeqOps($n(c)._2__O())).foldLeft__O__F2__O(acc, new $c_sjsr_AnonFunction2(((r$2, v$2) => {
      var r = $as_Lcom_iz2use_common_TypedRange(r$2);
      var v = $as_Lreactbuild_model_BuildingSiteStage(v$2);
      return $n($n(r).$plus__O__Lcom_iz2use_common_TypedRange($n($n(v).Lreactbuild_model_BuildingSiteStage__f_range).Lcom_iz2use_common_TypedRange__f_from)).$plus__O__Lcom_iz2use_common_TypedRange($n($n(v).Lreactbuild_model_BuildingSiteStage__f_range).Lcom_iz2use_common_TypedRange__f_until)
    }))))
  });
  if ($is_sc_IndexedSeq(this$18)) {
    var x2 = $as_sc_IndexedSeq(this$18);
    var at = 0;
    var end = $n(x2).length__I();
    var acc$1 = z;
    var $$x6;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1$4 = acc$1;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f$1(arg1$4, arg2);
        at = temp$at;
        acc$1 = temp$acc;
        continue
      };
      var $$x6 = acc$1;
      break
    }
  } else {
    var result = z;
    var it = this$18.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1$5 = result;
      var arg2$1 = $n(it).next__O();
      result = f$1(arg1$5, arg2$1)
    };
    var $$x6 = result
  };
  var total = $as_Lcom_iz2use_common_TypedRange($$x6);
  var this$25 = $n(total);
  var toRange = new $c_Lcom_iz2use_common_TypedRange(200, 0, $m_s_math_Ordering$Int$());
  var doubleFromT = new $c_sjsr_AnonFunction1(((x$36$2) => {
    var x$36 = $as_Ljava_time_LocalDate(x$36$2);
    var this$19 = $n(x$36).toEpochDay__J();
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$19.RTLong__f_lo, this$19.RTLong__f_hi)
  }));
  var doubleToU = new $c_sjsr_AnonFunction1(((x$37$2) => {
    var x$37 = $uD(x$37$2);
    var this$24 = $m_RTLong$();
    var value = $uD(Math.round(x$37));
    var lo = this$24.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    return lo
  }));
  var numericU = $m_s_math_Numeric$IntIsIntegral$();
  var target = new $c_Lcom_iz2use_common_MappedTypedRange(this$25, toRange, doubleFromT, doubleToU, numericU);
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  var context$1 = $n(context).contramap__F1__Lcom_iz2use_react_components_internal_TextEditorContext(new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_Lreactbuild_common_model_Project(in$2);
    return $n(in$1).Lreactbuild_common_model_Project__f__id
  })));
  $n($m_Lcom_iz2use_react_components_internal_editor_TextComponent$().Lcom_iz2use_react_components_internal_editor_TextComponent$__f_SuggestionHelper);
  var focusHandler = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionFocusHandler$$anon$2();
  var fetcher = this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher;
  var fetcherBackend = $m_Lcom_iz2use_react_components_internal_suggestion_FetcherBackend$OnMountFetcherBackend$();
  var filter = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
  var keyOf = this.keyOf__F1();
  var this$28 = $m_s_math_Equiv$();
  var equiv = this$28.universal__s_math_Equiv();
  var handleNonexistent = this.handleNonexistent__F1();
  var tokenMatcher = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
  var tokenizer = this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer;
  var h$1 = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$1();
  var highlighter = new $c_Lcom_iz2use_react_components_internal_Highlighter$$anon$3(h$1);
  var u = new $c_Lcom_iz2use_react_components_internal_suggestion_SuggestionHelper$Builder(text, open, context$1, focusHandler, fetcher, fetcherBackend, filter, keyOf, equiv, handleNonexistent, tokenMatcher, tokenizer, highlighter).apply__F2__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction2(((i$2, v$2$1) => {
    var i = $as_Lreactbuild_common_model_Project(i$2);
    var v$1 = $as_sci_Seq(v$2$1);
    var $$x23 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x22 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$().apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less), $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf), "div"), v$1);
    var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x10 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$NormalOpenStyle("lineHeight")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("12px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x9 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "paddingBottom")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("2px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$41 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
    var $$x8 = this$41.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("relative", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var $$x7 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var as = $as_sc_IterableOnce($n(stages).getOrElse__O__F0__O($n(i).Lreactbuild_common_model_Project__f__id, new $c_sjsr_AnonFunction0((() => $m_s_package$().s_package$__f_Nil))));
    var array$1 = [$$x10, $$x9, $$x8, $n($$x7).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_model_BuildingSiteStage(s$2);
      var from = $uI(target.apply__O__O($n($n(s).Lreactbuild_model_BuildingSiteStage__f_range).Lcom_iz2use_common_TypedRange__f_from));
      var until = $uI(target.apply__O__O($n($n(s).Lreactbuild_model_BuildingSiteStage__f_range).Lcom_iz2use_common_TypedRange__f_until));
      var a = ((until - from) | 0);
      var width = ((a > 4) ? a : 4);
      var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var this$46 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).position__Ljapgolly_scalajs_react_vdom_HtmlStyles$position$());
      var $$x19 = this$46.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("absolute", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x18 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("left")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((from + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x17 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("bottom")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x16 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((width + "px"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x15 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n($as_Lscalacss_internal_ValueT($n($m_Lreactbuild_Style$().Lreactbuild_Style$__f_colors).apply__I__O($intMod($uI($n(buildingStages).getOrElse__O__F0__O($n(s).Lreactbuild_model_BuildingSiteStage__f_stage, new $c_sjsr_AnonFunction0((() => 0)))), colorLength)))).Lscalacss_internal_ValueT__f_value, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x14 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("8px", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
      var $$x13 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_title;
      $m_Lcom_iz2use_common_Textualizable$();
      var v$3 = $n(s).Lreactbuild_model_BuildingSiteStage__f_stage;
      var this$53 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_$outer);
      var proxy$2 = this.Lreactbuild_model_LowPriorityImplicits$$anon$20__f_proxy$12;
      var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$53, proxy$2);
      var $$x12 = $n(ev$2).stringify__O__T(v$3);
      $m_Lcom_iz2use_common_Textualizable$();
      var v$4 = $n($n(s).Lreactbuild_model_BuildingSiteStage__f_range).Lcom_iz2use_common_TypedRange__f_from;
      var ev$3 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
      var $$x11 = $n(ev$3).stringify__O__T(v$4);
      $m_Lcom_iz2use_common_Textualizable$();
      var v$5 = $n($n(s).Lreactbuild_model_BuildingSiteStage__f_range).Lcom_iz2use_common_TypedRange__f_until;
      var ev$4 = $m_Lcom_iz2use_common_Textualizable$().Lcom_iz2use_common_Textualizable$__f_fromLocalDate;
      var array = [$$x19, $$x18, $$x17, $$x16, $$x15, $$x14, $n($$x13).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(((((($$x12 + " (") + $$x11) + " - ") + $n(ev$4).stringify__O__T(v$5)) + ")"), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
      return $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    })))];
    var array$2 = [$$x22, $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    return $n($$x23).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  })));
  var this$67 = $n(u);
  var n = this$67.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype.getRef__O__Lreactbuild_common_model_RefTo = (function(in$1) {
  var in$2 = $as_Lreactbuild_common_model_Project(in$1);
  return $n(in$2).Lreactbuild_common_model_Project__f__id
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype.getTitle__O__T = (function(in$1) {
  return this.getTitle__Lreactbuild_common_model_Project__T($as_Lreactbuild_common_model_Project(in$1))
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$20 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$20: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$20", {
  Lreactbuild_model_LowPriorityImplicits$$anon$20: 1,
  Lreactbuild_model_RefToResolver: 1,
  Lreactbuild_model_BaseRefToResolver: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$20.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$20;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$21(outer, proxy$13, organization$5) {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$21__f_proxy$13 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$21__f_organization$5 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$21__f_proxy$13 = proxy$13;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$21__f_organization$5 = organization$5;
  $ct_Lreactbuild_model_BaseRefToResolver__(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$21.prototype = new $h_Lreactbuild_model_RefToResolver();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$21.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$21;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$21() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$21.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$21.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$21.prototype.allItems__sci_List = (function() {
  $m_Lreactbuild_package$();
  var proxy = this.Lreactbuild_model_LowPriorityImplicits$$anon$21__f_proxy$13;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$38 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$38).Lreactbuild_model_CommonData__f_resources
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$21.prototype.createItem__T__s_Option = (function(in$1) {
  var this$1 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$21__f_organization$5);
  if (this$1.isEmpty__Z()) {
    var this$2 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$21__f_proxy$13);
    var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
    var $$x1 = $n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_activeOrganization
  } else {
    var $$x1 = this$1
  };
  var this$4 = $n($$x1);
  if (this$4.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$4.get__O();
    var orgRef = $as_Lreactbuild_common_model_RefTo(arg1);
    return new $c_s_Some($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
      var item = new $c_Lreactbuild_model_Resource(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())), orgRef, in$1, $m_s_None$(), $m_s_None$(), ($m_Lreactbuild_model_Resource$(), $m_s_None$()), ($m_Lreactbuild_model_Resource$(), $m_s_None$()));
      var this$9 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$21__f_proxy$13);
      var action = new $c_Lreactbuild_analyze_cost_actions_PersistResource(item);
      $n(this$9.Ldiode_react_ModelProxy__f_theDispatch).apply__O__O(action);
      return item
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$21.prototype.getRef__O__Lreactbuild_common_model_RefTo = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_Resource(in$1);
  return $n(in$2).Lreactbuild_model_Resource__f__id
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$21.prototype.getTitle__O__T = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_Resource(in$1);
  return $n(in$2).Lreactbuild_model_Resource__f_name
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$21 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$21: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$21", {
  Lreactbuild_model_LowPriorityImplicits$$anon$21: 1,
  Lreactbuild_model_RefToResolver: 1,
  Lreactbuild_model_BaseRefToResolver: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$21.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$21;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$22(outer, proxy$14, organization$6) {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$22__f_proxy$14 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$22__f_organization$6 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$22__f_proxy$14 = proxy$14;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$22__f_organization$6 = organization$6;
  $ct_Lreactbuild_model_BaseRefToResolver__(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype = new $h_Lreactbuild_model_RefToResolver();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$22;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$22() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype.allItems__sci_List = (function() {
  $m_Lreactbuild_package$();
  var proxy = this.Lreactbuild_model_LowPriorityImplicits$$anon$22__f_proxy$14;
  new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
  var this$3 = $n(proxy);
  var this$4 = $n(this$3.Ldiode_react_ModelProxy__f_modelReader);
  var m = $as_Lreactbuild_analyze_cost_services_Model(this$4.value__O());
  if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
    $n($m_s_package$().s_package$__f_List);
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
    var x$39 = $as_Lreactbuild_model_CommonData(arg1);
    var $$x1 = $n(x$39).Lreactbuild_model_CommonData__f_persons
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype.getTitle__Lreactbuild_person_Person__T = (function(in$1) {
  var this$1 = $n($n(in$1).Lreactbuild_person_Person__f_code);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $n(in$1).Lreactbuild_person_Person__f_name
  } else {
    var arg1 = this$1.get__O();
    var code = $as_T(arg1);
    var $$x1 = ((code + " - ") + $n(in$1).Lreactbuild_person_Person__f_name)
  };
  return $as_T($$x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype.createItem__T__s_Option = (function(in$1) {
  var this$1 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$22__f_organization$6);
  if (this$1.isEmpty__Z()) {
    var this$2 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$22__f_proxy$14);
    var this$3 = $n(this$2.Ldiode_react_ModelProxy__f_modelReader);
    var $$x1 = $n($as_Lreactbuild_analyze_cost_services_Model(this$3.value__O())).Lreactbuild_analyze_cost_services_Model__f_activeOrganization
  } else {
    var $$x1 = this$1
  };
  var this$4 = $n($$x1);
  if (this$4.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$4.get__O();
    var orgRef = $as_Lreactbuild_common_model_RefTo(arg1);
    return new $c_s_Some($m_s_concurrent_Future$().apply__F0__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction0((() => {
      $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
      var $$x3 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
      $m_Lreactbuild_person_Person$();
      var $$x2 = $m_s_None$();
      $m_Lreactbuild_person_Person$();
      $m_Lreactbuild_person_Facets$();
      $m_Lreactbuild_person_Facets$();
      $n($m_s_Predef$().s_Predef$__f_Map);
      var facets = $m_sci_Map$EmptyMap$();
      var item = new $c_Lreactbuild_person_Person($$x3, orgRef, in$1, $$x2, new $c_Lreactbuild_person_Facets(facets), ($m_Lreactbuild_person_Person$(), $m_s_package$().s_package$__f_Nil), ($m_Lreactbuild_person_Person$(), $m_s_None$()), ($m_Lreactbuild_person_Person$(), $m_s_None$()));
      var this$15 = $n(this.Lreactbuild_model_LowPriorityImplicits$$anon$22__f_proxy$14);
      var action = new $c_Lreactbuild_analyze_cost_actions_PersistPerson(item);
      $n(this$15.Ldiode_react_ModelProxy__f_theDispatch).apply__O__O(action);
      return item
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()))
  }
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype.getRef__O__Lreactbuild_common_model_RefTo = (function(in$1) {
  var in$2 = $as_Lreactbuild_person_Person(in$1);
  return $n(in$2).Lreactbuild_person_Person__f__id
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype.getTitle__O__T = (function(in$1) {
  return this.getTitle__Lreactbuild_person_Person__T($as_Lreactbuild_person_Person(in$1))
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$22 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$22: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$22", {
  Lreactbuild_model_LowPriorityImplicits$$anon$22: 1,
  Lreactbuild_model_RefToResolver: 1,
  Lreactbuild_model_BaseRefToResolver: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$22.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$22;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2(outer, search$2) {
  this.Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2__f_search$2 = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2__f_search$2 = search$2
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var k = $as_T($n(x1)._1__O());
    var v = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder($n(x1)._2__O());
    var this$1 = $n(k);
    var prefix = this.Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2__f_search$2;
    if ((this$1.length >= 0)) {
      var this$2 = $n(prefix);
      var $$x2 = this$1.substring(0, this$2.length);
      var $$x1 = ($as_T($$x2) === prefix)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return v
    }
  };
  return $n(default$1).apply__O__O(x1)
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2.prototype.isDefinedAt__T2__Z = (function(x1) {
  if ((x1 !== null)) {
    var k = $as_T($n(x1)._1__O());
    var this$1 = $n(k);
    var prefix = this.Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2__f_search$2;
    if ((this$1.length >= 0)) {
      var this$2 = $n(prefix);
      var $$x2 = this$1.substring(0, this$2.length);
      var $$x1 = ($as_T($$x2) === prefix)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return true
    }
  };
  return false
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$7$$anonfun$2", {
  Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$7$$anonfun$2;
/** @constructor */
function $c_Lreactbuild_model_MissingDeliveryFormDetails(content) {
  this.Lreactbuild_model_MissingDeliveryFormDetails__f_content = null;
  this.Lreactbuild_model_MissingDeliveryFormDetails__f_content = content
}
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype = new $h_Lreactbuild_model_DeliveryFormDetails();
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.constructor = $c_Lreactbuild_model_MissingDeliveryFormDetails;
/** @constructor */
function $h_Lreactbuild_model_MissingDeliveryFormDetails() {
  /*<skip>*/
}
$h_Lreactbuild_model_MissingDeliveryFormDetails.prototype = $c_Lreactbuild_model_MissingDeliveryFormDetails.prototype;
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.amount__s_Option = (function() {
  return $n(this.Lreactbuild_model_MissingDeliveryFormDetails__f_content).Lreactbuild_model_InvoiceDetail__f_amount
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.asReconcilied__s_Option = (function() {
  return $m_s_None$()
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.deliveredQuantity__D = (function() {
  var this$1 = $n($n(this.Lreactbuild_model_MissingDeliveryFormDetails__f_content).Lreactbuild_model_InvoiceDetail__f_quantity);
  return $uD((this$1.isEmpty__Z() ? 0.0 : this$1.get__O()))
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.isSameLine__Lreactbuild_common_model_RefTo__ju_UUID__Z = (function(document, line) {
  return false
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.productPrefix__T = (function() {
  return "MissingDeliveryFormDetails"
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_MissingDeliveryFormDetails__f_content : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_MissingDeliveryFormDetails)) {
    var MissingDeliveryFormDetails$1 = $as_Lreactbuild_model_MissingDeliveryFormDetails(x$1);
    var x = this.Lreactbuild_model_MissingDeliveryFormDetails__f_content;
    var x$2 = $n(MissingDeliveryFormDetails$1).Lreactbuild_model_MissingDeliveryFormDetails__f_content;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_MissingDeliveryFormDetails(obj) {
  return (((obj instanceof $c_Lreactbuild_model_MissingDeliveryFormDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.MissingDeliveryFormDetails"))
}
function $isArrayOf_Lreactbuild_model_MissingDeliveryFormDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_MissingDeliveryFormDetails)))
}
function $asArrayOf_Lreactbuild_model_MissingDeliveryFormDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_MissingDeliveryFormDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.MissingDeliveryFormDetails;", depth))
}
var $d_Lreactbuild_model_MissingDeliveryFormDetails = new $TypeData().initClass({
  Lreactbuild_model_MissingDeliveryFormDetails: 0
}, false, "reactbuild.model.MissingDeliveryFormDetails", {
  Lreactbuild_model_MissingDeliveryFormDetails: 1,
  Lreactbuild_model_DeliveryFormDetails: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MissingDeliveryFormDetails.prototype.$classData = $d_Lreactbuild_model_MissingDeliveryFormDetails;
/** @constructor */
function $c_Lreactbuild_model_OtherCommunicationBody(source, part) {
  this.Lreactbuild_model_OtherCommunicationBody__f_source = null;
  this.Lreactbuild_model_OtherCommunicationBody__f_part = null;
  this.Lreactbuild_model_OtherCommunicationBody__f_source = source;
  this.Lreactbuild_model_OtherCommunicationBody__f_part = part
}
$c_Lreactbuild_model_OtherCommunicationBody.prototype = new $h_O();
$c_Lreactbuild_model_OtherCommunicationBody.prototype.constructor = $c_Lreactbuild_model_OtherCommunicationBody;
/** @constructor */
function $h_Lreactbuild_model_OtherCommunicationBody() {
  /*<skip>*/
}
$h_Lreactbuild_model_OtherCommunicationBody.prototype = $c_Lreactbuild_model_OtherCommunicationBody.prototype;
$c_Lreactbuild_model_OtherCommunicationBody.prototype.productPrefix__T = (function() {
  return "OtherCommunicationBody"
});
$c_Lreactbuild_model_OtherCommunicationBody.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_OtherCommunicationBody.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_OtherCommunicationBody__f_source;
      break
    }
    case 1: {
      return this.Lreactbuild_model_OtherCommunicationBody__f_part;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_OtherCommunicationBody.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_OtherCommunicationBody.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_OtherCommunicationBody.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_OtherCommunicationBody.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_OtherCommunicationBody)) {
    var OtherCommunicationBody$1 = $as_Lreactbuild_model_OtherCommunicationBody(x$1);
    return ((this.Lreactbuild_model_OtherCommunicationBody__f_source === $n(OtherCommunicationBody$1).Lreactbuild_model_OtherCommunicationBody__f_source) && (this.Lreactbuild_model_OtherCommunicationBody__f_part === $n(OtherCommunicationBody$1).Lreactbuild_model_OtherCommunicationBody__f_part))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_OtherCommunicationBody(obj) {
  return (((obj instanceof $c_Lreactbuild_model_OtherCommunicationBody) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.OtherCommunicationBody"))
}
function $isArrayOf_Lreactbuild_model_OtherCommunicationBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_OtherCommunicationBody)))
}
function $asArrayOf_Lreactbuild_model_OtherCommunicationBody(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_OtherCommunicationBody(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.OtherCommunicationBody;", depth))
}
var $d_Lreactbuild_model_OtherCommunicationBody = new $TypeData().initClass({
  Lreactbuild_model_OtherCommunicationBody: 0
}, false, "reactbuild.model.OtherCommunicationBody", {
  Lreactbuild_model_OtherCommunicationBody: 1,
  O: 1,
  Lreactbuild_model_CommunicationBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_OtherCommunicationBody.prototype.$classData = $d_Lreactbuild_model_OtherCommunicationBody;
/** @constructor */
function $c_Lreactbuild_model_Ping(origin) {
  this.Lreactbuild_model_Ping__f_origin = null;
  this.Lreactbuild_model_Ping__f_origin = origin
}
$c_Lreactbuild_model_Ping.prototype = new $h_O();
$c_Lreactbuild_model_Ping.prototype.constructor = $c_Lreactbuild_model_Ping;
/** @constructor */
function $h_Lreactbuild_model_Ping() {
  /*<skip>*/
}
$h_Lreactbuild_model_Ping.prototype = $c_Lreactbuild_model_Ping.prototype;
$c_Lreactbuild_model_Ping.prototype.productPrefix__T = (function() {
  return "Ping"
});
$c_Lreactbuild_model_Ping.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_Ping.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_Ping__f_origin : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_Ping.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Ping.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_Ping.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Ping.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Ping)) {
    var Ping$1 = $as_Lreactbuild_model_Ping(x$1);
    var x = this.Lreactbuild_model_Ping__f_origin;
    var x$2 = $n(Ping$1).Lreactbuild_model_Ping__f_origin;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Ping(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Ping) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Ping"))
}
function $isArrayOf_Lreactbuild_model_Ping(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Ping)))
}
function $asArrayOf_Lreactbuild_model_Ping(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Ping(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Ping;", depth))
}
var $d_Lreactbuild_model_Ping = new $TypeData().initClass({
  Lreactbuild_model_Ping: 0
}, false, "reactbuild.model.Ping", {
  Lreactbuild_model_Ping: 1,
  O: 1,
  Lreactbuild_model_ToClient: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Ping.prototype.$classData = $d_Lreactbuild_model_Ping;
/** @constructor */
function $c_Lreactbuild_model_ProjectTaskAttachment(id, target) {
  this.Lreactbuild_model_ProjectTaskAttachment__f_id = null;
  this.Lreactbuild_model_ProjectTaskAttachment__f_target = null;
  this.Lreactbuild_model_ProjectTaskAttachment__f_id = id;
  this.Lreactbuild_model_ProjectTaskAttachment__f_target = target
}
$c_Lreactbuild_model_ProjectTaskAttachment.prototype = new $h_O();
$c_Lreactbuild_model_ProjectTaskAttachment.prototype.constructor = $c_Lreactbuild_model_ProjectTaskAttachment;
/** @constructor */
function $h_Lreactbuild_model_ProjectTaskAttachment() {
  /*<skip>*/
}
$h_Lreactbuild_model_ProjectTaskAttachment.prototype = $c_Lreactbuild_model_ProjectTaskAttachment.prototype;
$c_Lreactbuild_model_ProjectTaskAttachment.prototype.productPrefix__T = (function() {
  return "ProjectTaskAttachment"
});
$c_Lreactbuild_model_ProjectTaskAttachment.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_ProjectTaskAttachment.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_ProjectTaskAttachment__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_ProjectTaskAttachment__f_target;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_ProjectTaskAttachment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ProjectTaskAttachment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ProjectTaskAttachment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ProjectTaskAttachment.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ProjectTaskAttachment)) {
    var ProjectTaskAttachment$1 = $as_Lreactbuild_model_ProjectTaskAttachment(x$1);
    var x = this.Lreactbuild_model_ProjectTaskAttachment__f_id;
    var x$2 = $n(ProjectTaskAttachment$1).Lreactbuild_model_ProjectTaskAttachment__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_ProjectTaskAttachment__f_target;
      var x$4 = $n(ProjectTaskAttachment$1).Lreactbuild_model_ProjectTaskAttachment__f_target;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ProjectTaskAttachment(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ProjectTaskAttachment) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ProjectTaskAttachment"))
}
function $isArrayOf_Lreactbuild_model_ProjectTaskAttachment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ProjectTaskAttachment)))
}
function $asArrayOf_Lreactbuild_model_ProjectTaskAttachment(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ProjectTaskAttachment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ProjectTaskAttachment;", depth))
}
var $d_Lreactbuild_model_ProjectTaskAttachment = new $TypeData().initClass({
  Lreactbuild_model_ProjectTaskAttachment: 0
}, false, "reactbuild.model.ProjectTaskAttachment", {
  Lreactbuild_model_ProjectTaskAttachment: 1,
  O: 1,
  Lreactbuild_model_TaskAttachment: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ProjectTaskAttachment.prototype.$classData = $d_Lreactbuild_model_ProjectTaskAttachment;
/** @constructor */
function $c_Lreactbuild_model_Reconcilied(left, right) {
  this.Lreactbuild_model_Reconcilied__f_left = null;
  this.Lreactbuild_model_Reconcilied__f_right = null;
  this.Lreactbuild_model_Reconcilied__f_left = left;
  this.Lreactbuild_model_Reconcilied__f_right = right
}
$c_Lreactbuild_model_Reconcilied.prototype = new $h_Lreactbuild_model_ReconciliationState();
$c_Lreactbuild_model_Reconcilied.prototype.constructor = $c_Lreactbuild_model_Reconcilied;
/** @constructor */
function $h_Lreactbuild_model_Reconcilied() {
  /*<skip>*/
}
$h_Lreactbuild_model_Reconcilied.prototype = $c_Lreactbuild_model_Reconcilied.prototype;
$c_Lreactbuild_model_Reconcilied.prototype.foldLeft__F0__F1__O = (function(ifEmpty, f) {
  return $n(f).apply__O__O(this.Lreactbuild_model_Reconcilied__f_left)
});
$c_Lreactbuild_model_Reconcilied.prototype.foldRight__F0__F1__O = (function(ifEmpty, f) {
  return $n(f).apply__O__O(this.Lreactbuild_model_Reconcilied__f_right)
});
$c_Lreactbuild_model_Reconcilied.prototype.leftOption__s_Option = (function() {
  return new $c_s_Some(this.Lreactbuild_model_Reconcilied__f_left)
});
$c_Lreactbuild_model_Reconcilied.prototype.rightOption__s_Option = (function() {
  return new $c_s_Some(this.Lreactbuild_model_Reconcilied__f_right)
});
$c_Lreactbuild_model_Reconcilied.prototype.fold__F1__F2__F1__O = (function(ifLeftOnly, ifReconcilied, ifRightOnly) {
  return $n(ifReconcilied).apply__O__O__O(this.Lreactbuild_model_Reconcilied__f_left, this.Lreactbuild_model_Reconcilied__f_right)
});
$c_Lreactbuild_model_Reconcilied.prototype.productPrefix__T = (function() {
  return "Reconcilied"
});
$c_Lreactbuild_model_Reconcilied.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_Reconcilied.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_Reconcilied__f_left;
      break
    }
    case 1: {
      return this.Lreactbuild_model_Reconcilied__f_right;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_Reconcilied.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_Reconcilied.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_Reconcilied.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_Reconcilied.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_Reconcilied)) {
    var Reconcilied$1 = $as_Lreactbuild_model_Reconcilied(x$1);
    var x = this.Lreactbuild_model_Reconcilied__f_left;
    var y = $n(Reconcilied$1).Lreactbuild_model_Reconcilied__f_left;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_model_Reconcilied__f_right;
      var y$1 = $n(Reconcilied$1).Lreactbuild_model_Reconcilied__f_right;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_Reconcilied(obj) {
  return (((obj instanceof $c_Lreactbuild_model_Reconcilied) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.Reconcilied"))
}
function $isArrayOf_Lreactbuild_model_Reconcilied(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_Reconcilied)))
}
function $asArrayOf_Lreactbuild_model_Reconcilied(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_Reconcilied(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.Reconcilied;", depth))
}
var $d_Lreactbuild_model_Reconcilied = new $TypeData().initClass({
  Lreactbuild_model_Reconcilied: 0
}, false, "reactbuild.model.Reconcilied", {
  Lreactbuild_model_Reconcilied: 1,
  Lreactbuild_model_ReconciliationState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Reconcilied.prototype.$classData = $d_Lreactbuild_model_Reconcilied;
/** @constructor */
function $c_Lreactbuild_model_ReconciliedDeliveryFormDetails(id, document, supplier, entryLine, deliveredQuantity, amount) {
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id = null;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document = null;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier = null;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine = null;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity = 0.0;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount = null;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id = id;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document = document;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier = supplier;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine = entryLine;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity = deliveredQuantity;
  this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount = amount
}
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype = new $h_Lreactbuild_model_DeliveryFormDetails();
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.constructor = $c_Lreactbuild_model_ReconciliedDeliveryFormDetails;
/** @constructor */
function $h_Lreactbuild_model_ReconciliedDeliveryFormDetails() {
  /*<skip>*/
}
$h_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype = $c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype;
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.deliveredQuantity__D = (function() {
  return this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.amount__s_Option = (function() {
  return this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.asReconcilied__s_Option = (function() {
  return new $c_s_Some(this)
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.isSameLine__Lreactbuild_common_model_RefTo__ju_UUID__Z = (function(document, line) {
  var x = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
  if (((x === null) ? (document === null) : $n(x).equals__O__Z(document))) {
    var x$3 = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
    return ((x$3 === null) ? (line === null) : $n(x$3).equals__O__Z(line))
  } else {
    return false
  }
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.productPrefix__T = (function() {
  return "ReconciliedDeliveryFormDetails"
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
      break
    }
    case 2: {
      return this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier;
      break
    }
    case 3: {
      return this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
      break
    }
    case 4: {
      return this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity;
      break
    }
    case 5: {
      return this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ReconciliedDeliveryFormDetails");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var dv = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity;
  var data$5 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ReconciliedDeliveryFormDetails)) {
    var ReconciliedDeliveryFormDetails$1 = $as_Lreactbuild_model_ReconciliedDeliveryFormDetails(x$1);
    if ((this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity === $n(ReconciliedDeliveryFormDetails$1).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_deliveredQuantity)) {
      var x = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id;
      var x$2 = $n(ReconciliedDeliveryFormDetails$1).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_id;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
        var x$4 = $n(ReconciliedDeliveryFormDetails$1).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_document;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier;
      var x$6 = $n(ReconciliedDeliveryFormDetails$1).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_supplier;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
        var x$8 = $n(ReconciliedDeliveryFormDetails$1).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_entryLine;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount;
          var x$10 = $n(ReconciliedDeliveryFormDetails$1).Lreactbuild_model_ReconciliedDeliveryFormDetails__f_amount;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ReconciliedDeliveryFormDetails(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ReconciliedDeliveryFormDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ReconciliedDeliveryFormDetails"))
}
function $isArrayOf_Lreactbuild_model_ReconciliedDeliveryFormDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ReconciliedDeliveryFormDetails)))
}
function $asArrayOf_Lreactbuild_model_ReconciliedDeliveryFormDetails(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ReconciliedDeliveryFormDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ReconciliedDeliveryFormDetails;", depth))
}
var $d_Lreactbuild_model_ReconciliedDeliveryFormDetails = new $TypeData().initClass({
  Lreactbuild_model_ReconciliedDeliveryFormDetails: 0
}, false, "reactbuild.model.ReconciliedDeliveryFormDetails", {
  Lreactbuild_model_ReconciliedDeliveryFormDetails: 1,
  Lreactbuild_model_DeliveryFormDetails: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ReconciliedDeliveryFormDetails.prototype.$classData = $d_Lreactbuild_model_ReconciliedDeliveryFormDetails;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$Document(ref) {
  this.Lreactbuild_model_SearchResult$Document__f_ref = null;
  this.Lreactbuild_model_SearchResult$Document__f_ref = ref
}
$c_Lreactbuild_model_SearchResult$Document.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$Document.prototype.constructor = $c_Lreactbuild_model_SearchResult$Document;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$Document() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$Document.prototype = $c_Lreactbuild_model_SearchResult$Document.prototype;
$c_Lreactbuild_model_SearchResult$Document.prototype.productPrefix__T = (function() {
  return "Document"
});
$c_Lreactbuild_model_SearchResult$Document.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_SearchResult$Document.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_SearchResult$Document__f_ref : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_SearchResult$Document.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_SearchResult$Document.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_SearchResult$Document.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_SearchResult$Document.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_SearchResult$Document)) {
    var Document$1 = $as_Lreactbuild_model_SearchResult$Document(x$1);
    var x = this.Lreactbuild_model_SearchResult$Document__f_ref;
    var x$2 = $n(Document$1).Lreactbuild_model_SearchResult$Document__f_ref;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_SearchResult$Document(obj) {
  return (((obj instanceof $c_Lreactbuild_model_SearchResult$Document) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.SearchResult$Document"))
}
function $isArrayOf_Lreactbuild_model_SearchResult$Document(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_SearchResult$Document)))
}
function $asArrayOf_Lreactbuild_model_SearchResult$Document(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_SearchResult$Document(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.SearchResult$Document;", depth))
}
var $d_Lreactbuild_model_SearchResult$Document = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$Document: 0
}, false, "reactbuild.model.SearchResult$Document", {
  Lreactbuild_model_SearchResult$Document: 1,
  O: 1,
  Lreactbuild_model_SearchResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$Document.prototype.$classData = $d_Lreactbuild_model_SearchResult$Document;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$Person(ref) {
  this.Lreactbuild_model_SearchResult$Person__f_ref = null;
  this.Lreactbuild_model_SearchResult$Person__f_ref = ref
}
$c_Lreactbuild_model_SearchResult$Person.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$Person.prototype.constructor = $c_Lreactbuild_model_SearchResult$Person;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$Person() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$Person.prototype = $c_Lreactbuild_model_SearchResult$Person.prototype;
$c_Lreactbuild_model_SearchResult$Person.prototype.productPrefix__T = (function() {
  return "Person"
});
$c_Lreactbuild_model_SearchResult$Person.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_SearchResult$Person.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_SearchResult$Person__f_ref : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_SearchResult$Person.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_SearchResult$Person.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_SearchResult$Person.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_SearchResult$Person.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_SearchResult$Person)) {
    var Person$1 = $as_Lreactbuild_model_SearchResult$Person(x$1);
    var x = this.Lreactbuild_model_SearchResult$Person__f_ref;
    var x$2 = $n(Person$1).Lreactbuild_model_SearchResult$Person__f_ref;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_SearchResult$Person(obj) {
  return (((obj instanceof $c_Lreactbuild_model_SearchResult$Person) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.SearchResult$Person"))
}
function $isArrayOf_Lreactbuild_model_SearchResult$Person(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_SearchResult$Person)))
}
function $asArrayOf_Lreactbuild_model_SearchResult$Person(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_SearchResult$Person(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.SearchResult$Person;", depth))
}
var $d_Lreactbuild_model_SearchResult$Person = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$Person: 0
}, false, "reactbuild.model.SearchResult$Person", {
  Lreactbuild_model_SearchResult$Person: 1,
  O: 1,
  Lreactbuild_model_SearchResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$Person.prototype.$classData = $d_Lreactbuild_model_SearchResult$Person;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$PersonReference(item) {
  this.Lreactbuild_model_SearchResult$PersonReference__f_item = null;
  this.Lreactbuild_model_SearchResult$PersonReference__f_item = item
}
$c_Lreactbuild_model_SearchResult$PersonReference.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$PersonReference.prototype.constructor = $c_Lreactbuild_model_SearchResult$PersonReference;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$PersonReference() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$PersonReference.prototype = $c_Lreactbuild_model_SearchResult$PersonReference.prototype;
$c_Lreactbuild_model_SearchResult$PersonReference.prototype.productPrefix__T = (function() {
  return "PersonReference"
});
$c_Lreactbuild_model_SearchResult$PersonReference.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_SearchResult$PersonReference.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_SearchResult$PersonReference__f_item : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_SearchResult$PersonReference.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_SearchResult$PersonReference.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_SearchResult$PersonReference.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_SearchResult$PersonReference.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_SearchResult$PersonReference)) {
    var PersonReference$1 = $as_Lreactbuild_model_SearchResult$PersonReference(x$1);
    var x = this.Lreactbuild_model_SearchResult$PersonReference__f_item;
    var x$2 = $n(PersonReference$1).Lreactbuild_model_SearchResult$PersonReference__f_item;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_SearchResult$PersonReference(obj) {
  return (((obj instanceof $c_Lreactbuild_model_SearchResult$PersonReference) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.SearchResult$PersonReference"))
}
function $isArrayOf_Lreactbuild_model_SearchResult$PersonReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_SearchResult$PersonReference)))
}
function $asArrayOf_Lreactbuild_model_SearchResult$PersonReference(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_SearchResult$PersonReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.SearchResult$PersonReference;", depth))
}
var $d_Lreactbuild_model_SearchResult$PersonReference = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$PersonReference: 0
}, false, "reactbuild.model.SearchResult$PersonReference", {
  Lreactbuild_model_SearchResult$PersonReference: 1,
  O: 1,
  Lreactbuild_model_SearchResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$PersonReference.prototype.$classData = $d_Lreactbuild_model_SearchResult$PersonReference;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$Project(ref) {
  this.Lreactbuild_model_SearchResult$Project__f_ref = null;
  this.Lreactbuild_model_SearchResult$Project__f_ref = ref
}
$c_Lreactbuild_model_SearchResult$Project.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$Project.prototype.constructor = $c_Lreactbuild_model_SearchResult$Project;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$Project() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$Project.prototype = $c_Lreactbuild_model_SearchResult$Project.prototype;
$c_Lreactbuild_model_SearchResult$Project.prototype.productPrefix__T = (function() {
  return "Project"
});
$c_Lreactbuild_model_SearchResult$Project.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_SearchResult$Project.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_SearchResult$Project__f_ref : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_SearchResult$Project.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_SearchResult$Project.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_SearchResult$Project.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_SearchResult$Project.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_SearchResult$Project)) {
    var Project$1 = $as_Lreactbuild_model_SearchResult$Project(x$1);
    var x = this.Lreactbuild_model_SearchResult$Project__f_ref;
    var x$2 = $n(Project$1).Lreactbuild_model_SearchResult$Project__f_ref;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_SearchResult$Project(obj) {
  return (((obj instanceof $c_Lreactbuild_model_SearchResult$Project) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.SearchResult$Project"))
}
function $isArrayOf_Lreactbuild_model_SearchResult$Project(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_SearchResult$Project)))
}
function $asArrayOf_Lreactbuild_model_SearchResult$Project(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_SearchResult$Project(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.SearchResult$Project;", depth))
}
var $d_Lreactbuild_model_SearchResult$Project = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$Project: 0
}, false, "reactbuild.model.SearchResult$Project", {
  Lreactbuild_model_SearchResult$Project: 1,
  O: 1,
  Lreactbuild_model_SearchResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$Project.prototype.$classData = $d_Lreactbuild_model_SearchResult$Project;
/** @constructor */
function $c_Lreactbuild_model_TaskRole$From$() {
  /*<skip>*/
}
$c_Lreactbuild_model_TaskRole$From$.prototype = new $h_O();
$c_Lreactbuild_model_TaskRole$From$.prototype.constructor = $c_Lreactbuild_model_TaskRole$From$;
/** @constructor */
function $h_Lreactbuild_model_TaskRole$From$() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskRole$From$.prototype = $c_Lreactbuild_model_TaskRole$From$.prototype;
$c_Lreactbuild_model_TaskRole$From$.prototype.productPrefix__T = (function() {
  return "From"
});
$c_Lreactbuild_model_TaskRole$From$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_TaskRole$From$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_TaskRole$From$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_TaskRole$From$.prototype.hashCode__I = (function() {
  return 2198474
});
$c_Lreactbuild_model_TaskRole$From$.prototype.toString__T = (function() {
  return "From"
});
function $as_Lreactbuild_model_TaskRole$From$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_TaskRole$From$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TaskRole$From$"))
}
function $isArrayOf_Lreactbuild_model_TaskRole$From$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TaskRole$From$)))
}
function $asArrayOf_Lreactbuild_model_TaskRole$From$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TaskRole$From$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TaskRole$From$;", depth))
}
var $d_Lreactbuild_model_TaskRole$From$ = new $TypeData().initClass({
  Lreactbuild_model_TaskRole$From$: 0
}, false, "reactbuild.model.TaskRole$From$", {
  Lreactbuild_model_TaskRole$From$: 1,
  O: 1,
  Lreactbuild_model_TaskRole: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskRole$From$.prototype.$classData = $d_Lreactbuild_model_TaskRole$From$;
var $n_Lreactbuild_model_TaskRole$From$;
function $m_Lreactbuild_model_TaskRole$From$() {
  if ((!$n_Lreactbuild_model_TaskRole$From$)) {
    $n_Lreactbuild_model_TaskRole$From$ = new $c_Lreactbuild_model_TaskRole$From$()
  };
  return $n_Lreactbuild_model_TaskRole$From$
}
/** @constructor */
function $c_Lreactbuild_model_TaskRole$To$() {
  /*<skip>*/
}
$c_Lreactbuild_model_TaskRole$To$.prototype = new $h_O();
$c_Lreactbuild_model_TaskRole$To$.prototype.constructor = $c_Lreactbuild_model_TaskRole$To$;
/** @constructor */
function $h_Lreactbuild_model_TaskRole$To$() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskRole$To$.prototype = $c_Lreactbuild_model_TaskRole$To$.prototype;
$c_Lreactbuild_model_TaskRole$To$.prototype.productPrefix__T = (function() {
  return "To"
});
$c_Lreactbuild_model_TaskRole$To$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_TaskRole$To$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_TaskRole$To$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_TaskRole$To$.prototype.hashCode__I = (function() {
  return 2715
});
$c_Lreactbuild_model_TaskRole$To$.prototype.toString__T = (function() {
  return "To"
});
function $as_Lreactbuild_model_TaskRole$To$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_TaskRole$To$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TaskRole$To$"))
}
function $isArrayOf_Lreactbuild_model_TaskRole$To$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TaskRole$To$)))
}
function $asArrayOf_Lreactbuild_model_TaskRole$To$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TaskRole$To$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TaskRole$To$;", depth))
}
var $d_Lreactbuild_model_TaskRole$To$ = new $TypeData().initClass({
  Lreactbuild_model_TaskRole$To$: 0
}, false, "reactbuild.model.TaskRole$To$", {
  Lreactbuild_model_TaskRole$To$: 1,
  O: 1,
  Lreactbuild_model_TaskRole: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskRole$To$.prototype.$classData = $d_Lreactbuild_model_TaskRole$To$;
var $n_Lreactbuild_model_TaskRole$To$;
function $m_Lreactbuild_model_TaskRole$To$() {
  if ((!$n_Lreactbuild_model_TaskRole$To$)) {
    $n_Lreactbuild_model_TaskRole$To$ = new $c_Lreactbuild_model_TaskRole$To$()
  };
  return $n_Lreactbuild_model_TaskRole$To$
}
/** @constructor */
function $c_Lreactbuild_model_TaskTaskAttachment(id, target) {
  this.Lreactbuild_model_TaskTaskAttachment__f_id = null;
  this.Lreactbuild_model_TaskTaskAttachment__f_target = null;
  this.Lreactbuild_model_TaskTaskAttachment__f_id = id;
  this.Lreactbuild_model_TaskTaskAttachment__f_target = target
}
$c_Lreactbuild_model_TaskTaskAttachment.prototype = new $h_O();
$c_Lreactbuild_model_TaskTaskAttachment.prototype.constructor = $c_Lreactbuild_model_TaskTaskAttachment;
/** @constructor */
function $h_Lreactbuild_model_TaskTaskAttachment() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskTaskAttachment.prototype = $c_Lreactbuild_model_TaskTaskAttachment.prototype;
$c_Lreactbuild_model_TaskTaskAttachment.prototype.productPrefix__T = (function() {
  return "TaskTaskAttachment"
});
$c_Lreactbuild_model_TaskTaskAttachment.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_TaskTaskAttachment.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_TaskTaskAttachment__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_TaskTaskAttachment__f_target;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_TaskTaskAttachment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_TaskTaskAttachment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_TaskTaskAttachment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_TaskTaskAttachment.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_TaskTaskAttachment)) {
    var TaskTaskAttachment$1 = $as_Lreactbuild_model_TaskTaskAttachment(x$1);
    var x = this.Lreactbuild_model_TaskTaskAttachment__f_id;
    var x$2 = $n(TaskTaskAttachment$1).Lreactbuild_model_TaskTaskAttachment__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_TaskTaskAttachment__f_target;
      var x$4 = $n(TaskTaskAttachment$1).Lreactbuild_model_TaskTaskAttachment__f_target;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_TaskTaskAttachment(obj) {
  return (((obj instanceof $c_Lreactbuild_model_TaskTaskAttachment) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TaskTaskAttachment"))
}
function $isArrayOf_Lreactbuild_model_TaskTaskAttachment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TaskTaskAttachment)))
}
function $asArrayOf_Lreactbuild_model_TaskTaskAttachment(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TaskTaskAttachment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TaskTaskAttachment;", depth))
}
var $d_Lreactbuild_model_TaskTaskAttachment = new $TypeData().initClass({
  Lreactbuild_model_TaskTaskAttachment: 0
}, false, "reactbuild.model.TaskTaskAttachment", {
  Lreactbuild_model_TaskTaskAttachment: 1,
  O: 1,
  Lreactbuild_model_TaskAttachment: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskTaskAttachment.prototype.$classData = $d_Lreactbuild_model_TaskTaskAttachment;
/** @constructor */
function $c_Lreactbuild_model_TextCommunicationBody(textSource) {
  this.Lreactbuild_model_TextCommunicationBody__f_textSource = null;
  this.Lreactbuild_model_TextCommunicationBody__f_textSource = textSource
}
$c_Lreactbuild_model_TextCommunicationBody.prototype = new $h_O();
$c_Lreactbuild_model_TextCommunicationBody.prototype.constructor = $c_Lreactbuild_model_TextCommunicationBody;
/** @constructor */
function $h_Lreactbuild_model_TextCommunicationBody() {
  /*<skip>*/
}
$h_Lreactbuild_model_TextCommunicationBody.prototype = $c_Lreactbuild_model_TextCommunicationBody.prototype;
$c_Lreactbuild_model_TextCommunicationBody.prototype.productPrefix__T = (function() {
  return "TextCommunicationBody"
});
$c_Lreactbuild_model_TextCommunicationBody.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_TextCommunicationBody.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_TextCommunicationBody__f_textSource : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_TextCommunicationBody.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_TextCommunicationBody.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_TextCommunicationBody.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_TextCommunicationBody.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_TextCommunicationBody)) {
    var TextCommunicationBody$1 = $as_Lreactbuild_model_TextCommunicationBody(x$1);
    return (this.Lreactbuild_model_TextCommunicationBody__f_textSource === $n(TextCommunicationBody$1).Lreactbuild_model_TextCommunicationBody__f_textSource)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_TextCommunicationBody(obj) {
  return (((obj instanceof $c_Lreactbuild_model_TextCommunicationBody) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.TextCommunicationBody"))
}
function $isArrayOf_Lreactbuild_model_TextCommunicationBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_TextCommunicationBody)))
}
function $asArrayOf_Lreactbuild_model_TextCommunicationBody(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_TextCommunicationBody(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.TextCommunicationBody;", depth))
}
var $d_Lreactbuild_model_TextCommunicationBody = new $TypeData().initClass({
  Lreactbuild_model_TextCommunicationBody: 0
}, false, "reactbuild.model.TextCommunicationBody", {
  Lreactbuild_model_TextCommunicationBody: 1,
  O: 1,
  Lreactbuild_model_CommunicationBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TextCommunicationBody.prototype.$classData = $d_Lreactbuild_model_TextCommunicationBody;
/** @constructor */
function $c_Lreactbuild_model_UnreconciliedLeft(left) {
  this.Lreactbuild_model_UnreconciliedLeft__f_left = null;
  this.Lreactbuild_model_UnreconciliedLeft__f_left = left
}
$c_Lreactbuild_model_UnreconciliedLeft.prototype = new $h_Lreactbuild_model_ReconciliationState();
$c_Lreactbuild_model_UnreconciliedLeft.prototype.constructor = $c_Lreactbuild_model_UnreconciliedLeft;
/** @constructor */
function $h_Lreactbuild_model_UnreconciliedLeft() {
  /*<skip>*/
}
$h_Lreactbuild_model_UnreconciliedLeft.prototype = $c_Lreactbuild_model_UnreconciliedLeft.prototype;
$c_Lreactbuild_model_UnreconciliedLeft.prototype.foldLeft__F0__F1__O = (function(ifEmpty, f) {
  return $n(f).apply__O__O(this.Lreactbuild_model_UnreconciliedLeft__f_left)
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.foldRight__F0__F1__O = (function(ifEmpty, f) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.leftOption__s_Option = (function() {
  return new $c_s_Some(this.Lreactbuild_model_UnreconciliedLeft__f_left)
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.rightOption__s_Option = (function() {
  return $m_s_None$()
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.fold__F1__F2__F1__O = (function(ifLeftOnly, ifReconcilied, ifRightOnly) {
  return $n(ifLeftOnly).apply__O__O(this.Lreactbuild_model_UnreconciliedLeft__f_left)
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.productPrefix__T = (function() {
  return "UnreconciliedLeft"
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_UnreconciliedLeft__f_left : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_UnreconciliedLeft)) {
    var UnreconciliedLeft$1 = $as_Lreactbuild_model_UnreconciliedLeft(x$1);
    var x = this.Lreactbuild_model_UnreconciliedLeft__f_left;
    var y = $n(UnreconciliedLeft$1).Lreactbuild_model_UnreconciliedLeft__f_left;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_UnreconciliedLeft(obj) {
  return (((obj instanceof $c_Lreactbuild_model_UnreconciliedLeft) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.UnreconciliedLeft"))
}
function $isArrayOf_Lreactbuild_model_UnreconciliedLeft(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_UnreconciliedLeft)))
}
function $asArrayOf_Lreactbuild_model_UnreconciliedLeft(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_UnreconciliedLeft(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.UnreconciliedLeft;", depth))
}
var $d_Lreactbuild_model_UnreconciliedLeft = new $TypeData().initClass({
  Lreactbuild_model_UnreconciliedLeft: 0
}, false, "reactbuild.model.UnreconciliedLeft", {
  Lreactbuild_model_UnreconciliedLeft: 1,
  Lreactbuild_model_ReconciliationState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_UnreconciliedLeft.prototype.$classData = $d_Lreactbuild_model_UnreconciliedLeft;
/** @constructor */
function $c_Lreactbuild_model_UnreconciliedRight(right) {
  this.Lreactbuild_model_UnreconciliedRight__f_right = null;
  this.Lreactbuild_model_UnreconciliedRight__f_right = right
}
$c_Lreactbuild_model_UnreconciliedRight.prototype = new $h_Lreactbuild_model_ReconciliationState();
$c_Lreactbuild_model_UnreconciliedRight.prototype.constructor = $c_Lreactbuild_model_UnreconciliedRight;
/** @constructor */
function $h_Lreactbuild_model_UnreconciliedRight() {
  /*<skip>*/
}
$h_Lreactbuild_model_UnreconciliedRight.prototype = $c_Lreactbuild_model_UnreconciliedRight.prototype;
$c_Lreactbuild_model_UnreconciliedRight.prototype.foldLeft__F0__F1__O = (function(ifEmpty, f) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.foldRight__F0__F1__O = (function(ifEmpty, f) {
  return $n(f).apply__O__O(this.Lreactbuild_model_UnreconciliedRight__f_right)
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.leftOption__s_Option = (function() {
  return $m_s_None$()
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.rightOption__s_Option = (function() {
  return new $c_s_Some(this.Lreactbuild_model_UnreconciliedRight__f_right)
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.fold__F1__F2__F1__O = (function(ifLeftOnly, ifReconcilied, ifRightOnly) {
  return $n(ifRightOnly).apply__O__O(this.Lreactbuild_model_UnreconciliedRight__f_right)
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.productPrefix__T = (function() {
  return "UnreconciliedRight"
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_UnreconciliedRight__f_right : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_UnreconciliedRight)) {
    var UnreconciliedRight$1 = $as_Lreactbuild_model_UnreconciliedRight(x$1);
    var x = this.Lreactbuild_model_UnreconciliedRight__f_right;
    var y = $n(UnreconciliedRight$1).Lreactbuild_model_UnreconciliedRight__f_right;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_UnreconciliedRight(obj) {
  return (((obj instanceof $c_Lreactbuild_model_UnreconciliedRight) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.UnreconciliedRight"))
}
function $isArrayOf_Lreactbuild_model_UnreconciliedRight(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_UnreconciliedRight)))
}
function $asArrayOf_Lreactbuild_model_UnreconciliedRight(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_UnreconciliedRight(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.UnreconciliedRight;", depth))
}
var $d_Lreactbuild_model_UnreconciliedRight = new $TypeData().initClass({
  Lreactbuild_model_UnreconciliedRight: 0
}, false, "reactbuild.model.UnreconciliedRight", {
  Lreactbuild_model_UnreconciliedRight: 1,
  Lreactbuild_model_ReconciliationState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_UnreconciliedRight.prototype.$classData = $d_Lreactbuild_model_UnreconciliedRight;
/** @constructor */
function $c_Lreactbuild_model_UpdateCursorLocation(projectRef, x, y) {
  this.Lreactbuild_model_UpdateCursorLocation__f_projectRef = null;
  this.Lreactbuild_model_UpdateCursorLocation__f_x = 0.0;
  this.Lreactbuild_model_UpdateCursorLocation__f_y = 0.0;
  this.Lreactbuild_model_UpdateCursorLocation__f_projectRef = projectRef;
  this.Lreactbuild_model_UpdateCursorLocation__f_x = x;
  this.Lreactbuild_model_UpdateCursorLocation__f_y = y
}
$c_Lreactbuild_model_UpdateCursorLocation.prototype = new $h_O();
$c_Lreactbuild_model_UpdateCursorLocation.prototype.constructor = $c_Lreactbuild_model_UpdateCursorLocation;
/** @constructor */
function $h_Lreactbuild_model_UpdateCursorLocation() {
  /*<skip>*/
}
$h_Lreactbuild_model_UpdateCursorLocation.prototype = $c_Lreactbuild_model_UpdateCursorLocation.prototype;
$c_Lreactbuild_model_UpdateCursorLocation.prototype.productPrefix__T = (function() {
  return "UpdateCursorLocation"
});
$c_Lreactbuild_model_UpdateCursorLocation.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_model_UpdateCursorLocation.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_UpdateCursorLocation__f_projectRef;
      break
    }
    case 1: {
      return this.Lreactbuild_model_UpdateCursorLocation__f_x;
      break
    }
    case 2: {
      return this.Lreactbuild_model_UpdateCursorLocation__f_y;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_UpdateCursorLocation.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_UpdateCursorLocation.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("UpdateCursorLocation");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_model_UpdateCursorLocation__f_projectRef;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_model_UpdateCursorLocation__f_x;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$1 = this.Lreactbuild_model_UpdateCursorLocation__f_y;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_model_UpdateCursorLocation.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_UpdateCursorLocation.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_UpdateCursorLocation)) {
    var UpdateCursorLocation$1 = $as_Lreactbuild_model_UpdateCursorLocation(x$1);
    if ((this.Lreactbuild_model_UpdateCursorLocation__f_x === $n(UpdateCursorLocation$1).Lreactbuild_model_UpdateCursorLocation__f_x)) {
      if ((this.Lreactbuild_model_UpdateCursorLocation__f_y === $n(UpdateCursorLocation$1).Lreactbuild_model_UpdateCursorLocation__f_y)) {
        var x = this.Lreactbuild_model_UpdateCursorLocation__f_projectRef;
        var x$2 = $n(UpdateCursorLocation$1).Lreactbuild_model_UpdateCursorLocation__f_projectRef;
        return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_UpdateCursorLocation(obj) {
  return (((obj instanceof $c_Lreactbuild_model_UpdateCursorLocation) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.UpdateCursorLocation"))
}
function $isArrayOf_Lreactbuild_model_UpdateCursorLocation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_UpdateCursorLocation)))
}
function $asArrayOf_Lreactbuild_model_UpdateCursorLocation(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_UpdateCursorLocation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.UpdateCursorLocation;", depth))
}
var $d_Lreactbuild_model_UpdateCursorLocation = new $TypeData().initClass({
  Lreactbuild_model_UpdateCursorLocation: 0
}, false, "reactbuild.model.UpdateCursorLocation", {
  Lreactbuild_model_UpdateCursorLocation: 1,
  O: 1,
  Lreactbuild_model_FromClient: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_UpdateCursorLocation.prototype.$classData = $d_Lreactbuild_model_UpdateCursorLocation;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(message) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Comment__f_message = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Comment__f_message = message
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype.productPrefix__T = (function() {
  return "Comment"
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? new $c_Lcom_iz2use_common_Multiline(this.Lreactbuild_model_process_ProcessInstanceEventDetails$Comment__f_message) : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment)) {
    var Comment$1 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(x$1);
    return (this.Lreactbuild_model_process_ProcessInstanceEventDetails$Comment__f_message === $n(Comment$1).Lreactbuild_model_process_ProcessInstanceEventDetails$Comment__f_message)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessInstanceEventDetails$Comment"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessInstanceEventDetails$Comment)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessInstanceEventDetails$Comment;", depth))
}
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$Comment: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$Comment", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$Comment: 1,
  O: 1,
  Lreactbuild_model_process_ProcessInstanceEventDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(node) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Done__f_node = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Done__f_node = node
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$Done() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype.productPrefix__T = (function() {
  return "Done"
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_process_ProcessInstanceEventDetails$Done__f_node : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done)) {
    var Done$1 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(x$1);
    var x = this.Lreactbuild_model_process_ProcessInstanceEventDetails$Done__f_node;
    var x$2 = $n(Done$1).Lreactbuild_model_process_ProcessInstanceEventDetails$Done__f_node;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessInstanceEventDetails$Done"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessInstanceEventDetails$Done)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Done(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessInstanceEventDetails$Done;", depth))
}
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$Done = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$Done: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$Done", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$Done: 1,
  O: 1,
  Lreactbuild_model_process_ProcessInstanceEventDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Done.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$Done;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(process, customProcessName) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_process = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_customProcessName = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_process = process;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_customProcessName = customProcessName
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype.productPrefix__T = (function() {
  return "Instantiate"
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_process;
      break
    }
    case 1: {
      return this.Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_customProcessName;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate)) {
    var Instantiate$1 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(x$1);
    var x = this.Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_process;
    var x$2 = $n(Instantiate$1).Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_process;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_customProcessName;
      var x$4 = $n(Instantiate$1).Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate__f_customProcessName;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessInstanceEventDetails$Instantiate"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessInstanceEventDetails$Instantiate;", depth))
}
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$Instantiate", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate: 1,
  O: 1,
  Lreactbuild_model_process_ProcessInstanceEventDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(details) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Link__f_details = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$Link__f_details = details
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$Link() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype.productPrefix__T = (function() {
  return "Link"
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_process_ProcessInstanceEventDetails$Link__f_details : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link)) {
    var Link$1 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(x$1);
    var x = this.Lreactbuild_model_process_ProcessInstanceEventDetails$Link__f_details;
    var x$2 = $n(Link$1).Lreactbuild_model_process_ProcessInstanceEventDetails$Link__f_details;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessInstanceEventDetails$Link"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessInstanceEventDetails$Link)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$Link(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessInstanceEventDetails$Link;", depth))
}
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$Link = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$Link: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$Link", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$Link: 1,
  O: 1,
  Lreactbuild_model_process_ProcessInstanceEventDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$Link.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$Link;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(ref, value) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_ref = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_value = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_ref = ref;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_value = value
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype.productPrefix__T = (function() {
  return "SetStepDate"
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_ref;
      break
    }
    case 1: {
      return this.Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_value;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate)) {
    var SetStepDate$1 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(x$1);
    var x = this.Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_ref;
    var x$2 = $n(SetStepDate$1).Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_ref;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_value;
      var x$4 = $n(SetStepDate$1).Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate__f_value;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessInstanceEventDetails$SetStepDate"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessInstanceEventDetails$SetStepDate;", depth))
}
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$SetStepDate", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate: 1,
  O: 1,
  Lreactbuild_model_process_ProcessInstanceEventDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLinkClass$Person$() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype.constructor = $c_Lreactbuild_model_process_ProcessLinkClass$Person$;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLinkClass$Person$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype = $c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype;
$c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype.productPrefix__T = (function() {
  return "Person"
});
$c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype.hashCode__I = (function() {
  return (-1907849355)
});
$c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype.toString__T = (function() {
  return "Person"
});
function $as_Lreactbuild_model_process_ProcessLinkClass$Person$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessLinkClass$Person$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessLinkClass$Person$"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessLinkClass$Person$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessLinkClass$Person$)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessLinkClass$Person$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessLinkClass$Person$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessLinkClass$Person$;", depth))
}
var $d_Lreactbuild_model_process_ProcessLinkClass$Person$ = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLinkClass$Person$: 0
}, false, "reactbuild.model.process.ProcessLinkClass$Person$", {
  Lreactbuild_model_process_ProcessLinkClass$Person$: 1,
  O: 1,
  Lreactbuild_model_process_ProcessLinkClass: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessLinkClass$Person$.prototype.$classData = $d_Lreactbuild_model_process_ProcessLinkClass$Person$;
var $n_Lreactbuild_model_process_ProcessLinkClass$Person$;
function $m_Lreactbuild_model_process_ProcessLinkClass$Person$() {
  if ((!$n_Lreactbuild_model_process_ProcessLinkClass$Person$)) {
    $n_Lreactbuild_model_process_ProcessLinkClass$Person$ = new $c_Lreactbuild_model_process_ProcessLinkClass$Person$()
  };
  return $n_Lreactbuild_model_process_ProcessLinkClass$Person$
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLinkClass$Project$() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype.constructor = $c_Lreactbuild_model_process_ProcessLinkClass$Project$;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLinkClass$Project$() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype = $c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype;
$c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype.productPrefix__T = (function() {
  return "Project"
});
$c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype.hashCode__I = (function() {
  return 1355342585
});
$c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype.toString__T = (function() {
  return "Project"
});
function $as_Lreactbuild_model_process_ProcessLinkClass$Project$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessLinkClass$Project$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessLinkClass$Project$"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessLinkClass$Project$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessLinkClass$Project$)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessLinkClass$Project$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessLinkClass$Project$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessLinkClass$Project$;", depth))
}
var $d_Lreactbuild_model_process_ProcessLinkClass$Project$ = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLinkClass$Project$: 0
}, false, "reactbuild.model.process.ProcessLinkClass$Project$", {
  Lreactbuild_model_process_ProcessLinkClass$Project$: 1,
  O: 1,
  Lreactbuild_model_process_ProcessLinkClass: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessLinkClass$Project$.prototype.$classData = $d_Lreactbuild_model_process_ProcessLinkClass$Project$;
var $n_Lreactbuild_model_process_ProcessLinkClass$Project$;
function $m_Lreactbuild_model_process_ProcessLinkClass$Project$() {
  if ((!$n_Lreactbuild_model_process_ProcessLinkClass$Project$)) {
    $n_Lreactbuild_model_process_ProcessLinkClass$Project$ = new $c_Lreactbuild_model_process_ProcessLinkClass$Project$()
  };
  return $n_Lreactbuild_model_process_ProcessLinkClass$Project$
}
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$Ask() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$Ask;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$Ask() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype.productPrefix__T = (function() {
  return "Ask"
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Ask)
});
function $as_Lreactbuild_model_process_ProcessNodeDetails$Ask(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Ask) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails$Ask"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Ask(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails$Ask)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Ask(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Ask(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails$Ask;", depth))
}
var $d_Lreactbuild_model_process_ProcessNodeDetails$Ask = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$Ask: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$Ask", {
  Lreactbuild_model_process_ProcessNodeDetails$Ask: 1,
  O: 1,
  Lreactbuild_model_process_ProcessNodeDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Ask.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$Ask;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$End() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$End;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$End() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$End.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype.productPrefix__T = (function() {
  return "End"
});
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$End)
});
function $as_Lreactbuild_model_process_ProcessNodeDetails$End(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$End) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails$End"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$End(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails$End)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails$End(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$End(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails$End;", depth))
}
var $d_Lreactbuild_model_process_ProcessNodeDetails$End = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$End: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$End", {
  Lreactbuild_model_process_ProcessNodeDetails$End: 1,
  O: 1,
  Lreactbuild_model_process_ProcessNodeDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$End.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$End;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$Milestone() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$Milestone;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$Milestone() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype.productPrefix__T = (function() {
  return "Milestone"
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Milestone)
});
function $as_Lreactbuild_model_process_ProcessNodeDetails$Milestone(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Milestone) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails$Milestone"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Milestone(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails$Milestone)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Milestone(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Milestone(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails$Milestone;", depth))
}
var $d_Lreactbuild_model_process_ProcessNodeDetails$Milestone = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$Milestone: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$Milestone", {
  Lreactbuild_model_process_ProcessNodeDetails$Milestone: 1,
  O: 1,
  Lreactbuild_model_process_ProcessNodeDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Milestone.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$Milestone;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$Receive() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$Receive;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$Receive() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype.productPrefix__T = (function() {
  return "Receive"
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Receive)
});
function $as_Lreactbuild_model_process_ProcessNodeDetails$Receive(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Receive) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails$Receive"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Receive(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails$Receive)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Receive(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Receive(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails$Receive;", depth))
}
var $d_Lreactbuild_model_process_ProcessNodeDetails$Receive = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$Receive: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$Receive", {
  Lreactbuild_model_process_ProcessNodeDetails$Receive: 1,
  O: 1,
  Lreactbuild_model_process_ProcessNodeDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Receive.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$Receive;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$Send() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$Send;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$Send() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype.productPrefix__T = (function() {
  return "Send"
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Send)
});
function $as_Lreactbuild_model_process_ProcessNodeDetails$Send(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Send) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails$Send"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Send(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails$Send)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Send(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Send(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails$Send;", depth))
}
var $d_Lreactbuild_model_process_ProcessNodeDetails$Send = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$Send: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$Send", {
  Lreactbuild_model_process_ProcessNodeDetails$Send: 1,
  O: 1,
  Lreactbuild_model_process_ProcessNodeDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Send.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$Send;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$Start() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$Start;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$Start() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype.productPrefix__T = (function() {
  return "Start"
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Start)
});
function $as_Lreactbuild_model_process_ProcessNodeDetails$Start(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Start) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails$Start"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Start(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails$Start)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Start(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Start(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails$Start;", depth))
}
var $d_Lreactbuild_model_process_ProcessNodeDetails$Start = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$Start: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$Start", {
  Lreactbuild_model_process_ProcessNodeDetails$Start: 1,
  O: 1,
  Lreactbuild_model_process_ProcessNodeDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Start.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$Start;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$UserActivity() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype.productPrefix__T = (function() {
  return "UserActivity"
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity)
});
function $as_Lreactbuild_model_process_ProcessNodeDetails$UserActivity(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails$UserActivity"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$UserActivity(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails$UserActivity)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails$UserActivity(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$UserActivity(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails$UserActivity;", depth))
}
var $d_Lreactbuild_model_process_ProcessNodeDetails$UserActivity = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$UserActivity: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$UserActivity", {
  Lreactbuild_model_process_ProcessNodeDetails$UserActivity: 1,
  O: 1,
  Lreactbuild_model_process_ProcessNodeDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserActivity.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$UserActivity;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$UserInput() {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$UserInput;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$UserInput() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype.productPrefix__T = (function() {
  return "UserInput"
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$UserInput)
});
function $as_Lreactbuild_model_process_ProcessNodeDetails$UserInput(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$UserInput) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails$UserInput"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$UserInput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails$UserInput)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails$UserInput(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$UserInput(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails$UserInput;", depth))
}
var $d_Lreactbuild_model_process_ProcessNodeDetails$UserInput = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$UserInput: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$UserInput", {
  Lreactbuild_model_process_ProcessNodeDetails$UserInput: 1,
  O: 1,
  Lreactbuild_model_process_ProcessNodeDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$UserInput.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$UserInput;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$Wait(period) {
  this.Lreactbuild_model_process_ProcessNodeDetails$Wait__f_period = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$Wait__f_period = period
}
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$Wait;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$Wait() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype.productPrefix__T = (function() {
  return "Wait"
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_process_ProcessNodeDetails$Wait__f_period : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Wait)) {
    var Wait$1 = $as_Lreactbuild_model_process_ProcessNodeDetails$Wait(x$1);
    var x = this.Lreactbuild_model_process_ProcessNodeDetails$Wait__f_period;
    var x$2 = $n(Wait$1).Lreactbuild_model_process_ProcessNodeDetails$Wait__f_period;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessNodeDetails$Wait(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNodeDetails$Wait) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNodeDetails$Wait"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Wait(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNodeDetails$Wait)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Wait(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNodeDetails$Wait(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNodeDetails$Wait;", depth))
}
var $d_Lreactbuild_model_process_ProcessNodeDetails$Wait = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$Wait: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$Wait", {
  Lreactbuild_model_process_ProcessNodeDetails$Wait: 1,
  O: 1,
  Lreactbuild_model_process_ProcessNodeDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$Wait.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$Wait;
/** @constructor */
function $c_Lreactbuild_person_CustomFormat(documentFieldLevel) {
  this.Lreactbuild_person_CustomFormat__f_documentFieldLevel = null;
  this.Lreactbuild_person_CustomFormat__f_documentFieldLevel = documentFieldLevel
}
$c_Lreactbuild_person_CustomFormat.prototype = new $h_O();
$c_Lreactbuild_person_CustomFormat.prototype.constructor = $c_Lreactbuild_person_CustomFormat;
/** @constructor */
function $h_Lreactbuild_person_CustomFormat() {
  /*<skip>*/
}
$h_Lreactbuild_person_CustomFormat.prototype = $c_Lreactbuild_person_CustomFormat.prototype;
$c_Lreactbuild_person_CustomFormat.prototype.productPrefix__T = (function() {
  return "CustomFormat"
});
$c_Lreactbuild_person_CustomFormat.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_CustomFormat.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_CustomFormat__f_documentFieldLevel : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_CustomFormat.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_CustomFormat.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_CustomFormat.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_CustomFormat.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_CustomFormat)) {
    var CustomFormat$1 = $as_Lreactbuild_person_CustomFormat(x$1);
    var x = this.Lreactbuild_person_CustomFormat__f_documentFieldLevel;
    var x$2 = $n(CustomFormat$1).Lreactbuild_person_CustomFormat__f_documentFieldLevel;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_CustomFormat(obj) {
  return (((obj instanceof $c_Lreactbuild_person_CustomFormat) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.CustomFormat"))
}
function $isArrayOf_Lreactbuild_person_CustomFormat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_CustomFormat)))
}
function $asArrayOf_Lreactbuild_person_CustomFormat(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_CustomFormat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.CustomFormat;", depth))
}
var $d_Lreactbuild_person_CustomFormat = new $TypeData().initClass({
  Lreactbuild_person_CustomFormat: 0
}, false, "reactbuild.person.CustomFormat", {
  Lreactbuild_person_CustomFormat: 1,
  O: 1,
  Lreactbuild_person_DocumentParserFormat: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CustomFormat.prototype.$classData = $d_Lreactbuild_person_CustomFormat;
/** @constructor */
function $c_Lreactbuild_person_CustomerFacet() {
  /*<skip>*/
}
$c_Lreactbuild_person_CustomerFacet.prototype = new $h_O();
$c_Lreactbuild_person_CustomerFacet.prototype.constructor = $c_Lreactbuild_person_CustomerFacet;
/** @constructor */
function $h_Lreactbuild_person_CustomerFacet() {
  /*<skip>*/
}
$h_Lreactbuild_person_CustomerFacet.prototype = $c_Lreactbuild_person_CustomerFacet.prototype;
$c_Lreactbuild_person_CustomerFacet.prototype.productPrefix__T = (function() {
  return "CustomerFacet"
});
$c_Lreactbuild_person_CustomerFacet.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_person_CustomerFacet.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_person_CustomerFacet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_CustomerFacet.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_CustomerFacet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_CustomerFacet.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_person_CustomerFacet)
});
function $as_Lreactbuild_person_CustomerFacet(obj) {
  return (((obj instanceof $c_Lreactbuild_person_CustomerFacet) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.CustomerFacet"))
}
function $isArrayOf_Lreactbuild_person_CustomerFacet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_CustomerFacet)))
}
function $asArrayOf_Lreactbuild_person_CustomerFacet(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_CustomerFacet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.CustomerFacet;", depth))
}
var $d_Lreactbuild_person_CustomerFacet = new $TypeData().initClass({
  Lreactbuild_person_CustomerFacet: 0
}, false, "reactbuild.person.CustomerFacet", {
  Lreactbuild_person_CustomerFacet: 1,
  O: 1,
  Lreactbuild_person_Facet: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CustomerFacet.prototype.$classData = $d_Lreactbuild_person_CustomerFacet;
/** @constructor */
function $c_Lreactbuild_person_DocumentLevelOnly(documentFieldLevel, project) {
  this.Lreactbuild_person_DocumentLevelOnly__f_documentFieldLevel = null;
  this.Lreactbuild_person_DocumentLevelOnly__f_project = null;
  this.Lreactbuild_person_DocumentLevelOnly__f_documentFieldLevel = documentFieldLevel;
  this.Lreactbuild_person_DocumentLevelOnly__f_project = project
}
$c_Lreactbuild_person_DocumentLevelOnly.prototype = new $h_O();
$c_Lreactbuild_person_DocumentLevelOnly.prototype.constructor = $c_Lreactbuild_person_DocumentLevelOnly;
/** @constructor */
function $h_Lreactbuild_person_DocumentLevelOnly() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentLevelOnly.prototype = $c_Lreactbuild_person_DocumentLevelOnly.prototype;
$c_Lreactbuild_person_DocumentLevelOnly.prototype.productPrefix__T = (function() {
  return "DocumentLevelOnly"
});
$c_Lreactbuild_person_DocumentLevelOnly.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_DocumentLevelOnly.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_DocumentLevelOnly__f_documentFieldLevel;
      break
    }
    case 1: {
      return this.Lreactbuild_person_DocumentLevelOnly__f_project;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_DocumentLevelOnly.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_DocumentLevelOnly.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_DocumentLevelOnly.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_DocumentLevelOnly.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_DocumentLevelOnly)) {
    var DocumentLevelOnly$1 = $as_Lreactbuild_person_DocumentLevelOnly(x$1);
    var x = this.Lreactbuild_person_DocumentLevelOnly__f_documentFieldLevel;
    var x$2 = $n(DocumentLevelOnly$1).Lreactbuild_person_DocumentLevelOnly__f_documentFieldLevel;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_DocumentLevelOnly__f_project;
      var x$4 = $n(DocumentLevelOnly$1).Lreactbuild_person_DocumentLevelOnly__f_project;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_DocumentLevelOnly(obj) {
  return (((obj instanceof $c_Lreactbuild_person_DocumentLevelOnly) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.DocumentLevelOnly"))
}
function $isArrayOf_Lreactbuild_person_DocumentLevelOnly(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_DocumentLevelOnly)))
}
function $asArrayOf_Lreactbuild_person_DocumentLevelOnly(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_DocumentLevelOnly(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.DocumentLevelOnly;", depth))
}
var $d_Lreactbuild_person_DocumentLevelOnly = new $TypeData().initClass({
  Lreactbuild_person_DocumentLevelOnly: 0
}, false, "reactbuild.person.DocumentLevelOnly", {
  Lreactbuild_person_DocumentLevelOnly: 1,
  O: 1,
  Lreactbuild_person_DocumentParserFormat: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentLevelOnly.prototype.$classData = $d_Lreactbuild_person_DocumentLevelOnly;
/** @constructor */
function $c_Lreactbuild_person_DocumentWithRows(documentFieldLevel, table, rowFieldLevel) {
  this.Lreactbuild_person_DocumentWithRows__f_documentFieldLevel = null;
  this.Lreactbuild_person_DocumentWithRows__f_table = null;
  this.Lreactbuild_person_DocumentWithRows__f_rowFieldLevel = null;
  this.Lreactbuild_person_DocumentWithRows__f_documentFieldLevel = documentFieldLevel;
  this.Lreactbuild_person_DocumentWithRows__f_table = table;
  this.Lreactbuild_person_DocumentWithRows__f_rowFieldLevel = rowFieldLevel
}
$c_Lreactbuild_person_DocumentWithRows.prototype = new $h_O();
$c_Lreactbuild_person_DocumentWithRows.prototype.constructor = $c_Lreactbuild_person_DocumentWithRows;
/** @constructor */
function $h_Lreactbuild_person_DocumentWithRows() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentWithRows.prototype = $c_Lreactbuild_person_DocumentWithRows.prototype;
$c_Lreactbuild_person_DocumentWithRows.prototype.productPrefix__T = (function() {
  return "DocumentWithRows"
});
$c_Lreactbuild_person_DocumentWithRows.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_person_DocumentWithRows.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_DocumentWithRows__f_documentFieldLevel;
      break
    }
    case 1: {
      return this.Lreactbuild_person_DocumentWithRows__f_table;
      break
    }
    case 2: {
      return this.Lreactbuild_person_DocumentWithRows__f_rowFieldLevel;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_DocumentWithRows.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_DocumentWithRows.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_DocumentWithRows.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_DocumentWithRows.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_DocumentWithRows)) {
    var DocumentWithRows$1 = $as_Lreactbuild_person_DocumentWithRows(x$1);
    var x = this.Lreactbuild_person_DocumentWithRows__f_documentFieldLevel;
    var x$2 = $n(DocumentWithRows$1).Lreactbuild_person_DocumentWithRows__f_documentFieldLevel;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_DocumentWithRows__f_table;
      var x$4 = $n(DocumentWithRows$1).Lreactbuild_person_DocumentWithRows__f_table;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_person_DocumentWithRows__f_rowFieldLevel;
        var x$6 = $n(DocumentWithRows$1).Lreactbuild_person_DocumentWithRows__f_rowFieldLevel;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_DocumentWithRows(obj) {
  return (((obj instanceof $c_Lreactbuild_person_DocumentWithRows) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.DocumentWithRows"))
}
function $isArrayOf_Lreactbuild_person_DocumentWithRows(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_DocumentWithRows)))
}
function $asArrayOf_Lreactbuild_person_DocumentWithRows(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_DocumentWithRows(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.DocumentWithRows;", depth))
}
var $d_Lreactbuild_person_DocumentWithRows = new $TypeData().initClass({
  Lreactbuild_person_DocumentWithRows: 0
}, false, "reactbuild.person.DocumentWithRows", {
  Lreactbuild_person_DocumentWithRows: 1,
  O: 1,
  Lreactbuild_person_DocumentParserFormat: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentWithRows.prototype.$classData = $d_Lreactbuild_person_DocumentWithRows;
/** @constructor */
function $c_Lreactbuild_person_Email(email) {
  this.Lreactbuild_person_Email__f_email = null;
  this.Lreactbuild_person_Email__f_email = email
}
$c_Lreactbuild_person_Email.prototype = new $h_O();
$c_Lreactbuild_person_Email.prototype.constructor = $c_Lreactbuild_person_Email;
/** @constructor */
function $h_Lreactbuild_person_Email() {
  /*<skip>*/
}
$h_Lreactbuild_person_Email.prototype = $c_Lreactbuild_person_Email.prototype;
$c_Lreactbuild_person_Email.prototype.productPrefix__T = (function() {
  return "Email"
});
$c_Lreactbuild_person_Email.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_Email.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_Email__f_email : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_Email.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Email.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_Email.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Email.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Email)) {
    var Email$1 = $as_Lreactbuild_person_Email(x$1);
    return (this.Lreactbuild_person_Email__f_email === $n(Email$1).Lreactbuild_person_Email__f_email)
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Email(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Email) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Email"))
}
function $isArrayOf_Lreactbuild_person_Email(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Email)))
}
function $asArrayOf_Lreactbuild_person_Email(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Email(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Email;", depth))
}
var $d_Lreactbuild_person_Email = new $TypeData().initClass({
  Lreactbuild_person_Email: 0
}, false, "reactbuild.person.Email", {
  Lreactbuild_person_Email: 1,
  O: 1,
  Lreactbuild_person_AddressDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Email.prototype.$classData = $d_Lreactbuild_person_Email;
/** @constructor */
function $c_Lreactbuild_person_EstateAgentFacet(showPrices) {
  this.Lreactbuild_person_EstateAgentFacet__f_showPrices = false;
  this.Lreactbuild_person_EstateAgentFacet__f_showPrices = showPrices
}
$c_Lreactbuild_person_EstateAgentFacet.prototype = new $h_O();
$c_Lreactbuild_person_EstateAgentFacet.prototype.constructor = $c_Lreactbuild_person_EstateAgentFacet;
/** @constructor */
function $h_Lreactbuild_person_EstateAgentFacet() {
  /*<skip>*/
}
$h_Lreactbuild_person_EstateAgentFacet.prototype = $c_Lreactbuild_person_EstateAgentFacet.prototype;
$c_Lreactbuild_person_EstateAgentFacet.prototype.productPrefix__T = (function() {
  return "EstateAgentFacet"
});
$c_Lreactbuild_person_EstateAgentFacet.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_EstateAgentFacet.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_EstateAgentFacet__f_showPrices : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_EstateAgentFacet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_EstateAgentFacet.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("EstateAgentFacet");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_person_EstateAgentFacet__f_showPrices ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_person_EstateAgentFacet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_EstateAgentFacet.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_EstateAgentFacet)) {
    var EstateAgentFacet$1 = $as_Lreactbuild_person_EstateAgentFacet(x$1);
    return (this.Lreactbuild_person_EstateAgentFacet__f_showPrices === $n(EstateAgentFacet$1).Lreactbuild_person_EstateAgentFacet__f_showPrices)
  } else {
    return false
  }
});
function $as_Lreactbuild_person_EstateAgentFacet(obj) {
  return (((obj instanceof $c_Lreactbuild_person_EstateAgentFacet) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.EstateAgentFacet"))
}
function $isArrayOf_Lreactbuild_person_EstateAgentFacet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_EstateAgentFacet)))
}
function $asArrayOf_Lreactbuild_person_EstateAgentFacet(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_EstateAgentFacet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.EstateAgentFacet;", depth))
}
var $d_Lreactbuild_person_EstateAgentFacet = new $TypeData().initClass({
  Lreactbuild_person_EstateAgentFacet: 0
}, false, "reactbuild.person.EstateAgentFacet", {
  Lreactbuild_person_EstateAgentFacet: 1,
  O: 1,
  Lreactbuild_person_Facet: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_EstateAgentFacet.prototype.$classData = $d_Lreactbuild_person_EstateAgentFacet;
/** @constructor */
function $c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1() {
  /*<skip>*/
}
$c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1.prototype.constructor = $c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1;
/** @constructor */
function $h_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1.prototype = $c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1.prototype;
$c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1.prototype.applyOrElse__T2__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var key = $as_T($n(x1)._1__O());
    var value = $as_Lio_circe_Json($n(x1)._2__O());
    var this$2 = $n(value);
    var this$1 = $m_Lreactbuild_person_FacetRegistry$();
    var d = $n($as_Lreactbuild_person_IsFacet($n(this$1.Lreactbuild_person_FacetRegistry$__f_registryByName).apply__O__O(key))).Lreactbuild_person_IsFacet__f_decoder;
    var x1$3 = $n(d).apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(this$2, null, null));
    if ((x1$3 instanceof $c_s_util_Left)) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Can not decode Facets")
    } else if ((x1$3 instanceof $c_s_util_Right)) {
      var x3 = $as_s_util_Right(x1$3);
      var value$2 = $as_Lreactbuild_person_Facet($n(x3).s_util_Right__f_value);
      return $ct_T2__O__O__(new $c_T2(), key, value$2)
    } else {
      throw new $c_s_MatchError(x1$3)
    }
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1.prototype.isDefinedAt__T2__Z = (function(x1) {
  return (x1 !== null)
});
$c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x))
});
$c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1)
});
var $d_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1 = new $TypeData().initClass({
  Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1: 0
}, false, "reactbuild.person.Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1", {
  Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1.prototype.$classData = $d_Lreactbuild_person_Facets$$anonfun$$nestedInanonfun$decodeFacets$1$1;
/** @constructor */
function $c_Lreactbuild_person_HorizontalInterval(left, right) {
  this.Lreactbuild_person_HorizontalInterval__f_left = 0.0;
  this.Lreactbuild_person_HorizontalInterval__f_right = 0.0;
  this.Lreactbuild_person_HorizontalInterval__f_left = left;
  this.Lreactbuild_person_HorizontalInterval__f_right = right
}
$c_Lreactbuild_person_HorizontalInterval.prototype = new $h_O();
$c_Lreactbuild_person_HorizontalInterval.prototype.constructor = $c_Lreactbuild_person_HorizontalInterval;
/** @constructor */
function $h_Lreactbuild_person_HorizontalInterval() {
  /*<skip>*/
}
$h_Lreactbuild_person_HorizontalInterval.prototype = $c_Lreactbuild_person_HorizontalInterval.prototype;
$c_Lreactbuild_person_HorizontalInterval.prototype.productPrefix__T = (function() {
  return "HorizontalInterval"
});
$c_Lreactbuild_person_HorizontalInterval.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_HorizontalInterval.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_HorizontalInterval__f_left;
      break
    }
    case 1: {
      return this.Lreactbuild_person_HorizontalInterval__f_right;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_HorizontalInterval.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_HorizontalInterval.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("HorizontalInterval");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_person_HorizontalInterval__f_left;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_person_HorizontalInterval__f_right;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_person_HorizontalInterval.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_HorizontalInterval.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_HorizontalInterval)) {
    var HorizontalInterval$1 = $as_Lreactbuild_person_HorizontalInterval(x$1);
    return ((this.Lreactbuild_person_HorizontalInterval__f_left === $n(HorizontalInterval$1).Lreactbuild_person_HorizontalInterval__f_left) && (this.Lreactbuild_person_HorizontalInterval__f_right === $n(HorizontalInterval$1).Lreactbuild_person_HorizontalInterval__f_right))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_HorizontalInterval(obj) {
  return (((obj instanceof $c_Lreactbuild_person_HorizontalInterval) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.HorizontalInterval"))
}
function $isArrayOf_Lreactbuild_person_HorizontalInterval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_HorizontalInterval)))
}
function $asArrayOf_Lreactbuild_person_HorizontalInterval(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_HorizontalInterval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.HorizontalInterval;", depth))
}
var $d_Lreactbuild_person_HorizontalInterval = new $TypeData().initClass({
  Lreactbuild_person_HorizontalInterval: 0
}, false, "reactbuild.person.HorizontalInterval", {
  Lreactbuild_person_HorizontalInterval: 1,
  O: 1,
  Lreactbuild_person_Bounds: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_HorizontalInterval.prototype.$classData = $d_Lreactbuild_person_HorizontalInterval;
/** @constructor */
function $c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(documentFieldLevel, table, deliveryHeader, rowFieldLevel) {
  this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_documentFieldLevel = null;
  this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_table = null;
  this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_deliveryHeader = null;
  this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_rowFieldLevel = null;
  this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_documentFieldLevel = documentFieldLevel;
  this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_table = table;
  this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_deliveryHeader = deliveryHeader;
  this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_rowFieldLevel = rowFieldLevel
}
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype = new $h_O();
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype.constructor = $c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup;
/** @constructor */
function $h_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup() {
  /*<skip>*/
}
$h_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype = $c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype;
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype.productPrefix__T = (function() {
  return "InvoiceWithDeliveryFormDetailGroup"
});
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_documentFieldLevel;
      break
    }
    case 1: {
      return this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_table;
      break
    }
    case 2: {
      return this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_deliveryHeader;
      break
    }
    case 3: {
      return this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_rowFieldLevel;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup)) {
    var InvoiceWithDeliveryFormDetailGroup$1 = $as_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(x$1);
    var x = this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_documentFieldLevel;
    var x$2 = $n(InvoiceWithDeliveryFormDetailGroup$1).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_documentFieldLevel;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_table;
      var x$4 = $n(InvoiceWithDeliveryFormDetailGroup$1).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_table;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_deliveryHeader;
      var x$6 = $n(InvoiceWithDeliveryFormDetailGroup$1).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_deliveryHeader;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_rowFieldLevel;
        var x$8 = $n(InvoiceWithDeliveryFormDetailGroup$1).Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup__f_rowFieldLevel;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(obj) {
  return (((obj instanceof $c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.InvoiceWithDeliveryFormDetailGroup"))
}
function $isArrayOf_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup)))
}
function $asArrayOf_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.InvoiceWithDeliveryFormDetailGroup;", depth))
}
var $d_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup = new $TypeData().initClass({
  Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup: 0
}, false, "reactbuild.person.InvoiceWithDeliveryFormDetailGroup", {
  Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup: 1,
  O: 1,
  Lreactbuild_person_DocumentParserFormat: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup.prototype.$classData = $d_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup;
/** @constructor */
function $c_Lreactbuild_person_Location(coordinates) {
  this.Lreactbuild_person_Location__f_coordinates = null;
  this.Lreactbuild_person_Location__f_coordinates = coordinates
}
$c_Lreactbuild_person_Location.prototype = new $h_O();
$c_Lreactbuild_person_Location.prototype.constructor = $c_Lreactbuild_person_Location;
/** @constructor */
function $h_Lreactbuild_person_Location() {
  /*<skip>*/
}
$h_Lreactbuild_person_Location.prototype = $c_Lreactbuild_person_Location.prototype;
$c_Lreactbuild_person_Location.prototype.productPrefix__T = (function() {
  return "Location"
});
$c_Lreactbuild_person_Location.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_Location.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_Location__f_coordinates : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_Location.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Location.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_Location.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Location.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Location)) {
    var Location$1 = $as_Lreactbuild_person_Location(x$1);
    var x = this.Lreactbuild_person_Location__f_coordinates;
    var x$2 = $n(Location$1).Lreactbuild_person_Location__f_coordinates;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Location(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Location) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Location"))
}
function $isArrayOf_Lreactbuild_person_Location(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Location)))
}
function $asArrayOf_Lreactbuild_person_Location(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Location(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Location;", depth))
}
var $d_Lreactbuild_person_Location = new $TypeData().initClass({
  Lreactbuild_person_Location: 0
}, false, "reactbuild.person.Location", {
  Lreactbuild_person_Location: 1,
  O: 1,
  Lreactbuild_person_AddressDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Location.prototype.$classData = $d_Lreactbuild_person_Location;
/** @constructor */
function $c_Lreactbuild_person_PasswordCredentialData(password) {
  this.Lreactbuild_person_PasswordCredentialData__f_password = null;
  this.Lreactbuild_person_PasswordCredentialData__f_password = password
}
$c_Lreactbuild_person_PasswordCredentialData.prototype = new $h_O();
$c_Lreactbuild_person_PasswordCredentialData.prototype.constructor = $c_Lreactbuild_person_PasswordCredentialData;
/** @constructor */
function $h_Lreactbuild_person_PasswordCredentialData() {
  /*<skip>*/
}
$h_Lreactbuild_person_PasswordCredentialData.prototype = $c_Lreactbuild_person_PasswordCredentialData.prototype;
$c_Lreactbuild_person_PasswordCredentialData.prototype.productPrefix__T = (function() {
  return "PasswordCredentialData"
});
$c_Lreactbuild_person_PasswordCredentialData.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_PasswordCredentialData.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_PasswordCredentialData__f_password : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_PasswordCredentialData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PasswordCredentialData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_PasswordCredentialData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_PasswordCredentialData.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_PasswordCredentialData)) {
    var PasswordCredentialData$1 = $as_Lreactbuild_person_PasswordCredentialData(x$1);
    var x = this.Lreactbuild_person_PasswordCredentialData__f_password;
    var x$2 = $n(PasswordCredentialData$1).Lreactbuild_person_PasswordCredentialData__f_password;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_PasswordCredentialData(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PasswordCredentialData) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PasswordCredentialData"))
}
function $isArrayOf_Lreactbuild_person_PasswordCredentialData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PasswordCredentialData)))
}
function $asArrayOf_Lreactbuild_person_PasswordCredentialData(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PasswordCredentialData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PasswordCredentialData;", depth))
}
var $d_Lreactbuild_person_PasswordCredentialData = new $TypeData().initClass({
  Lreactbuild_person_PasswordCredentialData: 0
}, false, "reactbuild.person.PasswordCredentialData", {
  Lreactbuild_person_PasswordCredentialData: 1,
  O: 1,
  Lreactbuild_person_CredentialData: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PasswordCredentialData.prototype.$classData = $d_Lreactbuild_person_PasswordCredentialData;
/** @constructor */
function $c_Lreactbuild_person_PaymentMethod$BankTransfer$() {
  /*<skip>*/
}
$c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype = new $h_O();
$c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype.constructor = $c_Lreactbuild_person_PaymentMethod$BankTransfer$;
/** @constructor */
function $h_Lreactbuild_person_PaymentMethod$BankTransfer$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype = $c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype;
$c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype.productPrefix__T = (function() {
  return "BankTransfer"
});
$c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype.hashCode__I = (function() {
  return (-1496286617)
});
$c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype.toString__T = (function() {
  return "BankTransfer"
});
function $as_Lreactbuild_person_PaymentMethod$BankTransfer$(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PaymentMethod$BankTransfer$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PaymentMethod$BankTransfer$"))
}
function $isArrayOf_Lreactbuild_person_PaymentMethod$BankTransfer$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PaymentMethod$BankTransfer$)))
}
function $asArrayOf_Lreactbuild_person_PaymentMethod$BankTransfer$(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PaymentMethod$BankTransfer$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PaymentMethod$BankTransfer$;", depth))
}
var $d_Lreactbuild_person_PaymentMethod$BankTransfer$ = new $TypeData().initClass({
  Lreactbuild_person_PaymentMethod$BankTransfer$: 0
}, false, "reactbuild.person.PaymentMethod$BankTransfer$", {
  Lreactbuild_person_PaymentMethod$BankTransfer$: 1,
  O: 1,
  Lreactbuild_person_PaymentMethod: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PaymentMethod$BankTransfer$.prototype.$classData = $d_Lreactbuild_person_PaymentMethod$BankTransfer$;
var $n_Lreactbuild_person_PaymentMethod$BankTransfer$;
function $m_Lreactbuild_person_PaymentMethod$BankTransfer$() {
  if ((!$n_Lreactbuild_person_PaymentMethod$BankTransfer$)) {
    $n_Lreactbuild_person_PaymentMethod$BankTransfer$ = new $c_Lreactbuild_person_PaymentMethod$BankTransfer$()
  };
  return $n_Lreactbuild_person_PaymentMethod$BankTransfer$
}
/** @constructor */
function $c_Lreactbuild_person_PaymentMethod$BillOfExchange$() {
  /*<skip>*/
}
$c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype = new $h_O();
$c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype.constructor = $c_Lreactbuild_person_PaymentMethod$BillOfExchange$;
/** @constructor */
function $h_Lreactbuild_person_PaymentMethod$BillOfExchange$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype = $c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype;
$c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype.productPrefix__T = (function() {
  return "BillOfExchange"
});
$c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype.hashCode__I = (function() {
  return 247130273
});
$c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype.toString__T = (function() {
  return "BillOfExchange"
});
function $as_Lreactbuild_person_PaymentMethod$BillOfExchange$(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PaymentMethod$BillOfExchange$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PaymentMethod$BillOfExchange$"))
}
function $isArrayOf_Lreactbuild_person_PaymentMethod$BillOfExchange$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PaymentMethod$BillOfExchange$)))
}
function $asArrayOf_Lreactbuild_person_PaymentMethod$BillOfExchange$(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PaymentMethod$BillOfExchange$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PaymentMethod$BillOfExchange$;", depth))
}
var $d_Lreactbuild_person_PaymentMethod$BillOfExchange$ = new $TypeData().initClass({
  Lreactbuild_person_PaymentMethod$BillOfExchange$: 0
}, false, "reactbuild.person.PaymentMethod$BillOfExchange$", {
  Lreactbuild_person_PaymentMethod$BillOfExchange$: 1,
  O: 1,
  Lreactbuild_person_PaymentMethod: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PaymentMethod$BillOfExchange$.prototype.$classData = $d_Lreactbuild_person_PaymentMethod$BillOfExchange$;
var $n_Lreactbuild_person_PaymentMethod$BillOfExchange$;
function $m_Lreactbuild_person_PaymentMethod$BillOfExchange$() {
  if ((!$n_Lreactbuild_person_PaymentMethod$BillOfExchange$)) {
    $n_Lreactbuild_person_PaymentMethod$BillOfExchange$ = new $c_Lreactbuild_person_PaymentMethod$BillOfExchange$()
  };
  return $n_Lreactbuild_person_PaymentMethod$BillOfExchange$
}
/** @constructor */
function $c_Lreactbuild_person_PaymentMethod$DirectDebit$() {
  /*<skip>*/
}
$c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype = new $h_O();
$c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype.constructor = $c_Lreactbuild_person_PaymentMethod$DirectDebit$;
/** @constructor */
function $h_Lreactbuild_person_PaymentMethod$DirectDebit$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype = $c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype;
$c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype.productPrefix__T = (function() {
  return "DirectDebit"
});
$c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype.hashCode__I = (function() {
  return 1555043
});
$c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype.toString__T = (function() {
  return "DirectDebit"
});
function $as_Lreactbuild_person_PaymentMethod$DirectDebit$(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PaymentMethod$DirectDebit$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PaymentMethod$DirectDebit$"))
}
function $isArrayOf_Lreactbuild_person_PaymentMethod$DirectDebit$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PaymentMethod$DirectDebit$)))
}
function $asArrayOf_Lreactbuild_person_PaymentMethod$DirectDebit$(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PaymentMethod$DirectDebit$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PaymentMethod$DirectDebit$;", depth))
}
var $d_Lreactbuild_person_PaymentMethod$DirectDebit$ = new $TypeData().initClass({
  Lreactbuild_person_PaymentMethod$DirectDebit$: 0
}, false, "reactbuild.person.PaymentMethod$DirectDebit$", {
  Lreactbuild_person_PaymentMethod$DirectDebit$: 1,
  O: 1,
  Lreactbuild_person_PaymentMethod: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PaymentMethod$DirectDebit$.prototype.$classData = $d_Lreactbuild_person_PaymentMethod$DirectDebit$;
var $n_Lreactbuild_person_PaymentMethod$DirectDebit$;
function $m_Lreactbuild_person_PaymentMethod$DirectDebit$() {
  if ((!$n_Lreactbuild_person_PaymentMethod$DirectDebit$)) {
    $n_Lreactbuild_person_PaymentMethod$DirectDebit$ = new $c_Lreactbuild_person_PaymentMethod$DirectDebit$()
  };
  return $n_Lreactbuild_person_PaymentMethod$DirectDebit$
}
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceEvent(_id, next, person, target, details, instant) {
  this.Lreactbuild_person_PersonReferenceEvent__f__id = null;
  this.Lreactbuild_person_PersonReferenceEvent__f_next = null;
  this.Lreactbuild_person_PersonReferenceEvent__f_person = null;
  this.Lreactbuild_person_PersonReferenceEvent__f_target = null;
  this.Lreactbuild_person_PersonReferenceEvent__f_details = null;
  this.Lreactbuild_person_PersonReferenceEvent__f_instant = null;
  this.Lreactbuild_person_PersonReferenceEvent__f__id = _id;
  this.Lreactbuild_person_PersonReferenceEvent__f_next = next;
  this.Lreactbuild_person_PersonReferenceEvent__f_person = person;
  this.Lreactbuild_person_PersonReferenceEvent__f_target = target;
  this.Lreactbuild_person_PersonReferenceEvent__f_details = details;
  this.Lreactbuild_person_PersonReferenceEvent__f_instant = instant
}
$c_Lreactbuild_person_PersonReferenceEvent.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceEvent.prototype.constructor = $c_Lreactbuild_person_PersonReferenceEvent;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceEvent() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceEvent.prototype = $c_Lreactbuild_person_PersonReferenceEvent.prototype;
$c_Lreactbuild_person_PersonReferenceEvent.prototype.productPrefix__T = (function() {
  return "PersonReferenceEvent"
});
$c_Lreactbuild_person_PersonReferenceEvent.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_person_PersonReferenceEvent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_PersonReferenceEvent__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_person_PersonReferenceEvent__f_next;
      break
    }
    case 2: {
      return this.Lreactbuild_person_PersonReferenceEvent__f_person;
      break
    }
    case 3: {
      return this.Lreactbuild_person_PersonReferenceEvent__f_target;
      break
    }
    case 4: {
      return this.Lreactbuild_person_PersonReferenceEvent__f_details;
      break
    }
    case 5: {
      return this.Lreactbuild_person_PersonReferenceEvent__f_instant;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_PersonReferenceEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PersonReferenceEvent.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_PersonReferenceEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_PersonReferenceEvent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_PersonReferenceEvent)) {
    var PersonReferenceEvent$1 = $as_Lreactbuild_person_PersonReferenceEvent(x$1);
    var x = this.Lreactbuild_person_PersonReferenceEvent__f__id;
    var x$2 = $n(PersonReferenceEvent$1).Lreactbuild_person_PersonReferenceEvent__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_PersonReferenceEvent__f_next;
      var x$4 = $n(PersonReferenceEvent$1).Lreactbuild_person_PersonReferenceEvent__f_next;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_person_PersonReferenceEvent__f_person;
        var x$6 = $n(PersonReferenceEvent$1).Lreactbuild_person_PersonReferenceEvent__f_person;
        var $$x1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$7 = this.Lreactbuild_person_PersonReferenceEvent__f_target;
      var x$8 = $n(PersonReferenceEvent$1).Lreactbuild_person_PersonReferenceEvent__f_target;
      if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
        var x$9 = this.Lreactbuild_person_PersonReferenceEvent__f_details;
        var x$10 = $n(PersonReferenceEvent$1).Lreactbuild_person_PersonReferenceEvent__f_details;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_person_PersonReferenceEvent__f_instant;
          var x$12 = $n(PersonReferenceEvent$1).Lreactbuild_person_PersonReferenceEvent__f_instant;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_PersonReferenceEvent(obj) {
  return (((obj instanceof $c_Lreactbuild_person_PersonReferenceEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.PersonReferenceEvent"))
}
function $isArrayOf_Lreactbuild_person_PersonReferenceEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_PersonReferenceEvent)))
}
function $asArrayOf_Lreactbuild_person_PersonReferenceEvent(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_PersonReferenceEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.PersonReferenceEvent;", depth))
}
var $d_Lreactbuild_person_PersonReferenceEvent = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceEvent: 0
}, false, "reactbuild.person.PersonReferenceEvent", {
  Lreactbuild_person_PersonReferenceEvent: 1,
  O: 1,
  Lreactbuild_person_GenEvent: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceEvent.prototype.$classData = $d_Lreactbuild_person_PersonReferenceEvent;
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceListRender$PersonView$() {
  /*<skip>*/
}
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype.constructor = $c_Lreactbuild_person_PersonReferenceListRender$PersonView$;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceListRender$PersonView$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype = $c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype;
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype.group__sci_List__Lreactbuild_package$PageProps__sci_List = (function(source, pageProps) {
  var this$1 = $n(source);
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = $n(rest).head__O();
    var ref = $as_Lreactbuild_person_PersonReferenceEvent(arg1);
    var this$5 = $n($n(ref).Lreactbuild_person_PersonReferenceEvent__f_target);
    var f = ((ref) => ((v$2) => {
      var v = $as_Lreactbuild_common_model_RefTo(v$2);
      return $ct_T2__O__O__(new $c_T2(), v, ref)
    }))(ref);
    if ((this$5 === $m_sci_Nil$())) {
      var $$x1 = $m_sci_Nil$()
    } else {
      var arg1$1 = this$5.head__O();
      var h$1 = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(this$5.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$2 = $n(rest$1).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
        $n(t$1).sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest$1 = $as_sci_List($n(rest$1).tail__O())
      };
      var $$x1 = h$1
    };
    var it = $n($$x1).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1
      } else {
        $n(t).sci_$colon$colon__f_next = nx$1
      };
      t = nx$1
    };
    rest = $as_sci_List($n(rest).tail__O())
  };
  var this$6 = $n(((h === null) ? $m_sci_Nil$() : h));
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it$1 = this$6.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var elem = $n(it$1).next__O();
    var x$1 = $as_T2(elem);
    var key = $as_Lreactbuild_common_model_RefTo($n(x$1)._1__O());
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => {
      $m_sci_List$();
      return new $c_scm_ListBuffer()
    }))));
    var this$8 = $n(bldr);
    this$8.addOne__O__scm_Growable(elem)
  };
  var this$9 = $m_sci_HashMap$();
  var result = this$9.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = $n(x1)._1__O();
    var v$1 = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v$1).result__O())
  };
  var this$10 = $n(result);
  $m_sci_List$();
  var this$15 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$10));
  var f$1 = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_T2(p$2);
    $m_Lcom_iz2use_common_Textualizable$();
    var v$3 = $n(p)._1__O();
    var this$13 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$13, proxy);
    return $n(ev).stringify__O__T(v$3)
  }));
  var ord = $m_s_math_Ordering$String$();
  var this$27 = $n($as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$15, f$1, ord)));
  var f$3 = ((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var ref$1 = $as_Lreactbuild_common_model_RefTo($n(x0$1)._1__O());
      var events = $as_sci_List($n(x0$1)._2__O());
      var $$x2 = $n($n($n(pageProps).Lreactbuild_package$PageProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$Project(new $c_Lreactbuild_analyze_cost_modules_project_ProjectView$ProjectSummary($m_s_Option$().apply__O__s_Option(ref$1)))));
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$17 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$1 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$17, proxy$1);
      var v$4 = $n(ev$1).stringify__O__T(ref$1);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$4)];
      var self = $n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      var this$25 = $n(events);
      var f$2 = ((x$2$2) => {
        var x$2 = $as_T2(x$2$2);
        return $as_Lreactbuild_person_PersonReferenceEvent($n(x$2)._2__O())
      });
      if ((this$25 === $m_sci_Nil$())) {
        var y = $m_sci_Nil$()
      } else {
        var arg1$3 = this$25.head__O();
        var h$2 = new $c_sci_$colon$colon(f$2(arg1$3), $m_sci_Nil$());
        var t$2 = h$2;
        var rest$2 = $as_sci_List(this$25.tail__O());
        while ((rest$2 !== $m_sci_Nil$())) {
          var arg1$4 = $n(rest$2).head__O();
          var nx$2 = new $c_sci_$colon$colon(f$2(arg1$4), $m_sci_Nil$());
          $n(t$2).sci_$colon$colon__f_next = nx$2;
          t$2 = nx$2;
          rest$2 = $as_sci_List($n(rest$2).tail__O())
        };
        var y = h$2
      };
      return $ct_T2__O__O__(new $c_T2(), self, y)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  });
  if ((this$27 === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var arg1$5 = this$27.head__O();
    var h$3 = new $c_sci_$colon$colon(f$3(arg1$5), $m_sci_Nil$());
    var t$3 = h$3;
    var rest$3 = $as_sci_List(this$27.tail__O());
    while ((rest$3 !== $m_sci_Nil$())) {
      var arg1$6 = $n(rest$3).head__O();
      var nx$3 = new $c_sci_$colon$colon(f$3(arg1$6), $m_sci_Nil$());
      $n(t$3).sci_$colon$colon__f_next = nx$3;
      t$3 = nx$3;
      rest$3 = $as_sci_List($n(rest$3).tail__O())
    };
    return h$3
  }
});
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype.productPrefix__T = (function() {
  return "PersonView"
});
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype.hashCode__I = (function() {
  return (-1622772806)
});
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype.toString__T = (function() {
  return "PersonView"
});
var $d_Lreactbuild_person_PersonReferenceListRender$PersonView$ = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceListRender$PersonView$: 0
}, false, "reactbuild.person.PersonReferenceListRender$PersonView$", {
  Lreactbuild_person_PersonReferenceListRender$PersonView$: 1,
  O: 1,
  Lreactbuild_person_PersonReferenceListRender: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceListRender$PersonView$.prototype.$classData = $d_Lreactbuild_person_PersonReferenceListRender$PersonView$;
var $n_Lreactbuild_person_PersonReferenceListRender$PersonView$;
function $m_Lreactbuild_person_PersonReferenceListRender$PersonView$() {
  if ((!$n_Lreactbuild_person_PersonReferenceListRender$PersonView$)) {
    $n_Lreactbuild_person_PersonReferenceListRender$PersonView$ = new $c_Lreactbuild_person_PersonReferenceListRender$PersonView$()
  };
  return $n_Lreactbuild_person_PersonReferenceListRender$PersonView$
}
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceListRender$ProjectView$() {
  /*<skip>*/
}
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype = new $h_O();
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype.constructor = $c_Lreactbuild_person_PersonReferenceListRender$ProjectView$;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceListRender$ProjectView$() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype = $c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype;
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype.group__sci_List__Lreactbuild_package$PageProps__sci_List = (function(source, pageProps) {
  var this$1 = $n(source);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var x$3 = $as_Lreactbuild_person_PersonReferenceEvent(elem);
    var key = $n(x$3).Lreactbuild_person_PersonReferenceEvent__f_person;
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => {
      $m_sci_List$();
      return new $c_scm_ListBuffer()
    }))));
    var this$3 = $n(bldr);
    this$3.addOne__O__scm_Growable(elem)
  };
  var this$4 = $m_sci_HashMap$();
  var result = this$4.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O())
  };
  var this$5 = $n(result);
  $m_sci_List$();
  var this$10 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$5));
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_T2(p$2);
    $m_Lcom_iz2use_common_Textualizable$();
    var v$1 = $n(p)._1__O();
    var this$8 = $m_Lreactbuild_model_Implicits$();
    $m_Lreactbuild_model_Implicits$();
    var proxy = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
    var ev = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$8, proxy);
    return $n(ev).stringify__O__T(v$1)
  }));
  var ord = $m_s_math_Ordering$String$();
  var this$21 = $n($as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$10, f, ord)));
  var f$1 = ((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var ref = $as_Lreactbuild_common_model_RefTo($n(x0$1)._1__O());
      var events = $as_sci_List($n(x0$1)._2__O());
      var $$x1 = $n($n($n(pageProps).Lreactbuild_package$PageProps__f_router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$Person($m_s_Option$().apply__O__s_Option(ref))));
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$12 = $m_Lreactbuild_model_Implicits$();
      $m_Lreactbuild_model_Implicits$();
      var proxy$1 = $n(pageProps).Lreactbuild_package$PageProps__f_proxy;
      var ev$1 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$12, proxy$1);
      var v$2 = $n(ev$1).stringify__O__T(ref);
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      var self = $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      return $ct_T2__O__O__(new $c_T2(), self, events)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  });
  if ((this$21 === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var arg1 = this$21.head__O();
    var h = new $c_sci_$colon$colon(f$1(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$21.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    return h
  }
});
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype.productPrefix__T = (function() {
  return "ProjectView"
});
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype.hashCode__I = (function() {
  return 728067390
});
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype.toString__T = (function() {
  return "ProjectView"
});
var $d_Lreactbuild_person_PersonReferenceListRender$ProjectView$ = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceListRender$ProjectView$: 0
}, false, "reactbuild.person.PersonReferenceListRender$ProjectView$", {
  Lreactbuild_person_PersonReferenceListRender$ProjectView$: 1,
  O: 1,
  Lreactbuild_person_PersonReferenceListRender: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PersonReferenceListRender$ProjectView$.prototype.$classData = $d_Lreactbuild_person_PersonReferenceListRender$ProjectView$;
var $n_Lreactbuild_person_PersonReferenceListRender$ProjectView$;
function $m_Lreactbuild_person_PersonReferenceListRender$ProjectView$() {
  if ((!$n_Lreactbuild_person_PersonReferenceListRender$ProjectView$)) {
    $n_Lreactbuild_person_PersonReferenceListRender$ProjectView$ = new $c_Lreactbuild_person_PersonReferenceListRender$ProjectView$()
  };
  return $n_Lreactbuild_person_PersonReferenceListRender$ProjectView$
}
/** @constructor */
function $c_Lreactbuild_person_Phone(number) {
  this.Lreactbuild_person_Phone__f_number = null;
  this.Lreactbuild_person_Phone__f_number = number
}
$c_Lreactbuild_person_Phone.prototype = new $h_O();
$c_Lreactbuild_person_Phone.prototype.constructor = $c_Lreactbuild_person_Phone;
/** @constructor */
function $h_Lreactbuild_person_Phone() {
  /*<skip>*/
}
$h_Lreactbuild_person_Phone.prototype = $c_Lreactbuild_person_Phone.prototype;
$c_Lreactbuild_person_Phone.prototype.productPrefix__T = (function() {
  return "Phone"
});
$c_Lreactbuild_person_Phone.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_Phone.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_Phone__f_number : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_Phone.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Phone.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_Phone.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Phone.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Phone)) {
    var Phone$1 = $as_Lreactbuild_person_Phone(x$1);
    return (this.Lreactbuild_person_Phone__f_number === $n(Phone$1).Lreactbuild_person_Phone__f_number)
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Phone(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Phone) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Phone"))
}
function $isArrayOf_Lreactbuild_person_Phone(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Phone)))
}
function $asArrayOf_Lreactbuild_person_Phone(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Phone(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Phone;", depth))
}
var $d_Lreactbuild_person_Phone = new $TypeData().initClass({
  Lreactbuild_person_Phone: 0
}, false, "reactbuild.person.Phone", {
  Lreactbuild_person_Phone: 1,
  O: 1,
  Lreactbuild_person_AddressDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Phone.prototype.$classData = $d_Lreactbuild_person_Phone;
/** @constructor */
function $c_Lreactbuild_person_Postal(street, postalCode, city) {
  this.Lreactbuild_person_Postal__f_street = null;
  this.Lreactbuild_person_Postal__f_postalCode = null;
  this.Lreactbuild_person_Postal__f_city = null;
  this.Lreactbuild_person_Postal__f_street = street;
  this.Lreactbuild_person_Postal__f_postalCode = postalCode;
  this.Lreactbuild_person_Postal__f_city = city
}
$c_Lreactbuild_person_Postal.prototype = new $h_O();
$c_Lreactbuild_person_Postal.prototype.constructor = $c_Lreactbuild_person_Postal;
/** @constructor */
function $h_Lreactbuild_person_Postal() {
  /*<skip>*/
}
$h_Lreactbuild_person_Postal.prototype = $c_Lreactbuild_person_Postal.prototype;
$c_Lreactbuild_person_Postal.prototype.productPrefix__T = (function() {
  return "Postal"
});
$c_Lreactbuild_person_Postal.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_person_Postal.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_Postal__f_street;
      break
    }
    case 1: {
      return this.Lreactbuild_person_Postal__f_postalCode;
      break
    }
    case 2: {
      return this.Lreactbuild_person_Postal__f_city;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_Postal.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Postal.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_Postal.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Postal.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Postal)) {
    var Postal$1 = $as_Lreactbuild_person_Postal(x$1);
    return ((this.Lreactbuild_person_Postal__f_street === $n(Postal$1).Lreactbuild_person_Postal__f_street) && ((this.Lreactbuild_person_Postal__f_postalCode === $n(Postal$1).Lreactbuild_person_Postal__f_postalCode) && (this.Lreactbuild_person_Postal__f_city === $n(Postal$1).Lreactbuild_person_Postal__f_city)))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Postal(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Postal) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Postal"))
}
function $isArrayOf_Lreactbuild_person_Postal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Postal)))
}
function $asArrayOf_Lreactbuild_person_Postal(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Postal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Postal;", depth))
}
var $d_Lreactbuild_person_Postal = new $TypeData().initClass({
  Lreactbuild_person_Postal: 0
}, false, "reactbuild.person.Postal", {
  Lreactbuild_person_Postal: 1,
  O: 1,
  Lreactbuild_person_AddressDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Postal.prototype.$classData = $d_Lreactbuild_person_Postal;
/** @constructor */
function $c_Lreactbuild_person_Rectangle(top, left, bottom, right) {
  this.Lreactbuild_person_Rectangle__f_top = 0.0;
  this.Lreactbuild_person_Rectangle__f_left = 0.0;
  this.Lreactbuild_person_Rectangle__f_bottom = 0.0;
  this.Lreactbuild_person_Rectangle__f_right = 0.0;
  this.Lreactbuild_person_Rectangle__f_top = top;
  this.Lreactbuild_person_Rectangle__f_left = left;
  this.Lreactbuild_person_Rectangle__f_bottom = bottom;
  this.Lreactbuild_person_Rectangle__f_right = right
}
$c_Lreactbuild_person_Rectangle.prototype = new $h_O();
$c_Lreactbuild_person_Rectangle.prototype.constructor = $c_Lreactbuild_person_Rectangle;
/** @constructor */
function $h_Lreactbuild_person_Rectangle() {
  /*<skip>*/
}
$h_Lreactbuild_person_Rectangle.prototype = $c_Lreactbuild_person_Rectangle.prototype;
$c_Lreactbuild_person_Rectangle.prototype.productPrefix__T = (function() {
  return "Rectangle"
});
$c_Lreactbuild_person_Rectangle.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_person_Rectangle.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_Rectangle__f_top;
      break
    }
    case 1: {
      return this.Lreactbuild_person_Rectangle__f_left;
      break
    }
    case 2: {
      return this.Lreactbuild_person_Rectangle__f_bottom;
      break
    }
    case 3: {
      return this.Lreactbuild_person_Rectangle__f_right;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_Rectangle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Rectangle.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Rectangle");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_person_Rectangle__f_top;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_person_Rectangle__f_left;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$2 = this.Lreactbuild_person_Rectangle__f_bottom;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$3 = this.Lreactbuild_person_Rectangle__f_right;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lreactbuild_person_Rectangle.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Rectangle.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Rectangle)) {
    var Rectangle$1 = $as_Lreactbuild_person_Rectangle(x$1);
    return (((this.Lreactbuild_person_Rectangle__f_top === $n(Rectangle$1).Lreactbuild_person_Rectangle__f_top) && (this.Lreactbuild_person_Rectangle__f_left === $n(Rectangle$1).Lreactbuild_person_Rectangle__f_left)) && ((this.Lreactbuild_person_Rectangle__f_bottom === $n(Rectangle$1).Lreactbuild_person_Rectangle__f_bottom) && (this.Lreactbuild_person_Rectangle__f_right === $n(Rectangle$1).Lreactbuild_person_Rectangle__f_right)))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Rectangle(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Rectangle) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Rectangle"))
}
function $isArrayOf_Lreactbuild_person_Rectangle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Rectangle)))
}
function $asArrayOf_Lreactbuild_person_Rectangle(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Rectangle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Rectangle;", depth))
}
var $d_Lreactbuild_person_Rectangle = new $TypeData().initClass({
  Lreactbuild_person_Rectangle: 0
}, false, "reactbuild.person.Rectangle", {
  Lreactbuild_person_Rectangle: 1,
  O: 1,
  Lreactbuild_person_Bounds: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Rectangle.prototype.$classData = $d_Lreactbuild_person_Rectangle;
/** @constructor */
function $c_Lreactbuild_person_ResourceFacet(entry, release, costByHour) {
  this.Lreactbuild_person_ResourceFacet__f_entry = null;
  this.Lreactbuild_person_ResourceFacet__f_release = null;
  this.Lreactbuild_person_ResourceFacet__f_costByHour = null;
  this.Lreactbuild_person_ResourceFacet__f_entry = entry;
  this.Lreactbuild_person_ResourceFacet__f_release = release;
  this.Lreactbuild_person_ResourceFacet__f_costByHour = costByHour
}
$c_Lreactbuild_person_ResourceFacet.prototype = new $h_O();
$c_Lreactbuild_person_ResourceFacet.prototype.constructor = $c_Lreactbuild_person_ResourceFacet;
/** @constructor */
function $h_Lreactbuild_person_ResourceFacet() {
  /*<skip>*/
}
$h_Lreactbuild_person_ResourceFacet.prototype = $c_Lreactbuild_person_ResourceFacet.prototype;
$c_Lreactbuild_person_ResourceFacet.prototype.productPrefix__T = (function() {
  return "ResourceFacet"
});
$c_Lreactbuild_person_ResourceFacet.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_person_ResourceFacet.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_ResourceFacet__f_entry;
      break
    }
    case 1: {
      return this.Lreactbuild_person_ResourceFacet__f_release;
      break
    }
    case 2: {
      return this.Lreactbuild_person_ResourceFacet__f_costByHour;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_ResourceFacet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_ResourceFacet.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_ResourceFacet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_ResourceFacet.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_ResourceFacet)) {
    var ResourceFacet$1 = $as_Lreactbuild_person_ResourceFacet(x$1);
    var x = this.Lreactbuild_person_ResourceFacet__f_entry;
    var x$2 = $n(ResourceFacet$1).Lreactbuild_person_ResourceFacet__f_entry;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_ResourceFacet__f_release;
      var x$4 = $n(ResourceFacet$1).Lreactbuild_person_ResourceFacet__f_release;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_person_ResourceFacet__f_costByHour;
        var x$6 = $n(ResourceFacet$1).Lreactbuild_person_ResourceFacet__f_costByHour;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_ResourceFacet(obj) {
  return (((obj instanceof $c_Lreactbuild_person_ResourceFacet) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.ResourceFacet"))
}
function $isArrayOf_Lreactbuild_person_ResourceFacet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_ResourceFacet)))
}
function $asArrayOf_Lreactbuild_person_ResourceFacet(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_ResourceFacet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.ResourceFacet;", depth))
}
var $d_Lreactbuild_person_ResourceFacet = new $TypeData().initClass({
  Lreactbuild_person_ResourceFacet: 0
}, false, "reactbuild.person.ResourceFacet", {
  Lreactbuild_person_ResourceFacet: 1,
  O: 1,
  Lreactbuild_person_Facet: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_ResourceFacet.prototype.$classData = $d_Lreactbuild_person_ResourceFacet;
/** @constructor */
function $c_Lreactbuild_person_Size$Undefined$() {
  /*<skip>*/
}
$c_Lreactbuild_person_Size$Undefined$.prototype = new $h_O();
$c_Lreactbuild_person_Size$Undefined$.prototype.constructor = $c_Lreactbuild_person_Size$Undefined$;
/** @constructor */
function $h_Lreactbuild_person_Size$Undefined$() {
  /*<skip>*/
}
$h_Lreactbuild_person_Size$Undefined$.prototype = $c_Lreactbuild_person_Size$Undefined$.prototype;
$c_Lreactbuild_person_Size$Undefined$.prototype.productPrefix__T = (function() {
  return "Undefined"
});
$c_Lreactbuild_person_Size$Undefined$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_person_Size$Undefined$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_person_Size$Undefined$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Size$Undefined$.prototype.hashCode__I = (function() {
  return 965837104
});
$c_Lreactbuild_person_Size$Undefined$.prototype.toString__T = (function() {
  return "Undefined"
});
function $as_Lreactbuild_person_Size$Undefined$(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Size$Undefined$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Size$Undefined$"))
}
function $isArrayOf_Lreactbuild_person_Size$Undefined$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Size$Undefined$)))
}
function $asArrayOf_Lreactbuild_person_Size$Undefined$(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Size$Undefined$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Size$Undefined$;", depth))
}
var $d_Lreactbuild_person_Size$Undefined$ = new $TypeData().initClass({
  Lreactbuild_person_Size$Undefined$: 0
}, false, "reactbuild.person.Size$Undefined$", {
  Lreactbuild_person_Size$Undefined$: 1,
  O: 1,
  Lreactbuild_person_Size: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Size$Undefined$.prototype.$classData = $d_Lreactbuild_person_Size$Undefined$;
var $n_Lreactbuild_person_Size$Undefined$;
function $m_Lreactbuild_person_Size$Undefined$() {
  if ((!$n_Lreactbuild_person_Size$Undefined$)) {
    $n_Lreactbuild_person_Size$Undefined$ = new $c_Lreactbuild_person_Size$Undefined$()
  };
  return $n_Lreactbuild_person_Size$Undefined$
}
/** @constructor */
function $c_Lreactbuild_person_SupplierFacet(reference, paymentTermAndConditions, group, documentParserSettings) {
  this.Lreactbuild_person_SupplierFacet__f_reference = null;
  this.Lreactbuild_person_SupplierFacet__f_paymentTermAndConditions = null;
  this.Lreactbuild_person_SupplierFacet__f_group = null;
  this.Lreactbuild_person_SupplierFacet__f_documentParserSettings = null;
  this.Lreactbuild_person_SupplierFacet__f_reference = reference;
  this.Lreactbuild_person_SupplierFacet__f_paymentTermAndConditions = paymentTermAndConditions;
  this.Lreactbuild_person_SupplierFacet__f_group = group;
  this.Lreactbuild_person_SupplierFacet__f_documentParserSettings = documentParserSettings
}
$c_Lreactbuild_person_SupplierFacet.prototype = new $h_O();
$c_Lreactbuild_person_SupplierFacet.prototype.constructor = $c_Lreactbuild_person_SupplierFacet;
/** @constructor */
function $h_Lreactbuild_person_SupplierFacet() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierFacet.prototype = $c_Lreactbuild_person_SupplierFacet.prototype;
$c_Lreactbuild_person_SupplierFacet.prototype.productPrefix__T = (function() {
  return "SupplierFacet"
});
$c_Lreactbuild_person_SupplierFacet.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_person_SupplierFacet.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_SupplierFacet__f_reference;
      break
    }
    case 1: {
      return this.Lreactbuild_person_SupplierFacet__f_paymentTermAndConditions;
      break
    }
    case 2: {
      return this.Lreactbuild_person_SupplierFacet__f_group;
      break
    }
    case 3: {
      return this.Lreactbuild_person_SupplierFacet__f_documentParserSettings;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_SupplierFacet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_SupplierFacet.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_SupplierFacet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_SupplierFacet.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_SupplierFacet)) {
    var SupplierFacet$1 = $as_Lreactbuild_person_SupplierFacet(x$1);
    var x = this.Lreactbuild_person_SupplierFacet__f_reference;
    var x$2 = $n(SupplierFacet$1).Lreactbuild_person_SupplierFacet__f_reference;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_SupplierFacet__f_paymentTermAndConditions;
      var x$4 = $n(SupplierFacet$1).Lreactbuild_person_SupplierFacet__f_paymentTermAndConditions;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_person_SupplierFacet__f_group;
      var x$6 = $n(SupplierFacet$1).Lreactbuild_person_SupplierFacet__f_group;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_person_SupplierFacet__f_documentParserSettings;
        var x$8 = $n(SupplierFacet$1).Lreactbuild_person_SupplierFacet__f_documentParserSettings;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_SupplierFacet(obj) {
  return (((obj instanceof $c_Lreactbuild_person_SupplierFacet) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.SupplierFacet"))
}
function $isArrayOf_Lreactbuild_person_SupplierFacet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_SupplierFacet)))
}
function $asArrayOf_Lreactbuild_person_SupplierFacet(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_SupplierFacet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.SupplierFacet;", depth))
}
var $d_Lreactbuild_person_SupplierFacet = new $TypeData().initClass({
  Lreactbuild_person_SupplierFacet: 0
}, false, "reactbuild.person.SupplierFacet", {
  Lreactbuild_person_SupplierFacet: 1,
  O: 1,
  Lreactbuild_person_Facet: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplierFacet.prototype.$classData = $d_Lreactbuild_person_SupplierFacet;
/** @constructor */
function $c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$() {
  this.Lreactbuild_person_SupplierGroup__f_title = null;
  $ct_Lreactbuild_person_SupplierGroup__T__(this, "Vend\u00e9e Mat\u00e9riaux")
}
$c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype = new $h_Lreactbuild_person_SupplierGroup();
$c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype.constructor = $c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$;
/** @constructor */
function $h_Lreactbuild_person_SupplierGroup$VendeeMateriaux$() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype = $c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype;
$c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype.productPrefix__T = (function() {
  return "VendeeMateriaux"
});
$c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype.hashCode__I = (function() {
  return (-1993921885)
});
$c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype.toString__T = (function() {
  return "VendeeMateriaux"
});
function $as_Lreactbuild_person_SupplierGroup$VendeeMateriaux$(obj) {
  return (((obj instanceof $c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.SupplierGroup$VendeeMateriaux$"))
}
function $isArrayOf_Lreactbuild_person_SupplierGroup$VendeeMateriaux$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_SupplierGroup$VendeeMateriaux$)))
}
function $asArrayOf_Lreactbuild_person_SupplierGroup$VendeeMateriaux$(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_SupplierGroup$VendeeMateriaux$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.SupplierGroup$VendeeMateriaux$;", depth))
}
var $d_Lreactbuild_person_SupplierGroup$VendeeMateriaux$ = new $TypeData().initClass({
  Lreactbuild_person_SupplierGroup$VendeeMateriaux$: 0
}, false, "reactbuild.person.SupplierGroup$VendeeMateriaux$", {
  Lreactbuild_person_SupplierGroup$VendeeMateriaux$: 1,
  Lreactbuild_person_SupplierGroup: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$.prototype.$classData = $d_Lreactbuild_person_SupplierGroup$VendeeMateriaux$;
var $n_Lreactbuild_person_SupplierGroup$VendeeMateriaux$;
function $m_Lreactbuild_person_SupplierGroup$VendeeMateriaux$() {
  if ((!$n_Lreactbuild_person_SupplierGroup$VendeeMateriaux$)) {
    $n_Lreactbuild_person_SupplierGroup$VendeeMateriaux$ = new $c_Lreactbuild_person_SupplierGroup$VendeeMateriaux$()
  };
  return $n_Lreactbuild_person_SupplierGroup$VendeeMateriaux$
}
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$Product(element, concrete) {
  this.Lreactbuild_person_SupplyRowTarget$Product__f_element = null;
  this.Lreactbuild_person_SupplyRowTarget$Product__f_concrete = null;
  this.Lreactbuild_person_SupplyRowTarget$Product__f_element = element;
  this.Lreactbuild_person_SupplyRowTarget$Product__f_concrete = concrete
}
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$Product;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$Product() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$Product.prototype = $c_Lreactbuild_person_SupplyRowTarget$Product.prototype;
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.renderTitle__Lreactbuild_person_RowListing__T = (function(l) {
  var this$1 = $n($n(l).Lreactbuild_person_RowListing__f_products);
  _return: {
    var these = this$1;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x$2 = $as_Lreactbuild_person_ProductProduct(arg1);
      var x = $n(x$2).Lreactbuild_person_ProductProduct__f__id;
      var x$3 = this.Lreactbuild_person_SupplyRowTarget$Product__f_element;
      if (((x === null) ? (x$3 === null) : $n(x).equals__O__Z(x$3))) {
        var $$x1 = new $c_s_Some($n(these).head__O());
        break _return
      };
      these = $as_sci_List($n(these).tail__O())
    };
    var $$x1 = $m_s_None$()
  };
  return $n($as_Lreactbuild_person_ProductProduct($$x1.get__O())).Lreactbuild_person_ProductProduct__f_title
});
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.productPrefix__T = (function() {
  return "Product"
});
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_SupplyRowTarget$Product__f_element;
      break
    }
    case 1: {
      return this.Lreactbuild_person_SupplyRowTarget$Product__f_concrete;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_SupplyRowTarget$Product)) {
    var Product$1 = $as_Lreactbuild_person_SupplyRowTarget$Product(x$1);
    var x = this.Lreactbuild_person_SupplyRowTarget$Product__f_element;
    var x$2 = $n(Product$1).Lreactbuild_person_SupplyRowTarget$Product__f_element;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_person_SupplyRowTarget$Product__f_concrete;
      var x$4 = $n(Product$1).Lreactbuild_person_SupplyRowTarget$Product__f_concrete;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_SupplyRowTarget$Product(obj) {
  return (((obj instanceof $c_Lreactbuild_person_SupplyRowTarget$Product) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.SupplyRowTarget$Product"))
}
function $isArrayOf_Lreactbuild_person_SupplyRowTarget$Product(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_SupplyRowTarget$Product)))
}
function $asArrayOf_Lreactbuild_person_SupplyRowTarget$Product(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_SupplyRowTarget$Product(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.SupplyRowTarget$Product;", depth))
}
var $d_Lreactbuild_person_SupplyRowTarget$Product = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$Product: 0
}, false, "reactbuild.person.SupplyRowTarget$Product", {
  Lreactbuild_person_SupplyRowTarget$Product: 1,
  O: 1,
  Lreactbuild_person_SupplyRowTarget: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$Product.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$Product;
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$Undefined(stage, title) {
  this.Lreactbuild_person_SupplyRowTarget$Undefined__f_stage = null;
  this.Lreactbuild_person_SupplyRowTarget$Undefined__f_title = null;
  this.Lreactbuild_person_SupplyRowTarget$Undefined__f_stage = stage;
  this.Lreactbuild_person_SupplyRowTarget$Undefined__f_title = title
}
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$Undefined;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$Undefined() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$Undefined.prototype = $c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype;
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.renderTitle__Lreactbuild_person_RowListing__T = (function(f) {
  return this.Lreactbuild_person_SupplyRowTarget$Undefined__f_title
});
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.productPrefix__T = (function() {
  return "Undefined"
});
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_SupplyRowTarget$Undefined__f_stage;
      break
    }
    case 1: {
      return this.Lreactbuild_person_SupplyRowTarget$Undefined__f_title;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_SupplyRowTarget$Undefined)) {
    var Undefined$1 = $as_Lreactbuild_person_SupplyRowTarget$Undefined(x$1);
    var x = this.Lreactbuild_person_SupplyRowTarget$Undefined__f_stage;
    var x$2 = $n(Undefined$1).Lreactbuild_person_SupplyRowTarget$Undefined__f_stage;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lreactbuild_person_SupplyRowTarget$Undefined__f_title === $n(Undefined$1).Lreactbuild_person_SupplyRowTarget$Undefined__f_title)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_SupplyRowTarget$Undefined(obj) {
  return (((obj instanceof $c_Lreactbuild_person_SupplyRowTarget$Undefined) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.SupplyRowTarget$Undefined"))
}
function $isArrayOf_Lreactbuild_person_SupplyRowTarget$Undefined(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_SupplyRowTarget$Undefined)))
}
function $asArrayOf_Lreactbuild_person_SupplyRowTarget$Undefined(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_SupplyRowTarget$Undefined(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.SupplyRowTarget$Undefined;", depth))
}
var $d_Lreactbuild_person_SupplyRowTarget$Undefined = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$Undefined: 0
}, false, "reactbuild.person.SupplyRowTarget$Undefined", {
  Lreactbuild_person_SupplyRowTarget$Undefined: 1,
  O: 1,
  Lreactbuild_person_SupplyRowTarget: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$Undefined.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$Undefined;
/** @constructor */
function $c_Lreactbuild_person_TextCredentialData(value) {
  this.Lreactbuild_person_TextCredentialData__f_value = null;
  this.Lreactbuild_person_TextCredentialData__f_value = value
}
$c_Lreactbuild_person_TextCredentialData.prototype = new $h_O();
$c_Lreactbuild_person_TextCredentialData.prototype.constructor = $c_Lreactbuild_person_TextCredentialData;
/** @constructor */
function $h_Lreactbuild_person_TextCredentialData() {
  /*<skip>*/
}
$h_Lreactbuild_person_TextCredentialData.prototype = $c_Lreactbuild_person_TextCredentialData.prototype;
$c_Lreactbuild_person_TextCredentialData.prototype.productPrefix__T = (function() {
  return "TextCredentialData"
});
$c_Lreactbuild_person_TextCredentialData.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_TextCredentialData.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_TextCredentialData__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_TextCredentialData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_TextCredentialData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_TextCredentialData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_TextCredentialData.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_TextCredentialData)) {
    var TextCredentialData$1 = $as_Lreactbuild_person_TextCredentialData(x$1);
    return (this.Lreactbuild_person_TextCredentialData__f_value === $n(TextCredentialData$1).Lreactbuild_person_TextCredentialData__f_value)
  } else {
    return false
  }
});
function $as_Lreactbuild_person_TextCredentialData(obj) {
  return (((obj instanceof $c_Lreactbuild_person_TextCredentialData) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.TextCredentialData"))
}
function $isArrayOf_Lreactbuild_person_TextCredentialData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_TextCredentialData)))
}
function $asArrayOf_Lreactbuild_person_TextCredentialData(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_TextCredentialData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.TextCredentialData;", depth))
}
var $d_Lreactbuild_person_TextCredentialData = new $TypeData().initClass({
  Lreactbuild_person_TextCredentialData: 0
}, false, "reactbuild.person.TextCredentialData", {
  Lreactbuild_person_TextCredentialData: 1,
  O: 1,
  Lreactbuild_person_CredentialData: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_TextCredentialData.prototype.$classData = $d_Lreactbuild_person_TextCredentialData;
/** @constructor */
function $c_Lreactbuild_person_UserFacet(email) {
  this.Lreactbuild_person_UserFacet__f_email = null;
  this.Lreactbuild_person_UserFacet__f_email = email
}
$c_Lreactbuild_person_UserFacet.prototype = new $h_O();
$c_Lreactbuild_person_UserFacet.prototype.constructor = $c_Lreactbuild_person_UserFacet;
/** @constructor */
function $h_Lreactbuild_person_UserFacet() {
  /*<skip>*/
}
$h_Lreactbuild_person_UserFacet.prototype = $c_Lreactbuild_person_UserFacet.prototype;
$c_Lreactbuild_person_UserFacet.prototype.productPrefix__T = (function() {
  return "UserFacet"
});
$c_Lreactbuild_person_UserFacet.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_UserFacet.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_UserFacet__f_email : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_UserFacet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_UserFacet.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_UserFacet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_UserFacet.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_UserFacet)) {
    var UserFacet$1 = $as_Lreactbuild_person_UserFacet(x$1);
    var x = this.Lreactbuild_person_UserFacet__f_email;
    var x$2 = $n(UserFacet$1).Lreactbuild_person_UserFacet__f_email;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_UserFacet(obj) {
  return (((obj instanceof $c_Lreactbuild_person_UserFacet) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.UserFacet"))
}
function $isArrayOf_Lreactbuild_person_UserFacet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_UserFacet)))
}
function $asArrayOf_Lreactbuild_person_UserFacet(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_UserFacet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.UserFacet;", depth))
}
var $d_Lreactbuild_person_UserFacet = new $TypeData().initClass({
  Lreactbuild_person_UserFacet: 0
}, false, "reactbuild.person.UserFacet", {
  Lreactbuild_person_UserFacet: 1,
  O: 1,
  Lreactbuild_person_Facet: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_UserFacet.prototype.$classData = $d_Lreactbuild_person_UserFacet;
/** @constructor */
function $c_Lreactbuild_person_VerticalInterval(top, bottom) {
  this.Lreactbuild_person_VerticalInterval__f_top = 0.0;
  this.Lreactbuild_person_VerticalInterval__f_bottom = 0.0;
  this.Lreactbuild_person_VerticalInterval__f_top = top;
  this.Lreactbuild_person_VerticalInterval__f_bottom = bottom
}
$c_Lreactbuild_person_VerticalInterval.prototype = new $h_O();
$c_Lreactbuild_person_VerticalInterval.prototype.constructor = $c_Lreactbuild_person_VerticalInterval;
/** @constructor */
function $h_Lreactbuild_person_VerticalInterval() {
  /*<skip>*/
}
$h_Lreactbuild_person_VerticalInterval.prototype = $c_Lreactbuild_person_VerticalInterval.prototype;
$c_Lreactbuild_person_VerticalInterval.prototype.productPrefix__T = (function() {
  return "VerticalInterval"
});
$c_Lreactbuild_person_VerticalInterval.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_VerticalInterval.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_VerticalInterval__f_top;
      break
    }
    case 1: {
      return this.Lreactbuild_person_VerticalInterval__f_bottom;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_VerticalInterval.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_VerticalInterval.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("VerticalInterval");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_person_VerticalInterval__f_top;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_person_VerticalInterval__f_bottom;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_person_VerticalInterval.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_VerticalInterval.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_VerticalInterval)) {
    var VerticalInterval$1 = $as_Lreactbuild_person_VerticalInterval(x$1);
    return ((this.Lreactbuild_person_VerticalInterval__f_top === $n(VerticalInterval$1).Lreactbuild_person_VerticalInterval__f_top) && (this.Lreactbuild_person_VerticalInterval__f_bottom === $n(VerticalInterval$1).Lreactbuild_person_VerticalInterval__f_bottom))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_VerticalInterval(obj) {
  return (((obj instanceof $c_Lreactbuild_person_VerticalInterval) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.VerticalInterval"))
}
function $isArrayOf_Lreactbuild_person_VerticalInterval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_VerticalInterval)))
}
function $asArrayOf_Lreactbuild_person_VerticalInterval(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_VerticalInterval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.VerticalInterval;", depth))
}
var $d_Lreactbuild_person_VerticalInterval = new $TypeData().initClass({
  Lreactbuild_person_VerticalInterval: 0
}, false, "reactbuild.person.VerticalInterval", {
  Lreactbuild_person_VerticalInterval: 1,
  O: 1,
  Lreactbuild_person_Bounds: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_VerticalInterval.prototype.$classData = $d_Lreactbuild_person_VerticalInterval;
/** @constructor */
function $c_Lreactbuild_person_Website(url, credentials) {
  this.Lreactbuild_person_Website__f_url = null;
  this.Lreactbuild_person_Website__f_credentials = null;
  this.Lreactbuild_person_Website__f_url = url;
  this.Lreactbuild_person_Website__f_credentials = credentials
}
$c_Lreactbuild_person_Website.prototype = new $h_O();
$c_Lreactbuild_person_Website.prototype.constructor = $c_Lreactbuild_person_Website;
/** @constructor */
function $h_Lreactbuild_person_Website() {
  /*<skip>*/
}
$h_Lreactbuild_person_Website.prototype = $c_Lreactbuild_person_Website.prototype;
$c_Lreactbuild_person_Website.prototype.productPrefix__T = (function() {
  return "Website"
});
$c_Lreactbuild_person_Website.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_person_Website.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_person_Website__f_url;
      break
    }
    case 1: {
      return this.Lreactbuild_person_Website__f_credentials;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_person_Website.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_Website.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_Website.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_Website.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_Website)) {
    var Website$1 = $as_Lreactbuild_person_Website(x$1);
    if ((this.Lreactbuild_person_Website__f_url === $n(Website$1).Lreactbuild_person_Website__f_url)) {
      var x = this.Lreactbuild_person_Website__f_credentials;
      var x$2 = $n(Website$1).Lreactbuild_person_Website__f_credentials;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_person_Website(obj) {
  return (((obj instanceof $c_Lreactbuild_person_Website) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.Website"))
}
function $isArrayOf_Lreactbuild_person_Website(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_Website)))
}
function $asArrayOf_Lreactbuild_person_Website(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_Website(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.Website;", depth))
}
var $d_Lreactbuild_person_Website = new $TypeData().initClass({
  Lreactbuild_person_Website: 0
}, false, "reactbuild.person.Website", {
  Lreactbuild_person_Website: 1,
  O: 1,
  Lreactbuild_person_AddressDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Website.prototype.$classData = $d_Lreactbuild_person_Website;
/** @constructor */
function $c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice(device) {
  this.Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice__f_device = null;
  this.Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice__f_device = device
}
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype.constructor = $c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice;
/** @constructor */
function $h_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype = $c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype;
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype.productPrefix__T = (function() {
  return "PushBluetoothDevice"
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice__f_device : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice)) {
    var PushBluetoothDevice$1 = $as_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice(x$1);
    var x = this.Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice__f_device;
    var y = $n(PushBluetoothDevice$1).Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice__f_device;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice(obj) {
  return (((obj instanceof $c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.plugins.devices.DeviceMeasure$PushBluetoothDevice"))
}
function $isArrayOf_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice)))
}
function $asArrayOf_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice(obj, depth) {
  return (($isArrayOf_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.plugins.devices.DeviceMeasure$PushBluetoothDevice;", depth))
}
var $d_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice = new $TypeData().initClass({
  Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice: 0
}, false, "reactbuild.plugins.devices.DeviceMeasure$PushBluetoothDevice", {
  Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice: 1,
  O: 1,
  Lreactbuild_plugins_devices_DeviceAction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice.prototype.$classData = $d_Lreactbuild_plugins_devices_DeviceMeasure$PushBluetoothDevice;
/** @constructor */
function $c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure(measure) {
  this.Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure__f_measure = null;
  this.Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure__f_measure = measure
}
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype.constructor = $c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure;
/** @constructor */
function $h_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype = $c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype;
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype.productPrefix__T = (function() {
  return "RecordMeasure"
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure__f_measure : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure)) {
    var RecordMeasure$1 = $as_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure(x$1);
    var x = this.Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure__f_measure;
    var x$2 = $n(RecordMeasure$1).Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure__f_measure;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure(obj) {
  return (((obj instanceof $c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.plugins.devices.DeviceMeasure$RecordMeasure"))
}
function $isArrayOf_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure)))
}
function $asArrayOf_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure(obj, depth) {
  return (($isArrayOf_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.plugins.devices.DeviceMeasure$RecordMeasure;", depth))
}
var $d_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure = new $TypeData().initClass({
  Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure: 0
}, false, "reactbuild.plugins.devices.DeviceMeasure$RecordMeasure", {
  Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure: 1,
  O: 1,
  Lreactbuild_plugins_devices_DeviceAction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure.prototype.$classData = $d_Lreactbuild_plugins_devices_DeviceMeasure$RecordMeasure;
/** @constructor */
function $c_Lreactbuild_plugins_devices_MeasureDetailsError(message) {
  this.Lreactbuild_plugins_devices_MeasureDetailsError__f_message = null;
  this.Lreactbuild_plugins_devices_MeasureDetailsError__f_message = message
}
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype.constructor = $c_Lreactbuild_plugins_devices_MeasureDetailsError;
/** @constructor */
function $h_Lreactbuild_plugins_devices_MeasureDetailsError() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_MeasureDetailsError.prototype = $c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype;
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype.productPrefix__T = (function() {
  return "MeasureDetailsError"
});
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_plugins_devices_MeasureDetailsError__f_message : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_plugins_devices_MeasureDetailsError)) {
    var MeasureDetailsError$1 = $as_Lreactbuild_plugins_devices_MeasureDetailsError(x$1);
    return (this.Lreactbuild_plugins_devices_MeasureDetailsError__f_message === $n(MeasureDetailsError$1).Lreactbuild_plugins_devices_MeasureDetailsError__f_message)
  } else {
    return false
  }
});
function $as_Lreactbuild_plugins_devices_MeasureDetailsError(obj) {
  return (((obj instanceof $c_Lreactbuild_plugins_devices_MeasureDetailsError) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.plugins.devices.MeasureDetailsError"))
}
function $isArrayOf_Lreactbuild_plugins_devices_MeasureDetailsError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_plugins_devices_MeasureDetailsError)))
}
function $asArrayOf_Lreactbuild_plugins_devices_MeasureDetailsError(obj, depth) {
  return (($isArrayOf_Lreactbuild_plugins_devices_MeasureDetailsError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.plugins.devices.MeasureDetailsError;", depth))
}
var $d_Lreactbuild_plugins_devices_MeasureDetailsError = new $TypeData().initClass({
  Lreactbuild_plugins_devices_MeasureDetailsError: 0
}, false, "reactbuild.plugins.devices.MeasureDetailsError", {
  Lreactbuild_plugins_devices_MeasureDetailsError: 1,
  O: 1,
  Lreactbuild_plugins_devices_MeasureDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_plugins_devices_MeasureDetailsError.prototype.$classData = $d_Lreactbuild_plugins_devices_MeasureDetailsError;
/** @constructor */
function $c_Lreactbuild_plugins_devices_NoMeasure$() {
  /*<skip>*/
}
$c_Lreactbuild_plugins_devices_NoMeasure$.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_NoMeasure$.prototype.constructor = $c_Lreactbuild_plugins_devices_NoMeasure$;
/** @constructor */
function $h_Lreactbuild_plugins_devices_NoMeasure$() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_NoMeasure$.prototype = $c_Lreactbuild_plugins_devices_NoMeasure$.prototype;
$c_Lreactbuild_plugins_devices_NoMeasure$.prototype.productPrefix__T = (function() {
  return "NoMeasure"
});
$c_Lreactbuild_plugins_devices_NoMeasure$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_plugins_devices_NoMeasure$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_plugins_devices_NoMeasure$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_plugins_devices_NoMeasure$.prototype.hashCode__I = (function() {
  return (-761101251)
});
$c_Lreactbuild_plugins_devices_NoMeasure$.prototype.toString__T = (function() {
  return "NoMeasure"
});
var $d_Lreactbuild_plugins_devices_NoMeasure$ = new $TypeData().initClass({
  Lreactbuild_plugins_devices_NoMeasure$: 0
}, false, "reactbuild.plugins.devices.NoMeasure$", {
  Lreactbuild_plugins_devices_NoMeasure$: 1,
  O: 1,
  Lreactbuild_plugins_devices_MeasureDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_plugins_devices_NoMeasure$.prototype.$classData = $d_Lreactbuild_plugins_devices_NoMeasure$;
var $n_Lreactbuild_plugins_devices_NoMeasure$;
function $m_Lreactbuild_plugins_devices_NoMeasure$() {
  if ((!$n_Lreactbuild_plugins_devices_NoMeasure$)) {
    $n_Lreactbuild_plugins_devices_NoMeasure$ = new $c_Lreactbuild_plugins_devices_NoMeasure$()
  };
  return $n_Lreactbuild_plugins_devices_NoMeasure$
}
/** @constructor */
function $c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1(orgOptRef$1, props$3, propsRef$1) {
  this.Lreactbuild_model_BaseRefToResolver__f_itemFetcher = null;
  this.Lreactbuild_model_BaseRefToResolver__f_itemTokenizer = null;
  this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_orgOptRef$1 = null;
  this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_props$3 = null;
  this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_propsRef$1 = null;
  this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_orgOptRef$1 = orgOptRef$1;
  this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_props$3 = props$3;
  this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_propsRef$1 = propsRef$1;
  $ct_Lreactbuild_model_BaseRefToResolver__(this)
}
$c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1.prototype = new $h_Lreactbuild_model_RefToResolver();
$c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1.prototype.constructor = $c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1;
/** @constructor */
function $h_Lreactbuild_process_NewProcessInstanceEvent$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_process_NewProcessInstanceEvent$$anon$1.prototype = $c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1.prototype;
$c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1.prototype.createItem__T__s_Option = (function(in$1) {
  var this$1 = $n(this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_orgOptRef$1);
  var this$19 = $n($as_s_Option(this$1.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
  var f = new $c_sjsr_AnonFunction1(((org$2) => {
    var org = $as_Lreactbuild_common_model_RefTo(org$2);
    var process = new $c_Lreactbuild_model_process_Process(($n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo), new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID())), org, in$1, $m_s_package$().s_package$__f_Nil);
    var cb = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
      var this$4 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x3 = new $c_Lautowire_ClientProxy(this$4).Lautowire_ClientProxy__f_self;
      var $$x2 = $m_s_package$().s_package$__f_Seq;
      var array = ["reactbuild", "process", "ProcessApi", "persistProcess"];
      var $$x1 = $as_sci_Seq($n($$x2).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
      var this$15 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$9 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$10 = $n(new $c_Lautowire_ClientProxy(this$9).Lautowire_ClientProxy__f_self);
      var evidence$2 = $m_Lreactbuild_model_process_Process$().Lreactbuild_model_process_Process$__f_codecForProcess;
      var y = this$10.write__O__Lio_circe_Encoder__Lio_circe_Json(process, evidence$2);
      var array$1 = [$ct_T2__O__O__(new $c_T2(), "process", y)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      return $n($n($$x3).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x1, this$15.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$16 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$17 = $n(new $c_Lautowire_ClientProxy(this$16).Lautowire_ClientProxy__f_self);
        var evidence$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit;
        this$17.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1)
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue), new $c_sjsr_AnonFunction1(((x$31$2) => {
      $as_jl_Void(x$31$2);
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r = $n($n(this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_props$3).Lreactbuild_process_NewProcessInstanceEvent$Props__f_parentState).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_process_Processes$Insert(process));
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x5).map$extension__F1__F1__F1($n($$x4).asAsyncCallback$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(r).value__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline), new $c_sjsr_AnonFunction1(((x$30$2) => {
        $as_jl_Void(x$30$2);
        return process
      }))))
    })));
    return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().unsafeToFuture$extension__F1__s_concurrent_Future(cb)
  }));
  return (this$19.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$19.get__O())))
});
$c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1.prototype.allItems__sci_List = (function() {
  var this$1 = $n(this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_orgOptRef$1);
  var this$2 = $n($as_s_Option(this$1.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
  if (this$2.isEmpty__Z()) {
    var $$x1 = $m_s_package$().s_package$__f_Nil
  } else {
    var arg1 = this$2.get__O();
    var org = $as_Lreactbuild_common_model_RefTo(arg1);
    var this$3 = $n(this.Lreactbuild_process_NewProcessInstanceEvent$$anon$1__f_propsRef$1);
    var this$4 = $n($n($as_Lreactbuild_process_NewProcessInstanceEvent$Props(this$3.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current)).Lreactbuild_process_NewProcessInstanceEvent$Props__f_parentState);
    var this$6 = $n($n($as_Lreactbuild_process_Processes$State(this$4.Ljapgolly_scalajs_react_hooks_Hooks$UseReducer__f_raw[0])).Lreactbuild_process_Processes$State__f_process);
    var f = ((x$32$2) => {
      var x$32 = $as_Lreactbuild_model_process_Process(x$32$2);
      var x = $n(x$32).Lreactbuild_model_process_Process__f_organization;
      return ((x === null) ? (org === null) : $n(x).equals__O__Z(org))
    });
    var l = this$6;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break
        } else {
          var h = $n(l).head__O();
          var t = $as_sci_List($n(l).tail__O());
          if (($uZ(f(h)) === false)) {
            l = t;
            continue
          };
          var start = l;
          var remaining = t;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block
            } else {
              var x$1 = $n(remaining).head__O();
              if (($uZ(f(x$1)) !== false)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue
              };
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O())
              };
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f(head)) !== false)) {
                  next = $as_sci_List($n(next).tail__O())
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
                  };
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O())
                }
              };
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy
              };
              var result = newHead;
              break block
            }
          }
        }
      }
    };
    var $$x1 = result
  };
  return $as_sci_List($$x1)
});
$c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1.prototype.getRef__O__Lreactbuild_common_model_RefTo = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_process_Process(in$1);
  return $n(in$2).Lreactbuild_model_process_Process__f__id
});
$c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1.prototype.getTitle__O__T = (function(in$1) {
  var in$2 = $as_Lreactbuild_model_process_Process(in$1);
  return $n(in$2).Lreactbuild_model_process_Process__f_name
});
var $d_Lreactbuild_process_NewProcessInstanceEvent$$anon$1 = new $TypeData().initClass({
  Lreactbuild_process_NewProcessInstanceEvent$$anon$1: 0
}, false, "reactbuild.process.NewProcessInstanceEvent$$anon$1", {
  Lreactbuild_process_NewProcessInstanceEvent$$anon$1: 1,
  Lreactbuild_model_RefToResolver: 1,
  Lreactbuild_model_BaseRefToResolver: 1,
  O: 1,
  Lcom_iz2use_common_Resolver: 1,
  Lcom_iz2use_react_components_TextEditorHelper: 1
});
$c_Lreactbuild_process_NewProcessInstanceEvent$$anon$1.prototype.$classData = $d_Lreactbuild_process_NewProcessInstanceEvent$$anon$1;
class $c_Lreactbuild_process_ProcessException extends $c_jl_RuntimeException {
}
/** @constructor */
function $c_Lreactbuild_process_Processes$EventInsert(events) {
  this.Lreactbuild_process_Processes$EventInsert__f_events = null;
  this.Lreactbuild_process_Processes$EventInsert__f_events = events
}
$c_Lreactbuild_process_Processes$EventInsert.prototype = new $h_O();
$c_Lreactbuild_process_Processes$EventInsert.prototype.constructor = $c_Lreactbuild_process_Processes$EventInsert;
/** @constructor */
function $h_Lreactbuild_process_Processes$EventInsert() {
  /*<skip>*/
}
$h_Lreactbuild_process_Processes$EventInsert.prototype = $c_Lreactbuild_process_Processes$EventInsert.prototype;
$c_Lreactbuild_process_Processes$EventInsert.prototype.productPrefix__T = (function() {
  return "EventInsert"
});
$c_Lreactbuild_process_Processes$EventInsert.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_process_Processes$EventInsert.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_process_Processes$EventInsert__f_events : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_process_Processes$EventInsert.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_Processes$EventInsert.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_Processes$EventInsert.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_Processes$EventInsert.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_Processes$EventInsert)) {
    var EventInsert$1 = $as_Lreactbuild_process_Processes$EventInsert(x$1);
    var x = this.Lreactbuild_process_Processes$EventInsert__f_events;
    var x$2 = $n(EventInsert$1).Lreactbuild_process_Processes$EventInsert__f_events;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_process_Processes$EventInsert(obj) {
  return (((obj instanceof $c_Lreactbuild_process_Processes$EventInsert) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.Processes$EventInsert"))
}
function $isArrayOf_Lreactbuild_process_Processes$EventInsert(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_Processes$EventInsert)))
}
function $asArrayOf_Lreactbuild_process_Processes$EventInsert(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_Processes$EventInsert(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.Processes$EventInsert;", depth))
}
var $d_Lreactbuild_process_Processes$EventInsert = new $TypeData().initClass({
  Lreactbuild_process_Processes$EventInsert: 0
}, false, "reactbuild.process.Processes$EventInsert", {
  Lreactbuild_process_Processes$EventInsert: 1,
  O: 1,
  Lreactbuild_process_Processes$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_Processes$EventInsert.prototype.$classData = $d_Lreactbuild_process_Processes$EventInsert;
/** @constructor */
function $c_Lreactbuild_process_Processes$Insert(process) {
  this.Lreactbuild_process_Processes$Insert__f_process = null;
  this.Lreactbuild_process_Processes$Insert__f_process = process
}
$c_Lreactbuild_process_Processes$Insert.prototype = new $h_O();
$c_Lreactbuild_process_Processes$Insert.prototype.constructor = $c_Lreactbuild_process_Processes$Insert;
/** @constructor */
function $h_Lreactbuild_process_Processes$Insert() {
  /*<skip>*/
}
$h_Lreactbuild_process_Processes$Insert.prototype = $c_Lreactbuild_process_Processes$Insert.prototype;
$c_Lreactbuild_process_Processes$Insert.prototype.productPrefix__T = (function() {
  return "Insert"
});
$c_Lreactbuild_process_Processes$Insert.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_process_Processes$Insert.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_process_Processes$Insert__f_process : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_process_Processes$Insert.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_Processes$Insert.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_Processes$Insert.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_Processes$Insert.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_Processes$Insert)) {
    var Insert$1 = $as_Lreactbuild_process_Processes$Insert(x$1);
    var x = this.Lreactbuild_process_Processes$Insert__f_process;
    var x$2 = $n(Insert$1).Lreactbuild_process_Processes$Insert__f_process;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_process_Processes$Insert(obj) {
  return (((obj instanceof $c_Lreactbuild_process_Processes$Insert) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.Processes$Insert"))
}
function $isArrayOf_Lreactbuild_process_Processes$Insert(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_Processes$Insert)))
}
function $asArrayOf_Lreactbuild_process_Processes$Insert(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_Processes$Insert(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.Processes$Insert;", depth))
}
var $d_Lreactbuild_process_Processes$Insert = new $TypeData().initClass({
  Lreactbuild_process_Processes$Insert: 0
}, false, "reactbuild.process.Processes$Insert", {
  Lreactbuild_process_Processes$Insert: 1,
  O: 1,
  Lreactbuild_process_Processes$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_Processes$Insert.prototype.$classData = $d_Lreactbuild_process_Processes$Insert;
/** @constructor */
function $c_Lreactbuild_process_Processes$ItemChanged(target) {
  this.Lreactbuild_process_Processes$ItemChanged__f_target = null;
  this.Lreactbuild_process_Processes$ItemChanged__f_target = target
}
$c_Lreactbuild_process_Processes$ItemChanged.prototype = new $h_O();
$c_Lreactbuild_process_Processes$ItemChanged.prototype.constructor = $c_Lreactbuild_process_Processes$ItemChanged;
/** @constructor */
function $h_Lreactbuild_process_Processes$ItemChanged() {
  /*<skip>*/
}
$h_Lreactbuild_process_Processes$ItemChanged.prototype = $c_Lreactbuild_process_Processes$ItemChanged.prototype;
$c_Lreactbuild_process_Processes$ItemChanged.prototype.productPrefix__T = (function() {
  return "ItemChanged"
});
$c_Lreactbuild_process_Processes$ItemChanged.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_process_Processes$ItemChanged.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_process_Processes$ItemChanged__f_target : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_process_Processes$ItemChanged.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_Processes$ItemChanged.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_Processes$ItemChanged.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_Processes$ItemChanged.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_Processes$ItemChanged)) {
    var ItemChanged$1 = $as_Lreactbuild_process_Processes$ItemChanged(x$1);
    var x = this.Lreactbuild_process_Processes$ItemChanged__f_target;
    var x$2 = $n(ItemChanged$1).Lreactbuild_process_Processes$ItemChanged__f_target;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_process_Processes$ItemChanged(obj) {
  return (((obj instanceof $c_Lreactbuild_process_Processes$ItemChanged) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.Processes$ItemChanged"))
}
function $isArrayOf_Lreactbuild_process_Processes$ItemChanged(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_Processes$ItemChanged)))
}
function $asArrayOf_Lreactbuild_process_Processes$ItemChanged(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_Processes$ItemChanged(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.Processes$ItemChanged;", depth))
}
var $d_Lreactbuild_process_Processes$ItemChanged = new $TypeData().initClass({
  Lreactbuild_process_Processes$ItemChanged: 0
}, false, "reactbuild.process.Processes$ItemChanged", {
  Lreactbuild_process_Processes$ItemChanged: 1,
  O: 1,
  Lreactbuild_process_Processes$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_Processes$ItemChanged.prototype.$classData = $d_Lreactbuild_process_Processes$ItemChanged;
/** @constructor */
function $c_Lreactbuild_process_Processes$LoadProcesses(processes) {
  this.Lreactbuild_process_Processes$LoadProcesses__f_processes = null;
  this.Lreactbuild_process_Processes$LoadProcesses__f_processes = processes
}
$c_Lreactbuild_process_Processes$LoadProcesses.prototype = new $h_O();
$c_Lreactbuild_process_Processes$LoadProcesses.prototype.constructor = $c_Lreactbuild_process_Processes$LoadProcesses;
/** @constructor */
function $h_Lreactbuild_process_Processes$LoadProcesses() {
  /*<skip>*/
}
$h_Lreactbuild_process_Processes$LoadProcesses.prototype = $c_Lreactbuild_process_Processes$LoadProcesses.prototype;
$c_Lreactbuild_process_Processes$LoadProcesses.prototype.productPrefix__T = (function() {
  return "LoadProcesses"
});
$c_Lreactbuild_process_Processes$LoadProcesses.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_process_Processes$LoadProcesses.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_process_Processes$LoadProcesses__f_processes : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_process_Processes$LoadProcesses.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_Processes$LoadProcesses.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_process_Processes$LoadProcesses.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_process_Processes$LoadProcesses.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_process_Processes$LoadProcesses)) {
    var LoadProcesses$1 = $as_Lreactbuild_process_Processes$LoadProcesses(x$1);
    var x = this.Lreactbuild_process_Processes$LoadProcesses__f_processes;
    var x$2 = $n(LoadProcesses$1).Lreactbuild_process_Processes$LoadProcesses__f_processes;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_process_Processes$LoadProcesses(obj) {
  return (((obj instanceof $c_Lreactbuild_process_Processes$LoadProcesses) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.process.Processes$LoadProcesses"))
}
function $isArrayOf_Lreactbuild_process_Processes$LoadProcesses(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_process_Processes$LoadProcesses)))
}
function $asArrayOf_Lreactbuild_process_Processes$LoadProcesses(obj, depth) {
  return (($isArrayOf_Lreactbuild_process_Processes$LoadProcesses(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.process.Processes$LoadProcesses;", depth))
}
var $d_Lreactbuild_process_Processes$LoadProcesses = new $TypeData().initClass({
  Lreactbuild_process_Processes$LoadProcesses: 0
}, false, "reactbuild.process.Processes$LoadProcesses", {
  Lreactbuild_process_Processes$LoadProcesses: 1,
  O: 1,
  Lreactbuild_process_Processes$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_Processes$LoadProcesses.prototype.$classData = $d_Lreactbuild_process_Processes$LoadProcesses;
/** @constructor */
function $c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$() {
  /*<skip>*/
}
$c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype = new $h_O();
$c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype.constructor = $c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$;
/** @constructor */
function $h_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$() {
  /*<skip>*/
}
$h_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype = $c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype;
$c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype.productPrefix__T = (function() {
  return "useProcessArgProject"
});
$c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype.hashCode__I = (function() {
  return 1606258923
});
$c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype.toString__T = (function() {
  return "useProcessArgProject"
});
var $d_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$ = new $TypeData().initClass({
  Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$: 0
}, false, "reactbuild.process.Processes$UseProcessArg$useProcessArgProject$", {
  Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$: 1,
  O: 1,
  Lreactbuild_process_Processes$UseProcessArg: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$.prototype.$classData = $d_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$;
var $n_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$;
function $m_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$() {
  if ((!$n_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$)) {
    $n_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$ = new $c_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$()
  };
  return $n_Lreactbuild_process_Processes$UseProcessArg$useProcessArgProject$
}
/** @constructor */
function $c_Lreactbuild_project_OnSiteSurvey$() {
  this.Lreactbuild_project_OnSiteSurvey$__f_title = null;
  this.Lreactbuild_project_OnSiteSurvey$__f_title = "Relev\u00e9 de mesures et prise de photos sur place pour travaux"
}
$c_Lreactbuild_project_OnSiteSurvey$.prototype = new $h_O();
$c_Lreactbuild_project_OnSiteSurvey$.prototype.constructor = $c_Lreactbuild_project_OnSiteSurvey$;
/** @constructor */
function $h_Lreactbuild_project_OnSiteSurvey$() {
  /*<skip>*/
}
$h_Lreactbuild_project_OnSiteSurvey$.prototype = $c_Lreactbuild_project_OnSiteSurvey$.prototype;
$c_Lreactbuild_project_OnSiteSurvey$.prototype.title__T = (function() {
  return this.Lreactbuild_project_OnSiteSurvey$__f_title
});
$c_Lreactbuild_project_OnSiteSurvey$.prototype.productPrefix__T = (function() {
  return "OnSiteSurvey"
});
$c_Lreactbuild_project_OnSiteSurvey$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_OnSiteSurvey$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_OnSiteSurvey$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_OnSiteSurvey$.prototype.hashCode__I = (function() {
  return (-484551456)
});
$c_Lreactbuild_project_OnSiteSurvey$.prototype.toString__T = (function() {
  return "OnSiteSurvey"
});
var $d_Lreactbuild_project_OnSiteSurvey$ = new $TypeData().initClass({
  Lreactbuild_project_OnSiteSurvey$: 0
}, false, "reactbuild.project.OnSiteSurvey$", {
  Lreactbuild_project_OnSiteSurvey$: 1,
  O: 1,
  Lreactbuild_project_Activity: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_OnSiteSurvey$.prototype.$classData = $d_Lreactbuild_project_OnSiteSurvey$;
var $n_Lreactbuild_project_OnSiteSurvey$;
function $m_Lreactbuild_project_OnSiteSurvey$() {
  if ((!$n_Lreactbuild_project_OnSiteSurvey$)) {
    $n_Lreactbuild_project_OnSiteSurvey$ = new $c_Lreactbuild_project_OnSiteSurvey$()
  };
  return $n_Lreactbuild_project_OnSiteSurvey$
}
/** @constructor */
function $c_Lreactbuild_project_OpportunityStudy$() {
  this.Lreactbuild_project_OpportunityStudy$__f_title = null;
  this.Lreactbuild_project_OpportunityStudy$__f_title = "Etudier un nouveau projet"
}
$c_Lreactbuild_project_OpportunityStudy$.prototype = new $h_O();
$c_Lreactbuild_project_OpportunityStudy$.prototype.constructor = $c_Lreactbuild_project_OpportunityStudy$;
/** @constructor */
function $h_Lreactbuild_project_OpportunityStudy$() {
  /*<skip>*/
}
$h_Lreactbuild_project_OpportunityStudy$.prototype = $c_Lreactbuild_project_OpportunityStudy$.prototype;
$c_Lreactbuild_project_OpportunityStudy$.prototype.title__T = (function() {
  return this.Lreactbuild_project_OpportunityStudy$__f_title
});
$c_Lreactbuild_project_OpportunityStudy$.prototype.productPrefix__T = (function() {
  return "OpportunityStudy"
});
$c_Lreactbuild_project_OpportunityStudy$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_OpportunityStudy$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_OpportunityStudy$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_OpportunityStudy$.prototype.hashCode__I = (function() {
  return (-830486826)
});
$c_Lreactbuild_project_OpportunityStudy$.prototype.toString__T = (function() {
  return "OpportunityStudy"
});
var $d_Lreactbuild_project_OpportunityStudy$ = new $TypeData().initClass({
  Lreactbuild_project_OpportunityStudy$: 0
}, false, "reactbuild.project.OpportunityStudy$", {
  Lreactbuild_project_OpportunityStudy$: 1,
  O: 1,
  Lreactbuild_project_Activity: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_OpportunityStudy$.prototype.$classData = $d_Lreactbuild_project_OpportunityStudy$;
var $n_Lreactbuild_project_OpportunityStudy$;
function $m_Lreactbuild_project_OpportunityStudy$() {
  if ((!$n_Lreactbuild_project_OpportunityStudy$)) {
    $n_Lreactbuild_project_OpportunityStudy$ = new $c_Lreactbuild_project_OpportunityStudy$()
  };
  return $n_Lreactbuild_project_OpportunityStudy$
}
/** @constructor */
function $c_Lreactbuild_project_PageSide$Any$() {
  /*<skip>*/
}
$c_Lreactbuild_project_PageSide$Any$.prototype = new $h_O();
$c_Lreactbuild_project_PageSide$Any$.prototype.constructor = $c_Lreactbuild_project_PageSide$Any$;
/** @constructor */
function $h_Lreactbuild_project_PageSide$Any$() {
  /*<skip>*/
}
$h_Lreactbuild_project_PageSide$Any$.prototype = $c_Lreactbuild_project_PageSide$Any$.prototype;
$c_Lreactbuild_project_PageSide$Any$.prototype.productPrefix__T = (function() {
  return "Any"
});
$c_Lreactbuild_project_PageSide$Any$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_PageSide$Any$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_PageSide$Any$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_PageSide$Any$.prototype.hashCode__I = (function() {
  return 65996
});
$c_Lreactbuild_project_PageSide$Any$.prototype.toString__T = (function() {
  return "Any"
});
var $d_Lreactbuild_project_PageSide$Any$ = new $TypeData().initClass({
  Lreactbuild_project_PageSide$Any$: 0
}, false, "reactbuild.project.PageSide$Any$", {
  Lreactbuild_project_PageSide$Any$: 1,
  O: 1,
  Lreactbuild_project_PageSide: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_PageSide$Any$.prototype.$classData = $d_Lreactbuild_project_PageSide$Any$;
var $n_Lreactbuild_project_PageSide$Any$;
function $m_Lreactbuild_project_PageSide$Any$() {
  if ((!$n_Lreactbuild_project_PageSide$Any$)) {
    $n_Lreactbuild_project_PageSide$Any$ = new $c_Lreactbuild_project_PageSide$Any$()
  };
  return $n_Lreactbuild_project_PageSide$Any$
}
/** @constructor */
function $c_Lreactbuild_project_PersonResourceUsage(project, date, person, buildingStage, total) {
  this.Lreactbuild_project_PersonResourceUsage__f_project = null;
  this.Lreactbuild_project_PersonResourceUsage__f_date = null;
  this.Lreactbuild_project_PersonResourceUsage__f_person = null;
  this.Lreactbuild_project_PersonResourceUsage__f_buildingStage = null;
  this.Lreactbuild_project_PersonResourceUsage__f_total = null;
  this.Lreactbuild_project_PersonResourceUsage__f_project = project;
  this.Lreactbuild_project_PersonResourceUsage__f_date = date;
  this.Lreactbuild_project_PersonResourceUsage__f_person = person;
  this.Lreactbuild_project_PersonResourceUsage__f_buildingStage = buildingStage;
  this.Lreactbuild_project_PersonResourceUsage__f_total = total
}
$c_Lreactbuild_project_PersonResourceUsage.prototype = new $h_O();
$c_Lreactbuild_project_PersonResourceUsage.prototype.constructor = $c_Lreactbuild_project_PersonResourceUsage;
/** @constructor */
function $h_Lreactbuild_project_PersonResourceUsage() {
  /*<skip>*/
}
$h_Lreactbuild_project_PersonResourceUsage.prototype = $c_Lreactbuild_project_PersonResourceUsage.prototype;
$c_Lreactbuild_project_PersonResourceUsage.prototype.project__s_Option = (function() {
  return this.Lreactbuild_project_PersonResourceUsage__f_project
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.date__Ljava_time_LocalDate = (function() {
  return this.Lreactbuild_project_PersonResourceUsage__f_date
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.fold__F1__F1__O = (function(ifProduct, ifPerson) {
  return $n(ifPerson).apply__O__O(this)
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.productPrefix__T = (function() {
  return "PersonResourceUsage"
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_PersonResourceUsage__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_project_PersonResourceUsage__f_date;
      break
    }
    case 2: {
      return this.Lreactbuild_project_PersonResourceUsage__f_person;
      break
    }
    case 3: {
      return this.Lreactbuild_project_PersonResourceUsage__f_buildingStage;
      break
    }
    case 4: {
      return this.Lreactbuild_project_PersonResourceUsage__f_total;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_PersonResourceUsage)) {
    var PersonResourceUsage$1 = $as_Lreactbuild_project_PersonResourceUsage(x$1);
    var x = this.Lreactbuild_project_PersonResourceUsage__f_project;
    var x$2 = $n(PersonResourceUsage$1).Lreactbuild_project_PersonResourceUsage__f_project;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_PersonResourceUsage__f_date;
      var x$4 = $n(PersonResourceUsage$1).Lreactbuild_project_PersonResourceUsage__f_date;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_project_PersonResourceUsage__f_person;
      var x$6 = $n(PersonResourceUsage$1).Lreactbuild_project_PersonResourceUsage__f_person;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_project_PersonResourceUsage__f_buildingStage;
        var x$8 = $n(PersonResourceUsage$1).Lreactbuild_project_PersonResourceUsage__f_buildingStage;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_project_PersonResourceUsage__f_total;
          var x$10 = $n(PersonResourceUsage$1).Lreactbuild_project_PersonResourceUsage__f_total;
          return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_PersonResourceUsage(obj) {
  return (((obj instanceof $c_Lreactbuild_project_PersonResourceUsage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.PersonResourceUsage"))
}
function $isArrayOf_Lreactbuild_project_PersonResourceUsage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_PersonResourceUsage)))
}
function $asArrayOf_Lreactbuild_project_PersonResourceUsage(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_PersonResourceUsage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.PersonResourceUsage;", depth))
}
var $d_Lreactbuild_project_PersonResourceUsage = new $TypeData().initClass({
  Lreactbuild_project_PersonResourceUsage: 0
}, false, "reactbuild.project.PersonResourceUsage", {
  Lreactbuild_project_PersonResourceUsage: 1,
  O: 1,
  Lreactbuild_project_ResourceUsage: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_PersonResourceUsage.prototype.$classData = $d_Lreactbuild_project_PersonResourceUsage;
/** @constructor */
function $c_Lreactbuild_project_ProductResourceUsage(project, date, supplier, reference, description, buildingStage, unitPrice, unit, quantity, total, parent) {
  this.Lreactbuild_project_ProductResourceUsage__f_project = null;
  this.Lreactbuild_project_ProductResourceUsage__f_date = null;
  this.Lreactbuild_project_ProductResourceUsage__f_supplier = null;
  this.Lreactbuild_project_ProductResourceUsage__f_reference = null;
  this.Lreactbuild_project_ProductResourceUsage__f_description = null;
  this.Lreactbuild_project_ProductResourceUsage__f_buildingStage = null;
  this.Lreactbuild_project_ProductResourceUsage__f_unitPrice = null;
  this.Lreactbuild_project_ProductResourceUsage__f_unit = null;
  this.Lreactbuild_project_ProductResourceUsage__f_quantity = null;
  this.Lreactbuild_project_ProductResourceUsage__f_total = null;
  this.Lreactbuild_project_ProductResourceUsage__f_parent = null;
  this.Lreactbuild_project_ProductResourceUsage__f_project = project;
  this.Lreactbuild_project_ProductResourceUsage__f_date = date;
  this.Lreactbuild_project_ProductResourceUsage__f_supplier = supplier;
  this.Lreactbuild_project_ProductResourceUsage__f_reference = reference;
  this.Lreactbuild_project_ProductResourceUsage__f_description = description;
  this.Lreactbuild_project_ProductResourceUsage__f_buildingStage = buildingStage;
  this.Lreactbuild_project_ProductResourceUsage__f_unitPrice = unitPrice;
  this.Lreactbuild_project_ProductResourceUsage__f_unit = unit;
  this.Lreactbuild_project_ProductResourceUsage__f_quantity = quantity;
  this.Lreactbuild_project_ProductResourceUsage__f_total = total;
  this.Lreactbuild_project_ProductResourceUsage__f_parent = parent
}
$c_Lreactbuild_project_ProductResourceUsage.prototype = new $h_O();
$c_Lreactbuild_project_ProductResourceUsage.prototype.constructor = $c_Lreactbuild_project_ProductResourceUsage;
/** @constructor */
function $h_Lreactbuild_project_ProductResourceUsage() {
  /*<skip>*/
}
$h_Lreactbuild_project_ProductResourceUsage.prototype = $c_Lreactbuild_project_ProductResourceUsage.prototype;
$c_Lreactbuild_project_ProductResourceUsage.prototype.project__s_Option = (function() {
  return this.Lreactbuild_project_ProductResourceUsage__f_project
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.date__Ljava_time_LocalDate = (function() {
  return this.Lreactbuild_project_ProductResourceUsage__f_date
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.fold__F1__F1__O = (function(ifProduct, ifPerson) {
  return $n(ifProduct).apply__O__O(this)
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.productPrefix__T = (function() {
  return "ProductResourceUsage"
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.productArity__I = (function() {
  return 11
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_ProductResourceUsage__f_project;
      break
    }
    case 1: {
      return this.Lreactbuild_project_ProductResourceUsage__f_date;
      break
    }
    case 2: {
      return this.Lreactbuild_project_ProductResourceUsage__f_supplier;
      break
    }
    case 3: {
      return this.Lreactbuild_project_ProductResourceUsage__f_reference;
      break
    }
    case 4: {
      return this.Lreactbuild_project_ProductResourceUsage__f_description;
      break
    }
    case 5: {
      return this.Lreactbuild_project_ProductResourceUsage__f_buildingStage;
      break
    }
    case 6: {
      return this.Lreactbuild_project_ProductResourceUsage__f_unitPrice;
      break
    }
    case 7: {
      return this.Lreactbuild_project_ProductResourceUsage__f_unit;
      break
    }
    case 8: {
      return this.Lreactbuild_project_ProductResourceUsage__f_quantity;
      break
    }
    case 9: {
      return this.Lreactbuild_project_ProductResourceUsage__f_total;
      break
    }
    case 10: {
      return this.Lreactbuild_project_ProductResourceUsage__f_parent;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_ProductResourceUsage)) {
    var ProductResourceUsage$1 = $as_Lreactbuild_project_ProductResourceUsage(x$1);
    var x = this.Lreactbuild_project_ProductResourceUsage__f_project;
    var x$2 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_project;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_ProductResourceUsage__f_date;
      var x$4 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_date;
      var $$x2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_project_ProductResourceUsage__f_supplier;
      var x$6 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_supplier;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_project_ProductResourceUsage__f_reference;
        var x$8 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_reference;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var $$x1 = (this.Lreactbuild_project_ProductResourceUsage__f_description === $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_description)
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lreactbuild_project_ProductResourceUsage__f_buildingStage;
      var x$10 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_buildingStage;
      if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
        var x$11 = this.Lreactbuild_project_ProductResourceUsage__f_unitPrice;
        var x$12 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_unitPrice;
        if (((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))) {
          var x$13 = this.Lreactbuild_project_ProductResourceUsage__f_unit;
          var x$14 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_unit;
          var $$x3 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14))
        } else {
          var $$x3 = false
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$15 = this.Lreactbuild_project_ProductResourceUsage__f_quantity;
        var x$16 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_quantity;
        if (((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))) {
          var x$17 = this.Lreactbuild_project_ProductResourceUsage__f_total;
          var x$18 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_total;
          if (((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))) {
            var x$19 = this.Lreactbuild_project_ProductResourceUsage__f_parent;
            var x$20 = $n(ProductResourceUsage$1).Lreactbuild_project_ProductResourceUsage__f_parent;
            return ((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20))
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_ProductResourceUsage(obj) {
  return (((obj instanceof $c_Lreactbuild_project_ProductResourceUsage) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.ProductResourceUsage"))
}
function $isArrayOf_Lreactbuild_project_ProductResourceUsage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_ProductResourceUsage)))
}
function $asArrayOf_Lreactbuild_project_ProductResourceUsage(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_ProductResourceUsage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.ProductResourceUsage;", depth))
}
var $d_Lreactbuild_project_ProductResourceUsage = new $TypeData().initClass({
  Lreactbuild_project_ProductResourceUsage: 0
}, false, "reactbuild.project.ProductResourceUsage", {
  Lreactbuild_project_ProductResourceUsage: 1,
  O: 1,
  Lreactbuild_project_ResourceUsage: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ProductResourceUsage.prototype.$classData = $d_Lreactbuild_project_ProductResourceUsage;
/** @constructor */
function $c_Lreactbuild_project_RenderingPageFormat$A4$() {
  /*<skip>*/
}
$c_Lreactbuild_project_RenderingPageFormat$A4$.prototype = new $h_O();
$c_Lreactbuild_project_RenderingPageFormat$A4$.prototype.constructor = $c_Lreactbuild_project_RenderingPageFormat$A4$;
/** @constructor */
function $h_Lreactbuild_project_RenderingPageFormat$A4$() {
  /*<skip>*/
}
$h_Lreactbuild_project_RenderingPageFormat$A4$.prototype = $c_Lreactbuild_project_RenderingPageFormat$A4$.prototype;
$c_Lreactbuild_project_RenderingPageFormat$A4$.prototype.productPrefix__T = (function() {
  return "A4"
});
$c_Lreactbuild_project_RenderingPageFormat$A4$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_RenderingPageFormat$A4$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_RenderingPageFormat$A4$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_RenderingPageFormat$A4$.prototype.hashCode__I = (function() {
  return 2067
});
$c_Lreactbuild_project_RenderingPageFormat$A4$.prototype.toString__T = (function() {
  return "A4"
});
var $d_Lreactbuild_project_RenderingPageFormat$A4$ = new $TypeData().initClass({
  Lreactbuild_project_RenderingPageFormat$A4$: 0
}, false, "reactbuild.project.RenderingPageFormat$A4$", {
  Lreactbuild_project_RenderingPageFormat$A4$: 1,
  O: 1,
  Lreactbuild_project_RenderingPageFormat: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_RenderingPageFormat$A4$.prototype.$classData = $d_Lreactbuild_project_RenderingPageFormat$A4$;
var $n_Lreactbuild_project_RenderingPageFormat$A4$;
function $m_Lreactbuild_project_RenderingPageFormat$A4$() {
  if ((!$n_Lreactbuild_project_RenderingPageFormat$A4$)) {
    $n_Lreactbuild_project_RenderingPageFormat$A4$ = new $c_Lreactbuild_project_RenderingPageFormat$A4$()
  };
  return $n_Lreactbuild_project_RenderingPageFormat$A4$
}
/** @constructor */
function $c_Lreactbuild_project_ResourceUsageClause$PersonFilter(selection) {
  this.Lreactbuild_project_ResourceUsageClause$PersonFilter__f_selection = null;
  this.Lreactbuild_project_ResourceUsageClause$PersonFilter__f_selection = selection
}
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype.constructor = $c_Lreactbuild_project_ResourceUsageClause$PersonFilter;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsageClause$PersonFilter() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype = $c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype;
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype.productPrefix__T = (function() {
  return "PersonFilter"
});
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_ResourceUsageClause$PersonFilter__f_selection : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_ResourceUsageClause$PersonFilter)) {
    var PersonFilter$1 = $as_Lreactbuild_project_ResourceUsageClause$PersonFilter(x$1);
    var x = this.Lreactbuild_project_ResourceUsageClause$PersonFilter__f_selection;
    var x$2 = $n(PersonFilter$1).Lreactbuild_project_ResourceUsageClause$PersonFilter__f_selection;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_ResourceUsageClause$PersonFilter(obj) {
  return (((obj instanceof $c_Lreactbuild_project_ResourceUsageClause$PersonFilter) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.ResourceUsageClause$PersonFilter"))
}
function $isArrayOf_Lreactbuild_project_ResourceUsageClause$PersonFilter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_ResourceUsageClause$PersonFilter)))
}
function $asArrayOf_Lreactbuild_project_ResourceUsageClause$PersonFilter(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_ResourceUsageClause$PersonFilter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.ResourceUsageClause$PersonFilter;", depth))
}
var $d_Lreactbuild_project_ResourceUsageClause$PersonFilter = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsageClause$PersonFilter: 0
}, false, "reactbuild.project.ResourceUsageClause$PersonFilter", {
  Lreactbuild_project_ResourceUsageClause$PersonFilter: 1,
  O: 1,
  Lreactbuild_project_ResourceUsageClause: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsageClause$PersonFilter.prototype.$classData = $d_Lreactbuild_project_ResourceUsageClause$PersonFilter;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsageClause$ProjectFilter(selection) {
  this.Lreactbuild_project_ResourceUsageClause$ProjectFilter__f_selection = null;
  this.Lreactbuild_project_ResourceUsageClause$ProjectFilter__f_selection = selection
}
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype.constructor = $c_Lreactbuild_project_ResourceUsageClause$ProjectFilter;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsageClause$ProjectFilter() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype = $c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype;
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype.productPrefix__T = (function() {
  return "ProjectFilter"
});
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_ResourceUsageClause$ProjectFilter__f_selection : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_ResourceUsageClause$ProjectFilter)) {
    var ProjectFilter$1 = $as_Lreactbuild_project_ResourceUsageClause$ProjectFilter(x$1);
    var x = this.Lreactbuild_project_ResourceUsageClause$ProjectFilter__f_selection;
    var x$2 = $n(ProjectFilter$1).Lreactbuild_project_ResourceUsageClause$ProjectFilter__f_selection;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_ResourceUsageClause$ProjectFilter(obj) {
  return (((obj instanceof $c_Lreactbuild_project_ResourceUsageClause$ProjectFilter) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.ResourceUsageClause$ProjectFilter"))
}
function $isArrayOf_Lreactbuild_project_ResourceUsageClause$ProjectFilter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_ResourceUsageClause$ProjectFilter)))
}
function $asArrayOf_Lreactbuild_project_ResourceUsageClause$ProjectFilter(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_ResourceUsageClause$ProjectFilter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.ResourceUsageClause$ProjectFilter;", depth))
}
var $d_Lreactbuild_project_ResourceUsageClause$ProjectFilter = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsageClause$ProjectFilter: 0
}, false, "reactbuild.project.ResourceUsageClause$ProjectFilter", {
  Lreactbuild_project_ResourceUsageClause$ProjectFilter: 1,
  O: 1,
  Lreactbuild_project_ResourceUsageClause: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsageClause$ProjectFilter.prototype.$classData = $d_Lreactbuild_project_ResourceUsageClause$ProjectFilter;
/** @constructor */
function $c_Lreactbuild_project_Selection$All() {
  /*<skip>*/
}
$c_Lreactbuild_project_Selection$All.prototype = new $h_O();
$c_Lreactbuild_project_Selection$All.prototype.constructor = $c_Lreactbuild_project_Selection$All;
/** @constructor */
function $h_Lreactbuild_project_Selection$All() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$All.prototype = $c_Lreactbuild_project_Selection$All.prototype;
$c_Lreactbuild_project_Selection$All.prototype.productPrefix__T = (function() {
  return "All"
});
$c_Lreactbuild_project_Selection$All.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_Selection$All.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_Selection$All.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_Selection$All.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_Selection$All.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_Selection$All.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_Selection$All)
});
function $as_Lreactbuild_project_Selection$All(obj) {
  return (((obj instanceof $c_Lreactbuild_project_Selection$All) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.Selection$All"))
}
function $isArrayOf_Lreactbuild_project_Selection$All(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_Selection$All)))
}
function $asArrayOf_Lreactbuild_project_Selection$All(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_Selection$All(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.Selection$All;", depth))
}
var $d_Lreactbuild_project_Selection$All = new $TypeData().initClass({
  Lreactbuild_project_Selection$All: 0
}, false, "reactbuild.project.Selection$All", {
  Lreactbuild_project_Selection$All: 1,
  O: 1,
  Lreactbuild_project_Selection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$All.prototype.$classData = $d_Lreactbuild_project_Selection$All;
/** @constructor */
function $c_Lreactbuild_project_Selection$List(items) {
  this.Lreactbuild_project_Selection$List__f_items = null;
  this.Lreactbuild_project_Selection$List__f_items = items
}
$c_Lreactbuild_project_Selection$List.prototype = new $h_O();
$c_Lreactbuild_project_Selection$List.prototype.constructor = $c_Lreactbuild_project_Selection$List;
/** @constructor */
function $h_Lreactbuild_project_Selection$List() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$List.prototype = $c_Lreactbuild_project_Selection$List.prototype;
$c_Lreactbuild_project_Selection$List.prototype.productPrefix__T = (function() {
  return "List"
});
$c_Lreactbuild_project_Selection$List.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_Selection$List.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_Selection$List__f_items : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_Selection$List.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_Selection$List.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_Selection$List.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_Selection$List.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_Selection$List)) {
    var List$1 = $as_Lreactbuild_project_Selection$List(x$1);
    var x = this.Lreactbuild_project_Selection$List__f_items;
    var x$2 = $n(List$1).Lreactbuild_project_Selection$List__f_items;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_Selection$List(obj) {
  return (((obj instanceof $c_Lreactbuild_project_Selection$List) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.Selection$List"))
}
function $isArrayOf_Lreactbuild_project_Selection$List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_Selection$List)))
}
function $asArrayOf_Lreactbuild_project_Selection$List(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_Selection$List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.Selection$List;", depth))
}
var $d_Lreactbuild_project_Selection$List = new $TypeData().initClass({
  Lreactbuild_project_Selection$List: 0
}, false, "reactbuild.project.Selection$List", {
  Lreactbuild_project_Selection$List: 1,
  O: 1,
  Lreactbuild_project_Selection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$List.prototype.$classData = $d_Lreactbuild_project_Selection$List;
/** @constructor */
function $c_Lreactbuild_project_Selection$None() {
  /*<skip>*/
}
$c_Lreactbuild_project_Selection$None.prototype = new $h_O();
$c_Lreactbuild_project_Selection$None.prototype.constructor = $c_Lreactbuild_project_Selection$None;
/** @constructor */
function $h_Lreactbuild_project_Selection$None() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$None.prototype = $c_Lreactbuild_project_Selection$None.prototype;
$c_Lreactbuild_project_Selection$None.prototype.productPrefix__T = (function() {
  return "None"
});
$c_Lreactbuild_project_Selection$None.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_Selection$None.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_Selection$None.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_Selection$None.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_Selection$None.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_Selection$None.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_Selection$None)
});
function $as_Lreactbuild_project_Selection$None(obj) {
  return (((obj instanceof $c_Lreactbuild_project_Selection$None) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.Selection$None"))
}
function $isArrayOf_Lreactbuild_project_Selection$None(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_Selection$None)))
}
function $asArrayOf_Lreactbuild_project_Selection$None(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_Selection$None(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.Selection$None;", depth))
}
var $d_Lreactbuild_project_Selection$None = new $TypeData().initClass({
  Lreactbuild_project_Selection$None: 0
}, false, "reactbuild.project.Selection$None", {
  Lreactbuild_project_Selection$None: 1,
  O: 1,
  Lreactbuild_project_Selection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$None.prototype.$classData = $d_Lreactbuild_project_Selection$None;
/** @constructor */
function $c_Lreactbuild_project_SiteVisit$() {
  this.Lreactbuild_project_SiteVisit$__f_title = null;
  this.Lreactbuild_project_SiteVisit$__f_title = "Visite d'un logement en vu d'une acquisition"
}
$c_Lreactbuild_project_SiteVisit$.prototype = new $h_O();
$c_Lreactbuild_project_SiteVisit$.prototype.constructor = $c_Lreactbuild_project_SiteVisit$;
/** @constructor */
function $h_Lreactbuild_project_SiteVisit$() {
  /*<skip>*/
}
$h_Lreactbuild_project_SiteVisit$.prototype = $c_Lreactbuild_project_SiteVisit$.prototype;
$c_Lreactbuild_project_SiteVisit$.prototype.title__T = (function() {
  return this.Lreactbuild_project_SiteVisit$__f_title
});
$c_Lreactbuild_project_SiteVisit$.prototype.productPrefix__T = (function() {
  return "SiteVisit"
});
$c_Lreactbuild_project_SiteVisit$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_SiteVisit$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_SiteVisit$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_SiteVisit$.prototype.hashCode__I = (function() {
  return 1462047268
});
$c_Lreactbuild_project_SiteVisit$.prototype.toString__T = (function() {
  return "SiteVisit"
});
var $d_Lreactbuild_project_SiteVisit$ = new $TypeData().initClass({
  Lreactbuild_project_SiteVisit$: 0
}, false, "reactbuild.project.SiteVisit$", {
  Lreactbuild_project_SiteVisit$: 1,
  O: 1,
  Lreactbuild_project_Activity: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_SiteVisit$.prototype.$classData = $d_Lreactbuild_project_SiteVisit$;
var $n_Lreactbuild_project_SiteVisit$;
function $m_Lreactbuild_project_SiteVisit$() {
  if ((!$n_Lreactbuild_project_SiteVisit$)) {
    $n_Lreactbuild_project_SiteVisit$ = new $c_Lreactbuild_project_SiteVisit$()
  };
  return $n_Lreactbuild_project_SiteVisit$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Alignment$End$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Alignment$End$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Alignment$End$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Alignment$End$.prototype = $c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype;
$c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype.productPrefix__T = (function() {
  return "End"
});
$c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype.hashCode__I = (function() {
  return 69819
});
$c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype.toString__T = (function() {
  return "End"
});
var $d_Lreactbuild_project_drawing_Area$Alignment$End$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Alignment$End$: 0
}, false, "reactbuild.project.drawing.Area$Alignment$End$", {
  Lreactbuild_project_drawing_Area$Alignment$End$: 1,
  O: 1,
  Lreactbuild_project_drawing_Area$Alignment: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Area$Alignment$End$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Alignment$End$;
var $n_Lreactbuild_project_drawing_Area$Alignment$End$;
function $m_Lreactbuild_project_drawing_Area$Alignment$End$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Alignment$End$)) {
    $n_Lreactbuild_project_drawing_Area$Alignment$End$ = new $c_Lreactbuild_project_drawing_Area$Alignment$End$()
  };
  return $n_Lreactbuild_project_drawing_Area$Alignment$End$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Alignment$Middle$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Alignment$Middle$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Alignment$Middle$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype = $c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype;
$c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype.productPrefix__T = (function() {
  return "Middle"
});
$c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype.hashCode__I = (function() {
  return (-1990474315)
});
$c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype.toString__T = (function() {
  return "Middle"
});
var $d_Lreactbuild_project_drawing_Area$Alignment$Middle$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Alignment$Middle$: 0
}, false, "reactbuild.project.drawing.Area$Alignment$Middle$", {
  Lreactbuild_project_drawing_Area$Alignment$Middle$: 1,
  O: 1,
  Lreactbuild_project_drawing_Area$Alignment: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Area$Alignment$Middle$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Alignment$Middle$;
var $n_Lreactbuild_project_drawing_Area$Alignment$Middle$;
function $m_Lreactbuild_project_drawing_Area$Alignment$Middle$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Alignment$Middle$)) {
    $n_Lreactbuild_project_drawing_Area$Alignment$Middle$ = new $c_Lreactbuild_project_drawing_Area$Alignment$Middle$()
  };
  return $n_Lreactbuild_project_drawing_Area$Alignment$Middle$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Alignment$Start$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Alignment$Start$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Alignment$Start$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype = $c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype;
$c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype.productPrefix__T = (function() {
  return "Start"
});
$c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype.hashCode__I = (function() {
  return 80204866
});
$c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype.toString__T = (function() {
  return "Start"
});
var $d_Lreactbuild_project_drawing_Area$Alignment$Start$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Alignment$Start$: 0
}, false, "reactbuild.project.drawing.Area$Alignment$Start$", {
  Lreactbuild_project_drawing_Area$Alignment$Start$: 1,
  O: 1,
  Lreactbuild_project_drawing_Area$Alignment: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Area$Alignment$Start$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Alignment$Start$;
var $n_Lreactbuild_project_drawing_Area$Alignment$Start$;
function $m_Lreactbuild_project_drawing_Area$Alignment$Start$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Alignment$Start$)) {
    $n_Lreactbuild_project_drawing_Area$Alignment$Start$ = new $c_Lreactbuild_project_drawing_Area$Alignment$Start$()
  };
  return $n_Lreactbuild_project_drawing_Area$Alignment$Start$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Axis$Horizontal$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Axis$Horizontal$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Axis$Horizontal$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype = $c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype;
$c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype.productPrefix__T = (function() {
  return "Horizontal"
});
$c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype.hashCode__I = (function() {
  return (-913872828)
});
$c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype.toString__T = (function() {
  return "Horizontal"
});
var $d_Lreactbuild_project_drawing_Area$Axis$Horizontal$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Axis$Horizontal$: 0
}, false, "reactbuild.project.drawing.Area$Axis$Horizontal$", {
  Lreactbuild_project_drawing_Area$Axis$Horizontal$: 1,
  O: 1,
  Lreactbuild_project_drawing_Area$Axis: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Area$Axis$Horizontal$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Axis$Horizontal$;
var $n_Lreactbuild_project_drawing_Area$Axis$Horizontal$;
function $m_Lreactbuild_project_drawing_Area$Axis$Horizontal$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Axis$Horizontal$)) {
    $n_Lreactbuild_project_drawing_Area$Axis$Horizontal$ = new $c_Lreactbuild_project_drawing_Area$Axis$Horizontal$()
  };
  return $n_Lreactbuild_project_drawing_Area$Axis$Horizontal$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Axis$Vertical$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Axis$Vertical$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Axis$Vertical$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype = $c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype;
$c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype.productPrefix__T = (function() {
  return "Vertical"
});
$c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype.hashCode__I = (function() {
  return (-1919497322)
});
$c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype.toString__T = (function() {
  return "Vertical"
});
var $d_Lreactbuild_project_drawing_Area$Axis$Vertical$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Axis$Vertical$: 0
}, false, "reactbuild.project.drawing.Area$Axis$Vertical$", {
  Lreactbuild_project_drawing_Area$Axis$Vertical$: 1,
  O: 1,
  Lreactbuild_project_drawing_Area$Axis: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Area$Axis$Vertical$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Axis$Vertical$;
var $n_Lreactbuild_project_drawing_Area$Axis$Vertical$;
function $m_Lreactbuild_project_drawing_Area$Axis$Vertical$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Axis$Vertical$)) {
    $n_Lreactbuild_project_drawing_Area$Axis$Vertical$ = new $c_Lreactbuild_project_drawing_Area$Axis$Vertical$()
  };
  return $n_Lreactbuild_project_drawing_Area$Axis$Vertical$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Position$End$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Area$Position$End$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Position$End$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Position$End$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Position$End$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Position$End$.prototype = $c_Lreactbuild_project_drawing_Area$Position$End$.prototype;
$c_Lreactbuild_project_drawing_Area$Position$End$.prototype.productPrefix__T = (function() {
  return "End"
});
$c_Lreactbuild_project_drawing_Area$Position$End$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Area$Position$End$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Area$Position$End$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Area$Position$End$.prototype.hashCode__I = (function() {
  return 69819
});
$c_Lreactbuild_project_drawing_Area$Position$End$.prototype.toString__T = (function() {
  return "End"
});
var $d_Lreactbuild_project_drawing_Area$Position$End$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Position$End$: 0
}, false, "reactbuild.project.drawing.Area$Position$End$", {
  Lreactbuild_project_drawing_Area$Position$End$: 1,
  O: 1,
  Lreactbuild_project_drawing_Area$Position: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Area$Position$End$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Position$End$;
var $n_Lreactbuild_project_drawing_Area$Position$End$;
function $m_Lreactbuild_project_drawing_Area$Position$End$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Position$End$)) {
    $n_Lreactbuild_project_drawing_Area$Position$End$ = new $c_Lreactbuild_project_drawing_Area$Position$End$()
  };
  return $n_Lreactbuild_project_drawing_Area$Position$End$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Area$Position$Start$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Area$Position$Start$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Area$Position$Start$.prototype.constructor = $c_Lreactbuild_project_drawing_Area$Position$Start$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Area$Position$Start$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Area$Position$Start$.prototype = $c_Lreactbuild_project_drawing_Area$Position$Start$.prototype;
$c_Lreactbuild_project_drawing_Area$Position$Start$.prototype.productPrefix__T = (function() {
  return "Start"
});
$c_Lreactbuild_project_drawing_Area$Position$Start$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Area$Position$Start$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Area$Position$Start$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Area$Position$Start$.prototype.hashCode__I = (function() {
  return 80204866
});
$c_Lreactbuild_project_drawing_Area$Position$Start$.prototype.toString__T = (function() {
  return "Start"
});
var $d_Lreactbuild_project_drawing_Area$Position$Start$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Area$Position$Start$: 0
}, false, "reactbuild.project.drawing.Area$Position$Start$", {
  Lreactbuild_project_drawing_Area$Position$Start$: 1,
  O: 1,
  Lreactbuild_project_drawing_Area$Position: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Area$Position$Start$.prototype.$classData = $d_Lreactbuild_project_drawing_Area$Position$Start$;
var $n_Lreactbuild_project_drawing_Area$Position$Start$;
function $m_Lreactbuild_project_drawing_Area$Position$Start$() {
  if ((!$n_Lreactbuild_project_drawing_Area$Position$Start$)) {
    $n_Lreactbuild_project_drawing_Area$Position$Start$ = new $c_Lreactbuild_project_drawing_Area$Position$Start$()
  };
  return $n_Lreactbuild_project_drawing_Area$Position$Start$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingContext$$anon$1() {
  this.Lreactbuild_project_drawing_DrawingContext$$anon$1__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this)
}
$c_Lreactbuild_project_drawing_DrawingContext$$anon$1.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingContext$$anon$1.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingContext$$anon$1;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingContext$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingContext$$anon$1.prototype = $c_Lreactbuild_project_drawing_DrawingContext$$anon$1.prototype;
$c_Lreactbuild_project_drawing_DrawingContext$$anon$1.prototype.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_drawing_DrawingContext$$anon$1.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners__sci_List = (function() {
  return this.Lreactbuild_project_drawing_DrawingContext$$anon$1__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners
});
$c_Lreactbuild_project_drawing_DrawingContext$$anon$1.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_drawing_DrawingContext$$anon$1__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = x$1
});
var $d_Lreactbuild_project_drawing_DrawingContext$$anon$1 = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingContext$$anon$1: 0
}, false, "reactbuild.project.drawing.DrawingContext$$anon$1", {
  Lreactbuild_project_drawing_DrawingContext$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_Broadcaster: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1,
  Ljapgolly_scalajs_react_extra_Listenable: 1
});
$c_Lreactbuild_project_drawing_DrawingContext$$anon$1.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingContext$$anon$1;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1(outer, context$1) {
  this.Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1__f_context$1 = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1__f_context$1 = context$1
}
$c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1.prototype = $c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1.prototype;
$c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1.prototype.applyOrElse__Lreactbuild_project_drawing_Tool__F1__O = (function(x1, default$1) {
  if ($is_Lreactbuild_project_drawing_ViewportTool(x1)) {
    var x2 = $as_Lreactbuild_project_drawing_ViewportTool(x1);
    return $n(x2).renderInViewport__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode(this.Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1__f_context$1)
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1.prototype.isDefinedAt__Lreactbuild_project_drawing_Tool__Z = (function(x1) {
  return $is_Lreactbuild_project_drawing_ViewportTool(x1)
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_project_drawing_Tool__Z($as_Lreactbuild_project_drawing_Tool(x))
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_project_drawing_Tool__F1__O($as_Lreactbuild_project_drawing_Tool(x), default$1)
});
var $d_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1 = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1: 0
}, false, "reactbuild.project.drawing.DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1", {
  Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingContextImpl(building, lightArea, accessibleArea, tool, theme, layers, debug, scale, realPosition, ids, backend) {
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_building = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_lightArea = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_tool = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_theme = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_layers = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_debug = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale = 0.0;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_ids = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_backend = null;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_building = building;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_lightArea = lightArea;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea = accessibleArea;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_tool = tool;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_theme = theme;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_layers = layers;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_debug = debug;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale = scale;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition = realPosition;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_ids = ids;
  this.Lreactbuild_project_drawing_DrawingContextImpl__f_backend = backend
}
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingContextImpl;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingContextImpl() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingContextImpl.prototype = $c_Lreactbuild_project_drawing_DrawingContextImpl.prototype;
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.apply__D__T = (function(v) {
  return ("" + (v * this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale))
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.apply__D__D__T = (function(x, y) {
  return (((x * this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale) + " ") + ((-y) * this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale))
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.atScale__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Vector2 = (function(v) {
  return new $c_Lreactbuild_geom_Vector2(($n(v).x__D() * this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale), ((-$n(v).y__D()) * this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale))
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.debounce__F3 = (function() {
  return new $c_sjsr_AnonFunction3(((key$2, cb$2, ms$2) => {
    var key = $as_T(key$2);
    var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var ms = $uD(ms$2);
    var this$2 = $n(this.Lreactbuild_project_drawing_DrawingContextImpl__f_backend);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Lcom_iz2use_react_components_DebounceSupport__debounceSet__T__Ljapgolly_scalajs_react_callback_Trampoline__D__Ljapgolly_scalajs_react_callback_Trampoline(this$2, key, cb, ms))
  }))
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.productPrefix__T = (function() {
  return "DrawingContextImpl"
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.productArity__I = (function() {
  return 11
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_building;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_lightArea;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea;
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_tool;
      break
    }
    case 4: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_theme;
      break
    }
    case 5: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_layers;
      break
    }
    case 6: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_debug;
      break
    }
    case 7: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale;
      break
    }
    case 8: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition;
      break
    }
    case 9: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_ids;
      break
    }
    case 10: {
      return this.Lreactbuild_project_drawing_DrawingContextImpl__f_backend;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DrawingContextImpl");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_drawing_DrawingContextImpl__f_building;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_lightArea;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_tool;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_theme;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$5 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_layers;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$6 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_debug;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var dv = this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale;
  var data$8 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$7 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$8 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_ids;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$8);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var x$9 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_backend;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$9);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$12, 11)
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_DrawingContextImpl)) {
    var DrawingContextImpl$1 = $as_Lreactbuild_project_drawing_DrawingContextImpl(x$1);
    if ((this.Lreactbuild_project_drawing_DrawingContextImpl__f_scale === $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_scale)) {
      var x = this.Lreactbuild_project_drawing_DrawingContextImpl__f_building;
      var x$2 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_building;
      if ((x === null)) {
        var $$x3 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x3 = (this$1 === x$2)
      };
      if ($$x3) {
        var x$3 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_lightArea;
        var x$4 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_lightArea;
        if ((x$3 === null)) {
          var $$x2 = (x$4 === null)
        } else {
          var this$2 = $n(x$3);
          var $$x2 = (this$2 === x$4)
        }
      } else {
        var $$x2 = false
      }
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea;
      var x$6 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea;
      if ((x$5 === null)) {
        var $$x4 = (x$6 === null)
      } else {
        var this$3 = $n(x$5);
        var $$x4 = (this$3 === x$6)
      };
      if ($$x4) {
        var x$7 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_tool;
        var x$8 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_tool;
        if ((x$7 === null)) {
          var $$x5 = (x$8 === null)
        } else {
          var this$4 = $n(x$7);
          var $$x5 = (this$4 === x$8)
        };
        if ($$x5) {
          var x$9 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_theme;
          var x$10 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_theme;
          if ((x$9 === null)) {
            var $$x1 = (x$10 === null)
          } else {
            var this$5 = $n(x$9);
            var $$x1 = (this$5 === x$10)
          }
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_layers;
      var x$12 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_layers;
      if ((x$11 === null)) {
        var $$x7 = (x$12 === null)
      } else {
        var this$6 = $n(x$11);
        var $$x7 = (this$6 === x$12)
      };
      if ($$x7) {
        var x$13 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_debug;
        var x$14 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_debug;
        if ((x$13 === null)) {
          var $$x8 = (x$14 === null)
        } else {
          var this$7 = $n(x$13);
          var $$x8 = (this$7 === x$14)
        };
        if ($$x8) {
          var x$15 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition;
          var x$16 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition;
          var $$x6 = ((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16))
        } else {
          var $$x6 = false
        }
      } else {
        var $$x6 = false
      };
      if ($$x6) {
        var x$17 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_ids;
        var x$18 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_ids;
        if (((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18))) {
          var x$19 = this.Lreactbuild_project_drawing_DrawingContextImpl__f_backend;
          var x$20 = $n(DrawingContextImpl$1).Lreactbuild_project_drawing_DrawingContextImpl__f_backend;
          if ((x$19 === null)) {
            var $$x9 = (x$20 === null)
          } else {
            var this$8 = $n(x$19);
            var $$x9 = (this$8 === x$20)
          };
          if ($$x9) {
            $n(DrawingContextImpl$1);
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_DrawingContextImpl(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawingContextImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawingContextImpl"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawingContextImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawingContextImpl)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawingContextImpl(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawingContextImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawingContextImpl;", depth))
}
var $d_Lreactbuild_project_drawing_DrawingContextImpl = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingContextImpl: 0
}, false, "reactbuild.project.drawing.DrawingContextImpl", {
  Lreactbuild_project_drawing_DrawingContextImpl: 1,
  O: 1,
  Lreactbuild_project_drawing_DrawingContext: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_DrawingContextImpl.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingContextImpl;
/** @constructor */
function $c_Lreactbuild_project_drawing_Furniture$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Furniture$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Furniture$.prototype.constructor = $c_Lreactbuild_project_drawing_Furniture$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Furniture$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Furniture$.prototype = $c_Lreactbuild_project_drawing_Furniture$.prototype;
$c_Lreactbuild_project_drawing_Furniture$.prototype.productPrefix__T = (function() {
  return "Furniture"
});
$c_Lreactbuild_project_drawing_Furniture$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Furniture$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Furniture$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Furniture$.prototype.hashCode__I = (function() {
  return 1423538130
});
$c_Lreactbuild_project_drawing_Furniture$.prototype.toString__T = (function() {
  return "Furniture"
});
var $d_Lreactbuild_project_drawing_Furniture$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Furniture$: 0
}, false, "reactbuild.project.drawing.Furniture$", {
  Lreactbuild_project_drawing_Furniture$: 1,
  O: 1,
  Lreactbuild_project_drawing_BuildingPart: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Furniture$.prototype.$classData = $d_Lreactbuild_project_drawing_Furniture$;
var $n_Lreactbuild_project_drawing_Furniture$;
function $m_Lreactbuild_project_drawing_Furniture$() {
  if ((!$n_Lreactbuild_project_drawing_Furniture$)) {
    $n_Lreactbuild_project_drawing_Furniture$ = new $c_Lreactbuild_project_drawing_Furniture$()
  };
  return $n_Lreactbuild_project_drawing_Furniture$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_InternalDistributionNetwork$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype.constructor = $c_Lreactbuild_project_drawing_InternalDistributionNetwork$;
/** @constructor */
function $h_Lreactbuild_project_drawing_InternalDistributionNetwork$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype = $c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype;
$c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype.productPrefix__T = (function() {
  return "InternalDistributionNetwork"
});
$c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype.hashCode__I = (function() {
  return 1620341997
});
$c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype.toString__T = (function() {
  return "InternalDistributionNetwork"
});
var $d_Lreactbuild_project_drawing_InternalDistributionNetwork$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_InternalDistributionNetwork$: 0
}, false, "reactbuild.project.drawing.InternalDistributionNetwork$", {
  Lreactbuild_project_drawing_InternalDistributionNetwork$: 1,
  O: 1,
  Lreactbuild_project_drawing_BuildingPart: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_InternalDistributionNetwork$.prototype.$classData = $d_Lreactbuild_project_drawing_InternalDistributionNetwork$;
var $n_Lreactbuild_project_drawing_InternalDistributionNetwork$;
function $m_Lreactbuild_project_drawing_InternalDistributionNetwork$() {
  if ((!$n_Lreactbuild_project_drawing_InternalDistributionNetwork$)) {
    $n_Lreactbuild_project_drawing_InternalDistributionNetwork$ = new $c_Lreactbuild_project_drawing_InternalDistributionNetwork$()
  };
  return $n_Lreactbuild_project_drawing_InternalDistributionNetwork$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_Joinery$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Joinery$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Joinery$.prototype.constructor = $c_Lreactbuild_project_drawing_Joinery$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Joinery$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Joinery$.prototype = $c_Lreactbuild_project_drawing_Joinery$.prototype;
$c_Lreactbuild_project_drawing_Joinery$.prototype.productPrefix__T = (function() {
  return "Joinery"
});
$c_Lreactbuild_project_drawing_Joinery$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Joinery$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Joinery$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Joinery$.prototype.hashCode__I = (function() {
  return 233978850
});
$c_Lreactbuild_project_drawing_Joinery$.prototype.toString__T = (function() {
  return "Joinery"
});
var $d_Lreactbuild_project_drawing_Joinery$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Joinery$: 0
}, false, "reactbuild.project.drawing.Joinery$", {
  Lreactbuild_project_drawing_Joinery$: 1,
  O: 1,
  Lreactbuild_project_drawing_BuildingPart: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Joinery$.prototype.$classData = $d_Lreactbuild_project_drawing_Joinery$;
var $n_Lreactbuild_project_drawing_Joinery$;
function $m_Lreactbuild_project_drawing_Joinery$() {
  if ((!$n_Lreactbuild_project_drawing_Joinery$)) {
    $n_Lreactbuild_project_drawing_Joinery$ = new $c_Lreactbuild_project_drawing_Joinery$()
  };
  return $n_Lreactbuild_project_drawing_Joinery$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_KitchenFurniture$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_KitchenFurniture$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_KitchenFurniture$.prototype.constructor = $c_Lreactbuild_project_drawing_KitchenFurniture$;
/** @constructor */
function $h_Lreactbuild_project_drawing_KitchenFurniture$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_KitchenFurniture$.prototype = $c_Lreactbuild_project_drawing_KitchenFurniture$.prototype;
$c_Lreactbuild_project_drawing_KitchenFurniture$.prototype.productPrefix__T = (function() {
  return "KitchenFurniture"
});
$c_Lreactbuild_project_drawing_KitchenFurniture$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_KitchenFurniture$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_KitchenFurniture$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_KitchenFurniture$.prototype.hashCode__I = (function() {
  return (-1330430770)
});
$c_Lreactbuild_project_drawing_KitchenFurniture$.prototype.toString__T = (function() {
  return "KitchenFurniture"
});
var $d_Lreactbuild_project_drawing_KitchenFurniture$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_KitchenFurniture$: 0
}, false, "reactbuild.project.drawing.KitchenFurniture$", {
  Lreactbuild_project_drawing_KitchenFurniture$: 1,
  O: 1,
  Lreactbuild_project_drawing_BuildingPart: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_KitchenFurniture$.prototype.$classData = $d_Lreactbuild_project_drawing_KitchenFurniture$;
var $n_Lreactbuild_project_drawing_KitchenFurniture$;
function $m_Lreactbuild_project_drawing_KitchenFurniture$() {
  if ((!$n_Lreactbuild_project_drawing_KitchenFurniture$)) {
    $n_Lreactbuild_project_drawing_KitchenFurniture$ = new $c_Lreactbuild_project_drawing_KitchenFurniture$()
  };
  return $n_Lreactbuild_project_drawing_KitchenFurniture$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_LOD100$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_LOD100$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_LOD100$.prototype.constructor = $c_Lreactbuild_project_drawing_LOD100$;
/** @constructor */
function $h_Lreactbuild_project_drawing_LOD100$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_LOD100$.prototype = $c_Lreactbuild_project_drawing_LOD100$.prototype;
$c_Lreactbuild_project_drawing_LOD100$.prototype.productPrefix__T = (function() {
  return "LOD100"
});
$c_Lreactbuild_project_drawing_LOD100$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_LOD100$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_LOD100$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_LOD100$.prototype.hashCode__I = (function() {
  return (-2044119248)
});
$c_Lreactbuild_project_drawing_LOD100$.prototype.toString__T = (function() {
  return "LOD100"
});
var $d_Lreactbuild_project_drawing_LOD100$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_LOD100$: 0
}, false, "reactbuild.project.drawing.LOD100$", {
  Lreactbuild_project_drawing_LOD100$: 1,
  O: 1,
  Lreactbuild_project_drawing_LOD: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_LOD100$.prototype.$classData = $d_Lreactbuild_project_drawing_LOD100$;
var $n_Lreactbuild_project_drawing_LOD100$;
function $m_Lreactbuild_project_drawing_LOD100$() {
  if ((!$n_Lreactbuild_project_drawing_LOD100$)) {
    $n_Lreactbuild_project_drawing_LOD100$ = new $c_Lreactbuild_project_drawing_LOD100$()
  };
  return $n_Lreactbuild_project_drawing_LOD100$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_LOD500$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_LOD500$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_LOD500$.prototype.constructor = $c_Lreactbuild_project_drawing_LOD500$;
/** @constructor */
function $h_Lreactbuild_project_drawing_LOD500$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_LOD500$.prototype = $c_Lreactbuild_project_drawing_LOD500$.prototype;
$c_Lreactbuild_project_drawing_LOD500$.prototype.productPrefix__T = (function() {
  return "LOD500"
});
$c_Lreactbuild_project_drawing_LOD500$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_LOD500$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_LOD500$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_LOD500$.prototype.hashCode__I = (function() {
  return (-2044115404)
});
$c_Lreactbuild_project_drawing_LOD500$.prototype.toString__T = (function() {
  return "LOD500"
});
var $d_Lreactbuild_project_drawing_LOD500$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_LOD500$: 0
}, false, "reactbuild.project.drawing.LOD500$", {
  Lreactbuild_project_drawing_LOD500$: 1,
  O: 1,
  Lreactbuild_project_drawing_LOD: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_LOD500$.prototype.$classData = $d_Lreactbuild_project_drawing_LOD500$;
var $n_Lreactbuild_project_drawing_LOD500$;
function $m_Lreactbuild_project_drawing_LOD500$() {
  if ((!$n_Lreactbuild_project_drawing_LOD500$)) {
    $n_Lreactbuild_project_drawing_LOD500$ = new $c_Lreactbuild_project_drawing_LOD500$()
  };
  return $n_Lreactbuild_project_drawing_LOD500$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_RemoteCursor(id, user, x, y, last) {
  this.Lreactbuild_project_drawing_RemoteCursor__f_id = null;
  this.Lreactbuild_project_drawing_RemoteCursor__f_user = null;
  this.Lreactbuild_project_drawing_RemoteCursor__f_x = 0.0;
  this.Lreactbuild_project_drawing_RemoteCursor__f_y = 0.0;
  this.Lreactbuild_project_drawing_RemoteCursor__f_last = null;
  this.Lreactbuild_project_drawing_RemoteCursor__f_id = id;
  this.Lreactbuild_project_drawing_RemoteCursor__f_user = user;
  this.Lreactbuild_project_drawing_RemoteCursor__f_x = x;
  this.Lreactbuild_project_drawing_RemoteCursor__f_y = y;
  this.Lreactbuild_project_drawing_RemoteCursor__f_last = last
}
$c_Lreactbuild_project_drawing_RemoteCursor.prototype = new $h_O();
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.constructor = $c_Lreactbuild_project_drawing_RemoteCursor;
/** @constructor */
function $h_Lreactbuild_project_drawing_RemoteCursor() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_RemoteCursor.prototype = $c_Lreactbuild_project_drawing_RemoteCursor.prototype;
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.x__D = (function() {
  return this.Lreactbuild_project_drawing_RemoteCursor__f_x
});
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.y__D = (function() {
  return this.Lreactbuild_project_drawing_RemoteCursor__f_y
});
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.productPrefix__T = (function() {
  return "RemoteCursor"
});
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.productArity__I = (function() {
  return 5
});
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_RemoteCursor__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_RemoteCursor__f_user;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_RemoteCursor__f_x;
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_RemoteCursor__f_y;
      break
    }
    case 4: {
      return this.Lreactbuild_project_drawing_RemoteCursor__f_last;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("RemoteCursor");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_drawing_RemoteCursor__f_id;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_drawing_RemoteCursor__f_user;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv = this.Lreactbuild_project_drawing_RemoteCursor__f_x;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$1 = this.Lreactbuild_project_drawing_RemoteCursor__f_y;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$2 = this.Lreactbuild_project_drawing_RemoteCursor__f_last;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_RemoteCursor)) {
    var RemoteCursor$1 = $as_Lreactbuild_project_drawing_RemoteCursor(x$1);
    if (((this.Lreactbuild_project_drawing_RemoteCursor__f_x === $n(RemoteCursor$1).Lreactbuild_project_drawing_RemoteCursor__f_x) && (this.Lreactbuild_project_drawing_RemoteCursor__f_y === $n(RemoteCursor$1).Lreactbuild_project_drawing_RemoteCursor__f_y))) {
      var x = this.Lreactbuild_project_drawing_RemoteCursor__f_id;
      var x$2 = $n(RemoteCursor$1).Lreactbuild_project_drawing_RemoteCursor__f_id;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_project_drawing_RemoteCursor__f_user;
        var x$4 = $n(RemoteCursor$1).Lreactbuild_project_drawing_RemoteCursor__f_user;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_project_drawing_RemoteCursor__f_last;
          var x$6 = $n(RemoteCursor$1).Lreactbuild_project_drawing_RemoteCursor__f_last;
          return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_RemoteCursor(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_RemoteCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.RemoteCursor"))
}
function $isArrayOf_Lreactbuild_project_drawing_RemoteCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_RemoteCursor)))
}
function $asArrayOf_Lreactbuild_project_drawing_RemoteCursor(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_RemoteCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.RemoteCursor;", depth))
}
var $d_Lreactbuild_project_drawing_RemoteCursor = new $TypeData().initClass({
  Lreactbuild_project_drawing_RemoteCursor: 0
}, false, "reactbuild.project.drawing.RemoteCursor", {
  Lreactbuild_project_drawing_RemoteCursor: 1,
  O: 1,
  Lreactbuild_geom_Vector2Based: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_RemoteCursor.prototype.$classData = $d_Lreactbuild_project_drawing_RemoteCursor;
/** @constructor */
function $c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1(outer) {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1.prototype.constructor = $c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1;
/** @constructor */
function $h_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1.prototype = $c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1.prototype;
$c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1.prototype.applyOrElse__Lreactbuild_project_drawing_Tool__F1__O = (function(x1, default$1) {
  if ($is_Lreactbuild_project_drawing_UITool(x1)) {
    var x2 = $as_Lreactbuild_project_drawing_UITool(x1);
    return x2
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1.prototype.isDefinedAt__Lreactbuild_project_drawing_Tool__Z = (function(x1) {
  return $is_Lreactbuild_project_drawing_UITool(x1)
});
$c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_project_drawing_Tool__Z($as_Lreactbuild_project_drawing_Tool(x))
});
$c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_project_drawing_Tool__F1__O($as_Lreactbuild_project_drawing_Tool(x), default$1)
});
var $d_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1 = new $TypeData().initClass({
  Lreactbuild_project_drawing_View$Backend$$anonfun$render$1: 0
}, false, "reactbuild.project.drawing.View$Backend$$anonfun$render$1", {
  Lreactbuild_project_drawing_View$Backend$$anonfun$render$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1.prototype.$classData = $d_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1;
/** @constructor */
function $c_Lreactbuild_project_drawing_Wall$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_Wall$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_Wall$.prototype.constructor = $c_Lreactbuild_project_drawing_Wall$;
/** @constructor */
function $h_Lreactbuild_project_drawing_Wall$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_Wall$.prototype = $c_Lreactbuild_project_drawing_Wall$.prototype;
$c_Lreactbuild_project_drawing_Wall$.prototype.productPrefix__T = (function() {
  return "Wall"
});
$c_Lreactbuild_project_drawing_Wall$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_Wall$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_Wall$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_Wall$.prototype.hashCode__I = (function() {
  return 2688490
});
$c_Lreactbuild_project_drawing_Wall$.prototype.toString__T = (function() {
  return "Wall"
});
var $d_Lreactbuild_project_drawing_Wall$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_Wall$: 0
}, false, "reactbuild.project.drawing.Wall$", {
  Lreactbuild_project_drawing_Wall$: 1,
  O: 1,
  Lreactbuild_project_drawing_BuildingPart: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_Wall$.prototype.$classData = $d_Lreactbuild_project_drawing_Wall$;
var $n_Lreactbuild_project_drawing_Wall$;
function $m_Lreactbuild_project_drawing_Wall$() {
  if ((!$n_Lreactbuild_project_drawing_Wall$)) {
    $n_Lreactbuild_project_drawing_Wall$ = new $c_Lreactbuild_project_drawing_Wall$()
  };
  return $n_Lreactbuild_project_drawing_Wall$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_ActiveTool$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_ActiveTool$;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_ActiveTool$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype = $c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype;
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  var this$1 = $n($as_s_Option($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_tool).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value));
  var pf = new $c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1();
  if ((!this$1.isEmpty__Z())) {
    var this$2 = new $c_s_PartialFunction$Lifted(pf);
    var v1 = this$1.get__O();
    var $$x1 = this$2.apply__O__s_Option(v1)
  } else {
    var $$x1 = $m_s_None$()
  };
  var this$3 = $n($$x1);
  if (this$3.isEmpty__Z()) {
    var $$x2 = $m_Lreactbuild_common_components_Skip$()
  } else {
    var arg1 = this$3.get__O();
    var tool = $as_Lreactbuild_project_drawing_ViewportTool(arg1);
    matchEnd10: {
      var $$x2;
      if ((ev instanceof $c_Lreactbuild_common_components_Input$KeyboardEvent)) {
        var x2 = $as_Lreactbuild_common_components_Input$KeyboardEvent(ev);
        var p3 = $n(x2).Lreactbuild_common_components_Input$KeyboardEvent__f_status;
        var p4 = $n(x2).Lreactbuild_common_components_Input$KeyboardEvent__f_keyCode;
        var p5 = $n(x2).Lreactbuild_common_components_Input$KeyboardEvent__f_modifiers;
        var x = $m_Lreactbuild_common_components_Input$End$();
        if ((x === p3)) {
          if ((p4 === 27)) {
            var x$3 = $m_Lreactbuild_common_components_Input$ModifierKey$None$();
            var $$x3 = (x$3 === p5)
          } else {
            var $$x3 = false
          }
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          var $$x4 = $m_Lreactbuild_project_drawing_interaction_ActiveTool$();
          var this$4 = $n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_tool);
          var callback = new $c_sjsr_AnonFunction0((() => {
            var this$5 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
            var this$6 = $n(this$5.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
            return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$6.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
          }));
          var this$7 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
          var G = this$7.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
          var arg1$1 = this$4.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
          $as_s_Option(arg1$1);
          var arg1$2 = $m_s_None$();
          var $$x2 = new $c_Lreactbuild_common_components_Continue($$x4, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$4.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(arg1$2), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
          break matchEnd10
        }
      };
      var $$x2 = $n($n(tool).handleViewportEvent__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult(ev, trackedPointers, context)).transformValueToCB__F0__F1__Lreactbuild_common_components_InteractionResult(new $c_sjsr_AnonFunction0((() => $m_Lreactbuild_project_drawing_interaction_ActiveTool$())), new $c_sjsr_AnonFunction1(((tool$2$2) => {
        var tool$2 = $as_s_Option(tool$2$2);
        return new $c_sjsr_AnonFunction1(((cb$2) => {
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(cb$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var this$9 = $n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_tool);
          var callback$1 = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(cb)));
          var G$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
          var arg1$3 = this$9.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
          $as_s_Option(arg1$3);
          return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$9.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(tool$2), callback$1, G$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        }))
      })))
    }
  };
  return $as_Lreactbuild_common_components_InteractionResult($$x2)
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.productPrefix__T = (function() {
  return "ActiveTool"
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.hashCode__I = (function() {
  return (-257538594)
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.toString__T = (function() {
  return "ActiveTool"
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return this.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult(ev, trackedPointers, $as_Lreactbuild_project_drawing_DrawingContext(context))
});
var $d_Lreactbuild_project_drawing_interaction_ActiveTool$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_ActiveTool$: 0
}, false, "reactbuild.project.drawing.interaction.ActiveTool$", {
  Lreactbuild_project_drawing_interaction_ActiveTool$: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_ActiveTool$;
var $n_Lreactbuild_project_drawing_interaction_ActiveTool$;
function $m_Lreactbuild_project_drawing_interaction_ActiveTool$() {
  if ((!$n_Lreactbuild_project_drawing_interaction_ActiveTool$)) {
    $n_Lreactbuild_project_drawing_interaction_ActiveTool$ = new $c_Lreactbuild_project_drawing_interaction_ActiveTool$()
  };
  return $n_Lreactbuild_project_drawing_interaction_ActiveTool$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1.prototype = $c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1.prototype;
$c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1.prototype.applyOrElse__Lreactbuild_project_drawing_Tool__F1__O = (function(x1, default$1) {
  if ($is_Lreactbuild_project_drawing_ViewportTool(x1)) {
    var x2 = $as_Lreactbuild_project_drawing_ViewportTool(x1);
    return x2
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1.prototype.isDefinedAt__Lreactbuild_project_drawing_Tool__Z = (function(x1) {
  return $is_Lreactbuild_project_drawing_ViewportTool(x1)
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_project_drawing_Tool__Z($as_Lreactbuild_project_drawing_Tool(x))
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_project_drawing_Tool__F1__O($as_Lreactbuild_project_drawing_Tool(x), default$1)
});
var $d_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1 = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1: 0
}, false, "reactbuild.project.drawing.interaction.ActiveTool$$anonfun$handle$1", {
  Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_ActiveTool$$anonfun$handle$1;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_DoubleClickZoom() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_DoubleClickZoom;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_DoubleClickZoom() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype = $c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype;
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.productPrefix__T = (function() {
  return "DoubleClickZoom"
});
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_drawing_interaction_DoubleClickZoom)
});
function $as_Lreactbuild_project_drawing_interaction_DoubleClickZoom(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_DoubleClickZoom) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.DoubleClickZoom"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_DoubleClickZoom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_DoubleClickZoom)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_DoubleClickZoom(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_DoubleClickZoom(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.DoubleClickZoom;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_DoubleClickZoom = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_DoubleClickZoom: 0
}, false, "reactbuild.project.drawing.interaction.DoubleClickZoom", {
  Lreactbuild_project_drawing_interaction_DoubleClickZoom: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_DoubleClickZoom.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_DoubleClickZoom;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_DragRotate() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_DragRotate;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_DragRotate() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_DragRotate.prototype = $c_Lreactbuild_project_drawing_interaction_DragRotate.prototype;
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.productPrefix__T = (function() {
  return "DragRotate"
});
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_drawing_interaction_DragRotate)
});
function $as_Lreactbuild_project_drawing_interaction_DragRotate(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_DragRotate) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.DragRotate"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_DragRotate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_DragRotate)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_DragRotate(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_DragRotate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.DragRotate;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_DragRotate = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_DragRotate: 0
}, false, "reactbuild.project.drawing.interaction.DragRotate", {
  Lreactbuild_project_drawing_interaction_DragRotate: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_DragRotate.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_DragRotate;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_DragZoom() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_DragZoom;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_DragZoom() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_DragZoom.prototype = $c_Lreactbuild_project_drawing_interaction_DragZoom.prototype;
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.productPrefix__T = (function() {
  return "DragZoom"
});
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_drawing_interaction_DragZoom)
});
function $as_Lreactbuild_project_drawing_interaction_DragZoom(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_DragZoom) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.DragZoom"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_DragZoom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_DragZoom)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_DragZoom(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_DragZoom(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.DragZoom;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_DragZoom = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_DragZoom: 0
}, false, "reactbuild.project.drawing.interaction.DragZoom", {
  Lreactbuild_project_drawing_interaction_DragZoom: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_DragZoom.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_DragZoom;
function $p_Lreactbuild_project_drawing_interaction_JustMoving__sendToServer$1__Lreactbuild_project_drawing_DrawingContext__F1($thiz, context$1) {
  return new $c_sjsr_AnonFunction1(((pt$2) => {
    var pt = $as_Lreactbuild_geom_Vector2Based(pt$2);
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var this$2 = $n(context$1);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x1).flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n(this$2.Lreactbuild_project_drawing_DrawingContextImpl__f_backend).Lreactbuild_project_drawing_DrawingContext$Backend__f_project, new $c_sjsr_AnonFunction1(((prj$2) => {
      var prj = $as_Lreactbuild_common_model_Project(prj$2);
      var this$3 = $n(context$1);
      var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this$3.Lreactbuild_project_drawing_DrawingContextImpl__f_backend).Lreactbuild_project_drawing_DrawingContext$Backend__f_sendToServer).apply__O__O(new $c_sjsr_AnonFunction0((() => new $c_Lreactbuild_model_UpdateCursorLocation($n(prj).Lreactbuild_common_model_Project__f__id, $n(pt).x__D(), $n(pt).y__D())))))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
        $as_jl_Void(x$1$2)
      }));
      var this$5 = $n(this$);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$5, f))
    }))))
  }))
}
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_JustMoving(lastSent) {
  this.Lreactbuild_project_drawing_interaction_JustMoving__f_lastSent = null;
  this.Lreactbuild_project_drawing_interaction_JustMoving__f_lastSent = lastSent
}
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_JustMoving;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_JustMoving() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_JustMoving.prototype = $c_Lreactbuild_project_drawing_interaction_JustMoving.prototype;
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var p3 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var coords = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_coords;
    var p5 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_isPrimary;
    var p7 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_buttons;
    var p11 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
    var x = $m_Lreactbuild_common_components_Input$Move$();
    if ((x === p3)) {
      if ((p5 === true)) {
        var x$3 = $m_s_package$().s_package$__f_Nil;
        if (((x$3 === null) ? (p7 === null) : $n(x$3).equals__O__Z(p7))) {
          var x$5 = $m_Lreactbuild_common_components_Input$ModifierKey$None$();
          var $$x1 = (x$5 === p11)
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var realCoords = $as_Lreactbuild_geom_Point2Based($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition).apply__O__O(coords));
      new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
      var $$x2 = $m_Ljava_time_Instant$();
      var this$5 = $m_RTLong$();
      var value = $uD(new Date().getTime());
      var lo = this$5.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
      var hi = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var now = $n($$x2).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
      var this$6 = $n(this.Lreactbuild_project_drawing_interaction_JustMoving__f_lastSent);
      if ((!this$6.isEmpty__Z())) {
        var arg1 = this$6.get__O();
        var prev = $as_Ljava_time_Instant(arg1);
        var this$7 = $n(now);
        var other = $n(prev).plusMillis__J__Ljava_time_Instant(new $c_RTLong(500, 0));
        var $$x3 = (this$7.compare__Ljava_time_Instant__I(other) < 0)
      } else {
        var $$x3 = false
      };
      if ((!$$x3)) {
        var lastSent = new $c_s_Some(now);
        return new $c_Lreactbuild_common_components_Done(new $c_Lreactbuild_project_drawing_interaction_JustMoving(lastSent), $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($p_Lreactbuild_project_drawing_interaction_JustMoving__sendToServer$1__Lreactbuild_project_drawing_DrawingContext__F1(this, context)).apply__O__O(realCoords))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      } else {
        return new $c_Lreactbuild_common_components_Done(this, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(context).debounce__F3()).apply__O__O__O__O("sendCursor", $n($p_Lreactbuild_project_drawing_interaction_JustMoving__sendToServer$1__Lreactbuild_project_drawing_DrawingContext__F1(this, context)).apply__O__O(realCoords), 100.0))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
      }
    }
  };
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.productPrefix__T = (function() {
  return "JustMoving"
});
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_drawing_interaction_JustMoving__f_lastSent : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_interaction_JustMoving)) {
    var JustMoving$1 = $as_Lreactbuild_project_drawing_interaction_JustMoving(x$1);
    var x = this.Lreactbuild_project_drawing_interaction_JustMoving__f_lastSent;
    var x$2 = $n(JustMoving$1).Lreactbuild_project_drawing_interaction_JustMoving__f_lastSent;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return this.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult(ev, trackedPointers, $as_Lreactbuild_project_drawing_DrawingContext(context))
});
function $as_Lreactbuild_project_drawing_interaction_JustMoving(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_JustMoving) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.JustMoving"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_JustMoving(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_JustMoving)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_JustMoving(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_JustMoving(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.JustMoving;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_JustMoving = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_JustMoving: 0
}, false, "reactbuild.project.drawing.interaction.JustMoving", {
  Lreactbuild_project_drawing_interaction_JustMoving: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_JustMoving.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_JustMoving;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_KeyboardPan() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_KeyboardPan;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_KeyboardPan() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype = $c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype;
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.productPrefix__T = (function() {
  return "KeyboardPan"
});
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_drawing_interaction_KeyboardPan)
});
function $as_Lreactbuild_project_drawing_interaction_KeyboardPan(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_KeyboardPan) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.KeyboardPan"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_KeyboardPan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_KeyboardPan)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_KeyboardPan(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_KeyboardPan(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.KeyboardPan;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_KeyboardPan = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_KeyboardPan: 0
}, false, "reactbuild.project.drawing.interaction.KeyboardPan", {
  Lreactbuild_project_drawing_interaction_KeyboardPan: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_KeyboardPan.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_KeyboardPan;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_KeyboardZoom() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_KeyboardZoom;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_KeyboardZoom() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype = $c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype;
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.productPrefix__T = (function() {
  return "KeyboardZoom"
});
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_drawing_interaction_KeyboardZoom)
});
function $as_Lreactbuild_project_drawing_interaction_KeyboardZoom(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_KeyboardZoom) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.KeyboardZoom"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_KeyboardZoom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_KeyboardZoom)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_KeyboardZoom(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_KeyboardZoom(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.KeyboardZoom;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_KeyboardZoom = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_KeyboardZoom: 0
}, false, "reactbuild.project.drawing.interaction.KeyboardZoom", {
  Lreactbuild_project_drawing_interaction_KeyboardZoom: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_KeyboardZoom.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_KeyboardZoom;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_MouseWheelZoom() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_MouseWheelZoom;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_MouseWheelZoom() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype = $c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype;
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  if ((ev instanceof $c_Lreactbuild_common_components_Input$WheelEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$WheelEvent(ev);
    var coords = $n(x2).Lreactbuild_common_components_Input$WheelEvent__f_coords;
    var deltaY = $n(x2).Lreactbuild_common_components_Input$WheelEvent__f_deltaY;
    var deltaMode = $n(x2).Lreactbuild_common_components_Input$WheelEvent__f_deltaMode;
    var delta = ((deltaMode === $uI(WheelEvent.DOM_DELTA_LINE)) ? (40.0 * deltaY) : deltaY);
    var f = (delta / 300.0);
    var factor = ((f === 0.0) ? 1.0 : ((f < 0.0) ? ((-1.0) / f) : f));
    var this$1 = $n(context);
    return new $c_Lreactbuild_common_components_Done(this, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this$1.Lreactbuild_project_drawing_DrawingContextImpl__f_backend).Lreactbuild_project_drawing_DrawingContext$Backend__f_zoom).apply__O__O__O(coords, factor))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  } else {
    return $m_Lreactbuild_common_components_Skip$()
  }
});
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.productPrefix__T = (function() {
  return "MouseWheelZoom"
});
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_drawing_interaction_MouseWheelZoom)
});
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return this.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult(ev, trackedPointers, $as_Lreactbuild_project_drawing_DrawingContext(context))
});
function $as_Lreactbuild_project_drawing_interaction_MouseWheelZoom(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_MouseWheelZoom) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.MouseWheelZoom"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_MouseWheelZoom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_MouseWheelZoom)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_MouseWheelZoom(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_MouseWheelZoom(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.MouseWheelZoom;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_MouseWheelZoom = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_MouseWheelZoom: 0
}, false, "reactbuild.project.drawing.interaction.MouseWheelZoom", {
  Lreactbuild_project_drawing_interaction_MouseWheelZoom: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_MouseWheelZoom.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_MouseWheelZoom;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_PinchRotate() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_PinchRotate;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_PinchRotate() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_PinchRotate.prototype = $c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype;
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.productPrefix__T = (function() {
  return "PinchRotate"
});
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_drawing_interaction_PinchRotate)
});
function $as_Lreactbuild_project_drawing_interaction_PinchRotate(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_PinchRotate) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.PinchRotate"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_PinchRotate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_PinchRotate)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_PinchRotate(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_PinchRotate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.PinchRotate;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_PinchRotate = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_PinchRotate: 0
}, false, "reactbuild.project.drawing.interaction.PinchRotate", {
  Lreactbuild_project_drawing_interaction_PinchRotate: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_PinchRotate.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_PinchRotate;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_PinchZoom() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_PinchZoom;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_PinchZoom() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_PinchZoom.prototype = $c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype;
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.productPrefix__T = (function() {
  return "PinchZoom"
});
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_project_drawing_interaction_PinchZoom)
});
function $as_Lreactbuild_project_drawing_interaction_PinchZoom(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_PinchZoom) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.PinchZoom"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_PinchZoom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_PinchZoom)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_PinchZoom(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_PinchZoom(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.PinchZoom;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_PinchZoom = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_PinchZoom: 0
}, false, "reactbuild.project.drawing.interaction.PinchZoom", {
  Lreactbuild_project_drawing_interaction_PinchZoom: 1,
  O: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_PinchZoom.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_PinchZoom;
/** @constructor */
function $c_Lreactbuild_project_generator_DocumentType$Brochure$() {
  this.Lreactbuild_project_generator_DocumentType__f_id = null;
  this.Lreactbuild_project_generator_DocumentType__f_name = null;
  this.Lreactbuild_project_generator_DocumentType__f_preferredScale = 0.0;
  $ct_Lreactbuild_project_generator_DocumentType__T__T__D__(this, "brochure", "Plaquette de vente", 0.3)
}
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype = new $h_Lreactbuild_project_generator_DocumentType();
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.constructor = $c_Lreactbuild_project_generator_DocumentType$Brochure$;
/** @constructor */
function $h_Lreactbuild_project_generator_DocumentType$Brochure$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_DocumentType$Brochure$.prototype = $c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype;
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.render__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_TagOf = (function(project, subprojects) {
  return $m_Lreactbuild_project_Document$().apply__Ldiode_data_Pot__sci_List__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Ldiode_data_Ready($n(project).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value), subprojects)
});
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.productPrefix__T = (function() {
  return "Brochure"
});
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.hashCode__I = (function() {
  return 430048324
});
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.toString__T = (function() {
  return "Brochure"
});
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.render__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode = (function(project, subprojects) {
  return this.render__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_TagOf(project, subprojects)
});
var $d_Lreactbuild_project_generator_DocumentType$Brochure$ = new $TypeData().initClass({
  Lreactbuild_project_generator_DocumentType$Brochure$: 0
}, false, "reactbuild.project.generator.DocumentType$Brochure$", {
  Lreactbuild_project_generator_DocumentType$Brochure$: 1,
  Lreactbuild_project_generator_DocumentType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_DocumentType$Brochure$.prototype.$classData = $d_Lreactbuild_project_generator_DocumentType$Brochure$;
var $n_Lreactbuild_project_generator_DocumentType$Brochure$;
function $m_Lreactbuild_project_generator_DocumentType$Brochure$() {
  if ((!$n_Lreactbuild_project_generator_DocumentType$Brochure$)) {
    $n_Lreactbuild_project_generator_DocumentType$Brochure$ = new $c_Lreactbuild_project_generator_DocumentType$Brochure$()
  };
  return $n_Lreactbuild_project_generator_DocumentType$Brochure$
}
/** @constructor */
function $c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$() {
  this.Lreactbuild_project_generator_DocumentType__f_id = null;
  this.Lreactbuild_project_generator_DocumentType__f_name = null;
  this.Lreactbuild_project_generator_DocumentType__f_preferredScale = 0.0;
  $ct_Lreactbuild_project_generator_DocumentType__T__T__D__(this, "electricalBoardLabels", "Etiquettes tableau \u00e9lectrique", ($m_Lreactbuild_project_generator_DocumentType$(), 1.0))
}
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype = new $h_Lreactbuild_project_generator_DocumentType();
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype.constructor = $c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$;
/** @constructor */
function $h_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype = $c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype;
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype.render__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode = (function(project, subprojects) {
  var this$7 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var u = $m_Lreactbuild_project_generator_electricalboard_components_Root$().apply__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot();
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$7, null, ns)
});
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype.productPrefix__T = (function() {
  return "ElectricalBoardLabel"
});
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype.hashCode__I = (function() {
  return (-1519381514)
});
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype.toString__T = (function() {
  return "ElectricalBoardLabel"
});
var $d_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$ = new $TypeData().initClass({
  Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$: 0
}, false, "reactbuild.project.generator.DocumentType$ElectricalBoardLabel$", {
  Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$: 1,
  Lreactbuild_project_generator_DocumentType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$.prototype.$classData = $d_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$;
var $n_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$;
function $m_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$() {
  if ((!$n_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$)) {
    $n_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$ = new $c_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$()
  };
  return $n_Lreactbuild_project_generator_DocumentType$ElectricalBoardLabel$
}
/** @constructor */
function $c_Lreactbuild_project_generator_DocumentType$PC$() {
  this.Lreactbuild_project_generator_DocumentType__f_id = null;
  this.Lreactbuild_project_generator_DocumentType__f_name = null;
  this.Lreactbuild_project_generator_DocumentType__f_preferredScale = 0.0;
  $ct_Lreactbuild_project_generator_DocumentType__T__T__D__(this, "PCMI", "Permis de construire", ($m_Lreactbuild_project_generator_DocumentType$(), 1.0))
}
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype = new $h_Lreactbuild_project_generator_DocumentType();
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.constructor = $c_Lreactbuild_project_generator_DocumentType$PC$;
/** @constructor */
function $h_Lreactbuild_project_generator_DocumentType$PC$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_DocumentType$PC$.prototype = $c_Lreactbuild_project_generator_DocumentType$PC$.prototype;
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.render__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomElement = (function(project, subprojects) {
  var $$x8 = $m_Lreactbuild_project_generator_Document$();
  var $$x7 = $m_Lreactbuild_project_generator_GeneratorPart$();
  var u = $m_Lreactbuild_project_generator_Place$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(project);
  var this$2 = $n(u);
  var n = this$2.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
  var $$x6 = $n($$x7).apply__T__T__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement("1", "Plan de situation", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), project);
  var $$x5 = $m_Lreactbuild_project_generator_GeneratorPart$();
  var array$1 = [$m_Lreactbuild_project_generator_GroundDrawing$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement(project)];
  var $$x4 = $n($$x5).apply__T__T__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement("2", "Plan de masse", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), project);
  var $$x3 = $m_Lreactbuild_project_generator_GeneratorPart$();
  var array$2 = [$m_Lreactbuild_project_generator_SectionCutDrawing$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement(project)];
  var $$x2 = $n($$x3).apply__T__T__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement("3", "Plan en coupe", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), project);
  var $$x1 = $m_Lreactbuild_project_generator_GeneratorPart$();
  var array$3 = [$m_Lreactbuild_project_generator_Notice$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomElement(project, subprojects)];
  var array$4 = [$$x6, $$x4, $$x2, $n($$x1).apply__T__T__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement("4", "Notice", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), project), $m_Lreactbuild_project_generator_GeneratorPart$().apply__T__T__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement("5", "Plan fa\u00e7ade & toitures", $m_sci_Nil$(), project), $m_Lreactbuild_project_generator_GeneratorPart$().apply__T__T__sci_Seq__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_vdom_VdomElement("6-8", "Photos & int\u00e9gration 3D", $m_sci_Nil$(), project)];
  var u$1 = $n($$x8).apply__sci_Seq__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var this$20 = $n(u$1);
  var n$1 = this$20.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
});
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.productPrefix__T = (function() {
  return "PC"
});
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.hashCode__I = (function() {
  return 2547
});
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.toString__T = (function() {
  return "PC"
});
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.render__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomNode = (function(project, subprojects) {
  return this.render__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__Ljapgolly_scalajs_react_vdom_VdomElement(project, subprojects)
});
var $d_Lreactbuild_project_generator_DocumentType$PC$ = new $TypeData().initClass({
  Lreactbuild_project_generator_DocumentType$PC$: 0
}, false, "reactbuild.project.generator.DocumentType$PC$", {
  Lreactbuild_project_generator_DocumentType$PC$: 1,
  Lreactbuild_project_generator_DocumentType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_DocumentType$PC$.prototype.$classData = $d_Lreactbuild_project_generator_DocumentType$PC$;
var $n_Lreactbuild_project_generator_DocumentType$PC$;
function $m_Lreactbuild_project_generator_DocumentType$PC$() {
  if ((!$n_Lreactbuild_project_generator_DocumentType$PC$)) {
    $n_Lreactbuild_project_generator_DocumentType$PC$ = new $c_Lreactbuild_project_generator_DocumentType$PC$()
  };
  return $n_Lreactbuild_project_generator_DocumentType$PC$
}
/** @constructor */
function $c_Lreactbuild_project_generator_Orientation$Landscape$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_Orientation$Landscape$.prototype = new $h_O();
$c_Lreactbuild_project_generator_Orientation$Landscape$.prototype.constructor = $c_Lreactbuild_project_generator_Orientation$Landscape$;
/** @constructor */
function $h_Lreactbuild_project_generator_Orientation$Landscape$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_Orientation$Landscape$.prototype = $c_Lreactbuild_project_generator_Orientation$Landscape$.prototype;
$c_Lreactbuild_project_generator_Orientation$Landscape$.prototype.productPrefix__T = (function() {
  return "Landscape"
});
$c_Lreactbuild_project_generator_Orientation$Landscape$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_Orientation$Landscape$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_Orientation$Landscape$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_Orientation$Landscape$.prototype.hashCode__I = (function() {
  return (-860351845)
});
$c_Lreactbuild_project_generator_Orientation$Landscape$.prototype.toString__T = (function() {
  return "Landscape"
});
var $d_Lreactbuild_project_generator_Orientation$Landscape$ = new $TypeData().initClass({
  Lreactbuild_project_generator_Orientation$Landscape$: 0
}, false, "reactbuild.project.generator.Orientation$Landscape$", {
  Lreactbuild_project_generator_Orientation$Landscape$: 1,
  O: 1,
  Lreactbuild_project_generator_Orientation: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_Orientation$Landscape$.prototype.$classData = $d_Lreactbuild_project_generator_Orientation$Landscape$;
var $n_Lreactbuild_project_generator_Orientation$Landscape$;
function $m_Lreactbuild_project_generator_Orientation$Landscape$() {
  if ((!$n_Lreactbuild_project_generator_Orientation$Landscape$)) {
    $n_Lreactbuild_project_generator_Orientation$Landscape$ = new $c_Lreactbuild_project_generator_Orientation$Landscape$()
  };
  return $n_Lreactbuild_project_generator_Orientation$Landscape$
}
/** @constructor */
function $c_Lreactbuild_project_generator_Orientation$Portrait$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_Orientation$Portrait$.prototype = new $h_O();
$c_Lreactbuild_project_generator_Orientation$Portrait$.prototype.constructor = $c_Lreactbuild_project_generator_Orientation$Portrait$;
/** @constructor */
function $h_Lreactbuild_project_generator_Orientation$Portrait$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_Orientation$Portrait$.prototype = $c_Lreactbuild_project_generator_Orientation$Portrait$.prototype;
$c_Lreactbuild_project_generator_Orientation$Portrait$.prototype.productPrefix__T = (function() {
  return "Portrait"
});
$c_Lreactbuild_project_generator_Orientation$Portrait$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_Orientation$Portrait$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_Orientation$Portrait$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_Orientation$Portrait$.prototype.hashCode__I = (function() {
  return 793911227
});
$c_Lreactbuild_project_generator_Orientation$Portrait$.prototype.toString__T = (function() {
  return "Portrait"
});
var $d_Lreactbuild_project_generator_Orientation$Portrait$ = new $TypeData().initClass({
  Lreactbuild_project_generator_Orientation$Portrait$: 0
}, false, "reactbuild.project.generator.Orientation$Portrait$", {
  Lreactbuild_project_generator_Orientation$Portrait$: 1,
  O: 1,
  Lreactbuild_project_generator_Orientation: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_Orientation$Portrait$.prototype.$classData = $d_Lreactbuild_project_generator_Orientation$Portrait$;
var $n_Lreactbuild_project_generator_Orientation$Portrait$;
function $m_Lreactbuild_project_generator_Orientation$Portrait$() {
  if ((!$n_Lreactbuild_project_generator_Orientation$Portrait$)) {
    $n_Lreactbuild_project_generator_Orientation$Portrait$ = new $c_Lreactbuild_project_generator_Orientation$Portrait$()
  };
  return $n_Lreactbuild_project_generator_Orientation$Portrait$
}
/** @constructor */
function $c_Lreactbuild_project_generator_OutputMedia$StandardPaper(mediaSize, orientation) {
  this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_mediaSize = null;
  this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_orientation = null;
  this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_min = 0.0;
  this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_max = 0.0;
  this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_width = 0.0;
  this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_height = 0.0;
  this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_mediaSize = mediaSize;
  this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_orientation = orientation;
  $f_Lreactbuild_project_generator_OutputMedia__$init$__V(this)
}
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype = new $h_O();
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype.constructor = $c_Lreactbuild_project_generator_OutputMedia$StandardPaper;
/** @constructor */
function $h_Lreactbuild_project_generator_OutputMedia$StandardPaper() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype = $c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype;
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype.productPrefix__T = (function() {
  return "StandardPaper"
});
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_mediaSize;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_orientation;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_OutputMedia$StandardPaper)) {
    var StandardPaper$1 = $as_Lreactbuild_project_generator_OutputMedia$StandardPaper(x$1);
    var x = this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_mediaSize;
    var x$2 = $n(StandardPaper$1).Lreactbuild_project_generator_OutputMedia$StandardPaper__f_mediaSize;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_generator_OutputMedia$StandardPaper__f_orientation;
      var x$4 = $n(StandardPaper$1).Lreactbuild_project_generator_OutputMedia$StandardPaper__f_orientation;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_OutputMedia$StandardPaper(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_OutputMedia$StandardPaper) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.OutputMedia$StandardPaper"))
}
function $isArrayOf_Lreactbuild_project_generator_OutputMedia$StandardPaper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_OutputMedia$StandardPaper)))
}
function $asArrayOf_Lreactbuild_project_generator_OutputMedia$StandardPaper(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_OutputMedia$StandardPaper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.OutputMedia$StandardPaper;", depth))
}
var $d_Lreactbuild_project_generator_OutputMedia$StandardPaper = new $TypeData().initClass({
  Lreactbuild_project_generator_OutputMedia$StandardPaper: 0
}, false, "reactbuild.project.generator.OutputMedia$StandardPaper", {
  Lreactbuild_project_generator_OutputMedia$StandardPaper: 1,
  O: 1,
  Lreactbuild_project_generator_OutputMedia: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_OutputMedia$StandardPaper.prototype.$classData = $d_Lreactbuild_project_generator_OutputMedia$StandardPaper;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend(\u03b4) {
  this.Lreactbuild_project_generator_electricalboard_components_Cell$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_generator_electricalboard_components_Cell$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Cell$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Cell$Backend.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_generator_electricalboard_components_Cell$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_generator_electricalboard_components_Cell$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend.prototype.render__Lreactbuild_project_generator_electricalboard_components_Cell$Props__jl_Void__Ljapgolly_scalajs_react_vdom_TagOf = (function(p, s) {
  var $$x55 = $n($m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardCellLayout);
  var $$x54 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "gridColumnEnd")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("span " + $n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_span), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x53 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "gridRow")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(("" + ((1 + $n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_rowColumn) | 0)), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var this$43 = $m_Lreactbuild_project_generator_paper_PrintOnly$();
  var $$x51 = $m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardCellContentLayout;
  var $$x50 = $n($m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardIcon);
  var this$22 = $n($n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_icon);
  var f = new $c_sjsr_AnonFunction1(((i$2) => {
    var i = $as_Lreactbuild_project_generator_electricalboard_model_Icon(i$2);
    var $$x49 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$9 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "viewBox");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x48 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$9.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0 0 24 24");
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$12 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "dangerouslySetInnerHTML");
    var a = $n(i).Lreactbuild_project_generator_electricalboard_model_Icon__f_svg;
    var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtInnerHtml__F2();
    var $$x47 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$12.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$15 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
    var a$1 = $n(i).Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor;
    var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x46 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$15.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$18 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
    var a$2 = $n(i).Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor;
    var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var array = [$$x48, $$x47, $$x46, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$18.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$2)];
    return $n($$x49).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("svg", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  }));
  var this$25 = $n((this$22.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$22.get__O()))));
  var default$1 = new $c_sjsr_AnonFunction0((() => {
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("")
  }));
  var array$1 = [$as_Ljapgolly_scalajs_react_vdom_TagMod((this$25.isEmpty__Z() ? default$1.apply__O() : this$25.get__O()))];
  var $$x45 = $n($$x50).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x44 = $m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardLabel;
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = $n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x43 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v);
  var $$x42 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  var this$31 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  var $$x41 = $n($$x42).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_vdom_HtmlTags__br__T(this$31), $m_sci_Nil$());
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$1 = $n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$2 = [$$x43, $$x41, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
  var array$3 = [$$x45, $n($$x44).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var array$4 = [$n($$x51).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var $$x52 = $n(this$43.Lreactbuild_project_generator_paper_PrintOnly$__f_printOnly).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(xs);
  var this$250 = $m_Lreactbuild_project_generator_paper_NotPrintable$();
  var $$x40 = $m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardCellContentLayout;
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$1 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDragOver");
  var $$x39 = stabilizer$1.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$2) => {
    ev$2.dataTransfer.dropEffect = "move";
    $m_Ljapgolly_scalajs_react_package$();
    var this$47 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$2, this$47.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$2 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDrop");
  var $$x37 = stabilizer$2.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$3$2) => {
    var data = $as_T(ev$3$2.dataTransfer.getData("item"));
    var $$x38 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    $m_Ljapgolly_scalajs_react_package$();
    var this$51 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x38).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_ReactExt\uff3fReactEvent(ev$3$2, this$51.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync).preventDefaultCB__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_moveCell).apply__O__O__O($m_ju_UUID$().fromString__T__ju_UUID(data), new $c_s_Some($n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_id)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
  })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  var $$x36 = $n($m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardLabel);
  var $$x35 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x34 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $ct_Ljapgolly_scalajs_react_vdom_Style__T__(new $c_Ljapgolly_scalajs_react_vdom_Style(), "backgroundColor")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("black", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x33 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("width")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x32 = ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), new $c_Ljapgolly_scalajs_react_vdom_HtmlStylesStatic$AutoStyle("height")).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("0.5em", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$60 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "draggable");
  var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean;
  var $$x31 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$60.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, true);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  var stabilizer$3 = new $c_Ljapgolly_scalajs_react_vdom_Attr$Event("onDragStart");
  var array$5 = [$$x34, $$x33, $$x32, $$x31, stabilizer$3.$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((ev$4$2) => {
    ev$4$2.dataTransfer.dropEffect = "move";
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      ev$4$2.dataTransfer.setData("item", $n($n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_id).toString__T())
    }));
    var f$2 = new $c_sjsr_AnonFunction0((() => {
      f$1.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$2))
  })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var $$x30 = $n($$x35).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("span", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$73 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t$5 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var array$6 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$5, this$73.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, (-1)), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("-")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => {
    var this$84 = $n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state);
    var mod = new $c_sjsr_AnonFunction1(((x$2$2) => {
      var x$2 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$2$2);
      var b = (((-1) + $n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_span) | 0);
      var x$1 = ((b < 1) ? 1 : b);
      var this$77 = $n(x$2);
      var x$2$2$1 = this$77.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      var this$78 = $n(x$2);
      var x$3 = this$78.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
      var this$79 = $n(x$2);
      var x$4 = this$79.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
      var this$80 = $n(x$2);
      var x$5 = this$80.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
      var this$81 = $n(x$2);
      var x$6 = this$81.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
      var this$82 = $n(x$2);
      var x$7 = this$82.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
      $n(x$2);
      return new $c_Lreactbuild_project_generator_electricalboard_model_Cell(x$2$2$1, x$3, x$4, x$5, x$1, x$6, x$7)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$84, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var $$x28 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$2 = $n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x27 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2);
  var $$x26 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$94 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t$6 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var array$7 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$6, this$94.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, (-1)), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("x")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_moveCell).apply__O__O__O($n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_id, $m_s_None$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var $$x25 = $n($$x26).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up);
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$104 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "tabIndex");
  var t$7 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var array$8 = [$m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$7, this$104.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, (-1)), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("+")), $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onClick).$minus$minus$greater__F0__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction0((() => {
    var this$114 = $n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state);
    var mod$1 = new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$3$2);
      var x$8 = ((1 + $n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_span) | 0);
      var this$107 = $n(x$3$1);
      var x$9 = this$107.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      var this$108 = $n(x$3$1);
      var x$10 = this$108.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
      var this$109 = $n(x$3$1);
      var x$11 = this$109.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
      var this$110 = $n(x$3$1);
      var x$12 = this$110.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
      var this$111 = $n(x$3$1);
      var x$13 = this$111.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
      var this$112 = $n(x$3$1);
      var x$14 = this$112.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
      $n(x$3$1);
      return new $c_Lreactbuild_project_generator_electricalboard_model_Cell(x$9, x$10, x$11, x$12, x$8, x$13, x$14)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$114, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync)];
  var array$9 = [$$x30, $$x28, $$x27, $$x25, $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("button", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x23 = $n($$x36).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var $$x22 = $n($m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardIcon);
  var $$x21 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x18 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_value);
  var this$123 = $n($n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_icon);
  var f$3 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4$1 = $as_Lreactbuild_project_generator_electricalboard_model_Icon(x$4$2);
    return $n(x$4$1).toString__T()
  }));
  var this$124 = $n((this$123.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f$3.apply__O__O(this$123.get__O()))));
  var default$2 = new $c_sjsr_AnonFunction0((() => ""));
  var $$x17 = $n($$x18).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod((this$124.isEmpty__Z() ? default$2.apply__O() : this$124.get__O()), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
  var $$x16 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_onChange).$eq$eq$greater__F1__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((e$2) => {
    var v$3 = $as_T(e$2.target.value);
    var this$132 = $n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state);
    var mod$2 = new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$5$2);
      var x$15 = $n($m_Lreactbuild_project_generator_electricalboard_model_Icon$().Lreactbuild_project_generator_electricalboard_model_Icon$__f_map).get__O__s_Option(v$3);
      var this$125 = $n(x$5$1);
      var x$16 = this$125.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      var this$126 = $n(x$5$1);
      var x$17 = this$126.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
      var this$127 = $n(x$5$1);
      var x$18 = this$127.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
      var this$128 = $n(x$5$1);
      var x$19 = this$128.Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
      var this$129 = $n(x$5$1);
      var x$20 = this$129.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
      var this$130 = $n(x$5$1);
      var x$21 = this$130.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
      $n(x$5$1);
      return new $c_Lreactbuild_project_generator_electricalboard_model_Cell(x$16, x$17, x$18, x$15, x$19, x$20, x$21)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$132, mod$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  })), $m_Ljapgolly_scalajs_react_vdom_Attr$EventCallback$().Ljapgolly_scalajs_react_vdom_Attr$EventCallback$__f_defaultSync);
  var $$x15 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var array$10 = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_value).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("", $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(""))];
  var $$x14 = $n($$x15).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("option", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
  var $$x13 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = $m_Lreactbuild_project_generator_electricalboard_model_Icon$().Lreactbuild_project_generator_electricalboard_model_Icon$__f_list;
  var array$12 = [$$x17, $$x16, $$x14, $n($$x13).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((v$2$1) => {
    var v$4 = $as_Lreactbuild_project_generator_electricalboard_model_Icon(v$2$1);
    var $$x20 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x19 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_value).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod($n(v$4).toString__T(), $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var v$5 = $n(v$4).Lreactbuild_project_generator_electricalboard_model_Icon__f_label;
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$11 = [$$x19, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
    return $n($$x20).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("option", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
  })))];
  var array$13 = [$n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("select", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  var $$x12 = $n($$x22).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
  var $$x11 = $n($m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardLabel);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ligne 1");
  var state = $n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$6$2);
    return $n(x$6$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_label1
  })), new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3$1 = $as_T(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$7$2);
      var this$156 = $n(x$7$1);
      var x$23 = this$156.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      var this$157 = $n(x$7$1);
      var x$24 = this$157.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
      var this$158 = $n(x$7$1);
      var x$25 = this$158.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
      var this$159 = $n(x$7$1);
      var x$26 = this$159.Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
      var this$160 = $n(x$7$1);
      var x$27 = this$160.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
      var this$161 = $n(x$7$1);
      var x$28 = this$161.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
      $n(x$7$1);
      return new $c_Lreactbuild_project_generator_electricalboard_model_Cell(x$23, v$3$1, x$24, x$25, x$26, x$27, x$28)
    }))
  })));
  var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
  var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$165 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$165);
  var editorComponent = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
  var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv = $m_s_math_Equiv$String$();
  var array$14 = [editorComponent.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv)];
  var $$x10 = $n($$x11).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
  var $$x9 = $n($m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardLabel);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Ligne 2");
  var state$1 = $n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$8$2);
    return $n(x$8$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_label2
  })), new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4$1 = $as_T(v$4$2);
    return new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$9$2);
      var this$174 = $n(x$9$1);
      var x$30 = this$174.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      var this$175 = $n(x$9$1);
      var x$31 = this$175.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
      var this$176 = $n(x$9$1);
      var x$32 = this$176.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
      var this$177 = $n(x$9$1);
      var x$33 = this$177.Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
      var this$178 = $n(x$9$1);
      var x$34 = this$178.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
      var this$179 = $n(x$9$1);
      var x$35 = this$179.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
      $n(x$9$1);
      return new $c_Lreactbuild_project_generator_electricalboard_model_Cell(x$30, x$31, v$4$1, x$32, x$33, x$34, x$35)
    }))
  })));
  var evDefault$1 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
  var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
  var parser$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
  var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$183 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$1 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$183);
  var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$1);
  var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$1 = $m_s_math_Equiv$String$();
  var array$15 = [editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$1, explainError$1, equiv$1)];
  var $$x8 = $n($$x9).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15));
  var $$x7 = $n($m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardLabel);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Intensit\u00e9");
  var state$2 = $n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$10$2);
    return $n(x$10$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity
  })), new $c_sjsr_AnonFunction1(((v$5$2) => {
    var v$5$1 = $as_s_Option(v$5$2);
    return new $c_sjsr_AnonFunction1(((x$11$2) => {
      var x$11$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$11$2);
      var this$192 = $n(x$11$1);
      var x$37 = this$192.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
      var this$193 = $n(x$11$1);
      var x$38 = this$193.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
      var this$194 = $n(x$11$1);
      var x$39 = this$194.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
      var this$195 = $n(x$11$1);
      var x$40 = this$195.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
      var this$196 = $n(x$11$1);
      var x$41 = this$196.Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
      var this$197 = $n(x$11$1);
      var x$42 = this$197.Lreactbuild_project_generator_electricalboard_model_Cell__f_targets;
      $n(x$11$1);
      return new $c_Lreactbuild_project_generator_electricalboard_model_Cell(x$37, x$38, x$39, x$40, x$41, x$42, v$5$1)
    }))
  })));
  var optioner$2 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
  var parser$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
  var ev$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
  $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
  var this$201 = $m_Lcom_iz2use_react_components_TextEditorHelper$();
  var helper$2 = new $c_Lcom_iz2use_react_components_LowestPriorityTextEditorHelperImplicits$$anon$1(this$201);
  var editorComponent$2 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper$2);
  var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
  var equiv$2 = $m_s_math_Equiv$Int$();
  var array$16 = [editorComponent$2.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$2, optioner$2, ev$3, explainError$2, equiv$2)];
  var $$x6 = $n($$x7).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
  var $$x5 = $m_Lreactbuild_project_generator_electricalboard_components_Cell$().Lreactbuild_project_generator_electricalboard_components_Cell$__f_electricalBoardLabel;
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$208 = $n($n($as_Lreactbuild_project_generator_electricalboard_model_Cell($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets);
  var as$1 = $as_sc_IterableOnce($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$208));
  var $$x3 = $n($$x4).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as$1, new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var target = $as_Lreactbuild_project_generator_electricalboard_model_LineSource($n(x0$1)._1__O());
      var idx = $n(x0$1)._2$mcI$sp__I();
      var u = $m_Lreactbuild_project_generator_electricalboard_components_LineSource$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state).zoomState__F1__F1__Ljapgolly_scalajs_react_extra_StateSnapshotF(new $c_sjsr_AnonFunction1(((x$12$2) => {
        var x$12$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(x$12$2);
        var this$210 = $n($n(x$12$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets);
        return $as_Lreactbuild_project_generator_electricalboard_model_LineSource($f_sc_LinearSeqOps__apply__I__O(this$210, idx))
      })), new $c_sjsr_AnonFunction1(((v$2$2) => {
        var v$6 = $as_Lreactbuild_project_generator_electricalboard_model_LineSource(v$2$2);
        return new $c_sjsr_AnonFunction1(((s$2) => {
          var s$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(s$2);
          var this$211 = $n($n(v$6).Lreactbuild_project_generator_electricalboard_model_LineSource__f_label);
          if ((this$211 === "")) {
            $m_sc_StringOps$();
            var x = $n(target).Lreactbuild_project_generator_electricalboard_model_LineSource__f_label;
            var this$214 = $n(x);
            var dropIt = (!(this$214 === ""))
          } else {
            var dropIt = false
          };
          var this$216 = $n($n(s$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets);
          if (dropIt) {
            var other = $m_s_package$().s_package$__f_Nil
          } else {
            var this$215 = $n($m_s_package$().s_package$__f_Nil);
            var other = new $c_sci_$colon$colon(v$6, this$215)
          };
          var x$43 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$216, idx, other, 1));
          var this$217 = $n(s$1);
          var x$44 = this$217.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
          var this$218 = $n(s$1);
          var x$45 = this$218.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
          var this$219 = $n(s$1);
          var x$46 = this$219.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
          var this$220 = $n(s$1);
          var x$47 = this$220.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
          var this$221 = $n(s$1);
          var x$48 = this$221.Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
          var this$222 = $n(s$1);
          var x$49 = this$222.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
          $n(s$1);
          return new $c_Lreactbuild_project_generator_electricalboard_model_Cell(x$44, x$45, x$46, x$47, x$48, x$43, x$49)
        }))
      }))));
      var this$225 = $n(u);
      var n = this$225.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })));
  var $$x2 = $m_Lcom_iz2use_react_components_Link$();
  var this$237 = $n($n(p).Lreactbuild_project_generator_electricalboard_components_Cell$Props__f_state);
  var mod$3 = new $c_sjsr_AnonFunction1(((v$6$2) => {
    var v$6$1 = $as_Lreactbuild_project_generator_electricalboard_model_Cell(v$6$2);
    var this$229 = $n($n(v$6$1).Lreactbuild_project_generator_electricalboard_model_Cell__f_targets);
    var elem = new $c_Lreactbuild_project_generator_electricalboard_model_LineSource(($m_Lreactbuild_project_generator_electricalboard_model_LineSource$(), $m_ju_UUID$().randomUUID__ju_UUID()), ($m_Lreactbuild_project_generator_electricalboard_model_LineSource$(), ""), ($m_Lreactbuild_project_generator_electricalboard_model_LineSource$(), $m_s_Option$().apply__O__s_Option(2.5)), $m_Lreactbuild_project_generator_electricalboard_model_LineSource$().apply$default$4__sci_Set());
    var x$50 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$229, elem));
    var this$230 = $n(v$6$1);
    var x$51 = this$230.Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
    var this$231 = $n(v$6$1);
    var x$52 = this$231.Lreactbuild_project_generator_electricalboard_model_Cell__f_label1;
    var this$232 = $n(v$6$1);
    var x$53 = this$232.Lreactbuild_project_generator_electricalboard_model_Cell__f_label2;
    var this$233 = $n(v$6$1);
    var x$54 = this$233.Lreactbuild_project_generator_electricalboard_model_Cell__f_icon;
    var this$234 = $n(v$6$1);
    var x$55 = this$234.Lreactbuild_project_generator_electricalboard_model_Cell__f_span;
    var this$235 = $n(v$6$1);
    var x$56 = this$235.Lreactbuild_project_generator_electricalboard_model_Cell__f_intensity;
    $n(v$6$1);
    return new $c_Lreactbuild_project_generator_electricalboard_model_Cell(x$51, x$52, x$53, x$54, x$55, x$50, x$56)
  }));
  var $$x1 = $n($$x2).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$237, mod$3))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
  var array$17 = [$m_Lcom_iz2use_react_components_Icon$().apply__Lcom_iz2use_react_components_IconSource__T__T__Ljapgolly_scalajs_react_vdom_TagOf($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_add, "", "24px")];
  var array$18 = [$$x3, $n($$x1).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))];
  var array$19 = [$$x39, $$x37, $$x23, $$x12, $$x10, $$x8, $$x6, $n($$x5).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))];
  var array$20 = [$n($$x40).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19))];
  var xs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20);
  var array$21 = [$$x54, $$x53, $$x52, $n(this$250.Lreactbuild_project_generator_paper_NotPrintable$__f_notPrintable).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf(xs$1)];
  return $n($$x55).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21))
});
function $as_Lreactbuild_project_generator_electricalboard_components_Cell$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.components.Cell$Backend"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_components_Cell$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_components_Cell$Backend)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_components_Cell$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_components_Cell$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.components.Cell$Backend;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_components_Cell$Backend = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Cell$Backend: 0
}, false, "reactbuild.project.generator.electricalboard.components.Cell$Backend", {
  Lreactbuild_project_generator_electricalboard_components_Cell$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_TimerSupport: 1,
  Ljapgolly_scalajs_react_extra_TimerSupportF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Cell$Backend.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Cell$Backend;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_Root$Backend(\u03b4) {
  this.Lreactbuild_project_generator_electricalboard_components_Root$Backend__f_$ = null;
  this.Lreactbuild_project_generator_electricalboard_components_Root$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_generator_electricalboard_components_Root$Backend__f_$ = \u03b4;
  this.Lreactbuild_project_generator_electricalboard_components_Root$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil
}
$c_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_Root$Backend;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_Root$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype = $c_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_generator_electricalboard_components_Root$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_generator_electricalboard_components_Root$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype.render__Lreactbuild_project_generator_electricalboard_model_Table__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(s) {
  var c = $m_Lreactbuild_project_generator_electricalboard_components_Table$().Lreactbuild_project_generator_electricalboard_components_Table$__f_component;
  var this$4 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
  $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
  var $$x1 = this.Lreactbuild_project_generator_electricalboard_components_Root$Backend__f_$;
  var this$3 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$3.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  var props = $n($$x2).setStateVia$extension__O__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $$x1, w);
  return $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$4.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$4.Ljapgolly_scalajs_react_CtorType$Props__f_mods))
});
$c_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype.save__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_project_generator_electricalboard_components_Root$Backend__f_$).state__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$2 = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_project_generator_electricalboard_model_Table(s$2);
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var f = new $c_sjsr_AnonFunction0((() => {
      var $$x2 = window.localStorage;
      var $$x1 = $m_Lreactbuild_project_generator_electricalboard_components_Root$().Lreactbuild_project_generator_electricalboard_components_Root$__f_key;
      var encoder = $m_Lreactbuild_project_generator_electricalboard_model_Table$().Lreactbuild_project_generator_electricalboard_model_Table$__f_codecForTable;
      var this$4 = $n(encoder);
      var this$5 = $n($f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$4, s));
      $$x2.setItem($$x1, $n($m_Lio_circe_Printer$().Lio_circe_Printer$__f_spaces2).print__Lio_circe_Json__T(this$5))
    }));
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      f.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
  }));
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$, f$2)
});
function $as_Lreactbuild_project_generator_electricalboard_components_Root$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_components_Root$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.components.Root$Backend"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_components_Root$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_components_Root$Backend)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_components_Root$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_components_Root$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.components.Root$Backend;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_components_Root$Backend = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_Root$Backend: 0
}, false, "reactbuild.project.generator.electricalboard.components.Root$Backend", {
  Lreactbuild_project_generator_electricalboard_components_Root$Backend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_TimerSupport: 1,
  Ljapgolly_scalajs_react_extra_TimerSupportF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_Root$Backend.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_Root$Backend;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1(focus$1) {
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1__f_focus$1 = null;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1__f_focus$1 = focus$1
}
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1.prototype = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1.prototype.applyOrElse__I__F1__O = (function(x1, default$1) {
  switch (x1) {
    case 37:
    case 38: {
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r = $n(this.Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1__f_focus$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex((-1), false));
      return $n(r).value__O();
      break
    }
    case 39:
    case 40: {
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r$1 = $n(this.Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1__f_focus$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex(1, false));
      return $n(r$1).value__O();
      break
    }
    case 36: {
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r$2 = $n(this.Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1__f_focus$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex((-1), true));
      return $n(r$2).value__O();
      break
    }
    case 35: {
      $m_Ljapgolly_scalajs_react_Reusable$();
      var r$3 = $n(this.Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1__f_focus$1).dispatch__O__Ljapgolly_scalajs_react_Reusable(new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex(1, true));
      return $n(r$3).value__O();
      break
    }
    default: {
      return $n(default$1).apply__O__O(x1)
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1.prototype.isDefinedAt__I__Z = (function(x1) {
  switch (x1) {
    case 37:
    case 38: {
      return true;
      break
    }
    case 39:
    case 40: {
      return true;
      break
    }
    case 36: {
      return true;
      break
    }
    case 35: {
      return true;
      break
    }
    default: {
      return false
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__I__F1__O($uI(x), default$1)
});
var $d_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1: 0
}, false, "reactbuild.project.generator.electricalboard.components.WireColors$$anonfun$1", {
  Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_WireColors$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype.productPrefix__T = (function() {
  return "Blur"
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype.hashCode__I = (function() {
  return 2073735
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype.toString__T = (function() {
  return "Blur"
});
var $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$: 0
}, false, "reactbuild.project.generator.electricalboard.components.WireColors$Action$Blur$", {
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$;
var $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$;
function $m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$ = new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Blur$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype.productPrefix__T = (function() {
  return "Focus"
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype.hashCode__I = (function() {
  return 68052152
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype.toString__T = (function() {
  return "Focus"
});
var $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$: 0
}, false, "reactbuild.project.generator.electricalboard.components.WireColors$Action$Focus$", {
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$;
var $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$;
function $m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$ = new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$Focus$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype.productPrefix__T = (function() {
  return "MouseExit"
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype.hashCode__I = (function() {
  return (-1705070781)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype.toString__T = (function() {
  return "MouseExit"
});
var $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$: 0
}, false, "reactbuild.project.generator.electricalboard.components.WireColors$Action$MouseExit$", {
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$;
var $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$;
function $m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$ = new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseExit$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype.productPrefix__T = (function() {
  return "MouseOver"
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype.hashCode__I = (function() {
  return (-1704774919)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype.toString__T = (function() {
  return "MouseOver"
});
var $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$: 0
}, false, "reactbuild.project.generator.electricalboard.components.WireColors$Action$MouseOver$", {
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$;
var $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$;
function $m_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$)) {
    $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$ = new $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MouseOver$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex(delta, extended) {
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_delta = 0;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_extended = false;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_delta = delta;
  this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_extended = extended
}
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype = $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype;
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype.productPrefix__T = (function() {
  return "MoveIndex"
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_delta;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_extended;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("MoveIndex");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_delta;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_extended ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex)) {
    var MoveIndex$1 = $as_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex(x$1);
    return ((this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_delta === $n(MoveIndex$1).Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_delta) && (this.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_extended === $n(MoveIndex$1).Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex__f_extended))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.components.WireColors$Action$MoveIndex"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.components.WireColors$Action$MoveIndex;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex: 0
}, false, "reactbuild.project.generator.electricalboard.components.WireColors$Action$MoveIndex", {
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_components_WireColors$Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_components_WireColors$Action$MoveIndex;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "CE", "<path\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       d=\"M 8.5,2.5 C 11,2 13,2 15.5,2.5 c 0.543242,0.1086483 1,0.446 1,1 v 13 c 0,0.554 -0.456758,0.891352 -1,1 -2.5,0.5 -4.5,0.5 -7,0 -0.5432417,-0.108648 -1,-0.446 -1,-1 v -13 c 0,-0.554 0.4567583,-0.8913517 1,-1 z\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"\n       d=\"M 23,22.5 H 11.5 c -0.5,0 -1,-0.5 -1,-1 V 18\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"\n       d=\"m 23,20.5 h -8.5 c -0.5,0 -1,-0.5 -1,-1 V 18\" />", "#DD7700")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype.productPrefix__T = (function() {
  return "boiler"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype.hashCode__I = (function() {
  return (-1383564579)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype.toString__T = (function() {
  return "boiler"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$boiler$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$boiler$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$boiler$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$boiler$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "LV", "<rect\n       style=\"display:inline;opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect4075-5-0\"\n       width=\"17\"\n       height=\"21\"\n       x=\"3.5\"\n       y=\"1.5\" />\n    <path\n       style=\"display:inline;fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 3,5.5 H 21\"\n       id=\"path4077-3-5\" />\n    <rect\n       style=\"display:inline;opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect4132-2-3\"\n       width=\"2\"\n       height=\"1\"\n       x=\"17\"\n       y=\"3\" />\n    <rect\n       style=\"display:inline;opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect4134-0-2\"\n       width=\"1\"\n       height=\"1\"\n       x=\"14\"\n       y=\"3\" />\n    <path\n       style=\"fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"m 5.5,20.5 c 1,0 2,-0.454545 2,-1.545454 v -3.181454 c -1,0 -2,-1.182183 -2,-2.273092 V 7.5000001 h 6 V 13.5 c 0,1.090909 -1,2.273092 -2,2.273092 v 3.181454 c 0,1.090909 1,1.545454 2,1.545454\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"m 18.5,7 v 5 c 0,3 -2,2 -2,3.028571 V 21\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:0.99999994px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 16.5,6.9999998 V 12\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:0.99999994px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 14.5,6.9999998 V 12\" />", "#00A0A0")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype.productPrefix__T = (function() {
  return "dishwasher"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype.hashCode__I = (function() {
  return 890135974
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype.toString__T = (function() {
  return "dishwasher"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$dishwasher$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$dishwasher$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "SL", "<rect\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect4075-5\"\n       width=\"17\"\n       height=\"21\"\n       x=\"3.5\"\n       y=\"1.5\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 3,5.5 H 21\"\n       id=\"path4077-3\" />\n    <circle\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:0.99999988;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"path4111-6\"\n       cx=\"12\"\n       cy=\"14\"\n       r=\"4.5\" />\n    <rect\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect4132-2\"\n       width=\"2\"\n       height=\"1\"\n       x=\"17\"\n       y=\"3\" />\n    <rect\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect4134-0\"\n       width=\"1\"\n       height=\"1\"\n       x=\"14\"\n       y=\"3\" />\n    <g\n       id=\"g4190\"\n       transform=\"translate(-0.5,0.5)\">\n      <path\n         d=\"m 11,11 c 0.549238,0.714286 0.549238,1.428571 0,2.5 -0.549238,1.071429 -0.549238,1.785714 0,2.5\"\n         style=\"display:inline;fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" />\n      <path\n         d=\"m 14,11 c 0.549238,0.714286 0.549238,1.428571 0,2.5 -0.549238,1.071429 -0.549238,1.785714 0,2.5\"\n         style=\"display:inline;fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\" />\n    </g>", "#0000A0")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype.productPrefix__T = (function() {
  return "dryer"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype.hashCode__I = (function() {
  return 95867800
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype.toString__T = (function() {
  return "dryer"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$dryer$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$dryer$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$dryer$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$dryer$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "Hotte", "\n    <defs>\n      <marker\n         orient=\"auto\"\n         refY=\"0\"\n         refX=\"0\"\n         id=\"marker7503\"\n         style=\"overflow:visible\">\n        <path\n           id=\"path7501\"\n           d=\"M 5.77,0 -2.88,5 V -5 Z\"\n           style=\"fill-opacity:1;fill-rule:evenodd;stroke-width:1.00000003pt;stroke-opacity:1\"\n           transform=\"scale(0.2)\" />\n      </marker>\n    </defs>\n    <path\n       d=\"M 1.5,8.5 V 12 h 21 V 8.5 Z\"\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\" />\n    <path\n       d=\"M 20,8.5 16,1 H 8 L 4,8.5 Z\"\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\" />\n    <path\n       style=\"display:inline;fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;marker-end:url(#marker7503)\"\n       d=\"m 12.295097,21.510075 c 0.455681,-0.82966 0.455681,-1.65932 0,-2.90381 -0.455681,-1.244491 -0.455681,-2.074151 0,-2.903811\" />\n    <path\n       style=\"display:inline;fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;marker-end:url(#marker7503)\"\n       d=\"m 6.806117,21.510075 c 0.455681,-0.82966 0.455681,-1.65932 0,-2.90381 -0.455681,-1.244491 -0.455681,-2.074151 0,-2.903811\" />\n    <path\n       style=\"display:inline;fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;marker-end:url(#marker7503)\"\n       d=\"m 17.784077,21.510075 c 0.455681,-0.82966 0.455681,-1.65932 0,-2.90381 -0.45568,-1.244491 -0.45568,-2.074151 0,-2.903811\" />", "#00A0A0")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype.productPrefix__T = (function() {
  return "extractor"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype.hashCode__I = (function() {
  return (-252850652)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype.toString__T = (function() {
  return "extractor"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$extractor$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$extractor$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$extractor$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$extractor$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "Frigo", "<rect\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect8891\"\n       width=\"13\"\n       height=\"6\"\n       x=\"5.5\"\n       y=\"1.5\" />\n    <rect\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:0.99999994;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect8891-9\"\n       width=\"13\"\n       height=\"15\"\n       x=\"5.5\"\n       y=\"7.5\" />\n    <rect\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect8908\"\n       width=\"1\"\n       height=\"2\"\n       x=\"7\"\n       y=\"4\" />\n    <rect\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect8910\"\n       width=\"1\"\n       height=\"3\"\n       x=\"7\"\n       y=\"10\" />", "#00A0A0")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype.productPrefix__T = (function() {
  return "fridge"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype.hashCode__I = (function() {
  return (-1266285051)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype.toString__T = (function() {
  return "fridge"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$fridge$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$fridge$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$fridge$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$fridge$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "PAC", $m_Lreactbuild_project_generator_electricalboard_model_Icon$heater$().Lreactbuild_project_generator_electricalboard_model_Icon__f_svg, "#00A000")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype.productPrefix__T = (function() {
  return "heatPump"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype.hashCode__I = (function() {
  return (-1101105032)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype.toString__T = (function() {
  return "heatPump"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$heatPump$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$heatPump$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "convecteur", "<rect\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect1779\"\n       width=\"21\"\n       height=\"13\"\n       x=\"1.5\"\n       y=\"9.4999533\"\n       rx=\"1.9090909\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 2,11.5 H 22\"\n       id=\"path1781\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 2,13.5 H 22\"\n       id=\"path1783\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"\n       d=\"m 12,1 c 0.549238,1 0.549238,2 0,3.5 C 11.450762,6 11.450762,7 12,8\" />\n    <path\n       style=\"display:inline;fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"\n       d=\"M 9,1 C 9.549238,2 9.549238,3 9,4.5 8.450762,6 8.450762,7 9,8\" />\n    <path\n       style=\"display:inline;fill:none;fill-rule:evenodd;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"\n       d=\"m 15,1 c 0.549238,1 0.549238,2 0,3.5 C 14.450762,6 14.450762,7 15,8\" />", "#FF0000")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$heater$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype.productPrefix__T = (function() {
  return "heater"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype.hashCode__I = (function() {
  return (-1221255523)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype.toString__T = (function() {
  return "heater"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$heater$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$heater$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$heater$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$heater$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$heater$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$heater$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$heater$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$heater$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$heater$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$heater$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$heater$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "Cuisson", "<rect\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect1813\"\n       width=\"21\"\n       height=\"21\"\n       x=\"1.5\"\n       y=\"1.5\" />\n    <circle\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"path1815\"\n       cx=\"6\"\n       cy=\"6\"\n       r=\"2.5\" />\n    <circle\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:0.99999988;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"path1815-1\"\n       cx=\"7\"\n       cy=\"17\"\n       r=\"3.5\" />\n    <circle\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:0.99999988;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"path1815-1-4\"\n       cx=\"15.5\"\n       cy=\"9.5\"\n       r=\"5\" />", "#00A0A0")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype.productPrefix__T = (function() {
  return "hotplate"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype.hashCode__I = (function() {
  return (-274927895)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype.toString__T = (function() {
  return "hotplate"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$hotplate$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$hotplate$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$light$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "Lumi\u00e8re", "<path\n       style=\"fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 8.8671875,15.841797 C 8.9473954,16.37057 9,16.918873 9,17.5 c 0,2.209139 1.265948,5 3,5 1.734052,0 3,-2.790861 3,-5 0,-0.581127 0.0526,-1.12943 0.132812,-1.658203 z\" />\n    <path\n       style=\"display:inline;opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       d=\"m 12,22.5 c 0,0 -3,0 -3,-4.384615 C 9,13.96056 6.5,11.257136 6.5,8.8589743 6.5,5.8992945 8.9624339,3.5 12,3.5 c 3.037566,0 5.5,2.3992945 5.5,5.3589743 C 17.5,11.257136 15,13.96056 15,18.115385 15,22.5 12,22.5 12,22.5 Z\"\n       id=\"path1850-0-5\" />\n    <path\n       style=\"display:inline;opacity:1;fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 4.368272,1.5753788 6.4895924,3.6966991\"\n       id=\"path2134-5-4\" />\n    <path\n       style=\"display:inline;opacity:1;fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"m 19.631728,1.5753788 -2.12132,2.1213203\"\n       id=\"path2134-5-0\" />\n    <path\n       style=\"display:inline;opacity:1;fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"m 1.5,9.5 h 3\"\n       id=\"path2134-5-5\" />\n    <path\n       style=\"display:inline;opacity:1;fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"m 22.5,9.5 h -3\"\n       id=\"path2134-5-3\" />", "#00A000")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$light$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$light$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype.productPrefix__T = (function() {
  return "light"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype.hashCode__I = (function() {
  return 102970646
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype.toString__T = (function() {
  return "light"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$light$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$light$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$light$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$light$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$light$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$light$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$light$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$light$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$light$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$light$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$light$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$light$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "VMC", "<circle\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:0.99999988;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"path2262\"\n       cx=\"12\"\n       cy=\"12\"\n       r=\"10.5\" />\n    <path\n       style=\"fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"m 12.717737,12.330517 c 0.531249,-0.578148 6.410033,-1.534042 7.814842,0.995558 1.40481,2.529601 -4.542346,7.276006 -5.957464,5.098258 -1.415118,-2.177748 -2.388627,-5.515668 -1.857378,-6.093816 z\" />\n    <path\n       style=\"fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 11.927368,11.213163 C 11.161052,11.042162 7.3938318,6.4289326 8.8821251,3.9475323 10.370419,1.4661307 17.454504,4.2433164 16.276078,6.5577185 15.097652,8.8721206 12.693683,11.384164 11.927368,11.213163 Z\" />\n    <path\n       style=\"fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"m 11.354895,12.45632 c 0.235067,0.749149 -1.8764968,6.318272 -4.7695991,6.270073 -2.8931038,-0.0482 -4.0300331,-7.57179 -1.436489,-7.708444 2.5935441,-0.136655 5.9710221,0.689222 6.2060881,1.438371 z\" />\n    <circle\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:1;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       cx=\"12\"\n       cy=\"12\"\n       r=\"2.5\" />", "#00A000")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype.productPrefix__T = (function() {
  return "mechanicalVentilation"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype.hashCode__I = (function() {
  return 285975342
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype.toString__T = (function() {
  return "mechanicalVentilation"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$mechanicalVentilation$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$mechanicalVentilation$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "Four", "<rect\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:0.99999994;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect8837\"\n       width=\"21\"\n       height=\"17\"\n       x=\"1.5\"\n       y=\"3.5\" />\n    <rect\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect8837-8\"\n       width=\"17\"\n       height=\"11\"\n       x=\"3.5\"\n       y=\"7.5\" />\n    <rect\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect8857\"\n       width=\"4\"\n       height=\"1\"\n       x=\"13\"\n       y=\"5\" />\n    <rect\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect8857-1\"\n       width=\"4\"\n       height=\"1\"\n       x=\"7\"\n       y=\"5\" />\n    <rect\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect8857-5\"\n       width=\"16\"\n       height=\"1\"\n       x=\"4\"\n       y=\"9\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 5,16.5 H 19.000001\"\n       id=\"path8889\" />", "#00A0A0")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$oven$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype.productPrefix__T = (function() {
  return "oven"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype.hashCode__I = (function() {
  return 3423440
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype.toString__T = (function() {
  return "oven"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$oven$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$oven$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$oven$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$oven$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$oven$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$oven$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$oven$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$oven$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$oven$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$oven$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$oven$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$power$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "PC", "<circle\n       r=\"10.5\"\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"path1249\"\n       cx=\"12\"\n       cy=\"11.999953\" />\n    <path\n       id=\"path1759\"\n       d=\"M 13.5,7 A 1.5,1.5 0 0 1 12,8.5 1.5,1.5 0 0 1 10.5,7 1.5,1.5 0 0 1 12,5.5 1.5,1.5 0 0 1 13.5,7 Z\"\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\" />\n    <path\n       id=\"path1757\"\n       d=\"M 18.5,12 A 1.5,1.5 0 0 1 17,13.5 1.5,1.5 0 0 1 15.5,12 1.5,1.5 0 0 1 17,10.5 1.5,1.5 0 0 1 18.5,12 Z\"\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\" />\n    <path\n       id=\"path1228-5-3\"\n       d=\"M 8.5,12 A 1.5,1.5 0 0 1 7,13.5 1.5,1.5 0 0 1 5.5,12 1.5,1.5 0 0 1 7,10.5 1.5,1.5 0 0 1 8.5,12 Z\"\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\" />", ($m_Lreactbuild_project_generator_electricalboard_model_Icon$(), "#000"))
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$power$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$power$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype.productPrefix__T = (function() {
  return "power"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype.hashCode__I = (function() {
  return 106858757
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype.toString__T = (function() {
  return "power"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$power$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$power$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$power$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$power$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$power$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$power$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$power$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$power$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$power$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$power$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$power$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$power$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "T\u00e9l\u00e9rupteur", $m_Lreactbuild_project_generator_electricalboard_model_Icon$light$().Lreactbuild_project_generator_electricalboard_model_Icon__f_svg, $m_Lreactbuild_project_generator_electricalboard_model_Icon$light$().Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor)
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype.productPrefix__T = (function() {
  return "remoteSwitch"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype.hashCode__I = (function() {
  return (-41562342)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype.toString__T = (function() {
  return "remoteSwitch"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$remoteSwitch$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$remoteSwitch$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "VR", "<defs>\n      <marker\n         style=\"overflow:visible\"\n         id=\"marker3956\"\n         refX=\"0.0\"\n         refY=\"0.0\"\n         orient=\"auto\">\n        <path\n           transform=\"scale(0.2)\"\n           style=\"fill-rule:evenodd;stroke-width:1pt;stroke-opacity:1;fill-opacity:1\"\n           d=\"M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z \"\n           id=\"path3954\" />\n      </marker>\n    </defs>\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"\n       d=\"M 12,22 V 2\"\n       id=\"path2391\" />\n    <rect\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect2342\"\n       width=\"21\"\n       height=\"21\"\n       x=\"1.5\"\n       y=\"1.5\" />\n    <rect\n       style=\"opacity:1;fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       width=\"21\"\n       height=\"15\"\n       x=\"1.5\"\n       y=\"1.5\" />\n    <g\n       transform=\"translate(0,1.5795)\">\n      <path\n         d=\"M 8,3 V 9\"\n         style=\"fill:none;fill-rule:evenodd;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;marker-end:url(#marker3956)\" />\n      <path\n         d=\"M 16,11.841 V 5.8409999\"\n         style=\"fill:none;fill-rule:evenodd;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;marker-end:url(#marker3956)\" />\n    </g>", "#00A000")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype.productPrefix__T = (function() {
  return "rollerBlind"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype.hashCode__I = (function() {
  return 1052770187
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype.toString__T = (function() {
  return "rollerBlind"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$rollerBlind$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$rollerBlind$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "D\u00e9lesteur", ($m_Lreactbuild_project_generator_electricalboard_model_Icon$(), ""), ($m_Lreactbuild_project_generator_electricalboard_model_Icon$(), "#000"))
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype.productPrefix__T = (function() {
  return "selectivePowerCut"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype.hashCode__I = (function() {
  return 1522852217
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype.toString__T = (function() {
  return "selectivePowerCut"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$selectivePowerCut$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$selectivePowerCut$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$() {
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_label = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_svg = null;
  this.Lreactbuild_project_generator_electricalboard_model_Icon__f_mainColor = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_Icon__T__T__T__(this, "LL", "<path\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.99999988;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       d=\"m 7.5097656,13.816406 c -0.0025,0.04034 -0.00445,0.08071 -0.00586,0.121094 l 0.011719,0.40625 C 7.6952142,16.687876 9.649005,18.498706 12,18.5 c 2.485281,0 4.5,-2.014719 4.5,-4.5 -7.3e-4,-0.06058 -0.0027,-0.12114 -0.0059,-0.181641 C 15,12 14,16 12,13.822266 10,11.644532 9,12 7.5097656,13.816406 Z\" />\n    <rect\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect4075\"\n       width=\"17\"\n       height=\"21\"\n       x=\"3.5\"\n       y=\"1.5\" />\n    <path\n       style=\"fill:none;fill-rule:evenodd;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1\"\n       d=\"M 3,5.5 H 21\"\n       id=\"path4077\" />\n    <circle\n       style=\"opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:0.99999988;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"path4111\"\n       cx=\"12\"\n       cy=\"14\"\n       r=\"4.5\" />\n    <rect\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect4132\"\n       width=\"2\"\n       height=\"1\"\n       x=\"17\"\n       y=\"3\" />\n    <rect\n       style=\"opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:normal\"\n       id=\"rect4134\"\n       width=\"1\"\n       height=\"1\"\n       x=\"14\"\n       y=\"3\" />", "#0000A0")
}
$c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_Icon();
$c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Icon$washer$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype.productPrefix__T = (function() {
  return "washer"
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype.hashCode__I = (function() {
  return (-794987636)
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype.toString__T = (function() {
  return "washer"
});
var $d_Lreactbuild_project_generator_electricalboard_model_Icon$washer$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Icon$washer$: 0
}, false, "reactbuild.project.generator.electricalboard.model.Icon$washer$", {
  Lreactbuild_project_generator_electricalboard_model_Icon$washer$: 1,
  Lreactbuild_project_generator_electricalboard_model_Icon: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Icon$washer$;
var $n_Lreactbuild_project_generator_electricalboard_model_Icon$washer$;
function $m_Lreactbuild_project_generator_electricalboard_model_Icon$washer$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_Icon$washer$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_Icon$washer$ = new $c_Lreactbuild_project_generator_electricalboard_model_Icon$washer$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_Icon$washer$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1(outer, source$1) {
  this.Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1__f_source$1 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1__f_source$1 = source$1
}
$c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1.prototype.applyOrElse__Lreactbuild_project_generator_electricalboard_model_Cell__F1__O = (function(x1, default$1) {
  var x = $n(x1).Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
  var x$2 = this.Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1__f_source$1;
  if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
    return x1
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1.prototype.isDefinedAt__Lreactbuild_project_generator_electricalboard_model_Cell__Z = (function(x1) {
  var x = $n(x1).Lreactbuild_project_generator_electricalboard_model_Cell__f_id;
  var x$2 = this.Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1__f_source$1;
  return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_project_generator_electricalboard_model_Cell__Z($as_Lreactbuild_project_generator_electricalboard_model_Cell(x))
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_project_generator_electricalboard_model_Cell__F1__O($as_Lreactbuild_project_generator_electricalboard_model_Cell(x), default$1)
});
var $d_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.Table$$anonfun$$nestedInanonfun$move$5$1", {
  Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Table$$anonfun$$nestedInanonfun$move$5$1;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$() {
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_colors = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_keycode = 0;
  $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$ = this;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_mainOrder = 3;
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array = ["#FFFF00", "#00FF00"];
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_colors = $as_sci_Seq($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_keycode = 84
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.mainOrder__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_mainOrder
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.colors__sci_Seq = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_colors
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.order__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_order
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.keycode__I = (function() {
  return this.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$__f_keycode
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.productPrefix__T = (function() {
  return "Ground"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.hashCode__I = (function() {
  return 2141373863
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.toString__T = (function() {
  return "Ground"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$Ground$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$Ground$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$Ground$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$
}
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_Header(level, body) {
  this.Lreactbuild_project_generator_markdown_Header__f_level = 0;
  this.Lreactbuild_project_generator_markdown_Header__f_body = null;
  this.Lreactbuild_project_generator_markdown_Header__f_level = level;
  this.Lreactbuild_project_generator_markdown_Header__f_body = body
}
$c_Lreactbuild_project_generator_markdown_Header.prototype = new $h_O();
$c_Lreactbuild_project_generator_markdown_Header.prototype.constructor = $c_Lreactbuild_project_generator_markdown_Header;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_Header() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_Header.prototype = $c_Lreactbuild_project_generator_markdown_Header.prototype;
$c_Lreactbuild_project_generator_markdown_Header.prototype.productPrefix__T = (function() {
  return "Header"
});
$c_Lreactbuild_project_generator_markdown_Header.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_generator_markdown_Header.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_markdown_Header__f_level;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_markdown_Header__f_body;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_markdown_Header.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_markdown_Header.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Header");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_project_generator_markdown_Header__f_level;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_project_generator_markdown_Header__f_body;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_project_generator_markdown_Header.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_markdown_Header.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_markdown_Header)) {
    var Header$1 = $as_Lreactbuild_project_generator_markdown_Header(x$1);
    if ((this.Lreactbuild_project_generator_markdown_Header__f_level === $n(Header$1).Lreactbuild_project_generator_markdown_Header__f_level)) {
      var x = this.Lreactbuild_project_generator_markdown_Header__f_body;
      var x$2 = $n(Header$1).Lreactbuild_project_generator_markdown_Header__f_body;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_markdown_Header(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_markdown_Header) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.markdown.Header"))
}
function $isArrayOf_Lreactbuild_project_generator_markdown_Header(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_markdown_Header)))
}
function $asArrayOf_Lreactbuild_project_generator_markdown_Header(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_markdown_Header(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.markdown.Header;", depth))
}
var $d_Lreactbuild_project_generator_markdown_Header = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_Header: 0
}, false, "reactbuild.project.generator.markdown.Header", {
  Lreactbuild_project_generator_markdown_Header: 1,
  O: 1,
  Lreactbuild_project_generator_markdown_MarkdownBlock: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_Header.prototype.$classData = $d_Lreactbuild_project_generator_markdown_Header;
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1.prototype.constructor = $c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1.prototype = $c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1.prototype;
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1.prototype.applyOrElse__Lreactbuild_project_generator_markdown_MarkdownBlock__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_Lreactbuild_project_generator_markdown_OL)) {
    var x2 = $as_Lreactbuild_project_generator_markdown_OL(x1);
    var body = $n(x2).Lreactbuild_project_generator_markdown_OL__f_body;
    return body
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1.prototype.isDefinedAt__Lreactbuild_project_generator_markdown_MarkdownBlock__Z = (function(x1) {
  return (x1 instanceof $c_Lreactbuild_project_generator_markdown_OL)
});
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_project_generator_markdown_MarkdownBlock__Z($as_Lreactbuild_project_generator_markdown_MarkdownBlock(x))
});
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_project_generator_markdown_MarkdownBlock__F1__O($as_Lreactbuild_project_generator_markdown_MarkdownBlock(x), default$1)
});
var $d_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1: 0
}, false, "reactbuild.project.generator.markdown.MarkdownRender$$anonfun$1", {
  Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1.prototype.$classData = $d_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$1;
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2() {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2.prototype.constructor = $c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2.prototype = $c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2.prototype;
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2.prototype.applyOrElse__Lreactbuild_project_generator_markdown_MarkdownBlock__F1__O = (function(x2, default$1) {
  if ((x2 instanceof $c_Lreactbuild_project_generator_markdown_UL)) {
    var x2$2 = $as_Lreactbuild_project_generator_markdown_UL(x2);
    var body = $n(x2$2).Lreactbuild_project_generator_markdown_UL__f_body;
    return body
  } else {
    return $n(default$1).apply__O__O(x2)
  }
});
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2.prototype.isDefinedAt__Lreactbuild_project_generator_markdown_MarkdownBlock__Z = (function(x2) {
  return (x2 instanceof $c_Lreactbuild_project_generator_markdown_UL)
});
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_project_generator_markdown_MarkdownBlock__Z($as_Lreactbuild_project_generator_markdown_MarkdownBlock(x))
});
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_project_generator_markdown_MarkdownBlock__F1__O($as_Lreactbuild_project_generator_markdown_MarkdownBlock(x), default$1)
});
var $d_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2 = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2: 0
}, false, "reactbuild.project.generator.markdown.MarkdownRender$$anonfun$2", {
  Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2.prototype.$classData = $d_Lreactbuild_project_generator_markdown_MarkdownRender$$anonfun$2;
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_OL(level, body) {
  this.Lreactbuild_project_generator_markdown_OL__f_level = 0;
  this.Lreactbuild_project_generator_markdown_OL__f_body = null;
  this.Lreactbuild_project_generator_markdown_OL__f_level = level;
  this.Lreactbuild_project_generator_markdown_OL__f_body = body
}
$c_Lreactbuild_project_generator_markdown_OL.prototype = new $h_O();
$c_Lreactbuild_project_generator_markdown_OL.prototype.constructor = $c_Lreactbuild_project_generator_markdown_OL;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_OL() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_OL.prototype = $c_Lreactbuild_project_generator_markdown_OL.prototype;
$c_Lreactbuild_project_generator_markdown_OL.prototype.productPrefix__T = (function() {
  return "OL"
});
$c_Lreactbuild_project_generator_markdown_OL.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_generator_markdown_OL.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_markdown_OL__f_level;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_markdown_OL__f_body;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_markdown_OL.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_markdown_OL.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("OL");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_project_generator_markdown_OL__f_level;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_project_generator_markdown_OL__f_body;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_project_generator_markdown_OL.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_markdown_OL.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_markdown_OL)) {
    var OL$1 = $as_Lreactbuild_project_generator_markdown_OL(x$1);
    if ((this.Lreactbuild_project_generator_markdown_OL__f_level === $n(OL$1).Lreactbuild_project_generator_markdown_OL__f_level)) {
      var x = this.Lreactbuild_project_generator_markdown_OL__f_body;
      var x$2 = $n(OL$1).Lreactbuild_project_generator_markdown_OL__f_body;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_markdown_OL(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_markdown_OL) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.markdown.OL"))
}
function $isArrayOf_Lreactbuild_project_generator_markdown_OL(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_markdown_OL)))
}
function $asArrayOf_Lreactbuild_project_generator_markdown_OL(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_markdown_OL(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.markdown.OL;", depth))
}
var $d_Lreactbuild_project_generator_markdown_OL = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_OL: 0
}, false, "reactbuild.project.generator.markdown.OL", {
  Lreactbuild_project_generator_markdown_OL: 1,
  O: 1,
  Lreactbuild_project_generator_markdown_MarkdownBlock: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_OL.prototype.$classData = $d_Lreactbuild_project_generator_markdown_OL;
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_Paragraph(lines) {
  this.Lreactbuild_project_generator_markdown_Paragraph__f_lines = null;
  this.Lreactbuild_project_generator_markdown_Paragraph__f_lines = lines
}
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype = new $h_O();
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype.constructor = $c_Lreactbuild_project_generator_markdown_Paragraph;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_Paragraph() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_Paragraph.prototype = $c_Lreactbuild_project_generator_markdown_Paragraph.prototype;
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype.productPrefix__T = (function() {
  return "Paragraph"
});
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_generator_markdown_Paragraph__f_lines : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_markdown_Paragraph)) {
    var Paragraph$1 = $as_Lreactbuild_project_generator_markdown_Paragraph(x$1);
    var x = this.Lreactbuild_project_generator_markdown_Paragraph__f_lines;
    var x$2 = $n(Paragraph$1).Lreactbuild_project_generator_markdown_Paragraph__f_lines;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_markdown_Paragraph(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_markdown_Paragraph) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.markdown.Paragraph"))
}
function $isArrayOf_Lreactbuild_project_generator_markdown_Paragraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_markdown_Paragraph)))
}
function $asArrayOf_Lreactbuild_project_generator_markdown_Paragraph(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_markdown_Paragraph(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.markdown.Paragraph;", depth))
}
var $d_Lreactbuild_project_generator_markdown_Paragraph = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_Paragraph: 0
}, false, "reactbuild.project.generator.markdown.Paragraph", {
  Lreactbuild_project_generator_markdown_Paragraph: 1,
  O: 1,
  Lreactbuild_project_generator_markdown_MarkdownBlock: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_Paragraph.prototype.$classData = $d_Lreactbuild_project_generator_markdown_Paragraph;
/** @constructor */
function $c_Lreactbuild_project_generator_markdown_UL(level, body) {
  this.Lreactbuild_project_generator_markdown_UL__f_level = 0;
  this.Lreactbuild_project_generator_markdown_UL__f_body = null;
  this.Lreactbuild_project_generator_markdown_UL__f_level = level;
  this.Lreactbuild_project_generator_markdown_UL__f_body = body
}
$c_Lreactbuild_project_generator_markdown_UL.prototype = new $h_O();
$c_Lreactbuild_project_generator_markdown_UL.prototype.constructor = $c_Lreactbuild_project_generator_markdown_UL;
/** @constructor */
function $h_Lreactbuild_project_generator_markdown_UL() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_markdown_UL.prototype = $c_Lreactbuild_project_generator_markdown_UL.prototype;
$c_Lreactbuild_project_generator_markdown_UL.prototype.productPrefix__T = (function() {
  return "UL"
});
$c_Lreactbuild_project_generator_markdown_UL.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_generator_markdown_UL.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_generator_markdown_UL__f_level;
      break
    }
    case 1: {
      return this.Lreactbuild_project_generator_markdown_UL__f_body;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_generator_markdown_UL.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_markdown_UL.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("UL");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_project_generator_markdown_UL__f_level;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_project_generator_markdown_UL__f_body;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_project_generator_markdown_UL.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_generator_markdown_UL.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_generator_markdown_UL)) {
    var UL$1 = $as_Lreactbuild_project_generator_markdown_UL(x$1);
    if ((this.Lreactbuild_project_generator_markdown_UL__f_level === $n(UL$1).Lreactbuild_project_generator_markdown_UL__f_level)) {
      var x = this.Lreactbuild_project_generator_markdown_UL__f_body;
      var x$2 = $n(UL$1).Lreactbuild_project_generator_markdown_UL__f_body;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_generator_markdown_UL(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_markdown_UL) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.markdown.UL"))
}
function $isArrayOf_Lreactbuild_project_generator_markdown_UL(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_markdown_UL)))
}
function $asArrayOf_Lreactbuild_project_generator_markdown_UL(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_markdown_UL(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.markdown.UL;", depth))
}
var $d_Lreactbuild_project_generator_markdown_UL = new $TypeData().initClass({
  Lreactbuild_project_generator_markdown_UL: 0
}, false, "reactbuild.project.generator.markdown.UL", {
  Lreactbuild_project_generator_markdown_UL: 1,
  O: 1,
  Lreactbuild_project_generator_markdown_MarkdownBlock: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_markdown_UL.prototype.$classData = $d_Lreactbuild_project_generator_markdown_UL;
/** @constructor */
function $c_Lreactbuild_project_notebook_MapLayer$Elevation$() {
  /*<skip>*/
}
$c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype.constructor = $c_Lreactbuild_project_notebook_MapLayer$Elevation$;
/** @constructor */
function $h_Lreactbuild_project_notebook_MapLayer$Elevation$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype = $c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype;
$c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype.productPrefix__T = (function() {
  return "Elevation"
});
$c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype.hashCode__I = (function() {
  return 1999588925
});
$c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype.toString__T = (function() {
  return "Elevation"
});
var $d_Lreactbuild_project_notebook_MapLayer$Elevation$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_MapLayer$Elevation$: 0
}, false, "reactbuild.project.notebook.MapLayer$Elevation$", {
  Lreactbuild_project_notebook_MapLayer$Elevation$: 1,
  O: 1,
  Lreactbuild_project_notebook_MapLayer: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_MapLayer$Elevation$.prototype.$classData = $d_Lreactbuild_project_notebook_MapLayer$Elevation$;
var $n_Lreactbuild_project_notebook_MapLayer$Elevation$;
function $m_Lreactbuild_project_notebook_MapLayer$Elevation$() {
  if ((!$n_Lreactbuild_project_notebook_MapLayer$Elevation$)) {
    $n_Lreactbuild_project_notebook_MapLayer$Elevation$ = new $c_Lreactbuild_project_notebook_MapLayer$Elevation$()
  };
  return $n_Lreactbuild_project_notebook_MapLayer$Elevation$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1() {
  /*<skip>*/
}
$c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1.prototype.constructor = $c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1;
/** @constructor */
function $h_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1.prototype = $c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1.prototype;
$c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1.prototype.applyOrElse__Lreactbuild_project_notebook_CellConfig__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_Lreactbuild_project_notebook_Title)) {
    var x2 = $as_Lreactbuild_project_notebook_Title(x1);
    var id = $n(x2).Lreactbuild_project_notebook_Title__f_id;
    var title = $n(x2).Lreactbuild_project_notebook_Title__f_title;
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var u = $m_Lreactbuild_project_notebook_NotebookLink$().apply__ju_UUID__T__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(id, title);
    var this$4 = $n(u);
    var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    return $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  } else {
    return $n(default$1).apply__O__O(x1)
  }
});
$c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1.prototype.isDefinedAt__Lreactbuild_project_notebook_CellConfig__Z = (function(x1) {
  return (x1 instanceof $c_Lreactbuild_project_notebook_Title)
});
$c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lreactbuild_project_notebook_CellConfig__Z($as_Lreactbuild_project_notebook_CellConfig(x))
});
$c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lreactbuild_project_notebook_CellConfig__F1__O($as_Lreactbuild_project_notebook_CellConfig(x), default$1)
});
var $d_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1 = new $TypeData().initClass({
  Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1: 0
}, false, "reactbuild.project.notebook.Notebook$$anonfun$$nestedInanonfun$component$6$1", {
  Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1.prototype.$classData = $d_Lreactbuild_project_notebook_Notebook$$anonfun$$nestedInanonfun$component$6$1;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$() {
  $ct_Lreactbuild_task_TaskScheduler$AllocatablePeriodType__D__(this, 0.9)
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype = new $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype.productPrefix__T = (function() {
  return "Administrative"
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype.hashCode__I = (function() {
  return 253709646
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype.toString__T = (function() {
  return "Administrative"
});
function $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$AllocatablePeriodType$Administrative$"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$AllocatablePeriodType$Administrative$;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriodType$Administrative$", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$: 1,
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$;
var $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$;
function $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$)) {
    $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$ = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$()
  };
  return $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$() {
  $ct_Lreactbuild_task_TaskScheduler$AllocatablePeriodType__D__(this, 0.6)
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype = new $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype.productPrefix__T = (function() {
  return "Craftwork"
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype.hashCode__I = (function() {
  return (-803981039)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype.toString__T = (function() {
  return "Craftwork"
});
function $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$AllocatablePeriodType$Craftwork$"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$AllocatablePeriodType$Craftwork$;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriodType$Craftwork$", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$: 1,
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$;
var $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$;
function $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$)) {
    $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$ = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$()
  };
  return $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$() {
  $ct_Lreactbuild_task_TaskScheduler$AllocatablePeriodType__D__(this, 0.5)
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype = new $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype.productPrefix__T = (function() {
  return "Dev"
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype.hashCode__I = (function() {
  return 68597
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype.toString__T = (function() {
  return "Dev"
});
function $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$AllocatablePeriodType$Dev$"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$AllocatablePeriodType$Dev$;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriodType$Dev$", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$: 1,
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$;
var $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$;
function $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$)) {
    $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$ = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$()
  };
  return $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$() {
  $ct_Lreactbuild_task_TaskScheduler$AllocatablePeriodType__D__(this, 0.5)
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype = new $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype.productPrefix__T = (function() {
  return "Draw"
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype.hashCode__I = (function() {
  return 2138468
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype.toString__T = (function() {
  return "Draw"
});
function $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$AllocatablePeriodType$Draw$"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$AllocatablePeriodType$Draw$;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$ = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriodType$Draw$", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$: 1,
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$;
var $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$;
function $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$() {
  if ((!$n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$)) {
    $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$ = new $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$()
  };
  return $n_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$
}
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free(tpe) {
  this.Lreactbuild_task_TaskScheduler$PeriodDetails$Free__f_tpe = null;
  this.Lreactbuild_task_TaskScheduler$PeriodDetails$Free__f_tpe = tpe
}
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$PeriodDetails$Free() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype = $c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype;
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.isFree__Lreactbuild_task_TaskScheduler$AllocatablePeriodType__Z = (function(tpe) {
  var x$2 = this.Lreactbuild_task_TaskScheduler$PeriodDetails$Free__f_tpe;
  if ((tpe === null)) {
    return (x$2 === null)
  } else {
    var this$1 = $n(tpe);
    return (this$1 === x$2)
  }
});
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.productPrefix__T = (function() {
  return "Free"
});
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_task_TaskScheduler$PeriodDetails$Free__f_tpe : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free)) {
    var Free$1 = $as_Lreactbuild_task_TaskScheduler$PeriodDetails$Free(x$1);
    var x = this.Lreactbuild_task_TaskScheduler$PeriodDetails$Free__f_tpe;
    var x$2 = $n(Free$1).Lreactbuild_task_TaskScheduler$PeriodDetails$Free__f_tpe;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_task_TaskScheduler$PeriodDetails$Free(obj) {
  return (((obj instanceof $c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.task.TaskScheduler$PeriodDetails$Free"))
}
function $isArrayOf_Lreactbuild_task_TaskScheduler$PeriodDetails$Free(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_task_TaskScheduler$PeriodDetails$Free)))
}
function $asArrayOf_Lreactbuild_task_TaskScheduler$PeriodDetails$Free(obj, depth) {
  return (($isArrayOf_Lreactbuild_task_TaskScheduler$PeriodDetails$Free(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.task.TaskScheduler$PeriodDetails$Free;", depth))
}
var $d_Lreactbuild_task_TaskScheduler$PeriodDetails$Free = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$PeriodDetails$Free: 0
}, false, "reactbuild.task.TaskScheduler$PeriodDetails$Free", {
  Lreactbuild_task_TaskScheduler$PeriodDetails$Free: 1,
  O: 1,
  Lreactbuild_task_TaskScheduler$PeriodDetails: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$PeriodDetails$Free.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$PeriodDetails$Free;
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
  /*<skip>*/
}
$c_s_$less$colon$less$$anon$1.prototype = new $h_s_$eq$colon$eq();
$c_s_$less$colon$less$$anon$1.prototype.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
  /*<skip>*/
}
$h_s_$less$colon$less$$anon$1.prototype = $c_s_$less$colon$less$$anon$1.prototype;
$c_s_$less$colon$less$$anon$1.prototype.apply__O__O = (function(x) {
  return x
});
$c_s_$less$colon$less$$anon$1.prototype.compose__F1__F1 = (function(r) {
  return r
});
$c_s_$less$colon$less$$anon$1.prototype.andThen__F1__F1 = (function(r) {
  return r
});
$c_s_$less$colon$less$$anon$1.prototype.toString__T = (function() {
  return "generalized constraint"
});
var $d_s_$less$colon$less$$anon$1 = new $TypeData().initClass({
  s_$less$colon$less$$anon$1: 0
}, false, "scala.$less$colon$less$$anon$1", {
  s_$less$colon$less$$anon$1: 1,
  s_$eq$colon$eq: 1,
  s_$less$colon$less: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_$less$colon$less$$anon$1.prototype.$classData = $d_s_$less$colon$less$$anon$1;
function $p_s_MatchError__objString$lzycompute__T($thiz) {
  if ((!$thiz.s_MatchError__f_bitmap$0)) {
    $thiz.s_MatchError__f_objString = (($thiz.s_MatchError__f_obj === null) ? "null" : $p_s_MatchError__liftedTree1$1__T($thiz));
    $thiz.s_MatchError__f_bitmap$0 = true
  };
  return $thiz.s_MatchError__f_objString
}
function $p_s_MatchError__objString__T($thiz) {
  return ((!$thiz.s_MatchError__f_bitmap$0) ? $p_s_MatchError__objString$lzycompute__T($thiz) : $thiz.s_MatchError__f_objString)
}
function $p_s_MatchError__ofClass$1__T($thiz) {
  var this$1 = $n($thiz.s_MatchError__f_obj);
  return ("of class " + $n($objectGetClass(this$1)).getName__T())
}
function $p_s_MatchError__liftedTree1$1__T($thiz) {
  try {
    return ((($thiz.s_MatchError__f_obj + " (") + $p_s_MatchError__ofClass$1__T($thiz)) + ")")
  } catch (e) {
    return ("an instance " + $p_s_MatchError__ofClass$1__T($thiz))
  }
}
class $c_s_MatchError extends $c_jl_RuntimeException {
  constructor(obj) {
    super();
    this.s_MatchError__f_objString = null;
    this.s_MatchError__f_obj = null;
    this.s_MatchError__f_bitmap$0 = false;
    this.s_MatchError__f_obj = obj;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    return $p_s_MatchError__objString__T(this)
  };
}
var $d_s_MatchError = new $TypeData().initClass({
  s_MatchError: 0
}, false, "scala.MatchError", {
  s_MatchError: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_MatchError.prototype.$classData = $d_s_MatchError;
/** @constructor */
function $c_s_Option() {
  /*<skip>*/
}
$c_s_Option.prototype = new $h_O();
$c_s_Option.prototype.constructor = $c_s_Option;
/** @constructor */
function $h_s_Option() {
  /*<skip>*/
}
$h_s_Option.prototype = $c_s_Option.prototype;
$c_s_Option.prototype.isEmpty__Z = (function() {
  return (this === $m_s_None$())
});
$c_s_Option.prototype.knownSize__I = (function() {
  return (this.isEmpty__Z() ? 0 : 1)
});
$c_s_Option.prototype.flatten__s_$less$colon$less__s_Option = (function(ev) {
  if (this.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    $n(ev);
    var x = this.get__O();
    return $as_s_Option(x)
  }
});
$c_s_Option.prototype.contains__O__Z = (function(elem) {
  return ((!this.isEmpty__Z()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.get__O(), elem))
});
$c_s_Option.prototype.iterator__sc_Iterator = (function() {
  if (this.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  } else {
    $m_sc_Iterator$();
    var a = this.get__O();
    return new $c_sc_Iterator$$anon$20(a)
  }
});
$c_s_Option.prototype.toList__sci_List = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$() : new $c_sci_$colon$colon(this.get__O(), $m_s_package$().s_package$__f_Nil))
});
function $as_s_Option(obj) {
  return (((obj instanceof $c_s_Option) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Option"))
}
function $isArrayOf_s_Option(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Option)))
}
function $asArrayOf_s_Option(obj, depth) {
  return (($isArrayOf_s_Option(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Option;", depth))
}
/** @constructor */
function $c_s_PartialFunction$OrElse(f1, f2) {
  this.s_PartialFunction$OrElse__f_f1 = null;
  this.s_PartialFunction$OrElse__f_f2 = null;
  this.s_PartialFunction$OrElse__f_f1 = f1;
  this.s_PartialFunction$OrElse__f_f2 = f2
}
$c_s_PartialFunction$OrElse.prototype = new $h_sr_AbstractPartialFunction();
$c_s_PartialFunction$OrElse.prototype.constructor = $c_s_PartialFunction$OrElse;
/** @constructor */
function $h_s_PartialFunction$OrElse() {
  /*<skip>*/
}
$h_s_PartialFunction$OrElse.prototype = $c_s_PartialFunction$OrElse.prototype;
$c_s_PartialFunction$OrElse.prototype.isDefinedAt__O__Z = (function(x) {
  return ($n(this.s_PartialFunction$OrElse__f_f1).isDefinedAt__O__Z(x) || $n(this.s_PartialFunction$OrElse__f_f2).isDefinedAt__O__Z(x))
});
$c_s_PartialFunction$OrElse.prototype.apply__O__O = (function(x) {
  return $n(this.s_PartialFunction$OrElse__f_f1).applyOrElse__O__F1__O(x, this.s_PartialFunction$OrElse__f_f2)
});
$c_s_PartialFunction$OrElse.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var z = $n(this.s_PartialFunction$OrElse__f_f1).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? z : $n(this.s_PartialFunction$OrElse__f_f2).applyOrElse__O__F1__O(x, default$1))
});
$c_s_PartialFunction$OrElse.prototype.orElse__s_PartialFunction__s_PartialFunction$OrElse = (function(that) {
  return new $c_s_PartialFunction$OrElse(this.s_PartialFunction$OrElse__f_f1, $n(this.s_PartialFunction$OrElse__f_f2).orElse__s_PartialFunction__s_PartialFunction(that))
});
$c_s_PartialFunction$OrElse.prototype.andThen__F1__s_PartialFunction$OrElse = (function(k) {
  return new $c_s_PartialFunction$OrElse($n(this.s_PartialFunction$OrElse__f_f1).andThen__F1__s_PartialFunction(k), $n(this.s_PartialFunction$OrElse__f_f2).andThen__F1__s_PartialFunction(k))
});
$c_s_PartialFunction$OrElse.prototype.andThen__F1__F1 = (function(g) {
  return this.andThen__F1__s_PartialFunction$OrElse(g)
});
$c_s_PartialFunction$OrElse.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return this.andThen__F1__s_PartialFunction$OrElse(k)
});
$c_s_PartialFunction$OrElse.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return this.orElse__s_PartialFunction__s_PartialFunction$OrElse(that)
});
var $d_s_PartialFunction$OrElse = new $TypeData().initClass({
  s_PartialFunction$OrElse: 0
}, false, "scala.PartialFunction$OrElse", {
  s_PartialFunction$OrElse: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$OrElse.prototype.$classData = $d_s_PartialFunction$OrElse;
/** @constructor */
function $c_T10(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10) {
  this.T10__f__1 = null;
  this.T10__f__2 = null;
  this.T10__f__3 = null;
  this.T10__f__4 = null;
  this.T10__f__5 = null;
  this.T10__f__6 = null;
  this.T10__f__7 = null;
  this.T10__f__8 = null;
  this.T10__f__9 = null;
  this.T10__f__10 = null;
  this.T10__f__1 = _1;
  this.T10__f__2 = _2;
  this.T10__f__3 = _3;
  this.T10__f__4 = _4;
  this.T10__f__5 = _5;
  this.T10__f__6 = _6;
  this.T10__f__7 = _7;
  this.T10__f__8 = _8;
  this.T10__f__9 = _9;
  this.T10__f__10 = _10
}
$c_T10.prototype = new $h_O();
$c_T10.prototype.constructor = $c_T10;
/** @constructor */
function $h_T10() {
  /*<skip>*/
}
$h_T10.prototype = $c_T10.prototype;
$c_T10.prototype.productArity__I = (function() {
  return 10
});
$c_T10.prototype.productElement__I__O = (function(n) {
  return $f_s_Product10__productElement__I__O(this, n)
});
$c_T10.prototype.toString__T = (function() {
  return (((((((((((((((((((("(" + this.T10__f__1) + ",") + this.T10__f__2) + ",") + this.T10__f__3) + ",") + this.T10__f__4) + ",") + this.T10__f__5) + ",") + this.T10__f__6) + ",") + this.T10__f__7) + ",") + this.T10__f__8) + ",") + this.T10__f__9) + ",") + this.T10__f__10) + ")")
});
$c_T10.prototype.productPrefix__T = (function() {
  return "Tuple10"
});
$c_T10.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T10.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T10.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T10)) {
    var Tuple10$1 = $as_T10(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__1, $n(Tuple10$1).T10__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__2, $n(Tuple10$1).T10__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__3, $n(Tuple10$1).T10__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__4, $n(Tuple10$1).T10__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__5, $n(Tuple10$1).T10__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__6, $n(Tuple10$1).T10__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__7, $n(Tuple10$1).T10__f__7)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__8, $n(Tuple10$1).T10__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__9, $n(Tuple10$1).T10__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__10, $n(Tuple10$1).T10__f__10)))))
  } else {
    return false
  }
});
function $as_T10(obj) {
  return (((obj instanceof $c_T10) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple10"))
}
function $isArrayOf_T10(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T10)))
}
function $asArrayOf_T10(obj, depth) {
  return (($isArrayOf_T10(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple10;", depth))
}
var $d_T10 = new $TypeData().initClass({
  T10: 0
}, false, "scala.Tuple10", {
  T10: 1,
  O: 1,
  s_Product10: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T10.prototype.$classData = $d_T10;
/** @constructor */
function $c_T11(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11) {
  this.T11__f__1 = null;
  this.T11__f__2 = null;
  this.T11__f__3 = null;
  this.T11__f__4 = null;
  this.T11__f__5 = null;
  this.T11__f__6 = null;
  this.T11__f__7 = null;
  this.T11__f__8 = null;
  this.T11__f__9 = null;
  this.T11__f__10 = null;
  this.T11__f__11 = null;
  this.T11__f__1 = _1;
  this.T11__f__2 = _2;
  this.T11__f__3 = _3;
  this.T11__f__4 = _4;
  this.T11__f__5 = _5;
  this.T11__f__6 = _6;
  this.T11__f__7 = _7;
  this.T11__f__8 = _8;
  this.T11__f__9 = _9;
  this.T11__f__10 = _10;
  this.T11__f__11 = _11
}
$c_T11.prototype = new $h_O();
$c_T11.prototype.constructor = $c_T11;
/** @constructor */
function $h_T11() {
  /*<skip>*/
}
$h_T11.prototype = $c_T11.prototype;
$c_T11.prototype.productArity__I = (function() {
  return 11
});
$c_T11.prototype.productElement__I__O = (function(n) {
  return $f_s_Product11__productElement__I__O(this, n)
});
$c_T11.prototype.toString__T = (function() {
  return (((((((((((((((((((((("(" + this.T11__f__1) + ",") + this.T11__f__2) + ",") + this.T11__f__3) + ",") + this.T11__f__4) + ",") + this.T11__f__5) + ",") + this.T11__f__6) + ",") + this.T11__f__7) + ",") + this.T11__f__8) + ",") + this.T11__f__9) + ",") + this.T11__f__10) + ",") + this.T11__f__11) + ")")
});
$c_T11.prototype.productPrefix__T = (function() {
  return "Tuple11"
});
$c_T11.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T11.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T11.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T11)) {
    var Tuple11$1 = $as_T11(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__1, $n(Tuple11$1).T11__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__2, $n(Tuple11$1).T11__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__3, $n(Tuple11$1).T11__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__4, $n(Tuple11$1).T11__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__5, $n(Tuple11$1).T11__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__6, $n(Tuple11$1).T11__f__6) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__7, $n(Tuple11$1).T11__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__8, $n(Tuple11$1).T11__f__8))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__9, $n(Tuple11$1).T11__f__9) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__10, $n(Tuple11$1).T11__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__11, $n(Tuple11$1).T11__f__11)))))
  } else {
    return false
  }
});
function $as_T11(obj) {
  return (((obj instanceof $c_T11) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple11"))
}
function $isArrayOf_T11(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T11)))
}
function $asArrayOf_T11(obj, depth) {
  return (($isArrayOf_T11(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple11;", depth))
}
var $d_T11 = new $TypeData().initClass({
  T11: 0
}, false, "scala.Tuple11", {
  T11: 1,
  O: 1,
  s_Product11: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T11.prototype.$classData = $d_T11;
/** @constructor */
function $c_T12(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12) {
  this.T12__f__1 = null;
  this.T12__f__2 = null;
  this.T12__f__3 = null;
  this.T12__f__4 = null;
  this.T12__f__5 = null;
  this.T12__f__6 = null;
  this.T12__f__7 = null;
  this.T12__f__8 = null;
  this.T12__f__9 = null;
  this.T12__f__10 = null;
  this.T12__f__11 = null;
  this.T12__f__12 = null;
  this.T12__f__1 = _1;
  this.T12__f__2 = _2;
  this.T12__f__3 = _3;
  this.T12__f__4 = _4;
  this.T12__f__5 = _5;
  this.T12__f__6 = _6;
  this.T12__f__7 = _7;
  this.T12__f__8 = _8;
  this.T12__f__9 = _9;
  this.T12__f__10 = _10;
  this.T12__f__11 = _11;
  this.T12__f__12 = _12
}
$c_T12.prototype = new $h_O();
$c_T12.prototype.constructor = $c_T12;
/** @constructor */
function $h_T12() {
  /*<skip>*/
}
$h_T12.prototype = $c_T12.prototype;
$c_T12.prototype.productArity__I = (function() {
  return 12
});
$c_T12.prototype.productElement__I__O = (function(n) {
  return $f_s_Product12__productElement__I__O(this, n)
});
$c_T12.prototype.toString__T = (function() {
  return (((((((((((((((((((((((("(" + this.T12__f__1) + ",") + this.T12__f__2) + ",") + this.T12__f__3) + ",") + this.T12__f__4) + ",") + this.T12__f__5) + ",") + this.T12__f__6) + ",") + this.T12__f__7) + ",") + this.T12__f__8) + ",") + this.T12__f__9) + ",") + this.T12__f__10) + ",") + this.T12__f__11) + ",") + this.T12__f__12) + ")")
});
$c_T12.prototype.productPrefix__T = (function() {
  return "Tuple12"
});
$c_T12.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T12.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T12.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T12)) {
    var Tuple12$1 = $as_T12(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__1, $n(Tuple12$1).T12__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__2, $n(Tuple12$1).T12__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__3, $n(Tuple12$1).T12__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__4, $n(Tuple12$1).T12__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__5, $n(Tuple12$1).T12__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__6, $n(Tuple12$1).T12__f__6)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__7, $n(Tuple12$1).T12__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__8, $n(Tuple12$1).T12__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__9, $n(Tuple12$1).T12__f__9))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__10, $n(Tuple12$1).T12__f__10) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__11, $n(Tuple12$1).T12__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__12, $n(Tuple12$1).T12__f__12)))))
  } else {
    return false
  }
});
function $as_T12(obj) {
  return (((obj instanceof $c_T12) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple12"))
}
function $isArrayOf_T12(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T12)))
}
function $asArrayOf_T12(obj, depth) {
  return (($isArrayOf_T12(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple12;", depth))
}
var $d_T12 = new $TypeData().initClass({
  T12: 0
}, false, "scala.Tuple12", {
  T12: 1,
  O: 1,
  s_Product12: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T12.prototype.$classData = $d_T12;
/** @constructor */
function $c_T13(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13) {
  this.T13__f__1 = null;
  this.T13__f__2 = null;
  this.T13__f__3 = null;
  this.T13__f__4 = null;
  this.T13__f__5 = null;
  this.T13__f__6 = null;
  this.T13__f__7 = null;
  this.T13__f__8 = null;
  this.T13__f__9 = null;
  this.T13__f__10 = null;
  this.T13__f__11 = null;
  this.T13__f__12 = null;
  this.T13__f__13 = null;
  this.T13__f__1 = _1;
  this.T13__f__2 = _2;
  this.T13__f__3 = _3;
  this.T13__f__4 = _4;
  this.T13__f__5 = _5;
  this.T13__f__6 = _6;
  this.T13__f__7 = _7;
  this.T13__f__8 = _8;
  this.T13__f__9 = _9;
  this.T13__f__10 = _10;
  this.T13__f__11 = _11;
  this.T13__f__12 = _12;
  this.T13__f__13 = _13
}
$c_T13.prototype = new $h_O();
$c_T13.prototype.constructor = $c_T13;
/** @constructor */
function $h_T13() {
  /*<skip>*/
}
$h_T13.prototype = $c_T13.prototype;
$c_T13.prototype.productArity__I = (function() {
  return 13
});
$c_T13.prototype.productElement__I__O = (function(n) {
  return $f_s_Product13__productElement__I__O(this, n)
});
$c_T13.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((("(" + this.T13__f__1) + ",") + this.T13__f__2) + ",") + this.T13__f__3) + ",") + this.T13__f__4) + ",") + this.T13__f__5) + ",") + this.T13__f__6) + ",") + this.T13__f__7) + ",") + this.T13__f__8) + ",") + this.T13__f__9) + ",") + this.T13__f__10) + ",") + this.T13__f__11) + ",") + this.T13__f__12) + ",") + this.T13__f__13) + ")")
});
$c_T13.prototype.productPrefix__T = (function() {
  return "Tuple13"
});
$c_T13.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T13.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T13.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T13)) {
    var Tuple13$1 = $as_T13(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__1, $n(Tuple13$1).T13__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__2, $n(Tuple13$1).T13__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__3, $n(Tuple13$1).T13__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__4, $n(Tuple13$1).T13__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__5, $n(Tuple13$1).T13__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__6, $n(Tuple13$1).T13__f__6)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__7, $n(Tuple13$1).T13__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__8, $n(Tuple13$1).T13__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__9, $n(Tuple13$1).T13__f__9))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__10, $n(Tuple13$1).T13__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__11, $n(Tuple13$1).T13__f__11)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__12, $n(Tuple13$1).T13__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__13, $n(Tuple13$1).T13__f__13)))))
  } else {
    return false
  }
});
function $as_T13(obj) {
  return (((obj instanceof $c_T13) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple13"))
}
function $isArrayOf_T13(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T13)))
}
function $asArrayOf_T13(obj, depth) {
  return (($isArrayOf_T13(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple13;", depth))
}
var $d_T13 = new $TypeData().initClass({
  T13: 0
}, false, "scala.Tuple13", {
  T13: 1,
  O: 1,
  s_Product13: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T13.prototype.$classData = $d_T13;
/** @constructor */
function $c_T14(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14) {
  this.T14__f__1 = null;
  this.T14__f__2 = null;
  this.T14__f__3 = null;
  this.T14__f__4 = null;
  this.T14__f__5 = null;
  this.T14__f__6 = null;
  this.T14__f__7 = null;
  this.T14__f__8 = null;
  this.T14__f__9 = null;
  this.T14__f__10 = null;
  this.T14__f__11 = null;
  this.T14__f__12 = null;
  this.T14__f__13 = null;
  this.T14__f__14 = null;
  this.T14__f__1 = _1;
  this.T14__f__2 = _2;
  this.T14__f__3 = _3;
  this.T14__f__4 = _4;
  this.T14__f__5 = _5;
  this.T14__f__6 = _6;
  this.T14__f__7 = _7;
  this.T14__f__8 = _8;
  this.T14__f__9 = _9;
  this.T14__f__10 = _10;
  this.T14__f__11 = _11;
  this.T14__f__12 = _12;
  this.T14__f__13 = _13;
  this.T14__f__14 = _14
}
$c_T14.prototype = new $h_O();
$c_T14.prototype.constructor = $c_T14;
/** @constructor */
function $h_T14() {
  /*<skip>*/
}
$h_T14.prototype = $c_T14.prototype;
$c_T14.prototype.productArity__I = (function() {
  return 14
});
$c_T14.prototype.productElement__I__O = (function(n) {
  return $f_s_Product14__productElement__I__O(this, n)
});
$c_T14.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((("(" + this.T14__f__1) + ",") + this.T14__f__2) + ",") + this.T14__f__3) + ",") + this.T14__f__4) + ",") + this.T14__f__5) + ",") + this.T14__f__6) + ",") + this.T14__f__7) + ",") + this.T14__f__8) + ",") + this.T14__f__9) + ",") + this.T14__f__10) + ",") + this.T14__f__11) + ",") + this.T14__f__12) + ",") + this.T14__f__13) + ",") + this.T14__f__14) + ")")
});
$c_T14.prototype.productPrefix__T = (function() {
  return "Tuple14"
});
$c_T14.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T14.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T14.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T14)) {
    var Tuple14$1 = $as_T14(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__1, $n(Tuple14$1).T14__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__2, $n(Tuple14$1).T14__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__3, $n(Tuple14$1).T14__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__4, $n(Tuple14$1).T14__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__5, $n(Tuple14$1).T14__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__6, $n(Tuple14$1).T14__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__7, $n(Tuple14$1).T14__f__7)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__8, $n(Tuple14$1).T14__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__9, $n(Tuple14$1).T14__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__10, $n(Tuple14$1).T14__f__10))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__11, $n(Tuple14$1).T14__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__12, $n(Tuple14$1).T14__f__12)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__13, $n(Tuple14$1).T14__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__14, $n(Tuple14$1).T14__f__14)))))
  } else {
    return false
  }
});
function $as_T14(obj) {
  return (((obj instanceof $c_T14) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple14"))
}
function $isArrayOf_T14(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T14)))
}
function $asArrayOf_T14(obj, depth) {
  return (($isArrayOf_T14(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple14;", depth))
}
var $d_T14 = new $TypeData().initClass({
  T14: 0
}, false, "scala.Tuple14", {
  T14: 1,
  O: 1,
  s_Product14: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T14.prototype.$classData = $d_T14;
/** @constructor */
function $c_T15(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15) {
  this.T15__f__1 = null;
  this.T15__f__2 = null;
  this.T15__f__3 = null;
  this.T15__f__4 = null;
  this.T15__f__5 = null;
  this.T15__f__6 = null;
  this.T15__f__7 = null;
  this.T15__f__8 = null;
  this.T15__f__9 = null;
  this.T15__f__10 = null;
  this.T15__f__11 = null;
  this.T15__f__12 = null;
  this.T15__f__13 = null;
  this.T15__f__14 = null;
  this.T15__f__15 = null;
  this.T15__f__1 = _1;
  this.T15__f__2 = _2;
  this.T15__f__3 = _3;
  this.T15__f__4 = _4;
  this.T15__f__5 = _5;
  this.T15__f__6 = _6;
  this.T15__f__7 = _7;
  this.T15__f__8 = _8;
  this.T15__f__9 = _9;
  this.T15__f__10 = _10;
  this.T15__f__11 = _11;
  this.T15__f__12 = _12;
  this.T15__f__13 = _13;
  this.T15__f__14 = _14;
  this.T15__f__15 = _15
}
$c_T15.prototype = new $h_O();
$c_T15.prototype.constructor = $c_T15;
/** @constructor */
function $h_T15() {
  /*<skip>*/
}
$h_T15.prototype = $c_T15.prototype;
$c_T15.prototype.productArity__I = (function() {
  return 15
});
$c_T15.prototype.productElement__I__O = (function(n) {
  return $f_s_Product15__productElement__I__O(this, n)
});
$c_T15.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((("(" + this.T15__f__1) + ",") + this.T15__f__2) + ",") + this.T15__f__3) + ",") + this.T15__f__4) + ",") + this.T15__f__5) + ",") + this.T15__f__6) + ",") + this.T15__f__7) + ",") + this.T15__f__8) + ",") + this.T15__f__9) + ",") + this.T15__f__10) + ",") + this.T15__f__11) + ",") + this.T15__f__12) + ",") + this.T15__f__13) + ",") + this.T15__f__14) + ",") + this.T15__f__15) + ")")
});
$c_T15.prototype.productPrefix__T = (function() {
  return "Tuple15"
});
$c_T15.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T15.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T15.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T15)) {
    var Tuple15$1 = $as_T15(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__1, $n(Tuple15$1).T15__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__2, $n(Tuple15$1).T15__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__3, $n(Tuple15$1).T15__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__4, $n(Tuple15$1).T15__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__5, $n(Tuple15$1).T15__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__6, $n(Tuple15$1).T15__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__7, $n(Tuple15$1).T15__f__7)))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__8, $n(Tuple15$1).T15__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__9, $n(Tuple15$1).T15__f__9)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__10, $n(Tuple15$1).T15__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__11, $n(Tuple15$1).T15__f__11))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__12, $n(Tuple15$1).T15__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__13, $n(Tuple15$1).T15__f__13)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__14, $n(Tuple15$1).T15__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__15, $n(Tuple15$1).T15__f__15)))))
  } else {
    return false
  }
});
function $as_T15(obj) {
  return (((obj instanceof $c_T15) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple15"))
}
function $isArrayOf_T15(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T15)))
}
function $asArrayOf_T15(obj, depth) {
  return (($isArrayOf_T15(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple15;", depth))
}
var $d_T15 = new $TypeData().initClass({
  T15: 0
}, false, "scala.Tuple15", {
  T15: 1,
  O: 1,
  s_Product15: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T15.prototype.$classData = $d_T15;
/** @constructor */
function $c_T16(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16) {
  this.T16__f__1 = null;
  this.T16__f__2 = null;
  this.T16__f__3 = null;
  this.T16__f__4 = null;
  this.T16__f__5 = null;
  this.T16__f__6 = null;
  this.T16__f__7 = null;
  this.T16__f__8 = null;
  this.T16__f__9 = null;
  this.T16__f__10 = null;
  this.T16__f__11 = null;
  this.T16__f__12 = null;
  this.T16__f__13 = null;
  this.T16__f__14 = null;
  this.T16__f__15 = null;
  this.T16__f__16 = null;
  this.T16__f__1 = _1;
  this.T16__f__2 = _2;
  this.T16__f__3 = _3;
  this.T16__f__4 = _4;
  this.T16__f__5 = _5;
  this.T16__f__6 = _6;
  this.T16__f__7 = _7;
  this.T16__f__8 = _8;
  this.T16__f__9 = _9;
  this.T16__f__10 = _10;
  this.T16__f__11 = _11;
  this.T16__f__12 = _12;
  this.T16__f__13 = _13;
  this.T16__f__14 = _14;
  this.T16__f__15 = _15;
  this.T16__f__16 = _16
}
$c_T16.prototype = new $h_O();
$c_T16.prototype.constructor = $c_T16;
/** @constructor */
function $h_T16() {
  /*<skip>*/
}
$h_T16.prototype = $c_T16.prototype;
$c_T16.prototype.productArity__I = (function() {
  return 16
});
$c_T16.prototype.productElement__I__O = (function(n) {
  return $f_s_Product16__productElement__I__O(this, n)
});
$c_T16.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((("(" + this.T16__f__1) + ",") + this.T16__f__2) + ",") + this.T16__f__3) + ",") + this.T16__f__4) + ",") + this.T16__f__5) + ",") + this.T16__f__6) + ",") + this.T16__f__7) + ",") + this.T16__f__8) + ",") + this.T16__f__9) + ",") + this.T16__f__10) + ",") + this.T16__f__11) + ",") + this.T16__f__12) + ",") + this.T16__f__13) + ",") + this.T16__f__14) + ",") + this.T16__f__15) + ",") + this.T16__f__16) + ")")
});
$c_T16.prototype.productPrefix__T = (function() {
  return "Tuple16"
});
$c_T16.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T16.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T16.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T16)) {
    var Tuple16$1 = $as_T16(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__1, $n(Tuple16$1).T16__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__2, $n(Tuple16$1).T16__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__3, $n(Tuple16$1).T16__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__4, $n(Tuple16$1).T16__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__5, $n(Tuple16$1).T16__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__6, $n(Tuple16$1).T16__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__7, $n(Tuple16$1).T16__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__8, $n(Tuple16$1).T16__f__8)))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__9, $n(Tuple16$1).T16__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__10, $n(Tuple16$1).T16__f__10)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__11, $n(Tuple16$1).T16__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__12, $n(Tuple16$1).T16__f__12))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__13, $n(Tuple16$1).T16__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__14, $n(Tuple16$1).T16__f__14)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__15, $n(Tuple16$1).T16__f__15) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__16, $n(Tuple16$1).T16__f__16)))))
  } else {
    return false
  }
});
function $as_T16(obj) {
  return (((obj instanceof $c_T16) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple16"))
}
function $isArrayOf_T16(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T16)))
}
function $asArrayOf_T16(obj, depth) {
  return (($isArrayOf_T16(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple16;", depth))
}
var $d_T16 = new $TypeData().initClass({
  T16: 0
}, false, "scala.Tuple16", {
  T16: 1,
  O: 1,
  s_Product16: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T16.prototype.$classData = $d_T16;
/** @constructor */
function $c_T17(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17) {
  this.T17__f__1 = null;
  this.T17__f__2 = null;
  this.T17__f__3 = null;
  this.T17__f__4 = null;
  this.T17__f__5 = null;
  this.T17__f__6 = null;
  this.T17__f__7 = null;
  this.T17__f__8 = null;
  this.T17__f__9 = null;
  this.T17__f__10 = null;
  this.T17__f__11 = null;
  this.T17__f__12 = null;
  this.T17__f__13 = null;
  this.T17__f__14 = null;
  this.T17__f__15 = null;
  this.T17__f__16 = null;
  this.T17__f__17 = null;
  this.T17__f__1 = _1;
  this.T17__f__2 = _2;
  this.T17__f__3 = _3;
  this.T17__f__4 = _4;
  this.T17__f__5 = _5;
  this.T17__f__6 = _6;
  this.T17__f__7 = _7;
  this.T17__f__8 = _8;
  this.T17__f__9 = _9;
  this.T17__f__10 = _10;
  this.T17__f__11 = _11;
  this.T17__f__12 = _12;
  this.T17__f__13 = _13;
  this.T17__f__14 = _14;
  this.T17__f__15 = _15;
  this.T17__f__16 = _16;
  this.T17__f__17 = _17
}
$c_T17.prototype = new $h_O();
$c_T17.prototype.constructor = $c_T17;
/** @constructor */
function $h_T17() {
  /*<skip>*/
}
$h_T17.prototype = $c_T17.prototype;
$c_T17.prototype.productArity__I = (function() {
  return 17
});
$c_T17.prototype.productElement__I__O = (function(n) {
  return $f_s_Product17__productElement__I__O(this, n)
});
$c_T17.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((("(" + this.T17__f__1) + ",") + this.T17__f__2) + ",") + this.T17__f__3) + ",") + this.T17__f__4) + ",") + this.T17__f__5) + ",") + this.T17__f__6) + ",") + this.T17__f__7) + ",") + this.T17__f__8) + ",") + this.T17__f__9) + ",") + this.T17__f__10) + ",") + this.T17__f__11) + ",") + this.T17__f__12) + ",") + this.T17__f__13) + ",") + this.T17__f__14) + ",") + this.T17__f__15) + ",") + this.T17__f__16) + ",") + this.T17__f__17) + ")")
});
$c_T17.prototype.productPrefix__T = (function() {
  return "Tuple17"
});
$c_T17.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T17.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T17.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T17)) {
    var Tuple17$1 = $as_T17(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__1, $n(Tuple17$1).T17__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__2, $n(Tuple17$1).T17__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__3, $n(Tuple17$1).T17__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__4, $n(Tuple17$1).T17__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__5, $n(Tuple17$1).T17__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__6, $n(Tuple17$1).T17__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__7, $n(Tuple17$1).T17__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__8, $n(Tuple17$1).T17__f__8)))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__9, $n(Tuple17$1).T17__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__10, $n(Tuple17$1).T17__f__10)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__11, $n(Tuple17$1).T17__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__12, $n(Tuple17$1).T17__f__12))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__13, $n(Tuple17$1).T17__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__14, $n(Tuple17$1).T17__f__14)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__15, $n(Tuple17$1).T17__f__15) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__16, $n(Tuple17$1).T17__f__16) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__17, $n(Tuple17$1).T17__f__17))))))
  } else {
    return false
  }
});
function $as_T17(obj) {
  return (((obj instanceof $c_T17) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple17"))
}
function $isArrayOf_T17(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T17)))
}
function $asArrayOf_T17(obj, depth) {
  return (($isArrayOf_T17(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple17;", depth))
}
var $d_T17 = new $TypeData().initClass({
  T17: 0
}, false, "scala.Tuple17", {
  T17: 1,
  O: 1,
  s_Product17: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T17.prototype.$classData = $d_T17;
/** @constructor */
function $c_T18(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18) {
  this.T18__f__1 = null;
  this.T18__f__2 = null;
  this.T18__f__3 = null;
  this.T18__f__4 = null;
  this.T18__f__5 = null;
  this.T18__f__6 = null;
  this.T18__f__7 = null;
  this.T18__f__8 = null;
  this.T18__f__9 = null;
  this.T18__f__10 = null;
  this.T18__f__11 = null;
  this.T18__f__12 = null;
  this.T18__f__13 = null;
  this.T18__f__14 = null;
  this.T18__f__15 = null;
  this.T18__f__16 = null;
  this.T18__f__17 = null;
  this.T18__f__18 = null;
  this.T18__f__1 = _1;
  this.T18__f__2 = _2;
  this.T18__f__3 = _3;
  this.T18__f__4 = _4;
  this.T18__f__5 = _5;
  this.T18__f__6 = _6;
  this.T18__f__7 = _7;
  this.T18__f__8 = _8;
  this.T18__f__9 = _9;
  this.T18__f__10 = _10;
  this.T18__f__11 = _11;
  this.T18__f__12 = _12;
  this.T18__f__13 = _13;
  this.T18__f__14 = _14;
  this.T18__f__15 = _15;
  this.T18__f__16 = _16;
  this.T18__f__17 = _17;
  this.T18__f__18 = _18
}
$c_T18.prototype = new $h_O();
$c_T18.prototype.constructor = $c_T18;
/** @constructor */
function $h_T18() {
  /*<skip>*/
}
$h_T18.prototype = $c_T18.prototype;
$c_T18.prototype.productArity__I = (function() {
  return 18
});
$c_T18.prototype.productElement__I__O = (function(n) {
  return $f_s_Product18__productElement__I__O(this, n)
});
$c_T18.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((("(" + this.T18__f__1) + ",") + this.T18__f__2) + ",") + this.T18__f__3) + ",") + this.T18__f__4) + ",") + this.T18__f__5) + ",") + this.T18__f__6) + ",") + this.T18__f__7) + ",") + this.T18__f__8) + ",") + this.T18__f__9) + ",") + this.T18__f__10) + ",") + this.T18__f__11) + ",") + this.T18__f__12) + ",") + this.T18__f__13) + ",") + this.T18__f__14) + ",") + this.T18__f__15) + ",") + this.T18__f__16) + ",") + this.T18__f__17) + ",") + this.T18__f__18) + ")")
});
$c_T18.prototype.productPrefix__T = (function() {
  return "Tuple18"
});
$c_T18.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T18.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T18.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T18)) {
    var Tuple18$1 = $as_T18(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__1, $n(Tuple18$1).T18__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__2, $n(Tuple18$1).T18__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__3, $n(Tuple18$1).T18__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__4, $n(Tuple18$1).T18__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__5, $n(Tuple18$1).T18__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__6, $n(Tuple18$1).T18__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__7, $n(Tuple18$1).T18__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__8, $n(Tuple18$1).T18__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__9, $n(Tuple18$1).T18__f__9))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__10, $n(Tuple18$1).T18__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__11, $n(Tuple18$1).T18__f__11)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__12, $n(Tuple18$1).T18__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__13, $n(Tuple18$1).T18__f__13))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__14, $n(Tuple18$1).T18__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__15, $n(Tuple18$1).T18__f__15)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__16, $n(Tuple18$1).T18__f__16) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__17, $n(Tuple18$1).T18__f__17) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__18, $n(Tuple18$1).T18__f__18))))))
  } else {
    return false
  }
});
function $as_T18(obj) {
  return (((obj instanceof $c_T18) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple18"))
}
function $isArrayOf_T18(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T18)))
}
function $asArrayOf_T18(obj, depth) {
  return (($isArrayOf_T18(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple18;", depth))
}
var $d_T18 = new $TypeData().initClass({
  T18: 0
}, false, "scala.Tuple18", {
  T18: 1,
  O: 1,
  s_Product18: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T18.prototype.$classData = $d_T18;
/** @constructor */
function $c_T19(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19) {
  this.T19__f__1 = null;
  this.T19__f__2 = null;
  this.T19__f__3 = null;
  this.T19__f__4 = null;
  this.T19__f__5 = null;
  this.T19__f__6 = null;
  this.T19__f__7 = null;
  this.T19__f__8 = null;
  this.T19__f__9 = null;
  this.T19__f__10 = null;
  this.T19__f__11 = null;
  this.T19__f__12 = null;
  this.T19__f__13 = null;
  this.T19__f__14 = null;
  this.T19__f__15 = null;
  this.T19__f__16 = null;
  this.T19__f__17 = null;
  this.T19__f__18 = null;
  this.T19__f__19 = null;
  this.T19__f__1 = _1;
  this.T19__f__2 = _2;
  this.T19__f__3 = _3;
  this.T19__f__4 = _4;
  this.T19__f__5 = _5;
  this.T19__f__6 = _6;
  this.T19__f__7 = _7;
  this.T19__f__8 = _8;
  this.T19__f__9 = _9;
  this.T19__f__10 = _10;
  this.T19__f__11 = _11;
  this.T19__f__12 = _12;
  this.T19__f__13 = _13;
  this.T19__f__14 = _14;
  this.T19__f__15 = _15;
  this.T19__f__16 = _16;
  this.T19__f__17 = _17;
  this.T19__f__18 = _18;
  this.T19__f__19 = _19
}
$c_T19.prototype = new $h_O();
$c_T19.prototype.constructor = $c_T19;
/** @constructor */
function $h_T19() {
  /*<skip>*/
}
$h_T19.prototype = $c_T19.prototype;
$c_T19.prototype.productArity__I = (function() {
  return 19
});
$c_T19.prototype.productElement__I__O = (function(n) {
  return $f_s_Product19__productElement__I__O(this, n)
});
$c_T19.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((("(" + this.T19__f__1) + ",") + this.T19__f__2) + ",") + this.T19__f__3) + ",") + this.T19__f__4) + ",") + this.T19__f__5) + ",") + this.T19__f__6) + ",") + this.T19__f__7) + ",") + this.T19__f__8) + ",") + this.T19__f__9) + ",") + this.T19__f__10) + ",") + this.T19__f__11) + ",") + this.T19__f__12) + ",") + this.T19__f__13) + ",") + this.T19__f__14) + ",") + this.T19__f__15) + ",") + this.T19__f__16) + ",") + this.T19__f__17) + ",") + this.T19__f__18) + ",") + this.T19__f__19) + ")")
});
$c_T19.prototype.productPrefix__T = (function() {
  return "Tuple19"
});
$c_T19.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T19.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T19.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T19)) {
    var Tuple19$1 = $as_T19(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__1, $n(Tuple19$1).T19__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__2, $n(Tuple19$1).T19__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__3, $n(Tuple19$1).T19__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__4, $n(Tuple19$1).T19__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__5, $n(Tuple19$1).T19__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__6, $n(Tuple19$1).T19__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__7, $n(Tuple19$1).T19__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__8, $n(Tuple19$1).T19__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__9, $n(Tuple19$1).T19__f__9))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__10, $n(Tuple19$1).T19__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__11, $n(Tuple19$1).T19__f__11)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__12, $n(Tuple19$1).T19__f__12) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__13, $n(Tuple19$1).T19__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__14, $n(Tuple19$1).T19__f__14)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__15, $n(Tuple19$1).T19__f__15) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__16, $n(Tuple19$1).T19__f__16)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__17, $n(Tuple19$1).T19__f__17) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__18, $n(Tuple19$1).T19__f__18) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__19, $n(Tuple19$1).T19__f__19))))))
  } else {
    return false
  }
});
function $as_T19(obj) {
  return (((obj instanceof $c_T19) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple19"))
}
function $isArrayOf_T19(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T19)))
}
function $asArrayOf_T19(obj, depth) {
  return (($isArrayOf_T19(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple19;", depth))
}
var $d_T19 = new $TypeData().initClass({
  T19: 0
}, false, "scala.Tuple19", {
  T19: 1,
  O: 1,
  s_Product19: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T19.prototype.$classData = $d_T19;
function $ct_T2__O__O__($thiz, _1, _2) {
  $thiz.T2__f__1 = _1;
  $thiz.T2__f__2 = _2;
  return $thiz
}
/** @constructor */
function $c_T2() {
  this.T2__f__1 = null;
  this.T2__f__2 = null
}
$c_T2.prototype = new $h_O();
$c_T2.prototype.constructor = $c_T2;
/** @constructor */
function $h_T2() {
  /*<skip>*/
}
$h_T2.prototype = $c_T2.prototype;
$c_T2.prototype.productArity__I = (function() {
  return 2
});
$c_T2.prototype.productElement__I__O = (function(n) {
  return $f_s_Product2__productElement__I__O(this, n)
});
$c_T2.prototype._1__O = (function() {
  return this.T2__f__1
});
$c_T2.prototype._2__O = (function() {
  return this.T2__f__2
});
$c_T2.prototype.toString__T = (function() {
  return (((("(" + this._1__O()) + ",") + this._2__O()) + ")")
});
$c_T2.prototype.copy$default$2__O = (function() {
  return this._2__O()
});
$c_T2.prototype.productPrefix__T = (function() {
  return "Tuple2"
});
$c_T2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T2.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T2.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T2)) {
    var Tuple2$1 = $as_T2(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this._1__O(), $n(Tuple2$1)._1__O()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this._2__O(), $n(Tuple2$1)._2__O()))
  } else {
    return false
  }
});
$c_T2.prototype._1$mcZ$sp__Z = (function() {
  return $uZ(this._1__O())
});
$c_T2.prototype._1$mcD$sp__D = (function() {
  return $uD(this._1__O())
});
$c_T2.prototype._1$mcI$sp__I = (function() {
  return $uI(this._1__O())
});
$c_T2.prototype._2$mcZ$sp__Z = (function() {
  return $uZ(this._2__O())
});
$c_T2.prototype._2$mcD$sp__D = (function() {
  return $uD(this._2__O())
});
$c_T2.prototype._2$mcI$sp__I = (function() {
  return $uI(this._2__O())
});
function $as_T2(obj) {
  return (((obj instanceof $c_T2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple2"))
}
function $isArrayOf_T2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T2)))
}
function $asArrayOf_T2(obj, depth) {
  return (($isArrayOf_T2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple2;", depth))
}
var $d_T2 = new $TypeData().initClass({
  T2: 0
}, false, "scala.Tuple2", {
  T2: 1,
  O: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T2.prototype.$classData = $d_T2;
/** @constructor */
function $c_T20(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20) {
  this.T20__f__1 = null;
  this.T20__f__2 = null;
  this.T20__f__3 = null;
  this.T20__f__4 = null;
  this.T20__f__5 = null;
  this.T20__f__6 = null;
  this.T20__f__7 = null;
  this.T20__f__8 = null;
  this.T20__f__9 = null;
  this.T20__f__10 = null;
  this.T20__f__11 = null;
  this.T20__f__12 = null;
  this.T20__f__13 = null;
  this.T20__f__14 = null;
  this.T20__f__15 = null;
  this.T20__f__16 = null;
  this.T20__f__17 = null;
  this.T20__f__18 = null;
  this.T20__f__19 = null;
  this.T20__f__20 = null;
  this.T20__f__1 = _1;
  this.T20__f__2 = _2;
  this.T20__f__3 = _3;
  this.T20__f__4 = _4;
  this.T20__f__5 = _5;
  this.T20__f__6 = _6;
  this.T20__f__7 = _7;
  this.T20__f__8 = _8;
  this.T20__f__9 = _9;
  this.T20__f__10 = _10;
  this.T20__f__11 = _11;
  this.T20__f__12 = _12;
  this.T20__f__13 = _13;
  this.T20__f__14 = _14;
  this.T20__f__15 = _15;
  this.T20__f__16 = _16;
  this.T20__f__17 = _17;
  this.T20__f__18 = _18;
  this.T20__f__19 = _19;
  this.T20__f__20 = _20
}
$c_T20.prototype = new $h_O();
$c_T20.prototype.constructor = $c_T20;
/** @constructor */
function $h_T20() {
  /*<skip>*/
}
$h_T20.prototype = $c_T20.prototype;
$c_T20.prototype.productArity__I = (function() {
  return 20
});
$c_T20.prototype.productElement__I__O = (function(n) {
  return $f_s_Product20__productElement__I__O(this, n)
});
$c_T20.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((((("(" + this.T20__f__1) + ",") + this.T20__f__2) + ",") + this.T20__f__3) + ",") + this.T20__f__4) + ",") + this.T20__f__5) + ",") + this.T20__f__6) + ",") + this.T20__f__7) + ",") + this.T20__f__8) + ",") + this.T20__f__9) + ",") + this.T20__f__10) + ",") + this.T20__f__11) + ",") + this.T20__f__12) + ",") + this.T20__f__13) + ",") + this.T20__f__14) + ",") + this.T20__f__15) + ",") + this.T20__f__16) + ",") + this.T20__f__17) + ",") + this.T20__f__18) + ",") + this.T20__f__19) + ",") + this.T20__f__20) + ")")
});
$c_T20.prototype.productPrefix__T = (function() {
  return "Tuple20"
});
$c_T20.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T20.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T20.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T20)) {
    var Tuple20$1 = $as_T20(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__1, $n(Tuple20$1).T20__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__2, $n(Tuple20$1).T20__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__3, $n(Tuple20$1).T20__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__4, $n(Tuple20$1).T20__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__5, $n(Tuple20$1).T20__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__6, $n(Tuple20$1).T20__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__7, $n(Tuple20$1).T20__f__7)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__8, $n(Tuple20$1).T20__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__9, $n(Tuple20$1).T20__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__10, $n(Tuple20$1).T20__f__10))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__11, $n(Tuple20$1).T20__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__12, $n(Tuple20$1).T20__f__12)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__13, $n(Tuple20$1).T20__f__13) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__14, $n(Tuple20$1).T20__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__15, $n(Tuple20$1).T20__f__15)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__16, $n(Tuple20$1).T20__f__16) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__17, $n(Tuple20$1).T20__f__17)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__18, $n(Tuple20$1).T20__f__18) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__19, $n(Tuple20$1).T20__f__19) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__20, $n(Tuple20$1).T20__f__20))))))
  } else {
    return false
  }
});
function $as_T20(obj) {
  return (((obj instanceof $c_T20) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple20"))
}
function $isArrayOf_T20(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T20)))
}
function $asArrayOf_T20(obj, depth) {
  return (($isArrayOf_T20(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple20;", depth))
}
var $d_T20 = new $TypeData().initClass({
  T20: 0
}, false, "scala.Tuple20", {
  T20: 1,
  O: 1,
  s_Product20: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T20.prototype.$classData = $d_T20;
/** @constructor */
function $c_T21(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21) {
  this.T21__f__1 = null;
  this.T21__f__2 = null;
  this.T21__f__3 = null;
  this.T21__f__4 = null;
  this.T21__f__5 = null;
  this.T21__f__6 = null;
  this.T21__f__7 = null;
  this.T21__f__8 = null;
  this.T21__f__9 = null;
  this.T21__f__10 = null;
  this.T21__f__11 = null;
  this.T21__f__12 = null;
  this.T21__f__13 = null;
  this.T21__f__14 = null;
  this.T21__f__15 = null;
  this.T21__f__16 = null;
  this.T21__f__17 = null;
  this.T21__f__18 = null;
  this.T21__f__19 = null;
  this.T21__f__20 = null;
  this.T21__f__21 = null;
  this.T21__f__1 = _1;
  this.T21__f__2 = _2;
  this.T21__f__3 = _3;
  this.T21__f__4 = _4;
  this.T21__f__5 = _5;
  this.T21__f__6 = _6;
  this.T21__f__7 = _7;
  this.T21__f__8 = _8;
  this.T21__f__9 = _9;
  this.T21__f__10 = _10;
  this.T21__f__11 = _11;
  this.T21__f__12 = _12;
  this.T21__f__13 = _13;
  this.T21__f__14 = _14;
  this.T21__f__15 = _15;
  this.T21__f__16 = _16;
  this.T21__f__17 = _17;
  this.T21__f__18 = _18;
  this.T21__f__19 = _19;
  this.T21__f__20 = _20;
  this.T21__f__21 = _21
}
$c_T21.prototype = new $h_O();
$c_T21.prototype.constructor = $c_T21;
/** @constructor */
function $h_T21() {
  /*<skip>*/
}
$h_T21.prototype = $c_T21.prototype;
$c_T21.prototype.productArity__I = (function() {
  return 21
});
$c_T21.prototype.productElement__I__O = (function(n) {
  return $f_s_Product21__productElement__I__O(this, n)
});
$c_T21.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((((((("(" + this.T21__f__1) + ",") + this.T21__f__2) + ",") + this.T21__f__3) + ",") + this.T21__f__4) + ",") + this.T21__f__5) + ",") + this.T21__f__6) + ",") + this.T21__f__7) + ",") + this.T21__f__8) + ",") + this.T21__f__9) + ",") + this.T21__f__10) + ",") + this.T21__f__11) + ",") + this.T21__f__12) + ",") + this.T21__f__13) + ",") + this.T21__f__14) + ",") + this.T21__f__15) + ",") + this.T21__f__16) + ",") + this.T21__f__17) + ",") + this.T21__f__18) + ",") + this.T21__f__19) + ",") + this.T21__f__20) + ",") + this.T21__f__21) + ")")
});
$c_T21.prototype.productPrefix__T = (function() {
  return "Tuple21"
});
$c_T21.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T21.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T21.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T21)) {
    var Tuple21$1 = $as_T21(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__1, $n(Tuple21$1).T21__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__2, $n(Tuple21$1).T21__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__3, $n(Tuple21$1).T21__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__4, $n(Tuple21$1).T21__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__5, $n(Tuple21$1).T21__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__6, $n(Tuple21$1).T21__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__7, $n(Tuple21$1).T21__f__7)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__8, $n(Tuple21$1).T21__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__9, $n(Tuple21$1).T21__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__10, $n(Tuple21$1).T21__f__10))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__11, $n(Tuple21$1).T21__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__12, $n(Tuple21$1).T21__f__12)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__13, $n(Tuple21$1).T21__f__13) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__14, $n(Tuple21$1).T21__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__15, $n(Tuple21$1).T21__f__15)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__16, $n(Tuple21$1).T21__f__16) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__17, $n(Tuple21$1).T21__f__17) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__18, $n(Tuple21$1).T21__f__18))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__19, $n(Tuple21$1).T21__f__19) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__20, $n(Tuple21$1).T21__f__20) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__21, $n(Tuple21$1).T21__f__21))))))
  } else {
    return false
  }
});
function $as_T21(obj) {
  return (((obj instanceof $c_T21) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple21"))
}
function $isArrayOf_T21(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T21)))
}
function $asArrayOf_T21(obj, depth) {
  return (($isArrayOf_T21(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple21;", depth))
}
var $d_T21 = new $TypeData().initClass({
  T21: 0
}, false, "scala.Tuple21", {
  T21: 1,
  O: 1,
  s_Product21: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T21.prototype.$classData = $d_T21;
/** @constructor */
function $c_T22(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22) {
  this.T22__f__1 = null;
  this.T22__f__2 = null;
  this.T22__f__3 = null;
  this.T22__f__4 = null;
  this.T22__f__5 = null;
  this.T22__f__6 = null;
  this.T22__f__7 = null;
  this.T22__f__8 = null;
  this.T22__f__9 = null;
  this.T22__f__10 = null;
  this.T22__f__11 = null;
  this.T22__f__12 = null;
  this.T22__f__13 = null;
  this.T22__f__14 = null;
  this.T22__f__15 = null;
  this.T22__f__16 = null;
  this.T22__f__17 = null;
  this.T22__f__18 = null;
  this.T22__f__19 = null;
  this.T22__f__20 = null;
  this.T22__f__21 = null;
  this.T22__f__22 = null;
  this.T22__f__1 = _1;
  this.T22__f__2 = _2;
  this.T22__f__3 = _3;
  this.T22__f__4 = _4;
  this.T22__f__5 = _5;
  this.T22__f__6 = _6;
  this.T22__f__7 = _7;
  this.T22__f__8 = _8;
  this.T22__f__9 = _9;
  this.T22__f__10 = _10;
  this.T22__f__11 = _11;
  this.T22__f__12 = _12;
  this.T22__f__13 = _13;
  this.T22__f__14 = _14;
  this.T22__f__15 = _15;
  this.T22__f__16 = _16;
  this.T22__f__17 = _17;
  this.T22__f__18 = _18;
  this.T22__f__19 = _19;
  this.T22__f__20 = _20;
  this.T22__f__21 = _21;
  this.T22__f__22 = _22
}
$c_T22.prototype = new $h_O();
$c_T22.prototype.constructor = $c_T22;
/** @constructor */
function $h_T22() {
  /*<skip>*/
}
$h_T22.prototype = $c_T22.prototype;
$c_T22.prototype.productArity__I = (function() {
  return 22
});
$c_T22.prototype.productElement__I__O = (function(n) {
  return $f_s_Product22__productElement__I__O(this, n)
});
$c_T22.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((((((((("(" + this.T22__f__1) + ",") + this.T22__f__2) + ",") + this.T22__f__3) + ",") + this.T22__f__4) + ",") + this.T22__f__5) + ",") + this.T22__f__6) + ",") + this.T22__f__7) + ",") + this.T22__f__8) + ",") + this.T22__f__9) + ",") + this.T22__f__10) + ",") + this.T22__f__11) + ",") + this.T22__f__12) + ",") + this.T22__f__13) + ",") + this.T22__f__14) + ",") + this.T22__f__15) + ",") + this.T22__f__16) + ",") + this.T22__f__17) + ",") + this.T22__f__18) + ",") + this.T22__f__19) + ",") + this.T22__f__20) + ",") + this.T22__f__21) + ",") + this.T22__f__22) + ")")
});
$c_T22.prototype.productPrefix__T = (function() {
  return "Tuple22"
});
$c_T22.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T22.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T22.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T22)) {
    var Tuple22$1 = $as_T22(x$1);
    return (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__1, $n(Tuple22$1).T22__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__2, $n(Tuple22$1).T22__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__3, $n(Tuple22$1).T22__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__4, $n(Tuple22$1).T22__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__5, $n(Tuple22$1).T22__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__6, $n(Tuple22$1).T22__f__6) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__7, $n(Tuple22$1).T22__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__8, $n(Tuple22$1).T22__f__8))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__9, $n(Tuple22$1).T22__f__9) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__10, $n(Tuple22$1).T22__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__11, $n(Tuple22$1).T22__f__11))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__12, $n(Tuple22$1).T22__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__13, $n(Tuple22$1).T22__f__13)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__14, $n(Tuple22$1).T22__f__14) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__15, $n(Tuple22$1).T22__f__15) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__16, $n(Tuple22$1).T22__f__16)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__17, $n(Tuple22$1).T22__f__17) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__18, $n(Tuple22$1).T22__f__18) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__19, $n(Tuple22$1).T22__f__19))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__20, $n(Tuple22$1).T22__f__20) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__21, $n(Tuple22$1).T22__f__21) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__22, $n(Tuple22$1).T22__f__22))))))
  } else {
    return false
  }
});
function $as_T22(obj) {
  return (((obj instanceof $c_T22) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple22"))
}
function $isArrayOf_T22(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T22)))
}
function $asArrayOf_T22(obj, depth) {
  return (($isArrayOf_T22(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple22;", depth))
}
var $d_T22 = new $TypeData().initClass({
  T22: 0
}, false, "scala.Tuple22", {
  T22: 1,
  O: 1,
  s_Product22: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T22.prototype.$classData = $d_T22;
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.T3__f__1 = null;
  this.T3__f__2 = null;
  this.T3__f__3 = null;
  this.T3__f__1 = _1;
  this.T3__f__2 = _2;
  this.T3__f__3 = _3
}
$c_T3.prototype = new $h_O();
$c_T3.prototype.constructor = $c_T3;
/** @constructor */
function $h_T3() {
  /*<skip>*/
}
$h_T3.prototype = $c_T3.prototype;
$c_T3.prototype.productArity__I = (function() {
  return 3
});
$c_T3.prototype.productElement__I__O = (function(n) {
  return $f_s_Product3__productElement__I__O(this, n)
});
$c_T3.prototype.toString__T = (function() {
  return (((((("(" + this.T3__f__1) + ",") + this.T3__f__2) + ",") + this.T3__f__3) + ")")
});
$c_T3.prototype.productPrefix__T = (function() {
  return "Tuple3"
});
$c_T3.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T3.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T3.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T3)) {
    var Tuple3$1 = $as_T3(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__1, $n(Tuple3$1).T3__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__2, $n(Tuple3$1).T3__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__3, $n(Tuple3$1).T3__f__3)))
  } else {
    return false
  }
});
function $as_T3(obj) {
  return (((obj instanceof $c_T3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple3"))
}
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T3)))
}
function $asArrayOf_T3(obj, depth) {
  return (($isArrayOf_T3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple3;", depth))
}
var $d_T3 = new $TypeData().initClass({
  T3: 0
}, false, "scala.Tuple3", {
  T3: 1,
  O: 1,
  s_Product3: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T3.prototype.$classData = $d_T3;
/** @constructor */
function $c_T4(_1, _2, _3, _4) {
  this.T4__f__1 = null;
  this.T4__f__2 = null;
  this.T4__f__3 = null;
  this.T4__f__4 = null;
  this.T4__f__1 = _1;
  this.T4__f__2 = _2;
  this.T4__f__3 = _3;
  this.T4__f__4 = _4
}
$c_T4.prototype = new $h_O();
$c_T4.prototype.constructor = $c_T4;
/** @constructor */
function $h_T4() {
  /*<skip>*/
}
$h_T4.prototype = $c_T4.prototype;
$c_T4.prototype.productArity__I = (function() {
  return 4
});
$c_T4.prototype.productElement__I__O = (function(n) {
  return $f_s_Product4__productElement__I__O(this, n)
});
$c_T4.prototype.toString__T = (function() {
  return (((((((("(" + this.T4__f__1) + ",") + this.T4__f__2) + ",") + this.T4__f__3) + ",") + this.T4__f__4) + ")")
});
$c_T4.prototype.productPrefix__T = (function() {
  return "Tuple4"
});
$c_T4.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T4.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T4.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T4)) {
    var Tuple4$1 = $as_T4(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__1, $n(Tuple4$1).T4__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__2, $n(Tuple4$1).T4__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__3, $n(Tuple4$1).T4__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__4, $n(Tuple4$1).T4__f__4)))
  } else {
    return false
  }
});
function $as_T4(obj) {
  return (((obj instanceof $c_T4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple4"))
}
function $isArrayOf_T4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T4)))
}
function $asArrayOf_T4(obj, depth) {
  return (($isArrayOf_T4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple4;", depth))
}
var $d_T4 = new $TypeData().initClass({
  T4: 0
}, false, "scala.Tuple4", {
  T4: 1,
  O: 1,
  s_Product4: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T4.prototype.$classData = $d_T4;
/** @constructor */
function $c_T5(_1, _2, _3, _4, _5) {
  this.T5__f__1 = null;
  this.T5__f__2 = null;
  this.T5__f__3 = null;
  this.T5__f__4 = null;
  this.T5__f__5 = null;
  this.T5__f__1 = _1;
  this.T5__f__2 = _2;
  this.T5__f__3 = _3;
  this.T5__f__4 = _4;
  this.T5__f__5 = _5
}
$c_T5.prototype = new $h_O();
$c_T5.prototype.constructor = $c_T5;
/** @constructor */
function $h_T5() {
  /*<skip>*/
}
$h_T5.prototype = $c_T5.prototype;
$c_T5.prototype.productArity__I = (function() {
  return 5
});
$c_T5.prototype.productElement__I__O = (function(n) {
  return $f_s_Product5__productElement__I__O(this, n)
});
$c_T5.prototype.toString__T = (function() {
  return (((((((((("(" + this.T5__f__1) + ",") + this.T5__f__2) + ",") + this.T5__f__3) + ",") + this.T5__f__4) + ",") + this.T5__f__5) + ")")
});
$c_T5.prototype.productPrefix__T = (function() {
  return "Tuple5"
});
$c_T5.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T5.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T5.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T5)) {
    var Tuple5$1 = $as_T5(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__1, $n(Tuple5$1).T5__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__2, $n(Tuple5$1).T5__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__3, $n(Tuple5$1).T5__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__4, $n(Tuple5$1).T5__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__5, $n(Tuple5$1).T5__f__5))))
  } else {
    return false
  }
});
function $as_T5(obj) {
  return (((obj instanceof $c_T5) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple5"))
}
function $isArrayOf_T5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T5)))
}
function $asArrayOf_T5(obj, depth) {
  return (($isArrayOf_T5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple5;", depth))
}
var $d_T5 = new $TypeData().initClass({
  T5: 0
}, false, "scala.Tuple5", {
  T5: 1,
  O: 1,
  s_Product5: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T5.prototype.$classData = $d_T5;
/** @constructor */
function $c_T6(_1, _2, _3, _4, _5, _6) {
  this.T6__f__1 = null;
  this.T6__f__2 = null;
  this.T6__f__3 = null;
  this.T6__f__4 = null;
  this.T6__f__5 = null;
  this.T6__f__6 = null;
  this.T6__f__1 = _1;
  this.T6__f__2 = _2;
  this.T6__f__3 = _3;
  this.T6__f__4 = _4;
  this.T6__f__5 = _5;
  this.T6__f__6 = _6
}
$c_T6.prototype = new $h_O();
$c_T6.prototype.constructor = $c_T6;
/** @constructor */
function $h_T6() {
  /*<skip>*/
}
$h_T6.prototype = $c_T6.prototype;
$c_T6.prototype.productArity__I = (function() {
  return 6
});
$c_T6.prototype.productElement__I__O = (function(n) {
  return $f_s_Product6__productElement__I__O(this, n)
});
$c_T6.prototype.toString__T = (function() {
  return (((((((((((("(" + this.T6__f__1) + ",") + this.T6__f__2) + ",") + this.T6__f__3) + ",") + this.T6__f__4) + ",") + this.T6__f__5) + ",") + this.T6__f__6) + ")")
});
$c_T6.prototype.productPrefix__T = (function() {
  return "Tuple6"
});
$c_T6.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T6.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T6.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T6)) {
    var Tuple6$1 = $as_T6(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__1, $n(Tuple6$1).T6__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__2, $n(Tuple6$1).T6__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__3, $n(Tuple6$1).T6__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__4, $n(Tuple6$1).T6__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__5, $n(Tuple6$1).T6__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__6, $n(Tuple6$1).T6__f__6))))
  } else {
    return false
  }
});
function $as_T6(obj) {
  return (((obj instanceof $c_T6) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple6"))
}
function $isArrayOf_T6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T6)))
}
function $asArrayOf_T6(obj, depth) {
  return (($isArrayOf_T6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple6;", depth))
}
var $d_T6 = new $TypeData().initClass({
  T6: 0
}, false, "scala.Tuple6", {
  T6: 1,
  O: 1,
  s_Product6: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T6.prototype.$classData = $d_T6;
/** @constructor */
function $c_T7(_1, _2, _3, _4, _5, _6, _7) {
  this.T7__f__1 = null;
  this.T7__f__2 = null;
  this.T7__f__3 = null;
  this.T7__f__4 = null;
  this.T7__f__5 = null;
  this.T7__f__6 = null;
  this.T7__f__7 = null;
  this.T7__f__1 = _1;
  this.T7__f__2 = _2;
  this.T7__f__3 = _3;
  this.T7__f__4 = _4;
  this.T7__f__5 = _5;
  this.T7__f__6 = _6;
  this.T7__f__7 = _7
}
$c_T7.prototype = new $h_O();
$c_T7.prototype.constructor = $c_T7;
/** @constructor */
function $h_T7() {
  /*<skip>*/
}
$h_T7.prototype = $c_T7.prototype;
$c_T7.prototype.productArity__I = (function() {
  return 7
});
$c_T7.prototype.productElement__I__O = (function(n) {
  return $f_s_Product7__productElement__I__O(this, n)
});
$c_T7.prototype.toString__T = (function() {
  return (((((((((((((("(" + this.T7__f__1) + ",") + this.T7__f__2) + ",") + this.T7__f__3) + ",") + this.T7__f__4) + ",") + this.T7__f__5) + ",") + this.T7__f__6) + ",") + this.T7__f__7) + ")")
});
$c_T7.prototype.productPrefix__T = (function() {
  return "Tuple7"
});
$c_T7.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T7.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T7.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T7)) {
    var Tuple7$1 = $as_T7(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__1, $n(Tuple7$1).T7__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__2, $n(Tuple7$1).T7__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__3, $n(Tuple7$1).T7__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__4, $n(Tuple7$1).T7__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__5, $n(Tuple7$1).T7__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__6, $n(Tuple7$1).T7__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__7, $n(Tuple7$1).T7__f__7))))
  } else {
    return false
  }
});
function $as_T7(obj) {
  return (((obj instanceof $c_T7) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple7"))
}
function $isArrayOf_T7(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T7)))
}
function $asArrayOf_T7(obj, depth) {
  return (($isArrayOf_T7(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple7;", depth))
}
var $d_T7 = new $TypeData().initClass({
  T7: 0
}, false, "scala.Tuple7", {
  T7: 1,
  O: 1,
  s_Product7: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T7.prototype.$classData = $d_T7;
/** @constructor */
function $c_T8(_1, _2, _3, _4, _5, _6, _7, _8) {
  this.T8__f__1 = null;
  this.T8__f__2 = null;
  this.T8__f__3 = null;
  this.T8__f__4 = null;
  this.T8__f__5 = null;
  this.T8__f__6 = null;
  this.T8__f__7 = null;
  this.T8__f__8 = null;
  this.T8__f__1 = _1;
  this.T8__f__2 = _2;
  this.T8__f__3 = _3;
  this.T8__f__4 = _4;
  this.T8__f__5 = _5;
  this.T8__f__6 = _6;
  this.T8__f__7 = _7;
  this.T8__f__8 = _8
}
$c_T8.prototype = new $h_O();
$c_T8.prototype.constructor = $c_T8;
/** @constructor */
function $h_T8() {
  /*<skip>*/
}
$h_T8.prototype = $c_T8.prototype;
$c_T8.prototype.productArity__I = (function() {
  return 8
});
$c_T8.prototype.productElement__I__O = (function(n) {
  return $f_s_Product8__productElement__I__O(this, n)
});
$c_T8.prototype.toString__T = (function() {
  return (((((((((((((((("(" + this.T8__f__1) + ",") + this.T8__f__2) + ",") + this.T8__f__3) + ",") + this.T8__f__4) + ",") + this.T8__f__5) + ",") + this.T8__f__6) + ",") + this.T8__f__7) + ",") + this.T8__f__8) + ")")
});
$c_T8.prototype.productPrefix__T = (function() {
  return "Tuple8"
});
$c_T8.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T8.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T8.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T8)) {
    var Tuple8$1 = $as_T8(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__1, $n(Tuple8$1).T8__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__2, $n(Tuple8$1).T8__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__3, $n(Tuple8$1).T8__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__4, $n(Tuple8$1).T8__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__5, $n(Tuple8$1).T8__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__6, $n(Tuple8$1).T8__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__7, $n(Tuple8$1).T8__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__8, $n(Tuple8$1).T8__f__8))))
  } else {
    return false
  }
});
function $as_T8(obj) {
  return (((obj instanceof $c_T8) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple8"))
}
function $isArrayOf_T8(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T8)))
}
function $asArrayOf_T8(obj, depth) {
  return (($isArrayOf_T8(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple8;", depth))
}
var $d_T8 = new $TypeData().initClass({
  T8: 0
}, false, "scala.Tuple8", {
  T8: 1,
  O: 1,
  s_Product8: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T8.prototype.$classData = $d_T8;
/** @constructor */
function $c_T9(_1, _2, _3, _4, _5, _6, _7, _8, _9) {
  this.T9__f__1 = null;
  this.T9__f__2 = null;
  this.T9__f__3 = null;
  this.T9__f__4 = null;
  this.T9__f__5 = null;
  this.T9__f__6 = null;
  this.T9__f__7 = null;
  this.T9__f__8 = null;
  this.T9__f__9 = null;
  this.T9__f__1 = _1;
  this.T9__f__2 = _2;
  this.T9__f__3 = _3;
  this.T9__f__4 = _4;
  this.T9__f__5 = _5;
  this.T9__f__6 = _6;
  this.T9__f__7 = _7;
  this.T9__f__8 = _8;
  this.T9__f__9 = _9
}
$c_T9.prototype = new $h_O();
$c_T9.prototype.constructor = $c_T9;
/** @constructor */
function $h_T9() {
  /*<skip>*/
}
$h_T9.prototype = $c_T9.prototype;
$c_T9.prototype.productArity__I = (function() {
  return 9
});
$c_T9.prototype.productElement__I__O = (function(n) {
  return $f_s_Product9__productElement__I__O(this, n)
});
$c_T9.prototype.toString__T = (function() {
  return (((((((((((((((((("(" + this.T9__f__1) + ",") + this.T9__f__2) + ",") + this.T9__f__3) + ",") + this.T9__f__4) + ",") + this.T9__f__5) + ",") + this.T9__f__6) + ",") + this.T9__f__7) + ",") + this.T9__f__8) + ",") + this.T9__f__9) + ")")
});
$c_T9.prototype.productPrefix__T = (function() {
  return "Tuple9"
});
$c_T9.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T9.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T9.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T9)) {
    var Tuple9$1 = $as_T9(x$1);
    return ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__1, $n(Tuple9$1).T9__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__2, $n(Tuple9$1).T9__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__3, $n(Tuple9$1).T9__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__4, $n(Tuple9$1).T9__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__5, $n(Tuple9$1).T9__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__6, $n(Tuple9$1).T9__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__7, $n(Tuple9$1).T9__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__8, $n(Tuple9$1).T9__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__9, $n(Tuple9$1).T9__f__9)))))
  } else {
    return false
  }
});
function $as_T9(obj) {
  return (((obj instanceof $c_T9) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple9"))
}
function $isArrayOf_T9(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T9)))
}
function $asArrayOf_T9(obj, depth) {
  return (($isArrayOf_T9(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple9;", depth))
}
var $d_T9 = new $TypeData().initClass({
  T9: 0
}, false, "scala.Tuple9", {
  T9: 1,
  O: 1,
  s_Product9: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T9.prototype.$classData = $d_T9;
/** @constructor */
function $c_sc_BitSetOps$$anon$1(outer, start$1) {
  this.sc_BitSetOps$$anon$1__f_currentPos = 0;
  this.sc_BitSetOps$$anon$1__f_currentWord = $L0;
  this.sc_BitSetOps$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_BitSetOps$$anon$1__f_$outer = outer
  };
  this.sc_BitSetOps$$anon$1__f_currentPos = ((start$1 > 0) ? (start$1 >> 6) : 0);
  if ((start$1 > 0)) {
    var this$1 = $n(outer).word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos);
    var n = (63 & start$1);
    var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
    var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
    var lo$1 = (this$1.RTLong__f_lo & lo);
    var hi$1 = (this$1.RTLong__f_hi & hi);
    var x__lo = lo$1;
    var x__hi = hi$1;
    var $$x1 = new $c_RTLong(x__lo, x__hi)
  } else {
    var $$x1 = $n(outer).word__I__J(0)
  };
  this.sc_BitSetOps$$anon$1__f_currentWord = $$x1
}
$c_sc_BitSetOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_BitSetOps$$anon$1.prototype.constructor = $c_sc_BitSetOps$$anon$1;
/** @constructor */
function $h_sc_BitSetOps$$anon$1() {
  /*<skip>*/
}
$h_sc_BitSetOps$$anon$1.prototype = $c_sc_BitSetOps$$anon$1.prototype;
$c_sc_BitSetOps$$anon$1.prototype.hasNext__Z = (function() {
  while (true) {
    var this$1 = this.sc_BitSetOps$$anon$1__f_currentWord;
    if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
      if ((((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0) >= $n(this.sc_BitSetOps$$anon$1__f_$outer).nwords__I())) {
        return false
      };
      this.sc_BitSetOps$$anon$1__f_currentPos = ((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0);
      this.sc_BitSetOps$$anon$1__f_currentWord = $n(this.sc_BitSetOps$$anon$1__f_$outer).word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos)
    } else {
      break
    }
  };
  return true
});
$c_sc_BitSetOps$$anon$1.prototype.next__I = (function() {
  if (this.hasNext__Z()) {
    var t = this.sc_BitSetOps$$anon$1__f_currentWord;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((lo !== 0)) {
      if ((lo === 0)) {
        var bitPos = 32
      } else {
        var i = (lo & ((-lo) | 0));
        var bitPos = ((31 - $uI(Math.clz32(i))) | 0)
      }
    } else {
      if ((hi === 0)) {
        var $$x1 = 32
      } else {
        var i$1 = (hi & ((-hi) | 0));
        var $$x1 = ((31 - $uI(Math.clz32(i$1))) | 0)
      };
      var bitPos = ((32 + $$x1) | 0)
    };
    var this$5 = this.sc_BitSetOps$$anon$1__f_currentWord;
    var b = this.sc_BitSetOps$$anon$1__f_currentWord;
    var bhi = b.RTLong__f_hi;
    var lo$1 = (((-1) + b.RTLong__f_lo) | 0);
    var hi$1 = ((lo$1 !== (-1)) ? bhi : (((-1) + bhi) | 0));
    var lo$2 = (this$5.RTLong__f_lo & lo$1);
    var hi$2 = (this$5.RTLong__f_hi & hi$1);
    this.sc_BitSetOps$$anon$1__f_currentWord = new $c_RTLong(lo$2, hi$2);
    return (((this.sc_BitSetOps$$anon$1__f_currentPos << 6) + bitPos) | 0)
  } else {
    return $uI($n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O())
  }
});
$c_sc_BitSetOps$$anon$1.prototype.next__O = (function() {
  return this.next__I()
});
var $d_sc_BitSetOps$$anon$1 = new $TypeData().initClass({
  sc_BitSetOps$$anon$1: 0
}, false, "scala.collection.BitSetOps$$anon$1", {
  sc_BitSetOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_BitSetOps$$anon$1.prototype.$classData = $d_sc_BitSetOps$$anon$1;
/** @constructor */
function $c_sc_ClassTagSeqFactory$AnySeqDelegate(delegate) {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
  $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__(this, delegate)
}
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = new $h_sc_ClassTagIterableFactory$AnyIterableDelegate();
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.constructor = $c_sc_ClassTagSeqFactory$AnySeqDelegate;
/** @constructor */
function $h_sc_ClassTagSeqFactory$AnySeqDelegate() {
  /*<skip>*/
}
$h_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = $c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype;
var $d_sc_ClassTagSeqFactory$AnySeqDelegate = new $TypeData().initClass({
  sc_ClassTagSeqFactory$AnySeqDelegate: 0
}, false, "scala.collection.ClassTagSeqFactory$AnySeqDelegate", {
  sc_ClassTagSeqFactory$AnySeqDelegate: 1,
  sc_ClassTagIterableFactory$AnyIterableDelegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SeqFactory: 1
});
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.$classData = $d_sc_ClassTagSeqFactory$AnySeqDelegate;
function $f_sc_IndexedSeqOps__prepended__O__O($thiz, elem) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, $thiz))
}
function $f_sc_IndexedSeqOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), $thiz, n))
}
function $f_sc_IndexedSeqOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), $thiz, n))
}
function $f_sc_IndexedSeqOps__dropRight__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), $thiz, n))
}
function $f_sc_IndexedSeqOps__map__F1__O($thiz, f) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), $thiz, f))
}
function $f_sc_IndexedSeqOps__reverse__O($thiz) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), $thiz))
}
function $f_sc_IndexedSeqOps__slice__I__I__O($thiz, from, until) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_IndexedSeqView$Slice($thiz, from, until))
}
function $f_sc_IndexedSeqOps__head__O($thiz) {
  if ((!$thiz.isEmpty__Z())) {
    return $thiz.apply__I__O(0)
  } else {
    if ($is_sc_IndexedSeq($thiz)) {
      var x2 = $as_sc_IndexedSeq($thiz);
      var this$1 = $n(x2);
      var $$x1 = this$1.className__T()
    } else {
      var $$x1 = $thiz.toString__T()
    };
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("head of empty " + $$x1))
  }
}
function $f_sc_IndexedSeqOps__headOption__s_Option($thiz) {
  return ($thiz.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($thiz.head__O()))
}
function $f_sc_IndexedSeqOps__last__O($thiz) {
  if ((!$thiz.isEmpty__Z())) {
    return $thiz.apply__I__O((((-1) + $thiz.length__I()) | 0))
  } else {
    if ($is_sc_IndexedSeq($thiz)) {
      var x2 = $as_sc_IndexedSeq($thiz);
      var this$1 = $n(x2);
      var $$x1 = this$1.className__T()
    } else {
      var $$x1 = $thiz.toString__T()
    };
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("last of empty " + $$x1))
  }
}
function $f_sc_Iterable__toString__T($thiz) {
  var start = ($thiz.className__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, ", ", ")")
}
function $is_sc_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterable)))
}
function $as_sc_Iterable(obj) {
  return (($is_sc_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterable"))
}
function $isArrayOf_sc_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterable)))
}
function $asArrayOf_sc_Iterable(obj, depth) {
  return (($isArrayOf_sc_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterable;", depth))
}
function $p_sc_Iterator$$anon$10__nextCur__V($thiz) {
  $thiz.sc_Iterator$$anon$10__f_cur = null;
  $thiz.sc_Iterator$$anon$10__f_cur = $n($as_sc_IterableOnce($n($thiz.sc_Iterator$$anon$10__f_f$3).apply__O__O($n($thiz.sc_Iterator$$anon$10__f_$outer).next__O()))).iterator__sc_Iterator();
  $thiz.sc_Iterator$$anon$10__f__hasNext = (-1)
}
/** @constructor */
function $c_sc_Iterator$$anon$10(outer, f$3) {
  this.sc_Iterator$$anon$10__f_cur = null;
  this.sc_Iterator$$anon$10__f__hasNext = 0;
  this.sc_Iterator$$anon$10__f_$outer = null;
  this.sc_Iterator$$anon$10__f_f$3 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$10__f_$outer = outer
  };
  this.sc_Iterator$$anon$10__f_f$3 = f$3;
  this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  this.sc_Iterator$$anon$10__f__hasNext = (-1)
}
$c_sc_Iterator$$anon$10.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$10.prototype.constructor = $c_sc_Iterator$$anon$10;
/** @constructor */
function $h_sc_Iterator$$anon$10() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$10.prototype = $c_sc_Iterator$$anon$10.prototype;
$c_sc_Iterator$$anon$10.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$10__f__hasNext === (-1))) {
    while ((!$n(this.sc_Iterator$$anon$10__f_cur).hasNext__Z())) {
      if ((!$n(this.sc_Iterator$$anon$10__f_$outer).hasNext__Z())) {
        this.sc_Iterator$$anon$10__f__hasNext = 0;
        this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
        return false
      };
      $p_sc_Iterator$$anon$10__nextCur__V(this)
    };
    this.sc_Iterator$$anon$10__f__hasNext = 1;
    return true
  } else {
    return (this.sc_Iterator$$anon$10__f__hasNext === 1)
  }
});
$c_sc_Iterator$$anon$10.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$10__f__hasNext = (-1)
  };
  return $n(this.sc_Iterator$$anon$10__f_cur).next__O()
});
var $d_sc_Iterator$$anon$10 = new $TypeData().initClass({
  sc_Iterator$$anon$10: 0
}, false, "scala.collection.Iterator$$anon$10", {
  sc_Iterator$$anon$10: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$10.prototype.$classData = $d_sc_Iterator$$anon$10;
/** @constructor */
function $c_sc_Iterator$$anon$11(outer, p$2) {
  this.sc_Iterator$$anon$11__f_hd = null;
  this.sc_Iterator$$anon$11__f_hdDefined = false;
  this.sc_Iterator$$anon$11__f_tail = null;
  this.sc_Iterator$$anon$11__f_p$2 = null;
  this.sc_Iterator$$anon$11__f_p$2 = p$2;
  this.sc_Iterator$$anon$11__f_hdDefined = false;
  this.sc_Iterator$$anon$11__f_tail = outer
}
$c_sc_Iterator$$anon$11.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$11.prototype.constructor = $c_sc_Iterator$$anon$11;
/** @constructor */
function $h_sc_Iterator$$anon$11() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$11.prototype = $c_sc_Iterator$$anon$11.prototype;
$c_sc_Iterator$$anon$11.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$$anon$11__f_hdDefined) {
    return true
  } else if ($n(this.sc_Iterator$$anon$11__f_tail).hasNext__Z()) {
    this.sc_Iterator$$anon$11__f_hd = $n(this.sc_Iterator$$anon$11__f_tail).next__O();
    if ($uZ($n(this.sc_Iterator$$anon$11__f_p$2).apply__O__O(this.sc_Iterator$$anon$11__f_hd))) {
      this.sc_Iterator$$anon$11__f_hdDefined = true
    } else {
      this.sc_Iterator$$anon$11__f_tail = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
    };
    return this.sc_Iterator$$anon$11__f_hdDefined
  } else {
    return false
  }
});
$c_sc_Iterator$$anon$11.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$11__f_hdDefined = false;
    return this.sc_Iterator$$anon$11__f_hd
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
var $d_sc_Iterator$$anon$11 = new $TypeData().initClass({
  sc_Iterator$$anon$11: 0
}, false, "scala.collection.Iterator$$anon$11", {
  sc_Iterator$$anon$11: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$11.prototype.$classData = $d_sc_Iterator$$anon$11;
/** @constructor */
function $c_sc_Iterator$$anon$12(outer, p$3) {
  this.sc_Iterator$$anon$12__f_status = 0;
  this.sc_Iterator$$anon$12__f_fst = null;
  this.sc_Iterator$$anon$12__f_$outer = null;
  this.sc_Iterator$$anon$12__f_p$3 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$12__f_$outer = outer
  };
  this.sc_Iterator$$anon$12__f_p$3 = p$3;
  this.sc_Iterator$$anon$12__f_status = (-1)
}
$c_sc_Iterator$$anon$12.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$12.prototype.constructor = $c_sc_Iterator$$anon$12;
/** @constructor */
function $h_sc_Iterator$$anon$12() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$12.prototype = $c_sc_Iterator$$anon$12.prototype;
$c_sc_Iterator$$anon$12.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$12__f_status === 1)) {
    return $n(this.sc_Iterator$$anon$12__f_$outer).hasNext__Z()
  } else if ((this.sc_Iterator$$anon$12__f_status === 0)) {
    return true
  } else {
    while ($n(this.sc_Iterator$$anon$12__f_$outer).hasNext__Z()) {
      var a = $n(this.sc_Iterator$$anon$12__f_$outer).next__O();
      if ((!$uZ($n(this.sc_Iterator$$anon$12__f_p$3).apply__O__O(a)))) {
        this.sc_Iterator$$anon$12__f_fst = a;
        this.sc_Iterator$$anon$12__f_status = 0;
        return true
      }
    };
    this.sc_Iterator$$anon$12__f_status = 1;
    return false
  }
});
$c_sc_Iterator$$anon$12.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    if ((this.sc_Iterator$$anon$12__f_status === 1)) {
      return $n(this.sc_Iterator$$anon$12__f_$outer).next__O()
    } else {
      this.sc_Iterator$$anon$12__f_status = 1;
      return this.sc_Iterator$$anon$12__f_fst
    }
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
var $d_sc_Iterator$$anon$12 = new $TypeData().initClass({
  sc_Iterator$$anon$12: 0
}, false, "scala.collection.Iterator$$anon$12", {
  sc_Iterator$$anon$12: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$12.prototype.$classData = $d_sc_Iterator$$anon$12;
/** @constructor */
function $c_sc_Iterator$$anon$14(outer, that$1) {
  this.sc_Iterator$$anon$14__f_thatIterator = null;
  this.sc_Iterator$$anon$14__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$14__f_$outer = outer
  };
  this.sc_Iterator$$anon$14__f_thatIterator = $n(that$1).iterator__sc_Iterator()
}
$c_sc_Iterator$$anon$14.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$14.prototype.constructor = $c_sc_Iterator$$anon$14;
/** @constructor */
function $h_sc_Iterator$$anon$14() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$14.prototype = $c_sc_Iterator$$anon$14.prototype;
$c_sc_Iterator$$anon$14.prototype.knownSize__I = (function() {
  var x = $n(this.sc_Iterator$$anon$14__f_$outer).knownSize__I();
  var that = $n(this.sc_Iterator$$anon$14__f_thatIterator).knownSize__I();
  return ((x < that) ? x : that)
});
$c_sc_Iterator$$anon$14.prototype.hasNext__Z = (function() {
  return ($n(this.sc_Iterator$$anon$14__f_$outer).hasNext__Z() && $n(this.sc_Iterator$$anon$14__f_thatIterator).hasNext__Z())
});
$c_sc_Iterator$$anon$14.prototype.next__T2 = (function() {
  return $ct_T2__O__O__(new $c_T2(), $n(this.sc_Iterator$$anon$14__f_$outer).next__O(), $n(this.sc_Iterator$$anon$14__f_thatIterator).next__O())
});
$c_sc_Iterator$$anon$14.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sc_Iterator$$anon$14 = new $TypeData().initClass({
  sc_Iterator$$anon$14: 0
}, false, "scala.collection.Iterator$$anon$14", {
  sc_Iterator$$anon$14: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$14.prototype.$classData = $d_sc_Iterator$$anon$14;
/** @constructor */
function $c_sc_Iterator$$anon$16(outer) {
  this.sc_Iterator$$anon$16__f_idx = 0;
  this.sc_Iterator$$anon$16__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$16__f_$outer = outer
  };
  this.sc_Iterator$$anon$16__f_idx = 0
}
$c_sc_Iterator$$anon$16.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$16.prototype.constructor = $c_sc_Iterator$$anon$16;
/** @constructor */
function $h_sc_Iterator$$anon$16() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$16.prototype = $c_sc_Iterator$$anon$16.prototype;
$c_sc_Iterator$$anon$16.prototype.knownSize__I = (function() {
  return $n(this.sc_Iterator$$anon$16__f_$outer).knownSize__I()
});
$c_sc_Iterator$$anon$16.prototype.hasNext__Z = (function() {
  return $n(this.sc_Iterator$$anon$16__f_$outer).hasNext__Z()
});
$c_sc_Iterator$$anon$16.prototype.next__T2 = (function() {
  var ret = $ct_T2__O__O__(new $c_T2(), $n(this.sc_Iterator$$anon$16__f_$outer).next__O(), this.sc_Iterator$$anon$16__f_idx);
  this.sc_Iterator$$anon$16__f_idx = ((1 + this.sc_Iterator$$anon$16__f_idx) | 0);
  return ret
});
$c_sc_Iterator$$anon$16.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sc_Iterator$$anon$16 = new $TypeData().initClass({
  sc_Iterator$$anon$16: 0
}, false, "scala.collection.Iterator$$anon$16", {
  sc_Iterator$$anon$16: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$16.prototype.$classData = $d_sc_Iterator$$anon$16;
/** @constructor */
function $c_sc_Iterator$$anon$17(outer, from$1, replaced$1, patchElems$1) {
  this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems = null;
  this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state = 0;
  this.sc_Iterator$$anon$17__f_replaced$1 = 0;
  this.sc_Iterator$$anon$17__f_patchElems$1 = null;
  this.sc_Iterator$$anon$17__f_replaced$1 = replaced$1;
  this.sc_Iterator$$anon$17__f_patchElems$1 = patchElems$1;
  this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems = outer;
  this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state = ((from$1 > 0) ? from$1 : 0)
}
$c_sc_Iterator$$anon$17.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$17.prototype.constructor = $c_sc_Iterator$$anon$17;
/** @constructor */
function $h_sc_Iterator$$anon$17() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$17.prototype = $c_sc_Iterator$$anon$17.prototype;
$c_sc_Iterator$$anon$17.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state === 0)) {
    this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems = $n(this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems).drop__I__sc_Iterator(this.sc_Iterator$$anon$17__f_replaced$1);
    this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state = (-1)
  };
  return ($n(this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems).hasNext__Z() || $n(this.sc_Iterator$$anon$17__f_patchElems$1).hasNext__Z())
});
$c_sc_Iterator$$anon$17.prototype.next__O = (function() {
  if ((this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state === 0)) {
    this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems = $n(this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems).drop__I__sc_Iterator(this.sc_Iterator$$anon$17__f_replaced$1);
    this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state = (-1)
  };
  if ((this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state < 0)) {
    return ($n(this.sc_Iterator$$anon$17__f_patchElems$1).hasNext__Z() ? $n(this.sc_Iterator$$anon$17__f_patchElems$1).next__O() : $n(this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems).next__O())
  } else if ($n(this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems).hasNext__Z()) {
    this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state = (((-1) + this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state) | 0);
    return $n(this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$origElems).next__O()
  } else {
    this.sc_Iterator$$anon$17__f_scala$collection$Iterator$$anon$$state = (-1);
    return $n(this.sc_Iterator$$anon$17__f_patchElems$1).next__O()
  }
});
var $d_sc_Iterator$$anon$17 = new $TypeData().initClass({
  sc_Iterator$$anon$17: 0
}, false, "scala.collection.Iterator$$anon$17", {
  sc_Iterator$$anon$17: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$17.prototype.$classData = $d_sc_Iterator$$anon$17;
/** @constructor */
function $c_sc_Iterator$$anon$19() {
  /*<skip>*/
}
$c_sc_Iterator$$anon$19.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$19.prototype.constructor = $c_sc_Iterator$$anon$19;
/** @constructor */
function $h_sc_Iterator$$anon$19() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$19.prototype = $c_sc_Iterator$$anon$19.prototype;
$c_sc_Iterator$$anon$19.prototype.hasNext__Z = (function() {
  return false
});
$c_sc_Iterator$$anon$19.prototype.next__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
});
$c_sc_Iterator$$anon$19.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_Iterator$$anon$19.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return this
});
$c_sc_Iterator$$anon$19.prototype.next__O = (function() {
  this.next__E()
});
var $d_sc_Iterator$$anon$19 = new $TypeData().initClass({
  sc_Iterator$$anon$19: 0
}, false, "scala.collection.Iterator$$anon$19", {
  sc_Iterator$$anon$19: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$19.prototype.$classData = $d_sc_Iterator$$anon$19;
/** @constructor */
function $c_sc_Iterator$$anon$20(a$1) {
  this.sc_Iterator$$anon$20__f_consumed = false;
  this.sc_Iterator$$anon$20__f_a$1 = null;
  this.sc_Iterator$$anon$20__f_a$1 = a$1;
  this.sc_Iterator$$anon$20__f_consumed = false
}
$c_sc_Iterator$$anon$20.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$20.prototype.constructor = $c_sc_Iterator$$anon$20;
/** @constructor */
function $h_sc_Iterator$$anon$20() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$20.prototype = $c_sc_Iterator$$anon$20.prototype;
$c_sc_Iterator$$anon$20.prototype.hasNext__Z = (function() {
  return (!this.sc_Iterator$$anon$20__f_consumed)
});
$c_sc_Iterator$$anon$20.prototype.next__O = (function() {
  if (this.sc_Iterator$$anon$20__f_consumed) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  } else {
    this.sc_Iterator$$anon$20__f_consumed = true;
    return this.sc_Iterator$$anon$20__f_a$1
  }
});
$c_sc_Iterator$$anon$20.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return (((this.sc_Iterator$$anon$20__f_consumed || (from > 0)) || (until === 0)) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : this)
});
var $d_sc_Iterator$$anon$20 = new $TypeData().initClass({
  sc_Iterator$$anon$20: 0
}, false, "scala.collection.Iterator$$anon$20", {
  sc_Iterator$$anon$20: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$20.prototype.$classData = $d_sc_Iterator$$anon$20;
/** @constructor */
function $c_sc_Iterator$$anon$3(outer, z$1, op$1) {
  this.sc_Iterator$$anon$3__f_scala$collection$Iterator$$anon$$current = null;
  this.sc_Iterator$$anon$3__f_$outer = null;
  this.sc_Iterator$$anon$3__f_z$1 = null;
  this.sc_Iterator$$anon$3__f_op$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$3__f_$outer = outer
  };
  this.sc_Iterator$$anon$3__f_z$1 = z$1;
  this.sc_Iterator$$anon$3__f_op$1 = op$1;
  this.sc_Iterator$$anon$3__f_scala$collection$Iterator$$anon$$current = new $c_sc_Iterator$$anon$3$$anon$4(this)
}
$c_sc_Iterator$$anon$3.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$3.prototype.constructor = $c_sc_Iterator$$anon$3;
/** @constructor */
function $h_sc_Iterator$$anon$3() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$3.prototype = $c_sc_Iterator$$anon$3.prototype;
$c_sc_Iterator$$anon$3.prototype.knownSize__I = (function() {
  return $n(this.sc_Iterator$$anon$3__f_scala$collection$Iterator$$anon$$current).knownSize__I()
});
$c_sc_Iterator$$anon$3.prototype.next__O = (function() {
  return $n(this.sc_Iterator$$anon$3__f_scala$collection$Iterator$$anon$$current).next__O()
});
$c_sc_Iterator$$anon$3.prototype.hasNext__Z = (function() {
  return $n(this.sc_Iterator$$anon$3__f_scala$collection$Iterator$$anon$$current).hasNext__Z()
});
var $d_sc_Iterator$$anon$3 = new $TypeData().initClass({
  sc_Iterator$$anon$3: 0
}, false, "scala.collection.Iterator$$anon$3", {
  sc_Iterator$$anon$3: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$3.prototype.$classData = $d_sc_Iterator$$anon$3;
/** @constructor */
function $c_sc_Iterator$$anon$3$$anon$4(outer) {
  this.sc_Iterator$$anon$3$$anon$4__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$3$$anon$4__f_$outer = outer
  }
}
$c_sc_Iterator$$anon$3$$anon$4.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$3$$anon$4.prototype.constructor = $c_sc_Iterator$$anon$3$$anon$4;
/** @constructor */
function $h_sc_Iterator$$anon$3$$anon$4() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$3$$anon$4.prototype = $c_sc_Iterator$$anon$3$$anon$4.prototype;
$c_sc_Iterator$$anon$3$$anon$4.prototype.knownSize__I = (function() {
  var thisSize = $n($n(this.sc_Iterator$$anon$3$$anon$4__f_$outer).sc_Iterator$$anon$3__f_$outer).knownSize__I();
  return ((thisSize < 0) ? (-1) : ((1 + thisSize) | 0))
});
$c_sc_Iterator$$anon$3$$anon$4.prototype.hasNext__Z = (function() {
  return true
});
$c_sc_Iterator$$anon$3$$anon$4.prototype.next__O = (function() {
  $n(this.sc_Iterator$$anon$3$$anon$4__f_$outer).sc_Iterator$$anon$3__f_scala$collection$Iterator$$anon$$current = new $c_sc_Iterator$$anon$3$$anon$4$$anon$5(this);
  return $n(this.sc_Iterator$$anon$3$$anon$4__f_$outer).sc_Iterator$$anon$3__f_z$1
});
var $d_sc_Iterator$$anon$3$$anon$4 = new $TypeData().initClass({
  sc_Iterator$$anon$3$$anon$4: 0
}, false, "scala.collection.Iterator$$anon$3$$anon$4", {
  sc_Iterator$$anon$3$$anon$4: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$3$$anon$4.prototype.$classData = $d_sc_Iterator$$anon$3$$anon$4;
/** @constructor */
function $c_sc_Iterator$$anon$3$$anon$4$$anon$5(outer) {
  this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_acc = null;
  this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_$outer = outer
  };
  this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_acc = $n($n(outer).sc_Iterator$$anon$3$$anon$4__f_$outer).sc_Iterator$$anon$3__f_z$1
}
$c_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype.constructor = $c_sc_Iterator$$anon$3$$anon$4$$anon$5;
/** @constructor */
function $h_sc_Iterator$$anon$3$$anon$4$$anon$5() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype = $c_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype;
$c_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype.next__O = (function() {
  this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_acc = $n($n($n(this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_$outer).sc_Iterator$$anon$3$$anon$4__f_$outer).sc_Iterator$$anon$3__f_op$1).apply__O__O__O(this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_acc, $n($n($n(this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_$outer).sc_Iterator$$anon$3$$anon$4__f_$outer).sc_Iterator$$anon$3__f_$outer).next__O());
  return this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_acc
});
$c_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype.hasNext__Z = (function() {
  return $n($n($n(this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_$outer).sc_Iterator$$anon$3$$anon$4__f_$outer).sc_Iterator$$anon$3__f_$outer).hasNext__Z()
});
$c_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype.knownSize__I = (function() {
  return $n($n($n(this.sc_Iterator$$anon$3$$anon$4$$anon$5__f_$outer).sc_Iterator$$anon$3$$anon$4__f_$outer).sc_Iterator$$anon$3__f_$outer).knownSize__I()
});
var $d_sc_Iterator$$anon$3$$anon$4$$anon$5 = new $TypeData().initClass({
  sc_Iterator$$anon$3$$anon$4$$anon$5: 0
}, false, "scala.collection.Iterator$$anon$3$$anon$4$$anon$5", {
  sc_Iterator$$anon$3$$anon$4$$anon$5: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$3$$anon$4$$anon$5.prototype.$classData = $d_sc_Iterator$$anon$3$$anon$4$$anon$5;
/** @constructor */
function $c_sc_Iterator$$anon$6(outer, p$1, isFlipped$1) {
  this.sc_Iterator$$anon$6__f_hd = null;
  this.sc_Iterator$$anon$6__f_hdDefined = false;
  this.sc_Iterator$$anon$6__f_$outer = null;
  this.sc_Iterator$$anon$6__f_p$1 = null;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = false;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$6__f_$outer = outer
  };
  this.sc_Iterator$$anon$6__f_p$1 = p$1;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = isFlipped$1;
  this.sc_Iterator$$anon$6__f_hdDefined = false
}
$c_sc_Iterator$$anon$6.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$6.prototype.constructor = $c_sc_Iterator$$anon$6;
/** @constructor */
function $h_sc_Iterator$$anon$6() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$6.prototype = $c_sc_Iterator$$anon$6.prototype;
$c_sc_Iterator$$anon$6.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$$anon$6__f_hdDefined) {
    return true
  } else {
    if ((!$n(this.sc_Iterator$$anon$6__f_$outer).hasNext__Z())) {
      return false
    };
    this.sc_Iterator$$anon$6__f_hd = $n(this.sc_Iterator$$anon$6__f_$outer).next__O();
    while (($uZ($n(this.sc_Iterator$$anon$6__f_p$1).apply__O__O(this.sc_Iterator$$anon$6__f_hd)) === this.sc_Iterator$$anon$6__f_isFlipped$1)) {
      if ((!$n(this.sc_Iterator$$anon$6__f_$outer).hasNext__Z())) {
        return false
      };
      this.sc_Iterator$$anon$6__f_hd = $n(this.sc_Iterator$$anon$6__f_$outer).next__O()
    };
    this.sc_Iterator$$anon$6__f_hdDefined = true;
    return true
  }
});
$c_sc_Iterator$$anon$6.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$6__f_hdDefined = false;
    return this.sc_Iterator$$anon$6__f_hd
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
var $d_sc_Iterator$$anon$6 = new $TypeData().initClass({
  sc_Iterator$$anon$6: 0
}, false, "scala.collection.Iterator$$anon$6", {
  sc_Iterator$$anon$6: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$6.prototype.$classData = $d_sc_Iterator$$anon$6;
/** @constructor */
function $c_sc_Iterator$$anon$8(outer, f$1) {
  this.sc_Iterator$$anon$8__f_traversedValues = null;
  this.sc_Iterator$$anon$8__f_nextElementDefined = false;
  this.sc_Iterator$$anon$8__f_nextElement = null;
  this.sc_Iterator$$anon$8__f_$outer = null;
  this.sc_Iterator$$anon$8__f_f$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$8__f_$outer = outer
  };
  this.sc_Iterator$$anon$8__f_f$1 = f$1;
  this.sc_Iterator$$anon$8__f_traversedValues = $ct_scm_HashSet__(new $c_scm_HashSet());
  this.sc_Iterator$$anon$8__f_nextElementDefined = false
}
$c_sc_Iterator$$anon$8.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$8.prototype.constructor = $c_sc_Iterator$$anon$8;
/** @constructor */
function $h_sc_Iterator$$anon$8() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$8.prototype = $c_sc_Iterator$$anon$8.prototype;
$c_sc_Iterator$$anon$8.prototype.hasNext__Z = (function() {
  while (true) {
    if (this.sc_Iterator$$anon$8__f_nextElementDefined) {
      return true
    } else if ($n(this.sc_Iterator$$anon$8__f_$outer).hasNext__Z()) {
      var a = $n(this.sc_Iterator$$anon$8__f_$outer).next__O();
      if ($n(this.sc_Iterator$$anon$8__f_traversedValues).add__O__Z($n(this.sc_Iterator$$anon$8__f_f$1).apply__O__O(a))) {
        this.sc_Iterator$$anon$8__f_nextElement = a;
        this.sc_Iterator$$anon$8__f_nextElementDefined = true;
        return true
      }
    } else {
      return false
    }
  }
});
$c_sc_Iterator$$anon$8.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$8__f_nextElementDefined = false;
    return this.sc_Iterator$$anon$8__f_nextElement
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
var $d_sc_Iterator$$anon$8 = new $TypeData().initClass({
  sc_Iterator$$anon$8: 0
}, false, "scala.collection.Iterator$$anon$8", {
  sc_Iterator$$anon$8: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$8.prototype.$classData = $d_sc_Iterator$$anon$8;
/** @constructor */
function $c_sc_Iterator$$anon$9(outer, f$2) {
  this.sc_Iterator$$anon$9__f_$outer = null;
  this.sc_Iterator$$anon$9__f_f$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$9__f_$outer = outer
  };
  this.sc_Iterator$$anon$9__f_f$2 = f$2
}
$c_sc_Iterator$$anon$9.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$9.prototype.constructor = $c_sc_Iterator$$anon$9;
/** @constructor */
function $h_sc_Iterator$$anon$9() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$9.prototype = $c_sc_Iterator$$anon$9.prototype;
$c_sc_Iterator$$anon$9.prototype.knownSize__I = (function() {
  return $n(this.sc_Iterator$$anon$9__f_$outer).knownSize__I()
});
$c_sc_Iterator$$anon$9.prototype.hasNext__Z = (function() {
  return $n(this.sc_Iterator$$anon$9__f_$outer).hasNext__Z()
});
$c_sc_Iterator$$anon$9.prototype.next__O = (function() {
  return $n(this.sc_Iterator$$anon$9__f_f$2).apply__O__O($n(this.sc_Iterator$$anon$9__f_$outer).next__O())
});
var $d_sc_Iterator$$anon$9 = new $TypeData().initClass({
  sc_Iterator$$anon$9: 0
}, false, "scala.collection.Iterator$$anon$9", {
  sc_Iterator$$anon$9: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$9.prototype.$classData = $d_sc_Iterator$$anon$9;
function $p_sc_Iterator$ConcatIterator__merge$1__V($thiz) {
  while (($thiz.sc_Iterator$ConcatIterator__f_current instanceof $c_sc_Iterator$ConcatIterator)) {
    var c = $as_sc_Iterator$ConcatIterator($thiz.sc_Iterator$ConcatIterator__f_current);
    $thiz.sc_Iterator$ConcatIterator__f_current = $n(c).sc_Iterator$ConcatIterator__f_current;
    $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = $n(c).sc_Iterator$ConcatIterator__f_currentHasNextChecked;
    if (($n(c).sc_Iterator$ConcatIterator__f_tail !== null)) {
      if (($thiz.sc_Iterator$ConcatIterator__f_last === null)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = $n(c).sc_Iterator$ConcatIterator__f_last
      };
      $n($n(c).sc_Iterator$ConcatIterator__f_last).sc_Iterator$ConcatIteratorCell__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail;
      $thiz.sc_Iterator$ConcatIterator__f_tail = $n(c).sc_Iterator$ConcatIterator__f_tail
    }
  }
}
function $p_sc_Iterator$ConcatIterator__advance$1__Z($thiz) {
  while (true) {
    if (($thiz.sc_Iterator$ConcatIterator__f_tail === null)) {
      $thiz.sc_Iterator$ConcatIterator__f_current = null;
      $thiz.sc_Iterator$ConcatIterator__f_last = null;
      return false
    } else {
      $thiz.sc_Iterator$ConcatIterator__f_current = $n($thiz.sc_Iterator$ConcatIterator__f_tail).headIterator__sc_Iterator();
      if (($thiz.sc_Iterator$ConcatIterator__f_last === $thiz.sc_Iterator$ConcatIterator__f_tail)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = $n($thiz.sc_Iterator$ConcatIterator__f_last).sc_Iterator$ConcatIteratorCell__f_tail
      };
      $thiz.sc_Iterator$ConcatIterator__f_tail = $n($thiz.sc_Iterator$ConcatIterator__f_tail).sc_Iterator$ConcatIteratorCell__f_tail;
      $p_sc_Iterator$ConcatIterator__merge$1__V($thiz);
      if ($thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
        return true
      } else if ((($thiz.sc_Iterator$ConcatIterator__f_current !== null) && $n($thiz.sc_Iterator$ConcatIterator__f_current).hasNext__Z())) {
        $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
        return true
      }
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIterator(current) {
  this.sc_Iterator$ConcatIterator__f_current = null;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
  this.sc_Iterator$ConcatIterator__f_current = current;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false
}
$c_sc_Iterator$ConcatIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$ConcatIterator.prototype.constructor = $c_sc_Iterator$ConcatIterator;
/** @constructor */
function $h_sc_Iterator$ConcatIterator() {
  /*<skip>*/
}
$h_sc_Iterator$ConcatIterator.prototype = $c_sc_Iterator$ConcatIterator.prototype;
$c_sc_Iterator$ConcatIterator.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
    return true
  } else if ((this.sc_Iterator$ConcatIterator__f_current !== null)) {
    if ($n(this.sc_Iterator$ConcatIterator__f_current).hasNext__Z()) {
      this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
      return true
    } else {
      return $p_sc_Iterator$ConcatIterator__advance$1__Z(this)
    }
  } else {
    return false
  }
});
$c_sc_Iterator$ConcatIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
    return $n(this.sc_Iterator$ConcatIterator__f_current).next__O()
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
$c_sc_Iterator$ConcatIterator.prototype.concat__F0__sc_Iterator = (function(that) {
  var c = new $c_sc_Iterator$ConcatIteratorCell(that, null);
  if ((this.sc_Iterator$ConcatIterator__f_tail === null)) {
    this.sc_Iterator$ConcatIterator__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c
  } else {
    $n(this.sc_Iterator$ConcatIterator__f_last).sc_Iterator$ConcatIteratorCell__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c
  };
  if ((this.sc_Iterator$ConcatIterator__f_current === null)) {
    this.sc_Iterator$ConcatIterator__f_current = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  };
  return this
});
function $as_sc_Iterator$ConcatIterator(obj) {
  return (((obj instanceof $c_sc_Iterator$ConcatIterator) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator$ConcatIterator"))
}
function $isArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator$ConcatIterator)))
}
function $asArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (($isArrayOf_sc_Iterator$ConcatIterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator$ConcatIterator;", depth))
}
var $d_sc_Iterator$ConcatIterator = new $TypeData().initClass({
  sc_Iterator$ConcatIterator: 0
}, false, "scala.collection.Iterator$ConcatIterator", {
  sc_Iterator$ConcatIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$ConcatIterator.prototype.$classData = $d_sc_Iterator$ConcatIterator;
function $p_sc_Iterator$GroupedIterator__pad__Z($thiz) {
  return ($thiz.sc_Iterator$GroupedIterator__f_padding !== null)
}
function $p_sc_Iterator$GroupedIterator__newBuilder__scm_ArrayBuilder($thiz) {
  $m_s_reflect_ManifestFactory$AnyManifest$();
  var b = new $c_scm_ArrayBuilder$generic($d_O.getClassOf());
  var k = $n($thiz.sc_Iterator$GroupedIterator__f_self).knownSize__I();
  if ((k > 0)) {
    var that = $thiz.sc_Iterator$GroupedIterator__f_size;
    b.sizeHint__I__V(((k < that) ? k : that))
  };
  return b
}
function $p_sc_Iterator$GroupedIterator__fulfill__Z($thiz) {
  var builder = $p_sc_Iterator$GroupedIterator__newBuilder__scm_ArrayBuilder($thiz);
  var done = false;
  if (($thiz.sc_Iterator$GroupedIterator__f_prev !== null)) {
    $n(builder).addAll__O__scm_ArrayBuilder($thiz.sc_Iterator$GroupedIterator__f_prev)
  };
  if (((!$thiz.sc_Iterator$GroupedIterator__f_first) && ($thiz.sc_Iterator$GroupedIterator__f_step > $thiz.sc_Iterator$GroupedIterator__f_size))) {
    var dropping = (($thiz.sc_Iterator$GroupedIterator__f_step - $thiz.sc_Iterator$GroupedIterator__f_size) | 0);
    while (((dropping > 0) && $n($thiz.sc_Iterator$GroupedIterator__f_self).hasNext__Z())) {
      $n($thiz.sc_Iterator$GroupedIterator__f_self).next__O();
      dropping = (((-1) + dropping) | 0)
    };
    done = (dropping > 0)
  };
  var index = $n(builder).length__I();
  if ((!done)) {
    while (((index < $thiz.sc_Iterator$GroupedIterator__f_size) && $n($thiz.sc_Iterator$GroupedIterator__f_self).hasNext__Z())) {
      var this$1 = $n(builder);
      var elem = $n($thiz.sc_Iterator$GroupedIterator__f_self).next__O();
      this$1.addOne__O__scm_ArrayBuilder$generic(elem);
      index = ((1 + index) | 0)
    };
    if (((index < $thiz.sc_Iterator$GroupedIterator__f_size) && $p_sc_Iterator$GroupedIterator__pad__Z($thiz))) {
      $n(builder).sizeHint__I__V($thiz.sc_Iterator$GroupedIterator__f_size);
      while ((index < $thiz.sc_Iterator$GroupedIterator__f_size)) {
        var this$2 = $n(builder);
        var elem$1 = $n($thiz.sc_Iterator$GroupedIterator__f_padding).apply__O();
        this$2.addOne__O__scm_ArrayBuilder$generic(elem$1);
        index = ((1 + index) | 0)
      }
    }
  };
  var ok = ((index > 0) && ($thiz.sc_Iterator$GroupedIterator__f_partial || (index === $thiz.sc_Iterator$GroupedIterator__f_size)));
  if (ok) {
    $thiz.sc_Iterator$GroupedIterator__f_buffer = $n(builder).result__O()
  } else {
    $thiz.sc_Iterator$GroupedIterator__f_prev = null
  };
  return ok
}
function $p_sc_Iterator$GroupedIterator__fill__Z($thiz) {
  if ($thiz.sc_Iterator$GroupedIterator__f_filled) {
    return true
  } else {
    $thiz.sc_Iterator$GroupedIterator__f_filled = ($n($thiz.sc_Iterator$GroupedIterator__f_self).hasNext__Z() && $p_sc_Iterator$GroupedIterator__fulfill__Z($thiz));
    return $thiz.sc_Iterator$GroupedIterator__f_filled
  }
}
/** @constructor */
function $c_sc_Iterator$GroupedIterator(outer, self, size, step) {
  this.sc_Iterator$GroupedIterator__f_self = null;
  this.sc_Iterator$GroupedIterator__f_size = 0;
  this.sc_Iterator$GroupedIterator__f_step = 0;
  this.sc_Iterator$GroupedIterator__f_buffer = null;
  this.sc_Iterator$GroupedIterator__f_prev = null;
  this.sc_Iterator$GroupedIterator__f_first = false;
  this.sc_Iterator$GroupedIterator__f_filled = false;
  this.sc_Iterator$GroupedIterator__f_partial = false;
  this.sc_Iterator$GroupedIterator__f_padding = null;
  this.sc_Iterator$GroupedIterator__f_self = self;
  this.sc_Iterator$GroupedIterator__f_size = size;
  this.sc_Iterator$GroupedIterator__f_step = step;
  if ((outer === null)) {
    $n(null)
  };
  var requirement = ((size >= 1) && (step >= 1));
  if ((!requirement)) {
    var $$x1 = $m_sc_StringOps$();
    var array = [this.sc_Iterator$GroupedIterator__f_size, this.sc_Iterator$GroupedIterator__f_step];
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("requirement failed: " + $n($$x1).format$extension__T__sci_Seq__T("size=%d and step=%d, but both must be positive", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))))
  };
  this.sc_Iterator$GroupedIterator__f_buffer = null;
  this.sc_Iterator$GroupedIterator__f_prev = null;
  this.sc_Iterator$GroupedIterator__f_first = true;
  this.sc_Iterator$GroupedIterator__f_filled = false;
  this.sc_Iterator$GroupedIterator__f_partial = true;
  this.sc_Iterator$GroupedIterator__f_padding = null
}
$c_sc_Iterator$GroupedIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$GroupedIterator.prototype.constructor = $c_sc_Iterator$GroupedIterator;
/** @constructor */
function $h_sc_Iterator$GroupedIterator() {
  /*<skip>*/
}
$h_sc_Iterator$GroupedIterator.prototype = $c_sc_Iterator$GroupedIterator.prototype;
$c_sc_Iterator$GroupedIterator.prototype.hasNext__Z = (function() {
  return $p_sc_Iterator$GroupedIterator__fill__Z(this)
});
$c_sc_Iterator$GroupedIterator.prototype.next__sci_Seq = (function() {
  if ((!$p_sc_Iterator$GroupedIterator__fill__Z(this))) {
    return $as_sci_Seq($n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O())
  } else {
    this.sc_Iterator$GroupedIterator__f_filled = false;
    if ((this.sc_Iterator$GroupedIterator__f_step < this.sc_Iterator$GroupedIterator__f_size)) {
      if (this.sc_Iterator$GroupedIterator__f_first) {
        var $$x1 = $m_sc_ArrayOps$();
        var xs = this.sc_Iterator$GroupedIterator__f_buffer;
        this.sc_Iterator$GroupedIterator__f_prev = $n($$x1).drop$extension__O__I__O(xs, this.sc_Iterator$GroupedIterator__f_step)
      } else {
        var xs$1 = this.sc_Iterator$GroupedIterator__f_buffer;
        if (($m_jl_reflect_Array$().getLength__O__I(xs$1) === this.sc_Iterator$GroupedIterator__f_size)) {
          $m_s_Array$().copy__O__I__O__I__I__V(this.sc_Iterator$GroupedIterator__f_buffer, this.sc_Iterator$GroupedIterator__f_step, this.sc_Iterator$GroupedIterator__f_prev, 0, ((this.sc_Iterator$GroupedIterator__f_size - this.sc_Iterator$GroupedIterator__f_step) | 0))
        } else {
          this.sc_Iterator$GroupedIterator__f_prev = null
        }
      }
    };
    var res = $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(this.sc_Iterator$GroupedIterator__f_buffer);
    this.sc_Iterator$GroupedIterator__f_buffer = null;
    this.sc_Iterator$GroupedIterator__f_first = false;
    return res
  }
});
$c_sc_Iterator$GroupedIterator.prototype.next__O = (function() {
  return this.next__sci_Seq()
});
var $d_sc_Iterator$GroupedIterator = new $TypeData().initClass({
  sc_Iterator$GroupedIterator: 0
}, false, "scala.collection.Iterator$GroupedIterator", {
  sc_Iterator$GroupedIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$GroupedIterator.prototype.$classData = $d_sc_Iterator$GroupedIterator;
function $p_sc_Iterator$SliceIterator__skip__V($thiz) {
  while (($thiz.sc_Iterator$SliceIterator__f_dropping > 0)) {
    if ($n($thiz.sc_Iterator$SliceIterator__f_underlying).hasNext__Z()) {
      $n($thiz.sc_Iterator$SliceIterator__f_underlying).next__O();
      $thiz.sc_Iterator$SliceIterator__f_dropping = (((-1) + $thiz.sc_Iterator$SliceIterator__f_dropping) | 0)
    } else {
      $thiz.sc_Iterator$SliceIterator__f_dropping = 0
    }
  }
}
function $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I($thiz, lo$1) {
  if (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    return (-1)
  } else {
    var that = (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining - lo$1) | 0);
    return ((that < 0) ? 0 : that)
  }
}
/** @constructor */
function $c_sc_Iterator$SliceIterator(underlying, start, limit) {
  this.sc_Iterator$SliceIterator__f_underlying = null;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = 0;
  this.sc_Iterator$SliceIterator__f_dropping = 0;
  this.sc_Iterator$SliceIterator__f_underlying = underlying;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = limit;
  this.sc_Iterator$SliceIterator__f_dropping = start
}
$c_sc_Iterator$SliceIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$SliceIterator.prototype.constructor = $c_sc_Iterator$SliceIterator;
/** @constructor */
function $h_sc_Iterator$SliceIterator() {
  /*<skip>*/
}
$h_sc_Iterator$SliceIterator.prototype = $c_sc_Iterator$SliceIterator.prototype;
$c_sc_Iterator$SliceIterator.prototype.knownSize__I = (function() {
  var size = $n(this.sc_Iterator$SliceIterator__f_underlying).knownSize__I();
  if ((size < 0)) {
    return (-1)
  } else {
    var that = ((size - this.sc_Iterator$SliceIterator__f_dropping) | 0);
    var dropSize = ((that < 0) ? 0 : that);
    if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
      return dropSize
    } else {
      var x = this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining;
      return ((x < dropSize) ? x : dropSize)
    }
  }
});
$c_sc_Iterator$SliceIterator.prototype.hasNext__Z = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining !== 0) && $n(this.sc_Iterator$SliceIterator__f_underlying).hasNext__Z())
});
$c_sc_Iterator$SliceIterator.prototype.next__O = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining > 0)) {
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = (((-1) + this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining) | 0);
    return $n(this.sc_Iterator$SliceIterator__f_underlying).next__O()
  } else {
    return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0) ? $n(this.sc_Iterator$SliceIterator__f_underlying).next__O() : $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O())
  }
});
$c_sc_Iterator$SliceIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  if ((until < 0)) {
    var rest = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo)
  } else if ((until <= lo)) {
    var rest = 0
  } else if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    var rest = ((until - lo) | 0)
  } else {
    var x = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
    var that = ((until - lo) | 0);
    var rest = ((x < that) ? x : that)
  };
  if ((rest === 0)) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  } else {
    this.sc_Iterator$SliceIterator__f_dropping = ((this.sc_Iterator$SliceIterator__f_dropping + lo) | 0);
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = rest;
    return this
  }
});
var $d_sc_Iterator$SliceIterator = new $TypeData().initClass({
  sc_Iterator$SliceIterator: 0
}, false, "scala.collection.Iterator$SliceIterator", {
  sc_Iterator$SliceIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$SliceIterator.prototype.$classData = $d_sc_Iterator$SliceIterator;
/** @constructor */
function $c_sc_LinearSeqIterator(coll) {
  this.sc_LinearSeqIterator__f_these = null;
  this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0((() => coll)))
}
$c_sc_LinearSeqIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_LinearSeqIterator.prototype.constructor = $c_sc_LinearSeqIterator;
/** @constructor */
function $h_sc_LinearSeqIterator() {
  /*<skip>*/
}
$h_sc_LinearSeqIterator.prototype = $c_sc_LinearSeqIterator.prototype;
$c_sc_LinearSeqIterator.prototype.hasNext__Z = (function() {
  var this$1 = $n($n(this.sc_LinearSeqIterator__f_these).v__sc_LinearSeqOps());
  return (!this$1.isEmpty__Z())
});
$c_sc_LinearSeqIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  } else {
    var cur = $n(this.sc_LinearSeqIterator__f_these).v__sc_LinearSeqOps();
    var result = $n(cur).head__O();
    this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0((() => $as_sc_LinearSeq($n(cur).tail__O()))));
    return result
  }
});
var $d_sc_LinearSeqIterator = new $TypeData().initClass({
  sc_LinearSeqIterator: 0
}, false, "scala.collection.LinearSeqIterator", {
  sc_LinearSeqIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_LinearSeqIterator.prototype.$classData = $d_sc_LinearSeqIterator;
function $f_sc_LinearSeqOps__headOption__s_Option($thiz) {
  return ($thiz.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($thiz.head__O()))
}
function $f_sc_LinearSeqOps__iterator__sc_Iterator($thiz) {
  return (($thiz.knownSize__I() === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_LinearSeqIterator($thiz))
}
function $f_sc_LinearSeqOps__length__I($thiz) {
  var these = $as_sc_LinearSeq($thiz);
  var len = 0;
  while (true) {
    var this$1 = $n(these);
    if ((!this$1.isEmpty__Z())) {
      len = ((1 + len) | 0);
      these = $as_sc_LinearSeq($n(these).tail__O())
    } else {
      break
    }
  };
  return len
}
function $f_sc_LinearSeqOps__last__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "LinearSeq.last")
  } else {
    var these = $as_sc_LinearSeq($thiz);
    var scout = $as_sc_LinearSeq($thiz.tail__O());
    while (true) {
      var this$1 = $n(scout);
      if ((!this$1.isEmpty__Z())) {
        these = scout;
        scout = $as_sc_LinearSeq($n(scout).tail__O())
      } else {
        break
      }
    };
    return $n(these).head__O()
  }
}
function $f_sc_LinearSeqOps__lengthCompare__I__I($thiz, len) {
  return ((len < 0) ? 1 : $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, 0, $as_sc_LinearSeq($thiz), len))
}
function $f_sc_LinearSeqOps__isDefinedAt__I__Z($thiz, x) {
  return ((x >= 0) && ($thiz.lengthCompare__I__I(x) > 0))
}
function $f_sc_LinearSeqOps__apply__I__O($thiz, n) {
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  var skipped = $as_sc_LinearSeq($thiz.drop__I__O(n));
  if ($n(skipped).isEmpty__Z()) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  return $n(skipped).head__O()
}
function $f_sc_LinearSeqOps__foreach__F1__V($thiz, f) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    $n(f).apply__O__O($n(these).head__O());
    these = $as_sc_LinearSeq($n(these).tail__O())
  }
}
function $f_sc_LinearSeqOps__forall__F1__Z($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    if ((!$uZ($n(p).apply__O__O($n(these).head__O())))) {
      return false
    };
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return true
}
function $f_sc_LinearSeqOps__exists__F1__Z($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return true
    };
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return false
}
function $f_sc_LinearSeqOps__contains__O__Z($thiz, elem) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n(these).head__O(), elem)) {
      return true
    };
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return false
}
function $f_sc_LinearSeqOps__find__F1__s_Option($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return new $c_s_Some($n(these).head__O())
    };
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return $m_s_None$()
}
function $f_sc_LinearSeqOps__foldLeft__O__F2__O($thiz, z, op) {
  var acc = z;
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    acc = $n(op).apply__O__O__O(acc, $n(these).head__O());
    these = $as_sc_LinearSeq($n(these).tail__O())
  };
  return acc
}
function $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  if ($is_sc_LinearSeq(that)) {
    var x2 = $as_sc_LinearSeq(that);
    return $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, $as_sc_LinearSeq($thiz), x2)
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that)
  }
}
function $f_sc_LinearSeqOps__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var these = $as_sc_LinearSeq($thiz.drop__I__O(from));
  while (true) {
    var this$3 = $n(these);
    if ((!this$3.isEmpty__Z())) {
      if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
        return i
      };
      i = ((1 + i) | 0);
      these = $as_sc_LinearSeq($n(these).tail__O())
    } else {
      break
    }
  };
  return (-1)
}
function $f_sc_LinearSeqOps__lastIndexWhere__F1__I__I($thiz, p, end) {
  var i = 0;
  var these = $as_sc_LinearSeq($thiz);
  var last = (-1);
  while (((!$n(these).isEmpty__Z()) && (i <= end))) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      last = i
    };
    these = $as_sc_LinearSeq($n(these).tail__O());
    i = ((1 + i) | 0)
  };
  return last
}
function $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return ($n(xs).isEmpty__Z() ? 0 : 1)
    } else if ($n(xs).isEmpty__Z()) {
      return (-1)
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sc_LinearSeq($n(xs).tail__O());
      i = temp$i;
      xs = temp$xs
    }
  }
}
function $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true
    } else {
      var this$1 = $n(a);
      if ((!this$1.isEmpty__Z())) {
        var this$2 = $n(b);
        var $$x1 = (!this$2.isEmpty__Z())
      } else {
        var $$x1 = false
      };
      if (($$x1 && $m_sr_BoxesRunTime$().equals__O__O__Z($n(a).head__O(), $n(b).head__O()))) {
        var temp$a = $as_sc_LinearSeq($n(a).tail__O());
        var temp$b = $as_sc_LinearSeq($n(b).tail__O());
        a = temp$a;
        b = temp$b
      } else {
        return ($n(a).isEmpty__Z() && $n(b).isEmpty__Z())
      }
    }
  }
}
function $is_sc_LinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeqOps)))
}
function $as_sc_LinearSeqOps(obj) {
  return (($is_sc_LinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeqOps"))
}
function $isArrayOf_sc_LinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeqOps)))
}
function $asArrayOf_sc_LinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_LinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeqOps;", depth))
}
/** @constructor */
function $c_sc_MapOps$$anon$2(outer) {
  this.sc_MapOps$$anon$2__f_iter = null;
  this.sc_MapOps$$anon$2__f_iter = $n(outer).iterator__sc_Iterator()
}
$c_sc_MapOps$$anon$2.prototype = new $h_sc_AbstractIterator();
$c_sc_MapOps$$anon$2.prototype.constructor = $c_sc_MapOps$$anon$2;
/** @constructor */
function $h_sc_MapOps$$anon$2() {
  /*<skip>*/
}
$h_sc_MapOps$$anon$2.prototype = $c_sc_MapOps$$anon$2.prototype;
$c_sc_MapOps$$anon$2.prototype.hasNext__Z = (function() {
  return $n(this.sc_MapOps$$anon$2__f_iter).hasNext__Z()
});
$c_sc_MapOps$$anon$2.prototype.next__O = (function() {
  return $n($as_T2($n(this.sc_MapOps$$anon$2__f_iter).next__O()))._1__O()
});
var $d_sc_MapOps$$anon$2 = new $TypeData().initClass({
  sc_MapOps$$anon$2: 0
}, false, "scala.collection.MapOps$$anon$2", {
  sc_MapOps$$anon$2: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_MapOps$$anon$2.prototype.$classData = $d_sc_MapOps$$anon$2;
/** @constructor */
function $c_sc_MapOps$$anon$3(outer) {
  this.sc_MapOps$$anon$3__f_iter = null;
  this.sc_MapOps$$anon$3__f_iter = $n(outer).iterator__sc_Iterator()
}
$c_sc_MapOps$$anon$3.prototype = new $h_sc_AbstractIterator();
$c_sc_MapOps$$anon$3.prototype.constructor = $c_sc_MapOps$$anon$3;
/** @constructor */
function $h_sc_MapOps$$anon$3() {
  /*<skip>*/
}
$h_sc_MapOps$$anon$3.prototype = $c_sc_MapOps$$anon$3.prototype;
$c_sc_MapOps$$anon$3.prototype.hasNext__Z = (function() {
  return $n(this.sc_MapOps$$anon$3__f_iter).hasNext__Z()
});
$c_sc_MapOps$$anon$3.prototype.next__O = (function() {
  return $n($as_T2($n(this.sc_MapOps$$anon$3__f_iter).next__O()))._2__O()
});
var $d_sc_MapOps$$anon$3 = new $TypeData().initClass({
  sc_MapOps$$anon$3: 0
}, false, "scala.collection.MapOps$$anon$3", {
  sc_MapOps$$anon$3: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_MapOps$$anon$3.prototype.$classData = $d_sc_MapOps$$anon$3;
/** @constructor */
function $c_sc_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Seq$())
}
$c_sc_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sc_Seq$.prototype.constructor = $c_sc_Seq$;
/** @constructor */
function $h_sc_Seq$() {
  /*<skip>*/
}
$h_sc_Seq$.prototype = $c_sc_Seq$.prototype;
var $d_sc_Seq$ = new $TypeData().initClass({
  sc_Seq$: 0
}, false, "scala.collection.Seq$", {
  sc_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Seq$.prototype.$classData = $d_sc_Seq$;
var $n_sc_Seq$;
function $m_sc_Seq$() {
  if ((!$n_sc_Seq$)) {
    $n_sc_Seq$ = new $c_sc_Seq$()
  };
  return $n_sc_Seq$
}
function $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($thiz, that) {
  if ((($thiz instanceof $c_sci_Set$Set1) || (($thiz instanceof $c_sci_Set$Set2) || (($thiz instanceof $c_sci_Set$Set3) || ($thiz instanceof $c_sci_Set$Set4))))) {
    var result = $as_sci_SetOps($thiz);
    var it = $n(that).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var this$1 = $n(result);
      var elem = $n(it).next__O();
      result = this$1.incl__O__sci_SetOps(elem)
    };
    return result
  } else {
    if ($is_sc_Iterable(that)) {
      var x2 = $as_sc_Iterable(that);
      var $$x1 = new $c_sc_View$Concat($thiz, x2)
    } else {
      var $$x1 = $n($thiz.iterator__sc_Iterator()).concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0((() => $n(that).iterator__sc_Iterator())))
    };
    return $as_sc_SetOps($thiz.fromSpecific__sc_IterableOnce__O($$x1))
  }
}
function $is_sc_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SetOps)))
}
function $as_sc_SetOps(obj) {
  return (($is_sc_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SetOps"))
}
function $isArrayOf_sc_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SetOps)))
}
function $asArrayOf_sc_SetOps(obj, depth) {
  return (($isArrayOf_sc_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SetOps;", depth))
}
/** @constructor */
function $c_sc_SortedIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null
}
$c_sc_SortedIterableFactory$Delegate.prototype = new $h_sc_EvidenceIterableFactory$Delegate();
$c_sc_SortedIterableFactory$Delegate.prototype.constructor = $c_sc_SortedIterableFactory$Delegate;
/** @constructor */
function $h_sc_SortedIterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_SortedIterableFactory$Delegate.prototype = $c_sc_SortedIterableFactory$Delegate.prototype;
/** @constructor */
function $c_sc_SortedMapOps$WithFilter(self, p) {
  this.sc_IterableOps$WithFilter__f_self = null;
  this.sc_IterableOps$WithFilter__f_p = null;
  this.sc_MapOps$WithFilter__f_self = null;
  this.sc_MapOps$WithFilter__f_p = null;
  this.sc_SortedMapOps$WithFilter__f_self = null;
  this.sc_SortedMapOps$WithFilter__f_p = null;
  this.sc_SortedMapOps$WithFilter__f_self = self;
  this.sc_SortedMapOps$WithFilter__f_p = p;
  $ct_sc_MapOps$WithFilter__sc_MapOps__F1__(this, self, p)
}
$c_sc_SortedMapOps$WithFilter.prototype = new $h_sc_MapOps$WithFilter();
$c_sc_SortedMapOps$WithFilter.prototype.constructor = $c_sc_SortedMapOps$WithFilter;
/** @constructor */
function $h_sc_SortedMapOps$WithFilter() {
  /*<skip>*/
}
$h_sc_SortedMapOps$WithFilter.prototype = $c_sc_SortedMapOps$WithFilter.prototype;
$c_sc_SortedMapOps$WithFilter.prototype.withFilter__F1__sc_SortedMapOps$WithFilter = (function(q) {
  return new $c_sc_SortedMapOps$WithFilter(this.sc_SortedMapOps$WithFilter__f_self, new $c_sjsr_AnonFunction1(((kv$2) => {
    var kv = $as_T2(kv$2);
    return ($uZ($n(this.sc_SortedMapOps$WithFilter__f_p).apply__O__O(kv)) && $uZ($n(q).apply__O__O(kv)))
  })))
});
$c_sc_SortedMapOps$WithFilter.prototype.withFilter__F1__sc_WithFilter = (function(q) {
  return this.withFilter__F1__sc_SortedMapOps$WithFilter(q)
});
$c_sc_SortedMapOps$WithFilter.prototype.withFilter__F1__sc_IterableOps$WithFilter = (function(q) {
  return this.withFilter__F1__sc_SortedMapOps$WithFilter(q)
});
$c_sc_SortedMapOps$WithFilter.prototype.withFilter__F1__sc_MapOps$WithFilter = (function(q) {
  return this.withFilter__F1__sc_SortedMapOps$WithFilter(q)
});
var $d_sc_SortedMapOps$WithFilter = new $TypeData().initClass({
  sc_SortedMapOps$WithFilter: 0
}, false, "scala.collection.SortedMapOps$WithFilter", {
  sc_SortedMapOps$WithFilter: 1,
  sc_MapOps$WithFilter: 1,
  sc_IterableOps$WithFilter: 1,
  sc_WithFilter: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sc_SortedMapOps$WithFilter.prototype.$classData = $d_sc_SortedMapOps$WithFilter;
/** @constructor */
function $c_sc_StrictOptimizedLinearSeqOps$$anon$1(outer) {
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = null;
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = outer
}
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.constructor = $c_sc_StrictOptimizedLinearSeqOps$$anon$1;
/** @constructor */
function $h_sc_StrictOptimizedLinearSeqOps$$anon$1() {
  /*<skip>*/
}
$h_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = $c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype;
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.hasNext__Z = (function() {
  return (!$n(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current).isEmpty__Z())
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.next__O = (function() {
  var r = $n(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current).head__O();
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = $as_sc_StrictOptimizedLinearSeqOps($n(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current).tail__O());
  return r
});
var $d_sc_StrictOptimizedLinearSeqOps$$anon$1 = new $TypeData().initClass({
  sc_StrictOptimizedLinearSeqOps$$anon$1: 0
}, false, "scala.collection.StrictOptimizedLinearSeqOps$$anon$1", {
  sc_StrictOptimizedLinearSeqOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.$classData = $d_sc_StrictOptimizedLinearSeqOps$$anon$1;
function $p_sc_StringOps$$anon$1__advance__T($thiz) {
  var start = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  while (true) {
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      $m_sc_StringOps$();
      $m_sc_StringOps$();
      var this$ = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var this$2 = $n(this$);
      var c = $charAt(this$2, i);
      var $$x1 = (!((c === 13) || (c === 10)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0)
    } else {
      break
    }
  };
  var end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    $m_sc_StringOps$();
    var this$$2 = $thiz.sc_StringOps$$anon$1__f_$this$2;
    var i$1 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
    var this$5 = $n(this$$2);
    var c$1 = $charAt(this$5, i$1);
    $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      $m_sc_StringOps$();
      $m_sc_StringOps$();
      var this$$3 = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i$2 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var this$7 = $n(this$$3);
      var c$2 = $charAt(this$7, i$2);
      var $$x2 = ((c$1 === 13) && (c$2 === 10))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0)
    };
    if ((!$thiz.sc_StringOps$$anon$1__f_stripped$1)) {
      end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index
    }
  };
  var this$9 = $n($thiz.sc_StringOps$$anon$1__f_$this$2);
  var endIndex = end;
  if ((start < 0)) {
    $charAt(this$9, start)
  };
  if ((endIndex > this$9.length)) {
    $charAt(this$9, endIndex)
  };
  if ((endIndex < start)) {
    $charAt(this$9, (-1))
  };
  return $as_T(this$9.substring(start, endIndex))
}
/** @constructor */
function $c_sc_StringOps$$anon$1(\u03b4this$2, stripped$1) {
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = 0;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0;
  this.sc_StringOps$$anon$1__f_$this$2 = null;
  this.sc_StringOps$$anon$1__f_stripped$1 = false;
  this.sc_StringOps$$anon$1__f_$this$2 = \u03b4this$2;
  this.sc_StringOps$$anon$1__f_stripped$1 = stripped$1;
  var this$1 = $n(\u03b4this$2);
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = this$1.length;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0
}
$c_sc_StringOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StringOps$$anon$1.prototype.constructor = $c_sc_StringOps$$anon$1;
/** @constructor */
function $h_sc_StringOps$$anon$1() {
  /*<skip>*/
}
$h_sc_StringOps$$anon$1.prototype = $c_sc_StringOps$$anon$1.prototype;
$c_sc_StringOps$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)
});
$c_sc_StringOps$$anon$1.prototype.next__T = (function() {
  return ((this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index >= this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len) ? $as_T($n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()) : $p_sc_StringOps$$anon$1__advance__T(this))
});
$c_sc_StringOps$$anon$1.prototype.next__O = (function() {
  return this.next__T()
});
var $d_sc_StringOps$$anon$1 = new $TypeData().initClass({
  sc_StringOps$$anon$1: 0
}, false, "scala.collection.StringOps$$anon$1", {
  sc_StringOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_StringOps$$anon$1.prototype.$classData = $d_sc_StringOps$$anon$1;
/** @constructor */
function $c_sc_View$DropRightIterator(underlying, maxlen) {
  this.sc_View$DropRightIterator__f_underlying = null;
  this.sc_View$DropRightIterator__f_maxlen = 0;
  this.sc_View$DropRightIterator__f_len = 0;
  this.sc_View$DropRightIterator__f_pos = 0;
  this.sc_View$DropRightIterator__f_buf = null;
  this.sc_View$DropRightIterator__f_underlying = underlying;
  this.sc_View$DropRightIterator__f_maxlen = maxlen;
  this.sc_View$DropRightIterator__f_len = (-1);
  this.sc_View$DropRightIterator__f_pos = 0
}
$c_sc_View$DropRightIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_View$DropRightIterator.prototype.constructor = $c_sc_View$DropRightIterator;
/** @constructor */
function $h_sc_View$DropRightIterator() {
  /*<skip>*/
}
$h_sc_View$DropRightIterator.prototype = $c_sc_View$DropRightIterator.prototype;
$c_sc_View$DropRightIterator.prototype.init__V = (function() {
  if ((this.sc_View$DropRightIterator__f_buf === null)) {
    var x = this.sc_View$DropRightIterator__f_maxlen;
    this.sc_View$DropRightIterator__f_buf = $ct_scm_ArrayBuffer__I__(new $c_scm_ArrayBuffer(), ((x < 256) ? x : 256));
    while (((this.sc_View$DropRightIterator__f_pos < this.sc_View$DropRightIterator__f_maxlen) && $n(this.sc_View$DropRightIterator__f_underlying).hasNext__Z())) {
      $n(this.sc_View$DropRightIterator__f_buf).addOne__O__scm_ArrayBuffer($n(this.sc_View$DropRightIterator__f_underlying).next__O());
      this.sc_View$DropRightIterator__f_pos = ((1 + this.sc_View$DropRightIterator__f_pos) | 0)
    };
    if ((!$n(this.sc_View$DropRightIterator__f_underlying).hasNext__Z())) {
      this.sc_View$DropRightIterator__f_len = 0
    };
    this.sc_View$DropRightIterator__f_pos = 0
  }
});
$c_sc_View$DropRightIterator.prototype.knownSize__I = (function() {
  return this.sc_View$DropRightIterator__f_len
});
$c_sc_View$DropRightIterator.prototype.hasNext__Z = (function() {
  this.init__V();
  return (this.sc_View$DropRightIterator__f_len !== 0)
});
$c_sc_View$DropRightIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  } else {
    var x = $n(this.sc_View$DropRightIterator__f_buf).apply__I__O(this.sc_View$DropRightIterator__f_pos);
    if ((this.sc_View$DropRightIterator__f_len === (-1))) {
      $n(this.sc_View$DropRightIterator__f_buf).update__I__O__V(this.sc_View$DropRightIterator__f_pos, $n(this.sc_View$DropRightIterator__f_underlying).next__O());
      if ((!$n(this.sc_View$DropRightIterator__f_underlying).hasNext__Z())) {
        this.sc_View$DropRightIterator__f_len = 0
      }
    } else {
      this.sc_View$DropRightIterator__f_len = (((-1) + this.sc_View$DropRightIterator__f_len) | 0)
    };
    this.sc_View$DropRightIterator__f_pos = ((1 + this.sc_View$DropRightIterator__f_pos) | 0);
    if ((this.sc_View$DropRightIterator__f_pos === this.sc_View$DropRightIterator__f_maxlen)) {
      this.sc_View$DropRightIterator__f_pos = 0
    };
    return x
  }
});
var $d_sc_View$DropRightIterator = new $TypeData().initClass({
  sc_View$DropRightIterator: 0
}, false, "scala.collection.View$DropRightIterator", {
  sc_View$DropRightIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_View$DropRightIterator.prototype.$classData = $d_sc_View$DropRightIterator;
/** @constructor */
function $c_sc_View$Updated$$anon$4(outer) {
  this.sc_View$Updated$$anon$4__f_it = null;
  this.sc_View$Updated$$anon$4__f_i = 0;
  this.sc_View$Updated$$anon$4__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_View$Updated$$anon$4__f_$outer = outer
  };
  this.sc_View$Updated$$anon$4__f_it = $n($n(outer).sc_View$Updated__f_scala$collection$View$Updated$$underlying).iterator__sc_Iterator();
  this.sc_View$Updated$$anon$4__f_i = 0
}
$c_sc_View$Updated$$anon$4.prototype = new $h_sc_AbstractIterator();
$c_sc_View$Updated$$anon$4.prototype.constructor = $c_sc_View$Updated$$anon$4;
/** @constructor */
function $h_sc_View$Updated$$anon$4() {
  /*<skip>*/
}
$h_sc_View$Updated$$anon$4.prototype = $c_sc_View$Updated$$anon$4.prototype;
$c_sc_View$Updated$$anon$4.prototype.next__O = (function() {
  var value = ((this.sc_View$Updated$$anon$4__f_i === $n(this.sc_View$Updated$$anon$4__f_$outer).sc_View$Updated__f_scala$collection$View$Updated$$index) ? ($n(this.sc_View$Updated$$anon$4__f_it).next__O(), $n(this.sc_View$Updated$$anon$4__f_$outer).sc_View$Updated__f_scala$collection$View$Updated$$elem) : $n(this.sc_View$Updated$$anon$4__f_it).next__O());
  this.sc_View$Updated$$anon$4__f_i = ((1 + this.sc_View$Updated$$anon$4__f_i) | 0);
  return value
});
$c_sc_View$Updated$$anon$4.prototype.hasNext__Z = (function() {
  if ($n(this.sc_View$Updated$$anon$4__f_it).hasNext__Z()) {
    return true
  } else if (($n(this.sc_View$Updated$$anon$4__f_$outer).sc_View$Updated__f_scala$collection$View$Updated$$index >= this.sc_View$Updated$$anon$4__f_i)) {
    var this$1 = $n(this.sc_View$Updated$$anon$4__f_$outer).sc_View$Updated__f_scala$collection$View$Updated$$index;
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + this$1))
  } else {
    return false
  }
});
var $d_sc_View$Updated$$anon$4 = new $TypeData().initClass({
  sc_View$Updated$$anon$4: 0
}, false, "scala.collection.View$Updated$$anon$4", {
  sc_View$Updated$$anon$4: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_View$Updated$$anon$4.prototype.$classData = $d_sc_View$Updated$$anon$4;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5(outer) {
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5__f_ui = null;
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5__f_ui = $n($n($n(outer).sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).entrySet__ju_Set()).iterator__ju_Iterator()
}
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype = new $h_sc_AbstractIterator();
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype;
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.hasNext__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5__f_ui).hasNext__Z()
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.next__T2 = (function() {
  var e = $as_ju_Map$Entry($n(this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5__f_ui).next__O());
  return $ct_T2__O__O__(new $c_T2(), $n(e).getKey__O(), $n(e).getValue__O())
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JMapWrapperLike$$anon$5", {
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5;
function $as_sc_convert_JavaCollectionWrappers$MutableMapWrapper(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$MutableMapWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$MutableMapWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$MutableMapWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$MutableMapWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$MutableMapWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$MutableMapWrapper;", depth))
}
function $p_sci_ChampBaseIterator__initNodes__V($thiz) {
  if (($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths === null)) {
    $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths = new $ac_I(($m_sci_Node$().sci_Node$__f_MaxDepth << 1));
    $thiz.sci_ChampBaseIterator__f_nodes = new ($d_sci_Node.getArrayOf().constr)($m_sci_Node$().sci_Node$__f_MaxDepth)
  }
}
function $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = $n(node).payloadArity__I()
}
function $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, node) {
  $p_sci_ChampBaseIterator__initNodes__V($thiz);
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0);
  var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
  var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
  $n($thiz.sci_ChampBaseIterator__f_nodes).set($thiz.sci_ChampBaseIterator__f_currentStackLevel, node);
  $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).set(cursorIndex, 0);
  $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).set(lengthIndex, $n(node).nodeArity__I())
}
function $p_sci_ChampBaseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0)
}
function $p_sci_ChampBaseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseIterator__f_currentStackLevel >= 0)) {
    var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
    var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
    var nodeCursor = $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).get(cursorIndex);
    var nodeLength = $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).get(lengthIndex);
    if ((nodeCursor < nodeLength)) {
      var ev$1 = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths;
      $n(ev$1).set(cursorIndex, ((1 + $n(ev$1).get(cursorIndex)) | 0));
      var nextNode = $n($n($thiz.sci_ChampBaseIterator__f_nodes).get($thiz.sci_ChampBaseIterator__f_currentStackLevel)).getNode__I__sci_Node(nodeCursor);
      if ($n(nextNode).hasNodes__Z()) {
        $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, nextNode)
      };
      if ($n(nextNode).hasPayload__Z()) {
        $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, nextNode);
        return true
      }
    } else {
      $p_sci_ChampBaseIterator__popNode__V($thiz)
    }
  };
  return false
}
function $ct_sci_ChampBaseIterator__($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = 0;
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (-1);
  return $thiz
}
function $ct_sci_ChampBaseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseIterator__($thiz);
  if ($n(rootNode).hasNodes__Z()) {
    $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, rootNode)
  };
  if ($n(rootNode).hasPayload__Z()) {
    $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, rootNode)
  };
  return $thiz
}
/** @constructor */
function $c_sci_ChampBaseIterator() {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null
}
$c_sci_ChampBaseIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_ChampBaseIterator.prototype.constructor = $c_sci_ChampBaseIterator;
/** @constructor */
function $h_sci_ChampBaseIterator() {
  /*<skip>*/
}
$h_sci_ChampBaseIterator.prototype = $c_sci_ChampBaseIterator.prototype;
$c_sci_ChampBaseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseIterator__f_currentValueCursor < this.sci_ChampBaseIterator__f_currentValueLength) || $p_sci_ChampBaseIterator__searchNextValueNode__Z(this))
});
function $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + $n(node).payloadArity__I()) | 0)
}
function $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0);
  $n($thiz.sci_ChampBaseReverseIterator__f_nodeStack).set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, node);
  $n($thiz.sci_ChampBaseReverseIterator__f_nodeIndex).set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + $n(node).nodeArity__I()) | 0))
}
function $p_sci_ChampBaseReverseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0)
}
function $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel >= 0)) {
    var nodeCursor = $n($thiz.sci_ChampBaseReverseIterator__f_nodeIndex).get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
    $n($thiz.sci_ChampBaseReverseIterator__f_nodeIndex).set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + nodeCursor) | 0));
    if ((nodeCursor >= 0)) {
      var nextNode = $n($n($thiz.sci_ChampBaseReverseIterator__f_nodeStack).get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel)).getNode__I__sci_Node(nodeCursor);
      $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, nextNode)
    } else {
      var currNode = $n($thiz.sci_ChampBaseReverseIterator__f_nodeStack).get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
      $p_sci_ChampBaseReverseIterator__popNode__V($thiz);
      if ($n(currNode).hasPayload__Z()) {
        $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, currNode);
        return true
      }
    }
  };
  return false
}
function $ct_sci_ChampBaseReverseIterator__($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex = new $ac_I(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack = new ($d_sci_Node.getArrayOf().constr)(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  return $thiz
}
function $ct_sci_ChampBaseReverseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseReverseIterator__($thiz);
  $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, rootNode);
  $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz);
  return $thiz
}
/** @constructor */
function $c_sci_ChampBaseReverseIterator() {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null
}
$c_sci_ChampBaseReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_ChampBaseReverseIterator.prototype.constructor = $c_sci_ChampBaseReverseIterator;
/** @constructor */
function $h_sci_ChampBaseReverseIterator() {
  /*<skip>*/
}
$h_sci_ChampBaseReverseIterator.prototype = $c_sci_ChampBaseReverseIterator.prototype;
$c_sci_ChampBaseReverseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseReverseIterator__f_currentValueCursor >= 0) || $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z(this))
});
function $p_sci_HashMapBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashMapBuilder__f_aliased !== null)
}
function $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  if ((ix > $n(as).u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  var result = new $ac_I(((1 + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  $n(result).set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = (($n(as).u.length - ix) | 0);
  $systemArraycopy($n(as), ix, result, destPos, length);
  return result
}
function $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V($thiz, bm, bitpos, key, originalHash, keyHash, value) {
  var dataIx = $n(bm).dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = $n(bm).sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idx);
  $n(dst).set(idx, key);
  $n(dst).set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = (($n(src).u.length - idx) | 0);
  $systemArraycopyRefs($n(src), idx, dst, destPos, length);
  var dstHashes = $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, $n(bm).sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  $n(bm).sci_BitmapIndexedMapNode__f_dataMap = ($n(bm).sci_BitmapIndexedMapNode__f_dataMap | bitpos);
  $n(bm).sci_BitmapIndexedMapNode__f_content = dst;
  $n(bm).sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  $n(bm).sci_BitmapIndexedMapNode__f_size = ((1 + $n(bm).sci_BitmapIndexedMapNode__f_size) | 0);
  $n(bm).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = (($n(bm).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0)
}
function $p_sci_HashMapBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashMapBuilder__isAliased__Z($thiz)) {
    $p_sci_HashMapBuilder__copyElems__V($thiz)
  };
  $thiz.sci_HashMapBuilder__f_aliased = null
}
function $p_sci_HashMapBuilder__copyElems__V($thiz) {
  $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = $n($thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode).copy__sci_BitmapIndexedMapNode()
}
/** @constructor */
function $c_sci_HashMapBuilder() {
  this.sci_HashMapBuilder__f_aliased = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = new $c_sci_BitmapIndexedMapNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0)
}
$c_sci_HashMapBuilder.prototype = new $h_O();
$c_sci_HashMapBuilder.prototype.constructor = $c_sci_HashMapBuilder;
/** @constructor */
function $h_sci_HashMapBuilder() {
  /*<skip>*/
}
$h_sci_HashMapBuilder.prototype = $c_sci_HashMapBuilder.prototype;
$c_sci_HashMapBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_HashMapBuilder.prototype.update__sci_MapNode__O__O__I__I__I__V = (function(mapNode, key, value, originalHash, keyHash, shift) {
  if ((mapNode instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(mapNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if ((($n(x2).sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
      var key0 = $n(x2).getKey__I__O(index);
      var key0UnimprovedHash = $n(x2).getHash__I__I(index);
      if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
        $n($n(x2).sci_BitmapIndexedMapNode__f_content).set(((1 + (index << 1)) | 0), value)
      } else {
        var value0 = $n(x2).getValue__I__O(index);
        var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
        var subNodeNew = $n(x2).mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
        $n(x2).migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew)
      }
    } else if ((($n(x2).sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
      var subNode = $n(x2).getNode__I__sci_MapNode(index$2);
      var beforeSize = $n(subNode).size__I();
      var beforeHash = $n(subNode).cachedJavaKeySetHashCode__I();
      this.update__sci_MapNode__O__O__I__I__I__V(subNode, key, value, originalHash, keyHash, ((5 + shift) | 0));
      $n(x2).sci_BitmapIndexedMapNode__f_size = (($n(x2).sci_BitmapIndexedMapNode__f_size + (($n(subNode).size__I() - beforeSize) | 0)) | 0);
      $n(x2).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = (($n(x2).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + (($n(subNode).cachedJavaKeySetHashCode__I() - beforeHash) | 0)) | 0)
    } else {
      $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V(this, x2, bitpos, key, originalHash, keyHash, value)
    }
  } else if ((mapNode instanceof $c_sci_HashCollisionMapNode)) {
    var x3 = $as_sci_HashCollisionMapNode(mapNode);
    var index$3 = $n(x3).indexOf__O__I(key);
    if ((index$3 < 0)) {
      $n(x3).sci_HashCollisionMapNode__f_content = $n($n(x3).sci_HashCollisionMapNode__f_content).appended__O__sci_Vector($ct_T2__O__O__(new $c_T2(), key, value))
    } else {
      $n(x3).sci_HashCollisionMapNode__f_content = $n($n(x3).sci_HashCollisionMapNode__f_content).updated__I__O__sci_Vector(index$3, $ct_T2__O__O__(new $c_T2(), key, value))
    }
  } else {
    throw new $c_s_MatchError(mapNode)
  }
});
$c_sci_HashMapBuilder.prototype.result__sci_HashMap = (function() {
  if (($n(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode).sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap
  } else if ((this.sci_HashMapBuilder__f_aliased !== null)) {
    return this.sci_HashMapBuilder__f_aliased
  } else {
    this.sci_HashMapBuilder__f_aliased = new $c_sci_HashMap(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode);
    return this.sci_HashMapBuilder__f_aliased
  }
});
$c_sci_HashMapBuilder.prototype.addOne__T2__sci_HashMapBuilder = (function(elem) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var x = $n(elem)._1__O();
  var h = $m_sr_Statics$().anyHash__O__I(x);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n(elem)._1__O(), $n(elem)._2__O(), h, im, 0);
  return this
});
$c_sci_HashMapBuilder.prototype.addOne__O__O__sci_HashMapBuilder = (function(key, value) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, key, value, originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
  return this
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__sci_HashMapBuilder = (function(xs) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    new $c_sci_HashMapBuilder$$anon$1(this, x2)
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = $n(x3).nodeIterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var next = $as_scm_HashMap$Node($n(iter).next__O());
      $n(x3);
      var improvedHash = $n(next).scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var hash = $m_sc_Hashing$().improve__I__I(originalHash);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n(next).scm_HashMap$Node__f__key, $n(next).scm_HashMap$Node__f__value, originalHash, hash, 0)
    }
  } else if (false) {
    var x4 = $as_scm_LinkedHashMap(xs);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    while ($n(iter$2).hasNext__Z()) {
      var next$2 = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
      var originalHash$2 = $n(x4).unimproveHash__I__I($n(next$2).hash__I());
      var hash$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n(next$2).key__O(), $n(next$2).value__O(), originalHash$2, hash$2, 0)
    }
  } else if ($is_sci_Map(xs)) {
    var x5 = $as_sci_Map(xs);
    $n(x5).foreachEntry__F2__V(new $c_sjsr_AnonFunction2(((key$2, value$2) => this.addOne__O__O__sci_HashMapBuilder(key$2, value$2))))
  } else {
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      this.addOne__T2__sci_HashMapBuilder($as_T2($n(it).next__O()))
    }
  };
  return this
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_HashMapBuilder(xs)
});
$c_sci_HashMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_HashMapBuilder($as_T2(elem))
});
$c_sci_HashMapBuilder.prototype.result__O = (function() {
  return this.result__sci_HashMap()
});
var $d_sci_HashMapBuilder = new $TypeData().initClass({
  sci_HashMapBuilder: 0
}, false, "scala.collection.immutable.HashMapBuilder", {
  sci_HashMapBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_HashMapBuilder.prototype.$classData = $d_sci_HashMapBuilder;
function $p_sci_HashSetBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashSetBuilder__f_aliased !== null)
}
function $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  if ((ix > $n(as).u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  var result = new $ac_I(((1 + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  $n(result).set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = (($n(as).u.length - ix) | 0);
  $systemArraycopy($n(as), ix, result, destPos, length);
  return result
}
function $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V($thiz, bm, bitpos, key, originalHash, keyHash) {
  var dataIx = $n(bm).dataIndex__I__I(bitpos);
  var src = $n(bm).sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  $n(dst).set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = (($n(src).u.length - dataIx) | 0);
  $systemArraycopyRefs($n(src), dataIx, dst, destPos, length);
  var dstHashes = $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, $n(bm).sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  $n(bm).sci_BitmapIndexedSetNode__f_dataMap = ($n(bm).sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  $n(bm).sci_BitmapIndexedSetNode__f_content = dst;
  $n(bm).sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  $n(bm).sci_BitmapIndexedSetNode__f_size = ((1 + $n(bm).sci_BitmapIndexedSetNode__f_size) | 0);
  $n(bm).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = (($n(bm).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + keyHash) | 0)
}
function $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V($thiz, bm, bitpos, elem) {
  var dataIx = $n(bm).dataIndex__I__I(bitpos);
  $n($n(bm).sci_BitmapIndexedSetNode__f_content).set(dataIx, elem)
}
function $p_sci_HashSetBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashSetBuilder__isAliased__Z($thiz)) {
    $p_sci_HashSetBuilder__copyElems__V($thiz)
  };
  $thiz.sci_HashSetBuilder__f_aliased = null
}
function $p_sci_HashSetBuilder__copyElems__V($thiz) {
  $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = $n($thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode).copy__sci_BitmapIndexedSetNode()
}
/** @constructor */
function $c_sci_HashSetBuilder() {
  this.sci_HashSetBuilder__f_aliased = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = new $c_sci_BitmapIndexedSetNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0)
}
$c_sci_HashSetBuilder.prototype = new $h_O();
$c_sci_HashSetBuilder.prototype.constructor = $c_sci_HashSetBuilder;
/** @constructor */
function $h_sci_HashSetBuilder() {
  /*<skip>*/
}
$h_sci_HashSetBuilder.prototype = $c_sci_HashSetBuilder.prototype;
$c_sci_HashSetBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_HashSetBuilder.prototype.update__sci_SetNode__O__I__I__I__V = (function(setNode, element, originalHash, elementHash, shift) {
  if ((setNode instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(setNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if ((($n(x2).sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
      var element0 = $n(x2).getPayload__I__O(index);
      var element0UnimprovedHash = $n(x2).getHash__I__I(index);
      if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V(this, x2, bitpos, element0)
      } else {
        var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
        var subNodeNew = $n(x2).mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        $n(x2).migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew)
      }
    } else if ((($n(x2).sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
      var subNode = $n(x2).getNode__I__sci_SetNode(index$2);
      var beforeSize = $n(subNode).size__I();
      var beforeHashCode = $n(subNode).cachedJavaKeySetHashCode__I();
      this.update__sci_SetNode__O__I__I__I__V(subNode, element, originalHash, elementHash, ((5 + shift) | 0));
      $n(x2).sci_BitmapIndexedSetNode__f_size = (($n(x2).sci_BitmapIndexedSetNode__f_size + (($n(subNode).size__I() - beforeSize) | 0)) | 0);
      $n(x2).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = (($n(x2).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + (($n(subNode).cachedJavaKeySetHashCode__I() - beforeHashCode) | 0)) | 0)
    } else {
      $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V(this, x2, bitpos, element, originalHash, elementHash)
    }
  } else if ((setNode instanceof $c_sci_HashCollisionSetNode)) {
    var x3 = $as_sci_HashCollisionSetNode(setNode);
    var this$1 = $n($n(x3).sci_HashCollisionSetNode__f_content);
    var index$3 = $f_sc_SeqOps__indexOf__O__I__I(this$1, element, 0);
    if ((index$3 < 0)) {
      $n(x3).sci_HashCollisionSetNode__f_content = $n($n(x3).sci_HashCollisionSetNode__f_content).appended__O__sci_Vector(element)
    } else {
      $n(x3).sci_HashCollisionSetNode__f_content = $n($n(x3).sci_HashCollisionSetNode__f_content).updated__I__O__sci_Vector(index$3, element)
    }
  } else {
    throw new $c_s_MatchError(setNode)
  }
});
$c_sci_HashSetBuilder.prototype.result__sci_HashSet = (function() {
  if (($n(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode).sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet
  } else if ((this.sci_HashSetBuilder__f_aliased !== null)) {
    return this.sci_HashSetBuilder__f_aliased
  } else {
    this.sci_HashSetBuilder__f_aliased = new $c_sci_HashSet(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode);
    return this.sci_HashSetBuilder__f_aliased
  }
});
$c_sci_HashSetBuilder.prototype.addOne__O__sci_HashSetBuilder = (function(elem) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().anyHash__O__I(elem);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_SetNode__O__I__I__I__V(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, elem, h, im, 0);
  return this
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__sci_HashSetBuilder = (function(xs) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    new $c_sci_HashSetBuilder$$anon$1(this, x2)
  } else {
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      this.addOne__O__sci_HashSetBuilder($n(it).next__O())
    }
  };
  return this
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_HashSetBuilder(xs)
});
$c_sci_HashSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_HashSetBuilder(elem)
});
$c_sci_HashSetBuilder.prototype.result__O = (function() {
  return this.result__sci_HashSet()
});
var $d_sci_HashSetBuilder = new $TypeData().initClass({
  sci_HashSetBuilder: 0
}, false, "scala.collection.immutable.HashSetBuilder", {
  sci_HashSetBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_HashSetBuilder.prototype.$classData = $d_sci_HashSetBuilder;
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Vector$())
}
$c_sci_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_IndexedSeq$.prototype.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
  /*<skip>*/
}
$h_sci_IndexedSeq$.prototype = $c_sci_IndexedSeq$.prototype;
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sci_IndexedSeq = (function(it) {
  if ($is_sci_IndexedSeq(it)) {
    var x2 = $as_sci_IndexedSeq(it);
    return x2
  } else {
    return $as_sci_IndexedSeq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it))
  }
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(source)
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(it)
});
var $d_sci_IndexedSeq$ = new $TypeData().initClass({
  sci_IndexedSeq$: 0
}, false, "scala.collection.immutable.IndexedSeq$", {
  sci_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_IndexedSeq$.prototype.$classData = $d_sci_IndexedSeq$;
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$()
  };
  return $n_sci_IndexedSeq$
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder() {
  this.sci_LazyList$LazyBuilder__f_next = null;
  this.sci_LazyList$LazyBuilder__f_list = null;
  this.clear__V()
}
$c_sci_LazyList$LazyBuilder.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder.prototype.constructor = $c_sci_LazyList$LazyBuilder;
/** @constructor */
function $h_sci_LazyList$LazyBuilder() {
  /*<skip>*/
}
$h_sci_LazyList$LazyBuilder.prototype = $c_sci_LazyList$LazyBuilder.prototype;
$c_sci_LazyList$LazyBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_LazyList$LazyBuilder.prototype.clear__V = (function() {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => deferred.eval__sci_LazyList$State()));
  this.sci_LazyList$LazyBuilder__f_list = new $c_sci_LazyList(state);
  this.sci_LazyList$LazyBuilder__f_next = deferred
});
$c_sci_LazyList$LazyBuilder.prototype.result__sci_LazyList = (function() {
  $n(this.sci_LazyList$LazyBuilder__f_next).init__F0__V(new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$State$Empty$())));
  return this.sci_LazyList$LazyBuilder__f_list
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__sci_LazyList$LazyBuilder = (function(elem) {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $n(this.sci_LazyList$LazyBuilder__f_next).init__F0__V(new $c_sjsr_AnonFunction0((() => {
    $m_sci_LazyList$();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => deferred.eval__sci_LazyList$State()));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(elem, tl)
  })));
  this.sci_LazyList$LazyBuilder__f_next = deferred;
  return this
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder = (function(xs) {
  if (($n(xs).knownSize__I() !== 0)) {
    var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
    $n(this.sci_LazyList$LazyBuilder__f_next).init__F0__V(new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State($n(xs).iterator__sc_Iterator(), new $c_sjsr_AnonFunction0((() => deferred.eval__sci_LazyList$State()))))));
    this.sci_LazyList$LazyBuilder__f_next = deferred
  };
  return this
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder(xs)
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_LazyList$LazyBuilder(elem)
});
$c_sci_LazyList$LazyBuilder.prototype.result__O = (function() {
  return this.result__sci_LazyList()
});
var $d_sci_LazyList$LazyBuilder = new $TypeData().initClass({
  sci_LazyList$LazyBuilder: 0
}, false, "scala.collection.immutable.LazyList$LazyBuilder", {
  sci_LazyList$LazyBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_LazyList$LazyBuilder.prototype.$classData = $d_sci_LazyList$LazyBuilder;
/** @constructor */
function $c_sci_LazyList$LazyIterator(lazyList) {
  this.sci_LazyList$LazyIterator__f_lazyList = null;
  this.sci_LazyList$LazyIterator__f_lazyList = lazyList
}
$c_sci_LazyList$LazyIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_LazyList$LazyIterator.prototype.constructor = $c_sci_LazyList$LazyIterator;
/** @constructor */
function $h_sci_LazyList$LazyIterator() {
  /*<skip>*/
}
$h_sci_LazyList$LazyIterator.prototype = $c_sci_LazyList$LazyIterator.prototype;
$c_sci_LazyList$LazyIterator.prototype.hasNext__Z = (function() {
  return (!$n(this.sci_LazyList$LazyIterator__f_lazyList).isEmpty__Z())
});
$c_sci_LazyList$LazyIterator.prototype.next__O = (function() {
  if ($n(this.sci_LazyList$LazyIterator__f_lazyList).isEmpty__Z()) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  } else {
    var this$1 = $n(this.sci_LazyList$LazyIterator__f_lazyList);
    var res = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
    var this$2 = $n(this.sci_LazyList$LazyIterator__f_lazyList);
    this.sci_LazyList$LazyIterator__f_lazyList = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    return res
  }
});
var $d_sci_LazyList$LazyIterator = new $TypeData().initClass({
  sci_LazyList$LazyIterator: 0
}, false, "scala.collection.immutable.LazyList$LazyIterator", {
  sci_LazyList$LazyIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_LazyList$LazyIterator.prototype.$classData = $d_sci_LazyList$LazyIterator;
/** @constructor */
function $c_sci_List$() {
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = null;
  this.sci_List$__f_partialNotApplied = null;
  $n_sci_List$ = this;
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = $ct_T2__O__O__(new $c_T2(), $m_sci_Nil$(), $m_sci_Nil$());
  this.sci_List$__f_partialNotApplied = new $c_sci_List$$anon$1()
}
$c_sci_List$.prototype = new $h_O();
$c_sci_List$.prototype.constructor = $c_sci_List$;
/** @constructor */
function $h_sci_List$() {
  /*<skip>*/
}
$h_sci_List$.prototype = $c_sci_List$.prototype;
$c_sci_List$.prototype.apply__sci_Seq__O = (function(elems) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
$c_sci_List$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ListBuffer()
});
$c_sci_List$.prototype.empty__O = (function() {
  return $m_sci_Nil$()
});
$c_sci_List$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source)
});
var $d_sci_List$ = new $TypeData().initClass({
  sci_List$: 0
}, false, "scala.collection.immutable.List$", {
  sci_List$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_List$.prototype.$classData = $d_sci_List$;
var $n_sci_List$;
function $m_sci_List$() {
  if ((!$n_sci_List$)) {
    $n_sci_List$ = new $c_sci_List$()
  };
  return $n_sci_List$
}
function $p_sci_ListMapBuilder__insertValueAtKeyReturnFound__sci_ListMap__O__O__Z($thiz, m, key, value) {
  while (true) {
    var x1 = m;
    if ((x1 instanceof $c_sci_ListMap$Node)) {
      var x2 = $as_sci_ListMap$Node(x1);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z($n(x2).sci_ListMap$Node__f_key, key)) {
        $n(x2).sci_ListMap$Node__f__value = value;
        return true
      } else {
        var this$1 = $n(x2);
        m = this$1.sci_ListMap$Node__f__init
      }
    } else {
      return false
    }
  }
}
/** @constructor */
function $c_sci_ListMapBuilder() {
  this.sci_ListMapBuilder__f_isAliased = false;
  this.sci_ListMapBuilder__f_underlying = null;
  this.sci_ListMapBuilder__f_isAliased = false;
  this.sci_ListMapBuilder__f_underlying = $m_sci_ListMap$EmptyListMap$()
}
$c_sci_ListMapBuilder.prototype = new $h_O();
$c_sci_ListMapBuilder.prototype.constructor = $c_sci_ListMapBuilder;
/** @constructor */
function $h_sci_ListMapBuilder() {
  /*<skip>*/
}
$h_sci_ListMapBuilder.prototype = $c_sci_ListMapBuilder.prototype;
$c_sci_ListMapBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_ListMapBuilder.prototype.result__sci_ListMap = (function() {
  this.sci_ListMapBuilder__f_isAliased = true;
  return this.sci_ListMapBuilder__f_underlying
});
$c_sci_ListMapBuilder.prototype.addOne__O__O__sci_ListMapBuilder = (function(key, value) {
  if (this.sci_ListMapBuilder__f_isAliased) {
    this.sci_ListMapBuilder__f_underlying = $n(this.sci_ListMapBuilder__f_underlying).updated__O__O__sci_ListMap(key, value)
  } else if ((!$p_sci_ListMapBuilder__insertValueAtKeyReturnFound__sci_ListMap__O__O__Z(this, this.sci_ListMapBuilder__f_underlying, key, value))) {
    this.sci_ListMapBuilder__f_underlying = new $c_sci_ListMap$Node(key, value, this.sci_ListMapBuilder__f_underlying)
  };
  return this
});
$c_sci_ListMapBuilder.prototype.addAll__sc_IterableOnce__sci_ListMapBuilder = (function(xs) {
  if (this.sci_ListMapBuilder__f_isAliased) {
    return $as_sci_ListMapBuilder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  } else {
    var this$1 = $n(this.sci_ListMapBuilder__f_underlying);
    if ((!this$1.isEmpty__Z())) {
      if ($is_sc_Map(xs)) {
        var x2 = $as_sc_Map(xs);
        var iter = $n(x2).iterator__sc_Iterator();
        var newUnderlying = this.sci_ListMapBuilder__f_underlying;
        while ($n(iter).hasNext__Z()) {
          var next = $as_T2($n(iter).next__O());
          if ((!$p_sci_ListMapBuilder__insertValueAtKeyReturnFound__sci_ListMap__O__O__Z(this, this.sci_ListMapBuilder__f_underlying, $n(next)._1__O(), $n(next)._2__O()))) {
            newUnderlying = new $c_sci_ListMap$Node($n(next)._1__O(), $n(next)._2__O(), newUnderlying)
          }
        };
        this.sci_ListMapBuilder__f_underlying = newUnderlying;
        return this
      } else {
        return $as_sci_ListMapBuilder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
      }
    } else if (false) {
      var x2$2 = $as_scm_LinkedHashMap(xs);
      var firstEntry = $n(x2$2)._firstEntry__scm_LinkedHashMap$LinkedEntry();
      while ((firstEntry !== null)) {
        this.sci_ListMapBuilder__f_underlying = new $c_sci_ListMap$Node($n(firstEntry).key__O(), $n(firstEntry).value__O(), this.sci_ListMapBuilder__f_underlying);
        firstEntry = $n(firstEntry).later__scm_LinkedHashMap$LinkedEntry()
      };
      return this
    } else if (($is_sc_Map(xs) || $is_sc_MapView(xs))) {
      var iter$2 = $n(xs).iterator__sc_Iterator();
      while ($n(iter$2).hasNext__Z()) {
        var x1$3 = $as_T2($n(iter$2).next__O());
        if ((x1$3 === null)) {
          throw new $c_s_MatchError(x1$3)
        };
        var k = $n(x1$3)._1__O();
        var v = $n(x1$3)._2__O();
        this.sci_ListMapBuilder__f_underlying = new $c_sci_ListMap$Node(k, v, this.sci_ListMapBuilder__f_underlying)
      };
      return this
    } else {
      return $as_sci_ListMapBuilder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
    }
  }
});
$c_sci_ListMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_ListMapBuilder(xs)
});
$c_sci_ListMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  var elem$1 = $as_T2(elem);
  return this.addOne__O__O__sci_ListMapBuilder($n(elem$1)._1__O(), $n(elem$1)._2__O())
});
$c_sci_ListMapBuilder.prototype.result__O = (function() {
  return this.result__sci_ListMap()
});
function $as_sci_ListMapBuilder(obj) {
  return (((obj instanceof $c_sci_ListMapBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ListMapBuilder"))
}
function $isArrayOf_sci_ListMapBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListMapBuilder)))
}
function $asArrayOf_sci_ListMapBuilder(obj, depth) {
  return (($isArrayOf_sci_ListMapBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ListMapBuilder;", depth))
}
var $d_sci_ListMapBuilder = new $TypeData().initClass({
  sci_ListMapBuilder: 0
}, false, "scala.collection.immutable.ListMapBuilder", {
  sci_ListMapBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_ListMapBuilder.prototype.$classData = $d_sci_ListMapBuilder;
function $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.sci_Map$Map2$Map2Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map2$Map2Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map2$Map2Iterator() {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null
}
$c_sci_Map$Map2$Map2Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map2$Map2Iterator.prototype.constructor = $c_sci_Map$Map2$Map2Iterator;
/** @constructor */
function $h_sci_Map$Map2$Map2Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map2$Map2Iterator.prototype = $c_sci_Map$Map2$Map2Iterator.prototype;
$c_sci_Map$Map2$Map2Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map2$Map2Iterator__f_i < 2)
});
$c_sci_Map$Map2$Map2Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map2$Map2Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, $n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
      break
    }
    case 1: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, $n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
      break
    }
    default: {
      var result = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
    }
  };
  this.sci_Map$Map2$Map2Iterator__f_i = ((1 + this.sci_Map$Map2$Map2Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map2$Map2Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map2$Map2Iterator__f_i = ((this.sci_Map$Map2$Map2Iterator__f_i + n) | 0);
  return this
});
function $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.sci_Map$Map3$Map3Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map3$Map3Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map3$Map3Iterator() {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null
}
$c_sci_Map$Map3$Map3Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map3$Map3Iterator.prototype.constructor = $c_sci_Map$Map3$Map3Iterator;
/** @constructor */
function $h_sci_Map$Map3$Map3Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map3$Map3Iterator.prototype = $c_sci_Map$Map3$Map3Iterator.prototype;
$c_sci_Map$Map3$Map3Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map3$Map3Iterator__f_i < 3)
});
$c_sci_Map$Map3$Map3Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map3$Map3Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, $n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
      break
    }
    case 1: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, $n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
      break
    }
    case 2: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, $n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
      break
    }
    default: {
      var result = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
    }
  };
  this.sci_Map$Map3$Map3Iterator__f_i = ((1 + this.sci_Map$Map3$Map3Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map3$Map3Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map3$Map3Iterator__f_i = ((this.sci_Map$Map3$Map3Iterator__f_i + n) | 0);
  return this
});
function $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.sci_Map$Map4$Map4Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map4$Map4Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map4$Map4Iterator() {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null
}
$c_sci_Map$Map4$Map4Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map4$Map4Iterator.prototype.constructor = $c_sci_Map$Map4$Map4Iterator;
/** @constructor */
function $h_sci_Map$Map4$Map4Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map4$Map4Iterator.prototype = $c_sci_Map$Map4$Map4Iterator.prototype;
$c_sci_Map$Map4$Map4Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map4$Map4Iterator__f_i < 4)
});
$c_sci_Map$Map4$Map4Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map4$Map4Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
      break
    }
    case 1: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
      break
    }
    case 2: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
      break
    }
    case 3: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
      break
    }
    default: {
      var result = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
    }
  };
  this.sci_Map$Map4$Map4Iterator__f_i = ((1 + this.sci_Map$Map4$Map4Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map4$Map4Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map4$Map4Iterator__f_i = ((this.sci_Map$Map4$Map4Iterator__f_i + n) | 0);
  return this
});
/** @constructor */
function $c_sci_MapBuilderImpl() {
  this.sci_MapBuilderImpl__f_elems = null;
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
  this.sci_MapBuilderImpl__f_hashMapBuilder = null;
  this.sci_MapBuilderImpl__f_elems = $m_sci_Map$EmptyMap$();
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false
}
$c_sci_MapBuilderImpl.prototype = new $h_O();
$c_sci_MapBuilderImpl.prototype.constructor = $c_sci_MapBuilderImpl;
/** @constructor */
function $h_sci_MapBuilderImpl() {
  /*<skip>*/
}
$h_sci_MapBuilderImpl.prototype = $c_sci_MapBuilderImpl.prototype;
$c_sci_MapBuilderImpl.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_MapBuilderImpl.prototype.result__sci_Map = (function() {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? $n(this.sci_MapBuilderImpl__f_hashMapBuilder).result__sci_HashMap() : this.sci_MapBuilderImpl__f_elems)
});
$c_sci_MapBuilderImpl.prototype.addOne__O__O__sci_MapBuilderImpl = (function(key, value) {
  if (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder) {
    $n(this.sci_MapBuilderImpl__f_hashMapBuilder).addOne__O__O__sci_HashMapBuilder(key, value)
  } else if (($n(this.sci_MapBuilderImpl__f_elems).size__I() < 4)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map($n(this.sci_MapBuilderImpl__f_elems).updated__O__O__sci_MapOps(key, value))
  } else if ($n(this.sci_MapBuilderImpl__f_elems).contains__O__Z(key)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map($n(this.sci_MapBuilderImpl__f_elems).updated__O__O__sci_MapOps(key, value))
  } else {
    this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = true;
    if ((this.sci_MapBuilderImpl__f_hashMapBuilder === null)) {
      this.sci_MapBuilderImpl__f_hashMapBuilder = new $c_sci_HashMapBuilder()
    };
    $n($as_sci_Map$Map4(this.sci_MapBuilderImpl__f_elems)).buildTo__sci_HashMapBuilder__sci_HashMapBuilder(this.sci_MapBuilderImpl__f_hashMapBuilder);
    $n(this.sci_MapBuilderImpl__f_hashMapBuilder).addOne__O__O__sci_HashMapBuilder(key, value)
  };
  return this
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__sci_MapBuilderImpl = (function(xs) {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? ($n(this.sci_MapBuilderImpl__f_hashMapBuilder).addAll__sc_IterableOnce__sci_HashMapBuilder(xs), this) : $as_sci_MapBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)))
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_MapBuilderImpl(xs)
});
$c_sci_MapBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  var elem$1 = $as_T2(elem);
  return this.addOne__O__O__sci_MapBuilderImpl($n(elem$1)._1__O(), $n(elem$1)._2__O())
});
$c_sci_MapBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Map()
});
function $as_sci_MapBuilderImpl(obj) {
  return (((obj instanceof $c_sci_MapBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapBuilderImpl"))
}
function $isArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapBuilderImpl)))
}
function $asArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_MapBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapBuilderImpl;", depth))
}
var $d_sci_MapBuilderImpl = new $TypeData().initClass({
  sci_MapBuilderImpl: 0
}, false, "scala.collection.immutable.MapBuilderImpl", {
  sci_MapBuilderImpl: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_MapBuilderImpl.prototype.$classData = $d_sci_MapBuilderImpl;
/** @constructor */
function $c_sci_Queue$() {
  /*<skip>*/
}
$c_sci_Queue$.prototype = new $h_O();
$c_sci_Queue$.prototype.constructor = $c_sci_Queue$;
/** @constructor */
function $h_sci_Queue$() {
  /*<skip>*/
}
$h_sci_Queue$.prototype = $c_sci_Queue$.prototype;
$c_sci_Queue$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = new $c_scm_ListBuffer();
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_sci_List(x$2);
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), x)
  }));
  return new $c_scm_Builder$$anon$1(this$2, f)
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__sci_Queue = (function(source) {
  if ((source instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(source);
    return x2
  } else {
    $m_sci_List$();
    var list = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source);
    return ($n(list).isEmpty__Z() ? $m_sci_Queue$EmptyQueue$() : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), list))
  }
});
$c_sci_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $n(elems).toList__sci_List())
});
$c_sci_Queue$.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$()
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Queue(source)
});
var $d_sci_Queue$ = new $TypeData().initClass({
  sci_Queue$: 0
}, false, "scala.collection.immutable.Queue$", {
  sci_Queue$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Queue$.prototype.$classData = $d_sci_Queue$;
var $n_sci_Queue$;
function $m_sci_Queue$() {
  if ((!$n_sci_Queue$)) {
    $n_sci_Queue$ = new $c_sci_Queue$()
  };
  return $n_sci_Queue$
}
function $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, key) {
  return (($thiz.sci_RedBlackTree$TreeIterator__f_root === null) ? null : $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, $thiz.sci_RedBlackTree$TreeIterator__f_root, key))
}
function $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, tree, key$1) {
  while (true) {
    if ((tree === null)) {
      if (($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null
      } else {
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return $n($thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      }
    } else {
      var $$x1 = $thiz.sci_RedBlackTree$TreeIterator__f_ordering;
      var this$1 = $n(tree);
      if ($n($$x1).lteq__O__O__Z(key$1, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        var tree$1 = tree;
        $n($thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts).set($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index, tree$1);
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var this$2 = $n(tree$1);
        tree = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
      } else {
        var tree$2 = tree;
        var this$3 = $n(tree$2);
        tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
      }
    }
  }
}
function $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__($thiz, root, start, ordering) {
  $thiz.sci_RedBlackTree$TreeIterator__f_root = root;
  $thiz.sci_RedBlackTree$TreeIterator__f_ordering = ordering;
  if ((root === null)) {
    var $$x1 = null
  } else {
    var this$1 = $n(root);
    var i = ((1 + (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0);
    var maximumHeight = (((-2) + (((32 - $uI(Math.clz32(i))) | 0) << 1)) | 0);
    var $$x1 = new ($d_sci_RedBlackTree$Tree.getArrayOf().constr)(maximumHeight)
  };
  $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts = $$x1;
  $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  var this$3 = $n(start);
  $thiz.sci_RedBlackTree$TreeIterator__f_lookahead = ((!this$3.isEmpty__Z()) ? $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, $n(start).get__O()) : $thiz.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(root));
  return $thiz
}
/** @constructor */
function $c_sci_RedBlackTree$TreeIterator() {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null
}
$c_sci_RedBlackTree$TreeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RedBlackTree$TreeIterator.prototype.constructor = $c_sci_RedBlackTree$TreeIterator;
/** @constructor */
function $h_sci_RedBlackTree$TreeIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$TreeIterator.prototype = $c_sci_RedBlackTree$TreeIterator.prototype;
$c_sci_RedBlackTree$TreeIterator.prototype.hasNext__Z = (function() {
  return (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)
});
$c_sci_RedBlackTree$TreeIterator.prototype.next__O = (function() {
  var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
  if ((tree !== null)) {
    var this$1 = $n(tree);
    this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    return this.nextResult__sci_RedBlackTree$Tree__O(tree)
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
$c_sci_RedBlackTree$TreeIterator.prototype.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  while (true) {
    if ((tree === null)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return $n(this.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      }
    } else {
      var this$1 = $n(tree);
      if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === null)) {
        return tree
      } else {
        var tree$1 = tree;
        $n(this.sci_RedBlackTree$TreeIterator__f_stackOfNexts).set(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index, tree$1);
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var this$2 = $n(tree$1);
        tree = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
      }
    }
  }
});
/** @constructor */
function $c_sci_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_List$())
}
$c_sci_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_Seq$.prototype.constructor = $c_sci_Seq$;
/** @constructor */
function $h_sci_Seq$() {
  /*<skip>*/
}
$h_sci_Seq$.prototype = $c_sci_Seq$.prototype;
$c_sci_Seq$.prototype.from__sc_IterableOnce__sci_Seq = (function(it) {
  if ($is_sci_Seq(it)) {
    var x2 = $as_sci_Seq(it);
    return x2
  } else {
    return $as_sci_Seq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it))
  }
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Seq(source)
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_Seq(it)
});
var $d_sci_Seq$ = new $TypeData().initClass({
  sci_Seq$: 0
}, false, "scala.collection.immutable.Seq$", {
  sci_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Seq$.prototype.$classData = $d_sci_Seq$;
var $n_sci_Seq$;
function $m_sci_Seq$() {
  if ((!$n_sci_Seq$)) {
    $n_sci_Seq$ = new $c_sci_Seq$()
  };
  return $n_sci_Seq$
}
/** @constructor */
function $c_sci_SetBuilderImpl() {
  this.sci_SetBuilderImpl__f_elems = null;
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
  this.sci_SetBuilderImpl__f_hashSetBuilder = null;
  this.sci_SetBuilderImpl__f_elems = $m_sci_Set$EmptySet$();
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false
}
$c_sci_SetBuilderImpl.prototype = new $h_O();
$c_sci_SetBuilderImpl.prototype.constructor = $c_sci_SetBuilderImpl;
/** @constructor */
function $h_sci_SetBuilderImpl() {
  /*<skip>*/
}
$h_sci_SetBuilderImpl.prototype = $c_sci_SetBuilderImpl.prototype;
$c_sci_SetBuilderImpl.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_SetBuilderImpl.prototype.result__sci_Set = (function() {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? $n(this.sci_SetBuilderImpl__f_hashSetBuilder).result__sci_HashSet() : this.sci_SetBuilderImpl__f_elems)
});
$c_sci_SetBuilderImpl.prototype.addOne__O__sci_SetBuilderImpl = (function(elem) {
  if (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder) {
    $n(this.sci_SetBuilderImpl__f_hashSetBuilder).addOne__O__sci_HashSetBuilder(elem)
  } else if (($n(this.sci_SetBuilderImpl__f_elems).size__I() < 4)) {
    var this$1 = $n(this.sci_SetBuilderImpl__f_elems);
    this.sci_SetBuilderImpl__f_elems = $as_sci_Set(this$1.incl__O__sci_SetOps(elem))
  } else if ((!$n(this.sci_SetBuilderImpl__f_elems).contains__O__Z(elem))) {
    this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = true;
    if ((this.sci_SetBuilderImpl__f_hashSetBuilder === null)) {
      this.sci_SetBuilderImpl__f_hashSetBuilder = new $c_sci_HashSetBuilder()
    };
    $n($as_sci_Set$Set4(this.sci_SetBuilderImpl__f_elems)).buildTo__scm_Builder__scm_Builder(this.sci_SetBuilderImpl__f_hashSetBuilder);
    $n(this.sci_SetBuilderImpl__f_hashSetBuilder).addOne__O__sci_HashSetBuilder(elem)
  };
  return this
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__sci_SetBuilderImpl = (function(xs) {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? ($n(this.sci_SetBuilderImpl__f_hashSetBuilder).addAll__sc_IterableOnce__sci_HashSetBuilder(xs), this) : $as_sci_SetBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)))
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_SetBuilderImpl(xs)
});
$c_sci_SetBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_SetBuilderImpl(elem)
});
$c_sci_SetBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Set()
});
function $as_sci_SetBuilderImpl(obj) {
  return (((obj instanceof $c_sci_SetBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetBuilderImpl"))
}
function $isArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetBuilderImpl)))
}
function $asArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_SetBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetBuilderImpl;", depth))
}
var $d_sci_SetBuilderImpl = new $TypeData().initClass({
  sci_SetBuilderImpl: 0
}, false, "scala.collection.immutable.SetBuilderImpl", {
  sci_SetBuilderImpl: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_SetBuilderImpl.prototype.$classData = $d_sci_SetBuilderImpl;
function $p_sci_Vector$__liftedTree1$1__I($thiz) {
  try {
    $m_sc_StringOps$();
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.Vector.defaultApplyPreferredMaxLength", "250");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10)
  } catch (e) {
    if (false) {
      return 250
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_sci_Vector$() {
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = 0;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = null;
  $n_sci_Vector$ = this;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = $p_sci_Vector$__liftedTree1$1__I(this);
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = new $c_sci_NewVectorIterator($m_sci_Vector0$(), 0, 0)
}
$c_sci_Vector$.prototype = new $h_O();
$c_sci_Vector$.prototype.constructor = $c_sci_Vector$;
/** @constructor */
function $h_sci_Vector$() {
  /*<skip>*/
}
$h_sci_Vector$.prototype = $c_sci_Vector$.prototype;
$c_sci_Vector$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Vector(elems)
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__sci_Vector = (function(it) {
  if ((it instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(it);
    return x2
  } else {
    var knownSize = $n(it).knownSize__I();
    if ((knownSize === 0)) {
      return $m_sci_Vector0$()
    } else if (((knownSize > 0) && (knownSize <= 32))) {
      matchEnd5: {
        var a1$3;
        if ((it instanceof $c_sci_ArraySeq$ofRef)) {
          var x2$2 = $as_sci_ArraySeq$ofRef(it);
          var x = $n($n(x2$2).elemTag__s_reflect_ClassTag()).runtimeClass__jl_Class();
          if ((x !== null)) {
            var this$1 = $n(x);
            var $$x1 = (this$1 === $d_O.getClassOf())
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            var a1$3 = $n(x2$2).sci_ArraySeq$ofRef__f_unsafeArray;
            break matchEnd5
          }
        };
        if ($is_sci_Iterable(it)) {
          var x3 = $as_sci_Iterable(it);
          var a1 = new $ac_O(knownSize);
          var this$2 = $n(x3);
          this$2.copyToArray__O__I__I__I(a1, 0, 2147483647);
          var a1$3 = a1;
          break matchEnd5
        };
        var a1$2 = new $ac_O(knownSize);
        var this$3 = $n($n(it).iterator__sc_Iterator());
        this$3.copyToArray__O__I__I__I(a1$2, 0, 2147483647);
        var a1$3 = a1$2
      };
      return new $c_sci_Vector1(a1$3)
    } else {
      var this$4 = new $c_sci_VectorBuilder();
      var this$5 = $n(this$4.addAll__sc_IterableOnce__sci_VectorBuilder(it));
      return this$5.result__sci_Vector()
    }
  }
});
$c_sci_Vector$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_VectorBuilder()
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Vector(source)
});
$c_sci_Vector$.prototype.empty__O = (function() {
  return $m_sci_Vector0$()
});
var $d_sci_Vector$ = new $TypeData().initClass({
  sci_Vector$: 0
}, false, "scala.collection.immutable.Vector$", {
  sci_Vector$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector$.prototype.$classData = $d_sci_Vector$;
var $n_sci_Vector$;
function $m_sci_Vector$() {
  if ((!$n_sci_Vector$)) {
    $n_sci_Vector$ = new $c_sci_Vector$()
  };
  return $n_sci_Vector$
}
function $p_sci_VectorBuilder__leftAlignPrefix__V($thiz) {
  var a = null;
  var aParent = null;
  if (($thiz.sci_VectorBuilder__f_depth >= 6)) {
    a = $thiz.sci_VectorBuilder__f_a6;
    var i = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 25) | 0);
    if ((i > 0)) {
      var src = a;
      var dest = a;
      var length = ((64 - i) | 0);
      $systemArraycopyRefs($n(src), i, $n(dest), 0, length)
    };
    var newOffset = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 33554432) | 0);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset) | 0)) | 0);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset;
    if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 25) | 0) === 0)) {
      $thiz.sci_VectorBuilder__f_depth = 5
    };
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1)
  };
  if (($thiz.sci_VectorBuilder__f_depth >= 5)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a5
    };
    var i$2 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 20) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 5)) {
      if ((i$2 > 0)) {
        var src$1 = a;
        var dest$1 = a;
        var length$1 = ((32 - i$2) | 0);
        $systemArraycopyRefs($n(src$1), i$2, $n(dest$1), 0, length$1)
      };
      $thiz.sci_VectorBuilder__f_a5 = $asArrayOf_O(a, 5);
      var newOffset$1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 1048576) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$1) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$1;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 20) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 4
      }
    } else {
      if ((i$2 > 0)) {
        var original = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, i$2, 32)
      };
      $n(aParent).set(0, a)
    };
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1)
  };
  if (($thiz.sci_VectorBuilder__f_depth >= 4)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a4
    };
    var i$3 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 15) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 4)) {
      if ((i$3 > 0)) {
        var src$2 = a;
        var dest$2 = a;
        var length$2 = ((32 - i$3) | 0);
        $systemArraycopyRefs($n(src$2), i$3, $n(dest$2), 0, length$2)
      };
      $thiz.sci_VectorBuilder__f_a4 = $asArrayOf_O(a, 4);
      var newOffset$2 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 32768) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$2) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$2;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 15) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 3
      }
    } else {
      if ((i$3 > 0)) {
        var original$1 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, i$3, 32)
      };
      $n(aParent).set(0, a)
    };
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1)
  };
  if (($thiz.sci_VectorBuilder__f_depth >= 3)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a3
    };
    var i$4 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 10) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 3)) {
      if ((i$4 > 0)) {
        var src$3 = a;
        var dest$3 = a;
        var length$3 = ((32 - i$4) | 0);
        $systemArraycopyRefs($n(src$3), i$4, $n(dest$3), 0, length$3)
      };
      $thiz.sci_VectorBuilder__f_a3 = $asArrayOf_O(a, 3);
      var newOffset$3 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 1024) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$3) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$3;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 10) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 2
      }
    } else {
      if ((i$4 > 0)) {
        var original$2 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$2, i$4, 32)
      };
      $n(aParent).set(0, a)
    };
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1)
  };
  if (($thiz.sci_VectorBuilder__f_depth >= 2)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a2
    };
    var i$5 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 5) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 2)) {
      if ((i$5 > 0)) {
        var src$4 = a;
        var dest$4 = a;
        var length$4 = ((32 - i$5) | 0);
        $systemArraycopyRefs($n(src$4), i$5, $n(dest$4), 0, length$4)
      };
      $thiz.sci_VectorBuilder__f_a2 = $asArrayOf_O(a, 2);
      var newOffset$4 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 32) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$4) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$4;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 5) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 1
      }
    } else {
      if ((i$5 > 0)) {
        var original$3 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$3, i$5, 32)
      };
      $n(aParent).set(0, a)
    };
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1)
  };
  if (($thiz.sci_VectorBuilder__f_depth >= 1)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a1
    };
    var i$6 = (31 & $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset);
    if (($thiz.sci_VectorBuilder__f_depth === 1)) {
      if ((i$6 > 0)) {
        var src$5 = a;
        var dest$5 = a;
        var length$5 = ((32 - i$6) | 0);
        $systemArraycopyRefs($n(src$5), i$6, $n(dest$5), 0, length$5)
      };
      $thiz.sci_VectorBuilder__f_a1 = a;
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0
    } else {
      if ((i$6 > 0)) {
        var original$4 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$4, i$6, 32)
      };
      $n(aParent).set(0, a)
    }
  };
  $thiz.sci_VectorBuilder__f_prefixIsRightAligned = false
}
function $p_sci_VectorBuilder__addArr1__AO__V($thiz, data) {
  var dl = $n(data).u.length;
  if ((dl > 0)) {
    if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
      $p_sci_VectorBuilder__advance__V($thiz)
    };
    var a = ((32 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
    var copy1 = ((a < dl) ? a : dl);
    var copy2 = ((dl - copy1) | 0);
    var dest = $thiz.sci_VectorBuilder__f_a1;
    var destPos = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1;
    $systemArraycopyRefs($n(data), 0, $n(dest), destPos, copy1);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy1) | 0);
    if ((copy2 > 0)) {
      $p_sci_VectorBuilder__advance__V($thiz);
      var dest$1 = $thiz.sci_VectorBuilder__f_a1;
      $systemArraycopyRefs($n(data), copy1, $n(dest$1), 0, copy2);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy2) | 0)
    }
  }
}
function $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, dim) {
  if (($m_sc_ArrayOps$(), ($n(slice).u.length === 0))) {
    return (void 0)
  };
  if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V($thiz)
  };
  var sl = $n(slice).u.length;
  switch (dim) {
    case 2: {
      var a = (31 & ((((1024 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 5) | 0));
      var copy1 = ((a < sl) ? a : sl);
      var copy2 = ((sl - copy1) | 0);
      var destPos = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 5) | 0));
      var dest = $thiz.sci_VectorBuilder__f_a2;
      $systemArraycopyRefs($n(slice), 0, $n(dest), destPos, copy1);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1 << 5));
      if ((copy2 > 0)) {
        var dest$1 = $thiz.sci_VectorBuilder__f_a2;
        $systemArraycopyRefs($n(slice), copy1, $n(dest$1), 0, copy2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2 << 5))
      };
      break
    }
    case 3: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 1024) | 0) !== 0)) {
        $m_sc_ArrayOps$();
        var f = ((e$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$2, 1), 2)
        });
        var len = $n(slice).u.length;
        var i = 0;
        if ((slice !== null)) {
          while ((i < len)) {
            var arg1 = $n(slice).get(i);
            f(arg1);
            i = ((1 + i) | 0)
          }
        } else if ((slice instanceof $ac_I)) {
          var x3 = $asArrayOf_I(slice, 1);
          while ((i < len)) {
            var arg1$1 = $n(x3).get(i);
            f(arg1$1);
            i = ((1 + i) | 0)
          }
        } else if ((slice instanceof $ac_D)) {
          var x4 = $asArrayOf_D(slice, 1);
          while ((i < len)) {
            var arg1$2 = $n(x4).get(i);
            f(arg1$2);
            i = ((1 + i) | 0)
          }
        } else if ((slice instanceof $ac_J)) {
          var x5 = $asArrayOf_J(slice, 1);
          while ((i < len)) {
            var t = $n(x5).get(i);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            f(new $c_RTLong(lo, hi));
            i = ((1 + i) | 0)
          }
        } else if ((slice instanceof $ac_F)) {
          var x6 = $asArrayOf_F(slice, 1);
          while ((i < len)) {
            var arg1$3 = $n(x6).get(i);
            f(arg1$3);
            i = ((1 + i) | 0)
          }
        } else if ((slice instanceof $ac_C)) {
          var x7 = $asArrayOf_C(slice, 1);
          while ((i < len)) {
            var arg1$4 = $n(x7).get(i);
            f($bC(arg1$4));
            i = ((1 + i) | 0)
          }
        } else if ((slice instanceof $ac_B)) {
          var x8 = $asArrayOf_B(slice, 1);
          while ((i < len)) {
            var arg1$5 = $n(x8).get(i);
            f(arg1$5);
            i = ((1 + i) | 0)
          }
        } else if ((slice instanceof $ac_S)) {
          var x9 = $asArrayOf_S(slice, 1);
          while ((i < len)) {
            var arg1$6 = $n(x9).get(i);
            f(arg1$6);
            i = ((1 + i) | 0)
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10 = $asArrayOf_Z(slice, 1);
          while ((i < len)) {
            var arg1$7 = $n(x10).get(i);
            f(arg1$7);
            i = ((1 + i) | 0)
          }
        } else {
          throw new $c_s_MatchError(slice)
        };
        return (void 0)
      };
      var a$1 = (31 & ((((32768 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 10) | 0));
      var copy1$2 = ((a$1 < sl) ? a$1 : sl);
      var copy2$2 = ((sl - copy1$2) | 0);
      var destPos$2 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 10) | 0));
      var dest$2 = $thiz.sci_VectorBuilder__f_a3;
      $systemArraycopyRefs($n(slice), 0, $n(dest$2), destPos$2, copy1$2);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$2 << 10));
      if ((copy2$2 > 0)) {
        var dest$3 = $thiz.sci_VectorBuilder__f_a3;
        $systemArraycopyRefs($n(slice), copy1$2, $n(dest$3), 0, copy2$2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$2 << 10))
      };
      break
    }
    case 4: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 32768) | 0) !== 0)) {
        $m_sc_ArrayOps$();
        var f$1 = ((e$3$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$3$2, 1), 3)
        });
        var len$1 = $n(slice).u.length;
        var i$1 = 0;
        if ((slice !== null)) {
          while ((i$1 < len$1)) {
            var arg1$8 = $n(slice).get(i$1);
            f$1(arg1$8);
            i$1 = ((1 + i$1) | 0)
          }
        } else if ((slice instanceof $ac_I)) {
          var x3$1 = $asArrayOf_I(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$9 = $n(x3$1).get(i$1);
            f$1(arg1$9);
            i$1 = ((1 + i$1) | 0)
          }
        } else if ((slice instanceof $ac_D)) {
          var x4$1 = $asArrayOf_D(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$10 = $n(x4$1).get(i$1);
            f$1(arg1$10);
            i$1 = ((1 + i$1) | 0)
          }
        } else if ((slice instanceof $ac_J)) {
          var x5$1 = $asArrayOf_J(slice, 1);
          while ((i$1 < len$1)) {
            var t$1 = $n(x5$1).get(i$1);
            var lo$1 = t$1.RTLong__f_lo;
            var hi$1 = t$1.RTLong__f_hi;
            f$1(new $c_RTLong(lo$1, hi$1));
            i$1 = ((1 + i$1) | 0)
          }
        } else if ((slice instanceof $ac_F)) {
          var x6$1 = $asArrayOf_F(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$11 = $n(x6$1).get(i$1);
            f$1(arg1$11);
            i$1 = ((1 + i$1) | 0)
          }
        } else if ((slice instanceof $ac_C)) {
          var x7$1 = $asArrayOf_C(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$12 = $n(x7$1).get(i$1);
            f$1($bC(arg1$12));
            i$1 = ((1 + i$1) | 0)
          }
        } else if ((slice instanceof $ac_B)) {
          var x8$1 = $asArrayOf_B(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$13 = $n(x8$1).get(i$1);
            f$1(arg1$13);
            i$1 = ((1 + i$1) | 0)
          }
        } else if ((slice instanceof $ac_S)) {
          var x9$1 = $asArrayOf_S(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$14 = $n(x9$1).get(i$1);
            f$1(arg1$14);
            i$1 = ((1 + i$1) | 0)
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10$1 = $asArrayOf_Z(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$15 = $n(x10$1).get(i$1);
            f$1(arg1$15);
            i$1 = ((1 + i$1) | 0)
          }
        } else {
          throw new $c_s_MatchError(slice)
        };
        return (void 0)
      };
      var a$2 = (31 & ((((1048576 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 15) | 0));
      var copy1$3 = ((a$2 < sl) ? a$2 : sl);
      var copy2$3 = ((sl - copy1$3) | 0);
      var destPos$3 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 15) | 0));
      var dest$4 = $thiz.sci_VectorBuilder__f_a4;
      $systemArraycopyRefs($n(slice), 0, $n(dest$4), destPos$3, copy1$3);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$3 << 15));
      if ((copy2$3 > 0)) {
        var dest$5 = $thiz.sci_VectorBuilder__f_a4;
        $systemArraycopyRefs($n(slice), copy1$3, $n(dest$5), 0, copy2$3);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$3 << 15))
      };
      break
    }
    case 5: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 1048576) | 0) !== 0)) {
        $m_sc_ArrayOps$();
        var f$2 = ((e$4$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$4$2, 1), 4)
        });
        var len$2 = $n(slice).u.length;
        var i$2 = 0;
        if ((slice !== null)) {
          while ((i$2 < len$2)) {
            var arg1$16 = $n(slice).get(i$2);
            f$2(arg1$16);
            i$2 = ((1 + i$2) | 0)
          }
        } else if ((slice instanceof $ac_I)) {
          var x3$2 = $asArrayOf_I(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$17 = $n(x3$2).get(i$2);
            f$2(arg1$17);
            i$2 = ((1 + i$2) | 0)
          }
        } else if ((slice instanceof $ac_D)) {
          var x4$2 = $asArrayOf_D(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$18 = $n(x4$2).get(i$2);
            f$2(arg1$18);
            i$2 = ((1 + i$2) | 0)
          }
        } else if ((slice instanceof $ac_J)) {
          var x5$2 = $asArrayOf_J(slice, 1);
          while ((i$2 < len$2)) {
            var t$2 = $n(x5$2).get(i$2);
            var lo$2 = t$2.RTLong__f_lo;
            var hi$2 = t$2.RTLong__f_hi;
            f$2(new $c_RTLong(lo$2, hi$2));
            i$2 = ((1 + i$2) | 0)
          }
        } else if ((slice instanceof $ac_F)) {
          var x6$2 = $asArrayOf_F(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$19 = $n(x6$2).get(i$2);
            f$2(arg1$19);
            i$2 = ((1 + i$2) | 0)
          }
        } else if ((slice instanceof $ac_C)) {
          var x7$2 = $asArrayOf_C(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$20 = $n(x7$2).get(i$2);
            f$2($bC(arg1$20));
            i$2 = ((1 + i$2) | 0)
          }
        } else if ((slice instanceof $ac_B)) {
          var x8$2 = $asArrayOf_B(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$21 = $n(x8$2).get(i$2);
            f$2(arg1$21);
            i$2 = ((1 + i$2) | 0)
          }
        } else if ((slice instanceof $ac_S)) {
          var x9$2 = $asArrayOf_S(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$22 = $n(x9$2).get(i$2);
            f$2(arg1$22);
            i$2 = ((1 + i$2) | 0)
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10$2 = $asArrayOf_Z(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$23 = $n(x10$2).get(i$2);
            f$2(arg1$23);
            i$2 = ((1 + i$2) | 0)
          }
        } else {
          throw new $c_s_MatchError(slice)
        };
        return (void 0)
      };
      var a$3 = (31 & ((((33554432 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 20) | 0));
      var copy1$4 = ((a$3 < sl) ? a$3 : sl);
      var copy2$4 = ((sl - copy1$4) | 0);
      var destPos$4 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 20) | 0));
      var dest$6 = $thiz.sci_VectorBuilder__f_a5;
      $systemArraycopyRefs($n(slice), 0, $n(dest$6), destPos$4, copy1$4);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$4 << 20));
      if ((copy2$4 > 0)) {
        var dest$7 = $thiz.sci_VectorBuilder__f_a5;
        $systemArraycopyRefs($n(slice), copy1$4, $n(dest$7), 0, copy2$4);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$4 << 20))
      };
      break
    }
    case 6: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 33554432) | 0) !== 0)) {
        $m_sc_ArrayOps$();
        var f$3 = ((e$5$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$5$2, 1), 5)
        });
        var len$3 = $n(slice).u.length;
        var i$3 = 0;
        if ((slice !== null)) {
          while ((i$3 < len$3)) {
            var arg1$24 = $n(slice).get(i$3);
            f$3(arg1$24);
            i$3 = ((1 + i$3) | 0)
          }
        } else if ((slice instanceof $ac_I)) {
          var x3$3 = $asArrayOf_I(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$25 = $n(x3$3).get(i$3);
            f$3(arg1$25);
            i$3 = ((1 + i$3) | 0)
          }
        } else if ((slice instanceof $ac_D)) {
          var x4$3 = $asArrayOf_D(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$26 = $n(x4$3).get(i$3);
            f$3(arg1$26);
            i$3 = ((1 + i$3) | 0)
          }
        } else if ((slice instanceof $ac_J)) {
          var x5$3 = $asArrayOf_J(slice, 1);
          while ((i$3 < len$3)) {
            var t$3 = $n(x5$3).get(i$3);
            var lo$3 = t$3.RTLong__f_lo;
            var hi$3 = t$3.RTLong__f_hi;
            f$3(new $c_RTLong(lo$3, hi$3));
            i$3 = ((1 + i$3) | 0)
          }
        } else if ((slice instanceof $ac_F)) {
          var x6$3 = $asArrayOf_F(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$27 = $n(x6$3).get(i$3);
            f$3(arg1$27);
            i$3 = ((1 + i$3) | 0)
          }
        } else if ((slice instanceof $ac_C)) {
          var x7$3 = $asArrayOf_C(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$28 = $n(x7$3).get(i$3);
            f$3($bC(arg1$28));
            i$3 = ((1 + i$3) | 0)
          }
        } else if ((slice instanceof $ac_B)) {
          var x8$3 = $asArrayOf_B(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$29 = $n(x8$3).get(i$3);
            f$3(arg1$29);
            i$3 = ((1 + i$3) | 0)
          }
        } else if ((slice instanceof $ac_S)) {
          var x9$3 = $asArrayOf_S(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$30 = $n(x9$3).get(i$3);
            f$3(arg1$30);
            i$3 = ((1 + i$3) | 0)
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10$3 = $asArrayOf_Z(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$31 = $n(x10$3).get(i$3);
            f$3(arg1$31);
            i$3 = ((1 + i$3) | 0)
          }
        } else {
          throw new $c_s_MatchError(slice)
        };
        return (void 0)
      };
      var destPos$5 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 25) | 0);
      if ((((destPos$5 + sl) | 0) > 64)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "exceeding 2^31 elements")
      };
      var dest$8 = $thiz.sci_VectorBuilder__f_a6;
      $systemArraycopyRefs($n(slice), 0, $n(dest$8), destPos$5, sl);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (sl << 25));
      break
    }
    default: {
      throw new $c_s_MatchError(dim)
    }
  }
}
function $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder($thiz, xs) {
  var sliceCount = $n(xs).vectorSliceCount__I();
  var sliceIdx = 0;
  while ((sliceIdx < sliceCount)) {
    var slice = $n(xs).vectorSlice__I__AO(sliceIdx);
    var idx = sliceIdx;
    var c = ((sliceCount / 2) | 0);
    var a = ((idx - c) | 0);
    var x1 = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
    if ((x1 === 1)) {
      $p_sci_VectorBuilder__addArr1__AO__V($thiz, slice)
    } else if ((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32) || ($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0))) {
      $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, x1)
    } else {
      $m_sci_VectorStatics$().foreachRec__I__AO__F1__V((((-2) + x1) | 0), slice, new $c_sjsr_AnonFunction1(((data$2) => {
        var data = $asArrayOf_O(data$2, 1);
        $p_sci_VectorBuilder__addArr1__AO__V($thiz, data)
      })))
    };
    sliceIdx = ((1 + sliceIdx) | 0)
  };
  return $thiz
}
function $p_sci_VectorBuilder__advance__V($thiz) {
  var idx = ((32 + $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor)
}
function $p_sci_VectorBuilder__advanceN__I__V($thiz, n) {
  if ((n > 0)) {
    var idx = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest + n) | 0);
    var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
    $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor)
  }
}
function $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor) {
  if ((xor <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((((((((((((((("advance1(" + idx) + ", ") + xor) + "): a1=") + $thiz.sci_VectorBuilder__f_a1) + ", a2=") + $thiz.sci_VectorBuilder__f_a2) + ", a3=") + $thiz.sci_VectorBuilder__f_a3) + ", a4=") + $thiz.sci_VectorBuilder__f_a4) + ", a5=") + $thiz.sci_VectorBuilder__f_a5) + ", a6=") + $thiz.sci_VectorBuilder__f_a6) + ", depth=") + $thiz.sci_VectorBuilder__f_depth))
  } else if ((xor < 1024)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 1)) {
      $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a2).set(0, $thiz.sci_VectorBuilder__f_a1);
      $thiz.sci_VectorBuilder__f_depth = 2
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1)
  } else if ((xor < 32768)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 2)) {
      $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a3).set(0, $thiz.sci_VectorBuilder__f_a2);
      $thiz.sci_VectorBuilder__f_depth = 3
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2)
  } else if ((xor < 1048576)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 3)) {
      $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a4).set(0, $thiz.sci_VectorBuilder__f_a3);
      $thiz.sci_VectorBuilder__f_depth = 4
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $n($thiz.sci_VectorBuilder__f_a4).set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3)
  } else if ((xor < 33554432)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 4)) {
      $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a5).set(0, $thiz.sci_VectorBuilder__f_a4);
      $thiz.sci_VectorBuilder__f_depth = 5
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $n($thiz.sci_VectorBuilder__f_a4).set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $n($thiz.sci_VectorBuilder__f_a5).set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4)
  } else {
    if (($thiz.sci_VectorBuilder__f_depth <= 5)) {
      $thiz.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $n($thiz.sci_VectorBuilder__f_a6).set(0, $thiz.sci_VectorBuilder__f_a5);
      $thiz.sci_VectorBuilder__f_depth = 6
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $n($thiz.sci_VectorBuilder__f_a4).set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $n($thiz.sci_VectorBuilder__f_a5).set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4);
    $n($thiz.sci_VectorBuilder__f_a6).set(((idx >>> 25) | 0), $thiz.sci_VectorBuilder__f_a5)
  }
}
/** @constructor */
function $c_sci_VectorBuilder() {
  this.sci_VectorBuilder__f_a6 = null;
  this.sci_VectorBuilder__f_a5 = null;
  this.sci_VectorBuilder__f_a4 = null;
  this.sci_VectorBuilder__f_a3 = null;
  this.sci_VectorBuilder__f_a2 = null;
  this.sci_VectorBuilder__f_a1 = null;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
  this.sci_VectorBuilder__f_prefixIsRightAligned = false;
  this.sci_VectorBuilder__f_depth = 0;
  this.sci_VectorBuilder__f_a1 = new $ac_O(32);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
  this.sci_VectorBuilder__f_prefixIsRightAligned = false;
  this.sci_VectorBuilder__f_depth = 1
}
$c_sci_VectorBuilder.prototype = new $h_O();
$c_sci_VectorBuilder.prototype.constructor = $c_sci_VectorBuilder;
/** @constructor */
function $h_sci_VectorBuilder() {
  /*<skip>*/
}
$h_sci_VectorBuilder.prototype = $c_sci_VectorBuilder.prototype;
$c_sci_VectorBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_VectorBuilder.prototype.initFrom__AO__V = (function(prefix1) {
  this.sci_VectorBuilder__f_depth = 1;
  var i = $n(prefix1).u.length;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  this.sci_VectorBuilder__f_a1 = (($n(prefix1).u.length === 32) ? prefix1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(prefix1, 0, 32));
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0)
  }
});
$c_sci_VectorBuilder.prototype.initFrom__sci_Vector__sci_VectorBuilder = (function(v) {
  var x1 = $n(v).vectorSliceCount__I();
  switch (x1) {
    case 0: {
      break
    }
    case 1: {
      var v1 = $as_sci_Vector1(v);
      this.sci_VectorBuilder__f_depth = 1;
      var i = $n($n(v1).sci_Vector__f_prefix1).u.length;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      var a = $n(v1).sci_Vector__f_prefix1;
      this.sci_VectorBuilder__f_a1 = (($n(a).u.length === 32) ? a : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, 32));
      break
    }
    case 3: {
      var v2 = $as_sci_Vector2(v);
      var d2 = $n(v2).sci_Vector2__f_data2;
      var a$1 = $n(v2).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$1).u.length === 32) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 0, 32));
      this.sci_VectorBuilder__f_depth = 2;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((32 - $n(v2).sci_Vector2__f_len1) | 0);
      var i$1 = (($n(v2).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$1);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$1 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a2).set(0, $n(v2).sci_Vector__f_prefix1);
      var dest = this.sci_VectorBuilder__f_a2;
      var length = $n(d2).u.length;
      $systemArraycopyRefs($n(d2), 0, $n(dest), 1, length);
      $n(this.sci_VectorBuilder__f_a2).set(((1 + $n(d2).u.length) | 0), this.sci_VectorBuilder__f_a1);
      break
    }
    case 5: {
      var v3 = $as_sci_Vector3(v);
      var d3 = $n(v3).sci_Vector3__f_data3;
      var s2 = $n(v3).sci_Vector3__f_suffix2;
      var a$2 = $n(v3).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$2).u.length === 32) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 0, 32));
      this.sci_VectorBuilder__f_depth = 3;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((1024 - $n(v3).sci_Vector3__f_len12) | 0);
      var i$2 = (($n(v3).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$2);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$2 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a3).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v3).sci_Vector__f_prefix1, $n(v3).sci_Vector3__f_prefix2), 2));
      var dest$1 = this.sci_VectorBuilder__f_a3;
      var length$1 = $n(d3).u.length;
      $systemArraycopyRefs($n(d3), 0, $n(dest$1), 1, length$1);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2, 32), 2);
      $n(this.sci_VectorBuilder__f_a3).set(((1 + $n(d3).u.length) | 0), this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2).u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 7: {
      var v4 = $as_sci_Vector4(v);
      var d4 = $n(v4).sci_Vector4__f_data4;
      var s3 = $n(v4).sci_Vector4__f_suffix3;
      var s2$2 = $n(v4).sci_Vector4__f_suffix2;
      var a$3 = $n(v4).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$3).u.length === 32) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 0, 32));
      this.sci_VectorBuilder__f_depth = 4;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((32768 - $n(v4).sci_Vector4__f_len123) | 0);
      var i$3 = (($n(v4).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$3);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$3 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a4).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v4).sci_Vector__f_prefix1, $n(v4).sci_Vector4__f_prefix2), $n(v4).sci_Vector4__f_prefix3), 3));
      var dest$2 = this.sci_VectorBuilder__f_a4;
      var length$2 = $n(d4).u.length;
      $systemArraycopyRefs($n(d4), 0, $n(dest$2), 1, length$2);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$2, 32), 2);
      $n(this.sci_VectorBuilder__f_a4).set(((1 + $n(d4).u.length) | 0), this.sci_VectorBuilder__f_a3);
      $n(this.sci_VectorBuilder__f_a3).set($n(s3).u.length, this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2$2).u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 9: {
      var v5 = $as_sci_Vector5(v);
      var d5 = $n(v5).sci_Vector5__f_data5;
      var s4 = $n(v5).sci_Vector5__f_suffix4;
      var s3$2 = $n(v5).sci_Vector5__f_suffix3;
      var s2$3 = $n(v5).sci_Vector5__f_suffix2;
      var a$4 = $n(v5).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$4).u.length === 32) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 0, 32));
      this.sci_VectorBuilder__f_depth = 5;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((1048576 - $n(v5).sci_Vector5__f_len1234) | 0);
      var i$4 = (($n(v5).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$4);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$4 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a5).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v5).sci_Vector__f_prefix1, $n(v5).sci_Vector5__f_prefix2), $n(v5).sci_Vector5__f_prefix3), $n(v5).sci_Vector5__f_prefix4), 4));
      var dest$3 = this.sci_VectorBuilder__f_a5;
      var length$3 = $n(d5).u.length;
      $systemArraycopyRefs($n(d5), 0, $n(dest$3), 1, length$3);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$2, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$3, 32), 2);
      $n(this.sci_VectorBuilder__f_a5).set(((1 + $n(d5).u.length) | 0), this.sci_VectorBuilder__f_a4);
      $n(this.sci_VectorBuilder__f_a4).set($n(s4).u.length, this.sci_VectorBuilder__f_a3);
      $n(this.sci_VectorBuilder__f_a3).set($n(s3$2).u.length, this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2$3).u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 11: {
      var v6 = $as_sci_Vector6(v);
      var d6 = $n(v6).sci_Vector6__f_data6;
      var s5 = $n(v6).sci_Vector6__f_suffix5;
      var s4$2 = $n(v6).sci_Vector6__f_suffix4;
      var s3$3 = $n(v6).sci_Vector6__f_suffix3;
      var s2$4 = $n(v6).sci_Vector6__f_suffix2;
      var a$5 = $n(v6).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$5).u.length === 32) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 0, 32));
      this.sci_VectorBuilder__f_depth = 6;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((33554432 - $n(v6).sci_Vector6__f_len12345) | 0);
      var i$5 = (($n(v6).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$5);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$5 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $n(this.sci_VectorBuilder__f_a6).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v6).sci_Vector__f_prefix1, $n(v6).sci_Vector6__f_prefix2), $n(v6).sci_Vector6__f_prefix3), $n(v6).sci_Vector6__f_prefix4), $n(v6).sci_Vector6__f_prefix5), 5));
      var dest$4 = this.sci_VectorBuilder__f_a6;
      var length$4 = $n(d6).u.length;
      $systemArraycopyRefs($n(d6), 0, $n(dest$4), 1, length$4);
      this.sci_VectorBuilder__f_a5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s5, 32), 5);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4$2, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$4, 32), 2);
      $n(this.sci_VectorBuilder__f_a6).set(((1 + $n(d6).u.length) | 0), this.sci_VectorBuilder__f_a5);
      $n(this.sci_VectorBuilder__f_a5).set($n(s5).u.length, this.sci_VectorBuilder__f_a4);
      $n(this.sci_VectorBuilder__f_a4).set($n(s4$2).u.length, this.sci_VectorBuilder__f_a3);
      $n(this.sci_VectorBuilder__f_a3).set($n(s3$3).u.length, this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2$4).u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0)
  };
  return this
});
$c_sci_VectorBuilder.prototype.alignTo__I__sci_Vector__sci_VectorBuilder = (function(before, bigVector) {
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 !== 0) || (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest !== 0))) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "A non-empty VectorBuilder cannot be aligned retrospectively. Please call .reset() or use a new VectorBuilder.")
  };
  var x = $m_sci_Vector0$();
  if (x.equals__O__Z(bigVector)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1
  } else if ((bigVector instanceof $c_sci_Vector1)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1
  } else if ((bigVector instanceof $c_sci_Vector2)) {
    var x4 = $as_sci_Vector2(bigVector);
    var _1$mcI$sp = $n(x4).sci_Vector2__f_len1;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp;
    var x1$2___2$mcI$sp = 32
  } else if ((bigVector instanceof $c_sci_Vector3)) {
    var x5 = $as_sci_Vector3(bigVector);
    var _1$mcI$sp$1 = $n(x5).sci_Vector3__f_len12;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$1;
    var x1$2___2$mcI$sp = 1024
  } else if ((bigVector instanceof $c_sci_Vector4)) {
    var x6 = $as_sci_Vector4(bigVector);
    var _1$mcI$sp$2 = $n(x6).sci_Vector4__f_len123;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$2;
    var x1$2___2$mcI$sp = 32768
  } else if ((bigVector instanceof $c_sci_Vector5)) {
    var x7 = $as_sci_Vector5(bigVector);
    var _1$mcI$sp$3 = $n(x7).sci_Vector5__f_len1234;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$3;
    var x1$2___2$mcI$sp = 1048576
  } else {
    if ((!(bigVector instanceof $c_sci_Vector6))) {
      throw new $c_s_MatchError(bigVector)
    };
    var x8 = $as_sci_Vector6(bigVector);
    var _1$mcI$sp$4 = $n(x8).sci_Vector6__f_len12345;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$4;
    var x1$2___2$mcI$sp = 33554432
  };
  var prefixLength = x1$2___1$mcI$sp;
  var maxPrefixLength = x1$2___2$mcI$sp;
  if ((maxPrefixLength === 1)) {
    return this
  };
  var overallPrefixLength = $intMod(((before + prefixLength) | 0), maxPrefixLength);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = $intMod(((maxPrefixLength - overallPrefixLength) | 0), maxPrefixLength);
  $p_sci_VectorBuilder__advanceN__I__V(this, ((-32) & this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset));
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset);
  this.sci_VectorBuilder__f_prefixIsRightAligned = true;
  return this
});
$c_sci_VectorBuilder.prototype.addOne__O__sci_VectorBuilder = (function(elem) {
  if ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V(this)
  };
  $n(this.sci_VectorBuilder__f_a1).set(this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1, elem);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = ((1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  return this
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__sci_VectorBuilder = (function(xs) {
  if ((xs instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(xs);
    return ((((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest === 0)) && (!this.sci_VectorBuilder__f_prefixIsRightAligned)) ? this.initFrom__sci_Vector__sci_VectorBuilder(x2) : $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder(this, x2))
  } else {
    return $as_sci_VectorBuilder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_sci_VectorBuilder.prototype.result__sci_Vector = (function() {
  if (this.sci_VectorBuilder__f_prefixIsRightAligned) {
    $p_sci_VectorBuilder__leftAlignPrefix__V(this)
  };
  var len = ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var realLen = ((len - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
  if ((realLen === 0)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$()
  } else if ((len < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("Vector cannot have negative size " + len))
  } else if ((len <= 32)) {
    var a = this.sci_VectorBuilder__f_a1;
    return new $c_sci_Vector1((($n(a).u.length === realLen) ? a : $m_ju_Arrays$().copyOf__AO__I__AO(a, realLen)))
  } else if ((len <= 1024)) {
    var i1 = (31 & (((-1) + len) | 0));
    var i2 = (((((-1) + len) | 0) >>> 5) | 0);
    var original = this.sci_VectorBuilder__f_a2;
    var data = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, 1, i2), 2);
    var prefix1 = $n(this.sci_VectorBuilder__f_a2).get(0);
    var a$1 = $n(this.sci_VectorBuilder__f_a2).get(i2);
    var len$1 = ((1 + i1) | 0);
    var suffix1 = (($n(a$1).u.length === len$1) ? a$1 : $m_ju_Arrays$().copyOf__AO__I__AO(a$1, len$1));
    return new $c_sci_Vector2(prefix1, ((32 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0), data, suffix1, realLen)
  } else if ((len <= 32768)) {
    var i1$2 = (31 & (((-1) + len) | 0));
    var i2$2 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3 = (((((-1) + len) | 0) >>> 10) | 0);
    var original$1 = this.sci_VectorBuilder__f_a3;
    var data$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, 1, i3), 3);
    var a$2 = $n(this.sci_VectorBuilder__f_a3).get(0);
    var to = $n(a$2).u.length;
    var prefix2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 1, to), 2);
    var prefix1$2 = $n($n(this.sci_VectorBuilder__f_a3).get(0)).get(0);
    var original$2 = $n(this.sci_VectorBuilder__f_a3).get(i3);
    var suffix2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$2, i2$2), 2);
    var a$3 = $n($n(this.sci_VectorBuilder__f_a3).get(i3)).get(i2$2);
    var len$2 = ((1 + i1$2) | 0);
    var suffix1$2 = (($n(a$3).u.length === len$2) ? a$3 : $m_ju_Arrays$().copyOf__AO__I__AO(a$3, len$2));
    var len1 = $n(prefix1$2).u.length;
    var len12 = ((len1 + ($n(prefix2).u.length << 5)) | 0);
    return new $c_sci_Vector3(prefix1$2, len1, prefix2, len12, data$2, suffix2, suffix1$2, realLen)
  } else if ((len <= 1048576)) {
    var i1$3 = (31 & (((-1) + len) | 0));
    var i2$3 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$2 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4 = (((((-1) + len) | 0) >>> 15) | 0);
    var original$3 = this.sci_VectorBuilder__f_a4;
    var data$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$3, 1, i4), 4);
    var a$4 = $n(this.sci_VectorBuilder__f_a4).get(0);
    var to$1 = $n(a$4).u.length;
    var prefix3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 1, to$1), 3);
    var a$5 = $n($n(this.sci_VectorBuilder__f_a4).get(0)).get(0);
    var to$2 = $n(a$5).u.length;
    var prefix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 1, to$2), 2);
    var prefix1$3 = $n($n($n(this.sci_VectorBuilder__f_a4).get(0)).get(0)).get(0);
    var original$4 = $n(this.sci_VectorBuilder__f_a4).get(i4);
    var suffix3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$4, i3$2), 3);
    var original$5 = $n($n(this.sci_VectorBuilder__f_a4).get(i4)).get(i3$2);
    var suffix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$5, i2$3), 2);
    var a$6 = $n($n($n(this.sci_VectorBuilder__f_a4).get(i4)).get(i3$2)).get(i2$3);
    var len$3 = ((1 + i1$3) | 0);
    var suffix1$3 = (($n(a$6).u.length === len$3) ? a$6 : $m_ju_Arrays$().copyOf__AO__I__AO(a$6, len$3));
    var len1$2 = $n(prefix1$3).u.length;
    var len12$2 = ((len1$2 + ($n(prefix2$2).u.length << 5)) | 0);
    var len123 = ((len12$2 + ($n(prefix3).u.length << 10)) | 0);
    return new $c_sci_Vector4(prefix1$3, len1$2, prefix2$2, len12$2, prefix3, len123, data$3, suffix3, suffix2$2, suffix1$3, realLen)
  } else if ((len <= 33554432)) {
    var i1$4 = (31 & (((-1) + len) | 0));
    var i2$4 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$3 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$2 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5 = (((((-1) + len) | 0) >>> 20) | 0);
    var original$6 = this.sci_VectorBuilder__f_a5;
    var data$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$6, 1, i5), 5);
    var a$7 = $n(this.sci_VectorBuilder__f_a5).get(0);
    var to$3 = $n(a$7).u.length;
    var prefix4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$7, 1, to$3), 4);
    var a$8 = $n($n(this.sci_VectorBuilder__f_a5).get(0)).get(0);
    var to$4 = $n(a$8).u.length;
    var prefix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$8, 1, to$4), 3);
    var a$9 = $n($n($n(this.sci_VectorBuilder__f_a5).get(0)).get(0)).get(0);
    var to$5 = $n(a$9).u.length;
    var prefix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$9, 1, to$5), 2);
    var prefix1$4 = $n($n($n($n(this.sci_VectorBuilder__f_a5).get(0)).get(0)).get(0)).get(0);
    var original$7 = $n(this.sci_VectorBuilder__f_a5).get(i5);
    var suffix4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$7, i4$2), 4);
    var original$8 = $n($n(this.sci_VectorBuilder__f_a5).get(i5)).get(i4$2);
    var suffix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$8, i3$3), 3);
    var original$9 = $n($n($n(this.sci_VectorBuilder__f_a5).get(i5)).get(i4$2)).get(i3$3);
    var suffix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$9, i2$4), 2);
    var a$10 = $n($n($n($n(this.sci_VectorBuilder__f_a5).get(i5)).get(i4$2)).get(i3$3)).get(i2$4);
    var len$4 = ((1 + i1$4) | 0);
    var suffix1$4 = (($n(a$10).u.length === len$4) ? a$10 : $m_ju_Arrays$().copyOf__AO__I__AO(a$10, len$4));
    var len1$3 = $n(prefix1$4).u.length;
    var len12$3 = ((len1$3 + ($n(prefix2$3).u.length << 5)) | 0);
    var len123$2 = ((len12$3 + ($n(prefix3$2).u.length << 10)) | 0);
    var len1234 = ((len123$2 + ($n(prefix4).u.length << 15)) | 0);
    return new $c_sci_Vector5(prefix1$4, len1$3, prefix2$3, len12$3, prefix3$2, len123$2, prefix4, len1234, data$4, suffix4, suffix3$2, suffix2$3, suffix1$4, realLen)
  } else {
    var i1$5 = (31 & (((-1) + len) | 0));
    var i2$5 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$4 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$3 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5$2 = (31 & (((((-1) + len) | 0) >>> 20) | 0));
    var i6 = (((((-1) + len) | 0) >>> 25) | 0);
    var original$10 = this.sci_VectorBuilder__f_a6;
    var data$5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$10, 1, i6), 6);
    var a$11 = $n(this.sci_VectorBuilder__f_a6).get(0);
    var to$6 = $n(a$11).u.length;
    var prefix5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$11, 1, to$6), 5);
    var a$12 = $n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0);
    var to$7 = $n(a$12).u.length;
    var prefix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$12, 1, to$7), 4);
    var a$13 = $n($n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0)).get(0);
    var to$8 = $n(a$13).u.length;
    var prefix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$13, 1, to$8), 3);
    var a$14 = $n($n($n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0)).get(0)).get(0);
    var to$9 = $n(a$14).u.length;
    var prefix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$14, 1, to$9), 2);
    var prefix1$5 = $n($n($n($n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0)).get(0)).get(0)).get(0);
    var original$11 = $n(this.sci_VectorBuilder__f_a6).get(i6);
    var suffix5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$11, i5$2), 5);
    var original$12 = $n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2);
    var suffix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$12, i4$3), 4);
    var original$13 = $n($n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2)).get(i4$3);
    var suffix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$13, i3$4), 3);
    var original$14 = $n($n($n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2)).get(i4$3)).get(i3$4);
    var suffix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$14, i2$5), 2);
    var a$15 = $n($n($n($n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2)).get(i4$3)).get(i3$4)).get(i2$5);
    var len$5 = ((1 + i1$5) | 0);
    var suffix1$5 = (($n(a$15).u.length === len$5) ? a$15 : $m_ju_Arrays$().copyOf__AO__I__AO(a$15, len$5));
    var len1$4 = $n(prefix1$5).u.length;
    var len12$4 = ((len1$4 + ($n(prefix2$4).u.length << 5)) | 0);
    var len123$3 = ((len12$4 + ($n(prefix3$3).u.length << 10)) | 0);
    var len1234$2 = ((len123$3 + ($n(prefix4$2).u.length << 15)) | 0);
    var len12345 = ((len1234$2 + ($n(prefix5).u.length << 20)) | 0);
    return new $c_sci_Vector6(prefix1$5, len1$4, prefix2$4, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data$5, suffix5, suffix4$2, suffix3$3, suffix2$4, suffix1$5, realLen)
  }
});
$c_sci_VectorBuilder.prototype.toString__T = (function() {
  return (((((((("VectorBuilder(len1=" + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) + ", lenRest=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) + ", offset=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) + ", depth=") + this.sci_VectorBuilder__f_depth) + ")")
});
$c_sci_VectorBuilder.prototype.result__O = (function() {
  return this.result__sci_Vector()
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_VectorBuilder(xs)
});
$c_sci_VectorBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_VectorBuilder(elem)
});
function $as_sci_VectorBuilder(obj) {
  return (((obj instanceof $c_sci_VectorBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.VectorBuilder"))
}
function $isArrayOf_sci_VectorBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorBuilder)))
}
function $asArrayOf_sci_VectorBuilder(obj, depth) {
  return (($isArrayOf_sci_VectorBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.VectorBuilder;", depth))
}
var $d_sci_VectorBuilder = new $TypeData().initClass({
  sci_VectorBuilder: 0
}, false, "scala.collection.immutable.VectorBuilder", {
  sci_VectorBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_VectorBuilder.prototype.$classData = $d_sci_VectorBuilder;
function $p_scm_ArrayBuffer$__resizeUp__J__J__I($thiz, arrayLen, targetLen) {
  var ahi = targetLen.RTLong__f_hi;
  var bhi = arrayLen.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ targetLen.RTLong__f_lo) <= ((-2147483648) ^ arrayLen.RTLong__f_lo)) : (ahi < bhi))) {
    return (-1)
  } else {
    var ahi$1 = targetLen.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ targetLen.RTLong__f_lo) > (-1)) : (ahi$1 > 0))) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Collections cannot have more than 2147483647 elements")
    };
    var size = targetLen.RTLong__f_lo;
    if ((size > 2147483645)) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Size of array-backed collection exceeds VM array size limit of 2147483645")
    };
    var lo = arrayLen.RTLong__f_lo;
    var lo$1 = (lo << 1);
    var hi = (((lo >>> 31) | 0) | (arrayLen.RTLong__f_hi << 1));
    var t = (((hi === 0) ? (((-2147483648) ^ lo$1) > (-2147483632)) : (hi > 0)) ? new $c_RTLong(lo$1, hi) : new $c_RTLong(16, 0));
    var lo$2 = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    var ahi$2 = targetLen.RTLong__f_hi;
    if (((ahi$2 === hi$1) ? (((-2147483648) ^ targetLen.RTLong__f_lo) > ((-2147483648) ^ lo$2)) : (ahi$2 > hi$1))) {
      var t$1 = targetLen
    } else {
      var t$1 = new $c_RTLong(lo$2, hi$1)
    };
    var lo$3 = t$1.RTLong__f_lo;
    var hi$2 = t$1.RTLong__f_hi;
    var this$8 = (((hi$2 === 0) ? (((-2147483648) ^ lo$3) < (-3)) : (hi$2 < 0)) ? new $c_RTLong(lo$3, hi$2) : new $c_RTLong(2147483645, 0));
    return this$8.RTLong__f_lo
  }
}
/** @constructor */
function $c_scm_ArrayBuffer$() {
  this.scm_ArrayBuffer$__f_emptyArray = null;
  $n_scm_ArrayBuffer$ = this;
  this.scm_ArrayBuffer$__f_emptyArray = new $ac_O(0)
}
$c_scm_ArrayBuffer$.prototype = new $h_O();
$c_scm_ArrayBuffer$.prototype.constructor = $c_scm_ArrayBuffer$;
/** @constructor */
function $h_scm_ArrayBuffer$() {
  /*<skip>*/
}
$h_scm_ArrayBuffer$.prototype = $c_scm_ArrayBuffer$.prototype;
$c_scm_ArrayBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(elems)
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__scm_ArrayBuffer = (function(coll) {
  var k = $n(coll).knownSize__I();
  if ((k >= 0)) {
    var $$x1 = this.scm_ArrayBuffer$__f_emptyArray;
    var hi = (k >> 31);
    var array = this.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__J__AO($$x1, 0, new $c_RTLong(k, hi));
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      var actual = $n(x2).copyToArray__O__I__I__I(array, 0, 2147483647)
    } else {
      var actual = $n($n(coll).iterator__sc_Iterator()).copyToArray__O__I__I__I(array, 0, 2147483647)
    };
    if ((actual !== k)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + k))
    };
    return $ct_scm_ArrayBuffer__AO__I__(new $c_scm_ArrayBuffer(), array, k)
  } else {
    var this$3 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    return this$3.addAll__sc_IterableOnce__scm_ArrayBuffer(coll)
  }
});
$c_scm_ArrayBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayBuffer$$anon$1()
});
$c_scm_ArrayBuffer$.prototype.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__J__AO = (function(array, curSize, targetSize) {
  var value = $n(array).u.length;
  var hi = (value >> 31);
  var newLen = $p_scm_ArrayBuffer$__resizeUp__J__J__I(this, new $c_RTLong(value, hi), targetSize);
  if ((newLen < 0)) {
    return array
  } else {
    var res = new $ac_O(newLen);
    $systemArraycopyRefs($n(array), 0, res, 0, curSize);
    return res
  }
});
$c_scm_ArrayBuffer$.prototype.empty__O = (function() {
  return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(source)
});
var $d_scm_ArrayBuffer$ = new $TypeData().initClass({
  scm_ArrayBuffer$: 0
}, false, "scala.collection.mutable.ArrayBuffer$", {
  scm_ArrayBuffer$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuffer$.prototype.$classData = $d_scm_ArrayBuffer$;
var $n_scm_ArrayBuffer$;
function $m_scm_ArrayBuffer$() {
  if ((!$n_scm_ArrayBuffer$)) {
    $n_scm_ArrayBuffer$ = new $c_scm_ArrayBuffer$()
  };
  return $n_scm_ArrayBuffer$
}
/** @constructor */
function $c_scm_ArrayBuffer$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())))
}
$c_scm_ArrayBuffer$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayBuffer$$anon$1.prototype.constructor = $c_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $h_scm_ArrayBuffer$$anon$1() {
  /*<skip>*/
}
$h_scm_ArrayBuffer$$anon$1.prototype = $c_scm_ArrayBuffer$$anon$1.prototype;
$c_scm_ArrayBuffer$$anon$1.prototype.sizeHint__I__V = (function(size) {
  $n($as_scm_ArrayBuffer(this.scm_GrowableBuilder__f_elems)).ensureSize__I__V(size)
});
var $d_scm_ArrayBuffer$$anon$1 = new $TypeData().initClass({
  scm_ArrayBuffer$$anon$1: 0
}, false, "scala.collection.mutable.ArrayBuffer$$anon$1", {
  scm_ArrayBuffer$$anon$1: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_ArrayBuffer$$anon$1.prototype.$classData = $d_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $c_scm_ArrayDeque$() {
  /*<skip>*/
}
$c_scm_ArrayDeque$.prototype = new $h_O();
$c_scm_ArrayDeque$.prototype.constructor = $c_scm_ArrayDeque$;
/** @constructor */
function $h_scm_ArrayDeque$() {
  /*<skip>*/
}
$h_scm_ArrayDeque$.prototype = $c_scm_ArrayDeque$.prototype;
$c_scm_ArrayDeque$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(elems)
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__scm_ArrayDeque = (function(coll) {
  var s = $n(coll).knownSize__I();
  if ((s >= 0)) {
    var array = this.alloc__I__AO(s);
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      var actual = $n(x2).copyToArray__O__I__I__I(array, 0, 2147483647)
    } else {
      var actual = $n($n(coll).iterator__sc_Iterator()).copyToArray__O__I__I__I(array, 0, 2147483647)
    };
    if ((actual !== s)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + s))
    };
    return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, s)
  } else {
    var this$2 = $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
    return this$2.addAll__sc_IterableOnce__scm_ArrayDeque(coll)
  }
});
$c_scm_ArrayDeque$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayDeque$$anon$1()
});
$c_scm_ArrayDeque$.prototype.alloc__I__AO = (function(len) {
  var requirement = (len >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Non-negative array size required")
  };
  var size = ((((-2147483648) >>> $uI(Math.clz32(len))) | 0) << 1);
  var requirement$1 = (size >= 0);
  if ((!requirement$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "ArrayDeque too big - cannot allocate ArrayDeque of length ") + len))
  };
  return new $ac_O(((size > 16) ? size : 16))
});
$c_scm_ArrayDeque$.prototype.empty__O = (function() {
  return $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16)
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(source)
});
var $d_scm_ArrayDeque$ = new $TypeData().initClass({
  scm_ArrayDeque$: 0
}, false, "scala.collection.mutable.ArrayDeque$", {
  scm_ArrayDeque$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayDeque$.prototype.$classData = $d_scm_ArrayDeque$;
var $n_scm_ArrayDeque$;
function $m_scm_ArrayDeque$() {
  if ((!$n_scm_ArrayDeque$)) {
    $n_scm_ArrayDeque$ = new $c_scm_ArrayDeque$()
  };
  return $n_scm_ArrayDeque$
}
/** @constructor */
function $c_scm_ArrayDeque$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16))
}
$c_scm_ArrayDeque$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayDeque$$anon$1.prototype.constructor = $c_scm_ArrayDeque$$anon$1;
/** @constructor */
function $h_scm_ArrayDeque$$anon$1() {
  /*<skip>*/
}
$h_scm_ArrayDeque$$anon$1.prototype = $c_scm_ArrayDeque$$anon$1.prototype;
$c_scm_ArrayDeque$$anon$1.prototype.sizeHint__I__V = (function(size) {
  var this$1 = $n($as_scm_ArrayDeque(this.scm_GrowableBuilder__f_elems));
  var idx = this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((size > (((this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this$1.scm_ArrayDeque__f_array).u.length) | 0))) && (size >= $n(this$1.scm_ArrayDeque__f_array).u.length))) {
    this$1.scala$collection$mutable$ArrayDeque$$resize__I__V(size)
  }
});
var $d_scm_ArrayDeque$$anon$1 = new $TypeData().initClass({
  scm_ArrayDeque$$anon$1: 0
}, false, "scala.collection.mutable.ArrayDeque$$anon$1", {
  scm_ArrayDeque$$anon$1: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_ArrayDeque$$anon$1.prototype.$classData = $d_scm_ArrayDeque$$anon$1;
/** @constructor */
function $c_scm_Buffer$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sjs_js_WrappedArray$())
}
$c_scm_Buffer$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_Buffer$.prototype.constructor = $c_scm_Buffer$;
/** @constructor */
function $h_scm_Buffer$() {
  /*<skip>*/
}
$h_scm_Buffer$.prototype = $c_scm_Buffer$.prototype;
var $d_scm_Buffer$ = new $TypeData().initClass({
  scm_Buffer$: 0
}, false, "scala.collection.mutable.Buffer$", {
  scm_Buffer$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Buffer$.prototype.$classData = $d_scm_Buffer$;
var $n_scm_Buffer$;
function $m_scm_Buffer$() {
  if ((!$n_scm_Buffer$)) {
    $n_scm_Buffer$ = new $c_scm_Buffer$()
  };
  return $n_scm_Buffer$
}
/** @constructor */
function $c_scm_HashMap$$anon$6(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), initialCapacity$1, loadFactor$1))
}
$c_scm_HashMap$$anon$6.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashMap$$anon$6.prototype.constructor = $c_scm_HashMap$$anon$6;
/** @constructor */
function $h_scm_HashMap$$anon$6() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$6.prototype = $c_scm_HashMap$$anon$6.prototype;
$c_scm_HashMap$$anon$6.prototype.sizeHint__I__V = (function(size) {
  $n($as_scm_HashMap(this.scm_GrowableBuilder__f_elems)).sizeHint__I__V(size)
});
var $d_scm_HashMap$$anon$6 = new $TypeData().initClass({
  scm_HashMap$$anon$6: 0
}, false, "scala.collection.mutable.HashMap$$anon$6", {
  scm_HashMap$$anon$6: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_HashMap$$anon$6.prototype.$classData = $d_scm_HashMap$$anon$6;
function $ct_scm_HashMap$HashMapIterator__scm_HashMap__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.scm_HashMap$HashMapIterator__f_$outer = outer
  };
  $thiz.scm_HashMap$HashMapIterator__f_i = 0;
  $thiz.scm_HashMap$HashMapIterator__f_node = null;
  $thiz.scm_HashMap$HashMapIterator__f_len = $n($n(outer).scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  return $thiz
}
/** @constructor */
function $c_scm_HashMap$HashMapIterator() {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null
}
$c_scm_HashMap$HashMapIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashMap$HashMapIterator.prototype.constructor = $c_scm_HashMap$HashMapIterator;
/** @constructor */
function $h_scm_HashMap$HashMapIterator() {
  /*<skip>*/
}
$h_scm_HashMap$HashMapIterator.prototype = $c_scm_HashMap$HashMapIterator.prototype;
$c_scm_HashMap$HashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashMap$HashMapIterator__f_node !== null)) {
    return true
  } else {
    while ((this.scm_HashMap$HashMapIterator__f_i < this.scm_HashMap$HashMapIterator__f_len)) {
      var n = $n($n(this.scm_HashMap$HashMapIterator__f_$outer).scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(this.scm_HashMap$HashMapIterator__f_i);
      this.scm_HashMap$HashMapIterator__f_i = ((1 + this.scm_HashMap$HashMapIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashMap$HashMapIterator__f_node = n;
        return true
      }
    };
    return false
  }
});
$c_scm_HashMap$HashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  } else {
    var r = this.extract__scm_HashMap$Node__O(this.scm_HashMap$HashMapIterator__f_node);
    this.scm_HashMap$HashMapIterator__f_node = $n(this.scm_HashMap$HashMapIterator__f_node).scm_HashMap$Node__f__next;
    return r
  }
});
/** @constructor */
function $c_scm_HashSet$$anon$4(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), initialCapacity$1, loadFactor$1))
}
$c_scm_HashSet$$anon$4.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashSet$$anon$4.prototype.constructor = $c_scm_HashSet$$anon$4;
/** @constructor */
function $h_scm_HashSet$$anon$4() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$4.prototype = $c_scm_HashSet$$anon$4.prototype;
$c_scm_HashSet$$anon$4.prototype.sizeHint__I__V = (function(size) {
  $n($as_scm_HashSet(this.scm_GrowableBuilder__f_elems)).sizeHint__I__V(size)
});
var $d_scm_HashSet$$anon$4 = new $TypeData().initClass({
  scm_HashSet$$anon$4: 0
}, false, "scala.collection.mutable.HashSet$$anon$4", {
  scm_HashSet$$anon$4: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_HashSet$$anon$4.prototype.$classData = $d_scm_HashSet$$anon$4;
function $ct_scm_HashSet$HashSetIterator__scm_HashSet__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.scm_HashSet$HashSetIterator__f_$outer = outer
  };
  $thiz.scm_HashSet$HashSetIterator__f_i = 0;
  $thiz.scm_HashSet$HashSetIterator__f_node = null;
  $thiz.scm_HashSet$HashSetIterator__f_len = $n($n(outer).scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length;
  return $thiz
}
/** @constructor */
function $c_scm_HashSet$HashSetIterator() {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null
}
$c_scm_HashSet$HashSetIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashSet$HashSetIterator.prototype.constructor = $c_scm_HashSet$HashSetIterator;
/** @constructor */
function $h_scm_HashSet$HashSetIterator() {
  /*<skip>*/
}
$h_scm_HashSet$HashSetIterator.prototype = $c_scm_HashSet$HashSetIterator.prototype;
$c_scm_HashSet$HashSetIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashSet$HashSetIterator__f_node !== null)) {
    return true
  } else {
    while ((this.scm_HashSet$HashSetIterator__f_i < this.scm_HashSet$HashSetIterator__f_len)) {
      var n = $n($n(this.scm_HashSet$HashSetIterator__f_$outer).scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(this.scm_HashSet$HashSetIterator__f_i);
      this.scm_HashSet$HashSetIterator__f_i = ((1 + this.scm_HashSet$HashSetIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashSet$HashSetIterator__f_node = n;
        return true
      }
    };
    return false
  }
});
$c_scm_HashSet$HashSetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  } else {
    var r = this.extract__scm_HashSet$Node__O(this.scm_HashSet$HashSetIterator__f_node);
    this.scm_HashSet$HashSetIterator__f_node = $n(this.scm_HashSet$HashSetIterator__f_node).scm_HashSet$Node__f__next;
    return r
  }
});
function $ct_scm_ImmutableBuilder__sc_IterableOnce__($thiz, empty) {
  $thiz.scm_ImmutableBuilder__f_elems = empty;
  return $thiz
}
/** @constructor */
function $c_scm_ImmutableBuilder() {
  this.scm_ImmutableBuilder__f_elems = null
}
$c_scm_ImmutableBuilder.prototype = new $h_O();
$c_scm_ImmutableBuilder.prototype.constructor = $c_scm_ImmutableBuilder;
/** @constructor */
function $h_scm_ImmutableBuilder() {
  /*<skip>*/
}
$h_scm_ImmutableBuilder.prototype = $c_scm_ImmutableBuilder.prototype;
$c_scm_ImmutableBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_ImmutableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_ImmutableBuilder.prototype.result__O = (function() {
  return this.scm_ImmutableBuilder__f_elems
});
/** @constructor */
function $c_scm_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_scm_ArrayBuffer$())
}
$c_scm_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_IndexedSeq$.prototype.constructor = $c_scm_IndexedSeq$;
/** @constructor */
function $h_scm_IndexedSeq$() {
  /*<skip>*/
}
$h_scm_IndexedSeq$.prototype = $c_scm_IndexedSeq$.prototype;
var $d_scm_IndexedSeq$ = new $TypeData().initClass({
  scm_IndexedSeq$: 0
}, false, "scala.collection.mutable.IndexedSeq$", {
  scm_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_IndexedSeq$.prototype.$classData = $d_scm_IndexedSeq$;
var $n_scm_IndexedSeq$;
function $m_scm_IndexedSeq$() {
  if ((!$n_scm_IndexedSeq$)) {
    $n_scm_IndexedSeq$ = new $c_scm_IndexedSeq$()
  };
  return $n_scm_IndexedSeq$
}
/** @constructor */
function $c_scm_ListBuffer$() {
  /*<skip>*/
}
$c_scm_ListBuffer$.prototype = new $h_O();
$c_scm_ListBuffer$.prototype.constructor = $c_scm_ListBuffer$;
/** @constructor */
function $h_scm_ListBuffer$() {
  /*<skip>*/
}
$h_scm_ListBuffer$.prototype = $c_scm_ListBuffer$.prototype;
$c_scm_ListBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(elems)
});
$c_scm_ListBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer())
});
$c_scm_ListBuffer$.prototype.empty__O = (function() {
  return new $c_scm_ListBuffer()
});
$c_scm_ListBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(source)
});
var $d_scm_ListBuffer$ = new $TypeData().initClass({
  scm_ListBuffer$: 0
}, false, "scala.collection.mutable.ListBuffer$", {
  scm_ListBuffer$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ListBuffer$.prototype.$classData = $d_scm_ListBuffer$;
var $n_scm_ListBuffer$;
function $m_scm_ListBuffer$() {
  if ((!$n_scm_ListBuffer$)) {
    $n_scm_ListBuffer$ = new $c_scm_ListBuffer$()
  };
  return $n_scm_ListBuffer$
}
/** @constructor */
function $c_scm_MutationTracker$CheckedIterator(underlying, mutationCount) {
  this.scm_MutationTracker$CheckedIterator__f_underlying = null;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = null;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = 0;
  this.scm_MutationTracker$CheckedIterator__f_underlying = underlying;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = mutationCount;
  var this$1 = $n(mutationCount);
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = $uI(this$1.apply__O())
}
$c_scm_MutationTracker$CheckedIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_MutationTracker$CheckedIterator.prototype.constructor = $c_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $h_scm_MutationTracker$CheckedIterator() {
  /*<skip>*/
}
$h_scm_MutationTracker$CheckedIterator.prototype = $c_scm_MutationTracker$CheckedIterator.prototype;
$c_scm_MutationTracker$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_MutationTracker$CheckedIterator__f_expectedCount;
  var this$1 = $n(this.scm_MutationTracker$CheckedIterator__f_mutationCount);
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return $n(this.scm_MutationTracker$CheckedIterator__f_underlying).hasNext__Z()
});
$c_scm_MutationTracker$CheckedIterator.prototype.next__O = (function() {
  return $n(this.scm_MutationTracker$CheckedIterator__f_underlying).next__O()
});
var $d_scm_MutationTracker$CheckedIterator = new $TypeData().initClass({
  scm_MutationTracker$CheckedIterator: 0
}, false, "scala.collection.mutable.MutationTracker$CheckedIterator", {
  scm_MutationTracker$CheckedIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_MutationTracker$CheckedIterator.prototype.$classData = $d_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $c_scm_Queue$() {
  /*<skip>*/
}
$c_scm_Queue$.prototype = new $h_O();
$c_scm_Queue$.prototype.constructor = $c_scm_Queue$;
/** @constructor */
function $h_scm_Queue$() {
  /*<skip>*/
}
$h_scm_Queue$.prototype = $c_scm_Queue$.prototype;
$c_scm_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  var this$1 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
  return $as_scm_Queue(this$1.addAll__sc_IterableOnce__scm_ArrayDeque(elems))
});
$c_scm_Queue$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_Queue__I__(new $c_scm_Queue(), 16))
});
$c_scm_Queue$.prototype.empty__O = (function() {
  return $ct_scm_Queue__I__(new $c_scm_Queue(), 16)
});
$c_scm_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  var this$1 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
  return $as_scm_Queue(this$1.addAll__sc_IterableOnce__scm_ArrayDeque(source))
});
var $d_scm_Queue$ = new $TypeData().initClass({
  scm_Queue$: 0
}, false, "scala.collection.mutable.Queue$", {
  scm_Queue$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Queue$.prototype.$classData = $d_scm_Queue$;
var $n_scm_Queue$;
function $m_scm_Queue$() {
  if ((!$n_scm_Queue$)) {
    $n_scm_Queue$ = new $c_scm_Queue$()
  };
  return $n_scm_Queue$
}
function $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V($thiz) {
  var this$1 = $n($thiz.scm_RedBlackTree$TreeIterator__f_end);
  if ((((!this$1.isEmpty__Z()) && ($thiz.scm_RedBlackTree$TreeIterator__f_nextNode !== null)) && ($n($thiz.scm_RedBlackTree$TreeIterator__f_ord).compare__O__O__I($n($thiz.scm_RedBlackTree$TreeIterator__f_nextNode).scm_RedBlackTree$Node__f_key, $n($thiz.scm_RedBlackTree$TreeIterator__f_end).get__O()) >= 0))) {
    $thiz.scm_RedBlackTree$TreeIterator__f_nextNode = null
  }
}
function $ct_scm_RedBlackTree$TreeIterator__scm_RedBlackTree$Tree__s_Option__s_Option__s_math_Ordering__($thiz, tree, start, end, ord) {
  $thiz.scm_RedBlackTree$TreeIterator__f_end = end;
  $thiz.scm_RedBlackTree$TreeIterator__f_ord = ord;
  var x = $m_s_None$();
  if ((x === start)) {
    var $$x1 = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(tree).scm_RedBlackTree$Tree__f_root)
  } else {
    if ((!(start instanceof $c_s_Some))) {
      throw new $c_s_MatchError(start)
    };
    var x3 = $as_s_Some(start);
    var from = $n(x3).s_Some__f_value;
    var $$x1 = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$minNodeAfter__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node($n(tree).scm_RedBlackTree$Tree__f_root, from, ord)
  };
  $thiz.scm_RedBlackTree$TreeIterator__f_nextNode = $$x1;
  $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V($thiz);
  return $thiz
}
/** @constructor */
function $c_scm_RedBlackTree$TreeIterator() {
  this.scm_RedBlackTree$TreeIterator__f_end = null;
  this.scm_RedBlackTree$TreeIterator__f_ord = null;
  this.scm_RedBlackTree$TreeIterator__f_nextNode = null
}
$c_scm_RedBlackTree$TreeIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_RedBlackTree$TreeIterator.prototype.constructor = $c_scm_RedBlackTree$TreeIterator;
/** @constructor */
function $h_scm_RedBlackTree$TreeIterator() {
  /*<skip>*/
}
$h_scm_RedBlackTree$TreeIterator.prototype = $c_scm_RedBlackTree$TreeIterator.prototype;
$c_scm_RedBlackTree$TreeIterator.prototype.hasNext__Z = (function() {
  return (this.scm_RedBlackTree$TreeIterator__f_nextNode !== null)
});
$c_scm_RedBlackTree$TreeIterator.prototype.next__O = (function() {
  var x1 = this.scm_RedBlackTree$TreeIterator__f_nextNode;
  if ((x1 === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
  } else {
    this.scm_RedBlackTree$TreeIterator__f_nextNode = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node(x1);
    $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V(this);
    return $n(x1).scm_RedBlackTree$Node__f_key
  }
});
/** @constructor */
function $c_scm_TreeSet$$anon$1(ordering$1) {
  this.scm_TreeSet$$anon$1__f_tree = null;
  this.scm_TreeSet$$anon$1__f_ordering$1 = null;
  this.scm_TreeSet$$anon$1__f_ordering$1 = ordering$1;
  this.scm_TreeSet$$anon$1__f_tree = new $c_scm_RedBlackTree$Tree(null, 0)
}
$c_scm_TreeSet$$anon$1.prototype = new $h_O();
$c_scm_TreeSet$$anon$1.prototype.constructor = $c_scm_TreeSet$$anon$1;
/** @constructor */
function $h_scm_TreeSet$$anon$1() {
  /*<skip>*/
}
$h_scm_TreeSet$$anon$1.prototype = $c_scm_TreeSet$$anon$1.prototype;
$c_scm_TreeSet$$anon$1.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_TreeSet$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_TreeSet$$anon$1.prototype.addOne__O__scm_TreeSet$$anon$1 = (function(elem) {
  $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(this.scm_TreeSet$$anon$1__f_tree, elem, null, this.scm_TreeSet$$anon$1__f_ordering$1);
  return this
});
$c_scm_TreeSet$$anon$1.prototype.result__scm_TreeSet = (function() {
  return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), this.scm_TreeSet$$anon$1__f_tree, this.scm_TreeSet$$anon$1__f_ordering$1)
});
$c_scm_TreeSet$$anon$1.prototype.result__O = (function() {
  return this.result__scm_TreeSet()
});
$c_scm_TreeSet$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_TreeSet$$anon$1(elem)
});
var $d_scm_TreeSet$$anon$1 = new $TypeData().initClass({
  scm_TreeSet$$anon$1: 0
}, false, "scala.collection.mutable.TreeSet$$anon$1", {
  scm_TreeSet$$anon$1: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_TreeSet$$anon$1.prototype.$classData = $d_scm_TreeSet$$anon$1;
/** @constructor */
function $c_s_concurrent_ExecutionContext$parasitic$() {
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = null;
  $n_s_concurrent_ExecutionContext$parasitic$ = this;
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = $ct_jl_ThreadLocal__(new $c_jl_ThreadLocal())
}
$c_s_concurrent_ExecutionContext$parasitic$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$parasitic$.prototype.constructor = $c_s_concurrent_ExecutionContext$parasitic$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$parasitic$() {
  /*<skip>*/
}
$h_s_concurrent_ExecutionContext$parasitic$.prototype = $c_s_concurrent_ExecutionContext$parasitic$.prototype;
$c_s_concurrent_ExecutionContext$parasitic$.prototype.execute__jl_Runnable__V = (function(runnable) {
  $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V(this, runnable)
});
$c_s_concurrent_ExecutionContext$parasitic$.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(t)
});
var $d_s_concurrent_ExecutionContext$parasitic$ = new $TypeData().initClass({
  s_concurrent_ExecutionContext$parasitic$: 0
}, false, "scala.concurrent.ExecutionContext$parasitic$", {
  s_concurrent_ExecutionContext$parasitic$: 1,
  O: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_BatchingExecutor: 1
});
$c_s_concurrent_ExecutionContext$parasitic$.prototype.$classData = $d_s_concurrent_ExecutionContext$parasitic$;
var $n_s_concurrent_ExecutionContext$parasitic$;
function $m_s_concurrent_ExecutionContext$parasitic$() {
  if ((!$n_s_concurrent_ExecutionContext$parasitic$)) {
    $n_s_concurrent_ExecutionContext$parasitic$ = new $c_s_concurrent_ExecutionContext$parasitic$()
  };
  return $n_s_concurrent_ExecutionContext$parasitic$
}
/** @constructor */
function $c_s_concurrent_duration_Duration$Infinite() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$Infinite.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_Duration$Infinite.prototype.constructor = $c_s_concurrent_duration_Duration$Infinite;
/** @constructor */
function $h_s_concurrent_duration_Duration$Infinite() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$Infinite.prototype = $c_s_concurrent_duration_Duration$Infinite.prototype;
$c_s_concurrent_duration_Duration$Infinite.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined)) {
    return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined
  };
  if ((other instanceof $c_s_concurrent_duration_Duration$Infinite)) {
    var x2 = $as_s_concurrent_duration_Duration$Infinite(other);
    if ((x2 !== this)) {
      return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined
    }
  };
  return this
});
function $as_s_concurrent_duration_Duration$Infinite(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration$Infinite) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration$Infinite"))
}
function $isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration$Infinite)))
}
function $asArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration$Infinite;", depth))
}
function $p_s_concurrent_duration_FiniteDuration__bounded__J__Z($thiz, max) {
  var lo = max.RTLong__f_lo;
  var hi = max.RTLong__f_hi;
  var lo$1 = ((-lo) | 0);
  var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
  var b = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  var bhi = b.RTLong__f_hi;
  if (((hi$1 === bhi) ? (((-2147483648) ^ lo$1) <= ((-2147483648) ^ b.RTLong__f_lo)) : (hi$1 < bhi))) {
    var this$3 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
    var ahi = this$3.RTLong__f_hi;
    var bhi$1 = max.RTLong__f_hi;
    return ((ahi === bhi$1) ? (((-2147483648) ^ this$3.RTLong__f_lo) <= ((-2147483648) ^ max.RTLong__f_lo)) : (ahi < bhi$1))
  } else {
    return false
  }
}
function $p_s_concurrent_duration_FiniteDuration__unitString__T($thiz) {
  var $$x1 = $as_T($n($m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_timeUnitName).apply__O__O($thiz.s_concurrent_duration_FiniteDuration__f_unit));
  var this$1 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  return ($$x1 + (((this$1.RTLong__f_lo === 1) && (this$1.RTLong__f_hi === 0)) ? "" : "s"))
}
function $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, a, b) {
  var ahi = b.RTLong__f_hi;
  if (((ahi === 0) ? (b.RTLong__f_lo !== 0) : (ahi > 0))) {
    var bhi = b.RTLong__f_hi;
    var lo = (((-1) - b.RTLong__f_lo) | 0);
    var hi = ((2147483647 - bhi) | 0);
    var ahi$1 = a.RTLong__f_hi;
    var $$x2 = ((ahi$1 === hi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ lo)) : (ahi$1 > hi))
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var $$x1 = true
  } else {
    var ahi$2 = b.RTLong__f_hi;
    if ((ahi$2 < 0)) {
      var bhi$1 = b.RTLong__f_hi;
      var lo$1 = ((-b.RTLong__f_lo) | 0);
      var hi$1 = ((lo$1 !== 0) ? ((2147483647 - bhi$1) | 0) : (((-2147483648) - bhi$1) | 0));
      var ahi$3 = a.RTLong__f_hi;
      var $$x1 = ((ahi$3 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$3 < hi$1))
    } else {
      var $$x1 = false
    }
  };
  if ($$x1) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "integer overflow")
  };
  var alo = a.RTLong__f_lo;
  var ahi$4 = a.RTLong__f_hi;
  var bhi$2 = b.RTLong__f_hi;
  var lo$2 = ((alo + b.RTLong__f_lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ alo)) ? ((1 + ((ahi$4 + bhi$2) | 0)) | 0) : ((ahi$4 + bhi$2) | 0));
  return new $c_RTLong(lo$2, hi$2)
}
function $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration($thiz, otherLength, otherUnit) {
  var this$1 = $n(otherUnit).convert__J__ju_concurrent_TimeUnit__J(new $c_RTLong(1, 0), $thiz.s_concurrent_duration_FiniteDuration__f_unit);
  if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
    var commonUnit = $thiz.s_concurrent_duration_FiniteDuration__f_unit
  } else {
    var commonUnit = otherUnit
  };
  var t = $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, $n(commonUnit).convert__J__ju_concurrent_TimeUnit__J($thiz.s_concurrent_duration_FiniteDuration__f_length, $thiz.s_concurrent_duration_FiniteDuration__f_unit), $n(commonUnit).convert__J__ju_concurrent_TimeUnit__J(otherLength, otherUnit));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi), commonUnit)
}
/** @constructor */
function $c_s_concurrent_duration_FiniteDuration(length, unit) {
  this.s_concurrent_duration_FiniteDuration__f_length = $L0;
  this.s_concurrent_duration_FiniteDuration__f_unit = null;
  this.s_concurrent_duration_FiniteDuration__f_length = length;
  this.s_concurrent_duration_FiniteDuration__f_unit = unit;
  var x = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  if ((x === null)) {
    var $$x1 = (unit === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = (this$1 === unit)
  };
  if ($$x1) {
    var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1), 2147483647))
  } else {
    var x$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$3 === null)) {
      var $$x2 = (unit === null)
    } else {
      var this$2 = $n(x$3);
      var $$x2 = (this$2 === unit)
    };
    if ($$x2) {
      var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1511828489), 2147483))
    } else {
      var x$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$5 === null)) {
        var $$x3 = (unit === null)
      } else {
        var this$3 = $n(x$5);
        var $$x3 = (this$3 === unit)
      };
      if ($$x3) {
        var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2077252342, 2147))
      } else {
        var x$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
        if ((x$7 === null)) {
          var $$x4 = (unit === null)
        } else {
          var this$4 = $n(x$7);
          var $$x4 = (this$4 === unit)
        };
        if ($$x4) {
          var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(633437444, 2))
        } else {
          var x$9 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
          if ((x$9 === null)) {
            var $$x5 = (unit === null)
          } else {
            var this$5 = $n(x$9);
            var $$x5 = (this$5 === unit)
          };
          if ($$x5) {
            var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(153722867, 0))
          } else {
            var x$11 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
            if ((x$11 === null)) {
              var $$x6 = (unit === null)
            } else {
              var this$6 = $n(x$11);
              var $$x6 = (this$6 === unit)
            };
            if ($$x6) {
              var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2562047, 0))
            } else {
              var x$13 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
              if ((x$13 === null)) {
                var $$x7 = (unit === null)
              } else {
                var this$7 = $n(x$13);
                var $$x7 = (this$7 === unit)
              };
              if ($$x7) {
                var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(106751, 0))
              } else {
                var t = $n($m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS).convert__J__ju_concurrent_TimeUnit__J(length, unit);
                var lo = t.RTLong__f_lo;
                var hi = t.RTLong__f_hi;
                var requirement = (((hi === (-1)) ? (((-2147483648) ^ lo) >= 2147376897) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-2147376897)) : (hi < 0)))
              }
            }
          }
        }
      }
    }
  };
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Duration is limited to +-(2^63-1)ns (ca. 292 years)")
  }
}
$c_s_concurrent_duration_FiniteDuration.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_FiniteDuration.prototype.constructor = $c_s_concurrent_duration_FiniteDuration;
/** @constructor */
function $h_s_concurrent_duration_FiniteDuration() {
  /*<skip>*/
}
$h_s_concurrent_duration_FiniteDuration.prototype = $c_s_concurrent_duration_FiniteDuration.prototype;
$c_s_concurrent_duration_FiniteDuration.prototype.toString__T = (function() {
  return ((this.s_concurrent_duration_FiniteDuration__f_length + " ") + $p_s_concurrent_duration_FiniteDuration__unitString__T(this))
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var t = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$3 = new $c_sr_RichLong(new $c_RTLong(lo, hi));
    var this$2 = $n(x2);
    var t$1 = $n(this$2.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this$2.s_concurrent_duration_FiniteDuration__f_length);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var t$3 = this$3.sr_RichLong__f_self;
    var lo$3 = t$3.RTLong__f_lo;
    var hi$3 = t$3.RTLong__f_hi;
    var t$4 = $uJ(new $c_RTLong(lo$3, hi$3));
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var t$5 = $uJ(new $c_RTLong(lo$1, hi$1));
    var lo$5 = t$5.RTLong__f_lo;
    var hi$5 = t$5.RTLong__f_hi;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$4, hi$4, lo$5, hi$5)
  } else {
    var this$6 = $n(other);
    return ((-this$6.compare__s_concurrent_duration_Duration__I(this)) | 0)
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, $n(x2).s_concurrent_duration_FiniteDuration__f_length, $n(x2).s_concurrent_duration_FiniteDuration__f_unit)
  } else {
    return other
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var this$2 = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var this$1 = $n(x2);
    var b = $n(this$1.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length);
    return ((this$2.RTLong__f_lo === b.RTLong__f_lo) && (this$2.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return (this === other)
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.hashCode__I = (function() {
  var this$1 = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
  return this$1.RTLong__f_lo
});
function $as_s_concurrent_duration_FiniteDuration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_FiniteDuration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.FiniteDuration"))
}
function $isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_FiniteDuration)))
}
function $asArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.FiniteDuration;", depth))
}
var $d_s_concurrent_duration_FiniteDuration = new $TypeData().initClass({
  s_concurrent_duration_FiniteDuration: 0
}, false, "scala.concurrent.duration.FiniteDuration", {
  s_concurrent_duration_FiniteDuration: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_FiniteDuration.prototype.$classData = $d_s_concurrent_duration_FiniteDuration;
function $f_s_math_Ordering__tryCompare__O__O__s_Some($thiz, x, y) {
  return new $c_s_Some($thiz.compare__O__O__I(x, y))
}
function $f_s_math_Ordering__lteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) <= 0)
}
function $f_s_math_Ordering__gteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) >= 0)
}
function $f_s_math_Ordering__lt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) < 0)
}
function $f_s_math_Ordering__gt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) > 0)
}
function $f_s_math_Ordering__equiv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0)
}
function $f_s_math_Ordering__max__O__O__O($thiz, x, y) {
  return ($thiz.gteq__O__O__Z(x, y) ? x : y)
}
function $f_s_math_Ordering__min__O__O__O($thiz, x, y) {
  return ($thiz.lteq__O__O__Z(x, y) ? x : y)
}
function $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z($thiz, other) {
  if ((other instanceof $c_s_math_Ordering$Reverse)) {
    var x2 = $as_s_math_Ordering$Reverse(other);
    var x = $n(x2).s_math_Ordering$Reverse__f_outer;
    return ((x !== null) && $n(x).equals__O__Z($thiz))
  } else {
    return false
  }
}
function $is_s_math_Ordering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Ordering)))
}
function $as_s_math_Ordering(obj) {
  return (($is_s_math_Ordering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering"))
}
function $isArrayOf_s_math_Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering)))
}
function $asArrayOf_s_math_Ordering(obj, depth) {
  return (($isArrayOf_s_math_Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering;", depth))
}
function $f_s_reflect_ClassTag__unapply__O__s_Option($thiz, x) {
  return ($n($thiz.runtimeClass__jl_Class()).isInstance__O__Z(x) ? new $c_s_Some(x) : $m_s_None$())
}
function $f_s_reflect_ClassTag__equals__O__Z($thiz, x) {
  if ($is_s_reflect_ClassTag(x)) {
    var x$2 = $thiz.runtimeClass__jl_Class();
    var x$3 = $n($as_s_reflect_ClassTag(x)).runtimeClass__jl_Class();
    if ((x$2 === null)) {
      return (x$3 === null)
    } else {
      var this$1 = $n(x$2);
      return (this$1 === x$3)
    }
  } else {
    return false
  }
}
function $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz) {
  return ($n(clazz).isArray__Z() ? (("Array[" + $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, $n(clazz).getComponentType__jl_Class())) + "]") : $n(clazz).getName__T())
}
function $is_s_reflect_ClassTag(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_reflect_ClassTag)))
}
function $as_s_reflect_ClassTag(obj) {
  return (($is_s_reflect_ClassTag(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.reflect.ClassTag"))
}
function $isArrayOf_s_reflect_ClassTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_reflect_ClassTag)))
}
function $asArrayOf_s_reflect_ClassTag(obj, depth) {
  return (($isArrayOf_s_reflect_ClassTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.reflect.ClassTag;", depth))
}
class $c_sr_NonLocalReturnControl$mcI$sp extends $c_sr_NonLocalReturnControl {
  constructor(key, value$mcI$sp) {
    super();
    this.sr_NonLocalReturnControl$mcI$sp__f_value$mcI$sp = 0;
    this.sr_NonLocalReturnControl$mcI$sp__f_value$mcI$sp = value$mcI$sp;
    $ct_sr_NonLocalReturnControl__O__O__(this, key, null)
  };
  value$mcI$sp__I() {
    return this.sr_NonLocalReturnControl$mcI$sp__f_value$mcI$sp
  };
  value__O() {
    return this.sr_NonLocalReturnControl$mcI$sp__f_value$mcI$sp
  };
}
var $d_sr_NonLocalReturnControl$mcI$sp = new $TypeData().initClass({
  sr_NonLocalReturnControl$mcI$sp: 0
}, false, "scala.runtime.NonLocalReturnControl$mcI$sp", {
  sr_NonLocalReturnControl$mcI$sp: 1,
  sr_NonLocalReturnControl: 1,
  s_util_control_ControlThrowable: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_NonLocalReturnControl$mcI$sp.prototype.$classData = $d_sr_NonLocalReturnControl$mcI$sp;
class $c_sr_NonLocalReturnControl$mcZ$sp extends $c_sr_NonLocalReturnControl {
  constructor(key, value$mcZ$sp) {
    super();
    this.sr_NonLocalReturnControl$mcZ$sp__f_value$mcZ$sp = false;
    this.sr_NonLocalReturnControl$mcZ$sp__f_value$mcZ$sp = value$mcZ$sp;
    $ct_sr_NonLocalReturnControl__O__O__(this, key, null)
  };
  value$mcZ$sp__Z() {
    return this.sr_NonLocalReturnControl$mcZ$sp__f_value$mcZ$sp
  };
  value__O() {
    return this.sr_NonLocalReturnControl$mcZ$sp__f_value$mcZ$sp
  };
}
var $d_sr_NonLocalReturnControl$mcZ$sp = new $TypeData().initClass({
  sr_NonLocalReturnControl$mcZ$sp: 0
}, false, "scala.runtime.NonLocalReturnControl$mcZ$sp", {
  sr_NonLocalReturnControl$mcZ$sp: 1,
  sr_NonLocalReturnControl: 1,
  s_util_control_ControlThrowable: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_NonLocalReturnControl$mcZ$sp.prototype.$classData = $d_sr_NonLocalReturnControl$mcZ$sp;
/** @constructor */
function $c_sr_ScalaRunTime$$anon$1(x$2) {
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = 0;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = null;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = x$2;
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = $n(x$2).productArity__I()
}
$c_sr_ScalaRunTime$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sr_ScalaRunTime$$anon$1.prototype.constructor = $c_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $h_sr_ScalaRunTime$$anon$1() {
  /*<skip>*/
}
$h_sr_ScalaRunTime$$anon$1.prototype = $c_sr_ScalaRunTime$$anon$1.prototype;
$c_sr_ScalaRunTime$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sr_ScalaRunTime$$anon$1__f_c < this.sr_ScalaRunTime$$anon$1__f_cmax)
});
$c_sr_ScalaRunTime$$anon$1.prototype.next__O = (function() {
  var result = $n(this.sr_ScalaRunTime$$anon$1__f_x$2).productElement__I__O(this.sr_ScalaRunTime$$anon$1__f_c);
  this.sr_ScalaRunTime$$anon$1__f_c = ((1 + this.sr_ScalaRunTime$$anon$1__f_c) | 0);
  return result
});
var $d_sr_ScalaRunTime$$anon$1 = new $TypeData().initClass({
  sr_ScalaRunTime$$anon$1: 0
}, false, "scala.runtime.ScalaRunTime$$anon$1", {
  sr_ScalaRunTime$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sr_ScalaRunTime$$anon$1.prototype.$classData = $d_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $c_sjs_js_ArrayOps$ArrayIterator(xs) {
  this.sjs_js_ArrayOps$ArrayIterator__f_xs = null;
  this.sjs_js_ArrayOps$ArrayIterator__f_pos = 0;
  this.sjs_js_ArrayOps$ArrayIterator__f_xs = xs;
  this.sjs_js_ArrayOps$ArrayIterator__f_pos = 0
}
$c_sjs_js_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$c_sjs_js_ArrayOps$ArrayIterator.prototype.constructor = $c_sjs_js_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sjs_js_ArrayOps$ArrayIterator() {
  /*<skip>*/
}
$h_sjs_js_ArrayOps$ArrayIterator.prototype = $c_sjs_js_ArrayOps$ArrayIterator.prototype;
$c_sjs_js_ArrayOps$ArrayIterator.prototype.hasNext__Z = (function() {
  return (this.sjs_js_ArrayOps$ArrayIterator__f_pos < $uI(this.sjs_js_ArrayOps$ArrayIterator__f_xs.length))
});
$c_sjs_js_ArrayOps$ArrayIterator.prototype.next__O = (function() {
  if ((this.sjs_js_ArrayOps$ArrayIterator__f_pos >= $uI(this.sjs_js_ArrayOps$ArrayIterator__f_xs.length))) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  var r = this.sjs_js_ArrayOps$ArrayIterator__f_xs[this.sjs_js_ArrayOps$ArrayIterator__f_pos];
  this.sjs_js_ArrayOps$ArrayIterator__f_pos = ((1 + this.sjs_js_ArrayOps$ArrayIterator__f_pos) | 0);
  return r
});
$c_sjs_js_ArrayOps$ArrayIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sjs_js_ArrayOps$ArrayIterator__f_pos = $uI(Math.min($uI(this.sjs_js_ArrayOps$ArrayIterator__f_xs.length), ((this.sjs_js_ArrayOps$ArrayIterator__f_pos + n) | 0)))
  };
  return this
});
var $d_sjs_js_ArrayOps$ArrayIterator = new $TypeData().initClass({
  sjs_js_ArrayOps$ArrayIterator: 0
}, false, "scala.scalajs.js.ArrayOps$ArrayIterator", {
  sjs_js_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sjs_js_ArrayOps$ArrayIterator.prototype.$classData = $d_sjs_js_ArrayOps$ArrayIterator;
/** @constructor */
function $c_sjs_js_WrappedArray$() {
  /*<skip>*/
}
$c_sjs_js_WrappedArray$.prototype = new $h_O();
$c_sjs_js_WrappedArray$.prototype.constructor = $c_sjs_js_WrappedArray$;
/** @constructor */
function $h_sjs_js_WrappedArray$() {
  /*<skip>*/
}
$h_sjs_js_WrappedArray$.prototype = $c_sjs_js_WrappedArray$.prototype;
$c_sjs_js_WrappedArray$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(elems)
});
$c_sjs_js_WrappedArray$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray())
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__sjs_js_WrappedArray = (function(source) {
  var this$1 = $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
  return $as_sjs_js_WrappedArray($n($as_scm_Builder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this$1, source))).result__O())
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(source)
});
$c_sjs_js_WrappedArray$.prototype.empty__O = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray())
});
var $d_sjs_js_WrappedArray$ = new $TypeData().initClass({
  sjs_js_WrappedArray$: 0
}, false, "scala.scalajs.js.WrappedArray$", {
  sjs_js_WrappedArray$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sjs_js_WrappedArray$.prototype.$classData = $d_sjs_js_WrappedArray$;
var $n_sjs_js_WrappedArray$;
function $m_sjs_js_WrappedArray$() {
  if ((!$n_sjs_js_WrappedArray$)) {
    $n_sjs_js_WrappedArray$ = new $c_sjs_js_WrappedArray$()
  };
  return $n_sjs_js_WrappedArray$
}
/** @constructor */
function $c_sjsr_WrappedVarArgs$() {
  /*<skip>*/
}
$c_sjsr_WrappedVarArgs$.prototype = new $h_O();
$c_sjsr_WrappedVarArgs$.prototype.constructor = $c_sjsr_WrappedVarArgs$;
/** @constructor */
function $h_sjsr_WrappedVarArgs$() {
  /*<skip>*/
}
$h_sjsr_WrappedVarArgs$.prototype = $c_sjsr_WrappedVarArgs$.prototype;
$c_sjsr_WrappedVarArgs$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(elems)
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__sjsr_WrappedVarArgs = (function(source) {
  var this$1 = $n(this.newBuilder__scm_Builder());
  return $as_sjsr_WrappedVarArgs($n($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(source))).result__O())
});
$c_sjsr_WrappedVarArgs$.prototype.newBuilder__scm_Builder = (function() {
  var array = [];
  var this$4 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_sjs_js_WrappedArray(x$1$2);
    return $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), $n(x$1).sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array)
  }));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(source)
});
$c_sjsr_WrappedVarArgs$.prototype.empty__O = (function() {
  return $ct_sjsr_WrappedVarArgs__(new $c_sjsr_WrappedVarArgs())
});
var $d_sjsr_WrappedVarArgs$ = new $TypeData().initClass({
  sjsr_WrappedVarArgs$: 0
}, false, "scala.scalajs.runtime.WrappedVarArgs$", {
  sjsr_WrappedVarArgs$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sjsr_WrappedVarArgs$.prototype.$classData = $d_sjsr_WrappedVarArgs$;
var $n_sjsr_WrappedVarArgs$;
function $m_sjsr_WrappedVarArgs$() {
  if ((!$n_sjsr_WrappedVarArgs$)) {
    $n_sjsr_WrappedVarArgs$ = new $c_sjsr_WrappedVarArgs$()
  };
  return $n_sjsr_WrappedVarArgs$
}
/** @constructor */
function $c_s_util_Failure(exception) {
  this.s_util_Failure__f_exception = null;
  this.s_util_Failure__f_exception = exception
}
$c_s_util_Failure.prototype = new $h_s_util_Try();
$c_s_util_Failure.prototype.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
  /*<skip>*/
}
$h_s_util_Failure.prototype = $c_s_util_Failure.prototype;
$c_s_util_Failure.prototype.isFailure__Z = (function() {
  return true
});
$c_s_util_Failure.prototype.get__O = (function() {
  var $$x1 = this.s_util_Failure__f_exception;
  throw (($$x1 instanceof $c_sjs_js_JavaScriptException) ? $$x1.sjs_js_JavaScriptException__f_exception : $n($$x1))
});
$c_s_util_Failure.prototype.getOrElse__F0__O = (function(default$1) {
  return $n(default$1).apply__O()
});
$c_s_util_Failure.prototype.orElse__F0__s_util_Try = (function(default$1) {
  try {
    return $as_s_util_Try($n(default$1).apply__O())
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(o11).isEmpty__Z())) {
      var e$3 = $as_jl_Throwable($n(o11).get__O());
      return new $c_s_util_Failure(e$3)
    };
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
  }
});
$c_s_util_Failure.prototype.foreach__F1__V = (function(f) {
  /*<skip>*/
});
$c_s_util_Failure.prototype.map__F1__s_util_Try = (function(f) {
  return this
});
$c_s_util_Failure.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = $n(pf).applyOrElse__O__F1__O(this.s_util_Failure__f_exception, new $c_sjsr_AnonFunction1(((x$2) => {
      $as_jl_Throwable(x$2);
      return marker
    })));
    return ((marker !== v) ? new $c_s_util_Success(v) : this)
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(o11).isEmpty__Z())) {
      var e$3 = $as_jl_Throwable($n(o11).get__O());
      return new $c_s_util_Failure(e$3)
    };
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
  }
});
$c_s_util_Failure.prototype.toOption__s_Option = (function() {
  return $m_s_None$()
});
$c_s_util_Failure.prototype.fold__F1__F1__O = (function(fa, fb) {
  return $n(fa).apply__O__O(this.s_util_Failure__f_exception)
});
$c_s_util_Failure.prototype.productPrefix__T = (function() {
  return "Failure"
});
$c_s_util_Failure.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Failure.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Failure__f_exception : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Failure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Failure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Failure)) {
    var Failure$1 = $as_s_util_Failure(x$1);
    var x = this.s_util_Failure__f_exception;
    var x$2 = $n(Failure$1).s_util_Failure__f_exception;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_s_util_Failure(obj) {
  return (((obj instanceof $c_s_util_Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Failure"))
}
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Failure)))
}
function $asArrayOf_s_util_Failure(obj, depth) {
  return (($isArrayOf_s_util_Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Failure;", depth))
}
var $d_s_util_Failure = new $TypeData().initClass({
  s_util_Failure: 0
}, false, "scala.util.Failure", {
  s_util_Failure: 1,
  s_util_Try: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Failure.prototype.$classData = $d_s_util_Failure;
/** @constructor */
function $c_s_util_Left(value) {
  this.s_util_Left__f_value = null;
  this.s_util_Left__f_value = value
}
$c_s_util_Left.prototype = new $h_s_util_Either();
$c_s_util_Left.prototype.constructor = $c_s_util_Left;
/** @constructor */
function $h_s_util_Left() {
  /*<skip>*/
}
$h_s_util_Left.prototype = $c_s_util_Left.prototype;
$c_s_util_Left.prototype.productPrefix__T = (function() {
  return "Left"
});
$c_s_util_Left.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Left.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Left__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Left.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Left.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Left.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Left.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Left)) {
    var Left$1 = $as_s_util_Left(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Left__f_value, $n(Left$1).s_util_Left__f_value)
  } else {
    return false
  }
});
function $as_s_util_Left(obj) {
  return (((obj instanceof $c_s_util_Left) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Left"))
}
function $isArrayOf_s_util_Left(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Left)))
}
function $asArrayOf_s_util_Left(obj, depth) {
  return (($isArrayOf_s_util_Left(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Left;", depth))
}
var $d_s_util_Left = new $TypeData().initClass({
  s_util_Left: 0
}, false, "scala.util.Left", {
  s_util_Left: 1,
  s_util_Either: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Left.prototype.$classData = $d_s_util_Left;
/** @constructor */
function $c_s_util_Right(value) {
  this.s_util_Right__f_value = null;
  this.s_util_Right__f_value = value
}
$c_s_util_Right.prototype = new $h_s_util_Either();
$c_s_util_Right.prototype.constructor = $c_s_util_Right;
/** @constructor */
function $h_s_util_Right() {
  /*<skip>*/
}
$h_s_util_Right.prototype = $c_s_util_Right.prototype;
$c_s_util_Right.prototype.productPrefix__T = (function() {
  return "Right"
});
$c_s_util_Right.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Right.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Right__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Right.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Right.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Right.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Right.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Right)) {
    var Right$1 = $as_s_util_Right(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Right__f_value, $n(Right$1).s_util_Right__f_value)
  } else {
    return false
  }
});
function $as_s_util_Right(obj) {
  return (((obj instanceof $c_s_util_Right) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Right"))
}
function $isArrayOf_s_util_Right(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Right)))
}
function $asArrayOf_s_util_Right(obj, depth) {
  return (($isArrayOf_s_util_Right(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Right;", depth))
}
var $d_s_util_Right = new $TypeData().initClass({
  s_util_Right: 0
}, false, "scala.util.Right", {
  s_util_Right: 1,
  s_util_Either: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Right.prototype.$classData = $d_s_util_Right;
/** @constructor */
function $c_s_util_Success(value) {
  this.s_util_Success__f_value = null;
  this.s_util_Success__f_value = value
}
$c_s_util_Success.prototype = new $h_s_util_Try();
$c_s_util_Success.prototype.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
  /*<skip>*/
}
$h_s_util_Success.prototype = $c_s_util_Success.prototype;
$c_s_util_Success.prototype.isFailure__Z = (function() {
  return false
});
$c_s_util_Success.prototype.get__O = (function() {
  return this.s_util_Success__f_value
});
$c_s_util_Success.prototype.getOrElse__F0__O = (function(default$1) {
  return this.s_util_Success__f_value
});
$c_s_util_Success.prototype.orElse__F0__s_util_Try = (function(default$1) {
  return this
});
$c_s_util_Success.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.s_util_Success__f_value)
});
$c_s_util_Success.prototype.map__F1__s_util_Try = (function(f) {
  try {
    return new $c_s_util_Success($n(f).apply__O__O(this.s_util_Success__f_value))
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(o11).isEmpty__Z())) {
      var e$3 = $as_jl_Throwable($n(o11).get__O());
      return new $c_s_util_Failure(e$3)
    };
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
  }
});
$c_s_util_Success.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  return this
});
$c_s_util_Success.prototype.toOption__s_Option = (function() {
  return new $c_s_Some(this.s_util_Success__f_value)
});
$c_s_util_Success.prototype.fold__F1__F1__O = (function(fa, fb) {
  try {
    return $n(fb).apply__O__O(this.s_util_Success__f_value)
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(o11).isEmpty__Z())) {
      var e$3 = $as_jl_Throwable($n(o11).get__O());
      return $n(fa).apply__O__O(e$3)
    };
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
  }
});
$c_s_util_Success.prototype.productPrefix__T = (function() {
  return "Success"
});
$c_s_util_Success.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Success.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Success__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Success.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Success.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Success)) {
    var Success$1 = $as_s_util_Success(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Success__f_value, $n(Success$1).s_util_Success__f_value)
  } else {
    return false
  }
});
function $as_s_util_Success(obj) {
  return (((obj instanceof $c_s_util_Success) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Success"))
}
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Success)))
}
function $asArrayOf_s_util_Success(obj, depth) {
  return (($isArrayOf_s_util_Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Success;", depth))
}
var $d_s_util_Success = new $TypeData().initClass({
  s_util_Success: 0
}, false, "scala.util.Success", {
  s_util_Success: 1,
  s_util_Try: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Success.prototype.$classData = $d_s_util_Success;
/** @constructor */
function $c_Lscalacss_internal_AttrCmp$Unrelated$() {
  /*<skip>*/
}
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype = new $h_Lscalacss_internal_AttrCmp();
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.constructor = $c_Lscalacss_internal_AttrCmp$Unrelated$;
/** @constructor */
function $h_Lscalacss_internal_AttrCmp$Unrelated$() {
  /*<skip>*/
}
$h_Lscalacss_internal_AttrCmp$Unrelated$.prototype = $c_Lscalacss_internal_AttrCmp$Unrelated$.prototype;
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.$greater$greater__F0__Lscalacss_internal_AttrCmp = (function(next) {
  return $as_Lscalacss_internal_AttrCmp($n(next).apply__O())
});
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.conflict__Z = (function() {
  return false
});
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.productPrefix__T = (function() {
  return "Unrelated"
});
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.hashCode__I = (function() {
  return 511295314
});
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.toString__T = (function() {
  return "Unrelated"
});
var $d_Lscalacss_internal_AttrCmp$Unrelated$ = new $TypeData().initClass({
  Lscalacss_internal_AttrCmp$Unrelated$: 0
}, false, "scalacss.internal.AttrCmp$Unrelated$", {
  Lscalacss_internal_AttrCmp$Unrelated$: 1,
  Lscalacss_internal_AttrCmp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_AttrCmp$Unrelated$.prototype.$classData = $d_Lscalacss_internal_AttrCmp$Unrelated$;
var $n_Lscalacss_internal_AttrCmp$Unrelated$;
function $m_Lscalacss_internal_AttrCmp$Unrelated$() {
  if ((!$n_Lscalacss_internal_AttrCmp$Unrelated$)) {
    $n_Lscalacss_internal_AttrCmp$Unrelated$ = new $c_Lscalacss_internal_AttrCmp$Unrelated$()
  };
  return $n_Lscalacss_internal_AttrCmp$Unrelated$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderColor$() {
  this.Lscalacss_internal_ValueT$TypedAttrT4Edges__f_sep = null;
  this.Lscalacss_internal_Attrs$borderColor$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttrT4Edges__T__(this, " ");
  $n_Lscalacss_internal_Attrs$borderColor$ = this;
  this.Lscalacss_internal_Attrs$borderColor$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("border-color")).apply__O__O(new $c_sjsr_AnonFunction1(((x$22$2) => {
    var x$22 = $as_Lscalacss_internal_Attr$AliasB$(x$22$2);
    $n(x$22);
    var t = $m_Lscalacss_internal_Attrs$borderTopColor$();
    var h = t.Lscalacss_internal_Attrs$borderTopColor$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$borderRightColor$();
    var $$x2 = t$1.Lscalacss_internal_Attrs$borderRightColor$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$borderBottomColor$();
    var $$x1 = t$2.Lscalacss_internal_Attrs$borderBottomColor$__f_attr;
    var t$3 = $m_Lscalacss_internal_Attrs$borderLeftColor$();
    var array = [$$x2, $$x1, t$3.Lscalacss_internal_Attrs$borderLeftColor$__f_attr];
    var t$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$5 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$4);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$5)
  }))))
}
$c_Lscalacss_internal_Attrs$borderColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT4Edges();
$c_Lscalacss_internal_Attrs$borderColor$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderColor$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderColor$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderColor$.prototype = $c_Lscalacss_internal_Attrs$borderColor$.prototype;
$c_Lscalacss_internal_Attrs$borderColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderColor$__f_attr
});
$c_Lscalacss_internal_Attrs$borderColor$.prototype.mkColor__T__O = (function(s) {
  return new $c_Lscalacss_internal_AV(this.Lscalacss_internal_Attrs$borderColor$__f_attr, s)
});
var $d_Lscalacss_internal_Attrs$borderColor$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderColor$: 0
}, false, "scalacss.internal.Attrs$borderColor$", {
  Lscalacss_internal_Attrs$borderColor$: 1,
  Lscalacss_internal_ValueT$TypedAttrT4Edges: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$borderColor$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderColor$;
var $n_Lscalacss_internal_Attrs$borderColor$;
function $m_Lscalacss_internal_Attrs$borderColor$() {
  if ((!$n_Lscalacss_internal_Attrs$borderColor$)) {
    $n_Lscalacss_internal_Attrs$borderColor$ = new $c_Lscalacss_internal_Attrs$borderColor$()
  };
  return $n_Lscalacss_internal_Attrs$borderColor$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderWidth$() {
  this.Lscalacss_internal_ValueT$TypedAttrT4Edges__f_sep = null;
  this.Lscalacss_internal_Attrs$borderWidth$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttrT4Edges__T__(this, " ");
  $n_Lscalacss_internal_Attrs$borderWidth$ = this;
  this.Lscalacss_internal_Attrs$borderWidth$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("border-width")).apply__O__O(new $c_sjsr_AnonFunction1(((x$37$2) => {
    var x$37 = $as_Lscalacss_internal_Attr$AliasB$(x$37$2);
    $n(x$37);
    var t = $m_Lscalacss_internal_Attrs$borderTopWidth$();
    var h = t.Lscalacss_internal_Attrs$borderTopWidth$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$borderRightWidth$();
    var $$x2 = t$1.Lscalacss_internal_Attrs$borderRightWidth$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$borderBottomWidth$();
    var $$x1 = t$2.Lscalacss_internal_Attrs$borderBottomWidth$__f_attr;
    var t$3 = $m_Lscalacss_internal_Attrs$borderLeftWidth$();
    var array = [$$x2, $$x1, t$3.Lscalacss_internal_Attrs$borderLeftWidth$__f_attr];
    var t$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$5 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$4);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$5)
  }))))
}
$c_Lscalacss_internal_Attrs$borderWidth$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT4Edges();
$c_Lscalacss_internal_Attrs$borderWidth$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderWidth$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderWidth$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderWidth$.prototype = $c_Lscalacss_internal_Attrs$borderWidth$.prototype;
$c_Lscalacss_internal_Attrs$borderWidth$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderWidth$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderWidth$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderWidth$: 0
}, false, "scalacss.internal.Attrs$borderWidth$", {
  Lscalacss_internal_Attrs$borderWidth$: 1,
  Lscalacss_internal_ValueT$TypedAttrT4Edges: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderWidth$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderWidth$;
var $n_Lscalacss_internal_Attrs$borderWidth$;
function $m_Lscalacss_internal_Attrs$borderWidth$() {
  if ((!$n_Lscalacss_internal_Attrs$borderWidth$)) {
    $n_Lscalacss_internal_Attrs$borderWidth$ = new $c_Lscalacss_internal_Attrs$borderWidth$()
  };
  return $n_Lscalacss_internal_Attrs$borderWidth$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$bottom$() {
  this.Lscalacss_internal_Attrs$bottom$__f_attr = null;
  $n_Lscalacss_internal_Attrs$bottom$ = this;
  this.Lscalacss_internal_Attrs$bottom$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("bottom")
}
$c_Lscalacss_internal_Attrs$bottom$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto();
$c_Lscalacss_internal_Attrs$bottom$.prototype.constructor = $c_Lscalacss_internal_Attrs$bottom$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$bottom$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$bottom$.prototype = $c_Lscalacss_internal_Attrs$bottom$.prototype;
$c_Lscalacss_internal_Attrs$bottom$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$bottom$__f_attr
});
var $d_Lscalacss_internal_Attrs$bottom$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$bottom$: 0
}, false, "scalacss.internal.Attrs$bottom$", {
  Lscalacss_internal_Attrs$bottom$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$bottom$.prototype.$classData = $d_Lscalacss_internal_Attrs$bottom$;
var $n_Lscalacss_internal_Attrs$bottom$;
function $m_Lscalacss_internal_Attrs$bottom$() {
  if ((!$n_Lscalacss_internal_Attrs$bottom$)) {
    $n_Lscalacss_internal_Attrs$bottom$ = new $c_Lscalacss_internal_Attrs$bottom$()
  };
  return $n_Lscalacss_internal_Attrs$bottom$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$columnGap$() {
  this.Lscalacss_internal_Attrs$columnGap$__f_attr = null;
  $n_Lscalacss_internal_Attrs$columnGap$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_multicolumn;
  this.Lscalacss_internal_Attrs$columnGap$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("column-gap", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$columnGap$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$columnGap$.prototype.constructor = $c_Lscalacss_internal_Attrs$columnGap$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$columnGap$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$columnGap$.prototype = $c_Lscalacss_internal_Attrs$columnGap$.prototype;
$c_Lscalacss_internal_Attrs$columnGap$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$columnGap$__f_attr
});
var $d_Lscalacss_internal_Attrs$columnGap$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$columnGap$: 0
}, false, "scalacss.internal.Attrs$columnGap$", {
  Lscalacss_internal_Attrs$columnGap$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$GapStyleOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$columnGap$.prototype.$classData = $d_Lscalacss_internal_Attrs$columnGap$;
var $n_Lscalacss_internal_Attrs$columnGap$;
function $m_Lscalacss_internal_Attrs$columnGap$() {
  if ((!$n_Lscalacss_internal_Attrs$columnGap$)) {
    $n_Lscalacss_internal_Attrs$columnGap$ = new $c_Lscalacss_internal_Attrs$columnGap$()
  };
  return $n_Lscalacss_internal_Attrs$columnGap$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$height$() {
  this.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fLength__(this)
}
$c_Lscalacss_internal_Attrs$height$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLength();
$c_Lscalacss_internal_Attrs$height$.prototype.constructor = $c_Lscalacss_internal_Attrs$height$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$height$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$height$.prototype = $c_Lscalacss_internal_Attrs$height$.prototype;
$c_Lscalacss_internal_Attrs$height$.prototype.attr2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lscalacss_internal_Transform(x$2$2);
    return $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("height", x$2)
  }))
});
var $d_Lscalacss_internal_Attrs$height$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$height$: 0
}, false, "scalacss.internal.Attrs$height$", {
  Lscalacss_internal_Attrs$height$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLength: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$height$.prototype.$classData = $d_Lscalacss_internal_Attrs$height$;
var $n_Lscalacss_internal_Attrs$height$;
function $m_Lscalacss_internal_Attrs$height$() {
  if ((!$n_Lscalacss_internal_Attrs$height$)) {
    $n_Lscalacss_internal_Attrs$height$ = new $c_Lscalacss_internal_Attrs$height$()
  };
  return $n_Lscalacss_internal_Attrs$height$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$left$() {
  this.Lscalacss_internal_Attrs$left$__f_attr = null;
  $n_Lscalacss_internal_Attrs$left$ = this;
  this.Lscalacss_internal_Attrs$left$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("left")
}
$c_Lscalacss_internal_Attrs$left$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto();
$c_Lscalacss_internal_Attrs$left$.prototype.constructor = $c_Lscalacss_internal_Attrs$left$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$left$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$left$.prototype = $c_Lscalacss_internal_Attrs$left$.prototype;
$c_Lscalacss_internal_Attrs$left$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$left$__f_attr
});
var $d_Lscalacss_internal_Attrs$left$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$left$: 0
}, false, "scalacss.internal.Attrs$left$", {
  Lscalacss_internal_Attrs$left$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$left$.prototype.$classData = $d_Lscalacss_internal_Attrs$left$;
var $n_Lscalacss_internal_Attrs$left$;
function $m_Lscalacss_internal_Attrs$left$() {
  if ((!$n_Lscalacss_internal_Attrs$left$)) {
    $n_Lscalacss_internal_Attrs$left$ = new $c_Lscalacss_internal_Attrs$left$()
  };
  return $n_Lscalacss_internal_Attrs$left$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$marginBottom$() {
  this.Lscalacss_internal_Attrs$marginBottom$__f_attr = null;
  $n_Lscalacss_internal_Attrs$marginBottom$ = this;
  this.Lscalacss_internal_Attrs$marginBottom$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("margin-bottom")
}
$c_Lscalacss_internal_Attrs$marginBottom$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto();
$c_Lscalacss_internal_Attrs$marginBottom$.prototype.constructor = $c_Lscalacss_internal_Attrs$marginBottom$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$marginBottom$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$marginBottom$.prototype = $c_Lscalacss_internal_Attrs$marginBottom$.prototype;
$c_Lscalacss_internal_Attrs$marginBottom$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$marginBottom$__f_attr
});
var $d_Lscalacss_internal_Attrs$marginBottom$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$marginBottom$: 0
}, false, "scalacss.internal.Attrs$marginBottom$", {
  Lscalacss_internal_Attrs$marginBottom$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$marginBottom$.prototype.$classData = $d_Lscalacss_internal_Attrs$marginBottom$;
var $n_Lscalacss_internal_Attrs$marginBottom$;
function $m_Lscalacss_internal_Attrs$marginBottom$() {
  if ((!$n_Lscalacss_internal_Attrs$marginBottom$)) {
    $n_Lscalacss_internal_Attrs$marginBottom$ = new $c_Lscalacss_internal_Attrs$marginBottom$()
  };
  return $n_Lscalacss_internal_Attrs$marginBottom$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$marginLeft$() {
  this.Lscalacss_internal_Attrs$marginLeft$__f_attr = null;
  $n_Lscalacss_internal_Attrs$marginLeft$ = this;
  this.Lscalacss_internal_Attrs$marginLeft$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("margin-left")
}
$c_Lscalacss_internal_Attrs$marginLeft$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto();
$c_Lscalacss_internal_Attrs$marginLeft$.prototype.constructor = $c_Lscalacss_internal_Attrs$marginLeft$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$marginLeft$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$marginLeft$.prototype = $c_Lscalacss_internal_Attrs$marginLeft$.prototype;
$c_Lscalacss_internal_Attrs$marginLeft$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$marginLeft$__f_attr
});
var $d_Lscalacss_internal_Attrs$marginLeft$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$marginLeft$: 0
}, false, "scalacss.internal.Attrs$marginLeft$", {
  Lscalacss_internal_Attrs$marginLeft$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$marginLeft$.prototype.$classData = $d_Lscalacss_internal_Attrs$marginLeft$;
var $n_Lscalacss_internal_Attrs$marginLeft$;
function $m_Lscalacss_internal_Attrs$marginLeft$() {
  if ((!$n_Lscalacss_internal_Attrs$marginLeft$)) {
    $n_Lscalacss_internal_Attrs$marginLeft$ = new $c_Lscalacss_internal_Attrs$marginLeft$()
  };
  return $n_Lscalacss_internal_Attrs$marginLeft$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$marginRight$() {
  this.Lscalacss_internal_Attrs$marginRight$__f_attr = null;
  $n_Lscalacss_internal_Attrs$marginRight$ = this;
  this.Lscalacss_internal_Attrs$marginRight$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("margin-right")
}
$c_Lscalacss_internal_Attrs$marginRight$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto();
$c_Lscalacss_internal_Attrs$marginRight$.prototype.constructor = $c_Lscalacss_internal_Attrs$marginRight$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$marginRight$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$marginRight$.prototype = $c_Lscalacss_internal_Attrs$marginRight$.prototype;
$c_Lscalacss_internal_Attrs$marginRight$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$marginRight$__f_attr
});
var $d_Lscalacss_internal_Attrs$marginRight$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$marginRight$: 0
}, false, "scalacss.internal.Attrs$marginRight$", {
  Lscalacss_internal_Attrs$marginRight$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$marginRight$.prototype.$classData = $d_Lscalacss_internal_Attrs$marginRight$;
var $n_Lscalacss_internal_Attrs$marginRight$;
function $m_Lscalacss_internal_Attrs$marginRight$() {
  if ((!$n_Lscalacss_internal_Attrs$marginRight$)) {
    $n_Lscalacss_internal_Attrs$marginRight$ = new $c_Lscalacss_internal_Attrs$marginRight$()
  };
  return $n_Lscalacss_internal_Attrs$marginRight$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$marginTop$() {
  this.Lscalacss_internal_Attrs$marginTop$__f_attr = null;
  $n_Lscalacss_internal_Attrs$marginTop$ = this;
  this.Lscalacss_internal_Attrs$marginTop$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("margin-top")
}
$c_Lscalacss_internal_Attrs$marginTop$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto();
$c_Lscalacss_internal_Attrs$marginTop$.prototype.constructor = $c_Lscalacss_internal_Attrs$marginTop$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$marginTop$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$marginTop$.prototype = $c_Lscalacss_internal_Attrs$marginTop$.prototype;
$c_Lscalacss_internal_Attrs$marginTop$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$marginTop$__f_attr
});
var $d_Lscalacss_internal_Attrs$marginTop$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$marginTop$: 0
}, false, "scalacss.internal.Attrs$marginTop$", {
  Lscalacss_internal_Attrs$marginTop$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$marginTop$.prototype.$classData = $d_Lscalacss_internal_Attrs$marginTop$;
var $n_Lscalacss_internal_Attrs$marginTop$;
function $m_Lscalacss_internal_Attrs$marginTop$() {
  if ((!$n_Lscalacss_internal_Attrs$marginTop$)) {
    $n_Lscalacss_internal_Attrs$marginTop$ = new $c_Lscalacss_internal_Attrs$marginTop$()
  };
  return $n_Lscalacss_internal_Attrs$marginTop$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$maxHeight$() {
  this.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__(this)
}
$c_Lscalacss_internal_Attrs$maxHeight$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength();
$c_Lscalacss_internal_Attrs$maxHeight$.prototype.constructor = $c_Lscalacss_internal_Attrs$maxHeight$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$maxHeight$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$maxHeight$.prototype = $c_Lscalacss_internal_Attrs$maxHeight$.prototype;
$c_Lscalacss_internal_Attrs$maxHeight$.prototype.attr2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lscalacss_internal_Transform(x$3$2);
    return $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("max-height", x$3)
  }))
});
var $d_Lscalacss_internal_Attrs$maxHeight$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$maxHeight$: 0
}, false, "scalacss.internal.Attrs$maxHeight$", {
  Lscalacss_internal_Attrs$maxHeight$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$maxHeight$.prototype.$classData = $d_Lscalacss_internal_Attrs$maxHeight$;
var $n_Lscalacss_internal_Attrs$maxHeight$;
function $m_Lscalacss_internal_Attrs$maxHeight$() {
  if ((!$n_Lscalacss_internal_Attrs$maxHeight$)) {
    $n_Lscalacss_internal_Attrs$maxHeight$ = new $c_Lscalacss_internal_Attrs$maxHeight$()
  };
  return $n_Lscalacss_internal_Attrs$maxHeight$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$maxWidth$() {
  this.Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength__(this)
}
$c_Lscalacss_internal_Attrs$maxWidth$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength();
$c_Lscalacss_internal_Attrs$maxWidth$.prototype.constructor = $c_Lscalacss_internal_Attrs$maxWidth$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$maxWidth$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$maxWidth$.prototype = $c_Lscalacss_internal_Attrs$maxWidth$.prototype;
$c_Lscalacss_internal_Attrs$maxWidth$.prototype.attr2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4 = $as_Lscalacss_internal_Transform(x$4$2);
    return $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("max-width", x$4)
  }))
});
var $d_Lscalacss_internal_Attrs$maxWidth$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$maxWidth$: 0
}, false, "scalacss.internal.Attrs$maxWidth$", {
  Lscalacss_internal_Attrs$maxWidth$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fMaxLength: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$maxWidth$.prototype.$classData = $d_Lscalacss_internal_Attrs$maxWidth$;
var $n_Lscalacss_internal_Attrs$maxWidth$;
function $m_Lscalacss_internal_Attrs$maxWidth$() {
  if ((!$n_Lscalacss_internal_Attrs$maxWidth$)) {
    $n_Lscalacss_internal_Attrs$maxWidth$ = new $c_Lscalacss_internal_Attrs$maxWidth$()
  };
  return $n_Lscalacss_internal_Attrs$maxWidth$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$minHeight$() {
  this.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__(this)
}
$c_Lscalacss_internal_Attrs$minHeight$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength();
$c_Lscalacss_internal_Attrs$minHeight$.prototype.constructor = $c_Lscalacss_internal_Attrs$minHeight$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$minHeight$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$minHeight$.prototype = $c_Lscalacss_internal_Attrs$minHeight$.prototype;
$c_Lscalacss_internal_Attrs$minHeight$.prototype.attr2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$5$2) => {
    var x$5 = $as_Lscalacss_internal_Transform(x$5$2);
    return $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("min-height", x$5)
  }))
});
var $d_Lscalacss_internal_Attrs$minHeight$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$minHeight$: 0
}, false, "scalacss.internal.Attrs$minHeight$", {
  Lscalacss_internal_Attrs$minHeight$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$minHeight$.prototype.$classData = $d_Lscalacss_internal_Attrs$minHeight$;
var $n_Lscalacss_internal_Attrs$minHeight$;
function $m_Lscalacss_internal_Attrs$minHeight$() {
  if ((!$n_Lscalacss_internal_Attrs$minHeight$)) {
    $n_Lscalacss_internal_Attrs$minHeight$ = new $c_Lscalacss_internal_Attrs$minHeight$()
  };
  return $n_Lscalacss_internal_Attrs$minHeight$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$minWidth$() {
  this.Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength__(this)
}
$c_Lscalacss_internal_Attrs$minWidth$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength();
$c_Lscalacss_internal_Attrs$minWidth$.prototype.constructor = $c_Lscalacss_internal_Attrs$minWidth$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$minWidth$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$minWidth$.prototype = $c_Lscalacss_internal_Attrs$minWidth$.prototype;
$c_Lscalacss_internal_Attrs$minWidth$.prototype.attr2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6 = $as_Lscalacss_internal_Transform(x$6$2);
    return $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("min-width", x$6)
  }))
});
var $d_Lscalacss_internal_Attrs$minWidth$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$minWidth$: 0
}, false, "scalacss.internal.Attrs$minWidth$", {
  Lscalacss_internal_Attrs$minWidth$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fMinLength: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$minWidth$.prototype.$classData = $d_Lscalacss_internal_Attrs$minWidth$;
var $n_Lscalacss_internal_Attrs$minWidth$;
function $m_Lscalacss_internal_Attrs$minWidth$() {
  if ((!$n_Lscalacss_internal_Attrs$minWidth$)) {
    $n_Lscalacss_internal_Attrs$minWidth$ = new $c_Lscalacss_internal_Attrs$minWidth$()
  };
  return $n_Lscalacss_internal_Attrs$minWidth$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$right$() {
  this.Lscalacss_internal_Attrs$right$__f_attr = null;
  $n_Lscalacss_internal_Attrs$right$ = this;
  this.Lscalacss_internal_Attrs$right$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("right")
}
$c_Lscalacss_internal_Attrs$right$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto();
$c_Lscalacss_internal_Attrs$right$.prototype.constructor = $c_Lscalacss_internal_Attrs$right$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$right$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$right$.prototype = $c_Lscalacss_internal_Attrs$right$.prototype;
$c_Lscalacss_internal_Attrs$right$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$right$__f_attr
});
var $d_Lscalacss_internal_Attrs$right$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$right$: 0
}, false, "scalacss.internal.Attrs$right$", {
  Lscalacss_internal_Attrs$right$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$right$.prototype.$classData = $d_Lscalacss_internal_Attrs$right$;
var $n_Lscalacss_internal_Attrs$right$;
function $m_Lscalacss_internal_Attrs$right$() {
  if ((!$n_Lscalacss_internal_Attrs$right$)) {
    $n_Lscalacss_internal_Attrs$right$ = new $c_Lscalacss_internal_Attrs$right$()
  };
  return $n_Lscalacss_internal_Attrs$right$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$rowGap$() {
  this.Lscalacss_internal_Attrs$rowGap$__f_attr = null;
  $n_Lscalacss_internal_Attrs$rowGap$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_multicolumn;
  this.Lscalacss_internal_Attrs$rowGap$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("row-gap", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$rowGap$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_Attrs$rowGap$.prototype.constructor = $c_Lscalacss_internal_Attrs$rowGap$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$rowGap$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$rowGap$.prototype = $c_Lscalacss_internal_Attrs$rowGap$.prototype;
$c_Lscalacss_internal_Attrs$rowGap$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$rowGap$__f_attr
});
var $d_Lscalacss_internal_Attrs$rowGap$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$rowGap$: 0
}, false, "scalacss.internal.Attrs$rowGap$", {
  Lscalacss_internal_Attrs$rowGap$: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$GapStyleOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$rowGap$.prototype.$classData = $d_Lscalacss_internal_Attrs$rowGap$;
var $n_Lscalacss_internal_Attrs$rowGap$;
function $m_Lscalacss_internal_Attrs$rowGap$() {
  if ((!$n_Lscalacss_internal_Attrs$rowGap$)) {
    $n_Lscalacss_internal_Attrs$rowGap$ = new $c_Lscalacss_internal_Attrs$rowGap$()
  };
  return $n_Lscalacss_internal_Attrs$rowGap$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$top$() {
  this.Lscalacss_internal_Attrs$top$__f_attr = null;
  $n_Lscalacss_internal_Attrs$top$ = this;
  this.Lscalacss_internal_Attrs$top$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("top")
}
$c_Lscalacss_internal_Attrs$top$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto();
$c_Lscalacss_internal_Attrs$top$.prototype.constructor = $c_Lscalacss_internal_Attrs$top$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$top$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$top$.prototype = $c_Lscalacss_internal_Attrs$top$.prototype;
$c_Lscalacss_internal_Attrs$top$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$top$__f_attr
});
var $d_Lscalacss_internal_Attrs$top$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$top$: 0
}, false, "scalacss.internal.Attrs$top$", {
  Lscalacss_internal_Attrs$top$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLenPctAuto: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$top$.prototype.$classData = $d_Lscalacss_internal_Attrs$top$;
var $n_Lscalacss_internal_Attrs$top$;
function $m_Lscalacss_internal_Attrs$top$() {
  if ((!$n_Lscalacss_internal_Attrs$top$)) {
    $n_Lscalacss_internal_Attrs$top$ = new $c_Lscalacss_internal_Attrs$top$()
  };
  return $n_Lscalacss_internal_Attrs$top$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$width$() {
  this.Lscalacss_internal_ValueT$TypedAttr\uff3fLength__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fLength__(this)
}
$c_Lscalacss_internal_Attrs$width$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fLength();
$c_Lscalacss_internal_Attrs$width$.prototype.constructor = $c_Lscalacss_internal_Attrs$width$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$width$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$width$.prototype = $c_Lscalacss_internal_Attrs$width$.prototype;
$c_Lscalacss_internal_Attrs$width$.prototype.attr2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$7$2) => {
    var x$7 = $as_Lscalacss_internal_Transform(x$7$2);
    return $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("width", x$7)
  }))
});
var $d_Lscalacss_internal_Attrs$width$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$width$: 0
}, false, "scalacss.internal.Attrs$width$", {
  Lscalacss_internal_Attrs$width$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fLength: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$width$.prototype.$classData = $d_Lscalacss_internal_Attrs$width$;
var $n_Lscalacss_internal_Attrs$width$;
function $m_Lscalacss_internal_Attrs$width$() {
  if ((!$n_Lscalacss_internal_Attrs$width$)) {
    $n_Lscalacss_internal_Attrs$width$ = new $c_Lscalacss_internal_Attrs$width$()
  };
  return $n_Lscalacss_internal_Attrs$width$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Prefix$moz$() {
  this.Lscalacss_internal_CanIUse$Prefix__f_name = null;
  this.Lscalacss_internal_CanIUse$Prefix__f_prefix = null;
  $ct_Lscalacss_internal_CanIUse$Prefix__T__(this, "moz")
}
$c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype = new $h_Lscalacss_internal_CanIUse$Prefix();
$c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Prefix$moz$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Prefix$moz$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Prefix$moz$.prototype = $c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype;
$c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype.productPrefix__T = (function() {
  return "moz"
});
$c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype.hashCode__I = (function() {
  return 108312
});
$c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype.toString__T = (function() {
  return "moz"
});
var $d_Lscalacss_internal_CanIUse$Prefix$moz$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Prefix$moz$: 0
}, false, "scalacss.internal.CanIUse$Prefix$moz$", {
  Lscalacss_internal_CanIUse$Prefix$moz$: 1,
  Lscalacss_internal_CanIUse$Prefix: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Prefix$moz$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Prefix$moz$;
var $n_Lscalacss_internal_CanIUse$Prefix$moz$;
function $m_Lscalacss_internal_CanIUse$Prefix$moz$() {
  if ((!$n_Lscalacss_internal_CanIUse$Prefix$moz$)) {
    $n_Lscalacss_internal_CanIUse$Prefix$moz$ = new $c_Lscalacss_internal_CanIUse$Prefix$moz$()
  };
  return $n_Lscalacss_internal_CanIUse$Prefix$moz$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Prefix$ms$() {
  this.Lscalacss_internal_CanIUse$Prefix__f_name = null;
  this.Lscalacss_internal_CanIUse$Prefix__f_prefix = null;
  $ct_Lscalacss_internal_CanIUse$Prefix__T__(this, "ms")
}
$c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype = new $h_Lscalacss_internal_CanIUse$Prefix();
$c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Prefix$ms$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Prefix$ms$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Prefix$ms$.prototype = $c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype;
$c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype.productPrefix__T = (function() {
  return "ms"
});
$c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype.hashCode__I = (function() {
  return 3494
});
$c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype.toString__T = (function() {
  return "ms"
});
var $d_Lscalacss_internal_CanIUse$Prefix$ms$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Prefix$ms$: 0
}, false, "scalacss.internal.CanIUse$Prefix$ms$", {
  Lscalacss_internal_CanIUse$Prefix$ms$: 1,
  Lscalacss_internal_CanIUse$Prefix: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Prefix$ms$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Prefix$ms$;
var $n_Lscalacss_internal_CanIUse$Prefix$ms$;
function $m_Lscalacss_internal_CanIUse$Prefix$ms$() {
  if ((!$n_Lscalacss_internal_CanIUse$Prefix$ms$)) {
    $n_Lscalacss_internal_CanIUse$Prefix$ms$ = new $c_Lscalacss_internal_CanIUse$Prefix$ms$()
  };
  return $n_Lscalacss_internal_CanIUse$Prefix$ms$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Prefix$o$() {
  this.Lscalacss_internal_CanIUse$Prefix__f_name = null;
  this.Lscalacss_internal_CanIUse$Prefix__f_prefix = null;
  $ct_Lscalacss_internal_CanIUse$Prefix__T__(this, "o")
}
$c_Lscalacss_internal_CanIUse$Prefix$o$.prototype = new $h_Lscalacss_internal_CanIUse$Prefix();
$c_Lscalacss_internal_CanIUse$Prefix$o$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Prefix$o$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Prefix$o$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Prefix$o$.prototype = $c_Lscalacss_internal_CanIUse$Prefix$o$.prototype;
$c_Lscalacss_internal_CanIUse$Prefix$o$.prototype.productPrefix__T = (function() {
  return "o"
});
$c_Lscalacss_internal_CanIUse$Prefix$o$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Prefix$o$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Prefix$o$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Prefix$o$.prototype.hashCode__I = (function() {
  return 111
});
$c_Lscalacss_internal_CanIUse$Prefix$o$.prototype.toString__T = (function() {
  return "o"
});
var $d_Lscalacss_internal_CanIUse$Prefix$o$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Prefix$o$: 0
}, false, "scalacss.internal.CanIUse$Prefix$o$", {
  Lscalacss_internal_CanIUse$Prefix$o$: 1,
  Lscalacss_internal_CanIUse$Prefix: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Prefix$o$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Prefix$o$;
var $n_Lscalacss_internal_CanIUse$Prefix$o$;
function $m_Lscalacss_internal_CanIUse$Prefix$o$() {
  if ((!$n_Lscalacss_internal_CanIUse$Prefix$o$)) {
    $n_Lscalacss_internal_CanIUse$Prefix$o$ = new $c_Lscalacss_internal_CanIUse$Prefix$o$()
  };
  return $n_Lscalacss_internal_CanIUse$Prefix$o$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Prefix$webkit$() {
  this.Lscalacss_internal_CanIUse$Prefix__f_name = null;
  this.Lscalacss_internal_CanIUse$Prefix__f_prefix = null;
  $ct_Lscalacss_internal_CanIUse$Prefix__T__(this, "webkit")
}
$c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype = new $h_Lscalacss_internal_CanIUse$Prefix();
$c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Prefix$webkit$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Prefix$webkit$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype = $c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype;
$c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype.productPrefix__T = (function() {
  return "webkit"
});
$c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype.hashCode__I = (function() {
  return (-791796990)
});
$c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype.toString__T = (function() {
  return "webkit"
});
var $d_Lscalacss_internal_CanIUse$Prefix$webkit$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Prefix$webkit$: 0
}, false, "scalacss.internal.CanIUse$Prefix$webkit$", {
  Lscalacss_internal_CanIUse$Prefix$webkit$: 1,
  Lscalacss_internal_CanIUse$Prefix: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Prefix$webkit$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Prefix$webkit$;
var $n_Lscalacss_internal_CanIUse$Prefix$webkit$;
function $m_Lscalacss_internal_CanIUse$Prefix$webkit$() {
  if ((!$n_Lscalacss_internal_CanIUse$Prefix$webkit$)) {
    $n_Lscalacss_internal_CanIUse$Prefix$webkit$ = new $c_Lscalacss_internal_CanIUse$Prefix$webkit$()
  };
  return $n_Lscalacss_internal_CanIUse$Prefix$webkit$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Support$Full$() {
  /*<skip>*/
}
$c_Lscalacss_internal_CanIUse$Support$Full$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Support$Full$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Support$Full$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Support$Full$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Support$Full$.prototype = $c_Lscalacss_internal_CanIUse$Support$Full$.prototype;
$c_Lscalacss_internal_CanIUse$Support$Full$.prototype.productPrefix__T = (function() {
  return "Full"
});
$c_Lscalacss_internal_CanIUse$Support$Full$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Support$Full$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Support$Full$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Support$Full$.prototype.hashCode__I = (function() {
  return 2201263
});
$c_Lscalacss_internal_CanIUse$Support$Full$.prototype.toString__T = (function() {
  return "Full"
});
var $d_Lscalacss_internal_CanIUse$Support$Full$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Support$Full$: 0
}, false, "scalacss.internal.CanIUse$Support$Full$", {
  Lscalacss_internal_CanIUse$Support$Full$: 1,
  O: 1,
  Lscalacss_internal_CanIUse$Support: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Support$Full$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Support$Full$;
var $n_Lscalacss_internal_CanIUse$Support$Full$;
function $m_Lscalacss_internal_CanIUse$Support$Full$() {
  if ((!$n_Lscalacss_internal_CanIUse$Support$Full$)) {
    $n_Lscalacss_internal_CanIUse$Support$Full$ = new $c_Lscalacss_internal_CanIUse$Support$Full$()
  };
  return $n_Lscalacss_internal_CanIUse$Support$Full$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Support$FullX$() {
  /*<skip>*/
}
$c_Lscalacss_internal_CanIUse$Support$FullX$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Support$FullX$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Support$FullX$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Support$FullX$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Support$FullX$.prototype = $c_Lscalacss_internal_CanIUse$Support$FullX$.prototype;
$c_Lscalacss_internal_CanIUse$Support$FullX$.prototype.productPrefix__T = (function() {
  return "FullX"
});
$c_Lscalacss_internal_CanIUse$Support$FullX$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Support$FullX$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Support$FullX$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Support$FullX$.prototype.hashCode__I = (function() {
  return 68239241
});
$c_Lscalacss_internal_CanIUse$Support$FullX$.prototype.toString__T = (function() {
  return "FullX"
});
var $d_Lscalacss_internal_CanIUse$Support$FullX$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Support$FullX$: 0
}, false, "scalacss.internal.CanIUse$Support$FullX$", {
  Lscalacss_internal_CanIUse$Support$FullX$: 1,
  O: 1,
  Lscalacss_internal_CanIUse$Support: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Support$FullX$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Support$FullX$;
var $n_Lscalacss_internal_CanIUse$Support$FullX$;
function $m_Lscalacss_internal_CanIUse$Support$FullX$() {
  if ((!$n_Lscalacss_internal_CanIUse$Support$FullX$)) {
    $n_Lscalacss_internal_CanIUse$Support$FullX$ = new $c_Lscalacss_internal_CanIUse$Support$FullX$()
  };
  return $n_Lscalacss_internal_CanIUse$Support$FullX$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Support$Partial$() {
  /*<skip>*/
}
$c_Lscalacss_internal_CanIUse$Support$Partial$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Support$Partial$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Support$Partial$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Support$Partial$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Support$Partial$.prototype = $c_Lscalacss_internal_CanIUse$Support$Partial$.prototype;
$c_Lscalacss_internal_CanIUse$Support$Partial$.prototype.productPrefix__T = (function() {
  return "Partial"
});
$c_Lscalacss_internal_CanIUse$Support$Partial$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Support$Partial$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Support$Partial$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Support$Partial$.prototype.hashCode__I = (function() {
  return 871719265
});
$c_Lscalacss_internal_CanIUse$Support$Partial$.prototype.toString__T = (function() {
  return "Partial"
});
var $d_Lscalacss_internal_CanIUse$Support$Partial$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Support$Partial$: 0
}, false, "scalacss.internal.CanIUse$Support$Partial$", {
  Lscalacss_internal_CanIUse$Support$Partial$: 1,
  O: 1,
  Lscalacss_internal_CanIUse$Support: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Support$Partial$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Support$Partial$;
var $n_Lscalacss_internal_CanIUse$Support$Partial$;
function $m_Lscalacss_internal_CanIUse$Support$Partial$() {
  if ((!$n_Lscalacss_internal_CanIUse$Support$Partial$)) {
    $n_Lscalacss_internal_CanIUse$Support$Partial$ = new $c_Lscalacss_internal_CanIUse$Support$Partial$()
  };
  return $n_Lscalacss_internal_CanIUse$Support$Partial$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Support$PartialX$() {
  /*<skip>*/
}
$c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Support$PartialX$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Support$PartialX$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Support$PartialX$.prototype = $c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype;
$c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype.productPrefix__T = (function() {
  return "PartialX"
});
$c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype.hashCode__I = (function() {
  return 1253493527
});
$c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype.toString__T = (function() {
  return "PartialX"
});
var $d_Lscalacss_internal_CanIUse$Support$PartialX$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Support$PartialX$: 0
}, false, "scalacss.internal.CanIUse$Support$PartialX$", {
  Lscalacss_internal_CanIUse$Support$PartialX$: 1,
  O: 1,
  Lscalacss_internal_CanIUse$Support: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Support$PartialX$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Support$PartialX$;
var $n_Lscalacss_internal_CanIUse$Support$PartialX$;
function $m_Lscalacss_internal_CanIUse$Support$PartialX$() {
  if ((!$n_Lscalacss_internal_CanIUse$Support$PartialX$)) {
    $n_Lscalacss_internal_CanIUse$Support$PartialX$ = new $c_Lscalacss_internal_CanIUse$Support$PartialX$()
  };
  return $n_Lscalacss_internal_CanIUse$Support$PartialX$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Support$Unknown$() {
  /*<skip>*/
}
$c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Support$Unknown$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Support$Unknown$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Support$Unknown$.prototype = $c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype;
$c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype.productPrefix__T = (function() {
  return "Unknown"
});
$c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype.hashCode__I = (function() {
  return 1379812394
});
$c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype.toString__T = (function() {
  return "Unknown"
});
var $d_Lscalacss_internal_CanIUse$Support$Unknown$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Support$Unknown$: 0
}, false, "scalacss.internal.CanIUse$Support$Unknown$", {
  Lscalacss_internal_CanIUse$Support$Unknown$: 1,
  O: 1,
  Lscalacss_internal_CanIUse$Support: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Support$Unknown$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Support$Unknown$;
var $n_Lscalacss_internal_CanIUse$Support$Unknown$;
function $m_Lscalacss_internal_CanIUse$Support$Unknown$() {
  if ((!$n_Lscalacss_internal_CanIUse$Support$Unknown$)) {
    $n_Lscalacss_internal_CanIUse$Support$Unknown$ = new $c_Lscalacss_internal_CanIUse$Support$Unknown$()
  };
  return $n_Lscalacss_internal_CanIUse$Support$Unknown$
}
/** @constructor */
function $c_Lscalacss_internal_CanIUse$Support$Unsupported$() {
  /*<skip>*/
}
$c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype = new $h_O();
$c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype.constructor = $c_Lscalacss_internal_CanIUse$Support$Unsupported$;
/** @constructor */
function $h_Lscalacss_internal_CanIUse$Support$Unsupported$() {
  /*<skip>*/
}
$h_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype = $c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype;
$c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype.productPrefix__T = (function() {
  return "Unsupported"
});
$c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype.hashCode__I = (function() {
  return 1716505109
});
$c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype.toString__T = (function() {
  return "Unsupported"
});
var $d_Lscalacss_internal_CanIUse$Support$Unsupported$ = new $TypeData().initClass({
  Lscalacss_internal_CanIUse$Support$Unsupported$: 0
}, false, "scalacss.internal.CanIUse$Support$Unsupported$", {
  Lscalacss_internal_CanIUse$Support$Unsupported$: 1,
  O: 1,
  Lscalacss_internal_CanIUse$Support: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CanIUse$Support$Unsupported$.prototype.$classData = $d_Lscalacss_internal_CanIUse$Support$Unsupported$;
var $n_Lscalacss_internal_CanIUse$Support$Unsupported$;
function $m_Lscalacss_internal_CanIUse$Support$Unsupported$() {
  if ((!$n_Lscalacss_internal_CanIUse$Support$Unsupported$)) {
    $n_Lscalacss_internal_CanIUse$Support$Unsupported$ = new $c_Lscalacss_internal_CanIUse$Support$Unsupported$()
  };
  return $n_Lscalacss_internal_CanIUse$Support$Unsupported$
}
/** @constructor */
function $c_Lscalacss_internal_Cond(pseudo, mediaQueries) {
  this.Lscalacss_internal_Cond__f_pseudo = null;
  this.Lscalacss_internal_Cond__f_mediaQueries = null;
  this.Lscalacss_internal_Cond__f_pseudo = pseudo;
  this.Lscalacss_internal_Cond__f_mediaQueries = mediaQueries;
  var s = new $c_sr_ObjectRef("");
  var this$2 = $n(pseudo);
  if ((!this$2.isEmpty__Z())) {
    var arg1 = this$2.get__O();
    var p = $as_Lscalacss_internal_Pseudo(arg1);
    s.sr_ObjectRef__f_elem = (("" + $as_T(s.sr_ObjectRef__f_elem)) + $n(p).cssValue__T())
  };
  $n(mediaQueries).foreach__F1__V(new $c_sjsr_AnonFunction1(((q$2) => {
    var q = $as_Lscalacss_internal_Media$Query(q$2);
    s.sr_ObjectRef__f_elem = (("" + $as_T(s.sr_ObjectRef__f_elem)) + $n(q).Lscalacss_internal_Media$Query__f_cssSuffix)
  })));
  $as_T(s.sr_ObjectRef__f_elem)
}
$c_Lscalacss_internal_Cond.prototype = new $h_O();
$c_Lscalacss_internal_Cond.prototype.constructor = $c_Lscalacss_internal_Cond;
/** @constructor */
function $h_Lscalacss_internal_Cond() {
  /*<skip>*/
}
$h_Lscalacss_internal_Cond.prototype = $c_Lscalacss_internal_Cond.prototype;
$c_Lscalacss_internal_Cond.prototype.toString__T = (function() {
  var this$1 = $n($m_Lscalacss_internal_NonEmptyVector$().option__sci_Vector__s_Option(this.Lscalacss_internal_Cond__f_mediaQueries));
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var qs = $as_Lscalacss_internal_NonEmptyVector(arg1);
    var $$x1 = new $c_s_Some($m_Lscalacss_internal_Media$().css__Lscalacss_internal_NonEmptyVector__T(qs))
  };
  var this$2 = $n($$x1);
  if (this$2.isEmpty__Z()) {
    var $$x2 = ""
  } else {
    var arg1$1 = this$2.get__O();
    var x$1 = $as_T(arg1$1);
    var $$x2 = (x$1 + " ")
  };
  return ($$x2 + $m_Lscalacss_internal_Css$().selector__T__Lscalacss_internal_Cond__T("", this))
});
$c_Lscalacss_internal_Cond.prototype.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Cond = (function(p) {
  var this$1 = $n(this.Lscalacss_internal_Cond__f_pseudo);
  if (this$1.isEmpty__Z()) {
    var $$x1 = p
  } else {
    var arg1 = this$1.get__O();
    var x$2 = $as_Lscalacss_internal_Pseudo(arg1);
    var this$2 = $n(x$2);
    var $$x1 = this$2.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Pseudo(p)
  };
  var pseudo = new $c_s_Some($$x1);
  var mediaQueries = this.Lscalacss_internal_Cond__f_mediaQueries;
  return new $c_Lscalacss_internal_Cond(pseudo, mediaQueries)
});
$c_Lscalacss_internal_Cond.prototype.$amp__Lscalacss_internal_Cond__Lscalacss_internal_Cond = (function(b) {
  var oa = this.Lscalacss_internal_Cond__f_pseudo;
  var ob = $n(b).Lscalacss_internal_Cond__f_pseudo;
  var x1 = $ct_T2__O__O__(new $c_T2(), oa, ob);
  matchEnd19: {
    var $$x2;
    var p2 = $as_s_Option(x1.T2__f__1);
    var p3 = $as_s_Option(x1.T2__f__2);
    var x = $m_s_None$();
    if ((x === p2)) {
      var x$3 = $m_s_None$();
      var $$x3 = (x$3 === p3)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var $$x2 = $m_s_None$();
      break matchEnd19
    };
    var p6 = $as_s_Option(x1.T2__f__1);
    var p7 = $as_s_Option(x1.T2__f__2);
    if ((p6 instanceof $c_s_Some)) {
      var x8 = $as_s_Some(p6);
      var a = $n(x8).s_Some__f_value;
      var x$5 = $m_s_None$();
      if ((x$5 === p7)) {
        var $$x2 = new $c_s_Some(a);
        break matchEnd19
      }
    };
    var p10 = $as_s_Option(x1.T2__f__1);
    var p11 = $as_s_Option(x1.T2__f__2);
    var x$7 = $m_s_None$();
    if (((x$7 === p10) && (p11 instanceof $c_s_Some))) {
      var x12 = $as_s_Some(p11);
      var b$1 = $n(x12).s_Some__f_value;
      var $$x2 = new $c_s_Some(b$1);
      break matchEnd19
    };
    var p14 = $as_s_Option(x1.T2__f__1);
    var p15 = $as_s_Option(x1.T2__f__2);
    if ((p14 instanceof $c_s_Some)) {
      var x16 = $as_s_Some(p14);
      var a$2 = $n(x16).s_Some__f_value;
      if ((p15 instanceof $c_s_Some)) {
        var x17 = $as_s_Some(p15);
        var b$2 = $n(x17).s_Some__f_value;
        var x$3$1 = $as_Lscalacss_internal_Pseudo(a$2);
        var x$4 = $as_Lscalacss_internal_Pseudo(b$2);
        var this$2 = $n(x$3$1);
        var $$x2 = new $c_s_Some(this$2.addPseudo__Lscalacss_internal_Pseudo__Lscalacss_internal_Pseudo(x$4));
        break matchEnd19
      }
    };
    throw new $c_s_MatchError(x1)
  };
  var this$3 = $n($n(b).Lscalacss_internal_Cond__f_mediaQueries);
  var z = this.Lscalacss_internal_Cond__f_mediaQueries;
  var at = 0;
  var end = this$3.length__I();
  var acc = z;
  var $$x1;
  while (true) {
    if ((at !== end)) {
      var temp$at = ((1 + at) | 0);
      var arg1 = acc;
      var arg2 = this$3.apply__I__O(at);
      var x$5$1 = $as_sci_Vector(arg1);
      var x$6 = $as_Lscalacss_internal_Media$Query(arg2);
      var temp$acc = $n(x$6).$plus$colon__sci_Vector__sci_Vector(x$5$1);
      at = temp$at;
      acc = temp$acc;
      continue
    };
    var $$x1 = acc;
    break
  };
  return new $c_Lscalacss_internal_Cond($$x2, $as_sci_Vector($$x1))
});
$c_Lscalacss_internal_Cond.prototype.applyToStyle__Lscalacss_internal_StyleS__Lscalacss_internal_StyleS = (function(s) {
  var this$3 = $n($n(s).Lscalacss_internal_StyleS__f_data);
  var z = $m_sci_SortedMap$().empty__s_math_Ordering__O($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_ordering);
  var f = ((x0$1$2, x1$1$2) => {
    var x0$1 = $as_sci_SortedMap(x0$1$2);
    var x1$1 = $as_T2(x1$1$2);
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
    var q = $as_sci_SortedMap(x1.T2__f__1);
    var p2 = $as_T2(x1.T2__f__2);
    if ((p2 !== null)) {
      var oldCond = $as_Lscalacss_internal_Cond($n(p2)._1__O());
      var av = $as_Lscalacss_internal_AVs($n(p2)._2__O());
      var newCond = this.$amp__Lscalacss_internal_Cond__Lscalacss_internal_Cond(oldCond);
      var this$2 = $n($n(q).get__O__s_Option(newCond));
      if (this$2.isEmpty__Z()) {
        var newValue = av
      } else {
        var arg1 = this$2.get__O();
        var x$7 = $as_Lscalacss_internal_AVs(arg1);
        var newValue = $n(x$7).$plus$plus__Lscalacss_internal_AVs__Lscalacss_internal_AVs(av)
      };
      return $as_sci_SortedMap($n(q).updated__O__O__sci_Map(newCond, newValue))
    };
    throw new $c_s_MatchError(x1)
  });
  if ($is_sc_IndexedSeq(this$3)) {
    var x2 = $as_sc_IndexedSeq(this$3);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = z;
    var $$x1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1$1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f(arg1$1, arg2);
        at = temp$at;
        acc = temp$acc;
        continue
      };
      var $$x1 = acc;
      break
    }
  } else {
    var result = z;
    var it = this$3.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1$2 = result;
      var arg2$1 = $n(it).next__O();
      result = f(arg1$2, arg2$1)
    };
    var $$x1 = result
  };
  var d = $as_sci_SortedMap($$x1);
  var u = $as_sci_Vector($n($n(s).Lscalacss_internal_StyleS__f_unsafeExts).map__F1__O(new $c_sjsr_AnonFunction1(((e$2) => {
    var e = $as_Lscalacss_internal_Style$UnsafeExt(e$2);
    var pseudo = $m_s_None$();
    var mediaQueries = this.Lscalacss_internal_Cond__f_mediaQueries;
    var x$3 = new $c_Lscalacss_internal_Cond(pseudo, mediaQueries).applyToStyle__Lscalacss_internal_StyleS__Lscalacss_internal_StyleS($n(e).Lscalacss_internal_Style$UnsafeExt__f_style);
    $n($m_s_package$().s_package$__f_Vector);
    var x$1 = $m_sci_Vector0$();
    var x$2 = this.Lscalacss_internal_Cond__f_pseudo;
    var x$4 = new $c_Lscalacss_internal_Cond(x$2, x$1).$amp__Lscalacss_internal_Cond__Lscalacss_internal_Cond($n(e).Lscalacss_internal_Style$UnsafeExt__f_cond);
    var this$5 = $n(e);
    var x$5 = this$5.Lscalacss_internal_Style$UnsafeExt__f_sel;
    $n(e);
    return new $c_Lscalacss_internal_Style$UnsafeExt(x$5, x$4, x$3)
  }))));
  $n(s);
  var this$7 = $n(s);
  var className = this$7.Lscalacss_internal_StyleS__f_className;
  var this$8 = $n(s);
  var addClassNames = this$8.Lscalacss_internal_StyleS__f_addClassNames;
  var this$9 = $n(s);
  var warnings = this$9.Lscalacss_internal_StyleS__f_warnings;
  return new $c_Lscalacss_internal_StyleS(d, u, className, addClassNames, warnings)
});
$c_Lscalacss_internal_Cond.prototype.productPrefix__T = (function() {
  return "Cond"
});
$c_Lscalacss_internal_Cond.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_Cond.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_Cond__f_pseudo;
      break
    }
    case 1: {
      return this.Lscalacss_internal_Cond__f_mediaQueries;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_Cond.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Cond.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Cond.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Cond)) {
    var Cond$1 = $as_Lscalacss_internal_Cond(x$1);
    var x = this.Lscalacss_internal_Cond__f_pseudo;
    var x$2 = $n(Cond$1).Lscalacss_internal_Cond__f_pseudo;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalacss_internal_Cond__f_mediaQueries;
      var x$4 = $n(Cond$1).Lscalacss_internal_Cond__f_mediaQueries;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Cond(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Cond) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Cond"))
}
function $isArrayOf_Lscalacss_internal_Cond(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Cond)))
}
function $asArrayOf_Lscalacss_internal_Cond(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Cond(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Cond;", depth))
}
var $d_Lscalacss_internal_Cond = new $TypeData().initClass({
  Lscalacss_internal_Cond: 0
}, false, "scalacss.internal.Cond", {
  Lscalacss_internal_Cond: 1,
  O: 1,
  Lscalacss_internal_Pseudo$ChainOps: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Cond.prototype.$classData = $d_Lscalacss_internal_Cond;
/** @constructor */
function $c_Lscalacss_internal_CssEntry$FontFace(fontFamily, src, fontStretch, fontStyle, fontWeight, unicodeRange) {
  this.Lscalacss_internal_CssEntry$FontFace__f_fontFamily = null;
  this.Lscalacss_internal_CssEntry$FontFace__f_src = null;
  this.Lscalacss_internal_CssEntry$FontFace__f_fontStretch = null;
  this.Lscalacss_internal_CssEntry$FontFace__f_fontStyle = null;
  this.Lscalacss_internal_CssEntry$FontFace__f_fontWeight = null;
  this.Lscalacss_internal_CssEntry$FontFace__f_unicodeRange = null;
  this.Lscalacss_internal_CssEntry$FontFace__f_fontFamily = fontFamily;
  this.Lscalacss_internal_CssEntry$FontFace__f_src = src;
  this.Lscalacss_internal_CssEntry$FontFace__f_fontStretch = fontStretch;
  this.Lscalacss_internal_CssEntry$FontFace__f_fontStyle = fontStyle;
  this.Lscalacss_internal_CssEntry$FontFace__f_fontWeight = fontWeight;
  this.Lscalacss_internal_CssEntry$FontFace__f_unicodeRange = unicodeRange
}
$c_Lscalacss_internal_CssEntry$FontFace.prototype = new $h_O();
$c_Lscalacss_internal_CssEntry$FontFace.prototype.constructor = $c_Lscalacss_internal_CssEntry$FontFace;
/** @constructor */
function $h_Lscalacss_internal_CssEntry$FontFace() {
  /*<skip>*/
}
$h_Lscalacss_internal_CssEntry$FontFace.prototype = $c_Lscalacss_internal_CssEntry$FontFace.prototype;
$c_Lscalacss_internal_CssEntry$FontFace.prototype.productPrefix__T = (function() {
  return "FontFace"
});
$c_Lscalacss_internal_CssEntry$FontFace.prototype.productArity__I = (function() {
  return 6
});
$c_Lscalacss_internal_CssEntry$FontFace.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_CssEntry$FontFace__f_fontFamily;
      break
    }
    case 1: {
      return this.Lscalacss_internal_CssEntry$FontFace__f_src;
      break
    }
    case 2: {
      return this.Lscalacss_internal_CssEntry$FontFace__f_fontStretch;
      break
    }
    case 3: {
      return this.Lscalacss_internal_CssEntry$FontFace__f_fontStyle;
      break
    }
    case 4: {
      return this.Lscalacss_internal_CssEntry$FontFace__f_fontWeight;
      break
    }
    case 5: {
      return this.Lscalacss_internal_CssEntry$FontFace__f_unicodeRange;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_CssEntry$FontFace.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CssEntry$FontFace.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_CssEntry$FontFace.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_CssEntry$FontFace.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_CssEntry$FontFace)) {
    var FontFace$1 = $as_Lscalacss_internal_CssEntry$FontFace(x$1);
    if ((this.Lscalacss_internal_CssEntry$FontFace__f_fontFamily === $n(FontFace$1).Lscalacss_internal_CssEntry$FontFace__f_fontFamily)) {
      var x = this.Lscalacss_internal_CssEntry$FontFace__f_src;
      var x$2 = $n(FontFace$1).Lscalacss_internal_CssEntry$FontFace__f_src;
      var $$x5 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$3 = this.Lscalacss_internal_CssEntry$FontFace__f_fontStretch;
      var x$4 = $n(FontFace$1).Lscalacss_internal_CssEntry$FontFace__f_fontStretch;
      var $$x4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$5 = this.Lscalacss_internal_CssEntry$FontFace__f_fontStyle;
      var x$6 = $n(FontFace$1).Lscalacss_internal_CssEntry$FontFace__f_fontStyle;
      var $$x3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$7 = this.Lscalacss_internal_CssEntry$FontFace__f_fontWeight;
      var x$8 = $n(FontFace$1).Lscalacss_internal_CssEntry$FontFace__f_fontWeight;
      var $$x2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$9 = this.Lscalacss_internal_CssEntry$FontFace__f_unicodeRange;
      var x$10 = $n(FontFace$1).Lscalacss_internal_CssEntry$FontFace__f_unicodeRange;
      var $$x1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(FontFace$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_CssEntry$FontFace(obj) {
  return (((obj instanceof $c_Lscalacss_internal_CssEntry$FontFace) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.CssEntry$FontFace"))
}
function $isArrayOf_Lscalacss_internal_CssEntry$FontFace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_CssEntry$FontFace)))
}
function $asArrayOf_Lscalacss_internal_CssEntry$FontFace(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_CssEntry$FontFace(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.CssEntry$FontFace;", depth))
}
var $d_Lscalacss_internal_CssEntry$FontFace = new $TypeData().initClass({
  Lscalacss_internal_CssEntry$FontFace: 0
}, false, "scalacss.internal.CssEntry$FontFace", {
  Lscalacss_internal_CssEntry$FontFace: 1,
  O: 1,
  Lscalacss_internal_CssEntry: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CssEntry$FontFace.prototype.$classData = $d_Lscalacss_internal_CssEntry$FontFace;
/** @constructor */
function $c_Lscalacss_internal_CssEntry$Keyframes(name, frames) {
  this.Lscalacss_internal_CssEntry$Keyframes__f_name = null;
  this.Lscalacss_internal_CssEntry$Keyframes__f_frames = null;
  this.Lscalacss_internal_CssEntry$Keyframes__f_name = name;
  this.Lscalacss_internal_CssEntry$Keyframes__f_frames = frames
}
$c_Lscalacss_internal_CssEntry$Keyframes.prototype = new $h_O();
$c_Lscalacss_internal_CssEntry$Keyframes.prototype.constructor = $c_Lscalacss_internal_CssEntry$Keyframes;
/** @constructor */
function $h_Lscalacss_internal_CssEntry$Keyframes() {
  /*<skip>*/
}
$h_Lscalacss_internal_CssEntry$Keyframes.prototype = $c_Lscalacss_internal_CssEntry$Keyframes.prototype;
$c_Lscalacss_internal_CssEntry$Keyframes.prototype.productPrefix__T = (function() {
  return "Keyframes"
});
$c_Lscalacss_internal_CssEntry$Keyframes.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_CssEntry$Keyframes.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_CssEntry$Keyframes__f_name;
      break
    }
    case 1: {
      return this.Lscalacss_internal_CssEntry$Keyframes__f_frames;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_CssEntry$Keyframes.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CssEntry$Keyframes.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_CssEntry$Keyframes.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_CssEntry$Keyframes.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_CssEntry$Keyframes)) {
    var Keyframes$1 = $as_Lscalacss_internal_CssEntry$Keyframes(x$1);
    var x = this.Lscalacss_internal_CssEntry$Keyframes__f_name;
    var x$2 = $n(Keyframes$1).Lscalacss_internal_CssEntry$Keyframes__f_name;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalacss_internal_CssEntry$Keyframes__f_frames;
      var x$4 = $n(Keyframes$1).Lscalacss_internal_CssEntry$Keyframes__f_frames;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = $f_sc_Map__equals__O__Z(this$1, x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(Keyframes$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_CssEntry$Keyframes(obj) {
  return (((obj instanceof $c_Lscalacss_internal_CssEntry$Keyframes) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.CssEntry$Keyframes"))
}
function $isArrayOf_Lscalacss_internal_CssEntry$Keyframes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_CssEntry$Keyframes)))
}
function $asArrayOf_Lscalacss_internal_CssEntry$Keyframes(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_CssEntry$Keyframes(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.CssEntry$Keyframes;", depth))
}
var $d_Lscalacss_internal_CssEntry$Keyframes = new $TypeData().initClass({
  Lscalacss_internal_CssEntry$Keyframes: 0
}, false, "scalacss.internal.CssEntry$Keyframes", {
  Lscalacss_internal_CssEntry$Keyframes: 1,
  O: 1,
  Lscalacss_internal_CssEntry: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CssEntry$Keyframes.prototype.$classData = $d_Lscalacss_internal_CssEntry$Keyframes;
/** @constructor */
function $c_Lscalacss_internal_CssEntry$Style(mq, sel, content) {
  this.Lscalacss_internal_CssEntry$Style__f_mq = null;
  this.Lscalacss_internal_CssEntry$Style__f_sel = null;
  this.Lscalacss_internal_CssEntry$Style__f_content = null;
  this.Lscalacss_internal_CssEntry$Style__f_mq = mq;
  this.Lscalacss_internal_CssEntry$Style__f_sel = sel;
  this.Lscalacss_internal_CssEntry$Style__f_content = content
}
$c_Lscalacss_internal_CssEntry$Style.prototype = new $h_O();
$c_Lscalacss_internal_CssEntry$Style.prototype.constructor = $c_Lscalacss_internal_CssEntry$Style;
/** @constructor */
function $h_Lscalacss_internal_CssEntry$Style() {
  /*<skip>*/
}
$h_Lscalacss_internal_CssEntry$Style.prototype = $c_Lscalacss_internal_CssEntry$Style.prototype;
$c_Lscalacss_internal_CssEntry$Style.prototype.productPrefix__T = (function() {
  return "Style"
});
$c_Lscalacss_internal_CssEntry$Style.prototype.productArity__I = (function() {
  return 3
});
$c_Lscalacss_internal_CssEntry$Style.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_CssEntry$Style__f_mq;
      break
    }
    case 1: {
      return this.Lscalacss_internal_CssEntry$Style__f_sel;
      break
    }
    case 2: {
      return this.Lscalacss_internal_CssEntry$Style__f_content;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_CssEntry$Style.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_CssEntry$Style.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_CssEntry$Style.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_CssEntry$Style.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_CssEntry$Style)) {
    var Style$1 = $as_Lscalacss_internal_CssEntry$Style(x$1);
    var x = this.Lscalacss_internal_CssEntry$Style__f_mq;
    var x$2 = $n(Style$1).Lscalacss_internal_CssEntry$Style__f_mq;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lscalacss_internal_CssEntry$Style__f_sel === $n(Style$1).Lscalacss_internal_CssEntry$Style__f_sel))) {
      var x$3 = this.Lscalacss_internal_CssEntry$Style__f_content;
      var x$4 = $n(Style$1).Lscalacss_internal_CssEntry$Style__f_content;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(Style$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_CssEntry$Style(obj) {
  return (((obj instanceof $c_Lscalacss_internal_CssEntry$Style) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.CssEntry$Style"))
}
function $isArrayOf_Lscalacss_internal_CssEntry$Style(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_CssEntry$Style)))
}
function $asArrayOf_Lscalacss_internal_CssEntry$Style(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_CssEntry$Style(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.CssEntry$Style;", depth))
}
var $d_Lscalacss_internal_CssEntry$Style = new $TypeData().initClass({
  Lscalacss_internal_CssEntry$Style: 0
}, false, "scalacss.internal.CssEntry$Style", {
  Lscalacss_internal_CssEntry$Style: 1,
  O: 1,
  Lscalacss_internal_CssEntry: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_CssEntry$Style.prototype.$classData = $d_Lscalacss_internal_CssEntry$Style;
function $ct_Lscalacss_internal_DslBase__($thiz) {
  $m_Lscalacss_internal_PseudoType$();
  $m_Lscalacss_internal_Pseudo$();
  $m_Lscalacss_internal_Domain$();
  $thiz.Lscalacss_internal_DslBase__f_StyleS = $m_Lscalacss_internal_StyleS$();
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_DslBase() {
  this.Lscalacss_internal_DslBase__f_StyleS = null
}
$c_Lscalacss_internal_DslBase.prototype = new $h_Lscalacss_internal_AttrAliasesAndValueTRules();
$c_Lscalacss_internal_DslBase.prototype.constructor = $c_Lscalacss_internal_DslBase;
/** @constructor */
function $h_Lscalacss_internal_DslBase() {
  /*<skip>*/
}
$h_Lscalacss_internal_DslBase.prototype = $c_Lscalacss_internal_DslBase.prototype;
$c_Lscalacss_internal_DslBase.prototype.DslCond__O__F1__Lscalacss_internal_DslBase$DslCond = (function(x, f) {
  return new $c_Lscalacss_internal_DslBase$DslCond($as_Lscalacss_internal_Cond($n(f).apply__O__O(x)), this)
});
$c_Lscalacss_internal_DslBase.prototype.CondMediaQuery__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond = (function(x) {
  return new $c_Lscalacss_internal_Cond($m_s_None$(), $m_Lscalacss_internal_package$().Vector1__O__sci_Vector(x))
});
$c_Lscalacss_internal_DslBase.prototype.ToStyleAV__Lscalacss_internal_AV__Lscalacss_internal_StyleS = (function(x) {
  var x$1 = $m_Lscalacss_internal_AVs$().apply__Lscalacss_internal_AV__sci_Seq__Lscalacss_internal_AVs(x, $m_sci_Nil$());
  return $n(this.Lscalacss_internal_DslBase__f_StyleS).data1__Lscalacss_internal_Cond__Lscalacss_internal_AVs__Lscalacss_internal_StyleS($m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty, x$1)
});
$c_Lscalacss_internal_DslBase.prototype.ToStyleUnsafeExt__Lscalacss_internal_Style$UnsafeExt__Lscalacss_internal_StyleS = (function(x) {
  return this.ToStyleUnsafeExts__sci_Vector__Lscalacss_internal_StyleS($m_Lscalacss_internal_package$().Vector1__O__sci_Vector(x))
});
$c_Lscalacss_internal_DslBase.prototype.ToStyleUnsafeExts__sci_Vector__Lscalacss_internal_StyleS = (function(x) {
  var this$1 = $n($n(this.Lscalacss_internal_DslBase__f_StyleS).Lscalacss_internal_StyleS$__f_empty);
  var x$2 = this$1.Lscalacss_internal_StyleS__f_data;
  var this$2 = $n($n(this.Lscalacss_internal_DslBase__f_StyleS).Lscalacss_internal_StyleS$__f_empty);
  var x$3 = this$2.Lscalacss_internal_StyleS__f_className;
  var this$3 = $n($n(this.Lscalacss_internal_DslBase__f_StyleS).Lscalacss_internal_StyleS$__f_empty);
  var x$4 = this$3.Lscalacss_internal_StyleS__f_addClassNames;
  var this$4 = $n($n(this.Lscalacss_internal_DslBase__f_StyleS).Lscalacss_internal_StyleS$__f_empty);
  var x$5 = this$4.Lscalacss_internal_StyleS__f_warnings;
  $n($n(this.Lscalacss_internal_DslBase__f_StyleS).Lscalacss_internal_StyleS$__f_empty);
  return new $c_Lscalacss_internal_StyleS(x$2, x, x$3, x$4, x$5)
});
$c_Lscalacss_internal_DslBase.prototype.unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt = (function(f, t, c) {
  return new $c_Lscalacss_internal_Style$UnsafeExt(f, $m_Lscalacss_internal_Cond$().Lscalacss_internal_Cond$__f_empty, this.styleS__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c))
});
$c_Lscalacss_internal_DslBase.prototype.unsafeChild__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt = (function(n, t, c) {
  return this.unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_T(x$3$2);
    return ((x$3 + " ") + n)
  })), t, c)
});
$c_Lscalacss_internal_DslBase.prototype.unsafeRoot__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt = (function(sel, t, c) {
  return this.unsafeExt__F1__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_Style$UnsafeExt(new $c_sjsr_AnonFunction1(((x$4$2) => {
    $as_T(x$4$2);
    return sel
  })), t, c)
});
$c_Lscalacss_internal_DslBase.prototype.mkColor__T__O = (function(s) {
  return new $c_Lscalacss_internal_ValueT(s)
});
function $as_Lscalacss_internal_DslBase(obj) {
  return (((obj instanceof $c_Lscalacss_internal_DslBase) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.DslBase"))
}
function $isArrayOf_Lscalacss_internal_DslBase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_DslBase)))
}
function $asArrayOf_Lscalacss_internal_DslBase(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_DslBase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.DslBase;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_LengthUnit$cm$() {
  this.Lscalacss_internal_LengthUnit__f_value = null;
  $ct_Lscalacss_internal_LengthUnit__T__(this, "cm")
}
$c_Lscalacss_internal_LengthUnit$cm$.prototype = new $h_Lscalacss_internal_LengthUnit();
$c_Lscalacss_internal_LengthUnit$cm$.prototype.constructor = $c_Lscalacss_internal_LengthUnit$cm$;
/** @constructor */
function $h_Lscalacss_internal_LengthUnit$cm$() {
  /*<skip>*/
}
$h_Lscalacss_internal_LengthUnit$cm$.prototype = $c_Lscalacss_internal_LengthUnit$cm$.prototype;
$c_Lscalacss_internal_LengthUnit$cm$.prototype.productPrefix__T = (function() {
  return "cm"
});
$c_Lscalacss_internal_LengthUnit$cm$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_LengthUnit$cm$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_LengthUnit$cm$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_LengthUnit$cm$.prototype.hashCode__I = (function() {
  return 3178
});
$c_Lscalacss_internal_LengthUnit$cm$.prototype.toString__T = (function() {
  return "cm"
});
var $d_Lscalacss_internal_LengthUnit$cm$ = new $TypeData().initClass({
  Lscalacss_internal_LengthUnit$cm$: 0
}, false, "scalacss.internal.LengthUnit$cm$", {
  Lscalacss_internal_LengthUnit$cm$: 1,
  Lscalacss_internal_LengthUnit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_LengthUnit$cm$.prototype.$classData = $d_Lscalacss_internal_LengthUnit$cm$;
var $n_Lscalacss_internal_LengthUnit$cm$;
function $m_Lscalacss_internal_LengthUnit$cm$() {
  if ((!$n_Lscalacss_internal_LengthUnit$cm$)) {
    $n_Lscalacss_internal_LengthUnit$cm$ = new $c_Lscalacss_internal_LengthUnit$cm$()
  };
  return $n_Lscalacss_internal_LengthUnit$cm$
}
/** @constructor */
function $c_Lscalacss_internal_LengthUnit$em$() {
  this.Lscalacss_internal_LengthUnit__f_value = null;
  $ct_Lscalacss_internal_LengthUnit__T__(this, "em")
}
$c_Lscalacss_internal_LengthUnit$em$.prototype = new $h_Lscalacss_internal_LengthUnit();
$c_Lscalacss_internal_LengthUnit$em$.prototype.constructor = $c_Lscalacss_internal_LengthUnit$em$;
/** @constructor */
function $h_Lscalacss_internal_LengthUnit$em$() {
  /*<skip>*/
}
$h_Lscalacss_internal_LengthUnit$em$.prototype = $c_Lscalacss_internal_LengthUnit$em$.prototype;
$c_Lscalacss_internal_LengthUnit$em$.prototype.productPrefix__T = (function() {
  return "em"
});
$c_Lscalacss_internal_LengthUnit$em$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_LengthUnit$em$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_LengthUnit$em$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_LengthUnit$em$.prototype.hashCode__I = (function() {
  return 3240
});
$c_Lscalacss_internal_LengthUnit$em$.prototype.toString__T = (function() {
  return "em"
});
var $d_Lscalacss_internal_LengthUnit$em$ = new $TypeData().initClass({
  Lscalacss_internal_LengthUnit$em$: 0
}, false, "scalacss.internal.LengthUnit$em$", {
  Lscalacss_internal_LengthUnit$em$: 1,
  Lscalacss_internal_LengthUnit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_LengthUnit$em$.prototype.$classData = $d_Lscalacss_internal_LengthUnit$em$;
var $n_Lscalacss_internal_LengthUnit$em$;
function $m_Lscalacss_internal_LengthUnit$em$() {
  if ((!$n_Lscalacss_internal_LengthUnit$em$)) {
    $n_Lscalacss_internal_LengthUnit$em$ = new $c_Lscalacss_internal_LengthUnit$em$()
  };
  return $n_Lscalacss_internal_LengthUnit$em$
}
/** @constructor */
function $c_Lscalacss_internal_LengthUnit$mm$() {
  this.Lscalacss_internal_LengthUnit__f_value = null;
  $ct_Lscalacss_internal_LengthUnit__T__(this, "mm")
}
$c_Lscalacss_internal_LengthUnit$mm$.prototype = new $h_Lscalacss_internal_LengthUnit();
$c_Lscalacss_internal_LengthUnit$mm$.prototype.constructor = $c_Lscalacss_internal_LengthUnit$mm$;
/** @constructor */
function $h_Lscalacss_internal_LengthUnit$mm$() {
  /*<skip>*/
}
$h_Lscalacss_internal_LengthUnit$mm$.prototype = $c_Lscalacss_internal_LengthUnit$mm$.prototype;
$c_Lscalacss_internal_LengthUnit$mm$.prototype.productPrefix__T = (function() {
  return "mm"
});
$c_Lscalacss_internal_LengthUnit$mm$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_LengthUnit$mm$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_LengthUnit$mm$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_LengthUnit$mm$.prototype.hashCode__I = (function() {
  return 3488
});
$c_Lscalacss_internal_LengthUnit$mm$.prototype.toString__T = (function() {
  return "mm"
});
var $d_Lscalacss_internal_LengthUnit$mm$ = new $TypeData().initClass({
  Lscalacss_internal_LengthUnit$mm$: 0
}, false, "scalacss.internal.LengthUnit$mm$", {
  Lscalacss_internal_LengthUnit$mm$: 1,
  Lscalacss_internal_LengthUnit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_LengthUnit$mm$.prototype.$classData = $d_Lscalacss_internal_LengthUnit$mm$;
var $n_Lscalacss_internal_LengthUnit$mm$;
function $m_Lscalacss_internal_LengthUnit$mm$() {
  if ((!$n_Lscalacss_internal_LengthUnit$mm$)) {
    $n_Lscalacss_internal_LengthUnit$mm$ = new $c_Lscalacss_internal_LengthUnit$mm$()
  };
  return $n_Lscalacss_internal_LengthUnit$mm$
}
/** @constructor */
function $c_Lscalacss_internal_LengthUnit$pt$() {
  this.Lscalacss_internal_LengthUnit__f_value = null;
  $ct_Lscalacss_internal_LengthUnit__T__(this, "pt")
}
$c_Lscalacss_internal_LengthUnit$pt$.prototype = new $h_Lscalacss_internal_LengthUnit();
$c_Lscalacss_internal_LengthUnit$pt$.prototype.constructor = $c_Lscalacss_internal_LengthUnit$pt$;
/** @constructor */
function $h_Lscalacss_internal_LengthUnit$pt$() {
  /*<skip>*/
}
$h_Lscalacss_internal_LengthUnit$pt$.prototype = $c_Lscalacss_internal_LengthUnit$pt$.prototype;
$c_Lscalacss_internal_LengthUnit$pt$.prototype.productPrefix__T = (function() {
  return "pt"
});
$c_Lscalacss_internal_LengthUnit$pt$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_LengthUnit$pt$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_LengthUnit$pt$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_LengthUnit$pt$.prototype.hashCode__I = (function() {
  return 3588
});
$c_Lscalacss_internal_LengthUnit$pt$.prototype.toString__T = (function() {
  return "pt"
});
var $d_Lscalacss_internal_LengthUnit$pt$ = new $TypeData().initClass({
  Lscalacss_internal_LengthUnit$pt$: 0
}, false, "scalacss.internal.LengthUnit$pt$", {
  Lscalacss_internal_LengthUnit$pt$: 1,
  Lscalacss_internal_LengthUnit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_LengthUnit$pt$.prototype.$classData = $d_Lscalacss_internal_LengthUnit$pt$;
var $n_Lscalacss_internal_LengthUnit$pt$;
function $m_Lscalacss_internal_LengthUnit$pt$() {
  if ((!$n_Lscalacss_internal_LengthUnit$pt$)) {
    $n_Lscalacss_internal_LengthUnit$pt$ = new $c_Lscalacss_internal_LengthUnit$pt$()
  };
  return $n_Lscalacss_internal_LengthUnit$pt$
}
/** @constructor */
function $c_Lscalacss_internal_LengthUnit$px$() {
  this.Lscalacss_internal_LengthUnit__f_value = null;
  $ct_Lscalacss_internal_LengthUnit__T__(this, "px")
}
$c_Lscalacss_internal_LengthUnit$px$.prototype = new $h_Lscalacss_internal_LengthUnit();
$c_Lscalacss_internal_LengthUnit$px$.prototype.constructor = $c_Lscalacss_internal_LengthUnit$px$;
/** @constructor */
function $h_Lscalacss_internal_LengthUnit$px$() {
  /*<skip>*/
}
$h_Lscalacss_internal_LengthUnit$px$.prototype = $c_Lscalacss_internal_LengthUnit$px$.prototype;
$c_Lscalacss_internal_LengthUnit$px$.prototype.productPrefix__T = (function() {
  return "px"
});
$c_Lscalacss_internal_LengthUnit$px$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_LengthUnit$px$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_LengthUnit$px$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_LengthUnit$px$.prototype.hashCode__I = (function() {
  return 3592
});
$c_Lscalacss_internal_LengthUnit$px$.prototype.toString__T = (function() {
  return "px"
});
var $d_Lscalacss_internal_LengthUnit$px$ = new $TypeData().initClass({
  Lscalacss_internal_LengthUnit$px$: 0
}, false, "scalacss.internal.LengthUnit$px$", {
  Lscalacss_internal_LengthUnit$px$: 1,
  Lscalacss_internal_LengthUnit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_LengthUnit$px$.prototype.$classData = $d_Lscalacss_internal_LengthUnit$px$;
var $n_Lscalacss_internal_LengthUnit$px$;
function $m_Lscalacss_internal_LengthUnit$px$() {
  if ((!$n_Lscalacss_internal_LengthUnit$px$)) {
    $n_Lscalacss_internal_LengthUnit$px$ = new $c_Lscalacss_internal_LengthUnit$px$()
  };
  return $n_Lscalacss_internal_LengthUnit$px$
}
/** @constructor */
function $c_Lscalacss_internal_LengthUnit$rem$() {
  this.Lscalacss_internal_LengthUnit__f_value = null;
  $ct_Lscalacss_internal_LengthUnit__T__(this, "rem")
}
$c_Lscalacss_internal_LengthUnit$rem$.prototype = new $h_Lscalacss_internal_LengthUnit();
$c_Lscalacss_internal_LengthUnit$rem$.prototype.constructor = $c_Lscalacss_internal_LengthUnit$rem$;
/** @constructor */
function $h_Lscalacss_internal_LengthUnit$rem$() {
  /*<skip>*/
}
$h_Lscalacss_internal_LengthUnit$rem$.prototype = $c_Lscalacss_internal_LengthUnit$rem$.prototype;
$c_Lscalacss_internal_LengthUnit$rem$.prototype.productPrefix__T = (function() {
  return "rem"
});
$c_Lscalacss_internal_LengthUnit$rem$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_LengthUnit$rem$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_LengthUnit$rem$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_LengthUnit$rem$.prototype.hashCode__I = (function() {
  return 112794
});
$c_Lscalacss_internal_LengthUnit$rem$.prototype.toString__T = (function() {
  return "rem"
});
var $d_Lscalacss_internal_LengthUnit$rem$ = new $TypeData().initClass({
  Lscalacss_internal_LengthUnit$rem$: 0
}, false, "scalacss.internal.LengthUnit$rem$", {
  Lscalacss_internal_LengthUnit$rem$: 1,
  Lscalacss_internal_LengthUnit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_LengthUnit$rem$.prototype.$classData = $d_Lscalacss_internal_LengthUnit$rem$;
var $n_Lscalacss_internal_LengthUnit$rem$;
function $m_Lscalacss_internal_LengthUnit$rem$() {
  if ((!$n_Lscalacss_internal_LengthUnit$rem$)) {
    $n_Lscalacss_internal_LengthUnit$rem$ = new $c_Lscalacss_internal_LengthUnit$rem$()
  };
  return $n_Lscalacss_internal_LengthUnit$rem$
}
/** @constructor */
function $c_Lscalacss_internal_LengthUnit$vh$() {
  this.Lscalacss_internal_LengthUnit__f_value = null;
  $ct_Lscalacss_internal_LengthUnit__T__(this, "vh")
}
$c_Lscalacss_internal_LengthUnit$vh$.prototype = new $h_Lscalacss_internal_LengthUnit();
$c_Lscalacss_internal_LengthUnit$vh$.prototype.constructor = $c_Lscalacss_internal_LengthUnit$vh$;
/** @constructor */
function $h_Lscalacss_internal_LengthUnit$vh$() {
  /*<skip>*/
}
$h_Lscalacss_internal_LengthUnit$vh$.prototype = $c_Lscalacss_internal_LengthUnit$vh$.prototype;
$c_Lscalacss_internal_LengthUnit$vh$.prototype.productPrefix__T = (function() {
  return "vh"
});
$c_Lscalacss_internal_LengthUnit$vh$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_LengthUnit$vh$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_LengthUnit$vh$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_LengthUnit$vh$.prototype.hashCode__I = (function() {
  return 3762
});
$c_Lscalacss_internal_LengthUnit$vh$.prototype.toString__T = (function() {
  return "vh"
});
var $d_Lscalacss_internal_LengthUnit$vh$ = new $TypeData().initClass({
  Lscalacss_internal_LengthUnit$vh$: 0
}, false, "scalacss.internal.LengthUnit$vh$", {
  Lscalacss_internal_LengthUnit$vh$: 1,
  Lscalacss_internal_LengthUnit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_LengthUnit$vh$.prototype.$classData = $d_Lscalacss_internal_LengthUnit$vh$;
var $n_Lscalacss_internal_LengthUnit$vh$;
function $m_Lscalacss_internal_LengthUnit$vh$() {
  if ((!$n_Lscalacss_internal_LengthUnit$vh$)) {
    $n_Lscalacss_internal_LengthUnit$vh$ = new $c_Lscalacss_internal_LengthUnit$vh$()
  };
  return $n_Lscalacss_internal_LengthUnit$vh$
}
/** @constructor */
function $c_Lscalacss_internal_LengthUnit$vw$() {
  this.Lscalacss_internal_LengthUnit__f_value = null;
  $ct_Lscalacss_internal_LengthUnit__T__(this, "vw")
}
$c_Lscalacss_internal_LengthUnit$vw$.prototype = new $h_Lscalacss_internal_LengthUnit();
$c_Lscalacss_internal_LengthUnit$vw$.prototype.constructor = $c_Lscalacss_internal_LengthUnit$vw$;
/** @constructor */
function $h_Lscalacss_internal_LengthUnit$vw$() {
  /*<skip>*/
}
$h_Lscalacss_internal_LengthUnit$vw$.prototype = $c_Lscalacss_internal_LengthUnit$vw$.prototype;
$c_Lscalacss_internal_LengthUnit$vw$.prototype.productPrefix__T = (function() {
  return "vw"
});
$c_Lscalacss_internal_LengthUnit$vw$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_LengthUnit$vw$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_LengthUnit$vw$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_LengthUnit$vw$.prototype.hashCode__I = (function() {
  return 3777
});
$c_Lscalacss_internal_LengthUnit$vw$.prototype.toString__T = (function() {
  return "vw"
});
var $d_Lscalacss_internal_LengthUnit$vw$ = new $TypeData().initClass({
  Lscalacss_internal_LengthUnit$vw$: 0
}, false, "scalacss.internal.LengthUnit$vw$", {
  Lscalacss_internal_LengthUnit$vw$: 1,
  Lscalacss_internal_LengthUnit: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_LengthUnit$vw$.prototype.$classData = $d_Lscalacss_internal_LengthUnit$vw$;
var $n_Lscalacss_internal_LengthUnit$vw$;
function $m_Lscalacss_internal_LengthUnit$vw$() {
  if ((!$n_Lscalacss_internal_LengthUnit$vw$)) {
    $n_Lscalacss_internal_LengthUnit$vw$ = new $c_Lscalacss_internal_LengthUnit$vw$()
  };
  return $n_Lscalacss_internal_LengthUnit$vw$
}
function $as_Lscalacss_internal_Media$AspectRatio(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$AspectRatio"))
}
function $isArrayOf_Lscalacss_internal_Media$AspectRatio(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$AspectRatio)))
}
function $asArrayOf_Lscalacss_internal_Media$AspectRatio(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$AspectRatio(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$AspectRatio;", depth))
}
function $as_Lscalacss_internal_Media$Color(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Color"))
}
function $isArrayOf_Lscalacss_internal_Media$Color(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Color)))
}
function $asArrayOf_Lscalacss_internal_Media$Color(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Color(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Color;", depth))
}
function $as_Lscalacss_internal_Media$ColorIndex(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$ColorIndex"))
}
function $isArrayOf_Lscalacss_internal_Media$ColorIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$ColorIndex)))
}
function $asArrayOf_Lscalacss_internal_Media$ColorIndex(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$ColorIndex(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$ColorIndex;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_Media$Dark$() {
  this.Lscalacss_internal_Media$PrefersColorSchemeValue__f_value = null;
  $ct_Lscalacss_internal_Media$PrefersColorSchemeValue__T__(this, "dark")
}
$c_Lscalacss_internal_Media$Dark$.prototype = new $h_Lscalacss_internal_Media$PrefersColorSchemeValue();
$c_Lscalacss_internal_Media$Dark$.prototype.constructor = $c_Lscalacss_internal_Media$Dark$;
/** @constructor */
function $h_Lscalacss_internal_Media$Dark$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Dark$.prototype = $c_Lscalacss_internal_Media$Dark$.prototype;
$c_Lscalacss_internal_Media$Dark$.prototype.productPrefix__T = (function() {
  return "Dark"
});
$c_Lscalacss_internal_Media$Dark$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Media$Dark$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Media$Dark$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Dark$.prototype.hashCode__I = (function() {
  return 2122646
});
$c_Lscalacss_internal_Media$Dark$.prototype.toString__T = (function() {
  return "Dark"
});
var $d_Lscalacss_internal_Media$Dark$ = new $TypeData().initClass({
  Lscalacss_internal_Media$Dark$: 0
}, false, "scalacss.internal.Media$Dark$", {
  Lscalacss_internal_Media$Dark$: 1,
  Lscalacss_internal_Media$PrefersColorSchemeValue: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Dark$.prototype.$classData = $d_Lscalacss_internal_Media$Dark$;
var $n_Lscalacss_internal_Media$Dark$;
function $m_Lscalacss_internal_Media$Dark$() {
  if ((!$n_Lscalacss_internal_Media$Dark$)) {
    $n_Lscalacss_internal_Media$Dark$ = new $c_Lscalacss_internal_Media$Dark$()
  };
  return $n_Lscalacss_internal_Media$Dark$
}
function $as_Lscalacss_internal_Media$DeviceAspectRatio(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$DeviceAspectRatio"))
}
function $isArrayOf_Lscalacss_internal_Media$DeviceAspectRatio(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$DeviceAspectRatio)))
}
function $asArrayOf_Lscalacss_internal_Media$DeviceAspectRatio(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$DeviceAspectRatio(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$DeviceAspectRatio;", depth))
}
function $as_Lscalacss_internal_Media$DeviceHeight(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$DeviceHeight"))
}
function $isArrayOf_Lscalacss_internal_Media$DeviceHeight(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$DeviceHeight)))
}
function $asArrayOf_Lscalacss_internal_Media$DeviceHeight(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$DeviceHeight(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$DeviceHeight;", depth))
}
function $as_Lscalacss_internal_Media$DeviceWidth(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$DeviceWidth"))
}
function $isArrayOf_Lscalacss_internal_Media$DeviceWidth(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$DeviceWidth)))
}
function $asArrayOf_Lscalacss_internal_Media$DeviceWidth(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$DeviceWidth(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$DeviceWidth;", depth))
}
function $as_Lscalacss_internal_Media$Eql(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Eql"))
}
function $isArrayOf_Lscalacss_internal_Media$Eql(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Eql)))
}
function $asArrayOf_Lscalacss_internal_Media$Eql(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Eql(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Eql;", depth))
}
function $as_Lscalacss_internal_Media$Grid(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Grid"))
}
function $isArrayOf_Lscalacss_internal_Media$Grid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Grid)))
}
function $asArrayOf_Lscalacss_internal_Media$Grid(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Grid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Grid;", depth))
}
function $as_Lscalacss_internal_Media$Height(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Height"))
}
function $isArrayOf_Lscalacss_internal_Media$Height(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Height)))
}
function $asArrayOf_Lscalacss_internal_Media$Height(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Height(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Height;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_Media$Just(t) {
  this.Lscalacss_internal_Media$Just__f_t = null;
  this.Lscalacss_internal_Media$Just__f_t = t
}
$c_Lscalacss_internal_Media$Just.prototype = new $h_O();
$c_Lscalacss_internal_Media$Just.prototype.constructor = $c_Lscalacss_internal_Media$Just;
/** @constructor */
function $h_Lscalacss_internal_Media$Just() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Just.prototype = $c_Lscalacss_internal_Media$Just.prototype;
$c_Lscalacss_internal_Media$Just.prototype.productPrefix__T = (function() {
  return "Just"
});
$c_Lscalacss_internal_Media$Just.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_Media$Just.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_Media$Just__f_t : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_Media$Just.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Just.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Media$Just.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Media$Just.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Media$Just)) {
    var Just$1 = $as_Lscalacss_internal_Media$Just(x$1);
    var x = this.Lscalacss_internal_Media$Just__f_t;
    var x$2 = $n(Just$1).Lscalacss_internal_Media$Just__f_t;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      $n(Just$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Media$Just(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Media$Just) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Just"))
}
function $isArrayOf_Lscalacss_internal_Media$Just(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Just)))
}
function $asArrayOf_Lscalacss_internal_Media$Just(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Just(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Just;", depth))
}
var $d_Lscalacss_internal_Media$Just = new $TypeData().initClass({
  Lscalacss_internal_Media$Just: 0
}, false, "scalacss.internal.Media$Just", {
  Lscalacss_internal_Media$Just: 1,
  O: 1,
  Lscalacss_internal_Media$TypeExpr: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Just.prototype.$classData = $d_Lscalacss_internal_Media$Just;
/** @constructor */
function $c_Lscalacss_internal_Media$Landscape$() {
  this.Lscalacss_internal_Media$OrientationValue__f_value = null;
  $ct_Lscalacss_internal_Media$OrientationValue__T__(this, "landscape")
}
$c_Lscalacss_internal_Media$Landscape$.prototype = new $h_Lscalacss_internal_Media$OrientationValue();
$c_Lscalacss_internal_Media$Landscape$.prototype.constructor = $c_Lscalacss_internal_Media$Landscape$;
/** @constructor */
function $h_Lscalacss_internal_Media$Landscape$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Landscape$.prototype = $c_Lscalacss_internal_Media$Landscape$.prototype;
$c_Lscalacss_internal_Media$Landscape$.prototype.productPrefix__T = (function() {
  return "Landscape"
});
$c_Lscalacss_internal_Media$Landscape$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Media$Landscape$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Media$Landscape$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Landscape$.prototype.hashCode__I = (function() {
  return (-860351845)
});
$c_Lscalacss_internal_Media$Landscape$.prototype.toString__T = (function() {
  return "Landscape"
});
var $d_Lscalacss_internal_Media$Landscape$ = new $TypeData().initClass({
  Lscalacss_internal_Media$Landscape$: 0
}, false, "scalacss.internal.Media$Landscape$", {
  Lscalacss_internal_Media$Landscape$: 1,
  Lscalacss_internal_Media$OrientationValue: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Landscape$.prototype.$classData = $d_Lscalacss_internal_Media$Landscape$;
var $n_Lscalacss_internal_Media$Landscape$;
function $m_Lscalacss_internal_Media$Landscape$() {
  if ((!$n_Lscalacss_internal_Media$Landscape$)) {
    $n_Lscalacss_internal_Media$Landscape$ = new $c_Lscalacss_internal_Media$Landscape$()
  };
  return $n_Lscalacss_internal_Media$Landscape$
}
/** @constructor */
function $c_Lscalacss_internal_Media$Max(max) {
  this.Lscalacss_internal_Media$Max__f_max = null;
  this.Lscalacss_internal_Media$Max__f_max = max
}
$c_Lscalacss_internal_Media$Max.prototype = new $h_O();
$c_Lscalacss_internal_Media$Max.prototype.constructor = $c_Lscalacss_internal_Media$Max;
/** @constructor */
function $h_Lscalacss_internal_Media$Max() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Max.prototype = $c_Lscalacss_internal_Media$Max.prototype;
$c_Lscalacss_internal_Media$Max.prototype.productPrefix__T = (function() {
  return "Max"
});
$c_Lscalacss_internal_Media$Max.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_Media$Max.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_Media$Max__f_max : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_Media$Max.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Max.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Media$Max.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Media$Max.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Media$Max)) {
    var Max$1 = $as_Lscalacss_internal_Media$Max(x$1);
    var x = this.Lscalacss_internal_Media$Max__f_max;
    var y = $n(Max$1).Lscalacss_internal_Media$Max__f_max;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(Max$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Media$Max(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Media$Max) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Max"))
}
function $isArrayOf_Lscalacss_internal_Media$Max(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Max)))
}
function $asArrayOf_Lscalacss_internal_Media$Max(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Max(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Max;", depth))
}
var $d_Lscalacss_internal_Media$Max = new $TypeData().initClass({
  Lscalacss_internal_Media$Max: 0
}, false, "scalacss.internal.Media$Max", {
  Lscalacss_internal_Media$Max: 1,
  O: 1,
  Lscalacss_internal_Media$ValueExpr: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Max.prototype.$classData = $d_Lscalacss_internal_Media$Max;
/** @constructor */
function $c_Lscalacss_internal_Media$Min(min) {
  this.Lscalacss_internal_Media$Min__f_min = null;
  this.Lscalacss_internal_Media$Min__f_min = min
}
$c_Lscalacss_internal_Media$Min.prototype = new $h_O();
$c_Lscalacss_internal_Media$Min.prototype.constructor = $c_Lscalacss_internal_Media$Min;
/** @constructor */
function $h_Lscalacss_internal_Media$Min() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Min.prototype = $c_Lscalacss_internal_Media$Min.prototype;
$c_Lscalacss_internal_Media$Min.prototype.productPrefix__T = (function() {
  return "Min"
});
$c_Lscalacss_internal_Media$Min.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_Media$Min.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_Media$Min__f_min : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_Media$Min.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Min.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Media$Min.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Media$Min.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Media$Min)) {
    var Min$1 = $as_Lscalacss_internal_Media$Min(x$1);
    var x = this.Lscalacss_internal_Media$Min__f_min;
    var y = $n(Min$1).Lscalacss_internal_Media$Min__f_min;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(Min$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Media$Min(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Media$Min) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Min"))
}
function $isArrayOf_Lscalacss_internal_Media$Min(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Min)))
}
function $asArrayOf_Lscalacss_internal_Media$Min(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Min(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Min;", depth))
}
var $d_Lscalacss_internal_Media$Min = new $TypeData().initClass({
  Lscalacss_internal_Media$Min: 0
}, false, "scalacss.internal.Media$Min", {
  Lscalacss_internal_Media$Min: 1,
  O: 1,
  Lscalacss_internal_Media$ValueExpr: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Min.prototype.$classData = $d_Lscalacss_internal_Media$Min;
function $as_Lscalacss_internal_Media$Monochrome(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Monochrome"))
}
function $isArrayOf_Lscalacss_internal_Media$Monochrome(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Monochrome)))
}
function $asArrayOf_Lscalacss_internal_Media$Monochrome(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Monochrome(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Monochrome;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_Media$Not(t) {
  this.Lscalacss_internal_Media$Not__f_t = null;
  this.Lscalacss_internal_Media$Not__f_t = t
}
$c_Lscalacss_internal_Media$Not.prototype = new $h_O();
$c_Lscalacss_internal_Media$Not.prototype.constructor = $c_Lscalacss_internal_Media$Not;
/** @constructor */
function $h_Lscalacss_internal_Media$Not() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Not.prototype = $c_Lscalacss_internal_Media$Not.prototype;
$c_Lscalacss_internal_Media$Not.prototype.productPrefix__T = (function() {
  return "Not"
});
$c_Lscalacss_internal_Media$Not.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_Media$Not.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_Media$Not__f_t : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_Media$Not.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Not.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Media$Not.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Media$Not.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Media$Not)) {
    var Not$1 = $as_Lscalacss_internal_Media$Not(x$1);
    var x = this.Lscalacss_internal_Media$Not__f_t;
    var x$2 = $n(Not$1).Lscalacss_internal_Media$Not__f_t;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      $n(Not$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Media$Not(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Media$Not) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Not"))
}
function $isArrayOf_Lscalacss_internal_Media$Not(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Not)))
}
function $asArrayOf_Lscalacss_internal_Media$Not(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Not(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Not;", depth))
}
var $d_Lscalacss_internal_Media$Not = new $TypeData().initClass({
  Lscalacss_internal_Media$Not: 0
}, false, "scalacss.internal.Media$Not", {
  Lscalacss_internal_Media$Not: 1,
  O: 1,
  Lscalacss_internal_Media$TypeExpr: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Not.prototype.$classData = $d_Lscalacss_internal_Media$Not;
function $as_Lscalacss_internal_Media$Only(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Only"))
}
function $isArrayOf_Lscalacss_internal_Media$Only(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Only)))
}
function $asArrayOf_Lscalacss_internal_Media$Only(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Only(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Only;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_Media$Orientation(value) {
  this.Lscalacss_internal_Media$Orientation__f_value = null;
  this.Lscalacss_internal_Media$Orientation__f_value = value
}
$c_Lscalacss_internal_Media$Orientation.prototype = new $h_O();
$c_Lscalacss_internal_Media$Orientation.prototype.constructor = $c_Lscalacss_internal_Media$Orientation;
/** @constructor */
function $h_Lscalacss_internal_Media$Orientation() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Orientation.prototype = $c_Lscalacss_internal_Media$Orientation.prototype;
$c_Lscalacss_internal_Media$Orientation.prototype.productPrefix__T = (function() {
  return "Orientation"
});
$c_Lscalacss_internal_Media$Orientation.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_Media$Orientation.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_Media$Orientation__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_Media$Orientation.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Orientation.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Media$Orientation.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Media$Orientation.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Media$Orientation)) {
    var Orientation$1 = $as_Lscalacss_internal_Media$Orientation(x$1);
    var x = this.Lscalacss_internal_Media$Orientation__f_value;
    var x$2 = $n(Orientation$1).Lscalacss_internal_Media$Orientation__f_value;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      $n(Orientation$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Media$Orientation(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Media$Orientation) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Orientation"))
}
function $isArrayOf_Lscalacss_internal_Media$Orientation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Orientation)))
}
function $asArrayOf_Lscalacss_internal_Media$Orientation(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Orientation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Orientation;", depth))
}
var $d_Lscalacss_internal_Media$Orientation = new $TypeData().initClass({
  Lscalacss_internal_Media$Orientation: 0
}, false, "scalacss.internal.Media$Orientation", {
  Lscalacss_internal_Media$Orientation: 1,
  O: 1,
  Lscalacss_internal_Media$Feature: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Orientation.prototype.$classData = $d_Lscalacss_internal_Media$Orientation;
/** @constructor */
function $c_Lscalacss_internal_Media$Portrait$() {
  this.Lscalacss_internal_Media$OrientationValue__f_value = null;
  $ct_Lscalacss_internal_Media$OrientationValue__T__(this, "portrait")
}
$c_Lscalacss_internal_Media$Portrait$.prototype = new $h_Lscalacss_internal_Media$OrientationValue();
$c_Lscalacss_internal_Media$Portrait$.prototype.constructor = $c_Lscalacss_internal_Media$Portrait$;
/** @constructor */
function $h_Lscalacss_internal_Media$Portrait$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Portrait$.prototype = $c_Lscalacss_internal_Media$Portrait$.prototype;
$c_Lscalacss_internal_Media$Portrait$.prototype.productPrefix__T = (function() {
  return "Portrait"
});
$c_Lscalacss_internal_Media$Portrait$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Media$Portrait$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Media$Portrait$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Portrait$.prototype.hashCode__I = (function() {
  return 793911227
});
$c_Lscalacss_internal_Media$Portrait$.prototype.toString__T = (function() {
  return "Portrait"
});
var $d_Lscalacss_internal_Media$Portrait$ = new $TypeData().initClass({
  Lscalacss_internal_Media$Portrait$: 0
}, false, "scalacss.internal.Media$Portrait$", {
  Lscalacss_internal_Media$Portrait$: 1,
  Lscalacss_internal_Media$OrientationValue: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Portrait$.prototype.$classData = $d_Lscalacss_internal_Media$Portrait$;
var $n_Lscalacss_internal_Media$Portrait$;
function $m_Lscalacss_internal_Media$Portrait$() {
  if ((!$n_Lscalacss_internal_Media$Portrait$)) {
    $n_Lscalacss_internal_Media$Portrait$ = new $c_Lscalacss_internal_Media$Portrait$()
  };
  return $n_Lscalacss_internal_Media$Portrait$
}
/** @constructor */
function $c_Lscalacss_internal_Media$PrefersColorScheme(value) {
  this.Lscalacss_internal_Media$PrefersColorScheme__f_value = null;
  this.Lscalacss_internal_Media$PrefersColorScheme__f_value = value
}
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype = new $h_O();
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype.constructor = $c_Lscalacss_internal_Media$PrefersColorScheme;
/** @constructor */
function $h_Lscalacss_internal_Media$PrefersColorScheme() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$PrefersColorScheme.prototype = $c_Lscalacss_internal_Media$PrefersColorScheme.prototype;
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype.productPrefix__T = (function() {
  return "PrefersColorScheme"
});
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_Media$PrefersColorScheme__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Media$PrefersColorScheme)) {
    var PrefersColorScheme$1 = $as_Lscalacss_internal_Media$PrefersColorScheme(x$1);
    var x = this.Lscalacss_internal_Media$PrefersColorScheme__f_value;
    var x$2 = $n(PrefersColorScheme$1).Lscalacss_internal_Media$PrefersColorScheme__f_value;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      $n(PrefersColorScheme$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Media$PrefersColorScheme(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Media$PrefersColorScheme) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$PrefersColorScheme"))
}
function $isArrayOf_Lscalacss_internal_Media$PrefersColorScheme(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$PrefersColorScheme)))
}
function $asArrayOf_Lscalacss_internal_Media$PrefersColorScheme(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$PrefersColorScheme(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$PrefersColorScheme;", depth))
}
var $d_Lscalacss_internal_Media$PrefersColorScheme = new $TypeData().initClass({
  Lscalacss_internal_Media$PrefersColorScheme: 0
}, false, "scalacss.internal.Media$PrefersColorScheme", {
  Lscalacss_internal_Media$PrefersColorScheme: 1,
  O: 1,
  Lscalacss_internal_Media$Feature: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$PrefersColorScheme.prototype.$classData = $d_Lscalacss_internal_Media$PrefersColorScheme;
/** @constructor */
function $c_Lscalacss_internal_Media$Query(head, tail) {
  this.Lscalacss_internal_Media$Query__f_head = null;
  this.Lscalacss_internal_Media$Query__f_tail = null;
  this.Lscalacss_internal_Media$Query__f_cssSuffix = null;
  this.Lscalacss_internal_Media$Query__f_head = head;
  this.Lscalacss_internal_Media$Query__f_tail = tail;
  var z = $as_T($n(head).fold__F1__F1__O($m_Lscalacss_internal_Media$().Lscalacss_internal_Media$__f_cssTypeExpr, $m_Lscalacss_internal_Media$().Lscalacss_internal_Media$__f_cssFeature));
  var this$1 = $n(tail);
  var at = 0;
  var end = this$1.length__I();
  var acc = z;
  var $$x1;
  while (true) {
    if ((at !== end)) {
      var temp$at = ((1 + at) | 0);
      var arg1 = acc;
      var arg2 = this$1.apply__I__O(at);
      var x$1 = $as_T(arg1);
      var x$2 = $as_Lscalacss_internal_Media$Feature(arg2);
      var $$x2 = $m_Lscalacss_internal_Media$StringExt$();
      $m_Lscalacss_internal_Media$();
      var _s = $m_Lscalacss_internal_Media$StringExt$().$tilde$extension__T__T__T(($m_Lscalacss_internal_Media$(), x$1), ($m_Lscalacss_internal_Media$(), " and "));
      var temp$acc = $n($$x2).$tilde$extension__T__T__T(_s, $as_T($n($m_Lscalacss_internal_Media$().Lscalacss_internal_Media$__f_cssFeature).apply__O__O(x$2)));
      at = temp$at;
      acc = temp$acc;
      continue
    };
    var $$x1 = acc;
    break
  };
  this.Lscalacss_internal_Media$Query__f_cssSuffix = $as_T($$x1)
}
$c_Lscalacss_internal_Media$Query.prototype = new $h_O();
$c_Lscalacss_internal_Media$Query.prototype.constructor = $c_Lscalacss_internal_Media$Query;
/** @constructor */
function $h_Lscalacss_internal_Media$Query() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Query.prototype = $c_Lscalacss_internal_Media$Query.prototype;
$c_Lscalacss_internal_Media$Query.prototype.F__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_Lscalacss_internal_Media$Feature(f$2);
    var $$x1 = this.Lscalacss_internal_Media$Query__f_head;
    var this$2 = $n(this.Lscalacss_internal_Media$Query__f_tail);
    return new $c_Lscalacss_internal_Media$Query($$x1, $as_sci_Vector(this$2.appended__O__O(f)))
  }))
});
$c_Lscalacss_internal_Media$Query.prototype.toString__T = (function() {
  return $m_Lscalacss_internal_Media$().css__Lscalacss_internal_NonEmptyVector__T($m_Lscalacss_internal_NonEmptyVector$().one__O__Lscalacss_internal_NonEmptyVector(this))
});
$c_Lscalacss_internal_Media$Query.prototype.$plus$colon__sci_Vector__sci_Vector = (function(qs) {
  var this$1 = $n(qs);
  var res = false;
  var it = this$1.iterator__sc_Iterator();
  while (((!res) && $n(it).hasNext__Z())) {
    var arg1 = $n(it).next__O();
    var x$3 = $as_Lscalacss_internal_Media$Query(arg1);
    res = ((x$3 !== null) && $n(x$3).equals__O__Z(this))
  };
  if (res) {
    return qs
  } else {
    var this$2 = $n(qs);
    return $as_sci_Vector(this$2.appended__O__O(this))
  }
});
$c_Lscalacss_internal_Media$Query.prototype.$plus__Lscalacss_internal_Media$Query__sci_Vector = (function(q2) {
  var rassoc$1 = $m_Lscalacss_internal_package$().Vector1__O__sci_Vector(this);
  return $n(q2).$plus$colon__sci_Vector__sci_Vector(rassoc$1)
});
$c_Lscalacss_internal_Media$Query.prototype.$amp__Lscalacss_internal_Media$Query__Lscalacss_internal_Cond = (function(q2) {
  return new $c_Lscalacss_internal_Cond($m_s_None$(), this.$plus__Lscalacss_internal_Media$Query__sci_Vector(q2))
});
$c_Lscalacss_internal_Media$Query.prototype.productPrefix__T = (function() {
  return "Query"
});
$c_Lscalacss_internal_Media$Query.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_Media$Query.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_Media$Query__f_head;
      break
    }
    case 1: {
      return this.Lscalacss_internal_Media$Query__f_tail;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_Media$Query.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Query.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Media$Query.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Media$Query)) {
    var Query$1 = $as_Lscalacss_internal_Media$Query(x$1);
    var x = this.Lscalacss_internal_Media$Query__f_head;
    var x$2 = $n(Query$1).Lscalacss_internal_Media$Query__f_head;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalacss_internal_Media$Query__f_tail;
      var x$4 = $n(Query$1).Lscalacss_internal_Media$Query__f_tail;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(Query$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Media$Query(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Media$Query) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Query"))
}
function $isArrayOf_Lscalacss_internal_Media$Query(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Query)))
}
function $asArrayOf_Lscalacss_internal_Media$Query(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Query(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Query;", depth))
}
var $d_Lscalacss_internal_Media$Query = new $TypeData().initClass({
  Lscalacss_internal_Media$Query: 0
}, false, "scalacss.internal.Media$Query", {
  Lscalacss_internal_Media$Query: 1,
  O: 1,
  Lscalacss_internal_Media$FeatureOps: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Query.prototype.$classData = $d_Lscalacss_internal_Media$Query;
function $as_Lscalacss_internal_Media$Resolution(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Resolution"))
}
function $isArrayOf_Lscalacss_internal_Media$Resolution(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Resolution)))
}
function $asArrayOf_Lscalacss_internal_Media$Resolution(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Resolution(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Resolution;", depth))
}
function $as_Lscalacss_internal_Media$Scan(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Scan"))
}
function $isArrayOf_Lscalacss_internal_Media$Scan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Scan)))
}
function $asArrayOf_Lscalacss_internal_Media$Scan(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Scan(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Scan;", depth))
}
/** @constructor */
function $c_Lscalacss_internal_Media$Width(length) {
  this.Lscalacss_internal_Media$Width__f_length = null;
  this.Lscalacss_internal_Media$Width__f_length = length
}
$c_Lscalacss_internal_Media$Width.prototype = new $h_O();
$c_Lscalacss_internal_Media$Width.prototype.constructor = $c_Lscalacss_internal_Media$Width;
/** @constructor */
function $h_Lscalacss_internal_Media$Width() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Width.prototype = $c_Lscalacss_internal_Media$Width.prototype;
$c_Lscalacss_internal_Media$Width.prototype.productPrefix__T = (function() {
  return "Width"
});
$c_Lscalacss_internal_Media$Width.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalacss_internal_Media$Width.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalacss_internal_Media$Width__f_length : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalacss_internal_Media$Width.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Width.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Media$Width.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Media$Width.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Media$Width)) {
    var Width$1 = $as_Lscalacss_internal_Media$Width(x$1);
    var x = this.Lscalacss_internal_Media$Width__f_length;
    var x$2 = $n(Width$1).Lscalacss_internal_Media$Width__f_length;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Width$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Media$Width(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Media$Width) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Media$Width"))
}
function $isArrayOf_Lscalacss_internal_Media$Width(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Media$Width)))
}
function $asArrayOf_Lscalacss_internal_Media$Width(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Media$Width(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Media$Width;", depth))
}
var $d_Lscalacss_internal_Media$Width = new $TypeData().initClass({
  Lscalacss_internal_Media$Width: 0
}, false, "scalacss.internal.Media$Width", {
  Lscalacss_internal_Media$Width: 1,
  O: 1,
  Lscalacss_internal_Media$Feature: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Width.prototype.$classData = $d_Lscalacss_internal_Media$Width;
/** @constructor */
function $c_Lscalacss_internal_Percentage$mcI$sp(n$mcI$sp) {
  this.Lscalacss_internal_Percentage__f_n = null;
  this.Lscalacss_internal_Percentage$mcI$sp__f_n$mcI$sp = 0;
  this.Lscalacss_internal_Percentage$mcI$sp__f_n$mcI$sp = n$mcI$sp;
  $ct_Lscalacss_internal_Percentage__O__(this, null)
}
$c_Lscalacss_internal_Percentage$mcI$sp.prototype = new $h_Lscalacss_internal_Percentage();
$c_Lscalacss_internal_Percentage$mcI$sp.prototype.constructor = $c_Lscalacss_internal_Percentage$mcI$sp;
/** @constructor */
function $h_Lscalacss_internal_Percentage$mcI$sp() {
  /*<skip>*/
}
$h_Lscalacss_internal_Percentage$mcI$sp.prototype = $c_Lscalacss_internal_Percentage$mcI$sp.prototype;
$c_Lscalacss_internal_Percentage$mcI$sp.prototype.n__O = (function() {
  return this.Lscalacss_internal_Percentage$mcI$sp__f_n$mcI$sp
});
var $d_Lscalacss_internal_Percentage$mcI$sp = new $TypeData().initClass({
  Lscalacss_internal_Percentage$mcI$sp: 0
}, false, "scalacss.internal.Percentage$mcI$sp", {
  Lscalacss_internal_Percentage$mcI$sp: 1,
  Lscalacss_internal_Percentage: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Percentage$mcI$sp.prototype.$classData = $d_Lscalacss_internal_Percentage$mcI$sp;
/** @constructor */
function $c_Lscalacss_internal_PseudoType$Class$() {
  this.Lscalacss_internal_PseudoType__f_priority = 0;
  $ct_Lscalacss_internal_PseudoType__S__(this, 1)
}
$c_Lscalacss_internal_PseudoType$Class$.prototype = new $h_Lscalacss_internal_PseudoType();
$c_Lscalacss_internal_PseudoType$Class$.prototype.constructor = $c_Lscalacss_internal_PseudoType$Class$;
/** @constructor */
function $h_Lscalacss_internal_PseudoType$Class$() {
  /*<skip>*/
}
$h_Lscalacss_internal_PseudoType$Class$.prototype = $c_Lscalacss_internal_PseudoType$Class$.prototype;
$c_Lscalacss_internal_PseudoType$Class$.prototype.productPrefix__T = (function() {
  return "Class"
});
$c_Lscalacss_internal_PseudoType$Class$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_PseudoType$Class$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_PseudoType$Class$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_PseudoType$Class$.prototype.hashCode__I = (function() {
  return 65190232
});
$c_Lscalacss_internal_PseudoType$Class$.prototype.toString__T = (function() {
  return "Class"
});
var $d_Lscalacss_internal_PseudoType$Class$ = new $TypeData().initClass({
  Lscalacss_internal_PseudoType$Class$: 0
}, false, "scalacss.internal.PseudoType$Class$", {
  Lscalacss_internal_PseudoType$Class$: 1,
  Lscalacss_internal_PseudoType: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_PseudoType$Class$.prototype.$classData = $d_Lscalacss_internal_PseudoType$Class$;
var $n_Lscalacss_internal_PseudoType$Class$;
function $m_Lscalacss_internal_PseudoType$Class$() {
  if ((!$n_Lscalacss_internal_PseudoType$Class$)) {
    $n_Lscalacss_internal_PseudoType$Class$ = new $c_Lscalacss_internal_PseudoType$Class$()
  };
  return $n_Lscalacss_internal_PseudoType$Class$
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth.prototype = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth.prototype;
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttr\uff3fColor() {
  /*<skip>*/
}
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fColor.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT1();
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fColor.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fColor;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor.prototype = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fColor.prototype;
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fColor.prototype.mkColor__T__O = (function(s) {
  return new $c_Lscalacss_internal_AV(this.attr__Lscalacss_internal_Attr(), s)
});
/** @constructor */
function $c_Lscalatags_generic_AttrPair(a, v, ev) {
  this.Lscalatags_generic_AttrPair__f_a = null;
  this.Lscalatags_generic_AttrPair__f_v = null;
  this.Lscalatags_generic_AttrPair__f_ev = null;
  this.Lscalatags_generic_AttrPair__f_a = a;
  this.Lscalatags_generic_AttrPair__f_v = v;
  this.Lscalatags_generic_AttrPair__f_ev = ev
}
$c_Lscalatags_generic_AttrPair.prototype = new $h_O();
$c_Lscalatags_generic_AttrPair.prototype.constructor = $c_Lscalatags_generic_AttrPair;
/** @constructor */
function $h_Lscalatags_generic_AttrPair() {
  /*<skip>*/
}
$h_Lscalatags_generic_AttrPair.prototype = $c_Lscalatags_generic_AttrPair.prototype;
$c_Lscalatags_generic_AttrPair.prototype.applyTo__O__V = (function(t) {
  var this$1 = $n(this.Lscalatags_generic_AttrPair__f_ev);
  var a = this.Lscalatags_generic_AttrPair__f_a;
  var v = this.Lscalatags_generic_AttrPair__f_v;
  this$1.apply__Lorg_scalajs_dom_Element__Lscalatags_generic_Attr__O__V(t, a, v)
});
$c_Lscalatags_generic_AttrPair.prototype.productPrefix__T = (function() {
  return "AttrPair"
});
$c_Lscalatags_generic_AttrPair.prototype.productArity__I = (function() {
  return 3
});
$c_Lscalatags_generic_AttrPair.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalatags_generic_AttrPair__f_a;
      break
    }
    case 1: {
      return this.Lscalatags_generic_AttrPair__f_v;
      break
    }
    case 2: {
      return this.Lscalatags_generic_AttrPair__f_ev;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalatags_generic_AttrPair.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalatags_generic_AttrPair.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalatags_generic_AttrPair.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalatags_generic_AttrPair.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalatags_generic_AttrPair)) {
    var AttrPair$1 = $as_Lscalatags_generic_AttrPair(x$1);
    var x = this.Lscalatags_generic_AttrPair__f_a;
    var x$2 = $n(AttrPair$1).Lscalatags_generic_AttrPair__f_a;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalatags_generic_AttrPair__f_v;
      var y = $n(AttrPair$1).Lscalatags_generic_AttrPair__f_v;
      var $$x2 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3$1 = this.Lscalatags_generic_AttrPair__f_ev;
      var x$4 = $n(AttrPair$1).Lscalatags_generic_AttrPair__f_ev;
      if ((x$3$1 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3$1);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(AttrPair$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalatags_generic_AttrPair(obj) {
  return (((obj instanceof $c_Lscalatags_generic_AttrPair) || (obj === null)) ? obj : $throwClassCastException(obj, "scalatags.generic.AttrPair"))
}
function $isArrayOf_Lscalatags_generic_AttrPair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalatags_generic_AttrPair)))
}
function $asArrayOf_Lscalatags_generic_AttrPair(obj, depth) {
  return (($isArrayOf_Lscalatags_generic_AttrPair(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalatags.generic.AttrPair;", depth))
}
var $d_Lscalatags_generic_AttrPair = new $TypeData().initClass({
  Lscalatags_generic_AttrPair: 0
}, false, "scalatags.generic.AttrPair", {
  Lscalatags_generic_AttrPair: 1,
  O: 1,
  Lscalatags_generic_Modifier: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalatags_generic_AttrPair.prototype.$classData = $d_Lscalatags_generic_AttrPair;
/** @constructor */
function $c_Lshapeless_$colon$colon(head, tail) {
  this.Lshapeless_$colon$colon__f_head = null;
  this.Lshapeless_$colon$colon__f_tail = null;
  this.Lshapeless_$colon$colon__f_head = head;
  this.Lshapeless_$colon$colon__f_tail = tail
}
$c_Lshapeless_$colon$colon.prototype = new $h_O();
$c_Lshapeless_$colon$colon.prototype.constructor = $c_Lshapeless_$colon$colon;
/** @constructor */
function $h_Lshapeless_$colon$colon() {
  /*<skip>*/
}
$h_Lshapeless_$colon$colon.prototype = $c_Lshapeless_$colon$colon.prototype;
$c_Lshapeless_$colon$colon.prototype.toString__T = (function() {
  var x1 = this.Lshapeless_$colon$colon__f_head;
  return ((x1 instanceof $c_Lshapeless_$colon$colon) ? ((("(" + this.Lshapeless_$colon$colon__f_head) + ") :: ") + this.Lshapeless_$colon$colon__f_tail) : ((this.Lshapeless_$colon$colon__f_head + " :: ") + this.Lshapeless_$colon$colon__f_tail))
});
$c_Lshapeless_$colon$colon.prototype.productPrefix__T = (function() {
  return "::"
});
$c_Lshapeless_$colon$colon.prototype.productArity__I = (function() {
  return 2
});
$c_Lshapeless_$colon$colon.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lshapeless_$colon$colon__f_head;
      break
    }
    case 1: {
      return this.Lshapeless_$colon$colon__f_tail;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lshapeless_$colon$colon.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshapeless_$colon$colon.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshapeless_$colon$colon.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshapeless_$colon$colon)) {
    var \u03b4colon$colon$1 = $as_Lshapeless_$colon$colon(x$1);
    var x = this.Lshapeless_$colon$colon__f_head;
    var y = $n(\u03b4colon$colon$1).Lshapeless_$colon$colon__f_head;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lshapeless_$colon$colon__f_tail;
      var x$2$1 = $n(\u03b4colon$colon$1).Lshapeless_$colon$colon__f_tail;
      return ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lshapeless_$colon$colon(obj) {
  return (((obj instanceof $c_Lshapeless_$colon$colon) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.$colon$colon"))
}
function $isArrayOf_Lshapeless_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_$colon$colon)))
}
function $asArrayOf_Lshapeless_$colon$colon(obj, depth) {
  return (($isArrayOf_Lshapeless_$colon$colon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.$colon$colon;", depth))
}
var $d_Lshapeless_$colon$colon = new $TypeData().initClass({
  Lshapeless_$colon$colon: 0
}, false, "shapeless.$colon$colon", {
  Lshapeless_$colon$colon: 1,
  O: 1,
  Lshapeless_HList: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_$colon$colon.prototype.$classData = $d_Lshapeless_$colon$colon;
function $is_Lshapeless_$colon$plus$colon(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lshapeless_$colon$plus$colon)))
}
function $as_Lshapeless_$colon$plus$colon(obj) {
  return (($is_Lshapeless_$colon$plus$colon(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.$colon$plus$colon"))
}
function $isArrayOf_Lshapeless_$colon$plus$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_$colon$plus$colon)))
}
function $asArrayOf_Lshapeless_$colon$plus$colon(obj, depth) {
  return (($isArrayOf_Lshapeless_$colon$plus$colon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.$colon$plus$colon;", depth))
}
function $is_Lshapeless_CNil(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lshapeless_CNil)))
}
function $as_Lshapeless_CNil(obj) {
  return (($is_Lshapeless_CNil(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.CNil"))
}
function $isArrayOf_Lshapeless_CNil(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_CNil)))
}
function $asArrayOf_Lshapeless_CNil(obj, depth) {
  return (($isArrayOf_Lshapeless_CNil(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.CNil;", depth))
}
function $is_Lshapeless_HNil(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lshapeless_HNil)))
}
function $as_Lshapeless_HNil(obj) {
  return (($is_Lshapeless_HNil(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.HNil"))
}
function $isArrayOf_Lshapeless_HNil(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_HNil)))
}
function $asArrayOf_Lshapeless_HNil(obj, depth) {
  return (($isArrayOf_Lshapeless_HNil(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.HNil;", depth))
}
/** @constructor */
function $c_Lshapeless_Succ() {
  /*<skip>*/
}
$c_Lshapeless_Succ.prototype = new $h_O();
$c_Lshapeless_Succ.prototype.constructor = $c_Lshapeless_Succ;
/** @constructor */
function $h_Lshapeless_Succ() {
  /*<skip>*/
}
$h_Lshapeless_Succ.prototype = $c_Lshapeless_Succ.prototype;
$c_Lshapeless_Succ.prototype.productPrefix__T = (function() {
  return "Succ"
});
$c_Lshapeless_Succ.prototype.productArity__I = (function() {
  return 0
});
$c_Lshapeless_Succ.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lshapeless_Succ.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshapeless_Succ.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshapeless_Succ.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshapeless_Succ.prototype.equals__O__Z = (function(x$1) {
  return ((x$1 instanceof $c_Lshapeless_Succ) && ($n($as_Lshapeless_Succ(x$1)), true))
});
function $as_Lshapeless_Succ(obj) {
  return (((obj instanceof $c_Lshapeless_Succ) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.Succ"))
}
function $isArrayOf_Lshapeless_Succ(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_Succ)))
}
function $asArrayOf_Lshapeless_Succ(obj, depth) {
  return (($isArrayOf_Lshapeless_Succ(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.Succ;", depth))
}
var $d_Lshapeless_Succ = new $TypeData().initClass({
  Lshapeless_Succ: 0
}, false, "shapeless.Succ", {
  Lshapeless_Succ: 1,
  O: 1,
  Lshapeless_Nat: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Succ.prototype.$classData = $d_Lshapeless_Succ;
/** @constructor */
function $c_Lshapeless_Typeable$ValueTypeable(cB, describe) {
  this.Lshapeless_Typeable$ValueTypeable__f_cB = null;
  this.Lshapeless_Typeable$ValueTypeable__f_describe = null;
  this.Lshapeless_Typeable$ValueTypeable__f_cB = cB;
  this.Lshapeless_Typeable$ValueTypeable__f_describe = describe
}
$c_Lshapeless_Typeable$ValueTypeable.prototype = new $h_O();
$c_Lshapeless_Typeable$ValueTypeable.prototype.constructor = $c_Lshapeless_Typeable$ValueTypeable;
/** @constructor */
function $h_Lshapeless_Typeable$ValueTypeable() {
  /*<skip>*/
}
$h_Lshapeless_Typeable$ValueTypeable.prototype = $c_Lshapeless_Typeable$ValueTypeable.prototype;
$c_Lshapeless_Typeable$ValueTypeable.prototype.toString__T = (function() {
  return $f_Lshapeless_Typeable__toString__T(this)
});
$c_Lshapeless_Typeable$ValueTypeable.prototype.describe__T = (function() {
  return this.Lshapeless_Typeable$ValueTypeable__f_describe
});
$c_Lshapeless_Typeable$ValueTypeable.prototype.cast__O__s_Option = (function(t) {
  return (((t !== null) && $n(this.Lshapeless_Typeable$ValueTypeable__f_cB).isInstance__O__Z(t)) ? new $c_s_Some(t) : $m_s_None$())
});
$c_Lshapeless_Typeable$ValueTypeable.prototype.productPrefix__T = (function() {
  return "ValueTypeable"
});
$c_Lshapeless_Typeable$ValueTypeable.prototype.productArity__I = (function() {
  return 2
});
$c_Lshapeless_Typeable$ValueTypeable.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lshapeless_Typeable$ValueTypeable__f_cB;
      break
    }
    case 1: {
      return this.Lshapeless_Typeable$ValueTypeable__f_describe;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lshapeless_Typeable$ValueTypeable.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshapeless_Typeable$ValueTypeable.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshapeless_Typeable$ValueTypeable.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshapeless_Typeable$ValueTypeable)) {
    var ValueTypeable$1 = $as_Lshapeless_Typeable$ValueTypeable(x$1);
    var x = this.Lshapeless_Typeable$ValueTypeable__f_cB;
    var x$2 = $n(ValueTypeable$1).Lshapeless_Typeable$ValueTypeable__f_cB;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      return ((this.Lshapeless_Typeable$ValueTypeable__f_describe === $n(ValueTypeable$1).Lshapeless_Typeable$ValueTypeable__f_describe) && ($n(ValueTypeable$1), true))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lshapeless_Typeable$ValueTypeable(obj) {
  return (((obj instanceof $c_Lshapeless_Typeable$ValueTypeable) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.Typeable$ValueTypeable"))
}
function $isArrayOf_Lshapeless_Typeable$ValueTypeable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_Typeable$ValueTypeable)))
}
function $asArrayOf_Lshapeless_Typeable$ValueTypeable(obj, depth) {
  return (($isArrayOf_Lshapeless_Typeable$ValueTypeable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.Typeable$ValueTypeable;", depth))
}
var $d_Lshapeless_Typeable$ValueTypeable = new $TypeData().initClass({
  Lshapeless_Typeable$ValueTypeable: 0
}, false, "shapeless.Typeable$ValueTypeable", {
  Lshapeless_Typeable$ValueTypeable: 1,
  O: 1,
  Lshapeless_Typeable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lshapeless_Typeable$ValueTypeable.prototype.$classData = $d_Lshapeless_Typeable$ValueTypeable;
/** @constructor */
function $c_Lsourcecode_Enclosing(value) {
  this.Lsourcecode_Enclosing__f_value = null;
  this.Lsourcecode_Enclosing__f_value = value
}
$c_Lsourcecode_Enclosing.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_Enclosing.prototype.constructor = $c_Lsourcecode_Enclosing;
/** @constructor */
function $h_Lsourcecode_Enclosing() {
  /*<skip>*/
}
$h_Lsourcecode_Enclosing.prototype = $c_Lsourcecode_Enclosing.prototype;
$c_Lsourcecode_Enclosing.prototype.productPrefix__T = (function() {
  return "Enclosing"
});
$c_Lsourcecode_Enclosing.prototype.productArity__I = (function() {
  return 1
});
$c_Lsourcecode_Enclosing.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lsourcecode_Enclosing__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lsourcecode_Enclosing.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lsourcecode_Enclosing.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsourcecode_Enclosing.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsourcecode_Enclosing.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lsourcecode_Enclosing)) {
    var Enclosing$1 = $as_Lsourcecode_Enclosing(x$1);
    return ((this.Lsourcecode_Enclosing__f_value === $n(Enclosing$1).Lsourcecode_Enclosing__f_value) && ($n(Enclosing$1), true))
  } else {
    return false
  }
});
function $as_Lsourcecode_Enclosing(obj) {
  return (((obj instanceof $c_Lsourcecode_Enclosing) || (obj === null)) ? obj : $throwClassCastException(obj, "sourcecode.Enclosing"))
}
function $isArrayOf_Lsourcecode_Enclosing(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_Enclosing)))
}
function $asArrayOf_Lsourcecode_Enclosing(obj, depth) {
  return (($isArrayOf_Lsourcecode_Enclosing(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsourcecode.Enclosing;", depth))
}
var $d_Lsourcecode_Enclosing = new $TypeData().initClass({
  Lsourcecode_Enclosing: 0
}, false, "sourcecode.Enclosing", {
  Lsourcecode_Enclosing: 1,
  Lsourcecode_SourceValue: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lsourcecode_Enclosing.prototype.$classData = $d_Lsourcecode_Enclosing;
/** @constructor */
function $c_Lsourcecode_FileName(value) {
  this.Lsourcecode_FileName__f_value = null;
  this.Lsourcecode_FileName__f_value = value
}
$c_Lsourcecode_FileName.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_FileName.prototype.constructor = $c_Lsourcecode_FileName;
/** @constructor */
function $h_Lsourcecode_FileName() {
  /*<skip>*/
}
$h_Lsourcecode_FileName.prototype = $c_Lsourcecode_FileName.prototype;
$c_Lsourcecode_FileName.prototype.productPrefix__T = (function() {
  return "FileName"
});
$c_Lsourcecode_FileName.prototype.productArity__I = (function() {
  return 1
});
$c_Lsourcecode_FileName.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lsourcecode_FileName__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lsourcecode_FileName.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lsourcecode_FileName.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsourcecode_FileName.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsourcecode_FileName.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lsourcecode_FileName)) {
    var FileName$1 = $as_Lsourcecode_FileName(x$1);
    return ((this.Lsourcecode_FileName__f_value === $n(FileName$1).Lsourcecode_FileName__f_value) && ($n(FileName$1), true))
  } else {
    return false
  }
});
function $as_Lsourcecode_FileName(obj) {
  return (((obj instanceof $c_Lsourcecode_FileName) || (obj === null)) ? obj : $throwClassCastException(obj, "sourcecode.FileName"))
}
function $isArrayOf_Lsourcecode_FileName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_FileName)))
}
function $asArrayOf_Lsourcecode_FileName(obj, depth) {
  return (($isArrayOf_Lsourcecode_FileName(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsourcecode.FileName;", depth))
}
var $d_Lsourcecode_FileName = new $TypeData().initClass({
  Lsourcecode_FileName: 0
}, false, "sourcecode.FileName", {
  Lsourcecode_FileName: 1,
  Lsourcecode_SourceValue: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lsourcecode_FileName.prototype.$classData = $d_Lsourcecode_FileName;
/** @constructor */
function $c_Lsourcecode_FullName(value) {
  this.Lsourcecode_FullName__f_value = null;
  this.Lsourcecode_FullName__f_value = value
}
$c_Lsourcecode_FullName.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_FullName.prototype.constructor = $c_Lsourcecode_FullName;
/** @constructor */
function $h_Lsourcecode_FullName() {
  /*<skip>*/
}
$h_Lsourcecode_FullName.prototype = $c_Lsourcecode_FullName.prototype;
$c_Lsourcecode_FullName.prototype.productPrefix__T = (function() {
  return "FullName"
});
$c_Lsourcecode_FullName.prototype.productArity__I = (function() {
  return 1
});
$c_Lsourcecode_FullName.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lsourcecode_FullName__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lsourcecode_FullName.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lsourcecode_FullName.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsourcecode_FullName.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsourcecode_FullName.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lsourcecode_FullName)) {
    var FullName$1 = $as_Lsourcecode_FullName(x$1);
    return ((this.Lsourcecode_FullName__f_value === $n(FullName$1).Lsourcecode_FullName__f_value) && ($n(FullName$1), true))
  } else {
    return false
  }
});
function $as_Lsourcecode_FullName(obj) {
  return (((obj instanceof $c_Lsourcecode_FullName) || (obj === null)) ? obj : $throwClassCastException(obj, "sourcecode.FullName"))
}
function $isArrayOf_Lsourcecode_FullName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_FullName)))
}
function $asArrayOf_Lsourcecode_FullName(obj, depth) {
  return (($isArrayOf_Lsourcecode_FullName(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsourcecode.FullName;", depth))
}
var $d_Lsourcecode_FullName = new $TypeData().initClass({
  Lsourcecode_FullName: 0
}, false, "sourcecode.FullName", {
  Lsourcecode_FullName: 1,
  Lsourcecode_SourceValue: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lsourcecode_FullName.prototype.$classData = $d_Lsourcecode_FullName;
/** @constructor */
function $c_Lsourcecode_Name(value) {
  this.Lsourcecode_Name__f_value = null;
  this.Lsourcecode_Name__f_value = value
}
$c_Lsourcecode_Name.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_Name.prototype.constructor = $c_Lsourcecode_Name;
/** @constructor */
function $h_Lsourcecode_Name() {
  /*<skip>*/
}
$h_Lsourcecode_Name.prototype = $c_Lsourcecode_Name.prototype;
$c_Lsourcecode_Name.prototype.productPrefix__T = (function() {
  return "Name"
});
$c_Lsourcecode_Name.prototype.productArity__I = (function() {
  return 1
});
$c_Lsourcecode_Name.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lsourcecode_Name__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lsourcecode_Name.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lsourcecode_Name.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsourcecode_Name.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsourcecode_Name.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lsourcecode_Name)) {
    var Name$1 = $as_Lsourcecode_Name(x$1);
    return ((this.Lsourcecode_Name__f_value === $n(Name$1).Lsourcecode_Name__f_value) && ($n(Name$1), true))
  } else {
    return false
  }
});
function $as_Lsourcecode_Name(obj) {
  return (((obj instanceof $c_Lsourcecode_Name) || (obj === null)) ? obj : $throwClassCastException(obj, "sourcecode.Name"))
}
function $isArrayOf_Lsourcecode_Name(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_Name)))
}
function $asArrayOf_Lsourcecode_Name(obj, depth) {
  return (($isArrayOf_Lsourcecode_Name(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsourcecode.Name;", depth))
}
var $d_Lsourcecode_Name = new $TypeData().initClass({
  Lsourcecode_Name: 0
}, false, "sourcecode.Name", {
  Lsourcecode_Name: 1,
  Lsourcecode_SourceValue: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lsourcecode_Name.prototype.$classData = $d_Lsourcecode_Name;
/** @constructor */
function $c_Lsourcecode_Pkg(value) {
  this.Lsourcecode_Pkg__f_value = null;
  this.Lsourcecode_Pkg__f_value = value
}
$c_Lsourcecode_Pkg.prototype = new $h_Lsourcecode_SourceValue();
$c_Lsourcecode_Pkg.prototype.constructor = $c_Lsourcecode_Pkg;
/** @constructor */
function $h_Lsourcecode_Pkg() {
  /*<skip>*/
}
$h_Lsourcecode_Pkg.prototype = $c_Lsourcecode_Pkg.prototype;
$c_Lsourcecode_Pkg.prototype.productPrefix__T = (function() {
  return "Pkg"
});
$c_Lsourcecode_Pkg.prototype.productArity__I = (function() {
  return 1
});
$c_Lsourcecode_Pkg.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lsourcecode_Pkg__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lsourcecode_Pkg.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lsourcecode_Pkg.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsourcecode_Pkg.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsourcecode_Pkg.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lsourcecode_Pkg)) {
    var Pkg$1 = $as_Lsourcecode_Pkg(x$1);
    return ((this.Lsourcecode_Pkg__f_value === $n(Pkg$1).Lsourcecode_Pkg__f_value) && ($n(Pkg$1), true))
  } else {
    return false
  }
});
function $as_Lsourcecode_Pkg(obj) {
  return (((obj instanceof $c_Lsourcecode_Pkg) || (obj === null)) ? obj : $throwClassCastException(obj, "sourcecode.Pkg"))
}
function $isArrayOf_Lsourcecode_Pkg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsourcecode_Pkg)))
}
function $asArrayOf_Lsourcecode_Pkg(obj, depth) {
  return (($isArrayOf_Lsourcecode_Pkg(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsourcecode.Pkg;", depth))
}
var $d_Lsourcecode_Pkg = new $TypeData().initClass({
  Lsourcecode_Pkg: 0
}, false, "sourcecode.Pkg", {
  Lsourcecode_Pkg: 1,
  Lsourcecode_SourceValue: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lsourcecode_Pkg.prototype.$classData = $d_Lsourcecode_Pkg;
/** @constructor */
function $c_Lcats_Now(value) {
  this.Lcats_Now__f_value = null;
  this.Lcats_Now__f_value = value
}
$c_Lcats_Now.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Now.prototype.constructor = $c_Lcats_Now;
/** @constructor */
function $h_Lcats_Now() {
  /*<skip>*/
}
$h_Lcats_Now.prototype = $c_Lcats_Now.prototype;
$c_Lcats_Now.prototype.productPrefix__T = (function() {
  return "Now"
});
$c_Lcats_Now.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_Now.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcats_Now__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcats_Now.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcats_Now.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_Now.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_Now.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcats_Now)) {
    var Now$1 = $as_Lcats_Now(x$1);
    var x = this.Lcats_Now__f_value;
    var y = $n(Now$1).Lcats_Now__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lcats_Now(obj) {
  return (((obj instanceof $c_Lcats_Now) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Now"))
}
function $isArrayOf_Lcats_Now(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Now)))
}
function $asArrayOf_Lcats_Now(obj, depth) {
  return (($isArrayOf_Lcats_Now(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Now;", depth))
}
var $d_Lcats_Now = new $TypeData().initClass({
  Lcats_Now: 0
}, false, "cats.Now", {
  Lcats_Now: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lcats_Now.prototype.$classData = $d_Lcats_Now;
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$1() {
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_False
}
$c_Lcats_UnorderedFoldable$$anon$1.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$1.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$1;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$1() {
  /*<skip>*/
}
$h_Lcats_UnorderedFoldable$$anon$1.prototype = $c_Lcats_UnorderedFoldable$$anon$1.prototype;
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return $n(lx).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $uZ(x0$1$2);
    if ((x0$1 === true)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_True
    } else if ((x0$1 === false)) {
      return ly
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y))
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$1__f_empty
});
var $d_Lcats_UnorderedFoldable$$anon$1 = new $TypeData().initClass({
  Lcats_UnorderedFoldable$$anon$1: 0
}, false, "cats.UnorderedFoldable$$anon$1", {
  Lcats_UnorderedFoldable$$anon$1: 1,
  O: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.$classData = $d_Lcats_UnorderedFoldable$$anon$1;
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$2() {
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_True
}
$c_Lcats_UnorderedFoldable$$anon$2.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$2.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$2;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$2() {
  /*<skip>*/
}
$h_Lcats_UnorderedFoldable$$anon$2.prototype = $c_Lcats_UnorderedFoldable$$anon$2.prototype;
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return $n(lx).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $uZ(x0$1$2);
    if ((x0$1 === true)) {
      return ly
    } else if ((x0$1 === false)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_False
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y))
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$2__f_empty
});
var $d_Lcats_UnorderedFoldable$$anon$2 = new $TypeData().initClass({
  Lcats_UnorderedFoldable$$anon$2: 0
}, false, "cats.UnorderedFoldable$$anon$2", {
  Lcats_UnorderedFoldable$$anon$2: 1,
  O: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.$classData = $d_Lcats_UnorderedFoldable$$anon$2;
function $f_Lcats_arrow_Arrow__id__O($thiz) {
  return $thiz.lift__F1__O(new $c_sjsr_AnonFunction1(((x$2) => x$2)))
}
/** @constructor */
function $c_Lcats_data_AndThen$Concat(left, right) {
  this.Lcats_data_AndThen$Concat__f_left = null;
  this.Lcats_data_AndThen$Concat__f_right = null;
  this.Lcats_data_AndThen$Concat__f_left = left;
  this.Lcats_data_AndThen$Concat__f_right = right
}
$c_Lcats_data_AndThen$Concat.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Concat.prototype.constructor = $c_Lcats_data_AndThen$Concat;
/** @constructor */
function $h_Lcats_data_AndThen$Concat() {
  /*<skip>*/
}
$h_Lcats_data_AndThen$Concat.prototype = $c_Lcats_data_AndThen$Concat.prototype;
$c_Lcats_data_AndThen$Concat.prototype.productPrefix__T = (function() {
  return "Concat"
});
$c_Lcats_data_AndThen$Concat.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_data_AndThen$Concat.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcats_data_AndThen$Concat__f_left;
      break
    }
    case 1: {
      return this.Lcats_data_AndThen$Concat__f_right;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcats_data_AndThen$Concat.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcats_data_AndThen$Concat.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_AndThen$Concat.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcats_data_AndThen$Concat)) {
    var Concat$1 = $as_Lcats_data_AndThen$Concat(x$1);
    var x = this.Lcats_data_AndThen$Concat__f_left;
    var x$2 = $n(Concat$1).Lcats_data_AndThen$Concat__f_left;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_data_AndThen$Concat__f_right;
      var x$4 = $n(Concat$1).Lcats_data_AndThen$Concat__f_right;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcats_data_AndThen$Concat(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen$Concat) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen$Concat"))
}
function $isArrayOf_Lcats_data_AndThen$Concat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Concat)))
}
function $asArrayOf_Lcats_data_AndThen$Concat(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen$Concat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen$Concat;", depth))
}
var $d_Lcats_data_AndThen$Concat = new $TypeData().initClass({
  Lcats_data_AndThen$Concat: 0
}, false, "cats.data.AndThen$Concat", {
  Lcats_data_AndThen$Concat: 1,
  Lcats_data_AndThen: 1,
  O: 1,
  F1: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_AndThen$Concat.prototype.$classData = $d_Lcats_data_AndThen$Concat;
/** @constructor */
function $c_Lcats_data_AndThen$Single(f, index) {
  this.Lcats_data_AndThen$Single__f_f = null;
  this.Lcats_data_AndThen$Single__f_index = 0;
  this.Lcats_data_AndThen$Single__f_f = f;
  this.Lcats_data_AndThen$Single__f_index = index
}
$c_Lcats_data_AndThen$Single.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Single.prototype.constructor = $c_Lcats_data_AndThen$Single;
/** @constructor */
function $h_Lcats_data_AndThen$Single() {
  /*<skip>*/
}
$h_Lcats_data_AndThen$Single.prototype = $c_Lcats_data_AndThen$Single.prototype;
$c_Lcats_data_AndThen$Single.prototype.productPrefix__T = (function() {
  return "Single"
});
$c_Lcats_data_AndThen$Single.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_data_AndThen$Single.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcats_data_AndThen$Single__f_f;
      break
    }
    case 1: {
      return this.Lcats_data_AndThen$Single__f_index;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcats_data_AndThen$Single.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcats_data_AndThen$Single.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Single");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_data_AndThen$Single__f_f;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_data_AndThen$Single__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lcats_data_AndThen$Single.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcats_data_AndThen$Single)) {
    var Single$1 = $as_Lcats_data_AndThen$Single(x$1);
    if ((this.Lcats_data_AndThen$Single__f_index === $n(Single$1).Lcats_data_AndThen$Single__f_index)) {
      var x = this.Lcats_data_AndThen$Single__f_f;
      var x$2 = $n(Single$1).Lcats_data_AndThen$Single__f_f;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcats_data_AndThen$Single(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen$Single) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen$Single"))
}
function $isArrayOf_Lcats_data_AndThen$Single(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Single)))
}
function $asArrayOf_Lcats_data_AndThen$Single(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen$Single(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen$Single;", depth))
}
var $d_Lcats_data_AndThen$Single = new $TypeData().initClass({
  Lcats_data_AndThen$Single: 0
}, false, "cats.data.AndThen$Single", {
  Lcats_data_AndThen$Single: 1,
  Lcats_data_AndThen: 1,
  O: 1,
  F1: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_AndThen$Single.prototype.$classData = $d_Lcats_data_AndThen$Single;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$4(outer) {
  /*<skip>*/
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_kernel_Semigroup(fa);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$6(this, f, fa$1, g)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Semigroup(fa);
  var fb$1 = $as_Lcats_kernel_Semigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$4$$anon$5(this, fa$1, fb$1)
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$4: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$4", {
  Lcats_instances_InvariantMonoidalInstances$$anon$4: 1,
  O: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$4;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$7(outer) {
  /*<skip>*/
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$7;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$7() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$7.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$7.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_kernel_CommutativeSemigroup(fa);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$9(this, f, fa$1, g)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_CommutativeSemigroup(fa);
  var fb$1 = $as_Lcats_kernel_CommutativeSemigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$7$$anon$8(this, fa$1, fb$1)
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$7 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$7: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$7", {
  Lcats_instances_InvariantMonoidalInstances$$anon$7: 1,
  O: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$7.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$7;
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$1$$anon$2(outer, fa$1, fb$1) {
  this.Lcats_instances_OrderingInstances$$anon$1$$anon$2__f_fa$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$1$$anon$2__f_fb$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$1$$anon$2__f_fa$1 = fa$1;
  this.Lcats_instances_OrderingInstances$$anon$1$$anon$2__f_fb$1 = fb$1
}
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$1$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$1$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype = $c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype;
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var z = $n(this.Lcats_instances_OrderingInstances$$anon$1$$anon$2__f_fa$1).compare__O__O__I($n(x)._1__O(), $n(y)._1__O());
  return ((z === 0) ? $n(this.Lcats_instances_OrderingInstances$$anon$1$$anon$2__f_fb$1).compare__O__O__I($n(x)._2__O(), $n(y)._2__O()) : z)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_OrderingInstances$$anon$1$$anon$2 = new $TypeData().initClass({
  Lcats_instances_OrderingInstances$$anon$1$$anon$2: 0
}, false, "cats.instances.OrderingInstances$$anon$1$$anon$2", {
  Lcats_instances_OrderingInstances$$anon$1$$anon$2: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_OrderingInstances$$anon$1$$anon$2.prototype.$classData = $d_Lcats_instances_OrderingInstances$$anon$1$$anon$2;
/** @constructor */
function $c_Lcats_instances_SetInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_SetInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SetInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SetInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SetInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SetInstances$$anon$1.prototype = $c_Lcats_instances_SetInstances$$anon$1.prototype;
$c_Lcats_instances_SetInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this)
});
$c_Lcats_instances_SetInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Set(x);
  var y$1 = $as_sci_Set(y);
  var this$1 = $n(x$1);
  return $as_sci_Set(this$1.concat__sc_IterableOnce__sc_SetOps(y$1))
});
$c_Lcats_instances_SetInstances$$anon$1.prototype.empty__O = (function() {
  $n($m_s_Predef$().s_Predef$__f_Set);
  return $m_sci_Set$EmptySet$()
});
var $d_Lcats_instances_SetInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SetInstances$$anon$1: 0
}, false, "cats.instances.SetInstances$$anon$1", {
  Lcats_instances_SetInstances$$anon$1: 1,
  O: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_UnorderedFoldable: 1,
  Ljava_io_Serializable: 1,
  Lcats_MonoidK: 1,
  Lcats_SemigroupK: 1
});
$c_Lcats_instances_SetInstances$$anon$1.prototype.$classData = $d_Lcats_instances_SetInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_package$list$() {
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = null;
  $n_Lcats_instances_package$list$ = this;
  $f_Lcats_instances_ListInstances__$init$__V(this);
  $f_Lcats_instances_ListInstancesBinCompat0__$init$__V(this)
}
$c_Lcats_instances_package$list$.prototype = new $h_O();
$c_Lcats_instances_package$list$.prototype.constructor = $c_Lcats_instances_package$list$;
/** @constructor */
function $h_Lcats_instances_package$list$() {
  /*<skip>*/
}
$h_Lcats_instances_package$list$.prototype = $c_Lcats_instances_package$list$.prototype;
$c_Lcats_instances_package$list$.prototype.cats$instances$ListInstancesBinCompat0$_setter_$catsStdTraverseFilterForList_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_package$list$.prototype.cats$instances$ListInstances$_setter_$catsStdInstancesForList_$eq__Lcats_Traverse__V = (function(x$1) {
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = x$1
});
var $d_Lcats_instances_package$list$ = new $TypeData().initClass({
  Lcats_instances_package$list$: 0
}, false, "cats.instances.package$list$", {
  Lcats_instances_package$list$: 1,
  O: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_instances_ListInstancesBinCompat0: 1
});
$c_Lcats_instances_package$list$.prototype.$classData = $d_Lcats_instances_package$list$;
var $n_Lcats_instances_package$list$;
function $m_Lcats_instances_package$list$() {
  if ((!$n_Lcats_instances_package$list$)) {
    $n_Lcats_instances_package$list$ = new $c_Lcats_instances_package$list$()
  };
  return $n_Lcats_instances_package$list$
}
/** @constructor */
function $c_Lcats_instances_package$stream$() {
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = null;
  $n_Lcats_instances_package$stream$ = this;
  $f_Lcats_instances_StreamInstances__$init$__V(this);
  $f_Lcats_instances_StreamInstancesBinCompat0__$init$__V(this)
}
$c_Lcats_instances_package$stream$.prototype = new $h_O();
$c_Lcats_instances_package$stream$.prototype.constructor = $c_Lcats_instances_package$stream$;
/** @constructor */
function $h_Lcats_instances_package$stream$() {
  /*<skip>*/
}
$h_Lcats_instances_package$stream$.prototype = $c_Lcats_instances_package$stream$.prototype;
$c_Lcats_instances_package$stream$.prototype.cats$instances$StreamInstancesBinCompat0$_setter_$catsStdTraverseFilterForStream_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_package$stream$.prototype.cats$instances$StreamInstances$_setter_$catsStdInstancesForStream_$eq__Lcats_Traverse__V = (function(x$1) {
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = x$1
});
var $d_Lcats_instances_package$stream$ = new $TypeData().initClass({
  Lcats_instances_package$stream$: 0
}, false, "cats.instances.package$stream$", {
  Lcats_instances_package$stream$: 1,
  O: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1
});
$c_Lcats_instances_package$stream$.prototype.$classData = $d_Lcats_instances_package$stream$;
var $n_Lcats_instances_package$stream$;
function $m_Lcats_instances_package$stream$() {
  if ((!$n_Lcats_instances_package$stream$)) {
    $n_Lcats_instances_package$stream$ = new $c_Lcats_instances_package$stream$()
  };
  return $n_Lcats_instances_package$stream$
}
/** @constructor */
function $c_Lcats_instances_package$vector$() {
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = null;
  $n_Lcats_instances_package$vector$ = this;
  $f_Lcats_instances_VectorInstances__$init$__V(this);
  $f_Lcats_instances_VectorInstancesBinCompat0__$init$__V(this)
}
$c_Lcats_instances_package$vector$.prototype = new $h_O();
$c_Lcats_instances_package$vector$.prototype.constructor = $c_Lcats_instances_package$vector$;
/** @constructor */
function $h_Lcats_instances_package$vector$() {
  /*<skip>*/
}
$h_Lcats_instances_package$vector$.prototype = $c_Lcats_instances_package$vector$.prototype;
$c_Lcats_instances_package$vector$.prototype.cats$instances$VectorInstancesBinCompat0$_setter_$catsStdTraverseFilterForVector_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_package$vector$.prototype.cats$instances$VectorInstances$_setter_$catsStdInstancesForVector_$eq__Lcats_Traverse__V = (function(x$1) {
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = x$1
});
var $d_Lcats_instances_package$vector$ = new $TypeData().initClass({
  Lcats_instances_package$vector$: 0
}, false, "cats.instances.package$vector$", {
  Lcats_instances_package$vector$: 1,
  O: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1
});
$c_Lcats_instances_package$vector$.prototype.$classData = $d_Lcats_instances_package$vector$;
var $n_Lcats_instances_package$vector$;
function $m_Lcats_instances_package$vector$() {
  if ((!$n_Lcats_instances_package$vector$)) {
    $n_Lcats_instances_package$vector$ = new $c_Lcats_instances_package$vector$()
  };
  return $n_Lcats_instances_package$vector$
}
/** @constructor */
function $c_Lcats_kernel_Order$() {
  /*<skip>*/
}
$c_Lcats_kernel_Order$.prototype = new $h_Lcats_kernel_OrderFunctions();
$c_Lcats_kernel_Order$.prototype.constructor = $c_Lcats_kernel_Order$;
/** @constructor */
function $h_Lcats_kernel_Order$() {
  /*<skip>*/
}
$h_Lcats_kernel_Order$.prototype = $c_Lcats_kernel_Order$.prototype;
var $d_Lcats_kernel_Order$ = new $TypeData().initClass({
  Lcats_kernel_Order$: 0
}, false, "cats.kernel.Order$", {
  Lcats_kernel_Order$: 1,
  Lcats_kernel_OrderFunctions: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Order$.prototype.$classData = $d_Lcats_kernel_Order$;
var $n_Lcats_kernel_Order$;
function $m_Lcats_kernel_Order$() {
  if ((!$n_Lcats_kernel_Order$)) {
    $n_Lcats_kernel_Order$ = new $c_Lcats_kernel_Order$()
  };
  return $n_Lcats_kernel_Order$
}
/** @constructor */
function $c_Lcats_kernel_Order$$anon$1(outer) {
  this.Lcats_kernel_Order$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcats_kernel_Order$$anon$1__f_$outer = outer
  }
}
$c_Lcats_kernel_Order$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$1.prototype.constructor = $c_Lcats_kernel_Order$$anon$1;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$1() {
  /*<skip>*/
}
$h_Lcats_kernel_Order$$anon$1.prototype = $c_Lcats_kernel_Order$$anon$1.prototype;
$c_Lcats_kernel_Order$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lcats_kernel_Order$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.Lcats_kernel_Order$$anon$1__f_$outer).compare__O__O__I(x, y)
});
$c_Lcats_kernel_Order$$anon$1.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
var $d_Lcats_kernel_Order$$anon$1 = new $TypeData().initClass({
  Lcats_kernel_Order$$anon$1: 0
}, false, "cats.kernel.Order$$anon$1", {
  Lcats_kernel_Order$$anon$1: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Order$$anon$1.prototype.$classData = $d_Lcats_kernel_Order$$anon$1;
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BigDecimalOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigDecimalOrder.prototype = $c_Lcats_kernel_instances_BigDecimalOrder.prototype;
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.eqv__s_math_BigDecimal__s_math_BigDecimal__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $n(x).equals__O__Z(y))
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.neqv__s_math_BigDecimal__s_math_BigDecimal__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : $n(x).equals__O__Z(y)))
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_math_BigDecimal__s_math_BigDecimal__Z($as_s_math_BigDecimal(x), $as_s_math_BigDecimal(y))
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_math_BigDecimal__s_math_BigDecimal__Z($as_s_math_BigDecimal(x), $as_s_math_BigDecimal(y))
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  var this$1 = $n(x$1);
  return $n(this$1.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(y$1).s_math_BigDecimal__f_bigDecimal)
});
var $d_Lcats_kernel_instances_BigDecimalOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BigDecimalOrder: 0
}, false, "cats.kernel.instances.BigDecimalOrder", {
  Lcats_kernel_instances_BigDecimalOrder: 1,
  O: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.$classData = $d_Lcats_kernel_instances_BigDecimalOrder;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState(outer, items) {
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState__f_items = null;
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState__f_$outer = null;
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState__f_items = items;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.noMatched__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$NotMatchedTypedState = (function(iterable) {
  return this
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.matched__s_Option__F1__F1__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState = (function(lastState, tokenizer, matching, iterable, keyMapper) {
  window.performance.mark("SearchResults.base.start");
  var r = $n($n(this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState__f_$outer).MatchedTypedState__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$()).from__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState($n(this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState__f_items).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((items$2) => $n(iterable).map__O__F1__O(items$2, new $c_sjsr_AnonFunction1(((t$2) => {
    var t = $as_T2(t$2);
    var u = $as_Lcom_iz2use_common_internal_tokenizer_MappedTokenized($n(tokenizer).apply__O__O($n(t)._1__O()));
    var v = $as_Lcom_iz2use_common_TokenMatches($n(matching).apply__O__O(u));
    return new $c_T3(t, u, v)
  })))))), iterable);
  window.performance.mark("SearchResults.base.end");
  window.performance.measure("SearchResults.base", "SearchResults.base.start", "SearchResults.base.end");
  return r
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.productPrefix__T = (function() {
  return "BaseTypedState"
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState__f_items : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState)) {
    var BaseTypedState$1 = $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState__f_items;
    var x$2 = $n(BaseTypedState$1).Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState__f_items;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.SearchRefiner$BaseTypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.SearchRefiner$BaseTypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState: 0
}, false, "com.iz2use.react.components.internal.multiview.SearchRefiner$BaseTypedState", {
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState: 1,
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$NotMatchedTypedState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$BaseTypedState;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState(outer, tokenized) {
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState__f_tokenized = null;
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState__f_$outer = null;
  this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState__f_tokenized = tokenized;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState__f_$outer = outer
  }
}
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.noMatched__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$NotMatchedTypedState = (function(iterable) {
  return this
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.matched__s_Option__F1__F1__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState = (function(lastState, tokenizer, matching, iterable, keyMapper) {
  window.performance.mark("SearchResults.tokenize.start");
  var r = $n($n(this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState__f_$outer).MatchedTypedState__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState$()).from__Ldiode_data_Pot__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_SearchRefiner$MatchedTypedState($n(this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState__f_tokenized).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((tokenized$2) => $n(iterable).map__O__F1__O(tokenized$2, new $c_sjsr_AnonFunction1(((in$2) => {
    var in$1 = $as_T2(in$2);
    var v = $as_Lcom_iz2use_common_TokenMatches($n(matching).apply__O__O($n(tokenizer).apply__O__O($n($as_T2($n(in$1)._1__O()))._1__O())));
    return new $c_T3($n(in$1)._1__O(), $n(in$1)._2__O(), v)
  })))))), iterable);
  window.performance.mark("SearchResults.tokenize.end");
  window.performance.measure("SearchResults.tokenize", "SearchResults.tokenize.start", "SearchResults.tokenize.end");
  return r
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.productPrefix__T = (function() {
  return "TokenizedTypedState"
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.productArity__I = (function() {
  return 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState__f_tokenized : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState)) {
    var TokenizedTypedState$1 = $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState(x$1);
    var x = this.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState__f_tokenized;
    var x$2 = $n(TokenizedTypedState$1).Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState__f_tokenized;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.multiview.SearchRefiner$TokenizedTypedState"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.multiview.SearchRefiner$TokenizedTypedState;", depth))
}
var $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState: 0
}, false, "com.iz2use.react.components.internal.multiview.SearchRefiner$TokenizedTypedState", {
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState: 1,
  O: 1,
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$NotMatchedTypedState: 1,
  Lcom_iz2use_react_components_internal_multiview_SearchRefiner$InternalState: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SearchRefiner$TokenizedTypedState;
function $p_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1__loop$1__sci_List__sci_Map__sci_Map__I($thiz, in$1, a$1, b$1) {
  while (true) {
    var x1 = in$1;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      return 0
    };
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var p4 = $as_T3($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      if ((p4 !== null)) {
        var sbl = $as_s_Symbol($n(p4).T3__f__1);
        var ord = $as_s_math_Ordering($n(p4).T3__f__2);
        var asc = $uZ($n(p4).T3__f__3);
        var r = $n(ord).compare__O__O__I($n(a$1).apply__O__O(sbl), $n(b$1).apply__O__O(sbl));
        if ((r === 0)) {
          in$1 = tail;
          continue
        } else {
          return (asc ? r : ((-r) | 0))
        }
      }
    };
    throw new $c_s_MatchError(x1)
  }
}
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1(outer, fieldOrderings$1) {
  this.Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1__f_fieldOrderings$1 = null;
  this.Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1__f_fieldOrderings$1 = fieldOrderings$1
}
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype = new $h_O();
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.constructor = $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype = $c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype;
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.compare__sci_Map__sci_Map__I = (function(a, b) {
  return $p_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1__loop$1__sci_List__sci_Map__sci_Map__I(this, this.Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1__f_fieldOrderings$1, a, b)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__sci_Map__sci_Map__I($as_sci_Map(x), $as_sci_Map(y))
});
var $d_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1 = new $TypeData().initClass({
  Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1: 0
}, false, "com.iz2use.react.components.internal.multiview.SortRefiner$$anon$1", {
  Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1.prototype.$classData = $d_Lcom_iz2use_react_components_internal_multiview_SortRefiner$$anon$1;
/** @constructor */
function $c_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher() {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null
}
$c_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher();
$c_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher.prototype.constructor = $c_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher;
/** @constructor */
function $h_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher.prototype = $c_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher.prototype;
function $as_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.components.internal.suggestion.OnMountFetcher"))
}
function $isArrayOf_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher)))
}
function $asArrayOf_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.components.internal.suggestion.OnMountFetcher;", depth))
}
/** @constructor */
function $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$(outer) {
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_dpi = $L0;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_$outer = null;
  this.Lcom_iz2use_react_style_MaterialDesign$PressableElevation__f_pressedDpi = $L0;
  $ct_Lcom_iz2use_react_style_MaterialDesign$PressableElevation__Lcom_iz2use_react_style_MaterialDesign__J__J__(this, $n(outer).Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_$outer, new $c_RTLong(2, 0), new $c_RTLong(8, 0))
}
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype = new $h_Lcom_iz2use_react_style_MaterialDesign$PressableElevation();
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype.constructor = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$;
/** @constructor */
function $h_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype;
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype.productPrefix__T = (function() {
  return "Button"
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype.hashCode__I = (function() {
  return 2001146706
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype.toString__T = (function() {
  return "Button"
});
var $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$: 0
}, false, "com.iz2use.react.style.MaterialDesign$Elevation$Button$", {
  Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$: 1,
  Lcom_iz2use_react_style_MaterialDesign$PressableElevation: 1,
  Lcom_iz2use_react_style_MaterialDesign$Elevation: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$.prototype.$classData = $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$Button$;
/** @constructor */
function $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$(outer) {
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_dpi = $L0;
  this.Lcom_iz2use_react_style_MaterialDesign$Elevation__f_$outer = null;
  this.Lcom_iz2use_react_style_MaterialDesign$PressableElevation__f_pressedDpi = $L0;
  $ct_Lcom_iz2use_react_style_MaterialDesign$PressableElevation__Lcom_iz2use_react_style_MaterialDesign__J__J__(this, $n(outer).Lcom_iz2use_react_style_MaterialDesign$Elevation$__f_$outer, new $c_RTLong(2, 0), new $c_RTLong(8, 0))
}
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype = new $h_Lcom_iz2use_react_style_MaterialDesign$PressableElevation();
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype.constructor = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$;
/** @constructor */
function $h_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype = $c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype;
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype.productPrefix__T = (function() {
  return "Card"
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype.hashCode__I = (function() {
  return 2092848
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype.toString__T = (function() {
  return "Card"
});
var $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$: 0
}, false, "com.iz2use.react.style.MaterialDesign$Elevation$Card$", {
  Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$: 1,
  Lcom_iz2use_react_style_MaterialDesign$PressableElevation: 1,
  Lcom_iz2use_react_style_MaterialDesign$Elevation: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$.prototype.$classData = $d_Lcom_iz2use_react_style_MaterialDesign$Elevation$Card$;
/** @constructor */
function $c_Lcom_iz2use_react_style_StyleSettings$() {
  this.Lcom_iz2use_react_style_StyleSettings$__f_cssRegisterNameGen = null;
  this.Lcom_iz2use_react_style_StyleSettings$__f_cssRegisterErrorHandler = null;
  $n_Lcom_iz2use_react_style_StyleSettings$ = this;
  $f_Lscalacss_defaults_Exports__$init$__V(this);
  $f_Lscalacss_defaults_DefaultSettings$Dev__$init$__V(this)
}
$c_Lcom_iz2use_react_style_StyleSettings$.prototype = new $h_O();
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.constructor = $c_Lcom_iz2use_react_style_StyleSettings$;
/** @constructor */
function $h_Lcom_iz2use_react_style_StyleSettings$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_style_StyleSettings$.prototype = $c_Lcom_iz2use_react_style_StyleSettings$.prototype;
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.scalacss$defaults$DefaultSettings$Dev$_setter_$cssRegisterNameGen_$eq__Lscalacss_internal_mutable_Register$NameGen__V = (function(x$1) {
  this.Lcom_iz2use_react_style_StyleSettings$__f_cssRegisterNameGen = x$1
});
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.scalacss$defaults$DefaultSettings$Dev$_setter_$cssRegisterErrorHandler_$eq__Lscalacss_internal_mutable_Register$ErrorHandler__V = (function(x$1) {
  this.Lcom_iz2use_react_style_StyleSettings$__f_cssRegisterErrorHandler = x$1
});
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.scalacss$defaults$Exports$_setter_$PseudoType_$eq__Lscalacss_internal_PseudoType$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.scalacss$defaults$Exports$_setter_$Pseudo_$eq__Lscalacss_internal_Pseudo$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.scalacss$defaults$Exports$_setter_$Domain_$eq__Lscalacss_internal_Domain$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.scalacss$defaults$Exports$_setter_$StyleA_$eq__Lscalacss_internal_StyleA$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.scalacss$defaults$Exports$_setter_$CssComposer_$eq__Lscalacss_internal_Compose$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.scalacss$defaults$Exports$_setter_$CssEnv_$eq__Lscalacss_internal_Env$__V = (function(x$1) {
  /*<skip>*/
});
var $d_Lcom_iz2use_react_style_StyleSettings$ = new $TypeData().initClass({
  Lcom_iz2use_react_style_StyleSettings$: 0
}, false, "com.iz2use.react.style.StyleSettings$", {
  Lcom_iz2use_react_style_StyleSettings$: 1,
  O: 1,
  Lscalacss_defaults_Exports: 1,
  Lscalacss_defaults_PlatformExports: 1,
  Lcom_iz2use_react_style_MyDev: 1,
  Lscalacss_defaults_DefaultSettings$Dev: 1,
  Lscalacss_internal_mutable_Settings: 1
});
$c_Lcom_iz2use_react_style_StyleSettings$.prototype.$classData = $d_Lcom_iz2use_react_style_StyleSettings$;
var $n_Lcom_iz2use_react_style_StyleSettings$;
function $m_Lcom_iz2use_react_style_StyleSettings$() {
  if ((!$n_Lcom_iz2use_react_style_StyleSettings$)) {
    $n_Lcom_iz2use_react_style_StyleSettings$ = new $c_Lcom_iz2use_react_style_StyleSettings$()
  };
  return $n_Lcom_iz2use_react_style_StyleSettings$
}
/** @constructor */
function $c_Ldiode_ActionResult$EffectOnly(effect) {
  this.Ldiode_ActionResult$EffectOnly__f_effect = null;
  this.Ldiode_ActionResult$EffectOnly__f_effect = effect
}
$c_Ldiode_ActionResult$EffectOnly.prototype = new $h_O();
$c_Ldiode_ActionResult$EffectOnly.prototype.constructor = $c_Ldiode_ActionResult$EffectOnly;
/** @constructor */
function $h_Ldiode_ActionResult$EffectOnly() {
  /*<skip>*/
}
$h_Ldiode_ActionResult$EffectOnly.prototype = $c_Ldiode_ActionResult$EffectOnly.prototype;
$c_Ldiode_ActionResult$EffectOnly.prototype.effectOpt__s_Option = (function() {
  return new $c_s_Some(this.Ldiode_ActionResult$EffectOnly__f_effect)
});
$c_Ldiode_ActionResult$EffectOnly.prototype.newModelOpt__s_Option = (function() {
  return $m_s_None$()
});
$c_Ldiode_ActionResult$EffectOnly.prototype.productPrefix__T = (function() {
  return "EffectOnly"
});
$c_Ldiode_ActionResult$EffectOnly.prototype.productArity__I = (function() {
  return 1
});
$c_Ldiode_ActionResult$EffectOnly.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ldiode_ActionResult$EffectOnly__f_effect : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ldiode_ActionResult$EffectOnly.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_ActionResult$EffectOnly.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiode_ActionResult$EffectOnly.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_ActionResult$EffectOnly.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ldiode_ActionResult$EffectOnly)) {
    var EffectOnly$1 = $as_Ldiode_ActionResult$EffectOnly(x$1);
    var x = this.Ldiode_ActionResult$EffectOnly__f_effect;
    var x$2 = $n(EffectOnly$1).Ldiode_ActionResult$EffectOnly__f_effect;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
function $as_Ldiode_ActionResult$EffectOnly(obj) {
  return (((obj instanceof $c_Ldiode_ActionResult$EffectOnly) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ActionResult$EffectOnly"))
}
function $isArrayOf_Ldiode_ActionResult$EffectOnly(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ActionResult$EffectOnly)))
}
function $asArrayOf_Ldiode_ActionResult$EffectOnly(obj, depth) {
  return (($isArrayOf_Ldiode_ActionResult$EffectOnly(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ActionResult$EffectOnly;", depth))
}
var $d_Ldiode_ActionResult$EffectOnly = new $TypeData().initClass({
  Ldiode_ActionResult$EffectOnly: 0
}, false, "diode.ActionResult$EffectOnly", {
  Ldiode_ActionResult$EffectOnly: 1,
  O: 1,
  Ldiode_ActionResult: 1,
  Ldiode_HasEffect: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_ActionResult$EffectOnly.prototype.$classData = $d_Ldiode_ActionResult$EffectOnly;
/** @constructor */
function $c_Ldiode_ActionResult$ModelUpdate(newModel) {
  this.Ldiode_ActionResult$ModelUpdate__f_newModel = null;
  this.Ldiode_ActionResult$ModelUpdate__f_newModel = newModel
}
$c_Ldiode_ActionResult$ModelUpdate.prototype = new $h_O();
$c_Ldiode_ActionResult$ModelUpdate.prototype.constructor = $c_Ldiode_ActionResult$ModelUpdate;
/** @constructor */
function $h_Ldiode_ActionResult$ModelUpdate() {
  /*<skip>*/
}
$h_Ldiode_ActionResult$ModelUpdate.prototype = $c_Ldiode_ActionResult$ModelUpdate.prototype;
$c_Ldiode_ActionResult$ModelUpdate.prototype.newModelOpt__s_Option = (function() {
  return new $c_s_Some(this.Ldiode_ActionResult$ModelUpdate__f_newModel)
});
$c_Ldiode_ActionResult$ModelUpdate.prototype.effectOpt__s_Option = (function() {
  return $m_s_None$()
});
$c_Ldiode_ActionResult$ModelUpdate.prototype.productPrefix__T = (function() {
  return "ModelUpdate"
});
$c_Ldiode_ActionResult$ModelUpdate.prototype.productArity__I = (function() {
  return 1
});
$c_Ldiode_ActionResult$ModelUpdate.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ldiode_ActionResult$ModelUpdate__f_newModel : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ldiode_ActionResult$ModelUpdate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_ActionResult$ModelUpdate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiode_ActionResult$ModelUpdate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_ActionResult$ModelUpdate.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ldiode_ActionResult$ModelUpdate)) {
    var ModelUpdate$1 = $as_Ldiode_ActionResult$ModelUpdate(x$1);
    var x = this.Ldiode_ActionResult$ModelUpdate__f_newModel;
    var y = $n(ModelUpdate$1).Ldiode_ActionResult$ModelUpdate__f_newModel;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Ldiode_ActionResult$ModelUpdate(obj) {
  return (((obj instanceof $c_Ldiode_ActionResult$ModelUpdate) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ActionResult$ModelUpdate"))
}
function $isArrayOf_Ldiode_ActionResult$ModelUpdate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ActionResult$ModelUpdate)))
}
function $asArrayOf_Ldiode_ActionResult$ModelUpdate(obj, depth) {
  return (($isArrayOf_Ldiode_ActionResult$ModelUpdate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ActionResult$ModelUpdate;", depth))
}
var $d_Ldiode_ActionResult$ModelUpdate = new $TypeData().initClass({
  Ldiode_ActionResult$ModelUpdate: 0
}, false, "diode.ActionResult$ModelUpdate", {
  Ldiode_ActionResult$ModelUpdate: 1,
  O: 1,
  Ldiode_ModelUpdated: 1,
  Ldiode_ActionResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_ActionResult$ModelUpdate.prototype.$classData = $d_Ldiode_ActionResult$ModelUpdate;
function $f_Ldiode_BaseModelRW__zoomRW__F1__F2__Ldiode_FastEq__Ldiode_ZoomModelRW($thiz, get, set, feq) {
  return new $c_Ldiode_ZoomModelRW($thiz.root__Ldiode_ModelR(), $n(get).compose__F1__F1(new $c_sjsr_AnonFunction1(((model$2) => $thiz.eval__O__O(model$2)))), new $c_sjsr_AnonFunction2(((s$2, u$2) => $thiz.updatedWith__O__O__O(s$2, $n(set).apply__O__O__O($thiz.eval__O__O(s$2), u$2)))), feq)
}
/** @constructor */
function $c_Ldiode_data_Failed(exception) {
  this.Ldiode_data_Failed__f_exception = null;
  this.Ldiode_data_Failed__f_exception = exception
}
$c_Ldiode_data_Failed.prototype = new $h_Ldiode_data_Pot();
$c_Ldiode_data_Failed.prototype.constructor = $c_Ldiode_data_Failed;
/** @constructor */
function $h_Ldiode_data_Failed() {
  /*<skip>*/
}
$h_Ldiode_data_Failed.prototype = $c_Ldiode_data_Failed.prototype;
$c_Ldiode_data_Failed.prototype.isPending__Z = (function() {
  return false
});
$c_Ldiode_data_Failed.prototype.isFailed__Z = (function() {
  return true
});
$c_Ldiode_data_Failed.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Failed.get")
});
$c_Ldiode_data_Failed.prototype.isEmpty__Z = (function() {
  return true
});
$c_Ldiode_data_Failed.prototype.isStale__Z = (function() {
  return false
});
$c_Ldiode_data_Failed.prototype.pending$default$1__J = (function() {
  var this$2 = $ct_ju_Date__(new $c_ju_Date());
  return this$2.ju_Date__f_java$util$Date$$millis
});
$c_Ldiode_data_Failed.prototype.productPrefix__T = (function() {
  return "Failed"
});
$c_Ldiode_data_Failed.prototype.productArity__I = (function() {
  return 1
});
$c_Ldiode_data_Failed.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ldiode_data_Failed__f_exception : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ldiode_data_Failed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_Failed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiode_data_Failed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_data_Failed.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ldiode_data_Failed)) {
    var Failed$1 = $as_Ldiode_data_Failed(x$1);
    var x = this.Ldiode_data_Failed__f_exception;
    var x$2 = $n(Failed$1).Ldiode_data_Failed__f_exception;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ldiode_data_Failed.prototype.state__Ldiode_data_PotState = (function() {
  return $m_Ldiode_data_PotState$PotFailed$()
});
$c_Ldiode_data_Failed.prototype.fail__jl_Throwable__Ldiode_data_Pot = (function(exception) {
  return new $c_Ldiode_data_Failed(exception)
});
$c_Ldiode_data_Failed.prototype.pending__J__Ldiode_data_Pot = (function(startTime) {
  return new $c_Ldiode_data_Pending(startTime)
});
$c_Ldiode_data_Failed.prototype.exceptionOption__s_Option = (function() {
  return new $c_s_Some(this.Ldiode_data_Failed__f_exception)
});
$c_Ldiode_data_Failed.prototype.get__O = (function() {
  this.get__E()
});
function $as_Ldiode_data_Failed(obj) {
  return (((obj instanceof $c_Ldiode_data_Failed) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.data.Failed"))
}
function $isArrayOf_Ldiode_data_Failed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_data_Failed)))
}
function $asArrayOf_Ldiode_data_Failed(obj, depth) {
  return (($isArrayOf_Ldiode_data_Failed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.data.Failed;", depth))
}
var $d_Ldiode_data_Failed = new $TypeData().initClass({
  Ldiode_data_Failed: 0
}, false, "diode.data.Failed", {
  Ldiode_data_Failed: 1,
  Ldiode_data_Pot: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1,
  Ldiode_data_FailedBase: 1
});
$c_Ldiode_data_Failed.prototype.$classData = $d_Ldiode_data_Failed;
/** @constructor */
function $c_Ldiode_data_FailedStale(x, exception) {
  this.Ldiode_data_FailedStale__f_x = null;
  this.Ldiode_data_FailedStale__f_exception = null;
  this.Ldiode_data_FailedStale__f_x = x;
  this.Ldiode_data_FailedStale__f_exception = exception
}
$c_Ldiode_data_FailedStale.prototype = new $h_Ldiode_data_Pot();
$c_Ldiode_data_FailedStale.prototype.constructor = $c_Ldiode_data_FailedStale;
/** @constructor */
function $h_Ldiode_data_FailedStale() {
  /*<skip>*/
}
$h_Ldiode_data_FailedStale.prototype = $c_Ldiode_data_FailedStale.prototype;
$c_Ldiode_data_FailedStale.prototype.isPending__Z = (function() {
  return false
});
$c_Ldiode_data_FailedStale.prototype.isFailed__Z = (function() {
  return true
});
$c_Ldiode_data_FailedStale.prototype.get__O = (function() {
  return this.Ldiode_data_FailedStale__f_x
});
$c_Ldiode_data_FailedStale.prototype.isEmpty__Z = (function() {
  return false
});
$c_Ldiode_data_FailedStale.prototype.isStale__Z = (function() {
  return true
});
$c_Ldiode_data_FailedStale.prototype.pending$default$1__J = (function() {
  var this$2 = $ct_ju_Date__(new $c_ju_Date());
  return this$2.ju_Date__f_java$util$Date$$millis
});
$c_Ldiode_data_FailedStale.prototype.productPrefix__T = (function() {
  return "FailedStale"
});
$c_Ldiode_data_FailedStale.prototype.productArity__I = (function() {
  return 2
});
$c_Ldiode_data_FailedStale.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ldiode_data_FailedStale__f_x;
      break
    }
    case 1: {
      return this.Ldiode_data_FailedStale__f_exception;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ldiode_data_FailedStale.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_FailedStale.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiode_data_FailedStale.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_data_FailedStale.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ldiode_data_FailedStale)) {
    var FailedStale$1 = $as_Ldiode_data_FailedStale(x$1);
    var x = this.Ldiode_data_FailedStale__f_x;
    var y = $n(FailedStale$1).Ldiode_data_FailedStale__f_x;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Ldiode_data_FailedStale__f_exception;
      var x$2$1 = $n(FailedStale$1).Ldiode_data_FailedStale__f_exception;
      return ((x$2 === null) ? (x$2$1 === null) : $n(x$2).equals__O__Z(x$2$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ldiode_data_FailedStale.prototype.state__Ldiode_data_PotState = (function() {
  return $m_Ldiode_data_PotState$PotFailed$()
});
$c_Ldiode_data_FailedStale.prototype.fail__jl_Throwable__Ldiode_data_Pot = (function(exception) {
  return new $c_Ldiode_data_FailedStale(this.Ldiode_data_FailedStale__f_x, exception)
});
$c_Ldiode_data_FailedStale.prototype.pending__J__Ldiode_data_Pot = (function(startTime) {
  return new $c_Ldiode_data_PendingStale(this.Ldiode_data_FailedStale__f_x, startTime)
});
$c_Ldiode_data_FailedStale.prototype.exceptionOption__s_Option = (function() {
  return new $c_s_Some(this.Ldiode_data_FailedStale__f_exception)
});
function $as_Ldiode_data_FailedStale(obj) {
  return (((obj instanceof $c_Ldiode_data_FailedStale) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.data.FailedStale"))
}
function $isArrayOf_Ldiode_data_FailedStale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_data_FailedStale)))
}
function $asArrayOf_Ldiode_data_FailedStale(obj, depth) {
  return (($isArrayOf_Ldiode_data_FailedStale(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.data.FailedStale;", depth))
}
var $d_Ldiode_data_FailedStale = new $TypeData().initClass({
  Ldiode_data_FailedStale: 0
}, false, "diode.data.FailedStale", {
  Ldiode_data_FailedStale: 1,
  Ldiode_data_Pot: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1,
  Ldiode_data_FailedBase: 1
});
$c_Ldiode_data_FailedStale.prototype.$classData = $d_Ldiode_data_FailedStale;
/** @constructor */
function $c_Ldiode_data_Pending(startTime) {
  this.Ldiode_data_Pending__f_startTime = $L0;
  this.Ldiode_data_Pending__f_startTime = startTime
}
$c_Ldiode_data_Pending.prototype = new $h_Ldiode_data_Pot();
$c_Ldiode_data_Pending.prototype.constructor = $c_Ldiode_data_Pending;
/** @constructor */
function $h_Ldiode_data_Pending() {
  /*<skip>*/
}
$h_Ldiode_data_Pending.prototype = $c_Ldiode_data_Pending.prototype;
$c_Ldiode_data_Pending.prototype.isPending__Z = (function() {
  return true
});
$c_Ldiode_data_Pending.prototype.startTime__J = (function() {
  return this.Ldiode_data_Pending__f_startTime
});
$c_Ldiode_data_Pending.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Pending.get")
});
$c_Ldiode_data_Pending.prototype.isEmpty__Z = (function() {
  return true
});
$c_Ldiode_data_Pending.prototype.isFailed__Z = (function() {
  return false
});
$c_Ldiode_data_Pending.prototype.isStale__Z = (function() {
  return false
});
$c_Ldiode_data_Pending.prototype.pending$default$1__J = (function() {
  return this.Ldiode_data_Pending__f_startTime
});
$c_Ldiode_data_Pending.prototype.productPrefix__T = (function() {
  return "Pending"
});
$c_Ldiode_data_Pending.prototype.productArity__I = (function() {
  return 1
});
$c_Ldiode_data_Pending.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ldiode_data_Pending__f_startTime : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ldiode_data_Pending.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_Pending.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Pending");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Ldiode_data_Pending__f_startTime;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Ldiode_data_Pending.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_data_Pending.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ldiode_data_Pending)) {
    var Pending$1 = $as_Ldiode_data_Pending(x$1);
    var this$1 = this.Ldiode_data_Pending__f_startTime;
    var b = $n(Pending$1).Ldiode_data_Pending__f_startTime;
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return false
  }
});
$c_Ldiode_data_Pending.prototype.state__Ldiode_data_PotState = (function() {
  return $m_Ldiode_data_PotState$PotPending$()
});
$c_Ldiode_data_Pending.prototype.fail__jl_Throwable__Ldiode_data_Pot = (function(exception) {
  return new $c_Ldiode_data_Failed(exception)
});
$c_Ldiode_data_Pending.prototype.pending__J__Ldiode_data_Pot = (function(startTime) {
  return new $c_Ldiode_data_Pending(startTime)
});
$c_Ldiode_data_Pending.prototype.get__O = (function() {
  this.get__E()
});
function $as_Ldiode_data_Pending(obj) {
  return (((obj instanceof $c_Ldiode_data_Pending) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.data.Pending"))
}
function $isArrayOf_Ldiode_data_Pending(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_data_Pending)))
}
function $asArrayOf_Ldiode_data_Pending(obj, depth) {
  return (($isArrayOf_Ldiode_data_Pending(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.data.Pending;", depth))
}
var $d_Ldiode_data_Pending = new $TypeData().initClass({
  Ldiode_data_Pending: 0
}, false, "diode.data.Pending", {
  Ldiode_data_Pending: 1,
  Ldiode_data_Pot: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1,
  Ldiode_data_PendingBase: 1
});
$c_Ldiode_data_Pending.prototype.$classData = $d_Ldiode_data_Pending;
/** @constructor */
function $c_Ldiode_data_PendingStale(x, startTime) {
  this.Ldiode_data_PendingStale__f_x = null;
  this.Ldiode_data_PendingStale__f_startTime = $L0;
  this.Ldiode_data_PendingStale__f_x = x;
  this.Ldiode_data_PendingStale__f_startTime = startTime
}
$c_Ldiode_data_PendingStale.prototype = new $h_Ldiode_data_Pot();
$c_Ldiode_data_PendingStale.prototype.constructor = $c_Ldiode_data_PendingStale;
/** @constructor */
function $h_Ldiode_data_PendingStale() {
  /*<skip>*/
}
$h_Ldiode_data_PendingStale.prototype = $c_Ldiode_data_PendingStale.prototype;
$c_Ldiode_data_PendingStale.prototype.isPending__Z = (function() {
  return true
});
$c_Ldiode_data_PendingStale.prototype.startTime__J = (function() {
  return this.Ldiode_data_PendingStale__f_startTime
});
$c_Ldiode_data_PendingStale.prototype.get__O = (function() {
  return this.Ldiode_data_PendingStale__f_x
});
$c_Ldiode_data_PendingStale.prototype.isEmpty__Z = (function() {
  return false
});
$c_Ldiode_data_PendingStale.prototype.isFailed__Z = (function() {
  return false
});
$c_Ldiode_data_PendingStale.prototype.isStale__Z = (function() {
  return true
});
$c_Ldiode_data_PendingStale.prototype.pending$default$1__J = (function() {
  return this.Ldiode_data_PendingStale__f_startTime
});
$c_Ldiode_data_PendingStale.prototype.productPrefix__T = (function() {
  return "PendingStale"
});
$c_Ldiode_data_PendingStale.prototype.productArity__I = (function() {
  return 2
});
$c_Ldiode_data_PendingStale.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ldiode_data_PendingStale__f_x;
      break
    }
    case 1: {
      return this.Ldiode_data_PendingStale__f_startTime;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ldiode_data_PendingStale.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_data_PendingStale.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("PendingStale");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Ldiode_data_PendingStale__f_x;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t = this.Ldiode_data_PendingStale__f_startTime;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$2 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Ldiode_data_PendingStale.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_data_PendingStale.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ldiode_data_PendingStale)) {
    var PendingStale$1 = $as_Ldiode_data_PendingStale(x$1);
    var this$1 = this.Ldiode_data_PendingStale__f_startTime;
    var b = $n(PendingStale$1).Ldiode_data_PendingStale__f_startTime;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Ldiode_data_PendingStale__f_x;
      var y = $n(PendingStale$1).Ldiode_data_PendingStale__f_x;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ldiode_data_PendingStale.prototype.state__Ldiode_data_PotState = (function() {
  return $m_Ldiode_data_PotState$PotPending$()
});
$c_Ldiode_data_PendingStale.prototype.fail__jl_Throwable__Ldiode_data_Pot = (function(exception) {
  return new $c_Ldiode_data_FailedStale(this.Ldiode_data_PendingStale__f_x, exception)
});
$c_Ldiode_data_PendingStale.prototype.pending__J__Ldiode_data_Pot = (function(startTime) {
  var x = this.Ldiode_data_PendingStale__f_x;
  return new $c_Ldiode_data_PendingStale(x, startTime)
});
function $as_Ldiode_data_PendingStale(obj) {
  return (((obj instanceof $c_Ldiode_data_PendingStale) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.data.PendingStale"))
}
function $isArrayOf_Ldiode_data_PendingStale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_data_PendingStale)))
}
function $asArrayOf_Ldiode_data_PendingStale(obj, depth) {
  return (($isArrayOf_Ldiode_data_PendingStale(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.data.PendingStale;", depth))
}
var $d_Ldiode_data_PendingStale = new $TypeData().initClass({
  Ldiode_data_PendingStale: 0
}, false, "diode.data.PendingStale", {
  Ldiode_data_PendingStale: 1,
  Ldiode_data_Pot: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1,
  Ldiode_data_PendingBase: 1
});
$c_Ldiode_data_PendingStale.prototype.$classData = $d_Ldiode_data_PendingStale;
function $p_Lfastparse_IndexedParserInput__lineNumberLookup$lzycompute__AI($thiz) {
  if ((!$thiz.Lfastparse_IndexedParserInput__f_bitmap$0)) {
    $thiz.Lfastparse_IndexedParserInput__f_lineNumberLookup = $m_Lfastparse_internal_Util$().lineNumberLookup__T__AI($thiz.Lfastparse_IndexedParserInput__f_data);
    $thiz.Lfastparse_IndexedParserInput__f_bitmap$0 = true
  };
  return $thiz.Lfastparse_IndexedParserInput__f_lineNumberLookup
}
function $p_Lfastparse_IndexedParserInput__lineNumberLookup__AI($thiz) {
  return ((!$thiz.Lfastparse_IndexedParserInput__f_bitmap$0) ? $p_Lfastparse_IndexedParserInput__lineNumberLookup$lzycompute__AI($thiz) : $thiz.Lfastparse_IndexedParserInput__f_lineNumberLookup)
}
/** @constructor */
function $c_Lfastparse_IndexedParserInput(data) {
  this.Lfastparse_IndexedParserInput__f_lineNumberLookup = null;
  this.Lfastparse_IndexedParserInput__f_data = null;
  this.Lfastparse_IndexedParserInput__f_bitmap$0 = false;
  this.Lfastparse_IndexedParserInput__f_data = data
}
$c_Lfastparse_IndexedParserInput.prototype = new $h_Lfastparse_ParserInput();
$c_Lfastparse_IndexedParserInput.prototype.constructor = $c_Lfastparse_IndexedParserInput;
/** @constructor */
function $h_Lfastparse_IndexedParserInput() {
  /*<skip>*/
}
$h_Lfastparse_IndexedParserInput.prototype = $c_Lfastparse_IndexedParserInput.prototype;
$c_Lfastparse_IndexedParserInput.prototype.slice__I__I__T = (function(from, until) {
  var $$x1 = $m_sc_StringOps$();
  var x = this.Lfastparse_IndexedParserInput__f_data;
  return $n($$x1).slice$extension__T__I__I__T(x, from, until)
});
$c_Lfastparse_IndexedParserInput.prototype.isReachable__I__Z = (function(index) {
  var this$1 = $n(this.Lfastparse_IndexedParserInput__f_data);
  return (index < this$1.length)
});
$c_Lfastparse_IndexedParserInput.prototype.prettyIndex__I__T = (function(index) {
  var xs = $p_Lfastparse_IndexedParserInput__lineNumberLookup__AI(this);
  $m_sc_ArrayOps$();
  var x$2 = 0;
  $m_sc_ArrayOps$();
  _return: {
    var i = x$2;
    while ((i < $n(xs).u.length)) {
      var x1 = i;
      var arg1 = $n(xs).get(x1);
      if ((arg1 > index)) {
        var x1$1 = i;
        break _return
      };
      i = ((1 + i) | 0)
    };
    var x1$1 = (-1)
  };
  if ((x1$1 === (-1))) {
    var line = (((-1) + $n($p_Lfastparse_IndexedParserInput__lineNumberLookup__AI(this)).u.length) | 0)
  } else {
    var y = (((-1) + x1$1) | 0);
    var line = ((y < 0) ? 0 : y)
  };
  var col = ((index - $n($p_Lfastparse_IndexedParserInput__lineNumberLookup__AI(this)).get(line)) | 0);
  return ((((1 + line) | 0) + ":") + ((1 + col) | 0))
});
$c_Lfastparse_IndexedParserInput.prototype.productPrefix__T = (function() {
  return "IndexedParserInput"
});
$c_Lfastparse_IndexedParserInput.prototype.productArity__I = (function() {
  return 1
});
$c_Lfastparse_IndexedParserInput.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lfastparse_IndexedParserInput__f_data : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lfastparse_IndexedParserInput.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lfastparse_IndexedParserInput.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfastparse_IndexedParserInput.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfastparse_IndexedParserInput.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lfastparse_IndexedParserInput)) {
    var IndexedParserInput$1 = $as_Lfastparse_IndexedParserInput(x$1);
    return ((this.Lfastparse_IndexedParserInput__f_data === $n(IndexedParserInput$1).Lfastparse_IndexedParserInput__f_data) && ($n(IndexedParserInput$1), true))
  } else {
    return false
  }
});
function $as_Lfastparse_IndexedParserInput(obj) {
  return (((obj instanceof $c_Lfastparse_IndexedParserInput) || (obj === null)) ? obj : $throwClassCastException(obj, "fastparse.IndexedParserInput"))
}
function $isArrayOf_Lfastparse_IndexedParserInput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfastparse_IndexedParserInput)))
}
function $asArrayOf_Lfastparse_IndexedParserInput(obj, depth) {
  return (($isArrayOf_Lfastparse_IndexedParserInput(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfastparse.IndexedParserInput;", depth))
}
var $d_Lfastparse_IndexedParserInput = new $TypeData().initClass({
  Lfastparse_IndexedParserInput: 0
}, false, "fastparse.IndexedParserInput", {
  Lfastparse_IndexedParserInput: 1,
  Lfastparse_ParserInput: 1,
  O: 1,
  Lfastparse_IsReachable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lfastparse_IndexedParserInput.prototype.$classData = $d_Lfastparse_IndexedParserInput;
/** @constructor */
function $c_Lio_circe_CursorOp$DeleteGoParent$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.constructor = $c_Lio_circe_CursorOp$DeleteGoParent$;
/** @constructor */
function $h_Lio_circe_CursorOp$DeleteGoParent$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$DeleteGoParent$.prototype = $c_Lio_circe_CursorOp$DeleteGoParent$.prototype;
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productPrefix__T = (function() {
  return "DeleteGoParent"
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.hashCode__I = (function() {
  return (-1822060899)
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.toString__T = (function() {
  return "DeleteGoParent"
});
var $d_Lio_circe_CursorOp$DeleteGoParent$ = new $TypeData().initClass({
  Lio_circe_CursorOp$DeleteGoParent$: 0
}, false, "io.circe.CursorOp$DeleteGoParent$", {
  Lio_circe_CursorOp$DeleteGoParent$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.$classData = $d_Lio_circe_CursorOp$DeleteGoParent$;
var $n_Lio_circe_CursorOp$DeleteGoParent$;
function $m_Lio_circe_CursorOp$DeleteGoParent$() {
  if ((!$n_Lio_circe_CursorOp$DeleteGoParent$)) {
    $n_Lio_circe_CursorOp$DeleteGoParent$ = new $c_Lio_circe_CursorOp$DeleteGoParent$()
  };
  return $n_Lio_circe_CursorOp$DeleteGoParent$
}
/** @constructor */
function $c_Lio_circe_CursorOp$DownArray$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$DownArray$.prototype = new $h_Lio_circe_CursorOp$ArrayOp();
$c_Lio_circe_CursorOp$DownArray$.prototype.constructor = $c_Lio_circe_CursorOp$DownArray$;
/** @constructor */
function $h_Lio_circe_CursorOp$DownArray$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$DownArray$.prototype = $c_Lio_circe_CursorOp$DownArray$.prototype;
$c_Lio_circe_CursorOp$DownArray$.prototype.productPrefix__T = (function() {
  return "DownArray"
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$DownArray$.prototype.hashCode__I = (function() {
  return (-1017900361)
});
$c_Lio_circe_CursorOp$DownArray$.prototype.toString__T = (function() {
  return "DownArray"
});
var $d_Lio_circe_CursorOp$DownArray$ = new $TypeData().initClass({
  Lio_circe_CursorOp$DownArray$: 0
}, false, "io.circe.CursorOp$DownArray$", {
  Lio_circe_CursorOp$DownArray$: 1,
  Lio_circe_CursorOp$ArrayOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$DownArray$.prototype.$classData = $d_Lio_circe_CursorOp$DownArray$;
var $n_Lio_circe_CursorOp$DownArray$;
function $m_Lio_circe_CursorOp$DownArray$() {
  if ((!$n_Lio_circe_CursorOp$DownArray$)) {
    $n_Lio_circe_CursorOp$DownArray$ = new $c_Lio_circe_CursorOp$DownArray$()
  };
  return $n_Lio_circe_CursorOp$DownArray$
}
/** @constructor */
function $c_Lio_circe_CursorOp$DownField(k) {
  this.Lio_circe_CursorOp$DownField__f_k = null;
  this.Lio_circe_CursorOp$DownField__f_k = k
}
$c_Lio_circe_CursorOp$DownField.prototype = new $h_Lio_circe_CursorOp$ObjectOp();
$c_Lio_circe_CursorOp$DownField.prototype.constructor = $c_Lio_circe_CursorOp$DownField;
/** @constructor */
function $h_Lio_circe_CursorOp$DownField() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$DownField.prototype = $c_Lio_circe_CursorOp$DownField.prototype;
$c_Lio_circe_CursorOp$DownField.prototype.productPrefix__T = (function() {
  return "DownField"
});
$c_Lio_circe_CursorOp$DownField.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_CursorOp$DownField.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_CursorOp$DownField__f_k : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_CursorOp$DownField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$DownField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_circe_CursorOp$DownField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_CursorOp$DownField.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_circe_CursorOp$DownField)) {
    var DownField$1 = $as_Lio_circe_CursorOp$DownField(x$1);
    return (this.Lio_circe_CursorOp$DownField__f_k === $n(DownField$1).Lio_circe_CursorOp$DownField__f_k)
  } else {
    return false
  }
});
function $as_Lio_circe_CursorOp$DownField(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$DownField) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$DownField"))
}
function $isArrayOf_Lio_circe_CursorOp$DownField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$DownField)))
}
function $asArrayOf_Lio_circe_CursorOp$DownField(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$DownField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$DownField;", depth))
}
var $d_Lio_circe_CursorOp$DownField = new $TypeData().initClass({
  Lio_circe_CursorOp$DownField: 0
}, false, "io.circe.CursorOp$DownField", {
  Lio_circe_CursorOp$DownField: 1,
  Lio_circe_CursorOp$ObjectOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$DownField.prototype.$classData = $d_Lio_circe_CursorOp$DownField;
/** @constructor */
function $c_Lio_circe_CursorOp$DownN(n) {
  this.Lio_circe_CursorOp$DownN__f_n = 0;
  this.Lio_circe_CursorOp$DownN__f_n = n
}
$c_Lio_circe_CursorOp$DownN.prototype = new $h_Lio_circe_CursorOp$ArrayOp();
$c_Lio_circe_CursorOp$DownN.prototype.constructor = $c_Lio_circe_CursorOp$DownN;
/** @constructor */
function $h_Lio_circe_CursorOp$DownN() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$DownN.prototype = $c_Lio_circe_CursorOp$DownN.prototype;
$c_Lio_circe_CursorOp$DownN.prototype.productPrefix__T = (function() {
  return "DownN"
});
$c_Lio_circe_CursorOp$DownN.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_circe_CursorOp$DownN.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_circe_CursorOp$DownN__f_n : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_circe_CursorOp$DownN.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$DownN.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DownN");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lio_circe_CursorOp$DownN__f_n;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lio_circe_CursorOp$DownN.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_circe_CursorOp$DownN.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_circe_CursorOp$DownN)) {
    var DownN$1 = $as_Lio_circe_CursorOp$DownN(x$1);
    return (this.Lio_circe_CursorOp$DownN__f_n === $n(DownN$1).Lio_circe_CursorOp$DownN__f_n)
  } else {
    return false
  }
});
function $as_Lio_circe_CursorOp$DownN(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$DownN) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$DownN"))
}
function $isArrayOf_Lio_circe_CursorOp$DownN(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$DownN)))
}
function $asArrayOf_Lio_circe_CursorOp$DownN(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$DownN(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$DownN;", depth))
}
var $d_Lio_circe_CursorOp$DownN = new $TypeData().initClass({
  Lio_circe_CursorOp$DownN: 0
}, false, "io.circe.CursorOp$DownN", {
  Lio_circe_CursorOp$DownN: 1,
  Lio_circe_CursorOp$ArrayOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$DownN.prototype.$classData = $d_Lio_circe_CursorOp$DownN;
function $as_Lio_circe_CursorOp$Field(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$Field"))
}
function $isArrayOf_Lio_circe_CursorOp$Field(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$Field)))
}
function $asArrayOf_Lio_circe_CursorOp$Field(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$Field(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$Field;", depth))
}
function $as_Lio_circe_CursorOp$LeftN(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$LeftN"))
}
function $isArrayOf_Lio_circe_CursorOp$LeftN(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$LeftN)))
}
function $asArrayOf_Lio_circe_CursorOp$LeftN(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$LeftN(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$LeftN;", depth))
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveFirst$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$MoveFirst$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveFirst$.prototype.constructor = $c_Lio_circe_CursorOp$MoveFirst$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveFirst$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$MoveFirst$.prototype = $c_Lio_circe_CursorOp$MoveFirst$.prototype;
$c_Lio_circe_CursorOp$MoveFirst$.prototype.productPrefix__T = (function() {
  return "MoveFirst"
});
$c_Lio_circe_CursorOp$MoveFirst$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$MoveFirst$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_circe_CursorOp$MoveFirst$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$MoveFirst$.prototype.hashCode__I = (function() {
  return (-1245937345)
});
$c_Lio_circe_CursorOp$MoveFirst$.prototype.toString__T = (function() {
  return "MoveFirst"
});
var $d_Lio_circe_CursorOp$MoveFirst$ = new $TypeData().initClass({
  Lio_circe_CursorOp$MoveFirst$: 0
}, false, "io.circe.CursorOp$MoveFirst$", {
  Lio_circe_CursorOp$MoveFirst$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$MoveFirst$.prototype.$classData = $d_Lio_circe_CursorOp$MoveFirst$;
var $n_Lio_circe_CursorOp$MoveFirst$;
function $m_Lio_circe_CursorOp$MoveFirst$() {
  if ((!$n_Lio_circe_CursorOp$MoveFirst$)) {
    $n_Lio_circe_CursorOp$MoveFirst$ = new $c_Lio_circe_CursorOp$MoveFirst$()
  };
  return $n_Lio_circe_CursorOp$MoveFirst$
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveLeft$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$MoveLeft$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveLeft$.prototype.constructor = $c_Lio_circe_CursorOp$MoveLeft$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveLeft$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$MoveLeft$.prototype = $c_Lio_circe_CursorOp$MoveLeft$.prototype;
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productPrefix__T = (function() {
  return "MoveLeft"
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.hashCode__I = (function() {
  return (-40017000)
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.toString__T = (function() {
  return "MoveLeft"
});
var $d_Lio_circe_CursorOp$MoveLeft$ = new $TypeData().initClass({
  Lio_circe_CursorOp$MoveLeft$: 0
}, false, "io.circe.CursorOp$MoveLeft$", {
  Lio_circe_CursorOp$MoveLeft$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.$classData = $d_Lio_circe_CursorOp$MoveLeft$;
var $n_Lio_circe_CursorOp$MoveLeft$;
function $m_Lio_circe_CursorOp$MoveLeft$() {
  if ((!$n_Lio_circe_CursorOp$MoveLeft$)) {
    $n_Lio_circe_CursorOp$MoveLeft$ = new $c_Lio_circe_CursorOp$MoveLeft$()
  };
  return $n_Lio_circe_CursorOp$MoveLeft$
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveRight$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$MoveRight$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveRight$.prototype.constructor = $c_Lio_circe_CursorOp$MoveRight$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveRight$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$MoveRight$.prototype = $c_Lio_circe_CursorOp$MoveRight$.prototype;
$c_Lio_circe_CursorOp$MoveRight$.prototype.productPrefix__T = (function() {
  return "MoveRight"
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.hashCode__I = (function() {
  return (-1234866005)
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.toString__T = (function() {
  return "MoveRight"
});
var $d_Lio_circe_CursorOp$MoveRight$ = new $TypeData().initClass({
  Lio_circe_CursorOp$MoveRight$: 0
}, false, "io.circe.CursorOp$MoveRight$", {
  Lio_circe_CursorOp$MoveRight$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.$classData = $d_Lio_circe_CursorOp$MoveRight$;
var $n_Lio_circe_CursorOp$MoveRight$;
function $m_Lio_circe_CursorOp$MoveRight$() {
  if ((!$n_Lio_circe_CursorOp$MoveRight$)) {
    $n_Lio_circe_CursorOp$MoveRight$ = new $c_Lio_circe_CursorOp$MoveRight$()
  };
  return $n_Lio_circe_CursorOp$MoveRight$
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveUp$() {
  /*<skip>*/
}
$c_Lio_circe_CursorOp$MoveUp$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveUp$.prototype.constructor = $c_Lio_circe_CursorOp$MoveUp$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveUp$() {
  /*<skip>*/
}
$h_Lio_circe_CursorOp$MoveUp$.prototype = $c_Lio_circe_CursorOp$MoveUp$.prototype;
$c_Lio_circe_CursorOp$MoveUp$.prototype.productPrefix__T = (function() {
  return "MoveUp"
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.hashCode__I = (function() {
  return (-1984396692)
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.toString__T = (function() {
  return "MoveUp"
});
var $d_Lio_circe_CursorOp$MoveUp$ = new $TypeData().initClass({
  Lio_circe_CursorOp$MoveUp$: 0
}, false, "io.circe.CursorOp$MoveUp$", {
  Lio_circe_CursorOp$MoveUp$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.$classData = $d_Lio_circe_CursorOp$MoveUp$;
var $n_Lio_circe_CursorOp$MoveUp$;
function $m_Lio_circe_CursorOp$MoveUp$() {
  if ((!$n_Lio_circe_CursorOp$MoveUp$)) {
    $n_Lio_circe_CursorOp$MoveUp$ = new $c_Lio_circe_CursorOp$MoveUp$()
  };
  return $n_Lio_circe_CursorOp$MoveUp$
}
function $as_Lio_circe_CursorOp$RightN(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$RightN"))
}
function $isArrayOf_Lio_circe_CursorOp$RightN(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$RightN)))
}
function $asArrayOf_Lio_circe_CursorOp$RightN(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$RightN(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$RightN;", depth))
}
function $p_Lio_circe_DecodingFailure$$anon$2__history$lzycompute__sci_List($thiz) {
  if ((!$thiz.Lio_circe_DecodingFailure$$anon$2__f_bitmap$0)) {
    $thiz.Lio_circe_DecodingFailure$$anon$2__f_history = $as_sci_List($n($thiz.Lio_circe_DecodingFailure$$anon$2__f_ops$1).apply__O());
    $thiz.Lio_circe_DecodingFailure$$anon$2__f_bitmap$0 = true
  };
  $thiz.Lio_circe_DecodingFailure$$anon$2__f_ops$1 = null;
  return $thiz.Lio_circe_DecodingFailure$$anon$2__f_history
}
class $c_Lio_circe_DecodingFailure$$anon$2 extends $c_Lio_circe_DecodingFailure {
  constructor(message$2, ops$1) {
    super();
    this.Lio_circe_DecodingFailure$$anon$2__f_history = null;
    this.Lio_circe_DecodingFailure$$anon$2__f_bitmap$0 = false;
    this.Lio_circe_DecodingFailure$$anon$2__f_ops$1 = null;
    this.Lio_circe_DecodingFailure$$anon$2__f_ops$1 = ops$1;
    $ct_Lio_circe_DecodingFailure__T__(this, message$2)
  };
  history__sci_List() {
    return ((!this.Lio_circe_DecodingFailure$$anon$2__f_bitmap$0) ? $p_Lio_circe_DecodingFailure$$anon$2__history$lzycompute__sci_List(this) : this.Lio_circe_DecodingFailure$$anon$2__f_history)
  };
}
var $d_Lio_circe_DecodingFailure$$anon$2 = new $TypeData().initClass({
  Lio_circe_DecodingFailure$$anon$2: 0
}, false, "io.circe.DecodingFailure$$anon$2", {
  Lio_circe_DecodingFailure$$anon$2: 1,
  Lio_circe_DecodingFailure: 1,
  Lio_circe_Error: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_DecodingFailure$$anon$2.prototype.$classData = $d_Lio_circe_DecodingFailure$$anon$2;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$23(encodeA$1) {
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = null;
  $ct_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__Lio_circe_MidPriorityEncoders__Lio_circe_Encoder__(this, $m_Lio_circe_Encoder$(), encodeA$1)
}
$c_Lio_circe_Encoder$$anon$23.prototype = new $h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder();
$c_Lio_circe_Encoder$$anon$23.prototype.constructor = $c_Lio_circe_Encoder$$anon$23;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$23() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$23.prototype = $c_Lio_circe_Encoder$$anon$23.prototype;
$c_Lio_circe_Encoder$$anon$23.prototype.toIterator__O__sc_Iterator = (function(a) {
  var a$1 = $as_sci_Seq(a);
  return $n(a$1).iterator__sc_Iterator()
});
var $d_Lio_circe_Encoder$$anon$23 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$23: 0
}, false, "io.circe.Encoder$$anon$23", {
  Lio_circe_Encoder$$anon$23: 1,
  Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsArray: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$23.prototype.$classData = $d_Lio_circe_Encoder$$anon$23;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$24(encodeA$2) {
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = null;
  $ct_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__Lio_circe_MidPriorityEncoders__Lio_circe_Encoder__(this, $m_Lio_circe_Encoder$(), encodeA$2)
}
$c_Lio_circe_Encoder$$anon$24.prototype = new $h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder();
$c_Lio_circe_Encoder$$anon$24.prototype.constructor = $c_Lio_circe_Encoder$$anon$24;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$24() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$24.prototype = $c_Lio_circe_Encoder$$anon$24.prototype;
$c_Lio_circe_Encoder$$anon$24.prototype.toIterator__O__sc_Iterator = (function(a) {
  var a$1 = $as_sci_Set(a);
  return $n(a$1).iterator__sc_Iterator()
});
var $d_Lio_circe_Encoder$$anon$24 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$24: 0
}, false, "io.circe.Encoder$$anon$24", {
  Lio_circe_Encoder$$anon$24: 1,
  Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsArray: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$24.prototype.$classData = $d_Lio_circe_Encoder$$anon$24;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$25(encodeA$3) {
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = null;
  $ct_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__Lio_circe_MidPriorityEncoders__Lio_circe_Encoder__(this, $m_Lio_circe_Encoder$(), encodeA$3)
}
$c_Lio_circe_Encoder$$anon$25.prototype = new $h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder();
$c_Lio_circe_Encoder$$anon$25.prototype.constructor = $c_Lio_circe_Encoder$$anon$25;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$25() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$25.prototype = $c_Lio_circe_Encoder$$anon$25.prototype;
$c_Lio_circe_Encoder$$anon$25.prototype.toIterator__O__sc_Iterator = (function(a) {
  var a$1 = $as_sci_List(a);
  return $n(a$1).iterator__sc_Iterator()
});
var $d_Lio_circe_Encoder$$anon$25 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$25: 0
}, false, "io.circe.Encoder$$anon$25", {
  Lio_circe_Encoder$$anon$25: 1,
  Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsArray: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$25.prototype.$classData = $d_Lio_circe_Encoder$$anon$25;
/** @constructor */
function $c_Lio_circe_Encoder$$anon$34(encodeK$2, encodeV$2, ev$2) {
  this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeK = null;
  this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeV = null;
  this.Lio_circe_Encoder$$anon$34__f_ev$2 = null;
  this.Lio_circe_Encoder$$anon$34__f_ev$2 = ev$2;
  $ct_Lio_circe_Encoder$IterableAsObjectEncoder__Lio_circe_KeyEncoder__Lio_circe_Encoder__(this, encodeK$2, encodeV$2)
}
$c_Lio_circe_Encoder$$anon$34.prototype = new $h_Lio_circe_Encoder$IterableAsObjectEncoder();
$c_Lio_circe_Encoder$$anon$34.prototype.constructor = $c_Lio_circe_Encoder$$anon$34;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$34() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$$anon$34.prototype = $c_Lio_circe_Encoder$$anon$34.prototype;
$c_Lio_circe_Encoder$$anon$34.prototype.toIterator__sc_Map__sc_Iterator = (function(a) {
  return $n($as_sc_IterableOnce($n(this.Lio_circe_Encoder$$anon$34__f_ev$2).apply__O__O(a))).iterator__sc_Iterator()
});
var $d_Lio_circe_Encoder$$anon$34 = new $TypeData().initClass({
  Lio_circe_Encoder$$anon$34: 0
}, false, "io.circe.Encoder$$anon$34", {
  Lio_circe_Encoder$$anon$34: 1,
  Lio_circe_Encoder$IterableAsObjectEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$$anon$34.prototype.$classData = $d_Lio_circe_Encoder$$anon$34;
/** @constructor */
function $c_Lio_circe_JsonBiggerDecimal(value, input) {
  this.Lio_circe_BiggerDecimalJsonNumber__f_input = null;
  this.Lio_circe_JsonBiggerDecimal__f_value = null;
  this.Lio_circe_JsonBiggerDecimal__f_input = null;
  this.Lio_circe_JsonBiggerDecimal__f_value = value;
  this.Lio_circe_JsonBiggerDecimal__f_input = input;
  $ct_Lio_circe_BiggerDecimalJsonNumber__T__(this, input)
}
$c_Lio_circe_JsonBiggerDecimal.prototype = new $h_Lio_circe_BiggerDecimalJsonNumber();
$c_Lio_circe_JsonBiggerDecimal.prototype.constructor = $c_Lio_circe_JsonBiggerDecimal;
/** @constructor */
function $h_Lio_circe_JsonBiggerDecimal() {
  /*<skip>*/
}
$h_Lio_circe_JsonBiggerDecimal.prototype = $c_Lio_circe_JsonBiggerDecimal.prototype;
$c_Lio_circe_JsonBiggerDecimal.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return this.Lio_circe_JsonBiggerDecimal__f_value
});
$c_Lio_circe_JsonBiggerDecimal.prototype.toDouble__D = (function() {
  return $n(this.Lio_circe_JsonBiggerDecimal__f_value).toDouble__D()
});
$c_Lio_circe_JsonBiggerDecimal.prototype.toFloat__F = (function() {
  return $n(this.Lio_circe_JsonBiggerDecimal__f_value).toFloat__F()
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productPrefix__T = (function() {
  return "JsonBiggerDecimal"
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productArity__I = (function() {
  return 2
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lio_circe_JsonBiggerDecimal__f_value;
      break
    }
    case 1: {
      return this.Lio_circe_JsonBiggerDecimal__f_input;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
var $d_Lio_circe_JsonBiggerDecimal = new $TypeData().initClass({
  Lio_circe_JsonBiggerDecimal: 0
}, false, "io.circe.JsonBiggerDecimal", {
  Lio_circe_JsonBiggerDecimal: 1,
  Lio_circe_BiggerDecimalJsonNumber: 1,
  Lio_circe_JsonNumber: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lio_circe_JsonBiggerDecimal.prototype.$classData = $d_Lio_circe_JsonBiggerDecimal;
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1(outer) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1__f_$outer = outer
  }
}
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype = new $h_O();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.className__T = (function() {
  return "Iterable"
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_Iterable$().newBuilder__scm_Builder()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.head__O = (function() {
  var this$1 = new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2(this);
  return this$1.next__T()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.zipWithIndex__O = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1$$anon$2(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $as_sc_IterableOps($m_sc_Iterable$().from__sc_IterableOnce__O(coll))
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1 = new $TypeData().initClass({
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1: 0
}, false, "io.circe.JsonObject$LinkedHashMapJsonObject$$anon$1", {
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.$classData = $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1;
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(outer) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5__f_$outer = outer
  }
}
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype = new $h_O();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5() {
  /*<skip>*/
}
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.className__T = (function() {
  return "Iterable"
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_Iterable$().newBuilder__scm_Builder()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.head__O = (function() {
  var this$1 = new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6(this);
  return this$1.next__T2()
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.zipWithIndex__O = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5$$anon$6(this)
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $as_sc_IterableOps($m_sc_Iterable$().from__sc_IterableOnce__O(coll))
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5 = new $TypeData().initClass({
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5: 0
}, false, "io.circe.JsonObject$LinkedHashMapJsonObject$$anon$5", {
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.$classData = $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5;
/** @constructor */
function $c_Lio_circe_MidPriorityEncoders$$anon$69(outer, encodeA$12, ev$3) {
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = null;
  this.Lio_circe_MidPriorityEncoders$$anon$69__f_ev$3 = null;
  this.Lio_circe_MidPriorityEncoders$$anon$69__f_ev$3 = ev$3;
  $ct_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__Lio_circe_MidPriorityEncoders__Lio_circe_Encoder__(this, outer, encodeA$12)
}
$c_Lio_circe_MidPriorityEncoders$$anon$69.prototype = new $h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder();
$c_Lio_circe_MidPriorityEncoders$$anon$69.prototype.constructor = $c_Lio_circe_MidPriorityEncoders$$anon$69;
/** @constructor */
function $h_Lio_circe_MidPriorityEncoders$$anon$69() {
  /*<skip>*/
}
$h_Lio_circe_MidPriorityEncoders$$anon$69.prototype = $c_Lio_circe_MidPriorityEncoders$$anon$69.prototype;
$c_Lio_circe_MidPriorityEncoders$$anon$69.prototype.toIterator__O__sc_Iterator = (function(a) {
  return $n($as_sc_IterableOnce($n(this.Lio_circe_MidPriorityEncoders$$anon$69__f_ev$3).apply__O__O(a))).iterator__sc_Iterator()
});
var $d_Lio_circe_MidPriorityEncoders$$anon$69 = new $TypeData().initClass({
  Lio_circe_MidPriorityEncoders$$anon$69: 0
}, false, "io.circe.MidPriorityEncoders$$anon$69", {
  Lio_circe_MidPriorityEncoders$$anon$69: 1,
  Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsArray: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_MidPriorityEncoders$$anon$69.prototype.$classData = $d_Lio_circe_MidPriorityEncoders$$anon$69;
/** @constructor */
function $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1(encode$1, gen$1) {
  this.Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1__f_encode$1 = null;
  this.Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1__f_gen$1 = null;
  this.Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1__f_encode$1 = encode$1;
  this.Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1__f_gen$1 = gen$1
}
$c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1.prototype = new $h_Lio_circe_generic_encoding_DerivedAsObjectEncoder();
$c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1.prototype.constructor = $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1;
/** @constructor */
function $h_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1.prototype = $c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1.prototype;
$c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $n($as_Lio_circe_Encoder$AsObject($n(this.Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1__f_encode$1).value__O())).encodeObject__O__Lio_circe_JsonObject($n(this.Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1__f_gen$1).to__O__O(a))
});
var $d_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1: 0
}, false, "io.circe.generic.encoding.DerivedAsObjectEncoder$$anon$1", {
  Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1: 1,
  Lio_circe_generic_encoding_DerivedAsObjectEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1.prototype.$classData = $d_Lio_circe_generic_encoding_DerivedAsObjectEncoder$$anon$1;
function $as_Lio_circe_generic_extras_JsonKey(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.generic.extras.JsonKey"))
}
function $isArrayOf_Lio_circe_generic_extras_JsonKey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_generic_extras_JsonKey)))
}
function $asArrayOf_Lio_circe_generic_extras_JsonKey(obj, depth) {
  return (($isArrayOf_Lio_circe_generic_extras_JsonKey(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.generic.extras.JsonKey;", depth))
}
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder(gen, decodeR, config, defaultMap, keyAnnotationMap) {
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_config = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_constructorNameCache = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_config = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_keyAnnotationMap = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_memberNameCache = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder__f_gen = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder__f_decodeR = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder__f_defaultMap = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder__f_gen = gen;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder__f_decodeR = decodeR;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder__f_defaultMap = defaultMap;
  $ct_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__Lio_circe_generic_extras_Configuration__sci_Map__(this, config, keyAnnotationMap)
}
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder.prototype = new $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder();
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder.prototype = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder.prototype;
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n($as_Lio_circe_generic_extras_decoding_ReprDecoder($n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder__f_decodeR).value__O())).configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either(c, new $c_sjsr_AnonFunction1(((value$2) => {
    var value = $as_T(value$2);
    return this.memberNameTransformer__T__T(value)
  })), new $c_sjsr_AnonFunction1(((value$3$2) => {
    var value$3 = $as_T(value$3$2);
    return this.constructorNameTransformer__T__T(value$3)
  })), this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder__f_defaultMap, $m_s_None$());
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var r = $as_Lshapeless_HList($n(x2).s_util_Right__f_value);
    $n($m_s_package$().s_package$__f_Right);
    var value$1 = $n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder__f_gen).from__O__O(r);
    return new $c_s_util_Right(value$1)
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
var $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder = new $TypeData().initClass({
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder: 0
}, false, "io.circe.generic.extras.decoding.ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder", {
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder: 1,
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder: 1,
  Lio_circe_generic_extras_decoding_ConfiguredDecoder: 1,
  Lio_circe_generic_decoding_DerivedDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder.prototype.$classData = $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder;
/** @constructor */
function $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder(gen, decodeR, config, defaultMap, keyNames, keyAnnotationMap) {
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_config = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder__f_constructorNameCache = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_config = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_keyAnnotationMap = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__f_memberNameCache = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_expectedFields = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_expectedFieldsStr = null;
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_wrapped = null;
  $ct_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder__Lio_circe_generic_extras_Configuration__sci_Map__(this, config, keyAnnotationMap);
  var this$2 = $n(keyNames);
  var f = ((value$2) => {
    var value = $as_T(value$2);
    return this.memberNameTransformer__T__T(value)
  });
  if ((this$2 === $m_sci_Nil$())) {
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x1 = h
  };
  var this$4 = $n($$x1);
  var this$3 = $n($n(config).Lio_circe_generic_extras_Configuration__f_discriminator);
  if (this$3.isEmpty__Z()) {
    var suffix = $m_s_None$()
  } else {
    var arg1$2 = this$3.get__O();
    var value$3 = $as_T(arg1$2);
    var suffix = new $c_s_Some(this.constructorNameTransformer__T__T(value$3))
  };
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_expectedFields = this$4.appendedAll__sc_IterableOnce__sci_List(suffix);
  var this$5 = $n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_expectedFields);
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_expectedFieldsStr = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", ", ", "");
  var this$18 = new $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$NonStrictCaseClassConfiguredDecoder(gen, decodeR, config, defaultMap, keyAnnotationMap);
  var errors = new $c_sjsr_AnonFunction1(((cursor$2) => {
    var cursor = $as_Lio_circe_HCursor(cursor$2);
    var this$6 = $n(cursor);
    var this$7 = new $c_s_Some(this$6.value__Lio_circe_Json());
    if (this$7.isEmpty__Z()) {
      var maybeUnexpectedErrors = $m_s_None$()
    } else {
      var arg1$3 = this$7.s_Some__f_value;
      var json = $as_Lio_circe_Json(arg1$3);
      var this$8 = $n(json);
      var this$10 = $n(new $c_Lio_circe_cursor_TopCursor(this$8, null, null).keys__s_Option());
      if (this$10.isEmpty__Z()) {
        var $$x2 = $m_s_None$()
      } else {
        var arg1$4 = this$10.get__O();
        var jsonKeys = $as_sc_Iterable(arg1$4);
        var this$11 = $n(jsonKeys);
        var this$12 = $n($m_sci_Set$().from__sc_IterableOnce__sci_Set(this$11));
        var that = this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_expectedFields;
        var unexpected = $as_sci_Set(this$12.removedAll__sc_IterableOnce__sci_SetOps(that));
        var $$x2 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), jsonKeys, unexpected))
      };
      var this$13 = $n($$x2);
      if (this$13.isEmpty__Z()) {
        var maybeUnexpectedErrors = $m_s_None$()
      } else {
        var arg1$5 = this$13.get__O();
        var x$1 = $as_T2(arg1$5);
        if ((x$1 === null)) {
          throw new $c_s_MatchError(x$1)
        };
        var unexpected$1 = $as_sci_Set($n(x$1)._2__O());
        var this$14 = $n(unexpected$1);
        $m_sci_List$();
        var this$16 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$14));
        var f$1 = ((unexpectedField$2) => {
          var unexpectedField = $as_T(unexpectedField$2);
          return ((("Unexpected field: [" + unexpectedField) + "]; valid fields: ") + this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_expectedFieldsStr)
        });
        if ((this$16 === $m_sci_Nil$())) {
          var $$x3 = $m_sci_Nil$()
        } else {
          var arg1$6 = this$16.head__O();
          var h$1 = new $c_sci_$colon$colon(f$1(arg1$6), $m_sci_Nil$());
          var t$1 = h$1;
          var rest$1 = $as_sci_List(this$16.tail__O());
          while ((rest$1 !== $m_sci_Nil$())) {
            var arg1$7 = $n(rest$1).head__O();
            var nx$1 = new $c_sci_$colon$colon(f$1(arg1$7), $m_sci_Nil$());
            $n(t$1).sci_$colon$colon__f_next = nx$1;
            t$1 = nx$1;
            rest$1 = $as_sci_List($n(rest$1).tail__O())
          };
          var $$x3 = h$1
        };
        var maybeUnexpectedErrors = new $c_s_Some($$x3)
      }
    };
    var this$17 = $n(maybeUnexpectedErrors);
    return $as_sci_List((this$17.isEmpty__Z() ? $m_sci_Nil$() : this$17.get__O()))
  }));
  this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_wrapped = new $c_Lio_circe_Decoder$$anon$7(this$18, errors)
}
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder.prototype = new $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder();
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder.prototype.constructor = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder;
/** @constructor */
function $h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder.prototype = $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder.prototype;
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $n(this.Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder__f_wrapped).apply__Lio_circe_HCursor__s_util_Either(c)
});
var $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder = new $TypeData().initClass({
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder: 0
}, false, "io.circe.generic.extras.decoding.ConfiguredDecoder$StrictCaseClassConfiguredDecoder", {
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder: 1,
  Lio_circe_generic_extras_decoding_ConfiguredDecoder$CaseClassConfiguredDecoder: 1,
  Lio_circe_generic_extras_decoding_ConfiguredDecoder: 1,
  Lio_circe_generic_decoding_DerivedDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder.prototype.$classData = $d_Lio_circe_generic_extras_decoding_ConfiguredDecoder$StrictCaseClassConfiguredDecoder;
function $ct_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__Lio_circe_generic_extras_Configuration__($thiz, config) {
  $thiz.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_config = config;
  $thiz.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_constructorNameCache = $ct_ju_concurrent_ConcurrentHashMap__(new $c_ju_concurrent_ConcurrentHashMap());
  return $thiz
}
/** @constructor */
function $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder() {
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_config = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_constructorNameCache = null
}
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder.prototype = new $h_Lio_circe_generic_encoding_DerivedAsObjectEncoder();
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder.prototype.constructor = $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder;
/** @constructor */
function $h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder.prototype = $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder.prototype;
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder.prototype.constructorNameTransformer__T__T = (function(value) {
  var current = $as_T($n(this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_constructorNameCache).get__O__O(value));
  if ((current === null)) {
    var transformed = $as_T($n($n(this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_config).Lio_circe_generic_extras_Configuration__f_transformConstructorNames).apply__O__O(value));
    $n(this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_constructorNameCache).put__O__O__O(value, transformed);
    return transformed
  } else {
    return current
  }
});
function $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(obj) {
  return (((obj instanceof $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.generic.extras.encoding.ConfiguredAsObjectEncoder"))
}
function $isArrayOf_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder)))
}
function $asArrayOf_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(obj, depth) {
  return (($isArrayOf_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.generic.extras.encoding.ConfiguredAsObjectEncoder;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_ComponentDom$Element(element) {
  this.Ljapgolly_scalajs_react_ComponentDom$Element__f_element = null;
  this.Ljapgolly_scalajs_react_ComponentDom$Element__f_element = element
}
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.constructor = $c_Ljapgolly_scalajs_react_ComponentDom$Element;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ComponentDom$Element() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ComponentDom$Element.prototype = $c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype;
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.productPrefix__T = (function() {
  return "Element"
});
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_ComponentDom$Element__f_element : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_ComponentDom$Element)) {
    var Element$1 = $as_Ljapgolly_scalajs_react_ComponentDom$Element(x$1);
    var x = this.Ljapgolly_scalajs_react_ComponentDom$Element__f_element;
    var y = $n(Element$1).Ljapgolly_scalajs_react_ComponentDom$Element__f_element;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.toElement__s_Option = (function() {
  return new $c_s_Some(this.Ljapgolly_scalajs_react_ComponentDom$Element__f_element)
});
function $as_Ljapgolly_scalajs_react_ComponentDom$Element(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_ComponentDom$Element) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.ComponentDom$Element"))
}
function $isArrayOf_Ljapgolly_scalajs_react_ComponentDom$Element(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_ComponentDom$Element)))
}
function $asArrayOf_Ljapgolly_scalajs_react_ComponentDom$Element(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_ComponentDom$Element(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.ComponentDom$Element;", depth))
}
var $d_Ljapgolly_scalajs_react_ComponentDom$Element = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ComponentDom$Element: 0
}, false, "japgolly.scalajs.react.ComponentDom$Element", {
  Ljapgolly_scalajs_react_ComponentDom$Element: 1,
  O: 1,
  Ljapgolly_scalajs_react_ComponentDom$Mounted: 1,
  Ljapgolly_scalajs_react_ComponentDom: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_ComponentDom$Element.prototype.$classData = $d_Ljapgolly_scalajs_react_ComponentDom$Element;
/** @constructor */
function $c_Ljapgolly_scalajs_react_ComponentDom$Text(text) {
  this.Ljapgolly_scalajs_react_ComponentDom$Text__f_text = null;
  this.Ljapgolly_scalajs_react_ComponentDom$Text__f_text = text
}
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.constructor = $c_Ljapgolly_scalajs_react_ComponentDom$Text;
/** @constructor */
function $h_Ljapgolly_scalajs_react_ComponentDom$Text() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_ComponentDom$Text.prototype = $c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype;
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.productPrefix__T = (function() {
  return "Text"
});
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_ComponentDom$Text__f_text : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_ComponentDom$Text)) {
    var Text$1 = $as_Ljapgolly_scalajs_react_ComponentDom$Text(x$1);
    var x = this.Ljapgolly_scalajs_react_ComponentDom$Text__f_text;
    var y = $n(Text$1).Ljapgolly_scalajs_react_ComponentDom$Text__f_text;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.toElement__s_Option = (function() {
  return $m_s_None$()
});
function $as_Ljapgolly_scalajs_react_ComponentDom$Text(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_ComponentDom$Text) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.ComponentDom$Text"))
}
function $isArrayOf_Ljapgolly_scalajs_react_ComponentDom$Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_ComponentDom$Text)))
}
function $asArrayOf_Ljapgolly_scalajs_react_ComponentDom$Text(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_ComponentDom$Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.ComponentDom$Text;", depth))
}
var $d_Ljapgolly_scalajs_react_ComponentDom$Text = new $TypeData().initClass({
  Ljapgolly_scalajs_react_ComponentDom$Text: 0
}, false, "japgolly.scalajs.react.ComponentDom$Text", {
  Ljapgolly_scalajs_react_ComponentDom$Text: 1,
  O: 1,
  Ljapgolly_scalajs_react_ComponentDom$Mounted: 1,
  Ljapgolly_scalajs_react_ComponentDom: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_ComponentDom$Text.prototype.$classData = $d_Ljapgolly_scalajs_react_ComponentDom$Text;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Js$$anon$1(r$1, m$1) {
  this.Ljapgolly_scalajs_react_component_Js$$anon$1__f_raw = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$1__f_mountRaw = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$1__f_raw = r$1;
  this.Ljapgolly_scalajs_react_component_Js$$anon$1__f_mountRaw = m$1
}
$c_Ljapgolly_scalajs_react_component_Js$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_Js$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Js$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Js$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Js$$anon$1.prototype = $c_Ljapgolly_scalajs_react_component_Js$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_component_Js$$anon$1.prototype.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement = (function() {
  return this.Ljapgolly_scalajs_react_component_Js$$anon$1__f_raw
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$1.prototype.mountRaw__F1 = (function() {
  return this.Ljapgolly_scalajs_react_component_Js$$anon$1__f_mountRaw
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$1.prototype.mapUnmountedProps__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(f) {
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var mm = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  return new $c_Ljapgolly_scalajs_react_component_Js$$anon$2(this, f, mm)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$1.prototype.mapMounted__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(f) {
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var mp = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  return new $c_Ljapgolly_scalajs_react_component_Js$$anon$2(this, mp, f)
});
var $d_Ljapgolly_scalajs_react_component_Js$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_Js$$anon$1: 0
}, false, "japgolly.scalajs.react.component.Js$$anon$1", {
  Ljapgolly_scalajs_react_component_Js$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Js$UnmountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedRaw: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot: 1
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_component_Js$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Js$$anon$2(from$1, mp$1, mm$1) {
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_raw = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mountRaw = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_from$1 = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mp$1 = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mm$1 = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_from$1 = from$1;
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mp$1 = mp$1;
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mm$1 = mm$1;
  var this$1 = $n(from$1);
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_raw = this$1.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mountRaw = $n(mm$1).compose__F1__F1($n(from$1).mountRaw__F1())
}
$c_Ljapgolly_scalajs_react_component_Js$$anon$2.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_Js$$anon$2.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Js$$anon$2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Js$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Js$$anon$2.prototype = $c_Ljapgolly_scalajs_react_component_Js$$anon$2.prototype;
$c_Ljapgolly_scalajs_react_component_Js$$anon$2.prototype.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement = (function() {
  return this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_raw
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$2.prototype.mapUnmountedProps__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(f) {
  var from = this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_from$1;
  var mp = $n(f).compose__F1__F1(this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mp$1);
  var mm = this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mm$1;
  return new $c_Ljapgolly_scalajs_react_component_Js$$anon$2(from, mp, mm)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$2.prototype.mapMounted__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot = (function(f) {
  var from = this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_from$1;
  var mp = this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mp$1;
  var mm = $n(f).compose__F1__F1(this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mm$1);
  return new $c_Ljapgolly_scalajs_react_component_Js$$anon$2(from, mp, mm)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$2.prototype.mountRaw__F1 = (function() {
  return this.Ljapgolly_scalajs_react_component_Js$$anon$2__f_mountRaw
});
var $d_Ljapgolly_scalajs_react_component_Js$$anon$2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_Js$$anon$2: 0
}, false, "japgolly.scalajs.react.component.Js$$anon$2", {
  Ljapgolly_scalajs_react_component_Js$$anon$2: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Js$UnmountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedRaw: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot: 1
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$2.prototype.$classData = $d_Ljapgolly_scalajs_react_component_Js$$anon$2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1(outer, rc$1, c$1, pf$1) {
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_raw = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_ctor = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_$outer = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_pf$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_$outer = outer
  };
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_pf$1 = pf$1;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_raw = rc$1;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_ctor = c$1
}
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1.prototype = $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1.prototype.raw__sjs_js_Any = (function() {
  return this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_raw
});
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1.prototype.ctor__Ljapgolly_scalajs_react_CtorType = (function() {
  return this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_ctor
});
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1.prototype.cmapCtorProps__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(f) {
  var this$3 = $n(this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_$outer);
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var mc = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  var this$2 = $m_Ljapgolly_scalajs_react_util_Util$();
  var mu = this$2.Ljapgolly_scalajs_react_util_Util$__f_identity;
  var pf = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_pf$1;
  return new $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2(this$3, this, mc, f, mu, pf)
});
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1.prototype.mapUnmounted__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(f) {
  var this$3 = $n(this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_$outer);
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var cp = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  var this$2 = $m_Ljapgolly_scalajs_react_util_Util$();
  var mc = this$2.Ljapgolly_scalajs_react_util_Util$__f_identity;
  var pf = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1__f_pf$1;
  return new $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2(this$3, this, mc, cp, f, pf)
});
var $d_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1: 0
}, false, "japgolly.scalajs.react.component.JsBaseComponentTemplate$$anon$1", {
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot: 1,
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$ComponentSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$ComponentRaw: 1,
  Ljapgolly_scalajs_react_component_Generic$ComponentWithRoot: 1
});
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2(outer, from$1, mc$1, cp$1, mu$1, pf$2) {
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_raw = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_ctor = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_$outer = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_from$1 = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_mc$1 = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_cp$1 = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_mu$1 = null;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_pf$2 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_$outer = outer
  };
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_from$1 = from$1;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_mc$1 = mc$1;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_cp$1 = cp$1;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_mu$1 = mu$1;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_pf$2 = pf$2;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_raw = $n(from$1).raw__sjs_js_Any();
  var f = $n(mc$1).apply__O__O($n(from$1).ctor__Ljapgolly_scalajs_react_CtorType());
  var p = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_pf$2;
  this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_ctor = $as_Ljapgolly_scalajs_react_CtorType($n(p).dimap__O__F1__F1__O(f, cp$1, mu$1))
}
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2.prototype.constructor = $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2.prototype = $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2.prototype;
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2.prototype.raw__sjs_js_Any = (function() {
  return this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_raw
});
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2.prototype.ctor__Ljapgolly_scalajs_react_CtorType = (function() {
  return this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_ctor
});
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2.prototype.cmapCtorProps__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(f) {
  var this$1 = $n(this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_$outer);
  var from = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_from$1;
  var cp = $n(this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_cp$1).compose__F1__F1(f);
  var mc = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_mc$1;
  var mu = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_mu$1;
  var pf = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_pf$2;
  return new $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2(this$1, from, mc, cp, mu, pf)
});
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2.prototype.mapUnmounted__F1__Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot = (function(f) {
  var this$1 = $n(this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_$outer);
  var from = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_from$1;
  var cp = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_cp$1;
  var mc = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_mc$1;
  var mu = $n(f).compose__F1__F1(this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_mu$1);
  var pf = this.Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2__f_pf$2;
  return new $c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2(this$1, from, mc, cp, mu, pf)
});
var $d_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2: 0
}, false, "japgolly.scalajs.react.component.JsBaseComponentTemplate$$anon$2", {
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentWithRoot: 1,
  Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$ComponentSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$ComponentSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$ComponentRaw: 1,
  Ljapgolly_scalajs_react_component_Generic$ComponentWithRoot: 1
});
$c_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2.prototype.$classData = $d_Ljapgolly_scalajs_react_component_JsBaseComponentTemplate$$anon$2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_JsFn$$anon$3(r$1) {
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$3__f_raw = null;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$3__f_mountRaw = null;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$3__f_raw = r$1;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$3__f_mountRaw = $m_Ljapgolly_scalajs_react_component_JsFn$().Ljapgolly_scalajs_react_component_JsFn$__f_japgolly$scalajs$react$component$JsFn$$constUnit
}
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$3.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$3.prototype.constructor = $c_Ljapgolly_scalajs_react_component_JsFn$$anon$3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_JsFn$$anon$3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_JsFn$$anon$3.prototype = $c_Ljapgolly_scalajs_react_component_JsFn$$anon$3.prototype;
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$3.prototype.mapUnmountedProps__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(f) {
  $m_Ljapgolly_scalajs_react_component_JsFn$();
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var mm = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  return new $c_Ljapgolly_scalajs_react_component_JsFn$$anon$4(this, mm, f)
});
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$3.prototype.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement = (function() {
  return this.Ljapgolly_scalajs_react_component_JsFn$$anon$3__f_raw
});
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$3.prototype.mountRaw__F1 = (function() {
  return this.Ljapgolly_scalajs_react_component_JsFn$$anon$3__f_mountRaw
});
var $d_Ljapgolly_scalajs_react_component_JsFn$$anon$3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_JsFn$$anon$3: 0
}, false, "japgolly.scalajs.react.component.JsFn$$anon$3", {
  Ljapgolly_scalajs_react_component_JsFn$$anon$3: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_JsFn$UnmountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedRaw: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot: 1
});
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$3.prototype.$classData = $d_Ljapgolly_scalajs_react_component_JsFn$$anon$3;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_JsFn$$anon$4(from$1, mm$1, mp$1) {
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_raw = null;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_mountRaw = null;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_from$1 = null;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_mm$1 = null;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_mp$1 = null;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_from$1 = from$1;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_mm$1 = mm$1;
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_mp$1 = mp$1;
  var this$1 = $n(from$1);
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_raw = this$1.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_mountRaw = $n(mm$1).compose__F1__F1($n(from$1).mountRaw__F1())
}
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$4.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$4.prototype.constructor = $c_Ljapgolly_scalajs_react_component_JsFn$$anon$4;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_JsFn$$anon$4() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_JsFn$$anon$4.prototype = $c_Ljapgolly_scalajs_react_component_JsFn$$anon$4.prototype;
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$4.prototype.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement = (function() {
  return this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_raw
});
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$4.prototype.mountRaw__F1 = (function() {
  return this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_mountRaw
});
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$4.prototype.mapUnmountedProps__F1__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot = (function(f) {
  $m_Ljapgolly_scalajs_react_component_JsFn$();
  var from = this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_from$1;
  var mp = $n(f).compose__F1__F1(this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_mp$1);
  var mm = this.Ljapgolly_scalajs_react_component_JsFn$$anon$4__f_mm$1;
  return new $c_Ljapgolly_scalajs_react_component_JsFn$$anon$4(from, mm, mp)
});
var $d_Ljapgolly_scalajs_react_component_JsFn$$anon$4 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_JsFn$$anon$4: 0
}, false, "japgolly.scalajs.react.component.JsFn$$anon$4", {
  Ljapgolly_scalajs_react_component_JsFn$$anon$4: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_JsFn$UnmountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedRaw: 1,
  Ljapgolly_scalajs_react_component_Generic$UnmountedWithRoot: 1
});
$c_Ljapgolly_scalajs_react_component_JsFn$$anon$4.prototype.$classData = $d_Ljapgolly_scalajs_react_component_JsFn$$anon$4;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RedirectToPage(page, via) {
  this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_page = null;
  this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_via = null;
  this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_page = page;
  this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_via = via
}
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RedirectToPage;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RedirectToPage() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype = $c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.map__F1__Ljapgolly_scalajs_react_extra_router_RedirectToPage = (function(f) {
  return new $c_Ljapgolly_scalajs_react_extra_router_RedirectToPage($n(f).apply__O__O(this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_page), this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_via)
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.productPrefix__T = (function() {
  return "RedirectToPage"
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.productArity__I = (function() {
  return 2
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_page;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_via;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RedirectToPage)) {
    var RedirectToPage$1 = $as_Ljapgolly_scalajs_react_extra_router_RedirectToPage(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_page;
    var y = $n(RedirectToPage$1).Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_page;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_via;
      var x$2$1 = $n(RedirectToPage$1).Ljapgolly_scalajs_react_extra_router_RedirectToPage__f_via;
      if ((x$2 === null)) {
        return (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$2$1)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_ActionF = (function(G) {
  return this
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.map__F1__Ljapgolly_scalajs_react_extra_router_ActionF = (function(f) {
  return this.map__F1__Ljapgolly_scalajs_react_extra_router_RedirectToPage(f)
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.map__F1__Ljapgolly_scalajs_react_extra_router_Redirect = (function(f) {
  return this.map__F1__Ljapgolly_scalajs_react_extra_router_RedirectToPage(f)
});
function $as_Ljapgolly_scalajs_react_extra_router_RedirectToPage(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RedirectToPage) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RedirectToPage"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RedirectToPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RedirectToPage)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RedirectToPage(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RedirectToPage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RedirectToPage;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RedirectToPage = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RedirectToPage: 0
}, false, "japgolly.scalajs.react.extra.router.RedirectToPage", {
  Ljapgolly_scalajs_react_extra_router_RedirectToPage: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_Redirect: 1,
  Ljapgolly_scalajs_react_extra_router_ActionF: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPage.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RedirectToPage;
/** @constructor */
function $c_Ljapgolly_scalajs_react_extra_router_RedirectToPath(path, via) {
  this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_path = null;
  this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_via = null;
  this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_path = path;
  this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_via = via
}
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.constructor = $c_Ljapgolly_scalajs_react_extra_router_RedirectToPath;
/** @constructor */
function $h_Ljapgolly_scalajs_react_extra_router_RedirectToPath() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype = $c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype;
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.productPrefix__T = (function() {
  return "RedirectToPath"
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.productArity__I = (function() {
  return 2
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_path;
      break
    }
    case 1: {
      return this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_via;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_extra_router_RedirectToPath)) {
    var RedirectToPath$1 = $as_Ljapgolly_scalajs_react_extra_router_RedirectToPath(x$1);
    var x = this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_path;
    var x$2 = $n(RedirectToPath$1).Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_path;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_via;
      var x$4 = $n(RedirectToPath$1).Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_via;
      if ((x$3 === null)) {
        return (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$Sync__Ljapgolly_scalajs_react_extra_router_ActionF = (function(G) {
  return this
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.map__F1__Ljapgolly_scalajs_react_extra_router_ActionF = (function(f) {
  return new $c_Ljapgolly_scalajs_react_extra_router_RedirectToPath(this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_path, this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_via)
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.map__F1__Ljapgolly_scalajs_react_extra_router_Redirect = (function(f) {
  return new $c_Ljapgolly_scalajs_react_extra_router_RedirectToPath(this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_path, this.Ljapgolly_scalajs_react_extra_router_RedirectToPath__f_via)
});
function $as_Ljapgolly_scalajs_react_extra_router_RedirectToPath(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_extra_router_RedirectToPath) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.extra.router.RedirectToPath"))
}
function $isArrayOf_Ljapgolly_scalajs_react_extra_router_RedirectToPath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_extra_router_RedirectToPath)))
}
function $asArrayOf_Ljapgolly_scalajs_react_extra_router_RedirectToPath(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_extra_router_RedirectToPath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.extra.router.RedirectToPath;", depth))
}
var $d_Ljapgolly_scalajs_react_extra_router_RedirectToPath = new $TypeData().initClass({
  Ljapgolly_scalajs_react_extra_router_RedirectToPath: 0
}, false, "japgolly.scalajs.react.extra.router.RedirectToPath", {
  Ljapgolly_scalajs_react_extra_router_RedirectToPath: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_router_Redirect: 1,
  Ljapgolly_scalajs_react_extra_router_ActionF: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_extra_router_RedirectToPath.prototype.$classData = $d_Ljapgolly_scalajs_react_extra_router_RedirectToPath;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I5__O__O__O__O__O__O__($thiz, input, hook1, hook2, hook3, hook4, hook5) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5 = hook5;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I4__O__O__O__O__O__($thiz, input, hook1, hook2, hook3, hook4);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$I5() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I5.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$I4();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I5.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I5;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$I5() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$I5.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I5.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I5.prototype.toString__T = (function() {
  return (((((((((((("HookCtx.withInput(\n  input = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$I5(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$I5) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$I5"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$I5)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I5(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$I5;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$I5 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$I5: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$I5", {
  Ljapgolly_scalajs_react_hooks_HookCtx$I5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I5.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$I5;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P5__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = hook5;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P4__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P5() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P5.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P4();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P5.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P5;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P5() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P5.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P5.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P5.prototype.toString__T = (function() {
  return (((((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P5(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P5) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P5"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P5)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P5(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P5;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P5 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P5", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P5.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P5;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC4(props, propsChildren, hook1, hook2, hook3, hook4) {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$PC4__f_hook4 = hook4;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$PC3__O__sjs_js_Any__O__O__O__(this, props, propsChildren, hook1, hook2, hook3)
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC4.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$PC3();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC4.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC4;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$PC4() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$PC4.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$PC4.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC4.prototype.toString__T = (function() {
  return (((((((((((("HookCtx.withChildren(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  propsChildren = ") + new $c_Ljapgolly_scalajs_react_PropsChildren(this.Ljapgolly_scalajs_react_hooks_HookCtx$PC0__f_propsChildren)) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$PC4__f_hook4) + ")")
});
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC4 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$PC4: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$PC4", {
  Ljapgolly_scalajs_react_hooks_HookCtx$PC4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$PC0: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$PC4.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$PC4;
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_CoreGeneral$() {
  this.Ljapgolly_scalajs_react_internal_CoreGeneral$__f_JsComponent = null;
  $n_Ljapgolly_scalajs_react_internal_CoreGeneral$ = this;
  $f_Ljapgolly_scalajs_react_internal_CoreGeneral__$init$__V(this)
}
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_CoreGeneral$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_CoreGeneral$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype = $c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype;
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$GenericComponent_$eq__Ljapgolly_scalajs_react_component_Generic$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$JsComponent_$eq__Ljapgolly_scalajs_react_component_Js$__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_internal_CoreGeneral$__f_JsComponent = x$1
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$JsFnComponent_$eq__Ljapgolly_scalajs_react_component_JsFn$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$JsForwardRefComponent_$eq__Ljapgolly_scalajs_react_component_JsForwardRef$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$ScalaFnComponent_$eq__Ljapgolly_scalajs_react_component_ScalaFn$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$ScalaForwardRefComponent_$eq__Ljapgolly_scalajs_react_component_ScalaForwardRef$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$CustomHook_$eq__Ljapgolly_scalajs_react_hooks_CustomHook$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$Hooks_$eq__Ljapgolly_scalajs_react_hooks_Hooks$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$HooksApi_$eq__Ljapgolly_scalajs_react_hooks_Api$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$ReactEffect_$eq__Ljapgolly_scalajs_react_util_Effect$__V = (function(x$1) {
  /*<skip>*/
});
var $d_Ljapgolly_scalajs_react_internal_CoreGeneral$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_internal_CoreGeneral$: 0
}, false, "japgolly.scalajs.react.internal.CoreGeneral$", {
  Ljapgolly_scalajs_react_internal_CoreGeneral$: 1,
  O: 1,
  Ljapgolly_scalajs_react_internal_CoreGeneral: 1,
  Ljapgolly_scalajs_react_ReactEventTypes: 1,
  Ljapgolly_scalajs_react_ReactExtensions: 1,
  Ljapgolly_scalajs_react_util_DomUtil: 1,
  Ljapgolly_scalajs_react_internal_FacadeExports: 1
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneral$.prototype.$classData = $d_Ljapgolly_scalajs_react_internal_CoreGeneral$;
var $n_Ljapgolly_scalajs_react_internal_CoreGeneral$;
function $m_Ljapgolly_scalajs_react_internal_CoreGeneral$() {
  if ((!$n_Ljapgolly_scalajs_react_internal_CoreGeneral$)) {
    $n_Ljapgolly_scalajs_react_internal_CoreGeneral$ = new $c_Ljapgolly_scalajs_react_internal_CoreGeneral$()
  };
  return $n_Ljapgolly_scalajs_react_internal_CoreGeneral$
}
function $ct_Ljapgolly_scalajs_react_internal_CoreGeneralF__Ljapgolly_scalajs_react_util_Effect$Sync__($thiz, F) {
  $f_Ljapgolly_scalajs_react_internal_CoreGeneral__$init$__V($thiz);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_internal_CoreGeneralF() {
  this.Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent = null;
  this.Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook = null
}
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.constructor = $c_Ljapgolly_scalajs_react_internal_CoreGeneralF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_internal_CoreGeneralF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype = $c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype;
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$GenericComponent_$eq__Ljapgolly_scalajs_react_component_Generic$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$JsComponent_$eq__Ljapgolly_scalajs_react_component_Js$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$JsFnComponent_$eq__Ljapgolly_scalajs_react_component_JsFn$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$JsForwardRefComponent_$eq__Ljapgolly_scalajs_react_component_JsForwardRef$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$ScalaFnComponent_$eq__Ljapgolly_scalajs_react_component_ScalaFn$__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent = x$1
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$ScalaForwardRefComponent_$eq__Ljapgolly_scalajs_react_component_ScalaForwardRef$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$CustomHook_$eq__Ljapgolly_scalajs_react_hooks_CustomHook$__V = (function(x$1) {
  this.Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook = x$1
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$Hooks_$eq__Ljapgolly_scalajs_react_hooks_Hooks$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$HooksApi_$eq__Ljapgolly_scalajs_react_hooks_Api$__V = (function(x$1) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_internal_CoreGeneralF.prototype.japgolly$scalajs$react$internal$CoreGeneral$_setter_$ReactEffect_$eq__Ljapgolly_scalajs_react_util_Effect$__V = (function(x$1) {
  /*<skip>*/
});
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_EffectFallbacks1() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_EffectFallbacks1.prototype = new $h_Ljapgolly_scalajs_react_util_EffectFallbacks2();
$c_Ljapgolly_scalajs_react_util_EffectFallbacks1.prototype.constructor = $c_Ljapgolly_scalajs_react_util_EffectFallbacks1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_EffectFallbacks1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_EffectFallbacks1.prototype = $c_Ljapgolly_scalajs_react_util_EffectFallbacks1.prototype;
function $ct_jl_ArrayIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_ArrayIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_ArrayIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
var $d_jl_ArrayIndexOutOfBoundsException = new $TypeData().initClass({
  jl_ArrayIndexOutOfBoundsException: 0
}, false, "java.lang.ArrayIndexOutOfBoundsException", {
  jl_ArrayIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ArrayIndexOutOfBoundsException.prototype.$classData = $d_jl_ArrayIndexOutOfBoundsException;
function $f_jl_Double__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Double__hashCode__I($thiz) {
  return $m_jl_FloatingPointBits$().numberHashCode__D__I($thiz)
}
function $f_jl_Double__toString__T($thiz) {
  return ("" + $thiz)
}
function $f_jl_Double__compareTo__O__I($thiz, o) {
  var that = $as_jl_Double(o);
  var $$x1 = $m_jl_Double$();
  var this$1 = $n(that);
  return $n($$x1).compare__D__D__I($thiz, this$1)
}
function $as_jl_Double(obj) {
  return ((((typeof obj) === "number") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Double"))
}
function $isArrayOf_jl_Double(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Double)))
}
function $asArrayOf_jl_Double(obj, depth) {
  return (($isArrayOf_jl_Double(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Double;", depth))
}
var $d_jl_Double = new $TypeData().initClass({
  jl_Double: 0
}, false, "java.lang.Double", {
  jl_Double: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => ((typeof x) === "number")));
function $f_jl_Float__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Float__hashCode__I($thiz) {
  return $m_jl_FloatingPointBits$().numberHashCode__D__I($thiz)
}
function $f_jl_Float__toString__T($thiz) {
  return ("" + $thiz)
}
function $f_jl_Float__compareTo__O__I($thiz, o) {
  var that = $as_jl_Float(o);
  var this$1 = $n(that);
  return $m_jl_Double$().compare__D__D__I($thiz, this$1)
}
function $as_jl_Float(obj) {
  return (($isFloat(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Float"))
}
function $isArrayOf_jl_Float(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Float)))
}
function $asArrayOf_jl_Float(obj, depth) {
  return (($isArrayOf_jl_Float(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Float;", depth))
}
var $d_jl_Float = new $TypeData().initClass({
  jl_Float: 0
}, false, "java.lang.Float", {
  jl_Float: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => $isFloat(x)));
function $f_jl_Integer__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Integer__hashCode__I($thiz) {
  return $thiz
}
function $f_jl_Integer__toString__T($thiz) {
  return ("" + $thiz)
}
function $f_jl_Integer__compareTo__O__I($thiz, o) {
  var that = $as_jl_Integer(o);
  var this$1 = $n(that);
  return (($thiz === this$1) ? 0 : (($thiz < this$1) ? (-1) : 1))
}
function $as_jl_Integer(obj) {
  return (($isInt(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Integer"))
}
function $isArrayOf_jl_Integer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Integer)))
}
function $asArrayOf_jl_Integer(obj, depth) {
  return (($isArrayOf_jl_Integer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Integer;", depth))
}
var $d_jl_Integer = new $TypeData().initClass({
  jl_Integer: 0
}, false, "java.lang.Integer", {
  jl_Integer: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => $isInt(x)));
function $f_jl_Long__equals__O__Z($thiz, that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_jl_Long(that);
    var this$1 = $n(x2);
    var b = $uJ(this$1);
    return (($thiz.RTLong__f_lo === b.RTLong__f_lo) && ($thiz.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return false
  }
}
function $f_jl_Long__hashCode__I($thiz) {
  var $$x1 = $thiz.RTLong__f_lo;
  var hi = $thiz.RTLong__f_hi;
  return ($$x1 ^ hi)
}
function $f_jl_Long__toString__T($thiz) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T($thiz.RTLong__f_lo, $thiz.RTLong__f_hi)
}
function $f_jl_Long__compareTo__O__I($thiz, o) {
  var that = $as_jl_Long(o);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I($thiz.RTLong__f_lo, $thiz.RTLong__f_hi, $n(that).RTLong__f_lo, $n(that).RTLong__f_hi)
}
function $as_jl_Long(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long"))
}
function $isArrayOf_jl_Long(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long)))
}
function $asArrayOf_jl_Long(obj, depth) {
  return (($isArrayOf_jl_Long(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long;", depth))
}
var $d_jl_Long = new $TypeData().initClass({
  jl_Long: 0
}, false, "java.lang.Long", {
  jl_Long: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => (x instanceof $c_RTLong)));
class $c_jl_NumberFormatException extends $c_jl_IllegalArgumentException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
function $as_jl_NumberFormatException(obj) {
  return (((obj instanceof $c_jl_NumberFormatException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.NumberFormatException"))
}
function $isArrayOf_jl_NumberFormatException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_NumberFormatException)))
}
function $asArrayOf_jl_NumberFormatException(obj, depth) {
  return (($isArrayOf_jl_NumberFormatException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.NumberFormatException;", depth))
}
var $d_jl_NumberFormatException = new $TypeData().initClass({
  jl_NumberFormatException: 0
}, false, "java.lang.NumberFormatException", {
  jl_NumberFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NumberFormatException.prototype.$classData = $d_jl_NumberFormatException;
function $f_T__length__I($thiz) {
  return $thiz.length
}
function $f_T__charAt__I__C($thiz, index) {
  return $charAt($thiz, index)
}
function $f_T__codePointAt__I__I($thiz, index) {
  $charAt($thiz, index);
  return $uI($thiz.codePointAt(index))
}
function $f_T__hashCode__I($thiz) {
  var res = 0;
  var mul = 1;
  var i = (((-1) + $thiz.length) | 0);
  while ((i >= 0)) {
    var $$x1 = res;
    var index = i;
    res = (($$x1 + Math.imul($charAt($thiz, index), mul)) | 0);
    mul = Math.imul(31, mul);
    i = (((-1) + i) | 0)
  };
  return res
}
function $f_T__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_T__compareTo__T__I($thiz, anotherString) {
  var thisLength = $thiz.length;
  var this$1 = $n(anotherString);
  var strLength = this$1.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var index = i;
    var this$3 = $n(anotherString);
    var index$1 = i;
    var cmp = (($charAt($thiz, index) - $charAt(this$3, index$1)) | 0);
    if ((cmp !== 0)) {
      return cmp
    };
    i = ((1 + i) | 0)
  };
  return ((thisLength - strLength) | 0)
}
function $f_T__endsWith__T__Z($thiz, suffix) {
  var this$1 = $n(suffix);
  var $$x1 = $thiz.substring((($thiz.length - this$1.length) | 0));
  return ($as_T($$x1) === suffix)
}
function $f_T__getChars__I__I__AC__I__V($thiz, srcBegin, srcEnd, dst, dstBegin) {
  if (((((srcEnd > $thiz.length) || (srcBegin < 0)) || (srcEnd < 0)) || (srcBegin > srcEnd))) {
    throw $ct_jl_StringIndexOutOfBoundsException__T__(new $c_jl_StringIndexOutOfBoundsException(), "Index out of Bound")
  };
  var offset = ((dstBegin - srcBegin) | 0);
  var i = srcBegin;
  while ((i < srcEnd)) {
    var $$x2 = $n(dst);
    var $$x1 = i;
    var index = i;
    $$x2.set((($$x1 + offset) | 0), $charAt($thiz, index));
    i = ((1 + i) | 0)
  }
}
function $f_T__indexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.indexOf(str))
}
function $f_T__indexOf__I__I__I($thiz, ch, fromIndex) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.indexOf(str, fromIndex))
}
function $f_T__lastIndexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.lastIndexOf(str))
}
function $f_T__repeat__I__T($thiz, count) {
  if ((count < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  } else {
    return $as_T($thiz.repeat(count))
  }
}
function $f_T__replaceAll__T__T__T($thiz, regex, replacement) {
  var this$2 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  return new $c_ju_regex_Matcher(this$2, $thiz).replaceAll__T__T(replacement)
}
function $f_T__replaceFirst__T__T__T($thiz, regex, replacement) {
  var this$2 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  return new $c_ju_regex_Matcher(this$2, $thiz).replaceFirst__T__T(replacement)
}
function $f_T__split__T__I__AT($thiz, regex, limit) {
  var this$2 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  return this$2.java$util$regex$Pattern$$split__T__I__AT($thiz, limit)
}
function $f_T__subSequence__I__I__jl_CharSequence($thiz, beginIndex, endIndex) {
  if ((beginIndex < 0)) {
    $charAt($thiz, beginIndex)
  };
  if ((endIndex > $thiz.length)) {
    $charAt($thiz, endIndex)
  };
  if ((endIndex < beginIndex)) {
    $charAt($thiz, (-1))
  };
  return $as_T($thiz.substring(beginIndex, endIndex))
}
function $f_T__toCharArray__AC($thiz) {
  var len = $thiz.length;
  var result = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $$x2 = $n(result);
    var $$x1 = i;
    var index = i;
    $$x2.set($$x1, $charAt($thiz, index));
    i = ((1 + i) | 0)
  };
  return result
}
function $f_T__trim__T($thiz) {
  var len = $thiz.length;
  var start = 0;
  while (true) {
    if ((start !== len)) {
      var index = start;
      var $$x1 = ($charAt($thiz, index) <= 32)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      start = ((1 + start) | 0)
    } else {
      break
    }
  };
  if ((start === len)) {
    return ""
  } else {
    var end = len;
    while (true) {
      var index$1 = (((-1) + end) | 0);
      if (($charAt($thiz, index$1) <= 32)) {
        end = (((-1) + end) | 0)
      } else {
        break
      }
    };
    if (((start === 0) && (end === len))) {
      return $thiz
    } else {
      var beginIndex = start;
      var endIndex = end;
      if ((beginIndex < 0)) {
        $charAt($thiz, beginIndex)
      };
      if ((endIndex > $thiz.length)) {
        $charAt($thiz, endIndex)
      };
      if ((endIndex < beginIndex)) {
        $charAt($thiz, (-1))
      };
      return $as_T($thiz.substring(beginIndex, endIndex))
    }
  }
}
function $f_T__toString__T($thiz) {
  return $thiz
}
function $f_T__compareTo__O__I($thiz, o) {
  return $f_T__compareTo__T__I($thiz, $as_T(o))
}
function $as_T(obj) {
  return ((((typeof obj) === "string") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.String"))
}
function $isArrayOf_T(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T)))
}
function $asArrayOf_T(obj, depth) {
  return (($isArrayOf_T(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.String;", depth))
}
var $d_T = new $TypeData().initClass({
  T: 0
}, false, "java.lang.String", {
  T: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => ((typeof x) === "string")));
function $ct_jl_StringIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_StringIndexOutOfBoundsException__I__($thiz, index) {
  var s = ("String index out of range: " + index);
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_StringIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_StringIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
var $d_jl_StringIndexOutOfBoundsException = new $TypeData().initClass({
  jl_StringIndexOutOfBoundsException: 0
}, false, "java.lang.StringIndexOutOfBoundsException", {
  jl_StringIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringIndexOutOfBoundsException.prototype.$classData = $d_jl_StringIndexOutOfBoundsException;
/** @constructor */
function $c_Ljava_time_DayOfWeek(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_DayOfWeek.prototype = new $h_jl_Enum();
$c_Ljava_time_DayOfWeek.prototype.constructor = $c_Ljava_time_DayOfWeek;
/** @constructor */
function $h_Ljava_time_DayOfWeek() {
  /*<skip>*/
}
$h_Ljava_time_DayOfWeek.prototype = $c_Ljava_time_DayOfWeek.prototype;
$c_Ljava_time_DayOfWeek.prototype.getValue__I = (function() {
  return ((1 + this.Ljava_time_DayOfWeek__f_ordinal) | 0)
});
$c_Ljava_time_DayOfWeek.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field === $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()) : ((field !== null) && $n(field).isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)))
});
$c_Ljava_time_DayOfWeek.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    return $n(field).range__Ljava_time_temporal_ValueRange()
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return $n(field).rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this)
  }
});
$c_Ljava_time_DayOfWeek.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field === $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField()) ? this.getValue__I() : $n(this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field))
});
$c_Ljava_time_DayOfWeek.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    var value = this.getValue__I();
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return $n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this)
  }
});
$c_Ljava_time_DayOfWeek.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)))
});
$c_Ljava_time_DayOfWeek.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $$x2 = $n(temporal);
  var $$x1 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  var value = this.getValue__I();
  var hi = (value >> 31);
  return $n($$x2).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(value, hi))
});
var $d_Ljava_time_DayOfWeek = new $TypeData().initClass({
  Ljava_time_DayOfWeek: 0
}, false, "java.time.DayOfWeek", {
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1
});
$c_Ljava_time_DayOfWeek.prototype.$classData = $d_Ljava_time_DayOfWeek;
/** @constructor */
function $c_Ljava_time_Month(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  this.Ljava_time_Month__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_time_Month.prototype = new $h_jl_Enum();
$c_Ljava_time_Month.prototype.constructor = $c_Ljava_time_Month;
/** @constructor */
function $h_Ljava_time_Month() {
  /*<skip>*/
}
$h_Ljava_time_Month.prototype = $c_Ljava_time_Month.prototype;
$c_Ljava_time_Month.prototype.getValue__I = (function() {
  return ((1 + this.Ljava_time_Month__f_ordinal) | 0)
});
$c_Ljava_time_Month.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field === $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) : ((field !== null) && $n(field).isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)))
});
$c_Ljava_time_Month.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    return $n(field).range__Ljava_time_temporal_ValueRange()
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return $n(field).rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this)
  }
});
$c_Ljava_time_Month.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field === $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) ? this.getValue__I() : $n(this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field))
});
$c_Ljava_time_Month.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    var value = this.getValue__I();
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return $n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this)
  }
});
$c_Ljava_time_Month.prototype.plus__J__Ljava_time_Month = (function(months) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(months.RTLong__f_lo, months.RTLong__f_hi, 12, 0);
  return $n($m_Ljava_time_Month$().java$time$Month$$ENUMS__ALjava_time_Month()).get(((((this.Ljava_time_Month__f_ordinal + ((12 + lo) | 0)) | 0) % 12) | 0))
});
$c_Ljava_time_Month.prototype.length__Z__I = (function(leapYear) {
  var x = $m_Ljava_time_Month$().FEBRUARY__Ljava_time_Month();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $$x1 = (this$1 === this)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return (leapYear ? 29 : 28)
  } else {
    var x$3 = $m_Ljava_time_Month$().APRIL__Ljava_time_Month();
    if ((x$3 !== null)) {
      var this$2 = $n(x$3);
      var $$x3 = (this$2 === this)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var $$x2 = true
    } else {
      var x$5 = $m_Ljava_time_Month$().JUNE__Ljava_time_Month();
      if ((x$5 !== null)) {
        var this$3 = $n(x$5);
        var $$x4 = (this$3 === this)
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var $$x2 = true
      } else {
        var x$7 = $m_Ljava_time_Month$().SEPTEMBER__Ljava_time_Month();
        if ((x$7 !== null)) {
          var this$4 = $n(x$7);
          var $$x5 = (this$4 === this)
        } else {
          var $$x5 = false
        };
        if ($$x5) {
          var $$x2 = true
        } else {
          var x$9 = $m_Ljava_time_Month$().NOVEMBER__Ljava_time_Month();
          if ((x$9 !== null)) {
            var this$5 = $n(x$9);
            var $$x2 = (this$5 === this)
          } else {
            var $$x2 = false
          }
        }
      }
    };
    if ($$x2) {
      return 30
    } else {
      return 31
    }
  }
});
$c_Ljava_time_Month.prototype.firstDayOfYear__Z__I = (function(leapYear) {
  var leap = (leapYear ? 1 : 0);
  var x = $m_Ljava_time_Month$().JANUARY__Ljava_time_Month();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $$x1 = (this$1 === this)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return 1
  } else {
    var x$3 = $m_Ljava_time_Month$().FEBRUARY__Ljava_time_Month();
    if ((x$3 !== null)) {
      var this$2 = $n(x$3);
      var $$x2 = (this$2 === this)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      return 32
    } else {
      var x$5 = $m_Ljava_time_Month$().MARCH__Ljava_time_Month();
      if ((x$5 !== null)) {
        var this$3 = $n(x$5);
        var $$x3 = (this$3 === this)
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        return ((60 + leap) | 0)
      } else {
        var x$7 = $m_Ljava_time_Month$().APRIL__Ljava_time_Month();
        if ((x$7 !== null)) {
          var this$4 = $n(x$7);
          var $$x4 = (this$4 === this)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          return ((91 + leap) | 0)
        } else {
          var x$9 = $m_Ljava_time_Month$().MAY__Ljava_time_Month();
          if ((x$9 !== null)) {
            var this$5 = $n(x$9);
            var $$x5 = (this$5 === this)
          } else {
            var $$x5 = false
          };
          if ($$x5) {
            return ((121 + leap) | 0)
          } else {
            var x$11 = $m_Ljava_time_Month$().JUNE__Ljava_time_Month();
            if ((x$11 !== null)) {
              var this$6 = $n(x$11);
              var $$x6 = (this$6 === this)
            } else {
              var $$x6 = false
            };
            if ($$x6) {
              return ((152 + leap) | 0)
            } else {
              var x$13 = $m_Ljava_time_Month$().JULY__Ljava_time_Month();
              if ((x$13 !== null)) {
                var this$7 = $n(x$13);
                var $$x7 = (this$7 === this)
              } else {
                var $$x7 = false
              };
              if ($$x7) {
                return ((182 + leap) | 0)
              } else {
                var x$15 = $m_Ljava_time_Month$().AUGUST__Ljava_time_Month();
                if ((x$15 !== null)) {
                  var this$8 = $n(x$15);
                  var $$x8 = (this$8 === this)
                } else {
                  var $$x8 = false
                };
                if ($$x8) {
                  return ((213 + leap) | 0)
                } else {
                  var x$17 = $m_Ljava_time_Month$().SEPTEMBER__Ljava_time_Month();
                  if ((x$17 !== null)) {
                    var this$9 = $n(x$17);
                    var $$x9 = (this$9 === this)
                  } else {
                    var $$x9 = false
                  };
                  if ($$x9) {
                    return ((244 + leap) | 0)
                  } else {
                    var x$19 = $m_Ljava_time_Month$().OCTOBER__Ljava_time_Month();
                    if ((x$19 !== null)) {
                      var this$10 = $n(x$19);
                      var $$x10 = (this$10 === this)
                    } else {
                      var $$x10 = false
                    };
                    if ($$x10) {
                      return ((274 + leap) | 0)
                    } else {
                      var x$21 = $m_Ljava_time_Month$().NOVEMBER__Ljava_time_Month();
                      if ((x$21 !== null)) {
                        var this$11 = $n(x$21);
                        var $$x11 = (this$11 === this)
                      } else {
                        var $$x11 = false
                      };
                      if ($$x11) {
                        return ((305 + leap) | 0)
                      } else {
                        var x$23 = $m_Ljava_time_Month$().DECEMBER__Ljava_time_Month();
                        if ((x$23 !== null)) {
                          var this$12 = $n(x$23);
                          var $$x12 = (this$12 === this)
                        } else {
                          var $$x12 = false
                        };
                        if ($$x12) {
                          return ((335 + leap) | 0)
                        } else {
                          throw new $c_s_MatchError(this)
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});
$c_Ljava_time_Month.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology() : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit() : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this))))
});
$c_Ljava_time_Month.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var x = $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal);
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  if ((x === null)) {
    var $$x1 = (x$2 === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = $f_Ljava_time_chrono_Chronology__equals__O__Z(this$1, x$2)
  };
  if ((!$$x1)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Adjustment only supported on ISO date-time")
  } else {
    var $$x3 = $n(temporal);
    var $$x2 = $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var value = this.getValue__I();
    var hi = (value >> 31);
    return $n($$x3).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x2, new $c_RTLong(value, hi))
  }
});
var $d_Ljava_time_Month = new $TypeData().initClass({
  Ljava_time_Month: 0
}, false, "java.time.Month", {
  Ljava_time_Month: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1
});
$c_Ljava_time_Month.prototype.$classData = $d_Ljava_time_Month;
function $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z($thiz, field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? $n(field).isDateBased__Z() : ((field !== null) && $n(field).isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z($thiz)))
}
function $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $$x1 = (query === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = (this$1 === query)
  };
  if ($$x1) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
  } else {
    var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
    if ((x$3 === null)) {
      var $$x2 = (query === null)
    } else {
      var this$2 = $n(x$3);
      var $$x2 = (this$2 === query)
    };
    if ($$x2) {
      return $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit()
    } else {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === null)) {
        var $$x3 = (query === null)
      } else {
        var this$3 = $n(x$5);
        var $$x3 = (this$3 === query)
      };
      if ($$x3) {
        return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate($thiz.toEpochDay__J())
      } else {
        var x$7 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
        if ((x$7 === null)) {
          var $$x5 = (query === null)
        } else {
          var this$4 = $n(x$7);
          var $$x5 = (this$4 === query)
        };
        if ($$x5) {
          var $$x4 = true
        } else {
          var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
          if ((x$9 === null)) {
            var $$x6 = (query === null)
          } else {
            var this$5 = $n(x$9);
            var $$x6 = (this$5 === query)
          };
          if ($$x6) {
            var $$x4 = true
          } else {
            var x$11 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
            if ((x$11 === null)) {
              var $$x7 = (query === null)
            } else {
              var this$6 = $n(x$11);
              var $$x7 = (this$6 === query)
            };
            if ($$x7) {
              var $$x4 = true
            } else {
              var x$13 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
              if ((x$13 === null)) {
                var $$x4 = (query === null)
              } else {
                var this$7 = $n(x$13);
                var $$x4 = (this$7 === query)
              }
            }
          }
        };
        if ($$x4) {
          return null
        } else {
          return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query)
        }
      }
    }
  }
}
function $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T($thiz, formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter")
  };
  return $n(formatter).format__Ljava_time_temporal_TemporalAccessor__T($thiz)
}
function $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I($thiz, other) {
  var t = $thiz.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $n(other).toEpochDay__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  if ((cmp === 0)) {
    $n($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    $n(other);
    var that = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    cmp = $f_T__compareTo__T__I("ISO", ($n(that), "ISO"))
  };
  return cmp
}
function $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z($thiz, other) {
  var this$1 = $thiz.toEpochDay__J();
  var b = $n(other).toEpochDay__J();
  var ahi = this$1.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) > ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
}
function $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z($thiz, other) {
  var this$1 = $thiz.toEpochDay__J();
  var b = $n(other).toEpochDay__J();
  var ahi = this$1.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
}
function $is_Ljava_time_chrono_ChronoLocalDate(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_ChronoLocalDate)))
}
function $as_Ljava_time_chrono_ChronoLocalDate(obj) {
  return (($is_Ljava_time_chrono_ChronoLocalDate(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.ChronoLocalDate"))
}
function $isArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoLocalDate)))
}
function $asArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.ChronoLocalDate;", depth))
}
/** @constructor */
function $c_Ljava_time_chrono_ChronoLocalDateTime() {
  /*<skip>*/
}
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype = new $h_O();
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.constructor = $c_Ljava_time_chrono_ChronoLocalDateTime;
/** @constructor */
function $h_Ljava_time_chrono_ChronoLocalDateTime() {
  /*<skip>*/
}
$h_Ljava_time_chrono_ChronoLocalDateTime.prototype = $c_Ljava_time_chrono_ChronoLocalDateTime.prototype;
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $$x1 = (query === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = (this$1 === query)
  };
  if ($$x1) {
    $n(this.Ljava_time_LocalDateTime__f_date);
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
  } else {
    var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
    if ((x$3 === null)) {
      var $$x2 = (query === null)
    } else {
      var this$3 = $n(x$3);
      var $$x2 = (this$3 === query)
    };
    if ($$x2) {
      return $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit()
    } else {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === null)) {
        var $$x3 = (query === null)
      } else {
        var this$4 = $n(x$5);
        var $$x3 = (this$4 === query)
      };
      if ($$x3) {
        return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate($n(this.Ljava_time_LocalDateTime__f_date).toEpochDay__J())
      } else {
        var x$7 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
        if ((x$7 === null)) {
          var $$x4 = (query === null)
        } else {
          var this$5 = $n(x$7);
          var $$x4 = (this$5 === query)
        };
        if ($$x4) {
          return this.Ljava_time_LocalDateTime__f_time
        } else {
          var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
          if ((x$9 === null)) {
            var $$x6 = (query === null)
          } else {
            var this$6 = $n(x$9);
            var $$x6 = (this$6 === query)
          };
          if ($$x6) {
            var $$x5 = true
          } else {
            var x$11 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
            if ((x$11 === null)) {
              var $$x7 = (query === null)
            } else {
              var this$7 = $n(x$11);
              var $$x7 = (this$7 === query)
            };
            if ($$x7) {
              var $$x5 = true
            } else {
              var x$13 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
              if ((x$13 === null)) {
                var $$x5 = (query === null)
              } else {
                var this$8 = $n(x$13);
                var $$x5 = (this$8 === query)
              }
            }
          };
          if ($$x5) {
            return null
          } else {
            return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query)
          }
        }
      }
    }
  }
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return $n($n(temporal).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField(), $n(this.Ljava_time_LocalDateTime__f_date).toEpochDay__J())).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField(), $n(this.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J())
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant = (function(offset) {
  var $$x2 = $m_Ljava_time_Instant$();
  var $$x1 = this.toEpochSecond__Ljava_time_ZoneOffset__J(offset);
  var this$1 = $n(this.Ljava_time_LocalDateTime__f_time);
  var value = this$1.Ljava_time_LocalTime__f_nano;
  var hi = (value >> 31);
  return $n($$x2).ofEpochSecond__J__J__Ljava_time_Instant($$x1, new $c_RTLong(value, hi))
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.toEpochSecond__Ljava_time_ZoneOffset__J = (function(offset) {
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  };
  var t = $n(this.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo$1 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((Math.imul(86400, hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var value = $n(this.Ljava_time_LocalDateTime__f_time).toSecondOfDay__I();
  var hi$2 = (value >> 31);
  var lo$2 = ((lo$1 + value) | 0);
  var hi$3 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  var secs__lo = lo$2;
  var secs__hi = hi$3;
  var this$6__lo = secs__lo;
  var this$6__hi = secs__hi;
  var this$4 = $n(offset);
  var value$1 = this$4.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$4 = (value$1 >> 31);
  var alo = this$6__lo;
  var ahi = this$6__hi;
  var lo$3 = ((alo - value$1) | 0);
  var hi$5 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$4) | 0)) | 0) : ((ahi - hi$4) | 0));
  var $$x1__lo = lo$3;
  var $$x1__hi = hi$5;
  secs__lo = $$x1__lo;
  secs__hi = $$x1__hi;
  return new $c_RTLong(secs__lo, secs__hi)
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.compare__Ljava_time_chrono_ChronoLocalDateTime__I = (function(other) {
  var this$2 = $n(this.Ljava_time_LocalDateTime__f_date);
  var this$1 = $n(other);
  var that = this$1.Ljava_time_LocalDateTime__f_date;
  var cmp = this$2.compareTo__Ljava_time_chrono_ChronoLocalDate__I(that);
  if ((cmp === 0)) {
    var this$4 = $n(this.Ljava_time_LocalDateTime__f_time);
    var this$3 = $n(other);
    var other$1 = this$3.Ljava_time_LocalDateTime__f_time;
    cmp = this$4.compare__Ljava_time_LocalTime__I(other$1);
    if ((cmp === 0)) {
      $n(($n(this.Ljava_time_LocalDateTime__f_date), $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()));
      var this$6 = $n(other);
      $n(this$6.Ljava_time_LocalDateTime__f_date);
      var that$1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      cmp = $f_T__compareTo__T__I("ISO", ($n(that$1), "ISO"))
    }
  };
  return cmp
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  var t = $n(this.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$1 = $n(other);
  var t$1 = $n(this$1.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? (((-2147483648) ^ lo) > ((-2147483648) ^ lo$1)) : (hi > hi$1))) {
    return true
  } else if (((lo === lo$1) && (hi === hi$1))) {
    var this$3 = $n(this.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
    var this$2 = $n(other);
    var b = $n(this$2.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
    var ahi = this$3.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    return ((ahi === bhi) ? (((-2147483648) ^ this$3.RTLong__f_lo) > ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
  } else {
    return false
  }
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  var t = $n(this.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$1 = $n(other);
  var t$1 = $n(this$1.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? (((-2147483648) ^ lo) < ((-2147483648) ^ lo$1)) : (hi < hi$1))) {
    return true
  } else if (((lo === lo$1) && (hi === hi$1))) {
    var this$3 = $n(this.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
    var this$2 = $n(other);
    var b = $n(this$2.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
    var ahi = this$3.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    return ((ahi === bhi) ? (((-2147483648) ^ this$3.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
  } else {
    return false
  }
});
function $as_Ljava_time_chrono_ChronoLocalDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_chrono_ChronoLocalDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.ChronoLocalDateTime"))
}
function $isArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoLocalDateTime)))
}
function $asArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.ChronoLocalDateTime;", depth))
}
class $c_Ljava_time_format_DateTimeParseException extends $c_Ljava_time_DateTimeException {
  constructor(message, parsedData, errorIndex, cause) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
    $dp_toString__T($n(parsedData))
  };
}
function $as_Ljava_time_format_DateTimeParseException(obj) {
  return (((obj instanceof $c_Ljava_time_format_DateTimeParseException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.DateTimeParseException"))
}
function $isArrayOf_Ljava_time_format_DateTimeParseException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_DateTimeParseException)))
}
function $asArrayOf_Ljava_time_format_DateTimeParseException(obj, depth) {
  return (($isArrayOf_Ljava_time_format_DateTimeParseException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.DateTimeParseException;", depth))
}
var $d_Ljava_time_format_DateTimeParseException = new $TypeData().initClass({
  Ljava_time_format_DateTimeParseException: 0
}, false, "java.time.format.DateTimeParseException", {
  Ljava_time_format_DateTimeParseException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_DateTimeParseException.prototype.$classData = $d_Ljava_time_format_DateTimeParseException;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1() {
  /*<skip>*/
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1() {
  /*<skip>*/
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.compare__ju_Map$Entry__ju_Map$Entry__I = (function(str1, str2) {
  var this$1 = $n($as_T($n(str2).getKey__O()));
  var this$2 = $n($as_T($n(str1).getKey__O()));
  var cmp = ((this$1.length - this$2.length) | 0);
  if ((cmp === 0)) {
    cmp = $f_T__compareTo__T__I($n($as_T($n(str1).getKey__O())), $as_T($n(str2).getKey__O()))
  };
  return cmp
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__ju_Map$Entry__ju_Map$Entry__I($as_ju_Map$Entry(x), $as_ju_Map$Entry(y))
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1 = new $TypeData().initClass({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1: 0
}, false, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1", {
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1.prototype.$classData = $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$1;
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "QUARTER_OF_YEAR", 1)
}
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype = new $h_Ljava_time_temporal_IsoFields$Field();
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field$$anon$2() {
  /*<skip>*/
}
$h_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype = $c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype;
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.toString__T = (function() {
  return "QuarterOfYear"
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.range__Ljava_time_temporal_ValueRange = (function() {
  return $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(4, 0))
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z = (function(temporal) {
  return ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) && $m_Ljava_time_temporal_IsoFields$Field$().java$time$temporal$IsoFields$Field$$isIso__Ljava_time_temporal_TemporalAccessor__Z(temporal))
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange = (function(temporal) {
  return $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(4, 0))
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.getFrom__Ljava_time_temporal_TemporalAccessor__J = (function(temporal) {
  if ((!$n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z(this))) {
    var x = $m_Ljava_time_temporal_IsoFields$Field$().java$time$temporal$IsoFields$Field$$unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException("QuarterOfYear");
    throw ((x === null) ? $n(null) : x)
  };
  var t = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var lo$1 = ((2 + lo) | 0);
  var hi$1 = ((((-2147483648) ^ lo$1) < (-2147483646)) ? ((1 + hi) | 0) : hi);
  var this$2 = $m_RTLong$();
  var lo$2 = this$2.divideImpl__I__I__I__I__I(lo$1, hi$1, 3, 0);
  var hi$2 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo$2, hi$2)
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(temporal, newValue) {
  var t = this.getFrom__Ljava_time_temporal_TemporalAccessor__J(temporal);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  $n($m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(4, 0))).checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, this);
  var $$x2 = $n(temporal);
  var $$x1 = $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
  var this$2 = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
  var alo = newValue.RTLong__f_lo;
  var ahi = newValue.RTLong__f_hi;
  var lo$1 = ((alo - lo) | 0);
  var hi$1 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi) | 0)) | 0) : ((ahi - hi) | 0));
  var b0 = (65535 & lo$1);
  var b1 = ((lo$1 >>> 16) | 0);
  var a0b0 = Math.imul(3, b0);
  var a0b1 = Math.imul(3, b1);
  var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((Math.imul(3, hi$1) + ((c1part >>> 16) | 0)) | 0);
  var alo$1 = this$2.RTLong__f_lo;
  var ahi$1 = this$2.RTLong__f_hi;
  var lo$3 = ((alo$1 + lo$2) | 0);
  var hi$3 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$1 + hi$2) | 0)) | 0) : ((ahi$1 + hi$2) | 0));
  return $n($$x2).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(lo$3, hi$3))
});
var $d_Ljava_time_temporal_IsoFields$Field$$anon$2 = new $TypeData().initClass({
  Ljava_time_temporal_IsoFields$Field$$anon$2: 0
}, false, "java.time.temporal.IsoFields$Field$$anon$2", {
  Ljava_time_temporal_IsoFields$Field$$anon$2: 1,
  Ljava_time_temporal_IsoFields$Field: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.$classData = $d_Ljava_time_temporal_IsoFields$Field$$anon$2;
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "WEEK_BASED_YEAR", 3)
}
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype = new $h_Ljava_time_temporal_IsoFields$Field();
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field$$anon$4() {
  /*<skip>*/
}
$h_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype = $c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype;
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.toString__T = (function() {
  return "WeekBasedYear"
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.range__Ljava_time_temporal_ValueRange = (function() {
  var this$1 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  return this$1.Ljava_time_temporal_ChronoField__f__range
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z = (function(temporal) {
  return ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField()) && $m_Ljava_time_temporal_IsoFields$Field$().java$time$temporal$IsoFields$Field$$isIso__Ljava_time_temporal_TemporalAccessor__Z(temporal))
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange = (function(temporal) {
  var this$1 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  return this$1.Ljava_time_temporal_ChronoField__f__range
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.getFrom__Ljava_time_temporal_TemporalAccessor__J = (function(temporal) {
  if ((!$n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z(this))) {
    var x = $m_Ljava_time_temporal_IsoFields$Field$().java$time$temporal$IsoFields$Field$$unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException("WeekBasedYear");
    throw ((x === null) ? $n(null) : x)
  } else {
    var value = $m_Ljava_time_temporal_IsoFields$Field$().java$time$temporal$IsoFields$Field$$getWeekBasedYear__Ljava_time_LocalDate__I($m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal));
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  }
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(temporal, newValue) {
  if ((!this.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(temporal))) {
    var x = $m_Ljava_time_temporal_IsoFields$Field$().java$time$temporal$IsoFields$Field$$unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException("WeekBasedYear");
    throw ((x === null) ? $n(null) : x)
  };
  var this$1 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
  var newWby = $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, $m_Ljava_time_temporal_IsoFields$Field$().WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field());
  var date = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
  var dow = $n(date).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var week = $m_Ljava_time_temporal_IsoFields$Field$().java$time$temporal$IsoFields$Field$$getWeek__Ljava_time_LocalDate__I(date);
  if (((week === 53) && ($m_Ljava_time_temporal_IsoFields$Field$().java$time$temporal$IsoFields$Field$$getWeekRange__I__I(newWby) === 52))) {
    week = 52
  };
  var resolved = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(newWby, 1, 4);
  var days = ((((dow - $n(resolved).get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) | 0) + Math.imul(7, (((-1) + week) | 0))) | 0);
  var $$x1 = $n(temporal);
  var hi = (days >> 31);
  return $n($$x1).with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal($n(resolved).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(days, hi)))
});
var $d_Ljava_time_temporal_IsoFields$Field$$anon$4 = new $TypeData().initClass({
  Ljava_time_temporal_IsoFields$Field$$anon$4: 0
}, false, "java.time.temporal.IsoFields$Field$$anon$4", {
  Ljava_time_temporal_IsoFields$Field$$anon$4: 1,
  Ljava_time_temporal_IsoFields$Field: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.$classData = $d_Ljava_time_temporal_IsoFields$Field$$anon$4;
class $c_Ljava_time_temporal_UnsupportedTemporalTypeException extends $c_Ljava_time_DateTimeException {
  constructor(message) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true)
  };
}
var $d_Ljava_time_temporal_UnsupportedTemporalTypeException = new $TypeData().initClass({
  Ljava_time_temporal_UnsupportedTemporalTypeException: 0
}, false, "java.time.temporal.UnsupportedTemporalTypeException", {
  Ljava_time_temporal_UnsupportedTemporalTypeException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_temporal_UnsupportedTemporalTypeException.prototype.$classData = $d_Ljava_time_temporal_UnsupportedTemporalTypeException;
class $c_Ljava_time_zone_ZoneRulesException extends $c_Ljava_time_DateTimeException {
  constructor(message) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true)
  };
}
function $as_Ljava_time_zone_ZoneRulesException(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRulesException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRulesException"))
}
function $isArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRulesException)))
}
function $asArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRulesException;", depth))
}
var $d_Ljava_time_zone_ZoneRulesException = new $TypeData().initClass({
  Ljava_time_zone_ZoneRulesException: 0
}, false, "java.time.zone.ZoneRulesException", {
  Ljava_time_zone_ZoneRulesException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_zone_ZoneRulesException.prototype.$classData = $d_Ljava_time_zone_ZoneRulesException;
/** @constructor */
function $c_ju_AbstractMap$$anon$1(outer) {
  this.ju_AbstractMap$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.ju_AbstractMap$$anon$1__f_$outer = outer
  }
}
$c_ju_AbstractMap$$anon$1.prototype = new $h_ju_AbstractSet();
$c_ju_AbstractMap$$anon$1.prototype.constructor = $c_ju_AbstractMap$$anon$1;
/** @constructor */
function $h_ju_AbstractMap$$anon$1() {
  /*<skip>*/
}
$h_ju_AbstractMap$$anon$1.prototype = $c_ju_AbstractMap$$anon$1.prototype;
$c_ju_AbstractMap$$anon$1.prototype.size__I = (function() {
  return $n(this.ju_AbstractMap$$anon$1__f_$outer).size__I()
});
$c_ju_AbstractMap$$anon$1.prototype.iterator__ju_Iterator = (function() {
  return new $c_ju_AbstractMap$$anon$1$$anon$2(this)
});
var $d_ju_AbstractMap$$anon$1 = new $TypeData().initClass({
  ju_AbstractMap$$anon$1: 0
}, false, "java.util.AbstractMap$$anon$1", {
  ju_AbstractMap$$anon$1: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
});
$c_ju_AbstractMap$$anon$1.prototype.$classData = $d_ju_AbstractMap$$anon$1;
/** @constructor */
function $c_ju_Collections$UnmodifiableListIterator(innerIterator) {
  this.ju_Collections$UnmodifiableIterator__f_inner = null;
  $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(this, innerIterator)
}
$c_ju_Collections$UnmodifiableListIterator.prototype = new $h_ju_Collections$UnmodifiableIterator();
$c_ju_Collections$UnmodifiableListIterator.prototype.constructor = $c_ju_Collections$UnmodifiableListIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableListIterator() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableListIterator.prototype = $c_ju_Collections$UnmodifiableListIterator.prototype;
$c_ju_Collections$UnmodifiableListIterator.prototype.set__O__V = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
var $d_ju_Collections$UnmodifiableListIterator = new $TypeData().initClass({
  ju_Collections$UnmodifiableListIterator: 0
}, false, "java.util.Collections$UnmodifiableListIterator", {
  ju_Collections$UnmodifiableListIterator: 1,
  ju_Collections$UnmodifiableIterator: 1,
  O: 1,
  ju_Collections$WrappedIterator: 1,
  ju_Iterator: 1,
  ju_Collections$WrappedListIterator: 1,
  ju_ListIterator: 1
});
$c_ju_Collections$UnmodifiableListIterator.prototype.$classData = $d_ju_Collections$UnmodifiableListIterator;
class $c_ju_FormatterClosedException extends $c_jl_IllegalStateException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
}
var $d_ju_FormatterClosedException = new $TypeData().initClass({
  ju_FormatterClosedException: 0
}, false, "java.util.FormatterClosedException", {
  ju_FormatterClosedException: 1,
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_FormatterClosedException.prototype.$classData = $d_ju_FormatterClosedException;
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.ju_HashMap$EntrySet__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.ju_HashMap$EntrySet__f_$outer = outer
  }
}
$c_ju_HashMap$EntrySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$EntrySet.prototype.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
  /*<skip>*/
}
$h_ju_HashMap$EntrySet.prototype = $c_ju_HashMap$EntrySet.prototype;
$c_ju_HashMap$EntrySet.prototype.iterator__ju_Iterator = (function() {
  var this$1 = $n(this.ju_HashMap$EntrySet__f_$outer);
  return this$1.nodeIterator__ju_Iterator()
});
$c_ju_HashMap$EntrySet.prototype.size__I = (function() {
  return $n(this.ju_HashMap$EntrySet__f_$outer).ju_HashMap__f_contentSize
});
$c_ju_HashMap$EntrySet.prototype.contains__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var x2 = $as_ju_Map$Entry(o);
    var this$1 = $n(this.ju_HashMap$EntrySet__f_$outer);
    var key = $n(x2).getKey__O();
    if ((key === null)) {
      var hash = 0
    } else {
      var originalHash = $dp_hashCode__I($n(key));
      var hash = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    var node = this$1.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + $n(this$1.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0)));
    if ((node !== null)) {
      var this$3 = $n(node);
      var a = this$3.ju_HashMap$Node__f_value;
      var b = $n(x2).getValue__O();
      return ((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_HashMap$EntrySet.prototype.remove__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var x2 = $as_ju_Map$Entry(o);
    var key = $n(x2).getKey__O();
    var this$1 = $n(this.ju_HashMap$EntrySet__f_$outer);
    if ((key === null)) {
      var hash = 0
    } else {
      var originalHash = $dp_hashCode__I($n(key));
      var hash = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    var idx = (hash & (((-1) + $n(this$1.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0));
    var node = this$1.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
    if ((node !== null)) {
      var this$3 = $n(node);
      var a = this$3.ju_HashMap$Node__f_value;
      var b = $n(x2).getValue__O();
      var $$x1 = ((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(this.ju_HashMap$EntrySet__f_$outer).java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
var $d_ju_HashMap$EntrySet = new $TypeData().initClass({
  ju_HashMap$EntrySet: 0
}, false, "java.util.HashMap$EntrySet", {
  ju_HashMap$EntrySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
});
$c_ju_HashMap$EntrySet.prototype.$classData = $d_ju_HashMap$EntrySet;
/** @constructor */
function $c_ju_HashMap$KeySet(outer) {
  this.ju_HashMap$KeySet__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.ju_HashMap$KeySet__f_$outer = outer
  }
}
$c_ju_HashMap$KeySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$KeySet.prototype.constructor = $c_ju_HashMap$KeySet;
/** @constructor */
function $h_ju_HashMap$KeySet() {
  /*<skip>*/
}
$h_ju_HashMap$KeySet.prototype = $c_ju_HashMap$KeySet.prototype;
$c_ju_HashMap$KeySet.prototype.iterator__ju_Iterator = (function() {
  return $n(this.ju_HashMap$KeySet__f_$outer).keyIterator__ju_Iterator()
});
$c_ju_HashMap$KeySet.prototype.size__I = (function() {
  return $n(this.ju_HashMap$KeySet__f_$outer).ju_HashMap__f_contentSize
});
$c_ju_HashMap$KeySet.prototype.contains__O__Z = (function(o) {
  return $n(this.ju_HashMap$KeySet__f_$outer).containsKey__O__Z(o)
});
$c_ju_HashMap$KeySet.prototype.remove__O__Z = (function(o) {
  return ($n(this.ju_HashMap$KeySet__f_$outer).java$util$HashMap$$remove0__O__ju_HashMap$Node(o) !== null)
});
var $d_ju_HashMap$KeySet = new $TypeData().initClass({
  ju_HashMap$KeySet: 0
}, false, "java.util.HashMap$KeySet", {
  ju_HashMap$KeySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
});
$c_ju_HashMap$KeySet.prototype.$classData = $d_ju_HashMap$KeySet;
class $c_ju_IllegalFormatException extends $c_jl_IllegalArgumentException {
}
function $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = $thiz.ju_LinkedHashMap__f_youngest;
  if ((older !== null)) {
    $n(older).ju_LinkedHashMap$Node__f_younger = node
  } else {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = node
  };
  $n(node).ju_LinkedHashMap$Node__f_older = older;
  $n(node).ju_LinkedHashMap$Node__f_younger = null;
  $thiz.ju_LinkedHashMap__f_youngest = node
}
function $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = $n(node).ju_LinkedHashMap$Node__f_older;
  var younger = $n(node).ju_LinkedHashMap$Node__f_younger;
  if ((older === null)) {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = younger
  } else {
    $n(older).ju_LinkedHashMap$Node__f_younger = younger
  };
  if ((younger === null)) {
    $thiz.ju_LinkedHashMap__f_youngest = older
  } else {
    $n(younger).ju_LinkedHashMap$Node__f_older = older
  }
}
function $ct_ju_LinkedHashMap__I__F__Z__($thiz, initialCapacity, loadFactor, accessOrder) {
  $thiz.ju_LinkedHashMap__f_accessOrder = accessOrder;
  $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor);
  return $thiz
}
function $ct_ju_LinkedHashMap__($thiz) {
  $ct_ju_LinkedHashMap__I__F__Z__($thiz, 16, 0.75, false);
  return $thiz
}
/** @constructor */
function $c_ju_LinkedHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  this.ju_LinkedHashMap__f_accessOrder = false;
  this.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = null;
  this.ju_LinkedHashMap__f_youngest = null
}
$c_ju_LinkedHashMap.prototype = new $h_ju_HashMap();
$c_ju_LinkedHashMap.prototype.constructor = $c_ju_LinkedHashMap;
/** @constructor */
function $h_ju_LinkedHashMap() {
  /*<skip>*/
}
$h_ju_LinkedHashMap.prototype = $c_ju_LinkedHashMap.prototype;
$c_ju_LinkedHashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return new $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, null, null)
});
$c_ju_LinkedHashMap.prototype.nodeWasAccessed__ju_HashMap$Node__V = (function(node) {
  if (this.ju_LinkedHashMap__f_accessOrder) {
    var myNode = $as_ju_LinkedHashMap$Node(node);
    if (($n(myNode).ju_LinkedHashMap$Node__f_younger !== null)) {
      $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, myNode);
      $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, myNode)
    }
  }
});
$c_ju_LinkedHashMap.prototype.nodeWasAdded__ju_HashMap$Node__V = (function(node) {
  $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, $as_ju_LinkedHashMap$Node(node))
});
$c_ju_LinkedHashMap.prototype.nodeWasRemoved__ju_HashMap$Node__V = (function(node) {
  $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, $as_ju_LinkedHashMap$Node(node))
});
$c_ju_LinkedHashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_LinkedHashMap$NodeIterator(this)
});
$c_ju_LinkedHashMap.prototype.keyIterator__ju_Iterator = (function() {
  return new $c_ju_LinkedHashMap$KeyIterator(this)
});
var $d_ju_LinkedHashMap = new $TypeData().initClass({
  ju_LinkedHashMap: 0
}, false, "java.util.LinkedHashMap", {
  ju_LinkedHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
});
$c_ju_LinkedHashMap.prototype.$classData = $d_ju_LinkedHashMap;
/** @constructor */
function $c_ju_NullRejectingHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0
}
$c_ju_NullRejectingHashMap.prototype = new $h_ju_HashMap();
$c_ju_NullRejectingHashMap.prototype.constructor = $c_ju_NullRejectingHashMap;
/** @constructor */
function $h_ju_NullRejectingHashMap() {
  /*<skip>*/
}
$h_ju_NullRejectingHashMap.prototype = $c_ju_NullRejectingHashMap.prototype;
$c_ju_NullRejectingHashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return new $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next)
});
$c_ju_NullRejectingHashMap.prototype.get__O__O = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this, key, null)
});
$c_ju_NullRejectingHashMap.prototype.containsKey__O__Z = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $c_ju_HashMap.prototype.containsKey__O__Z.call(this, key)
});
$c_ju_NullRejectingHashMap.prototype.put__O__O__O = (function(key, value) {
  if (((key === null) || (value === null))) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ((key === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  return this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $$x1, false)
});
$c_ju_NullRejectingHashMap.prototype.putIfAbsent__O__O__O = (function(key, value) {
  if ((value === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var old = this.get__O__O(key);
  if ((old === null)) {
    if ((key === null)) {
      var $$x1 = 0
    } else {
      var originalHash = $dp_hashCode__I($n(key));
      var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $$x1, false)
  };
  return old
});
$c_ju_NullRejectingHashMap.prototype.putAll__ju_Map__V = (function(m) {
  var iter = $n($n(m).entrySet__ju_Set()).iterator__ju_Iterator();
  while ($n(iter).hasNext__Z()) {
    var entry = $as_ju_Map$Entry($n(iter).next__O());
    this.put__O__O__O($n(entry).getKey__O(), $n(entry).getValue__O())
  }
});
$c_ju_NullRejectingHashMap.prototype.remove__O__O = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $c_ju_HashMap.prototype.remove__O__O.call(this, key)
});
class $c_ju_regex_PatternSyntaxException extends $c_jl_IllegalArgumentException {
  constructor(desc, regex, index) {
    super();
    this.ju_regex_PatternSyntaxException__f_desc = null;
    this.ju_regex_PatternSyntaxException__f_regex = null;
    this.ju_regex_PatternSyntaxException__f_index = 0;
    this.ju_regex_PatternSyntaxException__f_desc = desc;
    this.ju_regex_PatternSyntaxException__f_regex = regex;
    this.ju_regex_PatternSyntaxException__f_index = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    var idx = this.ju_regex_PatternSyntaxException__f_index;
    var re = this.ju_regex_PatternSyntaxException__f_regex;
    var indexHint = ((idx < 0) ? "" : (" near index " + idx));
    var base = (((this.ju_regex_PatternSyntaxException__f_desc + indexHint) + "\n") + re);
    if (((idx >= 0) && (re !== null))) {
      var this$1 = $n(re);
      var $$x1 = (idx < this$1.length)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return (((base + "\n") + $f_T__repeat__I__T(" ", idx)) + "^")
    } else {
      return base
    }
  };
}
var $d_ju_regex_PatternSyntaxException = new $TypeData().initClass({
  ju_regex_PatternSyntaxException: 0
}, false, "java.util.regex.PatternSyntaxException", {
  ju_regex_PatternSyntaxException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_PatternSyntaxException.prototype.$classData = $d_ju_regex_PatternSyntaxException;
/** @constructor */
function $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2(outer) {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2.prototype.constructor = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2.prototype = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2.prototype;
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2: 0
}, false, "reactbuild.analyze.cost.ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2", {
  Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2.prototype.$classData = $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend(\u03b4) {
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__f_stateSnapshot = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$Backend__f_$ = null;
  this.Lreactbuild_analyze_cost_components_AutomaticallySave$Backend__f_$ = \u03b4;
  $ct_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend__(this)
}
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend.prototype = new $h_Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend();
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend.prototype.constructor = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend.prototype = $c_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend.prototype;
function $as_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.AutomaticallySave$Backend"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_AutomaticallySave$Backend)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.AutomaticallySave$Backend;", depth))
}
var $d_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_AutomaticallySave$Backend: 0
}, false, "reactbuild.analyze.cost.components.AutomaticallySave$Backend", {
  Lreactbuild_analyze_cost_components_AutomaticallySave$Backend: 1,
  Lreactbuild_analyze_cost_components_AutomaticallySave$TypedBackend: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_TimerSupport: 1,
  Ljapgolly_scalajs_react_extra_TimerSupportF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1
});
$c_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend.prototype.$classData = $d_Lreactbuild_analyze_cost_components_AutomaticallySave$Backend;
function $p_Lreactbuild_analyze_cost_components_Handle$CreatingColumn__loop$1__D__sci_List__I__T3($thiz, position, rest, index) {
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      return new $c_T3(($thiz.Lreactbuild_analyze_cost_components_Handle$CreatingColumn__f_origin - position), $m_s_None$(), index)
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var c = $as_Lreactbuild_person_DocumentParserColumn($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      var acc = (position + $n(c).Lreactbuild_person_DocumentParserColumn__f_width);
      if (($thiz.Lreactbuild_analyze_cost_components_Handle$CreatingColumn__f_origin < position)) {
        return new $c_T3(acc, new $c_s_Some(c), index)
      } else {
        var temp$index = ((1 + index) | 0);
        position = acc;
        rest = tail;
        index = temp$index
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn(origin) {
  this.Lreactbuild_analyze_cost_components_Handle$CreatingColumn__f_origin = 0.0;
  this.Lreactbuild_analyze_cost_components_Handle$CreatingColumn__f_origin = origin
}
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$CreatingColumn() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype = $c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.order__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point(($n(area).Lreactbuild_person_DocumentParserArea__f_left + this.Lreactbuild_analyze_cost_components_Handle$CreatingColumn__f_origin), $n(area).Lreactbuild_person_DocumentParserArea__f_centerY)
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var x1 = $p_Lreactbuild_analyze_cost_components_Handle$CreatingColumn__loop$1__D__sci_List__I__T3(this, 0.0, $n(area).Lreactbuild_person_DocumentParserArea__f_columns, 0);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var acc = $uD($n(x1).T3__f__1);
    var colOpt = $as_s_Option($n(x1).T3__f__2);
    var index = $uI($n(x1).T3__f__3);
    var column = new $c_Lreactbuild_person_DocumentParserColumn(acc, ($m_Lreactbuild_person_DocumentParserColumn$(), $m_ju_UUID$().randomUUID__ju_UUID()), ($m_Lreactbuild_person_DocumentParserColumn$(), ""));
    var newHandle = new $c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn(column.Lreactbuild_person_DocumentParserColumn__f_id);
    var this$7 = $n($n(area).Lreactbuild_person_DocumentParserArea__f_columns);
    var $$x1 = $m_s_package$().s_package$__f_Seq;
    var array = [column];
    var this$6 = $n($n($$x1).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var other = $as_sc_IterableOnce(this$6.appendedAll__sc_IterableOnce__O(colOpt));
    var replaced = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(colOpt)).size__I();
    var x$1 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$7, index, other, replaced));
    var this$8 = $n(area);
    var x$2$2 = this$8.Lreactbuild_person_DocumentParserArea__f_left;
    var this$9 = $n(area);
    var x$3 = this$9.Lreactbuild_person_DocumentParserArea__f_top;
    var this$10 = $n(area);
    var x$4 = this$10.Lreactbuild_person_DocumentParserArea__f_width;
    var this$11 = $n(area);
    var x$5 = this$11.Lreactbuild_person_DocumentParserArea__f_height;
    var this$12 = $n(area);
    var x$6 = this$12.Lreactbuild_person_DocumentParserArea__f_id;
    var this$13 = $n(area);
    var x$7 = this$13.Lreactbuild_person_DocumentParserArea__f_name;
    $n(area);
    var updatedArea = new $c_Lreactbuild_person_DocumentParserArea(x$2$2, x$3, x$4, x$5, x$6, x$7, x$1);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(updatedArea, newHandle)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.productPrefix__T = (function() {
  return "CreatingColumn"
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_Handle$CreatingColumn__f_origin : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("CreatingColumn");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_analyze_cost_components_Handle$CreatingColumn__f_origin;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn)) {
    var CreatingColumn$1 = $as_Lreactbuild_analyze_cost_components_Handle$CreatingColumn(x$1);
    return (this.Lreactbuild_analyze_cost_components_Handle$CreatingColumn__f_origin === $n(CreatingColumn$1).Lreactbuild_analyze_cost_components_Handle$CreatingColumn__f_origin)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_Handle$CreatingColumn(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Handle$CreatingColumn"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Handle$CreatingColumn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Handle$CreatingColumn)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Handle$CreatingColumn(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Handle$CreatingColumn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Handle$CreatingColumn;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Handle$CreatingColumn = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$CreatingColumn: 0
}, false, "reactbuild.analyze.cost.components.Handle$CreatingColumn", {
  Lreactbuild_analyze_cost_components_Handle$CreatingColumn: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_Handle$ColumnHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$CreatingColumn.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$CreatingColumn;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$East$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$East$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$East$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$East$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$East$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.order__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($n(area).Lreactbuild_person_DocumentParserArea__f_right, $n(area).Lreactbuild_person_DocumentParserArea__f_centerY)
});
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$9 = $m_Lreactbuild_analyze_cost_components_Handle$East$();
    var x$1 = ($n(area).Lreactbuild_person_DocumentParserArea__f_width + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var this$2 = $n(area);
    var x$2 = this$2.Lreactbuild_person_DocumentParserArea__f_left;
    var this$3 = $n(area);
    var x$3 = this$3.Lreactbuild_person_DocumentParserArea__f_top;
    var this$4 = $n(area);
    var x$4 = this$4.Lreactbuild_person_DocumentParserArea__f_height;
    var this$5 = $n(area);
    var x$5 = this$5.Lreactbuild_person_DocumentParserArea__f_id;
    var this$6 = $n(area);
    var x$6 = this$6.Lreactbuild_person_DocumentParserArea__f_name;
    var this$7 = $n(area);
    var x$7 = this$7.Lreactbuild_person_DocumentParserArea__f_columns;
    $n(area);
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(x$2, x$3, x$1, x$4, x$5, x$6, x$7);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this$9)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.productPrefix__T = (function() {
  return "East"
});
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.hashCode__I = (function() {
  return 2152477
});
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.toString__T = (function() {
  return "East"
});
var $d_Lreactbuild_analyze_cost_components_Handle$East$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$East$: 0
}, false, "reactbuild.analyze.cost.components.Handle$East$", {
  Lreactbuild_analyze_cost_components_Handle$East$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_BorderHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$East$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$East$;
var $n_Lreactbuild_analyze_cost_components_Handle$East$;
function $m_Lreactbuild_analyze_cost_components_Handle$East$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$East$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$East$ = new $c_Lreactbuild_analyze_cost_components_Handle$East$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$East$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn(id) {
  this.Lreactbuild_analyze_cost_components_Handle$ExistingColumn__f_id = null;
  this.Lreactbuild_analyze_cost_components_Handle$ExistingColumn__f_id = id
}
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$ExistingColumn() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype = $c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.order__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.getPositionInArea__Lreactbuild_person_DocumentParserArea__s_Option = (function(area) {
  $m_Lreactbuild_analyze_cost_components_PDFText$();
  var qual$1 = new $c_Lreactbuild_analyze_cost_components_PDFText$RichDocumentParserArea(area);
  var x$1 = $n(area).Lreactbuild_person_DocumentParserArea__f_left;
  var x$2 = qual$1.findColumn$default$2__sci_List();
  var position = x$1;
  var rest = x$2;
  while (true) {
    var x1 = rest;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : $n(x).equals__O__Z(x1))) {
      return $m_s_None$()
    } else if ((x1 instanceof $c_sci_$colon$colon)) {
      var x3 = $as_sci_$colon$colon(x1);
      var c = $as_Lreactbuild_person_DocumentParserColumn($n(x3).sci_$colon$colon__f_head);
      var tail = $n(x3).sci_$colon$colon__f_next;
      var acc = (position + $n(c).Lreactbuild_person_DocumentParserColumn__f_width);
      var x$3 = $n(c).Lreactbuild_person_DocumentParserColumn__f_id;
      var x$2$1 = this.Lreactbuild_analyze_cost_components_Handle$ExistingColumn__f_id;
      if (((x$3 === null) ? (x$2$1 === null) : $n(x$3).equals__O__Z(x$2$1))) {
        var x1$2 = new $c_s_Some(acc)
      } else {
        var x1$2 = $m_s_None$()
      };
      var x$3$1 = $m_s_None$();
      if ((x$3$1 === x1$2)) {
        position = acc;
        rest = tail
      } else {
        return x1$2
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  var this$1 = $n(this.getPositionInArea__Lreactbuild_person_DocumentParserArea__s_Option(area));
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($uD((this$1.isEmpty__Z() ? 10.0 : this$1.get__O())), $n(area).Lreactbuild_person_DocumentParserArea__f_centerY)
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$5 = $n($n(area).Lreactbuild_person_DocumentParserArea__f_columns);
    var f = ((c$2) => {
      var c = $as_Lreactbuild_person_DocumentParserColumn(c$2);
      var x = $n(c).Lreactbuild_person_DocumentParserColumn__f_id;
      var x$2 = this.Lreactbuild_analyze_cost_components_Handle$ExistingColumn__f_id;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        $n(c);
        var width = ($n(c).Lreactbuild_person_DocumentParserColumn__f_width + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
        var this$2 = $n(c);
        var id = this$2.Lreactbuild_person_DocumentParserColumn__f_id;
        var this$3 = $n(c);
        var name = this$3.Lreactbuild_person_DocumentParserColumn__f_name;
        return new $c_Lreactbuild_person_DocumentParserColumn(width, id, name)
      } else {
        return c
      }
    });
    if ((this$5 === $m_sci_Nil$())) {
      var x$1 = $m_sci_Nil$()
    } else {
      var arg1 = this$5.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$5.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var x$1 = h
    };
    var this$6 = $n(area);
    var x$2$1 = this$6.Lreactbuild_person_DocumentParserArea__f_left;
    var this$7 = $n(area);
    var x$3 = this$7.Lreactbuild_person_DocumentParserArea__f_top;
    var this$8 = $n(area);
    var x$4 = this$8.Lreactbuild_person_DocumentParserArea__f_width;
    var this$9 = $n(area);
    var x$5 = this$9.Lreactbuild_person_DocumentParserArea__f_height;
    var this$10 = $n(area);
    var x$6 = this$10.Lreactbuild_person_DocumentParserArea__f_id;
    var this$11 = $n(area);
    var x$7 = this$11.Lreactbuild_person_DocumentParserArea__f_name;
    $n(area);
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(x$2$1, x$3, x$4, x$5, x$6, x$7, x$1);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.productPrefix__T = (function() {
  return "ExistingColumn"
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_components_Handle$ExistingColumn__f_id : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn)) {
    var ExistingColumn$1 = $as_Lreactbuild_analyze_cost_components_Handle$ExistingColumn(x$1);
    var x = this.Lreactbuild_analyze_cost_components_Handle$ExistingColumn__f_id;
    var x$2 = $n(ExistingColumn$1).Lreactbuild_analyze_cost_components_Handle$ExistingColumn__f_id;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_components_Handle$ExistingColumn(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.components.Handle$ExistingColumn"))
}
function $isArrayOf_Lreactbuild_analyze_cost_components_Handle$ExistingColumn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_components_Handle$ExistingColumn)))
}
function $asArrayOf_Lreactbuild_analyze_cost_components_Handle$ExistingColumn(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_components_Handle$ExistingColumn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.components.Handle$ExistingColumn;", depth))
}
var $d_Lreactbuild_analyze_cost_components_Handle$ExistingColumn = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$ExistingColumn: 0
}, false, "reactbuild.analyze.cost.components.Handle$ExistingColumn", {
  Lreactbuild_analyze_cost_components_Handle$ExistingColumn: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_Handle$ColumnHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$ExistingColumn.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$ExistingColumn;
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$North$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$North$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$North$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$North$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$North$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.order__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($n(area).Lreactbuild_person_DocumentParserArea__f_centerX, $n(area).Lreactbuild_person_DocumentParserArea__f_top)
});
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$8 = $m_Lreactbuild_analyze_cost_components_Handle$North$();
    var x$1 = ($n(area).Lreactbuild_person_DocumentParserArea__f_top + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var x$2 = ($n(area).Lreactbuild_person_DocumentParserArea__f_height - $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var this$2 = $n(area);
    var x$3 = this$2.Lreactbuild_person_DocumentParserArea__f_left;
    var this$3 = $n(area);
    var x$4 = this$3.Lreactbuild_person_DocumentParserArea__f_width;
    var this$4 = $n(area);
    var x$5 = this$4.Lreactbuild_person_DocumentParserArea__f_id;
    var this$5 = $n(area);
    var x$6 = this$5.Lreactbuild_person_DocumentParserArea__f_name;
    var this$6 = $n(area);
    var x$7 = this$6.Lreactbuild_person_DocumentParserArea__f_columns;
    $n(area);
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(x$3, x$1, x$4, x$2, x$5, x$6, x$7);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this$8)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.productPrefix__T = (function() {
  return "North"
});
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.hashCode__I = (function() {
  return 75454693
});
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.toString__T = (function() {
  return "North"
});
var $d_Lreactbuild_analyze_cost_components_Handle$North$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$North$: 0
}, false, "reactbuild.analyze.cost.components.Handle$North$", {
  Lreactbuild_analyze_cost_components_Handle$North$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_BorderHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$North$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$North$;
var $n_Lreactbuild_analyze_cost_components_Handle$North$;
function $m_Lreactbuild_analyze_cost_components_Handle$North$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$North$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$North$ = new $c_Lreactbuild_analyze_cost_components_Handle$North$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$North$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$NorthEast$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$NorthEast$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$NorthEast$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.order__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($n(area).Lreactbuild_person_DocumentParserArea__f_right, $n(area).Lreactbuild_person_DocumentParserArea__f_top)
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$7 = $m_Lreactbuild_analyze_cost_components_Handle$NorthEast$();
    var x$1 = ($n(area).Lreactbuild_person_DocumentParserArea__f_width + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var x$2 = ($n(area).Lreactbuild_person_DocumentParserArea__f_top + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var x$3 = ($n(area).Lreactbuild_person_DocumentParserArea__f_height - $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var this$2 = $n(area);
    var x$4 = this$2.Lreactbuild_person_DocumentParserArea__f_left;
    var this$3 = $n(area);
    var x$5 = this$3.Lreactbuild_person_DocumentParserArea__f_id;
    var this$4 = $n(area);
    var x$6 = this$4.Lreactbuild_person_DocumentParserArea__f_name;
    var this$5 = $n(area);
    var x$7 = this$5.Lreactbuild_person_DocumentParserArea__f_columns;
    $n(area);
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(x$4, x$2, x$1, x$3, x$5, x$6, x$7);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this$7)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.productPrefix__T = (function() {
  return "NorthEast"
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.hashCode__I = (function() {
  return (-1848691070)
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.toString__T = (function() {
  return "NorthEast"
});
var $d_Lreactbuild_analyze_cost_components_Handle$NorthEast$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$NorthEast$: 0
}, false, "reactbuild.analyze.cost.components.Handle$NorthEast$", {
  Lreactbuild_analyze_cost_components_Handle$NorthEast$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_CornerHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthEast$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$NorthEast$;
var $n_Lreactbuild_analyze_cost_components_Handle$NorthEast$;
function $m_Lreactbuild_analyze_cost_components_Handle$NorthEast$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$NorthEast$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$NorthEast$ = new $c_Lreactbuild_analyze_cost_components_Handle$NorthEast$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$NorthEast$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$NorthWest$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$NorthWest$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$NorthWest$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.order__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($n(area).Lreactbuild_person_DocumentParserArea__f_left, $n(area).Lreactbuild_person_DocumentParserArea__f_top)
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$6 = $m_Lreactbuild_analyze_cost_components_Handle$NorthWest$();
    var x$1 = ($n(area).Lreactbuild_person_DocumentParserArea__f_left + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var x$2 = ($n(area).Lreactbuild_person_DocumentParserArea__f_width - $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var x$3 = ($n(area).Lreactbuild_person_DocumentParserArea__f_top + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var x$4 = ($n(area).Lreactbuild_person_DocumentParserArea__f_height - $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var this$2 = $n(area);
    var x$5 = this$2.Lreactbuild_person_DocumentParserArea__f_id;
    var this$3 = $n(area);
    var x$6 = this$3.Lreactbuild_person_DocumentParserArea__f_name;
    var this$4 = $n(area);
    var x$7 = this$4.Lreactbuild_person_DocumentParserArea__f_columns;
    $n(area);
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(x$1, x$3, x$2, x$4, x$5, x$6, x$7);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this$6)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.productPrefix__T = (function() {
  return "NorthWest"
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.hashCode__I = (function() {
  return (-1848150988)
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.toString__T = (function() {
  return "NorthWest"
});
var $d_Lreactbuild_analyze_cost_components_Handle$NorthWest$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$NorthWest$: 0
}, false, "reactbuild.analyze.cost.components.Handle$NorthWest$", {
  Lreactbuild_analyze_cost_components_Handle$NorthWest$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_CornerHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$NorthWest$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$NorthWest$;
var $n_Lreactbuild_analyze_cost_components_Handle$NorthWest$;
function $m_Lreactbuild_analyze_cost_components_Handle$NorthWest$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$NorthWest$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$NorthWest$ = new $c_Lreactbuild_analyze_cost_components_Handle$NorthWest$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$NorthWest$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$South$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$South$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$South$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$South$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$South$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.order__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($n(area).Lreactbuild_person_DocumentParserArea__f_centerX, $n(area).Lreactbuild_person_DocumentParserArea__f_bottom)
});
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$9 = $m_Lreactbuild_analyze_cost_components_Handle$South$();
    var x$1 = ($n(area).Lreactbuild_person_DocumentParserArea__f_height + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var this$2 = $n(area);
    var x$2 = this$2.Lreactbuild_person_DocumentParserArea__f_left;
    var this$3 = $n(area);
    var x$3 = this$3.Lreactbuild_person_DocumentParserArea__f_top;
    var this$4 = $n(area);
    var x$4 = this$4.Lreactbuild_person_DocumentParserArea__f_width;
    var this$5 = $n(area);
    var x$5 = this$5.Lreactbuild_person_DocumentParserArea__f_id;
    var this$6 = $n(area);
    var x$6 = this$6.Lreactbuild_person_DocumentParserArea__f_name;
    var this$7 = $n(area);
    var x$7 = this$7.Lreactbuild_person_DocumentParserArea__f_columns;
    $n(area);
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(x$2, x$3, x$4, x$1, x$5, x$6, x$7);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this$9)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.productPrefix__T = (function() {
  return "South"
});
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.hashCode__I = (function() {
  return 80075181
});
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.toString__T = (function() {
  return "South"
});
var $d_Lreactbuild_analyze_cost_components_Handle$South$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$South$: 0
}, false, "reactbuild.analyze.cost.components.Handle$South$", {
  Lreactbuild_analyze_cost_components_Handle$South$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_BorderHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$South$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$South$;
var $n_Lreactbuild_analyze_cost_components_Handle$South$;
function $m_Lreactbuild_analyze_cost_components_Handle$South$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$South$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$South$ = new $c_Lreactbuild_analyze_cost_components_Handle$South$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$South$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$SouthEast$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$SouthEast$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$SouthEast$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.order__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($n(area).Lreactbuild_person_DocumentParserArea__f_right, $n(area).Lreactbuild_person_DocumentParserArea__f_bottom)
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$8 = $m_Lreactbuild_analyze_cost_components_Handle$SouthEast$();
    var x$1 = ($n(area).Lreactbuild_person_DocumentParserArea__f_width + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var x$2 = ($n(area).Lreactbuild_person_DocumentParserArea__f_height + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var this$2 = $n(area);
    var x$3 = this$2.Lreactbuild_person_DocumentParserArea__f_left;
    var this$3 = $n(area);
    var x$4 = this$3.Lreactbuild_person_DocumentParserArea__f_top;
    var this$4 = $n(area);
    var x$5 = this$4.Lreactbuild_person_DocumentParserArea__f_id;
    var this$5 = $n(area);
    var x$6 = this$5.Lreactbuild_person_DocumentParserArea__f_name;
    var this$6 = $n(area);
    var x$7 = this$6.Lreactbuild_person_DocumentParserArea__f_columns;
    $n(area);
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(x$3, x$4, x$1, x$2, x$5, x$6, x$7);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this$8)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.productPrefix__T = (function() {
  return "SouthEast"
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.hashCode__I = (function() {
  return 366482250
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.toString__T = (function() {
  return "SouthEast"
});
var $d_Lreactbuild_analyze_cost_components_Handle$SouthEast$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$SouthEast$: 0
}, false, "reactbuild.analyze.cost.components.Handle$SouthEast$", {
  Lreactbuild_analyze_cost_components_Handle$SouthEast$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_CornerHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthEast$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$SouthEast$;
var $n_Lreactbuild_analyze_cost_components_Handle$SouthEast$;
function $m_Lreactbuild_analyze_cost_components_Handle$SouthEast$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$SouthEast$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$SouthEast$ = new $c_Lreactbuild_analyze_cost_components_Handle$SouthEast$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$SouthEast$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$SouthWest$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$SouthWest$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$SouthWest$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.order__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($n(area).Lreactbuild_person_DocumentParserArea__f_left, $n(area).Lreactbuild_person_DocumentParserArea__f_bottom)
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$7 = $m_Lreactbuild_analyze_cost_components_Handle$SouthWest$();
    var x$1 = ($n(area).Lreactbuild_person_DocumentParserArea__f_left + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var x$2 = ($n(area).Lreactbuild_person_DocumentParserArea__f_width - $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var x$3 = ($n(area).Lreactbuild_person_DocumentParserArea__f_height + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_y);
    var this$2 = $n(area);
    var x$4 = this$2.Lreactbuild_person_DocumentParserArea__f_top;
    var this$3 = $n(area);
    var x$5 = this$3.Lreactbuild_person_DocumentParserArea__f_id;
    var this$4 = $n(area);
    var x$6 = this$4.Lreactbuild_person_DocumentParserArea__f_name;
    var this$5 = $n(area);
    var x$7 = this$5.Lreactbuild_person_DocumentParserArea__f_columns;
    $n(area);
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(x$1, x$4, x$2, x$3, x$5, x$6, x$7);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this$7)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.productPrefix__T = (function() {
  return "SouthWest"
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.hashCode__I = (function() {
  return 367022332
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.toString__T = (function() {
  return "SouthWest"
});
var $d_Lreactbuild_analyze_cost_components_Handle$SouthWest$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$SouthWest$: 0
}, false, "reactbuild.analyze.cost.components.Handle$SouthWest$", {
  Lreactbuild_analyze_cost_components_Handle$SouthWest$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_CornerHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$SouthWest$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$SouthWest$;
var $n_Lreactbuild_analyze_cost_components_Handle$SouthWest$;
function $m_Lreactbuild_analyze_cost_components_Handle$SouthWest$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$SouthWest$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$SouthWest$ = new $c_Lreactbuild_analyze_cost_components_Handle$SouthWest$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$SouthWest$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_components_Handle$West$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.constructor = $c_Lreactbuild_analyze_cost_components_Handle$West$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_components_Handle$West$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_components_Handle$West$.prototype = $c_Lreactbuild_analyze_cost_components_Handle$West$.prototype;
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.order__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.getPointForArea__Lreactbuild_person_DocumentParserArea__Lreactbuild_analyze_cost_components_PDFText$Point = (function(area) {
  return new $c_Lreactbuild_analyze_cost_components_PDFText$Point($n(area).Lreactbuild_person_DocumentParserArea__f_left, $n(area).Lreactbuild_person_DocumentParserArea__f_centerY)
});
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.moveArea__Lreactbuild_analyze_cost_components_PDFText$Point__F1 = (function(delta) {
  return new $c_sjsr_AnonFunction1(((area$2) => {
    var area = $as_Lreactbuild_person_DocumentParserArea(area$2);
    var this$8 = $m_Lreactbuild_analyze_cost_components_Handle$West$();
    var x$1 = ($n(area).Lreactbuild_person_DocumentParserArea__f_left + $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var x$2 = ($n(area).Lreactbuild_person_DocumentParserArea__f_width - $n(delta).Lreactbuild_analyze_cost_components_PDFText$Point__f_x);
    var this$2 = $n(area);
    var x$3 = this$2.Lreactbuild_person_DocumentParserArea__f_top;
    var this$3 = $n(area);
    var x$4 = this$3.Lreactbuild_person_DocumentParserArea__f_height;
    var this$4 = $n(area);
    var x$5 = this$4.Lreactbuild_person_DocumentParserArea__f_id;
    var this$5 = $n(area);
    var x$6 = this$5.Lreactbuild_person_DocumentParserArea__f_name;
    var this$6 = $n(area);
    var x$7 = this$6.Lreactbuild_person_DocumentParserArea__f_columns;
    $n(area);
    var area$1 = new $c_Lreactbuild_person_DocumentParserArea(x$1, x$3, x$2, x$4, x$5, x$6, x$7);
    return new $c_Lreactbuild_analyze_cost_components_AreaWithHandle(area$1, this$8)
  }))
});
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.productPrefix__T = (function() {
  return "West"
});
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.hashCode__I = (function() {
  return 2692559
});
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.toString__T = (function() {
  return "West"
});
var $d_Lreactbuild_analyze_cost_components_Handle$West$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_components_Handle$West$: 0
}, false, "reactbuild.analyze.cost.components.Handle$West$", {
  Lreactbuild_analyze_cost_components_Handle$West$: 1,
  O: 1,
  Lreactbuild_analyze_cost_components_BorderHandle: 1,
  Lreactbuild_analyze_cost_components_Handle: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_components_Handle$West$.prototype.$classData = $d_Lreactbuild_analyze_cost_components_Handle$West$;
var $n_Lreactbuild_analyze_cost_components_Handle$West$;
function $m_Lreactbuild_analyze_cost_components_Handle$West$() {
  if ((!$n_Lreactbuild_analyze_cost_components_Handle$West$)) {
    $n_Lreactbuild_analyze_cost_components_Handle$West$ = new $c_Lreactbuild_analyze_cost_components_Handle$West$()
  };
  return $n_Lreactbuild_analyze_cost_components_Handle$West$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps(context, entry, update) {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_context = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entry = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_update = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_created = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entryOpt = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_history = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_permanentId = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_template = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_terms = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_title = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_tpe = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_context = context;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entry = entry;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_update = update;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_created = $m_s_Option$().apply__O__s_Option($n($as_Lreactbuild_model_CustomListEntry($n(entry).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_CustomListEntry__f_created);
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entryOpt = $m_s_Option$().apply__O__s_Option($n(entry).Lreactbuild_model_WithChildren__f_item);
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_history = $n(entry).Lreactbuild_model_WithChildren__f_children;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_permanentId = $n($as_Lreactbuild_model_CustomListEntry($n(entry).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_CustomListEntry__f__id;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_template = $m_s_None$();
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_terms = $n($as_Lreactbuild_model_CustomListEntry($n(entry).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_CustomListEntry__f_terms;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_title = $n($as_Lreactbuild_model_CustomListEntry($n(entry).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_CustomListEntry__f_title;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_tpe = $n($as_Lreactbuild_model_CustomListEntry($n(entry).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_CustomListEntry__f_type
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.foldExisting__F0__F1__O = (function(ifEmpty, f) {
  return $n(f).apply__O__O(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.foldInstance__F0__F1__O = (function(ifEmpty, ifExisting) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.validation__Lreactbuild_model_ListEntryValidation = (function() {
  $m_Lreactbuild_model_ListEntryValidation$();
  return $m_Lreactbuild_model_ListEntryValidation$NoValidation$()
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.context__Lreactbuild_analyze_cost_modules_EditListEntry$Context = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_context
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.update__Lreactbuild_analyze_cost_modules_EntryList$Updater = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_update
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.created__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_created
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.entryOpt__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entryOpt
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.history__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_history
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.permanentId__Lreactbuild_common_model_RefTo = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_permanentId
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.terms__sci_ListSet = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_terms
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_title
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.tpe__Lreactbuild_model_ListEntryType = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_tpe
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.productPrefix__T = (function() {
  return "CustomProps"
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_context;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entry;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_update;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps)) {
    var CustomProps$1 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_context;
    var x$2 = $n(CustomProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_context;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entry;
      var x$4 = $n(CustomProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entry;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_update;
        var x$6 = $n(CustomProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_update;
        if ((x$5 === null)) {
          return (x$6 === null)
        } else {
          var this$1 = $n(x$5);
          return (this$1 === x$6)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.template__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_template
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.createEntry__Lreactbuild_model_ListEntry = (function() {
  return $as_Lreactbuild_model_CustomListEntry($n(this.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps__f_entry).Lreactbuild_model_WithChildren__f_item)
});
function $as_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditListEntry$CustomProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditListEntry$CustomProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$CustomProps", {
  Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps: 1,
  Lreactbuild_analyze_cost_modules_EditListEntry$Props: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$CustomProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(context, entry, templateEntry, update) {
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_context = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entry = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_templateEntry = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_update = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_created = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entryOpt = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_history = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_permanentId = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_template = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_terms = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_tpe = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_title = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_validation = null;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_context = context;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entry = entry;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_templateEntry = templateEntry;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_update = update;
  var this$1 = $n(entry);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x$31 = $as_Lreactbuild_model_WithChildren(arg1);
    var $$x1 = new $c_s_Some($n($as_Lreactbuild_model_InstanceListEntry($n(x$31).Lreactbuild_model_WithChildren__f_item)).Lreactbuild_model_InstanceListEntry__f_created)
  };
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_created = $$x1;
  var this$2 = $n(entry);
  if (this$2.isEmpty__Z()) {
    var $$x2 = $m_s_None$()
  } else {
    var arg1$1 = this$2.get__O();
    var x$33 = $as_Lreactbuild_model_WithChildren(arg1$1);
    var $$x2 = new $c_s_Some($as_Lreactbuild_model_InstanceListEntry($n(x$33).Lreactbuild_model_WithChildren__f_item))
  };
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entryOpt = $$x2;
  var this$3 = $n(entry);
  if (this$3.isEmpty__Z()) {
    var $$x3 = $m_sci_Nil$()
  } else {
    var arg1$2 = this$3.get__O();
    var x$35 = $as_Lreactbuild_model_WithChildren(arg1$2);
    var $$x3 = $n(x$35).Lreactbuild_model_WithChildren__f_children
  };
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_history = $as_sci_List($$x3);
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_permanentId = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f__id;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_template = $m_s_Option$().apply__O__s_Option($n(templateEntry).Lreactbuild_model_ListTemplateEntry__f_template);
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_terms = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f_terms;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_tpe = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f_type;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_title = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f_title;
  this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_validation = $n(templateEntry).Lreactbuild_model_ListTemplateEntry__f_validation
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.foldExisting__F0__F1__O = (function(ifEmpty, f) {
  return $n(f).apply__O__O(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.context__Lreactbuild_analyze_cost_modules_EditListEntry$Context = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_context
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.update__Lreactbuild_analyze_cost_modules_EntryList$Updater = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_update
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.created__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_created
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.createEntry__Lreactbuild_model_InstanceListEntry = (function() {
  var this$1 = $n(this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entry);
  if (this$1.isEmpty__Z()) {
    var x$1 = $n(this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_templateEntry).Lreactbuild_model_ListTemplateEntry__f__id;
    var x$2 = $n($n(this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_context).Lreactbuild_analyze_cost_modules_EditListEntry$Context__f_project).Lreactbuild_common_model_Project__f__id;
    $n($m_Lreactbuild_model_package$().Lreactbuild_model_package$__f_RefTo);
    var x$3 = new $c_Lreactbuild_common_model_RefTo($m_ju_UUID$().randomUUID__ju_UUID());
    new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var $$x1 = $m_Ljava_time_Instant$();
    var this$9 = $m_RTLong$();
    var value = $uD(new Date().getTime());
    var lo = this$9.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var x$4 = $n($$x1).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
    var x$5 = $m_s_None$();
    return new $c_Lreactbuild_model_InstanceListEntry(x$1, x$3, x$4, x$2, x$5)
  } else {
    var arg1 = this$1.get__O();
    var x$32 = $as_Lreactbuild_model_WithChildren(arg1);
    return $as_Lreactbuild_model_InstanceListEntry($n(x$32).Lreactbuild_model_WithChildren__f_item)
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.entryOpt__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entryOpt
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.foldInstance__F0__F1__O = (function(ifEmpty, f) {
  return $n(f).apply__O__O(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.history__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_history
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.permanentId__Lreactbuild_common_model_RefTo = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_permanentId
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.template__s_Option = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_template
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.terms__sci_ListSet = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_terms
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.tpe__Lreactbuild_model_ListEntryType = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_tpe
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_title
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.validation__Lreactbuild_model_ListEntryValidation = (function() {
  return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_validation
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.productPrefix__T = (function() {
  return "InstanceProps"
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_context;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entry;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_templateEntry;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_update;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps)) {
    var InstanceProps$1 = $as_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_context;
    var x$2 = $n(InstanceProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_context;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entry;
      var x$4 = $n(InstanceProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_entry;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_templateEntry;
      var x$6 = $n(InstanceProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_templateEntry;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_update;
        var x$8 = $n(InstanceProps$1).Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps__f_update;
        if ((x$7 === null)) {
          return (x$8 === null)
        } else {
          var this$1 = $n(x$7);
          return (this$1 === x$8)
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.createEntry__Lreactbuild_model_ListEntry = (function() {
  return this.createEntry__Lreactbuild_model_InstanceListEntry()
});
function $as_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.EditListEntry$InstanceProps"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.EditListEntry$InstanceProps;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$InstanceProps", {
  Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_EditListEntry$ExistingProps: 1,
  Lreactbuild_analyze_cost_modules_EditListEntry$Props: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$InstanceProps;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList(outer, communication) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_communication = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_title = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_$outer = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_communication = communication;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_$outer = outer
  };
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_title = "Echanges"
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.handleClose__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq = (function(router, proxy, person, setDetailState) {
  var $$x133 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
  var $$x132 = $n(person).Lreactbuild_person_Person__f__id;
  var $$x128 = new $c_sjsr_AnonFunction1(((ref$2) => {
    var ref = $as_Lreactbuild_common_model_RefTo(ref$2);
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x131 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x130 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listCommunications"];
    var $$x129 = $as_sci_Seq($n($$x130).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$13 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$8 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
    var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var y = this$8.write__O__Lio_circe_Encoder__Lio_circe_Json(ref, evidence$2);
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "person", y)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($$x131).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x129, this$13.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$14 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$16 = $n(new $c_Lautowire_ClientProxy(this$14).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_model_Communication$().Lreactbuild_model_Communication$__f_codecForCommunication;
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$16.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  }));
  var $$x3 = new $c_sjsr_AnonFunction1(((r$2) => {
    var r = $as_Ldiode_data_Pot(r$2);
    if ($n(r).isFailed__Z()) {
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var $$x4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var v = $n(r).toString__T();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$2 = [$$x4, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
      return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    } else {
      var this$27 = $n(r);
      if ((!this$27.isEmpty__Z())) {
        var arg1 = $n(r).get__O();
        var r$2$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
        var $$x126 = $m_Lcom_iz2use_react_components_Multiview$();
        var $$x125 = new $c_Lcom_iz2use_react_components_internal_multiview_TraversableSourceHandler();
        var this$29 = $m_s_Symbol$();
        var $$x122 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$29, "_id"));
        var this$30 = $m_s_Symbol$();
        var $$x121 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$30, "organization"));
        var this$31 = $m_s_Symbol$();
        var $$x120 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "persons"));
        var this$32 = $m_s_Symbol$();
        var $$x119 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$32, "senderAddress"));
        var this$33 = $m_s_Symbol$();
        var $$x118 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$33, "receiverAddress"));
        var this$34 = $m_s_Symbol$();
        var $$x117 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "date"));
        var this$35 = $m_s_Symbol$();
        var $$x116 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$35, "subject"));
        var this$36 = $m_s_Symbol$();
        var $$x115 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$36, "bodies"));
        var this$37 = $m_s_Symbol$();
        var $$x114 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "attachments"));
        var this$38 = $m_s_Symbol$();
        var labels = new $c_Lshapeless_$colon$colon($$x122, new $c_Lshapeless_$colon$colon($$x121, new $c_Lshapeless_$colon$colon($$x120, new $c_Lshapeless_$colon$colon($$x119, new $c_Lshapeless_$colon$colon($$x118, new $c_Lshapeless_$colon$colon($$x117, new $c_Lshapeless_$colon$colon($$x116, new $c_Lshapeless_$colon$colon($$x115, new $c_Lshapeless_$colon$colon($$x114, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$38, "headers")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
        var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
          var x0$3 = $as_Lreactbuild_model_Communication(x0$3$2);
          if ((x0$3 !== null)) {
            var _id$macro$31 = $n(x0$3).Lreactbuild_model_Communication__f__id;
            var organization$macro$32 = $n(x0$3).Lreactbuild_model_Communication__f_organization;
            var persons$macro$33 = $n(x0$3).Lreactbuild_model_Communication__f_persons;
            var senderAddress$macro$34 = $n(x0$3).Lreactbuild_model_Communication__f_senderAddress;
            var receiverAddress$macro$35 = $n(x0$3).Lreactbuild_model_Communication__f_receiverAddress;
            var date$macro$36 = $n(x0$3).Lreactbuild_model_Communication__f_date;
            var subject$macro$37 = $n(x0$3).Lreactbuild_model_Communication__f_subject;
            var bodies$macro$38 = $n(x0$3).Lreactbuild_model_Communication__f_bodies;
            var attachments$macro$39 = $n(x0$3).Lreactbuild_model_Communication__f_attachments;
            var headers$macro$40 = $n(x0$3).Lreactbuild_model_Communication__f_headers;
            return new $c_Lshapeless_$colon$colon(_id$macro$31, new $c_Lshapeless_$colon$colon(organization$macro$32, new $c_Lshapeless_$colon$colon(persons$macro$33, new $c_Lshapeless_$colon$colon(senderAddress$macro$34, new $c_Lshapeless_$colon$colon(receiverAddress$macro$35, new $c_Lshapeless_$colon$colon(date$macro$36, new $c_Lshapeless_$colon$colon(subject$macro$37, new $c_Lshapeless_$colon$colon(bodies$macro$38, new $c_Lshapeless_$colon$colon(attachments$macro$39, new $c_Lshapeless_$colon$colon(headers$macro$40, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$3)
          }
        }));
        var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
          var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
          if ((x0$4 !== null)) {
            var _id$macro$21 = $as_Lreactbuild_common_model_RefTo($n(x0$4).Lshapeless_$colon$colon__f_head);
            var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
            if ((p2 !== null)) {
              var organization$macro$22 = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
              var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
              if ((p3 !== null)) {
                var persons$macro$23 = $as_sci_Seq($n(p3).Lshapeless_$colon$colon__f_head);
                var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
                if ((p4 !== null)) {
                  var senderAddress$macro$24 = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
                  var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
                  if ((p5 !== null)) {
                    var receiverAddress$macro$25 = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
                    var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                    if ((p6 !== null)) {
                      var date$macro$26 = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
                      var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                      if ((p7 !== null)) {
                        var subject$macro$27 = $as_T($n(p7).Lshapeless_$colon$colon__f_head);
                        var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                        if ((p8 !== null)) {
                          var bodies$macro$28 = $as_sci_Seq($n(p8).Lshapeless_$colon$colon__f_head);
                          var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                          if ((p9 !== null)) {
                            var attachments$macro$29 = $as_sci_Seq($n(p9).Lshapeless_$colon$colon__f_head);
                            var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                            if ((p10 !== null)) {
                              var headers$macro$30 = $as_sci_Map($n(p10).Lshapeless_$colon$colon__f_head);
                              var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                              var x = $m_Lshapeless_HNil$();
                              if ((x === p11)) {
                                return new $c_Lreactbuild_model_Communication(_id$macro$21, organization$macro$22, persons$macro$23, senderAddress$macro$24, receiverAddress$macro$25, date$macro$26, subject$macro$27, bodies$macro$28, attachments$macro$29, headers$macro$30)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$4)
        }));
        var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$41 = $m_s_Symbol$();
        var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$41, "headers"));
        new $c_Lshapeless_Witness$$anon$1(value0);
        var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
        $m_Lshapeless_Witness$();
        var this$44 = $m_s_Symbol$();
        var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$44, "attachments"));
        new $c_Lshapeless_Witness$$anon$1(value0$1);
        var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
        $m_Lshapeless_Witness$();
        var this$47 = $m_s_Symbol$();
        var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$47, "bodies"));
        new $c_Lshapeless_Witness$$anon$1(value0$2);
        var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
        $m_Lshapeless_Witness$();
        var this$50 = $m_s_Symbol$();
        var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$50, "subject"));
        new $c_Lshapeless_Witness$$anon$1(value0$3);
        var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
        $m_Lshapeless_Witness$();
        var this$53 = $m_s_Symbol$();
        var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$53, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$4);
        var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
        $m_Lshapeless_Witness$();
        var this$56 = $m_s_Symbol$();
        var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$56, "receiverAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$5);
        var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
        $m_Lshapeless_Witness$();
        var this$59 = $m_s_Symbol$();
        var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$59, "senderAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$6);
        var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
        $m_Lshapeless_Witness$();
        var this$62 = $m_s_Symbol$();
        var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$62, "persons"));
        new $c_Lshapeless_Witness$$anon$1(value0$7);
        var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
        $m_Lshapeless_Witness$();
        var this$65 = $m_s_Symbol$();
        var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$65, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$8);
        var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
        $m_Lshapeless_Witness$();
        var this$68 = $m_s_Symbol$();
        var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "_id"));
        new $c_Lshapeless_Witness$$anon$1(value0$9);
        var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
        var this$71 = $m_s_$less$colon$less$();
        var ev = this$71.s_$less$colon$less$__f_singleton;
        var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
        $m_Lshapeless_Witness$();
        var this$73 = $m_s_Symbol$();
        var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "headers"));
        var wk = new $c_Lshapeless_Witness$$anon$1(value0$10);
        var tailToMap = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk);
        var keyLub = new $c_Lshapeless_Lub$$anon$4();
        var valueLub = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$78 = $m_s_Symbol$();
        var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "attachments"));
        var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
        var tailToMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap, keyLub, valueLub, wk$1);
        var keyLub$1 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$1 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$83 = $m_s_Symbol$();
        var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "bodies"));
        var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$12);
        var tailToMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$2);
        var keyLub$2 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$2 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$88 = $m_s_Symbol$();
        var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "subject"));
        var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$13);
        var tailToMap$3 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$2, keyLub$2, valueLub$2, wk$3);
        var keyLub$3 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$3 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$93 = $m_s_Symbol$();
        var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "date"));
        var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$14);
        var tailToMap$4 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$3, keyLub$3, valueLub$3, wk$4);
        var keyLub$4 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$4 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$98 = $m_s_Symbol$();
        var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$98, "receiverAddress"));
        var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$15);
        var tailToMap$5 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$4, keyLub$4, valueLub$4, wk$5);
        var keyLub$5 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$5 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$103 = $m_s_Symbol$();
        var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$103, "senderAddress"));
        var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$16);
        var tailToMap$6 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$5, keyLub$5, valueLub$5, wk$6);
        var keyLub$6 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$6 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$108 = $m_s_Symbol$();
        var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$108, "persons"));
        var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$17);
        var tailToMap$7 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$6, keyLub$6, valueLub$6, wk$7);
        var keyLub$7 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$7 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$113 = $m_s_Symbol$();
        var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$113, "organization"));
        var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$18);
        var tailToMap$8 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$7, keyLub$7, valueLub$7, wk$8);
        var keyLub$8 = new $c_Lshapeless_Lub$$anon$4();
        var valueLub$8 = new $c_Lshapeless_Lub$$anon$4();
        $m_Lshapeless_Witness$();
        var this$118 = $m_s_Symbol$();
        var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$118, "_id"));
        var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$19);
        var toMap = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$8, keyLub$8, valueLub$8, wk$9);
        $m_Lshapeless_Witness$();
        var this$121 = $m_s_Symbol$();
        var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$121, "_id"));
        var wk$19 = new $c_Lshapeless_Witness$$anon$1(value0$20);
        var tv$9 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
        $m_Lshapeless_Witness$();
        var this$123 = $m_s_Symbol$();
        var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$123, "organization"));
        var wk$18 = new $c_Lshapeless_Witness$$anon$1(value0$21);
        var tv$8 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
        $m_Lshapeless_Witness$();
        var this$125 = $m_s_Symbol$();
        var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$125, "persons"));
        var wk$17 = new $c_Lshapeless_Witness$$anon$1(value0$22);
        var tv$7 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_CommunicationPerson.getClassOf(), new $c_sjsr_AnonFunction0((() => "CommunicationPerson"))));
        $m_Lshapeless_Witness$();
        var this$128 = $m_s_Symbol$();
        var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$128, "senderAddress"));
        var wk$16 = new $c_Lshapeless_Witness$$anon$1(value0$23);
        var tv$6 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")));
        $m_Lshapeless_Witness$();
        var this$130 = $m_s_Symbol$();
        var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$130, "receiverAddress"));
        var wk$15 = new $c_Lshapeless_Witness$$anon$1(value0$24);
        var tv$5 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")));
        $m_Lshapeless_Witness$();
        var this$132 = $m_s_Symbol$();
        var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$132, "date"));
        var wk$14 = new $c_Lshapeless_Witness$$anon$1(value0$25);
        var tv$4 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_Instant.getClassOf(), new $c_sjsr_AnonFunction0((() => "Instant")));
        $m_Lshapeless_Witness$();
        var this$134 = $m_s_Symbol$();
        var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$134, "subject"));
        var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$26);
        var tv$3 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")));
        $m_Lshapeless_Witness$();
        var this$136 = $m_s_Symbol$();
        var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$136, "bodies"));
        var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$27);
        var tv$2 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_CommunicationBody.getClassOf(), new $c_sjsr_AnonFunction0((() => "CommunicationBody"))));
        $m_Lshapeless_Witness$();
        var this$139 = $m_s_Symbol$();
        var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$139, "attachments"));
        var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$28);
        var tv$1 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_CommunicationAttachment.getClassOf(), new $c_sjsr_AnonFunction0((() => "CommunicationAttachment"))));
        $m_Lshapeless_Witness$();
        var this$142 = $m_s_Symbol$();
        var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$142, "headers"));
        var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$29);
        var $$x123 = $m_Lshapeless_Typeable$();
        var this$144 = $m_s_$less$colon$less$();
        var tv = $n($$x123).genMapTypeable__s_$less$colon$less__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable__Lshapeless_Typeable(this$144.s_$less$colon$less$__f_singleton, new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Map.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))), $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String")))));
        var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
        var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$10, tv, fmt);
        var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$11, tv$1, fmt$1);
        var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$12, tv$2, fmt$2);
        var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$13, tv$3, fmt$3);
        var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$14, tv$4, fmt$4);
        var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$15, tv$5, fmt$5);
        var fmt$7 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$16, tv$6, fmt$6);
        var fmt$8 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$17, tv$7, fmt$7);
        var fmt$9 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$18, tv$8, fmt$8);
        var fromMap = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$19, tv$9, fmt$9);
        var $$x124 = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap, gen$1, fromMap);
        $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$();
        var this$360 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$359 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$358 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$357 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$159 = $m_s_Symbol$();
        var $$x63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$159, "_id"));
        var this$160 = $m_s_Symbol$();
        var $$x62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$160, "organization"));
        var this$161 = $m_s_Symbol$();
        var $$x61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$161, "persons"));
        var this$162 = $m_s_Symbol$();
        var $$x60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$162, "senderAddress"));
        var this$163 = $m_s_Symbol$();
        var $$x59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$163, "receiverAddress"));
        var this$164 = $m_s_Symbol$();
        var $$x58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$164, "date"));
        var this$165 = $m_s_Symbol$();
        var $$x57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$165, "subject"));
        var this$166 = $m_s_Symbol$();
        var $$x56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$166, "bodies"));
        var this$167 = $m_s_Symbol$();
        var $$x55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$167, "attachments"));
        var this$168 = $m_s_Symbol$();
        var labels$1 = new $c_Lshapeless_$colon$colon($$x63, new $c_Lshapeless_$colon$colon($$x62, new $c_Lshapeless_$colon$colon($$x61, new $c_Lshapeless_$colon$colon($$x60, new $c_Lshapeless_$colon$colon($$x59, new $c_Lshapeless_$colon$colon($$x58, new $c_Lshapeless_$colon$colon($$x57, new $c_Lshapeless_$colon$colon($$x56, new $c_Lshapeless_$colon$colon($$x55, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$168, "headers")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
        var f$1 = new $c_sjsr_AnonFunction1(((x0$7$2) => {
          var x0$7 = $as_Lreactbuild_model_Communication(x0$7$2);
          if ((x0$7 !== null)) {
            var _id$macro$71 = $n(x0$7).Lreactbuild_model_Communication__f__id;
            var organization$macro$72 = $n(x0$7).Lreactbuild_model_Communication__f_organization;
            var persons$macro$73 = $n(x0$7).Lreactbuild_model_Communication__f_persons;
            var senderAddress$macro$74 = $n(x0$7).Lreactbuild_model_Communication__f_senderAddress;
            var receiverAddress$macro$75 = $n(x0$7).Lreactbuild_model_Communication__f_receiverAddress;
            var date$macro$76 = $n(x0$7).Lreactbuild_model_Communication__f_date;
            var subject$macro$77 = $n(x0$7).Lreactbuild_model_Communication__f_subject;
            var bodies$macro$78 = $n(x0$7).Lreactbuild_model_Communication__f_bodies;
            var attachments$macro$79 = $n(x0$7).Lreactbuild_model_Communication__f_attachments;
            var headers$macro$80 = $n(x0$7).Lreactbuild_model_Communication__f_headers;
            return new $c_Lshapeless_$colon$colon(_id$macro$71, new $c_Lshapeless_$colon$colon(organization$macro$72, new $c_Lshapeless_$colon$colon(persons$macro$73, new $c_Lshapeless_$colon$colon(senderAddress$macro$74, new $c_Lshapeless_$colon$colon(receiverAddress$macro$75, new $c_Lshapeless_$colon$colon(date$macro$76, new $c_Lshapeless_$colon$colon(subject$macro$77, new $c_Lshapeless_$colon$colon(bodies$macro$78, new $c_Lshapeless_$colon$colon(attachments$macro$79, new $c_Lshapeless_$colon$colon(headers$macro$80, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$7)
          }
        }));
        var g$1 = new $c_sjsr_AnonFunction1(((x0$8$2) => {
          var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
          if ((x0$8 !== null)) {
            var _id$macro$61 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
            var p2$1 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
            if ((p2$1 !== null)) {
              var organization$macro$62 = $as_Lreactbuild_common_model_RefTo($n(p2$1).Lshapeless_$colon$colon__f_head);
              var p3$1 = $as_Lshapeless_$colon$colon($n(p2$1).Lshapeless_$colon$colon__f_tail);
              if ((p3$1 !== null)) {
                var persons$macro$63 = $as_sci_Seq($n(p3$1).Lshapeless_$colon$colon__f_head);
                var p4$1 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
                if ((p4$1 !== null)) {
                  var senderAddress$macro$64 = $as_T($n(p4$1).Lshapeless_$colon$colon__f_head);
                  var p5$1 = $as_Lshapeless_$colon$colon($n(p4$1).Lshapeless_$colon$colon__f_tail);
                  if ((p5$1 !== null)) {
                    var receiverAddress$macro$65 = $as_T($n(p5$1).Lshapeless_$colon$colon__f_head);
                    var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
                    if ((p6$1 !== null)) {
                      var date$macro$66 = $as_Ljava_time_Instant($n(p6$1).Lshapeless_$colon$colon__f_head);
                      var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                      if ((p7$1 !== null)) {
                        var subject$macro$67 = $as_T($n(p7$1).Lshapeless_$colon$colon__f_head);
                        var p8$1 = $as_Lshapeless_$colon$colon($n(p7$1).Lshapeless_$colon$colon__f_tail);
                        if ((p8$1 !== null)) {
                          var bodies$macro$68 = $as_sci_Seq($n(p8$1).Lshapeless_$colon$colon__f_head);
                          var p9$1 = $as_Lshapeless_$colon$colon($n(p8$1).Lshapeless_$colon$colon__f_tail);
                          if ((p9$1 !== null)) {
                            var attachments$macro$69 = $as_sci_Seq($n(p9$1).Lshapeless_$colon$colon__f_head);
                            var p10$1 = $as_Lshapeless_$colon$colon($n(p9$1).Lshapeless_$colon$colon__f_tail);
                            if ((p10$1 !== null)) {
                              var headers$macro$70 = $as_sci_Map($n(p10$1).Lshapeless_$colon$colon__f_head);
                              var p11$1 = $as_Lshapeless_HNil($n(p10$1).Lshapeless_$colon$colon__f_tail);
                              var x$2 = $m_Lshapeless_HNil$();
                              if ((x$2 === p11$1)) {
                                return new $c_Lreactbuild_model_Communication(_id$macro$61, organization$macro$62, persons$macro$63, senderAddress$macro$64, receiverAddress$macro$65, date$macro$66, subject$macro$67, bodies$macro$68, attachments$macro$69, headers$macro$70)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$8)
        }));
        var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys$10 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$171 = $m_s_Symbol$();
        var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$171, "headers"));
        new $c_Lshapeless_Witness$$anon$1(value0$30);
        var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
        $m_Lshapeless_Witness$();
        var this$174 = $m_s_Symbol$();
        var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$174, "attachments"));
        new $c_Lshapeless_Witness$$anon$1(value0$31);
        var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
        $m_Lshapeless_Witness$();
        var this$177 = $m_s_Symbol$();
        var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$177, "bodies"));
        new $c_Lshapeless_Witness$$anon$1(value0$32);
        var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
        $m_Lshapeless_Witness$();
        var this$180 = $m_s_Symbol$();
        var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$180, "subject"));
        new $c_Lshapeless_Witness$$anon$1(value0$33);
        var zipWithKeys$14 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
        $m_Lshapeless_Witness$();
        var this$183 = $m_s_Symbol$();
        var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$183, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$34);
        var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
        $m_Lshapeless_Witness$();
        var this$186 = $m_s_Symbol$();
        var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$186, "receiverAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$35);
        var zipWithKeys$16 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
        $m_Lshapeless_Witness$();
        var this$189 = $m_s_Symbol$();
        var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$189, "senderAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$36);
        var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
        $m_Lshapeless_Witness$();
        var this$192 = $m_s_Symbol$();
        var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$192, "persons"));
        new $c_Lshapeless_Witness$$anon$1(value0$37);
        var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
        $m_Lshapeless_Witness$();
        var this$195 = $m_s_Symbol$();
        var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$195, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$38);
        var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
        $m_Lshapeless_Witness$();
        var this$198 = $m_s_Symbol$();
        var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$198, "_id"));
        new $c_Lshapeless_Witness$$anon$1(value0$39);
        var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
        var this$201 = $m_s_$less$colon$less$();
        var ev$1 = this$201.s_$less$colon$less$__f_singleton;
        new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$1);
        var this$252 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Communication", "reactbuild.model.RefTo[reactbuild.model.Communication]");
        var this$251 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$203 = $m_s_Symbol$();
        var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$203, "organization"));
        var witness$4 = new $c_Lshapeless_Witness$$anon$1(value0$40);
        var $$x67 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var this$205 = $m_Lreactbuild_model_Implicits$();
        var format = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$205);
        var $$x66 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format);
        var this$208 = $m_Lreactbuild_model_Implicits$();
        var this$207 = $m_Lreactbuild_model_Implicits$();
        var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$207, proxy);
        var $$x65 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$208, ev$2)));
        var $$x64 = new $c_Lcom_iz2use_react_components_NotEditable();
        var this$210 = $m_Lreactbuild_model_Implicits$();
        var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$210, proxy);
        var fieldRenderable$4 = $n($$x67).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x66, $$x65, $$x64, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        var this$250 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Communication", "Seq[reactbuild.model.CommunicationPerson]");
        var this$249 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$212 = $m_s_Symbol$();
        var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$212, "senderAddress"));
        var witness$3 = new $c_Lshapeless_Witness$$anon$1(value0$41);
        var $$x71 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var format$1 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var $$x70 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$1);
        var $$x69 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
        $m_Lcom_iz2use_common_Parsable$();
        var evDefault = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
        var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
        var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var resolver = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
        var $$x68 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner, resolver);
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var fieldRenderable$3 = $n($$x71).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x70, $$x69, $$x68, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$1), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
        var this$248 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$220 = $m_s_Symbol$();
        var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$220, "receiverAddress"));
        var witness$2 = new $c_Lshapeless_Witness$$anon$1(value0$42);
        var $$x75 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var format$2 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var $$x74 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$2);
        var $$x73 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
        $m_Lcom_iz2use_common_Parsable$();
        var evDefault$1 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
        var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
        var parser$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var resolver$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
        var $$x72 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$1, resolver$1);
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var fieldRenderable$2 = $n($$x75).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x74, $$x73, $$x72, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$3), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
        var this$247 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$228 = $m_s_Symbol$();
        var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$228, "date"));
        var witness$1 = new $c_Lshapeless_Witness$$anon$1(value0$43);
        var $$x79 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var format$3 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
        var $$x78 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$3);
        var $$x77 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering));
        var $$x76 = new $c_Lcom_iz2use_react_components_NotEditable();
        var this$232 = $m_Lreactbuild_model_Implicits$();
        var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
        var textualizable$1 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$232, locale);
        var fieldRenderable$1 = $n($$x79).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x78, $$x77, $$x76, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$1), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        var this$246 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        $m_Lshapeless_Witness$();
        var this$234 = $m_s_Symbol$();
        var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$234, "subject"));
        var witness = new $c_Lshapeless_Witness$$anon$1(value0$44);
        var $$x83 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var format$4 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var $$x82 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$4);
        var $$x81 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
        $m_Lcom_iz2use_common_Parsable$();
        var evDefault$2 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
        var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
        var parser$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var resolver$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
        var $$x80 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$2, resolver$2);
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var fieldRenderable = $n($$x83).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x82, $$x81, $$x80, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$5), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
        var this$245 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Communication", "Seq[reactbuild.model.CommunicationBody]");
        var this$244 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Communication", "Seq[reactbuild.model.CommunicationAttachment]");
        var this$243 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_ForgetField("reactbuild.model.Communication", "Map[String,Seq[String]]");
        var tail = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4();
        var tail$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$243, tail);
        var tail$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$244, tail$1);
        var tail$3 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$245, tail$2);
        var tail$4 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$246, fieldRenderable, witness, tail$3);
        var tail$5 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$247, fieldRenderable$1, witness$1, tail$4);
        var tail$6 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$248, fieldRenderable$2, witness$2, tail$5);
        var tail$7 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$249, fieldRenderable$3, witness$3, tail$6);
        var tail$8 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$250, tail$7);
        var tail$9 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$251, fieldRenderable$4, witness$4, tail$8);
        var renderer = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererLowPriorityImplicits$$anon$2(this$252, tail$9);
        $m_s_DummyImplicit$();
        new $c_Lshapeless_Refute$$anon$2();
        var view$1 = new $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1(renderer);
        var this$355 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$354 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
        var this$255 = $m_s_Symbol$();
        var $$x92 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$255, "_id"));
        var this$256 = $m_s_Symbol$();
        var $$x91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$256, "organization"));
        var this$257 = $m_s_Symbol$();
        var $$x90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$257, "persons"));
        var this$258 = $m_s_Symbol$();
        var $$x89 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$258, "senderAddress"));
        var this$259 = $m_s_Symbol$();
        var $$x88 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$259, "receiverAddress"));
        var this$260 = $m_s_Symbol$();
        var $$x87 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$260, "date"));
        var this$261 = $m_s_Symbol$();
        var $$x86 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$261, "subject"));
        var this$262 = $m_s_Symbol$();
        var $$x85 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$262, "bodies"));
        var this$263 = $m_s_Symbol$();
        var $$x84 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$263, "attachments"));
        var this$264 = $m_s_Symbol$();
        var labels$2 = new $c_Lshapeless_$colon$colon($$x92, new $c_Lshapeless_$colon$colon($$x91, new $c_Lshapeless_$colon$colon($$x90, new $c_Lshapeless_$colon$colon($$x89, new $c_Lshapeless_$colon$colon($$x88, new $c_Lshapeless_$colon$colon($$x87, new $c_Lshapeless_$colon$colon($$x86, new $c_Lshapeless_$colon$colon($$x85, new $c_Lshapeless_$colon$colon($$x84, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$264, "headers")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
        var f$2 = new $c_sjsr_AnonFunction1(((x0$11$2) => {
          var x0$11 = $as_Lreactbuild_model_Communication(x0$11$2);
          if ((x0$11 !== null)) {
            var _id$macro$111 = $n(x0$11).Lreactbuild_model_Communication__f__id;
            var organization$macro$112 = $n(x0$11).Lreactbuild_model_Communication__f_organization;
            var persons$macro$113 = $n(x0$11).Lreactbuild_model_Communication__f_persons;
            var senderAddress$macro$114 = $n(x0$11).Lreactbuild_model_Communication__f_senderAddress;
            var receiverAddress$macro$115 = $n(x0$11).Lreactbuild_model_Communication__f_receiverAddress;
            var date$macro$116 = $n(x0$11).Lreactbuild_model_Communication__f_date;
            var subject$macro$117 = $n(x0$11).Lreactbuild_model_Communication__f_subject;
            var bodies$macro$118 = $n(x0$11).Lreactbuild_model_Communication__f_bodies;
            var attachments$macro$119 = $n(x0$11).Lreactbuild_model_Communication__f_attachments;
            var headers$macro$120 = $n(x0$11).Lreactbuild_model_Communication__f_headers;
            return new $c_Lshapeless_$colon$colon(_id$macro$111, new $c_Lshapeless_$colon$colon(organization$macro$112, new $c_Lshapeless_$colon$colon(persons$macro$113, new $c_Lshapeless_$colon$colon(senderAddress$macro$114, new $c_Lshapeless_$colon$colon(receiverAddress$macro$115, new $c_Lshapeless_$colon$colon(date$macro$116, new $c_Lshapeless_$colon$colon(subject$macro$117, new $c_Lshapeless_$colon$colon(bodies$macro$118, new $c_Lshapeless_$colon$colon(attachments$macro$119, new $c_Lshapeless_$colon$colon(headers$macro$120, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$11)
          }
        }));
        var g$2 = new $c_sjsr_AnonFunction1(((x0$12$2) => {
          var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
          if ((x0$12 !== null)) {
            var _id$macro$101 = $as_Lreactbuild_common_model_RefTo($n(x0$12).Lshapeless_$colon$colon__f_head);
            var p2$2 = $as_Lshapeless_$colon$colon($n(x0$12).Lshapeless_$colon$colon__f_tail);
            if ((p2$2 !== null)) {
              var organization$macro$102 = $as_Lreactbuild_common_model_RefTo($n(p2$2).Lshapeless_$colon$colon__f_head);
              var p3$2 = $as_Lshapeless_$colon$colon($n(p2$2).Lshapeless_$colon$colon__f_tail);
              if ((p3$2 !== null)) {
                var persons$macro$103 = $as_sci_Seq($n(p3$2).Lshapeless_$colon$colon__f_head);
                var p4$2 = $as_Lshapeless_$colon$colon($n(p3$2).Lshapeless_$colon$colon__f_tail);
                if ((p4$2 !== null)) {
                  var senderAddress$macro$104 = $as_T($n(p4$2).Lshapeless_$colon$colon__f_head);
                  var p5$2 = $as_Lshapeless_$colon$colon($n(p4$2).Lshapeless_$colon$colon__f_tail);
                  if ((p5$2 !== null)) {
                    var receiverAddress$macro$105 = $as_T($n(p5$2).Lshapeless_$colon$colon__f_head);
                    var p6$2 = $as_Lshapeless_$colon$colon($n(p5$2).Lshapeless_$colon$colon__f_tail);
                    if ((p6$2 !== null)) {
                      var date$macro$106 = $as_Ljava_time_Instant($n(p6$2).Lshapeless_$colon$colon__f_head);
                      var p7$2 = $as_Lshapeless_$colon$colon($n(p6$2).Lshapeless_$colon$colon__f_tail);
                      if ((p7$2 !== null)) {
                        var subject$macro$107 = $as_T($n(p7$2).Lshapeless_$colon$colon__f_head);
                        var p8$2 = $as_Lshapeless_$colon$colon($n(p7$2).Lshapeless_$colon$colon__f_tail);
                        if ((p8$2 !== null)) {
                          var bodies$macro$108 = $as_sci_Seq($n(p8$2).Lshapeless_$colon$colon__f_head);
                          var p9$2 = $as_Lshapeless_$colon$colon($n(p8$2).Lshapeless_$colon$colon__f_tail);
                          if ((p9$2 !== null)) {
                            var attachments$macro$109 = $as_sci_Seq($n(p9$2).Lshapeless_$colon$colon__f_head);
                            var p10$2 = $as_Lshapeless_$colon$colon($n(p9$2).Lshapeless_$colon$colon__f_tail);
                            if ((p10$2 !== null)) {
                              var headers$macro$110 = $as_sci_Map($n(p10$2).Lshapeless_$colon$colon__f_head);
                              var p11$2 = $as_Lshapeless_HNil($n(p10$2).Lshapeless_$colon$colon__f_tail);
                              var x$3 = $m_Lshapeless_HNil$();
                              if ((x$3 === p11$2)) {
                                return new $c_Lreactbuild_model_Communication(_id$macro$101, organization$macro$102, persons$macro$103, senderAddress$macro$104, receiverAddress$macro$105, date$macro$106, subject$macro$107, bodies$macro$108, attachments$macro$109, headers$macro$110)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$12)
        }));
        var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys$20 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$267 = $m_s_Symbol$();
        var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$267, "headers"));
        new $c_Lshapeless_Witness$$anon$1(value0$45);
        var zipWithKeys$21 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
        $m_Lshapeless_Witness$();
        var this$270 = $m_s_Symbol$();
        var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$270, "attachments"));
        new $c_Lshapeless_Witness$$anon$1(value0$46);
        var zipWithKeys$22 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
        $m_Lshapeless_Witness$();
        var this$273 = $m_s_Symbol$();
        var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$273, "bodies"));
        new $c_Lshapeless_Witness$$anon$1(value0$47);
        var zipWithKeys$23 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
        $m_Lshapeless_Witness$();
        var this$276 = $m_s_Symbol$();
        var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$276, "subject"));
        new $c_Lshapeless_Witness$$anon$1(value0$48);
        var zipWithKeys$24 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$23);
        $m_Lshapeless_Witness$();
        var this$279 = $m_s_Symbol$();
        var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$279, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$49);
        var zipWithKeys$25 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$24);
        $m_Lshapeless_Witness$();
        var this$282 = $m_s_Symbol$();
        var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$282, "receiverAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$50);
        var zipWithKeys$26 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$25);
        $m_Lshapeless_Witness$();
        var this$285 = $m_s_Symbol$();
        var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$285, "senderAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$51);
        var zipWithKeys$27 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$26);
        $m_Lshapeless_Witness$();
        var this$288 = $m_s_Symbol$();
        var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$288, "persons"));
        new $c_Lshapeless_Witness$$anon$1(value0$52);
        var zipWithKeys$28 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$27);
        $m_Lshapeless_Witness$();
        var this$291 = $m_s_Symbol$();
        var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$291, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$53);
        var zipWithKeys$29 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$28);
        $m_Lshapeless_Witness$();
        var this$294 = $m_s_Symbol$();
        var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$294, "_id"));
        new $c_Lshapeless_Witness$$anon$1(value0$54);
        var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$29);
        var this$297 = $m_s_$less$colon$less$();
        var ev$3 = this$297.s_$less$colon$less$__f_singleton;
        new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$3);
        var this$348 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Communication", "reactbuild.model.RefTo[reactbuild.model.Communication]");
        var this$347 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$299 = $m_s_Symbol$();
        var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$299, "organization"));
        var witness$9 = new $c_Lshapeless_Witness$$anon$1(value0$55);
        var $$x96 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        var this$301 = $m_Lreactbuild_model_Implicits$();
        var format$5 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$301);
        var $$x95 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$5);
        var this$304 = $m_Lreactbuild_model_Implicits$();
        var this$303 = $m_Lreactbuild_model_Implicits$();
        var ev$4 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$303, proxy);
        var $$x94 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$304, ev$4)));
        var $$x93 = new $c_Lcom_iz2use_react_components_NotEditable();
        var this$306 = $m_Lreactbuild_model_Implicits$();
        var textualizable$2 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$306, proxy);
        var columnRenderable$4 = $n($$x96).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x95, $$x94, $$x93, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$2));
        var this$346 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Communication", "Seq[reactbuild.model.CommunicationPerson]");
        var this$345 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$308 = $m_s_Symbol$();
        var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$308, "senderAddress"));
        var witness$8 = new $c_Lshapeless_Witness$$anon$1(value0$56);
        var $$x100 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        var format$6 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var $$x99 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$6);
        var $$x98 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
        $m_Lcom_iz2use_common_Parsable$();
        var evDefault$3 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
        var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
        var parser$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var resolver$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
        var $$x97 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$3, resolver$3);
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var columnRenderable$3 = $n($$x100).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x99, $$x98, $$x97, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$7));
        var this$344 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$316 = $m_s_Symbol$();
        var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$316, "receiverAddress"));
        var witness$7 = new $c_Lshapeless_Witness$$anon$1(value0$57);
        var $$x104 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        var format$7 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var $$x103 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$7);
        var $$x102 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
        $m_Lcom_iz2use_common_Parsable$();
        var evDefault$4 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
        var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$4);
        var parser$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var resolver$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
        var $$x101 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$4, resolver$4);
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var columnRenderable$2 = $n($$x104).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x103, $$x102, $$x101, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$9));
        var this$343 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$324 = $m_s_Symbol$();
        var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$324, "date"));
        var witness$6 = new $c_Lshapeless_Witness$$anon$1(value0$58);
        var $$x108 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        var format$8 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
        var $$x107 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$8);
        var $$x106 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering));
        var $$x105 = new $c_Lcom_iz2use_react_components_NotEditable();
        var this$328 = $m_Lreactbuild_model_Implicits$();
        var locale$1 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
        var textualizable$3 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$328, locale$1);
        var columnRenderable$1 = $n($$x108).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x107, $$x106, $$x105, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$3));
        var this$342 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        $m_Lshapeless_Witness$();
        var this$330 = $m_s_Symbol$();
        var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$330, "subject"));
        var witness$5 = new $c_Lshapeless_Witness$$anon$1(value0$59);
        var $$x112 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
        var format$9 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var $$x111 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$9);
        var $$x110 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
        $m_Lcom_iz2use_common_Parsable$();
        var evDefault$5 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
        var optioner$5 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$5);
        var parser$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var resolver$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
        var $$x109 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$5, resolver$5);
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$11 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var columnRenderable = $n($$x112).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x111, $$x110, $$x109, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$11));
        var this$341 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Communication", "Seq[reactbuild.model.CommunicationBody]");
        var this$340 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Communication", "Seq[reactbuild.model.CommunicationAttachment]");
        var this$339 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
        new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.Communication", "Map[String,Seq[String]]");
        var tail$10 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
        var tail$11 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$339, tail$10);
        var tail$12 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$340, tail$11);
        var tail$13 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$341, tail$12);
        var tail$14 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$342, columnRenderable, witness$5, tail$13);
        var tail$15 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$343, columnRenderable$1, witness$6, tail$14);
        var tail$16 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$344, columnRenderable$2, witness$7, tail$15);
        var tail$17 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$345, columnRenderable$3, witness$8, tail$16);
        var tail$18 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$346, tail$17);
        var tail$19 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$347, columnRenderable$4, witness$9, tail$18);
        var renderer$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$348, tail$19);
        $m_s_DummyImplicit$();
        new $c_Lshapeless_Refute$$anon$2();
        var columnFragment = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$1);
        var view = new $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment);
        var tail$20 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2();
        var tail$21 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view, tail$20);
        var tail$22 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$354, tail$21);
        var tail$23 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$355, tail$22);
        var tail$24 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$1, tail$23);
        var tail$25 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$357, tail$24);
        var tail$26 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$358, tail$25);
        var tail$27 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$359, tail$26);
        var mat = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$360, tail$27);
        $m_s_DummyImplicit$();
        new $c_Lshapeless_Refute$$anon$2();
        var $$x113 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViews(mat.apply__sci_List());
        var $$x54 = $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$().Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable;
        var this$363 = $m_s_Symbol$();
        var $$x32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$363, "_id"));
        var this$364 = $m_s_Symbol$();
        var $$x31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$364, "organization"));
        var this$365 = $m_s_Symbol$();
        var $$x30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$365, "persons"));
        var this$366 = $m_s_Symbol$();
        var $$x29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$366, "senderAddress"));
        var this$367 = $m_s_Symbol$();
        var $$x28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$367, "receiverAddress"));
        var this$368 = $m_s_Symbol$();
        var $$x27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$368, "date"));
        var this$369 = $m_s_Symbol$();
        var $$x26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$369, "subject"));
        var this$370 = $m_s_Symbol$();
        var $$x25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$370, "bodies"));
        var this$371 = $m_s_Symbol$();
        var $$x24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$371, "attachments"));
        var this$372 = $m_s_Symbol$();
        var labels$3 = new $c_Lshapeless_$colon$colon($$x32, new $c_Lshapeless_$colon$colon($$x31, new $c_Lshapeless_$colon$colon($$x30, new $c_Lshapeless_$colon$colon($$x29, new $c_Lshapeless_$colon$colon($$x28, new $c_Lshapeless_$colon$colon($$x27, new $c_Lshapeless_$colon$colon($$x26, new $c_Lshapeless_$colon$colon($$x25, new $c_Lshapeless_$colon$colon($$x24, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$372, "headers")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
        var f$3 = new $c_sjsr_AnonFunction1(((x0$15$2) => {
          var x0$15 = $as_Lreactbuild_model_Communication(x0$15$2);
          if ((x0$15 !== null)) {
            var _id$macro$151 = $n(x0$15).Lreactbuild_model_Communication__f__id;
            var organization$macro$152 = $n(x0$15).Lreactbuild_model_Communication__f_organization;
            var persons$macro$153 = $n(x0$15).Lreactbuild_model_Communication__f_persons;
            var senderAddress$macro$154 = $n(x0$15).Lreactbuild_model_Communication__f_senderAddress;
            var receiverAddress$macro$155 = $n(x0$15).Lreactbuild_model_Communication__f_receiverAddress;
            var date$macro$156 = $n(x0$15).Lreactbuild_model_Communication__f_date;
            var subject$macro$157 = $n(x0$15).Lreactbuild_model_Communication__f_subject;
            var bodies$macro$158 = $n(x0$15).Lreactbuild_model_Communication__f_bodies;
            var attachments$macro$159 = $n(x0$15).Lreactbuild_model_Communication__f_attachments;
            var headers$macro$160 = $n(x0$15).Lreactbuild_model_Communication__f_headers;
            return new $c_Lshapeless_$colon$colon(_id$macro$151, new $c_Lshapeless_$colon$colon(organization$macro$152, new $c_Lshapeless_$colon$colon(persons$macro$153, new $c_Lshapeless_$colon$colon(senderAddress$macro$154, new $c_Lshapeless_$colon$colon(receiverAddress$macro$155, new $c_Lshapeless_$colon$colon(date$macro$156, new $c_Lshapeless_$colon$colon(subject$macro$157, new $c_Lshapeless_$colon$colon(bodies$macro$158, new $c_Lshapeless_$colon$colon(attachments$macro$159, new $c_Lshapeless_$colon$colon(headers$macro$160, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$15)
          }
        }));
        var g$3 = new $c_sjsr_AnonFunction1(((x0$16$2) => {
          var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
          if ((x0$16 !== null)) {
            var _id$macro$141 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
            var p2$3 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
            if ((p2$3 !== null)) {
              var organization$macro$142 = $as_Lreactbuild_common_model_RefTo($n(p2$3).Lshapeless_$colon$colon__f_head);
              var p3$3 = $as_Lshapeless_$colon$colon($n(p2$3).Lshapeless_$colon$colon__f_tail);
              if ((p3$3 !== null)) {
                var persons$macro$143 = $as_sci_Seq($n(p3$3).Lshapeless_$colon$colon__f_head);
                var p4$3 = $as_Lshapeless_$colon$colon($n(p3$3).Lshapeless_$colon$colon__f_tail);
                if ((p4$3 !== null)) {
                  var senderAddress$macro$144 = $as_T($n(p4$3).Lshapeless_$colon$colon__f_head);
                  var p5$3 = $as_Lshapeless_$colon$colon($n(p4$3).Lshapeless_$colon$colon__f_tail);
                  if ((p5$3 !== null)) {
                    var receiverAddress$macro$145 = $as_T($n(p5$3).Lshapeless_$colon$colon__f_head);
                    var p6$3 = $as_Lshapeless_$colon$colon($n(p5$3).Lshapeless_$colon$colon__f_tail);
                    if ((p6$3 !== null)) {
                      var date$macro$146 = $as_Ljava_time_Instant($n(p6$3).Lshapeless_$colon$colon__f_head);
                      var p7$3 = $as_Lshapeless_$colon$colon($n(p6$3).Lshapeless_$colon$colon__f_tail);
                      if ((p7$3 !== null)) {
                        var subject$macro$147 = $as_T($n(p7$3).Lshapeless_$colon$colon__f_head);
                        var p8$3 = $as_Lshapeless_$colon$colon($n(p7$3).Lshapeless_$colon$colon__f_tail);
                        if ((p8$3 !== null)) {
                          var bodies$macro$148 = $as_sci_Seq($n(p8$3).Lshapeless_$colon$colon__f_head);
                          var p9$3 = $as_Lshapeless_$colon$colon($n(p8$3).Lshapeless_$colon$colon__f_tail);
                          if ((p9$3 !== null)) {
                            var attachments$macro$149 = $as_sci_Seq($n(p9$3).Lshapeless_$colon$colon__f_head);
                            var p10$3 = $as_Lshapeless_$colon$colon($n(p9$3).Lshapeless_$colon$colon__f_tail);
                            if ((p10$3 !== null)) {
                              var headers$macro$150 = $as_sci_Map($n(p10$3).Lshapeless_$colon$colon__f_head);
                              var p11$3 = $as_Lshapeless_HNil($n(p10$3).Lshapeless_$colon$colon__f_tail);
                              var x$4 = $m_Lshapeless_HNil$();
                              if ((x$4 === p11$3)) {
                                return new $c_Lreactbuild_model_Communication(_id$macro$141, organization$macro$142, persons$macro$143, senderAddress$macro$144, receiverAddress$macro$145, date$macro$146, subject$macro$147, bodies$macro$148, attachments$macro$149, headers$macro$150)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$16)
        }));
        var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys$30 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$375 = $m_s_Symbol$();
        var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$375, "headers"));
        new $c_Lshapeless_Witness$$anon$1(value0$60);
        var zipWithKeys$31 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$30);
        $m_Lshapeless_Witness$();
        var this$378 = $m_s_Symbol$();
        var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$378, "attachments"));
        new $c_Lshapeless_Witness$$anon$1(value0$61);
        var zipWithKeys$32 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$31);
        $m_Lshapeless_Witness$();
        var this$381 = $m_s_Symbol$();
        var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$381, "bodies"));
        new $c_Lshapeless_Witness$$anon$1(value0$62);
        var zipWithKeys$33 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$32);
        $m_Lshapeless_Witness$();
        var this$384 = $m_s_Symbol$();
        var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$384, "subject"));
        new $c_Lshapeless_Witness$$anon$1(value0$63);
        var zipWithKeys$34 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$33);
        $m_Lshapeless_Witness$();
        var this$387 = $m_s_Symbol$();
        var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$387, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$64);
        var zipWithKeys$35 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$34);
        $m_Lshapeless_Witness$();
        var this$390 = $m_s_Symbol$();
        var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$390, "receiverAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$65);
        var zipWithKeys$36 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$35);
        $m_Lshapeless_Witness$();
        var this$393 = $m_s_Symbol$();
        var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$393, "senderAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$66);
        var zipWithKeys$37 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$36);
        $m_Lshapeless_Witness$();
        var this$396 = $m_s_Symbol$();
        var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$396, "persons"));
        new $c_Lshapeless_Witness$$anon$1(value0$67);
        var zipWithKeys$38 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$37);
        $m_Lshapeless_Witness$();
        var this$399 = $m_s_Symbol$();
        var value0$68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$399, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$68);
        var zipWithKeys$39 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$38);
        $m_Lshapeless_Witness$();
        var this$402 = $m_s_Symbol$();
        var value0$69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$402, "_id"));
        new $c_Lshapeless_Witness$$anon$1(value0$69);
        var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$39);
        var this$405 = $m_s_$less$colon$less$();
        var ev$5 = this$405.s_$less$colon$less$__f_singleton;
        new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$5);
        var this$456 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
        $m_Lshapeless_Witness$();
        var this$407 = $m_s_Symbol$();
        var value0$70 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$407, "organization"));
        var witness$14 = new $c_Lshapeless_Witness$$anon$1(value0$70);
        var $$x36 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var this$409 = $m_Lreactbuild_model_Implicits$();
        var format$10 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$409);
        var $$x35 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$10);
        var this$412 = $m_Lreactbuild_model_Implicits$();
        var this$411 = $m_Lreactbuild_model_Implicits$();
        var ev$6 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$411, proxy);
        var $$x34 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$412, ev$6)));
        var $$x33 = new $c_Lcom_iz2use_react_components_NotEditable();
        var this$414 = $m_Lreactbuild_model_Implicits$();
        var textualizable$4 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$414, proxy);
        var fieldRenderable$9 = $n($$x36).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x35, $$x34, $$x33, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$4), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        var this$454 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
        $m_Lshapeless_Witness$();
        var this$416 = $m_s_Symbol$();
        var value0$71 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$416, "senderAddress"));
        var witness$13 = new $c_Lshapeless_Witness$$anon$1(value0$71);
        var $$x40 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var format$11 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var $$x39 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$11);
        var $$x38 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
        $m_Lcom_iz2use_common_Parsable$();
        var evDefault$6 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
        var optioner$6 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$6);
        var parser$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var resolver$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
        var $$x37 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$6, resolver$6);
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$13 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var fieldRenderable$8 = $n($$x40).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x39, $$x38, $$x37, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$13), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
        $m_Lshapeless_Witness$();
        var this$424 = $m_s_Symbol$();
        var value0$72 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$424, "receiverAddress"));
        var witness$12 = new $c_Lshapeless_Witness$$anon$1(value0$72);
        var $$x44 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var format$12 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var $$x43 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$12);
        var $$x42 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
        $m_Lcom_iz2use_common_Parsable$();
        var evDefault$7 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
        var optioner$7 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$7);
        var parser$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var resolver$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
        var $$x41 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$7, resolver$7);
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var fieldRenderable$7 = $n($$x44).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x43, $$x42, $$x41, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$15), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
        $m_Lshapeless_Witness$();
        var this$432 = $m_s_Symbol$();
        var value0$73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$432, "date"));
        var witness$11 = new $c_Lshapeless_Witness$$anon$1(value0$73);
        var $$x48 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var format$13 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
        var $$x47 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$13);
        var $$x46 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering));
        var $$x45 = new $c_Lcom_iz2use_react_components_NotEditable();
        var this$436 = $m_Lreactbuild_model_Implicits$();
        var locale$2 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
        var textualizable$5 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$436, locale$2);
        var fieldRenderable$6 = $n($$x48).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x47, $$x46, $$x45, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$5), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
        $m_Lshapeless_Witness$();
        var this$438 = $m_s_Symbol$();
        var value0$74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$438, "subject"));
        var witness$10 = new $c_Lshapeless_Witness$$anon$1(value0$74);
        var $$x52 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
        var format$14 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
        var $$x51 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$14);
        var $$x50 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$String$()));
        $m_Lcom_iz2use_common_Parsable$();
        var evDefault$8 = $m_Lcom_iz2use_react_components_internal_Default$StringDefault$();
        var optioner$8 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$8);
        var parser$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var resolver$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$8);
        var $$x49 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$8, resolver$8);
        $m_Lcom_iz2use_common_Textualizable$();
        var parsable$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
        var fieldRenderable$5 = $n($$x52).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x51, $$x50, $$x49, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$17), new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString)));
        var this$449 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
        var this$448 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
        var this$447 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
        var tail$28 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3();
        var tail$29 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$447, tail$28);
        var tail$30 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$448, tail$29);
        var tail$31 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$449, tail$30);
        var tail$32 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$5, witness$10, tail$31);
        var tail$33 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$6, witness$11, tail$32);
        var tail$34 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$7, witness$12, tail$33);
        var tail$35 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$8, witness$13, tail$34);
        var tail$36 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$454, tail$35);
        var tail$37 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$9, witness$14, tail$36);
        var renderer$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$456, tail$37);
        var $$x53 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$2);
        var $$x23 = $m_Lreactbuild_model_Communication$().Lreactbuild_model_Communication$__f_keyMapper;
        var $$x22 = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
        var $$x21 = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
        var this$458 = $m_s_Symbol$();
        var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$458, "_id"));
        var this$459 = $m_s_Symbol$();
        var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$459, "organization"));
        var this$460 = $m_s_Symbol$();
        var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$460, "persons"));
        var this$461 = $m_s_Symbol$();
        var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$461, "senderAddress"));
        var this$462 = $m_s_Symbol$();
        var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$462, "receiverAddress"));
        var this$463 = $m_s_Symbol$();
        var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$463, "date"));
        var this$464 = $m_s_Symbol$();
        var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$464, "subject"));
        var this$465 = $m_s_Symbol$();
        var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$465, "bodies"));
        var this$466 = $m_s_Symbol$();
        var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$466, "attachments"));
        var this$467 = $m_s_Symbol$();
        var labels$4 = new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$467, "headers")), $m_Lshapeless_HNil$()))))))))));
        new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$4);
        var f$4 = new $c_sjsr_AnonFunction1(((x0$19$2) => {
          var x0$19 = $as_Lreactbuild_model_Communication(x0$19$2);
          if ((x0$19 !== null)) {
            var _id$macro$191 = $n(x0$19).Lreactbuild_model_Communication__f__id;
            var organization$macro$192 = $n(x0$19).Lreactbuild_model_Communication__f_organization;
            var persons$macro$193 = $n(x0$19).Lreactbuild_model_Communication__f_persons;
            var senderAddress$macro$194 = $n(x0$19).Lreactbuild_model_Communication__f_senderAddress;
            var receiverAddress$macro$195 = $n(x0$19).Lreactbuild_model_Communication__f_receiverAddress;
            var date$macro$196 = $n(x0$19).Lreactbuild_model_Communication__f_date;
            var subject$macro$197 = $n(x0$19).Lreactbuild_model_Communication__f_subject;
            var bodies$macro$198 = $n(x0$19).Lreactbuild_model_Communication__f_bodies;
            var attachments$macro$199 = $n(x0$19).Lreactbuild_model_Communication__f_attachments;
            var headers$macro$200 = $n(x0$19).Lreactbuild_model_Communication__f_headers;
            return new $c_Lshapeless_$colon$colon(_id$macro$191, new $c_Lshapeless_$colon$colon(organization$macro$192, new $c_Lshapeless_$colon$colon(persons$macro$193, new $c_Lshapeless_$colon$colon(senderAddress$macro$194, new $c_Lshapeless_$colon$colon(receiverAddress$macro$195, new $c_Lshapeless_$colon$colon(date$macro$196, new $c_Lshapeless_$colon$colon(subject$macro$197, new $c_Lshapeless_$colon$colon(bodies$macro$198, new $c_Lshapeless_$colon$colon(attachments$macro$199, new $c_Lshapeless_$colon$colon(headers$macro$200, $m_Lshapeless_HNil$()))))))))))
          } else {
            throw new $c_s_MatchError(x0$19)
          }
        }));
        var g$4 = new $c_sjsr_AnonFunction1(((x0$20$2) => {
          var x0$20 = $as_Lshapeless_$colon$colon(x0$20$2);
          if ((x0$20 !== null)) {
            var _id$macro$181 = $as_Lreactbuild_common_model_RefTo($n(x0$20).Lshapeless_$colon$colon__f_head);
            var p2$4 = $as_Lshapeless_$colon$colon($n(x0$20).Lshapeless_$colon$colon__f_tail);
            if ((p2$4 !== null)) {
              var organization$macro$182 = $as_Lreactbuild_common_model_RefTo($n(p2$4).Lshapeless_$colon$colon__f_head);
              var p3$4 = $as_Lshapeless_$colon$colon($n(p2$4).Lshapeless_$colon$colon__f_tail);
              if ((p3$4 !== null)) {
                var persons$macro$183 = $as_sci_Seq($n(p3$4).Lshapeless_$colon$colon__f_head);
                var p4$4 = $as_Lshapeless_$colon$colon($n(p3$4).Lshapeless_$colon$colon__f_tail);
                if ((p4$4 !== null)) {
                  var senderAddress$macro$184 = $as_T($n(p4$4).Lshapeless_$colon$colon__f_head);
                  var p5$4 = $as_Lshapeless_$colon$colon($n(p4$4).Lshapeless_$colon$colon__f_tail);
                  if ((p5$4 !== null)) {
                    var receiverAddress$macro$185 = $as_T($n(p5$4).Lshapeless_$colon$colon__f_head);
                    var p6$4 = $as_Lshapeless_$colon$colon($n(p5$4).Lshapeless_$colon$colon__f_tail);
                    if ((p6$4 !== null)) {
                      var date$macro$186 = $as_Ljava_time_Instant($n(p6$4).Lshapeless_$colon$colon__f_head);
                      var p7$4 = $as_Lshapeless_$colon$colon($n(p6$4).Lshapeless_$colon$colon__f_tail);
                      if ((p7$4 !== null)) {
                        var subject$macro$187 = $as_T($n(p7$4).Lshapeless_$colon$colon__f_head);
                        var p8$4 = $as_Lshapeless_$colon$colon($n(p7$4).Lshapeless_$colon$colon__f_tail);
                        if ((p8$4 !== null)) {
                          var bodies$macro$188 = $as_sci_Seq($n(p8$4).Lshapeless_$colon$colon__f_head);
                          var p9$4 = $as_Lshapeless_$colon$colon($n(p8$4).Lshapeless_$colon$colon__f_tail);
                          if ((p9$4 !== null)) {
                            var attachments$macro$189 = $as_sci_Seq($n(p9$4).Lshapeless_$colon$colon__f_head);
                            var p10$4 = $as_Lshapeless_$colon$colon($n(p9$4).Lshapeless_$colon$colon__f_tail);
                            if ((p10$4 !== null)) {
                              var headers$macro$190 = $as_sci_Map($n(p10$4).Lshapeless_$colon$colon__f_head);
                              var p11$4 = $as_Lshapeless_HNil($n(p10$4).Lshapeless_$colon$colon__f_tail);
                              var x$5 = $m_Lshapeless_HNil$();
                              if ((x$5 === p11$4)) {
                                return new $c_Lreactbuild_model_Communication(_id$macro$181, organization$macro$182, persons$macro$183, senderAddress$macro$184, receiverAddress$macro$185, date$macro$186, subject$macro$187, bodies$macro$188, attachments$macro$189, headers$macro$190)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          };
          throw new $c_s_MatchError(x0$20)
        }));
        var gen$8 = new $c_Lshapeless_Generic$$anon$1(f$4, g$4);
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        $m_Lshapeless_ops_hlist$ZipWithKeys$();
        var zipWithKeys$40 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
        $m_Lshapeless_Witness$();
        var this$470 = $m_s_Symbol$();
        var value0$75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$470, "headers"));
        new $c_Lshapeless_Witness$$anon$1(value0$75);
        var zipWithKeys$41 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$40);
        $m_Lshapeless_Witness$();
        var this$473 = $m_s_Symbol$();
        var value0$76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$473, "attachments"));
        new $c_Lshapeless_Witness$$anon$1(value0$76);
        var zipWithKeys$42 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$41);
        $m_Lshapeless_Witness$();
        var this$476 = $m_s_Symbol$();
        var value0$77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$476, "bodies"));
        new $c_Lshapeless_Witness$$anon$1(value0$77);
        var zipWithKeys$43 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$42);
        $m_Lshapeless_Witness$();
        var this$479 = $m_s_Symbol$();
        var value0$78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$479, "subject"));
        new $c_Lshapeless_Witness$$anon$1(value0$78);
        var zipWithKeys$44 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$43);
        $m_Lshapeless_Witness$();
        var this$482 = $m_s_Symbol$();
        var value0$79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$482, "date"));
        new $c_Lshapeless_Witness$$anon$1(value0$79);
        var zipWithKeys$45 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$44);
        $m_Lshapeless_Witness$();
        var this$485 = $m_s_Symbol$();
        var value0$80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$485, "receiverAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$80);
        var zipWithKeys$46 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$45);
        $m_Lshapeless_Witness$();
        var this$488 = $m_s_Symbol$();
        var value0$81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$488, "senderAddress"));
        new $c_Lshapeless_Witness$$anon$1(value0$81);
        var zipWithKeys$47 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$46);
        $m_Lshapeless_Witness$();
        var this$491 = $m_s_Symbol$();
        var value0$82 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$491, "persons"));
        new $c_Lshapeless_Witness$$anon$1(value0$82);
        var zipWithKeys$48 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$47);
        $m_Lshapeless_Witness$();
        var this$494 = $m_s_Symbol$();
        var value0$83 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$494, "organization"));
        new $c_Lshapeless_Witness$$anon$1(value0$83);
        var zipWithKeys$49 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$48);
        $m_Lshapeless_Witness$();
        var this$497 = $m_s_Symbol$();
        var value0$84 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$497, "_id"));
        new $c_Lshapeless_Witness$$anon$1(value0$84);
        var zip$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$49);
        var this$500 = $m_s_$less$colon$less$();
        var ev$7 = this$500.s_$less$colon$less$__f_singleton;
        var gen$9 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$4, gen$8, ev$7);
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$502 = $m_s_Symbol$();
        var value0$85 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$502, "_id"));
        var witness$24 = new $c_Lshapeless_Witness$$anon$1(value0$85);
        var ht$9 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$504 = $m_s_Symbol$();
        var value0$86 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$504, "organization"));
        var witness$23 = new $c_Lshapeless_Witness$$anon$1(value0$86);
        var this$507 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        var this$506 = $m_Lreactbuild_model_Implicits$();
        var textualizable$6 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$506, proxy);
        var ev$8 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$8 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$507, textualizable$6, ev$8)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$508 = $m_s_Symbol$();
        var value0$87 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$508, "persons"));
        var witness$22 = new $c_Lshapeless_Witness$$anon$1(value0$87);
        var ht$7 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$510 = $m_s_Symbol$();
        var value0$88 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$510, "senderAddress"));
        var witness$21 = new $c_Lshapeless_Witness$$anon$1(value0$88);
        var ht$6 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$()));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$512 = $m_s_Symbol$();
        var value0$89 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$512, "receiverAddress"));
        var witness$20 = new $c_Lshapeless_Witness$$anon$1(value0$89);
        var ht$5 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$()));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$514 = $m_s_Symbol$();
        var value0$90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$514, "date"));
        var witness$19 = new $c_Lshapeless_Witness$$anon$1(value0$90);
        var this$517 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
        var this$516 = $m_Lreactbuild_model_Implicits$();
        var locale$3 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
        var textualizable$7 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$516, locale$3);
        var ev$9 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
        var ht$4 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$517, textualizable$7, ev$9)));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$518 = $m_s_Symbol$();
        var value0$91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$518, "subject"));
        var witness$18 = new $c_Lshapeless_Witness$$anon$1(value0$91);
        var ht$3 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$()));
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$520 = $m_s_Symbol$();
        var value0$92 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$520, "bodies"));
        var witness$17 = new $c_Lshapeless_Witness$$anon$1(value0$92);
        var ht$2 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$522 = $m_s_Symbol$();
        var value0$93 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$522, "attachments"));
        var witness$16 = new $c_Lshapeless_Witness$$anon$1(value0$93);
        var ht$1 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
        $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
        $m_Lshapeless_Witness$();
        var this$524 = $m_s_Symbol$();
        var value0$94 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$524, "headers"));
        var witness$15 = new $c_Lshapeless_Witness$$anon$1(value0$94);
        var ht = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
        var tt = $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$().Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil;
        var tt$1 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt, ht, witness$15);
        var tt$2 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$16);
        var tt$3 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$2, ht$2, witness$17);
        var tt$4 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$3, ht$3, witness$18);
        var tt$5 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$4, ht$4, witness$19);
        var tt$6 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$5, ht$5, witness$20);
        var tt$7 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$6, ht$6, witness$21);
        var tt$8 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$7, ht$7, witness$22);
        var tt$9 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$8, ht$8, witness$23);
        var tokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$9, ht$9, witness$24);
        var $$x20 = new $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer, gen$9);
        var $$x10 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
        var $$x9 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
        var $$x8 = new $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1();
        var $$x7 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
        var $$x6 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
        $m_Lreactbuild_model_Implicits$();
        var this$539 = $m_Ljapgolly_scalajs_react_Reusability$();
        var u = $n($$x126).noExternalStateNorActive__O__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(r$2$1, $$x125, $$x124, $$x113, $$x54, $$x53, $$x23, $$x22, $$x21, $$x20, $$x10, $$x9, $$x8, $$x7, $$x6, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$539.byRef__F2(), this$539.by_$eq$eq__F2()), new $c_sjsr_AnonFunction1(((evT$2) => {
          var evT = $n($as_Ljapgolly_scalajs_react_Reusability(evT$2)).Ljapgolly_scalajs_react_Reusability__f_test;
          return new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityMultiviewItemColl__F2__F2(evT))
        })), $m_Lcom_iz2use_react_components_internal_multiview_View$().defaultViewOrdering__s_math_Ordering());
        var this$541 = $n(u);
        var n = this$541.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
        return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
      } else if ($n(r).isPending__Z()) {
        return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
      } else {
        var $$x127 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        var array$3 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
        return $n($$x127).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
      }
    }
  }));
  var $$x2 = $m_Lreactbuild_model_Implicits$().reusabilityRefTo__F2();
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Lreactbuild_model_Implicits$();
  var this$551 = $m_Ljapgolly_scalajs_react_Reusability$();
  var rassoc$2 = $n($$x133).query__O__F1__F1__F2__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x132, $$x128, $$x3, $$x2, $n($$x1).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$551.byRef__F2(), this$551.by_$eq$eq__F2())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
  var this$555 = $n($m_s_package$().s_package$__f_Nil);
  var this$553 = $n(rassoc$2);
  var n$1 = this$553.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var elem = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
  return new $c_sci_$colon$colon(elem, this$555)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_title
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.productPrefix__T = (function() {
  return "CommunicationList"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_communication : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if (((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList) && ($n($as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList(x$1)).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_$outer === this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_$outer))) {
    var CommunicationList$1 = $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList(x$1);
    var x = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_communication;
    var x$2 = $n(CommunicationList$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList__f_communication;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(CommunicationList$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  return this.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq(router, proxy, $as_Lreactbuild_person_Person(current), setDetailState)
});
function $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$CommunicationList"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.PersonDetailViewHandler$CommunicationList;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$CommunicationList", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$CommunicationList;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(outer, allGroup) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_allGroup = false;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_title = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_$outer = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_allGroup = allGroup;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_$outer = outer
  };
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_title = "Lignes des documents"
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.handleClose__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq = (function(router, proxy, person, setDetailState) {
  var rassoc$1 = $m_Lreactbuild_analyze_cost_components_PeriodProvider$().apply__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((period$2) => {
    var period = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(period$2);
    var this$875 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x172 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$4 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
    var $$x171 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s);
    var c = $m_Lcom_iz2use_react_components_Layout$().Lcom_iz2use_react_components_Layout$__f_horizontal;
    var this$17 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Voir sur l'ensemble du groupe (le cas \u00e9ch\u00e9ant)");
    var $$x168 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_allGroup;
    var state = $n($$x168).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x169;
        var p2 = $as_s_Option(x1.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x = $m_s_None$();
        if ((x === p2)) {
          var $$x169 = cb;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1.T2__f__1);
        var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v = $uZ($n(x5).s_Some__f_value);
          var $$x169 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(setDetailState).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_$outer, v)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2);
          break matchEnd7
        };
        throw new $c_s_MatchError(x1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x169)
    })));
    var evDefault = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
    var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv = $m_s_math_Equiv$Boolean$();
    var this$13 = $n(editorComponent);
    var array = [this$13.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv)];
    var children = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var u = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$17.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$17.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children));
    var this$19 = $n(u);
    var n = this$19.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x170 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var u$1 = $m_Lreactbuild_analyze_cost_components_PeriodSelector$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(period);
    var this$22 = $n(u$1);
    var n$1 = this$22.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$1 = [$$x171, $$x170, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
    var $$x167 = $n($$x172).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x166 = $m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment;
    var a = ((("" + this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_allGroup) + $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from) + $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_to);
    var $$x165 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
    var $$x158 = new $c_sjsr_AnonFunction0((() => {
      var this$30 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x164 = new $c_Lautowire_ClientProxy(this$30).Lautowire_ClientProxy__f_self;
      var $$x163 = $m_s_package$().s_package$__f_Seq;
      var array$2 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listAllInvoiceDetails"];
      var $$x162 = $as_sci_Seq($n($$x163).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
      var this$55 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$35 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$36 = $n(new $c_Lautowire_ClientProxy(this$35).Lautowire_ClientProxy__f_self);
      var r = $n(person).Lreactbuild_person_Person__f__id;
      var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y = this$36.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
      var $$x161 = $ct_T2__O__O__(new $c_T2(), "supplier", y);
      var this$39 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$40 = $n(new $c_Lautowire_ClientProxy(this$39).Lautowire_ClientProxy__f_self);
      var r$1 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_allGroup;
      var evidence$2$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
      var y$1 = this$40.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
      var $$x160 = $ct_T2__O__O__(new $c_T2(), "allInSameGroup", y$1);
      var this$43 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$45 = $n(new $c_Lautowire_ClientProxy(this$43).Lautowire_ClientProxy__f_self);
      var r$2 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from;
      $m_Lio_circe_Encoder$();
      var e = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
      var evidence$2$2 = new $c_Lio_circe_Encoder$$anon$21(e);
      var y$2 = this$45.write__O__Lio_circe_Encoder__Lio_circe_Json(r$2, evidence$2$2);
      var $$x159 = $ct_T2__O__O__(new $c_T2(), "from", y$2);
      var this$48 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$50 = $n(new $c_Lautowire_ClientProxy(this$48).Lautowire_ClientProxy__f_self);
      var r$3 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_to;
      $m_Lio_circe_Encoder$();
      var e$1 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
      var evidence$2$3 = new $c_Lio_circe_Encoder$$anon$21(e$1);
      var y$3 = this$50.write__O__Lio_circe_Encoder__Lio_circe_Json(r$3, evidence$2$3);
      var array$3 = [$$x161, $$x160, $$x159, $ct_T2__O__O__(new $c_T2(), "to", y$3)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
      return $n($n($n($$x164).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x162, this$55.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$56 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$58 = $n(new $c_Lautowire_ClientProxy(this$56).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lreactbuild_model_ChildWithParent$().decodeChildWithParent__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_model_InvoiceDetail$().Lreactbuild_model_InvoiceDetail$__f_codecForInvoiceDetail, $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage);
        var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
        return $as_sci_List(this$58.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$6$2) => {
        var x$6 = $as_sci_List(x$6$2);
        return $n(x$6).reverse__sci_List()
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var $$x2 = new $c_sjsr_AnonFunction1(((r$2$1) => {
      var r$4 = $as_Ldiode_data_Pot(r$2$1);
      var $$x157 = $m_Lcom_iz2use_react_components_Multiview$();
      var $$x156 = new $c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler();
      var this$60 = $m_s_Symbol$();
      var $$x154 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$60, "child"));
      var this$61 = $m_s_Symbol$();
      var labels = new $c_Lshapeless_$colon$colon($$x154, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$61, "parent")), $m_Lshapeless_HNil$()));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
      var f = new $c_sjsr_AnonFunction1(((x0$4$2) => {
        var x0$4 = $as_Lreactbuild_model_ChildWithParent(x0$4$2);
        if ((x0$4 !== null)) {
          var child$macro$7 = $as_Lreactbuild_model_InvoiceDetail($n(x0$4).Lreactbuild_model_ChildWithParent__f_child);
          var parent$macro$8 = $as_Lreactbuild_model_InvoicePage($n(x0$4).Lreactbuild_model_ChildWithParent__f_parent);
          return new $c_Lshapeless_$colon$colon(child$macro$7, new $c_Lshapeless_$colon$colon(parent$macro$8, $m_Lshapeless_HNil$()))
        } else {
          throw new $c_s_MatchError(x0$4)
        }
      }));
      var g = new $c_sjsr_AnonFunction1(((x0$5$2) => {
        var x0$5 = $as_Lshapeless_$colon$colon(x0$5$2);
        if ((x0$5 !== null)) {
          var child$macro$5 = $as_Lreactbuild_model_InvoiceDetail($n(x0$5).Lshapeless_$colon$colon__f_head);
          var p2$1 = $as_Lshapeless_$colon$colon($n(x0$5).Lshapeless_$colon$colon__f_tail);
          if ((p2$1 !== null)) {
            var parent$macro$6 = $as_Lreactbuild_model_InvoicePage($n(p2$1).Lshapeless_$colon$colon__f_head);
            var p3 = $as_Lshapeless_HNil($n(p2$1).Lshapeless_$colon$colon__f_tail);
            var x$2 = $m_Lshapeless_HNil$();
            if ((x$2 === p3)) {
              return new $c_Lreactbuild_model_ChildWithParent(child$macro$5, parent$macro$6)
            }
          }
        };
        throw new $c_s_MatchError(x0$5)
      }));
      var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$64 = $m_s_Symbol$();
      var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$64, "parent"));
      new $c_Lshapeless_Witness$$anon$1(value0);
      var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
      $m_Lshapeless_Witness$();
      var this$67 = $m_s_Symbol$();
      var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$67, "child"));
      new $c_Lshapeless_Witness$$anon$1(value0$1);
      var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
      var this$70 = $m_s_$less$colon$less$();
      var ev$3 = this$70.s_$less$colon$less$__f_singleton;
      var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev$3);
      $m_Lshapeless_Witness$();
      var this$72 = $m_s_Symbol$();
      var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$72, "parent"));
      var wk = new $c_Lshapeless_Witness$$anon$1(value0$2);
      var tailToMap = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk);
      var keyLub = new $c_Lshapeless_Lub$$anon$4();
      var valueLub = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$77 = $m_s_Symbol$();
      var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$77, "child"));
      var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$3);
      var toMap = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap, keyLub, valueLub, wk$1);
      $m_Lshapeless_Witness$();
      var this$80 = $m_s_Symbol$();
      var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$80, "child"));
      var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$4);
      var tv$1 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_InvoiceDetail.getClassOf(), new $c_sjsr_AnonFunction0((() => "InvoiceDetail")));
      $m_Lshapeless_Witness$();
      var this$82 = $m_s_Symbol$();
      var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$82, "parent"));
      var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$5);
      var tv = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_InvoicePage.getClassOf(), new $c_sjsr_AnonFunction0((() => "InvoicePage")));
      var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
      var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$2, tv, fmt);
      var fromMap = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$3, tv$1, fmt$1);
      var $$x155 = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap, gen$1, fromMap);
      $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$();
      var this$820 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$819 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$818 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$817 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$816 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$815 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      var this$814 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
      $m_Lreactbuild_model_Implicits$();
      var this$88 = $m_s_Symbol$();
      var $$x24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "id"));
      var this$89 = $m_s_Symbol$();
      var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$89, "reference"));
      var this$90 = $m_s_Symbol$();
      var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$90, "description"));
      var this$91 = $m_s_Symbol$();
      var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$91, "quantity"));
      var this$92 = $m_s_Symbol$();
      var $$x20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$92, "unit"));
      var this$93 = $m_s_Symbol$();
      var $$x19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "unitPrice"));
      var this$94 = $m_s_Symbol$();
      var $$x18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$94, "amount"));
      var this$95 = $m_s_Symbol$();
      var $$x17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$95, "tradeBody"));
      var this$96 = $m_s_Symbol$();
      var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$96, "buildingSite"));
      var this$97 = $m_s_Symbol$();
      var labels$1 = new $c_Lshapeless_$colon$colon($$x24, new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($$x20, new $c_Lshapeless_$colon$colon($$x19, new $c_Lshapeless_$colon$colon($$x18, new $c_Lshapeless_$colon$colon($$x17, new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$97, "deliveryDate")), $m_Lshapeless_HNil$()))))))))));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
      var f$1 = new $c_sjsr_AnonFunction1(((x0$12$2) => {
        var x0$12 = $as_Lreactbuild_model_InvoiceDetail(x0$12$2);
        if ((x0$12 !== null)) {
          var id$macro$47 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_id;
          var reference$macro$48 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_reference;
          var description$macro$49 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_description;
          var quantity$macro$50 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_quantity;
          var unit$macro$51 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_unit;
          var unitPrice$macro$52 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var amount$macro$53 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_amount;
          var tradeBody$macro$54 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var buildingSite$macro$55 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var deliveryDate$macro$56 = $n(x0$12).Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          return new $c_Lshapeless_$colon$colon(id$macro$47, new $c_Lshapeless_$colon$colon(reference$macro$48, new $c_Lshapeless_$colon$colon(description$macro$49, new $c_Lshapeless_$colon$colon(quantity$macro$50, new $c_Lshapeless_$colon$colon(unit$macro$51, new $c_Lshapeless_$colon$colon(unitPrice$macro$52, new $c_Lshapeless_$colon$colon(amount$macro$53, new $c_Lshapeless_$colon$colon(tradeBody$macro$54, new $c_Lshapeless_$colon$colon(buildingSite$macro$55, new $c_Lshapeless_$colon$colon(deliveryDate$macro$56, $m_Lshapeless_HNil$()))))))))))
        } else {
          throw new $c_s_MatchError(x0$12)
        }
      }));
      var g$1 = new $c_sjsr_AnonFunction1(((x0$13$2) => {
        var x0$13 = $as_Lshapeless_$colon$colon(x0$13$2);
        if ((x0$13 !== null)) {
          var id$macro$37 = $as_ju_UUID($n(x0$13).Lshapeless_$colon$colon__f_head);
          var p2$2 = $as_Lshapeless_$colon$colon($n(x0$13).Lshapeless_$colon$colon__f_tail);
          if ((p2$2 !== null)) {
            var reference$macro$38 = $as_s_Option($n(p2$2).Lshapeless_$colon$colon__f_head);
            var p3$1 = $as_Lshapeless_$colon$colon($n(p2$2).Lshapeless_$colon$colon__f_tail);
            if ((p3$1 !== null)) {
              var description$macro$39 = $as_s_Option($n(p3$1).Lshapeless_$colon$colon__f_head);
              var p4$1 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
              if ((p4$1 !== null)) {
                var quantity$macro$40 = $as_s_Option($n(p4$1).Lshapeless_$colon$colon__f_head);
                var p5 = $as_Lshapeless_$colon$colon($n(p4$1).Lshapeless_$colon$colon__f_tail);
                if ((p5 !== null)) {
                  var unit$macro$41 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                  var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                  if ((p6 !== null)) {
                    var unitPrice$macro$42 = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
                    var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                    if ((p7 !== null)) {
                      var amount$macro$43 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                      var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                      if ((p8 !== null)) {
                        var tradeBody$macro$44 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                        var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                        if ((p9 !== null)) {
                          var buildingSite$macro$45 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                          var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                          if ((p10 !== null)) {
                            var deliveryDate$macro$46 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                            var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                            var x$3 = $m_Lshapeless_HNil$();
                            if ((x$3 === p11)) {
                              return new $c_Lreactbuild_model_InvoiceDetail(id$macro$37, reference$macro$38, description$macro$39, quantity$macro$40, unit$macro$41, unitPrice$macro$42, amount$macro$43, tradeBody$macro$44, buildingSite$macro$45, deliveryDate$macro$46)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
        throw new $c_s_MatchError(x0$13)
      }));
      var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$2 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$100 = $m_s_Symbol$();
      var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$100, "deliveryDate"));
      new $c_Lshapeless_Witness$$anon$1(value0$6);
      var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
      $m_Lshapeless_Witness$();
      var this$103 = $m_s_Symbol$();
      var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$103, "buildingSite"));
      new $c_Lshapeless_Witness$$anon$1(value0$7);
      var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
      $m_Lshapeless_Witness$();
      var this$106 = $m_s_Symbol$();
      var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$106, "tradeBody"));
      new $c_Lshapeless_Witness$$anon$1(value0$8);
      var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
      $m_Lshapeless_Witness$();
      var this$109 = $m_s_Symbol$();
      var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$109, "amount"));
      new $c_Lshapeless_Witness$$anon$1(value0$9);
      var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
      $m_Lshapeless_Witness$();
      var this$112 = $m_s_Symbol$();
      var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$112, "unitPrice"));
      new $c_Lshapeless_Witness$$anon$1(value0$10);
      var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
      $m_Lshapeless_Witness$();
      var this$115 = $m_s_Symbol$();
      var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$115, "unit"));
      new $c_Lshapeless_Witness$$anon$1(value0$11);
      var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
      $m_Lshapeless_Witness$();
      var this$118 = $m_s_Symbol$();
      var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$118, "quantity"));
      new $c_Lshapeless_Witness$$anon$1(value0$12);
      var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
      $m_Lshapeless_Witness$();
      var this$121 = $m_s_Symbol$();
      var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$121, "description"));
      new $c_Lshapeless_Witness$$anon$1(value0$13);
      var zipWithKeys$10 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
      $m_Lshapeless_Witness$();
      var this$124 = $m_s_Symbol$();
      var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$124, "reference"));
      new $c_Lshapeless_Witness$$anon$1(value0$14);
      var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
      $m_Lshapeless_Witness$();
      var this$127 = $m_s_Symbol$();
      var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$127, "id"));
      new $c_Lshapeless_Witness$$anon$1(value0$15);
      var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
      var this$130 = $m_s_$less$colon$less$();
      var ev$4 = this$130.s_$less$colon$less$__f_singleton;
      new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$4);
      var this$252 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.InvoiceDetail", "java.util.UUID");
      var this$251 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$132 = $m_s_Symbol$();
      var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$132, "reference"));
      var witness$8 = new $c_Lshapeless_Witness$$anon$1(value0$16);
      var $$x28 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
      var format$1 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format);
      var $$x27 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$1);
      var ord = $m_s_math_Ordering$String$();
      var $$x26 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$5);
      var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$6);
      var resolver = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
      var $$x25 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$1, resolver);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var textualizable = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
      var columnRenderable$8 = $n($$x28).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x27, $$x26, $$x25, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable));
      var this$250 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$146 = $m_s_Symbol$();
      var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$146, "description"));
      var witness$7 = new $c_Lshapeless_Witness$$anon$1(value0$17);
      var $$x32 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$2 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
      var format$3 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$2);
      var $$x31 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$3);
      var ord$1 = $m_s_math_Ordering$String$();
      var $$x30 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$1)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$7);
      var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$2 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$8);
      var resolver$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
      var $$x29 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$2, resolver$1);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var textualizable$1 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$3);
      var columnRenderable$7 = $n($$x32).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x31, $$x30, $$x29, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$1));
      var this$249 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$160 = $m_s_Symbol$();
      var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$160, "quantity"));
      var witness$6 = new $c_Lshapeless_Witness$$anon$1(value0$18);
      var $$x36 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$4 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_double;
      var format$5 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$4);
      var $$x35 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$5);
      var ord$2 = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
      var $$x34 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$2)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$9);
      var evDefault$3 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
      var parser$3 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$10);
      var resolver$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
      var $$x33 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$3, resolver$2);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableDouble;
      var textualizable$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$5);
      var columnRenderable$6 = $n($$x36).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x35, $$x34, $$x33, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$2));
      var this$248 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$174 = $m_s_Symbol$();
      var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$174, "unit"));
      var witness$5 = new $c_Lshapeless_Witness$$anon$1(value0$19);
      var $$x40 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$6 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
      var format$7 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$6);
      var $$x39 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$7);
      var ord$3 = $m_s_math_Ordering$String$();
      var $$x38 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$3)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$11 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$11);
      var evDefault$4 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$4);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$12 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$4 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$12);
      var resolver$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
      var $$x37 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$4, resolver$3);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var textualizable$3 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$7);
      var columnRenderable$5 = $n($$x40).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x39, $$x38, $$x37, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$3));
      var this$247 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$188 = $m_s_Symbol$();
      var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$188, "unitPrice"));
      var witness$4 = new $c_Lshapeless_Witness$$anon$1(value0$20);
      var $$x44 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$8 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$9 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$8);
      var $$x43 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$9);
      var ord$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x42 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$4)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$13);
      var optioner$5 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
      var $$x41 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$5, resolver$4);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$4);
      var columnRenderable$4 = $n($$x44).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x43, $$x42, $$x41, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$5));
      var this$246 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$199 = $m_s_Symbol$();
      var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$199, "amount"));
      var witness$3 = new $c_Lshapeless_Witness$$anon$1(value0$21);
      var $$x48 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$10 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$11 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$10);
      var $$x47 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$11);
      var ord$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x46 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$5)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$14 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$14);
      var optioner$6 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
      var $$x45 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$6, resolver$5);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$7 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$6);
      var columnRenderable$3 = $n($$x48).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x47, $$x46, $$x45, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$7));
      var this$245 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$210 = $m_s_Symbol$();
      var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$210, "tradeBody"));
      var witness$2 = new $c_Lshapeless_Witness$$anon$1(value0$22);
      var $$x52 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var this$212 = $m_Lreactbuild_model_Implicits$();
      var format$12 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$212);
      var format$13 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$12);
      var $$x51 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$13);
      var this$216 = $m_Lreactbuild_model_Implicits$();
      var this$215 = $m_Lreactbuild_model_Implicits$();
      var ev$15 = $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$215, proxy);
      var ord$6 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$216, ev$15);
      var $$x50 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$6)));
      var $$x49 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$219 = $m_Lreactbuild_model_Implicits$();
      var textualizable$8 = $f_Lreactbuild_model_LowPriorityImplicits__buildingPartTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$219, proxy);
      var textualizable$9 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$8);
      var columnRenderable$2 = $n($$x52).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x51, $$x50, $$x49, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$9));
      var this$244 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$222 = $m_s_Symbol$();
      var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$222, "buildingSite"));
      var witness$1 = new $c_Lshapeless_Witness$$anon$1(value0$23);
      var $$x56 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var this$224 = $m_Lreactbuild_model_Implicits$();
      var format$14 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$224);
      var format$15 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$14);
      var $$x55 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$15);
      var this$228 = $m_Lreactbuild_model_Implicits$();
      var this$227 = $m_Lreactbuild_model_Implicits$();
      var ev$16 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$227, proxy);
      var ord$7 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$228, ev$16);
      var $$x54 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$7)));
      var $$x53 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$231 = $m_Lreactbuild_model_Implicits$();
      var textualizable$10 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$231, proxy);
      var textualizable$11 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$10);
      var columnRenderable$1 = $n($$x56).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x55, $$x54, $$x53, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$11));
      var this$243 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$234 = $m_s_Symbol$();
      var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$234, "deliveryDate"));
      var witness = new $c_Lshapeless_Witness$$anon$1(value0$24);
      var $$x60 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$16 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
      var format$17 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$16);
      var $$x59 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$17);
      var ord$8 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
      var $$x58 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$8)));
      var $$x57 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var textualizable$13 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$12);
      var columnRenderable = $n($$x60).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x59, $$x58, $$x57, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$13));
      var tail = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
      var tail$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$243, columnRenderable, witness, tail);
      var tail$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$244, columnRenderable$1, witness$1, tail$1);
      var tail$3 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$245, columnRenderable$2, witness$2, tail$2);
      var tail$4 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$246, columnRenderable$3, witness$3, tail$3);
      var tail$5 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$247, columnRenderable$4, witness$4, tail$4);
      var tail$6 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$248, columnRenderable$5, witness$5, tail$5);
      var tail$7 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$249, columnRenderable$6, witness$6, tail$6);
      var tail$8 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$250, columnRenderable$7, witness$7, tail$7);
      var tail$9 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$251, columnRenderable$8, witness$8, tail$8);
      var renderer = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$252, tail$9);
      $m_s_DummyImplicit$();
      new $c_Lshapeless_Refute$$anon$2();
      var evL = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer);
      var this$255 = $m_s_Symbol$();
      var $$x69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$255, "id"));
      var this$256 = $m_s_Symbol$();
      var $$x68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$256, "reference"));
      var this$257 = $m_s_Symbol$();
      var $$x67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$257, "description"));
      var this$258 = $m_s_Symbol$();
      var $$x66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$258, "quantity"));
      var this$259 = $m_s_Symbol$();
      var $$x65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$259, "unit"));
      var this$260 = $m_s_Symbol$();
      var $$x64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$260, "unitPrice"));
      var this$261 = $m_s_Symbol$();
      var $$x63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$261, "amount"));
      var this$262 = $m_s_Symbol$();
      var $$x62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$262, "tradeBody"));
      var this$263 = $m_s_Symbol$();
      var $$x61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$263, "buildingSite"));
      var this$264 = $m_s_Symbol$();
      var labels$2 = new $c_Lshapeless_$colon$colon($$x69, new $c_Lshapeless_$colon$colon($$x68, new $c_Lshapeless_$colon$colon($$x67, new $c_Lshapeless_$colon$colon($$x66, new $c_Lshapeless_$colon$colon($$x65, new $c_Lshapeless_$colon$colon($$x64, new $c_Lshapeless_$colon$colon($$x63, new $c_Lshapeless_$colon$colon($$x62, new $c_Lshapeless_$colon$colon($$x61, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$264, "deliveryDate")), $m_Lshapeless_HNil$()))))))))));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
      var f$2 = new $c_sjsr_AnonFunction1(((x0$16$2) => {
        var x0$16 = $as_Lreactbuild_model_InvoiceDetail(x0$16$2);
        if ((x0$16 !== null)) {
          var id$macro$87 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_id;
          var reference$macro$88 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_reference;
          var description$macro$89 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_description;
          var quantity$macro$90 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_quantity;
          var unit$macro$91 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_unit;
          var unitPrice$macro$92 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_unitPrice;
          var amount$macro$93 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_amount;
          var tradeBody$macro$94 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_tradeBody;
          var buildingSite$macro$95 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_buildingSite;
          var deliveryDate$macro$96 = $n(x0$16).Lreactbuild_model_InvoiceDetail__f_deliveryDate;
          return new $c_Lshapeless_$colon$colon(id$macro$87, new $c_Lshapeless_$colon$colon(reference$macro$88, new $c_Lshapeless_$colon$colon(description$macro$89, new $c_Lshapeless_$colon$colon(quantity$macro$90, new $c_Lshapeless_$colon$colon(unit$macro$91, new $c_Lshapeless_$colon$colon(unitPrice$macro$92, new $c_Lshapeless_$colon$colon(amount$macro$93, new $c_Lshapeless_$colon$colon(tradeBody$macro$94, new $c_Lshapeless_$colon$colon(buildingSite$macro$95, new $c_Lshapeless_$colon$colon(deliveryDate$macro$96, $m_Lshapeless_HNil$()))))))))))
        } else {
          throw new $c_s_MatchError(x0$16)
        }
      }));
      var g$2 = new $c_sjsr_AnonFunction1(((x0$17$2) => {
        var x0$17 = $as_Lshapeless_$colon$colon(x0$17$2);
        if ((x0$17 !== null)) {
          var id$macro$77 = $as_ju_UUID($n(x0$17).Lshapeless_$colon$colon__f_head);
          var p2$3 = $as_Lshapeless_$colon$colon($n(x0$17).Lshapeless_$colon$colon__f_tail);
          if ((p2$3 !== null)) {
            var reference$macro$78 = $as_s_Option($n(p2$3).Lshapeless_$colon$colon__f_head);
            var p3$2 = $as_Lshapeless_$colon$colon($n(p2$3).Lshapeless_$colon$colon__f_tail);
            if ((p3$2 !== null)) {
              var description$macro$79 = $as_s_Option($n(p3$2).Lshapeless_$colon$colon__f_head);
              var p4$2 = $as_Lshapeless_$colon$colon($n(p3$2).Lshapeless_$colon$colon__f_tail);
              if ((p4$2 !== null)) {
                var quantity$macro$80 = $as_s_Option($n(p4$2).Lshapeless_$colon$colon__f_head);
                var p5$1 = $as_Lshapeless_$colon$colon($n(p4$2).Lshapeless_$colon$colon__f_tail);
                if ((p5$1 !== null)) {
                  var unit$macro$81 = $as_s_Option($n(p5$1).Lshapeless_$colon$colon__f_head);
                  var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
                  if ((p6$1 !== null)) {
                    var unitPrice$macro$82 = $as_s_Option($n(p6$1).Lshapeless_$colon$colon__f_head);
                    var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                    if ((p7$1 !== null)) {
                      var amount$macro$83 = $as_s_Option($n(p7$1).Lshapeless_$colon$colon__f_head);
                      var p8$1 = $as_Lshapeless_$colon$colon($n(p7$1).Lshapeless_$colon$colon__f_tail);
                      if ((p8$1 !== null)) {
                        var tradeBody$macro$84 = $as_s_Option($n(p8$1).Lshapeless_$colon$colon__f_head);
                        var p9$1 = $as_Lshapeless_$colon$colon($n(p8$1).Lshapeless_$colon$colon__f_tail);
                        if ((p9$1 !== null)) {
                          var buildingSite$macro$85 = $as_s_Option($n(p9$1).Lshapeless_$colon$colon__f_head);
                          var p10$1 = $as_Lshapeless_$colon$colon($n(p9$1).Lshapeless_$colon$colon__f_tail);
                          if ((p10$1 !== null)) {
                            var deliveryDate$macro$86 = $as_s_Option($n(p10$1).Lshapeless_$colon$colon__f_head);
                            var p11$1 = $as_Lshapeless_HNil($n(p10$1).Lshapeless_$colon$colon__f_tail);
                            var x$4 = $m_Lshapeless_HNil$();
                            if ((x$4 === p11$1)) {
                              return new $c_Lreactbuild_model_InvoiceDetail(id$macro$77, reference$macro$78, description$macro$79, quantity$macro$80, unit$macro$81, unitPrice$macro$82, amount$macro$83, tradeBody$macro$84, buildingSite$macro$85, deliveryDate$macro$86)
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
        throw new $c_s_MatchError(x0$17)
      }));
      var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$12 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$267 = $m_s_Symbol$();
      var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$267, "deliveryDate"));
      new $c_Lshapeless_Witness$$anon$1(value0$25);
      var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
      $m_Lshapeless_Witness$();
      var this$270 = $m_s_Symbol$();
      var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$270, "buildingSite"));
      new $c_Lshapeless_Witness$$anon$1(value0$26);
      var zipWithKeys$14 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
      $m_Lshapeless_Witness$();
      var this$273 = $m_s_Symbol$();
      var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$273, "tradeBody"));
      new $c_Lshapeless_Witness$$anon$1(value0$27);
      var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
      $m_Lshapeless_Witness$();
      var this$276 = $m_s_Symbol$();
      var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$276, "amount"));
      new $c_Lshapeless_Witness$$anon$1(value0$28);
      var zipWithKeys$16 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
      $m_Lshapeless_Witness$();
      var this$279 = $m_s_Symbol$();
      var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$279, "unitPrice"));
      new $c_Lshapeless_Witness$$anon$1(value0$29);
      var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
      $m_Lshapeless_Witness$();
      var this$282 = $m_s_Symbol$();
      var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$282, "unit"));
      new $c_Lshapeless_Witness$$anon$1(value0$30);
      var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
      $m_Lshapeless_Witness$();
      var this$285 = $m_s_Symbol$();
      var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$285, "quantity"));
      new $c_Lshapeless_Witness$$anon$1(value0$31);
      var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
      $m_Lshapeless_Witness$();
      var this$288 = $m_s_Symbol$();
      var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$288, "description"));
      new $c_Lshapeless_Witness$$anon$1(value0$32);
      var zipWithKeys$20 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
      $m_Lshapeless_Witness$();
      var this$291 = $m_s_Symbol$();
      var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$291, "reference"));
      new $c_Lshapeless_Witness$$anon$1(value0$33);
      var zipWithKeys$21 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
      $m_Lshapeless_Witness$();
      var this$294 = $m_s_Symbol$();
      var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$294, "id"));
      new $c_Lshapeless_Witness$$anon$1(value0$34);
      var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
      var this$297 = $m_s_$less$colon$less$();
      var ev$17 = this$297.s_$less$colon$less$__f_singleton;
      var gen$5 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$17);
      $m_Lshapeless_Witness$();
      var this$299 = $m_s_Symbol$();
      var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$299, "deliveryDate"));
      var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$35);
      var tailToMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk$4);
      var keyLub$1 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$1 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$304 = $m_s_Symbol$();
      var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$304, "buildingSite"));
      var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$36);
      var tailToMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$5);
      var keyLub$2 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$2 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$309 = $m_s_Symbol$();
      var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$309, "tradeBody"));
      var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$37);
      var tailToMap$3 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$2, keyLub$2, valueLub$2, wk$6);
      var keyLub$3 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$3 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$314 = $m_s_Symbol$();
      var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$314, "amount"));
      var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$38);
      var tailToMap$4 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$3, keyLub$3, valueLub$3, wk$7);
      var keyLub$4 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$4 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$319 = $m_s_Symbol$();
      var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$319, "unitPrice"));
      var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$39);
      var tailToMap$5 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$4, keyLub$4, valueLub$4, wk$8);
      var keyLub$5 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$5 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$324 = $m_s_Symbol$();
      var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$324, "unit"));
      var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$40);
      var tailToMap$6 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$5, keyLub$5, valueLub$5, wk$9);
      var keyLub$6 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$6 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$329 = $m_s_Symbol$();
      var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$329, "quantity"));
      var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$41);
      var tailToMap$7 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$6, keyLub$6, valueLub$6, wk$10);
      var keyLub$7 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$7 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$334 = $m_s_Symbol$();
      var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$334, "description"));
      var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$42);
      var tailToMap$8 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$7, keyLub$7, valueLub$7, wk$11);
      var keyLub$8 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$8 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$339 = $m_s_Symbol$();
      var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$339, "reference"));
      var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$43);
      var tailToMap$9 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$8, keyLub$8, valueLub$8, wk$12);
      var keyLub$9 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$9 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$344 = $m_s_Symbol$();
      var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$344, "id"));
      var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$44);
      var toMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$9, keyLub$9, valueLub$9, wk$13);
      $m_Lshapeless_Witness$();
      var this$347 = $m_s_Symbol$();
      var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$347, "id"));
      var wk$23 = new $c_Lshapeless_Witness$$anon$1(value0$45);
      var tv$11 = $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")));
      $m_Lshapeless_Witness$();
      var this$349 = $m_s_Symbol$();
      var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$349, "reference"));
      var wk$22 = new $c_Lshapeless_Witness$$anon$1(value0$46);
      var tv$10 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
      $m_Lshapeless_Witness$();
      var this$351 = $m_s_Symbol$();
      var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$351, "description"));
      var wk$21 = new $c_Lshapeless_Witness$$anon$1(value0$47);
      var tv$9 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
      $m_Lshapeless_Witness$();
      var this$353 = $m_s_Symbol$();
      var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$353, "quantity"));
      var wk$20 = new $c_Lshapeless_Witness$$anon$1(value0$48);
      var tv$8 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_doubleTypeable);
      $m_Lshapeless_Witness$();
      var this$355 = $m_s_Symbol$();
      var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$355, "unit"));
      var wk$19 = new $c_Lshapeless_Witness$$anon$1(value0$49);
      var tv$7 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
      $m_Lshapeless_Witness$();
      var this$357 = $m_s_Symbol$();
      var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$357, "unitPrice"));
      var wk$18 = new $c_Lshapeless_Witness$$anon$1(value0$50);
      var tv$6 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
      $m_Lshapeless_Witness$();
      var this$359 = $m_s_Symbol$();
      var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$359, "amount"));
      var wk$17 = new $c_Lshapeless_Witness$$anon$1(value0$51);
      var tv$5 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
      $m_Lshapeless_Witness$();
      var this$361 = $m_s_Symbol$();
      var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$361, "tradeBody"));
      var wk$16 = new $c_Lshapeless_Witness$$anon$1(value0$52);
      var tv$4 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
      $m_Lshapeless_Witness$();
      var this$363 = $m_s_Symbol$();
      var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$363, "buildingSite"));
      var wk$15 = new $c_Lshapeless_Witness$$anon$1(value0$53);
      var tv$3 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
      $m_Lshapeless_Witness$();
      var this$365 = $m_s_Symbol$();
      var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$365, "deliveryDate"));
      var wk$14 = new $c_Lshapeless_Witness$$anon$1(value0$54);
      var tv$2 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_Date.getClassOf(), new $c_sjsr_AnonFunction0((() => "Date"))));
      var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
      var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$14, tv$2, fmt$2);
      var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$15, tv$3, fmt$3);
      var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$16, tv$4, fmt$4);
      var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$17, tv$5, fmt$5);
      var fmt$7 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$18, tv$6, fmt$6);
      var fmt$8 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$19, tv$7, fmt$7);
      var fmt$9 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$20, tv$8, fmt$8);
      var fmt$10 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$21, tv$9, fmt$9);
      var fmt$11 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$22, tv$10, fmt$10);
      var fromMap$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$23, tv$11, fmt$11);
      var mapC = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap$1, gen$5, fromMap$1);
      var this$379 = $m_s_Symbol$();
      var $$x84 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$379, "_id"));
      var this$380 = $m_s_Symbol$();
      var $$x83 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$380, "organization"));
      var this$381 = $m_s_Symbol$();
      var $$x82 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$381, "file"));
      var this$382 = $m_s_Symbol$();
      var $$x81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$382, "notDone"));
      var this$383 = $m_s_Symbol$();
      var $$x80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$383, "supplier"));
      var this$384 = $m_s_Symbol$();
      var $$x79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$384, "supplierOffice"));
      var this$385 = $m_s_Symbol$();
      var $$x78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$385, "date"));
      var this$386 = $m_s_Symbol$();
      var $$x77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$386, "reference"));
      var this$387 = $m_s_Symbol$();
      var $$x76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$387, "pageIndex"));
      var this$388 = $m_s_Symbol$();
      var $$x75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$388, "pageCount"));
      var this$389 = $m_s_Symbol$();
      var $$x74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$389, "amount"));
      var this$390 = $m_s_Symbol$();
      var $$x73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$390, "totalAmount"));
      var this$391 = $m_s_Symbol$();
      var $$x72 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$391, "details"));
      var this$392 = $m_s_Symbol$();
      var $$x71 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$392, "entryNumber"));
      var this$393 = $m_s_Symbol$();
      var $$x70 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$393, "category"));
      var this$394 = $m_s_Symbol$();
      var labels$3 = new $c_Lshapeless_$colon$colon($$x84, new $c_Lshapeless_$colon$colon($$x83, new $c_Lshapeless_$colon$colon($$x82, new $c_Lshapeless_$colon$colon($$x81, new $c_Lshapeless_$colon$colon($$x80, new $c_Lshapeless_$colon$colon($$x79, new $c_Lshapeless_$colon$colon($$x78, new $c_Lshapeless_$colon$colon($$x77, new $c_Lshapeless_$colon$colon($$x76, new $c_Lshapeless_$colon$colon($$x75, new $c_Lshapeless_$colon$colon($$x74, new $c_Lshapeless_$colon$colon($$x73, new $c_Lshapeless_$colon$colon($$x72, new $c_Lshapeless_$colon$colon($$x71, new $c_Lshapeless_$colon$colon($$x70, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$394, "deletedAt")), $m_Lshapeless_HNil$()))))))))))))))));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
      var f$3 = new $c_sjsr_AnonFunction1(((x0$20$2) => {
        var x0$20 = $as_Lreactbuild_model_InvoicePage(x0$20$2);
        if ((x0$20 !== null)) {
          var _id$macro$145 = $n(x0$20).Lreactbuild_model_InvoicePage__f__id;
          var organization$macro$146 = $n(x0$20).Lreactbuild_model_InvoicePage__f_organization;
          var file$macro$147 = $n(x0$20).Lreactbuild_model_InvoicePage__f_file;
          var notDone$macro$148 = $n(x0$20).Lreactbuild_model_InvoicePage__f_notDone;
          var supplier$macro$149 = $n(x0$20).Lreactbuild_model_InvoicePage__f_supplier;
          var supplierOffice$macro$150 = $n(x0$20).Lreactbuild_model_InvoicePage__f_supplierOffice;
          var date$macro$151 = $n(x0$20).Lreactbuild_model_InvoicePage__f_date;
          var reference$macro$152 = $n(x0$20).Lreactbuild_model_InvoicePage__f_reference;
          var pageIndex$macro$153 = $n(x0$20).Lreactbuild_model_InvoicePage__f_pageIndex;
          var pageCount$macro$154 = $n(x0$20).Lreactbuild_model_InvoicePage__f_pageCount;
          var amount$macro$155 = $n(x0$20).Lreactbuild_model_InvoicePage__f_amount;
          var totalAmount$macro$156 = $n(x0$20).Lreactbuild_model_InvoicePage__f_totalAmount;
          var details$macro$157 = $n(x0$20).Lreactbuild_model_InvoicePage__f_details;
          var entryNumber$macro$158 = $n(x0$20).Lreactbuild_model_InvoicePage__f_entryNumber;
          var category$macro$159 = $n(x0$20).Lreactbuild_model_InvoicePage__f_category;
          var deletedAt$macro$160 = $n(x0$20).Lreactbuild_model_InvoicePage__f_deletedAt;
          return new $c_Lshapeless_$colon$colon(_id$macro$145, new $c_Lshapeless_$colon$colon(organization$macro$146, new $c_Lshapeless_$colon$colon(file$macro$147, new $c_Lshapeless_$colon$colon(notDone$macro$148, new $c_Lshapeless_$colon$colon(supplier$macro$149, new $c_Lshapeless_$colon$colon(supplierOffice$macro$150, new $c_Lshapeless_$colon$colon(date$macro$151, new $c_Lshapeless_$colon$colon(reference$macro$152, new $c_Lshapeless_$colon$colon(pageIndex$macro$153, new $c_Lshapeless_$colon$colon(pageCount$macro$154, new $c_Lshapeless_$colon$colon(amount$macro$155, new $c_Lshapeless_$colon$colon(totalAmount$macro$156, new $c_Lshapeless_$colon$colon(details$macro$157, new $c_Lshapeless_$colon$colon(entryNumber$macro$158, new $c_Lshapeless_$colon$colon(category$macro$159, new $c_Lshapeless_$colon$colon(deletedAt$macro$160, $m_Lshapeless_HNil$()))))))))))))))))
        } else {
          throw new $c_s_MatchError(x0$20)
        }
      }));
      var g$3 = new $c_sjsr_AnonFunction1(((x0$21$2) => {
        var x0$21 = $as_Lshapeless_$colon$colon(x0$21$2);
        if ((x0$21 !== null)) {
          var _id$macro$129 = $as_Lreactbuild_common_model_RefTo($n(x0$21).Lshapeless_$colon$colon__f_head);
          var p2$4 = $as_Lshapeless_$colon$colon($n(x0$21).Lshapeless_$colon$colon__f_tail);
          if ((p2$4 !== null)) {
            var organization$macro$130 = $as_Lreactbuild_common_model_RefTo($n(p2$4).Lshapeless_$colon$colon__f_head);
            var p3$3 = $as_Lshapeless_$colon$colon($n(p2$4).Lshapeless_$colon$colon__f_tail);
            if ((p3$3 !== null)) {
              var file$macro$131 = $as_s_Option($n(p3$3).Lshapeless_$colon$colon__f_head);
              var p4$3 = $as_Lshapeless_$colon$colon($n(p3$3).Lshapeless_$colon$colon__f_tail);
              if ((p4$3 !== null)) {
                var notDone$macro$132 = $uZ($n(p4$3).Lshapeless_$colon$colon__f_head);
                var p5$2 = $as_Lshapeless_$colon$colon($n(p4$3).Lshapeless_$colon$colon__f_tail);
                if ((p5$2 !== null)) {
                  var supplier$macro$133 = $as_s_Option($n(p5$2).Lshapeless_$colon$colon__f_head);
                  var p6$2 = $as_Lshapeless_$colon$colon($n(p5$2).Lshapeless_$colon$colon__f_tail);
                  if ((p6$2 !== null)) {
                    var supplierOffice$macro$134 = $as_s_Option($n(p6$2).Lshapeless_$colon$colon__f_head);
                    var p7$2 = $as_Lshapeless_$colon$colon($n(p6$2).Lshapeless_$colon$colon__f_tail);
                    if ((p7$2 !== null)) {
                      var date$macro$135 = $as_s_Option($n(p7$2).Lshapeless_$colon$colon__f_head);
                      var p8$2 = $as_Lshapeless_$colon$colon($n(p7$2).Lshapeless_$colon$colon__f_tail);
                      if ((p8$2 !== null)) {
                        var reference$macro$136 = $as_s_Option($n(p8$2).Lshapeless_$colon$colon__f_head);
                        var p9$2 = $as_Lshapeless_$colon$colon($n(p8$2).Lshapeless_$colon$colon__f_tail);
                        if ((p9$2 !== null)) {
                          var pageIndex$macro$137 = $as_s_Option($n(p9$2).Lshapeless_$colon$colon__f_head);
                          var p10$2 = $as_Lshapeless_$colon$colon($n(p9$2).Lshapeless_$colon$colon__f_tail);
                          if ((p10$2 !== null)) {
                            var pageCount$macro$138 = $as_s_Option($n(p10$2).Lshapeless_$colon$colon__f_head);
                            var p11$2 = $as_Lshapeless_$colon$colon($n(p10$2).Lshapeless_$colon$colon__f_tail);
                            if ((p11$2 !== null)) {
                              var amount$macro$139 = $as_s_Option($n(p11$2).Lshapeless_$colon$colon__f_head);
                              var p12 = $as_Lshapeless_$colon$colon($n(p11$2).Lshapeless_$colon$colon__f_tail);
                              if ((p12 !== null)) {
                                var totalAmount$macro$140 = $as_s_Option($n(p12).Lshapeless_$colon$colon__f_head);
                                var p13 = $as_Lshapeless_$colon$colon($n(p12).Lshapeless_$colon$colon__f_tail);
                                if ((p13 !== null)) {
                                  var details$macro$141 = $as_sci_List($n(p13).Lshapeless_$colon$colon__f_head);
                                  var p14 = $as_Lshapeless_$colon$colon($n(p13).Lshapeless_$colon$colon__f_tail);
                                  if ((p14 !== null)) {
                                    var entryNumber$macro$142 = $as_s_Option($n(p14).Lshapeless_$colon$colon__f_head);
                                    var p15 = $as_Lshapeless_$colon$colon($n(p14).Lshapeless_$colon$colon__f_tail);
                                    if ((p15 !== null)) {
                                      var category$macro$143 = $as_s_Option($n(p15).Lshapeless_$colon$colon__f_head);
                                      var p16 = $as_Lshapeless_$colon$colon($n(p15).Lshapeless_$colon$colon__f_tail);
                                      if ((p16 !== null)) {
                                        var deletedAt$macro$144 = $as_s_Option($n(p16).Lshapeless_$colon$colon__f_head);
                                        var p17 = $as_Lshapeless_HNil($n(p16).Lshapeless_$colon$colon__f_tail);
                                        var x$5 = $m_Lshapeless_HNil$();
                                        if ((x$5 === p17)) {
                                          return new $c_Lreactbuild_model_InvoicePage(_id$macro$129, organization$macro$130, file$macro$131, notDone$macro$132, supplier$macro$133, supplierOffice$macro$134, date$macro$135, reference$macro$136, pageIndex$macro$137, pageCount$macro$138, amount$macro$139, totalAmount$macro$140, details$macro$141, entryNumber$macro$142, category$macro$143, deletedAt$macro$144)
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
        throw new $c_s_MatchError(x0$21)
      }));
      var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$22 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$397 = $m_s_Symbol$();
      var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$397, "deletedAt"));
      new $c_Lshapeless_Witness$$anon$1(value0$55);
      var zipWithKeys$23 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
      $m_Lshapeless_Witness$();
      var this$400 = $m_s_Symbol$();
      var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$400, "category"));
      new $c_Lshapeless_Witness$$anon$1(value0$56);
      var zipWithKeys$24 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$23);
      $m_Lshapeless_Witness$();
      var this$403 = $m_s_Symbol$();
      var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$403, "entryNumber"));
      new $c_Lshapeless_Witness$$anon$1(value0$57);
      var zipWithKeys$25 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$24);
      $m_Lshapeless_Witness$();
      var this$406 = $m_s_Symbol$();
      var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$406, "details"));
      new $c_Lshapeless_Witness$$anon$1(value0$58);
      var zipWithKeys$26 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$25);
      $m_Lshapeless_Witness$();
      var this$409 = $m_s_Symbol$();
      var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$409, "totalAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$59);
      var zipWithKeys$27 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$26);
      $m_Lshapeless_Witness$();
      var this$412 = $m_s_Symbol$();
      var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$412, "amount"));
      new $c_Lshapeless_Witness$$anon$1(value0$60);
      var zipWithKeys$28 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$27);
      $m_Lshapeless_Witness$();
      var this$415 = $m_s_Symbol$();
      var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$415, "pageCount"));
      new $c_Lshapeless_Witness$$anon$1(value0$61);
      var zipWithKeys$29 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$28);
      $m_Lshapeless_Witness$();
      var this$418 = $m_s_Symbol$();
      var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$418, "pageIndex"));
      new $c_Lshapeless_Witness$$anon$1(value0$62);
      var zipWithKeys$30 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$29);
      $m_Lshapeless_Witness$();
      var this$421 = $m_s_Symbol$();
      var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$421, "reference"));
      new $c_Lshapeless_Witness$$anon$1(value0$63);
      var zipWithKeys$31 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$30);
      $m_Lshapeless_Witness$();
      var this$424 = $m_s_Symbol$();
      var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$424, "date"));
      new $c_Lshapeless_Witness$$anon$1(value0$64);
      var zipWithKeys$32 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$31);
      $m_Lshapeless_Witness$();
      var this$427 = $m_s_Symbol$();
      var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$427, "supplierOffice"));
      new $c_Lshapeless_Witness$$anon$1(value0$65);
      var zipWithKeys$33 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$32);
      $m_Lshapeless_Witness$();
      var this$430 = $m_s_Symbol$();
      var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$430, "supplier"));
      new $c_Lshapeless_Witness$$anon$1(value0$66);
      var zipWithKeys$34 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$33);
      $m_Lshapeless_Witness$();
      var this$433 = $m_s_Symbol$();
      var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$433, "notDone"));
      new $c_Lshapeless_Witness$$anon$1(value0$67);
      var zipWithKeys$35 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$34);
      $m_Lshapeless_Witness$();
      var this$436 = $m_s_Symbol$();
      var value0$68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$436, "file"));
      new $c_Lshapeless_Witness$$anon$1(value0$68);
      var zipWithKeys$36 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$35);
      $m_Lshapeless_Witness$();
      var this$439 = $m_s_Symbol$();
      var value0$69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$439, "organization"));
      new $c_Lshapeless_Witness$$anon$1(value0$69);
      var zipWithKeys$37 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$36);
      $m_Lshapeless_Witness$();
      var this$442 = $m_s_Symbol$();
      var value0$70 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$442, "_id"));
      new $c_Lshapeless_Witness$$anon$1(value0$70);
      var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$37);
      var this$445 = $m_s_$less$colon$less$();
      var ev$18 = this$445.s_$less$colon$less$__f_singleton;
      new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$18);
      var this$608 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$447 = $m_s_Symbol$();
      var value0$71 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$447, "_id"));
      var witness$22 = new $c_Lshapeless_Witness$$anon$1(value0$71);
      var $$x85 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      var this$449 = $m_Lreactbuild_model_Implicits$();
      var format$18 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$449);
      var columnRenderable$22 = $n($$x85).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable(new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$18), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()), new $c_Lcom_iz2use_react_components_NotEditable(), new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList$$anon$1(this, router));
      var this$607 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$452 = $m_s_Symbol$();
      var value0$72 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$452, "organization"));
      var witness$21 = new $c_Lshapeless_Witness$$anon$1(value0$72);
      var $$x89 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      var this$454 = $m_Lreactbuild_model_Implicits$();
      var format$19 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$454);
      var $$x88 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$19);
      var this$457 = $m_Lreactbuild_model_Implicits$();
      var this$456 = $m_Lreactbuild_model_Implicits$();
      var ev$19 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$456, proxy);
      var $$x87 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$457, ev$19)));
      var $$x86 = new $c_Lcom_iz2use_react_components_NotEditable();
      var this$459 = $m_Lreactbuild_model_Implicits$();
      var textualizable$14 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$459, proxy);
      var columnRenderable$21 = $n($$x89).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x88, $$x87, $$x86, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$14));
      var this$606 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.InvoicePage", "Option[reactbuild.model.InvoicePageFile]");
      var this$605 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$461 = $m_s_Symbol$();
      var value0$73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$461, "notDone"));
      var witness$20 = new $c_Lshapeless_Witness$$anon$1(value0$73);
      var $$x93 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      var format$20 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_boolean;
      var $$x92 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$20);
      var $$x91 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_s_math_Ordering$Boolean$()));
      $m_Lcom_iz2use_common_Parsable$();
      var evDefault$5 = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
      var optioner$7 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$5);
      var parser$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
      var resolver$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
      var $$x90 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$7, resolver$6);
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$11 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
      var columnRenderable$20 = $n($$x93).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x92, $$x91, $$x90, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(parsable$11));
      var this$604 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$469 = $m_s_Symbol$();
      var value0$74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$469, "supplier"));
      var witness$19 = new $c_Lshapeless_Witness$$anon$1(value0$74);
      var $$x97 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var this$471 = $m_Lreactbuild_model_Implicits$();
      var format$21 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$471);
      var format$22 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$21);
      var $$x96 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$22);
      var this$475 = $m_Lreactbuild_model_Implicits$();
      var this$474 = $m_Lreactbuild_model_Implicits$();
      var ev$20 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$474, proxy);
      var ord$9 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$475, ev$20);
      var $$x95 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$9)));
      var $$x94 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$478 = $m_Lreactbuild_model_Implicits$();
      var textualizable$15 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$478, proxy);
      var textualizable$16 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$15);
      var columnRenderable$19 = $n($$x97).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x96, $$x95, $$x94, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$16));
      var this$603 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$481 = $m_s_Symbol$();
      var value0$75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$481, "supplierOffice"));
      var witness$18 = new $c_Lshapeless_Witness$$anon$1(value0$75);
      var $$x101 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var this$483 = $m_Lreactbuild_model_Implicits$();
      var format$23 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$483);
      var format$24 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$23);
      var $$x100 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$24);
      var this$487 = $m_Lreactbuild_model_Implicits$();
      var this$486 = $m_Lreactbuild_model_Implicits$();
      var ev$21 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$486, proxy);
      var ord$10 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$487, ev$21);
      var $$x99 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$10)));
      var $$x98 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$490 = $m_Lreactbuild_model_Implicits$();
      var textualizable$17 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$490, proxy);
      var textualizable$18 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$17);
      var columnRenderable$18 = $n($$x101).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x100, $$x99, $$x98, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$18));
      var this$602 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$493 = $m_s_Symbol$();
      var value0$76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$493, "date"));
      var witness$17 = new $c_Lshapeless_Witness$$anon$1(value0$76);
      var $$x105 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$25 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
      var format$26 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$25);
      var $$x104 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$26);
      var ord$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
      var $$x103 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$11)));
      var $$x102 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$19 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
      var textualizable$20 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$19);
      var columnRenderable$17 = $n($$x105).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x104, $$x103, $$x102, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$20));
      var this$601 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$501 = $m_s_Symbol$();
      var value0$77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$501, "reference"));
      var witness$16 = new $c_Lshapeless_Witness$$anon$1(value0$77);
      var $$x109 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$27 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
      var format$28 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$27);
      var $$x108 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$28);
      var ord$12 = $m_s_math_Ordering$String$();
      var $$x107 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$12)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$22 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$22);
      var evDefault$6 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
      var optioner$8 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$6);
      $m_Lcom_iz2use_common_Parsable$();
      var ev$23 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var parser$8 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$23);
      var resolver$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$8);
      var $$x106 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$8, resolver$7);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$13 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
      var textualizable$21 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$13);
      var columnRenderable$16 = $n($$x109).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x108, $$x107, $$x106, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$21));
      var this$600 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$515 = $m_s_Symbol$();
      var value0$78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$515, "pageIndex"));
      var witness$15 = new $c_Lshapeless_Witness$$anon$1(value0$78);
      var $$x113 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$29 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
      var format$30 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$29);
      var $$x112 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$30);
      var ord$13 = $m_s_math_Ordering$Int$();
      var $$x111 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$13)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$24 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$24);
      var optioner$9 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$9 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var resolver$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$9);
      var $$x110 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$9, resolver$8);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var textualizable$22 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$15);
      var columnRenderable$15 = $n($$x113).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x112, $$x111, $$x110, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$22));
      var this$599 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$527 = $m_s_Symbol$();
      var value0$79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$527, "pageCount"));
      var witness$14 = new $c_Lshapeless_Witness$$anon$1(value0$79);
      var $$x117 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$31 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
      var format$32 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$31);
      var $$x116 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$32);
      var ord$14 = $m_s_math_Ordering$Int$();
      var $$x115 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$14)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$25 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$25);
      var optioner$10 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var resolver$9 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$10);
      var $$x114 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$10, resolver$9);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var textualizable$23 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$17);
      var columnRenderable$14 = $n($$x117).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x116, $$x115, $$x114, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$23));
      var this$598 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$539 = $m_s_Symbol$();
      var value0$80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$539, "amount"));
      var witness$13 = new $c_Lshapeless_Witness$$anon$1(value0$80);
      var $$x121 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$33 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$34 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$33);
      var $$x120 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$34);
      var ord$15 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x119 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$15)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$26 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$26);
      var optioner$11 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$10 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$11);
      var $$x118 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$11, resolver$10);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$24 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$25 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$24);
      var columnRenderable$13 = $n($$x121).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x120, $$x119, $$x118, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$25));
      var this$597 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$550 = $m_s_Symbol$();
      var value0$81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$550, "totalAmount"));
      var witness$12 = new $c_Lshapeless_Witness$$anon$1(value0$81);
      var $$x125 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$35 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
      var format$36 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$35);
      var $$x124 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$36);
      var ord$16 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
      var $$x123 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$16)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$27 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$27);
      var optioner$12 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var resolver$11 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$12);
      var $$x122 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$12, resolver$11);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$26 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
      var textualizable$27 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$26);
      var columnRenderable$12 = $n($$x125).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x124, $$x123, $$x122, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$27));
      var this$596 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      new $c_Lcom_iz2use_react_components_internal_multiview_table_ForgetColumn("reactbuild.model.InvoicePage", "List[reactbuild.model.InvoiceDetail]");
      var this$595 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$561 = $m_s_Symbol$();
      var value0$82 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$561, "entryNumber"));
      var witness$11 = new $c_Lshapeless_Witness$$anon$1(value0$82);
      var $$x129 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$37 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
      var format$38 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$37);
      var $$x128 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$38);
      var ord$17 = $m_s_math_Ordering$Int$();
      var $$x127 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$17)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$28 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$28);
      var optioner$13 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var parser$13 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var resolver$12 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$13);
      var $$x126 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$13, resolver$12);
      $m_Lcom_iz2use_common_Textualizable$();
      $m_Lcom_iz2use_common_Textualizable$();
      var parsable$21 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
      var textualizable$28 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$21);
      var columnRenderable$11 = $n($$x129).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x128, $$x127, $$x126, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$28));
      var this$594 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$573 = $m_s_Symbol$();
      var value0$83 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$573, "category"));
      var witness$10 = new $c_Lshapeless_Witness$$anon$1(value0$83);
      var $$x133 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$39 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
      var format$40 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$39);
      var $$x132 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$40);
      var ord$18 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
      var $$x131 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$18)));
      $m_Lcom_iz2use_common_Parsable$();
      var ev$29 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$29);
      var optioner$14 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
      var resolver$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
      var $$x130 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$14, resolver$13);
      $m_Lcom_iz2use_common_Textualizable$();
      var textualizable$29 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
      var textualizable$30 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$29);
      var columnRenderable$10 = $n($$x133).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x132, $$x131, $$x130, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$30));
      var this$593 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
      $m_Lshapeless_Witness$();
      var this$583 = $m_s_Symbol$();
      var value0$84 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$583, "deletedAt"));
      var witness$9 = new $c_Lshapeless_Witness$$anon$1(value0$84);
      var $$x137 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
      $m_Lcom_iz2use_react_components_internal_multiview_Format$();
      var format$41 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
      var format$42 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$41);
      var $$x136 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$42);
      var ord$19 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
      var $$x135 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$19)));
      var $$x134 = new $c_Lcom_iz2use_react_components_NotEditable();
      $m_Lcom_iz2use_common_Textualizable$();
      var this$589 = $m_Lreactbuild_model_Implicits$();
      var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
      var textualizable$31 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$589, locale);
      var textualizable$32 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$31);
      var columnRenderable$9 = $n($$x137).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x136, $$x135, $$x134, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$32));
      var tail$10 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
      var tail$11 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$593, columnRenderable$9, witness$9, tail$10);
      var tail$12 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$594, columnRenderable$10, witness$10, tail$11);
      var tail$13 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$595, columnRenderable$11, witness$11, tail$12);
      var tail$14 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$596, tail$13);
      var tail$15 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$597, columnRenderable$12, witness$12, tail$14);
      var tail$16 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$598, columnRenderable$13, witness$13, tail$15);
      var tail$17 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$599, columnRenderable$14, witness$14, tail$16);
      var tail$18 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$600, columnRenderable$15, witness$15, tail$17);
      var tail$19 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$601, columnRenderable$16, witness$16, tail$18);
      var tail$20 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$602, columnRenderable$17, witness$17, tail$19);
      var tail$21 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$603, columnRenderable$18, witness$18, tail$20);
      var tail$22 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$604, columnRenderable$19, witness$19, tail$21);
      var tail$23 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$605, columnRenderable$20, witness$20, tail$22);
      var tail$24 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererLowPriorityImplicits$$anon$6(this$606, tail$23);
      var tail$25 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$607, columnRenderable$21, witness$21, tail$24);
      var renderer$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$608, columnRenderable$22, witness$22, tail$25);
      $m_s_DummyImplicit$();
      new $c_Lshapeless_Refute$$anon$2();
      var evR = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$1);
      var this$611 = $m_s_Symbol$();
      var $$x152 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$611, "_id"));
      var this$612 = $m_s_Symbol$();
      var $$x151 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$612, "organization"));
      var this$613 = $m_s_Symbol$();
      var $$x150 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$613, "file"));
      var this$614 = $m_s_Symbol$();
      var $$x149 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$614, "notDone"));
      var this$615 = $m_s_Symbol$();
      var $$x148 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$615, "supplier"));
      var this$616 = $m_s_Symbol$();
      var $$x147 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$616, "supplierOffice"));
      var this$617 = $m_s_Symbol$();
      var $$x146 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$617, "date"));
      var this$618 = $m_s_Symbol$();
      var $$x145 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$618, "reference"));
      var this$619 = $m_s_Symbol$();
      var $$x144 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$619, "pageIndex"));
      var this$620 = $m_s_Symbol$();
      var $$x143 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$620, "pageCount"));
      var this$621 = $m_s_Symbol$();
      var $$x142 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$621, "amount"));
      var this$622 = $m_s_Symbol$();
      var $$x141 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$622, "totalAmount"));
      var this$623 = $m_s_Symbol$();
      var $$x140 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$623, "details"));
      var this$624 = $m_s_Symbol$();
      var $$x139 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$624, "entryNumber"));
      var this$625 = $m_s_Symbol$();
      var $$x138 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$625, "category"));
      var this$626 = $m_s_Symbol$();
      var labels$4 = new $c_Lshapeless_$colon$colon($$x152, new $c_Lshapeless_$colon$colon($$x151, new $c_Lshapeless_$colon$colon($$x150, new $c_Lshapeless_$colon$colon($$x149, new $c_Lshapeless_$colon$colon($$x148, new $c_Lshapeless_$colon$colon($$x147, new $c_Lshapeless_$colon$colon($$x146, new $c_Lshapeless_$colon$colon($$x145, new $c_Lshapeless_$colon$colon($$x144, new $c_Lshapeless_$colon$colon($$x143, new $c_Lshapeless_$colon$colon($$x142, new $c_Lshapeless_$colon$colon($$x141, new $c_Lshapeless_$colon$colon($$x140, new $c_Lshapeless_$colon$colon($$x139, new $c_Lshapeless_$colon$colon($$x138, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$626, "deletedAt")), $m_Lshapeless_HNil$()))))))))))))))));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$4);
      var f$4 = new $c_sjsr_AnonFunction1(((x0$24$2) => {
        var x0$24 = $as_Lreactbuild_model_InvoicePage(x0$24$2);
        if ((x0$24 !== null)) {
          var _id$macro$209 = $n(x0$24).Lreactbuild_model_InvoicePage__f__id;
          var organization$macro$210 = $n(x0$24).Lreactbuild_model_InvoicePage__f_organization;
          var file$macro$211 = $n(x0$24).Lreactbuild_model_InvoicePage__f_file;
          var notDone$macro$212 = $n(x0$24).Lreactbuild_model_InvoicePage__f_notDone;
          var supplier$macro$213 = $n(x0$24).Lreactbuild_model_InvoicePage__f_supplier;
          var supplierOffice$macro$214 = $n(x0$24).Lreactbuild_model_InvoicePage__f_supplierOffice;
          var date$macro$215 = $n(x0$24).Lreactbuild_model_InvoicePage__f_date;
          var reference$macro$216 = $n(x0$24).Lreactbuild_model_InvoicePage__f_reference;
          var pageIndex$macro$217 = $n(x0$24).Lreactbuild_model_InvoicePage__f_pageIndex;
          var pageCount$macro$218 = $n(x0$24).Lreactbuild_model_InvoicePage__f_pageCount;
          var amount$macro$219 = $n(x0$24).Lreactbuild_model_InvoicePage__f_amount;
          var totalAmount$macro$220 = $n(x0$24).Lreactbuild_model_InvoicePage__f_totalAmount;
          var details$macro$221 = $n(x0$24).Lreactbuild_model_InvoicePage__f_details;
          var entryNumber$macro$222 = $n(x0$24).Lreactbuild_model_InvoicePage__f_entryNumber;
          var category$macro$223 = $n(x0$24).Lreactbuild_model_InvoicePage__f_category;
          var deletedAt$macro$224 = $n(x0$24).Lreactbuild_model_InvoicePage__f_deletedAt;
          return new $c_Lshapeless_$colon$colon(_id$macro$209, new $c_Lshapeless_$colon$colon(organization$macro$210, new $c_Lshapeless_$colon$colon(file$macro$211, new $c_Lshapeless_$colon$colon(notDone$macro$212, new $c_Lshapeless_$colon$colon(supplier$macro$213, new $c_Lshapeless_$colon$colon(supplierOffice$macro$214, new $c_Lshapeless_$colon$colon(date$macro$215, new $c_Lshapeless_$colon$colon(reference$macro$216, new $c_Lshapeless_$colon$colon(pageIndex$macro$217, new $c_Lshapeless_$colon$colon(pageCount$macro$218, new $c_Lshapeless_$colon$colon(amount$macro$219, new $c_Lshapeless_$colon$colon(totalAmount$macro$220, new $c_Lshapeless_$colon$colon(details$macro$221, new $c_Lshapeless_$colon$colon(entryNumber$macro$222, new $c_Lshapeless_$colon$colon(category$macro$223, new $c_Lshapeless_$colon$colon(deletedAt$macro$224, $m_Lshapeless_HNil$()))))))))))))))))
        } else {
          throw new $c_s_MatchError(x0$24)
        }
      }));
      var g$4 = new $c_sjsr_AnonFunction1(((x0$25$2) => {
        var x0$25 = $as_Lshapeless_$colon$colon(x0$25$2);
        if ((x0$25 !== null)) {
          var _id$macro$193 = $as_Lreactbuild_common_model_RefTo($n(x0$25).Lshapeless_$colon$colon__f_head);
          var p2$5 = $as_Lshapeless_$colon$colon($n(x0$25).Lshapeless_$colon$colon__f_tail);
          if ((p2$5 !== null)) {
            var organization$macro$194 = $as_Lreactbuild_common_model_RefTo($n(p2$5).Lshapeless_$colon$colon__f_head);
            var p3$4 = $as_Lshapeless_$colon$colon($n(p2$5).Lshapeless_$colon$colon__f_tail);
            if ((p3$4 !== null)) {
              var file$macro$195 = $as_s_Option($n(p3$4).Lshapeless_$colon$colon__f_head);
              var p4$4 = $as_Lshapeless_$colon$colon($n(p3$4).Lshapeless_$colon$colon__f_tail);
              if ((p4$4 !== null)) {
                var notDone$macro$196 = $uZ($n(p4$4).Lshapeless_$colon$colon__f_head);
                var p5$3 = $as_Lshapeless_$colon$colon($n(p4$4).Lshapeless_$colon$colon__f_tail);
                if ((p5$3 !== null)) {
                  var supplier$macro$197 = $as_s_Option($n(p5$3).Lshapeless_$colon$colon__f_head);
                  var p6$3 = $as_Lshapeless_$colon$colon($n(p5$3).Lshapeless_$colon$colon__f_tail);
                  if ((p6$3 !== null)) {
                    var supplierOffice$macro$198 = $as_s_Option($n(p6$3).Lshapeless_$colon$colon__f_head);
                    var p7$3 = $as_Lshapeless_$colon$colon($n(p6$3).Lshapeless_$colon$colon__f_tail);
                    if ((p7$3 !== null)) {
                      var date$macro$199 = $as_s_Option($n(p7$3).Lshapeless_$colon$colon__f_head);
                      var p8$3 = $as_Lshapeless_$colon$colon($n(p7$3).Lshapeless_$colon$colon__f_tail);
                      if ((p8$3 !== null)) {
                        var reference$macro$200 = $as_s_Option($n(p8$3).Lshapeless_$colon$colon__f_head);
                        var p9$3 = $as_Lshapeless_$colon$colon($n(p8$3).Lshapeless_$colon$colon__f_tail);
                        if ((p9$3 !== null)) {
                          var pageIndex$macro$201 = $as_s_Option($n(p9$3).Lshapeless_$colon$colon__f_head);
                          var p10$3 = $as_Lshapeless_$colon$colon($n(p9$3).Lshapeless_$colon$colon__f_tail);
                          if ((p10$3 !== null)) {
                            var pageCount$macro$202 = $as_s_Option($n(p10$3).Lshapeless_$colon$colon__f_head);
                            var p11$3 = $as_Lshapeless_$colon$colon($n(p10$3).Lshapeless_$colon$colon__f_tail);
                            if ((p11$3 !== null)) {
                              var amount$macro$203 = $as_s_Option($n(p11$3).Lshapeless_$colon$colon__f_head);
                              var p12$1 = $as_Lshapeless_$colon$colon($n(p11$3).Lshapeless_$colon$colon__f_tail);
                              if ((p12$1 !== null)) {
                                var totalAmount$macro$204 = $as_s_Option($n(p12$1).Lshapeless_$colon$colon__f_head);
                                var p13$1 = $as_Lshapeless_$colon$colon($n(p12$1).Lshapeless_$colon$colon__f_tail);
                                if ((p13$1 !== null)) {
                                  var details$macro$205 = $as_sci_List($n(p13$1).Lshapeless_$colon$colon__f_head);
                                  var p14$1 = $as_Lshapeless_$colon$colon($n(p13$1).Lshapeless_$colon$colon__f_tail);
                                  if ((p14$1 !== null)) {
                                    var entryNumber$macro$206 = $as_s_Option($n(p14$1).Lshapeless_$colon$colon__f_head);
                                    var p15$1 = $as_Lshapeless_$colon$colon($n(p14$1).Lshapeless_$colon$colon__f_tail);
                                    if ((p15$1 !== null)) {
                                      var category$macro$207 = $as_s_Option($n(p15$1).Lshapeless_$colon$colon__f_head);
                                      var p16$1 = $as_Lshapeless_$colon$colon($n(p15$1).Lshapeless_$colon$colon__f_tail);
                                      if ((p16$1 !== null)) {
                                        var deletedAt$macro$208 = $as_s_Option($n(p16$1).Lshapeless_$colon$colon__f_head);
                                        var p17$1 = $as_Lshapeless_HNil($n(p16$1).Lshapeless_$colon$colon__f_tail);
                                        var x$7 = $m_Lshapeless_HNil$();
                                        if ((x$7 === p17$1)) {
                                          return new $c_Lreactbuild_model_InvoicePage(_id$macro$193, organization$macro$194, file$macro$195, notDone$macro$196, supplier$macro$197, supplierOffice$macro$198, date$macro$199, reference$macro$200, pageIndex$macro$201, pageCount$macro$202, amount$macro$203, totalAmount$macro$204, details$macro$205, entryNumber$macro$206, category$macro$207, deletedAt$macro$208)
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
        throw new $c_s_MatchError(x0$25)
      }));
      var gen$8 = new $c_Lshapeless_Generic$$anon$1(f$4, g$4);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$38 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$629 = $m_s_Symbol$();
      var value0$85 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$629, "deletedAt"));
      new $c_Lshapeless_Witness$$anon$1(value0$85);
      var zipWithKeys$39 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$38);
      $m_Lshapeless_Witness$();
      var this$632 = $m_s_Symbol$();
      var value0$86 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$632, "category"));
      new $c_Lshapeless_Witness$$anon$1(value0$86);
      var zipWithKeys$40 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$39);
      $m_Lshapeless_Witness$();
      var this$635 = $m_s_Symbol$();
      var value0$87 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$635, "entryNumber"));
      new $c_Lshapeless_Witness$$anon$1(value0$87);
      var zipWithKeys$41 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$40);
      $m_Lshapeless_Witness$();
      var this$638 = $m_s_Symbol$();
      var value0$88 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$638, "details"));
      new $c_Lshapeless_Witness$$anon$1(value0$88);
      var zipWithKeys$42 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$41);
      $m_Lshapeless_Witness$();
      var this$641 = $m_s_Symbol$();
      var value0$89 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$641, "totalAmount"));
      new $c_Lshapeless_Witness$$anon$1(value0$89);
      var zipWithKeys$43 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$42);
      $m_Lshapeless_Witness$();
      var this$644 = $m_s_Symbol$();
      var value0$90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$644, "amount"));
      new $c_Lshapeless_Witness$$anon$1(value0$90);
      var zipWithKeys$44 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$43);
      $m_Lshapeless_Witness$();
      var this$647 = $m_s_Symbol$();
      var value0$91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$647, "pageCount"));
      new $c_Lshapeless_Witness$$anon$1(value0$91);
      var zipWithKeys$45 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$44);
      $m_Lshapeless_Witness$();
      var this$650 = $m_s_Symbol$();
      var value0$92 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$650, "pageIndex"));
      new $c_Lshapeless_Witness$$anon$1(value0$92);
      var zipWithKeys$46 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$45);
      $m_Lshapeless_Witness$();
      var this$653 = $m_s_Symbol$();
      var value0$93 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$653, "reference"));
      new $c_Lshapeless_Witness$$anon$1(value0$93);
      var zipWithKeys$47 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$46);
      $m_Lshapeless_Witness$();
      var this$656 = $m_s_Symbol$();
      var value0$94 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$656, "date"));
      new $c_Lshapeless_Witness$$anon$1(value0$94);
      var zipWithKeys$48 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$47);
      $m_Lshapeless_Witness$();
      var this$659 = $m_s_Symbol$();
      var value0$95 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$659, "supplierOffice"));
      new $c_Lshapeless_Witness$$anon$1(value0$95);
      var zipWithKeys$49 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$48);
      $m_Lshapeless_Witness$();
      var this$662 = $m_s_Symbol$();
      var value0$96 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$662, "supplier"));
      new $c_Lshapeless_Witness$$anon$1(value0$96);
      var zipWithKeys$50 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$49);
      $m_Lshapeless_Witness$();
      var this$665 = $m_s_Symbol$();
      var value0$97 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$665, "notDone"));
      new $c_Lshapeless_Witness$$anon$1(value0$97);
      var zipWithKeys$51 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$50);
      $m_Lshapeless_Witness$();
      var this$668 = $m_s_Symbol$();
      var value0$98 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$668, "file"));
      new $c_Lshapeless_Witness$$anon$1(value0$98);
      var zipWithKeys$52 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$51);
      $m_Lshapeless_Witness$();
      var this$671 = $m_s_Symbol$();
      var value0$99 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$671, "organization"));
      new $c_Lshapeless_Witness$$anon$1(value0$99);
      var zipWithKeys$53 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$52);
      $m_Lshapeless_Witness$();
      var this$674 = $m_s_Symbol$();
      var value0$100 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$674, "_id"));
      new $c_Lshapeless_Witness$$anon$1(value0$100);
      var zip$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$53);
      var this$677 = $m_s_$less$colon$less$();
      var ev$30 = this$677.s_$less$colon$less$__f_singleton;
      var gen$9 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$4, gen$8, ev$30);
      $m_Lshapeless_Witness$();
      var this$679 = $m_s_Symbol$();
      var value0$101 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$679, "deletedAt"));
      var wk$24 = new $c_Lshapeless_Witness$$anon$1(value0$101);
      var tailToMap$10 = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk$24);
      var keyLub$10 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$10 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$684 = $m_s_Symbol$();
      var value0$102 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$684, "category"));
      var wk$25 = new $c_Lshapeless_Witness$$anon$1(value0$102);
      var tailToMap$11 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$10, keyLub$10, valueLub$10, wk$25);
      var keyLub$11 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$11 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$689 = $m_s_Symbol$();
      var value0$103 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$689, "entryNumber"));
      var wk$26 = new $c_Lshapeless_Witness$$anon$1(value0$103);
      var tailToMap$12 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$11, keyLub$11, valueLub$11, wk$26);
      var keyLub$12 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$12 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$694 = $m_s_Symbol$();
      var value0$104 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$694, "details"));
      var wk$27 = new $c_Lshapeless_Witness$$anon$1(value0$104);
      var tailToMap$13 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$12, keyLub$12, valueLub$12, wk$27);
      var keyLub$13 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$13 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$699 = $m_s_Symbol$();
      var value0$105 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$699, "totalAmount"));
      var wk$28 = new $c_Lshapeless_Witness$$anon$1(value0$105);
      var tailToMap$14 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$13, keyLub$13, valueLub$13, wk$28);
      var keyLub$14 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$14 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$704 = $m_s_Symbol$();
      var value0$106 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$704, "amount"));
      var wk$29 = new $c_Lshapeless_Witness$$anon$1(value0$106);
      var tailToMap$15 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$14, keyLub$14, valueLub$14, wk$29);
      var keyLub$15 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$15 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$709 = $m_s_Symbol$();
      var value0$107 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$709, "pageCount"));
      var wk$30 = new $c_Lshapeless_Witness$$anon$1(value0$107);
      var tailToMap$16 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$15, keyLub$15, valueLub$15, wk$30);
      var keyLub$16 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$16 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$714 = $m_s_Symbol$();
      var value0$108 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$714, "pageIndex"));
      var wk$31 = new $c_Lshapeless_Witness$$anon$1(value0$108);
      var tailToMap$17 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$16, keyLub$16, valueLub$16, wk$31);
      var keyLub$17 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$17 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$719 = $m_s_Symbol$();
      var value0$109 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$719, "reference"));
      var wk$32 = new $c_Lshapeless_Witness$$anon$1(value0$109);
      var tailToMap$18 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$17, keyLub$17, valueLub$17, wk$32);
      var keyLub$18 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$18 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$724 = $m_s_Symbol$();
      var value0$110 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$724, "date"));
      var wk$33 = new $c_Lshapeless_Witness$$anon$1(value0$110);
      var tailToMap$19 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$18, keyLub$18, valueLub$18, wk$33);
      var keyLub$19 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$19 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$729 = $m_s_Symbol$();
      var value0$111 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$729, "supplierOffice"));
      var wk$34 = new $c_Lshapeless_Witness$$anon$1(value0$111);
      var tailToMap$20 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$19, keyLub$19, valueLub$19, wk$34);
      var keyLub$20 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$20 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$734 = $m_s_Symbol$();
      var value0$112 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$734, "supplier"));
      var wk$35 = new $c_Lshapeless_Witness$$anon$1(value0$112);
      var tailToMap$21 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$20, keyLub$20, valueLub$20, wk$35);
      var keyLub$21 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$21 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$739 = $m_s_Symbol$();
      var value0$113 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$739, "notDone"));
      var wk$36 = new $c_Lshapeless_Witness$$anon$1(value0$113);
      var tailToMap$22 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$21, keyLub$21, valueLub$21, wk$36);
      var keyLub$22 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$22 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$744 = $m_s_Symbol$();
      var value0$114 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$744, "file"));
      var wk$37 = new $c_Lshapeless_Witness$$anon$1(value0$114);
      var tailToMap$23 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$22, keyLub$22, valueLub$22, wk$37);
      var keyLub$23 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$23 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$749 = $m_s_Symbol$();
      var value0$115 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$749, "organization"));
      var wk$38 = new $c_Lshapeless_Witness$$anon$1(value0$115);
      var tailToMap$24 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$23, keyLub$23, valueLub$23, wk$38);
      var keyLub$24 = new $c_Lshapeless_Lub$$anon$4();
      var valueLub$24 = new $c_Lshapeless_Lub$$anon$4();
      $m_Lshapeless_Witness$();
      var this$754 = $m_s_Symbol$();
      var value0$116 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$754, "_id"));
      var wk$39 = new $c_Lshapeless_Witness$$anon$1(value0$116);
      var toMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$24, keyLub$24, valueLub$24, wk$39);
      $m_Lshapeless_Witness$();
      var this$757 = $m_s_Symbol$();
      var value0$117 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$757, "_id"));
      var wk$55 = new $c_Lshapeless_Witness$$anon$1(value0$117);
      var tv$27 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
      $m_Lshapeless_Witness$();
      var this$759 = $m_s_Symbol$();
      var value0$118 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$759, "organization"));
      var wk$54 = new $c_Lshapeless_Witness$$anon$1(value0$118);
      var tv$26 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
      $m_Lshapeless_Witness$();
      var this$761 = $m_s_Symbol$();
      var value0$119 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$761, "file"));
      var wk$53 = new $c_Lshapeless_Witness$$anon$1(value0$119);
      var tv$25 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_InvoicePageFile.getClassOf(), new $c_sjsr_AnonFunction0((() => "InvoicePageFile"))));
      $m_Lshapeless_Witness$();
      var this$763 = $m_s_Symbol$();
      var value0$120 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$763, "notDone"));
      var wk$52 = new $c_Lshapeless_Witness$$anon$1(value0$120);
      var tv$24 = $m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_booleanTypeable;
      $m_Lshapeless_Witness$();
      var this$765 = $m_s_Symbol$();
      var value0$121 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$765, "supplier"));
      var wk$51 = new $c_Lshapeless_Witness$$anon$1(value0$121);
      var tv$23 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
      $m_Lshapeless_Witness$();
      var this$767 = $m_s_Symbol$();
      var value0$122 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$767, "supplierOffice"));
      var wk$50 = new $c_Lshapeless_Witness$$anon$1(value0$122);
      var tv$22 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
      $m_Lshapeless_Witness$();
      var this$769 = $m_s_Symbol$();
      var value0$123 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$769, "date"));
      var wk$49 = new $c_Lshapeless_Witness$$anon$1(value0$123);
      var tv$21 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_Date.getClassOf(), new $c_sjsr_AnonFunction0((() => "Date"))));
      $m_Lshapeless_Witness$();
      var this$771 = $m_s_Symbol$();
      var value0$124 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$771, "reference"));
      var wk$48 = new $c_Lshapeless_Witness$$anon$1(value0$124);
      var tv$20 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
      $m_Lshapeless_Witness$();
      var this$773 = $m_s_Symbol$();
      var value0$125 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$773, "pageIndex"));
      var wk$47 = new $c_Lshapeless_Witness$$anon$1(value0$125);
      var tv$19 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_intTypeable);
      $m_Lshapeless_Witness$();
      var this$775 = $m_s_Symbol$();
      var value0$126 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$775, "pageCount"));
      var wk$46 = new $c_Lshapeless_Witness$$anon$1(value0$126);
      var tv$18 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_intTypeable);
      $m_Lshapeless_Witness$();
      var this$777 = $m_s_Symbol$();
      var value0$127 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$777, "amount"));
      var wk$45 = new $c_Lshapeless_Witness$$anon$1(value0$127);
      var tv$17 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
      $m_Lshapeless_Witness$();
      var this$779 = $m_s_Symbol$();
      var value0$128 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$779, "totalAmount"));
      var wk$44 = new $c_Lshapeless_Witness$$anon$1(value0$128);
      var tv$16 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
      $m_Lshapeless_Witness$();
      var this$781 = $m_s_Symbol$();
      var value0$129 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$781, "details"));
      var wk$43 = new $c_Lshapeless_Witness$$anon$1(value0$129);
      var tv$15 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_List.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_InvoiceDetail.getClassOf(), new $c_sjsr_AnonFunction0((() => "InvoiceDetail"))));
      $m_Lshapeless_Witness$();
      var this$784 = $m_s_Symbol$();
      var value0$130 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$784, "entryNumber"));
      var wk$42 = new $c_Lshapeless_Witness$$anon$1(value0$130);
      var tv$14 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_intTypeable);
      $m_Lshapeless_Witness$();
      var this$786 = $m_s_Symbol$();
      var value0$131 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$786, "category"));
      var wk$41 = new $c_Lshapeless_Witness$$anon$1(value0$131);
      var tv$13 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_DocumentCategory.getClassOf(), new $c_sjsr_AnonFunction0((() => "DocumentCategory"))));
      $m_Lshapeless_Witness$();
      var this$788 = $m_s_Symbol$();
      var value0$132 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$788, "deletedAt"));
      var wk$40 = new $c_Lshapeless_Witness$$anon$1(value0$132);
      var tv$12 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_Instant.getClassOf(), new $c_sjsr_AnonFunction0((() => "Instant"))));
      var fmt$12 = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
      var fmt$13 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$40, tv$12, fmt$12);
      var fmt$14 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$41, tv$13, fmt$13);
      var fmt$15 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$42, tv$14, fmt$14);
      var fmt$16 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$43, tv$15, fmt$15);
      var fmt$17 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$44, tv$16, fmt$16);
      var fmt$18 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$45, tv$17, fmt$17);
      var fmt$19 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$46, tv$18, fmt$18);
      var fmt$20 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$47, tv$19, fmt$19);
      var fmt$21 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$48, tv$20, fmt$20);
      var fmt$22 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$49, tv$21, fmt$21);
      var fmt$23 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$50, tv$22, fmt$22);
      var fmt$24 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$51, tv$23, fmt$23);
      var fmt$25 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$52, tv$24, fmt$24);
      var fmt$26 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$53, tv$25, fmt$25);
      var fmt$27 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$54, tv$26, fmt$26);
      var fromMap$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$55, tv$27, fmt$27);
      var mapP = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap$2, gen$9, fromMap$2);
      var ctc = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_model_InvoiceDetail.getClassOf());
      var ctp = new $c_s_reflect_ClassTag$GenericClassTag($d_Lreactbuild_model_InvoicePage.getClassOf());
      var columnFragment = new $c_Lreactbuild_model_Implicits$$anon$31(evL, ctc, mapC, evR, ctp, mapP);
      var view = new $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment);
      var tail$26 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2();
      var tail$27 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view, tail$26);
      var tail$28 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$814, tail$27);
      var tail$29 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$815, tail$28);
      var tail$30 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$816, tail$29);
      var tail$31 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$817, tail$30);
      var tail$32 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$818, tail$31);
      var tail$33 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$819, tail$32);
      var mat = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$820, tail$33);
      $m_s_DummyImplicit$();
      new $c_Lshapeless_Refute$$anon$2();
      var $$x153 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViews(mat.apply__sci_List());
      var $$x15 = $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$().Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable;
      var this$823 = $m_s_Symbol$();
      var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$823, "child"));
      var this$824 = $m_s_Symbol$();
      var labels$5 = new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$824, "parent")), $m_Lshapeless_HNil$()));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$5);
      var f$5 = new $c_sjsr_AnonFunction1(((x0$28$2) => {
        var x0$28 = $as_Lreactbuild_model_ChildWithParent(x0$28$2);
        if ((x0$28 !== null)) {
          var child$macro$231 = $as_Lreactbuild_model_InvoiceDetail($n(x0$28).Lreactbuild_model_ChildWithParent__f_child);
          var parent$macro$232 = $as_Lreactbuild_model_InvoicePage($n(x0$28).Lreactbuild_model_ChildWithParent__f_parent);
          return new $c_Lshapeless_$colon$colon(child$macro$231, new $c_Lshapeless_$colon$colon(parent$macro$232, $m_Lshapeless_HNil$()))
        } else {
          throw new $c_s_MatchError(x0$28)
        }
      }));
      var g$5 = new $c_sjsr_AnonFunction1(((x0$29$2) => {
        var x0$29 = $as_Lshapeless_$colon$colon(x0$29$2);
        if ((x0$29 !== null)) {
          var child$macro$229 = $as_Lreactbuild_model_InvoiceDetail($n(x0$29).Lshapeless_$colon$colon__f_head);
          var p2$6 = $as_Lshapeless_$colon$colon($n(x0$29).Lshapeless_$colon$colon__f_tail);
          if ((p2$6 !== null)) {
            var parent$macro$230 = $as_Lreactbuild_model_InvoicePage($n(p2$6).Lshapeless_$colon$colon__f_head);
            var p3$5 = $as_Lshapeless_HNil($n(p2$6).Lshapeless_$colon$colon__f_tail);
            var x$8 = $m_Lshapeless_HNil$();
            if ((x$8 === p3$5)) {
              return new $c_Lreactbuild_model_ChildWithParent(child$macro$229, parent$macro$230)
            }
          }
        };
        throw new $c_s_MatchError(x0$29)
      }));
      var gen$10 = new $c_Lshapeless_Generic$$anon$1(f$5, g$5);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$54 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$827 = $m_s_Symbol$();
      var value0$133 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$827, "parent"));
      new $c_Lshapeless_Witness$$anon$1(value0$133);
      var zipWithKeys$55 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$54);
      $m_Lshapeless_Witness$();
      var this$830 = $m_s_Symbol$();
      var value0$134 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$830, "child"));
      new $c_Lshapeless_Witness$$anon$1(value0$134);
      var zip$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$55);
      var this$833 = $m_s_$less$colon$less$();
      var ev$31 = this$833.s_$less$colon$less$__f_singleton;
      new $c_Lshapeless_LabelledGeneric$$anon$2(zip$5, gen$10, ev$31);
      var this$837 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
      var this$836 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$();
      var tail$34 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3();
      var tail$35 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$836, tail$34);
      var renderer$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRendererLowPriorityImplicits$$anon$2(this$837, tail$35);
      var $$x14 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$2);
      var $$x12 = $m_Lreactbuild_model_Implicits$().keyMapperChildWithParent__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_KeyMapper($m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_keyMapperInvoiceDetail);
      var $$x11 = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
      var $$x10 = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
      var this$839 = $m_s_Symbol$();
      var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$839, "child"));
      var this$840 = $m_s_Symbol$();
      var labels$6 = new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$840, "parent")), $m_Lshapeless_HNil$()));
      new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$6);
      var f$6 = new $c_sjsr_AnonFunction1(((x0$32$2) => {
        var x0$32 = $as_Lreactbuild_model_ChildWithParent(x0$32$2);
        if ((x0$32 !== null)) {
          var child$macro$239 = $as_Lreactbuild_model_InvoiceDetail($n(x0$32).Lreactbuild_model_ChildWithParent__f_child);
          var parent$macro$240 = $as_Lreactbuild_model_InvoicePage($n(x0$32).Lreactbuild_model_ChildWithParent__f_parent);
          return new $c_Lshapeless_$colon$colon(child$macro$239, new $c_Lshapeless_$colon$colon(parent$macro$240, $m_Lshapeless_HNil$()))
        } else {
          throw new $c_s_MatchError(x0$32)
        }
      }));
      var g$6 = new $c_sjsr_AnonFunction1(((x0$33$2) => {
        var x0$33 = $as_Lshapeless_$colon$colon(x0$33$2);
        if ((x0$33 !== null)) {
          var child$macro$237 = $as_Lreactbuild_model_InvoiceDetail($n(x0$33).Lshapeless_$colon$colon__f_head);
          var p2$7 = $as_Lshapeless_$colon$colon($n(x0$33).Lshapeless_$colon$colon__f_tail);
          if ((p2$7 !== null)) {
            var parent$macro$238 = $as_Lreactbuild_model_InvoicePage($n(p2$7).Lshapeless_$colon$colon__f_head);
            var p3$6 = $as_Lshapeless_HNil($n(p2$7).Lshapeless_$colon$colon__f_tail);
            var x$9 = $m_Lshapeless_HNil$();
            if ((x$9 === p3$6)) {
              return new $c_Lreactbuild_model_ChildWithParent(child$macro$237, parent$macro$238)
            }
          }
        };
        throw new $c_s_MatchError(x0$33)
      }));
      var gen$12 = new $c_Lshapeless_Generic$$anon$1(f$6, g$6);
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      $m_Lshapeless_ops_hlist$ZipWithKeys$();
      var zipWithKeys$56 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
      $m_Lshapeless_Witness$();
      var this$843 = $m_s_Symbol$();
      var value0$135 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$843, "parent"));
      new $c_Lshapeless_Witness$$anon$1(value0$135);
      var zipWithKeys$57 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$56);
      $m_Lshapeless_Witness$();
      var this$846 = $m_s_Symbol$();
      var value0$136 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$846, "child"));
      new $c_Lshapeless_Witness$$anon$1(value0$136);
      var zip$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$57);
      var this$849 = $m_s_$less$colon$less$();
      var ev$32 = this$849.s_$less$colon$less$__f_singleton;
      var gen$13 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$6, gen$12, ev$32);
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$851 = $m_s_Symbol$();
      var value0$137 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$851, "child"));
      var witness$24 = new $c_Lshapeless_Witness$$anon$1(value0$137);
      var ht$1 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
      $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
      $m_Lshapeless_Witness$();
      var this$853 = $m_s_Symbol$();
      var value0$138 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$853, "parent"));
      var witness$23 = new $c_Lshapeless_Witness$$anon$1(value0$138);
      var ht = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
      var tt = $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$().Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil;
      var tt$1 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt, ht, witness$23);
      var tokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$24);
      var $$x9 = new $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer, gen$13);
      var $$x7 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
      var $$x6 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
      var $$x5 = new $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1();
      var $$x4 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
      var $$x3 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
      $m_Lreactbuild_model_Implicits$();
      var this$860 = $m_Ljapgolly_scalajs_react_Reusability$();
      var u$2 = $n($$x157).noExternalStateNorActive__O__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(r$4, $$x156, $$x155, $$x153, $$x15, $$x14, $$x12, $$x11, $$x10, $$x9, $$x7, $$x6, $$x5, $$x4, $$x3, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$860.byRef__F2(), this$860.by_$eq$eq__F2()), new $c_sjsr_AnonFunction1(((evT$2) => {
        var evT = $n($as_Ljapgolly_scalajs_react_Reusability(evT$2)).Ljapgolly_scalajs_react_Reusability__f_test;
        return new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityMultiviewItemColl__F2__F2(evT))
      })), $m_Lcom_iz2use_react_components_internal_multiview_View$().defaultViewOrdering__s_math_Ordering());
      var this$862 = $n(u$2);
      var n$2 = this$862.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
    }));
    var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$();
    $m_Lreactbuild_model_Implicits$();
    var this$865 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u$3 = $n($$x165).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x158, $$x2, $n($$x1).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$865.byRef__F2(), this$865.by_$eq$eq__F2())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var this$867 = $n(u$3);
    var n$3 = this$867.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$4 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)];
    var array$5 = [$$x167, $n($$x166).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$875, null, ns)
  })), proxy);
  var this$879 = $n($m_s_package$().s_package$__f_Nil);
  var this$877 = $n(rassoc$1);
  var n$4 = this$877.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var elem = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4);
  return new $c_sci_$colon$colon(elem, this$879)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_title
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.productPrefix__T = (function() {
  return "DocumentLineList"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_allGroup : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DocumentLineList");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_allGroup ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if (((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList) && ($n($as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(x$1)).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_$outer === this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_$outer))) {
    var DocumentLineList$1 = $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(x$1);
    return ((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_allGroup === $n(DocumentLineList$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList__f_allGroup) && ($n(DocumentLineList$1), true))
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  return this.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq(router, proxy, $as_Lreactbuild_person_Person(current), setDetailState)
});
function $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$DocumentLineList"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.PersonDetailViewHandler$DocumentLineList;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$DocumentLineList", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentLineList;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$(outer) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$__f_title = null;
  if ((outer === null)) {
    $n(null)
  };
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$__f_title = "Documents"
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.handleClose__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq = (function(router, proxy, person, setDetailState) {
  var $$x198 = $m_s_package$().s_package$__f_Seq;
  var $$x197 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
  var $$x193 = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var $$x196 = new $c_Lautowire_ClientProxy(this$2).Lautowire_ClientProxy__f_self;
    var $$x195 = $m_s_package$().s_package$__f_Seq;
    var array = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listAllInvoices"];
    var $$x194 = $as_sci_Seq($n($$x195).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)));
    var this$14 = $n($m_s_Predef$().s_Predef$__f_Map);
    var this$7 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
    var this$9 = $n(new $c_Lautowire_ClientProxy(this$7).Lautowire_ClientProxy__f_self);
    var r = new $c_s_Some($n(person).Lreactbuild_person_Person__f__id);
    $m_Lio_circe_Encoder$();
    var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
    var evidence$2 = new $c_Lio_circe_Encoder$$anon$21(e);
    var y = this$9.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
    var array$1 = [$ct_T2__O__O__(new $c_T2(), "supplier", y)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    return $n($n($n($$x196).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x194, this$14.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $as_Lio_circe_Json(x$1$2);
      var this$15 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$17 = $n(new $c_Lautowire_ClientProxy(this$15).Lautowire_ClientProxy__f_self);
      $m_Lio_circe_Decoder$();
      var decodeA = $m_Lreactbuild_model_InvoicePageGroup$().Lreactbuild_model_InvoicePageGroup$__f_codecForInvoicePageGroup;
      var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
      return $as_sci_List(this$17.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5 = $as_sci_List(x$5$2);
      return $n(x$5).reverse__sci_List()
    })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
  }));
  var $$x2 = new $c_sjsr_AnonFunction1(((r$2) => {
    var r$1 = $as_Ldiode_data_Pot(r$2);
    var $$x192 = $m_Lcom_iz2use_react_components_Multiview$();
    var $$x191 = new $c_Lcom_iz2use_react_components_internal_multiview_PotSourceHandler();
    var this$19 = $m_s_Symbol$();
    var $$x189 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$19, "organization"));
    var this$20 = $m_s_Symbol$();
    var $$x188 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$20, "supplier"));
    var this$21 = $m_s_Symbol$();
    var $$x187 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$21, "date"));
    var this$22 = $m_s_Symbol$();
    var $$x186 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$22, "entryNumber"));
    var this$23 = $m_s_Symbol$();
    var $$x185 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$23, "reference"));
    var this$24 = $m_s_Symbol$();
    var $$x184 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$24, "pages"));
    var this$25 = $m_s_Symbol$();
    var $$x183 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$25, "totalAmount"));
    var this$26 = $m_s_Symbol$();
    var $$x182 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$26, "expectedAmount"));
    var this$27 = $m_s_Symbol$();
    var $$x181 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$27, "received"));
    var this$28 = $m_s_Symbol$();
    var labels = new $c_Lshapeless_$colon$colon($$x189, new $c_Lshapeless_$colon$colon($$x188, new $c_Lshapeless_$colon$colon($$x187, new $c_Lshapeless_$colon$colon($$x186, new $c_Lshapeless_$colon$colon($$x185, new $c_Lshapeless_$colon$colon($$x184, new $c_Lshapeless_$colon$colon($$x183, new $c_Lshapeless_$colon$colon($$x182, new $c_Lshapeless_$colon$colon($$x181, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$28, "category")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels);
    var f = new $c_sjsr_AnonFunction1(((x0$3$2) => {
      var x0$3 = $as_Lreactbuild_model_InvoicePageGroup(x0$3$2);
      if ((x0$3 !== null)) {
        var organization$macro$31 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_organization;
        var supplier$macro$32 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_supplier;
        var date$macro$33 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_date;
        var entryNumber$macro$34 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
        var reference$macro$35 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_reference;
        var pages$macro$36 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_pages;
        var totalAmount$macro$37 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
        var expectedAmount$macro$38 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
        var received$macro$39 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_received;
        var category$macro$40 = $n(x0$3).Lreactbuild_model_InvoicePageGroup__f_category;
        return new $c_Lshapeless_$colon$colon(organization$macro$31, new $c_Lshapeless_$colon$colon(supplier$macro$32, new $c_Lshapeless_$colon$colon(date$macro$33, new $c_Lshapeless_$colon$colon(entryNumber$macro$34, new $c_Lshapeless_$colon$colon(reference$macro$35, new $c_Lshapeless_$colon$colon(pages$macro$36, new $c_Lshapeless_$colon$colon(totalAmount$macro$37, new $c_Lshapeless_$colon$colon(expectedAmount$macro$38, new $c_Lshapeless_$colon$colon(received$macro$39, new $c_Lshapeless_$colon$colon(category$macro$40, $m_Lshapeless_HNil$()))))))))))
      } else {
        throw new $c_s_MatchError(x0$3)
      }
    }));
    var g = new $c_sjsr_AnonFunction1(((x0$4$2) => {
      var x0$4 = $as_Lshapeless_$colon$colon(x0$4$2);
      if ((x0$4 !== null)) {
        var organization$macro$21 = $as_Lreactbuild_common_model_RefTo($n(x0$4).Lshapeless_$colon$colon__f_head);
        var p2 = $as_Lshapeless_$colon$colon($n(x0$4).Lshapeless_$colon$colon__f_tail);
        if ((p2 !== null)) {
          var supplier$macro$22 = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
          var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
          if ((p3 !== null)) {
            var date$macro$23 = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
            var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
            if ((p4 !== null)) {
              var entryNumber$macro$24 = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
              var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
              if ((p5 !== null)) {
                var reference$macro$25 = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
                var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
                if ((p6 !== null)) {
                  var pages$macro$26 = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
                  var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
                  if ((p7 !== null)) {
                    var totalAmount$macro$27 = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                    var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                    if ((p8 !== null)) {
                      var expectedAmount$macro$28 = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                      var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                      if ((p9 !== null)) {
                        var received$macro$29 = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                        var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                        if ((p10 !== null)) {
                          var category$macro$30 = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                          var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                          var x = $m_Lshapeless_HNil$();
                          if ((x === p11)) {
                            return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$21, supplier$macro$22, date$macro$23, entryNumber$macro$24, reference$macro$25, pages$macro$26, totalAmount$macro$27, expectedAmount$macro$28, received$macro$29, category$macro$30)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$4)
    }));
    var gen = new $c_Lshapeless_Generic$$anon$1(f, g);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$31 = $m_s_Symbol$();
    var value0 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$31, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0);
    var zipWithKeys$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys);
    $m_Lshapeless_Witness$();
    var this$34 = $m_s_Symbol$();
    var value0$1 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$34, "received"));
    new $c_Lshapeless_Witness$$anon$1(value0$1);
    var zipWithKeys$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$1);
    $m_Lshapeless_Witness$();
    var this$37 = $m_s_Symbol$();
    var value0$2 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$37, "expectedAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$2);
    var zipWithKeys$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$2);
    $m_Lshapeless_Witness$();
    var this$40 = $m_s_Symbol$();
    var value0$3 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$40, "totalAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$3);
    var zipWithKeys$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$3);
    $m_Lshapeless_Witness$();
    var this$43 = $m_s_Symbol$();
    var value0$4 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$43, "pages"));
    new $c_Lshapeless_Witness$$anon$1(value0$4);
    var zipWithKeys$5 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$4);
    $m_Lshapeless_Witness$();
    var this$46 = $m_s_Symbol$();
    var value0$5 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$46, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$5);
    var zipWithKeys$6 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$5);
    $m_Lshapeless_Witness$();
    var this$49 = $m_s_Symbol$();
    var value0$6 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$49, "entryNumber"));
    new $c_Lshapeless_Witness$$anon$1(value0$6);
    var zipWithKeys$7 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$6);
    $m_Lshapeless_Witness$();
    var this$52 = $m_s_Symbol$();
    var value0$7 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$52, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$7);
    var zipWithKeys$8 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$7);
    $m_Lshapeless_Witness$();
    var this$55 = $m_s_Symbol$();
    var value0$8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$55, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$8);
    var zipWithKeys$9 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$8);
    $m_Lshapeless_Witness$();
    var this$58 = $m_s_Symbol$();
    var value0$9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$58, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$9);
    var zip = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$9);
    var this$61 = $m_s_$less$colon$less$();
    var ev = this$61.s_$less$colon$less$__f_singleton;
    var gen$1 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip, gen, ev);
    $m_Lshapeless_Witness$();
    var this$63 = $m_s_Symbol$();
    var value0$10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$63, "category"));
    var wk = new $c_Lshapeless_Witness$$anon$1(value0$10);
    var tailToMap = new $c_Lshapeless_ops_record_ToMap$$anon$39(wk);
    var keyLub = new $c_Lshapeless_Lub$$anon$4();
    var valueLub = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$68 = $m_s_Symbol$();
    var value0$11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$68, "received"));
    var wk$1 = new $c_Lshapeless_Witness$$anon$1(value0$11);
    var tailToMap$1 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap, keyLub, valueLub, wk$1);
    var keyLub$1 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$1 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$73 = $m_s_Symbol$();
    var value0$12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$73, "expectedAmount"));
    var wk$2 = new $c_Lshapeless_Witness$$anon$1(value0$12);
    var tailToMap$2 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$1, keyLub$1, valueLub$1, wk$2);
    var keyLub$2 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$2 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$78 = $m_s_Symbol$();
    var value0$13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$78, "totalAmount"));
    var wk$3 = new $c_Lshapeless_Witness$$anon$1(value0$13);
    var tailToMap$3 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$2, keyLub$2, valueLub$2, wk$3);
    var keyLub$3 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$3 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$83 = $m_s_Symbol$();
    var value0$14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$83, "pages"));
    var wk$4 = new $c_Lshapeless_Witness$$anon$1(value0$14);
    var tailToMap$4 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$3, keyLub$3, valueLub$3, wk$4);
    var keyLub$4 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$4 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$88 = $m_s_Symbol$();
    var value0$15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$88, "reference"));
    var wk$5 = new $c_Lshapeless_Witness$$anon$1(value0$15);
    var tailToMap$5 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$4, keyLub$4, valueLub$4, wk$5);
    var keyLub$5 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$5 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$93 = $m_s_Symbol$();
    var value0$16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$93, "entryNumber"));
    var wk$6 = new $c_Lshapeless_Witness$$anon$1(value0$16);
    var tailToMap$6 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$5, keyLub$5, valueLub$5, wk$6);
    var keyLub$6 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$6 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$98 = $m_s_Symbol$();
    var value0$17 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$98, "date"));
    var wk$7 = new $c_Lshapeless_Witness$$anon$1(value0$17);
    var tailToMap$7 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$6, keyLub$6, valueLub$6, wk$7);
    var keyLub$7 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$7 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$103 = $m_s_Symbol$();
    var value0$18 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$103, "supplier"));
    var wk$8 = new $c_Lshapeless_Witness$$anon$1(value0$18);
    var tailToMap$8 = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$7, keyLub$7, valueLub$7, wk$8);
    var keyLub$8 = new $c_Lshapeless_Lub$$anon$4();
    var valueLub$8 = new $c_Lshapeless_Lub$$anon$4();
    $m_Lshapeless_Witness$();
    var this$108 = $m_s_Symbol$();
    var value0$19 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$108, "organization"));
    var wk$9 = new $c_Lshapeless_Witness$$anon$1(value0$19);
    var toMap = new $c_Lshapeless_ops_record_ToMap$$anon$40(tailToMap$8, keyLub$8, valueLub$8, wk$9);
    $m_Lshapeless_Witness$();
    var this$111 = $m_s_Symbol$();
    var value0$20 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$111, "organization"));
    var wk$19 = new $c_Lshapeless_Witness$$anon$1(value0$20);
    var tv$9 = $m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo")));
    $m_Lshapeless_Witness$();
    var this$113 = $m_s_Symbol$();
    var value0$21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$113, "supplier"));
    var wk$18 = new $c_Lshapeless_Witness$$anon$1(value0$21);
    var tv$8 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedCaseClassTypeable__jl_Class__ALshapeless_Typeable__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_RefTo.getClassOf(), new ($d_Lshapeless_Typeable.getArrayOf().constr)([$m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_ju_UUID.getClassOf(), new $c_sjsr_AnonFunction0((() => "UUID")))]), new $c_sjsr_AnonFunction0((() => "RefTo"))));
    $m_Lshapeless_Witness$();
    var this$115 = $m_s_Symbol$();
    var value0$22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$115, "date"));
    var wk$17 = new $c_Lshapeless_Witness$$anon$1(value0$22);
    var tv$7 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_common_model_Date.getClassOf(), new $c_sjsr_AnonFunction0((() => "Date"))));
    $m_Lshapeless_Witness$();
    var this$117 = $m_s_Symbol$();
    var value0$23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$117, "entryNumber"));
    var wk$16 = new $c_Lshapeless_Witness$$anon$1(value0$23);
    var tv$6 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().Lshapeless_Typeable$__f_intTypeable);
    $m_Lshapeless_Witness$();
    var this$119 = $m_s_Symbol$();
    var value0$24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$119, "reference"));
    var wk$15 = new $c_Lshapeless_Witness$$anon$1(value0$24);
    var tv$5 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_T.getClassOf(), new $c_sjsr_AnonFunction0((() => "String"))));
    $m_Lshapeless_Witness$();
    var this$121 = $m_s_Symbol$();
    var value0$25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$121, "pages"));
    var wk$14 = new $c_Lshapeless_Witness$$anon$1(value0$25);
    var tv$4 = $m_Lshapeless_Typeable$().genTraversableTypeable__s_reflect_ClassTag__Lshapeless_Typeable__Lshapeless_Typeable(new $c_s_reflect_ClassTag$GenericClassTag($d_sci_Seq.getClassOf()), $m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_InvoicePage.getClassOf(), new $c_sjsr_AnonFunction0((() => "InvoicePage"))));
    $m_Lshapeless_Witness$();
    var this$124 = $m_s_Symbol$();
    var value0$26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$124, "totalAmount"));
    var wk$13 = new $c_Lshapeless_Witness$$anon$1(value0$26);
    var tv$3 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
    $m_Lshapeless_Witness$();
    var this$126 = $m_s_Symbol$();
    var value0$27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$126, "expectedAmount"));
    var wk$12 = new $c_Lshapeless_Witness$$anon$1(value0$27);
    var tv$2 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_Price.getClassOf(), new $c_sjsr_AnonFunction0((() => "Price"))));
    $m_Lshapeless_Witness$();
    var this$128 = $m_s_Symbol$();
    var value0$28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$128, "received"));
    var wk$11 = new $c_Lshapeless_Witness$$anon$1(value0$28);
    var tv$1 = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Ljava_time_Instant.getClassOf(), new $c_sjsr_AnonFunction0((() => "Instant"))));
    $m_Lshapeless_Witness$();
    var this$130 = $m_s_Symbol$();
    var value0$29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$130, "category"));
    var wk$10 = new $c_Lshapeless_Witness$$anon$1(value0$29);
    var tv = $m_Lshapeless_Typeable$().optionTypeable__Lshapeless_Typeable__Lshapeless_Typeable($m_Lshapeless_Typeable$().namedSimpleTypeable__jl_Class__F0__Lshapeless_Typeable($d_Lreactbuild_model_DocumentCategory.getClassOf(), new $c_sjsr_AnonFunction0((() => "DocumentCategory"))));
    var fmt = new $c_Lshapeless_ops_maps$FromMap$$anon$1();
    var fmt$1 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$10, tv, fmt);
    var fmt$2 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$11, tv$1, fmt$1);
    var fmt$3 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$12, tv$2, fmt$2);
    var fmt$4 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$13, tv$3, fmt$3);
    var fmt$5 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$14, tv$4, fmt$4);
    var fmt$6 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$15, tv$5, fmt$5);
    var fmt$7 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$16, tv$6, fmt$6);
    var fmt$8 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$17, tv$7, fmt$7);
    var fmt$9 = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$18, tv$8, fmt$8);
    var fromMap = new $c_Lshapeless_ops_maps$FromMap$$anon$2(wk$19, tv$9, fmt$9);
    var $$x190 = new $c_Lcom_iz2use_react_components_internal_multiview_AsMap$$anon$1(toMap, gen$1, fromMap);
    $m_Lcom_iz2use_react_components_internal_multiview_DefinedViews$();
    var this$474 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$473 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$472 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$471 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$144 = $m_s_Symbol$();
    var $$x85 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$144, "organization"));
    var this$145 = $m_s_Symbol$();
    var $$x84 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$145, "supplier"));
    var this$146 = $m_s_Symbol$();
    var $$x83 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$146, "date"));
    var this$147 = $m_s_Symbol$();
    var $$x82 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$147, "entryNumber"));
    var this$148 = $m_s_Symbol$();
    var $$x81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$148, "reference"));
    var this$149 = $m_s_Symbol$();
    var $$x80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$149, "pages"));
    var this$150 = $m_s_Symbol$();
    var $$x79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$150, "totalAmount"));
    var this$151 = $m_s_Symbol$();
    var $$x78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$151, "expectedAmount"));
    var this$152 = $m_s_Symbol$();
    var $$x77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$152, "received"));
    var this$153 = $m_s_Symbol$();
    var labels$1 = new $c_Lshapeless_$colon$colon($$x85, new $c_Lshapeless_$colon$colon($$x84, new $c_Lshapeless_$colon$colon($$x83, new $c_Lshapeless_$colon$colon($$x82, new $c_Lshapeless_$colon$colon($$x81, new $c_Lshapeless_$colon$colon($$x80, new $c_Lshapeless_$colon$colon($$x79, new $c_Lshapeless_$colon$colon($$x78, new $c_Lshapeless_$colon$colon($$x77, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$153, "category")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$1);
    var f$1 = new $c_sjsr_AnonFunction1(((x0$7$2) => {
      var x0$7 = $as_Lreactbuild_model_InvoicePageGroup(x0$7$2);
      if ((x0$7 !== null)) {
        var organization$macro$71 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_organization;
        var supplier$macro$72 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_supplier;
        var date$macro$73 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_date;
        var entryNumber$macro$74 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
        var reference$macro$75 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_reference;
        var pages$macro$76 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_pages;
        var totalAmount$macro$77 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
        var expectedAmount$macro$78 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
        var received$macro$79 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_received;
        var category$macro$80 = $n(x0$7).Lreactbuild_model_InvoicePageGroup__f_category;
        return new $c_Lshapeless_$colon$colon(organization$macro$71, new $c_Lshapeless_$colon$colon(supplier$macro$72, new $c_Lshapeless_$colon$colon(date$macro$73, new $c_Lshapeless_$colon$colon(entryNumber$macro$74, new $c_Lshapeless_$colon$colon(reference$macro$75, new $c_Lshapeless_$colon$colon(pages$macro$76, new $c_Lshapeless_$colon$colon(totalAmount$macro$77, new $c_Lshapeless_$colon$colon(expectedAmount$macro$78, new $c_Lshapeless_$colon$colon(received$macro$79, new $c_Lshapeless_$colon$colon(category$macro$80, $m_Lshapeless_HNil$()))))))))))
      } else {
        throw new $c_s_MatchError(x0$7)
      }
    }));
    var g$1 = new $c_sjsr_AnonFunction1(((x0$8$2) => {
      var x0$8 = $as_Lshapeless_$colon$colon(x0$8$2);
      if ((x0$8 !== null)) {
        var organization$macro$61 = $as_Lreactbuild_common_model_RefTo($n(x0$8).Lshapeless_$colon$colon__f_head);
        var p2$1 = $as_Lshapeless_$colon$colon($n(x0$8).Lshapeless_$colon$colon__f_tail);
        if ((p2$1 !== null)) {
          var supplier$macro$62 = $as_s_Option($n(p2$1).Lshapeless_$colon$colon__f_head);
          var p3$1 = $as_Lshapeless_$colon$colon($n(p2$1).Lshapeless_$colon$colon__f_tail);
          if ((p3$1 !== null)) {
            var date$macro$63 = $as_s_Option($n(p3$1).Lshapeless_$colon$colon__f_head);
            var p4$1 = $as_Lshapeless_$colon$colon($n(p3$1).Lshapeless_$colon$colon__f_tail);
            if ((p4$1 !== null)) {
              var entryNumber$macro$64 = $as_s_Option($n(p4$1).Lshapeless_$colon$colon__f_head);
              var p5$1 = $as_Lshapeless_$colon$colon($n(p4$1).Lshapeless_$colon$colon__f_tail);
              if ((p5$1 !== null)) {
                var reference$macro$65 = $as_s_Option($n(p5$1).Lshapeless_$colon$colon__f_head);
                var p6$1 = $as_Lshapeless_$colon$colon($n(p5$1).Lshapeless_$colon$colon__f_tail);
                if ((p6$1 !== null)) {
                  var pages$macro$66 = $as_sci_Seq($n(p6$1).Lshapeless_$colon$colon__f_head);
                  var p7$1 = $as_Lshapeless_$colon$colon($n(p6$1).Lshapeless_$colon$colon__f_tail);
                  if ((p7$1 !== null)) {
                    var totalAmount$macro$67 = $as_s_Option($n(p7$1).Lshapeless_$colon$colon__f_head);
                    var p8$1 = $as_Lshapeless_$colon$colon($n(p7$1).Lshapeless_$colon$colon__f_tail);
                    if ((p8$1 !== null)) {
                      var expectedAmount$macro$68 = $as_s_Option($n(p8$1).Lshapeless_$colon$colon__f_head);
                      var p9$1 = $as_Lshapeless_$colon$colon($n(p8$1).Lshapeless_$colon$colon__f_tail);
                      if ((p9$1 !== null)) {
                        var received$macro$69 = $as_s_Option($n(p9$1).Lshapeless_$colon$colon__f_head);
                        var p10$1 = $as_Lshapeless_$colon$colon($n(p9$1).Lshapeless_$colon$colon__f_tail);
                        if ((p10$1 !== null)) {
                          var category$macro$70 = $as_s_Option($n(p10$1).Lshapeless_$colon$colon__f_head);
                          var p11$1 = $as_Lshapeless_HNil($n(p10$1).Lshapeless_$colon$colon__f_tail);
                          var x$2 = $m_Lshapeless_HNil$();
                          if ((x$2 === p11$1)) {
                            return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$61, supplier$macro$62, date$macro$63, entryNumber$macro$64, reference$macro$65, pages$macro$66, totalAmount$macro$67, expectedAmount$macro$68, received$macro$69, category$macro$70)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$8)
    }));
    var gen$2 = new $c_Lshapeless_Generic$$anon$1(f$1, g$1);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$10 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$156 = $m_s_Symbol$();
    var value0$30 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$156, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0$30);
    var zipWithKeys$11 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$10);
    $m_Lshapeless_Witness$();
    var this$159 = $m_s_Symbol$();
    var value0$31 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$159, "received"));
    new $c_Lshapeless_Witness$$anon$1(value0$31);
    var zipWithKeys$12 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$11);
    $m_Lshapeless_Witness$();
    var this$162 = $m_s_Symbol$();
    var value0$32 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$162, "expectedAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$32);
    var zipWithKeys$13 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$12);
    $m_Lshapeless_Witness$();
    var this$165 = $m_s_Symbol$();
    var value0$33 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$165, "totalAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$33);
    var zipWithKeys$14 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$13);
    $m_Lshapeless_Witness$();
    var this$168 = $m_s_Symbol$();
    var value0$34 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$168, "pages"));
    new $c_Lshapeless_Witness$$anon$1(value0$34);
    var zipWithKeys$15 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$14);
    $m_Lshapeless_Witness$();
    var this$171 = $m_s_Symbol$();
    var value0$35 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$171, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$35);
    var zipWithKeys$16 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$15);
    $m_Lshapeless_Witness$();
    var this$174 = $m_s_Symbol$();
    var value0$36 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$174, "entryNumber"));
    new $c_Lshapeless_Witness$$anon$1(value0$36);
    var zipWithKeys$17 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$16);
    $m_Lshapeless_Witness$();
    var this$177 = $m_s_Symbol$();
    var value0$37 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$177, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$37);
    var zipWithKeys$18 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$17);
    $m_Lshapeless_Witness$();
    var this$180 = $m_s_Symbol$();
    var value0$38 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$180, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$38);
    var zipWithKeys$19 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$18);
    $m_Lshapeless_Witness$();
    var this$183 = $m_s_Symbol$();
    var value0$39 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$183, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$39);
    var zip$1 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$19);
    var this$186 = $m_s_$less$colon$less$();
    var ev$1 = this$186.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$1, gen$2, ev$1);
    var this$304 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$188 = $m_s_Symbol$();
    var value0$40 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$188, "organization"));
    var witness$9 = new $c_Lshapeless_Witness$$anon$1(value0$40);
    var $$x89 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var this$190 = $m_Lreactbuild_model_Implicits$();
    var format = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$190);
    var $$x88 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format);
    var this$193 = $m_Lreactbuild_model_Implicits$();
    var this$192 = $m_Lreactbuild_model_Implicits$();
    var ev$2 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$192, proxy);
    var $$x87 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$193, ev$2)));
    var $$x86 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$195 = $m_Lreactbuild_model_Implicits$();
    var textualizable = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$195, proxy);
    var fieldRenderable$9 = $n($$x89).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x88, $$x87, $$x86, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$303 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$197 = $m_s_Symbol$();
    var value0$41 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$197, "supplier"));
    var witness$8 = new $c_Lshapeless_Witness$$anon$1(value0$41);
    var $$x93 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var this$199 = $m_Lreactbuild_model_Implicits$();
    var format$1 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$199);
    var format$2 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$1);
    var $$x92 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$2);
    var this$203 = $m_Lreactbuild_model_Implicits$();
    var this$202 = $m_Lreactbuild_model_Implicits$();
    var ev$3 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$202, proxy);
    var ord = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$203, ev$3);
    var $$x91 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord)));
    var $$x90 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$206 = $m_Lreactbuild_model_Implicits$();
    var textualizable$1 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$206, proxy);
    var textualizable$2 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$1);
    var fieldRenderable$8 = $n($$x93).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x92, $$x91, $$x90, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$2), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$302 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$209 = $m_s_Symbol$();
    var value0$42 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$209, "date"));
    var witness$7 = new $c_Lshapeless_Witness$$anon$1(value0$42);
    var $$x97 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
    var format$4 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$3);
    var $$x96 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$4);
    var ord$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
    var $$x95 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$1)));
    var $$x94 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
    var textualizable$4 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$3);
    var fieldRenderable$7 = $n($$x97).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x96, $$x95, $$x94, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$4), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$301 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$217 = $m_s_Symbol$();
    var value0$43 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$217, "entryNumber"));
    var witness$6 = new $c_Lshapeless_Witness$$anon$1(value0$43);
    var $$x102 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$5 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
    var format$6 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$5);
    var $$x101 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$6);
    var ord$2 = $m_s_math_Ordering$Int$();
    var $$x100 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$2)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$4);
    var optioner = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var resolver = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    var $$x99 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner, resolver);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var textualizable$5 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$1);
    var $$x98 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$5);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$5 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var fieldRenderable$6 = $n($$x102).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x101, $$x100, $$x99, $$x98, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$5))));
    var this$300 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$230 = $m_s_Symbol$();
    var value0$44 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$230, "reference"));
    var witness$5 = new $c_Lshapeless_Witness$$anon$1(value0$44);
    var $$x107 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$7 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$8 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$7);
    var $$x106 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$8);
    var ord$3 = $m_s_math_Ordering$String$();
    var $$x105 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$3)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$6 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$6);
    var evDefault = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$7 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$1 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$7);
    var resolver$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    var $$x104 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$1, resolver$1);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$6 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$3);
    var $$x103 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$6);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$5 = $n($$x107).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x106, $$x105, $$x104, $$x103, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$8))));
    var this$299 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$245 = $m_s_Symbol$();
    var value0$45 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$245, "pages"));
    var witness$4 = new $c_Lshapeless_Witness$$anon$1(value0$45);
    var $$x111 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsFormat;
    var $$x110 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$9);
    var $$x109 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsSeqOrdering));
    var $$x108 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$249 = $m_Lreactbuild_model_Implicits$();
    new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var fieldRenderable$4 = $n($$x111).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x110, $$x109, $$x108, new $c_Lreactbuild_model_LowPriorityImplicits$$anon$14(this$249), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$298 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$250 = $m_s_Symbol$();
    var value0$46 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$250, "totalAmount"));
    var witness$3 = new $c_Lshapeless_Witness$$anon$1(value0$46);
    var $$x116 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$10 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
    var format$11 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$10);
    var $$x115 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$11);
    var ord$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
    var $$x114 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$4)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$9);
    var optioner$2 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$2 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var resolver$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
    var $$x113 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$2, resolver$2);
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var textualizable$8 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$7);
    var $$x112 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$8);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$10 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var fieldRenderable$3 = $n($$x116).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x115, $$x114, $$x113, $$x112, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$10))));
    var this$297 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$262 = $m_s_Symbol$();
    var value0$47 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$262, "expectedAmount"));
    var witness$2 = new $c_Lshapeless_Witness$$anon$1(value0$47);
    var $$x121 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
    var format$13 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$12);
    var $$x120 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$13);
    var ord$5 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
    var $$x119 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$5)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$11);
    var optioner$3 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$3 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var resolver$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
    var $$x118 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$3, resolver$3);
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var textualizable$10 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$9);
    var $$x117 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$10);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var fieldRenderable$2 = $n($$x121).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x120, $$x119, $$x118, $$x117, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$12))));
    var this$296 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$274 = $m_s_Symbol$();
    var value0$48 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$274, "received"));
    var witness$1 = new $c_Lshapeless_Witness$$anon$1(value0$48);
    var $$x125 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$14 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
    var format$15 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$14);
    var $$x124 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$15);
    var ord$6 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
    var $$x123 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$6)));
    var $$x122 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$280 = $m_Lreactbuild_model_Implicits$();
    var locale = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$11 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$280, locale);
    var textualizable$12 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$11);
    var fieldRenderable$1 = $n($$x125).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x124, $$x123, $$x122, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$12), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    var this$295 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$();
    $m_Lshapeless_Witness$();
    var this$283 = $m_s_Symbol$();
    var value0$49 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$283, "category"));
    var witness = new $c_Lshapeless_Witness$$anon$1(value0$49);
    var $$x130 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$16 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
    var format$17 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$16);
    var $$x129 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$17);
    var ord$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
    var $$x128 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$7)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$13);
    var optioner$4 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var resolver$4 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
    var $$x127 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$4, resolver$4);
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    var textualizable$14 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$13);
    var $$x126 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$14);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$14 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    var fieldRenderable = $n($$x130).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x129, $$x128, $$x127, $$x126, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$14))));
    var tail = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRenderer$$anon$4();
    var tail$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$295, fieldRenderable, witness, tail);
    var tail$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$296, fieldRenderable$1, witness$1, tail$1);
    var tail$3 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$297, fieldRenderable$2, witness$2, tail$2);
    var tail$4 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$298, fieldRenderable$3, witness$3, tail$3);
    var tail$5 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$299, fieldRenderable$4, witness$4, tail$4);
    var tail$6 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$300, fieldRenderable$5, witness$5, tail$5);
    var tail$7 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$301, fieldRenderable$6, witness$6, tail$6);
    var tail$8 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$302, fieldRenderable$7, witness$7, tail$7);
    var tail$9 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$303, fieldRenderable$8, witness$8, tail$8);
    var renderer = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingListRendererMidPriorityImplicits$$anon$3(this$304, fieldRenderable$9, witness$9, tail$9);
    $m_s_DummyImplicit$();
    new $c_Lshapeless_Refute$$anon$2();
    var view$1 = new $c_Lcom_iz2use_react_components_internal_multiview_ListRenderer$$anon$1(renderer);
    var this$469 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$468 = $m_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$();
    var this$307 = $m_s_Symbol$();
    var $$x139 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$307, "organization"));
    var this$308 = $m_s_Symbol$();
    var $$x138 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$308, "supplier"));
    var this$309 = $m_s_Symbol$();
    var $$x137 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$309, "date"));
    var this$310 = $m_s_Symbol$();
    var $$x136 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$310, "entryNumber"));
    var this$311 = $m_s_Symbol$();
    var $$x135 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$311, "reference"));
    var this$312 = $m_s_Symbol$();
    var $$x134 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$312, "pages"));
    var this$313 = $m_s_Symbol$();
    var $$x133 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$313, "totalAmount"));
    var this$314 = $m_s_Symbol$();
    var $$x132 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$314, "expectedAmount"));
    var this$315 = $m_s_Symbol$();
    var $$x131 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$315, "received"));
    var this$316 = $m_s_Symbol$();
    var labels$2 = new $c_Lshapeless_$colon$colon($$x139, new $c_Lshapeless_$colon$colon($$x138, new $c_Lshapeless_$colon$colon($$x137, new $c_Lshapeless_$colon$colon($$x136, new $c_Lshapeless_$colon$colon($$x135, new $c_Lshapeless_$colon$colon($$x134, new $c_Lshapeless_$colon$colon($$x133, new $c_Lshapeless_$colon$colon($$x132, new $c_Lshapeless_$colon$colon($$x131, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$316, "category")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$2);
    var f$2 = new $c_sjsr_AnonFunction1(((x0$11$2) => {
      var x0$11 = $as_Lreactbuild_model_InvoicePageGroup(x0$11$2);
      if ((x0$11 !== null)) {
        var organization$macro$111 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_organization;
        var supplier$macro$112 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_supplier;
        var date$macro$113 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_date;
        var entryNumber$macro$114 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
        var reference$macro$115 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_reference;
        var pages$macro$116 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_pages;
        var totalAmount$macro$117 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
        var expectedAmount$macro$118 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
        var received$macro$119 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_received;
        var category$macro$120 = $n(x0$11).Lreactbuild_model_InvoicePageGroup__f_category;
        return new $c_Lshapeless_$colon$colon(organization$macro$111, new $c_Lshapeless_$colon$colon(supplier$macro$112, new $c_Lshapeless_$colon$colon(date$macro$113, new $c_Lshapeless_$colon$colon(entryNumber$macro$114, new $c_Lshapeless_$colon$colon(reference$macro$115, new $c_Lshapeless_$colon$colon(pages$macro$116, new $c_Lshapeless_$colon$colon(totalAmount$macro$117, new $c_Lshapeless_$colon$colon(expectedAmount$macro$118, new $c_Lshapeless_$colon$colon(received$macro$119, new $c_Lshapeless_$colon$colon(category$macro$120, $m_Lshapeless_HNil$()))))))))))
      } else {
        throw new $c_s_MatchError(x0$11)
      }
    }));
    var g$2 = new $c_sjsr_AnonFunction1(((x0$12$2) => {
      var x0$12 = $as_Lshapeless_$colon$colon(x0$12$2);
      if ((x0$12 !== null)) {
        var organization$macro$101 = $as_Lreactbuild_common_model_RefTo($n(x0$12).Lshapeless_$colon$colon__f_head);
        var p2$2 = $as_Lshapeless_$colon$colon($n(x0$12).Lshapeless_$colon$colon__f_tail);
        if ((p2$2 !== null)) {
          var supplier$macro$102 = $as_s_Option($n(p2$2).Lshapeless_$colon$colon__f_head);
          var p3$2 = $as_Lshapeless_$colon$colon($n(p2$2).Lshapeless_$colon$colon__f_tail);
          if ((p3$2 !== null)) {
            var date$macro$103 = $as_s_Option($n(p3$2).Lshapeless_$colon$colon__f_head);
            var p4$2 = $as_Lshapeless_$colon$colon($n(p3$2).Lshapeless_$colon$colon__f_tail);
            if ((p4$2 !== null)) {
              var entryNumber$macro$104 = $as_s_Option($n(p4$2).Lshapeless_$colon$colon__f_head);
              var p5$2 = $as_Lshapeless_$colon$colon($n(p4$2).Lshapeless_$colon$colon__f_tail);
              if ((p5$2 !== null)) {
                var reference$macro$105 = $as_s_Option($n(p5$2).Lshapeless_$colon$colon__f_head);
                var p6$2 = $as_Lshapeless_$colon$colon($n(p5$2).Lshapeless_$colon$colon__f_tail);
                if ((p6$2 !== null)) {
                  var pages$macro$106 = $as_sci_Seq($n(p6$2).Lshapeless_$colon$colon__f_head);
                  var p7$2 = $as_Lshapeless_$colon$colon($n(p6$2).Lshapeless_$colon$colon__f_tail);
                  if ((p7$2 !== null)) {
                    var totalAmount$macro$107 = $as_s_Option($n(p7$2).Lshapeless_$colon$colon__f_head);
                    var p8$2 = $as_Lshapeless_$colon$colon($n(p7$2).Lshapeless_$colon$colon__f_tail);
                    if ((p8$2 !== null)) {
                      var expectedAmount$macro$108 = $as_s_Option($n(p8$2).Lshapeless_$colon$colon__f_head);
                      var p9$2 = $as_Lshapeless_$colon$colon($n(p8$2).Lshapeless_$colon$colon__f_tail);
                      if ((p9$2 !== null)) {
                        var received$macro$109 = $as_s_Option($n(p9$2).Lshapeless_$colon$colon__f_head);
                        var p10$2 = $as_Lshapeless_$colon$colon($n(p9$2).Lshapeless_$colon$colon__f_tail);
                        if ((p10$2 !== null)) {
                          var category$macro$110 = $as_s_Option($n(p10$2).Lshapeless_$colon$colon__f_head);
                          var p11$2 = $as_Lshapeless_HNil($n(p10$2).Lshapeless_$colon$colon__f_tail);
                          var x$3 = $m_Lshapeless_HNil$();
                          if ((x$3 === p11$2)) {
                            return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$101, supplier$macro$102, date$macro$103, entryNumber$macro$104, reference$macro$105, pages$macro$106, totalAmount$macro$107, expectedAmount$macro$108, received$macro$109, category$macro$110)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$12)
    }));
    var gen$4 = new $c_Lshapeless_Generic$$anon$1(f$2, g$2);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$20 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$319 = $m_s_Symbol$();
    var value0$50 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$319, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0$50);
    var zipWithKeys$21 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$20);
    $m_Lshapeless_Witness$();
    var this$322 = $m_s_Symbol$();
    var value0$51 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$322, "received"));
    new $c_Lshapeless_Witness$$anon$1(value0$51);
    var zipWithKeys$22 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$21);
    $m_Lshapeless_Witness$();
    var this$325 = $m_s_Symbol$();
    var value0$52 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$325, "expectedAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$52);
    var zipWithKeys$23 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$22);
    $m_Lshapeless_Witness$();
    var this$328 = $m_s_Symbol$();
    var value0$53 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$328, "totalAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$53);
    var zipWithKeys$24 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$23);
    $m_Lshapeless_Witness$();
    var this$331 = $m_s_Symbol$();
    var value0$54 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$331, "pages"));
    new $c_Lshapeless_Witness$$anon$1(value0$54);
    var zipWithKeys$25 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$24);
    $m_Lshapeless_Witness$();
    var this$334 = $m_s_Symbol$();
    var value0$55 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$334, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$55);
    var zipWithKeys$26 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$25);
    $m_Lshapeless_Witness$();
    var this$337 = $m_s_Symbol$();
    var value0$56 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$337, "entryNumber"));
    new $c_Lshapeless_Witness$$anon$1(value0$56);
    var zipWithKeys$27 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$26);
    $m_Lshapeless_Witness$();
    var this$340 = $m_s_Symbol$();
    var value0$57 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$340, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$57);
    var zipWithKeys$28 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$27);
    $m_Lshapeless_Witness$();
    var this$343 = $m_s_Symbol$();
    var value0$58 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$343, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$58);
    var zipWithKeys$29 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$28);
    $m_Lshapeless_Witness$();
    var this$346 = $m_s_Symbol$();
    var value0$59 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$346, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$59);
    var zip$2 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$29);
    var this$349 = $m_s_$less$colon$less$();
    var ev$15 = this$349.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$2, gen$4, ev$15);
    var this$462 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$351 = $m_s_Symbol$();
    var value0$60 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$351, "organization"));
    var witness$19 = new $c_Lshapeless_Witness$$anon$1(value0$60);
    var $$x143 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    var this$353 = $m_Lreactbuild_model_Implicits$();
    var format$18 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$353);
    var $$x142 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$18);
    var this$356 = $m_Lreactbuild_model_Implicits$();
    var this$355 = $m_Lreactbuild_model_Implicits$();
    var ev$16 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$355, proxy);
    var $$x141 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$356, ev$16)));
    var $$x140 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$358 = $m_Lreactbuild_model_Implicits$();
    var textualizable$15 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$358, proxy);
    var columnRenderable$9 = $n($$x143).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x142, $$x141, $$x140, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$15));
    var this$461 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$360 = $m_s_Symbol$();
    var value0$61 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$360, "supplier"));
    var witness$18 = new $c_Lshapeless_Witness$$anon$1(value0$61);
    var $$x147 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var this$362 = $m_Lreactbuild_model_Implicits$();
    var format$19 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$362);
    var format$20 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$19);
    var $$x146 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$20);
    var this$366 = $m_Lreactbuild_model_Implicits$();
    var this$365 = $m_Lreactbuild_model_Implicits$();
    var ev$17 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$365, proxy);
    var ord$8 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$366, ev$17);
    var $$x145 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$8)));
    var $$x144 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$369 = $m_Lreactbuild_model_Implicits$();
    var textualizable$16 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$369, proxy);
    var textualizable$17 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$16);
    var columnRenderable$8 = $n($$x147).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x146, $$x145, $$x144, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$17));
    var this$460 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$372 = $m_s_Symbol$();
    var value0$62 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$372, "date"));
    var witness$17 = new $c_Lshapeless_Witness$$anon$1(value0$62);
    var $$x151 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$21 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
    var format$22 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$21);
    var $$x150 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$22);
    var ord$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
    var $$x149 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$9)));
    var $$x148 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$18 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
    var textualizable$19 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$18);
    var columnRenderable$7 = $n($$x151).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x150, $$x149, $$x148, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$19));
    var this$459 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$380 = $m_s_Symbol$();
    var value0$63 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$380, "entryNumber"));
    var witness$16 = new $c_Lshapeless_Witness$$anon$1(value0$63);
    var $$x155 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$23 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
    var format$24 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$23);
    var $$x154 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$24);
    var ord$10 = $m_s_math_Ordering$Int$();
    var $$x153 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$10)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$18 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$18);
    var optioner$5 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var resolver$5 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
    var $$x152 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$5, resolver$5);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var textualizable$20 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$8);
    var columnRenderable$6 = $n($$x155).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x154, $$x153, $$x152, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$20));
    var this$458 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$392 = $m_s_Symbol$();
    var value0$64 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$392, "reference"));
    var witness$15 = new $c_Lshapeless_Witness$$anon$1(value0$64);
    var $$x159 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$25 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$26 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$25);
    var $$x158 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$26);
    var ord$11 = $m_s_math_Ordering$String$();
    var $$x157 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$11)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$19 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$19);
    var evDefault$1 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$6 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$20 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$5 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$20);
    var resolver$6 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$5);
    var $$x156 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$6, resolver$6);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$10 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$21 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$10);
    var columnRenderable$5 = $n($$x159).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x158, $$x157, $$x156, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$21));
    var this$457 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$406 = $m_s_Symbol$();
    var value0$65 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$406, "pages"));
    var witness$14 = new $c_Lshapeless_Witness$$anon$1(value0$65);
    var $$x163 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    var format$27 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsFormat;
    var $$x162 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$27);
    var $$x161 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsSeqOrdering));
    var $$x160 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$410 = $m_Lreactbuild_model_Implicits$();
    new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var columnRenderable$4 = $n($$x163).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x162, $$x161, $$x160, new $c_Lreactbuild_model_LowPriorityImplicits$$anon$14(this$410));
    var this$456 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$411 = $m_s_Symbol$();
    var value0$66 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$411, "totalAmount"));
    var witness$13 = new $c_Lshapeless_Witness$$anon$1(value0$66);
    var $$x167 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$28 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
    var format$29 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$28);
    var $$x166 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$29);
    var ord$12 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
    var $$x165 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$12)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$21 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$21);
    var optioner$7 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$6 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var resolver$7 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$6);
    var $$x164 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$7, resolver$7);
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$22 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var textualizable$23 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$22);
    var columnRenderable$3 = $n($$x167).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x166, $$x165, $$x164, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$23));
    var this$455 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$422 = $m_s_Symbol$();
    var value0$67 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$422, "expectedAmount"));
    var witness$12 = new $c_Lshapeless_Witness$$anon$1(value0$67);
    var $$x171 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$30 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
    var format$31 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$30);
    var $$x170 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$31);
    var ord$13 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
    var $$x169 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$13)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$22 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$22);
    var optioner$8 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$7 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var resolver$8 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$7);
    var $$x168 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$8, resolver$8);
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$24 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var textualizable$25 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$24);
    var columnRenderable$2 = $n($$x171).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x170, $$x169, $$x168, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$25));
    var this$454 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$433 = $m_s_Symbol$();
    var value0$68 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$433, "received"));
    var witness$11 = new $c_Lshapeless_Witness$$anon$1(value0$68);
    var $$x175 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$32 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
    var format$33 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$32);
    var $$x174 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$33);
    var ord$14 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
    var $$x173 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$14)));
    var $$x172 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$439 = $m_Lreactbuild_model_Implicits$();
    var locale$1 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$26 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$439, locale$1);
    var textualizable$27 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$26);
    var columnRenderable$1 = $n($$x175).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x174, $$x173, $$x172, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$27));
    var this$453 = $m_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$();
    $m_Lshapeless_Witness$();
    var this$442 = $m_s_Symbol$();
    var value0$69 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$442, "category"));
    var witness$10 = new $c_Lshapeless_Witness$$anon$1(value0$69);
    var $$x179 = $m_Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$34 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
    var format$35 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$34);
    var $$x178 = new $c_Lcom_iz2use_react_components_internal_multiview_table_ProxyColumnFormat(format$35);
    var ord$15 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
    var $$x177 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$15)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$23 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$23);
    var optioner$9 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var resolver$9 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
    var $$x176 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$9, resolver$9);
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$28 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    var textualizable$29 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$28);
    var columnRenderable = $n($$x179).of__Lcom_iz2use_react_components_internal_multiview_table_ColumnFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_react_components_internal_multiview_table_ColumnRenderable($$x178, $$x177, $$x176, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$29));
    var tail$10 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRenderer$$anon$8();
    var tail$11 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$453, columnRenderable, witness$10, tail$10);
    var tail$12 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$454, columnRenderable$1, witness$11, tail$11);
    var tail$13 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$455, columnRenderable$2, witness$12, tail$12);
    var tail$14 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$456, columnRenderable$3, witness$13, tail$13);
    var tail$15 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$457, columnRenderable$4, witness$14, tail$14);
    var tail$16 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$458, columnRenderable$5, witness$15, tail$15);
    var tail$17 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$459, columnRenderable$6, witness$16, tail$16);
    var tail$18 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$460, columnRenderable$7, witness$17, tail$17);
    var tail$19 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$461, columnRenderable$8, witness$18, tail$18);
    var renderer$1 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingTableRendererMidPriorityImplicits$$anon$7(this$462, columnRenderable$9, witness$19, tail$19);
    $m_s_DummyImplicit$();
    new $c_Lshapeless_Refute$$anon$2();
    var columnFragment = new $c_Lcom_iz2use_react_components_internal_multiview_ColumnFragment$$anon$3(renderer$1);
    var view = new $c_Lcom_iz2use_react_components_internal_multiview_TableRenderer$$anon$2(columnFragment);
    var tail$20 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$2();
    var tail$21 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view, tail$20);
    var tail$22 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$468, tail$21);
    var tail$23 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$469, tail$22);
    var tail$24 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializer$$anon$3(view$1, tail$23);
    var tail$25 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$471, tail$24);
    var tail$26 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$472, tail$25);
    var tail$27 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$473, tail$26);
    var mat = new $c_Lcom_iz2use_react_components_internal_multiview_HasViewMaterializerLowPriorityImplicits$$anon$1(this$474, tail$27);
    $m_s_DummyImplicit$();
    new $c_Lshapeless_Refute$$anon$2();
    var $$x180 = new $c_Lcom_iz2use_react_components_internal_multiview_HasViews(mat.apply__sci_List());
    var $$x76 = $m_Lcom_iz2use_react_components_internal_multiview_HasIterator$().Lcom_iz2use_react_components_internal_multiview_HasIterator$__f_listIterable;
    var this$477 = $m_s_Symbol$();
    var $$x29 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$477, "organization"));
    var this$478 = $m_s_Symbol$();
    var $$x28 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$478, "supplier"));
    var this$479 = $m_s_Symbol$();
    var $$x27 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$479, "date"));
    var this$480 = $m_s_Symbol$();
    var $$x26 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$480, "entryNumber"));
    var this$481 = $m_s_Symbol$();
    var $$x25 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$481, "reference"));
    var this$482 = $m_s_Symbol$();
    var $$x24 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$482, "pages"));
    var this$483 = $m_s_Symbol$();
    var $$x23 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$483, "totalAmount"));
    var this$484 = $m_s_Symbol$();
    var $$x22 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$484, "expectedAmount"));
    var this$485 = $m_s_Symbol$();
    var $$x21 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$485, "received"));
    var this$486 = $m_s_Symbol$();
    var labels$3 = new $c_Lshapeless_$colon$colon($$x29, new $c_Lshapeless_$colon$colon($$x28, new $c_Lshapeless_$colon$colon($$x27, new $c_Lshapeless_$colon$colon($$x26, new $c_Lshapeless_$colon$colon($$x25, new $c_Lshapeless_$colon$colon($$x24, new $c_Lshapeless_$colon$colon($$x23, new $c_Lshapeless_$colon$colon($$x22, new $c_Lshapeless_$colon$colon($$x21, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$486, "category")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$3);
    var f$3 = new $c_sjsr_AnonFunction1(((x0$15$2) => {
      var x0$15 = $as_Lreactbuild_model_InvoicePageGroup(x0$15$2);
      if ((x0$15 !== null)) {
        var organization$macro$151 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_organization;
        var supplier$macro$152 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_supplier;
        var date$macro$153 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_date;
        var entryNumber$macro$154 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
        var reference$macro$155 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_reference;
        var pages$macro$156 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_pages;
        var totalAmount$macro$157 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
        var expectedAmount$macro$158 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
        var received$macro$159 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_received;
        var category$macro$160 = $n(x0$15).Lreactbuild_model_InvoicePageGroup__f_category;
        return new $c_Lshapeless_$colon$colon(organization$macro$151, new $c_Lshapeless_$colon$colon(supplier$macro$152, new $c_Lshapeless_$colon$colon(date$macro$153, new $c_Lshapeless_$colon$colon(entryNumber$macro$154, new $c_Lshapeless_$colon$colon(reference$macro$155, new $c_Lshapeless_$colon$colon(pages$macro$156, new $c_Lshapeless_$colon$colon(totalAmount$macro$157, new $c_Lshapeless_$colon$colon(expectedAmount$macro$158, new $c_Lshapeless_$colon$colon(received$macro$159, new $c_Lshapeless_$colon$colon(category$macro$160, $m_Lshapeless_HNil$()))))))))))
      } else {
        throw new $c_s_MatchError(x0$15)
      }
    }));
    var g$3 = new $c_sjsr_AnonFunction1(((x0$16$2) => {
      var x0$16 = $as_Lshapeless_$colon$colon(x0$16$2);
      if ((x0$16 !== null)) {
        var organization$macro$141 = $as_Lreactbuild_common_model_RefTo($n(x0$16).Lshapeless_$colon$colon__f_head);
        var p2$3 = $as_Lshapeless_$colon$colon($n(x0$16).Lshapeless_$colon$colon__f_tail);
        if ((p2$3 !== null)) {
          var supplier$macro$142 = $as_s_Option($n(p2$3).Lshapeless_$colon$colon__f_head);
          var p3$3 = $as_Lshapeless_$colon$colon($n(p2$3).Lshapeless_$colon$colon__f_tail);
          if ((p3$3 !== null)) {
            var date$macro$143 = $as_s_Option($n(p3$3).Lshapeless_$colon$colon__f_head);
            var p4$3 = $as_Lshapeless_$colon$colon($n(p3$3).Lshapeless_$colon$colon__f_tail);
            if ((p4$3 !== null)) {
              var entryNumber$macro$144 = $as_s_Option($n(p4$3).Lshapeless_$colon$colon__f_head);
              var p5$3 = $as_Lshapeless_$colon$colon($n(p4$3).Lshapeless_$colon$colon__f_tail);
              if ((p5$3 !== null)) {
                var reference$macro$145 = $as_s_Option($n(p5$3).Lshapeless_$colon$colon__f_head);
                var p6$3 = $as_Lshapeless_$colon$colon($n(p5$3).Lshapeless_$colon$colon__f_tail);
                if ((p6$3 !== null)) {
                  var pages$macro$146 = $as_sci_Seq($n(p6$3).Lshapeless_$colon$colon__f_head);
                  var p7$3 = $as_Lshapeless_$colon$colon($n(p6$3).Lshapeless_$colon$colon__f_tail);
                  if ((p7$3 !== null)) {
                    var totalAmount$macro$147 = $as_s_Option($n(p7$3).Lshapeless_$colon$colon__f_head);
                    var p8$3 = $as_Lshapeless_$colon$colon($n(p7$3).Lshapeless_$colon$colon__f_tail);
                    if ((p8$3 !== null)) {
                      var expectedAmount$macro$148 = $as_s_Option($n(p8$3).Lshapeless_$colon$colon__f_head);
                      var p9$3 = $as_Lshapeless_$colon$colon($n(p8$3).Lshapeless_$colon$colon__f_tail);
                      if ((p9$3 !== null)) {
                        var received$macro$149 = $as_s_Option($n(p9$3).Lshapeless_$colon$colon__f_head);
                        var p10$3 = $as_Lshapeless_$colon$colon($n(p9$3).Lshapeless_$colon$colon__f_tail);
                        if ((p10$3 !== null)) {
                          var category$macro$150 = $as_s_Option($n(p10$3).Lshapeless_$colon$colon__f_head);
                          var p11$3 = $as_Lshapeless_HNil($n(p10$3).Lshapeless_$colon$colon__f_tail);
                          var x$4 = $m_Lshapeless_HNil$();
                          if ((x$4 === p11$3)) {
                            return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$141, supplier$macro$142, date$macro$143, entryNumber$macro$144, reference$macro$145, pages$macro$146, totalAmount$macro$147, expectedAmount$macro$148, received$macro$149, category$macro$150)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$16)
    }));
    var gen$6 = new $c_Lshapeless_Generic$$anon$1(f$3, g$3);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$30 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$489 = $m_s_Symbol$();
    var value0$70 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$489, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0$70);
    var zipWithKeys$31 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$30);
    $m_Lshapeless_Witness$();
    var this$492 = $m_s_Symbol$();
    var value0$71 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$492, "received"));
    new $c_Lshapeless_Witness$$anon$1(value0$71);
    var zipWithKeys$32 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$31);
    $m_Lshapeless_Witness$();
    var this$495 = $m_s_Symbol$();
    var value0$72 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$495, "expectedAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$72);
    var zipWithKeys$33 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$32);
    $m_Lshapeless_Witness$();
    var this$498 = $m_s_Symbol$();
    var value0$73 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$498, "totalAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$73);
    var zipWithKeys$34 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$33);
    $m_Lshapeless_Witness$();
    var this$501 = $m_s_Symbol$();
    var value0$74 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$501, "pages"));
    new $c_Lshapeless_Witness$$anon$1(value0$74);
    var zipWithKeys$35 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$34);
    $m_Lshapeless_Witness$();
    var this$504 = $m_s_Symbol$();
    var value0$75 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$504, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$75);
    var zipWithKeys$36 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$35);
    $m_Lshapeless_Witness$();
    var this$507 = $m_s_Symbol$();
    var value0$76 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$507, "entryNumber"));
    new $c_Lshapeless_Witness$$anon$1(value0$76);
    var zipWithKeys$37 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$36);
    $m_Lshapeless_Witness$();
    var this$510 = $m_s_Symbol$();
    var value0$77 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$510, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$77);
    var zipWithKeys$38 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$37);
    $m_Lshapeless_Witness$();
    var this$513 = $m_s_Symbol$();
    var value0$78 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$513, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$78);
    var zipWithKeys$39 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$38);
    $m_Lshapeless_Witness$();
    var this$516 = $m_s_Symbol$();
    var value0$79 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$516, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$79);
    var zip$3 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$39);
    var this$519 = $m_s_$less$colon$less$();
    var ev$24 = this$519.s_$less$colon$less$__f_singleton;
    new $c_Lshapeless_LabelledGeneric$$anon$2(zip$3, gen$6, ev$24);
    $m_Lshapeless_Witness$();
    var this$521 = $m_s_Symbol$();
    var value0$80 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$521, "organization"));
    var witness$29 = new $c_Lshapeless_Witness$$anon$1(value0$80);
    var $$x33 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var this$523 = $m_Lreactbuild_model_Implicits$();
    var format$36 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$523);
    var $$x32 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$36);
    var this$526 = $m_Lreactbuild_model_Implicits$();
    var this$525 = $m_Lreactbuild_model_Implicits$();
    var ev$25 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$525, proxy);
    var $$x31 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$526, ev$25)));
    var $$x30 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$528 = $m_Lreactbuild_model_Implicits$();
    var textualizable$30 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$528, proxy);
    var fieldRenderable$19 = $n($$x33).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x32, $$x31, $$x30, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$30), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    $m_Lshapeless_Witness$();
    var this$530 = $m_s_Symbol$();
    var value0$81 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$530, "supplier"));
    var witness$28 = new $c_Lshapeless_Witness$$anon$1(value0$81);
    var $$x37 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var this$532 = $m_Lreactbuild_model_Implicits$();
    var format$37 = $f_Lreactbuild_model_LowPriorityImplicits__refToFormat__Lcom_iz2use_react_components_internal_multiview_Format(this$532);
    var format$38 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$37);
    var $$x36 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$38);
    var this$536 = $m_Lreactbuild_model_Implicits$();
    var this$535 = $m_Lreactbuild_model_Implicits$();
    var ev$26 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$535, proxy);
    var ord$16 = $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$536, ev$26);
    var $$x35 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$16)));
    var $$x34 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$539 = $m_Lreactbuild_model_Implicits$();
    var textualizable$31 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$539, proxy);
    var textualizable$32 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$31);
    var fieldRenderable$18 = $n($$x37).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x36, $$x35, $$x34, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$32), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    $m_Lshapeless_Witness$();
    var this$542 = $m_s_Symbol$();
    var value0$82 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$542, "date"));
    var witness$27 = new $c_Lshapeless_Witness$$anon$1(value0$82);
    var $$x41 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$39 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateFormat;
    var format$40 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$39);
    var $$x40 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$40);
    var ord$17 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateOrdering;
    var $$x39 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$17)));
    var $$x38 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$33 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
    var textualizable$34 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$33);
    var fieldRenderable$17 = $n($$x41).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x40, $$x39, $$x38, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$34), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    $m_Lshapeless_Witness$();
    var this$550 = $m_s_Symbol$();
    var value0$83 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$550, "entryNumber"));
    var witness$26 = new $c_Lshapeless_Witness$$anon$1(value0$83);
    var $$x46 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$41 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_integer;
    var format$42 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$41);
    var $$x45 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$42);
    var ord$18 = $m_s_math_Ordering$Int$();
    var $$x44 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$18)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$27 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$27);
    var optioner$10 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$8 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var resolver$10 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$8);
    var $$x43 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$10, resolver$10);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$15 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var textualizable$35 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$15);
    var $$x42 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$35);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$28 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var fieldRenderable$16 = $n($$x46).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x45, $$x44, $$x43, $$x42, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$28))));
    $m_Lshapeless_Witness$();
    var this$563 = $m_s_Symbol$();
    var value0$84 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$563, "reference"));
    var witness$25 = new $c_Lshapeless_Witness$$anon$1(value0$84);
    var $$x51 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$43 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_string;
    var format$44 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$43);
    var $$x50 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$44);
    var ord$19 = $m_s_math_Ordering$String$();
    var $$x49 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$19)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$29 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$29);
    var evDefault$2 = new $c_Lcom_iz2use_react_components_internal_Default$$anon$1();
    var optioner$11 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$30 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var parser$9 = new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$30);
    var resolver$11 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$9);
    var $$x48 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$11, resolver$11);
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$17 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$36 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$17);
    var $$x47 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$36);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$31 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var fieldRenderable$15 = $n($$x51).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x50, $$x49, $$x48, $$x47, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$31))));
    $m_Lshapeless_Witness$();
    var this$578 = $m_s_Symbol$();
    var value0$85 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$578, "pages"));
    var witness$24 = new $c_Lshapeless_Witness$$anon$1(value0$85);
    var $$x55 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    var format$45 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsFormat;
    var $$x54 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$45);
    var $$x53 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_invoicePageGroupDetailsSeqOrdering));
    var $$x52 = new $c_Lcom_iz2use_react_components_NotEditable();
    var this$582 = $m_Lreactbuild_model_Implicits$();
    new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var fieldRenderable$14 = $n($$x55).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x54, $$x53, $$x52, new $c_Lreactbuild_model_LowPriorityImplicits$$anon$14(this$582), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    $m_Lshapeless_Witness$();
    var this$583 = $m_s_Symbol$();
    var value0$86 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$583, "totalAmount"));
    var witness$23 = new $c_Lshapeless_Witness$$anon$1(value0$86);
    var $$x60 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$46 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
    var format$47 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$46);
    var $$x59 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$47);
    var ord$20 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
    var $$x58 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$20)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$32 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$32);
    var optioner$12 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$10 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var resolver$12 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$10);
    var $$x57 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$12, resolver$12);
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$37 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var textualizable$38 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$37);
    var $$x56 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$38);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$33 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var fieldRenderable$13 = $n($$x60).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x59, $$x58, $$x57, $$x56, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$33))));
    $m_Lshapeless_Witness$();
    var this$595 = $m_s_Symbol$();
    var value0$87 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$595, "expectedAmount"));
    var witness$22 = new $c_Lshapeless_Witness$$anon$1(value0$87);
    var $$x65 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$48 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceFormat;
    var format$49 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$48);
    var $$x64 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$49);
    var ord$21 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceOrdering;
    var $$x63 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$21)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$34 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$34);
    var optioner$13 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var parser$11 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var resolver$13 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$11);
    var $$x62 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$13, resolver$13);
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$39 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var textualizable$40 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$39);
    var $$x61 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$40);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$35 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var fieldRenderable$12 = $n($$x65).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x64, $$x63, $$x62, $$x61, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$35))));
    $m_Lshapeless_Witness$();
    var this$607 = $m_s_Symbol$();
    var value0$88 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$607, "received"));
    var witness$21 = new $c_Lshapeless_Witness$$anon$1(value0$88);
    var $$x69 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$50 = $m_Lcom_iz2use_react_components_internal_multiview_Format$().Lcom_iz2use_react_components_internal_multiview_Format$__f_instant;
    var format$51 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$50);
    var $$x68 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$51);
    var ord$22 = $m_Lcom_iz2use_react_components_package$().Lcom_iz2use_react_components_package$__f_instantOrdering;
    var $$x67 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$22)));
    var $$x66 = new $c_Lcom_iz2use_react_components_NotEditable();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$613 = $m_Lreactbuild_model_Implicits$();
    var locale$2 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$41 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$613, locale$2);
    var textualizable$42 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$41);
    var fieldRenderable$11 = $n($$x69).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x68, $$x67, $$x66, new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$42), new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$()));
    $m_Lshapeless_Witness$();
    var this$616 = $m_s_Symbol$();
    var value0$89 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$616, "category"));
    var witness$20 = new $c_Lshapeless_Witness$$anon$1(value0$89);
    var $$x74 = $m_Lcom_iz2use_react_components_internal_multiview_FieldRenderable$();
    $m_Lcom_iz2use_react_components_internal_multiview_Format$();
    var format$52 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryFormat;
    var format$53 = new $c_Lcom_iz2use_react_components_internal_multiview_Format$$anon$8(format$52);
    var $$x73 = new $c_Lcom_iz2use_react_components_internal_multiview_ProxyFieldFormat(format$53);
    var ord$23 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryOrdering;
    var $$x72 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_s_math_Ordering$O$1(ord$23)));
    $m_Lcom_iz2use_common_Parsable$();
    var ev$36 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$36);
    var optioner$14 = new $c_Lcom_iz2use_react_components_internal_OptionOptioner();
    var resolver$14 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_documentCategoryResolver;
    var $$x71 = new $c_Lcom_iz2use_react_components_Editable$$anon$1(optioner$14, resolver$14);
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$43 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    var textualizable$44 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$43);
    var $$x70 = new $c_Lcom_iz2use_react_components_Viewable$$anon$1(textualizable$44);
    $m_Lcom_iz2use_common_Parsable$();
    var ev$37 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    var fieldRenderable$10 = $n($$x74).of__Lcom_iz2use_react_components_internal_multiview_FieldFormat__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_Editable__Lcom_iz2use_react_components_Viewable__Lcom_iz2use_common_FailableImplicit__Lcom_iz2use_react_components_internal_multiview_FieldRenderable($$x73, $$x72, $$x71, $$x70, new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some(new $c_Lcom_iz2use_common_Parsable$$anon$3(ev$37))));
    var tail$28 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$3();
    var tail$29 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$10, witness$20, tail$28);
    var tail$30 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$11, witness$21, tail$29);
    var tail$31 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$12, witness$22, tail$30);
    var tail$32 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$13, witness$23, tail$31);
    var tail$33 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$14, witness$24, tail$32);
    var tail$34 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$15, witness$25, tail$33);
    var tail$35 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$16, witness$26, tail$34);
    var tail$36 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$17, witness$27, tail$35);
    var tail$37 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$18, witness$28, tail$36);
    var renderer$2 = new $c_Lcom_iz2use_react_components_internal_multiview_AccumulatingFieldsRenderer$$anon$4(fieldRenderable$19, witness$29, tail$37);
    var $$x75 = new $c_Lcom_iz2use_react_components_internal_multiview_FieldsRenderer$$anon$1(renderer$2);
    var $$x20 = $m_Lreactbuild_model_InvoicePageGroup$().keyMapperInvoicePageGroup__Lcom_iz2use_common_KeyMapper();
    var $$x19 = $m_Lcom_iz2use_common_Filter$().Lcom_iz2use_common_Filter$__f_defaultFilter;
    var $$x18 = $m_Lcom_iz2use_common_TokenMatcher$().Lcom_iz2use_common_TokenMatcher$__f_defaultTokenMatcher;
    var this$639 = $m_s_Symbol$();
    var $$x16 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$639, "organization"));
    var this$640 = $m_s_Symbol$();
    var $$x15 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$640, "supplier"));
    var this$641 = $m_s_Symbol$();
    var $$x14 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$641, "date"));
    var this$642 = $m_s_Symbol$();
    var $$x13 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$642, "entryNumber"));
    var this$643 = $m_s_Symbol$();
    var $$x12 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$643, "reference"));
    var this$644 = $m_s_Symbol$();
    var $$x11 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$644, "pages"));
    var this$645 = $m_s_Symbol$();
    var $$x10 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$645, "totalAmount"));
    var this$646 = $m_s_Symbol$();
    var $$x9 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$646, "expectedAmount"));
    var this$647 = $m_s_Symbol$();
    var $$x8 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$647, "received"));
    var this$648 = $m_s_Symbol$();
    var labels$4 = new $c_Lshapeless_$colon$colon($$x16, new $c_Lshapeless_$colon$colon($$x15, new $c_Lshapeless_$colon$colon($$x14, new $c_Lshapeless_$colon$colon($$x13, new $c_Lshapeless_$colon$colon($$x12, new $c_Lshapeless_$colon$colon($$x11, new $c_Lshapeless_$colon$colon($$x10, new $c_Lshapeless_$colon$colon($$x9, new $c_Lshapeless_$colon$colon($$x8, new $c_Lshapeless_$colon$colon($as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$648, "category")), $m_Lshapeless_HNil$()))))))))));
    new $c_Lshapeless_DefaultSymbolicLabelling$$anon$1(labels$4);
    var f$4 = new $c_sjsr_AnonFunction1(((x0$19$2) => {
      var x0$19 = $as_Lreactbuild_model_InvoicePageGroup(x0$19$2);
      if ((x0$19 !== null)) {
        var organization$macro$191 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_organization;
        var supplier$macro$192 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_supplier;
        var date$macro$193 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_date;
        var entryNumber$macro$194 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_entryNumber;
        var reference$macro$195 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_reference;
        var pages$macro$196 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_pages;
        var totalAmount$macro$197 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_totalAmount;
        var expectedAmount$macro$198 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_expectedAmount;
        var received$macro$199 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_received;
        var category$macro$200 = $n(x0$19).Lreactbuild_model_InvoicePageGroup__f_category;
        return new $c_Lshapeless_$colon$colon(organization$macro$191, new $c_Lshapeless_$colon$colon(supplier$macro$192, new $c_Lshapeless_$colon$colon(date$macro$193, new $c_Lshapeless_$colon$colon(entryNumber$macro$194, new $c_Lshapeless_$colon$colon(reference$macro$195, new $c_Lshapeless_$colon$colon(pages$macro$196, new $c_Lshapeless_$colon$colon(totalAmount$macro$197, new $c_Lshapeless_$colon$colon(expectedAmount$macro$198, new $c_Lshapeless_$colon$colon(received$macro$199, new $c_Lshapeless_$colon$colon(category$macro$200, $m_Lshapeless_HNil$()))))))))))
      } else {
        throw new $c_s_MatchError(x0$19)
      }
    }));
    var g$4 = new $c_sjsr_AnonFunction1(((x0$20$2) => {
      var x0$20 = $as_Lshapeless_$colon$colon(x0$20$2);
      if ((x0$20 !== null)) {
        var organization$macro$181 = $as_Lreactbuild_common_model_RefTo($n(x0$20).Lshapeless_$colon$colon__f_head);
        var p2$4 = $as_Lshapeless_$colon$colon($n(x0$20).Lshapeless_$colon$colon__f_tail);
        if ((p2$4 !== null)) {
          var supplier$macro$182 = $as_s_Option($n(p2$4).Lshapeless_$colon$colon__f_head);
          var p3$4 = $as_Lshapeless_$colon$colon($n(p2$4).Lshapeless_$colon$colon__f_tail);
          if ((p3$4 !== null)) {
            var date$macro$183 = $as_s_Option($n(p3$4).Lshapeless_$colon$colon__f_head);
            var p4$4 = $as_Lshapeless_$colon$colon($n(p3$4).Lshapeless_$colon$colon__f_tail);
            if ((p4$4 !== null)) {
              var entryNumber$macro$184 = $as_s_Option($n(p4$4).Lshapeless_$colon$colon__f_head);
              var p5$4 = $as_Lshapeless_$colon$colon($n(p4$4).Lshapeless_$colon$colon__f_tail);
              if ((p5$4 !== null)) {
                var reference$macro$185 = $as_s_Option($n(p5$4).Lshapeless_$colon$colon__f_head);
                var p6$4 = $as_Lshapeless_$colon$colon($n(p5$4).Lshapeless_$colon$colon__f_tail);
                if ((p6$4 !== null)) {
                  var pages$macro$186 = $as_sci_Seq($n(p6$4).Lshapeless_$colon$colon__f_head);
                  var p7$4 = $as_Lshapeless_$colon$colon($n(p6$4).Lshapeless_$colon$colon__f_tail);
                  if ((p7$4 !== null)) {
                    var totalAmount$macro$187 = $as_s_Option($n(p7$4).Lshapeless_$colon$colon__f_head);
                    var p8$4 = $as_Lshapeless_$colon$colon($n(p7$4).Lshapeless_$colon$colon__f_tail);
                    if ((p8$4 !== null)) {
                      var expectedAmount$macro$188 = $as_s_Option($n(p8$4).Lshapeless_$colon$colon__f_head);
                      var p9$4 = $as_Lshapeless_$colon$colon($n(p8$4).Lshapeless_$colon$colon__f_tail);
                      if ((p9$4 !== null)) {
                        var received$macro$189 = $as_s_Option($n(p9$4).Lshapeless_$colon$colon__f_head);
                        var p10$4 = $as_Lshapeless_$colon$colon($n(p9$4).Lshapeless_$colon$colon__f_tail);
                        if ((p10$4 !== null)) {
                          var category$macro$190 = $as_s_Option($n(p10$4).Lshapeless_$colon$colon__f_head);
                          var p11$4 = $as_Lshapeless_HNil($n(p10$4).Lshapeless_$colon$colon__f_tail);
                          var x$6 = $m_Lshapeless_HNil$();
                          if ((x$6 === p11$4)) {
                            return new $c_Lreactbuild_model_InvoicePageGroup(organization$macro$181, supplier$macro$182, date$macro$183, entryNumber$macro$184, reference$macro$185, pages$macro$186, totalAmount$macro$187, expectedAmount$macro$188, received$macro$189, category$macro$190)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      };
      throw new $c_s_MatchError(x0$20)
    }));
    var gen$8 = new $c_Lshapeless_Generic$$anon$1(f$4, g$4);
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    $m_Lshapeless_ops_hlist$ZipWithKeys$();
    var zipWithKeys$40 = $m_Lshapeless_ops_hlist$ZipWithKeys$().Lshapeless_ops_hlist$ZipWithKeys$__f_hnilZipWithKeys;
    $m_Lshapeless_Witness$();
    var this$651 = $m_s_Symbol$();
    var value0$90 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$651, "category"));
    new $c_Lshapeless_Witness$$anon$1(value0$90);
    var zipWithKeys$41 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$40);
    $m_Lshapeless_Witness$();
    var this$654 = $m_s_Symbol$();
    var value0$91 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$654, "received"));
    new $c_Lshapeless_Witness$$anon$1(value0$91);
    var zipWithKeys$42 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$41);
    $m_Lshapeless_Witness$();
    var this$657 = $m_s_Symbol$();
    var value0$92 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$657, "expectedAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$92);
    var zipWithKeys$43 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$42);
    $m_Lshapeless_Witness$();
    var this$660 = $m_s_Symbol$();
    var value0$93 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$660, "totalAmount"));
    new $c_Lshapeless_Witness$$anon$1(value0$93);
    var zipWithKeys$44 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$43);
    $m_Lshapeless_Witness$();
    var this$663 = $m_s_Symbol$();
    var value0$94 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$663, "pages"));
    new $c_Lshapeless_Witness$$anon$1(value0$94);
    var zipWithKeys$45 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$44);
    $m_Lshapeless_Witness$();
    var this$666 = $m_s_Symbol$();
    var value0$95 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$666, "reference"));
    new $c_Lshapeless_Witness$$anon$1(value0$95);
    var zipWithKeys$46 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$45);
    $m_Lshapeless_Witness$();
    var this$669 = $m_s_Symbol$();
    var value0$96 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$669, "entryNumber"));
    new $c_Lshapeless_Witness$$anon$1(value0$96);
    var zipWithKeys$47 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$46);
    $m_Lshapeless_Witness$();
    var this$672 = $m_s_Symbol$();
    var value0$97 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$672, "date"));
    new $c_Lshapeless_Witness$$anon$1(value0$97);
    var zipWithKeys$48 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$47);
    $m_Lshapeless_Witness$();
    var this$675 = $m_s_Symbol$();
    var value0$98 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$675, "supplier"));
    new $c_Lshapeless_Witness$$anon$1(value0$98);
    var zipWithKeys$49 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$48);
    $m_Lshapeless_Witness$();
    var this$678 = $m_s_Symbol$();
    var value0$99 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$678, "organization"));
    new $c_Lshapeless_Witness$$anon$1(value0$99);
    var zip$4 = new $c_Lshapeless_ops_hlist$ZipWithKeys$$anon$161(zipWithKeys$49);
    var this$681 = $m_s_$less$colon$less$();
    var ev$38 = this$681.s_$less$colon$less$__f_singleton;
    var gen$9 = new $c_Lshapeless_LabelledGeneric$$anon$2(zip$4, gen$8, ev$38);
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$683 = $m_s_Symbol$();
    var value0$100 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$683, "organization"));
    var witness$39 = new $c_Lshapeless_Witness$$anon$1(value0$100);
    var this$686 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    var this$685 = $m_Lreactbuild_model_Implicits$();
    var textualizable$45 = $f_Lreactbuild_model_LowPriorityImplicits__organizationTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$685, proxy);
    var ev$39 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$9 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$686, textualizable$45, ev$39)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$687 = $m_s_Symbol$();
    var value0$101 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$687, "supplier"));
    var witness$38 = new $c_Lshapeless_Witness$$anon$1(value0$101);
    var this$691 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$689 = $m_Lreactbuild_model_Implicits$();
    var textualizable$46 = $f_Lreactbuild_model_LowPriorityImplicits__personTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$689, proxy);
    var textualizable$47 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$46);
    var ev$40 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$8 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$691, textualizable$47, ev$40)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$692 = $m_s_Symbol$();
    var value0$102 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$692, "date"));
    var witness$37 = new $c_Lshapeless_Witness$$anon$1(value0$102);
    var this$695 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$48 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_dateTextualizable;
    var textualizable$49 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$48);
    var ev$41 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$7 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$695, textualizable$49, ev$41)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$696 = $m_s_Symbol$();
    var value0$103 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$696, "entryNumber"));
    var witness$36 = new $c_Lshapeless_Witness$$anon$1(value0$103);
    var this$700 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$21 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableInt;
    var textualizable$50 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$21);
    var ev$42 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$6 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$700, textualizable$50, ev$42)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$701 = $m_s_Symbol$();
    var value0$104 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$701, "reference"));
    var witness$35 = new $c_Lshapeless_Witness$$anon$1(value0$104);
    var this$705 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    $m_Lcom_iz2use_common_Textualizable$();
    var parsable$22 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableString;
    var textualizable$51 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(parsable$22);
    var ev$43 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$5 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$705, textualizable$51, ev$43)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$706 = $m_s_Symbol$();
    var value0$105 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$706, "pages"));
    var witness$34 = new $c_Lshapeless_Witness$$anon$1(value0$105);
    var ht$4 = new $c_Lcom_iz2use_common_FailableImplicit($m_s_None$());
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$708 = $m_s_Symbol$();
    var value0$106 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$708, "totalAmount"));
    var witness$33 = new $c_Lshapeless_Witness$$anon$1(value0$106);
    var this$711 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$52 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var textualizable$53 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$52);
    var ev$44 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$3 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$711, textualizable$53, ev$44)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$712 = $m_s_Symbol$();
    var value0$107 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$712, "expectedAmount"));
    var witness$32 = new $c_Lshapeless_Witness$$anon$1(value0$107);
    var this$715 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$54 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_priceParsable;
    var textualizable$55 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$54);
    var ev$45 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$2 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$715, textualizable$55, ev$45)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$716 = $m_s_Symbol$();
    var value0$108 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$716, "received"));
    var witness$31 = new $c_Lshapeless_Witness$$anon$1(value0$108);
    var this$720 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    var this$718 = $m_Lreactbuild_model_Implicits$();
    var locale$3 = $m_Lreactbuild_package$().Lreactbuild_package$__f_locale;
    var textualizable$56 = $f_Lreactbuild_model_LowPriorityImplicits__fromInstant__ju_Locale__Lcom_iz2use_common_Textualizable(this$718, locale$3);
    var textualizable$57 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$56);
    var ev$46 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht$1 = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$720, textualizable$57, ev$46)));
    $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$();
    $m_Lshapeless_Witness$();
    var this$721 = $m_s_Symbol$();
    var value0$109 = $as_s_Symbol($c_s_JSUniquenessCache.prototype.apply__T__O.call(this$721, "category"));
    var witness$30 = new $c_Lshapeless_Witness$$anon$1(value0$109);
    var this$724 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$();
    $m_Lcom_iz2use_common_Textualizable$();
    var textualizable$58 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_parsableDocumentCategory;
    var textualizable$59 = new $c_Lcom_iz2use_common_Textualizable$$anon$3(textualizable$58);
    var ev$47 = $m_Lcom_iz2use_common_internal_tokenizer_Tokenizer$tokenizeString$();
    var ht = new $c_Lcom_iz2use_common_FailableImplicit(new $c_s_Some($f_Lcom_iz2use_common_internal_tokenizer_TokenizerMidPriorityImplicits__tokenizeTextualizable__Lcom_iz2use_common_Textualizable__Lcom_iz2use_common_internal_tokenizer_Tokenizer__Lcom_iz2use_common_internal_tokenizer_Tokenizer(this$724, textualizable$59, ev$47)));
    var tt = $m_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$().Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$__f_tokenizeHNil;
    var tt$1 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt, ht, witness$30);
    var tt$2 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$1, ht$1, witness$31);
    var tt$3 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$2, ht$2, witness$32);
    var tt$4 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$3, ht$3, witness$33);
    var tt$5 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$4, ht$4, witness$34);
    var tt$6 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$5, ht$5, witness$35);
    var tt$7 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$6, ht$6, witness$36);
    var tt$8 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$7, ht$7, witness$37);
    var tt$9 = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$8, ht$8, witness$38);
    var tokenizer = new $c_Lcom_iz2use_common_internal_tokenizer_AccumulatingTokenizer$$anon$2(tt$9, ht$9, witness$39);
    var $$x17 = new $c_Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer$$anon$1(tokenizer, gen$9);
    var $$x7 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var $$x6 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var $$x5 = new $c_Lcom_iz2use_react_components_internal_multiview_Actions$$anon$1();
    var $$x4 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    var $$x3 = new $c_Lcom_iz2use_common_MaybeImplicit($m_s_None$());
    $m_Lreactbuild_model_Implicits$();
    var this$738 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u = $n($$x192).noExternalStateNorActive__O__Lcom_iz2use_react_components_internal_multiview_SourceHandler__Lcom_iz2use_react_components_internal_multiview_AsMap__Lcom_iz2use_react_components_internal_multiview_HasViews__Lcom_iz2use_react_components_internal_multiview_HasIterator__Lcom_iz2use_react_components_internal_multiview_FieldsRenderer__Lcom_iz2use_common_KeyMapper__Lcom_iz2use_common_Filter__Lcom_iz2use_common_TokenMatcher__Lcom_iz2use_common_internal_tokenizer_ObjectTokenizer__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_react_components_internal_multiview_Actions__Lcom_iz2use_common_MaybeImplicit__Lcom_iz2use_common_MaybeImplicit__F2__F1__s_math_Ordering__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(r$1, $$x191, $$x190, $$x180, $$x76, $$x75, $$x20, $$x19, $$x18, $$x17, $$x7, $$x6, $$x5, $$x4, $$x3, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$738.byRef__F2(), this$738.by_$eq$eq__F2()), new $c_sjsr_AnonFunction1(((evT$2) => {
      var evT = $n($as_Ljapgolly_scalajs_react_Reusability(evT$2)).Ljapgolly_scalajs_react_Reusability__f_test;
      return new $c_Ljapgolly_scalajs_react_Reusability($m_Lreactbuild_model_Implicits$().reusabilityMultiviewItemColl__F2__F2(evT))
    })), $m_Lcom_iz2use_react_components_internal_multiview_View$().defaultViewOrdering__s_math_Ordering());
    var this$740 = $n(u);
    var n = this$740.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)
  }));
  var $$x1 = $m_Ljapgolly_scalajs_react_Reusability$();
  $m_Lreactbuild_model_Implicits$();
  var this$743 = $m_Ljapgolly_scalajs_react_Reusability$();
  var u$1 = $n($$x197).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x193, $$x2, $n($$x1).list__F2__F2($m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$743.byRef__F2(), this$743.by_$eq$eq__F2())), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
  var this$745 = $n(u$1);
  var n$1 = this$745.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
  return $as_sci_Seq($n($$x198).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$__f_title
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.productPrefix__T = (function() {
  return "DocumentList"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.hashCode__I = (function() {
  return (-1309129607)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.toString__T = (function() {
  return "DocumentList"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  return this.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq(router, proxy, $as_Lreactbuild_person_Person(current), setDetailState)
});
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$DocumentList$", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DocumentList$;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$(outer) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$__f_title = null;
  if ((outer === null)) {
    $n(null)
  };
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$__f_title = "D\u00e9tails"
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.handleClose__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq = (function(router, proxy, person, setDetailState) {
  var $$x1 = $m_Lreactbuild_analyze_cost_modules_EditPerson$();
  var this$1 = $n($n(person).Lreactbuild_person_Person__f__id);
  var u = $n($$x1).withKey__T__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($m_sr_ScalaRunTime$()._toString__s_Product__T(this$1), router, proxy, $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), person), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x2;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p2 instanceof $c_s_Some)) {
        var x3 = $as_s_Some(p2);
        var v = $as_Lreactbuild_person_Person($n(x3).s_Some__f_value);
        var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n(proxy).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_analyze_cost_actions_PersistPerson(v), $m_Ldiode_Action$aType$()), cb);
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p4)) {
        var $$x2 = cb$2;
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  }))));
  var this$5 = $n(u);
  var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var details = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  var $$x3 = $m_s_package$().s_package$__f_Seq;
  var array = [details];
  return $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$__f_title
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.productPrefix__T = (function() {
  return "PersonDetails"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.hashCode__I = (function() {
  return 1230808333
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.toString__T = (function() {
  return "PersonDetails"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  return this.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq(router, proxy, $as_Lreactbuild_person_Person(current), setDetailState)
});
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$PersonDetails$", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$PersonDetails$;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(outer, allGroup, hideFixedPriceLines, hideDescendingPriceLines, showOnlyMovementInPeriod, showOnlyReferencePrice, invoicePage) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup = false;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines = false;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines = false;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod = false;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice = false;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_title = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup = allGroup;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines = hideFixedPriceLines;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines = hideDescendingPriceLines;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod = showOnlyMovementInPeriod;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice = showOnlyReferencePrice;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage = invoicePage;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer = outer
  };
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_title = "Produits"
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq = (function(router, proxy, person, setDetailState) {
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  var reuseT = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var this$2 = $n(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage);
  if (this$2.isEmpty__Z()) {
    var invoiceView = $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var ref = $as_Lreactbuild_common_model_RefTo(arg1);
    var u = $m_Lreactbuild_analyze_cost_components_PDFViewer$().apply__Lreactbuild_common_model_RefTo__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(ref);
    var this$4 = $n(u);
    var n = this$4.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var invoiceView = new $c_s_Some(new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n))
  };
  var rassoc$3 = $m_Lreactbuild_analyze_cost_components_PeriodProvider$().apply__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((period$2) => {
    var period = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(period$2);
    var this$133 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x36 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$8 = $m_Lscalacss_ScalaCssReact$();
    var s = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_notPrintable;
    var $$x35 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$8, s);
    var c = $m_Lcom_iz2use_react_components_Layout$().Lcom_iz2use_react_components_Layout$__f_horizontal;
    var this$53 = $n($as_Ljapgolly_scalajs_react_CtorType$Children($n(c).ctor__Ljapgolly_scalajs_react_CtorType()));
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Voir sur l'ensemble du groupe (le cas \u00e9ch\u00e9ant)");
    var $$x30 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup;
    var state = $n($$x30).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x31;
        var p2 = $as_s_Option(x1.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x = $m_s_None$();
        if ((x === p2)) {
          var $$x31 = cb;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1.T2__f__1);
        var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v = $uZ($n(x5).s_Some__f_value);
          var $$x32 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var hideFixedPriceLines = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines;
          var hideDescendingPriceLines = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines;
          var showOnlyMovementInPeriod = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod;
          var showOnlyReferencePrice = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice;
          var invoicePage = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage;
          var $$x31 = $n($$x32).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(setDetailState).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer, v, hideFixedPriceLines, hideDescendingPriceLines, showOnlyMovementInPeriod, showOnlyReferencePrice, invoicePage)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2);
          break matchEnd7
        };
        throw new $c_s_MatchError(x1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x31)
    })));
    var evDefault = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
    var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv = $m_s_math_Equiv$Boolean$();
    var this$17 = $n(editorComponent);
    var $$x33 = this$17.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cacher les lignes avec prix fixe");
    var $$x26 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value$1 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines;
    var state$1 = $n($$x26).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$1, new $c_sjsr_AnonFunction2(((x0$2$2, x1$2$2) => {
      var x0$2 = $as_s_Option(x0$2$2);
      var x1$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$3 = $ct_T2__O__O__(new $c_T2(), x0$2, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2));
      matchEnd7$1: {
        var $$x27;
        var p2$1 = $as_s_Option(x1$3.T2__f__1);
        var cb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$1 = $m_s_None$();
        if ((x$1 === p2$1)) {
          var $$x27 = cb$1;
          break matchEnd7$1
        };
        var p4$1 = $as_s_Option(x1$3.T2__f__1);
        var cb$2$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4$1 instanceof $c_s_Some)) {
          var x5$1 = $as_s_Some(p4$1);
          var v$1 = $uZ($n(x5$1).s_Some__f_value);
          var $$x28 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var x$2$2 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup;
          var x$3 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines;
          var x$4 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod;
          var x$5 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice;
          var x$6 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage;
          var $$x27 = $n($$x28).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(setDetailState).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer, x$2$2, v$1, x$3, x$4, x$5, x$6)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2$1);
          break matchEnd7$1
        };
        throw new $c_s_MatchError(x1$3)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x27)
    })));
    var evDefault$1 = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    var parser$1 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var ev$1 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$1);
    var editorComponent$1 = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$1 = $m_s_math_Equiv$Boolean$();
    var this$25 = $n(editorComponent$1);
    var $$x29 = this$25.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$1, explainError$1, equiv$1);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$2 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Cacher les lignes avec prix d\u00e9croissant");
    var $$x22 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value$2 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines;
    var state$2 = $n($$x22).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$2, new $c_sjsr_AnonFunction2(((x0$3$2, x1$3$2) => {
      var x0$3 = $as_s_Option(x0$3$2);
      var x1$3$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$4 = $ct_T2__O__O__(new $c_T2(), x0$3, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3$1));
      matchEnd7$2: {
        var $$x23;
        var p2$2 = $as_s_Option(x1$4.T2__f__1);
        var cb$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$4.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$2 = $m_s_None$();
        if ((x$2 === p2$2)) {
          var $$x23 = cb$3;
          break matchEnd7$2
        };
        var p4$2 = $as_s_Option(x1$4.T2__f__1);
        var cb$2$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$4.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4$2 instanceof $c_s_Some)) {
          var x5$2 = $as_s_Some(p4$2);
          var v$2 = $uZ($n(x5$2).s_Some__f_value);
          var $$x24 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var x$8 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup;
          var x$9 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines;
          var x$10 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod;
          var x$11 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice;
          var x$12 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage;
          var $$x23 = $n($$x24).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(setDetailState).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer, x$8, x$9, v$2, x$10, x$11, x$12)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2$2);
          break matchEnd7$2
        };
        throw new $c_s_MatchError(x1$4)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x23)
    })));
    var evDefault$2 = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
    var optioner$2 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$2);
    var parser$2 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var ev$2 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$2);
    var editorComponent$2 = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
    var explainError$2 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$2 = $m_s_math_Equiv$Boolean$();
    var this$33 = $n(editorComponent$2);
    var $$x25 = this$33.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$2, state$2, optioner$2, ev$2, explainError$2, equiv$2);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$3 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Afficher uniquement les produits mouvement\u00e9s pendant la p\u00e9riode s\u00e9lectionn\u00e9e");
    var $$x18 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value$3 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod;
    var state$3 = $n($$x18).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$3, new $c_sjsr_AnonFunction2(((x0$4$2, x1$4$2) => {
      var x0$4 = $as_s_Option(x0$4$2);
      var x1$4$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$4$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$5 = $ct_T2__O__O__(new $c_T2(), x0$4, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$4$1));
      matchEnd7$3: {
        var $$x19;
        var p2$3 = $as_s_Option(x1$5.T2__f__1);
        var cb$4 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$5.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$7 = $m_s_None$();
        if ((x$7 === p2$3)) {
          var $$x19 = cb$4;
          break matchEnd7$3
        };
        var p4$3 = $as_s_Option(x1$5.T2__f__1);
        var cb$2$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$5.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4$3 instanceof $c_s_Some)) {
          var x5$3 = $as_s_Some(p4$3);
          var v$3 = $uZ($n(x5$3).s_Some__f_value);
          var $$x20 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var x$14 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup;
          var x$15 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines;
          var x$16 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines;
          var x$17 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice;
          var x$18 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage;
          var $$x19 = $n($$x20).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(setDetailState).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer, x$14, x$15, x$16, v$3, x$17, x$18)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2$3);
          break matchEnd7$3
        };
        throw new $c_s_MatchError(x1$5)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x19)
    })));
    var evDefault$3 = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
    var optioner$3 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$3);
    var parser$3 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var ev$3 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$3);
    var editorComponent$3 = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
    var explainError$3 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$3 = $m_s_math_Equiv$Boolean$();
    var this$41 = $n(editorComponent$3);
    var $$x21 = this$41.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$3, state$3, optioner$3, ev$3, explainError$3, equiv$3);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$4 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Afficher uniquement le prix de r\u00e9f\u00e9rence");
    var $$x15 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value$4 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice;
    var state$4 = $n($$x15).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$4, new $c_sjsr_AnonFunction2(((x0$5$2, x1$5$2) => {
      var x0$5 = $as_s_Option(x0$5$2);
      var x1$5$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$5$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$6 = $ct_T2__O__O__(new $c_T2(), x0$5, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$5$1));
      matchEnd7$4: {
        var $$x16;
        var p2$4 = $as_s_Option(x1$6.T2__f__1);
        var cb$5 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$6.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$13 = $m_s_None$();
        if ((x$13 === p2$4)) {
          var $$x16 = cb$5;
          break matchEnd7$4
        };
        var p4$4 = $as_s_Option(x1$6.T2__f__1);
        var cb$2$4 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$6.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4$4 instanceof $c_s_Some)) {
          var x5$4 = $as_s_Some(p4$4);
          var v$4 = $uZ($n(x5$4).s_Some__f_value);
          var $$x17 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var x$20 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup;
          var x$21 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines;
          var x$22 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines;
          var x$23 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod;
          var x$24 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage;
          var $$x16 = $n($$x17).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(setDetailState).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer, x$20, x$21, x$22, x$23, v$4, x$24)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2$4);
          break matchEnd7$4
        };
        throw new $c_s_MatchError(x1$6)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x16)
    })));
    var evDefault$4 = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
    var optioner$4 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$4);
    var parser$4 = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var ev$4 = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser$4);
    var editorComponent$4 = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
    var explainError$4 = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv$4 = $m_s_math_Equiv$Boolean$();
    var this$49 = $n(editorComponent$4);
    var array = [$$x33, $$x29, $$x25, $$x21, this$49.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$4, state$4, optioner$4, ev$4, explainError$4, equiv$4)];
    var children = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var u$1 = $as_Ljapgolly_scalajs_react_component_Generic$UnmountedRaw($n(this$53.Ljapgolly_scalajs_react_CtorType$Children__f_construct).apply__O__O__O(this$53.Ljapgolly_scalajs_react_CtorType$Children__f_mods, children));
    var this$55 = $n(u$1);
    var n$1 = this$55.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x34 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1);
    var u$2 = $m_Lreactbuild_analyze_cost_components_PeriodSelector$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(period);
    var this$58 = $n(u$2);
    var n$2 = this$58.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$1 = [$$x35, $$x34, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
    var $$x14 = $n($$x36).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var $$x13 = $m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment;
    var a = (((("" + this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup) + $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from) + $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_to) + this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod);
    var u$3 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$().apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_sjsr_AnonFunction0((() => {
      var this$66 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x7 = new $c_Lautowire_ClientProxy(this$66).Lautowire_ClientProxy__f_self;
      var $$x6 = $m_s_package$().s_package$__f_Seq;
      var array$2 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listPriceEvolutionOverTime"];
      var $$x5 = $as_sci_Seq($n($$x6).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
      var this$95 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$71 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$72 = $n(new $c_Lautowire_ClientProxy(this$71).Lautowire_ClientProxy__f_self);
      var r = $n(person).Lreactbuild_person_Person__f__id;
      var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y = this$72.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
      var $$x4 = $ct_T2__O__O__(new $c_T2(), "supplier", y);
      var this$75 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$76 = $n(new $c_Lautowire_ClientProxy(this$75).Lautowire_ClientProxy__f_self);
      var r$1 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup;
      var evidence$2$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
      var y$1 = this$76.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
      var $$x3 = $ct_T2__O__O__(new $c_T2(), "allInSameGroup", y$1);
      var this$79 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$81 = $n(new $c_Lautowire_ClientProxy(this$79).Lautowire_ClientProxy__f_self);
      var r$2 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from;
      $m_Lio_circe_Encoder$();
      var e = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
      var evidence$2$2 = new $c_Lio_circe_Encoder$$anon$21(e);
      var y$2 = this$81.write__O__Lio_circe_Encoder__Lio_circe_Json(r$2, evidence$2$2);
      var $$x2 = $ct_T2__O__O__(new $c_T2(), "from", y$2);
      var this$84 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$86 = $n(new $c_Lautowire_ClientProxy(this$84).Lautowire_ClientProxy__f_self);
      var r$3 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_to;
      $m_Lio_circe_Encoder$();
      var e$1 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
      var evidence$2$3 = new $c_Lio_circe_Encoder$$anon$21(e$1);
      var y$3 = this$86.write__O__Lio_circe_Encoder__Lio_circe_Json(r$3, evidence$2$3);
      var $$x1 = $ct_T2__O__O__(new $c_T2(), "to", y$3);
      var this$89 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$90 = $n(new $c_Lautowire_ClientProxy(this$89).Lautowire_ClientProxy__f_self);
      var r$4 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod;
      var evidence$2$4 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
      var y$4 = this$90.write__O__Lio_circe_Encoder__Lio_circe_Json(r$4, evidence$2$4);
      var array$3 = [$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "showOnlyMovementInPeriod", y$4)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
      return $n($n($$x7).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x5, this$95.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$25$2) => {
        var x$25 = $as_Lio_circe_Json(x$25$2);
        var this$96 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$98 = $n(new $c_Lautowire_ClientProxy(this$96).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lreactbuild_model_PriceEvolutionProduct$().Lreactbuild_model_PriceEvolutionProduct$__f_codecForPriceEvolutionProduct;
        var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
        return $as_sci_List(this$98.read__Lio_circe_Json__Lio_circe_Decoder__O(x$25, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), new $c_sjsr_AnonFunction1(((r$2$1) => {
      var r$5 = $as_Ldiode_data_Pot(r$2$1);
      var this$99 = $n($n(r$5).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$7$2) => {
        var x$7$1 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$7$2);
        return $as_sci_List($n(x$7$1).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
      }))));
      var this$100 = $n($as_sci_List((this$99.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : this$99.get__O())));
      var rest = this$100;
      var h = null;
      var t = null;
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var x$8$1 = $as_Lreactbuild_model_PriceEvolutionProduct(arg1$1);
        var it = $n($n(x$8$1).Lreactbuild_model_PriceEvolutionProduct__f_events).iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
          if ((t === null)) {
            h = nx
          } else {
            $n(t).sci_$colon$colon__f_next = nx
          };
          t = nx
        };
        rest = $as_sci_List($n(rest).tail__O())
      };
      var this$101 = $n(((h === null) ? $m_sci_Nil$() : h));
      var f = ((x$9$2) => {
        var x$9$1 = $as_Lreactbuild_model_PriceEvolutionProductEntry(x$9$2);
        return $n(x$9$1).Lreactbuild_model_PriceEvolutionProductEntry__f_date
      });
      if ((this$101 === $m_sci_Nil$())) {
        var allDates = $m_sci_Nil$()
      } else {
        var arg1$2 = this$101.head__O();
        var h$1 = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(this$101.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$3 = $n(rest$1).head__O();
          var nx$1 = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
          $n(t$1).sci_$colon$colon__f_next = nx$1;
          t$1 = nx$1;
          rest$1 = $as_sci_List($n(rest$1).tail__O())
        };
        var allDates = h$1
      };
      if ($n(r$5).isFailed__Z()) {
        var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v$5 = $n(r$5).toString__T();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$4 = [$$x8, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$5)];
        return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
      } else {
        var this$112 = $n(r$5);
        if ((!this$112.isEmpty__Z())) {
          var arg1$4 = $n(r$5).get__O();
          var r$2$2 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1$4);
          var $$x11 = $m_Lreactbuild_analyze_cost_modules_ProductPriceEvolutions$();
          var this$113 = $n($n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from);
          if (this$113.isEmpty__Z()) {
            if ($n(allDates).isEmpty__Z()) {
              var this$114 = $m_Ljava_time_LocalDate$();
              var $$x10 = this$114.now__Ljava_time_Clock__Ljava_time_LocalDate(new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneId$().systemDefault__Ljava_time_ZoneId()))
            } else {
              var this$116 = $n(allDates);
              var ord = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_localDateOrdering;
              var $$x10 = $as_Ljava_time_LocalDate($f_sc_IterableOnceOps__min__s_math_Ordering__O(this$116, ord))
            }
          } else {
            var $$x10 = this$113.get__O()
          };
          return $n($$x11).apply__Ljava_time_LocalDate__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Lreactbuild_person_Person__Z__Z__Z__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf($as_Ljava_time_LocalDate($$x10), router, person, this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines, this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines, this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice, r$2$2, proxy)
        } else if ($n(r$5).isPending__Z()) {
          return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
        } else {
          var $$x12 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
          return $n($$x12).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
        }
      }
    })), reuseT, $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var this$125 = $n(u$3);
    var n$3 = this$125.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$6 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3)];
    var array$7 = [$$x14, $n($$x13).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$133, null, ns)
  })), proxy);
  var this$137 = $n($n(invoiceView).toList__sci_List());
  var this$135 = $n(rassoc$3);
  var n$4 = this$135.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var elem = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4);
  return new $c_sci_$colon$colon(elem, this$137)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.handleClose__s_PartialFunction = (function() {
  return new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products$$anonfun$handleClose$1(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_title
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.productPrefix__T = (function() {
  return "Products"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Products");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if (((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products) && ($n($as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(x$1)).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer === this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_$outer))) {
    var Products$1 = $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(x$1);
    if (((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup === $n(Products$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_allGroup) && ((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines === $n(Products$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideFixedPriceLines) && (this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines === $n(Products$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_hideDescendingPriceLines)))) {
      if (((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod === $n(Products$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyMovementInPeriod) && (this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice === $n(Products$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_showOnlyReferencePrice))) {
        var x = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage;
        var x$2 = $n(Products$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products__f_invoicePage;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          $n(Products$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  return this.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq(router, proxy, $as_Lreactbuild_person_Person(current), setDetailState)
});
function $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$Products"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.PersonDetailViewHandler$Products;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$Products", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$Products;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(outer, allGroup, order) {
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup = false;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_title = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_$outer = null;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup = allGroup;
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order = order;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_$outer = outer
  };
  this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_title = "Etat rapprochements"
}
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype = $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype;
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.handleClose__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq = (function(router, proxy, person, setDetailState) {
  var this$1 = $m_Ljapgolly_scalajs_react_Reusability$();
  var reuseT = $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$1.byRef__F2(), this$1.by_$eq$eq__F2());
  var $$x25 = $m_s_package$().s_package$__f_Seq;
  var u$2 = $m_Lreactbuild_analyze_cost_components_PeriodProvider$().apply__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((period$2) => {
    var period = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(period$2);
    var periodValue = $as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
    var this$91 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x24 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$5 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).display__Ljapgolly_scalajs_react_vdom_HtmlStyles$display$());
    var $$x23 = this$5.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("flex", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$6 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).flexDirection__Ljapgolly_scalajs_react_vdom_HtmlStyles$flexDirection$());
    var $$x22 = this$6.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("row", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    var this$7 = $n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).alignItems__Ljapgolly_scalajs_react_vdom_HtmlStyles$alignItems$());
    var $$x21 = this$7.$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod("baseline", $m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Voir sur l'ensemble du groupe (le cas \u00e9ch\u00e9ant)");
    var $$x17 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup;
    var state = $n($$x17).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value, new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
      matchEnd7: {
        var $$x18;
        var p2 = $as_s_Option(x1.T2__f__1);
        var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x = $m_s_None$();
        if ((x === p2)) {
          var $$x18 = cb;
          break matchEnd7
        };
        var p4 = $as_s_Option(x1.T2__f__1);
        var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4 instanceof $c_s_Some)) {
          var x5 = $as_s_Some(p4);
          var v = $uZ($n(x5).s_Some__f_value);
          var $$x19 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var order = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order;
          var $$x18 = $n($$x19).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(setDetailState).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_$outer, v, order)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2);
          break matchEnd7
        };
        throw new $c_s_MatchError(x1)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x18)
    })));
    var evDefault = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
    var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
    var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
    var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
    var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
    var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
    var equiv = $m_s_math_Equiv$Boolean$();
    var this$15 = $n(editorComponent);
    var $$x20 = this$15.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv);
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var label$1 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Trier par ");
    var $$x13 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$();
    $n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$());
    var value$1 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order;
    var state$1 = $n($$x13).apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(value$1, new $c_sjsr_AnonFunction2(((x0$2$2, x1$2$2) => {
      var x0$2 = $as_s_Option(x0$2$2);
      var x1$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x1$3 = $ct_T2__O__O__(new $c_T2(), x0$2, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$2));
      matchEnd7$1: {
        var $$x14;
        var p2$1 = $as_s_Option(x1$3.T2__f__1);
        var cb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x$1 = $m_s_None$();
        if ((x$1 === p2$1)) {
          var $$x14 = cb$1;
          break matchEnd7$1
        };
        var p4$1 = $as_s_Option(x1$3.T2__f__1);
        var cb$2$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$3.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        if ((p4$1 instanceof $c_s_Some)) {
          var x5$1 = $as_s_Some(p4$1);
          var v$1 = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder($n(x5$1).s_Some__f_value);
          var $$x15 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
          var x$2$2 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup;
          var $$x14 = $n($$x15).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(setDetailState).apply__O__O(new $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_$outer, x$2$2, v$1)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, cb$2$1);
          break matchEnd7$1
        };
        throw new $c_s_MatchError(x1$3)
      };
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x14)
    })));
    var evDefault$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_reconciliationReportDefault;
    var optioner$1 = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault$1);
    var ev$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_reconciliationReportOrderResolver;
    $m_Lcom_iz2use_react_components_ConcreteEditorComponent$();
    var helper = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_reconciliationReportOrderHelper;
    var editorComponent$1 = new $c_Lcom_iz2use_react_components_internal_editor_TextComponent(helper);
    var this$21 = $m_Lcom_iz2use_react_components_ExplainError$();
    var explainError$1 = new $c_Lcom_iz2use_react_components_ExplainErrorLowPriorityImplicits$$anon$1(this$21);
    var this$22 = $m_s_math_Equiv$();
    var equiv$1 = this$22.universal__s_math_Equiv();
    var $$x16 = editorComponent$1.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label$1, state$1, optioner$1, ev$1, explainError$1, equiv$1);
    var u = $m_Lreactbuild_analyze_cost_components_PeriodSelector$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(period);
    var this$25 = $n(u);
    var n = this$25.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array = [$$x23, $$x22, $$x21, $$x20, $$x16, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
    var $$x12 = $n($$x24).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x11 = $m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment;
    var a = (("" + this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup) + this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order);
    var $$x10 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$1 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Bons de livraison - Factures"))];
    var $$x9 = $n($$x10).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h3", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var u$1 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$().apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot(new $c_sjsr_AnonFunction0((() => {
      var this$40 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x5 = new $c_Lautowire_ClientProxy(this$40).Lautowire_ClientProxy__f_self;
      var $$x4 = $m_s_package$().s_package$__f_Seq;
      var array$2 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listReconciliationReport"];
      var $$x3 = $as_sci_Seq($n($$x4).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)));
      var this$59 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$45 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$46 = $n(new $c_Lautowire_ClientProxy(this$45).Lautowire_ClientProxy__f_self);
      var r = $n(person).Lreactbuild_person_Person__f__id;
      var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y = this$46.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
      var $$x2 = $ct_T2__O__O__(new $c_T2(), "supplier", y);
      var this$49 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$50 = $n(new $c_Lautowire_ClientProxy(this$49).Lautowire_ClientProxy__f_self);
      var r$1 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup;
      var evidence$2$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
      var y$1 = this$50.write__O__Lio_circe_Encoder__Lio_circe_Json(r$1, evidence$2$1);
      var $$x1 = $ct_T2__O__O__(new $c_T2(), "allInSameGroup", y$1);
      var this$53 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$54 = $n(new $c_Lautowire_ClientProxy(this$53).Lautowire_ClientProxy__f_self);
      var r$2 = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order;
      var evidence$2$2 = $m_Lreactbuild_analyze_cost_ReconciliationReportOrder$().Lreactbuild_analyze_cost_ReconciliationReportOrder$__f_codecForReconciliationReportOrder;
      var y$2 = this$54.write__O__Lio_circe_Encoder__Lio_circe_Json(r$2, evidence$2$2);
      var array$3 = [$$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "order", y$2)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
      return $n($n($$x5).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x3, this$59.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$3$2) => {
        var x$3 = $as_Lio_circe_Json(x$3$2);
        var this$60 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$63 = $n(new $c_Lautowire_ClientProxy(this$60).Lautowire_ClientProxy__f_self);
        $m_Lio_circe_Decoder$();
        $m_Lio_circe_Decoder$();
        var decodeA = $m_Lreactbuild_model_ReconciliationState$().decodeReconciliationState__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_model_ChildWithParent$().decodeChildWithParent__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_model_InvoiceDetail$().Lreactbuild_model_InvoiceDetail$__f_codecForInvoiceDetail, $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage), $m_Lreactbuild_model_ChildWithParent$().decodeChildWithParent__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_model_DeliveryFormDetails$().Lreactbuild_model_DeliveryFormDetails$__f_codecForDeliveryFormDetails, $m_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$().Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$__f_codecForReconcileInvoicePageWithDeliveryForm));
        var decodeA$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA);
        var evidence$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA$1);
        return $as_sci_List(this$63.read__Lio_circe_Json__Lio_circe_Decoder__O(x$3, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    })), new $c_sjsr_AnonFunction1(((x$4$2) => {
      var x$4 = $as_Ldiode_data_Pot(x$4$2);
      if ($n(x$4).isFailed__Z()) {
        var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
        $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
        $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var $$x6 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Une erreur s'est produite");
        $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
        var v$2 = $n(x$4).toString__T();
        $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
        var array$4 = [$$x6, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
        return $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
      } else {
        var this$74 = $n(x$4);
        if ((!this$74.isEmpty__Z())) {
          var arg1 = $n(x$4).get__O();
          var r$3 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(arg1);
          return $m_Lreactbuild_analyze_cost_modules_ReconciliationReportTable$().apply__Lreactbuild_analyze_cost_components_Period__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_vdom_TagOf(periodValue, r$3, proxy)
        } else if ($n(x$4).isPending__Z()) {
          return $m_Lreactbuild_analyze_cost_components_RenderPot$().apply$default$2__Ljapgolly_scalajs_react_vdom_VdomNode()
        } else {
          var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
          $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
          $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
          var array$5 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("Aucun contenu"))];
          return $n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
        }
      }
    })), reuseT, $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var this$83 = $n(u$1);
    var n$1 = this$83.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$6 = [$$x9, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)];
    var array$7 = [$$x12, $n($$x11).withKey__sjs_js_$bar__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(a, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
    return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$91, null, ns)
  })), proxy);
  var this$93 = $n(u$2);
  var n$2 = this$93.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$8 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
  return $as_sci_Seq($n($$x25).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8)))
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_title
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.productPrefix__T = (function() {
  return "ReconciliationReport"
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ReconciliationReport");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if (((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport) && ($n($as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(x$1)).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_$outer === this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_$outer))) {
    var ReconciliationReport$1 = $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup === $n(ReconciliationReport$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_allGroup)) {
      var x = this.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order;
      var x$2 = $n(ReconciliationReport$1).Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport__f_order;
      if ((x === null)) {
        var $$x1 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === x$2)
      };
      if ($$x1) {
        $n(ReconciliationReport$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  return this.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_person_Person__F1__sci_Seq(router, proxy, $as_Lreactbuild_person_Person(current), setDetailState)
});
function $as_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$ReconciliationReport"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.PersonDetailViewHandler$ReconciliationReport;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport: 0
}, false, "reactbuild.analyze.cost.modules.PersonDetailViewHandler$ReconciliationReport", {
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$DetailState: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_PersonDetailViewHandler$ReconciliationReport;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$(outer) {
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$__f_title = null;
  if ((outer === null)) {
    $n(null)
  };
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$__f_title = "D\u00e9tails"
}
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype = $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype;
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.handleClose__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_model_Resource__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  var $$x1 = $m_Lreactbuild_analyze_cost_modules_EditResource$();
  var this$1 = $n($n(current).Lreactbuild_model_Resource__f__id);
  var u = $n($$x1).withKey__T__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($m_sr_ScalaRunTime$()._toString__s_Product__T(this$1), proxy, $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), current), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x2;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x2 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $as_Lreactbuild_model_Resource($n(x5).s_Some__f_value);
        var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n(proxy).dispatchCB__O__Ldiode_ActionType__Ljapgolly_scalajs_react_callback_Trampoline(new $c_Lreactbuild_analyze_cost_actions_PersistResource(v), $m_Ldiode_Action$aType$()), cb$2);
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x2)
  }))));
  var this$5 = $n(u);
  var n = this$5.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var details = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  var $$x3 = $m_s_package$().s_package$__f_Seq;
  var array = [details];
  return $as_sci_Seq($n($$x3).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$__f_title
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.productPrefix__T = (function() {
  return "ResourceDetails"
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.hashCode__I = (function() {
  return 1195668020
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.toString__T = (function() {
  return "ResourceDetails"
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  return this.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_model_Resource__F1__sci_Seq(router, proxy, $as_Lreactbuild_model_Resource(current), setDetailState)
});
var $d_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$: 0
}, false, "reactbuild.analyze.cost.modules.ResourceDetailViewHandler$ResourceDetails$", {
  Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$ResourceDetails$;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$(outer) {
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$__f_title = null;
  if ((outer === null)) {
    $n(null)
  };
  this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$__f_title = "Usage"
}
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype = $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype;
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.handleClose__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_model_Resource__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), this), new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x1;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x1 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $as_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$($n(x5).s_Some__f_value);
        var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(setDetailState).apply__O__O(v))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        break matchEnd7
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  })));
  var details = $m_Lreactbuild_analyze_cost_components_PeriodProvider$().apply__F1__Ldiode_react_ModelProxy__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(new $c_sjsr_AnonFunction1(((period$2) => {
    var period = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(period$2);
    var $$x32 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var $$x31 = $m_Lcom_iz2use_react_components_Media$();
    var this$61 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var u = $m_Lreactbuild_analyze_cost_components_PeriodSelector$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(period);
    var this$6 = $n(u);
    var n = this$6.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x30 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
    var $$x29 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9partition par corps d'\u00e9tat"))];
    var $$x28 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h3", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    var $$x27 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
    var $$x23 = new $c_sjsr_AnonFunction0((() => {
      var this$15 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x26 = new $c_Lautowire_ClientProxy(this$15).Lautowire_ClientProxy__f_self;
      var $$x25 = $m_s_package$().s_package$__f_Seq;
      var array$1 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listDurationByDateAndBuildingStageForResource"];
      var $$x24 = $as_sci_Seq($n($$x25).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)));
      var this$26 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$20 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$21 = $n(new $c_Lautowire_ClientProxy(this$20).Lautowire_ClientProxy__f_self);
      var r = $n(current).Lreactbuild_model_Resource__f__id;
      var evidence$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y = this$21.write__O__Lio_circe_Encoder__Lio_circe_Json(r, evidence$2);
      var array$2 = [$ct_T2__O__O__(new $c_T2(), "resource", y)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return $n($n($$x26).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x24, this$26.from__sc_IterableOnce__sci_Map(elems)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1 = $as_Lio_circe_Json(x$1$2);
        var this$27 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$32 = $n(new $c_Lautowire_ClientProxy(this$27).Lautowire_ClientProxy__f_self);
        var this$31 = $m_Lreactbuild_model_package$();
        $m_s_DummyImplicit$();
        var ev = new $c_Lshapeless_Refute$$anon$2();
        var this$30 = $m_Lio_circe_Decoder$();
        var decodeA0 = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
        $m_Lio_circe_Decoder$();
        var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
        var decodeA1 = new $c_Lio_circe_Decoder$$anon$39(d);
        var decodeK = new $c_Lio_circe_TupleDecoders$$anon$2(this$30, decodeA0, decodeA1);
        var decodeV = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_decodeDuration;
        var evidence$1 = $f_Lreactbuild_common_CirceExtendedImplicits__decodeOtherMap__Lshapeless_Refute__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder(this$31, ev, decodeK, decodeV);
        return $as_sci_Map(this$32.read__Lio_circe_Json__Lio_circe_Decoder__O(x$1, evidence$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var $$x17 = new $c_sjsr_AnonFunction1(((r$2) => {
      var r$1 = $as_Ldiode_data_Pot(r$2);
      var this$44 = $m_Lreactbuild_analyze_cost_modules_AccumulatingTable$();
      var $$x21 = $m_sci_SortedSet$();
      $m_Lreactbuild_package$();
      new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
      var this$35 = $n(proxy);
      var this$36 = $n(this$35.Ldiode_react_ModelProxy__f_modelReader);
      var m = $as_Lreactbuild_analyze_cost_services_Model(this$36.value__O());
      if ($n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
        $n($m_s_package$().s_package$__f_List);
        var $$x19 = $m_sci_Nil$()
      } else {
        var arg1 = $n($n(m).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
        var x$14 = $as_Lreactbuild_model_CommonData(arg1);
        var $$x19 = $n(x$14).Lreactbuild_model_CommonData__f_buildingStages
      };
      var this$38 = $n($as_sci_List($$x19));
      var f = ((x$15$2) => {
        var x$15 = $as_Lreactbuild_model_BuildingStage(x$15$2);
        return $n(x$15).Lreactbuild_model_BuildingStage__f__id
      });
      if ((this$38 === $m_sci_Nil$())) {
        var $$x20 = $m_sci_Nil$()
      } else {
        var arg1$1 = this$38.head__O();
        var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$38.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O())
        };
        var $$x20 = h
      };
      var $$x18 = $m_Lreactbuild_model_Implicits$();
      var this$39 = $m_Lreactbuild_model_Implicits$();
      var items = $as_sci_SortedSet($n($$x21).apply__sci_Seq__O__O($$x20, $n($$x18).buildingStageRefOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering($f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$39, proxy))));
      var this$40 = $n($n(r$1).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$16$2) => {
        var x$16 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$16$2);
        return $as_sci_Map($n(x$16).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
      }))));
      var accumulatings = $as_sci_Map((this$40.isEmpty__Z() ? ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()) : this$40.get__O()));
      var seeMore = new $c_sjsr_AnonFunction1(((d$2) => {
        var d$1 = $as_Ljava_time_LocalDate(d$2);
        return $n(router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$TimeReport(new $c_s_Some(d$1)))
      }));
      var from = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from;
      var to = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_to;
      var this$42 = $m_Lreactbuild_model_Implicits$();
      var rTextualizable = $f_Lreactbuild_model_LowPriorityImplicits__buildingStageTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$42, proxy);
      var accTextualizable = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
      var accNumeric = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_numericDuration;
      var c = this$44.Lreactbuild_analyze_cost_modules_AccumulatingTable$__f_component;
      var $$x22 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c).ctor__Ljapgolly_scalajs_react_CtorType());
      var a = $d_Lreactbuild_model_Duration.getClassOf().getSimpleName__T();
      var this$50 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x22).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a)));
      var props = new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(proxy, items, accumulatings, seeMore, rTextualizable, accTextualizable, accNumeric, from, to);
      var u$1 = $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$50.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props, this$50.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
      var this$52 = $n(u$1);
      var n$1 = this$52.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    }));
    var this$54 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u$2 = $n($$x27).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x23, $$x17, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$54.byRef__F2(), this$54.by_$eq$eq__F2()), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var this$56 = $n(u$2);
    var n$2 = this$56.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$3 = [$$x30, $$x28, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    var $$x16 = $n($$x31).page__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_TagOf($p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$61, null, ns));
    var $$x15 = $m_Lcom_iz2use_react_components_Media$();
    var this$119 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var u$3 = $m_Lreactbuild_analyze_cost_components_PeriodSelector$().apply__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(period);
    var this$63 = $n(u$3);
    var n$3 = this$63.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var $$x14 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$3);
    var $$x13 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var array$4 = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1("R\u00e9partition par projet"))];
    var $$x12 = $n($$x13).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("h3", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var $$x11 = $m_Lcom_iz2use_react_components_FetchCacheAndRender$();
    var $$x7 = new $c_sjsr_AnonFunction0((() => {
      var this$72 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var $$x10 = new $c_Lautowire_ClientProxy(this$72).Lautowire_ClientProxy__f_self;
      var $$x9 = $m_s_package$().s_package$__f_Seq;
      var array$5 = ["reactbuild", "analyze", "cost", "CostAnalyzeApi", "listDurationByDateAndBuildingSiteForResource"];
      var $$x8 = $as_sci_Seq($n($$x9).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)));
      var this$83 = $n($m_s_Predef$().s_Predef$__f_Map);
      var this$77 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
      var this$78 = $n(new $c_Lautowire_ClientProxy(this$77).Lautowire_ClientProxy__f_self);
      var r$3 = $n(current).Lreactbuild_model_Resource__f__id;
      var evidence$2$1 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
      var y$1 = this$78.write__O__Lio_circe_Encoder__Lio_circe_Json(r$3, evidence$2$1);
      var array$6 = [$ct_T2__O__O__(new $c_T2(), "resource", y$1)];
      var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
      return $n($n($$x10).doCall__Lautowire_Core$Request__s_concurrent_Future(new $c_Lautowire_Core$Request($$x8, this$83.from__sc_IterableOnce__sci_Map(elems$1)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((x$2$2) => {
        var x$2 = $as_Lio_circe_Json(x$2$2);
        var this$84 = $m_Lreactbuild_analyze_cost_services_AjaxClient$();
        var this$89 = $n(new $c_Lautowire_ClientProxy(this$84).Lautowire_ClientProxy__f_self);
        var this$88 = $m_Lreactbuild_model_package$();
        $m_s_DummyImplicit$();
        var ev$5 = new $c_Lshapeless_Refute$$anon$2();
        var this$87 = $m_Lio_circe_Decoder$();
        var decodeA0$1 = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
        $m_Lio_circe_Decoder$();
        var d$3 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
        var decodeA1$1 = new $c_Lio_circe_Decoder$$anon$39(d$3);
        var decodeK$1 = new $c_Lio_circe_TupleDecoders$$anon$2(this$87, decodeA0$1, decodeA1$1);
        var decodeV$1 = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_decodeDuration;
        var evidence$1$1 = $f_Lreactbuild_common_CirceExtendedImplicits__decodeOtherMap__Lshapeless_Refute__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder(this$88, ev$5, decodeK$1, decodeV$1);
        return $as_sci_Map(this$89.read__Lio_circe_Json__Lio_circe_Decoder__O(x$2, evidence$1$1))
      })), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue)
    }));
    var $$x2 = new $c_sjsr_AnonFunction1(((r$3$2) => {
      var r$3$1 = $as_Ldiode_data_Pot(r$3$2);
      var this$102 = $m_Lreactbuild_analyze_cost_modules_AccumulatingTable$();
      var $$x5 = $m_sci_SortedSet$();
      $m_Lreactbuild_package$();
      new $c_Lreactbuild_package$DefaultCommonData$$anon$1();
      var this$92 = $n(proxy);
      var this$93 = $n(this$92.Ldiode_react_ModelProxy__f_modelReader);
      var m$1 = $as_Lreactbuild_analyze_cost_services_Model(this$93.value__O());
      if ($n($n(m$1).Lreactbuild_analyze_cost_services_Model__f_commonData).isEmpty__Z()) {
        $n($m_s_package$().s_package$__f_List);
        var $$x3 = $m_sci_Nil$()
      } else {
        var arg1$3 = $n($n(m$1).Lreactbuild_analyze_cost_services_Model__f_commonData).get__O();
        var x$17 = $as_Lreactbuild_model_CommonData(arg1$3);
        var $$x3 = $n(x$17).Lreactbuild_model_CommonData__f_buildingSites
      };
      var this$95 = $n($as_sci_List($$x3));
      var f$1 = ((x$18$2) => {
        var x$18 = $as_Lreactbuild_common_model_Project(x$18$2);
        return $n(x$18).Lreactbuild_common_model_Project__f__id
      });
      if ((this$95 === $m_sci_Nil$())) {
        var $$x4 = $m_sci_Nil$()
      } else {
        var arg1$4 = this$95.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(arg1$4), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(this$95.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$5 = $n(rest$1).head__O();
          var nx$1 = new $c_sci_$colon$colon(f$1(arg1$5), $m_sci_Nil$());
          $n(t$1).sci_$colon$colon__f_next = nx$1;
          t$1 = nx$1;
          rest$1 = $as_sci_List($n(rest$1).tail__O())
        };
        var $$x4 = h$1
      };
      var this$97 = $m_Lreactbuild_model_Implicits$();
      var this$96 = $m_Lreactbuild_model_Implicits$();
      var ev$7 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$96, proxy);
      var items$1 = $as_sci_SortedSet($n($$x5).apply__sci_Seq__O__O($$x4, $f_Lreactbuild_model_LowPriorityImplicits__textualizableOrdering__Lcom_iz2use_common_Textualizable__s_math_Ordering(this$97, ev$7)));
      var this$98 = $n($n(r$3$1).map__F1__Ldiode_data_Pot(new $c_sjsr_AnonFunction1(((x$19$2) => {
        var x$19 = $as_Ljapgolly_scalajs_react_extra_StateSnapshotF(x$19$2);
        return $as_sci_Map($n(x$19).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)
      }))));
      var accumulatings$1 = $as_sci_Map((this$98.isEmpty__Z() ? ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()) : this$98.get__O()));
      var seeMore$1 = new $c_sjsr_AnonFunction1(((d$2$1) => {
        var d$4 = $as_Ljava_time_LocalDate(d$2$1);
        return $n(router).link__O__Ljapgolly_scalajs_react_vdom_TagOf(new $c_Lreactbuild_Loc$TimeReport(new $c_s_Some(d$4)))
      }));
      var from$1 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_from;
      var to$1 = $n($as_Lreactbuild_analyze_cost_components_Period($n(period).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_analyze_cost_components_Period__f_to;
      var this$100 = $m_Lreactbuild_model_Implicits$();
      var rTextualizable$1 = $f_Lreactbuild_model_LowPriorityImplicits__buildingSiteTextualizable__Ldiode_react_ModelProxy__Lcom_iz2use_common_Textualizable(this$100, proxy);
      var accTextualizable$1 = $m_Lreactbuild_model_Implicits$().Lreactbuild_model_Implicits$__f_duration;
      var accNumeric$1 = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_numericDuration;
      var c$1 = this$102.Lreactbuild_analyze_cost_modules_AccumulatingTable$__f_component;
      var $$x6 = $as_Ljapgolly_scalajs_react_CtorType$Props($n(c$1).ctor__Ljapgolly_scalajs_react_CtorType());
      var a$1 = $d_Lreactbuild_model_Duration.getClassOf().getSimpleName__T();
      var this$108 = $n($as_Ljapgolly_scalajs_react_CtorType$Props($n($$x6).withKey__sjs_js_$bar__Ljapgolly_scalajs_react_CtorType(a$1)));
      var props$1 = new $c_Lreactbuild_analyze_cost_modules_AccumulatingTable$TypedProps(proxy, items$1, accumulatings$1, seeMore$1, rTextualizable$1, accTextualizable$1, accNumeric$1, from$1, to$1);
      var u$4 = $as_Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(this$108.Ljapgolly_scalajs_react_CtorType$Props__f_construct).apply__O__O__O(props$1, this$108.Ljapgolly_scalajs_react_CtorType$Props__f_mods));
      var this$110 = $n(u$4);
      var n$4 = this$110.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$4)
    }));
    var this$112 = $m_Ljapgolly_scalajs_react_Reusability$();
    var u$5 = $n($$x11).apply__F0__F1__F2__s_concurrent_ExecutionContext__Ljapgolly_scalajs_react_component_JsFn$UnmountedWithRoot($$x7, $$x2, $m_Ljapgolly_scalajs_react_Reusability$().$bar$bar$extension__F2__F2__F2(this$112.byRef__F2(), this$112.by_$eq$eq__F2()), $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
    var this$114 = $n(u$5);
    var n$5 = this$114.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    var array$7 = [$$x14, $$x12, new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$5)];
    var ns$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
    var array$8 = [$$x16, $n($$x15).page__Ljapgolly_scalajs_react_vdom_VdomNode__Ljapgolly_scalajs_react_vdom_TagOf($p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$119, null, ns$1))];
    return $n($$x32).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
  })), proxy);
  var $$x33 = $m_s_package$().s_package$__f_Seq;
  var this$124 = $n(details);
  var n$6 = this$124.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var array$9 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$6)];
  return $as_sci_Seq($n($$x33).apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9)))
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$__f_title
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.productPrefix__T = (function() {
  return "UsageReports"
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.hashCode__I = (function() {
  return 1214404862
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.toString__T = (function() {
  return "UsageReports"
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__O__F1__sci_Seq = (function(router, proxy, current, setDetailState) {
  return this.apply__Ljapgolly_scalajs_react_extra_router_RouterCtlF__Ldiode_react_ModelProxy__Lreactbuild_model_Resource__F1__sci_Seq(router, proxy, $as_Lreactbuild_model_Resource(current), setDetailState)
});
function $as_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.ResourceDetailViewHandler$UsageReports$"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.ResourceDetailViewHandler$UsageReports$;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$: 0
}, false, "reactbuild.analyze.cost.modules.ResourceDetailViewHandler$UsageReports$", {
  Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$DetailState: 1,
  Lreactbuild_analyze_cost_ui_ItemDetailViewHandler$DetailStateBase: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_ResourceDetailViewHandler$UsageReports$;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this)
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.title__T = (function() {
  return "Fichiers DXF"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.getSectionsFromFeatures__sjs_js_Array__sci_List = (function(features) {
  var b = [];
  var len = $uI(features.length);
  var i = 0;
  while ((i < len)) {
    var arg1 = features[i];
    var value = arg1.get("code_insee");
    var this$11 = $n(((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value)));
    if (this$11.isEmpty__Z()) {
      var ys = $m_s_None$()
    } else {
      var arg1$1 = this$11.get__O();
      var code_insee = $as_T(arg1$1);
      var value$1 = arg1.get("com_abs");
      var this$17 = $n(((value$1 === (void 0)) ? $m_s_None$() : new $c_s_Some(value$1)));
      if (this$17.isEmpty__Z()) {
        var ys = $m_s_None$()
      } else {
        var arg1$2 = this$17.get__O();
        var com_abs = $as_T(arg1$2);
        var value$2 = arg1.get("section");
        var this$23 = $n(((value$2 === (void 0)) ? $m_s_None$() : new $c_s_Some(value$2)));
        if (this$23.isEmpty__Z()) {
          var ys = $m_s_None$()
        } else {
          var arg1$3 = this$23.get__O();
          var section = $as_T(arg1$3);
          var value$3 = arg1.get("feuille");
          var this$29 = $n(((value$3 === (void 0)) ? $m_s_None$() : new $c_s_Some(value$3)));
          if (this$29.isEmpty__Z()) {
            var ys = $m_s_None$()
          } else {
            var arg1$4 = this$29.get__O();
            var feuille = $as_jl_Integer(arg1$4);
            var $$x1 = $m_sc_StringOps$();
            var array = [code_insee, com_abs, section, $uI(feuille)];
            var ys = new $c_s_Some($n($$x1).format$extension__T__sci_Seq__T("%s%s%s%02d", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
          }
        }
      }
    };
    $m_sjs_js_ArrayOps$().addAll$extension__sjs_js_Array__sc_IterableOnce__sjs_js_Array(b, ys);
    i = ((1 + i) | 0)
  };
  var array$1 = $m_sjs_js_ArrayOps$().distinct$extension__sjs_js_Array__sjs_js_Array(b);
  var this$37 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array$1);
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$37)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.getFileUrlFromSection__T__T = (function(section) {
  var this$1 = $n(section);
  if ((this$1.length < 2)) {
    $charAt(this$1, 2)
  };
  var $$x1 = $as_T(this$1.substring(0, 2));
  var this$2 = $n(section);
  if ((this$2.length < 5)) {
    $charAt(this$2, 5)
  };
  return (((((("/api/geo/service/cadastre/dxf/" + $$x1) + "/") + $as_T(this$2.substring(0, 5))) + "/dxf-") + section) + ".tar.bz2")
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.getDocuments__sjs_js_Array__D__T__F1 = (function(coordinates, resolution, projection) {
  var url = $n($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$__f_Site).buildUrl__T__sjs_js_Tuple4__T(projection, ($n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Extent), $i_ol$002fextent.createOrUpdateFromCoordinate(coordinates)));
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
    var $$x1 = $m_sjs_js_Thenable$ThenableOps$();
    var p = fetch(url);
    return $n($$x1).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((res$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
    var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
    var p$1 = res$2.json();
    return $n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((json$2) => {
    var $$x5 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
    var $$x4 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
    var $$x3 = $i_ol$002fformat.GeoJSON;
    $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_GeoJSONOptions);
    var fields = $m_sci_Nil$();
    var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    var geoJson = new $$x3(_\uff3fobj);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x5).flatMap$extension__F1__F1__F1($n($$x4).pure__O__F1(geoJson.readFeaturesFromObject(json$2)), new $c_sjsr_AnonFunction1(((features$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$().getSectionsFromFeatures__sjs_js_Array__sci_List(features$2)), new $c_sjsr_AnonFunction1(((sections$2) => {
      var sections = $as_sci_List(sections$2);
      $n($m_s_package$().s_package$__f_List);
      var array = [new $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links($n(sections).map__F1__sci_List(new $c_sjsr_AnonFunction1(((section$2) => {
        var section = $as_T(section$2);
        var this$12 = $n(section);
        if ((this$12.length < 5)) {
          $charAt(this$12, 5)
        };
        var $$x8 = $as_T(this$12.substring(0, 5));
        var this$13 = $n(section);
        if ((this$13.length < 8)) {
          $charAt(this$13, 8)
        };
        var $$x7 = $as_T(this$13.substring(5, 8));
        var this$14 = $n(section);
        if ((this$14.length < 10)) {
          $charAt(this$14, 10)
        };
        var $$x6 = $as_T(this$14.substring(8, 10));
        var this$15 = $n(section);
        if ((this$15.length < 12)) {
          $charAt(this$15, 12)
        };
        var self = (((((((("Plan " + $$x8) + " ") + $$x7) + " ") + $$x6) + " ") + $as_T(this$15.substring(10, 12))) + ".dxf");
        var y = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$().getFileUrlFromSection__T__T(section);
        return $ct_T2__O__O__(new $c_T2(), self, y)
      }))))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
    }))))))))
  })))))))
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  var $$x1 = $moduleDefault($i_ol$002flayer$002fVector);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  return new $$x1(_\uff3fobj)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.productPrefix__T = (function() {
  return "DXF_files"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.hashCode__I = (function() {
  return 913586730
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.toString__T = (function() {
  return "DXF_files"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$DXF_files$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$: 1,
  Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$DXF\uff3ffiles$
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$__buildFeatureRequest__sjs_js_Array__T__sjs_js_Promise($thiz, coordinates, projection) {
  var url = new URL("/api/geo/service/carto/gpu/document", $as_T(window.location.href));
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "type", "Point");
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_Projections);
  var a = $m_Lreactbuild_analyze_cost_modules_mapview_openlayers_View$().Lreactbuild_analyze_cost_modules_mapview_openlayers_View$__f_WGS84Proj;
  var y = $i_ol$002fproj.transform(coordinates, projection, a);
  var array = [$$x1, $ct_T2__O__O__(new $c_T2(), "coordinates", y)];
  var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var point = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
  url.searchParams.set("geom", $as_T(JSON.stringify(point)));
  var $$x2 = fetch;
  var a$1 = $dp_toString__T($n(url));
  return $$x2(a$1)
}
function $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$__buildDocumentRequest__T__sjs_js_Promise($thiz, id) {
  var url = new URL((("/api/geo/service/document/" + id) + "/details"), $as_T(window.location.href));
  var $$x1 = fetch;
  var a = $dp_toString__T($n(url));
  return $$x1(a)
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  $ct_Lreactbuild_analyze_cost_modules_mapview_Layer__(this)
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.title__T = (function() {
  return "Documents PLU"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  var $$x1 = $moduleDefault($i_ol$002flayer$002fVector);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  return new $$x1(_\uff3fobj)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.getDocuments__sjs_js_Array__D__T__F1 = (function(coordinates, resolution, projection) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
    var $$x1 = $m_sjs_js_Thenable$ThenableOps$();
    var p = $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$__buildFeatureRequest__sjs_js_Array__T__sjs_js_Promise($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$(), coordinates, projection);
    return $n($$x1).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((res$2) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
    var $$x2 = $m_sjs_js_Thenable$ThenableOps$();
    var p$1 = res$2.text();
    return $n($$x2).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$1)
  })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((text$2) => {
    var text = $as_T(text$2);
    return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
      var $$x4 = $m_s_concurrent_Future$();
      var this$6 = $m_Lio_circe_parser_package$();
      var evidence$1 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest$__f_decodeFeatureRequest;
      var $$x3 = $f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either(this$6, text, evidence$1);
      var this$7 = $m_s_$less$colon$less$();
      return $n($$x4).fromTry__s_util_Try__s_concurrent_Future($n($$x3).toTry__s_$less$colon$less__s_util_Try(this$7.s_$less$colon$less$__f_singleton))
    })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((result$2) => {
      var result = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest(result$2);
      var $$x5 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
      var this$9 = $n($n($n(result).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequest__f_features).headOption__s_Option());
      var ifEmpty = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).throwException__F0__F1(new $c_sjsr_AnonFunction0((() => $ct_jl_Exception__T__(new $c_jl_Exception(), "No feature found :")))))));
      var f = new $c_sjsr_AnonFunction1(((feature$2) => {
        var feature = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry(feature$2);
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).pure__O__F1($n($n(feature).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntry__f_properties).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$FeatureRequestEntryProperties__f_id))
      }));
      return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x5).flatMap$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback((this$9.isEmpty__Z() ? ifEmpty.apply__O() : f.apply__O__O(this$9.get__O())))).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, new $c_sjsr_AnonFunction1(((id$2) => {
        var id = $as_T(id$2);
        return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
          var $$x6 = $m_sjs_js_Thenable$ThenableOps$();
          var p$2 = $p_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$__buildDocumentRequest__T__sjs_js_Promise($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$(), id);
          return $n($$x6).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$2)
        })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((res$2$1) => new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
          var $$x7 = $m_sjs_js_Thenable$ThenableOps$();
          var p$3 = res$2$1.text();
          return $n($$x7).toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p$3)
        })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((text$2$1) => {
          var text$1 = $as_T(text$2$1);
          return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback).fromFuture__F0__s_concurrent_ExecutionContext__F1(new $c_sjsr_AnonFunction0((() => {
            var $$x9 = $m_s_concurrent_Future$();
            var this$14 = $m_Lio_circe_parser_package$();
            var evidence$1$1 = $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse$__f_decodeDocumentResponse;
            var $$x8 = $f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either(this$14, text$1, evidence$1$1);
            var this$15 = $m_s_$less$colon$less$();
            return $n($$x9).fromTry__s_util_Try__s_concurrent_Future($n($$x8).toTry__s_$less$colon$less__s_util_Try(this$15.s_$less$colon$less$__f_singleton))
          })), $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()), new $c_sjsr_AnonFunction1(((result$2$1) => {
            var result$1 = $as_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse(result$2$1);
            var $$x11 = $m_Ljapgolly_scalajs_react_callback_AsyncCallback$();
            var $$x10 = $m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_AsyncCallback;
            var this$17 = $n($n(result$1).Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$DocumentResponse__f_writingMaterials);
            return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($n($$x11).map$extension__F1__F1__F1($n($$x10).pure__O__F1(new $c_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$17))), new $c_sjsr_AnonFunction1(((links$2) => {
              var links = $as_Lreactbuild_analyze_cost_modules_mapview_FeatureInfo$Links(links$2);
              $n($m_s_package$().s_package$__f_List);
              var array = [links];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
            }))))
          }))))
        }))))))))
      }))))
    }))))
  })))))))
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.productPrefix__T = (function() {
  return "PLU_documents"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.hashCode__I = (function() {
  return 555534290
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.toString__T = (function() {
  return "PLU_documents"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$PLU_documents$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$: 1,
  Lreactbuild_analyze_cost_modules_mapview_OnlyFeatureInfo: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$PLU\uff3fdocuments$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$() {
  this.Lreactbuild_analyze_cost_modules_mapview_Layer__f_id = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_source = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_evidence$1 = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_format = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__f_bitmap$0 = false;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_category = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_title = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_baseUrl = null;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_innerRadius = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_outerRadius = 0.0;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_halfDelta = 0.0;
  $ct_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer__Lio_circe_Decoder__(this, $m_Lreactbuild_model_MapFeature$MapFeature$().Lreactbuild_model_MapFeature$MapFeature$__f_codecForMapFeature);
  $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$ = this;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_category = $m_Lreactbuild_analyze_cost_modules_mapview_MapCategory$().Lreactbuild_analyze_cost_modules_mapview_MapCategory$__f_BaseMap;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_title = "Mes donn\u00e9es";
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_baseUrl = "/api/mapFeatures/wfs";
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_innerRadius = 7.0;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_outerRadius = 21.0;
  this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_halfDelta = 0.7853981633974483
}
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype = new $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer();
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.category__Lreactbuild_analyze_cost_modules_mapview_MapCategory = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_category
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.title__T = (function() {
  return this.Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_title
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.idOf__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x$3$2) => {
    var x$3 = $as_Lreactbuild_model_MapFeature$MapFeature(x$3$2);
    return $n(x$3)._id__Lreactbuild_common_model_RefTo()
  }))
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.render__Ltypings_ol_layerBaseMod$default = (function() {
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_StyleOptions);
  var fields = $m_sci_Nil$();
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var value = new $c_sjsr_AnonFunction2(((coordinates$2, state$2) => {
    $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
    var f = new $c_sjsr_AnonFunction0((() => {
      var ctx = state$2.context;
      $uD(state$2.rotation);
      var x = $uD(coordinates$2[0]);
      var y = $uD(coordinates$2[1]);
      ctx.beginPath();
      ctx.arc(x, y, $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$__f_innerRadius, 0.0, 6.283185307179586, true);
      ctx.closePath();
      ctx.fillStyle = "#0000ff";
      ctx.fill();
      $n($as_Lreactbuild_model_MapFeature$MapFeature($m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$().getData__sjs_js_$bar__O(state$2.feature)))
    }));
    var f$1 = new $c_sjsr_AnonFunction0((() => {
      f.apply__O()
    }));
    $m_Ljapgolly_scalajs_react_callback_Trampoline$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1))
  }));
  var value$1 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(new $c_sjsr_AnonFunction2(((t0$2, t1$2) => {
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(value.apply__O__O__O(t0$2, t1$2))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$12 = $n(this$);
    $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$12)
  })));
  _\uff3fobj.renderer = value$1;
  new $i_ol$002fstyle.Style(_\uff3fobj);
  $n($m_Lreactbuild_analyze_cost_modules_mapview_MapImports$().Lreactbuild_analyze_cost_modules_mapview_MapImports$__f_VectorLayerOptions);
  var fields$1 = $m_sci_Nil$();
  var _\uff3fobj$1 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
  var value$2 = this.source__Ltypings_ol_sourceVectorMod$default();
  _\uff3fobj$1.source = value$2;
  var value$3 = new $c_sjsr_AnonFunction2(((feature$2, res$2) => {
    var res = $uD(res$2);
    var a = $m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$().styleDrawing__sjs_js_$bar__D__Z__sjs_js_Array(feature$2, res, ($m_Lreactbuild_analyze_cost_modules_mapview_MapStyle$(), false));
    return a
  }));
  var value$4 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(value$3);
  _\uff3fobj$1.style = value$4;
  _\uff3fobj$1.minZoom = 17.0;
  return new ($moduleDefault($i_ol$002flayer$002fVector))(_\uff3fobj$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.productPrefix__T = (function() {
  return "Reactbuild"
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.hashCode__I = (function() {
  return 1533993071
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.toString__T = (function() {
  return "Reactbuild"
});
var $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$: 0
}, false, "reactbuild.analyze.cost.modules.mapview.LayerLibrary$Reactbuild$", {
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$: 1,
  Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$ReactbuildLayer: 1,
  Lreactbuild_analyze_cost_modules_mapview_Layer: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$;
var $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$;
function $m_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$)) {
    $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$ = new $c_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$()
  };
  return $n_Lreactbuild_analyze_cost_modules_mapview_LayerLibrary$Reactbuild$
}
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName(cityName) {
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName__f_cityName = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName__f_cityName = cityName
}
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype.productPrefix__T = (function() {
  return "CityName"
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName__f_cityName : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName)) {
    var CityName$1 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName(x$1);
    return (this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName__f_cityName === $n(CityName$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName__f_cityName)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$CityName"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.ParsedMapQuery$CityName;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName: 0
}, false, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$CityName", {
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea: 1,
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityName;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode(postalCode) {
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode__f_postalCode = null;
  this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode__f_postalCode = postalCode
}
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype.productPrefix__T = (function() {
  return "PostalCode"
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode__f_postalCode : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode)) {
    var PostalCode$1 = $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode(x$1);
    return (this.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode__f_postalCode === $n(PostalCode$1).Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode__f_postalCode)
  } else {
    return false
  }
});
function $as_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$PostalCode"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.ParsedMapQuery$PostalCode;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode: 0
}, false, "reactbuild.analyze.cost.modules.mapview.ParsedMapQuery$PostalCode", {
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$CityArea: 1,
  Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_ParsedMapQuery$PostalCode;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active(pointerType, lastDistanceAndMidPoint, lastPoint, initialPoint, startAt, maxActiveCursor) {
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType = null;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastDistanceAndMidPoint = null;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastPoint = null;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_initialPoint = null;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_startAt = 0.0;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_maxActiveCursor = 0;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType = pointerType;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastDistanceAndMidPoint = lastDistanceAndMidPoint;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastPoint = lastPoint;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_initialPoint = initialPoint;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_startAt = startAt;
  this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_maxActiveCursor = maxActiveCursor
}
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_DragPan$Active() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype = $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.updateTracked__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_DragPan$Active = (function(trackedPointers) {
  var newPoint = $n(trackedPointers).centroid__Lreactbuild_common_components_Input$CursorType__Lreactbuild_geom_Vector2Based(this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType);
  var x = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType;
  var x$2 = $m_Lreactbuild_common_components_Input$Touch$();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $$x1 = (this$1 === x$2)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var nextDistance = $n(trackedPointers).touchDistance__s_Option()
  } else {
    var nextDistance = $m_s_None$()
  };
  var a = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_maxActiveCursor;
  var b = $n(trackedPointers).count__Lreactbuild_common_components_Input$CursorType__I(this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType);
  var x$3 = ((a > b) ? a : b);
  var x$4 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType;
  var x$5 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_initialPoint;
  var x$6 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_startAt;
  return new $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active(x$4, nextDistance, newPoint, x$5, x$6, x$3)
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_PlannerContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var way = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var coords = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_coords;
    var timestamp = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_timestamp;
    var x = $n(coords).Lreactbuild_common_components_Input$Coords__f_cursor;
    var x$2 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ((!$$x1)) {
      return new $c_Lreactbuild_common_components_Continue(this, $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var x$3 = $m_Lreactbuild_common_components_Input$Start$();
      if ((x$3 === way)) {
        var next = this.updateTracked__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_DragPan$Active(trackedPointers);
        return new $c_Lreactbuild_common_components_Continue(next, $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
      } else {
        var x$5 = $m_Lreactbuild_common_components_Input$Move$();
        if ((x$5 === way)) {
          var next$2 = this.updateTracked__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_DragPan$Active(trackedPointers);
          var this$4 = $n($n(next$2).Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastPoint);
          var that = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastPoint;
          var delta = new $c_Lreactbuild_geom_Vector2((this$4.x__D() - $n(that).x__D()), (this$4.y__D() - $n(that).y__D()));
          var this$6 = $n(this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastDistanceAndMidPoint);
          var p = new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
            var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
            return (check$ifrefutable$1 !== null)
          }));
          var this$7 = new $c_s_Option$WithFilter(this$6, p);
          var this$8 = $n(this$7.s_Option$WithFilter__f_$outer);
          var p$1 = this$7.s_Option$WithFilter__f_p;
          var this$9 = $n(((this$8.isEmpty__Z() || $uZ($n(p$1).apply__O__O(this$8.get__O()))) ? this$8 : $m_s_None$()));
          if (this$9.isEmpty__Z()) {
            var zoomOpt = $m_s_None$()
          } else {
            var arg1 = this$9.get__O();
            var x$3$2 = $as_T2(arg1);
            if ((x$3$2 === null)) {
              throw new $c_s_MatchError(x$3$2)
            };
            var prev = $n(x$3$2)._1$mcD$sp__D();
            var this$11 = $n($n(next$2).Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastDistanceAndMidPoint);
            var p$2 = new $c_sjsr_AnonFunction1(((check$ifrefutable$2$2) => {
              var check$ifrefutable$2 = $as_T2(check$ifrefutable$2$2);
              return (check$ifrefutable$2 !== null)
            }));
            var this$12 = $n(new $c_s_Option$WithFilter(this$11, p$2).withFilter__F1__s_Option$WithFilter(new $c_sjsr_AnonFunction1(((x$1$2) => {
              var x$1 = $as_T2(x$1$2);
              if ((x$1 !== null)) {
                return (prev !== 0.0)
              } else {
                throw new $c_s_MatchError(x$1)
              }
            }))));
            var this$13 = $n(this$12.s_Option$WithFilter__f_$outer);
            var p$3 = this$12.s_Option$WithFilter__f_p;
            var this$14 = $n(((this$13.isEmpty__Z() || $uZ($n(p$3).apply__O__O(this$13.get__O()))) ? this$13 : $m_s_None$()));
            if (this$14.isEmpty__Z()) {
              var zoomOpt = $m_s_None$()
            } else {
              var arg1$1 = this$14.get__O();
              var x$2$1 = $as_T2(arg1$1);
              if ((x$2$1 === null)) {
                throw new $c_s_MatchError(x$2$1)
              };
              var curr = $n(x$2$1)._1$mcD$sp__D();
              var pt = $as_Lreactbuild_geom_Vector2Based($n(x$2$1)._2__O());
              var zoomOpt = new $c_s_Some(new $c_T2$mcDD$sp($n(pt).x__D(), (prev / curr)))
            }
          };
          var this$15 = $n(zoomOpt);
          var zoom = $as_T2((this$15.isEmpty__Z() ? new $c_T2$mcDD$sp(0.0, 1.0) : this$15.get__O()));
          return new $c_Lreactbuild_common_components_Continue(next$2, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(context).Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_zoomAndTranslate).apply__O__O__O__O__O($n(zoom)._1$mcD$sp__D(), $n(zoom)._2$mcD$sp__D(), delta.Lreactbuild_geom_Vector2__f_x, delta.Lreactbuild_geom_Vector2__f_y))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
        } else {
          var x$7 = $m_Lreactbuild_common_components_Input$Cancel$();
          if ((x$7 === way)) {
            console.log("cancel");
            return $m_Lreactbuild_common_components_Skip$()
          } else {
            var x$9 = $m_Lreactbuild_common_components_Input$End$();
            if ((x$9 === way)) {
              var $$x2 = true
            } else {
              var x$11 = $m_Lreactbuild_common_components_Input$Out$();
              if ((x$11 === way)) {
                var $$x2 = true
              } else {
                var x$13 = $m_Lreactbuild_common_components_Input$Leave$();
                var $$x2 = (x$13 === way)
              }
            };
            if ($$x2) {
              var x$16 = $m_Lreactbuild_common_components_Input$End$();
              if ((way !== null)) {
                var this$16 = $n(way);
                var $$x4 = (this$16 === x$16)
              } else {
                var $$x4 = false
              };
              if ((($$x4 && (this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_maxActiveCursor === 1)) && ((timestamp - this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_startAt) <= 150.0))) {
                var this$17 = $n(coords);
                var that$1 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_initialPoint;
                var this$18 = new $c_Lreactbuild_geom_Vector2((this$17.Lreactbuild_common_components_Input$Coords__f_x - $n(that$1).x__D()), (this$17.Lreactbuild_common_components_Input$Coords__f_y - $n(that$1).y__D()));
                if ((this$18.Lreactbuild_geom_Vector2__f_x === 0.0)) {
                  $m_Lreactbuild_math_package$SquareRoot$();
                  var x$4 = this$18.Lreactbuild_geom_Vector2__f_y;
                  var length = $uD(Math.abs(x$4));
                  var sq = (length * length);
                  var sqrt = $uD(Math.abs(length));
                  var $$x5 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt)
                } else if ((this$18.Lreactbuild_geom_Vector2__f_y === 0.0)) {
                  $m_Lreactbuild_math_package$SquareRoot$();
                  var x$6 = this$18.Lreactbuild_geom_Vector2__f_x;
                  var length$1 = $uD(Math.abs(x$6));
                  var sq$1 = (length$1 * length$1);
                  var sqrt$1 = $uD(Math.abs(length$1));
                  var $$x5 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$1, sqrt$1)
                } else {
                  $m_Lreactbuild_math_package$SquareRoot$();
                  var v = this$18.Lreactbuild_geom_Vector2__f_x;
                  var v$1 = this$18.Lreactbuild_geom_Vector2__f_y;
                  var value = ((v * v) + (v$1 * v$1));
                  var $$x5 = new $c_Lreactbuild_math_package$LazySquareRoot(value)
                };
                var this$44 = $n($$x5);
                var x$8 = ($n(this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType).Lreactbuild_common_components_Input$CursorType__f_precision / 2.0);
                var $$x3 = (this$44.sq__D() <= (x$8 * x$8))
              } else {
                var $$x3 = false
              };
              if ($$x3) {
                return new $c_Lreactbuild_common_components_Done($m_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$(), $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(context).Lreactbuild_analyze_cost_modules_planner_PlannerContext__f_create).apply__O__O($n(coords).Lreactbuild_common_components_Input$Coords__f_x))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
              } else {
                return (($n(trackedPointers).count__Lreactbuild_common_components_Input$CursorType__I(this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType) === 0) ? new $c_Lreactbuild_common_components_Done($m_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$(), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty) : new $c_Lreactbuild_common_components_Continue(this.updateTracked__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_DragPan$Active(trackedPointers), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty))
              }
            } else {
              return $m_Lreactbuild_common_components_Skip$()
            }
          }
        }
      }
    }
  } else {
    return $m_Lreactbuild_common_components_Skip$()
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.productPrefix__T = (function() {
  return "Active"
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType;
      break
    }
    case 1: {
      return this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastDistanceAndMidPoint;
      break
    }
    case 2: {
      return this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastPoint;
      break
    }
    case 3: {
      return this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_initialPoint;
      break
    }
    case 4: {
      return this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_startAt;
      break
    }
    case 5: {
      return this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_maxActiveCursor;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Active");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastDistanceAndMidPoint;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastPoint;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_initialPoint;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var dv = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_startAt;
  var data$5 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_maxActiveCursor;
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active)) {
    var Active$1 = $as_Lreactbuild_analyze_cost_modules_planner_DragPan$Active(x$1);
    if ((this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_startAt === $n(Active$1).Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_startAt)) {
      if ((this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_maxActiveCursor === $n(Active$1).Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_maxActiveCursor)) {
        var x = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType;
        var x$2 = $n(Active$1).Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_pointerType;
        if ((x === null)) {
          var $$x1 = (x$2 === null)
        } else {
          var this$1 = $n(x);
          var $$x1 = (this$1 === x$2)
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastDistanceAndMidPoint;
      var x$4 = $n(Active$1).Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastDistanceAndMidPoint;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastPoint;
        var x$6 = $n(Active$1).Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_lastPoint;
        if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
          var x$7 = this.Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_initialPoint;
          var x$8 = $n(Active$1).Lreactbuild_analyze_cost_modules_planner_DragPan$Active__f_initialPoint;
          return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return this.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_PlannerContext__Lreactbuild_common_components_InteractionResult(ev, trackedPointers, $as_Lreactbuild_analyze_cost_modules_planner_PlannerContext(context))
});
function $as_Lreactbuild_analyze_cost_modules_planner_DragPan$Active(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.planner.DragPan$Active"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_planner_DragPan$Active(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_planner_DragPan$Active)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_planner_DragPan$Active(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_planner_DragPan$Active(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.planner.DragPan$Active;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_planner_DragPan$Active = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_DragPan$Active: 0
}, false, "reactbuild.analyze.cost.modules.planner.DragPan$Active", {
  Lreactbuild_analyze_cost_modules_planner_DragPan$Active: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_planner_DragPan: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_DragPan$Active;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$() {
  /*<skip>*/
}
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype = $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype;
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_PlannerContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var p3 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var coords = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_coords;
    var p4 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_button;
    var p9 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
    var timestamp = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_timestamp;
    var x = $m_Lreactbuild_common_components_Input$Start$();
    if ((x === p3)) {
      var x$3 = $m_Lreactbuild_common_components_Input$Left$();
      if ((x$3 === p4)) {
        var $$x2 = true
      } else {
        var x$5 = $m_Lreactbuild_common_components_Input$Middle$();
        var $$x2 = (x$5 === p4)
      };
      if ($$x2) {
        var x$7 = $m_Lreactbuild_common_components_Input$ModifierKey$None$();
        if ((x$7 === p9)) {
          var $$x3 = true
        } else {
          var x$9 = $m_Lreactbuild_common_components_Input$ModifierKey$Shift$();
          var $$x3 = (x$9 === p9)
        };
        if ($$x3) {
          var x$11 = $n(coords).Lreactbuild_common_components_Input$Coords__f_cursor;
          var x$12 = $m_Lreactbuild_common_components_Input$Touch$();
          if ((x$11 !== null)) {
            var this$1 = $n(x$11);
            var $$x4 = (this$1 === x$12)
          } else {
            var $$x4 = false
          };
          if ((!$$x4)) {
            var $$x1 = true
          } else {
            var $$x1 = ($n(trackedPointers).count__Lreactbuild_common_components_Input$CursorType__I($n(coords).Lreactbuild_common_components_Input$Coords__f_cursor) <= 2)
          }
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      console.log(("active : " + x2));
      var x$1 = $n(coords).Lreactbuild_common_components_Input$Coords__f_cursor;
      var x$5$2 = $m_s_None$();
      return new $c_Lreactbuild_common_components_Continue(new $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Active(x$1, x$5$2, coords, coords, timestamp, 1), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    }
  };
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.productPrefix__T = (function() {
  return "Idle"
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.hashCode__I = (function() {
  return 2274292
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.toString__T = (function() {
  return "Idle"
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return this.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_analyze_cost_modules_planner_PlannerContext__Lreactbuild_common_components_InteractionResult(ev, trackedPointers, $as_Lreactbuild_analyze_cost_modules_planner_PlannerContext(context))
});
var $d_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$ = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$: 0
}, false, "reactbuild.analyze.cost.modules.planner.DragPan$Idle$", {
  Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$: 1,
  O: 1,
  Lreactbuild_analyze_cost_modules_planner_DragPan: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$;
var $n_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$;
function $m_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$() {
  if ((!$n_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$)) {
    $n_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$ = new $c_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$()
  };
  return $n_Lreactbuild_analyze_cost_modules_planner_DragPan$Idle$
}
/** @constructor */
function $c_Lreactbuild_common_components_Continue(state, cb) {
  this.Lreactbuild_common_components_Continue__f_state = null;
  this.Lreactbuild_common_components_Continue__f_cb = null;
  this.Lreactbuild_common_components_Continue__f_state = state;
  this.Lreactbuild_common_components_Continue__f_cb = cb
}
$c_Lreactbuild_common_components_Continue.prototype = new $h_O();
$c_Lreactbuild_common_components_Continue.prototype.constructor = $c_Lreactbuild_common_components_Continue;
/** @constructor */
function $h_Lreactbuild_common_components_Continue() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Continue.prototype = $c_Lreactbuild_common_components_Continue.prototype;
$c_Lreactbuild_common_components_Continue.prototype.state__O = (function() {
  return this.Lreactbuild_common_components_Continue__f_state
});
$c_Lreactbuild_common_components_Continue.prototype.cb__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  return this.Lreactbuild_common_components_Continue__f_cb
});
$c_Lreactbuild_common_components_Continue.prototype.map__F1__Lreactbuild_common_components_InteractionResult = (function(f) {
  return new $c_Lreactbuild_common_components_Continue($n(f).apply__O__O(this.Lreactbuild_common_components_Continue__f_state), this.Lreactbuild_common_components_Continue__f_cb)
});
$c_Lreactbuild_common_components_Continue.prototype.isDone__Z = (function() {
  return false
});
$c_Lreactbuild_common_components_Continue.prototype.transformValueToCB__F0__F1__Lreactbuild_common_components_InteractionResult = (function(newState, f) {
  return new $c_Lreactbuild_common_components_Continue($n(newState).apply__O(), $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(f).apply__O__O(this.Lreactbuild_common_components_Continue__f_state))).apply__O__O(new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_common_components_Continue__f_cb)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
});
$c_Lreactbuild_common_components_Continue.prototype.productPrefix__T = (function() {
  return "Continue"
});
$c_Lreactbuild_common_components_Continue.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_components_Continue.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_Continue__f_state;
      break
    }
    case 1: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_common_components_Continue__f_cb);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_Continue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Continue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_components_Continue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_Continue.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_Continue)) {
    var Continue$1 = $as_Lreactbuild_common_components_Continue(x$1);
    var x = this.Lreactbuild_common_components_Continue__f_state;
    var y = $n(Continue$1).Lreactbuild_common_components_Continue__f_state;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_common_components_Continue__f_cb;
      var x$2$1 = $n(Continue$1).Lreactbuild_common_components_Continue__f_cb;
      if ((x$2 === null)) {
        return (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$2$1)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_Continue(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_Continue) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Continue"))
}
function $isArrayOf_Lreactbuild_common_components_Continue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Continue)))
}
function $asArrayOf_Lreactbuild_common_components_Continue(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Continue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Continue;", depth))
}
var $d_Lreactbuild_common_components_Continue = new $TypeData().initClass({
  Lreactbuild_common_components_Continue: 0
}, false, "reactbuild.common.components.Continue", {
  Lreactbuild_common_components_Continue: 1,
  O: 1,
  Lreactbuild_common_components_ProcessedInteractionResult: 1,
  Lreactbuild_common_components_InteractionResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Continue.prototype.$classData = $d_Lreactbuild_common_components_Continue;
/** @constructor */
function $c_Lreactbuild_common_components_Done(state, cb) {
  this.Lreactbuild_common_components_Done__f_state = null;
  this.Lreactbuild_common_components_Done__f_cb = null;
  this.Lreactbuild_common_components_Done__f_state = state;
  this.Lreactbuild_common_components_Done__f_cb = cb
}
$c_Lreactbuild_common_components_Done.prototype = new $h_O();
$c_Lreactbuild_common_components_Done.prototype.constructor = $c_Lreactbuild_common_components_Done;
/** @constructor */
function $h_Lreactbuild_common_components_Done() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Done.prototype = $c_Lreactbuild_common_components_Done.prototype;
$c_Lreactbuild_common_components_Done.prototype.state__O = (function() {
  return this.Lreactbuild_common_components_Done__f_state
});
$c_Lreactbuild_common_components_Done.prototype.cb__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  return this.Lreactbuild_common_components_Done__f_cb
});
$c_Lreactbuild_common_components_Done.prototype.map__F1__Lreactbuild_common_components_InteractionResult = (function(f) {
  return new $c_Lreactbuild_common_components_Done($n(f).apply__O__O(this.Lreactbuild_common_components_Done__f_state), this.Lreactbuild_common_components_Done__f_cb)
});
$c_Lreactbuild_common_components_Done.prototype.isDone__Z = (function() {
  return true
});
$c_Lreactbuild_common_components_Done.prototype.transformValueToCB__F0__F1__Lreactbuild_common_components_InteractionResult = (function(newState, f) {
  return new $c_Lreactbuild_common_components_Done($n(newState).apply__O(), $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_F1($n(f).apply__O__O(this.Lreactbuild_common_components_Done__f_state))).apply__O__O(new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_common_components_Done__f_cb)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
});
$c_Lreactbuild_common_components_Done.prototype.productPrefix__T = (function() {
  return "Done"
});
$c_Lreactbuild_common_components_Done.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_common_components_Done.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_Done__f_state;
      break
    }
    case 1: {
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.Lreactbuild_common_components_Done__f_cb);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_Done.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Done.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_common_components_Done.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_Done.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_Done)) {
    var Done$1 = $as_Lreactbuild_common_components_Done(x$1);
    var x = this.Lreactbuild_common_components_Done__f_state;
    var y = $n(Done$1).Lreactbuild_common_components_Done__f_state;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lreactbuild_common_components_Done__f_cb;
      var x$2$1 = $n(Done$1).Lreactbuild_common_components_Done__f_cb;
      if ((x$2 === null)) {
        return (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$2$1)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_Done(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_Done) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Done"))
}
function $isArrayOf_Lreactbuild_common_components_Done(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Done)))
}
function $asArrayOf_Lreactbuild_common_components_Done(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Done(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Done;", depth))
}
var $d_Lreactbuild_common_components_Done = new $TypeData().initClass({
  Lreactbuild_common_components_Done: 0
}, false, "reactbuild.common.components.Done", {
  Lreactbuild_common_components_Done: 1,
  O: 1,
  Lreactbuild_common_components_ProcessedInteractionResult: 1,
  Lreactbuild_common_components_InteractionResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Done.prototype.$classData = $d_Lreactbuild_common_components_Done;
/** @constructor */
function $c_Lreactbuild_common_components_Input$Back$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Back$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Back$.prototype.constructor = $c_Lreactbuild_common_components_Input$Back$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Back$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Back$.prototype = $c_Lreactbuild_common_components_Input$Back$.prototype;
$c_Lreactbuild_common_components_Input$Back$.prototype.productPrefix__T = (function() {
  return "Back"
});
$c_Lreactbuild_common_components_Input$Back$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Back$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Back$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Back$.prototype.hashCode__I = (function() {
  return 2062599
});
$c_Lreactbuild_common_components_Input$Back$.prototype.toString__T = (function() {
  return "Back"
});
var $d_Lreactbuild_common_components_Input$Back$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Back$: 0
}, false, "reactbuild.common.components.Input$Back$", {
  Lreactbuild_common_components_Input$Back$: 1,
  O: 1,
  Lreactbuild_common_components_Input$MouseButton: 1,
  Lreactbuild_common_components_Input$PointerButton: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Back$.prototype.$classData = $d_Lreactbuild_common_components_Input$Back$;
var $n_Lreactbuild_common_components_Input$Back$;
function $m_Lreactbuild_common_components_Input$Back$() {
  if ((!$n_Lreactbuild_common_components_Input$Back$)) {
    $n_Lreactbuild_common_components_Input$Back$ = new $c_Lreactbuild_common_components_Input$Back$()
  };
  return $n_Lreactbuild_common_components_Input$Back$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Cancel$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Cancel$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Cancel$.prototype.constructor = $c_Lreactbuild_common_components_Input$Cancel$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Cancel$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Cancel$.prototype = $c_Lreactbuild_common_components_Input$Cancel$.prototype;
$c_Lreactbuild_common_components_Input$Cancel$.prototype.productPrefix__T = (function() {
  return "Cancel"
});
$c_Lreactbuild_common_components_Input$Cancel$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Cancel$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Cancel$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Cancel$.prototype.hashCode__I = (function() {
  return 2011110042
});
$c_Lreactbuild_common_components_Input$Cancel$.prototype.toString__T = (function() {
  return "Cancel"
});
var $d_Lreactbuild_common_components_Input$Cancel$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Cancel$: 0
}, false, "reactbuild.common.components.Input$Cancel$", {
  Lreactbuild_common_components_Input$Cancel$: 1,
  O: 1,
  Lreactbuild_common_components_Input$TouchWay: 1,
  Lreactbuild_common_components_Input$PointerWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Cancel$.prototype.$classData = $d_Lreactbuild_common_components_Input$Cancel$;
var $n_Lreactbuild_common_components_Input$Cancel$;
function $m_Lreactbuild_common_components_Input$Cancel$() {
  if ((!$n_Lreactbuild_common_components_Input$Cancel$)) {
    $n_Lreactbuild_common_components_Input$Cancel$ = new $c_Lreactbuild_common_components_Input$Cancel$()
  };
  return $n_Lreactbuild_common_components_Input$Cancel$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Coords(x, y, cursor) {
  this.Lreactbuild_common_components_Input$Coords__f_x = 0.0;
  this.Lreactbuild_common_components_Input$Coords__f_y = 0.0;
  this.Lreactbuild_common_components_Input$Coords__f_cursor = null;
  this.Lreactbuild_common_components_Input$Coords__f_x = x;
  this.Lreactbuild_common_components_Input$Coords__f_y = y;
  this.Lreactbuild_common_components_Input$Coords__f_cursor = cursor
}
$c_Lreactbuild_common_components_Input$Coords.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Coords.prototype.constructor = $c_Lreactbuild_common_components_Input$Coords;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Coords() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Coords.prototype = $c_Lreactbuild_common_components_Input$Coords.prototype;
$c_Lreactbuild_common_components_Input$Coords.prototype.x__D = (function() {
  return this.Lreactbuild_common_components_Input$Coords__f_x
});
$c_Lreactbuild_common_components_Input$Coords.prototype.y__D = (function() {
  return this.Lreactbuild_common_components_Input$Coords__f_y
});
$c_Lreactbuild_common_components_Input$Coords.prototype.toString__T = (function() {
  var $$x1 = $m_sc_StringOps$();
  var array = [this.Lreactbuild_common_components_Input$Coords__f_x, this.Lreactbuild_common_components_Input$Coords__f_y, this.Lreactbuild_common_components_Input$Coords__f_cursor];
  return $n($$x1).format$extension__T__sci_Seq__T("Coords(%5f,%5f, %s)", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_common_components_Input$Coords.prototype.productPrefix__T = (function() {
  return "Coords"
});
$c_Lreactbuild_common_components_Input$Coords.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_common_components_Input$Coords.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_Input$Coords__f_x;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_Input$Coords__f_y;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_Input$Coords__f_cursor;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_Input$Coords.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Coords.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Coords");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_common_components_Input$Coords__f_x;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_common_components_Input$Coords__f_y;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x = this.Lreactbuild_common_components_Input$Coords__f_cursor;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_common_components_Input$Coords.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_Input$Coords)) {
    var Coords$1 = $as_Lreactbuild_common_components_Input$Coords(x$1);
    if (((this.Lreactbuild_common_components_Input$Coords__f_x === $n(Coords$1).Lreactbuild_common_components_Input$Coords__f_x) && (this.Lreactbuild_common_components_Input$Coords__f_y === $n(Coords$1).Lreactbuild_common_components_Input$Coords__f_y))) {
      var x = this.Lreactbuild_common_components_Input$Coords__f_cursor;
      var x$2 = $n(Coords$1).Lreactbuild_common_components_Input$Coords__f_cursor;
      if ((x === null)) {
        var $$x1 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === x$2)
      };
      if ($$x1) {
        $n(Coords$1);
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_Input$Coords(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_Input$Coords) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Input$Coords"))
}
function $isArrayOf_Lreactbuild_common_components_Input$Coords(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Input$Coords)))
}
function $asArrayOf_Lreactbuild_common_components_Input$Coords(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Input$Coords(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Input$Coords;", depth))
}
var $d_Lreactbuild_common_components_Input$Coords = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Coords: 0
}, false, "reactbuild.common.components.Input$Coords", {
  Lreactbuild_common_components_Input$Coords: 1,
  O: 1,
  Lreactbuild_geom_Point2Based: 1,
  Lreactbuild_geom_Vector2Based: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Coords.prototype.$classData = $d_Lreactbuild_common_components_Input$Coords;
/** @constructor */
function $c_Lreactbuild_common_components_Input$DontKnow$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$DontKnow$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$DontKnow$.prototype.constructor = $c_Lreactbuild_common_components_Input$DontKnow$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$DontKnow$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$DontKnow$.prototype = $c_Lreactbuild_common_components_Input$DontKnow$.prototype;
$c_Lreactbuild_common_components_Input$DontKnow$.prototype.productPrefix__T = (function() {
  return "DontKnow"
});
$c_Lreactbuild_common_components_Input$DontKnow$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$DontKnow$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$DontKnow$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$DontKnow$.prototype.hashCode__I = (function() {
  return 1239357916
});
$c_Lreactbuild_common_components_Input$DontKnow$.prototype.toString__T = (function() {
  return "DontKnow"
});
var $d_Lreactbuild_common_components_Input$DontKnow$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$DontKnow$: 0
}, false, "reactbuild.common.components.Input$DontKnow$", {
  Lreactbuild_common_components_Input$DontKnow$: 1,
  O: 1,
  Lreactbuild_common_components_Input$KeyboardLocation: 1,
  Lreactbuild_common_components_Input$MouseButton: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$DontKnow$.prototype.$classData = $d_Lreactbuild_common_components_Input$DontKnow$;
var $n_Lreactbuild_common_components_Input$DontKnow$;
function $m_Lreactbuild_common_components_Input$DontKnow$() {
  if ((!$n_Lreactbuild_common_components_Input$DontKnow$)) {
    $n_Lreactbuild_common_components_Input$DontKnow$ = new $c_Lreactbuild_common_components_Input$DontKnow$()
  };
  return $n_Lreactbuild_common_components_Input$DontKnow$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Enter$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Enter$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Enter$.prototype.constructor = $c_Lreactbuild_common_components_Input$Enter$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Enter$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Enter$.prototype = $c_Lreactbuild_common_components_Input$Enter$.prototype;
$c_Lreactbuild_common_components_Input$Enter$.prototype.productPrefix__T = (function() {
  return "Enter"
});
$c_Lreactbuild_common_components_Input$Enter$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Enter$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Enter$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Enter$.prototype.hashCode__I = (function() {
  return 67114680
});
$c_Lreactbuild_common_components_Input$Enter$.prototype.toString__T = (function() {
  return "Enter"
});
var $d_Lreactbuild_common_components_Input$Enter$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Enter$: 0
}, false, "reactbuild.common.components.Input$Enter$", {
  Lreactbuild_common_components_Input$Enter$: 1,
  O: 1,
  Lreactbuild_common_components_Input$MouseWay: 1,
  Lreactbuild_common_components_Input$PointerWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Enter$.prototype.$classData = $d_Lreactbuild_common_components_Input$Enter$;
var $n_Lreactbuild_common_components_Input$Enter$;
function $m_Lreactbuild_common_components_Input$Enter$() {
  if ((!$n_Lreactbuild_common_components_Input$Enter$)) {
    $n_Lreactbuild_common_components_Input$Enter$ = new $c_Lreactbuild_common_components_Input$Enter$()
  };
  return $n_Lreactbuild_common_components_Input$Enter$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Forward$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Forward$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Forward$.prototype.constructor = $c_Lreactbuild_common_components_Input$Forward$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Forward$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Forward$.prototype = $c_Lreactbuild_common_components_Input$Forward$.prototype;
$c_Lreactbuild_common_components_Input$Forward$.prototype.productPrefix__T = (function() {
  return "Forward"
});
$c_Lreactbuild_common_components_Input$Forward$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Forward$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Forward$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Forward$.prototype.hashCode__I = (function() {
  return 987507365
});
$c_Lreactbuild_common_components_Input$Forward$.prototype.toString__T = (function() {
  return "Forward"
});
var $d_Lreactbuild_common_components_Input$Forward$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Forward$: 0
}, false, "reactbuild.common.components.Input$Forward$", {
  Lreactbuild_common_components_Input$Forward$: 1,
  O: 1,
  Lreactbuild_common_components_Input$MouseButton: 1,
  Lreactbuild_common_components_Input$PointerButton: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Forward$.prototype.$classData = $d_Lreactbuild_common_components_Input$Forward$;
var $n_Lreactbuild_common_components_Input$Forward$;
function $m_Lreactbuild_common_components_Input$Forward$() {
  if ((!$n_Lreactbuild_common_components_Input$Forward$)) {
    $n_Lreactbuild_common_components_Input$Forward$ = new $c_Lreactbuild_common_components_Input$Forward$()
  };
  return $n_Lreactbuild_common_components_Input$Forward$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$KeyboardEvent(status, charCode, keyCode, modifiers, location, timestamp) {
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_status = null;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_charCode = 0;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_keyCode = 0;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_modifiers = null;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_location = null;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_timestamp = 0.0;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_status = status;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_charCode = charCode;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_keyCode = keyCode;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_modifiers = modifiers;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_location = location;
  this.Lreactbuild_common_components_Input$KeyboardEvent__f_timestamp = timestamp
}
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype.constructor = $c_Lreactbuild_common_components_Input$KeyboardEvent;
/** @constructor */
function $h_Lreactbuild_common_components_Input$KeyboardEvent() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$KeyboardEvent.prototype = $c_Lreactbuild_common_components_Input$KeyboardEvent.prototype;
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype.productPrefix__T = (function() {
  return "KeyboardEvent"
});
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_Input$KeyboardEvent__f_status;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_Input$KeyboardEvent__f_charCode;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_Input$KeyboardEvent__f_keyCode;
      break
    }
    case 3: {
      return this.Lreactbuild_common_components_Input$KeyboardEvent__f_modifiers;
      break
    }
    case 4: {
      return this.Lreactbuild_common_components_Input$KeyboardEvent__f_location;
      break
    }
    case 5: {
      return this.Lreactbuild_common_components_Input$KeyboardEvent__f_timestamp;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("KeyboardEvent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_common_components_Input$KeyboardEvent__f_status;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lreactbuild_common_components_Input$KeyboardEvent__f_charCode;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lreactbuild_common_components_Input$KeyboardEvent__f_keyCode;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$1 = this.Lreactbuild_common_components_Input$KeyboardEvent__f_modifiers;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$2 = this.Lreactbuild_common_components_Input$KeyboardEvent__f_location;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var dv = this.Lreactbuild_common_components_Input$KeyboardEvent__f_timestamp;
  var data$6 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_Input$KeyboardEvent)) {
    var KeyboardEvent$1 = $as_Lreactbuild_common_components_Input$KeyboardEvent(x$1);
    if (((this.Lreactbuild_common_components_Input$KeyboardEvent__f_charCode === $n(KeyboardEvent$1).Lreactbuild_common_components_Input$KeyboardEvent__f_charCode) && ((this.Lreactbuild_common_components_Input$KeyboardEvent__f_keyCode === $n(KeyboardEvent$1).Lreactbuild_common_components_Input$KeyboardEvent__f_keyCode) && (this.Lreactbuild_common_components_Input$KeyboardEvent__f_timestamp === $n(KeyboardEvent$1).Lreactbuild_common_components_Input$KeyboardEvent__f_timestamp)))) {
      var x = this.Lreactbuild_common_components_Input$KeyboardEvent__f_status;
      var x$2 = $n(KeyboardEvent$1).Lreactbuild_common_components_Input$KeyboardEvent__f_status;
      if ((x === null)) {
        var $$x2 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x2 = (this$1 === x$2)
      };
      if ($$x2) {
        var x$3 = this.Lreactbuild_common_components_Input$KeyboardEvent__f_modifiers;
        var x$4 = $n(KeyboardEvent$1).Lreactbuild_common_components_Input$KeyboardEvent__f_modifiers;
        if ((x$3 === null)) {
          var $$x1 = (x$4 === null)
        } else {
          var this$2 = $n(x$3);
          var $$x1 = (this$2 === x$4)
        }
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$5 = this.Lreactbuild_common_components_Input$KeyboardEvent__f_location;
        var x$6 = $n(KeyboardEvent$1).Lreactbuild_common_components_Input$KeyboardEvent__f_location;
        if ((x$5 === null)) {
          var $$x3 = (x$6 === null)
        } else {
          var this$3 = $n(x$5);
          var $$x3 = (this$3 === x$6)
        };
        if ($$x3) {
          $n(KeyboardEvent$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_Input$KeyboardEvent(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_Input$KeyboardEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Input$KeyboardEvent"))
}
function $isArrayOf_Lreactbuild_common_components_Input$KeyboardEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Input$KeyboardEvent)))
}
function $asArrayOf_Lreactbuild_common_components_Input$KeyboardEvent(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Input$KeyboardEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Input$KeyboardEvent;", depth))
}
var $d_Lreactbuild_common_components_Input$KeyboardEvent = new $TypeData().initClass({
  Lreactbuild_common_components_Input$KeyboardEvent: 0
}, false, "reactbuild.common.components.Input$KeyboardEvent", {
  Lreactbuild_common_components_Input$KeyboardEvent: 1,
  O: 1,
  Lreactbuild_common_components_Input$InputEvent: 1,
  Lreactbuild_common_components_Input$Event: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$KeyboardEvent.prototype.$classData = $d_Lreactbuild_common_components_Input$KeyboardEvent;
/** @constructor */
function $c_Lreactbuild_common_components_Input$Leave$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Leave$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Leave$.prototype.constructor = $c_Lreactbuild_common_components_Input$Leave$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Leave$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Leave$.prototype = $c_Lreactbuild_common_components_Input$Leave$.prototype;
$c_Lreactbuild_common_components_Input$Leave$.prototype.productPrefix__T = (function() {
  return "Leave"
});
$c_Lreactbuild_common_components_Input$Leave$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Leave$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Leave$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Leave$.prototype.hashCode__I = (function() {
  return 73293463
});
$c_Lreactbuild_common_components_Input$Leave$.prototype.toString__T = (function() {
  return "Leave"
});
var $d_Lreactbuild_common_components_Input$Leave$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Leave$: 0
}, false, "reactbuild.common.components.Input$Leave$", {
  Lreactbuild_common_components_Input$Leave$: 1,
  O: 1,
  Lreactbuild_common_components_Input$MouseWay: 1,
  Lreactbuild_common_components_Input$PointerWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Leave$.prototype.$classData = $d_Lreactbuild_common_components_Input$Leave$;
var $n_Lreactbuild_common_components_Input$Leave$;
function $m_Lreactbuild_common_components_Input$Leave$() {
  if ((!$n_Lreactbuild_common_components_Input$Leave$)) {
    $n_Lreactbuild_common_components_Input$Leave$ = new $c_Lreactbuild_common_components_Input$Leave$()
  };
  return $n_Lreactbuild_common_components_Input$Leave$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Middle$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Middle$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Middle$.prototype.constructor = $c_Lreactbuild_common_components_Input$Middle$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Middle$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Middle$.prototype = $c_Lreactbuild_common_components_Input$Middle$.prototype;
$c_Lreactbuild_common_components_Input$Middle$.prototype.productPrefix__T = (function() {
  return "Middle"
});
$c_Lreactbuild_common_components_Input$Middle$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Middle$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Middle$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Middle$.prototype.hashCode__I = (function() {
  return (-1990474315)
});
$c_Lreactbuild_common_components_Input$Middle$.prototype.toString__T = (function() {
  return "Middle"
});
var $d_Lreactbuild_common_components_Input$Middle$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Middle$: 0
}, false, "reactbuild.common.components.Input$Middle$", {
  Lreactbuild_common_components_Input$Middle$: 1,
  O: 1,
  Lreactbuild_common_components_Input$MouseButton: 1,
  Lreactbuild_common_components_Input$PointerButton: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Middle$.prototype.$classData = $d_Lreactbuild_common_components_Input$Middle$;
var $n_Lreactbuild_common_components_Input$Middle$;
function $m_Lreactbuild_common_components_Input$Middle$() {
  if ((!$n_Lreactbuild_common_components_Input$Middle$)) {
    $n_Lreactbuild_common_components_Input$Middle$ = new $c_Lreactbuild_common_components_Input$Middle$()
  };
  return $n_Lreactbuild_common_components_Input$Middle$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$ModifierKey$Alt$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype.constructor = $c_Lreactbuild_common_components_Input$ModifierKey$Alt$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$ModifierKey$Alt$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype = $c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype;
$c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype.productPrefix__T = (function() {
  return "Alt"
});
$c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype.hashCode__I = (function() {
  return 65929
});
$c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype.toString__T = (function() {
  return "Alt"
});
var $d_Lreactbuild_common_components_Input$ModifierKey$Alt$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$ModifierKey$Alt$: 0
}, false, "reactbuild.common.components.Input$ModifierKey$Alt$", {
  Lreactbuild_common_components_Input$ModifierKey$Alt$: 1,
  O: 1,
  Lreactbuild_common_components_Input$AltKey: 1,
  Lreactbuild_common_components_Input$ModifierKey: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$ModifierKey$Alt$.prototype.$classData = $d_Lreactbuild_common_components_Input$ModifierKey$Alt$;
var $n_Lreactbuild_common_components_Input$ModifierKey$Alt$;
function $m_Lreactbuild_common_components_Input$ModifierKey$Alt$() {
  if ((!$n_Lreactbuild_common_components_Input$ModifierKey$Alt$)) {
    $n_Lreactbuild_common_components_Input$ModifierKey$Alt$ = new $c_Lreactbuild_common_components_Input$ModifierKey$Alt$()
  };
  return $n_Lreactbuild_common_components_Input$ModifierKey$Alt$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype.constructor = $c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$ModifierKey$Ctrl$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype = $c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype;
$c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype.productPrefix__T = (function() {
  return "Ctrl"
});
$c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype.hashCode__I = (function() {
  return 2111115
});
$c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype.toString__T = (function() {
  return "Ctrl"
});
var $d_Lreactbuild_common_components_Input$ModifierKey$Ctrl$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$ModifierKey$Ctrl$: 0
}, false, "reactbuild.common.components.Input$ModifierKey$Ctrl$", {
  Lreactbuild_common_components_Input$ModifierKey$Ctrl$: 1,
  O: 1,
  Lreactbuild_common_components_Input$CtrlKey: 1,
  Lreactbuild_common_components_Input$ModifierKey: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$.prototype.$classData = $d_Lreactbuild_common_components_Input$ModifierKey$Ctrl$;
var $n_Lreactbuild_common_components_Input$ModifierKey$Ctrl$;
function $m_Lreactbuild_common_components_Input$ModifierKey$Ctrl$() {
  if ((!$n_Lreactbuild_common_components_Input$ModifierKey$Ctrl$)) {
    $n_Lreactbuild_common_components_Input$ModifierKey$Ctrl$ = new $c_Lreactbuild_common_components_Input$ModifierKey$Ctrl$()
  };
  return $n_Lreactbuild_common_components_Input$ModifierKey$Ctrl$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$ModifierKey$Shift$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype.constructor = $c_Lreactbuild_common_components_Input$ModifierKey$Shift$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$ModifierKey$Shift$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype = $c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype;
$c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype.productPrefix__T = (function() {
  return "Shift"
});
$c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype.hashCode__I = (function() {
  return 79854690
});
$c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype.toString__T = (function() {
  return "Shift"
});
var $d_Lreactbuild_common_components_Input$ModifierKey$Shift$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$ModifierKey$Shift$: 0
}, false, "reactbuild.common.components.Input$ModifierKey$Shift$", {
  Lreactbuild_common_components_Input$ModifierKey$Shift$: 1,
  O: 1,
  Lreactbuild_common_components_Input$ShiftKey: 1,
  Lreactbuild_common_components_Input$ModifierKey: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$ModifierKey$Shift$.prototype.$classData = $d_Lreactbuild_common_components_Input$ModifierKey$Shift$;
var $n_Lreactbuild_common_components_Input$ModifierKey$Shift$;
function $m_Lreactbuild_common_components_Input$ModifierKey$Shift$() {
  if ((!$n_Lreactbuild_common_components_Input$ModifierKey$Shift$)) {
    $n_Lreactbuild_common_components_Input$ModifierKey$Shift$ = new $c_Lreactbuild_common_components_Input$ModifierKey$Shift$()
  };
  return $n_Lreactbuild_common_components_Input$ModifierKey$Shift$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$PointerEvent(status, id, coords, isPrimary, button, buttons, width, height, pressure, modifiers, timestamp) {
  this.Lreactbuild_common_components_Input$PointerEvent__f_status = null;
  this.Lreactbuild_common_components_Input$PointerEvent__f_id = 0.0;
  this.Lreactbuild_common_components_Input$PointerEvent__f_coords = null;
  this.Lreactbuild_common_components_Input$PointerEvent__f_isPrimary = false;
  this.Lreactbuild_common_components_Input$PointerEvent__f_button = null;
  this.Lreactbuild_common_components_Input$PointerEvent__f_buttons = null;
  this.Lreactbuild_common_components_Input$PointerEvent__f_width = 0.0;
  this.Lreactbuild_common_components_Input$PointerEvent__f_height = 0.0;
  this.Lreactbuild_common_components_Input$PointerEvent__f_pressure = 0.0;
  this.Lreactbuild_common_components_Input$PointerEvent__f_modifiers = null;
  this.Lreactbuild_common_components_Input$PointerEvent__f_timestamp = 0.0;
  this.Lreactbuild_common_components_Input$PointerEvent__f_status = status;
  this.Lreactbuild_common_components_Input$PointerEvent__f_id = id;
  this.Lreactbuild_common_components_Input$PointerEvent__f_coords = coords;
  this.Lreactbuild_common_components_Input$PointerEvent__f_isPrimary = isPrimary;
  this.Lreactbuild_common_components_Input$PointerEvent__f_button = button;
  this.Lreactbuild_common_components_Input$PointerEvent__f_buttons = buttons;
  this.Lreactbuild_common_components_Input$PointerEvent__f_width = width;
  this.Lreactbuild_common_components_Input$PointerEvent__f_height = height;
  this.Lreactbuild_common_components_Input$PointerEvent__f_pressure = pressure;
  this.Lreactbuild_common_components_Input$PointerEvent__f_modifiers = modifiers;
  this.Lreactbuild_common_components_Input$PointerEvent__f_timestamp = timestamp
}
$c_Lreactbuild_common_components_Input$PointerEvent.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$PointerEvent.prototype.constructor = $c_Lreactbuild_common_components_Input$PointerEvent;
/** @constructor */
function $h_Lreactbuild_common_components_Input$PointerEvent() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$PointerEvent.prototype = $c_Lreactbuild_common_components_Input$PointerEvent.prototype;
$c_Lreactbuild_common_components_Input$PointerEvent.prototype.productPrefix__T = (function() {
  return "PointerEvent"
});
$c_Lreactbuild_common_components_Input$PointerEvent.prototype.productArity__I = (function() {
  return 11
});
$c_Lreactbuild_common_components_Input$PointerEvent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_status;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_id;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_coords;
      break
    }
    case 3: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_isPrimary;
      break
    }
    case 4: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_button;
      break
    }
    case 5: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_buttons;
      break
    }
    case 6: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_width;
      break
    }
    case 7: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_height;
      break
    }
    case 8: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_pressure;
      break
    }
    case 9: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
      break
    }
    case 10: {
      return this.Lreactbuild_common_components_Input$PointerEvent__f_timestamp;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_Input$PointerEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$PointerEvent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("PointerEvent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_common_components_Input$PointerEvent__f_status;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_common_components_Input$PointerEvent__f_id;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_common_components_Input$PointerEvent__f_coords;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lreactbuild_common_components_Input$PointerEvent__f_isPrimary ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$2 = this.Lreactbuild_common_components_Input$PointerEvent__f_button;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$3 = this.Lreactbuild_common_components_Input$PointerEvent__f_buttons;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var dv$1 = this.Lreactbuild_common_components_Input$PointerEvent__f_width;
  var data$7 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var dv$2 = this.Lreactbuild_common_components_Input$PointerEvent__f_height;
  var data$8 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var dv$3 = this.Lreactbuild_common_components_Input$PointerEvent__f_pressure;
  var data$9 = $m_sr_Statics$().doubleHash__D__I(dv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$4 = this.Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var dv$4 = this.Lreactbuild_common_components_Input$PointerEvent__f_timestamp;
  var data$11 = $m_sr_Statics$().doubleHash__D__I(dv$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$12, 11)
});
$c_Lreactbuild_common_components_Input$PointerEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_Input$PointerEvent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var PointerEvent$1 = $as_Lreactbuild_common_components_Input$PointerEvent(x$1);
    if ((((this.Lreactbuild_common_components_Input$PointerEvent__f_id === $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_id) && ((this.Lreactbuild_common_components_Input$PointerEvent__f_isPrimary === $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_isPrimary) && (this.Lreactbuild_common_components_Input$PointerEvent__f_width === $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_width))) && ((this.Lreactbuild_common_components_Input$PointerEvent__f_height === $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_height) && ((this.Lreactbuild_common_components_Input$PointerEvent__f_pressure === $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_pressure) && (this.Lreactbuild_common_components_Input$PointerEvent__f_timestamp === $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_timestamp))))) {
      var x = this.Lreactbuild_common_components_Input$PointerEvent__f_status;
      var x$2 = $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_status;
      if ((x === null)) {
        var $$x2 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x2 = (this$1 === x$2)
      };
      if ($$x2) {
        var x$3 = this.Lreactbuild_common_components_Input$PointerEvent__f_coords;
        var x$4 = $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_coords;
        if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
          var x$5 = this.Lreactbuild_common_components_Input$PointerEvent__f_button;
          var x$6 = $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_button;
          if ((x$5 === null)) {
            var $$x1 = (x$6 === null)
          } else {
            var this$2 = $n(x$5);
            var $$x1 = (this$2 === x$6)
          }
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$7 = this.Lreactbuild_common_components_Input$PointerEvent__f_buttons;
        var x$8 = $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_buttons;
        if (((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))) {
          var x$9 = this.Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
          var x$10 = $n(PointerEvent$1).Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
          if ((x$9 === null)) {
            var $$x3 = (x$10 === null)
          } else {
            var this$3 = $n(x$9);
            var $$x3 = (this$3 === x$10)
          };
          if ($$x3) {
            $n(PointerEvent$1);
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_Input$PointerEvent(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_Input$PointerEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Input$PointerEvent"))
}
function $isArrayOf_Lreactbuild_common_components_Input$PointerEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Input$PointerEvent)))
}
function $asArrayOf_Lreactbuild_common_components_Input$PointerEvent(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Input$PointerEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Input$PointerEvent;", depth))
}
var $d_Lreactbuild_common_components_Input$PointerEvent = new $TypeData().initClass({
  Lreactbuild_common_components_Input$PointerEvent: 0
}, false, "reactbuild.common.components.Input$PointerEvent", {
  Lreactbuild_common_components_Input$PointerEvent: 1,
  O: 1,
  Lreactbuild_common_components_Input$InputEvent: 1,
  Lreactbuild_common_components_Input$Event: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$PointerEvent.prototype.$classData = $d_Lreactbuild_common_components_Input$PointerEvent;
/** @constructor */
function $c_Lreactbuild_common_components_Input$Tap$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Tap$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Tap$.prototype.constructor = $c_Lreactbuild_common_components_Input$Tap$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Tap$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Tap$.prototype = $c_Lreactbuild_common_components_Input$Tap$.prototype;
$c_Lreactbuild_common_components_Input$Tap$.prototype.productPrefix__T = (function() {
  return "Tap"
});
$c_Lreactbuild_common_components_Input$Tap$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Tap$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Tap$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Tap$.prototype.hashCode__I = (function() {
  return 83843
});
$c_Lreactbuild_common_components_Input$Tap$.prototype.toString__T = (function() {
  return "Tap"
});
var $d_Lreactbuild_common_components_Input$Tap$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Tap$: 0
}, false, "reactbuild.common.components.Input$Tap$", {
  Lreactbuild_common_components_Input$Tap$: 1,
  O: 1,
  Lreactbuild_common_components_Input$MouseWay: 1,
  Lreactbuild_common_components_Input$KeyboardWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Tap$.prototype.$classData = $d_Lreactbuild_common_components_Input$Tap$;
var $n_Lreactbuild_common_components_Input$Tap$;
function $m_Lreactbuild_common_components_Input$Tap$() {
  if ((!$n_Lreactbuild_common_components_Input$Tap$)) {
    $n_Lreactbuild_common_components_Input$Tap$ = new $c_Lreactbuild_common_components_Input$Tap$()
  };
  return $n_Lreactbuild_common_components_Input$Tap$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$WheelEvent(coords, deltaX, deltaY, deltaZ, deltaMode, timestamp) {
  this.Lreactbuild_common_components_Input$WheelEvent__f_coords = null;
  this.Lreactbuild_common_components_Input$WheelEvent__f_deltaX = 0.0;
  this.Lreactbuild_common_components_Input$WheelEvent__f_deltaY = 0.0;
  this.Lreactbuild_common_components_Input$WheelEvent__f_deltaZ = 0.0;
  this.Lreactbuild_common_components_Input$WheelEvent__f_deltaMode = 0;
  this.Lreactbuild_common_components_Input$WheelEvent__f_timestamp = 0.0;
  this.Lreactbuild_common_components_Input$WheelEvent__f_coords = coords;
  this.Lreactbuild_common_components_Input$WheelEvent__f_deltaX = deltaX;
  this.Lreactbuild_common_components_Input$WheelEvent__f_deltaY = deltaY;
  this.Lreactbuild_common_components_Input$WheelEvent__f_deltaZ = deltaZ;
  this.Lreactbuild_common_components_Input$WheelEvent__f_deltaMode = deltaMode;
  this.Lreactbuild_common_components_Input$WheelEvent__f_timestamp = timestamp
}
$c_Lreactbuild_common_components_Input$WheelEvent.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$WheelEvent.prototype.constructor = $c_Lreactbuild_common_components_Input$WheelEvent;
/** @constructor */
function $h_Lreactbuild_common_components_Input$WheelEvent() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$WheelEvent.prototype = $c_Lreactbuild_common_components_Input$WheelEvent.prototype;
$c_Lreactbuild_common_components_Input$WheelEvent.prototype.productPrefix__T = (function() {
  return "WheelEvent"
});
$c_Lreactbuild_common_components_Input$WheelEvent.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_common_components_Input$WheelEvent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_Input$WheelEvent__f_coords;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_Input$WheelEvent__f_deltaX;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_Input$WheelEvent__f_deltaY;
      break
    }
    case 3: {
      return this.Lreactbuild_common_components_Input$WheelEvent__f_deltaZ;
      break
    }
    case 4: {
      return this.Lreactbuild_common_components_Input$WheelEvent__f_deltaMode;
      break
    }
    case 5: {
      return this.Lreactbuild_common_components_Input$WheelEvent__f_timestamp;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_Input$WheelEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$WheelEvent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("WheelEvent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_common_components_Input$WheelEvent__f_coords;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_common_components_Input$WheelEvent__f_deltaX;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv$1 = this.Lreactbuild_common_components_Input$WheelEvent__f_deltaY;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var dv$2 = this.Lreactbuild_common_components_Input$WheelEvent__f_deltaZ;
  var data$4 = $m_sr_Statics$().doubleHash__D__I(dv$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = this.Lreactbuild_common_components_Input$WheelEvent__f_deltaMode;
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var dv$3 = this.Lreactbuild_common_components_Input$WheelEvent__f_timestamp;
  var data$6 = $m_sr_Statics$().doubleHash__D__I(dv$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_common_components_Input$WheelEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_Input$WheelEvent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_Input$WheelEvent)) {
    var WheelEvent$1 = $as_Lreactbuild_common_components_Input$WheelEvent(x$1);
    if (((this.Lreactbuild_common_components_Input$WheelEvent__f_deltaX === $n(WheelEvent$1).Lreactbuild_common_components_Input$WheelEvent__f_deltaX) && ((this.Lreactbuild_common_components_Input$WheelEvent__f_deltaY === $n(WheelEvent$1).Lreactbuild_common_components_Input$WheelEvent__f_deltaY) && (this.Lreactbuild_common_components_Input$WheelEvent__f_deltaZ === $n(WheelEvent$1).Lreactbuild_common_components_Input$WheelEvent__f_deltaZ)))) {
      if (((this.Lreactbuild_common_components_Input$WheelEvent__f_deltaMode === $n(WheelEvent$1).Lreactbuild_common_components_Input$WheelEvent__f_deltaMode) && (this.Lreactbuild_common_components_Input$WheelEvent__f_timestamp === $n(WheelEvent$1).Lreactbuild_common_components_Input$WheelEvent__f_timestamp))) {
        var x = this.Lreactbuild_common_components_Input$WheelEvent__f_coords;
        var x$2 = $n(WheelEvent$1).Lreactbuild_common_components_Input$WheelEvent__f_coords;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          $n(WheelEvent$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_Input$WheelEvent(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_Input$WheelEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Input$WheelEvent"))
}
function $isArrayOf_Lreactbuild_common_components_Input$WheelEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Input$WheelEvent)))
}
function $asArrayOf_Lreactbuild_common_components_Input$WheelEvent(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Input$WheelEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Input$WheelEvent;", depth))
}
var $d_Lreactbuild_common_components_Input$WheelEvent = new $TypeData().initClass({
  Lreactbuild_common_components_Input$WheelEvent: 0
}, false, "reactbuild.common.components.Input$WheelEvent", {
  Lreactbuild_common_components_Input$WheelEvent: 1,
  O: 1,
  Lreactbuild_common_components_Input$InputEvent: 1,
  Lreactbuild_common_components_Input$Event: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$WheelEvent.prototype.$classData = $d_Lreactbuild_common_components_Input$WheelEvent;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31(outer) {
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31__f_circeGenericEncoderForfile = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31__f_circeGenericEncoderForfile = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31.prototype = new $h_O();
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31.prototype.constructor = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31.prototype = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31.prototype;
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForfile = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("file"), $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31__f_circeGenericEncoderForfile).apply__O__Lio_circe_Json(circeGenericHListBindingForfile))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31: 0
}, false, "reactbuild.common.model.AssetDetails$anon$lazy$macro$159$1$$anon$31", {
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31.prototype.$classData = $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$31;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32(outer) {
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderForbaseColor = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderForbumpScale = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderFormap = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderForbaseColor = $m_Lreactbuild_common_model_Color$().Lreactbuild_common_model_Color$__f_encodeColor;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderForbumpScale = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderFormap = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32.prototype = new $h_O();
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32.prototype.constructor = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32.prototype = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32.prototype;
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForbaseColor = $n($as_Lreactbuild_common_model_Color($n(a).Lshapeless_$colon$colon__f_head)).Lreactbuild_common_model_Color__f_color;
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForroughness = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForbumpMap = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForbumpScale = $uD($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFormap = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x1 = $m_Lio_circe_JsonObject$();
              var this$4 = $m_sci_Vector$();
              var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("baseColor"), $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderForbaseColor).apply__O__Lio_circe_Json(new $c_Lreactbuild_common_model_Color(circeGenericHListBindingForbaseColor))), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("roughness"), $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderForbumpScale).apply__O__Lio_circe_Json(circeGenericHListBindingForroughness)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("bumpMap"), $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderFormap).apply__O__Lio_circe_Json(circeGenericHListBindingForbumpMap)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("bumpScale"), $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderForbumpScale).apply__O__Lio_circe_Json(circeGenericHListBindingForbumpScale)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("map"), $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32__f_circeGenericEncoderFormap).apply__O__Lio_circe_Json(circeGenericHListBindingFormap))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32: 0
}, false, "reactbuild.common.model.AssetDetails$anon$lazy$macro$159$1$$anon$32", {
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32.prototype.$classData = $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$32;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33(outer) {
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33__f_circeGenericEncoderForfiles2d = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33__f_circeGenericEncoderForloader = null;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33__f_circeGenericEncoderForfiles2d = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33__f_circeGenericEncoderForloader = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33.prototype = new $h_O();
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33.prototype.constructor = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33.prototype = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33.prototype;
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForfiles3d = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForfiles2d = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForloader = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x4 = $m_Lio_circe_JsonObject$();
          var this$6 = $m_sci_Vector$();
          var $$x3 = $n(transformMemberNames).apply__O__O("files3d");
          var this$1 = $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33__f_circeGenericEncoderForfiles2d);
          var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForfiles3d));
          var $$x1 = $n(transformMemberNames).apply__O__O("files2d");
          var this$2 = $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33__f_circeGenericEncoderForfiles2d);
          var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForfiles2d)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("loader"), $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33__f_circeGenericEncoderForloader).apply__O__Lio_circe_Json(circeGenericHListBindingForloader))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x4).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33: 0
}, false, "reactbuild.common.model.AssetDetails$anon$lazy$macro$159$1$$anon$33", {
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33.prototype.$classData = $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$33;
/** @constructor */
function $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36(outer) {
  /*<skip>*/
}
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36.prototype = new $h_O();
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36.prototype.constructor = $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36;
/** @constructor */
function $h_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36.prototype = $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36.prototype;
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36 = new $TypeData().initClass({
  Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36: 0
}, false, "reactbuild.common.model.Country$anon$lazy$macro$7$2$$anon$36", {
  Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36.prototype.$classData = $d_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$36;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23(outer) {
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForcountry = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForraw = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForparcels = null;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForcoordinates = null;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_Country$().Lreactbuild_common_model_Country$__f_codecForCountry;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForcountry = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForraw = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForparcels = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lreactbuild_common_model_Coordinates$().encodeCoordinates__Lio_circe_Encoder();
  this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForcoordinates = new $c_Lio_circe_Encoder$$anon$21(e$2)
}
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23.prototype = new $h_O();
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23.prototype.constructor = $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23.prototype = $c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23.prototype;
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForcountry = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForraw = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForparcels = $as_sci_List($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForcoordinates = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x4 = $m_Lio_circe_JsonObject$();
            var this$5 = $m_sci_Vector$();
            var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("country"), $n(this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForcountry).apply__O__Lio_circe_Json(circeGenericHListBindingForcountry));
            var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("raw"), $n(this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForraw).apply__O__Lio_circe_Json(circeGenericHListBindingForraw));
            var $$x1 = $n(transformMemberNames).apply__O__O("parcels");
            var this$1 = $n(this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForparcels);
            var array = [$$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForparcels)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("coordinates"), $n(this.Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23__f_circeGenericEncoderForcoordinates).apply__O__Lio_circe_Json(circeGenericHListBindingForcoordinates))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x4).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23: 0
}, false, "reactbuild.common.model.ProjectAddress$anon$lazy$macro$35$5$$anon$23", {
  Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23.prototype.$classData = $d_Lreactbuild_common_model_ProjectAddress$anon$lazy$macro$35$5$$anon$23;
/** @constructor */
function $c_Lreactbuild_format_dxf_BitIndex(index) {
  this.Lreactbuild_format_dxf_BitIndex__f_index = 0;
  this.Lreactbuild_format_dxf_BitIndex__f_index = index
}
$c_Lreactbuild_format_dxf_BitIndex.prototype = new $h_s_annotation_Annotation();
$c_Lreactbuild_format_dxf_BitIndex.prototype.constructor = $c_Lreactbuild_format_dxf_BitIndex;
/** @constructor */
function $h_Lreactbuild_format_dxf_BitIndex() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_BitIndex.prototype = $c_Lreactbuild_format_dxf_BitIndex.prototype;
$c_Lreactbuild_format_dxf_BitIndex.prototype.productPrefix__T = (function() {
  return "BitIndex"
});
$c_Lreactbuild_format_dxf_BitIndex.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_BitIndex.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_BitIndex__f_index : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_BitIndex.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_BitIndex.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("BitIndex");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_format_dxf_BitIndex__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_format_dxf_BitIndex.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_BitIndex.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_BitIndex)) {
    var BitIndex$1 = $as_Lreactbuild_format_dxf_BitIndex(x$1);
    return (this.Lreactbuild_format_dxf_BitIndex__f_index === $n(BitIndex$1).Lreactbuild_format_dxf_BitIndex__f_index)
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_BitIndex(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_BitIndex) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.BitIndex"))
}
function $isArrayOf_Lreactbuild_format_dxf_BitIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_BitIndex)))
}
function $asArrayOf_Lreactbuild_format_dxf_BitIndex(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_BitIndex(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.BitIndex;", depth))
}
var $d_Lreactbuild_format_dxf_BitIndex = new $TypeData().initClass({
  Lreactbuild_format_dxf_BitIndex: 0
}, false, "reactbuild.format.dxf.BitIndex", {
  Lreactbuild_format_dxf_BitIndex: 1,
  s_annotation_Annotation: 1,
  O: 1,
  s_annotation_StaticAnnotation: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_BitIndex.prototype.$classData = $d_Lreactbuild_format_dxf_BitIndex;
/** @constructor */
function $c_Lreactbuild_format_dxf_GroupCode(code) {
  this.Lreactbuild_format_dxf_GroupCode__f_code = 0;
  this.Lreactbuild_format_dxf_GroupCode__f_code = code
}
$c_Lreactbuild_format_dxf_GroupCode.prototype = new $h_s_annotation_Annotation();
$c_Lreactbuild_format_dxf_GroupCode.prototype.constructor = $c_Lreactbuild_format_dxf_GroupCode;
/** @constructor */
function $h_Lreactbuild_format_dxf_GroupCode() {
  /*<skip>*/
}
$h_Lreactbuild_format_dxf_GroupCode.prototype = $c_Lreactbuild_format_dxf_GroupCode.prototype;
$c_Lreactbuild_format_dxf_GroupCode.prototype.productPrefix__T = (function() {
  return "GroupCode"
});
$c_Lreactbuild_format_dxf_GroupCode.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_format_dxf_GroupCode.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_format_dxf_GroupCode__f_code : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_format_dxf_GroupCode.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_format_dxf_GroupCode.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("GroupCode");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lreactbuild_format_dxf_GroupCode__f_code;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lreactbuild_format_dxf_GroupCode.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_format_dxf_GroupCode.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_format_dxf_GroupCode)) {
    var GroupCode$1 = $as_Lreactbuild_format_dxf_GroupCode(x$1);
    return (this.Lreactbuild_format_dxf_GroupCode__f_code === $n(GroupCode$1).Lreactbuild_format_dxf_GroupCode__f_code)
  } else {
    return false
  }
});
function $as_Lreactbuild_format_dxf_GroupCode(obj) {
  return (((obj instanceof $c_Lreactbuild_format_dxf_GroupCode) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.format.dxf.GroupCode"))
}
function $isArrayOf_Lreactbuild_format_dxf_GroupCode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_format_dxf_GroupCode)))
}
function $asArrayOf_Lreactbuild_format_dxf_GroupCode(obj, depth) {
  return (($isArrayOf_Lreactbuild_format_dxf_GroupCode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.format.dxf.GroupCode;", depth))
}
var $d_Lreactbuild_format_dxf_GroupCode = new $TypeData().initClass({
  Lreactbuild_format_dxf_GroupCode: 0
}, false, "reactbuild.format.dxf.GroupCode", {
  Lreactbuild_format_dxf_GroupCode: 1,
  s_annotation_Annotation: 1,
  O: 1,
  s_annotation_StaticAnnotation: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_dxf_GroupCode.prototype.$classData = $d_Lreactbuild_format_dxf_GroupCode;
/** @constructor */
function $c_Lreactbuild_geom_Point2(x, y) {
  this.Lreactbuild_geom_Point2__f_x = 0.0;
  this.Lreactbuild_geom_Point2__f_y = 0.0;
  this.Lreactbuild_geom_Point2__f_x = x;
  this.Lreactbuild_geom_Point2__f_y = y
}
$c_Lreactbuild_geom_Point2.prototype = new $h_O();
$c_Lreactbuild_geom_Point2.prototype.constructor = $c_Lreactbuild_geom_Point2;
/** @constructor */
function $h_Lreactbuild_geom_Point2() {
  /*<skip>*/
}
$h_Lreactbuild_geom_Point2.prototype = $c_Lreactbuild_geom_Point2.prototype;
$c_Lreactbuild_geom_Point2.prototype.x__D = (function() {
  return this.Lreactbuild_geom_Point2__f_x
});
$c_Lreactbuild_geom_Point2.prototype.y__D = (function() {
  return this.Lreactbuild_geom_Point2__f_y
});
$c_Lreactbuild_geom_Point2.prototype.toString__T = (function() {
  return (((("p(" + this.Lreactbuild_geom_Point2__f_x) + ",") + this.Lreactbuild_geom_Point2__f_y) + ")")
});
$c_Lreactbuild_geom_Point2.prototype.productPrefix__T = (function() {
  return "Point2"
});
$c_Lreactbuild_geom_Point2.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_geom_Point2.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_geom_Point2__f_x;
      break
    }
    case 1: {
      return this.Lreactbuild_geom_Point2__f_y;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_geom_Point2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_geom_Point2.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Point2");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Lreactbuild_geom_Point2__f_x;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv$1 = this.Lreactbuild_geom_Point2__f_y;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lreactbuild_geom_Point2.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_geom_Point2)) {
    var Point2$1 = $as_Lreactbuild_geom_Point2(x$1);
    return ((this.Lreactbuild_geom_Point2__f_x === $n(Point2$1).Lreactbuild_geom_Point2__f_x) && (this.Lreactbuild_geom_Point2__f_y === $n(Point2$1).Lreactbuild_geom_Point2__f_y))
  } else {
    return false
  }
});
function $as_Lreactbuild_geom_Point2(obj) {
  return (((obj instanceof $c_Lreactbuild_geom_Point2) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.geom.Point2"))
}
function $isArrayOf_Lreactbuild_geom_Point2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_geom_Point2)))
}
function $asArrayOf_Lreactbuild_geom_Point2(obj, depth) {
  return (($isArrayOf_Lreactbuild_geom_Point2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.geom.Point2;", depth))
}
var $d_Lreactbuild_geom_Point2 = new $TypeData().initClass({
  Lreactbuild_geom_Point2: 0
}, false, "reactbuild.geom.Point2", {
  Lreactbuild_geom_Point2: 1,
  O: 1,
  Lreactbuild_geom_Point2Based: 1,
  Lreactbuild_geom_Vector2Based: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_geom_Point2.prototype.$classData = $d_Lreactbuild_geom_Point2;
/** @constructor */
function $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26(outer) {
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26__f_circeGenericEncoderForrange = null;
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26__f_circeGenericEncoderForstage = null;
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26__f_circeGenericEncoderForrange = $m_Lreactbuild_model_BuildingSiteStage$().encodeTypedRange__Lio_circe_Encoder__Lio_circe_Encoder($m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder());
  this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26__f_circeGenericEncoderForstage = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26.prototype = new $h_O();
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26.prototype.constructor = $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26;
/** @constructor */
function $h_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26.prototype = $c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26.prototype;
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForrange = $as_Lcom_iz2use_common_TypedRange($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForstage = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("range"), $n(this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26__f_circeGenericEncoderForrange).apply__O__Lio_circe_Json(circeGenericHListBindingForrange)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("stage"), $n(this.Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26__f_circeGenericEncoderForstage).apply__O__Lio_circe_Json(circeGenericHListBindingForstage))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26 = new $TypeData().initClass({
  Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26: 0
}, false, "reactbuild.model.BuildingSiteStage$anon$lazy$macro$19$3$$anon$26", {
  Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26.prototype.$classData = $d_Lreactbuild_model_BuildingSiteStage$anon$lazy$macro$19$3$$anon$26;
/** @constructor */
function $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80(outer) {
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80__f_circeGenericEncoderForexpression = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80__f_circeGenericEncoderForcalculatedValue = null;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80__f_circeGenericEncoderForexpression = $n(outer).Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_encExprA$1;
  this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80__f_circeGenericEncoderForcalculatedValue = $n(outer).Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7__f_encOptB$1
}
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80.prototype = new $h_O();
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80.prototype.constructor = $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80;
/** @constructor */
function $h_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80() {
  /*<skip>*/
}
$h_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80.prototype = $c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80.prototype;
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForexpression = $as_Lreactbuild_model_Expression($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForcalculatedValue = $n(p2).Lshapeless_$colon$colon__f_head;
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("expression"), $n(this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80__f_circeGenericEncoderForexpression).apply__O__Lio_circe_Json(circeGenericHListBindingForexpression)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("calculatedValue"), $n(this.Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80__f_circeGenericEncoderForcalculatedValue).apply__O__Lio_circe_Json(circeGenericHListBindingForcalculatedValue))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80 = new $TypeData().initClass({
  Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80: 0
}, false, "reactbuild.model.CachedExpression$anon$lazy$macro$19$7$$anon$80", {
  Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80.prototype.$classData = $d_Lreactbuild_model_CachedExpression$anon$lazy$macro$19$7$$anon$80;
/** @constructor */
function $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10(outer) {
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10__f_circeGenericEncoderForhtmlSource = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10__f_circeGenericEncoderForhtmlSource = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10.prototype.constructor = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10;
/** @constructor */
function $h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10.prototype = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10.prototype;
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForhtmlSource = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("htmlSource"), $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10__f_circeGenericEncoderForhtmlSource).apply__O__Lio_circe_Json(circeGenericHListBindingForhtmlSource))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10: 0
}, false, "reactbuild.model.CommunicationBody$anon$lazy$macro$79$1$$anon$10", {
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10.prototype.$classData = $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$10;
/** @constructor */
function $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8(outer) {
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8__f_circeGenericEncoderFortextSource = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8__f_circeGenericEncoderFortextSource = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8.prototype.constructor = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8;
/** @constructor */
function $h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8.prototype = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8.prototype;
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFortextSource = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("textSource"), $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8__f_circeGenericEncoderFortextSource).apply__O__Lio_circe_Json(circeGenericHListBindingFortextSource))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8: 0
}, false, "reactbuild.model.CommunicationBody$anon$lazy$macro$79$1$$anon$8", {
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8.prototype.$classData = $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$8;
/** @constructor */
function $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9(outer) {
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9__f_circeGenericEncoderForpart = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9__f_circeGenericEncoderForpart = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9.prototype.constructor = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9;
/** @constructor */
function $h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9.prototype = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9.prototype;
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForsource = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForpart = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("source"), $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9__f_circeGenericEncoderForpart).apply__O__Lio_circe_Json(circeGenericHListBindingForsource)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("part"), $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9__f_circeGenericEncoderForpart).apply__O__Lio_circe_Json(circeGenericHListBindingForpart))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9: 0
}, false, "reactbuild.model.CommunicationBody$anon$lazy$macro$79$1$$anon$9", {
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9.prototype.$classData = $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$9;
/** @constructor */
function $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2(outer) {
  /*<skip>*/
}
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2.prototype.constructor = $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2.prototype = $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2.prototype;
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2: 0
}, false, "reactbuild.model.CommunicationRole$anon$lazy$macro$13$1$$anon$2", {
  Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2.prototype.$classData = $d_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39(outer) {
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderFordocument = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForsupplier = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForentryLine = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderFordeliveredQuantity = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForamount = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderFordocument = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForsupplier = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForentryLine = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderFordeliveredQuantity = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForamount = new $c_Lio_circe_Encoder$$anon$21(e$1)
}
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39.prototype = new $h_O();
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39.prototype.constructor = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39;
/** @constructor */
function $h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39() {
  /*<skip>*/
}
$h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39.prototype = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39.prototype;
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFordocument = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForsupplier = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForentryLine = $as_ju_UUID($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFordeliveredQuantity = $uD($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForamount = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p7)) {
                var $$x1 = $m_Lio_circe_JsonObject$();
                var this$4 = $m_sci_Vector$();
                var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForentryLine).apply__O__Lio_circe_Json(circeGenericHListBindingForid)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("document"), $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderFordocument).apply__O__Lio_circe_Json(circeGenericHListBindingFordocument)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("supplier"), $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForsupplier).apply__O__Lio_circe_Json(circeGenericHListBindingForsupplier)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("entryLine"), $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForentryLine).apply__O__Lio_circe_Json(circeGenericHListBindingForentryLine)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("deliveredQuantity"), $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderFordeliveredQuantity).apply__O__Lio_circe_Json(circeGenericHListBindingFordeliveredQuantity)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("amount"), $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39__f_circeGenericEncoderForamount).apply__O__Lio_circe_Json(circeGenericHListBindingForamount))];
                var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39 = new $TypeData().initClass({
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39: 0
}, false, "reactbuild.model.DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39", {
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39.prototype.$classData = $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$39;
/** @constructor */
function $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40(outer) {
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40__f_circeGenericEncoderForcontent = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40__f_circeGenericEncoderForcontent = $m_Lreactbuild_model_InvoiceDetail$().Lreactbuild_model_InvoiceDetail$__f_codecForInvoiceDetail
}
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40.prototype = new $h_O();
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40.prototype.constructor = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40;
/** @constructor */
function $h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40() {
  /*<skip>*/
}
$h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40.prototype = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40.prototype;
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForcontent = $as_Lreactbuild_model_InvoiceDetail($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("content");
      var this$1 = $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40__f_circeGenericEncoderForcontent);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForcontent))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40 = new $TypeData().initClass({
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40: 0
}, false, "reactbuild.model.DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40", {
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40.prototype.$classData = $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$40;
/** @constructor */
function $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3(outer) {
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3__f_circeGenericEncoderForprojectRef = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3__f_circeGenericEncoderFory = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3__f_circeGenericEncoderForprojectRef = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3__f_circeGenericEncoderFory = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3.prototype = new $h_Lio_circe_generic_encoding_ReprAsObjectEncoder();
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3.prototype.constructor = $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3;
/** @constructor */
function $h_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3.prototype = $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3.prototype;
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3.prototype.encodeObject__Lshapeless_$colon$colon__Lio_circe_JsonObject = (function(a) {
  if ((a !== null)) {
    var circeGenericHListBindingForprojectRef = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForx = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFory = $uD($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), "projectRef", $n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3__f_circeGenericEncoderForprojectRef).apply__O__Lio_circe_Json(circeGenericHListBindingForprojectRef)), $ct_T2__O__O__(new $c_T2(), "x", $n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3__f_circeGenericEncoderFory).apply__O__Lio_circe_Json(circeGenericHListBindingForx)), $ct_T2__O__O__(new $c_T2(), "y", $n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3__f_circeGenericEncoderFory).apply__O__Lio_circe_Json(circeGenericHListBindingFory))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lshapeless_$colon$colon__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a))
});
var $d_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3 = new $TypeData().initClass({
  Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3: 0
}, false, "reactbuild.model.FromClient$anon$lazy$macro$31$1$$anon$3", {
  Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3: 1,
  Lio_circe_generic_encoding_ReprAsObjectEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3.prototype.$classData = $d_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$3;
/** @constructor */
function $c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78(outer) {
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForcreated = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForproject = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderFortitle = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForterms = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForduration = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForfrom = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderFortype = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForcreated = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForproject = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderFortitle = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var this$3 = $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  var this$2 = $m_s_$less$colon$less$();
  var ev = this$2.s_$less$colon$less$__f_singleton;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForterms = new $c_Lio_circe_MidPriorityEncoders$$anon$69(this$3, encodeA, ev);
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().encodeDuration__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForduration = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForfrom = new $c_Lio_circe_Encoder$$anon$21(e$1);
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderFortype = $m_Lreactbuild_model_ListEntryType$().Lreactbuild_model_ListEntryType$__f_codecForListEntryType
}
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78.prototype = new $h_O();
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78.prototype.constructor = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78;
/** @constructor */
function $h_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78.prototype = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78.prototype;
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForcreated = $as_Ljava_time_Instant($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForproject = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFortitle = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForterms = $as_sci_ListSet($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForduration = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForfrom = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingFortype = $as_Lreactbuild_model_ListEntryType($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p9)) {
                    var $$x10 = $m_Lio_circe_JsonObject$();
                    var this$6 = $m_sci_Vector$();
                    var $$x9 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                    var $$x8 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("created"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForcreated).apply__O__Lio_circe_Json(circeGenericHListBindingForcreated));
                    var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("project"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForproject).apply__O__Lio_circe_Json(circeGenericHListBindingForproject));
                    var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle));
                    var $$x5 = $n(transformMemberNames).apply__O__O("terms");
                    var this$1 = $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForterms);
                    var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForterms));
                    var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("duration"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForduration).apply__O__Lio_circe_Json(circeGenericHListBindingForduration));
                    var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("from"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderForfrom).apply__O__Lio_circe_Json(circeGenericHListBindingForfrom));
                    var $$x1 = $n(transformMemberNames).apply__O__O("type");
                    var this$2 = $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78__f_circeGenericEncoderFortype);
                    var array = [$$x9, $$x8, $$x7, $$x6, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFortype))];
                    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                    return $n($$x10).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78 = new $TypeData().initClass({
  Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78: 0
}, false, "reactbuild.model.ListEntry$anon$lazy$macro$155$1$$anon$78", {
  Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78.prototype.$classData = $d_Lreactbuild_model_ListEntry$anon$lazy$macro$155$1$$anon$78;
/** @constructor */
function $c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76(outer) {
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderFortemplateEntry = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderForcreated = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderForproject = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderForduration = null;
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderFortemplateEntry = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderForcreated = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderForproject = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_model_CachedExpression$().encodeCachedExpression__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder($m_Lreactbuild_model_Expression$().encodeExpression__Lio_circe_Encoder(), $m_Lio_circe_Encoder$().encodeDuration__Lio_circe_Encoder());
  this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderForduration = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76.prototype = new $h_O();
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76.prototype.constructor = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76;
/** @constructor */
function $h_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76.prototype = $c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76.prototype;
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFortemplateEntry = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForcreated = $as_Ljava_time_Instant($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForproject = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForduration = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x1 = $m_Lio_circe_JsonObject$();
              var this$4 = $m_sci_Vector$();
              var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("templateEntry"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderFortemplateEntry).apply__O__Lio_circe_Json(circeGenericHListBindingFortemplateEntry)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("created"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderForcreated).apply__O__Lio_circe_Json(circeGenericHListBindingForcreated)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("project"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderForproject).apply__O__Lio_circe_Json(circeGenericHListBindingForproject)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("duration"), $n(this.Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76__f_circeGenericEncoderForduration).apply__O__Lio_circe_Json(circeGenericHListBindingForduration))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76 = new $TypeData().initClass({
  Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76: 0
}, false, "reactbuild.model.ListEntry$anon$lazy$macro$43$8$$anon$76", {
  Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76.prototype.$classData = $d_Lreactbuild_model_ListEntry$anon$lazy$macro$43$8$$anon$76;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Approved$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Approved$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Approved$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Approved$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype.productPrefix__T = (function() {
  return "Approved"
});
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype.hashCode__I = (function() {
  return 1249888983
});
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype.toString__T = (function() {
  return "Approved"
});
function $as_Lreactbuild_model_ListEntryEventBody$Approved$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Approved$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Approved$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Approved$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Approved$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Approved$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Approved$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Approved$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Approved$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Approved$: 0
}, false, "reactbuild.model.ListEntryEventBody$Approved$", {
  Lreactbuild_model_ListEntryEventBody$Approved$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventIssue: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Approved$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Approved$;
var $n_Lreactbuild_model_ListEntryEventBody$Approved$;
function $m_Lreactbuild_model_ListEntryEventBody$Approved$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Approved$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Approved$ = new $c_Lreactbuild_model_ListEntryEventBody$Approved$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Approved$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Compliant$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Compliant$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Compliant$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype.productPrefix__T = (function() {
  return "Compliant"
});
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype.hashCode__I = (function() {
  return 601137531
});
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype.toString__T = (function() {
  return "Compliant"
});
function $as_Lreactbuild_model_ListEntryEventBody$Compliant$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Compliant$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Compliant$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Compliant$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Compliant$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Compliant$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Compliant$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Compliant$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Compliant$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Compliant$: 0
}, false, "reactbuild.model.ListEntryEventBody$Compliant$", {
  Lreactbuild_model_ListEntryEventBody$Compliant$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventCheck: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Compliant$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Compliant$;
var $n_Lreactbuild_model_ListEntryEventBody$Compliant$;
function $m_Lreactbuild_model_ListEntryEventBody$Compliant$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Compliant$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Compliant$ = new $c_Lreactbuild_model_ListEntryEventBody$Compliant$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Compliant$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Done$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Done$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Done$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Done$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Done$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype.productPrefix__T = (function() {
  return "Done"
});
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype.hashCode__I = (function() {
  return 2135970
});
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype.toString__T = (function() {
  return "Done"
});
function $as_Lreactbuild_model_ListEntryEventBody$Done$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Done$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Done$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Done$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Done$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Done$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Done$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Done$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Done$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Done$: 0
}, false, "reactbuild.model.ListEntryEventBody$Done$", {
  Lreactbuild_model_ListEntryEventBody$Done$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventTask: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Done$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Done$;
var $n_Lreactbuild_model_ListEntryEventBody$Done$;
function $m_Lreactbuild_model_ListEntryEventBody$Done$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Done$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Done$ = new $c_Lreactbuild_model_ListEntryEventBody$Done$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Done$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Followed$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Followed$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Followed$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Followed$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype.productPrefix__T = (function() {
  return "Followed"
});
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype.hashCode__I = (function() {
  return 366445616
});
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype.toString__T = (function() {
  return "Followed"
});
function $as_Lreactbuild_model_ListEntryEventBody$Followed$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Followed$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Followed$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Followed$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Followed$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Followed$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Followed$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Followed$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Followed$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Followed$: 0
}, false, "reactbuild.model.ListEntryEventBody$Followed$", {
  Lreactbuild_model_ListEntryEventBody$Followed$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventGuideline: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Followed$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Followed$;
var $n_Lreactbuild_model_ListEntryEventBody$Followed$;
function $m_Lreactbuild_model_ListEntryEventBody$Followed$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Followed$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Followed$ = new $c_Lreactbuild_model_ListEntryEventBody$Followed$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Followed$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Ignored$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Ignored$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Ignored$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype.productPrefix__T = (function() {
  return "Ignored"
});
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype.hashCode__I = (function() {
  return (-877898574)
});
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype.toString__T = (function() {
  return "Ignored"
});
function $as_Lreactbuild_model_ListEntryEventBody$Ignored$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Ignored$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Ignored$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Ignored$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Ignored$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Ignored$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Ignored$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Ignored$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Ignored$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Ignored$: 0
}, false, "reactbuild.model.ListEntryEventBody$Ignored$", {
  Lreactbuild_model_ListEntryEventBody$Ignored$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventGuideline: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Ignored$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Ignored$;
var $n_Lreactbuild_model_ListEntryEventBody$Ignored$;
function $m_Lreactbuild_model_ListEntryEventBody$Ignored$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Ignored$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Ignored$ = new $c_Lreactbuild_model_ListEntryEventBody$Ignored$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Ignored$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$InStock$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$InStock$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$InStock$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$InStock$.prototype = $c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype.productPrefix__T = (function() {
  return "InStock"
});
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype.hashCode__I = (function() {
  return (-702283567)
});
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype.toString__T = (function() {
  return "InStock"
});
function $as_Lreactbuild_model_ListEntryEventBody$InStock$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$InStock$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$InStock$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$InStock$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$InStock$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$InStock$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$InStock$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$InStock$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$InStock$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$InStock$: 0
}, false, "reactbuild.model.ListEntryEventBody$InStock$", {
  Lreactbuild_model_ListEntryEventBody$InStock$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventSupply: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$InStock$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$InStock$;
var $n_Lreactbuild_model_ListEntryEventBody$InStock$;
function $m_Lreactbuild_model_ListEntryEventBody$InStock$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$InStock$)) {
    $n_Lreactbuild_model_ListEntryEventBody$InStock$ = new $c_Lreactbuild_model_ListEntryEventBody$InStock$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$InStock$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$NonCompliant(reason) {
  this.Lreactbuild_model_ListEntryEventBody$NonCompliant__f_reason = null;
  this.Lreactbuild_model_ListEntryEventBody$NonCompliant__f_reason = reason
}
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$NonCompliant;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$NonCompliant() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype = $c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype;
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifFound).apply__O__O(this.Lreactbuild_model_ListEntryEventBody$NonCompliant__f_reason)
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.productPrefix__T = (function() {
  return "NonCompliant"
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_ListEntryEventBody$NonCompliant__f_reason : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListEntryEventBody$NonCompliant)) {
    var NonCompliant$1 = $as_Lreactbuild_model_ListEntryEventBody$NonCompliant(x$1);
    return (this.Lreactbuild_model_ListEntryEventBody$NonCompliant__f_reason === $n(NonCompliant$1).Lreactbuild_model_ListEntryEventBody$NonCompliant__f_reason)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListEntryEventBody$NonCompliant(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$NonCompliant) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$NonCompliant"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$NonCompliant(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$NonCompliant)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$NonCompliant(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$NonCompliant(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$NonCompliant;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$NonCompliant = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$NonCompliant: 0
}, false, "reactbuild.model.ListEntryEventBody$NonCompliant", {
  Lreactbuild_model_ListEntryEventBody$NonCompliant: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventCheck: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$NonCompliant.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$NonCompliant;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Ordered$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Ordered$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Ordered$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype.productPrefix__T = (function() {
  return "Ordered"
});
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype.hashCode__I = (function() {
  return 457543757
});
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype.toString__T = (function() {
  return "Ordered"
});
function $as_Lreactbuild_model_ListEntryEventBody$Ordered$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Ordered$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Ordered$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Ordered$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Ordered$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Ordered$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Ordered$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Ordered$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Ordered$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Ordered$: 0
}, false, "reactbuild.model.ListEntryEventBody$Ordered$", {
  Lreactbuild_model_ListEntryEventBody$Ordered$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventSupply: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Ordered$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Ordered$;
var $n_Lreactbuild_model_ListEntryEventBody$Ordered$;
function $m_Lreactbuild_model_ListEntryEventBody$Ordered$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Ordered$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Ordered$ = new $c_Lreactbuild_model_ListEntryEventBody$Ordered$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Ordered$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Pending$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Pending$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Pending$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Pending$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype.productPrefix__T = (function() {
  return "Pending"
});
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype.hashCode__I = (function() {
  return 982065527
});
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype.toString__T = (function() {
  return "Pending"
});
function $as_Lreactbuild_model_ListEntryEventBody$Pending$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Pending$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Pending$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Pending$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Pending$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Pending$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Pending$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Pending$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Pending$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Pending$: 0
}, false, "reactbuild.model.ListEntryEventBody$Pending$", {
  Lreactbuild_model_ListEntryEventBody$Pending$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventTask: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Pending$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Pending$;
var $n_Lreactbuild_model_ListEntryEventBody$Pending$;
function $m_Lreactbuild_model_ListEntryEventBody$Pending$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Pending$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Pending$ = new $c_Lreactbuild_model_ListEntryEventBody$Pending$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Pending$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Pickup$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Pickup$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Pickup$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype.productPrefix__T = (function() {
  return "Pickup"
});
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype.hashCode__I = (function() {
  return (-1904609636)
});
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype.toString__T = (function() {
  return "Pickup"
});
function $as_Lreactbuild_model_ListEntryEventBody$Pickup$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Pickup$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Pickup$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Pickup$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Pickup$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Pickup$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Pickup$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Pickup$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Pickup$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Pickup$: 0
}, false, "reactbuild.model.ListEntryEventBody$Pickup$", {
  Lreactbuild_model_ListEntryEventBody$Pickup$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventSupply: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Pickup$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Pickup$;
var $n_Lreactbuild_model_ListEntryEventBody$Pickup$;
function $m_Lreactbuild_model_ListEntryEventBody$Pickup$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Pickup$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Pickup$ = new $c_Lreactbuild_model_ListEntryEventBody$Pickup$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Pickup$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Read$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Read$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Read$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Read$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Read$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype.productPrefix__T = (function() {
  return "Read"
});
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype.hashCode__I = (function() {
  return 2543030
});
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype.toString__T = (function() {
  return "Read"
});
function $as_Lreactbuild_model_ListEntryEventBody$Read$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Read$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Read$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Read$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Read$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Read$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Read$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Read$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Read$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Read$: 0
}, false, "reactbuild.model.ListEntryEventBody$Read$", {
  Lreactbuild_model_ListEntryEventBody$Read$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventIssue: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Read$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Read$;
var $n_Lreactbuild_model_ListEntryEventBody$Read$;
function $m_Lreactbuild_model_ListEntryEventBody$Read$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Read$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Read$ = new $c_Lreactbuild_model_ListEntryEventBody$Read$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Read$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Received$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Received$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Received$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Received$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Received$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype.productPrefix__T = (function() {
  return "Received"
});
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype.hashCode__I = (function() {
  return (-744075775)
});
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype.toString__T = (function() {
  return "Received"
});
function $as_Lreactbuild_model_ListEntryEventBody$Received$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Received$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Received$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Received$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Received$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Received$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Received$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Received$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Received$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Received$: 0
}, false, "reactbuild.model.ListEntryEventBody$Received$", {
  Lreactbuild_model_ListEntryEventBody$Received$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventSupply: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Received$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Received$;
var $n_Lreactbuild_model_ListEntryEventBody$Received$;
function $m_Lreactbuild_model_ListEntryEventBody$Received$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Received$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Received$ = new $c_Lreactbuild_model_ListEntryEventBody$Received$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Received$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Rejected(reason) {
  this.Lreactbuild_model_ListEntryEventBody$Rejected__f_reason = null;
  this.Lreactbuild_model_ListEntryEventBody$Rejected__f_reason = reason
}
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Rejected;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Rejected() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Rejected.prototype = $c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifFound).apply__O__O(this.Lreactbuild_model_ListEntryEventBody$Rejected__f_reason)
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.productPrefix__T = (function() {
  return "Rejected"
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_ListEntryEventBody$Rejected__f_reason : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListEntryEventBody$Rejected)) {
    var Rejected$1 = $as_Lreactbuild_model_ListEntryEventBody$Rejected(x$1);
    return (this.Lreactbuild_model_ListEntryEventBody$Rejected__f_reason === $n(Rejected$1).Lreactbuild_model_ListEntryEventBody$Rejected__f_reason)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListEntryEventBody$Rejected(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Rejected) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Rejected"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Rejected(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Rejected)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Rejected(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Rejected(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Rejected;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Rejected = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Rejected: 0
}, false, "reactbuild.model.ListEntryEventBody$Rejected", {
  Lreactbuild_model_ListEntryEventBody$Rejected: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventIssue: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Rejected.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Rejected;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Shipped$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Shipped$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Shipped$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype.productPrefix__T = (function() {
  return "Shipped"
});
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype.hashCode__I = (function() {
  return (-568756941)
});
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype.toString__T = (function() {
  return "Shipped"
});
function $as_Lreactbuild_model_ListEntryEventBody$Shipped$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Shipped$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Shipped$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Shipped$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Shipped$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Shipped$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Shipped$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Shipped$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Shipped$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Shipped$: 0
}, false, "reactbuild.model.ListEntryEventBody$Shipped$", {
  Lreactbuild_model_ListEntryEventBody$Shipped$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventSupply: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Shipped$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Shipped$;
var $n_Lreactbuild_model_ListEntryEventBody$Shipped$;
function $m_Lreactbuild_model_ListEntryEventBody$Shipped$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Shipped$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Shipped$ = new $c_Lreactbuild_model_ListEntryEventBody$Shipped$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Shipped$
}
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69(outer) {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69__f_circeGenericEncoderForterm = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69__f_circeGenericEncoderForterm = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForterm = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("term"), $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69__f_circeGenericEncoderForterm).apply__O__Lio_circe_Json(circeGenericHListBindingForterm))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$69", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$69;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70(outer) {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$70", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$70;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71(outer) {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71__f_circeGenericEncoderForreason = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71__f_circeGenericEncoderForreason = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForreason = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reason"), $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71__f_circeGenericEncoderForreason).apply__O__Lio_circe_Json(circeGenericHListBindingForreason))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$71", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$71;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72(outer) {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72__f_circeGenericEncoderForcomment = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72__f_circeGenericEncoderForcomment = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForcomment = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("comment"), $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72__f_circeGenericEncoderForcomment).apply__O__Lio_circe_Json(circeGenericHListBindingForcomment))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$72", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$72;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73(outer) {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73__f_circeGenericEncoderForpreviousTitle = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73__f_circeGenericEncoderForpreviousTitle = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForpreviousTitle = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("previousTitle"), $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73__f_circeGenericEncoderForpreviousTitle).apply__O__Lio_circe_Json(circeGenericHListBindingForpreviousTitle))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$73", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$73;
/** @constructor */
function $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62(outer) {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62.prototype.constructor = $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62;
/** @constructor */
function $h_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62.prototype = $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62.prototype;
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62: 0
}, false, "reactbuild.model.ListEntryType$anon$lazy$macro$15$2$$anon$62", {
  Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62.prototype.$classData = $d_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$62;
/** @constructor */
function $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60(outer) {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60.prototype.constructor = $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60;
/** @constructor */
function $h_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60.prototype = $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60.prototype;
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60: 0
}, false, "reactbuild.model.ListEntryValidation$anon$lazy$macro$9$1$$anon$60", {
  Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60.prototype.$classData = $d_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$60;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$Document(_id, file) {
  this.Lreactbuild_model_MapFeature$Document__f__id = null;
  this.Lreactbuild_model_MapFeature$Document__f_file = null;
  this.Lreactbuild_model_MapFeature$Document__f__id = _id;
  this.Lreactbuild_model_MapFeature$Document__f_file = file
}
$c_Lreactbuild_model_MapFeature$Document.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$Document.prototype.constructor = $c_Lreactbuild_model_MapFeature$Document;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$Document() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$Document.prototype = $c_Lreactbuild_model_MapFeature$Document.prototype;
$c_Lreactbuild_model_MapFeature$Document.prototype._id__Lreactbuild_common_model_RefTo = (function() {
  return this.Lreactbuild_model_MapFeature$Document__f__id
});
$c_Lreactbuild_model_MapFeature$Document.prototype.productPrefix__T = (function() {
  return "Document"
});
$c_Lreactbuild_model_MapFeature$Document.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_model_MapFeature$Document.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_MapFeature$Document__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_MapFeature$Document__f_file;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_MapFeature$Document.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_MapFeature$Document.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_MapFeature$Document.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_MapFeature$Document.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_MapFeature$Document)) {
    var Document$1 = $as_Lreactbuild_model_MapFeature$Document(x$1);
    var x = this.Lreactbuild_model_MapFeature$Document__f__id;
    var x$2 = $n(Document$1).Lreactbuild_model_MapFeature$Document__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_MapFeature$Document__f_file;
      var x$4 = $n(Document$1).Lreactbuild_model_MapFeature$Document__f_file;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_MapFeature$Document(obj) {
  return (((obj instanceof $c_Lreactbuild_model_MapFeature$Document) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.MapFeature$Document"))
}
function $isArrayOf_Lreactbuild_model_MapFeature$Document(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_MapFeature$Document)))
}
function $asArrayOf_Lreactbuild_model_MapFeature$Document(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_MapFeature$Document(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.MapFeature$Document;", depth))
}
var $d_Lreactbuild_model_MapFeature$Document = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$Document: 0
}, false, "reactbuild.model.MapFeature$Document", {
  Lreactbuild_model_MapFeature$Document: 1,
  O: 1,
  Lreactbuild_model_MapFeature$WithFile: 1,
  Lreactbuild_model_MapFeature$MapFeature: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$Document.prototype.$classData = $d_Lreactbuild_model_MapFeature$Document;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$Image(_id, project, orientation, level, file, metadata, markers) {
  this.Lreactbuild_model_MapFeature$Image__f__id = null;
  this.Lreactbuild_model_MapFeature$Image__f_project = null;
  this.Lreactbuild_model_MapFeature$Image__f_orientation = null;
  this.Lreactbuild_model_MapFeature$Image__f_level = 0;
  this.Lreactbuild_model_MapFeature$Image__f_file = null;
  this.Lreactbuild_model_MapFeature$Image__f_metadata = null;
  this.Lreactbuild_model_MapFeature$Image__f_markers = null;
  this.Lreactbuild_model_MapFeature$Image__f__id = _id;
  this.Lreactbuild_model_MapFeature$Image__f_project = project;
  this.Lreactbuild_model_MapFeature$Image__f_orientation = orientation;
  this.Lreactbuild_model_MapFeature$Image__f_level = level;
  this.Lreactbuild_model_MapFeature$Image__f_file = file;
  this.Lreactbuild_model_MapFeature$Image__f_metadata = metadata;
  this.Lreactbuild_model_MapFeature$Image__f_markers = markers
}
$c_Lreactbuild_model_MapFeature$Image.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$Image.prototype.constructor = $c_Lreactbuild_model_MapFeature$Image;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$Image() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$Image.prototype = $c_Lreactbuild_model_MapFeature$Image.prototype;
$c_Lreactbuild_model_MapFeature$Image.prototype._id__Lreactbuild_common_model_RefTo = (function() {
  return this.Lreactbuild_model_MapFeature$Image__f__id
});
$c_Lreactbuild_model_MapFeature$Image.prototype.productPrefix__T = (function() {
  return "Image"
});
$c_Lreactbuild_model_MapFeature$Image.prototype.productArity__I = (function() {
  return 7
});
$c_Lreactbuild_model_MapFeature$Image.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_MapFeature$Image__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_MapFeature$Image__f_project;
      break
    }
    case 2: {
      return this.Lreactbuild_model_MapFeature$Image__f_orientation;
      break
    }
    case 3: {
      return this.Lreactbuild_model_MapFeature$Image__f_level;
      break
    }
    case 4: {
      return this.Lreactbuild_model_MapFeature$Image__f_file;
      break
    }
    case 5: {
      return this.Lreactbuild_model_MapFeature$Image__f_metadata;
      break
    }
    case 6: {
      return this.Lreactbuild_model_MapFeature$Image__f_markers;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_MapFeature$Image.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_MapFeature$Image.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Image");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_model_MapFeature$Image__f__id;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_model_MapFeature$Image__f_project;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_model_MapFeature$Image__f_orientation;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Lreactbuild_model_MapFeature$Image__f_level;
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lreactbuild_model_MapFeature$Image__f_file;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lreactbuild_model_MapFeature$Image__f_metadata;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.Lreactbuild_model_MapFeature$Image__f_markers;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$8, 7)
});
$c_Lreactbuild_model_MapFeature$Image.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_MapFeature$Image.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_MapFeature$Image)) {
    var Image$1 = $as_Lreactbuild_model_MapFeature$Image(x$1);
    if ((this.Lreactbuild_model_MapFeature$Image__f_level === $n(Image$1).Lreactbuild_model_MapFeature$Image__f_level)) {
      var x = this.Lreactbuild_model_MapFeature$Image__f__id;
      var x$2 = $n(Image$1).Lreactbuild_model_MapFeature$Image__f__id;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lreactbuild_model_MapFeature$Image__f_project;
        var x$4 = $n(Image$1).Lreactbuild_model_MapFeature$Image__f_project;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_model_MapFeature$Image__f_orientation;
      var x$6 = $n(Image$1).Lreactbuild_model_MapFeature$Image__f_orientation;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_MapFeature$Image__f_file;
        var x$8 = $n(Image$1).Lreactbuild_model_MapFeature$Image__f_file;
        var $$x2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        var x$9 = this.Lreactbuild_model_MapFeature$Image__f_metadata;
        var x$10 = $n(Image$1).Lreactbuild_model_MapFeature$Image__f_metadata;
        if (((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))) {
          var x$11 = this.Lreactbuild_model_MapFeature$Image__f_markers;
          var x$12 = $n(Image$1).Lreactbuild_model_MapFeature$Image__f_markers;
          return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12))
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_MapFeature$Image(obj) {
  return (((obj instanceof $c_Lreactbuild_model_MapFeature$Image) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.MapFeature$Image"))
}
function $isArrayOf_Lreactbuild_model_MapFeature$Image(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_MapFeature$Image)))
}
function $asArrayOf_Lreactbuild_model_MapFeature$Image(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_MapFeature$Image(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.MapFeature$Image;", depth))
}
var $d_Lreactbuild_model_MapFeature$Image = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$Image: 0
}, false, "reactbuild.model.MapFeature$Image", {
  Lreactbuild_model_MapFeature$Image: 1,
  O: 1,
  Lreactbuild_model_MapFeature$WithFile: 1,
  Lreactbuild_model_MapFeature$MapFeature: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$Image.prototype.$classData = $d_Lreactbuild_model_MapFeature$Image;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5(outer) {
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderForlevel = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderForaltitude = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderForlabel = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderForlevel = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderForaltitude = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderForlabel = new $c_Lio_circe_Encoder$$anon$21(e$2)
}
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5.prototype = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5.prototype;
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForlevel = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForaltitude = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForlabel = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("level"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderForlevel).apply__O__Lio_circe_Json(circeGenericHListBindingForlevel)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("altitude"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderForaltitude).apply__O__Lio_circe_Json(circeGenericHListBindingForaltitude)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("label"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5__f_circeGenericEncoderForlabel).apply__O__Lio_circe_Json(circeGenericHListBindingForlabel))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5 = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5: 0
}, false, "reactbuild.model.MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5", {
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$5;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6(outer) {
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderForproject = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFororientation = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderForlevel = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderForfile = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFormetadata = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFormarkers = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderForproject = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFororientation = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderForlevel = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderForfile = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFormetadata = $m_Lio_circe_Encoder$().encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString, $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeJson);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_MapFeature$MapFeatureMarker$().Lreactbuild_model_MapFeature$MapFeatureMarker$__f_codecForMapFeatureMarker;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFormarkers = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6.prototype = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6.prototype;
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForproject = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFororientation = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForlevel = $uI($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForfile = $as_Lreactbuild_common_model_RefTo($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingFormetadata = $as_sci_Map($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingFormarkers = $as_sci_List($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p8)) {
                  var $$x9 = $m_Lio_circe_JsonObject$();
                  var this$6 = $m_sci_Vector$();
                  var $$x8 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                  var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("project"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderForproject).apply__O__Lio_circe_Json(circeGenericHListBindingForproject));
                  var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("orientation"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFororientation).apply__O__Lio_circe_Json(circeGenericHListBindingFororientation));
                  var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("level"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderForlevel).apply__O__Lio_circe_Json(circeGenericHListBindingForlevel));
                  var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("file"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderForfile).apply__O__Lio_circe_Json(circeGenericHListBindingForfile));
                  var $$x3 = $n(transformMemberNames).apply__O__O("metadata");
                  var this$1 = $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFormetadata);
                  var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFormetadata));
                  var $$x1 = $n(transformMemberNames).apply__O__O("markers");
                  var this$2 = $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6__f_circeGenericEncoderFormarkers);
                  var array = [$$x8, $$x7, $$x6, $$x5, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFormarkers))];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                  return $n($$x9).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6: 0
}, false, "reactbuild.model.MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6", {
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7(outer) {
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7__f_circeGenericEncoderForfile = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7__f_circeGenericEncoderForfile = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7.prototype = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7.prototype;
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForfile = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("file"), $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7__f_circeGenericEncoderForfile).apply__O__Lio_circe_Json(circeGenericHListBindingForfile))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7: 0
}, false, "reactbuild.model.MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7", {
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$Measure(_id, level, altitude, label) {
  this.Lreactbuild_model_MapFeature$Measure__f__id = null;
  this.Lreactbuild_model_MapFeature$Measure__f_level = null;
  this.Lreactbuild_model_MapFeature$Measure__f_altitude = null;
  this.Lreactbuild_model_MapFeature$Measure__f_label = null;
  this.Lreactbuild_model_MapFeature$Measure__f__id = _id;
  this.Lreactbuild_model_MapFeature$Measure__f_level = level;
  this.Lreactbuild_model_MapFeature$Measure__f_altitude = altitude;
  this.Lreactbuild_model_MapFeature$Measure__f_label = label
}
$c_Lreactbuild_model_MapFeature$Measure.prototype = new $h_O();
$c_Lreactbuild_model_MapFeature$Measure.prototype.constructor = $c_Lreactbuild_model_MapFeature$Measure;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$Measure() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$Measure.prototype = $c_Lreactbuild_model_MapFeature$Measure.prototype;
$c_Lreactbuild_model_MapFeature$Measure.prototype._id__Lreactbuild_common_model_RefTo = (function() {
  return this.Lreactbuild_model_MapFeature$Measure__f__id
});
$c_Lreactbuild_model_MapFeature$Measure.prototype.productPrefix__T = (function() {
  return "Measure"
});
$c_Lreactbuild_model_MapFeature$Measure.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_model_MapFeature$Measure.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_MapFeature$Measure__f__id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_MapFeature$Measure__f_level;
      break
    }
    case 2: {
      return this.Lreactbuild_model_MapFeature$Measure__f_altitude;
      break
    }
    case 3: {
      return this.Lreactbuild_model_MapFeature$Measure__f_label;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_MapFeature$Measure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_MapFeature$Measure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_MapFeature$Measure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_MapFeature$Measure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_MapFeature$Measure)) {
    var Measure$1 = $as_Lreactbuild_model_MapFeature$Measure(x$1);
    var x = this.Lreactbuild_model_MapFeature$Measure__f__id;
    var x$2 = $n(Measure$1).Lreactbuild_model_MapFeature$Measure__f__id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_model_MapFeature$Measure__f_level;
      var x$4 = $n(Measure$1).Lreactbuild_model_MapFeature$Measure__f_level;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_model_MapFeature$Measure__f_altitude;
      var x$6 = $n(Measure$1).Lreactbuild_model_MapFeature$Measure__f_altitude;
      if (((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))) {
        var x$7 = this.Lreactbuild_model_MapFeature$Measure__f_label;
        var x$8 = $n(Measure$1).Lreactbuild_model_MapFeature$Measure__f_label;
        return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_MapFeature$Measure(obj) {
  return (((obj instanceof $c_Lreactbuild_model_MapFeature$Measure) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.MapFeature$Measure"))
}
function $isArrayOf_Lreactbuild_model_MapFeature$Measure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_MapFeature$Measure)))
}
function $asArrayOf_Lreactbuild_model_MapFeature$Measure(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_MapFeature$Measure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.MapFeature$Measure;", depth))
}
var $d_Lreactbuild_model_MapFeature$Measure = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$Measure: 0
}, false, "reactbuild.model.MapFeature$Measure", {
  Lreactbuild_model_MapFeature$Measure: 1,
  O: 1,
  Lreactbuild_model_MapFeature$WithoutFile: 1,
  Lreactbuild_model_MapFeature$MapFeature: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_MapFeature$Measure.prototype.$classData = $d_Lreactbuild_model_MapFeature$Measure;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100(outer) {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100__f_circeGenericEncoderForref = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100__f_circeGenericEncoderForref = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForref = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("ref"), $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100__f_circeGenericEncoderForref).apply__O__Lio_circe_Json(circeGenericHListBindingForref))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4$$anon$100", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$100;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101(outer) {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101__f_circeGenericEncoderForref = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101__f_circeGenericEncoderForref = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForref = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("ref"), $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101__f_circeGenericEncoderForref).apply__O__Lio_circe_Json(circeGenericHListBindingForref))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4$$anon$101", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$101;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98(outer) {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98__f_circeGenericEncoderForref = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98__f_circeGenericEncoderForref = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForref = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("ref"), $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98__f_circeGenericEncoderForref).apply__O__Lio_circe_Json(circeGenericHListBindingForref))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4$$anon$98", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$98;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99(outer) {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99__f_circeGenericEncoderForitem = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99__f_circeGenericEncoderForitem = $m_Lreactbuild_person_PersonReferenceEvent$().Lreactbuild_person_PersonReferenceEvent$__f_codecForPersonReferenceEvent
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99.prototype = new $h_O();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForitem = $as_Lreactbuild_person_PersonReferenceEvent($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("item");
      var this$1 = $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99__f_circeGenericEncoderForitem);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForitem))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4$$anon$99", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$99;
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10(outer) {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10__f_circeGenericEncoderForid = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10__f_circeGenericEncoderFortarget = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10__f_circeGenericEncoderFortarget = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10.prototype = new $h_O();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortarget = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("target"), $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10__f_circeGenericEncoderFortarget).apply__O__Lio_circe_Json(circeGenericHListBindingFortarget))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1$$anon$10", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$10;
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11(outer) {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11__f_circeGenericEncoderForid = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11__f_circeGenericEncoderFortarget = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11__f_circeGenericEncoderFortarget = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11.prototype = new $h_O();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortarget = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("target"), $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11__f_circeGenericEncoderFortarget).apply__O__Lio_circe_Json(circeGenericHListBindingFortarget))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1$$anon$11", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$11;
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12(outer) {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12__f_circeGenericEncoderForid = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12__f_circeGenericEncoderFortarget = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12__f_circeGenericEncoderFortarget = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12.prototype = new $h_O();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortarget = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("target"), $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12__f_circeGenericEncoderFortarget).apply__O__Lio_circe_Json(circeGenericHListBindingFortarget))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1$$anon$12", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$12;
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9(outer) {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9__f_circeGenericEncoderForid = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9__f_circeGenericEncoderFortarget = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9__f_circeGenericEncoderFortarget = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9.prototype = new $h_O();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortarget = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("target"), $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9__f_circeGenericEncoderFortarget).apply__O__Lio_circe_Json(circeGenericHListBindingFortarget))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1$$anon$9", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$9;
/** @constructor */
function $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2(outer) {
  /*<skip>*/
}
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2.prototype = new $h_O();
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2.prototype.constructor = $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2.prototype = $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2.prototype;
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2: 0
}, false, "reactbuild.model.TaskRole$anon$lazy$macro$9$1$$anon$2", {
  Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2.prototype.$classData = $d_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7(outer) {
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFororigin = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFororigin = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder()
}
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7.prototype = new $h_Lio_circe_generic_encoding_ReprAsObjectEncoder();
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7.prototype.constructor = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7.prototype = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7.prototype;
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7.prototype.encodeObject__Lshapeless_$colon$colon__Lio_circe_JsonObject = (function(a) {
  if ((a !== null)) {
    var circeGenericHListBindingFororigin = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), "origin", $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFororigin).apply__O__Lio_circe_Json(circeGenericHListBindingFororigin))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lshapeless_$colon$colon__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a))
});
var $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7: 0
}, false, "reactbuild.model.ToClient$anon$lazy$macro$59$1$$anon$7", {
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7: 1,
  Lio_circe_generic_encoding_ReprAsObjectEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7.prototype.$classData = $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8(outer) {
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderFororigin = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderForuser = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderForprojectRef = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderFory = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderFororigin = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderForuser = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderForprojectRef = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderFory = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8.prototype = new $h_Lio_circe_generic_encoding_ReprAsObjectEncoder();
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8.prototype.constructor = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8;
/** @constructor */
function $h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8.prototype = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8.prototype;
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8.prototype.encodeObject__Lshapeless_$colon$colon__Lio_circe_JsonObject = (function(a) {
  if ((a !== null)) {
    var circeGenericHListBindingFororigin = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForuser = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForprojectRef = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForx = $uD($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFory = $uD($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x1 = $m_Lio_circe_JsonObject$();
              var this$4 = $m_sci_Vector$();
              var array = [$ct_T2__O__O__(new $c_T2(), "origin", $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderFororigin).apply__O__Lio_circe_Json(circeGenericHListBindingFororigin)), $ct_T2__O__O__(new $c_T2(), "user", $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderForuser).apply__O__Lio_circe_Json(circeGenericHListBindingForuser)), $ct_T2__O__O__(new $c_T2(), "projectRef", $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderForprojectRef).apply__O__Lio_circe_Json(circeGenericHListBindingForprojectRef)), $ct_T2__O__O__(new $c_T2(), "x", $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderFory).apply__O__Lio_circe_Json(circeGenericHListBindingForx)), $ct_T2__O__O__(new $c_T2(), "y", $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8__f_circeGenericEncoderFory).apply__O__Lio_circe_Json(circeGenericHListBindingFory))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lshapeless_$colon$colon__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a))
});
var $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8 = new $TypeData().initClass({
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8: 0
}, false, "reactbuild.model.ToClient$anon$lazy$macro$59$1$$anon$8", {
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8: 1,
  Lio_circe_generic_encoding_ReprAsObjectEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8.prototype.$classData = $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$8;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessEdge(id, name, sourceRef, targetRef) {
  this.Lreactbuild_model_process_ProcessEdge__f_id = null;
  this.Lreactbuild_model_process_ProcessEdge__f_name = null;
  this.Lreactbuild_model_process_ProcessEdge__f_sourceRef = null;
  this.Lreactbuild_model_process_ProcessEdge__f_targetRef = null;
  this.Lreactbuild_model_process_ProcessEdge__f_id = id;
  this.Lreactbuild_model_process_ProcessEdge__f_name = name;
  this.Lreactbuild_model_process_ProcessEdge__f_sourceRef = sourceRef;
  this.Lreactbuild_model_process_ProcessEdge__f_targetRef = targetRef
}
$c_Lreactbuild_model_process_ProcessEdge.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessEdge.prototype.constructor = $c_Lreactbuild_model_process_ProcessEdge;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessEdge() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessEdge.prototype = $c_Lreactbuild_model_process_ProcessEdge.prototype;
$c_Lreactbuild_model_process_ProcessEdge.prototype.productPrefix__T = (function() {
  return "ProcessEdge"
});
$c_Lreactbuild_model_process_ProcessEdge.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_model_process_ProcessEdge.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_process_ProcessEdge__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_process_ProcessEdge__f_name;
      break
    }
    case 2: {
      return this.Lreactbuild_model_process_ProcessEdge__f_sourceRef;
      break
    }
    case 3: {
      return this.Lreactbuild_model_process_ProcessEdge__f_targetRef;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessEdge.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessEdge.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessEdge.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessEdge.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessEdge)) {
    var ProcessEdge$1 = $as_Lreactbuild_model_process_ProcessEdge(x$1);
    var x = this.Lreactbuild_model_process_ProcessEdge__f_id;
    var x$2 = $n(ProcessEdge$1).Lreactbuild_model_process_ProcessEdge__f_id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_model_process_ProcessEdge__f_name === $n(ProcessEdge$1).Lreactbuild_model_process_ProcessEdge__f_name))) {
      var x$3 = this.Lreactbuild_model_process_ProcessEdge__f_sourceRef;
      var x$4 = $n(ProcessEdge$1).Lreactbuild_model_process_ProcessEdge__f_sourceRef;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_model_process_ProcessEdge__f_targetRef;
        var x$6 = $n(ProcessEdge$1).Lreactbuild_model_process_ProcessEdge__f_targetRef;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessEdge(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessEdge) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessEdge"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessEdge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessEdge)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessEdge(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessEdge(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessEdge;", depth))
}
var $d_Lreactbuild_model_process_ProcessEdge = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessEdge: 0
}, false, "reactbuild.model.process.ProcessEdge", {
  Lreactbuild_model_process_ProcessEdge: 1,
  O: 1,
  Lreactbuild_model_process_AbstractProcessElement: 1,
  Lreactbuild_model_process_ProcessElement: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessEdge.prototype.$classData = $d_Lreactbuild_model_process_ProcessEdge;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4(outer) {
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4__f_circeGenericEncoderForid = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4__f_circeGenericEncoderForname = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4__f_circeGenericEncoderFordetails = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4__f_circeGenericEncoderForid = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4__f_circeGenericEncoderFordetails = $m_Lreactbuild_model_process_ProcessNodeDetails$().Lreactbuild_model_process_ProcessNodeDetails$__f_codecForProcessNodeDetails
}
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4.prototype.constructor = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4.prototype = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4.prototype;
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForname = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFordetails = $as_Lreactbuild_model_process_ProcessNodeDetails($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x4 = $m_Lio_circe_JsonObject$();
          var this$5 = $m_sci_Vector$();
          var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid));
          var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname));
          var $$x1 = $n(transformMemberNames).apply__O__O("details");
          var this$1 = $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4__f_circeGenericEncoderFordetails);
          var array = [$$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordetails))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x4).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4: 0
}, false, "reactbuild.model.process.ProcessElement$anon$lazy$macro$123$1$$anon$4", {
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4.prototype.$classData = $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$4;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5(outer) {
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderForid = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderForname = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderFortargetRef = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderForid = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderFortargetRef = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5.prototype.constructor = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5.prototype = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5.prototype;
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForname = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForsourceRef = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFortargetRef = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("sourceRef"), $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderFortargetRef).apply__O__Lio_circe_Json(circeGenericHListBindingForsourceRef)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("targetRef"), $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5__f_circeGenericEncoderFortargetRef).apply__O__Lio_circe_Json(circeGenericHListBindingFortargetRef))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5: 0
}, false, "reactbuild.model.process.ProcessElement$anon$lazy$macro$123$1$$anon$5", {
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5.prototype.$classData = $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$5;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20__f_circeGenericEncoderForref = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20__f_circeGenericEncoderForvalue = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20__f_circeGenericEncoderForref = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20__f_circeGenericEncoderForvalue = $m_Lreactbuild_model_process_PartialDate$().encodePartialDate__Lio_circe_Encoder()
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForref = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForvalue = $as_Lreactbuild_model_process_PartialDate($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("ref"), $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20__f_circeGenericEncoderForref).apply__O__Lio_circe_Json(circeGenericHListBindingForref)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("value"), $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20__f_circeGenericEncoderForvalue).apply__O__Lio_circe_Json(circeGenericHListBindingForvalue))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$20;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21__f_circeGenericEncoderFordetails = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21__f_circeGenericEncoderFordetails = $m_Lreactbuild_model_process_ProcessLink$().Lreactbuild_model_process_ProcessLink$__f_codecForProcessLink
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFordetails = $as_Lreactbuild_model_process_ProcessLink($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("details");
      var this$1 = $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21__f_circeGenericEncoderFordetails);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordetails))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$21;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22__f_circeGenericEncoderForprocess = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22__f_circeGenericEncoderForcustomProcessName = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22__f_circeGenericEncoderForprocess = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22__f_circeGenericEncoderForcustomProcessName = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForprocess = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForcustomProcessName = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("process"), $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22__f_circeGenericEncoderForprocess).apply__O__Lio_circe_Json(circeGenericHListBindingForprocess)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("customProcessName"), $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22__f_circeGenericEncoderForcustomProcessName).apply__O__Lio_circe_Json(circeGenericHListBindingForcustomProcessName))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$22;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23__f_circeGenericEncoderFornode = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23__f_circeGenericEncoderFornode = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFornode = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("node"), $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23__f_circeGenericEncoderFornode).apply__O__Lio_circe_Json(circeGenericHListBindingFornode))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$23;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24__f_circeGenericEncoderFormessage = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24__f_circeGenericEncoderFormessage = $m_Lcom_iz2use_common_Multiline$().encodeMultiline__Lio_circe_Encoder()
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFormessage = $n($as_Lcom_iz2use_common_Multiline($n(a).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("message"), $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24__f_circeGenericEncoderFormessage).apply__O__Lio_circe_Json(new $c_Lcom_iz2use_common_Multiline(circeGenericHListBindingFormessage)))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$24;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12(outer) {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12.prototype.constructor = $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12.prototype = $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12.prototype;
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12: 0
}, false, "reactbuild.model.process.ProcessLinkClass$anon$lazy$macro$9$1$$anon$12", {
  Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12.prototype.$classData = $d_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$12;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNode(id, name, details) {
  this.Lreactbuild_model_process_ProcessNode__f_id = null;
  this.Lreactbuild_model_process_ProcessNode__f_name = null;
  this.Lreactbuild_model_process_ProcessNode__f_details = null;
  this.Lreactbuild_model_process_ProcessNode__f_id = id;
  this.Lreactbuild_model_process_ProcessNode__f_name = name;
  this.Lreactbuild_model_process_ProcessNode__f_details = details
}
$c_Lreactbuild_model_process_ProcessNode.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNode.prototype.constructor = $c_Lreactbuild_model_process_ProcessNode;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNode() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNode.prototype = $c_Lreactbuild_model_process_ProcessNode.prototype;
$c_Lreactbuild_model_process_ProcessNode.prototype.productPrefix__T = (function() {
  return "ProcessNode"
});
$c_Lreactbuild_model_process_ProcessNode.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_model_process_ProcessNode.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_model_process_ProcessNode__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_model_process_ProcessNode__f_name;
      break
    }
    case 2: {
      return this.Lreactbuild_model_process_ProcessNode__f_details;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessNode.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_process_ProcessNode.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_process_ProcessNode.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_process_ProcessNode.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_process_ProcessNode)) {
    var ProcessNode$1 = $as_Lreactbuild_model_process_ProcessNode(x$1);
    var x = this.Lreactbuild_model_process_ProcessNode__f_id;
    var x$2 = $n(ProcessNode$1).Lreactbuild_model_process_ProcessNode__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      if ((this.Lreactbuild_model_process_ProcessNode__f_name === $n(ProcessNode$1).Lreactbuild_model_process_ProcessNode__f_name)) {
        var x$3 = this.Lreactbuild_model_process_ProcessNode__f_details;
        var x$4 = $n(ProcessNode$1).Lreactbuild_model_process_ProcessNode__f_details;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_model_process_ProcessNode(obj) {
  return (((obj instanceof $c_Lreactbuild_model_process_ProcessNode) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.process.ProcessNode"))
}
function $isArrayOf_Lreactbuild_model_process_ProcessNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_process_ProcessNode)))
}
function $asArrayOf_Lreactbuild_model_process_ProcessNode(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_process_ProcessNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.process.ProcessNode;", depth))
}
var $d_Lreactbuild_model_process_ProcessNode = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNode: 0
}, false, "reactbuild.model.process.ProcessNode", {
  Lreactbuild_model_process_ProcessNode: 1,
  O: 1,
  Lreactbuild_model_process_AbstractProcessElement: 1,
  Lreactbuild_model_process_ProcessElement: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNode.prototype.$classData = $d_Lreactbuild_model_process_ProcessNode;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8(outer) {
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8__f_circeGenericEncoderForperiod = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8__f_circeGenericEncoderForperiod = $m_Lio_circe_Encoder$().encodePeriod__Lio_circe_Encoder()
}
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForperiod = $as_Ljava_time_Period($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("period"), $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8__f_circeGenericEncoderForperiod).apply__O__Lio_circe_Json(circeGenericHListBindingForperiod))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8", {
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$8;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9(outer) {
  /*<skip>*/
}
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9.prototype = new $h_O();
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9", {
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$9;
/** @constructor */
function $c_Lreactbuild_package$CssSettings$() {
  this.Lreactbuild_package$CssSettings$__f_cssRegisterNameGen = null;
  this.Lreactbuild_package$CssSettings$__f_cssRegisterErrorHandler = null;
  $n_Lreactbuild_package$CssSettings$ = this;
  $f_Lscalacss_defaults_Exports__$init$__V(this);
  $f_Lscalacss_defaults_DefaultSettings$Dev__$init$__V(this)
}
$c_Lreactbuild_package$CssSettings$.prototype = new $h_O();
$c_Lreactbuild_package$CssSettings$.prototype.constructor = $c_Lreactbuild_package$CssSettings$;
/** @constructor */
function $h_Lreactbuild_package$CssSettings$() {
  /*<skip>*/
}
$h_Lreactbuild_package$CssSettings$.prototype = $c_Lreactbuild_package$CssSettings$.prototype;
$c_Lreactbuild_package$CssSettings$.prototype.scalacss$defaults$DefaultSettings$Dev$_setter_$cssRegisterNameGen_$eq__Lscalacss_internal_mutable_Register$NameGen__V = (function(x$1) {
  this.Lreactbuild_package$CssSettings$__f_cssRegisterNameGen = x$1
});
$c_Lreactbuild_package$CssSettings$.prototype.scalacss$defaults$DefaultSettings$Dev$_setter_$cssRegisterErrorHandler_$eq__Lscalacss_internal_mutable_Register$ErrorHandler__V = (function(x$1) {
  this.Lreactbuild_package$CssSettings$__f_cssRegisterErrorHandler = x$1
});
$c_Lreactbuild_package$CssSettings$.prototype.scalacss$defaults$Exports$_setter_$PseudoType_$eq__Lscalacss_internal_PseudoType$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lreactbuild_package$CssSettings$.prototype.scalacss$defaults$Exports$_setter_$Pseudo_$eq__Lscalacss_internal_Pseudo$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lreactbuild_package$CssSettings$.prototype.scalacss$defaults$Exports$_setter_$Domain_$eq__Lscalacss_internal_Domain$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lreactbuild_package$CssSettings$.prototype.scalacss$defaults$Exports$_setter_$StyleA_$eq__Lscalacss_internal_StyleA$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lreactbuild_package$CssSettings$.prototype.scalacss$defaults$Exports$_setter_$CssComposer_$eq__Lscalacss_internal_Compose$__V = (function(x$1) {
  /*<skip>*/
});
$c_Lreactbuild_package$CssSettings$.prototype.scalacss$defaults$Exports$_setter_$CssEnv_$eq__Lscalacss_internal_Env$__V = (function(x$1) {
  /*<skip>*/
});
var $d_Lreactbuild_package$CssSettings$ = new $TypeData().initClass({
  Lreactbuild_package$CssSettings$: 0
}, false, "reactbuild.package$CssSettings$", {
  Lreactbuild_package$CssSettings$: 1,
  O: 1,
  Lscalacss_defaults_Exports: 1,
  Lscalacss_defaults_PlatformExports: 1,
  Lreactbuild_package$MyDev: 1,
  Lscalacss_defaults_DefaultSettings$Dev: 1,
  Lscalacss_internal_mutable_Settings: 1
});
$c_Lreactbuild_package$CssSettings$.prototype.$classData = $d_Lreactbuild_package$CssSettings$;
var $n_Lreactbuild_package$CssSettings$;
function $m_Lreactbuild_package$CssSettings$() {
  if ((!$n_Lreactbuild_package$CssSettings$)) {
    $n_Lreactbuild_package$CssSettings$ = new $c_Lreactbuild_package$CssSettings$()
  };
  return $n_Lreactbuild_package$CssSettings$
}
/** @constructor */
function $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8(outer) {
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8__f_circeGenericEncoderForurl = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8__f_circeGenericEncoderForcredentials = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8__f_circeGenericEncoderForurl = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_person_Credential$().Lreactbuild_person_Credential$__f_codecForCredential;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8__f_circeGenericEncoderForcredentials = new $c_Lio_circe_Encoder$$anon$23(encodeA)
}
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8.prototype = new $h_O();
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8.prototype.constructor = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8;
/** @constructor */
function $h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8.prototype = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8.prototype;
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForurl = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForcredentials = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x3 = $m_Lio_circe_JsonObject$();
        var this$5 = $m_sci_Vector$();
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("url"), $n(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8__f_circeGenericEncoderForurl).apply__O__Lio_circe_Json(circeGenericHListBindingForurl));
        var $$x1 = $n(transformMemberNames).apply__O__O("credentials");
        var this$1 = $n(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8__f_circeGenericEncoderForcredentials);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForcredentials))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8 = new $TypeData().initClass({
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8: 0
}, false, "reactbuild.person.AddressDetails$anon$lazy$macro$91$1$$anon$8", {
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8.prototype.$classData = $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$8;
/** @constructor */
function $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9(outer) {
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9__f_circeGenericEncoderForcity = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9__f_circeGenericEncoderForcity = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9.prototype = new $h_O();
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9.prototype.constructor = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9;
/** @constructor */
function $h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9.prototype = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9.prototype;
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForstreet = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForpostalCode = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForcity = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("street"), $n(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9__f_circeGenericEncoderForcity).apply__O__Lio_circe_Json(circeGenericHListBindingForstreet)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("postalCode"), $n(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9__f_circeGenericEncoderForcity).apply__O__Lio_circe_Json(circeGenericHListBindingForpostalCode)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("city"), $n(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9__f_circeGenericEncoderForcity).apply__O__Lio_circe_Json(circeGenericHListBindingForcity))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9 = new $TypeData().initClass({
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9: 0
}, false, "reactbuild.person.AddressDetails$anon$lazy$macro$91$1$$anon$9", {
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9.prototype.$classData = $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$9;
/** @constructor */
function $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5(outer) {
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5__f_circeGenericEncoderForbounds = null;
  this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5__f_circeGenericEncoderForbounds = $n(outer).Lreactbuild_person_BoundedField$anon$lazy$macro$11$2__f_encB$1
}
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5.prototype = new $h_O();
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5.prototype.constructor = $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5;
/** @constructor */
function $h_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5.prototype = $c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5.prototype;
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForbounds = $as_Lreactbuild_person_Bounds($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("bounds"), $n(this.Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5__f_circeGenericEncoderForbounds).apply__O__Lio_circe_Json(circeGenericHListBindingForbounds))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5 = new $TypeData().initClass({
  Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5: 0
}, false, "reactbuild.person.BoundedField$anon$lazy$macro$11$2$$anon$5", {
  Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5.prototype.$classData = $d_Lreactbuild_person_BoundedField$anon$lazy$macro$11$2$$anon$5;
/** @constructor */
function $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3(outer) {
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3__f_circeGenericEncoderForpassword = null;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_model_PasswordCrossImpl$().encodePassword__Lio_circe_Encoder();
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3__f_circeGenericEncoderForpassword = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3.prototype = new $h_O();
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3.prototype.constructor = $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3;
/** @constructor */
function $h_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3.prototype = $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3.prototype;
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForpassword = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("password"), $n(this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3__f_circeGenericEncoderForpassword).apply__O__Lio_circe_Json(circeGenericHListBindingForpassword))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3 = new $TypeData().initClass({
  Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3: 0
}, false, "reactbuild.person.CredentialData$anon$lazy$macro$23$1$$anon$3", {
  Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3.prototype.$classData = $d_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$3;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15(outer) {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderFordocumentFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderFortable = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderFordeliveryHeader = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderForrowFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderFordocumentFieldLevel = $m_Lreactbuild_person_DocumentFieldLevel$().Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderFortable = $m_Lreactbuild_person_VerticalInterval$().Lreactbuild_person_VerticalInterval$__f_codecForVerticalInterval;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderFordeliveryHeader = $m_Lreactbuild_person_DeliveryHeaderFormat$().Lreactbuild_person_DeliveryHeaderFormat$__f_codecForDeliveryHeaderFormat;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderForrowFieldLevel = $m_Lreactbuild_person_RowFieldLevel$().Lreactbuild_person_RowFieldLevel$__f_codecForRowFieldLevel
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFordocumentFieldLevel = $as_Lreactbuild_person_DocumentFieldLevel($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortable = $as_Lreactbuild_person_VerticalInterval($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFordeliveryHeader = $as_Lreactbuild_person_DeliveryHeaderFormat($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForrowFieldLevel = $as_Lreactbuild_person_RowFieldLevel($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x8 = $m_Lio_circe_JsonObject$();
            var this$8 = $m_sci_Vector$();
            var $$x7 = $n(transformMemberNames).apply__O__O("documentFieldLevel");
            var this$1 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderFordocumentFieldLevel);
            var $$x6 = $ct_T2__O__O__(new $c_T2(), $$x7, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordocumentFieldLevel));
            var $$x5 = $n(transformMemberNames).apply__O__O("table");
            var this$2 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderFortable);
            var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFortable));
            var $$x3 = $n(transformMemberNames).apply__O__O("deliveryHeader");
            var this$3 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderFordeliveryHeader);
            var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingFordeliveryHeader));
            var $$x1 = $n(transformMemberNames).apply__O__O("rowFieldLevel");
            var this$4 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15__f_circeGenericEncoderForrowFieldLevel);
            var array = [$$x6, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$4, circeGenericHListBindingForrowFieldLevel))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x8).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$8.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1$$anon$15", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$15;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16(outer) {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16__f_circeGenericEncoderFordocumentFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16__f_circeGenericEncoderFortable = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16__f_circeGenericEncoderForrowFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16__f_circeGenericEncoderFordocumentFieldLevel = $m_Lreactbuild_person_DocumentFieldLevel$().Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16__f_circeGenericEncoderFortable = $m_Lreactbuild_person_VerticalInterval$().Lreactbuild_person_VerticalInterval$__f_codecForVerticalInterval;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16__f_circeGenericEncoderForrowFieldLevel = $m_Lreactbuild_person_RowFieldLevel$().Lreactbuild_person_RowFieldLevel$__f_codecForRowFieldLevel
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFordocumentFieldLevel = $as_Lreactbuild_person_DocumentFieldLevel($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortable = $as_Lreactbuild_person_VerticalInterval($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForrowFieldLevel = $as_Lreactbuild_person_RowFieldLevel($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x6 = $m_Lio_circe_JsonObject$();
          var this$7 = $m_sci_Vector$();
          var $$x5 = $n(transformMemberNames).apply__O__O("documentFieldLevel");
          var this$1 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16__f_circeGenericEncoderFordocumentFieldLevel);
          var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordocumentFieldLevel));
          var $$x3 = $n(transformMemberNames).apply__O__O("table");
          var this$2 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16__f_circeGenericEncoderFortable);
          var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFortable));
          var $$x1 = $n(transformMemberNames).apply__O__O("rowFieldLevel");
          var this$3 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16__f_circeGenericEncoderForrowFieldLevel);
          var array = [$$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForrowFieldLevel))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x6).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$7.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1$$anon$16", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$16;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17(outer) {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17__f_circeGenericEncoderFordocumentFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17__f_circeGenericEncoderForproject = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17__f_circeGenericEncoderFordocumentFieldLevel = $m_Lreactbuild_person_DocumentFieldLevel$().Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17__f_circeGenericEncoderForproject = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle)
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFordocumentFieldLevel = $as_Lreactbuild_person_DocumentFieldLevel($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForproject = $as_Lreactbuild_person_BoundedField($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x4 = $m_Lio_circe_JsonObject$();
        var this$6 = $m_sci_Vector$();
        var $$x3 = $n(transformMemberNames).apply__O__O("documentFieldLevel");
        var this$1 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17__f_circeGenericEncoderFordocumentFieldLevel);
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordocumentFieldLevel));
        var $$x1 = $n(transformMemberNames).apply__O__O("project");
        var this$2 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17__f_circeGenericEncoderForproject);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForproject))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x4).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1$$anon$17", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$17;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18(outer) {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18__f_circeGenericEncoderFordocumentFieldLevel = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18__f_circeGenericEncoderFordocumentFieldLevel = $m_Lreactbuild_person_DocumentFieldLevel$().Lreactbuild_person_DocumentFieldLevel$__f_codecForDocumentFieldLevel
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18.prototype = new $h_O();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFordocumentFieldLevel = $as_Lreactbuild_person_DocumentFieldLevel($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("documentFieldLevel");
      var this$1 = $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18__f_circeGenericEncoderFordocumentFieldLevel);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordocumentFieldLevel))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1$$anon$18", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$18;
/** @constructor */
function $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12(outer) {
  /*<skip>*/
}
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12.prototype = new $h_O();
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12.prototype.constructor = $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12;
/** @constructor */
function $h_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12.prototype = $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12.prototype;
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12 = new $TypeData().initClass({
  Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12: 0
}, false, "reactbuild.person.PaymentMethod$anon$lazy$macro$11$1$$anon$12", {
  Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12.prototype.$classData = $d_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$12;
/** @constructor */
function $c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4(outer) {
  /*<skip>*/
}
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4.prototype = new $h_O();
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4.prototype.constructor = $c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4;
/** @constructor */
function $h_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4.prototype = $c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4.prototype;
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4 = new $TypeData().initClass({
  Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4: 0
}, false, "reactbuild.person.Size$anon$lazy$macro$7$1$$anon$4", {
  Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4.prototype.$classData = $d_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$4;
/** @constructor */
function $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14(outer) {
  /*<skip>*/
}
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14.prototype = new $h_O();
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14.prototype.constructor = $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14;
/** @constructor */
function $h_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14.prototype = $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14.prototype;
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14 = new $TypeData().initClass({
  Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14: 0
}, false, "reactbuild.person.SupplierGroup$anon$lazy$macro$7$1$$anon$14", {
  Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14.prototype.$classData = $d_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$14;
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$Generic(element) {
  this.Lreactbuild_person_SupplyRowTarget$Generic__f_element = null;
  this.Lreactbuild_person_SupplyRowTarget$Generic__f_element = element
}
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$Generic;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$Generic() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$Generic.prototype = $c_Lreactbuild_person_SupplyRowTarget$Generic.prototype;
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.renderTitle__Lreactbuild_person_RowListing__T = (function(l) {
  var this$1 = $n($n(l).Lreactbuild_person_RowListing__f_generics);
  _return: {
    var these = this$1;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x$1 = $as_Lreactbuild_person_ProductGeneric(arg1);
      var x = $n(x$1).Lreactbuild_person_ProductGeneric__f__id;
      var x$2 = this.Lreactbuild_person_SupplyRowTarget$Generic__f_element;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var $$x1 = new $c_s_Some($n(these).head__O());
        break _return
      };
      these = $as_sci_List($n(these).tail__O())
    };
    var $$x1 = $m_s_None$()
  };
  return $n($as_Lreactbuild_person_ProductGeneric($$x1.get__O())).Lreactbuild_person_ProductGeneric__f_title
});
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.productPrefix__T = (function() {
  return "Generic"
});
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_person_SupplyRowTarget$Generic__f_element : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_person_SupplyRowTarget$Generic)) {
    var Generic$1 = $as_Lreactbuild_person_SupplyRowTarget$Generic(x$1);
    var x = this.Lreactbuild_person_SupplyRowTarget$Generic__f_element;
    var x$2 = $n(Generic$1).Lreactbuild_person_SupplyRowTarget$Generic__f_element;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_person_SupplyRowTarget$Generic(obj) {
  return (((obj instanceof $c_Lreactbuild_person_SupplyRowTarget$Generic) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.person.SupplyRowTarget$Generic"))
}
function $isArrayOf_Lreactbuild_person_SupplyRowTarget$Generic(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_person_SupplyRowTarget$Generic)))
}
function $asArrayOf_Lreactbuild_person_SupplyRowTarget$Generic(obj, depth) {
  return (($isArrayOf_Lreactbuild_person_SupplyRowTarget$Generic(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.person.SupplyRowTarget$Generic;", depth))
}
var $d_Lreactbuild_person_SupplyRowTarget$Generic = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$Generic: 0
}, false, "reactbuild.person.SupplyRowTarget$Generic", {
  Lreactbuild_person_SupplyRowTarget$Generic: 1,
  O: 1,
  Lreactbuild_person_SupplyRowTargetWithAbstract: 1,
  Lreactbuild_person_SupplyRowTarget: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$Generic.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$Generic;
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10(outer) {
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10__f_circeGenericEncoderForelement = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10__f_circeGenericEncoderForconcrete = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10__f_circeGenericEncoderForelement = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10__f_circeGenericEncoderForconcrete = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10.prototype = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10.prototype;
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForelement = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForconcrete = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("element"), $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10__f_circeGenericEncoderForelement).apply__O__Lio_circe_Json(circeGenericHListBindingForelement)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("concrete"), $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10__f_circeGenericEncoderForconcrete).apply__O__Lio_circe_Json(circeGenericHListBindingForconcrete))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10: 0
}, false, "reactbuild.person.SupplyRowTarget$anon$lazy$macro$95$1$$anon$10", {
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$10;
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11(outer) {
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11__f_circeGenericEncoderForelement = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11__f_circeGenericEncoderForelement = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11.prototype = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11.prototype;
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForelement = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("element"), $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11__f_circeGenericEncoderForelement).apply__O__Lio_circe_Json(circeGenericHListBindingForelement))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11: 0
}, false, "reactbuild.person.SupplyRowTarget$anon$lazy$macro$95$1$$anon$11", {
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$11;
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9(outer) {
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9__f_circeGenericEncoderForstage = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9__f_circeGenericEncoderFortitle = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9__f_circeGenericEncoderForstage = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9__f_circeGenericEncoderFortitle = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9.prototype = new $h_O();
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9.prototype = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9.prototype;
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForstage = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortitle = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("stage"), $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9__f_circeGenericEncoderForstage).apply__O__Lio_circe_Json(circeGenericHListBindingForstage)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9: 0
}, false, "reactbuild.person.SupplyRowTarget$anon$lazy$macro$95$1$$anon$9", {
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$9;
/** @constructor */
function $c_Lreactbuild_plugins_devices_MEAZOR$() {
  this.Lreactbuild_plugins_devices_MEAZOR$__f_services = null;
  this.Lreactbuild_plugins_devices_MEAZOR$__f_characteristics = null;
  this.Lreactbuild_plugins_devices_MEAZOR$__f_filters = null;
  $n_Lreactbuild_plugins_devices_MEAZOR$ = this;
  $n($m_s_package$().s_package$__f_List);
  var array = ["0000fff0-0000-1000-8000-00805f9b34fb"];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_plugins_devices_MEAZOR$__f_services = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $n($m_s_package$().s_package$__f_List);
  var array$1 = ["0000fff2-0000-1000-8000-00805f9b34fb"];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  this.Lreactbuild_plugins_devices_MEAZOR$__f_characteristics = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  $n($m_s_package$().s_package$__f_List);
  var array$2 = [(() => {
    var this$9 = {};
    this$9.namePrefix = "MEAZOR";
    return this$9
  })()];
  var elems$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  this.Lreactbuild_plugins_devices_MEAZOR$__f_filters = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2)
}
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype.constructor = $c_Lreactbuild_plugins_devices_MEAZOR$;
/** @constructor */
function $h_Lreactbuild_plugins_devices_MEAZOR$() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_MEAZOR$.prototype = $c_Lreactbuild_plugins_devices_MEAZOR$.prototype;
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype.handleEvent__Lreactbuild_plugins_devices_BluetoothEvent__Lreactbuild_plugins_devices_MeasureDetails = (function(event) {
  var value = new $c_Lreactbuild_plugins_devices_BluetoothEvent$RichBluetoothEvent(event).typedTarget__O().value;
  var x1 = ((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value));
  var x = $m_s_None$();
  if ((x === x1)) {
    return $m_Lreactbuild_plugins_devices_NoMeasure$()
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var value$1 = $n(x3).s_Some__f_value;
    var length = $uI(value$1.byteLength);
    var isEmpty = (length <= 0);
    if (isEmpty) {
      var scala$collection$immutable$Range$$numRangeElements = 0
    } else {
      var hi = (length >> 31);
      var scala$collection$immutable$Range$$numRangeElements = (((hi === 0) ? (((-2147483648) ^ length) > (-1)) : (hi > 0)) ? (-1) : length)
    };
    var scala$collection$immutable$Range$$lastElement = (((-1) + length) | 0);
    if ((scala$collection$immutable$Range$$numRangeElements < 0)) {
      $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, length, 1, false)
    };
    var b = $m_sci_IndexedSeq$().newBuilder__scm_Builder();
    var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
    while (it.sci_RangeIterator__f__hasNext) {
      var this$12 = $n(b);
      var arg1 = it.next__I();
      var elem = $uS(value$1.getUint8(arg1));
      this$12.addOne__O__scm_Growable(elem)
    };
    var data = $n($as_sc_Seq($n($as_sci_IndexedSeq($n(b).result__O())).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1 = $uS(x$1$2);
      return $bC((65535 & x$1))
    }))))).toString__T();
    return new $c_Lreactbuild_plugins_devices_MeasureDetailsError(("Not handled " + data))
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype.productPrefix__T = (function() {
  return "MEAZOR"
});
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype.hashCode__I = (function() {
  return (-2024774284)
});
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype.toString__T = (function() {
  return "MEAZOR"
});
var $d_Lreactbuild_plugins_devices_MEAZOR$ = new $TypeData().initClass({
  Lreactbuild_plugins_devices_MEAZOR$: 0
}, false, "reactbuild.plugins.devices.MEAZOR$", {
  Lreactbuild_plugins_devices_MEAZOR$: 1,
  O: 1,
  Lreactbuild_plugins_devices_BLEDeviceMeasure: 1,
  Lreactbuild_plugins_devices_DeviceMeasure: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_plugins_devices_MEAZOR$.prototype.$classData = $d_Lreactbuild_plugins_devices_MEAZOR$;
var $n_Lreactbuild_plugins_devices_MEAZOR$;
function $m_Lreactbuild_plugins_devices_MEAZOR$() {
  if ((!$n_Lreactbuild_plugins_devices_MEAZOR$)) {
    $n_Lreactbuild_plugins_devices_MEAZOR$ = new $c_Lreactbuild_plugins_devices_MEAZOR$()
  };
  return $n_Lreactbuild_plugins_devices_MEAZOR$
}
/** @constructor */
function $c_Lreactbuild_plugins_devices_MeasureAction$Toggle$() {
  /*<skip>*/
}
$c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype = new $h_O();
$c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype.constructor = $c_Lreactbuild_plugins_devices_MeasureAction$Toggle$;
/** @constructor */
function $h_Lreactbuild_plugins_devices_MeasureAction$Toggle$() {
  /*<skip>*/
}
$h_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype = $c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype;
$c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype.productPrefix__T = (function() {
  return "Toggle"
});
$c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype.hashCode__I = (function() {
  return (-1784436876)
});
$c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype.toString__T = (function() {
  return "Toggle"
});
var $d_Lreactbuild_plugins_devices_MeasureAction$Toggle$ = new $TypeData().initClass({
  Lreactbuild_plugins_devices_MeasureAction$Toggle$: 0
}, false, "reactbuild.plugins.devices.MeasureAction$Toggle$", {
  Lreactbuild_plugins_devices_MeasureAction$Toggle$: 1,
  O: 1,
  Lreactbuild_plugins_devices_MeasureAction: 1,
  Lreactbuild_plugins_devices_DeviceAction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_plugins_devices_MeasureAction$Toggle$.prototype.$classData = $d_Lreactbuild_plugins_devices_MeasureAction$Toggle$;
var $n_Lreactbuild_plugins_devices_MeasureAction$Toggle$;
function $m_Lreactbuild_plugins_devices_MeasureAction$Toggle$() {
  if ((!$n_Lreactbuild_plugins_devices_MeasureAction$Toggle$)) {
    $n_Lreactbuild_plugins_devices_MeasureAction$Toggle$ = new $c_Lreactbuild_plugins_devices_MeasureAction$Toggle$()
  };
  return $n_Lreactbuild_plugins_devices_MeasureAction$Toggle$
}
/** @constructor */
function $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10(outer) {
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderForproject = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderForperson = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderForbuildingStage = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderFortotal = null;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderForproject = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderFordate = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderForperson = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderForbuildingStage = new $c_Lio_circe_Encoder$$anon$21(e$1);
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderFortotal = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_encodeDuration
}
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10.prototype.constructor = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10.prototype = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10.prototype;
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForproject = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFordate = $as_Ljava_time_LocalDate($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForperson = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForbuildingStage = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFortotal = $as_Lreactbuild_model_Duration($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x1 = $m_Lio_circe_JsonObject$();
              var this$4 = $m_sci_Vector$();
              var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("project"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderForproject).apply__O__Lio_circe_Json(circeGenericHListBindingForproject)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("person"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderForperson).apply__O__Lio_circe_Json(circeGenericHListBindingForperson)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("buildingStage"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderForbuildingStage).apply__O__Lio_circe_Json(circeGenericHListBindingForbuildingStage)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("total"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10__f_circeGenericEncoderFortotal).apply__O__Lio_circe_Json(circeGenericHListBindingFortotal))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10: 0
}, false, "reactbuild.project.ResourceUsage$anon$lazy$macro$267$1$$anon$10", {
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10.prototype.$classData = $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$10;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9(outer) {
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForproject = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForsupplier = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFordescription = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForbuildingStage = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForunit = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForquantity = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFortotal = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForparent = null;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForproject = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFordate = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForsupplier = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFordescription = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForbuildingStage = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForunit = new $c_Lio_circe_Encoder$$anon$21(e$2);
  $m_Lio_circe_Encoder$();
  var e$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForquantity = new $c_Lio_circe_Encoder$$anon$21(e$3);
  $m_Lio_circe_Encoder$();
  var e$4 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFortotal = new $c_Lio_circe_Encoder$$anon$21(e$4);
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForparent = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage
}
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9.prototype.constructor = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9.prototype = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9.prototype;
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForproject = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFordate = $as_Ljava_time_LocalDate($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForsupplier = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForreference = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFordescription = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForbuildingStage = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForunitPrice = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForunit = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                  if ((p9 !== null)) {
                    var circeGenericHListBindingForquantity = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                    var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                    if ((p10 !== null)) {
                      var circeGenericHListBindingFortotal = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                      var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                      if ((p11 !== null)) {
                        var circeGenericHListBindingForparent = $as_Lreactbuild_model_InvoicePage($n(p11).Lshapeless_$colon$colon__f_head);
                        var p12 = $as_Lshapeless_HNil($n(p11).Lshapeless_$colon$colon__f_tail);
                        var x = $m_Lshapeless_HNil$();
                        if ((x === p12)) {
                          var $$x12 = $m_Lio_circe_JsonObject$();
                          var this$5 = $m_sci_Vector$();
                          var $$x11 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("project"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForproject).apply__O__Lio_circe_Json(circeGenericHListBindingForproject));
                          var $$x10 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate));
                          var $$x9 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("supplier"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForsupplier).apply__O__Lio_circe_Json(circeGenericHListBindingForsupplier));
                          var $$x8 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForunit).apply__O__Lio_circe_Json(circeGenericHListBindingForreference));
                          var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("description"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFordescription).apply__O__Lio_circe_Json(circeGenericHListBindingFordescription));
                          var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("buildingStage"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForbuildingStage).apply__O__Lio_circe_Json(circeGenericHListBindingForbuildingStage));
                          var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("unitPrice"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFortotal).apply__O__Lio_circe_Json(circeGenericHListBindingForunitPrice));
                          var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("unit"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForunit).apply__O__Lio_circe_Json(circeGenericHListBindingForunit));
                          var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("quantity"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForquantity).apply__O__Lio_circe_Json(circeGenericHListBindingForquantity));
                          var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("total"), $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderFortotal).apply__O__Lio_circe_Json(circeGenericHListBindingFortotal));
                          var $$x1 = $n(transformMemberNames).apply__O__O("parent");
                          var this$1 = $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9__f_circeGenericEncoderForparent);
                          var array = [$$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForparent))];
                          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                          return $n($$x12).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9: 0
}, false, "reactbuild.project.ResourceUsage$anon$lazy$macro$267$1$$anon$9", {
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9.prototype.$classData = $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$9;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19(outer) {
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19__f_circeGenericEncoderForselection = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19__f_circeGenericEncoderForselection = $m_Lreactbuild_project_Selection$().encodeSelection__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder())
}
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19.prototype.constructor = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19.prototype = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19.prototype;
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForselection = $as_Lreactbuild_project_Selection($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("selection");
      var this$1 = $n(this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19__f_circeGenericEncoderForselection);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForselection))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19: 0
}, false, "reactbuild.project.ResourceUsageClause$anon$lazy$macro$43$1$$anon$19", {
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19.prototype.$classData = $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$19;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20(outer) {
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20__f_circeGenericEncoderForselection = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20__f_circeGenericEncoderForselection = $m_Lreactbuild_project_Selection$().encodeSelection__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder())
}
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20.prototype = new $h_O();
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20.prototype.constructor = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20.prototype = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20.prototype;
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForselection = $as_Lreactbuild_project_Selection($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("selection");
      var this$1 = $n(this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20__f_circeGenericEncoderForselection);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForselection))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20: 0
}, false, "reactbuild.project.ResourceUsageClause$anon$lazy$macro$43$1$$anon$20", {
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20.prototype.$classData = $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$20;
/** @constructor */
function $c_Lreactbuild_project_RichContent$Image(href, cls) {
  this.Lreactbuild_project_RichContent$Image__f_href = null;
  this.Lreactbuild_project_RichContent$Image__f_cls = null;
  this.Lreactbuild_project_RichContent$Image__f_href = href;
  this.Lreactbuild_project_RichContent$Image__f_cls = cls
}
$c_Lreactbuild_project_RichContent$Image.prototype = new $h_O();
$c_Lreactbuild_project_RichContent$Image.prototype.constructor = $c_Lreactbuild_project_RichContent$Image;
/** @constructor */
function $h_Lreactbuild_project_RichContent$Image() {
  /*<skip>*/
}
$h_Lreactbuild_project_RichContent$Image.prototype = $c_Lreactbuild_project_RichContent$Image.prototype;
$c_Lreactbuild_project_RichContent$Image.prototype.apply__Ljapgolly_scalajs_react_vdom_TagOf = (function() {
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  var this$1 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  var $$x1 = $f_Ljapgolly_scalajs_react_vdom_HtmlTags__img__T(this$1);
  var array = [$n($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up).Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$__f_src).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(this.Lreactbuild_project_RichContent$Image__f_href, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString), ($n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up), $m_Ljapgolly_scalajs_react_vdom_Attr$ClassName$()).$colon$eq__O__F2__Ljapgolly_scalajs_react_vdom_TagMod(this.Lreactbuild_project_RichContent$Image__f_cls, $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString)];
  return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_project_RichContent$Image.prototype.productPrefix__T = (function() {
  return "Image"
});
$c_Lreactbuild_project_RichContent$Image.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_RichContent$Image.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_RichContent$Image__f_href;
      break
    }
    case 1: {
      return this.Lreactbuild_project_RichContent$Image__f_cls;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_RichContent$Image.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_RichContent$Image.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_RichContent$Image.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_RichContent$Image.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_RichContent$Image)) {
    var Image$1 = $as_Lreactbuild_project_RichContent$Image(x$1);
    return ((this.Lreactbuild_project_RichContent$Image__f_href === $n(Image$1).Lreactbuild_project_RichContent$Image__f_href) && ((this.Lreactbuild_project_RichContent$Image__f_cls === $n(Image$1).Lreactbuild_project_RichContent$Image__f_cls) && ($n(Image$1), true)))
  } else {
    return false
  }
});
$c_Lreactbuild_project_RichContent$Image.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomNode = (function() {
  return this.apply__Ljapgolly_scalajs_react_vdom_TagOf()
});
function $as_Lreactbuild_project_RichContent$Image(obj) {
  return (((obj instanceof $c_Lreactbuild_project_RichContent$Image) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.RichContent$Image"))
}
function $isArrayOf_Lreactbuild_project_RichContent$Image(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_RichContent$Image)))
}
function $asArrayOf_Lreactbuild_project_RichContent$Image(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_RichContent$Image(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.RichContent$Image;", depth))
}
var $d_Lreactbuild_project_RichContent$Image = new $TypeData().initClass({
  Lreactbuild_project_RichContent$Image: 0
}, false, "reactbuild.project.RichContent$Image", {
  Lreactbuild_project_RichContent$Image: 1,
  O: 1,
  Lreactbuild_project_RichContent$Part: 1,
  Lreactbuild_project_RichContent$Element: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_RichContent$Image.prototype.$classData = $d_Lreactbuild_project_RichContent$Image;
/** @constructor */
function $c_Lreactbuild_project_RichContent$Paragraph(lines) {
  this.Lreactbuild_project_RichContent$Paragraph__f_lines = null;
  this.Lreactbuild_project_RichContent$Paragraph__f_lines = lines
}
$c_Lreactbuild_project_RichContent$Paragraph.prototype = new $h_O();
$c_Lreactbuild_project_RichContent$Paragraph.prototype.constructor = $c_Lreactbuild_project_RichContent$Paragraph;
/** @constructor */
function $h_Lreactbuild_project_RichContent$Paragraph() {
  /*<skip>*/
}
$h_Lreactbuild_project_RichContent$Paragraph.prototype = $c_Lreactbuild_project_RichContent$Paragraph.prototype;
$c_Lreactbuild_project_RichContent$Paragraph.prototype.apply__Ljapgolly_scalajs_react_vdom_TagOf = (function() {
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$5 = $n(this.Lreactbuild_project_RichContent$Paragraph__f_lines);
  var f = ((line$2) => {
    var line = $as_Lreactbuild_project_RichContent$Line(line$2);
    var this$4 = $n(line);
    return $n(this$4.Lreactbuild_project_RichContent$Line__f_part).apply__Ljapgolly_scalajs_react_vdom_VdomNode()
  });
  if ((this$5 === $m_sci_Nil$())) {
    var as = $m_sci_Nil$()
  } else {
    var arg1 = this$5.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$5.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var as = h
  };
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  var this$7 = $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  var sep = $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($f_Ljapgolly_scalajs_react_vdom_HtmlTags__br__T(this$7), $m_sci_Nil$());
  var this$9 = $m_s_$less$colon$less$();
  var f$1 = this$9.s_$less$colon$less$__f_singleton;
  var array = [$m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$().mkTagMod$extension__sc_IterableOnce__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_vdom_TagMod__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, sep, $m_Ljapgolly_scalajs_react_vdom_VdomNode$().Ljapgolly_scalajs_react_vdom_VdomNode$__f_empty, f$1)];
  return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("p", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_project_RichContent$Paragraph.prototype.push__Lreactbuild_project_RichContent$Line__Lreactbuild_project_RichContent$Paragraph = (function(line) {
  var this$1 = $n(this.Lreactbuild_project_RichContent$Paragraph__f_lines);
  var lines = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$1, line));
  return new $c_Lreactbuild_project_RichContent$Paragraph(lines)
});
$c_Lreactbuild_project_RichContent$Paragraph.prototype.productPrefix__T = (function() {
  return "Paragraph"
});
$c_Lreactbuild_project_RichContent$Paragraph.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_RichContent$Paragraph.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_RichContent$Paragraph__f_lines : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_RichContent$Paragraph.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_RichContent$Paragraph.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_RichContent$Paragraph.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_RichContent$Paragraph.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_RichContent$Paragraph)) {
    var Paragraph$1 = $as_Lreactbuild_project_RichContent$Paragraph(x$1);
    var x = this.Lreactbuild_project_RichContent$Paragraph__f_lines;
    var x$2 = $n(Paragraph$1).Lreactbuild_project_RichContent$Paragraph__f_lines;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(Paragraph$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_RichContent$Paragraph(obj) {
  return (((obj instanceof $c_Lreactbuild_project_RichContent$Paragraph) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.RichContent$Paragraph"))
}
function $isArrayOf_Lreactbuild_project_RichContent$Paragraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_RichContent$Paragraph)))
}
function $asArrayOf_Lreactbuild_project_RichContent$Paragraph(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_RichContent$Paragraph(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.RichContent$Paragraph;", depth))
}
var $d_Lreactbuild_project_RichContent$Paragraph = new $TypeData().initClass({
  Lreactbuild_project_RichContent$Paragraph: 0
}, false, "reactbuild.project.RichContent$Paragraph", {
  Lreactbuild_project_RichContent$Paragraph: 1,
  O: 1,
  Lreactbuild_project_RichContent$Block: 1,
  Lreactbuild_project_RichContent$Element: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_RichContent$Paragraph.prototype.$classData = $d_Lreactbuild_project_RichContent$Paragraph;
/** @constructor */
function $c_Lreactbuild_project_RichContent$Text(text) {
  this.Lreactbuild_project_RichContent$Text__f_text = null;
  this.Lreactbuild_project_RichContent$Text__f_text = text
}
$c_Lreactbuild_project_RichContent$Text.prototype = new $h_O();
$c_Lreactbuild_project_RichContent$Text.prototype.constructor = $c_Lreactbuild_project_RichContent$Text;
/** @constructor */
function $h_Lreactbuild_project_RichContent$Text() {
  /*<skip>*/
}
$h_Lreactbuild_project_RichContent$Text.prototype = $c_Lreactbuild_project_RichContent$Text.prototype;
$c_Lreactbuild_project_RichContent$Text.prototype.apply__Ljapgolly_scalajs_react_vdom_VdomNode = (function() {
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v = this.Lreactbuild_project_RichContent$Text__f_text;
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)
});
$c_Lreactbuild_project_RichContent$Text.prototype.productPrefix__T = (function() {
  return "Text"
});
$c_Lreactbuild_project_RichContent$Text.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_RichContent$Text.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_RichContent$Text__f_text : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_RichContent$Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_RichContent$Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_RichContent$Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_RichContent$Text.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_RichContent$Text)) {
    var Text$1 = $as_Lreactbuild_project_RichContent$Text(x$1);
    return ((this.Lreactbuild_project_RichContent$Text__f_text === $n(Text$1).Lreactbuild_project_RichContent$Text__f_text) && ($n(Text$1), true))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_RichContent$Text(obj) {
  return (((obj instanceof $c_Lreactbuild_project_RichContent$Text) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.RichContent$Text"))
}
function $isArrayOf_Lreactbuild_project_RichContent$Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_RichContent$Text)))
}
function $asArrayOf_Lreactbuild_project_RichContent$Text(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_RichContent$Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.RichContent$Text;", depth))
}
var $d_Lreactbuild_project_RichContent$Text = new $TypeData().initClass({
  Lreactbuild_project_RichContent$Text: 0
}, false, "reactbuild.project.RichContent$Text", {
  Lreactbuild_project_RichContent$Text: 1,
  O: 1,
  Lreactbuild_project_RichContent$Part: 1,
  Lreactbuild_project_RichContent$Element: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_RichContent$Text.prototype.$classData = $d_Lreactbuild_project_RichContent$Text;
/** @constructor */
function $c_Lreactbuild_project_RichContent$UnorderedList(items) {
  this.Lreactbuild_project_RichContent$UnorderedList__f_items = null;
  this.Lreactbuild_project_RichContent$UnorderedList__f_items = items
}
$c_Lreactbuild_project_RichContent$UnorderedList.prototype = new $h_O();
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.constructor = $c_Lreactbuild_project_RichContent$UnorderedList;
/** @constructor */
function $h_Lreactbuild_project_RichContent$UnorderedList() {
  /*<skip>*/
}
$h_Lreactbuild_project_RichContent$UnorderedList.prototype = $c_Lreactbuild_project_RichContent$UnorderedList.prototype;
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.push__Lreactbuild_project_RichContent$Line__Lreactbuild_project_RichContent$UnorderedList = (function(item) {
  var this$1 = $n(this.Lreactbuild_project_RichContent$UnorderedList__f_items);
  var items = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$1, item));
  return new $c_Lreactbuild_project_RichContent$UnorderedList(items)
});
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.apply__Ljapgolly_scalajs_react_vdom_TagOf = (function() {
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = this.Lreactbuild_project_RichContent$UnorderedList__f_items;
  var array$1 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((line$2) => {
    var line = $as_Lreactbuild_project_RichContent$Line(line$2);
    var $$x2 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
    $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
    $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
    var this$7 = $n(line);
    var array = [$n(this$7.Lreactbuild_project_RichContent$Line__f_part).apply__Ljapgolly_scalajs_react_vdom_VdomNode()];
    return $n($$x2).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
  })))];
  return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.productPrefix__T = (function() {
  return "UnorderedList"
});
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_RichContent$UnorderedList__f_items : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_RichContent$UnorderedList)) {
    var UnorderedList$1 = $as_Lreactbuild_project_RichContent$UnorderedList(x$1);
    var x = this.Lreactbuild_project_RichContent$UnorderedList__f_items;
    var x$2 = $n(UnorderedList$1).Lreactbuild_project_RichContent$UnorderedList__f_items;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(UnorderedList$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_RichContent$UnorderedList(obj) {
  return (((obj instanceof $c_Lreactbuild_project_RichContent$UnorderedList) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.RichContent$UnorderedList"))
}
function $isArrayOf_Lreactbuild_project_RichContent$UnorderedList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_RichContent$UnorderedList)))
}
function $asArrayOf_Lreactbuild_project_RichContent$UnorderedList(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_RichContent$UnorderedList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.RichContent$UnorderedList;", depth))
}
var $d_Lreactbuild_project_RichContent$UnorderedList = new $TypeData().initClass({
  Lreactbuild_project_RichContent$UnorderedList: 0
}, false, "reactbuild.project.RichContent$UnorderedList", {
  Lreactbuild_project_RichContent$UnorderedList: 1,
  O: 1,
  Lreactbuild_project_RichContent$Block: 1,
  Lreactbuild_project_RichContent$Element: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_RichContent$UnorderedList.prototype.$classData = $d_Lreactbuild_project_RichContent$UnorderedList;
/** @constructor */
function $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13(outer) {
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_circeGenericEncoderForAll = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_circeGenericEncoderForList = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_circeGenericEncoderForNone = null;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_$outer).inst$macro$32__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_circeGenericEncoderForAll = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_$outer).inst$macro$22__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_circeGenericEncoderForList = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_$outer).inst$macro$20__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_circeGenericEncoderForNone = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O())
}
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13.prototype = new $h_O();
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13.prototype.constructor = $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13;
/** @constructor */
function $h_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13.prototype = $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13.prototype;
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForAll = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForAll instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForAll);
    var circeGenericInlBindingForAll = $as_Lreactbuild_project_Selection$All($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_circeGenericEncoderForAll;
    var name = $as_T($n(transformConstructorNames).apply__O__O("All"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForAll, name, discriminator)
  } else if ((circeGenericInrBindingForAll instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForAll);
    var circeGenericInrBindingForList = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForList instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForList);
      var circeGenericInlBindingForList = $as_Lreactbuild_project_Selection$List($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_circeGenericEncoderForList;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("List"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForList, name$1, discriminator)
    } else if ((circeGenericInrBindingForList instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForList);
      var circeGenericInrBindingForNone = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForNone instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForNone);
        var circeGenericInlBindingForNone = $as_Lreactbuild_project_Selection$None($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13__f_circeGenericEncoderForNone;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("None"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForNone, name$2, discriminator)
      } else if ((circeGenericInrBindingForNone instanceof $c_Lshapeless_Inr)) {
        $m_s_sys_package$().error__T__E("Cannot encode CNil")
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForNone)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForList)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForAll)
  }
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13 = new $TypeData().initClass({
  Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13: 0
}, false, "reactbuild.project.Selection$anon$lazy$macro$33$1$$anon$13", {
  Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13.prototype.$classData = $d_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$13;
/** @constructor */
function $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14(outer) {
  /*<skip>*/
}
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14.prototype = new $h_O();
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14.prototype.constructor = $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14;
/** @constructor */
function $h_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14.prototype = $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14.prototype;
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14 = new $TypeData().initClass({
  Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14: 0
}, false, "reactbuild.project.Selection$anon$lazy$macro$33$1$$anon$14", {
  Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14.prototype.$classData = $d_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$14;
/** @constructor */
function $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15(outer) {
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15__f_circeGenericEncoderForitems = null;
  $m_Lio_circe_Encoder$();
  var encodeA = $n(outer).Lreactbuild_project_Selection$anon$lazy$macro$33$1__f_encode0$1;
  this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15__f_circeGenericEncoderForitems = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15.prototype = new $h_O();
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15.prototype.constructor = $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15;
/** @constructor */
function $h_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15() {
  /*<skip>*/
}
$h_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15.prototype = $c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15.prototype;
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForitems = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("items");
      var this$1 = $n(this.Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15__f_circeGenericEncoderForitems);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForitems))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15 = new $TypeData().initClass({
  Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15: 0
}, false, "reactbuild.project.Selection$anon$lazy$macro$33$1$$anon$15", {
  Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15.prototype.$classData = $d_Lreactbuild_project_Selection$anon$lazy$macro$33$1$$anon$15;
/** @constructor */
function $c_Lreactbuild_project_drawing_DrawingContext$Backend(\u03b4) {
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_$ = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseLightArea = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseAccessibleArea = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseTool = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseSize = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseTheme = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseLayers = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseDebug = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_translate = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_zoom = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_sendToServer = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_project = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_com$iz2use$react$components$DebounceSupport$$debounceHandlers = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_$ = \u03b4;
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $f_Lcom_iz2use_react_components_DebounceSupport__$init$__V(this);
  var $$x2 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$2$2);
    return $n(x$2).Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea
  }));
  var set = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $uZ(v$2);
    return new $c_sjsr_AnonFunction1(((x$3$2) => {
      var x$3 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$3$2);
      var this$3 = $n(x$3);
      var x$2$1 = this$3.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$4 = $n(x$3);
      var x$3$2$1 = this$4.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$5 = $n(x$3);
      var x$4 = this$5.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      var this$6 = $n(x$3);
      var x$5 = this$6.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$7 = $n(x$3);
      var x$6 = this$7.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var this$8 = $n(x$3);
      var x$7 = this$8.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$9 = $n(x$3);
      var x$8 = this$9.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$10 = $n(x$3);
      var x$9 = this$10.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$11 = $n(x$3);
      var x$10 = this$11.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      var this$12 = $n(x$3);
      var x$11 = this$12.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      $n(x$3);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$2$1, x$3$2$1, x$4, x$5, x$6, x$7, x$8, x$9, v, x$10, x$11)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x1 = new $c_Ljapgolly_scalajs_react_internal_Lens(get, set);
  var this$16 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w = this$16.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseLightArea = $n($$x2).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x1, \u03b4, w);
  var $$x4 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$1 = new $c_sjsr_AnonFunction1(((x$4$2) => {
    var x$4$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$4$2);
    return $n(x$4$1).Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea
  }));
  var set$1 = new $c_sjsr_AnonFunction1(((v$3$2) => {
    var v$3 = $uZ(v$3$2);
    return new $c_sjsr_AnonFunction1(((x$5$2) => {
      var x$5$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$5$2);
      var this$17 = $n(x$5$1);
      var x$13 = this$17.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$18 = $n(x$5$1);
      var x$14 = this$18.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$19 = $n(x$5$1);
      var x$15 = this$19.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      var this$20 = $n(x$5$1);
      var x$16 = this$20.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$21 = $n(x$5$1);
      var x$17 = this$21.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var this$22 = $n(x$5$1);
      var x$18 = this$22.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$23 = $n(x$5$1);
      var x$19 = this$23.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$24 = $n(x$5$1);
      var x$20 = this$24.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$25 = $n(x$5$1);
      var x$21 = this$25.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$26 = $n(x$5$1);
      var x$22 = this$26.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      $n(x$5$1);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$13, x$14, x$15, x$16, x$17, x$18, x$19, x$20, x$21, v$3, x$22)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x3 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$1, set$1);
  var this$30 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$1 = this$30.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseAccessibleArea = $n($$x4).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x3, \u03b4, w$1);
  var $$x6 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$2 = new $c_sjsr_AnonFunction1(((x$6$2) => {
    var x$6$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$6$2);
    return $n(x$6$1).Lreactbuild_project_drawing_DrawingContext$State__f_tool
  }));
  var set$2 = new $c_sjsr_AnonFunction1(((v$4$2) => {
    var v$4 = $as_s_Option(v$4$2);
    return new $c_sjsr_AnonFunction1(((x$7$2) => {
      var x$7$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$7$2);
      var this$31 = $n(x$7$1);
      var x$24 = this$31.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$32 = $n(x$7$1);
      var x$25 = this$32.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$33 = $n(x$7$1);
      var x$26 = this$33.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      var this$34 = $n(x$7$1);
      var x$27 = this$34.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$35 = $n(x$7$1);
      var x$28 = this$35.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var this$36 = $n(x$7$1);
      var x$29 = this$36.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$37 = $n(x$7$1);
      var x$30 = this$37.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$38 = $n(x$7$1);
      var x$31 = this$38.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$39 = $n(x$7$1);
      var x$32 = this$39.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      var this$40 = $n(x$7$1);
      var x$33 = this$40.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      $n(x$7$1);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$24, x$25, x$26, x$27, x$28, x$29, v$4, x$30, x$31, x$32, x$33)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x5 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$2, set$2);
  var this$44 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$2 = this$44.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseTool = $n($$x6).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x5, \u03b4, w$2);
  var $$x8 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$3 = new $c_sjsr_AnonFunction1(((x$8$2) => {
    var x$8$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$8$2);
    return $n(x$8$1).Lreactbuild_project_drawing_DrawingContext$State__f_size
  }));
  var set$3 = new $c_sjsr_AnonFunction1(((v$5$2) => {
    var v$5 = $as_Lreactbuild_geom_Vector2Based(v$5$2);
    return new $c_sjsr_AnonFunction1(((x$9$2) => {
      var x$9$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$9$2);
      var this$45 = $n(x$9$1);
      var x$35 = this$45.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$46 = $n(x$9$1);
      var x$36 = this$46.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$47 = $n(x$9$1);
      var x$37 = this$47.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      var this$48 = $n(x$9$1);
      var x$38 = this$48.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$49 = $n(x$9$1);
      var x$39 = this$49.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var this$50 = $n(x$9$1);
      var x$40 = this$50.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$51 = $n(x$9$1);
      var x$41 = this$51.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$52 = $n(x$9$1);
      var x$42 = this$52.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$53 = $n(x$9$1);
      var x$43 = this$53.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$54 = $n(x$9$1);
      var x$44 = this$54.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      $n(x$9$1);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, v$5)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x7 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$3, set$3);
  var this$58 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$3 = this$58.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseSize = $n($$x8).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x7, \u03b4, w$3);
  var $$x10 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$4 = new $c_sjsr_AnonFunction1(((x$10$2) => {
    var x$10$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$10$2);
    return $n(x$10$1).Lreactbuild_project_drawing_DrawingContext$State__f_theme
  }));
  var set$4 = new $c_sjsr_AnonFunction1(((v$6$2) => {
    var v$6 = $as_Lreactbuild_project_drawing_Theme(v$6$2);
    return new $c_sjsr_AnonFunction1(((x$11$2) => {
      var x$11$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$11$2);
      $n(x$11$1);
      var this$59 = $n(x$11$1);
      var layers = this$59.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$60 = $n(x$11$1);
      var translation = this$60.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      var this$61 = $n(x$11$1);
      var zoomLevel = this$61.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$62 = $n(x$11$1);
      var hideControls = this$62.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var this$63 = $n(x$11$1);
      var debug = this$63.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$64 = $n(x$11$1);
      var tool = this$64.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$65 = $n(x$11$1);
      var cursors = this$65.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$66 = $n(x$11$1);
      var showLightArea = this$66.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$67 = $n(x$11$1);
      var showAccessibleArea = this$67.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      var this$68 = $n(x$11$1);
      var size = this$68.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(v$6, layers, translation, zoomLevel, hideControls, debug, tool, cursors, showLightArea, showAccessibleArea, size)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x9 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$4, set$4);
  var this$72 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$4 = this$72.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseTheme = $n($$x10).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x9, \u03b4, w$4);
  var $$x12 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$5 = new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$12$2);
    return $n(x$12).Lreactbuild_project_drawing_DrawingContext$State__f_layers
  }));
  var set$5 = new $c_sjsr_AnonFunction1(((v$7$2) => {
    var v$7 = $as_Lreactbuild_project_drawing_Layers(v$7$2);
    return new $c_sjsr_AnonFunction1(((x$13$2) => {
      var x$13$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$13$2);
      var this$73 = $n(x$13$1);
      var x$46 = this$73.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$74 = $n(x$13$1);
      var x$47 = this$74.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      var this$75 = $n(x$13$1);
      var x$48 = this$75.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$76 = $n(x$13$1);
      var x$49 = this$76.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var this$77 = $n(x$13$1);
      var x$50 = this$77.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$78 = $n(x$13$1);
      var x$51 = this$78.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$79 = $n(x$13$1);
      var x$52 = this$79.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$80 = $n(x$13$1);
      var x$53 = this$80.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$81 = $n(x$13$1);
      var x$54 = this$81.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      var this$82 = $n(x$13$1);
      var x$55 = this$82.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      $n(x$13$1);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$46, v$7, x$47, x$48, x$49, x$50, x$51, x$52, x$53, x$54, x$55)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x11 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$5, set$5);
  var this$86 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$5 = this$86.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseLayers = $n($$x12).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x11, \u03b4, w$5);
  var $$x14 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLens$();
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var get$6 = new $c_sjsr_AnonFunction1(((x$14$2) => {
    var x$14$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$14$2);
    return $n(x$14$1).Lreactbuild_project_drawing_DrawingContext$State__f_debug
  }));
  var set$6 = new $c_sjsr_AnonFunction1(((v$8$2) => {
    var v$8 = $uZ(v$8$2);
    return new $c_sjsr_AnonFunction1(((x$15$2) => {
      var x$15$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$15$2);
      var this$87 = $n(x$15$1);
      var x$57 = this$87.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$88 = $n(x$15$1);
      var x$58 = this$88.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$89 = $n(x$15$1);
      var x$59 = this$89.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      var this$90 = $n(x$15$1);
      var x$60 = this$90.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$91 = $n(x$15$1);
      var x$61 = this$91.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var this$92 = $n(x$15$1);
      var x$62 = this$92.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$93 = $n(x$15$1);
      var x$63 = this$93.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$94 = $n(x$15$1);
      var x$64 = this$94.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$95 = $n(x$15$1);
      var x$65 = this$95.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      var this$96 = $n(x$15$1);
      var x$66 = this$96.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      $n(x$15$1);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$57, x$58, x$59, x$60, x$61, v$8, x$62, x$63, x$64, x$65, x$66)
    }))
  }));
  $m_Ljapgolly_scalajs_react_internal_Lens$();
  var $$x13 = new $c_Ljapgolly_scalajs_react_internal_Lens(get$6, set$6);
  var this$100 = $m_Ljapgolly_scalajs_react_StateAccessor$();
  var w$6 = this$100.japgolly$scalajs$react$StateAccessorImplicits$$stateAccessPureInstance__Ljapgolly_scalajs_react_StateAccessor$ReadWrite();
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseDebug = $n($$x14).prepareVia$extension__Ljapgolly_scalajs_react_internal_Lens__O__Ljapgolly_scalajs_react_StateAccessor$Write__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromLensSetStateFn($$x13, \u03b4, w$6);
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_translate = new $c_sjsr_AnonFunction1(((vec$2) => {
    var vec = $as_Lreactbuild_geom_Vector2Based(vec$2);
    var this$113 = $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_project_drawing_DrawingContext$State(s$2);
      var this$101 = $n($n(s).Lreactbuild_project_drawing_DrawingContext$State__f_translation);
      var x$67 = new $c_Lreactbuild_geom_Vector2((this$101.x__D() + $n(vec).x__D()), (this$101.y__D() + $n(vec).y__D()));
      var this$102 = $n(s);
      var x$68 = this$102.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$103 = $n(s);
      var x$69 = this$103.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$104 = $n(s);
      var x$70 = this$104.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$105 = $n(s);
      var x$71 = this$105.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var this$106 = $n(s);
      var x$72 = this$106.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$107 = $n(s);
      var x$73 = this$107.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$108 = $n(s);
      var x$74 = this$108.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$109 = $n(s);
      var x$75 = this$109.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$110 = $n(s);
      var x$76 = this$110.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      var this$111 = $n(s);
      var x$77 = this$111.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      $n(s);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$68, x$69, x$67, x$70, x$71, x$72, x$73, x$74, x$75, x$76, x$77)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$113, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_zoom = new $c_sjsr_AnonFunction2(((vec$3$2, factor$2) => {
    var vec$3 = $as_Lreactbuild_geom_Vector2Based(vec$3$2);
    var factor = $uD(factor$2);
    var this$126 = $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_$);
    var mod$1 = new $c_sjsr_AnonFunction1(((s$2$1) => {
      var s$1 = $as_Lreactbuild_project_drawing_DrawingContext$State(s$2$1);
      var a = ($n(s$1).Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel * factor);
      var a$1 = $uD(Math.max(a, 0.1));
      var newScale = $uD(Math.min(a$1, 10.0));
      var delta = (newScale / $n(s$1).Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel);
      var newOrigin = new $c_Lreactbuild_geom_Vector2(($n(vec$3).x__D() - (delta * ($n(vec$3).x__D() - $n($n(s$1).Lreactbuild_project_drawing_DrawingContext$State__f_translation).x__D()))), ($n(vec$3).y__D() - (delta * ($n(vec$3).y__D() - $n($n(s$1).Lreactbuild_project_drawing_DrawingContext$State__f_translation).y__D()))));
      var this$116 = $n(s$1);
      var x$80 = this$116.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$117 = $n(s$1);
      var x$81 = this$117.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$118 = $n(s$1);
      var x$82 = this$118.Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var this$119 = $n(s$1);
      var x$83 = this$119.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$120 = $n(s$1);
      var x$84 = this$120.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$121 = $n(s$1);
      var x$85 = this$121.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$122 = $n(s$1);
      var x$86 = this$122.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$123 = $n(s$1);
      var x$87 = this$123.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      var this$124 = $n(s$1);
      var x$88 = this$124.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      $n(s$1);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$80, x$81, newOrigin, newScale, x$82, x$83, x$84, x$85, x$86, x$87, x$88)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$126, mod$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_sendToServer = new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $as_F0(f$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_project_drawing_DrawingContext$Props(p$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var co = $m_Ljapgolly_scalajs_react_callback_CallbackOption$().flatMap$extension__F0__F1__F0($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_CallbackOption).option__F0__F0(new $c_sjsr_AnonFunction0((() => $n(p).Lreactbuild_project_drawing_DrawingContext$Props__f_serverConnection))), new $c_sjsr_AnonFunction1(((connection$2) => {
        var connection = $as_Lreactbuild_analyze_cost_services_ServerConnection(connection$2);
        $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
        var this$ = $n(connection).send__Lreactbuild_model_FromClient__Ljapgolly_scalajs_react_callback_Trampoline($as_Lreactbuild_model_FromClient($n(f).apply__O()));
        var f$1 = new $c_sjsr_AnonFunction1(((x$16$2) => {
          $as_jl_Void(x$16$2)
        }));
        var this$128 = $n(this$);
        var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$128, f$1);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
      })));
      var $$x15 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$131 = $m_s_$less$colon$less$();
      return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x15).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$131.s_$less$colon$less$__f_singleton))
    }))))
  }));
  var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(\u03b4).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var f$3 = new $c_sjsr_AnonFunction1(((x$17$2) => {
    var x$17$1 = $as_Lreactbuild_project_drawing_DrawingContext$Props(x$17$2);
    return $n(x$17$1).Lreactbuild_project_drawing_DrawingContext$Props__f_project
  }));
  var this$133 = $n(this$$1);
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_project = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$133, f$3)
}
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype = new $h_O();
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.constructor = $c_Lreactbuild_project_drawing_DrawingContext$Backend;
/** @constructor */
function $h_Lreactbuild_project_drawing_DrawingContext$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_DrawingContext$Backend.prototype = $c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype;
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.com$iz2use$react$components$DebounceSupport$$debounceHandlers__sci_Map = (function() {
  return this.Lreactbuild_project_drawing_DrawingContext$Backend__f_com$iz2use$react$components$DebounceSupport$$debounceHandlers
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.com$iz2use$react$components$DebounceSupport$$debounceHandlers_$eq__sci_Map__V = (function(x$1) {
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_com$iz2use$react$components$DebounceSupport$$debounceHandlers = x$1
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_drawing_DrawingContext$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_drawing_DrawingContext$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.render__Lreactbuild_project_drawing_DrawingContext$Props__Lreactbuild_project_drawing_DrawingContext$State__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s) {
  var u$2 = $m_Lreactbuild_project_drawing_DrawingParser$().apply__T__F1__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($n(p).Lreactbuild_project_drawing_DrawingContext$Props__f_modelSource, new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_Lreactbuild_project_drawing_DrawingParser$Model(x0$1$2);
    if ((x0$1 !== null)) {
      var v = $n(x0$1).Lreactbuild_project_drawing_DrawingParser$Model__f_building;
      var ids = $n(x0$1).Lreactbuild_project_drawing_DrawingParser$Model__f_ids;
      var realPosition = new $c_sjsr_AnonFunction1(((pt$2) => {
        var pt = $as_Lreactbuild_geom_Point2Based(pt$2);
        var this$2 = $n(pt);
        var that = $n(s).Lreactbuild_project_drawing_DrawingContext$State__f_translation;
        var this$3 = new $c_Lreactbuild_geom_Vector2((this$2.x__D() - $n(that).x__D()), (this$2.y__D() - $n(that).y__D()));
        var scalar = $n(s).Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
        var this$4 = new $c_Lreactbuild_geom_Vector2((this$3.Lreactbuild_geom_Vector2__f_x / scalar), (this$3.Lreactbuild_geom_Vector2__f_y / scalar));
        var scalar$1 = $n(p).Lreactbuild_project_drawing_DrawingContext$Props__f_scale;
        var r = new $c_Lreactbuild_geom_Vector2((this$4.Lreactbuild_geom_Vector2__f_x / scalar$1), (this$4.Lreactbuild_geom_Vector2__f_y / scalar$1));
        return new $c_Lreactbuild_geom_Point2(r.Lreactbuild_geom_Vector2__f_x, ($n($n(s).Lreactbuild_project_drawing_DrawingContext$State__f_size).y__D() - r.Lreactbuild_geom_Vector2__f_y))
      }));
      var $$x10 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withoutReuse$FromValue$().apply$extension__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(($n($m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$()), v), new $c_sjsr_AnonFunction2(((x0$2$2, x1$1$2) => {
        var x0$2 = $as_s_Option(x0$2$2);
        var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
        var x1 = $ct_T2__O__O__(new $c_T2(), x0$2, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
        matchEnd7: {
          var $$x11;
          var p2 = $as_s_Option(x1.T2__f__1);
          var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          var x = $m_s_None$();
          if ((x === p2)) {
            var $$x11 = cb;
            break matchEnd7
          };
          var p4 = $as_s_Option(x1.T2__f__1);
          var cb$2 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          if ((p4 instanceof $c_s_Some)) {
            var x5 = $as_s_Some(p4);
            var v$1 = $as_Lreactbuild_format_iz2use_package$Building($n(x5).s_Some__f_value);
            var $$x11 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).alert__T__Ljapgolly_scalajs_react_callback_Trampoline(("Need to change with \n" + v$1)), cb$2);
            break matchEnd7
          };
          throw new $c_s_MatchError(x1)
        };
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x11)
      })));
      var $$x9 = $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseLightArea);
      var this$6 = $m_Ljapgolly_scalajs_react_Reusability$();
      var $$x8 = $n($$x9).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$6.by_$eq$eq__F2());
      var $$x7 = $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseAccessibleArea);
      var this$7 = $m_Ljapgolly_scalajs_react_Reusability$();
      var $$x6 = $n($$x7).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$7.by_$eq$eq__F2());
      var $$x5 = $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseTool);
      var this$8 = $m_Ljapgolly_scalajs_react_Reusability$();
      var evidence$3 = $m_Lreactbuild_project_drawing_DrawingContext$().Lreactbuild_project_drawing_DrawingContext$__f_reusabilityTool;
      var $$x4 = $n($$x5).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$8.optionLike__Ljapgolly_scalajs_react_util_OptionLike__F2__F2($m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance, evidence$3));
      var $$x3 = $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseTheme).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $m_Lreactbuild_project_drawing_DrawingContext$().Lreactbuild_project_drawing_DrawingContext$__f_reusabilityTheme);
      var $$x2 = $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseLayers).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $m_Lreactbuild_project_drawing_DrawingContext$().Lreactbuild_project_drawing_DrawingContext$__f_reusabilityLayers);
      var $$x1 = this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseDebug;
      var this$9 = $m_Ljapgolly_scalajs_react_Reusability$();
      var context = new $c_Lreactbuild_project_drawing_DrawingContextImpl($$x10, $$x8, $$x6, $$x4, $$x3, $$x2, $n($$x1).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, this$9.by_$eq$eq__F2()), $n(p).Lreactbuild_project_drawing_DrawingContext$Props__f_scale, realPosition, ids, this);
      var $$x134 = $m_Lreactbuild_project_drawing_View$();
      var $$x133 = $n(p).Lreactbuild_project_drawing_DrawingContext$Props__f_project;
      var $$x132 = $n(s).Lreactbuild_project_drawing_DrawingContext$State__f_hideControls;
      var $$x131 = $n(s).Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var $$x130 = $m_Lreactbuild_project_drawing_Viewport$();
      var $$x129 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      var $$x128 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$14 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "id");
      var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x127 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$14.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "dimension");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$17 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "viewBox");
      var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x126 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$17.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0 0 8 8");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$20 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "refX");
      var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x125 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$20.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "4");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$23 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "refY");
      var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x124 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$23.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "4");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$26 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "markerWidth");
      var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x123 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$26.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "8");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$29 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "markerHeight");
      var t$5 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x122 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$5, this$29.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "8");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$32 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "orient");
      var t$6 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x121 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$6, this$32.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "auto");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$35 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "markerUnits");
      var t$7 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x120 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$7, this$35.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "userSpaceOnUse");
      var $$x119 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$39 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "d");
      var t$8 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x118 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$8, this$39.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "M 1 7 L 7 1");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$42 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
      var t$9 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x117 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$9, this$42.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "none");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$45 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
      var t$10 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array = [$$x118, $$x117, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$10, this$45.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#000000")];
      var array$1 = [$$x127, $$x126, $$x125, $$x124, $$x123, $$x122, $$x121, $$x120, $n($$x119).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("path", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
      var $$x116 = $n($$x128).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("marker", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var $$x115 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$55 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "id");
      var t$11 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x114 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$11, this$55.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "accessible-area");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$58 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
      var t$12 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x113 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$12, this$58.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "6");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$61 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
      var t$13 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x112 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$13, this$61.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "6");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$64 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "patternUnits");
      var t$14 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x111 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$14, this$64.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "userSpaceOnUse");
      var $$x110 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$68 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x1");
      var t$15 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x109 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$15, this$68.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-1");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$71 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y1");
      var t$16 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x108 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$16, this$71.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "6");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$74 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x2");
      var t$17 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x107 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$17, this$74.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "21");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$77 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y2");
      var t$18 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x106 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$18, this$77.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-16");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$80 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
      var t$19 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$2 = [$$x109, $$x108, $$x107, $$x106, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$19, this$80.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#0000FF")];
      var $$x105 = $n($$x110).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("line", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
      var $$x104 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$87 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x1");
      var t$20 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x103 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$20, this$87.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-1");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$90 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y1");
      var t$21 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x102 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$21, this$90.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "12");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$93 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x2");
      var t$22 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x101 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$22, this$93.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "21");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$96 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y2");
      var t$23 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x100 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$23, this$96.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-10");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$99 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
      var t$24 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$3 = [$$x103, $$x102, $$x101, $$x100, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$24, this$99.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#0000FF")];
      var array$4 = [$$x114, $$x113, $$x112, $$x111, $$x105, $n($$x104).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("line", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
      var $$x99 = $n($$x115).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("pattern", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
      var $$x98 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$109 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "id");
      var t$25 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x97 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$25, this$109.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "wall");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$112 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
      var t$26 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x96 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$26, this$112.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "20");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$115 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
      var t$27 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x95 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$27, this$115.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "20");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$118 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "patternUnits");
      var t$28 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x94 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$28, this$118.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "userSpaceOnUse");
      var $$x93 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$122 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
      var t$29 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x92 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$29, this$122.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "20");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$125 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
      var t$30 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x91 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$30, this$125.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "20");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$128 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
      var t$31 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$5 = [$$x92, $$x91, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$31, this$128.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#FFFFFF")];
      var $$x90 = $n($$x93).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
      var $$x89 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$135 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x1");
      var t$32 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x88 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$32, this$135.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-1");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$138 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y1");
      var t$33 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x87 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$33, this$138.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "6");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$141 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x2");
      var t$34 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x86 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$34, this$141.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "21");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$144 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y2");
      var t$35 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x85 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$35, this$144.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-16");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$147 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
      var t$36 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$6 = [$$x88, $$x87, $$x86, $$x85, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$36, this$147.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#000000")];
      var $$x84 = $n($$x89).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("line", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
      var $$x83 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$154 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x1");
      var t$37 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x82 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$37, this$154.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-1");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$157 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y1");
      var t$38 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x81 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$38, this$157.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "26");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$160 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x2");
      var t$39 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x80 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$39, this$160.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "21");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$163 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y2");
      var t$40 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x79 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$40, this$163.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "4");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$166 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
      var t$41 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$7 = [$$x82, $$x81, $$x80, $$x79, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$41, this$166.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#000000")];
      var array$8 = [$$x97, $$x96, $$x95, $$x94, $$x90, $$x84, $n($$x83).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("line", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
      var $$x78 = $n($$x98).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("pattern", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8));
      var $$x77 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$176 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "id");
      var t$42 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x76 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$42, this$176.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "tiled");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$179 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
      var t$43 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x75 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$43, this$179.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "20");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$182 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
      var t$44 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x74 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$44, this$182.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "20");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$185 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "patternUnits");
      var t$45 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x73 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$45, this$185.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "userSpaceOnUse");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$188 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "patternTransform");
      var a = (("scale(" + context.apply__D__T(30.0)) + ")");
      var t$46 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x72 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$46, this$188.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
      var $$x71 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$192 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
      var t$47 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x70 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$47, this$192.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "20");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$195 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
      var t$48 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x69 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$48, this$195.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "20");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$198 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "fill");
      var t$49 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$9 = [$$x70, $$x69, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$49, this$198.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#FFFFFF")];
      var $$x68 = $n($$x71).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
      var $$x67 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$205 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x1");
      var t$50 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x66 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$50, this$205.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "10");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$208 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y1");
      var t$51 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x65 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$51, this$208.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-1");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$211 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x2");
      var t$52 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x64 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$52, this$211.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "10");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$214 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y2");
      var t$53 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x63 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$53, this$214.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "21");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$217 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
      var t$54 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$10 = [$$x66, $$x65, $$x64, $$x63, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$54, this$217.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#EEEEEE")];
      var $$x62 = $n($$x67).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("line", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10));
      var $$x61 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$224 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x1");
      var t$55 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x60 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$55, this$224.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "-1");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$227 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y1");
      var t$56 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x59 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$56, this$227.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "10");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$230 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x2");
      var t$57 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x58 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$57, this$230.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "21");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$233 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y2");
      var t$58 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x57 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$58, this$233.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "10");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$236 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stroke");
      var t$59 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$11 = [$$x60, $$x59, $$x58, $$x57, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$59, this$236.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#EEEEEE")];
      var array$12 = [$$x76, $$x75, $$x74, $$x73, $$x72, $$x68, $$x62, $n($$x61).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("line", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
      var $$x56 = $n($$x77).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("pattern", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
      var $$x55 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$246 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "id");
      var t$60 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x54 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$60, this$246.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "lightCircleArea");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$249 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "cx");
      var t$61 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x53 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$61, this$249.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "50%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$252 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "cy");
      var t$62 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x52 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$62, this$252.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "50%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$255 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "r");
      var t$63 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x51 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$63, this$255.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "50%");
      var $$x50 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$259 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "offset");
      var t$64 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x49 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$64, this$259.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "40%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$262 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopColor");
      var t$65 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x48 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$65, this$262.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#FFFF00");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$265 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopOpacity");
      var t$66 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$13 = [$$x49, $$x48, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$66, this$265.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1")];
      var $$x47 = $n($$x50).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("stop", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13));
      var $$x46 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$272 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "offset");
      var t$67 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x45 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$67, this$272.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "80%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$275 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopColor");
      var t$68 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x44 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$68, this$275.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#FFFF00");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$278 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopOpacity");
      var t$69 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$14 = [$$x45, $$x44, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$69, this$278.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, ".25")];
      var $$x43 = $n($$x46).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("stop", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
      var $$x42 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$285 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "offset");
      var t$70 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x41 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$70, this$285.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "100%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$288 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopColor");
      var t$71 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x40 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$71, this$288.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#FFFF00");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$291 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopOpacity");
      var t$72 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$15 = [$$x41, $$x40, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$72, this$291.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0")];
      var array$16 = [$$x54, $$x53, $$x52, $$x51, $$x47, $$x43, $n($$x42).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("stop", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
      var $$x39 = $n($$x55).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("radialGradient", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16));
      var $$x38 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$301 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "id");
      var t$73 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x37 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$73, this$301.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "lightHalfCircleArea");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$304 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "cx");
      var t$74 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x36 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$74, this$304.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "50%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$307 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "cy");
      var t$75 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x35 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$75, this$307.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "00%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$310 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "r");
      var t$76 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x34 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$76, this$310.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "100%");
      var $$x33 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$314 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "offset");
      var t$77 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x32 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$77, this$314.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "40%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$317 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopColor");
      var t$78 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x31 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$78, this$317.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#FFFF00");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$320 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopOpacity");
      var t$79 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$17 = [$$x32, $$x31, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$79, this$320.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "1")];
      var $$x30 = $n($$x33).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("stop", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17));
      var $$x29 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$327 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "offset");
      var t$80 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x28 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$80, this$327.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "80%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$330 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopColor");
      var t$81 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x27 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$81, this$330.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#FFFF00");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$333 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopOpacity");
      var t$82 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$18 = [$$x28, $$x27, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$82, this$333.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, ".25")];
      var $$x26 = $n($$x29).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("stop", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18));
      var $$x25 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$340 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "offset");
      var t$83 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x24 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$83, this$340.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "100%");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$343 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopColor");
      var t$84 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x23 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$84, this$343.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "#FFFF00");
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$346 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "stopOpacity");
      var t$85 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var array$19 = [$$x24, $$x23, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$85, this$346.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "0")];
      var array$20 = [$$x37, $$x36, $$x35, $$x34, $$x30, $$x26, $n($$x25).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("stop", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19))];
      var array$21 = [$$x116, $$x99, $$x78, $$x56, $$x39, $n($$x38).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("radialGradient", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20))];
      var $$x22 = $n($$x129).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("defs", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$21));
      var $$x21 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$359 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
      var a$1 = (((((("translate(" + $n($n(s).Lreactbuild_project_drawing_DrawingContext$State__f_translation).x__D()) + ", ") + $n($n(s).Lreactbuild_project_drawing_DrawingContext$State__f_translation).y__D()) + ") scale(") + $n(s).Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel) + ")");
      var t$86 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x20 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$86, this$359.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$1);
      var $$x19 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$363 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
      var a$2 = (("translate(0, " + context.apply__D__T($n($n(s).Lreactbuild_project_drawing_DrawingContext$State__f_size).y__D())) + ")");
      var t$87 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x16 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$87, this$363.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$2);
      var $$x15 = $as_Ljapgolly_scalajs_react_vdom_TagMod($n($n(p).Lreactbuild_project_drawing_DrawingContext$Props__f_render).apply__O__O(new $c_Lreactbuild_project_drawing_BoxedDrawingContext(context, $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_reuseSize).apply__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(s, $m_Lreactbuild_project_drawing_DrawingContext$().Lreactbuild_project_drawing_DrawingContext$__f_reusabilityVector2Based))));
      var this$364 = $n($n(s).Lreactbuild_project_drawing_DrawingContext$State__f_tool);
      var pf = new $c_Lreactbuild_project_drawing_DrawingContext$Backend$$anonfun$$nestedInanonfun$render$1$1(this, context);
      if ((!this$364.isEmpty__Z())) {
        var this$365 = new $c_s_PartialFunction$Lifted(pf);
        var v1 = this$364.get__O();
        var $$x14 = this$365.apply__O__s_Option(v1)
      } else {
        var $$x14 = $m_s_None$()
      };
      var this$366 = $n($$x14);
      var $$x13 = $as_Ljapgolly_scalajs_react_vdom_TagMod((this$366.isEmpty__Z() ? $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom : this$366.get__O()));
      var $$x12 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var as = $n(s).Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var array$23 = [$$x16, $$x15, $$x13, $n($$x12).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((c$2) => {
        var c = $as_Lreactbuild_project_drawing_RemoteCursor(c$2);
        var $$x18 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        var this$369 = $m_Lscalacss_ScalaCssReact$();
        var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingRemoteCursor;
        var $$x17 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$369, s$1);
        $m_Ljapgolly_scalajs_react_vdom_all$svg$();
        $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
        var this$372 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
        var a$3 = (("translate(" + context.apply__D__D__T($n(c).Lreactbuild_project_drawing_RemoteCursor__f_x, $n(c).Lreactbuild_project_drawing_RemoteCursor__f_y)) + ")");
        var t$88 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
        var array$22 = [$$x17, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$88, this$372.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a$3)];
        return $n($$x18).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("circle", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$22))
      })))];
      var array$24 = [$$x20, $n($$x19).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("g", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$23))];
      var array$25 = [$$x22, $n($$x21).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("g", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$24))];
      var u = $n($$x130).apply__sci_Seq__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$25), context);
      var this$386 = $n(u);
      var n = this$386.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      var array$26 = [new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n)];
      var u$1 = $n($$x134).apply__Lreactbuild_common_model_Project__Z__s_Option__sci_Seq__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x133, $$x132, $$x131, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$26), context);
      var this$392 = $n(u$1);
      var n$1 = this$392.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
      return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })));
  var this$395 = $n(u$2);
  var n$2 = this$395.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$2)
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.showControls__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
  var key = $m_Lreactbuild_project_drawing_DrawingContext$().Lreactbuild_project_drawing_DrawingContext$__f_reactbuild$project$drawing$DrawingContext$$DebounceHidecontrols;
  return $n($$x1).$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($f_Lcom_iz2use_react_components_DebounceSupport__debounceReset__T__Ljapgolly_scalajs_react_callback_Trampoline(this, key), $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_$).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_Lreactbuild_project_drawing_DrawingContext$State(s$2);
    if ($n(s).Lreactbuild_project_drawing_DrawingContext$State__f_hideControls) {
      var this$2 = $n(s);
      var x$2 = this$2.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$3 = $n(s);
      var x$3 = this$3.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$4 = $n(s);
      var x$4 = this$4.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      var this$5 = $n(s);
      var x$5 = this$5.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$6 = $n(s);
      var x$6 = this$6.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$7 = $n(s);
      var x$7 = this$7.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$8 = $n(s);
      var x$8 = this$8.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$9 = $n(s);
      var x$9 = this$9.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$10 = $n(s);
      var x$10 = this$10.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      var this$11 = $n(s);
      var x$11 = this$11.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      $n(s);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$2, x$3, x$4, x$5, false, x$6, x$7, x$8, x$9, x$10, x$11)
    } else {
      return s
    }
  })), new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this.hideControls__D__Ljapgolly_scalajs_react_callback_Trampoline(5000.0)))), $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.hideControls__D__Ljapgolly_scalajs_react_callback_Trampoline = (function(ms) {
  var key = $m_Lreactbuild_project_drawing_DrawingContext$().Lreactbuild_project_drawing_DrawingContext$__f_reactbuild$project$drawing$DrawingContext$$DebounceHidecontrols;
  var later = new $c_sjsr_AnonFunction0((() => {
    var this$13 = $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_$);
    var mod = new $c_sjsr_AnonFunction1(((s$2) => {
      var s = $as_Lreactbuild_project_drawing_DrawingContext$State(s$2);
      var this$2 = $n(s);
      var x$2 = this$2.Lreactbuild_project_drawing_DrawingContext$State__f_theme;
      var this$3 = $n(s);
      var x$3 = this$3.Lreactbuild_project_drawing_DrawingContext$State__f_layers;
      var this$4 = $n(s);
      var x$4 = this$4.Lreactbuild_project_drawing_DrawingContext$State__f_translation;
      var this$5 = $n(s);
      var x$5 = this$5.Lreactbuild_project_drawing_DrawingContext$State__f_zoomLevel;
      var this$6 = $n(s);
      var x$6 = this$6.Lreactbuild_project_drawing_DrawingContext$State__f_debug;
      var this$7 = $n(s);
      var x$7 = this$7.Lreactbuild_project_drawing_DrawingContext$State__f_tool;
      var this$8 = $n(s);
      var x$8 = this$8.Lreactbuild_project_drawing_DrawingContext$State__f_cursors;
      var this$9 = $n(s);
      var x$9 = this$9.Lreactbuild_project_drawing_DrawingContext$State__f_showLightArea;
      var this$10 = $n(s);
      var x$10 = this$10.Lreactbuild_project_drawing_DrawingContext$State__f_showAccessibleArea;
      var this$11 = $n(s);
      var x$11 = this$11.Lreactbuild_project_drawing_DrawingContext$State__f_size;
      $n(s);
      return new $c_Lreactbuild_project_drawing_DrawingContext$State(x$2, x$3, x$4, x$5, true, x$6, x$7, x$8, x$9, x$10, x$11)
    }));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$13, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
  }));
  return $f_Lcom_iz2use_react_components_DebounceSupport__debounce__T__D__F0__Ljapgolly_scalajs_react_callback_Trampoline(this, key, ms, later)
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.message__Lreactbuild_model_ToClient__Ljapgolly_scalajs_react_callback_Trampoline = (function(e) {
  if ((e instanceof $c_Lreactbuild_model_CursorLocationUpdate)) {
    var x2 = $as_Lreactbuild_model_CursorLocationUpdate(e);
    var origin = $n(x2).Lreactbuild_model_CursorLocationUpdate__f_origin;
    var user = $n(x2).Lreactbuild_model_CursorLocationUpdate__f_user;
    var projectRef = $n(x2).Lreactbuild_model_CursorLocationUpdate__f_projectRef;
    var x = $n(x2).Lreactbuild_model_CursorLocationUpdate__f_x;
    var y = $n(x2).Lreactbuild_model_CursorLocationUpdate__f_y;
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var $$x1 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$ = $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_$).props__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
    var condition = new $c_sjsr_AnonFunction1(((p$2) => {
      var p = $as_Lreactbuild_project_drawing_DrawingContext$Props(p$2);
      var x$1 = $n($n(p).Lreactbuild_project_drawing_DrawingContext$Props__f_project).Lreactbuild_common_model_Project__f__id;
      return ((x$1 === null) ? (projectRef === null) : $n(x$1).equals__O__Z(projectRef))
    }));
    var co = $n($$x1).flatMap$extension__F0__F1__F0($m_Ljapgolly_scalajs_react_callback_CallbackOption$().filter$extension__F0__F1__F0(this$, condition), new $c_sjsr_AnonFunction1(((p$3$2) => {
      $as_Lreactbuild_project_drawing_DrawingContext$Props(p$3$2);
      $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
      var this$9 = $n(this.Lreactbuild_project_drawing_DrawingContext$Backend__f_$);
      var mod = new $c_sjsr_AnonFunction1(((x$18$2) => {
        var x$18 = $as_Lreactbuild_project_drawing_DrawingContext$State(x$18$2);
        var $$x3 = $n(x$18);
        new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        var $$x2 = $m_Ljava_time_Instant$();
        var this$8 = $m_RTLong$();
        var value = $uD(new Date().getTime());
        var lo = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
        var hi = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return $n($$x3).pushRemoteCursor__Lreactbuild_project_drawing_RemoteCursor__Lreactbuild_project_drawing_DrawingContext$State(new $c_Lreactbuild_project_drawing_RemoteCursor(origin, user, x, y, $n($$x2).ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi))))
      }));
      var this$$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$9, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var f = new $c_sjsr_AnonFunction1(((x$19$2) => {
        $as_jl_Void(x$19$2)
      }));
      var this$11 = $n(this$$1);
      var c = $f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$11, f);
      return new $c_Ljapgolly_scalajs_react_callback_CallbackOption($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toCBO$extension__Ljapgolly_scalajs_react_callback_Trampoline__F0(c))
    })));
    var $$x4 = $m_Ljapgolly_scalajs_react_callback_CallbackOption$();
    var this$14 = $m_s_$less$colon$less$();
    return $n($$x4).toCallback$extension__F0__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(co, this$14.s_$less$colon$less$__f_singleton)
  } else {
    return $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).log__O__sci_Seq__Ljapgolly_scalajs_react_callback_Trampoline($n(e).toString__T(), $m_sci_Nil$())
  }
});
function $as_Lreactbuild_project_drawing_DrawingContext$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_DrawingContext$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.DrawingContext$Backend"))
}
function $isArrayOf_Lreactbuild_project_drawing_DrawingContext$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_DrawingContext$Backend)))
}
function $asArrayOf_Lreactbuild_project_drawing_DrawingContext$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_DrawingContext$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.DrawingContext$Backend;", depth))
}
var $d_Lreactbuild_project_drawing_DrawingContext$Backend = new $TypeData().initClass({
  Lreactbuild_project_drawing_DrawingContext$Backend: 0
}, false, "reactbuild.project.drawing.DrawingContext$Backend", {
  Lreactbuild_project_drawing_DrawingContext$Backend: 1,
  O: 1,
  Lcom_iz2use_react_components_DebounceSupport: 1,
  Ljapgolly_scalajs_react_extra_TimerSupport: 1,
  Ljapgolly_scalajs_react_extra_TimerSupportF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1
});
$c_Lreactbuild_project_drawing_DrawingContext$Backend.prototype.$classData = $d_Lreactbuild_project_drawing_DrawingContext$Backend;
/** @constructor */
function $c_Lreactbuild_project_drawing_View$Backend(\u03b4) {
  this.Lreactbuild_project_drawing_View$Backend__f_$ = null;
  this.Lreactbuild_project_drawing_View$Backend__f_fullScreenReuse = null;
  this.Lreactbuild_project_drawing_View$Backend__f_com$iz2use$react$components$DebounceSupport$$debounceHandlers = null;
  this.Lreactbuild_project_drawing_View$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = null;
  this.Lreactbuild_project_drawing_View$Backend__f_$ = \u03b4;
  this.Lreactbuild_project_drawing_View$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = $m_s_package$().s_package$__f_Nil;
  $f_Lcom_iz2use_react_components_DebounceSupport__$init$__V(this);
  $m_Ljapgolly_scalajs_react_extra_package$().StateSnapshot__Ljapgolly_scalajs_react_extra_internal_StateSnapshot$();
  var f$4 = new $c_sjsr_AnonFunction2(((x0$1$2, x1$1$2) => {
    var x0$1 = $as_s_Option(x0$1$2);
    var x1$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x1 = $ct_T2__O__O__(new $c_T2(), x0$1, new $c_Ljapgolly_scalajs_react_callback_CallbackTo(x1$1));
    matchEnd7: {
      var $$x1;
      var p2 = $as_s_Option(x1.T2__f__1);
      var cb = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x1.T2__f__2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
      var x = $m_s_None$();
      if ((x === p2)) {
        var $$x1 = cb;
        break matchEnd7
      };
      var p4 = $as_s_Option(x1.T2__f__1);
      if ((p4 instanceof $c_s_Some)) {
        var x5 = $as_s_Some(p4);
        var v = $uZ($n(x5).s_Some__f_value);
        if (v) {
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f = new $c_sjsr_AnonFunction0((() => {
            var qual$1 = document.body;
            return qual$1.requestFullscreen()
          }));
          var f$1 = new $c_sjsr_AnonFunction0((() => {
            f.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          var $$x1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1);
          break matchEnd7
        } else {
          $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
          var f$2 = new $c_sjsr_AnonFunction0((() => document.exitFullscreen()));
          var f$3 = new $c_sjsr_AnonFunction0((() => {
            f$2.apply__O()
          }));
          $m_Ljapgolly_scalajs_react_callback_Trampoline$();
          var $$x1 = new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$3);
          break matchEnd7
        }
      };
      throw new $c_s_MatchError(x1)
    };
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($$x1)
  }));
  this.Lreactbuild_project_drawing_View$Backend__f_fullScreenReuse = $m_Ljapgolly_scalajs_react_Reusable$().byRef__O__Ljapgolly_scalajs_react_Reusable(f$4)
}
$c_Lreactbuild_project_drawing_View$Backend.prototype = new $h_O();
$c_Lreactbuild_project_drawing_View$Backend.prototype.constructor = $c_Lreactbuild_project_drawing_View$Backend;
/** @constructor */
function $h_Lreactbuild_project_drawing_View$Backend() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_View$Backend.prototype = $c_Lreactbuild_project_drawing_View$Backend.prototype;
$c_Lreactbuild_project_drawing_View$Backend.prototype.onUnmountEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_project_drawing_View$Backend.prototype.com$iz2use$react$components$DebounceSupport$$debounceHandlers__sci_Map = (function() {
  return this.Lreactbuild_project_drawing_View$Backend__f_com$iz2use$react$components$DebounceSupport$$debounceHandlers
});
$c_Lreactbuild_project_drawing_View$Backend.prototype.com$iz2use$react$components$DebounceSupport$$debounceHandlers_$eq__sci_Map__V = (function(x$1) {
  this.Lreactbuild_project_drawing_View$Backend__f_com$iz2use$react$components$DebounceSupport$$debounceHandlers = x$1
});
$c_Lreactbuild_project_drawing_View$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs__sci_List = (function() {
  return this.Lreactbuild_project_drawing_View$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs
});
$c_Lreactbuild_project_drawing_View$Backend.prototype.japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_project_drawing_View$Backend__f_japgolly$scalajs$react$extra$OnUnmountF$$unmountProcs = x$1
});
$c_Lreactbuild_project_drawing_View$Backend.prototype.render__Lreactbuild_project_drawing_View$Props__Lreactbuild_project_drawing_View$State__sjs_js_Any__Ljapgolly_scalajs_react_vdom_VdomNode = (function(p, s, c) {
  var $$x11 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var this$3 = $m_Lscalacss_ScalaCssReact$();
  var s$1 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingView;
  var $$x10 = $f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$3, s$1);
  var this$4 = $m_Lscalacss_ScalaCssReact$();
  var s$2 = $m_Lreactbuild_Style$().Lreactbuild_Style$__f_drawingViewFullScreen;
  var this$5 = $n($f_Lscalacss_ScalaCssReactImplicits__scalacssStyleaToTagMod__Lscalacss_internal_StyleA__Ljapgolly_scalajs_react_vdom_TagMod(this$4, s$2));
  var condition = $n(s).Lreactbuild_project_drawing_View$State__f_fullScreen;
  var $$x9 = $f_Ljapgolly_scalajs_react_vdom_TagMod__when__Z__Ljapgolly_scalajs_react_vdom_TagMod(this$5, condition);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var $$x8 = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(c);
  var $$x6 = $m_Lreactbuild_project_drawing_ToolSelector$();
  var $$x5 = $n(p).Lreactbuild_project_drawing_View$Props__f_project;
  var $$x4 = $n(p).Lreactbuild_project_drawing_View$Props__f_hideControls;
  var $$x3 = $m_Ljapgolly_scalajs_react_extra_internal_StateSnapshot$withReuse$FromSetStateFn$();
  var $$x2 = this.Lreactbuild_project_drawing_View$Backend__f_fullScreenReuse;
  var $$x1 = $n(s).Lreactbuild_project_drawing_View$State__f_fullScreen;
  var this$9 = $m_Ljapgolly_scalajs_react_Reusability$();
  var u = $n($$x6).apply__Lreactbuild_common_model_Project__Z__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot($$x5, $$x4, $n($$x3).apply$extension__Ljapgolly_scalajs_react_Reusable__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF($$x2, $$x1, this$9.by_$eq$eq__F2()), $n(p).Lreactbuild_project_drawing_View$Props__f_context);
  var this$11 = $n(u);
  var n = this$11.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
  var $$x7 = new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$13 = $n($n(p).Lreactbuild_project_drawing_View$Props__f_tool);
  var pf = new $c_Lreactbuild_project_drawing_View$Backend$$anonfun$render$1(this);
  if ((!this$13.isEmpty__Z())) {
    var this$14 = new $c_s_PartialFunction$Lifted(pf);
    var v1 = this$13.get__O();
    var o = this$14.apply__O__s_Option(v1)
  } else {
    var o = $m_s_None$()
  };
  var O = $m_Ljapgolly_scalajs_react_util_OptionLike$().Ljapgolly_scalajs_react_util_OptionLike$__f_optionInstance;
  var array = [$$x10, $$x9, $$x8, $$x7, new $c_Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod$OptionExt(o, O).whenDefined__F1__Ljapgolly_scalajs_react_vdom_TagMod(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_project_drawing_UITool(x$1$2);
    var u$1 = $m_Lreactbuild_project_drawing_ToolControls$().apply__Lreactbuild_project_drawing_UITool__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_component_Js$UnmountedWithRoot(x$1, $n(p).Lreactbuild_project_drawing_View$Props__f_context);
    var this$18 = $n(u$1);
    var n$1 = this$18.raw__Ljapgolly_scalajs_react_facade_React$ComponentElement();
    return new $c_Ljapgolly_scalajs_react_vdom_VdomElement$$anon$1(n$1)
  })))];
  return $n($$x11).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lreactbuild_project_drawing_View$Backend.prototype.updateFullScreenMode__Ljapgolly_scalajs_react_callback_Trampoline = (function() {
  var this$3 = $n(this.Lreactbuild_project_drawing_View$Backend__f_$);
  var mod = new $c_sjsr_AnonFunction1(((x$2$2) => {
    var x$2 = $as_Lreactbuild_project_drawing_View$State(x$2$2);
    $n(x$2);
    var fullScreen = $m_Lreactbuild_project_drawing_View$().checkFullscreenMode__Z();
    return new $c_Lreactbuild_project_drawing_View$State(fullScreen)
  }));
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_StateAccess$ModState__modState__F1__O(this$3, mod))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
function $as_Lreactbuild_project_drawing_View$Backend(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_View$Backend) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.View$Backend"))
}
function $isArrayOf_Lreactbuild_project_drawing_View$Backend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_View$Backend)))
}
function $asArrayOf_Lreactbuild_project_drawing_View$Backend(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_View$Backend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.View$Backend;", depth))
}
var $d_Lreactbuild_project_drawing_View$Backend = new $TypeData().initClass({
  Lreactbuild_project_drawing_View$Backend: 0
}, false, "reactbuild.project.drawing.View$Backend", {
  Lreactbuild_project_drawing_View$Backend: 1,
  O: 1,
  Lcom_iz2use_react_components_DebounceSupport: 1,
  Ljapgolly_scalajs_react_extra_TimerSupport: 1,
  Ljapgolly_scalajs_react_extra_TimerSupportF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmountF: 1,
  Ljapgolly_scalajs_react_extra_OnUnmount: 1
});
$c_Lreactbuild_project_drawing_View$Backend.prototype.$classData = $d_Lreactbuild_project_drawing_View$Backend;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_DragPan$Active(pointerType, lastDistanceAndMidPoint, lastPoint) {
  this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType = null;
  this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastDistanceAndMidPoint = null;
  this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastPoint = null;
  this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType = pointerType;
  this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastDistanceAndMidPoint = lastDistanceAndMidPoint;
  this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastPoint = lastPoint
}
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_DragPan$Active;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_DragPan$Active() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype = $c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype;
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.updateTracked__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_interaction_DragPan$Active = (function(trackedPointers) {
  var newPoint = $n(trackedPointers).centroid__Lreactbuild_common_components_Input$CursorType__Lreactbuild_geom_Vector2Based(this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType);
  var x = this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType;
  var x$2 = $m_Lreactbuild_common_components_Input$Touch$();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $$x1 = (this$1 === x$2)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var nextDistance = $n(trackedPointers).touchDistance__s_Option()
  } else {
    var nextDistance = $m_s_None$()
  };
  var x$2$2 = new $c_s_Some(newPoint);
  var x$3 = this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType;
  return new $c_Lreactbuild_project_drawing_interaction_DragPan$Active(x$3, nextDistance, x$2$2)
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var way = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var coords = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_coords;
    var x = $n(coords).Lreactbuild_common_components_Input$Coords__f_cursor;
    var x$2 = this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ((!$$x1)) {
      return new $c_Lreactbuild_common_components_Continue(this, $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var x$3 = $m_Lreactbuild_common_components_Input$Start$();
      if ((x$3 === way)) {
        var next = this.updateTracked__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_interaction_DragPan$Active(trackedPointers);
        return new $c_Lreactbuild_common_components_Continue(next, $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
      } else {
        var x$5 = $m_Lreactbuild_common_components_Input$Move$();
        if ((x$5 === way)) {
          var next$2 = this.updateTracked__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_interaction_DragPan$Active(trackedPointers);
          var this$4 = $n(this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastPoint);
          if (this$4.isEmpty__Z()) {
            var deltaCBOpt = $m_s_None$()
          } else {
            var arg1 = this$4.get__O();
            var prev = $as_Lreactbuild_geom_Vector2Based(arg1);
            var this$5 = $n($n(next$2).Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastPoint);
            if (this$5.isEmpty__Z()) {
              var $$x2 = $m_s_None$()
            } else {
              var arg1$1 = this$5.get__O();
              var curr = $as_Lreactbuild_geom_Vector2Based(arg1$1);
              var this$6 = $n(curr);
              var delta = new $c_Lreactbuild_geom_Vector2((this$6.x__D() - $n(prev).x__D()), (this$6.y__D() - $n(prev).y__D()));
              var $$x2 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), curr, delta))
            };
            var this$7 = $n($$x2);
            if (this$7.isEmpty__Z()) {
              var deltaCBOpt = $m_s_None$()
            } else {
              var arg1$2 = this$7.get__O();
              var x$1 = $as_T2(arg1$2);
              if ((x$1 === null)) {
                throw new $c_s_MatchError(x$1)
              };
              var delta$1 = $as_Lreactbuild_geom_Vector2($n(x$1)._2__O());
              var this$8 = $n(context);
              var deltaCBOpt = new $c_s_Some(new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this$8.Lreactbuild_project_drawing_DrawingContextImpl__f_backend).Lreactbuild_project_drawing_DrawingContext$Backend__f_translate).apply__O__O(delta$1))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
            }
          };
          var this$9 = $n(this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastDistanceAndMidPoint);
          var p = new $c_sjsr_AnonFunction1(((check$ifrefutable$1$2) => {
            var check$ifrefutable$1 = $as_T2(check$ifrefutable$1$2);
            return (check$ifrefutable$1 !== null)
          }));
          var this$10 = new $c_s_Option$WithFilter(this$9, p);
          var this$11 = $n(this$10.s_Option$WithFilter__f_$outer);
          var p$1 = this$10.s_Option$WithFilter__f_p;
          var this$12 = $n(((this$11.isEmpty__Z() || $uZ($n(p$1).apply__O__O(this$11.get__O()))) ? this$11 : $m_s_None$()));
          if (this$12.isEmpty__Z()) {
            var zoomCBOpt = $m_s_None$()
          } else {
            var arg1$3 = this$12.get__O();
            var x$4$2 = $as_T2(arg1$3);
            if ((x$4$2 === null)) {
              throw new $c_s_MatchError(x$4$2)
            };
            var prev$1 = $n(x$4$2)._1$mcD$sp__D();
            var this$14 = $n($n(next$2).Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastDistanceAndMidPoint);
            var p$2 = new $c_sjsr_AnonFunction1(((check$ifrefutable$2$2) => {
              var check$ifrefutable$2 = $as_T2(check$ifrefutable$2$2);
              return (check$ifrefutable$2 !== null)
            }));
            var this$15 = $n(new $c_s_Option$WithFilter(this$14, p$2).withFilter__F1__s_Option$WithFilter(new $c_sjsr_AnonFunction1(((x$2$2) => {
              var x$2$1 = $as_T2(x$2$2);
              if ((x$2$1 !== null)) {
                return (prev$1 !== 0.0)
              } else {
                throw new $c_s_MatchError(x$2$1)
              }
            }))));
            var this$16 = $n(this$15.s_Option$WithFilter__f_$outer);
            var p$3 = this$15.s_Option$WithFilter__f_p;
            var this$17 = $n(((this$16.isEmpty__Z() || $uZ($n(p$3).apply__O__O(this$16.get__O()))) ? this$16 : $m_s_None$()));
            if (this$17.isEmpty__Z()) {
              var zoomCBOpt = $m_s_None$()
            } else {
              var arg1$4 = this$17.get__O();
              var x$3$1 = $as_T2(arg1$4);
              if ((x$3$1 === null)) {
                throw new $c_s_MatchError(x$3$1)
              };
              var curr$1 = $n(x$3$1)._1$mcD$sp__D();
              var pt = $as_Lreactbuild_geom_Vector2Based($n(x$3$1)._2__O());
              var this$18 = $n(context);
              var zoomCBOpt = new $c_s_Some(new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n($n(this$18.Lreactbuild_project_drawing_DrawingContextImpl__f_backend).Lreactbuild_project_drawing_DrawingContext$Backend__f_zoom).apply__O__O__O(pt, (curr$1 / prev$1)))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
            }
          };
          $m_Ljapgolly_scalajs_react_package$();
          var F = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
          var this$22 = $n(deltaCBOpt);
          var deltaCB = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo((this$22.isEmpty__Z() ? new $c_Ljapgolly_scalajs_react_callback_CallbackTo(F.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty) : this$22.get__O()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          $m_Ljapgolly_scalajs_react_package$();
          var F$1 = $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$();
          var this$26 = $n(zoomCBOpt);
          var zoomCB = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo((this$26.isEmpty__Z() ? new $c_Ljapgolly_scalajs_react_callback_CallbackTo(F$1.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty) : this$26.get__O()))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
          return new $c_Lreactbuild_common_components_Continue(next$2, $m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(zoomCB, deltaCB))
        } else {
          var x$7 = $m_Lreactbuild_common_components_Input$End$();
          if ((x$7 === way)) {
            var next$3 = this.updateTracked__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_interaction_DragPan$Active(trackedPointers);
            return (($n(trackedPointers).count__Lreactbuild_common_components_Input$CursorType__I(this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType) === 0) ? new $c_Lreactbuild_common_components_Done($m_Lreactbuild_project_drawing_interaction_DragPan$Idle$(), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty) : new $c_Lreactbuild_common_components_Continue(next$3, $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty))
          } else {
            return $m_Lreactbuild_common_components_Skip$()
          }
        }
      }
    }
  } else {
    return $m_Lreactbuild_common_components_Skip$()
  }
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.productPrefix__T = (function() {
  return "Active"
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastDistanceAndMidPoint;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastPoint;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_interaction_DragPan$Active)) {
    var Active$1 = $as_Lreactbuild_project_drawing_interaction_DragPan$Active(x$1);
    var x = this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType;
    var x$2 = $n(Active$1).Lreactbuild_project_drawing_interaction_DragPan$Active__f_pointerType;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastDistanceAndMidPoint;
      var x$4 = $n(Active$1).Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastDistanceAndMidPoint;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastPoint;
        var x$6 = $n(Active$1).Lreactbuild_project_drawing_interaction_DragPan$Active__f_lastPoint;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return this.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult(ev, trackedPointers, $as_Lreactbuild_project_drawing_DrawingContext(context))
});
function $as_Lreactbuild_project_drawing_interaction_DragPan$Active(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_interaction_DragPan$Active) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.interaction.DragPan$Active"))
}
function $isArrayOf_Lreactbuild_project_drawing_interaction_DragPan$Active(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_interaction_DragPan$Active)))
}
function $asArrayOf_Lreactbuild_project_drawing_interaction_DragPan$Active(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_interaction_DragPan$Active(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.interaction.DragPan$Active;", depth))
}
var $d_Lreactbuild_project_drawing_interaction_DragPan$Active = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_DragPan$Active: 0
}, false, "reactbuild.project.drawing.interaction.DragPan$Active", {
  Lreactbuild_project_drawing_interaction_DragPan$Active: 1,
  O: 1,
  Lreactbuild_project_drawing_interaction_DragPan: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Active.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_DragPan$Active;
/** @constructor */
function $c_Lreactbuild_project_drawing_interaction_DragPan$Idle$() {
  /*<skip>*/
}
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.constructor = $c_Lreactbuild_project_drawing_interaction_DragPan$Idle$;
/** @constructor */
function $h_Lreactbuild_project_drawing_interaction_DragPan$Idle$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype = $c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype;
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var p3 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var coords = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_coords;
    var p4 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_button;
    var p9 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
    var x = $m_Lreactbuild_common_components_Input$Start$();
    if ((x === p3)) {
      var x$3 = $m_Lreactbuild_common_components_Input$Left$();
      if ((x$3 === p4)) {
        var $$x2 = true
      } else {
        var x$5 = $m_Lreactbuild_common_components_Input$Middle$();
        var $$x2 = (x$5 === p4)
      };
      if ($$x2) {
        var x$7 = $m_Lreactbuild_common_components_Input$ModifierKey$None$();
        if ((x$7 === p9)) {
          var $$x3 = true
        } else {
          var x$9 = $m_Lreactbuild_common_components_Input$ModifierKey$Shift$();
          var $$x3 = (x$9 === p9)
        };
        if ($$x3) {
          var x$11 = $n(coords).Lreactbuild_common_components_Input$Coords__f_cursor;
          var x$12 = $m_Lreactbuild_common_components_Input$Touch$();
          if ((x$11 !== null)) {
            var this$1 = $n(x$11);
            var $$x4 = (this$1 === x$12)
          } else {
            var $$x4 = false
          };
          if ((!$$x4)) {
            var $$x1 = true
          } else {
            var $$x1 = ($n(trackedPointers).count__Lreactbuild_common_components_Input$CursorType__I($n(coords).Lreactbuild_common_components_Input$Coords__f_cursor) <= 2)
          }
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return new $c_Lreactbuild_common_components_Continue(new $c_Lreactbuild_project_drawing_interaction_DragPan$Active($n(coords).Lreactbuild_common_components_Input$Coords__f_cursor, $m_s_None$(), $m_s_None$()), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    }
  };
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.productPrefix__T = (function() {
  return "Idle"
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.hashCode__I = (function() {
  return 2274292
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.toString__T = (function() {
  return "Idle"
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__O__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  return this.handle__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult(ev, trackedPointers, $as_Lreactbuild_project_drawing_DrawingContext(context))
});
var $d_Lreactbuild_project_drawing_interaction_DragPan$Idle$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_interaction_DragPan$Idle$: 0
}, false, "reactbuild.project.drawing.interaction.DragPan$Idle$", {
  Lreactbuild_project_drawing_interaction_DragPan$Idle$: 1,
  O: 1,
  Lreactbuild_project_drawing_interaction_DragPan: 1,
  Lreactbuild_common_components_Interaction: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_interaction_DragPan$Idle$.prototype.$classData = $d_Lreactbuild_project_drawing_interaction_DragPan$Idle$;
var $n_Lreactbuild_project_drawing_interaction_DragPan$Idle$;
function $m_Lreactbuild_project_drawing_interaction_DragPan$Idle$() {
  if ((!$n_Lreactbuild_project_drawing_interaction_DragPan$Idle$)) {
    $n_Lreactbuild_project_drawing_interaction_DragPan$Idle$ = new $c_Lreactbuild_project_drawing_interaction_DragPan$Idle$()
  };
  return $n_Lreactbuild_project_drawing_interaction_DragPan$Idle$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_DebugInfo$() {
  this.Lreactbuild_project_drawing_tool_DebugInfo$__f_name = null;
  this.Lreactbuild_project_drawing_tool_DebugInfo$__f_icon = null;
  this.Lreactbuild_project_drawing_tool_DebugInfo$__f_state = null;
  $n_Lreactbuild_project_drawing_tool_DebugInfo$ = this;
  this.Lreactbuild_project_drawing_tool_DebugInfo$__f_name = "Informations de d\u00e9bogage";
  this.Lreactbuild_project_drawing_tool_DebugInfo$__f_icon = "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z";
  this.Lreactbuild_project_drawing_tool_DebugInfo$__f_state = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_project_drawing_DrawingContext(x$1$2);
    return $n(x$1).Lreactbuild_project_drawing_DrawingContextImpl__f_debug
  }))
}
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.constructor = $c_Lreactbuild_project_drawing_tool_DebugInfo$;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_DebugInfo$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_DebugInfo$.prototype = $c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype;
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_DebugInfo$__f_name
});
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_DebugInfo$__f_icon
});
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.state__F1 = (function() {
  return this.Lreactbuild_project_drawing_tool_DebugInfo$__f_state
});
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.productPrefix__T = (function() {
  return "DebugInfo"
});
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.hashCode__I = (function() {
  return 1805397377
});
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.toString__T = (function() {
  return "DebugInfo"
});
var $d_Lreactbuild_project_drawing_tool_DebugInfo$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_DebugInfo$: 0
}, false, "reactbuild.project.drawing.tool.DebugInfo$", {
  Lreactbuild_project_drawing_tool_DebugInfo$: 1,
  O: 1,
  Lreactbuild_project_drawing_ToggleTool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_DebugInfo$.prototype.$classData = $d_Lreactbuild_project_drawing_tool_DebugInfo$;
var $n_Lreactbuild_project_drawing_tool_DebugInfo$;
function $m_Lreactbuild_project_drawing_tool_DebugInfo$() {
  if ((!$n_Lreactbuild_project_drawing_tool_DebugInfo$)) {
    $n_Lreactbuild_project_drawing_tool_DebugInfo$ = new $c_Lreactbuild_project_drawing_tool_DebugInfo$()
  };
  return $n_Lreactbuild_project_drawing_tool_DebugInfo$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_LayerSelection$() {
  this.Lreactbuild_project_drawing_tool_LayerSelection$__f_name = null;
  this.Lreactbuild_project_drawing_tool_LayerSelection$__f_icon = null;
  this.Lreactbuild_project_drawing_tool_LayerSelection$__f_layers = null;
  $n_Lreactbuild_project_drawing_tool_LayerSelection$ = this;
  this.Lreactbuild_project_drawing_tool_LayerSelection$__f_name = "Calques";
  this.Lreactbuild_project_drawing_tool_LayerSelection$__f_icon = "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z";
  $n($m_s_package$().s_package$__f_List);
  var y = $m_Lreactbuild_project_drawing_Wall$();
  var $$x4 = $ct_T2__O__O__(new $c_T2(), "Murs", y);
  var y$1 = $m_Lreactbuild_project_drawing_Joinery$();
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "Menuiseries", y$1);
  var y$2 = $m_Lreactbuild_project_drawing_Furniture$();
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "Ameublements", y$2);
  var y$3 = $m_Lreactbuild_project_drawing_KitchenFurniture$();
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "Cuisine", y$3);
  var y$4 = $m_Lreactbuild_project_drawing_InternalDistributionNetwork$();
  var array = [$$x4, $$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "R\u00e9seaux : Distribution int\u00e9rieure", y$4)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_project_drawing_tool_LayerSelection$__f_layers = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
}
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.constructor = $c_Lreactbuild_project_drawing_tool_LayerSelection$;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_LayerSelection$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_LayerSelection$.prototype = $c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype;
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_LayerSelection$__f_name
});
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_LayerSelection$__f_icon
});
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.render__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_TagOf = (function(context) {
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = this.Lreactbuild_project_drawing_tool_LayerSelection$__f_layers;
  var array$1 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var name = $as_T($n(x0$1)._1__O());
      var part = $as_s_Product($n(x0$1)._2__O());
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var label = new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(name);
      var this$9 = $n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_layers);
      var g = new $c_sjsr_AnonFunction1(((v$2) => {
        var v = $uZ(v$2);
        return new $c_sjsr_AnonFunction1(((x$2$2) => {
          var x$2 = $as_Lreactbuild_project_drawing_Layers(x$2$2);
          return $n(x$2).withLayer__Lreactbuild_project_drawing_BuildingPart__Z__Lreactbuild_project_drawing_Layers($as_Lreactbuild_project_drawing_BuildingPart(part), v)
        }))
      }));
      var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$9.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
      var arg1 = this$9.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var x$1 = $as_Lreactbuild_project_drawing_Layers(arg1);
      var state = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$9, (!$n($n(x$1).Lreactbuild_project_drawing_Layers__f_layers).contains__O__Z(part)), new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
        var ot = $as_s_Option(ot$2);
        var $$x2 = $n($as_F2($n(this$9.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
        var this$10 = $n(ot);
        return $n($$x2).apply__O__O__O((this$10.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$10.get__O()))), cb$2)
      })));
      var evDefault = $m_Lcom_iz2use_react_components_internal_Default$BooleanDefault$();
      var optioner = new $c_Lcom_iz2use_react_components_internal_SomeOptioner(evDefault);
      var parser = $m_Lcom_iz2use_common_Parsable$().Lcom_iz2use_common_Parsable$__f_parsableBoolean;
      var ev = new $c_Lcom_iz2use_common_Resolver$$anon$1(parser);
      var editorComponent = $m_Lcom_iz2use_react_components_ConcreteEditorComponent$().Lcom_iz2use_react_components_ConcreteEditorComponent$__f_checkboxComponent;
      var explainError = new $c_Lcom_iz2use_react_components_ExplainError$$anon$2();
      var equiv = $m_s_math_Equiv$Boolean$();
      var this$15 = $n(editorComponent);
      var array = [this$15.apply__Ljapgolly_scalajs_react_vdom_TagMod__Ljapgolly_scalajs_react_extra_StateSnapshotF__Lcom_iz2use_react_components_internal_Optioner__Lcom_iz2use_common_Resolver__Lcom_iz2use_react_components_ExplainError__s_math_Equiv__Ljapgolly_scalajs_react_vdom_VdomElement(label, state, optioner, ev, explainError, equiv)];
      return $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))];
  return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.productPrefix__T = (function() {
  return "LayerSelection"
});
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.hashCode__I = (function() {
  return (-1467092133)
});
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.toString__T = (function() {
  return "LayerSelection"
});
var $d_Lreactbuild_project_drawing_tool_LayerSelection$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_LayerSelection$: 0
}, false, "reactbuild.project.drawing.tool.LayerSelection$", {
  Lreactbuild_project_drawing_tool_LayerSelection$: 1,
  O: 1,
  Lreactbuild_project_drawing_UITool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_LayerSelection$.prototype.$classData = $d_Lreactbuild_project_drawing_tool_LayerSelection$;
var $n_Lreactbuild_project_drawing_tool_LayerSelection$;
function $m_Lreactbuild_project_drawing_tool_LayerSelection$() {
  if ((!$n_Lreactbuild_project_drawing_tool_LayerSelection$)) {
    $n_Lreactbuild_project_drawing_tool_LayerSelection$ = new $c_Lreactbuild_project_drawing_tool_LayerSelection$()
  };
  return $n_Lreactbuild_project_drawing_tool_LayerSelection$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_Ruler(position, activePointer) {
  this.Lreactbuild_project_drawing_tool_Ruler__f_position = null;
  this.Lreactbuild_project_drawing_tool_Ruler__f_activePointer = null;
  this.Lreactbuild_project_drawing_tool_Ruler__f_name = null;
  this.Lreactbuild_project_drawing_tool_Ruler__f_icon = null;
  this.Lreactbuild_project_drawing_tool_Ruler__f_position = position;
  this.Lreactbuild_project_drawing_tool_Ruler__f_activePointer = activePointer;
  this.Lreactbuild_project_drawing_tool_Ruler__f_name = "R\u00e8gle";
  this.Lreactbuild_project_drawing_tool_Ruler__f_icon = "M17.66,17.66l-1.06,1.06l-0.71-0.71l1.06-1.06l-1.94-1.94l-1.06,1.06l-0.71-0.71l1.06-1.06l-1.94-1.94l-1.06,1.06 l-0.71-0.71l1.06-1.06L9.7,9.7l-1.06,1.06l-0.71-0.71l1.06-1.06L7.05,7.05L5.99,8.11L5.28,7.4l1.06-1.06L4,4v14c0,1.1,0.9,2,2,2 h14L17.66,17.66z M7,17v-5.76L12.76,17H7z"
}
$c_Lreactbuild_project_drawing_tool_Ruler.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.constructor = $c_Lreactbuild_project_drawing_tool_Ruler;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_Ruler() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_Ruler.prototype = $c_Lreactbuild_project_drawing_tool_Ruler.prototype;
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_Ruler__f_name
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_Ruler__f_icon
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.handleViewportEvent__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  var f = ((ev$2$2) => {
    var ev$2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev$2$2);
    var x1 = $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var x = $m_Lreactbuild_common_components_Input$Start$();
    if (((x === x1) && $n(this.Lreactbuild_project_drawing_tool_Ruler__f_activePointer).isEmpty__Z())) {
      var self = $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_id;
      var y = $n($n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_coords).Lreactbuild_common_components_Input$Coords__f_cursor;
      var x$1 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, y));
      var x$2$2 = this.Lreactbuild_project_drawing_tool_Ruler__f_position;
      return new $c_Lreactbuild_common_components_Continue(new $c_s_Some(new $c_Lreactbuild_project_drawing_tool_Ruler(x$2$2, x$1)), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var x$3 = $m_Lreactbuild_common_components_Input$Move$();
      if ((x$3 === x1)) {
        var this$5 = $n(this.Lreactbuild_project_drawing_tool_Ruler__f_activePointer);
        if ((!this$5.isEmpty__Z())) {
          var arg1 = this$5.get__O();
          var x$1$2 = $as_T2(arg1);
          var $$x1 = ($n(x$1$2)._1$mcD$sp__D() === $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_id)
        } else {
          var $$x1 = false
        }
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var realCoords = $as_Lreactbuild_geom_Point2Based($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition).apply__O__O($n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_coords));
        var position = new $c_s_Some(realCoords);
        var activePointer = this.Lreactbuild_project_drawing_tool_Ruler__f_activePointer;
        return new $c_Lreactbuild_common_components_Continue(new $c_s_Some(new $c_Lreactbuild_project_drawing_tool_Ruler(position, activePointer)), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
      } else {
        var x$5 = $m_Lreactbuild_common_components_Input$End$();
        if ((x$5 === x1)) {
          var this$7 = $n(this.Lreactbuild_project_drawing_tool_Ruler__f_activePointer);
          if ((!this$7.isEmpty__Z())) {
            var arg1$1 = this$7.get__O();
            var x$2$3 = $as_T2(arg1$1);
            var $$x2 = ($n(x$2$3)._1$mcD$sp__D() === $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_id)
          } else {
            var $$x2 = false
          }
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          var x$3$2 = $m_s_None$();
          var x$4$2 = this.Lreactbuild_project_drawing_tool_Ruler__f_position;
          return new $c_Lreactbuild_common_components_Done(new $c_s_Some(new $c_Lreactbuild_project_drawing_tool_Ruler(x$4$2, x$3$2)), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
        } else {
          return $m_Lreactbuild_common_components_Skip$()
        }
      }
    }
  });
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var way = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var coords = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_coords;
    var p3 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_isPrimary;
    var button = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_button;
    var p8 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
    if ((p3 === true)) {
      var x$2 = $m_Lreactbuild_common_components_Input$ModifierKey$None$();
      var $$x3 = (x$2 === p8)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$3$1 = $m_Lreactbuild_common_components_Input$Start$();
      if ((x$3$1 === way)) {
        var x$6 = $m_Lreactbuild_common_components_Input$Left$();
        if ((button !== null)) {
          var this$10 = $n(button);
          var $$x4 = (this$10 === x$6)
        } else {
          var $$x4 = false
        }
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        return $as_Lreactbuild_common_components_InteractionResult(f(x2))
      } else {
        var x$7 = $m_Lreactbuild_common_components_Input$Move$();
        if ((x$7 === way)) {
          var x$9 = $n(coords).Lreactbuild_common_components_Input$Coords__f_cursor;
          var x$10 = $m_Lreactbuild_common_components_Input$Touch$();
          if ((x$9 !== null)) {
            var this$11 = $n(x$9);
            var $$x6 = (this$11 === x$10)
          } else {
            var $$x6 = false
          };
          if ((!$$x6)) {
            var $$x5 = true
          } else {
            var $$x5 = ($n(trackedPointers).count__Lreactbuild_common_components_Input$CursorType__I($n(coords).Lreactbuild_common_components_Input$Coords__f_cursor) === 1)
          }
        } else {
          var $$x5 = false
        };
        if ($$x5) {
          return $as_Lreactbuild_common_components_InteractionResult(f(x2))
        } else {
          var x$11 = $m_Lreactbuild_common_components_Input$End$();
          if ((x$11 === way)) {
            return $as_Lreactbuild_common_components_InteractionResult(f(x2))
          } else {
            return $m_Lreactbuild_common_components_Skip$()
          }
        }
      }
    }
  };
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.renderInViewport__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(context) {
  var this$1 = $n(this.Lreactbuild_project_drawing_tool_Ruler__f_position);
  if (this$1.isEmpty__Z()) {
    return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  } else {
    var arg1 = this$1.get__O();
    var position = $as_Lreactbuild_geom_Vector2Based(arg1);
    var x1 = $n($n($n($as_Lreactbuild_format_iz2use_package$Building($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_building).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_format_iz2use_package$Building__f_storeys).take__I__sci_List(1)).headOption__s_Option();
    if ((x1 instanceof $c_s_Some)) {
      var x2 = $as_s_Some(x1);
      var storey = $as_Lreactbuild_format_iz2use_package$Storey($n(x2).s_Some__f_value);
      var this$2 = $n(position);
      var pt = new $c_Lreactbuild_geom_Point2(this$2.x__D(), this$2.y__D());
      var this$3 = $n(context);
      this$3.atScale__Lreactbuild_geom_Vector2Based__Lreactbuild_geom_Vector2(pt);
      var this$5 = $n($n(storey).Lreactbuild_format_iz2use_package$Storey__f_rooms);
      var f = ((x$3$2) => {
        var x$3 = $as_Lreactbuild_format_iz2use_package$Room(x$3$2);
        return $n(x$3).shape__sci_List()
      });
      if ((this$5 === $m_sci_Nil$())) {
        var roomShapes = $m_sci_Nil$()
      } else {
        var arg1$1 = this$5.head__O();
        var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$5.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O())
        };
        var roomShapes = h
      };
      var this$16 = $m_Lreactbuild_project_drawing_ProjectSegmentOnRulers$();
      var rassoc$1 = $n(storey).shape__sci_List();
      var this$6 = $n($m_s_package$().s_package$__f_Nil);
      var baseShape = new $c_sci_$colon$colon(rassoc$1, this$6);
      var $$x3 = $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_X_AXIS;
      var array = [pt];
      var $$x2 = new $c_Lreactbuild_project_drawing_OrientedRulers($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
      var $$x1 = $m_Lreactbuild_geom_Vector2$().Lreactbuild_geom_Vector2$__f_Y_AXIS;
      var array$1 = [pt];
      var array$2 = [$$x2, new $c_Lreactbuild_project_drawing_OrientedRulers($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
      var rulers = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      return $p_Lreactbuild_project_drawing_ProjectSegmentOnRulers$__classifyOnRulers$1__sci_List__sci_List__sci_Map__sci_List__sci_Seq__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode(this$16, $n(roomShapes).$colon$colon$colon__sci_List__sci_List(baseShape), $m_s_package$().s_package$__f_Nil, ($n($m_s_Predef$().s_Predef$__f_Map), $m_sci_Map$EmptyMap$()), $m_s_package$().s_package$__f_Nil, rulers, context)
    } else {
      var x = $m_s_None$();
      if ((!(x === x1))) {
        throw new $c_s_MatchError(x1)
      };
      return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
    }
  }
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.productPrefix__T = (function() {
  return "Ruler"
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_tool_Ruler__f_position;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_tool_Ruler__f_activePointer;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_tool_Ruler)) {
    var Ruler$1 = $as_Lreactbuild_project_drawing_tool_Ruler(x$1);
    var x = this.Lreactbuild_project_drawing_tool_Ruler__f_position;
    var x$2 = $n(Ruler$1).Lreactbuild_project_drawing_tool_Ruler__f_position;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_drawing_tool_Ruler__f_activePointer;
      var x$4 = $n(Ruler$1).Lreactbuild_project_drawing_tool_Ruler__f_activePointer;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_tool_Ruler(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_tool_Ruler) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.tool.Ruler"))
}
function $isArrayOf_Lreactbuild_project_drawing_tool_Ruler(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_tool_Ruler)))
}
function $asArrayOf_Lreactbuild_project_drawing_tool_Ruler(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_tool_Ruler(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.tool.Ruler;", depth))
}
var $d_Lreactbuild_project_drawing_tool_Ruler = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_Ruler: 0
}, false, "reactbuild.project.drawing.tool.Ruler", {
  Lreactbuild_project_drawing_tool_Ruler: 1,
  O: 1,
  Lreactbuild_project_drawing_ViewportTool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_Ruler.prototype.$classData = $d_Lreactbuild_project_drawing_tool_Ruler;
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_StyleSelection$() {
  this.Lreactbuild_project_drawing_tool_StyleSelection$__f_name = null;
  this.Lreactbuild_project_drawing_tool_StyleSelection$__f_icon = null;
  this.Lreactbuild_project_drawing_tool_StyleSelection$__f_styles = null;
  $n_Lreactbuild_project_drawing_tool_StyleSelection$ = this;
  this.Lreactbuild_project_drawing_tool_StyleSelection$__f_name = "Styles";
  this.Lreactbuild_project_drawing_tool_StyleSelection$__f_icon = "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z";
  $n($m_s_package$().s_package$__f_List);
  var y = $m_Lreactbuild_project_drawing_Theme$().Lreactbuild_project_drawing_Theme$__f_defaultTheme;
  var $$x3 = $ct_T2__O__O__(new $c_T2(), "Menuiseries", y);
  var y$1 = $m_Lreactbuild_project_drawing_Theme$().Lreactbuild_project_drawing_Theme$__f_walls;
  var $$x2 = $ct_T2__O__O__(new $c_T2(), "Murs", y$1);
  var y$2 = $m_Lreactbuild_project_drawing_Theme$().Lreactbuild_project_drawing_Theme$__f_furnitures;
  var $$x1 = $ct_T2__O__O__(new $c_T2(), "Ameublements", y$2);
  var y$3 = $m_Lreactbuild_project_drawing_Theme$().Lreactbuild_project_drawing_Theme$__f_network;
  var array = [$$x3, $$x2, $$x1, $ct_T2__O__O__(new $c_T2(), "R\u00e9seaux : distribution int\u00e9rieur", y$3)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.Lreactbuild_project_drawing_tool_StyleSelection$__f_styles = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
}
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.constructor = $c_Lreactbuild_project_drawing_tool_StyleSelection$;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_StyleSelection$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_StyleSelection$.prototype = $c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype;
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_StyleSelection$__f_name
});
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_StyleSelection$__f_icon
});
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.render__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_TagOf = (function(context) {
  $as_Lreactbuild_project_drawing_Theme($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_theme).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value);
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode$TraversableOnceExt$();
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var as = this.Lreactbuild_project_drawing_tool_StyleSelection$__f_styles;
  var array$2 = [$n($$x1).toTagMod$extension__sc_IterableOnce__F1__Ljapgolly_scalajs_react_vdom_TagMod(as, new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var name = $as_T($n(x0$1)._1__O());
      var theme = $as_Lreactbuild_project_drawing_Theme($n(x0$1)._2__O());
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
      $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
      $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
      var $$x3 = $m_Lcom_iz2use_react_components_Link$();
      var this$7 = $n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_theme);
      var callback = new $c_sjsr_AnonFunction0((() => {
        var this$8 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
        var this$9 = $n(this$8.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
        return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(this$9.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty)
      }));
      var this$10 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
      var G = this$10.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync;
      var arg1 = this$7.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      $as_Lreactbuild_project_drawing_Theme(arg1);
      var $$x2 = $n($$x3).apply__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_vdom_TagOf($n($as_Ljapgolly_scalajs_react_callback_CallbackTo(this$7.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_s_Some(theme), callback, G))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline);
      var array = [($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$(), $m_Ljapgolly_scalajs_react_vdom_VdomNode$(), new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(name))];
      var array$1 = [$n($$x2).apply__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
      return $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  })))];
  return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.productPrefix__T = (function() {
  return "StyleSelection"
});
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.hashCode__I = (function() {
  return 870192891
});
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.toString__T = (function() {
  return "StyleSelection"
});
var $d_Lreactbuild_project_drawing_tool_StyleSelection$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_StyleSelection$: 0
}, false, "reactbuild.project.drawing.tool.StyleSelection$", {
  Lreactbuild_project_drawing_tool_StyleSelection$: 1,
  O: 1,
  Lreactbuild_project_drawing_UITool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_StyleSelection$.prototype.$classData = $d_Lreactbuild_project_drawing_tool_StyleSelection$;
var $n_Lreactbuild_project_drawing_tool_StyleSelection$;
function $m_Lreactbuild_project_drawing_tool_StyleSelection$() {
  if ((!$n_Lreactbuild_project_drawing_tool_StyleSelection$)) {
    $n_Lreactbuild_project_drawing_tool_StyleSelection$ = new $c_Lreactbuild_project_drawing_tool_StyleSelection$()
  };
  return $n_Lreactbuild_project_drawing_tool_StyleSelection$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$() {
  this.Lreactbuild_project_drawing_tool_SwitchAccessibleArea$__f_name = null;
  this.Lreactbuild_project_drawing_tool_SwitchAccessibleArea$__f_icon = null;
  this.Lreactbuild_project_drawing_tool_SwitchAccessibleArea$__f_state = null;
  $n_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$ = this;
  this.Lreactbuild_project_drawing_tool_SwitchAccessibleArea$__f_name = "Afficher les zones d'accessibilit\u00e9";
  this.Lreactbuild_project_drawing_tool_SwitchAccessibleArea$__f_icon = "M12 2 A 2 2 0 0 0 10 4 A 2 2 0 0 0 12 6 A 2 2 0 0 0 14 4 A 2 2 0 0 0 12 2 z M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z";
  this.Lreactbuild_project_drawing_tool_SwitchAccessibleArea$__f_state = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_project_drawing_DrawingContext(x$1$2);
    return $n(x$1).Lreactbuild_project_drawing_DrawingContextImpl__f_accessibleArea
  }))
}
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.constructor = $c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype = $c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype;
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_SwitchAccessibleArea$__f_name
});
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_SwitchAccessibleArea$__f_icon
});
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.state__F1 = (function() {
  return this.Lreactbuild_project_drawing_tool_SwitchAccessibleArea$__f_state
});
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.productPrefix__T = (function() {
  return "SwitchAccessibleArea"
});
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.hashCode__I = (function() {
  return (-601677353)
});
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.toString__T = (function() {
  return "SwitchAccessibleArea"
});
var $d_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_SwitchAccessibleArea$: 0
}, false, "reactbuild.project.drawing.tool.SwitchAccessibleArea$", {
  Lreactbuild_project_drawing_tool_SwitchAccessibleArea$: 1,
  O: 1,
  Lreactbuild_project_drawing_ToggleTool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$.prototype.$classData = $d_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$;
var $n_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$;
function $m_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$() {
  if ((!$n_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$)) {
    $n_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$ = new $c_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$()
  };
  return $n_Lreactbuild_project_drawing_tool_SwitchAccessibleArea$
}
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_SwitchLightArea$() {
  this.Lreactbuild_project_drawing_tool_SwitchLightArea$__f_name = null;
  this.Lreactbuild_project_drawing_tool_SwitchLightArea$__f_icon = null;
  this.Lreactbuild_project_drawing_tool_SwitchLightArea$__f_state = null;
  $n_Lreactbuild_project_drawing_tool_SwitchLightArea$ = this;
  this.Lreactbuild_project_drawing_tool_SwitchLightArea$__f_name = "Afficher les zones d'\u00e9clairage";
  this.Lreactbuild_project_drawing_tool_SwitchLightArea$__f_icon = "M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z";
  this.Lreactbuild_project_drawing_tool_SwitchLightArea$__f_state = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_Lreactbuild_project_drawing_DrawingContext(x$1$2);
    return $n(x$1).Lreactbuild_project_drawing_DrawingContextImpl__f_lightArea
  }))
}
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.constructor = $c_Lreactbuild_project_drawing_tool_SwitchLightArea$;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_SwitchLightArea$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype = $c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype;
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_SwitchLightArea$__f_name
});
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_SwitchLightArea$__f_icon
});
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.state__F1 = (function() {
  return this.Lreactbuild_project_drawing_tool_SwitchLightArea$__f_state
});
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.productPrefix__T = (function() {
  return "SwitchLightArea"
});
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.hashCode__I = (function() {
  return (-486016561)
});
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.toString__T = (function() {
  return "SwitchLightArea"
});
var $d_Lreactbuild_project_drawing_tool_SwitchLightArea$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_SwitchLightArea$: 0
}, false, "reactbuild.project.drawing.tool.SwitchLightArea$", {
  Lreactbuild_project_drawing_tool_SwitchLightArea$: 1,
  O: 1,
  Lreactbuild_project_drawing_ToggleTool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_SwitchLightArea$.prototype.$classData = $d_Lreactbuild_project_drawing_tool_SwitchLightArea$;
var $n_Lreactbuild_project_drawing_tool_SwitchLightArea$;
function $m_Lreactbuild_project_drawing_tool_SwitchLightArea$() {
  if ((!$n_Lreactbuild_project_drawing_tool_SwitchLightArea$)) {
    $n_Lreactbuild_project_drawing_tool_SwitchLightArea$ = new $c_Lreactbuild_project_drawing_tool_SwitchLightArea$()
  };
  return $n_Lreactbuild_project_drawing_tool_SwitchLightArea$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2(outer) {
  /*<skip>*/
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2.prototype = new $h_O();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$anon$lazy$macro$25$1$$anon$2", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_project_notebook_AddressType$() {
  /*<skip>*/
}
$c_Lreactbuild_project_notebook_AddressType$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_AddressType$.prototype.constructor = $c_Lreactbuild_project_notebook_AddressType$;
/** @constructor */
function $h_Lreactbuild_project_notebook_AddressType$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_AddressType$.prototype = $c_Lreactbuild_project_notebook_AddressType$.prototype;
$c_Lreactbuild_project_notebook_AddressType$.prototype.productPrefix__T = (function() {
  return "AddressType"
});
$c_Lreactbuild_project_notebook_AddressType$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_notebook_AddressType$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_notebook_AddressType$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_AddressType$.prototype.hashCode__I = (function() {
  return 290598190
});
$c_Lreactbuild_project_notebook_AddressType$.prototype.toString__T = (function() {
  return "AddressType"
});
var $d_Lreactbuild_project_notebook_AddressType$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_AddressType$: 0
}, false, "reactbuild.project.notebook.AddressType$", {
  Lreactbuild_project_notebook_AddressType$: 1,
  O: 1,
  Lreactbuild_project_notebook_InputType$Generic: 1,
  Lreactbuild_project_notebook_InputType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_AddressType$.prototype.$classData = $d_Lreactbuild_project_notebook_AddressType$;
var $n_Lreactbuild_project_notebook_AddressType$;
function $m_Lreactbuild_project_notebook_AddressType$() {
  if ((!$n_Lreactbuild_project_notebook_AddressType$)) {
    $n_Lreactbuild_project_notebook_AddressType$ = new $c_Lreactbuild_project_notebook_AddressType$()
  };
  return $n_Lreactbuild_project_notebook_AddressType$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_Cell$JSON(name, source, output) {
  this.Lreactbuild_project_notebook_Cell$JSON__f_name = null;
  this.Lreactbuild_project_notebook_Cell$JSON__f_source = null;
  this.Lreactbuild_project_notebook_Cell$JSON__f_name = name;
  this.Lreactbuild_project_notebook_Cell$JSON__f_source = source
}
$c_Lreactbuild_project_notebook_Cell$JSON.prototype = new $h_O();
$c_Lreactbuild_project_notebook_Cell$JSON.prototype.constructor = $c_Lreactbuild_project_notebook_Cell$JSON;
/** @constructor */
function $h_Lreactbuild_project_notebook_Cell$JSON() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_Cell$JSON.prototype = $c_Lreactbuild_project_notebook_Cell$JSON.prototype;
$c_Lreactbuild_project_notebook_Cell$JSON.prototype.productPrefix__T = (function() {
  return "JSON"
});
$c_Lreactbuild_project_notebook_Cell$JSON.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_notebook_Cell$JSON.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_Cell$JSON__f_name;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_Cell$JSON__f_source;
      break
    }
    case 2: {
      return (void 0);
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_Cell$JSON.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_Cell$JSON.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("JSON");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_notebook_Cell$JSON__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_project_notebook_Cell$JSON__f_source;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, 0);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lreactbuild_project_notebook_Cell$JSON.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_Cell$JSON.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_Cell$JSON)) {
    var JSON$1 = $as_Lreactbuild_project_notebook_Cell$JSON(x$1);
    if ((this.Lreactbuild_project_notebook_Cell$JSON__f_name === $n(JSON$1).Lreactbuild_project_notebook_Cell$JSON__f_name)) {
      var x = this.Lreactbuild_project_notebook_Cell$JSON__f_source;
      var x$2 = $n(JSON$1).Lreactbuild_project_notebook_Cell$JSON__f_source;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_Cell$JSON(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_Cell$JSON) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.Cell$JSON"))
}
function $isArrayOf_Lreactbuild_project_notebook_Cell$JSON(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_Cell$JSON)))
}
function $asArrayOf_Lreactbuild_project_notebook_Cell$JSON(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_Cell$JSON(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.Cell$JSON;", depth))
}
var $d_Lreactbuild_project_notebook_Cell$JSON = new $TypeData().initClass({
  Lreactbuild_project_notebook_Cell$JSON: 0
}, false, "reactbuild.project.notebook.Cell$JSON", {
  Lreactbuild_project_notebook_Cell$JSON: 1,
  O: 1,
  Lreactbuild_project_notebook_Cell$GenCell: 1,
  Lreactbuild_project_notebook_Cell: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_Cell$JSON.prototype.$classData = $d_Lreactbuild_project_notebook_Cell$JSON;
/** @constructor */
function $c_Lreactbuild_project_notebook_ChecklistOnMap(id, source, layers, points) {
  this.Lreactbuild_project_notebook_ChecklistOnMap__f_id = null;
  this.Lreactbuild_project_notebook_ChecklistOnMap__f_source = null;
  this.Lreactbuild_project_notebook_ChecklistOnMap__f_layers = null;
  this.Lreactbuild_project_notebook_ChecklistOnMap__f_points = null;
  this.Lreactbuild_project_notebook_ChecklistOnMap__f_id = id;
  this.Lreactbuild_project_notebook_ChecklistOnMap__f_source = source;
  this.Lreactbuild_project_notebook_ChecklistOnMap__f_layers = layers;
  this.Lreactbuild_project_notebook_ChecklistOnMap__f_points = points
}
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype = new $h_O();
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype.constructor = $c_Lreactbuild_project_notebook_ChecklistOnMap;
/** @constructor */
function $h_Lreactbuild_project_notebook_ChecklistOnMap() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_ChecklistOnMap.prototype = $c_Lreactbuild_project_notebook_ChecklistOnMap.prototype;
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype.productPrefix__T = (function() {
  return "ChecklistOnMap"
});
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_ChecklistOnMap__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_ChecklistOnMap__f_source;
      break
    }
    case 2: {
      return this.Lreactbuild_project_notebook_ChecklistOnMap__f_layers;
      break
    }
    case 3: {
      return this.Lreactbuild_project_notebook_ChecklistOnMap__f_points;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_ChecklistOnMap)) {
    var ChecklistOnMap$1 = $as_Lreactbuild_project_notebook_ChecklistOnMap(x$1);
    var x = this.Lreactbuild_project_notebook_ChecklistOnMap__f_id;
    var x$2 = $n(ChecklistOnMap$1).Lreactbuild_project_notebook_ChecklistOnMap__f_id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_project_notebook_ChecklistOnMap__f_source === $n(ChecklistOnMap$1).Lreactbuild_project_notebook_ChecklistOnMap__f_source))) {
      var x$3 = this.Lreactbuild_project_notebook_ChecklistOnMap__f_layers;
      var x$4 = $n(ChecklistOnMap$1).Lreactbuild_project_notebook_ChecklistOnMap__f_layers;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_project_notebook_ChecklistOnMap__f_points;
        var x$6 = $n(ChecklistOnMap$1).Lreactbuild_project_notebook_ChecklistOnMap__f_points;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_ChecklistOnMap(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_ChecklistOnMap) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.ChecklistOnMap"))
}
function $isArrayOf_Lreactbuild_project_notebook_ChecklistOnMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_ChecklistOnMap)))
}
function $asArrayOf_Lreactbuild_project_notebook_ChecklistOnMap(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_ChecklistOnMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.ChecklistOnMap;", depth))
}
var $d_Lreactbuild_project_notebook_ChecklistOnMap = new $TypeData().initClass({
  Lreactbuild_project_notebook_ChecklistOnMap: 0
}, false, "reactbuild.project.notebook.ChecklistOnMap", {
  Lreactbuild_project_notebook_ChecklistOnMap: 1,
  O: 1,
  Lreactbuild_project_notebook_CellConfig$AbstractCellConfig: 1,
  Lreactbuild_project_notebook_CellConfig: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_ChecklistOnMap.prototype.$classData = $d_Lreactbuild_project_notebook_ChecklistOnMap;
/** @constructor */
function $c_Lreactbuild_project_notebook_FindAndSelectParcels(id, source, findTitle, selectTitle) {
  this.Lreactbuild_project_notebook_FindAndSelectParcels__f_id = null;
  this.Lreactbuild_project_notebook_FindAndSelectParcels__f_source = null;
  this.Lreactbuild_project_notebook_FindAndSelectParcels__f_findTitle = null;
  this.Lreactbuild_project_notebook_FindAndSelectParcels__f_selectTitle = null;
  this.Lreactbuild_project_notebook_FindAndSelectParcels__f_id = id;
  this.Lreactbuild_project_notebook_FindAndSelectParcels__f_source = source;
  this.Lreactbuild_project_notebook_FindAndSelectParcels__f_findTitle = findTitle;
  this.Lreactbuild_project_notebook_FindAndSelectParcels__f_selectTitle = selectTitle
}
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype = new $h_O();
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype.constructor = $c_Lreactbuild_project_notebook_FindAndSelectParcels;
/** @constructor */
function $h_Lreactbuild_project_notebook_FindAndSelectParcels() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_FindAndSelectParcels.prototype = $c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype;
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype.productPrefix__T = (function() {
  return "FindAndSelectParcels"
});
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_FindAndSelectParcels__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_FindAndSelectParcels__f_source;
      break
    }
    case 2: {
      return this.Lreactbuild_project_notebook_FindAndSelectParcels__f_findTitle;
      break
    }
    case 3: {
      return this.Lreactbuild_project_notebook_FindAndSelectParcels__f_selectTitle;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_FindAndSelectParcels)) {
    var FindAndSelectParcels$1 = $as_Lreactbuild_project_notebook_FindAndSelectParcels(x$1);
    var x = this.Lreactbuild_project_notebook_FindAndSelectParcels__f_id;
    var x$2 = $n(FindAndSelectParcels$1).Lreactbuild_project_notebook_FindAndSelectParcels__f_id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_project_notebook_FindAndSelectParcels__f_source === $n(FindAndSelectParcels$1).Lreactbuild_project_notebook_FindAndSelectParcels__f_source))) {
      return ((this.Lreactbuild_project_notebook_FindAndSelectParcels__f_findTitle === $n(FindAndSelectParcels$1).Lreactbuild_project_notebook_FindAndSelectParcels__f_findTitle) && (this.Lreactbuild_project_notebook_FindAndSelectParcels__f_selectTitle === $n(FindAndSelectParcels$1).Lreactbuild_project_notebook_FindAndSelectParcels__f_selectTitle))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_FindAndSelectParcels(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_FindAndSelectParcels) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.FindAndSelectParcels"))
}
function $isArrayOf_Lreactbuild_project_notebook_FindAndSelectParcels(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_FindAndSelectParcels)))
}
function $asArrayOf_Lreactbuild_project_notebook_FindAndSelectParcels(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_FindAndSelectParcels(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.FindAndSelectParcels;", depth))
}
var $d_Lreactbuild_project_notebook_FindAndSelectParcels = new $TypeData().initClass({
  Lreactbuild_project_notebook_FindAndSelectParcels: 0
}, false, "reactbuild.project.notebook.FindAndSelectParcels", {
  Lreactbuild_project_notebook_FindAndSelectParcels: 1,
  O: 1,
  Lreactbuild_project_notebook_CellConfig$AbstractCellConfig: 1,
  Lreactbuild_project_notebook_CellConfig: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_FindAndSelectParcels.prototype.$classData = $d_Lreactbuild_project_notebook_FindAndSelectParcels;
/** @constructor */
function $c_Lreactbuild_project_notebook_Input(id, source, tpe, label) {
  this.Lreactbuild_project_notebook_Input__f_id = null;
  this.Lreactbuild_project_notebook_Input__f_source = null;
  this.Lreactbuild_project_notebook_Input__f_tpe = null;
  this.Lreactbuild_project_notebook_Input__f_label = null;
  this.Lreactbuild_project_notebook_Input__f_id = id;
  this.Lreactbuild_project_notebook_Input__f_source = source;
  this.Lreactbuild_project_notebook_Input__f_tpe = tpe;
  this.Lreactbuild_project_notebook_Input__f_label = label
}
$c_Lreactbuild_project_notebook_Input.prototype = new $h_O();
$c_Lreactbuild_project_notebook_Input.prototype.constructor = $c_Lreactbuild_project_notebook_Input;
/** @constructor */
function $h_Lreactbuild_project_notebook_Input() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_Input.prototype = $c_Lreactbuild_project_notebook_Input.prototype;
$c_Lreactbuild_project_notebook_Input.prototype.productPrefix__T = (function() {
  return "Input"
});
$c_Lreactbuild_project_notebook_Input.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_notebook_Input.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_Input__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_Input__f_source;
      break
    }
    case 2: {
      return this.Lreactbuild_project_notebook_Input__f_tpe;
      break
    }
    case 3: {
      return this.Lreactbuild_project_notebook_Input__f_label;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_Input.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_Input.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_Input.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_Input.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_Input)) {
    var Input$1 = $as_Lreactbuild_project_notebook_Input(x$1);
    var x = this.Lreactbuild_project_notebook_Input__f_id;
    var x$2 = $n(Input$1).Lreactbuild_project_notebook_Input__f_id;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Lreactbuild_project_notebook_Input__f_source === $n(Input$1).Lreactbuild_project_notebook_Input__f_source))) {
      var x$3 = this.Lreactbuild_project_notebook_Input__f_tpe;
      var x$4 = $n(Input$1).Lreactbuild_project_notebook_Input__f_tpe;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        return (this.Lreactbuild_project_notebook_Input__f_label === $n(Input$1).Lreactbuild_project_notebook_Input__f_label)
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_Input(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_Input) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.Input"))
}
function $isArrayOf_Lreactbuild_project_notebook_Input(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_Input)))
}
function $asArrayOf_Lreactbuild_project_notebook_Input(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_Input(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.Input;", depth))
}
var $d_Lreactbuild_project_notebook_Input = new $TypeData().initClass({
  Lreactbuild_project_notebook_Input: 0
}, false, "reactbuild.project.notebook.Input", {
  Lreactbuild_project_notebook_Input: 1,
  O: 1,
  Lreactbuild_project_notebook_CellConfig$AbstractCellConfig: 1,
  Lreactbuild_project_notebook_CellConfig: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_Input.prototype.$classData = $d_Lreactbuild_project_notebook_Input;
/** @constructor */
function $c_Lreactbuild_project_notebook_ProjectType$() {
  /*<skip>*/
}
$c_Lreactbuild_project_notebook_ProjectType$.prototype = new $h_O();
$c_Lreactbuild_project_notebook_ProjectType$.prototype.constructor = $c_Lreactbuild_project_notebook_ProjectType$;
/** @constructor */
function $h_Lreactbuild_project_notebook_ProjectType$() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_ProjectType$.prototype = $c_Lreactbuild_project_notebook_ProjectType$.prototype;
$c_Lreactbuild_project_notebook_ProjectType$.prototype.productPrefix__T = (function() {
  return "ProjectType"
});
$c_Lreactbuild_project_notebook_ProjectType$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_notebook_ProjectType$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_notebook_ProjectType$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_ProjectType$.prototype.hashCode__I = (function() {
  return 728023507
});
$c_Lreactbuild_project_notebook_ProjectType$.prototype.toString__T = (function() {
  return "ProjectType"
});
var $d_Lreactbuild_project_notebook_ProjectType$ = new $TypeData().initClass({
  Lreactbuild_project_notebook_ProjectType$: 0
}, false, "reactbuild.project.notebook.ProjectType$", {
  Lreactbuild_project_notebook_ProjectType$: 1,
  O: 1,
  Lreactbuild_project_notebook_InputType$Generic: 1,
  Lreactbuild_project_notebook_InputType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_ProjectType$.prototype.$classData = $d_Lreactbuild_project_notebook_ProjectType$;
var $n_Lreactbuild_project_notebook_ProjectType$;
function $m_Lreactbuild_project_notebook_ProjectType$() {
  if ((!$n_Lreactbuild_project_notebook_ProjectType$)) {
    $n_Lreactbuild_project_notebook_ProjectType$ = new $c_Lreactbuild_project_notebook_ProjectType$()
  };
  return $n_Lreactbuild_project_notebook_ProjectType$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_Text(id, source, label) {
  this.Lreactbuild_project_notebook_Text__f_id = null;
  this.Lreactbuild_project_notebook_Text__f_source = null;
  this.Lreactbuild_project_notebook_Text__f_label = null;
  this.Lreactbuild_project_notebook_Text__f_id = id;
  this.Lreactbuild_project_notebook_Text__f_source = source;
  this.Lreactbuild_project_notebook_Text__f_label = label
}
$c_Lreactbuild_project_notebook_Text.prototype = new $h_O();
$c_Lreactbuild_project_notebook_Text.prototype.constructor = $c_Lreactbuild_project_notebook_Text;
/** @constructor */
function $h_Lreactbuild_project_notebook_Text() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_Text.prototype = $c_Lreactbuild_project_notebook_Text.prototype;
$c_Lreactbuild_project_notebook_Text.prototype.productPrefix__T = (function() {
  return "Text"
});
$c_Lreactbuild_project_notebook_Text.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_notebook_Text.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_Text__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_Text__f_source;
      break
    }
    case 2: {
      return this.Lreactbuild_project_notebook_Text__f_label;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_Text.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_Text)) {
    var Text$1 = $as_Lreactbuild_project_notebook_Text(x$1);
    var x = this.Lreactbuild_project_notebook_Text__f_id;
    var x$2 = $n(Text$1).Lreactbuild_project_notebook_Text__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return ((this.Lreactbuild_project_notebook_Text__f_source === $n(Text$1).Lreactbuild_project_notebook_Text__f_source) && (this.Lreactbuild_project_notebook_Text__f_label === $n(Text$1).Lreactbuild_project_notebook_Text__f_label))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_Text(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_Text) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.Text"))
}
function $isArrayOf_Lreactbuild_project_notebook_Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_Text)))
}
function $asArrayOf_Lreactbuild_project_notebook_Text(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.Text;", depth))
}
var $d_Lreactbuild_project_notebook_Text = new $TypeData().initClass({
  Lreactbuild_project_notebook_Text: 0
}, false, "reactbuild.project.notebook.Text", {
  Lreactbuild_project_notebook_Text: 1,
  O: 1,
  Lreactbuild_project_notebook_CellConfig$AbstractCellConfig: 1,
  Lreactbuild_project_notebook_CellConfig: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_Text.prototype.$classData = $d_Lreactbuild_project_notebook_Text;
/** @constructor */
function $c_Lreactbuild_project_notebook_Title(id, title) {
  this.Lreactbuild_project_notebook_Title__f_id = null;
  this.Lreactbuild_project_notebook_Title__f_title = null;
  this.Lreactbuild_project_notebook_Title__f_id = id;
  this.Lreactbuild_project_notebook_Title__f_title = title
}
$c_Lreactbuild_project_notebook_Title.prototype = new $h_O();
$c_Lreactbuild_project_notebook_Title.prototype.constructor = $c_Lreactbuild_project_notebook_Title;
/** @constructor */
function $h_Lreactbuild_project_notebook_Title() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_Title.prototype = $c_Lreactbuild_project_notebook_Title.prototype;
$c_Lreactbuild_project_notebook_Title.prototype.productPrefix__T = (function() {
  return "Title"
});
$c_Lreactbuild_project_notebook_Title.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_notebook_Title.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_notebook_Title__f_id;
      break
    }
    case 1: {
      return this.Lreactbuild_project_notebook_Title__f_title;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_notebook_Title.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_Title.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_Title.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_Title.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_Title)) {
    var Title$1 = $as_Lreactbuild_project_notebook_Title(x$1);
    var x = this.Lreactbuild_project_notebook_Title__f_id;
    var x$2 = $n(Title$1).Lreactbuild_project_notebook_Title__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return (this.Lreactbuild_project_notebook_Title__f_title === $n(Title$1).Lreactbuild_project_notebook_Title__f_title)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_Title(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_Title) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.Title"))
}
function $isArrayOf_Lreactbuild_project_notebook_Title(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_Title)))
}
function $asArrayOf_Lreactbuild_project_notebook_Title(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_Title(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.Title;", depth))
}
var $d_Lreactbuild_project_notebook_Title = new $TypeData().initClass({
  Lreactbuild_project_notebook_Title: 0
}, false, "reactbuild.project.notebook.Title", {
  Lreactbuild_project_notebook_Title: 1,
  O: 1,
  Lreactbuild_project_notebook_CellConfig$AbstractCellConfig: 1,
  Lreactbuild_project_notebook_CellConfig: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_Title.prototype.$classData = $d_Lreactbuild_project_notebook_Title;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2(outer) {
  /*<skip>*/
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2.prototype = new $h_O();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2.prototype.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x = $m_Lshapeless_HNil$();
  if ((x === a)) {
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $m_sci_Vector$();
    var elems = $m_sci_Nil$();
    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$1.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    throw new $c_s_MatchError(a)
  }
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_HNil__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_HNil(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2: 1,
  O: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$2;
/** @constructor */
function $c_s_None$() {
  /*<skip>*/
}
$c_s_None$.prototype = new $h_s_Option();
$c_s_None$.prototype.constructor = $c_s_None$;
/** @constructor */
function $h_s_None$() {
  /*<skip>*/
}
$h_s_None$.prototype = $c_s_None$.prototype;
$c_s_None$.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "None.get")
});
$c_s_None$.prototype.productPrefix__T = (function() {
  return "None"
});
$c_s_None$.prototype.productArity__I = (function() {
  return 0
});
$c_s_None$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_s_None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_None$.prototype.hashCode__I = (function() {
  return 2433880
});
$c_s_None$.prototype.toString__T = (function() {
  return "None"
});
$c_s_None$.prototype.get__O = (function() {
  this.get__E()
});
function $as_s_None$(obj) {
  return (((obj instanceof $c_s_None$) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.None$"))
}
function $isArrayOf_s_None$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_None$)))
}
function $asArrayOf_s_None$(obj, depth) {
  return (($isArrayOf_s_None$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.None$;", depth))
}
var $d_s_None$ = new $TypeData().initClass({
  s_None$: 0
}, false, "scala.None$", {
  s_None$: 1,
  s_Option: 1,
  O: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_None$.prototype.$classData = $d_s_None$;
var $n_s_None$;
function $m_s_None$() {
  if ((!$n_s_None$)) {
    $n_s_None$ = new $c_s_None$()
  };
  return $n_s_None$
}
/** @constructor */
function $c_s_Some(value) {
  this.s_Some__f_value = null;
  this.s_Some__f_value = value
}
$c_s_Some.prototype = new $h_s_Option();
$c_s_Some.prototype.constructor = $c_s_Some;
/** @constructor */
function $h_s_Some() {
  /*<skip>*/
}
$h_s_Some.prototype = $c_s_Some.prototype;
$c_s_Some.prototype.get__O = (function() {
  return this.s_Some__f_value
});
$c_s_Some.prototype.productPrefix__T = (function() {
  return "Some"
});
$c_s_Some.prototype.productArity__I = (function() {
  return 1
});
$c_s_Some.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_Some__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_Some.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_Some.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_Some.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_Some.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_Some)) {
    var Some$1 = $as_s_Some(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_Some__f_value, $n(Some$1).s_Some__f_value)
  } else {
    return false
  }
});
function $as_s_Some(obj) {
  return (((obj instanceof $c_s_Some) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Some"))
}
function $isArrayOf_s_Some(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Some)))
}
function $asArrayOf_s_Some(obj, depth) {
  return (($isArrayOf_s_Some(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Some;", depth))
}
var $d_s_Some = new $TypeData().initClass({
  s_Some: 0
}, false, "scala.Some", {
  s_Some: 1,
  s_Option: 1,
  O: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_Some.prototype.$classData = $d_s_Some;
/** @constructor */
function $c_T2$mcZZ$sp(_1$mcZ$sp, _2$mcZ$sp) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2$mcZZ$sp__f__1$mcZ$sp = false;
  this.T2$mcZZ$sp__f__2$mcZ$sp = false;
  this.T2$mcZZ$sp__f__1$mcZ$sp = _1$mcZ$sp;
  this.T2$mcZZ$sp__f__2$mcZ$sp = _2$mcZ$sp;
  $ct_T2__O__O__(this, null, null)
}
$c_T2$mcZZ$sp.prototype = new $h_T2();
$c_T2$mcZZ$sp.prototype.constructor = $c_T2$mcZZ$sp;
/** @constructor */
function $h_T2$mcZZ$sp() {
  /*<skip>*/
}
$h_T2$mcZZ$sp.prototype = $c_T2$mcZZ$sp.prototype;
$c_T2$mcZZ$sp.prototype._1$mcZ$sp__Z = (function() {
  return this.T2$mcZZ$sp__f__1$mcZ$sp
});
$c_T2$mcZZ$sp.prototype._2$mcZ$sp__Z = (function() {
  return this.T2$mcZZ$sp__f__2$mcZ$sp
});
$c_T2$mcZZ$sp.prototype.copy$default$2__O = (function() {
  return this.T2$mcZZ$sp__f__2$mcZ$sp
});
$c_T2$mcZZ$sp.prototype._2__O = (function() {
  return this.T2$mcZZ$sp__f__2$mcZ$sp
});
$c_T2$mcZZ$sp.prototype._1__O = (function() {
  return this.T2$mcZZ$sp__f__1$mcZ$sp
});
var $d_T2$mcZZ$sp = new $TypeData().initClass({
  T2$mcZZ$sp: 0
}, false, "scala.Tuple2$mcZZ$sp", {
  T2$mcZZ$sp: 1,
  T2: 1,
  O: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T2$mcZZ$sp.prototype.$classData = $d_T2$mcZZ$sp;
/** @constructor */
function $c_sc_AbstractIterable() {
  /*<skip>*/
}
$c_sc_AbstractIterable.prototype = new $h_O();
$c_sc_AbstractIterable.prototype.constructor = $c_sc_AbstractIterable;
/** @constructor */
function $h_sc_AbstractIterable() {
  /*<skip>*/
}
$h_sc_AbstractIterable.prototype = $c_sc_AbstractIterable.prototype;
$c_sc_AbstractIterable.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$()
});
$c_sc_AbstractIterable.prototype.className__T = (function() {
  return this.stringPrefix__T()
});
$c_sc_AbstractIterable.prototype.stringPrefix__T = (function() {
  return "Iterable"
});
$c_sc_AbstractIterable.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps($n(this.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(coll))
});
$c_sc_AbstractIterable.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $n(this.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder()
});
$c_sc_AbstractIterable.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O()
});
$c_sc_AbstractIterable.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this)
});
$c_sc_AbstractIterable.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this)
});
$c_sc_AbstractIterable.prototype.sizeCompare__I__I = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize)
});
$c_sc_AbstractIterable.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred)
});
$c_sc_AbstractIterable.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred)
});
$c_sc_AbstractIterable.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p)
});
$c_sc_AbstractIterable.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n)
});
$c_sc_AbstractIterable.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p)
});
$c_sc_AbstractIterable.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_sc_AbstractIterable.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n)
});
$c_sc_AbstractIterable.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p)
});
$c_sc_AbstractIterable.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sc_AbstractIterable.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this)
});
$c_sc_AbstractIterable.prototype.slice__I__I__O = (function(from, until) {
  return $f_sc_IterableOps__slice__I__I__O(this, from, until)
});
$c_sc_AbstractIterable.prototype.scanLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOps__scanLeft__O__F2__O(this, z, op)
});
$c_sc_AbstractIterable.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f)
});
$c_sc_AbstractIterable.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f)
});
$c_sc_AbstractIterable.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sc_AbstractIterable.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractIterable.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sc_AbstractIterable.prototype.zipWithIndex__O = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this)
});
$c_sc_AbstractIterable.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sc_AbstractIterable.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_sc_AbstractIterable.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_AbstractIterable.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p)
});
$c_sc_AbstractIterable.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_AbstractIterable.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sc_AbstractIterable.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this)
});
$c_sc_AbstractIterable.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_sc_AbstractIterable.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_AbstractIterable.prototype.min__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord)
});
$c_sc_AbstractIterable.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sc_AbstractIterable.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf)
});
$c_sc_AbstractIterable.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_AbstractIterable.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_sc_AbstractIterable.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sc_AbstractIterable.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sc_AbstractIterable.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_sc_AbstractIterable.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq(this)
});
$c_sc_AbstractIterable.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_AbstractIterable.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this)
});
$c_sc_AbstractIterable.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll)
});
function $ct_sc_ArrayOps$ArrayIterator__O__($thiz, xs) {
  $thiz.sc_ArrayOps$ArrayIterator__f_xs = xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  var xs$1 = $thiz.sc_ArrayOps$ArrayIterator__f_xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_len = $m_jl_reflect_Array$().getLength__O__I(xs$1);
  return $thiz
}
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator() {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0
}
$c_sc_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_ArrayOps$ArrayIterator.prototype.constructor = $c_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator.prototype = $c_sc_ArrayOps$ArrayIterator.prototype;
$c_sc_ArrayOps$ArrayIterator.prototype.knownSize__I = (function() {
  return ((this.sc_ArrayOps$ArrayIterator__f_len - this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0)
});
$c_sc_ArrayOps$ArrayIterator.prototype.hasNext__Z = (function() {
  return (this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos < this.sc_ArrayOps$ArrayIterator__f_len)
});
$c_sc_ArrayOps$ArrayIterator.prototype.next__O = (function() {
  var $$x1 = this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos;
  var xs = this.sc_ArrayOps$ArrayIterator__f_xs;
  if (($$x1 >= $m_jl_reflect_Array$().getLength__O__I(xs))) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var r = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.sc_ArrayOps$ArrayIterator__f_xs, this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r
});
$c_sc_ArrayOps$ArrayIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var newPos = ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos + n) | 0);
    if ((newPos < 0)) {
      var $$x1 = this.sc_ArrayOps$ArrayIterator__f_len
    } else {
      var a = this.sc_ArrayOps$ArrayIterator__f_len;
      var $$x1 = ((a < newPos) ? a : newPos)
    };
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = $$x1
  };
  return this
});
var $d_sc_ArrayOps$ArrayIterator = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator: 0
}, false, "scala.collection.ArrayOps$ArrayIterator", {
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator.prototype.$classData = $d_sc_ArrayOps$ArrayIterator;
function $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I($thiz, value) {
  return ((value < 0) ? 0 : ((value > $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) ? $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder : value))
}
function $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = $n(self).length__I();
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0
}
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewIterator() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.knownSize__I = (function() {
  return this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)) {
    var r = $n(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self).apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((1 + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) | 0);
    return r
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + n) | 0);
    var b = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder - n) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b)
  };
  return this
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var formatFrom = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, from);
  var formatUntil = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, until);
  var b = ((formatUntil - formatFrom) | 0);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + formatFrom) | 0);
  return this
});
var $d_sc_IndexedSeqView$IndexedSeqViewIterator = new $TypeData().initClass({
  sc_IndexedSeqView$IndexedSeqViewIterator: 0
}, false, "scala.collection.IndexedSeqView$IndexedSeqViewIterator", {
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.$classData = $d_sc_IndexedSeqView$IndexedSeqViewIterator;
function $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = $n(self).length__I();
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0
}
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    var r = $n(this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self).apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
    return r
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder <= from)) {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0
    } else if ((from <= 0)) {
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = until
      }
    } else {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos - from) | 0);
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        if ((until <= from)) {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0
        } else {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((until - from) | 0)
        }
      } else {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder - from) | 0)
      }
    }
  };
  return this
});
var $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator = new $TypeData().initClass({
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 0
}, false, "scala.collection.IndexedSeqView$IndexedSeqViewReverseIterator", {
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.$classData = $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $c_sc_Iterator$$anon$21() {
  this.scm_ImmutableBuilder__f_elems = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty)
}
$c_sc_Iterator$$anon$21.prototype = new $h_scm_ImmutableBuilder();
$c_sc_Iterator$$anon$21.prototype.constructor = $c_sc_Iterator$$anon$21;
/** @constructor */
function $h_sc_Iterator$$anon$21() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$21.prototype = $c_sc_Iterator$$anon$21.prototype;
$c_sc_Iterator$$anon$21.prototype.addOne__O__sc_Iterator$$anon$21 = (function(elem) {
  var this$3 = $n($as_sc_Iterator(this.scm_ImmutableBuilder__f_elems));
  var xs = new $c_sjsr_AnonFunction0((() => {
    $m_sc_Iterator$();
    return new $c_sc_Iterator$$anon$20(elem)
  }));
  this.scm_ImmutableBuilder__f_elems = this$3.concat__F0__sc_Iterator(xs);
  return this
});
$c_sc_Iterator$$anon$21.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_Iterator$$anon$21(elem)
});
var $d_sc_Iterator$$anon$21 = new $TypeData().initClass({
  sc_Iterator$$anon$21: 0
}, false, "scala.collection.Iterator$$anon$21", {
  sc_Iterator$$anon$21: 1,
  scm_ImmutableBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sc_Iterator$$anon$21.prototype.$classData = $d_sc_Iterator$$anon$21;
/** @constructor */
function $c_sc_Iterator$$anon$7(outer, pf$1) {
  this.sc_Iterator$$anon$7__f_hd = null;
  this.sc_Iterator$$anon$7__f_status = 0;
  this.sc_Iterator$$anon$7__f_$outer = null;
  this.sc_Iterator$$anon$7__f_pf$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_Iterator$$anon$7__f_$outer = outer
  };
  this.sc_Iterator$$anon$7__f_pf$1 = pf$1;
  this.sc_Iterator$$anon$7__f_status = 0
}
$c_sc_Iterator$$anon$7.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$7.prototype.constructor = $c_sc_Iterator$$anon$7;
/** @constructor */
function $h_sc_Iterator$$anon$7() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$7.prototype = $c_sc_Iterator$$anon$7.prototype;
$c_sc_Iterator$$anon$7.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($m_sr_Statics$PFMarker$())
});
$c_sc_Iterator$$anon$7.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_Iterator$$anon$7.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sc_Iterator$$anon$7.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sc_Iterator$$anon$7.prototype.apply__O__O = (function(value) {
  return $m_sr_Statics$PFMarker$()
});
$c_sc_Iterator$$anon$7.prototype.hasNext__Z = (function() {
  var marker = $m_sr_Statics$PFMarker$();
  while ((this.sc_Iterator$$anon$7__f_status === 0)) {
    if ($n(this.sc_Iterator$$anon$7__f_$outer).hasNext__Z()) {
      var x = $n(this.sc_Iterator$$anon$7__f_$outer).next__O();
      var v = $n(this.sc_Iterator$$anon$7__f_pf$1).applyOrElse__O__F1__O(x, this);
      if ((marker !== v)) {
        this.sc_Iterator$$anon$7__f_hd = v;
        this.sc_Iterator$$anon$7__f_status = 1
      }
    } else {
      this.sc_Iterator$$anon$7__f_status = (-1)
    }
  };
  return (this.sc_Iterator$$anon$7__f_status === 1)
});
$c_sc_Iterator$$anon$7.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$7__f_status = 0;
    return this.sc_Iterator$$anon$7__f_hd
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
var $d_sc_Iterator$$anon$7 = new $TypeData().initClass({
  sc_Iterator$$anon$7: 0
}, false, "scala.collection.Iterator$$anon$7", {
  sc_Iterator$$anon$7: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  F1: 1
});
$c_sc_Iterator$$anon$7.prototype.$classData = $d_sc_Iterator$$anon$7;
function $f_sc_MapOps__getOrElse__O__F0__O($thiz, key, default$1) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $n(x2).s_Some__f_value;
    return v
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return $n(default$1).apply__O()
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
function $f_sc_MapOps__apply__O__O($thiz, key) {
  var x1 = $thiz.get__O__s_Option(key);
  var x = $m_s_None$();
  if ((x === x1)) {
    return $thiz.default__O__O(key)
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var value = $n(x3).s_Some__f_value;
    return value
  } else {
    throw new $c_s_MatchError(x1)
  }
}
function $f_sc_MapOps__applyOrElse__O__F1__O($thiz, x, default$1) {
  return $thiz.getOrElse__O__F0__O(x, new $c_sjsr_AnonFunction0((() => $n(default$1).apply__O__O(x))))
}
function $f_sc_MapOps__foreachEntry__F2__V($thiz, f) {
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var next = $as_T2($n(it).next__O());
    $n(f).apply__O__O__O($n(next)._1__O(), $n(next)._2__O())
  }
}
function $f_sc_MapOps__default__O__O($thiz, key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
}
function $f_sc_MapOps__contains__O__Z($thiz, key) {
  var this$1 = $n($thiz.get__O__s_Option(key));
  return (!this$1.isEmpty__Z())
}
function $f_sc_MapOps__map__F1__sc_IterableOps($thiz, f) {
  return $as_sc_IterableOps($n($thiz.mapFactory__sc_MapFactory()).from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f)))
}
function $f_sc_MapOps__collect__s_PartialFunction__sc_IterableOps($thiz, pf) {
  return $as_sc_IterableOps($n($thiz.mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(new $c_sc_View$Collect($thiz, pf)))
}
function $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, sb, start, sep, end) {
  var this$2 = $n($thiz.iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = $n(x0$1)._1__O();
      var v = $n(x0$1)._2__O();
      return ((k + " -> ") + v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  var this$3 = new $c_sc_Iterator$$anon$9(this$2, f);
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this$3, sb, start, sep, end)
}
function $f_sc_MapOps__$plus__T2__sc_IterableOps($thiz, kv) {
  return $as_sc_IterableOps($n($thiz.mapFactory__sc_MapFactory()).from__sc_IterableOnce__O($ct_sc_View$Appended__sc_IterableOps__O__(new $c_sc_View$Appended(), $thiz, kv)))
}
function $is_sc_MapOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_MapOps)))
}
function $as_sc_MapOps(obj) {
  return (($is_sc_MapOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.MapOps"))
}
function $isArrayOf_sc_MapOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_MapOps)))
}
function $asArrayOf_sc_MapOps(obj, depth) {
  return (($isArrayOf_sc_MapOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.MapOps;", depth))
}
function $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  var builder = $thiz.newSpecificBuilder__scm_Builder();
  var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var next = $n(it).next__O();
    if (seen.add__O__Z($n(f).apply__O__O(next))) {
      var this$2 = $n(builder);
      this$2.addOne__O__scm_Growable(next)
    }
  };
  return $n(builder).result__O()
}
function $f_sc_StrictOptimizedSeqOps__prepended__O__O($thiz, elem) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  if (($thiz.knownSize__I() >= 0)) {
    $n(b).sizeHint__I__V(((1 + $thiz.length__I()) | 0))
  };
  var this$1 = $n(b);
  this$1.addOne__O__scm_Growable(elem);
  var this$2 = $n(b);
  this$2.addAll__sc_IterableOnce__scm_Growable($thiz);
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedSeqOps__appended__O__O($thiz, elem) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  if (($thiz.knownSize__I() >= 0)) {
    $n(b).sizeHint__I__V(((1 + $thiz.length__I()) | 0))
  };
  var this$1 = $n(b);
  this$1.addAll__sc_IterableOnce__scm_Growable($thiz);
  var this$2 = $n(b);
  this$2.addOne__O__scm_Growable(elem);
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O($thiz, suffix) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  var this$1 = $n(b);
  this$1.addAll__sc_IterableOnce__scm_Growable($thiz);
  var this$2 = $n(b);
  this$2.addAll__sc_IterableOnce__scm_Growable(suffix);
  return $n(b).result__O()
}
function $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O($thiz, that) {
  if (($thiz.isEmpty__Z() || $n(that).isEmpty__Z())) {
    return $thiz
  } else {
    var occ = $f_sc_SeqOps__occCounts__sc_Seq__scm_Map($thiz, that);
    var b = $thiz.newSpecificBuilder__scm_Builder();
    $thiz.foreach__F1__V(new $c_sjsr_AnonFunction1(((x$2) => $n(occ).updateWith__O__F1__s_Option(x$2, new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_s_Option(x0$1$2);
      var rc8 = false;
      var x3 = null;
      var x = $m_s_None$();
      if ((x === x0$1)) {
        $n(b).addOne__O__scm_Growable(x$2);
        return $m_s_None$()
      };
      if ((x0$1 instanceof $c_s_Some)) {
        rc8 = true;
        x3 = $as_s_Some(x0$1);
        var p4 = $uI($n(x3).s_Some__f_value);
        if ((p4 === 1)) {
          return $m_s_None$()
        }
      };
      if (rc8) {
        var n = $uI($n(x3).s_Some__f_value);
        return new $c_s_Some((((-1) + n) | 0))
      };
      throw new $c_s_MatchError(x0$1)
    }))))));
    return $n(b).result__O()
  }
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying = underlying
}
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = new $h_sc_AbstractIterator();
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JIteratorWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.hasNext__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying).hasNext__Z()
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.next__O = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying).next__O()
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper)) {
    var x2 = $as_sc_convert_JavaCollectionWrappers$JIteratorWrapper(other);
    var x = this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying;
    var x$2 = $n(x2).sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying;
    if ((x === null)) {
      return (x$2 === null)
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2)
    }
  } else {
    return false
  }
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.hashCode__I = (function() {
  var this$1 = $n(this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying);
  return $systemIdentityHashCode(this$1)
});
function $as_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj) {
  return (((obj instanceof $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$JIteratorWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$JIteratorWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$JIteratorWrapper;", depth))
}
var $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JIteratorWrapper: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JIteratorWrapper", {
  sc_convert_JavaCollectionWrappers$JIteratorWrapper: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2(outer) {
  this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2__f_$outer = outer
  }
}
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2.prototype = new $h_ju_AbstractSet();
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2.prototype = $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2.prototype;
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2.prototype.size__I = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2__f_$outer).size__I()
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2.prototype.iterator__ju_Iterator = (function() {
  return new $c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2$$anon$3(this)
});
var $d_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$MapWrapper$$anon$2", {
  sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
});
$c_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$MapWrapper$$anon$2;
function $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) {
  if ((!$thiz.sci_ArraySeq$__f_bitmap$0)) {
    $thiz.sci_ArraySeq$__f_emptyImpl = new $c_sci_ArraySeq$ofRef(new $ac_O(0));
    $thiz.sci_ArraySeq$__f_bitmap$0 = true
  };
  return $thiz.sci_ArraySeq$__f_emptyImpl
}
function $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef($thiz) {
  return ((!$thiz.sci_ArraySeq$__f_bitmap$0) ? $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) : $thiz.sci_ArraySeq$__f_emptyImpl)
}
/** @constructor */
function $c_sci_ArraySeq$() {
  this.sci_ArraySeq$__f_emptyImpl = null;
  this.sci_ArraySeq$__f_untagged = null;
  this.sci_ArraySeq$__f_bitmap$0 = false;
  $n_sci_ArraySeq$ = this;
  this.sci_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this)
}
$c_sci_ArraySeq$.prototype = new $h_O();
$c_sci_ArraySeq$.prototype.constructor = $c_sci_ArraySeq$;
/** @constructor */
function $h_sci_ArraySeq$() {
  /*<skip>*/
}
$h_sci_ArraySeq$.prototype = $c_sci_ArraySeq$.prototype;
$c_sci_ArraySeq$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(xs, $as_s_reflect_ClassTag(evidence$7))
});
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq = (function(it, tag) {
  if ((it instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(it);
    return x2
  } else {
    return this.unsafeWrapArray__O__sci_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, tag))
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$2) {
  $m_scm_ArrayBuffer$();
  var this$4 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((b$2) => {
    var b = $as_scm_ArrayBuffer(b$2);
    var $$x1 = $m_sci_ArraySeq$();
    var this$3 = $n(b);
    return $n($$x1).unsafeWrapArray__O__sci_ArraySeq($f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this$3, evidence$2))
  }));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_sci_ArraySeq$.prototype.unsafeWrapArray__O__sci_ArraySeq = (function(x) {
  if ((x === null)) {
    return null
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_sci_ArraySeq$ofRef(x3)
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_sci_ArraySeq$ofInt(x4)
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_sci_ArraySeq$ofDouble(x5)
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_sci_ArraySeq$ofLong(x6)
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_sci_ArraySeq$ofFloat(x7)
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_sci_ArraySeq$ofChar(x8)
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_sci_ArraySeq$ofByte(x9)
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_sci_ArraySeq$ofShort(x10)
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_sci_ArraySeq$ofBoolean(x11)
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_sci_ArraySeq$ofUnit(x12)
  } else {
    throw new $c_s_MatchError(x)
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder($as_s_reflect_ClassTag(evidence$12))
});
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5))
});
$c_sci_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this)
});
var $d_sci_ArraySeq$ = new $TypeData().initClass({
  sci_ArraySeq$: 0
}, false, "scala.collection.immutable.ArraySeq$", {
  sci_ArraySeq$: 1,
  O: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$.prototype.$classData = $d_sci_ArraySeq$;
var $n_sci_ArraySeq$;
function $m_sci_ArraySeq$() {
  if ((!$n_sci_ArraySeq$)) {
    $n_sci_ArraySeq$ = new $c_sci_ArraySeq$()
  };
  return $n_sci_ArraySeq$
}
/** @constructor */
function $c_sci_HashMapBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, $n(x2$1).sci_HashMap__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    $n(outer).update__sci_MapNode__O__O__I__I__I__V($n(outer).sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0)
  }
}
$c_sci_HashMapBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashMapBuilder$$anon$1.prototype.constructor = $c_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $h_sci_HashMapBuilder$$anon$1() {
  /*<skip>*/
}
$h_sci_HashMapBuilder$$anon$1.prototype = $c_sci_HashMapBuilder$$anon$1.prototype;
$c_sci_HashMapBuilder$$anon$1.prototype.next__E = (function() {
  $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException())
});
$c_sci_HashMapBuilder$$anon$1.prototype.next__O = (function() {
  this.next__E()
});
var $d_sci_HashMapBuilder$$anon$1 = new $TypeData().initClass({
  sci_HashMapBuilder$$anon$1: 0
}, false, "scala.collection.immutable.HashMapBuilder$$anon$1", {
  sci_HashMapBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_HashMapBuilder$$anon$1.prototype.$classData = $d_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $c_sci_HashSetBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, $n(x2$1).sci_HashSet__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    $n(outer).update__sci_SetNode__O__I__I__I__V($n(outer).sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, $n($as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0)
  }
}
$c_sci_HashSetBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashSetBuilder$$anon$1.prototype.constructor = $c_sci_HashSetBuilder$$anon$1;
/** @constructor */
function $h_sci_HashSetBuilder$$anon$1() {
  /*<skip>*/
}
$h_sci_HashSetBuilder$$anon$1.prototype = $c_sci_HashSetBuilder$$anon$1.prototype;
$c_sci_HashSetBuilder$$anon$1.prototype.next__E = (function() {
  $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException())
});
$c_sci_HashSetBuilder$$anon$1.prototype.next__O = (function() {
  this.next__E()
});
var $d_sci_HashSetBuilder$$anon$1 = new $TypeData().initClass({
  sci_HashSetBuilder$$anon$1: 0
}, false, "scala.collection.immutable.HashSetBuilder$$anon$1", {
  sci_HashSetBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_HashSetBuilder$$anon$1.prototype.$classData = $d_sci_HashSetBuilder$$anon$1;
function $is_sci_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Iterable)))
}
function $as_sci_Iterable(obj) {
  return (($is_sci_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Iterable"))
}
function $isArrayOf_sci_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Iterable)))
}
function $asArrayOf_sci_Iterable(obj, depth) {
  return (($isArrayOf_sci_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Iterable;", depth))
}
/** @constructor */
function $c_sci_ListSet$$anon$1() {
  this.scm_ImmutableBuilder__f_elems = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sci_ListSet$EmptyListSet$())
}
$c_sci_ListSet$$anon$1.prototype = new $h_scm_ImmutableBuilder();
$c_sci_ListSet$$anon$1.prototype.constructor = $c_sci_ListSet$$anon$1;
/** @constructor */
function $h_sci_ListSet$$anon$1() {
  /*<skip>*/
}
$h_sci_ListSet$$anon$1.prototype = $c_sci_ListSet$$anon$1.prototype;
$c_sci_ListSet$$anon$1.prototype.addOne__O__sci_ListSet$$anon$1 = (function(elem) {
  var this$1 = $n($as_sci_SetOps(this.scm_ImmutableBuilder__f_elems));
  this.scm_ImmutableBuilder__f_elems = this$1.incl__O__sci_SetOps(elem);
  return this
});
$c_sci_ListSet$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_ListSet$$anon$1(elem)
});
var $d_sci_ListSet$$anon$1 = new $TypeData().initClass({
  sci_ListSet$$anon$1: 0
}, false, "scala.collection.immutable.ListSet$$anon$1", {
  sci_ListSet$$anon$1: 1,
  scm_ImmutableBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_ListSet$$anon$1.prototype.$classData = $d_sci_ListSet$$anon$1;
/** @constructor */
function $c_sci_Map$Map2$$anon$1(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer)
}
$c_sci_Map$Map2$$anon$1.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$1.prototype.constructor = $c_sci_Map$Map2$$anon$1;
/** @constructor */
function $h_sci_Map$Map2$$anon$1() {
  /*<skip>*/
}
$h_sci_Map$Map2$$anon$1.prototype = $c_sci_Map$Map2$$anon$1.prototype;
$c_sci_Map$Map2$$anon$1.prototype.nextResult__O__O__O = (function(k, v) {
  return $ct_T2__O__O__(new $c_T2(), k, v)
});
var $d_sci_Map$Map2$$anon$1 = new $TypeData().initClass({
  sci_Map$Map2$$anon$1: 0
}, false, "scala.collection.immutable.Map$Map2$$anon$1", {
  sci_Map$Map2$$anon$1: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map2$$anon$1.prototype.$classData = $d_sci_Map$Map2$$anon$1;
/** @constructor */
function $c_sci_Map$Map2$$anon$2(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer)
}
$c_sci_Map$Map2$$anon$2.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$2.prototype.constructor = $c_sci_Map$Map2$$anon$2;
/** @constructor */
function $h_sci_Map$Map2$$anon$2() {
  /*<skip>*/
}
$h_sci_Map$Map2$$anon$2.prototype = $c_sci_Map$Map2$$anon$2.prototype;
$c_sci_Map$Map2$$anon$2.prototype.nextResult__O__O__O = (function(k, v) {
  return k
});
var $d_sci_Map$Map2$$anon$2 = new $TypeData().initClass({
  sci_Map$Map2$$anon$2: 0
}, false, "scala.collection.immutable.Map$Map2$$anon$2", {
  sci_Map$Map2$$anon$2: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map2$$anon$2.prototype.$classData = $d_sci_Map$Map2$$anon$2;
/** @constructor */
function $c_sci_Map$Map2$$anon$3(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer)
}
$c_sci_Map$Map2$$anon$3.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$3.prototype.constructor = $c_sci_Map$Map2$$anon$3;
/** @constructor */
function $h_sci_Map$Map2$$anon$3() {
  /*<skip>*/
}
$h_sci_Map$Map2$$anon$3.prototype = $c_sci_Map$Map2$$anon$3.prototype;
$c_sci_Map$Map2$$anon$3.prototype.nextResult__O__O__O = (function(k, v) {
  return v
});
var $d_sci_Map$Map2$$anon$3 = new $TypeData().initClass({
  sci_Map$Map2$$anon$3: 0
}, false, "scala.collection.immutable.Map$Map2$$anon$3", {
  sci_Map$Map2$$anon$3: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map2$$anon$3.prototype.$classData = $d_sci_Map$Map2$$anon$3;
/** @constructor */
function $c_sci_Map$Map3$$anon$4(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer)
}
$c_sci_Map$Map3$$anon$4.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$4.prototype.constructor = $c_sci_Map$Map3$$anon$4;
/** @constructor */
function $h_sci_Map$Map3$$anon$4() {
  /*<skip>*/
}
$h_sci_Map$Map3$$anon$4.prototype = $c_sci_Map$Map3$$anon$4.prototype;
$c_sci_Map$Map3$$anon$4.prototype.nextResult__O__O__O = (function(k, v) {
  return $ct_T2__O__O__(new $c_T2(), k, v)
});
var $d_sci_Map$Map3$$anon$4 = new $TypeData().initClass({
  sci_Map$Map3$$anon$4: 0
}, false, "scala.collection.immutable.Map$Map3$$anon$4", {
  sci_Map$Map3$$anon$4: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map3$$anon$4.prototype.$classData = $d_sci_Map$Map3$$anon$4;
/** @constructor */
function $c_sci_Map$Map3$$anon$5(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer)
}
$c_sci_Map$Map3$$anon$5.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$5.prototype.constructor = $c_sci_Map$Map3$$anon$5;
/** @constructor */
function $h_sci_Map$Map3$$anon$5() {
  /*<skip>*/
}
$h_sci_Map$Map3$$anon$5.prototype = $c_sci_Map$Map3$$anon$5.prototype;
$c_sci_Map$Map3$$anon$5.prototype.nextResult__O__O__O = (function(k, v) {
  return k
});
var $d_sci_Map$Map3$$anon$5 = new $TypeData().initClass({
  sci_Map$Map3$$anon$5: 0
}, false, "scala.collection.immutable.Map$Map3$$anon$5", {
  sci_Map$Map3$$anon$5: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map3$$anon$5.prototype.$classData = $d_sci_Map$Map3$$anon$5;
/** @constructor */
function $c_sci_Map$Map3$$anon$6(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer)
}
$c_sci_Map$Map3$$anon$6.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$6.prototype.constructor = $c_sci_Map$Map3$$anon$6;
/** @constructor */
function $h_sci_Map$Map3$$anon$6() {
  /*<skip>*/
}
$h_sci_Map$Map3$$anon$6.prototype = $c_sci_Map$Map3$$anon$6.prototype;
$c_sci_Map$Map3$$anon$6.prototype.nextResult__O__O__O = (function(k, v) {
  return v
});
var $d_sci_Map$Map3$$anon$6 = new $TypeData().initClass({
  sci_Map$Map3$$anon$6: 0
}, false, "scala.collection.immutable.Map$Map3$$anon$6", {
  sci_Map$Map3$$anon$6: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map3$$anon$6.prototype.$classData = $d_sci_Map$Map3$$anon$6;
/** @constructor */
function $c_sci_Map$Map4$$anon$7(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer)
}
$c_sci_Map$Map4$$anon$7.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$7.prototype.constructor = $c_sci_Map$Map4$$anon$7;
/** @constructor */
function $h_sci_Map$Map4$$anon$7() {
  /*<skip>*/
}
$h_sci_Map$Map4$$anon$7.prototype = $c_sci_Map$Map4$$anon$7.prototype;
$c_sci_Map$Map4$$anon$7.prototype.nextResult__O__O__O = (function(k, v) {
  return $ct_T2__O__O__(new $c_T2(), k, v)
});
var $d_sci_Map$Map4$$anon$7 = new $TypeData().initClass({
  sci_Map$Map4$$anon$7: 0
}, false, "scala.collection.immutable.Map$Map4$$anon$7", {
  sci_Map$Map4$$anon$7: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map4$$anon$7.prototype.$classData = $d_sci_Map$Map4$$anon$7;
/** @constructor */
function $c_sci_Map$Map4$$anon$8(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer)
}
$c_sci_Map$Map4$$anon$8.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$8.prototype.constructor = $c_sci_Map$Map4$$anon$8;
/** @constructor */
function $h_sci_Map$Map4$$anon$8() {
  /*<skip>*/
}
$h_sci_Map$Map4$$anon$8.prototype = $c_sci_Map$Map4$$anon$8.prototype;
$c_sci_Map$Map4$$anon$8.prototype.nextResult__O__O__O = (function(k, v) {
  return k
});
var $d_sci_Map$Map4$$anon$8 = new $TypeData().initClass({
  sci_Map$Map4$$anon$8: 0
}, false, "scala.collection.immutable.Map$Map4$$anon$8", {
  sci_Map$Map4$$anon$8: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map4$$anon$8.prototype.$classData = $d_sci_Map$Map4$$anon$8;
/** @constructor */
function $c_sci_Map$Map4$$anon$9(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer)
}
$c_sci_Map$Map4$$anon$9.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$9.prototype.constructor = $c_sci_Map$Map4$$anon$9;
/** @constructor */
function $h_sci_Map$Map4$$anon$9() {
  /*<skip>*/
}
$h_sci_Map$Map4$$anon$9.prototype = $c_sci_Map$Map4$$anon$9.prototype;
$c_sci_Map$Map4$$anon$9.prototype.nextResult__O__O__O = (function(k, v) {
  return v
});
var $d_sci_Map$Map4$$anon$9 = new $TypeData().initClass({
  sci_Map$Map4$$anon$9: 0
}, false, "scala.collection.immutable.Map$Map4$$anon$9", {
  sci_Map$Map4$$anon$9: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map4$$anon$9.prototype.$classData = $d_sci_Map$Map4$$anon$9;
/** @constructor */
function $c_sci_MapKeyIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_MapKeyIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyIterator.prototype.constructor = $c_sci_MapKeyIterator;
/** @constructor */
function $h_sci_MapKeyIterator() {
  /*<skip>*/
}
$h_sci_MapKeyIterator.prototype = $c_sci_MapKeyIterator.prototype;
$c_sci_MapKeyIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var key = $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return key
});
var $d_sci_MapKeyIterator = new $TypeData().initClass({
  sci_MapKeyIterator: 0
}, false, "scala.collection.immutable.MapKeyIterator", {
  sci_MapKeyIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyIterator.prototype.$classData = $d_sci_MapKeyIterator;
/** @constructor */
function $c_sci_MapKeyValueTupleHashIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
  this.sci_MapKeyValueTupleHashIterator__f_value = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0
}
$c_sci_MapKeyValueTupleHashIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_MapKeyValueTupleHashIterator.prototype.constructor = $c_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleHashIterator() {
  /*<skip>*/
}
$h_sci_MapKeyValueTupleHashIterator.prototype = $c_sci_MapKeyValueTupleHashIterator.prototype;
$c_sci_MapKeyValueTupleHashIterator.prototype.hashCode__I = (function() {
  var $$x2 = $m_s_util_hashing_MurmurHash3$();
  var $$x1 = this.sci_MapKeyValueTupleHashIterator__f_hash;
  var x = this.sci_MapKeyValueTupleHashIterator__f_value;
  return $n($$x2).tuple2Hash__I__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x), (-889275714))
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__sci_MapKeyValueTupleHashIterator = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  this.sci_MapKeyValueTupleHashIterator__f_hash = $n(this.sci_ChampBaseReverseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_MapKeyValueTupleHashIterator__f_value = $n($as_sci_MapNode(this.sci_ChampBaseReverseIterator__f_currentValueNode)).getValue__I__O(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return this
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__O = (function() {
  return this.next__sci_MapKeyValueTupleHashIterator()
});
var $d_sci_MapKeyValueTupleHashIterator = new $TypeData().initClass({
  sci_MapKeyValueTupleHashIterator: 0
}, false, "scala.collection.immutable.MapKeyValueTupleHashIterator", {
  sci_MapKeyValueTupleHashIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyValueTupleHashIterator.prototype.$classData = $d_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $c_sci_MapKeyValueTupleIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_MapKeyValueTupleIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyValueTupleIterator.prototype.constructor = $c_sci_MapKeyValueTupleIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleIterator() {
  /*<skip>*/
}
$h_sci_MapKeyValueTupleIterator.prototype = $c_sci_MapKeyValueTupleIterator.prototype;
$c_sci_MapKeyValueTupleIterator.prototype.next__T2 = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var payload = $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__T2(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload
});
$c_sci_MapKeyValueTupleIterator.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sci_MapKeyValueTupleIterator = new $TypeData().initClass({
  sci_MapKeyValueTupleIterator: 0
}, false, "scala.collection.immutable.MapKeyValueTupleIterator", {
  sci_MapKeyValueTupleIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyValueTupleIterator.prototype.$classData = $d_sci_MapKeyValueTupleIterator;
/** @constructor */
function $c_sci_MapValueIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_MapValueIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapValueIterator.prototype.constructor = $c_sci_MapValueIterator;
/** @constructor */
function $h_sci_MapValueIterator() {
  /*<skip>*/
}
$h_sci_MapValueIterator.prototype = $c_sci_MapValueIterator.prototype;
$c_sci_MapValueIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var value = $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return value
});
var $d_sci_MapValueIterator = new $TypeData().initClass({
  sci_MapValueIterator: 0
}, false, "scala.collection.immutable.MapValueIterator", {
  sci_MapValueIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapValueIterator.prototype.$classData = $d_sci_MapValueIterator;
function $p_sci_NewVectorIterator__advanceSlice__V($thiz) {
  if (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
  var slice = $n($thiz.sci_NewVectorIterator__f_v).vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  while (($n(slice).u.length === 0)) {
    $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
    slice = $n($thiz.sci_NewVectorIterator__f_v).vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx)
  };
  $thiz.sci_NewVectorIterator__f_sliceStart = $thiz.sci_NewVectorIterator__f_sliceEnd;
  var count = $thiz.sci_NewVectorIterator__f_sliceCount;
  var idx = $thiz.sci_NewVectorIterator__f_sliceIdx;
  var c = ((count / 2) | 0);
  var a = ((idx - c) | 0);
  $thiz.sci_NewVectorIterator__f_sliceDim = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
  var x1 = $thiz.sci_NewVectorIterator__f_sliceDim;
  switch (x1) {
    case 1: {
      $thiz.sci_NewVectorIterator__f_a1 = slice;
      break
    }
    case 2: {
      $thiz.sci_NewVectorIterator__f_a2 = $asArrayOf_O(slice, 2);
      break
    }
    case 3: {
      $thiz.sci_NewVectorIterator__f_a3 = $asArrayOf_O(slice, 3);
      break
    }
    case 4: {
      $thiz.sci_NewVectorIterator__f_a4 = $asArrayOf_O(slice, 4);
      break
    }
    case 5: {
      $thiz.sci_NewVectorIterator__f_a5 = $asArrayOf_O(slice, 5);
      break
    }
    case 6: {
      $thiz.sci_NewVectorIterator__f_a6 = $asArrayOf_O(slice, 6);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  $thiz.sci_NewVectorIterator__f_sliceEnd = (($thiz.sci_NewVectorIterator__f_sliceStart + Math.imul($n(slice).u.length, (1 << Math.imul(5, (((-1) + $thiz.sci_NewVectorIterator__f_sliceDim) | 0))))) | 0);
  if (($thiz.sci_NewVectorIterator__f_sliceEnd > $thiz.sci_NewVectorIterator__f_totalLength)) {
    $thiz.sci_NewVectorIterator__f_sliceEnd = $thiz.sci_NewVectorIterator__f_totalLength
  };
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    $thiz.sci_NewVectorIterator__f_oldPos = (((-1) + (1 << Math.imul(5, $thiz.sci_NewVectorIterator__f_sliceDim))) | 0)
  }
}
function $p_sci_NewVectorIterator__advance__V($thiz) {
  var pos = (((($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + $thiz.sci_NewVectorIterator__f_totalLength) | 0);
  if ((pos === $thiz.sci_NewVectorIterator__f_sliceEnd)) {
    $p_sci_NewVectorIterator__advanceSlice__V($thiz)
  };
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    var io = ((pos - $thiz.sci_NewVectorIterator__f_sliceStart) | 0);
    var xor = ($thiz.sci_NewVectorIterator__f_oldPos ^ io);
    $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor);
    $thiz.sci_NewVectorIterator__f_oldPos = io
  };
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var a = $n($thiz.sci_NewVectorIterator__f_a1).u.length;
  var b = $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
  $thiz.sci_NewVectorIterator__f_a1len = ((a < b) ? a : b);
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0
}
function $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0)
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0)
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0)
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $n($thiz.sci_NewVectorIterator__f_a6).get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get(0);
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0)
  }
}
function $p_sci_NewVectorIterator__setA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)))
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $n($thiz.sci_NewVectorIterator__f_a6).get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)))
  }
}
/** @constructor */
function $c_sci_NewVectorIterator(v, totalLength, sliceCount) {
  this.sci_NewVectorIterator__f_v = null;
  this.sci_NewVectorIterator__f_totalLength = 0;
  this.sci_NewVectorIterator__f_sliceCount = 0;
  this.sci_NewVectorIterator__f_a1 = null;
  this.sci_NewVectorIterator__f_a2 = null;
  this.sci_NewVectorIterator__f_a3 = null;
  this.sci_NewVectorIterator__f_a4 = null;
  this.sci_NewVectorIterator__f_a5 = null;
  this.sci_NewVectorIterator__f_a6 = null;
  this.sci_NewVectorIterator__f_a1len = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 0;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = 0;
  this.sci_NewVectorIterator__f_v = v;
  this.sci_NewVectorIterator__f_totalLength = totalLength;
  this.sci_NewVectorIterator__f_sliceCount = sliceCount;
  this.sci_NewVectorIterator__f_a1 = $n(v).sci_Vector__f_prefix1;
  this.sci_NewVectorIterator__f_a1len = $n(this.sci_NewVectorIterator__f_a1).u.length;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = this.sci_NewVectorIterator__f_totalLength;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 1;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_a1len
}
$c_sci_NewVectorIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_NewVectorIterator.prototype.constructor = $c_sci_NewVectorIterator;
/** @constructor */
function $h_sci_NewVectorIterator() {
  /*<skip>*/
}
$h_sci_NewVectorIterator.prototype = $c_sci_NewVectorIterator.prototype;
$c_sci_NewVectorIterator.prototype.knownSize__I = (function() {
  return ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0)
});
$c_sci_NewVectorIterator.prototype.hasNext__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)
});
$c_sci_NewVectorIterator.prototype.next__O = (function() {
  if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
    $p_sci_NewVectorIterator__advance__V(this)
  };
  var r = $n(this.sci_NewVectorIterator__f_a1).get(this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1);
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((1 + this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  return r
});
$c_sci_NewVectorIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var oldpos = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + this.sci_NewVectorIterator__f_totalLength) | 0);
    var a = ((oldpos + n) | 0);
    var b = this.sci_NewVectorIterator__f_totalLength;
    var newpos = ((a < b) ? a : b);
    if ((newpos === this.sci_NewVectorIterator__f_totalLength)) {
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
      this.sci_NewVectorIterator__f_a1len = 0
    } else {
      while ((newpos >= this.sci_NewVectorIterator__f_sliceEnd)) {
        $p_sci_NewVectorIterator__advanceSlice__V(this)
      };
      var io = ((newpos - this.sci_NewVectorIterator__f_sliceStart) | 0);
      if ((this.sci_NewVectorIterator__f_sliceDim > 1)) {
        var xor = (this.sci_NewVectorIterator__f_oldPos ^ io);
        $p_sci_NewVectorIterator__setA__I__I__V(this, io, xor);
        this.sci_NewVectorIterator__f_oldPos = io
      };
      this.sci_NewVectorIterator__f_a1len = $n(this.sci_NewVectorIterator__f_a1).u.length;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = (31 & io);
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + ((this.sci_NewVectorIterator__f_totalLength - newpos) | 0)) | 0);
      if ((this.sci_NewVectorIterator__f_a1len > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1)) {
        this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1
      }
    }
  };
  return this
});
$c_sci_NewVectorIterator.prototype.take__I__sc_Iterator = (function(n) {
  if ((n < ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0))) {
    var trunc = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0) - ((n < 0) ? 0 : n)) | 0);
    this.sci_NewVectorIterator__f_totalLength = ((this.sci_NewVectorIterator__f_totalLength - trunc) | 0);
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - trunc) | 0);
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 < this.sci_NewVectorIterator__f_a1len)) {
      this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1
    };
    if ((this.sci_NewVectorIterator__f_totalLength < this.sci_NewVectorIterator__f_sliceEnd)) {
      this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_totalLength
    }
  };
  return this
});
$c_sci_NewVectorIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var xsLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var srcLen = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((xsLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var total = ((x$1 > 0) ? x$1 : 0);
  var copied = 0;
  var isBoxed = (xs instanceof $ac_O);
  while ((copied < total)) {
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
      $p_sci_NewVectorIterator__advance__V(this)
    };
    var a = ((total - copied) | 0);
    var b = (($n(this.sci_NewVectorIterator__f_a1).u.length - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
    var count = ((a < b) ? a : b);
    if (isBoxed) {
      var src = this.sci_NewVectorIterator__f_a1;
      var srcPos = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1;
      var destPos = ((start + copied) | 0);
      $systemArraycopyFull($n(src), srcPos, $n(xs), destPos, count)
    } else {
      $m_s_Array$().copy__O__I__O__I__I__V(this.sci_NewVectorIterator__f_a1, this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1, xs, ((start + copied) | 0), count)
    };
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + count) | 0);
    copied = ((copied + count) | 0)
  };
  return total
});
$c_sci_NewVectorIterator.prototype.toVector__sci_Vector = (function() {
  return $as_sci_Vector($n(this.sci_NewVectorIterator__f_v).slice__I__I__O(((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + this.sci_NewVectorIterator__f_totalLength) | 0), this.sci_NewVectorIterator__f_totalLength))
});
var $d_sci_NewVectorIterator = new $TypeData().initClass({
  sci_NewVectorIterator: 0
}, false, "scala.collection.immutable.NewVectorIterator", {
  sci_NewVectorIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  jl_Cloneable: 1
});
$c_sci_NewVectorIterator.prototype.$classData = $d_sci_NewVectorIterator;
/** @constructor */
function $c_sci_RangeIterator(start, step, lastElement, initiallyEmpty) {
  this.sci_RangeIterator__f_step = 0;
  this.sci_RangeIterator__f_lastElement = 0;
  this.sci_RangeIterator__f__hasNext = false;
  this.sci_RangeIterator__f__next = 0;
  this.sci_RangeIterator__f_step = step;
  this.sci_RangeIterator__f_lastElement = lastElement;
  this.sci_RangeIterator__f__hasNext = (!initiallyEmpty);
  this.sci_RangeIterator__f__next = start
}
$c_sci_RangeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RangeIterator.prototype.constructor = $c_sci_RangeIterator;
/** @constructor */
function $h_sci_RangeIterator() {
  /*<skip>*/
}
$h_sci_RangeIterator.prototype = $c_sci_RangeIterator.prototype;
$c_sci_RangeIterator.prototype.knownSize__I = (function() {
  return (this.sci_RangeIterator__f__hasNext ? ((1 + $intDiv(((this.sci_RangeIterator__f_lastElement - this.sci_RangeIterator__f__next) | 0), this.sci_RangeIterator__f_step)) | 0) : 0)
});
$c_sci_RangeIterator.prototype.hasNext__Z = (function() {
  return this.sci_RangeIterator__f__hasNext
});
$c_sci_RangeIterator.prototype.next__I = (function() {
  if ((!this.sci_RangeIterator__f__hasNext)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var value = this.sci_RangeIterator__f__next;
  this.sci_RangeIterator__f__hasNext = (value !== this.sci_RangeIterator__f_lastElement);
  this.sci_RangeIterator__f__next = ((value + this.sci_RangeIterator__f_step) | 0);
  return value
});
$c_sci_RangeIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var value = this.sci_RangeIterator__f__next;
    var hi = (value >> 31);
    var value$1 = Math.imul(this.sci_RangeIterator__f_step, n);
    var hi$1 = (value$1 >> 31);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
    if ((this.sci_RangeIterator__f_step > 0)) {
      var value$2 = this.sci_RangeIterator__f_lastElement;
      var hi$3 = (value$2 >> 31);
      if (((hi$3 === hi$2) ? (((-2147483648) ^ value$2) < ((-2147483648) ^ lo)) : (hi$3 < hi$2))) {
        var this$6__lo = value$2;
        var this$6__hi = hi$3
      } else {
        var this$6__lo = lo;
        var this$6__hi = hi$2
      };
      this.sci_RangeIterator__f__next = this$6__lo;
      var value$3 = this.sci_RangeIterator__f_lastElement;
      var hi$4 = (value$3 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$4) ? (((-2147483648) ^ lo) <= ((-2147483648) ^ value$3)) : (hi$2 < hi$4))
    } else if ((this.sci_RangeIterator__f_step < 0)) {
      var value$4 = this.sci_RangeIterator__f_lastElement;
      var hi$5 = (value$4 >> 31);
      if (((hi$5 === hi$2) ? (((-2147483648) ^ value$4) > ((-2147483648) ^ lo)) : (hi$5 > hi$2))) {
        var this$10__lo = value$4;
        var this$10__hi = hi$5
      } else {
        var this$10__lo = lo;
        var this$10__hi = hi$2
      };
      this.sci_RangeIterator__f__next = this$10__lo;
      var value$5 = this.sci_RangeIterator__f_lastElement;
      var hi$6 = (value$5 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$6) ? (((-2147483648) ^ lo) >= ((-2147483648) ^ value$5)) : (hi$2 > hi$6))
    }
  };
  return this
});
$c_sci_RangeIterator.prototype.next__O = (function() {
  return this.next__I()
});
var $d_sci_RangeIterator = new $TypeData().initClass({
  sci_RangeIterator: 0
}, false, "scala.collection.immutable.RangeIterator", {
  sci_RangeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_RangeIterator.prototype.$classData = $d_sci_RangeIterator;
/** @constructor */
function $c_sci_RedBlackTree$EntriesIterator(tree, focus, evidence$20) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, focus, evidence$20)
}
$c_sci_RedBlackTree$EntriesIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$EntriesIterator.prototype.constructor = $c_sci_RedBlackTree$EntriesIterator;
/** @constructor */
function $h_sci_RedBlackTree$EntriesIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$EntriesIterator.prototype = $c_sci_RedBlackTree$EntriesIterator.prototype;
$c_sci_RedBlackTree$EntriesIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  var this$1 = $n(tree);
  var $$x1 = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
  var this$2 = $n(tree);
  return $ct_T2__O__O__(new $c_T2(), $$x1, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value)
});
var $d_sci_RedBlackTree$EntriesIterator = new $TypeData().initClass({
  sci_RedBlackTree$EntriesIterator: 0
}, false, "scala.collection.immutable.RedBlackTree$EntriesIterator", {
  sci_RedBlackTree$EntriesIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_RedBlackTree$EntriesIterator.prototype.$classData = $d_sci_RedBlackTree$EntriesIterator;
/** @constructor */
function $c_sci_RedBlackTree$EqualsIterator(tree, evidence$19) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, $m_s_None$(), evidence$19)
}
$c_sci_RedBlackTree$EqualsIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$EqualsIterator.prototype.constructor = $c_sci_RedBlackTree$EqualsIterator;
/** @constructor */
function $h_sci_RedBlackTree$EqualsIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$EqualsIterator.prototype = $c_sci_RedBlackTree$EqualsIterator.prototype;
$c_sci_RedBlackTree$EqualsIterator.prototype.sameKeys__sci_RedBlackTree$EqualsIterator__Z = (function(that) {
  var equal = true;
  while (((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)) && ($n(that).sci_RedBlackTree$TreeIterator__f_lookahead !== null))) {
    if ((this.sci_RedBlackTree$TreeIterator__f_lookahead === $n(that).sci_RedBlackTree$TreeIterator__f_lookahead)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $$x1 = null
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $$x1 = $n(this.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      };
      this.sci_RedBlackTree$TreeIterator__f_lookahead = $$x1;
      var $$x3 = $n(that);
      var this$1 = $n(that);
      if ((this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $$x2 = null
      } else {
        this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $$x2 = $n(this$1.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get(this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      };
      $$x3.sci_RedBlackTree$TreeIterator__f_lookahead = $$x2
    } else {
      var this$2 = $n(this.sci_RedBlackTree$TreeIterator__f_lookahead);
      var $$x4 = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$3 = $n($n(that).sci_RedBlackTree$TreeIterator__f_lookahead);
      if (Object.is($$x4, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        equal = true
      } else {
        var $$x6 = $n(this.sci_RedBlackTree$TreeIterator__f_ordering);
        var this$4 = $n(this.sci_RedBlackTree$TreeIterator__f_lookahead);
        var $$x5 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
        var this$5 = $n($n(that).sci_RedBlackTree$TreeIterator__f_lookahead);
        equal = $n($$x6).equiv__O__O__Z($$x5, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)
      };
      var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      var this$6 = $n(tree);
      this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      var $$x7 = $n(that);
      $n(that);
      var tree$1 = $n(that).sci_RedBlackTree$TreeIterator__f_lookahead;
      var this$8 = $n(tree$1);
      $$x7.sci_RedBlackTree$TreeIterator__f_lookahead = $n(that).findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  };
  return ((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead === null)) && ($n(that).sci_RedBlackTree$TreeIterator__f_lookahead === null))
});
$c_sci_RedBlackTree$EqualsIterator.prototype.sameEntries__sci_RedBlackTree$EqualsIterator__Z = (function(that) {
  var equal = true;
  while (((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)) && ($n(that).sci_RedBlackTree$TreeIterator__f_lookahead !== null))) {
    if ((this.sci_RedBlackTree$TreeIterator__f_lookahead === $n(that).sci_RedBlackTree$TreeIterator__f_lookahead)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $$x1 = null
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $$x1 = $n(this.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      };
      this.sci_RedBlackTree$TreeIterator__f_lookahead = $$x1;
      var $$x3 = $n(that);
      var this$1 = $n(that);
      if ((this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $$x2 = null
      } else {
        this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $$x2 = $n(this$1.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get(this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      };
      $$x3.sci_RedBlackTree$TreeIterator__f_lookahead = $$x2
    } else {
      var this$2 = $n(this.sci_RedBlackTree$TreeIterator__f_lookahead);
      var $$x5 = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$3 = $n($n(that).sci_RedBlackTree$TreeIterator__f_lookahead);
      if (Object.is($$x5, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        var $$x4 = true
      } else {
        var $$x7 = $n(this.sci_RedBlackTree$TreeIterator__f_ordering);
        var this$4 = $n(this.sci_RedBlackTree$TreeIterator__f_lookahead);
        var $$x6 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
        var this$5 = $n($n(that).sci_RedBlackTree$TreeIterator__f_lookahead);
        var $$x4 = $n($$x7).equiv__O__O__Z($$x6, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)
      };
      if ($$x4) {
        var $$x9 = $m_sr_BoxesRunTime$();
        var this$6 = $n(this.sci_RedBlackTree$TreeIterator__f_lookahead);
        var $$x8 = this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
        var this$7 = $n($n(that).sci_RedBlackTree$TreeIterator__f_lookahead);
        equal = $n($$x9).equals__O__O__Z($$x8, this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value)
      } else {
        equal = false
      };
      var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      var this$8 = $n(tree);
      this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      var $$x10 = $n(that);
      $n(that);
      var tree$1 = $n(that).sci_RedBlackTree$TreeIterator__f_lookahead;
      var this$10 = $n(tree$1);
      $$x10.sci_RedBlackTree$TreeIterator__f_lookahead = $n(that).findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  };
  return ((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead === null)) && ($n(that).sci_RedBlackTree$TreeIterator__f_lookahead === null))
});
$c_sci_RedBlackTree$EqualsIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
var $d_sci_RedBlackTree$EqualsIterator = new $TypeData().initClass({
  sci_RedBlackTree$EqualsIterator: 0
}, false, "scala.collection.immutable.RedBlackTree$EqualsIterator", {
  sci_RedBlackTree$EqualsIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_RedBlackTree$EqualsIterator.prototype.$classData = $d_sci_RedBlackTree$EqualsIterator;
/** @constructor */
function $c_sci_RedBlackTree$KeysIterator(tree, focus, evidence$21) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, focus, evidence$21)
}
$c_sci_RedBlackTree$KeysIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$KeysIterator.prototype.constructor = $c_sci_RedBlackTree$KeysIterator;
/** @constructor */
function $h_sci_RedBlackTree$KeysIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$KeysIterator.prototype = $c_sci_RedBlackTree$KeysIterator.prototype;
$c_sci_RedBlackTree$KeysIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  var this$1 = $n(tree);
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key
});
var $d_sci_RedBlackTree$KeysIterator = new $TypeData().initClass({
  sci_RedBlackTree$KeysIterator: 0
}, false, "scala.collection.immutable.RedBlackTree$KeysIterator", {
  sci_RedBlackTree$KeysIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_RedBlackTree$KeysIterator.prototype.$classData = $d_sci_RedBlackTree$KeysIterator;
function $ct_sci_Set$SetNIterator__I__($thiz, n) {
  $thiz.sci_Set$SetNIterator__f_current = 0;
  $thiz.sci_Set$SetNIterator__f_remainder = n;
  return $thiz
}
/** @constructor */
function $c_sci_Set$SetNIterator() {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0
}
$c_sci_Set$SetNIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Set$SetNIterator.prototype.constructor = $c_sci_Set$SetNIterator;
/** @constructor */
function $h_sci_Set$SetNIterator() {
  /*<skip>*/
}
$h_sci_Set$SetNIterator.prototype = $c_sci_Set$SetNIterator.prototype;
$c_sci_Set$SetNIterator.prototype.knownSize__I = (function() {
  return this.sci_Set$SetNIterator__f_remainder
});
$c_sci_Set$SetNIterator.prototype.hasNext__Z = (function() {
  return (this.sci_Set$SetNIterator__f_remainder > 0)
});
$c_sci_Set$SetNIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.apply__I__O(this.sci_Set$SetNIterator__f_current);
    this.sci_Set$SetNIterator__f_current = ((1 + this.sci_Set$SetNIterator__f_current) | 0);
    this.sci_Set$SetNIterator__f_remainder = (((-1) + this.sci_Set$SetNIterator__f_remainder) | 0);
    return r
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  }
});
$c_sci_Set$SetNIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sci_Set$SetNIterator__f_current = ((this.sci_Set$SetNIterator__f_current + n) | 0);
    var b = ((this.sci_Set$SetNIterator__f_remainder - n) | 0);
    this.sci_Set$SetNIterator__f_remainder = ((b < 0) ? 0 : b)
  };
  return this
});
/** @constructor */
function $c_sci_SetHashIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  this.sci_SetHashIterator__f_hash = 0;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
  this.sci_SetHashIterator__f_hash = 0
}
$c_sci_SetHashIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetHashIterator.prototype.constructor = $c_sci_SetHashIterator;
/** @constructor */
function $h_sci_SetHashIterator() {
  /*<skip>*/
}
$h_sci_SetHashIterator.prototype = $c_sci_SetHashIterator.prototype;
$c_sci_SetHashIterator.prototype.hashCode__I = (function() {
  return this.sci_SetHashIterator__f_hash
});
$c_sci_SetHashIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  this.sci_SetHashIterator__f_hash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return this
});
var $d_sci_SetHashIterator = new $TypeData().initClass({
  sci_SetHashIterator: 0
}, false, "scala.collection.immutable.SetHashIterator", {
  sci_SetHashIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_SetHashIterator.prototype.$classData = $d_sci_SetHashIterator;
/** @constructor */
function $c_sci_SetIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_SetIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetIterator.prototype.constructor = $c_sci_SetIterator;
/** @constructor */
function $h_sci_SetIterator() {
  /*<skip>*/
}
$h_sci_SetIterator.prototype = $c_sci_SetIterator.prototype;
$c_sci_SetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var payload = $n($as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload
});
var $d_sci_SetIterator = new $TypeData().initClass({
  sci_SetIterator: 0
}, false, "scala.collection.immutable.SetIterator", {
  sci_SetIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_SetIterator.prototype.$classData = $d_sci_SetIterator;
function $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps($thiz, that) {
  var this$3 = $n($n(that).iterator__sc_Iterator());
  var f = ((x$1$2, x$2$2) => {
    var x$1 = $as_sci_SetOps(x$1$2);
    var this$2 = $n(x$1);
    return this$2.excl__O__sci_SetOps(x$2$2)
  });
  if ($is_sc_IndexedSeq(this$3)) {
    var x2 = $as_sc_IndexedSeq(this$3);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = $thiz;
    var $$x1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f(arg1, arg2);
        at = temp$at;
        acc = temp$acc;
        continue
      };
      var $$x1 = acc;
      break
    }
  } else {
    var result = $thiz;
    while (this$3.hasNext__Z()) {
      var arg1$1 = result;
      var arg2$1 = this$3.next__O();
      result = f(arg1$1, arg2$1)
    };
    var $$x1 = result
  };
  return $as_sci_SetOps($$x1)
}
function $is_sci_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SetOps)))
}
function $as_sci_SetOps(obj) {
  return (($is_sci_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetOps"))
}
function $isArrayOf_sci_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetOps)))
}
function $asArrayOf_sci_SetOps(obj, depth) {
  return (($isArrayOf_sci_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetOps;", depth))
}
/** @constructor */
function $c_sci_SortedSet$() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
  var delegate = $m_sci_TreeSet$();
  $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__(this, delegate)
}
$c_sci_SortedSet$.prototype = new $h_sc_SortedIterableFactory$Delegate();
$c_sci_SortedSet$.prototype.constructor = $c_sci_SortedSet$;
/** @constructor */
function $h_sci_SortedSet$() {
  /*<skip>*/
}
$h_sci_SortedSet$.prototype = $c_sci_SortedSet$.prototype;
$c_sci_SortedSet$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_SortedSet = (function(it, evidence$1) {
  if ($is_sci_SortedSet(it)) {
    var x2 = $as_sci_SortedSet(it);
    $n($m_s_package$().s_package$__f_Ordering);
    var x$2 = $n(x2).ordering__s_math_Ordering();
    if (((evidence$1 === null) ? (x$2 === null) : $n(evidence$1).equals__O__Z(x$2))) {
      return x2
    }
  };
  return $as_sci_SortedSet($c_sc_EvidenceIterableFactory$Delegate.prototype.from__sc_IterableOnce__O__O.call(this, it, evidence$1))
});
$c_sci_SortedSet$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$20) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_SortedSet(it, $as_s_math_Ordering(evidence$20))
});
var $d_sci_SortedSet$ = new $TypeData().initClass({
  sci_SortedSet$: 0
}, false, "scala.collection.immutable.SortedSet$", {
  sci_SortedSet$: 1,
  sc_SortedIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory$Delegate: 1,
  O: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SortedIterableFactory: 1
});
$c_sci_SortedSet$.prototype.$classData = $d_sci_SortedSet$;
var $n_sci_SortedSet$;
function $m_sci_SortedSet$() {
  if ((!$n_sci_SortedSet$)) {
    $n_sci_SortedSet$ = new $c_sci_SortedSet$()
  };
  return $n_sci_SortedSet$
}
function $ct_scm_ArrayBuilder__($thiz) {
  $thiz.scm_ArrayBuilder__f_capacity = 0;
  return $thiz
}
/** @constructor */
function $c_scm_ArrayBuilder() {
  this.scm_ArrayBuilder__f_capacity = 0
}
$c_scm_ArrayBuilder.prototype = new $h_O();
$c_scm_ArrayBuilder.prototype.constructor = $c_scm_ArrayBuilder;
/** @constructor */
function $h_scm_ArrayBuilder() {
  /*<skip>*/
}
$h_scm_ArrayBuilder.prototype = $c_scm_ArrayBuilder.prototype;
$c_scm_ArrayBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_ArrayBuilder.prototype.addAll__O__scm_ArrayBuilder = (function(xs) {
  var length = $m_jl_reflect_Array$().getLength__O__I(xs);
  return this.addAll__O__I__I__scm_ArrayBuilder$generic(xs, 0, length)
});
/** @constructor */
function $c_scm_ArraySeq$() {
  this.scm_ArraySeq$__f_untagged = null;
  this.scm_ArraySeq$__f_EmptyArraySeq = null;
  $n_scm_ArraySeq$ = this;
  this.scm_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
  this.scm_ArraySeq$__f_EmptyArraySeq = new $c_scm_ArraySeq$ofRef(new $ac_O(0))
}
$c_scm_ArraySeq$.prototype = new $h_O();
$c_scm_ArraySeq$.prototype.constructor = $c_scm_ArraySeq$;
/** @constructor */
function $h_scm_ArraySeq$() {
  /*<skip>*/
}
$h_scm_ArraySeq$.prototype = $c_scm_ArraySeq$.prototype;
$c_scm_ArraySeq$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq(xs, $as_s_reflect_ClassTag(evidence$7))
});
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq = (function(it, evidence$2) {
  return this.make__O__scm_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, evidence$2))
});
$c_scm_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$3) {
  var this$4 = new $c_scm_ArrayBuilder$generic($n(evidence$3).runtimeClass__jl_Class());
  var f = new $c_sjsr_AnonFunction1(((x$2) => $m_scm_ArraySeq$().make__O__scm_ArraySeq(x$2)));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_scm_ArraySeq$.prototype.make__O__scm_ArraySeq = (function(x) {
  if ((x === null)) {
    return null
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_scm_ArraySeq$ofRef(x3)
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_scm_ArraySeq$ofInt(x4)
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_scm_ArraySeq$ofDouble(x5)
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_scm_ArraySeq$ofLong(x6)
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_scm_ArraySeq$ofFloat(x7)
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_scm_ArraySeq$ofChar(x8)
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_scm_ArraySeq$ofByte(x9)
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_scm_ArraySeq$ofShort(x10)
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_scm_ArraySeq$ofBoolean(x11)
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_scm_ArraySeq$ofUnit(x12)
  } else {
    throw new $c_s_MatchError(x)
  }
});
$c_scm_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder($as_s_reflect_ClassTag(evidence$12))
});
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5))
});
$c_scm_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return this.scm_ArraySeq$__f_EmptyArraySeq
});
var $d_scm_ArraySeq$ = new $TypeData().initClass({
  scm_ArraySeq$: 0
}, false, "scala.collection.mutable.ArraySeq$", {
  scm_ArraySeq$: 1,
  O: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$.prototype.$classData = $d_scm_ArraySeq$;
var $n_scm_ArraySeq$;
function $m_scm_ArraySeq$() {
  if ((!$n_scm_ArraySeq$)) {
    $n_scm_ArraySeq$ = new $c_scm_ArraySeq$()
  };
  return $n_scm_ArraySeq$
}
/** @constructor */
function $c_scm_HashMap$$anon$1(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$1.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$1.prototype.constructor = $c_scm_HashMap$$anon$1;
/** @constructor */
function $h_scm_HashMap$$anon$1() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$1.prototype = $c_scm_HashMap$$anon$1.prototype;
$c_scm_HashMap$$anon$1.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return $ct_T2__O__O__(new $c_T2(), $n(nd).scm_HashMap$Node__f__key, $n(nd).scm_HashMap$Node__f__value)
});
var $d_scm_HashMap$$anon$1 = new $TypeData().initClass({
  scm_HashMap$$anon$1: 0
}, false, "scala.collection.mutable.HashMap$$anon$1", {
  scm_HashMap$$anon$1: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$1.prototype.$classData = $d_scm_HashMap$$anon$1;
/** @constructor */
function $c_scm_HashMap$$anon$2(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$2.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$2.prototype.constructor = $c_scm_HashMap$$anon$2;
/** @constructor */
function $h_scm_HashMap$$anon$2() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$2.prototype = $c_scm_HashMap$$anon$2.prototype;
$c_scm_HashMap$$anon$2.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return $n(nd).scm_HashMap$Node__f__key
});
var $d_scm_HashMap$$anon$2 = new $TypeData().initClass({
  scm_HashMap$$anon$2: 0
}, false, "scala.collection.mutable.HashMap$$anon$2", {
  scm_HashMap$$anon$2: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$2.prototype.$classData = $d_scm_HashMap$$anon$2;
/** @constructor */
function $c_scm_HashMap$$anon$3(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$3.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$3.prototype.constructor = $c_scm_HashMap$$anon$3;
/** @constructor */
function $h_scm_HashMap$$anon$3() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$3.prototype = $c_scm_HashMap$$anon$3.prototype;
$c_scm_HashMap$$anon$3.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return $n(nd).scm_HashMap$Node__f__value
});
var $d_scm_HashMap$$anon$3 = new $TypeData().initClass({
  scm_HashMap$$anon$3: 0
}, false, "scala.collection.mutable.HashMap$$anon$3", {
  scm_HashMap$$anon$3: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$3.prototype.$classData = $d_scm_HashMap$$anon$3;
/** @constructor */
function $c_scm_HashMap$$anon$4(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$4.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$4.prototype.constructor = $c_scm_HashMap$$anon$4;
/** @constructor */
function $h_scm_HashMap$$anon$4() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$4.prototype = $c_scm_HashMap$$anon$4.prototype;
$c_scm_HashMap$$anon$4.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd
});
var $d_scm_HashMap$$anon$4 = new $TypeData().initClass({
  scm_HashMap$$anon$4: 0
}, false, "scala.collection.mutable.HashMap$$anon$4", {
  scm_HashMap$$anon$4: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$4.prototype.$classData = $d_scm_HashMap$$anon$4;
/** @constructor */
function $c_scm_HashMap$$anon$5(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  this.scm_HashMap$$anon$5__f_hash = 0;
  this.scm_HashMap$$anon$5__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.scm_HashMap$$anon$5__f_$outer = outer
  };
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
  this.scm_HashMap$$anon$5__f_hash = 0
}
$c_scm_HashMap$$anon$5.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$5.prototype.constructor = $c_scm_HashMap$$anon$5;
/** @constructor */
function $h_scm_HashMap$$anon$5() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$5.prototype = $c_scm_HashMap$$anon$5.prototype;
$c_scm_HashMap$$anon$5.prototype.hashCode__I = (function() {
  return this.scm_HashMap$$anon$5__f_hash
});
$c_scm_HashMap$$anon$5.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  var $$x1 = $m_s_util_hashing_MurmurHash3$();
  $n(this.scm_HashMap$$anon$5__f_$outer);
  var improvedHash = $n(nd).scm_HashMap$Node__f__hash;
  var x = $n(nd).scm_HashMap$Node__f__value;
  this.scm_HashMap$$anon$5__f_hash = $n($$x1).tuple2Hash__O__O__I((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().anyHash__O__I(x));
  return this
});
var $d_scm_HashMap$$anon$5 = new $TypeData().initClass({
  scm_HashMap$$anon$5: 0
}, false, "scala.collection.mutable.HashMap$$anon$5", {
  scm_HashMap$$anon$5: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$5.prototype.$classData = $d_scm_HashMap$$anon$5;
/** @constructor */
function $c_scm_HashSet$$anon$1(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer)
}
$c_scm_HashSet$$anon$1.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$1.prototype.constructor = $c_scm_HashSet$$anon$1;
/** @constructor */
function $h_scm_HashSet$$anon$1() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$1.prototype = $c_scm_HashSet$$anon$1.prototype;
$c_scm_HashSet$$anon$1.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return $n(nd).scm_HashSet$Node__f__key
});
var $d_scm_HashSet$$anon$1 = new $TypeData().initClass({
  scm_HashSet$$anon$1: 0
}, false, "scala.collection.mutable.HashSet$$anon$1", {
  scm_HashSet$$anon$1: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashSet$$anon$1.prototype.$classData = $d_scm_HashSet$$anon$1;
/** @constructor */
function $c_scm_HashSet$$anon$2(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer)
}
$c_scm_HashSet$$anon$2.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$2.prototype.constructor = $c_scm_HashSet$$anon$2;
/** @constructor */
function $h_scm_HashSet$$anon$2() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$2.prototype = $c_scm_HashSet$$anon$2.prototype;
$c_scm_HashSet$$anon$2.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return nd
});
var $d_scm_HashSet$$anon$2 = new $TypeData().initClass({
  scm_HashSet$$anon$2: 0
}, false, "scala.collection.mutable.HashSet$$anon$2", {
  scm_HashSet$$anon$2: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashSet$$anon$2.prototype.$classData = $d_scm_HashSet$$anon$2;
/** @constructor */
function $c_scm_HashSet$$anon$3(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  this.scm_HashSet$$anon$3__f_hash = 0;
  this.scm_HashSet$$anon$3__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.scm_HashSet$$anon$3__f_$outer = outer
  };
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
  this.scm_HashSet$$anon$3__f_hash = 0
}
$c_scm_HashSet$$anon$3.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$3.prototype.constructor = $c_scm_HashSet$$anon$3;
/** @constructor */
function $h_scm_HashSet$$anon$3() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$3.prototype = $c_scm_HashSet$$anon$3.prototype;
$c_scm_HashSet$$anon$3.prototype.hashCode__I = (function() {
  return this.scm_HashSet$$anon$3__f_hash
});
$c_scm_HashSet$$anon$3.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  var this$1 = $n(this.scm_HashSet$$anon$3__f_$outer);
  var improvedHash = $n(nd).scm_HashSet$Node__f__hash;
  this.scm_HashSet$$anon$3__f_hash = this$1.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
  return this
});
var $d_scm_HashSet$$anon$3 = new $TypeData().initClass({
  scm_HashSet$$anon$3: 0
}, false, "scala.collection.mutable.HashSet$$anon$3", {
  scm_HashSet$$anon$3: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashSet$$anon$3.prototype.$classData = $d_scm_HashSet$$anon$3;
/** @constructor */
function $c_scm_RedBlackTree$KeysIterator(tree, start, end, evidence$7) {
  this.scm_RedBlackTree$TreeIterator__f_end = null;
  this.scm_RedBlackTree$TreeIterator__f_ord = null;
  this.scm_RedBlackTree$TreeIterator__f_nextNode = null;
  $ct_scm_RedBlackTree$TreeIterator__scm_RedBlackTree$Tree__s_Option__s_Option__s_math_Ordering__(this, tree, start, end, evidence$7)
}
$c_scm_RedBlackTree$KeysIterator.prototype = new $h_scm_RedBlackTree$TreeIterator();
$c_scm_RedBlackTree$KeysIterator.prototype.constructor = $c_scm_RedBlackTree$KeysIterator;
/** @constructor */
function $h_scm_RedBlackTree$KeysIterator() {
  /*<skip>*/
}
$h_scm_RedBlackTree$KeysIterator.prototype = $c_scm_RedBlackTree$KeysIterator.prototype;
var $d_scm_RedBlackTree$KeysIterator = new $TypeData().initClass({
  scm_RedBlackTree$KeysIterator: 0
}, false, "scala.collection.mutable.RedBlackTree$KeysIterator", {
  scm_RedBlackTree$KeysIterator: 1,
  scm_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_RedBlackTree$KeysIterator.prototype.$classData = $d_scm_RedBlackTree$KeysIterator;
/** @constructor */
function $c_scm_SortedSet$() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
  var delegate = $m_scm_TreeSet$();
  $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__(this, delegate)
}
$c_scm_SortedSet$.prototype = new $h_sc_SortedIterableFactory$Delegate();
$c_scm_SortedSet$.prototype.constructor = $c_scm_SortedSet$;
/** @constructor */
function $h_scm_SortedSet$() {
  /*<skip>*/
}
$h_scm_SortedSet$.prototype = $c_scm_SortedSet$.prototype;
var $d_scm_SortedSet$ = new $TypeData().initClass({
  scm_SortedSet$: 0
}, false, "scala.collection.mutable.SortedSet$", {
  scm_SortedSet$: 1,
  sc_SortedIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory$Delegate: 1,
  O: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SortedIterableFactory: 1
});
$c_scm_SortedSet$.prototype.$classData = $d_scm_SortedSet$;
var $n_scm_SortedSet$;
function $m_scm_SortedSet$() {
  if ((!$n_scm_SortedSet$)) {
    $n_scm_SortedSet$ = new $c_scm_SortedSet$()
  };
  return $n_scm_SortedSet$
}
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$1() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$1.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$1.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$1() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$1.prototype = $c_s_concurrent_duration_Duration$$anon$1.prototype;
$c_s_concurrent_duration_Duration$$anon$1.prototype.toString__T = (function() {
  return "Duration.Undefined"
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.equals__O__Z = (function(other) {
  return false
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  return this
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : 1)
});
var $d_s_concurrent_duration_Duration$$anon$1 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$1: 0
}, false, "scala.concurrent.duration.Duration$$anon$1", {
  s_concurrent_duration_Duration$$anon$1: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$2() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$2.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$2.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$2() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$2.prototype = $c_s_concurrent_duration_Duration$$anon$2.prototype;
$c_s_concurrent_duration_Duration$$anon$2.prototype.toString__T = (function() {
  return "Duration.Inf"
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined) ? (-1) : ((other === this) ? 0 : 1))
});
var $d_s_concurrent_duration_Duration$$anon$2 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$2: 0
}, false, "scala.concurrent.duration.Duration$$anon$2", {
  s_concurrent_duration_Duration$$anon$2: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$3() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$3.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$3.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$3() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$3.prototype = $c_s_concurrent_duration_Duration$$anon$3.prototype;
$c_s_concurrent_duration_Duration$$anon$3.prototype.toString__T = (function() {
  return "Duration.MinusInf"
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : (-1))
});
var $d_s_concurrent_duration_Duration$$anon$3 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$3: 0
}, false, "scala.concurrent.duration.Duration$$anon$3", {
  s_concurrent_duration_Duration$$anon$3: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $c_s_math_LowPriorityOrderingImplicits$$anon$2(outer, asComparable$1) {
  this.s_math_LowPriorityOrderingImplicits$$anon$2__f_asComparable$1 = null;
  this.s_math_LowPriorityOrderingImplicits$$anon$2__f_asComparable$1 = asComparable$1
}
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype = new $h_O();
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.constructor = $c_s_math_LowPriorityOrderingImplicits$$anon$2;
/** @constructor */
function $h_s_math_LowPriorityOrderingImplicits$$anon$2() {
  /*<skip>*/
}
$h_s_math_LowPriorityOrderingImplicits$$anon$2.prototype = $c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype;
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return $dp_compareTo__O__I($n($as_jl_Comparable($n(this.s_math_LowPriorityOrderingImplicits$$anon$2__f_asComparable$1).apply__O__O(x))), y)
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
var $d_s_math_LowPriorityOrderingImplicits$$anon$2 = new $TypeData().initClass({
  s_math_LowPriorityOrderingImplicits$$anon$2: 0
}, false, "scala.math.LowPriorityOrderingImplicits$$anon$2", {
  s_math_LowPriorityOrderingImplicits$$anon$2: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.$classData = $d_s_math_LowPriorityOrderingImplicits$$anon$2;
/** @constructor */
function $c_s_math_Ordering$$anon$1(outer, f$1) {
  this.s_math_Ordering$$anon$1__f_$outer = null;
  this.s_math_Ordering$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.s_math_Ordering$$anon$1__f_$outer = outer
  };
  this.s_math_Ordering$$anon$1__f_f$1 = f$1
}
$c_s_math_Ordering$$anon$1.prototype = new $h_O();
$c_s_math_Ordering$$anon$1.prototype.constructor = $c_s_math_Ordering$$anon$1;
/** @constructor */
function $h_s_math_Ordering$$anon$1() {
  /*<skip>*/
}
$h_s_math_Ordering$$anon$1.prototype = $c_s_math_Ordering$$anon$1.prototype;
$c_s_math_Ordering$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.s_math_Ordering$$anon$1__f_$outer).compare__O__O__I($n(this.s_math_Ordering$$anon$1__f_f$1).apply__O__O(x), $n(this.s_math_Ordering$$anon$1__f_f$1).apply__O__O(y))
});
$c_s_math_Ordering$$anon$1.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
var $d_s_math_Ordering$$anon$1 = new $TypeData().initClass({
  s_math_Ordering$$anon$1: 0
}, false, "scala.math.Ordering$$anon$1", {
  s_math_Ordering$$anon$1: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$$anon$1.prototype.$classData = $d_s_math_Ordering$$anon$1;
/** @constructor */
function $c_s_math_Ordering$$anon$4(cmp$2) {
  this.s_math_Ordering$$anon$4__f_cmp$2 = null;
  this.s_math_Ordering$$anon$4__f_cmp$2 = cmp$2
}
$c_s_math_Ordering$$anon$4.prototype = new $h_O();
$c_s_math_Ordering$$anon$4.prototype.constructor = $c_s_math_Ordering$$anon$4;
/** @constructor */
function $h_s_math_Ordering$$anon$4() {
  /*<skip>*/
}
$h_s_math_Ordering$$anon$4.prototype = $c_s_math_Ordering$$anon$4.prototype;
$c_s_math_Ordering$$anon$4.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$4.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$$anon$4.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$$anon$4.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$$anon$4.prototype.compare__O__O__I = (function(x, y) {
  return ($uZ($n(this.s_math_Ordering$$anon$4__f_cmp$2).apply__O__O__O(x, y)) ? (-1) : ($uZ($n(this.s_math_Ordering$$anon$4__f_cmp$2).apply__O__O__O(y, x)) ? 1 : 0))
});
$c_s_math_Ordering$$anon$4.prototype.lt__O__O__Z = (function(x, y) {
  return $uZ($n(this.s_math_Ordering$$anon$4__f_cmp$2).apply__O__O__O(x, y))
});
$c_s_math_Ordering$$anon$4.prototype.gt__O__O__Z = (function(x, y) {
  return $uZ($n(this.s_math_Ordering$$anon$4__f_cmp$2).apply__O__O__O(y, x))
});
$c_s_math_Ordering$$anon$4.prototype.gteq__O__O__Z = (function(x, y) {
  return (!$uZ($n(this.s_math_Ordering$$anon$4__f_cmp$2).apply__O__O__O(x, y)))
});
$c_s_math_Ordering$$anon$4.prototype.lteq__O__O__Z = (function(x, y) {
  return (!$uZ($n(this.s_math_Ordering$$anon$4__f_cmp$2).apply__O__O__O(y, x)))
});
$c_s_math_Ordering$$anon$4.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
var $d_s_math_Ordering$$anon$4 = new $TypeData().initClass({
  s_math_Ordering$$anon$4: 0
}, false, "scala.math.Ordering$$anon$4", {
  s_math_Ordering$$anon$4: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$$anon$4.prototype.$classData = $d_s_math_Ordering$$anon$4;
/** @constructor */
function $c_s_math_Ordering$$anon$5(ord$2, f$3) {
  this.s_math_Ordering$$anon$5__f_ord$2 = null;
  this.s_math_Ordering$$anon$5__f_f$3 = null;
  this.s_math_Ordering$$anon$5__f_ord$2 = ord$2;
  this.s_math_Ordering$$anon$5__f_f$3 = f$3
}
$c_s_math_Ordering$$anon$5.prototype = new $h_O();
$c_s_math_Ordering$$anon$5.prototype.constructor = $c_s_math_Ordering$$anon$5;
/** @constructor */
function $h_s_math_Ordering$$anon$5() {
  /*<skip>*/
}
$h_s_math_Ordering$$anon$5.prototype = $c_s_math_Ordering$$anon$5.prototype;
$c_s_math_Ordering$$anon$5.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$5.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$$anon$5.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$$anon$5.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$$anon$5.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.s_math_Ordering$$anon$5__f_ord$2).compare__O__O__I($n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(x), $n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(y))
});
$c_s_math_Ordering$$anon$5.prototype.lt__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$$anon$5__f_ord$2).lt__O__O__Z($n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(x), $n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(y))
});
$c_s_math_Ordering$$anon$5.prototype.gt__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$$anon$5__f_ord$2).gt__O__O__Z($n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(x), $n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(y))
});
$c_s_math_Ordering$$anon$5.prototype.gteq__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$$anon$5__f_ord$2).gteq__O__O__Z($n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(x), $n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(y))
});
$c_s_math_Ordering$$anon$5.prototype.lteq__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$$anon$5__f_ord$2).lteq__O__O__Z($n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(x), $n(this.s_math_Ordering$$anon$5__f_f$3).apply__O__O(y))
});
$c_s_math_Ordering$$anon$5.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
var $d_s_math_Ordering$$anon$5 = new $TypeData().initClass({
  s_math_Ordering$$anon$5: 0
}, false, "scala.math.Ordering$$anon$5", {
  s_math_Ordering$$anon$5: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$$anon$5.prototype.$classData = $d_s_math_Ordering$$anon$5;
function $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($thiz, other) {
  return (other === $thiz.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)
}
function $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z($thiz, x, y) {
  return (x <= y)
}
function $f_s_math_Ordering$Double$IeeeOrdering__gteq__D__D__Z($thiz, x, y) {
  return (x >= y)
}
function $f_s_math_Ordering$Double$IeeeOrdering__lt__D__D__Z($thiz, x, y) {
  return (x < y)
}
function $f_s_math_Ordering$Double$IeeeOrdering__gt__D__D__Z($thiz, x, y) {
  return (x > y)
}
function $f_s_math_Ordering$Double$IeeeOrdering__equiv__D__D__Z($thiz, x, y) {
  return (x === y)
}
function $f_s_math_Ordering$OptionOrdering__compare__s_Option__s_Option__I($thiz, x, y) {
  var x1 = $ct_T2__O__O__(new $c_T2(), x, y);
  var p2 = $as_s_Option(x1.T2__f__1);
  var p3 = $as_s_Option(x1.T2__f__2);
  var x$2 = $m_s_None$();
  if ((x$2 === p2)) {
    var x$4 = $m_s_None$();
    var $$x1 = (x$4 === p3)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return 0
  };
  var p6 = $as_s_Option(x1.T2__f__1);
  var x$6 = $m_s_None$();
  if ((x$6 === p6)) {
    return (-1)
  };
  var p10 = $as_s_Option(x1.T2__f__2);
  var x$8 = $m_s_None$();
  if ((x$8 === p10)) {
    return 1
  };
  var p12 = $as_s_Option(x1.T2__f__1);
  var p13 = $as_s_Option(x1.T2__f__2);
  if ((p12 instanceof $c_s_Some)) {
    var x14 = $as_s_Some(p12);
    var x$10 = $n(x14).s_Some__f_value;
    if ((p13 instanceof $c_s_Some)) {
      var x15 = $as_s_Some(p13);
      var y$2 = $n(x15).s_Some__f_value;
      return $n($thiz.s_math_Ordering$O$1__f_optionOrdering).compare__O__O__I(x$10, y$2)
    }
  };
  throw new $c_s_MatchError(x1)
}
function $f_s_math_Ordering$OptionOrdering__equals__O__Z($thiz, obj) {
  if ((obj !== null)) {
    if (($thiz === obj)) {
      return true
    }
  };
  if ($is_s_math_Ordering$OptionOrdering(obj)) {
    var x3 = $as_s_math_Ordering$OptionOrdering(obj);
    var x = $thiz.s_math_Ordering$O$1__f_optionOrdering;
    var x$2 = $n(x3).s_math_Ordering$O$1__f_optionOrdering;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  };
  return false
}
function $f_s_math_Ordering$OptionOrdering__hashCode__I($thiz) {
  return Math.imul(43, $n($thiz.s_math_Ordering$O$1__f_optionOrdering).hashCode__I())
}
function $is_s_math_Ordering$OptionOrdering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Ordering$OptionOrdering)))
}
function $as_s_math_Ordering$OptionOrdering(obj) {
  return (($is_s_math_Ordering$OptionOrdering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$OptionOrdering"))
}
function $isArrayOf_s_math_Ordering$OptionOrdering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$OptionOrdering)))
}
function $asArrayOf_s_math_Ordering$OptionOrdering(obj, depth) {
  return (($isArrayOf_s_math_Ordering$OptionOrdering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$OptionOrdering;", depth))
}
/** @constructor */
function $c_s_math_Ordering$Reverse(outer) {
  this.s_math_Ordering$Reverse__f_outer = null;
  this.s_math_Ordering$Reverse__f_outer = outer
}
$c_s_math_Ordering$Reverse.prototype = new $h_O();
$c_s_math_Ordering$Reverse.prototype.constructor = $c_s_math_Ordering$Reverse;
/** @constructor */
function $h_s_math_Ordering$Reverse() {
  /*<skip>*/
}
$h_s_math_Ordering$Reverse.prototype = $c_s_math_Ordering$Reverse.prototype;
$c_s_math_Ordering$Reverse.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  var x$2 = this.s_math_Ordering$Reverse__f_outer;
  return ((other === null) ? (x$2 === null) : $n(other).equals__O__Z(x$2))
});
$c_s_math_Ordering$Reverse.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).compare__O__O__I(y, x)
});
$c_s_math_Ordering$Reverse.prototype.lteq__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).lteq__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.gteq__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).gteq__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.lt__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).lt__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.gt__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).gt__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.equiv__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).equiv__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.max__O__O__O = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).min__O__O__O(x, y)
});
$c_s_math_Ordering$Reverse.prototype.min__O__O__O = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).max__O__O__O(x, y)
});
$c_s_math_Ordering$Reverse.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true
    }
  };
  if ((obj instanceof $c_s_math_Ordering$Reverse)) {
    var x3 = $as_s_math_Ordering$Reverse(obj);
    var x = this.s_math_Ordering$Reverse__f_outer;
    var x$2 = $n(x3).s_math_Ordering$Reverse__f_outer;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  };
  return false
});
$c_s_math_Ordering$Reverse.prototype.hashCode__I = (function() {
  return Math.imul(41, $n(this.s_math_Ordering$Reverse__f_outer).hashCode__I())
});
$c_s_math_Ordering$Reverse.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
function $as_s_math_Ordering$Reverse(obj) {
  return (((obj instanceof $c_s_math_Ordering$Reverse) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$Reverse"))
}
function $isArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Reverse)))
}
function $asArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (($isArrayOf_s_math_Ordering$Reverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$Reverse;", depth))
}
var $d_s_math_Ordering$Reverse = new $TypeData().initClass({
  s_math_Ordering$Reverse: 0
}, false, "scala.math.Ordering$Reverse", {
  s_math_Ordering$Reverse: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Reverse.prototype.$classData = $d_s_math_Ordering$Reverse;
/** @constructor */
function $c_s_math_Ordering$Tuple2Ordering(ord1, ord2) {
  this.s_math_Ordering$Tuple2Ordering__f_ord1 = null;
  this.s_math_Ordering$Tuple2Ordering__f_ord2 = null;
  this.s_math_Ordering$Tuple2Ordering__f_ord1 = ord1;
  this.s_math_Ordering$Tuple2Ordering__f_ord2 = ord2
}
$c_s_math_Ordering$Tuple2Ordering.prototype = new $h_O();
$c_s_math_Ordering$Tuple2Ordering.prototype.constructor = $c_s_math_Ordering$Tuple2Ordering;
/** @constructor */
function $h_s_math_Ordering$Tuple2Ordering() {
  /*<skip>*/
}
$h_s_math_Ordering$Tuple2Ordering.prototype = $c_s_math_Ordering$Tuple2Ordering.prototype;
$c_s_math_Ordering$Tuple2Ordering.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.compare__T2__T2__I = (function(x, y) {
  var compare1 = $n(this.s_math_Ordering$Tuple2Ordering__f_ord1).compare__O__O__I($n(x)._1__O(), $n(y)._1__O());
  if ((compare1 !== 0)) {
    return compare1
  };
  return $n(this.s_math_Ordering$Tuple2Ordering__f_ord2).compare__O__O__I($n(x)._2__O(), $n(y)._2__O())
});
$c_s_math_Ordering$Tuple2Ordering.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true
    }
  };
  if ((obj instanceof $c_s_math_Ordering$Tuple2Ordering)) {
    var x3 = $as_s_math_Ordering$Tuple2Ordering(obj);
    var x = this.s_math_Ordering$Tuple2Ordering__f_ord1;
    var x$2 = $n(x3).s_math_Ordering$Tuple2Ordering__f_ord1;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.s_math_Ordering$Tuple2Ordering__f_ord2;
      var x$4 = $n(x3).s_math_Ordering$Tuple2Ordering__f_ord2;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  };
  return false
});
$c_s_math_Ordering$Tuple2Ordering.prototype.hashCode__I = (function() {
  var _1 = this.s_math_Ordering$Tuple2Ordering__f_ord1;
  var _2 = this.s_math_Ordering$Tuple2Ordering__f_ord2;
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  var h = (-889275714);
  h = this$2.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  var i = 0;
  while ((i < 2)) {
    var $$x1 = h;
    var n = i;
    switch (n) {
      case 0: {
        var x = _1;
        break
      }
      case 1: {
        var x = _2;
        break
      }
      default: {
        var x;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"))
      }
    };
    h = this$2.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0)
  };
  return this$2.finalizeHash__I__I__I(h, 2)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y))
});
function $as_s_math_Ordering$Tuple2Ordering(obj) {
  return (((obj instanceof $c_s_math_Ordering$Tuple2Ordering) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$Tuple2Ordering"))
}
function $isArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Tuple2Ordering)))
}
function $asArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) {
  return (($isArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$Tuple2Ordering;", depth))
}
var $d_s_math_Ordering$Tuple2Ordering = new $TypeData().initClass({
  s_math_Ordering$Tuple2Ordering: 0
}, false, "scala.math.Ordering$Tuple2Ordering", {
  s_math_Ordering$Tuple2Ordering: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Tuple2Ordering.prototype.$classData = $d_s_math_Ordering$Tuple2Ordering;
/** @constructor */
function $c_s_math_Ordering$Tuple3Ordering(ord1, ord2, ord3) {
  this.s_math_Ordering$Tuple3Ordering__f_ord1 = null;
  this.s_math_Ordering$Tuple3Ordering__f_ord2 = null;
  this.s_math_Ordering$Tuple3Ordering__f_ord3 = null;
  this.s_math_Ordering$Tuple3Ordering__f_ord1 = ord1;
  this.s_math_Ordering$Tuple3Ordering__f_ord2 = ord2;
  this.s_math_Ordering$Tuple3Ordering__f_ord3 = ord3
}
$c_s_math_Ordering$Tuple3Ordering.prototype = new $h_O();
$c_s_math_Ordering$Tuple3Ordering.prototype.constructor = $c_s_math_Ordering$Tuple3Ordering;
/** @constructor */
function $h_s_math_Ordering$Tuple3Ordering() {
  /*<skip>*/
}
$h_s_math_Ordering$Tuple3Ordering.prototype = $c_s_math_Ordering$Tuple3Ordering.prototype;
$c_s_math_Ordering$Tuple3Ordering.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.compare__T3__T3__I = (function(x, y) {
  var compare1 = $n(this.s_math_Ordering$Tuple3Ordering__f_ord1).compare__O__O__I($n(x).T3__f__1, $n(y).T3__f__1);
  if ((compare1 !== 0)) {
    return compare1
  };
  var compare2 = $n(this.s_math_Ordering$Tuple3Ordering__f_ord2).compare__O__O__I($n(x).T3__f__2, $n(y).T3__f__2);
  if ((compare2 !== 0)) {
    return compare2
  };
  return $n(this.s_math_Ordering$Tuple3Ordering__f_ord3).compare__O__O__I($n(x).T3__f__3, $n(y).T3__f__3)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true
    }
  };
  if ((obj instanceof $c_s_math_Ordering$Tuple3Ordering)) {
    var x3 = $as_s_math_Ordering$Tuple3Ordering(obj);
    var x = this.s_math_Ordering$Tuple3Ordering__f_ord1;
    var x$2 = $n(x3).s_math_Ordering$Tuple3Ordering__f_ord1;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.s_math_Ordering$Tuple3Ordering__f_ord2;
      var x$4 = $n(x3).s_math_Ordering$Tuple3Ordering__f_ord2;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.s_math_Ordering$Tuple3Ordering__f_ord3;
      var x$6 = $n(x3).s_math_Ordering$Tuple3Ordering__f_ord3;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
    } else {
      return false
    }
  };
  return false
});
$c_s_math_Ordering$Tuple3Ordering.prototype.hashCode__I = (function() {
  var _1 = this.s_math_Ordering$Tuple3Ordering__f_ord1;
  var _2 = this.s_math_Ordering$Tuple3Ordering__f_ord2;
  var _3 = this.s_math_Ordering$Tuple3Ordering__f_ord3;
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  var h = (-889275714);
  h = this$2.mix__I__I__I(h, $f_T__hashCode__I("Tuple3"));
  var i = 0;
  while ((i < 3)) {
    var $$x1 = h;
    var n = i;
    switch (n) {
      case 0: {
        var x = _1;
        break
      }
      case 1: {
        var x = _2;
        break
      }
      case 2: {
        var x = _3;
        break
      }
      default: {
        var x;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"))
      }
    };
    h = this$2.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0)
  };
  return this$2.finalizeHash__I__I__I(h, 3)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$Tuple3Ordering.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T3__T3__I($as_T3(x), $as_T3(y))
});
function $as_s_math_Ordering$Tuple3Ordering(obj) {
  return (((obj instanceof $c_s_math_Ordering$Tuple3Ordering) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$Tuple3Ordering"))
}
function $isArrayOf_s_math_Ordering$Tuple3Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Tuple3Ordering)))
}
function $asArrayOf_s_math_Ordering$Tuple3Ordering(obj, depth) {
  return (($isArrayOf_s_math_Ordering$Tuple3Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$Tuple3Ordering;", depth))
}
var $d_s_math_Ordering$Tuple3Ordering = new $TypeData().initClass({
  s_math_Ordering$Tuple3Ordering: 0
}, false, "scala.math.Ordering$Tuple3Ordering", {
  s_math_Ordering$Tuple3Ordering: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Tuple3Ordering.prototype.$classData = $d_s_math_Ordering$Tuple3Ordering;
/** @constructor */
function $c_s_reflect_ClassTag$GenericClassTag(runtimeClass) {
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = null;
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = runtimeClass
}
$c_s_reflect_ClassTag$GenericClassTag.prototype = new $h_O();
$c_s_reflect_ClassTag$GenericClassTag.prototype.constructor = $c_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $h_s_reflect_ClassTag$GenericClassTag() {
  /*<skip>*/
}
$h_s_reflect_ClassTag$GenericClassTag.prototype = $c_s_reflect_ClassTag$GenericClassTag.prototype;
$c_s_reflect_ClassTag$GenericClassTag.prototype.unapply__O__s_Option = (function(x) {
  return $f_s_reflect_ClassTag__unapply__O__s_Option(this, x)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.equals__O__Z = (function(x) {
  return $f_s_reflect_ClassTag__equals__O__Z(this, x)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.hashCode__I = (function() {
  var x = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_sr_Statics$().anyHash__O__I(x)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.toString__T = (function() {
  return $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this, this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.runtimeClass__jl_Class = (function() {
  return this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.newArray__I__O = (function(len) {
  var componentType = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, len)
});
var $d_s_reflect_ClassTag$GenericClassTag = new $TypeData().initClass({
  s_reflect_ClassTag$GenericClassTag: 0
}, false, "scala.reflect.ClassTag$GenericClassTag", {
  s_reflect_ClassTag$GenericClassTag: 1,
  O: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.$classData = $d_s_reflect_ClassTag$GenericClassTag;
function $p_s_util_matching_Regex$MatchIterator__ensure__V($thiz) {
  var x1 = $thiz.s_util_matching_Regex$MatchIterator__f_nextSeen;
  switch (x1) {
    case 0: {
      if ((!$thiz.hasNext__Z())) {
        throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException())
      };
      break
    }
    case 1: {
      break
    }
    case 2: {
      break
    }
    case 3: {
      throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_s_util_matching_Regex$MatchIterator(source, regex, _groupNames) {
  this.s_util_matching_Regex$MatchIterator__f_source = null;
  this.s_util_matching_Regex$MatchIterator__f__groupNames = null;
  this.s_util_matching_Regex$MatchIterator__f_matcher = null;
  this.s_util_matching_Regex$MatchIterator__f_nextSeen = 0;
  this.s_util_matching_Regex$MatchIterator__f_source = source;
  this.s_util_matching_Regex$MatchIterator__f__groupNames = _groupNames;
  var this$1 = $n($n(regex).s_util_matching_Regex__f_pattern);
  this.s_util_matching_Regex$MatchIterator__f_matcher = new $c_ju_regex_Matcher(this$1, $dp_toString__T($n(source)));
  this.s_util_matching_Regex$MatchIterator__f_nextSeen = 0
}
$c_s_util_matching_Regex$MatchIterator.prototype = new $h_sc_AbstractIterator();
$c_s_util_matching_Regex$MatchIterator.prototype.constructor = $c_s_util_matching_Regex$MatchIterator;
/** @constructor */
function $h_s_util_matching_Regex$MatchIterator() {
  /*<skip>*/
}
$h_s_util_matching_Regex$MatchIterator.prototype = $c_s_util_matching_Regex$MatchIterator.prototype;
$c_s_util_matching_Regex$MatchIterator.prototype.source__jl_CharSequence = (function() {
  return this.s_util_matching_Regex$MatchIterator__f_source
});
$c_s_util_matching_Regex$MatchIterator.prototype.hasNext__Z = (function() {
  var x1 = this.s_util_matching_Regex$MatchIterator__f_nextSeen;
  switch (x1) {
    case 0: {
      this.s_util_matching_Regex$MatchIterator__f_nextSeen = ($n(this.s_util_matching_Regex$MatchIterator__f_matcher).find__Z() ? 1 : 3);
      break
    }
    case 1: {
      break
    }
    case 2: {
      this.s_util_matching_Regex$MatchIterator__f_nextSeen = 0;
      this.hasNext__Z();
      break
    }
    case 3: {
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  return (this.s_util_matching_Regex$MatchIterator__f_nextSeen === 1)
});
$c_s_util_matching_Regex$MatchIterator.prototype.next__T = (function() {
  var x1 = this.s_util_matching_Regex$MatchIterator__f_nextSeen;
  switch (x1) {
    case 0: {
      if ((!this.hasNext__Z())) {
        throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
      };
      this.next__T();
      break
    }
    case 1: {
      this.s_util_matching_Regex$MatchIterator__f_nextSeen = 2;
      break
    }
    case 2: {
      this.s_util_matching_Regex$MatchIterator__f_nextSeen = 0;
      this.next__T();
      break
    }
    case 3: {
      throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException());
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  return $n(this.s_util_matching_Regex$MatchIterator__f_matcher).group__T()
});
$c_s_util_matching_Regex$MatchIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_s_util_matching_Regex$MatchIterator.prototype.start__I = (function() {
  $p_s_util_matching_Regex$MatchIterator__ensure__V(this);
  return $n(this.s_util_matching_Regex$MatchIterator__f_matcher).start__I()
});
$c_s_util_matching_Regex$MatchIterator.prototype.start__I__I = (function(i) {
  $p_s_util_matching_Regex$MatchIterator__ensure__V(this);
  return $n(this.s_util_matching_Regex$MatchIterator__f_matcher).start__I__I(i)
});
$c_s_util_matching_Regex$MatchIterator.prototype.end__I = (function() {
  $p_s_util_matching_Regex$MatchIterator__ensure__V(this);
  return $n(this.s_util_matching_Regex$MatchIterator__f_matcher).end__I()
});
$c_s_util_matching_Regex$MatchIterator.prototype.end__I__I = (function(i) {
  $p_s_util_matching_Regex$MatchIterator__ensure__V(this);
  return $n(this.s_util_matching_Regex$MatchIterator__f_matcher).end__I__I(i)
});
$c_s_util_matching_Regex$MatchIterator.prototype.next__O = (function() {
  return this.next__T()
});
var $d_s_util_matching_Regex$MatchIterator = new $TypeData().initClass({
  s_util_matching_Regex$MatchIterator: 0
}, false, "scala.util.matching.Regex$MatchIterator", {
  s_util_matching_Regex$MatchIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  s_util_matching_Regex$MatchData: 1
});
$c_s_util_matching_Regex$MatchIterator.prototype.$classData = $d_s_util_matching_Regex$MatchIterator;
/** @constructor */
function $c_s_util_matching_Regex$MatchIterator$$anon$4(outer) {
  this.s_util_matching_Regex$MatchIterator$$anon$4__f_scala$util$matching$Regex$Replacement$$sb = null;
  this.s_util_matching_Regex$MatchIterator$$anon$4__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.s_util_matching_Regex$MatchIterator$$anon$4__f_$outer = outer
  };
  this.s_util_matching_Regex$MatchIterator$$anon$4__f_scala$util$matching$Regex$Replacement$$sb = $ct_jl_StringBuffer__(new $c_jl_StringBuffer())
}
$c_s_util_matching_Regex$MatchIterator$$anon$4.prototype = new $h_sc_AbstractIterator();
$c_s_util_matching_Regex$MatchIterator$$anon$4.prototype.constructor = $c_s_util_matching_Regex$MatchIterator$$anon$4;
/** @constructor */
function $h_s_util_matching_Regex$MatchIterator$$anon$4() {
  /*<skip>*/
}
$h_s_util_matching_Regex$MatchIterator$$anon$4.prototype = $c_s_util_matching_Regex$MatchIterator$$anon$4.prototype;
$c_s_util_matching_Regex$MatchIterator$$anon$4.prototype.matcher__ju_regex_Matcher = (function() {
  return $n(this.s_util_matching_Regex$MatchIterator$$anon$4__f_$outer).s_util_matching_Regex$MatchIterator__f_matcher
});
$c_s_util_matching_Regex$MatchIterator$$anon$4.prototype.hasNext__Z = (function() {
  return $n(this.s_util_matching_Regex$MatchIterator$$anon$4__f_$outer).hasNext__Z()
});
$c_s_util_matching_Regex$MatchIterator$$anon$4.prototype.next__s_util_matching_Regex$Match = (function() {
  $n(this.s_util_matching_Regex$MatchIterator$$anon$4__f_$outer).next__T();
  return new $c_s_util_matching_Regex$Match($n(this.s_util_matching_Regex$MatchIterator$$anon$4__f_$outer).s_util_matching_Regex$MatchIterator__f_source, this.matcher__ju_regex_Matcher(), $n(this.s_util_matching_Regex$MatchIterator$$anon$4__f_$outer).s_util_matching_Regex$MatchIterator__f__groupNames).force__s_util_matching_Regex$Match()
});
$c_s_util_matching_Regex$MatchIterator$$anon$4.prototype.next__O = (function() {
  return this.next__s_util_matching_Regex$Match()
});
var $d_s_util_matching_Regex$MatchIterator$$anon$4 = new $TypeData().initClass({
  s_util_matching_Regex$MatchIterator$$anon$4: 0
}, false, "scala.util.matching.Regex$MatchIterator$$anon$4", {
  s_util_matching_Regex$MatchIterator$$anon$4: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  s_util_matching_Regex$Replacement: 1
});
$c_s_util_matching_Regex$MatchIterator$$anon$4.prototype.$classData = $d_s_util_matching_Regex$MatchIterator$$anon$4;
/** @constructor */
function $c_Lscalacss_internal_AttrCmp$Overlap$() {
  /*<skip>*/
}
$c_Lscalacss_internal_AttrCmp$Overlap$.prototype = new $h_Lscalacss_internal_AttrCmp$Conflict();
$c_Lscalacss_internal_AttrCmp$Overlap$.prototype.constructor = $c_Lscalacss_internal_AttrCmp$Overlap$;
/** @constructor */
function $h_Lscalacss_internal_AttrCmp$Overlap$() {
  /*<skip>*/
}
$h_Lscalacss_internal_AttrCmp$Overlap$.prototype = $c_Lscalacss_internal_AttrCmp$Overlap$.prototype;
$c_Lscalacss_internal_AttrCmp$Overlap$.prototype.productPrefix__T = (function() {
  return "Overlap"
});
$c_Lscalacss_internal_AttrCmp$Overlap$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_AttrCmp$Overlap$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_AttrCmp$Overlap$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_AttrCmp$Overlap$.prototype.hashCode__I = (function() {
  return 573365287
});
$c_Lscalacss_internal_AttrCmp$Overlap$.prototype.toString__T = (function() {
  return "Overlap"
});
var $d_Lscalacss_internal_AttrCmp$Overlap$ = new $TypeData().initClass({
  Lscalacss_internal_AttrCmp$Overlap$: 0
}, false, "scalacss.internal.AttrCmp$Overlap$", {
  Lscalacss_internal_AttrCmp$Overlap$: 1,
  Lscalacss_internal_AttrCmp$Conflict: 1,
  Lscalacss_internal_AttrCmp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_AttrCmp$Overlap$.prototype.$classData = $d_Lscalacss_internal_AttrCmp$Overlap$;
var $n_Lscalacss_internal_AttrCmp$Overlap$;
function $m_Lscalacss_internal_AttrCmp$Overlap$() {
  if ((!$n_Lscalacss_internal_AttrCmp$Overlap$)) {
    $n_Lscalacss_internal_AttrCmp$Overlap$ = new $c_Lscalacss_internal_AttrCmp$Overlap$()
  };
  return $n_Lscalacss_internal_AttrCmp$Overlap$
}
/** @constructor */
function $c_Lscalacss_internal_AttrCmp$Same$() {
  /*<skip>*/
}
$c_Lscalacss_internal_AttrCmp$Same$.prototype = new $h_Lscalacss_internal_AttrCmp$Conflict();
$c_Lscalacss_internal_AttrCmp$Same$.prototype.constructor = $c_Lscalacss_internal_AttrCmp$Same$;
/** @constructor */
function $h_Lscalacss_internal_AttrCmp$Same$() {
  /*<skip>*/
}
$h_Lscalacss_internal_AttrCmp$Same$.prototype = $c_Lscalacss_internal_AttrCmp$Same$.prototype;
$c_Lscalacss_internal_AttrCmp$Same$.prototype.productPrefix__T = (function() {
  return "Same"
});
$c_Lscalacss_internal_AttrCmp$Same$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_AttrCmp$Same$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_AttrCmp$Same$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_AttrCmp$Same$.prototype.hashCode__I = (function() {
  return 2569350
});
$c_Lscalacss_internal_AttrCmp$Same$.prototype.toString__T = (function() {
  return "Same"
});
var $d_Lscalacss_internal_AttrCmp$Same$ = new $TypeData().initClass({
  Lscalacss_internal_AttrCmp$Same$: 0
}, false, "scalacss.internal.AttrCmp$Same$", {
  Lscalacss_internal_AttrCmp$Same$: 1,
  Lscalacss_internal_AttrCmp$Conflict: 1,
  Lscalacss_internal_AttrCmp: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_AttrCmp$Same$.prototype.$classData = $d_Lscalacss_internal_AttrCmp$Same$;
var $n_Lscalacss_internal_AttrCmp$Same$;
function $m_Lscalacss_internal_AttrCmp$Same$() {
  if ((!$n_Lscalacss_internal_AttrCmp$Same$)) {
    $n_Lscalacss_internal_AttrCmp$Same$ = new $c_Lscalacss_internal_AttrCmp$Same$()
  };
  return $n_Lscalacss_internal_AttrCmp$Same$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$backgroundColor$() {
  this.Lscalacss_internal_Attrs$backgroundColor$__f_attr = null;
  $n_Lscalacss_internal_Attrs$backgroundColor$ = this;
  this.Lscalacss_internal_Attrs$backgroundColor$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("background-color")
}
$c_Lscalacss_internal_Attrs$backgroundColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor();
$c_Lscalacss_internal_Attrs$backgroundColor$.prototype.constructor = $c_Lscalacss_internal_Attrs$backgroundColor$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$backgroundColor$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$backgroundColor$.prototype = $c_Lscalacss_internal_Attrs$backgroundColor$.prototype;
$c_Lscalacss_internal_Attrs$backgroundColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$backgroundColor$__f_attr
});
var $d_Lscalacss_internal_Attrs$backgroundColor$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$backgroundColor$: 0
}, false, "scalacss.internal.Attrs$backgroundColor$", {
  Lscalacss_internal_Attrs$backgroundColor$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fColor: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$backgroundColor$.prototype.$classData = $d_Lscalacss_internal_Attrs$backgroundColor$;
var $n_Lscalacss_internal_Attrs$backgroundColor$;
function $m_Lscalacss_internal_Attrs$backgroundColor$() {
  if ((!$n_Lscalacss_internal_Attrs$backgroundColor$)) {
    $n_Lscalacss_internal_Attrs$backgroundColor$ = new $c_Lscalacss_internal_Attrs$backgroundColor$()
  };
  return $n_Lscalacss_internal_Attrs$backgroundColor$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderBottomColor$() {
  this.Lscalacss_internal_Attrs$borderBottomColor$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderBottomColor$ = this;
  this.Lscalacss_internal_Attrs$borderBottomColor$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-bottom-color")
}
$c_Lscalacss_internal_Attrs$borderBottomColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor();
$c_Lscalacss_internal_Attrs$borderBottomColor$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderBottomColor$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderBottomColor$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderBottomColor$.prototype = $c_Lscalacss_internal_Attrs$borderBottomColor$.prototype;
$c_Lscalacss_internal_Attrs$borderBottomColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderBottomColor$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderBottomColor$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderBottomColor$: 0
}, false, "scalacss.internal.Attrs$borderBottomColor$", {
  Lscalacss_internal_Attrs$borderBottomColor$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fColor: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$borderBottomColor$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderBottomColor$;
var $n_Lscalacss_internal_Attrs$borderBottomColor$;
function $m_Lscalacss_internal_Attrs$borderBottomColor$() {
  if ((!$n_Lscalacss_internal_Attrs$borderBottomColor$)) {
    $n_Lscalacss_internal_Attrs$borderBottomColor$ = new $c_Lscalacss_internal_Attrs$borderBottomColor$()
  };
  return $n_Lscalacss_internal_Attrs$borderBottomColor$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderBottomWidth$() {
  this.Lscalacss_internal_Attrs$borderBottomWidth$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderBottomWidth$ = this;
  this.Lscalacss_internal_Attrs$borderBottomWidth$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-bottom-width")
}
$c_Lscalacss_internal_Attrs$borderBottomWidth$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth();
$c_Lscalacss_internal_Attrs$borderBottomWidth$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderBottomWidth$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderBottomWidth$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderBottomWidth$.prototype = $c_Lscalacss_internal_Attrs$borderBottomWidth$.prototype;
$c_Lscalacss_internal_Attrs$borderBottomWidth$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderBottomWidth$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderBottomWidth$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderBottomWidth$: 0
}, false, "scalacss.internal.Attrs$borderBottomWidth$", {
  Lscalacss_internal_Attrs$borderBottomWidth$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderBottomWidth$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderBottomWidth$;
var $n_Lscalacss_internal_Attrs$borderBottomWidth$;
function $m_Lscalacss_internal_Attrs$borderBottomWidth$() {
  if ((!$n_Lscalacss_internal_Attrs$borderBottomWidth$)) {
    $n_Lscalacss_internal_Attrs$borderBottomWidth$ = new $c_Lscalacss_internal_Attrs$borderBottomWidth$()
  };
  return $n_Lscalacss_internal_Attrs$borderBottomWidth$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderLeftColor$() {
  this.Lscalacss_internal_Attrs$borderLeftColor$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderLeftColor$ = this;
  this.Lscalacss_internal_Attrs$borderLeftColor$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-left-color")
}
$c_Lscalacss_internal_Attrs$borderLeftColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor();
$c_Lscalacss_internal_Attrs$borderLeftColor$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderLeftColor$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderLeftColor$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderLeftColor$.prototype = $c_Lscalacss_internal_Attrs$borderLeftColor$.prototype;
$c_Lscalacss_internal_Attrs$borderLeftColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderLeftColor$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderLeftColor$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderLeftColor$: 0
}, false, "scalacss.internal.Attrs$borderLeftColor$", {
  Lscalacss_internal_Attrs$borderLeftColor$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fColor: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$borderLeftColor$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderLeftColor$;
var $n_Lscalacss_internal_Attrs$borderLeftColor$;
function $m_Lscalacss_internal_Attrs$borderLeftColor$() {
  if ((!$n_Lscalacss_internal_Attrs$borderLeftColor$)) {
    $n_Lscalacss_internal_Attrs$borderLeftColor$ = new $c_Lscalacss_internal_Attrs$borderLeftColor$()
  };
  return $n_Lscalacss_internal_Attrs$borderLeftColor$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderLeftWidth$() {
  this.Lscalacss_internal_Attrs$borderLeftWidth$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderLeftWidth$ = this;
  this.Lscalacss_internal_Attrs$borderLeftWidth$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-left-width")
}
$c_Lscalacss_internal_Attrs$borderLeftWidth$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth();
$c_Lscalacss_internal_Attrs$borderLeftWidth$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderLeftWidth$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderLeftWidth$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderLeftWidth$.prototype = $c_Lscalacss_internal_Attrs$borderLeftWidth$.prototype;
$c_Lscalacss_internal_Attrs$borderLeftWidth$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderLeftWidth$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderLeftWidth$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderLeftWidth$: 0
}, false, "scalacss.internal.Attrs$borderLeftWidth$", {
  Lscalacss_internal_Attrs$borderLeftWidth$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderLeftWidth$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderLeftWidth$;
var $n_Lscalacss_internal_Attrs$borderLeftWidth$;
function $m_Lscalacss_internal_Attrs$borderLeftWidth$() {
  if ((!$n_Lscalacss_internal_Attrs$borderLeftWidth$)) {
    $n_Lscalacss_internal_Attrs$borderLeftWidth$ = new $c_Lscalacss_internal_Attrs$borderLeftWidth$()
  };
  return $n_Lscalacss_internal_Attrs$borderLeftWidth$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderRightColor$() {
  this.Lscalacss_internal_Attrs$borderRightColor$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderRightColor$ = this;
  this.Lscalacss_internal_Attrs$borderRightColor$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-right-color")
}
$c_Lscalacss_internal_Attrs$borderRightColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor();
$c_Lscalacss_internal_Attrs$borderRightColor$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderRightColor$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderRightColor$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderRightColor$.prototype = $c_Lscalacss_internal_Attrs$borderRightColor$.prototype;
$c_Lscalacss_internal_Attrs$borderRightColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderRightColor$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderRightColor$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderRightColor$: 0
}, false, "scalacss.internal.Attrs$borderRightColor$", {
  Lscalacss_internal_Attrs$borderRightColor$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fColor: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$borderRightColor$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderRightColor$;
var $n_Lscalacss_internal_Attrs$borderRightColor$;
function $m_Lscalacss_internal_Attrs$borderRightColor$() {
  if ((!$n_Lscalacss_internal_Attrs$borderRightColor$)) {
    $n_Lscalacss_internal_Attrs$borderRightColor$ = new $c_Lscalacss_internal_Attrs$borderRightColor$()
  };
  return $n_Lscalacss_internal_Attrs$borderRightColor$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderRightWidth$() {
  this.Lscalacss_internal_Attrs$borderRightWidth$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderRightWidth$ = this;
  this.Lscalacss_internal_Attrs$borderRightWidth$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-right-width")
}
$c_Lscalacss_internal_Attrs$borderRightWidth$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth();
$c_Lscalacss_internal_Attrs$borderRightWidth$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderRightWidth$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderRightWidth$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderRightWidth$.prototype = $c_Lscalacss_internal_Attrs$borderRightWidth$.prototype;
$c_Lscalacss_internal_Attrs$borderRightWidth$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderRightWidth$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderRightWidth$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderRightWidth$: 0
}, false, "scalacss.internal.Attrs$borderRightWidth$", {
  Lscalacss_internal_Attrs$borderRightWidth$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderRightWidth$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderRightWidth$;
var $n_Lscalacss_internal_Attrs$borderRightWidth$;
function $m_Lscalacss_internal_Attrs$borderRightWidth$() {
  if ((!$n_Lscalacss_internal_Attrs$borderRightWidth$)) {
    $n_Lscalacss_internal_Attrs$borderRightWidth$ = new $c_Lscalacss_internal_Attrs$borderRightWidth$()
  };
  return $n_Lscalacss_internal_Attrs$borderRightWidth$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderTopColor$() {
  this.Lscalacss_internal_Attrs$borderTopColor$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderTopColor$ = this;
  this.Lscalacss_internal_Attrs$borderTopColor$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-top-color")
}
$c_Lscalacss_internal_Attrs$borderTopColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor();
$c_Lscalacss_internal_Attrs$borderTopColor$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderTopColor$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderTopColor$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderTopColor$.prototype = $c_Lscalacss_internal_Attrs$borderTopColor$.prototype;
$c_Lscalacss_internal_Attrs$borderTopColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderTopColor$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderTopColor$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderTopColor$: 0
}, false, "scalacss.internal.Attrs$borderTopColor$", {
  Lscalacss_internal_Attrs$borderTopColor$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fColor: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$borderTopColor$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderTopColor$;
var $n_Lscalacss_internal_Attrs$borderTopColor$;
function $m_Lscalacss_internal_Attrs$borderTopColor$() {
  if ((!$n_Lscalacss_internal_Attrs$borderTopColor$)) {
    $n_Lscalacss_internal_Attrs$borderTopColor$ = new $c_Lscalacss_internal_Attrs$borderTopColor$()
  };
  return $n_Lscalacss_internal_Attrs$borderTopColor$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderTopWidth$() {
  this.Lscalacss_internal_Attrs$borderTopWidth$__f_attr = null;
  $n_Lscalacss_internal_Attrs$borderTopWidth$ = this;
  this.Lscalacss_internal_Attrs$borderTopWidth$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("border-top-width")
}
$c_Lscalacss_internal_Attrs$borderTopWidth$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth();
$c_Lscalacss_internal_Attrs$borderTopWidth$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderTopWidth$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderTopWidth$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderTopWidth$.prototype = $c_Lscalacss_internal_Attrs$borderTopWidth$.prototype;
$c_Lscalacss_internal_Attrs$borderTopWidth$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderTopWidth$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderTopWidth$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderTopWidth$: 0
}, false, "scalacss.internal.Attrs$borderTopWidth$", {
  Lscalacss_internal_Attrs$borderTopWidth$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$borderTopWidth$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderTopWidth$;
var $n_Lscalacss_internal_Attrs$borderTopWidth$;
function $m_Lscalacss_internal_Attrs$borderTopWidth$() {
  if ((!$n_Lscalacss_internal_Attrs$borderTopWidth$)) {
    $n_Lscalacss_internal_Attrs$borderTopWidth$ = new $c_Lscalacss_internal_Attrs$borderTopWidth$()
  };
  return $n_Lscalacss_internal_Attrs$borderTopWidth$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$color$() {
  this.Lscalacss_internal_Attrs$color$__f_attr = null;
  $n_Lscalacss_internal_Attrs$color$ = this;
  this.Lscalacss_internal_Attrs$color$__f_attr = $m_Lscalacss_internal_Attr$().real__T__Lscalacss_internal_Attr("color")
}
$c_Lscalacss_internal_Attrs$color$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor();
$c_Lscalacss_internal_Attrs$color$.prototype.constructor = $c_Lscalacss_internal_Attrs$color$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$color$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$color$.prototype = $c_Lscalacss_internal_Attrs$color$.prototype;
$c_Lscalacss_internal_Attrs$color$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$color$__f_attr
});
var $d_Lscalacss_internal_Attrs$color$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$color$: 0
}, false, "scalacss.internal.Attrs$color$", {
  Lscalacss_internal_Attrs$color$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fColor: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$color$.prototype.$classData = $d_Lscalacss_internal_Attrs$color$;
var $n_Lscalacss_internal_Attrs$color$;
function $m_Lscalacss_internal_Attrs$color$() {
  if ((!$n_Lscalacss_internal_Attrs$color$)) {
    $n_Lscalacss_internal_Attrs$color$ = new $c_Lscalacss_internal_Attrs$color$()
  };
  return $n_Lscalacss_internal_Attrs$color$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$outlineColor$() {
  this.Lscalacss_internal_Attrs$outlineColor$__f_attr = null;
  $n_Lscalacss_internal_Attrs$outlineColor$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_outline;
  this.Lscalacss_internal_Attrs$outlineColor$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("outline-color", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$outlineColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor();
$c_Lscalacss_internal_Attrs$outlineColor$.prototype.constructor = $c_Lscalacss_internal_Attrs$outlineColor$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$outlineColor$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$outlineColor$.prototype = $c_Lscalacss_internal_Attrs$outlineColor$.prototype;
$c_Lscalacss_internal_Attrs$outlineColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$outlineColor$__f_attr
});
var $d_Lscalacss_internal_Attrs$outlineColor$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$outlineColor$: 0
}, false, "scalacss.internal.Attrs$outlineColor$", {
  Lscalacss_internal_Attrs$outlineColor$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fColor: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$outlineColor$.prototype.$classData = $d_Lscalacss_internal_Attrs$outlineColor$;
var $n_Lscalacss_internal_Attrs$outlineColor$;
function $m_Lscalacss_internal_Attrs$outlineColor$() {
  if ((!$n_Lscalacss_internal_Attrs$outlineColor$)) {
    $n_Lscalacss_internal_Attrs$outlineColor$ = new $c_Lscalacss_internal_Attrs$outlineColor$()
  };
  return $n_Lscalacss_internal_Attrs$outlineColor$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$outlineWidth$() {
  this.Lscalacss_internal_Attrs$outlineWidth$__f_attr = null;
  $n_Lscalacss_internal_Attrs$outlineWidth$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_outline;
  this.Lscalacss_internal_Attrs$outlineWidth$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("outline-width", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$outlineWidth$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth();
$c_Lscalacss_internal_Attrs$outlineWidth$.prototype.constructor = $c_Lscalacss_internal_Attrs$outlineWidth$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$outlineWidth$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$outlineWidth$.prototype = $c_Lscalacss_internal_Attrs$outlineWidth$.prototype;
$c_Lscalacss_internal_Attrs$outlineWidth$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$outlineWidth$__f_attr
});
var $d_Lscalacss_internal_Attrs$outlineWidth$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$outlineWidth$: 0
}, false, "scalacss.internal.Attrs$outlineWidth$", {
  Lscalacss_internal_Attrs$outlineWidth$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidth: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1
});
$c_Lscalacss_internal_Attrs$outlineWidth$.prototype.$classData = $d_Lscalacss_internal_Attrs$outlineWidth$;
var $n_Lscalacss_internal_Attrs$outlineWidth$;
function $m_Lscalacss_internal_Attrs$outlineWidth$() {
  if ((!$n_Lscalacss_internal_Attrs$outlineWidth$)) {
    $n_Lscalacss_internal_Attrs$outlineWidth$ = new $c_Lscalacss_internal_Attrs$outlineWidth$()
  };
  return $n_Lscalacss_internal_Attrs$outlineWidth$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$textDecorationColor$() {
  this.Lscalacss_internal_Attrs$textDecorationColor$__f_attr = null;
  $n_Lscalacss_internal_Attrs$textDecorationColor$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_textDecoration;
  this.Lscalacss_internal_Attrs$textDecorationColor$__f_attr = $n($$x1).real__T__Lscalacss_internal_Transform__Lscalacss_internal_Attr("text-decoration-color", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))
}
$c_Lscalacss_internal_Attrs$textDecorationColor$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fColor();
$c_Lscalacss_internal_Attrs$textDecorationColor$.prototype.constructor = $c_Lscalacss_internal_Attrs$textDecorationColor$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$textDecorationColor$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$textDecorationColor$.prototype = $c_Lscalacss_internal_Attrs$textDecorationColor$.prototype;
$c_Lscalacss_internal_Attrs$textDecorationColor$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$textDecorationColor$__f_attr
});
var $d_Lscalacss_internal_Attrs$textDecorationColor$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$textDecorationColor$: 0
}, false, "scalacss.internal.Attrs$textDecorationColor$", {
  Lscalacss_internal_Attrs$textDecorationColor$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fColor: 1,
  Lscalacss_internal_ValueT$TypedAttrT1: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$textDecorationColor$.prototype.$classData = $d_Lscalacss_internal_Attrs$textDecorationColor$;
var $n_Lscalacss_internal_Attrs$textDecorationColor$;
function $m_Lscalacss_internal_Attrs$textDecorationColor$() {
  if ((!$n_Lscalacss_internal_Attrs$textDecorationColor$)) {
    $n_Lscalacss_internal_Attrs$textDecorationColor$ = new $c_Lscalacss_internal_Attrs$textDecorationColor$()
  };
  return $n_Lscalacss_internal_Attrs$textDecorationColor$
}
/** @constructor */
function $c_Lscalacss_internal_Dsl$() {
  this.Lscalacss_internal_DslBase__f_StyleS = null;
  $ct_Lscalacss_internal_DslBase__(this)
}
$c_Lscalacss_internal_Dsl$.prototype = new $h_Lscalacss_internal_DslBase();
$c_Lscalacss_internal_Dsl$.prototype.constructor = $c_Lscalacss_internal_Dsl$;
/** @constructor */
function $h_Lscalacss_internal_Dsl$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Dsl$.prototype = $c_Lscalacss_internal_Dsl$.prototype;
$c_Lscalacss_internal_Dsl$.prototype.styleS__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS = (function(t, c) {
  return this.style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c)
});
$c_Lscalacss_internal_Dsl$.prototype.style__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS = (function(className, t, c) {
  var qual$1 = this.style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c);
  var this$1 = $n($m_s_Option$().apply__O__s_Option(className));
  if (this$1.isEmpty__Z()) {
    var x$1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var value = $as_T(arg1);
    var x$1 = new $c_s_Some(new $c_Lscalacss_internal_ClassName(value))
  };
  var this$2 = $n(qual$1);
  var x$2 = this$2.Lscalacss_internal_StyleS__f_data;
  var this$3 = $n(qual$1);
  var x$3 = this$3.Lscalacss_internal_StyleS__f_unsafeExts;
  var this$4 = $n(qual$1);
  var x$4 = this$4.Lscalacss_internal_StyleS__f_addClassNames;
  var this$5 = $n(qual$1);
  var x$5 = this$5.Lscalacss_internal_StyleS__f_warnings;
  $n(qual$1);
  return new $c_Lscalacss_internal_StyleS(x$2, x$3, x$1, x$4, x$5)
});
$c_Lscalacss_internal_Dsl$.prototype.style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS = (function(t, c) {
  if ($n(t).isEmpty__Z()) {
    return $n(this.Lscalacss_internal_DslBase__f_StyleS).Lscalacss_internal_StyleS$__f_empty
  } else {
    var this$4 = $n($as_sc_IterableOnceOps($n(t).map__F1__O(new $c_sjsr_AnonFunction1(((x$8$2) => {
      var x$8 = $n($as_Lscalacss_internal_DslBase$ToStyle(x$8$2)).Lscalacss_internal_DslBase$ToStyle__f_s;
      return x$8
    })))));
    var op = new $c_sjsr_AnonFunction2(((x$9$2, x$10$2) => {
      var x$9 = $as_Lscalacss_internal_StyleS(x$9$2);
      var x$10 = $as_Lscalacss_internal_StyleS(x$10$2);
      var this$3 = $n(x$9);
      return $n(c).apply__Lscalacss_internal_StyleS__Lscalacss_internal_StyleS__Lscalacss_internal_StyleS(this$3, x$10)
    }));
    return $as_Lscalacss_internal_StyleS(this$4.reduceLeft__F2__O(op))
  }
});
var $d_Lscalacss_internal_Dsl$ = new $TypeData().initClass({
  Lscalacss_internal_Dsl$: 0
}, false, "scalacss.internal.Dsl$", {
  Lscalacss_internal_Dsl$: 1,
  Lscalacss_internal_DslBase: 1,
  Lscalacss_internal_AttrAliasesAndValueTRules: 1,
  Lscalacss_internal_ValueT$Rules: 1,
  O: 1,
  Lscalacss_internal_TypedLiteralAliases: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Dsl$.prototype.$classData = $d_Lscalacss_internal_Dsl$;
var $n_Lscalacss_internal_Dsl$;
function $m_Lscalacss_internal_Dsl$() {
  if ((!$n_Lscalacss_internal_Dsl$)) {
    $n_Lscalacss_internal_Dsl$ = new $c_Lscalacss_internal_Dsl$()
  };
  return $n_Lscalacss_internal_Dsl$
}
/** @constructor */
function $c_Lscalacss_internal_Media$Handheld$() {
  this.Lscalacss_internal_Media$TypeA__f_value = null;
  $ct_Lscalacss_internal_Media$TypeA__T__(this, "handheld")
}
$c_Lscalacss_internal_Media$Handheld$.prototype = new $h_Lscalacss_internal_Media$Type();
$c_Lscalacss_internal_Media$Handheld$.prototype.constructor = $c_Lscalacss_internal_Media$Handheld$;
/** @constructor */
function $h_Lscalacss_internal_Media$Handheld$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Handheld$.prototype = $c_Lscalacss_internal_Media$Handheld$.prototype;
$c_Lscalacss_internal_Media$Handheld$.prototype.productPrefix__T = (function() {
  return "Handheld"
});
$c_Lscalacss_internal_Media$Handheld$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Media$Handheld$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Media$Handheld$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Handheld$.prototype.hashCode__I = (function() {
  return 66593860
});
$c_Lscalacss_internal_Media$Handheld$.prototype.toString__T = (function() {
  return "Handheld"
});
var $d_Lscalacss_internal_Media$Handheld$ = new $TypeData().initClass({
  Lscalacss_internal_Media$Handheld$: 0
}, false, "scalacss.internal.Media$Handheld$", {
  Lscalacss_internal_Media$Handheld$: 1,
  Lscalacss_internal_Media$Type: 1,
  Lscalacss_internal_Media$TypeA: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Handheld$.prototype.$classData = $d_Lscalacss_internal_Media$Handheld$;
var $n_Lscalacss_internal_Media$Handheld$;
function $m_Lscalacss_internal_Media$Handheld$() {
  if ((!$n_Lscalacss_internal_Media$Handheld$)) {
    $n_Lscalacss_internal_Media$Handheld$ = new $c_Lscalacss_internal_Media$Handheld$()
  };
  return $n_Lscalacss_internal_Media$Handheld$
}
/** @constructor */
function $c_Lscalacss_internal_Media$Print$() {
  this.Lscalacss_internal_Media$TypeA__f_value = null;
  $ct_Lscalacss_internal_Media$TypeA__T__(this, "print")
}
$c_Lscalacss_internal_Media$Print$.prototype = new $h_Lscalacss_internal_Media$Type();
$c_Lscalacss_internal_Media$Print$.prototype.constructor = $c_Lscalacss_internal_Media$Print$;
/** @constructor */
function $h_Lscalacss_internal_Media$Print$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Print$.prototype = $c_Lscalacss_internal_Media$Print$.prototype;
$c_Lscalacss_internal_Media$Print$.prototype.productPrefix__T = (function() {
  return "Print"
});
$c_Lscalacss_internal_Media$Print$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Media$Print$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Media$Print$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Print$.prototype.hashCode__I = (function() {
  return 77382285
});
$c_Lscalacss_internal_Media$Print$.prototype.toString__T = (function() {
  return "Print"
});
var $d_Lscalacss_internal_Media$Print$ = new $TypeData().initClass({
  Lscalacss_internal_Media$Print$: 0
}, false, "scalacss.internal.Media$Print$", {
  Lscalacss_internal_Media$Print$: 1,
  Lscalacss_internal_Media$Type: 1,
  Lscalacss_internal_Media$TypeA: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Print$.prototype.$classData = $d_Lscalacss_internal_Media$Print$;
var $n_Lscalacss_internal_Media$Print$;
function $m_Lscalacss_internal_Media$Print$() {
  if ((!$n_Lscalacss_internal_Media$Print$)) {
    $n_Lscalacss_internal_Media$Print$ = new $c_Lscalacss_internal_Media$Print$()
  };
  return $n_Lscalacss_internal_Media$Print$
}
/** @constructor */
function $c_Lscalacss_internal_Media$Screen$() {
  this.Lscalacss_internal_Media$TypeA__f_value = null;
  $ct_Lscalacss_internal_Media$TypeA__T__(this, "screen")
}
$c_Lscalacss_internal_Media$Screen$.prototype = new $h_Lscalacss_internal_Media$Type();
$c_Lscalacss_internal_Media$Screen$.prototype.constructor = $c_Lscalacss_internal_Media$Screen$;
/** @constructor */
function $h_Lscalacss_internal_Media$Screen$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Media$Screen$.prototype = $c_Lscalacss_internal_Media$Screen$.prototype;
$c_Lscalacss_internal_Media$Screen$.prototype.productPrefix__T = (function() {
  return "Screen"
});
$c_Lscalacss_internal_Media$Screen$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Media$Screen$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Media$Screen$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Media$Screen$.prototype.hashCode__I = (function() {
  return (-1823822708)
});
$c_Lscalacss_internal_Media$Screen$.prototype.toString__T = (function() {
  return "Screen"
});
var $d_Lscalacss_internal_Media$Screen$ = new $TypeData().initClass({
  Lscalacss_internal_Media$Screen$: 0
}, false, "scalacss.internal.Media$Screen$", {
  Lscalacss_internal_Media$Screen$: 1,
  Lscalacss_internal_Media$Type: 1,
  Lscalacss_internal_Media$TypeA: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Media$Screen$.prototype.$classData = $d_Lscalacss_internal_Media$Screen$;
var $n_Lscalacss_internal_Media$Screen$;
function $m_Lscalacss_internal_Media$Screen$() {
  if ((!$n_Lscalacss_internal_Media$Screen$)) {
    $n_Lscalacss_internal_Media$Screen$ = new $c_Lscalacss_internal_Media$Screen$()
  };
  return $n_Lscalacss_internal_Media$Screen$
}
/** @constructor */
function $c_Lscalacss_internal_NaturalOrdering$() {
  /*<skip>*/
}
$c_Lscalacss_internal_NaturalOrdering$.prototype = new $h_O();
$c_Lscalacss_internal_NaturalOrdering$.prototype.constructor = $c_Lscalacss_internal_NaturalOrdering$;
/** @constructor */
function $h_Lscalacss_internal_NaturalOrdering$() {
  /*<skip>*/
}
$h_Lscalacss_internal_NaturalOrdering$.prototype = $c_Lscalacss_internal_NaturalOrdering$.prototype;
$c_Lscalacss_internal_NaturalOrdering$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.compare__T__T__I = (function(a, b) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var elem$2 = 0;
  elem$2 = 0;
  var elem$3 = 0;
  elem$3 = 0;
  var elem$4 = 0;
  elem$4 = 0;
  var ia = 0;
  var ib = 0;
  var nza = 0;
  var nzb = 0;
  var ca = 0;
  var cb = 0;
  var result = 0;
  while (true) {
    nza = 0;
    nzb = 0;
    ca = this.scalacss$internal$NaturalOrdering$$charAt__T__I__C(a, ia);
    cb = this.scalacss$internal$NaturalOrdering$$charAt__T__I__C(b, ib);
    while (true) {
      var ch = ca;
      var this$6 = $m_jl_Character$();
      if ((this$6.isSpaceChar__I__Z(ch) || (ca === 48))) {
        if ((ca === 48)) {
          nza = ((1 + nza) | 0)
        } else {
          nza = 0
        };
        ia = ((1 + ia) | 0);
        ca = this.scalacss$internal$NaturalOrdering$$charAt__T__I__C(a, ia)
      } else {
        break
      }
    };
    while (true) {
      var ch$1 = cb;
      var this$7 = $m_jl_Character$();
      if ((this$7.isSpaceChar__I__Z(ch$1) || (cb === 48))) {
        if ((cb === 48)) {
          nzb = ((1 + nzb) | 0)
        } else {
          nzb = 0
        };
        ib = ((1 + ib) | 0);
        cb = this.scalacss$internal$NaturalOrdering$$charAt__T__I__C(b, ib)
      } else {
        break
      }
    };
    var c = ca;
    var this$8 = $m_jl_Character$();
    if (this$8.isDigit__I__Z(c)) {
      var c$1 = cb;
      var this$9 = $m_jl_Character$();
      var $$x1 = this$9.isDigit__I__Z(c$1)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      elem$1 = ia;
      elem$2 = ib;
      elem = 0;
      while (true) {
        elem$3 = this.scalacss$internal$NaturalOrdering$$charAt__T__I__C(a, elem$1);
        elem$4 = this.scalacss$internal$NaturalOrdering$$charAt__T__I__C(b, elem$2);
        var c$2 = elem$3;
        var this$10 = $m_jl_Character$();
        if ((!this$10.isDigit__I__Z(c$2))) {
          var c$3 = elem$4;
          var this$11 = $m_jl_Character$();
          if (this$11.isDigit__I__Z(c$3)) {
            result = (-1);
            break
          } else {
            result = elem;
            break
          }
        } else {
          var c$4 = elem$4;
          var this$12 = $m_jl_Character$();
          if ((!this$12.isDigit__I__Z(c$4))) {
            result = 1;
            break
          } else if ((elem$3 < elem$4)) {
            if ((elem === 0)) {
              elem = (-1)
            }
          } else if ((elem$3 > elem$4)) {
            if ((elem === 0)) {
              elem = 1
            }
          } else if (((elem$3 === 0) && (elem$4 === 0))) {
            result = elem;
            break
          }
        };
        elem$1 = ((1 + elem$1) | 0);
        elem$2 = ((1 + elem$2) | 0)
      };
      if ((result !== 0)) {
        return result
      }
    } else if (((ca === 0) && (cb === 0))) {
      return ((nza - nzb) | 0)
    };
    result = ((ca - cb) | 0);
    if ((result !== 0)) {
      return result
    };
    ia = ((1 + ia) | 0);
    ib = ((1 + ib) | 0)
  }
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.scalacss$internal$NaturalOrdering$$charAt__T__I__C = (function(s, i) {
  var this$1 = $n(s);
  if ((i >= this$1.length)) {
    return 0
  } else {
    var this$2 = $n(s);
    return $charAt(this$2, i)
  }
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T__T__I($as_T(x), $as_T(y))
});
var $d_Lscalacss_internal_NaturalOrdering$ = new $TypeData().initClass({
  Lscalacss_internal_NaturalOrdering$: 0
}, false, "scalacss.internal.NaturalOrdering$", {
  Lscalacss_internal_NaturalOrdering$: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_NaturalOrdering$.prototype.$classData = $d_Lscalacss_internal_NaturalOrdering$;
var $n_Lscalacss_internal_NaturalOrdering$;
function $m_Lscalacss_internal_NaturalOrdering$() {
  if ((!$n_Lscalacss_internal_NaturalOrdering$)) {
    $n_Lscalacss_internal_NaturalOrdering$ = new $c_Lscalacss_internal_NaturalOrdering$()
  };
  return $n_Lscalacss_internal_NaturalOrdering$
}
/** @constructor */
function $c_Lscalacss_internal_Pseudo$$anon$2() {
  /*<skip>*/
}
$c_Lscalacss_internal_Pseudo$$anon$2.prototype = new $h_O();
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.constructor = $c_Lscalacss_internal_Pseudo$$anon$2;
/** @constructor */
function $h_Lscalacss_internal_Pseudo$$anon$2() {
  /*<skip>*/
}
$h_Lscalacss_internal_Pseudo$$anon$2.prototype = $c_Lscalacss_internal_Pseudo$$anon$2.prototype;
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.compare__Lscalacss_internal_Pseudo$Single__Lscalacss_internal_Pseudo$Single__I = (function(x, y) {
  var n = $n($m_Lscalacss_internal_PseudoType$().Lscalacss_internal_PseudoType$__f_ordering).compare__O__O__I($n(x).Lscalacss_internal_Pseudo$Single__f_pseudoType, $n(y).Lscalacss_internal_Pseudo$Single__f_pseudoType);
  return ((n === 0) ? $f_T__compareTo__T__I($n($n(x).Lscalacss_internal_Pseudo$Single__f_cssValue), $n(y).Lscalacss_internal_Pseudo$Single__f_cssValue) : n)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__Lscalacss_internal_Pseudo$Single__Lscalacss_internal_Pseudo$Single__I($as_Lscalacss_internal_Pseudo$Single(x), $as_Lscalacss_internal_Pseudo$Single(y))
});
var $d_Lscalacss_internal_Pseudo$$anon$2 = new $TypeData().initClass({
  Lscalacss_internal_Pseudo$$anon$2: 0
}, false, "scalacss.internal.Pseudo$$anon$2", {
  Lscalacss_internal_Pseudo$$anon$2: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Pseudo$$anon$2.prototype.$classData = $d_Lscalacss_internal_Pseudo$$anon$2;
function $p_Lscalacss_internal_Pseudo$Composite__cssValue$lzycompute__T($thiz) {
  if ((!$thiz.Lscalacss_internal_Pseudo$Composite__f_bitmap$0)) {
    var this$1 = $n($thiz.Lscalacss_internal_Pseudo$Composite__f_t);
    var elem = $thiz.Lscalacss_internal_Pseudo$Composite__f_h;
    var this$3 = $n(this$1.incl__O__sci_SetOps(elem));
    var f = ((x$1$2, x$2$2) => {
      var x$1 = $as_T(x$1$2);
      var x$2 = $as_Lscalacss_internal_Pseudo$Single(x$2$2);
      return (("" + x$1) + $n(x$2).Lscalacss_internal_Pseudo$Single__f_cssValue)
    });
    if ($is_sc_IndexedSeq(this$3)) {
      var x2 = $as_sc_IndexedSeq(this$3);
      var at = 0;
      var end = $n(x2).length__I();
      var acc = "";
      var $$x1;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var arg1 = acc;
          var arg2 = $n(x2).apply__I__O(at);
          var temp$acc = f(arg1, arg2);
          at = temp$at;
          acc = temp$acc;
          continue
        };
        var $$x1 = acc;
        break
      }
    } else {
      var result = "";
      var it = this$3.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var arg1$1 = result;
        var arg2$1 = $n(it).next__O();
        result = f(arg1$1, arg2$1)
      };
      var $$x1 = result
    };
    $thiz.Lscalacss_internal_Pseudo$Composite__f_cssValue = $as_T($$x1);
    $thiz.Lscalacss_internal_Pseudo$Composite__f_bitmap$0 = true
  };
  return $thiz.Lscalacss_internal_Pseudo$Composite__f_cssValue
}
/** @constructor */
function $c_Lscalacss_internal_Pseudo$Composite(h, t) {
  this.Lscalacss_internal_Pseudo$Composite__f_cssValue = null;
  this.Lscalacss_internal_Pseudo$Composite__f_h = null;
  this.Lscalacss_internal_Pseudo$Composite__f_t = null;
  this.Lscalacss_internal_Pseudo$Composite__f_bitmap$0 = false;
  this.Lscalacss_internal_Pseudo$Composite__f_h = h;
  this.Lscalacss_internal_Pseudo$Composite__f_t = t
}
$c_Lscalacss_internal_Pseudo$Composite.prototype = new $h_Lscalacss_internal_Pseudo();
$c_Lscalacss_internal_Pseudo$Composite.prototype.constructor = $c_Lscalacss_internal_Pseudo$Composite;
/** @constructor */
function $h_Lscalacss_internal_Pseudo$Composite() {
  /*<skip>*/
}
$h_Lscalacss_internal_Pseudo$Composite.prototype = $c_Lscalacss_internal_Pseudo$Composite.prototype;
$c_Lscalacss_internal_Pseudo$Composite.prototype.cssValue__T = (function() {
  return ((!this.Lscalacss_internal_Pseudo$Composite__f_bitmap$0) ? $p_Lscalacss_internal_Pseudo$Composite__cssValue$lzycompute__T(this) : this.Lscalacss_internal_Pseudo$Composite__f_cssValue)
});
$c_Lscalacss_internal_Pseudo$Composite.prototype.contains__Lscalacss_internal_Pseudo$Single__Z = (function(p) {
  var x = this.Lscalacss_internal_Pseudo$Composite__f_h;
  if ((x === null)) {
    var $$x1 = (p === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = (this$1 === p)
  };
  if ($$x1) {
    return true
  } else {
    return $n(this.Lscalacss_internal_Pseudo$Composite__f_t).contains__O__Z(p)
  }
});
$c_Lscalacss_internal_Pseudo$Composite.prototype.productPrefix__T = (function() {
  return "Composite"
});
$c_Lscalacss_internal_Pseudo$Composite.prototype.productArity__I = (function() {
  return 2
});
$c_Lscalacss_internal_Pseudo$Composite.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_Pseudo$Composite__f_h;
      break
    }
    case 1: {
      return this.Lscalacss_internal_Pseudo$Composite__f_t;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_Pseudo$Composite.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Pseudo$Composite.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_Pseudo$Composite.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalacss_internal_Pseudo$Composite.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_Pseudo$Composite)) {
    var Composite$1 = $as_Lscalacss_internal_Pseudo$Composite(x$1);
    var x = this.Lscalacss_internal_Pseudo$Composite__f_h;
    var x$2 = $n(Composite$1).Lscalacss_internal_Pseudo$Composite__f_h;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      var x$3 = this.Lscalacss_internal_Pseudo$Composite__f_t;
      var x$4 = $n(Composite$1).Lscalacss_internal_Pseudo$Composite__f_t;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_Pseudo$Composite(obj) {
  return (((obj instanceof $c_Lscalacss_internal_Pseudo$Composite) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.Pseudo$Composite"))
}
function $isArrayOf_Lscalacss_internal_Pseudo$Composite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_Pseudo$Composite)))
}
function $asArrayOf_Lscalacss_internal_Pseudo$Composite(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_Pseudo$Composite(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.Pseudo$Composite;", depth))
}
var $d_Lscalacss_internal_Pseudo$Composite = new $TypeData().initClass({
  Lscalacss_internal_Pseudo$Composite: 0
}, false, "scalacss.internal.Pseudo$Composite", {
  Lscalacss_internal_Pseudo$Composite: 1,
  Lscalacss_internal_Pseudo: 1,
  O: 1,
  Lscalacss_internal_Pseudo$ChainOps: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Pseudo$Composite.prototype.$classData = $d_Lscalacss_internal_Pseudo$Composite;
/** @constructor */
function $c_Lscalacss_internal_PseudoType$$anon$1() {
  /*<skip>*/
}
$c_Lscalacss_internal_PseudoType$$anon$1.prototype = new $h_O();
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.constructor = $c_Lscalacss_internal_PseudoType$$anon$1;
/** @constructor */
function $h_Lscalacss_internal_PseudoType$$anon$1() {
  /*<skip>*/
}
$h_Lscalacss_internal_PseudoType$$anon$1.prototype = $c_Lscalacss_internal_PseudoType$$anon$1.prototype;
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.compare__Lscalacss_internal_PseudoType__Lscalacss_internal_PseudoType__I = (function(x, y) {
  return (($n(x).Lscalacss_internal_PseudoType__f_priority - $n(y).Lscalacss_internal_PseudoType__f_priority) | 0)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__Lscalacss_internal_PseudoType__Lscalacss_internal_PseudoType__I($as_Lscalacss_internal_PseudoType(x), $as_Lscalacss_internal_PseudoType(y))
});
var $d_Lscalacss_internal_PseudoType$$anon$1 = new $TypeData().initClass({
  Lscalacss_internal_PseudoType$$anon$1: 0
}, false, "scalacss.internal.PseudoType$$anon$1", {
  Lscalacss_internal_PseudoType$$anon$1: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_PseudoType$$anon$1.prototype.$classData = $d_Lscalacss_internal_PseudoType$$anon$1;
/** @constructor */
function $c_Lscalacss_internal_StyleS(data, unsafeExts, className, addClassNames, warnings) {
  this.Lscalacss_internal_StyleS__f_data = null;
  this.Lscalacss_internal_StyleS__f_unsafeExts = null;
  this.Lscalacss_internal_StyleS__f_className = null;
  this.Lscalacss_internal_StyleS__f_addClassNames = null;
  this.Lscalacss_internal_StyleS__f_warnings = null;
  this.Lscalacss_internal_StyleS__f_data = data;
  this.Lscalacss_internal_StyleS__f_unsafeExts = unsafeExts;
  this.Lscalacss_internal_StyleS__f_className = className;
  this.Lscalacss_internal_StyleS__f_addClassNames = addClassNames;
  this.Lscalacss_internal_StyleS__f_warnings = warnings
}
$c_Lscalacss_internal_StyleS.prototype = new $h_Lscalacss_internal_Style1();
$c_Lscalacss_internal_StyleS.prototype.constructor = $c_Lscalacss_internal_StyleS;
/** @constructor */
function $h_Lscalacss_internal_StyleS() {
  /*<skip>*/
}
$h_Lscalacss_internal_StyleS.prototype = $c_Lscalacss_internal_StyleS.prototype;
$c_Lscalacss_internal_StyleS.prototype.toString__T = (function() {
  return $as_T($n($m_Lscalacss_internal_StringRenderer$().defaultPretty__Lscalacss_internal_Renderer()).apply__sci_Vector__O(this.inspectCss__sci_Vector()))
});
$c_Lscalacss_internal_StyleS.prototype.inspectCss__sci_Vector = (function() {
  var $$x1 = $m_Lscalacss_internal_Css$();
  var this$1 = $n(this.Lscalacss_internal_StyleS__f_className);
  return $n($$x1).styleA__Lscalacss_internal_StyleA__Lscalacss_internal_Env__sci_Vector(new $c_Lscalacss_internal_StyleA($as_Lscalacss_internal_ClassName((this$1.isEmpty__Z() ? new $c_Lscalacss_internal_ClassName("???") : this$1.get__O())), this.Lscalacss_internal_StyleS__f_addClassNames, this), $m_Lscalacss_internal_Env$().Lscalacss_internal_Env$__f_empty)
});
$c_Lscalacss_internal_StyleS.prototype.productPrefix__T = (function() {
  return "StyleS"
});
$c_Lscalacss_internal_StyleS.prototype.productArity__I = (function() {
  return 5
});
$c_Lscalacss_internal_StyleS.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalacss_internal_StyleS__f_data;
      break
    }
    case 1: {
      return this.Lscalacss_internal_StyleS__f_unsafeExts;
      break
    }
    case 2: {
      return this.Lscalacss_internal_StyleS__f_className;
      break
    }
    case 3: {
      return this.Lscalacss_internal_StyleS__f_addClassNames;
      break
    }
    case 4: {
      return this.Lscalacss_internal_StyleS__f_warnings;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalacss_internal_StyleS.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_StyleS.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalacss_internal_StyleS.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalacss_internal_StyleS)) {
    var StyleS$1 = $as_Lscalacss_internal_StyleS(x$1);
    var x = this.Lscalacss_internal_StyleS__f_data;
    var x$2 = $n(StyleS$1).Lscalacss_internal_StyleS__f_data;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lscalacss_internal_StyleS__f_unsafeExts;
      var x$4 = $n(StyleS$1).Lscalacss_internal_StyleS__f_unsafeExts;
      var $$x3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$5 = this.Lscalacss_internal_StyleS__f_className;
      var x$6 = $n(StyleS$1).Lscalacss_internal_StyleS__f_className;
      var $$x2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Lscalacss_internal_StyleS__f_addClassNames;
      var x$8 = $n(StyleS$1).Lscalacss_internal_StyleS__f_addClassNames;
      var $$x1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lscalacss_internal_StyleS__f_warnings;
      var x$10 = $n(StyleS$1).Lscalacss_internal_StyleS__f_warnings;
      return ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscalacss_internal_StyleS(obj) {
  return (((obj instanceof $c_Lscalacss_internal_StyleS) || (obj === null)) ? obj : $throwClassCastException(obj, "scalacss.internal.StyleS"))
}
function $isArrayOf_Lscalacss_internal_StyleS(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalacss_internal_StyleS)))
}
function $asArrayOf_Lscalacss_internal_StyleS(obj, depth) {
  return (($isArrayOf_Lscalacss_internal_StyleS(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalacss.internal.StyleS;", depth))
}
var $d_Lscalacss_internal_StyleS = new $TypeData().initClass({
  Lscalacss_internal_StyleS: 0
}, false, "scalacss.internal.StyleS", {
  Lscalacss_internal_StyleS: 1,
  Lscalacss_internal_Style1: 1,
  O: 1,
  Lscalacss_internal_Style: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_StyleS.prototype.$classData = $d_Lscalacss_internal_StyleS;
/** @constructor */
function $c_Lscalacss_internal_mutable_StyleSheet$Base$dsl$(outer) {
  this.Lscalacss_internal_DslBase__f_StyleS = null;
  if ((outer === null)) {
    $n(null)
  };
  $ct_Lscalacss_internal_DslBase__(this)
}
$c_Lscalacss_internal_mutable_StyleSheet$Base$dsl$.prototype = new $h_Lscalacss_internal_DslBase();
$c_Lscalacss_internal_mutable_StyleSheet$Base$dsl$.prototype.constructor = $c_Lscalacss_internal_mutable_StyleSheet$Base$dsl$;
/** @constructor */
function $h_Lscalacss_internal_mutable_StyleSheet$Base$dsl$() {
  /*<skip>*/
}
$h_Lscalacss_internal_mutable_StyleSheet$Base$dsl$.prototype = $c_Lscalacss_internal_mutable_StyleSheet$Base$dsl$.prototype;
$c_Lscalacss_internal_mutable_StyleSheet$Base$dsl$.prototype.styleS__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS = (function(t, c) {
  return $m_Lscalacss_internal_Dsl$().style__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleS(t, c)
});
var $d_Lscalacss_internal_mutable_StyleSheet$Base$dsl$ = new $TypeData().initClass({
  Lscalacss_internal_mutable_StyleSheet$Base$dsl$: 0
}, false, "scalacss.internal.mutable.StyleSheet$Base$dsl$", {
  Lscalacss_internal_mutable_StyleSheet$Base$dsl$: 1,
  Lscalacss_internal_DslBase: 1,
  Lscalacss_internal_AttrAliasesAndValueTRules: 1,
  Lscalacss_internal_ValueT$Rules: 1,
  O: 1,
  Lscalacss_internal_TypedLiteralAliases: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_mutable_StyleSheet$Base$dsl$.prototype.$classData = $d_Lscalacss_internal_mutable_StyleSheet$Base$dsl$;
/** @constructor */
function $c_Lshapeless_HNil$() {
  /*<skip>*/
}
$c_Lshapeless_HNil$.prototype = new $h_O();
$c_Lshapeless_HNil$.prototype.constructor = $c_Lshapeless_HNil$;
/** @constructor */
function $h_Lshapeless_HNil$() {
  /*<skip>*/
}
$h_Lshapeless_HNil$.prototype = $c_Lshapeless_HNil$.prototype;
$c_Lshapeless_HNil$.prototype.toString__T = (function() {
  return "HNil"
});
$c_Lshapeless_HNil$.prototype.productPrefix__T = (function() {
  return "HNil"
});
$c_Lshapeless_HNil$.prototype.productArity__I = (function() {
  return 0
});
$c_Lshapeless_HNil$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lshapeless_HNil$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshapeless_HNil$.prototype.hashCode__I = (function() {
  return 2223273
});
var $d_Lshapeless_HNil$ = new $TypeData().initClass({
  Lshapeless_HNil$: 0
}, false, "shapeless.HNil$", {
  Lshapeless_HNil$: 1,
  O: 1,
  Lshapeless_HNil: 1,
  Lshapeless_HList: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_HNil$.prototype.$classData = $d_Lshapeless_HNil$;
var $n_Lshapeless_HNil$;
function $m_Lshapeless_HNil$() {
  if ((!$n_Lshapeless_HNil$)) {
    $n_Lshapeless_HNil$ = new $c_Lshapeless_HNil$()
  };
  return $n_Lshapeless_HNil$
}
/** @constructor */
function $c_Lshapeless_Inl(head) {
  this.Lshapeless_Inl__f_head = null;
  this.Lshapeless_Inl__f_head = head
}
$c_Lshapeless_Inl.prototype = new $h_O();
$c_Lshapeless_Inl.prototype.constructor = $c_Lshapeless_Inl;
/** @constructor */
function $h_Lshapeless_Inl() {
  /*<skip>*/
}
$h_Lshapeless_Inl.prototype = $c_Lshapeless_Inl.prototype;
$c_Lshapeless_Inl.prototype.productPrefix__T = (function() {
  return "Inl"
});
$c_Lshapeless_Inl.prototype.productArity__I = (function() {
  return 1
});
$c_Lshapeless_Inl.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshapeless_Inl__f_head : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshapeless_Inl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshapeless_Inl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshapeless_Inl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshapeless_Inl.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshapeless_Inl)) {
    var Inl$1 = $as_Lshapeless_Inl(x$1);
    var x = this.Lshapeless_Inl__f_head;
    var y = $n(Inl$1).Lshapeless_Inl__f_head;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lshapeless_Inl(obj) {
  return (((obj instanceof $c_Lshapeless_Inl) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.Inl"))
}
function $isArrayOf_Lshapeless_Inl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_Inl)))
}
function $asArrayOf_Lshapeless_Inl(obj, depth) {
  return (($isArrayOf_Lshapeless_Inl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.Inl;", depth))
}
var $d_Lshapeless_Inl = new $TypeData().initClass({
  Lshapeless_Inl: 0
}, false, "shapeless.Inl", {
  Lshapeless_Inl: 1,
  O: 1,
  Lshapeless_$colon$plus$colon: 1,
  Lshapeless_Coproduct: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Inl.prototype.$classData = $d_Lshapeless_Inl;
/** @constructor */
function $c_Lshapeless_Inr(tail) {
  this.Lshapeless_Inr__f_tail = null;
  this.Lshapeless_Inr__f_tail = tail
}
$c_Lshapeless_Inr.prototype = new $h_O();
$c_Lshapeless_Inr.prototype.constructor = $c_Lshapeless_Inr;
/** @constructor */
function $h_Lshapeless_Inr() {
  /*<skip>*/
}
$h_Lshapeless_Inr.prototype = $c_Lshapeless_Inr.prototype;
$c_Lshapeless_Inr.prototype.productPrefix__T = (function() {
  return "Inr"
});
$c_Lshapeless_Inr.prototype.productArity__I = (function() {
  return 1
});
$c_Lshapeless_Inr.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshapeless_Inr__f_tail : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshapeless_Inr.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshapeless_Inr.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshapeless_Inr.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshapeless_Inr.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshapeless_Inr)) {
    var Inr$1 = $as_Lshapeless_Inr(x$1);
    var x = this.Lshapeless_Inr__f_tail;
    var x$2 = $n(Inr$1).Lshapeless_Inr__f_tail;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lshapeless_Inr(obj) {
  return (((obj instanceof $c_Lshapeless_Inr) || (obj === null)) ? obj : $throwClassCastException(obj, "shapeless.Inr"))
}
function $isArrayOf_Lshapeless_Inr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshapeless_Inr)))
}
function $asArrayOf_Lshapeless_Inr(obj, depth) {
  return (($isArrayOf_Lshapeless_Inr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshapeless.Inr;", depth))
}
var $d_Lshapeless_Inr = new $TypeData().initClass({
  Lshapeless_Inr: 0
}, false, "shapeless.Inr", {
  Lshapeless_Inr: 1,
  O: 1,
  Lshapeless_$colon$plus$colon: 1,
  Lshapeless_Coproduct: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_Inr.prototype.$classData = $d_Lshapeless_Inr;
/** @constructor */
function $c_Lshapeless_PolyDefns$identity$() {
  /*<skip>*/
}
$c_Lshapeless_PolyDefns$identity$.prototype = new $h_O();
$c_Lshapeless_PolyDefns$identity$.prototype.constructor = $c_Lshapeless_PolyDefns$identity$;
/** @constructor */
function $h_Lshapeless_PolyDefns$identity$() {
  /*<skip>*/
}
$h_Lshapeless_PolyDefns$identity$.prototype = $c_Lshapeless_PolyDefns$identity$.prototype;
var $d_Lshapeless_PolyDefns$identity$ = new $TypeData().initClass({
  Lshapeless_PolyDefns$identity$: 0
}, false, "shapeless.PolyDefns$identity$", {
  Lshapeless_PolyDefns$identity$: 1,
  O: 1,
  Lshapeless_PolyDefns$$tilde$greater: 1,
  Lshapeless_Poly1: 1,
  Lshapeless_Poly: 1,
  Lshapeless_PolyApply: 1,
  Ljava_io_Serializable: 1
});
$c_Lshapeless_PolyDefns$identity$.prototype.$classData = $d_Lshapeless_PolyDefns$identity$;
var $n_Lshapeless_PolyDefns$identity$;
function $m_Lshapeless_PolyDefns$identity$() {
  if ((!$n_Lshapeless_PolyDefns$identity$)) {
    $n_Lshapeless_PolyDefns$identity$ = new $c_Lshapeless_PolyDefns$identity$()
  };
  return $n_Lshapeless_PolyDefns$identity$
}
function $f_Lcats_Apply__map2__O__O__F2__O($thiz, fa, fb, f) {
  var $$x1 = $thiz.product__O__O__O(fa, fb);
  var this$1 = $n(f);
  return $thiz.map__O__F1__O($$x1, $f_F2__tupled__F1(this$1))
}
/** @constructor */
function $c_Lcats_data_Validated$() {
  $ct_Lcats_data_ValidatedInstances__(this)
}
$c_Lcats_data_Validated$.prototype = new $h_Lcats_data_ValidatedInstances();
$c_Lcats_data_Validated$.prototype.constructor = $c_Lcats_data_Validated$;
/** @constructor */
function $h_Lcats_data_Validated$() {
  /*<skip>*/
}
$h_Lcats_data_Validated$.prototype = $c_Lcats_data_Validated$.prototype;
var $d_Lcats_data_Validated$ = new $TypeData().initClass({
  Lcats_data_Validated$: 0
}, false, "cats.data.Validated$", {
  Lcats_data_Validated$: 1,
  Lcats_data_ValidatedInstances: 1,
  Lcats_data_ValidatedInstances1: 1,
  Lcats_data_ValidatedInstances2: 1,
  O: 1,
  Lcats_data_ValidatedFunctions: 1,
  Lcats_data_ValidatedFunctionsBinCompat0: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Validated$.prototype.$classData = $d_Lcats_data_Validated$;
var $n_Lcats_data_Validated$;
function $m_Lcats_data_Validated$() {
  if ((!$n_Lcats_data_Validated$)) {
    $n_Lcats_data_Validated$ = new $c_Lcats_data_Validated$()
  };
  return $n_Lcats_data_Validated$
}
/** @constructor */
function $c_Lcats_instances_package$option$() {
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = null;
  $n_Lcats_instances_package$option$ = this;
  $f_Lcats_instances_OptionInstances__$init$__V(this);
  $f_Lcats_instances_OptionInstancesBinCompat0__$init$__V(this)
}
$c_Lcats_instances_package$option$.prototype = new $h_O();
$c_Lcats_instances_package$option$.prototype.constructor = $c_Lcats_instances_package$option$;
/** @constructor */
function $h_Lcats_instances_package$option$() {
  /*<skip>*/
}
$h_Lcats_instances_package$option$.prototype = $c_Lcats_instances_package$option$.prototype;
$c_Lcats_instances_package$option$.prototype.cats$instances$OptionInstancesBinCompat0$_setter_$catsStdTraverseFilterForOption_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_package$option$.prototype.cats$instances$OptionInstances$_setter_$catsStdInstancesForOption_$eq__Lcats_Traverse__V = (function(x$1) {
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = x$1
});
var $d_Lcats_instances_package$option$ = new $TypeData().initClass({
  Lcats_instances_package$option$: 0
}, false, "cats.instances.package$option$", {
  Lcats_instances_package$option$: 1,
  O: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1
});
$c_Lcats_instances_package$option$.prototype.$classData = $d_Lcats_instances_package$option$;
var $n_Lcats_instances_package$option$;
function $m_Lcats_instances_package$option$() {
  if ((!$n_Lcats_instances_package$option$)) {
    $n_Lcats_instances_package$option$ = new $c_Lcats_instances_package$option$()
  };
  return $n_Lcats_instances_package$option$
}
function $f_Lcats_kernel_Order$mcB$sp__partialCompare$mcB$sp__B__B__D($thiz, x, y) {
  return $thiz.compare$mcB$sp__B__B__I(x, y)
}
function $f_Lcats_kernel_Order$mcC$sp__partialCompare$mcC$sp__C__C__D($thiz, x, y) {
  return $thiz.compare$mcC$sp__C__C__I(x, y)
}
function $f_Lcats_kernel_Order$mcD$sp__partialCompare$mcD$sp__D__D__D($thiz, x, y) {
  return $m_jl_Double$().compare__D__D__I(x, y)
}
function $f_Lcats_kernel_Order$mcF$sp__partialCompare$mcF$sp__F__F__D($thiz, x, y) {
  return $m_jl_Double$().compare__D__D__I(x, y)
}
function $f_Lcats_kernel_Order$mcI$sp__partialCompare$mcI$sp__I__I__D($thiz, x, y) {
  return $thiz.compare$mcI$sp__I__I__I(x, y)
}
function $f_Lcats_kernel_Order$mcJ$sp__partialCompare$mcJ$sp__J__J__D($thiz, x, y) {
  return $thiz.compare$mcJ$sp__J__J__I(x, y)
}
function $f_Lcats_kernel_Order$mcS$sp__partialCompare$mcS$sp__S__S__D($thiz, x, y) {
  return $thiz.compare$mcS$sp__S__S__I(x, y)
}
function $f_Lcats_kernel_Order$mcV$sp__partialCompare$mcV$sp__jl_Void__jl_Void__D($thiz, x, y) {
  return 0.0
}
function $f_Lcats_kernel_Order$mcZ$sp__partialCompare$mcZ$sp__Z__Z__D($thiz, x, y) {
  return $thiz.compare$mcZ$sp__Z__Z__I(x, y)
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Gesture$SwipeLeft$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype.constructor = $c_Lcom_iz2use_react_components_Gesture$SwipeLeft$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Gesture$SwipeLeft$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype = $c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype;
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype.direction__I = (function() {
  return $f_Lcom_iz2use_react_components_Gesture$Left__direction__I(this)
});
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype.productPrefix__T = (function() {
  return "SwipeLeft"
});
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype.hashCode__I = (function() {
  return (-753121727)
});
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype.toString__T = (function() {
  return "SwipeLeft"
});
var $d_Lcom_iz2use_react_components_Gesture$SwipeLeft$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Gesture$SwipeLeft$: 0
}, false, "com.iz2use.react.components.Gesture$SwipeLeft$", {
  Lcom_iz2use_react_components_Gesture$SwipeLeft$: 1,
  O: 1,
  Lcom_iz2use_react_components_Gesture$Swipe: 1,
  Lcom_iz2use_react_components_Gesture$GestureType: 1,
  Lcom_iz2use_react_components_Gesture$Left: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Gesture$SwipeLeft$.prototype.$classData = $d_Lcom_iz2use_react_components_Gesture$SwipeLeft$;
var $n_Lcom_iz2use_react_components_Gesture$SwipeLeft$;
function $m_Lcom_iz2use_react_components_Gesture$SwipeLeft$() {
  if ((!$n_Lcom_iz2use_react_components_Gesture$SwipeLeft$)) {
    $n_Lcom_iz2use_react_components_Gesture$SwipeLeft$ = new $c_Lcom_iz2use_react_components_Gesture$SwipeLeft$()
  };
  return $n_Lcom_iz2use_react_components_Gesture$SwipeLeft$
}
/** @constructor */
function $c_Lcom_iz2use_react_components_Gesture$SwipeRight$() {
  /*<skip>*/
}
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype = new $h_O();
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype.constructor = $c_Lcom_iz2use_react_components_Gesture$SwipeRight$;
/** @constructor */
function $h_Lcom_iz2use_react_components_Gesture$SwipeRight$() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype = $c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype;
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype.direction__I = (function() {
  return $f_Lcom_iz2use_react_components_Gesture$Right__direction__I(this)
});
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype.productPrefix__T = (function() {
  return "SwipeRight"
});
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype.hashCode__I = (function() {
  return (-1866276062)
});
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype.toString__T = (function() {
  return "SwipeRight"
});
var $d_Lcom_iz2use_react_components_Gesture$SwipeRight$ = new $TypeData().initClass({
  Lcom_iz2use_react_components_Gesture$SwipeRight$: 0
}, false, "com.iz2use.react.components.Gesture$SwipeRight$", {
  Lcom_iz2use_react_components_Gesture$SwipeRight$: 1,
  O: 1,
  Lcom_iz2use_react_components_Gesture$Swipe: 1,
  Lcom_iz2use_react_components_Gesture$GestureType: 1,
  Lcom_iz2use_react_components_Gesture$Right: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_components_Gesture$SwipeRight$.prototype.$classData = $d_Lcom_iz2use_react_components_Gesture$SwipeRight$;
var $n_Lcom_iz2use_react_components_Gesture$SwipeRight$;
function $m_Lcom_iz2use_react_components_Gesture$SwipeRight$() {
  if ((!$n_Lcom_iz2use_react_components_Gesture$SwipeRight$)) {
    $n_Lcom_iz2use_react_components_Gesture$SwipeRight$ = new $c_Lcom_iz2use_react_components_Gesture$SwipeRight$()
  };
  return $n_Lcom_iz2use_react_components_Gesture$SwipeRight$
}
/** @constructor */
function $c_Lcom_iz2use_react_hooks_SuppliedDsl(name, builder) {
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_dsl$module = null;
  this.Lscalacss_internal_mutable_StyleSheet$Base__f_classNameHint = null;
  this.Lscalacss_internal_mutable_StyleSheet$Inline__f_cssRegister = null;
  this.Lcom_iz2use_react_hooks_SuppliedDsl__f_name = null;
  this.Lcom_iz2use_react_hooks_SuppliedDsl__f_builder = null;
  this.Lcom_iz2use_react_hooks_SuppliedDsl__f_entry = null;
  this.Lcom_iz2use_react_hooks_SuppliedDsl__f_name = name;
  this.Lcom_iz2use_react_hooks_SuppliedDsl__f_builder = builder;
  var this$1 = $m_Lcom_iz2use_react_style_StyleSettings$();
  $ct_Lscalacss_internal_mutable_StyleSheet$Inline__Lscalacss_internal_mutable_Register__(this, new $c_Lscalacss_internal_mutable_Register(this$1.Lcom_iz2use_react_style_StyleSettings$__f_cssRegisterNameGen, $m_Lscalacss_internal_mutable_Register$MacroName$Use$(), this$1.Lcom_iz2use_react_style_StyleSettings$__f_cssRegisterErrorHandler, $m_Lscalacss_internal_mutable_Mutex$().Lscalacss_internal_mutable_Mutex$__f_mutex));
  this.Lcom_iz2use_react_hooks_SuppliedDsl__f_entry = new $c_Lscalacss_internal_mutable_StyleSheet$Inline$MStyle(this, "entry").apply__T__sci_Seq__Lscalacss_internal_Compose__Lscalacss_internal_StyleA(name, $as_sci_Seq($n(builder).apply__O__O(this.dsl__Lscalacss_internal_mutable_StyleSheet$Base$dsl$())), ($m_Lcom_iz2use_react_style_StyleSettings$(), $m_Lscalacss_internal_Compose$().safe__Lscalacss_internal_Compose()))
}
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype = new $h_Lscalacss_internal_mutable_StyleSheet$Inline();
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype.constructor = $c_Lcom_iz2use_react_hooks_SuppliedDsl;
/** @constructor */
function $h_Lcom_iz2use_react_hooks_SuppliedDsl() {
  /*<skip>*/
}
$h_Lcom_iz2use_react_hooks_SuppliedDsl.prototype = $c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype;
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype.productPrefix__T = (function() {
  return "SuppliedDsl"
});
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype.productArity__I = (function() {
  return 2
});
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lcom_iz2use_react_hooks_SuppliedDsl__f_name;
      break
    }
    case 1: {
      return this.Lcom_iz2use_react_hooks_SuppliedDsl__f_builder;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lcom_iz2use_react_hooks_SuppliedDsl)) {
    var SuppliedDsl$1 = $as_Lcom_iz2use_react_hooks_SuppliedDsl(x$1);
    if ((this.Lcom_iz2use_react_hooks_SuppliedDsl__f_name === $n(SuppliedDsl$1).Lcom_iz2use_react_hooks_SuppliedDsl__f_name)) {
      var x = this.Lcom_iz2use_react_hooks_SuppliedDsl__f_builder;
      var x$2 = $n(SuppliedDsl$1).Lcom_iz2use_react_hooks_SuppliedDsl__f_builder;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lcom_iz2use_react_hooks_SuppliedDsl(obj) {
  return (((obj instanceof $c_Lcom_iz2use_react_hooks_SuppliedDsl) || (obj === null)) ? obj : $throwClassCastException(obj, "com.iz2use.react.hooks.SuppliedDsl"))
}
function $isArrayOf_Lcom_iz2use_react_hooks_SuppliedDsl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_iz2use_react_hooks_SuppliedDsl)))
}
function $asArrayOf_Lcom_iz2use_react_hooks_SuppliedDsl(obj, depth) {
  return (($isArrayOf_Lcom_iz2use_react_hooks_SuppliedDsl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcom.iz2use.react.hooks.SuppliedDsl;", depth))
}
var $d_Lcom_iz2use_react_hooks_SuppliedDsl = new $TypeData().initClass({
  Lcom_iz2use_react_hooks_SuppliedDsl: 0
}, false, "com.iz2use.react.hooks.SuppliedDsl", {
  Lcom_iz2use_react_hooks_SuppliedDsl: 1,
  Lscalacss_internal_mutable_StyleSheet$Inline: 1,
  Lscalacss_internal_mutable_StyleSheet$Base: 1,
  O: 1,
  Lscalacss_internal_Macros$Dsl$Mixin: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lcom_iz2use_react_hooks_SuppliedDsl.prototype.$classData = $d_Lcom_iz2use_react_hooks_SuppliedDsl;
/** @constructor */
function $c_Ldiode_ActionResult$ModelUpdateEffect(newModel, effect) {
  this.Ldiode_ActionResult$ModelUpdateEffect__f_newModel = null;
  this.Ldiode_ActionResult$ModelUpdateEffect__f_effect = null;
  this.Ldiode_ActionResult$ModelUpdateEffect__f_newModel = newModel;
  this.Ldiode_ActionResult$ModelUpdateEffect__f_effect = effect
}
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype = new $h_O();
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.constructor = $c_Ldiode_ActionResult$ModelUpdateEffect;
/** @constructor */
function $h_Ldiode_ActionResult$ModelUpdateEffect() {
  /*<skip>*/
}
$h_Ldiode_ActionResult$ModelUpdateEffect.prototype = $c_Ldiode_ActionResult$ModelUpdateEffect.prototype;
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.effectOpt__s_Option = (function() {
  return new $c_s_Some(this.Ldiode_ActionResult$ModelUpdateEffect__f_effect)
});
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.newModelOpt__s_Option = (function() {
  return new $c_s_Some(this.Ldiode_ActionResult$ModelUpdateEffect__f_newModel)
});
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.productPrefix__T = (function() {
  return "ModelUpdateEffect"
});
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.productArity__I = (function() {
  return 2
});
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Ldiode_ActionResult$ModelUpdateEffect__f_newModel;
      break
    }
    case 1: {
      return this.Ldiode_ActionResult$ModelUpdateEffect__f_effect;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ldiode_ActionResult$ModelUpdateEffect)) {
    var ModelUpdateEffect$1 = $as_Ldiode_ActionResult$ModelUpdateEffect(x$1);
    var x = this.Ldiode_ActionResult$ModelUpdateEffect__f_newModel;
    var y = $n(ModelUpdateEffect$1).Ldiode_ActionResult$ModelUpdateEffect__f_newModel;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Ldiode_ActionResult$ModelUpdateEffect__f_effect;
      var x$2$1 = $n(ModelUpdateEffect$1).Ldiode_ActionResult$ModelUpdateEffect__f_effect;
      if ((x$2 === null)) {
        return (x$2$1 === null)
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$2$1)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Ldiode_ActionResult$ModelUpdateEffect(obj) {
  return (((obj instanceof $c_Ldiode_ActionResult$ModelUpdateEffect) || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ActionResult$ModelUpdateEffect"))
}
function $isArrayOf_Ldiode_ActionResult$ModelUpdateEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ActionResult$ModelUpdateEffect)))
}
function $asArrayOf_Ldiode_ActionResult$ModelUpdateEffect(obj, depth) {
  return (($isArrayOf_Ldiode_ActionResult$ModelUpdateEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ActionResult$ModelUpdateEffect;", depth))
}
var $d_Ldiode_ActionResult$ModelUpdateEffect = new $TypeData().initClass({
  Ldiode_ActionResult$ModelUpdateEffect: 0
}, false, "diode.ActionResult$ModelUpdateEffect", {
  Ldiode_ActionResult$ModelUpdateEffect: 1,
  O: 1,
  Ldiode_ModelUpdated: 1,
  Ldiode_ActionResult: 1,
  Ldiode_HasEffect: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ldiode_ActionResult$ModelUpdateEffect.prototype.$classData = $d_Ldiode_ActionResult$ModelUpdateEffect;
function $as_Ldiode_ActionResult$ModelUpdateSilent(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ActionResult$ModelUpdateSilent"))
}
function $isArrayOf_Ldiode_ActionResult$ModelUpdateSilent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ActionResult$ModelUpdateSilent)))
}
function $asArrayOf_Ldiode_ActionResult$ModelUpdateSilent(obj, depth) {
  return (($isArrayOf_Ldiode_ActionResult$ModelUpdateSilent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ActionResult$ModelUpdateSilent;", depth))
}
class $c_Lio_circe_ParsingFailure extends $c_Lio_circe_Error {
  constructor(message, underlying) {
    super();
    this.Lio_circe_ParsingFailure__f_message = null;
    this.Lio_circe_ParsingFailure__f_underlying = null;
    this.Lio_circe_ParsingFailure__f_message = message;
    this.Lio_circe_ParsingFailure__f_underlying = underlying;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    return this.Lio_circe_ParsingFailure__f_message
  };
  productPrefix__T() {
    return "ParsingFailure"
  };
  productArity__I() {
    return 2
  };
  productElement__I__O(x$1) {
    switch (x$1) {
      case 0: {
        return this.Lio_circe_ParsingFailure__f_message;
        break
      }
      case 1: {
        return this.Lio_circe_ParsingFailure__f_underlying;
        break
      }
      default: {
        return $m_sr_Statics$().ioobe__I__O(x$1)
      }
    }
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
  };
  equals__O__Z(x$1) {
    if ((this === x$1)) {
      return true
    } else if ((x$1 instanceof $c_Lio_circe_ParsingFailure)) {
      var ParsingFailure$1 = $as_Lio_circe_ParsingFailure(x$1);
      if ((this.Lio_circe_ParsingFailure__f_message === $n(ParsingFailure$1).Lio_circe_ParsingFailure__f_message)) {
        var x = this.Lio_circe_ParsingFailure__f_underlying;
        var x$2 = $n(ParsingFailure$1).Lio_circe_ParsingFailure__f_underlying;
        return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
      } else {
        return false
      }
    } else {
      return false
    }
  };
}
function $as_Lio_circe_ParsingFailure(obj) {
  return (((obj instanceof $c_Lio_circe_ParsingFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.ParsingFailure"))
}
function $isArrayOf_Lio_circe_ParsingFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_ParsingFailure)))
}
function $asArrayOf_Lio_circe_ParsingFailure(obj, depth) {
  return (($isArrayOf_Lio_circe_ParsingFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.ParsingFailure;", depth))
}
var $d_Lio_circe_ParsingFailure = new $TypeData().initClass({
  Lio_circe_ParsingFailure: 0
}, false, "io.circe.ParsingFailure", {
  Lio_circe_ParsingFailure: 1,
  Lio_circe_Error: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lio_circe_ParsingFailure.prototype.$classData = $d_Lio_circe_ParsingFailure;
function $p_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__memberNameTransformer__T__T($thiz, value) {
  return ($thiz.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_hasKeyAnnotations ? $as_T($n($thiz.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_keyAnnotationMap).getOrElse__O__F0__O(value, new $c_sjsr_AnonFunction0((() => $as_T($n($n($thiz.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_config$1).Lio_circe_generic_extras_Configuration__f_transformMemberNames).apply__O__O(value)))))) : $as_T($n($n($thiz.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_config$1).Lio_circe_generic_extras_Configuration__f_transformMemberNames).apply__O__O(value)))
}
function $p_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__transformMemberName__T__T($thiz, value) {
  return $as_T($n($thiz.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_transformedMemberCache).getOrElse__O__F0__O(value, new $c_sjsr_AnonFunction0((() => value))))
}
/** @constructor */
function $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config$1, keysToList$1, keys$1, fieldsToList$1, fields$1, encode$1, gen$1) {
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_config = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_constructorNameCache = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_keyAnnotations = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_hasKeyAnnotations = false;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_keyAnnotationMap = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_transformedMemberCache = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_config$1 = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_encode$1 = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_gen$1 = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_config$1 = config$1;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_encode$1 = encode$1;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_gen$1 = gen$1;
  $ct_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__Lio_circe_generic_extras_Configuration__(this, config$1);
  var this$2 = $n(keysToList$1);
  var this$1 = $n(keys$1);
  var l = this$1.apply__Lshapeless_HList();
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_keyAnnotations = $as_sci_List($f_Lshapeless_ops_hlist$ToTraversable__apply__Lshapeless_HList__O(this$2, l));
  var this$3 = $n(this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_keyAnnotations);
  _return: {
    var these = this$3;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x$1 = $as_s_Option(arg1);
      var this$4 = $n(x$1);
      if ((!this$4.isEmpty__Z())) {
        var $$x1 = true;
        break _return
      };
      these = $as_sci_List($n(these).tail__O())
    };
    var $$x1 = false
  };
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_hasKeyAnnotations = $$x1;
  var this$5 = $n(fieldsToList$1);
  var l$1 = $as_Lshapeless_HList($n(fields$1).apply__O());
  var this$6 = $n($as_sci_List($f_Lshapeless_ops_hlist$ToTraversable__apply__Lshapeless_HList__O(this$5, l$1)));
  var f = ((x$2$2) => {
    var x$2 = $as_s_Symbol(x$2$2);
    return $n(x$2).s_Symbol__f_name
  });
  if ((this$6 === $m_sci_Nil$())) {
    var $$x2 = $m_sci_Nil$()
  } else {
    var arg1$1 = this$6.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$6.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    var $$x2 = h
  };
  var this$7 = $n($$x2);
  var that = this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_keyAnnotations;
  var this$9 = $n($n($as_sci_List($f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this$7, that))).collect__s_PartialFunction__sci_List(new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1$$anonfun$1(this)));
  var this$8 = $m_s_$less$colon$less$();
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_keyAnnotationMap = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$9);
  var this$10 = $n(fieldsToList$1);
  var l$2 = $as_Lshapeless_HList($n(fields$1).apply__O());
  var this$11 = $n($as_sci_List($f_Lshapeless_ops_hlist$ToTraversable__apply__Lshapeless_HList__O(this$10, l$2)));
  var f$3 = ((f$2) => {
    var f$1 = $as_s_Symbol(f$2);
    return $ct_T2__O__O__(new $c_T2(), $n(f$1).s_Symbol__f_name, $p_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__memberNameTransformer__T__T(this, $n(f$1).s_Symbol__f_name))
  });
  if ((this$11 === $m_sci_Nil$())) {
    var $$x3 = $m_sci_Nil$()
  } else {
    var arg1$3 = this$11.head__O();
    var h$1 = new $c_sci_$colon$colon(f$3(arg1$3), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = $as_sci_List(this$11.tail__O());
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$4 = $n(rest$1).head__O();
      var nx$1 = new $c_sci_$colon$colon(f$3(arg1$4), $m_sci_Nil$());
      $n(t$1).sci_$colon$colon__f_next = nx$1;
      t$1 = nx$1;
      rest$1 = $as_sci_List($n(rest$1).tail__O())
    };
    var $$x3 = h$1
  };
  var this$13 = $n($$x3);
  var this$12 = $m_s_$less$colon$less$();
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_transformedMemberCache = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$13)
}
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1.prototype = new $h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder();
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1.prototype.constructor = $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1;
/** @constructor */
function $h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1.prototype = $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1.prototype;
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $n($as_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($n(this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_encode$1).value__O())).configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject($n(this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__f_gen$1).to__O__O(a), new $c_sjsr_AnonFunction1(((value$2) => {
    var value = $as_T(value$2);
    return $p_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1__transformMemberName__T__T(this, value)
  })), new $c_sjsr_AnonFunction1(((value$3$2) => {
    var value$3 = $as_T(value$3$2);
    return this.constructorNameTransformer__T__T(value$3)
  })), $m_s_None$())
});
var $d_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1 = new $TypeData().initClass({
  Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1: 0
}, false, "io.circe.generic.extras.encoding.ConfiguredAsObjectEncoder$$anon$1", {
  Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1: 1,
  Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder: 1,
  Lio_circe_generic_encoding_DerivedAsObjectEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1.prototype.$classData = $d_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1;
/** @constructor */
function $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2(config$2, encode$2, gen$2) {
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_config = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__f_constructorNameCache = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2__f_encode$2 = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2__f_gen$2 = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2__f_config$2 = null;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2__f_encode$2 = encode$2;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2__f_gen$2 = gen$2;
  this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2__f_config$2 = config$2;
  $ct_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder__Lio_circe_generic_extras_Configuration__(this, config$2)
}
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2.prototype = new $h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder();
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2.prototype.constructor = $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2;
/** @constructor */
function $h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2.prototype = $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2.prototype;
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $n($as_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder($n(this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2__f_encode$2).value__O())).configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject($n(this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2__f_gen$2).to__O__O(a), new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return x
  })), new $c_sjsr_AnonFunction1(((value$2) => {
    var value = $as_T(value$2);
    return this.constructorNameTransformer__T__T(value)
  })), $n(this.Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2__f_config$2).Lio_circe_generic_extras_Configuration__f_discriminator)
});
var $d_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2 = new $TypeData().initClass({
  Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2: 0
}, false, "io.circe.generic.extras.encoding.ConfiguredAsObjectEncoder$$anon$2", {
  Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2: 1,
  Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder: 1,
  Lio_circe_generic_encoding_DerivedAsObjectEncoder: 1,
  O: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2.prototype.$classData = $d_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2;
function $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, newState, callback, G) {
  return $n($n($as_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base($thiz)).mountedPure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(newState, callback, G)
}
function $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, mod, callback, G) {
  return $n($n($as_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base($thiz)).mountedPure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(mod, callback, G)
}
function $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, mod, callback, G) {
  return $n($n($as_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base($thiz)).mountedPure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(mod, callback, G)
}
function $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, newState, callback, G) {
  return $n($n($as_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base($thiz)).mountedPure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(newState, callback, G)
}
function $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($thiz, mod, callback, G) {
  return $n($n($as_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base($thiz)).mountedPure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(mod, callback, G)
}
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I6__O__O__O__O__O__O__O__($thiz, input, hook1, hook2, hook3, hook4, hook5, hook6) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$I6__f_hook6 = hook6;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I5__O__O__O__O__O__O__($thiz, input, hook1, hook2, hook3, hook4, hook5);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$I6() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I6__f_hook6 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I6.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$I5();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I6.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I6;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$I6() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$I6.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I6.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I6.prototype.toString__T = (function() {
  return (((((((((((((("HookCtx.withInput(\n  input = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I6__f_hook6) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$I6(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$I6) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$I6"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$I6)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I6(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$I6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$I6;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$I6 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$I6: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$I6", {
  Ljapgolly_scalajs_react_hooks_HookCtx$I6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I6.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$I6;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P6__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6 = hook6;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P5__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P6() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P6.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P5();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P6.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P6;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P6() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P6.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P6.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P6.prototype.toString__T = (function() {
  return (((((((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P6(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P6) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P6"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P6)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P6(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P6;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P6 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P6: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P6", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P6.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P6;
function $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$WithDefaults__toJsFn__F0__sjs_js_Function0($thiz, f) {
  return (() => $n(f).apply__O())
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype = $c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype;
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.async___F1__F1 = (function(onCompletion) {
  return $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().viaCallback__F1__F1(new $c_sjsr_AnonFunction1(((f$2) => {
    var f = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(f$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    $m_Ljapgolly_scalajs_react_callback_Callback$();
    var f$1 = $n(onCompletion).apply__O__O($m_Ljapgolly_scalajs_react_callback_CallbackTo$().toJsFn$extension__Ljapgolly_scalajs_react_callback_Trampoline__sjs_js_Function0(f));
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().fromJsFn__sjs_js_Function0__Ljapgolly_scalajs_react_callback_Trampoline(f$1))
  })))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.handleError__F0__F1__O = (function(fa, f) {
  return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().handleError$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(fa).apply__O())).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, f))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.dispatch__O__V = (function(fa) {
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_AsyncCallback(fa)).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr;
  $m_Ljapgolly_scalajs_react_callback_AsyncCallback$().runNow$extension__F1__V(fa$1)
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.async___F1__O = (function(onCompletion) {
  return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback(this.async___F1__F1(onCompletion))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.finallyRun__F0__F0__O = (function(fa, runFinally) {
  return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().finallyRun$extension__F1__F1__F1($n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(fa).apply__O())).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr, $n($as_Ljapgolly_scalajs_react_callback_AsyncCallback($n(runFinally).apply__O())).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_AsyncCallback(fa)).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr;
  return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().flatMap$extension__F1__F1__F1(fa$1, f))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_AsyncCallback(fa)).Ljapgolly_scalajs_react_callback_AsyncCallback__f_underlyingRepr;
  return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().map$extension__F1__F1__F1(fa$1, f))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.pure__O__O = (function(a) {
  return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().pure__O__F1(a))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.delay__F0__O = (function(a) {
  return new $c_Ljapgolly_scalajs_react_callback_AsyncCallback($m_Ljapgolly_scalajs_react_callback_AsyncCallback$().delay__F0__F1(a))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.chain__O__O__O = (function(fa, fb) {
  return $f_Ljapgolly_scalajs_react_util_Monad__chain__O__O__O(this, fa, fb)
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.dispatchFn__F0__sjs_js_Function0 = (function(fa) {
  return $f_Ljapgolly_scalajs_react_util_Effect$Dispatch$WithDefaults__dispatchFn__F0__sjs_js_Function0(this, fa)
});
var $d_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$: 0
}, false, "japgolly.scalajs.react.util.EffectCallback$asyncCallback$", {
  Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$: 1,
  O: 1,
  Ljapgolly_scalajs_react_util_Effect$Async: 1,
  Ljapgolly_scalajs_react_util_Effect$Dispatch: 1,
  Ljapgolly_scalajs_react_util_Effect: 1,
  Ljapgolly_scalajs_react_util_Monad: 1,
  Ljapgolly_scalajs_react_util_Effect$Dispatch$WithDefaults: 1,
  Ljapgolly_scalajs_react_util_Effect$WithDefaults: 1
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$;
var $n_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$;
function $m_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$() {
  if ((!$n_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$)) {
    $n_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$ = new $c_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$()
  };
  return $n_Ljapgolly_scalajs_react_util_EffectCallback$asyncCallback$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_EffectFallbacks() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_EffectFallbacks.prototype = new $h_Ljapgolly_scalajs_react_util_EffectFallbacks1();
$c_Ljapgolly_scalajs_react_util_EffectFallbacks.prototype.constructor = $c_Ljapgolly_scalajs_react_util_EffectFallbacks;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_EffectFallbacks() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_EffectFallbacks.prototype = $c_Ljapgolly_scalajs_react_util_EffectFallbacks.prototype;
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  return $thiz
}
/** @constructor */
function $c_Ljava_io_PrintStream() {
  /*<skip>*/
}
$c_Ljava_io_PrintStream.prototype = new $h_Ljava_io_FilterOutputStream();
$c_Ljava_io_PrintStream.prototype.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
  /*<skip>*/
}
$h_Ljava_io_PrintStream.prototype = $c_Ljava_io_PrintStream.prototype;
$c_Ljava_io_PrintStream.prototype.println__T__V = (function(s) {
  this.print__T__V(s);
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V("\n")
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__Ljava_io_PrintStream = (function(csq) {
  this.print__T__V(((csq === null) ? "null" : $dp_toString__T($n(csq))));
  return this
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__I__I__Ljava_io_PrintStream = (function(csq, start, end) {
  var csq1 = ((csq === null) ? "null" : csq);
  this.print__T__V($dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n(csq1), start, end))));
  return this
});
$c_Ljava_io_PrintStream.prototype.append__C__Ljava_io_PrintStream = (function(c) {
  this.print__C__V(c);
  return this
});
$c_Ljava_io_PrintStream.prototype.append__C__jl_Appendable = (function(c) {
  return this.append__C__Ljava_io_PrintStream(c)
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__Ljava_io_PrintStream(csq, start, end)
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  return this.append__jl_CharSequence__Ljava_io_PrintStream(csq)
});
function $as_Ljava_io_PrintStream(obj) {
  return (((obj instanceof $c_Ljava_io_PrintStream) || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.PrintStream"))
}
function $isArrayOf_Ljava_io_PrintStream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_PrintStream)))
}
function $asArrayOf_Ljava_io_PrintStream(obj, depth) {
  return (($isArrayOf_Ljava_io_PrintStream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.PrintStream;", depth))
}
function $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant($thiz, secondsToAdd, nanosToAdd) {
  var lo = nanosToAdd.RTLong__f_lo;
  var hi = nanosToAdd.RTLong__f_hi;
  var _nanosToAdd__lo = lo;
  var _nanosToAdd__hi = hi;
  var b__lo = _nanosToAdd__lo;
  var b__hi = _nanosToAdd__hi;
  var lo$1 = (secondsToAdd.RTLong__f_lo | b__lo);
  var hi$1 = (secondsToAdd.RTLong__f_hi | b__hi);
  if (((lo$1 === 0) && (hi$1 === 0))) {
    return $thiz
  };
  var t = $thiz.Ljava_time_Instant__f_seconds;
  var lo$2 = t.RTLong__f_lo;
  var hi$2 = t.RTLong__f_hi;
  var t$1 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$2, hi$2), secondsToAdd);
  var lo$3 = t$1.RTLong__f_lo;
  var hi$3 = t$1.RTLong__f_hi;
  var epochSec__lo = lo$3;
  var epochSec__hi = hi$3;
  var a__lo = epochSec__lo;
  var a__hi = epochSec__hi;
  var this$1__lo = _nanosToAdd__lo;
  var this$1__hi = _nanosToAdd__hi;
  var this$2 = $m_RTLong$();
  var lo$4 = this$2.divideImpl__I__I__I__I__I(this$1__lo, this$1__hi, 1000000000, 0);
  var hi$4 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var t$2 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(a__lo, a__hi), new $c_RTLong(lo$4, hi$4));
  var lo$5 = t$2.RTLong__f_lo;
  var hi$5 = t$2.RTLong__f_hi;
  var $$x1__lo = lo$5;
  var $$x1__hi = hi$5;
  epochSec__lo = $$x1__lo;
  epochSec__hi = $$x1__hi;
  var this$3__lo = _nanosToAdd__lo;
  var this$3__hi = _nanosToAdd__hi;
  var this$4 = $m_RTLong$();
  var lo$6 = this$4.remainderImpl__I__I__I__I__I(this$3__lo, this$3__hi, 1000000000, 0);
  var hi$6 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var $$x2__lo = lo$6;
  var $$x2__hi = hi$6;
  _nanosToAdd__lo = $$x2__lo;
  _nanosToAdd__hi = $$x2__hi;
  var value = $thiz.Ljava_time_Instant__f_nanos;
  var hi$7 = (value >> 31);
  var b$1__lo = _nanosToAdd__lo;
  var b$1__hi = _nanosToAdd__hi;
  var bhi = b$1__hi;
  var lo$7 = ((value + b$1__lo) | 0);
  var hi$8 = ((((-2147483648) ^ lo$7) < ((-2147483648) ^ value)) ? ((1 + ((hi$7 + bhi) | 0)) | 0) : ((hi$7 + bhi) | 0));
  return $m_Ljava_time_Instant$().ofEpochSecond__J__J__Ljava_time_Instant(new $c_RTLong(epochSec__lo, epochSec__hi), new $c_RTLong(lo$7, hi$8))
}
function $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J($thiz, end) {
  var t = $n(end).Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $thiz.Ljava_time_Instant__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var t$3 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$2, hi$2), new $c_RTLong(1000000000, 0));
  var lo$3 = t$3.RTLong__f_lo;
  var hi$3 = t$3.RTLong__f_hi;
  var value = $n(end).Ljava_time_Instant__f_nanos;
  var hi$4 = (value >> 31);
  var value$1 = $thiz.Ljava_time_Instant__f_nanos;
  var hi$5 = (value$1 >> 31);
  var lo$4 = ((value - value$1) | 0);
  var hi$6 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ value)) ? (((-1) + ((hi$4 - hi$5) | 0)) | 0) : ((hi$4 - hi$5) | 0));
  return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$3, hi$3), new $c_RTLong(lo$4, hi$6))
}
function $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J($thiz, end) {
  var t = $n(end).Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $thiz.Ljava_time_Instant__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var value = $n(end).Ljava_time_Instant__f_nanos;
  var hi$3 = (value >> 31);
  var value$1 = $thiz.Ljava_time_Instant__f_nanos;
  var hi$4 = (value$1 >> 31);
  var lo$3 = ((value - value$1) | 0);
  var hi$5 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ value)) ? (((-1) + ((hi$3 - hi$4) | 0)) | 0) : ((hi$3 - hi$4) | 0));
  if ((((hi$2 === 0) ? (lo$2 !== 0) : (hi$2 > 0)) && (hi$5 < 0))) {
    var lo$4 = (((-1) + lo$2) | 0);
    var hi$6 = ((lo$4 !== (-1)) ? hi$2 : (((-1) + hi$2) | 0));
    return new $c_RTLong(lo$4, hi$6)
  } else if (((hi$2 < 0) && ((hi$5 === 0) ? (lo$3 !== 0) : (hi$5 > 0)))) {
    var lo$5 = ((1 + lo$2) | 0);
    var hi$7 = ((lo$5 === 0) ? ((1 + hi$2) | 0) : hi$2);
    return new $c_RTLong(lo$5, hi$7)
  } else {
    return new $c_RTLong(lo$2, hi$2)
  }
}
/** @constructor */
function $c_Ljava_time_Instant(seconds, nanos) {
  this.Ljava_time_Instant__f_seconds = $L0;
  this.Ljava_time_Instant__f_nanos = 0;
  this.Ljava_time_Instant__f_seconds = seconds;
  this.Ljava_time_Instant__f_nanos = nanos
}
$c_Ljava_time_Instant.prototype = new $h_O();
$c_Ljava_time_Instant.prototype.constructor = $c_Ljava_time_Instant;
/** @constructor */
function $h_Ljava_time_Instant() {
  /*<skip>*/
}
$h_Ljava_time_Instant.prototype = $c_Ljava_time_Instant.prototype;
$c_Ljava_time_Instant.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? ((((field === $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) : ((field !== null) && $n(field).isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)))
});
$c_Ljava_time_Instant.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field)
});
$c_Ljava_time_Instant.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var x = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      return this.Ljava_time_Instant__f_nanos
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x2)
      };
      if ($$x2) {
        return ((this.Ljava_time_Instant__f_nanos / 1000) | 0)
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
        if ((x$5 === null)) {
          var $$x3 = (x2 === null)
        } else {
          var this$3 = $n(x$5);
          var $$x3 = (this$3 === x2)
        };
        if ($$x3) {
          return ((this.Ljava_time_Instant__f_nanos / 1000000) | 0)
        } else {
          throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
        }
      }
    }
  } else {
    return $n($f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field)).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this), field)
  }
});
$c_Ljava_time_Instant.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var x = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      var value = this.Ljava_time_Instant__f_nanos;
      var hi = (value >> 31);
      return new $c_RTLong(value, hi)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$3 = $n(x$3);
        var $$x2 = (this$3 === x2)
      };
      if ($$x2) {
        var value$1 = this.Ljava_time_Instant__f_nanos;
        var hi$1 = (value$1 >> 31);
        var this$5 = $m_RTLong$();
        var lo = this$5.divideImpl__I__I__I__I__I(value$1, hi$1, 1000, 0);
        var hi$2 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return new $c_RTLong(lo, hi$2)
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
        if ((x$5 === null)) {
          var $$x3 = (x2 === null)
        } else {
          var this$6 = $n(x$5);
          var $$x3 = (this$6 === x2)
        };
        if ($$x3) {
          var value$2 = this.Ljava_time_Instant__f_nanos;
          var hi$3 = (value$2 >> 31);
          var this$8 = $m_RTLong$();
          var lo$1 = this$8.divideImpl__I__I__I__I__I(value$2, hi$3, 1000000, 0);
          var hi$4 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          return new $c_RTLong(lo$1, hi$4)
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
          if ((x$7 === null)) {
            var $$x4 = (x2 === null)
          } else {
            var this$9 = $n(x$7);
            var $$x4 = (this$9 === x2)
          };
          if ($$x4) {
            return this.Ljava_time_Instant__f_seconds
          } else {
            throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
          }
        }
      }
    }
  } else {
    return $n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this)
  }
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var this$1 = $n(x2);
    $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, this$1);
    var x = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$2 = $n(x);
      var $$x1 = (this$2 === x2)
    };
    if ($$x1) {
      var nval = Math.imul(1000000, newValue.RTLong__f_lo);
      return ((nval !== this.Ljava_time_Instant__f_nanos) ? $m_Ljava_time_Instant$().java$time$Instant$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds, nval) : this)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$3 = $n(x$3);
        var $$x2 = (this$3 === x2)
      };
      if ($$x2) {
        var nval$2 = Math.imul(1000, newValue.RTLong__f_lo);
        return ((nval$2 !== this.Ljava_time_Instant__f_nanos) ? $m_Ljava_time_Instant$().java$time$Instant$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds, nval$2) : this)
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
        if ((x$5 === null)) {
          var $$x3 = (x2 === null)
        } else {
          var this$4 = $n(x$5);
          var $$x3 = (this$4 === x2)
        };
        if ($$x3) {
          var value = this.Ljava_time_Instant__f_nanos;
          var hi = (value >> 31);
          if ((!((newValue.RTLong__f_lo === value) && (newValue.RTLong__f_hi === hi)))) {
            return $m_Ljava_time_Instant$().java$time$Instant$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds, newValue.RTLong__f_lo)
          } else {
            return this
          }
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
          if ((x$7 === null)) {
            var $$x4 = (x2 === null)
          } else {
            var this$6 = $n(x$7);
            var $$x4 = (this$6 === x2)
          };
          if ($$x4) {
            var b = this.Ljava_time_Instant__f_seconds;
            if ((!((newValue.RTLong__f_lo === b.RTLong__f_lo) && (newValue.RTLong__f_hi === b.RTLong__f_hi)))) {
              return $m_Ljava_time_Instant$().java$time$Instant$$create__J__I__Ljava_time_Instant(newValue, this.Ljava_time_Instant__f_nanos)
            } else {
              return this
            }
          } else {
            throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
          }
        }
      }
    }
  };
  return $as_Ljava_time_Instant($n(field).adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue))
});
$c_Ljava_time_Instant.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x2 = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $L0, amountToAdd)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoUnit$().MICROS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x2)
      };
      if ($$x2) {
        var this$3 = $m_RTLong$();
        var lo = this$3.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 1000000, 0);
        var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $$x3 = new $c_RTLong(lo, hi);
        var this$4 = $m_RTLong$();
        var lo$1 = this$4.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 1000000, 0);
        var hi$1 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var b0 = (65535 & lo$1);
        var b1 = ((lo$1 >>> 16) | 0);
        var a0b0 = Math.imul(1000, b0);
        var a0b1 = Math.imul(1000, b1);
        var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((Math.imul(1000, hi$1) + ((c1part >>> 16) | 0)) | 0);
        return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $$x3, new $c_RTLong(lo$2, hi$2))
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoUnit$().MILLIS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === null)) {
          var $$x4 = (x2 === null)
        } else {
          var this$5 = $n(x$5);
          var $$x4 = (this$5 === x2)
        };
        if ($$x4) {
          return this.plusMillis__J__Ljava_time_Instant(amountToAdd)
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === null)) {
            var $$x5 = (x2 === null)
          } else {
            var this$6 = $n(x$7);
            var $$x5 = (this$6 === x2)
          };
          if ($$x5) {
            return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, amountToAdd, $L0)
          } else {
            var x$9 = $m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === null)) {
              var $$x6 = (x2 === null)
            } else {
              var this$7 = $n(x$9);
              var $$x6 = (this$7 === x2)
            };
            if ($$x6) {
              var value = $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I();
              var hi$3 = (value >> 31);
              var t = $m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(value, hi$3));
              var lo$3 = t.RTLong__f_lo;
              var hi$4 = t.RTLong__f_hi;
              return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$3, hi$4), $L0)
            } else {
              var x$11 = $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === null)) {
                var $$x7 = (x2 === null)
              } else {
                var this$9 = $n(x$11);
                var $$x7 = (this$9 === x2)
              };
              if ($$x7) {
                var value$1 = $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I();
                var hi$5 = (value$1 >> 31);
                var t$1 = $m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(value$1, hi$5));
                var lo$4 = t$1.RTLong__f_lo;
                var hi$6 = t$1.RTLong__f_hi;
                return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$4, hi$6), $L0)
              } else {
                var x$13 = $m_Ljava_time_temporal_ChronoUnit$().HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === null)) {
                  var $$x8 = (x2 === null)
                } else {
                  var this$11 = $n(x$13);
                  var $$x8 = (this$11 === x2)
                };
                if ($$x8) {
                  var value$2 = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
                  var hi$7 = (value$2 >> 31);
                  var this$13 = $m_RTLong$();
                  var lo$5 = this$13.divideImpl__I__I__I__I__I(value$2, hi$7, 2, 0);
                  var hi$8 = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var t$2 = $m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(lo$5, hi$8));
                  var lo$6 = t$2.RTLong__f_lo;
                  var hi$9 = t$2.RTLong__f_hi;
                  return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$6, hi$9), $L0)
                } else {
                  var x$15 = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
                  if ((x$15 === null)) {
                    var $$x9 = (x2 === null)
                  } else {
                    var this$14 = $n(x$15);
                    var $$x9 = (this$14 === x2)
                  };
                  if ($$x9) {
                    var value$3 = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
                    var hi$10 = (value$3 >> 31);
                    var t$3 = $m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(value$3, hi$10));
                    var lo$7 = t$3.RTLong__f_lo;
                    var hi$11 = t$3.RTLong__f_hi;
                    return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$7, hi$11), $L0)
                  } else {
                    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  return $as_Ljava_time_Instant($n(unit).addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd))
});
$c_Ljava_time_Instant.prototype.plusMillis__J__Ljava_time_Instant = (function(millisToAdd) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(millisToAdd.RTLong__f_lo, millisToAdd.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var $$x1 = new $c_RTLong(lo, hi);
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.remainderImpl__I__I__I__I__I(millisToAdd.RTLong__f_lo, millisToAdd.RTLong__f_hi, 1000, 0);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b0 = (65535 & lo$1);
  var b1 = ((lo$1 >>> 16) | 0);
  var a0b0 = Math.imul(16960, b0);
  var a1b0 = Math.imul(15, b0);
  var a0b1 = Math.imul(16960, b1);
  var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((((((Math.imul(1000000, hi$1) + Math.imul(15, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $$x1, new $c_RTLong(lo$2, hi$2))
});
$c_Ljava_time_Instant.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return $n(this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(new $c_RTLong((-1), 2147483647), unit)).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_Instant.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)))
});
$c_Ljava_time_Instant.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $$x2 = $n($n(temporal).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), this.Ljava_time_Instant__f_seconds));
  var $$x1 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var value = this.Ljava_time_Instant__f_nanos;
  var hi = (value >> 31);
  return $n($$x2).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(value, hi))
});
$c_Ljava_time_Instant.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x2 = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      return $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J(this, end)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoUnit$().MICROS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x2)
      };
      if ($$x2) {
        var this$3 = $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J(this, end);
        var this$4 = $m_RTLong$();
        var lo = this$4.divideImpl__I__I__I__I__I(this$3.RTLong__f_lo, this$3.RTLong__f_hi, 1000, 0);
        var hi = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return new $c_RTLong(lo, hi)
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoUnit$().MILLIS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === null)) {
          var $$x3 = (x2 === null)
        } else {
          var this$5 = $n(x$5);
          var $$x3 = (this$5 === x2)
        };
        if ($$x3) {
          var t = $n(end).toEpochMilli__J();
          var lo$1 = t.RTLong__f_lo;
          var hi$1 = t.RTLong__f_hi;
          var t$1 = this.toEpochMilli__J();
          var lo$2 = t$1.RTLong__f_lo;
          var hi$2 = t$1.RTLong__f_hi;
          return $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$1, hi$1), new $c_RTLong(lo$2, hi$2))
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === null)) {
            var $$x4 = (x2 === null)
          } else {
            var this$6 = $n(x$7);
            var $$x4 = (this$6 === x2)
          };
          if ($$x4) {
            return $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end)
          } else {
            var x$9 = $m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === null)) {
              var $$x5 = (x2 === null)
            } else {
              var this$7 = $n(x$9);
              var $$x5 = (this$7 === x2)
            };
            if ($$x5) {
              var this$9 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
              var value = $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I();
              var hi$3 = (value >> 31);
              var this$10 = $m_RTLong$();
              var lo$3 = this$10.divideImpl__I__I__I__I__I(this$9.RTLong__f_lo, this$9.RTLong__f_hi, value, hi$3);
              var hi$4 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              return new $c_RTLong(lo$3, hi$4)
            } else {
              var x$11 = $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === null)) {
                var $$x6 = (x2 === null)
              } else {
                var this$11 = $n(x$11);
                var $$x6 = (this$11 === x2)
              };
              if ($$x6) {
                var this$13 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
                var value$1 = $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I();
                var hi$5 = (value$1 >> 31);
                var this$14 = $m_RTLong$();
                var lo$4 = this$14.divideImpl__I__I__I__I__I(this$13.RTLong__f_lo, this$13.RTLong__f_hi, value$1, hi$5);
                var hi$6 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                return new $c_RTLong(lo$4, hi$6)
              } else {
                var x$13 = $m_Ljava_time_temporal_ChronoUnit$().HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === null)) {
                  var $$x7 = (x2 === null)
                } else {
                  var this$15 = $n(x$13);
                  var $$x7 = (this$15 === x2)
                };
                if ($$x7) {
                  var this$17 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
                  var value$2 = Math.imul(12, $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I());
                  var hi$7 = (value$2 >> 31);
                  var this$18 = $m_RTLong$();
                  var lo$5 = this$18.divideImpl__I__I__I__I__I(this$17.RTLong__f_lo, this$17.RTLong__f_hi, value$2, hi$7);
                  var hi$8 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  return new $c_RTLong(lo$5, hi$8)
                } else {
                  var x$15 = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
                  if ((x$15 === null)) {
                    var $$x8 = (x2 === null)
                  } else {
                    var this$19 = $n(x$15);
                    var $$x8 = (this$19 === x2)
                  };
                  if ($$x8) {
                    var this$21 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
                    var value$3 = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
                    var hi$9 = (value$3 >> 31);
                    var this$22 = $m_RTLong$();
                    var lo$6 = this$22.divideImpl__I__I__I__I__I(this$21.RTLong__f_lo, this$21.RTLong__f_hi, value$3, hi$9);
                    var hi$10 = this$22.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                    return new $c_RTLong(lo$6, hi$10)
                  } else {
                    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  return $n(unit).between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end)
});
$c_Ljava_time_Instant.prototype.toEpochMilli__J = (function() {
  var this$1 = this.Ljava_time_Instant__f_seconds;
  var ahi = this$1.RTLong__f_hi;
  if ((ahi >= 0)) {
    var t = this.Ljava_time_Instant__f_seconds;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo, hi), new $c_RTLong(1000, 0));
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var value = this.Ljava_time_Instant__f_nanos;
    var hi$2 = (value >> 31);
    var this$3 = $m_RTLong$();
    var lo$2 = this$3.divideImpl__I__I__I__I__I(value, hi$2, 1000000, 0);
    var hi$3 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$1, hi$1), new $c_RTLong(lo$2, hi$3))
  } else {
    var b = this.Ljava_time_Instant__f_seconds;
    var bhi = b.RTLong__f_hi;
    var lo$3 = ((1 + b.RTLong__f_lo) | 0);
    var hi$4 = ((lo$3 === 0) ? ((1 + bhi) | 0) : bhi);
    var t$2 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(lo$3, hi$4), new $c_RTLong(1000, 0));
    var lo$4 = t$2.RTLong__f_lo;
    var hi$5 = t$2.RTLong__f_hi;
    var value$1 = this.Ljava_time_Instant__f_nanos;
    var hi$6 = (value$1 >> 31);
    var this$6 = $m_RTLong$();
    var lo$5 = this$6.divideImpl__I__I__I__I__I(value$1, hi$6, 1000000, 0);
    var hi$7 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$6 = ((1000 - lo$5) | 0);
    var hi$8 = ((((-2147483648) ^ lo$6) > (-2147482648)) ? (((-1) - hi$7) | 0) : ((-hi$7) | 0));
    return $m_jl_Math$().subtractExact__J__J__J(new $c_RTLong(lo$4, hi$5), new $c_RTLong(lo$6, hi$8))
  }
});
$c_Ljava_time_Instant.prototype.compare__Ljava_time_Instant__I = (function(otherInstant) {
  var t = this.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $n(otherInstant).Ljava_time_Instant__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  return ((cmp !== 0) ? cmp : ((this.Ljava_time_Instant__f_nanos - $n(otherInstant).Ljava_time_Instant__f_nanos) | 0))
});
$c_Ljava_time_Instant.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_Instant)) {
    var x2 = $as_Ljava_time_Instant(other);
    if ((this === x2)) {
      return true
    } else {
      var this$1 = this.Ljava_time_Instant__f_seconds;
      var b = $n(x2).Ljava_time_Instant__f_seconds;
      if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
        return (this.Ljava_time_Instant__f_nanos === $n(x2).Ljava_time_Instant__f_nanos)
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_Instant.prototype.hashCode__I = (function() {
  var this$2 = this.Ljava_time_Instant__f_seconds;
  var this$1 = this.Ljava_time_Instant__f_seconds;
  var hi = this$1.RTLong__f_hi;
  var lo = (this$2.RTLong__f_lo ^ hi);
  return ((lo + Math.imul(51, this.Ljava_time_Instant__f_nanos)) | 0)
});
$c_Ljava_time_Instant.prototype.toString__T = (function() {
  return $n($m_Ljava_time_format_DateTimeFormatter$().ISO_INSTANT__Ljava_time_format_DateTimeFormatter()).format__Ljava_time_temporal_TemporalAccessor__T(this)
});
$c_Ljava_time_Instant.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_Instant(that);
  return this.compare__Ljava_time_Instant__I(other)
});
$c_Ljava_time_Instant.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(amountToSubtract, unit)
});
$c_Ljava_time_Instant.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(amountToAdd, unit)
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant(field, newValue)
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return $as_Ljava_time_Instant($n(adjuster).adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this))
});
function $as_Ljava_time_Instant(obj) {
  return (((obj instanceof $c_Ljava_time_Instant) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Instant"))
}
function $isArrayOf_Ljava_time_Instant(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Instant)))
}
function $asArrayOf_Ljava_time_Instant(obj, depth) {
  return (($isArrayOf_Ljava_time_Instant(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Instant;", depth))
}
var $d_Ljava_time_Instant = new $TypeData().initClass({
  Ljava_time_Instant: 0
}, false, "java.time.Instant", {
  Ljava_time_Instant: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_Instant.prototype.$classData = $d_Ljava_time_Instant;
function $p_Ljava_time_LocalTime__hour__B($thiz) {
  if (((((1 & $thiz.Ljava_time_LocalTime__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 391")
  };
  return $thiz.Ljava_time_LocalTime__f_hour
}
function $p_Ljava_time_LocalTime__minute__B($thiz) {
  if (((((2 & $thiz.Ljava_time_LocalTime__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 394")
  };
  return $thiz.Ljava_time_LocalTime__f_minute
}
function $p_Ljava_time_LocalTime__second__B($thiz) {
  if (((((4 & $thiz.Ljava_time_LocalTime__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalTime.scala: 397")
  };
  return $thiz.Ljava_time_LocalTime__f_second
}
function $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x1 = $as_Ljava_time_temporal_ChronoField(field);
  var x = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  if ((x === null)) {
    var $$x1 = (x1 === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = (this$1 === x1)
  };
  if ($$x1) {
    var value = $thiz.Ljava_time_LocalTime__f_nano;
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  } else {
    var x$3 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $$x2 = (x1 === null)
    } else {
      var this$3 = $n(x$3);
      var $$x2 = (this$3 === x1)
    };
    if ($$x2) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
    } else {
      var x$5 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((x$5 === null)) {
        var $$x3 = (x1 === null)
      } else {
        var this$4 = $n(x$5);
        var $$x3 = (this$4 === x1)
      };
      if ($$x3) {
        var value$1 = $thiz.Ljava_time_LocalTime__f_nano;
        var hi$1 = (value$1 >> 31);
        var this$6 = $m_RTLong$();
        var lo = this$6.divideImpl__I__I__I__I__I(value$1, hi$1, 1000, 0);
        var hi$2 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return new $c_RTLong(lo, hi$2)
      } else {
        var x$7 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
        if ((x$7 === null)) {
          var $$x4 = (x1 === null)
        } else {
          var this$7 = $n(x$7);
          var $$x4 = (this$7 === x1)
        };
        if ($$x4) {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
        } else {
          var x$9 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
          if ((x$9 === null)) {
            var $$x5 = (x1 === null)
          } else {
            var this$8 = $n(x$9);
            var $$x5 = (this$8 === x1)
          };
          if ($$x5) {
            var value$2 = $thiz.Ljava_time_LocalTime__f_nano;
            var hi$3 = (value$2 >> 31);
            var this$10 = $m_RTLong$();
            var lo$1 = this$10.divideImpl__I__I__I__I__I(value$2, hi$3, 1000000, 0);
            var hi$4 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            return new $c_RTLong(lo$1, hi$4)
          } else {
            var x$11 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
            if ((x$11 === null)) {
              var $$x6 = (x1 === null)
            } else {
              var this$11 = $n(x$11);
              var $$x6 = (this$11 === x1)
            };
            if ($$x6) {
              var this$12 = $thiz.toNanoOfDay__J();
              var this$13 = $m_RTLong$();
              var lo$2 = this$13.divideImpl__I__I__I__I__I(this$12.RTLong__f_lo, this$12.RTLong__f_hi, 1000000, 0);
              var hi$5 = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              return new $c_RTLong(lo$2, hi$5)
            } else {
              var x$13 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
              if ((x$13 === null)) {
                var $$x7 = (x1 === null)
              } else {
                var this$14 = $n(x$13);
                var $$x7 = (this$14 === x1)
              };
              if ($$x7) {
                var value$3 = $p_Ljava_time_LocalTime__second__B($thiz);
                var hi$6 = (value$3 >> 31);
                return new $c_RTLong(value$3, hi$6)
              } else {
                var x$15 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
                if ((x$15 === null)) {
                  var $$x8 = (x1 === null)
                } else {
                  var this$16 = $n(x$15);
                  var $$x8 = (this$16 === x1)
                };
                if ($$x8) {
                  var value$4 = $thiz.toSecondOfDay__I();
                  var hi$7 = (value$4 >> 31);
                  return new $c_RTLong(value$4, hi$7)
                } else {
                  var x$17 = $m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
                  if ((x$17 === null)) {
                    var $$x9 = (x1 === null)
                  } else {
                    var this$18 = $n(x$17);
                    var $$x9 = (this$18 === x1)
                  };
                  if ($$x9) {
                    var value$5 = $p_Ljava_time_LocalTime__minute__B($thiz);
                    var hi$8 = (value$5 >> 31);
                    return new $c_RTLong(value$5, hi$8)
                  } else {
                    var x$19 = $m_Ljava_time_temporal_ChronoField$().MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
                    if ((x$19 === null)) {
                      var $$x10 = (x1 === null)
                    } else {
                      var this$20 = $n(x$19);
                      var $$x10 = (this$20 === x1)
                    };
                    if ($$x10) {
                      var value$6 = $p_Ljava_time_LocalTime__hour__B($thiz);
                      var hi$9 = (value$6 >> 31);
                      var b0 = (65535 & value$6);
                      var b1 = ((value$6 >>> 16) | 0);
                      var a0b0 = Math.imul(60, b0);
                      var a0b1 = Math.imul(60, b1);
                      var lo$3 = ((a0b0 + (a0b1 << 16)) | 0);
                      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
                      var hi$10 = ((Math.imul(60, hi$9) + ((c1part >>> 16) | 0)) | 0);
                      var value$7 = $p_Ljava_time_LocalTime__minute__B($thiz);
                      var hi$11 = (value$7 >> 31);
                      var lo$4 = ((lo$3 + value$7) | 0);
                      var hi$12 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ lo$3)) ? ((1 + ((hi$10 + hi$11) | 0)) | 0) : ((hi$10 + hi$11) | 0));
                      return new $c_RTLong(lo$4, hi$12)
                    } else {
                      var x$21 = $m_Ljava_time_temporal_ChronoField$().HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
                      if ((x$21 === null)) {
                        var $$x11 = (x1 === null)
                      } else {
                        var this$24 = $n(x$21);
                        var $$x11 = (this$24 === x1)
                      };
                      if ($$x11) {
                        var value$8 = $p_Ljava_time_LocalTime__hour__B($thiz);
                        var hi$13 = (value$8 >> 31);
                        var this$26 = $m_RTLong$();
                        var lo$5 = this$26.remainderImpl__I__I__I__I__I(value$8, hi$13, 12, 0);
                        var hi$14 = this$26.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                        return new $c_RTLong(lo$5, hi$14)
                      } else {
                        var x$23 = $m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
                        if ((x$23 === null)) {
                          var $$x12 = (x1 === null)
                        } else {
                          var this$27 = $n(x$23);
                          var $$x12 = (this$27 === x1)
                        };
                        if ($$x12) {
                          var value$9 = $p_Ljava_time_LocalTime__hour__B($thiz);
                          var hi$15 = (value$9 >> 31);
                          var this$29 = $m_RTLong$();
                          var lo$6 = this$29.remainderImpl__I__I__I__I__I(value$9, hi$15, 12, 0);
                          var hi$16 = this$29.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                          var this$30 = $m_RTLong$();
                          var lo$7 = this$30.remainderImpl__I__I__I__I__I(lo$6, hi$16, 12, 0);
                          var hi$17 = this$30.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                          if (((lo$7 === 0) && (hi$17 === 0))) {
                            return new $c_RTLong(12, 0)
                          } else {
                            return new $c_RTLong(lo$6, hi$16)
                          }
                        } else {
                          var x$25 = $m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
                          if ((x$25 === null)) {
                            var $$x13 = (x1 === null)
                          } else {
                            var this$31 = $n(x$25);
                            var $$x13 = (this$31 === x1)
                          };
                          if ($$x13) {
                            var value$10 = $p_Ljava_time_LocalTime__hour__B($thiz);
                            var hi$18 = (value$10 >> 31);
                            return new $c_RTLong(value$10, hi$18)
                          } else {
                            var x$27 = $m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
                            if ((x$27 === null)) {
                              var $$x14 = (x1 === null)
                            } else {
                              var this$33 = $n(x$27);
                              var $$x14 = (this$33 === x1)
                            };
                            if ($$x14) {
                              if (($p_Ljava_time_LocalTime__hour__B($thiz) === 0)) {
                                return new $c_RTLong(24, 0)
                              } else {
                                var value$11 = $p_Ljava_time_LocalTime__hour__B($thiz);
                                var hi$19 = (value$11 >> 31);
                                return new $c_RTLong(value$11, hi$19)
                              }
                            } else {
                              var x$29 = $m_Ljava_time_temporal_ChronoField$().AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
                              if ((x$29 === null)) {
                                var $$x15 = (x1 === null)
                              } else {
                                var this$35 = $n(x$29);
                                var $$x15 = (this$35 === x1)
                              };
                              if ($$x15) {
                                var value$12 = $p_Ljava_time_LocalTime__hour__B($thiz);
                                var hi$20 = (value$12 >> 31);
                                var this$37 = $m_RTLong$();
                                var lo$8 = this$37.divideImpl__I__I__I__I__I(value$12, hi$20, 12, 0);
                                var hi$21 = this$37.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                                return new $c_RTLong(lo$8, hi$21)
                              } else {
                                throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
/** @constructor */
function $c_Ljava_time_LocalTime(_hour, _minute, _second, nano) {
  this.Ljava_time_LocalTime__f_nano = 0;
  this.Ljava_time_LocalTime__f_hour = 0;
  this.Ljava_time_LocalTime__f_minute = 0;
  this.Ljava_time_LocalTime__f_second = 0;
  this.Ljava_time_LocalTime__f_bitmap$init$0 = 0;
  this.Ljava_time_LocalTime__f_nano = nano;
  this.Ljava_time_LocalTime__f_hour = ((_hour << 24) >> 24);
  this.Ljava_time_LocalTime__f_bitmap$init$0 = (((1 | this.Ljava_time_LocalTime__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_LocalTime__f_minute = ((_minute << 24) >> 24);
  this.Ljava_time_LocalTime__f_bitmap$init$0 = (((2 | this.Ljava_time_LocalTime__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_LocalTime__f_second = ((_second << 24) >> 24);
  this.Ljava_time_LocalTime__f_bitmap$init$0 = (((4 | this.Ljava_time_LocalTime__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_LocalTime.prototype = new $h_O();
$c_Ljava_time_LocalTime.prototype.constructor = $c_Ljava_time_LocalTime;
/** @constructor */
function $h_Ljava_time_LocalTime() {
  /*<skip>*/
}
$h_Ljava_time_LocalTime.prototype = $c_Ljava_time_LocalTime.prototype;
$c_Ljava_time_LocalTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? $n(field).isTimeBased__Z() : ((field !== null) && $n(field).isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)))
});
$c_Ljava_time_LocalTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field)
});
$c_Ljava_time_LocalTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var this$1 = $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field);
    return this$1.RTLong__f_lo
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
  }
});
$c_Ljava_time_LocalTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ((field === $m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      return this.toNanoOfDay__J()
    };
    if ((field === $m_Ljava_time_temporal_ChronoField$().MICRO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      var this$1 = this.toNanoOfDay__J();
      var this$2 = $m_RTLong$();
      var lo = this$2.divideImpl__I__I__I__I__I(this$1.RTLong__f_lo, this$1.RTLong__f_hi, 1000, 0);
      var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo, hi)
    };
    return $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field)
  } else {
    return $n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this)
  }
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalTime = (function(adjuster) {
  if ((adjuster instanceof $c_Ljava_time_LocalTime)) {
    var x2 = $as_Ljava_time_LocalTime(adjuster);
    return x2
  } else {
    return $as_Ljava_time_LocalTime($n(adjuster).adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this))
  }
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var this$1 = $n(x2);
    $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, this$1);
    var x = $m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$2 = $n(x);
      var $$x1 = (this$2 === x2)
    };
    if ($$x1) {
      return this.withNano__I__Ljava_time_LocalTime(newValue.RTLong__f_lo)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$3 = $n(x$3);
        var $$x2 = (this$3 === x2)
      };
      if ($$x2) {
        return $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(newValue)
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
        if ((x$5 === null)) {
          var $$x3 = (x2 === null)
        } else {
          var this$4 = $n(x$5);
          var $$x3 = (this$4 === x2)
        };
        if ($$x3) {
          return this.withNano__I__Ljava_time_LocalTime(Math.imul(1000, newValue.RTLong__f_lo))
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoField$().MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
          if ((x$7 === null)) {
            var $$x4 = (x2 === null)
          } else {
            var this$5 = $n(x$7);
            var $$x4 = (this$5 === x2)
          };
          if ($$x4) {
            var $$x5 = $m_Ljava_time_LocalTime$();
            var blo = newValue.RTLong__f_lo;
            var b0 = (65535 & blo);
            var b1 = ((blo >>> 16) | 0);
            var a0b0 = Math.imul(1000, b0);
            var a0b1 = Math.imul(1000, b1);
            var lo = ((a0b0 + (a0b1 << 16)) | 0);
            var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
            var hi = ((Math.imul(1000, newValue.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
            return $n($$x5).ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo, hi))
          } else {
            var x$9 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
            if ((x$9 === null)) {
              var $$x6 = (x2 === null)
            } else {
              var this$6 = $n(x$9);
              var $$x6 = (this$6 === x2)
            };
            if ($$x6) {
              return this.withNano__I__Ljava_time_LocalTime(Math.imul(1000000, newValue.RTLong__f_lo))
            } else {
              var x$11 = $m_Ljava_time_temporal_ChronoField$().MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
              if ((x$11 === null)) {
                var $$x7 = (x2 === null)
              } else {
                var this$7 = $n(x$11);
                var $$x7 = (this$7 === x2)
              };
              if ($$x7) {
                var $$x8 = $m_Ljava_time_LocalTime$();
                var blo$1 = newValue.RTLong__f_lo;
                var b0$1 = (65535 & blo$1);
                var b1$1 = ((blo$1 >>> 16) | 0);
                var a0b0$1 = Math.imul(16960, b0$1);
                var a1b0 = Math.imul(15, b0$1);
                var a0b1$1 = Math.imul(16960, b1$1);
                var lo$1 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
                var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
                var hi$1 = ((((((Math.imul(1000000, newValue.RTLong__f_hi) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
                return $n($$x8).ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$1, hi$1))
              } else {
                var x$13 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
                if ((x$13 === null)) {
                  var $$x9 = (x2 === null)
                } else {
                  var this$8 = $n(x$13);
                  var $$x9 = (this$8 === x2)
                };
                if ($$x9) {
                  return this.withSecond__I__Ljava_time_LocalTime(newValue.RTLong__f_lo)
                } else {
                  var x$15 = $m_Ljava_time_temporal_ChronoField$().SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
                  if ((x$15 === null)) {
                    var $$x10 = (x2 === null)
                  } else {
                    var this$9 = $n(x$15);
                    var $$x10 = (this$9 === x2)
                  };
                  if ($$x10) {
                    var value = this.toSecondOfDay__I();
                    var hi$2 = (value >> 31);
                    var alo = newValue.RTLong__f_lo;
                    var ahi = newValue.RTLong__f_hi;
                    var lo$2 = ((alo - value) | 0);
                    var hi$3 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$2) | 0)) | 0) : ((ahi - hi$2) | 0));
                    return this.plusSeconds__J__Ljava_time_LocalTime(new $c_RTLong(lo$2, hi$3))
                  } else {
                    var x$17 = $m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
                    if ((x$17 === null)) {
                      var $$x11 = (x2 === null)
                    } else {
                      var this$12 = $n(x$17);
                      var $$x11 = (this$12 === x2)
                    };
                    if ($$x11) {
                      return this.withMinute__I__Ljava_time_LocalTime(newValue.RTLong__f_lo)
                    } else {
                      var x$19 = $m_Ljava_time_temporal_ChronoField$().MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
                      if ((x$19 === null)) {
                        var $$x12 = (x2 === null)
                      } else {
                        var this$13 = $n(x$19);
                        var $$x12 = (this$13 === x2)
                      };
                      if ($$x12) {
                        var value$1 = ((Math.imul(60, $p_Ljava_time_LocalTime__hour__B(this)) + $p_Ljava_time_LocalTime__minute__B(this)) | 0);
                        var hi$4 = (value$1 >> 31);
                        var alo$1 = newValue.RTLong__f_lo;
                        var ahi$1 = newValue.RTLong__f_hi;
                        var lo$3 = ((alo$1 - value$1) | 0);
                        var hi$5 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - hi$4) | 0)) | 0) : ((ahi$1 - hi$4) | 0));
                        return this.plusMinutes__J__Ljava_time_LocalTime(new $c_RTLong(lo$3, hi$5))
                      } else {
                        var x$21 = $m_Ljava_time_temporal_ChronoField$().HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
                        if ((x$21 === null)) {
                          var $$x13 = (x2 === null)
                        } else {
                          var this$16 = $n(x$21);
                          var $$x13 = (this$16 === x2)
                        };
                        if ($$x13) {
                          var value$2 = (($p_Ljava_time_LocalTime__hour__B(this) % 12) | 0);
                          var hi$6 = (value$2 >> 31);
                          var alo$2 = newValue.RTLong__f_lo;
                          var ahi$2 = newValue.RTLong__f_hi;
                          var lo$4 = ((alo$2 - value$2) | 0);
                          var hi$7 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$2 - hi$6) | 0)) | 0) : ((ahi$2 - hi$6) | 0));
                          return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$4, hi$7))
                        } else {
                          var x$23 = $m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
                          if ((x$23 === null)) {
                            var $$x14 = (x2 === null)
                          } else {
                            var this$19 = $n(x$23);
                            var $$x14 = (this$19 === x2)
                          };
                          if ($$x14) {
                            var this$21 = (((newValue.RTLong__f_lo === 12) && (newValue.RTLong__f_hi === 0)) ? $L0 : newValue);
                            var value$3 = (($p_Ljava_time_LocalTime__hour__B(this) % 12) | 0);
                            var hi$8 = (value$3 >> 31);
                            var alo$3 = this$21.RTLong__f_lo;
                            var ahi$3 = this$21.RTLong__f_hi;
                            var lo$5 = ((alo$3 - value$3) | 0);
                            var hi$9 = ((((-2147483648) ^ lo$5) > ((-2147483648) ^ alo$3)) ? (((-1) + ((ahi$3 - hi$8) | 0)) | 0) : ((ahi$3 - hi$8) | 0));
                            return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$5, hi$9))
                          } else {
                            var x$25 = $m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
                            if ((x$25 === null)) {
                              var $$x15 = (x2 === null)
                            } else {
                              var this$23 = $n(x$25);
                              var $$x15 = (this$23 === x2)
                            };
                            if ($$x15) {
                              return this.withHour__I__Ljava_time_LocalTime(newValue.RTLong__f_lo)
                            } else {
                              var x$27 = $m_Ljava_time_temporal_ChronoField$().CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
                              if ((x$27 === null)) {
                                var $$x16 = (x2 === null)
                              } else {
                                var this$24 = $n(x$27);
                                var $$x16 = (this$24 === x2)
                              };
                              if ($$x16) {
                                var this$25 = (((newValue.RTLong__f_lo === 24) && (newValue.RTLong__f_hi === 0)) ? $L0 : newValue);
                                return this.withHour__I__Ljava_time_LocalTime(this$25.RTLong__f_lo)
                              } else {
                                var x$29 = $m_Ljava_time_temporal_ChronoField$().AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
                                if ((x$29 === null)) {
                                  var $$x17 = (x2 === null)
                                } else {
                                  var this$26 = $n(x$29);
                                  var $$x17 = (this$26 === x2)
                                };
                                if ($$x17) {
                                  var value$4 = (($p_Ljava_time_LocalTime__hour__B(this) / 12) | 0);
                                  var hi$10 = (value$4 >> 31);
                                  var alo$4 = newValue.RTLong__f_lo;
                                  var ahi$4 = newValue.RTLong__f_hi;
                                  var lo$6 = ((alo$4 - value$4) | 0);
                                  var hi$11 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ alo$4)) ? (((-1) + ((ahi$4 - hi$10) | 0)) | 0) : ((ahi$4 - hi$10) | 0));
                                  var b0$2 = (65535 & lo$6);
                                  var b1$2 = ((lo$6 >>> 16) | 0);
                                  var a0b0$2 = Math.imul(12, b0$2);
                                  var a0b1$2 = Math.imul(12, b1$2);
                                  var lo$7 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
                                  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
                                  var hi$12 = ((Math.imul(12, hi$11) + ((c1part$2 >>> 16) | 0)) | 0);
                                  return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$7, hi$12))
                                } else {
                                  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  } else {
    return $as_Ljava_time_LocalTime($n(field).adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue))
  }
});
$c_Ljava_time_LocalTime.prototype.withHour__I__Ljava_time_LocalTime = (function(hour) {
  if (($p_Ljava_time_LocalTime__hour__B(this) === hour)) {
    return this
  } else {
    var this$2 = $n($m_Ljava_time_temporal_ChronoField$().HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
    var hi = (hour >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime(hour, $p_Ljava_time_LocalTime__minute__B(this), $p_Ljava_time_LocalTime__second__B(this), this.Ljava_time_LocalTime__f_nano)
  }
});
$c_Ljava_time_LocalTime.prototype.withMinute__I__Ljava_time_LocalTime = (function(minute) {
  if (($p_Ljava_time_LocalTime__minute__B(this) === minute)) {
    return this
  } else {
    var this$2 = $n($m_Ljava_time_temporal_ChronoField$().MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
    var hi = (minute >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime($p_Ljava_time_LocalTime__hour__B(this), minute, $p_Ljava_time_LocalTime__second__B(this), this.Ljava_time_LocalTime__f_nano)
  }
});
$c_Ljava_time_LocalTime.prototype.withSecond__I__Ljava_time_LocalTime = (function(second) {
  if (($p_Ljava_time_LocalTime__second__B(this) === second)) {
    return this
  } else {
    var this$2 = $n($m_Ljava_time_temporal_ChronoField$().SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
    var hi = (second >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(second, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime($p_Ljava_time_LocalTime__hour__B(this), $p_Ljava_time_LocalTime__minute__B(this), second, this.Ljava_time_LocalTime__f_nano)
  }
});
$c_Ljava_time_LocalTime.prototype.withNano__I__Ljava_time_LocalTime = (function(nanoOfSecond) {
  if ((this.Ljava_time_LocalTime__f_nano === nanoOfSecond)) {
    return this
  } else {
    var this$2 = $n($m_Ljava_time_temporal_ChronoField$().NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var hi = (nanoOfSecond >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(nanoOfSecond, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime($p_Ljava_time_LocalTime__hour__B(this), $p_Ljava_time_LocalTime__minute__B(this), $p_Ljava_time_LocalTime__second__B(this), nanoOfSecond)
  }
});
$c_Ljava_time_LocalTime.prototype.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime = (function(unit) {
  if ((unit === $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit())) {
    return this
  };
  var unitDur = $n(unit).getDuration__Ljava_time_Duration();
  var this$1 = $n(unitDur);
  var this$3 = this$1.Ljava_time_Duration__f_seconds;
  var value = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
  var hi = (value >> 31);
  var ahi = this$3.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ this$3.RTLong__f_lo) > ((-2147483648) ^ value)) : (ahi > hi))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Unit is too large to be used for truncation")
  };
  var t = $n(unitDur).toNanos__J();
  var lo = t.RTLong__f_lo;
  var hi$1 = t.RTLong__f_hi;
  var this$4 = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
  var this$5 = $m_RTLong$();
  var lo$1 = this$5.remainderImpl__I__I__I__I__I(this$4.RTLong__f_lo, this$4.RTLong__f_hi, lo, hi$1);
  var hi$2 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((!((lo$1 === 0) && (hi$2 === 0)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Unit must divide into a standard day without remainder")
  };
  var t$1 = this.toNanoOfDay__J();
  var lo$2 = t$1.RTLong__f_lo;
  var hi$3 = t$1.RTLong__f_hi;
  var $$x1 = $m_Ljava_time_LocalTime$();
  var this$6 = $m_RTLong$();
  var lo$3 = this$6.divideImpl__I__I__I__I__I(lo$2, hi$3, lo, hi$1);
  var hi$4 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var a0 = (65535 & lo$3);
  var a1 = ((lo$3 >>> 16) | 0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$5 = ((((((((Math.imul(lo$3, hi$1) + Math.imul(hi$4, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $n($$x1).ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$4, hi$5))
});
$c_Ljava_time_LocalTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x2 = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      return this.plusNanos__J__Ljava_time_LocalTime(amountToAdd)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoUnit$().MICROS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x2)
      };
      if ($$x2) {
        var b = $m_Ljava_time_LocalTime$().MICROS_PER_DAY__J();
        var this$3 = $m_RTLong$();
        var lo = this$3.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
        var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = Math.imul(1000, b0);
        var a0b1 = Math.imul(1000, b1);
        var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$1 = ((Math.imul(1000, hi) + ((c1part >>> 16) | 0)) | 0);
        return this.plusNanos__J__Ljava_time_LocalTime(new $c_RTLong(lo$1, hi$1))
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoUnit$().MILLIS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === null)) {
          var $$x3 = (x2 === null)
        } else {
          var this$4 = $n(x$5);
          var $$x3 = (this$4 === x2)
        };
        if ($$x3) {
          var b$1 = $m_Ljava_time_LocalTime$().MILLIS_PER_DAY__J();
          var this$5 = $m_RTLong$();
          var lo$2 = this$5.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b$1.RTLong__f_lo, b$1.RTLong__f_hi);
          var hi$2 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var b0$1 = (65535 & lo$2);
          var b1$1 = ((lo$2 >>> 16) | 0);
          var a0b0$1 = Math.imul(16960, b0$1);
          var a1b0 = Math.imul(15, b0$1);
          var a0b1$1 = Math.imul(16960, b1$1);
          var lo$3 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$3 = ((((((Math.imul(1000000, hi$2) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
          return this.plusNanos__J__Ljava_time_LocalTime(new $c_RTLong(lo$3, hi$3))
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === null)) {
            var $$x4 = (x2 === null)
          } else {
            var this$6 = $n(x$7);
            var $$x4 = (this$6 === x2)
          };
          if ($$x4) {
            return this.plusSeconds__J__Ljava_time_LocalTime(amountToAdd)
          } else {
            var x$9 = $m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === null)) {
              var $$x5 = (x2 === null)
            } else {
              var this$7 = $n(x$9);
              var $$x5 = (this$7 === x2)
            };
            if ($$x5) {
              return this.plusMinutes__J__Ljava_time_LocalTime(amountToAdd)
            } else {
              var x$11 = $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === null)) {
                var $$x6 = (x2 === null)
              } else {
                var this$8 = $n(x$11);
                var $$x6 = (this$8 === x2)
              };
              if ($$x6) {
                return this.plusHours__J__Ljava_time_LocalTime(amountToAdd)
              } else {
                var x$13 = $m_Ljava_time_temporal_ChronoUnit$().HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === null)) {
                  var $$x7 = (x2 === null)
                } else {
                  var this$9 = $n(x$13);
                  var $$x7 = (this$9 === x2)
                };
                if ($$x7) {
                  var this$10 = $m_RTLong$();
                  var lo$4 = this$10.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 2, 0);
                  var hi$4 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var b0$2 = (65535 & lo$4);
                  var b1$2 = ((lo$4 >>> 16) | 0);
                  var a0b0$2 = Math.imul(12, b0$2);
                  var a0b1$2 = Math.imul(12, b1$2);
                  var lo$5 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
                  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
                  var hi$5 = ((Math.imul(12, hi$4) + ((c1part$2 >>> 16) | 0)) | 0);
                  return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$5, hi$5))
                } else {
                  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                }
              }
            }
          }
        }
      }
    }
  } else {
    return $as_Ljava_time_LocalTime($n(unit).addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd))
  }
});
$c_Ljava_time_LocalTime.prototype.plusHours__J__Ljava_time_LocalTime = (function(hoursToAdd) {
  if (((hoursToAdd.RTLong__f_lo === 0) && (hoursToAdd.RTLong__f_hi === 0))) {
    return this
  };
  var value = $m_Ljava_time_LocalTime$().HOURS_PER_DAY__I();
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var lo = this$2.remainderImpl__I__I__I__I__I(hoursToAdd.RTLong__f_lo, hoursToAdd.RTLong__f_hi, value, hi);
  var newHour = $intMod(((((lo + $p_Ljava_time_LocalTime__hour__B(this)) | 0) + $m_Ljava_time_LocalTime$().HOURS_PER_DAY__I()) | 0), $m_Ljava_time_LocalTime$().HOURS_PER_DAY__I());
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime(newHour, $p_Ljava_time_LocalTime__minute__B(this), $p_Ljava_time_LocalTime__second__B(this), this.Ljava_time_LocalTime__f_nano)
});
$c_Ljava_time_LocalTime.prototype.plusMinutes__J__Ljava_time_LocalTime = (function(minutesToAdd) {
  if (((minutesToAdd.RTLong__f_lo === 0) && (minutesToAdd.RTLong__f_hi === 0))) {
    return this
  };
  var mofd = ((Math.imul($p_Ljava_time_LocalTime__hour__B(this), $m_Ljava_time_LocalTime$().MINUTES_PER_HOUR__I()) + $p_Ljava_time_LocalTime__minute__B(this)) | 0);
  var value = $m_Ljava_time_LocalTime$().MINUTES_PER_DAY__I();
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var lo = this$2.remainderImpl__I__I__I__I__I(minutesToAdd.RTLong__f_lo, minutesToAdd.RTLong__f_hi, value, hi);
  var newMofd = $intMod(((((lo + mofd) | 0) + $m_Ljava_time_LocalTime$().MINUTES_PER_DAY__I()) | 0), $m_Ljava_time_LocalTime$().MINUTES_PER_DAY__I());
  if ((mofd === newMofd)) {
    return this
  };
  var newHour = $intDiv(newMofd, $m_Ljava_time_LocalTime$().MINUTES_PER_HOUR__I());
  var newMinute = $intMod(newMofd, $m_Ljava_time_LocalTime$().MINUTES_PER_HOUR__I());
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime(newHour, newMinute, $p_Ljava_time_LocalTime__second__B(this), this.Ljava_time_LocalTime__f_nano)
});
$c_Ljava_time_LocalTime.prototype.plusSeconds__J__Ljava_time_LocalTime = (function(secondstoAdd) {
  if (((secondstoAdd.RTLong__f_lo === 0) && (secondstoAdd.RTLong__f_hi === 0))) {
    return this
  };
  var sofd = ((((Math.imul($p_Ljava_time_LocalTime__hour__B(this), $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I()) + Math.imul($p_Ljava_time_LocalTime__minute__B(this), $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I())) | 0) + $p_Ljava_time_LocalTime__second__B(this)) | 0);
  var value = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var lo = this$2.remainderImpl__I__I__I__I__I(secondstoAdd.RTLong__f_lo, secondstoAdd.RTLong__f_hi, value, hi);
  var newSofd = $intMod(((((lo + sofd) | 0) + $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I()) | 0), $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I());
  if ((sofd === newSofd)) {
    return this
  };
  var newHour = $intDiv(newSofd, $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I());
  var newMinute = $intMod($intDiv(newSofd, $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I()), $m_Ljava_time_LocalTime$().MINUTES_PER_HOUR__I());
  var newSecond = $intMod(newSofd, $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I());
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime(newHour, newMinute, newSecond, this.Ljava_time_LocalTime__f_nano)
});
$c_Ljava_time_LocalTime.prototype.plusNanos__J__Ljava_time_LocalTime = (function(nanosToAdd) {
  if (((nanosToAdd.RTLong__f_lo === 0) && (nanosToAdd.RTLong__f_hi === 0))) {
    return this
  };
  var t = this.toNanoOfDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var b = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
  var this$1 = $m_RTLong$();
  var lo$1 = this$1.remainderImpl__I__I__I__I__I(nanosToAdd.RTLong__f_lo, nanosToAdd.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var hi$1 = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$2 = ((lo$1 + lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$1 + hi) | 0)) | 0) : ((hi$1 + hi) | 0));
  var b$1 = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
  var bhi = b$1.RTLong__f_hi;
  var lo$3 = ((lo$2 + b$1.RTLong__f_lo) | 0);
  var hi$3 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$2)) ? ((1 + ((hi$2 + bhi) | 0)) | 0) : ((hi$2 + bhi) | 0));
  var b$2 = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
  var this$4 = $m_RTLong$();
  var lo$4 = this$4.remainderImpl__I__I__I__I__I(lo$3, hi$3, b$2.RTLong__f_lo, b$2.RTLong__f_hi);
  var hi$4 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === lo$4) && (hi === hi$4))) {
    return this
  };
  var b$3 = $m_Ljava_time_LocalTime$().NANOS_PER_HOUR__J();
  var this$5 = $m_RTLong$();
  var lo$5 = this$5.divideImpl__I__I__I__I__I(lo$4, hi$4, b$3.RTLong__f_lo, b$3.RTLong__f_hi);
  var b$4 = $m_Ljava_time_LocalTime$().NANOS_PER_MINUTE__J();
  var this$6 = $m_RTLong$();
  var lo$6 = this$6.divideImpl__I__I__I__I__I(lo$4, hi$4, b$4.RTLong__f_lo, b$4.RTLong__f_hi);
  var hi$6 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value = $m_Ljava_time_LocalTime$().MINUTES_PER_HOUR__I();
  var hi$7 = (value >> 31);
  var this$8 = $m_RTLong$();
  var lo$7 = this$8.remainderImpl__I__I__I__I__I(lo$6, hi$6, value, hi$7);
  var b$5 = $m_Ljava_time_LocalTime$().NANOS_PER_SECOND__J();
  var this$9 = $m_RTLong$();
  var lo$8 = this$9.divideImpl__I__I__I__I__I(lo$4, hi$4, b$5.RTLong__f_lo, b$5.RTLong__f_hi);
  var hi$9 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value$1 = $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I();
  var hi$10 = (value$1 >> 31);
  var this$11 = $m_RTLong$();
  var lo$9 = this$11.remainderImpl__I__I__I__I__I(lo$8, hi$9, value$1, hi$10);
  var b$6 = $m_Ljava_time_LocalTime$().NANOS_PER_SECOND__J();
  var this$12 = $m_RTLong$();
  var lo$10 = this$12.remainderImpl__I__I__I__I__I(lo$4, hi$4, b$6.RTLong__f_lo, b$6.RTLong__f_hi);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$create__I__I__I__I__Ljava_time_LocalTime(lo$5, lo$7, lo$9, lo$10)
});
$c_Ljava_time_LocalTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return $n(this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(new $c_RTLong((-1), 2147483647), unit)).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_LocalTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $$x1 = (query === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = (this$1 === query)
  };
  if ($$x1) {
    return $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit()
  } else {
    var x$3 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
    if ((x$3 === null)) {
      var $$x2 = (query === null)
    } else {
      var this$2 = $n(x$3);
      var $$x2 = (this$2 === query)
    };
    if ($$x2) {
      return this
    } else {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === null)) {
        var $$x4 = (query === null)
      } else {
        var this$3 = $n(x$5);
        var $$x4 = (this$3 === query)
      };
      if ($$x4) {
        var $$x3 = true
      } else {
        var x$7 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
        if ((x$7 === null)) {
          var $$x5 = (query === null)
        } else {
          var this$4 = $n(x$7);
          var $$x5 = (this$4 === query)
        };
        if ($$x5) {
          var $$x3 = true
        } else {
          var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
          if ((x$9 === null)) {
            var $$x6 = (query === null)
          } else {
            var this$5 = $n(x$9);
            var $$x6 = (this$5 === query)
          };
          if ($$x6) {
            var $$x3 = true
          } else {
            var x$11 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
            if ((x$11 === null)) {
              var $$x7 = (query === null)
            } else {
              var this$6 = $n(x$11);
              var $$x7 = (this$6 === query)
            };
            if ($$x7) {
              var $$x3 = true
            } else {
              var x$13 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
              if ((x$13 === null)) {
                var $$x3 = (query === null)
              } else {
                var this$7 = $n(x$13);
                var $$x3 = (this$7 === query)
              }
            }
          }
        }
      };
      if ($$x3) {
        return null
      } else {
        return $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)
      }
    }
  }
});
$c_Ljava_time_LocalTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return $n(temporal).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField(), this.toNanoOfDay__J())
});
$c_Ljava_time_LocalTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x2 = $as_Ljava_time_temporal_ChronoUnit(unit);
    var this$1 = $n(end).toNanoOfDay__J();
    var b = this.toNanoOfDay__J();
    var alo = this$1.RTLong__f_lo;
    var ahi = this$1.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    var lo = ((alo - b.RTLong__f_lo) | 0);
    var hi = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
    var x = $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$3 = $n(x);
      var $$x1 = (this$3 === x2)
    };
    if ($$x1) {
      return new $c_RTLong(lo, hi)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoUnit$().MICROS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$4 = $n(x$3);
        var $$x2 = (this$4 === x2)
      };
      if ($$x2) {
        var this$5 = $m_RTLong$();
        var lo$1 = this$5.divideImpl__I__I__I__I__I(lo, hi, 1000, 0);
        var hi$1 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return new $c_RTLong(lo$1, hi$1)
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoUnit$().MILLIS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === null)) {
          var $$x3 = (x2 === null)
        } else {
          var this$6 = $n(x$5);
          var $$x3 = (this$6 === x2)
        };
        if ($$x3) {
          var this$7 = $m_RTLong$();
          var lo$2 = this$7.divideImpl__I__I__I__I__I(lo, hi, 1000000, 0);
          var hi$2 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          return new $c_RTLong(lo$2, hi$2)
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === null)) {
            var $$x4 = (x2 === null)
          } else {
            var this$8 = $n(x$7);
            var $$x4 = (this$8 === x2)
          };
          if ($$x4) {
            var b$1 = $m_Ljava_time_LocalTime$().NANOS_PER_SECOND__J();
            var this$9 = $m_RTLong$();
            var lo$3 = this$9.divideImpl__I__I__I__I__I(lo, hi, b$1.RTLong__f_lo, b$1.RTLong__f_hi);
            var hi$3 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            return new $c_RTLong(lo$3, hi$3)
          } else {
            var x$9 = $m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === null)) {
              var $$x5 = (x2 === null)
            } else {
              var this$10 = $n(x$9);
              var $$x5 = (this$10 === x2)
            };
            if ($$x5) {
              var b$2 = $m_Ljava_time_LocalTime$().NANOS_PER_MINUTE__J();
              var this$11 = $m_RTLong$();
              var lo$4 = this$11.divideImpl__I__I__I__I__I(lo, hi, b$2.RTLong__f_lo, b$2.RTLong__f_hi);
              var hi$4 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              return new $c_RTLong(lo$4, hi$4)
            } else {
              var x$11 = $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === null)) {
                var $$x6 = (x2 === null)
              } else {
                var this$12 = $n(x$11);
                var $$x6 = (this$12 === x2)
              };
              if ($$x6) {
                var b$3 = $m_Ljava_time_LocalTime$().NANOS_PER_HOUR__J();
                var this$13 = $m_RTLong$();
                var lo$5 = this$13.divideImpl__I__I__I__I__I(lo, hi, b$3.RTLong__f_lo, b$3.RTLong__f_hi);
                var hi$5 = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                return new $c_RTLong(lo$5, hi$5)
              } else {
                var x$13 = $m_Ljava_time_temporal_ChronoUnit$().HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === null)) {
                  var $$x7 = (x2 === null)
                } else {
                  var this$14 = $n(x$13);
                  var $$x7 = (this$14 === x2)
                };
                if ($$x7) {
                  var b$4 = $m_Ljava_time_LocalTime$().NANOS_PER_HOUR__J();
                  var blo = b$4.RTLong__f_lo;
                  var b0 = (65535 & blo);
                  var b1 = ((blo >>> 16) | 0);
                  var a0b0 = Math.imul(12, b0);
                  var a0b1 = Math.imul(12, b1);
                  var lo$6 = ((a0b0 + (a0b1 << 16)) | 0);
                  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
                  var hi$6 = ((Math.imul(12, b$4.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
                  var this$15 = $m_RTLong$();
                  var lo$7 = this$15.divideImpl__I__I__I__I__I(lo, hi, lo$6, hi$6);
                  var hi$7 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  return new $c_RTLong(lo$7, hi$7)
                } else {
                  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                }
              }
            }
          }
        }
      }
    }
  } else {
    return $n(unit).between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end)
  }
});
$c_Ljava_time_LocalTime.prototype.toSecondOfDay__I = (function() {
  var total = Math.imul($p_Ljava_time_LocalTime__hour__B(this), $m_Ljava_time_LocalTime$().SECONDS_PER_HOUR__I());
  total = ((total + Math.imul($p_Ljava_time_LocalTime__minute__B(this), $m_Ljava_time_LocalTime$().SECONDS_PER_MINUTE__I())) | 0);
  total = ((total + $p_Ljava_time_LocalTime__second__B(this)) | 0);
  return total
});
$c_Ljava_time_LocalTime.prototype.toNanoOfDay__J = (function() {
  var value = $p_Ljava_time_LocalTime__hour__B(this);
  var hi = (value >> 31);
  var b = $m_Ljava_time_LocalTime$().NANOS_PER_HOUR__J();
  var blo = b.RTLong__f_lo;
  var a0 = (65535 & value);
  var a1 = ((value >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(value, b.RTLong__f_hi) + Math.imul(hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var total__lo = lo;
  var total__hi = hi$1;
  var this$3__lo = total__lo;
  var this$3__hi = total__hi;
  var value$1 = $p_Ljava_time_LocalTime__minute__B(this);
  var hi$2 = (value$1 >> 31);
  var b$1 = $m_Ljava_time_LocalTime$().NANOS_PER_MINUTE__J();
  var blo$1 = b$1.RTLong__f_lo;
  var a0$1 = (65535 & value$1);
  var a1$1 = ((value$1 >>> 16) | 0);
  var b0$1 = (65535 & blo$1);
  var b1$1 = ((blo$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(a0$1, b0$1);
  var a1b0$1 = Math.imul(a1$1, b0$1);
  var a0b1$1 = Math.imul(a0$1, b1$1);
  var lo$1 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((((((Math.imul(value$1, b$1.RTLong__f_hi) + Math.imul(hi$2, blo$1)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var alo = this$3__lo;
  var ahi = this$3__hi;
  var lo$2 = ((alo + lo$1) | 0);
  var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$3) | 0)) | 0) : ((ahi + hi$3) | 0));
  var $$x1__lo = lo$2;
  var $$x1__hi = hi$4;
  total__lo = $$x1__lo;
  total__hi = $$x1__hi;
  var this$6__lo = total__lo;
  var this$6__hi = total__hi;
  var value$2 = $p_Ljava_time_LocalTime__second__B(this);
  var hi$5 = (value$2 >> 31);
  var b$2 = $m_Ljava_time_LocalTime$().NANOS_PER_SECOND__J();
  var blo$2 = b$2.RTLong__f_lo;
  var a0$2 = (65535 & value$2);
  var a1$2 = ((value$2 >>> 16) | 0);
  var b0$2 = (65535 & blo$2);
  var b1$2 = ((blo$2 >>> 16) | 0);
  var a0b0$2 = Math.imul(a0$2, b0$2);
  var a1b0$2 = Math.imul(a1$2, b0$2);
  var a0b1$2 = Math.imul(a0$2, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$6 = ((((((((Math.imul(value$2, b$2.RTLong__f_hi) + Math.imul(hi$5, blo$2)) | 0) + Math.imul(a1$2, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var alo$1 = this$6__lo;
  var ahi$1 = this$6__hi;
  var lo$4 = ((alo$1 + lo$3) | 0);
  var hi$7 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$1 + hi$6) | 0)) | 0) : ((ahi$1 + hi$6) | 0));
  var $$x2__lo = lo$4;
  var $$x2__hi = hi$7;
  total__lo = $$x2__lo;
  total__hi = $$x2__hi;
  var this$9__lo = total__lo;
  var this$9__hi = total__hi;
  var value$3 = this.Ljava_time_LocalTime__f_nano;
  var hi$8 = (value$3 >> 31);
  var alo$2 = this$9__lo;
  var ahi$2 = this$9__hi;
  var lo$5 = ((alo$2 + value$3) | 0);
  var hi$9 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ alo$2)) ? ((1 + ((ahi$2 + hi$8) | 0)) | 0) : ((ahi$2 + hi$8) | 0));
  var $$x3__lo = lo$5;
  var $$x3__hi = hi$9;
  total__lo = $$x3__lo;
  total__hi = $$x3__hi;
  return new $c_RTLong(total__lo, total__hi)
});
$c_Ljava_time_LocalTime.prototype.compare__Ljava_time_LocalTime__I = (function(other) {
  var x = $p_Ljava_time_LocalTime__hour__B(this);
  var y = $p_Ljava_time_LocalTime__hour__B($n(other));
  var cmp = ((x === y) ? 0 : ((x < y) ? (-1) : 1));
  if ((cmp === 0)) {
    var x$1 = $p_Ljava_time_LocalTime__minute__B(this);
    var y$1 = $p_Ljava_time_LocalTime__minute__B($n(other));
    cmp = ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
    if ((cmp === 0)) {
      var x$2 = $p_Ljava_time_LocalTime__second__B(this);
      var y$2 = $p_Ljava_time_LocalTime__second__B($n(other));
      cmp = ((x$2 === y$2) ? 0 : ((x$2 < y$2) ? (-1) : 1));
      if ((cmp === 0)) {
        var x$3 = this.Ljava_time_LocalTime__f_nano;
        var y$3 = $n(other).Ljava_time_LocalTime__f_nano;
        cmp = ((x$3 === y$3) ? 0 : ((x$3 < y$3) ? (-1) : 1))
      }
    }
  };
  return cmp
});
$c_Ljava_time_LocalTime.prototype.isAfter__Ljava_time_LocalTime__Z = (function(other) {
  return (this.compare__Ljava_time_LocalTime__I(other) > 0)
});
$c_Ljava_time_LocalTime.prototype.isBefore__Ljava_time_LocalTime__Z = (function(other) {
  return (this.compare__Ljava_time_LocalTime__I(other) < 0)
});
$c_Ljava_time_LocalTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalTime)) {
    var x2 = $as_Ljava_time_LocalTime(obj);
    return ((this === x2) || (((($p_Ljava_time_LocalTime__hour__B(this) === $p_Ljava_time_LocalTime__hour__B($n(x2))) && ($p_Ljava_time_LocalTime__minute__B(this) === $p_Ljava_time_LocalTime__minute__B($n(x2)))) && ($p_Ljava_time_LocalTime__second__B(this) === $p_Ljava_time_LocalTime__second__B($n(x2)))) && (this.Ljava_time_LocalTime__f_nano === $n(x2).Ljava_time_LocalTime__f_nano)))
  } else {
    return false
  }
});
$c_Ljava_time_LocalTime.prototype.hashCode__I = (function() {
  var t = this.toNanoOfDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var lo$1 = (lo ^ hi);
  return lo$1
});
$c_Ljava_time_LocalTime.prototype.toString__T = (function() {
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 18);
  var hourValue = $p_Ljava_time_LocalTime__hour__B(this);
  var minuteValue = $p_Ljava_time_LocalTime__minute__B(this);
  var secondValue = $p_Ljava_time_LocalTime__second__B(this);
  var nanoValue = this.Ljava_time_LocalTime__f_nano;
  $n($n($n(buf.append__T__scm_StringBuilder(((hourValue < 10) ? "0" : ""))).append__I__scm_StringBuilder(hourValue)).append__T__scm_StringBuilder(((minuteValue < 10) ? ":0" : ":"))).append__I__scm_StringBuilder(minuteValue);
  if (((secondValue > 0) || (nanoValue > 0))) {
    $n(buf.append__T__scm_StringBuilder(((secondValue < 10) ? ":0" : ":"))).append__I__scm_StringBuilder(secondValue);
    if ((nanoValue > 0)) {
      buf.append__C__scm_StringBuilder(46);
      if ((((nanoValue % 1000000) | 0) === 0)) {
        var i = ((1000 + ((nanoValue / 1000000) | 0)) | 0);
        var this$2 = ("" + i);
        if ((this$2.length < 1)) {
          $charAt(this$2, 1)
        };
        buf.append__T__scm_StringBuilder($as_T(this$2.substring(1)))
      } else if ((((nanoValue % 1000) | 0) === 0)) {
        var i$1 = ((1000000 + ((nanoValue / 1000) | 0)) | 0);
        var this$4 = ("" + i$1);
        if ((this$4.length < 1)) {
          $charAt(this$4, 1)
        };
        buf.append__T__scm_StringBuilder($as_T(this$4.substring(1)))
      } else {
        var i$2 = ((1000000000 + nanoValue) | 0);
        var this$6 = ("" + i$2);
        if ((this$6.length < 1)) {
          $charAt(this$6, 1)
        };
        buf.append__T__scm_StringBuilder($as_T(this$6.substring(1)))
      }
    }
  };
  return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_LocalTime.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_LocalTime(that);
  return this.compare__Ljava_time_LocalTime__I(other)
});
$c_Ljava_time_LocalTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(amountToSubtract, unit)
});
$c_Ljava_time_LocalTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(amountToAdd, unit)
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(field, newValue)
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalTime(adjuster)
});
function $as_Ljava_time_LocalTime(obj) {
  return (((obj instanceof $c_Ljava_time_LocalTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.LocalTime"))
}
function $isArrayOf_Ljava_time_LocalTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalTime)))
}
function $asArrayOf_Ljava_time_LocalTime(obj, depth) {
  return (($isArrayOf_Ljava_time_LocalTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.LocalTime;", depth))
}
var $d_Ljava_time_LocalTime = new $TypeData().initClass({
  Ljava_time_LocalTime: 0
}, false, "java.time.LocalTime", {
  Ljava_time_LocalTime: 1,
  O: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_LocalTime.prototype.$classData = $d_Ljava_time_LocalTime;
function $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime($thiz, dateTime, offset) {
  if (($thiz.Ljava_time_OffsetDateTime__f_dateTime === dateTime)) {
    var x = $thiz.Ljava_time_OffsetDateTime__f_offset;
    var $$x1 = ((x === null) ? (offset === null) : $n(x).equals__O__Z(offset))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $thiz
  } else {
    return new $c_Ljava_time_OffsetDateTime(dateTime, offset)
  }
}
/** @constructor */
function $c_Ljava_time_OffsetDateTime(dateTime, offset) {
  this.Ljava_time_OffsetDateTime__f_dateTime = null;
  this.Ljava_time_OffsetDateTime__f_offset = null;
  this.Ljava_time_OffsetDateTime__f_dateTime = dateTime;
  this.Ljava_time_OffsetDateTime__f_offset = offset;
  if ((dateTime === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "dateTime")
  };
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset")
  }
}
$c_Ljava_time_OffsetDateTime.prototype = new $h_O();
$c_Ljava_time_OffsetDateTime.prototype.constructor = $c_Ljava_time_OffsetDateTime;
/** @constructor */
function $h_Ljava_time_OffsetDateTime() {
  /*<skip>*/
}
$h_Ljava_time_OffsetDateTime.prototype = $c_Ljava_time_OffsetDateTime.prototype;
$c_Ljava_time_OffsetDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) || ((field !== null) && $n(field).isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)))
});
$c_Ljava_time_OffsetDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (((field === $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) ? $n(field).range__Ljava_time_temporal_ValueRange() : $n(this.Ljava_time_OffsetDateTime__f_dateTime).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)) : $n(field).rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this))
});
$c_Ljava_time_OffsetDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var x = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x2)
      };
      if ($$x2) {
        var this$3 = $n(this.Ljava_time_OffsetDateTime__f_offset);
        return this$3.Ljava_time_ZoneOffset__f_totalSeconds
      } else {
        return $n(this.Ljava_time_OffsetDateTime__f_dateTime).get__Ljava_time_temporal_TemporalField__I(field)
      }
    }
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
  }
});
$c_Ljava_time_OffsetDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var x = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      return $n(this.Ljava_time_OffsetDateTime__f_dateTime).toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_OffsetDateTime__f_offset)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x2)
      };
      if ($$x2) {
        var this$3 = $n(this.Ljava_time_OffsetDateTime__f_offset);
        var value = this$3.Ljava_time_ZoneOffset__f_totalSeconds;
        var hi = (value >> 31);
        return new $c_RTLong(value, hi)
      } else {
        return $n(this.Ljava_time_OffsetDateTime__f_dateTime).getLong__Ljava_time_temporal_TemporalField__J(field)
      }
    }
  } else {
    return $n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this)
  }
});
$c_Ljava_time_OffsetDateTime.prototype.withOffsetSameInstant__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime = (function(offset) {
  var x$2 = this.Ljava_time_OffsetDateTime__f_offset;
  if (((offset === null) ? (x$2 === null) : $n(offset).equals__O__Z(x$2))) {
    return this
  };
  var this$1 = $n(offset);
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $n(this.Ljava_time_OffsetDateTime__f_offset);
  var difference = (($$x1 - this$2.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
  var this$4 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
  var hi = (difference >> 31);
  var adjusted = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$4, this$4.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(difference, hi), $L0, 1);
  return new $c_Ljava_time_OffsetDateTime(adjusted, offset)
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_OffsetDateTime = (function(adjuster) {
  if (((adjuster instanceof $c_Ljava_time_LocalDate) || ((adjuster instanceof $c_Ljava_time_LocalTime) || (adjuster instanceof $c_Ljava_time_LocalDateTime)))) {
    return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, $n(this.Ljava_time_OffsetDateTime__f_dateTime).with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDateTime(adjuster), this.Ljava_time_OffsetDateTime__f_offset)
  } else if ((adjuster instanceof $c_Ljava_time_Instant)) {
    var x5 = $as_Ljava_time_Instant(adjuster);
    return $m_Ljava_time_OffsetDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime(x5, this.Ljava_time_OffsetDateTime__f_offset)
  } else if ((adjuster instanceof $c_Ljava_time_ZoneOffset)) {
    var x6 = $as_Ljava_time_ZoneOffset(adjuster);
    return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, this.Ljava_time_OffsetDateTime__f_dateTime, x6)
  } else if ((adjuster instanceof $c_Ljava_time_OffsetDateTime)) {
    var x7 = $as_Ljava_time_OffsetDateTime(adjuster);
    return x7
  } else {
    return $as_Ljava_time_OffsetDateTime($n(adjuster).adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this))
  }
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var x = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      var $$x3 = $m_Ljava_time_OffsetDateTime$();
      var $$x2 = $m_Ljava_time_Instant$();
      var this$2 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
      var this$3 = $n(this$2.Ljava_time_LocalDateTime__f_time);
      var value = this$3.Ljava_time_LocalTime__f_nano;
      var hi = (value >> 31);
      return $n($$x3).ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime($n($$x2).ofEpochSecond__J__J__Ljava_time_Instant(newValue, new $c_RTLong(value, hi)), this.Ljava_time_OffsetDateTime__f_offset)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x4 = (x2 === null)
      } else {
        var this$5 = $n(x$3);
        var $$x4 = (this$5 === x2)
      };
      if ($$x4) {
        var $$x6 = this.Ljava_time_OffsetDateTime__f_dateTime;
        var $$x5 = $m_Ljava_time_ZoneOffset$();
        var this$6 = $n(x2);
        return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, $$x6, $n($$x5).ofTotalSeconds__I__Ljava_time_ZoneOffset($n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, this$6)))
      } else {
        return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, $n(this.Ljava_time_OffsetDateTime__f_dateTime).with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue), this.Ljava_time_OffsetDateTime__f_offset)
      }
    }
  } else {
    return $as_Ljava_time_OffsetDateTime($n(field).adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue))
  }
});
$c_Ljava_time_OffsetDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime = (function(amountToAdd, unit) {
  return ((unit instanceof $c_Ljava_time_temporal_ChronoUnit) ? $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, $n(this.Ljava_time_OffsetDateTime__f_dateTime).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit), this.Ljava_time_OffsetDateTime__f_offset) : $as_Ljava_time_OffsetDateTime($n(unit).addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd)))
});
$c_Ljava_time_OffsetDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return $n(this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(new $c_RTLong((-1), 2147483647), unit)).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_OffsetDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $$x1 = (query === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = (this$1 === query)
  };
  if ($$x1) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()
  } else {
    var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
    if ((x$3 === null)) {
      var $$x2 = (query === null)
    } else {
      var this$2 = $n(x$3);
      var $$x2 = (this$2 === query)
    };
    if ($$x2) {
      return $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit()
    } else {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === null)) {
        var $$x4 = (query === null)
      } else {
        var this$3 = $n(x$5);
        var $$x4 = (this$3 === query)
      };
      if ($$x4) {
        var $$x3 = true
      } else {
        var x$7 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
        if ((x$7 === null)) {
          var $$x3 = (query === null)
        } else {
          var this$4 = $n(x$7);
          var $$x3 = (this$4 === query)
        }
      };
      if ($$x3) {
        return this.Ljava_time_OffsetDateTime__f_offset
      } else {
        var x$9 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
        if ((x$9 === null)) {
          var $$x5 = (query === null)
        } else {
          var this$5 = $n(x$9);
          var $$x5 = (this$5 === query)
        };
        if ($$x5) {
          var this$6 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
          return this$6.Ljava_time_LocalDateTime__f_date
        } else {
          var x$11 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
          if ((x$11 === null)) {
            var $$x6 = (query === null)
          } else {
            var this$7 = $n(x$11);
            var $$x6 = (this$7 === query)
          };
          if ($$x6) {
            var this$8 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
            return this$8.Ljava_time_LocalDateTime__f_time
          } else {
            var x$13 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
            if ((x$13 === null)) {
              var $$x7 = (query === null)
            } else {
              var this$9 = $n(x$13);
              var $$x7 = (this$9 === query)
            };
            if ($$x7) {
              return null
            } else {
              return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query)
            }
          }
        }
      }
    }
  }
});
$c_Ljava_time_OffsetDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $$x6 = $n(temporal);
  var $$x5 = $m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField();
  var this$1 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
  var $$x4 = $n($$x6).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x5, $n(this$1.Ljava_time_LocalDateTime__f_date).toEpochDay__J());
  var $$x3 = $m_Ljava_time_temporal_ChronoField$().NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  var this$2 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
  var $$x2 = $n($n($$x4).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x3, $n(this$2.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J()));
  var $$x1 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  var this$3 = $n(this.Ljava_time_OffsetDateTime__f_offset);
  var value = this$3.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  return $n($$x2).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(value, hi))
});
$c_Ljava_time_OffsetDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_OffsetDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_OffsetDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    end = $n(end).withOffsetSameInstant__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this.Ljava_time_OffsetDateTime__f_offset);
    return $n(this.Ljava_time_OffsetDateTime__f_dateTime).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J($n(end).Ljava_time_OffsetDateTime__f_dateTime, unit)
  } else {
    return $n(unit).between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end)
  }
});
$c_Ljava_time_OffsetDateTime.prototype.compare__Ljava_time_OffsetDateTime__I = (function(other) {
  var x = this.Ljava_time_OffsetDateTime__f_offset;
  var this$1 = $n(other);
  var x$2 = this$1.Ljava_time_OffsetDateTime__f_offset;
  if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
    var $$x1 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
    var this$2 = $n(other);
    return $n($$x1).compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(this$2.Ljava_time_OffsetDateTime__f_dateTime)
  };
  var t = $n(this.Ljava_time_OffsetDateTime__f_dateTime).toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_OffsetDateTime__f_offset);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$3 = $n(other);
  var t$1 = $n(this$3.Ljava_time_OffsetDateTime__f_dateTime).toEpochSecond__Ljava_time_ZoneOffset__J(this$3.Ljava_time_OffsetDateTime__f_offset);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  if ((cmp === 0)) {
    var this$4 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
    var this$5 = $n(this$4.Ljava_time_LocalDateTime__f_time);
    var $$x2 = this$5.Ljava_time_LocalTime__f_nano;
    var this$6 = $n(other);
    var this$7 = $n(this$6.Ljava_time_OffsetDateTime__f_dateTime);
    var this$8 = $n(this$7.Ljava_time_LocalDateTime__f_time);
    cmp = (($$x2 - this$8.Ljava_time_LocalTime__f_nano) | 0);
    if ((cmp === 0)) {
      var $$x3 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
      var this$9 = $n(other);
      cmp = $n($$x3).compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(this$9.Ljava_time_OffsetDateTime__f_dateTime)
    }
  };
  return cmp
});
$c_Ljava_time_OffsetDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_OffsetDateTime)) {
    var x2 = $as_Ljava_time_OffsetDateTime(obj);
    if ((this === x2)) {
      return true
    } else {
      var x = this.Ljava_time_OffsetDateTime__f_dateTime;
      var x$2 = $n(x2).Ljava_time_OffsetDateTime__f_dateTime;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_OffsetDateTime__f_offset;
        var x$4 = $n(x2).Ljava_time_OffsetDateTime__f_offset;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_OffsetDateTime.prototype.hashCode__I = (function() {
  var $$x1 = $n(this.Ljava_time_OffsetDateTime__f_dateTime).hashCode__I();
  var this$1 = $n(this.Ljava_time_OffsetDateTime__f_offset);
  return ($$x1 ^ this$1.Ljava_time_ZoneOffset__f_totalSeconds)
});
$c_Ljava_time_OffsetDateTime.prototype.toString__T = (function() {
  var $$x1 = $n(this.Ljava_time_OffsetDateTime__f_dateTime).toString__T();
  var this$1 = $n(this.Ljava_time_OffsetDateTime__f_offset);
  return (("" + $$x1) + $p_Ljava_time_ZoneOffset__id__T(this$1))
});
$c_Ljava_time_OffsetDateTime.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_OffsetDateTime(that);
  return this.compare__Ljava_time_OffsetDateTime__I(other)
});
$c_Ljava_time_OffsetDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(amountToSubtract, unit)
});
$c_Ljava_time_OffsetDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(amountToAdd, unit)
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime(field, newValue)
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_OffsetDateTime(adjuster)
});
function $as_Ljava_time_OffsetDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_OffsetDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.OffsetDateTime"))
}
function $isArrayOf_Ljava_time_OffsetDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_OffsetDateTime)))
}
function $asArrayOf_Ljava_time_OffsetDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_OffsetDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.OffsetDateTime;", depth))
}
var $d_Ljava_time_OffsetDateTime = new $TypeData().initClass({
  Ljava_time_OffsetDateTime: 0
}, false, "java.time.OffsetDateTime", {
  Ljava_time_OffsetDateTime: 1,
  O: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_OffsetDateTime.prototype.$classData = $d_Ljava_time_OffsetDateTime;
function $p_Ljava_time_ZoneOffset__id__T($thiz) {
  if ((!$thiz.Ljava_time_ZoneOffset__f_bitmap$inittrans$0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/ZoneOffset.scala: 386")
  };
  return $thiz.Ljava_time_ZoneOffset__f_id
}
/** @constructor */
function $c_Ljava_time_ZoneOffset(totalSeconds) {
  this.Ljava_time_ZoneOffset__f_totalSeconds = 0;
  this.Ljava_time_ZoneOffset__f_id = null;
  this.Ljava_time_ZoneOffset__f_bitmap$inittrans$0 = false;
  this.Ljava_time_ZoneOffset__f_totalSeconds = totalSeconds;
  $ct_Ljava_time_ZoneId__(this);
  this.Ljava_time_ZoneOffset__f_id = $m_Ljava_time_ZoneOffset$().java$time$ZoneOffset$$buildId__I__T(totalSeconds);
  this.Ljava_time_ZoneOffset__f_bitmap$inittrans$0 = true
}
$c_Ljava_time_ZoneOffset.prototype = new $h_Ljava_time_ZoneId();
$c_Ljava_time_ZoneOffset.prototype.constructor = $c_Ljava_time_ZoneOffset;
/** @constructor */
function $h_Ljava_time_ZoneOffset() {
  /*<skip>*/
}
$h_Ljava_time_ZoneOffset.prototype = $c_Ljava_time_ZoneOffset.prototype;
$c_Ljava_time_ZoneOffset.prototype.getId__T = (function() {
  return $p_Ljava_time_ZoneOffset__id__T(this)
});
$c_Ljava_time_ZoneOffset.prototype.getRules__Ljava_time_zone_ZoneRules = (function() {
  return $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this)
});
$c_Ljava_time_ZoneOffset.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field === $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField()) : ((field !== null) && $n(field).isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)))
});
$c_Ljava_time_ZoneOffset.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    return $n(field).range__Ljava_time_temporal_ValueRange()
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return $n(field).rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this)
  }
});
$c_Ljava_time_ZoneOffset.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field === $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    return this.Ljava_time_ZoneOffset__f_totalSeconds
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
  } else {
    return $n(this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field)
  }
});
$c_Ljava_time_ZoneOffset.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    var value = this.Ljava_time_ZoneOffset__f_totalSeconds;
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unsupported field: " + field))
  } else {
    return $n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this)
  }
});
$c_Ljava_time_ZoneOffset.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return (((query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) ? this : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) ? null : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)))
});
$c_Ljava_time_ZoneOffset.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $$x2 = $n(temporal);
  var $$x1 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  var value = this.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  return $n($$x2).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($$x1, new $c_RTLong(value, hi))
});
$c_Ljava_time_ZoneOffset.prototype.compare__Ljava_time_ZoneOffset__I = (function(other) {
  return (($n(other).Ljava_time_ZoneOffset__f_totalSeconds - this.Ljava_time_ZoneOffset__f_totalSeconds) | 0)
});
$c_Ljava_time_ZoneOffset.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZoneOffset)) {
    var x2 = $as_Ljava_time_ZoneOffset(obj);
    return ((this === x2) || (this.Ljava_time_ZoneOffset__f_totalSeconds === $n(x2).Ljava_time_ZoneOffset__f_totalSeconds))
  } else {
    return false
  }
});
$c_Ljava_time_ZoneOffset.prototype.hashCode__I = (function() {
  return this.Ljava_time_ZoneOffset__f_totalSeconds
});
$c_Ljava_time_ZoneOffset.prototype.toString__T = (function() {
  return $p_Ljava_time_ZoneOffset__id__T(this)
});
$c_Ljava_time_ZoneOffset.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_ZoneOffset(that);
  return this.compare__Ljava_time_ZoneOffset__I(other)
});
function $as_Ljava_time_ZoneOffset(obj) {
  return (((obj instanceof $c_Ljava_time_ZoneOffset) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.ZoneOffset"))
}
function $isArrayOf_Ljava_time_ZoneOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZoneOffset)))
}
function $asArrayOf_Ljava_time_ZoneOffset(obj, depth) {
  return (($isArrayOf_Ljava_time_ZoneOffset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.ZoneOffset;", depth))
}
var $d_Ljava_time_ZoneOffset = new $TypeData().initClass({
  Ljava_time_ZoneOffset: 0
}, false, "java.time.ZoneOffset", {
  Ljava_time_ZoneOffset: 1,
  Ljava_time_ZoneId: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_Ljava_time_ZoneOffset.prototype.$classData = $d_Ljava_time_ZoneOffset;
function $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime($thiz, offset) {
  var x$2 = $thiz.Ljava_time_ZonedDateTime__f_offset;
  if (((!((offset === null) ? (x$2 === null) : $n(offset).equals__O__Z(x$2))) && $n($n($thiz.Ljava_time_ZonedDateTime__f_zone).getRules__Ljava_time_zone_ZoneRules()).isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z($thiz.Ljava_time_ZonedDateTime__f_dateTime, offset))) {
    return new $c_Ljava_time_ZonedDateTime($thiz.Ljava_time_ZonedDateTime__f_dateTime, offset, $thiz.Ljava_time_ZonedDateTime__f_zone)
  } else {
    return $thiz
  }
}
/** @constructor */
function $c_Ljava_time_ZonedDateTime(dateTime, offset, zone) {
  this.Ljava_time_ZonedDateTime__f_dateTime = null;
  this.Ljava_time_ZonedDateTime__f_offset = null;
  this.Ljava_time_ZonedDateTime__f_zone = null;
  this.Ljava_time_ZonedDateTime__f_dateTime = dateTime;
  this.Ljava_time_ZonedDateTime__f_offset = offset;
  this.Ljava_time_ZonedDateTime__f_zone = zone
}
$c_Ljava_time_ZonedDateTime.prototype = new $h_O();
$c_Ljava_time_ZonedDateTime.prototype.constructor = $c_Ljava_time_ZonedDateTime;
/** @constructor */
function $h_Ljava_time_ZonedDateTime() {
  /*<skip>*/
}
$h_Ljava_time_ZonedDateTime.prototype = $c_Ljava_time_ZonedDateTime.prototype;
$c_Ljava_time_ZonedDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) || ((field !== null) && $n(field).isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)))
});
$c_Ljava_time_ZonedDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (((field === $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) ? $n(field).range__Ljava_time_temporal_ValueRange() : $n(this.Ljava_time_ZonedDateTime__f_dateTime).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)) : $n(field).rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this))
});
$c_Ljava_time_ZonedDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var x = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x2)
      };
      if ($$x2) {
        var this$3 = $n(this.Ljava_time_ZonedDateTime__f_offset);
        return this$3.Ljava_time_ZoneOffset__f_totalSeconds
      } else {
        return $n(this.Ljava_time_ZonedDateTime__f_dateTime).get__Ljava_time_temporal_TemporalField__I(field)
      }
    }
  } else {
    return $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I(this, field)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var x = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      return $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(this)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x2)
      };
      if ($$x2) {
        var this$3 = $n(this.Ljava_time_ZonedDateTime__f_offset);
        var value = this$3.Ljava_time_ZoneOffset__f_totalSeconds;
        var hi = (value >> 31);
        return new $c_RTLong(value, hi)
      } else {
        return $n(this.Ljava_time_ZonedDateTime__f_dateTime).getLong__Ljava_time_temporal_TemporalField__J(field)
      }
    }
  } else {
    return $n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.withZoneSameInstant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(zone) {
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone")
  };
  var x = this.Ljava_time_ZonedDateTime__f_zone;
  if (((x === null) ? (zone === null) : $n(x).equals__O__Z(zone))) {
    return this
  } else {
    var $$x2 = $m_Ljava_time_ZonedDateTime$();
    var $$x1 = $n(this.Ljava_time_ZonedDateTime__f_dateTime).toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_ZonedDateTime__f_offset);
    var this$2 = $n(this.Ljava_time_ZonedDateTime__f_dateTime);
    var this$3 = $n(this$2.Ljava_time_LocalDateTime__f_time);
    return $n($$x2).java$time$ZonedDateTime$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($$x1, this$3.Ljava_time_LocalTime__f_nano, zone)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_ZonedDateTime = (function(adjuster) {
  if ((adjuster instanceof $c_Ljava_time_LocalDate)) {
    var x2 = $as_Ljava_time_LocalDate(adjuster);
    var $$x1 = $m_Ljava_time_LocalDateTime$();
    var this$1 = $n(this.Ljava_time_ZonedDateTime__f_dateTime);
    var newDateTime = $n($$x1).of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(x2, this$1.Ljava_time_LocalDateTime__f_time);
    return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset)
  } else if ((adjuster instanceof $c_Ljava_time_LocalTime)) {
    var x3 = $as_Ljava_time_LocalTime(adjuster);
    var $$x2 = $m_Ljava_time_LocalDateTime$();
    var this$2 = $n(this.Ljava_time_ZonedDateTime__f_dateTime);
    var newDateTime$1 = $n($$x2).of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$2.Ljava_time_LocalDateTime__f_date, x3);
    return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime$1, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset)
  } else if ((adjuster instanceof $c_Ljava_time_LocalDateTime)) {
    var x4 = $as_Ljava_time_LocalDateTime(adjuster);
    return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(x4, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset)
  } else if ((adjuster instanceof $c_Ljava_time_Instant)) {
    var x5 = $as_Ljava_time_Instant(adjuster);
    var $$x4 = $m_Ljava_time_ZonedDateTime$();
    var this$3 = $n(x5);
    var $$x3 = this$3.Ljava_time_Instant__f_seconds;
    var this$4 = $n(x5);
    return $n($$x4).java$time$ZonedDateTime$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($$x3, this$4.Ljava_time_Instant__f_nanos, this.Ljava_time_ZonedDateTime__f_zone)
  } else if ((adjuster instanceof $c_Ljava_time_ZoneOffset)) {
    var x6 = $as_Ljava_time_ZoneOffset(adjuster);
    return $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this, x6)
  } else {
    return $as_Ljava_time_ZonedDateTime($n(adjuster).adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this))
  }
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x2 = $as_Ljava_time_temporal_ChronoField(field);
    var x = $m_Ljava_time_temporal_ChronoField$().INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      var $$x2 = $m_Ljava_time_ZonedDateTime$();
      var this$2 = $n(this.Ljava_time_ZonedDateTime__f_dateTime);
      var this$3 = $n(this$2.Ljava_time_LocalDateTime__f_time);
      return $n($$x2).java$time$ZonedDateTime$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(newValue, this$3.Ljava_time_LocalTime__f_nano, this.Ljava_time_ZonedDateTime__f_zone)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x3 = (x2 === null)
      } else {
        var this$4 = $n(x$3);
        var $$x3 = (this$4 === x2)
      };
      if ($$x3) {
        var $$x4 = $m_Ljava_time_ZoneOffset$();
        var this$5 = $n(x2);
        return $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this, $n($$x4).ofTotalSeconds__I__Ljava_time_ZoneOffset($n(this$5.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, this$5)))
      } else {
        var newDateTime = $n(this.Ljava_time_ZonedDateTime__f_dateTime).with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue);
        return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset)
      }
    }
  } else {
    return $as_Ljava_time_ZonedDateTime($n(field).adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue))
  }
});
$c_Ljava_time_ZonedDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    if ($n(unit).isDateBased__Z()) {
      var newDateTime = $n(this.Ljava_time_ZonedDateTime__f_dateTime).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit);
      return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset)
    } else {
      var newDateTime$1 = $n(this.Ljava_time_ZonedDateTime__f_dateTime).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit);
      return $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(newDateTime$1, this.Ljava_time_ZonedDateTime__f_offset, this.Ljava_time_ZonedDateTime__f_zone)
    }
  } else {
    return $as_Ljava_time_ZonedDateTime($n(unit).addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd))
  }
});
$c_Ljava_time_ZonedDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return $n(this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(new $c_RTLong((-1), 2147483647), unit)).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  if ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery())) {
    var this$1 = $n(this.Ljava_time_ZonedDateTime__f_dateTime);
    return this$1.Ljava_time_LocalDateTime__f_date
  } else {
    return $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O(this, query)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_ZonedDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZonedDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    end = $n(end).withZoneSameInstant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(this.Ljava_time_ZonedDateTime__f_zone);
    if ($n(unit).isDateBased__Z()) {
      return $n(this.Ljava_time_ZonedDateTime__f_dateTime).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J($n(end).Ljava_time_ZonedDateTime__f_dateTime, unit)
    } else {
      var dateTime = this.Ljava_time_ZonedDateTime__f_dateTime;
      var offset = this.Ljava_time_ZonedDateTime__f_offset;
      var $$x1 = new $c_Ljava_time_OffsetDateTime(dateTime, offset);
      var this$2 = $n(end);
      var dateTime$1 = this$2.Ljava_time_ZonedDateTime__f_dateTime;
      var offset$1 = this$2.Ljava_time_ZonedDateTime__f_offset;
      return $$x1.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(new $c_Ljava_time_OffsetDateTime(dateTime$1, offset$1), unit)
    }
  } else {
    return $n(unit).between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end)
  }
});
$c_Ljava_time_ZonedDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZonedDateTime)) {
    var x2 = $as_Ljava_time_ZonedDateTime(obj);
    if ((this === x2)) {
      return true
    } else {
      var x = this.Ljava_time_ZonedDateTime__f_dateTime;
      var x$2 = $n(x2).Ljava_time_ZonedDateTime__f_dateTime;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_ZonedDateTime__f_offset;
        var x$4 = $n(x2).Ljava_time_ZonedDateTime__f_offset;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var x$5 = this.Ljava_time_ZonedDateTime__f_zone;
        var x$6 = $n(x2).Ljava_time_ZonedDateTime__f_zone;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_ZonedDateTime.prototype.hashCode__I = (function() {
  var $$x2 = $n(this.Ljava_time_ZonedDateTime__f_dateTime).hashCode__I();
  var this$1 = $n(this.Ljava_time_ZonedDateTime__f_offset);
  var $$x1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var i = $n(this.Ljava_time_ZonedDateTime__f_zone).hashCode__I();
  return (($$x2 ^ $$x1) ^ ((i << 3) | ((i >>> 29) | 0)))
});
$c_Ljava_time_ZonedDateTime.prototype.toString__T = (function() {
  var $$x1 = $n(this.Ljava_time_ZonedDateTime__f_dateTime).toString__T();
  var this$1 = $n(this.Ljava_time_ZonedDateTime__f_offset);
  var str = (("" + $$x1) + $p_Ljava_time_ZoneOffset__id__T(this$1));
  if ((this.Ljava_time_ZonedDateTime__f_offset !== this.Ljava_time_ZonedDateTime__f_zone)) {
    str = ((str + ("[" + $n(this.Ljava_time_ZonedDateTime__f_zone).toString__T())) + "]")
  };
  return str
});
$c_Ljava_time_ZonedDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(amountToSubtract, unit)
});
$c_Ljava_time_ZonedDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(amountToAdd, unit)
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime(field, newValue)
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_ZonedDateTime(adjuster)
});
$c_Ljava_time_ZonedDateTime.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_chrono_ChronoZonedDateTime(that);
  return $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I(this, other)
});
function $as_Ljava_time_ZonedDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_ZonedDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.ZonedDateTime"))
}
function $isArrayOf_Ljava_time_ZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZonedDateTime)))
}
function $asArrayOf_Ljava_time_ZonedDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_ZonedDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.ZonedDateTime;", depth))
}
var $d_Ljava_time_ZonedDateTime = new $TypeData().initClass({
  Ljava_time_ZonedDateTime: 0
}, false, "java.time.ZonedDateTime", {
  Ljava_time_ZonedDateTime: 1,
  O: 1,
  Ljava_time_chrono_ChronoZonedDateTime: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_ZonedDateTime.prototype.$classData = $d_Ljava_time_ZonedDateTime;
/** @constructor */
function $c_ju_Arrays$$anon$1(a$1) {
  this.ju_Arrays$$anon$1__f_a$1 = null;
  this.ju_Arrays$$anon$1__f_a$1 = a$1
}
$c_ju_Arrays$$anon$1.prototype = new $h_ju_AbstractList();
$c_ju_Arrays$$anon$1.prototype.constructor = $c_ju_Arrays$$anon$1;
/** @constructor */
function $h_ju_Arrays$$anon$1() {
  /*<skip>*/
}
$h_ju_Arrays$$anon$1.prototype = $c_ju_Arrays$$anon$1.prototype;
$c_ju_Arrays$$anon$1.prototype.size__I = (function() {
  return $n(this.ju_Arrays$$anon$1__f_a$1).u.length
});
$c_ju_Arrays$$anon$1.prototype.get__I__O = (function(index) {
  return $n(this.ju_Arrays$$anon$1__f_a$1).get(index)
});
$c_ju_Arrays$$anon$1.prototype.set__I__O__O = (function(index, element) {
  var ret = $n(this.ju_Arrays$$anon$1__f_a$1).get(index);
  $n(this.ju_Arrays$$anon$1__f_a$1).set(index, element);
  return ret
});
var $d_ju_Arrays$$anon$1 = new $TypeData().initClass({
  ju_Arrays$$anon$1: 0
}, false, "java.util.Arrays$$anon$1", {
  ju_Arrays$$anon$1: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_RandomAccess: 1
});
$c_ju_Arrays$$anon$1.prototype.$classData = $d_ju_Arrays$$anon$1;
/** @constructor */
function $c_ju_Collections$$anon$15(o$2) {
  this.ju_Collections$$anon$15__f_o$2 = null;
  this.ju_Collections$$anon$15__f_o$2 = o$2
}
$c_ju_Collections$$anon$15.prototype = new $h_ju_AbstractList();
$c_ju_Collections$$anon$15.prototype.constructor = $c_ju_Collections$$anon$15;
/** @constructor */
function $h_ju_Collections$$anon$15() {
  /*<skip>*/
}
$h_ju_Collections$$anon$15.prototype = $c_ju_Collections$$anon$15.prototype;
$c_ju_Collections$$anon$15.prototype.size__I = (function() {
  return 1
});
$c_ju_Collections$$anon$15.prototype.get__I__O = (function(index) {
  if ((index === 0)) {
    return this.ju_Collections$$anon$15__f_o$2
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
var $d_ju_Collections$$anon$15 = new $TypeData().initClass({
  ju_Collections$$anon$15: 0
}, false, "java.util.Collections$$anon$15", {
  ju_Collections$$anon$15: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Collections$$anon$15.prototype.$classData = $d_ju_Collections$$anon$15;
class $c_ju_DuplicateFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_DuplicateFormatFlagsException__f_f = null;
    this.ju_DuplicateFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return (("Flags = '" + this.ju_DuplicateFormatFlagsException__f_f) + "'")
  };
}
var $d_ju_DuplicateFormatFlagsException = new $TypeData().initClass({
  ju_DuplicateFormatFlagsException: 0
}, false, "java.util.DuplicateFormatFlagsException", {
  ju_DuplicateFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_DuplicateFormatFlagsException.prototype.$classData = $d_ju_DuplicateFormatFlagsException;
class $c_ju_FormatFlagsConversionMismatchException extends $c_ju_IllegalFormatException {
  constructor(f, c) {
    super();
    this.ju_FormatFlagsConversionMismatchException__f_f = null;
    this.ju_FormatFlagsConversionMismatchException__f_c = 0;
    this.ju_FormatFlagsConversionMismatchException__f_f = f;
    this.ju_FormatFlagsConversionMismatchException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return ((("Conversion = " + $bC(this.ju_FormatFlagsConversionMismatchException__f_c)) + ", Flags = ") + this.ju_FormatFlagsConversionMismatchException__f_f)
  };
}
var $d_ju_FormatFlagsConversionMismatchException = new $TypeData().initClass({
  ju_FormatFlagsConversionMismatchException: 0
}, false, "java.util.FormatFlagsConversionMismatchException", {
  ju_FormatFlagsConversionMismatchException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_FormatFlagsConversionMismatchException.prototype.$classData = $d_ju_FormatFlagsConversionMismatchException;
class $c_ju_IllegalFormatArgumentIndexException extends $c_ju_IllegalFormatException {
  constructor(msg) {
    super();
    this.ju_IllegalFormatArgumentIndexException__f_msg = null;
    this.ju_IllegalFormatArgumentIndexException__f_msg = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    return this.ju_IllegalFormatArgumentIndexException__f_msg
  };
}
var $d_ju_IllegalFormatArgumentIndexException = new $TypeData().initClass({
  ju_IllegalFormatArgumentIndexException: 0
}, false, "java.util.IllegalFormatArgumentIndexException", {
  ju_IllegalFormatArgumentIndexException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatArgumentIndexException.prototype.$classData = $d_ju_IllegalFormatArgumentIndexException;
class $c_ju_IllegalFormatCodePointException extends $c_ju_IllegalFormatException {
  constructor(c) {
    super();
    this.ju_IllegalFormatCodePointException__f_c = 0;
    this.ju_IllegalFormatCodePointException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    var i = this.ju_IllegalFormatCodePointException__f_c;
    return ("Code point = 0x" + $as_T($uD((i >>> 0.0)).toString(16)))
  };
}
var $d_ju_IllegalFormatCodePointException = new $TypeData().initClass({
  ju_IllegalFormatCodePointException: 0
}, false, "java.util.IllegalFormatCodePointException", {
  ju_IllegalFormatCodePointException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatCodePointException.prototype.$classData = $d_ju_IllegalFormatCodePointException;
class $c_ju_IllegalFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(c, arg) {
    super();
    this.ju_IllegalFormatConversionException__f_c = 0;
    this.ju_IllegalFormatConversionException__f_arg = null;
    this.ju_IllegalFormatConversionException__f_c = c;
    this.ju_IllegalFormatConversionException__f_arg = arg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((arg === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    var this$1 = this.ju_IllegalFormatConversionException__f_c;
    return (($as_T(String.fromCharCode(this$1)) + " != ") + $n(this.ju_IllegalFormatConversionException__f_arg).getName__T())
  };
}
var $d_ju_IllegalFormatConversionException = new $TypeData().initClass({
  ju_IllegalFormatConversionException: 0
}, false, "java.util.IllegalFormatConversionException", {
  ju_IllegalFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatConversionException.prototype.$classData = $d_ju_IllegalFormatConversionException;
class $c_ju_IllegalFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_IllegalFormatFlagsException__f_f = null;
    this.ju_IllegalFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return (("Flags = '" + this.ju_IllegalFormatFlagsException__f_f) + "'")
  };
}
var $d_ju_IllegalFormatFlagsException = new $TypeData().initClass({
  ju_IllegalFormatFlagsException: 0
}, false, "java.util.IllegalFormatFlagsException", {
  ju_IllegalFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatFlagsException.prototype.$classData = $d_ju_IllegalFormatFlagsException;
class $c_ju_IllegalFormatPrecisionException extends $c_ju_IllegalFormatException {
  constructor(p) {
    super();
    this.ju_IllegalFormatPrecisionException__f_p = 0;
    this.ju_IllegalFormatPrecisionException__f_p = p;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    var i = this.ju_IllegalFormatPrecisionException__f_p;
    return ("" + i)
  };
}
var $d_ju_IllegalFormatPrecisionException = new $TypeData().initClass({
  ju_IllegalFormatPrecisionException: 0
}, false, "java.util.IllegalFormatPrecisionException", {
  ju_IllegalFormatPrecisionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatPrecisionException.prototype.$classData = $d_ju_IllegalFormatPrecisionException;
class $c_ju_IllegalFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(w) {
    super();
    this.ju_IllegalFormatWidthException__f_w = 0;
    this.ju_IllegalFormatWidthException__f_w = w;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    var i = this.ju_IllegalFormatWidthException__f_w;
    return ("" + i)
  };
}
var $d_ju_IllegalFormatWidthException = new $TypeData().initClass({
  ju_IllegalFormatWidthException: 0
}, false, "java.util.IllegalFormatWidthException", {
  ju_IllegalFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatWidthException.prototype.$classData = $d_ju_IllegalFormatWidthException;
class $c_ju_MissingFormatArgumentException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatArgumentException__f_s = null;
    this.ju_MissingFormatArgumentException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return (("Format specifier '" + this.ju_MissingFormatArgumentException__f_s) + "'")
  };
}
var $d_ju_MissingFormatArgumentException = new $TypeData().initClass({
  ju_MissingFormatArgumentException: 0
}, false, "java.util.MissingFormatArgumentException", {
  ju_MissingFormatArgumentException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_MissingFormatArgumentException.prototype.$classData = $d_ju_MissingFormatArgumentException;
class $c_ju_MissingFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatWidthException__f_s = null;
    this.ju_MissingFormatWidthException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return this.ju_MissingFormatWidthException__f_s
  };
}
var $d_ju_MissingFormatWidthException = new $TypeData().initClass({
  ju_MissingFormatWidthException: 0
}, false, "java.util.MissingFormatWidthException", {
  ju_MissingFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_MissingFormatWidthException.prototype.$classData = $d_ju_MissingFormatWidthException;
class $c_ju_UnknownFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_UnknownFormatConversionException__f_s = null;
    this.ju_UnknownFormatConversionException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    }
  };
  getMessage__T() {
    return (("Conversion = '" + this.ju_UnknownFormatConversionException__f_s) + "'")
  };
}
var $d_ju_UnknownFormatConversionException = new $TypeData().initClass({
  ju_UnknownFormatConversionException: 0
}, false, "java.util.UnknownFormatConversionException", {
  ju_UnknownFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_UnknownFormatConversionException.prototype.$classData = $d_ju_UnknownFormatConversionException;
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor) {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  $ct_ju_HashMap__I__F__(this, initialCapacity, loadFactor)
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = new $h_ju_NullRejectingHashMap();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(this)
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.keyIterator__ju_Iterator = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator(this)
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList = (function() {
  var snapshot = $ct_ju_ArrayList__I__(new $c_ju_ArrayList(), this.ju_HashMap__f_contentSize);
  var iter = new $c_ju_HashMap$NodeIterator(this);
  while (iter.hasNext__Z()) {
    snapshot.add__O__Z(iter.next__O())
  };
  return snapshot
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap = new $TypeData().initClass({
  ju_concurrent_ConcurrentHashMap$InnerHashMap: 0
}, false, "java.util.concurrent.ConcurrentHashMap$InnerHashMap", {
  ju_concurrent_ConcurrentHashMap$InnerHashMap: 1,
  ju_NullRejectingHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.$classData = $d_ju_concurrent_ConcurrentHashMap$InnerHashMap;
function $ct_ju_concurrent_CopyOnWriteArrayList__O__($thiz, inner) {
  $thiz.ju_concurrent_CopyOnWriteArrayList__f_inner = inner;
  $thiz.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false;
  return $thiz
}
function $ct_ju_concurrent_CopyOnWriteArrayList__($thiz) {
  $ct_ju_concurrent_CopyOnWriteArrayList__O__($thiz, []);
  return $thiz
}
function $ct_ju_concurrent_CopyOnWriteArrayList__AO__($thiz, toCopyIn) {
  $ct_ju_concurrent_CopyOnWriteArrayList__($thiz);
  var end = $n(toCopyIn).u.length;
  var i = 0;
  while ((i < end)) {
    var i$2 = i;
    $thiz.add__O__Z($n(toCopyIn).get(i$2));
    i = ((1 + i) | 0)
  };
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_CopyOnWriteArrayList() {
  this.ju_concurrent_CopyOnWriteArrayList__f_inner = null;
  this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false
}
$c_ju_concurrent_CopyOnWriteArrayList.prototype = new $h_O();
$c_ju_concurrent_CopyOnWriteArrayList.prototype.constructor = $c_ju_concurrent_CopyOnWriteArrayList;
/** @constructor */
function $h_ju_concurrent_CopyOnWriteArrayList() {
  /*<skip>*/
}
$h_ju_concurrent_CopyOnWriteArrayList.prototype = $c_ju_concurrent_CopyOnWriteArrayList.prototype;
$c_ju_concurrent_CopyOnWriteArrayList.prototype.size__I = (function() {
  return $uI(this.ju_concurrent_CopyOnWriteArrayList__f_inner.length)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  while ($n(_\uff3fself).hasNext__Z()) {
    var x$1$2 = $n(_\uff3fself).next__O();
    if (((o === null) ? (x$1$2 === null) : $dp_equals__O__Z($n(o), x$1$2))) {
      return true
    }
  };
  return false
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toArray__AO = (function() {
  return this.toArray__AO__AO(new $ac_O(this.size__I()))
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toArray__AO__AO = (function(a) {
  var this$1 = $n(a);
  var componentType = $objectGetClass(this$1).getComponentType__jl_Class();
  var toFill = (($n(a).u.length >= this.size__I()) ? a : $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, this.size__I()), 1));
  var iter = this.listIterator__I__ju_ListIterator(0);
  var end = this.size__I();
  var i = 0;
  while ((i < end)) {
    var i$2 = i;
    $n(toFill).set(i$2, $n(iter).next__O());
    i = ((1 + i) | 0)
  };
  if (($n(toFill).u.length > this.size__I())) {
    $n(toFill).set(this.size__I(), null)
  };
  return toFill
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  return this.innerGet__I__O(index)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.set__I__O__O = (function(index, element) {
  this.checkIndexInBounds__I__V(index);
  this.copyIfNeeded__V();
  var oldValue = this.innerGet__I__O(index);
  this.innerSet__I__O__V(index, element);
  return oldValue
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.add__O__Z = (function(e) {
  this.copyIfNeeded__V();
  this.innerPush__O__V(e);
  return true
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.remove__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  this.copyIfNeeded__V();
  var array = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return array.splice(index, 1)[0]
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = $n(c).iterator__ju_Iterator();
  _return: {
    while ($n(_\uff3fself).hasNext__Z()) {
      var x$2 = $n(_\uff3fself).next__O();
      if ((!this.contains__O__Z(x$2))) {
        var $$x1 = true;
        break _return
      }
    };
    var $$x1 = false
  };
  return (!$$x1)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toString__T = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = "[";
  var first = true;
  while ($n(_\uff3fself).hasNext__Z()) {
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (("" + result) + $n(_\uff3fself).next__O())
  };
  return (result + "]")
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.equals__O__Z = (function(obj) {
  if ((obj === this)) {
    return true
  } else if ($is_ju_List(obj)) {
    var x2 = $as_ju_List(obj);
    var oIter = $n(x2).listIterator__ju_ListIterator();
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while ($n(_\uff3fself).hasNext__Z()) {
        var x$2 = $n(_\uff3fself).next__O();
        if ($n(oIter).hasNext__Z()) {
          var b = $n(oIter).next__O();
          var $$x2 = ((x$2 === null) ? (b === null) : $dp_equals__O__Z($n(x$2), b))
        } else {
          var $$x2 = false
        };
        if ((!$$x2)) {
          var $$x1 = true;
          break _return
        }
      };
      var $$x1 = false
    };
    if ((!$$x1)) {
      return (!$n(oIter).hasNext__Z())
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while ($n(_\uff3fself).hasNext__Z()) {
    var prev$2 = result;
    var elem$2 = $n(_\uff3fself).next__O();
    var prev = $uI(prev$2);
    result = ((Math.imul(31, prev) + ((elem$2 === null) ? 0 : $dp_hashCode__I($n(elem$2)))) | 0)
  };
  return $uI(result)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.listIterator__ju_ListIterator = (function() {
  return this.listIterator__I__ju_ListIterator(0)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  return new $c_ju_concurrent_CopyOnWriteArrayListIterator(this.innerSnapshot__O(), index, 0, this.size__I())
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerGet__I__O = (function(index) {
  return this.ju_concurrent_CopyOnWriteArrayList__f_inner[index]
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerSet__I__O__V = (function(index, elem) {
  this.ju_concurrent_CopyOnWriteArrayList__f_inner[index] = elem
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerPush__O__V = (function(elem) {
  this.ju_concurrent_CopyOnWriteArrayList__f_inner.push(elem)
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.copyIfNeeded__V = (function() {
  if (this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite) {
    var qual$1 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    this.ju_concurrent_CopyOnWriteArrayList__f_inner = qual$1.slice();
    this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerSnapshot__O = (function() {
  this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = true;
  return this.ju_concurrent_CopyOnWriteArrayList__f_inner
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.checkIndexInBounds__I__V = (function(index) {
  if (((index < 0) || (index >= this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if (((index < 0) || (index > this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
var $d_ju_concurrent_CopyOnWriteArrayList = new $TypeData().initClass({
  ju_concurrent_CopyOnWriteArrayList: 0
}, false, "java.util.concurrent.CopyOnWriteArrayList", {
  ju_concurrent_CopyOnWriteArrayList: 1,
  O: 1,
  ju_List: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.$classData = $d_ju_concurrent_CopyOnWriteArrayList;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9(outer) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this)
}
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher();
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9.prototype = $c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9.prototype;
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9.prototype.initialFetch__s_concurrent_Future = (function() {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lreactbuild_model_ListEntryType$().Lreactbuild_model_ListEntryType$__f_orderedList)
});
var $d_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9: 0
}, false, "reactbuild.analyze.cost.modules.EditListEntry$$anon$8$$anon$9", {
  Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9: 1,
  Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_Broadcaster: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1,
  Ljapgolly_scalajs_react_extra_Listenable: 1
});
$c_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_EditListEntry$$anon$8$$anon$9;
class $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException extends $c_jl_RuntimeException {
  constructor(e) {
    super();
    this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException__f_e = null;
    this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException__f_e = e;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  productPrefix__T() {
    return "GeolocationException"
  };
  productArity__I() {
    return 1
  };
  productElement__I__O(x$1) {
    return ((x$1 === 0) ? this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException__f_e : $m_sr_Statics$().ioobe__I__O(x$1))
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
  };
  equals__O__Z(x$1) {
    if ((this === x$1)) {
      return true
    } else if ((x$1 instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException)) {
      var GeolocationException$1 = $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException(x$1);
      var x = this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException__f_e;
      var y = $n(GeolocationException$1).Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException__f_e;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  };
}
function $as_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.GeolocationException"))
}
function $isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException)))
}
function $asArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.modules.mapview.interactions.takepicture.GeolocationException;", depth))
}
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.GeolocationException", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationException;
/** @constructor */
function $c_Lreactbuild_common_components_Input$Left$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Left$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Left$.prototype.constructor = $c_Lreactbuild_common_components_Input$Left$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Left$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Left$.prototype = $c_Lreactbuild_common_components_Input$Left$.prototype;
$c_Lreactbuild_common_components_Input$Left$.prototype.productPrefix__T = (function() {
  return "Left"
});
$c_Lreactbuild_common_components_Input$Left$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Left$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Left$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Left$.prototype.hashCode__I = (function() {
  return 2364455
});
$c_Lreactbuild_common_components_Input$Left$.prototype.toString__T = (function() {
  return "Left"
});
var $d_Lreactbuild_common_components_Input$Left$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Left$: 0
}, false, "reactbuild.common.components.Input$Left$", {
  Lreactbuild_common_components_Input$Left$: 1,
  O: 1,
  Lreactbuild_common_components_Input$KeyboardLocation: 1,
  Lreactbuild_common_components_Input$MouseButton: 1,
  Lreactbuild_common_components_Input$PointerButton: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Left$.prototype.$classData = $d_Lreactbuild_common_components_Input$Left$;
var $n_Lreactbuild_common_components_Input$Left$;
function $m_Lreactbuild_common_components_Input$Left$() {
  if ((!$n_Lreactbuild_common_components_Input$Left$)) {
    $n_Lreactbuild_common_components_Input$Left$ = new $c_Lreactbuild_common_components_Input$Left$()
  };
  return $n_Lreactbuild_common_components_Input$Left$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype.constructor = $c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype = $c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype;
$c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype.productPrefix__T = (function() {
  return "CtrlAlt"
});
$c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype.hashCode__I = (function() {
  return (-1532216546)
});
$c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype.toString__T = (function() {
  return "CtrlAlt"
});
var $d_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$: 0
}, false, "reactbuild.common.components.Input$ModifierKey$CtrlAlt$", {
  Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$: 1,
  O: 1,
  Lreactbuild_common_components_Input$CtrlKey: 1,
  Lreactbuild_common_components_Input$ModifierKey: 1,
  Lreactbuild_common_components_Input$AltKey: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$.prototype.$classData = $d_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$;
var $n_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$;
function $m_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$() {
  if ((!$n_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$)) {
    $n_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$ = new $c_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$()
  };
  return $n_Lreactbuild_common_components_Input$ModifierKey$CtrlAlt$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype.constructor = $c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype = $c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype;
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype.productPrefix__T = (function() {
  return "ShiftAlt"
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype.hashCode__I = (function() {
  return (-460746265)
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype.toString__T = (function() {
  return "ShiftAlt"
});
var $d_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$: 0
}, false, "reactbuild.common.components.Input$ModifierKey$ShiftAlt$", {
  Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$: 1,
  O: 1,
  Lreactbuild_common_components_Input$ShiftKey: 1,
  Lreactbuild_common_components_Input$ModifierKey: 1,
  Lreactbuild_common_components_Input$AltKey: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$.prototype.$classData = $d_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$;
var $n_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$;
function $m_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$() {
  if ((!$n_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$)) {
    $n_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$ = new $c_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$()
  };
  return $n_Lreactbuild_common_components_Input$ModifierKey$ShiftAlt$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype.constructor = $c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype = $c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype;
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype.productPrefix__T = (function() {
  return "ShiftCtrl"
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype.hashCode__I = (function() {
  return (-1398165011)
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype.toString__T = (function() {
  return "ShiftCtrl"
});
var $d_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$: 0
}, false, "reactbuild.common.components.Input$ModifierKey$ShiftCtrl$", {
  Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$: 1,
  O: 1,
  Lreactbuild_common_components_Input$ShiftKey: 1,
  Lreactbuild_common_components_Input$ModifierKey: 1,
  Lreactbuild_common_components_Input$CtrlKey: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$.prototype.$classData = $d_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$;
var $n_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$;
function $m_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$() {
  if ((!$n_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$)) {
    $n_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$ = new $c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$()
  };
  return $n_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrl$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$MouseEvent(status, coords, button, buttons, modifiers, timestamp) {
  this.Lreactbuild_common_components_Input$MouseEvent__f_status = null;
  this.Lreactbuild_common_components_Input$MouseEvent__f_coords = null;
  this.Lreactbuild_common_components_Input$MouseEvent__f_button = null;
  this.Lreactbuild_common_components_Input$MouseEvent__f_buttons = null;
  this.Lreactbuild_common_components_Input$MouseEvent__f_modifiers = null;
  this.Lreactbuild_common_components_Input$MouseEvent__f_timestamp = 0.0;
  this.Lreactbuild_common_components_Input$MouseEvent__f_status = status;
  this.Lreactbuild_common_components_Input$MouseEvent__f_coords = coords;
  this.Lreactbuild_common_components_Input$MouseEvent__f_button = button;
  this.Lreactbuild_common_components_Input$MouseEvent__f_buttons = buttons;
  this.Lreactbuild_common_components_Input$MouseEvent__f_modifiers = modifiers;
  this.Lreactbuild_common_components_Input$MouseEvent__f_timestamp = timestamp
}
$c_Lreactbuild_common_components_Input$MouseEvent.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$MouseEvent.prototype.constructor = $c_Lreactbuild_common_components_Input$MouseEvent;
/** @constructor */
function $h_Lreactbuild_common_components_Input$MouseEvent() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$MouseEvent.prototype = $c_Lreactbuild_common_components_Input$MouseEvent.prototype;
$c_Lreactbuild_common_components_Input$MouseEvent.prototype.productPrefix__T = (function() {
  return "MouseEvent"
});
$c_Lreactbuild_common_components_Input$MouseEvent.prototype.productArity__I = (function() {
  return 6
});
$c_Lreactbuild_common_components_Input$MouseEvent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_common_components_Input$MouseEvent__f_status;
      break
    }
    case 1: {
      return this.Lreactbuild_common_components_Input$MouseEvent__f_coords;
      break
    }
    case 2: {
      return this.Lreactbuild_common_components_Input$MouseEvent__f_button;
      break
    }
    case 3: {
      return this.Lreactbuild_common_components_Input$MouseEvent__f_buttons;
      break
    }
    case 4: {
      return this.Lreactbuild_common_components_Input$MouseEvent__f_modifiers;
      break
    }
    case 5: {
      return this.Lreactbuild_common_components_Input$MouseEvent__f_timestamp;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_common_components_Input$MouseEvent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$MouseEvent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("MouseEvent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_common_components_Input$MouseEvent__f_status;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lreactbuild_common_components_Input$MouseEvent__f_coords;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lreactbuild_common_components_Input$MouseEvent__f_button;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lreactbuild_common_components_Input$MouseEvent__f_buttons;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lreactbuild_common_components_Input$MouseEvent__f_modifiers;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var dv = this.Lreactbuild_common_components_Input$MouseEvent__f_timestamp;
  var data$6 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lreactbuild_common_components_Input$MouseEvent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_common_components_Input$MouseEvent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_common_components_Input$MouseEvent)) {
    var MouseEvent$1 = $as_Lreactbuild_common_components_Input$MouseEvent(x$1);
    if ((this.Lreactbuild_common_components_Input$MouseEvent__f_timestamp === $n(MouseEvent$1).Lreactbuild_common_components_Input$MouseEvent__f_timestamp)) {
      var x = this.Lreactbuild_common_components_Input$MouseEvent__f_status;
      var x$2 = $n(MouseEvent$1).Lreactbuild_common_components_Input$MouseEvent__f_status;
      if ((x === null)) {
        var $$x2 = (x$2 === null)
      } else {
        var this$1 = $n(x);
        var $$x2 = (this$1 === x$2)
      };
      if ($$x2) {
        var x$3 = this.Lreactbuild_common_components_Input$MouseEvent__f_coords;
        var x$4 = $n(MouseEvent$1).Lreactbuild_common_components_Input$MouseEvent__f_coords;
        var $$x1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lreactbuild_common_components_Input$MouseEvent__f_button;
      var x$6 = $n(MouseEvent$1).Lreactbuild_common_components_Input$MouseEvent__f_button;
      if ((x$5 === null)) {
        var $$x4 = (x$6 === null)
      } else {
        var this$2 = $n(x$5);
        var $$x4 = (this$2 === x$6)
      };
      if ($$x4) {
        var x$7 = this.Lreactbuild_common_components_Input$MouseEvent__f_buttons;
        var x$8 = $n(MouseEvent$1).Lreactbuild_common_components_Input$MouseEvent__f_buttons;
        var $$x3 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$9 = this.Lreactbuild_common_components_Input$MouseEvent__f_modifiers;
        var x$10 = $n(MouseEvent$1).Lreactbuild_common_components_Input$MouseEvent__f_modifiers;
        if ((x$9 === null)) {
          var $$x5 = (x$10 === null)
        } else {
          var this$3 = $n(x$9);
          var $$x5 = (this$3 === x$10)
        };
        if ($$x5) {
          $n(MouseEvent$1);
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_common_components_Input$MouseEvent(obj) {
  return (((obj instanceof $c_Lreactbuild_common_components_Input$MouseEvent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.common.components.Input$MouseEvent"))
}
function $isArrayOf_Lreactbuild_common_components_Input$MouseEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_common_components_Input$MouseEvent)))
}
function $asArrayOf_Lreactbuild_common_components_Input$MouseEvent(obj, depth) {
  return (($isArrayOf_Lreactbuild_common_components_Input$MouseEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.common.components.Input$MouseEvent;", depth))
}
var $d_Lreactbuild_common_components_Input$MouseEvent = new $TypeData().initClass({
  Lreactbuild_common_components_Input$MouseEvent: 0
}, false, "reactbuild.common.components.Input$MouseEvent", {
  Lreactbuild_common_components_Input$MouseEvent: 1,
  O: 1,
  Lreactbuild_common_components_Input$PointerInputEvent: 1,
  Lreactbuild_common_components_Input$InputEvent: 1,
  Lreactbuild_common_components_Input$Event: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$MouseEvent.prototype.$classData = $d_Lreactbuild_common_components_Input$MouseEvent;
/** @constructor */
function $c_Lreactbuild_common_components_Input$Right$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Right$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Right$.prototype.constructor = $c_Lreactbuild_common_components_Input$Right$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Right$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Right$.prototype = $c_Lreactbuild_common_components_Input$Right$.prototype;
$c_Lreactbuild_common_components_Input$Right$.prototype.productPrefix__T = (function() {
  return "Right"
});
$c_Lreactbuild_common_components_Input$Right$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Right$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Right$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Right$.prototype.hashCode__I = (function() {
  return 78959100
});
$c_Lreactbuild_common_components_Input$Right$.prototype.toString__T = (function() {
  return "Right"
});
var $d_Lreactbuild_common_components_Input$Right$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Right$: 0
}, false, "reactbuild.common.components.Input$Right$", {
  Lreactbuild_common_components_Input$Right$: 1,
  O: 1,
  Lreactbuild_common_components_Input$KeyboardLocation: 1,
  Lreactbuild_common_components_Input$MouseButton: 1,
  Lreactbuild_common_components_Input$PointerButton: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Right$.prototype.$classData = $d_Lreactbuild_common_components_Input$Right$;
var $n_Lreactbuild_common_components_Input$Right$;
function $m_Lreactbuild_common_components_Input$Right$() {
  if ((!$n_Lreactbuild_common_components_Input$Right$)) {
    $n_Lreactbuild_common_components_Input$Right$ = new $c_Lreactbuild_common_components_Input$Right$()
  };
  return $n_Lreactbuild_common_components_Input$Right$
}
/** @constructor */
function $c_Lreactbuild_format_iz2use_package$Length$$anon$1() {
  /*<skip>*/
}
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype = new $h_O();
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.constructor = $c_Lreactbuild_format_iz2use_package$Length$$anon$1;
/** @constructor */
function $h_Lreactbuild_format_iz2use_package$Length$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype = $c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype;
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.zero__O = (function() {
  return new $c_Lreactbuild_format_iz2use_package$Length(0)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.minus__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length = (function(x, y) {
  var this$1 = $n($m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_reactbuild$format$iz2use$Length$$underlying);
  var x$1 = $n(x).Lreactbuild_format_iz2use_package$Length__f_length;
  var y$1 = $n(y).Lreactbuild_format_iz2use_package$Length__f_length;
  return new $c_Lreactbuild_format_iz2use_package$Length($f_s_math_Numeric$IntIsIntegral__minus__I__I__I(this$1, x$1, y$1))
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.negate__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length = (function(x) {
  var this$1 = $n($m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_reactbuild$format$iz2use$Length$$underlying);
  var x$1 = $n(x).Lreactbuild_format_iz2use_package$Length__f_length;
  return new $c_Lreactbuild_format_iz2use_package$Length($f_s_math_Numeric$IntIsIntegral__negate__I__I(this$1, x$1))
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.plus__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length = (function(x, y) {
  var this$1 = $n($m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_reactbuild$format$iz2use$Length$$underlying);
  var x$1 = $n(x).Lreactbuild_format_iz2use_package$Length__f_length;
  var y$1 = $n(y).Lreactbuild_format_iz2use_package$Length__f_length;
  return new $c_Lreactbuild_format_iz2use_package$Length($f_s_math_Numeric$IntIsIntegral__plus__I__I__I(this$1, x$1, y$1))
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.toDouble__O__D = (function(x) {
  var x$1 = $as_Lreactbuild_format_iz2use_package$Length(x);
  $n($m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_reactbuild$format$iz2use$Length$$underlying);
  var x$2 = $n(x$1).Lreactbuild_format_iz2use_package$Length__f_length;
  return x$2
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.times__O__O__O = (function(x, y) {
  $as_Lreactbuild_format_iz2use_package$Length(x);
  $as_Lreactbuild_format_iz2use_package$Length(y);
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.plus__O__O__O = (function(x, y) {
  return this.plus__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length($as_Lreactbuild_format_iz2use_package$Length(x), $as_Lreactbuild_format_iz2use_package$Length(y))
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.negate__O__O = (function(x) {
  return this.negate__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length($as_Lreactbuild_format_iz2use_package$Length(x))
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.minus__O__O__O = (function(x, y) {
  return this.minus__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length__Lreactbuild_format_iz2use_package$Length($as_Lreactbuild_format_iz2use_package$Length(x), $as_Lreactbuild_format_iz2use_package$Length(y))
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.fromInt__I__O = (function(x) {
  return new $c_Lreactbuild_format_iz2use_package$Length(x)
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_Lreactbuild_format_iz2use_package$Length(x);
  var y$1 = $as_Lreactbuild_format_iz2use_package$Length(y);
  $n($m_Lreactbuild_format_iz2use_package$Length$().Lreactbuild_format_iz2use_package$Length$__f_reactbuild$format$iz2use$Length$$underlying);
  var x$2 = $n(x$1).Lreactbuild_format_iz2use_package$Length__f_length;
  var y$2 = $n(y$1).Lreactbuild_format_iz2use_package$Length__f_length;
  return ((x$2 === y$2) ? 0 : ((x$2 < y$2) ? (-1) : 1))
});
var $d_Lreactbuild_format_iz2use_package$Length$$anon$1 = new $TypeData().initClass({
  Lreactbuild_format_iz2use_package$Length$$anon$1: 0
}, false, "reactbuild.format.iz2use.package$Length$$anon$1", {
  Lreactbuild_format_iz2use_package$Length$$anon$1: 1,
  O: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_format_iz2use_package$Length$$anon$1.prototype.$classData = $d_Lreactbuild_format_iz2use_package$Length$$anon$1;
/** @constructor */
function $c_Lreactbuild_model_BaseRefToResolver$$anon$1(outer) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  this.Lreactbuild_model_BaseRefToResolver$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_BaseRefToResolver$$anon$1__f_$outer = outer
  };
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this)
}
$c_Lreactbuild_model_BaseRefToResolver$$anon$1.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher();
$c_Lreactbuild_model_BaseRefToResolver$$anon$1.prototype.constructor = $c_Lreactbuild_model_BaseRefToResolver$$anon$1;
/** @constructor */
function $h_Lreactbuild_model_BaseRefToResolver$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_BaseRefToResolver$$anon$1.prototype = $c_Lreactbuild_model_BaseRefToResolver$$anon$1.prototype;
$c_Lreactbuild_model_BaseRefToResolver$$anon$1.prototype.initialFetch__s_concurrent_Future = (function() {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n(this.Lreactbuild_model_BaseRefToResolver$$anon$1__f_$outer).allItems__sci_List())
});
var $d_Lreactbuild_model_BaseRefToResolver$$anon$1 = new $TypeData().initClass({
  Lreactbuild_model_BaseRefToResolver$$anon$1: 0
}, false, "reactbuild.model.BaseRefToResolver$$anon$1", {
  Lreactbuild_model_BaseRefToResolver$$anon$1: 1,
  Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_Broadcaster: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1,
  Ljapgolly_scalajs_react_extra_Listenable: 1
});
$c_Lreactbuild_model_BaseRefToResolver$$anon$1.prototype.$classData = $d_Lreactbuild_model_BaseRefToResolver$$anon$1;
/** @constructor */
function $c_Lreactbuild_model_CommunicationRole$From$() {
  /*<skip>*/
}
$c_Lreactbuild_model_CommunicationRole$From$.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationRole$From$.prototype.constructor = $c_Lreactbuild_model_CommunicationRole$From$;
/** @constructor */
function $h_Lreactbuild_model_CommunicationRole$From$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationRole$From$.prototype = $c_Lreactbuild_model_CommunicationRole$From$.prototype;
$c_Lreactbuild_model_CommunicationRole$From$.prototype.isSender__Z = (function() {
  return true
});
$c_Lreactbuild_model_CommunicationRole$From$.prototype.isRecipient__Z = (function() {
  return false
});
$c_Lreactbuild_model_CommunicationRole$From$.prototype.productPrefix__T = (function() {
  return "From"
});
$c_Lreactbuild_model_CommunicationRole$From$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_CommunicationRole$From$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_CommunicationRole$From$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CommunicationRole$From$.prototype.hashCode__I = (function() {
  return 2198474
});
$c_Lreactbuild_model_CommunicationRole$From$.prototype.toString__T = (function() {
  return "From"
});
function $as_Lreactbuild_model_CommunicationRole$From$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CommunicationRole$From$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommunicationRole$From$"))
}
function $isArrayOf_Lreactbuild_model_CommunicationRole$From$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommunicationRole$From$)))
}
function $asArrayOf_Lreactbuild_model_CommunicationRole$From$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommunicationRole$From$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommunicationRole$From$;", depth))
}
var $d_Lreactbuild_model_CommunicationRole$From$ = new $TypeData().initClass({
  Lreactbuild_model_CommunicationRole$From$: 0
}, false, "reactbuild.model.CommunicationRole$From$", {
  Lreactbuild_model_CommunicationRole$From$: 1,
  O: 1,
  Lreactbuild_model_NotOriginalCommunicationRole: 1,
  Lreactbuild_model_CommunicationRole: 1,
  Lreactbuild_model_SenderCommunicationRole: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationRole$From$.prototype.$classData = $d_Lreactbuild_model_CommunicationRole$From$;
var $n_Lreactbuild_model_CommunicationRole$From$;
function $m_Lreactbuild_model_CommunicationRole$From$() {
  if ((!$n_Lreactbuild_model_CommunicationRole$From$)) {
    $n_Lreactbuild_model_CommunicationRole$From$ = new $c_Lreactbuild_model_CommunicationRole$From$()
  };
  return $n_Lreactbuild_model_CommunicationRole$From$
}
/** @constructor */
function $c_Lreactbuild_model_CommunicationRole$Recipient$() {
  /*<skip>*/
}
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.constructor = $c_Lreactbuild_model_CommunicationRole$Recipient$;
/** @constructor */
function $h_Lreactbuild_model_CommunicationRole$Recipient$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationRole$Recipient$.prototype = $c_Lreactbuild_model_CommunicationRole$Recipient$.prototype;
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.isSender__Z = (function() {
  return false
});
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.isRecipient__Z = (function() {
  return true
});
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.productPrefix__T = (function() {
  return "Recipient"
});
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.hashCode__I = (function() {
  return (-1470918151)
});
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.toString__T = (function() {
  return "Recipient"
});
function $as_Lreactbuild_model_CommunicationRole$Recipient$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CommunicationRole$Recipient$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommunicationRole$Recipient$"))
}
function $isArrayOf_Lreactbuild_model_CommunicationRole$Recipient$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommunicationRole$Recipient$)))
}
function $asArrayOf_Lreactbuild_model_CommunicationRole$Recipient$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommunicationRole$Recipient$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommunicationRole$Recipient$;", depth))
}
var $d_Lreactbuild_model_CommunicationRole$Recipient$ = new $TypeData().initClass({
  Lreactbuild_model_CommunicationRole$Recipient$: 0
}, false, "reactbuild.model.CommunicationRole$Recipient$", {
  Lreactbuild_model_CommunicationRole$Recipient$: 1,
  O: 1,
  Lreactbuild_model_OriginalCommunicationRole: 1,
  Lreactbuild_model_CommunicationRole: 1,
  Lreactbuild_model_RecipientCommunicationRole: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationRole$Recipient$.prototype.$classData = $d_Lreactbuild_model_CommunicationRole$Recipient$;
var $n_Lreactbuild_model_CommunicationRole$Recipient$;
function $m_Lreactbuild_model_CommunicationRole$Recipient$() {
  if ((!$n_Lreactbuild_model_CommunicationRole$Recipient$)) {
    $n_Lreactbuild_model_CommunicationRole$Recipient$ = new $c_Lreactbuild_model_CommunicationRole$Recipient$()
  };
  return $n_Lreactbuild_model_CommunicationRole$Recipient$
}
/** @constructor */
function $c_Lreactbuild_model_CommunicationRole$Sender$() {
  /*<skip>*/
}
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.constructor = $c_Lreactbuild_model_CommunicationRole$Sender$;
/** @constructor */
function $h_Lreactbuild_model_CommunicationRole$Sender$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationRole$Sender$.prototype = $c_Lreactbuild_model_CommunicationRole$Sender$.prototype;
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.isSender__Z = (function() {
  return true
});
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.isRecipient__Z = (function() {
  return false
});
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.productPrefix__T = (function() {
  return "Sender"
});
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.hashCode__I = (function() {
  return (-1822095787)
});
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.toString__T = (function() {
  return "Sender"
});
function $as_Lreactbuild_model_CommunicationRole$Sender$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CommunicationRole$Sender$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommunicationRole$Sender$"))
}
function $isArrayOf_Lreactbuild_model_CommunicationRole$Sender$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommunicationRole$Sender$)))
}
function $asArrayOf_Lreactbuild_model_CommunicationRole$Sender$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommunicationRole$Sender$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommunicationRole$Sender$;", depth))
}
var $d_Lreactbuild_model_CommunicationRole$Sender$ = new $TypeData().initClass({
  Lreactbuild_model_CommunicationRole$Sender$: 0
}, false, "reactbuild.model.CommunicationRole$Sender$", {
  Lreactbuild_model_CommunicationRole$Sender$: 1,
  O: 1,
  Lreactbuild_model_OriginalCommunicationRole: 1,
  Lreactbuild_model_CommunicationRole: 1,
  Lreactbuild_model_SenderCommunicationRole: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationRole$Sender$.prototype.$classData = $d_Lreactbuild_model_CommunicationRole$Sender$;
var $n_Lreactbuild_model_CommunicationRole$Sender$;
function $m_Lreactbuild_model_CommunicationRole$Sender$() {
  if ((!$n_Lreactbuild_model_CommunicationRole$Sender$)) {
    $n_Lreactbuild_model_CommunicationRole$Sender$ = new $c_Lreactbuild_model_CommunicationRole$Sender$()
  };
  return $n_Lreactbuild_model_CommunicationRole$Sender$
}
/** @constructor */
function $c_Lreactbuild_model_CommunicationRole$To$() {
  /*<skip>*/
}
$c_Lreactbuild_model_CommunicationRole$To$.prototype = new $h_O();
$c_Lreactbuild_model_CommunicationRole$To$.prototype.constructor = $c_Lreactbuild_model_CommunicationRole$To$;
/** @constructor */
function $h_Lreactbuild_model_CommunicationRole$To$() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationRole$To$.prototype = $c_Lreactbuild_model_CommunicationRole$To$.prototype;
$c_Lreactbuild_model_CommunicationRole$To$.prototype.isSender__Z = (function() {
  return false
});
$c_Lreactbuild_model_CommunicationRole$To$.prototype.isRecipient__Z = (function() {
  return true
});
$c_Lreactbuild_model_CommunicationRole$To$.prototype.productPrefix__T = (function() {
  return "To"
});
$c_Lreactbuild_model_CommunicationRole$To$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_CommunicationRole$To$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_CommunicationRole$To$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_CommunicationRole$To$.prototype.hashCode__I = (function() {
  return 2715
});
$c_Lreactbuild_model_CommunicationRole$To$.prototype.toString__T = (function() {
  return "To"
});
function $as_Lreactbuild_model_CommunicationRole$To$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_CommunicationRole$To$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.CommunicationRole$To$"))
}
function $isArrayOf_Lreactbuild_model_CommunicationRole$To$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_CommunicationRole$To$)))
}
function $asArrayOf_Lreactbuild_model_CommunicationRole$To$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_CommunicationRole$To$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.CommunicationRole$To$;", depth))
}
var $d_Lreactbuild_model_CommunicationRole$To$ = new $TypeData().initClass({
  Lreactbuild_model_CommunicationRole$To$: 0
}, false, "reactbuild.model.CommunicationRole$To$", {
  Lreactbuild_model_CommunicationRole$To$: 1,
  O: 1,
  Lreactbuild_model_NotOriginalCommunicationRole: 1,
  Lreactbuild_model_CommunicationRole: 1,
  Lreactbuild_model_RecipientCommunicationRole: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_CommunicationRole$To$.prototype.$classData = $d_Lreactbuild_model_CommunicationRole$To$;
var $n_Lreactbuild_model_CommunicationRole$To$;
function $m_Lreactbuild_model_CommunicationRole$To$() {
  if ((!$n_Lreactbuild_model_CommunicationRole$To$)) {
    $n_Lreactbuild_model_CommunicationRole$To$ = new $c_Lreactbuild_model_CommunicationRole$To$()
  };
  return $n_Lreactbuild_model_CommunicationRole$To$
}
/** @constructor */
function $c_Lreactbuild_model_Duration$$anon$3() {
  /*<skip>*/
}
$c_Lreactbuild_model_Duration$$anon$3.prototype = new $h_O();
$c_Lreactbuild_model_Duration$$anon$3.prototype.constructor = $c_Lreactbuild_model_Duration$$anon$3;
/** @constructor */
function $h_Lreactbuild_model_Duration$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_Duration$$anon$3.prototype = $c_Lreactbuild_model_Duration$$anon$3.prototype;
$c_Lreactbuild_model_Duration$$anon$3.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.plus__Lreactbuild_model_Duration__Lreactbuild_model_Duration__Lreactbuild_model_Duration = (function(x, y) {
  return (($n(y).Lreactbuild_model_Duration__f_value === 0.0) ? x : new $c_Lreactbuild_model_Duration(($n(x).Lreactbuild_model_Duration__f_value + $n(y).Lreactbuild_model_Duration__f_value)))
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.minus__Lreactbuild_model_Duration__Lreactbuild_model_Duration__Lreactbuild_model_Duration = (function(x, y) {
  return new $c_Lreactbuild_model_Duration(($n(x).Lreactbuild_model_Duration__f_value - $n(y).Lreactbuild_model_Duration__f_value))
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.negate__Lreactbuild_model_Duration__Lreactbuild_model_Duration = (function(x) {
  return new $c_Lreactbuild_model_Duration((-$n(x).Lreactbuild_model_Duration__f_value))
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.compare__Lreactbuild_model_Duration__Lreactbuild_model_Duration__I = (function(x, y) {
  var x$1 = $n(x).Lreactbuild_model_Duration__f_value;
  var this$2 = new $c_sr_RichDouble(x$1);
  var y$1 = $n(y).Lreactbuild_model_Duration__f_value;
  var x$2 = this$2.sr_RichDouble__f_self;
  return $m_jl_Double$().compare__D__D__I(x$2, y$1)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__Lreactbuild_model_Duration__Lreactbuild_model_Duration__I($as_Lreactbuild_model_Duration(x), $as_Lreactbuild_model_Duration(y))
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.zero__O = (function() {
  return $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_zeroDuration
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.toDouble__O__D = (function(x) {
  var x$1 = $as_Lreactbuild_model_Duration(x);
  return $n(x$1).Lreactbuild_model_Duration__f_value
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.fromInt__I__O = (function(x) {
  return new $c_Lreactbuild_model_Duration(x)
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.negate__O__O = (function(x) {
  return this.negate__Lreactbuild_model_Duration__Lreactbuild_model_Duration($as_Lreactbuild_model_Duration(x))
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.times__O__O__O = (function(x, y) {
  $as_Lreactbuild_model_Duration(x);
  $as_Lreactbuild_model_Duration(y);
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.minus__O__O__O = (function(x, y) {
  return this.minus__Lreactbuild_model_Duration__Lreactbuild_model_Duration__Lreactbuild_model_Duration($as_Lreactbuild_model_Duration(x), $as_Lreactbuild_model_Duration(y))
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.plus__O__O__O = (function(x, y) {
  return this.plus__Lreactbuild_model_Duration__Lreactbuild_model_Duration__Lreactbuild_model_Duration($as_Lreactbuild_model_Duration(x), $as_Lreactbuild_model_Duration(y))
});
var $d_Lreactbuild_model_Duration$$anon$3 = new $TypeData().initClass({
  Lreactbuild_model_Duration$$anon$3: 0
}, false, "reactbuild.model.Duration$$anon$3", {
  Lreactbuild_model_Duration$$anon$3: 1,
  O: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Duration$$anon$3.prototype.$classData = $d_Lreactbuild_model_Duration$$anon$3;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$NotApplicable(reason) {
  this.Lreactbuild_model_ListEntryEventBody$NotApplicable__f_reason = null;
  this.Lreactbuild_model_ListEntryEventBody$NotApplicable__f_reason = reason
}
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$NotApplicable;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$NotApplicable() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype = $c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype;
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifFound).apply__O__O(this.Lreactbuild_model_ListEntryEventBody$NotApplicable__f_reason)
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.productPrefix__T = (function() {
  return "NotApplicable"
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_model_ListEntryEventBody$NotApplicable__f_reason : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_model_ListEntryEventBody$NotApplicable)) {
    var NotApplicable$1 = $as_Lreactbuild_model_ListEntryEventBody$NotApplicable(x$1);
    return (this.Lreactbuild_model_ListEntryEventBody$NotApplicable__f_reason === $n(NotApplicable$1).Lreactbuild_model_ListEntryEventBody$NotApplicable__f_reason)
  } else {
    return false
  }
});
function $as_Lreactbuild_model_ListEntryEventBody$NotApplicable(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$NotApplicable) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$NotApplicable"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$NotApplicable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$NotApplicable)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$NotApplicable(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$NotApplicable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$NotApplicable;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$NotApplicable = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$NotApplicable: 0
}, false, "reactbuild.model.ListEntryEventBody$NotApplicable", {
  Lreactbuild_model_ListEntryEventBody$NotApplicable: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventCheck: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  Lreactbuild_model_ListEntryEventGuideline: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$NotApplicable.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$NotApplicable;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13(outer) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13.prototype.initialFetch__s_concurrent_Future = (function() {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($m_Lreactbuild_person_SupplierGroup$().Lreactbuild_person_SupplierGroup$__f_list)
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$12$$anon$13", {
  Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13: 1,
  Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_Broadcaster: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1,
  Ljapgolly_scalajs_react_extra_Listenable: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$12$$anon$13;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5(outer) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5__f_$outer = outer
  };
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5.prototype.initialFetch__s_concurrent_Future = (function() {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5__f_$outer).Lreactbuild_model_LowPriorityImplicits$$anon$4__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$documentCategoryList)
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$4$$anon$5", {
  Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5: 1,
  Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_Broadcaster: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1,
  Ljapgolly_scalajs_react_extra_Listenable: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$4$$anon$5;
/** @constructor */
function $c_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10(outer) {
  this.Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  this.Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10__f_$outer = outer
  };
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this)
}
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10.prototype = new $h_Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher();
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10.prototype.constructor = $c_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10;
/** @constructor */
function $h_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10.prototype = $c_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10.prototype;
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10.prototype.initialFetch__s_concurrent_Future = (function() {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future($n($n(this.Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10__f_$outer).Lreactbuild_model_LowPriorityImplicits$$anon$9__f_$outer).Lreactbuild_model_Implicits$__f_reactbuild$model$LowPriorityImplicits$$reconciliationReportOrderList)
});
var $d_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10 = new $TypeData().initClass({
  Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10: 0
}, false, "reactbuild.model.LowPriorityImplicits$$anon$9$$anon$10", {
  Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10: 1,
  Lcom_iz2use_react_components_internal_suggestion_OnMountFetcher: 1,
  Lcom_iz2use_react_components_internal_suggestion_SuggestionFetcher: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_Broadcaster: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1,
  Ljapgolly_scalajs_react_extra_Listenable: 1
});
$c_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10.prototype.$classData = $d_Lreactbuild_model_LowPriorityImplicits$$anon$9$$anon$10;
/** @constructor */
function $c_Lreactbuild_model_Price$$anon$4() {
  /*<skip>*/
}
$c_Lreactbuild_model_Price$$anon$4.prototype = new $h_O();
$c_Lreactbuild_model_Price$$anon$4.prototype.constructor = $c_Lreactbuild_model_Price$$anon$4;
/** @constructor */
function $h_Lreactbuild_model_Price$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_Price$$anon$4.prototype = $c_Lreactbuild_model_Price$$anon$4.prototype;
$c_Lreactbuild_model_Price$$anon$4.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.plus__Lreactbuild_model_Price__Lreactbuild_model_Price__Lreactbuild_model_Price = (function(x, y) {
  return new $c_Lreactbuild_model_Price(($n(x).Lreactbuild_model_Price__f_amount + $n(y).Lreactbuild_model_Price__f_amount))
});
$c_Lreactbuild_model_Price$$anon$4.prototype.minus__Lreactbuild_model_Price__Lreactbuild_model_Price__Lreactbuild_model_Price = (function(x, y) {
  return new $c_Lreactbuild_model_Price(($n(x).Lreactbuild_model_Price__f_amount - $n(y).Lreactbuild_model_Price__f_amount))
});
$c_Lreactbuild_model_Price$$anon$4.prototype.negate__Lreactbuild_model_Price__Lreactbuild_model_Price = (function(x) {
  return new $c_Lreactbuild_model_Price((-$n(x).Lreactbuild_model_Price__f_amount))
});
$c_Lreactbuild_model_Price$$anon$4.prototype.compare__Lreactbuild_model_Price__Lreactbuild_model_Price__I = (function(x, y) {
  var x$1 = $n(x).Lreactbuild_model_Price__f_amount;
  var this$2 = new $c_sr_RichDouble(x$1);
  var y$1 = $n(y).Lreactbuild_model_Price__f_amount;
  var x$2 = this$2.sr_RichDouble__f_self;
  return $m_jl_Double$().compare__D__D__I(x$2, y$1)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__Lreactbuild_model_Price__Lreactbuild_model_Price__I($as_Lreactbuild_model_Price(x), $as_Lreactbuild_model_Price(y))
});
$c_Lreactbuild_model_Price$$anon$4.prototype.zero__O = (function() {
  return $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_zero
});
$c_Lreactbuild_model_Price$$anon$4.prototype.toDouble__O__D = (function(x) {
  $as_Lreactbuild_model_Price(x);
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
$c_Lreactbuild_model_Price$$anon$4.prototype.fromInt__I__O = (function(x) {
  return new $c_Lreactbuild_model_Price(x)
});
$c_Lreactbuild_model_Price$$anon$4.prototype.negate__O__O = (function(x) {
  return this.negate__Lreactbuild_model_Price__Lreactbuild_model_Price($as_Lreactbuild_model_Price(x))
});
$c_Lreactbuild_model_Price$$anon$4.prototype.times__O__O__O = (function(x, y) {
  $as_Lreactbuild_model_Price(x);
  $as_Lreactbuild_model_Price(y);
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
$c_Lreactbuild_model_Price$$anon$4.prototype.minus__O__O__O = (function(x, y) {
  return this.minus__Lreactbuild_model_Price__Lreactbuild_model_Price__Lreactbuild_model_Price($as_Lreactbuild_model_Price(x), $as_Lreactbuild_model_Price(y))
});
$c_Lreactbuild_model_Price$$anon$4.prototype.plus__O__O__O = (function(x, y) {
  return this.plus__Lreactbuild_model_Price__Lreactbuild_model_Price__Lreactbuild_model_Price($as_Lreactbuild_model_Price(x), $as_Lreactbuild_model_Price(y))
});
var $d_Lreactbuild_model_Price$$anon$4 = new $TypeData().initClass({
  Lreactbuild_model_Price$$anon$4: 0
}, false, "reactbuild.model.Price$$anon$4", {
  Lreactbuild_model_Price$$anon$4: 1,
  O: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_Price$$anon$4.prototype.$classData = $d_Lreactbuild_model_Price$$anon$4;
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_EditingComponent(ss, transform) {
  this.Lreactbuild_project_drawing_tool_EditingComponent__f_ss = null;
  this.Lreactbuild_project_drawing_tool_EditingComponent__f_transform = null;
  this.Lreactbuild_project_drawing_tool_EditingComponent__f_name = null;
  this.Lreactbuild_project_drawing_tool_EditingComponent__f_icon = null;
  this.Lreactbuild_project_drawing_tool_EditingComponent__f_ss = ss;
  this.Lreactbuild_project_drawing_tool_EditingComponent__f_transform = transform;
  this.Lreactbuild_project_drawing_tool_EditingComponent__f_name = "Propri\u00e9t\u00e9 du composant";
  this.Lreactbuild_project_drawing_tool_EditingComponent__f_icon = $n($m_Lcom_iz2use_react_components_IconSource$().Lcom_iz2use_react_components_IconSource$__f_unknown).Lcom_iz2use_react_components_IconSourceShape__f_shapePath
}
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.constructor = $c_Lreactbuild_project_drawing_tool_EditingComponent;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_EditingComponent() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_EditingComponent.prototype = $c_Lreactbuild_project_drawing_tool_EditingComponent.prototype;
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_EditingComponent__f_name
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_EditingComponent__f_icon
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.render__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_TagOf = (function(context) {
  var $$x9 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x8 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  var $$x7 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var this$7 = $n($n($as_Lreactbuild_format_iz2use_package$ComponentGroup($n(this.Lreactbuild_project_drawing_tool_EditingComponent__f_ss).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_format_iz2use_package$ComponentGroup__f_columns);
  var v = $f_sc_Iterable__toString__T(this$7);
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
  var $$x6 = $n($$x7).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$1 = $n($n($as_Lreactbuild_format_iz2use_package$ComponentGroup($n(this.Lreactbuild_project_drawing_tool_EditingComponent__f_ss).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_format_iz2use_package$ComponentGroup__f_margin).toString__T();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$1 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$1)];
  var $$x4 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$2 = $n($n($as_Lreactbuild_format_iz2use_package$ComponentGroup($n(this.Lreactbuild_project_drawing_tool_EditingComponent__f_ss).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_format_iz2use_package$ComponentGroup__f_offsets).toString__T();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$2 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
  var $$x2 = $n($$x3).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_HtmlTagOf$();
  $n($m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less);
  $n($m_Ljapgolly_scalajs_react_vdom_Exports$().Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf);
  $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
  var v$3 = $n($n($as_Lreactbuild_format_iz2use_package$ComponentGroup($n(this.Lreactbuild_project_drawing_tool_EditingComponent__f_ss).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_format_iz2use_package$ComponentGroup__f_z).toString__T();
  $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
  var array$3 = [new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$3)];
  var array$4 = [$$x6, $$x4, $$x2, $n($$x1).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("li", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var array$5 = [$n($$x8).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("ul", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  return $n($$x9).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("div", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.renderInViewport__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_TagOf = (function(context) {
  var $$x6 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$4 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
  var a = this.Lreactbuild_project_drawing_tool_EditingComponent__f_transform;
  var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
  var $$x5 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$4.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
  var $$x4 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$8 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "width");
  var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$8.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 5);
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$11 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "height");
  var t$2 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt;
  var $$x2 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$2, this$11.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, 5);
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$14 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "x");
  var t$3 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
  var $$x1 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$3, this$14.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, (-2.5));
  $m_Ljapgolly_scalajs_react_vdom_all$svg$();
  $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
  var this$17 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "y");
  var t$4 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().vdomAttrVtDouble__F2();
  var array = [$$x3, $$x2, $$x1, $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$4, this$17.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, (-2.5))];
  var array$1 = [$$x5, $n($$x4).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("rect", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  return $n($$x6).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("g", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.handleViewportEvent__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  if ((ev instanceof $c_Lreactbuild_common_components_Input$KeyboardEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$KeyboardEvent(ev);
    var p3 = $n(x2).Lreactbuild_common_components_Input$KeyboardEvent__f_status;
    var keyCode = $n(x2).Lreactbuild_common_components_Input$KeyboardEvent__f_keyCode;
    var p4 = $n(x2).Lreactbuild_common_components_Input$KeyboardEvent__f_modifiers;
    var x = $m_Lreactbuild_common_components_Input$End$();
    if ((x === p3)) {
      var x$3 = $m_Lreactbuild_common_components_Input$ModifierKey$None$();
      if ((x$3 === p4)) {
        var $$x1 = (keyCode === 27)
      } else {
        var $$x1 = false
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return new $c_Lreactbuild_common_components_Continue($m_s_None$(), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    }
  };
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.productPrefix__T = (function() {
  return "EditingComponent"
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.productArity__I = (function() {
  return 2
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_tool_EditingComponent__f_ss;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_tool_EditingComponent__f_transform;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_tool_EditingComponent)) {
    var EditingComponent$1 = $as_Lreactbuild_project_drawing_tool_EditingComponent(x$1);
    var x = this.Lreactbuild_project_drawing_tool_EditingComponent__f_ss;
    var x$2 = $n(EditingComponent$1).Lreactbuild_project_drawing_tool_EditingComponent__f_ss;
    if ((x === null)) {
      var $$x1 = (x$2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x$2)
    };
    if ($$x1) {
      return (this.Lreactbuild_project_drawing_tool_EditingComponent__f_transform === $n(EditingComponent$1).Lreactbuild_project_drawing_tool_EditingComponent__f_transform)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.renderInViewport__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(context) {
  return this.renderInViewport__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_TagOf(context)
});
function $as_Lreactbuild_project_drawing_tool_EditingComponent(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_tool_EditingComponent) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.tool.EditingComponent"))
}
function $isArrayOf_Lreactbuild_project_drawing_tool_EditingComponent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_tool_EditingComponent)))
}
function $asArrayOf_Lreactbuild_project_drawing_tool_EditingComponent(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_tool_EditingComponent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.tool.EditingComponent;", depth))
}
var $d_Lreactbuild_project_drawing_tool_EditingComponent = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_EditingComponent: 0
}, false, "reactbuild.project.drawing.tool.EditingComponent", {
  Lreactbuild_project_drawing_tool_EditingComponent: 1,
  O: 1,
  Lreactbuild_project_drawing_UITool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  Lreactbuild_project_drawing_ViewportTool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_EditingComponent.prototype.$classData = $d_Lreactbuild_project_drawing_tool_EditingComponent;
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall(wall, position, projectedPoint) {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_position = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_projectedPoint = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_name = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_icon = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall = wall;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_position = position;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_projectedPoint = projectedPoint;
  $f_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal__$init$__V(this)
}
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.constructor = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype;
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_name
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_icon
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.reactbuild$project$drawing$tool$PlaceNetworkTerminal$_setter_$name_$eq__T__V = (function(x$1) {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_name = x$1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.reactbuild$project$drawing$tool$PlaceNetworkTerminal$_setter_$icon_$eq__T__V = (function(x$1) {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_icon = x$1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.handleViewportEvent__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  var f = ((ev$2$2) => {
    var ev$2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev$2$2);
    var x1 = $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var x = $m_Lreactbuild_common_components_Input$Start$();
    if ((x === x1)) {
      var $$x1 = true
    } else {
      var x$3 = $m_Lreactbuild_common_components_Input$Move$();
      var $$x1 = (x$3 === x1)
    };
    if ($$x1) {
      return new $c_Lreactbuild_common_components_Continue(new $c_s_Some(this.withPosition__Lreactbuild_geom_Point2Based__Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall($as_Lreactbuild_geom_Point2Based($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition).apply__O__O($n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_coords)))), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var x$5 = $m_Lreactbuild_common_components_Input$End$();
      if ((x$5 === x1)) {
        return new $c_Lreactbuild_common_components_Continue(new $c_s_Some($m_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$()), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
      } else {
        return $m_Lreactbuild_common_components_Skip$()
      }
    }
  });
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var way = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var coords = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_coords;
    var p3 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_isPrimary;
    var button = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_button;
    var p8 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
    if ((p3 === true)) {
      var x$1 = $m_Lreactbuild_common_components_Input$ModifierKey$None$();
      var $$x2 = (x$1 === p8)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3$1 = $m_Lreactbuild_common_components_Input$Start$();
      if ((x$3$1 === way)) {
        var x$6 = $m_Lreactbuild_common_components_Input$Left$();
        if ((button !== null)) {
          var this$5 = $n(button);
          var $$x3 = (this$5 === x$6)
        } else {
          var $$x3 = false
        }
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        return $as_Lreactbuild_common_components_InteractionResult(f(x2))
      } else {
        var x$7 = $m_Lreactbuild_common_components_Input$Move$();
        if ((x$7 === way)) {
          var x$9 = $n(coords).Lreactbuild_common_components_Input$Coords__f_cursor;
          var x$10 = $m_Lreactbuild_common_components_Input$Touch$();
          if ((x$9 !== null)) {
            var this$6 = $n(x$9);
            var $$x5 = (this$6 === x$10)
          } else {
            var $$x5 = false
          };
          if ((!$$x5)) {
            var $$x4 = true
          } else {
            var $$x4 = ($n(trackedPointers).count__Lreactbuild_common_components_Input$CursorType__I($n(coords).Lreactbuild_common_components_Input$Coords__f_cursor) === 1)
          }
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          return $as_Lreactbuild_common_components_InteractionResult(f(x2))
        } else {
          var x$11 = $m_Lreactbuild_common_components_Input$End$();
          if ((x$11 === way)) {
            return $as_Lreactbuild_common_components_InteractionResult(f(x2))
          } else {
            return $m_Lreactbuild_common_components_Skip$()
          }
        }
      }
    }
  };
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.renderInViewport__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(context) {
  var this$1 = $n(this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_projectedPoint);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  } else {
    var arg1 = this$1.get__O();
    var projection = $as_Lreactbuild_geom_Point2Based(arg1);
    var $$x5 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$6 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
    var this$5 = $n(context);
    var a = (("translate(" + this$5.apply__D__D__T($n(projection).x__D(), $n(projection).y__D())) + ")");
    var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x4 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$6.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
    $m_Ljapgolly_scalajs_react_vdom_all$svg$();
    $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
    var this$9 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
    var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
    var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$9.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "middle");
    $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
    var $$x2 = $m_sc_StringOps$();
    var array = [$n($n(this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_distance).sqrt__D()];
    var v = $n($$x2).format$extension__T__sci_Seq__T("%.0f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
    $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
    var array$1 = [$$x4, $$x3, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v)];
    var $$x1 = $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  };
  var text = $as_Ljapgolly_scalajs_react_vdom_VdomNode($$x1);
  var this$21 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
  var array$2 = [$m_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$().highlightWall__Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__Lreactbuild_geom_Point2Based__s_Option__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomElement(this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall, this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_position, this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_projectedPoint, context), text];
  var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  return $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$21, null, ns)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.withPosition__Lreactbuild_geom_Point2Based__Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall = (function(position) {
  var this$1 = $n(position);
  var origin = $n(this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallOrigin;
  var vector = $n(this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallVector;
  var projection = $m_Lreactbuild_geom_Point2$().projectToLine__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Z__Lreactbuild_geom_Point2Based(this$1, origin, vector, true);
  var x$2 = new $c_s_Some(projection);
  var x$3 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall;
  return new $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall(x$3, position, x$2)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.productPrefix__T = (function() {
  return "ChoosePositionOnWall"
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.productArity__I = (function() {
  return 3
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_position;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_projectedPoint;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall)) {
    var ChoosePositionOnWall$1 = $as_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall(x$1);
    var x = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall;
    var x$2 = $n(ChoosePositionOnWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_wall;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_position;
      var x$4 = $n(ChoosePositionOnWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_position;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        var x$5 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_projectedPoint;
        var x$6 = $n(ChoosePositionOnWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_projectedPoint;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.tool.PlaceNetworkTerminal$ChoosePositionOnWall"))
}
function $isArrayOf_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall)))
}
function $asArrayOf_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.tool.PlaceNetworkTerminal$ChoosePositionOnWall;", depth))
}
var $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall: 0
}, false, "reactbuild.project.drawing.tool.PlaceNetworkTerminal$ChoosePositionOnWall", {
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall: 1,
  O: 1,
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal: 1,
  Lreactbuild_project_drawing_ViewportTool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall.prototype.$classData = $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall;
function $p_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__findNearestWall$1__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__I__sci_List__I__s_Option__Lreactbuild_geom_Point2Based__D__Lreactbuild_math_package$EagerSquareRoot__s_Option($thiz, parent, geometry, shapes, shapeIndex, pointList, wallIndex, candidate, position$1, distanceMaxAtScale$1, distanceMaxAtScaleSq$1) {
  while (true) {
    var x1 = pointList;
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x2 = $as_sci_$colon$colon(x1);
      var a = $as_Lreactbuild_geom_Point2($n(x2).sci_$colon$colon__f_head);
      var tail = $n(x2).sci_$colon$colon__f_next;
      if ((tail instanceof $c_sci_$colon$colon)) {
        var x3 = $as_sci_$colon$colon(tail);
        var b = $as_Lreactbuild_geom_Point2($n(x3).sci_$colon$colon__f_head);
        if ((!$m_Lreactbuild_geom_Bounds2$().isNear__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Point2Based__D__Z(position$1, a, b, distanceMaxAtScale$1))) {
          var updatedCandidate = candidate
        } else {
          var this$1 = $n(b);
          var vec = new $c_Lreactbuild_geom_Vector2((this$1.Lreactbuild_geom_Point2__f_x - $n(a).Lreactbuild_geom_Point2__f_x), (this$1.Lreactbuild_geom_Point2__f_y - $n(a).Lreactbuild_geom_Point2__f_y));
          var this$2 = $n(position$1);
          var p = $m_Lreactbuild_geom_Point2$().projectToLineParameter__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Point2Based__Lreactbuild_geom_Vector2Based__Z__D(this$2, a, vec, true);
          var this$3 = $n(((p === 1.0) ? vec : new $c_Lreactbuild_geom_Vector2((vec.Lreactbuild_geom_Vector2__f_x * p), (vec.Lreactbuild_geom_Vector2__f_y * p))));
          var projection = new $c_Lreactbuild_geom_Point2((this$3.Lreactbuild_geom_Vector2__f_x + $n(a).Lreactbuild_geom_Point2__f_x), (this$3.Lreactbuild_geom_Vector2__f_y + $n(a).Lreactbuild_geom_Point2__f_y));
          var projVec = new $c_Lreactbuild_geom_Vector2((projection.Lreactbuild_geom_Point2__f_x - $n(position$1).x__D()), (projection.Lreactbuild_geom_Point2__f_y - $n(position$1).y__D()));
          if ((projVec.Lreactbuild_geom_Vector2__f_x === 0.0)) {
            $m_Lreactbuild_math_package$SquareRoot$();
            var x = projVec.Lreactbuild_geom_Vector2__f_y;
            var length = $uD(Math.abs(x));
            var sq = (length * length);
            var sqrt = $uD(Math.abs(length));
            var distanceToLine = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt)
          } else if ((projVec.Lreactbuild_geom_Vector2__f_y === 0.0)) {
            $m_Lreactbuild_math_package$SquareRoot$();
            var x$1 = projVec.Lreactbuild_geom_Vector2__f_x;
            var length$1 = $uD(Math.abs(x$1));
            var sq$1 = (length$1 * length$1);
            var sqrt$1 = $uD(Math.abs(length$1));
            var distanceToLine = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$1, sqrt$1)
          } else {
            $m_Lreactbuild_math_package$SquareRoot$();
            var v = projVec.Lreactbuild_geom_Vector2__f_x;
            var v$1 = projVec.Lreactbuild_geom_Vector2__f_y;
            var value = ((v * v) + (v$1 * v$1));
            var distanceToLine = new $c_Lreactbuild_math_package$LazySquareRoot(value)
          };
          var this$29 = $n(distanceToLine);
          if ((this$29.sq__D() > $n(distanceMaxAtScaleSq$1).Lreactbuild_math_package$EagerSquareRoot__f_sq)) {
            var updatedCandidate = candidate
          } else {
            var this$32 = $n(geometry);
            var wallIndex$1 = wallIndex;
            var wallIndex$3 = wallIndex;
            var g = new $c_sjsr_AnonFunction1(((wallIndex$2) => ((v$2) => {
              var v$3 = $as_Lreactbuild_format_iz2use_package$Side(v$2);
              return new $c_sjsr_AnonFunction1(((s$2) => {
                var s = $as_Lreactbuild_format_iz2use_package$GenerateGeometry(s$2);
                var $$x1 = $n(s);
                var this$31 = $n($n(s).sides__sci_List());
                var this$30 = $n($m_s_package$().s_package$__f_Nil);
                var other = new $c_sci_$colon$colon(v$3, this$30);
                return $n($$x1).withSides__sci_List__Lreactbuild_format_iz2use_package$GenerateGeometry($as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$31, wallIndex$2, other, 1)))
              }))
            }))(wallIndex$3));
            var g$1 = new $c_sjsr_AnonFunction1(((this$32, g) => ((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$32.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)))(this$32, g));
            var arg1 = this$32.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
            var x$1$1 = $as_Lreactbuild_format_iz2use_package$GenerateGeometry(arg1);
            var this$33 = $n($n(x$1$1).sides__sci_List());
            var side = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$32, $as_Lreactbuild_format_iz2use_package$Side($f_sc_LinearSeqOps__apply__I__O(this$33, wallIndex$1)), new $c_sjsr_AnonFunction2(((this$32, g$1) => ((ot$2, cb$2) => {
              var ot = $as_s_Option(ot$2);
              var $$x2 = $n($as_F2($n(this$32.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
              var this$34 = $n(ot);
              return $n($$x2).apply__O__O__O((this$34.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$34.get__O()))), cb$2)
            }))(this$32, g$1)));
            var this$35 = $n(candidate);
            if (this$35.isEmpty__Z()) {
              var $$x3 = true
            } else {
              var arg1$1 = this$35.get__O();
              var x$2 = $as_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(arg1$1);
              var this$36 = $n($n(x$2).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_distance);
              var $$x3 = (this$36.sq__D() <= $n(distanceToLine).sq__D())
            };
            var this$37 = $n(($$x3 ? this$35 : $m_s_None$()));
            var geometry$1 = geometry;
            var wallIndex$4 = wallIndex;
            if (this$37.isEmpty__Z()) {
              var $$x4 = $m_s_Option$();
              $m_Lreactbuild_math_package$SquareRoot$();
              if ((vec.Lreactbuild_geom_Vector2__f_x === 0.0)) {
                $m_Lreactbuild_math_package$SquareRoot$();
                var x$3 = vec.Lreactbuild_geom_Vector2__f_y;
                var length$2 = $uD(Math.abs(x$3));
                var sq$2 = (length$2 * length$2);
                var sqrt$2 = $uD(Math.abs(length$2));
                var sqrt$4 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$2, sqrt$2)
              } else if ((vec.Lreactbuild_geom_Vector2__f_y === 0.0)) {
                $m_Lreactbuild_math_package$SquareRoot$();
                var x$4 = vec.Lreactbuild_geom_Vector2__f_x;
                var length$3 = $uD(Math.abs(x$4));
                var sq$3 = (length$3 * length$3);
                var sqrt$3 = $uD(Math.abs(length$3));
                var sqrt$4 = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$3, sqrt$3)
              } else {
                $m_Lreactbuild_math_package$SquareRoot$();
                var v$4 = vec.Lreactbuild_geom_Vector2__f_x;
                var v$5 = vec.Lreactbuild_geom_Vector2__f_y;
                var value$1 = ((v$4 * v$4) + (v$5 * v$5));
                var sqrt$4 = new $c_Lreactbuild_math_package$LazySquareRoot(value$1)
              };
              var updatedCandidate = $n($$x4).apply__O__s_Option(new $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(distanceToLine, projection, geometry$1, side, a, b, vec, wallIndex$4, (p * $n(sqrt$4).sqrt__D())))
            } else {
              var updatedCandidate = this$37
            }
          }
        };
        var temp$wallIndex = ((1 + wallIndex) | 0);
        pointList = x3;
        wallIndex = temp$wallIndex;
        candidate = updatedCandidate;
        continue
      }
    };
    var x1$2 = shapes;
    if ((x1$2 instanceof $c_sci_$colon$colon)) {
      var x2$2 = $as_sci_$colon$colon(x1$2);
      var tail$2 = $n(x2$2).sci_$colon$colon__f_next;
      var this$69 = $n(parent);
      var shapeIndex$1 = shapeIndex;
      var shapeIndex$3 = shapeIndex;
      var g$2 = new $c_sjsr_AnonFunction1(((shapeIndex$2) => ((v$3$2) => {
        var v$3$1 = $as_Lreactbuild_format_iz2use_package$Room(v$3$2);
        return new $c_sjsr_AnonFunction1(((s$2$1) => {
          var s$1 = $as_Lreactbuild_format_iz2use_package$Storey(s$2$1);
          var this$65 = $n($n(s$1).Lreactbuild_format_iz2use_package$Storey__f_rooms);
          var this$64 = $n($m_s_package$().s_package$__f_Nil);
          var other$1 = new $c_sci_$colon$colon(v$3$1, this$64);
          var x$1$3 = $as_sci_List($f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this$65, shapeIndex$2, other$1, 1));
          var this$66 = $n(s$1);
          var x$2$1 = this$66.Lreactbuild_format_iz2use_package$Storey__f_sides;
          var this$67 = $n(s$1);
          var x$3$1 = this$67.Lreactbuild_format_iz2use_package$Storey__f_roofs;
          $n(s$1);
          return new $c_Lreactbuild_format_iz2use_package$Storey(x$2$1, x$1$3, x$3$1)
        }))
      }))(shapeIndex$3));
      var g$3 = new $c_sjsr_AnonFunction1(((this$69, g$2) => ((x$1$2$1) => $n($as_F1(g$2.apply__O__O(x$1$2$1))).apply__O__O(this$69.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)))(this$69, g$2));
      var arg1$2 = this$69.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
      var x$3$2 = $as_Lreactbuild_format_iz2use_package$Storey(arg1$2);
      var this$70 = $n($n(x$3$2).Lreactbuild_format_iz2use_package$Storey__f_rooms);
      var nextGeometry = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$69, $as_Lreactbuild_format_iz2use_package$Room($f_sc_LinearSeqOps__apply__I__O(this$70, shapeIndex$1)), new $c_sjsr_AnonFunction2(((this$69, g$3) => ((ot$2$1, cb$2$1) => {
        var ot$1 = $as_s_Option(ot$2$1);
        var $$x5 = $n($as_F2($n(this$69.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
        var this$71 = $n(ot$1);
        return $n($$x5).apply__O__O__O((this$71.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$3.apply__O__O(this$71.get__O()))), cb$2$1)
      }))(this$69, g$3)));
      var temp$shapeIndex = ((1 + shapeIndex) | 0);
      var temp$pointList$2 = $n($as_Lreactbuild_format_iz2use_package$GenerateGeometry($n(nextGeometry).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).shape__sci_List();
      geometry = nextGeometry;
      shapes = tail$2;
      shapeIndex = temp$shapeIndex;
      pointList = temp$pointList$2;
      wallIndex = 0
    } else {
      var x$5 = $m_s_package$().s_package$__f_Nil;
      if (((x$5 === null) ? (x1$2 === null) : $n(x$5).equals__O__Z(x1$2))) {
        return candidate
      } else {
        throw new $c_s_MatchError(x1$2)
      }
    }
  }
}
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall(position, activePointer, pointer, activeWall) {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_position = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activePointer = 0.0;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_pointer = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activeWall = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_name = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_icon = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_position = position;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activePointer = activePointer;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_pointer = pointer;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activeWall = activeWall;
  $f_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal__$init$__V(this)
}
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.constructor = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype;
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_name
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_icon
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.reactbuild$project$drawing$tool$PlaceNetworkTerminal$_setter_$name_$eq__T__V = (function(x$1) {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_name = x$1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.reactbuild$project$drawing$tool$PlaceNetworkTerminal$_setter_$icon_$eq__T__V = (function(x$1) {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_icon = x$1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.renderInViewport__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(context) {
  var this$1 = $n(this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activeWall);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
  } else {
    var arg1 = this$1.get__O();
    var result = $as_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(arg1);
    $n($m_s_package$().s_package$__f_List);
    var array = [$n(result).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallEnd, $n(result).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_wallOrigin];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$50 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
    var f = ((pt$2) => {
      var pt = $as_Lreactbuild_geom_Point2Based(pt$2);
      var this$7 = $n($n(result).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_projectedPoint);
      var vec = new $c_Lreactbuild_geom_Vector2((this$7.x__D() - $n(pt).x__D()), (this$7.y__D() - $n(pt).y__D()));
      var this$8 = $n(pt);
      var other = new $c_Lreactbuild_geom_Vector2((vec.Lreactbuild_geom_Vector2__f_x / 2.0), (vec.Lreactbuild_geom_Vector2__f_y / 2.0));
      var middle = new $c_Lreactbuild_geom_Vector2((this$8.x__D() + other.Lreactbuild_geom_Vector2__f_x), (this$8.y__D() + other.Lreactbuild_geom_Vector2__f_y));
      if ((vec.Lreactbuild_geom_Vector2__f_x === 0.0)) {
        $m_Lreactbuild_math_package$SquareRoot$();
        var x = vec.Lreactbuild_geom_Vector2__f_y;
        var length = $uD(Math.abs(x));
        var sq = (length * length);
        var sqrt = $uD(Math.abs(length));
        var distance = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt)
      } else if ((vec.Lreactbuild_geom_Vector2__f_y === 0.0)) {
        $m_Lreactbuild_math_package$SquareRoot$();
        var x$1 = vec.Lreactbuild_geom_Vector2__f_x;
        var length$1 = $uD(Math.abs(x$1));
        var sq$1 = (length$1 * length$1);
        var sqrt$1 = $uD(Math.abs(length$1));
        var distance = new $c_Lreactbuild_math_package$EagerSquareRoot(sq$1, sqrt$1)
      } else {
        $m_Lreactbuild_math_package$SquareRoot$();
        var v = vec.Lreactbuild_geom_Vector2__f_x;
        var v$1 = vec.Lreactbuild_geom_Vector2__f_y;
        var value = ((v * v) + (v$1 * v$1));
        var distance = new $c_Lreactbuild_math_package$LazySquareRoot(value)
      };
      var $$x5 = $m_Ljapgolly_scalajs_react_vdom_SvgTagOf$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$38 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "transform");
      var this$37 = $n(context);
      var a = (("translate(" + this$37.apply__D__D__T(middle.Lreactbuild_geom_Vector2__f_x, middle.Lreactbuild_geom_Vector2__f_y)) + ")");
      var t = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x4 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t, this$38.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, a);
      $m_Ljapgolly_scalajs_react_vdom_all$svg$();
      $n($m_Ljapgolly_scalajs_react_vdom_PackageBase$().Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr);
      var this$41 = $ct_Ljapgolly_scalajs_react_vdom_Attr$Generic__T__(new $c_Ljapgolly_scalajs_react_vdom_Attr$Generic(), "textAnchor");
      var t$1 = $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString;
      var $$x3 = $m_Ljapgolly_scalajs_react_vdom_Attr$ValueType$().apply$extension__F2__T__O__Ljapgolly_scalajs_react_vdom_TagMod(t$1, this$41.Ljapgolly_scalajs_react_vdom_Attr__f_attrName, "middle");
      $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$();
      var $$x2 = $m_sc_StringOps$();
      var array$1 = [$n(distance).sqrt__D()];
      var v$2 = $n($$x2).format$extension__T__sci_Seq__T("%.0f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      $m_Ljapgolly_scalajs_react_vdom_VdomNode$();
      var array$2 = [$$x4, $$x3, new $c_Ljapgolly_scalajs_react_vdom_VdomNode$$anon$1(v$2)];
      return $n($$x5).apply$extension__T__sci_Seq__Ljapgolly_scalajs_react_vdom_TagOf("text", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
    });
    if ((this$50 === $m_sci_Nil$())) {
      var text = $m_sci_Nil$()
    } else {
      var arg1$1 = this$50.head__O();
      var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      var t$2 = h;
      var rest = $as_sci_List(this$50.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$2 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
        $n(t$2).sci_$colon$colon__f_next = nx;
        t$2 = nx;
        rest = $as_sci_List($n(rest).tail__O())
      };
      var text = h
    };
    var this$55 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var $$x6 = $m_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$().highlightWall__Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__Lreactbuild_geom_Point2Based__s_Option__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomElement(result, this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_position, new $c_s_Some($n(result).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall__f_projectedPoint), context);
    var this$51 = $n($m_Ljapgolly_scalajs_react_React$().Ljapgolly_scalajs_react_React$__f_Fragment);
    var array$3 = [$$x6, $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$51, null, text)];
    var ns = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    var $$x1 = $p_Ljapgolly_scalajs_react_feature_ReactFragment$__create__sjs_js_Object__sci_Seq__Ljapgolly_scalajs_react_vdom_VdomElement(this$55, null, ns)
  };
  return $as_Ljapgolly_scalajs_react_vdom_VdomNode($$x1)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.handleViewportEvent__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  var f = ((ev$2$2) => {
    var ev$2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev$2$2);
    var x1 = $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var x = $m_Lreactbuild_common_components_Input$Start$();
    if ((x === x1)) {
      var $$x1 = true
    } else {
      var x$3 = $m_Lreactbuild_common_components_Input$Move$();
      var $$x1 = (x$3 === x1)
    };
    if (($$x1 && ($n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_id === this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activePointer))) {
      return new $c_Lreactbuild_common_components_Continue(new $c_s_Some(this.withPosition__Lreactbuild_geom_Point2Based__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall($as_Lreactbuild_geom_Point2Based($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition).apply__O__O($n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_coords)), context)), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      var x$5 = $m_Lreactbuild_common_components_Input$End$();
      if (((x$5 === x1) && ($n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_id === this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activePointer))) {
        var this$3 = $n($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activeWall)).headOption__s_Option());
        if (this$3.isEmpty__Z()) {
          var $$x2 = $m_Lreactbuild_common_components_Skip$()
        } else {
          var arg1 = this$3.get__O();
          var wall = $as_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$FoundWall(arg1);
          var qual$1 = new $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall(wall, this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_position, $m_s_None$());
          var x$1 = qual$1.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall__f_position;
          var $$x2 = new $c_Lreactbuild_common_components_Continue(new $c_s_Some(qual$1.withPosition__Lreactbuild_geom_Point2Based__Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChoosePositionOnWall(x$1)), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
        };
        return $as_Lreactbuild_common_components_InteractionResult($$x2)
      } else {
        return $m_Lreactbuild_common_components_Skip$()
      }
    }
  });
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var way = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var coords = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_coords;
    var p3 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_isPrimary;
    var button = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_button;
    var p8 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
    if ((p3 === true)) {
      var x$2 = $m_Lreactbuild_common_components_Input$ModifierKey$None$();
      var $$x3 = (x$2 === p8)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$3$1 = $m_Lreactbuild_common_components_Input$Start$();
      if ((x$3$1 === way)) {
        var x$6 = $m_Lreactbuild_common_components_Input$Left$();
        if ((button !== null)) {
          var this$7 = $n(button);
          var $$x4 = (this$7 === x$6)
        } else {
          var $$x4 = false
        }
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        return $as_Lreactbuild_common_components_InteractionResult(f(x2))
      } else {
        var x$7 = $m_Lreactbuild_common_components_Input$Move$();
        if ((x$7 === way)) {
          var x$9 = $n(coords).Lreactbuild_common_components_Input$Coords__f_cursor;
          var x$10 = $m_Lreactbuild_common_components_Input$Touch$();
          if ((x$9 !== null)) {
            var this$8 = $n(x$9);
            var $$x6 = (this$8 === x$10)
          } else {
            var $$x6 = false
          };
          if ((!$$x6)) {
            var $$x5 = true
          } else {
            var $$x5 = ($n(trackedPointers).count__Lreactbuild_common_components_Input$CursorType__I($n(coords).Lreactbuild_common_components_Input$Coords__f_cursor) === 1)
          }
        } else {
          var $$x5 = false
        };
        if ($$x5) {
          return $as_Lreactbuild_common_components_InteractionResult(f(x2))
        } else {
          var x$11 = $m_Lreactbuild_common_components_Input$End$();
          if ((x$11 === way)) {
            return $as_Lreactbuild_common_components_InteractionResult(f(x2))
          } else {
            return $m_Lreactbuild_common_components_Skip$()
          }
        }
      }
    }
  };
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.withPosition__Lreactbuild_geom_Point2Based__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall = (function(position, context) {
  var distanceMax = $n(this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_pointer).Lreactbuild_common_components_Input$CursorType__f_precision;
  var distanceMaxAtScale = (distanceMax / $n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_scale);
  $m_Lreactbuild_math_package$SquareRoot$();
  var sq = (distanceMaxAtScale * distanceMaxAtScale);
  var sqrt = $uD(Math.abs(distanceMaxAtScale));
  var distanceMaxAtScaleSq = new $c_Lreactbuild_math_package$EagerSquareRoot(sq, sqrt);
  var this$7 = $n($n($n($n($as_Lreactbuild_format_iz2use_package$Building($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_building).Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)).Lreactbuild_format_iz2use_package$Building__f_storeys).take__I__sci_List(1)).headOption__s_Option());
  if (this$7.isEmpty__Z()) {
    var wallOpt = $m_s_None$()
  } else {
    var arg1 = this$7.get__O();
    var storey = $as_Lreactbuild_format_iz2use_package$Storey(arg1);
    var this$13 = $n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_building);
    var g = new $c_sjsr_AnonFunction1(((v$2) => {
      var v = $as_Lreactbuild_format_iz2use_package$Storey(v$2);
      return new $c_sjsr_AnonFunction1(((s$2) => {
        var s = $as_Lreactbuild_format_iz2use_package$Building(s$2);
        var this$8 = $n($as_sci_List($n($n(s).Lreactbuild_format_iz2use_package$Building__f_storeys).tail__O()));
        var x$1 = new $c_sci_$colon$colon(v, this$8);
        var this$9 = $n(s);
        var x$2 = this$9.Lreactbuild_format_iz2use_package$Building__f_name;
        var this$10 = $n(s);
        var x$3 = this$10.Lreactbuild_format_iz2use_package$Building__f_description;
        var this$11 = $n(s);
        var x$4 = this$11.Lreactbuild_format_iz2use_package$Building__f_settings;
        $n(s);
        return new $c_Lreactbuild_format_iz2use_package$Building(x$2, x$3, x$4, x$1)
      }))
    }));
    var g$1 = new $c_sjsr_AnonFunction1(((x$1$2) => $n($as_F1(g.apply__O__O(x$1$2))).apply__O__O(this$13.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value)));
    var arg1$1 = this$13.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_value;
    var x$4$1 = $as_Lreactbuild_format_iz2use_package$Building(arg1$1);
    var storeyState = $p_Ljapgolly_scalajs_react_extra_StateSnapshotF__copyWithoutReuse__O__F2__Ljapgolly_scalajs_react_extra_StateSnapshotF(this$13, $as_Lreactbuild_format_iz2use_package$Storey($n($n(x$4$1).Lreactbuild_format_iz2use_package$Building__f_storeys).head__O()), new $c_sjsr_AnonFunction2(((ot$2, cb$2) => {
      var ot = $as_s_Option(ot$2);
      var $$x1 = $n($as_F2($n(this$13.Ljapgolly_scalajs_react_extra_StateSnapshotF__f_underlyingSetFn).value__O()));
      var this$14 = $n(ot);
      return $n($$x1).apply__O__O__O((this$14.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(g$1.apply__O__O(this$14.get__O()))), cb$2)
    })));
    var wallOpt = $p_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__findNearestWall$1__Ljapgolly_scalajs_react_extra_StateSnapshotF__Ljapgolly_scalajs_react_extra_StateSnapshotF__sci_List__I__sci_List__I__s_Option__Lreactbuild_geom_Point2Based__D__Lreactbuild_math_package$EagerSquareRoot__s_Option(this, storeyState, storeyState, $n(storey).Lreactbuild_format_iz2use_package$Storey__f_rooms, 0, $n(storey).shape__sci_List(), 0, $m_s_None$(), position, distanceMaxAtScale, distanceMaxAtScaleSq)
  };
  var x$7 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activePointer;
  var x$8 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_pointer;
  return new $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall(position, x$7, x$8, wallOpt)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.productPrefix__T = (function() {
  return "ChooseWall"
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.productArity__I = (function() {
  return 4
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_position;
      break
    }
    case 1: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activePointer;
      break
    }
    case 2: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_pointer;
      break
    }
    case 3: {
      return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activeWall;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ChooseWall");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_position;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var dv = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activePointer;
  var data$2 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_pointer;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activeWall;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall)) {
    var ChooseWall$1 = $as_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall(x$1);
    if ((this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activePointer === $n(ChooseWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activePointer)) {
      var x = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_position;
      var x$2 = $n(ChooseWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_position;
      var $$x1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_pointer;
      var x$4 = $n(ChooseWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_pointer;
      if ((x$3 === null)) {
        var $$x2 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x2 = (this$1 === x$4)
      };
      if ($$x2) {
        var x$5 = this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activeWall;
        var x$6 = $n(ChooseWall$1).Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_activeWall;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall(obj) {
  return (((obj instanceof $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.drawing.tool.PlaceNetworkTerminal$ChooseWall"))
}
function $isArrayOf_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall)))
}
function $asArrayOf_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.drawing.tool.PlaceNetworkTerminal$ChooseWall;", depth))
}
var $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall: 0
}, false, "reactbuild.project.drawing.tool.PlaceNetworkTerminal$ChooseWall", {
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall: 1,
  O: 1,
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal: 1,
  Lreactbuild_project_drawing_ViewportTool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall.prototype.$classData = $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall;
/** @constructor */
function $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$() {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$__f_name = null;
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$__f_icon = null;
  $n_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$ = this;
  $f_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal__$init$__V(this)
}
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype = new $h_O();
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.constructor = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$;
/** @constructor */
function $h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$() {
  /*<skip>*/
}
$h_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype = $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype;
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.name__T = (function() {
  return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$__f_name
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.icon__T = (function() {
  return this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$__f_icon
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.reactbuild$project$drawing$tool$PlaceNetworkTerminal$_setter_$name_$eq__T__V = (function(x$1) {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$__f_name = x$1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.reactbuild$project$drawing$tool$PlaceNetworkTerminal$_setter_$icon_$eq__T__V = (function(x$1) {
  this.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$__f_icon = x$1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.renderInViewport__Lreactbuild_project_drawing_DrawingContext__Ljapgolly_scalajs_react_vdom_VdomNode = (function(context) {
  return $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$().Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.handleViewportEvent__Lreactbuild_common_components_Input$Event__Lreactbuild_common_components_TrackedPointers__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_common_components_InteractionResult = (function(ev, trackedPointers, context) {
  var f = ((ev$2$2) => {
    var ev$2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev$2$2);
    var x = $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var x$2 = $m_Lreactbuild_common_components_Input$Start$();
    if ((x !== null)) {
      var this$2 = $n(x);
      var $$x2 = (this$2 === x$2)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var $$x1 = true
    } else {
      var x$3 = $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_status;
      var x$4 = $m_Lreactbuild_common_components_Input$Move$();
      if ((x$3 !== null)) {
        var this$3 = $n(x$3);
        var $$x4 = (this$3 === x$4)
      } else {
        var $$x4 = false
      };
      if ($$x4) {
        var x$5 = $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_buttons;
        var x$6 = $m_s_package$().s_package$__f_Nil;
        var $$x3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        var x$7 = $n($n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_coords).Lreactbuild_common_components_Input$Coords__f_cursor;
        var x$8 = $m_Lreactbuild_common_components_Input$Touch$();
        if ((x$7 !== null)) {
          var this$4 = $n(x$7);
          var $$x5 = (this$4 === x$8)
        } else {
          var $$x5 = false
        };
        var $$x1 = (!$$x5)
      } else {
        var $$x1 = false
      }
    };
    if ($$x1) {
      var qual$1 = new $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall($as_Lreactbuild_geom_Point2Based($n($n(context).Lreactbuild_project_drawing_DrawingContextImpl__f_realPosition).apply__O__O($n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_coords)), $n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_id, $n($n(ev$2).Lreactbuild_common_components_Input$PointerEvent__f_coords).Lreactbuild_common_components_Input$Coords__f_cursor, $m_s_None$());
      var x$1 = qual$1.Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall__f_position;
      return new $c_Lreactbuild_common_components_Continue(new $c_s_Some(qual$1.withPosition__Lreactbuild_geom_Point2Based__Lreactbuild_project_drawing_DrawingContext__Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$ChooseWall(x$1, context)), $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback).Ljapgolly_scalajs_react_callback_Callback$__f_empty)
    } else {
      return $m_Lreactbuild_common_components_Skip$()
    }
  });
  if ((ev instanceof $c_Lreactbuild_common_components_Input$PointerEvent)) {
    var x2 = $as_Lreactbuild_common_components_Input$PointerEvent(ev);
    var way = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_status;
    var coords = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_coords;
    var p3 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_isPrimary;
    var button = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_button;
    var p8 = $n(x2).Lreactbuild_common_components_Input$PointerEvent__f_modifiers;
    if ((p3 === true)) {
      var x$9 = $m_Lreactbuild_common_components_Input$ModifierKey$None$();
      var $$x6 = (x$9 === p8)
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$3$1 = $m_Lreactbuild_common_components_Input$Start$();
      if ((x$3$1 === way)) {
        var x$6$1 = $m_Lreactbuild_common_components_Input$Left$();
        if ((button !== null)) {
          var this$8 = $n(button);
          var $$x7 = (this$8 === x$6$1)
        } else {
          var $$x7 = false
        }
      } else {
        var $$x7 = false
      };
      if ($$x7) {
        return $as_Lreactbuild_common_components_InteractionResult(f(x2))
      } else {
        var x$7$1 = $m_Lreactbuild_common_components_Input$Move$();
        if ((x$7$1 === way)) {
          var x$9$1 = $n(coords).Lreactbuild_common_components_Input$Coords__f_cursor;
          var x$10 = $m_Lreactbuild_common_components_Input$Touch$();
          if ((x$9$1 !== null)) {
            var this$9 = $n(x$9$1);
            var $$x9 = (this$9 === x$10)
          } else {
            var $$x9 = false
          };
          if ((!$$x9)) {
            var $$x8 = true
          } else {
            var $$x8 = ($n(trackedPointers).count__Lreactbuild_common_components_Input$CursorType__I($n(coords).Lreactbuild_common_components_Input$Coords__f_cursor) === 1)
          }
        } else {
          var $$x8 = false
        };
        if ($$x8) {
          return $as_Lreactbuild_common_components_InteractionResult(f(x2))
        } else {
          var x$11 = $m_Lreactbuild_common_components_Input$End$();
          if ((x$11 === way)) {
            return $as_Lreactbuild_common_components_InteractionResult(f(x2))
          } else {
            return $m_Lreactbuild_common_components_Skip$()
          }
        }
      }
    }
  };
  return $m_Lreactbuild_common_components_Skip$()
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.productPrefix__T = (function() {
  return "Idle"
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.hashCode__I = (function() {
  return 2274292
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.toString__T = (function() {
  return "Idle"
});
var $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$ = new $TypeData().initClass({
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$: 0
}, false, "reactbuild.project.drawing.tool.PlaceNetworkTerminal$Idle$", {
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$: 1,
  O: 1,
  Lreactbuild_project_drawing_tool_PlaceNetworkTerminal: 1,
  Lreactbuild_project_drawing_ViewportTool: 1,
  Lreactbuild_project_drawing_Tool: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$.prototype.$classData = $d_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$;
var $n_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$;
function $m_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$() {
  if ((!$n_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$)) {
    $n_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$ = new $c_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$()
  };
  return $n_Lreactbuild_project_drawing_tool_PlaceNetworkTerminal$Idle$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$() {
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_colors = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_LineWireColor__I__T__I__(this, 1, "#000000", 78)
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_LineWireColor();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype.productPrefix__T = (function() {
  return "Black"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype.hashCode__I = (function() {
  return 64266207
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype.toString__T = (function() {
  return "Black"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$Black$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$Black$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$Black$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$Black$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$Black$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$Black$: 1,
  Lreactbuild_project_generator_electricalboard_model_LineWireColor: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$() {
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_colors = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__I__T__I__(this, 0, "#0d47a1", 66)
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype.productPrefix__T = (function() {
  return "Blue"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype.hashCode__I = (function() {
  return 2073722
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype.toString__T = (function() {
  return "Blue"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$Blue$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$Blue$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$Blue$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$: 1,
  Lreactbuild_project_generator_electricalboard_model_NeutralWireColor: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$() {
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_colors = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_LineWireColor__I__T__I__(this, 2, "#795548", 77)
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_LineWireColor();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype.productPrefix__T = (function() {
  return "Brown"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype.hashCode__I = (function() {
  return 64459030
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype.toString__T = (function() {
  return "Brown"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$Brown$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$Brown$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$Brown$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$: 1,
  Lreactbuild_project_generator_electricalboard_model_LineWireColor: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$() {
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_colors = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_LineWireColor__I__T__I__(this, 3, "#9e9e9e", 71)
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_LineWireColor();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype.productPrefix__T = (function() {
  return "Gray"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype.hashCode__I = (function() {
  return 2227843
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype.toString__T = (function() {
  return "Gray"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$Gray$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$Gray$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$Gray$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$: 1,
  Lreactbuild_project_generator_electricalboard_model_LineWireColor: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$() {
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__f_colors = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor__I__T__I__(this, 1, "#03a9f4", 67)
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_NeutralWireColor();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype.productPrefix__T = (function() {
  return "LightBlue"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype.hashCode__I = (function() {
  return (-1605861776)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype.toString__T = (function() {
  return "LightBlue"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$LightBlue$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$LightBlue$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$LightBlue$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$: 1,
  Lreactbuild_project_generator_electricalboard_model_NeutralWireColor: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$() {
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_colors = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__I__T__I__(this, 0, "#ff5722", 79)
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype.productPrefix__T = (function() {
  return "Orange"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype.hashCode__I = (function() {
  return (-1924984242)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype.toString__T = (function() {
  return "Orange"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$Orange$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$Orange$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$Orange$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$: 1,
  Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$() {
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_LineWireColor__f_colors = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_LineWireColor__I__T__I__(this, 0, "#f44336", 82)
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_LineWireColor();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype.productPrefix__T = (function() {
  return "Red"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype.hashCode__I = (function() {
  return 82033
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype.toString__T = (function() {
  return "Red"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$Red$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$Red$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$Red$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$Red$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$Red$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$Red$: 1,
  Lreactbuild_project_generator_electricalboard_model_LineWireColor: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$() {
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_colors = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__I__T__I__(this, 1, "#673ab7", 86)
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype.productPrefix__T = (function() {
  return "Violet"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype.hashCode__I = (function() {
  return (-1732476769)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype.toString__T = (function() {
  return "Violet"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$Violet$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$Violet$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$Violet$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$: 1,
  Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$
}
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$() {
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_order = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_color = null;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_keycode = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_mainOrder = 0;
  this.Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__f_colors = null;
  $ct_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor__I__T__I__(this, 2, "#fff9c4", 87)
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype = new $h_Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$White$() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype.productPrefix__T = (function() {
  return "White"
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype.hashCode__I = (function() {
  return 83549193
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype.toString__T = (function() {
  return "White"
});
function $as_Lreactbuild_project_generator_electricalboard_model_WireColor$White$(obj) {
  return (((obj instanceof $c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.generator.electricalboard.model.WireColor$White$"))
}
function $isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$White$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_generator_electricalboard_model_WireColor$White$)))
}
function $asArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$White$(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_generator_electricalboard_model_WireColor$White$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.generator.electricalboard.model.WireColor$White$;", depth))
}
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$White$ = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$White$: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$White$", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$White$: 1,
  Lreactbuild_project_generator_electricalboard_model_OtherLineWireColor: 1,
  O: 1,
  Lreactbuild_project_generator_electricalboard_model_SingleColorWireColor: 1,
  Lreactbuild_project_generator_electricalboard_model_WireColor: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$White$;
var $n_Lreactbuild_project_generator_electricalboard_model_WireColor$White$;
function $m_Lreactbuild_project_generator_electricalboard_model_WireColor$White$() {
  if ((!$n_Lreactbuild_project_generator_electricalboard_model_WireColor$White$)) {
    $n_Lreactbuild_project_generator_electricalboard_model_WireColor$White$ = new $c_Lreactbuild_project_generator_electricalboard_model_WireColor$White$()
  };
  return $n_Lreactbuild_project_generator_electricalboard_model_WireColor$White$
}
/** @constructor */
function $c_Lreactbuild_project_notebook_OptionType(tpe) {
  this.Lreactbuild_project_notebook_OptionType__f_tpe = null;
  this.Lreactbuild_project_notebook_OptionType__f_tpe = tpe
}
$c_Lreactbuild_project_notebook_OptionType.prototype = new $h_O();
$c_Lreactbuild_project_notebook_OptionType.prototype.constructor = $c_Lreactbuild_project_notebook_OptionType;
/** @constructor */
function $h_Lreactbuild_project_notebook_OptionType() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_OptionType.prototype = $c_Lreactbuild_project_notebook_OptionType.prototype;
$c_Lreactbuild_project_notebook_OptionType.prototype.productPrefix__T = (function() {
  return "OptionType"
});
$c_Lreactbuild_project_notebook_OptionType.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_notebook_OptionType.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_notebook_OptionType__f_tpe : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_notebook_OptionType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_OptionType.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_OptionType.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_OptionType.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_OptionType)) {
    var OptionType$1 = $as_Lreactbuild_project_notebook_OptionType(x$1);
    var x = this.Lreactbuild_project_notebook_OptionType__f_tpe;
    var x$2 = $n(OptionType$1).Lreactbuild_project_notebook_OptionType__f_tpe;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_OptionType(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_OptionType) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.OptionType"))
}
function $isArrayOf_Lreactbuild_project_notebook_OptionType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_OptionType)))
}
function $asArrayOf_Lreactbuild_project_notebook_OptionType(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_OptionType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.OptionType;", depth))
}
var $d_Lreactbuild_project_notebook_OptionType = new $TypeData().initClass({
  Lreactbuild_project_notebook_OptionType: 0
}, false, "reactbuild.project.notebook.OptionType", {
  Lreactbuild_project_notebook_OptionType: 1,
  O: 1,
  Lreactbuild_project_notebook_InputType$GenGeneric: 1,
  Lreactbuild_project_notebook_InputType$Generic: 1,
  Lreactbuild_project_notebook_InputType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_OptionType.prototype.$classData = $d_Lreactbuild_project_notebook_OptionType;
/** @constructor */
function $c_Lreactbuild_project_notebook_RefToType(tpe) {
  this.Lreactbuild_project_notebook_RefToType__f_tpe = null;
  this.Lreactbuild_project_notebook_RefToType__f_tpe = tpe
}
$c_Lreactbuild_project_notebook_RefToType.prototype = new $h_O();
$c_Lreactbuild_project_notebook_RefToType.prototype.constructor = $c_Lreactbuild_project_notebook_RefToType;
/** @constructor */
function $h_Lreactbuild_project_notebook_RefToType() {
  /*<skip>*/
}
$h_Lreactbuild_project_notebook_RefToType.prototype = $c_Lreactbuild_project_notebook_RefToType.prototype;
$c_Lreactbuild_project_notebook_RefToType.prototype.productPrefix__T = (function() {
  return "RefToType"
});
$c_Lreactbuild_project_notebook_RefToType.prototype.productArity__I = (function() {
  return 1
});
$c_Lreactbuild_project_notebook_RefToType.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lreactbuild_project_notebook_RefToType__f_tpe : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lreactbuild_project_notebook_RefToType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_project_notebook_RefToType.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_project_notebook_RefToType.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_project_notebook_RefToType.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lreactbuild_project_notebook_RefToType)) {
    var RefToType$1 = $as_Lreactbuild_project_notebook_RefToType(x$1);
    var x = this.Lreactbuild_project_notebook_RefToType__f_tpe;
    var x$2 = $n(RefToType$1).Lreactbuild_project_notebook_RefToType__f_tpe;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lreactbuild_project_notebook_RefToType(obj) {
  return (((obj instanceof $c_Lreactbuild_project_notebook_RefToType) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.project.notebook.RefToType"))
}
function $isArrayOf_Lreactbuild_project_notebook_RefToType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_project_notebook_RefToType)))
}
function $asArrayOf_Lreactbuild_project_notebook_RefToType(obj, depth) {
  return (($isArrayOf_Lreactbuild_project_notebook_RefToType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.project.notebook.RefToType;", depth))
}
var $d_Lreactbuild_project_notebook_RefToType = new $TypeData().initClass({
  Lreactbuild_project_notebook_RefToType: 0
}, false, "reactbuild.project.notebook.RefToType", {
  Lreactbuild_project_notebook_RefToType: 1,
  O: 1,
  Lreactbuild_project_notebook_InputType$GenGeneric: 1,
  Lreactbuild_project_notebook_InputType$Generic: 1,
  Lreactbuild_project_notebook_InputType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_project_notebook_RefToType.prototype.$classData = $d_Lreactbuild_project_notebook_RefToType;
/** @constructor */
function $c_T2$mcDD$sp(_1$mcD$sp, _2$mcD$sp) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2$mcDD$sp__f__1$mcD$sp = 0.0;
  this.T2$mcDD$sp__f__2$mcD$sp = 0.0;
  this.T2$mcDD$sp__f__1$mcD$sp = _1$mcD$sp;
  this.T2$mcDD$sp__f__2$mcD$sp = _2$mcD$sp;
  $ct_T2__O__O__(this, null, null)
}
$c_T2$mcDD$sp.prototype = new $h_T2();
$c_T2$mcDD$sp.prototype.constructor = $c_T2$mcDD$sp;
/** @constructor */
function $h_T2$mcDD$sp() {
  /*<skip>*/
}
$h_T2$mcDD$sp.prototype = $c_T2$mcDD$sp.prototype;
$c_T2$mcDD$sp.prototype._1$mcD$sp__D = (function() {
  return this.T2$mcDD$sp__f__1$mcD$sp
});
$c_T2$mcDD$sp.prototype._2$mcD$sp__D = (function() {
  return this.T2$mcDD$sp__f__2$mcD$sp
});
$c_T2$mcDD$sp.prototype.copy$default$2__O = (function() {
  return this.T2$mcDD$sp__f__2$mcD$sp
});
$c_T2$mcDD$sp.prototype._2__O = (function() {
  return this.T2$mcDD$sp__f__2$mcD$sp
});
$c_T2$mcDD$sp.prototype._1__O = (function() {
  return this.T2$mcDD$sp__f__1$mcD$sp
});
var $d_T2$mcDD$sp = new $TypeData().initClass({
  T2$mcDD$sp: 0
}, false, "scala.Tuple2$mcDD$sp", {
  T2$mcDD$sp: 1,
  T2: 1,
  O: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1,
  s_Product2$mcDD$sp: 1
});
$c_T2$mcDD$sp.prototype.$classData = $d_T2$mcDD$sp;
/** @constructor */
function $c_T2$mcID$sp(_1$mcI$sp, _2$mcD$sp) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2$mcID$sp__f__1$mcI$sp = 0;
  this.T2$mcID$sp__f__2$mcD$sp = 0.0;
  this.T2$mcID$sp__f__1$mcI$sp = _1$mcI$sp;
  this.T2$mcID$sp__f__2$mcD$sp = _2$mcD$sp;
  $ct_T2__O__O__(this, null, null)
}
$c_T2$mcID$sp.prototype = new $h_T2();
$c_T2$mcID$sp.prototype.constructor = $c_T2$mcID$sp;
/** @constructor */
function $h_T2$mcID$sp() {
  /*<skip>*/
}
$h_T2$mcID$sp.prototype = $c_T2$mcID$sp.prototype;
$c_T2$mcID$sp.prototype._1$mcI$sp__I = (function() {
  return this.T2$mcID$sp__f__1$mcI$sp
});
$c_T2$mcID$sp.prototype._2$mcD$sp__D = (function() {
  return this.T2$mcID$sp__f__2$mcD$sp
});
$c_T2$mcID$sp.prototype.copy$default$2__O = (function() {
  return this.T2$mcID$sp__f__2$mcD$sp
});
$c_T2$mcID$sp.prototype._2__O = (function() {
  return this.T2$mcID$sp__f__2$mcD$sp
});
$c_T2$mcID$sp.prototype._1__O = (function() {
  return this.T2$mcID$sp__f__1$mcI$sp
});
var $d_T2$mcID$sp = new $TypeData().initClass({
  T2$mcID$sp: 0
}, false, "scala.Tuple2$mcID$sp", {
  T2$mcID$sp: 1,
  T2: 1,
  O: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1,
  s_Product2$mcID$sp: 1
});
$c_T2$mcID$sp.prototype.$classData = $d_T2$mcID$sp;
/** @constructor */
function $c_T2$mcII$sp(_1$mcI$sp, _2$mcI$sp) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2$mcII$sp__f__1$mcI$sp = 0;
  this.T2$mcII$sp__f__2$mcI$sp = 0;
  this.T2$mcII$sp__f__1$mcI$sp = _1$mcI$sp;
  this.T2$mcII$sp__f__2$mcI$sp = _2$mcI$sp;
  $ct_T2__O__O__(this, null, null)
}
$c_T2$mcII$sp.prototype = new $h_T2();
$c_T2$mcII$sp.prototype.constructor = $c_T2$mcII$sp;
/** @constructor */
function $h_T2$mcII$sp() {
  /*<skip>*/
}
$h_T2$mcII$sp.prototype = $c_T2$mcII$sp.prototype;
$c_T2$mcII$sp.prototype._1$mcI$sp__I = (function() {
  return this.T2$mcII$sp__f__1$mcI$sp
});
$c_T2$mcII$sp.prototype._2$mcI$sp__I = (function() {
  return this.T2$mcII$sp__f__2$mcI$sp
});
$c_T2$mcII$sp.prototype.copy$default$2__O = (function() {
  return this.T2$mcII$sp__f__2$mcI$sp
});
$c_T2$mcII$sp.prototype._2__O = (function() {
  return this.T2$mcII$sp__f__2$mcI$sp
});
$c_T2$mcII$sp.prototype._1__O = (function() {
  return this.T2$mcII$sp__f__1$mcI$sp
});
var $d_T2$mcII$sp = new $TypeData().initClass({
  T2$mcII$sp: 0
}, false, "scala.Tuple2$mcII$sp", {
  T2$mcII$sp: 1,
  T2: 1,
  O: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1,
  s_Product2$mcII$sp: 1
});
$c_T2$mcII$sp.prototype.$classData = $d_T2$mcII$sp;
class $c_s_UninitializedFieldError extends $c_jl_RuntimeException {
  constructor(msg) {
    super();
    this.s_UninitializedFieldError__f_msg = null;
    this.s_UninitializedFieldError__f_msg = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true)
  };
  productPrefix__T() {
    return "UninitializedFieldError"
  };
  productArity__I() {
    return 1
  };
  productElement__I__O(x$1) {
    return ((x$1 === 0) ? this.s_UninitializedFieldError__f_msg : $m_sr_Statics$().ioobe__I__O(x$1))
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
  };
  equals__O__Z(x$1) {
    if ((this === x$1)) {
      return true
    } else if ((x$1 instanceof $c_s_UninitializedFieldError)) {
      var UninitializedFieldError$1 = $as_s_UninitializedFieldError(x$1);
      return (this.s_UninitializedFieldError__f_msg === $n(UninitializedFieldError$1).s_UninitializedFieldError__f_msg)
    } else {
      return false
    }
  };
}
function $as_s_UninitializedFieldError(obj) {
  return (((obj instanceof $c_s_UninitializedFieldError) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.UninitializedFieldError"))
}
function $isArrayOf_s_UninitializedFieldError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_UninitializedFieldError)))
}
function $asArrayOf_s_UninitializedFieldError(obj, depth) {
  return (($isArrayOf_s_UninitializedFieldError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.UninitializedFieldError;", depth))
}
var $d_s_UninitializedFieldError = new $TypeData().initClass({
  s_UninitializedFieldError: 0
}, false, "scala.UninitializedFieldError", {
  s_UninitializedFieldError: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_s_UninitializedFieldError.prototype.$classData = $d_s_UninitializedFieldError;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcB$sp(xs$mcB$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = xs$mcB$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcB$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcB$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next$mcB$sp__B = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next__O = (function() {
  return this.next$mcB$sp__B()
});
var $d_sc_ArrayOps$ArrayIterator$mcB$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcB$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcB$sp", {
  sc_ArrayOps$ArrayIterator$mcB$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcC$sp(xs$mcC$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = xs$mcC$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcC$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcC$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next$mcC$sp__C = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next__O = (function() {
  return $bC(this.next$mcC$sp__C())
});
var $d_sc_ArrayOps$ArrayIterator$mcC$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcC$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcC$sp", {
  sc_ArrayOps$ArrayIterator$mcC$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcD$sp(xs$mcD$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = xs$mcD$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcD$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcD$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next$mcD$sp__D = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next__O = (function() {
  return this.next$mcD$sp__D()
});
var $d_sc_ArrayOps$ArrayIterator$mcD$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcD$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcD$sp", {
  sc_ArrayOps$ArrayIterator$mcD$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcF$sp(xs$mcF$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = xs$mcF$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcF$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcF$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next$mcF$sp__F = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next__O = (function() {
  return this.next$mcF$sp__F()
});
var $d_sc_ArrayOps$ArrayIterator$mcF$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcF$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcF$sp", {
  sc_ArrayOps$ArrayIterator$mcF$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcI$sp(xs$mcI$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = xs$mcI$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcI$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcI$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next$mcI$sp__I = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next__O = (function() {
  return this.next$mcI$sp__I()
});
var $d_sc_ArrayOps$ArrayIterator$mcI$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcI$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcI$sp", {
  sc_ArrayOps$ArrayIterator$mcI$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcJ$sp(xs$mcJ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = xs$mcJ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcJ$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcJ$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next$mcJ$sp__J = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var t = $n(this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return new $c_RTLong(lo, hi)
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next__O = (function() {
  return this.next$mcJ$sp__J()
});
var $d_sc_ArrayOps$ArrayIterator$mcJ$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcJ$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcJ$sp", {
  sc_ArrayOps$ArrayIterator$mcJ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcS$sp(xs$mcS$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = xs$mcS$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcS$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcS$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next$mcS$sp__S = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next__O = (function() {
  return this.next$mcS$sp__S()
});
var $d_sc_ArrayOps$ArrayIterator$mcS$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcS$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcS$sp", {
  sc_ArrayOps$ArrayIterator$mcS$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcV$sp(xs$mcV$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = xs$mcV$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcV$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcV$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next$mcV$sp__V = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  $n(this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0)
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next__O = (function() {
  this.next$mcV$sp__V()
});
var $d_sc_ArrayOps$ArrayIterator$mcV$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcV$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcV$sp", {
  sc_ArrayOps$ArrayIterator$mcV$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcZ$sp(xs$mcZ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = xs$mcZ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcZ$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcZ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcZ$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next$mcZ$sp__Z = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()
  };
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next__O = (function() {
  return this.next$mcZ$sp__Z()
});
var $d_sc_ArrayOps$ArrayIterator$mcZ$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcZ$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcZ$sp", {
  sc_ArrayOps$ArrayIterator$mcZ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcZ$sp;
/** @constructor */
function $c_sc_Iterable$$anon$1(a$1) {
  this.sc_Iterable$$anon$1__f_a$1 = null;
  this.sc_Iterable$$anon$1__f_a$1 = a$1
}
$c_sc_Iterable$$anon$1.prototype = new $h_sc_AbstractIterable();
$c_sc_Iterable$$anon$1.prototype.constructor = $c_sc_Iterable$$anon$1;
/** @constructor */
function $h_sc_Iterable$$anon$1() {
  /*<skip>*/
}
$h_sc_Iterable$$anon$1.prototype = $c_sc_Iterable$$anon$1.prototype;
$c_sc_Iterable$$anon$1.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sc_Iterable$$anon$1__f_a$1;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sc_Iterable$$anon$1.prototype.knownSize__I = (function() {
  return 1
});
$c_sc_Iterable$$anon$1.prototype.head__O = (function() {
  return this.sc_Iterable$$anon$1__f_a$1
});
$c_sc_Iterable$$anon$1.prototype.headOption__s_Some = (function() {
  return new $c_s_Some(this.sc_Iterable$$anon$1__f_a$1)
});
$c_sc_Iterable$$anon$1.prototype.take__I__sc_Iterable = (function(n) {
  return ((n > 0) ? this : $as_sc_Iterable($m_sc_Iterable$().empty__O()))
});
$c_sc_Iterable$$anon$1.prototype.drop__I__sc_Iterable = (function(n) {
  return ((n > 0) ? $as_sc_Iterable($m_sc_Iterable$().empty__O()) : this)
});
$c_sc_Iterable$$anon$1.prototype.dropRight__I__sc_Iterable = (function(n) {
  return ((n > 0) ? $as_sc_Iterable($m_sc_Iterable$().empty__O()) : this)
});
$c_sc_Iterable$$anon$1.prototype.tail__O = (function() {
  return $as_sc_Iterable($m_sc_Iterable$().empty__O())
});
$c_sc_Iterable$$anon$1.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_Iterable(n)
});
$c_sc_Iterable$$anon$1.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_Iterable(n)
});
$c_sc_Iterable$$anon$1.prototype.take__I__O = (function(n) {
  return this.take__I__sc_Iterable(n)
});
$c_sc_Iterable$$anon$1.prototype.headOption__s_Option = (function() {
  return this.headOption__s_Some()
});
var $d_sc_Iterable$$anon$1 = new $TypeData().initClass({
  sc_Iterable$$anon$1: 0
}, false, "scala.collection.Iterable$$anon$1", {
  sc_Iterable$$anon$1: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1
});
$c_sc_Iterable$$anon$1.prototype.$classData = $d_sc_Iterable$$anon$1;
function $is_sc_MapFactoryDefaults(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_MapFactoryDefaults)))
}
function $as_sc_MapFactoryDefaults(obj) {
  return (($is_sc_MapFactoryDefaults(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.MapFactoryDefaults"))
}
function $isArrayOf_sc_MapFactoryDefaults(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_MapFactoryDefaults)))
}
function $asArrayOf_sc_MapFactoryDefaults(obj, depth) {
  return (($isArrayOf_sc_MapFactoryDefaults(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.MapFactoryDefaults;", depth))
}
function $f_sc_SortedSetOps__map__F1__s_math_Ordering__sc_SortedSet($thiz, f, ev) {
  return $as_sc_SortedSet($n($thiz.sortedIterableFactory__sc_SortedIterableFactory()).from__sc_IterableOnce__O__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f), ev))
}
function $f_sc_SortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet($thiz, f, ev) {
  return $as_sc_SortedSet($n($thiz.sortedIterableFactory__sc_SortedIterableFactory()).from__sc_IterableOnce__O__O(new $c_sc_View$FlatMap($thiz, f), ev))
}
function $f_sc_View__toString__T($thiz) {
  return ($thiz.className__T() + "(<not computed>)")
}
function $is_sc_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_View)))
}
function $as_sc_View(obj) {
  return (($is_sc_View(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.View"))
}
function $isArrayOf_sc_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_View)))
}
function $asArrayOf_sc_View(obj, depth) {
  return (($isArrayOf_sc_View(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.View;", depth))
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying = underlying
}
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = new $h_ju_AbstractSet();
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.contains__O__Z = (function(o) {
  try {
    return $n(this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying).contains__O__Z(o)
  } catch (e) {
    if ((e instanceof $c_jl_ClassCastException)) {
      $as_jl_ClassCastException(e);
      return false
    } else {
      throw e
    }
  }
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.isEmpty__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying).isEmpty__Z()
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.size__I = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying).size__I()
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.iterator__ju_Iterator = (function() {
  return new $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1(this)
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$SetWrapper: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$SetWrapper", {
  sc_convert_JavaCollectionWrappers$SetWrapper: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1,
  Ljava_io_Serializable: 1
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$SetWrapper;
function $f_sci_IndexedSeqOps__slice__I__I__O($thiz, from, until) {
  return (((from <= 0) && (until >= $thiz.length__I())) ? $thiz : $f_sc_IndexedSeqOps__slice__I__I__O($thiz, from, until))
}
function $is_sci_MapOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_MapOps)))
}
function $as_sci_MapOps(obj) {
  return (($is_sci_MapOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapOps"))
}
function $isArrayOf_sci_MapOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapOps)))
}
function $asArrayOf_sci_MapOps(obj, depth) {
  return (($isArrayOf_sci_MapOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapOps;", depth))
}
/** @constructor */
function $c_sci_Set$Set2$$anon$1(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set2$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sci_Set$Set2$$anon$1__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, ($n(outer), 2))
}
$c_sci_Set$Set2$$anon$1.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set2$$anon$1.prototype.constructor = $c_sci_Set$Set2$$anon$1;
/** @constructor */
function $h_sci_Set$Set2$$anon$1() {
  /*<skip>*/
}
$h_sci_Set$Set2$$anon$1.prototype = $c_sci_Set$Set2$$anon$1.prototype;
$c_sci_Set$Set2$$anon$1.prototype.apply__I__O = (function(i) {
  return $n(this.sci_Set$Set2$$anon$1__f_$outer).scala$collection$immutable$Set$Set2$$getElem__I__O(i)
});
var $d_sci_Set$Set2$$anon$1 = new $TypeData().initClass({
  sci_Set$Set2$$anon$1: 0
}, false, "scala.collection.immutable.Set$Set2$$anon$1", {
  sci_Set$Set2$$anon$1: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set2$$anon$1.prototype.$classData = $d_sci_Set$Set2$$anon$1;
/** @constructor */
function $c_sci_Set$Set3$$anon$2(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set3$$anon$2__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sci_Set$Set3$$anon$2__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, ($n(outer), 3))
}
$c_sci_Set$Set3$$anon$2.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set3$$anon$2.prototype.constructor = $c_sci_Set$Set3$$anon$2;
/** @constructor */
function $h_sci_Set$Set3$$anon$2() {
  /*<skip>*/
}
$h_sci_Set$Set3$$anon$2.prototype = $c_sci_Set$Set3$$anon$2.prototype;
$c_sci_Set$Set3$$anon$2.prototype.apply__I__O = (function(i) {
  return $n(this.sci_Set$Set3$$anon$2__f_$outer).scala$collection$immutable$Set$Set3$$getElem__I__O(i)
});
var $d_sci_Set$Set3$$anon$2 = new $TypeData().initClass({
  sci_Set$Set3$$anon$2: 0
}, false, "scala.collection.immutable.Set$Set3$$anon$2", {
  sci_Set$Set3$$anon$2: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set3$$anon$2.prototype.$classData = $d_sci_Set$Set3$$anon$2;
/** @constructor */
function $c_sci_Set$Set4$$anon$3(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set4$$anon$3__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sci_Set$Set4$$anon$3__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, ($n(outer), 4))
}
$c_sci_Set$Set4$$anon$3.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set4$$anon$3.prototype.constructor = $c_sci_Set$Set4$$anon$3;
/** @constructor */
function $h_sci_Set$Set4$$anon$3() {
  /*<skip>*/
}
$h_sci_Set$Set4$$anon$3.prototype = $c_sci_Set$Set4$$anon$3.prototype;
$c_sci_Set$Set4$$anon$3.prototype.apply__I__O = (function(i) {
  return $n(this.sci_Set$Set4$$anon$3__f_$outer).scala$collection$immutable$Set$Set4$$getElem__I__O(i)
});
var $d_sci_Set$Set4$$anon$3 = new $TypeData().initClass({
  sci_Set$Set4$$anon$3: 0
}, false, "scala.collection.immutable.Set$Set4$$anon$3", {
  sci_Set$Set4$$anon$3: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set4$$anon$3.prototype.$classData = $d_sci_Set$Set4$$anon$3;
function $p_sci_TreeMap$TreeMapBuilder__adder__sci_TreeMap$TreeMapBuilder$adder$($thiz) {
  if (($thiz.sci_TreeMap$TreeMapBuilder__f_adder$module === null)) {
    $p_sci_TreeMap$TreeMapBuilder__adder$lzycompute$1__V($thiz)
  };
  return $thiz.sci_TreeMap$TreeMapBuilder__f_adder$module
}
function $p_sci_TreeMap$TreeMapBuilder__adder$lzycompute$1__V($thiz) {
  if (($thiz.sci_TreeMap$TreeMapBuilder__f_adder$module === null)) {
    $thiz.sci_TreeMap$TreeMapBuilder__f_adder$module = new $c_sci_TreeMap$TreeMapBuilder$adder$($thiz)
  }
}
/** @constructor */
function $c_sci_TreeMap$TreeMapBuilder(ordering) {
  this.sci_RedBlackTree$Helper__f_ordering = null;
  this.sci_TreeMap$TreeMapBuilder__f_adder$module = null;
  this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = null;
  $ct_sci_RedBlackTree$Helper__s_math_Ordering__(this, ordering);
  this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = null
}
$c_sci_TreeMap$TreeMapBuilder.prototype = new $h_sci_RedBlackTree$MapHelper();
$c_sci_TreeMap$TreeMapBuilder.prototype.constructor = $c_sci_TreeMap$TreeMapBuilder;
/** @constructor */
function $h_sci_TreeMap$TreeMapBuilder() {
  /*<skip>*/
}
$h_sci_TreeMap$TreeMapBuilder.prototype = $c_sci_TreeMap$TreeMapBuilder.prototype;
$c_sci_TreeMap$TreeMapBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_TreeMap$TreeMapBuilder.prototype.addOne__T2__sci_TreeMap$TreeMapBuilder = (function(elem) {
  this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = this.mutableUpd__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree(this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree, $n(elem)._1__O(), $n(elem)._2__O());
  return this
});
$c_sci_TreeMap$TreeMapBuilder.prototype.addAll__sc_IterableOnce__sci_TreeMap$TreeMapBuilder = (function(xs) {
  matchEnd5: {
    if ((xs instanceof $c_sci_TreeMap)) {
      var x2 = $as_sci_TreeMap(xs);
      var x = $n(x2).sci_TreeMap__f_ordering;
      var x$2 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        if ((this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree === null)) {
          var this$1 = $n(x2);
          this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = this$1.sci_TreeMap__f_tree;
          break matchEnd5
        } else {
          var $$x2 = $m_sci_RedBlackTree$();
          var $$x1 = this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree);
          var this$2 = $n(x2);
          this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree = $n($$x2).union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($$x1, this$2.sci_TreeMap__f_tree, this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5
        }
      }
    };
    if ($is_sc_Map(xs)) {
      var x3 = $as_sc_Map(xs);
      $n($p_sci_TreeMap$TreeMapBuilder__adder__sci_TreeMap$TreeMapBuilder$adder$(this)).addForEach__sc_Map__V(x3);
      break matchEnd5
    };
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
  };
  return this
});
$c_sci_TreeMap$TreeMapBuilder.prototype.result__sci_TreeMap = (function() {
  return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeMap$TreeMapBuilder__f_scala$collection$immutable$TreeMap$TreeMapBuilder$$tree), this.sci_RedBlackTree$Helper__f_ordering)
});
$c_sci_TreeMap$TreeMapBuilder.prototype.result__O = (function() {
  return this.result__sci_TreeMap()
});
$c_sci_TreeMap$TreeMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_TreeMap$TreeMapBuilder(xs)
});
$c_sci_TreeMap$TreeMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_TreeMap$TreeMapBuilder($as_T2(elem))
});
var $d_sci_TreeMap$TreeMapBuilder = new $TypeData().initClass({
  sci_TreeMap$TreeMapBuilder: 0
}, false, "scala.collection.immutable.TreeMap$TreeMapBuilder", {
  sci_TreeMap$TreeMapBuilder: 1,
  sci_RedBlackTree$MapHelper: 1,
  sci_RedBlackTree$Helper: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_TreeMap$TreeMapBuilder.prototype.$classData = $d_sci_TreeMap$TreeMapBuilder;
/** @constructor */
function $c_sci_TreeSet$TreeSetBuilder(ordering) {
  this.sci_RedBlackTree$Helper__f_ordering = null;
  this.sci_TreeSet$TreeSetBuilder__f_tree = null;
  $ct_sci_RedBlackTree$Helper__s_math_Ordering__(this, ordering);
  this.sci_TreeSet$TreeSetBuilder__f_tree = null
}
$c_sci_TreeSet$TreeSetBuilder.prototype = new $h_sci_RedBlackTree$SetHelper();
$c_sci_TreeSet$TreeSetBuilder.prototype.constructor = $c_sci_TreeSet$TreeSetBuilder;
/** @constructor */
function $h_sci_TreeSet$TreeSetBuilder() {
  /*<skip>*/
}
$h_sci_TreeSet$TreeSetBuilder.prototype = $c_sci_TreeSet$TreeSetBuilder.prototype;
$c_sci_TreeSet$TreeSetBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__sci_TreeSet$TreeSetBuilder = (function(elem) {
  this.sci_TreeSet$TreeSetBuilder__f_tree = this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree, elem);
  return this
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder = (function(xs) {
  matchEnd5: {
    if ((xs instanceof $c_sci_TreeSet)) {
      var x2 = $as_sci_TreeSet(xs);
      var x = $n(x2).sci_TreeSet__f_ordering;
      var x$2 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $n(x2).sci_TreeSet__f_tree;
          break matchEnd5
        } else {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), $n(x2).sci_TreeSet__f_tree, this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5
        }
      }
    };
    if ((xs instanceof $c_sci_TreeMap)) {
      var x3 = $as_sci_TreeMap(xs);
      var x$3 = $n(x3).sci_TreeMap__f_ordering;
      var x$4 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          var this$1 = $n(x3);
          this.sci_TreeSet$TreeSetBuilder__f_tree = this$1.sci_TreeMap__f_tree;
          break matchEnd5
        } else {
          var $$x2 = $m_sci_RedBlackTree$();
          var $$x1 = this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree);
          var this$2 = $n(x3);
          this.sci_TreeSet$TreeSetBuilder__f_tree = $n($$x2).union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($$x1, this$2.sci_TreeMap__f_tree, this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5
        }
      }
    };
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
  };
  return this
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__sci_TreeSet = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), this.sci_RedBlackTree$Helper__f_ordering)
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__O = (function() {
  return this.result__sci_TreeSet()
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder(xs)
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_TreeSet$TreeSetBuilder(elem)
});
var $d_sci_TreeSet$TreeSetBuilder = new $TypeData().initClass({
  sci_TreeSet$TreeSetBuilder: 0
}, false, "scala.collection.immutable.TreeSet$TreeSetBuilder", {
  sci_TreeSet$TreeSetBuilder: 1,
  sci_RedBlackTree$SetHelper: 1,
  sci_RedBlackTree$Helper: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_TreeSet$TreeSetBuilder.prototype.$classData = $d_sci_TreeSet$TreeSetBuilder;
/** @constructor */
function $c_scm_ArrayBuilder$generic(elementClass) {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder$generic__f_elementClass = null;
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = false;
  this.scm_ArrayBuilder$generic__f_jsElems = null;
  this.scm_ArrayBuilder$generic__f_elementClass = elementClass;
  $ct_scm_ArrayBuilder__(this);
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  this.scm_ArrayBuilder$generic__f_jsElems = []
}
$c_scm_ArrayBuilder$generic.prototype = new $h_scm_ArrayBuilder();
$c_scm_ArrayBuilder$generic.prototype.constructor = $c_scm_ArrayBuilder$generic;
/** @constructor */
function $h_scm_ArrayBuilder$generic() {
  /*<skip>*/
}
$h_scm_ArrayBuilder$generic.prototype = $c_scm_ArrayBuilder$generic.prototype;
$c_scm_ArrayBuilder$generic.prototype.length__I = (function() {
  return $uI(this.scm_ArrayBuilder$generic__f_jsElems.length)
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_ArrayBuilder$generic = (function(elem) {
  var unboxedElem = (this.scm_ArrayBuilder$generic__f_isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(this.scm_ArrayBuilder$generic__f_elementClass).jl_Class__f_data.zero : elem));
  this.scm_ArrayBuilder$generic__f_jsElems.push(unboxedElem);
  return this
});
$c_scm_ArrayBuilder$generic.prototype.addAll__O__I__I__scm_ArrayBuilder$generic = (function(xs, offset, length) {
  var end = ((offset + length) | 0);
  var i = offset;
  while ((i < end)) {
    var elem = $m_sr_ScalaRunTime$().array_apply__O__I__O(xs, i);
    this.addOne__O__scm_ArrayBuilder$generic(elem);
    i = ((1 + i) | 0)
  };
  return this
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_ArrayBuilder$generic = (function(xs) {
  var it = $n(xs).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    this.addOne__O__scm_ArrayBuilder$generic(elem)
  };
  return this
});
$c_scm_ArrayBuilder$generic.prototype.result__O = (function() {
  var x$2 = this.scm_ArrayBuilder$generic__f_elementClass;
  if ((x$2 === $d_V.getClassOf())) {
    var elemRuntimeClass = $d_jl_Void.getClassOf()
  } else {
    var x$4 = this.scm_ArrayBuilder$generic__f_elementClass;
    if ((x$4 === $d_sr_Null$.getClassOf())) {
      var $$x1 = true
    } else {
      var x$6 = this.scm_ArrayBuilder$generic__f_elementClass;
      var $$x1 = (x$6 === $d_sr_Nothing$.getClassOf())
    };
    if ($$x1) {
      var elemRuntimeClass = $d_O.getClassOf()
    } else {
      var elemRuntimeClass = this.scm_ArrayBuilder$generic__f_elementClass
    }
  };
  return $n(elemRuntimeClass).jl_Class__f_data.getArrayOf().wrapArray(this.scm_ArrayBuilder$generic__f_jsElems)
});
$c_scm_ArrayBuilder$generic.prototype.toString__T = (function() {
  return "ArrayBuilder.generic"
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuilder$generic(xs)
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuilder$generic(elem)
});
var $d_scm_ArrayBuilder$generic = new $TypeData().initClass({
  scm_ArrayBuilder$generic: 0
}, false, "scala.collection.mutable.ArrayBuilder$generic", {
  scm_ArrayBuilder$generic: 1,
  scm_ArrayBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuilder$generic.prototype.$classData = $d_scm_ArrayBuilder$generic;
function $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O($thiz, srcStart, dest, destStart, maxItems) {
  var until = ((1 + $m_jl_reflect_Array$().getLength__O__I(dest)) | 0);
  if (((destStart < 0) || (destStart >= until))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((destStart + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"))
  };
  var idx = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var a = ((((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n($thiz.scm_ArrayDeque__f_array).u.length) | 0)) - srcStart) | 0);
  var b = (($m_jl_reflect_Array$().getLength__O__I(dest) - destStart) | 0);
  var b$1 = ((a < b) ? a : b);
  var toCopy = ((maxItems < b$1) ? maxItems : b$1);
  if ((toCopy > 0)) {
    var idx$1 = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var until$1 = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n($thiz.scm_ArrayDeque__f_array).u.length) | 0));
    if (((srcStart < 0) || (srcStart >= until$1))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((srcStart + " is out of bounds (min 0, max ") + (((-1) + until$1) | 0)) + ")"))
    };
    var startIdx = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + srcStart) | 0) & (((-1) + $n($thiz.scm_ArrayDeque__f_array).u.length) | 0));
    var b$2 = (($n($thiz.scm_ArrayDeque__f_array).u.length - startIdx) | 0);
    var block1 = ((toCopy < b$2) ? toCopy : b$2);
    $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, startIdx, dest, destStart, block1);
    var block2 = ((toCopy - block1) | 0);
    if ((block2 > 0)) {
      $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, 0, dest, ((destStart + block1) | 0), block2)
    }
  };
  return dest
}
function $f_scm_ArrayDequeOps__reverse__O($thiz) {
  var idx = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var n = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n($thiz.scm_ArrayDeque__f_array).u.length) | 0));
  var arr = $m_scm_ArrayDeque$().alloc__I__AO(n);
  var i = 0;
  while ((i < n)) {
    $n(arr).set(i, $thiz.apply__I__O((((-1) + ((n - i) | 0)) | 0)));
    i = ((1 + i) | 0)
  };
  return $thiz.ofArray__AO__I__O(arr, n)
}
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(this, self);
  var this$1 = $n(mutationCount);
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = $uI(this$1.apply__O())
}
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewIterator();
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedIterator() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$CheckedIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount;
  var this$1 = $n(this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount);
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)
});
var $d_scm_CheckedIndexedSeqView$CheckedIterator = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$CheckedIterator: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$CheckedIterator", {
  scm_CheckedIndexedSeqView$CheckedIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.$classData = $d_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(this, self);
  var this$1 = $n(mutationCount);
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = $uI(this$1.apply__O())
}
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator();
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedReverseIterator() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount;
  var this$1 = $n(this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount);
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)
});
var $d_scm_CheckedIndexedSeqView$CheckedReverseIterator = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$CheckedReverseIterator: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$CheckedReverseIterator", {
  scm_CheckedIndexedSeqView$CheckedReverseIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.$classData = $d_scm_CheckedIndexedSeqView$CheckedReverseIterator;
class $c_s_concurrent_Future$$anon$1 extends $c_ju_NoSuchElementException {
  constructor(t$2) {
    super();
    var s = ("Future.collect partial function is not defined at: " + t$2);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
  };
}
var $d_s_concurrent_Future$$anon$1 = new $TypeData().initClass({
  s_concurrent_Future$$anon$1: 0
}, false, "scala.concurrent.Future$$anon$1", {
  s_concurrent_Future$$anon$1: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$1.prototype.$classData = $d_s_concurrent_Future$$anon$1;
class $c_s_concurrent_Future$$anon$2 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.filter predicate is not satisfied", null, true, true)
  };
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
  };
}
var $d_s_concurrent_Future$$anon$2 = new $TypeData().initClass({
  s_concurrent_Future$$anon$2: 0
}, false, "scala.concurrent.Future$$anon$2", {
  s_concurrent_Future$$anon$2: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$2.prototype.$classData = $d_s_concurrent_Future$$anon$2;
class $c_s_concurrent_Future$$anon$3 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.failed not completed with a throwable.", null, true, true)
  };
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
  };
}
var $d_s_concurrent_Future$$anon$3 = new $TypeData().initClass({
  s_concurrent_Future$$anon$3: 0
}, false, "scala.concurrent.Future$$anon$3", {
  s_concurrent_Future$$anon$3: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$3.prototype.$classData = $d_s_concurrent_Future$$anon$3;
function $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($thiz) {
  var _$this = $thiz;
  while (true) {
    var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return $as_s_util_Try(state)
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this)
    } else {
      return null
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, state, callbacks) {
  var _$this = $thiz;
  while (true) {
    if ((state instanceof $c_s_util_Try)) {
      $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($n(_$this), callbacks, $as_s_util_Try(state));
      return callbacks
    } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if ($n(_$this).compareAndSet__O__O__Z(state, ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop) ? $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($n(_$this), callbacks, $as_s_concurrent_impl_Promise$Callbacks(state)) : callbacks))) {
        return callbacks
      } else {
        state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value
      }
    } else {
      var p = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      var temp$state$2 = $n(p).ju_concurrent_atomic_AtomicReference__f_value;
      _$this = p;
      state = temp$state$2
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, left, right) {
  while (true) {
    if ((left instanceof $c_s_concurrent_impl_Promise$Transformation)) {
      return new $c_s_concurrent_impl_Promise$ManyCallbacks($as_s_concurrent_impl_Promise$Transformation(left), right)
    } else {
      var m = $as_s_concurrent_impl_Promise$ManyCallbacks(left);
      var temp$left = $n(m).s_concurrent_impl_Promise$ManyCallbacks__f_rest;
      var temp$right = new $c_s_concurrent_impl_Promise$ManyCallbacks($n(m).s_concurrent_impl_Promise$ManyCallbacks__f_first, right);
      left = temp$left;
      right = temp$right
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($thiz, callbacks, resolved) {
  while ((callbacks instanceof $c_s_concurrent_impl_Promise$ManyCallbacks)) {
    var m = $as_s_concurrent_impl_Promise$ManyCallbacks(callbacks);
    $n($n(m).s_concurrent_impl_Promise$ManyCallbacks__f_first).submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved);
    callbacks = $n(m).s_concurrent_impl_Promise$ManyCallbacks__f_rest
  };
  $n($as_s_concurrent_impl_Promise$Transformation(callbacks)).submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved)
}
function $p_s_concurrent_impl_Promise$DefaultPromise__liftedTree1$1__F2__s_util_Success__s_util_Success__s_util_Try($thiz, f$1, x2$1, right$1) {
  try {
    var this$1 = $n(x2$1);
    var $$x1 = this$1.s_util_Success__f_value;
    var this$2 = $n(right$1);
    return new $c_s_util_Success($n(f$1).apply__O__O__O($$x1, this$2.s_util_Success__f_value))
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2)
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__liftedTree2$1__F2__s_util_Success__s_util_Success__s_util_Try($thiz, f$1, left$1, x2$2) {
  try {
    var this$1 = $n(left$1);
    var $$x1 = this$1.s_util_Success__f_value;
    var this$2 = $n(x2$2);
    return new $c_s_util_Success($n(f$1).apply__O__O__O($$x1, this$2.s_util_Success__f_value))
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2)
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
    }
  }
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, initial) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, initial);
  return $thiz
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__($thiz, result) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(result));
  return $thiz
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop);
  return $thiz
}
/** @constructor */
function $c_s_concurrent_impl_Promise$DefaultPromise() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null
}
$c_s_concurrent_impl_Promise$DefaultPromise.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.constructor = $c_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $h_s_concurrent_impl_Promise$DefaultPromise() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$DefaultPromise.prototype = $c_s_concurrent_impl_Promise$DefaultPromise.prototype;
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  var resolved = $as_s_util_Try(v1);
  this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolved);
  return $uZ((void 0))
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.transform__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  return $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ju_concurrent_atomic_AtomicReference__f_value, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 3, f, executor)))
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.zipWith__s_concurrent_Future__F2__s_concurrent_ExecutionContext__s_concurrent_Future = (function(that, f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  if ((state instanceof $c_s_util_Try)) {
    if ($n($as_s_util_Try(state)).isFailure__Z()) {
      return this
    } else {
      var this$1 = $n($as_s_util_Success(state));
      var l = this$1.s_util_Success__f_value;
      return $n(that).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1(((r$2) => $n(f).apply__O__O__O(l, r$2))), executor)
    }
  } else {
    var buffer = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
    var zipped = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
    var thisF = new $c_sjsr_AnonFunction1(((x0$1$2) => {
      var x0$1 = $as_s_util_Try(x0$1$2);
      if ((x0$1 instanceof $c_s_util_Success)) {
        var x2 = $as_s_util_Success(x0$1);
        var right = $as_s_util_Success(buffer.getAndSet__O__O(x2));
        if ((right !== null)) {
          zipped.tryComplete__s_util_Try__Z($p_s_concurrent_impl_Promise$DefaultPromise__liftedTree1$1__F2__s_util_Success__s_util_Success__s_util_Try(this, f, x2, right))
        }
      } else {
        zipped.tryComplete__s_util_Try__Z($as_s_util_Failure(x0$1))
      }
    }));
    var thatF = new $c_sjsr_AnonFunction1(((x0$2$2) => {
      var x0$2 = $as_s_util_Try(x0$2$2);
      if ((x0$2 instanceof $c_s_util_Success)) {
        var x2$1 = $as_s_util_Success(x0$2);
        var left = $as_s_util_Success(buffer.getAndSet__O__O(x2$1));
        if ((left !== null)) {
          zipped.tryComplete__s_util_Try__Z($p_s_concurrent_impl_Promise$DefaultPromise__liftedTree2$1__F2__s_util_Success__s_util_Success__s_util_Try(this, f, left, x2$1))
        }
      } else {
        zipped.tryComplete__s_util_Try__Z($as_s_util_Failure(x0$2))
      }
    }));
    $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, thisF, executor));
    $n(that).onComplete__F1__s_concurrent_ExecutionContext__V(thatF, executor);
    return zipped
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Failure)) ? $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 2, f, executor))) : this)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Failure)) ? $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 1, f, executor))) : this)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.filter__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(p, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Failure)) ? $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 9, p, executor))) : this)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.recoverWith__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future = (function(pf, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Success)) ? $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 8, pf, executor))) : this)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future = (function(pf, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Success)) ? $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 7, pf, executor))) : this)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.onComplete__F1__s_concurrent_ExecutionContext__V = (function(func, executor) {
  $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ju_concurrent_atomic_AtomicReference__f_value, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, func, executor))
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.toString__T = (function() {
  var _$this = this;
  while (true) {
    var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return (("Future(" + state) + ")")
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this)
    } else {
      return "Future(<not completed>)"
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete__s_util_Try__Z = (function(value) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Try)) && this.tryComplete0__O__s_util_Try__Z(state, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(value)))
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete0__O__s_util_Try__Z = (function(state, resolved) {
  var _$this = this;
  while (true) {
    if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if ($n(_$this).compareAndSet__O__O__Z(state, resolved)) {
        if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
          $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($n(_$this), $as_s_concurrent_impl_Promise$Callbacks(state), resolved)
        };
        return true
      } else {
        state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value
      }
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var p = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      if ((p !== _$this)) {
        var temp$state$2 = $n(p).ju_concurrent_atomic_AtomicReference__f_value;
        _$this = p;
        state = temp$state$2
      } else {
        return false
      }
    } else {
      return false
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise = (function(other) {
  if ((other !== this)) {
    var state = this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((!(state instanceof $c_s_util_Try))) {
      if ((other instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
        var resolved = $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($n($as_s_concurrent_impl_Promise$DefaultPromise(other)))
      } else {
        var this$1 = $n(other);
        var this$3 = $n($m_s_Option$().apply__O__s_Option($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(this$1)));
        var this$2 = $m_s_$less$colon$less$();
        var ev = this$2.s_$less$colon$less$__f_singleton;
        var resolved = $as_s_util_Try((this$3.isEmpty__Z() ? ($n(ev), null) : this$3.get__O()))
      };
      if ((resolved !== null)) {
        this.tryComplete0__O__s_util_Try__Z(state, resolved)
      } else {
        $n(other).onComplete__F1__s_concurrent_ExecutionContext__V(this, $m_s_concurrent_ExecutionContext$parasitic$())
      }
    }
  };
  return this
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V = (function(target, link) {
  var _$this = this;
  while (true) {
    if ((_$this !== target)) {
      var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
      if ((state instanceof $c_s_util_Try)) {
        if ((!$n(target).tryComplete0__O__s_util_Try__Z($n(target).ju_concurrent_atomic_AtomicReference__f_value, $as_s_util_Try(state)))) {
          throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot link completed promises together")
        }
      } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
        var l = ((link !== null) ? link : new $c_s_concurrent_impl_Promise$Link(target));
        var p = $n(l).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        if (((_$this !== p) && $n(_$this).compareAndSet__O__O__Z(state, l))) {
          if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
            $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($n(p), $n(p).ju_concurrent_atomic_AtomicReference__f_value, $as_s_concurrent_impl_Promise$Callbacks(state))
          }
        } else {
          target = p;
          link = l;
          continue
        }
      } else {
        _$this = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        continue
      }
    };
    break
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.unlink__s_util_Try__V = (function(resolved) {
  var _$this = this;
  while (true) {
    var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var next = ($n(_$this).compareAndSet__O__O__Z(state, resolved) ? $as_s_concurrent_impl_Promise$DefaultPromise($n($as_s_concurrent_impl_Promise$Link(state)).ju_concurrent_atomic_AtomicReference__f_value) : _$this);
      _$this = next;
      continue
    } else {
      $n(_$this).tryComplete0__O__s_util_Try__Z(state, resolved)
    };
    break
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply__O__O = (function(v1) {
  var resolved = $as_s_util_Try(v1);
  this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolved)
});
function $as_s_concurrent_impl_Promise$DefaultPromise(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$DefaultPromise) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$DefaultPromise"))
}
function $isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$DefaultPromise)))
}
function $asArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$DefaultPromise;", depth))
}
var $d_s_concurrent_impl_Promise$DefaultPromise = new $TypeData().initClass({
  s_concurrent_impl_Promise$DefaultPromise: 0
}, false, "scala.concurrent.impl.Promise$DefaultPromise", {
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.$classData = $d_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $c_s_math_Ordering$Boolean$() {
  /*<skip>*/
}
$c_s_math_Ordering$Boolean$.prototype = new $h_O();
$c_s_math_Ordering$Boolean$.prototype.constructor = $c_s_math_Ordering$Boolean$;
/** @constructor */
function $h_s_math_Ordering$Boolean$() {
  /*<skip>*/
}
$h_s_math_Ordering$Boolean$.prototype = $c_s_math_Ordering$Boolean$.prototype;
$c_s_math_Ordering$Boolean$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Boolean$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uZ(x);
  var y$1 = $uZ(y);
  return ((x$1 === y$1) ? 0 : (x$1 ? 1 : (-1)))
});
var $d_s_math_Ordering$Boolean$ = new $TypeData().initClass({
  s_math_Ordering$Boolean$: 0
}, false, "scala.math.Ordering$Boolean$", {
  s_math_Ordering$Boolean$: 1,
  O: 1,
  s_math_Ordering$BooleanOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Boolean$.prototype.$classData = $d_s_math_Ordering$Boolean$;
var $n_s_math_Ordering$Boolean$;
function $m_s_math_Ordering$Boolean$() {
  if ((!$n_s_math_Ordering$Boolean$)) {
    $n_s_math_Ordering$Boolean$ = new $c_s_math_Ordering$Boolean$()
  };
  return $n_s_math_Ordering$Boolean$
}
/** @constructor */
function $c_s_math_Ordering$Byte$() {
  /*<skip>*/
}
$c_s_math_Ordering$Byte$.prototype = new $h_O();
$c_s_math_Ordering$Byte$.prototype.constructor = $c_s_math_Ordering$Byte$;
/** @constructor */
function $h_s_math_Ordering$Byte$() {
  /*<skip>*/
}
$h_s_math_Ordering$Byte$.prototype = $c_s_math_Ordering$Byte$.prototype;
$c_s_math_Ordering$Byte$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Byte$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return ((x$1 - y$1) | 0)
});
var $d_s_math_Ordering$Byte$ = new $TypeData().initClass({
  s_math_Ordering$Byte$: 0
}, false, "scala.math.Ordering$Byte$", {
  s_math_Ordering$Byte$: 1,
  O: 1,
  s_math_Ordering$ByteOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Byte$.prototype.$classData = $d_s_math_Ordering$Byte$;
var $n_s_math_Ordering$Byte$;
function $m_s_math_Ordering$Byte$() {
  if ((!$n_s_math_Ordering$Byte$)) {
    $n_s_math_Ordering$Byte$ = new $c_s_math_Ordering$Byte$()
  };
  return $n_s_math_Ordering$Byte$
}
/** @constructor */
function $c_s_math_Ordering$Char$() {
  /*<skip>*/
}
$c_s_math_Ordering$Char$.prototype = new $h_O();
$c_s_math_Ordering$Char$.prototype.constructor = $c_s_math_Ordering$Char$;
/** @constructor */
function $h_s_math_Ordering$Char$() {
  /*<skip>*/
}
$h_s_math_Ordering$Char$.prototype = $c_s_math_Ordering$Char$.prototype;
$c_s_math_Ordering$Char$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Char$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return ((x$1 - y$1) | 0)
});
var $d_s_math_Ordering$Char$ = new $TypeData().initClass({
  s_math_Ordering$Char$: 0
}, false, "scala.math.Ordering$Char$", {
  s_math_Ordering$Char$: 1,
  O: 1,
  s_math_Ordering$CharOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Char$.prototype.$classData = $d_s_math_Ordering$Char$;
var $n_s_math_Ordering$Char$;
function $m_s_math_Ordering$Char$() {
  if ((!$n_s_math_Ordering$Char$)) {
    $n_s_math_Ordering$Char$ = new $c_s_math_Ordering$Char$()
  };
  return $n_s_math_Ordering$Char$
}
/** @constructor */
function $c_s_math_Ordering$DeprecatedDoubleOrdering$() {
  /*<skip>*/
}
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype = new $h_O();
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.constructor = $c_s_math_Ordering$DeprecatedDoubleOrdering$;
/** @constructor */
function $h_s_math_Ordering$DeprecatedDoubleOrdering$() {
  /*<skip>*/
}
$h_s_math_Ordering$DeprecatedDoubleOrdering$.prototype = $c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype;
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
var $d_s_math_Ordering$DeprecatedDoubleOrdering$ = new $TypeData().initClass({
  s_math_Ordering$DeprecatedDoubleOrdering$: 0
}, false, "scala.math.Ordering$DeprecatedDoubleOrdering$", {
  s_math_Ordering$DeprecatedDoubleOrdering$: 1,
  O: 1,
  s_math_Ordering$Double$TotalOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.$classData = $d_s_math_Ordering$DeprecatedDoubleOrdering$;
var $n_s_math_Ordering$DeprecatedDoubleOrdering$;
function $m_s_math_Ordering$DeprecatedDoubleOrdering$() {
  if ((!$n_s_math_Ordering$DeprecatedDoubleOrdering$)) {
    $n_s_math_Ordering$DeprecatedDoubleOrdering$ = new $c_s_math_Ordering$DeprecatedDoubleOrdering$()
  };
  return $n_s_math_Ordering$DeprecatedDoubleOrdering$
}
/** @constructor */
function $c_s_math_Ordering$DeprecatedFloatOrdering$() {
  /*<skip>*/
}
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype = new $h_O();
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.constructor = $c_s_math_Ordering$DeprecatedFloatOrdering$;
/** @constructor */
function $h_s_math_Ordering$DeprecatedFloatOrdering$() {
  /*<skip>*/
}
$h_s_math_Ordering$DeprecatedFloatOrdering$.prototype = $c_s_math_Ordering$DeprecatedFloatOrdering$.prototype;
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
var $d_s_math_Ordering$DeprecatedFloatOrdering$ = new $TypeData().initClass({
  s_math_Ordering$DeprecatedFloatOrdering$: 0
}, false, "scala.math.Ordering$DeprecatedFloatOrdering$", {
  s_math_Ordering$DeprecatedFloatOrdering$: 1,
  O: 1,
  s_math_Ordering$Float$TotalOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$DeprecatedFloatOrdering$.prototype.$classData = $d_s_math_Ordering$DeprecatedFloatOrdering$;
var $n_s_math_Ordering$DeprecatedFloatOrdering$;
function $m_s_math_Ordering$DeprecatedFloatOrdering$() {
  if ((!$n_s_math_Ordering$DeprecatedFloatOrdering$)) {
    $n_s_math_Ordering$DeprecatedFloatOrdering$ = new $c_s_math_Ordering$DeprecatedFloatOrdering$()
  };
  return $n_s_math_Ordering$DeprecatedFloatOrdering$
}
/** @constructor */
function $c_s_math_Ordering$Long$() {
  /*<skip>*/
}
$c_s_math_Ordering$Long$.prototype = new $h_O();
$c_s_math_Ordering$Long$.prototype.constructor = $c_s_math_Ordering$Long$;
/** @constructor */
function $h_s_math_Ordering$Long$() {
  /*<skip>*/
}
$h_s_math_Ordering$Long$.prototype = $c_s_math_Ordering$Long$.prototype;
$c_s_math_Ordering$Long$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Long$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.compare__O__O__I = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1)
});
var $d_s_math_Ordering$Long$ = new $TypeData().initClass({
  s_math_Ordering$Long$: 0
}, false, "scala.math.Ordering$Long$", {
  s_math_Ordering$Long$: 1,
  O: 1,
  s_math_Ordering$LongOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Long$.prototype.$classData = $d_s_math_Ordering$Long$;
var $n_s_math_Ordering$Long$;
function $m_s_math_Ordering$Long$() {
  if ((!$n_s_math_Ordering$Long$)) {
    $n_s_math_Ordering$Long$ = new $c_s_math_Ordering$Long$()
  };
  return $n_s_math_Ordering$Long$
}
/** @constructor */
function $c_s_math_Ordering$O$1(ord$3) {
  this.s_math_Ordering$O$1__f_optionOrdering = null;
  this.s_math_Ordering$O$1__f_optionOrdering = ord$3
}
$c_s_math_Ordering$O$1.prototype = new $h_O();
$c_s_math_Ordering$O$1.prototype.constructor = $c_s_math_Ordering$O$1;
/** @constructor */
function $h_s_math_Ordering$O$1() {
  /*<skip>*/
}
$h_s_math_Ordering$O$1.prototype = $c_s_math_Ordering$O$1.prototype;
$c_s_math_Ordering$O$1.prototype.equals__O__Z = (function(obj) {
  return $f_s_math_Ordering$OptionOrdering__equals__O__Z(this, obj)
});
$c_s_math_Ordering$O$1.prototype.hashCode__I = (function() {
  return $f_s_math_Ordering$OptionOrdering__hashCode__I(this)
});
$c_s_math_Ordering$O$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$O$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$O$1.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$O$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$O$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$O$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$O$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$O$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$O$1.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$O$1.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_Option(x);
  var y$1 = $as_s_Option(y);
  return $f_s_math_Ordering$OptionOrdering__compare__s_Option__s_Option__I(this, x$1, y$1)
});
var $d_s_math_Ordering$O$1 = new $TypeData().initClass({
  s_math_Ordering$O$1: 0
}, false, "scala.math.Ordering$O$1", {
  s_math_Ordering$O$1: 1,
  O: 1,
  s_math_Ordering$OptionOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$O$1.prototype.$classData = $d_s_math_Ordering$O$1;
/** @constructor */
function $c_s_math_Ordering$Short$() {
  /*<skip>*/
}
$c_s_math_Ordering$Short$.prototype = new $h_O();
$c_s_math_Ordering$Short$.prototype.constructor = $c_s_math_Ordering$Short$;
/** @constructor */
function $h_s_math_Ordering$Short$() {
  /*<skip>*/
}
$h_s_math_Ordering$Short$.prototype = $c_s_math_Ordering$Short$.prototype;
$c_s_math_Ordering$Short$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Short$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return ((x$1 - y$1) | 0)
});
var $d_s_math_Ordering$Short$ = new $TypeData().initClass({
  s_math_Ordering$Short$: 0
}, false, "scala.math.Ordering$Short$", {
  s_math_Ordering$Short$: 1,
  O: 1,
  s_math_Ordering$ShortOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Short$.prototype.$classData = $d_s_math_Ordering$Short$;
var $n_s_math_Ordering$Short$;
function $m_s_math_Ordering$Short$() {
  if ((!$n_s_math_Ordering$Short$)) {
    $n_s_math_Ordering$Short$ = new $c_s_math_Ordering$Short$()
  };
  return $n_s_math_Ordering$Short$
}
/** @constructor */
function $c_s_math_Ordering$String$() {
  /*<skip>*/
}
$c_s_math_Ordering$String$.prototype = new $h_O();
$c_s_math_Ordering$String$.prototype.constructor = $c_s_math_Ordering$String$;
/** @constructor */
function $h_s_math_Ordering$String$() {
  /*<skip>*/
}
$h_s_math_Ordering$String$.prototype = $c_s_math_Ordering$String$.prototype;
$c_s_math_Ordering$String$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$String$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$String$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$String$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$String$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$String$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$String$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$String$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$String$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$String$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_T(x);
  var y$1 = $as_T(y);
  return $f_T__compareTo__T__I($n(x$1), y$1)
});
var $d_s_math_Ordering$String$ = new $TypeData().initClass({
  s_math_Ordering$String$: 0
}, false, "scala.math.Ordering$String$", {
  s_math_Ordering$String$: 1,
  O: 1,
  s_math_Ordering$StringOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$String$.prototype.$classData = $d_s_math_Ordering$String$;
var $n_s_math_Ordering$String$;
function $m_s_math_Ordering$String$() {
  if ((!$n_s_math_Ordering$String$)) {
    $n_s_math_Ordering$String$ = new $c_s_math_Ordering$String$()
  };
  return $n_s_math_Ordering$String$
}
/** @constructor */
function $c_s_reflect_AnyValManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_AnyValManifest.prototype = new $h_O();
$c_s_reflect_AnyValManifest.prototype.constructor = $c_s_reflect_AnyValManifest;
/** @constructor */
function $h_s_reflect_AnyValManifest() {
  /*<skip>*/
}
$h_s_reflect_AnyValManifest.prototype = $c_s_reflect_AnyValManifest.prototype;
$c_s_reflect_AnyValManifest.prototype.toString__T = (function() {
  return this.s_reflect_AnyValManifest__f_toString
});
$c_s_reflect_AnyValManifest.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_s_reflect_AnyValManifest.prototype.hashCode__I = (function() {
  return this.s_reflect_AnyValManifest__f_hashCode
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ClassTypeManifest() {
  /*<skip>*/
}
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype = new $h_O();
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ClassTypeManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ClassTypeManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ClassTypeManifest.prototype = $c_s_reflect_ManifestFactory$ClassTypeManifest.prototype;
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.unapply__O__s_Option = (function(x) {
  return $f_s_reflect_ClassTag__unapply__O__s_Option(this, x)
});
class $c_sjs_js_JavaScriptException extends $c_jl_RuntimeException {
  constructor(exception) {
    super();
    this.sjs_js_JavaScriptException__f_exception = null;
    this.sjs_js_JavaScriptException__f_exception = exception;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    return $dp_toString__T($n(this.sjs_js_JavaScriptException__f_exception))
  };
  productPrefix__T() {
    return "JavaScriptException"
  };
  productArity__I() {
    return 1
  };
  productElement__I__O(x$1) {
    return ((x$1 === 0) ? this.sjs_js_JavaScriptException__f_exception : $m_sr_Statics$().ioobe__I__O(x$1))
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
  };
  equals__O__Z(x$1) {
    if ((this === x$1)) {
      return true
    } else if ((x$1 instanceof $c_sjs_js_JavaScriptException)) {
      var JavaScriptException$1 = $as_sjs_js_JavaScriptException(x$1);
      var x = this.sjs_js_JavaScriptException__f_exception;
      var y = $n(JavaScriptException$1).sjs_js_JavaScriptException__f_exception;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  };
}
function $as_sjs_js_JavaScriptException(obj) {
  return (((obj instanceof $c_sjs_js_JavaScriptException) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.JavaScriptException"))
}
function $isArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_JavaScriptException)))
}
function $asArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (($isArrayOf_sjs_js_JavaScriptException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.JavaScriptException;", depth))
}
var $d_sjs_js_JavaScriptException = new $TypeData().initClass({
  sjs_js_JavaScriptException: 0
}, false, "scala.scalajs.js.JavaScriptException", {
  sjs_js_JavaScriptException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sjs_js_JavaScriptException.prototype.$classData = $d_sjs_js_JavaScriptException;
/** @constructor */
function $c_Lscalacss_internal_Pseudo$Disabled$() {
  this.Lscalacss_internal_Pseudo$Single__f_cssValue = null;
  this.Lscalacss_internal_Pseudo$Single__f_pseudoType = null;
  $ct_Lscalacss_internal_Pseudo$Single__T__Lscalacss_internal_PseudoType__(this, ":disabled", $m_Lscalacss_internal_PseudoType$Class$())
}
$c_Lscalacss_internal_Pseudo$Disabled$.prototype = new $h_Lscalacss_internal_Pseudo$Single();
$c_Lscalacss_internal_Pseudo$Disabled$.prototype.constructor = $c_Lscalacss_internal_Pseudo$Disabled$;
/** @constructor */
function $h_Lscalacss_internal_Pseudo$Disabled$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Pseudo$Disabled$.prototype = $c_Lscalacss_internal_Pseudo$Disabled$.prototype;
$c_Lscalacss_internal_Pseudo$Disabled$.prototype.productPrefix__T = (function() {
  return "Disabled"
});
$c_Lscalacss_internal_Pseudo$Disabled$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Pseudo$Disabled$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Pseudo$Disabled$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Pseudo$Disabled$.prototype.hashCode__I = (function() {
  return 335584924
});
$c_Lscalacss_internal_Pseudo$Disabled$.prototype.toString__T = (function() {
  return "Disabled"
});
var $d_Lscalacss_internal_Pseudo$Disabled$ = new $TypeData().initClass({
  Lscalacss_internal_Pseudo$Disabled$: 0
}, false, "scalacss.internal.Pseudo$Disabled$", {
  Lscalacss_internal_Pseudo$Disabled$: 1,
  Lscalacss_internal_Pseudo$Single: 1,
  Lscalacss_internal_Pseudo: 1,
  O: 1,
  Lscalacss_internal_Pseudo$ChainOps: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Pseudo$Disabled$.prototype.$classData = $d_Lscalacss_internal_Pseudo$Disabled$;
var $n_Lscalacss_internal_Pseudo$Disabled$;
function $m_Lscalacss_internal_Pseudo$Disabled$() {
  if ((!$n_Lscalacss_internal_Pseudo$Disabled$)) {
    $n_Lscalacss_internal_Pseudo$Disabled$ = new $c_Lscalacss_internal_Pseudo$Disabled$()
  };
  return $n_Lscalacss_internal_Pseudo$Disabled$
}
/** @constructor */
function $c_Lscalacss_internal_Pseudo$FirstChild$() {
  this.Lscalacss_internal_Pseudo$Single__f_cssValue = null;
  this.Lscalacss_internal_Pseudo$Single__f_pseudoType = null;
  $ct_Lscalacss_internal_Pseudo$Single__T__Lscalacss_internal_PseudoType__(this, ":first-child", $m_Lscalacss_internal_PseudoType$Class$())
}
$c_Lscalacss_internal_Pseudo$FirstChild$.prototype = new $h_Lscalacss_internal_Pseudo$Single();
$c_Lscalacss_internal_Pseudo$FirstChild$.prototype.constructor = $c_Lscalacss_internal_Pseudo$FirstChild$;
/** @constructor */
function $h_Lscalacss_internal_Pseudo$FirstChild$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Pseudo$FirstChild$.prototype = $c_Lscalacss_internal_Pseudo$FirstChild$.prototype;
$c_Lscalacss_internal_Pseudo$FirstChild$.prototype.productPrefix__T = (function() {
  return "FirstChild"
});
$c_Lscalacss_internal_Pseudo$FirstChild$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Pseudo$FirstChild$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Pseudo$FirstChild$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Pseudo$FirstChild$.prototype.hashCode__I = (function() {
  return 1806449772
});
$c_Lscalacss_internal_Pseudo$FirstChild$.prototype.toString__T = (function() {
  return "FirstChild"
});
var $d_Lscalacss_internal_Pseudo$FirstChild$ = new $TypeData().initClass({
  Lscalacss_internal_Pseudo$FirstChild$: 0
}, false, "scalacss.internal.Pseudo$FirstChild$", {
  Lscalacss_internal_Pseudo$FirstChild$: 1,
  Lscalacss_internal_Pseudo$Single: 1,
  Lscalacss_internal_Pseudo: 1,
  O: 1,
  Lscalacss_internal_Pseudo$ChainOps: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Pseudo$FirstChild$.prototype.$classData = $d_Lscalacss_internal_Pseudo$FirstChild$;
var $n_Lscalacss_internal_Pseudo$FirstChild$;
function $m_Lscalacss_internal_Pseudo$FirstChild$() {
  if ((!$n_Lscalacss_internal_Pseudo$FirstChild$)) {
    $n_Lscalacss_internal_Pseudo$FirstChild$ = new $c_Lscalacss_internal_Pseudo$FirstChild$()
  };
  return $n_Lscalacss_internal_Pseudo$FirstChild$
}
/** @constructor */
function $c_Lscalacss_internal_Pseudo$Focus$() {
  this.Lscalacss_internal_Pseudo$Single__f_cssValue = null;
  this.Lscalacss_internal_Pseudo$Single__f_pseudoType = null;
  $ct_Lscalacss_internal_Pseudo$Single__T__Lscalacss_internal_PseudoType__(this, ":focus", $m_Lscalacss_internal_PseudoType$Class$())
}
$c_Lscalacss_internal_Pseudo$Focus$.prototype = new $h_Lscalacss_internal_Pseudo$Single();
$c_Lscalacss_internal_Pseudo$Focus$.prototype.constructor = $c_Lscalacss_internal_Pseudo$Focus$;
/** @constructor */
function $h_Lscalacss_internal_Pseudo$Focus$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Pseudo$Focus$.prototype = $c_Lscalacss_internal_Pseudo$Focus$.prototype;
$c_Lscalacss_internal_Pseudo$Focus$.prototype.productPrefix__T = (function() {
  return "Focus"
});
$c_Lscalacss_internal_Pseudo$Focus$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Pseudo$Focus$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Pseudo$Focus$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Pseudo$Focus$.prototype.hashCode__I = (function() {
  return 68052152
});
$c_Lscalacss_internal_Pseudo$Focus$.prototype.toString__T = (function() {
  return "Focus"
});
var $d_Lscalacss_internal_Pseudo$Focus$ = new $TypeData().initClass({
  Lscalacss_internal_Pseudo$Focus$: 0
}, false, "scalacss.internal.Pseudo$Focus$", {
  Lscalacss_internal_Pseudo$Focus$: 1,
  Lscalacss_internal_Pseudo$Single: 1,
  Lscalacss_internal_Pseudo: 1,
  O: 1,
  Lscalacss_internal_Pseudo$ChainOps: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Pseudo$Focus$.prototype.$classData = $d_Lscalacss_internal_Pseudo$Focus$;
var $n_Lscalacss_internal_Pseudo$Focus$;
function $m_Lscalacss_internal_Pseudo$Focus$() {
  if ((!$n_Lscalacss_internal_Pseudo$Focus$)) {
    $n_Lscalacss_internal_Pseudo$Focus$ = new $c_Lscalacss_internal_Pseudo$Focus$()
  };
  return $n_Lscalacss_internal_Pseudo$Focus$
}
/** @constructor */
function $c_Lscalacss_internal_Pseudo$Hover$() {
  this.Lscalacss_internal_Pseudo$Single__f_cssValue = null;
  this.Lscalacss_internal_Pseudo$Single__f_pseudoType = null;
  $ct_Lscalacss_internal_Pseudo$Single__T__Lscalacss_internal_PseudoType__(this, ":hover", $m_Lscalacss_internal_PseudoType$Class$())
}
$c_Lscalacss_internal_Pseudo$Hover$.prototype = new $h_Lscalacss_internal_Pseudo$Single();
$c_Lscalacss_internal_Pseudo$Hover$.prototype.constructor = $c_Lscalacss_internal_Pseudo$Hover$;
/** @constructor */
function $h_Lscalacss_internal_Pseudo$Hover$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Pseudo$Hover$.prototype = $c_Lscalacss_internal_Pseudo$Hover$.prototype;
$c_Lscalacss_internal_Pseudo$Hover$.prototype.productPrefix__T = (function() {
  return "Hover"
});
$c_Lscalacss_internal_Pseudo$Hover$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscalacss_internal_Pseudo$Hover$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscalacss_internal_Pseudo$Hover$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalacss_internal_Pseudo$Hover$.prototype.hashCode__I = (function() {
  return 69916956
});
$c_Lscalacss_internal_Pseudo$Hover$.prototype.toString__T = (function() {
  return "Hover"
});
var $d_Lscalacss_internal_Pseudo$Hover$ = new $TypeData().initClass({
  Lscalacss_internal_Pseudo$Hover$: 0
}, false, "scalacss.internal.Pseudo$Hover$", {
  Lscalacss_internal_Pseudo$Hover$: 1,
  Lscalacss_internal_Pseudo$Single: 1,
  Lscalacss_internal_Pseudo: 1,
  O: 1,
  Lscalacss_internal_Pseudo$ChainOps: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalacss_internal_Pseudo$Hover$.prototype.$classData = $d_Lscalacss_internal_Pseudo$Hover$;
var $n_Lscalacss_internal_Pseudo$Hover$;
function $m_Lscalacss_internal_Pseudo$Hover$() {
  if ((!$n_Lscalacss_internal_Pseudo$Hover$)) {
    $n_Lscalacss_internal_Pseudo$Hover$ = new $c_Lscalacss_internal_Pseudo$Hover$()
  };
  return $n_Lscalacss_internal_Pseudo$Hover$
}
/** @constructor */
function $c_Lscalatags_JsDom$StringFrag(v) {
  this.Lscalatags_JsDom$StringFrag__f_v = null;
  this.Lscalatags_JsDom$StringFrag__f_v = v;
  if ((v === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_Lscalatags_JsDom$StringFrag.prototype = new $h_O();
$c_Lscalatags_JsDom$StringFrag.prototype.constructor = $c_Lscalatags_JsDom$StringFrag;
/** @constructor */
function $h_Lscalatags_JsDom$StringFrag() {
  /*<skip>*/
}
$h_Lscalatags_JsDom$StringFrag.prototype = $c_Lscalatags_JsDom$StringFrag.prototype;
$c_Lscalatags_JsDom$StringFrag.prototype.render__Lorg_scalajs_dom_Text = (function() {
  return document.createTextNode(this.Lscalatags_JsDom$StringFrag__f_v)
});
$c_Lscalatags_JsDom$StringFrag.prototype.productPrefix__T = (function() {
  return "StringFrag"
});
$c_Lscalatags_JsDom$StringFrag.prototype.productArity__I = (function() {
  return 1
});
$c_Lscalatags_JsDom$StringFrag.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscalatags_JsDom$StringFrag__f_v : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscalatags_JsDom$StringFrag.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalatags_JsDom$StringFrag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscalatags_JsDom$StringFrag.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscalatags_JsDom$StringFrag.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalatags_JsDom$StringFrag)) {
    var StringFrag$1 = $as_Lscalatags_JsDom$StringFrag(x$1);
    return ((this.Lscalatags_JsDom$StringFrag__f_v === $n(StringFrag$1).Lscalatags_JsDom$StringFrag__f_v) && ($n(StringFrag$1), true))
  } else {
    return false
  }
});
$c_Lscalatags_JsDom$StringFrag.prototype.applyTo__O__V = (function(t) {
  $f_Lscalatags_jsdom_Frag__applyTo__Lorg_scalajs_dom_Element__V(this, t)
});
$c_Lscalatags_JsDom$StringFrag.prototype.render__Lorg_scalajs_dom_Node = (function() {
  return this.render__Lorg_scalajs_dom_Text()
});
function $as_Lscalatags_JsDom$StringFrag(obj) {
  return (((obj instanceof $c_Lscalatags_JsDom$StringFrag) || (obj === null)) ? obj : $throwClassCastException(obj, "scalatags.JsDom$StringFrag"))
}
function $isArrayOf_Lscalatags_JsDom$StringFrag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalatags_JsDom$StringFrag)))
}
function $asArrayOf_Lscalatags_JsDom$StringFrag(obj, depth) {
  return (($isArrayOf_Lscalatags_JsDom$StringFrag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalatags.JsDom$StringFrag;", depth))
}
var $d_Lscalatags_JsDom$StringFrag = new $TypeData().initClass({
  Lscalatags_JsDom$StringFrag: 0
}, false, "scalatags.JsDom$StringFrag", {
  Lscalatags_JsDom$StringFrag: 1,
  O: 1,
  Lscalatags_jsdom_Frag: 1,
  Lscalatags_generic_Frag: 1,
  Lscalatags_generic_Modifier: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalatags_JsDom$StringFrag.prototype.$classData = $d_Lscalatags_JsDom$StringFrag;
function $p_Lscalatags_JsDom$tags2$__style$lzycompute__Lscalatags_JsDom$TypedTag($thiz) {
  if (((2 & $thiz.Lscalatags_JsDom$tags2$__f_bitmap$0) === 0)) {
    var ns = $m_Lscalatags_generic_Namespace$().Lscalatags_generic_Namespace$__f_htmlNamespaceConfig;
    $thiz.Lscalatags_JsDom$tags2$__f_style = $as_Lscalatags_JsDom$TypedTag($f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag($thiz, "style", false, ns));
    $thiz.Lscalatags_JsDom$tags2$__f_bitmap$0 = (2 | $thiz.Lscalatags_JsDom$tags2$__f_bitmap$0)
  };
  return $thiz.Lscalatags_JsDom$tags2$__f_style
}
/** @constructor */
function $c_Lscalatags_JsDom$tags2$() {
  this.Lscalatags_JsDom$tags2$__f_style = null;
  this.Lscalatags_JsDom$tags2$__f_bitmap$0 = 0
}
$c_Lscalatags_JsDom$tags2$.prototype = new $h_O();
$c_Lscalatags_JsDom$tags2$.prototype.constructor = $c_Lscalatags_JsDom$tags2$;
/** @constructor */
function $h_Lscalatags_JsDom$tags2$() {
  /*<skip>*/
}
$h_Lscalatags_JsDom$tags2$.prototype = $c_Lscalatags_JsDom$tags2$.prototype;
$c_Lscalatags_JsDom$tags2$.prototype.style__Lscalatags_JsDom$TypedTag = (function() {
  return (((2 & this.Lscalatags_JsDom$tags2$__f_bitmap$0) === 0) ? $p_Lscalatags_JsDom$tags2$__style$lzycompute__Lscalatags_JsDom$TypedTag(this) : this.Lscalatags_JsDom$tags2$__f_style)
});
var $d_Lscalatags_JsDom$tags2$ = new $TypeData().initClass({
  Lscalatags_JsDom$tags2$: 0
}, false, "scalatags.JsDom$tags2$", {
  Lscalatags_JsDom$tags2$: 1,
  O: 1,
  Lscalatags_JsDom$Cap: 1,
  Lscalatags_generic_Util: 1,
  Lscalatags_generic_LowPriUtil: 1,
  Lscalatags_jsdom_TagFactory: 1,
  Lscalatags_jsdom_Tags2: 1,
  Lscalatags_generic_Tags2: 1
});
$c_Lscalatags_JsDom$tags2$.prototype.$classData = $d_Lscalatags_JsDom$tags2$;
var $n_Lscalatags_JsDom$tags2$;
function $m_Lscalatags_JsDom$tags2$() {
  if ((!$n_Lscalatags_JsDom$tags2$)) {
    $n_Lscalatags_JsDom$tags2$ = new $c_Lscalatags_JsDom$tags2$()
  };
  return $n_Lscalatags_JsDom$tags2$
}
function $f_Lcats_FlatMap__product__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((a$2) => $thiz.map__O__F1__O(fb, new $c_sjsr_AnonFunction1(((b$2) => $ct_T2__O__O__(new $c_T2(), a$2, b$2)))))))
}
function $f_Lcats_FlatMap__map2__O__O__F2__O($thiz, fa, fb, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((a$2) => $thiz.map__O__F1__O(fb, new $c_sjsr_AnonFunction1(((b$2) => $n(f).apply__O__O__O(a$2, b$2)))))))
}
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalGroup() {
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = null;
  var this$1 = $n($m_s_package$().BigDecimal__s_math_BigDecimal$());
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = this$1.apply__I__Ljava_math_MathContext__s_math_BigDecimal(0, this$1.s_math_BigDecimal$__f_defaultMathContext)
}
$c_Lcats_kernel_instances_BigDecimalGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigDecimalGroup.prototype = $c_Lcats_kernel_instances_BigDecimalGroup.prototype;
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal = (function(x, y) {
  return $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__(new $c_s_math_BigDecimal(), $n($n(x).s_math_BigDecimal__f_bigDecimal).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($n(y).s_math_BigDecimal__f_bigDecimal), $n(x).s_math_BigDecimal__f_mc)
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal($as_s_math_BigDecimal(x), $as_s_math_BigDecimal(y))
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigDecimalGroup__f_empty
});
var $d_Lcats_kernel_instances_BigDecimalGroup = new $TypeData().initClass({
  Lcats_kernel_instances_BigDecimalGroup: 0
}, false, "cats.kernel.instances.BigDecimalGroup", {
  Lcats_kernel_instances_BigDecimalGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.$classData = $d_Lcats_kernel_instances_BigDecimalGroup;
/** @constructor */
function $c_Lcats_kernel_instances_BigIntGroup() {
  this.Lcats_kernel_instances_BigIntGroup__f_empty = null;
  this.Lcats_kernel_instances_BigIntGroup__f_empty = $n($m_s_package$().BigInt__s_math_BigInt$()).apply__I__s_math_BigInt(0)
}
$c_Lcats_kernel_instances_BigIntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntGroup.prototype.constructor = $c_Lcats_kernel_instances_BigIntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigIntGroup.prototype = $c_Lcats_kernel_instances_BigIntGroup.prototype;
$c_Lcats_kernel_instances_BigIntGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $n(x$1).$plus__s_math_BigInt__s_math_BigInt(y$1)
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigIntGroup__f_empty
});
var $d_Lcats_kernel_instances_BigIntGroup = new $TypeData().initClass({
  Lcats_kernel_instances_BigIntGroup: 0
}, false, "cats.kernel.instances.BigIntGroup", {
  Lcats_kernel_instances_BigIntGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.$classData = $d_Lcats_kernel_instances_BigIntGroup;
/** @constructor */
function $c_Lcats_kernel_instances_ByteGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ByteGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteGroup.prototype.constructor = $c_Lcats_kernel_instances_ByteGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ByteGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ByteGroup.prototype = $c_Lcats_kernel_instances_ByteGroup.prototype;
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__B__B__B = (function(x, y) {
  return ((((x + y) | 0) << 24) >> 24)
});
$c_Lcats_kernel_instances_ByteGroup.prototype.empty__O = (function() {
  return 0
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__B__B__B($uB(x), $uB(y))
});
var $d_Lcats_kernel_instances_ByteGroup = new $TypeData().initClass({
  Lcats_kernel_instances_ByteGroup: 0
}, false, "cats.kernel.instances.ByteGroup", {
  Lcats_kernel_instances_ByteGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_kernel_instances_ByteGroup.prototype.$classData = $d_Lcats_kernel_instances_ByteGroup;
/** @constructor */
function $c_Lcats_kernel_instances_DurationGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationGroup.prototype.constructor = $c_Lcats_kernel_instances_DurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DurationGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DurationGroup.prototype = $c_Lcats_kernel_instances_DurationGroup.prototype;
$c_Lcats_kernel_instances_DurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  return $n(x$1).$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration(y$1)
});
$c_Lcats_kernel_instances_DurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero
});
var $d_Lcats_kernel_instances_DurationGroup = new $TypeData().initClass({
  Lcats_kernel_instances_DurationGroup: 0
}, false, "cats.kernel.instances.DurationGroup", {
  Lcats_kernel_instances_DurationGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_kernel_instances_DurationGroup.prototype.$classData = $d_Lcats_kernel_instances_DurationGroup;
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FiniteDurationGroup.prototype = $c_Lcats_kernel_instances_FiniteDurationGroup.prototype;
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  var this$1 = $n(x$1);
  return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this$1, $n(y$1).s_concurrent_duration_FiniteDuration__f_length, $n(y$1).s_concurrent_duration_FiniteDuration__f_unit)
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero
});
var $d_Lcats_kernel_instances_FiniteDurationGroup = new $TypeData().initClass({
  Lcats_kernel_instances_FiniteDurationGroup: 0
}, false, "cats.kernel.instances.FiniteDurationGroup", {
  Lcats_kernel_instances_FiniteDurationGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.$classData = $d_Lcats_kernel_instances_FiniteDurationGroup;
/** @constructor */
function $c_Lcats_kernel_instances_ShortGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ShortGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortGroup.prototype.constructor = $c_Lcats_kernel_instances_ShortGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ShortGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ShortGroup.prototype = $c_Lcats_kernel_instances_ShortGroup.prototype;
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__S__S__S = (function(x, y) {
  return ((((x + y) | 0) << 16) >> 16)
});
$c_Lcats_kernel_instances_ShortGroup.prototype.empty__O = (function() {
  return 0
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__S__S__S($uS(x), $uS(y))
});
var $d_Lcats_kernel_instances_ShortGroup = new $TypeData().initClass({
  Lcats_kernel_instances_ShortGroup: 0
}, false, "cats.kernel.instances.ShortGroup", {
  Lcats_kernel_instances_ShortGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_kernel_instances_ShortGroup.prototype.$classData = $d_Lcats_kernel_instances_ShortGroup;
/** @constructor */
function $c_Lcats_kernel_instances_StringOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_StringOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_StringOrder.prototype.constructor = $c_Lcats_kernel_instances_StringOrder;
/** @constructor */
function $h_Lcats_kernel_instances_StringOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StringOrder.prototype = $c_Lcats_kernel_instances_StringOrder.prototype;
$c_Lcats_kernel_instances_StringOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_StringOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__T__T__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__T__T__I = (function(x, y) {
  return ((x === y) ? 0 : $f_T__compareTo__T__I($n(x), y))
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T__T__I($as_T(x), $as_T(y))
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__T__T__Z($as_T(x), $as_T(y))
});
var $d_Lcats_kernel_instances_StringOrder = new $TypeData().initClass({
  Lcats_kernel_instances_StringOrder: 0
}, false, "cats.kernel.instances.StringOrder", {
  Lcats_kernel_instances_StringOrder: 1,
  O: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_StringLowerBounded: 1,
  Lcats_kernel_LowerBounded: 1
});
$c_Lcats_kernel_instances_StringOrder.prototype.$classData = $d_Lcats_kernel_instances_StringOrder;
/** @constructor */
function $c_Lcats_kernel_instances_SymbolOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_SymbolOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_SymbolOrder.prototype.constructor = $c_Lcats_kernel_instances_SymbolOrder;
/** @constructor */
function $h_Lcats_kernel_instances_SymbolOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_SymbolOrder.prototype = $c_Lcats_kernel_instances_SymbolOrder.prototype;
$c_Lcats_kernel_instances_SymbolOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.eqv__s_Symbol__s_Symbol__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.compare__s_Symbol__s_Symbol__I = (function(x, y) {
  return ((x === y) ? 0 : $f_T__compareTo__T__I($n($n(x).s_Symbol__f_name), $n(y).s_Symbol__f_name))
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__s_Symbol__s_Symbol__I($as_s_Symbol(x), $as_s_Symbol(y))
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_Symbol__s_Symbol__Z($as_s_Symbol(x), $as_s_Symbol(y))
});
var $d_Lcats_kernel_instances_SymbolOrder = new $TypeData().initClass({
  Lcats_kernel_instances_SymbolOrder: 0
}, false, "cats.kernel.instances.SymbolOrder", {
  Lcats_kernel_instances_SymbolOrder: 1,
  O: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_SymbolLowerBounded: 1,
  Lcats_kernel_LowerBounded: 1
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.$classData = $d_Lcats_kernel_instances_SymbolOrder;
function $as_Ldiode_ActionResult$ModelUpdateSilentEffect(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "diode.ActionResult$ModelUpdateSilentEffect"))
}
function $isArrayOf_Ldiode_ActionResult$ModelUpdateSilentEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldiode_ActionResult$ModelUpdateSilentEffect)))
}
function $asArrayOf_Ldiode_ActionResult$ModelUpdateSilentEffect(obj, depth) {
  return (($isArrayOf_Ldiode_ActionResult$ModelUpdateSilentEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldiode.ActionResult$ModelUpdateSilentEffect;", depth))
}
/** @constructor */
function $c_Ldiode_RootModelRW(get) {
  this.Ldiode_RootModelR__f_get = null;
  $ct_Ldiode_RootModelR__F0__(this, get)
}
$c_Ldiode_RootModelRW.prototype = new $h_Ldiode_RootModelR();
$c_Ldiode_RootModelRW.prototype.constructor = $c_Ldiode_RootModelRW;
/** @constructor */
function $h_Ldiode_RootModelRW() {
  /*<skip>*/
}
$h_Ldiode_RootModelRW.prototype = $c_Ldiode_RootModelRW.prototype;
$c_Ldiode_RootModelRW.prototype.updatedWith__O__O__O = (function(model, value) {
  return value
});
var $d_Ldiode_RootModelRW = new $TypeData().initClass({
  Ldiode_RootModelRW: 0
}, false, "diode.RootModelRW", {
  Ldiode_RootModelRW: 1,
  Ldiode_RootModelR: 1,
  O: 1,
  Ldiode_BaseModelR: 1,
  Ldiode_ModelR: 1,
  Ldiode_ModelRO: 1,
  Ldiode_BaseModelRW: 1,
  Ldiode_ModelRW: 1,
  Ldiode_ZoomTo: 1
});
$c_Ldiode_RootModelRW.prototype.$classData = $d_Ldiode_RootModelRW;
/** @constructor */
function $c_Ldiode_ZoomModelRW(root, get, set, feq) {
  this.Ldiode_ZoomModelR__f_root = null;
  this.Ldiode_ZoomModelR__f_get = null;
  this.Ldiode_ZoomModelR__f_feq = null;
  this.Ldiode_ZoomModelRW__f_set = null;
  this.Ldiode_ZoomModelRW__f_set = set;
  $ct_Ldiode_ZoomModelR__Ldiode_ModelR__F1__Ldiode_FastEq__(this, root, get, feq)
}
$c_Ldiode_ZoomModelRW.prototype = new $h_Ldiode_ZoomModelR();
$c_Ldiode_ZoomModelRW.prototype.constructor = $c_Ldiode_ZoomModelRW;
/** @constructor */
function $h_Ldiode_ZoomModelRW() {
  /*<skip>*/
}
$h_Ldiode_ZoomModelRW.prototype = $c_Ldiode_ZoomModelRW.prototype;
$c_Ldiode_ZoomModelRW.prototype.updatedWith__O__O__O = (function(model, value) {
  return $n(this.Ldiode_ZoomModelRW__f_set).apply__O__O__O(model, value)
});
var $d_Ldiode_ZoomModelRW = new $TypeData().initClass({
  Ldiode_ZoomModelRW: 0
}, false, "diode.ZoomModelRW", {
  Ldiode_ZoomModelRW: 1,
  Ldiode_ZoomModelR: 1,
  O: 1,
  Ldiode_BaseModelR: 1,
  Ldiode_ModelR: 1,
  Ldiode_ModelRO: 1,
  Ldiode_BaseModelRW: 1,
  Ldiode_ModelRW: 1,
  Ldiode_ZoomTo: 1
});
$c_Ldiode_ZoomModelRW.prototype.$classData = $d_Ldiode_ZoomModelRW;
function $is_Lio_circe_Codec$AsObject(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_circe_Codec$AsObject)))
}
function $as_Lio_circe_Codec$AsObject(obj) {
  return (($is_Lio_circe_Codec$AsObject(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Codec$AsObject"))
}
function $isArrayOf_Lio_circe_Codec$AsObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Codec$AsObject)))
}
function $asArrayOf_Lio_circe_Codec$AsObject(obj, depth) {
  return (($isArrayOf_Lio_circe_Codec$AsObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Codec$AsObject;", depth))
}
function $p_Lio_circe_Encoder$__encodeUUID$lzycompute__Lio_circe_Encoder($thiz) {
  if (((1024 & $thiz.Lio_circe_Encoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Encoder$__f_encodeUUID = new $c_Lio_circe_Encoder$$anon$20();
    $thiz.Lio_circe_Encoder$__f_bitmap$0 = (1024 | $thiz.Lio_circe_Encoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Encoder$__f_encodeUUID
}
function $p_Lio_circe_Encoder$__encodeDuration$lzycompute__Lio_circe_Encoder($thiz) {
  if (((2048 & $thiz.Lio_circe_Encoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Encoder$__f_encodeDuration = new $c_Lio_circe_Encoder$$anon$37();
    $thiz.Lio_circe_Encoder$__f_bitmap$0 = (2048 | $thiz.Lio_circe_Encoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Encoder$__f_encodeDuration
}
function $p_Lio_circe_Encoder$__encodeInstant$lzycompute__Lio_circe_Encoder($thiz) {
  if (((4096 & $thiz.Lio_circe_Encoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Encoder$__f_encodeInstant = new $c_Lio_circe_Encoder$$anon$38();
    $thiz.Lio_circe_Encoder$__f_bitmap$0 = (4096 | $thiz.Lio_circe_Encoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Encoder$__f_encodeInstant
}
function $p_Lio_circe_Encoder$__encodePeriod$lzycompute__Lio_circe_Encoder($thiz) {
  if (((8192 & $thiz.Lio_circe_Encoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Encoder$__f_encodePeriod = new $c_Lio_circe_Encoder$$anon$39();
    $thiz.Lio_circe_Encoder$__f_bitmap$0 = (8192 | $thiz.Lio_circe_Encoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Encoder$__f_encodePeriod
}
function $p_Lio_circe_Encoder$__encodeLocalDate$lzycompute__Lio_circe_Encoder($thiz) {
  if (((32768 & $thiz.Lio_circe_Encoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Encoder$__f_encodeLocalDate = new $c_Lio_circe_Encoder$$anon$51();
    $thiz.Lio_circe_Encoder$__f_bitmap$0 = (32768 | $thiz.Lio_circe_Encoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Encoder$__f_encodeLocalDate
}
function $p_Lio_circe_Encoder$__encodeLocalTime$lzycompute__Lio_circe_Encoder($thiz) {
  if (((65536 & $thiz.Lio_circe_Encoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Encoder$__f_encodeLocalTime = new $c_Lio_circe_Encoder$$anon$52();
    $thiz.Lio_circe_Encoder$__f_bitmap$0 = (65536 | $thiz.Lio_circe_Encoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Encoder$__f_encodeLocalTime
}
function $p_Lio_circe_Encoder$__encodeLocalDateTime$lzycompute__Lio_circe_Encoder($thiz) {
  if (((131072 & $thiz.Lio_circe_Encoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Encoder$__f_encodeLocalDateTime = new $c_Lio_circe_Encoder$$anon$53();
    $thiz.Lio_circe_Encoder$__f_bitmap$0 = (131072 | $thiz.Lio_circe_Encoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Encoder$__f_encodeLocalDateTime
}
/** @constructor */
function $c_Lio_circe_Encoder$() {
  this.Lio_circe_Encoder$__f_encodeUUID = null;
  this.Lio_circe_Encoder$__f_encodeDuration = null;
  this.Lio_circe_Encoder$__f_encodeInstant = null;
  this.Lio_circe_Encoder$__f_encodePeriod = null;
  this.Lio_circe_Encoder$__f_encodeLocalDate = null;
  this.Lio_circe_Encoder$__f_encodeLocalTime = null;
  this.Lio_circe_Encoder$__f_encodeLocalDateTime = null;
  this.Lio_circe_Encoder$__f_encodeJson = null;
  this.Lio_circe_Encoder$__f_encodeJsonObject = null;
  this.Lio_circe_Encoder$__f_encodeString = null;
  this.Lio_circe_Encoder$__f_encodeUnit = null;
  this.Lio_circe_Encoder$__f_encodeBoolean = null;
  this.Lio_circe_Encoder$__f_encodeFloat = null;
  this.Lio_circe_Encoder$__f_encodeDouble = null;
  this.Lio_circe_Encoder$__f_encodeInt = null;
  this.Lio_circe_Encoder$__f_encodeLong = null;
  this.Lio_circe_Encoder$__f_bitmap$0 = 0;
  $n_Lio_circe_Encoder$ = this;
  this.Lio_circe_Encoder$__f_encodeJson = new $c_Lio_circe_Encoder$$anon$5();
  this.Lio_circe_Encoder$__f_encodeJsonObject = new $c_Lio_circe_Encoder$$anon$6();
  new $c_Lio_circe_Encoder$$anon$7();
  this.Lio_circe_Encoder$__f_encodeString = new $c_Lio_circe_Encoder$$anon$8();
  this.Lio_circe_Encoder$__f_encodeUnit = new $c_Lio_circe_Encoder$$anon$9();
  this.Lio_circe_Encoder$__f_encodeBoolean = new $c_Lio_circe_Encoder$$anon$10();
  new $c_Lio_circe_Encoder$$anon$11();
  this.Lio_circe_Encoder$__f_encodeFloat = new $c_Lio_circe_Encoder$$anon$12();
  this.Lio_circe_Encoder$__f_encodeDouble = new $c_Lio_circe_Encoder$$anon$13();
  new $c_Lio_circe_Encoder$$anon$14();
  new $c_Lio_circe_Encoder$$anon$15();
  this.Lio_circe_Encoder$__f_encodeInt = new $c_Lio_circe_Encoder$$anon$16();
  this.Lio_circe_Encoder$__f_encodeLong = new $c_Lio_circe_Encoder$$anon$17();
  new $c_Lio_circe_Encoder$$anon$18();
  new $c_Lio_circe_Encoder$$anon$19();
  new $c_Lio_circe_Encoder$$anon$22();
  new $c_Lio_circe_Encoder$$anon$36()
}
$c_Lio_circe_Encoder$.prototype = new $h_O();
$c_Lio_circe_Encoder$.prototype.constructor = $c_Lio_circe_Encoder$;
/** @constructor */
function $h_Lio_circe_Encoder$() {
  /*<skip>*/
}
$h_Lio_circe_Encoder$.prototype = $c_Lio_circe_Encoder$.prototype;
$c_Lio_circe_Encoder$.prototype.encodeUUID__Lio_circe_Encoder = (function() {
  return (((1024 & this.Lio_circe_Encoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Encoder$__encodeUUID$lzycompute__Lio_circe_Encoder(this) : this.Lio_circe_Encoder$__f_encodeUUID)
});
$c_Lio_circe_Encoder$.prototype.encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject = (function(encodeK, encodeV) {
  var ev = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_sci_Map(x$2);
    return x
  }));
  return new $c_Lio_circe_Encoder$$anon$34(encodeK, encodeV, ev)
});
$c_Lio_circe_Encoder$.prototype.encodeDuration__Lio_circe_Encoder = (function() {
  return (((2048 & this.Lio_circe_Encoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Encoder$__encodeDuration$lzycompute__Lio_circe_Encoder(this) : this.Lio_circe_Encoder$__f_encodeDuration)
});
$c_Lio_circe_Encoder$.prototype.encodeInstant__Lio_circe_Encoder = (function() {
  return (((4096 & this.Lio_circe_Encoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Encoder$__encodeInstant$lzycompute__Lio_circe_Encoder(this) : this.Lio_circe_Encoder$__f_encodeInstant)
});
$c_Lio_circe_Encoder$.prototype.encodePeriod__Lio_circe_Encoder = (function() {
  return (((8192 & this.Lio_circe_Encoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Encoder$__encodePeriod$lzycompute__Lio_circe_Encoder(this) : this.Lio_circe_Encoder$__f_encodePeriod)
});
$c_Lio_circe_Encoder$.prototype.encodeLocalDate__Lio_circe_Encoder = (function() {
  return (((32768 & this.Lio_circe_Encoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Encoder$__encodeLocalDate$lzycompute__Lio_circe_Encoder(this) : this.Lio_circe_Encoder$__f_encodeLocalDate)
});
$c_Lio_circe_Encoder$.prototype.encodeLocalTime__Lio_circe_Encoder = (function() {
  return (((65536 & this.Lio_circe_Encoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Encoder$__encodeLocalTime$lzycompute__Lio_circe_Encoder(this) : this.Lio_circe_Encoder$__f_encodeLocalTime)
});
$c_Lio_circe_Encoder$.prototype.encodeLocalDateTime__Lio_circe_Encoder = (function() {
  return (((131072 & this.Lio_circe_Encoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Encoder$__encodeLocalDateTime$lzycompute__Lio_circe_Encoder(this) : this.Lio_circe_Encoder$__f_encodeLocalDateTime)
});
var $d_Lio_circe_Encoder$ = new $TypeData().initClass({
  Lio_circe_Encoder$: 0
}, false, "io.circe.Encoder$", {
  Lio_circe_Encoder$: 1,
  O: 1,
  Lio_circe_TupleEncoders: 1,
  Lio_circe_ProductEncoders: 1,
  Lio_circe_LiteralEncoders: 1,
  Lio_circe_EnumerationEncoders: 1,
  Lio_circe_MidPriorityEncoders: 1,
  Lio_circe_LowPriorityEncoders: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Encoder$.prototype.$classData = $d_Lio_circe_Encoder$;
var $n_Lio_circe_Encoder$;
function $m_Lio_circe_Encoder$() {
  if ((!$n_Lio_circe_Encoder$)) {
    $n_Lio_circe_Encoder$ = new $c_Lio_circe_Encoder$()
  };
  return $n_Lio_circe_Encoder$
}
/** @constructor */
function $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec() {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec.prototype = new $h_Lio_circe_generic_extras_decoding_ReprDecoder();
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec.prototype.constructor = $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec;
/** @constructor */
function $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_codec_ReprAsObjectCodec.prototype = $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec.prototype;
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__encodeObject__O__Lio_circe_JsonObject(this, a)
});
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
function $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O($thiz) {
  return $n($n($as_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base($thiz)).mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O()
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$I7(input, hook1, hook2, hook3, hook4, hook5, hook6, hook7) {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I6__f_hook6 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I7__f_hook7 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$I7__f_hook7 = hook7;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$I6__O__O__O__O__O__O__O__(this, input, hook1, hook2, hook3, hook4, hook5, hook6)
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I7.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$I6();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I7.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I7;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$I7() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$I7.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$I7.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I7.prototype.toString__T = (function() {
  return (((((((((((((((("HookCtx.withInput(\n  input = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$I0__f_input) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I6__f_hook6) + ",\n  hook7 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$I7__f_hook7) + ")")
});
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$I7 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$I7: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$I7", {
  Ljapgolly_scalajs_react_hooks_HookCtx$I7: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$I0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$I7.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$I7;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P7__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7 = hook7;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P6__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P7() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P7.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P6();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P7.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P7;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P7() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P7.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P7.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P7.prototype.toString__T = (function() {
  return (((((((((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6) + ",\n  hook7 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P7(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P7) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P7"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P7(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P7)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P7(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P7(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P7;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P7 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P7: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P7", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P7: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P7.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P7;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(raw, FF) {
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw = null;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_FF = null;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw = raw;
  this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_FF = FF
}
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype = $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype;
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.set__O__O = (function(a) {
  $n(this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_FF);
  var a$1 = new $c_sjsr_AnonFunction0((() => {
    this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current = a
  }));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a$1)))
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.get__O = (function() {
  $n(this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_FF);
  var a = new $c_sjsr_AnonFunction0((() => this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw.current));
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.productPrefix__T = (function() {
  return "UseRefF"
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.productArity__I = (function() {
  return 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF)) {
    var UseRefF$1 = $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(x$1);
    var x = this.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw;
    var y = $n(UseRefF$1).Ljapgolly_scalajs_react_hooks_Hooks$UseRefF__f_raw;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.Hooks$UseRefF"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_Hooks$UseRefF)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.Hooks$UseRefF;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_Hooks$UseRefF: 0
}, false, "japgolly.scalajs.react.hooks.Hooks$UseRefF", {
  Ljapgolly_scalajs_react_hooks_Hooks$UseRefF: 1,
  O: 1,
  Ljapgolly_scalajs_react_NonEmptyRef$FullF: 1,
  Ljapgolly_scalajs_react_NonEmptyRef$HandleF: 1,
  Ljapgolly_scalajs_react_NonEmptyRef$SetF: 1,
  Ljapgolly_scalajs_react_NonEmptyRef$GetF: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_Hooks$UseRefF;
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_Effect$() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_Effect$.prototype = new $h_Ljapgolly_scalajs_react_util_EffectFallbacks();
$c_Ljapgolly_scalajs_react_util_Effect$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_Effect$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_Effect$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_Effect$.prototype = $c_Ljapgolly_scalajs_react_util_Effect$.prototype;
var $d_Ljapgolly_scalajs_react_util_Effect$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_Effect$: 0
}, false, "japgolly.scalajs.react.util.Effect$", {
  Ljapgolly_scalajs_react_util_Effect$: 1,
  Ljapgolly_scalajs_react_util_EffectFallbacks: 1,
  Ljapgolly_scalajs_react_util_EffectFallbacks1: 1,
  Ljapgolly_scalajs_react_util_EffectFallbacks2: 1,
  Ljapgolly_scalajs_react_util_EffectFallbacks3: 1,
  Ljapgolly_scalajs_react_util_EffectFallbacks4: 1,
  Ljapgolly_scalajs_react_util_EffectFallbacks5: 1,
  Ljapgolly_scalajs_react_userdefined_Effects: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_util_Effect$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_Effect$;
var $n_Ljapgolly_scalajs_react_util_Effect$;
function $m_Ljapgolly_scalajs_react_util_Effect$() {
  if ((!$n_Ljapgolly_scalajs_react_util_Effect$)) {
    $n_Ljapgolly_scalajs_react_util_Effect$ = new $c_Ljapgolly_scalajs_react_util_Effect$()
  };
  return $n_Ljapgolly_scalajs_react_util_Effect$
}
function $f_Ljapgolly_scalajs_react_util_Effect$Sync$WithDefaultDispatch__dispatch__O__V($thiz, fa) {
  var f = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  if ((!$m_Ljapgolly_scalajs_react_callback_CallbackTo$().isEmpty_$qmark$extension__Ljapgolly_scalajs_react_callback_Trampoline__Z(f))) {
    var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$2 = $n(this$);
    $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)
  }
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1() {
  /*<skip>*/
}
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype = $c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.delay__F0__O = (function(a) {
  return $n(a).apply__O()
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.dispatch__O__V = (function(a) {
  /*<skip>*/
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.finallyRun__F0__F0__O = (function(a, runFinally) {
  try {
    return $n(a).apply__O()
  } finally {
    $n(runFinally).apply__O()
  }
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.flatMap__O__F1__O = (function(a, f) {
  return $n(f).apply__O__O(a)
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.map__O__F1__O = (function(a, f) {
  return $n(f).apply__O__O(a)
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.pure__O__O = (function(a) {
  return a
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.runSync__F0__O = (function(a) {
  return $n(a).apply__O()
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.handleError__F0__F1__O = (function(a, f) {
  try {
    return $n(a).apply__O()
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    return $n(f).apply__O__O(e$2)
  }
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.chain__O__O__O = (function(fa, fb) {
  return $f_Ljapgolly_scalajs_react_util_Monad__chain__O__O__O(this, fa, fb)
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.dispatchFn__F0__sjs_js_Function0 = (function(fa) {
  return $f_Ljapgolly_scalajs_react_util_Effect$Dispatch$WithDefaults__dispatchFn__F0__sjs_js_Function0(this, fa)
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.toJsFn__F0__sjs_js_Function0 = (function(f) {
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$WithDefaults__toJsFn__F0__sjs_js_Function0(this, f)
});
var $d_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1: 0
}, false, "japgolly.scalajs.react.util.Effect$UnsafeSync$$anon$1", {
  Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1: 1,
  O: 1,
  Ljapgolly_scalajs_react_util_Effect$UnsafeSync$WithDefaults: 1,
  Ljapgolly_scalajs_react_util_Effect$UnsafeSync: 1,
  Ljapgolly_scalajs_react_util_Effect$Dispatch: 1,
  Ljapgolly_scalajs_react_util_Effect: 1,
  Ljapgolly_scalajs_react_util_Monad: 1,
  Ljapgolly_scalajs_react_util_Effect$Dispatch$WithDefaults: 1,
  Ljapgolly_scalajs_react_util_Effect$WithDefaults: 1
});
$c_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$$anon$1;
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (($as_T((typeof console)) !== "undefined")) {
    if (($thiz.jl_JSConsoleBasedPrintStream__f_isErr && $uZ((!(!console.error))))) {
      console.error(line)
    } else {
      console.log(line)
    }
  }
}
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.jl_JSConsoleBasedPrintStream__f_isErr = false;
  this.jl_JSConsoleBasedPrintStream__f_buffer = null;
  this.jl_JSConsoleBasedPrintStream__f_isErr = isErr;
  var out = new $c_jl_JSConsoleBasedPrintStream$DummyOutputStream();
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, out, false, null);
  this.jl_JSConsoleBasedPrintStream__f_buffer = ""
}
$c_jl_JSConsoleBasedPrintStream.prototype = new $h_Ljava_io_PrintStream();
$c_jl_JSConsoleBasedPrintStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
  /*<skip>*/
}
$h_jl_JSConsoleBasedPrintStream.prototype = $c_jl_JSConsoleBasedPrintStream.prototype;
$c_jl_JSConsoleBasedPrintStream.prototype.print__C__V = (function(c) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V($as_T(String.fromCharCode(c)))
});
$c_jl_JSConsoleBasedPrintStream.prototype.print__T__V = (function(s) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(((s === null) ? "null" : s))
});
$c_jl_JSConsoleBasedPrintStream.prototype.java$lang$JSConsoleBasedPrintStream$$printString__T__V = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = $n(rest);
    var nlPos = $uI(this$1.indexOf("\n"));
    if ((nlPos < 0)) {
      this.jl_JSConsoleBasedPrintStream__f_buffer = (("" + this.jl_JSConsoleBasedPrintStream__f_buffer) + rest);
      rest = ""
    } else {
      var $$x1 = this.jl_JSConsoleBasedPrintStream__f_buffer;
      var this$2 = $n(rest);
      if ((nlPos > this$2.length)) {
        $charAt(this$2, nlPos)
      };
      if ((nlPos < 0)) {
        $charAt(this$2, (-1))
      };
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $$x1) + $as_T(this$2.substring(0, nlPos))));
      this.jl_JSConsoleBasedPrintStream__f_buffer = "";
      var this$3 = $n(rest);
      var beginIndex = ((1 + nlPos) | 0);
      if (((beginIndex < 0) || (beginIndex > this$3.length))) {
        $charAt(this$3, beginIndex)
      };
      rest = $as_T(this$3.substring(beginIndex))
    }
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $TypeData().initClass({
  jl_JSConsoleBasedPrintStream: 0
}, false, "java.lang.JSConsoleBasedPrintStream", {
  jl_JSConsoleBasedPrintStream: 1,
  Ljava_io_PrintStream: 1,
  Ljava_io_FilterOutputStream: 1,
  Ljava_io_OutputStream: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1,
  jl_Appendable: 1
});
$c_jl_JSConsoleBasedPrintStream.prototype.$classData = $d_jl_JSConsoleBasedPrintStream;
function $p_Ljava_time_LocalDate__month__S($thiz) {
  if (((((1 & $thiz.Ljava_time_LocalDate__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalDate.scala: 351")
  };
  return $thiz.Ljava_time_LocalDate__f_month
}
function $p_Ljava_time_LocalDate__day__S($thiz) {
  if (((((2 & $thiz.Ljava_time_LocalDate__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scala-java-time/scala-java-time/core/js/target/scala-2.13/src_managed/main/org/threeten/bp/LocalDate.scala: 354")
  };
  return $thiz.Ljava_time_LocalDate__f_day
}
function $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x1 = $as_Ljava_time_temporal_ChronoField(field);
  var x = $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  if ((x === null)) {
    var $$x1 = (x1 === null)
  } else {
    var this$1 = $n(x);
    var $$x1 = (this$1 === x1)
  };
  if ($$x1) {
    var value = $n($thiz.getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I();
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  } else {
    var x$3 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $$x2 = (x1 === null)
    } else {
      var this$3 = $n(x$3);
      var $$x2 = (this$3 === x1)
    };
    if ($$x2) {
      var value$1 = $p_Ljava_time_LocalDate__day__S($thiz);
      var hi$1 = (value$1 >> 31);
      var lo = (((-1) + value$1) | 0);
      var hi$2 = ((lo !== (-1)) ? hi$1 : (((-1) + hi$1) | 0));
      var this$6 = $m_RTLong$();
      var lo$1 = this$6.remainderImpl__I__I__I__I__I(lo, hi$2, 7, 0);
      var hi$3 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var lo$2 = ((1 + lo$1) | 0);
      var hi$4 = ((lo$2 === 0) ? ((1 + hi$3) | 0) : hi$3);
      return new $c_RTLong(lo$2, hi$4)
    } else {
      var x$5 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
      if ((x$5 === null)) {
        var $$x3 = (x1 === null)
      } else {
        var this$8 = $n(x$5);
        var $$x3 = (this$8 === x1)
      };
      if ($$x3) {
        var value$2 = $thiz.getDayOfYear__I();
        var hi$5 = (value$2 >> 31);
        var lo$3 = (((-1) + value$2) | 0);
        var hi$6 = ((lo$3 !== (-1)) ? hi$5 : (((-1) + hi$5) | 0));
        var this$11 = $m_RTLong$();
        var lo$4 = this$11.remainderImpl__I__I__I__I__I(lo$3, hi$6, 7, 0);
        var hi$7 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var lo$5 = ((1 + lo$4) | 0);
        var hi$8 = ((lo$5 === 0) ? ((1 + hi$7) | 0) : hi$7);
        return new $c_RTLong(lo$5, hi$8)
      } else {
        var x$7 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
        if ((x$7 === null)) {
          var $$x4 = (x1 === null)
        } else {
          var this$13 = $n(x$7);
          var $$x4 = (this$13 === x1)
        };
        if ($$x4) {
          var value$3 = $p_Ljava_time_LocalDate__day__S($thiz);
          var hi$9 = (value$3 >> 31);
          return new $c_RTLong(value$3, hi$9)
        } else {
          var x$9 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
          if ((x$9 === null)) {
            var $$x5 = (x1 === null)
          } else {
            var this$15 = $n(x$9);
            var $$x5 = (this$15 === x1)
          };
          if ($$x5) {
            var value$4 = $thiz.getDayOfYear__I();
            var hi$10 = (value$4 >> 31);
            return new $c_RTLong(value$4, hi$10)
          } else {
            var x$11 = $m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField();
            if ((x$11 === null)) {
              var $$x6 = (x1 === null)
            } else {
              var this$17 = $n(x$11);
              var $$x6 = (this$17 === x1)
            };
            if ($$x6) {
              throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
            } else {
              var x$13 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
              if ((x$13 === null)) {
                var $$x7 = (x1 === null)
              } else {
                var this$18 = $n(x$13);
                var $$x7 = (this$18 === x1)
              };
              if ($$x7) {
                var value$5 = $p_Ljava_time_LocalDate__day__S($thiz);
                var hi$11 = (value$5 >> 31);
                var lo$6 = (((-1) + value$5) | 0);
                var hi$12 = ((lo$6 !== (-1)) ? hi$11 : (((-1) + hi$11) | 0));
                var this$21 = $m_RTLong$();
                var lo$7 = this$21.divideImpl__I__I__I__I__I(lo$6, hi$12, 7, 0);
                var hi$13 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                var lo$8 = ((1 + lo$7) | 0);
                var hi$14 = ((lo$8 === 0) ? ((1 + hi$13) | 0) : hi$13);
                return new $c_RTLong(lo$8, hi$14)
              } else {
                var x$15 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
                if ((x$15 === null)) {
                  var $$x8 = (x1 === null)
                } else {
                  var this$23 = $n(x$15);
                  var $$x8 = (this$23 === x1)
                };
                if ($$x8) {
                  var value$6 = $thiz.getDayOfYear__I();
                  var hi$15 = (value$6 >> 31);
                  var lo$9 = (((-1) + value$6) | 0);
                  var hi$16 = ((lo$9 !== (-1)) ? hi$15 : (((-1) + hi$15) | 0));
                  var this$26 = $m_RTLong$();
                  var lo$10 = this$26.divideImpl__I__I__I__I__I(lo$9, hi$16, 7, 0);
                  var hi$17 = this$26.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var lo$11 = ((1 + lo$10) | 0);
                  var hi$18 = ((lo$11 === 0) ? ((1 + hi$17) | 0) : hi$17);
                  return new $c_RTLong(lo$11, hi$18)
                } else {
                  var x$17 = $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
                  if ((x$17 === null)) {
                    var $$x9 = (x1 === null)
                  } else {
                    var this$28 = $n(x$17);
                    var $$x9 = (this$28 === x1)
                  };
                  if ($$x9) {
                    var value$7 = $p_Ljava_time_LocalDate__month__S($thiz);
                    var hi$19 = (value$7 >> 31);
                    return new $c_RTLong(value$7, hi$19)
                  } else {
                    var x$19 = $m_Ljava_time_temporal_ChronoField$().PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
                    if ((x$19 === null)) {
                      var $$x10 = (x1 === null)
                    } else {
                      var this$30 = $n(x$19);
                      var $$x10 = (this$30 === x1)
                    };
                    if ($$x10) {
                      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field))
                    } else {
                      var x$21 = $m_Ljava_time_temporal_ChronoField$().YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
                      if ((x$21 === null)) {
                        var $$x11 = (x1 === null)
                      } else {
                        var this$31 = $n(x$21);
                        var $$x11 = (this$31 === x1)
                      };
                      if ($$x11) {
                        if (($thiz.Ljava_time_LocalDate__f_year >= 1)) {
                          var value$8 = $thiz.Ljava_time_LocalDate__f_year;
                          var hi$20 = (value$8 >> 31);
                          return new $c_RTLong(value$8, hi$20)
                        } else {
                          var value$9 = $thiz.Ljava_time_LocalDate__f_year;
                          var hi$21 = (value$9 >> 31);
                          var lo$12 = ((1 - value$9) | 0);
                          var hi$22 = ((((-2147483648) ^ lo$12) > (-2147483647)) ? (((-1) - hi$21) | 0) : ((-hi$21) | 0));
                          return new $c_RTLong(lo$12, hi$22)
                        }
                      } else {
                        var x$23 = $m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField();
                        if ((x$23 === null)) {
                          var $$x12 = (x1 === null)
                        } else {
                          var this$35 = $n(x$23);
                          var $$x12 = (this$35 === x1)
                        };
                        if ($$x12) {
                          var value$10 = $thiz.Ljava_time_LocalDate__f_year;
                          var hi$23 = (value$10 >> 31);
                          return new $c_RTLong(value$10, hi$23)
                        } else {
                          var x$25 = $m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField();
                          if ((x$25 === null)) {
                            var $$x13 = (x1 === null)
                          } else {
                            var this$37 = $n(x$25);
                            var $$x13 = (this$37 === x1)
                          };
                          if ($$x13) {
                            return (($thiz.Ljava_time_LocalDate__f_year >= 1) ? new $c_RTLong(1, 0) : $L0)
                          } else {
                            throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
function $p_Ljava_time_LocalDate__getProlepticMonth__J($thiz) {
  var value = $thiz.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = (((-1) + $p_Ljava_time_LocalDate__month__S($thiz)) | 0);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  return new $c_RTLong(lo$1, hi$3)
}
function $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J($thiz, end) {
  var this$1 = $p_Ljava_time_LocalDate__getProlepticMonth__J($thiz);
  var lo = this$1.RTLong__f_lo;
  var lo$1 = (lo << 5);
  var hi = (((lo >>> 27) | 0) | (this$1.RTLong__f_hi << 5));
  var value = $p_Ljava_time_LocalDate__day__S($thiz);
  var hi$1 = (value >> 31);
  var lo$2 = ((lo$1 + value) | 0);
  var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
  var this$4 = $p_Ljava_time_LocalDate__getProlepticMonth__J($n(end));
  var lo$3 = this$4.RTLong__f_lo;
  var lo$4 = (lo$3 << 5);
  var hi$3 = (((lo$3 >>> 27) | 0) | (this$4.RTLong__f_hi << 5));
  var this$5 = $n(end);
  var value$1 = $p_Ljava_time_LocalDate__day__S(this$5);
  var hi$4 = (value$1 >> 31);
  var lo$5 = ((lo$4 + value$1) | 0);
  var hi$5 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$3 + hi$4) | 0)) | 0) : ((hi$3 + hi$4) | 0));
  var lo$6 = ((lo$5 - lo$2) | 0);
  var hi$6 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ lo$5)) ? (((-1) + ((hi$5 - hi$2) | 0)) | 0) : ((hi$5 - hi$2) | 0));
  var this$9 = $m_RTLong$();
  var lo$7 = this$9.divideImpl__I__I__I__I__I(lo$6, hi$6, 32, 0);
  var hi$7 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo$7, hi$7)
}
/** @constructor */
function $c_Ljava_time_LocalDate(year, monthOfYear, dayOfMonth) {
  this.Ljava_time_LocalDate__f_year = 0;
  this.Ljava_time_LocalDate__f_month = 0;
  this.Ljava_time_LocalDate__f_day = 0;
  this.Ljava_time_LocalDate__f_bitmap$init$0 = 0;
  this.Ljava_time_LocalDate__f_year = year;
  this.Ljava_time_LocalDate__f_month = ((monthOfYear << 16) >> 16);
  this.Ljava_time_LocalDate__f_bitmap$init$0 = (((1 | this.Ljava_time_LocalDate__f_bitmap$init$0) << 24) >> 24);
  this.Ljava_time_LocalDate__f_day = ((dayOfMonth << 16) >> 16);
  this.Ljava_time_LocalDate__f_bitmap$init$0 = (((2 | this.Ljava_time_LocalDate__f_bitmap$init$0) << 24) >> 24)
}
$c_Ljava_time_LocalDate.prototype = new $h_O();
$c_Ljava_time_LocalDate.prototype.constructor = $c_Ljava_time_LocalDate;
/** @constructor */
function $h_Ljava_time_LocalDate() {
  /*<skip>*/
}
$h_Ljava_time_LocalDate.prototype = $c_Ljava_time_LocalDate.prototype;
$c_Ljava_time_LocalDate.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this, field)
});
$c_Ljava_time_LocalDate.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    if ($n(f).isDateBased__Z()) {
      var x = $m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
      if ((x === null)) {
        var $$x1 = (f === null)
      } else {
        var this$1 = $n(x);
        var $$x1 = (this$1 === f)
      };
      if ($$x1) {
        var $$x2 = $m_Ljava_time_temporal_ValueRange$();
        var value = this.lengthOfMonth__I();
        var hi = (value >> 31);
        return $n($$x2).of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value, hi))
      } else {
        var x$3 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
        if ((x$3 === null)) {
          var $$x3 = (f === null)
        } else {
          var this$3 = $n(x$3);
          var $$x3 = (this$3 === f)
        };
        if ($$x3) {
          var $$x4 = $m_Ljava_time_temporal_ValueRange$();
          var value$1 = this.lengthOfYear__I();
          var hi$1 = (value$1 >> 31);
          return $n($$x4).of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value$1, hi$1))
        } else {
          var x$5 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          if ((x$5 === null)) {
            var $$x5 = (f === null)
          } else {
            var this$5 = $n(x$5);
            var $$x5 = (this$5 === f)
          };
          if ($$x5) {
            var $$x8 = $m_Ljava_time_temporal_ValueRange$();
            if (($m_Ljava_time_Month$().of__I__Ljava_time_Month($p_Ljava_time_LocalDate__month__S(this)) === $m_Ljava_time_Month$().FEBRUARY__Ljava_time_Month())) {
              var $$x7 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
              var value$2 = this.Ljava_time_LocalDate__f_year;
              var hi$2 = (value$2 >> 31);
              var $$x6 = (!$n($$x7).isLeapYear__J__Z(new $c_RTLong(value$2, hi$2)))
            } else {
              var $$x6 = false
            };
            return $n($$x8).of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), ($$x6 ? new $c_RTLong(4, 0) : new $c_RTLong(5, 0)))
          } else {
            var x$7 = $m_Ljava_time_temporal_ChronoField$().YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
            if ((x$7 === null)) {
              var $$x9 = (f === null)
            } else {
              var this$7 = $n(x$7);
              var $$x9 = (this$7 === f)
            };
            if ($$x9) {
              if ((this.Ljava_time_LocalDate__f_year <= 0)) {
                var $$x10 = $m_Ljava_time_temporal_ValueRange$();
                var value$3 = $m_Ljava_time_Year$().MAX_VALUE__I();
                var hi$3 = (value$3 >> 31);
                var lo = ((1 + value$3) | 0);
                var hi$4 = ((lo === 0) ? ((1 + hi$3) | 0) : hi$3);
                return $n($$x10).of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(lo, hi$4))
              } else {
                var $$x11 = $m_Ljava_time_temporal_ValueRange$();
                var value$4 = $m_Ljava_time_Year$().MAX_VALUE__I();
                var hi$5 = (value$4 >> 31);
                return $n($$x11).of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value$4, hi$5))
              }
            } else {
              return $n(field).range__Ljava_time_temporal_ValueRange()
            }
          }
        }
      }
    } else {
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
    }
  } else {
    return $n(field).rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this)
  }
});
$c_Ljava_time_LocalDate.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var this$1 = $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field);
    return this$1.RTLong__f_lo
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field)
  }
});
$c_Ljava_time_LocalDate.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ((field === $m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
      return this.toEpochDay__J()
    };
    if ((field === $m_Ljava_time_temporal_ChronoField$().PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField())) {
      return $p_Ljava_time_LocalDate__getProlepticMonth__J(this)
    };
    return $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field)
  } else {
    return $n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this)
  }
});
$c_Ljava_time_LocalDate.prototype.getDayOfYear__I = (function() {
  var $$x2 = $m_Ljava_time_Month$().of__I__Ljava_time_Month($p_Ljava_time_LocalDate__month__S(this));
  var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  return (((-1) + (($n($$x2).firstDayOfYear__Z__I($n($$x1).isLeapYear__J__Z(new $c_RTLong(value, hi))) + $p_Ljava_time_LocalDate__day__S(this)) | 0)) | 0)
});
$c_Ljava_time_LocalDate.prototype.getDayOfWeek__Ljava_time_DayOfWeek = (function() {
  var b = this.toEpochDay__J();
  var bhi = b.RTLong__f_hi;
  var lo = ((3 + b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < (-2147483645)) ? ((1 + bhi) | 0) : bhi);
  var this$2 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo, hi), new $c_RTLong(7, 0));
  var dow0 = this$2.RTLong__f_lo;
  return $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(((1 + dow0) | 0))
});
$c_Ljava_time_LocalDate.prototype.lengthOfMonth__I = (function() {
  var x1 = $p_Ljava_time_LocalDate__month__S(this);
  switch (x1) {
    case 2: {
      var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      var value = this.Ljava_time_LocalDate__f_year;
      var hi = (value >> 31);
      if ($n($$x1).isLeapYear__J__Z(new $c_RTLong(value, hi))) {
        return 29
      } else {
        return 28
      };
      break
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      return 30;
      break
    }
    default: {
      return 31
    }
  }
});
$c_Ljava_time_LocalDate.prototype.lengthOfYear__I = (function() {
  var $$x1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  if ($n($$x1).isLeapYear__J__Z(new $c_RTLong(value, hi))) {
    return 366
  } else {
    return 365
  }
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate = (function(adjuster) {
  return ((adjuster instanceof $c_Ljava_time_LocalDate) ? $as_Ljava_time_LocalDate(adjuster) : $as_Ljava_time_LocalDate($n(adjuster).adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this)))
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var this$1 = $n(f);
    $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, this$1);
    var x = $m_Ljava_time_temporal_ChronoField$().DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $$x1 = (f === null)
    } else {
      var this$2 = $n(x);
      var $$x1 = (this$2 === f)
    };
    if ($$x1) {
      var value = $n(this.getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I();
      var hi = (value >> 31);
      var alo = newValue.RTLong__f_lo;
      var ahi = newValue.RTLong__f_hi;
      var lo = ((alo - value) | 0);
      var hi$1 = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi) | 0)) | 0) : ((ahi - hi) | 0));
      return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi$1))
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $$x2 = (f === null)
      } else {
        var this$5 = $n(x$3);
        var $$x2 = (this$5 === f)
      };
      if ($$x2) {
        var b = this.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField());
        var alo$1 = newValue.RTLong__f_lo;
        var ahi$1 = newValue.RTLong__f_hi;
        var bhi = b.RTLong__f_hi;
        var lo$1 = ((alo$1 - b.RTLong__f_lo) | 0);
        var hi$2 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$1 - bhi) | 0)) | 0) : ((ahi$1 - bhi) | 0));
        return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$2))
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
        if ((x$5 === null)) {
          var $$x3 = (f === null)
        } else {
          var this$7 = $n(x$5);
          var $$x3 = (this$7 === f)
        };
        if ($$x3) {
          var b$1 = this.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField());
          var alo$2 = newValue.RTLong__f_lo;
          var ahi$2 = newValue.RTLong__f_hi;
          var bhi$1 = b$1.RTLong__f_hi;
          var lo$2 = ((alo$2 - b$1.RTLong__f_lo) | 0);
          var hi$3 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$2 - bhi$1) | 0)) | 0) : ((ahi$2 - bhi$1) | 0));
          return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$2, hi$3))
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
          if ((x$7 === null)) {
            var $$x4 = (f === null)
          } else {
            var this$9 = $n(x$7);
            var $$x4 = (this$9 === f)
          };
          if ($$x4) {
            return this.withDayOfMonth__I__Ljava_time_LocalDate(newValue.RTLong__f_lo)
          } else {
            var x$9 = $m_Ljava_time_temporal_ChronoField$().DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
            if ((x$9 === null)) {
              var $$x5 = (f === null)
            } else {
              var this$10 = $n(x$9);
              var $$x5 = (this$10 === f)
            };
            if ($$x5) {
              return this.withDayOfYear__I__Ljava_time_LocalDate(newValue.RTLong__f_lo)
            } else {
              var x$11 = $m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField();
              if ((x$11 === null)) {
                var $$x6 = (f === null)
              } else {
                var this$11 = $n(x$11);
                var $$x6 = (this$11 === f)
              };
              if ($$x6) {
                return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(newValue)
              } else {
                var x$13 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
                if ((x$13 === null)) {
                  var $$x7 = (f === null)
                } else {
                  var this$12 = $n(x$13);
                  var $$x7 = (this$12 === f)
                };
                if ($$x7) {
                  var b$2 = this.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
                  var alo$3 = newValue.RTLong__f_lo;
                  var ahi$3 = newValue.RTLong__f_hi;
                  var bhi$2 = b$2.RTLong__f_hi;
                  var lo$3 = ((alo$3 - b$2.RTLong__f_lo) | 0);
                  var hi$4 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ alo$3)) ? (((-1) + ((ahi$3 - bhi$2) | 0)) | 0) : ((ahi$3 - bhi$2) | 0));
                  return this.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$3, hi$4))
                } else {
                  var x$15 = $m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
                  if ((x$15 === null)) {
                    var $$x8 = (f === null)
                  } else {
                    var this$14 = $n(x$15);
                    var $$x8 = (this$14 === f)
                  };
                  if ($$x8) {
                    var b$3 = this.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
                    var alo$4 = newValue.RTLong__f_lo;
                    var ahi$4 = newValue.RTLong__f_hi;
                    var bhi$3 = b$3.RTLong__f_hi;
                    var lo$4 = ((alo$4 - b$3.RTLong__f_lo) | 0);
                    var hi$5 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo$4)) ? (((-1) + ((ahi$4 - bhi$3) | 0)) | 0) : ((ahi$4 - bhi$3) | 0));
                    return this.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$4, hi$5))
                  } else {
                    var x$17 = $m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
                    if ((x$17 === null)) {
                      var $$x9 = (f === null)
                    } else {
                      var this$16 = $n(x$17);
                      var $$x9 = (this$16 === f)
                    };
                    if ($$x9) {
                      return this.withMonth__I__Ljava_time_LocalDate(newValue.RTLong__f_lo)
                    } else {
                      var x$19 = $m_Ljava_time_temporal_ChronoField$().PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
                      if ((x$19 === null)) {
                        var $$x10 = (f === null)
                      } else {
                        var this$17 = $n(x$19);
                        var $$x10 = (this$17 === f)
                      };
                      if ($$x10) {
                        var b$4 = this.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField());
                        var alo$5 = newValue.RTLong__f_lo;
                        var ahi$5 = newValue.RTLong__f_hi;
                        var bhi$4 = b$4.RTLong__f_hi;
                        var lo$5 = ((alo$5 - b$4.RTLong__f_lo) | 0);
                        var hi$6 = ((((-2147483648) ^ lo$5) > ((-2147483648) ^ alo$5)) ? (((-1) + ((ahi$5 - bhi$4) | 0)) | 0) : ((ahi$5 - bhi$4) | 0));
                        return this.plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$5, hi$6))
                      } else {
                        var x$21 = $m_Ljava_time_temporal_ChronoField$().YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
                        if ((x$21 === null)) {
                          var $$x11 = (f === null)
                        } else {
                          var this$19 = $n(x$21);
                          var $$x11 = (this$19 === f)
                        };
                        if ($$x11) {
                          if ((this.Ljava_time_LocalDate__f_year >= 1)) {
                            var this$21 = newValue
                          } else {
                            var bhi$5 = newValue.RTLong__f_hi;
                            var lo$6 = ((1 - newValue.RTLong__f_lo) | 0);
                            var hi$7 = ((((-2147483648) ^ lo$6) > (-2147483647)) ? (((-1) - bhi$5) | 0) : ((-bhi$5) | 0));
                            var x$1__lo = lo$6;
                            var x$1__hi = hi$7;
                            var this$21 = new $c_RTLong(x$1__lo, x$1__hi)
                          };
                          return this.withYear__I__Ljava_time_LocalDate(this$21.RTLong__f_lo)
                        } else {
                          var x$23 = $m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField();
                          if ((x$23 === null)) {
                            var $$x12 = (f === null)
                          } else {
                            var this$22 = $n(x$23);
                            var $$x12 = (this$22 === f)
                          };
                          if ($$x12) {
                            return this.withYear__I__Ljava_time_LocalDate(newValue.RTLong__f_lo)
                          } else {
                            var x$25 = $m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField();
                            if ((x$25 === null)) {
                              var $$x13 = (f === null)
                            } else {
                              var this$23 = $n(x$25);
                              var $$x13 = (this$23 === f)
                            };
                            if ($$x13) {
                              var this$24 = this.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField());
                              if (((this$24.RTLong__f_lo === newValue.RTLong__f_lo) && (this$24.RTLong__f_hi === newValue.RTLong__f_hi))) {
                                return this
                              } else {
                                return this.withYear__I__Ljava_time_LocalDate(((1 - this.Ljava_time_LocalDate__f_year) | 0))
                              }
                            } else {
                              throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field))
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  } else {
    return $as_Ljava_time_LocalDate($n(field).adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue))
  }
});
$c_Ljava_time_LocalDate.prototype.withYear__I__Ljava_time_LocalDate = (function(year) {
  if ((this.Ljava_time_LocalDate__f_year === year)) {
    return this
  } else {
    var this$2 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
    var hi = (year >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(year, $p_Ljava_time_LocalDate__month__S(this), $p_Ljava_time_LocalDate__day__S(this))
  }
});
$c_Ljava_time_LocalDate.prototype.withMonth__I__Ljava_time_LocalDate = (function(month) {
  if (($p_Ljava_time_LocalDate__month__S(this) === month)) {
    return this
  } else {
    var this$2 = $n($m_Ljava_time_temporal_ChronoField$().MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
    var hi = (month >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(month, hi), this$2);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, month, $p_Ljava_time_LocalDate__day__S(this))
  }
});
$c_Ljava_time_LocalDate.prototype.withDayOfMonth__I__Ljava_time_LocalDate = (function(dayOfMonth) {
  return (($p_Ljava_time_LocalDate__day__S(this) === dayOfMonth) ? this : $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, $p_Ljava_time_LocalDate__month__S(this), dayOfMonth))
});
$c_Ljava_time_LocalDate.prototype.withDayOfYear__I__Ljava_time_LocalDate = (function(dayOfYear) {
  return ((this.getDayOfYear__I() === dayOfYear) ? this : $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, dayOfYear))
});
$c_Ljava_time_LocalDate.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var f = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
    if ((x === null)) {
      var $$x1 = (f === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === f)
    };
    if ($$x1) {
      return this.plusDays__J__Ljava_time_LocalDate(amountToAdd)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === null)) {
        var $$x2 = (f === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === f)
      };
      if ($$x2) {
        return this.plusWeeks__J__Ljava_time_LocalDate(amountToAdd)
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === null)) {
          var $$x3 = (f === null)
        } else {
          var this$3 = $n(x$5);
          var $$x3 = (this$3 === f)
        };
        if ($$x3) {
          return this.plusMonths__J__Ljava_time_LocalDate(amountToAdd)
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === null)) {
            var $$x4 = (f === null)
          } else {
            var this$4 = $n(x$7);
            var $$x4 = (this$4 === f)
          };
          if ($$x4) {
            return this.plusYears__J__Ljava_time_LocalDate(amountToAdd)
          } else {
            var x$9 = $m_Ljava_time_temporal_ChronoUnit$().DECADES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === null)) {
              var $$x5 = (f === null)
            } else {
              var this$5 = $n(x$9);
              var $$x5 = (this$5 === f)
            };
            if ($$x5) {
              return this.plusYears__J__Ljava_time_LocalDate($m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(10, 0)))
            } else {
              var x$11 = $m_Ljava_time_temporal_ChronoUnit$().CENTURIES__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === null)) {
                var $$x6 = (f === null)
              } else {
                var this$6 = $n(x$11);
                var $$x6 = (this$6 === f)
              };
              if ($$x6) {
                return this.plusYears__J__Ljava_time_LocalDate($m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(100, 0)))
              } else {
                var x$13 = $m_Ljava_time_temporal_ChronoUnit$().MILLENNIA__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === null)) {
                  var $$x7 = (f === null)
                } else {
                  var this$7 = $n(x$13);
                  var $$x7 = (this$7 === f)
                };
                if ($$x7) {
                  return this.plusYears__J__Ljava_time_LocalDate($m_jl_Math$().multiplyExact__J__J__J(amountToAdd, new $c_RTLong(1000, 0)))
                } else {
                  var x$15 = $m_Ljava_time_temporal_ChronoUnit$().ERAS__Ljava_time_temporal_ChronoUnit();
                  if ((x$15 === null)) {
                    var $$x8 = (f === null)
                  } else {
                    var this$8 = $n(x$15);
                    var $$x8 = (this$8 === f)
                  };
                  if ($$x8) {
                    var $$x9 = $m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField();
                    var t = this.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField());
                    var lo = t.RTLong__f_lo;
                    var hi = t.RTLong__f_hi;
                    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate($$x9, $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo, hi), amountToAdd))
                  } else {
                    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                  }
                }
              }
            }
          }
        }
      }
    }
  } else {
    return $as_Ljava_time_LocalDate($n(unit).addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd))
  }
});
$c_Ljava_time_LocalDate.prototype.plusYears__J__Ljava_time_LocalDate = (function(yearsToAdd) {
  if (((yearsToAdd.RTLong__f_lo === 0) && (yearsToAdd.RTLong__f_hi === 0))) {
    return this
  } else {
    var this$3 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
    var value = this.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    var bhi = yearsToAdd.RTLong__f_hi;
    var lo = ((value + yearsToAdd.RTLong__f_lo) | 0);
    var hi$1 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + bhi) | 0)) | 0) : ((hi + bhi) | 0));
    var newYear = $n(this$3.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo, hi$1), this$3);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(newYear, $p_Ljava_time_LocalDate__month__S(this), $p_Ljava_time_LocalDate__day__S(this))
  }
});
$c_Ljava_time_LocalDate.prototype.plusMonths__J__Ljava_time_LocalDate = (function(monthsToAdd) {
  if (((monthsToAdd.RTLong__f_lo === 0) && (monthsToAdd.RTLong__f_hi === 0))) {
    return this
  } else {
    var value = this.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    var b0 = (65535 & value);
    var b1 = ((value >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
    var value$1 = (((-1) + $p_Ljava_time_LocalDate__month__S(this)) | 0);
    var hi$2 = (value$1 >> 31);
    var lo$1 = ((lo + value$1) | 0);
    var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
    var bhi = monthsToAdd.RTLong__f_hi;
    var lo$2 = ((lo$1 + monthsToAdd.RTLong__f_lo) | 0);
    var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + ((hi$3 + bhi) | 0)) | 0) : ((hi$3 + bhi) | 0));
    var this$5 = $n($m_Ljava_time_temporal_ChronoField$().YEAR__Ljava_time_temporal_ChronoField());
    var t = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(lo$2, hi$4), new $c_RTLong(12, 0));
    var lo$3 = t.RTLong__f_lo;
    var hi$5 = t.RTLong__f_hi;
    var newYear = $n(this$5.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$3, hi$5), this$5);
    var this$6 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(lo$2, hi$4), new $c_RTLong(12, 0));
    var newMonth = ((1 + this$6.RTLong__f_lo) | 0);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(newYear, newMonth, $p_Ljava_time_LocalDate__day__S(this))
  }
});
$c_Ljava_time_LocalDate.prototype.plusWeeks__J__Ljava_time_LocalDate = (function(weeksToAdd) {
  return this.plusDays__J__Ljava_time_LocalDate($m_jl_Math$().multiplyExact__J__J__J(weeksToAdd, new $c_RTLong(7, 0)))
});
$c_Ljava_time_LocalDate.prototype.plusDays__J__Ljava_time_LocalDate = (function(daysToAdd) {
  if (((daysToAdd.RTLong__f_lo === 0) && (daysToAdd.RTLong__f_hi === 0))) {
    return this
  } else {
    var t = this.toEpochDay__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo, hi), daysToAdd);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$1))
  }
});
$c_Ljava_time_LocalDate.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return $n(this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong((-1), 2147483647), unit)).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_LocalDate.prototype.minusYears__J__Ljava_time_LocalDate = (function(yearsToSubtract) {
  if (((yearsToSubtract.RTLong__f_lo === 0) && (yearsToSubtract.RTLong__f_hi === (-2147483648)))) {
    return $n(this.plusYears__J__Ljava_time_LocalDate(new $c_RTLong((-1), 2147483647))).plusYears__J__Ljava_time_LocalDate(new $c_RTLong(1, 0))
  } else {
    var lo = yearsToSubtract.RTLong__f_lo;
    var hi = yearsToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plusYears__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$1))
  }
});
$c_Ljava_time_LocalDate.prototype.minusDays__J__Ljava_time_LocalDate = (function(daysToSubtract) {
  if (((daysToSubtract.RTLong__f_lo === 0) && (daysToSubtract.RTLong__f_hi === (-2147483648)))) {
    return $n(this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong((-1), 2147483647))).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0))
  } else {
    var lo = daysToSubtract.RTLong__f_lo;
    var hi = daysToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$1))
  }
});
$c_Ljava_time_LocalDate.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? this : $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O(this, query))
});
$c_Ljava_time_LocalDate.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return $n(temporal).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($m_Ljava_time_temporal_ChronoField$().EPOCH_DAY__Ljava_time_temporal_ChronoField(), this.toEpochDay__J())
});
$c_Ljava_time_LocalDate.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x1 = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $m_Ljava_time_temporal_ChronoUnit$().DAYS__Ljava_time_temporal_ChronoUnit();
    if ((x === null)) {
      var $$x1 = (x1 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x1)
    };
    if ($$x1) {
      return this.daysUntil__Ljava_time_LocalDate__J(end)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoUnit$().WEEKS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === null)) {
        var $$x2 = (x1 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x1)
      };
      if ($$x2) {
        var this$3 = this.daysUntil__Ljava_time_LocalDate__J(end);
        var this$4 = $m_RTLong$();
        var lo = this$4.divideImpl__I__I__I__I__I(this$3.RTLong__f_lo, this$3.RTLong__f_hi, 7, 0);
        var hi = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        return new $c_RTLong(lo, hi)
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoUnit$().MONTHS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === null)) {
          var $$x3 = (x1 === null)
        } else {
          var this$5 = $n(x$5);
          var $$x3 = (this$5 === x1)
        };
        if ($$x3) {
          return $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end)
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoUnit$().YEARS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === null)) {
            var $$x4 = (x1 === null)
          } else {
            var this$6 = $n(x$7);
            var $$x4 = (this$6 === x1)
          };
          if ($$x4) {
            var this$7 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
            var this$8 = $m_RTLong$();
            var lo$1 = this$8.divideImpl__I__I__I__I__I(this$7.RTLong__f_lo, this$7.RTLong__f_hi, 12, 0);
            var hi$1 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            return new $c_RTLong(lo$1, hi$1)
          } else {
            var x$9 = $m_Ljava_time_temporal_ChronoUnit$().DECADES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === null)) {
              var $$x5 = (x1 === null)
            } else {
              var this$9 = $n(x$9);
              var $$x5 = (this$9 === x1)
            };
            if ($$x5) {
              var this$10 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
              var this$11 = $m_RTLong$();
              var lo$2 = this$11.divideImpl__I__I__I__I__I(this$10.RTLong__f_lo, this$10.RTLong__f_hi, 120, 0);
              var hi$2 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              return new $c_RTLong(lo$2, hi$2)
            } else {
              var x$11 = $m_Ljava_time_temporal_ChronoUnit$().CENTURIES__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === null)) {
                var $$x6 = (x1 === null)
              } else {
                var this$12 = $n(x$11);
                var $$x6 = (this$12 === x1)
              };
              if ($$x6) {
                var this$13 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
                var this$14 = $m_RTLong$();
                var lo$3 = this$14.divideImpl__I__I__I__I__I(this$13.RTLong__f_lo, this$13.RTLong__f_hi, 1200, 0);
                var hi$3 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                return new $c_RTLong(lo$3, hi$3)
              } else {
                var x$13 = $m_Ljava_time_temporal_ChronoUnit$().MILLENNIA__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === null)) {
                  var $$x7 = (x1 === null)
                } else {
                  var this$15 = $n(x$13);
                  var $$x7 = (this$15 === x1)
                };
                if ($$x7) {
                  var this$16 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
                  var this$17 = $m_RTLong$();
                  var lo$4 = this$17.divideImpl__I__I__I__I__I(this$16.RTLong__f_lo, this$16.RTLong__f_hi, 12000, 0);
                  var hi$4 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  return new $c_RTLong(lo$4, hi$4)
                } else {
                  var x$15 = $m_Ljava_time_temporal_ChronoUnit$().ERAS__Ljava_time_temporal_ChronoUnit();
                  if ((x$15 === null)) {
                    var $$x8 = (x1 === null)
                  } else {
                    var this$18 = $n(x$15);
                    var $$x8 = (this$18 === x1)
                  };
                  if ($$x8) {
                    var this$19 = $n(end).getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField());
                    var b = this.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_ChronoField$().ERA__Ljava_time_temporal_ChronoField());
                    var alo = this$19.RTLong__f_lo;
                    var ahi = this$19.RTLong__f_hi;
                    var bhi = b.RTLong__f_hi;
                    var lo$5 = ((alo - b.RTLong__f_lo) | 0);
                    var hi$5 = ((((-2147483648) ^ lo$5) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
                    return new $c_RTLong(lo$5, hi$5)
                  } else {
                    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                  }
                }
              }
            }
          }
        }
      }
    }
  } else {
    return $n(unit).between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end)
  }
});
$c_Ljava_time_LocalDate.prototype.daysUntil__Ljava_time_LocalDate__J = (function(end) {
  var this$1 = $n(end).toEpochDay__J();
  var b = this.toEpochDay__J();
  var alo = this$1.RTLong__f_lo;
  var ahi = this$1.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo - b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
  return new $c_RTLong(lo, hi)
});
$c_Ljava_time_LocalDate.prototype.until__Ljava_time_chrono_ChronoLocalDate__Ljava_time_Period = (function(endDate) {
  var end = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(endDate);
  var this$1 = $p_Ljava_time_LocalDate__getProlepticMonth__J($n(end));
  var b = $p_Ljava_time_LocalDate__getProlepticMonth__J(this);
  var alo = this$1.RTLong__f_lo;
  var ahi = this$1.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo - b.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
  var totalMonths__lo = lo;
  var totalMonths__hi = hi;
  var days = (($p_Ljava_time_LocalDate__day__S($n(end)) - $p_Ljava_time_LocalDate__day__S(this)) | 0);
  var this$3__lo = totalMonths__lo;
  var this$3__hi = totalMonths__hi;
  var ahi$1 = this$3__hi;
  if ((((ahi$1 === 0) ? (this$3__lo !== 0) : (ahi$1 > 0)) && (days < 0))) {
    var b$1__lo = totalMonths__lo;
    var b$1__hi = totalMonths__hi;
    var bhi$1 = b$1__hi;
    var lo$1 = (((-1) + b$1__lo) | 0);
    var hi$1 = ((lo$1 !== (-1)) ? bhi$1 : (((-1) + bhi$1) | 0));
    var $$x1__lo = lo$1;
    var $$x1__hi = hi$1;
    totalMonths__lo = $$x1__lo;
    totalMonths__hi = $$x1__hi;
    var calcDate = this.plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(totalMonths__lo, totalMonths__hi));
    var this$5 = $n(end).toEpochDay__J();
    var b$2 = $n(calcDate).toEpochDay__J();
    var alo$1 = this$5.RTLong__f_lo;
    var ahi$2 = this$5.RTLong__f_hi;
    var bhi$2 = b$2.RTLong__f_hi;
    var lo$2 = ((alo$1 - b$2.RTLong__f_lo) | 0);
    days = lo$2
  } else {
    var this$7__lo = totalMonths__lo;
    var this$7__hi = totalMonths__hi;
    var ahi$3 = this$7__hi;
    if (((ahi$3 < 0) && (days > 0))) {
      var b$3__lo = totalMonths__lo;
      var b$3__hi = totalMonths__hi;
      var bhi$3 = b$3__hi;
      var lo$3 = ((1 + b$3__lo) | 0);
      var hi$3 = ((lo$3 === 0) ? ((1 + bhi$3) | 0) : bhi$3);
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$3;
      totalMonths__lo = $$x2__lo;
      totalMonths__hi = $$x2__hi;
      days = ((days - $n(end).lengthOfMonth__I()) | 0)
    }
  };
  var this$9__lo = totalMonths__lo;
  var this$9__hi = totalMonths__hi;
  var this$10 = $m_RTLong$();
  var lo$4 = this$10.divideImpl__I__I__I__I__I(this$9__lo, this$9__hi, 12, 0);
  var hi$4 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$11__lo = totalMonths__lo;
  var this$11__hi = totalMonths__hi;
  var this$12 = $m_RTLong$();
  var lo$5 = this$12.remainderImpl__I__I__I__I__I(this$11__lo, this$11__hi, 12, 0);
  var this$13 = $m_Ljava_time_Period$();
  var years = $m_jl_Math$().toIntExact__J__I(new $c_RTLong(lo$4, hi$4));
  var days$1 = days;
  return this$13.java$time$Period$$create__I__I__I__Ljava_time_Period(years, lo$5, days$1)
});
$c_Ljava_time_LocalDate.prototype.toEpochDay__J = (function() {
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  var value$1 = $p_Ljava_time_LocalDate__month__S(this);
  var hi$1 = (value$1 >> 31);
  var total__lo = 0;
  var total__hi = 0;
  var this$3__lo = total__lo;
  var this$3__hi = total__hi;
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(365, b0);
  var a0b1 = Math.imul(365, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((Math.imul(365, hi) + ((c1part >>> 16) | 0)) | 0);
  var alo = this$3__lo;
  var ahi = this$3__hi;
  var lo$1 = ((alo + lo) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$2) | 0)) | 0) : ((ahi + hi$2) | 0));
  var $$x1__lo = lo$1;
  var $$x1__hi = hi$3;
  total__lo = $$x1__lo;
  total__hi = $$x1__hi;
  if ((hi >= 0)) {
    var this$13__lo = total__lo;
    var this$13__hi = total__hi;
    var lo$2 = ((3 + value) | 0);
    var hi$4 = ((((-2147483648) ^ lo$2) < (-2147483645)) ? ((1 + hi) | 0) : hi);
    var this$6 = $m_RTLong$();
    var lo$3 = this$6.divideImpl__I__I__I__I__I(lo$2, hi$4, 4, 0);
    var hi$5 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$4 = ((99 + value) | 0);
    var hi$6 = ((((-2147483648) ^ lo$4) < (-2147483549)) ? ((1 + hi) | 0) : hi);
    var this$8 = $m_RTLong$();
    var lo$5 = this$8.divideImpl__I__I__I__I__I(lo$4, hi$6, 100, 0);
    var hi$7 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$6 = ((lo$3 - lo$5) | 0);
    var hi$8 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ lo$3)) ? (((-1) + ((hi$5 - hi$7) | 0)) | 0) : ((hi$5 - hi$7) | 0));
    var lo$7 = ((399 + value) | 0);
    var hi$9 = ((((-2147483648) ^ lo$7) < (-2147483249)) ? ((1 + hi) | 0) : hi);
    var this$11 = $m_RTLong$();
    var lo$8 = this$11.divideImpl__I__I__I__I__I(lo$7, hi$9, 400, 0);
    var hi$10 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$9 = ((lo$6 + lo$8) | 0);
    var hi$11 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$6)) ? ((1 + ((hi$8 + hi$10) | 0)) | 0) : ((hi$8 + hi$10) | 0));
    var alo$1 = this$13__lo;
    var ahi$1 = this$13__hi;
    var lo$10 = ((alo$1 + lo$9) | 0);
    var hi$12 = ((((-2147483648) ^ lo$10) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$1 + hi$11) | 0)) | 0) : ((ahi$1 + hi$11) | 0));
    var $$x2__lo = lo$10;
    var $$x2__hi = hi$12;
    total__lo = $$x2__lo;
    total__hi = $$x2__hi
  } else {
    var this$20__lo = total__lo;
    var this$20__hi = total__hi;
    var this$15 = $m_RTLong$();
    var lo$11 = this$15.divideImpl__I__I__I__I__I(value, hi, (-4), (-1));
    var hi$13 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$16 = $m_RTLong$();
    var lo$12 = this$16.divideImpl__I__I__I__I__I(value, hi, (-100), (-1));
    var hi$14 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$13 = ((lo$11 - lo$12) | 0);
    var hi$15 = ((((-2147483648) ^ lo$13) > ((-2147483648) ^ lo$11)) ? (((-1) + ((hi$13 - hi$14) | 0)) | 0) : ((hi$13 - hi$14) | 0));
    var this$18 = $m_RTLong$();
    var lo$14 = this$18.divideImpl__I__I__I__I__I(value, hi, (-400), (-1));
    var hi$16 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$15 = ((lo$13 + lo$14) | 0);
    var hi$17 = ((((-2147483648) ^ lo$15) < ((-2147483648) ^ lo$13)) ? ((1 + ((hi$15 + hi$16) | 0)) | 0) : ((hi$15 + hi$16) | 0));
    var alo$2 = this$20__lo;
    var ahi$2 = this$20__hi;
    var lo$16 = ((alo$2 - lo$15) | 0);
    var hi$18 = ((((-2147483648) ^ lo$16) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$2 - hi$17) | 0)) | 0) : ((ahi$2 - hi$17) | 0));
    var $$x3__lo = lo$16;
    var $$x3__hi = hi$18;
    total__lo = $$x3__lo;
    total__hi = $$x3__hi
  };
  var this$24__lo = total__lo;
  var this$24__hi = total__hi;
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(367, b0$1);
  var a0b1$1 = Math.imul(367, b1$1);
  var lo$17 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$19 = ((Math.imul(367, hi$1) + ((c1part$1 >>> 16) | 0)) | 0);
  var lo$18 = (((-362) + lo$17) | 0);
  var hi$20 = ((((-2147483648) ^ lo$18) < 2147483286) ? hi$19 : (((-1) + hi$19) | 0));
  var this$23 = $m_RTLong$();
  var lo$19 = this$23.divideImpl__I__I__I__I__I(lo$18, hi$20, 12, 0);
  var hi$21 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var alo$3 = this$24__lo;
  var ahi$3 = this$24__hi;
  var lo$20 = ((alo$3 + lo$19) | 0);
  var hi$22 = ((((-2147483648) ^ lo$20) < ((-2147483648) ^ alo$3)) ? ((1 + ((ahi$3 + hi$21) | 0)) | 0) : ((ahi$3 + hi$21) | 0));
  var $$x4__lo = lo$20;
  var $$x4__hi = hi$22;
  total__lo = $$x4__lo;
  total__hi = $$x4__hi;
  var this$27__lo = total__lo;
  var this$27__hi = total__hi;
  var value$2 = (((-1) + $p_Ljava_time_LocalDate__day__S(this)) | 0);
  var hi$23 = (value$2 >> 31);
  var alo$4 = this$27__lo;
  var ahi$4 = this$27__hi;
  var lo$21 = ((alo$4 + value$2) | 0);
  var hi$24 = ((((-2147483648) ^ lo$21) < ((-2147483648) ^ alo$4)) ? ((1 + ((ahi$4 + hi$23) | 0)) | 0) : ((ahi$4 + hi$23) | 0));
  var $$x5__lo = lo$21;
  var $$x5__hi = hi$24;
  total__lo = $$x5__lo;
  total__hi = $$x5__hi;
  if (((hi$1 === 0) ? (((-2147483648) ^ value$1) > (-2147483646)) : (hi$1 > 0))) {
    var b__lo = total__lo;
    var b__hi = total__hi;
    var bhi = b__hi;
    var lo$22 = (((-1) + b__lo) | 0);
    var hi$25 = ((lo$22 !== (-1)) ? bhi : (((-1) + bhi) | 0));
    var $$x6__lo = lo$22;
    var $$x6__hi = hi$25;
    total__lo = $$x6__lo;
    total__hi = $$x6__hi;
    var $$x7 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var value$3 = this.Ljava_time_LocalDate__f_year;
    var hi$26 = (value$3 >> 31);
    if ((!$n($$x7).isLeapYear__J__Z(new $c_RTLong(value$3, hi$26)))) {
      var b$1__lo = total__lo;
      var b$1__hi = total__hi;
      var bhi$1 = b$1__hi;
      var lo$23 = (((-1) + b$1__lo) | 0);
      var hi$27 = ((lo$23 !== (-1)) ? bhi$1 : (((-1) + bhi$1) | 0));
      var $$x8__lo = lo$23;
      var $$x8__hi = hi$27;
      total__lo = $$x8__lo;
      total__hi = $$x8__hi
    }
  };
  var this$32__lo = total__lo;
  var this$32__hi = total__hi;
  var b$2 = $m_Ljava_time_LocalDate$().DAYS_0000_TO_1970__J();
  var alo$5 = this$32__lo;
  var ahi$5 = this$32__hi;
  var bhi$2 = b$2.RTLong__f_hi;
  var lo$24 = ((alo$5 - b$2.RTLong__f_lo) | 0);
  var hi$28 = ((((-2147483648) ^ lo$24) > ((-2147483648) ^ alo$5)) ? (((-1) + ((ahi$5 - bhi$2) | 0)) | 0) : ((ahi$5 - bhi$2) | 0));
  return new $c_RTLong(lo$24, hi$28)
});
$c_Ljava_time_LocalDate.prototype.compareTo__Ljava_time_chrono_ChronoLocalDate__I = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? this.compareTo0__Ljava_time_LocalDate__I($as_Ljava_time_LocalDate(other)) : $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I(this, other))
});
$c_Ljava_time_LocalDate.prototype.compareTo0__Ljava_time_LocalDate__I = (function(otherDate) {
  var cmp = ((this.Ljava_time_LocalDate__f_year - $n(otherDate).Ljava_time_LocalDate__f_year) | 0);
  if ((cmp === 0)) {
    cmp = (($p_Ljava_time_LocalDate__month__S(this) - $p_Ljava_time_LocalDate__month__S($n(otherDate))) | 0);
    if ((cmp === 0)) {
      cmp = (($p_Ljava_time_LocalDate__day__S(this) - $p_Ljava_time_LocalDate__day__S($n(otherDate))) | 0)
    }
  };
  return cmp
});
$c_Ljava_time_LocalDate.prototype.isAfter__Ljava_time_chrono_ChronoLocalDate__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? (this.compareTo0__Ljava_time_LocalDate__I($as_Ljava_time_LocalDate(other)) > 0) : $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z(this, other))
});
$c_Ljava_time_LocalDate.prototype.isBefore__Ljava_time_chrono_ChronoLocalDate__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? (this.compareTo0__Ljava_time_LocalDate__I($as_Ljava_time_LocalDate(other)) < 0) : $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z(this, other))
});
$c_Ljava_time_LocalDate.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalDate)) {
    var x2 = $as_Ljava_time_LocalDate(obj);
    return ((this === x2) || (this.compareTo0__Ljava_time_LocalDate__I(x2) === 0))
  } else {
    return false
  }
});
$c_Ljava_time_LocalDate.prototype.hashCode__I = (function() {
  var yearValue = this.Ljava_time_LocalDate__f_year;
  var monthValue = $p_Ljava_time_LocalDate__month__S(this);
  var dayValue = $p_Ljava_time_LocalDate__day__S(this);
  return (((-2048) & yearValue) ^ (((((yearValue << 11) + (monthValue << 6)) | 0) + dayValue) | 0))
});
$c_Ljava_time_LocalDate.prototype.toString__T = (function() {
  var yearValue = this.Ljava_time_LocalDate__f_year;
  var monthValue = $p_Ljava_time_LocalDate__month__S(this);
  var dayValue = $p_Ljava_time_LocalDate__day__S(this);
  var absYear = ((yearValue < 0) ? ((-yearValue) | 0) : yearValue);
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 10);
  if ((absYear < 1000)) {
    if ((yearValue < 0)) {
      $n(buf.append__I__scm_StringBuilder((((-10000) + yearValue) | 0))).deleteCharAt__I__scm_StringBuilder(1)
    } else {
      $n(buf.append__I__scm_StringBuilder(((10000 + yearValue) | 0))).deleteCharAt__I__scm_StringBuilder(0)
    }
  } else {
    if ((yearValue > 9999)) {
      buf.append__C__scm_StringBuilder(43)
    };
    buf.append__I__scm_StringBuilder(yearValue)
  };
  var this$2 = $n($n($n($n(buf.append__T__scm_StringBuilder(((monthValue < 10) ? "-0" : "-"))).append__I__scm_StringBuilder(monthValue)).append__T__scm_StringBuilder(((dayValue < 10) ? "-0" : "-"))).append__I__scm_StringBuilder(dayValue));
  return $n(this$2.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Ljava_time_LocalDate.prototype.compareTo__O__I = (function(that) {
  return this.compareTo__Ljava_time_chrono_ChronoLocalDate__I($as_Ljava_time_chrono_ChronoLocalDate(that))
});
$c_Ljava_time_LocalDate.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToSubtract, unit)
});
$c_Ljava_time_LocalDate.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToAdd, unit)
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(field, newValue)
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(adjuster)
});
function $as_Ljava_time_LocalDate(obj) {
  return (((obj instanceof $c_Ljava_time_LocalDate) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.LocalDate"))
}
function $isArrayOf_Ljava_time_LocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalDate)))
}
function $asArrayOf_Ljava_time_LocalDate(obj, depth) {
  return (($isArrayOf_Ljava_time_LocalDate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.LocalDate;", depth))
}
var $d_Ljava_time_LocalDate = new $TypeData().initClass({
  Ljava_time_LocalDate: 0
}, false, "java.time.LocalDate", {
  Ljava_time_LocalDate: 1,
  O: 1,
  Ljava_time_chrono_ChronoLocalDate: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_LocalDate.prototype.$classData = $d_Ljava_time_LocalDate;
function $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, newTime) {
  return ((($thiz.Ljava_time_LocalDateTime__f_date === newDate) && ($thiz.Ljava_time_LocalDateTime__f_time === newTime)) ? $thiz : new $c_Ljava_time_LocalDateTime(newDate, newTime))
}
function $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime($thiz, newDate, hours, minutes, seconds, nanos, sign) {
  var lo = (hours.RTLong__f_lo | minutes.RTLong__f_lo);
  var hi = (hours.RTLong__f_hi | minutes.RTLong__f_hi);
  var lo$1 = (lo | seconds.RTLong__f_lo);
  var hi$1 = (hi | seconds.RTLong__f_hi);
  var lo$2 = (lo$1 | nanos.RTLong__f_lo);
  var hi$2 = (hi$1 | nanos.RTLong__f_hi);
  if (((lo$2 === 0) && (hi$2 === 0))) {
    return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, $thiz.Ljava_time_LocalDateTime__f_time)
  };
  var b = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
  var this$1 = $m_RTLong$();
  var lo$3 = this$1.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  var hi$3 = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
  var hi$4 = (value >> 31);
  var this$3 = $m_RTLong$();
  var lo$4 = this$3.divideImpl__I__I__I__I__I(seconds.RTLong__f_lo, seconds.RTLong__f_hi, value, hi$4);
  var hi$5 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$5 = ((lo$3 + lo$4) | 0);
  var hi$6 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$3)) ? ((1 + ((hi$3 + hi$5) | 0)) | 0) : ((hi$3 + hi$5) | 0));
  var value$1 = $m_Ljava_time_LocalTime$().MINUTES_PER_DAY__I();
  var hi$7 = (value$1 >> 31);
  var this$6 = $m_RTLong$();
  var lo$6 = this$6.divideImpl__I__I__I__I__I(minutes.RTLong__f_lo, minutes.RTLong__f_hi, value$1, hi$7);
  var hi$8 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$7 = ((lo$5 + lo$6) | 0);
  var hi$9 = ((((-2147483648) ^ lo$7) < ((-2147483648) ^ lo$5)) ? ((1 + ((hi$6 + hi$8) | 0)) | 0) : ((hi$6 + hi$8) | 0));
  var value$2 = $m_Ljava_time_LocalTime$().HOURS_PER_DAY__I();
  var hi$10 = (value$2 >> 31);
  var this$9 = $m_RTLong$();
  var lo$8 = this$9.divideImpl__I__I__I__I__I(hours.RTLong__f_lo, hours.RTLong__f_hi, value$2, hi$10);
  var hi$11 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$9 = ((lo$7 + lo$8) | 0);
  var hi$12 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$7)) ? ((1 + ((hi$9 + hi$11) | 0)) | 0) : ((hi$9 + hi$11) | 0));
  var totDays__lo = lo$9;
  var totDays__hi = hi$12;
  var this$12__lo = totDays__lo;
  var this$12__hi = totDays__hi;
  var hi$13 = (sign >> 31);
  var alo = this$12__lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & sign);
  var b1 = ((sign >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$10 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$14 = ((((((((Math.imul(alo, hi$13) + Math.imul(this$12__hi, sign)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var $$x1__lo = lo$10;
  var $$x1__hi = hi$14;
  totDays__lo = $$x1__lo;
  totDays__hi = $$x1__hi;
  var b$1 = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
  var this$13 = $m_RTLong$();
  var lo$11 = this$13.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, b$1.RTLong__f_lo, b$1.RTLong__f_hi);
  var hi$15 = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value$3 = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
  var hi$16 = (value$3 >> 31);
  var this$15 = $m_RTLong$();
  var lo$12 = this$15.remainderImpl__I__I__I__I__I(seconds.RTLong__f_lo, seconds.RTLong__f_hi, value$3, hi$16);
  var hi$17 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b$2 = $m_Ljava_time_LocalTime$().NANOS_PER_SECOND__J();
  var blo = b$2.RTLong__f_lo;
  var a0$1 = (65535 & lo$12);
  var a1$1 = ((lo$12 >>> 16) | 0);
  var b0$1 = (65535 & blo);
  var b1$1 = ((blo >>> 16) | 0);
  var a0b0$1 = Math.imul(a0$1, b0$1);
  var a1b0$1 = Math.imul(a1$1, b0$1);
  var a0b1$1 = Math.imul(a0$1, b1$1);
  var lo$13 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$18 = ((((((((Math.imul(lo$12, b$2.RTLong__f_hi) + Math.imul(hi$17, blo)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$14 = ((lo$11 + lo$13) | 0);
  var hi$19 = ((((-2147483648) ^ lo$14) < ((-2147483648) ^ lo$11)) ? ((1 + ((hi$15 + hi$18) | 0)) | 0) : ((hi$15 + hi$18) | 0));
  var value$4 = $m_Ljava_time_LocalTime$().MINUTES_PER_DAY__I();
  var hi$20 = (value$4 >> 31);
  var this$18 = $m_RTLong$();
  var lo$15 = this$18.remainderImpl__I__I__I__I__I(minutes.RTLong__f_lo, minutes.RTLong__f_hi, value$4, hi$20);
  var hi$21 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b$3 = $m_Ljava_time_LocalTime$().NANOS_PER_MINUTE__J();
  var blo$1 = b$3.RTLong__f_lo;
  var a0$2 = (65535 & lo$15);
  var a1$2 = ((lo$15 >>> 16) | 0);
  var b0$2 = (65535 & blo$1);
  var b1$2 = ((blo$1 >>> 16) | 0);
  var a0b0$2 = Math.imul(a0$2, b0$2);
  var a1b0$2 = Math.imul(a1$2, b0$2);
  var a0b1$2 = Math.imul(a0$2, b1$2);
  var lo$16 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$22 = ((((((((Math.imul(lo$15, b$3.RTLong__f_hi) + Math.imul(hi$21, blo$1)) | 0) + Math.imul(a1$2, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var lo$17 = ((lo$14 + lo$16) | 0);
  var hi$23 = ((((-2147483648) ^ lo$17) < ((-2147483648) ^ lo$14)) ? ((1 + ((hi$19 + hi$22) | 0)) | 0) : ((hi$19 + hi$22) | 0));
  var value$5 = $m_Ljava_time_LocalTime$().HOURS_PER_DAY__I();
  var hi$24 = (value$5 >> 31);
  var this$21 = $m_RTLong$();
  var lo$18 = this$21.remainderImpl__I__I__I__I__I(hours.RTLong__f_lo, hours.RTLong__f_hi, value$5, hi$24);
  var hi$25 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b$4 = $m_Ljava_time_LocalTime$().NANOS_PER_HOUR__J();
  var blo$2 = b$4.RTLong__f_lo;
  var a0$3 = (65535 & lo$18);
  var a1$3 = ((lo$18 >>> 16) | 0);
  var b0$3 = (65535 & blo$2);
  var b1$3 = ((blo$2 >>> 16) | 0);
  var a0b0$3 = Math.imul(a0$3, b0$3);
  var a1b0$3 = Math.imul(a1$3, b0$3);
  var a0b1$3 = Math.imul(a0$3, b1$3);
  var lo$19 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$26 = ((((((((Math.imul(lo$18, b$4.RTLong__f_hi) + Math.imul(hi$25, blo$2)) | 0) + Math.imul(a1$3, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$20 = ((lo$17 + lo$19) | 0);
  var hi$27 = ((((-2147483648) ^ lo$20) < ((-2147483648) ^ lo$17)) ? ((1 + ((hi$23 + hi$26) | 0)) | 0) : ((hi$23 + hi$26) | 0));
  var totNanos__lo = lo$20;
  var totNanos__hi = hi$27;
  var t = $n($thiz.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
  var lo$21 = t.RTLong__f_lo;
  var hi$28 = t.RTLong__f_hi;
  var this$24__lo = totNanos__lo;
  var this$24__hi = totNanos__hi;
  var hi$29 = (sign >> 31);
  var alo$1 = this$24__lo;
  var a0$4 = (65535 & alo$1);
  var a1$4 = ((alo$1 >>> 16) | 0);
  var b0$4 = (65535 & sign);
  var b1$4 = ((sign >>> 16) | 0);
  var a0b0$4 = Math.imul(a0$4, b0$4);
  var a1b0$4 = Math.imul(a1$4, b0$4);
  var a0b1$4 = Math.imul(a0$4, b1$4);
  var lo$22 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$30 = ((((((((Math.imul(alo$1, hi$29) + Math.imul(this$24__hi, sign)) | 0) + Math.imul(a1$4, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var lo$23 = ((lo$22 + lo$21) | 0);
  var hi$31 = ((((-2147483648) ^ lo$23) < ((-2147483648) ^ lo$22)) ? ((1 + ((hi$30 + hi$28) | 0)) | 0) : ((hi$30 + hi$28) | 0));
  var $$x2__lo = lo$23;
  var $$x2__hi = hi$31;
  totNanos__lo = $$x2__lo;
  totNanos__hi = $$x2__hi;
  var this$26__lo = totDays__lo;
  var this$26__hi = totDays__hi;
  var a__lo = totNanos__lo;
  var a__hi = totNanos__hi;
  var t$1 = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
  var lo$24 = t$1.RTLong__f_lo;
  var hi$32 = t$1.RTLong__f_hi;
  var b$5 = $m_jl_Math$().floorDiv__J__J__J(new $c_RTLong(a__lo, a__hi), new $c_RTLong(lo$24, hi$32));
  var alo$2 = this$26__lo;
  var ahi = this$26__hi;
  var bhi = b$5.RTLong__f_hi;
  var lo$25 = ((alo$2 + b$5.RTLong__f_lo) | 0);
  var hi$33 = ((((-2147483648) ^ lo$25) < ((-2147483648) ^ alo$2)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  var $$x3__lo = lo$25;
  var $$x3__hi = hi$33;
  totDays__lo = $$x3__lo;
  totDays__hi = $$x3__hi;
  var a$1__lo = totNanos__lo;
  var a$1__hi = totNanos__hi;
  var t$2 = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
  var lo$26 = t$2.RTLong__f_lo;
  var hi$34 = t$2.RTLong__f_hi;
  var t$3 = $m_jl_Math$().floorMod__J__J__J(new $c_RTLong(a$1__lo, a$1__hi), new $c_RTLong(lo$26, hi$34));
  var lo$27 = t$3.RTLong__f_lo;
  var hi$35 = t$3.RTLong__f_hi;
  var newTime = (((lo$27 === lo$21) && (hi$35 === hi$28)) ? $thiz.Ljava_time_LocalDateTime__f_time : $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$27, hi$35)));
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, $n(newDate).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(totDays__lo, totDays__hi)), newTime)
}
function $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I($thiz, other) {
  var $$x1 = $n($thiz.Ljava_time_LocalDateTime__f_date);
  var this$1 = $n(other);
  var cmp = $n($$x1).compareTo0__Ljava_time_LocalDate__I(this$1.Ljava_time_LocalDateTime__f_date);
  if ((cmp === 0)) {
    var this$3 = $n($thiz.Ljava_time_LocalDateTime__f_time);
    var this$2 = $n(other);
    var other$1 = this$2.Ljava_time_LocalDateTime__f_time;
    cmp = this$3.compare__Ljava_time_LocalTime__I(other$1)
  };
  return cmp
}
/** @constructor */
function $c_Ljava_time_LocalDateTime(date, time) {
  this.Ljava_time_LocalDateTime__f_date = null;
  this.Ljava_time_LocalDateTime__f_time = null;
  this.Ljava_time_LocalDateTime__f_date = date;
  this.Ljava_time_LocalDateTime__f_time = time
}
$c_Ljava_time_LocalDateTime.prototype = new $h_Ljava_time_chrono_ChronoLocalDateTime();
$c_Ljava_time_LocalDateTime.prototype.constructor = $c_Ljava_time_LocalDateTime;
/** @constructor */
function $h_Ljava_time_LocalDateTime() {
  /*<skip>*/
}
$h_Ljava_time_LocalDateTime.prototype = $c_Ljava_time_LocalDateTime.prototype;
$c_Ljava_time_LocalDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? ($n(field).isDateBased__Z() || $n(field).isTimeBased__Z()) : ((field !== null) && $n(field).isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)))
});
$c_Ljava_time_LocalDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ($n(field).isTimeBased__Z()) {
      var this$1 = $n(this.Ljava_time_LocalDateTime__f_time);
      return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$1, field)
    } else {
      return $n(this.Ljava_time_LocalDateTime__f_date).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)
    }
  } else {
    return $n(field).rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this)
  }
});
$c_Ljava_time_LocalDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? ($n(field).isTimeBased__Z() ? $n(this.Ljava_time_LocalDateTime__f_time).get__Ljava_time_temporal_TemporalField__I(field) : $n(this.Ljava_time_LocalDateTime__f_date).get__Ljava_time_temporal_TemporalField__I(field)) : $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field))
});
$c_Ljava_time_LocalDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? ($n(field).isTimeBased__Z() ? $n(this.Ljava_time_LocalDateTime__f_time).getLong__Ljava_time_temporal_TemporalField__J(field) : $n(this.Ljava_time_LocalDateTime__f_date).getLong__Ljava_time_temporal_TemporalField__J(field)) : $n(field).getFrom__Ljava_time_temporal_TemporalAccessor__J(this))
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDateTime = (function(adjuster) {
  if ((adjuster instanceof $c_Ljava_time_LocalDate)) {
    var x2 = $as_Ljava_time_LocalDate(adjuster);
    return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, x2, this.Ljava_time_LocalDateTime__f_time)
  } else if ((adjuster instanceof $c_Ljava_time_LocalTime)) {
    var x3 = $as_Ljava_time_LocalTime(adjuster);
    return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, x3)
  } else if ((adjuster instanceof $c_Ljava_time_LocalDateTime)) {
    var x4 = $as_Ljava_time_LocalDateTime(adjuster);
    return x4
  } else {
    return $as_Ljava_time_LocalDateTime($n(adjuster).adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this))
  }
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime = (function(field, newValue) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? ($n(field).isTimeBased__Z() ? $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $n(this.Ljava_time_LocalDateTime__f_time).with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(field, newValue)) : $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, $n(this.Ljava_time_LocalDateTime__f_date).with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(field, newValue), this.Ljava_time_LocalDateTime__f_time)) : $as_Ljava_time_LocalDateTime($n(field).adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue)))
});
$c_Ljava_time_LocalDateTime.prototype.withDayOfMonth__I__Ljava_time_LocalDateTime = (function(dayOfMonth) {
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, $n(this.Ljava_time_LocalDateTime__f_date).withDayOfMonth__I__Ljava_time_LocalDate(dayOfMonth), this.Ljava_time_LocalDateTime__f_time)
});
$c_Ljava_time_LocalDateTime.prototype.withDayOfYear__I__Ljava_time_LocalDateTime = (function(dayOfYear) {
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, $n(this.Ljava_time_LocalDateTime__f_date).withDayOfYear__I__Ljava_time_LocalDate(dayOfYear), this.Ljava_time_LocalDateTime__f_time)
});
$c_Ljava_time_LocalDateTime.prototype.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime = (function(unit) {
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $n(this.Ljava_time_LocalDateTime__f_time).truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(unit))
});
$c_Ljava_time_LocalDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x2 = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x === null)) {
      var $$x1 = (x2 === null)
    } else {
      var this$1 = $n(x);
      var $$x1 = (this$1 === x2)
    };
    if ($$x1) {
      return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, amountToAdd, 1)
    } else {
      var x$3 = $m_Ljava_time_temporal_ChronoUnit$().MICROS__Ljava_time_temporal_ChronoUnit();
      if ((x$3 === null)) {
        var $$x2 = (x2 === null)
      } else {
        var this$2 = $n(x$3);
        var $$x2 = (this$2 === x2)
      };
      if ($$x2) {
        var b = $m_Ljava_time_LocalTime$().MICROS_PER_DAY__J();
        var this$3 = $m_RTLong$();
        var lo = this$3.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
        var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$5 = $n(this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo, hi)));
        var b$1 = $m_Ljava_time_LocalTime$().MICROS_PER_DAY__J();
        var this$4 = $m_RTLong$();
        var lo$1 = this$4.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b$1.RTLong__f_lo, b$1.RTLong__f_hi);
        var hi$1 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var b0 = (65535 & lo$1);
        var b1 = ((lo$1 >>> 16) | 0);
        var a0b0 = Math.imul(1000, b0);
        var a0b1 = Math.imul(1000, b1);
        var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((Math.imul(1000, hi$1) + ((c1part >>> 16) | 0)) | 0);
        return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$5, this$5.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, new $c_RTLong(lo$2, hi$2), 1)
      } else {
        var x$5 = $m_Ljava_time_temporal_ChronoUnit$().MILLIS__Ljava_time_temporal_ChronoUnit();
        if ((x$5 === null)) {
          var $$x3 = (x2 === null)
        } else {
          var this$6 = $n(x$5);
          var $$x3 = (this$6 === x2)
        };
        if ($$x3) {
          var b$2 = $m_Ljava_time_LocalTime$().MILLIS_PER_DAY__J();
          var this$7 = $m_RTLong$();
          var lo$3 = this$7.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b$2.RTLong__f_lo, b$2.RTLong__f_hi);
          var hi$3 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var this$9 = $n(this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo$3, hi$3)));
          var b$3 = $m_Ljava_time_LocalTime$().MILLIS_PER_DAY__J();
          var this$8 = $m_RTLong$();
          var lo$4 = this$8.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, b$3.RTLong__f_lo, b$3.RTLong__f_hi);
          var hi$4 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var b0$1 = (65535 & lo$4);
          var b1$1 = ((lo$4 >>> 16) | 0);
          var a0b0$1 = Math.imul(16960, b0$1);
          var a1b0 = Math.imul(15, b0$1);
          var a0b1$1 = Math.imul(16960, b1$1);
          var lo$5 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$5 = ((((((Math.imul(1000000, hi$4) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
          return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$9, this$9.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, new $c_RTLong(lo$5, hi$5), 1)
        } else {
          var x$7 = $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit();
          if ((x$7 === null)) {
            var $$x4 = (x2 === null)
          } else {
            var this$10 = $n(x$7);
            var $$x4 = (this$10 === x2)
          };
          if ($$x4) {
            return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $L0, $L0, amountToAdd, $L0, 1)
          } else {
            var x$9 = $m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit();
            if ((x$9 === null)) {
              var $$x5 = (x2 === null)
            } else {
              var this$11 = $n(x$9);
              var $$x5 = (this$11 === x2)
            };
            if ($$x5) {
              return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $L0, amountToAdd, $L0, $L0, 1)
            } else {
              var x$11 = $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit();
              if ((x$11 === null)) {
                var $$x6 = (x2 === null)
              } else {
                var this$12 = $n(x$11);
                var $$x6 = (this$12 === x2)
              };
              if ($$x6) {
                return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, amountToAdd, $L0, $L0, $L0, 1)
              } else {
                var x$13 = $m_Ljava_time_temporal_ChronoUnit$().HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if ((x$13 === null)) {
                  var $$x7 = (x2 === null)
                } else {
                  var this$13 = $n(x$13);
                  var $$x7 = (this$13 === x2)
                };
                if ($$x7) {
                  var this$14 = $m_RTLong$();
                  var lo$6 = this$14.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 256, 0);
                  var hi$6 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var this$16 = $n(this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo$6, hi$6)));
                  var this$15 = $m_RTLong$();
                  var lo$7 = this$15.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 256, 0);
                  var hi$7 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var b0$2 = (65535 & lo$7);
                  var b1$2 = ((lo$7 >>> 16) | 0);
                  var a0b0$2 = Math.imul(12, b0$2);
                  var a0b1$2 = Math.imul(12, b1$2);
                  var lo$8 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
                  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
                  var hi$8 = ((Math.imul(12, hi$7) + ((c1part$2 >>> 16) | 0)) | 0);
                  return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$16, this$16.Ljava_time_LocalDateTime__f_date, new $c_RTLong(lo$8, hi$8), $L0, $L0, $L0, 1)
                } else {
                  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, $n(this.Ljava_time_LocalDateTime__f_date).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToAdd, unit), this.Ljava_time_LocalDateTime__f_time)
                }
              }
            }
          }
        }
      }
    }
  } else {
    return $as_Ljava_time_LocalDateTime($n(unit).addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd))
  }
});
$c_Ljava_time_LocalDateTime.prototype.plusYears__J__Ljava_time_LocalDateTime = (function(years) {
  var newDate = $n(this.Ljava_time_LocalDateTime__f_date).plusYears__J__Ljava_time_LocalDate(years);
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, newDate, this.Ljava_time_LocalDateTime__f_time)
});
$c_Ljava_time_LocalDateTime.prototype.plusMonths__J__Ljava_time_LocalDateTime = (function(months) {
  var newDate = $n(this.Ljava_time_LocalDateTime__f_date).plusMonths__J__Ljava_time_LocalDate(months);
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, newDate, this.Ljava_time_LocalDateTime__f_time)
});
$c_Ljava_time_LocalDateTime.prototype.plusDays__J__Ljava_time_LocalDateTime = (function(days) {
  var newDate = $n(this.Ljava_time_LocalDateTime__f_date).plusDays__J__Ljava_time_LocalDate(days);
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, newDate, this.Ljava_time_LocalDateTime__f_time)
});
$c_Ljava_time_LocalDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return $n(this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong((-1), 2147483647), unit)).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong(1, 0), unit)
  } else {
    var lo = amountToSubtract.RTLong__f_lo;
    var hi = amountToSubtract.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong(lo$1, hi$1), unit)
  }
});
$c_Ljava_time_LocalDateTime.prototype.minusDays__J__Ljava_time_LocalDateTime = (function(days) {
  if (((days.RTLong__f_lo === 0) && (days.RTLong__f_hi === (-2147483648)))) {
    return $n(this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong((-1), 2147483647))).plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(1, 0))
  } else {
    var lo = days.RTLong__f_lo;
    var hi = days.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    return this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo$1, hi$1))
  }
});
$c_Ljava_time_LocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_LocalDateTime__f_date : $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O.call(this, query))
});
$c_Ljava_time_LocalDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal.call(this, temporal)
});
$c_Ljava_time_LocalDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x2 = $as_Ljava_time_temporal_ChronoUnit(unit);
    if ($n(x2).isTimeBased__Z()) {
      var t = $n(this.Ljava_time_LocalDateTime__f_date).daysUntil__Ljava_time_LocalDate__J($n(end).Ljava_time_LocalDateTime__f_date);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var daysUntil__lo = lo;
      var daysUntil__hi = hi;
      var this$1 = $n($n(end).Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
      var b = $n(this.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
      var alo = this$1.RTLong__f_lo;
      var ahi = this$1.RTLong__f_hi;
      var bhi = b.RTLong__f_hi;
      var lo$1 = ((alo - b.RTLong__f_lo) | 0);
      var hi$1 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
      var timeUntil__lo = lo$1;
      var timeUntil__hi = hi$1;
      var this$3__lo = daysUntil__lo;
      var this$3__hi = daysUntil__hi;
      var ahi$1 = this$3__hi;
      if (((ahi$1 === 0) ? (this$3__lo !== 0) : (ahi$1 > 0))) {
        var this$4__lo = timeUntil__lo;
        var this$4__hi = timeUntil__hi;
        var ahi$2 = this$4__hi;
        var $$x1 = (ahi$2 < 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var b$1__lo = daysUntil__lo;
        var b$1__hi = daysUntil__hi;
        var bhi$1 = b$1__hi;
        var lo$2 = (((-1) + b$1__lo) | 0);
        var hi$2 = ((lo$2 !== (-1)) ? bhi$1 : (((-1) + bhi$1) | 0));
        var $$x2__lo = lo$2;
        var $$x2__hi = hi$2;
        daysUntil__lo = $$x2__lo;
        daysUntil__hi = $$x2__hi;
        var this$6__lo = timeUntil__lo;
        var this$6__hi = timeUntil__hi;
        var b$2 = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
        var alo$1 = this$6__lo;
        var ahi$3 = this$6__hi;
        var bhi$2 = b$2.RTLong__f_hi;
        var lo$3 = ((alo$1 + b$2.RTLong__f_lo) | 0);
        var hi$3 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi$3 + bhi$2) | 0)) | 0) : ((ahi$3 + bhi$2) | 0));
        var $$x3__lo = lo$3;
        var $$x3__hi = hi$3;
        timeUntil__lo = $$x3__lo;
        timeUntil__hi = $$x3__hi
      } else {
        var this$8__lo = daysUntil__lo;
        var this$8__hi = daysUntil__hi;
        var ahi$4 = this$8__hi;
        if ((ahi$4 < 0)) {
          var this$9__lo = timeUntil__lo;
          var this$9__hi = timeUntil__hi;
          var ahi$5 = this$9__hi;
          var $$x4 = ((ahi$5 === 0) ? (this$9__lo !== 0) : (ahi$5 > 0))
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          var b$3__lo = daysUntil__lo;
          var b$3__hi = daysUntil__hi;
          var bhi$3 = b$3__hi;
          var lo$4 = ((1 + b$3__lo) | 0);
          var hi$4 = ((lo$4 === 0) ? ((1 + bhi$3) | 0) : bhi$3);
          var $$x5__lo = lo$4;
          var $$x5__hi = hi$4;
          daysUntil__lo = $$x5__lo;
          daysUntil__hi = $$x5__hi;
          var this$11__lo = timeUntil__lo;
          var this$11__hi = timeUntil__hi;
          var b$4 = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
          var alo$2 = this$11__lo;
          var ahi$6 = this$11__hi;
          var bhi$4 = b$4.RTLong__f_hi;
          var lo$5 = ((alo$2 - b$4.RTLong__f_lo) | 0);
          var hi$5 = ((((-2147483648) ^ lo$5) > ((-2147483648) ^ alo$2)) ? (((-1) + ((ahi$6 - bhi$4) | 0)) | 0) : ((ahi$6 - bhi$4) | 0));
          var $$x6__lo = lo$5;
          var $$x6__hi = hi$5;
          timeUntil__lo = $$x6__lo;
          timeUntil__hi = $$x6__hi
        }
      };
      var x = $m_Ljava_time_temporal_ChronoUnit$().NANOS__Ljava_time_temporal_ChronoUnit();
      if ((x === null)) {
        var $$x7 = (x2 === null)
      } else {
        var this$13 = $n(x);
        var $$x7 = (this$13 === x2)
      };
      if ($$x7) {
        var a__lo = daysUntil__lo;
        var a__hi = daysUntil__hi;
        var t$1 = $m_Ljava_time_LocalTime$().NANOS_PER_DAY__J();
        var lo$6 = t$1.RTLong__f_lo;
        var hi$6 = t$1.RTLong__f_hi;
        var t$2 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a__lo, a__hi), new $c_RTLong(lo$6, hi$6));
        var lo$7 = t$2.RTLong__f_lo;
        var hi$7 = t$2.RTLong__f_hi;
        var b$5__lo = timeUntil__lo;
        var b$5__hi = timeUntil__hi;
        return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$7, hi$7), new $c_RTLong(b$5__lo, b$5__hi))
      } else {
        var x$3 = $m_Ljava_time_temporal_ChronoUnit$().MICROS__Ljava_time_temporal_ChronoUnit();
        if ((x$3 === null)) {
          var $$x8 = (x2 === null)
        } else {
          var this$14 = $n(x$3);
          var $$x8 = (this$14 === x2)
        };
        if ($$x8) {
          var a$1__lo = daysUntil__lo;
          var a$1__hi = daysUntil__hi;
          var t$3 = $m_Ljava_time_LocalTime$().MICROS_PER_DAY__J();
          var lo$8 = t$3.RTLong__f_lo;
          var hi$8 = t$3.RTLong__f_hi;
          var t$4 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$1__lo, a$1__hi), new $c_RTLong(lo$8, hi$8));
          var lo$10 = t$4.RTLong__f_lo;
          var hi$10 = t$4.RTLong__f_hi;
          var this$15__lo = timeUntil__lo;
          var this$15__hi = timeUntil__hi;
          var this$16 = $m_RTLong$();
          var lo$9 = this$16.divideImpl__I__I__I__I__I(this$15__lo, this$15__hi, 1000, 0);
          var hi$9 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$10, hi$10), new $c_RTLong(lo$9, hi$9))
        } else {
          var x$5 = $m_Ljava_time_temporal_ChronoUnit$().MILLIS__Ljava_time_temporal_ChronoUnit();
          if ((x$5 === null)) {
            var $$x9 = (x2 === null)
          } else {
            var this$17 = $n(x$5);
            var $$x9 = (this$17 === x2)
          };
          if ($$x9) {
            var a$2__lo = daysUntil__lo;
            var a$2__hi = daysUntil__hi;
            var t$5 = $m_Ljava_time_LocalTime$().MILLIS_PER_DAY__J();
            var lo$11 = t$5.RTLong__f_lo;
            var hi$11 = t$5.RTLong__f_hi;
            var t$6 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$2__lo, a$2__hi), new $c_RTLong(lo$11, hi$11));
            var lo$13 = t$6.RTLong__f_lo;
            var hi$13 = t$6.RTLong__f_hi;
            var this$18__lo = timeUntil__lo;
            var this$18__hi = timeUntil__hi;
            var this$19 = $m_RTLong$();
            var lo$12 = this$19.divideImpl__I__I__I__I__I(this$18__lo, this$18__hi, 1000000, 0);
            var hi$12 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$13, hi$13), new $c_RTLong(lo$12, hi$12))
          } else {
            var x$7 = $m_Ljava_time_temporal_ChronoUnit$().SECONDS__Ljava_time_temporal_ChronoUnit();
            if ((x$7 === null)) {
              var $$x10 = (x2 === null)
            } else {
              var this$20 = $n(x$7);
              var $$x10 = (this$20 === x2)
            };
            if ($$x10) {
              var a$3__lo = daysUntil__lo;
              var a$3__hi = daysUntil__hi;
              var value = $m_Ljava_time_LocalTime$().SECONDS_PER_DAY__I();
              var hi$14 = (value >> 31);
              var t$7 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$3__lo, a$3__hi), new $c_RTLong(value, hi$14));
              var lo$15 = t$7.RTLong__f_lo;
              var hi$16 = t$7.RTLong__f_hi;
              var this$22__lo = timeUntil__lo;
              var this$22__hi = timeUntil__hi;
              var b$6 = $m_Ljava_time_LocalTime$().NANOS_PER_SECOND__J();
              var this$23 = $m_RTLong$();
              var lo$14 = this$23.divideImpl__I__I__I__I__I(this$22__lo, this$22__hi, b$6.RTLong__f_lo, b$6.RTLong__f_hi);
              var hi$15 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$15, hi$16), new $c_RTLong(lo$14, hi$15))
            } else {
              var x$9 = $m_Ljava_time_temporal_ChronoUnit$().MINUTES__Ljava_time_temporal_ChronoUnit();
              if ((x$9 === null)) {
                var $$x11 = (x2 === null)
              } else {
                var this$24 = $n(x$9);
                var $$x11 = (this$24 === x2)
              };
              if ($$x11) {
                var a$4__lo = daysUntil__lo;
                var a$4__hi = daysUntil__hi;
                var value$1 = $m_Ljava_time_LocalTime$().MINUTES_PER_DAY__I();
                var hi$17 = (value$1 >> 31);
                var t$8 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$4__lo, a$4__hi), new $c_RTLong(value$1, hi$17));
                var lo$17 = t$8.RTLong__f_lo;
                var hi$19 = t$8.RTLong__f_hi;
                var this$26__lo = timeUntil__lo;
                var this$26__hi = timeUntil__hi;
                var b$7 = $m_Ljava_time_LocalTime$().NANOS_PER_MINUTE__J();
                var this$27 = $m_RTLong$();
                var lo$16 = this$27.divideImpl__I__I__I__I__I(this$26__lo, this$26__hi, b$7.RTLong__f_lo, b$7.RTLong__f_hi);
                var hi$18 = this$27.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$17, hi$19), new $c_RTLong(lo$16, hi$18))
              } else {
                var x$11 = $m_Ljava_time_temporal_ChronoUnit$().HOURS__Ljava_time_temporal_ChronoUnit();
                if ((x$11 === null)) {
                  var $$x12 = (x2 === null)
                } else {
                  var this$28 = $n(x$11);
                  var $$x12 = (this$28 === x2)
                };
                if ($$x12) {
                  var a$5__lo = daysUntil__lo;
                  var a$5__hi = daysUntil__hi;
                  var value$2 = $m_Ljava_time_LocalTime$().HOURS_PER_DAY__I();
                  var hi$20 = (value$2 >> 31);
                  var t$9 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$5__lo, a$5__hi), new $c_RTLong(value$2, hi$20));
                  var lo$19 = t$9.RTLong__f_lo;
                  var hi$22 = t$9.RTLong__f_hi;
                  var this$30__lo = timeUntil__lo;
                  var this$30__hi = timeUntil__hi;
                  var b$8 = $m_Ljava_time_LocalTime$().NANOS_PER_HOUR__J();
                  var this$31 = $m_RTLong$();
                  var lo$18 = this$31.divideImpl__I__I__I__I__I(this$30__lo, this$30__hi, b$8.RTLong__f_lo, b$8.RTLong__f_hi);
                  var hi$21 = this$31.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$19, hi$22), new $c_RTLong(lo$18, hi$21))
                } else {
                  var x$13 = $m_Ljava_time_temporal_ChronoUnit$().HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                  if ((x$13 === null)) {
                    var $$x13 = (x2 === null)
                  } else {
                    var this$32 = $n(x$13);
                    var $$x13 = (this$32 === x2)
                  };
                  if ($$x13) {
                    var a$6__lo = daysUntil__lo;
                    var a$6__hi = daysUntil__hi;
                    var t$10 = $m_jl_Math$().multiplyExact__J__J__J(new $c_RTLong(a$6__lo, a$6__hi), new $c_RTLong(2, 0));
                    var lo$22 = t$10.RTLong__f_lo;
                    var hi$25 = t$10.RTLong__f_hi;
                    var this$33__lo = timeUntil__lo;
                    var this$33__hi = timeUntil__hi;
                    var b$9 = $m_Ljava_time_LocalTime$().NANOS_PER_HOUR__J();
                    var blo = b$9.RTLong__f_lo;
                    var b0 = (65535 & blo);
                    var b1 = ((blo >>> 16) | 0);
                    var a0b0 = Math.imul(12, b0);
                    var a0b1 = Math.imul(12, b1);
                    var lo$20 = ((a0b0 + (a0b1 << 16)) | 0);
                    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
                    var hi$23 = ((Math.imul(12, b$9.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
                    var this$34 = $m_RTLong$();
                    var lo$21 = this$34.divideImpl__I__I__I__I__I(this$33__lo, this$33__hi, lo$20, hi$23);
                    var hi$24 = this$34.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                    return $m_jl_Math$().addExact__J__J__J(new $c_RTLong(lo$22, hi$25), new $c_RTLong(lo$21, hi$24))
                  } else {
                    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit))
                  }
                }
              }
            }
          }
        }
      }
    };
    var endDate = (($n($n(end).Ljava_time_LocalDateTime__f_date).isAfter__Ljava_time_chrono_ChronoLocalDate__Z(this.Ljava_time_LocalDateTime__f_date) && $n($n(end).Ljava_time_LocalDateTime__f_time).isBefore__Ljava_time_LocalTime__Z(this.Ljava_time_LocalDateTime__f_time)) ? $n($n(end).Ljava_time_LocalDateTime__f_date).minusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)) : (($n($n(end).Ljava_time_LocalDateTime__f_date).isBefore__Ljava_time_chrono_ChronoLocalDate__Z(this.Ljava_time_LocalDateTime__f_date) && $n($n(end).Ljava_time_LocalDateTime__f_time).isAfter__Ljava_time_LocalTime__Z(this.Ljava_time_LocalDateTime__f_time)) ? $n($n(end).Ljava_time_LocalDateTime__f_date).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)) : $n(end).Ljava_time_LocalDateTime__f_date));
    return $n(this.Ljava_time_LocalDateTime__f_date).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(endDate, unit)
  } else {
    return $n(unit).between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end)
  }
});
$c_Ljava_time_LocalDateTime.prototype.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I = (function(other) {
  if ((other instanceof $c_Ljava_time_LocalDateTime)) {
    var x2 = $as_Ljava_time_LocalDateTime(other);
    return $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, x2)
  } else {
    return this.compare__Ljava_time_chrono_ChronoLocalDateTime__I(other)
  }
});
$c_Ljava_time_LocalDateTime.prototype.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_LocalDateTime)) {
    var x2 = $as_Ljava_time_LocalDateTime(other);
    return ($p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, x2) > 0)
  } else {
    return $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z.call(this, other)
  }
});
$c_Ljava_time_LocalDateTime.prototype.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_LocalDateTime)) {
    var x2 = $as_Ljava_time_LocalDateTime(other);
    return ($p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, x2) < 0)
  } else {
    return $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z.call(this, other)
  }
});
$c_Ljava_time_LocalDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalDateTime)) {
    var x2 = $as_Ljava_time_LocalDateTime(obj);
    if ((this === x2)) {
      return true
    } else {
      var x = this.Ljava_time_LocalDateTime__f_date;
      var x$2 = $n(x2).Ljava_time_LocalDateTime__f_date;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_LocalDateTime__f_time;
        var x$4 = $n(x2).Ljava_time_LocalDateTime__f_time;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_Ljava_time_LocalDateTime.prototype.hashCode__I = (function() {
  return ($n(this.Ljava_time_LocalDateTime__f_date).hashCode__I() ^ $n(this.Ljava_time_LocalDateTime__f_time).hashCode__I())
});
$c_Ljava_time_LocalDateTime.prototype.toString__T = (function() {
  return (($n(this.Ljava_time_LocalDateTime__f_date).toString__T() + "T") + $n(this.Ljava_time_LocalDateTime__f_time).toString__T())
});
$c_Ljava_time_LocalDateTime.prototype.compareTo__O__I = (function(that) {
  return this.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I($as_Ljava_time_chrono_ChronoLocalDateTime(that))
});
$c_Ljava_time_LocalDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToSubtract, unit)
});
$c_Ljava_time_LocalDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit)
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue)
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDateTime(adjuster)
});
function $as_Ljava_time_LocalDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_LocalDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.LocalDateTime"))
}
function $isArrayOf_Ljava_time_LocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalDateTime)))
}
function $asArrayOf_Ljava_time_LocalDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_LocalDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.LocalDateTime;", depth))
}
var $d_Ljava_time_LocalDateTime = new $TypeData().initClass({
  Ljava_time_LocalDateTime: 0
}, false, "java.time.LocalDateTime", {
  Ljava_time_LocalDateTime: 1,
  Ljava_time_chrono_ChronoLocalDateTime: 1,
  O: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_time_LocalDateTime.prototype.$classData = $d_Ljava_time_LocalDateTime;
/** @constructor */
function $c_ju_Collections$$anon$2() {
  /*<skip>*/
}
$c_ju_Collections$$anon$2.prototype = new $h_ju_AbstractList();
$c_ju_Collections$$anon$2.prototype.constructor = $c_ju_Collections$$anon$2;
/** @constructor */
function $h_ju_Collections$$anon$2() {
  /*<skip>*/
}
$h_ju_Collections$$anon$2.prototype = $c_ju_Collections$$anon$2.prototype;
$c_ju_Collections$$anon$2.prototype.get__I__O = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
});
$c_ju_Collections$$anon$2.prototype.size__I = (function() {
  return 0
});
var $d_ju_Collections$$anon$2 = new $TypeData().initClass({
  ju_Collections$$anon$2: 0
}, false, "java.util.Collections$$anon$2", {
  ju_Collections$$anon$2: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  Ljava_io_Serializable: 1,
  ju_RandomAccess: 1
});
$c_ju_Collections$$anon$2.prototype.$classData = $d_ju_Collections$$anon$2;
function $ct_ju_HashSet__ju_HashMap__($thiz, inner) {
  $thiz.ju_HashSet__f_inner = inner;
  var this$1 = $n(inner);
  $thiz.ju_HashSet__f_innerKeySet = new $c_ju_HashMap$KeySet(this$1);
  return $thiz
}
function $ct_ju_HashSet__I__($thiz, initialCapacity) {
  $ct_ju_HashSet__ju_HashMap__($thiz, $ct_ju_HashMap__I__(new $c_ju_HashMap(), initialCapacity));
  return $thiz
}
function $ct_ju_HashSet__($thiz) {
  $ct_ju_HashSet__ju_HashMap__($thiz, $ct_ju_HashMap__(new $c_ju_HashMap()));
  return $thiz
}
function $ct_ju_HashSet__ju_Collection__($thiz, c) {
  $ct_ju_HashSet__I__($thiz, $n(c).size__I());
  $thiz.addAll__ju_Collection__Z(c);
  return $thiz
}
/** @constructor */
function $c_ju_HashSet() {
  this.ju_HashSet__f_inner = null;
  this.ju_HashSet__f_innerKeySet = null
}
$c_ju_HashSet.prototype = new $h_ju_AbstractSet();
$c_ju_HashSet.prototype.constructor = $c_ju_HashSet;
/** @constructor */
function $h_ju_HashSet() {
  /*<skip>*/
}
$h_ju_HashSet.prototype = $c_ju_HashSet.prototype;
$c_ju_HashSet.prototype.contains__O__Z = (function(o) {
  return $n(this.ju_HashSet__f_inner).containsKey__O__Z(o)
});
$c_ju_HashSet.prototype.remove__O__Z = (function(o) {
  return ($n(this.ju_HashSet__f_inner).remove__O__O(o) !== null)
});
$c_ju_HashSet.prototype.containsAll__ju_Collection__Z = (function(c) {
  return $n(this.ju_HashSet__f_innerKeySet).containsAll__ju_Collection__Z(c)
});
$c_ju_HashSet.prototype.retainAll__ju_Collection__Z = (function(c) {
  return $n(this.ju_HashSet__f_innerKeySet).retainAll__ju_Collection__Z(c)
});
$c_ju_HashSet.prototype.add__O__Z = (function(e) {
  return ($n(this.ju_HashSet__f_inner).put__O__O__O(e, (void 0)) === null)
});
$c_ju_HashSet.prototype.addAll__ju_Collection__Z = (function(c) {
  var iter = $n(c).iterator__ju_Iterator();
  var changed = false;
  while ($n(iter).hasNext__Z()) {
    changed = (this.add__O__Z($n(iter).next__O()) || changed)
  };
  return changed
});
$c_ju_HashSet.prototype.size__I = (function() {
  return $n(this.ju_HashSet__f_inner).ju_HashMap__f_contentSize
});
$c_ju_HashSet.prototype.iterator__ju_Iterator = (function() {
  return $n(this.ju_HashSet__f_innerKeySet).iterator__ju_Iterator()
});
var $d_ju_HashSet = new $TypeData().initClass({
  ju_HashSet: 0
}, false, "java.util.HashSet", {
  ju_HashSet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_HashSet.prototype.$classData = $d_ju_HashSet;
var $d_Lorg_scalajs_dom_Element = new $TypeData().initClass({
  Lorg_scalajs_dom_Element: 0
}, false, "org.scalajs.dom.Element", {
  Lorg_scalajs_dom_Element: 1,
  Lorg_scalajs_dom_Node: 1,
  Lorg_scalajs_dom_EventTarget: 1,
  sjs_js_Object: 1,
  O: 1,
  sjs_js_Any: 1,
  Lorg_scalajs_dom_NodeSelector: 1,
  Lorg_scalajs_dom_ParentNode: 1,
  Lorg_scalajs_dom_NonDocumentTypeChildNode: 1
}, true, (void 0), ((x) => (x instanceof Element)));
/** @constructor */
function $c_Lreactbuild_analyze_cost_services_ServerConnection() {
  this.Lreactbuild_analyze_cost_services_ServerConnection__f_ws = null;
  this.Lreactbuild_analyze_cost_services_ServerConnection__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = null;
  $f_Ljapgolly_scalajs_react_extra_BroadcasterF__$init$__V(this);
  this.Lreactbuild_analyze_cost_services_ServerConnection__f_ws = $m_s_None$()
}
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype = new $h_O();
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.constructor = $c_Lreactbuild_analyze_cost_services_ServerConnection;
/** @constructor */
function $h_Lreactbuild_analyze_cost_services_ServerConnection() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_services_ServerConnection.prototype = $c_Lreactbuild_analyze_cost_services_ServerConnection.prototype;
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.listenableEffect__Ljapgolly_scalajs_react_util_Effect$Sync = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners__sci_List = (function() {
  return this.Lreactbuild_analyze_cost_services_ServerConnection__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.japgolly$scalajs$react$extra$BroadcasterF$$_listeners_$eq__sci_List__V = (function(x$1) {
  this.Lreactbuild_analyze_cost_services_ServerConnection__f_japgolly$scalajs$react$extra$BroadcasterF$$_listeners = x$1
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.send__Lreactbuild_model_FromClient__Ljapgolly_scalajs_react_callback_Trampoline = (function(message) {
  $n($m_Ljapgolly_scalajs_react_package$().Ljapgolly_scalajs_react_package$__f_Callback);
  var f = new $c_sjsr_AnonFunction0((() => {
    var encoder = $m_Lreactbuild_model_FromClient$().Lreactbuild_model_FromClient$__f_codecForFromClient;
    var this$4 = $n(encoder);
    var json = $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$4, message);
    var this$5 = $n(json);
    var msg = $n($m_Lio_circe_Printer$().Lio_circe_Printer$__f_noSpaces).print__Lio_circe_Json__T(this$5);
    var this$6 = $n(this.Lreactbuild_analyze_cost_services_ServerConnection__f_ws);
    if ((!this$6.isEmpty__Z())) {
      var arg1 = this$6.get__O();
      arg1.send(msg)
    }
  }));
  var f$1 = new $c_sjsr_AnonFunction0((() => {
    f.apply__O()
  }));
  $m_Ljapgolly_scalajs_react_callback_Trampoline$();
  return new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(f$1)
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.dispatchMessage__Lreactbuild_model_ToClient__Ljapgolly_scalajs_react_callback_Trampoline = (function(json) {
  return $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_extra_BroadcasterF__broadcast__O__O(this, json))).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.productPrefix__T = (function() {
  return "ServerConnection"
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.equals__O__Z = (function(x$1) {
  return (x$1 instanceof $c_Lreactbuild_analyze_cost_services_ServerConnection)
});
function $as_Lreactbuild_analyze_cost_services_ServerConnection(obj) {
  return (((obj instanceof $c_Lreactbuild_analyze_cost_services_ServerConnection) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.analyze.cost.services.ServerConnection"))
}
function $isArrayOf_Lreactbuild_analyze_cost_services_ServerConnection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_analyze_cost_services_ServerConnection)))
}
function $asArrayOf_Lreactbuild_analyze_cost_services_ServerConnection(obj, depth) {
  return (($isArrayOf_Lreactbuild_analyze_cost_services_ServerConnection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.analyze.cost.services.ServerConnection;", depth))
}
var $d_Lreactbuild_analyze_cost_services_ServerConnection = new $TypeData().initClass({
  Lreactbuild_analyze_cost_services_ServerConnection: 0
}, false, "reactbuild.analyze.cost.services.ServerConnection", {
  Lreactbuild_analyze_cost_services_ServerConnection: 1,
  O: 1,
  Ljapgolly_scalajs_react_extra_Broadcaster: 1,
  Ljapgolly_scalajs_react_extra_BroadcasterF: 1,
  Ljapgolly_scalajs_react_extra_ListenableF: 1,
  Ljapgolly_scalajs_react_extra_Listenable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_analyze_cost_services_ServerConnection.prototype.$classData = $d_Lreactbuild_analyze_cost_services_ServerConnection;
/** @constructor */
function $c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype.constructor = $c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype = $c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype;
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype.productPrefix__T = (function() {
  return "ShiftCtrlAlt"
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype.hashCode__I = (function() {
  return (-140940164)
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype.toString__T = (function() {
  return "ShiftCtrlAlt"
});
var $d_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$: 0
}, false, "reactbuild.common.components.Input$ModifierKey$ShiftCtrlAlt$", {
  Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$: 1,
  O: 1,
  Lreactbuild_common_components_Input$ShiftKey: 1,
  Lreactbuild_common_components_Input$ModifierKey: 1,
  Lreactbuild_common_components_Input$CtrlKey: 1,
  Lreactbuild_common_components_Input$AltKey: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$.prototype.$classData = $d_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$;
var $n_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$;
function $m_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$() {
  if ((!$n_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$)) {
    $n_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$ = new $c_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$()
  };
  return $n_Lreactbuild_common_components_Input$ModifierKey$ShiftCtrlAlt$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Move$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Move$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Move$.prototype.constructor = $c_Lreactbuild_common_components_Input$Move$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Move$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Move$.prototype = $c_Lreactbuild_common_components_Input$Move$.prototype;
$c_Lreactbuild_common_components_Input$Move$.prototype.productPrefix__T = (function() {
  return "Move"
});
$c_Lreactbuild_common_components_Input$Move$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Move$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Move$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Move$.prototype.hashCode__I = (function() {
  return 2404337
});
$c_Lreactbuild_common_components_Input$Move$.prototype.toString__T = (function() {
  return "Move"
});
var $d_Lreactbuild_common_components_Input$Move$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Move$: 0
}, false, "reactbuild.common.components.Input$Move$", {
  Lreactbuild_common_components_Input$Move$: 1,
  O: 1,
  Lreactbuild_common_components_Input$MouseWay: 1,
  Lreactbuild_common_components_Input$TouchWay: 1,
  Lreactbuild_common_components_Input$CursorWay: 1,
  Lreactbuild_common_components_Input$PointerWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Move$.prototype.$classData = $d_Lreactbuild_common_components_Input$Move$;
var $n_Lreactbuild_common_components_Input$Move$;
function $m_Lreactbuild_common_components_Input$Move$() {
  if ((!$n_Lreactbuild_common_components_Input$Move$)) {
    $n_Lreactbuild_common_components_Input$Move$ = new $c_Lreactbuild_common_components_Input$Move$()
  };
  return $n_Lreactbuild_common_components_Input$Move$
}
class $c_Lreactbuild_process_ProcessNotConnectedException$ extends $c_Lreactbuild_process_ProcessException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  productPrefix__T() {
    return "ProcessNotConnectedException"
  };
  productArity__I() {
    return 0
  };
  productElement__I__O(x$1) {
    return $m_sr_Statics$().ioobe__I__O(x$1)
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    return 510247018
  };
}
var $d_Lreactbuild_process_ProcessNotConnectedException$ = new $TypeData().initClass({
  Lreactbuild_process_ProcessNotConnectedException$: 0
}, false, "reactbuild.process.ProcessNotConnectedException$", {
  Lreactbuild_process_ProcessNotConnectedException$: 1,
  Lreactbuild_process_ProcessException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lreactbuild_process_ProcessNotConnectedException$.prototype.$classData = $d_Lreactbuild_process_ProcessNotConnectedException$;
var $n_Lreactbuild_process_ProcessNotConnectedException$;
function $m_Lreactbuild_process_ProcessNotConnectedException$() {
  if ((!$n_Lreactbuild_process_ProcessNotConnectedException$)) {
    $n_Lreactbuild_process_ProcessNotConnectedException$ = new $c_Lreactbuild_process_ProcessNotConnectedException$()
  };
  return $n_Lreactbuild_process_ProcessNotConnectedException$
}
class $c_Lreactbuild_process_ProcessNotSelectedException$ extends $c_Lreactbuild_process_ProcessException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  productPrefix__T() {
    return "ProcessNotSelectedException"
  };
  productArity__I() {
    return 0
  };
  productElement__I__O(x$1) {
    return $m_sr_Statics$().ioobe__I__O(x$1)
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    return (-1898668464)
  };
}
var $d_Lreactbuild_process_ProcessNotSelectedException$ = new $TypeData().initClass({
  Lreactbuild_process_ProcessNotSelectedException$: 0
}, false, "reactbuild.process.ProcessNotSelectedException$", {
  Lreactbuild_process_ProcessNotSelectedException$: 1,
  Lreactbuild_process_ProcessException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lreactbuild_process_ProcessNotSelectedException$.prototype.$classData = $d_Lreactbuild_process_ProcessNotSelectedException$;
var $n_Lreactbuild_process_ProcessNotSelectedException$;
function $m_Lreactbuild_process_ProcessNotSelectedException$() {
  if ((!$n_Lreactbuild_process_ProcessNotSelectedException$)) {
    $n_Lreactbuild_process_ProcessNotSelectedException$ = new $c_Lreactbuild_process_ProcessNotSelectedException$()
  };
  return $n_Lreactbuild_process_ProcessNotSelectedException$
}
class $c_Lreactbuild_process_ProcessOrganizationNotFoundException$ extends $c_Lreactbuild_process_ProcessException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  productPrefix__T() {
    return "ProcessOrganizationNotFoundException"
  };
  productArity__I() {
    return 0
  };
  productElement__I__O(x$1) {
    return $m_sr_Statics$().ioobe__I__O(x$1)
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    return 1377215390
  };
}
var $d_Lreactbuild_process_ProcessOrganizationNotFoundException$ = new $TypeData().initClass({
  Lreactbuild_process_ProcessOrganizationNotFoundException$: 0
}, false, "reactbuild.process.ProcessOrganizationNotFoundException$", {
  Lreactbuild_process_ProcessOrganizationNotFoundException$: 1,
  Lreactbuild_process_ProcessException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lreactbuild_process_ProcessOrganizationNotFoundException$.prototype.$classData = $d_Lreactbuild_process_ProcessOrganizationNotFoundException$;
var $n_Lreactbuild_process_ProcessOrganizationNotFoundException$;
function $m_Lreactbuild_process_ProcessOrganizationNotFoundException$() {
  if ((!$n_Lreactbuild_process_ProcessOrganizationNotFoundException$)) {
    $n_Lreactbuild_process_ProcessOrganizationNotFoundException$ = new $c_Lreactbuild_process_ProcessOrganizationNotFoundException$()
  };
  return $n_Lreactbuild_process_ProcessOrganizationNotFoundException$
}
class $c_Lreactbuild_process_ProcessOrganizationNotSelectedException$ extends $c_Lreactbuild_process_ProcessException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  productPrefix__T() {
    return "ProcessOrganizationNotSelectedException"
  };
  productArity__I() {
    return 0
  };
  productElement__I__O(x$1) {
    return $m_sr_Statics$().ioobe__I__O(x$1)
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    return 1993357731
  };
}
var $d_Lreactbuild_process_ProcessOrganizationNotSelectedException$ = new $TypeData().initClass({
  Lreactbuild_process_ProcessOrganizationNotSelectedException$: 0
}, false, "reactbuild.process.ProcessOrganizationNotSelectedException$", {
  Lreactbuild_process_ProcessOrganizationNotSelectedException$: 1,
  Lreactbuild_process_ProcessException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_Lreactbuild_process_ProcessOrganizationNotSelectedException$.prototype.$classData = $d_Lreactbuild_process_ProcessOrganizationNotSelectedException$;
var $n_Lreactbuild_process_ProcessOrganizationNotSelectedException$;
function $m_Lreactbuild_process_ProcessOrganizationNotSelectedException$() {
  if ((!$n_Lreactbuild_process_ProcessOrganizationNotSelectedException$)) {
    $n_Lreactbuild_process_ProcessOrganizationNotSelectedException$ = new $c_Lreactbuild_process_ProcessOrganizationNotSelectedException$()
  };
  return $n_Lreactbuild_process_ProcessOrganizationNotSelectedException$
}
function $f_sc_BitSetOps__contains__I__Z($thiz, elem) {
  if ((elem >= 0)) {
    var this$1 = $thiz.word__I__J((elem >> 6));
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$1.RTLong__f_lo & lo);
    var hi$1 = (this$1.RTLong__f_hi & hi);
    return (!((lo$1 === 0) && (hi$1 === 0)))
  } else {
    return false
  }
}
function $f_sc_BitSetOps__size__I($thiz) {
  var s = 0;
  var i = $thiz.nwords__I();
  while ((i > 0)) {
    i = (((-1) + i) | 0);
    var $$x1 = s;
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    s = (($$x1 + (($m_jl_Integer$().bitCount__I__I(lo) + $m_jl_Integer$().bitCount__I__I(hi)) | 0)) | 0)
  };
  return s
}
function $f_sc_BitSetOps__isEmpty__Z($thiz) {
  var end = $thiz.nwords__I();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
  var res = true;
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while ((res && it.sci_RangeIterator__f__hasNext)) {
    var arg1 = it.next__I();
    var this$6 = $thiz.word__I__J(arg1);
    res = ((this$6.RTLong__f_lo === 0) && (this$6.RTLong__f_hi === 0))
  };
  return res
}
function $f_sc_BitSetOps__foreach__F1__V($thiz, f) {
  var i = 0;
  while ((i < $thiz.nwords__I())) {
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var w__lo = lo;
    var w__hi = hi;
    var j = (i << 6);
    while (true) {
      var this$1__lo = w__lo;
      var this$1__hi = w__hi;
      if ((!((this$1__lo === 0) && (this$1__hi === 0)))) {
        var b__lo = w__lo;
        var b__hi = w__hi;
        var lo$1 = (1 & b__lo);
        if ((lo$1 === 1)) {
          $n(f).apply__O__O(j)
        };
        var this$2__lo = w__lo;
        var this$2__hi = w__hi;
        var hi$1 = this$2__hi;
        var lo$2 = (((this$2__lo >>> 1) | 0) | (hi$1 << 31));
        var hi$2 = ((hi$1 >>> 1) | 0);
        var $$x1__lo = lo$2;
        var $$x1__hi = hi$2;
        w__lo = $$x1__lo;
        w__hi = $$x1__hi;
        j = ((1 + j) | 0)
      } else {
        break
      }
    };
    i = ((1 + i) | 0)
  }
}
function $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet($thiz, other) {
  if ($is_sc_BitSet(other)) {
    var x2 = $as_sc_BitSet(other);
    var x = $n($as_sc_BitSetOps($thiz)).nwords__I();
    var that = $n(x2).nwords__I();
    var len = ((x > that) ? x : that);
    var words = new $ac_J(len);
    var isEmpty = (len <= 0);
    var scala$collection$immutable$Range$$lastElement = (((-1) + len) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var v1 = i;
        var $$x1 = $n(words);
        var this$10 = $thiz.word__I__J(v1);
        var b = $n(x2).word__I__J(v1);
        var lo = (this$10.RTLong__f_lo | b.RTLong__f_lo);
        var hi$2 = (this$10.RTLong__f_hi | b.RTLong__f_hi);
        $$x1.set(v1, new $c_RTLong(lo, hi$2));
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break
        };
        i = ((1 + i) | 0)
      }
    };
    return $thiz.fromBitMaskNoCopy__AJ__sc_BitSet(words)
  } else {
    return $thiz.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet(other)
  }
}
function $is_sc_BitSetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSetOps)))
}
function $as_sc_BitSetOps(obj) {
  return (($is_sc_BitSetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSetOps"))
}
function $isArrayOf_sc_BitSetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSetOps)))
}
function $asArrayOf_sc_BitSetOps(obj, depth) {
  return (($isArrayOf_sc_BitSetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSetOps;", depth))
}
function $is_sc_SortedMapOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SortedMapOps)))
}
function $as_sc_SortedMapOps(obj) {
  return (($is_sc_SortedMapOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SortedMapOps"))
}
function $isArrayOf_sc_SortedMapOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SortedMapOps)))
}
function $asArrayOf_sc_SortedMapOps(obj, depth) {
  return (($isArrayOf_sc_SortedMapOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SortedMapOps;", depth))
}
function $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq($thiz, n, s) {
  while (true) {
    if (((n <= 0) || $n(s).isEmpty__Z())) {
      return s
    } else {
      var temp$n = (((-1) + n) | 0);
      var temp$s = $as_sc_LinearSeq($n(s).tail__O());
      n = temp$n;
      s = temp$s
    }
  }
}
function $p_sc_StrictOptimizedLinearSeqOps__loop$3__sc_LinearSeq__F1__sc_LinearSeq($thiz, s, p$1) {
  while (true) {
    var this$1 = $n(s);
    if (((!this$1.isEmpty__Z()) && $uZ($n(p$1).apply__O__O($n(s).head__O())))) {
      s = $as_sc_LinearSeq($n(s).tail__O())
    } else {
      break
    }
  };
  return s
}
function $is_sc_StrictOptimizedLinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_StrictOptimizedLinearSeqOps)))
}
function $as_sc_StrictOptimizedLinearSeqOps(obj) {
  return (($is_sc_StrictOptimizedLinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StrictOptimizedLinearSeqOps"))
}
function $isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StrictOptimizedLinearSeqOps)))
}
function $asArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StrictOptimizedLinearSeqOps;", depth))
}
function $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps($thiz, f) {
  var b = $n($thiz.mapFactory__sc_MapFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $n(f).apply__O__O($n(it).next__O());
    this$1.addOne__O__scm_Growable(elem)
  };
  return $as_sc_IterableOps($n(b).result__O())
}
function $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps($thiz, pf) {
  var b = $n($thiz.mapFactory__sc_MapFactory()).newBuilder__scm_Builder();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var v = $n(pf).applyOrElse__O__F1__O(elem, new $c_sjsr_AnonFunction1(((marker) => ((x$2) => marker))(marker)));
    if ((marker !== v)) {
      var this$3 = $n(b);
      this$3.addOne__O__scm_Growable(v)
    }
  };
  return $as_sc_IterableOps($n(b).result__O())
}
function $as_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$MutableSetWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$MutableSetWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$MutableSetWrapper;", depth))
}
function $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  if (($thiz.lengthCompare__I__I(1) <= 0)) {
    return $thiz
  } else {
    var builder = $thiz.newSpecificBuilder__scm_Builder();
    var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
    var it = $thiz.iterator__sc_Iterator();
    var different = false;
    while ($n(it).hasNext__Z()) {
      var next = $n(it).next__O();
      if (seen.add__O__Z($n(f).apply__O__O(next))) {
        var this$2 = $n(builder);
        this$2.addOne__O__scm_Growable(next)
      } else {
        different = true
      }
    };
    return (different ? $n(builder).result__O() : $thiz)
  }
}
function $f_sci_StrictOptimizedSeqOps__updated__I__O__O($thiz, index, elem) {
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (($thiz.knownSize__I() >= 0) ? $thiz.knownSize__I() : "unknown")) + ")"))
  };
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  if (($thiz.knownSize__I() >= 0)) {
    $n(b).sizeHint__I__V($thiz.length__I())
  };
  var i = 0;
  var it = $thiz.iterator__sc_Iterator();
  while (((i < index) && $n(it).hasNext__Z())) {
    var this$1 = $n(b);
    var elem$1 = $n(it).next__O();
    this$1.addOne__O__scm_Growable(elem$1);
    i = ((1 + i) | 0)
  };
  if ((!$n(it).hasNext__Z())) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + i) | 0)) + ")"))
  };
  var this$2 = $n(b);
  this$2.addOne__O__scm_Growable(elem);
  $n(it).next__O();
  while ($n(it).hasNext__Z()) {
    var this$3 = $n(b);
    var elem$2 = $n(it).next__O();
    this$3.addOne__O__scm_Growable(elem$2)
  };
  return $n(b).result__O()
}
function $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O($thiz, from, other, replaced) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  var i = 0;
  var it = $thiz.iterator__sc_Iterator();
  while (((i < from) && $n(it).hasNext__Z())) {
    var this$1 = $n(b);
    var elem = $n(it).next__O();
    this$1.addOne__O__scm_Growable(elem);
    i = ((1 + i) | 0)
  };
  var this$2 = $n(b);
  this$2.addAll__sc_IterableOnce__scm_Growable(other);
  i = replaced;
  while (((i > 0) && $n(it).hasNext__Z())) {
    $n(it).next__O();
    i = (((-1) + i) | 0)
  };
  while ($n(it).hasNext__Z()) {
    var this$3 = $n(b);
    var elem$1 = $n(it).next__O();
    this$3.addOne__O__scm_Growable(elem$1)
  };
  return $n(b).result__O()
}
function $is_sci_StrictOptimizedSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_StrictOptimizedSeqOps)))
}
function $as_sci_StrictOptimizedSeqOps(obj) {
  return (($is_sci_StrictOptimizedSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.StrictOptimizedSeqOps"))
}
function $isArrayOf_sci_StrictOptimizedSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_StrictOptimizedSeqOps)))
}
function $asArrayOf_sci_StrictOptimizedSeqOps(obj, depth) {
  return (($isArrayOf_sci_StrictOptimizedSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.StrictOptimizedSeqOps;", depth))
}
function $p_s_math_BigDecimal__computeHashCode__V($thiz) {
  if ($thiz.isWhole__Z()) {
    var $$x3 = $n($thiz.s_math_BigDecimal__f_bigDecimal).precision__I();
    var this$1 = $n($thiz.s_math_BigDecimal__f_bigDecimal);
    var $$x2 = ((($$x3 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0) < 4934)
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var $$x1 = $n($thiz.toBigInt__s_math_BigInt()).hashCode__I()
  } else if ($thiz.isDecimalDouble__Z()) {
    var dv = $n($thiz.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
    var $$x1 = $m_sr_Statics$().doubleHash__D__I(dv)
  } else {
    var temp = $n($thiz.s_math_BigDecimal__f_bigDecimal).stripTrailingZeros__Ljava_math_BigDecimal();
    var $$x5 = $m_s_util_hashing_MurmurHash3$();
    var this$2 = $n(temp);
    var $$x4 = $n($n($n(temp).scaleByPowerOfTen__I__Ljava_math_BigDecimal(this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)).toBigInteger__Ljava_math_BigInteger()).hashCode__I();
    var this$3 = $n(temp);
    var $$x1 = $n($$x5).mixLast__I__I__I($$x4, this$3.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  };
  $thiz.s_math_BigDecimal__f_computedHashCode = $$x1
}
function $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__($thiz, bigDecimal, mc) {
  $thiz.s_math_BigDecimal__f_bigDecimal = bigDecimal;
  $thiz.s_math_BigDecimal__f_mc = mc;
  if ((bigDecimal === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null value for BigDecimal")
  };
  if ((mc === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null MathContext for BigDecimal")
  };
  $thiz.s_math_BigDecimal__f_computedHashCode = 1565550863;
  return $thiz
}
function $ct_s_math_BigDecimal__Ljava_math_BigDecimal__($thiz, bigDecimal) {
  $ct_s_math_BigDecimal__Ljava_math_BigDecimal__Ljava_math_MathContext__($thiz, bigDecimal, $m_s_math_BigDecimal$().s_math_BigDecimal$__f_defaultMathContext);
  return $thiz
}
/** @constructor */
function $c_s_math_BigDecimal() {
  this.s_math_BigDecimal__f_bigDecimal = null;
  this.s_math_BigDecimal__f_mc = null;
  this.s_math_BigDecimal__f_computedHashCode = 0
}
$c_s_math_BigDecimal.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigDecimal.prototype.constructor = $c_s_math_BigDecimal;
/** @constructor */
function $h_s_math_BigDecimal() {
  /*<skip>*/
}
$h_s_math_BigDecimal.prototype = $c_s_math_BigDecimal.prototype;
$c_s_math_BigDecimal.prototype.compareTo__O__I = (function(that) {
  var that$1 = $as_s_math_BigDecimal(that);
  return $n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that$1).s_math_BigDecimal__f_bigDecimal)
});
$c_s_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.s_math_BigDecimal__f_computedHashCode === 1565550863)) {
    $p_s_math_BigDecimal__computeHashCode__V(this)
  };
  return this.s_math_BigDecimal__f_computedHashCode
});
$c_s_math_BigDecimal.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigDecimal)) {
    var x2 = $as_s_math_BigDecimal(that);
    return this.equals__s_math_BigDecimal__Z(x2)
  } else if ((that instanceof $c_s_math_BigInt)) {
    var x3 = $as_s_math_BigInt(that);
    var $$x2 = $n(x3).bitLength__I();
    var $$x1 = $n(this.s_math_BigDecimal__f_bigDecimal).precision__I();
    var this$1 = $n(this.s_math_BigDecimal__f_bigDecimal);
    if (($$x2 > (3.3219280948873626 * (((-2) + (($$x1 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)) | 0)))) {
      var this$2 = $n(this.toBigIntExact__s_Option());
      if ((!this$2.isEmpty__Z())) {
        var arg1 = this$2.get__O();
        var x$1 = $as_s_math_BigInt(arg1);
        return $n(x3).equals__s_math_BigInt__Z(x$1)
      } else {
        return false
      }
    } else {
      return false
    }
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    if ((!((x4 === Infinity) || (x4 === (-Infinity))))) {
      var d = $n(this.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
      if (((!((d === Infinity) || (d === (-Infinity)))) && (d === x4))) {
        var this$9 = $m_s_math_BigDecimal$();
        return this.equals__s_math_BigDecimal__Z(this$9.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$9.s_math_BigDecimal$__f_defaultMathContext))
      } else {
        return false
      }
    } else {
      return false
    }
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if ((!((x5 === Infinity) || (x5 === (-Infinity))))) {
      var f = $n(this.s_math_BigDecimal__f_bigDecimal).floatValue__F();
      if (((!((f === Infinity) || (f === (-Infinity)))) && (f === x5))) {
        var this$16 = $m_s_math_BigDecimal$();
        var d$1 = f;
        return this.equals__s_math_BigDecimal__Z(this$16.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d$1, this$16.s_math_BigDecimal$__f_defaultMathContext))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that))
  }
});
$c_s_math_BigDecimal.prototype.isValidByte__Z = (function() {
  try {
    $n(this.s_math_BigDecimal__f_bigDecimal).byteValueExact__B();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidShort__Z = (function() {
  try {
    $n(this.s_math_BigDecimal__f_bigDecimal).shortValueExact__S();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidChar__Z = (function() {
  return ((this.isValidInt__Z() && ($n(this.s_math_BigDecimal__f_bigDecimal).intValueExact__I() >= 0)) && ($n(this.s_math_BigDecimal__f_bigDecimal).intValueExact__I() <= 65535))
});
$c_s_math_BigDecimal.prototype.isValidInt__Z = (function() {
  try {
    $n(this.s_math_BigDecimal__f_bigDecimal).intValueExact__I();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidLong__Z = (function() {
  try {
    var this$1 = $n(this.s_math_BigDecimal__f_bigDecimal);
    $p_Ljava_math_BigDecimal__valueExact__I__J(this$1, 64);
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isDecimalDouble__Z = (function() {
  var d = $n(this.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
  if ((!((d === Infinity) || (d === (-Infinity))))) {
    var this$4 = $m_s_math_BigDecimal$();
    return this.equals__s_math_BigDecimal__Z(this$4.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$4.s_math_BigDecimal$__f_defaultMathContext))
  } else {
    return false
  }
});
$c_s_math_BigDecimal.prototype.isWhole__Z = (function() {
  var this$1 = $n(this.s_math_BigDecimal__f_bigDecimal);
  if ((this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
    return true
  } else {
    var this$2 = $n($n(this.s_math_BigDecimal__f_bigDecimal).stripTrailingZeros__Ljava_math_BigDecimal());
    return (this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)
  }
});
$c_s_math_BigDecimal.prototype.equals__s_math_BigDecimal__Z = (function(that) {
  return ($n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that).s_math_BigDecimal__f_bigDecimal) === 0)
});
$c_s_math_BigDecimal.prototype.byteValue__B = (function() {
  return (($n(this.s_math_BigDecimal__f_bigDecimal).intValue__I() << 24) >> 24)
});
$c_s_math_BigDecimal.prototype.shortValue__S = (function() {
  return (($n(this.s_math_BigDecimal__f_bigDecimal).intValue__I() << 16) >> 16)
});
$c_s_math_BigDecimal.prototype.intValue__I = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).intValue__I()
});
$c_s_math_BigDecimal.prototype.longValue__J = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).longValue__J()
});
$c_s_math_BigDecimal.prototype.floatValue__F = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).floatValue__F()
});
$c_s_math_BigDecimal.prototype.doubleValue__D = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).doubleValue__D()
});
$c_s_math_BigDecimal.prototype.toBigInt__s_math_BigInt = (function() {
  return $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), $n(this.s_math_BigDecimal__f_bigDecimal).toBigInteger__Ljava_math_BigInteger())
});
$c_s_math_BigDecimal.prototype.toBigIntExact__s_Option = (function() {
  if (this.isWhole__Z()) {
    try {
      return new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), $n(this.s_math_BigDecimal__f_bigDecimal).toBigIntegerExact__Ljava_math_BigInteger()))
    } catch (e) {
      if ((e instanceof $c_jl_ArithmeticException)) {
        return $m_s_None$()
      } else {
        throw e
      }
    }
  } else {
    return $m_s_None$()
  }
});
$c_s_math_BigDecimal.prototype.toString__T = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).toString__T()
});
$c_s_math_BigDecimal.prototype.underlying__O = (function() {
  return this.s_math_BigDecimal__f_bigDecimal
});
function $as_s_math_BigDecimal(obj) {
  return (((obj instanceof $c_s_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigDecimal"))
}
function $isArrayOf_s_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigDecimal)))
}
function $asArrayOf_s_math_BigDecimal(obj, depth) {
  return (($isArrayOf_s_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigDecimal;", depth))
}
var $d_s_math_BigDecimal = new $TypeData().initClass({
  s_math_BigDecimal: 0
}, false, "scala.math.BigDecimal", {
  s_math_BigDecimal: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_math_BigDecimal.prototype.$classData = $d_s_math_BigDecimal;
function $p_s_math_BigInt__longEncoding__Z($thiz) {
  var this$1 = $thiz.s_math_BigInt__f__long;
  return (!((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === (-2147483648))))
}
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $n($thiz.bigInteger__Ljava_math_BigInteger()).shiftRight__I__Ljava_math_BigInteger(2147483647);
  var this$1 = $n(shifted);
  if ((this$1.Ljava_math_BigInteger__f_sign !== 0)) {
    return (!$n(shifted).equals__O__Z($m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$minusOne))
  } else {
    return false
  }
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, _bigInteger, _long) {
  $thiz.s_math_BigInt__f__bigInteger = _bigInteger;
  $thiz.s_math_BigInt__f__long = _long;
  return $thiz
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__($thiz, bigInteger) {
  var this$1 = $n(bigInteger);
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, bigInteger, (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1) <= 63) ? $n(bigInteger).longValue__J() : new $c_RTLong(0, (-2147483648))));
  return $thiz
}
/** @constructor */
function $c_s_math_BigInt() {
  this.s_math_BigInt__f__bigInteger = null;
  this.s_math_BigInt__f__long = $L0
}
$c_s_math_BigInt.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigInt.prototype.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
  /*<skip>*/
}
$h_s_math_BigInt.prototype = $c_s_math_BigInt.prototype;
$c_s_math_BigInt.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_math_BigInt__I($as_s_math_BigInt(that))
});
$c_s_math_BigInt.prototype.bigInteger__Ljava_math_BigInteger = (function() {
  var read = this.s_math_BigInt__f__bigInteger;
  if ((read !== null)) {
    return read
  } else {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var write = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi));
    this.s_math_BigInt__f__bigInteger = write;
    return write
  }
});
$c_s_math_BigInt.prototype.hashCode__I = (function() {
  if (this.isValidLong__Z()) {
    return $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this)
  } else {
    var x = this.bigInteger__Ljava_math_BigInteger();
    return $m_sr_Statics$().anyHash__O__I(x)
  }
});
$c_s_math_BigInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    var x2 = $as_s_math_BigInt(that);
    return this.equals__s_math_BigInt__Z(x2)
  } else if ((that instanceof $c_s_math_BigDecimal)) {
    var x3 = $as_s_math_BigDecimal(that);
    return $n(x3).equals__O__Z(this)
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    return (this.isValidDouble__Z() && (this.doubleValue__D() === x4))
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if (this.isValidFloat__Z()) {
      var this$1 = $n(this.bigInteger__Ljava_math_BigInteger());
      return ($m_jl_Float$().parseFloat__T__F($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1)) === x5)
    } else {
      return false
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that))
  }
});
$c_s_math_BigInt.prototype.isValidByte__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 2147483520) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147483521)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidShort__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 2147450880) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147450881)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidChar__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if ((ahi >= 0)) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147418113)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidInt__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 0) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-1)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidLong__Z = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) || $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, $m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger))
});
$c_s_math_BigInt.prototype.isValidFloat__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 24)) {
    var $$x1 = true
  } else {
    var lowest = this.lowestSetBit__I();
    var $$x1 = (((bitLen <= 128) && (lowest >= (((-24) + bitLen) | 0))) && (lowest < 128))
  };
  if ($$x1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidDouble__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 53)) {
    var $$x1 = true
  } else {
    var lowest = this.lowestSetBit__I();
    var $$x1 = (((bitLen <= 1024) && (lowest >= (((-53) + bitLen) | 0))) && (lowest < 1024))
  };
  if ($$x1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.equals__s_math_BigInt__Z = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z($n(that))) {
      var this$1 = this.s_math_BigInt__f__long;
      var b = $n(that).s_math_BigInt__f__long;
      return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
    } else {
      return false
    }
  } else {
    return ((!$p_s_math_BigInt__longEncoding__Z($n(that))) && $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, $n(that).s_math_BigInt__f__bigInteger))
  }
});
$c_s_math_BigInt.prototype.compare__s_math_BigInt__I = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z($n(that))) {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $n(that).s_math_BigInt__f__long;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1)
    } else {
      var this$1 = $n($n(that).s_math_BigInt__f__bigInteger);
      return ((-this$1.Ljava_math_BigInteger__f_sign) | 0)
    }
  } else if ($p_s_math_BigInt__longEncoding__Z($n(that))) {
    var this$2 = $n(this.s_math_BigInt__f__bigInteger);
    return this$2.Ljava_math_BigInteger__f_sign
  } else {
    return $n(this.s_math_BigInt__f__bigInteger).compareTo__Ljava_math_BigInteger__I($n(that).s_math_BigInt__f__bigInteger)
  }
});
$c_s_math_BigInt.prototype.$plus__s_math_BigInt__s_math_BigInt = (function(that) {
  if (($p_s_math_BigInt__longEncoding__Z(this) && $p_s_math_BigInt__longEncoding__Z($n(that)))) {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = $n(that).s_math_BigInt__f__long;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var lo$2 = ((lo + lo$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
    var hi$3 = (hi ^ hi$1);
    var hi$4 = (~hi$3);
    var hi$5 = (hi ^ hi$2);
    var hi$6 = (hi$4 & hi$5);
    if ((hi$6 >= 0)) {
      return $m_s_math_BigInt$().apply__J__s_math_BigInt(new $c_RTLong(lo$2, hi$2))
    }
  };
  var $$x1 = $m_s_math_BigInt$();
  var this$2 = $n(this.bigInteger__Ljava_math_BigInteger());
  var bi = $n(that).bigInteger__Ljava_math_BigInteger();
  return $n($$x1).apply__Ljava_math_BigInteger__s_math_BigInt($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, bi))
});
$c_s_math_BigInt.prototype.lowestSetBit__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
      return (-1)
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      if ((lo !== 0)) {
        if ((lo === 0)) {
          return 32
        } else {
          var i = (lo & ((-lo) | 0));
          return ((31 - $uI(Math.clz32(i))) | 0)
        }
      } else {
        if ((hi === 0)) {
          var $$x1 = 32
        } else {
          var i$1 = (hi & ((-hi) | 0));
          var $$x1 = ((31 - $uI(Math.clz32(i$1))) | 0)
        };
        return ((32 + $$x1) | 0)
      }
    }
  } else {
    return $n(this.bigInteger__Ljava_math_BigInteger()).getLowestSetBit__I()
  }
});
$c_s_math_BigInt.prototype.bitLength__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi < 0)) {
      var b = this.s_math_BigInt__f__long;
      var bhi = b.RTLong__f_hi;
      var lo = ((1 + b.RTLong__f_lo) | 0);
      var hi = ((lo === 0) ? ((1 + bhi) | 0) : bhi);
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      return ((64 - ((hi$1 !== 0) ? $uI(Math.clz32(hi$1)) : ((32 + $uI(Math.clz32(lo$1))) | 0))) | 0)
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo$2 = t.RTLong__f_lo;
      var hi$2 = t.RTLong__f_hi;
      return ((64 - ((hi$2 !== 0) ? $uI(Math.clz32(hi$2)) : ((32 + $uI(Math.clz32(lo$2))) | 0))) | 0)
    }
  } else {
    var this$11 = $n(this.s_math_BigInt__f__bigInteger);
    return $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$11)
  }
});
$c_s_math_BigInt.prototype.byteValue__B = (function() {
  return ((this.intValue__I() << 24) >> 24)
});
$c_s_math_BigInt.prototype.shortValue__S = (function() {
  return ((this.intValue__I() << 16) >> 16)
});
$c_s_math_BigInt.prototype.intValue__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    return this$1.RTLong__f_lo
  } else {
    return $n(this.bigInteger__Ljava_math_BigInteger()).intValue__I()
  }
});
$c_s_math_BigInt.prototype.longValue__J = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) ? this.s_math_BigInt__f__long : $n(this.s_math_BigInt__f__bigInteger).longValue__J())
});
$c_s_math_BigInt.prototype.floatValue__F = (function() {
  var this$1 = $n(this.bigInteger__Ljava_math_BigInteger());
  return $m_jl_Float$().parseFloat__T__F($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1))
});
$c_s_math_BigInt.prototype.doubleValue__D = (function() {
  if (this.isValidLong__Z()) {
    var this$1 = this.s_math_BigInt__f__long;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi >= (-2097152))) {
      var this$2 = this.s_math_BigInt__f__long;
      var ahi$1 = this$2.RTLong__f_hi;
      var $$x1 = ((ahi$1 === 2097152) ? (this$2.RTLong__f_lo === 0) : (ahi$1 < 2097152))
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var this$3 = this.s_math_BigInt__f__long;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$3.RTLong__f_lo, this$3.RTLong__f_hi)
  } else {
    var this$4 = $n(this.bigInteger__Ljava_math_BigInteger());
    return $m_jl_Double$().parseDouble__T__D($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$4))
  }
});
$c_s_math_BigInt.prototype.toString__T = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi)
  } else {
    var this$2 = $n(this.s_math_BigInt__f__bigInteger);
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$2)
  }
});
$c_s_math_BigInt.prototype.underlying__O = (function() {
  return this.bigInteger__Ljava_math_BigInteger()
});
function $as_s_math_BigInt(obj) {
  return (((obj instanceof $c_s_math_BigInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigInt"))
}
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigInt)))
}
function $asArrayOf_s_math_BigInt(obj, depth) {
  return (($isArrayOf_s_math_BigInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigInt;", depth))
}
var $d_s_math_BigInt = new $TypeData().initClass({
  s_math_BigInt: 0
}, false, "scala.math.BigInt", {
  s_math_BigInt: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_math_BigInt.prototype.$classData = $d_s_math_BigInt;
function $f_s_math_Numeric$DoubleIsFractional__plus__D__D__D($thiz, x, y) {
  return (x + y)
}
function $f_s_math_Numeric$DoubleIsFractional__minus__D__D__D($thiz, x, y) {
  return (x - y)
}
function $f_s_math_Numeric$DoubleIsFractional__times__D__D__D($thiz, x, y) {
  return (x * y)
}
function $f_s_math_Numeric$DoubleIsFractional__negate__D__D($thiz, x) {
  return (-x)
}
function $f_s_math_Numeric$IntIsIntegral__plus__I__I__I($thiz, x, y) {
  return ((x + y) | 0)
}
function $f_s_math_Numeric$IntIsIntegral__minus__I__I__I($thiz, x, y) {
  return ((x - y) | 0)
}
function $f_s_math_Numeric$IntIsIntegral__times__I__I__I($thiz, x, y) {
  return Math.imul(x, y)
}
function $f_s_math_Numeric$IntIsIntegral__negate__I__I($thiz, x) {
  return ((-x) | 0)
}
/** @constructor */
function $c_s_math_Ordering$Int$() {
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = null;
  $n_s_math_Ordering$Int$ = this;
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = new $c_s_math_Ordering$Reverse(this)
}
$c_s_math_Ordering$Int$.prototype = new $h_O();
$c_s_math_Ordering$Int$.prototype.constructor = $c_s_math_Ordering$Int$;
/** @constructor */
function $h_s_math_Ordering$Int$() {
  /*<skip>*/
}
$h_s_math_Ordering$Int$.prototype = $c_s_math_Ordering$Int$.prototype;
$c_s_math_Ordering$Int$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Int$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1))
});
var $d_s_math_Ordering$Int$ = new $TypeData().initClass({
  s_math_Ordering$Int$: 0
}, false, "scala.math.Ordering$Int$", {
  s_math_Ordering$Int$: 1,
  O: 1,
  s_math_Ordering$IntOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$CachedReverse: 1
});
$c_s_math_Ordering$Int$.prototype.$classData = $d_s_math_Ordering$Int$;
var $n_s_math_Ordering$Int$;
function $m_s_math_Ordering$Int$() {
  if ((!$n_s_math_Ordering$Int$)) {
    $n_s_math_Ordering$Int$ = new $c_s_math_Ordering$Int$()
  };
  return $n_s_math_Ordering$Int$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$BooleanManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$BooleanManifest.prototype = $c_s_reflect_ManifestFactory$BooleanManifest.prototype;
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_Z.getClassOf()
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.unapply__O__s_Option = (function(x) {
  if (((typeof x) === "boolean")) {
    var x2 = $uZ(x);
    return new $c_s_Some(x2)
  } else {
    return $m_s_None$()
  }
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_Z(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$ByteManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ByteManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ByteManifest.prototype = $c_s_reflect_ManifestFactory$ByteManifest.prototype;
$c_s_reflect_ManifestFactory$ByteManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_B.getClassOf()
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isByte(x)) {
    var x2 = $uB(x);
    return new $c_s_Some(x2)
  } else {
    return $m_s_None$()
  }
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_B(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$CharManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$CharManifest.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$CharManifest.prototype = $c_s_reflect_ManifestFactory$CharManifest.prototype;
$c_s_reflect_ManifestFactory$CharManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_C.getClassOf()
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.unapply__O__s_Option = (function(x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return new $c_s_Some($bC(x2))
  } else {
    return $m_s_None$()
  }
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_C(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$DoubleManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$DoubleManifest.prototype = $c_s_reflect_ManifestFactory$DoubleManifest.prototype;
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_D.getClassOf()
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.unapply__O__s_Option = (function(x) {
  if (((typeof x) === "number")) {
    var x2 = $uD(x);
    return new $c_s_Some(x2)
  } else {
    return $m_s_None$()
  }
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_D(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$FloatManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$FloatManifest.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$FloatManifest.prototype = $c_s_reflect_ManifestFactory$FloatManifest.prototype;
$c_s_reflect_ManifestFactory$FloatManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_F.getClassOf()
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isFloat(x)) {
    var x2 = $uF(x);
    return new $c_s_Some(x2)
  } else {
    return $m_s_None$()
  }
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_F(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$IntManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$IntManifest.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$IntManifest.prototype = $c_s_reflect_ManifestFactory$IntManifest.prototype;
$c_s_reflect_ManifestFactory$IntManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_I.getClassOf()
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isInt(x)) {
    var x2 = $uI(x);
    return new $c_s_Some(x2)
  } else {
    return $m_s_None$()
  }
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_I(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$LongManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$LongManifest.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$LongManifest.prototype = $c_s_reflect_ManifestFactory$LongManifest.prototype;
$c_s_reflect_ManifestFactory$LongManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_J.getClassOf()
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.unapply__O__s_Option = (function(x) {
  if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_s_Some(new $c_RTLong(lo, hi))
  } else {
    return $m_s_None$()
  }
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_J(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$PhantomManifest() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$PhantomManifest.prototype = new $h_s_reflect_ManifestFactory$ClassTypeManifest();
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.constructor = $c_s_reflect_ManifestFactory$PhantomManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$PhantomManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$PhantomManifest.prototype = $c_s_reflect_ManifestFactory$PhantomManifest.prototype;
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.toString__T = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_toString
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.hashCode__I = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$ShortManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ShortManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ShortManifest.prototype = $c_s_reflect_ManifestFactory$ShortManifest.prototype;
$c_s_reflect_ManifestFactory$ShortManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_S.getClassOf()
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isShort(x)) {
    var x2 = $uS(x);
    return new $c_s_Some(x2)
  } else {
    return $m_s_None$()
  }
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_S(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$UnitManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$UnitManifest.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$UnitManifest.prototype = $c_s_reflect_ManifestFactory$UnitManifest.prototype;
$c_s_reflect_ManifestFactory$UnitManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_V.getClassOf()
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.unapply__O__s_Option = (function(x) {
  return ((x === (void 0)) ? new $c_s_Some((void 0)) : $m_s_None$())
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.newArray__I__O = (function(len) {
  return new ($d_jl_Void.getArrayOf().constr)(len)
});
function $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour__($thiz) {
  $ct_Lscalacss_internal_ValueT$TypedAttrT3__T__($thiz, " ");
  return $thiz
}
/** @constructor */
function $c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour() {
  this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep = null
}
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour.prototype = new $h_Lscalacss_internal_ValueT$TypedAttrT3();
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour.prototype.constructor = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour;
/** @constructor */
function $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour() {
  /*<skip>*/
}
$h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour.prototype = $c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour.prototype;
$c_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour.prototype.mkColor__T__O = (function(s) {
  return new $c_Lscalacss_internal_AV(this.attr__Lscalacss_internal_Attr(), s)
});
/** @constructor */
function $c_Lscalatags_JsDom$TypedTag(tag, modifiers, void$1, namespace) {
  this.Lscalatags_JsDom$TypedTag__f_tag = null;
  this.Lscalatags_JsDom$TypedTag__f_modifiers = null;
  this.Lscalatags_JsDom$TypedTag__f_void = false;
  this.Lscalatags_JsDom$TypedTag__f_namespace = null;
  this.Lscalatags_JsDom$TypedTag__f_tag = tag;
  this.Lscalatags_JsDom$TypedTag__f_modifiers = modifiers;
  this.Lscalatags_JsDom$TypedTag__f_void = void$1;
  this.Lscalatags_JsDom$TypedTag__f_namespace = namespace
}
$c_Lscalatags_JsDom$TypedTag.prototype = new $h_O();
$c_Lscalatags_JsDom$TypedTag.prototype.constructor = $c_Lscalatags_JsDom$TypedTag;
/** @constructor */
function $h_Lscalatags_JsDom$TypedTag() {
  /*<skip>*/
}
$h_Lscalatags_JsDom$TypedTag.prototype = $c_Lscalatags_JsDom$TypedTag.prototype;
$c_Lscalatags_JsDom$TypedTag.prototype.render__Lorg_scalajs_dom_Element = (function() {
  var elem = document.createElementNS($n(this.Lscalatags_JsDom$TypedTag__f_namespace).uri__T(), this.Lscalatags_JsDom$TypedTag__f_tag);
  $f_Lscalatags_generic_TypedTag__build__O__V(this, elem);
  return elem
});
$c_Lscalatags_JsDom$TypedTag.prototype.apply__sci_Seq__Lscalatags_JsDom$TypedTag = (function(xs) {
  var x$1 = this.Lscalatags_JsDom$TypedTag__f_tag;
  var x$2 = this.Lscalatags_JsDom$TypedTag__f_void;
  var this$1 = $n(this.Lscalatags_JsDom$TypedTag__f_modifiers);
  var x$3 = new $c_sci_$colon$colon(xs, this$1);
  var x$4 = this.Lscalatags_JsDom$TypedTag__f_namespace;
  return new $c_Lscalatags_JsDom$TypedTag(x$1, x$3, x$2, x$4)
});
$c_Lscalatags_JsDom$TypedTag.prototype.toString__T = (function() {
  return $as_T(this.render__Lorg_scalajs_dom_Element().outerHTML)
});
$c_Lscalatags_JsDom$TypedTag.prototype.productPrefix__T = (function() {
  return "TypedTag"
});
$c_Lscalatags_JsDom$TypedTag.prototype.productArity__I = (function() {
  return 4
});
$c_Lscalatags_JsDom$TypedTag.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscalatags_JsDom$TypedTag__f_tag;
      break
    }
    case 1: {
      return this.Lscalatags_JsDom$TypedTag__f_modifiers;
      break
    }
    case 2: {
      return this.Lscalatags_JsDom$TypedTag__f_void;
      break
    }
    case 3: {
      return this.Lscalatags_JsDom$TypedTag__f_namespace;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscalatags_JsDom$TypedTag.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscalatags_JsDom$TypedTag.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TypedTag");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lscalatags_JsDom$TypedTag__f_tag;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lscalatags_JsDom$TypedTag__f_modifiers;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lscalatags_JsDom$TypedTag__f_void ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lscalatags_JsDom$TypedTag__f_namespace;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lscalatags_JsDom$TypedTag.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscalatags_JsDom$TypedTag)) {
    var TypedTag$1 = $as_Lscalatags_JsDom$TypedTag(x$1);
    if (((this.Lscalatags_JsDom$TypedTag__f_void === $n(TypedTag$1).Lscalatags_JsDom$TypedTag__f_void) && (this.Lscalatags_JsDom$TypedTag__f_tag === $n(TypedTag$1).Lscalatags_JsDom$TypedTag__f_tag))) {
      var x = this.Lscalatags_JsDom$TypedTag__f_modifiers;
      var x$2 = $n(TypedTag$1).Lscalatags_JsDom$TypedTag__f_modifiers;
      var $$x2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3 = this.Lscalatags_JsDom$TypedTag__f_namespace;
      var x$4 = $n(TypedTag$1).Lscalatags_JsDom$TypedTag__f_namespace;
      if ((x$3 === null)) {
        var $$x1 = (x$4 === null)
      } else {
        var this$1 = $n(x$3);
        var $$x1 = (this$1 === x$4)
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n(TypedTag$1);
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lscalatags_JsDom$TypedTag.prototype.applyTo__O__V = (function(t) {
  $f_Lscalatags_jsdom_Frag__applyTo__Lorg_scalajs_dom_Element__V(this, t)
});
$c_Lscalatags_JsDom$TypedTag.prototype.render__Lorg_scalajs_dom_Node = (function() {
  return this.render__Lorg_scalajs_dom_Element()
});
function $as_Lscalatags_JsDom$TypedTag(obj) {
  return (((obj instanceof $c_Lscalatags_JsDom$TypedTag) || (obj === null)) ? obj : $throwClassCastException(obj, "scalatags.JsDom$TypedTag"))
}
function $isArrayOf_Lscalatags_JsDom$TypedTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscalatags_JsDom$TypedTag)))
}
function $asArrayOf_Lscalatags_JsDom$TypedTag(obj, depth) {
  return (($isArrayOf_Lscalatags_JsDom$TypedTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscalatags.JsDom$TypedTag;", depth))
}
var $d_Lscalatags_JsDom$TypedTag = new $TypeData().initClass({
  Lscalatags_JsDom$TypedTag: 0
}, false, "scalatags.JsDom$TypedTag", {
  Lscalatags_JsDom$TypedTag: 1,
  O: 1,
  Lscalatags_generic_TypedTag: 1,
  Lscalatags_generic_Frag: 1,
  Lscalatags_generic_Modifier: 1,
  Lscalatags_jsdom_Frag: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscalatags_JsDom$TypedTag.prototype.$classData = $d_Lscalatags_JsDom$TypedTag;
/** @constructor */
function $c_Lcats_instances_EqInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_EqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EqInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_EqInstances$$anon$1.prototype = $c_Lcats_instances_EqInstances$$anon$1.prototype;
$c_Lcats_instances_EqInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_Lcats_kernel_Eq(fa);
  $n($m_Lcats_package$().Lcats_package$__f_Eq);
  return new $c_Lcats_kernel_Eq$$anon$2(fa$1, fi)
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.product__Lcats_kernel_Eq__Lcats_kernel_Eq__Lcats_kernel_Eq = (function(fa, fb) {
  $n($m_Lcats_package$().Lcats_package$__f_Eq);
  var f = new $c_sjsr_AnonFunction2(((left$2, right$2) => {
    var left = $as_T2(left$2);
    var right = $as_T2(right$2);
    return ($n(fa).eqv__O__O__Z($n(left)._1__O(), $n(right)._1__O()) && $n(fb).eqv__O__O__Z($n(left)._2__O(), $n(right)._2__O()))
  }));
  return new $c_Lcats_kernel_Eq$$anon$5(f)
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__Lcats_kernel_Eq__Lcats_kernel_Eq__Lcats_kernel_Eq($as_Lcats_kernel_Eq(fa), $as_Lcats_kernel_Eq(fb))
});
var $d_Lcats_instances_EqInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_EqInstances$$anon$1: 0
}, false, "cats.instances.EqInstances$$anon$1", {
  Lcats_instances_EqInstances$$anon$1: 1,
  O: 1,
  Lcats_ContravariantMonoidal: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.$classData = $d_Lcats_instances_EqInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_EquivInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_EquivInstances$$anon$1.prototype = $c_Lcats_instances_EquivInstances$$anon$1.prototype;
$c_Lcats_instances_EquivInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_s_math_Equiv(fa);
  return new $c_Lcats_instances_EquivInstances$$anon$1$$anon$3(this, fa$1, fi)
});
$c_Lcats_instances_EquivInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Equiv(fa);
  var fb$1 = $as_s_math_Equiv(fb);
  return new $c_Lcats_instances_EquivInstances$$anon$1$$anon$4(this, fa$1, fb$1)
});
var $d_Lcats_instances_EquivInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_EquivInstances$$anon$1: 0
}, false, "cats.instances.EquivInstances$$anon$1", {
  Lcats_instances_EquivInstances$$anon$1: 1,
  O: 1,
  Lcats_ContravariantMonoidal: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_EquivInstances$$anon$1.prototype.$classData = $d_Lcats_instances_EquivInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_OrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OrderInstances$$anon$1.prototype = $c_Lcats_instances_OrderInstances$$anon$1.prototype;
$c_Lcats_instances_OrderInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_Lcats_kernel_Order(fa);
  $n($m_Lcats_package$().Lcats_package$__f_Order);
  return new $c_Lcats_kernel_Order$$anon$2(fa$1, fi)
});
$c_Lcats_instances_OrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Order(fa);
  var fb$1 = $as_Lcats_kernel_Order(fb);
  return new $c_Lcats_instances_OrderInstances$$anon$1$$anon$2(this, fa$1, fb$1)
});
var $d_Lcats_instances_OrderInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OrderInstances$$anon$1: 0
}, false, "cats.instances.OrderInstances$$anon$1", {
  Lcats_instances_OrderInstances$$anon$1: 1,
  O: 1,
  Lcats_ContravariantMonoidal: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_OrderInstances$$anon$1.prototype.$classData = $d_Lcats_instances_OrderInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_OrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OrderingInstances$$anon$1.prototype = $c_Lcats_instances_OrderingInstances$$anon$1.prototype;
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_s_math_Ordering(fa);
  var this$1 = $n(fa$1);
  return new $c_s_math_Ordering$$anon$1(this$1, fi)
});
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Ordering(fa);
  var fb$1 = $as_s_math_Ordering(fb);
  return new $c_Lcats_instances_OrderingInstances$$anon$1$$anon$2(this, fa$1, fb$1)
});
var $d_Lcats_instances_OrderingInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OrderingInstances$$anon$1: 0
}, false, "cats.instances.OrderingInstances$$anon$1", {
  Lcats_instances_OrderingInstances$$anon$1: 1,
  O: 1,
  Lcats_ContravariantMonoidal: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.$classData = $d_Lcats_instances_OrderingInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_Lcats_kernel_PartialOrder(fa);
  $n($m_Lcats_package$().Lcats_package$__f_PartialOrder);
  return new $c_Lcats_kernel_PartialOrder$$anon$1(fa$1, fi)
});
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_PartialOrder(fa);
  var fb$1 = $as_Lcats_kernel_PartialOrder(fb);
  return new $c_Lcats_instances_PartialOrderInstances$$anon$1$$anon$2(this, fa$1, fb$1)
});
var $d_Lcats_instances_PartialOrderInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_PartialOrderInstances$$anon$1: 0
}, false, "cats.instances.PartialOrderInstances$$anon$1", {
  Lcats_instances_PartialOrderInstances$$anon$1: 1,
  O: 1,
  Lcats_ContravariantMonoidal: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.$classData = $d_Lcats_instances_PartialOrderInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_s_math_PartialOrdering(fa);
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$2(this, fa$1, fi)
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_PartialOrdering(fa);
  var fb$1 = $as_s_math_PartialOrdering(fb);
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$1$$anon$3(this, fa$1, fb$1)
});
var $d_Lcats_instances_PartialOrderingInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_PartialOrderingInstances$$anon$1: 0
}, false, "cats.instances.PartialOrderingInstances$$anon$1", {
  Lcats_instances_PartialOrderingInstances$$anon$1: 1,
  O: 1,
  Lcats_ContravariantMonoidal: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.$classData = $d_Lcats_instances_PartialOrderingInstances$$anon$1;
/** @constructor */
function $c_Lcats_kernel_instances_BitSetSemilattice() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BitSetSemilattice.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.constructor = $c_Lcats_kernel_instances_BitSetSemilattice;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetSemilattice() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BitSetSemilattice.prototype = $c_Lcats_kernel_instances_BitSetSemilattice.prototype;
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_BitSet(x);
  var y$1 = $as_sci_BitSet(y);
  var this$1 = $n(x$1);
  return $as_sci_BitSet($f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this$1, y$1))
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.empty__O = (function() {
  return $m_sci_BitSet$().sci_BitSet$__f_empty
});
var $d_Lcats_kernel_instances_BitSetSemilattice = new $TypeData().initClass({
  Lcats_kernel_instances_BitSetSemilattice: 0
}, false, "cats.kernel.instances.BitSetSemilattice", {
  Lcats_kernel_instances_BitSetSemilattice: 1,
  O: 1,
  Lcats_kernel_BoundedSemilattice: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.$classData = $d_Lcats_kernel_instances_BitSetSemilattice;
/** @constructor */
function $c_Lcats_kernel_instances_DurationOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationOrder.prototype.constructor = $c_Lcats_kernel_instances_DurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DurationOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DurationOrder.prototype = $c_Lcats_kernel_instances_DurationOrder.prototype;
$c_Lcats_kernel_instances_DurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $n(x).equals__O__Z(y))
});
$c_Lcats_kernel_instances_DurationOrder.prototype.neqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : $n(x).equals__O__Z(y)))
});
$c_Lcats_kernel_instances_DurationOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z($as_s_concurrent_duration_Duration(x), $as_s_concurrent_duration_Duration(y))
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z($as_s_concurrent_duration_Duration(x), $as_s_concurrent_duration_Duration(y))
});
$c_Lcats_kernel_instances_DurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  var this$1 = $n(x$1);
  return this$1.compare__s_concurrent_duration_Duration__I(y$1)
});
var $d_Lcats_kernel_instances_DurationOrder = new $TypeData().initClass({
  Lcats_kernel_instances_DurationOrder: 0
}, false, "cats.kernel.instances.DurationOrder", {
  Lcats_kernel_instances_DurationOrder: 1,
  O: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_DurationBounded: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1
});
$c_Lcats_kernel_instances_DurationOrder.prototype.$classData = $d_Lcats_kernel_instances_DurationOrder;
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FiniteDurationOrder.prototype = $c_Lcats_kernel_instances_FiniteDurationOrder.prototype;
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $n(x).equals__O__Z(y))
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.neqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : $n(x).equals__O__Z(y)))
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z($as_s_concurrent_duration_FiniteDuration(x), $as_s_concurrent_duration_FiniteDuration(y))
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z($as_s_concurrent_duration_FiniteDuration(x), $as_s_concurrent_duration_FiniteDuration(y))
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  return $n(x$1).compare__s_concurrent_duration_Duration__I(y$1)
});
var $d_Lcats_kernel_instances_FiniteDurationOrder = new $TypeData().initClass({
  Lcats_kernel_instances_FiniteDurationOrder: 0
}, false, "cats.kernel.instances.FiniteDurationOrder", {
  Lcats_kernel_instances_FiniteDurationOrder: 1,
  O: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_FiniteDurationBounded: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.$classData = $d_Lcats_kernel_instances_FiniteDurationOrder;
/** @constructor */
function $c_Lcats_kernel_instances_UUIDInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.constructor = $c_Lcats_kernel_instances_UUIDInstances$$anon$1;
/** @constructor */
function $h_Lcats_kernel_instances_UUIDInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype = $c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype;
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_ju_UUID(x);
  var y$1 = $as_ju_UUID(y);
  return $n(x$1).compareTo__ju_UUID__I(y$1)
});
var $d_Lcats_kernel_instances_UUIDInstances$$anon$1 = new $TypeData().initClass({
  Lcats_kernel_instances_UUIDInstances$$anon$1: 0
}, false, "cats.kernel.instances.UUIDInstances$$anon$1", {
  Lcats_kernel_instances_UUIDInstances$$anon$1: 1,
  O: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_UUIDBounded: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.$classData = $d_Lcats_kernel_instances_UUIDInstances$$anon$1;
function $p_Lio_circe_Decoder$__decodeUUID$lzycompute__Lio_circe_Decoder($thiz) {
  if (((1024 & $thiz.Lio_circe_Decoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Decoder$__f_decodeUUID = new $c_Lio_circe_Decoder$$anon$38();
    $thiz.Lio_circe_Decoder$__f_bitmap$0 = (1024 | $thiz.Lio_circe_Decoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Decoder$__f_decodeUUID
}
function $p_Lio_circe_Decoder$__decodeDuration$lzycompute__Lio_circe_Decoder($thiz) {
  if (((2048 & $thiz.Lio_circe_Decoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Decoder$__f_decodeDuration = new $c_Lio_circe_Decoder$$anon$53();
    $thiz.Lio_circe_Decoder$__f_bitmap$0 = (2048 | $thiz.Lio_circe_Decoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Decoder$__f_decodeDuration
}
function $p_Lio_circe_Decoder$__decodeInstant$lzycompute__Lio_circe_Decoder($thiz) {
  if (((4096 & $thiz.Lio_circe_Decoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Decoder$__f_decodeInstant = new $c_Lio_circe_Decoder$$anon$54();
    $thiz.Lio_circe_Decoder$__f_bitmap$0 = (4096 | $thiz.Lio_circe_Decoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Decoder$__f_decodeInstant
}
function $p_Lio_circe_Decoder$__decodePeriod$lzycompute__Lio_circe_Decoder($thiz) {
  if (((8192 & $thiz.Lio_circe_Decoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Decoder$__f_decodePeriod = new $c_Lio_circe_Decoder$$anon$55();
    $thiz.Lio_circe_Decoder$__f_bitmap$0 = (8192 | $thiz.Lio_circe_Decoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Decoder$__f_decodePeriod
}
function $p_Lio_circe_Decoder$__decodeLocalDate$lzycompute__Lio_circe_Decoder($thiz) {
  if (((32768 & $thiz.Lio_circe_Decoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Decoder$__f_decodeLocalDate = new $c_Lio_circe_Decoder$$anon$67();
    $thiz.Lio_circe_Decoder$__f_bitmap$0 = (32768 | $thiz.Lio_circe_Decoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Decoder$__f_decodeLocalDate
}
function $p_Lio_circe_Decoder$__decodeLocalTime$lzycompute__Lio_circe_Decoder($thiz) {
  if (((65536 & $thiz.Lio_circe_Decoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Decoder$__f_decodeLocalTime = new $c_Lio_circe_Decoder$$anon$68();
    $thiz.Lio_circe_Decoder$__f_bitmap$0 = (65536 | $thiz.Lio_circe_Decoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Decoder$__f_decodeLocalTime
}
function $p_Lio_circe_Decoder$__decodeLocalDateTime$lzycompute__Lio_circe_Decoder($thiz) {
  if (((131072 & $thiz.Lio_circe_Decoder$__f_bitmap$0) === 0)) {
    $thiz.Lio_circe_Decoder$__f_decodeLocalDateTime = new $c_Lio_circe_Decoder$$anon$69();
    $thiz.Lio_circe_Decoder$__f_bitmap$0 = (131072 | $thiz.Lio_circe_Decoder$__f_bitmap$0)
  };
  return $thiz.Lio_circe_Decoder$__f_decodeLocalDateTime
}
/** @constructor */
function $c_Lio_circe_Decoder$() {
  this.Lio_circe_Decoder$__f_decodeUUID = null;
  this.Lio_circe_Decoder$__f_decodeDuration = null;
  this.Lio_circe_Decoder$__f_decodeInstant = null;
  this.Lio_circe_Decoder$__f_decodePeriod = null;
  this.Lio_circe_Decoder$__f_decodeLocalDate = null;
  this.Lio_circe_Decoder$__f_decodeLocalTime = null;
  this.Lio_circe_Decoder$__f_decodeLocalDateTime = null;
  this.Lio_circe_Decoder$__f_resultInstance = null;
  this.Lio_circe_Decoder$__f_decodeJson = null;
  this.Lio_circe_Decoder$__f_decodeJsonObject = null;
  this.Lio_circe_Decoder$__f_decodeString = null;
  this.Lio_circe_Decoder$__f_decodeUnit = null;
  this.Lio_circe_Decoder$__f_decodeBoolean = null;
  this.Lio_circe_Decoder$__f_decodeFloat = null;
  this.Lio_circe_Decoder$__f_decodeDouble = null;
  this.Lio_circe_Decoder$__f_decodeInt = null;
  this.Lio_circe_Decoder$__f_decodeLong = null;
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$rightNone = null;
  this.Lio_circe_Decoder$__f_keyMissingNone = null;
  this.Lio_circe_Decoder$__f_decoderInstances = null;
  this.Lio_circe_Decoder$__f_bitmap$0 = 0;
  $n_Lio_circe_Decoder$ = this;
  var this$1 = $m_Lcats_instances_package$either$();
  this.Lio_circe_Decoder$__f_resultInstance = new $c_Lcats_instances_EitherInstances$$anon$2(this$1);
  var this$2 = $m_Lcats_data_Validated$();
  var E = $m_Lcats_data_NonEmptyList$().catsDataSemigroupForNonEmptyList__Lcats_kernel_Semigroup();
  new $c_Lcats_data_ValidatedInstances$$anon$7(this$2, E);
  var this$3 = $m_Lcats_instances_package$either$();
  new $c_Lcats_instances_EitherInstances$$anon$3(this$3);
  new $c_Lio_circe_Decoder$$anon$22();
  this.Lio_circe_Decoder$__f_decodeJson = new $c_Lio_circe_Decoder$$anon$23();
  this.Lio_circe_Decoder$__f_decodeJsonObject = new $c_Lio_circe_Decoder$$anon$24();
  new $c_Lio_circe_Decoder$$anon$25();
  this.Lio_circe_Decoder$__f_decodeString = new $c_Lio_circe_Decoder$$anon$26();
  this.Lio_circe_Decoder$__f_decodeUnit = new $c_Lio_circe_Decoder$$anon$27();
  this.Lio_circe_Decoder$__f_decodeBoolean = new $c_Lio_circe_Decoder$$anon$28();
  new $c_Lio_circe_Decoder$$anon$29();
  this.Lio_circe_Decoder$__f_decodeFloat = new $c_Lio_circe_Decoder$$anon$30();
  this.Lio_circe_Decoder$__f_decodeDouble = new $c_Lio_circe_Decoder$$anon$31();
  new $c_Lio_circe_Decoder$$anon$32();
  new $c_Lio_circe_Decoder$$anon$33();
  this.Lio_circe_Decoder$__f_decodeInt = new $c_Lio_circe_Decoder$$anon$34();
  this.Lio_circe_Decoder$__f_decodeLong = new $c_Lio_circe_Decoder$$anon$35();
  new $c_Lio_circe_Decoder$$anon$36();
  new $c_Lio_circe_Decoder$$anon$37();
  $n($m_s_package$().s_package$__f_Right);
  var value = $m_s_None$();
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$rightNone = new $c_s_util_Right(value);
  $m_Lcats_data_Validated$();
  var a = $m_s_None$();
  new $c_Lcats_data_Validated$Valid(a);
  $n($m_s_package$().s_package$__f_Right);
  var value$1 = $m_s_None$();
  this.Lio_circe_Decoder$__f_keyMissingNone = new $c_s_util_Right(value$1);
  $m_Lcats_data_Validated$();
  var a$1 = $m_s_None$();
  new $c_Lcats_data_Validated$Valid(a$1);
  new $c_Lio_circe_Decoder$$anon$40();
  this.Lio_circe_Decoder$__f_decoderInstances = new $c_Lio_circe_Decoder$$anon$77()
}
$c_Lio_circe_Decoder$.prototype = new $h_O();
$c_Lio_circe_Decoder$.prototype.constructor = $c_Lio_circe_Decoder$;
/** @constructor */
function $h_Lio_circe_Decoder$() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$.prototype = $c_Lio_circe_Decoder$.prototype;
$c_Lio_circe_Decoder$.prototype.decodeUUID__Lio_circe_Decoder = (function() {
  return (((1024 & this.Lio_circe_Decoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Decoder$__decodeUUID$lzycompute__Lio_circe_Decoder(this) : this.Lio_circe_Decoder$__f_decodeUUID)
});
$c_Lio_circe_Decoder$.prototype.decodeDuration__Lio_circe_Decoder = (function() {
  return (((2048 & this.Lio_circe_Decoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Decoder$__decodeDuration$lzycompute__Lio_circe_Decoder(this) : this.Lio_circe_Decoder$__f_decodeDuration)
});
$c_Lio_circe_Decoder$.prototype.decodeInstant__Lio_circe_Decoder = (function() {
  return (((4096 & this.Lio_circe_Decoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Decoder$__decodeInstant$lzycompute__Lio_circe_Decoder(this) : this.Lio_circe_Decoder$__f_decodeInstant)
});
$c_Lio_circe_Decoder$.prototype.decodePeriod__Lio_circe_Decoder = (function() {
  return (((8192 & this.Lio_circe_Decoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Decoder$__decodePeriod$lzycompute__Lio_circe_Decoder(this) : this.Lio_circe_Decoder$__f_decodePeriod)
});
$c_Lio_circe_Decoder$.prototype.decodeLocalDate__Lio_circe_Decoder = (function() {
  return (((32768 & this.Lio_circe_Decoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Decoder$__decodeLocalDate$lzycompute__Lio_circe_Decoder(this) : this.Lio_circe_Decoder$__f_decodeLocalDate)
});
$c_Lio_circe_Decoder$.prototype.decodeLocalTime__Lio_circe_Decoder = (function() {
  return (((65536 & this.Lio_circe_Decoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Decoder$__decodeLocalTime$lzycompute__Lio_circe_Decoder(this) : this.Lio_circe_Decoder$__f_decodeLocalTime)
});
$c_Lio_circe_Decoder$.prototype.decodeLocalDateTime__Lio_circe_Decoder = (function() {
  return (((131072 & this.Lio_circe_Decoder$__f_bitmap$0) === 0) ? $p_Lio_circe_Decoder$__decodeLocalDateTime$lzycompute__Lio_circe_Decoder(this) : this.Lio_circe_Decoder$__f_decodeLocalDateTime)
});
var $d_Lio_circe_Decoder$ = new $TypeData().initClass({
  Lio_circe_Decoder$: 0
}, false, "io.circe.Decoder$", {
  Lio_circe_Decoder$: 1,
  O: 1,
  Lio_circe_DecoderDerivation: 1,
  Lio_circe_CollectionDecoders: 1,
  Lio_circe_TupleDecoders: 1,
  Lio_circe_ProductDecoders: 1,
  Lio_circe_LiteralDecoders: 1,
  Lio_circe_EnumerationDecoders: 1,
  Lio_circe_LowPriorityDecoders: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_circe_Decoder$.prototype.$classData = $d_Lio_circe_Decoder$;
var $n_Lio_circe_Decoder$;
function $m_Lio_circe_Decoder$() {
  if ((!$n_Lio_circe_Decoder$)) {
    $n_Lio_circe_Decoder$ = new $c_Lio_circe_Decoder$()
  };
  return $n_Lio_circe_Decoder$
}
/** @constructor */
function $c_Lio_circe_generic_codec_DerivedAsObjectCodec() {
  /*<skip>*/
}
$c_Lio_circe_generic_codec_DerivedAsObjectCodec.prototype = new $h_O();
$c_Lio_circe_generic_codec_DerivedAsObjectCodec.prototype.constructor = $c_Lio_circe_generic_codec_DerivedAsObjectCodec;
/** @constructor */
function $h_Lio_circe_generic_codec_DerivedAsObjectCodec() {
  /*<skip>*/
}
$h_Lio_circe_generic_codec_DerivedAsObjectCodec.prototype = $c_Lio_circe_generic_codec_DerivedAsObjectCodec.prototype;
$c_Lio_circe_generic_codec_DerivedAsObjectCodec.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_generic_codec_DerivedAsObjectCodec.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
/** @constructor */
function $c_Lio_circe_generic_codec_ReprAsObjectCodec() {
  /*<skip>*/
}
$c_Lio_circe_generic_codec_ReprAsObjectCodec.prototype = new $h_O();
$c_Lio_circe_generic_codec_ReprAsObjectCodec.prototype.constructor = $c_Lio_circe_generic_codec_ReprAsObjectCodec;
/** @constructor */
function $h_Lio_circe_generic_codec_ReprAsObjectCodec() {
  /*<skip>*/
}
$h_Lio_circe_generic_codec_ReprAsObjectCodec.prototype = $c_Lio_circe_generic_codec_ReprAsObjectCodec.prototype;
$c_Lio_circe_generic_codec_ReprAsObjectCodec.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a)
});
$c_Lio_circe_generic_codec_ReprAsObjectCodec.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c)
});
/** @constructor */
function $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1() {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1.prototype.constructor = $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1;
/** @constructor */
function $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1.prototype = $c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1.prototype;
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  if ($n($n(c).value__Lio_circe_Json()).isObject__Z()) {
    $n($m_s_package$().s_package$__f_Right);
    var value = $m_Lshapeless_HNil$();
    return new $c_s_util_Right(value)
  } else {
    $n($m_s_package$().s_package$__f_Left);
    $m_Lio_circe_DecodingFailure$();
    var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
    var value$1 = new $c_Lio_circe_DecodingFailure$$anon$2("HNil", ops);
    return new $c_s_util_Left(value$1)
  }
});
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  $as_Lshapeless_HNil(a);
  return $m_Lio_circe_JsonObject$().Lio_circe_JsonObject$__f_empty
});
var $d_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1 = new $TypeData().initClass({
  Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1: 0
}, false, "io.circe.generic.extras.codec.ReprAsObjectCodec$$anon$1", {
  Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1.prototype.$classData = $d_Lio_circe_generic_extras_codec_ReprAsObjectCodec$$anon$1;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P8__O__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8 = hook8;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P7__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P8() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P8.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P7();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P8.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P8;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P8() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P8.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P8.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P8.prototype.toString__T = (function() {
  return (((((((((((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6) + ",\n  hook7 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7) + ",\n  hook8 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P8(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P8) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P8"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P8(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P8)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P8(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P8(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P8;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P8 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P8: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P8", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P8: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P7: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P8.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P8;
/** @constructor */
function $c_Ljapgolly_scalajs_react_package$() {
  this.Ljapgolly_scalajs_react_internal_CoreGeneralF__f_ScalaFnComponent = null;
  this.Ljapgolly_scalajs_react_internal_CoreGeneralF__f_CustomHook = null;
  this.Ljapgolly_scalajs_react_package$__f_AsyncCallback = null;
  this.Ljapgolly_scalajs_react_package$__f_Callback = null;
  this.Ljapgolly_scalajs_react_package$__f_CallbackTo = null;
  this.Ljapgolly_scalajs_react_package$__f_CallbackOption = null;
  $ct_Ljapgolly_scalajs_react_internal_CoreGeneralF__Ljapgolly_scalajs_react_util_Effect$Sync__(this, $m_Ljapgolly_scalajs_react_util_DefaultEffects$().Ljapgolly_scalajs_react_util_DefaultEffects$__f_Sync);
  $n_Ljapgolly_scalajs_react_package$ = this;
  $f_Ljapgolly_scalajs_react_callback_Exports__$init$__V(this)
}
$c_Ljapgolly_scalajs_react_package$.prototype = new $h_Ljapgolly_scalajs_react_internal_CoreGeneralF();
$c_Ljapgolly_scalajs_react_package$.prototype.constructor = $c_Ljapgolly_scalajs_react_package$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_package$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_package$.prototype = $c_Ljapgolly_scalajs_react_package$.prototype;
var $d_Ljapgolly_scalajs_react_package$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_package$: 0
}, false, "japgolly.scalajs.react.package$", {
  Ljapgolly_scalajs_react_package$: 1,
  Ljapgolly_scalajs_react_internal_CoreGeneralF: 1,
  O: 1,
  Ljapgolly_scalajs_react_internal_CoreGeneral: 1,
  Ljapgolly_scalajs_react_ReactEventTypes: 1,
  Ljapgolly_scalajs_react_ReactExtensions: 1,
  Ljapgolly_scalajs_react_util_DomUtil: 1,
  Ljapgolly_scalajs_react_internal_FacadeExports: 1,
  Ljapgolly_scalajs_react_internal_ReactCallbackExtensions: 1,
  Ljapgolly_scalajs_react_callback_Exports: 1
});
$c_Ljapgolly_scalajs_react_package$.prototype.$classData = $d_Ljapgolly_scalajs_react_package$;
var $n_Ljapgolly_scalajs_react_package$;
function $m_Ljapgolly_scalajs_react_package$() {
  if ((!$n_Ljapgolly_scalajs_react_package$)) {
    $n_Ljapgolly_scalajs_react_package$ = new $c_Ljapgolly_scalajs_react_package$()
  };
  return $n_Ljapgolly_scalajs_react_package$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_util_EffectCallback$callback$() {
  this.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty = null;
  this.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_semigroupSyncUnit = null;
  this.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_semigroupSyncOr = null;
  $n_Ljapgolly_scalajs_react_util_EffectCallback$callback$ = this;
  this.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_empty = $m_Ljapgolly_scalajs_react_callback_Callback$().Ljapgolly_scalajs_react_callback_Callback$__f_empty;
  this.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_semigroupSyncUnit = new $c_sjsr_AnonFunction2(((x$1$2, x$2$2) => {
    var x$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x$1$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x$2 = $as_F0(x$2$2);
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(x$1, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(x$2).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
  }));
  this.Ljapgolly_scalajs_react_util_EffectCallback$callback$__f_semigroupSyncOr = new $c_sjsr_AnonFunction2(((x$3$2, x$4$2) => {
    var x$3 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(x$3$2)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var x$4 = $as_F0(x$4$2);
    var $$x2 = $m_Ljapgolly_scalajs_react_callback_CallbackTo$();
    var $$x1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(x$4).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
    var this$3 = $m_s_$less$colon$less$();
    return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($n($$x2).$bar$bar$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__s_$less$colon$less__Ljapgolly_scalajs_react_callback_Trampoline(x$3, $$x1, this$3.s_$less$colon$less$__f_singleton))
  }))
}
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.constructor = $c_Ljapgolly_scalajs_react_util_EffectCallback$callback$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_util_EffectCallback$callback$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype = $c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype;
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.runSync__F0__O = (function(f) {
  var this$ = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(this$);
  return $m_Ljapgolly_scalajs_react_callback_Trampoline$().run__Ljapgolly_scalajs_react_callback_Trampoline__O(this$2)
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.toJsFn__F0__sjs_js_Function0 = (function(f) {
  return $m_Ljapgolly_scalajs_react_callback_CallbackTo$().toJsFn$extension__Ljapgolly_scalajs_react_callback_Trampoline__sjs_js_Function0($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(f).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline)
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.handleError__F0__F1__O = (function(fa, f) {
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().handleError$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(fa).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, f))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.finallyRun__F0__F0__O = (function(fa, runFinally) {
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().finallyRun$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline($n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(fa).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline, $n($as_Ljapgolly_scalajs_react_callback_CallbackTo($n(runFinally).apply__O())).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.chain__O__O__O = (function(fa, fb) {
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var fb$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fb)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().$greater$greater$extension__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, fb$1))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($m_Ljapgolly_scalajs_react_callback_CallbackTo$().flatMap$extension__Ljapgolly_scalajs_react_callback_Trampoline__F1__Ljapgolly_scalajs_react_callback_Trampoline(fa$1, f))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $n($as_Ljapgolly_scalajs_react_callback_CallbackTo(fa)).Ljapgolly_scalajs_react_callback_CallbackTo__f_japgolly$scalajs$react$callback$CallbackTo$$trampoline;
  var this$2 = $n(fa$1);
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo($f_Ljapgolly_scalajs_react_callback_Trampoline__map__F1__Ljapgolly_scalajs_react_callback_Trampoline(this$2, f))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.pure__O__O = (function(a) {
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Pure(a)))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.delay__F0__O = (function(a) {
  return new $c_Ljapgolly_scalajs_react_callback_CallbackTo(($m_Ljapgolly_scalajs_react_callback_Trampoline$(), new $c_Ljapgolly_scalajs_react_callback_Trampoline$Delay(a)))
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.dispatch__O__V = (function(fa) {
  $f_Ljapgolly_scalajs_react_util_Effect$Sync$WithDefaultDispatch__dispatch__O__V(this, fa)
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.dispatchFn__F0__sjs_js_Function0 = (function(fa) {
  return $f_Ljapgolly_scalajs_react_util_Effect$Dispatch$WithDefaults__dispatchFn__F0__sjs_js_Function0(this, fa)
});
var $d_Ljapgolly_scalajs_react_util_EffectCallback$callback$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_util_EffectCallback$callback$: 0
}, false, "japgolly.scalajs.react.util.EffectCallback$callback$", {
  Ljapgolly_scalajs_react_util_EffectCallback$callback$: 1,
  O: 1,
  Ljapgolly_scalajs_react_util_Effect$Sync$WithDefaultDispatch: 1,
  Ljapgolly_scalajs_react_util_Effect$Sync: 1,
  Ljapgolly_scalajs_react_util_Effect$UnsafeSync: 1,
  Ljapgolly_scalajs_react_util_Effect$Dispatch: 1,
  Ljapgolly_scalajs_react_util_Effect: 1,
  Ljapgolly_scalajs_react_util_Monad: 1,
  Ljapgolly_scalajs_react_util_Effect$Dispatch$WithDefaults: 1,
  Ljapgolly_scalajs_react_util_Effect$WithDefaults: 1
});
$c_Ljapgolly_scalajs_react_util_EffectCallback$callback$.prototype.$classData = $d_Ljapgolly_scalajs_react_util_EffectCallback$callback$;
var $n_Ljapgolly_scalajs_react_util_EffectCallback$callback$;
function $m_Ljapgolly_scalajs_react_util_EffectCallback$callback$() {
  if ((!$n_Ljapgolly_scalajs_react_util_EffectCallback$callback$)) {
    $n_Ljapgolly_scalajs_react_util_EffectCallback$callback$ = new $c_Ljapgolly_scalajs_react_util_EffectCallback$callback$()
  };
  return $n_Ljapgolly_scalajs_react_util_EffectCallback$callback$
}
function $p_Ljapgolly_scalajs_react_vdom_PackageBase__vdomAttrVtDouble$lzycompute__F2($thiz) {
  if (((((4 & $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtDouble = $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr__vdomAttrVtDouble__F2($thiz);
    $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0 = (((4 | $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtDouble
}
function $p_Ljapgolly_scalajs_react_vdom_PackageBase__vdomAttrVtInnerHtml$lzycompute__F2($thiz) {
  if (((((32 & $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInnerHtml = $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1__vdomAttrVtInnerHtml__F2($thiz);
    $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0 = (((32 | $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInnerHtml
}
function $ct_Ljapgolly_scalajs_react_vdom_PackageBase__($thiz) {
  $ct_Ljapgolly_scalajs_react_vdom_Exports__($thiz);
  $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1__$init$__V($thiz);
  $f_Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr__$init$__V($thiz);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_PackageBase() {
  this.Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_TagMod = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomStyle = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtDouble = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInnerHtml = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0 = 0
}
$c_Ljapgolly_scalajs_react_vdom_PackageBase.prototype = new $h_Ljapgolly_scalajs_react_vdom_Exports();
$c_Ljapgolly_scalajs_react_vdom_PackageBase.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_PackageBase;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_PackageBase() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_PackageBase.prototype = $c_Ljapgolly_scalajs_react_vdom_PackageBase.prototype;
$c_Ljapgolly_scalajs_react_vdom_PackageBase.prototype.vdomAttrVtDouble__F2 = (function() {
  return (((((4 & this.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljapgolly_scalajs_react_vdom_PackageBase__vdomAttrVtDouble$lzycompute__F2(this) : this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtDouble)
});
$c_Ljapgolly_scalajs_react_vdom_PackageBase.prototype.vdomAttrVtInnerHtml__F2 = (function() {
  return (((((32 & this.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljapgolly_scalajs_react_vdom_PackageBase__vdomAttrVtInnerHtml$lzycompute__F2(this) : this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInnerHtml)
});
function $ct_ju_ArrayList__O__($thiz, inner) {
  $thiz.ju_ArrayList__f_java$util$ArrayList$$inner = inner;
  return $thiz
}
function $ct_ju_ArrayList__I__($thiz, initialCapacity) {
  $ct_ju_ArrayList__O__($thiz, []);
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  };
  return $thiz
}
function $ct_ju_ArrayList__($thiz) {
  $ct_ju_ArrayList__O__($thiz, []);
  return $thiz
}
function $ct_ju_ArrayList__ju_Collection__($thiz, c) {
  $ct_ju_ArrayList__($thiz);
  $thiz.addAll__ju_Collection__Z(c);
  return $thiz
}
/** @constructor */
function $c_ju_ArrayList() {
  this.ju_ArrayList__f_java$util$ArrayList$$inner = null
}
$c_ju_ArrayList.prototype = new $h_ju_AbstractList();
$c_ju_ArrayList.prototype.constructor = $c_ju_ArrayList;
/** @constructor */
function $h_ju_ArrayList() {
  /*<skip>*/
}
$h_ju_ArrayList.prototype = $c_ju_ArrayList.prototype;
$c_ju_ArrayList.prototype.size__I = (function() {
  return $uI(this.ju_ArrayList__f_java$util$ArrayList$$inner.length)
});
$c_ju_ArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  return this.ju_ArrayList__f_java$util$ArrayList$$inner[index]
});
$c_ju_ArrayList.prototype.set__I__O__O = (function(index, element) {
  var e = this.get__I__O(index);
  this.ju_ArrayList__f_java$util$ArrayList$$inner[index] = element;
  return e
});
$c_ju_ArrayList.prototype.add__O__Z = (function(e) {
  this.ju_ArrayList__f_java$util$ArrayList$$inner.push(e);
  return true
});
$c_ju_ArrayList.prototype.add__I__O__V = (function(index, element) {
  this.checkIndexOnBounds__I__V(index);
  this.ju_ArrayList__f_java$util$ArrayList$$inner.splice(index, 0, element)
});
$c_ju_ArrayList.prototype.remove__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  var array = this.ju_ArrayList__f_java$util$ArrayList$$inner;
  return array.splice(index, 1)[0]
});
var $d_ju_ArrayList = new $TypeData().initClass({
  ju_ArrayList: 0
}, false, "java.util.ArrayList", {
  ju_ArrayList: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_ArrayList.prototype.$classData = $d_ju_ArrayList;
function $ct_ju_Collections$UnmodifiableList__ju_List__($thiz, inner) {
  $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner);
  return $thiz
}
/** @constructor */
function $c_ju_Collections$UnmodifiableList() {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false
}
$c_ju_Collections$UnmodifiableList.prototype = new $h_ju_Collections$UnmodifiableCollection();
$c_ju_Collections$UnmodifiableList.prototype.constructor = $c_ju_Collections$UnmodifiableList;
/** @constructor */
function $h_ju_Collections$UnmodifiableList() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableList.prototype = $c_ju_Collections$UnmodifiableList.prototype;
$c_ju_Collections$UnmodifiableList.prototype.get__I__O = (function(index) {
  return $n($as_ju_List(this.ju_Collections$UnmodifiableCollection__f_inner)).get__I__O(index)
});
$c_ju_Collections$UnmodifiableList.prototype.equals__O__Z = (function(obj) {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).equals__O__Z(obj)
});
$c_ju_Collections$UnmodifiableList.prototype.hashCode__I = (function() {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).hashCode__I()
});
$c_ju_Collections$UnmodifiableList.prototype.set__I__O__O = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_Collections$UnmodifiableList.prototype.remove__I__O = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
});
$c_ju_Collections$UnmodifiableList.prototype.listIterator__ju_ListIterator = (function() {
  return new $c_ju_Collections$UnmodifiableListIterator($n($as_ju_List(this.ju_Collections$UnmodifiableCollection__f_inner)).listIterator__ju_ListIterator())
});
/** @constructor */
function $c_ju_Collections$UnmodifiableSet(inner) {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false;
  $ct_ju_Collections$UnmodifiableCollection__ju_Collection__(this, inner)
}
$c_ju_Collections$UnmodifiableSet.prototype = new $h_ju_Collections$UnmodifiableCollection();
$c_ju_Collections$UnmodifiableSet.prototype.constructor = $c_ju_Collections$UnmodifiableSet;
/** @constructor */
function $h_ju_Collections$UnmodifiableSet() {
  /*<skip>*/
}
$h_ju_Collections$UnmodifiableSet.prototype = $c_ju_Collections$UnmodifiableSet.prototype;
$c_ju_Collections$UnmodifiableSet.prototype.equals__O__Z = (function(obj) {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).equals__O__Z(obj)
});
$c_ju_Collections$UnmodifiableSet.prototype.hashCode__I = (function() {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).hashCode__I()
});
var $d_ju_Collections$UnmodifiableSet = new $TypeData().initClass({
  ju_Collections$UnmodifiableSet: 0
}, false, "java.util.Collections$UnmodifiableSet", {
  ju_Collections$UnmodifiableSet: 1,
  ju_Collections$UnmodifiableCollection: 1,
  O: 1,
  ju_Collections$WrappedCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  Ljava_io_Serializable: 1,
  ju_Collections$WrappedSet: 1,
  ju_Collections$WrappedEquals: 1,
  ju_Set: 1
});
$c_ju_Collections$UnmodifiableSet.prototype.$classData = $d_ju_Collections$UnmodifiableSet;
var $d_Lorg_scalajs_dom_HTMLElement = new $TypeData().initClass({
  Lorg_scalajs_dom_HTMLElement: 0
}, false, "org.scalajs.dom.HTMLElement", {
  Lorg_scalajs_dom_HTMLElement: 1,
  Lorg_scalajs_dom_Element: 1,
  Lorg_scalajs_dom_Node: 1,
  Lorg_scalajs_dom_EventTarget: 1,
  sjs_js_Object: 1,
  O: 1,
  sjs_js_Any: 1,
  Lorg_scalajs_dom_NodeSelector: 1,
  Lorg_scalajs_dom_ParentNode: 1,
  Lorg_scalajs_dom_NonDocumentTypeChildNode: 1
}, true, (void 0), ((x) => (x instanceof HTMLElement)));
/** @constructor */
function $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1(outer) {
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDeliveryDate = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDeliveryFormReference = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForInvoiceReference = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForProductReference = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDeliveryDate = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDeliveryFormReference = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForInvoiceReference = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForProductReference = null;
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDeliveryDate = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDeliveryFormReference = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForInvoiceReference = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForProductReference = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$12__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDeliveryDate = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$11__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDeliveryFormReference = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$10__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForInvoiceReference = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForProductReference = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O())
}
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1.prototype = $c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForDeliveryDate = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForDeliveryDate instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForDeliveryDate);
    var circeGenericInlBindingForDeliveryDate = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDeliveryDate;
    var name = $as_T($n(transformConstructorNames).apply__O__O("DeliveryDate"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForDeliveryDate, name, discriminator)
  } else if ((circeGenericInrBindingForDeliveryDate instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForDeliveryDate);
    var circeGenericInrBindingForDeliveryFormReference = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForDeliveryFormReference instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForDeliveryFormReference);
      var circeGenericInlBindingForDeliveryFormReference = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDeliveryFormReference;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("DeliveryFormReference"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForDeliveryFormReference, name$1, discriminator)
    } else if ((circeGenericInrBindingForDeliveryFormReference instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForDeliveryFormReference);
      var circeGenericInrBindingForInvoiceReference = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForInvoiceReference instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForInvoiceReference);
        var circeGenericInlBindingForInvoiceReference = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForInvoiceReference;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("InvoiceReference"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForInvoiceReference, name$2, discriminator)
      } else if ((circeGenericInrBindingForInvoiceReference instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForInvoiceReference);
        var circeGenericInrBindingForProductReference = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForProductReference instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForProductReference);
          var circeGenericInlBindingForProductReference = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForProductReference;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("ProductReference"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForProductReference, name$3, discriminator)
        } else if ((circeGenericInrBindingForProductReference instanceof $c_Lshapeless_Inr)) {
          $m_s_sys_package$().error__T__E("Cannot encode CNil")
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForProductReference)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForInvoiceReference)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForDeliveryFormReference)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForDeliveryDate)
  }
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDeliveryDate, c, $as_T($n(transformConstructorNames).apply__O__O("DeliveryDate")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryDate$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDeliveryFormReference, c, $as_T($n(transformConstructorNames).apply__O__O("DeliveryFormReference")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$DeliveryFormReference$($n(x2$4).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForInvoiceReference, c, $as_T($n(transformConstructorNames).apply__O__O("InvoiceReference")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$InvoiceReference$($n(x2$6).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForProductReference, c, $as_T($n(transformConstructorNames).apply__O__O("ProductReference")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_analyze_cost_ReconciliationReportOrder$ProductReference$($n(x2$8).s_util_Right__f_value);
              var x1$10 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$10 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            $m_Lio_circe_DecodingFailure$();
            var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
            var x1$9 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
            var err$5 = $as_Lio_circe_DecodingFailure(x1$9.s_util_Left__f_value);
            var x1$10 = new $c_s_util_Left(err$5)
          };
          if ((x1$10 instanceof $c_s_util_Right)) {
            var x2$10 = $as_s_util_Right(x1$10);
            var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$10).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
          } else {
            if ((!(x1$10 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$10)
            };
            var x3$6 = $as_s_util_Left(x1$10);
            var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$6)
          }
        };
        if ((x1$11 instanceof $c_s_util_Right)) {
          var x2$11 = $as_s_util_Right(x1$11);
          var v$7 = $as_Lshapeless_$colon$plus$colon($n(x2$11).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$7))
        } else {
          if ((!(x1$11 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$11)
          };
          var x3$7 = $as_s_util_Left(x1$11);
          var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$7)
        }
      };
      if ((x1$12 instanceof $c_s_util_Right)) {
        var x2$12 = $as_s_util_Right(x1$12);
        var v$8 = $as_Lshapeless_$colon$plus$colon($n(x2$12).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$8))
      } else if ((x1$12 instanceof $c_s_util_Left)) {
        var x3$8 = $as_s_util_Left(x1$12);
        var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
        return new $c_s_util_Left(err$8)
      } else {
        throw new $c_s_MatchError(x1$12)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1: 0
}, false, "reactbuild.analyze.cost.ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1", {
  Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_ReconciliationReportOrder$anon$lazy$macro$13$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1(outer) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForlatitude = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForlongitude = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForaccuracy = $uD($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForaltitude = $uD($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForaltitudeAccuracy = $uD($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForheading = $uD($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForspeed = $uD($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingFortimestamp = $uD($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p9)) {
                    var $$x1 = $m_Lio_circe_JsonObject$();
                    var this$4 = $m_sci_Vector$();
                    var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("latitude"), $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp).apply__O__Lio_circe_Json(circeGenericHListBindingForlatitude)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("longitude"), $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp).apply__O__Lio_circe_Json(circeGenericHListBindingForlongitude)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("accuracy"), $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp).apply__O__Lio_circe_Json(circeGenericHListBindingForaccuracy)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("altitude"), $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp).apply__O__Lio_circe_Json(circeGenericHListBindingForaltitude)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("altitudeAccuracy"), $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp).apply__O__Lio_circe_Json(circeGenericHListBindingForaltitudeAccuracy)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("heading"), $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp).apply__O__Lio_circe_Json(circeGenericHListBindingForheading)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("speed"), $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp).apply__O__Lio_circe_Json(circeGenericHListBindingForspeed)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("timestamp"), $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericEncoderFortimestamp).apply__O__Lio_circe_Json(circeGenericHListBindingFortimestamp))];
                    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("latitude"))), this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp, "latitude", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("longitude"))), this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp, "longitude", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("accuracy"))), this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp, "accuracy", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("altitude"))), this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp, "altitude", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("altitudeAccuracy"))), this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp, "altitudeAccuracy", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("heading"))), this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp, "heading", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("speed"))), this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp, "speed", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("timestamp"))), this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1__f_circeGenericDecoderFortimestamp, "timestamp", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.GeolocationPosition$anon$lazy$macro$67$1$$anon$1", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_GeolocationPosition$anon$lazy$macro$67$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16(outer) {
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericDecoderForname = null;
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericDecoderForarea = null;
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericEncoderForname = null;
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericEncoderForarea = null;
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericDecoderForarea = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericEncoderForarea = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16.prototype.constructor = $c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16;
/** @constructor */
function $h_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16.prototype = $c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16.prototype;
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForname = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForarea = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("area"), $n(this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericEncoderForarea).apply__O__Lio_circe_Json(circeGenericHListBindingForarea))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("area"))), this.Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16__f_circeGenericDecoderForarea, "area", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16 = new $TypeData().initClass({
  Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16: 0
}, false, "reactbuild.common.model.Area$anon$lazy$macro$19$4$$anon$16", {
  Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16.prototype.$classData = $d_Lreactbuild_common_model_Area$anon$lazy$macro$19$4$$anon$16;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34(outer) {
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderForcategory = null;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderFordetails = null;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderForcategory = null;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderFordetails = null;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderForcategory = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderFordetails = $m_Lreactbuild_common_model_AssetDetails$().Lreactbuild_common_model_AssetDetails$__f_codecForAssetDetails;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderForcategory = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderFordetails = $m_Lreactbuild_common_model_AssetDetails$().Lreactbuild_common_model_AssetDetails$__f_codecForAssetDetails
}
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34.prototype.constructor = $c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34.prototype = $c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34.prototype;
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForname = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForcategory = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFordetails = $as_Lreactbuild_common_model_AssetDetails($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x5 = $m_Lio_circe_JsonObject$();
            var this$5 = $m_sci_Vector$();
            var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
            var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderForcategory).apply__O__Lio_circe_Json(circeGenericHListBindingForname));
            var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("category"), $n(this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderForcategory).apply__O__Lio_circe_Json(circeGenericHListBindingForcategory));
            var $$x1 = $n(transformMemberNames).apply__O__O("details");
            var this$1 = $n(this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericEncoderFordetails);
            var array = [$$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordetails))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x5).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderForcategory, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("category"))), this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderForcategory, "category", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("details"))), this.Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34__f_circeGenericDecoderFordetails, "details", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34: 0
}, false, "reactbuild.common.model.AssetDefinition$anon$lazy$macro$35$6$$anon$34", {
  Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34.prototype.$classData = $d_Lreactbuild_common_model_AssetDefinition$anon$lazy$macro$35$6$$anon$34;
/** @constructor */
function $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27(outer) {
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericDecoderForComponentDetails = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericDecoderForMaterialDetails = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericDecoderForTextureDetails = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericEncoderForComponentDetails = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericEncoderForMaterialDetails = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericEncoderForTextureDetails = null;
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_$outer).inst$macro$55__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericDecoderForComponentDetails = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_$outer).inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericDecoderForMaterialDetails = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericDecoderForTextureDetails = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_$outer).inst$macro$133__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericEncoderForComponentDetails = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_$outer).inst$macro$91__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericEncoderForMaterialDetails = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_$outer).inst$macro$81__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericEncoderForTextureDetails = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O())
}
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27.prototype.constructor = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27;
/** @constructor */
function $h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27.prototype = $c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27.prototype;
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForComponentDetails = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForComponentDetails instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForComponentDetails);
    var circeGenericInlBindingForComponentDetails = $as_Lreactbuild_common_model_ComponentDetails($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericEncoderForComponentDetails;
    var name = $as_T($n(transformConstructorNames).apply__O__O("ComponentDetails"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForComponentDetails, name, discriminator)
  } else if ((circeGenericInrBindingForComponentDetails instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForComponentDetails);
    var circeGenericInrBindingForMaterialDetails = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForMaterialDetails instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForMaterialDetails);
      var circeGenericInlBindingForMaterialDetails = $as_Lreactbuild_common_model_MaterialDetails($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericEncoderForMaterialDetails;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("MaterialDetails"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForMaterialDetails, name$1, discriminator)
    } else if ((circeGenericInrBindingForMaterialDetails instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForMaterialDetails);
      var circeGenericInrBindingForTextureDetails = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForTextureDetails instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForTextureDetails);
        var circeGenericInlBindingForTextureDetails = $as_Lreactbuild_common_model_TextureDetails($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericEncoderForTextureDetails;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("TextureDetails"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForTextureDetails, name$2, discriminator)
      } else if ((circeGenericInrBindingForTextureDetails instanceof $c_Lshapeless_Inr)) {
        $m_s_sys_package$().error__T__E("Cannot encode CNil")
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForTextureDetails)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForMaterialDetails)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForComponentDetails)
  }
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericDecoderForComponentDetails, c, $as_T($n(transformConstructorNames).apply__O__O("ComponentDetails")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_common_model_ComponentDetails($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericDecoderForMaterialDetails, c, $as_T($n(transformConstructorNames).apply__O__O("MaterialDetails")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_common_model_MaterialDetails($n(x2$4).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27__f_circeGenericDecoderForTextureDetails, c, $as_T($n(transformConstructorNames).apply__O__O("TextureDetails")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_common_model_TextureDetails($n(x2$6).s_util_Right__f_value);
            var x1$8 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$8 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          $m_Lio_circe_DecodingFailure$();
          var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
          var x1$7 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
          var err$4 = $as_Lio_circe_DecodingFailure(x1$7.s_util_Left__f_value);
          var x1$8 = new $c_s_util_Left(err$4)
        };
        if ((x1$8 instanceof $c_s_util_Right)) {
          var x2$8 = $as_s_util_Right(x1$8);
          var v$5 = $as_Lshapeless_$colon$plus$colon($n(x2$8).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$5))
        } else {
          if ((!(x1$8 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$8)
          };
          var x3$5 = $as_s_util_Left(x1$8);
          var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$5)
        }
      };
      if ((x1$9 instanceof $c_s_util_Right)) {
        var x2$9 = $as_s_util_Right(x1$9);
        var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$9).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
      } else if ((x1$9 instanceof $c_s_util_Left)) {
        var x3$6 = $as_s_util_Left(x1$9);
        var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
        return new $c_s_util_Left(err$6)
      } else {
        throw new $c_s_MatchError(x1$9)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27 = new $TypeData().initClass({
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27: 0
}, false, "reactbuild.common.model.AssetDetails$anon$lazy$macro$159$1$$anon$27", {
  Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27.prototype.$classData = $d_Lreactbuild_common_model_AssetDetails$anon$lazy$macro$159$1$$anon$27;
/** @constructor */
function $c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37(outer) {
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericDecoderForcountry = null;
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericDecoderForcode = null;
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericEncoderForcountry = null;
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericEncoderForcode = null;
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericDecoderForcountry = $m_Lreactbuild_common_model_Country$().Lreactbuild_common_model_Country$__f_codecForCountry;
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericDecoderForcode = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericEncoderForcountry = $m_Lreactbuild_common_model_Country$().Lreactbuild_common_model_Country$__f_codecForCountry;
  this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericEncoderForcode = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37.prototype.constructor = $c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37;
/** @constructor */
function $h_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37.prototype = $c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37.prototype;
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForcountry = $as_Lreactbuild_common_model_Country($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForcode = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x2 = $m_Lio_circe_JsonObject$();
        var this$5 = $m_sci_Vector$();
        var $$x1 = $n(transformMemberNames).apply__O__O("country");
        var this$1 = $n(this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericEncoderForcountry);
        var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForcountry)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("code"), $n(this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericEncoderForcode).apply__O__Lio_circe_Json(circeGenericHListBindingForcode))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("country"))), this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericDecoderForcountry, "country", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("code"))), this.Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37__f_circeGenericDecoderForcode, "code", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37 = new $TypeData().initClass({
  Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37: 0
}, false, "reactbuild.common.model.CityCode$anon$lazy$macro$19$6$$anon$37", {
  Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37.prototype.$classData = $d_Lreactbuild_common_model_CityCode$anon$lazy$macro$19$6$$anon$37;
/** @constructor */
function $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35(outer) {
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_circeGenericDecoderForFrance = null;
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_circeGenericEncoderForFrance = null;
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_circeGenericDecoderForFrance = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_$outer).inst$macro$5__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_circeGenericEncoderForFrance = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O())
}
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35.prototype.constructor = $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35;
/** @constructor */
function $h_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35.prototype = $c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35.prototype;
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForFrance = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForFrance instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForFrance);
    var circeGenericInlBindingForFrance = $as_Lreactbuild_common_model_Country$France$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_circeGenericEncoderForFrance;
    var name = $as_T($n(transformConstructorNames).apply__O__O("France"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForFrance, name, discriminator)
  } else if ((circeGenericInrBindingForFrance instanceof $c_Lshapeless_Inr)) {
    $m_s_sys_package$().error__T__E("Cannot encode CNil")
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForFrance)
  }
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35__f_circeGenericDecoderForFrance, c, $as_T($n(transformConstructorNames).apply__O__O("France")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_common_model_Country$France$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
      var x1$3 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
      var err$2 = $as_Lio_circe_DecodingFailure(x1$3.s_util_Left__f_value);
      return new $c_s_util_Left(err$2)
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35 = new $TypeData().initClass({
  Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35: 0
}, false, "reactbuild.common.model.Country$anon$lazy$macro$7$2$$anon$35", {
  Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35.prototype.$classData = $d_Lreactbuild_common_model_Country$anon$lazy$macro$7$2$$anon$35;
/** @constructor */
function $c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5(outer) {
  this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5__f_circeGenericDecoderForvalue = null;
  this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5__f_circeGenericEncoderForvalue = null;
  this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5__f_circeGenericDecoderForvalue = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong;
  this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5__f_circeGenericEncoderForvalue = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeLong
}
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5.prototype.constructor = $c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5;
/** @constructor */
function $h_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5.prototype = $c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5.prototype;
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var t = $uJ($n(a).Lshapeless_$colon$colon__f_head);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("value"), $n(this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5__f_circeGenericEncoderForvalue).apply__O__Lio_circe_Json(new $c_RTLong(lo, hi)))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("value"))), this.Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5__f_circeGenericDecoderForvalue, "value", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5 = new $TypeData().initClass({
  Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5: 0
}, false, "reactbuild.common.model.Date$anon$lazy$macro$11$1$$anon$5", {
  Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5.prototype.$classData = $d_Lreactbuild_common_model_Date$anon$lazy$macro$11$1$$anon$5;
/** @constructor */
function $c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20(outer) {
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForname = null;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForurl = null;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForhead = null;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForname = null;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForurl = null;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForhead = null;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForurl = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lcom_iz2use_common_Multiline$().decodeMultiline__Lio_circe_Decoder();
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForhead = new $c_Lio_circe_Decoder$$anon$39(d$1);
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForurl = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lcom_iz2use_common_Multiline$().encodeMultiline__Lio_circe_Encoder();
  this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForhead = new $c_Lio_circe_Encoder$$anon$21(e$1)
}
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20.prototype.constructor = $c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20;
/** @constructor */
function $h_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20.prototype = $c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20.prototype;
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForname = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForhome = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForcontact = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForusername = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForpassword = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForurl = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForhead = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p8)) {
                  var $$x1 = $m_Lio_circe_JsonObject$();
                  var this$4 = $m_sci_Vector$();
                  var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("home"), $n(this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForhead).apply__O__Lio_circe_Json(circeGenericHListBindingForhome)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("contact"), $n(this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForhead).apply__O__Lio_circe_Json(circeGenericHListBindingForcontact)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("username"), $n(this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForurl).apply__O__Lio_circe_Json(circeGenericHListBindingForusername)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("password"), $n(this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForurl).apply__O__Lio_circe_Json(circeGenericHListBindingForpassword)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("url"), $n(this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForurl).apply__O__Lio_circe_Json(circeGenericHListBindingForurl)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("head"), $n(this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericEncoderForhead).apply__O__Lio_circe_Json(circeGenericHListBindingForhead))];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                  return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("home"))), this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForhead, "home", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("contact"))), this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForhead, "contact", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("username"))), this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForurl, "username", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("password"))), this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForurl, "password", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("url"))), this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForurl, "url", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("head"))), this.Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20__f_circeGenericDecoderForhead, "head", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20 = new $TypeData().initClass({
  Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20: 0
}, false, "reactbuild.common.model.DeployableWebsite$anon$lazy$macro$59$1$$anon$20", {
  Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20.prototype.$classData = $d_Lreactbuild_common_model_DeployableWebsite$anon$lazy$macro$59$1$$anon$20;
/** @constructor */
function $c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2(outer) {
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForcreated = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForto = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForlabel = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForattributes = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForcreated = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForto = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForlabel = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForattributes = null;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForcreated = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForto = $m_Lreactbuild_common_model_TypedRefTo$().Lreactbuild_common_model_TypedRefTo$__f_codecForTypedRefTo;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForlabel = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForattributes = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeJsonObject;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForcreated = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForto = $m_Lreactbuild_common_model_TypedRefTo$().Lreactbuild_common_model_TypedRefTo$__f_codecForTypedRefTo;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForlabel = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForattributes = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeJsonObject
}
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2.prototype.constructor = $c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2.prototype = $c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2.prototype;
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForcreated = $as_Ljava_time_Instant($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForfrom = $as_Lreactbuild_common_model_TypedRefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForto = $as_Lreactbuild_common_model_TypedRefTo($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForlabel = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForattributes = $as_Lio_circe_JsonObject($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p7)) {
                var $$x9 = $m_Lio_circe_JsonObject$();
                var this$7 = $m_sci_Vector$();
                var $$x8 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("created"), $n(this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForcreated).apply__O__Lio_circe_Json(circeGenericHListBindingForcreated));
                var $$x6 = $n(transformMemberNames).apply__O__O("from");
                var this$1 = $n(this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForto);
                var $$x5 = $ct_T2__O__O__(new $c_T2(), $$x6, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForfrom));
                var $$x4 = $n(transformMemberNames).apply__O__O("to");
                var this$2 = $n(this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForto);
                var $$x3 = $ct_T2__O__O__(new $c_T2(), $$x4, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForto));
                var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("label"), $n(this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForlabel).apply__O__Lio_circe_Json(circeGenericHListBindingForlabel));
                var $$x1 = $n(transformMemberNames).apply__O__O("attributes");
                var this$3 = $n(this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericEncoderForattributes);
                var array = [$$x8, $$x7, $$x5, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForattributes))];
                var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                return $n($$x9).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$7.from__sc_IterableOnce__sci_Vector(elems))
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("created"))), this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForcreated, "created", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("from"))), this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForto, "from", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("to"))), this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForto, "to", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("label"))), this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForlabel, "label", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("attributes"))), this.Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2__f_circeGenericDecoderForattributes, "attributes", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2: 0
}, false, "reactbuild.common.model.Edge$anon$lazy$macro$51$1$$anon$2", {
  Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2.prototype.$classData = $d_Lreactbuild_common_model_Edge$anon$lazy$macro$51$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26(outer) {
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderForname = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderForcontentType = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderForsavedAt = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderForname = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderForcontentType = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderForsavedAt = null;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderFororganization = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderForcontentType = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderForsavedAt = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderFororganization = new $c_Lio_circe_Encoder$$anon$23(encodeA);
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderForcontentType = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderForsavedAt = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder()
}
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26.prototype.constructor = $c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26;
/** @constructor */
function $h_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26.prototype = $c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26.prototype;
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForcontentType = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForsavedAt = $as_Ljava_time_Instant($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x3 = $m_Lio_circe_JsonObject$();
              var this$5 = $m_sci_Vector$();
              var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
              var $$x1 = $n(transformMemberNames).apply__O__O("organization");
              var this$1 = $n(this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderFororganization);
              var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("contentType"), $n(this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderForcontentType).apply__O__Lio_circe_Json(circeGenericHListBindingForcontentType)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("savedAt"), $n(this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericEncoderForsavedAt).apply__O__Lio_circe_Json(circeGenericHListBindingForsavedAt))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("contentType"))), this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderForcontentType, "contentType", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("savedAt"))), this.Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26__f_circeGenericDecoderForsavedAt, "savedAt", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26 = new $TypeData().initClass({
  Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26: 0
}, false, "reactbuild.common.model.File$anon$lazy$macro$43$3$$anon$26", {
  Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26.prototype.$classData = $d_Lreactbuild_common_model_File$anon$lazy$macro$43$3$$anon$26;
/** @constructor */
function $c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15(outer) {
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderForheight = null;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderFortitle = null;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderFormarkers = null;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderForheight = null;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderFortitle = null;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderFormarkers = null;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderForheight = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderFortitle = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_Marker$().Lreactbuild_common_model_Marker$__f_codecForMarker;
  var d = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderFormarkers = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderForheight = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderFortitle = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_Marker$().Lreactbuild_common_model_Marker$__f_codecForMarker;
  var e = new $c_Lio_circe_Encoder$$anon$23(encodeA);
  this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderFormarkers = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15.prototype.constructor = $c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15;
/** @constructor */
function $h_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15.prototype = $c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15.prototype;
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForurl = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForwidth = $uI($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForheight = $uI($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFortitle = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFormarkers = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x1 = $m_Lio_circe_JsonObject$();
              var this$4 = $m_sci_Vector$();
              var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("url"), $n(this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingForurl)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("width"), $n(this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderForheight).apply__O__Lio_circe_Json(circeGenericHListBindingForwidth)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("height"), $n(this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderForheight).apply__O__Lio_circe_Json(circeGenericHListBindingForheight)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("markers"), $n(this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericEncoderFormarkers).apply__O__Lio_circe_Json(circeGenericHListBindingFormarkers))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("url"))), this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderFortitle, "url", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("width"))), this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderForheight, "width", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("height"))), this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderForheight, "height", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderFortitle, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("markers"))), this.Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15__f_circeGenericDecoderFormarkers, "markers", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15 = new $TypeData().initClass({
  Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15: 0
}, false, "reactbuild.common.model.Image$anon$lazy$macro$43$2$$anon$15", {
  Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15.prototype.$classData = $d_Lreactbuild_common_model_Image$anon$lazy$macro$43$2$$anon$15;
/** @constructor */
function $c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14(outer) {
  this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14__f_circeGenericDecoderFory = null;
  this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14__f_circeGenericEncoderFory = null;
  this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14__f_circeGenericDecoderFory = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14__f_circeGenericEncoderFory = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14.prototype.constructor = $c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14;
/** @constructor */
function $h_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14.prototype = $c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14.prototype;
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForx = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFory = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("x"), $n(this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14__f_circeGenericEncoderFory).apply__O__Lio_circe_Json(circeGenericHListBindingForx)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("y"), $n(this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14__f_circeGenericEncoderFory).apply__O__Lio_circe_Json(circeGenericHListBindingFory))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("x"))), this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14__f_circeGenericDecoderFory, "x", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("y"))), this.Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14__f_circeGenericDecoderFory, "y", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14 = new $TypeData().initClass({
  Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14: 0
}, false, "reactbuild.common.model.ImageCoordinates$anon$lazy$macro$19$3$$anon$14", {
  Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14.prototype.$classData = $d_Lreactbuild_common_model_ImageCoordinates$anon$lazy$macro$19$3$$anon$14;
/** @constructor */
function $c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17(outer) {
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericDecoderForlogged = null;
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericDecoderForprojects = null;
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericEncoderForlogged = null;
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericEncoderForprojects = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_LoggedUserWithOrganizations$().Lreactbuild_common_model_LoggedUserWithOrganizations$__f_codecForLoggedUserWithOrganizations;
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericDecoderForlogged = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_Project$().Lreactbuild_common_model_Project$__f_codecForProject;
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericDecoderForprojects = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_LoggedUserWithOrganizations$().Lreactbuild_common_model_LoggedUserWithOrganizations$__f_codecForLoggedUserWithOrganizations;
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericEncoderForlogged = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_Project$().Lreactbuild_common_model_Project$__f_codecForProject;
  this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericEncoderForprojects = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17.prototype.constructor = $c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17;
/** @constructor */
function $h_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17.prototype = $c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17.prototype;
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForlogged = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForprojects = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x3 = $m_Lio_circe_JsonObject$();
        var this$5 = $m_sci_Vector$();
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("logged"), $n(this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericEncoderForlogged).apply__O__Lio_circe_Json(circeGenericHListBindingForlogged));
        var $$x1 = $n(transformMemberNames).apply__O__O("projects");
        var this$1 = $n(this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericEncoderForprojects);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForprojects))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("logged"))), this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericDecoderForlogged, "logged", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("projects"))), this.Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17__f_circeGenericDecoderForprojects, "projects", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17 = new $TypeData().initClass({
  Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17: 0
}, false, "reactbuild.common.model.ListProjects$anon$lazy$macro$19$5$$anon$17", {
  Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17.prototype.$classData = $d_Lreactbuild_common_model_ListProjects$anon$lazy$macro$19$5$$anon$17;
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10(outer) {
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericDecoderForavatar = null;
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericEncoderForavatar = null;
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericDecoderForavatar = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericEncoderForavatar = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10.prototype.constructor = $c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10.prototype = $c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10.prototype;
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForemail = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForavatar = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("email"), $n(this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericEncoderForavatar).apply__O__Lio_circe_Json(circeGenericHListBindingForemail)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericEncoderForavatar).apply__O__Lio_circe_Json(circeGenericHListBindingForname)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("avatar"), $n(this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericEncoderForavatar).apply__O__Lio_circe_Json(circeGenericHListBindingForavatar))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("email"))), this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericDecoderForavatar, "email", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericDecoderForavatar, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("avatar"))), this.Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10__f_circeGenericDecoderForavatar, "avatar", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10 = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10: 0
}, false, "reactbuild.common.model.LoggedUser$anon$lazy$macro$35$4$$anon$10", {
  Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10.prototype.$classData = $d_Lreactbuild_common_model_LoggedUser$anon$lazy$macro$35$4$$anon$10;
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9(outer) {
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderForpath = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderForname = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderFororganizationUser = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderForpath = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderForname = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderFororganizationUser = null;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderForpath = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderForname = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderFororganizationUser = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderForpath = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderForname = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderFororganizationUser = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9.prototype.constructor = $c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9.prototype = $c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9.prototype;
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForpath = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFororganizationUser = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("path"), $n(this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderForpath).apply__O__Lio_circe_Json(circeGenericHListBindingForpath)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organizationUser"), $n(this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericEncoderFororganizationUser).apply__O__Lio_circe_Json(circeGenericHListBindingFororganizationUser))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("path"))), this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderForpath, "path", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organizationUser"))), this.Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9__f_circeGenericDecoderFororganizationUser, "organizationUser", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9 = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9: 0
}, false, "reactbuild.common.model.LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9", {
  Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9.prototype.$classData = $d_Lreactbuild_common_model_LoggedUserOrganization$anon$lazy$macro$35$3$$anon$9;
/** @constructor */
function $c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11(outer) {
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericDecoderForuser = null;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericDecoderFororganizations = null;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericEncoderForuser = null;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericEncoderFororganizations = null;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericDecoderForuser = $m_Lreactbuild_common_model_LoggedUser$().Lreactbuild_common_model_LoggedUser$__f_codecForLoggedUser;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_LoggedUserOrganization$().Lreactbuild_common_model_LoggedUserOrganization$__f_codecForLoggedUserOrganization;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericDecoderFororganizations = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericEncoderForuser = $m_Lreactbuild_common_model_LoggedUser$().Lreactbuild_common_model_LoggedUser$__f_codecForLoggedUser;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_LoggedUserOrganization$().Lreactbuild_common_model_LoggedUserOrganization$__f_codecForLoggedUserOrganization;
  this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericEncoderFororganizations = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11.prototype.constructor = $c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11;
/** @constructor */
function $h_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11.prototype = $c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11.prototype;
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForuser = $as_Lreactbuild_common_model_LoggedUser($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganizations = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x4 = $m_Lio_circe_JsonObject$();
        var this$6 = $m_sci_Vector$();
        var $$x3 = $n(transformMemberNames).apply__O__O("user");
        var this$1 = $n(this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericEncoderForuser);
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForuser));
        var $$x1 = $n(transformMemberNames).apply__O__O("organizations");
        var this$2 = $n(this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericEncoderFororganizations);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFororganizations))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x4).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("user"))), this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericDecoderForuser, "user", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organizations"))), this.Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11__f_circeGenericDecoderFororganizations, "organizations", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11 = new $TypeData().initClass({
  Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11: 0
}, false, "reactbuild.common.model.LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11", {
  Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11.prototype.$classData = $d_Lreactbuild_common_model_LoggedUserWithOrganizations$anon$lazy$macro$19$2$$anon$11;
/** @constructor */
function $c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13(outer) {
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericDecoderForlabel = null;
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericDecoderFory = null;
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericEncoderForlabel = null;
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericEncoderFory = null;
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericDecoderForlabel = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericDecoderFory = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericEncoderForlabel = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericEncoderFory = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13.prototype.constructor = $c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13;
/** @constructor */
function $h_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13.prototype = $c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13.prototype;
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForlabel = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForx = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFory = $uD($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("label"), $n(this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericEncoderForlabel).apply__O__Lio_circe_Json(circeGenericHListBindingForlabel)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("x"), $n(this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericEncoderFory).apply__O__Lio_circe_Json(circeGenericHListBindingForx)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("y"), $n(this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericEncoderFory).apply__O__Lio_circe_Json(circeGenericHListBindingFory))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("label"))), this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericDecoderForlabel, "label", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("x"))), this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericDecoderFory, "x", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("y"))), this.Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13__f_circeGenericDecoderFory, "y", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13 = new $TypeData().initClass({
  Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13: 0
}, false, "reactbuild.common.model.Marker$anon$lazy$macro$27$1$$anon$13", {
  Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13.prototype.$classData = $d_Lreactbuild_common_model_Marker$anon$lazy$macro$27$1$$anon$13;
/** @constructor */
function $c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8(outer) {
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderForpath = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderForname = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderForsettings = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderForpath = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderForname = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderForsettings = null;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderForpath = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderForname = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderForsettings = $m_Lreactbuild_common_model_OrganizationSettings$().Lreactbuild_common_model_OrganizationSettings$__f_codecForOrganizationSettings;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderForpath = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderForname = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderForsettings = $m_Lreactbuild_common_model_OrganizationSettings$().Lreactbuild_common_model_OrganizationSettings$__f_codecForOrganizationSettings
}
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8.prototype.constructor = $c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8;
/** @constructor */
function $h_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8.prototype = $c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8.prototype;
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForpath = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForsettings = $as_Lreactbuild_common_model_OrganizationSettings($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x5 = $m_Lio_circe_JsonObject$();
            var this$5 = $m_sci_Vector$();
            var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
            var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("path"), $n(this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderForpath).apply__O__Lio_circe_Json(circeGenericHListBindingForpath));
            var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname));
            var $$x1 = $n(transformMemberNames).apply__O__O("settings");
            var this$1 = $n(this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericEncoderForsettings);
            var array = [$$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForsettings))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x5).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("path"))), this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderForpath, "path", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("settings"))), this.Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8__f_circeGenericDecoderForsettings, "settings", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8 = new $TypeData().initClass({
  Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8: 0
}, false, "reactbuild.common.model.Organization$anon$lazy$macro$35$2$$anon$8", {
  Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8.prototype.$classData = $d_Lreactbuild_common_model_Organization$anon$lazy$macro$35$2$$anon$8;
/** @constructor */
function $c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7(outer) {
  this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7__f_circeGenericDecoderForusersNotifiedByIncomingCommunication = null;
  this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7__f_circeGenericEncoderForusersNotifiedByIncomingCommunication = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7__f_circeGenericDecoderForusersNotifiedByIncomingCommunication = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7__f_circeGenericEncoderForusersNotifiedByIncomingCommunication = new $c_Lio_circe_Encoder$$anon$23(encodeA)
}
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7.prototype.constructor = $c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7;
/** @constructor */
function $h_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7.prototype = $c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7.prototype;
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForusersNotifiedByIncomingCommunication = $as_sci_Seq($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("usersNotifiedByIncomingCommunication");
      var this$1 = $n(this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7__f_circeGenericEncoderForusersNotifiedByIncomingCommunication);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForusersNotifiedByIncomingCommunication))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("usersNotifiedByIncomingCommunication"))), this.Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7__f_circeGenericDecoderForusersNotifiedByIncomingCommunication, "usersNotifiedByIncomingCommunication", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7 = new $TypeData().initClass({
  Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7: 0
}, false, "reactbuild.common.model.OrganizationSettings$anon$lazy$macro$11$2$$anon$7", {
  Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7.prototype.$classData = $d_Lreactbuild_common_model_OrganizationSettings$anon$lazy$macro$11$2$$anon$7;
/** @constructor */
function $c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6(outer) {
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderForemail = null;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderForname = null;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderForemail = null;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderForname = null;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderForemail = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderForname = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderForemail = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderForname = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6.prototype.constructor = $c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6.prototype = $c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6.prototype;
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForemail = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForname = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderForemail).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("email"), $n(this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderForemail).apply__O__Lio_circe_Json(circeGenericHListBindingForemail)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderForemail, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("email"))), this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderForemail, "email", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6: 0
}, false, "reactbuild.common.model.OrganizationUser$anon$lazy$macro$35$1$$anon$6", {
  Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6.prototype.$classData = $d_Lreactbuild_common_model_OrganizationUser$anon$lazy$macro$35$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25(outer) {
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFororganizations = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForimages = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForlocation = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForareas = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForprice = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForsoldOut = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForscenes = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForrenderSettings = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFortopic = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForsummary = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForarchived = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForparent = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForaddress = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForreference = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFororganizations = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForimages = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForlocation = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForareas = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForprice = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForsoldOut = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForscenes = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForrenderSettings = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFortopic = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForsummary = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForarchived = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForparent = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForaddress = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForreference = null;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFororganizations = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  $m_Lio_circe_Decoder$();
  var decodeA$1 = $m_Lreactbuild_common_model_Image$().Lreactbuild_common_model_Image$__f_codecForImage;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForimages = new $c_Lio_circe_Decoder$$anon$42(decodeA$1);
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_Coordinates$().decodeCoordinates__Lio_circe_Decoder();
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForlocation = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  $m_Lio_circe_Decoder$();
  var decodeA$2 = $m_Lreactbuild_common_model_Area$().Lreactbuild_common_model_Area$__f_codecForArea;
  var d$1 = new $c_Lio_circe_Decoder$$anon$42(decodeA$2);
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForareas = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForprice = new $c_Lio_circe_Decoder$$anon$39(d$2);
  $m_Lio_circe_Decoder$();
  var d$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeBoolean;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForsoldOut = new $c_Lio_circe_Decoder$$anon$39(d$3);
  $m_Lio_circe_Decoder$();
  $m_Lio_circe_Decoder$();
  var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
  var decodeV = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var d$4 = new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeV);
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForscenes = new $c_Lio_circe_Decoder$$anon$39(d$4);
  $m_Lio_circe_Decoder$();
  var d$5 = $m_Lreactbuild_common_model_RenderSettings$().Lreactbuild_common_model_RenderSettings$__f_codecForRenderSettings;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForrenderSettings = new $c_Lio_circe_Decoder$$anon$39(d$5);
  $m_Lio_circe_Decoder$();
  var d$6 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFortopic = new $c_Lio_circe_Decoder$$anon$39(d$6);
  $m_Lio_circe_Decoder$();
  var d$7 = $m_Lcom_iz2use_common_Multiline$().decodeMultiline__Lio_circe_Decoder();
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForsummary = new $c_Lio_circe_Decoder$$anon$39(d$7);
  $m_Lio_circe_Decoder$();
  var d$8 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForarchived = new $c_Lio_circe_Decoder$$anon$39(d$8);
  $m_Lio_circe_Decoder$();
  var d$9 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForparent = new $c_Lio_circe_Decoder$$anon$39(d$9);
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForaddress = $m_Lreactbuild_common_model_ProjectAddress$().Lreactbuild_common_model_ProjectAddress$__f_decodeProjectAddress;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForreference = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFororganizations = new $c_Lio_circe_Encoder$$anon$23(encodeA);
  $m_Lio_circe_Encoder$();
  var encodeA$1 = $m_Lreactbuild_common_model_Image$().Lreactbuild_common_model_Image$__f_codecForImage;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForimages = new $c_Lio_circe_Encoder$$anon$23(encodeA$1);
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_Coordinates$().encodeCoordinates__Lio_circe_Encoder();
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForlocation = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  $m_Lio_circe_Encoder$();
  var encodeA$2 = $m_Lreactbuild_common_model_Area$().Lreactbuild_common_model_Area$__f_codecForArea;
  var e$1 = new $c_Lio_circe_Encoder$$anon$23(encodeA$2);
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForareas = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForprice = new $c_Lio_circe_Encoder$$anon$21(e$2);
  $m_Lio_circe_Encoder$();
  var e$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForsoldOut = new $c_Lio_circe_Encoder$$anon$21(e$3);
  $m_Lio_circe_Encoder$();
  var e$4 = $m_Lio_circe_Encoder$().encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString, $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString);
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForscenes = new $c_Lio_circe_Encoder$$anon$21(e$4);
  $m_Lio_circe_Encoder$();
  var e$5 = $m_Lreactbuild_common_model_RenderSettings$().Lreactbuild_common_model_RenderSettings$__f_codecForRenderSettings;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForrenderSettings = new $c_Lio_circe_Encoder$$anon$21(e$5);
  $m_Lio_circe_Encoder$();
  var e$6 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFortopic = new $c_Lio_circe_Encoder$$anon$21(e$6);
  $m_Lio_circe_Encoder$();
  var e$7 = $m_Lcom_iz2use_common_Multiline$().encodeMultiline__Lio_circe_Encoder();
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForsummary = new $c_Lio_circe_Encoder$$anon$21(e$7);
  $m_Lio_circe_Encoder$();
  var e$8 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForarchived = new $c_Lio_circe_Encoder$$anon$21(e$8);
  $m_Lio_circe_Encoder$();
  var e$9 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForparent = new $c_Lio_circe_Encoder$$anon$21(e$9);
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForaddress = $m_Lreactbuild_common_model_ProjectAddress$().Lreactbuild_common_model_ProjectAddress$__f_encodeProjectAddress;
  this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForreference = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25.prototype.constructor = $c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25;
/** @constructor */
function $h_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25.prototype = $c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25.prototype;
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganizations = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFortitle = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFordescription = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForimages = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForlocation = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForareas = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                  if ((p9 !== null)) {
                    var circeGenericHListBindingForprice = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                    var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                    if ((p10 !== null)) {
                      var circeGenericHListBindingForsoldOut = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                      var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                      if ((p11 !== null)) {
                        var circeGenericHListBindingForprivacy = $as_s_Option($n(p11).Lshapeless_$colon$colon__f_head);
                        var p12 = $as_Lshapeless_$colon$colon($n(p11).Lshapeless_$colon$colon__f_tail);
                        if ((p12 !== null)) {
                          var circeGenericHListBindingForscenes = $as_s_Option($n(p12).Lshapeless_$colon$colon__f_head);
                          var p13 = $as_Lshapeless_$colon$colon($n(p12).Lshapeless_$colon$colon__f_tail);
                          if ((p13 !== null)) {
                            var circeGenericHListBindingForrenderSettings = $as_s_Option($n(p13).Lshapeless_$colon$colon__f_head);
                            var p14 = $as_Lshapeless_$colon$colon($n(p13).Lshapeless_$colon$colon__f_tail);
                            if ((p14 !== null)) {
                              var circeGenericHListBindingForcity = $as_s_Option($n(p14).Lshapeless_$colon$colon__f_head);
                              var p15 = $as_Lshapeless_$colon$colon($n(p14).Lshapeless_$colon$colon__f_tail);
                              if ((p15 !== null)) {
                                var circeGenericHListBindingFordistrict = $as_s_Option($n(p15).Lshapeless_$colon$colon__f_head);
                                var p16 = $as_Lshapeless_$colon$colon($n(p15).Lshapeless_$colon$colon__f_tail);
                                if ((p16 !== null)) {
                                  var circeGenericHListBindingFortopic = $as_s_Option($n(p16).Lshapeless_$colon$colon__f_head);
                                  var p17 = $as_Lshapeless_$colon$colon($n(p16).Lshapeless_$colon$colon__f_tail);
                                  if ((p17 !== null)) {
                                    var circeGenericHListBindingFormodelSource = $as_s_Option($n(p17).Lshapeless_$colon$colon__f_head);
                                    var p18 = $as_Lshapeless_$colon$colon($n(p17).Lshapeless_$colon$colon__f_tail);
                                    if ((p18 !== null)) {
                                      var circeGenericHListBindingForprocedureState = $as_s_Option($n(p18).Lshapeless_$colon$colon__f_head);
                                      var p19 = $as_Lshapeless_$colon$colon($n(p18).Lshapeless_$colon$colon__f_tail);
                                      if ((p19 !== null)) {
                                        var circeGenericHListBindingForsummary = $as_s_Option($n(p19).Lshapeless_$colon$colon__f_head);
                                        var p20 = $as_Lshapeless_$colon$colon($n(p19).Lshapeless_$colon$colon__f_tail);
                                        if ((p20 !== null)) {
                                          var circeGenericHListBindingForarchived = $as_s_Option($n(p20).Lshapeless_$colon$colon__f_head);
                                          var p21 = $as_Lshapeless_$colon$colon($n(p20).Lshapeless_$colon$colon__f_tail);
                                          if ((p21 !== null)) {
                                            var circeGenericHListBindingForparent = $as_s_Option($n(p21).Lshapeless_$colon$colon__f_head);
                                            var p22 = $as_Lshapeless_$colon$colon($n(p21).Lshapeless_$colon$colon__f_tail);
                                            if ((p22 !== null)) {
                                              var circeGenericHListBindingForaddress = $as_Lreactbuild_common_model_ProjectAddress($n(p22).Lshapeless_$colon$colon__f_head);
                                              var p23 = $as_Lshapeless_$colon$colon($n(p22).Lshapeless_$colon$colon__f_tail);
                                              if ((p23 !== null)) {
                                                var circeGenericHListBindingForreference = $as_T($n(p23).Lshapeless_$colon$colon__f_head);
                                                var p24 = $as_Lshapeless_HNil($n(p23).Lshapeless_$colon$colon__f_tail);
                                                var x = $m_Lshapeless_HNil$();
                                                if ((x === p24)) {
                                                  var $$x25 = $m_Lio_circe_JsonObject$();
                                                  var this$7 = $m_sci_Vector$();
                                                  var $$x24 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                                                  var $$x23 = $n(transformMemberNames).apply__O__O("organizations");
                                                  var this$1 = $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFororganizations);
                                                  var $$x22 = $ct_T2__O__O__(new $c_T2(), $$x23, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFororganizations));
                                                  var $$x21 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForreference).apply__O__Lio_circe_Json(circeGenericHListBindingForname));
                                                  var $$x20 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForreference).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle));
                                                  var $$x19 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("description"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForsummary).apply__O__Lio_circe_Json(circeGenericHListBindingFordescription));
                                                  var $$x18 = $n(transformMemberNames).apply__O__O("images");
                                                  var this$2 = $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForimages);
                                                  var $$x17 = $ct_T2__O__O__(new $c_T2(), $$x18, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForimages));
                                                  var $$x16 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("location"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForlocation).apply__O__Lio_circe_Json(circeGenericHListBindingForlocation));
                                                  var $$x15 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("areas"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForareas).apply__O__Lio_circe_Json(circeGenericHListBindingForareas));
                                                  var $$x14 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("price"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForprice).apply__O__Lio_circe_Json(circeGenericHListBindingForprice));
                                                  var $$x13 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("soldOut"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForsoldOut).apply__O__Lio_circe_Json(circeGenericHListBindingForsoldOut));
                                                  var $$x12 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("privacy"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFortopic).apply__O__Lio_circe_Json(circeGenericHListBindingForprivacy));
                                                  var $$x11 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("scenes"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForscenes).apply__O__Lio_circe_Json(circeGenericHListBindingForscenes));
                                                  var $$x10 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("renderSettings"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForrenderSettings).apply__O__Lio_circe_Json(circeGenericHListBindingForrenderSettings));
                                                  var $$x9 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("city"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFortopic).apply__O__Lio_circe_Json(circeGenericHListBindingForcity));
                                                  var $$x8 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("district"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFortopic).apply__O__Lio_circe_Json(circeGenericHListBindingFordistrict));
                                                  var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("topic"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderFortopic).apply__O__Lio_circe_Json(circeGenericHListBindingFortopic));
                                                  var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("modelSource"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForsummary).apply__O__Lio_circe_Json(circeGenericHListBindingFormodelSource));
                                                  var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("procedureState"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForsummary).apply__O__Lio_circe_Json(circeGenericHListBindingForprocedureState));
                                                  var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("summary"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForsummary).apply__O__Lio_circe_Json(circeGenericHListBindingForsummary));
                                                  var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("archived"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForarchived).apply__O__Lio_circe_Json(circeGenericHListBindingForarchived));
                                                  var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("parent"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForparent).apply__O__Lio_circe_Json(circeGenericHListBindingForparent));
                                                  var $$x1 = $n(transformMemberNames).apply__O__O("address");
                                                  var this$3 = $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForaddress);
                                                  var array = [$$x24, $$x22, $$x21, $$x20, $$x19, $$x17, $$x16, $$x15, $$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForaddress)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericEncoderForreference).apply__O__Lio_circe_Json(circeGenericHListBindingForreference))];
                                                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                                                  return $n($$x25).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$7.from__sc_IterableOnce__sci_Vector(elems))
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organizations"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFororganizations, "organizations", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForreference, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForreference, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("description"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForsummary, "description", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("images"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForimages, "images", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("location"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForlocation, "location", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("areas"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForareas, "areas", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("price"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForprice, "price", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("soldOut"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForsoldOut, "soldOut", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("privacy"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFortopic, "privacy", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("scenes"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForscenes, "scenes", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("renderSettings"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForrenderSettings, "renderSettings", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("city"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFortopic, "city", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("district"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFortopic, "district", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("topic"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderFortopic, "topic", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("modelSource"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForsummary, "modelSource", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("procedureState"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForsummary, "procedureState", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("summary"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForsummary, "summary", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("archived"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForarchived, "archived", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("parent"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForparent, "parent", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("address"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForaddress, "address", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25__f_circeGenericDecoderForreference, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25 = new $TypeData().initClass({
  Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25: 0
}, false, "reactbuild.common.model.Project$anon$lazy$macro$99$1$$anon$25", {
  Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25.prototype.$classData = $d_Lreactbuild_common_model_Project$anon$lazy$macro$99$1$$anon$25;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12(outer) {
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForversion = null;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForassets = null;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForversion = null;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForassets = null;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForversion = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderFordate = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForassets = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForversion = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderFordate = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForassets = new $c_Lio_circe_Encoder$$anon$23(encodeA)
}
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12.prototype.constructor = $c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12.prototype = $c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12.prototype;
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFororganization = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForname = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForversion = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFordate = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForassets = $as_sci_Seq($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x6 = $m_Lio_circe_JsonObject$();
              var this$5 = $m_sci_Vector$();
              var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForversion).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization));
              var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForversion).apply__O__Lio_circe_Json(circeGenericHListBindingForname));
              var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("version"), $n(this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForversion).apply__O__Lio_circe_Json(circeGenericHListBindingForversion));
              var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate));
              var $$x1 = $n(transformMemberNames).apply__O__O("assets");
              var this$1 = $n(this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForassets);
              var array = [$$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForassets))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x6).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForversion, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForversion, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("version"))), this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForversion, "version", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("assets"))), this.Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForassets, "assets", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12: 0
}, false, "reactbuild.common.model.ProjectRelease$anon$lazy$macro$43$1$$anon$12", {
  Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12.prototype.$classData = $d_Lreactbuild_common_model_ProjectRelease$anon$lazy$macro$43$1$$anon$12;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21(outer) {
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForproject = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderFortitle = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderFordescription = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForprice = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForsoldOut = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForproject = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderFortitle = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderFordescription = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForprice = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForsoldOut = null;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForproject = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderFortitle = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lcom_iz2use_common_Multiline$().decodeMultiline__Lio_circe_Decoder();
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderFordescription = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForprice = new $c_Lio_circe_Decoder$$anon$39(d$2);
  $m_Lio_circe_Decoder$();
  var d$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeBoolean;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForsoldOut = new $c_Lio_circe_Decoder$$anon$39(d$3);
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForproject = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderFortitle = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lcom_iz2use_common_Multiline$().encodeMultiline__Lio_circe_Encoder();
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderFordescription = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForprice = new $c_Lio_circe_Encoder$$anon$21(e$2);
  $m_Lio_circe_Encoder$();
  var e$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
  this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForsoldOut = new $c_Lio_circe_Encoder$$anon$21(e$3)
}
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21.prototype.constructor = $c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21.prototype = $c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21.prototype;
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForproject = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFortitle = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFordescription = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForprice = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForpublish = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForsoldOut = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p8)) {
                  var $$x1 = $m_Lio_circe_JsonObject$();
                  var this$4 = $m_sci_Vector$();
                  var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("project"), $n(this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForproject).apply__O__Lio_circe_Json(circeGenericHListBindingForproject)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("description"), $n(this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderFordescription).apply__O__Lio_circe_Json(circeGenericHListBindingFordescription)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("price"), $n(this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForprice).apply__O__Lio_circe_Json(circeGenericHListBindingForprice)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("publish"), $n(this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForsoldOut).apply__O__Lio_circe_Json(circeGenericHListBindingForpublish)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("soldOut"), $n(this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericEncoderForsoldOut).apply__O__Lio_circe_Json(circeGenericHListBindingForsoldOut))];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                  return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("project"))), this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForproject, "project", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderFortitle, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("description"))), this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderFordescription, "description", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("price"))), this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForprice, "price", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("publish"))), this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForsoldOut, "publish", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("soldOut"))), this.Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21__f_circeGenericDecoderForsoldOut, "soldOut", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21: 0
}, false, "reactbuild.common.model.ProjectSpecific$anon$lazy$macro$59$2$$anon$21", {
  Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21.prototype.$classData = $d_Lreactbuild_common_model_ProjectSpecific$anon$lazy$macro$59$2$$anon$21;
/** @constructor */
function $c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22(outer) {
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericDecoderForwebsites = null;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericDecoderFororganizations = null;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericDecoderForprojectsSpecific = null;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericEncoderForwebsites = null;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericEncoderFororganizations = null;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericEncoderForprojectsSpecific = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_DeployableWebsite$().Lreactbuild_common_model_DeployableWebsite$__f_codecForDeployableWebsite;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericDecoderForwebsites = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  $m_Lio_circe_Decoder$();
  var decodeA$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericDecoderFororganizations = new $c_Lio_circe_Decoder$$anon$42(decodeA$1);
  $m_Lio_circe_Decoder$();
  var decodeA$2 = $m_Lreactbuild_common_model_ProjectSpecific$().Lreactbuild_common_model_ProjectSpecific$__f_codecForProjectSpecific;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericDecoderForprojectsSpecific = new $c_Lio_circe_Decoder$$anon$42(decodeA$2);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_DeployableWebsite$().Lreactbuild_common_model_DeployableWebsite$__f_codecForDeployableWebsite;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericEncoderForwebsites = new $c_Lio_circe_Encoder$$anon$23(encodeA);
  $m_Lio_circe_Encoder$();
  var encodeA$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericEncoderFororganizations = new $c_Lio_circe_Encoder$$anon$23(encodeA$1);
  $m_Lio_circe_Encoder$();
  var encodeA$2 = $m_Lreactbuild_common_model_ProjectSpecific$().Lreactbuild_common_model_ProjectSpecific$__f_codecForProjectSpecific;
  this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericEncoderForprojectsSpecific = new $c_Lio_circe_Encoder$$anon$23(encodeA$2)
}
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22.prototype.constructor = $c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22;
/** @constructor */
function $h_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22.prototype = $c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22.prototype;
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForwebsites = $as_sci_Seq($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganizations = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForprojectsSpecific = $as_sci_Seq($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x6 = $m_Lio_circe_JsonObject$();
          var this$7 = $m_sci_Vector$();
          var $$x5 = $n(transformMemberNames).apply__O__O("websites");
          var this$1 = $n(this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericEncoderForwebsites);
          var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForwebsites));
          var $$x3 = $n(transformMemberNames).apply__O__O("organizations");
          var this$2 = $n(this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericEncoderFororganizations);
          var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFororganizations));
          var $$x1 = $n(transformMemberNames).apply__O__O("projectsSpecific");
          var this$3 = $n(this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericEncoderForprojectsSpecific);
          var array = [$$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForprojectsSpecific))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x6).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$7.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("websites"))), this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericDecoderForwebsites, "websites", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organizations"))), this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericDecoderFororganizations, "organizations", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("projectsSpecific"))), this.Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22__f_circeGenericDecoderForprojectsSpecific, "projectsSpecific", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22 = new $TypeData().initClass({
  Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22: 0
}, false, "reactbuild.common.model.ProjectSpecifics$anon$lazy$macro$27$2$$anon$22", {
  Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22.prototype.$classData = $d_Lreactbuild_common_model_ProjectSpecifics$anon$lazy$macro$27$2$$anon$22;
/** @constructor */
function $c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19(outer) {
  this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19__f_circeGenericDecoderForsettings = null;
  this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19__f_circeGenericEncoderForsettings = null;
  $m_Lio_circe_Decoder$();
  var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
  var decodeV = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19__f_circeGenericDecoderForsettings = new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeV);
  this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19__f_circeGenericEncoderForsettings = $m_Lio_circe_Encoder$().encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString, $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString)
}
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19.prototype.constructor = $c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19;
/** @constructor */
function $h_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19.prototype = $c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19.prototype;
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForsettings = $as_sci_Map($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("settings");
      var this$1 = $n(this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19__f_circeGenericEncoderForsettings);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForsettings))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("settings"))), this.Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19__f_circeGenericDecoderForsettings, "settings", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19 = new $TypeData().initClass({
  Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19: 0
}, false, "reactbuild.common.model.RenderSettings$anon$lazy$macro$11$3$$anon$19", {
  Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19.prototype.$classData = $d_Lreactbuild_common_model_RenderSettings$anon$lazy$macro$11$3$$anon$19;
/** @constructor */
function $c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1(outer) {
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderFortpe = null;
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderForref = null;
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderFortpe = null;
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderForref = null;
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderFortpe = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderForref = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderFortpe = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderForref = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1.prototype.constructor = $c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1.prototype = $c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1.prototype;
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFortpe = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForref = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("tpe"), $n(this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderFortpe).apply__O__Lio_circe_Json(circeGenericHListBindingFortpe)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("ref"), $n(this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderForref).apply__O__Lio_circe_Json(circeGenericHListBindingForref))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("tpe"))), this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderFortpe, "tpe", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("ref"))), this.Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderForref, "ref", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1: 0
}, false, "reactbuild.common.model.TypedRefTo$anon$lazy$macro$19$1$$anon$1", {
  Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1.prototype.$classData = $d_Lreactbuild_common_model_TypedRefTo$anon$lazy$macro$19$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31(outer) {
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForproject = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForstage = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderFortitle = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForuntil = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForparticipant = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForproject = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForstage = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderFortitle = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForuntil = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForparticipant = null;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForproject = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForstage = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderFortitle = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForuntil = $m_Lio_circe_Decoder$().decodeLocalDateTime__Lio_circe_Decoder();
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForparticipant = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForproject = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForstage = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderFortitle = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForuntil = $m_Lio_circe_Encoder$().encodeLocalDateTime__Lio_circe_Encoder();
  this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForparticipant = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31.prototype.constructor = $c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31;
/** @constructor */
function $h_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31() {
  /*<skip>*/
}
$h_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31.prototype = $c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31.prototype;
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForproject = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForstage = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFortitle = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForfrom = $as_Ljava_time_LocalDateTime($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForuntil = $as_Ljava_time_LocalDateTime($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForparticipant = $as_Lreactbuild_common_model_RefTo($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p9)) {
                    var $$x1 = $m_Lio_circe_JsonObject$();
                    var this$4 = $m_sci_Vector$();
                    var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("project"), $n(this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForproject).apply__O__Lio_circe_Json(circeGenericHListBindingForproject)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("stage"), $n(this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForstage).apply__O__Lio_circe_Json(circeGenericHListBindingForstage)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("from"), $n(this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForuntil).apply__O__Lio_circe_Json(circeGenericHListBindingForfrom)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("until"), $n(this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForuntil).apply__O__Lio_circe_Json(circeGenericHListBindingForuntil)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("participant"), $n(this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericEncoderForparticipant).apply__O__Lio_circe_Json(circeGenericHListBindingForparticipant))];
                    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                    return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("project"))), this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForproject, "project", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("stage"))), this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForstage, "stage", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderFortitle, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("from"))), this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForuntil, "from", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("until"))), this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForuntil, "until", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("participant"))), this.Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31__f_circeGenericDecoderForparticipant, "participant", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31 = new $TypeData().initClass({
  Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31: 0
}, false, "reactbuild.model.AllocatedTime$anon$lazy$macro$67$2$$anon$31", {
  Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31.prototype.$classData = $d_Lreactbuild_model_AllocatedTime$anon$lazy$macro$67$2$$anon$31;
/** @constructor */
function $c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16(outer) {
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderForlabel = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderForparent = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderForlabel = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderForparent = null;
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderForlabel = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderForparent = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderForlabel = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderForparent = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16.prototype.constructor = $c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16;
/** @constructor */
function $h_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16.prototype = $c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16.prototype;
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForlabel = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForparent = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("label"), $n(this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderForlabel).apply__O__Lio_circe_Json(circeGenericHListBindingForlabel)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("parent"), $n(this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericEncoderForparent).apply__O__Lio_circe_Json(circeGenericHListBindingForparent))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("label"))), this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderForlabel, "label", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("parent"))), this.Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16__f_circeGenericDecoderForparent, "parent", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16 = new $TypeData().initClass({
  Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16: 0
}, false, "reactbuild.model.BuildingPart$anon$lazy$macro$35$3$$anon$16", {
  Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16.prototype.$classData = $d_Lreactbuild_model_BuildingPart$anon$lazy$macro$35$3$$anon$16;
/** @constructor */
function $c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13(outer) {
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderForname = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderForparent = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderForname = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderForparent = null;
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderForparent = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderForparent = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13.prototype.constructor = $c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13;
/** @constructor */
function $h_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13.prototype = $c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13.prototype;
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForparent = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("parent"), $n(this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericEncoderForparent).apply__O__Lio_circe_Json(circeGenericHListBindingForparent))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("parent"))), this.Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13__f_circeGenericDecoderForparent, "parent", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13 = new $TypeData().initClass({
  Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13: 0
}, false, "reactbuild.model.BuildingStage$anon$lazy$macro$35$1$$anon$13", {
  Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13.prototype.$classData = $d_Lreactbuild_model_BuildingStage$anon$lazy$macro$35$1$$anon$13;
/** @constructor */
function $c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32(outer) {
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForpersons = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForpersonAnnotations = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingParts = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingSites = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingStages = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingSiteStages = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForresources = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForproducts = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForlistTemplates = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForterms = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderFororganizationUsers = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForpersons = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForpersonAnnotations = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingParts = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingSites = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingStages = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingSiteStages = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForresources = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForproducts = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForlistTemplates = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForterms = null;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderFororganizationUsers = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_person_Person$().Lreactbuild_person_Person$__f_codecForPerson;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForpersons = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Decoder$();
  var decodeK = $m_Lreactbuild_common_model_RefTo$().decodeKeyRefTo__Lio_circe_KeyDecoder();
  $m_Lio_circe_Decoder$();
  var decodeA$1 = $m_Lreactbuild_person_PersonAnnotation$().Lreactbuild_person_PersonAnnotation$__f_codecForPersonAnnotation;
  var decodeV = new $c_Lio_circe_Decoder$$anon$42(decodeA$1);
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForpersonAnnotations = new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeV);
  $m_Lio_circe_Decoder$();
  var decodeA$2 = $m_Lreactbuild_model_BuildingPart$().Lreactbuild_model_BuildingPart$__f_codecForBuildingPart;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingParts = new $c_Lio_circe_Decoder$$anon$44(decodeA$2);
  $m_Lio_circe_Decoder$();
  var decodeA$3 = $m_Lreactbuild_common_model_Project$().Lreactbuild_common_model_Project$__f_codecForProject;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingSites = new $c_Lio_circe_Decoder$$anon$44(decodeA$3);
  $m_Lio_circe_Decoder$();
  var decodeA$4 = $m_Lreactbuild_model_BuildingStage$().Lreactbuild_model_BuildingStage$__f_codecForBuildingStage;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingStages = new $c_Lio_circe_Decoder$$anon$44(decodeA$4);
  $m_Lio_circe_Decoder$();
  var decodeK$1 = $m_Lreactbuild_common_model_RefTo$().decodeKeyRefTo__Lio_circe_KeyDecoder();
  $m_Lio_circe_Decoder$();
  var decodeA$5 = $m_Lreactbuild_model_BuildingSiteStage$().Lreactbuild_model_BuildingSiteStage$__f_decodeBuildingSiteStage;
  var decodeV$1 = new $c_Lio_circe_Decoder$$anon$44(decodeA$5);
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingSiteStages = new $c_Lio_circe_Decoder$$anon$41(decodeK$1, decodeV$1);
  $m_Lio_circe_Decoder$();
  var decodeA$6 = $m_Lreactbuild_model_Resource$().Lreactbuild_model_Resource$__f_codecForResource;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForresources = new $c_Lio_circe_Decoder$$anon$44(decodeA$6);
  $m_Lio_circe_Decoder$();
  var decodeA$7 = $m_Lreactbuild_model_Product$().Lreactbuild_model_Product$__f_codecForProduct;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForproducts = new $c_Lio_circe_Decoder$$anon$44(decodeA$7);
  $m_Lio_circe_Decoder$();
  var decodeA$8 = $m_Lreactbuild_model_WithChildren$().decodeWithChildren__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_model_ListTemplate$().Lreactbuild_model_ListTemplate$__f_codecForListTemplate, $m_Lreactbuild_model_ListTemplateEntry$().Lreactbuild_model_ListTemplateEntry$__f_codecForListTemplateEntry);
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForlistTemplates = new $c_Lio_circe_Decoder$$anon$44(decodeA$8);
  $m_Lio_circe_Decoder$();
  var decodeA$9 = $m_Lreactbuild_model_Term$().Lreactbuild_model_Term$__f_codecForTerm;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForterms = new $c_Lio_circe_Decoder$$anon$44(decodeA$9);
  $m_Lio_circe_Decoder$();
  var decodeA$10 = $m_Lreactbuild_common_model_OrganizationUser$().Lreactbuild_common_model_OrganizationUser$__f_codecForOrganizationUser;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderFororganizationUsers = new $c_Lio_circe_Decoder$$anon$44(decodeA$10);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_person_Person$().Lreactbuild_person_Person$__f_codecForPerson;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForpersons = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  var $$x2 = $m_Lio_circe_Encoder$();
  var $$x1 = $m_Lreactbuild_common_model_RefTo$().encodeKeyRefTo__Lio_circe_KeyEncoder();
  $m_Lio_circe_Encoder$();
  var encodeA$1 = $m_Lreactbuild_person_PersonAnnotation$().Lreactbuild_person_PersonAnnotation$__f_codecForPersonAnnotation;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForpersonAnnotations = $n($$x2).encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($$x1, new $c_Lio_circe_Encoder$$anon$23(encodeA$1));
  $m_Lio_circe_Encoder$();
  var encodeA$2 = $m_Lreactbuild_model_BuildingPart$().Lreactbuild_model_BuildingPart$__f_codecForBuildingPart;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingParts = new $c_Lio_circe_Encoder$$anon$25(encodeA$2);
  $m_Lio_circe_Encoder$();
  var encodeA$3 = $m_Lreactbuild_common_model_Project$().Lreactbuild_common_model_Project$__f_codecForProject;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingSites = new $c_Lio_circe_Encoder$$anon$25(encodeA$3);
  $m_Lio_circe_Encoder$();
  var encodeA$4 = $m_Lreactbuild_model_BuildingStage$().Lreactbuild_model_BuildingStage$__f_codecForBuildingStage;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingStages = new $c_Lio_circe_Encoder$$anon$25(encodeA$4);
  var $$x4 = $m_Lio_circe_Encoder$();
  var $$x3 = $m_Lreactbuild_common_model_RefTo$().encodeKeyRefTo__Lio_circe_KeyEncoder();
  $m_Lio_circe_Encoder$();
  var encodeA$5 = $m_Lreactbuild_model_BuildingSiteStage$().Lreactbuild_model_BuildingSiteStage$__f_encodeBuildingSiteStage;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingSiteStages = $n($$x4).encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($$x3, new $c_Lio_circe_Encoder$$anon$25(encodeA$5));
  $m_Lio_circe_Encoder$();
  var encodeA$6 = $m_Lreactbuild_model_Resource$().Lreactbuild_model_Resource$__f_codecForResource;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForresources = new $c_Lio_circe_Encoder$$anon$25(encodeA$6);
  $m_Lio_circe_Encoder$();
  var encodeA$7 = $m_Lreactbuild_model_Product$().Lreactbuild_model_Product$__f_codecForProduct;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForproducts = new $c_Lio_circe_Encoder$$anon$25(encodeA$7);
  $m_Lio_circe_Encoder$();
  var encodeA$8 = $m_Lreactbuild_model_WithChildren$().encodeWithChildren__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder($m_Lreactbuild_model_ListTemplateEntry$().Lreactbuild_model_ListTemplateEntry$__f_codecForListTemplateEntry, $m_Lreactbuild_model_ListTemplate$().Lreactbuild_model_ListTemplate$__f_codecForListTemplate);
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForlistTemplates = new $c_Lio_circe_Encoder$$anon$25(encodeA$8);
  $m_Lio_circe_Encoder$();
  var encodeA$9 = $m_Lreactbuild_model_Term$().Lreactbuild_model_Term$__f_codecForTerm;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForterms = new $c_Lio_circe_Encoder$$anon$25(encodeA$9);
  $m_Lio_circe_Encoder$();
  var encodeA$10 = $m_Lreactbuild_common_model_OrganizationUser$().Lreactbuild_common_model_OrganizationUser$__f_codecForOrganizationUser;
  this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderFororganizationUsers = new $c_Lio_circe_Encoder$$anon$25(encodeA$10)
}
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32.prototype.constructor = $c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32;
/** @constructor */
function $h_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32.prototype = $c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32.prototype;
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForpersons = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForpersonAnnotations = $as_sci_Map($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForbuildingParts = $as_sci_List($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForbuildingSites = $as_sci_List($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForbuildingStages = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForbuildingSiteStages = $as_sci_Map($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForresources = $as_sci_List($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForproducts = $as_sci_List($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                  if ((p9 !== null)) {
                    var circeGenericHListBindingForlistTemplates = $as_sci_List($n(p9).Lshapeless_$colon$colon__f_head);
                    var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                    if ((p10 !== null)) {
                      var circeGenericHListBindingForterms = $as_sci_List($n(p10).Lshapeless_$colon$colon__f_head);
                      var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                      if ((p11 !== null)) {
                        var circeGenericHListBindingFororganizationUsers = $as_sci_List($n(p11).Lshapeless_$colon$colon__f_head);
                        var p12 = $as_Lshapeless_HNil($n(p11).Lshapeless_$colon$colon__f_tail);
                        var x = $m_Lshapeless_HNil$();
                        if ((x === p12)) {
                          var $$x22 = $m_Lio_circe_JsonObject$();
                          var this$15 = $m_sci_Vector$();
                          var $$x21 = $n(transformMemberNames).apply__O__O("persons");
                          var this$1 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForpersons);
                          var $$x20 = $ct_T2__O__O__(new $c_T2(), $$x21, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForpersons));
                          var $$x19 = $n(transformMemberNames).apply__O__O("personAnnotations");
                          var this$2 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForpersonAnnotations);
                          var $$x18 = $ct_T2__O__O__(new $c_T2(), $$x19, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForpersonAnnotations));
                          var $$x17 = $n(transformMemberNames).apply__O__O("buildingParts");
                          var this$3 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingParts);
                          var $$x16 = $ct_T2__O__O__(new $c_T2(), $$x17, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForbuildingParts));
                          var $$x15 = $n(transformMemberNames).apply__O__O("buildingSites");
                          var this$4 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingSites);
                          var $$x14 = $ct_T2__O__O__(new $c_T2(), $$x15, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$4, circeGenericHListBindingForbuildingSites));
                          var $$x13 = $n(transformMemberNames).apply__O__O("buildingStages");
                          var this$5 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingStages);
                          var $$x12 = $ct_T2__O__O__(new $c_T2(), $$x13, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$5, circeGenericHListBindingForbuildingStages));
                          var $$x11 = $n(transformMemberNames).apply__O__O("buildingSiteStages");
                          var this$6 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForbuildingSiteStages);
                          var $$x10 = $ct_T2__O__O__(new $c_T2(), $$x11, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$6, circeGenericHListBindingForbuildingSiteStages));
                          var $$x9 = $n(transformMemberNames).apply__O__O("resources");
                          var this$7 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForresources);
                          var $$x8 = $ct_T2__O__O__(new $c_T2(), $$x9, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$7, circeGenericHListBindingForresources));
                          var $$x7 = $n(transformMemberNames).apply__O__O("products");
                          var this$8 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForproducts);
                          var $$x6 = $ct_T2__O__O__(new $c_T2(), $$x7, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$8, circeGenericHListBindingForproducts));
                          var $$x5 = $n(transformMemberNames).apply__O__O("listTemplates");
                          var this$9 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForlistTemplates);
                          var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$9, circeGenericHListBindingForlistTemplates));
                          var $$x3 = $n(transformMemberNames).apply__O__O("terms");
                          var this$10 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderForterms);
                          var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$10, circeGenericHListBindingForterms));
                          var $$x1 = $n(transformMemberNames).apply__O__O("organizationUsers");
                          var this$11 = $n(this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericEncoderFororganizationUsers);
                          var array = [$$x20, $$x18, $$x16, $$x14, $$x12, $$x10, $$x8, $$x6, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$11, circeGenericHListBindingFororganizationUsers))];
                          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                          return $n($$x22).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$15.from__sc_IterableOnce__sci_Vector(elems))
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("persons"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForpersons, "persons", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("personAnnotations"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForpersonAnnotations, "personAnnotations", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingParts"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingParts, "buildingParts", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingSites"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingSites, "buildingSites", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingStages"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingStages, "buildingStages", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingSiteStages"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForbuildingSiteStages, "buildingSiteStages", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("resources"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForresources, "resources", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("products"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForproducts, "products", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("listTemplates"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForlistTemplates, "listTemplates", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("terms"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderForterms, "terms", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organizationUsers"))), this.Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32__f_circeGenericDecoderFororganizationUsers, "organizationUsers", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32 = new $TypeData().initClass({
  Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32: 0
}, false, "reactbuild.model.CommonData$anon$lazy$macro$91$1$$anon$32", {
  Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32.prototype.$classData = $d_Lreactbuild_model_CommonData$anon$lazy$macro$91$1$$anon$32;
/** @constructor */
function $c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12(outer) {
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForpersons = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForsubject = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForbodies = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForattachments = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForheaders = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForpersons = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForsubject = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForbodies = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForattachments = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForheaders = null;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_CommunicationPerson$().Lreactbuild_model_CommunicationPerson$__f_codecForCommunicationPerson;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForpersons = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderFordate = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForsubject = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var decodeA$1 = $m_Lreactbuild_model_CommunicationBody$().Lreactbuild_model_CommunicationBody$__f_codecForCommunicationBody;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForbodies = new $c_Lio_circe_Decoder$$anon$42(decodeA$1);
  $m_Lio_circe_Decoder$();
  var decodeA$2 = $m_Lreactbuild_model_CommunicationAttachment$().Lreactbuild_model_CommunicationAttachment$__f_codecForCommunicationAttachment;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForattachments = new $c_Lio_circe_Decoder$$anon$42(decodeA$2);
  $m_Lio_circe_Decoder$();
  var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
  $m_Lio_circe_Decoder$();
  var decodeA$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var decodeV = new $c_Lio_circe_Decoder$$anon$42(decodeA$3);
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForheaders = new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeV);
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_CommunicationPerson$().Lreactbuild_model_CommunicationPerson$__f_codecForCommunicationPerson;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForpersons = new $c_Lio_circe_Encoder$$anon$23(encodeA);
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderFordate = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForsubject = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var encodeA$1 = $m_Lreactbuild_model_CommunicationBody$().Lreactbuild_model_CommunicationBody$__f_codecForCommunicationBody;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForbodies = new $c_Lio_circe_Encoder$$anon$23(encodeA$1);
  $m_Lio_circe_Encoder$();
  var encodeA$2 = $m_Lreactbuild_model_CommunicationAttachment$().Lreactbuild_model_CommunicationAttachment$__f_codecForCommunicationAttachment;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForattachments = new $c_Lio_circe_Encoder$$anon$23(encodeA$2);
  var $$x2 = $m_Lio_circe_Encoder$();
  var $$x1 = $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString;
  $m_Lio_circe_Encoder$();
  var encodeA$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForheaders = $n($$x2).encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($$x1, new $c_Lio_circe_Encoder$$anon$23(encodeA$3))
}
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12.prototype.constructor = $c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12;
/** @constructor */
function $h_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12.prototype = $c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12.prototype;
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForpersons = $as_sci_Seq($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForsenderAddress = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForreceiverAddress = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingFordate = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForsubject = $as_T($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForbodies = $as_sci_Seq($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                  if ((p9 !== null)) {
                    var circeGenericHListBindingForattachments = $as_sci_Seq($n(p9).Lshapeless_$colon$colon__f_head);
                    var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                    if ((p10 !== null)) {
                      var circeGenericHListBindingForheaders = $as_sci_Map($n(p10).Lshapeless_$colon$colon__f_head);
                      var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p11)) {
                        var $$x14 = $m_Lio_circe_JsonObject$();
                        var this$8 = $m_sci_Vector$();
                        var $$x13 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                        var $$x12 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization));
                        var $$x11 = $n(transformMemberNames).apply__O__O("persons");
                        var this$1 = $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForpersons);
                        var $$x10 = $ct_T2__O__O__(new $c_T2(), $$x11, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForpersons));
                        var $$x9 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("senderAddress"), $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForsubject).apply__O__Lio_circe_Json(circeGenericHListBindingForsenderAddress));
                        var $$x8 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("receiverAddress"), $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForsubject).apply__O__Lio_circe_Json(circeGenericHListBindingForreceiverAddress));
                        var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate));
                        var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("subject"), $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForsubject).apply__O__Lio_circe_Json(circeGenericHListBindingForsubject));
                        var $$x5 = $n(transformMemberNames).apply__O__O("bodies");
                        var this$2 = $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForbodies);
                        var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForbodies));
                        var $$x3 = $n(transformMemberNames).apply__O__O("attachments");
                        var this$3 = $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForattachments);
                        var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForattachments));
                        var $$x1 = $n(transformMemberNames).apply__O__O("headers");
                        var this$4 = $n(this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericEncoderForheaders);
                        var array = [$$x13, $$x12, $$x10, $$x9, $$x8, $$x7, $$x6, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$4, circeGenericHListBindingForheaders))];
                        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                        return $n($$x14).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$8.from__sc_IterableOnce__sci_Vector(elems))
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("persons"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForpersons, "persons", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("senderAddress"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForsubject, "senderAddress", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("receiverAddress"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForsubject, "receiverAddress", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("subject"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForsubject, "subject", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("bodies"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForbodies, "bodies", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("attachments"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForattachments, "attachments", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("headers"))), this.Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12__f_circeGenericDecoderForheaders, "headers", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12 = new $TypeData().initClass({
  Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12: 0
}, false, "reactbuild.model.Communication$anon$lazy$macro$83$1$$anon$12", {
  Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12.prototype.$classData = $d_Lreactbuild_model_Communication$anon$lazy$macro$83$1$$anon$12;
/** @constructor */
function $c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11(outer) {
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericDecoderForid = null;
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericDecoderForfile = null;
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericEncoderForid = null;
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericEncoderForfile = null;
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericDecoderForfile = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericEncoderForfile = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder()
}
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11.prototype.constructor = $c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11;
/** @constructor */
function $h_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11.prototype = $c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11.prototype;
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForfile = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("file"), $n(this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericEncoderForfile).apply__O__Lio_circe_Json(circeGenericHListBindingForfile))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("file"))), this.Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11__f_circeGenericDecoderForfile, "file", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11: 0
}, false, "reactbuild.model.CommunicationAttachment$anon$lazy$macro$19$1$$anon$11", {
  Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11.prototype.$classData = $d_Lreactbuild_model_CommunicationAttachment$anon$lazy$macro$19$1$$anon$11;
/** @constructor */
function $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4(outer) {
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericDecoderForHtmlCommunicationBody = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericDecoderForOtherCommunicationBody = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericDecoderForTextCommunicationBody = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericEncoderForHtmlCommunicationBody = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericEncoderForOtherCommunicationBody = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericEncoderForTextCommunicationBody = null;
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_$outer).inst$macro$31__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericDecoderForHtmlCommunicationBody = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_$outer).inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericDecoderForOtherCommunicationBody = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericDecoderForTextCommunicationBody = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_$outer).inst$macro$69__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericEncoderForHtmlCommunicationBody = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_$outer).inst$macro$51__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericEncoderForOtherCommunicationBody = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_$outer).inst$macro$41__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericEncoderForTextCommunicationBody = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O())
}
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4.prototype.constructor = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4;
/** @constructor */
function $h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4.prototype = $c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4.prototype;
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForHtmlCommunicationBody = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForHtmlCommunicationBody instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForHtmlCommunicationBody);
    var circeGenericInlBindingForHtmlCommunicationBody = $as_Lreactbuild_model_HtmlCommunicationBody($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericEncoderForHtmlCommunicationBody;
    var name = $as_T($n(transformConstructorNames).apply__O__O("HtmlCommunicationBody"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForHtmlCommunicationBody, name, discriminator)
  } else if ((circeGenericInrBindingForHtmlCommunicationBody instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForHtmlCommunicationBody);
    var circeGenericInrBindingForOtherCommunicationBody = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForOtherCommunicationBody instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForOtherCommunicationBody);
      var circeGenericInlBindingForOtherCommunicationBody = $as_Lreactbuild_model_OtherCommunicationBody($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericEncoderForOtherCommunicationBody;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("OtherCommunicationBody"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForOtherCommunicationBody, name$1, discriminator)
    } else if ((circeGenericInrBindingForOtherCommunicationBody instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForOtherCommunicationBody);
      var circeGenericInrBindingForTextCommunicationBody = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForTextCommunicationBody instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForTextCommunicationBody);
        var circeGenericInlBindingForTextCommunicationBody = $as_Lreactbuild_model_TextCommunicationBody($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericEncoderForTextCommunicationBody;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("TextCommunicationBody"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForTextCommunicationBody, name$2, discriminator)
      } else if ((circeGenericInrBindingForTextCommunicationBody instanceof $c_Lshapeless_Inr)) {
        $m_s_sys_package$().error__T__E("Cannot encode CNil")
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForTextCommunicationBody)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForOtherCommunicationBody)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForHtmlCommunicationBody)
  }
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericDecoderForHtmlCommunicationBody, c, $as_T($n(transformConstructorNames).apply__O__O("HtmlCommunicationBody")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_HtmlCommunicationBody($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericDecoderForOtherCommunicationBody, c, $as_T($n(transformConstructorNames).apply__O__O("OtherCommunicationBody")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_OtherCommunicationBody($n(x2$4).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4__f_circeGenericDecoderForTextCommunicationBody, c, $as_T($n(transformConstructorNames).apply__O__O("TextCommunicationBody")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_model_TextCommunicationBody($n(x2$6).s_util_Right__f_value);
            var x1$8 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$8 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          $m_Lio_circe_DecodingFailure$();
          var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
          var x1$7 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
          var err$4 = $as_Lio_circe_DecodingFailure(x1$7.s_util_Left__f_value);
          var x1$8 = new $c_s_util_Left(err$4)
        };
        if ((x1$8 instanceof $c_s_util_Right)) {
          var x2$8 = $as_s_util_Right(x1$8);
          var v$5 = $as_Lshapeless_$colon$plus$colon($n(x2$8).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$5))
        } else {
          if ((!(x1$8 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$8)
          };
          var x3$5 = $as_s_util_Left(x1$8);
          var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$5)
        }
      };
      if ((x1$9 instanceof $c_s_util_Right)) {
        var x2$9 = $as_s_util_Right(x1$9);
        var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$9).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
      } else if ((x1$9 instanceof $c_s_util_Left)) {
        var x3$6 = $as_s_util_Left(x1$9);
        var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
        return new $c_s_util_Left(err$6)
      } else {
        throw new $c_s_MatchError(x1$9)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4: 0
}, false, "reactbuild.model.CommunicationBody$anon$lazy$macro$79$1$$anon$4", {
  Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4.prototype.$classData = $d_Lreactbuild_model_CommunicationBody$anon$lazy$macro$79$1$$anon$4;
/** @constructor */
function $c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3(outer) {
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForrole = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForperson = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForaddress = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForadded = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForrole = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForperson = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForaddress = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForadded = null;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForrole = $m_Lreactbuild_model_CommunicationRole$().Lreactbuild_model_CommunicationRole$__f_codecForCommunicationRole;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForperson = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForaddress = new $c_Lio_circe_Decoder$$anon$39(d$1);
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForadded = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForrole = $m_Lreactbuild_model_CommunicationRole$().Lreactbuild_model_CommunicationRole$__f_codecForCommunicationRole;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForperson = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForaddress = new $c_Lio_circe_Encoder$$anon$21(e$1);
  this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForadded = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder()
}
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3.prototype.constructor = $c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3;
/** @constructor */
function $h_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3.prototype = $c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3.prototype;
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForrole = $as_Lreactbuild_model_CommunicationRole($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForperson = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForaddress = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForadded = $as_Ljava_time_Instant($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x2 = $m_Lio_circe_JsonObject$();
            var this$5 = $m_sci_Vector$();
            var $$x1 = $n(transformMemberNames).apply__O__O("role");
            var this$1 = $n(this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForrole);
            var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForrole)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("person"), $n(this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForperson).apply__O__Lio_circe_Json(circeGenericHListBindingForperson)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("address"), $n(this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForaddress).apply__O__Lio_circe_Json(circeGenericHListBindingForaddress)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("added"), $n(this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForadded).apply__O__Lio_circe_Json(circeGenericHListBindingForadded))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("role"))), this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForrole, "role", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("person"))), this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForperson, "person", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("address"))), this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForaddress, "address", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("added"))), this.Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForadded, "added", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3: 0
}, false, "reactbuild.model.CommunicationPerson$anon$lazy$macro$35$1$$anon$3", {
  Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3.prototype.$classData = $d_Lreactbuild_model_CommunicationPerson$anon$lazy$macro$35$1$$anon$3;
/** @constructor */
function $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1(outer) {
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForFrom = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForRecipient = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForSender = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForTo = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForFrom = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForRecipient = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForSender = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForTo = null;
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForFrom = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForRecipient = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForSender = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForTo = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$12__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForFrom = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$11__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForRecipient = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$10__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForSender = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForTo = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O())
}
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1.prototype.constructor = $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1.prototype = $c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1.prototype;
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForFrom = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForFrom instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForFrom);
    var circeGenericInlBindingForFrom = $as_Lreactbuild_model_CommunicationRole$From$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForFrom;
    var name = $as_T($n(transformConstructorNames).apply__O__O("From"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForFrom, name, discriminator)
  } else if ((circeGenericInrBindingForFrom instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForFrom);
    var circeGenericInrBindingForRecipient = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForRecipient instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForRecipient);
      var circeGenericInlBindingForRecipient = $as_Lreactbuild_model_CommunicationRole$Recipient$($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForRecipient;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Recipient"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForRecipient, name$1, discriminator)
    } else if ((circeGenericInrBindingForRecipient instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForRecipient);
      var circeGenericInrBindingForSender = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForSender instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForSender);
        var circeGenericInlBindingForSender = $as_Lreactbuild_model_CommunicationRole$Sender$($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForSender;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Sender"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForSender, name$2, discriminator)
      } else if ((circeGenericInrBindingForSender instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForSender);
        var circeGenericInrBindingForTo = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForTo instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForTo);
          var circeGenericInlBindingForTo = $as_Lreactbuild_model_CommunicationRole$To$($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForTo;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("To"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForTo, name$3, discriminator)
        } else if ((circeGenericInrBindingForTo instanceof $c_Lshapeless_Inr)) {
          $m_s_sys_package$().error__T__E("Cannot encode CNil")
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForTo)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForSender)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForRecipient)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForFrom)
  }
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForFrom, c, $as_T($n(transformConstructorNames).apply__O__O("From")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_CommunicationRole$From$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForRecipient, c, $as_T($n(transformConstructorNames).apply__O__O("Recipient")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_CommunicationRole$Recipient$($n(x2$4).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForSender, c, $as_T($n(transformConstructorNames).apply__O__O("Sender")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_model_CommunicationRole$Sender$($n(x2$6).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForTo, c, $as_T($n(transformConstructorNames).apply__O__O("To")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_model_CommunicationRole$To$($n(x2$8).s_util_Right__f_value);
              var x1$10 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$10 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            $m_Lio_circe_DecodingFailure$();
            var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
            var x1$9 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
            var err$5 = $as_Lio_circe_DecodingFailure(x1$9.s_util_Left__f_value);
            var x1$10 = new $c_s_util_Left(err$5)
          };
          if ((x1$10 instanceof $c_s_util_Right)) {
            var x2$10 = $as_s_util_Right(x1$10);
            var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$10).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
          } else {
            if ((!(x1$10 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$10)
            };
            var x3$6 = $as_s_util_Left(x1$10);
            var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$6)
          }
        };
        if ((x1$11 instanceof $c_s_util_Right)) {
          var x2$11 = $as_s_util_Right(x1$11);
          var v$7 = $as_Lshapeless_$colon$plus$colon($n(x2$11).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$7))
        } else {
          if ((!(x1$11 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$11)
          };
          var x3$7 = $as_s_util_Left(x1$11);
          var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$7)
        }
      };
      if ((x1$12 instanceof $c_s_util_Right)) {
        var x2$12 = $as_s_util_Right(x1$12);
        var v$8 = $as_Lshapeless_$colon$plus$colon($n(x2$12).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$8))
      } else if ((x1$12 instanceof $c_s_util_Left)) {
        var x3$8 = $as_s_util_Left(x1$12);
        var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
        return new $c_s_util_Left(err$8)
      } else {
        throw new $c_s_MatchError(x1$12)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1: 0
}, false, "reactbuild.model.CommunicationRole$anon$lazy$macro$13$1$$anon$1", {
  Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1.prototype.$classData = $d_Lreactbuild_model_CommunicationRole$anon$lazy$macro$13$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36(outer) {
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericDecoderForMissingDeliveryFormDetails = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericDecoderForReconciliedDeliveryFormDetails = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericEncoderForMissingDeliveryFormDetails = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericEncoderForReconciliedDeliveryFormDetails = null;
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_$outer).inst$macro$53__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericDecoderForMissingDeliveryFormDetails = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericDecoderForReconciliedDeliveryFormDetails = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_$outer).inst$macro$113__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericEncoderForMissingDeliveryFormDetails = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_$outer).inst$macro$63__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericEncoderForReconciliedDeliveryFormDetails = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O())
}
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36.prototype.constructor = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36;
/** @constructor */
function $h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36() {
  /*<skip>*/
}
$h_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36.prototype = $c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36.prototype;
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForMissingDeliveryFormDetails = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForMissingDeliveryFormDetails instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForMissingDeliveryFormDetails);
    var circeGenericInlBindingForMissingDeliveryFormDetails = $as_Lreactbuild_model_MissingDeliveryFormDetails($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericEncoderForMissingDeliveryFormDetails;
    var name = $as_T($n(transformConstructorNames).apply__O__O("MissingDeliveryFormDetails"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForMissingDeliveryFormDetails, name, discriminator)
  } else if ((circeGenericInrBindingForMissingDeliveryFormDetails instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForMissingDeliveryFormDetails);
    var circeGenericInrBindingForReconciliedDeliveryFormDetails = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForReconciliedDeliveryFormDetails instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForReconciliedDeliveryFormDetails);
      var circeGenericInlBindingForReconciliedDeliveryFormDetails = $as_Lreactbuild_model_ReconciliedDeliveryFormDetails($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericEncoderForReconciliedDeliveryFormDetails;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("ReconciliedDeliveryFormDetails"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForReconciliedDeliveryFormDetails, name$1, discriminator)
    } else if ((circeGenericInrBindingForReconciliedDeliveryFormDetails instanceof $c_Lshapeless_Inr)) {
      $m_s_sys_package$().error__T__E("Cannot encode CNil")
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForReconciliedDeliveryFormDetails)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForMissingDeliveryFormDetails)
  }
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericDecoderForMissingDeliveryFormDetails, c, $as_T($n(transformConstructorNames).apply__O__O("MissingDeliveryFormDetails")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_MissingDeliveryFormDetails($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36__f_circeGenericDecoderForReconciliedDeliveryFormDetails, c, $as_T($n(transformConstructorNames).apply__O__O("ReconciliedDeliveryFormDetails")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_ReconciliedDeliveryFormDetails($n(x2$4).s_util_Right__f_value);
          var x1$6 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$6 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        $m_Lio_circe_DecodingFailure$();
        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
        var x1$5 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
        var err$3 = $as_Lio_circe_DecodingFailure(x1$5.s_util_Left__f_value);
        var x1$6 = new $c_s_util_Left(err$3)
      };
      if ((x1$6 instanceof $c_s_util_Right)) {
        var x2$6 = $as_s_util_Right(x1$6);
        var v$4 = $as_Lshapeless_$colon$plus$colon($n(x2$6).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$4))
      } else if ((x1$6 instanceof $c_s_util_Left)) {
        var x3$4 = $as_s_util_Left(x1$6);
        var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
        return new $c_s_util_Left(err$4)
      } else {
        throw new $c_s_MatchError(x1$6)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36 = new $TypeData().initClass({
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36: 0
}, false, "reactbuild.model.DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36", {
  Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36.prototype.$classData = $d_Lreactbuild_model_DeliveryFormDetails$anon$lazy$macro$123$1$$anon$36;
/** @constructor */
function $c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18(outer) {
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForid = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForquantity = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForunit = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForamount = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderFortradeBody = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForbuildingSite = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderFordeliveryDate = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForid = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForquantity = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForunit = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForamount = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderFortradeBody = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForbuildingSite = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderFordeliveryDate = null;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForquantity = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForunit = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForamount = new $c_Lio_circe_Decoder$$anon$39(d$2);
  $m_Lio_circe_Decoder$();
  var d$3 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderFortradeBody = new $c_Lio_circe_Decoder$$anon$39(d$3);
  $m_Lio_circe_Decoder$();
  var d$4 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForbuildingSite = new $c_Lio_circe_Decoder$$anon$39(d$4);
  $m_Lio_circe_Decoder$();
  var d$5 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderFordeliveryDate = new $c_Lio_circe_Decoder$$anon$39(d$5);
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForquantity = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForunit = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForamount = new $c_Lio_circe_Encoder$$anon$21(e$2);
  $m_Lio_circe_Encoder$();
  var e$3 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderFortradeBody = new $c_Lio_circe_Encoder$$anon$21(e$3);
  $m_Lio_circe_Encoder$();
  var e$4 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForbuildingSite = new $c_Lio_circe_Encoder$$anon$21(e$4);
  $m_Lio_circe_Encoder$();
  var e$5 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderFordeliveryDate = new $c_Lio_circe_Encoder$$anon$21(e$5)
}
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18.prototype.constructor = $c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18;
/** @constructor */
function $h_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18.prototype = $c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18.prototype;
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForreference = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFordescription = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForquantity = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForunit = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForunitPrice = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForamount = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingFortradeBody = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                  if ((p9 !== null)) {
                    var circeGenericHListBindingForbuildingSite = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                    var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                    if ((p10 !== null)) {
                      var circeGenericHListBindingFordeliveryDate = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                      var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p11)) {
                        var $$x1 = $m_Lio_circe_JsonObject$();
                        var this$4 = $m_sci_Vector$();
                        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForunit).apply__O__Lio_circe_Json(circeGenericHListBindingForreference)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("description"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForunit).apply__O__Lio_circe_Json(circeGenericHListBindingFordescription)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("quantity"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForquantity).apply__O__Lio_circe_Json(circeGenericHListBindingForquantity)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("unit"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForunit).apply__O__Lio_circe_Json(circeGenericHListBindingForunit)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("unitPrice"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForamount).apply__O__Lio_circe_Json(circeGenericHListBindingForunitPrice)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("amount"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForamount).apply__O__Lio_circe_Json(circeGenericHListBindingForamount)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("tradeBody"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderFortradeBody).apply__O__Lio_circe_Json(circeGenericHListBindingFortradeBody)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("buildingSite"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderForbuildingSite).apply__O__Lio_circe_Json(circeGenericHListBindingForbuildingSite)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("deliveryDate"), $n(this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericEncoderFordeliveryDate).apply__O__Lio_circe_Json(circeGenericHListBindingFordeliveryDate))];
                        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForunit, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("description"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForunit, "description", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("quantity"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForquantity, "quantity", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unit"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForunit, "unit", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unitPrice"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForamount, "unitPrice", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("amount"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForamount, "amount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("tradeBody"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderFortradeBody, "tradeBody", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingSite"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderForbuildingSite, "buildingSite", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("deliveryDate"))), this.Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18__f_circeGenericDecoderFordeliveryDate, "deliveryDate", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18 = new $TypeData().initClass({
  Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18: 0
}, false, "reactbuild.model.InvoiceDetail$anon$lazy$macro$83$2$$anon$18", {
  Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18.prototype.$classData = $d_Lreactbuild_model_InvoiceDetail$anon$lazy$macro$83$2$$anon$18;
/** @constructor */
function $c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7(outer) {
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForfile = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFornotDone = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForsupplierOffice = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForreference = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFortotalAmount = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFordetails = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForentryNumber = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForcategory = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFordeletedAt = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForfile = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFornotDone = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForsupplierOffice = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForreference = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFortotalAmount = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFordetails = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForentryNumber = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForcategory = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFordeletedAt = null;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_model_InvoicePageFile$().Lreactbuild_model_InvoicePageFile$__f_codecForInvoicePageFile;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForfile = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFornotDone = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeBoolean;
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForsupplierOffice = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFordate = new $c_Lio_circe_Decoder$$anon$39(d$2);
  $m_Lio_circe_Decoder$();
  var d$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForreference = new $c_Lio_circe_Decoder$$anon$39(d$3);
  $m_Lio_circe_Decoder$();
  var d$4 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFortotalAmount = new $c_Lio_circe_Decoder$$anon$39(d$4);
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_InvoiceDetail$().Lreactbuild_model_InvoiceDetail$__f_codecForInvoiceDetail;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFordetails = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Decoder$();
  var d$5 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForentryNumber = new $c_Lio_circe_Decoder$$anon$39(d$5);
  $m_Lio_circe_Decoder$();
  var d$6 = $m_Lreactbuild_model_DocumentCategory$().Lreactbuild_model_DocumentCategory$__f_decodeDocumentCategory;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForcategory = new $c_Lio_circe_Decoder$$anon$39(d$6);
  $m_Lio_circe_Decoder$();
  var d$7 = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFordeletedAt = new $c_Lio_circe_Decoder$$anon$39(d$7);
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_model_InvoicePageFile$().Lreactbuild_model_InvoicePageFile$__f_codecForInvoicePageFile;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForfile = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFornotDone = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean;
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForsupplierOffice = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFordate = new $c_Lio_circe_Encoder$$anon$21(e$2);
  $m_Lio_circe_Encoder$();
  var e$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForreference = new $c_Lio_circe_Encoder$$anon$21(e$3);
  $m_Lio_circe_Encoder$();
  var e$4 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFortotalAmount = new $c_Lio_circe_Encoder$$anon$21(e$4);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_InvoiceDetail$().Lreactbuild_model_InvoiceDetail$__f_codecForInvoiceDetail;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFordetails = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  $m_Lio_circe_Encoder$();
  var e$5 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForentryNumber = new $c_Lio_circe_Encoder$$anon$21(e$5);
  $m_Lio_circe_Encoder$();
  var e$6 = $m_Lreactbuild_model_DocumentCategory$().Lreactbuild_model_DocumentCategory$__f_encodeDocumentCategory;
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForcategory = new $c_Lio_circe_Encoder$$anon$21(e$6);
  $m_Lio_circe_Encoder$();
  var e$7 = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFordeletedAt = new $c_Lio_circe_Encoder$$anon$21(e$7)
}
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7.prototype.constructor = $c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7.prototype = $c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7.prototype;
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForfile = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFornotDone = $uZ($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForsupplier = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForsupplierOffice = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingFordate = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForreference = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                  if ((p9 !== null)) {
                    var circeGenericHListBindingForpageIndex = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                    var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                    if ((p10 !== null)) {
                      var circeGenericHListBindingForpageCount = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                      var p11 = $as_Lshapeless_$colon$colon($n(p10).Lshapeless_$colon$colon__f_tail);
                      if ((p11 !== null)) {
                        var circeGenericHListBindingForamount = $as_s_Option($n(p11).Lshapeless_$colon$colon__f_head);
                        var p12 = $as_Lshapeless_$colon$colon($n(p11).Lshapeless_$colon$colon__f_tail);
                        if ((p12 !== null)) {
                          var circeGenericHListBindingFortotalAmount = $as_s_Option($n(p12).Lshapeless_$colon$colon__f_head);
                          var p13 = $as_Lshapeless_$colon$colon($n(p12).Lshapeless_$colon$colon__f_tail);
                          if ((p13 !== null)) {
                            var circeGenericHListBindingFordetails = $as_sci_List($n(p13).Lshapeless_$colon$colon__f_head);
                            var p14 = $as_Lshapeless_$colon$colon($n(p13).Lshapeless_$colon$colon__f_tail);
                            if ((p14 !== null)) {
                              var circeGenericHListBindingForentryNumber = $as_s_Option($n(p14).Lshapeless_$colon$colon__f_head);
                              var p15 = $as_Lshapeless_$colon$colon($n(p14).Lshapeless_$colon$colon__f_tail);
                              if ((p15 !== null)) {
                                var circeGenericHListBindingForcategory = $as_s_Option($n(p15).Lshapeless_$colon$colon__f_head);
                                var p16 = $as_Lshapeless_$colon$colon($n(p15).Lshapeless_$colon$colon__f_tail);
                                if ((p16 !== null)) {
                                  var circeGenericHListBindingFordeletedAt = $as_s_Option($n(p16).Lshapeless_$colon$colon__f_head);
                                  var p17 = $as_Lshapeless_HNil($n(p16).Lshapeless_$colon$colon__f_tail);
                                  var x = $m_Lshapeless_HNil$();
                                  if ((x === p17)) {
                                    var $$x14 = $m_Lio_circe_JsonObject$();
                                    var this$5 = $m_sci_Vector$();
                                    var $$x13 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                                    var $$x12 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization));
                                    var $$x11 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("file"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForfile).apply__O__Lio_circe_Json(circeGenericHListBindingForfile));
                                    var $$x10 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("notDone"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFornotDone).apply__O__Lio_circe_Json(circeGenericHListBindingFornotDone));
                                    var $$x9 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("supplier"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForsupplierOffice).apply__O__Lio_circe_Json(circeGenericHListBindingForsupplier));
                                    var $$x8 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("supplierOffice"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForsupplierOffice).apply__O__Lio_circe_Json(circeGenericHListBindingForsupplierOffice));
                                    var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate));
                                    var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForreference).apply__O__Lio_circe_Json(circeGenericHListBindingForreference));
                                    var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("pageIndex"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForentryNumber).apply__O__Lio_circe_Json(circeGenericHListBindingForpageIndex));
                                    var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("pageCount"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForentryNumber).apply__O__Lio_circe_Json(circeGenericHListBindingForpageCount));
                                    var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("amount"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFortotalAmount).apply__O__Lio_circe_Json(circeGenericHListBindingForamount));
                                    var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("totalAmount"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFortotalAmount).apply__O__Lio_circe_Json(circeGenericHListBindingFortotalAmount));
                                    var $$x1 = $n(transformMemberNames).apply__O__O("details");
                                    var this$1 = $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFordetails);
                                    var array = [$$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordetails)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("entryNumber"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForentryNumber).apply__O__Lio_circe_Json(circeGenericHListBindingForentryNumber)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("category"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderForcategory).apply__O__Lio_circe_Json(circeGenericHListBindingForcategory)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("deletedAt"), $n(this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericEncoderFordeletedAt).apply__O__Lio_circe_Json(circeGenericHListBindingFordeletedAt))];
                                    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                                    return $n($$x14).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("file"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForfile, "file", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("notDone"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFornotDone, "notDone", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("supplier"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForsupplierOffice, "supplier", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("supplierOffice"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForsupplierOffice, "supplierOffice", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForreference, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("pageIndex"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForentryNumber, "pageIndex", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("pageCount"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForentryNumber, "pageCount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("amount"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFortotalAmount, "amount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("totalAmount"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFortotalAmount, "totalAmount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("details"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFordetails, "details", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("entryNumber"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForentryNumber, "entryNumber", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("category"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderForcategory, "category", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("deletedAt"))), this.Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7__f_circeGenericDecoderFordeletedAt, "deletedAt", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7: 0
}, false, "reactbuild.model.InvoicePage$anon$lazy$macro$131$1$$anon$7", {
  Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7.prototype.$classData = $d_Lreactbuild_model_InvoicePage$anon$lazy$macro$131$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6(outer) {
  this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6__f_circeGenericDecoderForpath = null;
  this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6__f_circeGenericEncoderForpath = null;
  this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6__f_circeGenericDecoderForpath = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6__f_circeGenericEncoderForpath = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6.prototype.constructor = $c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6;
/** @constructor */
function $h_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6.prototype = $c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6.prototype;
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForpath = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("path"), $n(this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6__f_circeGenericEncoderForpath).apply__O__Lio_circe_Json(circeGenericHListBindingForpath))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("path"))), this.Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6__f_circeGenericDecoderForpath, "path", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6 = new $TypeData().initClass({
  Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6: 0
}, false, "reactbuild.model.InvoicePageFile$anon$lazy$macro$11$2$$anon$6", {
  Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6.prototype.$classData = $d_Lreactbuild_model_InvoicePageFile$anon$lazy$macro$11$2$$anon$6;
/** @constructor */
function $c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8(outer) {
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForsupplier = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForentryNumber = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForreference = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForpages = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForexpectedAmount = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForreceived = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForcategory = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForsupplier = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForentryNumber = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForreference = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForpages = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForexpectedAmount = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForreceived = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForcategory = null;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForsupplier = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderFordate = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForentryNumber = new $c_Lio_circe_Decoder$$anon$39(d$2);
  $m_Lio_circe_Decoder$();
  var d$3 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForreference = new $c_Lio_circe_Decoder$$anon$39(d$3);
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForpages = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  $m_Lio_circe_Decoder$();
  var d$4 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForexpectedAmount = new $c_Lio_circe_Decoder$$anon$39(d$4);
  $m_Lio_circe_Decoder$();
  var d$5 = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForreceived = new $c_Lio_circe_Decoder$$anon$39(d$5);
  $m_Lio_circe_Decoder$();
  var d$6 = $m_Lreactbuild_model_DocumentCategory$().Lreactbuild_model_DocumentCategory$__f_decodeDocumentCategory;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForcategory = new $c_Lio_circe_Decoder$$anon$39(d$6);
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForsupplier = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderFordate = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForentryNumber = new $c_Lio_circe_Encoder$$anon$21(e$2);
  $m_Lio_circe_Encoder$();
  var e$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForreference = new $c_Lio_circe_Encoder$$anon$21(e$3);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_InvoicePage$().Lreactbuild_model_InvoicePage$__f_codecForInvoicePage;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForpages = new $c_Lio_circe_Encoder$$anon$23(encodeA);
  $m_Lio_circe_Encoder$();
  var e$4 = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForexpectedAmount = new $c_Lio_circe_Encoder$$anon$21(e$4);
  $m_Lio_circe_Encoder$();
  var e$5 = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForreceived = new $c_Lio_circe_Encoder$$anon$21(e$5);
  $m_Lio_circe_Encoder$();
  var e$6 = $m_Lreactbuild_model_DocumentCategory$().Lreactbuild_model_DocumentCategory$__f_encodeDocumentCategory;
  this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForcategory = new $c_Lio_circe_Encoder$$anon$21(e$6)
}
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8.prototype.constructor = $c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8;
/** @constructor */
function $h_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8.prototype = $c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8.prototype;
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForsupplier = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFordate = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForentryNumber = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForreference = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForpages = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingFortotalAmount = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForexpectedAmount = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                  if ((p9 !== null)) {
                    var circeGenericHListBindingForreceived = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                    var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                    if ((p10 !== null)) {
                      var circeGenericHListBindingForcategory = $as_s_Option($n(p10).Lshapeless_$colon$colon__f_head);
                      var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p11)) {
                        var $$x7 = $m_Lio_circe_JsonObject$();
                        var this$5 = $m_sci_Vector$();
                        var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization));
                        var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("supplier"), $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForsupplier).apply__O__Lio_circe_Json(circeGenericHListBindingForsupplier));
                        var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate));
                        var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("entryNumber"), $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForentryNumber).apply__O__Lio_circe_Json(circeGenericHListBindingForentryNumber));
                        var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForreference).apply__O__Lio_circe_Json(circeGenericHListBindingForreference));
                        var $$x1 = $n(transformMemberNames).apply__O__O("pages");
                        var this$1 = $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForpages);
                        var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForpages)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("totalAmount"), $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForexpectedAmount).apply__O__Lio_circe_Json(circeGenericHListBindingFortotalAmount)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("expectedAmount"), $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForexpectedAmount).apply__O__Lio_circe_Json(circeGenericHListBindingForexpectedAmount)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("received"), $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForreceived).apply__O__Lio_circe_Json(circeGenericHListBindingForreceived)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("category"), $n(this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericEncoderForcategory).apply__O__Lio_circe_Json(circeGenericHListBindingForcategory))];
                        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                        return $n($$x7).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("supplier"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForsupplier, "supplier", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("entryNumber"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForentryNumber, "entryNumber", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForreference, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("pages"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForpages, "pages", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("totalAmount"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForexpectedAmount, "totalAmount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("expectedAmount"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForexpectedAmount, "expectedAmount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("received"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForreceived, "received", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("category"))), this.Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8__f_circeGenericDecoderForcategory, "category", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8 = new $TypeData().initClass({
  Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8: 0
}, false, "reactbuild.model.InvoicePageGroup$anon$lazy$macro$83$1$$anon$8", {
  Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8.prototype.$classData = $d_Lreactbuild_model_InvoicePageGroup$anon$lazy$macro$83$1$$anon$8;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63(outer) {
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForentry = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForcreated = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForuser = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForbody = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForentry = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForcreated = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForuser = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForbody = null;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForentry = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForcreated = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForuser = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForbody = $m_Lreactbuild_model_ListEntryEventBody$().Lreactbuild_model_ListEntryEventBody$__f_codecForListEntryEventBody;
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForentry = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForcreated = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForuser = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForbody = $m_Lreactbuild_model_ListEntryEventBody$().Lreactbuild_model_ListEntryEventBody$__f_codecForListEntryEventBody
}
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63.prototype.constructor = $c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63.prototype = $c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63.prototype;
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForentry = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForcreated = $as_Ljava_time_Instant($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForuser = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForbody = $as_Lreactbuild_model_ListEntryEventBody($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x6 = $m_Lio_circe_JsonObject$();
              var this$5 = $m_sci_Vector$();
              var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
              var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("entry"), $n(this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForentry).apply__O__Lio_circe_Json(circeGenericHListBindingForentry));
              var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("created"), $n(this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForcreated).apply__O__Lio_circe_Json(circeGenericHListBindingForcreated));
              var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("user"), $n(this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForuser).apply__O__Lio_circe_Json(circeGenericHListBindingForuser));
              var $$x1 = $n(transformMemberNames).apply__O__O("body");
              var this$1 = $n(this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericEncoderForbody);
              var array = [$$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForbody))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x6).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("entry"))), this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForentry, "entry", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("created"))), this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForcreated, "created", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("user"))), this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForuser, "user", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("body"))), this.Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63__f_circeGenericDecoderForbody, "body", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63: 0
}, false, "reactbuild.model.ListEntryEvent$anon$lazy$macro$43$7$$anon$63", {
  Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63.prototype.$classData = $d_Lreactbuild_model_ListEntryEvent$anon$lazy$macro$43$7$$anon$63;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64(outer) {
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForApproved = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForChangeTitle = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForComment = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForCompliant = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForDone = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForFollowed = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForIgnored = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForInStock = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForNeedMoreDetails = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForNonCompliant = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForNotApplicable = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForOrdered = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForPending = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForPickup = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForRead = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForReceived = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForRejected = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForReset = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForShipped = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForTermAdded = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForTermRemoved = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForApproved = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForChangeTitle = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForComment = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForCompliant = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForDone = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForFollowed = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForIgnored = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForInStock = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForNeedMoreDetails = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForNonCompliant = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForNotApplicable = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForOrdered = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForPending = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForPickup = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForRead = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForReceived = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForRejected = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForReset = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForShipped = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForTermAdded = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForTermRemoved = null;
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$92__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForApproved = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$82__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForChangeTitle = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$73__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForComment = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$72__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForCompliant = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$71__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForDone = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$70__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForFollowed = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$69__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForIgnored = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$68__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForInStock = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O());
  var t$8 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$58__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForNeedMoreDetails = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$8).value__O());
  var t$9 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$49__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForNonCompliant = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$9).value__O());
  var t$10 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$40__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForNotApplicable = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$10).value__O());
  var t$11 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$39__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForOrdered = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$11).value__O());
  var t$12 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$38__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForPending = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$12).value__O());
  var t$13 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$37__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForPickup = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$13).value__O());
  var t$14 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$36__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForRead = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$14).value__O());
  var t$15 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$35__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForReceived = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$15).value__O());
  var t$16 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$25__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForRejected = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$16).value__O());
  var t$17 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$24__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForReset = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$17).value__O());
  var t$18 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$22__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForShipped = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$18).value__O());
  var t$19 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForTermAdded = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$19).value__O());
  var t$20 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForTermRemoved = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$20).value__O());
  var t$21 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$182__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForApproved = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$21).value__O());
  var t$22 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$172__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForChangeTitle = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$22).value__O());
  var t$23 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$163__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForComment = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$23).value__O());
  var t$24 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$162__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForCompliant = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$24).value__O());
  var t$25 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$161__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForDone = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$25).value__O());
  var t$26 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$160__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForFollowed = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$26).value__O());
  var t$27 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$159__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForIgnored = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$27).value__O());
  var t$28 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$158__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForInStock = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$28).value__O());
  var t$29 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$148__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForNeedMoreDetails = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$29).value__O());
  var t$30 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$139__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForNonCompliant = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$30).value__O());
  var t$31 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$130__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForNotApplicable = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$31).value__O());
  var t$32 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$129__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForOrdered = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$32).value__O());
  var t$33 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$128__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForPending = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$33).value__O());
  var t$34 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$127__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForPickup = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$34).value__O());
  var t$35 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$126__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForRead = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$35).value__O());
  var t$36 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$125__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForReceived = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$36).value__O());
  var t$37 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$115__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForRejected = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$37).value__O());
  var t$38 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$114__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForReset = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$38).value__O());
  var t$39 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$112__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForShipped = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$39).value__O());
  var t$40 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$103__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForTermAdded = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$40).value__O());
  var t$41 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_$outer).inst$macro$93__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForTermRemoved = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$41).value__O())
}
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64.prototype = $c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64.prototype;
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForApproved = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForApproved instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForApproved);
    var circeGenericInlBindingForApproved = $as_Lreactbuild_model_ListEntryEventBody$Approved$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForApproved;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Approved"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForApproved, name, discriminator)
  } else if ((circeGenericInrBindingForApproved instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForApproved);
    var circeGenericInrBindingForChangeTitle = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForChangeTitle instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForChangeTitle);
      var circeGenericInlBindingForChangeTitle = $as_Lreactbuild_model_ListEntryEventBody$ChangeTitle($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForChangeTitle;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("ChangeTitle"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForChangeTitle, name$1, discriminator)
    } else if ((circeGenericInrBindingForChangeTitle instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForChangeTitle);
      var circeGenericInrBindingForComment = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForComment instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForComment);
        var circeGenericInlBindingForComment = $as_Lreactbuild_model_ListEntryEventBody$Comment($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForComment;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Comment"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForComment, name$2, discriminator)
      } else if ((circeGenericInrBindingForComment instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForComment);
        var circeGenericInrBindingForCompliant = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForCompliant instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForCompliant);
          var circeGenericInlBindingForCompliant = $as_Lreactbuild_model_ListEntryEventBody$Compliant$($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForCompliant;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("Compliant"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForCompliant, name$3, discriminator)
        } else if ((circeGenericInrBindingForCompliant instanceof $c_Lshapeless_Inr)) {
          var x3$4 = $as_Lshapeless_Inr(circeGenericInrBindingForCompliant);
          var circeGenericInrBindingForDone = $as_Lshapeless_$colon$plus$colon($n(x3$4).Lshapeless_Inr__f_tail);
          if ((circeGenericInrBindingForDone instanceof $c_Lshapeless_Inl)) {
            var x2$5 = $as_Lshapeless_Inl(circeGenericInrBindingForDone);
            var circeGenericInlBindingForDone = $as_Lreactbuild_model_ListEntryEventBody$Done$($n(x2$5).Lshapeless_Inl__f_head);
            var encode$4 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForDone;
            var name$4 = $as_T($n(transformConstructorNames).apply__O__O("Done"));
            return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$4, circeGenericInlBindingForDone, name$4, discriminator)
          } else if ((circeGenericInrBindingForDone instanceof $c_Lshapeless_Inr)) {
            var x3$5 = $as_Lshapeless_Inr(circeGenericInrBindingForDone);
            var circeGenericInrBindingForFollowed = $as_Lshapeless_$colon$plus$colon($n(x3$5).Lshapeless_Inr__f_tail);
            if ((circeGenericInrBindingForFollowed instanceof $c_Lshapeless_Inl)) {
              var x2$6 = $as_Lshapeless_Inl(circeGenericInrBindingForFollowed);
              var circeGenericInlBindingForFollowed = $as_Lreactbuild_model_ListEntryEventBody$Followed$($n(x2$6).Lshapeless_Inl__f_head);
              var encode$5 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForFollowed;
              var name$5 = $as_T($n(transformConstructorNames).apply__O__O("Followed"));
              return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$5, circeGenericInlBindingForFollowed, name$5, discriminator)
            } else if ((circeGenericInrBindingForFollowed instanceof $c_Lshapeless_Inr)) {
              var x3$6 = $as_Lshapeless_Inr(circeGenericInrBindingForFollowed);
              var circeGenericInrBindingForIgnored = $as_Lshapeless_$colon$plus$colon($n(x3$6).Lshapeless_Inr__f_tail);
              if ((circeGenericInrBindingForIgnored instanceof $c_Lshapeless_Inl)) {
                var x2$7 = $as_Lshapeless_Inl(circeGenericInrBindingForIgnored);
                var circeGenericInlBindingForIgnored = $as_Lreactbuild_model_ListEntryEventBody$Ignored$($n(x2$7).Lshapeless_Inl__f_head);
                var encode$6 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForIgnored;
                var name$6 = $as_T($n(transformConstructorNames).apply__O__O("Ignored"));
                return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$6, circeGenericInlBindingForIgnored, name$6, discriminator)
              } else if ((circeGenericInrBindingForIgnored instanceof $c_Lshapeless_Inr)) {
                var x3$7 = $as_Lshapeless_Inr(circeGenericInrBindingForIgnored);
                var circeGenericInrBindingForInStock = $as_Lshapeless_$colon$plus$colon($n(x3$7).Lshapeless_Inr__f_tail);
                if ((circeGenericInrBindingForInStock instanceof $c_Lshapeless_Inl)) {
                  var x2$8 = $as_Lshapeless_Inl(circeGenericInrBindingForInStock);
                  var circeGenericInlBindingForInStock = $as_Lreactbuild_model_ListEntryEventBody$InStock$($n(x2$8).Lshapeless_Inl__f_head);
                  var encode$7 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForInStock;
                  var name$7 = $as_T($n(transformConstructorNames).apply__O__O("InStock"));
                  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$7, circeGenericInlBindingForInStock, name$7, discriminator)
                } else if ((circeGenericInrBindingForInStock instanceof $c_Lshapeless_Inr)) {
                  var x3$8 = $as_Lshapeless_Inr(circeGenericInrBindingForInStock);
                  var circeGenericInrBindingForNeedMoreDetails = $as_Lshapeless_$colon$plus$colon($n(x3$8).Lshapeless_Inr__f_tail);
                  if ((circeGenericInrBindingForNeedMoreDetails instanceof $c_Lshapeless_Inl)) {
                    var x2$9 = $as_Lshapeless_Inl(circeGenericInrBindingForNeedMoreDetails);
                    var circeGenericInlBindingForNeedMoreDetails = $as_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails($n(x2$9).Lshapeless_Inl__f_head);
                    var encode$8 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForNeedMoreDetails;
                    var name$8 = $as_T($n(transformConstructorNames).apply__O__O("NeedMoreDetails"));
                    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$8, circeGenericInlBindingForNeedMoreDetails, name$8, discriminator)
                  } else if ((circeGenericInrBindingForNeedMoreDetails instanceof $c_Lshapeless_Inr)) {
                    var x3$9 = $as_Lshapeless_Inr(circeGenericInrBindingForNeedMoreDetails);
                    var circeGenericInrBindingForNonCompliant = $as_Lshapeless_$colon$plus$colon($n(x3$9).Lshapeless_Inr__f_tail);
                    if ((circeGenericInrBindingForNonCompliant instanceof $c_Lshapeless_Inl)) {
                      var x2$10 = $as_Lshapeless_Inl(circeGenericInrBindingForNonCompliant);
                      var circeGenericInlBindingForNonCompliant = $as_Lreactbuild_model_ListEntryEventBody$NonCompliant($n(x2$10).Lshapeless_Inl__f_head);
                      var encode$9 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForNonCompliant;
                      var name$9 = $as_T($n(transformConstructorNames).apply__O__O("NonCompliant"));
                      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$9, circeGenericInlBindingForNonCompliant, name$9, discriminator)
                    } else if ((circeGenericInrBindingForNonCompliant instanceof $c_Lshapeless_Inr)) {
                      var x3$10 = $as_Lshapeless_Inr(circeGenericInrBindingForNonCompliant);
                      var circeGenericInrBindingForNotApplicable = $as_Lshapeless_$colon$plus$colon($n(x3$10).Lshapeless_Inr__f_tail);
                      if ((circeGenericInrBindingForNotApplicable instanceof $c_Lshapeless_Inl)) {
                        var x2$11 = $as_Lshapeless_Inl(circeGenericInrBindingForNotApplicable);
                        var circeGenericInlBindingForNotApplicable = $as_Lreactbuild_model_ListEntryEventBody$NotApplicable($n(x2$11).Lshapeless_Inl__f_head);
                        var encode$10 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForNotApplicable;
                        var name$10 = $as_T($n(transformConstructorNames).apply__O__O("NotApplicable"));
                        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$10, circeGenericInlBindingForNotApplicable, name$10, discriminator)
                      } else if ((circeGenericInrBindingForNotApplicable instanceof $c_Lshapeless_Inr)) {
                        var x3$11 = $as_Lshapeless_Inr(circeGenericInrBindingForNotApplicable);
                        var circeGenericInrBindingForOrdered = $as_Lshapeless_$colon$plus$colon($n(x3$11).Lshapeless_Inr__f_tail);
                        if ((circeGenericInrBindingForOrdered instanceof $c_Lshapeless_Inl)) {
                          var x2$12 = $as_Lshapeless_Inl(circeGenericInrBindingForOrdered);
                          var circeGenericInlBindingForOrdered = $as_Lreactbuild_model_ListEntryEventBody$Ordered$($n(x2$12).Lshapeless_Inl__f_head);
                          var encode$11 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForOrdered;
                          var name$11 = $as_T($n(transformConstructorNames).apply__O__O("Ordered"));
                          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$11, circeGenericInlBindingForOrdered, name$11, discriminator)
                        } else if ((circeGenericInrBindingForOrdered instanceof $c_Lshapeless_Inr)) {
                          var x3$12 = $as_Lshapeless_Inr(circeGenericInrBindingForOrdered);
                          var circeGenericInrBindingForPending = $as_Lshapeless_$colon$plus$colon($n(x3$12).Lshapeless_Inr__f_tail);
                          if ((circeGenericInrBindingForPending instanceof $c_Lshapeless_Inl)) {
                            var x2$13 = $as_Lshapeless_Inl(circeGenericInrBindingForPending);
                            var circeGenericInlBindingForPending = $as_Lreactbuild_model_ListEntryEventBody$Pending$($n(x2$13).Lshapeless_Inl__f_head);
                            var encode$12 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForPending;
                            var name$12 = $as_T($n(transformConstructorNames).apply__O__O("Pending"));
                            return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$12, circeGenericInlBindingForPending, name$12, discriminator)
                          } else if ((circeGenericInrBindingForPending instanceof $c_Lshapeless_Inr)) {
                            var x3$13 = $as_Lshapeless_Inr(circeGenericInrBindingForPending);
                            var circeGenericInrBindingForPickup = $as_Lshapeless_$colon$plus$colon($n(x3$13).Lshapeless_Inr__f_tail);
                            if ((circeGenericInrBindingForPickup instanceof $c_Lshapeless_Inl)) {
                              var x2$14 = $as_Lshapeless_Inl(circeGenericInrBindingForPickup);
                              var circeGenericInlBindingForPickup = $as_Lreactbuild_model_ListEntryEventBody$Pickup$($n(x2$14).Lshapeless_Inl__f_head);
                              var encode$13 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForPickup;
                              var name$13 = $as_T($n(transformConstructorNames).apply__O__O("Pickup"));
                              return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$13, circeGenericInlBindingForPickup, name$13, discriminator)
                            } else if ((circeGenericInrBindingForPickup instanceof $c_Lshapeless_Inr)) {
                              var x3$14 = $as_Lshapeless_Inr(circeGenericInrBindingForPickup);
                              var circeGenericInrBindingForRead = $as_Lshapeless_$colon$plus$colon($n(x3$14).Lshapeless_Inr__f_tail);
                              if ((circeGenericInrBindingForRead instanceof $c_Lshapeless_Inl)) {
                                var x2$15 = $as_Lshapeless_Inl(circeGenericInrBindingForRead);
                                var circeGenericInlBindingForRead = $as_Lreactbuild_model_ListEntryEventBody$Read$($n(x2$15).Lshapeless_Inl__f_head);
                                var encode$14 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForRead;
                                var name$14 = $as_T($n(transformConstructorNames).apply__O__O("Read"));
                                return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$14, circeGenericInlBindingForRead, name$14, discriminator)
                              } else if ((circeGenericInrBindingForRead instanceof $c_Lshapeless_Inr)) {
                                var x3$15 = $as_Lshapeless_Inr(circeGenericInrBindingForRead);
                                var circeGenericInrBindingForReceived = $as_Lshapeless_$colon$plus$colon($n(x3$15).Lshapeless_Inr__f_tail);
                                if ((circeGenericInrBindingForReceived instanceof $c_Lshapeless_Inl)) {
                                  var x2$16 = $as_Lshapeless_Inl(circeGenericInrBindingForReceived);
                                  var circeGenericInlBindingForReceived = $as_Lreactbuild_model_ListEntryEventBody$Received$($n(x2$16).Lshapeless_Inl__f_head);
                                  var encode$15 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForReceived;
                                  var name$15 = $as_T($n(transformConstructorNames).apply__O__O("Received"));
                                  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$15, circeGenericInlBindingForReceived, name$15, discriminator)
                                } else if ((circeGenericInrBindingForReceived instanceof $c_Lshapeless_Inr)) {
                                  var x3$16 = $as_Lshapeless_Inr(circeGenericInrBindingForReceived);
                                  var circeGenericInrBindingForRejected = $as_Lshapeless_$colon$plus$colon($n(x3$16).Lshapeless_Inr__f_tail);
                                  if ((circeGenericInrBindingForRejected instanceof $c_Lshapeless_Inl)) {
                                    var x2$17 = $as_Lshapeless_Inl(circeGenericInrBindingForRejected);
                                    var circeGenericInlBindingForRejected = $as_Lreactbuild_model_ListEntryEventBody$Rejected($n(x2$17).Lshapeless_Inl__f_head);
                                    var encode$16 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForRejected;
                                    var name$16 = $as_T($n(transformConstructorNames).apply__O__O("Rejected"));
                                    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$16, circeGenericInlBindingForRejected, name$16, discriminator)
                                  } else if ((circeGenericInrBindingForRejected instanceof $c_Lshapeless_Inr)) {
                                    var x3$17 = $as_Lshapeless_Inr(circeGenericInrBindingForRejected);
                                    var circeGenericInrBindingForReset = $as_Lshapeless_$colon$plus$colon($n(x3$17).Lshapeless_Inr__f_tail);
                                    if ((circeGenericInrBindingForReset instanceof $c_Lshapeless_Inl)) {
                                      var x2$18 = $as_Lshapeless_Inl(circeGenericInrBindingForReset);
                                      var circeGenericInlBindingForReset = $as_Lreactbuild_model_ListEntryEventBody$Reset$($n(x2$18).Lshapeless_Inl__f_head);
                                      var encode$17 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForReset;
                                      var name$17 = $as_T($n(transformConstructorNames).apply__O__O("Reset"));
                                      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$17, circeGenericInlBindingForReset, name$17, discriminator)
                                    } else if ((circeGenericInrBindingForReset instanceof $c_Lshapeless_Inr)) {
                                      var x3$18 = $as_Lshapeless_Inr(circeGenericInrBindingForReset);
                                      var circeGenericInrBindingForShipped = $as_Lshapeless_$colon$plus$colon($n(x3$18).Lshapeless_Inr__f_tail);
                                      if ((circeGenericInrBindingForShipped instanceof $c_Lshapeless_Inl)) {
                                        var x2$19 = $as_Lshapeless_Inl(circeGenericInrBindingForShipped);
                                        var circeGenericInlBindingForShipped = $as_Lreactbuild_model_ListEntryEventBody$Shipped$($n(x2$19).Lshapeless_Inl__f_head);
                                        var encode$18 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForShipped;
                                        var name$18 = $as_T($n(transformConstructorNames).apply__O__O("Shipped"));
                                        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$18, circeGenericInlBindingForShipped, name$18, discriminator)
                                      } else if ((circeGenericInrBindingForShipped instanceof $c_Lshapeless_Inr)) {
                                        var x3$19 = $as_Lshapeless_Inr(circeGenericInrBindingForShipped);
                                        var circeGenericInrBindingForTermAdded = $as_Lshapeless_$colon$plus$colon($n(x3$19).Lshapeless_Inr__f_tail);
                                        if ((circeGenericInrBindingForTermAdded instanceof $c_Lshapeless_Inl)) {
                                          var x2$20 = $as_Lshapeless_Inl(circeGenericInrBindingForTermAdded);
                                          var circeGenericInlBindingForTermAdded = $as_Lreactbuild_model_ListEntryEventBody$TermAdded($n(x2$20).Lshapeless_Inl__f_head);
                                          var encode$19 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForTermAdded;
                                          var name$19 = $as_T($n(transformConstructorNames).apply__O__O("TermAdded"));
                                          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$19, circeGenericInlBindingForTermAdded, name$19, discriminator)
                                        } else if ((circeGenericInrBindingForTermAdded instanceof $c_Lshapeless_Inr)) {
                                          var x3$20 = $as_Lshapeless_Inr(circeGenericInrBindingForTermAdded);
                                          var circeGenericInrBindingForTermRemoved = $as_Lshapeless_$colon$plus$colon($n(x3$20).Lshapeless_Inr__f_tail);
                                          if ((circeGenericInrBindingForTermRemoved instanceof $c_Lshapeless_Inl)) {
                                            var x2$21 = $as_Lshapeless_Inl(circeGenericInrBindingForTermRemoved);
                                            var circeGenericInlBindingForTermRemoved = $as_Lreactbuild_model_ListEntryEventBody$TermRemoved($n(x2$21).Lshapeless_Inl__f_head);
                                            var encode$20 = this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericEncoderForTermRemoved;
                                            var name$20 = $as_T($n(transformConstructorNames).apply__O__O("TermRemoved"));
                                            return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$20, circeGenericInlBindingForTermRemoved, name$20, discriminator)
                                          } else if ((circeGenericInrBindingForTermRemoved instanceof $c_Lshapeless_Inr)) {
                                            $m_s_sys_package$().error__T__E("Cannot encode CNil")
                                          } else {
                                            throw new $c_s_MatchError(circeGenericInrBindingForTermRemoved)
                                          }
                                        } else {
                                          throw new $c_s_MatchError(circeGenericInrBindingForTermAdded)
                                        }
                                      } else {
                                        throw new $c_s_MatchError(circeGenericInrBindingForShipped)
                                      }
                                    } else {
                                      throw new $c_s_MatchError(circeGenericInrBindingForReset)
                                    }
                                  } else {
                                    throw new $c_s_MatchError(circeGenericInrBindingForRejected)
                                  }
                                } else {
                                  throw new $c_s_MatchError(circeGenericInrBindingForReceived)
                                }
                              } else {
                                throw new $c_s_MatchError(circeGenericInrBindingForRead)
                              }
                            } else {
                              throw new $c_s_MatchError(circeGenericInrBindingForPickup)
                            }
                          } else {
                            throw new $c_s_MatchError(circeGenericInrBindingForPending)
                          }
                        } else {
                          throw new $c_s_MatchError(circeGenericInrBindingForOrdered)
                        }
                      } else {
                        throw new $c_s_MatchError(circeGenericInrBindingForNotApplicable)
                      }
                    } else {
                      throw new $c_s_MatchError(circeGenericInrBindingForNonCompliant)
                    }
                  } else {
                    throw new $c_s_MatchError(circeGenericInrBindingForNeedMoreDetails)
                  }
                } else {
                  throw new $c_s_MatchError(circeGenericInrBindingForInStock)
                }
              } else {
                throw new $c_s_MatchError(circeGenericInrBindingForIgnored)
              }
            } else {
              throw new $c_s_MatchError(circeGenericInrBindingForFollowed)
            }
          } else {
            throw new $c_s_MatchError(circeGenericInrBindingForDone)
          }
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForCompliant)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForComment)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForChangeTitle)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForApproved)
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForApproved, c, $as_T($n(transformConstructorNames).apply__O__O("Approved")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_ListEntryEventBody$Approved$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForChangeTitle, c, $as_T($n(transformConstructorNames).apply__O__O("ChangeTitle")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_ListEntryEventBody$ChangeTitle($n(x2$4).s_util_Right__f_value);
          var x1$63 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$63 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForComment, c, $as_T($n(transformConstructorNames).apply__O__O("Comment")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_model_ListEntryEventBody$Comment($n(x2$6).s_util_Right__f_value);
            var x1$62 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$62 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForCompliant, c, $as_T($n(transformConstructorNames).apply__O__O("Compliant")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_model_ListEntryEventBody$Compliant$($n(x2$8).s_util_Right__f_value);
              var x1$61 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$61 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            var x1$9 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForDone, c, $as_T($n(transformConstructorNames).apply__O__O("Done")), discriminator);
            if ((x1$9 instanceof $c_s_Some)) {
              var x2$9 = $as_s_Some(x1$9);
              var result$5 = $as_s_util_Either($n(x2$9).s_Some__f_value);
              if ((result$5 instanceof $c_s_util_Right)) {
                var x2$10 = $as_s_util_Right(result$5);
                var v$5 = $as_Lreactbuild_model_ListEntryEventBody$Done$($n(x2$10).s_util_Right__f_value);
                var x1$60 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$5))
              } else {
                if ((!(result$5 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(result$5)
                };
                var x3$5 = $as_s_util_Left(result$5);
                var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
                var x1$60 = new $c_s_util_Left(err$5)
              }
            } else {
              var x$9 = $m_s_None$();
              if ((!(x$9 === x1$9))) {
                throw new $c_s_MatchError(x1$9)
              };
              var x1$11 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForFollowed, c, $as_T($n(transformConstructorNames).apply__O__O("Followed")), discriminator);
              if ((x1$11 instanceof $c_s_Some)) {
                var x2$11 = $as_s_Some(x1$11);
                var result$6 = $as_s_util_Either($n(x2$11).s_Some__f_value);
                if ((result$6 instanceof $c_s_util_Right)) {
                  var x2$12 = $as_s_util_Right(result$6);
                  var v$6 = $as_Lreactbuild_model_ListEntryEventBody$Followed$($n(x2$12).s_util_Right__f_value);
                  var x1$59 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$6))
                } else {
                  if ((!(result$6 instanceof $c_s_util_Left))) {
                    throw new $c_s_MatchError(result$6)
                  };
                  var x3$6 = $as_s_util_Left(result$6);
                  var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
                  var x1$59 = new $c_s_util_Left(err$6)
                }
              } else {
                var x$11 = $m_s_None$();
                if ((!(x$11 === x1$11))) {
                  throw new $c_s_MatchError(x1$11)
                };
                var x1$13 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForIgnored, c, $as_T($n(transformConstructorNames).apply__O__O("Ignored")), discriminator);
                if ((x1$13 instanceof $c_s_Some)) {
                  var x2$13 = $as_s_Some(x1$13);
                  var result$7 = $as_s_util_Either($n(x2$13).s_Some__f_value);
                  if ((result$7 instanceof $c_s_util_Right)) {
                    var x2$14 = $as_s_util_Right(result$7);
                    var v$7 = $as_Lreactbuild_model_ListEntryEventBody$Ignored$($n(x2$14).s_util_Right__f_value);
                    var x1$58 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$7))
                  } else {
                    if ((!(result$7 instanceof $c_s_util_Left))) {
                      throw new $c_s_MatchError(result$7)
                    };
                    var x3$7 = $as_s_util_Left(result$7);
                    var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
                    var x1$58 = new $c_s_util_Left(err$7)
                  }
                } else {
                  var x$13 = $m_s_None$();
                  if ((!(x$13 === x1$13))) {
                    throw new $c_s_MatchError(x1$13)
                  };
                  var x1$15 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForInStock, c, $as_T($n(transformConstructorNames).apply__O__O("InStock")), discriminator);
                  if ((x1$15 instanceof $c_s_Some)) {
                    var x2$15 = $as_s_Some(x1$15);
                    var result$8 = $as_s_util_Either($n(x2$15).s_Some__f_value);
                    if ((result$8 instanceof $c_s_util_Right)) {
                      var x2$16 = $as_s_util_Right(result$8);
                      var v$8 = $as_Lreactbuild_model_ListEntryEventBody$InStock$($n(x2$16).s_util_Right__f_value);
                      var x1$57 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$8))
                    } else {
                      if ((!(result$8 instanceof $c_s_util_Left))) {
                        throw new $c_s_MatchError(result$8)
                      };
                      var x3$8 = $as_s_util_Left(result$8);
                      var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
                      var x1$57 = new $c_s_util_Left(err$8)
                    }
                  } else {
                    var x$15 = $m_s_None$();
                    if ((!(x$15 === x1$15))) {
                      throw new $c_s_MatchError(x1$15)
                    };
                    var x1$17 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForNeedMoreDetails, c, $as_T($n(transformConstructorNames).apply__O__O("NeedMoreDetails")), discriminator);
                    if ((x1$17 instanceof $c_s_Some)) {
                      var x2$17 = $as_s_Some(x1$17);
                      var result$9 = $as_s_util_Either($n(x2$17).s_Some__f_value);
                      if ((result$9 instanceof $c_s_util_Right)) {
                        var x2$18 = $as_s_util_Right(result$9);
                        var v$9 = $as_Lreactbuild_model_ListEntryEventBody$NeedMoreDetails($n(x2$18).s_util_Right__f_value);
                        var x1$56 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$9))
                      } else {
                        if ((!(result$9 instanceof $c_s_util_Left))) {
                          throw new $c_s_MatchError(result$9)
                        };
                        var x3$9 = $as_s_util_Left(result$9);
                        var err$9 = $as_Lio_circe_DecodingFailure($n(x3$9).s_util_Left__f_value);
                        var x1$56 = new $c_s_util_Left(err$9)
                      }
                    } else {
                      var x$17 = $m_s_None$();
                      if ((!(x$17 === x1$17))) {
                        throw new $c_s_MatchError(x1$17)
                      };
                      var x1$19 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForNonCompliant, c, $as_T($n(transformConstructorNames).apply__O__O("NonCompliant")), discriminator);
                      if ((x1$19 instanceof $c_s_Some)) {
                        var x2$19 = $as_s_Some(x1$19);
                        var result$10 = $as_s_util_Either($n(x2$19).s_Some__f_value);
                        if ((result$10 instanceof $c_s_util_Right)) {
                          var x2$20 = $as_s_util_Right(result$10);
                          var v$10 = $as_Lreactbuild_model_ListEntryEventBody$NonCompliant($n(x2$20).s_util_Right__f_value);
                          var x1$55 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$10))
                        } else {
                          if ((!(result$10 instanceof $c_s_util_Left))) {
                            throw new $c_s_MatchError(result$10)
                          };
                          var x3$10 = $as_s_util_Left(result$10);
                          var err$10 = $as_Lio_circe_DecodingFailure($n(x3$10).s_util_Left__f_value);
                          var x1$55 = new $c_s_util_Left(err$10)
                        }
                      } else {
                        var x$19 = $m_s_None$();
                        if ((!(x$19 === x1$19))) {
                          throw new $c_s_MatchError(x1$19)
                        };
                        var x1$21 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForNotApplicable, c, $as_T($n(transformConstructorNames).apply__O__O("NotApplicable")), discriminator);
                        if ((x1$21 instanceof $c_s_Some)) {
                          var x2$21 = $as_s_Some(x1$21);
                          var result$11 = $as_s_util_Either($n(x2$21).s_Some__f_value);
                          if ((result$11 instanceof $c_s_util_Right)) {
                            var x2$22 = $as_s_util_Right(result$11);
                            var v$11 = $as_Lreactbuild_model_ListEntryEventBody$NotApplicable($n(x2$22).s_util_Right__f_value);
                            var x1$54 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$11))
                          } else {
                            if ((!(result$11 instanceof $c_s_util_Left))) {
                              throw new $c_s_MatchError(result$11)
                            };
                            var x3$11 = $as_s_util_Left(result$11);
                            var err$11 = $as_Lio_circe_DecodingFailure($n(x3$11).s_util_Left__f_value);
                            var x1$54 = new $c_s_util_Left(err$11)
                          }
                        } else {
                          var x$21 = $m_s_None$();
                          if ((!(x$21 === x1$21))) {
                            throw new $c_s_MatchError(x1$21)
                          };
                          var x1$23 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForOrdered, c, $as_T($n(transformConstructorNames).apply__O__O("Ordered")), discriminator);
                          if ((x1$23 instanceof $c_s_Some)) {
                            var x2$23 = $as_s_Some(x1$23);
                            var result$12 = $as_s_util_Either($n(x2$23).s_Some__f_value);
                            if ((result$12 instanceof $c_s_util_Right)) {
                              var x2$24 = $as_s_util_Right(result$12);
                              var v$12 = $as_Lreactbuild_model_ListEntryEventBody$Ordered$($n(x2$24).s_util_Right__f_value);
                              var x1$53 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$12))
                            } else {
                              if ((!(result$12 instanceof $c_s_util_Left))) {
                                throw new $c_s_MatchError(result$12)
                              };
                              var x3$12 = $as_s_util_Left(result$12);
                              var err$12 = $as_Lio_circe_DecodingFailure($n(x3$12).s_util_Left__f_value);
                              var x1$53 = new $c_s_util_Left(err$12)
                            }
                          } else {
                            var x$23 = $m_s_None$();
                            if ((!(x$23 === x1$23))) {
                              throw new $c_s_MatchError(x1$23)
                            };
                            var x1$25 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForPending, c, $as_T($n(transformConstructorNames).apply__O__O("Pending")), discriminator);
                            if ((x1$25 instanceof $c_s_Some)) {
                              var x2$25 = $as_s_Some(x1$25);
                              var result$13 = $as_s_util_Either($n(x2$25).s_Some__f_value);
                              if ((result$13 instanceof $c_s_util_Right)) {
                                var x2$26 = $as_s_util_Right(result$13);
                                var v$13 = $as_Lreactbuild_model_ListEntryEventBody$Pending$($n(x2$26).s_util_Right__f_value);
                                var x1$52 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$13))
                              } else {
                                if ((!(result$13 instanceof $c_s_util_Left))) {
                                  throw new $c_s_MatchError(result$13)
                                };
                                var x3$13 = $as_s_util_Left(result$13);
                                var err$13 = $as_Lio_circe_DecodingFailure($n(x3$13).s_util_Left__f_value);
                                var x1$52 = new $c_s_util_Left(err$13)
                              }
                            } else {
                              var x$25 = $m_s_None$();
                              if ((!(x$25 === x1$25))) {
                                throw new $c_s_MatchError(x1$25)
                              };
                              var x1$27 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForPickup, c, $as_T($n(transformConstructorNames).apply__O__O("Pickup")), discriminator);
                              if ((x1$27 instanceof $c_s_Some)) {
                                var x2$27 = $as_s_Some(x1$27);
                                var result$14 = $as_s_util_Either($n(x2$27).s_Some__f_value);
                                if ((result$14 instanceof $c_s_util_Right)) {
                                  var x2$28 = $as_s_util_Right(result$14);
                                  var v$14 = $as_Lreactbuild_model_ListEntryEventBody$Pickup$($n(x2$28).s_util_Right__f_value);
                                  var x1$51 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$14))
                                } else {
                                  if ((!(result$14 instanceof $c_s_util_Left))) {
                                    throw new $c_s_MatchError(result$14)
                                  };
                                  var x3$14 = $as_s_util_Left(result$14);
                                  var err$14 = $as_Lio_circe_DecodingFailure($n(x3$14).s_util_Left__f_value);
                                  var x1$51 = new $c_s_util_Left(err$14)
                                }
                              } else {
                                var x$27 = $m_s_None$();
                                if ((!(x$27 === x1$27))) {
                                  throw new $c_s_MatchError(x1$27)
                                };
                                var x1$29 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForRead, c, $as_T($n(transformConstructorNames).apply__O__O("Read")), discriminator);
                                if ((x1$29 instanceof $c_s_Some)) {
                                  var x2$29 = $as_s_Some(x1$29);
                                  var result$15 = $as_s_util_Either($n(x2$29).s_Some__f_value);
                                  if ((result$15 instanceof $c_s_util_Right)) {
                                    var x2$30 = $as_s_util_Right(result$15);
                                    var v$15 = $as_Lreactbuild_model_ListEntryEventBody$Read$($n(x2$30).s_util_Right__f_value);
                                    var x1$50 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$15))
                                  } else {
                                    if ((!(result$15 instanceof $c_s_util_Left))) {
                                      throw new $c_s_MatchError(result$15)
                                    };
                                    var x3$15 = $as_s_util_Left(result$15);
                                    var err$15 = $as_Lio_circe_DecodingFailure($n(x3$15).s_util_Left__f_value);
                                    var x1$50 = new $c_s_util_Left(err$15)
                                  }
                                } else {
                                  var x$29 = $m_s_None$();
                                  if ((!(x$29 === x1$29))) {
                                    throw new $c_s_MatchError(x1$29)
                                  };
                                  var x1$31 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForReceived, c, $as_T($n(transformConstructorNames).apply__O__O("Received")), discriminator);
                                  if ((x1$31 instanceof $c_s_Some)) {
                                    var x2$31 = $as_s_Some(x1$31);
                                    var result$16 = $as_s_util_Either($n(x2$31).s_Some__f_value);
                                    if ((result$16 instanceof $c_s_util_Right)) {
                                      var x2$32 = $as_s_util_Right(result$16);
                                      var v$16 = $as_Lreactbuild_model_ListEntryEventBody$Received$($n(x2$32).s_util_Right__f_value);
                                      var x1$49 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$16))
                                    } else {
                                      if ((!(result$16 instanceof $c_s_util_Left))) {
                                        throw new $c_s_MatchError(result$16)
                                      };
                                      var x3$16 = $as_s_util_Left(result$16);
                                      var err$16 = $as_Lio_circe_DecodingFailure($n(x3$16).s_util_Left__f_value);
                                      var x1$49 = new $c_s_util_Left(err$16)
                                    }
                                  } else {
                                    var x$31 = $m_s_None$();
                                    if ((!(x$31 === x1$31))) {
                                      throw new $c_s_MatchError(x1$31)
                                    };
                                    var x1$33 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForRejected, c, $as_T($n(transformConstructorNames).apply__O__O("Rejected")), discriminator);
                                    if ((x1$33 instanceof $c_s_Some)) {
                                      var x2$33 = $as_s_Some(x1$33);
                                      var result$17 = $as_s_util_Either($n(x2$33).s_Some__f_value);
                                      if ((result$17 instanceof $c_s_util_Right)) {
                                        var x2$34 = $as_s_util_Right(result$17);
                                        var v$17 = $as_Lreactbuild_model_ListEntryEventBody$Rejected($n(x2$34).s_util_Right__f_value);
                                        var x1$48 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$17))
                                      } else {
                                        if ((!(result$17 instanceof $c_s_util_Left))) {
                                          throw new $c_s_MatchError(result$17)
                                        };
                                        var x3$17 = $as_s_util_Left(result$17);
                                        var err$17 = $as_Lio_circe_DecodingFailure($n(x3$17).s_util_Left__f_value);
                                        var x1$48 = new $c_s_util_Left(err$17)
                                      }
                                    } else {
                                      var x$33 = $m_s_None$();
                                      if ((!(x$33 === x1$33))) {
                                        throw new $c_s_MatchError(x1$33)
                                      };
                                      var x1$35 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForReset, c, $as_T($n(transformConstructorNames).apply__O__O("Reset")), discriminator);
                                      if ((x1$35 instanceof $c_s_Some)) {
                                        var x2$35 = $as_s_Some(x1$35);
                                        var result$18 = $as_s_util_Either($n(x2$35).s_Some__f_value);
                                        if ((result$18 instanceof $c_s_util_Right)) {
                                          var x2$36 = $as_s_util_Right(result$18);
                                          var v$18 = $as_Lreactbuild_model_ListEntryEventBody$Reset$($n(x2$36).s_util_Right__f_value);
                                          var x1$47 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$18))
                                        } else {
                                          if ((!(result$18 instanceof $c_s_util_Left))) {
                                            throw new $c_s_MatchError(result$18)
                                          };
                                          var x3$18 = $as_s_util_Left(result$18);
                                          var err$18 = $as_Lio_circe_DecodingFailure($n(x3$18).s_util_Left__f_value);
                                          var x1$47 = new $c_s_util_Left(err$18)
                                        }
                                      } else {
                                        var x$35 = $m_s_None$();
                                        if ((!(x$35 === x1$35))) {
                                          throw new $c_s_MatchError(x1$35)
                                        };
                                        var x1$37 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForShipped, c, $as_T($n(transformConstructorNames).apply__O__O("Shipped")), discriminator);
                                        if ((x1$37 instanceof $c_s_Some)) {
                                          var x2$37 = $as_s_Some(x1$37);
                                          var result$19 = $as_s_util_Either($n(x2$37).s_Some__f_value);
                                          if ((result$19 instanceof $c_s_util_Right)) {
                                            var x2$38 = $as_s_util_Right(result$19);
                                            var v$19 = $as_Lreactbuild_model_ListEntryEventBody$Shipped$($n(x2$38).s_util_Right__f_value);
                                            var x1$46 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$19))
                                          } else {
                                            if ((!(result$19 instanceof $c_s_util_Left))) {
                                              throw new $c_s_MatchError(result$19)
                                            };
                                            var x3$19 = $as_s_util_Left(result$19);
                                            var err$19 = $as_Lio_circe_DecodingFailure($n(x3$19).s_util_Left__f_value);
                                            var x1$46 = new $c_s_util_Left(err$19)
                                          }
                                        } else {
                                          var x$37 = $m_s_None$();
                                          if ((!(x$37 === x1$37))) {
                                            throw new $c_s_MatchError(x1$37)
                                          };
                                          var x1$39 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForTermAdded, c, $as_T($n(transformConstructorNames).apply__O__O("TermAdded")), discriminator);
                                          if ((x1$39 instanceof $c_s_Some)) {
                                            var x2$39 = $as_s_Some(x1$39);
                                            var result$20 = $as_s_util_Either($n(x2$39).s_Some__f_value);
                                            if ((result$20 instanceof $c_s_util_Right)) {
                                              var x2$40 = $as_s_util_Right(result$20);
                                              var v$20 = $as_Lreactbuild_model_ListEntryEventBody$TermAdded($n(x2$40).s_util_Right__f_value);
                                              var x1$45 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$20))
                                            } else {
                                              if ((!(result$20 instanceof $c_s_util_Left))) {
                                                throw new $c_s_MatchError(result$20)
                                              };
                                              var x3$20 = $as_s_util_Left(result$20);
                                              var err$20 = $as_Lio_circe_DecodingFailure($n(x3$20).s_util_Left__f_value);
                                              var x1$45 = new $c_s_util_Left(err$20)
                                            }
                                          } else {
                                            var x$39 = $m_s_None$();
                                            if ((!(x$39 === x1$39))) {
                                              throw new $c_s_MatchError(x1$39)
                                            };
                                            var x1$41 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64__f_circeGenericDecoderForTermRemoved, c, $as_T($n(transformConstructorNames).apply__O__O("TermRemoved")), discriminator);
                                            if ((x1$41 instanceof $c_s_Some)) {
                                              var x2$41 = $as_s_Some(x1$41);
                                              var result$21 = $as_s_util_Either($n(x2$41).s_Some__f_value);
                                              if ((result$21 instanceof $c_s_util_Right)) {
                                                var x2$42 = $as_s_util_Right(result$21);
                                                var v$21 = $as_Lreactbuild_model_ListEntryEventBody$TermRemoved($n(x2$42).s_util_Right__f_value);
                                                var x1$44 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$21))
                                              } else {
                                                if ((!(result$21 instanceof $c_s_util_Left))) {
                                                  throw new $c_s_MatchError(result$21)
                                                };
                                                var x3$21 = $as_s_util_Left(result$21);
                                                var err$21 = $as_Lio_circe_DecodingFailure($n(x3$21).s_util_Left__f_value);
                                                var x1$44 = new $c_s_util_Left(err$21)
                                              }
                                            } else {
                                              var x$41 = $m_s_None$();
                                              if ((!(x$41 === x1$41))) {
                                                throw new $c_s_MatchError(x1$41)
                                              };
                                              $m_Lio_circe_DecodingFailure$();
                                              var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
                                              var x1$43 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
                                              var err$22 = $as_Lio_circe_DecodingFailure(x1$43.s_util_Left__f_value);
                                              var x1$44 = new $c_s_util_Left(err$22)
                                            };
                                            if ((x1$44 instanceof $c_s_util_Right)) {
                                              var x2$44 = $as_s_util_Right(x1$44);
                                              var v$23 = $as_Lshapeless_$colon$plus$colon($n(x2$44).s_util_Right__f_value);
                                              var x1$45 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$23))
                                            } else {
                                              if ((!(x1$44 instanceof $c_s_util_Left))) {
                                                throw new $c_s_MatchError(x1$44)
                                              };
                                              var x3$23 = $as_s_util_Left(x1$44);
                                              var err$23 = $as_Lio_circe_DecodingFailure($n(x3$23).s_util_Left__f_value);
                                              var x1$45 = new $c_s_util_Left(err$23)
                                            }
                                          };
                                          if ((x1$45 instanceof $c_s_util_Right)) {
                                            var x2$45 = $as_s_util_Right(x1$45);
                                            var v$24 = $as_Lshapeless_$colon$plus$colon($n(x2$45).s_util_Right__f_value);
                                            var x1$46 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$24))
                                          } else {
                                            if ((!(x1$45 instanceof $c_s_util_Left))) {
                                              throw new $c_s_MatchError(x1$45)
                                            };
                                            var x3$24 = $as_s_util_Left(x1$45);
                                            var err$24 = $as_Lio_circe_DecodingFailure($n(x3$24).s_util_Left__f_value);
                                            var x1$46 = new $c_s_util_Left(err$24)
                                          }
                                        };
                                        if ((x1$46 instanceof $c_s_util_Right)) {
                                          var x2$46 = $as_s_util_Right(x1$46);
                                          var v$25 = $as_Lshapeless_$colon$plus$colon($n(x2$46).s_util_Right__f_value);
                                          var x1$47 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$25))
                                        } else {
                                          if ((!(x1$46 instanceof $c_s_util_Left))) {
                                            throw new $c_s_MatchError(x1$46)
                                          };
                                          var x3$25 = $as_s_util_Left(x1$46);
                                          var err$25 = $as_Lio_circe_DecodingFailure($n(x3$25).s_util_Left__f_value);
                                          var x1$47 = new $c_s_util_Left(err$25)
                                        }
                                      };
                                      if ((x1$47 instanceof $c_s_util_Right)) {
                                        var x2$47 = $as_s_util_Right(x1$47);
                                        var v$26 = $as_Lshapeless_$colon$plus$colon($n(x2$47).s_util_Right__f_value);
                                        var x1$48 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$26))
                                      } else {
                                        if ((!(x1$47 instanceof $c_s_util_Left))) {
                                          throw new $c_s_MatchError(x1$47)
                                        };
                                        var x3$26 = $as_s_util_Left(x1$47);
                                        var err$26 = $as_Lio_circe_DecodingFailure($n(x3$26).s_util_Left__f_value);
                                        var x1$48 = new $c_s_util_Left(err$26)
                                      }
                                    };
                                    if ((x1$48 instanceof $c_s_util_Right)) {
                                      var x2$48 = $as_s_util_Right(x1$48);
                                      var v$27 = $as_Lshapeless_$colon$plus$colon($n(x2$48).s_util_Right__f_value);
                                      var x1$49 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$27))
                                    } else {
                                      if ((!(x1$48 instanceof $c_s_util_Left))) {
                                        throw new $c_s_MatchError(x1$48)
                                      };
                                      var x3$27 = $as_s_util_Left(x1$48);
                                      var err$27 = $as_Lio_circe_DecodingFailure($n(x3$27).s_util_Left__f_value);
                                      var x1$49 = new $c_s_util_Left(err$27)
                                    }
                                  };
                                  if ((x1$49 instanceof $c_s_util_Right)) {
                                    var x2$49 = $as_s_util_Right(x1$49);
                                    var v$28 = $as_Lshapeless_$colon$plus$colon($n(x2$49).s_util_Right__f_value);
                                    var x1$50 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$28))
                                  } else {
                                    if ((!(x1$49 instanceof $c_s_util_Left))) {
                                      throw new $c_s_MatchError(x1$49)
                                    };
                                    var x3$28 = $as_s_util_Left(x1$49);
                                    var err$28 = $as_Lio_circe_DecodingFailure($n(x3$28).s_util_Left__f_value);
                                    var x1$50 = new $c_s_util_Left(err$28)
                                  }
                                };
                                if ((x1$50 instanceof $c_s_util_Right)) {
                                  var x2$50 = $as_s_util_Right(x1$50);
                                  var v$29 = $as_Lshapeless_$colon$plus$colon($n(x2$50).s_util_Right__f_value);
                                  var x1$51 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$29))
                                } else {
                                  if ((!(x1$50 instanceof $c_s_util_Left))) {
                                    throw new $c_s_MatchError(x1$50)
                                  };
                                  var x3$29 = $as_s_util_Left(x1$50);
                                  var err$29 = $as_Lio_circe_DecodingFailure($n(x3$29).s_util_Left__f_value);
                                  var x1$51 = new $c_s_util_Left(err$29)
                                }
                              };
                              if ((x1$51 instanceof $c_s_util_Right)) {
                                var x2$51 = $as_s_util_Right(x1$51);
                                var v$30 = $as_Lshapeless_$colon$plus$colon($n(x2$51).s_util_Right__f_value);
                                var x1$52 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$30))
                              } else {
                                if ((!(x1$51 instanceof $c_s_util_Left))) {
                                  throw new $c_s_MatchError(x1$51)
                                };
                                var x3$30 = $as_s_util_Left(x1$51);
                                var err$30 = $as_Lio_circe_DecodingFailure($n(x3$30).s_util_Left__f_value);
                                var x1$52 = new $c_s_util_Left(err$30)
                              }
                            };
                            if ((x1$52 instanceof $c_s_util_Right)) {
                              var x2$52 = $as_s_util_Right(x1$52);
                              var v$31 = $as_Lshapeless_$colon$plus$colon($n(x2$52).s_util_Right__f_value);
                              var x1$53 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$31))
                            } else {
                              if ((!(x1$52 instanceof $c_s_util_Left))) {
                                throw new $c_s_MatchError(x1$52)
                              };
                              var x3$31 = $as_s_util_Left(x1$52);
                              var err$31 = $as_Lio_circe_DecodingFailure($n(x3$31).s_util_Left__f_value);
                              var x1$53 = new $c_s_util_Left(err$31)
                            }
                          };
                          if ((x1$53 instanceof $c_s_util_Right)) {
                            var x2$53 = $as_s_util_Right(x1$53);
                            var v$32 = $as_Lshapeless_$colon$plus$colon($n(x2$53).s_util_Right__f_value);
                            var x1$54 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$32))
                          } else {
                            if ((!(x1$53 instanceof $c_s_util_Left))) {
                              throw new $c_s_MatchError(x1$53)
                            };
                            var x3$32 = $as_s_util_Left(x1$53);
                            var err$32 = $as_Lio_circe_DecodingFailure($n(x3$32).s_util_Left__f_value);
                            var x1$54 = new $c_s_util_Left(err$32)
                          }
                        };
                        if ((x1$54 instanceof $c_s_util_Right)) {
                          var x2$54 = $as_s_util_Right(x1$54);
                          var v$33 = $as_Lshapeless_$colon$plus$colon($n(x2$54).s_util_Right__f_value);
                          var x1$55 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$33))
                        } else {
                          if ((!(x1$54 instanceof $c_s_util_Left))) {
                            throw new $c_s_MatchError(x1$54)
                          };
                          var x3$33 = $as_s_util_Left(x1$54);
                          var err$33 = $as_Lio_circe_DecodingFailure($n(x3$33).s_util_Left__f_value);
                          var x1$55 = new $c_s_util_Left(err$33)
                        }
                      };
                      if ((x1$55 instanceof $c_s_util_Right)) {
                        var x2$55 = $as_s_util_Right(x1$55);
                        var v$34 = $as_Lshapeless_$colon$plus$colon($n(x2$55).s_util_Right__f_value);
                        var x1$56 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$34))
                      } else {
                        if ((!(x1$55 instanceof $c_s_util_Left))) {
                          throw new $c_s_MatchError(x1$55)
                        };
                        var x3$34 = $as_s_util_Left(x1$55);
                        var err$34 = $as_Lio_circe_DecodingFailure($n(x3$34).s_util_Left__f_value);
                        var x1$56 = new $c_s_util_Left(err$34)
                      }
                    };
                    if ((x1$56 instanceof $c_s_util_Right)) {
                      var x2$56 = $as_s_util_Right(x1$56);
                      var v$35 = $as_Lshapeless_$colon$plus$colon($n(x2$56).s_util_Right__f_value);
                      var x1$57 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$35))
                    } else {
                      if ((!(x1$56 instanceof $c_s_util_Left))) {
                        throw new $c_s_MatchError(x1$56)
                      };
                      var x3$35 = $as_s_util_Left(x1$56);
                      var err$35 = $as_Lio_circe_DecodingFailure($n(x3$35).s_util_Left__f_value);
                      var x1$57 = new $c_s_util_Left(err$35)
                    }
                  };
                  if ((x1$57 instanceof $c_s_util_Right)) {
                    var x2$57 = $as_s_util_Right(x1$57);
                    var v$36 = $as_Lshapeless_$colon$plus$colon($n(x2$57).s_util_Right__f_value);
                    var x1$58 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$36))
                  } else {
                    if ((!(x1$57 instanceof $c_s_util_Left))) {
                      throw new $c_s_MatchError(x1$57)
                    };
                    var x3$36 = $as_s_util_Left(x1$57);
                    var err$36 = $as_Lio_circe_DecodingFailure($n(x3$36).s_util_Left__f_value);
                    var x1$58 = new $c_s_util_Left(err$36)
                  }
                };
                if ((x1$58 instanceof $c_s_util_Right)) {
                  var x2$58 = $as_s_util_Right(x1$58);
                  var v$37 = $as_Lshapeless_$colon$plus$colon($n(x2$58).s_util_Right__f_value);
                  var x1$59 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$37))
                } else {
                  if ((!(x1$58 instanceof $c_s_util_Left))) {
                    throw new $c_s_MatchError(x1$58)
                  };
                  var x3$37 = $as_s_util_Left(x1$58);
                  var err$37 = $as_Lio_circe_DecodingFailure($n(x3$37).s_util_Left__f_value);
                  var x1$59 = new $c_s_util_Left(err$37)
                }
              };
              if ((x1$59 instanceof $c_s_util_Right)) {
                var x2$59 = $as_s_util_Right(x1$59);
                var v$38 = $as_Lshapeless_$colon$plus$colon($n(x2$59).s_util_Right__f_value);
                var x1$60 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$38))
              } else {
                if ((!(x1$59 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(x1$59)
                };
                var x3$38 = $as_s_util_Left(x1$59);
                var err$38 = $as_Lio_circe_DecodingFailure($n(x3$38).s_util_Left__f_value);
                var x1$60 = new $c_s_util_Left(err$38)
              }
            };
            if ((x1$60 instanceof $c_s_util_Right)) {
              var x2$60 = $as_s_util_Right(x1$60);
              var v$39 = $as_Lshapeless_$colon$plus$colon($n(x2$60).s_util_Right__f_value);
              var x1$61 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$39))
            } else {
              if ((!(x1$60 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(x1$60)
              };
              var x3$39 = $as_s_util_Left(x1$60);
              var err$39 = $as_Lio_circe_DecodingFailure($n(x3$39).s_util_Left__f_value);
              var x1$61 = new $c_s_util_Left(err$39)
            }
          };
          if ((x1$61 instanceof $c_s_util_Right)) {
            var x2$61 = $as_s_util_Right(x1$61);
            var v$40 = $as_Lshapeless_$colon$plus$colon($n(x2$61).s_util_Right__f_value);
            var x1$62 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$40))
          } else {
            if ((!(x1$61 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$61)
            };
            var x3$40 = $as_s_util_Left(x1$61);
            var err$40 = $as_Lio_circe_DecodingFailure($n(x3$40).s_util_Left__f_value);
            var x1$62 = new $c_s_util_Left(err$40)
          }
        };
        if ((x1$62 instanceof $c_s_util_Right)) {
          var x2$62 = $as_s_util_Right(x1$62);
          var v$41 = $as_Lshapeless_$colon$plus$colon($n(x2$62).s_util_Right__f_value);
          var x1$63 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$41))
        } else {
          if ((!(x1$62 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$62)
          };
          var x3$41 = $as_s_util_Left(x1$62);
          var err$41 = $as_Lio_circe_DecodingFailure($n(x3$41).s_util_Left__f_value);
          var x1$63 = new $c_s_util_Left(err$41)
        }
      };
      if ((x1$63 instanceof $c_s_util_Right)) {
        var x2$63 = $as_s_util_Right(x1$63);
        var v$42 = $as_Lshapeless_$colon$plus$colon($n(x2$63).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$42))
      } else if ((x1$63 instanceof $c_s_util_Left)) {
        var x3$42 = $as_s_util_Left(x1$63);
        var err$42 = $as_Lio_circe_DecodingFailure($n(x3$42).s_util_Left__f_value);
        return new $c_s_util_Left(err$42)
      } else {
        throw new $c_s_MatchError(x1$63)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64: 0
}, false, "reactbuild.model.ListEntryEventBody$anon$lazy$macro$183$1$$anon$64", {
  Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$anon$lazy$macro$183$1$$anon$64;
/** @constructor */
function $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61(outer) {
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForCheckList = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForGuideline = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForIssue = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForSupply = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForTaskList = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForCheckList = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForGuideline = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForIssue = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForSupply = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForTaskList = null;
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$8__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForCheckList = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForGuideline = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForIssue = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForSupply = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForTaskList = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$14__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForCheckList = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$13__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForGuideline = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$12__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForIssue = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O());
  var t$8 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$11__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForSupply = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$8).value__O());
  var t$9 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_$outer).inst$macro$9__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForTaskList = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$9).value__O())
}
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61.prototype.constructor = $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61;
/** @constructor */
function $h_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61.prototype = $c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61.prototype;
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForCheckList = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForCheckList instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForCheckList);
    var circeGenericInlBindingForCheckList = $as_Lreactbuild_model_ListEntryType$CheckList$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForCheckList;
    var name = $as_T($n(transformConstructorNames).apply__O__O("CheckList"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForCheckList, name, discriminator)
  } else if ((circeGenericInrBindingForCheckList instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForCheckList);
    var circeGenericInrBindingForGuideline = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForGuideline instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForGuideline);
      var circeGenericInlBindingForGuideline = $as_Lreactbuild_model_ListEntryType$Guideline$($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForGuideline;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Guideline"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForGuideline, name$1, discriminator)
    } else if ((circeGenericInrBindingForGuideline instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForGuideline);
      var circeGenericInrBindingForIssue = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForIssue instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForIssue);
        var circeGenericInlBindingForIssue = $as_Lreactbuild_model_ListEntryType$Issue$($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForIssue;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Issue"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForIssue, name$2, discriminator)
      } else if ((circeGenericInrBindingForIssue instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForIssue);
        var circeGenericInrBindingForSupply = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForSupply instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForSupply);
          var circeGenericInlBindingForSupply = $as_Lreactbuild_model_ListEntryType$Supply$($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForSupply;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("Supply"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForSupply, name$3, discriminator)
        } else if ((circeGenericInrBindingForSupply instanceof $c_Lshapeless_Inr)) {
          var x3$4 = $as_Lshapeless_Inr(circeGenericInrBindingForSupply);
          var circeGenericInrBindingForTaskList = $as_Lshapeless_$colon$plus$colon($n(x3$4).Lshapeless_Inr__f_tail);
          if ((circeGenericInrBindingForTaskList instanceof $c_Lshapeless_Inl)) {
            var x2$5 = $as_Lshapeless_Inl(circeGenericInrBindingForTaskList);
            var circeGenericInlBindingForTaskList = $as_Lreactbuild_model_ListEntryType$TaskList$($n(x2$5).Lshapeless_Inl__f_head);
            var encode$4 = this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericEncoderForTaskList;
            var name$4 = $as_T($n(transformConstructorNames).apply__O__O("TaskList"));
            return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$4, circeGenericInlBindingForTaskList, name$4, discriminator)
          } else if ((circeGenericInrBindingForTaskList instanceof $c_Lshapeless_Inr)) {
            $m_s_sys_package$().error__T__E("Cannot encode CNil")
          } else {
            throw new $c_s_MatchError(circeGenericInrBindingForTaskList)
          }
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForSupply)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForIssue)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForGuideline)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForCheckList)
  }
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForCheckList, c, $as_T($n(transformConstructorNames).apply__O__O("CheckList")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_ListEntryType$CheckList$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForGuideline, c, $as_T($n(transformConstructorNames).apply__O__O("Guideline")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_ListEntryType$Guideline$($n(x2$4).s_util_Right__f_value);
          var x1$15 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$15 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForIssue, c, $as_T($n(transformConstructorNames).apply__O__O("Issue")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_model_ListEntryType$Issue$($n(x2$6).s_util_Right__f_value);
            var x1$14 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$14 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForSupply, c, $as_T($n(transformConstructorNames).apply__O__O("Supply")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_model_ListEntryType$Supply$($n(x2$8).s_util_Right__f_value);
              var x1$13 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$13 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            var x1$9 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61__f_circeGenericDecoderForTaskList, c, $as_T($n(transformConstructorNames).apply__O__O("TaskList")), discriminator);
            if ((x1$9 instanceof $c_s_Some)) {
              var x2$9 = $as_s_Some(x1$9);
              var result$5 = $as_s_util_Either($n(x2$9).s_Some__f_value);
              if ((result$5 instanceof $c_s_util_Right)) {
                var x2$10 = $as_s_util_Right(result$5);
                var v$5 = $as_Lreactbuild_model_ListEntryType$TaskList$($n(x2$10).s_util_Right__f_value);
                var x1$12 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$5))
              } else {
                if ((!(result$5 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(result$5)
                };
                var x3$5 = $as_s_util_Left(result$5);
                var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
                var x1$12 = new $c_s_util_Left(err$5)
              }
            } else {
              var x$9 = $m_s_None$();
              if ((!(x$9 === x1$9))) {
                throw new $c_s_MatchError(x1$9)
              };
              $m_Lio_circe_DecodingFailure$();
              var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
              var x1$11 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
              var err$6 = $as_Lio_circe_DecodingFailure(x1$11.s_util_Left__f_value);
              var x1$12 = new $c_s_util_Left(err$6)
            };
            if ((x1$12 instanceof $c_s_util_Right)) {
              var x2$12 = $as_s_util_Right(x1$12);
              var v$7 = $as_Lshapeless_$colon$plus$colon($n(x2$12).s_util_Right__f_value);
              var x1$13 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$7))
            } else {
              if ((!(x1$12 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(x1$12)
              };
              var x3$7 = $as_s_util_Left(x1$12);
              var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
              var x1$13 = new $c_s_util_Left(err$7)
            }
          };
          if ((x1$13 instanceof $c_s_util_Right)) {
            var x2$13 = $as_s_util_Right(x1$13);
            var v$8 = $as_Lshapeless_$colon$plus$colon($n(x2$13).s_util_Right__f_value);
            var x1$14 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$8))
          } else {
            if ((!(x1$13 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$13)
            };
            var x3$8 = $as_s_util_Left(x1$13);
            var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
            var x1$14 = new $c_s_util_Left(err$8)
          }
        };
        if ((x1$14 instanceof $c_s_util_Right)) {
          var x2$14 = $as_s_util_Right(x1$14);
          var v$9 = $as_Lshapeless_$colon$plus$colon($n(x2$14).s_util_Right__f_value);
          var x1$15 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$9))
        } else {
          if ((!(x1$14 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$14)
          };
          var x3$9 = $as_s_util_Left(x1$14);
          var err$9 = $as_Lio_circe_DecodingFailure($n(x3$9).s_util_Left__f_value);
          var x1$15 = new $c_s_util_Left(err$9)
        }
      };
      if ((x1$15 instanceof $c_s_util_Right)) {
        var x2$15 = $as_s_util_Right(x1$15);
        var v$10 = $as_Lshapeless_$colon$plus$colon($n(x2$15).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$10))
      } else if ((x1$15 instanceof $c_s_util_Left)) {
        var x3$10 = $as_s_util_Left(x1$15);
        var err$10 = $as_Lio_circe_DecodingFailure($n(x3$10).s_util_Left__f_value);
        return new $c_s_util_Left(err$10)
      } else {
        throw new $c_s_MatchError(x1$15)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61: 0
}, false, "reactbuild.model.ListEntryType$anon$lazy$macro$15$2$$anon$61", {
  Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61.prototype.$classData = $d_Lreactbuild_model_ListEntryType$anon$lazy$macro$15$2$$anon$61;
/** @constructor */
function $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59(outer) {
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericDecoderForMediaMandatory = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericDecoderForNoValidation = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericEncoderForMediaMandatory = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericEncoderForNoValidation = null;
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericDecoderForMediaMandatory = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericDecoderForNoValidation = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_$outer).inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericEncoderForMediaMandatory = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_$outer).inst$macro$6__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericEncoderForNoValidation = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O())
}
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59.prototype.constructor = $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59;
/** @constructor */
function $h_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59.prototype = $c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59.prototype;
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForMediaMandatory = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForMediaMandatory instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForMediaMandatory);
    var circeGenericInlBindingForMediaMandatory = $as_Lreactbuild_model_ListEntryValidation$MediaMandatory$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericEncoderForMediaMandatory;
    var name = $as_T($n(transformConstructorNames).apply__O__O("MediaMandatory"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForMediaMandatory, name, discriminator)
  } else if ((circeGenericInrBindingForMediaMandatory instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForMediaMandatory);
    var circeGenericInrBindingForNoValidation = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForNoValidation instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForNoValidation);
      var circeGenericInlBindingForNoValidation = $as_Lreactbuild_model_ListEntryValidation$NoValidation$($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericEncoderForNoValidation;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("NoValidation"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForNoValidation, name$1, discriminator)
    } else if ((circeGenericInrBindingForNoValidation instanceof $c_Lshapeless_Inr)) {
      $m_s_sys_package$().error__T__E("Cannot encode CNil")
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForNoValidation)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForMediaMandatory)
  }
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericDecoderForMediaMandatory, c, $as_T($n(transformConstructorNames).apply__O__O("MediaMandatory")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_ListEntryValidation$MediaMandatory$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59__f_circeGenericDecoderForNoValidation, c, $as_T($n(transformConstructorNames).apply__O__O("NoValidation")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_ListEntryValidation$NoValidation$($n(x2$4).s_util_Right__f_value);
          var x1$6 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$6 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        $m_Lio_circe_DecodingFailure$();
        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
        var x1$5 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
        var err$3 = $as_Lio_circe_DecodingFailure(x1$5.s_util_Left__f_value);
        var x1$6 = new $c_s_util_Left(err$3)
      };
      if ((x1$6 instanceof $c_s_util_Right)) {
        var x2$6 = $as_s_util_Right(x1$6);
        var v$4 = $as_Lshapeless_$colon$plus$colon($n(x2$6).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$4))
      } else if ((x1$6 instanceof $c_s_util_Left)) {
        var x3$4 = $as_s_util_Left(x1$6);
        var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
        return new $c_s_util_Left(err$4)
      } else {
        throw new $c_s_MatchError(x1$6)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59 = new $TypeData().initClass({
  Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59: 0
}, false, "reactbuild.model.ListEntryValidation$anon$lazy$macro$9$1$$anon$59", {
  Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59.prototype.$classData = $d_Lreactbuild_model_ListEntryValidation$anon$lazy$macro$9$1$$anon$59;
/** @constructor */
function $c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74(outer) {
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericDecoderFortitle = null;
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericEncoderFortitle = null;
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericDecoderFortitle = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericEncoderFortitle = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74.prototype.constructor = $c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74;
/** @constructor */
function $h_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74.prototype = $c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74.prototype;
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFortitle = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74__f_circeGenericDecoderFortitle, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74 = new $TypeData().initClass({
  Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74: 0
}, false, "reactbuild.model.ListTemplate$anon$lazy$macro$27$2$$anon$74", {
  Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74.prototype.$classData = $d_Lreactbuild_model_ListTemplate$anon$lazy$macro$27$2$$anon$74;
/** @constructor */
function $c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75(outer) {
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFortemplate = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFortitle = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFortype = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForterms = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForcreated = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForvalidation = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForduration = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFortemplate = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFortitle = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFortype = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForterms = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForcreated = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForvalidation = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForduration = null;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFortemplate = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFortitle = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFortype = $m_Lreactbuild_model_ListEntryType$().Lreactbuild_model_ListEntryType$__f_codecForListEntryType;
  var this$3 = $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  var this$1 = $m_sci_ListSet$();
  var factory = new $c_sc_IterableFactory$ToFactory(this$1);
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForterms = new $c_Lio_circe_CollectionDecoders$$anon$2(this$3, decodeA, factory);
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForcreated = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForvalidation = $m_Lreactbuild_model_ListEntryValidation$().Lreactbuild_model_ListEntryValidation$__f_codecForListEntryValidation;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_model_Expression$().decodeExpression__Lio_circe_Decoder();
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForduration = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFortemplate = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFortitle = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFortype = $m_Lreactbuild_model_ListEntryType$().Lreactbuild_model_ListEntryType$__f_codecForListEntryType;
  var this$7 = $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  var this$6 = $m_s_$less$colon$less$();
  var ev = this$6.s_$less$colon$less$__f_singleton;
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForterms = new $c_Lio_circe_MidPriorityEncoders$$anon$69(this$7, encodeA, ev);
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForcreated = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForvalidation = $m_Lreactbuild_model_ListEntryValidation$().Lreactbuild_model_ListEntryValidation$__f_codecForListEntryValidation;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_model_Expression$().encodeExpression__Lio_circe_Encoder();
  this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForduration = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75.prototype.constructor = $c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75;
/** @constructor */
function $h_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75.prototype = $c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75.prototype;
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortemplate = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFortitle = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFortype = $as_Lreactbuild_model_ListEntryType($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForterms = $as_sci_ListSet($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForcreated = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForvalidation = $as_Lreactbuild_model_ListEntryValidation($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForduration = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p9)) {
                    var $$x10 = $m_Lio_circe_JsonObject$();
                    var this$7 = $m_sci_Vector$();
                    var $$x9 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                    var $$x8 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("template"), $n(this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFortemplate).apply__O__Lio_circe_Json(circeGenericHListBindingFortemplate));
                    var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle));
                    var $$x6 = $n(transformMemberNames).apply__O__O("type");
                    var this$1 = $n(this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderFortype);
                    var $$x5 = $ct_T2__O__O__(new $c_T2(), $$x6, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFortype));
                    var $$x4 = $n(transformMemberNames).apply__O__O("terms");
                    var this$2 = $n(this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForterms);
                    var $$x3 = $ct_T2__O__O__(new $c_T2(), $$x4, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForterms));
                    var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("created"), $n(this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForcreated).apply__O__Lio_circe_Json(circeGenericHListBindingForcreated));
                    var $$x1 = $n(transformMemberNames).apply__O__O("validation");
                    var this$3 = $n(this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForvalidation);
                    var array = [$$x9, $$x8, $$x7, $$x5, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForvalidation)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("duration"), $n(this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericEncoderForduration).apply__O__Lio_circe_Json(circeGenericHListBindingForduration))];
                    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                    return $n($$x10).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$7.from__sc_IterableOnce__sci_Vector(elems))
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("template"))), this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFortemplate, "template", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFortitle, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("type"))), this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderFortype, "type", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("terms"))), this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForterms, "terms", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("created"))), this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForcreated, "created", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("validation"))), this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForvalidation, "validation", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("duration"))), this.Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75__f_circeGenericDecoderForduration, "duration", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75 = new $TypeData().initClass({
  Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75: 0
}, false, "reactbuild.model.ListTemplateEntry$anon$lazy$macro$67$4$$anon$75", {
  Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75.prototype.$classData = $d_Lreactbuild_model_ListTemplateEntry$anon$lazy$macro$67$4$$anon$75;
/** @constructor */
function $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1(outer) {
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericDecoderForDocument = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericDecoderForImage = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericDecoderForMeasure = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericEncoderForDocument = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericEncoderForImage = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericEncoderForMeasure = null;
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_$outer).inst$macro$95__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericDecoderForDocument = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_$outer).inst$macro$37__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericDecoderForImage = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericDecoderForMeasure = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_$outer).inst$macro$205__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericEncoderForDocument = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_$outer).inst$macro$147__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericEncoderForImage = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_$outer).inst$macro$113__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericEncoderForMeasure = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O())
}
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1.prototype.constructor = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1.prototype = $c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1.prototype;
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForDocument = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForDocument instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForDocument);
    var circeGenericInlBindingForDocument = $as_Lreactbuild_model_MapFeature$Document($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericEncoderForDocument;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Document"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForDocument, name, discriminator)
  } else if ((circeGenericInrBindingForDocument instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForDocument);
    var circeGenericInrBindingForImage = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForImage instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForImage);
      var circeGenericInlBindingForImage = $as_Lreactbuild_model_MapFeature$Image($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericEncoderForImage;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Image"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForImage, name$1, discriminator)
    } else if ((circeGenericInrBindingForImage instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForImage);
      var circeGenericInrBindingForMeasure = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForMeasure instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForMeasure);
        var circeGenericInlBindingForMeasure = $as_Lreactbuild_model_MapFeature$Measure($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericEncoderForMeasure;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Measure"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForMeasure, name$2, discriminator)
      } else if ((circeGenericInrBindingForMeasure instanceof $c_Lshapeless_Inr)) {
        $m_s_sys_package$().error__T__E("Cannot encode CNil")
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForMeasure)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForImage)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForDocument)
  }
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericDecoderForDocument, c, $as_T($n(transformConstructorNames).apply__O__O("Document")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_MapFeature$Document($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericDecoderForImage, c, $as_T($n(transformConstructorNames).apply__O__O("Image")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_MapFeature$Image($n(x2$4).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1__f_circeGenericDecoderForMeasure, c, $as_T($n(transformConstructorNames).apply__O__O("Measure")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_model_MapFeature$Measure($n(x2$6).s_util_Right__f_value);
            var x1$8 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$8 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          $m_Lio_circe_DecodingFailure$();
          var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
          var x1$7 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
          var err$4 = $as_Lio_circe_DecodingFailure(x1$7.s_util_Left__f_value);
          var x1$8 = new $c_s_util_Left(err$4)
        };
        if ((x1$8 instanceof $c_s_util_Right)) {
          var x2$8 = $as_s_util_Right(x1$8);
          var v$5 = $as_Lshapeless_$colon$plus$colon($n(x2$8).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$5))
        } else {
          if ((!(x1$8 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$8)
          };
          var x3$5 = $as_s_util_Left(x1$8);
          var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$5)
        }
      };
      if ((x1$9 instanceof $c_s_util_Right)) {
        var x2$9 = $as_s_util_Right(x1$9);
        var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$9).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
      } else if ((x1$9 instanceof $c_s_util_Left)) {
        var x3$6 = $as_s_util_Left(x1$9);
        var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
        return new $c_s_util_Left(err$6)
      } else {
        throw new $c_s_MatchError(x1$9)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1: 0
}, false, "reactbuild.model.MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1", {
  Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1.prototype.$classData = $d_Lreactbuild_model_MapFeature$MapFeature$anon$lazy$macro$223$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42(outer) {
  this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42__f_circeGenericDecoderForpages = null;
  this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42__f_circeGenericEncoderForpages = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_PdfPage$().Lreactbuild_model_PdfPage$__f_codecForPdfPage;
  this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42__f_circeGenericDecoderForpages = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_PdfPage$().Lreactbuild_model_PdfPage$__f_codecForPdfPage;
  this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42__f_circeGenericEncoderForpages = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42.prototype.constructor = $c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42;
/** @constructor */
function $h_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42.prototype = $c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42.prototype;
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForpages = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("pages");
      var this$1 = $n(this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42__f_circeGenericEncoderForpages);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForpages))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("pages"))), this.Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42__f_circeGenericDecoderForpages, "pages", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42 = new $TypeData().initClass({
  Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42: 0
}, false, "reactbuild.model.PdfContent$anon$lazy$macro$11$4$$anon$42", {
  Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42.prototype.$classData = $d_Lreactbuild_model_PdfContent$anon$lazy$macro$11$4$$anon$42;
/** @constructor */
function $c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45(outer) {
  this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45__f_circeGenericDecoderForwords = null;
  this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45__f_circeGenericEncoderForwords = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_PdfWord$().Lreactbuild_model_PdfWord$__f_codecForPdfWord;
  this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45__f_circeGenericDecoderForwords = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_PdfWord$().Lreactbuild_model_PdfWord$__f_codecForPdfWord;
  this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45__f_circeGenericEncoderForwords = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45.prototype.constructor = $c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45;
/** @constructor */
function $h_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45.prototype = $c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45.prototype;
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForwords = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("words");
      var this$1 = $n(this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45__f_circeGenericEncoderForwords);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForwords))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("words"))), this.Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45__f_circeGenericDecoderForwords, "words", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45 = new $TypeData().initClass({
  Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45: 0
}, false, "reactbuild.model.PdfLine$anon$lazy$macro$11$6$$anon$45", {
  Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45.prototype.$classData = $d_Lreactbuild_model_PdfLine$anon$lazy$macro$11$6$$anon$45;
/** @constructor */
function $c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43(outer) {
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericDecoderForparagraphs = null;
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericDecoderForheight = null;
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericEncoderForparagraphs = null;
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericEncoderForheight = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_PdfParagraph$().Lreactbuild_model_PdfParagraph$__f_codecForPdfParagraph;
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericDecoderForparagraphs = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericDecoderForheight = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeFloat;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_PdfParagraph$().Lreactbuild_model_PdfParagraph$__f_codecForPdfParagraph;
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericEncoderForparagraphs = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericEncoderForheight = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeFloat
}
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43.prototype.constructor = $c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43;
/** @constructor */
function $h_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43.prototype = $c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43.prototype;
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForparagraphs = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForwidth = $uF($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForheight = $uF($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x2 = $m_Lio_circe_JsonObject$();
          var this$5 = $m_sci_Vector$();
          var $$x1 = $n(transformMemberNames).apply__O__O("paragraphs");
          var this$1 = $n(this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericEncoderForparagraphs);
          var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForparagraphs)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("width"), $n(this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericEncoderForheight).apply__O__Lio_circe_Json(circeGenericHListBindingForwidth)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("height"), $n(this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericEncoderForheight).apply__O__Lio_circe_Json(circeGenericHListBindingForheight))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("paragraphs"))), this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericDecoderForparagraphs, "paragraphs", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("width"))), this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericDecoderForheight, "width", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("height"))), this.Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43__f_circeGenericDecoderForheight, "height", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43 = new $TypeData().initClass({
  Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43: 0
}, false, "reactbuild.model.PdfPage$anon$lazy$macro$27$1$$anon$43", {
  Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43.prototype.$classData = $d_Lreactbuild_model_PdfPage$anon$lazy$macro$27$1$$anon$43;
/** @constructor */
function $c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44(outer) {
  this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44__f_circeGenericDecoderForlines = null;
  this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44__f_circeGenericEncoderForlines = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_PdfLine$().Lreactbuild_model_PdfLine$__f_codecForPdfLine;
  this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44__f_circeGenericDecoderForlines = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_PdfLine$().Lreactbuild_model_PdfLine$__f_codecForPdfLine;
  this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44__f_circeGenericEncoderForlines = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44.prototype.constructor = $c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44;
/** @constructor */
function $h_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44.prototype = $c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44.prototype;
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForlines = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("lines");
      var this$1 = $n(this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44__f_circeGenericEncoderForlines);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForlines))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("lines"))), this.Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44__f_circeGenericDecoderForlines, "lines", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44 = new $TypeData().initClass({
  Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44: 0
}, false, "reactbuild.model.PdfParagraph$anon$lazy$macro$11$5$$anon$44", {
  Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44.prototype.$classData = $d_Lreactbuild_model_PdfParagraph$anon$lazy$macro$11$5$$anon$44;
/** @constructor */
function $c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47(outer) {
  this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericDecoderForsize = null;
  this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericEncoderForsize = null;
  this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericDecoderForsize = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeFloat;
  this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericEncoderForsize = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeFloat
}
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47.prototype.constructor = $c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47;
/** @constructor */
function $h_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47.prototype = $c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47.prototype;
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForx = $uF($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFory = $uF($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForwidth = $uF($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForheight = $uF($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForsize = $uF($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x1 = $m_Lio_circe_JsonObject$();
              var this$4 = $m_sci_Vector$();
              var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("x"), $n(this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericEncoderForsize).apply__O__Lio_circe_Json(circeGenericHListBindingForx)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("y"), $n(this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericEncoderForsize).apply__O__Lio_circe_Json(circeGenericHListBindingFory)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("width"), $n(this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericEncoderForsize).apply__O__Lio_circe_Json(circeGenericHListBindingForwidth)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("height"), $n(this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericEncoderForsize).apply__O__Lio_circe_Json(circeGenericHListBindingForheight)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("size"), $n(this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericEncoderForsize).apply__O__Lio_circe_Json(circeGenericHListBindingForsize))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("x"))), this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericDecoderForsize, "x", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("y"))), this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericDecoderForsize, "y", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("width"))), this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericDecoderForsize, "width", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("height"))), this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericDecoderForsize, "height", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("size"))), this.Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47__f_circeGenericDecoderForsize, "size", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47 = new $TypeData().initClass({
  Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47: 0
}, false, "reactbuild.model.PdfTextPosition$anon$lazy$macro$43$6$$anon$47", {
  Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47.prototype.$classData = $d_Lreactbuild_model_PdfTextPosition$anon$lazy$macro$43$6$$anon$47;
/** @constructor */
function $c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46(outer) {
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericDecoderFortext = null;
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericDecoderFortextPositions = null;
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericEncoderFortext = null;
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericEncoderFortextPositions = null;
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericDecoderFortext = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_PdfTextPosition$().Lreactbuild_model_PdfTextPosition$__f_codecForPdfTextPosition;
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericDecoderFortextPositions = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericEncoderFortext = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_PdfTextPosition$().Lreactbuild_model_PdfTextPosition$__f_codecForPdfTextPosition;
  this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericEncoderFortextPositions = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46.prototype.constructor = $c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46;
/** @constructor */
function $h_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46() {
  /*<skip>*/
}
$h_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46.prototype = $c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46.prototype;
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFortext = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortextPositions = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x3 = $m_Lio_circe_JsonObject$();
        var this$5 = $m_sci_Vector$();
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("text"), $n(this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericEncoderFortext).apply__O__Lio_circe_Json(circeGenericHListBindingFortext));
        var $$x1 = $n(transformMemberNames).apply__O__O("textPositions");
        var this$1 = $n(this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericEncoderFortextPositions);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFortextPositions))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("text"))), this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericDecoderFortext, "text", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("textPositions"))), this.Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46__f_circeGenericDecoderFortextPositions, "textPositions", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46 = new $TypeData().initClass({
  Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46: 0
}, false, "reactbuild.model.PdfWord$anon$lazy$macro$19$4$$anon$46", {
  Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46.prototype.$classData = $d_Lreactbuild_model_PdfWord$anon$lazy$macro$19$4$$anon$46;
/** @constructor */
function $c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5(outer) {
  this.Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5__f_circeGenericDecoderForamount = null;
  this.Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5__f_circeGenericEncoderForamount = null;
  this.Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5__f_circeGenericDecoderForamount = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5__f_circeGenericEncoderForamount = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5.prototype.constructor = $c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5;
/** @constructor */
function $h_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5.prototype = $c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5.prototype;
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForamount = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("amount"), $n(this.Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5__f_circeGenericEncoderForamount).apply__O__Lio_circe_Json(circeGenericHListBindingForamount))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("amount"))), this.Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5__f_circeGenericDecoderForamount, "amount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5 = new $TypeData().initClass({
  Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5: 0
}, false, "reactbuild.model.Price$anon$lazy$macro$11$1$$anon$5", {
  Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5.prototype.$classData = $d_Lreactbuild_model_Price$anon$lazy$macro$11$1$$anon$5;
/** @constructor */
function $c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20(outer) {
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderFordescription = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderForbuildingPart = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderForunit = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderForevents = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderFordescription = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderForbuildingPart = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderForunit = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderForevents = null;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderFordescription = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderForbuildingPart = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderForunit = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_PriceEvolutionProductEntry$().Lreactbuild_model_PriceEvolutionProductEntry$__f_codecForPriceEvolutionProductEntry;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderForevents = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderFordescription = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderForbuildingPart = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderForunit = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_PriceEvolutionProductEntry$().Lreactbuild_model_PriceEvolutionProductEntry$__f_codecForPriceEvolutionProductEntry;
  this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderForevents = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20.prototype.constructor = $c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20;
/** @constructor */
function $h_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20() {
  /*<skip>*/
}
$h_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20.prototype = $c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20.prototype;
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFordescription = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForbuildingPart = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForunit = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForevents = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x6 = $m_Lio_circe_JsonObject$();
              var this$5 = $m_sci_Vector$();
              var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderFordescription).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
              var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("description"), $n(this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderFordescription).apply__O__Lio_circe_Json(circeGenericHListBindingFordescription));
              var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("buildingPart"), $n(this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderForbuildingPart).apply__O__Lio_circe_Json(circeGenericHListBindingForbuildingPart));
              var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("unit"), $n(this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderForunit).apply__O__Lio_circe_Json(circeGenericHListBindingForunit));
              var $$x1 = $n(transformMemberNames).apply__O__O("events");
              var this$1 = $n(this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericEncoderForevents);
              var array = [$$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForevents))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x6).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderFordescription, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("description"))), this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderFordescription, "description", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingPart"))), this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderForbuildingPart, "buildingPart", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unit"))), this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderForunit, "unit", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("events"))), this.Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20__f_circeGenericDecoderForevents, "events", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20 = new $TypeData().initClass({
  Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20: 0
}, false, "reactbuild.model.PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20", {
  Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20.prototype.$classData = $d_Lreactbuild_model_PriceEvolutionProduct$anon$lazy$macro$43$3$$anon$20;
/** @constructor */
function $c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19(outer) {
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForinvoicePage = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForreference = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForcategory = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForamount = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForquantity = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForbuildingPart = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForsupplier = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForinvoicePage = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForreference = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForcategory = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForamount = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForquantity = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForbuildingPart = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForsupplier = null;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForinvoicePage = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForreference = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForcategory = $m_Lreactbuild_model_DocumentCategory$().Lreactbuild_model_DocumentCategory$__f_decodeDocumentCategory;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderFordate = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForamount = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForquantity = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForbuildingPart = new $c_Lio_circe_Decoder$$anon$39(d$2);
  $m_Lio_circe_Decoder$();
  var d$3 = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForsupplier = new $c_Lio_circe_Decoder$$anon$39(d$3);
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForinvoicePage = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForreference = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForcategory = $m_Lreactbuild_model_DocumentCategory$().Lreactbuild_model_DocumentCategory$__f_encodeDocumentCategory;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderFordate = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForamount = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForquantity = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForbuildingPart = new $c_Lio_circe_Encoder$$anon$21(e$2);
  $m_Lio_circe_Encoder$();
  var e$3 = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForsupplier = new $c_Lio_circe_Encoder$$anon$21(e$3)
}
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19.prototype.constructor = $c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19;
/** @constructor */
function $h_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19() {
  /*<skip>*/
}
$h_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19.prototype = $c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19.prototype;
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForinvoicePage = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForreference = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForcategory = $as_Lreactbuild_model_DocumentCategory($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFordate = $as_Ljava_time_LocalDate($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForunitPrice = $as_Lreactbuild_model_Price($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForamount = $as_Lreactbuild_model_Price($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForquantity = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForbuildingPart = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                  if ((p9 !== null)) {
                    var circeGenericHListBindingForsupplier = $as_s_Option($n(p9).Lshapeless_$colon$colon__f_head);
                    var p10 = $as_Lshapeless_HNil($n(p9).Lshapeless_$colon$colon__f_tail);
                    var x = $m_Lshapeless_HNil$();
                    if ((x === p10)) {
                      var $$x8 = $m_Lio_circe_JsonObject$();
                      var this$6 = $m_sci_Vector$();
                      var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("invoicePage"), $n(this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForinvoicePage).apply__O__Lio_circe_Json(circeGenericHListBindingForinvoicePage));
                      var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForreference).apply__O__Lio_circe_Json(circeGenericHListBindingForreference));
                      var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("category"), $n(this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForcategory).apply__O__Lio_circe_Json(circeGenericHListBindingForcategory));
                      var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate));
                      var $$x3 = $n(transformMemberNames).apply__O__O("unitPrice");
                      var this$1 = $n(this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForamount);
                      var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForunitPrice));
                      var $$x1 = $n(transformMemberNames).apply__O__O("amount");
                      var this$2 = $n(this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForamount);
                      var array = [$$x7, $$x6, $$x5, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForamount)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("quantity"), $n(this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForquantity).apply__O__Lio_circe_Json(circeGenericHListBindingForquantity)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("buildingPart"), $n(this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForbuildingPart).apply__O__Lio_circe_Json(circeGenericHListBindingForbuildingPart)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("supplier"), $n(this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericEncoderForsupplier).apply__O__Lio_circe_Json(circeGenericHListBindingForsupplier))];
                      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                      return $n($$x8).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("invoicePage"))), this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForinvoicePage, "invoicePage", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForreference, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("category"))), this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForcategory, "category", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unitPrice"))), this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForamount, "unitPrice", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("amount"))), this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForamount, "amount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("quantity"))), this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForquantity, "quantity", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingPart"))), this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForbuildingPart, "buildingPart", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("supplier"))), this.Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19__f_circeGenericDecoderForsupplier, "supplier", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19 = new $TypeData().initClass({
  Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19: 0
}, false, "reactbuild.model.PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19", {
  Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19.prototype.$classData = $d_Lreactbuild_model_PriceEvolutionProductEntry$anon$lazy$macro$75$1$$anon$19;
/** @constructor */
function $c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21(outer) {
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForname = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForsupplier = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForbuildingPart = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForname = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForsupplier = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForbuildingPart = null;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForsupplier = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForbuildingPart = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForsupplier = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForbuildingPart = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21.prototype.constructor = $c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21;
/** @constructor */
function $h_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21() {
  /*<skip>*/
}
$h_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21.prototype = $c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21.prototype;
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForreference = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForname = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForsupplier = $as_Lreactbuild_common_model_RefTo($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForbuildingPart = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p7)) {
                var $$x1 = $m_Lio_circe_JsonObject$();
                var this$4 = $m_sci_Vector$();
                var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForreference)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("supplier"), $n(this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForsupplier).apply__O__Lio_circe_Json(circeGenericHListBindingForsupplier)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("buildingPart"), $n(this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForbuildingPart).apply__O__Lio_circe_Json(circeGenericHListBindingForbuildingPart))];
                var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForname, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("supplier"))), this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForsupplier, "supplier", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingPart"))), this.Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForbuildingPart, "buildingPart", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21 = new $TypeData().initClass({
  Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21: 0
}, false, "reactbuild.model.Product$anon$lazy$macro$51$1$$anon$21", {
  Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21.prototype.$classData = $d_Lreactbuild_model_Product$anon$lazy$macro$51$1$$anon$21;
/** @constructor */
function $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41(outer) {
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderForreference = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFordetails = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderForreference = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFordetails = null;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFordate = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderForreference = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_DeliveryFormDetails$().Lreactbuild_model_DeliveryFormDetails$__f_codecForDeliveryFormDetails;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFordetails = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFordate = $m_Lreactbuild_common_model_Date$().Lreactbuild_common_model_Date$__f_codecForDate;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderForreference = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_DeliveryFormDetails$().Lreactbuild_model_DeliveryFormDetails$__f_codecForDeliveryFormDetails;
  this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFordetails = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41.prototype.constructor = $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41;
/** @constructor */
function $h_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41() {
  /*<skip>*/
}
$h_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41.prototype = $c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41.prototype;
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFordate = $as_Lreactbuild_common_model_Date($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForreference = $as_T($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFordetails = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x7 = $m_Lio_circe_JsonObject$();
              var this$6 = $m_sci_Vector$();
              var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
              var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization));
              var $$x4 = $n(transformMemberNames).apply__O__O("date");
              var this$1 = $n(this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFordate);
              var $$x3 = $ct_T2__O__O__(new $c_T2(), $$x4, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordate));
              var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderForreference).apply__O__Lio_circe_Json(circeGenericHListBindingForreference));
              var $$x1 = $n(transformMemberNames).apply__O__O("details");
              var this$2 = $n(this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericEncoderFordetails);
              var array = [$$x6, $$x5, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFordetails))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x7).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderForreference, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("details"))), this.Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41__f_circeGenericDecoderFordetails, "details", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41 = new $TypeData().initClass({
  Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41: 0
}, false, "reactbuild.model.ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41", {
  Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41.prototype.$classData = $d_Lreactbuild_model_ReconcileInvoicePageWithDeliveryForm$anon$lazy$macro$43$5$$anon$41;
/** @constructor */
function $c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12(outer) {
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForname = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForcostByHour = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForcategory = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForrelease = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForname = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForcostByHour = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForcategory = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForrelease = null;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForcostByHour = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForcategory = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForrelease = new $c_Lio_circe_Decoder$$anon$39(d$2);
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForcostByHour = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForcategory = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
  this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForrelease = new $c_Lio_circe_Encoder$$anon$21(e$2)
}
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12.prototype.constructor = $c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12;
/** @constructor */
function $h_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12.prototype = $c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12.prototype;
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForcostByHour = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForcategory = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForentry = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForrelease = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p8)) {
                  var $$x1 = $m_Lio_circe_JsonObject$();
                  var this$4 = $m_sci_Vector$();
                  var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("costByHour"), $n(this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForcostByHour).apply__O__Lio_circe_Json(circeGenericHListBindingForcostByHour)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("category"), $n(this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForcategory).apply__O__Lio_circe_Json(circeGenericHListBindingForcategory)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("entry"), $n(this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForrelease).apply__O__Lio_circe_Json(circeGenericHListBindingForentry)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("release"), $n(this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericEncoderForrelease).apply__O__Lio_circe_Json(circeGenericHListBindingForrelease))];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                  return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("costByHour"))), this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForcostByHour, "costByHour", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("category"))), this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForcategory, "category", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("entry"))), this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForrelease, "entry", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("release"))), this.Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12__f_circeGenericDecoderForrelease, "release", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12 = new $TypeData().initClass({
  Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12: 0
}, false, "reactbuild.model.Resource$anon$lazy$macro$59$2$$anon$12", {
  Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12.prototype.$classData = $d_Lreactbuild_model_Resource$anon$lazy$macro$59$2$$anon$12;
/** @constructor */
function $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93(outer) {
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForDocument = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForPerson = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForPersonReference = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForProject = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForDocument = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForPerson = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForPersonReference = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForProject = null;
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer).inst$macro$33__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForDocument = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer).inst$macro$23__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForPerson = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer).inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForPersonReference = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForProject = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer).inst$macro$73__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForDocument = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer).inst$macro$63__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForPerson = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer).inst$macro$53__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForPersonReference = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_$outer).inst$macro$43__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForProject = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O())
}
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93.prototype.constructor = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93;
/** @constructor */
function $h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93() {
  /*<skip>*/
}
$h_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93.prototype = $c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93.prototype;
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForDocument = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForDocument instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForDocument);
    var circeGenericInlBindingForDocument = $as_Lreactbuild_model_SearchResult$Document($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForDocument;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Document"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForDocument, name, discriminator)
  } else if ((circeGenericInrBindingForDocument instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForDocument);
    var circeGenericInrBindingForPerson = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForPerson instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForPerson);
      var circeGenericInlBindingForPerson = $as_Lreactbuild_model_SearchResult$Person($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForPerson;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Person"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForPerson, name$1, discriminator)
    } else if ((circeGenericInrBindingForPerson instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForPerson);
      var circeGenericInrBindingForPersonReference = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForPersonReference instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForPersonReference);
        var circeGenericInlBindingForPersonReference = $as_Lreactbuild_model_SearchResult$PersonReference($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForPersonReference;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("PersonReference"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForPersonReference, name$2, discriminator)
      } else if ((circeGenericInrBindingForPersonReference instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForPersonReference);
        var circeGenericInrBindingForProject = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForProject instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForProject);
          var circeGenericInlBindingForProject = $as_Lreactbuild_model_SearchResult$Project($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericEncoderForProject;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("Project"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForProject, name$3, discriminator)
        } else if ((circeGenericInrBindingForProject instanceof $c_Lshapeless_Inr)) {
          $m_s_sys_package$().error__T__E("Cannot encode CNil")
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForProject)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForPersonReference)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForPerson)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForDocument)
  }
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForDocument, c, $as_T($n(transformConstructorNames).apply__O__O("Document")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_SearchResult$Document($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForPerson, c, $as_T($n(transformConstructorNames).apply__O__O("Person")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_SearchResult$Person($n(x2$4).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForPersonReference, c, $as_T($n(transformConstructorNames).apply__O__O("PersonReference")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_model_SearchResult$PersonReference($n(x2$6).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93__f_circeGenericDecoderForProject, c, $as_T($n(transformConstructorNames).apply__O__O("Project")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_model_SearchResult$Project($n(x2$8).s_util_Right__f_value);
              var x1$10 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$10 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            $m_Lio_circe_DecodingFailure$();
            var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
            var x1$9 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
            var err$5 = $as_Lio_circe_DecodingFailure(x1$9.s_util_Left__f_value);
            var x1$10 = new $c_s_util_Left(err$5)
          };
          if ((x1$10 instanceof $c_s_util_Right)) {
            var x2$10 = $as_s_util_Right(x1$10);
            var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$10).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
          } else {
            if ((!(x1$10 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$10)
            };
            var x3$6 = $as_s_util_Left(x1$10);
            var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$6)
          }
        };
        if ((x1$11 instanceof $c_s_util_Right)) {
          var x2$11 = $as_s_util_Right(x1$11);
          var v$7 = $as_Lshapeless_$colon$plus$colon($n(x2$11).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$7))
        } else {
          if ((!(x1$11 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$11)
          };
          var x3$7 = $as_s_util_Left(x1$11);
          var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$7)
        }
      };
      if ((x1$12 instanceof $c_s_util_Right)) {
        var x2$12 = $as_s_util_Right(x1$12);
        var v$8 = $as_Lshapeless_$colon$plus$colon($n(x2$12).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$8))
      } else if ((x1$12 instanceof $c_s_util_Left)) {
        var x3$8 = $as_s_util_Left(x1$12);
        var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
        return new $c_s_util_Left(err$8)
      } else {
        throw new $c_s_MatchError(x1$12)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93 = new $TypeData().initClass({
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93: 0
}, false, "reactbuild.model.SearchResult$anon$lazy$macro$83$4$$anon$93", {
  Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93.prototype.$classData = $d_Lreactbuild_model_SearchResult$anon$lazy$macro$83$4$$anon$93;
/** @constructor */
function $c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13(outer) {
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForpersons = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForsubject = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForattachments = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForcreated = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderFordone = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForpersons = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForsubject = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForattachments = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForcreated = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderFordone = null;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_TaskPerson$().Lreactbuild_model_TaskPerson$__f_codecForTaskPerson;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForpersons = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForsubject = $m_Lcom_iz2use_common_Multiline$().decodeMultiline__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var decodeA$1 = $m_Lreactbuild_model_TaskAttachment$().Lreactbuild_model_TaskAttachment$__f_codecForTaskAttachment;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForattachments = new $c_Lio_circe_Decoder$$anon$42(decodeA$1);
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForcreated = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderFordone = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_TaskPerson$().Lreactbuild_model_TaskPerson$__f_codecForTaskPerson;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForpersons = new $c_Lio_circe_Encoder$$anon$23(encodeA);
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForsubject = $m_Lcom_iz2use_common_Multiline$().encodeMultiline__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var encodeA$1 = $m_Lreactbuild_model_TaskAttachment$().Lreactbuild_model_TaskAttachment$__f_codecForTaskAttachment;
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForattachments = new $c_Lio_circe_Encoder$$anon$23(encodeA$1);
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForcreated = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderFordone = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13.prototype.constructor = $c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13;
/** @constructor */
function $h_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13.prototype = $c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13.prototype;
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForpersons = $as_sci_Seq($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForsubject = $n($as_Lcom_iz2use_common_Multiline($n(p4).Lshapeless_$colon$colon__f_head)).Lcom_iz2use_common_Multiline__f_underlying;
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForattachments = $as_sci_Seq($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForcreated = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingFordone = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p8)) {
                  var $$x7 = $m_Lio_circe_JsonObject$();
                  var this$6 = $m_sci_Vector$();
                  var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                  var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization));
                  var $$x4 = $n(transformMemberNames).apply__O__O("persons");
                  var this$1 = $n(this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForpersons);
                  var $$x3 = $ct_T2__O__O__(new $c_T2(), $$x4, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForpersons));
                  var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("subject"), $n(this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForsubject).apply__O__Lio_circe_Json(new $c_Lcom_iz2use_common_Multiline(circeGenericHListBindingForsubject)));
                  var $$x1 = $n(transformMemberNames).apply__O__O("attachments");
                  var this$2 = $n(this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForattachments);
                  var array = [$$x6, $$x5, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForattachments)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("created"), $n(this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderForcreated).apply__O__Lio_circe_Json(circeGenericHListBindingForcreated)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("done"), $n(this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericEncoderFordone).apply__O__Lio_circe_Json(circeGenericHListBindingFordone))];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                  return $n($$x7).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("persons"))), this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForpersons, "persons", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("subject"))), this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForsubject, "subject", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("attachments"))), this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForattachments, "attachments", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("created"))), this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderForcreated, "created", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("done"))), this.Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13__f_circeGenericDecoderFordone, "done", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13 = new $TypeData().initClass({
  Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13: 0
}, false, "reactbuild.model.Task$anon$lazy$macro$59$1$$anon$13", {
  Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13.prototype.$classData = $d_Lreactbuild_model_Task$anon$lazy$macro$59$1$$anon$13;
/** @constructor */
function $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4(outer) {
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForCommunicationTaskAttachment = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForFileTaskAttachment = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForProjectTaskAttachment = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForTaskTaskAttachment = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForCommunicationTaskAttachment = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForFileTaskAttachment = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForProjectTaskAttachment = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForTaskTaskAttachment = null;
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer).inst$macro$57__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForCommunicationTaskAttachment = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer).inst$macro$39__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForFileTaskAttachment = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer).inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForProjectTaskAttachment = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForTaskTaskAttachment = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer).inst$macro$129__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForCommunicationTaskAttachment = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer).inst$macro$111__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForFileTaskAttachment = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer).inst$macro$93__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForProjectTaskAttachment = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_$outer).inst$macro$75__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForTaskTaskAttachment = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O())
}
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4.prototype.constructor = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4;
/** @constructor */
function $h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4.prototype = $c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4.prototype;
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForCommunicationTaskAttachment = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForCommunicationTaskAttachment instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForCommunicationTaskAttachment);
    var circeGenericInlBindingForCommunicationTaskAttachment = $as_Lreactbuild_model_CommunicationTaskAttachment($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForCommunicationTaskAttachment;
    var name = $as_T($n(transformConstructorNames).apply__O__O("CommunicationTaskAttachment"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForCommunicationTaskAttachment, name, discriminator)
  } else if ((circeGenericInrBindingForCommunicationTaskAttachment instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForCommunicationTaskAttachment);
    var circeGenericInrBindingForFileTaskAttachment = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForFileTaskAttachment instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForFileTaskAttachment);
      var circeGenericInlBindingForFileTaskAttachment = $as_Lreactbuild_model_FileTaskAttachment($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForFileTaskAttachment;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("FileTaskAttachment"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForFileTaskAttachment, name$1, discriminator)
    } else if ((circeGenericInrBindingForFileTaskAttachment instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForFileTaskAttachment);
      var circeGenericInrBindingForProjectTaskAttachment = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForProjectTaskAttachment instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForProjectTaskAttachment);
        var circeGenericInlBindingForProjectTaskAttachment = $as_Lreactbuild_model_ProjectTaskAttachment($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForProjectTaskAttachment;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("ProjectTaskAttachment"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForProjectTaskAttachment, name$2, discriminator)
      } else if ((circeGenericInrBindingForProjectTaskAttachment instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForProjectTaskAttachment);
        var circeGenericInrBindingForTaskTaskAttachment = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForTaskTaskAttachment instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForTaskTaskAttachment);
          var circeGenericInlBindingForTaskTaskAttachment = $as_Lreactbuild_model_TaskTaskAttachment($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericEncoderForTaskTaskAttachment;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("TaskTaskAttachment"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForTaskTaskAttachment, name$3, discriminator)
        } else if ((circeGenericInrBindingForTaskTaskAttachment instanceof $c_Lshapeless_Inr)) {
          $m_s_sys_package$().error__T__E("Cannot encode CNil")
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForTaskTaskAttachment)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForProjectTaskAttachment)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForFileTaskAttachment)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForCommunicationTaskAttachment)
  }
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForCommunicationTaskAttachment, c, $as_T($n(transformConstructorNames).apply__O__O("CommunicationTaskAttachment")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_CommunicationTaskAttachment($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForFileTaskAttachment, c, $as_T($n(transformConstructorNames).apply__O__O("FileTaskAttachment")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_FileTaskAttachment($n(x2$4).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForProjectTaskAttachment, c, $as_T($n(transformConstructorNames).apply__O__O("ProjectTaskAttachment")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_model_ProjectTaskAttachment($n(x2$6).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4__f_circeGenericDecoderForTaskTaskAttachment, c, $as_T($n(transformConstructorNames).apply__O__O("TaskTaskAttachment")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_model_TaskTaskAttachment($n(x2$8).s_util_Right__f_value);
              var x1$10 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$10 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            $m_Lio_circe_DecodingFailure$();
            var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
            var x1$9 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
            var err$5 = $as_Lio_circe_DecodingFailure(x1$9.s_util_Left__f_value);
            var x1$10 = new $c_s_util_Left(err$5)
          };
          if ((x1$10 instanceof $c_s_util_Right)) {
            var x2$10 = $as_s_util_Right(x1$10);
            var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$10).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
          } else {
            if ((!(x1$10 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$10)
            };
            var x3$6 = $as_s_util_Left(x1$10);
            var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$6)
          }
        };
        if ((x1$11 instanceof $c_s_util_Right)) {
          var x2$11 = $as_s_util_Right(x1$11);
          var v$7 = $as_Lshapeless_$colon$plus$colon($n(x2$11).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$7))
        } else {
          if ((!(x1$11 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$11)
          };
          var x3$7 = $as_s_util_Left(x1$11);
          var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$7)
        }
      };
      if ((x1$12 instanceof $c_s_util_Right)) {
        var x2$12 = $as_s_util_Right(x1$12);
        var v$8 = $as_Lshapeless_$colon$plus$colon($n(x2$12).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$8))
      } else if ((x1$12 instanceof $c_s_util_Left)) {
        var x3$8 = $as_s_util_Left(x1$12);
        var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
        return new $c_s_util_Left(err$8)
      } else {
        throw new $c_s_MatchError(x1$12)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4 = new $TypeData().initClass({
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4: 0
}, false, "reactbuild.model.TaskAttachment$anon$lazy$macro$147$1$$anon$4", {
  Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4.prototype.$classData = $d_Lreactbuild_model_TaskAttachment$anon$lazy$macro$147$1$$anon$4;
/** @constructor */
function $c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3(outer) {
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForid = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForrole = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForuser = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForadded = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForid = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForrole = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForuser = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForadded = null;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForrole = $m_Lreactbuild_model_TaskRole$().Lreactbuild_model_TaskRole$__f_codecForTaskRole;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForuser = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForadded = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForrole = $m_Lreactbuild_model_TaskRole$().Lreactbuild_model_TaskRole$__f_codecForTaskRole;
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForuser = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForadded = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder()
}
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3.prototype.constructor = $c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3;
/** @constructor */
function $h_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3.prototype = $c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3.prototype;
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForrole = $as_Lreactbuild_model_TaskRole($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForuser = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForadded = $as_Ljava_time_Instant($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x3 = $m_Lio_circe_JsonObject$();
            var this$5 = $m_sci_Vector$();
            var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid));
            var $$x1 = $n(transformMemberNames).apply__O__O("role");
            var this$1 = $n(this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForrole);
            var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForrole)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("user"), $n(this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForuser).apply__O__Lio_circe_Json(circeGenericHListBindingForuser)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("added"), $n(this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericEncoderForadded).apply__O__Lio_circe_Json(circeGenericHListBindingForadded))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("role"))), this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForrole, "role", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("user"))), this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForuser, "user", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("added"))), this.Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3__f_circeGenericDecoderForadded, "added", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3 = new $TypeData().initClass({
  Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3: 0
}, false, "reactbuild.model.TaskPerson$anon$lazy$macro$35$1$$anon$3", {
  Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3.prototype.$classData = $d_Lreactbuild_model_TaskPerson$anon$lazy$macro$35$1$$anon$3;
/** @constructor */
function $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1(outer) {
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericDecoderForFrom = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericDecoderForTo = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericEncoderForFrom = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericEncoderForTo = null;
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericDecoderForFrom = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericDecoderForTo = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_$outer).inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericEncoderForFrom = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_$outer).inst$macro$6__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericEncoderForTo = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O())
}
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1.prototype.constructor = $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1.prototype = $c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1.prototype;
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForFrom = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForFrom instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForFrom);
    var circeGenericInlBindingForFrom = $as_Lreactbuild_model_TaskRole$From$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericEncoderForFrom;
    var name = $as_T($n(transformConstructorNames).apply__O__O("From"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForFrom, name, discriminator)
  } else if ((circeGenericInrBindingForFrom instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForFrom);
    var circeGenericInrBindingForTo = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForTo instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForTo);
      var circeGenericInlBindingForTo = $as_Lreactbuild_model_TaskRole$To$($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericEncoderForTo;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("To"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForTo, name$1, discriminator)
    } else if ((circeGenericInrBindingForTo instanceof $c_Lshapeless_Inr)) {
      $m_s_sys_package$().error__T__E("Cannot encode CNil")
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForTo)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForFrom)
  }
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericDecoderForFrom, c, $as_T($n(transformConstructorNames).apply__O__O("From")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_TaskRole$From$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1__f_circeGenericDecoderForTo, c, $as_T($n(transformConstructorNames).apply__O__O("To")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_TaskRole$To$($n(x2$4).s_util_Right__f_value);
          var x1$6 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$6 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        $m_Lio_circe_DecodingFailure$();
        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
        var x1$5 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
        var err$3 = $as_Lio_circe_DecodingFailure(x1$5.s_util_Left__f_value);
        var x1$6 = new $c_s_util_Left(err$3)
      };
      if ((x1$6 instanceof $c_s_util_Right)) {
        var x2$6 = $as_s_util_Right(x1$6);
        var v$4 = $as_Lshapeless_$colon$plus$colon($n(x2$6).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$4))
      } else if ((x1$6 instanceof $c_s_util_Left)) {
        var x3$4 = $as_s_util_Left(x1$6);
        var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
        return new $c_s_util_Left(err$4)
      } else {
        throw new $c_s_MatchError(x1$6)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1: 0
}, false, "reactbuild.model.TaskRole$anon$lazy$macro$9$1$$anon$1", {
  Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1.prototype.$classData = $d_Lreactbuild_model_TaskRole$anon$lazy$macro$9$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17(outer) {
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderForlabel = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderForparent = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderForlabel = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderForparent = null;
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderForlabel = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderForparent = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderForlabel = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderForparent = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17.prototype.constructor = $c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17;
/** @constructor */
function $h_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17() {
  /*<skip>*/
}
$h_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17.prototype = $c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17.prototype;
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForlabel = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForparent = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("label"), $n(this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderForlabel).apply__O__Lio_circe_Json(circeGenericHListBindingForlabel)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("parent"), $n(this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericEncoderForparent).apply__O__Lio_circe_Json(circeGenericHListBindingForparent))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("label"))), this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderForlabel, "label", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("parent"))), this.Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17__f_circeGenericDecoderForparent, "parent", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17 = new $TypeData().initClass({
  Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17: 0
}, false, "reactbuild.model.Term$anon$lazy$macro$35$4$$anon$17", {
  Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17.prototype.$classData = $d_Lreactbuild_model_Term$anon$lazy$macro$35$4$$anon$17;
/** @constructor */
function $c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9(outer) {
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForresource = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForbuildingSite = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForbuildingStage = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForduration = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForcomments = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForresource = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForbuildingSite = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForbuildingStage = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForduration = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForcomments = null;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderFordate = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForresource = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForbuildingSite = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForbuildingStage = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForduration = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_decodeDuration;
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForcomments = new $c_Lio_circe_Decoder$$anon$39(d$1);
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderFordate = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForresource = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForbuildingSite = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForbuildingStage = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForduration = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_encodeDuration;
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForcomments = new $c_Lio_circe_Encoder$$anon$21(e$1)
}
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9.prototype.constructor = $c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9;
/** @constructor */
function $h_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9.prototype = $c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9.prototype;
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFordate = $as_Ljava_time_LocalDate($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForresource = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForbuildingSite = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForbuildingStage = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForduration = $as_Lreactbuild_model_Duration($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForcomments = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p8)) {
                  var $$x1 = $m_Lio_circe_JsonObject$();
                  var this$4 = $m_sci_Vector$();
                  var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("resource"), $n(this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForresource).apply__O__Lio_circe_Json(circeGenericHListBindingForresource)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("buildingSite"), $n(this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForbuildingSite).apply__O__Lio_circe_Json(circeGenericHListBindingForbuildingSite)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("buildingStage"), $n(this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForbuildingStage).apply__O__Lio_circe_Json(circeGenericHListBindingForbuildingStage)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("duration"), $n(this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForduration).apply__O__Lio_circe_Json(circeGenericHListBindingForduration)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("comments"), $n(this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericEncoderForcomments).apply__O__Lio_circe_Json(circeGenericHListBindingForcomments))];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                  return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("resource"))), this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForresource, "resource", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingSite"))), this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForbuildingSite, "buildingSite", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("buildingStage"))), this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForbuildingStage, "buildingStage", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("duration"))), this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForduration, "duration", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("comments"))), this.Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9__f_circeGenericDecoderForcomments, "comments", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9 = new $TypeData().initClass({
  Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9: 0
}, false, "reactbuild.model.TimeReport$anon$lazy$macro$59$1$$anon$9", {
  Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9.prototype.$classData = $d_Lreactbuild_model_TimeReport$anon$lazy$macro$59$1$$anon$9;
/** @constructor */
function $c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10(outer) {
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderForresource = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFormanuallyAdded = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderForresource = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFormanuallyAdded = null;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderForresource = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFordate = $m_Lio_circe_Decoder$().decodeLocalDateTime__Lio_circe_Decoder();
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFormanuallyAdded = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeBoolean;
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderForresource = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFordate = $m_Lio_circe_Encoder$().encodeLocalDateTime__Lio_circe_Encoder();
  this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFormanuallyAdded = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean
}
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10.prototype.constructor = $c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10;
/** @constructor */
function $h_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10.prototype = $c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10.prototype;
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForresource = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFordate = $as_Ljava_time_LocalDateTime($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForignore = $uZ($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFormanuallyAdded = $uZ($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x1 = $m_Lio_circe_JsonObject$();
              var this$4 = $m_sci_Vector$();
              var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("resource"), $n(this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderForresource).apply__O__Lio_circe_Json(circeGenericHListBindingForresource)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("ignore"), $n(this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFormanuallyAdded).apply__O__Lio_circe_Json(circeGenericHListBindingForignore)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("manuallyAdded"), $n(this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericEncoderFormanuallyAdded).apply__O__Lio_circe_Json(circeGenericHListBindingFormanuallyAdded))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("resource"))), this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderForresource, "resource", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("ignore"))), this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFormanuallyAdded, "ignore", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("manuallyAdded"))), this.Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10__f_circeGenericDecoderFormanuallyAdded, "manuallyAdded", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10 = new $TypeData().initClass({
  Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10: 0
}, false, "reactbuild.model.TimeReportEvent$anon$lazy$macro$43$2$$anon$10", {
  Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10.prototype.$classData = $d_Lreactbuild_model_TimeReportEvent$anon$lazy$macro$43$2$$anon$10;
/** @constructor */
function $c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26(outer) {
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderForname = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderForelements = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderForname = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderForelements = null;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_model_process_ProcessElement$().Lreactbuild_model_process_ProcessElement$__f_codecForProcessElement;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderForelements = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_model_process_ProcessElement$().Lreactbuild_model_process_ProcessElement$__f_codecForProcessElement;
  this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderForelements = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26.prototype.constructor = $c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26;
/** @constructor */
function $h_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26.prototype = $c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26.prototype;
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForelements = $as_sci_List($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x5 = $m_Lio_circe_JsonObject$();
            var this$5 = $m_sci_Vector$();
            var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
            var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization));
            var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname));
            var $$x1 = $n(transformMemberNames).apply__O__O("elements");
            var this$1 = $n(this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericEncoderForelements);
            var array = [$$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForelements))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x5).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("elements"))), this.Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26__f_circeGenericDecoderForelements, "elements", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26 = new $TypeData().initClass({
  Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26: 0
}, false, "reactbuild.model.process.Process$anon$lazy$macro$35$1$$anon$26", {
  Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26.prototype.$classData = $d_Lreactbuild_model_process_Process$anon$lazy$macro$35$1$$anon$26;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1(outer) {
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericDecoderForProcessEdge = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericDecoderForProcessNode = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericEncoderForProcessEdge = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericEncoderForProcessNode = null;
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_$outer).inst$macro$29__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericDecoderForProcessEdge = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericDecoderForProcessNode = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_$outer).inst$macro$89__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericEncoderForProcessEdge = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_$outer).inst$macro$63__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericEncoderForProcessNode = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O())
}
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1.prototype.constructor = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1.prototype = $c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1.prototype;
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForProcessEdge = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForProcessEdge instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForProcessEdge);
    var circeGenericInlBindingForProcessEdge = $as_Lreactbuild_model_process_ProcessEdge($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericEncoderForProcessEdge;
    var name = $as_T($n(transformConstructorNames).apply__O__O("ProcessEdge"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForProcessEdge, name, discriminator)
  } else if ((circeGenericInrBindingForProcessEdge instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForProcessEdge);
    var circeGenericInrBindingForProcessNode = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForProcessNode instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForProcessNode);
      var circeGenericInlBindingForProcessNode = $as_Lreactbuild_model_process_ProcessNode($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericEncoderForProcessNode;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("ProcessNode"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForProcessNode, name$1, discriminator)
    } else if ((circeGenericInrBindingForProcessNode instanceof $c_Lshapeless_Inr)) {
      $m_s_sys_package$().error__T__E("Cannot encode CNil")
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForProcessNode)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForProcessEdge)
  }
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericDecoderForProcessEdge, c, $as_T($n(transformConstructorNames).apply__O__O("ProcessEdge")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_process_ProcessEdge($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1__f_circeGenericDecoderForProcessNode, c, $as_T($n(transformConstructorNames).apply__O__O("ProcessNode")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_process_ProcessNode($n(x2$4).s_util_Right__f_value);
          var x1$6 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$6 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        $m_Lio_circe_DecodingFailure$();
        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
        var x1$5 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
        var err$3 = $as_Lio_circe_DecodingFailure(x1$5.s_util_Left__f_value);
        var x1$6 = new $c_s_util_Left(err$3)
      };
      if ((x1$6 instanceof $c_s_util_Right)) {
        var x2$6 = $as_s_util_Right(x1$6);
        var v$4 = $as_Lshapeless_$colon$plus$colon($n(x2$6).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$4))
      } else if ((x1$6 instanceof $c_s_util_Left)) {
        var x3$4 = $as_s_util_Left(x1$6);
        var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
        return new $c_s_util_Left(err$4)
      } else {
        throw new $c_s_MatchError(x1$6)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1: 0
}, false, "reactbuild.model.process.ProcessElement$anon$lazy$macro$123$1$$anon$1", {
  Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1.prototype.$classData = $d_Lreactbuild_model_process_ProcessElement$anon$lazy$macro$123$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderForparents = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderForuser = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderFordetails = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderForinstant = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderForparents = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderForuser = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderFordetails = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderForinstant = null;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderForparents = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderForuser = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderFordate = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderFordetails = $m_Lreactbuild_model_process_ProcessInstanceEventDetails$().Lreactbuild_model_process_ProcessInstanceEventDetails$__f_codecForProcessInstanceEventDetails;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderForinstant = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderForparents = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderForuser = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderFordate = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderFordetails = $m_Lreactbuild_model_process_ProcessInstanceEventDetails$().Lreactbuild_model_process_ProcessInstanceEventDetails$__f_codecForProcessInstanceEventDetails;
  this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderForinstant = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder()
}
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10.prototype = $c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForparents = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForuser = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFordate = $as_Ljava_time_LocalDate($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFordetails = $as_Lreactbuild_model_process_ProcessInstanceEventDetails($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForinstant = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p7)) {
                var $$x7 = $m_Lio_circe_JsonObject$();
                var this$6 = $m_sci_Vector$();
                var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                var $$x5 = $n(transformMemberNames).apply__O__O("parents");
                var this$1 = $n(this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderForparents);
                var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForparents));
                var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("user"), $n(this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderForuser).apply__O__Lio_circe_Json(circeGenericHListBindingForuser));
                var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("date"), $n(this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderFordate).apply__O__Lio_circe_Json(circeGenericHListBindingFordate));
                var $$x1 = $n(transformMemberNames).apply__O__O("details");
                var this$2 = $n(this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderFordetails);
                var array = [$$x6, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFordetails)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("instant"), $n(this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericEncoderForinstant).apply__O__Lio_circe_Json(circeGenericHListBindingForinstant))];
                var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                return $n($$x7).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("parents"))), this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderForparents, "parents", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("user"))), this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderForuser, "user", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("details"))), this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderFordetails, "details", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("instant"))), this.Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10__f_circeGenericDecoderForinstant, "instant", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10: 0
}, false, "reactbuild.model.process.ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10", {
  Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEvent$anon$lazy$macro$51$1$$anon$10;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14(outer) {
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForComment = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForDone = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForInstantiate = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForLink = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForSetStepDate = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForComment = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForDone = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForInstantiate = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForLink = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForSetStepDate = null;
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$59__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForComment = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$49__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForDone = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$31__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForInstantiate = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForLink = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForSetStepDate = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$125__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForComment = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$115__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForDone = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$97__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForInstantiate = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O());
  var t$8 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$87__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForLink = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$8).value__O());
  var t$9 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_$outer).inst$macro$69__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForSetStepDate = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$9).value__O())
}
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14.prototype.constructor = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14.prototype = $c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14.prototype;
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForComment = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForComment instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForComment);
    var circeGenericInlBindingForComment = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForComment;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Comment"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForComment, name, discriminator)
  } else if ((circeGenericInrBindingForComment instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForComment);
    var circeGenericInrBindingForDone = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForDone instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForDone);
      var circeGenericInlBindingForDone = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Done($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForDone;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Done"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForDone, name$1, discriminator)
    } else if ((circeGenericInrBindingForDone instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForDone);
      var circeGenericInrBindingForInstantiate = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForInstantiate instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForInstantiate);
        var circeGenericInlBindingForInstantiate = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForInstantiate;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Instantiate"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForInstantiate, name$2, discriminator)
      } else if ((circeGenericInrBindingForInstantiate instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForInstantiate);
        var circeGenericInrBindingForLink = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForLink instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForLink);
          var circeGenericInlBindingForLink = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Link($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForLink;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("Link"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForLink, name$3, discriminator)
        } else if ((circeGenericInrBindingForLink instanceof $c_Lshapeless_Inr)) {
          var x3$4 = $as_Lshapeless_Inr(circeGenericInrBindingForLink);
          var circeGenericInrBindingForSetStepDate = $as_Lshapeless_$colon$plus$colon($n(x3$4).Lshapeless_Inr__f_tail);
          if ((circeGenericInrBindingForSetStepDate instanceof $c_Lshapeless_Inl)) {
            var x2$5 = $as_Lshapeless_Inl(circeGenericInrBindingForSetStepDate);
            var circeGenericInlBindingForSetStepDate = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate($n(x2$5).Lshapeless_Inl__f_head);
            var encode$4 = this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericEncoderForSetStepDate;
            var name$4 = $as_T($n(transformConstructorNames).apply__O__O("SetStepDate"));
            return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$4, circeGenericInlBindingForSetStepDate, name$4, discriminator)
          } else if ((circeGenericInrBindingForSetStepDate instanceof $c_Lshapeless_Inr)) {
            $m_s_sys_package$().error__T__E("Cannot encode CNil")
          } else {
            throw new $c_s_MatchError(circeGenericInrBindingForSetStepDate)
          }
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForLink)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForInstantiate)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForDone)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForComment)
  }
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForComment, c, $as_T($n(transformConstructorNames).apply__O__O("Comment")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Comment($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForDone, c, $as_T($n(transformConstructorNames).apply__O__O("Done")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Done($n(x2$4).s_util_Right__f_value);
          var x1$15 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$15 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForInstantiate, c, $as_T($n(transformConstructorNames).apply__O__O("Instantiate")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Instantiate($n(x2$6).s_util_Right__f_value);
            var x1$14 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$14 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForLink, c, $as_T($n(transformConstructorNames).apply__O__O("Link")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$Link($n(x2$8).s_util_Right__f_value);
              var x1$13 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$13 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            var x1$9 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14__f_circeGenericDecoderForSetStepDate, c, $as_T($n(transformConstructorNames).apply__O__O("SetStepDate")), discriminator);
            if ((x1$9 instanceof $c_s_Some)) {
              var x2$9 = $as_s_Some(x1$9);
              var result$5 = $as_s_util_Either($n(x2$9).s_Some__f_value);
              if ((result$5 instanceof $c_s_util_Right)) {
                var x2$10 = $as_s_util_Right(result$5);
                var v$5 = $as_Lreactbuild_model_process_ProcessInstanceEventDetails$SetStepDate($n(x2$10).s_util_Right__f_value);
                var x1$12 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$5))
              } else {
                if ((!(result$5 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(result$5)
                };
                var x3$5 = $as_s_util_Left(result$5);
                var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
                var x1$12 = new $c_s_util_Left(err$5)
              }
            } else {
              var x$9 = $m_s_None$();
              if ((!(x$9 === x1$9))) {
                throw new $c_s_MatchError(x1$9)
              };
              $m_Lio_circe_DecodingFailure$();
              var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
              var x1$11 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
              var err$6 = $as_Lio_circe_DecodingFailure(x1$11.s_util_Left__f_value);
              var x1$12 = new $c_s_util_Left(err$6)
            };
            if ((x1$12 instanceof $c_s_util_Right)) {
              var x2$12 = $as_s_util_Right(x1$12);
              var v$7 = $as_Lshapeless_$colon$plus$colon($n(x2$12).s_util_Right__f_value);
              var x1$13 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$7))
            } else {
              if ((!(x1$12 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(x1$12)
              };
              var x3$7 = $as_s_util_Left(x1$12);
              var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
              var x1$13 = new $c_s_util_Left(err$7)
            }
          };
          if ((x1$13 instanceof $c_s_util_Right)) {
            var x2$13 = $as_s_util_Right(x1$13);
            var v$8 = $as_Lshapeless_$colon$plus$colon($n(x2$13).s_util_Right__f_value);
            var x1$14 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$8))
          } else {
            if ((!(x1$13 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$13)
            };
            var x3$8 = $as_s_util_Left(x1$13);
            var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
            var x1$14 = new $c_s_util_Left(err$8)
          }
        };
        if ((x1$14 instanceof $c_s_util_Right)) {
          var x2$14 = $as_s_util_Right(x1$14);
          var v$9 = $as_Lshapeless_$colon$plus$colon($n(x2$14).s_util_Right__f_value);
          var x1$15 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$9))
        } else {
          if ((!(x1$14 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$14)
          };
          var x3$9 = $as_s_util_Left(x1$14);
          var err$9 = $as_Lio_circe_DecodingFailure($n(x3$9).s_util_Left__f_value);
          var x1$15 = new $c_s_util_Left(err$9)
        }
      };
      if ((x1$15 instanceof $c_s_util_Right)) {
        var x2$15 = $as_s_util_Right(x1$15);
        var v$10 = $as_Lshapeless_$colon$plus$colon($n(x2$15).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$10))
      } else if ((x1$15 instanceof $c_s_util_Left)) {
        var x3$10 = $as_s_util_Left(x1$15);
        var err$10 = $as_Lio_circe_DecodingFailure($n(x3$10).s_util_Left__f_value);
        return new $c_s_util_Left(err$10)
      } else {
        throw new $c_s_MatchError(x1$15)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14: 0
}, false, "reactbuild.model.process.ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14", {
  Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14.prototype.$classData = $d_Lreactbuild_model_process_ProcessInstanceEventDetails$anon$lazy$macro$135$1$$anon$14;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13(outer) {
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericDecoderForref = null;
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericDecoderForcls = null;
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericEncoderForref = null;
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericEncoderForcls = null;
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericDecoderForref = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericDecoderForcls = $m_Lreactbuild_model_process_ProcessLinkClass$().Lreactbuild_model_process_ProcessLinkClass$__f_codecForProcessLinkClass;
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericEncoderForref = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericEncoderForcls = $m_Lreactbuild_model_process_ProcessLinkClass$().Lreactbuild_model_process_ProcessLinkClass$__f_codecForProcessLinkClass
}
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13.prototype.constructor = $c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13.prototype = $c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13.prototype;
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForref = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForcls = $as_Lreactbuild_model_process_ProcessLinkClass($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x3 = $m_Lio_circe_JsonObject$();
        var this$5 = $m_sci_Vector$();
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("ref"), $n(this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericEncoderForref).apply__O__Lio_circe_Json(circeGenericHListBindingForref));
        var $$x1 = $n(transformMemberNames).apply__O__O("cls");
        var this$1 = $n(this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericEncoderForcls);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForcls))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("ref"))), this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericDecoderForref, "ref", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("cls"))), this.Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13__f_circeGenericDecoderForcls, "cls", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13: 0
}, false, "reactbuild.model.process.ProcessLink$anon$lazy$macro$19$1$$anon$13", {
  Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13.prototype.$classData = $d_Lreactbuild_model_process_ProcessLink$anon$lazy$macro$19$1$$anon$13;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11(outer) {
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericDecoderForPerson = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericDecoderForProject = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericEncoderForPerson = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericEncoderForProject = null;
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericDecoderForPerson = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericDecoderForProject = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_$outer).inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericEncoderForPerson = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_$outer).inst$macro$6__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericEncoderForProject = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O())
}
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11.prototype.constructor = $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11.prototype = $c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11.prototype;
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForPerson = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForPerson instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForPerson);
    var circeGenericInlBindingForPerson = $as_Lreactbuild_model_process_ProcessLinkClass$Person$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericEncoderForPerson;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Person"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForPerson, name, discriminator)
  } else if ((circeGenericInrBindingForPerson instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForPerson);
    var circeGenericInrBindingForProject = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForProject instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForProject);
      var circeGenericInlBindingForProject = $as_Lreactbuild_model_process_ProcessLinkClass$Project$($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericEncoderForProject;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Project"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForProject, name$1, discriminator)
    } else if ((circeGenericInrBindingForProject instanceof $c_Lshapeless_Inr)) {
      $m_s_sys_package$().error__T__E("Cannot encode CNil")
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForProject)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForPerson)
  }
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericDecoderForPerson, c, $as_T($n(transformConstructorNames).apply__O__O("Person")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_process_ProcessLinkClass$Person$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11__f_circeGenericDecoderForProject, c, $as_T($n(transformConstructorNames).apply__O__O("Project")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_process_ProcessLinkClass$Project$($n(x2$4).s_util_Right__f_value);
          var x1$6 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$6 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        $m_Lio_circe_DecodingFailure$();
        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
        var x1$5 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
        var err$3 = $as_Lio_circe_DecodingFailure(x1$5.s_util_Left__f_value);
        var x1$6 = new $c_s_util_Left(err$3)
      };
      if ((x1$6 instanceof $c_s_util_Right)) {
        var x2$6 = $as_s_util_Right(x1$6);
        var v$4 = $as_Lshapeless_$colon$plus$colon($n(x2$6).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$4))
      } else if ((x1$6 instanceof $c_s_util_Left)) {
        var x3$4 = $as_s_util_Left(x1$6);
        var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
        return new $c_s_util_Left(err$4)
      } else {
        throw new $c_s_MatchError(x1$6)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11: 0
}, false, "reactbuild.model.process.ProcessLinkClass$anon$lazy$macro$9$1$$anon$11", {
  Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11.prototype.$classData = $d_Lreactbuild_model_process_ProcessLinkClass$anon$lazy$macro$9$1$$anon$11;
/** @constructor */
function $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6(outer) {
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForAsk = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForEnd = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForMilestone = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForReceive = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForSend = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForStart = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForUserActivity = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForUserInput = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForWait = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForAsk = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForEnd = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForMilestone = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForReceive = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForSend = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForStart = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForUserActivity = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForUserInput = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForWait = null;
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForAsk = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$20__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForEnd = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$19__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForMilestone = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$18__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForReceive = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$17__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForSend = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$16__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForStart = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$15__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForUserActivity = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForUserInput = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O());
  var t$8 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForWait = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$8).value__O());
  var t$9 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$40__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForAsk = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$9).value__O());
  var t$10 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$39__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForEnd = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$10).value__O());
  var t$11 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$38__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForMilestone = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$11).value__O());
  var t$12 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$37__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForReceive = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$12).value__O());
  var t$13 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$36__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForSend = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$13).value__O());
  var t$14 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$35__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForStart = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$14).value__O());
  var t$15 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$34__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForUserActivity = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$15).value__O());
  var t$16 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$32__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForUserInput = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$16).value__O());
  var t$17 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_$outer).inst$macro$22__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForWait = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$17).value__O())
}
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6.prototype.constructor = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6.prototype = $c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6.prototype;
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForAsk = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForAsk instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForAsk);
    var circeGenericInlBindingForAsk = $as_Lreactbuild_model_process_ProcessNodeDetails$Ask($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForAsk;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Ask"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForAsk, name, discriminator)
  } else if ((circeGenericInrBindingForAsk instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForAsk);
    var circeGenericInrBindingForEnd = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForEnd instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForEnd);
      var circeGenericInlBindingForEnd = $as_Lreactbuild_model_process_ProcessNodeDetails$End($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForEnd;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("End"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForEnd, name$1, discriminator)
    } else if ((circeGenericInrBindingForEnd instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForEnd);
      var circeGenericInrBindingForMilestone = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForMilestone instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForMilestone);
        var circeGenericInlBindingForMilestone = $as_Lreactbuild_model_process_ProcessNodeDetails$Milestone($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForMilestone;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Milestone"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForMilestone, name$2, discriminator)
      } else if ((circeGenericInrBindingForMilestone instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForMilestone);
        var circeGenericInrBindingForReceive = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForReceive instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForReceive);
          var circeGenericInlBindingForReceive = $as_Lreactbuild_model_process_ProcessNodeDetails$Receive($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForReceive;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("Receive"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForReceive, name$3, discriminator)
        } else if ((circeGenericInrBindingForReceive instanceof $c_Lshapeless_Inr)) {
          var x3$4 = $as_Lshapeless_Inr(circeGenericInrBindingForReceive);
          var circeGenericInrBindingForSend = $as_Lshapeless_$colon$plus$colon($n(x3$4).Lshapeless_Inr__f_tail);
          if ((circeGenericInrBindingForSend instanceof $c_Lshapeless_Inl)) {
            var x2$5 = $as_Lshapeless_Inl(circeGenericInrBindingForSend);
            var circeGenericInlBindingForSend = $as_Lreactbuild_model_process_ProcessNodeDetails$Send($n(x2$5).Lshapeless_Inl__f_head);
            var encode$4 = this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForSend;
            var name$4 = $as_T($n(transformConstructorNames).apply__O__O("Send"));
            return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$4, circeGenericInlBindingForSend, name$4, discriminator)
          } else if ((circeGenericInrBindingForSend instanceof $c_Lshapeless_Inr)) {
            var x3$5 = $as_Lshapeless_Inr(circeGenericInrBindingForSend);
            var circeGenericInrBindingForStart = $as_Lshapeless_$colon$plus$colon($n(x3$5).Lshapeless_Inr__f_tail);
            if ((circeGenericInrBindingForStart instanceof $c_Lshapeless_Inl)) {
              var x2$6 = $as_Lshapeless_Inl(circeGenericInrBindingForStart);
              var circeGenericInlBindingForStart = $as_Lreactbuild_model_process_ProcessNodeDetails$Start($n(x2$6).Lshapeless_Inl__f_head);
              var encode$5 = this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForStart;
              var name$5 = $as_T($n(transformConstructorNames).apply__O__O("Start"));
              return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$5, circeGenericInlBindingForStart, name$5, discriminator)
            } else if ((circeGenericInrBindingForStart instanceof $c_Lshapeless_Inr)) {
              var x3$6 = $as_Lshapeless_Inr(circeGenericInrBindingForStart);
              var circeGenericInrBindingForUserActivity = $as_Lshapeless_$colon$plus$colon($n(x3$6).Lshapeless_Inr__f_tail);
              if ((circeGenericInrBindingForUserActivity instanceof $c_Lshapeless_Inl)) {
                var x2$7 = $as_Lshapeless_Inl(circeGenericInrBindingForUserActivity);
                var circeGenericInlBindingForUserActivity = $as_Lreactbuild_model_process_ProcessNodeDetails$UserActivity($n(x2$7).Lshapeless_Inl__f_head);
                var encode$6 = this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForUserActivity;
                var name$6 = $as_T($n(transformConstructorNames).apply__O__O("UserActivity"));
                return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$6, circeGenericInlBindingForUserActivity, name$6, discriminator)
              } else if ((circeGenericInrBindingForUserActivity instanceof $c_Lshapeless_Inr)) {
                var x3$7 = $as_Lshapeless_Inr(circeGenericInrBindingForUserActivity);
                var circeGenericInrBindingForUserInput = $as_Lshapeless_$colon$plus$colon($n(x3$7).Lshapeless_Inr__f_tail);
                if ((circeGenericInrBindingForUserInput instanceof $c_Lshapeless_Inl)) {
                  var x2$8 = $as_Lshapeless_Inl(circeGenericInrBindingForUserInput);
                  var circeGenericInlBindingForUserInput = $as_Lreactbuild_model_process_ProcessNodeDetails$UserInput($n(x2$8).Lshapeless_Inl__f_head);
                  var encode$7 = this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForUserInput;
                  var name$7 = $as_T($n(transformConstructorNames).apply__O__O("UserInput"));
                  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$7, circeGenericInlBindingForUserInput, name$7, discriminator)
                } else if ((circeGenericInrBindingForUserInput instanceof $c_Lshapeless_Inr)) {
                  var x3$8 = $as_Lshapeless_Inr(circeGenericInrBindingForUserInput);
                  var circeGenericInrBindingForWait = $as_Lshapeless_$colon$plus$colon($n(x3$8).Lshapeless_Inr__f_tail);
                  if ((circeGenericInrBindingForWait instanceof $c_Lshapeless_Inl)) {
                    var x2$9 = $as_Lshapeless_Inl(circeGenericInrBindingForWait);
                    var circeGenericInlBindingForWait = $as_Lreactbuild_model_process_ProcessNodeDetails$Wait($n(x2$9).Lshapeless_Inl__f_head);
                    var encode$8 = this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericEncoderForWait;
                    var name$8 = $as_T($n(transformConstructorNames).apply__O__O("Wait"));
                    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$8, circeGenericInlBindingForWait, name$8, discriminator)
                  } else if ((circeGenericInrBindingForWait instanceof $c_Lshapeless_Inr)) {
                    $m_s_sys_package$().error__T__E("Cannot encode CNil")
                  } else {
                    throw new $c_s_MatchError(circeGenericInrBindingForWait)
                  }
                } else {
                  throw new $c_s_MatchError(circeGenericInrBindingForUserInput)
                }
              } else {
                throw new $c_s_MatchError(circeGenericInrBindingForUserActivity)
              }
            } else {
              throw new $c_s_MatchError(circeGenericInrBindingForStart)
            }
          } else {
            throw new $c_s_MatchError(circeGenericInrBindingForSend)
          }
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForReceive)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForMilestone)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForEnd)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForAsk)
  }
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForAsk, c, $as_T($n(transformConstructorNames).apply__O__O("Ask")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_model_process_ProcessNodeDetails$Ask($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForEnd, c, $as_T($n(transformConstructorNames).apply__O__O("End")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_model_process_ProcessNodeDetails$End($n(x2$4).s_util_Right__f_value);
          var x1$27 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$27 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForMilestone, c, $as_T($n(transformConstructorNames).apply__O__O("Milestone")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_model_process_ProcessNodeDetails$Milestone($n(x2$6).s_util_Right__f_value);
            var x1$26 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$26 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForReceive, c, $as_T($n(transformConstructorNames).apply__O__O("Receive")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_model_process_ProcessNodeDetails$Receive($n(x2$8).s_util_Right__f_value);
              var x1$25 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$25 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            var x1$9 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForSend, c, $as_T($n(transformConstructorNames).apply__O__O("Send")), discriminator);
            if ((x1$9 instanceof $c_s_Some)) {
              var x2$9 = $as_s_Some(x1$9);
              var result$5 = $as_s_util_Either($n(x2$9).s_Some__f_value);
              if ((result$5 instanceof $c_s_util_Right)) {
                var x2$10 = $as_s_util_Right(result$5);
                var v$5 = $as_Lreactbuild_model_process_ProcessNodeDetails$Send($n(x2$10).s_util_Right__f_value);
                var x1$24 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$5))
              } else {
                if ((!(result$5 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(result$5)
                };
                var x3$5 = $as_s_util_Left(result$5);
                var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
                var x1$24 = new $c_s_util_Left(err$5)
              }
            } else {
              var x$9 = $m_s_None$();
              if ((!(x$9 === x1$9))) {
                throw new $c_s_MatchError(x1$9)
              };
              var x1$11 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForStart, c, $as_T($n(transformConstructorNames).apply__O__O("Start")), discriminator);
              if ((x1$11 instanceof $c_s_Some)) {
                var x2$11 = $as_s_Some(x1$11);
                var result$6 = $as_s_util_Either($n(x2$11).s_Some__f_value);
                if ((result$6 instanceof $c_s_util_Right)) {
                  var x2$12 = $as_s_util_Right(result$6);
                  var v$6 = $as_Lreactbuild_model_process_ProcessNodeDetails$Start($n(x2$12).s_util_Right__f_value);
                  var x1$23 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$6))
                } else {
                  if ((!(result$6 instanceof $c_s_util_Left))) {
                    throw new $c_s_MatchError(result$6)
                  };
                  var x3$6 = $as_s_util_Left(result$6);
                  var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
                  var x1$23 = new $c_s_util_Left(err$6)
                }
              } else {
                var x$11 = $m_s_None$();
                if ((!(x$11 === x1$11))) {
                  throw new $c_s_MatchError(x1$11)
                };
                var x1$13 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForUserActivity, c, $as_T($n(transformConstructorNames).apply__O__O("UserActivity")), discriminator);
                if ((x1$13 instanceof $c_s_Some)) {
                  var x2$13 = $as_s_Some(x1$13);
                  var result$7 = $as_s_util_Either($n(x2$13).s_Some__f_value);
                  if ((result$7 instanceof $c_s_util_Right)) {
                    var x2$14 = $as_s_util_Right(result$7);
                    var v$7 = $as_Lreactbuild_model_process_ProcessNodeDetails$UserActivity($n(x2$14).s_util_Right__f_value);
                    var x1$22 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$7))
                  } else {
                    if ((!(result$7 instanceof $c_s_util_Left))) {
                      throw new $c_s_MatchError(result$7)
                    };
                    var x3$7 = $as_s_util_Left(result$7);
                    var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
                    var x1$22 = new $c_s_util_Left(err$7)
                  }
                } else {
                  var x$13 = $m_s_None$();
                  if ((!(x$13 === x1$13))) {
                    throw new $c_s_MatchError(x1$13)
                  };
                  var x1$15 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForUserInput, c, $as_T($n(transformConstructorNames).apply__O__O("UserInput")), discriminator);
                  if ((x1$15 instanceof $c_s_Some)) {
                    var x2$15 = $as_s_Some(x1$15);
                    var result$8 = $as_s_util_Either($n(x2$15).s_Some__f_value);
                    if ((result$8 instanceof $c_s_util_Right)) {
                      var x2$16 = $as_s_util_Right(result$8);
                      var v$8 = $as_Lreactbuild_model_process_ProcessNodeDetails$UserInput($n(x2$16).s_util_Right__f_value);
                      var x1$21 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$8))
                    } else {
                      if ((!(result$8 instanceof $c_s_util_Left))) {
                        throw new $c_s_MatchError(result$8)
                      };
                      var x3$8 = $as_s_util_Left(result$8);
                      var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
                      var x1$21 = new $c_s_util_Left(err$8)
                    }
                  } else {
                    var x$15 = $m_s_None$();
                    if ((!(x$15 === x1$15))) {
                      throw new $c_s_MatchError(x1$15)
                    };
                    var x1$17 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6__f_circeGenericDecoderForWait, c, $as_T($n(transformConstructorNames).apply__O__O("Wait")), discriminator);
                    if ((x1$17 instanceof $c_s_Some)) {
                      var x2$17 = $as_s_Some(x1$17);
                      var result$9 = $as_s_util_Either($n(x2$17).s_Some__f_value);
                      if ((result$9 instanceof $c_s_util_Right)) {
                        var x2$18 = $as_s_util_Right(result$9);
                        var v$9 = $as_Lreactbuild_model_process_ProcessNodeDetails$Wait($n(x2$18).s_util_Right__f_value);
                        var x1$20 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$9))
                      } else {
                        if ((!(result$9 instanceof $c_s_util_Left))) {
                          throw new $c_s_MatchError(result$9)
                        };
                        var x3$9 = $as_s_util_Left(result$9);
                        var err$9 = $as_Lio_circe_DecodingFailure($n(x3$9).s_util_Left__f_value);
                        var x1$20 = new $c_s_util_Left(err$9)
                      }
                    } else {
                      var x$17 = $m_s_None$();
                      if ((!(x$17 === x1$17))) {
                        throw new $c_s_MatchError(x1$17)
                      };
                      $m_Lio_circe_DecodingFailure$();
                      var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
                      var x1$19 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
                      var err$10 = $as_Lio_circe_DecodingFailure(x1$19.s_util_Left__f_value);
                      var x1$20 = new $c_s_util_Left(err$10)
                    };
                    if ((x1$20 instanceof $c_s_util_Right)) {
                      var x2$20 = $as_s_util_Right(x1$20);
                      var v$11 = $as_Lshapeless_$colon$plus$colon($n(x2$20).s_util_Right__f_value);
                      var x1$21 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$11))
                    } else {
                      if ((!(x1$20 instanceof $c_s_util_Left))) {
                        throw new $c_s_MatchError(x1$20)
                      };
                      var x3$11 = $as_s_util_Left(x1$20);
                      var err$11 = $as_Lio_circe_DecodingFailure($n(x3$11).s_util_Left__f_value);
                      var x1$21 = new $c_s_util_Left(err$11)
                    }
                  };
                  if ((x1$21 instanceof $c_s_util_Right)) {
                    var x2$21 = $as_s_util_Right(x1$21);
                    var v$12 = $as_Lshapeless_$colon$plus$colon($n(x2$21).s_util_Right__f_value);
                    var x1$22 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$12))
                  } else {
                    if ((!(x1$21 instanceof $c_s_util_Left))) {
                      throw new $c_s_MatchError(x1$21)
                    };
                    var x3$12 = $as_s_util_Left(x1$21);
                    var err$12 = $as_Lio_circe_DecodingFailure($n(x3$12).s_util_Left__f_value);
                    var x1$22 = new $c_s_util_Left(err$12)
                  }
                };
                if ((x1$22 instanceof $c_s_util_Right)) {
                  var x2$22 = $as_s_util_Right(x1$22);
                  var v$13 = $as_Lshapeless_$colon$plus$colon($n(x2$22).s_util_Right__f_value);
                  var x1$23 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$13))
                } else {
                  if ((!(x1$22 instanceof $c_s_util_Left))) {
                    throw new $c_s_MatchError(x1$22)
                  };
                  var x3$13 = $as_s_util_Left(x1$22);
                  var err$13 = $as_Lio_circe_DecodingFailure($n(x3$13).s_util_Left__f_value);
                  var x1$23 = new $c_s_util_Left(err$13)
                }
              };
              if ((x1$23 instanceof $c_s_util_Right)) {
                var x2$23 = $as_s_util_Right(x1$23);
                var v$14 = $as_Lshapeless_$colon$plus$colon($n(x2$23).s_util_Right__f_value);
                var x1$24 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$14))
              } else {
                if ((!(x1$23 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(x1$23)
                };
                var x3$14 = $as_s_util_Left(x1$23);
                var err$14 = $as_Lio_circe_DecodingFailure($n(x3$14).s_util_Left__f_value);
                var x1$24 = new $c_s_util_Left(err$14)
              }
            };
            if ((x1$24 instanceof $c_s_util_Right)) {
              var x2$24 = $as_s_util_Right(x1$24);
              var v$15 = $as_Lshapeless_$colon$plus$colon($n(x2$24).s_util_Right__f_value);
              var x1$25 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$15))
            } else {
              if ((!(x1$24 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(x1$24)
              };
              var x3$15 = $as_s_util_Left(x1$24);
              var err$15 = $as_Lio_circe_DecodingFailure($n(x3$15).s_util_Left__f_value);
              var x1$25 = new $c_s_util_Left(err$15)
            }
          };
          if ((x1$25 instanceof $c_s_util_Right)) {
            var x2$25 = $as_s_util_Right(x1$25);
            var v$16 = $as_Lshapeless_$colon$plus$colon($n(x2$25).s_util_Right__f_value);
            var x1$26 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$16))
          } else {
            if ((!(x1$25 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$25)
            };
            var x3$16 = $as_s_util_Left(x1$25);
            var err$16 = $as_Lio_circe_DecodingFailure($n(x3$16).s_util_Left__f_value);
            var x1$26 = new $c_s_util_Left(err$16)
          }
        };
        if ((x1$26 instanceof $c_s_util_Right)) {
          var x2$26 = $as_s_util_Right(x1$26);
          var v$17 = $as_Lshapeless_$colon$plus$colon($n(x2$26).s_util_Right__f_value);
          var x1$27 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$17))
        } else {
          if ((!(x1$26 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$26)
          };
          var x3$17 = $as_s_util_Left(x1$26);
          var err$17 = $as_Lio_circe_DecodingFailure($n(x3$17).s_util_Left__f_value);
          var x1$27 = new $c_s_util_Left(err$17)
        }
      };
      if ((x1$27 instanceof $c_s_util_Right)) {
        var x2$27 = $as_s_util_Right(x1$27);
        var v$18 = $as_Lshapeless_$colon$plus$colon($n(x2$27).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$18))
      } else if ((x1$27 instanceof $c_s_util_Left)) {
        var x3$18 = $as_s_util_Left(x1$27);
        var err$18 = $as_Lio_circe_DecodingFailure($n(x3$18).s_util_Left__f_value);
        return new $c_s_util_Left(err$18)
      } else {
        throw new $c_s_MatchError(x1$27)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6: 0
}, false, "reactbuild.model.process.ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6", {
  Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6.prototype.$classData = $d_Lreactbuild_model_process_ProcessNodeDetails$anon$lazy$macro$41$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10(outer) {
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericDecoderForid = null;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericDecoderFordetails = null;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericDecoderForusage = null;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericEncoderForid = null;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericEncoderFordetails = null;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericEncoderForusage = null;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericDecoderFordetails = $m_Lreactbuild_person_AddressDetails$().Lreactbuild_person_AddressDetails$__f_codecForAddressDetails;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericDecoderForusage = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericEncoderFordetails = $m_Lreactbuild_person_AddressDetails$().Lreactbuild_person_AddressDetails$__f_codecForAddressDetails;
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericEncoderForusage = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10.prototype.constructor = $c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10;
/** @constructor */
function $h_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10.prototype = $c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10.prototype;
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFordetails = $as_Lreactbuild_person_AddressDetails($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForusage = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x3 = $m_Lio_circe_JsonObject$();
          var this$5 = $m_sci_Vector$();
          var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid));
          var $$x1 = $n(transformMemberNames).apply__O__O("details");
          var this$1 = $n(this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericEncoderFordetails);
          var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordetails)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("usage"), $n(this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericEncoderForusage).apply__O__Lio_circe_Json(circeGenericHListBindingForusage))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("details"))), this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericDecoderFordetails, "details", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("usage"))), this.Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10__f_circeGenericDecoderForusage, "usage", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10 = new $TypeData().initClass({
  Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10: 0
}, false, "reactbuild.person.Address$anon$lazy$macro$27$1$$anon$10", {
  Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10.prototype.$classData = $d_Lreactbuild_person_Address$anon$lazy$macro$27$1$$anon$10;
/** @constructor */
function $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5(outer) {
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForEmail = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForLocation = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForPhone = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForPostal = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForWebsite = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForEmail = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForLocation = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForPhone = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForPostal = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForWebsite = null;
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_$outer = outer
  };
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForEmail = $m_Lreactbuild_person_Email$().decodeEmail__Lio_circe_Decoder();
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForLocation = $m_Lreactbuild_person_Location$().decodeLocation__Lio_circe_Decoder();
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForPhone = $m_Lreactbuild_person_Phone$().decodePhone__Lio_circe_Decoder();
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_$outer).inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForPostal = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForWebsite = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForEmail = $m_Lreactbuild_person_Email$().encodeEmail__Lio_circe_Encoder();
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForLocation = $m_Lreactbuild_person_Location$().encodeLocation__Lio_circe_Encoder();
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForPhone = $m_Lreactbuild_person_Phone$().encodePhone__Lio_circe_Encoder();
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_$outer).inst$macro$65__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForPostal = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_$outer).inst$macro$47__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForWebsite = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O())
}
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5.prototype.constructor = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5;
/** @constructor */
function $h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5.prototype = $c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5.prototype;
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForEmail = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForEmail instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForEmail);
    var circeGenericInlBindingForEmail = $as_Lreactbuild_person_Email($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForEmail;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Email"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForEmail, name, discriminator)
  } else if ((circeGenericInrBindingForEmail instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForEmail);
    var circeGenericInrBindingForLocation = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForLocation instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForLocation);
      var circeGenericInlBindingForLocation = $as_Lreactbuild_person_Location($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForLocation;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Location"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForLocation, name$1, discriminator)
    } else if ((circeGenericInrBindingForLocation instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForLocation);
      var circeGenericInrBindingForPhone = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForPhone instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForPhone);
        var circeGenericInlBindingForPhone = $as_Lreactbuild_person_Phone($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForPhone;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Phone"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForPhone, name$2, discriminator)
      } else if ((circeGenericInrBindingForPhone instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForPhone);
        var circeGenericInrBindingForPostal = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForPostal instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForPostal);
          var circeGenericInlBindingForPostal = $as_Lreactbuild_person_Postal($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForPostal;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("Postal"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForPostal, name$3, discriminator)
        } else if ((circeGenericInrBindingForPostal instanceof $c_Lshapeless_Inr)) {
          var x3$4 = $as_Lshapeless_Inr(circeGenericInrBindingForPostal);
          var circeGenericInrBindingForWebsite = $as_Lshapeless_$colon$plus$colon($n(x3$4).Lshapeless_Inr__f_tail);
          if ((circeGenericInrBindingForWebsite instanceof $c_Lshapeless_Inl)) {
            var x2$5 = $as_Lshapeless_Inl(circeGenericInrBindingForWebsite);
            var circeGenericInlBindingForWebsite = $as_Lreactbuild_person_Website($n(x2$5).Lshapeless_Inl__f_head);
            var encode$4 = this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericEncoderForWebsite;
            var name$4 = $as_T($n(transformConstructorNames).apply__O__O("Website"));
            return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$4, circeGenericInlBindingForWebsite, name$4, discriminator)
          } else if ((circeGenericInrBindingForWebsite instanceof $c_Lshapeless_Inr)) {
            $m_s_sys_package$().error__T__E("Cannot encode CNil")
          } else {
            throw new $c_s_MatchError(circeGenericInrBindingForWebsite)
          }
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForPostal)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForPhone)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForLocation)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForEmail)
  }
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForEmail, c, $as_T($n(transformConstructorNames).apply__O__O("Email")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_person_Email($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForLocation, c, $as_T($n(transformConstructorNames).apply__O__O("Location")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_person_Location($n(x2$4).s_util_Right__f_value);
          var x1$15 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$15 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForPhone, c, $as_T($n(transformConstructorNames).apply__O__O("Phone")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_person_Phone($n(x2$6).s_util_Right__f_value);
            var x1$14 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$14 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForPostal, c, $as_T($n(transformConstructorNames).apply__O__O("Postal")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_person_Postal($n(x2$8).s_util_Right__f_value);
              var x1$13 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$13 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            var x1$9 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5__f_circeGenericDecoderForWebsite, c, $as_T($n(transformConstructorNames).apply__O__O("Website")), discriminator);
            if ((x1$9 instanceof $c_s_Some)) {
              var x2$9 = $as_s_Some(x1$9);
              var result$5 = $as_s_util_Either($n(x2$9).s_Some__f_value);
              if ((result$5 instanceof $c_s_util_Right)) {
                var x2$10 = $as_s_util_Right(result$5);
                var v$5 = $as_Lreactbuild_person_Website($n(x2$10).s_util_Right__f_value);
                var x1$12 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$5))
              } else {
                if ((!(result$5 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(result$5)
                };
                var x3$5 = $as_s_util_Left(result$5);
                var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
                var x1$12 = new $c_s_util_Left(err$5)
              }
            } else {
              var x$9 = $m_s_None$();
              if ((!(x$9 === x1$9))) {
                throw new $c_s_MatchError(x1$9)
              };
              $m_Lio_circe_DecodingFailure$();
              var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
              var x1$11 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
              var err$6 = $as_Lio_circe_DecodingFailure(x1$11.s_util_Left__f_value);
              var x1$12 = new $c_s_util_Left(err$6)
            };
            if ((x1$12 instanceof $c_s_util_Right)) {
              var x2$12 = $as_s_util_Right(x1$12);
              var v$7 = $as_Lshapeless_$colon$plus$colon($n(x2$12).s_util_Right__f_value);
              var x1$13 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$7))
            } else {
              if ((!(x1$12 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(x1$12)
              };
              var x3$7 = $as_s_util_Left(x1$12);
              var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
              var x1$13 = new $c_s_util_Left(err$7)
            }
          };
          if ((x1$13 instanceof $c_s_util_Right)) {
            var x2$13 = $as_s_util_Right(x1$13);
            var v$8 = $as_Lshapeless_$colon$plus$colon($n(x2$13).s_util_Right__f_value);
            var x1$14 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$8))
          } else {
            if ((!(x1$13 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$13)
            };
            var x3$8 = $as_s_util_Left(x1$13);
            var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
            var x1$14 = new $c_s_util_Left(err$8)
          }
        };
        if ((x1$14 instanceof $c_s_util_Right)) {
          var x2$14 = $as_s_util_Right(x1$14);
          var v$9 = $as_Lshapeless_$colon$plus$colon($n(x2$14).s_util_Right__f_value);
          var x1$15 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$9))
        } else {
          if ((!(x1$14 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$14)
          };
          var x3$9 = $as_s_util_Left(x1$14);
          var err$9 = $as_Lio_circe_DecodingFailure($n(x3$9).s_util_Left__f_value);
          var x1$15 = new $c_s_util_Left(err$9)
        }
      };
      if ((x1$15 instanceof $c_s_util_Right)) {
        var x2$15 = $as_s_util_Right(x1$15);
        var v$10 = $as_Lshapeless_$colon$plus$colon($n(x2$15).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$10))
      } else if ((x1$15 instanceof $c_s_util_Left)) {
        var x3$10 = $as_s_util_Left(x1$15);
        var err$10 = $as_Lio_circe_DecodingFailure($n(x3$10).s_util_Left__f_value);
        return new $c_s_util_Left(err$10)
      } else {
        throw new $c_s_MatchError(x1$15)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5 = new $TypeData().initClass({
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5: 0
}, false, "reactbuild.person.AddressDetails$anon$lazy$macro$91$1$$anon$5", {
  Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5.prototype.$classData = $d_Lreactbuild_person_AddressDetails$anon$lazy$macro$91$1$$anon$5;
/** @constructor */
function $c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2(outer) {
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForcache = null;
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForexpression = null;
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForcache = null;
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForexpression = null;
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForcache = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForexpression = $m_Lreactbuild_person_QuantifiedExpression$().Lreactbuild_person_QuantifiedExpression$__f_codecForQuantifiedExpression;
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForcache = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForexpression = $m_Lreactbuild_person_QuantifiedExpression$().Lreactbuild_person_QuantifiedExpression$__f_codecForQuantifiedExpression
}
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2.prototype.constructor = $c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2.prototype = $c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2.prototype;
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForcache = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForexpression = $as_Lreactbuild_person_QuantifiedExpression($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x3 = $m_Lio_circe_JsonObject$();
        var this$5 = $m_sci_Vector$();
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("cache"), $n(this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForcache).apply__O__Lio_circe_Json(circeGenericHListBindingForcache));
        var $$x1 = $n(transformMemberNames).apply__O__O("expression");
        var this$1 = $n(this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForexpression);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForexpression))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("cache"))), this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForcache, "cache", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("expression"))), this.Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForexpression, "expression", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2: 0
}, false, "reactbuild.person.CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2", {
  Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2.prototype.$classData = $d_Lreactbuild_person_CachedQuantifiedExpression$anon$lazy$macro$19$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4(outer) {
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericDecoderForname = null;
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericDecoderFordata = null;
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericEncoderForname = null;
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericEncoderFordata = null;
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var decodeK = $m_Lio_circe_KeyDecoder$().Lio_circe_KeyDecoder$__f_decodeKeyString;
  var decodeV = $m_Lreactbuild_person_CredentialData$().Lreactbuild_person_CredentialData$__f_codecForCredentialData;
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericDecoderFordata = new $c_Lio_circe_Decoder$$anon$41(decodeK, decodeV);
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericEncoderFordata = $m_Lio_circe_Encoder$().encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString, $m_Lreactbuild_person_CredentialData$().Lreactbuild_person_CredentialData$__f_codecForCredentialData)
}
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4.prototype.constructor = $c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4;
/** @constructor */
function $h_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4.prototype = $c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4.prototype;
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForname = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFordata = $as_sci_Map($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x3 = $m_Lio_circe_JsonObject$();
        var this$5 = $m_sci_Vector$();
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname));
        var $$x1 = $n(transformMemberNames).apply__O__O("data");
        var this$1 = $n(this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericEncoderFordata);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordata))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("data"))), this.Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4__f_circeGenericDecoderFordata, "data", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4 = new $TypeData().initClass({
  Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4: 0
}, false, "reactbuild.person.Credential$anon$lazy$macro$19$1$$anon$4", {
  Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4.prototype.$classData = $d_Lreactbuild_person_Credential$anon$lazy$macro$19$1$$anon$4;
/** @constructor */
function $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1(outer) {
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericDecoderForPasswordCredentialData = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericDecoderForTextCredentialData = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericEncoderForPasswordCredentialData = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericEncoderForTextCredentialData = null;
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericDecoderForPasswordCredentialData = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericDecoderForTextCredentialData = $m_Lreactbuild_person_TextCredentialData$().decodeTextCredentialData__Lio_circe_Decoder();
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_$outer).inst$macro$13__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericEncoderForPasswordCredentialData = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericEncoderForTextCredentialData = $m_Lreactbuild_person_TextCredentialData$().encodeTextCredentialData__Lio_circe_Encoder()
}
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1.prototype.constructor = $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1.prototype = $c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1.prototype;
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForPasswordCredentialData = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForPasswordCredentialData instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForPasswordCredentialData);
    var circeGenericInlBindingForPasswordCredentialData = $as_Lreactbuild_person_PasswordCredentialData($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericEncoderForPasswordCredentialData;
    var name = $as_T($n(transformConstructorNames).apply__O__O("PasswordCredentialData"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForPasswordCredentialData, name, discriminator)
  } else if ((circeGenericInrBindingForPasswordCredentialData instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForPasswordCredentialData);
    var circeGenericInrBindingForTextCredentialData = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForTextCredentialData instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForTextCredentialData);
      var circeGenericInlBindingForTextCredentialData = $as_Lreactbuild_person_TextCredentialData($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericEncoderForTextCredentialData;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("TextCredentialData"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForTextCredentialData, name$1, discriminator)
    } else if ((circeGenericInrBindingForTextCredentialData instanceof $c_Lshapeless_Inr)) {
      $m_s_sys_package$().error__T__E("Cannot encode CNil")
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForTextCredentialData)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForPasswordCredentialData)
  }
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericDecoderForPasswordCredentialData, c, $as_T($n(transformConstructorNames).apply__O__O("PasswordCredentialData")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_person_PasswordCredentialData($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1__f_circeGenericDecoderForTextCredentialData, c, $as_T($n(transformConstructorNames).apply__O__O("TextCredentialData")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_person_TextCredentialData($n(x2$4).s_util_Right__f_value);
          var x1$6 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$6 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        $m_Lio_circe_DecodingFailure$();
        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
        var x1$5 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
        var err$3 = $as_Lio_circe_DecodingFailure(x1$5.s_util_Left__f_value);
        var x1$6 = new $c_s_util_Left(err$3)
      };
      if ((x1$6 instanceof $c_s_util_Right)) {
        var x2$6 = $as_s_util_Right(x1$6);
        var v$4 = $as_Lshapeless_$colon$plus$colon($n(x2$6).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$4))
      } else if ((x1$6 instanceof $c_s_util_Left)) {
        var x3$4 = $as_s_util_Left(x1$6);
        var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
        return new $c_s_util_Left(err$4)
      } else {
        throw new $c_s_MatchError(x1$6)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1: 0
}, false, "reactbuild.person.CredentialData$anon$lazy$macro$23$1$$anon$1", {
  Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1.prototype.$classData = $d_Lreactbuild_person_CredentialData$anon$lazy$macro$23$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9(outer) {
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericDecoderForreference = null;
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericEncoderForreference = null;
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericDecoderFordate = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericDecoderForreference = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericEncoderFordate = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericEncoderForreference = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval)
}
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9.prototype.constructor = $c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9;
/** @constructor */
function $h_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9() {
  /*<skip>*/
}
$h_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9.prototype = $c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9.prototype;
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFordate = $as_Lreactbuild_person_BoundedField($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForsupplierReference = $as_Lreactbuild_person_BoundedField($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForreference = $as_Lreactbuild_person_BoundedField($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x6 = $m_Lio_circe_JsonObject$();
          var this$7 = $m_sci_Vector$();
          var $$x5 = $n(transformMemberNames).apply__O__O("date");
          var this$1 = $n(this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericEncoderFordate);
          var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordate));
          var $$x3 = $n(transformMemberNames).apply__O__O("supplierReference");
          var this$2 = $n(this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericEncoderForreference);
          var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForsupplierReference));
          var $$x1 = $n(transformMemberNames).apply__O__O("reference");
          var this$3 = $n(this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericEncoderForreference);
          var array = [$$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForreference))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x6).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$7.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("supplierReference"))), this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericDecoderForreference, "supplierReference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9__f_circeGenericDecoderForreference, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9 = new $TypeData().initClass({
  Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9: 0
}, false, "reactbuild.person.DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9", {
  Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9.prototype.$classData = $d_Lreactbuild_person_DeliveryHeaderFormat$anon$lazy$macro$27$1$$anon$9;
/** @constructor */
function $c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7(outer) {
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderForreference = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortaxAmount = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortotalAmount = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFordate = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortarget = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderForcategory = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderForreference = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortaxAmount = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortotalAmount = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFordate = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortarget = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderForcategory = null;
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderForreference = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortaxAmount = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortotalAmount = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFordate = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortarget = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderForcategory = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderForreference = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortaxAmount = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortotalAmount = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFordate = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortarget = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle);
  this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderForcategory = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_Rectangle$().Lreactbuild_person_Rectangle$__f_codecForRectangle)
}
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7.prototype.constructor = $c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7;
/** @constructor */
function $h_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7.prototype = $c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7.prototype;
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForreference = $as_Lreactbuild_person_BoundedField($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFornetAmount = $as_Lreactbuild_person_BoundedField($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFortaxAmount = $as_Lreactbuild_person_BoundedField($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFortotalAmount = $as_Lreactbuild_person_BoundedField($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFordate = $as_Lreactbuild_person_BoundedField($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingFortarget = $as_Lreactbuild_person_BoundedField($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForcategory = $as_Lreactbuild_person_BoundedField($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p8)) {
                  var $$x14 = $m_Lio_circe_JsonObject$();
                  var this$11 = $m_sci_Vector$();
                  var $$x13 = $n(transformMemberNames).apply__O__O("reference");
                  var this$1 = $n(this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderForreference);
                  var $$x12 = $ct_T2__O__O__(new $c_T2(), $$x13, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForreference));
                  var $$x11 = $n(transformMemberNames).apply__O__O("netAmount");
                  var this$2 = $n(this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortotalAmount);
                  var $$x10 = $ct_T2__O__O__(new $c_T2(), $$x11, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFornetAmount));
                  var $$x9 = $n(transformMemberNames).apply__O__O("taxAmount");
                  var this$3 = $n(this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortaxAmount);
                  var $$x8 = $ct_T2__O__O__(new $c_T2(), $$x9, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingFortaxAmount));
                  var $$x7 = $n(transformMemberNames).apply__O__O("totalAmount");
                  var this$4 = $n(this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortotalAmount);
                  var $$x6 = $ct_T2__O__O__(new $c_T2(), $$x7, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$4, circeGenericHListBindingFortotalAmount));
                  var $$x5 = $n(transformMemberNames).apply__O__O("date");
                  var this$5 = $n(this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFordate);
                  var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$5, circeGenericHListBindingFordate));
                  var $$x3 = $n(transformMemberNames).apply__O__O("target");
                  var this$6 = $n(this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderFortarget);
                  var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$6, circeGenericHListBindingFortarget));
                  var $$x1 = $n(transformMemberNames).apply__O__O("category");
                  var this$7 = $n(this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericEncoderForcategory);
                  var array = [$$x12, $$x10, $$x8, $$x6, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$7, circeGenericHListBindingForcategory))];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                  return $n($$x14).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$11.from__sc_IterableOnce__sci_Vector(elems))
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderForreference, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("netAmount"))), this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortotalAmount, "netAmount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("taxAmount"))), this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortaxAmount, "taxAmount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("totalAmount"))), this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortotalAmount, "totalAmount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("date"))), this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFordate, "date", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("target"))), this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderFortarget, "target", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("category"))), this.Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7__f_circeGenericDecoderForcategory, "category", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7 = new $TypeData().initClass({
  Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7: 0
}, false, "reactbuild.person.DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7", {
  Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7.prototype.$classData = $d_Lreactbuild_person_DocumentFieldLevel$anon$lazy$macro$59$1$$anon$7;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25(outer) {
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForheight = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForid = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForname = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForcolumns = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForheight = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForid = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForname = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForcolumns = null;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForheight = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_person_DocumentParserColumn$().Lreactbuild_person_DocumentParserColumn$__f_codecForDocumentParserColumn;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForcolumns = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForheight = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_person_DocumentParserColumn$().Lreactbuild_person_DocumentParserColumn$__f_codecForDocumentParserColumn;
  this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForcolumns = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25.prototype.constructor = $c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25.prototype = $c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25.prototype;
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForleft = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortop = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForwidth = $uD($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForheight = $uD($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForid = $as_ju_UUID($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForname = $as_T($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForcolumns = $as_sci_List($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p8)) {
                  var $$x8 = $m_Lio_circe_JsonObject$();
                  var this$5 = $m_sci_Vector$();
                  var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("left"), $n(this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForheight).apply__O__Lio_circe_Json(circeGenericHListBindingForleft));
                  var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("top"), $n(this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForheight).apply__O__Lio_circe_Json(circeGenericHListBindingFortop));
                  var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("width"), $n(this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForheight).apply__O__Lio_circe_Json(circeGenericHListBindingForwidth));
                  var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("height"), $n(this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForheight).apply__O__Lio_circe_Json(circeGenericHListBindingForheight));
                  var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid));
                  var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname));
                  var $$x1 = $n(transformMemberNames).apply__O__O("columns");
                  var this$1 = $n(this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericEncoderForcolumns);
                  var array = [$$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForcolumns))];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                  return $n($$x8).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("left"))), this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForheight, "left", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("top"))), this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForheight, "top", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("width"))), this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForheight, "width", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("height"))), this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForheight, "height", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("columns"))), this.Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25__f_circeGenericDecoderForcolumns, "columns", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25: 0
}, false, "reactbuild.person.DocumentParserArea$anon$lazy$macro$59$1$$anon$25", {
  Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25.prototype.$classData = $d_Lreactbuild_person_DocumentParserArea$anon$lazy$macro$59$1$$anon$25;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24(outer) {
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericDecoderForwidth = null;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericDecoderForid = null;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericDecoderForname = null;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericEncoderForwidth = null;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericEncoderForid = null;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericEncoderForname = null;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericDecoderForwidth = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericEncoderForwidth = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24.prototype.constructor = $c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24.prototype = $c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24.prototype;
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForwidth = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForid = $as_ju_UUID($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("width"), $n(this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericEncoderForwidth).apply__O__Lio_circe_Json(circeGenericHListBindingForwidth)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("width"))), this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericDecoderForwidth, "width", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24: 0
}, false, "reactbuild.person.DocumentParserColumn$anon$lazy$macro$27$4$$anon$24", {
  Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24.prototype.$classData = $d_Lreactbuild_person_DocumentParserColumn$anon$lazy$macro$27$4$$anon$24;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10(outer) {
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForCustomFormat = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForDocumentLevelOnly = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForDocumentWithRows = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForInvoiceWithDeliveryFormDetailGroup = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForCustomFormat = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForDocumentLevelOnly = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForDocumentWithRows = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForInvoiceWithDeliveryFormDetailGroup = null;
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer).inst$macro$81__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForCustomFormat = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer).inst$macro$63__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForDocumentLevelOnly = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer).inst$macro$37__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForDocumentWithRows = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForInvoiceWithDeliveryFormDetailGroup = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer).inst$macro$169__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForCustomFormat = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer).inst$macro$151__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForDocumentLevelOnly = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer).inst$macro$125__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForDocumentWithRows = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_$outer).inst$macro$91__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForInvoiceWithDeliveryFormDetailGroup = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O())
}
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10.prototype.constructor = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10.prototype = $c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10.prototype;
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForCustomFormat = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForCustomFormat instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForCustomFormat);
    var circeGenericInlBindingForCustomFormat = $as_Lreactbuild_person_CustomFormat($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForCustomFormat;
    var name = $as_T($n(transformConstructorNames).apply__O__O("CustomFormat"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForCustomFormat, name, discriminator)
  } else if ((circeGenericInrBindingForCustomFormat instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForCustomFormat);
    var circeGenericInrBindingForDocumentLevelOnly = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForDocumentLevelOnly instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForDocumentLevelOnly);
      var circeGenericInlBindingForDocumentLevelOnly = $as_Lreactbuild_person_DocumentLevelOnly($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForDocumentLevelOnly;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("DocumentLevelOnly"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForDocumentLevelOnly, name$1, discriminator)
    } else if ((circeGenericInrBindingForDocumentLevelOnly instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForDocumentLevelOnly);
      var circeGenericInrBindingForDocumentWithRows = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForDocumentWithRows instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForDocumentWithRows);
        var circeGenericInlBindingForDocumentWithRows = $as_Lreactbuild_person_DocumentWithRows($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForDocumentWithRows;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("DocumentWithRows"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForDocumentWithRows, name$2, discriminator)
      } else if ((circeGenericInrBindingForDocumentWithRows instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForDocumentWithRows);
        var circeGenericInrBindingForInvoiceWithDeliveryFormDetailGroup = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForInvoiceWithDeliveryFormDetailGroup instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForInvoiceWithDeliveryFormDetailGroup);
          var circeGenericInlBindingForInvoiceWithDeliveryFormDetailGroup = $as_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericEncoderForInvoiceWithDeliveryFormDetailGroup;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("InvoiceWithDeliveryFormDetailGroup"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForInvoiceWithDeliveryFormDetailGroup, name$3, discriminator)
        } else if ((circeGenericInrBindingForInvoiceWithDeliveryFormDetailGroup instanceof $c_Lshapeless_Inr)) {
          $m_s_sys_package$().error__T__E("Cannot encode CNil")
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForInvoiceWithDeliveryFormDetailGroup)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForDocumentWithRows)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForDocumentLevelOnly)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForCustomFormat)
  }
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForCustomFormat, c, $as_T($n(transformConstructorNames).apply__O__O("CustomFormat")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_person_CustomFormat($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForDocumentLevelOnly, c, $as_T($n(transformConstructorNames).apply__O__O("DocumentLevelOnly")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_person_DocumentLevelOnly($n(x2$4).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForDocumentWithRows, c, $as_T($n(transformConstructorNames).apply__O__O("DocumentWithRows")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_person_DocumentWithRows($n(x2$6).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10__f_circeGenericDecoderForInvoiceWithDeliveryFormDetailGroup, c, $as_T($n(transformConstructorNames).apply__O__O("InvoiceWithDeliveryFormDetailGroup")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_person_InvoiceWithDeliveryFormDetailGroup($n(x2$8).s_util_Right__f_value);
              var x1$10 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$10 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            $m_Lio_circe_DecodingFailure$();
            var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
            var x1$9 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
            var err$5 = $as_Lio_circe_DecodingFailure(x1$9.s_util_Left__f_value);
            var x1$10 = new $c_s_util_Left(err$5)
          };
          if ((x1$10 instanceof $c_s_util_Right)) {
            var x2$10 = $as_s_util_Right(x1$10);
            var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$10).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
          } else {
            if ((!(x1$10 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$10)
            };
            var x3$6 = $as_s_util_Left(x1$10);
            var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$6)
          }
        };
        if ((x1$11 instanceof $c_s_util_Right)) {
          var x2$11 = $as_s_util_Right(x1$11);
          var v$7 = $as_Lshapeless_$colon$plus$colon($n(x2$11).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$7))
        } else {
          if ((!(x1$11 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$11)
          };
          var x3$7 = $as_s_util_Left(x1$11);
          var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$7)
        }
      };
      if ((x1$12 instanceof $c_s_util_Right)) {
        var x2$12 = $as_s_util_Right(x1$12);
        var v$8 = $as_Lshapeless_$colon$plus$colon($n(x2$12).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$8))
      } else if ((x1$12 instanceof $c_s_util_Left)) {
        var x3$8 = $as_s_util_Left(x1$12);
        var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
        return new $c_s_util_Left(err$8)
      } else {
        throw new $c_s_MatchError(x1$12)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10: 0
}, false, "reactbuild.person.DocumentParserFormat$anon$lazy$macro$179$1$$anon$10", {
  Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10.prototype.$classData = $d_Lreactbuild_person_DocumentParserFormat$anon$lazy$macro$179$1$$anon$10;
/** @constructor */
function $c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1(outer) {
  this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1__f_circeGenericDecoderForformats = null;
  this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1__f_circeGenericEncoderForformats = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_person_DocumentParserFormat$().Lreactbuild_person_DocumentParserFormat$__f_codecForDocumentParserFormat;
  this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1__f_circeGenericDecoderForformats = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_person_DocumentParserFormat$().Lreactbuild_person_DocumentParserFormat$__f_codecForDocumentParserFormat;
  this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1__f_circeGenericEncoderForformats = new $c_Lio_circe_Encoder$$anon$25(encodeA)
}
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1.prototype.constructor = $c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1.prototype = $c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1.prototype;
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForformats = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("formats");
      var this$1 = $n(this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1__f_circeGenericEncoderForformats);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForformats))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("formats"))), this.Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1__f_circeGenericDecoderForformats, "formats", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1: 0
}, false, "reactbuild.person.DocumentParserSettings$anon$lazy$macro$11$1$$anon$1", {
  Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1.prototype.$classData = $d_Lreactbuild_person_DocumentParserSettings$anon$lazy$macro$11$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17(outer) {
  this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17__f_circeGenericDecoderForshowPrices = null;
  this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17__f_circeGenericEncoderForshowPrices = null;
  this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17__f_circeGenericDecoderForshowPrices = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeBoolean;
  this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17__f_circeGenericEncoderForshowPrices = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeBoolean
}
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17.prototype.constructor = $c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17;
/** @constructor */
function $h_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17() {
  /*<skip>*/
}
$h_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17.prototype = $c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17.prototype;
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForshowPrices = $uZ($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("showPrices"), $n(this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17__f_circeGenericEncoderForshowPrices).apply__O__Lio_circe_Json(circeGenericHListBindingForshowPrices))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("showPrices"))), this.Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17__f_circeGenericDecoderForshowPrices, "showPrices", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17 = new $TypeData().initClass({
  Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17: 0
}, false, "reactbuild.person.EstateAgentFacet$anon$lazy$macro$11$2$$anon$17", {
  Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17.prototype.$classData = $d_Lreactbuild_person_EstateAgentFacet$anon$lazy$macro$11$2$$anon$17;
/** @constructor */
function $c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2(outer) {
  this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForright = null;
  this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForright = null;
  this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForright = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForright = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2.prototype.constructor = $c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2.prototype = $c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2.prototype;
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForleft = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForright = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("left"), $n(this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForright).apply__O__Lio_circe_Json(circeGenericHListBindingForleft)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("right"), $n(this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2__f_circeGenericEncoderForright).apply__O__Lio_circe_Json(circeGenericHListBindingForright))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("left"))), this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForright, "left", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("right"))), this.Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2__f_circeGenericDecoderForright, "right", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2: 0
}, false, "reactbuild.person.HorizontalInterval$anon$lazy$macro$19$1$$anon$2", {
  Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2.prototype.$classData = $d_Lreactbuild_person_HorizontalInterval$anon$lazy$macro$19$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11(outer) {
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericDecoderForBankTransfer = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericDecoderForBillOfExchange = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericDecoderForDirectDebit = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericEncoderForBankTransfer = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericEncoderForBillOfExchange = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericEncoderForDirectDebit = null;
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_$outer).inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericDecoderForBankTransfer = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericDecoderForBillOfExchange = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericDecoderForDirectDebit = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_$outer).inst$macro$10__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericEncoderForBankTransfer = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_$outer).inst$macro$9__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericEncoderForBillOfExchange = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_$outer).inst$macro$7__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericEncoderForDirectDebit = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O())
}
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11.prototype.constructor = $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11;
/** @constructor */
function $h_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11.prototype = $c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11.prototype;
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForBankTransfer = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForBankTransfer instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForBankTransfer);
    var circeGenericInlBindingForBankTransfer = $as_Lreactbuild_person_PaymentMethod$BankTransfer$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericEncoderForBankTransfer;
    var name = $as_T($n(transformConstructorNames).apply__O__O("BankTransfer"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForBankTransfer, name, discriminator)
  } else if ((circeGenericInrBindingForBankTransfer instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForBankTransfer);
    var circeGenericInrBindingForBillOfExchange = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForBillOfExchange instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForBillOfExchange);
      var circeGenericInlBindingForBillOfExchange = $as_Lreactbuild_person_PaymentMethod$BillOfExchange$($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericEncoderForBillOfExchange;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("BillOfExchange"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForBillOfExchange, name$1, discriminator)
    } else if ((circeGenericInrBindingForBillOfExchange instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForBillOfExchange);
      var circeGenericInrBindingForDirectDebit = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForDirectDebit instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForDirectDebit);
        var circeGenericInlBindingForDirectDebit = $as_Lreactbuild_person_PaymentMethod$DirectDebit$($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericEncoderForDirectDebit;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("DirectDebit"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForDirectDebit, name$2, discriminator)
      } else if ((circeGenericInrBindingForDirectDebit instanceof $c_Lshapeless_Inr)) {
        $m_s_sys_package$().error__T__E("Cannot encode CNil")
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForDirectDebit)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForBillOfExchange)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForBankTransfer)
  }
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericDecoderForBankTransfer, c, $as_T($n(transformConstructorNames).apply__O__O("BankTransfer")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_person_PaymentMethod$BankTransfer$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericDecoderForBillOfExchange, c, $as_T($n(transformConstructorNames).apply__O__O("BillOfExchange")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_person_PaymentMethod$BillOfExchange$($n(x2$4).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11__f_circeGenericDecoderForDirectDebit, c, $as_T($n(transformConstructorNames).apply__O__O("DirectDebit")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_person_PaymentMethod$DirectDebit$($n(x2$6).s_util_Right__f_value);
            var x1$8 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$8 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          $m_Lio_circe_DecodingFailure$();
          var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
          var x1$7 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
          var err$4 = $as_Lio_circe_DecodingFailure(x1$7.s_util_Left__f_value);
          var x1$8 = new $c_s_util_Left(err$4)
        };
        if ((x1$8 instanceof $c_s_util_Right)) {
          var x2$8 = $as_s_util_Right(x1$8);
          var v$5 = $as_Lshapeless_$colon$plus$colon($n(x2$8).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$5))
        } else {
          if ((!(x1$8 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$8)
          };
          var x3$5 = $as_s_util_Left(x1$8);
          var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$5)
        }
      };
      if ((x1$9 instanceof $c_s_util_Right)) {
        var x2$9 = $as_s_util_Right(x1$9);
        var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$9).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
      } else if ((x1$9 instanceof $c_s_util_Left)) {
        var x3$6 = $as_s_util_Left(x1$9);
        var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
        return new $c_s_util_Left(err$6)
      } else {
        throw new $c_s_MatchError(x1$9)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11 = new $TypeData().initClass({
  Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11: 0
}, false, "reactbuild.person.PaymentMethod$anon$lazy$macro$11$1$$anon$11", {
  Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11.prototype.$classData = $d_Lreactbuild_person_PaymentMethod$anon$lazy$macro$11$1$$anon$11;
/** @constructor */
function $c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15(outer) {
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericDecoderFormethod = null;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericDecoderForperiod = null;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericDecoderForbefore = null;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericEncoderFormethod = null;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericEncoderForperiod = null;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericEncoderForbefore = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_person_PaymentMethod$().Lreactbuild_person_PaymentMethod$__f_codecForPaymentMethod;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericDecoderFormethod = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_decodeDuration;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericDecoderForperiod = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericDecoderForbefore = new $c_Lio_circe_Decoder$$anon$39(d$2);
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_person_PaymentMethod$().Lreactbuild_person_PaymentMethod$__f_codecForPaymentMethod;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericEncoderFormethod = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lreactbuild_model_Duration$().Lreactbuild_model_Duration$__f_encodeDuration;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericEncoderForperiod = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
  this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericEncoderForbefore = new $c_Lio_circe_Encoder$$anon$21(e$2)
}
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15.prototype.constructor = $c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15;
/** @constructor */
function $h_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15() {
  /*<skip>*/
}
$h_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15.prototype = $c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15.prototype;
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFormethod = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForperiod = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForbefore = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("method"), $n(this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericEncoderFormethod).apply__O__Lio_circe_Json(circeGenericHListBindingFormethod)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("period"), $n(this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericEncoderForperiod).apply__O__Lio_circe_Json(circeGenericHListBindingForperiod)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("before"), $n(this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericEncoderForbefore).apply__O__Lio_circe_Json(circeGenericHListBindingForbefore))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("method"))), this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericDecoderFormethod, "method", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("period"))), this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericDecoderForperiod, "period", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("before"))), this.Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15__f_circeGenericDecoderForbefore, "before", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15 = new $TypeData().initClass({
  Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15: 0
}, false, "reactbuild.person.PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15", {
  Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15.prototype.$classData = $d_Lreactbuild_person_PaymentTermAndConditions$anon$lazy$macro$27$2$$anon$15;
/** @constructor */
function $c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20(outer) {
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForname = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForfacets = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForaddresses = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForparent = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForimageUrl = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForname = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForfacets = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForaddresses = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForparent = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForimageUrl = null;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForfacets = $m_Lreactbuild_person_Facets$().Lreactbuild_person_Facets$__f_decodeFacets;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_person_Address$().Lreactbuild_person_Address$__f_codecForAddress;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForaddresses = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForparent = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForimageUrl = new $c_Lio_circe_Decoder$$anon$39(d$1);
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForfacets = $m_Lreactbuild_person_Facets$().Lreactbuild_person_Facets$__f_encodeFacets;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_person_Address$().Lreactbuild_person_Address$__f_codecForAddress;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForaddresses = new $c_Lio_circe_Encoder$$anon$23(encodeA);
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForparent = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForimageUrl = new $c_Lio_circe_Encoder$$anon$21(e$1)
}
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20.prototype.constructor = $c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20;
/** @constructor */
function $h_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20() {
  /*<skip>*/
}
$h_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20.prototype = $c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20.prototype;
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForcode = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForfacets = $as_Lreactbuild_person_Facets($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForaddresses = $as_sci_Seq($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForparent = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForimageUrl = $as_s_Option($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_HNil($n(p8).Lshapeless_$colon$colon__f_tail);
                  var x = $m_Lshapeless_HNil$();
                  if ((x === p9)) {
                    var $$x7 = $m_Lio_circe_JsonObject$();
                    var this$5 = $m_sci_Vector$();
                    var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                    var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization));
                    var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname));
                    var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("code"), $n(this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForimageUrl).apply__O__Lio_circe_Json(circeGenericHListBindingForcode));
                    var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("facets"), $n(this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForfacets).apply__O__Lio_circe_Json(circeGenericHListBindingForfacets));
                    var $$x1 = $n(transformMemberNames).apply__O__O("addresses");
                    var this$1 = $n(this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForaddresses);
                    var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForaddresses)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("parent"), $n(this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForparent).apply__O__Lio_circe_Json(circeGenericHListBindingForparent)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("imageUrl"), $n(this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericEncoderForimageUrl).apply__O__Lio_circe_Json(circeGenericHListBindingForimageUrl))];
                    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                    return $n($$x7).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("code"))), this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForimageUrl, "code", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("facets"))), this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForfacets, "facets", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("addresses"))), this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForaddresses, "addresses", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("parent"))), this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForparent, "parent", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("imageUrl"))), this.Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20__f_circeGenericDecoderForimageUrl, "imageUrl", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20 = new $TypeData().initClass({
  Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20: 0
}, false, "reactbuild.person.Person$anon$lazy$macro$67$1$$anon$20", {
  Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20.prototype.$classData = $d_Lreactbuild_person_Person$anon$lazy$macro$67$1$$anon$20;
/** @constructor */
function $c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23(outer) {
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForperson = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForlabel = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForcreated = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForexpired = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForperson = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForlabel = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForcreated = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForexpired = null;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForperson = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForlabel = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForcreated = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForexpired = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForperson = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForlabel = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForcreated = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder();
  this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForexpired = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23.prototype.constructor = $c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23;
/** @constructor */
function $h_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23.prototype = $c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23.prototype;
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForperson = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForlabel = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForcreated = $as_Ljava_time_Instant($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForexpired = $as_s_Option($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x1 = $m_Lio_circe_JsonObject$();
              var this$4 = $m_sci_Vector$();
              var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("person"), $n(this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForperson).apply__O__Lio_circe_Json(circeGenericHListBindingForperson)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("label"), $n(this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForlabel).apply__O__Lio_circe_Json(circeGenericHListBindingForlabel)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("created"), $n(this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForcreated).apply__O__Lio_circe_Json(circeGenericHListBindingForcreated)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("expired"), $n(this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericEncoderForexpired).apply__O__Lio_circe_Json(circeGenericHListBindingForexpired))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("person"))), this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForperson, "person", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("label"))), this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForlabel, "label", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("created"))), this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForcreated, "created", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("expired"))), this.Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23__f_circeGenericDecoderForexpired, "expired", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23 = new $TypeData().initClass({
  Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23: 0
}, false, "reactbuild.person.PersonAnnotation$anon$lazy$macro$43$1$$anon$23", {
  Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23.prototype.$classData = $d_Lreactbuild_person_PersonAnnotation$anon$lazy$macro$43$1$$anon$23;
/** @constructor */
function $c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21(outer) {
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFornext = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForperson = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFortarget = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFordetails = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForinstant = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFornext = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForperson = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFortarget = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFordetails = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForinstant = null;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFornext = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForperson = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFortarget = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Decoder$();
  var decodeA$1 = $m_Lreactbuild_person_PersonReferenceDetails$().Lreactbuild_person_PersonReferenceDetails$__f_decodePersonReferenceDetails;
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFordetails = new $c_Lio_circe_Decoder$$anon$44(decodeA$1);
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForinstant = $m_Lio_circe_Decoder$().decodeInstant__Lio_circe_Decoder();
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFornext = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForperson = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFortarget = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  $m_Lio_circe_Encoder$();
  var encodeA$1 = $m_Lreactbuild_person_PersonReferenceDetails$().encodePersonReferenceDetails__Lio_circe_Encoder$AsObject();
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFordetails = new $c_Lio_circe_Encoder$$anon$25(encodeA$1);
  this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForinstant = $m_Lio_circe_Encoder$().encodeInstant__Lio_circe_Encoder()
}
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21.prototype.constructor = $c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21;
/** @constructor */
function $h_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21() {
  /*<skip>*/
}
$h_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21.prototype = $c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21.prototype;
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFornext = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForperson = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFortarget = $as_sci_List($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingFordetails = $as_sci_List($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForinstant = $as_Ljava_time_Instant($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p7)) {
                var $$x7 = $m_Lio_circe_JsonObject$();
                var this$6 = $m_sci_Vector$();
                var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("next"), $n(this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFornext).apply__O__Lio_circe_Json(circeGenericHListBindingFornext));
                var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("person"), $n(this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForperson).apply__O__Lio_circe_Json(circeGenericHListBindingForperson));
                var $$x3 = $n(transformMemberNames).apply__O__O("target");
                var this$1 = $n(this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFortarget);
                var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFortarget));
                var $$x1 = $n(transformMemberNames).apply__O__O("details");
                var this$2 = $n(this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderFordetails);
                var array = [$$x6, $$x5, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFordetails)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("instant"), $n(this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericEncoderForinstant).apply__O__Lio_circe_Json(circeGenericHListBindingForinstant))];
                var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                return $n($$x7).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("next"))), this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFornext, "next", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("person"))), this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForperson, "person", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("target"))), this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFortarget, "target", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("details"))), this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderFordetails, "details", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("instant"))), this.Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21__f_circeGenericDecoderForinstant, "instant", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21 = new $TypeData().initClass({
  Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21: 0
}, false, "reactbuild.person.PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21", {
  Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21.prototype.$classData = $d_Lreactbuild_person_PersonReferenceEvent$anon$lazy$macro$51$1$$anon$21;
/** @constructor */
function $c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1(outer) {
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFortitle = null;
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFortitle = null;
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFortitle = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFortitle = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1.prototype.constructor = $c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1.prototype = $c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1.prototype;
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFortitle = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFortitle, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1: 0
}, false, "reactbuild.person.ProductGeneric$anon$lazy$macro$27$1$$anon$1", {
  Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1.prototype.$classData = $d_Lreactbuild_person_ProductGeneric$anon$lazy$macro$27$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2(outer) {
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderFortemplate = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForsupplier = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPrice = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitSize = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPerPackaging = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderFortemplate = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForsupplier = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPrice = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitSize = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPerPackaging = null;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderFortemplate = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForsupplier = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPrice = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitSize = $m_Lreactbuild_person_Size$().Lreactbuild_person_Size$__f_codecForSize;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPerPackaging = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderFortemplate = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForsupplier = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_model_Price$().Lreactbuild_model_Price$__f_codecForPrice;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPrice = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitSize = $m_Lreactbuild_person_Size$().Lreactbuild_person_Size$__f_codecForSize;
  this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPerPackaging = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2.prototype.constructor = $c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2;
/** @constructor */
function $h_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2() {
  /*<skip>*/
}
$h_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2.prototype = $c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2.prototype;
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortitle = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFortemplate = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForsupplier = $as_Lreactbuild_common_model_RefTo($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForreference = $as_T($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForunitPrice = $as_s_Option($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForunit = $as_T($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_$colon$colon($n(p7).Lshapeless_$colon$colon__f_tail);
                if ((p8 !== null)) {
                  var circeGenericHListBindingForunitSize = $as_Lreactbuild_person_Size($n(p8).Lshapeless_$colon$colon__f_head);
                  var p9 = $as_Lshapeless_$colon$colon($n(p8).Lshapeless_$colon$colon__f_tail);
                  if ((p9 !== null)) {
                    var circeGenericHListBindingForpackaging = $as_T($n(p9).Lshapeless_$colon$colon__f_head);
                    var p10 = $as_Lshapeless_$colon$colon($n(p9).Lshapeless_$colon$colon__f_tail);
                    if ((p10 !== null)) {
                      var circeGenericHListBindingForunitPerPackaging = $as_T($n(p10).Lshapeless_$colon$colon__f_head);
                      var p11 = $as_Lshapeless_HNil($n(p10).Lshapeless_$colon$colon__f_tail);
                      var x = $m_Lshapeless_HNil$();
                      if ((x === p11)) {
                        var $$x9 = $m_Lio_circe_JsonObject$();
                        var this$5 = $m_sci_Vector$();
                        var $$x8 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
                        var $$x7 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPerPackaging).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle));
                        var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("template"), $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderFortemplate).apply__O__Lio_circe_Json(circeGenericHListBindingFortemplate));
                        var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("supplier"), $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForsupplier).apply__O__Lio_circe_Json(circeGenericHListBindingForsupplier));
                        var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPerPackaging).apply__O__Lio_circe_Json(circeGenericHListBindingForreference));
                        var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("unitPrice"), $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPrice).apply__O__Lio_circe_Json(circeGenericHListBindingForunitPrice));
                        var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("unit"), $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPerPackaging).apply__O__Lio_circe_Json(circeGenericHListBindingForunit));
                        var $$x1 = $n(transformMemberNames).apply__O__O("unitSize");
                        var this$1 = $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitSize);
                        var array = [$$x8, $$x7, $$x6, $$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForunitSize)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("packaging"), $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPerPackaging).apply__O__Lio_circe_Json(circeGenericHListBindingForpackaging)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("unitPerPackaging"), $n(this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericEncoderForunitPerPackaging).apply__O__Lio_circe_Json(circeGenericHListBindingForunitPerPackaging))];
                        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                        return $n($$x9).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPerPackaging, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("template"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderFortemplate, "template", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("supplier"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForsupplier, "supplier", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPerPackaging, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unitPrice"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPrice, "unitPrice", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unit"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPerPackaging, "unit", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unitSize"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitSize, "unitSize", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("packaging"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPerPackaging, "packaging", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unitPerPackaging"))), this.Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2__f_circeGenericDecoderForunitPerPackaging, "unitPerPackaging", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2 = new $TypeData().initClass({
  Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2: 0
}, false, "reactbuild.person.ProductProduct$anon$lazy$macro$83$1$$anon$2", {
  Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2.prototype.$classData = $d_Lreactbuild_person_ProductProduct$anon$lazy$macro$83$1$$anon$2;
/** @constructor */
function $c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3(outer) {
  this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3__f_circeGenericDecoderForcode = null;
  this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3__f_circeGenericEncoderForcode = null;
  this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3__f_circeGenericDecoderForcode = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3__f_circeGenericEncoderForcode = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3.prototype.constructor = $c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3;
/** @constructor */
function $h_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3.prototype = $c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3.prototype;
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForcode = $as_T($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("code"), $n(this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3__f_circeGenericEncoderForcode).apply__O__Lio_circe_Json(circeGenericHListBindingForcode))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("code"))), this.Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3__f_circeGenericDecoderForcode, "code", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3 = new $TypeData().initClass({
  Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3: 0
}, false, "reactbuild.person.QuantifiedExpression$anon$lazy$macro$11$2$$anon$3", {
  Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3.prototype.$classData = $d_Lreactbuild_person_QuantifiedExpression$anon$lazy$macro$11$2$$anon$3;
/** @constructor */
function $c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4(outer) {
  this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericDecoderForright = null;
  this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericEncoderForright = null;
  this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericDecoderForright = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericEncoderForright = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4.prototype.constructor = $c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4;
/** @constructor */
function $h_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4.prototype = $c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4.prototype;
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFortop = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForleft = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForbottom = $uD($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForright = $uD($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("top"), $n(this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericEncoderForright).apply__O__Lio_circe_Json(circeGenericHListBindingFortop)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("left"), $n(this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericEncoderForright).apply__O__Lio_circe_Json(circeGenericHListBindingForleft)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("bottom"), $n(this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericEncoderForright).apply__O__Lio_circe_Json(circeGenericHListBindingForbottom)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("right"), $n(this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericEncoderForright).apply__O__Lio_circe_Json(circeGenericHListBindingForright))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("top"))), this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericDecoderForright, "top", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("left"))), this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericDecoderForright, "left", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("bottom"))), this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericDecoderForright, "bottom", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("right"))), this.Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4__f_circeGenericDecoderForright, "right", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4 = new $TypeData().initClass({
  Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4: 0
}, false, "reactbuild.person.Rectangle$anon$lazy$macro$35$1$$anon$4", {
  Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4.prototype.$classData = $d_Lreactbuild_person_Rectangle$anon$lazy$macro$35$1$$anon$4;
/** @constructor */
function $c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19(outer) {
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericDecoderForrelease = null;
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericDecoderForcostByHour = null;
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericEncoderForrelease = null;
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericEncoderForcostByHour = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().decodeLocalDate__Lio_circe_Decoder();
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericDecoderForrelease = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericDecoderForcostByHour = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().encodeLocalDate__Lio_circe_Encoder();
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericEncoderForrelease = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericEncoderForcostByHour = new $c_Lio_circe_Encoder$$anon$21(e$1)
}
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19.prototype.constructor = $c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19;
/** @constructor */
function $h_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19() {
  /*<skip>*/
}
$h_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19.prototype = $c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19.prototype;
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForentry = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForrelease = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForcostByHour = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("entry"), $n(this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericEncoderForrelease).apply__O__Lio_circe_Json(circeGenericHListBindingForentry)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("release"), $n(this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericEncoderForrelease).apply__O__Lio_circe_Json(circeGenericHListBindingForrelease)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("costByHour"), $n(this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericEncoderForcostByHour).apply__O__Lio_circe_Json(circeGenericHListBindingForcostByHour))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("entry"))), this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericDecoderForrelease, "entry", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("release"))), this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericDecoderForrelease, "release", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("costByHour"))), this.Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19__f_circeGenericDecoderForcostByHour, "costByHour", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19 = new $TypeData().initClass({
  Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19: 0
}, false, "reactbuild.person.ResourceFacet$anon$lazy$macro$27$3$$anon$19", {
  Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19.prototype.$classData = $d_Lreactbuild_person_ResourceFacet$anon$lazy$macro$27$3$$anon$19;
/** @constructor */
function $c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8(outer) {
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderFordescription = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForunit = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForunitPrice = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForamount = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderFordescription = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForunit = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForunitPrice = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForamount = null;
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderFordescription = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForunit = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForunitPrice = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForamount = $m_Lreactbuild_person_BoundedField$().decodeBoundedField__Lio_circe_Decoder__Lio_circe_Decoder($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderFordescription = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForunit = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForunitPrice = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval);
  this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForamount = $m_Lreactbuild_person_BoundedField$().encodeBoundedField__Lio_circe_Encoder__Lio_circe_Encoder$AsObject($m_Lreactbuild_person_HorizontalInterval$().Lreactbuild_person_HorizontalInterval$__f_codecForHorizontalInterval)
}
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8.prototype.constructor = $c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8;
/** @constructor */
function $h_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8() {
  /*<skip>*/
}
$h_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8.prototype = $c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8.prototype;
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForreference = $as_Lreactbuild_person_BoundedField($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFordescription = $as_Lreactbuild_person_BoundedField($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForquantity = $as_Lreactbuild_person_BoundedField($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForunit = $as_Lreactbuild_person_BoundedField($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForunitPrice = $as_Lreactbuild_person_BoundedField($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForamount = $as_Lreactbuild_person_BoundedField($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p7)) {
                var $$x12 = $m_Lio_circe_JsonObject$();
                var this$10 = $m_sci_Vector$();
                var $$x11 = $n(transformMemberNames).apply__O__O("reference");
                var this$1 = $n(this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderFordescription);
                var $$x10 = $ct_T2__O__O__(new $c_T2(), $$x11, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForreference));
                var $$x9 = $n(transformMemberNames).apply__O__O("description");
                var this$2 = $n(this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderFordescription);
                var $$x8 = $ct_T2__O__O__(new $c_T2(), $$x9, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFordescription));
                var $$x7 = $n(transformMemberNames).apply__O__O("quantity");
                var this$3 = $n(this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForunitPrice);
                var $$x6 = $ct_T2__O__O__(new $c_T2(), $$x7, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForquantity));
                var $$x5 = $n(transformMemberNames).apply__O__O("unit");
                var this$4 = $n(this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForunit);
                var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$4, circeGenericHListBindingForunit));
                var $$x3 = $n(transformMemberNames).apply__O__O("unitPrice");
                var this$5 = $n(this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForunitPrice);
                var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$5, circeGenericHListBindingForunitPrice));
                var $$x1 = $n(transformMemberNames).apply__O__O("amount");
                var this$6 = $n(this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericEncoderForamount);
                var array = [$$x10, $$x8, $$x6, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$6, circeGenericHListBindingForamount))];
                var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                return $n($$x12).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$10.from__sc_IterableOnce__sci_Vector(elems))
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderFordescription, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("description"))), this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderFordescription, "description", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("quantity"))), this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForunitPrice, "quantity", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unit"))), this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForunit, "unit", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("unitPrice"))), this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForunitPrice, "unitPrice", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("amount"))), this.Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8__f_circeGenericDecoderForamount, "amount", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8 = new $TypeData().initClass({
  Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8: 0
}, false, "reactbuild.person.RowFieldLevel$anon$lazy$macro$51$1$$anon$8", {
  Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8.prototype.$classData = $d_Lreactbuild_person_RowFieldLevel$anon$lazy$macro$51$1$$anon$8;
/** @constructor */
function $c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1(outer) {
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForlists = null;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForrows = null;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForgenerics = null;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForproducts = null;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForlists = null;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForrows = null;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForgenerics = null;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForproducts = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_person_SupplyTemplateList$().Lreactbuild_person_SupplyTemplateList$__f_codecForSupplyTemplateList;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForlists = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Decoder$();
  var decodeA$1 = $m_Lreactbuild_person_SupplyRow$().Lreactbuild_person_SupplyRow$__f_codecForSupplyRow;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForrows = new $c_Lio_circe_Decoder$$anon$44(decodeA$1);
  $m_Lio_circe_Decoder$();
  var decodeA$2 = $m_Lreactbuild_person_ProductGeneric$().Lreactbuild_person_ProductGeneric$__f_codecForProductGeneric;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForgenerics = new $c_Lio_circe_Decoder$$anon$44(decodeA$2);
  $m_Lio_circe_Decoder$();
  var decodeA$3 = $m_Lreactbuild_person_ProductProduct$().Lreactbuild_person_ProductProduct$__f_codecForProductProduct;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForproducts = new $c_Lio_circe_Decoder$$anon$44(decodeA$3);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_person_SupplyTemplateList$().Lreactbuild_person_SupplyTemplateList$__f_codecForSupplyTemplateList;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForlists = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  $m_Lio_circe_Encoder$();
  var encodeA$1 = $m_Lreactbuild_person_SupplyRow$().Lreactbuild_person_SupplyRow$__f_codecForSupplyRow;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForrows = new $c_Lio_circe_Encoder$$anon$25(encodeA$1);
  $m_Lio_circe_Encoder$();
  var encodeA$2 = $m_Lreactbuild_person_ProductGeneric$().Lreactbuild_person_ProductGeneric$__f_codecForProductGeneric;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForgenerics = new $c_Lio_circe_Encoder$$anon$25(encodeA$2);
  $m_Lio_circe_Encoder$();
  var encodeA$3 = $m_Lreactbuild_person_ProductProduct$().Lreactbuild_person_ProductProduct$__f_codecForProductProduct;
  this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForproducts = new $c_Lio_circe_Encoder$$anon$25(encodeA$3)
}
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1.prototype.constructor = $c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1.prototype = $c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1.prototype;
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForlists = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForrows = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForgenerics = $as_sci_List($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForproducts = $as_sci_List($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x8 = $m_Lio_circe_JsonObject$();
            var this$8 = $m_sci_Vector$();
            var $$x7 = $n(transformMemberNames).apply__O__O("lists");
            var this$1 = $n(this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForlists);
            var $$x6 = $ct_T2__O__O__(new $c_T2(), $$x7, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForlists));
            var $$x5 = $n(transformMemberNames).apply__O__O("rows");
            var this$2 = $n(this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForrows);
            var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForrows));
            var $$x3 = $n(transformMemberNames).apply__O__O("generics");
            var this$3 = $n(this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForgenerics);
            var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingForgenerics));
            var $$x1 = $n(transformMemberNames).apply__O__O("products");
            var this$4 = $n(this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForproducts);
            var array = [$$x6, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$4, circeGenericHListBindingForproducts))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x8).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$8.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("lists"))), this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForlists, "lists", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("rows"))), this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForrows, "rows", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("generics"))), this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForgenerics, "generics", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("products"))), this.Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForproducts, "products", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1: 0
}, false, "reactbuild.person.RowListing$anon$lazy$macro$35$1$$anon$1", {
  Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1.prototype.$classData = $d_Lreactbuild_person_RowListing$anon$lazy$macro$35$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3(outer) {
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_circeGenericDecoderForUndefined = null;
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_circeGenericEncoderForUndefined = null;
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_circeGenericDecoderForUndefined = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_$outer).inst$macro$5__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_circeGenericEncoderForUndefined = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O())
}
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3.prototype.constructor = $c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3;
/** @constructor */
function $h_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3.prototype = $c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3.prototype;
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForUndefined = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForUndefined instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForUndefined);
    var circeGenericInlBindingForUndefined = $as_Lreactbuild_person_Size$Undefined$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_circeGenericEncoderForUndefined;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Undefined"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForUndefined, name, discriminator)
  } else if ((circeGenericInrBindingForUndefined instanceof $c_Lshapeless_Inr)) {
    $m_s_sys_package$().error__T__E("Cannot encode CNil")
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForUndefined)
  }
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3__f_circeGenericDecoderForUndefined, c, $as_T($n(transformConstructorNames).apply__O__O("Undefined")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_person_Size$Undefined$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
      var x1$3 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
      var err$2 = $as_Lio_circe_DecodingFailure(x1$3.s_util_Left__f_value);
      return new $c_s_util_Left(err$2)
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3 = new $TypeData().initClass({
  Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3: 0
}, false, "reactbuild.person.Size$anon$lazy$macro$7$1$$anon$3", {
  Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3.prototype.$classData = $d_Lreactbuild_person_Size$anon$lazy$macro$7$1$$anon$3;
/** @constructor */
function $c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16(outer) {
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderForreference = null;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderForpaymentTermAndConditions = null;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderForgroup = null;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderFordocumentParserSettings = null;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderForreference = null;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderForpaymentTermAndConditions = null;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderForgroup = null;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderFordocumentParserSettings = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderForreference = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var d$1 = $m_Lreactbuild_person_PaymentTermAndConditions$().Lreactbuild_person_PaymentTermAndConditions$__f_codecForPaymentTermAndConditions;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderForpaymentTermAndConditions = new $c_Lio_circe_Decoder$$anon$39(d$1);
  $m_Lio_circe_Decoder$();
  var d$2 = $m_Lreactbuild_person_SupplierGroup$().Lreactbuild_person_SupplierGroup$__f_codecForSupplierGroup;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderForgroup = new $c_Lio_circe_Decoder$$anon$39(d$2);
  $m_Lio_circe_Decoder$();
  var d$3 = $m_Lreactbuild_person_DocumentParserSettings$().Lreactbuild_person_DocumentParserSettings$__f_codecForDocumentParserSettings;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderFordocumentParserSettings = new $c_Lio_circe_Decoder$$anon$39(d$3);
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderForreference = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var e$1 = $m_Lreactbuild_person_PaymentTermAndConditions$().Lreactbuild_person_PaymentTermAndConditions$__f_codecForPaymentTermAndConditions;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderForpaymentTermAndConditions = new $c_Lio_circe_Encoder$$anon$21(e$1);
  $m_Lio_circe_Encoder$();
  var e$2 = $m_Lreactbuild_person_SupplierGroup$().Lreactbuild_person_SupplierGroup$__f_codecForSupplierGroup;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderForgroup = new $c_Lio_circe_Encoder$$anon$21(e$2);
  $m_Lio_circe_Encoder$();
  var e$3 = $m_Lreactbuild_person_DocumentParserSettings$().Lreactbuild_person_DocumentParserSettings$__f_codecForDocumentParserSettings;
  this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderFordocumentParserSettings = new $c_Lio_circe_Encoder$$anon$21(e$3)
}
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16.prototype.constructor = $c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16;
/** @constructor */
function $h_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16.prototype = $c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16.prototype;
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForreference = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForpaymentTermAndConditions = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForgroup = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFordocumentParserSettings = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x1 = $m_Lio_circe_JsonObject$();
            var this$4 = $m_sci_Vector$();
            var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("reference"), $n(this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderForreference).apply__O__Lio_circe_Json(circeGenericHListBindingForreference)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("paymentTermAndConditions"), $n(this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderForpaymentTermAndConditions).apply__O__Lio_circe_Json(circeGenericHListBindingForpaymentTermAndConditions)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("group"), $n(this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderForgroup).apply__O__Lio_circe_Json(circeGenericHListBindingForgroup)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("documentParserSettings"), $n(this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericEncoderFordocumentParserSettings).apply__O__Lio_circe_Json(circeGenericHListBindingFordocumentParserSettings))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("reference"))), this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderForreference, "reference", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("paymentTermAndConditions"))), this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderForpaymentTermAndConditions, "paymentTermAndConditions", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("group"))), this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderForgroup, "group", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("documentParserSettings"))), this.Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16__f_circeGenericDecoderFordocumentParserSettings, "documentParserSettings", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16 = new $TypeData().initClass({
  Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16: 0
}, false, "reactbuild.person.SupplierFacet$anon$lazy$macro$35$1$$anon$16", {
  Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16.prototype.$classData = $d_Lreactbuild_person_SupplierFacet$anon$lazy$macro$35$1$$anon$16;
/** @constructor */
function $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13(outer) {
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_circeGenericDecoderForVendeeMateriaux = null;
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_circeGenericEncoderForVendeeMateriaux = null;
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_circeGenericDecoderForVendeeMateriaux = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_$outer).inst$macro$5__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_circeGenericEncoderForVendeeMateriaux = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O())
}
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13.prototype.constructor = $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13;
/** @constructor */
function $h_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13.prototype = $c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13.prototype;
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForVendeeMateriaux = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForVendeeMateriaux instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForVendeeMateriaux);
    var circeGenericInlBindingForVendeeMateriaux = $as_Lreactbuild_person_SupplierGroup$VendeeMateriaux$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_circeGenericEncoderForVendeeMateriaux;
    var name = $as_T($n(transformConstructorNames).apply__O__O("VendeeMateriaux"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForVendeeMateriaux, name, discriminator)
  } else if ((circeGenericInrBindingForVendeeMateriaux instanceof $c_Lshapeless_Inr)) {
    $m_s_sys_package$().error__T__E("Cannot encode CNil")
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForVendeeMateriaux)
  }
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13__f_circeGenericDecoderForVendeeMateriaux, c, $as_T($n(transformConstructorNames).apply__O__O("VendeeMateriaux")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_person_SupplierGroup$VendeeMateriaux$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
      var x1$3 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
      var err$2 = $as_Lio_circe_DecodingFailure(x1$3.s_util_Left__f_value);
      return new $c_s_util_Left(err$2)
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13 = new $TypeData().initClass({
  Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13: 0
}, false, "reactbuild.person.SupplierGroup$anon$lazy$macro$7$1$$anon$13", {
  Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13.prototype.$classData = $d_Lreactbuild_person_SupplierGroup$anon$lazy$macro$7$1$$anon$13;
/** @constructor */
function $c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12(outer) {
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForlist = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForproject = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderFortarget = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForquantity = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForlist = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForproject = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderFortarget = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForquantity = null;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForlist = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForproject = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderFortarget = $m_Lreactbuild_person_SupplyRowTarget$().Lreactbuild_person_SupplyRowTarget$__f_codecForSupplyRowTarget;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForquantity = $m_Lreactbuild_person_CachedQuantifiedExpression$().Lreactbuild_person_CachedQuantifiedExpression$__f_codecForCachedQuantifiedExpression;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForlist = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForproject = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderFortarget = $m_Lreactbuild_person_SupplyRowTarget$().Lreactbuild_person_SupplyRowTarget$__f_codecForSupplyRowTarget;
  this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForquantity = $m_Lreactbuild_person_CachedQuantifiedExpression$().Lreactbuild_person_CachedQuantifiedExpression$__f_codecForCachedQuantifiedExpression
}
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12.prototype.constructor = $c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12;
/** @constructor */
function $h_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12.prototype = $c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12.prototype;
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForlist = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForproject = $as_Lreactbuild_common_model_RefTo($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingFortarget = $as_Lreactbuild_person_SupplyRowTarget($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForquantity = $as_Lreactbuild_person_CachedQuantifiedExpression($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_HNil($n(p5).Lshapeless_$colon$colon__f_tail);
            var x = $m_Lshapeless_HNil$();
            if ((x === p6)) {
              var $$x7 = $m_Lio_circe_JsonObject$();
              var this$6 = $m_sci_Vector$();
              var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id));
              var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("list"), $n(this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForlist).apply__O__Lio_circe_Json(circeGenericHListBindingForlist));
              var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("project"), $n(this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForproject).apply__O__Lio_circe_Json(circeGenericHListBindingForproject));
              var $$x3 = $n(transformMemberNames).apply__O__O("target");
              var this$1 = $n(this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderFortarget);
              var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFortarget));
              var $$x1 = $n(transformMemberNames).apply__O__O("quantity");
              var this$2 = $n(this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericEncoderForquantity);
              var array = [$$x6, $$x5, $$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForquantity))];
              var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
              return $n($$x7).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("list"))), this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForlist, "list", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("project"))), this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForproject, "project", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("target"))), this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderFortarget, "target", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("quantity"))), this.Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12__f_circeGenericDecoderForquantity, "quantity", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12: 0
}, false, "reactbuild.person.SupplyRow$anon$lazy$macro$43$1$$anon$12", {
  Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12.prototype.$classData = $d_Lreactbuild_person_SupplyRow$anon$lazy$macro$43$1$$anon$12;
/** @constructor */
function $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5(outer) {
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericDecoderForGeneric = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericDecoderForProduct = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericDecoderForUndefined = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericEncoderForGeneric = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericEncoderForProduct = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericEncoderForUndefined = null;
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_$outer).inst$macro$39__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericDecoderForGeneric = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_$outer).inst$macro$21__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericDecoderForProduct = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericDecoderForUndefined = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_$outer).inst$macro$85__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericEncoderForGeneric = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_$outer).inst$macro$67__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericEncoderForProduct = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_$outer).inst$macro$49__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericEncoderForUndefined = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O())
}
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5.prototype.constructor = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5;
/** @constructor */
function $h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5.prototype = $c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5.prototype;
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForGeneric = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForGeneric instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForGeneric);
    var circeGenericInlBindingForGeneric = $as_Lreactbuild_person_SupplyRowTarget$Generic($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericEncoderForGeneric;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Generic"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForGeneric, name, discriminator)
  } else if ((circeGenericInrBindingForGeneric instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForGeneric);
    var circeGenericInrBindingForProduct = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForProduct instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForProduct);
      var circeGenericInlBindingForProduct = $as_Lreactbuild_person_SupplyRowTarget$Product($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericEncoderForProduct;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Product"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForProduct, name$1, discriminator)
    } else if ((circeGenericInrBindingForProduct instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForProduct);
      var circeGenericInrBindingForUndefined = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForUndefined instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForUndefined);
        var circeGenericInlBindingForUndefined = $as_Lreactbuild_person_SupplyRowTarget$Undefined($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericEncoderForUndefined;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Undefined"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForUndefined, name$2, discriminator)
      } else if ((circeGenericInrBindingForUndefined instanceof $c_Lshapeless_Inr)) {
        $m_s_sys_package$().error__T__E("Cannot encode CNil")
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForUndefined)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForProduct)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForGeneric)
  }
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericDecoderForGeneric, c, $as_T($n(transformConstructorNames).apply__O__O("Generic")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_person_SupplyRowTarget$Generic($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericDecoderForProduct, c, $as_T($n(transformConstructorNames).apply__O__O("Product")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_person_SupplyRowTarget$Product($n(x2$4).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5__f_circeGenericDecoderForUndefined, c, $as_T($n(transformConstructorNames).apply__O__O("Undefined")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_person_SupplyRowTarget$Undefined($n(x2$6).s_util_Right__f_value);
            var x1$8 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$8 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          $m_Lio_circe_DecodingFailure$();
          var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
          var x1$7 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
          var err$4 = $as_Lio_circe_DecodingFailure(x1$7.s_util_Left__f_value);
          var x1$8 = new $c_s_util_Left(err$4)
        };
        if ((x1$8 instanceof $c_s_util_Right)) {
          var x2$8 = $as_s_util_Right(x1$8);
          var v$5 = $as_Lshapeless_$colon$plus$colon($n(x2$8).s_util_Right__f_value);
          var x1$9 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$5))
        } else {
          if ((!(x1$8 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$8)
          };
          var x3$5 = $as_s_util_Left(x1$8);
          var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
          var x1$9 = new $c_s_util_Left(err$5)
        }
      };
      if ((x1$9 instanceof $c_s_util_Right)) {
        var x2$9 = $as_s_util_Right(x1$9);
        var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$9).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
      } else if ((x1$9 instanceof $c_s_util_Left)) {
        var x3$6 = $as_s_util_Left(x1$9);
        var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
        return new $c_s_util_Left(err$6)
      } else {
        throw new $c_s_MatchError(x1$9)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5 = new $TypeData().initClass({
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5: 0
}, false, "reactbuild.person.SupplyRowTarget$anon$lazy$macro$95$1$$anon$5", {
  Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5.prototype.$classData = $d_Lreactbuild_person_SupplyRowTarget$anon$lazy$macro$95$1$$anon$5;
/** @constructor */
function $c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1(outer) {
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFor_id = null;
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFororganization = null;
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFortitle = null;
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFor_id = null;
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFororganization = null;
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFortitle = null;
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFor_id = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFororganization = $m_Lreactbuild_common_model_RefTo$().decodeRefTo__Lio_circe_Decoder();
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFortitle = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFor_id = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFororganization = $m_Lreactbuild_common_model_RefTo$().encodeRefTo__Lio_circe_Encoder();
  this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFortitle = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1.prototype.constructor = $c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1.prototype = $c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1.prototype;
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFor_id = $as_Lreactbuild_common_model_RefTo($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFororganization = $as_Lreactbuild_common_model_RefTo($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFortitle = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("_id"), $n(this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFor_id).apply__O__Lio_circe_Json(circeGenericHListBindingFor_id)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("organization"), $n(this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFororganization).apply__O__Lio_circe_Json(circeGenericHListBindingFororganization)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("title"), $n(this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderFortitle).apply__O__Lio_circe_Json(circeGenericHListBindingFortitle))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("_id"))), this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFor_id, "_id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("organization"))), this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFororganization, "organization", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("title"))), this.Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderFortitle, "title", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1: 0
}, false, "reactbuild.person.SupplyTemplateList$anon$lazy$macro$27$1$$anon$1", {
  Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1.prototype.$classData = $d_Lreactbuild_person_SupplyTemplateList$anon$lazy$macro$27$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18(outer) {
  this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18__f_circeGenericDecoderForemail = null;
  this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18__f_circeGenericEncoderForemail = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18__f_circeGenericDecoderForemail = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18__f_circeGenericEncoderForemail = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18.prototype.constructor = $c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18;
/** @constructor */
function $h_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18() {
  /*<skip>*/
}
$h_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18.prototype = $c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18.prototype;
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForemail = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x1 = $m_Lio_circe_JsonObject$();
      var this$4 = $m_sci_Vector$();
      var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("email"), $n(this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18__f_circeGenericEncoderForemail).apply__O__Lio_circe_Json(circeGenericHListBindingForemail))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("email"))), this.Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18__f_circeGenericDecoderForemail, "email", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18 = new $TypeData().initClass({
  Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18: 0
}, false, "reactbuild.person.UserFacet$anon$lazy$macro$11$3$$anon$18", {
  Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18.prototype.$classData = $d_Lreactbuild_person_UserFacet$anon$lazy$macro$11$3$$anon$18;
/** @constructor */
function $c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3(outer) {
  this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3__f_circeGenericDecoderForbottom = null;
  this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3__f_circeGenericEncoderForbottom = null;
  this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3__f_circeGenericDecoderForbottom = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3__f_circeGenericEncoderForbottom = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3.prototype.constructor = $c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3;
/** @constructor */
function $h_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3.prototype = $c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3.prototype;
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFortop = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForbottom = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x1 = $m_Lio_circe_JsonObject$();
        var this$4 = $m_sci_Vector$();
        var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("top"), $n(this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3__f_circeGenericEncoderForbottom).apply__O__Lio_circe_Json(circeGenericHListBindingFortop)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("bottom"), $n(this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3__f_circeGenericEncoderForbottom).apply__O__Lio_circe_Json(circeGenericHListBindingForbottom))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("top"))), this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3__f_circeGenericDecoderForbottom, "top", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("bottom"))), this.Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3__f_circeGenericDecoderForbottom, "bottom", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3 = new $TypeData().initClass({
  Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3: 0
}, false, "reactbuild.person.VerticalInterval$anon$lazy$macro$19$2$$anon$3", {
  Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3.prototype.$classData = $d_Lreactbuild_person_VerticalInterval$anon$lazy$macro$19$2$$anon$3;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6(outer) {
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericDecoderForPersonResourceUsage = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericDecoderForProductResourceUsage = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericEncoderForPersonResourceUsage = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericEncoderForProductResourceUsage = null;
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_$outer).inst$macro$93__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericDecoderForPersonResourceUsage = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericDecoderForProductResourceUsage = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_$outer).inst$macro$225__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericEncoderForPersonResourceUsage = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_$outer).inst$macro$135__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericEncoderForProductResourceUsage = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O())
}
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6.prototype.constructor = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6.prototype = $c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6.prototype;
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForPersonResourceUsage = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForPersonResourceUsage instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForPersonResourceUsage);
    var circeGenericInlBindingForPersonResourceUsage = $as_Lreactbuild_project_PersonResourceUsage($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericEncoderForPersonResourceUsage;
    var name = $as_T($n(transformConstructorNames).apply__O__O("PersonResourceUsage"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForPersonResourceUsage, name, discriminator)
  } else if ((circeGenericInrBindingForPersonResourceUsage instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForPersonResourceUsage);
    var circeGenericInrBindingForProductResourceUsage = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForProductResourceUsage instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForProductResourceUsage);
      var circeGenericInlBindingForProductResourceUsage = $as_Lreactbuild_project_ProductResourceUsage($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericEncoderForProductResourceUsage;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("ProductResourceUsage"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForProductResourceUsage, name$1, discriminator)
    } else if ((circeGenericInrBindingForProductResourceUsage instanceof $c_Lshapeless_Inr)) {
      $m_s_sys_package$().error__T__E("Cannot encode CNil")
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForProductResourceUsage)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForPersonResourceUsage)
  }
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericDecoderForPersonResourceUsage, c, $as_T($n(transformConstructorNames).apply__O__O("PersonResourceUsage")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_project_PersonResourceUsage($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6__f_circeGenericDecoderForProductResourceUsage, c, $as_T($n(transformConstructorNames).apply__O__O("ProductResourceUsage")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_project_ProductResourceUsage($n(x2$4).s_util_Right__f_value);
          var x1$6 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$6 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        $m_Lio_circe_DecodingFailure$();
        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
        var x1$5 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
        var err$3 = $as_Lio_circe_DecodingFailure(x1$5.s_util_Left__f_value);
        var x1$6 = new $c_s_util_Left(err$3)
      };
      if ((x1$6 instanceof $c_s_util_Right)) {
        var x2$6 = $as_s_util_Right(x1$6);
        var v$4 = $as_Lshapeless_$colon$plus$colon($n(x2$6).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$4))
      } else if ((x1$6 instanceof $c_s_util_Left)) {
        var x3$4 = $as_s_util_Left(x1$6);
        var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
        return new $c_s_util_Left(err$4)
      } else {
        throw new $c_s_MatchError(x1$6)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6: 0
}, false, "reactbuild.project.ResourceUsage$anon$lazy$macro$267$1$$anon$6", {
  Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6.prototype.$classData = $d_Lreactbuild_project_ResourceUsage$anon$lazy$macro$267$1$$anon$6;
/** @constructor */
function $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16(outer) {
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericDecoderForPersonFilter = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericDecoderForProjectFilter = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericEncoderForPersonFilter = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericEncoderForProjectFilter = null;
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_$outer).inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericDecoderForPersonFilter = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericDecoderForProjectFilter = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_$outer).inst$macro$33__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericEncoderForPersonFilter = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_$outer).inst$macro$23__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericEncoderForProjectFilter = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O())
}
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16.prototype.constructor = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16;
/** @constructor */
function $h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16() {
  /*<skip>*/
}
$h_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16.prototype = $c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16.prototype;
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForPersonFilter = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForPersonFilter instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForPersonFilter);
    var circeGenericInlBindingForPersonFilter = $as_Lreactbuild_project_ResourceUsageClause$PersonFilter($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericEncoderForPersonFilter;
    var name = $as_T($n(transformConstructorNames).apply__O__O("PersonFilter"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForPersonFilter, name, discriminator)
  } else if ((circeGenericInrBindingForPersonFilter instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForPersonFilter);
    var circeGenericInrBindingForProjectFilter = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForProjectFilter instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForProjectFilter);
      var circeGenericInlBindingForProjectFilter = $as_Lreactbuild_project_ResourceUsageClause$ProjectFilter($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericEncoderForProjectFilter;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("ProjectFilter"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForProjectFilter, name$1, discriminator)
    } else if ((circeGenericInrBindingForProjectFilter instanceof $c_Lshapeless_Inr)) {
      $m_s_sys_package$().error__T__E("Cannot encode CNil")
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForProjectFilter)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForPersonFilter)
  }
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericDecoderForPersonFilter, c, $as_T($n(transformConstructorNames).apply__O__O("PersonFilter")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_project_ResourceUsageClause$PersonFilter($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16__f_circeGenericDecoderForProjectFilter, c, $as_T($n(transformConstructorNames).apply__O__O("ProjectFilter")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_project_ResourceUsageClause$ProjectFilter($n(x2$4).s_util_Right__f_value);
          var x1$6 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$6 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        $m_Lio_circe_DecodingFailure$();
        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
        var x1$5 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
        var err$3 = $as_Lio_circe_DecodingFailure(x1$5.s_util_Left__f_value);
        var x1$6 = new $c_s_util_Left(err$3)
      };
      if ((x1$6 instanceof $c_s_util_Right)) {
        var x2$6 = $as_s_util_Right(x1$6);
        var v$4 = $as_Lshapeless_$colon$plus$colon($n(x2$6).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$4))
      } else if ((x1$6 instanceof $c_s_util_Left)) {
        var x3$4 = $as_s_util_Left(x1$6);
        var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
        return new $c_s_util_Left(err$4)
      } else {
        throw new $c_s_MatchError(x1$6)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16 = new $TypeData().initClass({
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16: 0
}, false, "reactbuild.project.ResourceUsageClause$anon$lazy$macro$43$1$$anon$16", {
  Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16.prototype.$classData = $d_Lreactbuild_project_ResourceUsageClause$anon$lazy$macro$43$1$$anon$16;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1(outer) {
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForid = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForlabel2 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForicon = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForspan = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderFortargets = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForintensity = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForid = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForlabel2 = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForicon = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForspan = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderFortargets = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForintensity = null;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForlabel2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForicon = $m_Lreactbuild_project_generator_electricalboard_model_Icon$().Lreactbuild_project_generator_electricalboard_model_Icon$__f_decoder;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForspan = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_project_generator_electricalboard_model_LineSource$().Lreactbuild_project_generator_electricalboard_model_LineSource$__f_codecForLineSource;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderFortargets = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForintensity = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForlabel2 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForicon = $m_Lreactbuild_project_generator_electricalboard_model_Icon$().Lreactbuild_project_generator_electricalboard_model_Icon$__f_encoder;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForspan = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_project_generator_electricalboard_model_LineSource$().Lreactbuild_project_generator_electricalboard_model_LineSource$__f_codecForLineSource;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderFortargets = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
  this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForintensity = new $c_Lio_circe_Encoder$$anon$21(e)
}
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForlabel1 = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForlabel2 = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForicon = $as_s_Option($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForspan = $uI($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingFortargets = $as_sci_List($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_$colon$colon($n(p6).Lshapeless_$colon$colon__f_tail);
              if ((p7 !== null)) {
                var circeGenericHListBindingForintensity = $as_s_Option($n(p7).Lshapeless_$colon$colon__f_head);
                var p8 = $as_Lshapeless_HNil($n(p7).Lshapeless_$colon$colon__f_tail);
                var x = $m_Lshapeless_HNil$();
                if ((x === p8)) {
                  var $$x7 = $m_Lio_circe_JsonObject$();
                  var this$5 = $m_sci_Vector$();
                  var $$x6 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid));
                  var $$x5 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("label1"), $n(this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForlabel2).apply__O__Lio_circe_Json(circeGenericHListBindingForlabel1));
                  var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("label2"), $n(this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForlabel2).apply__O__Lio_circe_Json(circeGenericHListBindingForlabel2));
                  var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("icon"), $n(this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForicon).apply__O__Lio_circe_Json(circeGenericHListBindingForicon));
                  var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("span"), $n(this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForspan).apply__O__Lio_circe_Json(circeGenericHListBindingForspan));
                  var $$x1 = $n(transformMemberNames).apply__O__O("targets");
                  var this$1 = $n(this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderFortargets);
                  var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFortargets)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("intensity"), $n(this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericEncoderForintensity).apply__O__Lio_circe_Json(circeGenericHListBindingForintensity))];
                  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                  return $n($$x7).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
                }
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("label1"))), this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForlabel2, "label1", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("label2"))), this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForlabel2, "label2", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("icon"))), this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForicon, "icon", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("span"))), this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForspan, "span", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("targets"))), this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderFortargets, "targets", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("intensity"))), this.Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1__f_circeGenericDecoderForintensity, "intensity", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.Cell$anon$lazy$macro$59$1$$anon$1", {
  Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Cell$anon$lazy$macro$59$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1(outer) {
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderForid = null;
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderForcells = null;
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderForid = null;
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderForcells = null;
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_project_generator_electricalboard_model_Cell$().Lreactbuild_project_generator_electricalboard_model_Cell$__f_codecForCell;
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderForcells = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_project_generator_electricalboard_model_Cell$().Lreactbuild_project_generator_electricalboard_model_Cell$__f_codecForCell;
  this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderForcells = new $c_Lio_circe_Encoder$$anon$23(encodeA)
}
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForcells = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x3 = $m_Lio_circe_JsonObject$();
        var this$5 = $m_sci_Vector$();
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid));
        var $$x1 = $n(transformMemberNames).apply__O__O("cells");
        var this$1 = $n(this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericEncoderForcells);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForcells))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x3).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("cells"))), this.Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1__f_circeGenericDecoderForcells, "cells", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.Line$anon$lazy$macro$19$1$$anon$1", {
  Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Line$anon$lazy$macro$19$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1(outer) {
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForid = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForlabel = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderFordiameter = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForwireColors = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForid = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForlabel = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderFordiameter = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForwireColors = null;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForid = $m_Lio_circe_Decoder$().decodeUUID__Lio_circe_Decoder();
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForlabel = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  $m_Lio_circe_Decoder$();
  var d = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderFordiameter = new $c_Lio_circe_Decoder$$anon$39(d);
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_project_generator_electricalboard_model_WireColor$().Lreactbuild_project_generator_electricalboard_model_WireColor$__f_codecForWireColor;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForwireColors = new $c_Lio_circe_Decoder$$anon$43(decodeA);
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForid = $m_Lio_circe_Encoder$().encodeUUID__Lio_circe_Encoder();
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForlabel = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  $m_Lio_circe_Encoder$();
  var e = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderFordiameter = new $c_Lio_circe_Encoder$$anon$21(e);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_project_generator_electricalboard_model_WireColor$().Lreactbuild_project_generator_electricalboard_model_WireColor$__f_codecForWireColor;
  this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForwireColors = new $c_Lio_circe_Encoder$$anon$24(encodeA)
}
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForid = $as_ju_UUID($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForlabel = $as_T($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFordiameter = $as_s_Option($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForwireColors = $as_sci_Set($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_HNil($n(p4).Lshapeless_$colon$colon__f_tail);
          var x = $m_Lshapeless_HNil$();
          if ((x === p5)) {
            var $$x5 = $m_Lio_circe_JsonObject$();
            var this$5 = $m_sci_Vector$();
            var $$x4 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("id"), $n(this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForid).apply__O__Lio_circe_Json(circeGenericHListBindingForid));
            var $$x3 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("label"), $n(this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForlabel).apply__O__Lio_circe_Json(circeGenericHListBindingForlabel));
            var $$x2 = $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("diameter"), $n(this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderFordiameter).apply__O__Lio_circe_Json(circeGenericHListBindingFordiameter));
            var $$x1 = $n(transformMemberNames).apply__O__O("wireColors");
            var this$1 = $n(this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericEncoderForwireColors);
            var array = [$$x4, $$x3, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForwireColors))];
            var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
            return $n($$x5).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("id"))), this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForid, "id", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("label"))), this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForlabel, "label", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("diameter"))), this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderFordiameter, "diameter", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("wireColors"))), this.Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1__f_circeGenericDecoderForwireColors, "wireColors", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.LineSource$anon$lazy$macro$35$1$$anon$1", {
  Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_LineSource$anon$lazy$macro$35$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1(outer) {
  this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1__f_circeGenericDecoderForlines = null;
  this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1__f_circeGenericEncoderForlines = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_project_generator_electricalboard_model_Line$().Lreactbuild_project_generator_electricalboard_model_Line$__f_codecForLine;
  this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1__f_circeGenericDecoderForlines = new $c_Lio_circe_Decoder$$anon$42(decodeA);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_project_generator_electricalboard_model_Line$().Lreactbuild_project_generator_electricalboard_model_Line$__f_codecForLine;
  this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1__f_circeGenericEncoderForlines = new $c_Lio_circe_Encoder$$anon$23(encodeA)
}
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForlines = $as_sci_Seq($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_HNil($n(a).Lshapeless_$colon$colon__f_tail);
    var x = $m_Lshapeless_HNil$();
    if ((x === p2)) {
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$5 = $m_sci_Vector$();
      var $$x1 = $n(transformMemberNames).apply__O__O("lines");
      var this$1 = $n(this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1__f_circeGenericEncoderForlines);
      var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingForlines))];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("lines"))), this.Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1__f_circeGenericDecoderForlines, "lines", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.Table$anon$lazy$macro$11$1$$anon$1", {
  Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_Table$anon$lazy$macro$11$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1(outer) {
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForBlack = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForBlue = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForBrown = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForGray = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForGround = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForLightBlue = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForOrange = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForRed = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForViolet = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForWhite = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForBlack = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForBlue = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForBrown = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForGray = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForGround = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForLightBlue = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForOrange = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForRed = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForViolet = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForWhite = null;
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$13__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForBlack = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$12__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForBlue = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$11__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForBrown = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$10__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForGray = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$9__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForGround = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$8__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForLightBlue = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForOrange = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForRed = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O());
  var t$8 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForViolet = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$8).value__O());
  var t$9 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForWhite = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$9).value__O());
  var t$10 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$24__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForBlack = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$10).value__O());
  var t$11 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$23__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForBlue = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$11).value__O());
  var t$12 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$22__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForBrown = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$12).value__O());
  var t$13 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$21__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForGray = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$13).value__O());
  var t$14 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$20__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForGround = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$14).value__O());
  var t$15 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$19__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForLightBlue = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$15).value__O());
  var t$16 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$18__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForOrange = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$16).value__O());
  var t$17 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$17__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForRed = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$17).value__O());
  var t$18 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$16__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForViolet = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$18).value__O());
  var t$19 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_$outer).inst$macro$14__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForWhite = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$19).value__O())
}
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1.prototype.constructor = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1.prototype = $c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1.prototype;
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForBlack = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForBlack instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForBlack);
    var circeGenericInlBindingForBlack = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForBlack;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Black"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForBlack, name, discriminator)
  } else if ((circeGenericInrBindingForBlack instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForBlack);
    var circeGenericInrBindingForBlue = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForBlue instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForBlue);
      var circeGenericInlBindingForBlue = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForBlue;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Blue"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForBlue, name$1, discriminator)
    } else if ((circeGenericInrBindingForBlue instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForBlue);
      var circeGenericInrBindingForBrown = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForBrown instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForBrown);
        var circeGenericInlBindingForBrown = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForBrown;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Brown"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForBrown, name$2, discriminator)
      } else if ((circeGenericInrBindingForBrown instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForBrown);
        var circeGenericInrBindingForGray = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForGray instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForGray);
          var circeGenericInlBindingForGray = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForGray;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("Gray"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForGray, name$3, discriminator)
        } else if ((circeGenericInrBindingForGray instanceof $c_Lshapeless_Inr)) {
          var x3$4 = $as_Lshapeless_Inr(circeGenericInrBindingForGray);
          var circeGenericInrBindingForGround = $as_Lshapeless_$colon$plus$colon($n(x3$4).Lshapeless_Inr__f_tail);
          if ((circeGenericInrBindingForGround instanceof $c_Lshapeless_Inl)) {
            var x2$5 = $as_Lshapeless_Inl(circeGenericInrBindingForGround);
            var circeGenericInlBindingForGround = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$($n(x2$5).Lshapeless_Inl__f_head);
            var encode$4 = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForGround;
            var name$4 = $as_T($n(transformConstructorNames).apply__O__O("Ground"));
            return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$4, circeGenericInlBindingForGround, name$4, discriminator)
          } else if ((circeGenericInrBindingForGround instanceof $c_Lshapeless_Inr)) {
            var x3$5 = $as_Lshapeless_Inr(circeGenericInrBindingForGround);
            var circeGenericInrBindingForLightBlue = $as_Lshapeless_$colon$plus$colon($n(x3$5).Lshapeless_Inr__f_tail);
            if ((circeGenericInrBindingForLightBlue instanceof $c_Lshapeless_Inl)) {
              var x2$6 = $as_Lshapeless_Inl(circeGenericInrBindingForLightBlue);
              var circeGenericInlBindingForLightBlue = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$($n(x2$6).Lshapeless_Inl__f_head);
              var encode$5 = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForLightBlue;
              var name$5 = $as_T($n(transformConstructorNames).apply__O__O("LightBlue"));
              return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$5, circeGenericInlBindingForLightBlue, name$5, discriminator)
            } else if ((circeGenericInrBindingForLightBlue instanceof $c_Lshapeless_Inr)) {
              var x3$6 = $as_Lshapeless_Inr(circeGenericInrBindingForLightBlue);
              var circeGenericInrBindingForOrange = $as_Lshapeless_$colon$plus$colon($n(x3$6).Lshapeless_Inr__f_tail);
              if ((circeGenericInrBindingForOrange instanceof $c_Lshapeless_Inl)) {
                var x2$7 = $as_Lshapeless_Inl(circeGenericInrBindingForOrange);
                var circeGenericInlBindingForOrange = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$($n(x2$7).Lshapeless_Inl__f_head);
                var encode$6 = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForOrange;
                var name$6 = $as_T($n(transformConstructorNames).apply__O__O("Orange"));
                return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$6, circeGenericInlBindingForOrange, name$6, discriminator)
              } else if ((circeGenericInrBindingForOrange instanceof $c_Lshapeless_Inr)) {
                var x3$7 = $as_Lshapeless_Inr(circeGenericInrBindingForOrange);
                var circeGenericInrBindingForRed = $as_Lshapeless_$colon$plus$colon($n(x3$7).Lshapeless_Inr__f_tail);
                if ((circeGenericInrBindingForRed instanceof $c_Lshapeless_Inl)) {
                  var x2$8 = $as_Lshapeless_Inl(circeGenericInrBindingForRed);
                  var circeGenericInlBindingForRed = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$($n(x2$8).Lshapeless_Inl__f_head);
                  var encode$7 = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForRed;
                  var name$7 = $as_T($n(transformConstructorNames).apply__O__O("Red"));
                  return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$7, circeGenericInlBindingForRed, name$7, discriminator)
                } else if ((circeGenericInrBindingForRed instanceof $c_Lshapeless_Inr)) {
                  var x3$8 = $as_Lshapeless_Inr(circeGenericInrBindingForRed);
                  var circeGenericInrBindingForViolet = $as_Lshapeless_$colon$plus$colon($n(x3$8).Lshapeless_Inr__f_tail);
                  if ((circeGenericInrBindingForViolet instanceof $c_Lshapeless_Inl)) {
                    var x2$9 = $as_Lshapeless_Inl(circeGenericInrBindingForViolet);
                    var circeGenericInlBindingForViolet = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$($n(x2$9).Lshapeless_Inl__f_head);
                    var encode$8 = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForViolet;
                    var name$8 = $as_T($n(transformConstructorNames).apply__O__O("Violet"));
                    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$8, circeGenericInlBindingForViolet, name$8, discriminator)
                  } else if ((circeGenericInrBindingForViolet instanceof $c_Lshapeless_Inr)) {
                    var x3$9 = $as_Lshapeless_Inr(circeGenericInrBindingForViolet);
                    var circeGenericInrBindingForWhite = $as_Lshapeless_$colon$plus$colon($n(x3$9).Lshapeless_Inr__f_tail);
                    if ((circeGenericInrBindingForWhite instanceof $c_Lshapeless_Inl)) {
                      var x2$10 = $as_Lshapeless_Inl(circeGenericInrBindingForWhite);
                      var circeGenericInlBindingForWhite = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$White$($n(x2$10).Lshapeless_Inl__f_head);
                      var encode$9 = this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericEncoderForWhite;
                      var name$9 = $as_T($n(transformConstructorNames).apply__O__O("White"));
                      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$9, circeGenericInlBindingForWhite, name$9, discriminator)
                    } else if ((circeGenericInrBindingForWhite instanceof $c_Lshapeless_Inr)) {
                      $m_s_sys_package$().error__T__E("Cannot encode CNil")
                    } else {
                      throw new $c_s_MatchError(circeGenericInrBindingForWhite)
                    }
                  } else {
                    throw new $c_s_MatchError(circeGenericInrBindingForViolet)
                  }
                } else {
                  throw new $c_s_MatchError(circeGenericInrBindingForRed)
                }
              } else {
                throw new $c_s_MatchError(circeGenericInrBindingForOrange)
              }
            } else {
              throw new $c_s_MatchError(circeGenericInrBindingForLightBlue)
            }
          } else {
            throw new $c_s_MatchError(circeGenericInrBindingForGround)
          }
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForGray)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForBrown)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForBlue)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForBlack)
  }
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForBlack, c, $as_T($n(transformConstructorNames).apply__O__O("Black")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Black$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForBlue, c, $as_T($n(transformConstructorNames).apply__O__O("Blue")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Blue$($n(x2$4).s_util_Right__f_value);
          var x1$30 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$30 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForBrown, c, $as_T($n(transformConstructorNames).apply__O__O("Brown")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Brown$($n(x2$6).s_util_Right__f_value);
            var x1$29 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$29 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForGray, c, $as_T($n(transformConstructorNames).apply__O__O("Gray")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Gray$($n(x2$8).s_util_Right__f_value);
              var x1$28 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$28 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            var x1$9 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForGround, c, $as_T($n(transformConstructorNames).apply__O__O("Ground")), discriminator);
            if ((x1$9 instanceof $c_s_Some)) {
              var x2$9 = $as_s_Some(x1$9);
              var result$5 = $as_s_util_Either($n(x2$9).s_Some__f_value);
              if ((result$5 instanceof $c_s_util_Right)) {
                var x2$10 = $as_s_util_Right(result$5);
                var v$5 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Ground$($n(x2$10).s_util_Right__f_value);
                var x1$27 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$5))
              } else {
                if ((!(result$5 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(result$5)
                };
                var x3$5 = $as_s_util_Left(result$5);
                var err$5 = $as_Lio_circe_DecodingFailure($n(x3$5).s_util_Left__f_value);
                var x1$27 = new $c_s_util_Left(err$5)
              }
            } else {
              var x$9 = $m_s_None$();
              if ((!(x$9 === x1$9))) {
                throw new $c_s_MatchError(x1$9)
              };
              var x1$11 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForLightBlue, c, $as_T($n(transformConstructorNames).apply__O__O("LightBlue")), discriminator);
              if ((x1$11 instanceof $c_s_Some)) {
                var x2$11 = $as_s_Some(x1$11);
                var result$6 = $as_s_util_Either($n(x2$11).s_Some__f_value);
                if ((result$6 instanceof $c_s_util_Right)) {
                  var x2$12 = $as_s_util_Right(result$6);
                  var v$6 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$LightBlue$($n(x2$12).s_util_Right__f_value);
                  var x1$26 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$6))
                } else {
                  if ((!(result$6 instanceof $c_s_util_Left))) {
                    throw new $c_s_MatchError(result$6)
                  };
                  var x3$6 = $as_s_util_Left(result$6);
                  var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
                  var x1$26 = new $c_s_util_Left(err$6)
                }
              } else {
                var x$11 = $m_s_None$();
                if ((!(x$11 === x1$11))) {
                  throw new $c_s_MatchError(x1$11)
                };
                var x1$13 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForOrange, c, $as_T($n(transformConstructorNames).apply__O__O("Orange")), discriminator);
                if ((x1$13 instanceof $c_s_Some)) {
                  var x2$13 = $as_s_Some(x1$13);
                  var result$7 = $as_s_util_Either($n(x2$13).s_Some__f_value);
                  if ((result$7 instanceof $c_s_util_Right)) {
                    var x2$14 = $as_s_util_Right(result$7);
                    var v$7 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Orange$($n(x2$14).s_util_Right__f_value);
                    var x1$25 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$7))
                  } else {
                    if ((!(result$7 instanceof $c_s_util_Left))) {
                      throw new $c_s_MatchError(result$7)
                    };
                    var x3$7 = $as_s_util_Left(result$7);
                    var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
                    var x1$25 = new $c_s_util_Left(err$7)
                  }
                } else {
                  var x$13 = $m_s_None$();
                  if ((!(x$13 === x1$13))) {
                    throw new $c_s_MatchError(x1$13)
                  };
                  var x1$15 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForRed, c, $as_T($n(transformConstructorNames).apply__O__O("Red")), discriminator);
                  if ((x1$15 instanceof $c_s_Some)) {
                    var x2$15 = $as_s_Some(x1$15);
                    var result$8 = $as_s_util_Either($n(x2$15).s_Some__f_value);
                    if ((result$8 instanceof $c_s_util_Right)) {
                      var x2$16 = $as_s_util_Right(result$8);
                      var v$8 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Red$($n(x2$16).s_util_Right__f_value);
                      var x1$24 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$8))
                    } else {
                      if ((!(result$8 instanceof $c_s_util_Left))) {
                        throw new $c_s_MatchError(result$8)
                      };
                      var x3$8 = $as_s_util_Left(result$8);
                      var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
                      var x1$24 = new $c_s_util_Left(err$8)
                    }
                  } else {
                    var x$15 = $m_s_None$();
                    if ((!(x$15 === x1$15))) {
                      throw new $c_s_MatchError(x1$15)
                    };
                    var x1$17 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForViolet, c, $as_T($n(transformConstructorNames).apply__O__O("Violet")), discriminator);
                    if ((x1$17 instanceof $c_s_Some)) {
                      var x2$17 = $as_s_Some(x1$17);
                      var result$9 = $as_s_util_Either($n(x2$17).s_Some__f_value);
                      if ((result$9 instanceof $c_s_util_Right)) {
                        var x2$18 = $as_s_util_Right(result$9);
                        var v$9 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$Violet$($n(x2$18).s_util_Right__f_value);
                        var x1$23 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$9))
                      } else {
                        if ((!(result$9 instanceof $c_s_util_Left))) {
                          throw new $c_s_MatchError(result$9)
                        };
                        var x3$9 = $as_s_util_Left(result$9);
                        var err$9 = $as_Lio_circe_DecodingFailure($n(x3$9).s_util_Left__f_value);
                        var x1$23 = new $c_s_util_Left(err$9)
                      }
                    } else {
                      var x$17 = $m_s_None$();
                      if ((!(x$17 === x1$17))) {
                        throw new $c_s_MatchError(x1$17)
                      };
                      var x1$19 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1__f_circeGenericDecoderForWhite, c, $as_T($n(transformConstructorNames).apply__O__O("White")), discriminator);
                      if ((x1$19 instanceof $c_s_Some)) {
                        var x2$19 = $as_s_Some(x1$19);
                        var result$10 = $as_s_util_Either($n(x2$19).s_Some__f_value);
                        if ((result$10 instanceof $c_s_util_Right)) {
                          var x2$20 = $as_s_util_Right(result$10);
                          var v$10 = $as_Lreactbuild_project_generator_electricalboard_model_WireColor$White$($n(x2$20).s_util_Right__f_value);
                          var x1$22 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$10))
                        } else {
                          if ((!(result$10 instanceof $c_s_util_Left))) {
                            throw new $c_s_MatchError(result$10)
                          };
                          var x3$10 = $as_s_util_Left(result$10);
                          var err$10 = $as_Lio_circe_DecodingFailure($n(x3$10).s_util_Left__f_value);
                          var x1$22 = new $c_s_util_Left(err$10)
                        }
                      } else {
                        var x$19 = $m_s_None$();
                        if ((!(x$19 === x1$19))) {
                          throw new $c_s_MatchError(x1$19)
                        };
                        $m_Lio_circe_DecodingFailure$();
                        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
                        var x1$21 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
                        var err$11 = $as_Lio_circe_DecodingFailure(x1$21.s_util_Left__f_value);
                        var x1$22 = new $c_s_util_Left(err$11)
                      };
                      if ((x1$22 instanceof $c_s_util_Right)) {
                        var x2$22 = $as_s_util_Right(x1$22);
                        var v$12 = $as_Lshapeless_$colon$plus$colon($n(x2$22).s_util_Right__f_value);
                        var x1$23 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$12))
                      } else {
                        if ((!(x1$22 instanceof $c_s_util_Left))) {
                          throw new $c_s_MatchError(x1$22)
                        };
                        var x3$12 = $as_s_util_Left(x1$22);
                        var err$12 = $as_Lio_circe_DecodingFailure($n(x3$12).s_util_Left__f_value);
                        var x1$23 = new $c_s_util_Left(err$12)
                      }
                    };
                    if ((x1$23 instanceof $c_s_util_Right)) {
                      var x2$23 = $as_s_util_Right(x1$23);
                      var v$13 = $as_Lshapeless_$colon$plus$colon($n(x2$23).s_util_Right__f_value);
                      var x1$24 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$13))
                    } else {
                      if ((!(x1$23 instanceof $c_s_util_Left))) {
                        throw new $c_s_MatchError(x1$23)
                      };
                      var x3$13 = $as_s_util_Left(x1$23);
                      var err$13 = $as_Lio_circe_DecodingFailure($n(x3$13).s_util_Left__f_value);
                      var x1$24 = new $c_s_util_Left(err$13)
                    }
                  };
                  if ((x1$24 instanceof $c_s_util_Right)) {
                    var x2$24 = $as_s_util_Right(x1$24);
                    var v$14 = $as_Lshapeless_$colon$plus$colon($n(x2$24).s_util_Right__f_value);
                    var x1$25 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$14))
                  } else {
                    if ((!(x1$24 instanceof $c_s_util_Left))) {
                      throw new $c_s_MatchError(x1$24)
                    };
                    var x3$14 = $as_s_util_Left(x1$24);
                    var err$14 = $as_Lio_circe_DecodingFailure($n(x3$14).s_util_Left__f_value);
                    var x1$25 = new $c_s_util_Left(err$14)
                  }
                };
                if ((x1$25 instanceof $c_s_util_Right)) {
                  var x2$25 = $as_s_util_Right(x1$25);
                  var v$15 = $as_Lshapeless_$colon$plus$colon($n(x2$25).s_util_Right__f_value);
                  var x1$26 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$15))
                } else {
                  if ((!(x1$25 instanceof $c_s_util_Left))) {
                    throw new $c_s_MatchError(x1$25)
                  };
                  var x3$15 = $as_s_util_Left(x1$25);
                  var err$15 = $as_Lio_circe_DecodingFailure($n(x3$15).s_util_Left__f_value);
                  var x1$26 = new $c_s_util_Left(err$15)
                }
              };
              if ((x1$26 instanceof $c_s_util_Right)) {
                var x2$26 = $as_s_util_Right(x1$26);
                var v$16 = $as_Lshapeless_$colon$plus$colon($n(x2$26).s_util_Right__f_value);
                var x1$27 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$16))
              } else {
                if ((!(x1$26 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(x1$26)
                };
                var x3$16 = $as_s_util_Left(x1$26);
                var err$16 = $as_Lio_circe_DecodingFailure($n(x3$16).s_util_Left__f_value);
                var x1$27 = new $c_s_util_Left(err$16)
              }
            };
            if ((x1$27 instanceof $c_s_util_Right)) {
              var x2$27 = $as_s_util_Right(x1$27);
              var v$17 = $as_Lshapeless_$colon$plus$colon($n(x2$27).s_util_Right__f_value);
              var x1$28 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$17))
            } else {
              if ((!(x1$27 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(x1$27)
              };
              var x3$17 = $as_s_util_Left(x1$27);
              var err$17 = $as_Lio_circe_DecodingFailure($n(x3$17).s_util_Left__f_value);
              var x1$28 = new $c_s_util_Left(err$17)
            }
          };
          if ((x1$28 instanceof $c_s_util_Right)) {
            var x2$28 = $as_s_util_Right(x1$28);
            var v$18 = $as_Lshapeless_$colon$plus$colon($n(x2$28).s_util_Right__f_value);
            var x1$29 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$18))
          } else {
            if ((!(x1$28 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$28)
            };
            var x3$18 = $as_s_util_Left(x1$28);
            var err$18 = $as_Lio_circe_DecodingFailure($n(x3$18).s_util_Left__f_value);
            var x1$29 = new $c_s_util_Left(err$18)
          }
        };
        if ((x1$29 instanceof $c_s_util_Right)) {
          var x2$29 = $as_s_util_Right(x1$29);
          var v$19 = $as_Lshapeless_$colon$plus$colon($n(x2$29).s_util_Right__f_value);
          var x1$30 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$19))
        } else {
          if ((!(x1$29 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$29)
          };
          var x3$19 = $as_s_util_Left(x1$29);
          var err$19 = $as_Lio_circe_DecodingFailure($n(x3$19).s_util_Left__f_value);
          var x1$30 = new $c_s_util_Left(err$19)
        }
      };
      if ((x1$30 instanceof $c_s_util_Right)) {
        var x2$30 = $as_s_util_Right(x1$30);
        var v$20 = $as_Lshapeless_$colon$plus$colon($n(x2$30).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$20))
      } else if ((x1$30 instanceof $c_s_util_Left)) {
        var x3$20 = $as_s_util_Left(x1$30);
        var err$20 = $as_Lio_circe_DecodingFailure($n(x3$20).s_util_Left__f_value);
        return new $c_s_util_Left(err$20)
      } else {
        throw new $c_s_MatchError(x1$30)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1: 0
}, false, "reactbuild.project.generator.electricalboard.model.WireColor$anon$lazy$macro$25$1$$anon$1", {
  Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1.prototype.$classData = $d_Lreactbuild_project_generator_electricalboard_model_WireColor$anon$lazy$macro$25$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6(outer) {
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericDecoderFortpe = null;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericDecoderForestimatedDuration = null;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericDecoderForname = null;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericEncoderFortpe = null;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericEncoderForestimatedDuration = null;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericEncoderForname = null;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericDecoderFortpe = $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$().Lreactbuild_task_TaskScheduler$AllocatablePeriodType$__f_codecForAllocatablePeriodType;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericDecoderForestimatedDuration = $m_Lio_circe_Decoder$().decodeDuration__Lio_circe_Decoder();
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericDecoderForname = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericEncoderFortpe = $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$().Lreactbuild_task_TaskScheduler$AllocatablePeriodType$__f_codecForAllocatablePeriodType;
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericEncoderForestimatedDuration = $m_Lio_circe_Encoder$().encodeDuration__Lio_circe_Encoder();
  this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericEncoderForname = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString
}
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6.prototype = $c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6.prototype;
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFortpe = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForestimatedDuration = $as_Ljava_time_Duration($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForname = $as_T($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x2 = $m_Lio_circe_JsonObject$();
          var this$5 = $m_sci_Vector$();
          var $$x1 = $n(transformMemberNames).apply__O__O("tpe");
          var this$1 = $n(this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericEncoderFortpe);
          var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFortpe)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("estimatedDuration"), $n(this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericEncoderForestimatedDuration).apply__O__Lio_circe_Json(circeGenericHListBindingForestimatedDuration)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("name"), $n(this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericEncoderForname).apply__O__Lio_circe_Json(circeGenericHListBindingForname))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("tpe"))), this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericDecoderFortpe, "tpe", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("estimatedDuration"))), this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericDecoderForestimatedDuration, "estimatedDuration", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("name"))), this.Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6__f_circeGenericDecoderForname, "name", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6: 0
}, false, "reactbuild.task.TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6", {
  Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Activity$anon$lazy$macro$27$3$$anon$6;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5(outer) {
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericDecoderForto = null;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericDecoderForestimatedDuration = null;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericEncoderForto = null;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericEncoderForestimatedDuration = null;
  $m_Lio_circe_Decoder$();
  var d = $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$().Lreactbuild_task_TaskScheduler$AllocatablePeriodType$__f_codecForAllocatablePeriodType;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericDecoderForto = new $c_Lio_circe_Decoder$$anon$39(d);
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericDecoderForestimatedDuration = $m_Lio_circe_Decoder$().decodeDuration__Lio_circe_Decoder();
  $m_Lio_circe_Encoder$();
  var e = $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$().Lreactbuild_task_TaskScheduler$AllocatablePeriodType$__f_codecForAllocatablePeriodType;
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericEncoderForto = new $c_Lio_circe_Encoder$$anon$21(e);
  this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericEncoderForestimatedDuration = $m_Lio_circe_Encoder$().encodeDuration__Lio_circe_Encoder()
}
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5.prototype = $c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5.prototype;
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingForfrom = $as_s_Option($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForto = $as_s_Option($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForestimatedDuration = $as_Ljava_time_Duration($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x1 = $m_Lio_circe_JsonObject$();
          var this$4 = $m_sci_Vector$();
          var array = [$ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("from"), $n(this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericEncoderForto).apply__O__Lio_circe_Json(circeGenericHListBindingForfrom)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("to"), $n(this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericEncoderForto).apply__O__Lio_circe_Json(circeGenericHListBindingForto)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("estimatedDuration"), $n(this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericEncoderForestimatedDuration).apply__O__Lio_circe_Json(circeGenericHListBindingForestimatedDuration))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("from"))), this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericDecoderForto, "from", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("to"))), this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericDecoderForto, "to", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("estimatedDuration"))), this.Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5__f_circeGenericDecoderForestimatedDuration, "estimatedDuration", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5: 0
}, false, "reactbuild.task.TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5", {
  Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$ActivityTransition$anon$lazy$macro$27$2$$anon$5;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4(outer) {
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericDecoderFortpe = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericDecoderForend = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericEncoderFortpe = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericEncoderForend = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericDecoderFortpe = $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$().Lreactbuild_task_TaskScheduler$AllocatablePeriodType$__f_codecForAllocatablePeriodType;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericDecoderForend = $m_Lio_circe_Decoder$().decodeLocalTime__Lio_circe_Decoder();
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericEncoderFortpe = $m_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$().Lreactbuild_task_TaskScheduler$AllocatablePeriodType$__f_codecForAllocatablePeriodType;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericEncoderForend = $m_Lio_circe_Encoder$().encodeLocalTime__Lio_circe_Encoder()
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFortpe = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForstart = $as_Ljava_time_LocalTime($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForend = $as_Ljava_time_LocalTime($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x2 = $m_Lio_circe_JsonObject$();
          var this$5 = $m_sci_Vector$();
          var $$x1 = $n(transformMemberNames).apply__O__O("tpe");
          var this$1 = $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericEncoderFortpe);
          var array = [$ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFortpe)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("start"), $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericEncoderForend).apply__O__Lio_circe_Json(circeGenericHListBindingForstart)), $ct_T2__O__O__(new $c_T2(), $n(transformMemberNames).apply__O__O("end"), $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericEncoderForend).apply__O__Lio_circe_Json(circeGenericHListBindingForend))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x2).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$5.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("tpe"))), this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericDecoderFortpe, "tpe", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("start"))), this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericDecoderForend, "start", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("end"))), this.Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4__f_circeGenericDecoderForend, "end", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriod$anon$lazy$macro$27$1$$anon$4;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1(outer) {
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForAdministrative = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForCraftwork = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDev = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDraw = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForAdministrative = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForCraftwork = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDev = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDraw = null;
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$7__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForAdministrative = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$6__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForCraftwork = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$5__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDev = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$3__Lio_circe_generic_extras_decoding_ConfiguredDecoder()));
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDraw = $as_Lio_circe_generic_extras_decoding_ConfiguredDecoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O());
  var t$4 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$12__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForAdministrative = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$4).value__O());
  var t$5 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$11__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForCraftwork = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$5).value__O());
  var t$6 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$10__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDev = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$6).value__O());
  var t$7 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_$outer).inst$macro$8__Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder()));
  this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDraw = $as_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$7).value__O())
}
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1.prototype = $c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1.prototype;
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1.prototype.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForAdministrative = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForAdministrative instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForAdministrative);
    var circeGenericInlBindingForAdministrative = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$($n(x2).Lshapeless_Inl__f_head);
    var encode = this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForAdministrative;
    var name = $as_T($n(transformConstructorNames).apply__O__O("Administrative"));
    return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode, circeGenericInlBindingForAdministrative, name, discriminator)
  } else if ((circeGenericInrBindingForAdministrative instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForAdministrative);
    var circeGenericInrBindingForCraftwork = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForCraftwork instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForCraftwork);
      var circeGenericInlBindingForCraftwork = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$($n(x2$2).Lshapeless_Inl__f_head);
      var encode$1 = this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForCraftwork;
      var name$1 = $as_T($n(transformConstructorNames).apply__O__O("Craftwork"));
      return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$1, circeGenericInlBindingForCraftwork, name$1, discriminator)
    } else if ((circeGenericInrBindingForCraftwork instanceof $c_Lshapeless_Inr)) {
      var x3$2 = $as_Lshapeless_Inr(circeGenericInrBindingForCraftwork);
      var circeGenericInrBindingForDev = $as_Lshapeless_$colon$plus$colon($n(x3$2).Lshapeless_Inr__f_tail);
      if ((circeGenericInrBindingForDev instanceof $c_Lshapeless_Inl)) {
        var x2$3 = $as_Lshapeless_Inl(circeGenericInrBindingForDev);
        var circeGenericInlBindingForDev = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$($n(x2$3).Lshapeless_Inl__f_head);
        var encode$2 = this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDev;
        var name$2 = $as_T($n(transformConstructorNames).apply__O__O("Dev"));
        return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$2, circeGenericInlBindingForDev, name$2, discriminator)
      } else if ((circeGenericInrBindingForDev instanceof $c_Lshapeless_Inr)) {
        var x3$3 = $as_Lshapeless_Inr(circeGenericInrBindingForDev);
        var circeGenericInrBindingForDraw = $as_Lshapeless_$colon$plus$colon($n(x3$3).Lshapeless_Inr__f_tail);
        if ((circeGenericInrBindingForDraw instanceof $c_Lshapeless_Inl)) {
          var x2$4 = $as_Lshapeless_Inl(circeGenericInrBindingForDraw);
          var circeGenericInlBindingForDraw = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$($n(x2$4).Lshapeless_Inl__f_head);
          var encode$3 = this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericEncoderForDraw;
          var name$3 = $as_T($n(transformConstructorNames).apply__O__O("Draw"));
          return $f_Lio_circe_generic_extras_encoding_ReprAsObjectEncoder__addDiscriminator__Lio_circe_Encoder__O__T__s_Option__Lio_circe_JsonObject(this, encode$3, circeGenericInlBindingForDraw, name$3, discriminator)
        } else if ((circeGenericInrBindingForDraw instanceof $c_Lshapeless_Inr)) {
          $m_s_sys_package$().error__T__E("Cannot encode CNil")
        } else {
          throw new $c_s_MatchError(circeGenericInrBindingForDraw)
        }
      } else {
        throw new $c_s_MatchError(circeGenericInrBindingForDev)
      }
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForCraftwork)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForAdministrative)
  }
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  var x1 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForAdministrative, c, $as_T($n(transformConstructorNames).apply__O__O("Administrative")), discriminator);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result);
      var v = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Administrative$($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var x1$3 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForCraftwork, c, $as_T($n(transformConstructorNames).apply__O__O("Craftwork")), discriminator);
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$2 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$2 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$2);
          var v$2 = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Craftwork$($n(x2$4).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$2 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$2)
          };
          var x3$2 = $as_s_util_Left(result$2);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        var x1$5 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDev, c, $as_T($n(transformConstructorNames).apply__O__O("Dev")), discriminator);
        if ((x1$5 instanceof $c_s_Some)) {
          var x2$5 = $as_s_Some(x1$5);
          var result$3 = $as_s_util_Either($n(x2$5).s_Some__f_value);
          if ((result$3 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(result$3);
            var v$3 = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Dev$($n(x2$6).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$3))
          } else {
            if ((!(result$3 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(result$3)
            };
            var x3$3 = $as_s_util_Left(result$3);
            var err$3 = $as_Lio_circe_DecodingFailure($n(x3$3).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$3)
          }
        } else {
          var x$5 = $m_s_None$();
          if ((!(x$5 === x1$5))) {
            throw new $c_s_MatchError(x1$5)
          };
          var x1$7 = this.withDiscriminator__Lio_circe_Decoder__Lio_circe_HCursor__T__s_Option__s_Option(this.Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1__f_circeGenericDecoderForDraw, c, $as_T($n(transformConstructorNames).apply__O__O("Draw")), discriminator);
          if ((x1$7 instanceof $c_s_Some)) {
            var x2$7 = $as_s_Some(x1$7);
            var result$4 = $as_s_util_Either($n(x2$7).s_Some__f_value);
            if ((result$4 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(result$4);
              var v$4 = $as_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$Draw$($n(x2$8).s_util_Right__f_value);
              var x1$10 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$4))
            } else {
              if ((!(result$4 instanceof $c_s_util_Left))) {
                throw new $c_s_MatchError(result$4)
              };
              var x3$4 = $as_s_util_Left(result$4);
              var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
              var x1$10 = new $c_s_util_Left(err$4)
            }
          } else {
            var x$7 = $m_s_None$();
            if ((!(x$7 === x1$7))) {
              throw new $c_s_MatchError(x1$7)
            };
            $m_Lio_circe_DecodingFailure$();
            var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
            var x1$9 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
            var err$5 = $as_Lio_circe_DecodingFailure(x1$9.s_util_Left__f_value);
            var x1$10 = new $c_s_util_Left(err$5)
          };
          if ((x1$10 instanceof $c_s_util_Right)) {
            var x2$10 = $as_s_util_Right(x1$10);
            var v$6 = $as_Lshapeless_$colon$plus$colon($n(x2$10).s_util_Right__f_value);
            var x1$11 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$6))
          } else {
            if ((!(x1$10 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(x1$10)
            };
            var x3$6 = $as_s_util_Left(x1$10);
            var err$6 = $as_Lio_circe_DecodingFailure($n(x3$6).s_util_Left__f_value);
            var x1$11 = new $c_s_util_Left(err$6)
          }
        };
        if ((x1$11 instanceof $c_s_util_Right)) {
          var x2$11 = $as_s_util_Right(x1$11);
          var v$7 = $as_Lshapeless_$colon$plus$colon($n(x2$11).s_util_Right__f_value);
          var x1$12 = new $c_s_util_Right(new $c_Lshapeless_Inr(v$7))
        } else {
          if ((!(x1$11 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(x1$11)
          };
          var x3$7 = $as_s_util_Left(x1$11);
          var err$7 = $as_Lio_circe_DecodingFailure($n(x3$7).s_util_Left__f_value);
          var x1$12 = new $c_s_util_Left(err$7)
        }
      };
      if ((x1$12 instanceof $c_s_util_Right)) {
        var x2$12 = $as_s_util_Right(x1$12);
        var v$8 = $as_Lshapeless_$colon$plus$colon($n(x2$12).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$8))
      } else if ((x1$12 instanceof $c_s_util_Left)) {
        var x3$8 = $as_s_util_Left(x1$12);
        var err$8 = $as_Lio_circe_DecodingFailure($n(x3$8).s_util_Left__f_value);
        return new $c_s_util_Left(err$8)
      } else {
        throw new $c_s_MatchError(x1$12)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$plus$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1: 0
}, false, "reactbuild.task.TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1", {
  Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$AllocatablePeriodType$anon$lazy$macro$13$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7(outer) {
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericDecoderFordayTypes = null;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericDecoderFortasks = null;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericDecoderFortransitions = null;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericEncoderFordayTypes = null;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericEncoderFortasks = null;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericEncoderFortransitions = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lreactbuild_task_TaskScheduler$DayType$().Lreactbuild_task_TaskScheduler$DayType$__f_codecForDayType;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericDecoderFordayTypes = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Decoder$();
  var decodeA$1 = $m_Lreactbuild_task_TaskScheduler$Activity$().Lreactbuild_task_TaskScheduler$Activity$__f_codecForActivity;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericDecoderFortasks = new $c_Lio_circe_Decoder$$anon$44(decodeA$1);
  $m_Lio_circe_Decoder$();
  var decodeA$2 = $m_Lreactbuild_task_TaskScheduler$ActivityTransition$().Lreactbuild_task_TaskScheduler$ActivityTransition$__f_codecForActivityTransition;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericDecoderFortransitions = new $c_Lio_circe_Decoder$$anon$44(decodeA$2);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lreactbuild_task_TaskScheduler$DayType$().Lreactbuild_task_TaskScheduler$DayType$__f_codecForDayType;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericEncoderFordayTypes = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  $m_Lio_circe_Encoder$();
  var encodeA$1 = $m_Lreactbuild_task_TaskScheduler$Activity$().Lreactbuild_task_TaskScheduler$Activity$__f_codecForActivity;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericEncoderFortasks = new $c_Lio_circe_Encoder$$anon$25(encodeA$1);
  $m_Lio_circe_Encoder$();
  var encodeA$2 = $m_Lreactbuild_task_TaskScheduler$ActivityTransition$().Lreactbuild_task_TaskScheduler$ActivityTransition$__f_codecForActivityTransition;
  this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericEncoderFortransitions = new $c_Lio_circe_Encoder$$anon$25(encodeA$2)
}
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7.prototype = $c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7.prototype;
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFordayTypes = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingFortasks = $as_sci_List($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingFortransitions = $as_sci_List($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_HNil($n(p3).Lshapeless_$colon$colon__f_tail);
        var x = $m_Lshapeless_HNil$();
        if ((x === p4)) {
          var $$x6 = $m_Lio_circe_JsonObject$();
          var this$7 = $m_sci_Vector$();
          var $$x5 = $n(transformMemberNames).apply__O__O("dayTypes");
          var this$1 = $n(this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericEncoderFordayTypes);
          var $$x4 = $ct_T2__O__O__(new $c_T2(), $$x5, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordayTypes));
          var $$x3 = $n(transformMemberNames).apply__O__O("tasks");
          var this$2 = $n(this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericEncoderFortasks);
          var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingFortasks));
          var $$x1 = $n(transformMemberNames).apply__O__O("transitions");
          var this$3 = $n(this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericEncoderFortransitions);
          var array = [$$x4, $$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$3, circeGenericHListBindingFortransitions))];
          var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          return $n($$x6).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$7.from__sc_IterableOnce__sci_Vector(elems))
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("dayTypes"))), this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericDecoderFordayTypes, "dayTypes", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("tasks"))), this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericDecoderFortasks, "tasks", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("transitions"))), this.Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7__f_circeGenericDecoderFortransitions, "transitions", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7: 0
}, false, "reactbuild.task.TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7", {
  Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$Context$anon$lazy$macro$27$4$$anon$7;
/** @constructor */
function $c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3(outer) {
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericDecoderFordow = null;
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericDecoderForperiods = null;
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericEncoderFordow = null;
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericEncoderForperiods = null;
  $m_Lio_circe_Decoder$();
  var decodeA = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt;
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericDecoderFordow = new $c_Lio_circe_Decoder$$anon$44(decodeA);
  $m_Lio_circe_Decoder$();
  var decodeA$1 = $m_Lreactbuild_task_TaskScheduler$AllocatablePeriod$().Lreactbuild_task_TaskScheduler$AllocatablePeriod$__f_codecForAllocatablePeriod;
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericDecoderForperiods = new $c_Lio_circe_Decoder$$anon$42(decodeA$1);
  $m_Lio_circe_Encoder$();
  var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt;
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericEncoderFordow = new $c_Lio_circe_Encoder$$anon$25(encodeA);
  $m_Lio_circe_Encoder$();
  var encodeA$1 = $m_Lreactbuild_task_TaskScheduler$AllocatablePeriod$().Lreactbuild_task_TaskScheduler$AllocatablePeriod$__f_codecForAllocatablePeriod;
  this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericEncoderForperiods = new $c_Lio_circe_Encoder$$anon$23(encodeA$1)
}
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3.prototype = new $h_Lio_circe_generic_extras_codec_ReprAsObjectCodec();
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3.prototype.constructor = $c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3;
/** @constructor */
function $h_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3() {
  /*<skip>*/
}
$h_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3.prototype = $c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3.prototype;
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3.prototype.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformConstructorNames, discriminator) {
  if ((a !== null)) {
    var circeGenericHListBindingFordow = $as_sci_List($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForperiods = $as_sci_Seq($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_HNil($n(p2).Lshapeless_$colon$colon__f_tail);
      var x = $m_Lshapeless_HNil$();
      if ((x === p3)) {
        var $$x4 = $m_Lio_circe_JsonObject$();
        var this$6 = $m_sci_Vector$();
        var $$x3 = $n(transformMemberNames).apply__O__O("dow");
        var this$1 = $n(this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericEncoderFordow);
        var $$x2 = $ct_T2__O__O__(new $c_T2(), $$x3, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$1, circeGenericHListBindingFordow));
        var $$x1 = $n(transformMemberNames).apply__O__O("periods");
        var this$2 = $n(this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericEncoderForperiods);
        var array = [$$x2, $ct_T2__O__O__(new $c_T2(), $$x1, $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this$2, circeGenericHListBindingForperiods))];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        return $n($$x4).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$6.from__sc_IterableOnce__sci_Vector(elems))
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3.prototype.configuredDecode__Lio_circe_HCursor__F1__F1__sci_Map__s_Option__s_util_Either = (function(c, transformMemberNames, transformConstructorNames, defaults, discriminator) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("dow"))), this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericDecoderFordow, "dow", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O(this.orDefault__Lio_circe_ACursor__Lio_circe_Decoder__T__sci_Map__s_util_Either($n(c).downField__T__Lio_circe_ACursor($as_T($n(transformMemberNames).apply__O__O("periods"))), this.Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3__f_circeGenericDecoderForperiods, "periods", defaults), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3.prototype.configuredEncodeObject__O__F1__F1__s_Option__Lio_circe_JsonObject = (function(a, transformMemberNames, transformDiscriminator, discriminator) {
  return this.configuredEncodeObject__Lshapeless_$colon$colon__F1__F1__s_Option__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a), transformMemberNames, transformDiscriminator, discriminator)
});
var $d_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3 = new $TypeData().initClass({
  Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3: 0
}, false, "reactbuild.task.TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3", {
  Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3: 1,
  Lio_circe_generic_extras_codec_ReprAsObjectCodec: 1,
  Lio_circe_generic_extras_decoding_ReprDecoder: 1,
  O: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_generic_extras_encoding_ReprAsObjectEncoder: 1,
  Lio_circe_Encoder$AsObject: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder: 1
});
$c_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3.prototype.$classData = $d_Lreactbuild_task_TaskScheduler$DayType$anon$lazy$macro$15$1$$anon$3;
/** @constructor */
function $c_sc_AbstractView() {
  /*<skip>*/
}
$c_sc_AbstractView.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractView.prototype.constructor = $c_sc_AbstractView;
/** @constructor */
function $h_sc_AbstractView() {
  /*<skip>*/
}
$h_sc_AbstractView.prototype = $c_sc_AbstractView.prototype;
$c_sc_AbstractView.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_AbstractView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_AbstractView.prototype.stringPrefix__T = (function() {
  return "View"
});
/** @constructor */
function $c_sc_MapOps$$anon$1(outer) {
  this.sc_MapOps$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_MapOps$$anon$1__f_$outer = outer
  }
}
$c_sc_MapOps$$anon$1.prototype = new $h_sc_AbstractIterable();
$c_sc_MapOps$$anon$1.prototype.constructor = $c_sc_MapOps$$anon$1;
/** @constructor */
function $h_sc_MapOps$$anon$1() {
  /*<skip>*/
}
$h_sc_MapOps$$anon$1.prototype = $c_sc_MapOps$$anon$1.prototype;
$c_sc_MapOps$$anon$1.prototype.knownSize__I = (function() {
  return $n(this.sc_MapOps$$anon$1__f_$outer).knownSize__I()
});
$c_sc_MapOps$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_MapOps$$anon$1__f_$outer).valuesIterator__sc_Iterator()
});
var $d_sc_MapOps$$anon$1 = new $TypeData().initClass({
  sc_MapOps$$anon$1: 0
}, false, "scala.collection.MapOps$$anon$1", {
  sc_MapOps$$anon$1: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sc_MapOps$$anon$1.prototype.$classData = $d_sc_MapOps$$anon$1;
function $f_sc_Set__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true
  } else {
    if ($is_sc_Set(that)) {
      var x2 = $as_sc_Set(that);
      if (($n(x2), true)) {
        if (($thiz.size__I() === $n(x2).size__I())) {
          try {
            return $thiz.subsetOf__sc_Set__Z(x2)
          } catch (e) {
            if ((e instanceof $c_jl_ClassCastException)) {
              return false
            } else {
              throw e
            }
          }
        } else {
          return false
        }
      }
    };
    return false
  }
}
function $is_sc_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Set)))
}
function $as_sc_Set(obj) {
  return (($is_sc_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Set"))
}
function $isArrayOf_sc_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Set)))
}
function $asArrayOf_sc_Set(obj, depth) {
  return (($isArrayOf_sc_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Set;", depth))
}
function $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps($thiz, that) {
  var result = $as_sci_SetOps($thiz);
  var it = $n(that).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(result);
    var elem = $n(it).next__O();
    result = this$1.incl__O__sci_SetOps(elem)
  };
  return result
}
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Any";
  $m_s_package$();
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$AnyManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$AnyManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$AnyManifest$.prototype = $c_s_reflect_ManifestFactory$AnyManifest$.prototype;
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf()
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$AnyManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$AnyManifest$: 0
}, false, "scala.reflect.ManifestFactory$AnyManifest$", {
  s_reflect_ManifestFactory$AnyManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$AnyManifest$;
var $n_s_reflect_ManifestFactory$AnyManifest$;
function $m_s_reflect_ManifestFactory$AnyManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyManifest$)) {
    $n_s_reflect_ManifestFactory$AnyManifest$ = new $c_s_reflect_ManifestFactory$AnyManifest$()
  };
  return $n_s_reflect_ManifestFactory$AnyManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Boolean";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype = new $h_s_reflect_ManifestFactory$BooleanManifest();
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$BooleanManifest$.prototype = $c_s_reflect_ManifestFactory$BooleanManifest$.prototype;
var $d_s_reflect_ManifestFactory$BooleanManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$BooleanManifest$: 0
}, false, "scala.reflect.ManifestFactory$BooleanManifest$", {
  s_reflect_ManifestFactory$BooleanManifest$: 1,
  s_reflect_ManifestFactory$BooleanManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$BooleanManifest$;
var $n_s_reflect_ManifestFactory$BooleanManifest$;
function $m_s_reflect_ManifestFactory$BooleanManifest$() {
  if ((!$n_s_reflect_ManifestFactory$BooleanManifest$)) {
    $n_s_reflect_ManifestFactory$BooleanManifest$ = new $c_s_reflect_ManifestFactory$BooleanManifest$()
  };
  return $n_s_reflect_ManifestFactory$BooleanManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Byte";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ByteManifest$.prototype = new $h_s_reflect_ManifestFactory$ByteManifest();
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ByteManifest$.prototype = $c_s_reflect_ManifestFactory$ByteManifest$.prototype;
var $d_s_reflect_ManifestFactory$ByteManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ByteManifest$: 0
}, false, "scala.reflect.ManifestFactory$ByteManifest$", {
  s_reflect_ManifestFactory$ByteManifest$: 1,
  s_reflect_ManifestFactory$ByteManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ByteManifest$;
var $n_s_reflect_ManifestFactory$ByteManifest$;
function $m_s_reflect_ManifestFactory$ByteManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ByteManifest$)) {
    $n_s_reflect_ManifestFactory$ByteManifest$ = new $c_s_reflect_ManifestFactory$ByteManifest$()
  };
  return $n_s_reflect_ManifestFactory$ByteManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Char";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$CharManifest$.prototype = new $h_s_reflect_ManifestFactory$CharManifest();
$c_s_reflect_ManifestFactory$CharManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$CharManifest$.prototype = $c_s_reflect_ManifestFactory$CharManifest$.prototype;
var $d_s_reflect_ManifestFactory$CharManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$CharManifest$: 0
}, false, "scala.reflect.ManifestFactory$CharManifest$", {
  s_reflect_ManifestFactory$CharManifest$: 1,
  s_reflect_ManifestFactory$CharManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$CharManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$CharManifest$;
var $n_s_reflect_ManifestFactory$CharManifest$;
function $m_s_reflect_ManifestFactory$CharManifest$() {
  if ((!$n_s_reflect_ManifestFactory$CharManifest$)) {
    $n_s_reflect_ManifestFactory$CharManifest$ = new $c_s_reflect_ManifestFactory$CharManifest$()
  };
  return $n_s_reflect_ManifestFactory$CharManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Double";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype = new $h_s_reflect_ManifestFactory$DoubleManifest();
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$DoubleManifest$.prototype = $c_s_reflect_ManifestFactory$DoubleManifest$.prototype;
var $d_s_reflect_ManifestFactory$DoubleManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$DoubleManifest$: 0
}, false, "scala.reflect.ManifestFactory$DoubleManifest$", {
  s_reflect_ManifestFactory$DoubleManifest$: 1,
  s_reflect_ManifestFactory$DoubleManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$DoubleManifest$;
var $n_s_reflect_ManifestFactory$DoubleManifest$;
function $m_s_reflect_ManifestFactory$DoubleManifest$() {
  if ((!$n_s_reflect_ManifestFactory$DoubleManifest$)) {
    $n_s_reflect_ManifestFactory$DoubleManifest$ = new $c_s_reflect_ManifestFactory$DoubleManifest$()
  };
  return $n_s_reflect_ManifestFactory$DoubleManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Float";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$FloatManifest$.prototype = new $h_s_reflect_ManifestFactory$FloatManifest();
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$FloatManifest$.prototype = $c_s_reflect_ManifestFactory$FloatManifest$.prototype;
var $d_s_reflect_ManifestFactory$FloatManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$FloatManifest$: 0
}, false, "scala.reflect.ManifestFactory$FloatManifest$", {
  s_reflect_ManifestFactory$FloatManifest$: 1,
  s_reflect_ManifestFactory$FloatManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$FloatManifest$;
var $n_s_reflect_ManifestFactory$FloatManifest$;
function $m_s_reflect_ManifestFactory$FloatManifest$() {
  if ((!$n_s_reflect_ManifestFactory$FloatManifest$)) {
    $n_s_reflect_ManifestFactory$FloatManifest$ = new $c_s_reflect_ManifestFactory$FloatManifest$()
  };
  return $n_s_reflect_ManifestFactory$FloatManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Int";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$IntManifest$.prototype = new $h_s_reflect_ManifestFactory$IntManifest();
$c_s_reflect_ManifestFactory$IntManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$IntManifest$.prototype = $c_s_reflect_ManifestFactory$IntManifest$.prototype;
var $d_s_reflect_ManifestFactory$IntManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$IntManifest$: 0
}, false, "scala.reflect.ManifestFactory$IntManifest$", {
  s_reflect_ManifestFactory$IntManifest$: 1,
  s_reflect_ManifestFactory$IntManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$IntManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$IntManifest$;
var $n_s_reflect_ManifestFactory$IntManifest$;
function $m_s_reflect_ManifestFactory$IntManifest$() {
  if ((!$n_s_reflect_ManifestFactory$IntManifest$)) {
    $n_s_reflect_ManifestFactory$IntManifest$ = new $c_s_reflect_ManifestFactory$IntManifest$()
  };
  return $n_s_reflect_ManifestFactory$IntManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Long";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$LongManifest$.prototype = new $h_s_reflect_ManifestFactory$LongManifest();
$c_s_reflect_ManifestFactory$LongManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$LongManifest$.prototype = $c_s_reflect_ManifestFactory$LongManifest$.prototype;
var $d_s_reflect_ManifestFactory$LongManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$LongManifest$: 0
}, false, "scala.reflect.ManifestFactory$LongManifest$", {
  s_reflect_ManifestFactory$LongManifest$: 1,
  s_reflect_ManifestFactory$LongManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$LongManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$LongManifest$;
var $n_s_reflect_ManifestFactory$LongManifest$;
function $m_s_reflect_ManifestFactory$LongManifest$() {
  if ((!$n_s_reflect_ManifestFactory$LongManifest$)) {
    $n_s_reflect_ManifestFactory$LongManifest$ = new $c_s_reflect_ManifestFactory$LongManifest$()
  };
  return $n_s_reflect_ManifestFactory$LongManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NothingManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Nothing";
  $m_s_package$();
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$NothingManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NothingManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NothingManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$NothingManifest$.prototype = $c_s_reflect_ManifestFactory$NothingManifest$.prototype;
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Nothing$.getClassOf()
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$NothingManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$NothingManifest$: 0
}, false, "scala.reflect.ManifestFactory$NothingManifest$", {
  s_reflect_ManifestFactory$NothingManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$NothingManifest$;
var $n_s_reflect_ManifestFactory$NothingManifest$;
function $m_s_reflect_ManifestFactory$NothingManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NothingManifest$)) {
    $n_s_reflect_ManifestFactory$NothingManifest$ = new $c_s_reflect_ManifestFactory$NothingManifest$()
  };
  return $n_s_reflect_ManifestFactory$NothingManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NullManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Null";
  $m_s_package$();
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$NullManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NullManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NullManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NullManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$NullManifest$.prototype = $c_s_reflect_ManifestFactory$NullManifest$.prototype;
$c_s_reflect_ManifestFactory$NullManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Null$.getClassOf()
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$NullManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$NullManifest$: 0
}, false, "scala.reflect.ManifestFactory$NullManifest$", {
  s_reflect_ManifestFactory$NullManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$NullManifest$;
var $n_s_reflect_ManifestFactory$NullManifest$;
function $m_s_reflect_ManifestFactory$NullManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NullManifest$)) {
    $n_s_reflect_ManifestFactory$NullManifest$ = new $c_s_reflect_ManifestFactory$NullManifest$()
  };
  return $n_s_reflect_ManifestFactory$NullManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ObjectManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Object";
  $m_s_package$();
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ObjectManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ObjectManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ObjectManifest$.prototype = $c_s_reflect_ManifestFactory$ObjectManifest$.prototype;
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf()
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$ObjectManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ObjectManifest$: 0
}, false, "scala.reflect.ManifestFactory$ObjectManifest$", {
  s_reflect_ManifestFactory$ObjectManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ObjectManifest$;
var $n_s_reflect_ManifestFactory$ObjectManifest$;
function $m_s_reflect_ManifestFactory$ObjectManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ObjectManifest$)) {
    $n_s_reflect_ManifestFactory$ObjectManifest$ = new $c_s_reflect_ManifestFactory$ObjectManifest$()
  };
  return $n_s_reflect_ManifestFactory$ObjectManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Short";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ShortManifest$.prototype = new $h_s_reflect_ManifestFactory$ShortManifest();
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ShortManifest$.prototype = $c_s_reflect_ManifestFactory$ShortManifest$.prototype;
var $d_s_reflect_ManifestFactory$ShortManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ShortManifest$: 0
}, false, "scala.reflect.ManifestFactory$ShortManifest$", {
  s_reflect_ManifestFactory$ShortManifest$: 1,
  s_reflect_ManifestFactory$ShortManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ShortManifest$;
var $n_s_reflect_ManifestFactory$ShortManifest$;
function $m_s_reflect_ManifestFactory$ShortManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ShortManifest$)) {
    $n_s_reflect_ManifestFactory$ShortManifest$ = new $c_s_reflect_ManifestFactory$ShortManifest$()
  };
  return $n_s_reflect_ManifestFactory$ShortManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Unit";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$UnitManifest$.prototype = new $h_s_reflect_ManifestFactory$UnitManifest();
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$UnitManifest$.prototype = $c_s_reflect_ManifestFactory$UnitManifest$.prototype;
var $d_s_reflect_ManifestFactory$UnitManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$UnitManifest$: 0
}, false, "scala.reflect.ManifestFactory$UnitManifest$", {
  s_reflect_ManifestFactory$UnitManifest$: 1,
  s_reflect_ManifestFactory$UnitManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$UnitManifest$;
var $n_s_reflect_ManifestFactory$UnitManifest$;
function $m_s_reflect_ManifestFactory$UnitManifest$() {
  if ((!$n_s_reflect_ManifestFactory$UnitManifest$)) {
    $n_s_reflect_ManifestFactory$UnitManifest$ = new $c_s_reflect_ManifestFactory$UnitManifest$()
  };
  return $n_s_reflect_ManifestFactory$UnitManifest$
}
/** @constructor */
function $c_sr_RichDouble(self) {
  this.sr_RichDouble__f_self = 0.0;
  this.sr_RichDouble__f_self = self
}
$c_sr_RichDouble.prototype = new $h_O();
$c_sr_RichDouble.prototype.constructor = $c_sr_RichDouble;
/** @constructor */
function $h_sr_RichDouble() {
  /*<skip>*/
}
$h_sr_RichDouble.prototype = $c_sr_RichDouble.prototype;
$c_sr_RichDouble.prototype.compareTo__O__I = (function(that) {
  var x = this.sr_RichDouble__f_self;
  var y = $uD(that);
  return $m_jl_Double$().compare__D__D__I(x, y)
});
$c_sr_RichDouble.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this)
});
$c_sr_RichDouble.prototype.doubleValue__D = (function() {
  var this$ = this.sr_RichDouble__f_self;
  return this$
});
$c_sr_RichDouble.prototype.floatValue__F = (function() {
  var this$ = this.sr_RichDouble__f_self;
  return Math.fround(this$)
});
$c_sr_RichDouble.prototype.longValue__J = (function() {
  var this$ = this.sr_RichDouble__f_self;
  var this$2 = $m_RTLong$();
  var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(this$);
  var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_sr_RichDouble.prototype.intValue__I = (function() {
  var this$ = this.sr_RichDouble__f_self;
  return $doubleToInt(this$)
});
$c_sr_RichDouble.prototype.byteValue__B = (function() {
  var this$ = this.sr_RichDouble__f_self;
  return (($doubleToInt(this$) << 24) >> 24)
});
$c_sr_RichDouble.prototype.shortValue__S = (function() {
  var this$ = this.sr_RichDouble__f_self;
  return (($doubleToInt(this$) << 16) >> 16)
});
$c_sr_RichDouble.prototype.isValidByte__Z = (function() {
  return $m_sr_RichDouble$().isValidByte$extension__D__Z(this.sr_RichDouble__f_self)
});
$c_sr_RichDouble.prototype.isValidShort__Z = (function() {
  return $m_sr_RichDouble$().isValidShort$extension__D__Z(this.sr_RichDouble__f_self)
});
$c_sr_RichDouble.prototype.isValidChar__Z = (function() {
  return $m_sr_RichDouble$().isValidChar$extension__D__Z(this.sr_RichDouble__f_self)
});
$c_sr_RichDouble.prototype.isValidInt__Z = (function() {
  return $m_sr_RichDouble$().isValidInt$extension__D__Z(this.sr_RichDouble__f_self)
});
$c_sr_RichDouble.prototype.hashCode__I = (function() {
  var this$ = this.sr_RichDouble__f_self;
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(this$)
});
$c_sr_RichDouble.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichDouble$().equals$extension__D__O__Z(this.sr_RichDouble__f_self, x$1)
});
$c_sr_RichDouble.prototype.self__O = (function() {
  return this.sr_RichDouble__f_self
});
function $as_sr_RichDouble(obj) {
  return (((obj instanceof $c_sr_RichDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichDouble"))
}
function $isArrayOf_sr_RichDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichDouble)))
}
function $asArrayOf_sr_RichDouble(obj, depth) {
  return (($isArrayOf_sr_RichDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichDouble;", depth))
}
var $d_sr_RichDouble = new $TypeData().initClass({
  sr_RichDouble: 0
}, false, "scala.runtime.RichDouble", {
  sr_RichDouble: 1,
  O: 1,
  sr_FractionalProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_sr_RichDouble.prototype.$classData = $d_sr_RichDouble;
/** @constructor */
function $c_Lscalacss_internal_Attrs$border$() {
  this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep = null;
  this.Lscalacss_internal_Attrs$border$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour__(this);
  $n_Lscalacss_internal_Attrs$border$ = this;
  this.Lscalacss_internal_Attrs$border$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("border")).apply__O__O(new $c_sjsr_AnonFunction1(((x$12$2) => {
    var x$12 = $as_Lscalacss_internal_Attr$AliasB$(x$12$2);
    $n(x$12);
    var t = $m_Lscalacss_internal_Attrs$borderWidth$();
    var h = t.Lscalacss_internal_Attrs$borderWidth$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$borderStyle$();
    var $$x1 = t$1.Lscalacss_internal_Attrs$borderStyle$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$borderColor$();
    var array = [$$x1, t$2.Lscalacss_internal_Attrs$borderColor$__f_attr];
    var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$4 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$3);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$4)
  }))))
}
$c_Lscalacss_internal_Attrs$border$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour();
$c_Lscalacss_internal_Attrs$border$.prototype.constructor = $c_Lscalacss_internal_Attrs$border$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$border$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$border$.prototype = $c_Lscalacss_internal_Attrs$border$.prototype;
$c_Lscalacss_internal_Attrs$border$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$border$__f_attr
});
var $d_Lscalacss_internal_Attrs$border$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$border$: 0
}, false, "scalacss.internal.Attrs$border$", {
  Lscalacss_internal_Attrs$border$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour: 1,
  Lscalacss_internal_ValueT$TypedAttrT3: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$border$.prototype.$classData = $d_Lscalacss_internal_Attrs$border$;
var $n_Lscalacss_internal_Attrs$border$;
function $m_Lscalacss_internal_Attrs$border$() {
  if ((!$n_Lscalacss_internal_Attrs$border$)) {
    $n_Lscalacss_internal_Attrs$border$ = new $c_Lscalacss_internal_Attrs$border$()
  };
  return $n_Lscalacss_internal_Attrs$border$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderBottom$() {
  this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep = null;
  this.Lscalacss_internal_Attrs$borderBottom$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour__(this);
  $n_Lscalacss_internal_Attrs$borderBottom$ = this;
  this.Lscalacss_internal_Attrs$borderBottom$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("border-bottom")).apply__O__O(new $c_sjsr_AnonFunction1(((x$21$2) => {
    var x$21 = $as_Lscalacss_internal_Attr$AliasB$(x$21$2);
    $n(x$21);
    var t = $m_Lscalacss_internal_Attrs$borderBottomColor$();
    var h = t.Lscalacss_internal_Attrs$borderBottomColor$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$borderBottomStyle$();
    var $$x1 = t$1.Lscalacss_internal_Attrs$borderBottomStyle$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$borderBottomWidth$();
    var array = [$$x1, t$2.Lscalacss_internal_Attrs$borderBottomWidth$__f_attr];
    var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$4 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$3);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$4)
  }))))
}
$c_Lscalacss_internal_Attrs$borderBottom$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour();
$c_Lscalacss_internal_Attrs$borderBottom$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderBottom$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderBottom$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderBottom$.prototype = $c_Lscalacss_internal_Attrs$borderBottom$.prototype;
$c_Lscalacss_internal_Attrs$borderBottom$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderBottom$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderBottom$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderBottom$: 0
}, false, "scalacss.internal.Attrs$borderBottom$", {
  Lscalacss_internal_Attrs$borderBottom$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour: 1,
  Lscalacss_internal_ValueT$TypedAttrT3: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$borderBottom$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderBottom$;
var $n_Lscalacss_internal_Attrs$borderBottom$;
function $m_Lscalacss_internal_Attrs$borderBottom$() {
  if ((!$n_Lscalacss_internal_Attrs$borderBottom$)) {
    $n_Lscalacss_internal_Attrs$borderBottom$ = new $c_Lscalacss_internal_Attrs$borderBottom$()
  };
  return $n_Lscalacss_internal_Attrs$borderBottom$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderLeft$() {
  this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep = null;
  this.Lscalacss_internal_Attrs$borderLeft$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour__(this);
  $n_Lscalacss_internal_Attrs$borderLeft$ = this;
  this.Lscalacss_internal_Attrs$borderLeft$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("border-left")).apply__O__O(new $c_sjsr_AnonFunction1(((x$32$2) => {
    var x$32 = $as_Lscalacss_internal_Attr$AliasB$(x$32$2);
    $n(x$32);
    var t = $m_Lscalacss_internal_Attrs$borderLeftColor$();
    var h = t.Lscalacss_internal_Attrs$borderLeftColor$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$borderLeftStyle$();
    var $$x1 = t$1.Lscalacss_internal_Attrs$borderLeftStyle$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$borderLeftWidth$();
    var array = [$$x1, t$2.Lscalacss_internal_Attrs$borderLeftWidth$__f_attr];
    var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$4 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$3);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$4)
  }))))
}
$c_Lscalacss_internal_Attrs$borderLeft$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour();
$c_Lscalacss_internal_Attrs$borderLeft$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderLeft$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderLeft$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderLeft$.prototype = $c_Lscalacss_internal_Attrs$borderLeft$.prototype;
$c_Lscalacss_internal_Attrs$borderLeft$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderLeft$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderLeft$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderLeft$: 0
}, false, "scalacss.internal.Attrs$borderLeft$", {
  Lscalacss_internal_Attrs$borderLeft$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour: 1,
  Lscalacss_internal_ValueT$TypedAttrT3: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$borderLeft$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderLeft$;
var $n_Lscalacss_internal_Attrs$borderLeft$;
function $m_Lscalacss_internal_Attrs$borderLeft$() {
  if ((!$n_Lscalacss_internal_Attrs$borderLeft$)) {
    $n_Lscalacss_internal_Attrs$borderLeft$ = new $c_Lscalacss_internal_Attrs$borderLeft$()
  };
  return $n_Lscalacss_internal_Attrs$borderLeft$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderRight$() {
  this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep = null;
  this.Lscalacss_internal_Attrs$borderRight$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour__(this);
  $n_Lscalacss_internal_Attrs$borderRight$ = this;
  this.Lscalacss_internal_Attrs$borderRight$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("border-right")).apply__O__O(new $c_sjsr_AnonFunction1(((x$34$2) => {
    var x$34 = $as_Lscalacss_internal_Attr$AliasB$(x$34$2);
    $n(x$34);
    var t = $m_Lscalacss_internal_Attrs$borderRightColor$();
    var h = t.Lscalacss_internal_Attrs$borderRightColor$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$borderRightStyle$();
    var $$x1 = t$1.Lscalacss_internal_Attrs$borderRightStyle$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$borderRightWidth$();
    var array = [$$x1, t$2.Lscalacss_internal_Attrs$borderRightWidth$__f_attr];
    var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$4 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$3);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$4)
  }))))
}
$c_Lscalacss_internal_Attrs$borderRight$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour();
$c_Lscalacss_internal_Attrs$borderRight$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderRight$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderRight$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderRight$.prototype = $c_Lscalacss_internal_Attrs$borderRight$.prototype;
$c_Lscalacss_internal_Attrs$borderRight$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderRight$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderRight$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderRight$: 0
}, false, "scalacss.internal.Attrs$borderRight$", {
  Lscalacss_internal_Attrs$borderRight$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour: 1,
  Lscalacss_internal_ValueT$TypedAttrT3: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$borderRight$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderRight$;
var $n_Lscalacss_internal_Attrs$borderRight$;
function $m_Lscalacss_internal_Attrs$borderRight$() {
  if ((!$n_Lscalacss_internal_Attrs$borderRight$)) {
    $n_Lscalacss_internal_Attrs$borderRight$ = new $c_Lscalacss_internal_Attrs$borderRight$()
  };
  return $n_Lscalacss_internal_Attrs$borderRight$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$borderTop$() {
  this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep = null;
  this.Lscalacss_internal_Attrs$borderTop$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour__(this);
  $n_Lscalacss_internal_Attrs$borderTop$ = this;
  this.Lscalacss_internal_Attrs$borderTop$__f_attr = $as_Lscalacss_internal_Attr($n($m_Lscalacss_internal_Attr$().alias__T__F1("border-top")).apply__O__O(new $c_sjsr_AnonFunction1(((x$36$2) => {
    var x$36 = $as_Lscalacss_internal_Attr$AliasB$(x$36$2);
    $n(x$36);
    var t = $m_Lscalacss_internal_Attrs$borderTopColor$();
    var h = t.Lscalacss_internal_Attrs$borderTopColor$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$borderTopStyle$();
    var $$x1 = t$1.Lscalacss_internal_Attrs$borderTopStyle$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$borderTopWidth$();
    var array = [$$x1, t$2.Lscalacss_internal_Attrs$borderTopWidth$__f_attr];
    var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$4 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$3);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$4)
  }))))
}
$c_Lscalacss_internal_Attrs$borderTop$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour();
$c_Lscalacss_internal_Attrs$borderTop$.prototype.constructor = $c_Lscalacss_internal_Attrs$borderTop$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$borderTop$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$borderTop$.prototype = $c_Lscalacss_internal_Attrs$borderTop$.prototype;
$c_Lscalacss_internal_Attrs$borderTop$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$borderTop$__f_attr
});
var $d_Lscalacss_internal_Attrs$borderTop$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$borderTop$: 0
}, false, "scalacss.internal.Attrs$borderTop$", {
  Lscalacss_internal_Attrs$borderTop$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour: 1,
  Lscalacss_internal_ValueT$TypedAttrT3: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$borderTop$.prototype.$classData = $d_Lscalacss_internal_Attrs$borderTop$;
var $n_Lscalacss_internal_Attrs$borderTop$;
function $m_Lscalacss_internal_Attrs$borderTop$() {
  if ((!$n_Lscalacss_internal_Attrs$borderTop$)) {
    $n_Lscalacss_internal_Attrs$borderTop$ = new $c_Lscalacss_internal_Attrs$borderTop$()
  };
  return $n_Lscalacss_internal_Attrs$borderTop$
}
/** @constructor */
function $c_Lscalacss_internal_Attrs$outline$() {
  this.Lscalacss_internal_ValueT$TypedAttrT3__f_sep = null;
  this.Lscalacss_internal_Attrs$outline$__f_attr = null;
  $ct_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour__(this);
  $n_Lscalacss_internal_Attrs$outline$ = this;
  var $$x1 = $m_Lscalacss_internal_Attr$();
  var this$1 = $m_Lscalacss_internal_Transform$();
  var subject = $m_Lscalacss_internal_CanIUse$().Lscalacss_internal_CanIUse$__f_outline;
  this.Lscalacss_internal_Attrs$outline$__f_attr = $as_Lscalacss_internal_Attr($n($n($$x1).alias__T__Lscalacss_internal_Transform__F1("outline", $p_Lscalacss_internal_Transform$__prefix__sci_Map__F1__Lscalacss_internal_CssKV$Lens__Lscalacss_internal_Transform(this$1, subject, $m_Lscalacss_internal_CanIUse2$PrefixApply$().Lscalacss_internal_CanIUse2$PrefixApply$__f_prepend, $m_Lscalacss_internal_CssKV$().Lscalacss_internal_CssKV$__f_key))).apply__O__O(new $c_sjsr_AnonFunction1(((x$70$2) => {
    var x$70 = $as_Lscalacss_internal_Attr$AliasB$(x$70$2);
    $n(x$70);
    var t = $m_Lscalacss_internal_Attrs$outlineStyle$();
    var h = t.Lscalacss_internal_Attrs$outlineStyle$__f_attr;
    var t$1 = $m_Lscalacss_internal_Attrs$outlineWidth$();
    var $$x2 = t$1.Lscalacss_internal_Attrs$outlineWidth$__f_attr;
    var t$2 = $m_Lscalacss_internal_Attrs$outlineColor$();
    var array = [$$x2, t$2.Lscalacss_internal_Attrs$outlineColor$__f_attr];
    var t$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var t$4 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(t$3);
    return new $c_Lscalacss_internal_NonEmptyVector(h, t$4)
  }))))
}
$c_Lscalacss_internal_Attrs$outline$.prototype = new $h_Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour();
$c_Lscalacss_internal_Attrs$outline$.prototype.constructor = $c_Lscalacss_internal_Attrs$outline$;
/** @constructor */
function $h_Lscalacss_internal_Attrs$outline$() {
  /*<skip>*/
}
$h_Lscalacss_internal_Attrs$outline$.prototype = $c_Lscalacss_internal_Attrs$outline$.prototype;
$c_Lscalacss_internal_Attrs$outline$.prototype.attr__Lscalacss_internal_Attr = (function() {
  return this.Lscalacss_internal_Attrs$outline$__f_attr
});
var $d_Lscalacss_internal_Attrs$outline$ = new $TypeData().initClass({
  Lscalacss_internal_Attrs$outline$: 0
}, false, "scalacss.internal.Attrs$outline$", {
  Lscalacss_internal_Attrs$outline$: 1,
  Lscalacss_internal_ValueT$TypedAttr\uff3fBrWidthStyleColour: 1,
  Lscalacss_internal_ValueT$TypedAttrT3: 1,
  Lscalacss_internal_ValueT$TypedAttrBase: 1,
  O: 1,
  Lscalacss_internal_ValueT$BrWidthOps: 1,
  Lscalacss_internal_ValueT$ZeroLit: 1,
  Lscalacss_internal_ValueT$BrStyleOps: 1,
  Lscalacss_internal_ValueT$ColourOps: 1,
  Lscalacss_internal_ColorOps: 1
});
$c_Lscalacss_internal_Attrs$outline$.prototype.$classData = $d_Lscalacss_internal_Attrs$outline$;
var $n_Lscalacss_internal_Attrs$outline$;
function $m_Lscalacss_internal_Attrs$outline$() {
  if ((!$n_Lscalacss_internal_Attrs$outline$)) {
    $n_Lscalacss_internal_Attrs$outline$ = new $c_Lscalacss_internal_Attrs$outline$()
  };
  return $n_Lscalacss_internal_Attrs$outline$
}
/** @constructor */
function $c_Lcats_data_AndThenInstances0$$anon$3(outer) {
  $m_Lcats_instances_package$all$()
}
$c_Lcats_data_AndThenInstances0$$anon$3.prototype = new $h_O();
$c_Lcats_data_AndThenInstances0$$anon$3.prototype.constructor = $c_Lcats_data_AndThenInstances0$$anon$3;
/** @constructor */
function $h_Lcats_data_AndThenInstances0$$anon$3() {
  /*<skip>*/
}
$h_Lcats_data_AndThenInstances0$$anon$3.prototype = $c_Lcats_data_AndThenInstances0$$anon$3.prototype;
$c_Lcats_data_AndThenInstances0$$anon$3.prototype.compose__O__O__O = (function(f, g) {
  var f$1 = $as_Lcats_data_AndThen(f);
  var g$1 = $as_Lcats_data_AndThen(g);
  return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(g$1, f$1)
});
$c_Lcats_data_AndThenInstances0$$anon$3.prototype.lift__F1__O = (function(f) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen(f)
});
var $d_Lcats_data_AndThenInstances0$$anon$3 = new $TypeData().initClass({
  Lcats_data_AndThenInstances0$$anon$3: 0
}, false, "cats.data.AndThenInstances0$$anon$3", {
  Lcats_data_AndThenInstances0$$anon$3: 1,
  O: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Compose: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_CommutativeArrow: 1
});
$c_Lcats_data_AndThenInstances0$$anon$3.prototype.$classData = $d_Lcats_data_AndThenInstances0$$anon$3;
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$8(outer) {
  /*<skip>*/
}
$c_Lcats_instances_Function1Instances$$anon$8.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$8.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$8;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$8() {
  /*<skip>*/
}
$h_Lcats_instances_Function1Instances$$anon$8.prototype = $c_Lcats_instances_Function1Instances$$anon$8.prototype;
$c_Lcats_instances_Function1Instances$$anon$8.prototype.compose__O__O__O = (function(f, g) {
  var f$1 = $as_F1(f);
  var g$1 = $as_F1(g);
  return $n(f$1).compose__F1__F1(g$1)
});
$c_Lcats_instances_Function1Instances$$anon$8.prototype.lift__F1__O = (function(f) {
  return f
});
var $d_Lcats_instances_Function1Instances$$anon$8 = new $TypeData().initClass({
  Lcats_instances_Function1Instances$$anon$8: 0
}, false, "cats.instances.Function1Instances$$anon$8", {
  Lcats_instances_Function1Instances$$anon$8: 1,
  O: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Compose: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_CommutativeArrow: 1
});
$c_Lcats_instances_Function1Instances$$anon$8.prototype.$classData = $d_Lcats_instances_Function1Instances$$anon$8;
/** @constructor */
function $c_Lcats_kernel_instances_DoubleOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DoubleOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleOrder.prototype.constructor = $c_Lcats_kernel_instances_DoubleOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DoubleOrder.prototype = $c_Lcats_kernel_instances_DoubleOrder.prototype;
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv$mcD$sp__D__D__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.neqv$mcD$sp__D__D__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_Lcats_kernel_Order$mcD$sp__partialCompare$mcD$sp__D__D__D(this, x$1, y$1)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.neqv__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return this.neqv$mcD$sp__D__D__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return this.eqv$mcD$sp__D__D__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
var $d_Lcats_kernel_instances_DoubleOrder = new $TypeData().initClass({
  Lcats_kernel_instances_DoubleOrder: 0
}, false, "cats.kernel.instances.DoubleOrder", {
  Lcats_kernel_instances_DoubleOrder: 1,
  O: 1,
  Lcats_kernel_Order$mcD$sp: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_PartialOrder$mcD$sp: 1,
  Lcats_kernel_Eq$mcD$sp: 1,
  Lcats_kernel_Hash$mcD$sp: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.$classData = $d_Lcats_kernel_instances_DoubleOrder;
/** @constructor */
function $c_Lcats_kernel_instances_FloatOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FloatOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatOrder.prototype.constructor = $c_Lcats_kernel_instances_FloatOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FloatOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FloatOrder.prototype = $c_Lcats_kernel_instances_FloatOrder.prototype;
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv$mcF$sp__F__F__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.neqv$mcF$sp__F__F__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return $f_Lcats_kernel_Order$mcF$sp__partialCompare$mcF$sp__F__F__D(this, x$1, y$1)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.neqv__O__O__Z = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return this.neqv$mcF$sp__F__F__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return this.eqv$mcF$sp__F__F__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
var $d_Lcats_kernel_instances_FloatOrder = new $TypeData().initClass({
  Lcats_kernel_instances_FloatOrder: 0
}, false, "cats.kernel.instances.FloatOrder", {
  Lcats_kernel_instances_FloatOrder: 1,
  O: 1,
  Lcats_kernel_Order$mcF$sp: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_PartialOrder$mcF$sp: 1,
  Lcats_kernel_Eq$mcF$sp: 1,
  Lcats_kernel_Hash$mcF$sp: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_FloatOrder.prototype.$classData = $d_Lcats_kernel_instances_FloatOrder;
/** @constructor */
function $c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1(codec$1, gen$1) {
  this.Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1__f_codec$1 = null;
  this.Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1__f_gen$1 = null;
  this.Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1__f_codec$1 = codec$1;
  this.Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1__f_gen$1 = gen$1
}
$c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1.prototype = new $h_Lio_circe_generic_codec_DerivedAsObjectCodec();
$c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1.prototype.constructor = $c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1;
/** @constructor */
function $h_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1.prototype = $c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1.prototype;
$c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x1 = $n($as_Lio_circe_Decoder($n(this.Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1__f_codec$1).value__O())).apply__Lio_circe_HCursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(x1);
    var r = $n(x2).s_util_Right__f_value;
    $n($m_s_package$().s_package$__f_Right);
    var value = $n(this.Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1__f_gen$1).from__O__O(r);
    return new $c_s_util_Right(value)
  } else if ((x1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(x1);
    return x3
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $n($as_Lio_circe_Encoder$AsObject($n(this.Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1__f_codec$1).value__O())).encodeObject__O__Lio_circe_JsonObject($n(this.Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1__f_gen$1).to__O__O(a))
});
var $d_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1 = new $TypeData().initClass({
  Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1: 0
}, false, "io.circe.generic.codec.DerivedAsObjectCodec$$anon$1", {
  Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1: 1,
  Lio_circe_generic_codec_DerivedAsObjectCodec: 1,
  O: 1,
  Lio_circe_Codec$AsObject: 1,
  Lio_circe_Codec$AsRoot: 1,
  Lio_circe_Codec: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
});
$c_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1.prototype.$classData = $d_Lio_circe_generic_codec_DerivedAsObjectCodec$$anon$1;
/** @constructor */
function $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec() {
  /*<skip>*/
}
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec.prototype = new $h_Lio_circe_generic_codec_DerivedAsObjectCodec();
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec.prototype.constructor = $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec;
/** @constructor */
function $h_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec.prototype = $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec.prototype;
function $is_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_component_Generic$MountedWithRoot)))
}
function $as_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(obj) {
  return (($is_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.Generic$MountedWithRoot"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_Generic$MountedWithRoot)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.Generic$MountedWithRoot;", depth))
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(raw, prevProps, prevState, snapshot, evidence$5, evidence$6) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevProps = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevState = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_snapshot = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_evidence$5 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_evidence$6 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevProps = prevProps;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevState = prevState;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_snapshot = snapshot;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_evidence$5 = evidence$5;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_evidence$6 = evidence$6;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$5, evidence$6)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate = (function(G) {
  return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevProps, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevState, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_snapshot, G, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_evidence$6)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((((((((("ComponentDidUpdate(props: " + this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevProps) + " \u2192 ") + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()) + ", state: ") + this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate__f_prevState) + " \u2192 ") + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).state__O()) + ")"))
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
function $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentDidUpdate"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.LifecycleF$ComponentDidUpdate;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentDidUpdate", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ForceUpdate: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidUpdate;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(raw, evidence$7, evidence$8) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount__f_evidence$7 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount__f_evidence$8 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount__f_evidence$7 = evidence$7;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount__f_evidence$8 = evidence$8;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$7, evidence$8)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount = (function(G) {
  return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw, G, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount__f_evidence$8)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((((("ComponentWillMount(props: " + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()) + ", state: ") + $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this)) + ")"))
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
function $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentWillMount"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.LifecycleF$ComponentWillMount;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentWillMount", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillMount;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P9__O__O__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9 = hook9;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P8__O__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P9() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P9.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P8();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P9.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P9;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P9() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P9.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P9.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P9.prototype.toString__T = (function() {
  return (((((((((((((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6) + ",\n  hook7 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7) + ",\n  hook8 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8) + ",\n  hook9 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P9(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P9) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P9"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P9(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P9)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P9(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P9(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P9;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P9 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P9: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P9", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P9: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P8: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P7: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P9.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P9;
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_PackageBase$() {
  this.Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_TagMod = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomStyle = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtDouble = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInnerHtml = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0 = 0;
  $ct_Ljapgolly_scalajs_react_vdom_PackageBase__(this)
}
$c_Ljapgolly_scalajs_react_vdom_PackageBase$.prototype = new $h_Ljapgolly_scalajs_react_vdom_PackageBase();
$c_Ljapgolly_scalajs_react_vdom_PackageBase$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_PackageBase$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_PackageBase$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_PackageBase$.prototype = $c_Ljapgolly_scalajs_react_vdom_PackageBase$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_PackageBase$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_PackageBase$: 0
}, false, "japgolly.scalajs.react.vdom.PackageBase$", {
  Ljapgolly_scalajs_react_vdom_PackageBase$: 1,
  Ljapgolly_scalajs_react_vdom_PackageBase: 1,
  Ljapgolly_scalajs_react_vdom_Exports: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_Implicits: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1: 1,
  Ljapgolly_scalajs_react_vdom_CssUnitsOps: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode: 1,
  Ljapgolly_scalajs_react_vdom_VdomNodeScalaSpecificImplicits: 1
});
$c_Ljapgolly_scalajs_react_vdom_PackageBase$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_PackageBase$;
var $n_Ljapgolly_scalajs_react_vdom_PackageBase$;
function $m_Ljapgolly_scalajs_react_vdom_PackageBase$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_PackageBase$)) {
    $n_Ljapgolly_scalajs_react_vdom_PackageBase$ = new $c_Ljapgolly_scalajs_react_vdom_PackageBase$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_PackageBase$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$() {
  this.Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_TagMod = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomStyle = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtDouble = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInnerHtml = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0 = 0;
  this.Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less = null;
  this.Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up = null;
  $ct_Ljapgolly_scalajs_react_vdom_PackageBase__(this);
  $n_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$ = this;
  this.Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$less = $m_Ljapgolly_scalajs_react_vdom_HtmlTags$();
  this.Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$__f_$up = $m_Ljapgolly_scalajs_react_vdom_HtmlAttrAndStyles$()
}
$c_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$.prototype = new $h_Ljapgolly_scalajs_react_vdom_PackageBase();
$c_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$.prototype = $c_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$: 0
}, false, "japgolly.scalajs.react.vdom.html_$less$up$", {
  Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$: 1,
  Ljapgolly_scalajs_react_vdom_PackageBase: 1,
  Ljapgolly_scalajs_react_vdom_Exports: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_Implicits: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1: 1,
  Ljapgolly_scalajs_react_vdom_CssUnitsOps: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode: 1,
  Ljapgolly_scalajs_react_vdom_VdomNodeScalaSpecificImplicits: 1
});
$c_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$;
var $n_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$;
function $m_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$)) {
    $n_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$ = new $c_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_html\uff3f$less$up$
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$() {
  this.Ljapgolly_scalajs_react_vdom_Exports__f_EmptyVdom = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_HtmlTagOf = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_TagMod = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomAttr = null;
  this.Ljapgolly_scalajs_react_vdom_Exports__f_VdomStyle = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtBoolean = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtString = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInt = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtDouble = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtInnerHtml = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_vdomAttrVtKeyS = null;
  this.Ljapgolly_scalajs_react_vdom_PackageBase__f_bitmap$0 = 0;
  this.Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$less = null;
  this.Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$up = null;
  $ct_Ljapgolly_scalajs_react_vdom_PackageBase__(this);
  $n_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$ = this;
  this.Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$less = $m_Ljapgolly_scalajs_react_vdom_SvgTags$();
  this.Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$__f_$up = $m_Ljapgolly_scalajs_react_vdom_SvgAttrAndStyles$()
}
$c_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$.prototype = new $h_Ljapgolly_scalajs_react_vdom_PackageBase();
$c_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$.prototype.constructor = $c_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$;
/** @constructor */
function $h_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$.prototype = $c_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$.prototype;
var $d_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$ = new $TypeData().initClass({
  Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$: 0
}, false, "japgolly.scalajs.react.vdom.svg_$less$up$", {
  Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$: 1,
  Ljapgolly_scalajs_react_vdom_PackageBase: 1,
  Ljapgolly_scalajs_react_vdom_Exports: 1,
  O: 1,
  Ljapgolly_scalajs_react_vdom_Implicits: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForTagMod: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomAttr1: 1,
  Ljapgolly_scalajs_react_vdom_CssUnitsOps: 1,
  Ljapgolly_scalajs_react_vdom_ImplicitsForVdomNode: 1,
  Ljapgolly_scalajs_react_vdom_VdomNodeScalaSpecificImplicits: 1
});
$c_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$.prototype.$classData = $d_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$;
var $n_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$;
function $m_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$() {
  if ((!$n_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$)) {
    $n_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$ = new $c_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$()
  };
  return $n_Ljapgolly_scalajs_react_vdom_svg\uff3f$less$up$
}
/** @constructor */
function $c_ju_Collections$ImmutableList(inner) {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false;
  this.ju_Collections$ImmutableList__f_eagerThrow = false;
  $ct_ju_Collections$UnmodifiableList__ju_List__(this, inner);
  this.ju_Collections$ImmutableList__f_eagerThrow = false
}
$c_ju_Collections$ImmutableList.prototype = new $h_ju_Collections$UnmodifiableList();
$c_ju_Collections$ImmutableList.prototype.constructor = $c_ju_Collections$ImmutableList;
/** @constructor */
function $h_ju_Collections$ImmutableList() {
  /*<skip>*/
}
$h_ju_Collections$ImmutableList.prototype = $c_ju_Collections$ImmutableList.prototype;
$c_ju_Collections$ImmutableList.prototype.eagerThrow__Z = (function() {
  return this.ju_Collections$ImmutableList__f_eagerThrow
});
var $d_ju_Collections$ImmutableList = new $TypeData().initClass({
  ju_Collections$ImmutableList: 0
}, false, "java.util.Collections$ImmutableList", {
  ju_Collections$ImmutableList: 1,
  ju_Collections$UnmodifiableList: 1,
  ju_Collections$UnmodifiableCollection: 1,
  O: 1,
  ju_Collections$WrappedCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  Ljava_io_Serializable: 1,
  ju_Collections$WrappedList: 1,
  ju_Collections$WrappedEquals: 1,
  ju_List: 1
});
$c_ju_Collections$ImmutableList.prototype.$classData = $d_ju_Collections$ImmutableList;
var $d_Lorg_scalajs_dom_HTMLDivElement = new $TypeData().initClass({
  Lorg_scalajs_dom_HTMLDivElement: 0
}, false, "org.scalajs.dom.HTMLDivElement", {
  Lorg_scalajs_dom_HTMLDivElement: 1,
  Lorg_scalajs_dom_HTMLElement: 1,
  Lorg_scalajs_dom_Element: 1,
  Lorg_scalajs_dom_Node: 1,
  Lorg_scalajs_dom_EventTarget: 1,
  sjs_js_Object: 1,
  O: 1,
  sjs_js_Any: 1,
  Lorg_scalajs_dom_NodeSelector: 1,
  Lorg_scalajs_dom_ParentNode: 1,
  Lorg_scalajs_dom_NonDocumentTypeChildNode: 1
}, true, (void 0), ((x) => (x instanceof HTMLDivElement)));
/** @constructor */
function $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1(outer) {
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderForgamma = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderForgamma = null;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderForgamma = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeDouble;
  this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderForgamma = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeDouble
}
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1.prototype = new $h_Lio_circe_generic_codec_ReprAsObjectCodec();
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1.prototype.constructor = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1.prototype = $c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1.prototype;
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1.prototype.encodeObject__Lshapeless_$colon$colon__Lio_circe_JsonObject = (function(a) {
  if ((a !== null)) {
    var circeGenericHListBindingForpitch = $uD($n(a).Lshapeless_$colon$colon__f_head);
    var p2 = $as_Lshapeless_$colon$colon($n(a).Lshapeless_$colon$colon__f_tail);
    if ((p2 !== null)) {
      var circeGenericHListBindingForroll = $uD($n(p2).Lshapeless_$colon$colon__f_head);
      var p3 = $as_Lshapeless_$colon$colon($n(p2).Lshapeless_$colon$colon__f_tail);
      if ((p3 !== null)) {
        var circeGenericHListBindingForyaw = $uD($n(p3).Lshapeless_$colon$colon__f_head);
        var p4 = $as_Lshapeless_$colon$colon($n(p3).Lshapeless_$colon$colon__f_tail);
        if ((p4 !== null)) {
          var circeGenericHListBindingForalpha = $uD($n(p4).Lshapeless_$colon$colon__f_head);
          var p5 = $as_Lshapeless_$colon$colon($n(p4).Lshapeless_$colon$colon__f_tail);
          if ((p5 !== null)) {
            var circeGenericHListBindingForbeta = $uD($n(p5).Lshapeless_$colon$colon__f_head);
            var p6 = $as_Lshapeless_$colon$colon($n(p5).Lshapeless_$colon$colon__f_tail);
            if ((p6 !== null)) {
              var circeGenericHListBindingForgamma = $uD($n(p6).Lshapeless_$colon$colon__f_head);
              var p7 = $as_Lshapeless_HNil($n(p6).Lshapeless_$colon$colon__f_tail);
              var x = $m_Lshapeless_HNil$();
              if ((x === p7)) {
                var $$x1 = $m_Lio_circe_JsonObject$();
                var this$4 = $m_sci_Vector$();
                var array = [$ct_T2__O__O__(new $c_T2(), "pitch", $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderForgamma).apply__O__Lio_circe_Json(circeGenericHListBindingForpitch)), $ct_T2__O__O__(new $c_T2(), "roll", $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderForgamma).apply__O__Lio_circe_Json(circeGenericHListBindingForroll)), $ct_T2__O__O__(new $c_T2(), "yaw", $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderForgamma).apply__O__Lio_circe_Json(circeGenericHListBindingForyaw)), $ct_T2__O__O__(new $c_T2(), "alpha", $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderForgamma).apply__O__Lio_circe_Json(circeGenericHListBindingForalpha)), $ct_T2__O__O__(new $c_T2(), "beta", $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderForgamma).apply__O__Lio_circe_Json(circeGenericHListBindingForbeta)), $ct_T2__O__O__(new $c_T2(), "gamma", $n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericEncoderForgamma).apply__O__Lio_circe_Json(circeGenericHListBindingForgamma))];
                var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
                return $n($$x1).fromIterable__sc_Iterable__Lio_circe_JsonObject(this$4.from__sc_IterableOnce__sci_Vector(elems))
              }
            }
          }
        }
      }
    }
  };
  throw new $c_s_MatchError(a)
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderForgamma).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("pitch")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderForgamma).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("roll")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderForgamma).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("yaw")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderForgamma).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("alpha")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderForgamma).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("beta")), $m_Lio_circe_generic_decoding_ReprDecoder$().consResults__O__O__Lcats_Apply__O($n(this.Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1__f_circeGenericDecoderForgamma).tryDecode__Lio_circe_ACursor__s_util_Either($n(c).downField__T__Lio_circe_ACursor("gamma")), $m_Lio_circe_generic_decoding_ReprDecoder$().Lio_circe_generic_decoding_ReprDecoder$__f_hnilResult, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_resultInstance))
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lshapeless_$colon$colon__Lio_circe_JsonObject($as_Lshapeless_$colon$colon(a))
});
var $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1: 0
}, false, "reactbuild.analyze.cost.modules.mapview.interactions.takepicture.DeviceOrientationData$anon$lazy$macro$27$1$$anon$1", {
  Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1: 1,
  Lio_circe_generic_codec_ReprAsObjectCodec: 1,
  O: 1,
  Lio_circe_Codec$AsObject: 1,
  Lio_circe_Codec$AsRoot: 1,
  Lio_circe_Codec: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
});
$c_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1.prototype.$classData = $d_Lreactbuild_analyze_cost_modules_mapview_interactions_takepicture_DeviceOrientationData$anon$lazy$macro$27$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_common_components_Input$End$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$End$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$End$.prototype.constructor = $c_Lreactbuild_common_components_Input$End$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$End$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$End$.prototype = $c_Lreactbuild_common_components_Input$End$.prototype;
$c_Lreactbuild_common_components_Input$End$.prototype.productPrefix__T = (function() {
  return "End"
});
$c_Lreactbuild_common_components_Input$End$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$End$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$End$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$End$.prototype.hashCode__I = (function() {
  return 69819
});
$c_Lreactbuild_common_components_Input$End$.prototype.toString__T = (function() {
  return "End"
});
var $d_Lreactbuild_common_components_Input$End$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$End$: 0
}, false, "reactbuild.common.components.Input$End$", {
  Lreactbuild_common_components_Input$End$: 1,
  O: 1,
  Lreactbuild_common_components_Input$Way: 1,
  Lreactbuild_common_components_Input$MouseWay: 1,
  Lreactbuild_common_components_Input$TouchWay: 1,
  Lreactbuild_common_components_Input$KeyboardWay: 1,
  Lreactbuild_common_components_Input$CursorWay: 1,
  Lreactbuild_common_components_Input$PointerWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$End$.prototype.$classData = $d_Lreactbuild_common_components_Input$End$;
var $n_Lreactbuild_common_components_Input$End$;
function $m_Lreactbuild_common_components_Input$End$() {
  if ((!$n_Lreactbuild_common_components_Input$End$)) {
    $n_Lreactbuild_common_components_Input$End$ = new $c_Lreactbuild_common_components_Input$End$()
  };
  return $n_Lreactbuild_common_components_Input$End$
}
/** @constructor */
function $c_Lreactbuild_common_components_Input$Start$() {
  /*<skip>*/
}
$c_Lreactbuild_common_components_Input$Start$.prototype = new $h_O();
$c_Lreactbuild_common_components_Input$Start$.prototype.constructor = $c_Lreactbuild_common_components_Input$Start$;
/** @constructor */
function $h_Lreactbuild_common_components_Input$Start$() {
  /*<skip>*/
}
$h_Lreactbuild_common_components_Input$Start$.prototype = $c_Lreactbuild_common_components_Input$Start$.prototype;
$c_Lreactbuild_common_components_Input$Start$.prototype.productPrefix__T = (function() {
  return "Start"
});
$c_Lreactbuild_common_components_Input$Start$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_common_components_Input$Start$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_common_components_Input$Start$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_common_components_Input$Start$.prototype.hashCode__I = (function() {
  return 80204866
});
$c_Lreactbuild_common_components_Input$Start$.prototype.toString__T = (function() {
  return "Start"
});
var $d_Lreactbuild_common_components_Input$Start$ = new $TypeData().initClass({
  Lreactbuild_common_components_Input$Start$: 0
}, false, "reactbuild.common.components.Input$Start$", {
  Lreactbuild_common_components_Input$Start$: 1,
  O: 1,
  Lreactbuild_common_components_Input$Way: 1,
  Lreactbuild_common_components_Input$MouseWay: 1,
  Lreactbuild_common_components_Input$TouchWay: 1,
  Lreactbuild_common_components_Input$KeyboardWay: 1,
  Lreactbuild_common_components_Input$CursorWay: 1,
  Lreactbuild_common_components_Input$PointerWay: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_common_components_Input$Start$.prototype.$classData = $d_Lreactbuild_common_components_Input$Start$;
var $n_Lreactbuild_common_components_Input$Start$;
function $m_Lreactbuild_common_components_Input$Start$() {
  if ((!$n_Lreactbuild_common_components_Input$Start$)) {
    $n_Lreactbuild_common_components_Input$Start$ = new $c_Lreactbuild_common_components_Input$Start$()
  };
  return $n_Lreactbuild_common_components_Input$Start$
}
/** @constructor */
function $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1(outer) {
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_circeGenericDecoderForUpdateCursorLocation = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_circeGenericEncoderForUpdateCursorLocation = null;
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_$outer).inst$macro$3__Lio_circe_generic_decoding_DerivedDecoder()));
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_circeGenericDecoderForUpdateCursorLocation = $as_Lio_circe_generic_decoding_DerivedDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_$outer).inst$macro$17__Lio_circe_generic_encoding_DerivedAsObjectEncoder()));
  this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_circeGenericEncoderForUpdateCursorLocation = $as_Lio_circe_generic_encoding_DerivedAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O())
}
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1.prototype = new $h_Lio_circe_generic_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1.prototype.constructor = $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1;
/** @constructor */
function $h_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1() {
  /*<skip>*/
}
$h_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1.prototype = $c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1.prototype;
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1.prototype.encodeObject__Lshapeless_$colon$plus$colon__Lio_circe_JsonObject = (function(a) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForUpdateCursorLocation = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForUpdateCursorLocation instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForUpdateCursorLocation);
    var circeGenericInlBindingForUpdateCursorLocation = $as_Lreactbuild_model_UpdateCursorLocation($n(x2).Lshapeless_Inl__f_head);
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_circeGenericEncoderForUpdateCursorLocation);
    return $n($$x1).singleton__T__Lio_circe_Json__Lio_circe_JsonObject("UpdateCursorLocation", $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericInlBindingForUpdateCursorLocation))
  } else if ((circeGenericInrBindingForUpdateCursorLocation instanceof $c_Lshapeless_Inr)) {
    $m_s_sys_package$().error__T__E("Cannot encode CNil")
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForUpdateCursorLocation)
  }
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var result = $n(c).downField__T__Lio_circe_ACursor("UpdateCursorLocation");
  if ($n(result).succeeded__Z()) {
    var this$1 = $n(this.Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1__f_circeGenericDecoderForUpdateCursorLocation);
    var x1 = new $c_s_Some($f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this$1, result))
  } else {
    var x1 = $m_s_None$()
  };
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result$2 = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result$2 instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result$2);
      var v = $as_Lreactbuild_model_UpdateCursorLocation($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result$2 instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result$2);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result$2)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      $m_Lio_circe_DecodingFailure$();
      var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
      var x1$3 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
      var err$2 = $as_Lio_circe_DecodingFailure(x1$3.s_util_Left__f_value);
      return new $c_s_util_Left(err$2)
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lshapeless_$colon$plus$colon__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a))
});
var $d_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1 = new $TypeData().initClass({
  Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1: 0
}, false, "reactbuild.model.FromClient$anon$lazy$macro$31$1$$anon$1", {
  Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1: 1,
  Lio_circe_generic_codec_ReprAsObjectCodec: 1,
  O: 1,
  Lio_circe_Codec$AsObject: 1,
  Lio_circe_Codec$AsRoot: 1,
  Lio_circe_Codec: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
});
$c_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1.prototype.$classData = $d_Lreactbuild_model_FromClient$anon$lazy$macro$31$1$$anon$1;
/** @constructor */
function $c_Lreactbuild_model_ListEntryEventBody$Reset$() {
  /*<skip>*/
}
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype = new $h_O();
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype.constructor = $c_Lreactbuild_model_ListEntryEventBody$Reset$;
/** @constructor */
function $h_Lreactbuild_model_ListEntryEventBody$Reset$() {
  /*<skip>*/
}
$h_Lreactbuild_model_ListEntryEventBody$Reset$.prototype = $c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype;
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype.fold__F0__F1__O = (function(ifEmpty, ifFound) {
  return $n(ifEmpty).apply__O()
});
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype.productPrefix__T = (function() {
  return "Reset"
});
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype.productArity__I = (function() {
  return 0
});
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype.hashCode__I = (function() {
  return 78851375
});
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype.toString__T = (function() {
  return "Reset"
});
function $as_Lreactbuild_model_ListEntryEventBody$Reset$(obj) {
  return (((obj instanceof $c_Lreactbuild_model_ListEntryEventBody$Reset$) || (obj === null)) ? obj : $throwClassCastException(obj, "reactbuild.model.ListEntryEventBody$Reset$"))
}
function $isArrayOf_Lreactbuild_model_ListEntryEventBody$Reset$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lreactbuild_model_ListEntryEventBody$Reset$)))
}
function $asArrayOf_Lreactbuild_model_ListEntryEventBody$Reset$(obj, depth) {
  return (($isArrayOf_Lreactbuild_model_ListEntryEventBody$Reset$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lreactbuild.model.ListEntryEventBody$Reset$;", depth))
}
var $d_Lreactbuild_model_ListEntryEventBody$Reset$ = new $TypeData().initClass({
  Lreactbuild_model_ListEntryEventBody$Reset$: 0
}, false, "reactbuild.model.ListEntryEventBody$Reset$", {
  Lreactbuild_model_ListEntryEventBody$Reset$: 1,
  O: 1,
  Lreactbuild_model_ListEntryEventIssue: 1,
  Lreactbuild_model_ListEntryEventBody: 1,
  Lreactbuild_model_ListEntryEventCheck: 1,
  Lreactbuild_model_ListEntryEventTask: 1,
  Lreactbuild_model_ListEntryEventGuideline: 1,
  Lreactbuild_model_ListEntryEventSupply: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lreactbuild_model_ListEntryEventBody$Reset$.prototype.$classData = $d_Lreactbuild_model_ListEntryEventBody$Reset$;
var $n_Lreactbuild_model_ListEntryEventBody$Reset$;
function $m_Lreactbuild_model_ListEntryEventBody$Reset$() {
  if ((!$n_Lreactbuild_model_ListEntryEventBody$Reset$)) {
    $n_Lreactbuild_model_ListEntryEventBody$Reset$ = new $c_Lreactbuild_model_ListEntryEventBody$Reset$()
  };
  return $n_Lreactbuild_model_ListEntryEventBody$Reset$
}
/** @constructor */
function $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4(outer) {
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericDecoderForCursorLocationUpdate = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericDecoderForPing = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericEncoderForCursorLocationUpdate = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericEncoderForPing = null;
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_$outer = outer
  };
  var t = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_$outer).inst$macro$9__Lio_circe_generic_decoding_DerivedDecoder()));
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericDecoderForCursorLocationUpdate = $as_Lio_circe_generic_decoding_DerivedDecoder(new $c_Lshapeless_Lazy$$anon$1(t).value__O());
  var t$1 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_$outer).inst$macro$3__Lio_circe_generic_decoding_DerivedDecoder()));
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericDecoderForPing = $as_Lio_circe_generic_decoding_DerivedDecoder(new $c_Lshapeless_Lazy$$anon$1(t$1).value__O());
  var t$2 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_$outer).inst$macro$37__Lio_circe_generic_encoding_DerivedAsObjectEncoder()));
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericEncoderForCursorLocationUpdate = $as_Lio_circe_generic_encoding_DerivedAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$2).value__O());
  var t$3 = new $c_sjsr_AnonFunction0((() => $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_$outer).inst$macro$31__Lio_circe_generic_encoding_DerivedAsObjectEncoder()));
  this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericEncoderForPing = $as_Lio_circe_generic_encoding_DerivedAsObjectEncoder(new $c_Lshapeless_Lazy$$anon$1(t$3).value__O())
}
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4.prototype = new $h_Lio_circe_generic_codec_ReprAsObjectCodec();
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4.prototype.constructor = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4;
/** @constructor */
function $h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4() {
  /*<skip>*/
}
$h_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4.prototype = $c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4.prototype;
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4.prototype.encodeObject__Lshapeless_$colon$plus$colon__Lio_circe_JsonObject = (function(a) {
  var x1 = new $c_Lshapeless_Inr(a);
  var circeGenericInrBindingForCursorLocationUpdate = $as_Lshapeless_$colon$plus$colon(x1.Lshapeless_Inr__f_tail);
  if ((circeGenericInrBindingForCursorLocationUpdate instanceof $c_Lshapeless_Inl)) {
    var x2 = $as_Lshapeless_Inl(circeGenericInrBindingForCursorLocationUpdate);
    var circeGenericInlBindingForCursorLocationUpdate = $as_Lreactbuild_model_CursorLocationUpdate($n(x2).Lshapeless_Inl__f_head);
    var $$x1 = $m_Lio_circe_JsonObject$();
    var this$1 = $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericEncoderForCursorLocationUpdate);
    return $n($$x1).singleton__T__Lio_circe_Json__Lio_circe_JsonObject("CursorLocationUpdate", $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$1, circeGenericInlBindingForCursorLocationUpdate))
  } else if ((circeGenericInrBindingForCursorLocationUpdate instanceof $c_Lshapeless_Inr)) {
    var x3 = $as_Lshapeless_Inr(circeGenericInrBindingForCursorLocationUpdate);
    var circeGenericInrBindingForPing = $as_Lshapeless_$colon$plus$colon($n(x3).Lshapeless_Inr__f_tail);
    if ((circeGenericInrBindingForPing instanceof $c_Lshapeless_Inl)) {
      var x2$2 = $as_Lshapeless_Inl(circeGenericInrBindingForPing);
      var circeGenericInlBindingForPing = $as_Lreactbuild_model_Ping($n(x2$2).Lshapeless_Inl__f_head);
      var $$x2 = $m_Lio_circe_JsonObject$();
      var this$2 = $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericEncoderForPing);
      return $n($$x2).singleton__T__Lio_circe_Json__Lio_circe_JsonObject("Ping", $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this$2, circeGenericInlBindingForPing))
    } else if ((circeGenericInrBindingForPing instanceof $c_Lshapeless_Inr)) {
      $m_s_sys_package$().error__T__E("Cannot encode CNil")
    } else {
      throw new $c_s_MatchError(circeGenericInrBindingForPing)
    }
  } else {
    throw new $c_s_MatchError(circeGenericInrBindingForCursorLocationUpdate)
  }
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var result = $n(c).downField__T__Lio_circe_ACursor("CursorLocationUpdate");
  if ($n(result).succeeded__Z()) {
    var this$1 = $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericDecoderForCursorLocationUpdate);
    var x1 = new $c_s_Some($f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this$1, result))
  } else {
    var x1 = $m_s_None$()
  };
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var result$2 = $as_s_util_Either($n(x2).s_Some__f_value);
    if ((result$2 instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(result$2);
      var v = $as_Lreactbuild_model_CursorLocationUpdate($n(x2$2).s_util_Right__f_value);
      return new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v))
    } else if ((result$2 instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(result$2);
      var err = $as_Lio_circe_DecodingFailure($n(x3).s_util_Left__f_value);
      return new $c_s_util_Left(err)
    } else {
      throw new $c_s_MatchError(result$2)
    }
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var result$3 = $n(c).downField__T__Lio_circe_ACursor("Ping");
      if ($n(result$3).succeeded__Z()) {
        var this$2 = $n(this.Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4__f_circeGenericDecoderForPing);
        var x1$3 = new $c_s_Some($f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this$2, result$3))
      } else {
        var x1$3 = $m_s_None$()
      };
      if ((x1$3 instanceof $c_s_Some)) {
        var x2$3 = $as_s_Some(x1$3);
        var result$4 = $as_s_util_Either($n(x2$3).s_Some__f_value);
        if ((result$4 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(result$4);
          var v$2 = $as_Lreactbuild_model_Ping($n(x2$4).s_util_Right__f_value);
          var x1$6 = new $c_s_util_Right($m_Lio_circe_generic_decoding_ReprDecoder$().injectLeftValue__O__Lshapeless_$colon$plus$colon(v$2))
        } else {
          if ((!(result$4 instanceof $c_s_util_Left))) {
            throw new $c_s_MatchError(result$4)
          };
          var x3$2 = $as_s_util_Left(result$4);
          var err$2 = $as_Lio_circe_DecodingFailure($n(x3$2).s_util_Left__f_value);
          var x1$6 = new $c_s_util_Left(err$2)
        }
      } else {
        var x$3 = $m_s_None$();
        if ((!(x$3 === x1$3))) {
          throw new $c_s_MatchError(x1$3)
        };
        $m_Lio_circe_DecodingFailure$();
        var ops = new $c_sjsr_AnonFunction0((() => $n(c).history__sci_List()));
        var x1$5 = new $c_s_util_Left(new $c_Lio_circe_DecodingFailure$$anon$2("CNil", ops));
        var err$3 = $as_Lio_circe_DecodingFailure(x1$5.s_util_Left__f_value);
        var x1$6 = new $c_s_util_Left(err$3)
      };
      if ((x1$6 instanceof $c_s_util_Right)) {
        var x2$6 = $as_s_util_Right(x1$6);
        var v$4 = $as_Lshapeless_$colon$plus$colon($n(x2$6).s_util_Right__f_value);
        return new $c_s_util_Right(new $c_Lshapeless_Inr(v$4))
      } else if ((x1$6 instanceof $c_s_util_Left)) {
        var x3$4 = $as_s_util_Left(x1$6);
        var err$4 = $as_Lio_circe_DecodingFailure($n(x3$4).s_util_Left__f_value);
        return new $c_s_util_Left(err$4)
      } else {
        throw new $c_s_MatchError(x1$6)
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return this.encodeObject__Lshapeless_$colon$plus$colon__Lio_circe_JsonObject($as_Lshapeless_$colon$plus$colon(a))
});
var $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4 = new $TypeData().initClass({
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4: 0
}, false, "reactbuild.model.ToClient$anon$lazy$macro$59$1$$anon$4", {
  Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4: 1,
  Lio_circe_generic_codec_ReprAsObjectCodec: 1,
  O: 1,
  Lio_circe_Codec$AsObject: 1,
  Lio_circe_Codec$AsRoot: 1,
  Lio_circe_Codec: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
});
$c_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4.prototype.$classData = $d_Lreactbuild_model_ToClient$anon$lazy$macro$59$1$$anon$4;
/** @constructor */
function $c_sc_MapView$Values(underlying) {
  this.sc_MapView$Values__f_underlying = null;
  this.sc_MapView$Values__f_underlying = underlying
}
$c_sc_MapView$Values.prototype = new $h_sc_AbstractView();
$c_sc_MapView$Values.prototype.constructor = $c_sc_MapView$Values;
/** @constructor */
function $h_sc_MapView$Values() {
  /*<skip>*/
}
$h_sc_MapView$Values.prototype = $c_sc_MapView$Values.prototype;
$c_sc_MapView$Values.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_MapView$Values__f_underlying).valuesIterator__sc_Iterator()
});
$c_sc_MapView$Values.prototype.knownSize__I = (function() {
  return $n(this.sc_MapView$Values__f_underlying).knownSize__I()
});
$c_sc_MapView$Values.prototype.isEmpty__Z = (function() {
  return $n(this.sc_MapView$Values__f_underlying).isEmpty__Z()
});
var $d_sc_MapView$Values = new $TypeData().initClass({
  sc_MapView$Values: 0
}, false, "scala.collection.MapView$Values", {
  sc_MapView$Values: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_MapView$Values.prototype.$classData = $d_sc_MapView$Values;
function $f_sc_Seq__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true
  } else {
    if ($is_sc_Seq(o)) {
      var x2 = $as_sc_Seq(o);
      if ($n(x2).canEqual__O__Z($thiz)) {
        return $thiz.sameElements__sc_IterableOnce__Z(x2)
      }
    };
    return false
  }
}
function $is_sc_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Seq)))
}
function $as_sc_Seq(obj) {
  return (($is_sc_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Seq"))
}
function $isArrayOf_sc_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Seq)))
}
function $asArrayOf_sc_Seq(obj, depth) {
  return (($isArrayOf_sc_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Seq;", depth))
}
function $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq($thiz) {
  if ((!$thiz.sc_SeqView$Sorted__f_bitmap$0)) {
    var len = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
    if ((len === 0)) {
      var res = $m_s_package$().s_package$__f_Nil
    } else if ((len === 1)) {
      $n($m_s_package$().s_package$__f_List);
      var array = [$n($thiz.sc_SeqView$Sorted__f_underlying).head__O()];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var res = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
    } else {
      var arr = new $ac_O(len);
      var this$5 = $n($thiz.sc_SeqView$Sorted__f_underlying);
      this$5.copyToArray__O__I__I__I(arr, 0, 2147483647);
      var comparator = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
      $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, comparator);
      var res = $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(arr)
    };
    $thiz.sc_SeqView$Sorted__f_evaluated = true;
    $thiz.sc_SeqView$Sorted__f_underlying = null;
    $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = res;
    $thiz.sc_SeqView$Sorted__f_bitmap$0 = true
  };
  return $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, len, ord) {
  $thiz.sc_SeqView$Sorted__f_underlying = underlying;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = len;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = ord;
  $thiz.sc_SeqView$Sorted__f_evaluated = false;
  return $thiz
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__($thiz, underlying, ord) {
  $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, $n(underlying).length__I(), ord);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Sorted() {
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = null;
  this.sc_SeqView$Sorted__f_underlying = null;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = 0;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = null;
  this.sc_SeqView$Sorted__f_evaluated = false;
  this.sc_SeqView$Sorted__f_bitmap$0 = false
}
$c_sc_SeqView$Sorted.prototype = new $h_O();
$c_sc_SeqView$Sorted.prototype.constructor = $c_sc_SeqView$Sorted;
/** @constructor */
function $h_sc_SeqView$Sorted() {
  /*<skip>*/
}
$h_sc_SeqView$Sorted.prototype = $c_sc_SeqView$Sorted.prototype;
$c_sc_SeqView$Sorted.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_SeqView$Sorted.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Sorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_SeqView$Sorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_SeqView$Sorted.prototype.className__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Sorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder()
});
$c_sc_SeqView$Sorted.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Sorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Sorted.prototype.size__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_SeqView$Sorted.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Sorted.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this).iterator__sc_Iterator()
});
$c_sc_SeqView$Sorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Sorted.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_SeqView$Sorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Sorted.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_SeqView$Sorted.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O()
});
$c_sc_SeqView$Sorted.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this)
});
$c_sc_SeqView$Sorted.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this)
});
$c_sc_SeqView$Sorted.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred)
});
$c_sc_SeqView$Sorted.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred)
});
$c_sc_SeqView$Sorted.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p)
});
$c_sc_SeqView$Sorted.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p)
});
$c_sc_SeqView$Sorted.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p)
});
$c_sc_SeqView$Sorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sc_SeqView$Sorted.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this)
});
$c_sc_SeqView$Sorted.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f)
});
$c_sc_SeqView$Sorted.prototype.zipWithIndex__O = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this)
});
$c_sc_SeqView$Sorted.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sc_SeqView$Sorted.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_sc_SeqView$Sorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_SeqView$Sorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_SeqView$Sorted.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sc_SeqView$Sorted.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_SeqView$Sorted.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf)
});
$c_sc_SeqView$Sorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_SeqView$Sorted.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sc_SeqView$Sorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sc_SeqView$Sorted.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_sc_SeqView$Sorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$_sorted__sc_Seq = (function() {
  return ((!this.sc_SeqView$Sorted__f_bitmap$0) ? $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq(this) : this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted)
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$elems__sc_SeqOps = (function() {
  var orig = this.sc_SeqView$Sorted__f_underlying;
  return (this.sc_SeqView$Sorted__f_evaluated ? this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq() : orig)
});
$c_sc_SeqView$Sorted.prototype.apply__I__O = (function(i) {
  return $n(this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq()).apply__I__O(i)
});
$c_sc_SeqView$Sorted.prototype.length__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
  var xs = new $c_sjsr_AnonFunction0((() => $n(this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq()).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_SeqView$Sorted.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted.prototype.isEmpty__Z = (function() {
  return (this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0)
});
$c_sc_SeqView$Sorted.prototype.to__sc_Factory__O = (function(factory) {
  var this$1 = $n(this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq());
  return $n(factory).fromSpecific__sc_IterableOnce__O(this$1)
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : $n(ord1).equals__O__Z(x$2))) {
    return this
  } else {
    return ($n(ord1).isReverseOf__s_math_Ordering__Z(this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? new $c_sc_SeqView$Sorted$ReverseSorted(this) : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1))
  }
});
$c_sc_SeqView$Sorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll)
});
$c_sc_SeqView$Sorted.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n)
});
$c_sc_SeqView$Sorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Sorted.prototype.take__I__O = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Sorted.prototype.prepended__O__O = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this)
});
$c_sc_SeqView$Sorted.prototype.appended__O__O = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem)
});
$c_sc_SeqView$Sorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord)
});
$c_sc_SeqView$Sorted.prototype.reverse__O = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this)
});
var $d_sc_SeqView$Sorted = new $TypeData().initClass({
  sc_SeqView$Sorted: 0
}, false, "scala.collection.SeqView$Sorted", {
  sc_SeqView$Sorted: 1,
  O: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sc_SeqView$Sorted.prototype.$classData = $d_sc_SeqView$Sorted;
function $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) {
  if ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0)) {
    $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed = $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), $n($thiz.sc_SeqView$Sorted$ReverseSorted__f_$outer).scala$collection$SeqView$Sorted$$_sorted__sc_Seq());
    $thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = true
  };
  return $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed
}
function $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse($thiz) {
  return ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0) ? $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) : $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed)
}
/** @constructor */
function $c_sc_SeqView$Sorted$ReverseSorted(outer) {
  this.sc_SeqView$Sorted$ReverseSorted__f__reversed = null;
  this.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = false;
  this.sc_SeqView$Sorted$ReverseSorted__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_SeqView$Sorted$ReverseSorted__f_$outer = outer
  }
}
$c_sc_SeqView$Sorted$ReverseSorted.prototype = new $h_O();
$c_sc_SeqView$Sorted$ReverseSorted.prototype.constructor = $c_sc_SeqView$Sorted$ReverseSorted;
/** @constructor */
function $h_sc_SeqView$Sorted$ReverseSorted() {
  /*<skip>*/
}
$h_sc_SeqView$Sorted$ReverseSorted.prototype = $c_sc_SeqView$Sorted$ReverseSorted.prototype;
$c_sc_SeqView$Sorted$ReverseSorted.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.className__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.size__I = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).iterator__sc_Iterator()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.zipWithIndex__O = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.apply__I__O = (function(i) {
  return $n($p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this)).apply__I__O(i)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.length__I = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
  var xs = new $c_sjsr_AnonFunction0((() => $n($p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this)).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.knownSize__I = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.isEmpty__Z = (function() {
  return ($n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.to__sc_Factory__O = (function(factory) {
  var this$1 = $n($p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this));
  return $n(factory).fromSpecific__sc_IterableOnce__O(this$1)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : $n(ord1).equals__O__Z(x$2))) {
    return this.sc_SeqView$Sorted$ReverseSorted__f_$outer
  } else {
    return ($n(ord1).isReverseOf__s_math_Ordering__Z($n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? this : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1))
  }
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.take__I__O = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.prepended__O__O = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.appended__O__O = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reverse__O = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer
});
var $d_sc_SeqView$Sorted$ReverseSorted = new $TypeData().initClass({
  sc_SeqView$Sorted$ReverseSorted: 0
}, false, "scala.collection.SeqView$Sorted$ReverseSorted", {
  sc_SeqView$Sorted$ReverseSorted: 1,
  O: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.$classData = $d_sc_SeqView$Sorted$ReverseSorted;
function $f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet($thiz, f, ev) {
  var b = $n($thiz.sortedIterableFactory__sc_SortedIterableFactory()).newBuilder__O__scm_Builder(ev);
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $n(f).apply__O__O($n(it).next__O());
    this$1.addOne__O__scm_Growable(elem)
  };
  return $as_sc_SortedSet($n(b).result__O())
}
function $f_sc_StrictOptimizedSortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet($thiz, f, ev) {
  var b = $n($thiz.sortedIterableFactory__sc_SortedIterableFactory()).newBuilder__O__scm_Builder(ev);
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var xs = $as_sc_IterableOnce($n(f).apply__O__O($n(it).next__O()));
    this$1.addAll__sc_IterableOnce__scm_Growable(xs)
  };
  return $as_sc_SortedSet($n(b).result__O())
}
/** @constructor */
function $c_sc_View$$anon$1(it$1) {
  this.sc_View$$anon$1__f_it$1 = null;
  this.sc_View$$anon$1__f_it$1 = it$1
}
$c_sc_View$$anon$1.prototype = new $h_sc_AbstractView();
$c_sc_View$$anon$1.prototype.constructor = $c_sc_View$$anon$1;
/** @constructor */
function $h_sc_View$$anon$1() {
  /*<skip>*/
}
$h_sc_View$$anon$1.prototype = $c_sc_View$$anon$1.prototype;
$c_sc_View$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $as_sc_Iterator($n(this.sc_View$$anon$1__f_it$1).apply__O())
});
var $d_sc_View$$anon$1 = new $TypeData().initClass({
  sc_View$$anon$1: 0
}, false, "scala.collection.View$$anon$1", {
  sc_View$$anon$1: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$$anon$1.prototype.$classData = $d_sc_View$$anon$1;
function $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem) {
  $thiz.sc_View$Appended__f_underlying = underlying;
  $thiz.sc_View$Appended__f_elem = elem;
  return $thiz
}
/** @constructor */
function $c_sc_View$Appended() {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null
}
$c_sc_View$Appended.prototype = new $h_sc_AbstractView();
$c_sc_View$Appended.prototype.constructor = $c_sc_View$Appended;
/** @constructor */
function $h_sc_View$Appended() {
  /*<skip>*/
}
$h_sc_View$Appended.prototype = $c_sc_View$Appended.prototype;
$c_sc_View$Appended.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_View$Concat(this.sc_View$Appended__f_underlying, new $c_sc_View$Single(this.sc_View$Appended__f_elem)).iterator__sc_Iterator()
});
$c_sc_View$Appended.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Appended__f_underlying).knownSize__I();
  return ((size >= 0) ? ((1 + size) | 0) : (-1))
});
$c_sc_View$Appended.prototype.isEmpty__Z = (function() {
  return false
});
var $d_sc_View$Appended = new $TypeData().initClass({
  sc_View$Appended: 0
}, false, "scala.collection.View$Appended", {
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Appended.prototype.$classData = $d_sc_View$Appended;
/** @constructor */
function $c_sc_View$Collect(underlying, pf) {
  this.sc_View$Collect__f_underlying = null;
  this.sc_View$Collect__f_pf = null;
  this.sc_View$Collect__f_underlying = underlying;
  this.sc_View$Collect__f_pf = pf
}
$c_sc_View$Collect.prototype = new $h_sc_AbstractView();
$c_sc_View$Collect.prototype.constructor = $c_sc_View$Collect;
/** @constructor */
function $h_sc_View$Collect() {
  /*<skip>*/
}
$h_sc_View$Collect.prototype = $c_sc_View$Collect.prototype;
$c_sc_View$Collect.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Collect__f_underlying).iterator__sc_Iterator());
  var pf = this.sc_View$Collect__f_pf;
  return new $c_sc_Iterator$$anon$7(this$1, pf)
});
var $d_sc_View$Collect = new $TypeData().initClass({
  sc_View$Collect: 0
}, false, "scala.collection.View$Collect", {
  sc_View$Collect: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Collect.prototype.$classData = $d_sc_View$Collect;
/** @constructor */
function $c_sc_View$Concat(prefix, suffix) {
  this.sc_View$Concat__f_prefix = null;
  this.sc_View$Concat__f_suffix = null;
  this.sc_View$Concat__f_prefix = prefix;
  this.sc_View$Concat__f_suffix = suffix
}
$c_sc_View$Concat.prototype = new $h_sc_AbstractView();
$c_sc_View$Concat.prototype.constructor = $c_sc_View$Concat;
/** @constructor */
function $h_sc_View$Concat() {
  /*<skip>*/
}
$h_sc_View$Concat.prototype = $c_sc_View$Concat.prototype;
$c_sc_View$Concat.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($n(this.sc_View$Concat__f_prefix).iterator__sc_Iterator());
  var xs = new $c_sjsr_AnonFunction0((() => $n(this.sc_View$Concat__f_suffix).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_View$Concat.prototype.knownSize__I = (function() {
  var prefixSize = $n(this.sc_View$Concat__f_prefix).knownSize__I();
  if ((prefixSize >= 0)) {
    var suffixSize = $n(this.sc_View$Concat__f_suffix).knownSize__I();
    return ((suffixSize >= 0) ? ((prefixSize + suffixSize) | 0) : (-1))
  } else {
    return (-1)
  }
});
$c_sc_View$Concat.prototype.isEmpty__Z = (function() {
  return ($n(this.sc_View$Concat__f_prefix).isEmpty__Z() && $n(this.sc_View$Concat__f_suffix).isEmpty__Z())
});
var $d_sc_View$Concat = new $TypeData().initClass({
  sc_View$Concat: 0
}, false, "scala.collection.View$Concat", {
  sc_View$Concat: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Concat.prototype.$classData = $d_sc_View$Concat;
/** @constructor */
function $c_sc_View$DistinctBy(underlying, f) {
  this.sc_View$DistinctBy__f_underlying = null;
  this.sc_View$DistinctBy__f_f = null;
  this.sc_View$DistinctBy__f_underlying = underlying;
  this.sc_View$DistinctBy__f_f = f
}
$c_sc_View$DistinctBy.prototype = new $h_sc_AbstractView();
$c_sc_View$DistinctBy.prototype.constructor = $c_sc_View$DistinctBy;
/** @constructor */
function $h_sc_View$DistinctBy() {
  /*<skip>*/
}
$h_sc_View$DistinctBy.prototype = $c_sc_View$DistinctBy.prototype;
$c_sc_View$DistinctBy.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$DistinctBy__f_underlying).iterator__sc_Iterator());
  var f = this.sc_View$DistinctBy__f_f;
  return new $c_sc_Iterator$$anon$8(this$1, f)
});
$c_sc_View$DistinctBy.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$DistinctBy__f_underlying).knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_View$DistinctBy.prototype.isEmpty__Z = (function() {
  return $n(this.sc_View$DistinctBy__f_underlying).isEmpty__Z()
});
var $d_sc_View$DistinctBy = new $TypeData().initClass({
  sc_View$DistinctBy: 0
}, false, "scala.collection.View$DistinctBy", {
  sc_View$DistinctBy: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$DistinctBy.prototype.$classData = $d_sc_View$DistinctBy;
function $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Drop__f_underlying = underlying;
  $thiz.sc_View$Drop__f_n = n;
  $thiz.sc_View$Drop__f_normN = ((n > 0) ? n : 0);
  return $thiz
}
/** @constructor */
function $c_sc_View$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0
}
$c_sc_View$Drop.prototype = new $h_sc_AbstractView();
$c_sc_View$Drop.prototype.constructor = $c_sc_View$Drop;
/** @constructor */
function $h_sc_View$Drop() {
  /*<skip>*/
}
$h_sc_View$Drop.prototype = $c_sc_View$Drop.prototype;
$c_sc_View$Drop.prototype.iterator__sc_Iterator = (function() {
  return $n($n(this.sc_View$Drop__f_underlying).iterator__sc_Iterator()).drop__I__sc_Iterator(this.sc_View$Drop__f_n)
});
$c_sc_View$Drop.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Drop__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$Drop__f_normN) | 0);
    return ((x > 0) ? x : 0)
  } else {
    return (-1)
  }
});
$c_sc_View$Drop.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z())
});
var $d_sc_View$Drop = new $TypeData().initClass({
  sc_View$Drop: 0
}, false, "scala.collection.View$Drop", {
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Drop.prototype.$classData = $d_sc_View$Drop;
function $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$DropRight__f_underlying = underlying;
  $thiz.sc_View$DropRight__f_n = n;
  $thiz.sc_View$DropRight__f_normN = ((n > 0) ? n : 0);
  return $thiz
}
/** @constructor */
function $c_sc_View$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0
}
$c_sc_View$DropRight.prototype = new $h_sc_AbstractView();
$c_sc_View$DropRight.prototype.constructor = $c_sc_View$DropRight;
/** @constructor */
function $h_sc_View$DropRight() {
  /*<skip>*/
}
$h_sc_View$DropRight.prototype = $c_sc_View$DropRight.prototype;
$c_sc_View$DropRight.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_View$().dropRightIterator__sc_Iterator__I__sc_Iterator($n(this.sc_View$DropRight__f_underlying).iterator__sc_Iterator(), this.sc_View$DropRight__f_n)
});
$c_sc_View$DropRight.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$DropRight__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$DropRight__f_normN) | 0);
    return ((x > 0) ? x : 0)
  } else {
    return (-1)
  }
});
$c_sc_View$DropRight.prototype.isEmpty__Z = (function() {
  if ((this.knownSize__I() >= 0)) {
    return (this.knownSize__I() === 0)
  } else {
    var this$1 = $n(this.iterator__sc_Iterator());
    return (!this$1.hasNext__Z())
  }
});
var $d_sc_View$DropRight = new $TypeData().initClass({
  sc_View$DropRight: 0
}, false, "scala.collection.View$DropRight", {
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$DropRight.prototype.$classData = $d_sc_View$DropRight;
/** @constructor */
function $c_sc_View$DropWhile(underlying, p) {
  this.sc_View$DropWhile__f_underlying = null;
  this.sc_View$DropWhile__f_p = null;
  this.sc_View$DropWhile__f_underlying = underlying;
  this.sc_View$DropWhile__f_p = p
}
$c_sc_View$DropWhile.prototype = new $h_sc_AbstractView();
$c_sc_View$DropWhile.prototype.constructor = $c_sc_View$DropWhile;
/** @constructor */
function $h_sc_View$DropWhile() {
  /*<skip>*/
}
$h_sc_View$DropWhile.prototype = $c_sc_View$DropWhile.prototype;
$c_sc_View$DropWhile.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$DropWhile__f_underlying).iterator__sc_Iterator());
  var p = this.sc_View$DropWhile__f_p;
  return new $c_sc_Iterator$$anon$12(this$1, p)
});
$c_sc_View$DropWhile.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$DropWhile__f_underlying).knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_View$DropWhile.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z())
});
var $d_sc_View$DropWhile = new $TypeData().initClass({
  sc_View$DropWhile: 0
}, false, "scala.collection.View$DropWhile", {
  sc_View$DropWhile: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$DropWhile.prototype.$classData = $d_sc_View$DropWhile;
/** @constructor */
function $c_sc_View$Filter(underlying, p, isFlipped) {
  this.sc_View$Filter__f_underlying = null;
  this.sc_View$Filter__f_p = null;
  this.sc_View$Filter__f_isFlipped = false;
  this.sc_View$Filter__f_underlying = underlying;
  this.sc_View$Filter__f_p = p;
  this.sc_View$Filter__f_isFlipped = isFlipped
}
$c_sc_View$Filter.prototype = new $h_sc_AbstractView();
$c_sc_View$Filter.prototype.constructor = $c_sc_View$Filter;
/** @constructor */
function $h_sc_View$Filter() {
  /*<skip>*/
}
$h_sc_View$Filter.prototype = $c_sc_View$Filter.prototype;
$c_sc_View$Filter.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Filter__f_underlying).iterator__sc_Iterator());
  var p = this.sc_View$Filter__f_p;
  var isFlipped = this.sc_View$Filter__f_isFlipped;
  return new $c_sc_Iterator$$anon$6(this$1, p, isFlipped)
});
$c_sc_View$Filter.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$Filter__f_underlying).knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_View$Filter.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z())
});
var $d_sc_View$Filter = new $TypeData().initClass({
  sc_View$Filter: 0
}, false, "scala.collection.View$Filter", {
  sc_View$Filter: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Filter.prototype.$classData = $d_sc_View$Filter;
/** @constructor */
function $c_sc_View$FlatMap(underlying, f) {
  this.sc_View$FlatMap__f_underlying = null;
  this.sc_View$FlatMap__f_f = null;
  this.sc_View$FlatMap__f_underlying = underlying;
  this.sc_View$FlatMap__f_f = f
}
$c_sc_View$FlatMap.prototype = new $h_sc_AbstractView();
$c_sc_View$FlatMap.prototype.constructor = $c_sc_View$FlatMap;
/** @constructor */
function $h_sc_View$FlatMap() {
  /*<skip>*/
}
$h_sc_View$FlatMap.prototype = $c_sc_View$FlatMap.prototype;
$c_sc_View$FlatMap.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$FlatMap__f_underlying).iterator__sc_Iterator());
  var f = this.sc_View$FlatMap__f_f;
  return new $c_sc_Iterator$$anon$10(this$1, f)
});
$c_sc_View$FlatMap.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$FlatMap__f_underlying).knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_View$FlatMap.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z())
});
var $d_sc_View$FlatMap = new $TypeData().initClass({
  sc_View$FlatMap: 0
}, false, "scala.collection.View$FlatMap", {
  sc_View$FlatMap: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$FlatMap.prototype.$classData = $d_sc_View$FlatMap;
function $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f) {
  $thiz.sc_View$Map__f_underlying = underlying;
  $thiz.sc_View$Map__f_f = f;
  return $thiz
}
/** @constructor */
function $c_sc_View$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null
}
$c_sc_View$Map.prototype = new $h_sc_AbstractView();
$c_sc_View$Map.prototype.constructor = $c_sc_View$Map;
/** @constructor */
function $h_sc_View$Map() {
  /*<skip>*/
}
$h_sc_View$Map.prototype = $c_sc_View$Map.prototype;
$c_sc_View$Map.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Map__f_underlying).iterator__sc_Iterator());
  var f = this.sc_View$Map__f_f;
  return new $c_sc_Iterator$$anon$9(this$1, f)
});
$c_sc_View$Map.prototype.knownSize__I = (function() {
  return $n(this.sc_View$Map__f_underlying).knownSize__I()
});
$c_sc_View$Map.prototype.isEmpty__Z = (function() {
  return $n(this.sc_View$Map__f_underlying).isEmpty__Z()
});
var $d_sc_View$Map = new $TypeData().initClass({
  sc_View$Map: 0
}, false, "scala.collection.View$Map", {
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Map.prototype.$classData = $d_sc_View$Map;
/** @constructor */
function $c_sc_View$Patched(underlying, from, other, replaced) {
  this.sc_View$Patched__f_underlying = null;
  this.sc_View$Patched__f_from = 0;
  this.sc_View$Patched__f_replaced = 0;
  this.sc_View$Patched__f__other = null;
  this.sc_View$Patched__f_underlying = underlying;
  this.sc_View$Patched__f_from = from;
  this.sc_View$Patched__f_replaced = replaced;
  if ($is_sc_Iterable(other)) {
    var x2 = $as_sc_Iterable(other);
    var $$x1 = x2
  } else {
    var $$x1 = $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(other)
  };
  this.sc_View$Patched__f__other = $$x1
}
$c_sc_View$Patched.prototype = new $h_sc_AbstractView();
$c_sc_View$Patched.prototype.constructor = $c_sc_View$Patched;
/** @constructor */
function $h_sc_View$Patched() {
  /*<skip>*/
}
$h_sc_View$Patched.prototype = $c_sc_View$Patched.prototype;
$c_sc_View$Patched.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Patched__f_underlying).iterator__sc_Iterator());
  var from = this.sc_View$Patched__f_from;
  var patchElems = $n(this.sc_View$Patched__f__other).iterator__sc_Iterator();
  var replaced = this.sc_View$Patched__f_replaced;
  return new $c_sc_Iterator$$anon$17(this$1, from, replaced, patchElems)
});
$c_sc_View$Patched.prototype.knownSize__I = (function() {
  return ((($n(this.sc_View$Patched__f_underlying).knownSize__I() === 0) && ($n(this.sc_View$Patched__f__other).knownSize__I() === 0)) ? 0 : (-1))
});
$c_sc_View$Patched.prototype.isEmpty__Z = (function() {
  if ((this.knownSize__I() === 0)) {
    return true
  } else {
    var this$1 = $n(this.iterator__sc_Iterator());
    return (!this$1.hasNext__Z())
  }
});
var $d_sc_View$Patched = new $TypeData().initClass({
  sc_View$Patched: 0
}, false, "scala.collection.View$Patched", {
  sc_View$Patched: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Patched.prototype.$classData = $d_sc_View$Patched;
function $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying) {
  $thiz.sc_View$Prepended__f_elem = elem;
  $thiz.sc_View$Prepended__f_underlying = underlying;
  return $thiz
}
/** @constructor */
function $c_sc_View$Prepended() {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null
}
$c_sc_View$Prepended.prototype = new $h_sc_AbstractView();
$c_sc_View$Prepended.prototype.constructor = $c_sc_View$Prepended;
/** @constructor */
function $h_sc_View$Prepended() {
  /*<skip>*/
}
$h_sc_View$Prepended.prototype = $c_sc_View$Prepended.prototype;
$c_sc_View$Prepended.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_View$Concat(new $c_sc_View$Single(this.sc_View$Prepended__f_elem), this.sc_View$Prepended__f_underlying).iterator__sc_Iterator()
});
$c_sc_View$Prepended.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Prepended__f_underlying).knownSize__I();
  return ((size >= 0) ? ((1 + size) | 0) : (-1))
});
$c_sc_View$Prepended.prototype.isEmpty__Z = (function() {
  return false
});
var $d_sc_View$Prepended = new $TypeData().initClass({
  sc_View$Prepended: 0
}, false, "scala.collection.View$Prepended", {
  sc_View$Prepended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Prepended.prototype.$classData = $d_sc_View$Prepended;
/** @constructor */
function $c_sc_View$ScanLeft(underlying, z, op) {
  this.sc_View$ScanLeft__f_underlying = null;
  this.sc_View$ScanLeft__f_z = null;
  this.sc_View$ScanLeft__f_op = null;
  this.sc_View$ScanLeft__f_underlying = underlying;
  this.sc_View$ScanLeft__f_z = z;
  this.sc_View$ScanLeft__f_op = op
}
$c_sc_View$ScanLeft.prototype = new $h_sc_AbstractView();
$c_sc_View$ScanLeft.prototype.constructor = $c_sc_View$ScanLeft;
/** @constructor */
function $h_sc_View$ScanLeft() {
  /*<skip>*/
}
$h_sc_View$ScanLeft.prototype = $c_sc_View$ScanLeft.prototype;
$c_sc_View$ScanLeft.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$ScanLeft__f_underlying).iterator__sc_Iterator());
  var z = this.sc_View$ScanLeft__f_z;
  var op = this.sc_View$ScanLeft__f_op;
  return new $c_sc_Iterator$$anon$3(this$1, z, op)
});
$c_sc_View$ScanLeft.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$ScanLeft__f_underlying).knownSize__I();
  return ((size >= 0) ? ((1 + size) | 0) : (-1))
});
$c_sc_View$ScanLeft.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z())
});
var $d_sc_View$ScanLeft = new $TypeData().initClass({
  sc_View$ScanLeft: 0
}, false, "scala.collection.View$ScanLeft", {
  sc_View$ScanLeft: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$ScanLeft.prototype.$classData = $d_sc_View$ScanLeft;
/** @constructor */
function $c_sc_View$Single(a) {
  this.sc_View$Single__f_a = null;
  this.sc_View$Single__f_a = a
}
$c_sc_View$Single.prototype = new $h_sc_AbstractView();
$c_sc_View$Single.prototype.constructor = $c_sc_View$Single;
/** @constructor */
function $h_sc_View$Single() {
  /*<skip>*/
}
$h_sc_View$Single.prototype = $c_sc_View$Single.prototype;
$c_sc_View$Single.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sc_View$Single__f_a;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sc_View$Single.prototype.knownSize__I = (function() {
  return 1
});
$c_sc_View$Single.prototype.isEmpty__Z = (function() {
  return false
});
var $d_sc_View$Single = new $TypeData().initClass({
  sc_View$Single: 0
}, false, "scala.collection.View$Single", {
  sc_View$Single: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Single.prototype.$classData = $d_sc_View$Single;
function $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Take__f_underlying = underlying;
  $thiz.sc_View$Take__f_n = n;
  $thiz.sc_View$Take__f_normN = ((n > 0) ? n : 0);
  return $thiz
}
/** @constructor */
function $c_sc_View$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0
}
$c_sc_View$Take.prototype = new $h_sc_AbstractView();
$c_sc_View$Take.prototype.constructor = $c_sc_View$Take;
/** @constructor */
function $h_sc_View$Take() {
  /*<skip>*/
}
$h_sc_View$Take.prototype = $c_sc_View$Take.prototype;
$c_sc_View$Take.prototype.iterator__sc_Iterator = (function() {
  return $n($n(this.sc_View$Take__f_underlying).iterator__sc_Iterator()).take__I__sc_Iterator(this.sc_View$Take__f_n)
});
$c_sc_View$Take.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Take__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var that = this.sc_View$Take__f_normN;
    return ((size < that) ? size : that)
  } else {
    return (-1)
  }
});
$c_sc_View$Take.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z())
});
var $d_sc_View$Take = new $TypeData().initClass({
  sc_View$Take: 0
}, false, "scala.collection.View$Take", {
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Take.prototype.$classData = $d_sc_View$Take;
/** @constructor */
function $c_sc_View$TakeWhile(underlying, p) {
  this.sc_View$TakeWhile__f_underlying = null;
  this.sc_View$TakeWhile__f_p = null;
  this.sc_View$TakeWhile__f_underlying = underlying;
  this.sc_View$TakeWhile__f_p = p
}
$c_sc_View$TakeWhile.prototype = new $h_sc_AbstractView();
$c_sc_View$TakeWhile.prototype.constructor = $c_sc_View$TakeWhile;
/** @constructor */
function $h_sc_View$TakeWhile() {
  /*<skip>*/
}
$h_sc_View$TakeWhile.prototype = $c_sc_View$TakeWhile.prototype;
$c_sc_View$TakeWhile.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$TakeWhile__f_underlying).iterator__sc_Iterator());
  var p = this.sc_View$TakeWhile__f_p;
  return new $c_sc_Iterator$$anon$11(this$1, p)
});
$c_sc_View$TakeWhile.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$TakeWhile__f_underlying).knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_View$TakeWhile.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z())
});
var $d_sc_View$TakeWhile = new $TypeData().initClass({
  sc_View$TakeWhile: 0
}, false, "scala.collection.View$TakeWhile", {
  sc_View$TakeWhile: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$TakeWhile.prototype.$classData = $d_sc_View$TakeWhile;
/** @constructor */
function $c_sc_View$Updated(underlying, index, elem) {
  this.sc_View$Updated__f_scala$collection$View$Updated$$underlying = null;
  this.sc_View$Updated__f_scala$collection$View$Updated$$index = 0;
  this.sc_View$Updated__f_scala$collection$View$Updated$$elem = null;
  this.sc_View$Updated__f_scala$collection$View$Updated$$underlying = underlying;
  this.sc_View$Updated__f_scala$collection$View$Updated$$index = index;
  this.sc_View$Updated__f_scala$collection$View$Updated$$elem = elem
}
$c_sc_View$Updated.prototype = new $h_sc_AbstractView();
$c_sc_View$Updated.prototype.constructor = $c_sc_View$Updated;
/** @constructor */
function $h_sc_View$Updated() {
  /*<skip>*/
}
$h_sc_View$Updated.prototype = $c_sc_View$Updated.prototype;
$c_sc_View$Updated.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_View$Updated$$anon$4(this)
});
$c_sc_View$Updated.prototype.knownSize__I = (function() {
  return $n(this.sc_View$Updated__f_scala$collection$View$Updated$$underlying).knownSize__I()
});
$c_sc_View$Updated.prototype.isEmpty__Z = (function() {
  var this$1 = new $c_sc_View$Updated$$anon$4(this);
  return (!this$1.hasNext__Z())
});
var $d_sc_View$Updated = new $TypeData().initClass({
  sc_View$Updated: 0
}, false, "scala.collection.View$Updated", {
  sc_View$Updated: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Updated.prototype.$classData = $d_sc_View$Updated;
/** @constructor */
function $c_sc_View$Zip(underlying, other) {
  this.sc_View$Zip__f_underlying = null;
  this.sc_View$Zip__f_other = null;
  this.sc_View$Zip__f_underlying = underlying;
  this.sc_View$Zip__f_other = other
}
$c_sc_View$Zip.prototype = new $h_sc_AbstractView();
$c_sc_View$Zip.prototype.constructor = $c_sc_View$Zip;
/** @constructor */
function $h_sc_View$Zip() {
  /*<skip>*/
}
$h_sc_View$Zip.prototype = $c_sc_View$Zip.prototype;
$c_sc_View$Zip.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Zip__f_underlying).iterator__sc_Iterator());
  var that = this.sc_View$Zip__f_other;
  return new $c_sc_Iterator$$anon$14(this$1, that)
});
$c_sc_View$Zip.prototype.knownSize__I = (function() {
  var s1 = $n(this.sc_View$Zip__f_underlying).knownSize__I();
  if ((s1 === 0)) {
    return 0
  } else {
    var s2 = $n(this.sc_View$Zip__f_other).knownSize__I();
    return ((s2 === 0) ? 0 : ((s1 < s2) ? s1 : s2))
  }
});
$c_sc_View$Zip.prototype.isEmpty__Z = (function() {
  return ($n(this.sc_View$Zip__f_underlying).isEmpty__Z() || $n(this.sc_View$Zip__f_other).isEmpty__Z())
});
var $d_sc_View$Zip = new $TypeData().initClass({
  sc_View$Zip: 0
}, false, "scala.collection.View$Zip", {
  sc_View$Zip: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Zip.prototype.$classData = $d_sc_View$Zip;
/** @constructor */
function $c_sc_View$ZipWithIndex(underlying) {
  this.sc_View$ZipWithIndex__f_underlying = null;
  this.sc_View$ZipWithIndex__f_underlying = underlying
}
$c_sc_View$ZipWithIndex.prototype = new $h_sc_AbstractView();
$c_sc_View$ZipWithIndex.prototype.constructor = $c_sc_View$ZipWithIndex;
/** @constructor */
function $h_sc_View$ZipWithIndex() {
  /*<skip>*/
}
$h_sc_View$ZipWithIndex.prototype = $c_sc_View$ZipWithIndex.prototype;
$c_sc_View$ZipWithIndex.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$ZipWithIndex__f_underlying).iterator__sc_Iterator());
  return new $c_sc_Iterator$$anon$16(this$1)
});
$c_sc_View$ZipWithIndex.prototype.knownSize__I = (function() {
  return $n(this.sc_View$ZipWithIndex__f_underlying).knownSize__I()
});
$c_sc_View$ZipWithIndex.prototype.isEmpty__Z = (function() {
  return $n(this.sc_View$ZipWithIndex__f_underlying).isEmpty__Z()
});
var $d_sc_View$ZipWithIndex = new $TypeData().initClass({
  sc_View$ZipWithIndex: 0
}, false, "scala.collection.View$ZipWithIndex", {
  sc_View$ZipWithIndex: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$ZipWithIndex.prototype.$classData = $d_sc_View$ZipWithIndex;
/** @constructor */
function $c_s_math_Numeric$DoubleIsFractional$() {
  /*<skip>*/
}
$c_s_math_Numeric$DoubleIsFractional$.prototype = new $h_O();
$c_s_math_Numeric$DoubleIsFractional$.prototype.constructor = $c_s_math_Numeric$DoubleIsFractional$;
/** @constructor */
function $h_s_math_Numeric$DoubleIsFractional$() {
  /*<skip>*/
}
$h_s_math_Numeric$DoubleIsFractional$.prototype = $c_s_math_Numeric$DoubleIsFractional$.prototype;
$c_s_math_Numeric$DoubleIsFractional$.prototype.zero__O = (function() {
  return 0.0
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.toDouble__O__D = (function(x) {
  var x$1 = $uD(x);
  return x$1
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.fromInt__I__O = (function(x) {
  return x
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.negate__O__O = (function(x) {
  var x$1 = $uD(x);
  return $f_s_math_Numeric$DoubleIsFractional__negate__D__D(this, x$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Numeric$DoubleIsFractional__times__D__D__D(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Numeric$DoubleIsFractional__minus__D__D__D(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Numeric$DoubleIsFractional__plus__D__D__D(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.min__O__O__O = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $uD(Math.min(x$1, y$1))
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.max__O__O__O = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $uD(Math.max(x$1, y$1))
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.equiv__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Ordering$Double$IeeeOrdering__equiv__D__D__Z(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.gt__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Ordering$Double$IeeeOrdering__gt__D__D__Z(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.lt__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Ordering$Double$IeeeOrdering__lt__D__D__Z(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.gteq__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Ordering$Double$IeeeOrdering__gteq__D__D__Z(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.lteq__O__O__Z = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z(this, x$1, y$1)
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
var $d_s_math_Numeric$DoubleIsFractional$ = new $TypeData().initClass({
  s_math_Numeric$DoubleIsFractional$: 0
}, false, "scala.math.Numeric$DoubleIsFractional$", {
  s_math_Numeric$DoubleIsFractional$: 1,
  O: 1,
  s_math_Numeric$DoubleIsFractional: 1,
  s_math_Fractional: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$Double$IeeeOrdering: 1
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.$classData = $d_s_math_Numeric$DoubleIsFractional$;
var $n_s_math_Numeric$DoubleIsFractional$;
function $m_s_math_Numeric$DoubleIsFractional$() {
  if ((!$n_s_math_Numeric$DoubleIsFractional$)) {
    $n_s_math_Numeric$DoubleIsFractional$ = new $c_s_math_Numeric$DoubleIsFractional$()
  };
  return $n_s_math_Numeric$DoubleIsFractional$
}
/** @constructor */
function $c_s_math_Numeric$IntIsIntegral$() {
  /*<skip>*/
}
$c_s_math_Numeric$IntIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$IntIsIntegral$.prototype.constructor = $c_s_math_Numeric$IntIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$IntIsIntegral$() {
  /*<skip>*/
}
$h_s_math_Numeric$IntIsIntegral$.prototype = $c_s_math_Numeric$IntIsIntegral$.prototype;
$c_s_math_Numeric$IntIsIntegral$.prototype.zero__O = (function() {
  return 0
});
$c_s_math_Numeric$IntIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.tryCompare__O__O__s_Option = (function(x, y) {
  return $f_s_math_Ordering__tryCompare__O__O__s_Some(this, x, y)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.toDouble__O__D = (function(x) {
  var x$1 = $uI(x);
  return x$1
});
$c_s_math_Numeric$IntIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return x
});
$c_s_math_Numeric$IntIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uI(x);
  return $f_s_math_Numeric$IntIsIntegral__negate__I__I(this, x$1)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__times__I__I__I(this, x$1, y$1)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__minus__I__I__I(this, x$1, y$1)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__plus__I__I__I(this, x$1, y$1)
});
$c_s_math_Numeric$IntIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1))
});
var $d_s_math_Numeric$IntIsIntegral$ = new $TypeData().initClass({
  s_math_Numeric$IntIsIntegral$: 0
}, false, "scala.math.Numeric$IntIsIntegral$", {
  s_math_Numeric$IntIsIntegral$: 1,
  O: 1,
  s_math_Numeric$IntIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$IntOrdering: 1
});
$c_s_math_Numeric$IntIsIntegral$.prototype.$classData = $d_s_math_Numeric$IntIsIntegral$;
var $n_s_math_Numeric$IntIsIntegral$;
function $m_s_math_Numeric$IntIsIntegral$() {
  if ((!$n_s_math_Numeric$IntIsIntegral$)) {
    $n_s_math_Numeric$IntIsIntegral$ = new $c_s_math_Numeric$IntIsIntegral$()
  };
  return $n_s_math_Numeric$IntIsIntegral$
}
/** @constructor */
function $c_Lcats_kernel_instances_UnitAlgebra() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_UnitAlgebra.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitAlgebra.prototype.constructor = $c_Lcats_kernel_instances_UnitAlgebra;
/** @constructor */
function $h_Lcats_kernel_instances_UnitAlgebra() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_UnitAlgebra.prototype = $c_Lcats_kernel_instances_UnitAlgebra.prototype;
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combine__O__O__O = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y)
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.empty__O = (function() {
  return (void 0)
});
var $d_Lcats_kernel_instances_UnitAlgebra = new $TypeData().initClass({
  Lcats_kernel_instances_UnitAlgebra: 0
}, false, "cats.kernel.instances.UnitAlgebra", {
  Lcats_kernel_instances_UnitAlgebra: 1,
  O: 1,
  Lcats_kernel_BoundedSemilattice: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.$classData = $d_Lcats_kernel_instances_UnitAlgebra;
/** @constructor */
function $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1(gen$1, codec$1, defaults$1, defaultMapper$1, config$1, fields$1, fieldsToList$1, keys$1, keysToList$1) {
  this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1__f_decodeA = null;
  this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1__f_encodeA = null;
  this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1__f_decodeA = $m_Lio_circe_generic_extras_decoding_ConfiguredDecoder$().decodeCaseClass__Lshapeless_LabelledGeneric__Lshapeless_Lazy__Lshapeless_Default$AsRecord__Lio_circe_generic_extras_util_RecordToMap__Lio_circe_generic_extras_Configuration__Lshapeless_ops_record_Keys__Lshapeless_ops_hlist$ToTraversable__Lshapeless_Annotations__Lshapeless_ops_hlist$ToTraversable__Lio_circe_generic_extras_decoding_ConfiguredDecoder(gen$1, codec$1, defaults$1, defaultMapper$1, config$1, fields$1, fieldsToList$1, keys$1, keysToList$1);
  this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1__f_encodeA = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$1(config$1, keysToList$1, keys$1, fieldsToList$1, fields$1, codec$1, gen$1)
}
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1.prototype = new $h_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1.prototype.constructor = $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1;
/** @constructor */
function $h_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1.prototype = $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1.prototype;
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $n(this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1__f_decodeA).apply__Lio_circe_HCursor__s_util_Either(c)
});
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $n(this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1__f_encodeA).encodeObject__O__Lio_circe_JsonObject(a)
});
var $d_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1 = new $TypeData().initClass({
  Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1: 0
}, false, "io.circe.generic.extras.codec.ConfiguredAsObjectCodec$$anon$1", {
  Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1: 1,
  Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec: 1,
  Lio_circe_generic_codec_DerivedAsObjectCodec: 1,
  O: 1,
  Lio_circe_Codec$AsObject: 1,
  Lio_circe_Codec$AsRoot: 1,
  Lio_circe_Codec: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
});
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1.prototype.$classData = $d_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$1;
/** @constructor */
function $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2(gen$2, codec$2, config$2) {
  this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2__f_decodeA = null;
  this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2__f_encodeA = null;
  this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2__f_decodeA = new $c_Lio_circe_generic_extras_decoding_ConfiguredDecoder$AdtConfiguredDecoder(gen$2, codec$2, config$2);
  this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2__f_encodeA = new $c_Lio_circe_generic_extras_encoding_ConfiguredAsObjectEncoder$$anon$2(config$2, codec$2, gen$2)
}
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2.prototype = new $h_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec();
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2.prototype.constructor = $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2;
/** @constructor */
function $h_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2() {
  /*<skip>*/
}
$h_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2.prototype = $c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2.prototype;
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $n(this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2__f_decodeA).apply__Lio_circe_HCursor__s_util_Either(c)
});
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  return $n(this.Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2__f_encodeA).encodeObject__O__Lio_circe_JsonObject(a)
});
var $d_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2 = new $TypeData().initClass({
  Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2: 0
}, false, "io.circe.generic.extras.codec.ConfiguredAsObjectCodec$$anon$2", {
  Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2: 1,
  Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec: 1,
  Lio_circe_generic_codec_DerivedAsObjectCodec: 1,
  O: 1,
  Lio_circe_Codec$AsObject: 1,
  Lio_circe_Codec$AsRoot: 1,
  Lio_circe_Codec: 1,
  Lio_circe_Decoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
});
$c_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2.prototype.$classData = $d_Lio_circe_generic_extras_codec_ConfiguredAsObjectCodec$$anon$2;
function $ct_Ljapgolly_scalajs_react_component_Template$MountedMapped__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__($thiz, from, mp, ls, ft, at) {
  $thiz.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from = from;
  $thiz.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_mp = mp;
  $thiz.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls = ls;
  $thiz.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft = ft;
  $thiz.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_at = at;
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Template$MountedMapped() {
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_mp = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_at = null
}
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Template$MountedMapped;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Template$MountedMapped() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype = $c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype;
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.F__Ljapgolly_scalajs_react_util_Effect$UnsafeSync = (function() {
  return this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.A__Ljapgolly_scalajs_react_util_Effect$Async = (function() {
  return this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_at
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.getDOMNode__O = (function() {
  var this$2 = $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft);
  var ga = new $c_sjsr_AnonFunction0((() => $as_Ljapgolly_scalajs_react_ComponentDom($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from).getDOMNode__O())));
  var g = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.propsChildren__O = (function() {
  var this$2 = $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft);
  var ga = new $c_sjsr_AnonFunction0((() => new $c_Ljapgolly_scalajs_react_PropsChildren($n($as_Ljapgolly_scalajs_react_PropsChildren($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from).propsChildren__O())).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self)));
  var g = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.props__O = (function() {
  var this$2 = $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft);
  var ga = new $c_sjsr_AnonFunction0((() => $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_mp).apply__O__O($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from).props__O())));
  var g = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.state__O = (function() {
  var this$2 = $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft);
  var ga = new $c_sjsr_AnonFunction0((() => $n($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls).Ljapgolly_scalajs_react_internal_Lens__f_get).apply__O__O($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from).state__O())));
  var g = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(s, callback, G) {
  var this$2 = $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft);
  var ga = new $c_sjsr_AnonFunction0((() => {
    $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($as_F1($n($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls).Ljapgolly_scalajs_react_internal_Lens__f_set).apply__O__O(s)), callback, G)
  }));
  var g = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(f, callback, G) {
  var this$2 = $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft);
  var ga = new $c_sjsr_AnonFunction0((() => {
    $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($as_F1($n($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls).Ljapgolly_scalajs_react_internal_Lens__f_mod).apply__O__O(f)), callback, G)
  }));
  var g = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(f, callback, G) {
  var this$2 = $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft);
  var ga = new $c_sjsr_AnonFunction0((() => {
    $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from).modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction2(((s1$2, p1$2) => $n($as_F1($n($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls).Ljapgolly_scalajs_react_internal_Lens__f_set).apply__O__O($n(f).apply__O__O__O($n($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls).Ljapgolly_scalajs_react_internal_Lens__f_get).apply__O__O(s1$2), $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_mp).apply__O__O(p1$2))))).apply__O__O(s1$2))), callback, G)
  }));
  var g = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(o, callback, G) {
  var this$1 = $n(o);
  if (this$1.isEmpty__Z()) {
    var this$3 = $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft);
    var ga = new $c_sjsr_AnonFunction0((() => {
      $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from).setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($m_s_None$(), callback, G)
    }));
    var g = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
    return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$3, ga, g)
  } else {
    var arg1 = this$1.get__O();
    return this.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(arg1, callback, G)
  }
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(f, callback, G) {
  var this$2 = $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft);
  var ga = new $c_sjsr_AnonFunction0((() => {
    $n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from).modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($n(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls).modO__F1__F1(f), callback, G)
  }));
  var g = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  return $f_Ljapgolly_scalajs_react_util_Effect$UnsafeSync__transSync__F0__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__O(this$2, ga, g)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot = (function(t) {
  return this.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_mp, this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls, t, this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_at)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.withAsyncEffect__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot = (function(t) {
  return this.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_mp, this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls, this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft, t)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedMapped.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(G)
});
function $ct_Ljapgolly_scalajs_react_component_Template$MountedWithRoot__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__($thiz, ft, at) {
  $thiz.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_ft = ft;
  $thiz.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_at = at;
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Template$MountedWithRoot() {
  this.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_ft = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_at = null
}
$c_Ljapgolly_scalajs_react_component_Template$MountedWithRoot.prototype = new $h_O();
$c_Ljapgolly_scalajs_react_component_Template$MountedWithRoot.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Template$MountedWithRoot;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Template$MountedWithRoot() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Template$MountedWithRoot.prototype = $c_Ljapgolly_scalajs_react_component_Template$MountedWithRoot.prototype;
$c_Ljapgolly_scalajs_react_component_Template$MountedWithRoot.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot = (function(f1) {
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var $$x1 = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  var this$2 = $m_Ljapgolly_scalajs_react_internal_Lens$();
  return this.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot($$x1, this$2.Ljapgolly_scalajs_react_internal_Lens$__f_idInstance, f1, this.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_at)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedWithRoot.prototype.withAsyncEffect__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot = (function(a1) {
  var this$1 = $m_Ljapgolly_scalajs_react_util_Util$();
  var $$x1 = this$1.Ljapgolly_scalajs_react_util_Util$__f_identity;
  var this$2 = $m_Ljapgolly_scalajs_react_internal_Lens$();
  return this.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot($$x1, this$2.Ljapgolly_scalajs_react_internal_Lens$__f_idInstance, this.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_ft, a1)
});
$c_Ljapgolly_scalajs_react_component_Template$MountedWithRoot.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot(G)
});
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch(raw, rawError, rawInfo, evidence$1, evidence$2) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_rawError = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_rawInfo = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_evidence$1 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_evidence$2 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_error = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_rawError = rawError;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_rawInfo = rawInfo;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_evidence$1 = evidence$1;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_evidence$2 = evidence$2;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$1, evidence$2);
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_error = new $c_Ljapgolly_scalajs_react_ReactCaughtError(rawError, rawInfo)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch = (function(G) {
  return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch(this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_rawError, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_rawInfo, G, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_evidence$2)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((("ComponentDidCatch(" + $n(this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch__f_error).rawErrorString__T()) + ")"))
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch(G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentDidCatch", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ForceUpdate: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidCatch;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(raw, evidence$3, evidence$4) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount__f_evidence$3 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount__f_evidence$4 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount__f_evidence$3 = evidence$3;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount__f_evidence$4 = evidence$4;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$3, evidence$4)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount = (function(G) {
  return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw, G, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount__f_evidence$4)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((((("ComponentDidMount(props: " + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()) + ", state: ") + $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this)) + ")"))
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
function $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentDidMount"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.LifecycleF$ComponentDidMount;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentDidMount", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ForceUpdate: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentDidMount;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(raw, nextProps, evidence$11, evidence$12) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_evidence$11 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_evidence$12 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps = nextProps;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_evidence$11 = evidence$11;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_evidence$12 = evidence$12;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$11, evidence$12)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps = (function(G) {
  return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps, G, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_evidence$12)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((((((("ComponentWillReceiveProps(props: " + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()) + " \u2192 ") + this.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps__f_nextProps) + ", state: ") + $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this)) + ")"))
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
function $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentWillReceiveProps"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.LifecycleF$ComponentWillReceiveProps;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$ComponentWillReceiveProps", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ForceUpdate: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$ComponentWillReceiveProps;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(raw, evidence$19, evidence$20) {
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_f = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_a = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope__f_evidence$19 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope__f_evidence$20 = null;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope__f_evidence$19 = evidence$19;
  this.Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope__f_evidence$20 = evidence$20;
  $ct_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__Ljapgolly_scalajs_react_facade_React$Component__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, raw, evidence$19, evidence$20)
}
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype = new $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$Base();
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.constructor = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype = $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype;
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope = (function(G) {
  return new $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(this.Ljapgolly_scalajs_react_component_builder_LifecycleF$Base__f_raw, G, this.Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope__f_evidence$20)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.toString__T = (function() {
  return $m_Ljapgolly_scalajs_react_component_builder_LifecycleF$().japgolly$scalajs$react$component$builder$LifecycleF$$wrapTostring__T__T((((("Render(props: " + $n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).props__O()) + ", state: ") + $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW__state__O(this)) + ")"))
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.propsChildren__sjs_js_Any = (function() {
  return $n($as_Ljapgolly_scalajs_react_PropsChildren($n(this.mountedImpure__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot()).propsChildren__O())).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_StateAccess$Base = (function(G) {
  return this.withEffect__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  return $f_Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW__setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(this, newState, callback, G)
});
function $as_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.builder.LifecycleF$RenderScope"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.builder.LifecycleF$RenderScope;", depth))
}
var $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope: 0
}, false, "japgolly.scalajs.react.component.builder.LifecycleF$RenderScope", {
  Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$Base: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateRW: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$StateW: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1,
  Ljapgolly_scalajs_react_component_builder_LifecycleF$ForceUpdate: 1
});
$c_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope.prototype.$classData = $d_Ljapgolly_scalajs_react_component_builder_LifecycleF$RenderScope;
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P10__O__O__O__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10 = hook10;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P9__O__O__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P10() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P10.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P9();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P10.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P10;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P10() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P10.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P10.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P10.prototype.toString__T = (function() {
  return (((((((((((((((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6) + ",\n  hook7 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7) + ",\n  hook8 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8) + ",\n  hook9 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9) + ",\n  hook10 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P10(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P10) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P10"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P10(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P10)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P10(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P10(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P10;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P10 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P10: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P10", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P10: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P9: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P8: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P7: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P10.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P10;
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList) {
  this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList = null;
  this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList = domList
}
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = new $h_O();
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListSeq;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListSeq() {
  /*<skip>*/
}
$h_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = $c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype;
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.canEqual__O__Z = (function(that) {
  return true
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.view__sc_SeqView = (function() {
  return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.prepended__O__O = (function(elem) {
  return $f_sc_SeqOps__prepended__O__O(this, elem)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.size__I = (function() {
  return this.length__I()
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.reverse__O = (function() {
  var coll = $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
  var this$1 = $m_sc_Seq$();
  return this$1.from__sc_IterableOnce__sc_SeqOps(coll)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.reverseIterator__sc_Iterator = (function() {
  return $n($f_sc_IterableOnceOps__reversed__sc_Iterable(this)).iterator__sc_Iterator()
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__I__O(v1))
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.className__T = (function() {
  return "Seq"
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_Seq$().newBuilder__scm_Builder()
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O()
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.zipWithIndex__O = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.length__I = (function() {
  return $uI(this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList.length)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.apply__I__O = (function(x) {
  return this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList[x]
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lorg_scalajs_dom_DOMList$DOMListIterator(this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_Seq$();
  return this$1.from__sc_IterableOnce__sc_SeqOps(coll)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Seq$()
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
var $d_Lorg_scalajs_dom_DOMList$DOMListSeq = new $TypeData().initClass({
  Lorg_scalajs_dom_DOMList$DOMListSeq: 0
}, false, "org.scalajs.dom.DOMList$DOMListSeq", {
  Lorg_scalajs_dom_DOMList$DOMListSeq: 1,
  O: 1,
  sc_Seq: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.$classData = $d_Lorg_scalajs_dom_DOMList$DOMListSeq;
var $d_Lorg_scalajs_dom_HTMLVideoElement = new $TypeData().initClass({
  Lorg_scalajs_dom_HTMLVideoElement: 0
}, false, "org.scalajs.dom.HTMLVideoElement", {
  Lorg_scalajs_dom_HTMLVideoElement: 1,
  Lorg_scalajs_dom_HTMLMediaElement: 1,
  Lorg_scalajs_dom_HTMLElement: 1,
  Lorg_scalajs_dom_Element: 1,
  Lorg_scalajs_dom_Node: 1,
  Lorg_scalajs_dom_EventTarget: 1,
  sjs_js_Object: 1,
  O: 1,
  sjs_js_Any: 1,
  Lorg_scalajs_dom_NodeSelector: 1,
  Lorg_scalajs_dom_ParentNode: 1,
  Lorg_scalajs_dom_NonDocumentTypeChildNode: 1
}, true, (void 0), ((x) => (x instanceof HTMLVideoElement)));
/** @constructor */
function $c_sc_AbstractSet() {
  /*<skip>*/
}
$c_sc_AbstractSet.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSet.prototype.constructor = $c_sc_AbstractSet;
/** @constructor */
function $h_sc_AbstractSet() {
  /*<skip>*/
}
$h_sc_AbstractSet.prototype = $c_sc_AbstractSet.prototype;
$c_sc_AbstractSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_Set__equals__O__Z(this, that)
});
$c_sc_AbstractSet.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(this, this$1.s_util_hashing_MurmurHash3$__f_setSeed)
});
$c_sc_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Set$()
});
$c_sc_AbstractSet.prototype.stringPrefix__T = (function() {
  return "Set"
});
$c_sc_AbstractSet.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  return this.forall__F1__Z(that)
});
$c_sc_AbstractSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this, that)
});
$c_sc_AbstractSet.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.contains__O__Z(v1)
});
$c_sc_AbstractSet.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_AbstractSet.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sc_AbstractSet.prototype.apply__O__O = (function(v1) {
  return this.contains__O__Z(v1)
});
function $is_sc_IndexedSeqView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeqView)))
}
function $as_sc_IndexedSeqView(obj) {
  return (($is_sc_IndexedSeqView(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IndexedSeqView"))
}
function $isArrayOf_sc_IndexedSeqView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeqView)))
}
function $asArrayOf_sc_IndexedSeqView(obj, depth) {
  return (($isArrayOf_sc_IndexedSeqView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IndexedSeqView;", depth))
}
function $f_sc_Map__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true
  } else {
    if ($is_sc_Map(o)) {
      var x2 = $as_sc_Map(o);
      if (($n(x2), true)) {
        if (($thiz.size__I() === $n(x2).size__I())) {
          try {
            return $thiz.forall__F1__Z(new $c_sjsr_AnonFunction1(((kv$2) => {
              var kv = $as_T2(kv$2);
              return $m_sr_BoxesRunTime$().equals__O__O__Z($n(x2).getOrElse__O__F0__O($n(kv)._1__O(), $m_sc_Map$().sc_Map$__f_scala$collection$Map$$DefaultSentinelFn), $n(kv)._2__O())
            })))
          } catch (e) {
            if ((e instanceof $c_jl_ClassCastException)) {
              return false
            } else {
              throw e
            }
          }
        } else {
          return false
        }
      }
    };
    return false
  }
}
function $is_sc_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Map)))
}
function $as_sc_Map(obj) {
  return (($is_sc_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Map"))
}
function $isArrayOf_sc_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Map)))
}
function $asArrayOf_sc_Map(obj, depth) {
  return (($isArrayOf_sc_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Map;", depth))
}
function $is_sc_MapView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_MapView)))
}
function $as_sc_MapView(obj) {
  return (($is_sc_MapView(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.MapView"))
}
function $isArrayOf_sc_MapView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_MapView)))
}
function $asArrayOf_sc_MapView(obj, depth) {
  return (($isArrayOf_sc_MapView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.MapView;", depth))
}
function $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V($thiz, t, e) {
  var wasInterrupted = false;
  if ((wasInterrupted || $m_s_util_control_NonFatal$().apply__jl_Throwable__Z(t))) {
    var completed = $thiz.tryComplete0__O__s_util_Try__Z($thiz.ju_concurrent_atomic_AtomicReference__f_value, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(new $c_s_util_Failure(t)));
    if ((completed && wasInterrupted)) {
      $n($m_jl_Thread$().jl_Thread$__f_SingleThread)
    };
    if (((($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 5) || ($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 6)) || (!completed))) {
      $n(e).reportFailure__jl_Throwable__V(t)
    }
  } else {
    throw ((t instanceof $c_sjs_js_JavaScriptException) ? t.sjs_js_JavaScriptException__f_exception : $n(t))
  }
}
function $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, _fun, _ec, _arg, _xform) {
  $thiz.s_concurrent_impl_Promise$Transformation__f__fun = _fun;
  $thiz.s_concurrent_impl_Promise$Transformation__f__ec = _ec;
  $thiz.s_concurrent_impl_Promise$Transformation__f__arg = _arg;
  $thiz.s_concurrent_impl_Promise$Transformation__f__xform = _xform;
  $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz);
  return $thiz
}
function $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__($thiz, xform, f, ec) {
  var this$1 = $n(ec);
  $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, f, this$1, null, xform);
  return $thiz
}
/** @constructor */
function $c_s_concurrent_impl_Promise$Transformation() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__xform = 0
}
$c_s_concurrent_impl_Promise$Transformation.prototype = new $h_s_concurrent_impl_Promise$DefaultPromise();
$c_s_concurrent_impl_Promise$Transformation.prototype.constructor = $c_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $h_s_concurrent_impl_Promise$Transformation() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$Transformation.prototype = $c_s_concurrent_impl_Promise$Transformation.prototype;
$c_s_concurrent_impl_Promise$Transformation.prototype.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation = (function(resolved) {
  this.s_concurrent_impl_Promise$Transformation__f__arg = resolved;
  var e = this.s_concurrent_impl_Promise$Transformation__f__ec;
  try {
    $n(e).execute__jl_Runnable__V(this)
  } catch (e$2) {
    var e$3 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
    this.s_concurrent_impl_Promise$Transformation__f__fun = null;
    this.s_concurrent_impl_Promise$Transformation__f__arg = null;
    this.s_concurrent_impl_Promise$Transformation__f__ec = null;
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$3, e)
  };
  return this
});
$c_s_concurrent_impl_Promise$Transformation.prototype.run__V = (function() {
  var v = this.s_concurrent_impl_Promise$Transformation__f__arg;
  var fun = this.s_concurrent_impl_Promise$Transformation__f__fun;
  var ec = this.s_concurrent_impl_Promise$Transformation__f__ec;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  try {
    var x1 = this.s_concurrent_impl_Promise$Transformation__f__xform;
    switch (x1) {
      case 0: {
        var resolvedResult = null;
        break
      }
      case 1: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success($n(fun).apply__O__O($n(v).get__O())) : v);
        break
      }
      case 2: {
        if ((v instanceof $c_s_util_Success)) {
          var f = $n(fun).apply__O__O($n(v).get__O());
          if ((f instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
            $n($as_s_concurrent_impl_Promise$DefaultPromise(f)).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null)
          } else {
            this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f))
          };
          var resolvedResult = null
        } else {
          var resolvedResult = v
        };
        break
      }
      case 3: {
        var resolvedResult = $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try($as_s_util_Try($n(fun).apply__O__O(v)));
        break
      }
      case 4: {
        var f$2 = $n(fun).apply__O__O(v);
        if ((f$2 instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
          $n($as_s_concurrent_impl_Promise$DefaultPromise(f$2)).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null)
        } else {
          this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f$2))
        };
        var resolvedResult = null;
        break
      }
      case 5: {
        $n(v).foreach__F1__V(fun);
        var resolvedResult = null;
        break
      }
      case 6: {
        $n(fun).apply__O__O(v);
        var resolvedResult = null;
        break
      }
      case 7: {
        var resolvedResult = ((v instanceof $c_s_util_Failure) ? $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try($n(v).recover__s_PartialFunction__s_util_Try($as_s_PartialFunction(fun))) : v);
        break
      }
      case 8: {
        if ((v instanceof $c_s_util_Failure)) {
          var f$3 = $as_s_concurrent_Future($n($as_s_PartialFunction(fun)).applyOrElse__O__F1__O($n($as_s_util_Failure(v)).s_util_Failure__f_exception, $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailed));
          var resolvedResult = ((f$3 !== $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker) ? (((f$3 instanceof $c_s_concurrent_impl_Promise$DefaultPromise) ? $n($as_s_concurrent_impl_Promise$DefaultPromise(f$3)).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null) : this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise(f$3)), null) : v)
        } else {
          var resolvedResult = v
        };
        break
      }
      case 9: {
        var resolvedResult = (((v instanceof $c_s_util_Failure) || $uZ($n(fun).apply__O__O($n(v).get__O()))) ? v : $m_s_concurrent_Future$().s_concurrent_Future$__f_filterFailure);
        break
      }
      case 10: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success($n($as_s_PartialFunction(fun)).applyOrElse__O__F1__O($n(v).get__O(), $m_s_concurrent_Future$().s_concurrent_Future$__f_collectFailed)) : v);
        break
      }
      default: {
        var resolvedResult = new $c_s_util_Failure($ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("BUG: encountered transformation promise with illegal type: " + this.s_concurrent_impl_Promise$Transformation__f__xform)))
      }
    };
    if ((resolvedResult !== null)) {
      this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolvedResult)
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$2, ec)
  }
});
function $as_s_concurrent_impl_Promise$Transformation(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Transformation) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Transformation"))
}
function $isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Transformation)))
}
function $asArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Transformation;", depth))
}
var $d_s_concurrent_impl_Promise$Transformation = new $TypeData().initClass({
  s_concurrent_impl_Promise$Transformation: 0
}, false, "scala.concurrent.impl.Promise$Transformation", {
  s_concurrent_impl_Promise$Transformation: 1,
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1,
  s_concurrent_impl_Promise$Callbacks: 1,
  jl_Runnable: 1,
  s_concurrent_Batchable: 1
});
$c_s_concurrent_impl_Promise$Transformation.prototype.$classData = $d_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $c_sr_RichLong(self) {
  this.sr_RichLong__f_self = $L0;
  this.sr_RichLong__f_self = self
}
$c_sr_RichLong.prototype = new $h_O();
$c_sr_RichLong.prototype.constructor = $c_sr_RichLong;
/** @constructor */
function $h_sr_RichLong() {
  /*<skip>*/
}
$h_sr_RichLong.prototype = $c_sr_RichLong.prototype;
$c_sr_RichLong.prototype.compareTo__O__I = (function(that) {
  var t$1 = this.sr_RichLong__f_self;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $uJ(new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var t$3 = $uJ(that);
  var lo$3 = t$3.RTLong__f_lo;
  var hi$3 = t$3.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$2, hi$2, lo$3, hi$3)
});
$c_sr_RichLong.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this)
});
$c_sr_RichLong.prototype.doubleValue__D = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi)
});
$c_sr_RichLong.prototype.floatValue__F = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(lo, hi)
});
$c_sr_RichLong.prototype.longValue__J = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_RTLong(lo, hi)
});
$c_sr_RichLong.prototype.intValue__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return lo
});
$c_sr_RichLong.prototype.byteValue__B = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 24) >> 24)
});
$c_sr_RichLong.prototype.shortValue__S = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 16) >> 16)
});
$c_sr_RichLong.prototype.isValidByte__Z = (function() {
  return $m_sr_RichLong$().isValidByte$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidShort__Z = (function() {
  return $m_sr_RichLong$().isValidShort$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidChar__Z = (function() {
  return $m_sr_RichLong$().isValidChar$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidInt__Z = (function() {
  return $m_sr_RichLong$().isValidInt$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.hashCode__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
});
$c_sr_RichLong.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichLong$().equals$extension__J__O__Z(this.sr_RichLong__f_self, x$1)
});
$c_sr_RichLong.prototype.self__O = (function() {
  return this.sr_RichLong__f_self
});
function $as_sr_RichLong(obj) {
  return (((obj instanceof $c_sr_RichLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichLong"))
}
function $isArrayOf_sr_RichLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichLong)))
}
function $asArrayOf_sr_RichLong(obj, depth) {
  return (($isArrayOf_sr_RichLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichLong;", depth))
}
var $d_sr_RichLong = new $TypeData().initClass({
  sr_RichLong: 0
}, false, "scala.runtime.RichLong", {
  sr_RichLong: 1,
  O: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
});
$c_sr_RichLong.prototype.$classData = $d_sr_RichLong;
function $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__($thiz, evidence$10) {
  $thiz.Lcats_data_ValidatedApplicative__f_evidence$10 = evidence$10;
  return $thiz
}
/** @constructor */
function $c_Lcats_data_ValidatedApplicative() {
  this.Lcats_data_ValidatedApplicative__f_evidence$10 = null
}
$c_Lcats_data_ValidatedApplicative.prototype = new $h_O();
$c_Lcats_data_ValidatedApplicative.prototype.constructor = $c_Lcats_data_ValidatedApplicative;
/** @constructor */
function $h_Lcats_data_ValidatedApplicative() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedApplicative.prototype = $c_Lcats_data_ValidatedApplicative.prototype;
$c_Lcats_data_ValidatedApplicative.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_data_ValidatedApplicative.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_Validated(fa);
  return $n(fa$1).map__F1__Lcats_data_Validated(f)
});
$c_Lcats_data_ValidatedApplicative.prototype.product__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated = (function(fa, fb) {
  var $$x1 = $n(fa);
  $n($m_Lcats_package$().Lcats_package$__f_Semigroup);
  var ev = this.Lcats_data_ValidatedApplicative__f_evidence$10;
  return $n($$x1).product__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated(fb, ev)
});
$c_Lcats_data_ValidatedApplicative.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated($as_Lcats_data_Validated(fa), $as_Lcats_data_Validated(fb))
});
$c_Lcats_data_ValidatedApplicative.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Validated(fa);
  return $n(fa$1).map__F1__Lcats_data_Validated(f)
});
/** @constructor */
function $c_Lcats_kernel_instances_BigIntOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BigIntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntOrder.prototype.constructor = $c_Lcats_kernel_instances_BigIntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigIntOrder.prototype = $c_Lcats_kernel_instances_BigIntOrder.prototype;
$c_Lcats_kernel_instances_BigIntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.eqv__s_math_BigInt__s_math_BigInt__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $n(x).equals__O__Z(y))
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.neqv__s_math_BigInt__s_math_BigInt__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : $n(x).equals__O__Z(y)))
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_math_BigInt__s_math_BigInt__Z($as_s_math_BigInt(x), $as_s_math_BigInt(y))
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_math_BigInt__s_math_BigInt__Z($as_s_math_BigInt(x), $as_s_math_BigInt(y))
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $n(x$1).compare__s_math_BigInt__I(y$1)
});
var $d_Lcats_kernel_instances_BigIntOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BigIntOrder: 0
}, false, "cats.kernel.instances.BigIntOrder", {
  Lcats_kernel_instances_BigIntOrder: 1,
  O: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_BigIntUnboundedEnum: 1,
  Lcats_kernel_UnboundedEnumerable: 1,
  Lcats_kernel_Next: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_Previous: 1,
  Lcats_kernel_PartialPrevious: 1
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.$classData = $d_Lcats_kernel_instances_BigIntOrder;
function $is_Ljapgolly_scalajs_react_component_Js$MountedWithRoot(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_component_Js$MountedWithRoot)))
}
function $as_Ljapgolly_scalajs_react_component_Js$MountedWithRoot(obj) {
  return (($is_Ljapgolly_scalajs_react_component_Js$MountedWithRoot(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.Js$MountedWithRoot"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_Js$MountedWithRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_Js$MountedWithRoot)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_Js$MountedWithRoot(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_Js$MountedWithRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.Js$MountedWithRoot;", depth))
}
function $f_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot__backend__O($thiz) {
  return $n($thiz.js__Ljapgolly_scalajs_react_component_Js$MountedWithRoot()).raw__Ljapgolly_scalajs_react_facade_React$Component().backend
}
function $is_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljapgolly_scalajs_react_component_Scala$MountedWithRoot)))
}
function $as_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(obj) {
  return (($is_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.component.Scala$MountedWithRoot"))
}
function $isArrayOf_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_component_Scala$MountedWithRoot)))
}
function $asArrayOf_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.component.Scala$MountedWithRoot;", depth))
}
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P11__O__O__O__O__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10, hook11) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11 = hook11;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P10__O__O__O__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P11() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P11.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P10();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P11.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P11;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P11() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P11.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P11.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P11.prototype.toString__T = (function() {
  return (((((((((((((((((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6) + ",\n  hook7 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7) + ",\n  hook8 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8) + ",\n  hook9 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9) + ",\n  hook10 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10) + ",\n  hook11 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P11(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P11) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P11"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P11(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P11)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P11(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P11(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P11;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P11 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P11: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P11", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P11: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P10: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P9: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P8: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P7: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P11.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P11;
/** @constructor */
function $c_sc_AbstractSeq() {
  /*<skip>*/
}
$c_sc_AbstractSeq.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSeq.prototype.constructor = $c_sc_AbstractSeq;
/** @constructor */
function $h_sc_AbstractSeq() {
  /*<skip>*/
}
$h_sc_AbstractSeq.prototype = $c_sc_AbstractSeq.prototype;
$c_sc_AbstractSeq.prototype.canEqual__O__Z = (function(that) {
  return true
});
$c_sc_AbstractSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_sc_AbstractSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_sc_AbstractSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractSeq.prototype.view__sc_SeqView = (function() {
  return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this)
});
$c_sc_AbstractSeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem)
});
$c_sc_AbstractSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__O(suffix)
});
$c_sc_AbstractSeq.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_AbstractSeq.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_AbstractSeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_AbstractSeq.prototype.reverse__O = (function() {
  return this.fromSpecific__sc_IterableOnce__O(this.reversed__sc_Iterable())
});
$c_sc_AbstractSeq.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator()
});
$c_sc_AbstractSeq.prototype.startsWith__sc_IterableOnce__I__Z = (function(that, offset) {
  return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset)
});
$c_sc_AbstractSeq.prototype.startsWith$default$2__I = (function() {
  return 0
});
$c_sc_AbstractSeq.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_sc_AbstractSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_AbstractSeq.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_AbstractSeq.prototype.lastIndexWhere__F1__I__I = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end)
});
$c_sc_AbstractSeq.prototype.contains__O__Z = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem)
});
$c_sc_AbstractSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sc_AbstractSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize)
});
$c_sc_AbstractSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_AbstractSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_AbstractSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sc_AbstractSeq.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_SeqOps__diff__sc_Seq__O(this, that)
});
$c_sc_AbstractSeq.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_AbstractSeq.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem)
});
$c_sc_AbstractSeq.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that)
});
$c_sc_AbstractSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sc_AbstractSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this)
});
$c_sc_AbstractSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action)
});
$c_sc_AbstractSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1))
});
$c_sc_AbstractSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_AbstractSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sc_AbstractSeq.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
/** @constructor */
function $c_sc_AbstractSeqView() {
  /*<skip>*/
}
$c_sc_AbstractSeqView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractSeqView.prototype.constructor = $c_sc_AbstractSeqView;
/** @constructor */
function $h_sc_AbstractSeqView() {
  /*<skip>*/
}
$h_sc_AbstractSeqView.prototype = $c_sc_AbstractSeqView.prototype;
$c_sc_AbstractSeqView.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_AbstractSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_AbstractSeqView.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem)
});
$c_sc_AbstractSeqView.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this)
});
$c_sc_AbstractSeqView.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this)
});
$c_sc_AbstractSeqView.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_AbstractSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_AbstractSeqView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n)
});
$c_sc_AbstractSeqView.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_AbstractSeqView.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractSeqView.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractSeqView.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_AbstractSeqView.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_AbstractSeqView.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_AbstractSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator()
});
$c_sc_AbstractSeqView.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_AbstractSeqView.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_AbstractSeqView.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_AbstractSeqView.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_AbstractSeqView.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_AbstractSeqView.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_AbstractSeqView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n)
});
$c_sc_AbstractSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_AbstractSeqView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_AbstractSeqView.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView()
});
$c_sc_AbstractSeqView.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem)
});
$c_sc_AbstractSeqView.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem)
});
$c_sc_AbstractSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
function $is_sc_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeq)))
}
function $as_sc_IndexedSeq(obj) {
  return (($is_sc_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IndexedSeq"))
}
function $isArrayOf_sc_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeq)))
}
function $asArrayOf_sc_IndexedSeq(obj, depth) {
  return (($isArrayOf_sc_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IndexedSeq;", depth))
}
function $is_sc_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeq)))
}
function $as_sc_LinearSeq(obj) {
  return (($is_sc_LinearSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeq"))
}
function $isArrayOf_sc_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeq)))
}
function $asArrayOf_sc_LinearSeq(obj, depth) {
  return (($isArrayOf_sc_LinearSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeq;", depth))
}
/** @constructor */
function $c_sc_View$Empty$() {
  /*<skip>*/
}
$c_sc_View$Empty$.prototype = new $h_sc_AbstractView();
$c_sc_View$Empty$.prototype.constructor = $c_sc_View$Empty$;
/** @constructor */
function $h_sc_View$Empty$() {
  /*<skip>*/
}
$h_sc_View$Empty$.prototype = $c_sc_View$Empty$.prototype;
$c_sc_View$Empty$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sc_View$Empty$.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_View$Empty$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sc_View$Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_sc_View$Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_sc_View$Empty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_sc_View$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sc_View$Empty$.prototype.hashCode__I = (function() {
  return 67081517
});
var $d_sc_View$Empty$ = new $TypeData().initClass({
  sc_View$Empty$: 0
}, false, "scala.collection.View$Empty$", {
  sc_View$Empty$: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sc_View$Empty$.prototype.$classData = $d_sc_View$Empty$;
var $n_sc_View$Empty$;
function $m_sc_View$Empty$() {
  if ((!$n_sc_View$Empty$)) {
    $n_sc_View$Empty$ = new $c_sc_View$Empty$()
  };
  return $n_sc_View$Empty$
}
function $is_sci_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Set)))
}
function $as_sci_Set(obj) {
  return (($is_sci_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set"))
}
function $isArrayOf_sci_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set)))
}
function $asArrayOf_sci_Set(obj, depth) {
  return (($isArrayOf_sci_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set;", depth))
}
function $f_scm_SetOps__remove__O__Z($thiz, elem) {
  var res = $thiz.contains__O__Z(elem);
  var this$1 = $n($as_scm_Shrinkable($thiz));
  this$1.subtractOne__O__scm_Shrinkable(elem);
  return res
}
function $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P12__O__O__O__O__O__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10, hook11, hook12) {
  $thiz.Ljapgolly_scalajs_react_hooks_HookCtx$P12__f_hook12 = hook12;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P11__O__O__O__O__O__O__O__O__O__O__O__O__($thiz, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10, hook11);
  return $thiz
}
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P12() {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P12__f_hook12 = null
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P12.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P11();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P12.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P12;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P12() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P12.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P12.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P12.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6) + ",\n  hook7 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7) + ",\n  hook8 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8) + ",\n  hook9 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9) + ",\n  hook10 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10) + ",\n  hook11 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11) + ",\n  hook12 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P12__f_hook12) + ")")
});
function $as_Ljapgolly_scalajs_react_hooks_HookCtx$P12(obj) {
  return (((obj instanceof $c_Ljapgolly_scalajs_react_hooks_HookCtx$P12) || (obj === null)) ? obj : $throwClassCastException(obj, "japgolly.scalajs.react.hooks.HookCtx$P12"))
}
function $isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P12(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljapgolly_scalajs_react_hooks_HookCtx$P12)))
}
function $asArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P12(obj, depth) {
  return (($isArrayOf_Ljapgolly_scalajs_react_hooks_HookCtx$P12(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljapgolly.scalajs.react.hooks.HookCtx$P12;", depth))
}
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P12 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P12: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P12", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P12: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P11: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P10: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P9: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P8: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P7: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P12.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P12;
/** @constructor */
function $c_sc_AbstractMap() {
  /*<skip>*/
}
$c_sc_AbstractMap.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractMap.prototype.constructor = $c_sc_AbstractMap;
/** @constructor */
function $h_sc_AbstractMap() {
  /*<skip>*/
}
$h_sc_AbstractMap.prototype = $c_sc_AbstractMap.prototype;
$c_sc_AbstractMap.prototype.equals__O__Z = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o)
});
$c_sc_AbstractMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(this)
});
$c_sc_AbstractMap.prototype.stringPrefix__T = (function() {
  return "Map"
});
$c_sc_AbstractMap.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps($n(this.mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(coll))
});
$c_sc_AbstractMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $n(this.mapFactory__sc_MapFactory()).newBuilder__scm_Builder()
});
$c_sc_AbstractMap.prototype.withFilter__F1__sc_MapOps$WithFilter = (function(p) {
  return $ct_sc_MapOps$WithFilter__sc_MapOps__F1__(new $c_sc_MapOps$WithFilter(), this, p)
});
$c_sc_AbstractMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
});
$c_sc_AbstractMap.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key)
});
$c_sc_AbstractMap.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractMap.prototype.keySet__sc_Set = (function() {
  return new $c_sc_MapOps$KeySet(this)
});
$c_sc_AbstractMap.prototype.keys__sc_Iterable = (function() {
  return this.keySet__sc_Set()
});
$c_sc_AbstractMap.prototype.values__sc_Iterable = (function() {
  return new $c_sc_MapOps$$anon$1(this)
});
$c_sc_AbstractMap.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$2(this)
});
$c_sc_AbstractMap.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this)
});
$c_sc_AbstractMap.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f)
});
$c_sc_AbstractMap.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key)
});
$c_sc_AbstractMap.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key)
});
$c_sc_AbstractMap.prototype.isDefinedAt__O__Z = (function(key) {
  return this.contains__O__Z(key)
});
$c_sc_AbstractMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f)
});
$c_sc_AbstractMap.prototype.collect__s_PartialFunction__sc_IterableOps = (function(pf) {
  return $f_sc_MapOps__collect__s_PartialFunction__sc_IterableOps(this, pf)
});
$c_sc_AbstractMap.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end)
});
$c_sc_AbstractMap.prototype.$plus__T2__sc_IterableOps = (function(kv) {
  return $f_sc_MapOps__$plus__T2__sc_IterableOps(this, kv)
});
$c_sc_AbstractMap.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that)
});
$c_sc_AbstractMap.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sc_AbstractMap.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this)
});
$c_sc_AbstractMap.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action)
});
$c_sc_AbstractMap.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1))
});
$c_sc_AbstractMap.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_AbstractMap.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sc_AbstractMap.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return this.withFilter__F1__sc_MapOps$WithFilter(p)
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll)
});
function $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem) {
  $thiz.sc_SeqView$Appended__f_underlying = underlying;
  $thiz.sc_SeqView$Appended__f_elem = elem;
  $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Appended() {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
  this.sc_SeqView$Appended__f_underlying = null;
  this.sc_SeqView$Appended__f_elem = null
}
$c_sc_SeqView$Appended.prototype = new $h_sc_View$Appended();
$c_sc_SeqView$Appended.prototype.constructor = $c_sc_SeqView$Appended;
/** @constructor */
function $h_sc_SeqView$Appended() {
  /*<skip>*/
}
$h_sc_SeqView$Appended.prototype = $c_sc_SeqView$Appended.prototype;
$c_sc_SeqView$Appended.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_SeqView$Appended.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Appended.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem)
});
$c_sc_SeqView$Appended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this)
});
$c_sc_SeqView$Appended.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this)
});
$c_sc_SeqView$Appended.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Appended.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Appended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n)
});
$c_sc_SeqView$Appended.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Appended.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Appended.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Appended.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_SeqView$Appended.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_SeqView$Appended.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Appended.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator()
});
$c_sc_SeqView$Appended.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Appended.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_SeqView$Appended.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Appended.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Appended.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_SeqView$Appended.prototype.apply__I__O = (function(idx) {
  return ((idx === $n(this.sc_SeqView$Appended__f_underlying).length__I()) ? this.sc_SeqView$Appended__f_elem : $n(this.sc_SeqView$Appended__f_underlying).apply__I__O(idx))
});
$c_sc_SeqView$Appended.prototype.length__I = (function() {
  return ((1 + $n(this.sc_SeqView$Appended__f_underlying).length__I()) | 0)
});
$c_sc_SeqView$Appended.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$Appended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n)
});
$c_sc_SeqView$Appended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_SeqView$Appended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_SeqView$Appended.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView()
});
$c_sc_SeqView$Appended.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Appended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Appended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
var $d_sc_SeqView$Appended = new $TypeData().initClass({
  sc_SeqView$Appended: 0
}, false, "scala.collection.SeqView$Appended", {
  sc_SeqView$Appended: 1,
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Appended.prototype.$classData = $d_sc_SeqView$Appended;
function $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Drop__f_underlying = underlying;
  $thiz.sc_SeqView$Drop__f_n = n;
  $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0
}
$c_sc_SeqView$Drop.prototype = new $h_sc_View$Drop();
$c_sc_SeqView$Drop.prototype.constructor = $c_sc_SeqView$Drop;
/** @constructor */
function $h_sc_SeqView$Drop() {
  /*<skip>*/
}
$h_sc_SeqView$Drop.prototype = $c_sc_SeqView$Drop.prototype;
$c_sc_SeqView$Drop.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_SeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Drop.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem)
});
$c_sc_SeqView$Drop.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this)
});
$c_sc_SeqView$Drop.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this)
});
$c_sc_SeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n)
});
$c_sc_SeqView$Drop.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Drop.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Drop.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Drop.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_SeqView$Drop.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_SeqView$Drop.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator()
});
$c_sc_SeqView$Drop.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Drop.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_SeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Drop.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Drop.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_SeqView$Drop.prototype.length__I = (function() {
  var this$1 = $n(this.sc_SeqView$Drop__f_underlying);
  var x = ((this$1.length__I() - this.sc_View$Drop__f_normN) | 0);
  return ((x > 0) ? x : 0)
});
$c_sc_SeqView$Drop.prototype.apply__I__O = (function(i) {
  return $n(this.sc_SeqView$Drop__f_underlying).apply__I__O(((i + this.sc_View$Drop__f_normN) | 0))
});
$c_sc_SeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this.sc_SeqView$Drop__f_underlying, ((this.sc_SeqView$Drop__f_n + n) | 0))
});
$c_sc_SeqView$Drop.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n)
});
$c_sc_SeqView$Drop.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_SeqView$Drop.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView()
});
$c_sc_SeqView$Drop.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Drop.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
$c_sc_SeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
var $d_sc_SeqView$Drop = new $TypeData().initClass({
  sc_SeqView$Drop: 0
}, false, "scala.collection.SeqView$Drop", {
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Drop.prototype.$classData = $d_sc_SeqView$Drop;
function $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$DropRight__f_underlying = underlying;
  $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n);
  var this$1 = $n(underlying);
  var x = ((this$1.length__I() - ((n > 0) ? n : 0)) | 0);
  $thiz.sc_SeqView$DropRight__f_len = ((x > 0) ? x : 0);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0
}
$c_sc_SeqView$DropRight.prototype = new $h_sc_View$DropRight();
$c_sc_SeqView$DropRight.prototype.constructor = $c_sc_SeqView$DropRight;
/** @constructor */
function $h_sc_SeqView$DropRight() {
  /*<skip>*/
}
$h_sc_SeqView$DropRight.prototype = $c_sc_SeqView$DropRight.prototype;
$c_sc_SeqView$DropRight.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_SeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$DropRight.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem)
});
$c_sc_SeqView$DropRight.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this)
});
$c_sc_SeqView$DropRight.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this)
});
$c_sc_SeqView$DropRight.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n)
});
$c_sc_SeqView$DropRight.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$DropRight.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$DropRight.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$DropRight.prototype.size__I = (function() {
  return this.sc_SeqView$DropRight__f_len
});
$c_sc_SeqView$DropRight.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_SeqView$DropRight.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator()
});
$c_sc_SeqView$DropRight.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$DropRight.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_SeqView$DropRight.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$DropRight.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$DropRight.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_SeqView$DropRight.prototype.length__I = (function() {
  return this.sc_SeqView$DropRight__f_len
});
$c_sc_SeqView$DropRight.prototype.apply__I__O = (function(i) {
  return $n(this.sc_SeqView$DropRight__f_underlying).apply__I__O(i)
});
$c_sc_SeqView$DropRight.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n)
});
$c_sc_SeqView$DropRight.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_SeqView$DropRight.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_SeqView$DropRight.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView()
});
$c_sc_SeqView$DropRight.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem)
});
$c_sc_SeqView$DropRight.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem)
});
$c_sc_SeqView$DropRight.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
var $d_sc_SeqView$DropRight = new $TypeData().initClass({
  sc_SeqView$DropRight: 0
}, false, "scala.collection.SeqView$DropRight", {
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$DropRight.prototype.$classData = $d_sc_SeqView$DropRight;
function $ct_sc_SeqView$Id__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Id__f_underlying = underlying;
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Id() {
  this.sc_SeqView$Id__f_underlying = null
}
$c_sc_SeqView$Id.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Id.prototype.constructor = $c_sc_SeqView$Id;
/** @constructor */
function $h_sc_SeqView$Id() {
  /*<skip>*/
}
$h_sc_SeqView$Id.prototype = $c_sc_SeqView$Id.prototype;
$c_sc_SeqView$Id.prototype.apply__I__O = (function(idx) {
  return $n(this.sc_SeqView$Id__f_underlying).apply__I__O(idx)
});
$c_sc_SeqView$Id.prototype.length__I = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).length__I()
});
$c_sc_SeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).iterator__sc_Iterator()
});
$c_sc_SeqView$Id.prototype.knownSize__I = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).knownSize__I()
});
$c_sc_SeqView$Id.prototype.isEmpty__Z = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).isEmpty__Z()
});
var $d_sc_SeqView$Id = new $TypeData().initClass({
  sc_SeqView$Id: 0
}, false, "scala.collection.SeqView$Id", {
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Id.prototype.$classData = $d_sc_SeqView$Id;
function $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f) {
  $thiz.sc_SeqView$Map__f_underlying = underlying;
  $thiz.sc_SeqView$Map__f_f = f;
  $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null
}
$c_sc_SeqView$Map.prototype = new $h_sc_View$Map();
$c_sc_SeqView$Map.prototype.constructor = $c_sc_SeqView$Map;
/** @constructor */
function $h_sc_SeqView$Map() {
  /*<skip>*/
}
$h_sc_SeqView$Map.prototype = $c_sc_SeqView$Map.prototype;
$c_sc_SeqView$Map.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_SeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Map.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem)
});
$c_sc_SeqView$Map.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this)
});
$c_sc_SeqView$Map.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this)
});
$c_sc_SeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n)
});
$c_sc_SeqView$Map.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Map.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Map.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Map.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_SeqView$Map.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_SeqView$Map.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator()
});
$c_sc_SeqView$Map.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Map.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_SeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Map.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Map.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_SeqView$Map.prototype.apply__I__O = (function(idx) {
  return $n(this.sc_SeqView$Map__f_f).apply__O__O($n(this.sc_SeqView$Map__f_underlying).apply__I__O(idx))
});
$c_sc_SeqView$Map.prototype.length__I = (function() {
  return $n(this.sc_SeqView$Map__f_underlying).length__I()
});
$c_sc_SeqView$Map.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$Map.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n)
});
$c_sc_SeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_SeqView$Map.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_SeqView$Map.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView()
});
$c_sc_SeqView$Map.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Map.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
var $d_sc_SeqView$Map = new $TypeData().initClass({
  sc_SeqView$Map: 0
}, false, "scala.collection.SeqView$Map", {
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Map.prototype.$classData = $d_sc_SeqView$Map;
function $ct_sc_SeqView$Prepended__O__sc_SeqOps__($thiz, elem, underlying) {
  $thiz.sc_SeqView$Prepended__f_elem = elem;
  $thiz.sc_SeqView$Prepended__f_underlying = underlying;
  $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Prepended() {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
  this.sc_SeqView$Prepended__f_elem = null;
  this.sc_SeqView$Prepended__f_underlying = null
}
$c_sc_SeqView$Prepended.prototype = new $h_sc_View$Prepended();
$c_sc_SeqView$Prepended.prototype.constructor = $c_sc_SeqView$Prepended;
/** @constructor */
function $h_sc_SeqView$Prepended() {
  /*<skip>*/
}
$h_sc_SeqView$Prepended.prototype = $c_sc_SeqView$Prepended.prototype;
$c_sc_SeqView$Prepended.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_SeqView$Prepended.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Prepended.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem)
});
$c_sc_SeqView$Prepended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this)
});
$c_sc_SeqView$Prepended.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this)
});
$c_sc_SeqView$Prepended.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Prepended.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Prepended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n)
});
$c_sc_SeqView$Prepended.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Prepended.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Prepended.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Prepended.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_SeqView$Prepended.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_SeqView$Prepended.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Prepended.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator()
});
$c_sc_SeqView$Prepended.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Prepended.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_SeqView$Prepended.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Prepended.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Prepended.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_SeqView$Prepended.prototype.apply__I__O = (function(idx) {
  return ((idx === 0) ? this.sc_SeqView$Prepended__f_elem : $n(this.sc_SeqView$Prepended__f_underlying).apply__I__O((((-1) + idx) | 0)))
});
$c_sc_SeqView$Prepended.prototype.length__I = (function() {
  return ((1 + $n(this.sc_SeqView$Prepended__f_underlying).length__I()) | 0)
});
$c_sc_SeqView$Prepended.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$Prepended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n)
});
$c_sc_SeqView$Prepended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_SeqView$Prepended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_SeqView$Prepended.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView()
});
$c_sc_SeqView$Prepended.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Prepended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Prepended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
var $d_sc_SeqView$Prepended = new $TypeData().initClass({
  sc_SeqView$Prepended: 0
}, false, "scala.collection.SeqView$Prepended", {
  sc_SeqView$Prepended: 1,
  sc_View$Prepended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Prepended.prototype.$classData = $d_sc_SeqView$Prepended;
function $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Reverse__f_underlying = underlying;
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Reverse() {
  this.sc_SeqView$Reverse__f_underlying = null
}
$c_sc_SeqView$Reverse.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Reverse.prototype.constructor = $c_sc_SeqView$Reverse;
/** @constructor */
function $h_sc_SeqView$Reverse() {
  /*<skip>*/
}
$h_sc_SeqView$Reverse.prototype = $c_sc_SeqView$Reverse.prototype;
$c_sc_SeqView$Reverse.prototype.apply__I__O = (function(i) {
  return $n(this.sc_SeqView$Reverse__f_underlying).apply__I__O((((((-1) + this.length__I()) | 0) - i) | 0))
});
$c_sc_SeqView$Reverse.prototype.length__I = (function() {
  var this$1 = $n(this.sc_SeqView$Reverse__f_underlying);
  return this$1.length__I()
});
$c_sc_SeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_SeqView$Reverse__f_underlying).reverseIterator__sc_Iterator()
});
$c_sc_SeqView$Reverse.prototype.knownSize__I = (function() {
  return $n(this.sc_SeqView$Reverse__f_underlying).knownSize__I()
});
$c_sc_SeqView$Reverse.prototype.isEmpty__Z = (function() {
  return $n(this.sc_SeqView$Reverse__f_underlying).isEmpty__Z()
});
var $d_sc_SeqView$Reverse = new $TypeData().initClass({
  sc_SeqView$Reverse: 0
}, false, "scala.collection.SeqView$Reverse", {
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Reverse.prototype.$classData = $d_sc_SeqView$Reverse;
function $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Take__f_underlying = underlying;
  $thiz.sc_SeqView$Take__f_n = n;
  $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0
}
$c_sc_SeqView$Take.prototype = new $h_sc_View$Take();
$c_sc_SeqView$Take.prototype.constructor = $c_sc_SeqView$Take;
/** @constructor */
function $h_sc_SeqView$Take() {
  /*<skip>*/
}
$h_sc_SeqView$Take.prototype = $c_sc_SeqView$Take.prototype;
$c_sc_SeqView$Take.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_SeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Take.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem)
});
$c_sc_SeqView$Take.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this)
});
$c_sc_SeqView$Take.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this)
});
$c_sc_SeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n)
});
$c_sc_SeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Take.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n)
});
$c_sc_SeqView$Take.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Take.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Take.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Take.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_SeqView$Take.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sc_SeqView$Take.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator()
});
$c_sc_SeqView$Take.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Take.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sc_SeqView$Take.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Take.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Take.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sc_SeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sc_SeqView$Take.prototype.apply__I__O = (function(idx) {
  if ((idx < this.sc_SeqView$Take__f_n)) {
    return $n(this.sc_SeqView$Take__f_underlying).apply__I__O(idx)
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (($n(this.sc_SeqView$Take__f_underlying).knownSize__I() >= 0) ? (((-1) + this.knownSize__I()) | 0) : "unknown")) + ")"))
  }
});
$c_sc_SeqView$Take.prototype.length__I = (function() {
  var x = $n(this.sc_SeqView$Take__f_underlying).length__I();
  var that = this.sc_View$Take__f_normN;
  return ((x < that) ? x : that)
});
$c_sc_SeqView$Take.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$Take.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n)
});
$c_sc_SeqView$Take.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_SeqView$Take.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n)
});
$c_sc_SeqView$Take.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView()
});
$c_sc_SeqView$Take.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Take.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem)
});
$c_sc_SeqView$Take.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
var $d_sc_SeqView$Take = new $TypeData().initClass({
  sc_SeqView$Take: 0
}, false, "scala.collection.SeqView$Take", {
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Take.prototype.$classData = $d_sc_SeqView$Take;
function $f_sc_SortedSet__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true
  };
  if ($is_sc_SortedSet(that)) {
    var x2 = $as_sc_SortedSet(that);
    var x = $n(x2).ordering__s_math_Ordering();
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      if ((($n(x2), true) && ($thiz.size__I() === $n(x2).size__I()))) {
        var i1 = $thiz.iterator__sc_Iterator();
        var i2 = $n(x2).iterator__sc_Iterator();
        var allEqual = true;
        while ((allEqual && $n(i1).hasNext__Z())) {
          allEqual = $n($thiz.ordering__s_math_Ordering()).equiv__O__O__Z($n(i1).next__O(), $n(i2).next__O())
        };
        return allEqual
      } else {
        return false
      }
    }
  };
  return $f_sc_Set__equals__O__Z($thiz, that)
}
function $is_sc_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SortedSet)))
}
function $as_sc_SortedSet(obj) {
  return (($is_sc_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SortedSet"))
}
function $isArrayOf_sc_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SortedSet)))
}
function $asArrayOf_sc_SortedSet(obj, depth) {
  return (($isArrayOf_sc_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SortedSet;", depth))
}
function $is_sci_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Seq)))
}
function $as_sci_Seq(obj) {
  return (($is_sci_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Seq"))
}
function $isArrayOf_sci_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Seq)))
}
function $asArrayOf_sci_Seq(obj, depth) {
  return (($isArrayOf_sci_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Seq;", depth))
}
var $d_sci_Seq = new $TypeData().initClass({
  sci_Seq: 0
}, true, "scala.collection.immutable.Seq", {
  sci_Seq: 1,
  O: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1
});
function $f_scm_MapOps__update__O__O__V($thiz, key, value) {
  var this$1 = $n($as_scm_Growable($thiz));
  var elem = $ct_T2__O__O__(new $c_T2(), key, value);
  this$1.addOne__O__scm_Growable(elem)
}
function $f_scm_MapOps__updateWith__O__F1__s_Option($thiz, key, remappingFunction) {
  var previousValue = $thiz.get__O__s_Option(key);
  var nextValue = $as_s_Option($n(remappingFunction).apply__O__O(previousValue));
  var x1 = $ct_T2__O__O__(new $c_T2(), previousValue, nextValue);
  matchEnd15: {
    var p2 = $as_s_Option(x1.T2__f__1);
    var p3 = $as_s_Option(x1.T2__f__2);
    var x = $m_s_None$();
    if ((x === p2)) {
      var x$3 = $m_s_None$();
      var $$x1 = (x$3 === p3)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      break matchEnd15
    };
    var p6 = $as_s_Option(x1.T2__f__1);
    var p7 = $as_s_Option(x1.T2__f__2);
    if ((p6 instanceof $c_s_Some)) {
      var x$5 = $m_s_None$();
      var $$x2 = (x$5 === p7)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      $thiz.remove__O__s_Option(key);
      break matchEnd15
    };
    var p12 = $as_s_Option(x1.T2__f__2);
    if ((p12 instanceof $c_s_Some)) {
      var x13 = $as_s_Some(p12);
      var v = $n(x13).s_Some__f_value;
      $thiz.update__O__O__V(key, v);
      break matchEnd15
    };
    throw new $c_s_MatchError(x1)
  };
  return nextValue
}
function $f_scm_MapOps__getOrElseUpdate__O__F0__O($thiz, key, op) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $n(x2).s_Some__f_value;
    return v
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var d = $n(op).apply__O();
      $thiz.update__O__O__V(key, d);
      return d
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
function $f_scm_MapOps__remove__O__s_Option($thiz, key) {
  var r = $thiz.get__O__s_Option(key);
  var this$1 = $n(r);
  if ((!this$1.isEmpty__Z())) {
    $thiz.subtractOne__O__scm_Shrinkable(key)
  };
  return r
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances$$anon$7(outer, E$1) {
  this.Lcats_data_ValidatedApplicative__f_evidence$10 = null;
  $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__(this, E$1)
}
$c_Lcats_data_ValidatedInstances$$anon$7.prototype = new $h_Lcats_data_ValidatedApplicative();
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.constructor = $c_Lcats_data_ValidatedInstances$$anon$7;
/** @constructor */
function $h_Lcats_data_ValidatedInstances$$anon$7() {
  /*<skip>*/
}
$h_Lcats_data_ValidatedInstances$$anon$7.prototype = $c_Lcats_data_ValidatedInstances$$anon$7.prototype;
var $d_Lcats_data_ValidatedInstances$$anon$7 = new $TypeData().initClass({
  Lcats_data_ValidatedInstances$$anon$7: 0
}, false, "cats.data.ValidatedInstances$$anon$7", {
  Lcats_data_ValidatedInstances$$anon$7: 1,
  Lcats_data_ValidatedApplicative: 1,
  O: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_Applicative: 1,
  Lcats_Apply: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_CommutativeApply: 1,
  Lcats_ApplicativeError: 1
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.$classData = $d_Lcats_data_ValidatedInstances$$anon$7;
/** @constructor */
function $c_Lcats_kernel_instances_DoubleGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DoubleGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleGroup.prototype.constructor = $c_Lcats_kernel_instances_DoubleGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DoubleGroup.prototype = $c_Lcats_kernel_instances_DoubleGroup.prototype;
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine$mcD$sp__D__D__D = (function(x, y) {
  return (x + y)
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.empty__O = (function() {
  return 0.0
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return this.combine$mcD$sp__D__D__D(x$1, y$1)
});
var $d_Lcats_kernel_instances_DoubleGroup = new $TypeData().initClass({
  Lcats_kernel_instances_DoubleGroup: 0
}, false, "cats.kernel.instances.DoubleGroup", {
  Lcats_kernel_instances_DoubleGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup$mcD$sp: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid$mcD$sp: 1,
  Lcats_kernel_CommutativeSemigroup$mcD$sp: 1,
  Lcats_kernel_Semigroup$mcD$sp: 1,
  Lcats_kernel_Monoid$mcD$sp: 1,
  Lcats_kernel_Group$mcD$sp: 1
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.$classData = $d_Lcats_kernel_instances_DoubleGroup;
/** @constructor */
function $c_Lcats_kernel_instances_FloatGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FloatGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatGroup.prototype.constructor = $c_Lcats_kernel_instances_FloatGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FloatGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FloatGroup.prototype = $c_Lcats_kernel_instances_FloatGroup.prototype;
$c_Lcats_kernel_instances_FloatGroup.prototype.combine$mcF$sp__F__F__F = (function(x, y) {
  return Math.fround((x + y))
});
$c_Lcats_kernel_instances_FloatGroup.prototype.empty__O = (function() {
  return 0.0
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return this.combine$mcF$sp__F__F__F(x$1, y$1)
});
var $d_Lcats_kernel_instances_FloatGroup = new $TypeData().initClass({
  Lcats_kernel_instances_FloatGroup: 0
}, false, "cats.kernel.instances.FloatGroup", {
  Lcats_kernel_instances_FloatGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup$mcF$sp: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid$mcF$sp: 1,
  Lcats_kernel_CommutativeSemigroup$mcF$sp: 1,
  Lcats_kernel_Semigroup$mcF$sp: 1,
  Lcats_kernel_Monoid$mcF$sp: 1,
  Lcats_kernel_Group$mcF$sp: 1
});
$c_Lcats_kernel_instances_FloatGroup.prototype.$classData = $d_Lcats_kernel_instances_FloatGroup;
/** @constructor */
function $c_Lcats_kernel_instances_IntGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_IntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_IntGroup.prototype.constructor = $c_Lcats_kernel_instances_IntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_IntGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_IntGroup.prototype = $c_Lcats_kernel_instances_IntGroup.prototype;
$c_Lcats_kernel_instances_IntGroup.prototype.combine$mcI$sp__I__I__I = (function(x, y) {
  return ((x + y) | 0)
});
$c_Lcats_kernel_instances_IntGroup.prototype.empty__O = (function() {
  return 0
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return this.combine$mcI$sp__I__I__I(x$1, y$1)
});
var $d_Lcats_kernel_instances_IntGroup = new $TypeData().initClass({
  Lcats_kernel_instances_IntGroup: 0
}, false, "cats.kernel.instances.IntGroup", {
  Lcats_kernel_instances_IntGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup$mcI$sp: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid$mcI$sp: 1,
  Lcats_kernel_CommutativeSemigroup$mcI$sp: 1,
  Lcats_kernel_Semigroup$mcI$sp: 1,
  Lcats_kernel_Monoid$mcI$sp: 1,
  Lcats_kernel_Group$mcI$sp: 1
});
$c_Lcats_kernel_instances_IntGroup.prototype.$classData = $d_Lcats_kernel_instances_IntGroup;
/** @constructor */
function $c_Lcats_kernel_instances_LongGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_LongGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_LongGroup.prototype.constructor = $c_Lcats_kernel_instances_LongGroup;
/** @constructor */
function $h_Lcats_kernel_instances_LongGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_LongGroup.prototype = $c_Lcats_kernel_instances_LongGroup.prototype;
$c_Lcats_kernel_instances_LongGroup.prototype.combine$mcJ$sp__J__J__J = (function(x, y) {
  var alo = x.RTLong__f_lo;
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  var lo = ((alo + y.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  return new $c_RTLong(lo, hi)
});
$c_Lcats_kernel_instances_LongGroup.prototype.empty__O = (function() {
  return $L0
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return this.combine$mcJ$sp__J__J__J(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1))
});
var $d_Lcats_kernel_instances_LongGroup = new $TypeData().initClass({
  Lcats_kernel_instances_LongGroup: 0
}, false, "cats.kernel.instances.LongGroup", {
  Lcats_kernel_instances_LongGroup: 1,
  O: 1,
  Lcats_kernel_CommutativeGroup$mcJ$sp: 1,
  Lcats_kernel_CommutativeGroup: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Semigroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid$mcJ$sp: 1,
  Lcats_kernel_CommutativeSemigroup$mcJ$sp: 1,
  Lcats_kernel_Semigroup$mcJ$sp: 1,
  Lcats_kernel_Monoid$mcJ$sp: 1,
  Lcats_kernel_Group$mcJ$sp: 1
});
$c_Lcats_kernel_instances_LongGroup.prototype.$classData = $d_Lcats_kernel_instances_LongGroup;
/** @constructor */
function $c_Lio_circe_KeyDecoder$$anon$8() {
  /*<skip>*/
}
$c_Lio_circe_KeyDecoder$$anon$8.prototype = new $h_O();
$c_Lio_circe_KeyDecoder$$anon$8.prototype.constructor = $c_Lio_circe_KeyDecoder$$anon$8;
/** @constructor */
function $h_Lio_circe_KeyDecoder$$anon$8() {
  /*<skip>*/
}
$h_Lio_circe_KeyDecoder$$anon$8.prototype = $c_Lio_circe_KeyDecoder$$anon$8.prototype;
$c_Lio_circe_KeyDecoder$$anon$8.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lio_circe_KeyDecoder$$anon$8.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lio_circe_KeyDecoder$$anon$8.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lio_circe_KeyDecoder(fa);
  var this$1 = $n(fa$1);
  return new $c_Lio_circe_KeyDecoder$$anon$1(this$1, f)
});
$c_Lio_circe_KeyDecoder$$anon$8.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_KeyDecoder(fa);
  var this$1 = $n(fa$1);
  return new $c_Lio_circe_KeyDecoder$$anon$2(this$1, f)
});
$c_Lio_circe_KeyDecoder$$anon$8.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_KeyDecoder(fa);
  var this$1 = $n(fa$1);
  return new $c_Lio_circe_KeyDecoder$$anon$1(this$1, f)
});
var $d_Lio_circe_KeyDecoder$$anon$8 = new $TypeData().initClass({
  Lio_circe_KeyDecoder$$anon$8: 0
}, false, "io.circe.KeyDecoder$$anon$8", {
  Lio_circe_KeyDecoder$$anon$8: 1,
  O: 1,
  Lcats_MonadError: 1,
  Lcats_ApplicativeError: 1,
  Lcats_Applicative: 1,
  Lcats_Apply: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1
});
$c_Lio_circe_KeyDecoder$$anon$8.prototype.$classData = $d_Lio_circe_KeyDecoder$$anon$8;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Js$$anon$3(r$2) {
  this.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_ft = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_at = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw = null;
  var $$x1 = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  $ct_Ljapgolly_scalajs_react_component_Template$MountedWithRoot__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, $$x1, this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async);
  this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw = r$2
}
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype = new $h_Ljapgolly_scalajs_react_component_Template$MountedWithRoot();
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Js$$anon$3;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Js$$anon$3() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype = $c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype;
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.F__Ljapgolly_scalajs_react_util_Effect$UnsafeSync = (function() {
  return $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync()
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.A__Ljapgolly_scalajs_react_util_Effect$Async = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.raw__Ljapgolly_scalajs_react_facade_React$Component = (function() {
  return this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.props__sjs_js_Object = (function() {
  return this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw.props
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.propsChildren__sjs_js_Any = (function() {
  return $m_Ljapgolly_scalajs_react_PropsChildren$().fromRawProps__sjs_js_Object__sjs_js_Any(this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw.props)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.state__sjs_js_Object = (function() {
  return this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw.state
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.getDOMNode__Ljapgolly_scalajs_react_ComponentDom = (function() {
  var $$x1 = $m_Ljapgolly_scalajs_react_ComponentDom$();
  var a = this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw;
  return $n($$x1).findDOMNode__sjs_js_$bar__Ljapgolly_scalajs_react_ComponentDom(a)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.setState__sjs_js_Object__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(state, callback, G) {
  this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw.setState(state, $n(G).dispatchFn__F0__sjs_js_Function0(callback))
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(mod, callback, G) {
  var jsFn1 = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(mod);
  this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw.setState(jsFn1, $n(G).dispatchFn__F0__sjs_js_Function0(callback))
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(mod, callback, G) {
  var jsFn1 = $m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(mod);
  this.Ljapgolly_scalajs_react_component_Js$$anon$3__f_raw.setState(jsFn1, $n(G).dispatchFn__F0__sjs_js_Function0(callback))
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(state, callback, G) {
  var this$1 = $n(state);
  this.setState__sjs_js_Object__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V((this$1.isEmpty__Z() ? null : this$1.get__O()), callback, G)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(mod, callback, G) {
  this.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var this$2 = $n($as_s_Option($n(mod).apply__O__O(x$1$2)));
    return (this$2.isEmpty__Z() ? null : this$2.get__O())
  })), callback, G)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot = (function(mp, ls, ft, at) {
  return new $c_Ljapgolly_scalajs_react_component_Js$$anon$4(this, mp, ls, ft, at)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  this.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  this.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  this.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  this.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  this.setState__sjs_js_Object__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.getDOMNode__O = (function() {
  return this.getDOMNode__Ljapgolly_scalajs_react_ComponentDom()
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.state__O = (function() {
  return this.state__sjs_js_Object()
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.propsChildren__O = (function() {
  return new $c_Ljapgolly_scalajs_react_PropsChildren(this.propsChildren__sjs_js_Any())
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.props__O = (function() {
  return this.props__sjs_js_Object()
});
var $d_Ljapgolly_scalajs_react_component_Js$$anon$3 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_Js$$anon$3: 0
}, false, "japgolly.scalajs.react.component.Js$$anon$3", {
  Ljapgolly_scalajs_react_component_Js$$anon$3: 1,
  Ljapgolly_scalajs_react_component_Template$MountedWithRoot: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedRaw: 1,
  Ljapgolly_scalajs_react_StateAccess: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1,
  Ljapgolly_scalajs_react_component_Js$MountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Js$MountedSimple: 1
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$3.prototype.$classData = $d_Ljapgolly_scalajs_react_component_Js$$anon$3;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Js$$anon$4(from$2, mp$2, ls$1, ft$1, at$1) {
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_mp = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_at = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$4__f_raw = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$4__f_from$2 = null;
  this.Ljapgolly_scalajs_react_component_Js$$anon$4__f_from$2 = from$2;
  $ct_Ljapgolly_scalajs_react_component_Template$MountedMapped__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, from$2, mp$2, ls$1, ft$1, at$1);
  this.Ljapgolly_scalajs_react_component_Js$$anon$4__f_raw = $n(from$2).raw__Ljapgolly_scalajs_react_facade_React$Component()
}
$c_Ljapgolly_scalajs_react_component_Js$$anon$4.prototype = new $h_Ljapgolly_scalajs_react_component_Template$MountedMapped();
$c_Ljapgolly_scalajs_react_component_Js$$anon$4.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Js$$anon$4;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Js$$anon$4() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Js$$anon$4.prototype = $c_Ljapgolly_scalajs_react_component_Js$$anon$4.prototype;
$c_Ljapgolly_scalajs_react_component_Js$$anon$4.prototype.raw__Ljapgolly_scalajs_react_facade_React$Component = (function() {
  return this.Ljapgolly_scalajs_react_component_Js$$anon$4__f_raw
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$4.prototype.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Js$MountedWithRoot = (function(mp, ls, ft, at) {
  var from = this.Ljapgolly_scalajs_react_component_Js$$anon$4__f_from$2;
  return new $c_Ljapgolly_scalajs_react_component_Js$$anon$4(from, mp, ls, ft, at)
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$4.prototype.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot = (function(mp, ls, ft, at) {
  return this.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Js$MountedWithRoot(mp, ls, ft, at)
});
var $d_Ljapgolly_scalajs_react_component_Js$$anon$4 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_Js$$anon$4: 0
}, false, "japgolly.scalajs.react.component.Js$$anon$4", {
  Ljapgolly_scalajs_react_component_Js$$anon$4: 1,
  Ljapgolly_scalajs_react_component_Template$MountedMapped: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedRaw: 1,
  Ljapgolly_scalajs_react_StateAccess: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1,
  Ljapgolly_scalajs_react_component_Js$MountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Js$MountedSimple: 1
});
$c_Ljapgolly_scalajs_react_component_Js$$anon$4.prototype.$classData = $d_Ljapgolly_scalajs_react_component_Js$$anon$4;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Scala$$anon$1(x$1) {
  this.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_ft = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedWithRoot__f_at = null;
  this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_js = null;
  this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_raw = null;
  this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1 = null;
  this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1 = x$1;
  var $$x1 = $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync();
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  $ct_Ljapgolly_scalajs_react_component_Template$MountedWithRoot__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, $$x1, this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async);
  this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_js = x$1;
  this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_raw = $n(x$1).raw__Ljapgolly_scalajs_react_facade_React$Component()
}
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype = new $h_Ljapgolly_scalajs_react_component_Template$MountedWithRoot();
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Scala$$anon$1;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Scala$$anon$1() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype = $c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype;
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.F__Ljapgolly_scalajs_react_util_Effect$UnsafeSync = (function() {
  return $m_Ljapgolly_scalajs_react_util_Effect$UnsafeSync$().id__Ljapgolly_scalajs_react_util_Effect$UnsafeSync()
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.A__Ljapgolly_scalajs_react_util_Effect$Async = (function() {
  var this$1 = $m_Ljapgolly_scalajs_react_util_DefaultEffects$();
  return this$1.Ljapgolly_scalajs_react_util_DefaultEffects$__f_Async
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.js__Ljapgolly_scalajs_react_component_Js$MountedWithRoot = (function() {
  return this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_js
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.raw__Ljapgolly_scalajs_react_facade_React$Component = (function() {
  return this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_raw
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.props__O = (function() {
  return $n(this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1).props__O().a
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.propsChildren__sjs_js_Any = (function() {
  return $n($as_Ljapgolly_scalajs_react_PropsChildren($n(this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1).propsChildren__O())).Ljapgolly_scalajs_react_PropsChildren__f_japgolly$scalajs$react$PropsChildren$$self
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.state__O = (function() {
  return $n(this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1).state__O().a
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.getDOMNode__Ljapgolly_scalajs_react_ComponentDom = (function() {
  return $as_Ljapgolly_scalajs_react_ComponentDom($n(this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1).getDOMNode__O())
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(newState, callback, G) {
  var $$x1 = $n(this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1);
  $m_Ljapgolly_scalajs_react_internal_Box$();
  var array = [$ct_T2__O__O__(new $c_T2(), "a", newState)];
  var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  $n($$x1).setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields), callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(mod, callback, G) {
  $n(this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1).modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var value = $n(mod).apply__O__O(s$2.a);
    var array = [$ct_T2__O__O__(new $c_T2(), "a", value)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  })), callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(mod, callback, G) {
  $n(this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1).modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction2(((s$2, p$2) => {
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var value = $n(mod).apply__O__O__O(s$2.a, p$2.a);
    var array = [$ct_T2__O__O__(new $c_T2(), "a", value)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  })), callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(o, callback, G) {
  var $$x2 = $n(this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1);
  var this$1 = $n(o);
  if (this$1.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    $m_Ljapgolly_scalajs_react_internal_Box$();
    var array = [$ct_T2__O__O__(new $c_T2(), "a", arg1)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var $$x1 = new $c_s_Some($m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields))
  };
  $n($$x2).setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O($$x1, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V = (function(mod, callback, G) {
  $n(this.Ljapgolly_scalajs_react_component_Scala$$anon$1__f_x$1).modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O(new $c_sjsr_AnonFunction1(((s$2) => {
    var this$2 = $n($as_s_Option($n(mod).apply__O__O(s$2.a)));
    if (this$2.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = this$2.get__O();
      $m_Ljapgolly_scalajs_react_internal_Box$();
      var array = [$ct_T2__O__O__(new $c_T2(), "a", arg1)];
      var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      return new $c_s_Some($m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields))
    }
  })), callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot = (function(mp, ls, ft, at) {
  return new $c_Ljapgolly_scalajs_react_component_Scala$$anon$2(this, mp, ls, ft, at)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  this.modStateOption__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  this.setStateOption__s_Option__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  this.modState__F2__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(mod, callback, G) {
  this.modState__F1__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(mod, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__O = (function(newState, callback, G) {
  this.setState__O__F0__Ljapgolly_scalajs_react_util_Effect$Dispatch__V(newState, callback, G)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.getDOMNode__O = (function() {
  return this.getDOMNode__Ljapgolly_scalajs_react_ComponentDom()
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.propsChildren__O = (function() {
  return new $c_Ljapgolly_scalajs_react_PropsChildren(this.propsChildren__sjs_js_Any())
});
var $d_Ljapgolly_scalajs_react_component_Scala$$anon$1 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_Scala$$anon$1: 0
}, false, "japgolly.scalajs.react.component.Scala$$anon$1", {
  Ljapgolly_scalajs_react_component_Scala$$anon$1: 1,
  Ljapgolly_scalajs_react_component_Template$MountedWithRoot: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedRaw: 1,
  Ljapgolly_scalajs_react_StateAccess: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1,
  Ljapgolly_scalajs_react_component_Scala$MountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Scala$MountedSimple: 1
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$1.prototype.$classData = $d_Ljapgolly_scalajs_react_component_Scala$$anon$1;
/** @constructor */
function $c_Ljapgolly_scalajs_react_component_Scala$$anon$2(from$1, mp$1, ls$1, ft$1, at$1) {
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_from = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_mp = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ls = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_ft = null;
  this.Ljapgolly_scalajs_react_component_Template$MountedMapped__f_at = null;
  this.Ljapgolly_scalajs_react_component_Scala$$anon$2__f_js = null;
  this.Ljapgolly_scalajs_react_component_Scala$$anon$2__f_raw = null;
  this.Ljapgolly_scalajs_react_component_Scala$$anon$2__f_from$1 = null;
  this.Ljapgolly_scalajs_react_component_Scala$$anon$2__f_from$1 = from$1;
  $ct_Ljapgolly_scalajs_react_component_Template$MountedMapped__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__(this, from$1, mp$1, ls$1, ft$1, at$1);
  this.Ljapgolly_scalajs_react_component_Scala$$anon$2__f_js = $n(from$1).js__Ljapgolly_scalajs_react_component_Js$MountedWithRoot();
  this.Ljapgolly_scalajs_react_component_Scala$$anon$2__f_raw = $n(from$1).raw__Ljapgolly_scalajs_react_facade_React$Component()
}
$c_Ljapgolly_scalajs_react_component_Scala$$anon$2.prototype = new $h_Ljapgolly_scalajs_react_component_Template$MountedMapped();
$c_Ljapgolly_scalajs_react_component_Scala$$anon$2.prototype.constructor = $c_Ljapgolly_scalajs_react_component_Scala$$anon$2;
/** @constructor */
function $h_Ljapgolly_scalajs_react_component_Scala$$anon$2() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_component_Scala$$anon$2.prototype = $c_Ljapgolly_scalajs_react_component_Scala$$anon$2.prototype;
$c_Ljapgolly_scalajs_react_component_Scala$$anon$2.prototype.js__Ljapgolly_scalajs_react_component_Js$MountedWithRoot = (function() {
  return this.Ljapgolly_scalajs_react_component_Scala$$anon$2__f_js
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$2.prototype.raw__Ljapgolly_scalajs_react_facade_React$Component = (function() {
  return this.Ljapgolly_scalajs_react_component_Scala$$anon$2__f_raw
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$2.prototype.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot = (function(mp, ls, ft, at) {
  var from = this.Ljapgolly_scalajs_react_component_Scala$$anon$2__f_from$1;
  return new $c_Ljapgolly_scalajs_react_component_Scala$$anon$2(from, mp, ls, ft, at)
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$2.prototype.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Generic$MountedWithRoot = (function(mp, ls, ft, at) {
  return this.mapped__F1__Ljapgolly_scalajs_react_internal_Lens__Ljapgolly_scalajs_react_util_Effect$UnsafeSync__Ljapgolly_scalajs_react_util_Effect$Async__Ljapgolly_scalajs_react_component_Scala$MountedWithRoot(mp, ls, ft, at)
});
var $d_Ljapgolly_scalajs_react_component_Scala$$anon$2 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_component_Scala$$anon$2: 0
}, false, "japgolly.scalajs.react.component.Scala$$anon$2", {
  Ljapgolly_scalajs_react_component_Scala$$anon$2: 1,
  Ljapgolly_scalajs_react_component_Template$MountedMapped: 1,
  O: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedSimple: 1,
  Ljapgolly_scalajs_react_component_Generic$MountedRaw: 1,
  Ljapgolly_scalajs_react_StateAccess: 1,
  Ljapgolly_scalajs_react_StateAccess$Write: 1,
  Ljapgolly_scalajs_react_StateAccess$SetState: 1,
  Ljapgolly_scalajs_react_StateAccess$Base: 1,
  Ljapgolly_scalajs_react_StateAccess$ModState: 1,
  Ljapgolly_scalajs_react_StateAccess$WriteWithProps: 1,
  Ljapgolly_scalajs_react_StateAccess$ModStateWithProps: 1,
  Ljapgolly_scalajs_react_component_Scala$MountedWithRoot: 1,
  Ljapgolly_scalajs_react_component_Scala$MountedSimple: 1
});
$c_Ljapgolly_scalajs_react_component_Scala$$anon$2.prototype.$classData = $d_Ljapgolly_scalajs_react_component_Scala$$anon$2;
/** @constructor */
function $c_Ljapgolly_scalajs_react_hooks_HookCtx$P13(props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10, hook11, hook12, hook13) {
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P12__f_hook12 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P13__f_hook13 = null;
  this.Ljapgolly_scalajs_react_hooks_HookCtx$P13__f_hook13 = hook13;
  $ct_Ljapgolly_scalajs_react_hooks_HookCtx$P12__O__O__O__O__O__O__O__O__O__O__O__O__O__(this, props, hook1, hook2, hook3, hook4, hook5, hook6, hook7, hook8, hook9, hook10, hook11, hook12)
}
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P13.prototype = new $h_Ljapgolly_scalajs_react_hooks_HookCtx$P12();
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P13.prototype.constructor = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P13;
/** @constructor */
function $h_Ljapgolly_scalajs_react_hooks_HookCtx$P13() {
  /*<skip>*/
}
$h_Ljapgolly_scalajs_react_hooks_HookCtx$P13.prototype = $c_Ljapgolly_scalajs_react_hooks_HookCtx$P13.prototype;
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P13.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((("HookCtx(\n  props = " + this.Ljapgolly_scalajs_react_hooks_HookCtx$P0__f_props) + ",\n  hook1 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P1__f_hook1) + ",\n  hook2 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P2__f_hook2) + ",\n  hook3 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P3__f_hook3) + ",\n  hook4 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P4__f_hook4) + ",\n  hook5 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P5__f_hook5) + ",\n  hook6 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P6__f_hook6) + ",\n  hook7 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P7__f_hook7) + ",\n  hook8 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P8__f_hook8) + ",\n  hook9 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P9__f_hook9) + ",\n  hook10 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P10__f_hook10) + ",\n  hook11 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P11__f_hook11) + ",\n  hook12 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P12__f_hook12) + ",\n  hook13 = ") + this.Ljapgolly_scalajs_react_hooks_HookCtx$P13__f_hook13) + ")")
});
var $d_Ljapgolly_scalajs_react_hooks_HookCtx$P13 = new $TypeData().initClass({
  Ljapgolly_scalajs_react_hooks_HookCtx$P13: 0
}, false, "japgolly.scalajs.react.hooks.HookCtx$P13", {
  Ljapgolly_scalajs_react_hooks_HookCtx$P13: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P12: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P11: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P10: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P9: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P8: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P7: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P6: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P5: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P4: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P3: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P2: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P1: 1,
  Ljapgolly_scalajs_react_hooks_HookCtx$P0: 1,
  O: 1
});
$c_Ljapgolly_scalajs_react_hooks_HookCtx$P13.prototype.$classData = $d_Ljapgolly_scalajs_react_hooks_HookCtx$P13;
/** @constructor */
function $c_sc_AbstractMapView() {
  /*<skip>*/
}
$c_sc_AbstractMapView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractMapView.prototype.constructor = $c_sc_AbstractMapView;
/** @constructor */
function $h_sc_AbstractMapView() {
  /*<skip>*/
}
$h_sc_AbstractMapView.prototype = $c_sc_AbstractMapView.prototype;
$c_sc_AbstractMapView.prototype.values__sc_Iterable = (function() {
  return new $c_sc_MapView$Values(this)
});
$c_sc_AbstractMapView.prototype.filter__F1__sc_MapView = (function(pred) {
  return new $c_sc_MapView$Filter(this, false, pred)
});
$c_sc_AbstractMapView.prototype.filterNot__F1__sc_MapView = (function(pred) {
  return new $c_sc_MapView$Filter(this, true, pred)
});
$c_sc_AbstractMapView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_AbstractMapView.prototype.stringPrefix__T = (function() {
  return "MapView"
});
$c_sc_AbstractMapView.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
});
$c_sc_AbstractMapView.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key)
});
$c_sc_AbstractMapView.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractMapView.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$2(this)
});
$c_sc_AbstractMapView.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this)
});
$c_sc_AbstractMapView.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key)
});
$c_sc_AbstractMapView.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key)
});
$c_sc_AbstractMapView.prototype.isDefinedAt__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key)
});
$c_sc_AbstractMapView.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f)
});
$c_sc_AbstractMapView.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end)
});
$c_sc_AbstractMapView.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that)
});
$c_sc_AbstractMapView.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sc_AbstractMapView.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this)
});
$c_sc_AbstractMapView.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action)
});
$c_sc_AbstractMapView.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($f_sc_MapOps__apply__O__O(this, v1))
});
$c_sc_AbstractMapView.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sc_AbstractMapView.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sc_AbstractMapView.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_MapOps$WithFilter__sc_MapOps__F1__(new $c_sc_MapOps$WithFilter(), this, p)
});
$c_sc_AbstractMapView.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sc_MapView$()
});
$c_sc_AbstractMapView.prototype.filterNot__F1__O = (function(pred) {
  return this.filterNot__F1__sc_MapView(pred)
});
$c_sc_AbstractMapView.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sc_MapView(pred)
});
function $f_sci_Map__withDefaultValue__O__sci_Map($thiz, d) {
  return $ct_sci_Map$WithDefault__sci_Map__F1__(new $c_sci_Map$WithDefault(), $thiz, new $c_sjsr_AnonFunction1(((x$1$2) => d)))
}
function $is_sci_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Map)))
}
function $as_sci_Map(obj) {
  return (($is_sci_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map"))
}
function $isArrayOf_sci_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map)))
}
function $asArrayOf_sci_Map(obj, depth) {
  return (($isArrayOf_sci_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map;", depth))
}
var $d_sci_Map = new $TypeData().initClass({
  sci_Map: 0
}, true, "scala.collection.immutable.Map", {
  sci_Map: 1,
  O: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_MapOps: 1
});
/** @constructor */
function $c_Lcats_instances_Function0Instances$$anon$4(outer) {
  /*<skip>*/
}
$c_Lcats_instances_Function0Instances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_Function0Instances$$anon$4.prototype.constructor = $c_Lcats_instances_Function0Instances$$anon$4;
/** @constructor */
function $h_Lcats_instances_Function0Instances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_Function0Instances$$anon$4.prototype = $c_Lcats_instances_Function0Instances$$anon$4.prototype;
$c_Lcats_instances_Function0Instances$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__F0__F1__F0($as_F0(fa), f)
});
$c_Lcats_instances_Function0Instances$$anon$4.prototype.map__F0__F1__F0 = (function(fa, fn) {
  return new $c_sjsr_AnonFunction0((() => $n(fn).apply__O__O($n(fa).apply__O())))
});
$c_Lcats_instances_Function0Instances$$anon$4.prototype.map2__F0__F0__F2__F0 = (function(fa, fb, fn) {
  return new $c_sjsr_AnonFunction0((() => $n(fn).apply__O__O__O($n(fa).apply__O(), $n(fb).apply__O())))
});
$c_Lcats_instances_Function0Instances$$anon$4.prototype.product__F0__F0__F0 = (function(fa, fb) {
  return new $c_sjsr_AnonFunction0((() => $ct_T2__O__O__(new $c_T2(), $n(fa).apply__O(), $n(fb).apply__O())))
});
$c_Lcats_instances_Function0Instances$$anon$4.prototype.flatMap__F0__F1__F0 = (function(fa, f) {
  return new $c_sjsr_AnonFunction0((() => $n($as_F0($n(f).apply__O__O($n(fa).apply__O()))).apply__O()))
});
$c_Lcats_instances_Function0Instances$$anon$4.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.flatMap__F0__F1__F0($as_F0(fa), f)
});
$c_Lcats_instances_Function0Instances$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__F0__F0__F0($as_F0(fa), $as_F0(fb))
});
$c_Lcats_instances_Function0Instances$$anon$4.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__F0__F0__F2__F0($as_F0(fa), $as_F0(fb), f)
});
$c_Lcats_instances_Function0Instances$$anon$4.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__F0__F1__F0($as_F0(fa), f)
});
var $d_Lcats_instances_Function0Instances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_Function0Instances$$anon$4: 0
}, false, "cats.instances.Function0Instances$$anon$4", {
  Lcats_instances_Function0Instances$$anon$4: 1,
  O: 1,
  Lcats_Bimonad: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_Apply: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Applicative: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Comonad: 1,
  Lcats_CoflatMap: 1
});
$c_Lcats_instances_Function0Instances$$anon$4.prototype.$classData = $d_Lcats_instances_Function0Instances$$anon$4;
/** @constructor */
function $c_Lcats_kernel_instances_ByteOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ByteOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteOrder.prototype.constructor = $c_Lcats_kernel_instances_ByteOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ByteOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ByteOrder.prototype = $c_Lcats_kernel_instances_ByteOrder.prototype;
$c_Lcats_kernel_instances_ByteOrder.prototype.compare$mcB$sp__B__B__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv$mcB$sp__B__B__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.neqv$mcB$sp__B__B__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_Lcats_kernel_Order$mcB$sp__partialCompare$mcB$sp__B__B__D(this, x$1, y$1)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.neqv__O__O__Z = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return this.neqv$mcB$sp__B__B__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return this.eqv$mcB$sp__B__B__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return this.compare$mcB$sp__B__B__I(x$1, y$1)
});
var $d_Lcats_kernel_instances_ByteOrder = new $TypeData().initClass({
  Lcats_kernel_instances_ByteOrder: 0
}, false, "cats.kernel.instances.ByteOrder", {
  Lcats_kernel_instances_ByteOrder: 1,
  O: 1,
  Lcats_kernel_Order$mcB$sp: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_PartialOrder$mcB$sp: 1,
  Lcats_kernel_Eq$mcB$sp: 1,
  Lcats_kernel_Hash$mcB$sp: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_ByteBounded: 1,
  Lcats_kernel_LowerBounded$mcB$sp: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded$mcB$sp: 1,
  Lcats_kernel_UpperBounded: 1
});
$c_Lcats_kernel_instances_ByteOrder.prototype.$classData = $d_Lcats_kernel_instances_ByteOrder;
/** @constructor */
function $c_Lio_circe_Decoder$$anon$77() {
  /*<skip>*/
}
$c_Lio_circe_Decoder$$anon$77.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$77.prototype.constructor = $c_Lio_circe_Decoder$$anon$77;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$77() {
  /*<skip>*/
}
$h_Lio_circe_Decoder$$anon$77.prototype = $c_Lio_circe_Decoder$$anon$77.prototype;
$c_Lio_circe_Decoder$$anon$77.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lio_circe_Decoder$$anon$77.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lio_circe_Decoder(fa);
  var this$1 = $n(fa$1);
  return new $c_Lio_circe_Decoder$$anon$1(this$1, f)
});
$c_Lio_circe_Decoder$$anon$77.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this)
});
$c_Lio_circe_Decoder$$anon$77.prototype.combineK__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder = (function(x, y) {
  var this$2 = $n(x);
  var d = new $c_sjsr_AnonFunction0((() => y));
  return new $c_Lio_circe_Decoder$$anon$9(this$2, d)
});
$c_Lio_circe_Decoder$$anon$77.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_Decoder(fa);
  var this$1 = $n(fa$1);
  return new $c_Lio_circe_Decoder$$anon$2(this$1, f)
});
$c_Lio_circe_Decoder$$anon$77.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lio_circe_Decoder(fa);
  var fb$1 = $as_Lio_circe_Decoder(fb);
  var this$1 = $n(fa$1);
  return new $c_Lio_circe_Decoder$$anon$8(this$1, fb$1)
});
$c_Lio_circe_Decoder$$anon$77.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lio_circe_Decoder(fa);
  var this$1 = $n(fa$1);
  return new $c_Lio_circe_Decoder$$anon$1(this$1, f)
});
$c_Lio_circe_Decoder$$anon$77.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($as_Lio_circe_Decoder(x), $as_Lio_circe_Decoder(y))
});
var $d_Lio_circe_Decoder$$anon$77 = new $TypeData().initClass({
  Lio_circe_Decoder$$anon$77: 0
}, false, "io.circe.Decoder$$anon$77", {
  Lio_circe_Decoder$$anon$77: 1,
  O: 1,
  Lcats_SemigroupK: 1,
  Ljava_io_Serializable: 1,
  Lcats_MonadError: 1,
  Lcats_ApplicativeError: 1,
  Lcats_Applicative: 1,
  Lcats_Apply: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1
});
$c_Lio_circe_Decoder$$anon$77.prototype.$classData = $d_Lio_circe_Decoder$$anon$77;
/** @constructor */
function $c_sc_AbstractIndexedSeqView() {
  /*<skip>*/
}
$c_sc_AbstractIndexedSeqView.prototype = new $h_sc_AbstractSeqView();
$c_sc_AbstractIndexedSeqView.prototype.constructor = $c_sc_AbstractIndexedSeqView;
/** @constructor */
function $h_sc_AbstractIndexedSeqView() {
  /*<skip>*/
}
$h_sc_AbstractIndexedSeqView.prototype = $c_sc_AbstractIndexedSeqView.prototype;
$c_sc_AbstractIndexedSeqView.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_AbstractIndexedSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_AbstractIndexedSeqView.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_AbstractIndexedSeqView.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_AbstractIndexedSeqView.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_AbstractIndexedSeqView.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_AbstractIndexedSeqView.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_AbstractIndexedSeqView.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_AbstractIndexedSeqView.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sc_AbstractIndexedSeqView.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sc_AbstractIndexedSeqView.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sc_AbstractIndexedSeqView.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_AbstractIndexedSeqView.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_AbstractIndexedSeqView.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_AbstractIndexedSeqView.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_AbstractIndexedSeqView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_AbstractIndexedSeqView.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_AbstractIndexedSeqView.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_AbstractIndexedSeqView.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_AbstractIndexedSeqView.prototype.view__sc_SeqView = (function() {
  return this
});
function $is_sc_BitSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSet)))
}
function $as_sc_BitSet(obj) {
  return (($is_sc_BitSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSet"))
}
function $isArrayOf_sc_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSet)))
}
function $asArrayOf_sc_BitSet(obj, depth) {
  return (($isArrayOf_sc_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSet;", depth))
}
/** @constructor */
function $c_sc_MapOps$KeySet(outer) {
  this.sc_MapOps$KeySet__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sc_MapOps$KeySet__f_$outer = outer
  }
}
$c_sc_MapOps$KeySet.prototype = new $h_sc_AbstractSet();
$c_sc_MapOps$KeySet.prototype.constructor = $c_sc_MapOps$KeySet;
/** @constructor */
function $h_sc_MapOps$KeySet() {
  /*<skip>*/
}
$h_sc_MapOps$KeySet.prototype = $c_sc_MapOps$KeySet.prototype;
$c_sc_MapOps$KeySet.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_MapOps$KeySet__f_$outer).keysIterator__sc_Iterator()
});
$c_sc_MapOps$KeySet.prototype.contains__O__Z = (function(key) {
  return $n(this.sc_MapOps$KeySet__f_$outer).contains__O__Z(key)
});
$c_sc_MapOps$KeySet.prototype.size__I = (function() {
  return $n(this.sc_MapOps$KeySet__f_$outer).size__I()
});
$c_sc_MapOps$KeySet.prototype.knownSize__I = (function() {
  return $n(this.sc_MapOps$KeySet__f_$outer).knownSize__I()
});
$c_sc_MapOps$KeySet.prototype.isEmpty__Z = (function() {
  return $n(this.sc_MapOps$KeySet__f_$outer).isEmpty__Z()
});
var $d_sc_MapOps$KeySet = new $TypeData().initClass({
  sc_MapOps$KeySet: 0
}, false, "scala.collection.MapOps$KeySet", {
  sc_MapOps$KeySet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sc_MapOps$KeySet.prototype.$classData = $d_sc_MapOps$KeySet;
/** @constructor */
function $c_sc_MapView$$anon$1() {
  /*<skip>*/
}
$c_sc_MapView$$anon$1.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$$anon$1.prototype.constructor = $c_sc_MapView$$anon$1;
/** @constructor */
function $h_sc_MapView$$anon$1() {
  /*<skip>*/
}
$h_sc_MapView$$anon$1.prototype = $c_sc_MapView$$anon$1.prototype;
$c_sc_MapView$$anon$1.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$()
});
$c_sc_MapView$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sc_MapView$$anon$1.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_MapView$$anon$1.prototype.isEmpty__Z = (function() {
  return true
});
$c_sc_MapView$$anon$1.prototype.filter__F1__sc_MapView = (function(pred) {
  return this
});
$c_sc_MapView$$anon$1.prototype.filterNot__F1__sc_MapView = (function(pred) {
  return this
});
$c_sc_MapView$$anon$1.prototype.filterNot__F1__O = (function(pred) {
  return this
});
$c_sc_MapView$$anon$1.prototype.filter__F1__O = (function(pred) {
  return this
});
var $d_sc_MapView$$anon$1 = new $TypeData().initClass({
  sc_MapView$$anon$1: 0
}, false, "scala.collection.MapView$$anon$1", {
  sc_MapView$$anon$1: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$$anon$1.prototype.$classData = $d_sc_MapView$$anon$1;
/** @constructor */
function $c_sc_MapView$Filter(underlying, isFlipped, p) {
  this.sc_MapView$Filter__f_underlying = null;
  this.sc_MapView$Filter__f_isFlipped = false;
  this.sc_MapView$Filter__f_p = null;
  this.sc_MapView$Filter__f_underlying = underlying;
  this.sc_MapView$Filter__f_isFlipped = isFlipped;
  this.sc_MapView$Filter__f_p = p
}
$c_sc_MapView$Filter.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Filter.prototype.constructor = $c_sc_MapView$Filter;
/** @constructor */
function $h_sc_MapView$Filter() {
  /*<skip>*/
}
$h_sc_MapView$Filter.prototype = $c_sc_MapView$Filter.prototype;
$c_sc_MapView$Filter.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_MapView$Filter__f_underlying).iterator__sc_Iterator());
  var p = this.sc_MapView$Filter__f_p;
  var isFlipped = this.sc_MapView$Filter__f_isFlipped;
  return new $c_sc_Iterator$$anon$6(this$1, p, isFlipped)
});
$c_sc_MapView$Filter.prototype.get__O__s_Option = (function(key) {
  var x1 = $n(this.sc_MapView$Filter__f_underlying).get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $n(x2).s_Some__f_value;
    if (($uZ($n(this.sc_MapView$Filter__f_p).apply__O__O($ct_T2__O__O__(new $c_T2(), key, v))) !== this.sc_MapView$Filter__f_isFlipped)) {
      return x2
    }
  };
  return $m_s_None$()
});
$c_sc_MapView$Filter.prototype.knownSize__I = (function() {
  return (($n(this.sc_MapView$Filter__f_underlying).knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_MapView$Filter.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z())
});
var $d_sc_MapView$Filter = new $TypeData().initClass({
  sc_MapView$Filter: 0
}, false, "scala.collection.MapView$Filter", {
  sc_MapView$Filter: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$Filter.prototype.$classData = $d_sc_MapView$Filter;
/** @constructor */
function $c_sc_MapView$Id(underlying) {
  this.sc_MapView$Id__f_underlying = null;
  this.sc_MapView$Id__f_underlying = underlying
}
$c_sc_MapView$Id.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Id.prototype.constructor = $c_sc_MapView$Id;
/** @constructor */
function $h_sc_MapView$Id() {
  /*<skip>*/
}
$h_sc_MapView$Id.prototype = $c_sc_MapView$Id.prototype;
$c_sc_MapView$Id.prototype.get__O__s_Option = (function(key) {
  return $n(this.sc_MapView$Id__f_underlying).get__O__s_Option(key)
});
$c_sc_MapView$Id.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_MapView$Id__f_underlying).iterator__sc_Iterator()
});
$c_sc_MapView$Id.prototype.knownSize__I = (function() {
  return $n(this.sc_MapView$Id__f_underlying).knownSize__I()
});
$c_sc_MapView$Id.prototype.isEmpty__Z = (function() {
  return $n(this.sc_MapView$Id__f_underlying).isEmpty__Z()
});
var $d_sc_MapView$Id = new $TypeData().initClass({
  sc_MapView$Id: 0
}, false, "scala.collection.MapView$Id", {
  sc_MapView$Id: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$Id.prototype.$classData = $d_sc_MapView$Id;
/** @constructor */
function $c_sc_MapView$MapValues(underlying, f) {
  this.sc_MapView$MapValues__f_underlying = null;
  this.sc_MapView$MapValues__f_f = null;
  this.sc_MapView$MapValues__f_underlying = underlying;
  this.sc_MapView$MapValues__f_f = f
}
$c_sc_MapView$MapValues.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$MapValues.prototype.constructor = $c_sc_MapView$MapValues;
/** @constructor */
function $h_sc_MapView$MapValues() {
  /*<skip>*/
}
$h_sc_MapView$MapValues.prototype = $c_sc_MapView$MapValues.prototype;
$c_sc_MapView$MapValues.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($n(this.sc_MapView$MapValues__f_underlying).iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((kv$2) => {
    var kv = $as_T2(kv$2);
    return $ct_T2__O__O__(new $c_T2(), $n(kv)._1__O(), $n(this.sc_MapView$MapValues__f_f).apply__O__O($n(kv)._2__O()))
  }));
  return new $c_sc_Iterator$$anon$9(this$2, f)
});
$c_sc_MapView$MapValues.prototype.get__O__s_Option = (function(key) {
  var this$1 = $n($n(this.sc_MapView$MapValues__f_underlying).get__O__s_Option(key));
  var f = this.sc_MapView$MapValues__f_f;
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())))
});
$c_sc_MapView$MapValues.prototype.knownSize__I = (function() {
  return $n(this.sc_MapView$MapValues__f_underlying).knownSize__I()
});
$c_sc_MapView$MapValues.prototype.isEmpty__Z = (function() {
  return $n(this.sc_MapView$MapValues__f_underlying).isEmpty__Z()
});
var $d_sc_MapView$MapValues = new $TypeData().initClass({
  sc_MapView$MapValues: 0
}, false, "scala.collection.MapView$MapValues", {
  sc_MapView$MapValues: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$MapValues.prototype.$classData = $d_sc_MapView$MapValues;
function $f_sc_SortedMap__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true
  };
  if ($is_sc_SortedMap(that)) {
    var x2 = $as_sc_SortedMap(that);
    var x = $n(x2).ordering__s_math_Ordering();
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      if ((($n(x2), true) && ($thiz.size__I() === $n(x2).size__I()))) {
        var i1 = $thiz.iterator__sc_Iterator();
        var i2 = $n(x2).iterator__sc_Iterator();
        var allEqual = true;
        while ((allEqual && $n(i1).hasNext__Z())) {
          var kv1 = $as_T2($n(i1).next__O());
          var kv2 = $as_T2($n(i2).next__O());
          allEqual = ($n($thiz.ordering__s_math_Ordering()).equiv__O__O__Z($n(kv1)._1__O(), $n(kv2)._1__O()) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(kv1)._2__O(), $n(kv2)._2__O()))
        };
        return allEqual
      } else {
        return false
      }
    }
  };
  return $f_sc_Map__equals__O__Z($thiz, that)
}
function $is_sc_SortedMap(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SortedMap)))
}
function $as_sc_SortedMap(obj) {
  return (($is_sc_SortedMap(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SortedMap"))
}
function $isArrayOf_sc_SortedMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SortedMap)))
}
function $asArrayOf_sc_SortedMap(obj, depth) {
  return (($isArrayOf_sc_SortedMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SortedMap;", depth))
}
/** @constructor */
function $c_sci_AbstractSet() {
  /*<skip>*/
}
$c_sci_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_sci_AbstractSet.prototype.constructor = $c_sci_AbstractSet;
/** @constructor */
function $h_sci_AbstractSet() {
  /*<skip>*/
}
$h_sci_AbstractSet.prototype = $c_sci_AbstractSet.prototype;
$c_sci_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Set$()
});
$c_sci_AbstractSet.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps(this, that)
});
function $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__($thiz, underlying, elem) {
  $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Appended() {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
  this.sc_SeqView$Appended__f_underlying = null;
  this.sc_SeqView$Appended__f_elem = null
}
$c_sc_IndexedSeqView$Appended.prototype = new $h_sc_SeqView$Appended();
$c_sc_IndexedSeqView$Appended.prototype.constructor = $c_sc_IndexedSeqView$Appended;
/** @constructor */
function $h_sc_IndexedSeqView$Appended() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Appended.prototype = $c_sc_IndexedSeqView$Appended.prototype;
$c_sc_IndexedSeqView$Appended.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Appended.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Appended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_IndexedSeqView$Appended.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_IndexedSeqView$Appended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Appended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Appended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_IndexedSeqView$Appended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Appended.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Appended.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Appended.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Appended.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sc_IndexedSeqView$Appended.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sc_IndexedSeqView$Appended.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sc_IndexedSeqView$Appended.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Appended.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Appended.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Appended.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Appended.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Appended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Appended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Appended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Appended.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Appended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Appended.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Appended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Appended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Appended.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Appended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Appended.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Appended.prototype.view__sc_SeqView = (function() {
  return this
});
var $d_sc_IndexedSeqView$Appended = new $TypeData().initClass({
  sc_IndexedSeqView$Appended: 0
}, false, "scala.collection.IndexedSeqView$Appended", {
  sc_IndexedSeqView$Appended: 1,
  sc_SeqView$Appended: 1,
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Appended.prototype.$classData = $d_sc_IndexedSeqView$Appended;
function $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0
}
$c_sc_IndexedSeqView$Drop.prototype = new $h_sc_SeqView$Drop();
$c_sc_IndexedSeqView$Drop.prototype.constructor = $c_sc_IndexedSeqView$Drop;
/** @constructor */
function $h_sc_IndexedSeqView$Drop() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Drop.prototype = $c_sc_IndexedSeqView$Drop.prototype;
$c_sc_IndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Drop.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_IndexedSeqView$Drop.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Drop.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Drop.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Drop.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Drop.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sc_IndexedSeqView$Drop.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sc_IndexedSeqView$Drop.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sc_IndexedSeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Drop.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Drop.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Drop.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Drop.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Drop.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Drop.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Drop.prototype.view__sc_SeqView = (function() {
  return this
});
var $d_sc_IndexedSeqView$Drop = new $TypeData().initClass({
  sc_IndexedSeqView$Drop: 0
}, false, "scala.collection.IndexedSeqView$Drop", {
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Drop.prototype.$classData = $d_sc_IndexedSeqView$Drop;
function $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0
}
$c_sc_IndexedSeqView$DropRight.prototype = new $h_sc_SeqView$DropRight();
$c_sc_IndexedSeqView$DropRight.prototype.constructor = $c_sc_IndexedSeqView$DropRight;
/** @constructor */
function $h_sc_IndexedSeqView$DropRight() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$DropRight.prototype = $c_sc_IndexedSeqView$DropRight.prototype;
$c_sc_IndexedSeqView$DropRight.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$DropRight.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_IndexedSeqView$DropRight.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_IndexedSeqView$DropRight.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$DropRight.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$DropRight.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$DropRight.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$DropRight.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sc_IndexedSeqView$DropRight.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sc_IndexedSeqView$DropRight.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sc_IndexedSeqView$DropRight.prototype.lengthCompare__I__I = (function(len) {
  var x = this.sc_SeqView$DropRight__f_len;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$DropRight.prototype.knownSize__I = (function() {
  return this.sc_SeqView$DropRight__f_len
});
$c_sc_IndexedSeqView$DropRight.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$DropRight.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$DropRight.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$DropRight.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$DropRight.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$DropRight.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$DropRight.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$DropRight.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$DropRight.prototype.view__sc_SeqView = (function() {
  return this
});
var $d_sc_IndexedSeqView$DropRight = new $TypeData().initClass({
  sc_IndexedSeqView$DropRight: 0
}, false, "scala.collection.IndexedSeqView$DropRight", {
  sc_IndexedSeqView$DropRight: 1,
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$DropRight.prototype.$classData = $d_sc_IndexedSeqView$DropRight;
/** @constructor */
function $c_sc_IndexedSeqView$Id(underlying) {
  this.sc_SeqView$Id__f_underlying = null;
  $ct_sc_SeqView$Id__sc_SeqOps__(this, underlying)
}
$c_sc_IndexedSeqView$Id.prototype = new $h_sc_SeqView$Id();
$c_sc_IndexedSeqView$Id.prototype.constructor = $c_sc_IndexedSeqView$Id;
/** @constructor */
function $h_sc_IndexedSeqView$Id() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Id.prototype = $c_sc_IndexedSeqView$Id.prototype;
$c_sc_IndexedSeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Id.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Id.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Id.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Id.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sc_IndexedSeqView$Id.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sc_IndexedSeqView$Id.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sc_IndexedSeqView$Id.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Id.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Id.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Id.prototype.reverse__O = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__O = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Id.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.take__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_IndexedSeqView$Id.prototype.prepended__O__O = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_IndexedSeqView$Id.prototype.appended__O__O = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_IndexedSeqView$Id.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_IndexedSeqView$Id.prototype.view__sc_SeqView = (function() {
  return this
});
var $d_sc_IndexedSeqView$Id = new $TypeData().initClass({
  sc_IndexedSeqView$Id: 0
}, false, "scala.collection.IndexedSeqView$Id", {
  sc_IndexedSeqView$Id: 1,
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Id.prototype.$classData = $d_sc_IndexedSeqView$Id;
function $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__($thiz, underlying, f) {
  $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null
}
$c_sc_IndexedSeqView$Map.prototype = new $h_sc_SeqView$Map();
$c_sc_IndexedSeqView$Map.prototype.constructor = $c_sc_IndexedSeqView$Map;
/** @constructor */
function $h_sc_IndexedSeqView$Map() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Map.prototype = $c_sc_IndexedSeqView$Map.prototype;
$c_sc_IndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Map.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_IndexedSeqView$Map.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_IndexedSeqView$Map.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Map.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Map.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Map.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Map.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sc_IndexedSeqView$Map.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sc_IndexedSeqView$Map.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sc_IndexedSeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Map.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Map.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Map.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Map.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Map.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Map.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Map.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Map.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Map.prototype.view__sc_SeqView = (function() {
  return this
});
var $d_sc_IndexedSeqView$Map = new $TypeData().initClass({
  sc_IndexedSeqView$Map: 0
}, false, "scala.collection.IndexedSeqView$Map", {
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Map.prototype.$classData = $d_sc_IndexedSeqView$Map;
function $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__($thiz, elem, underlying) {
  $ct_sc_SeqView$Prepended__O__sc_SeqOps__($thiz, elem, underlying);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Prepended() {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
  this.sc_SeqView$Prepended__f_elem = null;
  this.sc_SeqView$Prepended__f_underlying = null
}
$c_sc_IndexedSeqView$Prepended.prototype = new $h_sc_SeqView$Prepended();
$c_sc_IndexedSeqView$Prepended.prototype.constructor = $c_sc_IndexedSeqView$Prepended;
/** @constructor */
function $h_sc_IndexedSeqView$Prepended() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Prepended.prototype = $c_sc_IndexedSeqView$Prepended.prototype;
$c_sc_IndexedSeqView$Prepended.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Prepended.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Prepended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_IndexedSeqView$Prepended.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_IndexedSeqView$Prepended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Prepended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Prepended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_IndexedSeqView$Prepended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Prepended.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Prepended.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Prepended.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Prepended.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sc_IndexedSeqView$Prepended.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sc_IndexedSeqView$Prepended.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sc_IndexedSeqView$Prepended.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Prepended.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Prepended.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Prepended.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Prepended.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Prepended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Prepended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Prepended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Prepended.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Prepended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Prepended.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Prepended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Prepended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Prepended.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Prepended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Prepended.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Prepended.prototype.view__sc_SeqView = (function() {
  return this
});
var $d_sc_IndexedSeqView$Prepended = new $TypeData().initClass({
  sc_IndexedSeqView$Prepended: 0
}, false, "scala.collection.IndexedSeqView$Prepended", {
  sc_IndexedSeqView$Prepended: 1,
  sc_SeqView$Prepended: 1,
  sc_View$Prepended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Prepended.prototype.$classData = $d_sc_IndexedSeqView$Prepended;
function $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__($thiz, underlying) {
  $thiz.sc_IndexedSeqView$Reverse__f_underlying = underlying;
  $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Reverse() {
  this.sc_SeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = null
}
$c_sc_IndexedSeqView$Reverse.prototype = new $h_sc_SeqView$Reverse();
$c_sc_IndexedSeqView$Reverse.prototype.constructor = $c_sc_IndexedSeqView$Reverse;
/** @constructor */
function $h_sc_IndexedSeqView$Reverse() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Reverse.prototype = $c_sc_IndexedSeqView$Reverse.prototype;
$c_sc_IndexedSeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Reverse.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Reverse.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_IndexedSeqView$Reverse.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Reverse.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Reverse.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Reverse.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sc_IndexedSeqView$Reverse.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sc_IndexedSeqView$Reverse.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sc_IndexedSeqView$Reverse.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Reverse.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Reverse.prototype.reverse__sc_IndexedSeqView = (function() {
  var x1 = this.sc_IndexedSeqView$Reverse__f_underlying;
  if ($is_sc_IndexedSeqView(x1)) {
    var x2 = $as_sc_IndexedSeqView(x1);
    return x2
  } else {
    return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
  }
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Reverse.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Reverse.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Reverse.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Reverse.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Reverse.prototype.view__sc_SeqView = (function() {
  return this
});
$c_sc_IndexedSeqView$Reverse.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Reverse.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
var $d_sc_IndexedSeqView$Reverse = new $TypeData().initClass({
  sc_IndexedSeqView$Reverse: 0
}, false, "scala.collection.IndexedSeqView$Reverse", {
  sc_IndexedSeqView$Reverse: 1,
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Reverse.prototype.$classData = $d_sc_IndexedSeqView$Reverse;
/** @constructor */
function $c_sc_IndexedSeqView$Slice(underlying, from, until) {
  this.sc_IndexedSeqView$Slice__f_underlying = null;
  this.sc_IndexedSeqView$Slice__f_lo = 0;
  this.sc_IndexedSeqView$Slice__f_hi = 0;
  this.sc_IndexedSeqView$Slice__f_len = 0;
  this.sc_IndexedSeqView$Slice__f_underlying = underlying;
  this.sc_IndexedSeqView$Slice__f_lo = ((from > 0) ? from : 0);
  var x = ((until > 0) ? until : 0);
  var that = $n(underlying).length__I();
  this.sc_IndexedSeqView$Slice__f_hi = ((x < that) ? x : that);
  var x$1 = ((this.sc_IndexedSeqView$Slice__f_hi - this.sc_IndexedSeqView$Slice__f_lo) | 0);
  this.sc_IndexedSeqView$Slice__f_len = ((x$1 > 0) ? x$1 : 0)
}
$c_sc_IndexedSeqView$Slice.prototype = new $h_sc_AbstractIndexedSeqView();
$c_sc_IndexedSeqView$Slice.prototype.constructor = $c_sc_IndexedSeqView$Slice;
/** @constructor */
function $h_sc_IndexedSeqView$Slice() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Slice.prototype = $c_sc_IndexedSeqView$Slice.prototype;
$c_sc_IndexedSeqView$Slice.prototype.apply__I__O = (function(i) {
  return $n(this.sc_IndexedSeqView$Slice__f_underlying).apply__I__O(((this.sc_IndexedSeqView$Slice__f_lo + i) | 0))
});
$c_sc_IndexedSeqView$Slice.prototype.length__I = (function() {
  return this.sc_IndexedSeqView$Slice__f_len
});
var $d_sc_IndexedSeqView$Slice = new $TypeData().initClass({
  sc_IndexedSeqView$Slice: 0
}, false, "scala.collection.IndexedSeqView$Slice", {
  sc_IndexedSeqView$Slice: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Slice.prototype.$classData = $d_sc_IndexedSeqView$Slice;
function $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0
}
$c_sc_IndexedSeqView$Take.prototype = new $h_sc_SeqView$Take();
$c_sc_IndexedSeqView$Take.prototype.constructor = $c_sc_IndexedSeqView$Take;
/** @constructor */
function $h_sc_IndexedSeqView$Take() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Take.prototype = $c_sc_IndexedSeqView$Take.prototype;
$c_sc_IndexedSeqView$Take.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Take.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem)
});
$c_sc_IndexedSeqView$Take.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this)
});
$c_sc_IndexedSeqView$Take.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n)
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n)
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f)
});
$c_sc_IndexedSeqView$Take.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Take.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Take.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sc_IndexedSeqView$Take.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sc_IndexedSeqView$Take.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sc_IndexedSeqView$Take.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sc_IndexedSeqView$Take.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Take.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Take.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Take.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Take.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Take.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Take.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Take.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Take.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_sc_IndexedSeqView$Take.prototype.view__sc_SeqView = (function() {
  return this
});
var $d_sc_IndexedSeqView$Take = new $TypeData().initClass({
  sc_IndexedSeqView$Take: 0
}, false, "scala.collection.IndexedSeqView$Take", {
  sc_IndexedSeqView$Take: 1,
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Take.prototype.$classData = $d_sc_IndexedSeqView$Take;
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__get__O__s_Option($thiz, k) {
  var v = $n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).get__O__O(k);
  return ((v !== null) ? new $c_s_Some(v) : ($n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).containsKey__O__Z(k) ? new $c_s_Some(null) : $m_s_None$()))
}
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__getOrElseUpdate__O__F0__O($thiz, key, op) {
  var x1 = $n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).computeIfAbsent__O__ju_function_Function__O(key, new $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$1(((x$4$2) => $n(op).apply__O())));
  return ((x1 === null) ? ($n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).put__O__O__O(key, null), null) : x1)
}
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__addOne__T2__sc_convert_JavaCollectionWrappers$JMapWrapperLike($thiz, kv) {
  $n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).put__O__O__O($n(kv)._1__O(), $n(kv)._2__O());
  return $thiz
}
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__subtractOne__O__sc_convert_JavaCollectionWrappers$JMapWrapperLike($thiz, key) {
  $n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).remove__O__O(key);
  return $thiz
}
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__updateWith__O__F1__s_Option($thiz, key, remappingFunction) {
  try {
    return $m_s_Option$().apply__O__s_Option($n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).compute__O__ju_function_BiFunction__O(key, new $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$3(((k$2, v$2) => $p_sc_convert_JavaCollectionWrappers$JMapWrapperLike__remap$1__O__O__F1__O($thiz, k$2, v$2, remappingFunction)))))
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x = $m_sc_convert_JavaCollectionWrappers$().sc_convert_JavaCollectionWrappers$__f_scala$collection$convert$JavaCollectionWrappers$$PutNull;
    if ((x !== null)) {
      var this$2 = $n(x);
      var $$x1 = (this$2 === e$2)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).put__O__O__O(key, null);
      return new $c_s_Some(null)
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2))
    }
  }
}
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__remove__O__s_Option($thiz, k) {
  var elem = $m_s_None$();
  var result = new $c_sr_ObjectRef(elem);
  $n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).compute__O__ju_function_BiFunction__O(k, new $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$Lambda$4(((k0$2, v0$2) => $p_sc_convert_JavaCollectionWrappers$JMapWrapperLike__recompute$2__O__O__sr_ObjectRef__O($thiz, k0$2, v0$2, result))));
  return $as_s_Option(result.sr_ObjectRef__f_elem)
}
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__foreachEntry__F2__V($thiz, f) {
  var i = $n($n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).entrySet__ju_Set()).iterator__ju_Iterator();
  while ($n(i).hasNext__Z()) {
    var entry = $as_ju_Map$Entry($n(i).next__O());
    $n(f).apply__O__O__O($n(entry).getKey__O(), $n(entry).getValue__O())
  }
}
function $p_sc_convert_JavaCollectionWrappers$JMapWrapperLike__remap$1__O__O__F1__O($thiz, k, v, remappingFunction$1) {
  var rc8 = false;
  var x2 = null;
  var x1 = $as_s_Option($n(remappingFunction$1).apply__O__O($m_s_Option$().apply__O__s_Option(v)));
  if ((x1 instanceof $c_s_Some)) {
    rc8 = true;
    x2 = $as_s_Some(x1);
    var p3 = $n(x2).s_Some__f_value;
    if ((p3 === null)) {
      throw $n($m_sc_convert_JavaCollectionWrappers$().sc_convert_JavaCollectionWrappers$__f_scala$collection$convert$JavaCollectionWrappers$$PutNull)
    }
  };
  if (rc8) {
    var x = $n(x2).s_Some__f_value;
    return x
  };
  var x$2 = $m_s_None$();
  if ((x$2 === x1)) {
    return null
  };
  throw new $c_s_MatchError(x1)
}
function $p_sc_convert_JavaCollectionWrappers$JMapWrapperLike__recompute$2__O__O__sr_ObjectRef__O($thiz, k0, v0, result$2) {
  if ((v0 !== null)) {
    $n(result$2).sr_ObjectRef__f_elem = new $c_s_Some(v0)
  } else if ($n($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).containsKey__O__Z(k0)) {
    $n(result$2).sr_ObjectRef__f_elem = new $c_s_Some(null)
  };
  return null
}
/** @constructor */
function $c_sci_AbstractSeq() {
  /*<skip>*/
}
$c_sci_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_sci_AbstractSeq.prototype.constructor = $c_sci_AbstractSeq;
/** @constructor */
function $h_sci_AbstractSeq() {
  /*<skip>*/
}
$h_sci_AbstractSeq.prototype = $c_sci_AbstractSeq.prototype;
$c_sci_AbstractSeq.prototype.toSeq__sci_Seq = (function() {
  return this
});
/** @constructor */
function $c_scm_ArrayBufferView(underlying, mutationCount) {
  this.scm_ArrayBufferView__f_underlying = null;
  this.scm_ArrayBufferView__f_mutationCount = null;
  this.scm_ArrayBufferView__f_underlying = underlying;
  this.scm_ArrayBufferView__f_mutationCount = mutationCount
}
$c_scm_ArrayBufferView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_scm_ArrayBufferView.prototype.constructor = $c_scm_ArrayBufferView;
/** @constructor */
function $h_scm_ArrayBufferView() {
  /*<skip>*/
}
$h_scm_ArrayBufferView.prototype = $c_scm_ArrayBufferView.prototype;
$c_scm_ArrayBufferView.prototype.apply__I__O = (function(n) {
  return $n(this.scm_ArrayBufferView__f_underlying).apply__I__O(n)
});
$c_scm_ArrayBufferView.prototype.length__I = (function() {
  var this$1 = $n(this.scm_ArrayBufferView__f_underlying);
  return this$1.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBufferView.prototype.className__T = (function() {
  return "ArrayBufferView"
});
$c_scm_ArrayBufferView.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_scm_ArrayBufferView.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_scm_ArrayBufferView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f)
});
$c_scm_ArrayBufferView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_scm_ArrayBufferView.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem)
});
$c_scm_ArrayBufferView.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
$c_scm_ArrayBufferView.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem)
});
var $d_scm_ArrayBufferView = new $TypeData().initClass({
  scm_ArrayBufferView: 0
}, false, "scala.collection.mutable.ArrayBufferView", {
  scm_ArrayBufferView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_scm_ArrayBufferView.prototype.$classData = $d_scm_ArrayBufferView;
/** @constructor */
function $c_sci_AbstractMap() {
  /*<skip>*/
}
$c_sci_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_sci_AbstractMap.prototype.constructor = $c_sci_AbstractMap;
/** @constructor */
function $h_sci_AbstractMap() {
  /*<skip>*/
}
$h_sci_AbstractMap.prototype = $c_sci_AbstractMap.prototype;
$c_sci_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_Map$()
});
$c_sci_AbstractMap.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sci_AbstractMap.prototype.withDefaultValue__O__sci_Map = (function(d) {
  return $f_sci_Map__withDefaultValue__O__sci_Map(this, d)
});
$c_sci_AbstractMap.prototype.$plus__T2__sci_MapOps = (function(kv) {
  return this.updated__O__O__sci_MapOps($n(kv)._1__O(), $n(kv)._2__O())
});
$c_sci_AbstractMap.prototype.keySet__sci_Set = (function() {
  return $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$ImmutableKeySet(), this)
});
$c_sci_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Iterable$()
});
$c_sci_AbstractMap.prototype.keySet__sc_Set = (function() {
  return this.keySet__sci_Set()
});
$c_sci_AbstractMap.prototype.$plus__T2__sc_IterableOps = (function(kv) {
  return this.$plus__T2__sci_MapOps(kv)
});
function $f_sci_IndexedSeq__canEqual__O__Z($thiz, that) {
  if ((!$is_sci_IndexedSeq(that))) {
    return true
  } else {
    var x2 = $as_sci_IndexedSeq(that);
    return ($thiz.length__I() === $n(x2).length__I())
  }
}
function $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z($thiz, o) {
  if ($is_sci_IndexedSeq(o)) {
    var x2 = $as_sci_IndexedSeq(o);
    if (($thiz === x2)) {
      return true
    } else {
      var length = $thiz.length__I();
      var equal = (length === $n(x2).length__I());
      if (equal) {
        var index = 0;
        var a = $thiz.applyPreferredMaxLength__I();
        var b = $n(x2).applyPreferredMaxLength__I();
        var preferredLength = ((a < b) ? a : b);
        var hi = (length >> 31);
        var hi$1 = (preferredLength >> 31);
        var lo = (preferredLength << 1);
        var hi$2 = (((preferredLength >>> 31) | 0) | (hi$1 << 1));
        if (((hi === hi$2) ? (((-2147483648) ^ length) > ((-2147483648) ^ lo)) : (hi > hi$2))) {
          var maxApplyCompare = preferredLength
        } else {
          var maxApplyCompare = length
        };
        while (((index < maxApplyCompare) && equal)) {
          equal = $m_sr_BoxesRunTime$().equals__O__O__Z($thiz.apply__I__O(index), $n(x2).apply__I__O(index));
          index = ((1 + index) | 0)
        };
        if (((index < length) && equal)) {
          var thisIt = $n($thiz.iterator__sc_Iterator()).drop__I__sc_Iterator(index);
          var thatIt = $n($n(x2).iterator__sc_Iterator()).drop__I__sc_Iterator(index);
          while ((equal && $n(thisIt).hasNext__Z())) {
            equal = $m_sr_BoxesRunTime$().equals__O__O__Z($n(thisIt).next__O(), $n(thatIt).next__O())
          }
        }
      };
      return equal
    }
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, o)
  }
}
function $is_sci_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_IndexedSeq)))
}
function $as_sci_IndexedSeq(obj) {
  return (($is_sci_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.IndexedSeq"))
}
function $isArrayOf_sci_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_IndexedSeq)))
}
function $asArrayOf_sci_IndexedSeq(obj, depth) {
  return (($isArrayOf_sci_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.IndexedSeq;", depth))
}
function $is_sci_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_LinearSeq)))
}
function $as_sci_LinearSeq(obj) {
  return (($is_sci_LinearSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LinearSeq"))
}
function $isArrayOf_sci_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LinearSeq)))
}
function $asArrayOf_sci_LinearSeq(obj, depth) {
  return (($isArrayOf_sci_LinearSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LinearSeq;", depth))
}
/** @constructor */
function $c_sci_Set$EmptySet$() {
  /*<skip>*/
}
$c_sci_Set$EmptySet$.prototype = new $h_sci_AbstractSet();
$c_sci_Set$EmptySet$.prototype.constructor = $c_sci_Set$EmptySet$;
/** @constructor */
function $h_sci_Set$EmptySet$() {
  /*<skip>*/
}
$h_sci_Set$EmptySet$.prototype = $c_sci_Set$EmptySet$.prototype;
$c_sci_Set$EmptySet$.prototype.size__I = (function() {
  return 0
});
$c_sci_Set$EmptySet$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Set$EmptySet$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Set$EmptySet$.prototype.subsetOf__sc_Set__Z = (function(that) {
  return true
});
$c_sci_Set$EmptySet$.prototype.contains__O__Z = (function(elem) {
  return false
});
$c_sci_Set$EmptySet$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Set$EmptySet$.prototype.foreach__F1__V = (function(f) {
  /*<skip>*/
});
$c_sci_Set$EmptySet$.prototype.excl__O__sci_SetOps = (function(elem) {
  return this
});
$c_sci_Set$EmptySet$.prototype.incl__O__sci_SetOps = (function(elem) {
  return new $c_sci_Set$Set1(elem)
});
$c_sci_Set$EmptySet$.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return this
});
$c_sci_Set$EmptySet$.prototype.filterNot__F1__O = (function(pred) {
  return this
});
$c_sci_Set$EmptySet$.prototype.filter__F1__O = (function(pred) {
  return this
});
var $d_sci_Set$EmptySet$ = new $TypeData().initClass({
  sci_Set$EmptySet$: 0
}, false, "scala.collection.immutable.Set$EmptySet$", {
  sci_Set$EmptySet$: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$EmptySet$.prototype.$classData = $d_sci_Set$EmptySet$;
var $n_sci_Set$EmptySet$;
function $m_sci_Set$EmptySet$() {
  if ((!$n_sci_Set$EmptySet$)) {
    $n_sci_Set$EmptySet$ = new $c_sci_Set$EmptySet$()
  };
  return $n_sci_Set$EmptySet$
}
/** @constructor */
function $c_sc_StringView(s) {
  this.sc_StringView__f_s = null;
  this.sc_StringView__f_s = s
}
$c_sc_StringView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_sc_StringView.prototype.constructor = $c_sc_StringView;
/** @constructor */
function $h_sc_StringView() {
  /*<skip>*/
}
$h_sc_StringView.prototype = $c_sc_StringView.prototype;
$c_sc_StringView.prototype.length__I = (function() {
  var this$1 = $n(this.sc_StringView__f_s);
  return this$1.length
});
$c_sc_StringView.prototype.toString__T = (function() {
  return (("StringView(" + this.sc_StringView__f_s) + ")")
});
$c_sc_StringView.prototype.productPrefix__T = (function() {
  return "StringView"
});
$c_sc_StringView.prototype.productArity__I = (function() {
  return 1
});
$c_sc_StringView.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.sc_StringView__f_s : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_sc_StringView.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sc_StringView.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_sc_StringView.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_sc_StringView)) {
    var StringView$1 = $as_sc_StringView(x$1);
    return (this.sc_StringView__f_s === $n(StringView$1).sc_StringView__f_s)
  } else {
    return false
  }
});
$c_sc_StringView.prototype.apply__I__O = (function(i) {
  var this$1 = $n(this.sc_StringView__f_s);
  return $bC($charAt(this$1, i))
});
function $as_sc_StringView(obj) {
  return (((obj instanceof $c_sc_StringView) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StringView"))
}
function $isArrayOf_sc_StringView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StringView)))
}
function $asArrayOf_sc_StringView(obj, depth) {
  return (($isArrayOf_sc_StringView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StringView;", depth))
}
var $d_sc_StringView = new $TypeData().initClass({
  sc_StringView: 0
}, false, "scala.collection.StringView", {
  sc_StringView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sc_StringView.prototype.$classData = $d_sc_StringView;
/** @constructor */
function $c_sci_ListMap$$anon$1(outer) {
  this.sci_ListMap$$anon$1__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sci_ListMap$$anon$1__f_$outer = outer
  }
}
$c_sci_ListMap$$anon$1.prototype = new $h_sci_AbstractMap();
$c_sci_ListMap$$anon$1.prototype.constructor = $c_sci_ListMap$$anon$1;
/** @constructor */
function $h_sci_ListMap$$anon$1() {
  /*<skip>*/
}
$h_sci_ListMap$$anon$1.prototype = $c_sci_ListMap$$anon$1.prototype;
$c_sci_ListMap$$anon$1.prototype.isEmpty__Z = (function() {
  return $n(this.sci_ListMap$$anon$1__f_$outer).isEmpty__Z()
});
$c_sci_ListMap$$anon$1.prototype.removed__O__sci_Map = (function(key) {
  return $n(this.sci_ListMap$$anon$1__f_$outer).removed__O__sci_ListMap(key)
});
$c_sci_ListMap$$anon$1.prototype.updated__O__O__sci_Map = (function(key, value) {
  return $n(this.sci_ListMap$$anon$1__f_$outer).updated__O__O__sci_ListMap(key, value)
});
$c_sci_ListMap$$anon$1.prototype.get__O__s_Option = (function(key) {
  return $n(this.sci_ListMap$$anon$1__f_$outer).get__O__s_Option(key)
});
$c_sci_ListMap$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sci_ListMap$$anon$1__f_$outer).iterator__sc_Iterator()
});
$c_sci_ListMap$$anon$1.prototype.foreachEntry__F2__V = (function(f) {
  var curr = this.sci_ListMap$$anon$1__f_$outer;
  while (true) {
    var this$1 = $n(curr);
    if ((!this$1.isEmpty__Z())) {
      $n(f).apply__O__O__O($n(curr).key__O(), $n(curr).value__O());
      curr = $n(curr).next__sci_ListMap()
    } else {
      break
    }
  }
});
$c_sci_ListMap$$anon$1.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
$c_sci_ListMap$$anon$1.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
var $d_sci_ListMap$$anon$1 = new $TypeData().initClass({
  sci_ListMap$$anon$1: 0
}, false, "scala.collection.immutable.ListMap$$anon$1", {
  sci_ListMap$$anon$1: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1
});
$c_sci_ListMap$$anon$1.prototype.$classData = $d_sci_ListMap$$anon$1;
function $as_sci_SeqMap$SeqMap1(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap1"))
}
function $isArrayOf_sci_SeqMap$SeqMap1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap1)))
}
function $asArrayOf_sci_SeqMap$SeqMap1(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap1;", depth))
}
function $as_sci_SeqMap$SeqMap2(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap2"))
}
function $isArrayOf_sci_SeqMap$SeqMap2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap2)))
}
function $asArrayOf_sci_SeqMap$SeqMap2(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap2;", depth))
}
function $as_sci_SeqMap$SeqMap3(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap3"))
}
function $isArrayOf_sci_SeqMap$SeqMap3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap3)))
}
function $asArrayOf_sci_SeqMap$SeqMap3(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap3;", depth))
}
function $as_sci_SeqMap$SeqMap4(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap4"))
}
function $isArrayOf_sci_SeqMap$SeqMap4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap4)))
}
function $asArrayOf_sci_SeqMap$SeqMap4(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap4;", depth))
}
/** @constructor */
function $c_sci_Set$Set1(elem1) {
  this.sci_Set$Set1__f_elem1 = null;
  this.sci_Set$Set1__f_elem1 = elem1
}
$c_sci_Set$Set1.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set1.prototype.constructor = $c_sci_Set$Set1;
/** @constructor */
function $h_sci_Set$Set1() {
  /*<skip>*/
}
$h_sci_Set$Set1.prototype = $c_sci_Set$Set1.prototype;
$c_sci_Set$Set1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set1.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Set$Set1.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Set$Set1.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Set$Set1.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false)
});
$c_sci_Set$Set1.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true)
});
$c_sci_Set$Set1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_Set$Set1.prototype.size__I = (function() {
  return 1
});
$c_sci_Set$Set1.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set1.prototype.knownSize__I = (function() {
  return 1
});
$c_sci_Set$Set1.prototype.contains__O__Z = (function(elem) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1)
});
$c_sci_Set$Set1.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set2(this.sci_Set$Set1__f_elem1, elem))
});
$c_sci_Set$Set1.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1) ? $m_sci_Set$EmptySet$() : this)
});
$c_sci_Set$Set1.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sci_Set$Set1__f_elem1;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Set$Set1.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set1__f_elem1)
});
$c_sci_Set$Set1.prototype.exists__F1__Z = (function(p) {
  return $uZ($n(p).apply__O__O(this.sci_Set$Set1__f_elem1))
});
$c_sci_Set$Set1.prototype.forall__F1__Z = (function(p) {
  return $uZ($n(p).apply__O__O(this.sci_Set$Set1__f_elem1))
});
$c_sci_Set$Set1.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  return (($uZ($n(pred).apply__O__O(this.sci_Set$Set1__f_elem1)) !== isFlipped) ? this : $m_sci_Set$EmptySet$())
});
$c_sci_Set$Set1.prototype.head__O = (function() {
  return this.sci_Set$Set1__f_elem1
});
$c_sci_Set$Set1.prototype.tail__O = (function() {
  return $m_sci_Set$EmptySet$()
});
$c_sci_Set$Set1.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set1.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
function $as_sci_Set$Set1(obj) {
  return (((obj instanceof $c_sci_Set$Set1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set1"))
}
function $isArrayOf_sci_Set$Set1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set1)))
}
function $asArrayOf_sci_Set$Set1(obj, depth) {
  return (($isArrayOf_sci_Set$Set1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set1;", depth))
}
var $d_sci_Set$Set1 = new $TypeData().initClass({
  sci_Set$Set1: 0
}, false, "scala.collection.immutable.Set$Set1", {
  sci_Set$Set1: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set1.prototype.$classData = $d_sci_Set$Set1;
/** @constructor */
function $c_sci_Set$Set2(elem1, elem2) {
  this.sci_Set$Set2__f_elem1 = null;
  this.sci_Set$Set2__f_elem2 = null;
  this.sci_Set$Set2__f_elem1 = elem1;
  this.sci_Set$Set2__f_elem2 = elem2
}
$c_sci_Set$Set2.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set2.prototype.constructor = $c_sci_Set$Set2;
/** @constructor */
function $h_sci_Set$Set2() {
  /*<skip>*/
}
$h_sci_Set$Set2.prototype = $c_sci_Set$Set2.prototype;
$c_sci_Set$Set2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set2.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Set$Set2.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Set$Set2.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Set$Set2.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false)
});
$c_sci_Set$Set2.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true)
});
$c_sci_Set$Set2.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_Set$Set2.prototype.size__I = (function() {
  return 2
});
$c_sci_Set$Set2.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set2.prototype.knownSize__I = (function() {
  return 2
});
$c_sci_Set$Set2.prototype.contains__O__Z = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2))
});
$c_sci_Set$Set2.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set3(this.sci_Set$Set2__f_elem1, this.sci_Set$Set2__f_elem2, elem))
});
$c_sci_Set$Set2.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem1) : this))
});
$c_sci_Set$Set2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set2$$anon$1(this)
});
$c_sci_Set$Set2.prototype.scala$collection$immutable$Set$Set2$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set2__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set2__f_elem2;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set2.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set2__f_elem1);
  $n(f).apply__O__O(this.sci_Set$Set2__f_elem2)
});
$c_sci_Set$Set2.prototype.exists__F1__Z = (function(p) {
  return ($uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem1)) || $uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem2)))
});
$c_sci_Set$Set2.prototype.forall__F1__Z = (function(p) {
  return ($uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem1)) && $uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem2)))
});
$c_sci_Set$Set2.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set2__f_elem1)) !== isFlipped)) {
    r1 = this.sci_Set$Set2__f_elem1;
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set2__f_elem2)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set2__f_elem2
    };
    n = ((1 + n) | 0)
  };
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break
    }
    case 2: {
      return this;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_Set$Set2.prototype.head__O = (function() {
  return this.sci_Set$Set2__f_elem1
});
$c_sci_Set$Set2.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2)
});
$c_sci_Set$Set2.prototype.tail__O = (function() {
  return this.tail__sci_Set()
});
$c_sci_Set$Set2.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set2.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
function $as_sci_Set$Set2(obj) {
  return (((obj instanceof $c_sci_Set$Set2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set2"))
}
function $isArrayOf_sci_Set$Set2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set2)))
}
function $asArrayOf_sci_Set$Set2(obj, depth) {
  return (($isArrayOf_sci_Set$Set2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set2;", depth))
}
var $d_sci_Set$Set2 = new $TypeData().initClass({
  sci_Set$Set2: 0
}, false, "scala.collection.immutable.Set$Set2", {
  sci_Set$Set2: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set2.prototype.$classData = $d_sci_Set$Set2;
/** @constructor */
function $c_sci_Set$Set3(elem1, elem2, elem3) {
  this.sci_Set$Set3__f_elem1 = null;
  this.sci_Set$Set3__f_elem2 = null;
  this.sci_Set$Set3__f_elem3 = null;
  this.sci_Set$Set3__f_elem1 = elem1;
  this.sci_Set$Set3__f_elem2 = elem2;
  this.sci_Set$Set3__f_elem3 = elem3
}
$c_sci_Set$Set3.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set3.prototype.constructor = $c_sci_Set$Set3;
/** @constructor */
function $h_sci_Set$Set3() {
  /*<skip>*/
}
$h_sci_Set$Set3.prototype = $c_sci_Set$Set3.prototype;
$c_sci_Set$Set3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set3.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Set$Set3.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Set$Set3.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Set$Set3.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false)
});
$c_sci_Set$Set3.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true)
});
$c_sci_Set$Set3.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_Set$Set3.prototype.size__I = (function() {
  return 3
});
$c_sci_Set$Set3.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set3.prototype.knownSize__I = (function() {
  return 3
});
$c_sci_Set$Set3.prototype.contains__O__Z = (function(elem) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3))
});
$c_sci_Set$Set3.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set4(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3, elem))
});
$c_sci_Set$Set3.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2) : this)))
});
$c_sci_Set$Set3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set3$$anon$2(this)
});
$c_sci_Set$Set3.prototype.scala$collection$immutable$Set$Set3$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set3__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set3__f_elem2;
      break
    }
    case 2: {
      return this.sci_Set$Set3__f_elem3;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set3.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set3__f_elem1);
  $n(f).apply__O__O(this.sci_Set$Set3__f_elem2);
  $n(f).apply__O__O(this.sci_Set$Set3__f_elem3)
});
$c_sci_Set$Set3.prototype.exists__F1__Z = (function(p) {
  return (($uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem1)) || $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem2))) || $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem3)))
});
$c_sci_Set$Set3.prototype.forall__F1__Z = (function(p) {
  return (($uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem1)) && $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem2))) && $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem3)))
});
$c_sci_Set$Set3.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set3__f_elem1)) !== isFlipped)) {
    r1 = this.sci_Set$Set3__f_elem1;
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set3__f_elem2)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set3__f_elem2
    } else {
      r2 = this.sci_Set$Set3__f_elem2
    };
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set3__f_elem3)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set3__f_elem3
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set3__f_elem3
    };
    n = ((1 + n) | 0)
  };
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break
    }
    case 3: {
      return this;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_Set$Set3.prototype.head__O = (function() {
  return this.sci_Set$Set3__f_elem1
});
$c_sci_Set$Set3.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3)
});
$c_sci_Set$Set3.prototype.tail__O = (function() {
  return this.tail__sci_Set()
});
$c_sci_Set$Set3.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set3.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
function $as_sci_Set$Set3(obj) {
  return (((obj instanceof $c_sci_Set$Set3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set3"))
}
function $isArrayOf_sci_Set$Set3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set3)))
}
function $asArrayOf_sci_Set$Set3(obj, depth) {
  return (($isArrayOf_sci_Set$Set3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set3;", depth))
}
var $d_sci_Set$Set3 = new $TypeData().initClass({
  sci_Set$Set3: 0
}, false, "scala.collection.immutable.Set$Set3", {
  sci_Set$Set3: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set3.prototype.$classData = $d_sci_Set$Set3;
/** @constructor */
function $c_sci_Set$Set4(elem1, elem2, elem3, elem4) {
  this.sci_Set$Set4__f_elem1 = null;
  this.sci_Set$Set4__f_elem2 = null;
  this.sci_Set$Set4__f_elem3 = null;
  this.sci_Set$Set4__f_elem4 = null;
  this.sci_Set$Set4__f_elem1 = elem1;
  this.sci_Set$Set4__f_elem2 = elem2;
  this.sci_Set$Set4__f_elem3 = elem3;
  this.sci_Set$Set4__f_elem4 = elem4
}
$c_sci_Set$Set4.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set4.prototype.constructor = $c_sci_Set$Set4;
/** @constructor */
function $h_sci_Set$Set4() {
  /*<skip>*/
}
$h_sci_Set$Set4.prototype = $c_sci_Set$Set4.prototype;
$c_sci_Set$Set4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set4.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Set$Set4.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Set$Set4.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Set$Set4.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false)
});
$c_sci_Set$Set4.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true)
});
$c_sci_Set$Set4.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_Set$Set4.prototype.size__I = (function() {
  return 4
});
$c_sci_Set$Set4.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set4.prototype.knownSize__I = (function() {
  return 4
});
$c_sci_Set$Set4.prototype.contains__O__Z = (function(elem) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4))
});
$c_sci_Set$Set4.prototype.incl__O__sci_Set = (function(elem) {
  if (this.contains__O__Z(elem)) {
    return this
  } else {
    var this$1 = $m_sci_HashSet$();
    var this$2 = $n(this$1.sci_HashSet$__f_EmptySet);
    var elem$1 = this.sci_Set$Set4__f_elem1;
    var this$3 = $n(this$2.incl__O__sci_HashSet(elem$1));
    var elem$2 = this.sci_Set$Set4__f_elem2;
    var this$4 = $n(this$3.incl__O__sci_HashSet(elem$2));
    var elem$3 = this.sci_Set$Set4__f_elem3;
    var this$5 = $n(this$4.incl__O__sci_HashSet(elem$3));
    var elem$4 = this.sci_Set$Set4__f_elem4;
    var this$6 = $n(this$5.incl__O__sci_HashSet(elem$4));
    return this$6.incl__O__sci_HashSet(elem)
  }
});
$c_sci_Set$Set4.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3) : this))))
});
$c_sci_Set$Set4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set4$$anon$3(this)
});
$c_sci_Set$Set4.prototype.scala$collection$immutable$Set$Set4$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set4__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set4__f_elem2;
      break
    }
    case 2: {
      return this.sci_Set$Set4__f_elem3;
      break
    }
    case 3: {
      return this.sci_Set$Set4__f_elem4;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set4.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem1);
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem2);
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem3);
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem4)
});
$c_sci_Set$Set4.prototype.exists__F1__Z = (function(p) {
  return ((($uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem1)) || $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem2))) || $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem3))) || $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem4)))
});
$c_sci_Set$Set4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem1)) && $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem2))) && $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem3))) && $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem4)))
});
$c_sci_Set$Set4.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var r3 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem1)) !== isFlipped)) {
    r1 = this.sci_Set$Set4__f_elem1;
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem2)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem2
    } else {
      r2 = this.sci_Set$Set4__f_elem2
    };
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem3)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem3
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set4__f_elem3
    } else {
      r3 = this.sci_Set$Set4__f_elem3
    };
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem4)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem4
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set4__f_elem4
    } else if ((n === 2)) {
      r3 = this.sci_Set$Set4__f_elem4
    };
    n = ((1 + n) | 0)
  };
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break
    }
    case 3: {
      return new $c_sci_Set$Set3(r1, r2, r3);
      break
    }
    case 4: {
      return this;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_Set$Set4.prototype.head__O = (function() {
  return this.sci_Set$Set4__f_elem1
});
$c_sci_Set$Set4.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4)
});
$c_sci_Set$Set4.prototype.buildTo__scm_Builder__scm_Builder = (function(builder) {
  return $as_scm_Builder($n($n($n($n(builder).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem1)).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem2)).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem3)).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem4))
});
$c_sci_Set$Set4.prototype.tail__O = (function() {
  return this.tail__sci_Set()
});
$c_sci_Set$Set4.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set4.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
function $as_sci_Set$Set4(obj) {
  return (((obj instanceof $c_sci_Set$Set4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set4"))
}
function $isArrayOf_sci_Set$Set4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set4)))
}
function $asArrayOf_sci_Set$Set4(obj, depth) {
  return (($isArrayOf_sci_Set$Set4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set4;", depth))
}
var $d_sci_Set$Set4 = new $TypeData().initClass({
  sci_Set$Set4: 0
}, false, "scala.collection.immutable.Set$Set4", {
  sci_Set$Set4: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set4.prototype.$classData = $d_sci_Set$Set4;
function $is_sci_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SortedSet)))
}
function $as_sci_SortedSet(obj) {
  return (($is_sci_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SortedSet"))
}
function $isArrayOf_sci_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SortedSet)))
}
function $asArrayOf_sci_SortedSet(obj, depth) {
  return (($isArrayOf_sci_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SortedSet;", depth))
}
/** @constructor */
function $c_scm_AbstractSeq() {
  /*<skip>*/
}
$c_scm_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_scm_AbstractSeq.prototype.constructor = $c_scm_AbstractSeq;
/** @constructor */
function $h_scm_AbstractSeq() {
  /*<skip>*/
}
$h_scm_AbstractSeq.prototype = $c_scm_AbstractSeq.prototype;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Appended(underlying, elem, mutationCount) {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
  this.sc_SeqView$Appended__f_underlying = null;
  this.sc_SeqView$Appended__f_elem = null;
  this.scm_CheckedIndexedSeqView$Appended__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Appended__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(this, underlying, elem)
}
$c_scm_CheckedIndexedSeqView$Appended.prototype = new $h_sc_IndexedSeqView$Appended();
$c_scm_CheckedIndexedSeqView$Appended.prototype.constructor = $c_scm_CheckedIndexedSeqView$Appended;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Appended() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Appended.prototype = $c_scm_CheckedIndexedSeqView$Appended.prototype;
$c_scm_CheckedIndexedSeqView$Appended.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$Appended = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Appended: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Appended", {
  scm_CheckedIndexedSeqView$Appended: 1,
  sc_IndexedSeqView$Appended: 1,
  sc_SeqView$Appended: 1,
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.$classData = $d_scm_CheckedIndexedSeqView$Appended;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Drop(underlying, n, mutationCount) {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(this, underlying, n)
}
$c_scm_CheckedIndexedSeqView$Drop.prototype = new $h_sc_IndexedSeqView$Drop();
$c_scm_CheckedIndexedSeqView$Drop.prototype.constructor = $c_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Drop() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Drop.prototype = $c_scm_CheckedIndexedSeqView$Drop.prototype;
$c_scm_CheckedIndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$Drop = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Drop: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Drop", {
  scm_CheckedIndexedSeqView$Drop: 1,
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.$classData = $d_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$DropRight(underlying, n, mutationCount) {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
  this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(this, underlying, n)
}
$c_scm_CheckedIndexedSeqView$DropRight.prototype = new $h_sc_IndexedSeqView$DropRight();
$c_scm_CheckedIndexedSeqView$DropRight.prototype.constructor = $c_scm_CheckedIndexedSeqView$DropRight;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$DropRight() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$DropRight.prototype = $c_scm_CheckedIndexedSeqView$DropRight.prototype;
$c_scm_CheckedIndexedSeqView$DropRight.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$DropRight = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$DropRight: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$DropRight", {
  scm_CheckedIndexedSeqView$DropRight: 1,
  sc_IndexedSeqView$DropRight: 1,
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.$classData = $d_scm_CheckedIndexedSeqView$DropRight;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Map(underlying, f, mutationCount) {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(this, underlying, f)
}
$c_scm_CheckedIndexedSeqView$Map.prototype = new $h_sc_IndexedSeqView$Map();
$c_scm_CheckedIndexedSeqView$Map.prototype.constructor = $c_scm_CheckedIndexedSeqView$Map;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Map() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Map.prototype = $c_scm_CheckedIndexedSeqView$Map.prototype;
$c_scm_CheckedIndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Map.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Map__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$Map = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Map: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Map", {
  scm_CheckedIndexedSeqView$Map: 1,
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Map.prototype.$classData = $d_scm_CheckedIndexedSeqView$Map;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Prepended(elem, underlying, mutationCount) {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
  this.sc_SeqView$Prepended__f_elem = null;
  this.sc_SeqView$Prepended__f_underlying = null;
  this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(this, elem, underlying)
}
$c_scm_CheckedIndexedSeqView$Prepended.prototype = new $h_sc_IndexedSeqView$Prepended();
$c_scm_CheckedIndexedSeqView$Prepended.prototype.constructor = $c_scm_CheckedIndexedSeqView$Prepended;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Prepended() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Prepended.prototype = $c_scm_CheckedIndexedSeqView$Prepended.prototype;
$c_scm_CheckedIndexedSeqView$Prepended.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$Prepended = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Prepended: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Prepended", {
  scm_CheckedIndexedSeqView$Prepended: 1,
  sc_IndexedSeqView$Prepended: 1,
  sc_SeqView$Prepended: 1,
  sc_View$Prepended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.$classData = $d_scm_CheckedIndexedSeqView$Prepended;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Reverse(underlying, mutationCount) {
  this.sc_SeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = null;
  this.scm_CheckedIndexedSeqView$Reverse__f_underlying = null;
  this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Reverse__f_underlying = underlying;
  this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(this, underlying)
}
$c_scm_CheckedIndexedSeqView$Reverse.prototype = new $h_sc_IndexedSeqView$Reverse();
$c_scm_CheckedIndexedSeqView$Reverse.prototype.constructor = $c_scm_CheckedIndexedSeqView$Reverse;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Reverse() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Reverse.prototype = $c_scm_CheckedIndexedSeqView$Reverse.prototype;
$c_scm_CheckedIndexedSeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverse__sc_IndexedSeqView = (function() {
  var x1 = this.scm_CheckedIndexedSeqView$Reverse__f_underlying;
  if ($is_sc_IndexedSeqView(x1)) {
    var x2 = $as_sc_IndexedSeqView(x1);
    return x2
  } else {
    return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
  }
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView()
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView()
});
var $d_scm_CheckedIndexedSeqView$Reverse = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Reverse: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Reverse", {
  scm_CheckedIndexedSeqView$Reverse: 1,
  sc_IndexedSeqView$Reverse: 1,
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.$classData = $d_scm_CheckedIndexedSeqView$Reverse;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Take(underlying, n, mutationCount) {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
  this.scm_CheckedIndexedSeqView$Take__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Take__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(this, underlying, n)
}
$c_scm_CheckedIndexedSeqView$Take.prototype = new $h_sc_IndexedSeqView$Take();
$c_scm_CheckedIndexedSeqView$Take.prototype.constructor = $c_scm_CheckedIndexedSeqView$Take;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Take() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Take.prototype = $c_scm_CheckedIndexedSeqView$Take.prototype;
$c_scm_CheckedIndexedSeqView$Take.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Take.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Take__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$Take = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Take: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Take", {
  scm_CheckedIndexedSeqView$Take: 1,
  sc_IndexedSeqView$Take: 1,
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Take.prototype.$classData = $d_scm_CheckedIndexedSeqView$Take;
function $is_scm_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Set)))
}
function $as_scm_Set(obj) {
  return (($is_scm_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Set"))
}
function $isArrayOf_scm_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Set)))
}
function $asArrayOf_scm_Set(obj, depth) {
  return (($isArrayOf_scm_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Set;", depth))
}
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$2(outer) {
  /*<skip>*/
}
$c_Lcats_instances_EitherInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$2.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_EitherInstances$$anon$2.prototype = $c_Lcats_instances_EitherInstances$$anon$2.prototype;
$c_Lcats_instances_EitherInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_util_Either(fa);
  return $n(fa$1).map__F1__s_util_Either(f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return $n(fa$1).map__F1__s_util_Either(f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return $n(fa$1).flatMap__F1__s_util_Either(f)
});
var $d_Lcats_instances_EitherInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_EitherInstances$$anon$2: 0
}, false, "cats.instances.EitherInstances$$anon$2", {
  Lcats_instances_EitherInstances$$anon$2: 1,
  O: 1,
  Lcats_MonadError: 1,
  Lcats_ApplicativeError: 1,
  Lcats_Applicative: 1,
  Lcats_Apply: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_Traverse: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.$classData = $d_Lcats_instances_EitherInstances$$anon$2;
/** @constructor */
function $c_Lcats_kernel_Eq$() {
  /*<skip>*/
}
$c_Lcats_kernel_Eq$.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_Eq$.prototype.constructor = $c_Lcats_kernel_Eq$;
/** @constructor */
function $h_Lcats_kernel_Eq$() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$.prototype = $c_Lcats_kernel_Eq$.prototype;
var $d_Lcats_kernel_Eq$ = new $TypeData().initClass({
  Lcats_kernel_Eq$: 0
}, false, "cats.kernel.Eq$", {
  Lcats_kernel_Eq$: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_ScalaVersionSpecificOrderInstances: 1,
  Lcats_kernel_ScalaVersionSpecificPartialOrderInstances: 1,
  Lcats_kernel_ScalaVersionSpecificHashInstances: 1,
  Lcats_kernel_ScalaVersionSpecificEqInstances: 1,
  Lcats_kernel_instances_TupleOrderInstances: 1,
  Lcats_kernel_instances_TuplePartialOrderInstances: 1,
  Lcats_kernel_instances_TupleHashInstances: 1,
  Lcats_kernel_instances_TupleEqInstances: 1,
  Lcats_kernel_OrderInstances0: 1,
  Lcats_kernel_PartialOrderInstances: 1,
  Lcats_kernel_PartialOrderInstances0: 1,
  Lcats_kernel_HashInstances: 1,
  Lcats_kernel_HashInstances0: 1,
  Lcats_kernel_EqInstances: 1,
  Lcats_kernel_EqInstances0: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Eq$.prototype.$classData = $d_Lcats_kernel_Eq$;
var $n_Lcats_kernel_Eq$;
function $m_Lcats_kernel_Eq$() {
  if ((!$n_Lcats_kernel_Eq$)) {
    $n_Lcats_kernel_Eq$ = new $c_Lcats_kernel_Eq$()
  };
  return $n_Lcats_kernel_Eq$
}
/** @constructor */
function $c_sci_Map$EmptyMap$() {
  /*<skip>*/
}
$c_sci_Map$EmptyMap$.prototype = new $h_sci_AbstractMap();
$c_sci_Map$EmptyMap$.prototype.constructor = $c_sci_Map$EmptyMap$;
/** @constructor */
function $h_sci_Map$EmptyMap$() {
  /*<skip>*/
}
$h_sci_Map$EmptyMap$.prototype = $c_sci_Map$EmptyMap$.prototype;
$c_sci_Map$EmptyMap$.prototype.size__I = (function() {
  return 0
});
$c_sci_Map$EmptyMap$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Map$EmptyMap$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Map$EmptyMap$.prototype.apply__O__E = (function(key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
});
$c_sci_Map$EmptyMap$.prototype.contains__O__Z = (function(key) {
  return false
});
$c_sci_Map$EmptyMap$.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$()
});
$c_sci_Map$EmptyMap$.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $n(default$1).apply__O()
});
$c_sci_Map$EmptyMap$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Map$EmptyMap$.prototype.keysIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Map$EmptyMap$.prototype.valuesIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Map$EmptyMap$.prototype.removed__O__sci_MapOps = (function(key) {
  return this
});
$c_sci_Map$EmptyMap$.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return new $c_sci_Map$Map1(key, value)
});
$c_sci_Map$EmptyMap$.prototype.apply__O__O = (function(key) {
  this.apply__O__E(key)
});
var $d_sci_Map$EmptyMap$ = new $TypeData().initClass({
  sci_Map$EmptyMap$: 0
}, false, "scala.collection.immutable.Map$EmptyMap$", {
  sci_Map$EmptyMap$: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$EmptyMap$.prototype.$classData = $d_sci_Map$EmptyMap$;
var $n_sci_Map$EmptyMap$;
function $m_sci_Map$EmptyMap$() {
  if ((!$n_sci_Map$EmptyMap$)) {
    $n_sci_Map$EmptyMap$ = new $c_sci_Map$EmptyMap$()
  };
  return $n_sci_Map$EmptyMap$
}
function $ct_sci_Map$WithDefault__sci_Map__F1__($thiz, underlying, defaultValue) {
  $thiz.sci_Map$WithDefault__f_underlying = underlying;
  $thiz.sci_Map$WithDefault__f_defaultValue = defaultValue;
  return $thiz
}
/** @constructor */
function $c_sci_Map$WithDefault() {
  this.sci_Map$WithDefault__f_underlying = null;
  this.sci_Map$WithDefault__f_defaultValue = null
}
$c_sci_Map$WithDefault.prototype = new $h_sci_AbstractMap();
$c_sci_Map$WithDefault.prototype.constructor = $c_sci_Map$WithDefault;
/** @constructor */
function $h_sci_Map$WithDefault() {
  /*<skip>*/
}
$h_sci_Map$WithDefault.prototype = $c_sci_Map$WithDefault.prototype;
$c_sci_Map$WithDefault.prototype.get__O__s_Option = (function(key) {
  return $n(this.sci_Map$WithDefault__f_underlying).get__O__s_Option(key)
});
$c_sci_Map$WithDefault.prototype.default__O__O = (function(key) {
  return $n(this.sci_Map$WithDefault__f_defaultValue).apply__O__O(key)
});
$c_sci_Map$WithDefault.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $n(this.sci_Map$WithDefault__f_underlying).iterableFactory__sc_IterableFactory()
});
$c_sci_Map$WithDefault.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sci_Map$WithDefault__f_underlying).iterator__sc_Iterator()
});
$c_sci_Map$WithDefault.prototype.isEmpty__Z = (function() {
  return $n(this.sci_Map$WithDefault__f_underlying).isEmpty__Z()
});
$c_sci_Map$WithDefault.prototype.mapFactory__sc_MapFactory = (function() {
  return $n(this.sci_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory()
});
$c_sci_Map$WithDefault.prototype.removed__O__sci_Map$WithDefault = (function(key) {
  return $ct_sci_Map$WithDefault__sci_Map__F1__(new $c_sci_Map$WithDefault(), $as_sci_Map($n(this.sci_Map$WithDefault__f_underlying).removed__O__sci_MapOps(key)), this.sci_Map$WithDefault__f_defaultValue)
});
$c_sci_Map$WithDefault.prototype.updated__O__O__sci_Map$WithDefault = (function(key, value) {
  return $ct_sci_Map$WithDefault__sci_Map__F1__(new $c_sci_Map$WithDefault(), $as_sci_Map($n(this.sci_Map$WithDefault__f_underlying).updated__O__O__sci_MapOps(key, value)), this.sci_Map$WithDefault__f_defaultValue)
});
$c_sci_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__sci_Map$WithDefault = (function(coll) {
  return $ct_sci_Map$WithDefault__sci_Map__F1__(new $c_sci_Map$WithDefault(), $as_sci_Map($n($n(this.sci_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(coll)), this.sci_Map$WithDefault__f_defaultValue)
});
$c_sci_Map$WithDefault.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$3 = new $c_sci_MapBuilderImpl();
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_sci_Map(p$2);
    return $ct_sci_Map$WithDefault__sci_Map__F1__(new $c_sci_Map$WithDefault(), p, this.sci_Map$WithDefault__f_defaultValue)
  }));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_Map$WithDefault(coll)
});
$c_sci_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_Map$WithDefault(coll)
});
$c_sci_Map$WithDefault.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map$WithDefault(key, value)
});
$c_sci_Map$WithDefault.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map$WithDefault(key)
});
var $d_sci_Map$WithDefault = new $TypeData().initClass({
  sci_Map$WithDefault: 0
}, false, "scala.collection.immutable.Map$WithDefault", {
  sci_Map$WithDefault: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$WithDefault.prototype.$classData = $d_sci_Map$WithDefault;
function $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__($thiz, outer) {
  if ((outer === null)) {
    $n(null)
  } else {
    $thiz.sci_MapOps$ImmutableKeySet__f_$outer = outer
  };
  return $thiz
}
/** @constructor */
function $c_sci_MapOps$ImmutableKeySet() {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null
}
$c_sci_MapOps$ImmutableKeySet.prototype = new $h_sci_AbstractSet();
$c_sci_MapOps$ImmutableKeySet.prototype.constructor = $c_sci_MapOps$ImmutableKeySet;
/** @constructor */
function $h_sci_MapOps$ImmutableKeySet() {
  /*<skip>*/
}
$h_sci_MapOps$ImmutableKeySet.prototype = $c_sci_MapOps$ImmutableKeySet.prototype;
$c_sci_MapOps$ImmutableKeySet.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).keysIterator__sc_Iterator()
});
$c_sci_MapOps$ImmutableKeySet.prototype.contains__O__Z = (function(key) {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).contains__O__Z(key)
});
$c_sci_MapOps$ImmutableKeySet.prototype.size__I = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).size__I()
});
$c_sci_MapOps$ImmutableKeySet.prototype.knownSize__I = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).knownSize__I()
});
$c_sci_MapOps$ImmutableKeySet.prototype.isEmpty__Z = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).isEmpty__Z()
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_Set = (function(elem) {
  if ($n(this.sci_MapOps$ImmutableKeySet__f_$outer).contains__O__Z(elem)) {
    return this
  } else {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $n($as_sci_SetOps($f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this)));
    return $as_sci_Set(this$3.incl__O__sci_SetOps(elem))
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_Set = (function(elem) {
  if ($n(this.sci_MapOps$ImmutableKeySet__f_$outer).contains__O__Z(elem)) {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $n($as_sci_SetOps($f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this)));
    return $as_sci_Set(this$3.excl__O__sci_SetOps(elem))
  } else {
    return this
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
function $as_sci_MapOps$ImmutableKeySet(obj) {
  return (((obj instanceof $c_sci_MapOps$ImmutableKeySet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapOps$ImmutableKeySet"))
}
function $isArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapOps$ImmutableKeySet)))
}
function $asArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) {
  return (($isArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapOps$ImmutableKeySet;", depth))
}
var $d_sci_MapOps$ImmutableKeySet = new $TypeData().initClass({
  sci_MapOps$ImmutableKeySet: 0
}, false, "scala.collection.immutable.MapOps$ImmutableKeySet", {
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_MapOps$ImmutableKeySet.prototype.$classData = $d_sci_MapOps$ImmutableKeySet;
function $f_scm_Buffer__subtractOne__O__scm_Buffer($thiz, x) {
  var i = $thiz.indexOf__O__I__I(x, 0);
  if ((i !== (-1))) {
    $thiz.remove__I__O(i)
  };
  return $thiz
}
function $is_scm_Buffer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Buffer)))
}
function $as_scm_Buffer(obj) {
  return (($is_scm_Buffer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Buffer"))
}
function $isArrayOf_scm_Buffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Buffer)))
}
function $asArrayOf_scm_Buffer(obj, depth) {
  return (($isArrayOf_scm_Buffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Buffer;", depth))
}
/** @constructor */
function $c_Lcats_EvalInstances$$anon$6(outer) {
  /*<skip>*/
}
$c_Lcats_EvalInstances$$anon$6.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$6.prototype.constructor = $c_Lcats_EvalInstances$$anon$6;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$6() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$6.prototype = $c_Lcats_EvalInstances$$anon$6.prototype;
$c_Lcats_EvalInstances$$anon$6.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_EvalInstances$$anon$6.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_EvalInstances$$anon$6.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_Eval(fa);
  return $n(fa$1).map__F1__Lcats_Eval(f)
});
$c_Lcats_EvalInstances$$anon$6.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return $n(fa$1).flatMap__F1__Lcats_Eval(f)
});
$c_Lcats_EvalInstances$$anon$6.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return $n(fa$1).map__F1__Lcats_Eval(f)
});
var $d_Lcats_EvalInstances$$anon$6 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$6: 0
}, false, "cats.EvalInstances$$anon$6", {
  Lcats_EvalInstances$$anon$6: 1,
  O: 1,
  Lcats_Bimonad: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_Apply: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Applicative: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Comonad: 1,
  Lcats_CoflatMap: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1
});
$c_Lcats_EvalInstances$$anon$6.prototype.$classData = $d_Lcats_EvalInstances$$anon$6;
/** @constructor */
function $c_Lcats_instances_QueueInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_QueueInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_QueueInstances$$anon$1.prototype.constructor = $c_Lcats_instances_QueueInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_QueueInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_QueueInstances$$anon$1.prototype = $c_Lcats_instances_QueueInstances$$anon$1.prototype;
$c_Lcats_instances_QueueInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Queue(fa);
  var this$1 = $n(fa$1);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__map__F1__O(this$1, f))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__sci_Queue__sci_Queue__F2__sci_Queue = (function(fa, fb, f) {
  if ($n(fb).isEmpty__Z()) {
    return $m_sci_Queue$EmptyQueue$()
  } else {
    var this$2 = $n(fa);
    var b = $m_sci_Queue$().newBuilder__scm_Builder();
    var it = this$2.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var this$5 = $n(b);
      var arg1 = $n(it).next__O();
      var this$3 = $n(fb);
      var b$1 = $m_sci_Queue$().newBuilder__scm_Builder();
      var it$1 = this$3.iterator__sc_Iterator();
      while ($n(it$1).hasNext__Z()) {
        var this$4 = $n(b$1);
        var arg1$1 = $n(it$1).next__O();
        var elem = $n(f).apply__O__O__O(arg1, arg1$1);
        this$4.addOne__O__scm_Growable(elem)
      };
      var xs = $as_sci_Queue($n(b$1).result__O());
      this$5.addAll__sc_IterableOnce__scm_Growable(xs)
    };
    return $as_sci_Queue($n(b).result__O())
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_QueueMonoid()
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Queue__sci_Queue__F2__sci_Queue($as_sci_Queue(fa), $as_sci_Queue(fb), f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Queue(fa);
  var this$1 = $n(fa$1);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this$1, f))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Queue(fa);
  var this$1 = $n(fa$1);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__map__F1__O(this$1, f))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Queue(x);
  var y$1 = $as_sci_Queue(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Queue(y$1)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$()
});
var $d_Lcats_instances_QueueInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_QueueInstances$$anon$1: 0
}, false, "cats.instances.QueueInstances$$anon$1", {
  Lcats_instances_QueueInstances$$anon$1: 1,
  O: 1,
  Lcats_Traverse: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Alternative: 1,
  Lcats_Applicative: 1,
  Lcats_Apply: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_MonoidK: 1,
  Lcats_SemigroupK: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_CoflatMap: 1
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.$classData = $d_Lcats_instances_QueueInstances$$anon$1;
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set($thiz, newHashMap) {
  return ((newHashMap === $as_sci_HashMap($thiz.sci_MapOps$ImmutableKeySet__f_$outer)) ? $thiz : $n(newHashMap).keySet__sci_Set())
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set($thiz, newRootNode) {
  return ((newRootNode === $n($as_sci_HashMap($thiz.sci_MapOps$ImmutableKeySet__f_$outer)).sci_HashMap__f_rootNode) ? $thiz : new $c_sci_HashMap(newRootNode).keySet__sci_Set())
}
/** @constructor */
function $c_sci_HashMap$HashKeySet(outer) {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null;
  $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(this, outer)
}
$c_sci_HashMap$HashKeySet.prototype = new $h_sci_MapOps$ImmutableKeySet();
$c_sci_HashMap$HashKeySet.prototype.constructor = $c_sci_HashMap$HashKeySet;
/** @constructor */
function $h_sci_HashMap$HashKeySet() {
  /*<skip>*/
}
$h_sci_HashMap$HashKeySet.prototype = $c_sci_HashMap$HashKeySet.prototype;
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_Set = (function(elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  var improvedHash = $m_sc_Hashing$().improve__I__I(originalHash);
  var newNode = $n($n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer)).sci_HashMap__f_rootNode).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(elem, null, originalHash, improvedHash, 0, false);
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set(this, newNode)
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_Set = (function(elem) {
  var this$1 = $n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$1.removed__O__sci_HashMap(elem))
});
$c_sci_HashMap$HashKeySet.prototype.filter__F1__sci_Set = (function(pred) {
  var this$2 = $n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer));
  var pred$1 = new $c_sjsr_AnonFunction1(((kv$2) => {
    var kv = $as_T2(kv$2);
    return $uZ($n(pred).apply__O__O($n(kv)._1__O()))
  }));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$2.filterImpl__F1__Z__sci_HashMap(pred$1, false))
});
$c_sci_HashMap$HashKeySet.prototype.filterNot__F1__sci_Set = (function(pred) {
  var this$2 = $n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer));
  var pred$1 = new $c_sjsr_AnonFunction1(((kv$2) => {
    var kv = $as_T2(kv$2);
    return $uZ($n(pred).apply__O__O($n(kv)._1__O()))
  }));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$2.filterImpl__F1__Z__sci_HashMap(pred$1, true))
});
$c_sci_HashMap$HashKeySet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterNot__F1__sci_Set(pred)
});
$c_sci_HashMap$HashKeySet.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_Set(pred)
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
function $as_sci_HashMap$HashKeySet(obj) {
  return (((obj instanceof $c_sci_HashMap$HashKeySet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashMap$HashKeySet"))
}
function $isArrayOf_sci_HashMap$HashKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap$HashKeySet)))
}
function $asArrayOf_sci_HashMap$HashKeySet(obj, depth) {
  return (($isArrayOf_sci_HashMap$HashKeySet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashMap$HashKeySet;", depth))
}
var $d_sci_HashMap$HashKeySet = new $TypeData().initClass({
  sci_HashMap$HashKeySet: 0
}, false, "scala.collection.immutable.HashMap$HashKeySet", {
  sci_HashMap$HashKeySet: 1,
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap$HashKeySet.prototype.$classData = $d_sci_HashMap$HashKeySet;
/** @constructor */
function $c_sci_Map$Map1(key1, value1) {
  this.sci_Map$Map1__f_key1 = null;
  this.sci_Map$Map1__f_value1 = null;
  this.sci_Map$Map1__f_key1 = key1;
  this.sci_Map$Map1__f_value1 = value1
}
$c_sci_Map$Map1.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map1.prototype.constructor = $c_sci_Map$Map1;
/** @constructor */
function $h_sci_Map$Map1() {
  /*<skip>*/
}
$h_sci_Map$Map1.prototype = $c_sci_Map$Map1.prototype;
$c_sci_Map$Map1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map1.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Map$Map1.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Map$Map1.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Map$Map1.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Map$Map1.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false)
});
$c_sci_Map$Map1.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true)
});
$c_sci_Map$Map1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_Map$Map1.prototype.size__I = (function() {
  return 1
});
$c_sci_Map$Map1.prototype.knownSize__I = (function() {
  return 1
});
$c_sci_Map$Map1.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map1.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)) {
    return this.sci_Map$Map1__f_value1
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map1.prototype.contains__O__Z = (function(key) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)
});
$c_sci_Map$Map1.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_s_Some(this.sci_Map$Map1__f_value1) : $m_s_None$())
});
$c_sci_Map$Map1.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? this.sci_Map$Map1__f_value1 : $n(default$1).apply__O())
});
$c_sci_Map$Map1.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = $ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Map$Map1.prototype.keysIterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sci_Map$Map1__f_key1;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Map$Map1.prototype.valuesIterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sci_Map$Map1__f_value1;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_sci_Map$Map1(this.sci_Map$Map1__f_key1, value) : new $c_sci_Map$Map2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1, key, value))
});
$c_sci_Map$Map1.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? $m_sci_Map$EmptyMap$() : this)
});
$c_sci_Map$Map1.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))
});
$c_sci_Map$Map1.prototype.exists__F1__Z = (function(p) {
  return $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1)))
});
$c_sci_Map$Map1.prototype.forall__F1__Z = (function(p) {
  return $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1)))
});
$c_sci_Map$Map1.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  return (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))) !== isFlipped) ? this : $m_sci_Map$EmptyMap$())
});
$c_sci_Map$Map1.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 1)
});
$c_sci_Map$Map1.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
function $as_sci_Map$Map1(obj) {
  return (((obj instanceof $c_sci_Map$Map1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map1"))
}
function $isArrayOf_sci_Map$Map1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map1)))
}
function $asArrayOf_sci_Map$Map1(obj, depth) {
  return (($isArrayOf_sci_Map$Map1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map1;", depth))
}
var $d_sci_Map$Map1 = new $TypeData().initClass({
  sci_Map$Map1: 0
}, false, "scala.collection.immutable.Map$Map1", {
  sci_Map$Map1: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map1.prototype.$classData = $d_sci_Map$Map1;
/** @constructor */
function $c_sci_Map$Map2(key1, value1, key2, value2) {
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = key1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = value1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = key2;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = value2
}
$c_sci_Map$Map2.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map2.prototype.constructor = $c_sci_Map$Map2;
/** @constructor */
function $h_sci_Map$Map2() {
  /*<skip>*/
}
$h_sci_Map$Map2.prototype = $c_sci_Map$Map2.prototype;
$c_sci_Map$Map2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map2.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Map$Map2.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Map$Map2.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Map$Map2.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Map$Map2.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false)
});
$c_sci_Map$Map2.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true)
});
$c_sci_Map$Map2.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_Map$Map2.prototype.size__I = (function() {
  return 2
});
$c_sci_Map$Map2.prototype.knownSize__I = (function() {
  return 2
});
$c_sci_Map$Map2.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map2.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map2.prototype.contains__O__Z = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2))
});
$c_sci_Map$Map2.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : $m_s_None$()))
});
$c_sci_Map$Map2.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 : $n(default$1).apply__O()))
});
$c_sci_Map$Map2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$1(this)
});
$c_sci_Map$Map2.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$2(this)
});
$c_sci_Map$Map2.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$3(this)
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, value, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, value) : new $c_sci_Map$Map3(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2, key, value)))
});
$c_sci_Map$Map2.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : this))
});
$c_sci_Map$Map2.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1));
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))
});
$c_sci_Map$Map2.prototype.exists__F1__Z = (function(p) {
  return ($uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) || $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))))
});
$c_sci_Map$Map2.prototype.forall__F1__Z = (function(p) {
  return ($uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) && $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))))
});
$c_sci_Map$Map2.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var v1 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1;
    v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1;
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2;
      v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2
    };
    n = ((1 + n) | 0)
  };
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break
    }
    case 2: {
      return this;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_Map$Map2.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 2)
});
$c_sci_Map$Map2.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
function $as_sci_Map$Map2(obj) {
  return (((obj instanceof $c_sci_Map$Map2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map2"))
}
function $isArrayOf_sci_Map$Map2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map2)))
}
function $asArrayOf_sci_Map$Map2(obj, depth) {
  return (($isArrayOf_sci_Map$Map2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map2;", depth))
}
var $d_sci_Map$Map2 = new $TypeData().initClass({
  sci_Map$Map2: 0
}, false, "scala.collection.immutable.Map$Map2", {
  sci_Map$Map2: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map2.prototype.$classData = $d_sci_Map$Map2;
/** @constructor */
function $c_sci_Map$Map3(key1, value1, key2, value2, key3, value3) {
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = key1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = value1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = key2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = value2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = key3;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = value3
}
$c_sci_Map$Map3.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map3.prototype.constructor = $c_sci_Map$Map3;
/** @constructor */
function $h_sci_Map$Map3() {
  /*<skip>*/
}
$h_sci_Map$Map3.prototype = $c_sci_Map$Map3.prototype;
$c_sci_Map$Map3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map3.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Map$Map3.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Map$Map3.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Map$Map3.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Map$Map3.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false)
});
$c_sci_Map$Map3.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true)
});
$c_sci_Map$Map3.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_Map$Map3.prototype.size__I = (function() {
  return 3
});
$c_sci_Map$Map3.prototype.knownSize__I = (function() {
  return 3
});
$c_sci_Map$Map3.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map3.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map3.prototype.contains__O__Z = (function(key) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3))
});
$c_sci_Map$Map3.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : $m_s_None$())))
});
$c_sci_Map$Map3.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 : $n(default$1).apply__O())))
});
$c_sci_Map$Map3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$4(this)
});
$c_sci_Map$Map3.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$5(this)
});
$c_sci_Map$Map3.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$6(this)
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, value) : new $c_sci_Map$Map4(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3, key, value))))
});
$c_sci_Map$Map3.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : this)))
});
$c_sci_Map$Map3.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1));
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2));
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))
});
$c_sci_Map$Map3.prototype.exists__F1__Z = (function(p) {
  return (($uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) || $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2)))) || $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))))
});
$c_sci_Map$Map3.prototype.forall__F1__Z = (function(p) {
  return (($uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) && $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2)))) && $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))))
});
$c_sci_Map$Map3.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var v1 = null;
  var v2 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1;
    v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1;
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2
    } else {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2
    };
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3
    };
    n = ((1 + n) | 0)
  };
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break
    }
    case 3: {
      return this;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_Map$Map3.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 3)
});
$c_sci_Map$Map3.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
function $as_sci_Map$Map3(obj) {
  return (((obj instanceof $c_sci_Map$Map3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map3"))
}
function $isArrayOf_sci_Map$Map3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map3)))
}
function $asArrayOf_sci_Map$Map3(obj, depth) {
  return (($isArrayOf_sci_Map$Map3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map3;", depth))
}
var $d_sci_Map$Map3 = new $TypeData().initClass({
  sci_Map$Map3: 0
}, false, "scala.collection.immutable.Map$Map3", {
  sci_Map$Map3: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map3.prototype.$classData = $d_sci_Map$Map3;
/** @constructor */
function $c_sci_Map$Map4(key1, value1, key2, value2, key3, value3, key4, value4) {
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = key1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = value1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = key2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = value2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = key3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = value3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = key4;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = value4
}
$c_sci_Map$Map4.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map4.prototype.constructor = $c_sci_Map$Map4;
/** @constructor */
function $h_sci_Map$Map4() {
  /*<skip>*/
}
$h_sci_Map$Map4.prototype = $c_sci_Map$Map4.prototype;
$c_sci_Map$Map4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map4.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Map$Map4.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Map$Map4.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Map$Map4.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Map$Map4.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false)
});
$c_sci_Map$Map4.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true)
});
$c_sci_Map$Map4.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_Map$Map4.prototype.size__I = (function() {
  return 4
});
$c_sci_Map$Map4.prototype.knownSize__I = (function() {
  return 4
});
$c_sci_Map$Map4.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map4.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map4.prototype.contains__O__Z = (function(key) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4))
});
$c_sci_Map$Map4.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : $m_s_None$()))))
});
$c_sci_Map$Map4.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 : $n(default$1).apply__O()))))
});
$c_sci_Map$Map4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$7(this)
});
$c_sci_Map$Map4.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$8(this)
});
$c_sci_Map$Map4.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$9(this)
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_Map = (function(key, value) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, value)
  } else {
    var this$1 = $m_sci_HashMap$();
    return $n($n($n($n($n(this$1.sci_HashMap$__f_EmptyMap).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1)).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)).updated__O__O__sci_HashMap(key, value)
  }
});
$c_sci_Map$Map4.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : this))))
});
$c_sci_Map$Map4.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1));
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2));
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3));
  $n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))
});
$c_sci_Map$Map4.prototype.exists__F1__Z = (function(p) {
  return ((($uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) || $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)))) || $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)))) || $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))))
});
$c_sci_Map$Map4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) && $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)))) && $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)))) && $uZ($n(p).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))))
});
$c_sci_Map$Map4.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var k3 = null;
  var v1 = null;
  var v2 = null;
  var v3 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1;
    v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1;
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2
    } else {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2
    };
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
    } else {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
    };
    n = ((1 + n) | 0)
  };
  if (($uZ($n(pred).apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
    } else if ((n === 2)) {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
    };
    n = ((1 + n) | 0)
  };
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break
    }
    case 3: {
      return new $c_sci_Map$Map3(k1, v1, k2, v2, k3, v3);
      break
    }
    case 4: {
      return this;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_Map$Map4.prototype.buildTo__sci_HashMapBuilder__sci_HashMapBuilder = (function(builder) {
  return $n($n($n($n(builder).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1)).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
});
$c_sci_Map$Map4.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 4)
});
$c_sci_Map$Map4.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
function $as_sci_Map$Map4(obj) {
  return (((obj instanceof $c_sci_Map$Map4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map4"))
}
function $isArrayOf_sci_Map$Map4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map4)))
}
function $asArrayOf_sci_Map$Map4(obj, depth) {
  return (($isArrayOf_sci_Map$Map4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map4;", depth))
}
var $d_sci_Map$Map4 = new $TypeData().initClass({
  sci_Map$Map4: 0
}, false, "scala.collection.immutable.Map$Map4", {
  sci_Map$Map4: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map4.prototype.$classData = $d_sci_Map$Map4;
function $f_sci_SortedMap__withDefaultValue__O__sci_SortedMap($thiz, d) {
  return new $c_sci_SortedMap$WithDefault($thiz, new $c_sjsr_AnonFunction1(((x$1$2) => d)))
}
function $is_sci_SortedMap(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SortedMap)))
}
function $as_sci_SortedMap(obj) {
  return (($is_sci_SortedMap(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SortedMap"))
}
function $isArrayOf_sci_SortedMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SortedMap)))
}
function $asArrayOf_sci_SortedMap(obj, depth) {
  return (($isArrayOf_sci_SortedMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SortedMap;", depth))
}
function $f_scm_Map__withDefaultValue__O__scm_Map($thiz, d) {
  return new $c_scm_Map$WithDefault($thiz, new $c_sjsr_AnonFunction1(((x$2) => d)))
}
function $is_scm_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Map)))
}
function $as_scm_Map(obj) {
  return (($is_scm_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Map"))
}
function $isArrayOf_scm_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Map)))
}
function $asArrayOf_scm_Map(obj, depth) {
  return (($isArrayOf_scm_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Map;", depth))
}
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_LazyListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_LazyListInstances$$anon$1.prototype = $c_Lcats_instances_LazyListInstances$$anon$1.prototype;
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).map__F1__sci_LazyList(f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__sci_LazyList__sci_LazyList__sci_LazyList = (function(x, y) {
  return $n(x).lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0((() => y)))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList = (function(fa, fb, f) {
  return ($n(fb).isEmpty__Z() ? $n($m_s_package$().s_package$__f_LazyList).sci_LazyList$__f__empty : $n(fa).flatMap__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((a$2) => $n(fb).map__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((b$2) => $n(f).apply__O__O__O(a$2, b$2))))))))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_LazyListMonoid()
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList($as_sci_LazyList(fa), $as_sci_LazyList(fb), f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).flatMap__F1__sci_LazyList(f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).map__F1__sci_LazyList(f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_LazyList__sci_LazyList__sci_LazyList($as_sci_LazyList(x), $as_sci_LazyList(y))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.empty__O = (function() {
  return $n($m_s_package$().s_package$__f_LazyList).sci_LazyList$__f__empty
});
var $d_Lcats_instances_LazyListInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_LazyListInstances$$anon$1: 0
}, false, "cats.instances.LazyListInstances$$anon$1", {
  Lcats_instances_LazyListInstances$$anon$1: 1,
  O: 1,
  Lcats_Traverse: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Alternative: 1,
  Lcats_Applicative: 1,
  Lcats_Apply: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_MonoidK: 1,
  Lcats_SemigroupK: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.$classData = $d_Lcats_instances_LazyListInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_ListInstances$$anon$1(outer) {
  $m_Lcats_Eval$();
  var a = $m_sci_Nil$();
  new $c_Lcats_Now(a)
}
$c_Lcats_instances_ListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_ListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_ListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_ListInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_ListInstances$$anon$1.prototype = $c_Lcats_instances_ListInstances$$anon$1.prototype;
$c_Lcats_instances_ListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_List(fa);
  return $n(fa$1).map__F1__sci_List(f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__sci_List__sci_List__F2__sci_List = (function(fa, fb, f) {
  if ($n(fb).isEmpty__Z()) {
    return $m_sci_Nil$()
  } else {
    var this$1 = $n(fa);
    var rest = this$1;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var this$3 = $n(fb);
      var f$1 = ((f, arg1) => ((b$2) => $n(f).apply__O__O__O(arg1, b$2)))(f, arg1);
      if ((this$3 === $m_sci_Nil$())) {
        var $$x1 = $m_sci_Nil$()
      } else {
        var arg1$1 = this$3.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(this$3.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest$1).head__O();
          var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
          $n(t$1).sci_$colon$colon__f_next = nx;
          t$1 = nx;
          rest$1 = $as_sci_List($n(rest$1).tail__O())
        };
        var $$x1 = h$1
      };
      var it = $n($$x1).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx$1
        } else {
          $n(t).sci_$colon$colon__f_next = nx$1
        };
        t = nx$1
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    return ((h === null) ? $m_sci_Nil$() : h)
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_ListMonoid()
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_List__sci_List__F2__sci_List($as_sci_List(fa), $as_sci_List(fb), f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return $n(fa$1).flatMap__F1__sci_List(f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return $n(fa$1).map__F1__sci_List(f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_List(x);
  var y$1 = $as_sci_List(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_List(y$1)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Nil$()
});
var $d_Lcats_instances_ListInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_ListInstances$$anon$1: 0
}, false, "cats.instances.ListInstances$$anon$1", {
  Lcats_instances_ListInstances$$anon$1: 1,
  O: 1,
  Lcats_Traverse: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Alternative: 1,
  Lcats_Applicative: 1,
  Lcats_Apply: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_MonoidK: 1,
  Lcats_SemigroupK: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.$classData = $d_Lcats_instances_ListInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$1(outer) {
  $m_Lcats_Eval$();
  var a = $m_sci_Seq$().empty__sc_SeqOps();
  new $c_Lcats_Now(a)
}
$c_Lcats_instances_SeqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SeqInstances$$anon$1.prototype = $c_Lcats_instances_SeqInstances$$anon$1.prototype;
$c_Lcats_instances_SeqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq($n(fa$1).map__F1__O(f))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__sci_Seq__sci_Seq__F2__sci_Seq = (function(fa, fb, f) {
  return ($n(fb).isEmpty__Z() ? $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()) : $as_sci_Seq($n(fa).flatMap__F1__O(new $c_sjsr_AnonFunction1(((a$2) => $as_sci_Seq($n(fb).map__F1__O(new $c_sjsr_AnonFunction1(((b$2) => $n(f).apply__O__O__O(a$2, b$2))))))))))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_SeqMonoid()
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Seq__sci_Seq__F2__sci_Seq($as_sci_Seq(fa), $as_sci_Seq(fb), f)
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq($n(fa$1).flatMap__F1__O(f))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq($n(fa$1).map__F1__O(f))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Seq(x);
  var y$1 = $as_sci_Seq(y);
  var this$1 = $n(x$1);
  return $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(y$1))
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.empty__O = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps())
});
var $d_Lcats_instances_SeqInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SeqInstances$$anon$1: 0
}, false, "cats.instances.SeqInstances$$anon$1", {
  Lcats_instances_SeqInstances$$anon$1: 1,
  O: 1,
  Lcats_Traverse: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_Apply: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Applicative: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Alternative: 1,
  Lcats_MonoidK: 1,
  Lcats_SemigroupK: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.$classData = $d_Lcats_instances_SeqInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_StreamInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_StreamInstances$$anon$1.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_StreamInstances$$anon$1.prototype = $c_Lcats_instances_StreamInstances$$anon$1.prototype;
$c_Lcats_instances_StreamInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).map__F1__sci_Stream(f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__sci_Stream__sci_Stream__sci_Stream = (function(x, y) {
  var l = new $c_sjsr_AnonFunction0((() => y));
  return $n(x).lazyAppendedAll__F0__sci_Stream(l)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__sci_Stream__sci_Stream__F2__sci_Stream = (function(fa, fb, f) {
  return ($n(fb).isEmpty__Z() ? ($n($m_s_package$().s_package$__f_Stream), $m_sci_Stream$Empty$()) : $n(fa).flatMap__F1__sci_Stream(new $c_sjsr_AnonFunction1(((a$2) => $n(fb).map__F1__sci_Stream(new $c_sjsr_AnonFunction1(((b$2) => $n(f).apply__O__O__O(a$2, b$2))))))))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_StreamMonoid()
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Stream__sci_Stream__F2__sci_Stream($as_sci_Stream(fa), $as_sci_Stream(fb), f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).flatMap__F1__sci_Stream(f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).map__F1__sci_Stream(f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_Stream__sci_Stream__sci_Stream($as_sci_Stream(x), $as_sci_Stream(y))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$()
});
var $d_Lcats_instances_StreamInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_StreamInstances$$anon$1: 0
}, false, "cats.instances.StreamInstances$$anon$1", {
  Lcats_instances_StreamInstances$$anon$1: 1,
  O: 1,
  Lcats_Traverse: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Alternative: 1,
  Lcats_Applicative: 1,
  Lcats_Apply: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_MonoidK: 1,
  Lcats_SemigroupK: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.$classData = $d_Lcats_instances_StreamInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_VectorInstances$$anon$1(outer) {
  $m_Lcats_Eval$();
  $n($m_s_package$().s_package$__f_Vector);
  var a = $m_sci_Vector0$();
  new $c_Lcats_Now(a)
}
$c_Lcats_instances_VectorInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_VectorInstances$$anon$1.prototype.constructor = $c_Lcats_instances_VectorInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_VectorInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_VectorInstances$$anon$1.prototype = $c_Lcats_instances_VectorInstances$$anon$1.prototype;
$c_Lcats_instances_VectorInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Vector(fa);
  return $as_sci_Vector($n(fa$1).map__F1__O(f))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__sci_Vector__sci_Vector__F2__sci_Vector = (function(fa, fb, f) {
  var this$1 = $n(fb);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    $n($m_s_package$().s_package$__f_Vector);
    return $m_sci_Vector0$()
  } else {
    var this$3 = $n(fa);
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$3.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1 = $n(it).next__O();
      var xs = $as_sci_Vector($n(fb).map__F1__O(new $c_sjsr_AnonFunction1(((f, arg1) => ((b$2) => $n(f).apply__O__O__O(arg1, b$2)))(f, arg1))));
      b.addAll__sc_IterableOnce__sci_VectorBuilder(xs)
    };
    return b.result__sci_Vector()
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_VectorMonoid()
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Vector__sci_Vector__F2__sci_Vector($as_sci_Vector(fa), $as_sci_Vector(fb), f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  var this$1 = $n(fa$1);
  return $as_sci_Vector($f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this$1, f))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  return $as_sci_Vector($n(fa$1).map__F1__O(f))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Vector(x);
  var y$1 = $as_sci_Vector(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Vector(y$1)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.empty__O = (function() {
  $n($m_s_package$().s_package$__f_Vector);
  return $m_sci_Vector0$()
});
var $d_Lcats_instances_VectorInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_VectorInstances$$anon$1: 0
}, false, "cats.instances.VectorInstances$$anon$1", {
  Lcats_instances_VectorInstances$$anon$1: 1,
  O: 1,
  Lcats_Traverse: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_Apply: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Applicative: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Alternative: 1,
  Lcats_MonoidK: 1,
  Lcats_SemigroupK: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.$classData = $d_Lcats_instances_VectorInstances$$anon$1;
/** @constructor */
function $c_Lcats_kernel_Semigroup$() {
  /*<skip>*/
}
$c_Lcats_kernel_Semigroup$.prototype = new $h_Lcats_kernel_SemigroupFunctions();
$c_Lcats_kernel_Semigroup$.prototype.constructor = $c_Lcats_kernel_Semigroup$;
/** @constructor */
function $h_Lcats_kernel_Semigroup$() {
  /*<skip>*/
}
$h_Lcats_kernel_Semigroup$.prototype = $c_Lcats_kernel_Semigroup$.prototype;
var $d_Lcats_kernel_Semigroup$ = new $TypeData().initClass({
  Lcats_kernel_Semigroup$: 0
}, false, "cats.kernel.Semigroup$", {
  Lcats_kernel_Semigroup$: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  O: 1,
  Lcats_kernel_ScalaVersionSpecificMonoidInstances: 1,
  Lcats_kernel_instances_TupleCommutativeGroupInstances: 1,
  Lcats_kernel_instances_TupleBoundedSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleGroupInstances: 1,
  Lcats_kernel_instances_TupleCommutativeMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleMonoidInstances: 1,
  Lcats_kernel_instances_TupleCommutativeSemigroupInstances: 1,
  Lcats_kernel_instances_TupleBandInstances: 1,
  Lcats_kernel_instances_TupleSemigroupInstances: 1,
  Lcats_kernel_GroupInstances: 1,
  Lcats_kernel_BoundedSemilatticeInstances: 1,
  Lcats_kernel_SemilatticeInstances: 1,
  Lcats_kernel_CommutativeMonoidInstances: 1,
  Lcats_kernel_MonoidInstances: 1,
  Lcats_kernel_BandInstances: 1,
  Lcats_kernel_CommutativeSemigroupInstances: 1,
  Lcats_kernel_SemigroupInstances: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_kernel_Semigroup$.prototype.$classData = $d_Lcats_kernel_Semigroup$;
var $n_Lcats_kernel_Semigroup$;
function $m_Lcats_kernel_Semigroup$() {
  if ((!$n_Lcats_kernel_Semigroup$)) {
    $n_Lcats_kernel_Semigroup$ = new $c_Lcats_kernel_Semigroup$()
  };
  return $n_Lcats_kernel_Semigroup$
}
function $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet($thiz, newRootNode) {
  return (($thiz.sci_HashSet__f_rootNode === newRootNode) ? $thiz : new $c_sci_HashSet(newRootNode))
}
function $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet($thiz, that) {
  var iter = $n(that).iterator__sc_Iterator();
  var curr = $thiz.sci_HashSet__f_rootNode;
  while ($n(iter).hasNext__Z()) {
    var next = $n(iter).next__O();
    var originalHash = $m_sr_Statics$().anyHash__O__I(next);
    var improved = $m_sc_Hashing$().improve__I__I(originalHash);
    curr = $n(curr).removed__O__I__I__I__sci_BitmapIndexedSetNode(next, originalHash, improved, 0);
    if ((curr !== $thiz.sci_HashSet__f_rootNode)) {
      if (($n(curr).sci_BitmapIndexedSetNode__f_size === 0)) {
        var this$1 = $m_sci_HashSet$();
        return this$1.sci_HashSet$__f_EmptySet
      };
      while ($n(iter).hasNext__Z()) {
        var next$2 = $n(iter).next__O();
        var originalHash$2 = $m_sr_Statics$().anyHash__O__I(next$2);
        var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
        $n(curr).removeWithShallowMutations__O__I__I__sci_BitmapIndexedSetNode(next$2, originalHash$2, improved$2);
        if (($n(curr).sci_BitmapIndexedSetNode__f_size === 0)) {
          var this$2 = $m_sci_HashSet$();
          return this$2.sci_HashSet$__f_EmptySet
        }
      };
      return new $c_sci_HashSet(curr)
    }
  };
  return $thiz
}
/** @constructor */
function $c_sci_HashSet(rootNode) {
  this.sci_HashSet__f_rootNode = null;
  this.sci_HashSet__f_rootNode = rootNode
}
$c_sci_HashSet.prototype = new $h_sci_AbstractSet();
$c_sci_HashSet.prototype.constructor = $c_sci_HashSet;
/** @constructor */
function $h_sci_HashSet() {
  /*<skip>*/
}
$h_sci_HashSet.prototype = $c_sci_HashSet.prototype;
$c_sci_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_HashSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_HashSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_HashSet.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_HashSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashSet(pred, false)
});
$c_sci_HashSet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashSet(pred, true)
});
$c_sci_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_HashSet$()
});
$c_sci_HashSet.prototype.knownSize__I = (function() {
  return $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size
});
$c_sci_HashSet.prototype.size__I = (function() {
  return $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size
});
$c_sci_HashSet.prototype.isEmpty__Z = (function() {
  return ($n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size === 0)
});
$c_sci_HashSet.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_SetIterator(this.sci_HashSet__f_rootNode))
});
$c_sci_HashSet.prototype.contains__O__Z = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  return $n(this.sci_HashSet__f_rootNode).contains__O__I__I__I__Z(element, elementUnimprovedHash, elementHash, 0)
});
$c_sci_HashSet.prototype.incl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = $n(this.sci_HashSet__f_rootNode).updated__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode)
});
$c_sci_HashSet.prototype.excl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = $n(this.sci_HashSet__f_rootNode).removed__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode)
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sci_HashSet = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if (this.isEmpty__Z()) {
      return x2
    } else {
      var newNode = $n(this.sci_HashSet__f_rootNode).concat__sci_SetNode__I__sci_BitmapIndexedSetNode($n(x2).sci_HashSet__f_rootNode, 0);
      return ((newNode === $n(x2).sci_HashSet__f_rootNode) ? x2 : $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newNode))
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(that);
    var this$1 = $n(x3);
    var iter = new $c_scm_HashSet$$anon$2(this$1);
    var current = this.sci_HashSet__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      var this$2 = $n(x3);
      var improvedHash = $n(next).scm_HashSet$Node__f__hash;
      var originalHash = this$2.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = $n(current).updated__O__I__I__I__sci_BitmapIndexedSetNode($n(next).scm_HashSet$Node__f__key, originalHash, improved, 0);
      if ((current !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while (iter.hasNext__Z()) {
          var next$2 = $as_scm_HashSet$Node(iter.next__O());
          var this$3 = $n(x3);
          var improvedHash$1 = $n(next$2).scm_HashSet$Node__f__hash;
          var originalHash$2 = this$3.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash$1);
          var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
          shallowlyMutableNodeMap = $n(current).updateWithShallowMutations__O__I__I__I__I__I($n(next$2).scm_HashSet$Node__f__key, originalHash$2, improved$2, 0, shallowlyMutableNodeMap)
        };
        return new $c_sci_HashSet(current)
      }
    };
    return this
  } else if (false) {
    var x4 = $as_scm_LinkedHashSet(that);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    var current$2 = this.sci_HashSet__f_rootNode;
    while ($n(iter$2).hasNext__Z()) {
      var next$3 = $as_scm_LinkedHashSet$Entry($n(iter$2).next__O());
      var originalHash$3 = $n(x4).unimproveHash__I__I($n(next$3).hash__I());
      var improved$3 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      current$2 = $n(current$2).updated__O__I__I__I__sci_BitmapIndexedSetNode($n(next$3).key__O(), originalHash$3, improved$3, 0);
      if ((current$2 !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$3, 0));
        while ($n(iter$2).hasNext__Z()) {
          var next$4 = $as_scm_LinkedHashSet$Entry($n(iter$2).next__O());
          var originalHash$4 = $n(x4).unimproveHash__I__I($n(next$4).hash__I());
          var improved$4 = $m_sc_Hashing$().improve__I__I(originalHash$4);
          shallowlyMutableNodeMap$2 = $n(current$2).updateWithShallowMutations__O__I__I__I__I__I($n(next$4).key__O(), originalHash$4, improved$4, 0, shallowlyMutableNodeMap$2)
        };
        return new $c_sci_HashSet(current$2)
      }
    };
    return this
  } else {
    var iter$3 = $n(that).iterator__sc_Iterator();
    var current$3 = this.sci_HashSet__f_rootNode;
    while ($n(iter$3).hasNext__Z()) {
      var element = $n(iter$3).next__O();
      var originalHash$5 = $m_sr_Statics$().anyHash__O__I(element);
      var improved$5 = $m_sc_Hashing$().improve__I__I(originalHash$5);
      current$3 = $n(current$3).updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash$5, improved$5, 0);
      if ((current$3 !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap$3 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$5, 0));
        while ($n(iter$3).hasNext__Z()) {
          var element$2 = $n(iter$3).next__O();
          var originalHash$6 = $m_sr_Statics$().anyHash__O__I(element$2);
          var improved$6 = $m_sc_Hashing$().improve__I__I(originalHash$6);
          shallowlyMutableNodeMap$3 = $n(current$3).updateWithShallowMutations__O__I__I__I__I__I(element$2, originalHash$6, improved$6, 0, shallowlyMutableNodeMap$3)
        };
        return new $c_sci_HashSet(current$3)
      }
    };
    return this
  }
});
$c_sci_HashSet.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O()
});
$c_sci_HashSet.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_HashSet__f_rootNode).foreach__F1__V(f)
});
$c_sci_HashSet.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if ((this === x2)) {
      return true
    } else {
      var x = this.sci_HashSet__f_rootNode;
      var x$2 = $n(x2).sci_HashSet__f_rootNode;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    }
  } else {
    return $f_sc_Set__equals__O__Z(this, that)
  }
});
$c_sci_HashSet.prototype.className__T = (function() {
  return "HashSet"
});
$c_sci_HashSet.prototype.hashCode__I = (function() {
  var it = new $c_sci_SetHashIterator(this.sci_HashSet__f_rootNode);
  var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(it, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
  return hash
});
$c_sci_HashSet.prototype.diff__sc_Set__sci_HashSet = (function(that) {
  if (this.isEmpty__Z()) {
    return this
  } else if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if ($n(x2).isEmpty__Z()) {
      return this
    } else {
      var newRootNode = $n(this.sci_HashSet__f_rootNode).diff__sci_SetNode__I__sci_BitmapIndexedSetNode($n(x2).sci_HashSet__f_rootNode, 0);
      if (($n(newRootNode).sci_BitmapIndexedSetNode__f_size === 0)) {
        var this$1 = $m_sci_HashSet$();
        return this$1.sci_HashSet$__f_EmptySet
      } else {
        return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, $n(this.sci_HashSet__f_rootNode).diff__sci_SetNode__I__sci_BitmapIndexedSetNode($n(x2).sci_HashSet__f_rootNode, 0))
      }
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(that);
    var this$2 = $n(x3);
    var iter = new $c_scm_HashSet$$anon$2(this$2);
    var curr = this.sci_HashSet__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      var this$3 = $n(x3);
      var improvedHash = $n(next).scm_HashSet$Node__f__hash;
      var originalHash = this$3.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      curr = $n(curr).removed__O__I__I__I__sci_BitmapIndexedSetNode($n(next).scm_HashSet$Node__f__key, originalHash, improved, 0);
      if ((curr !== this.sci_HashSet__f_rootNode)) {
        if (($n(curr).sci_BitmapIndexedSetNode__f_size === 0)) {
          var this$4 = $m_sci_HashSet$();
          return this$4.sci_HashSet$__f_EmptySet
        };
        while (iter.hasNext__Z()) {
          var next$2 = $as_scm_HashSet$Node(iter.next__O());
          var this$5 = $n(x3);
          var improvedHash$1 = $n(next$2).scm_HashSet$Node__f__hash;
          var originalHash$2 = this$5.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash$1);
          var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
          $n(curr).removeWithShallowMutations__O__I__I__sci_BitmapIndexedSetNode($n(next$2).scm_HashSet$Node__f__key, originalHash$2, improved$2);
          if (($n(curr).sci_BitmapIndexedSetNode__f_size === 0)) {
            var this$6 = $m_sci_HashSet$();
            return this$6.sci_HashSet$__f_EmptySet
          }
        };
        return new $c_sci_HashSet(curr)
      }
    };
    return this
  } else {
    var thatKnownSize = $n(that).knownSize__I();
    if ((thatKnownSize === 0)) {
      return this
    } else if ((thatKnownSize <= $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size)) {
      return $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet(this, that)
    } else {
      var pred = new $c_sjsr_AnonFunction1(((elem$2) => $n(that).contains__O__Z(elem$2)));
      return this.filterImpl__F1__Z__sci_HashSet(pred, true)
    }
  }
});
$c_sci_HashSet.prototype.removedAll__sc_IterableOnce__sci_HashSet = (function(that) {
  if ($is_sc_Set(that)) {
    var x2 = $as_sc_Set(that);
    return this.diff__sc_Set__sci_HashSet(x2)
  };
  if ((that instanceof $c_sci_Range)) {
    var x3 = $as_sci_Range(that);
    if (($n(x3).length__I() > $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size)) {
      var pred = new $c_sjsr_AnonFunction1(((x0$1$2) => {
        if ((!$isInt(x0$1$2))) {
          return true
        } else {
          var x2$1 = $uI(x0$1$2);
          return (!$n(x3).contains__I__Z(x2$1))
        }
      }));
      return this.filterImpl__F1__Z__sci_HashSet(pred, false)
    }
  };
  return $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet(this, that)
});
$c_sci_HashSet.prototype.filterImpl__F1__Z__sci_HashSet = (function(pred, isFlipped) {
  var newRootNode = $n(this.sci_HashSet__f_rootNode).filterImpl__F1__Z__sci_BitmapIndexedSetNode(pred, isFlipped);
  if ((newRootNode === this.sci_HashSet__f_rootNode)) {
    return this
  } else if (($n(newRootNode).sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet
  } else {
    return new $c_sci_HashSet(newRootNode)
  }
});
$c_sci_HashSet.prototype.dropWhile__F1__O = (function(p) {
  return $as_sci_HashSet($f_sc_IterableOps__dropWhile__F1__O(this, p))
});
$c_sci_HashSet.prototype.dropRight__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n))
});
$c_sci_HashSet.prototype.drop__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_IterableOps__drop__I__O(this, n))
});
$c_sci_HashSet.prototype.takeWhile__F1__O = (function(p) {
  return $as_sci_HashSet($f_sc_IterableOps__takeWhile__F1__O(this, p))
});
$c_sci_HashSet.prototype.take__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_IterableOps__take__I__O(this, n))
});
$c_sci_HashSet.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return this.removedAll__sc_IterableOnce__sci_HashSet(that)
});
$c_sci_HashSet.prototype.tail__O = (function() {
  var elem = $n(this.iterator__sc_Iterator()).next__O();
  return this.excl__O__sci_HashSet(elem)
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_HashSet(that)
});
$c_sci_HashSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_HashSet(elem)
});
$c_sci_HashSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_HashSet(elem)
});
function $as_sci_HashSet(obj) {
  return (((obj instanceof $c_sci_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashSet"))
}
function $isArrayOf_sci_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashSet)))
}
function $asArrayOf_sci_HashSet(obj, depth) {
  return (($isArrayOf_sci_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashSet;", depth))
}
var $d_sci_HashSet = new $TypeData().initClass({
  sci_HashSet: 0
}, false, "scala.collection.immutable.HashSet", {
  sci_HashSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashSet.prototype.$classData = $d_sci_HashSet;
/** @constructor */
function $c_sci_ListSet() {
  /*<skip>*/
}
$c_sci_ListSet.prototype = new $h_sci_AbstractSet();
$c_sci_ListSet.prototype.constructor = $c_sci_ListSet;
/** @constructor */
function $h_sci_ListSet() {
  /*<skip>*/
}
$h_sci_ListSet.prototype = $c_sci_ListSet.prototype;
$c_sci_ListSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_ListSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_ListSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_ListSet.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_ListSet.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_sci_ListSet.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sci_ListSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_ListSet.prototype.className__T = (function() {
  return "ListSet"
});
$c_sci_ListSet.prototype.size__I = (function() {
  return 0
});
$c_sci_ListSet.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_ListSet.prototype.contains__O__Z = (function(elem) {
  return false
});
$c_sci_ListSet.prototype.incl__O__sci_ListSet = (function(elem) {
  return new $c_sci_ListSet$Node(this, elem)
});
$c_sci_ListSet.prototype.excl__O__sci_ListSet = (function(elem) {
  return this
});
$c_sci_ListSet.prototype.iterator__sc_Iterator = (function() {
  var curr = this;
  var res = $m_sci_Nil$();
  while ((!$n(curr).isEmpty__Z())) {
    var rassoc$1 = $n(curr).elem__O();
    var this$1 = $n(res);
    res = new $c_sci_$colon$colon(rassoc$1, this$1);
    curr = $n(curr).next__sci_ListSet()
  };
  return $n(res).iterator__sc_Iterator()
});
$c_sci_ListSet.prototype.elem__O = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "elem of empty set")
});
$c_sci_ListSet.prototype.next__sci_ListSet = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next of empty set")
});
$c_sci_ListSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_ListSet$()
});
$c_sci_ListSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps(this, that)
});
$c_sci_ListSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_ListSet(elem)
});
$c_sci_ListSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_ListSet(elem)
});
function $as_sci_ListSet(obj) {
  return (((obj instanceof $c_sci_ListSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ListSet"))
}
function $isArrayOf_sci_ListSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListSet)))
}
function $asArrayOf_sci_ListSet(obj, depth) {
  return (($isArrayOf_sci_ListSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ListSet;", depth))
}
/** @constructor */
function $c_scm_AbstractSet() {
  /*<skip>*/
}
$c_scm_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_scm_AbstractSet.prototype.constructor = $c_scm_AbstractSet;
/** @constructor */
function $h_scm_AbstractSet() {
  /*<skip>*/
}
$h_scm_AbstractSet.prototype = $c_scm_AbstractSet.prototype;
$c_scm_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Set$()
});
$c_scm_AbstractSet.prototype.remove__O__Z = (function(elem) {
  return $f_scm_SetOps__remove__O__Z(this, elem)
});
$c_scm_AbstractSet.prototype.knownSize__I = (function() {
  return (-1)
});
$c_scm_AbstractSet.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_AbstractSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_AbstractSet.prototype.result__O = (function() {
  return this
});
function $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State($thiz) {
  if ((!$thiz.sci_LazyList__f_bitmap$0)) {
    if ($thiz.sci_LazyList__f_midEvaluation) {
      throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "self-referential LazyList or a derivation thereof has no more elements")
    };
    $thiz.sci_LazyList__f_midEvaluation = true;
    try {
      var res = $as_sci_LazyList$State($n($thiz.sci_LazyList__f_lazyState).apply__O())
    } finally {
      $thiz.sci_LazyList__f_midEvaluation = false
    };
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = true;
    $thiz.sci_LazyList__f_lazyState = null;
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state = res;
    $thiz.sci_LazyList__f_bitmap$0 = true
  };
  return $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state
}
function $p_sci_LazyList__scanLeftState__O__F2__sci_LazyList$State($thiz, z, op) {
  $m_sci_LazyList$();
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => ($thiz.isEmpty__Z() ? $m_sci_LazyList$State$Empty$() : $p_sci_LazyList__scanLeftState__O__F2__sci_LazyList$State($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), $n(op).apply__O__O__O(z, $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()), op))));
  var tl = new $c_sci_LazyList(state);
  return new $c_sci_LazyList$State$Cons(z, tl)
}
function $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz, f) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    if ($thiz.isEmpty__Z()) {
      return $m_sci_LazyList$State$Empty$()
    } else {
      $m_sci_LazyList$();
      var hd = $n(f).apply__O__O($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
      var tl = $p_sci_LazyList__mapImpl__F1__sci_LazyList($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), f);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    }
  }));
  return new $c_sci_LazyList(state)
}
function $p_sci_LazyList__zipState__sc_Iterator__sci_LazyList$State($thiz, it) {
  if (($thiz.isEmpty__Z() || (!$n(it).hasNext__Z()))) {
    return $m_sci_LazyList$State$Empty$()
  } else {
    $m_sci_LazyList$();
    var hd = $ct_T2__O__O__(new $c_T2(), $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O(), $n(it).next__O());
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => $p_sci_LazyList__zipState__sc_Iterator__sci_LazyList$State($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), it)));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  }
}
function $p_sci_LazyList__dropRightState__sci_LazyList__sci_LazyList$State($thiz, scout) {
  if ($n(scout).isEmpty__Z()) {
    return $m_sci_LazyList$State$Empty$()
  } else {
    $m_sci_LazyList$();
    var hd = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      var $$x1 = $n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList());
      var this$2 = $n(scout);
      return $p_sci_LazyList__dropRightState__sci_LazyList__sci_LazyList$State($n($$x1), $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList())
    }));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  }
}
function $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz, n) {
  if ((n <= 0)) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      if ($thiz.isEmpty__Z()) {
        return $m_sci_LazyList$State$Empty$()
      } else {
        $m_sci_LazyList$();
        var hd = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        var tl = $p_sci_LazyList__takeImpl__I__sci_LazyList($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), (((-1) + n) | 0));
        return new $c_sci_LazyList$State$Cons(hd, tl)
      }
    }));
    return new $c_sci_LazyList(state)
  }
}
function $p_sci_LazyList__takeWhileImpl__F1__sci_LazyList($thiz, p) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    if (($thiz.isEmpty__Z() || (!$uZ($n(p).apply__O__O($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()))))) {
      return $m_sci_LazyList$State$Empty$()
    } else {
      $m_sci_LazyList$();
      var hd = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      var tl = $p_sci_LazyList__takeWhileImpl__F1__sci_LazyList($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), p);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    }
  }));
  return new $c_sci_LazyList(state)
}
function $p_sci_LazyList__reverseOnto__sci_LazyList__sci_LazyList($thiz, tl) {
  var _$this = $thiz;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return tl
    } else {
      var this$1 = $n(_$this);
      var temp$_$this = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      $m_sci_LazyList$();
      var this$5 = _$this;
      var tl$2 = tl;
      var state = new $c_sjsr_AnonFunction0(((this$2, tl$1) => (() => {
        var this$3 = $n(this$2);
        $m_sci_LazyList$();
        var hd = $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        return new $c_sci_LazyList$State$Cons(hd, tl$1)
      }))(this$5, tl$2));
      var temp$tl = new $c_sci_LazyList(state);
      _$this = temp$_$this;
      tl = temp$tl
    }
  }
}
function $p_sci_LazyList__patchImpl__I__sc_IterableOnce__I__sci_LazyList($thiz, from, other, replaced) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    if ((from <= 0)) {
      return $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State($n(other).iterator__sc_Iterator(), new $c_sjsr_AnonFunction0((() => $n($m_sci_LazyList$().scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList($thiz, replaced)).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))
    } else if ($thiz.isEmpty__Z()) {
      return $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State($n(other).iterator__sc_Iterator())
    } else {
      $m_sci_LazyList$();
      var hd = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      var tl = $p_sci_LazyList__patchImpl__I__sc_IterableOnce__I__sci_LazyList($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), (((-1) + from) | 0), other, replaced);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    }
  }));
  return new $c_sci_LazyList(state)
}
function $p_sci_LazyList__updatedImpl__I__O__I__sci_LazyList($thiz, index, elem, startIndex) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    if ((index <= 0)) {
      $m_sci_LazyList$();
      var tl = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      return new $c_sci_LazyList$State$Cons(elem, tl)
    } else if ($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()).isEmpty__Z()) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + startIndex))
    } else {
      $m_sci_LazyList$();
      var hd = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      var tl$1 = $p_sci_LazyList__updatedImpl__I__O__I__sci_LazyList($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), (((-1) + index) | 0), elem, startIndex);
      return new $c_sci_LazyList$State$Cons(hd, tl$1)
    }
  }));
  return new $c_sci_LazyList(state)
}
function $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  var this$1 = $n(b);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
    var this$2 = $n(b);
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
  } else if ((!$thiz.isEmpty__Z())) {
    var this$3 = $n(b);
    var obj = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    var elem$1 = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    var elem$2 = null;
    elem$2 = elem$1;
    if ((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ((!$n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated) || ($n($as_sci_LazyList(elem)).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $n($as_sci_LazyList(elem$2)).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
      elem = $as_sci_LazyList(elem$2);
      if (($n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$n($as_sci_LazyList(elem$2)).isEmpty__Z()))) {
        var this$6 = $n($as_sci_LazyList(elem$2));
        elem$2 = $n(this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
        while (((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ($n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$n($as_sci_LazyList(elem$2)).isEmpty__Z()))) && ($n($as_sci_LazyList(elem)).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $n($as_sci_LazyList(elem$2)).scala$collection$immutable$LazyList$$state__sci_LazyList$State()))) {
          var this$7 = $n(b);
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$8 = $n($as_sci_LazyList(elem));
          var obj$1 = $n(this$8.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
          var this$9 = $n($as_sci_LazyList(elem));
          elem = $n(this$9.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
          var this$10 = $n($as_sci_LazyList(elem$2));
          elem$2 = $n(this$10.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
          if (($n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$n($as_sci_LazyList(elem$2)).isEmpty__Z()))) {
            var this$11 = $n($as_sci_LazyList(elem$2));
            elem$2 = $n(this$11.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
          }
        }
      }
    };
    if ((!($n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$n($as_sci_LazyList(elem$2)).isEmpty__Z())))) {
      while (($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2))) {
        var this$12 = $n(b);
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$13 = $n($as_sci_LazyList(elem));
        var obj$2 = $n(this$13.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
        var this$14 = $n($as_sci_LazyList(elem));
        elem = $n(this$14.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
      };
      if ((!$n($as_sci_LazyList(elem)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
        var this$15 = $n(b);
        this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
      }
    } else {
      var runner = $thiz;
      var k = 0;
      while (true) {
        var a = runner;
        var b$1 = $as_sci_LazyList(elem$2);
        if ((!((a === b$1) || ($n(a).scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $n(b$1).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          var this$16 = $n(runner);
          runner = $n(this$16.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
          var this$17 = $n($as_sci_LazyList(elem$2));
          elem$2 = $n(this$17.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
          k = ((1 + k) | 0)
        } else {
          break
        }
      };
      var a$1 = $as_sci_LazyList(elem);
      var b$2 = $as_sci_LazyList(elem$2);
      if ((((a$1 === b$2) || ($n(a$1).scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $n(b$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State())) && (k > 0))) {
        var this$18 = $n(b);
        this$18.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$18.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$19 = $n($as_sci_LazyList(elem));
        var obj$3 = $n(this$19.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        this$18.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$18.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
        var this$20 = $n($as_sci_LazyList(elem));
        elem = $n(this$20.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
      };
      while (true) {
        var a$2 = $as_sci_LazyList(elem);
        var b$3 = $as_sci_LazyList(elem$2);
        if ((!((a$2 === b$3) || ($n(a$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $n(b$3).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          var this$21 = $n(b);
          this$21.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$21.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$22 = $n($as_sci_LazyList(elem));
          var obj$4 = $n(this$22.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
          this$21.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$21.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          var this$23 = $n($as_sci_LazyList(elem));
          elem = $n(this$23.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
        } else {
          break
        }
      };
      var this$24 = $n(b);
      this$24.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$24.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      this$24.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$24.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>")
    }
  };
  var this$25 = $n(b);
  this$25.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$25.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b
}
/** @constructor */
function $c_sci_LazyList(lazyState) {
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$state = null;
  this.sci_LazyList__f_lazyState = null;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false;
  this.sci_LazyList__f_bitmap$0 = false;
  this.sci_LazyList__f_lazyState = lazyState;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false
}
$c_sci_LazyList.prototype = new $h_sci_AbstractSeq();
$c_sci_LazyList.prototype.constructor = $c_sci_LazyList;
/** @constructor */
function $h_sci_LazyList() {
  /*<skip>*/
}
$h_sci_LazyList.prototype = $c_sci_LazyList.prototype;
$c_sci_LazyList.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_LazyList.prototype.headOption__s_Option = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this)
});
$c_sci_LazyList.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this)
});
$c_sci_LazyList.prototype.last__O = (function() {
  return $f_sc_LinearSeqOps__last__O(this)
});
$c_sci_LazyList.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_LazyList.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_LazyList.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_LazyList.prototype.forall__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p)
});
$c_sci_LazyList.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p)
});
$c_sci_LazyList.prototype.contains__O__Z = (function(elem) {
  return $f_sc_LinearSeqOps__contains__O__Z(this, elem)
});
$c_sci_LazyList.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_LazyList.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_LazyList.prototype.lastIndexWhere__F1__I__I = (function(p, end) {
  return $f_sc_LinearSeqOps__lastIndexWhere__F1__I__I(this, p, end)
});
$c_sci_LazyList.prototype.scala$collection$immutable$LazyList$$state__sci_LazyList$State = (function() {
  return ((!this.sci_LazyList__f_bitmap$0) ? $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State(this) : this.sci_LazyList__f_scala$collection$immutable$LazyList$$state)
});
$c_sci_LazyList.prototype.isEmpty__Z = (function() {
  return (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())
});
$c_sci_LazyList.prototype.knownSize__I = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? 0 : (-1))
});
$c_sci_LazyList.prototype.head__O = (function() {
  return $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()
});
$c_sci_LazyList.prototype.force__sci_LazyList = (function() {
  var these = this;
  var those = this;
  if ((!$n(these).isEmpty__Z())) {
    var this$1 = $n(these);
    these = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
  };
  while ((those !== these)) {
    if ($n(these).isEmpty__Z()) {
      return this
    };
    var this$2 = $n(these);
    these = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    if ($n(these).isEmpty__Z()) {
      return this
    };
    var this$3 = $n(these);
    these = $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    if ((these === those)) {
      return this
    };
    var this$4 = $n(those);
    those = $n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
  };
  return this
});
$c_sci_LazyList.prototype.iterator__sc_Iterator = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_LazyList$LazyIterator(this))
});
$c_sci_LazyList.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!$n(_$this).isEmpty__Z())) {
    var $$x1 = $n(f);
    var this$1 = $n(_$this);
    $n($$x1).apply__O__O($n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
    var this$2 = $n(_$this);
    _$this = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
  }
});
$c_sci_LazyList.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return z
    } else {
      var this$1 = $n(_$this);
      var temp$_$this = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      var $$x2 = $n(op);
      var $$x1 = z;
      var this$2 = $n(_$this);
      var temp$z = $n($$x2).apply__O__O__O($$x1, $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
      _$this = temp$_$this;
      z = temp$z
    }
  }
});
$c_sci_LazyList.prototype.className__T = (function() {
  return "LazyList"
});
$c_sci_LazyList.prototype.lazyAppendedAll__F0__sci_LazyList = (function(suffix) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    if (this.isEmpty__Z()) {
      var x1 = $as_sc_IterableOnce($n(suffix).apply__O());
      if ((x1 instanceof $c_sci_LazyList)) {
        var x2 = $as_sci_LazyList(x1);
        return $n(x2).scala$collection$immutable$LazyList$$state__sci_LazyList$State()
      } else {
        return (($n(x1).knownSize__I() === 0) ? $m_sci_LazyList$State$Empty$() : $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State($n(x1).iterator__sc_Iterator()))
      }
    } else {
      $m_sci_LazyList$();
      var hd = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      var tl = $n($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()).lazyAppendedAll__F0__sci_LazyList(suffix);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    }
  }));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__sci_LazyList = (function(suffix) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(suffix) : this.lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0((() => suffix))))
});
$c_sci_LazyList.prototype.appended__O__sci_LazyList = (function(elem) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      $m_sci_LazyList$();
      var tl = $m_sci_LazyList$().sci_LazyList$__f__empty;
      return new $c_sci_LazyList$State$Cons(elem, tl)
    }));
    return new $c_sci_LazyList(state)
  } else {
    return this.lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0((() => {
      $m_sc_Iterator$();
      return new $c_sc_Iterator$$anon$20(elem)
    })))
  }
});
$c_sci_LazyList.prototype.scanLeft__O__F2__sci_LazyList = (function(z, op) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      $m_sci_LazyList$();
      var tl = $m_sci_LazyList$().sci_LazyList$__f__empty;
      return new $c_sci_LazyList$State$Cons(z, tl)
    }));
    return new $c_sci_LazyList(state)
  } else {
    $m_sci_LazyList$();
    var state$1 = new $c_sjsr_AnonFunction0((() => $p_sci_LazyList__scanLeftState__O__F2__sci_LazyList$State(this, z, op)));
    return new $c_sci_LazyList(state$1)
  }
});
$c_sci_LazyList.prototype.reduceLeft__F2__O = (function(f) {
  if (this.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
  } else {
    var reducedRes = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
    var left = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    while ((!$n(left).isEmpty__Z())) {
      var $$x2 = $n(f);
      var $$x1 = reducedRes;
      var this$1 = $n(left);
      reducedRes = $n($$x2).apply__O__O__O($$x1, $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
      var this$2 = $n(left);
      left = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
    };
    return reducedRes
  }
});
$c_sci_LazyList.prototype.filter__F1__sci_LazyList = (function(pred) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(this, pred, false))
});
$c_sci_LazyList.prototype.filterNot__F1__sci_LazyList = (function(pred) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(this, pred, true))
});
$c_sci_LazyList.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sci_LazyList$WithFilter(this, p)
});
$c_sci_LazyList.prototype.prepended__O__sci_LazyList = (function(elem) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    $m_sci_LazyList$();
    return new $c_sci_LazyList$State$Cons(elem, this)
  }));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList.prototype.map__F1__sci_LazyList = (function(f) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      if (this.isEmpty__Z()) {
        return $m_sci_LazyList$State$Empty$()
      } else {
        $m_sci_LazyList$();
        var hd = $n(f).apply__O__O($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
        var tl = $p_sci_LazyList__mapImpl__F1__sci_LazyList($n($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), f);
        return new $c_sci_LazyList$State$Cons(hd, tl)
      }
    }));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList.prototype.collect__s_PartialFunction__sci_LazyList = (function(pf) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$collectImpl__sci_LazyList__s_PartialFunction__sci_LazyList(this, pf))
});
$c_sci_LazyList.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var $$x1 = $n(pf);
      var this$1 = $n(_$this);
      var res = $n($$x1).applyOrElse__O__F1__O($n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O(), $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker);
      if ((res === $m_sr_Statics$PFMarker$())) {
        var this$3 = $n(_$this);
        _$this = $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
      } else {
        return new $c_s_Some(res)
      }
    }
  }
});
$c_sci_LazyList.prototype.find__F1__s_Option = (function(p) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var this$1 = $n(_$this);
      var elem = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      if ($uZ($n(p).apply__O__O(elem))) {
        return new $c_s_Some(elem)
      } else {
        var this$2 = $n(_$this);
        _$this = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
      }
    }
  }
});
$c_sci_LazyList.prototype.flatMap__F1__sci_LazyList = (function(f) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList(this, f))
});
$c_sci_LazyList.prototype.zip__sc_IterableOnce__sci_LazyList = (function(that) {
  if (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) || ($n(that).knownSize__I() === 0))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => $p_sci_LazyList__zipState__sc_Iterator__sci_LazyList$State(this, $n(that).iterator__sc_Iterator())));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList.prototype.zipWithIndex__sci_LazyList = (function() {
  var this$1 = $m_sci_LazyList$();
  return this.zip__sc_IterableOnce__sci_LazyList(this$1.from__I__I__sci_LazyList(0, 1))
});
$c_sci_LazyList.prototype.drop__I__sci_LazyList = (function(n) {
  return ((n <= 0) ? this : ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList(this, n)))
});
$c_sci_LazyList.prototype.dropWhile__F1__sci_LazyList = (function(p) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$dropWhileImpl__sci_LazyList__F1__sci_LazyList(this, p))
});
$c_sci_LazyList.prototype.dropRight__I__sci_LazyList = (function(n) {
  if ((n <= 0)) {
    return this
  } else if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      var scout = this;
      var remaining = n;
      while (((remaining > 0) && (!$n(scout).isEmpty__Z()))) {
        remaining = (((-1) + remaining) | 0);
        var this$2 = $n(scout);
        scout = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
      };
      return $p_sci_LazyList__dropRightState__sci_LazyList__sci_LazyList$State(this, scout)
    }));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList.prototype.take__I__sci_LazyList = (function(n) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty
  } else if ((n <= 0)) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      if (this.isEmpty__Z()) {
        return $m_sci_LazyList$State$Empty$()
      } else {
        $m_sci_LazyList$();
        var hd = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        var tl = $p_sci_LazyList__takeImpl__I__sci_LazyList($n($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), (((-1) + n) | 0));
        return new $c_sci_LazyList$State$Cons(hd, tl)
      }
    }));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList.prototype.takeWhile__F1__sci_LazyList = (function(p) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      if ((this.isEmpty__Z() || (!$uZ($n(p).apply__O__O($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()))))) {
        return $m_sci_LazyList$State$Empty$()
      } else {
        $m_sci_LazyList$();
        var hd = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        var tl = $p_sci_LazyList__takeWhileImpl__F1__sci_LazyList($n($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), p);
        return new $c_sci_LazyList$State$Cons(hd, tl)
      }
    }));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList.prototype.slice__I__I__sci_LazyList = (function(from, until) {
  return $n(this.take__I__sci_LazyList(until)).drop__I__sci_LazyList(from)
});
$c_sci_LazyList.prototype.diff__sc_Seq__sci_LazyList = (function(that) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $as_sci_LazyList($f_sc_SeqOps__diff__sc_Seq__O(this, that)))
});
$c_sci_LazyList.prototype.patch__I__sc_IterableOnce__I__sci_LazyList = (function(from, other, replaced) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(other) : $p_sci_LazyList__patchImpl__I__sc_IterableOnce__I__sci_LazyList(this, from, other, replaced))
});
$c_sci_LazyList.prototype.updated__I__O__sci_LazyList = (function(index, elem) {
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  } else {
    return $p_sci_LazyList__updatedImpl__I__O__I__sci_LazyList(this, index, elem, index)
  }
});
$c_sci_LazyList.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_LazyList();
  $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $n(sb).scm_StringBuilder__f_underlying, start, sep, end);
  return sb
});
$c_sci_LazyList.prototype.toString__T = (function() {
  return $n($p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "LazyList"), "(", ", ", ")")).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sci_LazyList.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_LazyList.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_LazyList.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_LazyList(index, elem)
});
$c_sci_LazyList.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return this.patch__I__sc_IterableOnce__I__sci_LazyList(from, other, replaced)
});
$c_sci_LazyList.prototype.diff__sc_Seq__O = (function(that) {
  return this.diff__sc_Seq__sci_LazyList(that)
});
$c_sci_LazyList.prototype.reverse__O = (function() {
  return $p_sci_LazyList__reverseOnto__sci_LazyList__sci_LazyList(this, $m_sci_LazyList$().sci_LazyList$__f__empty)
});
$c_sci_LazyList.prototype.slice__I__I__O = (function(from, until) {
  return this.slice__I__I__sci_LazyList(from, until)
});
$c_sci_LazyList.prototype.takeWhile__F1__O = (function(p) {
  return this.takeWhile__F1__sci_LazyList(p)
});
$c_sci_LazyList.prototype.take__I__O = (function(n) {
  return this.take__I__sci_LazyList(n)
});
$c_sci_LazyList.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_LazyList(n)
});
$c_sci_LazyList.prototype.dropWhile__F1__O = (function(p) {
  return this.dropWhile__F1__sci_LazyList(p)
});
$c_sci_LazyList.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_LazyList(n)
});
$c_sci_LazyList.prototype.zipWithIndex__O = (function() {
  return this.zipWithIndex__sci_LazyList()
});
$c_sci_LazyList.prototype.zip__sc_IterableOnce__O = (function(that) {
  return this.zip__sc_IterableOnce__sci_LazyList(that)
});
$c_sci_LazyList.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_LazyList(f)
});
$c_sci_LazyList.prototype.collect__s_PartialFunction__O = (function(pf) {
  return this.collect__s_PartialFunction__sci_LazyList(pf)
});
$c_sci_LazyList.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_LazyList(f)
});
$c_sci_LazyList.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_LazyList(elem)
});
$c_sci_LazyList.prototype.filterNot__F1__O = (function(pred) {
  return this.filterNot__F1__sci_LazyList(pred)
});
$c_sci_LazyList.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_LazyList(pred)
});
$c_sci_LazyList.prototype.scanLeft__O__F2__O = (function(z, op) {
  return this.scanLeft__O__F2__sci_LazyList(z, op)
});
$c_sci_LazyList.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_LazyList(elem)
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_LazyList(suffix)
});
$c_sci_LazyList.prototype.tail__O = (function() {
  return $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()
});
$c_sci_LazyList.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_LazyList$()
});
function $as_sci_LazyList(obj) {
  return (((obj instanceof $c_sci_LazyList) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList"))
}
function $isArrayOf_sci_LazyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList)))
}
function $asArrayOf_sci_LazyList(obj, depth) {
  return (($isArrayOf_sci_LazyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList;", depth))
}
var $d_sci_LazyList = new $TypeData().initClass({
  sci_LazyList: 0
}, false, "scala.collection.immutable.LazyList", {
  sci_LazyList: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList.prototype.$classData = $d_sci_LazyList;
/** @constructor */
function $c_sci_ListSet$EmptyListSet$() {
  /*<skip>*/
}
$c_sci_ListSet$EmptyListSet$.prototype = new $h_sci_ListSet();
$c_sci_ListSet$EmptyListSet$.prototype.constructor = $c_sci_ListSet$EmptyListSet$;
/** @constructor */
function $h_sci_ListSet$EmptyListSet$() {
  /*<skip>*/
}
$h_sci_ListSet$EmptyListSet$.prototype = $c_sci_ListSet$EmptyListSet$.prototype;
$c_sci_ListSet$EmptyListSet$.prototype.knownSize__I = (function() {
  return 0
});
var $d_sci_ListSet$EmptyListSet$ = new $TypeData().initClass({
  sci_ListSet$EmptyListSet$: 0
}, false, "scala.collection.immutable.ListSet$EmptyListSet$", {
  sci_ListSet$EmptyListSet$: 1,
  sci_ListSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ListSet$EmptyListSet$.prototype.$classData = $d_sci_ListSet$EmptyListSet$;
var $n_sci_ListSet$EmptyListSet$;
function $m_sci_ListSet$EmptyListSet$() {
  if ((!$n_sci_ListSet$EmptyListSet$)) {
    $n_sci_ListSet$EmptyListSet$ = new $c_sci_ListSet$EmptyListSet$()
  };
  return $n_sci_ListSet$EmptyListSet$
}
function $p_sci_ListSet$Node__sizeInternal__sci_ListSet__I__I($thiz, n, acc) {
  while (true) {
    if ($n(n).isEmpty__Z()) {
      return acc
    } else {
      var temp$n = $n(n).next__sci_ListSet();
      var temp$acc = ((1 + acc) | 0);
      n = temp$n;
      acc = temp$acc
    }
  }
}
function $p_sci_ListSet$Node__containsInternal__sci_ListSet__O__Z($thiz, n, e) {
  while (true) {
    if ((!$n(n).isEmpty__Z())) {
      if ($m_sr_BoxesRunTime$().equals__O__O__Z($n(n).elem__O(), e)) {
        return true
      } else {
        n = $n(n).next__sci_ListSet()
      }
    } else {
      return false
    }
  }
}
function $p_sci_ListSet$Node__removeInternal__O__sci_ListSet__sci_List__sci_ListSet($thiz, k, cur, acc) {
  while (true) {
    if ($n(cur).isEmpty__Z()) {
      return $as_sci_ListSet($n(acc).last__O())
    } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(cur).elem__O())) {
      var this$1 = $n(acc);
      var z = $n(cur).next__sci_ListSet();
      var acc$1 = z;
      var these = this$1;
      while ((!$n(these).isEmpty__Z())) {
        var arg1 = acc$1;
        var arg2 = $n(these).head__O();
        var t = $as_sci_ListSet(arg1);
        var h = $as_sci_ListSet(arg2);
        acc$1 = new $c_sci_ListSet$Node(t, $n(h).elem__O());
        these = $as_sc_LinearSeq($n(these).tail__O())
      };
      return $as_sci_ListSet(acc$1)
    } else {
      var temp$cur = $n(cur).next__sci_ListSet();
      var rassoc$2 = cur;
      var this$2 = $n(acc);
      var temp$acc = new $c_sci_$colon$colon(rassoc$2, this$2);
      cur = temp$cur;
      acc = temp$acc
    }
  }
}
/** @constructor */
function $c_sci_ListSet$Node(outer, elem) {
  this.sci_ListSet$Node__f_elem = null;
  this.sci_ListSet$Node__f_$outer = null;
  this.sci_ListSet$Node__f_elem = elem;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sci_ListSet$Node__f_$outer = outer
  }
}
$c_sci_ListSet$Node.prototype = new $h_sci_ListSet();
$c_sci_ListSet$Node.prototype.constructor = $c_sci_ListSet$Node;
/** @constructor */
function $h_sci_ListSet$Node() {
  /*<skip>*/
}
$h_sci_ListSet$Node.prototype = $c_sci_ListSet$Node.prototype;
$c_sci_ListSet$Node.prototype.elem__O = (function() {
  return this.sci_ListSet$Node__f_elem
});
$c_sci_ListSet$Node.prototype.size__I = (function() {
  return $p_sci_ListSet$Node__sizeInternal__sci_ListSet__I__I(this, this, 0)
});
$c_sci_ListSet$Node.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_ListSet$Node.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_ListSet$Node.prototype.contains__O__Z = (function(e) {
  return $p_sci_ListSet$Node__containsInternal__sci_ListSet__O__Z(this, this, e)
});
$c_sci_ListSet$Node.prototype.incl__O__sci_ListSet = (function(e) {
  return ($p_sci_ListSet$Node__containsInternal__sci_ListSet__O__Z(this, this, e) ? this : new $c_sci_ListSet$Node(this, e))
});
$c_sci_ListSet$Node.prototype.excl__O__sci_ListSet = (function(e) {
  return $p_sci_ListSet$Node__removeInternal__O__sci_ListSet__sci_List__sci_ListSet(this, e, this, $m_sci_Nil$())
});
$c_sci_ListSet$Node.prototype.next__sci_ListSet = (function() {
  return this.sci_ListSet$Node__f_$outer
});
$c_sci_ListSet$Node.prototype.excl__O__sci_SetOps = (function(elem) {
  return $p_sci_ListSet$Node__removeInternal__O__sci_ListSet__sci_List__sci_ListSet(this, elem, this, $m_sci_Nil$())
});
$c_sci_ListSet$Node.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_ListSet(elem)
});
var $d_sci_ListSet$Node = new $TypeData().initClass({
  sci_ListSet$Node: 0
}, false, "scala.collection.immutable.ListSet$Node", {
  sci_ListSet$Node: 1,
  sci_ListSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ListSet$Node.prototype.$classData = $d_sci_ListSet$Node;
function $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  var this$1 = $n(b);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.isEmpty__Z())) {
    var this$2 = $n(b);
    var obj = $thiz.head__O();
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    if ($thiz.tailDefined__Z()) {
      var scout = $as_sci_Stream($thiz.tail__O());
      if (($as_sci_Stream(elem) !== scout)) {
        elem = scout;
        if ($n(scout).tailDefined__Z()) {
          scout = $as_sci_Stream($n(scout).tail__O());
          while ((($as_sci_Stream(elem) !== scout) && $n(scout).tailDefined__Z())) {
            var this$4 = $n(b);
            this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$1 = $n($as_sci_Stream(elem)).head__O();
            this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
            elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O());
            scout = $as_sci_Stream($n(scout).tail__O());
            if ($n(scout).tailDefined__Z()) {
              scout = $as_sci_Stream($n(scout).tail__O())
            }
          }
        }
      };
      if ((!$n(scout).tailDefined__Z())) {
        while (($as_sci_Stream(elem) !== scout)) {
          var this$5 = $n(b);
          this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$2 = $n($as_sci_Stream(elem)).head__O();
          this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
          elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O())
        };
        var this$6 = $n($as_sci_Stream(elem));
        if ((!this$6.isEmpty__Z())) {
          var this$7 = $n(b);
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$3 = $n($as_sci_Stream(elem)).head__O();
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3)
        }
      } else {
        var runner = $thiz;
        var k = 0;
        while ((runner !== scout)) {
          runner = $as_sci_Stream($n(runner).tail__O());
          scout = $as_sci_Stream($n(scout).tail__O());
          k = ((1 + k) | 0)
        };
        if ((($as_sci_Stream(elem) === scout) && (k > 0))) {
          var this$8 = $n(b);
          this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$4 = $n($as_sci_Stream(elem)).head__O();
          this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O())
        };
        while (($as_sci_Stream(elem) !== scout)) {
          var this$9 = $n(b);
          this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$5 = $n($as_sci_Stream(elem)).head__O();
          this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$5);
          elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O())
        }
      }
    };
    var this$10 = $n($as_sci_Stream(elem));
    if ((!this$10.isEmpty__Z())) {
      if ((!$n($as_sci_Stream(elem)).tailDefined__Z())) {
        var this$11 = $n(b);
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
      } else {
        var this$12 = $n(b);
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>")
      }
    }
  };
  var this$13 = $n(b);
  this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b
}
/** @constructor */
function $c_sci_Stream() {
  /*<skip>*/
}
$c_sci_Stream.prototype = new $h_sci_AbstractSeq();
$c_sci_Stream.prototype.constructor = $c_sci_Stream;
/** @constructor */
function $h_sci_Stream() {
  /*<skip>*/
}
$h_sci_Stream.prototype = $c_sci_Stream.prototype;
$c_sci_Stream.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_Stream.prototype.headOption__s_Option = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this)
});
$c_sci_Stream.prototype.iterator__sc_Iterator = (function() {
  return $f_sc_LinearSeqOps__iterator__sc_Iterator(this)
});
$c_sci_Stream.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this)
});
$c_sci_Stream.prototype.last__O = (function() {
  return $f_sc_LinearSeqOps__last__O(this)
});
$c_sci_Stream.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_Stream.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_Stream.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_Stream.prototype.forall__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p)
});
$c_sci_Stream.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p)
});
$c_sci_Stream.prototype.contains__O__Z = (function(elem) {
  return $f_sc_LinearSeqOps__contains__O__Z(this, elem)
});
$c_sci_Stream.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_Stream.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_Stream.prototype.lastIndexWhere__F1__I__I = (function(p, end) {
  return $f_sc_LinearSeqOps__lastIndexWhere__F1__I__I(this, p, end)
});
$c_sci_Stream.prototype.className__T = (function() {
  return "Stream"
});
$c_sci_Stream.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!$n(_$this).isEmpty__Z())) {
    $n(f).apply__O__O($n(_$this).head__O());
    _$this = $as_sci_Stream($n(_$this).tail__O())
  }
});
$c_sci_Stream.prototype.find__F1__s_Option = (function(p) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_s_None$()
    } else if ($uZ($n(p).apply__O__O($n(_$this).head__O()))) {
      return new $c_s_Some($n(_$this).head__O())
    } else {
      _$this = $as_sci_Stream($n(_$this).tail__O())
    }
  }
});
$c_sci_Stream.prototype.take__I__sci_Stream = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? $m_sci_Stream$Empty$() : ((n === 1) ? new $c_sci_Stream$Cons(this.head__O(), new $c_sjsr_AnonFunction0((() => $m_sci_Stream$Empty$()))) : new $c_sci_Stream$Cons(this.head__O(), new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream(this.tail__O())).take__I__sci_Stream((((-1) + n) | 0)))))))
});
$c_sci_Stream.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return z
    } else {
      var temp$_$this = $as_sci_Stream($n(_$this).tail__O());
      var temp$z = $n(op).apply__O__O__O(z, $n(_$this).head__O());
      _$this = temp$_$this;
      z = temp$z
    }
  }
});
$c_sci_Stream.prototype.lazyAppendedAll__F0__sci_Stream = (function(suffix) {
  if (this.isEmpty__Z()) {
    var this$1 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce($n(suffix).apply__O());
    return this$1.from__sc_IterableOnce__sci_Stream(source)
  } else {
    var hd = this.head__O();
    var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream(this.tail__O())).lazyAppendedAll__F0__sci_Stream(suffix)));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.scanLeft__O__F2__sci_Stream = (function(z, op) {
  if (this.isEmpty__Z()) {
    var this$2 = $m_sci_Stream$Empty$();
    return this$2.prepended__O__sci_Stream(z)
  } else {
    var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream(this.tail__O())).scanLeft__O__F2__sci_Stream($n(op).apply__O__O__O(z, this.head__O()), op)));
    return new $c_sci_Stream$Cons(z, tl)
  }
});
$c_sci_Stream.prototype.reduceLeft__F2__O = (function(f) {
  if (this.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
  } else {
    var reducedRes = this.head__O();
    var left = $as_sci_Stream(this.tail__O());
    while ((!$n(left).isEmpty__Z())) {
      reducedRes = $n(f).apply__O__O__O(reducedRes, $n(left).head__O());
      left = $as_sci_Stream($n(left).tail__O())
    };
    return reducedRes
  }
});
$c_sci_Stream.prototype.filterImpl__F1__Z__sci_Stream = (function(p, isFlipped) {
  var rest = this;
  while (true) {
    var this$1 = $n(rest);
    if (((!this$1.isEmpty__Z()) && ($uZ($n(p).apply__O__O($n(rest).head__O())) === isFlipped))) {
      rest = $as_sci_Stream($n(rest).tail__O())
    } else {
      break
    }
  };
  var this$2 = $n(rest);
  if ((!this$2.isEmpty__Z())) {
    return $m_sci_Stream$().filteredTail__sci_Stream__F1__Z__sci_Stream(rest, p, isFlipped)
  } else {
    return $m_sci_Stream$Empty$()
  }
});
$c_sci_Stream.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sci_Stream$WithFilter(this, p)
});
$c_sci_Stream.prototype.prepended__O__sci_Stream = (function(elem) {
  var tl = new $c_sjsr_AnonFunction0((() => this));
  return new $c_sci_Stream$Cons(elem, tl)
});
$c_sci_Stream.prototype.map__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$()
  } else {
    var hd = $n(f).apply__O__O(this.head__O());
    var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream(this.tail__O())).map__F1__sci_Stream(f)));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.collect__s_PartialFunction__sci_Stream = (function(pf) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_sci_Stream$Empty$()
    } else {
      var newHead = new $c_sr_ObjectRef(null);
      var $$x1 = $n(pf);
      var this$5 = _$this;
      var runWith = $n($$x1).runWith__F1__F1(new $c_sjsr_AnonFunction1(((this$3, newHead) => ((b$2) => {
        $n(this$3);
        newHead.sr_ObjectRef__f_elem = b$2
      }))(this$5, newHead)));
      if ($uZ($n(runWith).apply__O__O($n(_$this).head__O()))) {
        return $m_sci_Stream$().collectedTail__O__sci_Stream__s_PartialFunction__sci_Stream(newHead.sr_ObjectRef__f_elem, _$this, pf)
      } else {
        _$this = $as_sci_Stream($n(_$this).tail__O())
      }
    }
  }
});
$c_sci_Stream.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var newHead = new $c_sr_ObjectRef(null);
      var $$x1 = $n(pf);
      var this$4 = _$this;
      var runWith = $n($$x1).runWith__F1__F1(new $c_sjsr_AnonFunction1(((this$2, newHead) => ((b$2) => {
        $n(this$2);
        newHead.sr_ObjectRef__f_elem = b$2
      }))(this$4, newHead)));
      if ($uZ($n(runWith).apply__O__O($n(_$this).head__O()))) {
        return new $c_s_Some(newHead.sr_ObjectRef__f_elem)
      } else {
        _$this = $as_sci_Stream($n(_$this).tail__O())
      }
    }
  }
});
$c_sci_Stream.prototype.flatMap__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$()
  } else {
    var nonEmptyPrefix = new $c_sr_ObjectRef(this);
    var this$3 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce($n(f).apply__O__O($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).head__O()));
    var prefix = this$3.from__sc_IterableOnce__sci_Stream(source);
    while (((!$n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).isEmpty__Z()) && $n(prefix).isEmpty__Z())) {
      nonEmptyPrefix.sr_ObjectRef__f_elem = $as_sci_Stream($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).tail__O());
      if ((!$n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).isEmpty__Z())) {
        var this$4 = $m_sci_Stream$();
        var source$1 = $as_sc_IterableOnce($n(f).apply__O__O($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).head__O()));
        prefix = this$4.from__sc_IterableOnce__sci_Stream(source$1)
      }
    };
    return ($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).isEmpty__Z() ? $m_sci_Stream$Empty$() : $n(prefix).lazyAppendedAll__F0__sci_Stream(new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).tail__O())).flatMap__F1__sci_Stream(f)))))
  }
});
$c_sci_Stream.prototype.zip__sc_IterableOnce__sci_Stream = (function(that) {
  if ((this.isEmpty__Z() || $m_sc_IterableOnceExtensionMethods$().isEmpty$extension__sc_IterableOnce__Z(that))) {
    return $m_sci_Stream$Empty$()
  } else {
    if ($is_sc_Iterable(that)) {
      var x2 = $as_sc_Iterable(that);
      var thatIterable = x2
    } else {
      var thatIterable = $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(that)
    };
    var hd = $ct_T2__O__O__(new $c_T2(), this.head__O(), $n(thatIterable).head__O());
    var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream(this.tail__O())).zip__sc_IterableOnce__sci_Stream($as_sc_IterableOnce($n(thatIterable).tail__O()))));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.zipWithIndex__sci_Stream = (function() {
  var this$1 = $m_sci_LazyList$();
  return this.zip__sc_IterableOnce__sci_Stream(this$1.from__I__I__sci_LazyList(0, 1))
});
$c_sci_Stream.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_Stream();
  $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $n(sb).scm_StringBuilder__f_underlying, start, sep, end);
  return sb
});
$c_sci_Stream.prototype.toString__T = (function() {
  return $n($p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "Stream"), "(", ", ", ")")).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sci_Stream.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_Stream.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_Stream.prototype.zipWithIndex__O = (function() {
  return this.zipWithIndex__sci_Stream()
});
$c_sci_Stream.prototype.zip__sc_IterableOnce__O = (function(that) {
  return this.zip__sc_IterableOnce__sci_Stream(that)
});
$c_sci_Stream.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_Stream(f)
});
$c_sci_Stream.prototype.collect__s_PartialFunction__O = (function(pf) {
  return this.collect__s_PartialFunction__sci_Stream(pf)
});
$c_sci_Stream.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Stream(f)
});
$c_sci_Stream.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Stream(elem)
});
$c_sci_Stream.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Stream(pred, true)
});
$c_sci_Stream.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Stream(pred, false)
});
$c_sci_Stream.prototype.scanLeft__O__F2__O = (function(z, op) {
  return this.scanLeft__O__F2__sci_Stream(z, op)
});
$c_sci_Stream.prototype.take__I__O = (function(n) {
  return this.take__I__sci_Stream(n)
});
$c_sci_Stream.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Stream$()
});
function $as_sci_Stream(obj) {
  return (((obj instanceof $c_sci_Stream) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Stream"))
}
function $isArrayOf_sci_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Stream)))
}
function $asArrayOf_sci_Stream(obj, depth) {
  return (($isArrayOf_sci_Stream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Stream;", depth))
}
/** @constructor */
function $c_sci_WrappedString(self) {
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = null;
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = self
}
$c_sci_WrappedString.prototype = new $h_sci_AbstractSeq();
$c_sci_WrappedString.prototype.constructor = $c_sci_WrappedString;
/** @constructor */
function $h_sci_WrappedString() {
  /*<skip>*/
}
$h_sci_WrappedString.prototype = $c_sci_WrappedString.prototype;
$c_sci_WrappedString.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_sci_WrappedString.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_WrappedString.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_WrappedString.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_sci_WrappedString.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_WrappedString.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sci_WrappedString.prototype.prepended__O__O = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem)
});
$c_sci_WrappedString.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_sci_WrappedString.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sci_WrappedString.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n)
});
$c_sci_WrappedString.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_sci_WrappedString.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this)
});
$c_sci_WrappedString.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sci_WrappedString.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sci_WrappedString.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sci_WrappedString.prototype.lengthCompare__I__I = (function(len) {
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  var x = this$1.length;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_WrappedString.prototype.knownSize__I = (function() {
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return this$1.length
});
$c_sci_WrappedString.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_WrappedString$().newBuilder__scm_Builder()
});
$c_sci_WrappedString.prototype.slice__I__I__sci_WrappedString = (function(from, until) {
  var start = ((from < 0) ? 0 : from);
  if ((until <= start)) {
    var $$x1 = true
  } else {
    var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
    var $$x1 = (start >= this$1.length)
  };
  if ($$x1) {
    return $m_sci_WrappedString$().sci_WrappedString$__f_empty
  };
  var this$2 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  if ((until > this$2.length)) {
    var this$3 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
    var end = this$3.length
  } else {
    var end = until
  };
  var this$4 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  if ((start < 0)) {
    $charAt(this$4, start)
  };
  if ((end > this$4.length)) {
    $charAt(this$4, end)
  };
  if ((end < start)) {
    $charAt(this$4, (-1))
  };
  return new $c_sci_WrappedString($as_T(this$4.substring(start, end)))
});
$c_sci_WrappedString.prototype.length__I = (function() {
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return this$1.length
});
$c_sci_WrappedString.prototype.toString__T = (function() {
  return this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self
});
$c_sci_WrappedString.prototype.startsWith__sc_IterableOnce__I__Z = (function(that, offset) {
  if ((that instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(that);
    var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
    var prefix = $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    if (((offset <= this$1.length) && (offset >= 0))) {
      var this$2 = $n(prefix);
      var $$x1 = this$1.substring(offset, ((offset + this$2.length) | 0));
      return ($as_T($$x1) === prefix)
    } else {
      return false
    }
  } else {
    return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset)
  }
});
$c_sci_WrappedString.prototype.startsWith$default$2__I = (function() {
  return 0
});
$c_sci_WrappedString.prototype.indexOf__O__I__I = (function(elem, from) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    return $f_T__indexOf__I__I__I($n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self), x2, from)
  } else {
    return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
  }
});
$c_sci_WrappedString.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  if ((xs instanceof $ac_C)) {
    var x2 = $asArrayOf_C(xs, 1);
    var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
    var srcLen = this$1.length;
    var destLen = $n(x2).u.length;
    var x = ((len < srcLen) ? len : srcLen);
    var y = ((destLen - start) | 0);
    var x$1 = ((x < y) ? x : y);
    var copied = ((x$1 > 0) ? x$1 : 0);
    $f_T__getChars__I__I__AC__I__V($n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self), 0, copied, x2, start);
    return copied
  } else {
    return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
  }
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__sci_IndexedSeq = (function(suffix) {
  if ((suffix instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(suffix);
    var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
    var s = $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    return new $c_sci_WrappedString((this$1 + s))
  } else {
    return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix))
  }
});
$c_sci_WrappedString.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  if ((o instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(o);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self)
  } else {
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
  }
});
$c_sci_WrappedString.prototype.className__T = (function() {
  return "WrappedString"
});
$c_sci_WrappedString.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647
});
$c_sci_WrappedString.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(other);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self)
  } else {
    return $f_sc_Seq__equals__O__Z(this, other)
  }
});
$c_sci_WrappedString.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$()
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_IndexedSeq(suffix)
});
$c_sci_WrappedString.prototype.view__sc_SeqView = (function() {
  return new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self)
});
$c_sci_WrappedString.prototype.slice__I__I__O = (function(from, until) {
  return this.slice__I__I__sci_WrappedString(from, until)
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll)
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll)
});
$c_sci_WrappedString.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $bC($charAt(this$1, i))
});
$c_sci_WrappedString.prototype.apply__I__O = (function(i) {
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $bC($charAt(this$1, i))
});
function $as_sci_WrappedString(obj) {
  return (((obj instanceof $c_sci_WrappedString) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.WrappedString"))
}
function $isArrayOf_sci_WrappedString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_WrappedString)))
}
function $asArrayOf_sci_WrappedString(obj, depth) {
  return (($isArrayOf_sci_WrappedString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.WrappedString;", depth))
}
var $d_sci_WrappedString = new $TypeData().initClass({
  sci_WrappedString: 0
}, false, "scala.collection.immutable.WrappedString", {
  sci_WrappedString: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_WrappedString.prototype.$classData = $d_sci_WrappedString;
function $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, array) {
  $thiz.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = array;
  return $thiz
}
function $ct_sjsr_WrappedVarArgs__($thiz) {
  $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, []);
  return $thiz
}
/** @constructor */
function $c_sjsr_WrappedVarArgs() {
  this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = null
}
$c_sjsr_WrappedVarArgs.prototype = new $h_O();
$c_sjsr_WrappedVarArgs.prototype.constructor = $c_sjsr_WrappedVarArgs;
/** @constructor */
function $h_sjsr_WrappedVarArgs() {
  /*<skip>*/
}
$h_sjsr_WrappedVarArgs.prototype = $c_sjsr_WrappedVarArgs.prototype;
$c_sjsr_WrappedVarArgs.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sci_StrictOptimizedSeqOps__updated__I__O__O(this, index, elem)
});
$c_sjsr_WrappedVarArgs.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sjsr_WrappedVarArgs.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sjsr_WrappedVarArgs.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem)
});
$c_sjsr_WrappedVarArgs.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem)
});
$c_sjsr_WrappedVarArgs.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjsr_WrappedVarArgs.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that)
});
$c_sjsr_WrappedVarArgs.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sjsr_WrappedVarArgs.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sjsr_WrappedVarArgs.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.scanLeft__O__F2__O = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op)
});
$c_sjsr_WrappedVarArgs.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_sjsr_WrappedVarArgs.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sjsr_WrappedVarArgs.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sjsr_WrappedVarArgs.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_sjsr_WrappedVarArgs.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sjsr_WrappedVarArgs.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sjsr_WrappedVarArgs.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength
});
$c_sjsr_WrappedVarArgs.prototype.slice__I__I__O = (function(from, until) {
  return $f_sci_IndexedSeqOps__slice__I__I__O(this, from, until)
});
$c_sjsr_WrappedVarArgs.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_sjsr_WrappedVarArgs.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sjsr_WrappedVarArgs.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_sjsr_WrappedVarArgs.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sjsr_WrappedVarArgs.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sjsr_WrappedVarArgs.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sjsr_WrappedVarArgs.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sjsr_WrappedVarArgs.prototype.toSeq__sci_Seq = (function() {
  return this
});
$c_sjsr_WrappedVarArgs.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_sjsr_WrappedVarArgs.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_sjsr_WrappedVarArgs.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sjsr_WrappedVarArgs.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjsr_WrappedVarArgs.prototype.size__I = (function() {
  return this.length__I()
});
$c_sjsr_WrappedVarArgs.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.startsWith__sc_IterableOnce__I__Z = (function(that, offset) {
  return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset)
});
$c_sjsr_WrappedVarArgs.prototype.startsWith$default$2__I = (function() {
  return 0
});
$c_sjsr_WrappedVarArgs.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_sjsr_WrappedVarArgs.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  var this$2 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
  return $f_sc_Iterator__indexWhere__F1__I__I(this$2, p, from)
});
$c_sjsr_WrappedVarArgs.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
});
$c_sjsr_WrappedVarArgs.prototype.lastIndexWhere__F1__I__I = (function(p, end) {
  return $f_sc_SeqOps__lastIndexWhere__F1__I__I(this, p, end)
});
$c_sjsr_WrappedVarArgs.prototype.contains__O__Z = (function(elem) {
  return $f_sc_SeqOps__contains__O__Z(this, elem)
});
$c_sjsr_WrappedVarArgs.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1))
});
$c_sjsr_WrappedVarArgs.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sjsr_WrappedVarArgs.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that)
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sjsr_WrappedVarArgs.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this)
});
$c_sjsr_WrappedVarArgs.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sjsr_WrappedVarArgs.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action)
});
$c_sjsr_WrappedVarArgs.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__I__O(v1))
});
$c_sjsr_WrappedVarArgs.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g)
});
$c_sjsr_WrappedVarArgs.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sjsr_WrappedVarArgs$().newBuilder__scm_Builder()
});
$c_sjsr_WrappedVarArgs.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p)
});
$c_sjsr_WrappedVarArgs.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p)
});
$c_sjsr_WrappedVarArgs.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p)
});
$c_sjsr_WrappedVarArgs.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_sjsr_WrappedVarArgs.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sjsr_WrappedVarArgs.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p)
});
$c_sjsr_WrappedVarArgs.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sjsr_WrappedVarArgs.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sjsr_WrappedVarArgs.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sjsr_WrappedVarArgs.prototype.min__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord)
});
$c_sjsr_WrappedVarArgs.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sjsr_WrappedVarArgs.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf)
});
$c_sjsr_WrappedVarArgs.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sjsr_WrappedVarArgs.prototype.to__sc_Factory__O = (function(factory) {
  return $n(factory).fromSpecific__sc_IterableOnce__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sjsr_WrappedVarArgs.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this)
});
$c_sjsr_WrappedVarArgs.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjsr_WrappedVarArgs$()
});
$c_sjsr_WrappedVarArgs.prototype.length__I = (function() {
  return $uI(this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array.length)
});
$c_sjsr_WrappedVarArgs.prototype.apply__I__O = (function(idx) {
  return this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array[idx]
});
$c_sjsr_WrappedVarArgs.prototype.className__T = (function() {
  return "WrappedVarArgs"
});
$c_sjsr_WrappedVarArgs.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sjsr_WrappedVarArgs$();
  return this$1.from__sc_IterableOnce__sjsr_WrappedVarArgs(coll)
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sjsr_WrappedVarArgs.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_sjsr_WrappedVarArgs.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this)
});
$c_sjsr_WrappedVarArgs.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjsr_WrappedVarArgs$()
});
function $as_sjsr_WrappedVarArgs(obj) {
  return (((obj instanceof $c_sjsr_WrappedVarArgs) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.runtime.WrappedVarArgs"))
}
function $isArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjsr_WrappedVarArgs)))
}
function $asArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (($isArrayOf_sjsr_WrappedVarArgs(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.runtime.WrappedVarArgs;", depth))
}
var $d_sjsr_WrappedVarArgs = new $TypeData().initClass({
  sjsr_WrappedVarArgs: 0
}, false, "scala.scalajs.runtime.WrappedVarArgs", {
  sjsr_WrappedVarArgs: 1,
  O: 1,
  sci_IndexedSeq: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sjsr_WrappedVarArgs.prototype.$classData = $d_sjsr_WrappedVarArgs;
/** @constructor */
function $c_sci_HashMap(rootNode) {
  this.sci_HashMap__f_rootNode = null;
  this.sci_HashMap__f_rootNode = rootNode
}
$c_sci_HashMap.prototype = new $h_sci_AbstractMap();
$c_sci_HashMap.prototype.constructor = $c_sci_HashMap;
/** @constructor */
function $h_sci_HashMap() {
  /*<skip>*/
}
$h_sci_HashMap.prototype = $c_sci_HashMap.prototype;
$c_sci_HashMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f)
});
$c_sci_HashMap.prototype.collect__s_PartialFunction__sc_IterableOps = (function(pf) {
  return $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this, pf)
});
$c_sci_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_HashMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_HashMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_HashMap.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_HashMap.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_HashMap.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashMap(pred, false)
});
$c_sci_HashMap.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashMap(pred, true)
});
$c_sci_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_HashMap$()
});
$c_sci_HashMap.prototype.knownSize__I = (function() {
  return $n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size
});
$c_sci_HashMap.prototype.size__I = (function() {
  return $n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size
});
$c_sci_HashMap.prototype.isEmpty__Z = (function() {
  return ($n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size === 0)
});
$c_sci_HashMap.prototype.keySet__sci_Set = (function() {
  return (($n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size === 0) ? $m_sci_Set$EmptySet$() : new $c_sci_HashMap$HashKeySet(this))
});
$c_sci_HashMap.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyValueTupleIterator(this.sci_HashMap__f_rootNode))
});
$c_sci_HashMap.prototype.keysIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyIterator(this.sci_HashMap__f_rootNode))
});
$c_sci_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapValueIterator(this.sci_HashMap__f_rootNode))
});
$c_sci_HashMap.prototype.contains__O__Z = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).containsKey__O__I__I__I__Z(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.apply__O__O = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).apply__O__I__I__I__O(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.get__O__s_Option = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).get__O__I__I__I__s_Option(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).getOrElse__O__I__I__I__F0__O(key, keyUnimprovedHash, keyHash, 0, default$1)
});
$c_sci_HashMap.prototype.updated__O__O__sci_HashMap = (function(key, value) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = $n(this.sci_HashMap__f_rootNode).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0, true);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
});
$c_sci_HashMap.prototype.removed__O__sci_HashMap = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = $n(this.sci_HashMap__f_rootNode).removed__O__I__I__I__sci_BitmapIndexedMapNode(key, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
});
$c_sci_HashMap.prototype.tail__sci_HashMap = (function() {
  var key = $n($as_T2($n(this.iterator__sc_Iterator()).next__O()))._1__O();
  return this.removed__O__sci_HashMap(key)
});
$c_sci_HashMap.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_HashMap__f_rootNode).foreach__F1__V(f)
});
$c_sci_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  $n(this.sci_HashMap__f_rootNode).foreachEntry__F2__V(f)
});
$c_sci_HashMap.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if ((this === x2)) {
      return true
    } else {
      var x = this.sci_HashMap__f_rootNode;
      var x$2 = $n(x2).sci_HashMap__f_rootNode;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))
    }
  } else {
    return $f_sc_Map__equals__O__Z(this, that)
  }
});
$c_sci_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var hashIterator = new $c_sci_MapKeyValueTupleHashIterator(this.sci_HashMap__f_rootNode);
    var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
    return hash
  }
});
$c_sci_HashMap.prototype.className__T = (function() {
  return "HashMap"
});
$c_sci_HashMap.prototype.filterImpl__F1__Z__sci_HashMap = (function(pred, isFlipped) {
  var newRootNode = $n(this.sci_HashMap__f_rootNode).filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped);
  if ((newRootNode === this.sci_HashMap__f_rootNode)) {
    return this
  } else if (($n(newRootNode).sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap
  } else {
    return new $c_sci_HashMap(newRootNode)
  }
});
$c_sci_HashMap.prototype.drop__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_IterableOps__drop__I__O(this, n))
});
$c_sci_HashMap.prototype.dropRight__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n))
});
$c_sci_HashMap.prototype.dropWhile__F1__O = (function(p) {
  return $as_sci_HashMap($f_sc_IterableOps__dropWhile__F1__O(this, p))
});
$c_sci_HashMap.prototype.takeWhile__F1__O = (function(p) {
  return $as_sci_HashMap($f_sc_IterableOps__takeWhile__F1__O(this, p))
});
$c_sci_HashMap.prototype.take__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_IterableOps__take__I__O(this, n))
});
$c_sci_HashMap.prototype.head__O = (function() {
  return $as_T2($n(this.iterator__sc_Iterator()).next__O())
});
$c_sci_HashMap.prototype.tail__O = (function() {
  return this.tail__sci_HashMap()
});
$c_sci_HashMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_HashMap(key)
});
$c_sci_HashMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_HashMap(key, value)
});
$c_sci_HashMap.prototype.keySet__sc_Set = (function() {
  return this.keySet__sci_Set()
});
function $as_sci_HashMap(obj) {
  return (((obj instanceof $c_sci_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashMap"))
}
function $isArrayOf_sci_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap)))
}
function $asArrayOf_sci_HashMap(obj, depth) {
  return (($isArrayOf_sci_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashMap;", depth))
}
var $d_sci_HashMap = new $TypeData().initClass({
  sci_HashMap: 0
}, false, "scala.collection.immutable.HashMap", {
  sci_HashMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap.prototype.$classData = $d_sci_HashMap;
/** @constructor */
function $c_sci_Stream$Cons(head, tl) {
  this.sci_Stream$Cons__f_head = null;
  this.sci_Stream$Cons__f_tlVal = null;
  this.sci_Stream$Cons__f_tlGen = null;
  this.sci_Stream$Cons__f_head = head;
  this.sci_Stream$Cons__f_tlGen = tl
}
$c_sci_Stream$Cons.prototype = new $h_sci_Stream();
$c_sci_Stream$Cons.prototype.constructor = $c_sci_Stream$Cons;
/** @constructor */
function $h_sci_Stream$Cons() {
  /*<skip>*/
}
$h_sci_Stream$Cons.prototype = $c_sci_Stream$Cons.prototype;
$c_sci_Stream$Cons.prototype.head__O = (function() {
  return this.sci_Stream$Cons__f_head
});
$c_sci_Stream$Cons.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Stream$Cons.prototype.tailDefined__Z = (function() {
  return (this.sci_Stream$Cons__f_tlGen === null)
});
$c_sci_Stream$Cons.prototype.tail__sci_Stream = (function() {
  if ((!this.tailDefined__Z())) {
    if ((!this.tailDefined__Z())) {
      this.sci_Stream$Cons__f_tlVal = $as_sci_Stream($n(this.sci_Stream$Cons__f_tlGen).apply__O());
      this.sci_Stream$Cons__f_tlGen = null
    }
  };
  return this.sci_Stream$Cons__f_tlVal
});
$c_sci_Stream$Cons.prototype.force__sci_Stream$Cons = (function() {
  var these = this;
  var those = this;
  if ((!$n(these).isEmpty__Z())) {
    these = $as_sci_Stream($n(these).tail__O())
  };
  while ((those !== these)) {
    if ($n(these).isEmpty__Z()) {
      return this
    };
    these = $as_sci_Stream($n(these).tail__O());
    if ($n(these).isEmpty__Z()) {
      return this
    };
    these = $as_sci_Stream($n(these).tail__O());
    if ((these === those)) {
      return this
    };
    those = $as_sci_Stream($n(those).tail__O())
  };
  return this
});
$c_sci_Stream$Cons.prototype.force__sci_Stream = (function() {
  return this.force__sci_Stream$Cons()
});
$c_sci_Stream$Cons.prototype.tail__O = (function() {
  return this.tail__sci_Stream()
});
var $d_sci_Stream$Cons = new $TypeData().initClass({
  sci_Stream$Cons: 0
}, false, "scala.collection.immutable.Stream$Cons", {
  sci_Stream$Cons: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$Cons.prototype.$classData = $d_sci_Stream$Cons;
/** @constructor */
function $c_sci_Stream$Empty$() {
  /*<skip>*/
}
$c_sci_Stream$Empty$.prototype = new $h_sci_Stream();
$c_sci_Stream$Empty$.prototype.constructor = $c_sci_Stream$Empty$;
/** @constructor */
function $h_sci_Stream$Empty$() {
  /*<skip>*/
}
$h_sci_Stream$Empty$.prototype = $c_sci_Stream$Empty$.prototype;
$c_sci_Stream$Empty$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Stream$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty stream")
});
$c_sci_Stream$Empty$.prototype.tail__sci_Stream = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty stream")
});
$c_sci_Stream$Empty$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Stream$Empty$.prototype.tailDefined__Z = (function() {
  return false
});
$c_sci_Stream$Empty$.prototype.force__sci_Stream = (function() {
  return this
});
$c_sci_Stream$Empty$.prototype.tail__O = (function() {
  return this.tail__sci_Stream()
});
$c_sci_Stream$Empty$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_Stream$Empty$ = new $TypeData().initClass({
  sci_Stream$Empty$: 0
}, false, "scala.collection.immutable.Stream$Empty$", {
  sci_Stream$Empty$: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$Empty$.prototype.$classData = $d_sci_Stream$Empty$;
var $n_sci_Stream$Empty$;
function $m_sci_Stream$Empty$() {
  if ((!$n_sci_Stream$Empty$)) {
    $n_sci_Stream$Empty$ = new $c_sci_Stream$Empty$()
  };
  return $n_sci_Stream$Empty$
}
function $as_sci_TreeSeqMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSeqMap"))
}
function $isArrayOf_sci_TreeSeqMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSeqMap)))
}
function $asArrayOf_sci_TreeSeqMap(obj, depth) {
  return (($isArrayOf_sci_TreeSeqMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSeqMap;", depth))
}
function $as_sci_VectorMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.VectorMap"))
}
function $isArrayOf_sci_VectorMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorMap)))
}
function $asArrayOf_sci_VectorMap(obj, depth) {
  return (($isArrayOf_sci_VectorMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.VectorMap;", depth))
}
/** @constructor */
function $c_scm_AbstractBuffer() {
  /*<skip>*/
}
$c_scm_AbstractBuffer.prototype = new $h_scm_AbstractSeq();
$c_scm_AbstractBuffer.prototype.constructor = $c_scm_AbstractBuffer;
/** @constructor */
function $h_scm_AbstractBuffer() {
  /*<skip>*/
}
$h_scm_AbstractBuffer.prototype = $c_scm_AbstractBuffer.prototype;
$c_scm_AbstractBuffer.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return $f_scm_Buffer__subtractOne__O__scm_Buffer(this, x)
});
$c_scm_AbstractBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_AbstractBuffer.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_Buffer(elem)
});
/** @constructor */
function $c_scm_AbstractMap() {
  /*<skip>*/
}
$c_scm_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_scm_AbstractMap.prototype.constructor = $c_scm_AbstractMap;
/** @constructor */
function $h_scm_AbstractMap() {
  /*<skip>*/
}
$h_scm_AbstractMap.prototype = $c_scm_AbstractMap.prototype;
$c_scm_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_Map$()
});
$c_scm_AbstractMap.prototype.update__O__O__V = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value)
});
$c_scm_AbstractMap.prototype.updateWith__O__F1__s_Option = (function(key, remappingFunction) {
  return $f_scm_MapOps__updateWith__O__F1__s_Option(this, key, remappingFunction)
});
$c_scm_AbstractMap.prototype.getOrElseUpdate__O__F0__O = (function(key, op) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, op)
});
$c_scm_AbstractMap.prototype.remove__O__s_Option = (function(key) {
  return $f_scm_MapOps__remove__O__s_Option(this, key)
});
$c_scm_AbstractMap.prototype.knownSize__I = (function() {
  return (-1)
});
$c_scm_AbstractMap.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_AbstractMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Iterable$()
});
$c_scm_AbstractMap.prototype.result__O = (function() {
  return this
});
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances$$anon$2(outer) {
  $ct_Lcats_NonEmptyReducible__Lcats_Foldable__(this, ($m_Lcats_UnorderedFoldable$(), $m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList))
}
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype = new $h_Lcats_NonEmptyReducible();
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.constructor = $c_Lcats_data_NonEmptyListInstances$$anon$2;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances$$anon$2.prototype = $c_Lcats_data_NonEmptyListInstances$$anon$2.prototype;
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).map__F1__Lcats_data_NonEmptyList(f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this)
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).flatMap__F1__Lcats_data_NonEmptyList(f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).map__F1__Lcats_data_NonEmptyList(f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.combineK__O__O__O = (function(x, y) {
  var a = $as_Lcats_data_NonEmptyList(x);
  var b = $as_Lcats_data_NonEmptyList(y);
  return $n(a).concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList(b)
});
var $d_Lcats_data_NonEmptyListInstances$$anon$2 = new $TypeData().initClass({
  Lcats_data_NonEmptyListInstances$$anon$2: 0
}, false, "cats.data.NonEmptyListInstances$$anon$2", {
  Lcats_data_NonEmptyListInstances$$anon$2: 1,
  Lcats_NonEmptyReducible: 1,
  O: 1,
  Lcats_Reducible: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1,
  Lcats_Bimonad: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_Apply: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Applicative: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Comonad: 1,
  Lcats_CoflatMap: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Align: 1
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.$classData = $d_Lcats_data_NonEmptyListInstances$$anon$2;
/** @constructor */
function $c_sci_SortedMapOps$ImmutableKeySortedSet(outer) {
  this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer = null;
  if ((outer === null)) {
    $n(null)
  } else {
    this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer = outer
  }
}
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype = new $h_sci_AbstractSet();
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.constructor = $c_sci_SortedMapOps$ImmutableKeySortedSet;
/** @constructor */
function $h_sci_SortedMapOps$ImmutableKeySortedSet() {
  /*<skip>*/
}
$h_sci_SortedMapOps$ImmutableKeySortedSet.prototype = $c_sci_SortedMapOps$ImmutableKeySortedSet.prototype;
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.ordering__s_math_Ordering = (function() {
  return $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer).ordering__s_math_Ordering()
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer);
  return new $c_sc_MapOps$$anon$2(this$1)
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.contains__O__Z = (function(key) {
  var this$1 = $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer);
  return $f_sc_MapOps__contains__O__Z(this$1, key)
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.size__I = (function() {
  return $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer).size__I()
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.knownSize__I = (function() {
  return $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer).knownSize__I()
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.isEmpty__Z = (function() {
  return $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer).isEmpty__Z()
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_sci_SortedSet$()
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.stringPrefix__T = (function() {
  return "SortedSet"
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_SortedSet$().newBuilder__O__scm_Builder($n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer).ordering__s_math_Ordering())
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.map__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $f_sc_SortedSetOps__map__F1__s_math_Ordering__sc_SortedSet(this, f, ev)
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.flatMap__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $f_sc_SortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet(this, f, ev)
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.incl__O__sci_SortedSet = (function(elem) {
  var this$1 = $m_sci_SortedSet$();
  var evidence$20 = $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer).ordering__s_math_Ordering();
  return $as_sci_SortedSet($n(this$1.from__sc_IterableOnce__s_math_Ordering__sci_SortedSet(this, evidence$20)).incl__O__sci_SetOps(elem))
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.excl__O__sci_SortedSet = (function(elem) {
  var this$1 = $m_sci_SortedSet$();
  var evidence$20 = $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer).ordering__s_math_Ordering();
  return $as_sci_SortedSet($n(this$1.from__sc_IterableOnce__s_math_Ordering__sci_SortedSet(this, evidence$20)).excl__O__sci_SetOps(elem))
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sc_SortedSetOps$WithFilter(this, p)
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_SortedSet$();
  var evidence$20 = $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer).ordering__s_math_Ordering();
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_SortedSet(coll, evidence$20)
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_SortedSet$();
  var evidence$20 = $n(this.sci_SortedMapOps$ImmutableKeySortedSet__f_$outer).ordering__s_math_Ordering();
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_SortedSet(coll, evidence$20)
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_SortedSet(elem)
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_SortedSet(elem)
});
var $d_sci_SortedMapOps$ImmutableKeySortedSet = new $TypeData().initClass({
  sci_SortedMapOps$ImmutableKeySortedSet: 0
}, false, "scala.collection.immutable.SortedMapOps$ImmutableKeySortedSet", {
  sci_SortedMapOps$ImmutableKeySortedSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sc_MapOps$GenKeySet: 1,
  sc_SortedMapOps$GenKeySortedSet: 1
});
$c_sci_SortedMapOps$ImmutableKeySortedSet.prototype.$classData = $d_sci_SortedMapOps$ImmutableKeySortedSet;
function $p_scm_HashSet__addElem__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length) | 0));
  var x1 = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(idx);
  if ((x1 === null)) {
    $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(idx, new $c_scm_HashSet$Node(elem, hash, null))
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && ($n(n).scm_HashSet$Node__f__hash <= hash))) {
      if ((($n(n).scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(elem, $n(n).scm_HashSet$Node__f__key))) {
        return false
      };
      prev = n;
      n = $n(n).scm_HashSet$Node__f__next
    };
    if ((prev === null)) {
      $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(idx, new $c_scm_HashSet$Node(elem, hash, x1))
    } else {
      $n(prev).scm_HashSet$Node__f__next = new $c_scm_HashSet$Node(elem, hash, $n(prev).scm_HashSet$Node__f__next)
    }
  };
  $thiz.scm_HashSet__f_contentSize = ((1 + $thiz.scm_HashSet__f_contentSize) | 0);
  return true
}
function $p_scm_HashSet__remove__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length) | 0));
  var x1 = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(idx);
  if ((x1 !== null)) {
    if ((($n(x1).scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(x1).scm_HashSet$Node__f__key, elem))) {
      $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(idx, $n(x1).scm_HashSet$Node__f__next);
      $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
      return true
    } else {
      var prev = x1;
      var next = $n(x1).scm_HashSet$Node__f__next;
      while (((next !== null) && ($n(next).scm_HashSet$Node__f__hash <= hash))) {
        if ((($n(next).scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(next).scm_HashSet$Node__f__key, elem))) {
          $n(prev).scm_HashSet$Node__f__next = $n(next).scm_HashSet$Node__f__next;
          $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
          return true
        };
        prev = next;
        next = $n(next).scm_HashSet$Node__f__next
      };
      return false
    }
  } else {
    return false
  }
}
function $p_scm_HashSet__growTable__I__V($thiz, newlen) {
  var oldlen = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length;
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashSet__f_contentSize === 0)) {
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)(newlen)
  } else {
    var original = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table;
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = $asArrayOf_scm_HashSet$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashSet$Node(null, 0, null);
    var preHigh = new $c_scm_HashSet$Node(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(i);
        if ((old !== null)) {
          preLow.scm_HashSet$Node__f__next = null;
          preHigh.scm_HashSet$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = $n(n).scm_HashSet$Node__f__next;
            if ((($n(n).scm_HashSet$Node__f__hash & oldlen) === 0)) {
              $n(lastLow).scm_HashSet$Node__f__next = n;
              lastLow = n
            } else {
              $n(lastHigh).scm_HashSet$Node__f__next = n;
              lastHigh = n
            };
            n = next
          };
          $n(lastLow).scm_HashSet$Node__f__next = null;
          if ((old !== preLow.scm_HashSet$Node__f__next)) {
            $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(i, preLow.scm_HashSet$Node__f__next)
          };
          if ((preHigh.scm_HashSet$Node__f__next !== null)) {
            $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(((i + oldlen) | 0), preHigh.scm_HashSet$Node__f__next);
            $n(lastHigh).scm_HashSet$Node__f__next = null
          }
        };
        i = ((1 + i) | 0)
      };
      oldlen = (oldlen << 1)
    }
  }
}
function $p_scm_HashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> $uI(Math.clz32(i))) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824)
}
function $p_scm_HashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashSet__f_loadFactor))
}
function $ct_scm_HashSet__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashSet__f_loadFactor = loadFactor;
  $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)($p_scm_HashSet__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length);
  $thiz.scm_HashSet__f_contentSize = 0;
  return $thiz
}
function $ct_scm_HashSet__($thiz) {
  $ct_scm_HashSet__I__D__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_scm_HashSet() {
  this.scm_HashSet__f_loadFactor = 0.0;
  this.scm_HashSet__f_scala$collection$mutable$HashSet$$table = null;
  this.scm_HashSet__f_threshold = 0;
  this.scm_HashSet__f_contentSize = 0
}
$c_scm_HashSet.prototype = new $h_scm_AbstractSet();
$c_scm_HashSet.prototype.constructor = $c_scm_HashSet;
/** @constructor */
function $h_scm_HashSet() {
  /*<skip>*/
}
$h_scm_HashSet.prototype = $c_scm_HashSet.prototype;
$c_scm_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_HashSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_HashSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_scm_HashSet.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_scm_HashSet.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_scm_HashSet.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_scm_HashSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_scm_HashSet.prototype.size__I = (function() {
  return this.scm_HashSet__f_contentSize
});
$c_scm_HashSet.prototype.scala$collection$mutable$HashSet$$improveHash__I__I = (function(originalHash) {
  return (originalHash ^ ((originalHash >>> 16) | 0))
});
$c_scm_HashSet.prototype.contains__O__Z = (function(elem) {
  var hash = this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem));
  var x1 = $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get((hash & (((-1) + $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length) | 0)));
  return (((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashSet$Node(elem, hash)) !== null)
});
$c_scm_HashSet.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashSet__f_loadFactor)));
  if ((target > $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length)) {
    $p_scm_HashSet__growTable__I__V(this, target)
  }
});
$c_scm_HashSet.prototype.add__O__Z = (function(elem) {
  if ((((1 + this.scm_HashSet__f_contentSize) | 0) >= this.scm_HashSet__f_threshold)) {
    $p_scm_HashSet__growTable__I__V(this, ($n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length << 1))
  };
  return $p_scm_HashSet__addElem__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)))
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_HashSet = (function(xs) {
  this.sizeHint__I__V($n(xs).knownSize__I());
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    var this$2 = $n(x2);
    var f = new $c_sjsr_AnonFunction2(((k$2, h$2) => {
      var h = $uI(h$2);
      $p_scm_HashSet__addElem__O__I__Z(this, k$2, this.scala$collection$mutable$HashSet$$improveHash__I__I(h))
    }));
    $n(this$2.sci_HashSet__f_rootNode).foreachWithHash__F2__V(f);
    return this
  } else if ((xs instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(xs);
    var this$3 = $n(x3);
    var iter = new $c_scm_HashSet$$anon$2(this$3);
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      $p_scm_HashSet__addElem__O__I__Z(this, $n(next).scm_HashSet$Node__f__key, $n(next).scm_HashSet$Node__f__hash)
    };
    return this
  } else if (false) {
    var x4 = $as_scm_LinkedHashSet(xs);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    while ($n(iter$2).hasNext__Z()) {
      var next$2 = $as_scm_LinkedHashSet$Entry($n(iter$2).next__O());
      $p_scm_HashSet__addElem__O__I__Z(this, $n(next$2).key__O(), $n(next$2).hash__I())
    };
    return this
  } else {
    return $as_scm_HashSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_HashSet.prototype.remove__O__Z = (function(elem) {
  return $p_scm_HashSet__remove__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)))
});
$c_scm_HashSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_HashSet$$anon$1(this)
});
$c_scm_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$()
});
$c_scm_HashSet.prototype.knownSize__I = (function() {
  return this.scm_HashSet__f_contentSize
});
$c_scm_HashSet.prototype.isEmpty__Z = (function() {
  return (this.scm_HashSet__f_contentSize === 0)
});
$c_scm_HashSet.prototype.foreach__F1__V = (function(f) {
  var len = $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length;
  var i = 0;
  while ((i < len)) {
    var n = $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(i);
    if ((n !== null)) {
      $n(n).foreach__F1__V(f)
    };
    i = ((1 + i) | 0)
  }
});
$c_scm_HashSet.prototype.className__T = (function() {
  return "HashSet"
});
$c_scm_HashSet.prototype.hashCode__I = (function() {
  var setIterator = new $c_scm_HashSet$$anon$1(this);
  var hashIterator = ((!setIterator.hasNext__Z()) ? setIterator : new $c_scm_HashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed)
});
$c_scm_HashSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  this.remove__O__Z(elem);
  return this
});
$c_scm_HashSet.prototype.addOne__O__scm_Growable = (function(elem) {
  this.add__O__Z(elem);
  return this
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_HashSet(xs)
});
function $as_scm_HashSet(obj) {
  return (((obj instanceof $c_scm_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet"))
}
function $isArrayOf_scm_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet)))
}
function $asArrayOf_scm_HashSet(obj, depth) {
  return (($isArrayOf_scm_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet;", depth))
}
var $d_scm_HashSet = new $TypeData().initClass({
  scm_HashSet: 0
}, false, "scala.collection.mutable.HashSet", {
  scm_HashSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashSet.prototype.$classData = $d_scm_HashSet;
/** @constructor */
function $c_sjs_js_WrappedDictionary(dict) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = null;
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = dict
}
$c_sjs_js_WrappedDictionary.prototype = new $h_scm_AbstractMap();
$c_sjs_js_WrappedDictionary.prototype.constructor = $c_sjs_js_WrappedDictionary;
/** @constructor */
function $h_sjs_js_WrappedDictionary() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary.prototype = $c_sjs_js_WrappedDictionary.prototype;
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary = (function(coll) {
  var d = new $c_sjs_js_WrappedDictionary({});
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(d, coll);
  return d
});
$c_sjs_js_WrappedDictionary.prototype.newSpecificBuilder__scm_Builder = (function() {
  return new $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder()
});
$c_sjs_js_WrappedDictionary.prototype.get__T__s_Option = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return new $c_s_Some(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key])
  } else {
    return $m_s_None$()
  }
});
$c_sjs_js_WrappedDictionary.prototype.apply__T__O = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sjs_js_WrappedDictionary.prototype.getOrElse__T__F0__O = (function(key, default$1) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]
  } else {
    return $n(default$1).apply__O()
  }
});
$c_sjs_js_WrappedDictionary.prototype.getOrElseUpdate__T__F0__O = (function(key, op) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]
  } else {
    var v = $n(op).apply__O();
    this.update__T__O__V(key, v);
    return v
  }
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__T__sjs_js_WrappedDictionary = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    delete this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]
  };
  return this
});
$c_sjs_js_WrappedDictionary.prototype.update__T__O__V = (function(key, value) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key] = value
});
$c_sjs_js_WrappedDictionary.prototype.addOne__T2__sjs_js_WrappedDictionary = (function(kv) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  var key = $as_T($n(kv)._1__O());
  var value = $n(kv)._2__O();
  dict[key] = value;
  return this
});
$c_sjs_js_WrappedDictionary.prototype.iterator__sc_Iterator = (function() {
  return new $c_sjs_js_WrappedDictionary$DictionaryIterator(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict)
});
$c_sjs_js_WrappedDictionary.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary($as_T2(elem))
});
$c_sjs_js_WrappedDictionary.prototype.update__O__O__V = (function(key, value) {
  this.update__T__O__V($as_T(key), value)
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__T__sjs_js_WrappedDictionary($as_T(elem))
});
$c_sjs_js_WrappedDictionary.prototype.contains__O__Z = (function(key) {
  var key$1 = $as_T(key);
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  return $uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key$1))
});
$c_sjs_js_WrappedDictionary.prototype.getOrElseUpdate__O__F0__O = (function(key, op) {
  return this.getOrElseUpdate__T__F0__O($as_T(key), op)
});
$c_sjs_js_WrappedDictionary.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return this.getOrElse__T__F0__O($as_T(key), default$1)
});
$c_sjs_js_WrappedDictionary.prototype.apply__O__O = (function(key) {
  return this.apply__T__O($as_T(key))
});
$c_sjs_js_WrappedDictionary.prototype.get__O__s_Option = (function(key) {
  return this.get__T__s_Option($as_T(key))
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll)
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll)
});
var $d_sjs_js_WrappedDictionary = new $TypeData().initClass({
  sjs_js_WrappedDictionary: 0
}, false, "scala.scalajs.js.WrappedDictionary", {
  sjs_js_WrappedDictionary: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1
});
$c_sjs_js_WrappedDictionary.prototype.$classData = $d_sjs_js_WrappedDictionary;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JSetWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying = underlying
}
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = new $h_scm_AbstractSet();
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JSetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JSetWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  var b = new $c_scm_HashSet$$anon$4(16, 0.75);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(this);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(that);
  return $as_sc_SetOps(b.scm_GrowableBuilder__f_elems)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.size__I = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).size__I()
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.isEmpty__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).isEmpty__Z()
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.knownSize__I = (function() {
  return ($n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).isEmpty__Z() ? 0 : (-1))
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $m_s_jdk_CollectionConverters$();
  var i = $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).iterator__ju_Iterator();
  return new $c_sc_convert_AsScalaExtensions$IteratorHasAsScala(this$1, i).asScala__sc_Iterator()
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.contains__O__Z = (function(elem) {
  return $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).contains__O__Z(elem)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.addOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper = (function(elem) {
  $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).add__O__Z(elem);
  return this
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.subtractOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper = (function(elem) {
  $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).remove__O__Z(elem);
  return this
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.remove__O__Z = (function(elem) {
  return $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).remove__O__Z(elem)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$()
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper(elem)
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper(elem)
});
function $as_sc_convert_JavaCollectionWrappers$JSetWrapper(obj) {
  return (((obj instanceof $c_sc_convert_JavaCollectionWrappers$JSetWrapper) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$JSetWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$JSetWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$JSetWrapper;", depth))
}
var $d_sc_convert_JavaCollectionWrappers$JSetWrapper = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JSetWrapper: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JSetWrapper", {
  sc_convert_JavaCollectionWrappers$JSetWrapper: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JSetWrapper;
/** @constructor */
function $c_sci_ListMap() {
  /*<skip>*/
}
$c_sci_ListMap.prototype = new $h_sci_AbstractMap();
$c_sci_ListMap.prototype.constructor = $c_sci_ListMap;
/** @constructor */
function $h_sci_ListMap() {
  /*<skip>*/
}
$h_sci_ListMap.prototype = $c_sci_ListMap.prototype;
$c_sci_ListMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f)
});
$c_sci_ListMap.prototype.collect__s_PartialFunction__sc_IterableOps = (function(pf) {
  return $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this, pf)
});
$c_sci_ListMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_ListMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_ListMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_ListMap.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_ListMap.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_ListMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_sci_ListMap.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sci_ListMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_ListMap.prototype.stringPrefix__T = (function() {
  return "SeqMap"
});
$c_sci_ListMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_ListMap$()
});
$c_sci_ListMap.prototype.size__I = (function() {
  return 0
});
$c_sci_ListMap.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_ListMap.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_ListMap.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$()
});
$c_sci_ListMap.prototype.updated__O__O__sci_ListMap = (function(key, value) {
  return new $c_sci_ListMap$Node(key, value, this)
});
$c_sci_ListMap.prototype.removed__O__sci_ListMap = (function(key) {
  return this
});
$c_sci_ListMap.prototype.iterator__sc_Iterator = (function() {
  var curr = this;
  var res = $m_sci_Nil$();
  while (true) {
    var this$1 = $n(curr);
    if ((!this$1.isEmpty__Z())) {
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), $n(curr).key__O(), $n(curr).value__O());
      var this$2 = $n(res);
      res = new $c_sci_$colon$colon(rassoc$1, this$2);
      curr = $n(curr).next__sci_ListMap()
    } else {
      break
    }
  };
  return $n(res).iterator__sc_Iterator()
});
$c_sci_ListMap.prototype.keys__sci_Iterable = (function() {
  var curr = this;
  var res = $m_sci_Nil$();
  while (true) {
    var this$1 = $n(curr);
    if ((!this$1.isEmpty__Z())) {
      var rassoc$2 = $n(curr).key__O();
      var this$2 = $n(res);
      res = new $c_sci_$colon$colon(rassoc$2, this$2);
      curr = $n(curr).next__sci_ListMap()
    } else {
      break
    }
  };
  return res
});
$c_sci_ListMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var _reversed = new $c_sci_ListMap$$anon$1(this);
    return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(_reversed)
  }
});
$c_sci_ListMap.prototype.key__O = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "key of empty map")
});
$c_sci_ListMap.prototype.value__O = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "value of empty map")
});
$c_sci_ListMap.prototype.next__sci_ListMap = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next of empty map")
});
$c_sci_ListMap.prototype.className__T = (function() {
  return "ListMap"
});
$c_sci_ListMap.prototype.keys__sc_Iterable = (function() {
  return this.keys__sci_Iterable()
});
$c_sci_ListMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_ListMap(key)
});
$c_sci_ListMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_ListMap(key, value)
});
function $as_sci_ListMap(obj) {
  return (((obj instanceof $c_sci_ListMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ListMap"))
}
function $isArrayOf_sci_ListMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListMap)))
}
function $asArrayOf_sci_ListMap(obj, depth) {
  return (($isArrayOf_sci_ListMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ListMap;", depth))
}
function $p_sci_Range__gap__J($thiz) {
  var value = $thiz.sci_Range__f_end;
  var hi = (value >> 31);
  var value$1 = $thiz.sci_Range__f_start;
  var hi$1 = (value$1 >> 31);
  var lo = ((value - value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  return new $c_RTLong(lo, hi$2)
}
function $p_sci_Range__isExact__Z($thiz) {
  var this$2 = $p_sci_Range__gap__J($thiz);
  var value = $thiz.sci_Range__f_step;
  var hi = (value >> 31);
  var this$3 = $m_RTLong$();
  var lo = this$3.remainderImpl__I__I__I__I__I(this$2.RTLong__f_lo, this$2.RTLong__f_hi, value, hi);
  var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return ((lo === 0) && (hi$1 === 0))
}
function $p_sci_Range__hasStub__Z($thiz) {
  return ($thiz.isInclusive__Z() || (!$p_sci_Range__isExact__Z($thiz)))
}
function $p_sci_Range__longLength__J($thiz) {
  var this$2 = $p_sci_Range__gap__J($thiz);
  var value = $thiz.sci_Range__f_step;
  var hi = (value >> 31);
  var this$3 = $m_RTLong$();
  var lo = this$3.divideImpl__I__I__I__I__I(this$2.RTLong__f_lo, this$2.RTLong__f_hi, value, hi);
  var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var value$1 = ($p_sci_Range__hasStub__Z($thiz) ? 1 : 0);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  return new $c_RTLong(lo$1, hi$3)
}
function $p_sci_Range__argTakeWhile__F1__J($thiz, p) {
  if ($thiz.sci_Range__f_isEmpty) {
    var value = $thiz.sci_Range__f_start;
    var hi = (value >> 31);
    return new $c_RTLong(value, hi)
  } else {
    var current = $thiz.sci_Range__f_start;
    var stop = $thiz.last__I();
    while (((current !== stop) && $n(p).apply$mcZI$sp__I__Z(current))) {
      current = ((current + $thiz.sci_Range__f_step) | 0)
    };
    if (((current !== stop) || (!$n(p).apply$mcZI$sp__I__Z(current)))) {
      var value$1 = current;
      var hi$1 = (value$1 >> 31);
      return new $c_RTLong(value$1, hi$1)
    } else {
      var value$2 = current;
      var hi$2 = (value$2 >> 31);
      var value$3 = $thiz.sci_Range__f_step;
      var hi$3 = (value$3 >> 31);
      var lo = ((value$2 + value$3) | 0);
      var hi$4 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value$2)) ? ((1 + ((hi$2 + hi$3) | 0)) | 0) : ((hi$2 + hi$3) | 0));
      return new $c_RTLong(lo, hi$4)
    }
  }
}
function $p_sci_Range__locationAfterN__I__I($thiz, n) {
  return (($thiz.sci_Range__f_start + Math.imul($thiz.sci_Range__f_step, n)) | 0)
}
function $ct_sci_Range__I__I__I__($thiz, start, end, step) {
  $thiz.sci_Range__f_start = start;
  $thiz.sci_Range__f_end = end;
  $thiz.sci_Range__f_step = step;
  $thiz.sci_Range__f_isEmpty = ((((start > end) && (step > 0)) || ((start < end) && (step < 0))) || ((start === end) && (!$thiz.isInclusive__Z())));
  if ((step === 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.")
  };
  if ($thiz.sci_Range__f_isEmpty) {
    var $$x1 = 0
  } else {
    var t = $p_sci_Range__longLength__J($thiz);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var $$x1 = (((hi === 0) ? (((-2147483648) ^ lo) > (-1)) : (hi > 0)) ? (-1) : lo)
  };
  $thiz.sci_Range__f_scala$collection$immutable$Range$$numRangeElements = $$x1;
  switch (step) {
    case 1: {
      var $$x2 = ($thiz.isInclusive__Z() ? end : (((-1) + end) | 0));
      break
    }
    case (-1): {
      var $$x2 = ($thiz.isInclusive__Z() ? end : ((1 + end) | 0));
      break
    }
    default: {
      var this$2 = $p_sci_Range__gap__J($thiz);
      var hi$1 = (step >> 31);
      var this$3 = $m_RTLong$();
      var lo$1 = this$3.remainderImpl__I__I__I__I__I(this$2.RTLong__f_lo, this$2.RTLong__f_hi, step, hi$1);
      var $$x2 = ((lo$1 !== 0) ? ((end - lo$1) | 0) : ($thiz.isInclusive__Z() ? end : ((end - step) | 0)))
    }
  };
  $thiz.sci_Range__f_scala$collection$immutable$Range$$lastElement = $$x2;
  return $thiz
}
/** @constructor */
function $c_sci_Range() {
  this.sci_Range__f_start = 0;
  this.sci_Range__f_end = 0;
  this.sci_Range__f_step = 0;
  this.sci_Range__f_isEmpty = false;
  this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements = 0;
  this.sci_Range__f_scala$collection$immutable$Range$$lastElement = 0
}
$c_sci_Range.prototype = new $h_sci_AbstractSeq();
$c_sci_Range.prototype.constructor = $c_sci_Range;
/** @constructor */
function $h_sci_Range() {
  /*<skip>*/
}
$h_sci_Range.prototype = $c_sci_Range.prototype;
$c_sci_Range.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sci_Range.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sci_StrictOptimizedSeqOps__updated__I__O__O(this, index, elem)
});
$c_sci_Range.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sci_Range.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem)
});
$c_sci_Range.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem)
});
$c_sci_Range.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sci_Range.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that)
});
$c_sci_Range.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Range.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Range.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Range.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Range.prototype.scanLeft__O__F2__O = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op)
});
$c_sci_Range.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_sci_Range.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sci_Range.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_sci_Range.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_Range.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_IndexedSeq$()
});
$c_sci_Range.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_Range.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_Range.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sci_Range.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sci_Range.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_Range.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sci_Range.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_RangeIterator(this.sci_Range__f_start, this.sci_Range__f_step, this.sci_Range__f_scala$collection$immutable$Range$$lastElement, this.sci_Range__f_isEmpty)
});
$c_sci_Range.prototype.isEmpty__Z = (function() {
  return this.sci_Range__f_isEmpty
});
$c_sci_Range.prototype.length__I = (function() {
  return ((this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements < 0) ? $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(this.sci_Range__f_start, this.sci_Range__f_end, this.sci_Range__f_step, this.isInclusive__Z()) : this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements)
});
$c_sci_Range.prototype.last__I = (function() {
  if (this.sci_Range__f_isEmpty) {
    var $$x1 = $m_sci_Range$().scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable("last");
    throw (($$x1 instanceof $c_sjs_js_JavaScriptException) ? $$x1.sjs_js_JavaScriptException__f_exception : $n($$x1))
  } else {
    return this.sci_Range__f_scala$collection$immutable$Range$$lastElement
  }
});
$c_sci_Range.prototype.head__I = (function() {
  if (this.sci_Range__f_isEmpty) {
    var $$x1 = $m_sci_Range$().scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable("head");
    throw (($$x1 instanceof $c_sjs_js_JavaScriptException) ? $$x1.sjs_js_JavaScriptException__f_exception : $n($$x1))
  } else {
    return this.sci_Range__f_start
  }
});
$c_sci_Range.prototype.init__sci_Range = (function() {
  if (this.sci_Range__f_isEmpty) {
    var $$x1 = $m_sci_Range$().scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable("init");
    throw (($$x1 instanceof $c_sjs_js_JavaScriptException) ? $$x1.sjs_js_JavaScriptException__f_exception : $n($$x1))
  } else {
    return this.dropRight__I__sci_Range(1)
  }
});
$c_sci_Range.prototype.tail__sci_Range = (function() {
  if (this.sci_Range__f_isEmpty) {
    var $$x1 = $m_sci_Range$().scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable("tail");
    throw (($$x1 instanceof $c_sjs_js_JavaScriptException) ? $$x1.sjs_js_JavaScriptException__f_exception : $n($$x1))
  };
  if ((this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements === 1)) {
    var value = this.sci_Range__f_end;
    return new $c_sci_Range$Exclusive(value, value, this.sci_Range__f_step)
  } else {
    return (this.isInclusive__Z() ? new $c_sci_Range$Inclusive(((this.sci_Range__f_start + this.sci_Range__f_step) | 0), this.sci_Range__f_end, this.sci_Range__f_step) : new $c_sci_Range$Exclusive(((this.sci_Range__f_start + this.sci_Range__f_step) | 0), this.sci_Range__f_end, this.sci_Range__f_step))
  }
});
$c_sci_Range.prototype.map__F1__sci_IndexedSeq = (function(f) {
  this.scala$collection$immutable$Range$$validateMaxLength__V();
  return $as_sci_IndexedSeq($f_sc_StrictOptimizedIterableOps__map__F1__O(this, f))
});
$c_sci_Range.prototype.copy__I__I__I__Z__sci_Range = (function(start, end, step, isInclusive) {
  return (isInclusive ? new $c_sci_Range$Inclusive(start, end, step) : new $c_sci_Range$Exclusive(start, end, step))
});
$c_sci_Range.prototype.scala$collection$immutable$Range$$validateMaxLength__V = (function() {
  if ((this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements < 0)) {
    $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(this.sci_Range__f_start, this.sci_Range__f_end, this.sci_Range__f_step, this.isInclusive__Z())
  }
});
$c_sci_Range.prototype.foreach__F1__V = (function(f) {
  if ((!this.sci_Range__f_isEmpty)) {
    var i = this.sci_Range__f_start;
    while (true) {
      $n(f).apply__O__O(i);
      if ((i === this.sci_Range__f_scala$collection$immutable$Range$$lastElement)) {
        return (void 0)
      };
      i = ((i + this.sci_Range__f_step) | 0)
    }
  }
});
$c_sci_Range.prototype.indexOf__O__I__I = (function(elem, from) {
  if ($isInt(elem)) {
    var x2 = $uI(elem);
    var pos = this.scala$collection$immutable$Range$$posOf__I__I(x2);
    return ((pos >= from) ? pos : (-1))
  } else {
    return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from)
  }
});
$c_sci_Range.prototype.scala$collection$immutable$Range$$posOf__I__I = (function(i) {
  return (this.contains__I__Z(i) ? $intDiv(((i - this.sci_Range__f_start) | 0), this.sci_Range__f_step) : (-1))
});
$c_sci_Range.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  if ((that instanceof $c_sci_Range)) {
    var x2 = $as_sci_Range(that);
    var x1$2 = this.length__I();
    switch (x1$2) {
      case 0: {
        return $n(x2).sci_Range__f_isEmpty;
        break
      }
      case 1: {
        return (($n(x2).length__I() === 1) && (this.sci_Range__f_start === $n(x2).sci_Range__f_start));
        break
      }
      default: {
        return (($n(x2).length__I() === x1$2) && ((this.sci_Range__f_start === $n(x2).sci_Range__f_start) && (this.sci_Range__f_step === $n(x2).sci_Range__f_step)))
      }
    }
  } else {
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, that)
  }
});
$c_sci_Range.prototype.take__I__sci_Range = (function(n) {
  if (((n <= 0) || this.sci_Range__f_isEmpty)) {
    var value = this.sci_Range__f_start;
    return new $c_sci_Range$Exclusive(value, value, this.sci_Range__f_step)
  } else {
    return (((n >= this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) && (this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements >= 0)) ? this : new $c_sci_Range$Inclusive(this.sci_Range__f_start, $p_sci_Range__locationAfterN__I__I(this, (((-1) + n) | 0)), this.sci_Range__f_step))
  }
});
$c_sci_Range.prototype.drop__I__sci_Range = (function(n) {
  if (((n <= 0) || this.sci_Range__f_isEmpty)) {
    return this
  } else if (((n >= this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) && (this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements >= 0))) {
    var value = this.sci_Range__f_end;
    return new $c_sci_Range$Exclusive(value, value, this.sci_Range__f_step)
  } else {
    return this.copy__I__I__I__Z__sci_Range($p_sci_Range__locationAfterN__I__I(this, n), this.sci_Range__f_end, this.sci_Range__f_step, this.isInclusive__Z())
  }
});
$c_sci_Range.prototype.dropRight__I__sci_Range = (function(n) {
  if ((n <= 0)) {
    return this
  } else if ((this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements >= 0)) {
    return this.take__I__sci_Range(((this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements - n) | 0))
  } else {
    var y = ((this.last__I() - Math.imul(this.sci_Range__f_step, n)) | 0);
    if ((((this.sci_Range__f_step > 0) && (y < this.sci_Range__f_start)) || ((this.sci_Range__f_step < 0) && (y > this.sci_Range__f_start)))) {
      var value = this.sci_Range__f_start;
      return new $c_sci_Range$Exclusive(value, value, this.sci_Range__f_step)
    } else {
      var start = this.sci_Range__f_start;
      var step = this.sci_Range__f_step;
      return new $c_sci_Range$Inclusive(start, y, step)
    }
  }
});
$c_sci_Range.prototype.takeWhile__F1__sci_Range = (function(p) {
  var t = $p_sci_Range__argTakeWhile__F1__J(this, p);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var value = this.sci_Range__f_start;
  var hi$1 = (value >> 31);
  if (((lo === value) && (hi === hi$1))) {
    var value$1 = this.sci_Range__f_start;
    return new $c_sci_Range$Exclusive(value$1, value$1, this.sci_Range__f_step)
  } else {
    var value$2 = this.sci_Range__f_step;
    var hi$2 = (value$2 >> 31);
    var lo$1 = ((lo - value$2) | 0);
    if ((lo$1 === this.last__I())) {
      return this
    } else {
      var start = this.sci_Range__f_start;
      var step = this.sci_Range__f_step;
      return new $c_sci_Range$Inclusive(start, lo$1, step)
    }
  }
});
$c_sci_Range.prototype.dropWhile__F1__sci_Range = (function(p) {
  var t = $p_sci_Range__argTakeWhile__F1__J(this, p);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var value = this.sci_Range__f_start;
  var hi$1 = (value >> 31);
  if (((lo === value) && (hi === hi$1))) {
    return this
  } else {
    var value$1 = this.sci_Range__f_step;
    var hi$2 = (value$1 >> 31);
    var lo$1 = ((lo - value$1) | 0);
    if ((lo$1 === this.last__I())) {
      var value$2 = this.last__I();
      return new $c_sci_Range$Exclusive(value$2, value$2, this.sci_Range__f_step)
    } else {
      var start = ((lo$1 + this.sci_Range__f_step) | 0);
      var end = this.last__I();
      var step = this.sci_Range__f_step;
      return new $c_sci_Range$Inclusive(start, end, step)
    }
  }
});
$c_sci_Range.prototype.slice__I__I__sci_Range = (function(from, until) {
  if ((from <= 0)) {
    return this.take__I__sci_Range(until)
  } else if (((until >= this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) && (this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements >= 0))) {
    return this.drop__I__sci_Range(from)
  } else {
    var fromValue = $p_sci_Range__locationAfterN__I__I(this, from);
    if ((from >= until)) {
      return new $c_sci_Range$Exclusive(fromValue, fromValue, this.sci_Range__f_step)
    } else {
      var end = $p_sci_Range__locationAfterN__I__I(this, (((-1) + until) | 0));
      var step = this.sci_Range__f_step;
      return new $c_sci_Range$Inclusive(fromValue, end, step)
    }
  }
});
$c_sci_Range.prototype.reverse__sci_Range = (function() {
  return (this.sci_Range__f_isEmpty ? this : new $c_sci_Range$Inclusive(this.last__I(), this.sci_Range__f_start, ((-this.sci_Range__f_step) | 0)))
});
$c_sci_Range.prototype.contains__I__Z = (function(x) {
  if ((!((x === this.sci_Range__f_end) && (!this.isInclusive__Z())))) {
    if ((this.sci_Range__f_step > 0)) {
      if ((!((x < this.sci_Range__f_start) || (x > this.sci_Range__f_end)))) {
        if ((this.sci_Range__f_step === 1)) {
          return true
        } else {
          var dividend = ((x - this.sci_Range__f_start) | 0);
          var divisor = this.sci_Range__f_step;
          if ((divisor === 0)) {
            var $$x1 = $intMod(0, 0)
          } else {
            var n = ($uD((dividend >>> 0.0)) % $uD((divisor >>> 0.0)));
            var $$x1 = $uI((n | 0.0))
          };
          return ($$x1 === 0)
        }
      } else {
        return false
      }
    } else if ((!((x < this.sci_Range__f_end) || (x > this.sci_Range__f_start)))) {
      if ((this.sci_Range__f_step === (-1))) {
        return true
      } else {
        var dividend$1 = ((this.sci_Range__f_start - x) | 0);
        var divisor$1 = ((-this.sci_Range__f_step) | 0);
        if ((divisor$1 === 0)) {
          var $$x2 = $intMod(0, 0)
        } else {
          var n$1 = ($uD((dividend$1 >>> 0.0)) % $uD((divisor$1 >>> 0.0)));
          var $$x2 = $uI((n$1 | 0.0))
        };
        return ($$x2 === 0)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_sci_Range.prototype.contains__O__Z = (function(elem) {
  if ($isInt(elem)) {
    var x2 = $uI(elem);
    return this.contains__I__Z(x2)
  } else {
    return $f_sc_SeqOps__contains__O__Z(this, elem)
  }
});
$c_sci_Range.prototype.min__s_math_Ordering__I = (function(ord) {
  if ((ord === $m_s_math_Ordering$Int$())) {
    return ((this.sci_Range__f_step > 0) ? this.head__I() : this.last__I())
  } else {
    var this$1 = $m_s_math_Ordering$Int$();
    if ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$1, ord)) {
      return ((this.sci_Range__f_step > 0) ? this.last__I() : this.head__I())
    } else {
      return $uI($f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord))
    }
  }
});
$c_sci_Range.prototype.max__s_math_Ordering__I = (function(ord) {
  if ((ord === $m_s_math_Ordering$Int$())) {
    return ((this.sci_Range__f_step > 0) ? this.last__I() : this.head__I())
  } else {
    var this$1 = $m_s_math_Ordering$Int$();
    if ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$1, ord)) {
      return ((this.sci_Range__f_step > 0) ? this.head__I() : this.last__I())
    } else {
      return $uI($f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord))
    }
  }
});
$c_sci_Range.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647
});
$c_sci_Range.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sci_Range)) {
    var x2 = $as_sci_Range(other);
    if (this.sci_Range__f_isEmpty) {
      return $n(x2).sci_Range__f_isEmpty
    } else {
      var this$1 = $n(x2);
      if (((!this$1.sci_Range__f_isEmpty) && (this.sci_Range__f_start === $n(x2).sci_Range__f_start))) {
        var l0 = this.last__I();
        return ((l0 === $n(x2).last__I()) && ((this.sci_Range__f_start === l0) || (this.sci_Range__f_step === $n(x2).sci_Range__f_step)))
      } else {
        return false
      }
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, other)
  }
});
$c_sci_Range.prototype.hashCode__I = (function() {
  if ((this.length__I() >= 2)) {
    var this$1 = $m_s_util_hashing_MurmurHash3$();
    var start = this.sci_Range__f_start;
    var step = this.sci_Range__f_step;
    var last = this.sci_Range__f_scala$collection$immutable$Range$$lastElement;
    return this$1.rangeHash__I__I__I__I__I(start, step, last, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
  } else {
    return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
  }
});
$c_sci_Range.prototype.toString__T = (function() {
  var preposition = (this.isInclusive__Z() ? "to" : "until");
  var stepped = ((this.sci_Range__f_step === 1) ? "" : (" by " + this.sci_Range__f_step));
  var prefix = (this.sci_Range__f_isEmpty ? "empty " : ((!$p_sci_Range__isExact__Z(this)) ? "inexact " : ""));
  return (((((((prefix + "Range ") + this.sci_Range__f_start) + " ") + preposition) + " ") + this.sci_Range__f_end) + stepped)
});
$c_sci_Range.prototype.className__T = (function() {
  return "Range"
});
$c_sci_Range.prototype.sorted__s_math_Ordering__sci_IndexedSeq = (function(ord) {
  return ((ord === $m_s_math_Ordering$Int$()) ? ((this.sci_Range__f_step > 0) ? this : this.reverse__sci_Range()) : $as_sci_IndexedSeq($f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)))
});
$c_sci_Range.prototype.apply$mcII$sp__I__I = (function(idx) {
  this.scala$collection$immutable$Range$$validateMaxLength__V();
  if (((idx < 0) || (idx >= this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (((-1) + this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) | 0)) + ")"))
  } else {
    return ((this.sci_Range__f_start + Math.imul(this.sci_Range__f_step, idx)) | 0)
  }
});
$c_sci_Range.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this)
});
$c_sci_Range.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$()
});
$c_sci_Range.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_IndexedSeq(ord)
});
$c_sci_Range.prototype.distinct__O = (function() {
  return this
});
$c_sci_Range.prototype.max__s_math_Ordering__O = (function(ord) {
  return this.max__s_math_Ordering__I(ord)
});
$c_sci_Range.prototype.min__s_math_Ordering__O = (function(ord) {
  return this.min__s_math_Ordering__I(ord)
});
$c_sci_Range.prototype.reverse__O = (function() {
  return this.reverse__sci_Range()
});
$c_sci_Range.prototype.slice__I__I__O = (function(from, until) {
  return this.slice__I__I__sci_Range(from, until)
});
$c_sci_Range.prototype.dropWhile__F1__O = (function(p) {
  return this.dropWhile__F1__sci_Range(p)
});
$c_sci_Range.prototype.takeWhile__F1__O = (function(p) {
  return this.takeWhile__F1__sci_Range(p)
});
$c_sci_Range.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_Range(n)
});
$c_sci_Range.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_Range(n)
});
$c_sci_Range.prototype.take__I__O = (function(n) {
  return this.take__I__sci_Range(n)
});
$c_sci_Range.prototype.apply__O__O = (function(v1) {
  var idx = $uI(v1);
  return this.apply$mcII$sp__I__I(idx)
});
$c_sci_Range.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i)
});
$c_sci_Range.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_IndexedSeq(f)
});
$c_sci_Range.prototype.tail__O = (function() {
  return this.tail__sci_Range()
});
$c_sci_Range.prototype.init__O = (function() {
  return this.init__sci_Range()
});
$c_sci_Range.prototype.head__O = (function() {
  return this.head__I()
});
$c_sci_Range.prototype.last__O = (function() {
  return this.last__I()
});
function $as_sci_Range(obj) {
  return (((obj instanceof $c_sci_Range) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Range"))
}
function $isArrayOf_sci_Range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Range)))
}
function $asArrayOf_sci_Range(obj, depth) {
  return (($isArrayOf_sci_Range(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Range;", depth))
}
function $as_scm_LinkedHashSet(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashSet"))
}
function $isArrayOf_scm_LinkedHashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashSet)))
}
function $asArrayOf_scm_LinkedHashSet(obj, depth) {
  return (($isArrayOf_scm_LinkedHashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashSet;", depth))
}
/** @constructor */
function $c_scm_Map$WithDefault(underlying, defaultValue) {
  this.scm_Map$WithDefault__f_underlying = null;
  this.scm_Map$WithDefault__f_defaultValue = null;
  this.scm_Map$WithDefault__f_underlying = underlying;
  this.scm_Map$WithDefault__f_defaultValue = defaultValue
}
$c_scm_Map$WithDefault.prototype = new $h_scm_AbstractMap();
$c_scm_Map$WithDefault.prototype.constructor = $c_scm_Map$WithDefault;
/** @constructor */
function $h_scm_Map$WithDefault() {
  /*<skip>*/
}
$h_scm_Map$WithDefault.prototype = $c_scm_Map$WithDefault.prototype;
$c_scm_Map$WithDefault.prototype.default__O__O = (function(key) {
  return $n(this.scm_Map$WithDefault__f_defaultValue).apply__O__O(key)
});
$c_scm_Map$WithDefault.prototype.iterator__sc_Iterator = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).iterator__sc_Iterator()
});
$c_scm_Map$WithDefault.prototype.isEmpty__Z = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).isEmpty__Z()
});
$c_scm_Map$WithDefault.prototype.knownSize__I = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).knownSize__I()
});
$c_scm_Map$WithDefault.prototype.mapFactory__sc_MapFactory = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory()
});
$c_scm_Map$WithDefault.prototype.get__O__s_Option = (function(key) {
  return $n(this.scm_Map$WithDefault__f_underlying).get__O__s_Option(key)
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Map$WithDefault = (function(elem) {
  $n(this.scm_Map$WithDefault__f_underlying).subtractOne__O__scm_Shrinkable(elem);
  return this
});
$c_scm_Map$WithDefault.prototype.addOne__T2__scm_Map$WithDefault = (function(elem) {
  $n(this.scm_Map$WithDefault__f_underlying).addOne__O__scm_Growable(elem);
  return this
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__scm_Map$WithDefault = (function(coll) {
  return new $c_scm_Map$WithDefault($as_scm_Map($n($n(this.scm_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(coll)), this.scm_Map$WithDefault__f_defaultValue)
});
$c_scm_Map$WithDefault.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$2 = $n($m_scm_Map$().newBuilder__scm_Builder());
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_scm_Map(p$2);
    return new $c_scm_Map$WithDefault(p, this.scm_Map$WithDefault__f_defaultValue)
  }));
  return new $c_scm_Builder$$anon$1(this$2, f)
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll)
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll)
});
$c_scm_Map$WithDefault.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_Map$WithDefault($as_T2(elem))
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_Map$WithDefault(elem)
});
var $d_scm_Map$WithDefault = new $TypeData().initClass({
  scm_Map$WithDefault: 0
}, false, "scala.collection.mutable.Map$WithDefault", {
  scm_Map$WithDefault: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Map$WithDefault.prototype.$classData = $d_scm_Map$WithDefault;
function $p_Lscalatags_JsDom$all$__div$lzycompute__Lscalatags_JsDom$TypedTag($thiz) {
  var b = $thiz.Lscalatags_JsDom$all$__f_bitmap$0;
  var lo = (134217728 & b.RTLong__f_lo);
  if ((lo === 0)) {
    var ns = $m_Lscalatags_generic_Namespace$().Lscalatags_generic_Namespace$__f_htmlNamespaceConfig;
    $thiz.Lscalatags_JsDom$all$__f_div = $as_Lscalatags_JsDom$TypedTag($f_Lscalatags_jsdom_TagFactory__typedTag__T__Z__Lscalatags_generic_Namespace__Lscalatags_generic_TypedTag($thiz, "div", false, ns));
    var b$1 = $thiz.Lscalatags_JsDom$all$__f_bitmap$0;
    var lo$1 = (134217728 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscalatags_JsDom$all$__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscalatags_JsDom$all$__f_div
}
function $p_Lscalatags_JsDom$all$__type$lzycompute__Lscalatags_generic_Attr($thiz) {
  var b = $thiz.Lscalatags_JsDom$all$__f_bitmap$4;
  var lo = (2097152 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscalatags_JsDom$all$__f_type = $f_Lscalatags_generic_Util__attr__T__Lscalatags_generic_Namespace__Z__Lscalatags_generic_Attr($thiz, "type", null, false);
    var b$1 = $thiz.Lscalatags_JsDom$all$__f_bitmap$4;
    var lo$1 = (2097152 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscalatags_JsDom$all$__f_bitmap$4 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscalatags_JsDom$all$__f_type
}
/** @constructor */
function $c_Lscalatags_JsDom$all$() {
  this.Lscalatags_JsDom$all$__f_stringAttr = null;
  this.Lscalatags_JsDom$all$__f_stringStyle = null;
  this.Lscalatags_JsDom$all$__f_booleanStyle = null;
  this.Lscalatags_JsDom$all$__f_div = null;
  this.Lscalatags_JsDom$all$__f_type = null;
  this.Lscalatags_JsDom$all$__f_bitmap$0 = $L0;
  this.Lscalatags_JsDom$all$__f_bitmap$4 = $L0;
  $n_Lscalatags_JsDom$all$ = this;
  $f_Lscalatags_generic_MouseEventAttrs__$init$__V(this);
  $f_Lscalatags_generic_Aggregate__$init$__V(this);
  $f_Lscalatags_JsDom$Aggregate__$init$__V(this)
}
$c_Lscalatags_JsDom$all$.prototype = new $h_O();
$c_Lscalatags_JsDom$all$.prototype.constructor = $c_Lscalatags_JsDom$all$;
/** @constructor */
function $h_Lscalatags_JsDom$all$() {
  /*<skip>*/
}
$h_Lscalatags_JsDom$all$.prototype = $c_Lscalatags_JsDom$all$.prototype;
$c_Lscalatags_JsDom$all$.prototype.div__Lscalatags_JsDom$TypedTag = (function() {
  var b = this.Lscalatags_JsDom$all$__f_bitmap$0;
  var lo = (134217728 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscalatags_JsDom$all$__div$lzycompute__Lscalatags_JsDom$TypedTag(this)
  } else {
    return this.Lscalatags_JsDom$all$__f_div
  }
});
$c_Lscalatags_JsDom$all$.prototype.type__Lscalatags_generic_Attr = (function() {
  var b = this.Lscalatags_JsDom$all$__f_bitmap$4;
  var lo = (2097152 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscalatags_JsDom$all$__type$lzycompute__Lscalatags_generic_Attr(this)
  } else {
    return this.Lscalatags_JsDom$all$__f_type
  }
});
var $d_Lscalatags_JsDom$all$ = new $TypeData().initClass({
  Lscalatags_JsDom$all$: 0
}, false, "scalatags.JsDom$all$", {
  Lscalatags_JsDom$all$: 1,
  O: 1,
  Lscalatags_JsDom$Cap: 1,
  Lscalatags_generic_Util: 1,
  Lscalatags_generic_LowPriUtil: 1,
  Lscalatags_jsdom_TagFactory: 1,
  Lscalatags_generic_Attrs: 1,
  Lscalatags_generic_InputAttrs: 1,
  Lscalatags_generic_GlobalAttrs: 1,
  Lscalatags_generic_ClipboardEventAttrs: 1,
  Lscalatags_generic_MediaEventAttrs: 1,
  Lscalatags_generic_SharedEventAttrs: 1,
  Lscalatags_generic_MiscellaneousEventAttrs: 1,
  Lscalatags_generic_KeyboardEventAttrs: 1,
  Lscalatags_generic_MouseEventAttrs: 1,
  Lscalatags_generic_WindowEventAttrs: 1,
  Lscalatags_generic_FormEventAttrs: 1,
  Lscalatags_generic_Styles: 1,
  Lscalatags_generic_StyleMisc: 1,
  Lscalatags_jsdom_Tags: 1,
  Lscalatags_generic_Tags: 1,
  Lscalatags_DataConverters: 1,
  Lscalatags_JsDom$Aggregate: 1,
  Lscalatags_generic_Aggregate: 1,
  Lscalatags_generic_Aliases: 1,
  Lscalatags_LowPriorityImplicits: 1
});
$c_Lscalatags_JsDom$all$.prototype.$classData = $d_Lscalatags_JsDom$all$;
var $n_Lscalatags_JsDom$all$;
function $m_Lscalatags_JsDom$all$() {
  if ((!$n_Lscalatags_JsDom$all$)) {
    $n_Lscalatags_JsDom$all$ = new $c_Lscalatags_JsDom$all$()
  };
  return $n_Lscalatags_JsDom$all$
}
/** @constructor */
function $c_Lcats_kernel_instances_BooleanOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BooleanOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BooleanOrder.prototype.constructor = $c_Lcats_kernel_instances_BooleanOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BooleanOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BooleanOrder.prototype = $c_Lcats_kernel_instances_BooleanOrder.prototype;
$c_Lcats_kernel_instances_BooleanOrder.prototype.compare$mcZ$sp__Z__Z__I = (function(x, y) {
  return ((x === y) ? 0 : (x ? 1 : (-1)))
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.eqv$mcZ$sp__Z__Z__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.neqv$mcZ$sp__Z__Z__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  var x$1 = $uZ(x);
  var y$1 = $uZ(y);
  return $f_Lcats_kernel_Order$mcZ$sp__partialCompare$mcZ$sp__Z__Z__D(this, x$1, y$1)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.neqv__O__O__Z = (function(x, y) {
  var x$1 = $uZ(x);
  var y$1 = $uZ(y);
  return this.neqv$mcZ$sp__Z__Z__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $uZ(x);
  var y$1 = $uZ(y);
  return this.eqv$mcZ$sp__Z__Z__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uZ(x);
  var y$1 = $uZ(y);
  return this.compare$mcZ$sp__Z__Z__I(x$1, y$1)
});
var $d_Lcats_kernel_instances_BooleanOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BooleanOrder: 0
}, false, "cats.kernel.instances.BooleanOrder", {
  Lcats_kernel_instances_BooleanOrder: 1,
  O: 1,
  Lcats_kernel_Order$mcZ$sp: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_PartialOrder$mcZ$sp: 1,
  Lcats_kernel_Eq$mcZ$sp: 1,
  Lcats_kernel_Hash$mcZ$sp: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_BooleanBounded: 1,
  Lcats_kernel_LowerBounded$mcZ$sp: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded$mcZ$sp: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_BooleanEnumerable: 1,
  Lcats_kernel_BoundedEnumerable$mcZ$sp: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_PartialNextLowerBounded$mcZ$sp: 1,
  Lcats_kernel_PartialNext$mcZ$sp: 1,
  Lcats_kernel_PartialPrevious$mcZ$sp: 1,
  Lcats_kernel_PartialPreviousUpperBounded$mcZ$sp: 1
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.$classData = $d_Lcats_kernel_instances_BooleanOrder;
/** @constructor */
function $c_Lcats_kernel_instances_CharOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_CharOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_CharOrder.prototype.constructor = $c_Lcats_kernel_instances_CharOrder;
/** @constructor */
function $h_Lcats_kernel_instances_CharOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_CharOrder.prototype = $c_Lcats_kernel_instances_CharOrder.prototype;
$c_Lcats_kernel_instances_CharOrder.prototype.compare$mcC$sp__C__C__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_CharOrder.prototype.eqv$mcC$sp__C__C__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_CharOrder.prototype.neqv$mcC$sp__C__C__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_CharOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $f_Lcats_kernel_Order$mcC$sp__partialCompare$mcC$sp__C__C__D(this, x$1, y$1)
});
$c_Lcats_kernel_instances_CharOrder.prototype.neqv__O__O__Z = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return this.neqv$mcC$sp__C__C__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_CharOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return this.eqv$mcC$sp__C__C__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_CharOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return this.compare$mcC$sp__C__C__I(x$1, y$1)
});
var $d_Lcats_kernel_instances_CharOrder = new $TypeData().initClass({
  Lcats_kernel_instances_CharOrder: 0
}, false, "cats.kernel.instances.CharOrder", {
  Lcats_kernel_instances_CharOrder: 1,
  O: 1,
  Lcats_kernel_Order$mcC$sp: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_PartialOrder$mcC$sp: 1,
  Lcats_kernel_Eq$mcC$sp: 1,
  Lcats_kernel_Hash$mcC$sp: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_CharBounded: 1,
  Lcats_kernel_LowerBounded$mcC$sp: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded$mcC$sp: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_CharEnumerable: 1,
  Lcats_kernel_BoundedEnumerable$mcC$sp: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_PartialNextLowerBounded$mcC$sp: 1,
  Lcats_kernel_PartialNext$mcC$sp: 1,
  Lcats_kernel_PartialPrevious$mcC$sp: 1,
  Lcats_kernel_PartialPreviousUpperBounded$mcC$sp: 1
});
$c_Lcats_kernel_instances_CharOrder.prototype.$classData = $d_Lcats_kernel_instances_CharOrder;
/** @constructor */
function $c_Lcats_kernel_instances_IntOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_IntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_IntOrder.prototype.constructor = $c_Lcats_kernel_instances_IntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_IntOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_IntOrder.prototype = $c_Lcats_kernel_instances_IntOrder.prototype;
$c_Lcats_kernel_instances_IntOrder.prototype.compare$mcI$sp__I__I__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv$mcI$sp__I__I__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_IntOrder.prototype.neqv$mcI$sp__I__I__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_IntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_Lcats_kernel_Order$mcI$sp__partialCompare$mcI$sp__I__I__D(this, x$1, y$1)
});
$c_Lcats_kernel_instances_IntOrder.prototype.neqv__O__O__Z = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return this.neqv$mcI$sp__I__I__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return this.eqv$mcI$sp__I__I__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return this.compare$mcI$sp__I__I__I(x$1, y$1)
});
var $d_Lcats_kernel_instances_IntOrder = new $TypeData().initClass({
  Lcats_kernel_instances_IntOrder: 0
}, false, "cats.kernel.instances.IntOrder", {
  Lcats_kernel_instances_IntOrder: 1,
  O: 1,
  Lcats_kernel_Order$mcI$sp: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_PartialOrder$mcI$sp: 1,
  Lcats_kernel_Eq$mcI$sp: 1,
  Lcats_kernel_Hash$mcI$sp: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_IntBounded: 1,
  Lcats_kernel_LowerBounded$mcI$sp: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded$mcI$sp: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_IntEnumerable: 1,
  Lcats_kernel_BoundedEnumerable$mcI$sp: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_PartialNextLowerBounded$mcI$sp: 1,
  Lcats_kernel_PartialNext$mcI$sp: 1,
  Lcats_kernel_PartialPrevious$mcI$sp: 1,
  Lcats_kernel_PartialPreviousUpperBounded$mcI$sp: 1
});
$c_Lcats_kernel_instances_IntOrder.prototype.$classData = $d_Lcats_kernel_instances_IntOrder;
/** @constructor */
function $c_Lcats_kernel_instances_LongOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_LongOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_LongOrder.prototype.constructor = $c_Lcats_kernel_instances_LongOrder;
/** @constructor */
function $h_Lcats_kernel_instances_LongOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_LongOrder.prototype = $c_Lcats_kernel_instances_LongOrder.prototype;
$c_Lcats_kernel_instances_LongOrder.prototype.compare$mcJ$sp__J__J__I = (function(x, y) {
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ x.RTLong__f_lo) < ((-2147483648) ^ y.RTLong__f_lo)) : (ahi < bhi))) {
    return (-1)
  } else {
    var ahi$1 = x.RTLong__f_hi;
    var bhi$1 = y.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ x.RTLong__f_lo) > ((-2147483648) ^ y.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
      return 1
    } else {
      return 0
    }
  }
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv$mcJ$sp__J__J__Z = (function(x, y) {
  return ((x.RTLong__f_lo === y.RTLong__f_lo) && (x.RTLong__f_hi === y.RTLong__f_hi))
});
$c_Lcats_kernel_instances_LongOrder.prototype.neqv$mcJ$sp__J__J__Z = (function(x, y) {
  return (!((x.RTLong__f_lo === y.RTLong__f_lo) && (x.RTLong__f_hi === y.RTLong__f_hi)))
});
$c_Lcats_kernel_instances_LongOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_Lcats_kernel_Order$mcJ$sp__partialCompare$mcJ$sp__J__J__D(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1))
});
$c_Lcats_kernel_instances_LongOrder.prototype.neqv__O__O__Z = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return this.neqv$mcJ$sp__J__J__Z(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1))
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return this.eqv$mcJ$sp__J__J__Z(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1))
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__O__O__I = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return this.compare$mcJ$sp__J__J__I(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1))
});
var $d_Lcats_kernel_instances_LongOrder = new $TypeData().initClass({
  Lcats_kernel_instances_LongOrder: 0
}, false, "cats.kernel.instances.LongOrder", {
  Lcats_kernel_instances_LongOrder: 1,
  O: 1,
  Lcats_kernel_Order$mcJ$sp: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_PartialOrder$mcJ$sp: 1,
  Lcats_kernel_Eq$mcJ$sp: 1,
  Lcats_kernel_Hash$mcJ$sp: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_LongBounded: 1,
  Lcats_kernel_UpperBounded$mcJ$sp: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_LowerBounded$mcJ$sp: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_LongEnumerable: 1,
  Lcats_kernel_BoundedEnumerable$mcJ$sp: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_PartialNextLowerBounded$mcJ$sp: 1,
  Lcats_kernel_PartialNext$mcJ$sp: 1,
  Lcats_kernel_PartialPrevious$mcJ$sp: 1,
  Lcats_kernel_PartialPreviousUpperBounded$mcJ$sp: 1
});
$c_Lcats_kernel_instances_LongOrder.prototype.$classData = $d_Lcats_kernel_instances_LongOrder;
/** @constructor */
function $c_Lcats_kernel_instances_ShortOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ShortOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortOrder.prototype.constructor = $c_Lcats_kernel_instances_ShortOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ShortOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ShortOrder.prototype = $c_Lcats_kernel_instances_ShortOrder.prototype;
$c_Lcats_kernel_instances_ShortOrder.prototype.compare$mcS$sp__S__S__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv$mcS$sp__S__S__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.neqv$mcS$sp__S__S__Z = (function(x, y) {
  return (x !== y)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_Lcats_kernel_Order$mcS$sp__partialCompare$mcS$sp__S__S__D(this, x$1, y$1)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.neqv__O__O__Z = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return this.neqv$mcS$sp__S__S__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return this.eqv$mcS$sp__S__S__Z(x$1, y$1)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return this.compare$mcS$sp__S__S__I(x$1, y$1)
});
var $d_Lcats_kernel_instances_ShortOrder = new $TypeData().initClass({
  Lcats_kernel_instances_ShortOrder: 0
}, false, "cats.kernel.instances.ShortOrder", {
  Lcats_kernel_instances_ShortOrder: 1,
  O: 1,
  Lcats_kernel_Order$mcS$sp: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_PartialOrder$mcS$sp: 1,
  Lcats_kernel_Eq$mcS$sp: 1,
  Lcats_kernel_Hash$mcS$sp: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_ShortBounded: 1,
  Lcats_kernel_LowerBounded$mcS$sp: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded$mcS$sp: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ShortEnumerable: 1,
  Lcats_kernel_BoundedEnumerable$mcS$sp: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_PartialNextLowerBounded$mcS$sp: 1,
  Lcats_kernel_PartialNext$mcS$sp: 1,
  Lcats_kernel_PartialPrevious$mcS$sp: 1,
  Lcats_kernel_PartialPreviousUpperBounded$mcS$sp: 1
});
$c_Lcats_kernel_instances_ShortOrder.prototype.$classData = $d_Lcats_kernel_instances_ShortOrder;
/** @constructor */
function $c_Lcats_kernel_instances_UnitOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_UnitOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitOrder.prototype.constructor = $c_Lcats_kernel_instances_UnitOrder;
/** @constructor */
function $h_Lcats_kernel_instances_UnitOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_UnitOrder.prototype = $c_Lcats_kernel_instances_UnitOrder.prototype;
$c_Lcats_kernel_instances_UnitOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  var x$1 = $as_jl_Void(x);
  var y$1 = $as_jl_Void(y);
  return $f_Lcats_kernel_Order$mcV$sp__partialCompare$mcV$sp__jl_Void__jl_Void__D(this, x$1, y$1)
});
$c_Lcats_kernel_instances_UnitOrder.prototype.neqv__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return false
});
$c_Lcats_kernel_instances_UnitOrder.prototype.eqv__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return true
});
$c_Lcats_kernel_instances_UnitOrder.prototype.compare__O__O__I = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return 0
});
var $d_Lcats_kernel_instances_UnitOrder = new $TypeData().initClass({
  Lcats_kernel_instances_UnitOrder: 0
}, false, "cats.kernel.instances.UnitOrder", {
  Lcats_kernel_instances_UnitOrder: 1,
  O: 1,
  Lcats_kernel_Order$mcV$sp: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Eq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_PartialOrder$mcV$sp: 1,
  Lcats_kernel_Eq$mcV$sp: 1,
  Lcats_kernel_Hash$mcV$sp: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_instances_UnitBounded: 1,
  Lcats_kernel_LowerBounded$mcV$sp: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded$mcV$sp: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_UnitEnumerable: 1,
  Lcats_kernel_BoundedEnumerable$mcV$sp: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_PartialNextLowerBounded$mcV$sp: 1,
  Lcats_kernel_PartialNext$mcV$sp: 1,
  Lcats_kernel_PartialPrevious$mcV$sp: 1,
  Lcats_kernel_PartialPreviousUpperBounded$mcV$sp: 1
});
$c_Lcats_kernel_instances_UnitOrder.prototype.$classData = $d_Lcats_kernel_instances_UnitOrder;
/** @constructor */
function $c_Lcats_package$$anon$1() {
  /*<skip>*/
}
$c_Lcats_package$$anon$1.prototype = new $h_O();
$c_Lcats_package$$anon$1.prototype.constructor = $c_Lcats_package$$anon$1;
/** @constructor */
function $h_Lcats_package$$anon$1() {
  /*<skip>*/
}
$h_Lcats_package$$anon$1.prototype = $c_Lcats_package$$anon$1.prototype;
$c_Lcats_package$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_package$$anon$1.prototype.flatMap__O__F1__O = (function(a, f) {
  return $n(f).apply__O__O(a)
});
$c_Lcats_package$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return $n(f).apply__O__O(fa)
});
$c_Lcats_package$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $n(f).apply__O__O__O(fa, fb)
});
$c_Lcats_package$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  return $n(f).apply__O__O(fa)
});
var $d_Lcats_package$$anon$1 = new $TypeData().initClass({
  Lcats_package$$anon$1: 0
}, false, "cats.package$$anon$1", {
  Lcats_package$$anon$1: 1,
  O: 1,
  Lcats_Bimonad: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_Apply: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Applicative: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Comonad: 1,
  Lcats_CoflatMap: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Reducible: 1,
  Lcats_Distributive: 1
});
$c_Lcats_package$$anon$1.prototype.$classData = $d_Lcats_package$$anon$1;
function $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq($thiz, that) {
  if ($f_sc_SeqOps__isEmpty__Z($thiz)) {
    return that
  } else {
    var this$1 = $n(that);
    if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
      return $thiz
    } else {
      var thisIsObj = ($thiz.unsafeArray__O() instanceof $ac_O);
      var thatIsObj = ($n(that).unsafeArray__O() instanceof $ac_O);
      var mismatch = (thisIsObj !== thatIsObj);
      if (mismatch) {
        return null
      } else if (thisIsObj) {
        var ax = $thiz.unsafeArray__O();
        var ay = $n(that).unsafeArray__O();
        var len = (($m_jl_reflect_Array$().getLength__O__I(ax) + $m_jl_reflect_Array$().getLength__O__I(ay)) | 0);
        var a = new $ac_O(len);
        var length = $m_jl_reflect_Array$().getLength__O__I(ax);
        $systemArraycopyFull($n(ax), 0, a, 0, length);
        var destPos = $m_jl_reflect_Array$().getLength__O__I(ax);
        var length$1 = $m_jl_reflect_Array$().getLength__O__I(ay);
        $systemArraycopyFull($n(ay), 0, a, destPos, length$1);
        return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a)
      } else {
        var ax$2 = $thiz.unsafeArray__O();
        var ay$2 = $n(that).unsafeArray__O();
        var len$2 = (($m_jl_reflect_Array$().getLength__O__I(ax$2) + $m_jl_reflect_Array$().getLength__O__I(ay$2)) | 0);
        var a$2 = $n($thiz.elemTag__s_reflect_ClassTag()).newArray__I__O(len$2);
        var length$2 = $m_jl_reflect_Array$().getLength__O__I(ax$2);
        $systemArraycopyFull($n(ax$2), 0, $n(a$2), 0, length$2);
        var destPos$1 = $m_jl_reflect_Array$().getLength__O__I(ax$2);
        var length$3 = $m_jl_reflect_Array$().getLength__O__I(ay$2);
        $systemArraycopyFull($n(ay$2), 0, $n(a$2), destPos$1, length$3);
        return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a$2)
      }
    }
  }
}
function $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq($thiz, suffix$1) {
  var k = $n(suffix$1).knownSize__I();
  if ((k === 0)) {
    return $thiz
  } else {
    $m_s_reflect_ManifestFactory$AnyManifest$();
    var capacity = 0;
    var jsElems = null;
    capacity = 0;
    jsElems = [];
    if ((k >= 0)) {
      var xs = $thiz.unsafeArray__O();
      $m_jl_reflect_Array$().getLength__O__I(xs)
    };
    var xs$1 = $thiz.unsafeArray__O();
    var length = $m_jl_reflect_Array$().getLength__O__I(xs$1);
    var i = 0;
    while ((i < length)) {
      var elem = $m_sr_ScalaRunTime$().array_apply__O__I__O(xs$1, i);
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
      i = ((1 + i) | 0)
    };
    var it = $n(suffix$1).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem$1 = $n(it).next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems.push(unboxedElem$1)
    };
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(new $ac_O(jsElems))
  }
}
/** @constructor */
function $c_sci_ArraySeq() {
  /*<skip>*/
}
$c_sci_ArraySeq.prototype = new $h_sci_AbstractSeq();
$c_sci_ArraySeq.prototype.constructor = $c_sci_ArraySeq;
/** @constructor */
function $h_sci_ArraySeq() {
  /*<skip>*/
}
$h_sci_ArraySeq.prototype = $c_sci_ArraySeq.prototype;
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5)
});
$c_sci_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$12 = this.elemTag__s_reflect_ClassTag();
  return this$1.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12)
});
$c_sci_ArraySeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sci_ArraySeq.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sci_ArraySeq.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that)
});
$c_sci_ArraySeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_ArraySeq.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_ArraySeq.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_ArraySeq.prototype.scanLeft__O__F2__O = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op)
});
$c_sci_ArraySeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_sci_ArraySeq.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sci_ArraySeq.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_sci_ArraySeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_ArraySeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sci_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sci_ArraySeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sci_ArraySeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sci_ArraySeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sci_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged
});
$c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  var dest = new $ac_O(this.length__I());
  $m_s_Array$().copy__O__I__O__I__I__V(this.unsafeArray__O(), 0, dest, 0, this.length__I());
  $n(dest).set(index, elem);
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(dest)
});
$c_sci_ArraySeq.prototype.map__F1__sci_ArraySeq = (function(f) {
  var a = new $ac_O(this.length__I());
  var i = 0;
  while ((i < $n(a).u.length)) {
    $n(a).set(i, $n(f).apply__O__O(this.apply__I__O(i)));
    i = ((1 + i) | 0)
  };
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a)
});
$c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  var $$x1 = $m_sci_ArraySeq$();
  $m_sc_ArrayOps$();
  var xs = this.unsafeArray__O();
  $m_s_reflect_ManifestFactory$AnyManifest$();
  var len = ((1 + $m_jl_reflect_Array$().getLength__O__I(xs)) | 0);
  var dest = new $ac_O(len);
  dest.set(0, elem);
  $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $m_jl_reflect_Array$().getLength__O__I(xs));
  return $n($$x1).unsafeWrapArray__O__sci_ArraySeq(dest)
});
$c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq = (function(elem) {
  var $$x1 = $m_sci_ArraySeq$();
  $m_sc_ArrayOps$();
  var xs = this.unsafeArray__O();
  $m_s_reflect_ManifestFactory$AnyManifest$();
  var this$6 = $m_s_Array$();
  var newLength = ((1 + $m_jl_reflect_Array$().getLength__O__I(xs)) | 0);
  var this$7 = $n(xs);
  if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($n($objectGetClass(this$7)).getComponentType__jl_Class())) {
    if ($d_O.getClassOf().isPrimitive__Z()) {
      var dest$1 = this$6.copyOf__O__I__O(xs, newLength)
    } else {
      var original = $asArrayOf_O(xs, 1);
      var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_O.getArrayOf().getClassOf())
    }
  } else {
    var dest = new $ac_O(newLength);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(xs));
    var dest$1 = dest
  };
  $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $m_jl_reflect_Array$().getLength__O__I(xs), elem);
  return $n($$x1).unsafeWrapArray__O__sci_ArraySeq(dest$1)
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__sci_ArraySeq = (function(suffix) {
  if ((suffix instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(suffix);
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq(this, x2);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix) : result)
  } else {
    return $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix)
  }
});
$c_sci_ArraySeq.prototype.zip__sc_IterableOnce__sci_ArraySeq = (function(that) {
  if ((that instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(that);
    $m_sci_ArraySeq$();
    var x = this.length__I();
    var that$1 = $n(x2).length__I();
    var n = ((x < that$1) ? x : that$1);
    var n1 = ((n > 0) ? n : 0);
    var elements = new ($d_T2.getArrayOf().constr)(n1);
    var i = 0;
    while ((i < n)) {
      var $$x1 = i;
      var arg1 = i;
      elements.set($$x1, $ct_T2__O__O__(new $c_T2(), this.apply__I__O(arg1), $n(x2).apply__I__O(arg1)));
      i = ((1 + i) | 0)
    };
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(elements)
  } else {
    var b = $n($m_sci_ArraySeq$().sci_ArraySeq$__f_untagged).newBuilder__scm_Builder();
    var it1 = this.iterator__sc_Iterator();
    var it2 = $n(that).iterator__sc_Iterator();
    while (($n(it1).hasNext__Z() && $n(it2).hasNext__Z())) {
      var this$10 = $n(b);
      var elem = $ct_T2__O__O__(new $c_T2(), $n(it1).next__O(), $n(it2).next__O());
      this$10.addOne__O__scm_Growable(elem)
    };
    return $as_sci_ArraySeq($n(b).result__O())
  }
});
$c_sci_ArraySeq.prototype.take__I__sci_ArraySeq = (function(n) {
  var xs = this.unsafeArray__O();
  if (($m_jl_reflect_Array$().getLength__O__I(xs) <= n)) {
    return this
  } else {
    var $$x1 = $m_sci_ArraySeq$();
    $m_sc_ArrayOps$();
    var this$ = this.unsafeArray__O();
    return $n($$x1).unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, n))
  }
});
$c_sci_ArraySeq.prototype.drop__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().drop$extension__O__I__O(this.unsafeArray__O(), n)))
});
$c_sci_ArraySeq.prototype.dropRight__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().dropRight$extension__O__I__O(this.unsafeArray__O(), n)))
});
$c_sci_ArraySeq.prototype.slice__I__I__sci_ArraySeq = (function(from, until) {
  if ((from <= 0)) {
    var xs = this.unsafeArray__O();
    var $$x1 = ($m_jl_reflect_Array$().getLength__O__I(xs) <= until)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return this
  } else {
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().slice$extension__O__I__I__O(this.unsafeArray__O(), from, until))
  }
});
$c_sci_ArraySeq.prototype.foldLeft__O__F2__O = (function(z, f) {
  var array = this.unsafeArray__O();
  var b = z;
  var i = 0;
  while ((i < $m_jl_reflect_Array$().getLength__O__I(array))) {
    var a = $m_sr_ScalaRunTime$().array_apply__O__I__O(array, i);
    b = $n(f).apply__O__O__O(b, a);
    i = ((1 + i) | 0)
  };
  return b
});
$c_sci_ArraySeq.prototype.tail__sci_ArraySeq = (function() {
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().tail$extension__O__O(this.unsafeArray__O()))
});
$c_sci_ArraySeq.prototype.reverse__sci_ArraySeq = (function() {
  var $$x2 = $m_sci_ArraySeq$();
  $m_sc_ArrayOps$();
  var this$ = this.unsafeArray__O();
  var len = $m_jl_reflect_Array$().getLength__O__I(this$);
  $m_sc_ArrayOps$();
  var $$x1 = $m_s_reflect_ClassTag$();
  var this$4 = $n(this$);
  var res = $n($n($$x1).apply__jl_Class__s_reflect_ClassTag($n($objectGetClass(this$4)).getComponentType__jl_Class())).newArray__I__O(len);
  var i = 0;
  while ((i < len)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(res, (((-1) + ((len - i) | 0)) | 0), $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, i));
    i = ((1 + i) | 0)
  };
  return $n($$x2).unsafeWrapArray__O__sci_ArraySeq(res)
});
$c_sci_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq"
});
$c_sci_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.unsafeArray__O(), 0, xs, start, copied)
  };
  return copied
});
$c_sci_ArraySeq.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  var xs = this.unsafeArray__O();
  if (($m_jl_reflect_Array$().getLength__O__I(xs) <= 1)) {
    return this
  } else {
    var this$4 = $m_s_Array$();
    var original = this.unsafeArray__O();
    var newLength = this.length__I();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    var this$5 = $n(original);
    if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($n($objectGetClass(this$5)).getComponentType__jl_Class())) {
      if ($d_O.getClassOf().isPrimitive__Z()) {
        var $$x1 = this$4.copyOf__O__I__O(original, newLength)
      } else {
        var original$1 = $asArrayOf_O(original, 1);
        var $$x1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, $d_O.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(original));
      var $$x1 = dest
    };
    var a = $asArrayOf_O($$x1, 1);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a)
  }
});
$c_sci_ArraySeq.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this)
});
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5)
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq.prototype.reverse__O = (function() {
  return this.reverse__sci_ArraySeq()
});
$c_sci_ArraySeq.prototype.tail__O = (function() {
  return this.tail__sci_ArraySeq()
});
$c_sci_ArraySeq.prototype.slice__I__I__O = (function(from, until) {
  return this.slice__I__I__sci_ArraySeq(from, until)
});
$c_sci_ArraySeq.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_ArraySeq(n)
});
$c_sci_ArraySeq.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_ArraySeq(n)
});
$c_sci_ArraySeq.prototype.take__I__O = (function(n) {
  return this.take__I__sci_ArraySeq(n)
});
$c_sci_ArraySeq.prototype.zip__sc_IterableOnce__O = (function(that) {
  return this.zip__sc_IterableOnce__sci_ArraySeq(that)
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_ArraySeq(suffix)
});
$c_sci_ArraySeq.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_ArraySeq(f)
});
$c_sci_ArraySeq.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem)
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged
});
function $as_sci_ArraySeq(obj) {
  return (((obj instanceof $c_sci_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq"))
}
function $isArrayOf_sci_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq)))
}
function $asArrayOf_sci_ArraySeq(obj, depth) {
  return (($isArrayOf_sci_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq;", depth))
}
/** @constructor */
function $c_sci_ListMap$EmptyListMap$() {
  /*<skip>*/
}
$c_sci_ListMap$EmptyListMap$.prototype = new $h_sci_ListMap();
$c_sci_ListMap$EmptyListMap$.prototype.constructor = $c_sci_ListMap$EmptyListMap$;
/** @constructor */
function $h_sci_ListMap$EmptyListMap$() {
  /*<skip>*/
}
$h_sci_ListMap$EmptyListMap$.prototype = $c_sci_ListMap$EmptyListMap$.prototype;
var $d_sci_ListMap$EmptyListMap$ = new $TypeData().initClass({
  sci_ListMap$EmptyListMap$: 0
}, false, "scala.collection.immutable.ListMap$EmptyListMap$", {
  sci_ListMap$EmptyListMap$: 1,
  sci_ListMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_SeqMap: 1,
  sc_SeqMap: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ListMap$EmptyListMap$.prototype.$classData = $d_sci_ListMap$EmptyListMap$;
var $n_sci_ListMap$EmptyListMap$;
function $m_sci_ListMap$EmptyListMap$() {
  if ((!$n_sci_ListMap$EmptyListMap$)) {
    $n_sci_ListMap$EmptyListMap$ = new $c_sci_ListMap$EmptyListMap$()
  };
  return $n_sci_ListMap$EmptyListMap$
}
function $p_sci_ListMap$Node__sizeInternal__sci_ListMap__I__I($thiz, cur, acc) {
  while (true) {
    if ($n(cur).isEmpty__Z()) {
      return acc
    } else {
      var temp$cur = $n(cur).next__sci_ListMap();
      var temp$acc = ((1 + acc) | 0);
      cur = temp$cur;
      acc = temp$acc
    }
  }
}
function $p_sci_ListMap$Node__applyInternal__sci_ListMap__O__O($thiz, cur, k) {
  while (true) {
    if ($n(cur).isEmpty__Z()) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + k))
    } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(cur).key__O())) {
      return $n(cur).value__O()
    } else {
      cur = $n(cur).next__sci_ListMap()
    }
  }
}
function $p_sci_ListMap$Node__getInternal__sci_ListMap__O__s_Option($thiz, cur, k) {
  while (true) {
    if ($n(cur).isEmpty__Z()) {
      return $m_s_None$()
    } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(cur).key__O())) {
      return new $c_s_Some($n(cur).value__O())
    } else {
      cur = $n(cur).next__sci_ListMap()
    }
  }
}
function $p_sci_ListMap$Node__containsInternal__sci_ListMap__O__Z($thiz, cur, k) {
  while (true) {
    if ((!$n(cur).isEmpty__Z())) {
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(cur).key__O())) {
        return true
      } else {
        cur = $n(cur).next__sci_ListMap()
      }
    } else {
      return false
    }
  }
}
function $p_sci_ListMap$Node__removeInternal__O__sci_ListMap__sci_List__sci_ListMap($thiz, k, cur, acc) {
  while (true) {
    if ($n(cur).isEmpty__Z()) {
      return $as_sci_ListMap($n(acc).last__O())
    } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(cur).key__O())) {
      var this$1 = $n(acc);
      var z = $n(cur).next__sci_ListMap();
      var acc$1 = z;
      var these = this$1;
      while ((!$n(these).isEmpty__Z())) {
        var arg1 = acc$1;
        var arg2 = $n(these).head__O();
        var t = $as_sci_ListMap(arg1);
        var h = $as_sci_ListMap(arg2);
        acc$1 = new $c_sci_ListMap$Node($n(h).key__O(), $n(h).value__O(), t);
        these = $as_sc_LinearSeq($n(these).tail__O())
      };
      return $as_sci_ListMap(acc$1)
    } else {
      var temp$cur = $n(cur).next__sci_ListMap();
      var rassoc$3 = cur;
      var this$2 = $n(acc);
      var temp$acc = new $c_sci_$colon$colon(rassoc$3, this$2);
      cur = temp$cur;
      acc = temp$acc
    }
  }
}
/** @constructor */
function $c_sci_ListMap$Node(key, _value, _init) {
  this.sci_ListMap$Node__f_key = null;
  this.sci_ListMap$Node__f__value = null;
  this.sci_ListMap$Node__f__init = null;
  this.sci_ListMap$Node__f_key = key;
  this.sci_ListMap$Node__f__value = _value;
  this.sci_ListMap$Node__f__init = _init
}
$c_sci_ListMap$Node.prototype = new $h_sci_ListMap();
$c_sci_ListMap$Node.prototype.constructor = $c_sci_ListMap$Node;
/** @constructor */
function $h_sci_ListMap$Node() {
  /*<skip>*/
}
$h_sci_ListMap$Node.prototype = $c_sci_ListMap$Node.prototype;
$c_sci_ListMap$Node.prototype.key__O = (function() {
  return this.sci_ListMap$Node__f_key
});
$c_sci_ListMap$Node.prototype.value__O = (function() {
  return this.sci_ListMap$Node__f__value
});
$c_sci_ListMap$Node.prototype.size__I = (function() {
  return $p_sci_ListMap$Node__sizeInternal__sci_ListMap__I__I(this, this, 0)
});
$c_sci_ListMap$Node.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_ListMap$Node.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_ListMap$Node.prototype.apply__O__O = (function(k) {
  return $p_sci_ListMap$Node__applyInternal__sci_ListMap__O__O(this, this, k)
});
$c_sci_ListMap$Node.prototype.get__O__s_Option = (function(k) {
  return $p_sci_ListMap$Node__getInternal__sci_ListMap__O__s_Option(this, this, k)
});
$c_sci_ListMap$Node.prototype.contains__O__Z = (function(k) {
  return $p_sci_ListMap$Node__containsInternal__sci_ListMap__O__Z(this, this, k)
});
$c_sci_ListMap$Node.prototype.updated__O__O__sci_ListMap = (function(k, v) {
  var index = (-1);
  var found = false;
  var isDifferent = false;
  var curr = this;
  while (true) {
    var this$1 = $n(curr);
    if (((!this$1.isEmpty__Z()) && (!found))) {
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(curr).key__O())) {
        found = true;
        isDifferent = (!Object.is(v, $n(curr).value__O()))
      };
      index = ((1 + index) | 0);
      curr = $as_sci_ListMap($n(curr).init__O())
    } else {
      break
    }
  };
  if (found) {
    if (isDifferent) {
      var newHead = null;
      var prev = null;
      var curr$2 = this;
      var i = 0;
      while ((i < index)) {
        var temp = new $c_sci_ListMap$Node($n(curr$2).key__O(), $n(curr$2).value__O(), null);
        if ((prev !== null)) {
          $n(prev).sci_ListMap$Node__f__init = temp
        };
        prev = temp;
        curr$2 = $as_sci_ListMap($n(curr$2).init__O());
        if ((newHead === null)) {
          newHead = prev
        };
        i = ((1 + i) | 0)
      };
      var newNode = new $c_sci_ListMap$Node($n(curr$2).key__O(), v, $as_sci_ListMap($n(curr$2).init__O()));
      if ((prev !== null)) {
        $n(prev).sci_ListMap$Node__f__init = newNode
      };
      return ((newHead === null) ? newNode : newHead)
    } else {
      return this
    }
  } else {
    return new $c_sci_ListMap$Node(k, v, this)
  }
});
$c_sci_ListMap$Node.prototype.removed__O__sci_ListMap = (function(k) {
  return $p_sci_ListMap$Node__removeInternal__O__sci_ListMap__sci_List__sci_ListMap(this, k, this, $m_sci_Nil$())
});
$c_sci_ListMap$Node.prototype.next__sci_ListMap = (function() {
  return this.sci_ListMap$Node__f__init
});
$c_sci_ListMap$Node.prototype.init__O = (function() {
  return this.sci_ListMap$Node__f__init
});
$c_sci_ListMap$Node.prototype.removed__O__sci_MapOps = (function(key) {
  return $p_sci_ListMap$Node__removeInternal__O__sci_ListMap__sci_List__sci_ListMap(this, key, this, $m_sci_Nil$())
});
$c_sci_ListMap$Node.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_ListMap(key, value)
});
function $as_sci_ListMap$Node(obj) {
  return (((obj instanceof $c_sci_ListMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ListMap$Node"))
}
function $isArrayOf_sci_ListMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListMap$Node)))
}
function $asArrayOf_sci_ListMap$Node(obj, depth) {
  return (($isArrayOf_sci_ListMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ListMap$Node;", depth))
}
var $d_sci_ListMap$Node = new $TypeData().initClass({
  sci_ListMap$Node: 0
}, false, "scala.collection.immutable.ListMap$Node", {
  sci_ListMap$Node: 1,
  sci_ListMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_SeqMap: 1,
  sc_SeqMap: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ListMap$Node.prototype.$classData = $d_sci_ListMap$Node;
/** @constructor */
function $c_sci_Range$Exclusive(start, end, step) {
  this.sci_Range__f_start = 0;
  this.sci_Range__f_end = 0;
  this.sci_Range__f_step = 0;
  this.sci_Range__f_isEmpty = false;
  this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements = 0;
  this.sci_Range__f_scala$collection$immutable$Range$$lastElement = 0;
  $ct_sci_Range__I__I__I__(this, start, end, step)
}
$c_sci_Range$Exclusive.prototype = new $h_sci_Range();
$c_sci_Range$Exclusive.prototype.constructor = $c_sci_Range$Exclusive;
/** @constructor */
function $h_sci_Range$Exclusive() {
  /*<skip>*/
}
$h_sci_Range$Exclusive.prototype = $c_sci_Range$Exclusive.prototype;
$c_sci_Range$Exclusive.prototype.isInclusive__Z = (function() {
  return false
});
var $d_sci_Range$Exclusive = new $TypeData().initClass({
  sci_Range$Exclusive: 0
}, false, "scala.collection.immutable.Range$Exclusive", {
  sci_Range$Exclusive: 1,
  sci_Range: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Range$Exclusive.prototype.$classData = $d_sci_Range$Exclusive;
/** @constructor */
function $c_sci_Range$Inclusive(start, end, step) {
  this.sci_Range__f_start = 0;
  this.sci_Range__f_end = 0;
  this.sci_Range__f_step = 0;
  this.sci_Range__f_isEmpty = false;
  this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements = 0;
  this.sci_Range__f_scala$collection$immutable$Range$$lastElement = 0;
  $ct_sci_Range__I__I__I__(this, start, end, step)
}
$c_sci_Range$Inclusive.prototype = new $h_sci_Range();
$c_sci_Range$Inclusive.prototype.constructor = $c_sci_Range$Inclusive;
/** @constructor */
function $h_sci_Range$Inclusive() {
  /*<skip>*/
}
$h_sci_Range$Inclusive.prototype = $c_sci_Range$Inclusive.prototype;
$c_sci_Range$Inclusive.prototype.isInclusive__Z = (function() {
  return true
});
var $d_sci_Range$Inclusive = new $TypeData().initClass({
  sci_Range$Inclusive: 0
}, false, "scala.collection.immutable.Range$Inclusive", {
  sci_Range$Inclusive: 1,
  sci_Range: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Range$Inclusive.prototype.$classData = $d_sci_Range$Inclusive;
/** @constructor */
function $c_sci_SortedMap$WithDefault(underlying, defaultValue) {
  this.sci_Map$WithDefault__f_underlying = null;
  this.sci_Map$WithDefault__f_defaultValue = null;
  $ct_sci_Map$WithDefault__sci_Map__F1__(this, underlying, defaultValue)
}
$c_sci_SortedMap$WithDefault.prototype = new $h_sci_Map$WithDefault();
$c_sci_SortedMap$WithDefault.prototype.constructor = $c_sci_SortedMap$WithDefault;
/** @constructor */
function $h_sci_SortedMap$WithDefault() {
  /*<skip>*/
}
$h_sci_SortedMap$WithDefault.prototype = $c_sci_SortedMap$WithDefault.prototype;
$c_sci_SortedMap$WithDefault.prototype.stringPrefix__T = (function() {
  return "SortedMap"
});
$c_sci_SortedMap$WithDefault.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedMap__equals__O__Z(this, that)
});
$c_sci_SortedMap$WithDefault.prototype.ordering__s_math_Ordering = (function() {
  return $n($as_sci_SortedMap(this.sci_Map$WithDefault__f_underlying)).ordering__s_math_Ordering()
});
$c_sci_SortedMap$WithDefault.prototype.sortedMapFactory__sc_SortedMapFactory = (function() {
  return $n($as_sci_SortedMap(this.sci_Map$WithDefault__f_underlying)).sortedMapFactory__sc_SortedMapFactory()
});
$c_sci_SortedMap$WithDefault.prototype.updated__O__O__sci_SortedMap$WithDefault = (function(key, value) {
  return new $c_sci_SortedMap$WithDefault($as_sci_SortedMap($n($as_sci_SortedMap(this.sci_Map$WithDefault__f_underlying)).updated__O__O__sci_Map(key, value)), this.sci_Map$WithDefault__f_defaultValue)
});
$c_sci_SortedMap$WithDefault.prototype.concat__sc_IterableOnce__sci_SortedMap$WithDefault = (function(xs) {
  return new $c_sci_SortedMap$WithDefault($as_sci_SortedMap($n($as_sci_SortedMap(this.sci_Map$WithDefault__f_underlying)).concat__sc_IterableOnce__sc_Map(xs)), this.sci_Map$WithDefault__f_defaultValue)
});
$c_sci_SortedMap$WithDefault.prototype.removed__O__sci_SortedMap$WithDefault = (function(key) {
  return new $c_sci_SortedMap$WithDefault($as_sci_SortedMap($n($as_sci_SortedMap(this.sci_Map$WithDefault__f_underlying)).removed__O__sci_MapOps(key)), this.sci_Map$WithDefault__f_defaultValue)
});
$c_sci_SortedMap$WithDefault.prototype.fromSpecific__sc_IterableOnce__sci_SortedMap$WithDefault = (function(coll) {
  return new $c_sci_SortedMap$WithDefault($as_sci_SortedMap($n($n($as_sci_SortedMap(this.sci_Map$WithDefault__f_underlying)).sortedMapFactory__sc_SortedMapFactory()).from__sc_IterableOnce__s_math_Ordering__O(coll, $n($as_sci_SortedMap(this.sci_Map$WithDefault__f_underlying)).ordering__s_math_Ordering())), this.sci_Map$WithDefault__f_defaultValue)
});
$c_sci_SortedMap$WithDefault.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$2 = $n($m_sci_SortedMap$().newBuilder__s_math_Ordering__scm_Builder($n($as_sci_SortedMap(this.sci_Map$WithDefault__f_underlying)).ordering__s_math_Ordering()));
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_sci_SortedMap(p$2);
    return new $c_sci_SortedMap$WithDefault(p, this.sci_Map$WithDefault__f_defaultValue)
  }));
  return new $c_scm_Builder$$anon$1(this$2, f)
});
$c_sci_SortedMap$WithDefault.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sc_SortedMapOps$WithFilter(this, p)
});
$c_sci_SortedMap$WithDefault.prototype.withFilter__F1__sc_MapOps$WithFilter = (function(p) {
  return new $c_sc_SortedMapOps$WithFilter(this, p)
});
$c_sci_SortedMap$WithDefault.prototype.$plus__T2__sc_IterableOps = (function(kv) {
  var key = $n(kv)._1__O();
  var value = $n(kv)._2__O();
  return this.updated__O__O__sci_SortedMap$WithDefault(key, value)
});
$c_sci_SortedMap$WithDefault.prototype.$plus__T2__sci_MapOps = (function(kv) {
  var key = $n(kv)._1__O();
  var value = $n(kv)._2__O();
  return this.updated__O__O__sci_SortedMap$WithDefault(key, value)
});
$c_sci_SortedMap$WithDefault.prototype.keySet__sc_Set = (function() {
  return new $c_sci_SortedMapOps$ImmutableKeySortedSet(this)
});
$c_sci_SortedMap$WithDefault.prototype.keySet__sci_Set = (function() {
  return new $c_sci_SortedMapOps$ImmutableKeySortedSet(this)
});
$c_sci_SortedMap$WithDefault.prototype.withDefaultValue__O__sci_Map = (function(d) {
  return $f_sci_SortedMap__withDefaultValue__O__sci_SortedMap(this, d)
});
$c_sci_SortedMap$WithDefault.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_SortedMap$WithDefault(coll)
});
$c_sci_SortedMap$WithDefault.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_SortedMap$WithDefault(coll)
});
$c_sci_SortedMap$WithDefault.prototype.fromSpecific__sc_IterableOnce__sci_Map$WithDefault = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_SortedMap$WithDefault(coll)
});
$c_sci_SortedMap$WithDefault.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_SortedMap$WithDefault(key)
});
$c_sci_SortedMap$WithDefault.prototype.removed__O__sci_Map$WithDefault = (function(key) {
  return this.removed__O__sci_SortedMap$WithDefault(key)
});
$c_sci_SortedMap$WithDefault.prototype.concat__sc_IterableOnce__sc_Map = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_SortedMap$WithDefault(suffix)
});
$c_sci_SortedMap$WithDefault.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_SortedMap$WithDefault(key, value)
});
$c_sci_SortedMap$WithDefault.prototype.updated__O__O__sci_Map = (function(key, value) {
  return this.updated__O__O__sci_SortedMap$WithDefault(key, value)
});
$c_sci_SortedMap$WithDefault.prototype.updated__O__O__sci_Map$WithDefault = (function(key, value) {
  return this.updated__O__O__sci_SortedMap$WithDefault(key, value)
});
var $d_sci_SortedMap$WithDefault = new $TypeData().initClass({
  sci_SortedMap$WithDefault: 0
}, false, "scala.collection.immutable.SortedMap$WithDefault", {
  sci_SortedMap$WithDefault: 1,
  sci_Map$WithDefault: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1,
  sci_SortedMap: 1,
  sc_SortedMap: 1,
  sc_SortedMapOps: 1,
  sc_SortedOps: 1,
  sc_SortedMapFactoryDefaults: 1,
  sci_SortedMapOps: 1
});
$c_sci_SortedMap$WithDefault.prototype.$classData = $d_sci_SortedMap$WithDefault;
function $ct_sci_Vector__AO__($thiz, prefix1) {
  $thiz.sci_Vector__f_prefix1 = prefix1;
  return $thiz
}
/** @constructor */
function $c_sci_Vector() {
  this.sci_Vector__f_prefix1 = null
}
$c_sci_Vector.prototype = new $h_sci_AbstractSeq();
$c_sci_Vector.prototype.constructor = $c_sci_Vector;
/** @constructor */
function $h_sci_Vector() {
  /*<skip>*/
}
$h_sci_Vector.prototype = $c_sci_Vector.prototype;
$c_sci_Vector.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sci_Vector.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sci_Vector.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sci_Vector.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that)
});
$c_sci_Vector.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Vector.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Vector.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Vector.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Vector.prototype.scanLeft__O__F2__O = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op)
});
$c_sci_Vector.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Vector(pred, false)
});
$c_sci_Vector.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Vector(pred, true)
});
$c_sci_Vector.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this
});
$c_sci_Vector.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_Vector.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sci_Vector.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_Vector.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_Vector.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sci_Vector.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this)
});
$c_sci_Vector.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sci_Vector.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_Vector.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sci_Vector.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Vector$()
});
$c_sci_Vector.prototype.length__I = (function() {
  return ((this instanceof $c_sci_BigVector) ? $n($as_sci_BigVector(this)).sci_BigVector__f_length0 : $n(this.sci_Vector__f_prefix1).u.length)
});
$c_sci_Vector.prototype.iterator__sc_Iterator = (function() {
  return (($m_sci_Vector0$() === this) ? $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator : new $c_sci_NewVectorIterator(this, this.length__I(), this.vectorSliceCount__I()))
});
$c_sci_Vector.prototype.filterImpl__F1__Z__sci_Vector = (function(pred, isFlipped) {
  var i = 0;
  var len = $n(this.sci_Vector__f_prefix1).u.length;
  while ((i !== len)) {
    if (($uZ($n(pred).apply__O__O($n(this.sci_Vector__f_prefix1).get(i))) === isFlipped)) {
      var bitmap = 0;
      var j = ((1 + i) | 0);
      while ((j < len)) {
        if (($uZ($n(pred).apply__O__O($n(this.sci_Vector__f_prefix1).get(j))) !== isFlipped)) {
          bitmap = (bitmap | (1 << j))
        };
        j = ((1 + j) | 0)
      };
      var $$x1 = i;
      var i$1 = bitmap;
      var newLen = (($$x1 + $m_jl_Integer$().bitCount__I__I(i$1)) | 0);
      if ((this instanceof $c_sci_BigVector)) {
        var b = new $c_sci_VectorBuilder();
        var k = 0;
        while ((k < i)) {
          b.addOne__O__sci_VectorBuilder($n(this.sci_Vector__f_prefix1).get(k));
          k = ((1 + k) | 0)
        };
        k = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k) & bitmap) !== 0)) {
            b.addOne__O__sci_VectorBuilder($n(this.sci_Vector__f_prefix1).get(k));
            i = ((1 + i) | 0)
          };
          k = ((1 + k) | 0)
        };
        $n($as_sci_BigVector(this)).foreachRest__F1__V(new $c_sjsr_AnonFunction1(((pred, isFlipped, b) => ((v$2) => (($uZ($n(pred).apply__O__O(v$2)) !== isFlipped) ? b.addOne__O__sci_VectorBuilder(v$2) : (void 0))))(pred, isFlipped, b)));
        return b.result__sci_Vector()
      } else {
        if ((newLen === 0)) {
          return $m_sci_Vector0$()
        };
        var newData = new $ac_O(newLen);
        var src = this.sci_Vector__f_prefix1;
        var length = i;
        $systemArraycopyRefs($n(src), 0, newData, 0, length);
        var k$2 = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k$2) & bitmap) !== 0)) {
            $n(newData).set(i, $n(this.sci_Vector__f_prefix1).get(k$2));
            i = ((1 + i) | 0)
          };
          k$2 = ((1 + k$2) | 0)
        };
        return new $c_sci_Vector1(newData)
      }
    };
    i = ((1 + i) | 0)
  };
  if ((this instanceof $c_sci_BigVector)) {
    var b$2 = new $c_sci_VectorBuilder();
    b$2.initFrom__AO__V(this.sci_Vector__f_prefix1);
    $n($as_sci_BigVector(this)).foreachRest__F1__V(new $c_sjsr_AnonFunction1(((v$3$2) => (($uZ($n(pred).apply__O__O(v$3$2)) !== isFlipped) ? b$2.addOne__O__sci_VectorBuilder(v$3$2) : (void 0)))));
    return b$2.result__sci_Vector()
  } else {
    return this
  }
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__sci_Vector = (function(suffix) {
  var k = $n(suffix).knownSize__I();
  return ((k === 0) ? this : ((k < 0) ? $as_sci_Vector($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)) : this.appendedAll0__sc_IterableOnce__I__sci_Vector(suffix, k)))
});
$c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var tinyAppendLimit = ((4 + this.vectorSliceCount__I()) | 0);
  if ((k < tinyAppendLimit)) {
    var v = new $c_sr_ObjectRef(this);
    if ($is_sci_Iterable(suffix)) {
      var x2 = $as_sci_Iterable(suffix);
      $n(x2).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$2) => {
        v.sr_ObjectRef__f_elem = $n($as_sci_Vector(v.sr_ObjectRef__f_elem)).appended__O__sci_Vector(x$2)
      })))
    } else {
      var this$3 = $n($n(suffix).iterator__sc_Iterator());
      while (this$3.hasNext__Z()) {
        var arg1 = this$3.next__O();
        v.sr_ObjectRef__f_elem = $n($as_sci_Vector(v.sr_ObjectRef__f_elem)).appended__O__sci_Vector(arg1)
      }
    };
    return $as_sci_Vector(v.sr_ObjectRef__f_elem)
  } else if (((this.length__I() < ((k >>> 5) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$2 = $as_sci_Vector(suffix);
    var this$4 = new $c_sc_IndexedSeqView$Id(this);
    var ri = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$4);
    while ((ri.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
      v$2 = $n(v$2).prepended__O__sci_Vector(ri.next__O())
    };
    return v$2
  } else if (((this.length__I() < (((-64) + k) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$3 = $as_sci_Vector(suffix);
    return $n($n($n(new $c_sci_VectorBuilder().alignTo__I__sci_Vector__sci_VectorBuilder(this.length__I(), v$3)).addAll__sc_IterableOnce__sci_VectorBuilder(this)).addAll__sc_IterableOnce__sci_VectorBuilder(v$3)).result__sci_Vector()
  } else {
    return $n($n(new $c_sci_VectorBuilder().initFrom__sci_Vector__sci_VectorBuilder(this)).addAll__sc_IterableOnce__sci_VectorBuilder(suffix)).result__sci_Vector()
  }
});
$c_sci_Vector.prototype.className__T = (function() {
  return "Vector"
});
$c_sci_Vector.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $n(this.iterator__sc_Iterator()).copyToArray__O__I__I__I(xs, start, len)
});
$c_sci_Vector.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength
});
$c_sci_Vector.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.length__I()) | 0)) + ")"))
});
$c_sci_Vector.prototype.head__O = (function() {
  if (($n(this.sci_Vector__f_prefix1).u.length === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.head")
  } else {
    return $n(this.sci_Vector__f_prefix1).get(0)
  }
});
$c_sci_Vector.prototype.last__O = (function() {
  if ((this instanceof $c_sci_BigVector)) {
    var suffix = $n($as_sci_BigVector(this)).sci_BigVector__f_suffix1;
    if (($n(suffix).u.length === 0)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.tail")
    } else {
      return $n(suffix).get((((-1) + $n(suffix).u.length) | 0))
    }
  } else {
    return $n(this.sci_Vector__f_prefix1).get((((-1) + $n(this.sci_Vector__f_prefix1).u.length) | 0))
  }
});
$c_sci_Vector.prototype.foreach__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 0;
  while ((i < c)) {
    var $$x1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $n($$x1).foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0)
  }
});
$c_sci_Vector.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this)
});
$c_sci_Vector.prototype.dropRight__I__O = (function(n) {
  return $as_sci_Vector(this.slice__I__I__O(0, ((this.length__I() - ((n > 0) ? n : 0)) | 0)))
});
$c_sci_Vector.prototype.drop__I__O = (function(n) {
  return $as_sci_Vector(this.slice__I__I__O(n, this.length__I()))
});
$c_sci_Vector.prototype.take__I__O = (function(n) {
  return $as_sci_Vector(this.slice__I__I__O(0, n))
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Vector(suffix)
});
$c_sci_Vector.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Vector$()
});
function $as_sci_Vector(obj) {
  return (((obj instanceof $c_sci_Vector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector"))
}
function $isArrayOf_sci_Vector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector)))
}
function $asArrayOf_sci_Vector(obj, depth) {
  return (($isArrayOf_sci_Vector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector;", depth))
}
/** @constructor */
function $c_scm_ArraySeq() {
  /*<skip>*/
}
$c_scm_ArraySeq.prototype = new $h_scm_AbstractSeq();
$c_scm_ArraySeq.prototype.constructor = $c_scm_ArraySeq;
/** @constructor */
function $h_scm_ArraySeq() {
  /*<skip>*/
}
$h_scm_ArraySeq.prototype = $c_scm_ArraySeq.prototype;
$c_scm_ArraySeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_scm_ArraySeq.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem)
});
$c_scm_ArraySeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem)
});
$c_scm_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArraySeq.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArraySeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_ArraySeq.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_scm_ArraySeq.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_scm_ArraySeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_scm_ArraySeq.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_scm_ArraySeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_scm_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_scm_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_scm_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_scm_ArraySeq.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_scm_ArraySeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArraySeq.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this)
});
$c_scm_ArraySeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_scm_ArraySeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_scm_ArraySeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_scm_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__scm_ArraySeq = (function(coll) {
  var evidence$1 = this.elemTag__s_reflect_ClassTag();
  var capacity = 0;
  var jsElems = null;
  var elementClass = $n(evidence$1).runtimeClass__jl_Class();
  capacity = 0;
  var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  jsElems = [];
  var s = $n(coll).knownSize__I();
  var it = $n(coll).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(elementClass).jl_Class__f_data.zero : elem));
    jsElems.push(unboxedElem)
  };
  var $$x1 = $m_scm_ArraySeq$();
  var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
  return $n($$x1).make__O__scm_ArraySeq($n(elemRuntimeClass).jl_Class__f_data.getArrayOf().wrapArray(jsElems))
});
$c_scm_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_scm_ArraySeq$().newBuilder__s_reflect_ClassTag__scm_Builder(this.elemTag__s_reflect_ClassTag())
});
$c_scm_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq"
});
$c_scm_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.array__O(), 0, xs, start, copied)
  };
  return copied
});
$c_scm_ArraySeq.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_scm_ArraySeq)) {
    var x2 = $as_scm_ArraySeq(other);
    var xs = this.array__O();
    var $$x1 = $m_jl_reflect_Array$().getLength__O__I(xs);
    var xs$1 = $n(x2).array__O();
    if (($$x1 !== $m_jl_reflect_Array$().getLength__O__I(xs$1))) {
      return false
    }
  };
  return $f_sc_Seq__equals__O__Z(this, other)
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__scm_ArraySeq = (function(ord) {
  var $$x2 = $m_scm_ArraySeq$();
  var $$x1 = $m_sc_ArrayOps$();
  var xs = this.array__O();
  return $n($$x2).make__O__scm_ArraySeq($n($$x1).sorted$extension__O__s_math_Ordering__O(xs, ord))
});
$c_scm_ArraySeq.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this)
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__scm_ArraySeq(ord)
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll)
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll)
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged
});
function $as_scm_ArraySeq(obj) {
  return (((obj instanceof $c_scm_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq"))
}
function $isArrayOf_scm_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq)))
}
function $asArrayOf_scm_ArraySeq(obj, depth) {
  return (($isArrayOf_scm_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq;", depth))
}
/** @constructor */
function $c_Lcats_instances_OptionInstances$$anon$1(outer) {
  /*<skip>*/
}
$c_Lcats_instances_OptionInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OptionInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OptionInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OptionInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OptionInstances$$anon$1.prototype = $c_Lcats_instances_OptionInstances$$anon$1.prototype;
$c_Lcats_instances_OptionInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__s_Option__s_Option__s_Option = (function(x, y) {
  var this$1 = $n(x);
  return (this$1.isEmpty__Z() ? y : this$1)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__s_Option__s_Option__F2__s_Option = (function(fa, fb, f) {
  var this$1 = $n(fa);
  if ((!this$1.isEmpty__Z())) {
    var this$2 = $n(fb);
    var $$x1 = (!this$2.isEmpty__Z())
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return new $c_s_Some($n(f).apply__O__O__O($n(fa).get__O(), $n(fb).get__O()))
  } else {
    return $m_s_None$()
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__s_Option__s_Option__s_Option = (function(fa, fb) {
  var this$1 = $n(fa);
  if ((!this$1.isEmpty__Z())) {
    var this$2 = $n(fb);
    var $$x1 = (!this$2.isEmpty__Z())
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return new $c_s_Some($ct_T2__O__O__(new $c_T2(), $n(fa).get__O(), $n(fb).get__O()))
  } else {
    return $m_s_None$()
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__s_Option__s_Option__F2__s_Option($as_s_Option(fa), $as_s_Option(fb), f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(f).apply__O__O(this$1.get__O())))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__s_Option__s_Option__s_Option($as_s_Option(x), $as_s_Option(y))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.empty__O = (function() {
  return $m_s_None$()
});
var $d_Lcats_instances_OptionInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OptionInstances$$anon$1: 0
}, false, "cats.instances.OptionInstances$$anon$1", {
  Lcats_instances_OptionInstances$$anon$1: 1,
  O: 1,
  Lcats_Traverse: 1,
  Lcats_Functor: 1,
  Lcats_Invariant: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_MonadError: 1,
  Lcats_ApplicativeError: 1,
  Lcats_Applicative: 1,
  Lcats_Apply: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Semigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Monad: 1,
  Lcats_FlatMap: 1,
  Lcats_Alternative: 1,
  Lcats_MonoidK: 1,
  Lcats_SemigroupK: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.$classData = $d_Lcats_instances_OptionInstances$$anon$1;
/** @constructor */
function $c_sci_ArraySeq$ofBoolean(unsafeArray) {
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = null;
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofBoolean.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofBoolean.prototype.constructor = $c_sci_ArraySeq$ofBoolean;
/** @constructor */
function $h_sci_ArraySeq$ofBoolean() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofBoolean.prototype = $c_sci_ArraySeq$ofBoolean.prototype;
$c_sci_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofBoolean__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofBoolean)) {
    var x2 = $as_sci_ArraySeq$ofBoolean(that);
    var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofBoolean__f_unsafeArray;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Boolean$())) {
    var this$1 = $n(this.sci_ArraySeq$ofBoolean__f_unsafeArray);
    var a = $n(this$1).clone__O();
    var this$2 = $m_s_util_Sorting$();
    var evidence$3 = $m_s_math_Ordering$Boolean$();
    this$2.stableSort__O__I__I__s_math_Ordering__V(a, 0, $n(a).u.length, evidence$3);
    return new $c_sci_ArraySeq$ofBoolean(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.sci_ArraySeq$ofBoolean__f_unsafeArray)
});
$c_sci_ArraySeq$ofBoolean.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = $uZ(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    $m_s_reflect_ManifestFactory$BooleanManifest$();
    if (((index < 0) || (index >= $n(xs).u.length))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + $n(xs).u.length) | 0)) + ")"))
    };
    $m_sc_ArrayOps$();
    var len = $n(xs).u.length;
    var destination = new $ac_Z(len);
    $m_sc_ArrayOps$();
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.set(index, x2);
    return new $c_sci_ArraySeq$ofBoolean(destination)
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem)
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = $uZ(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    $m_s_reflect_ManifestFactory$BooleanManifest$();
    var this$5 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$6 = $n(xs);
    if ($d_Z.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$6).getComponentType__jl_Class())) {
      if ($d_Z.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$5.copyOf__O__I__O(xs, newLength)
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_Z.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_Z(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest
    };
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofBoolean($asArrayOf_Z(dest$1, 1))
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = $uZ(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    $m_s_reflect_ManifestFactory$BooleanManifest$();
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_Z(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofBoolean(dest)
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(i) {
  return $n(this.sci_ArraySeq$ofBoolean__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofBoolean.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofBoolean.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofBoolean.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem)
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcZI$sp__I__Z(i)
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i)
});
$c_sci_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$()
});
$c_sci_ArraySeq$ofBoolean.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray
});
function $as_sci_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofBoolean"))
}
function $isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofBoolean)))
}
function $asArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofBoolean;", depth))
}
var $d_sci_ArraySeq$ofBoolean = new $TypeData().initClass({
  sci_ArraySeq$ofBoolean: 0
}, false, "scala.collection.immutable.ArraySeq$ofBoolean", {
  sci_ArraySeq$ofBoolean: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofBoolean.prototype.$classData = $d_sci_ArraySeq$ofBoolean;
/** @constructor */
function $c_sci_ArraySeq$ofByte(unsafeArray) {
  this.sci_ArraySeq$ofByte__f_unsafeArray = null;
  this.sci_ArraySeq$ofByte__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofByte.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofByte.prototype.constructor = $c_sci_ArraySeq$ofByte;
/** @constructor */
function $h_sci_ArraySeq$ofByte() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofByte.prototype = $c_sci_ArraySeq$ofByte.prototype;
$c_sci_ArraySeq$ofByte.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofByte__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__B = (function(i) {
  return $n(this.sci_ArraySeq$ofByte__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofByte)) {
    var x2 = $as_sci_ArraySeq$ofByte(that);
    var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofByte__f_unsafeArray;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Byte$())) {
    var this$1 = $n(this.sci_ArraySeq$ofByte__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AB__V(a);
    return new $c_sci_ArraySeq$ofByte(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.sci_ArraySeq$ofByte__f_unsafeArray)
});
$c_sci_ArraySeq$ofByte.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ($isByte(elem)) {
    var x2 = $uB(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofByte__f_unsafeArray;
    $m_s_reflect_ManifestFactory$ByteManifest$();
    if (((index < 0) || (index >= $n(xs).u.length))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + $n(xs).u.length) | 0)) + ")"))
    };
    $m_sc_ArrayOps$();
    var len = $n(xs).u.length;
    var destination = new $ac_B(len);
    $m_sc_ArrayOps$();
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.set(index, x2);
    return new $c_sci_ArraySeq$ofByte(destination)
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem)
  }
});
$c_sci_ArraySeq$ofByte.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isByte(elem)) {
    var x2 = $uB(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofByte__f_unsafeArray;
    $m_s_reflect_ManifestFactory$ByteManifest$();
    var this$5 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$6 = $n(xs);
    if ($d_B.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$6).getComponentType__jl_Class())) {
      if ($d_B.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$5.copyOf__O__I__O(xs, newLength)
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_B.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_B(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest
    };
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofByte($asArrayOf_B(dest$1, 1))
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofByte.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isByte(elem)) {
    var x2 = $uB(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofByte__f_unsafeArray;
    $m_s_reflect_ManifestFactory$ByteManifest$();
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_B(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofByte(dest)
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofByte.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofByte.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofByte.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem)
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1))
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i)
});
$c_sci_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$()
});
$c_sci_ArraySeq$ofByte.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofByte__f_unsafeArray
});
function $as_sci_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofByte"))
}
function $isArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofByte)))
}
function $asArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofByte;", depth))
}
var $d_sci_ArraySeq$ofByte = new $TypeData().initClass({
  sci_ArraySeq$ofByte: 0
}, false, "scala.collection.immutable.ArraySeq$ofByte", {
  sci_ArraySeq$ofByte: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofByte.prototype.$classData = $d_sci_ArraySeq$ofByte;
/** @constructor */
function $c_sci_ArraySeq$ofChar(unsafeArray) {
  this.sci_ArraySeq$ofChar__f_unsafeArray = null;
  this.sci_ArraySeq$ofChar__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofChar.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofChar.prototype.constructor = $c_sci_ArraySeq$ofChar;
/** @constructor */
function $h_sci_ArraySeq$ofChar() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofChar.prototype = $c_sci_ArraySeq$ofChar.prototype;
$c_sci_ArraySeq$ofChar.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofChar__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__C = (function(i) {
  return $n(this.sci_ArraySeq$ofChar__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofChar)) {
    var x2 = $as_sci_ArraySeq$ofChar(that);
    var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofChar__f_unsafeArray;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Char$())) {
    var this$1 = $n(this.sci_ArraySeq$ofChar__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AC__V(a);
    return new $c_sci_ArraySeq$ofChar(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.sci_ArraySeq$ofChar__f_unsafeArray)
});
$c_sci_ArraySeq$ofChar.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofChar__f_unsafeArray;
    $m_s_reflect_ManifestFactory$CharManifest$();
    if (((index < 0) || (index >= $n(xs).u.length))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + $n(xs).u.length) | 0)) + ")"))
    };
    $m_sc_ArrayOps$();
    var len = $n(xs).u.length;
    var destination = new $ac_C(len);
    $m_sc_ArrayOps$();
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.set(index, x2);
    return new $c_sci_ArraySeq$ofChar(destination)
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem)
  }
});
$c_sci_ArraySeq$ofChar.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofChar__f_unsafeArray;
    $m_s_reflect_ManifestFactory$CharManifest$();
    var this$5 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$6 = $n(xs);
    if ($d_C.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$6).getComponentType__jl_Class())) {
      if ($d_C.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$5.copyOf__O__I__O(xs, newLength)
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_C.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_C(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest
    };
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, $bC(x2));
    return new $c_sci_ArraySeq$ofChar($asArrayOf_C(dest$1, 1))
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofChar.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofChar__f_unsafeArray;
    $m_s_reflect_ManifestFactory$CharManifest$();
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_C(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofChar(dest)
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return new $c_scm_ArraySeq$ofChar(this.sci_ArraySeq$ofChar__f_unsafeArray).addString__scm_StringBuilder__T__T__T__scm_StringBuilder(sb, start, sep, end)
});
$c_sci_ArraySeq$ofChar.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofChar.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofChar.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem)
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)))
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i))
});
$c_sci_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$()
});
$c_sci_ArraySeq$ofChar.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofChar__f_unsafeArray
});
function $as_sci_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofChar"))
}
function $isArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofChar)))
}
function $asArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofChar;", depth))
}
var $d_sci_ArraySeq$ofChar = new $TypeData().initClass({
  sci_ArraySeq$ofChar: 0
}, false, "scala.collection.immutable.ArraySeq$ofChar", {
  sci_ArraySeq$ofChar: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofChar.prototype.$classData = $d_sci_ArraySeq$ofChar;
/** @constructor */
function $c_sci_ArraySeq$ofDouble(unsafeArray) {
  this.sci_ArraySeq$ofDouble__f_unsafeArray = null;
  this.sci_ArraySeq$ofDouble__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofDouble.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofDouble.prototype.constructor = $c_sci_ArraySeq$ofDouble;
/** @constructor */
function $h_sci_ArraySeq$ofDouble() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofDouble.prototype = $c_sci_ArraySeq$ofDouble.prototype;
$c_sci_ArraySeq$ofDouble.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofDouble__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofDouble)) {
    var x2 = $as_sci_ArraySeq$ofDouble(that);
    var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofDouble__f_unsafeArray;
    return $m_ju_Arrays$().equals__AD__AD__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.sci_ArraySeq$ofDouble__f_unsafeArray)
});
$c_sci_ArraySeq$ofDouble.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if (((typeof elem) === "number")) {
    var x2 = $uD(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    $m_s_reflect_ManifestFactory$DoubleManifest$();
    if (((index < 0) || (index >= $n(xs).u.length))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + $n(xs).u.length) | 0)) + ")"))
    };
    $m_sc_ArrayOps$();
    var len = $n(xs).u.length;
    var destination = new $ac_D(len);
    $m_sc_ArrayOps$();
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.set(index, x2);
    return new $c_sci_ArraySeq$ofDouble(destination)
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem)
  }
});
$c_sci_ArraySeq$ofDouble.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "number")) {
    var x2 = $uD(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    $m_s_reflect_ManifestFactory$DoubleManifest$();
    var this$5 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$6 = $n(xs);
    if ($d_D.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$6).getComponentType__jl_Class())) {
      if ($d_D.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$5.copyOf__O__I__O(xs, newLength)
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_D.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_D(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest
    };
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofDouble($asArrayOf_D(dest$1, 1))
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofDouble.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "number")) {
    var x2 = $uD(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    $m_s_reflect_ManifestFactory$DoubleManifest$();
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_D(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofDouble(dest)
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(i) {
  return $n(this.sci_ArraySeq$ofDouble__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofDouble.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofDouble.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofDouble.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem)
});
$c_sci_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcDI$sp__I__D(i)
});
$c_sci_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i)
});
$c_sci_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$()
});
$c_sci_ArraySeq$ofDouble.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray
});
function $as_sci_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofDouble"))
}
function $isArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofDouble)))
}
function $asArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofDouble;", depth))
}
var $d_sci_ArraySeq$ofDouble = new $TypeData().initClass({
  sci_ArraySeq$ofDouble: 0
}, false, "scala.collection.immutable.ArraySeq$ofDouble", {
  sci_ArraySeq$ofDouble: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofDouble.prototype.$classData = $d_sci_ArraySeq$ofDouble;
/** @constructor */
function $c_sci_ArraySeq$ofFloat(unsafeArray) {
  this.sci_ArraySeq$ofFloat__f_unsafeArray = null;
  this.sci_ArraySeq$ofFloat__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofFloat.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofFloat.prototype.constructor = $c_sci_ArraySeq$ofFloat;
/** @constructor */
function $h_sci_ArraySeq$ofFloat() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofFloat.prototype = $c_sci_ArraySeq$ofFloat.prototype;
$c_sci_ArraySeq$ofFloat.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofFloat__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofFloat)) {
    var x2 = $as_sci_ArraySeq$ofFloat(that);
    var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofFloat__f_unsafeArray;
    return $m_ju_Arrays$().equals__AF__AF__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.sci_ArraySeq$ofFloat__f_unsafeArray)
});
$c_sci_ArraySeq$ofFloat.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ($isFloat(elem)) {
    var x2 = $uF(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    $m_s_reflect_ManifestFactory$FloatManifest$();
    if (((index < 0) || (index >= $n(xs).u.length))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + $n(xs).u.length) | 0)) + ")"))
    };
    $m_sc_ArrayOps$();
    var len = $n(xs).u.length;
    var destination = new $ac_F(len);
    $m_sc_ArrayOps$();
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.set(index, x2);
    return new $c_sci_ArraySeq$ofFloat(destination)
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem)
  }
});
$c_sci_ArraySeq$ofFloat.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isFloat(elem)) {
    var x2 = $uF(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    $m_s_reflect_ManifestFactory$FloatManifest$();
    var this$5 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$6 = $n(xs);
    if ($d_F.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$6).getComponentType__jl_Class())) {
      if ($d_F.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$5.copyOf__O__I__O(xs, newLength)
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_F.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_F(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest
    };
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofFloat($asArrayOf_F(dest$1, 1))
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofFloat.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isFloat(elem)) {
    var x2 = $uF(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    $m_s_reflect_ManifestFactory$FloatManifest$();
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_F(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofFloat(dest)
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(i) {
  return $n(this.sci_ArraySeq$ofFloat__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofFloat.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofFloat.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofFloat.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem)
});
$c_sci_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcFI$sp__I__F(i)
});
$c_sci_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i)
});
$c_sci_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$()
});
$c_sci_ArraySeq$ofFloat.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray
});
function $as_sci_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofFloat"))
}
function $isArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofFloat)))
}
function $asArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofFloat;", depth))
}
var $d_sci_ArraySeq$ofFloat = new $TypeData().initClass({
  sci_ArraySeq$ofFloat: 0
}, false, "scala.collection.immutable.ArraySeq$ofFloat", {
  sci_ArraySeq$ofFloat: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofFloat.prototype.$classData = $d_sci_ArraySeq$ofFloat;
/** @constructor */
function $c_sci_ArraySeq$ofInt(unsafeArray) {
  this.sci_ArraySeq$ofInt__f_unsafeArray = null;
  this.sci_ArraySeq$ofInt__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofInt.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofInt.prototype.constructor = $c_sci_ArraySeq$ofInt;
/** @constructor */
function $h_sci_ArraySeq$ofInt() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofInt.prototype = $c_sci_ArraySeq$ofInt.prototype;
$c_sci_ArraySeq$ofInt.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofInt__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofInt)) {
    var x2 = $as_sci_ArraySeq$ofInt(that);
    var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofInt__f_unsafeArray;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Int$())) {
    var this$1 = $n(this.sci_ArraySeq$ofInt__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AI__V(a);
    return new $c_sci_ArraySeq$ofInt(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.sci_ArraySeq$ofInt__f_unsafeArray)
});
$c_sci_ArraySeq$ofInt.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ($isInt(elem)) {
    var x2 = $uI(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofInt__f_unsafeArray;
    $m_s_reflect_ManifestFactory$IntManifest$();
    if (((index < 0) || (index >= $n(xs).u.length))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + $n(xs).u.length) | 0)) + ")"))
    };
    $m_sc_ArrayOps$();
    var len = $n(xs).u.length;
    var destination = new $ac_I(len);
    $m_sc_ArrayOps$();
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.set(index, x2);
    return new $c_sci_ArraySeq$ofInt(destination)
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem)
  }
});
$c_sci_ArraySeq$ofInt.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isInt(elem)) {
    var x2 = $uI(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofInt__f_unsafeArray;
    $m_s_reflect_ManifestFactory$IntManifest$();
    var this$5 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$6 = $n(xs);
    if ($d_I.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$6).getComponentType__jl_Class())) {
      if ($d_I.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$5.copyOf__O__I__O(xs, newLength)
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_I.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_I(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest
    };
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofInt($asArrayOf_I(dest$1, 1))
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofInt.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isInt(elem)) {
    var x2 = $uI(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofInt__f_unsafeArray;
    $m_s_reflect_ManifestFactory$IntManifest$();
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_I(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofInt(dest)
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(i) {
  return $n(this.sci_ArraySeq$ofInt__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofInt.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofInt.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofInt.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem)
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcII$sp__I__I(i)
});
$c_sci_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i)
});
$c_sci_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$()
});
$c_sci_ArraySeq$ofInt.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofInt__f_unsafeArray
});
function $as_sci_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofInt"))
}
function $isArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofInt)))
}
function $asArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofInt;", depth))
}
var $d_sci_ArraySeq$ofInt = new $TypeData().initClass({
  sci_ArraySeq$ofInt: 0
}, false, "scala.collection.immutable.ArraySeq$ofInt", {
  sci_ArraySeq$ofInt: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofInt.prototype.$classData = $d_sci_ArraySeq$ofInt;
/** @constructor */
function $c_sci_ArraySeq$ofLong(unsafeArray) {
  this.sci_ArraySeq$ofLong__f_unsafeArray = null;
  this.sci_ArraySeq$ofLong__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofLong.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofLong.prototype.constructor = $c_sci_ArraySeq$ofLong;
/** @constructor */
function $h_sci_ArraySeq$ofLong() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofLong.prototype = $c_sci_ArraySeq$ofLong.prototype;
$c_sci_ArraySeq$ofLong.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofLong__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofLong)) {
    var x2 = $as_sci_ArraySeq$ofLong(that);
    var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofLong__f_unsafeArray;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Long$())) {
    var this$1 = $n(this.sci_ArraySeq$ofLong__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AJ__V(a);
    return new $c_sci_ArraySeq$ofLong(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.sci_ArraySeq$ofLong__f_unsafeArray)
});
$c_sci_ArraySeq$ofLong.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ((elem instanceof $c_RTLong)) {
    var t = $uJ(elem);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofLong__f_unsafeArray;
    $m_s_reflect_ManifestFactory$LongManifest$();
    if (((index < 0) || (index >= $n(xs).u.length))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + $n(xs).u.length) | 0)) + ")"))
    };
    $m_sc_ArrayOps$();
    var len = $n(xs).u.length;
    var destination = new $ac_J(len);
    $m_sc_ArrayOps$();
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.set(index, $uJ(new $c_RTLong(lo, hi)));
    return new $c_sci_ArraySeq$ofLong(destination)
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem)
  }
});
$c_sci_ArraySeq$ofLong.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $c_RTLong)) {
    var t = $uJ(elem);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofLong__f_unsafeArray;
    $m_s_reflect_ManifestFactory$LongManifest$();
    var this$5 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$6 = $n(xs);
    if ($d_J.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$6).getComponentType__jl_Class())) {
      if ($d_J.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$5.copyOf__O__I__O(xs, newLength)
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_J.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_J(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest
    };
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, new $c_RTLong(lo, hi));
    return new $c_sci_ArraySeq$ofLong($asArrayOf_J(dest$1, 1))
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofLong.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $c_RTLong)) {
    var t = $uJ(elem);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofLong__f_unsafeArray;
    $m_s_reflect_ManifestFactory$LongManifest$();
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_J(len);
    dest.set(0, $uJ(new $c_RTLong(lo, hi)));
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofLong(dest)
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(i) {
  return $n(this.sci_ArraySeq$ofLong__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofLong.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofLong.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofLong.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem)
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcJI$sp__I__J(i)
});
$c_sci_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i)
});
$c_sci_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$()
});
$c_sci_ArraySeq$ofLong.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofLong__f_unsafeArray
});
function $as_sci_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofLong"))
}
function $isArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofLong)))
}
function $asArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofLong;", depth))
}
var $d_sci_ArraySeq$ofLong = new $TypeData().initClass({
  sci_ArraySeq$ofLong: 0
}, false, "scala.collection.immutable.ArraySeq$ofLong", {
  sci_ArraySeq$ofLong: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofLong.prototype.$classData = $d_sci_ArraySeq$ofLong;
/** @constructor */
function $c_sci_ArraySeq$ofRef(unsafeArray) {
  this.sci_ArraySeq$ofRef__f_unsafeArray = null;
  this.sci_ArraySeq$ofRef__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofRef.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofRef.prototype.constructor = $c_sci_ArraySeq$ofRef;
/** @constructor */
function $h_sci_ArraySeq$ofRef() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofRef.prototype = $c_sci_ArraySeq$ofRef.prototype;
$c_sci_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $$x1 = $m_s_reflect_ClassTag$();
  var this$1 = $n(this.sci_ArraySeq$ofRef__f_unsafeArray);
  return $n($$x1).apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$1).getComponentType__jl_Class())
});
$c_sci_ArraySeq$ofRef.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofRef__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofRef.prototype.apply__I__O = (function(i) {
  return $n(this.sci_ArraySeq$ofRef__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofRef__f_unsafeArray;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofRef)) {
    var x2 = $as_sci_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.sci_ArraySeq$ofRef__f_unsafeArray, $n(x2).sci_ArraySeq$ofRef__f_unsafeArray)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq$ofRef = (function(ord) {
  if (($n(this.sci_ArraySeq$ofRef__f_unsafeArray).u.length <= 1)) {
    return this
  } else {
    var this$1 = $n(this.sci_ArraySeq$ofRef__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a)
  }
});
$c_sci_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.sci_ArraySeq$ofRef__f_unsafeArray)
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord)
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord)
});
$c_sci_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sci_ArraySeq$ofRef.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofRef__f_unsafeArray
});
function $as_sci_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofRef"))
}
function $isArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofRef)))
}
function $asArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofRef;", depth))
}
var $d_sci_ArraySeq$ofRef = new $TypeData().initClass({
  sci_ArraySeq$ofRef: 0
}, false, "scala.collection.immutable.ArraySeq$ofRef", {
  sci_ArraySeq$ofRef: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofRef.prototype.$classData = $d_sci_ArraySeq$ofRef;
/** @constructor */
function $c_sci_ArraySeq$ofShort(unsafeArray) {
  this.sci_ArraySeq$ofShort__f_unsafeArray = null;
  this.sci_ArraySeq$ofShort__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofShort.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofShort.prototype.constructor = $c_sci_ArraySeq$ofShort;
/** @constructor */
function $h_sci_ArraySeq$ofShort() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofShort.prototype = $c_sci_ArraySeq$ofShort.prototype;
$c_sci_ArraySeq$ofShort.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofShort__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__S = (function(i) {
  return $n(this.sci_ArraySeq$ofShort__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofShort)) {
    var x2 = $as_sci_ArraySeq$ofShort(that);
    var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofShort__f_unsafeArray;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Short$())) {
    var this$1 = $n(this.sci_ArraySeq$ofShort__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AS__V(a);
    return new $c_sci_ArraySeq$ofShort(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.sci_ArraySeq$ofShort__f_unsafeArray)
});
$c_sci_ArraySeq$ofShort.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ($isShort(elem)) {
    var x2 = $uS(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofShort__f_unsafeArray;
    $m_s_reflect_ManifestFactory$ShortManifest$();
    if (((index < 0) || (index >= $n(xs).u.length))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + $n(xs).u.length) | 0)) + ")"))
    };
    $m_sc_ArrayOps$();
    var len = $n(xs).u.length;
    var destination = new $ac_S(len);
    $m_sc_ArrayOps$();
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.set(index, x2);
    return new $c_sci_ArraySeq$ofShort(destination)
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem)
  }
});
$c_sci_ArraySeq$ofShort.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isShort(elem)) {
    var x2 = $uS(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofShort__f_unsafeArray;
    $m_s_reflect_ManifestFactory$ShortManifest$();
    var this$5 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$6 = $n(xs);
    if ($d_S.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$6).getComponentType__jl_Class())) {
      if ($d_S.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$5.copyOf__O__I__O(xs, newLength)
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_S.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_S(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest
    };
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofShort($asArrayOf_S(dest$1, 1))
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofShort.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isShort(elem)) {
    var x2 = $uS(elem);
    $m_sc_ArrayOps$();
    var xs = this.sci_ArraySeq$ofShort__f_unsafeArray;
    $m_s_reflect_ManifestFactory$ShortManifest$();
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_S(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofShort(dest)
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem)
  }
});
$c_sci_ArraySeq$ofShort.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofShort.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem)
});
$c_sci_ArraySeq$ofShort.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem)
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1))
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i)
});
$c_sci_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$()
});
$c_sci_ArraySeq$ofShort.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofShort__f_unsafeArray
});
function $as_sci_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofShort"))
}
function $isArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofShort)))
}
function $asArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofShort;", depth))
}
var $d_sci_ArraySeq$ofShort = new $TypeData().initClass({
  sci_ArraySeq$ofShort: 0
}, false, "scala.collection.immutable.ArraySeq$ofShort", {
  sci_ArraySeq$ofShort: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofShort.prototype.$classData = $d_sci_ArraySeq$ofShort;
/** @constructor */
function $c_sci_ArraySeq$ofUnit(unsafeArray) {
  this.sci_ArraySeq$ofUnit__f_unsafeArray = null;
  this.sci_ArraySeq$ofUnit__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofUnit.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofUnit.prototype.constructor = $c_sci_ArraySeq$ofUnit;
/** @constructor */
function $h_sci_ArraySeq$ofUnit() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofUnit.prototype = $c_sci_ArraySeq$ofUnit.prototype;
$c_sci_ArraySeq$ofUnit.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofUnit__f_unsafeArray).u.length
});
$c_sci_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofUnit__f_unsafeArray;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofUnit)) {
    var x2 = $as_sci_ArraySeq$ofUnit(that);
    return ($n(this.sci_ArraySeq$ofUnit__f_unsafeArray).u.length === $n($n(x2).sci_ArraySeq$ofUnit__f_unsafeArray).u.length)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.sci_ArraySeq$ofUnit__f_unsafeArray)
});
$c_sci_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(i) {
  $n(this.sci_ArraySeq$ofUnit__f_unsafeArray).get(i)
});
$c_sci_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  this.apply$mcVI$sp__I__V(i)
});
$c_sci_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i)
});
$c_sci_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$()
});
$c_sci_ArraySeq$ofUnit.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofUnit__f_unsafeArray
});
function $as_sci_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofUnit"))
}
function $isArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofUnit)))
}
function $asArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofUnit;", depth))
}
var $d_sci_ArraySeq$ofUnit = new $TypeData().initClass({
  sci_ArraySeq$ofUnit: 0
}, false, "scala.collection.immutable.ArraySeq$ofUnit", {
  sci_ArraySeq$ofUnit: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofUnit.prototype.$classData = $d_sci_ArraySeq$ofUnit;
function $p_sci_List__filterCommon__F1__Z__sci_List($thiz, p, isFlipped) {
  var result = $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, $thiz, p, isFlipped);
  return result
}
function $p_sci_List__loop$2__I__sci_List__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return ($n(xs).isEmpty__Z() ? 0 : 1)
    } else if ($n(xs).isEmpty__Z()) {
      return (-1)
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sci_List($n(xs).tail__O());
      i = temp$i;
      xs = temp$xs
    }
  }
}
function $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, l, p$1, isFlipped$1) {
  while (true) {
    if ($n(l).isEmpty__Z()) {
      return $m_sci_Nil$()
    } else {
      var h = $n(l).head__O();
      var t = $as_sci_List($n(l).tail__O());
      if (($uZ($n(p$1).apply__O__O(h)) !== isFlipped$1)) {
        return $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, l, t, p$1, isFlipped$1)
      } else {
        l = t
      }
    }
  }
}
function $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, start, remaining, p$1, isFlipped$1) {
  while (true) {
    if ($n(remaining).isEmpty__Z()) {
      return start
    } else {
      var x = $n(remaining).head__O();
      if (($uZ($n(p$1).apply__O__O(x)) !== isFlipped$1)) {
        remaining = $as_sci_List($n(remaining).tail__O())
      } else {
        return $p_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List($thiz, start, remaining, p$1, isFlipped$1)
      }
    }
  }
}
function $p_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List($thiz, origStart, firstMiss, p$1, isFlipped$1) {
  var newHead = new $c_sci_$colon$colon($n(origStart).head__O(), $m_sci_Nil$());
  var toProcess = $as_sci_List($n(origStart).tail__O());
  var currentLast = newHead;
  while ((toProcess !== firstMiss)) {
    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
    $n(currentLast).sci_$colon$colon__f_next = newElem;
    currentLast = newElem;
    toProcess = $as_sci_List($n(toProcess).tail__O())
  };
  var next = $as_sci_List($n(firstMiss).tail__O());
  var nextToCopy = next;
  while ((!$n(next).isEmpty__Z())) {
    var head = $n(next).head__O();
    if (($uZ($n(p$1).apply__O__O(head)) !== isFlipped$1)) {
      next = $as_sci_List($n(next).tail__O())
    } else {
      while ((nextToCopy !== next)) {
        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
        currentLast = newElem$2;
        nextToCopy = $as_sci_List($n(nextToCopy).tail__O())
      };
      nextToCopy = $as_sci_List($n(next).tail__O());
      next = $as_sci_List($n(next).tail__O())
    }
  };
  if ((!$n(nextToCopy).isEmpty__Z())) {
    $n(currentLast).sci_$colon$colon__f_next = nextToCopy
  };
  return newHead
}
function $p_sci_List__listEq$1__sci_List__sci_List__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true
    } else {
      var aEmpty = $n(a).isEmpty__Z();
      var bEmpty = $n(b).isEmpty__Z();
      if (((!(aEmpty || bEmpty)) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(a).head__O(), $n(b).head__O()))) {
        var temp$a = $as_sci_List($n(a).tail__O());
        var temp$b = $as_sci_List($n(b).tail__O());
        a = temp$a;
        b = temp$b
      } else {
        return (aEmpty && bEmpty)
      }
    }
  }
}
/** @constructor */
function $c_sci_List() {
  /*<skip>*/
}
$c_sci_List.prototype = new $h_sci_AbstractSeq();
$c_sci_List.prototype.constructor = $c_sci_List;
/** @constructor */
function $h_sci_List() {
  /*<skip>*/
}
$h_sci_List.prototype = $c_sci_List.prototype;
$c_sci_List.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sci_List.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sci_List.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sci_List.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this)
});
$c_sci_List.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem)
});
$c_sci_List.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that)
});
$c_sci_List.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_List.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_List.prototype.scanLeft__O__F2__O = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op)
});
$c_sci_List.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_List.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_List.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_List.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_List.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_List.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_List.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_List.prototype.lastIndexWhere__F1__I__I = (function(p, end) {
  return $f_sc_LinearSeqOps__lastIndexWhere__F1__I__I(this, p, end)
});
$c_sci_List.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_List$()
});
$c_sci_List.prototype.$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  if (this.isEmpty__Z()) {
    return prefix
  } else if ($n(prefix).isEmpty__Z()) {
    return this
  } else {
    var result = new $c_sci_$colon$colon($n(prefix).head__O(), this);
    var curr = result;
    var that = $as_sci_List($n(prefix).tail__O());
    while ((!$n(that).isEmpty__Z())) {
      var temp = new $c_sci_$colon$colon($n(that).head__O(), this);
      $n(curr).sci_$colon$colon__f_next = temp;
      curr = temp;
      that = $as_sci_List($n(that).tail__O())
    };
    return result
  }
});
$c_sci_List.prototype.reverse_$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  var these = this;
  var pres = prefix;
  while ((!$n(pres).isEmpty__Z())) {
    var rassoc$1 = $n(pres).head__O();
    var this$1 = $n(these);
    these = new $c_sci_$colon$colon(rassoc$1, this$1);
    pres = $as_sci_List($n(pres).tail__O())
  };
  return these
});
$c_sci_List.prototype.isEmpty__Z = (function() {
  return (this === $m_sci_Nil$())
});
$c_sci_List.prototype.prepended__O__sci_List = (function(elem) {
  return new $c_sci_$colon$colon(elem, this)
});
$c_sci_List.prototype.prependedAll__sc_IterableOnce__sci_List = (function(prefix) {
  if ((prefix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(prefix);
    return this.$colon$colon$colon__sci_List__sci_List(x2)
  };
  if (($n(prefix).knownSize__I() === 0)) {
    return this
  };
  if ((prefix instanceof $c_scm_ListBuffer)) {
    var x3 = $as_scm_ListBuffer(prefix);
    if (this.isEmpty__Z()) {
      return $n(x3).toList__sci_List()
    }
  };
  var iter = $n(prefix).iterator__sc_Iterator();
  if ($n(iter).hasNext__Z()) {
    var result = new $c_sci_$colon$colon($n(iter).next__O(), this);
    var curr = result;
    while ($n(iter).hasNext__Z()) {
      var temp = new $c_sci_$colon$colon($n(iter).next__O(), this);
      $n(curr).sci_$colon$colon__f_next = temp;
      curr = temp
    };
    return result
  } else {
    return this
  }
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__sci_List = (function(suffix) {
  if ((suffix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(suffix);
    return $n(x2).$colon$colon$colon__sci_List__sci_List(this)
  } else {
    return $as_sci_List($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix))
  }
});
$c_sci_List.prototype.take__I__sci_List = (function(n) {
  if ((this.isEmpty__Z() || (n <= 0))) {
    return $m_sci_Nil$()
  } else {
    var h = new $c_sci_$colon$colon(this.head__O(), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    var i = 1;
    while (true) {
      if ($n(rest).isEmpty__Z()) {
        return this
      };
      if ((i < n)) {
        i = ((1 + i) | 0);
        var nx = new $c_sci_$colon$colon($n(rest).head__O(), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O())
      } else {
        break
      }
    };
    return h
  }
});
$c_sci_List.prototype.slice__I__I__sci_List = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  return (((until <= lo) || this.isEmpty__Z()) ? $m_sci_Nil$() : $n($as_sci_List($p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, lo, this))).take__I__sci_List(((until - lo) | 0)))
});
$c_sci_List.prototype.updated__I__O__sci_List = (function(index, elem) {
  var i = 0;
  var current = this;
  var prefix = new $c_scm_ListBuffer();
  while (true) {
    if ((i < index)) {
      var this$2 = $n(current);
      var $$x1 = (!this$2.isEmpty__Z())
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      i = ((1 + i) | 0);
      var elem$1 = $n(current).head__O();
      prefix.addOne__O__scm_ListBuffer(elem$1);
      current = $as_sci_List($n(current).tail__O())
    } else {
      break
    }
  };
  if ((i === index)) {
    var this$3 = $n(current);
    var $$x2 = (!this$3.isEmpty__Z())
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var this$4 = $n($as_sci_List($n(current).tail__O()));
    return prefix.prependToList__sci_List__sci_List(new $c_sci_$colon$colon(elem, this$4))
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.length__I()) | 0)) + ")"))
  }
});
$c_sci_List.prototype.map__F1__sci_List = (function(f) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var h = new $c_sci_$colon$colon($n(f).apply__O__O(this.head__O()), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var nx = new $c_sci_$colon$colon($n(f).apply__O__O($n(rest).head__O()), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O())
    };
    return h
  }
});
$c_sci_List.prototype.collect__s_PartialFunction__sci_List = (function(pf) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var rest = this;
    var h = null;
    var x = null;
    while ((h === null)) {
      x = $n(pf).applyOrElse__O__F1__O($n(rest).head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        h = new $c_sci_$colon$colon(x, $m_sci_Nil$())
      };
      rest = $as_sci_List($n(rest).tail__O());
      if ((rest === $m_sci_Nil$())) {
        return ((h === null) ? $m_sci_Nil$() : h)
      }
    };
    var t = h;
    while ((rest !== $m_sci_Nil$())) {
      x = $n(pf).applyOrElse__O__F1__O($n(rest).head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        var nx = new $c_sci_$colon$colon(x, $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx
      };
      rest = $as_sci_List($n(rest).tail__O())
    };
    return h
  }
});
$c_sci_List.prototype.flatMap__F1__sci_List = (function(f) {
  var rest = this;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $n($as_sc_IterableOnce($n(f).apply__O__O($n(rest).head__O()))).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        $n(t).sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest = $as_sci_List($n(rest).tail__O())
  };
  return ((h === null) ? $m_sci_Nil$() : h)
});
$c_sci_List.prototype.foreach__F1__V = (function(f) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    $n(f).apply__O__O($n(these).head__O());
    these = $as_sci_List($n(these).tail__O())
  }
});
$c_sci_List.prototype.reverse__sci_List = (function() {
  var result = $m_sci_Nil$();
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    var rassoc$6 = $n(these).head__O();
    var this$1 = $n(result);
    result = new $c_sci_$colon$colon(rassoc$6, this$1);
    these = $as_sci_List($n(these).tail__O())
  };
  return result
});
$c_sci_List.prototype.length__I = (function() {
  var these = this;
  var len = 0;
  while ((!$n(these).isEmpty__Z())) {
    len = ((1 + len) | 0);
    these = $as_sci_List($n(these).tail__O())
  };
  return len
});
$c_sci_List.prototype.lengthCompare__I__I = (function(len) {
  return ((len < 0) ? 1 : $p_sci_List__loop$2__I__sci_List__I__I(this, 0, this, len))
});
$c_sci_List.prototype.forall__F1__Z = (function(p) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ((!$uZ($n(p).apply__O__O($n(these).head__O())))) {
      return false
    };
    these = $as_sci_List($n(these).tail__O())
  };
  return true
});
$c_sci_List.prototype.exists__F1__Z = (function(p) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return true
    };
    these = $as_sci_List($n(these).tail__O())
  };
  return false
});
$c_sci_List.prototype.contains__O__Z = (function(elem) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n(these).head__O(), elem)) {
      return true
    };
    these = $as_sci_List($n(these).tail__O())
  };
  return false
});
$c_sci_List.prototype.find__F1__s_Option = (function(p) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return new $c_s_Some($n(these).head__O())
    };
    these = $as_sci_List($n(these).tail__O())
  };
  return $m_s_None$()
});
$c_sci_List.prototype.last__O = (function() {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "List.last")
  } else {
    var these = this;
    var scout = $as_sci_List(this.tail__O());
    while ((!$n(scout).isEmpty__Z())) {
      these = scout;
      scout = $as_sci_List($n(scout).tail__O())
    };
    return $n(these).head__O()
  }
});
$c_sci_List.prototype.className__T = (function() {
  return "List"
});
$c_sci_List.prototype.toList__sci_List = (function() {
  return this
});
$c_sci_List.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_sci_List)) {
    var x2 = $as_sci_List(o);
    return $p_sci_List__listEq$1__sci_List__sci_List__Z(this, this, x2)
  } else {
    return $f_sc_Seq__equals__O__Z(this, o)
  }
});
$c_sci_List.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_List.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_List.prototype.dropWhile__F1__O = (function(p) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$3__sc_LinearSeq__F1__sc_LinearSeq(this, this, p)
});
$c_sci_List.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this)
});
$c_sci_List.prototype.filterNot__F1__O = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, true)
});
$c_sci_List.prototype.filter__F1__O = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, false)
});
$c_sci_List.prototype.reverse__O = (function() {
  return this.reverse__sci_List()
});
$c_sci_List.prototype.takeWhile__F1__O = (function(p) {
  var b = new $c_scm_ListBuffer();
  var these = this;
  while (((!$n(these).isEmpty__Z()) && $uZ($n(p).apply__O__O($n(these).head__O())))) {
    var elem = $n(these).head__O();
    b.addOne__O__scm_ListBuffer(elem);
    these = $as_sci_List($n(these).tail__O())
  };
  return b.toList__sci_List()
});
$c_sci_List.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_List(f)
});
$c_sci_List.prototype.collect__s_PartialFunction__O = (function(pf) {
  return this.collect__s_PartialFunction__sci_List(pf)
});
$c_sci_List.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_List(f)
});
$c_sci_List.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_List(index, elem)
});
$c_sci_List.prototype.slice__I__I__O = (function(from, until) {
  return this.slice__I__I__sci_List(from, until)
});
$c_sci_List.prototype.take__I__O = (function(n) {
  return this.take__I__sci_List(n)
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_List(suffix)
});
$c_sci_List.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_List(elem)
});
$c_sci_List.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_List$()
});
function $as_sci_List(obj) {
  return (((obj instanceof $c_sci_List) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.List"))
}
function $isArrayOf_sci_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_List)))
}
function $asArrayOf_sci_List(obj, depth) {
  return (($isArrayOf_sci_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.List;", depth))
}
var $d_sci_List = new $TypeData().initClass({
  sci_List: 0
}, false, "scala.collection.immutable.List", {
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_List.prototype.$classData = $d_sci_List;
function $p_sci_Queue__indexOutOfRange$1__I__E($thiz, n$1) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n$1))
}
function $ct_sci_Queue__sci_List__sci_List__($thiz, in$1, out) {
  $thiz.sci_Queue__f_in = in$1;
  $thiz.sci_Queue__f_out = out;
  return $thiz
}
/** @constructor */
function $c_sci_Queue() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null
}
$c_sci_Queue.prototype = new $h_sci_AbstractSeq();
$c_sci_Queue.prototype.constructor = $c_sci_Queue;
/** @constructor */
function $h_sci_Queue() {
  /*<skip>*/
}
$h_sci_Queue.prototype = $c_sci_Queue.prototype;
$c_sci_Queue.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sci_Queue.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sci_StrictOptimizedSeqOps__updated__I__O__O(this, index, elem)
});
$c_sci_Queue.prototype.patch__I__sc_IterableOnce__I__O = (function(from, other, replaced) {
  return $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O(this, from, other, replaced)
});
$c_sci_Queue.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sci_Queue.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that)
});
$c_sci_Queue.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Queue.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Queue.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_Queue.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_Queue.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Queue.prototype.scanLeft__O__F2__O = (function(z, op) {
  return $f_sc_StrictOptimizedIterableOps__scanLeft__O__F2__O(this, z, op)
});
$c_sci_Queue.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_sci_Queue.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sci_Queue.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_Queue.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_Queue.prototype.headOption__s_Option = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this)
});
$c_sci_Queue.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_Queue.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_Queue.prototype.foreach__F1__V = (function(f) {
  $f_sc_LinearSeqOps__foreach__F1__V(this, f)
});
$c_sci_Queue.prototype.contains__O__Z = (function(elem) {
  return $f_sc_LinearSeqOps__contains__O__Z(this, elem)
});
$c_sci_Queue.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_LinearSeqOps__find__F1__s_Option(this, p)
});
$c_sci_Queue.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_Queue.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_Queue.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_Queue.prototype.lastIndexWhere__F1__I__I = (function(p, end) {
  return $f_sc_LinearSeqOps__lastIndexWhere__F1__I__I(this, p, end)
});
$c_sci_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Queue$()
});
$c_sci_Queue.prototype.apply__I__O = (function(n) {
  var index = 0;
  var curr = this.sci_Queue__f_out;
  while (true) {
    if ((index < n)) {
      var this$1 = $n(curr);
      var $$x1 = (!this$1.isEmpty__Z())
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index = ((1 + index) | 0);
      curr = $as_sci_List($n(curr).tail__O())
    } else {
      break
    }
  };
  if ((index === n)) {
    var this$2 = $n(curr);
    if ((!this$2.isEmpty__Z())) {
      return $n(curr).head__O()
    } else {
      var this$3 = $n(this.sci_Queue__f_in);
      if ((!this$3.isEmpty__Z())) {
        return $n(this.sci_Queue__f_in).last__O()
      } else {
        $p_sci_Queue__indexOutOfRange$1__I__E(this, n)
      }
    }
  } else {
    var indexFromBack = ((n - index) | 0);
    var inLength = $n(this.sci_Queue__f_in).length__I();
    if ((indexFromBack >= inLength)) {
      $p_sci_Queue__indexOutOfRange$1__I__E(this, n)
    } else {
      var this$4 = $n(this.sci_Queue__f_in);
      var n$1 = (((-1) + ((inLength - indexFromBack) | 0)) | 0);
      return $f_sc_LinearSeqOps__apply__I__O(this$4, n$1)
    }
  }
});
$c_sci_Queue.prototype.iterator__sc_Iterator = (function() {
  return $n($n(this.sci_Queue__f_out).iterator__sc_Iterator()).concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0((() => $n(this.sci_Queue__f_in).reverse__sci_List())))
});
$c_sci_Queue.prototype.isEmpty__Z = (function() {
  return ($n(this.sci_Queue__f_in).isEmpty__Z() && $n(this.sci_Queue__f_out).isEmpty__Z())
});
$c_sci_Queue.prototype.head__O = (function() {
  var this$1 = $n(this.sci_Queue__f_out);
  if ((!this$1.isEmpty__Z())) {
    return $n(this.sci_Queue__f_out).head__O()
  } else {
    var this$2 = $n(this.sci_Queue__f_in);
    if ((!this$2.isEmpty__Z())) {
      return $n(this.sci_Queue__f_in).last__O()
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head on empty queue")
    }
  }
});
$c_sci_Queue.prototype.tail__sci_Queue = (function() {
  var this$1 = $n(this.sci_Queue__f_out);
  if ((!this$1.isEmpty__Z())) {
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, $as_sci_List($n(this.sci_Queue__f_out).tail__O()))
  } else {
    var this$2 = $n(this.sci_Queue__f_in);
    if ((!this$2.isEmpty__Z())) {
      return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List($n($n(this.sci_Queue__f_in).reverse__sci_List()).tail__O()))
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "tail on empty queue")
    }
  }
});
$c_sci_Queue.prototype.last__O = (function() {
  var this$1 = $n(this.sci_Queue__f_in);
  if ((!this$1.isEmpty__Z())) {
    return $n(this.sci_Queue__f_in).head__O()
  } else {
    var this$2 = $n(this.sci_Queue__f_out);
    if ((!this$2.isEmpty__Z())) {
      return $n(this.sci_Queue__f_out).last__O()
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last on empty queue")
    }
  }
});
$c_sci_Queue.prototype.forall__F1__Z = (function(p) {
  return ($n(this.sci_Queue__f_in).forall__F1__Z(p) && $n(this.sci_Queue__f_out).forall__F1__Z(p))
});
$c_sci_Queue.prototype.exists__F1__Z = (function(p) {
  return ($n(this.sci_Queue__f_in).exists__F1__Z(p) || $n(this.sci_Queue__f_out).exists__F1__Z(p))
});
$c_sci_Queue.prototype.className__T = (function() {
  return "Queue"
});
$c_sci_Queue.prototype.length__I = (function() {
  return (($n(this.sci_Queue__f_in).length__I() + $n(this.sci_Queue__f_out).length__I()) | 0)
});
$c_sci_Queue.prototype.prepended__O__sci_Queue = (function(elem) {
  var $$x1 = this.sci_Queue__f_in;
  var this$1 = $n(this.sci_Queue__f_out);
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $$x1, new $c_sci_$colon$colon(elem, this$1))
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__sci_Queue = (function(that) {
  if ((that instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(that);
    var this$1 = $n($n(x2).sci_Queue__f_in);
    var rassoc$2 = $n(x2).sci_Queue__f_out;
    var suffix = $n(this.sci_Queue__f_in).reverse_$colon$colon$colon__sci_List__sci_List(rassoc$2);
    var newIn = this$1.appendedAll__sc_IterableOnce__sci_List(suffix)
  } else if ((that instanceof $c_sci_List)) {
    var x3 = $as_sci_List(that);
    var newIn = $n(this.sci_Queue__f_in).reverse_$colon$colon$colon__sci_List__sci_List(x3)
  } else {
    var result = this.sci_Queue__f_in;
    var iter = $n(that).iterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var rassoc$4 = $n(iter).next__O();
      var this$2 = $n(result);
      result = new $c_sci_$colon$colon(rassoc$4, this$2)
    };
    var newIn = result
  };
  return ((newIn === this.sci_Queue__f_in) ? this : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), newIn, this.sci_Queue__f_out))
});
$c_sci_Queue.prototype.enqueue__O__sci_Queue = (function(elem) {
  var this$1 = $n(this.sci_Queue__f_in);
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), new $c_sci_$colon$colon(elem, this$1), this.sci_Queue__f_out)
});
$c_sci_Queue.prototype.dequeue__T2 = (function() {
  var x1 = this.sci_Queue__f_out;
  var x = $m_sci_Nil$();
  if ((x.equals__O__Z(x1) && (!$n(this.sci_Queue__f_in).isEmpty__Z()))) {
    var rev = $n(this.sci_Queue__f_in).reverse__sci_List();
    return $ct_T2__O__O__(new $c_T2(), $n(rev).head__O(), $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List($n(rev).tail__O())))
  } else if ((x1 instanceof $c_sci_$colon$colon)) {
    var x3 = $as_sci_$colon$colon(x1);
    var x$3 = $n(x3).sci_$colon$colon__f_head;
    var xs = $n(x3).sci_$colon$colon__f_next;
    return $ct_T2__O__O__(new $c_T2(), x$3, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, xs))
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "dequeue on empty queue")
  }
});
$c_sci_Queue.prototype.dequeueOption__s_Option = (function() {
  return (this.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(this.dequeue__T2()))
});
$c_sci_Queue.prototype.toString__T = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this, "Queue(", ", ", ")")
});
$c_sci_Queue.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_Queue.prototype.dropWhile__F1__O = (function(p) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$3__sc_LinearSeq__F1__sc_LinearSeq(this, this, p)
});
$c_sci_Queue.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this)
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Queue(suffix)
});
$c_sci_Queue.prototype.appended__O__O = (function(elem) {
  return this.enqueue__O__sci_Queue(elem)
});
$c_sci_Queue.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Queue(elem)
});
$c_sci_Queue.prototype.tail__O = (function() {
  return this.tail__sci_Queue()
});
$c_sci_Queue.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sci_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Queue$()
});
function $as_sci_Queue(obj) {
  return (((obj instanceof $c_sci_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Queue"))
}
function $isArrayOf_sci_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Queue)))
}
function $asArrayOf_sci_Queue(obj, depth) {
  return (($isArrayOf_sci_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Queue;", depth))
}
var $d_sci_Queue = new $TypeData().initClass({
  sci_Queue: 0
}, false, "scala.collection.immutable.Queue", {
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Queue.prototype.$classData = $d_sci_Queue;
/** @constructor */
function $c_sci_VectorImpl() {
  this.sci_Vector__f_prefix1 = null
}
$c_sci_VectorImpl.prototype = new $h_sci_Vector();
$c_sci_VectorImpl.prototype.constructor = $c_sci_VectorImpl;
/** @constructor */
function $h_sci_VectorImpl() {
  /*<skip>*/
}
$h_sci_VectorImpl.prototype = $c_sci_VectorImpl.prototype;
$c_sci_VectorImpl.prototype.slice__I__I__sci_Vector = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = this.length__I();
  var hi = ((until < b) ? until : b);
  return ((hi <= lo) ? $m_sci_Vector0$() : ((((hi - lo) | 0) === this.length__I()) ? this : this.slice0__I__I__sci_Vector(lo, hi)))
});
$c_sci_VectorImpl.prototype.slice__I__I__O = (function(from, until) {
  return this.slice__I__I__sci_Vector(from, until)
});
/** @constructor */
function $c_scm_ArraySeq$ofBoolean(array) {
  this.scm_ArraySeq$ofBoolean__f_array = null;
  this.scm_ArraySeq$ofBoolean__f_array = array
}
$c_scm_ArraySeq$ofBoolean.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofBoolean.prototype.constructor = $c_scm_ArraySeq$ofBoolean;
/** @constructor */
function $h_scm_ArraySeq$ofBoolean() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofBoolean.prototype = $c_scm_ArraySeq$ofBoolean.prototype;
$c_scm_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofBoolean__f_array).u.length
});
$c_scm_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofBoolean__f_array;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofBoolean)) {
    var x2 = $as_scm_ArraySeq$ofBoolean(that);
    var a = this.scm_ArraySeq$ofBoolean__f_array;
    var b = $n(x2).scm_ArraySeq$ofBoolean__f_array;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.scm_ArraySeq$ofBoolean__f_array)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(index) {
  return $n(this.scm_ArraySeq$ofBoolean__f_array).get(index)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcZI$sp__I__Z(index)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i)
});
$c_scm_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$()
});
$c_scm_ArraySeq$ofBoolean.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array
});
function $as_scm_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofBoolean"))
}
function $isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofBoolean)))
}
function $asArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofBoolean;", depth))
}
var $d_scm_ArraySeq$ofBoolean = new $TypeData().initClass({
  scm_ArraySeq$ofBoolean: 0
}, false, "scala.collection.mutable.ArraySeq$ofBoolean", {
  scm_ArraySeq$ofBoolean: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofBoolean.prototype.$classData = $d_scm_ArraySeq$ofBoolean;
/** @constructor */
function $c_scm_ArraySeq$ofByte(array) {
  this.scm_ArraySeq$ofByte__f_array = null;
  this.scm_ArraySeq$ofByte__f_array = array
}
$c_scm_ArraySeq$ofByte.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofByte.prototype.constructor = $c_scm_ArraySeq$ofByte;
/** @constructor */
function $h_scm_ArraySeq$ofByte() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofByte.prototype = $c_scm_ArraySeq$ofByte.prototype;
$c_scm_ArraySeq$ofByte.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofByte__f_array).u.length
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__B = (function(index) {
  return $n(this.scm_ArraySeq$ofByte__f_array).get(index)
});
$c_scm_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofByte__f_array;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofByte)) {
    var x2 = $as_scm_ArraySeq$ofByte(that);
    var a = this.scm_ArraySeq$ofByte__f_array;
    var b = $n(x2).scm_ArraySeq$ofByte__f_array;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.scm_ArraySeq$ofByte__f_array)
});
$c_scm_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1))
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i)
});
$c_scm_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$()
});
$c_scm_ArraySeq$ofByte.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofByte__f_array
});
function $as_scm_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofByte"))
}
function $isArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofByte)))
}
function $asArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofByte;", depth))
}
var $d_scm_ArraySeq$ofByte = new $TypeData().initClass({
  scm_ArraySeq$ofByte: 0
}, false, "scala.collection.mutable.ArraySeq$ofByte", {
  scm_ArraySeq$ofByte: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofByte.prototype.$classData = $d_scm_ArraySeq$ofByte;
/** @constructor */
function $c_scm_ArraySeq$ofChar(array) {
  this.scm_ArraySeq$ofChar__f_array = null;
  this.scm_ArraySeq$ofChar__f_array = array
}
$c_scm_ArraySeq$ofChar.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofChar.prototype.constructor = $c_scm_ArraySeq$ofChar;
/** @constructor */
function $h_scm_ArraySeq$ofChar() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofChar.prototype = $c_scm_ArraySeq$ofChar.prototype;
$c_scm_ArraySeq$ofChar.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofChar__f_array).u.length
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__C = (function(index) {
  return $n(this.scm_ArraySeq$ofChar__f_array).get(index)
});
$c_scm_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofChar__f_array;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofChar)) {
    var x2 = $as_scm_ArraySeq$ofChar(that);
    var a = this.scm_ArraySeq$ofChar__f_array;
    var b = $n(x2).scm_ArraySeq$ofChar__f_array;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.scm_ArraySeq$ofChar__f_array)
});
$c_scm_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  var jsb = $n(sb).scm_StringBuilder__f_underlying;
  var this$1 = $n(start);
  if ((this$1.length !== 0)) {
    var this$2 = $n(jsb);
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start)
  };
  var len = $n(this.scm_ArraySeq$ofChar__f_array).u.length;
  if ((len !== 0)) {
    var this$3 = $n(sep);
    if ((this$3 === "")) {
      $n(jsb).append__AC__jl_StringBuilder(this.scm_ArraySeq$ofChar__f_array)
    } else {
      $n(jsb);
      $n(jsb).length__I();
      $n(end);
      $n(sep);
      var this$6 = $n(jsb);
      var c = $n(this.scm_ArraySeq$ofChar__f_array).get(0);
      var str = $as_T(String.fromCharCode(c));
      this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      var i = 1;
      while ((i < len)) {
        var this$8 = $n(jsb);
        this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$9 = $n(jsb);
        var c$1 = $n(this.scm_ArraySeq$ofChar__f_array).get(i);
        var str$1 = $as_T(String.fromCharCode(c$1));
        this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
        i = ((1 + i) | 0)
      }
    }
  };
  var this$11 = $n(end);
  if ((this$11.length !== 0)) {
    var this$12 = $n(jsb);
    this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end)
  };
  return sb
});
$c_scm_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)))
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i))
});
$c_scm_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$()
});
$c_scm_ArraySeq$ofChar.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofChar__f_array
});
function $as_scm_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofChar"))
}
function $isArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofChar)))
}
function $asArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofChar;", depth))
}
var $d_scm_ArraySeq$ofChar = new $TypeData().initClass({
  scm_ArraySeq$ofChar: 0
}, false, "scala.collection.mutable.ArraySeq$ofChar", {
  scm_ArraySeq$ofChar: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofChar.prototype.$classData = $d_scm_ArraySeq$ofChar;
/** @constructor */
function $c_scm_ArraySeq$ofDouble(array) {
  this.scm_ArraySeq$ofDouble__f_array = null;
  this.scm_ArraySeq$ofDouble__f_array = array
}
$c_scm_ArraySeq$ofDouble.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofDouble.prototype.constructor = $c_scm_ArraySeq$ofDouble;
/** @constructor */
function $h_scm_ArraySeq$ofDouble() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofDouble.prototype = $c_scm_ArraySeq$ofDouble.prototype;
$c_scm_ArraySeq$ofDouble.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofDouble__f_array).u.length
});
$c_scm_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofDouble__f_array;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofDouble)) {
    var x2 = $as_scm_ArraySeq$ofDouble(that);
    var a = this.scm_ArraySeq$ofDouble__f_array;
    var b = $n(x2).scm_ArraySeq$ofDouble__f_array;
    return $m_ju_Arrays$().equals__AD__AD__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.scm_ArraySeq$ofDouble__f_array)
});
$c_scm_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(index) {
  return $n(this.scm_ArraySeq$ofDouble__f_array).get(index)
});
$c_scm_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcDI$sp__I__D(index)
});
$c_scm_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i)
});
$c_scm_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$()
});
$c_scm_ArraySeq$ofDouble.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofDouble__f_array
});
function $as_scm_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofDouble"))
}
function $isArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofDouble)))
}
function $asArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofDouble;", depth))
}
var $d_scm_ArraySeq$ofDouble = new $TypeData().initClass({
  scm_ArraySeq$ofDouble: 0
}, false, "scala.collection.mutable.ArraySeq$ofDouble", {
  scm_ArraySeq$ofDouble: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofDouble.prototype.$classData = $d_scm_ArraySeq$ofDouble;
/** @constructor */
function $c_scm_ArraySeq$ofFloat(array) {
  this.scm_ArraySeq$ofFloat__f_array = null;
  this.scm_ArraySeq$ofFloat__f_array = array
}
$c_scm_ArraySeq$ofFloat.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofFloat.prototype.constructor = $c_scm_ArraySeq$ofFloat;
/** @constructor */
function $h_scm_ArraySeq$ofFloat() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofFloat.prototype = $c_scm_ArraySeq$ofFloat.prototype;
$c_scm_ArraySeq$ofFloat.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofFloat__f_array).u.length
});
$c_scm_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofFloat__f_array;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofFloat)) {
    var x2 = $as_scm_ArraySeq$ofFloat(that);
    var a = this.scm_ArraySeq$ofFloat__f_array;
    var b = $n(x2).scm_ArraySeq$ofFloat__f_array;
    return $m_ju_Arrays$().equals__AF__AF__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.scm_ArraySeq$ofFloat__f_array)
});
$c_scm_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(index) {
  return $n(this.scm_ArraySeq$ofFloat__f_array).get(index)
});
$c_scm_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcFI$sp__I__F(index)
});
$c_scm_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i)
});
$c_scm_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$()
});
$c_scm_ArraySeq$ofFloat.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofFloat__f_array
});
function $as_scm_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofFloat"))
}
function $isArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofFloat)))
}
function $asArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofFloat;", depth))
}
var $d_scm_ArraySeq$ofFloat = new $TypeData().initClass({
  scm_ArraySeq$ofFloat: 0
}, false, "scala.collection.mutable.ArraySeq$ofFloat", {
  scm_ArraySeq$ofFloat: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofFloat.prototype.$classData = $d_scm_ArraySeq$ofFloat;
/** @constructor */
function $c_scm_ArraySeq$ofInt(array) {
  this.scm_ArraySeq$ofInt__f_array = null;
  this.scm_ArraySeq$ofInt__f_array = array
}
$c_scm_ArraySeq$ofInt.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofInt.prototype.constructor = $c_scm_ArraySeq$ofInt;
/** @constructor */
function $h_scm_ArraySeq$ofInt() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofInt.prototype = $c_scm_ArraySeq$ofInt.prototype;
$c_scm_ArraySeq$ofInt.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofInt__f_array).u.length
});
$c_scm_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofInt__f_array;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofInt)) {
    var x2 = $as_scm_ArraySeq$ofInt(that);
    var a = this.scm_ArraySeq$ofInt__f_array;
    var b = $n(x2).scm_ArraySeq$ofInt__f_array;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.scm_ArraySeq$ofInt__f_array)
});
$c_scm_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(index) {
  return $n(this.scm_ArraySeq$ofInt__f_array).get(index)
});
$c_scm_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcII$sp__I__I(index)
});
$c_scm_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i)
});
$c_scm_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$()
});
$c_scm_ArraySeq$ofInt.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofInt__f_array
});
function $as_scm_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofInt"))
}
function $isArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofInt)))
}
function $asArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofInt;", depth))
}
var $d_scm_ArraySeq$ofInt = new $TypeData().initClass({
  scm_ArraySeq$ofInt: 0
}, false, "scala.collection.mutable.ArraySeq$ofInt", {
  scm_ArraySeq$ofInt: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofInt.prototype.$classData = $d_scm_ArraySeq$ofInt;
/** @constructor */
function $c_scm_ArraySeq$ofLong(array) {
  this.scm_ArraySeq$ofLong__f_array = null;
  this.scm_ArraySeq$ofLong__f_array = array
}
$c_scm_ArraySeq$ofLong.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofLong.prototype.constructor = $c_scm_ArraySeq$ofLong;
/** @constructor */
function $h_scm_ArraySeq$ofLong() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofLong.prototype = $c_scm_ArraySeq$ofLong.prototype;
$c_scm_ArraySeq$ofLong.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofLong__f_array).u.length
});
$c_scm_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofLong__f_array;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofLong)) {
    var x2 = $as_scm_ArraySeq$ofLong(that);
    var a = this.scm_ArraySeq$ofLong__f_array;
    var b = $n(x2).scm_ArraySeq$ofLong__f_array;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.scm_ArraySeq$ofLong__f_array)
});
$c_scm_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(index) {
  return $n(this.scm_ArraySeq$ofLong__f_array).get(index)
});
$c_scm_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcJI$sp__I__J(index)
});
$c_scm_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i)
});
$c_scm_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$()
});
$c_scm_ArraySeq$ofLong.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofLong__f_array
});
function $as_scm_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofLong"))
}
function $isArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofLong)))
}
function $asArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofLong;", depth))
}
var $d_scm_ArraySeq$ofLong = new $TypeData().initClass({
  scm_ArraySeq$ofLong: 0
}, false, "scala.collection.mutable.ArraySeq$ofLong", {
  scm_ArraySeq$ofLong: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofLong.prototype.$classData = $d_scm_ArraySeq$ofLong;
/** @constructor */
function $c_scm_ArraySeq$ofRef(array) {
  this.scm_ArraySeq$ofRef__f_array = null;
  this.scm_ArraySeq$ofRef__f_array = array
}
$c_scm_ArraySeq$ofRef.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofRef.prototype.constructor = $c_scm_ArraySeq$ofRef;
/** @constructor */
function $h_scm_ArraySeq$ofRef() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofRef.prototype = $c_scm_ArraySeq$ofRef.prototype;
$c_scm_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $$x1 = $m_s_reflect_ClassTag$();
  var this$1 = $n(this.scm_ArraySeq$ofRef__f_array);
  return $n($$x1).apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$1).getComponentType__jl_Class())
});
$c_scm_ArraySeq$ofRef.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofRef__f_array).u.length
});
$c_scm_ArraySeq$ofRef.prototype.apply__I__O = (function(index) {
  return $n(this.scm_ArraySeq$ofRef__f_array).get(index)
});
$c_scm_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofRef__f_array;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofRef)) {
    var x2 = $as_scm_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.scm_ArraySeq$ofRef__f_array, $n(x2).scm_ArraySeq$ofRef__f_array)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.scm_ArraySeq$ofRef__f_array)
});
$c_scm_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_scm_ArraySeq$ofRef.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofRef__f_array
});
function $as_scm_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofRef"))
}
function $isArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofRef)))
}
function $asArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofRef;", depth))
}
var $d_scm_ArraySeq$ofRef = new $TypeData().initClass({
  scm_ArraySeq$ofRef: 0
}, false, "scala.collection.mutable.ArraySeq$ofRef", {
  scm_ArraySeq$ofRef: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofRef.prototype.$classData = $d_scm_ArraySeq$ofRef;
/** @constructor */
function $c_scm_ArraySeq$ofShort(array) {
  this.scm_ArraySeq$ofShort__f_array = null;
  this.scm_ArraySeq$ofShort__f_array = array
}
$c_scm_ArraySeq$ofShort.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofShort.prototype.constructor = $c_scm_ArraySeq$ofShort;
/** @constructor */
function $h_scm_ArraySeq$ofShort() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofShort.prototype = $c_scm_ArraySeq$ofShort.prototype;
$c_scm_ArraySeq$ofShort.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofShort__f_array).u.length
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__S = (function(index) {
  return $n(this.scm_ArraySeq$ofShort__f_array).get(index)
});
$c_scm_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofShort__f_array;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofShort)) {
    var x2 = $as_scm_ArraySeq$ofShort(that);
    var a = this.scm_ArraySeq$ofShort__f_array;
    var b = $n(x2).scm_ArraySeq$ofShort__f_array;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.scm_ArraySeq$ofShort__f_array)
});
$c_scm_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1))
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i)
});
$c_scm_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$()
});
$c_scm_ArraySeq$ofShort.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofShort__f_array
});
function $as_scm_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofShort"))
}
function $isArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofShort)))
}
function $asArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofShort;", depth))
}
var $d_scm_ArraySeq$ofShort = new $TypeData().initClass({
  scm_ArraySeq$ofShort: 0
}, false, "scala.collection.mutable.ArraySeq$ofShort", {
  scm_ArraySeq$ofShort: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofShort.prototype.$classData = $d_scm_ArraySeq$ofShort;
/** @constructor */
function $c_scm_ArraySeq$ofUnit(array) {
  this.scm_ArraySeq$ofUnit__f_array = null;
  this.scm_ArraySeq$ofUnit__f_array = array
}
$c_scm_ArraySeq$ofUnit.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofUnit.prototype.constructor = $c_scm_ArraySeq$ofUnit;
/** @constructor */
function $h_scm_ArraySeq$ofUnit() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofUnit.prototype = $c_scm_ArraySeq$ofUnit.prototype;
$c_scm_ArraySeq$ofUnit.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofUnit__f_array).u.length
});
$c_scm_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofUnit__f_array;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofUnit)) {
    var x2 = $as_scm_ArraySeq$ofUnit(that);
    return ($n(this.scm_ArraySeq$ofUnit__f_array).u.length === $n($n(x2).scm_ArraySeq$ofUnit__f_array).u.length)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.scm_ArraySeq$ofUnit__f_array)
});
$c_scm_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(index) {
  $n(this.scm_ArraySeq$ofUnit__f_array).get(index)
});
$c_scm_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  this.apply$mcVI$sp__I__V(index)
});
$c_scm_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i)
});
$c_scm_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$()
});
$c_scm_ArraySeq$ofUnit.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofUnit__f_array
});
function $as_scm_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofUnit"))
}
function $isArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofUnit)))
}
function $asArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofUnit;", depth))
}
var $d_scm_ArraySeq$ofUnit = new $TypeData().initClass({
  scm_ArraySeq$ofUnit: 0
}, false, "scala.collection.mutable.ArraySeq$ofUnit", {
  scm_ArraySeq$ofUnit: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofUnit.prototype.$classData = $d_scm_ArraySeq$ofUnit;
function $p_scm_HashMap__put0__O__O__I__Z__s_Some($thiz, key, value, hash, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1))
  };
  var idx = (hash & (((-1) + $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx)
}
function $p_scm_HashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1))
  };
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var idx = (hash & (((-1) + $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx)
}
function $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(idx);
  if ((x1 === null)) {
    $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(idx, new $c_scm_HashMap$Node(key, hash, value, null))
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && ($n(n).scm_HashMap$Node__f__hash <= hash))) {
      if ((($n(n).scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, $n(n).scm_HashMap$Node__f__key))) {
        var old = $n(n).scm_HashMap$Node__f__value;
        $n(n).scm_HashMap$Node__f__value = value;
        return (getOld ? new $c_s_Some(old) : null)
      };
      prev = n;
      n = $n(n).scm_HashMap$Node__f__next
    };
    if ((prev === null)) {
      $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(idx, new $c_scm_HashMap$Node(key, hash, value, x1))
    } else {
      $n(prev).scm_HashMap$Node__f__next = new $c_scm_HashMap$Node(key, hash, value, $n(prev).scm_HashMap$Node__f__next)
    }
  };
  $thiz.scm_HashMap__f_contentSize = ((1 + $thiz.scm_HashMap__f_contentSize) | 0);
  return null
}
function $p_scm_HashMap__remove0__O__scm_HashMap$Node($thiz, elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  return $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)))
}
function $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, hash) {
  var idx = (hash & (((-1) + $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
  var x1 = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(idx);
  if ((x1 === null)) {
    return null
  } else if ((($n(x1).scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(x1).scm_HashMap$Node__f__key, elem))) {
    $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(idx, $n(x1).scm_HashMap$Node__f__next);
    $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
    return x1
  } else {
    var prev = x1;
    var next = $n(x1).scm_HashMap$Node__f__next;
    while (((next !== null) && ($n(next).scm_HashMap$Node__f__hash <= hash))) {
      if ((($n(next).scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(next).scm_HashMap$Node__f__key, elem))) {
        $n(prev).scm_HashMap$Node__f__next = $n(next).scm_HashMap$Node__f__next;
        $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
        return next
      };
      prev = next;
      next = $n(next).scm_HashMap$Node__f__next
    };
    return null
  }
}
function $p_scm_HashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new HashMap table size " + newlen) + " exceeds maximum"))
  };
  var oldlen = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashMap__f_contentSize === 0)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)(newlen)
  } else {
    var original = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = $asArrayOf_scm_HashMap$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashMap$Node(null, 0, null, null);
    var preHigh = new $c_scm_HashMap$Node(null, 0, null, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(i);
        if ((old !== null)) {
          preLow.scm_HashMap$Node__f__next = null;
          preHigh.scm_HashMap$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = $n(n).scm_HashMap$Node__f__next;
            if ((($n(n).scm_HashMap$Node__f__hash & oldlen) === 0)) {
              $n(lastLow).scm_HashMap$Node__f__next = n;
              lastLow = n
            } else {
              $n(lastHigh).scm_HashMap$Node__f__next = n;
              lastHigh = n
            };
            n = next
          };
          $n(lastLow).scm_HashMap$Node__f__next = null;
          if ((old !== preLow.scm_HashMap$Node__f__next)) {
            $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(i, preLow.scm_HashMap$Node__f__next)
          };
          if ((preHigh.scm_HashMap$Node__f__next !== null)) {
            $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(((i + oldlen) | 0), preHigh.scm_HashMap$Node__f__next);
            $n(lastHigh).scm_HashMap$Node__f__next = null
          }
        };
        i = ((1 + i) | 0)
      };
      oldlen = (oldlen << 1)
    }
  }
}
function $p_scm_HashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> $uI(Math.clz32(i))) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824)
}
function $p_scm_HashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashMap__f_loadFactor))
}
function $ct_scm_HashMap__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashMap__f_loadFactor = loadFactor;
  $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)($p_scm_HashMap__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length);
  $thiz.scm_HashMap__f_contentSize = 0;
  return $thiz
}
function $ct_scm_HashMap__($thiz) {
  $ct_scm_HashMap__I__D__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_scm_HashMap() {
  this.scm_HashMap__f_loadFactor = 0.0;
  this.scm_HashMap__f_scala$collection$mutable$HashMap$$table = null;
  this.scm_HashMap__f_threshold = 0;
  this.scm_HashMap__f_contentSize = 0
}
$c_scm_HashMap.prototype = new $h_scm_AbstractMap();
$c_scm_HashMap.prototype.constructor = $c_scm_HashMap;
/** @constructor */
function $h_scm_HashMap() {
  /*<skip>*/
}
$h_scm_HashMap.prototype = $c_scm_HashMap.prototype;
$c_scm_HashMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f)
});
$c_scm_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_HashMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_HashMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_scm_HashMap.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_scm_HashMap.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_scm_HashMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_scm_HashMap.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_scm_HashMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_scm_HashMap.prototype.size__I = (function() {
  return this.scm_HashMap__f_contentSize
});
$c_scm_HashMap.prototype.contains__O__Z = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
  return (((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash)) !== null)
});
$c_scm_HashMap.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashMap__f_loadFactor)));
  if ((target > $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length)) {
    $p_scm_HashMap__growTable__I__V(this, target)
  }
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_HashMap = (function(xs) {
  this.sizeHint__I__V($n(xs).knownSize__I());
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    var this$2 = $n(x2);
    var f = new $c_sjsr_AnonFunction3(((k$2, v$2, h$2) => {
      var h = $uI(h$2);
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, k$2, v$2, (h ^ ((h >>> 16) | 0)), false)
    }));
    $n(this$2.sci_HashMap__f_rootNode).foreachWithHash__F3__V(f);
    return this
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = $n(x3).nodeIterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var next = $as_scm_HashMap$Node($n(iter).next__O());
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, $n(next).scm_HashMap$Node__f__key, $n(next).scm_HashMap$Node__f__value, $n(next).scm_HashMap$Node__f__hash, false)
    };
    return this
  } else if (false) {
    var x4 = $as_scm_LinkedHashMap(xs);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    while ($n(iter$2).hasNext__Z()) {
      var entry = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, $n(entry).key__O(), $n(entry).value__O(), $n(entry).hash__I(), false)
    };
    return this
  } else if ($is_scm_Map(xs)) {
    var x5 = $as_scm_Map(xs);
    $n(x5).foreachEntry__F2__V(new $c_sjsr_AnonFunction2(((key$2, value$2) => {
      var originalHash = $m_sr_Statics$().anyHash__O__I(key$2);
      return $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, key$2, value$2, (originalHash ^ ((originalHash >>> 16) | 0)), false)
    })));
    return this
  } else {
    return $as_scm_HashMap($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_HashMap.prototype.updateWith__O__F1__s_Option = (function(key, remappingFunction) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_scm_MapOps__updateWith__O__F1__s_Option(this, key, remappingFunction)
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var indexedHash = (hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
    var elem = null;
    elem = null;
    var elem$1 = null;
    elem$1 = null;
    var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(indexedHash);
    if ((x1 !== null)) {
      var prev = null;
      var nd = x1;
      while (true) {
        if (((hash === $n(nd).scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, $n(nd).scm_HashMap$Node__f__key))) {
          elem$1 = prev;
          elem = nd
        } else if ((!(($n(nd).scm_HashMap$Node__f__next === null) || ($n(nd).scm_HashMap$Node__f__hash > hash)))) {
          var temp$prev = nd;
          var temp$nd = $n(nd).scm_HashMap$Node__f__next;
          prev = temp$prev;
          nd = temp$nd;
          continue
        };
        break
      }
    };
    var x1$2 = $as_scm_HashMap$Node(elem);
    var previousValue = ((x1$2 === null) ? $m_s_None$() : new $c_s_Some($n(x1$2).scm_HashMap$Node__f__value));
    var nextValue = $as_s_Option($n(remappingFunction).apply__O__O(previousValue));
    var x1$3 = $ct_T2__O__O__(new $c_T2(), previousValue, nextValue);
    matchEnd21: {
      var p2 = $as_s_Option(x1$3.T2__f__1);
      var p3 = $as_s_Option(x1$3.T2__f__2);
      var x$3 = $m_s_None$();
      if ((x$3 === p2)) {
        var x$5 = $m_s_None$();
        var $$x1 = (x$5 === p3)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        break matchEnd21
      };
      var p6 = $as_s_Option(x1$3.T2__f__1);
      var p7 = $as_s_Option(x1$3.T2__f__2);
      if ((p6 instanceof $c_s_Some)) {
        var x$7 = $m_s_None$();
        var $$x2 = (x$7 === p7)
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        if (($as_scm_HashMap$Node(elem$1) !== null)) {
          $n($as_scm_HashMap$Node(elem$1)).scm_HashMap$Node__f__next = $n($as_scm_HashMap$Node(elem)).scm_HashMap$Node__f__next
        } else {
          $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(indexedHash, $n($as_scm_HashMap$Node(elem)).scm_HashMap$Node__f__next)
        };
        this.scm_HashMap__f_contentSize = (((-1) + this.scm_HashMap__f_contentSize) | 0);
        break matchEnd21
      };
      var p11 = $as_s_Option(x1$3.T2__f__1);
      var p12 = $as_s_Option(x1$3.T2__f__2);
      var x$9 = $m_s_None$();
      if (((x$9 === p11) && (p12 instanceof $c_s_Some))) {
        var x13 = $as_s_Some(p12);
        var value = $n(x13).s_Some__f_value;
        var newIndexedHash = ((((1 + this.scm_HashMap__f_contentSize) | 0) >= this.scm_HashMap__f_threshold) ? ($p_scm_HashMap__growTable__I__V(this, ($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1)), (hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0))) : indexedHash);
        $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, value, false, hash, newIndexedHash);
        break matchEnd21
      };
      var p15 = $as_s_Option(x1$3.T2__f__1);
      var p16 = $as_s_Option(x1$3.T2__f__2);
      if (((p15 instanceof $c_s_Some) && (p16 instanceof $c_s_Some))) {
        var x19 = $as_s_Some(p16);
        var newValue = $n(x19).s_Some__f_value;
        $n($as_scm_HashMap$Node(elem)).scm_HashMap$Node__f__value = newValue;
        break matchEnd21
      };
      throw new $c_s_MatchError(x1$3)
    };
    return nextValue
  }
});
$c_scm_HashMap.prototype.iterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$1(this))
});
$c_scm_HashMap.prototype.keysIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$2(this))
});
$c_scm_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$3(this))
});
$c_scm_HashMap.prototype.nodeIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$4(this))
});
$c_scm_HashMap.prototype.get__O__s_Option = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $m_s_None$() : new $c_s_Some($n(x1$1).scm_HashMap$Node__f__value))
});
$c_scm_HashMap.prototype.apply__O__O = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $f_sc_MapOps__default__O__O(this, key) : $n(x1$1).scm_HashMap$Node__f__value)
});
$c_scm_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
    var nd = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
    return ((nd === null) ? $n(default$1).apply__O() : $n(nd).scm_HashMap$Node__f__value)
  }
});
$c_scm_HashMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue)
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
    var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(idx);
    var nd = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
    if ((nd !== null)) {
      return $n(nd).scm_HashMap$Node__f__value
    } else {
      var table0 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
      var default$1 = $n(defaultValue).apply__O();
      if ((((1 + this.scm_HashMap__f_contentSize) | 0) >= this.scm_HashMap__f_threshold)) {
        $p_scm_HashMap__growTable__I__V(this, ($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1))
      };
      var newIdx = ((table0 === this.scm_HashMap__f_scala$collection$mutable$HashMap$$table) ? idx : (hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, newIdx);
      return default$1
    }
  }
});
$c_scm_HashMap.prototype.remove__O__s_Option = (function(key) {
  var x1 = $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, key);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some($n(x1).scm_HashMap$Node__f__value))
});
$c_scm_HashMap.prototype.update__O__O__V = (function(key, value) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, false)
});
$c_scm_HashMap.prototype.addOne__T2__scm_HashMap = (function(elem) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, $n(elem)._1__O(), $n(elem)._2__O(), false);
  return this
});
$c_scm_HashMap.prototype.subtractOne__O__scm_HashMap = (function(elem) {
  $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, elem);
  return this
});
$c_scm_HashMap.prototype.knownSize__I = (function() {
  return this.scm_HashMap__f_contentSize
});
$c_scm_HashMap.prototype.isEmpty__Z = (function() {
  return (this.scm_HashMap__f_contentSize === 0)
});
$c_scm_HashMap.prototype.foreach__F1__V = (function(f) {
  var len = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  var i = 0;
  while ((i < len)) {
    var n = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(i);
    if ((n !== null)) {
      $n(n).foreach__F1__V(f)
    };
    i = ((1 + i) | 0)
  }
});
$c_scm_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  var len = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  var i = 0;
  while ((i < len)) {
    var n = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(i);
    if ((n !== null)) {
      $n(n).foreachEntry__F2__V(f)
    };
    i = ((1 + i) | 0)
  }
});
$c_scm_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_HashMap$()
});
$c_scm_HashMap.prototype.stringPrefix__T = (function() {
  return "HashMap"
});
$c_scm_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var tupleHashIterator = new $c_scm_HashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed)
  }
});
$c_scm_HashMap.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_HashMap(elem)
});
$c_scm_HashMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_HashMap($as_T2(elem))
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_HashMap(xs)
});
function $as_scm_HashMap(obj) {
  return (((obj instanceof $c_scm_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap"))
}
function $isArrayOf_scm_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap)))
}
function $asArrayOf_scm_HashMap(obj, depth) {
  return (($isArrayOf_scm_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap;", depth))
}
var $d_scm_HashMap = new $TypeData().initClass({
  scm_HashMap: 0
}, false, "scala.collection.mutable.HashMap", {
  scm_HashMap: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedMapOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashMap.prototype.$classData = $d_scm_HashMap;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper() {
  /*<skip>*/
}
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype = new $h_scm_AbstractMap();
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.size__I = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).size__I()
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.get__O__s_Option = (function(k) {
  return $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__get__O__s_Option(this, k)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.getOrElseUpdate__O__F0__O = (function(key, op) {
  return $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__getOrElseUpdate__O__F0__O(this, key, op)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.update__O__O__V = (function(k, v) {
  $n(this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).put__O__O__O(k, v)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.updateWith__O__F1__s_Option = (function(key, remappingFunction) {
  return $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__updateWith__O__F1__s_Option(this, key, remappingFunction)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.remove__O__s_Option = (function(k) {
  return $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__remove__O__s_Option(this, k)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5(this)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__foreachEntry__F2__V(this, f)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__subtractOne__O__sc_convert_JavaCollectionWrappers$JMapWrapperLike(this, elem)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.addOne__O__scm_Growable = (function(elem) {
  var kv = $as_T2(elem);
  return $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__addOne__T2__sc_convert_JavaCollectionWrappers$JMapWrapperLike(this, kv)
});
function $ct_sci_BigVector__AO__AO__I__($thiz, _prefix1, suffix1, length0) {
  $thiz.sci_BigVector__f_suffix1 = suffix1;
  $thiz.sci_BigVector__f_length0 = length0;
  $ct_sci_Vector__AO__($thiz, _prefix1);
  return $thiz
}
/** @constructor */
function $c_sci_BigVector() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0
}
$c_sci_BigVector.prototype = new $h_sci_VectorImpl();
$c_sci_BigVector.prototype.constructor = $c_sci_BigVector;
/** @constructor */
function $h_sci_BigVector() {
  /*<skip>*/
}
$h_sci_BigVector.prototype = $c_sci_BigVector.prototype;
$c_sci_BigVector.prototype.foreachRest__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 1;
  while ((i < c)) {
    var $$x1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $n($$x1).foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0)
  }
});
function $as_sci_BigVector(obj) {
  return (((obj instanceof $c_sci_BigVector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BigVector"))
}
function $isArrayOf_sci_BigVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BigVector)))
}
function $asArrayOf_sci_BigVector(obj, depth) {
  return (($isArrayOf_sci_BigVector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BigVector;", depth))
}
/** @constructor */
function $c_sci_Queue$EmptyQueue$() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null;
  $ct_sci_Queue__sci_List__sci_List__(this, $m_sci_Nil$(), $m_sci_Nil$())
}
$c_sci_Queue$EmptyQueue$.prototype = new $h_sci_Queue();
$c_sci_Queue$EmptyQueue$.prototype.constructor = $c_sci_Queue$EmptyQueue$;
/** @constructor */
function $h_sci_Queue$EmptyQueue$() {
  /*<skip>*/
}
$h_sci_Queue$EmptyQueue$.prototype = $c_sci_Queue$EmptyQueue$.prototype;
var $d_sci_Queue$EmptyQueue$ = new $TypeData().initClass({
  sci_Queue$EmptyQueue$: 0
}, false, "scala.collection.immutable.Queue$EmptyQueue$", {
  sci_Queue$EmptyQueue$: 1,
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Queue$EmptyQueue$.prototype.$classData = $d_sci_Queue$EmptyQueue$;
var $n_sci_Queue$EmptyQueue$;
function $m_sci_Queue$EmptyQueue$() {
  if ((!$n_sci_Queue$EmptyQueue$)) {
    $n_sci_Queue$EmptyQueue$ = new $c_sci_Queue$EmptyQueue$()
  };
  return $n_sci_Queue$EmptyQueue$
}
/** @constructor */
function $c_sci_Vector1(_data1) {
  this.sci_Vector__f_prefix1 = null;
  $ct_sci_Vector__AO__(this, _data1)
}
$c_sci_Vector1.prototype = new $h_sci_VectorImpl();
$c_sci_Vector1.prototype.constructor = $c_sci_Vector1;
/** @constructor */
function $h_sci_Vector1() {
  /*<skip>*/
}
$h_sci_Vector1.prototype = $c_sci_Vector1.prototype;
$c_sci_Vector1.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < $n(this.sci_Vector__f_prefix1).u.length))) {
    return $n(this.sci_Vector__f_prefix1).get(index)
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector1.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < $n(this.sci_Vector__f_prefix1).u.length))) {
    var a1 = this.sci_Vector__f_prefix1;
    var this$2 = $n(a1);
    var a1c = $n(this$2).clone__O();
    $n(a1c).set(index, elem);
    return new $c_sci_Vector1(a1c)
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector1.prototype.appended__O__sci_Vector = (function(elem) {
  var len1 = $n(this.sci_Vector__f_prefix1).u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_Vector__f_prefix1, elem))
  } else {
    var $$x2 = this.sci_Vector__f_prefix1;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    return new $c_sci_Vector2($$x2, 32, $$x1, a, 33)
  }
});
$c_sci_Vector1.prototype.prepended__O__sci_Vector = (function(elem) {
  var len1 = $n(this.sci_Vector__f_prefix1).u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1))
  } else {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    return new $c_sci_Vector2(a, 1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2, this.sci_Vector__f_prefix1, ((1 + len1) | 0))
  }
});
$c_sci_Vector1.prototype.map__F1__sci_Vector = (function(f) {
  return new $c_sci_Vector1($m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f))
});
$c_sci_Vector1.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var original = this.sci_Vector__f_prefix1;
  return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, lo, hi))
});
$c_sci_Vector1.prototype.tail__sci_Vector = (function() {
  if (($n(this.sci_Vector__f_prefix1).u.length === 1)) {
    return $m_sci_Vector0$()
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to))
  }
});
$c_sci_Vector1.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_Vector__f_prefix1).u.length === 1)) {
    return $m_sci_Vector0$()
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = (((-1) + $n(a).u.length) | 0);
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to))
  }
});
$c_sci_Vector1.prototype.vectorSliceCount__I = (function() {
  return 1
});
$c_sci_Vector1.prototype.vectorSlice__I__AO = (function(idx) {
  return this.sci_Vector__f_prefix1
});
$c_sci_Vector1.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var data1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, suffix);
  return ((data1b !== null) ? new $c_sci_Vector1(data1b) : $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k))
});
$c_sci_Vector1.prototype.init__O = (function() {
  return this.init__sci_Vector()
});
$c_sci_Vector1.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector1.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector1.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem)
});
$c_sci_Vector1.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector1.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem)
});
$c_sci_Vector1.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < $n(this.sci_Vector__f_prefix1).u.length))) {
    return $n(this.sci_Vector__f_prefix1).get(index)
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
function $as_sci_Vector1(obj) {
  return (((obj instanceof $c_sci_Vector1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector1"))
}
function $isArrayOf_sci_Vector1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector1)))
}
function $asArrayOf_sci_Vector1(obj, depth) {
  return (($isArrayOf_sci_Vector1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector1;", depth))
}
var $d_sci_Vector1 = new $TypeData().initClass({
  sci_Vector1: 0
}, false, "scala.collection.immutable.Vector1", {
  sci_Vector1: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector1.prototype.$classData = $d_sci_Vector1;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JMapWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying = underlying
}
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype = new $h_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper();
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JMapWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JMapWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype.isEmpty__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).isEmpty__Z()
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype.knownSize__I = (function() {
  return ($n(this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying).isEmpty__Z() ? 0 : (-1))
});
function $as_sc_convert_JavaCollectionWrappers$JMapWrapper(obj) {
  return (((obj instanceof $c_sc_convert_JavaCollectionWrappers$JMapWrapper) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$JMapWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$JMapWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$JMapWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$JMapWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$JMapWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$JMapWrapper;", depth))
}
var $d_sc_convert_JavaCollectionWrappers$JMapWrapper = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JMapWrapper: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JMapWrapper", {
  sc_convert_JavaCollectionWrappers$JMapWrapper: 1,
  sc_convert_JavaCollectionWrappers$AbstractJMapWrapper: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_convert_JavaCollectionWrappers$JMapWrapperLike: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JMapWrapper;
/** @constructor */
function $c_sci_$colon$colon(head, next) {
  this.sci_$colon$colon__f_head = null;
  this.sci_$colon$colon__f_next = null;
  this.sci_$colon$colon__f_head = head;
  this.sci_$colon$colon__f_next = next
}
$c_sci_$colon$colon.prototype = new $h_sci_List();
$c_sci_$colon$colon.prototype.constructor = $c_sci_$colon$colon;
/** @constructor */
function $h_sci_$colon$colon() {
  /*<skip>*/
}
$h_sci_$colon$colon.prototype = $c_sci_$colon$colon.prototype;
$c_sci_$colon$colon.prototype.head__O = (function() {
  return this.sci_$colon$colon__f_head
});
$c_sci_$colon$colon.prototype.productPrefix__T = (function() {
  return "::"
});
$c_sci_$colon$colon.prototype.productArity__I = (function() {
  return 2
});
$c_sci_$colon$colon.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_$colon$colon__f_head;
      break
    }
    case 1: {
      return this.sci_$colon$colon__f_next;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_sci_$colon$colon.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sci_$colon$colon.prototype.tail__O = (function() {
  return this.sci_$colon$colon__f_next
});
$c_sci_$colon$colon.prototype.headOption__s_Option = (function() {
  return new $c_s_Some(this.sci_$colon$colon__f_head)
});
function $as_sci_$colon$colon(obj) {
  return (((obj instanceof $c_sci_$colon$colon) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.$colon$colon"))
}
function $isArrayOf_sci_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_$colon$colon)))
}
function $asArrayOf_sci_$colon$colon(obj, depth) {
  return (($isArrayOf_sci_$colon$colon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.$colon$colon;", depth))
}
var $d_sci_$colon$colon = new $TypeData().initClass({
  sci_$colon$colon: 0
}, false, "scala.collection.immutable.$colon$colon", {
  sci_$colon$colon: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_$colon$colon.prototype.$classData = $d_sci_$colon$colon;
/** @constructor */
function $c_sci_Nil$() {
  $n_sci_Nil$ = this;
  $ct_T2__O__O__(new $c_T2(), $m_sci_Nil$(), $m_sci_Nil$())
}
$c_sci_Nil$.prototype = new $h_sci_List();
$c_sci_Nil$.prototype.constructor = $c_sci_Nil$;
/** @constructor */
function $h_sci_Nil$() {
  /*<skip>*/
}
$h_sci_Nil$.prototype = $c_sci_Nil$.prototype;
$c_sci_Nil$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty list")
});
$c_sci_Nil$.prototype.tail__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty list")
});
$c_sci_Nil$.prototype.last__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty list")
});
$c_sci_Nil$.prototype.init__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "init of empty list")
});
$c_sci_Nil$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Nil$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Nil$.prototype.productPrefix__T = (function() {
  return "Nil"
});
$c_sci_Nil$.prototype.productArity__I = (function() {
  return 0
});
$c_sci_Nil$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_sci_Nil$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sci_Nil$.prototype.init__O = (function() {
  this.init__E()
});
$c_sci_Nil$.prototype.last__O = (function() {
  this.last__E()
});
$c_sci_Nil$.prototype.tail__O = (function() {
  this.tail__E()
});
$c_sci_Nil$.prototype.headOption__s_Option = (function() {
  return $m_s_None$()
});
$c_sci_Nil$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_Nil$ = new $TypeData().initClass({
  sci_Nil$: 0
}, false, "scala.collection.immutable.Nil$", {
  sci_Nil$: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_Nil$.prototype.$classData = $d_sci_Nil$;
var $n_sci_Nil$;
function $m_sci_Nil$() {
  if ((!$n_sci_Nil$)) {
    $n_sci_Nil$ = new $c_sci_Nil$()
  };
  return $n_sci_Nil$
}
function $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet($thiz, t) {
  return ((t === $thiz.sci_TreeSet__f_tree) ? $thiz : $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, $thiz.sci_TreeSet__f_ordering))
}
function $p_sci_TreeSet__countWhile__F1__I($thiz, p) {
  var result = 0;
  $m_sci_RedBlackTree$();
  var tree = $thiz.sci_TreeSet__f_tree;
  $m_sci_RedBlackTree$();
  var start = $m_s_None$();
  var evidence$17 = $thiz.sci_TreeSet__f_ordering;
  var it = new $c_sci_RedBlackTree$KeysIterator(tree, start, evidence$17);
  while ((it.hasNext__Z() && $uZ($n(p).apply__O__O(it.next__O())))) {
    result = ((1 + result) | 0)
  };
  return result
}
function $p_sci_TreeSet__sub$lzycompute$1__sr_LazyRef__sci_TreeSet$sub$1$($thiz, sub$module$1) {
  $n(sub$module$1);
  return ($n(sub$module$1).sr_LazyRef__f__initialized ? $as_sci_TreeSet$sub$1$($n(sub$module$1).sr_LazyRef__f__value) : $as_sci_TreeSet$sub$1$($n(sub$module$1).initialize__O__O(new $c_sci_TreeSet$sub$1$($thiz))))
}
function $p_sci_TreeSet__sub$2__sr_LazyRef__sci_TreeSet$sub$1$($thiz, sub$module$1) {
  return ($n(sub$module$1).sr_LazyRef__f__initialized ? $as_sci_TreeSet$sub$1$($n(sub$module$1).sr_LazyRef__f__value) : $p_sci_TreeSet__sub$lzycompute$1__sr_LazyRef__sci_TreeSet$sub$1$($thiz, sub$module$1))
}
function $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, tree, ordering) {
  $thiz.sci_TreeSet__f_tree = tree;
  $thiz.sci_TreeSet__f_ordering = ordering;
  if ((ordering === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "ordering must not be null")
  };
  return $thiz
}
function $ct_sci_TreeSet__s_math_Ordering__($thiz, ordering) {
  $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, null, ordering);
  return $thiz
}
/** @constructor */
function $c_sci_TreeSet() {
  this.sci_TreeSet__f_tree = null;
  this.sci_TreeSet__f_ordering = null
}
$c_sci_TreeSet.prototype = new $h_sci_AbstractSet();
$c_sci_TreeSet.prototype.constructor = $c_sci_TreeSet;
/** @constructor */
function $h_sci_TreeSet() {
  /*<skip>*/
}
$h_sci_TreeSet.prototype = $c_sci_TreeSet.prototype;
$c_sci_TreeSet.prototype.map__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet(this, f, ev)
});
$c_sci_TreeSet.prototype.flatMap__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $f_sc_StrictOptimizedSortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet(this, f, ev)
});
$c_sci_TreeSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_TreeSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_TreeSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_TreeSet.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_TreeSet.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sci_TreeSet.prototype.stringPrefix__T = (function() {
  return "SortedSet"
});
$c_sci_TreeSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  var evidence$12 = this.sci_TreeSet__f_ordering;
  return new $c_sci_TreeSet$TreeSetBuilder(evidence$12)
});
$c_sci_TreeSet.prototype.ordering__s_math_Ordering = (function() {
  return this.sci_TreeSet__f_ordering
});
$c_sci_TreeSet.prototype.size__I = (function() {
  return $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree)
});
$c_sci_TreeSet.prototype.isEmpty__Z = (function() {
  return ($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree) === 0)
});
$c_sci_TreeSet.prototype.head__O = (function() {
  var this$1 = $n($m_sci_RedBlackTree$().smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree));
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key
});
$c_sci_TreeSet.prototype.last__O = (function() {
  var this$1 = $n($m_sci_RedBlackTree$().greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree));
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key
});
$c_sci_TreeSet.prototype.tail__sci_TreeSet = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree), this.sci_TreeSet__f_ordering)
});
$c_sci_TreeSet.prototype.drop__I__sci_TreeSet = (function(n) {
  if ((n <= 0)) {
    return this
  } else if ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree))) {
    var evidence$6 = this.sci_TreeSet__f_ordering;
    return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6)
  } else {
    return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, n, this.sci_TreeSet__f_ordering), this.sci_TreeSet__f_ordering)
  }
});
$c_sci_TreeSet.prototype.take__I__sci_TreeSet = (function(n) {
  if ((n <= 0)) {
    var evidence$6 = this.sci_TreeSet__f_ordering;
    return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6)
  } else {
    return ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree)) ? this : $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, n, this.sci_TreeSet__f_ordering), this.sci_TreeSet__f_ordering))
  }
});
$c_sci_TreeSet.prototype.dropRight__I__sci_TreeSet = (function(n) {
  return this.take__I__sci_TreeSet((($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree) - ((n > 0) ? n : 0)) | 0))
});
$c_sci_TreeSet.prototype.dropWhile__F1__sci_TreeSet = (function(p) {
  return this.drop__I__sci_TreeSet($p_sci_TreeSet__countWhile__F1__I(this, p))
});
$c_sci_TreeSet.prototype.takeWhile__F1__sci_TreeSet = (function(p) {
  return this.take__I__sci_TreeSet($p_sci_TreeSet__countWhile__F1__I(this, p))
});
$c_sci_TreeSet.prototype.foreach__F1__V = (function(f) {
  $m_sci_RedBlackTree$().foreachKey__sci_RedBlackTree$Tree__F1__V(this.sci_TreeSet__f_tree, f)
});
$c_sci_TreeSet.prototype.iterator__sc_Iterator = (function() {
  $m_sci_RedBlackTree$();
  var tree = this.sci_TreeSet__f_tree;
  $m_sci_RedBlackTree$();
  var start = $m_s_None$();
  var evidence$17 = this.sci_TreeSet__f_ordering;
  return new $c_sci_RedBlackTree$KeysIterator(tree, start, evidence$17)
});
$c_sci_TreeSet.prototype.contains__O__Z = (function(elem) {
  return $m_sci_RedBlackTree$().contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering)
});
$c_sci_TreeSet.prototype.incl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, null, false, this.sci_TreeSet__f_ordering))
});
$c_sci_TreeSet.prototype.excl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering))
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sci_TreeSet = (function(that) {
  matchEnd4: {
    var t$2;
    if ((that instanceof $c_sci_TreeSet)) {
      var x2 = $as_sci_TreeSet(that);
      var x = this.sci_TreeSet__f_ordering;
      var x$2 = $n(x2).sci_TreeSet__f_ordering;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var t$2 = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, $n(x2).sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering);
        break matchEnd4
      }
    };
    var it = $n(that).iterator__sc_Iterator();
    var t = this.sci_TreeSet__f_tree;
    while ($n(it).hasNext__Z()) {
      t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, $n(it).next__O(), null, false, this.sci_TreeSet__f_ordering)
    };
    var t$2 = t
  };
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, t$2)
});
$c_sci_TreeSet.prototype.removedAll__sc_IterableOnce__sci_TreeSet = (function(that) {
  if ((that instanceof $c_sci_TreeSet)) {
    var x2 = $as_sci_TreeSet(that);
    var x = this.sci_TreeSet__f_ordering;
    var x$2 = $n(x2).sci_TreeSet__f_ordering;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().difference__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, $n(x2).sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering))
    }
  };
  var sub$module = new $c_sr_LazyRef();
  var this$1 = $n($n(that).iterator__sc_Iterator());
  var f = $p_sci_TreeSet__sub$2__sr_LazyRef__sci_TreeSet$sub$1$(this, sub$module);
  $f_sc_IterableOnceOps__foreach__F1__V(this$1, f);
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $n($p_sci_TreeSet__sub$2__sr_LazyRef__sci_TreeSet$sub$1$(this, sub$module)).sci_TreeSet$sub$1$__f_currentTree)
});
$c_sci_TreeSet.prototype.filter__F1__sci_TreeSet = (function(f) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().filterEntries__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, new $c_sjsr_AnonFunction2(((k$2, x$13$2) => $uZ($n(f).apply__O__O(k$2))))))
});
$c_sci_TreeSet.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_sci_TreeSet)) {
    var x2 = $as_sci_TreeSet(obj);
    var x = this.sci_TreeSet__f_ordering;
    var x$2 = $n(x2).sci_TreeSet__f_ordering;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return $m_sci_RedBlackTree$().keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z(this.sci_TreeSet__f_tree, $n(x2).sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering)
    }
  };
  return $f_sc_SortedSet__equals__O__Z(this, obj)
});
$c_sci_TreeSet.prototype.className__T = (function() {
  return "TreeSet"
});
$c_sci_TreeSet.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sc_SortedSetOps$WithFilter(this, p)
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5)
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5)
});
$c_sci_TreeSet.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_TreeSet(pred)
});
$c_sci_TreeSet.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return this.removedAll__sc_IterableOnce__sci_TreeSet(that)
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_TreeSet(that)
});
$c_sci_TreeSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_TreeSet(elem)
});
$c_sci_TreeSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_TreeSet(elem)
});
$c_sci_TreeSet.prototype.takeWhile__F1__O = (function(p) {
  return this.takeWhile__F1__sci_TreeSet(p)
});
$c_sci_TreeSet.prototype.dropWhile__F1__O = (function(p) {
  return this.dropWhile__F1__sci_TreeSet(p)
});
$c_sci_TreeSet.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_TreeSet(n)
});
$c_sci_TreeSet.prototype.take__I__O = (function(n) {
  return this.take__I__sci_TreeSet(n)
});
$c_sci_TreeSet.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_TreeSet(n)
});
$c_sci_TreeSet.prototype.tail__O = (function() {
  return this.tail__sci_TreeSet()
});
$c_sci_TreeSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_sci_TreeSet$()
});
function $as_sci_TreeSet(obj) {
  return (((obj instanceof $c_sci_TreeSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSet"))
}
function $isArrayOf_sci_TreeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSet)))
}
function $asArrayOf_sci_TreeSet(obj, depth) {
  return (($isArrayOf_sci_TreeSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSet;", depth))
}
var $d_sci_TreeSet = new $TypeData().initClass({
  sci_TreeSet: 0
}, false, "scala.collection.immutable.TreeSet", {
  sci_TreeSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_TreeSet.prototype.$classData = $d_sci_TreeSet;
/** @constructor */
function $c_sci_Vector0$() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  $ct_sci_BigVector__AO__AO__I__(this, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, 0)
}
$c_sci_Vector0$.prototype = new $h_sci_BigVector();
$c_sci_Vector0$.prototype.constructor = $c_sci_Vector0$;
/** @constructor */
function $h_sci_Vector0$() {
  /*<skip>*/
}
$h_sci_Vector0$.prototype = $c_sci_Vector0$.prototype;
$c_sci_Vector0$.prototype.apply__I__E = (function(index) {
  throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
});
$c_sci_Vector0$.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
});
$c_sci_Vector0$.prototype.appended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  $n(a).set(0, elem);
  return new $c_sci_Vector1(a)
});
$c_sci_Vector0$.prototype.prepended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  $n(a).set(0, elem);
  return new $c_sci_Vector1(a)
});
$c_sci_Vector0$.prototype.tail__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.tail")
});
$c_sci_Vector0$.prototype.init__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.init")
});
$c_sci_Vector0$.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  return this
});
$c_sci_Vector0$.prototype.vectorSliceCount__I = (function() {
  return 0
});
$c_sci_Vector0$.prototype.vectorSlice__I__AO = (function(idx) {
  return null
});
$c_sci_Vector0$.prototype.equals__O__Z = (function(o) {
  return ((this === o) || ((!(o instanceof $c_sci_Vector)) && $f_sc_Seq__equals__O__Z(this, o)))
});
$c_sci_Vector0$.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(suffix)
});
$c_sci_Vector0$.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (empty vector)"))
});
$c_sci_Vector0$.prototype.init__O = (function() {
  return this.init__sci_Vector()
});
$c_sci_Vector0$.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector0$.prototype.map__F1__O = (function(f) {
  return this
});
$c_sci_Vector0$.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem)
});
$c_sci_Vector0$.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector0$.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem)
});
$c_sci_Vector0$.prototype.apply__O__O = (function(v1) {
  this.apply__I__E($uI(v1))
});
$c_sci_Vector0$.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i)
});
var $d_sci_Vector0$ = new $TypeData().initClass({
  sci_Vector0$: 0
}, false, "scala.collection.immutable.Vector0$", {
  sci_Vector0$: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector0$.prototype.$classData = $d_sci_Vector0$;
var $n_sci_Vector0$;
function $m_sci_Vector0$() {
  if ((!$n_sci_Vector0$)) {
    $n_sci_Vector0$ = new $c_sci_Vector0$()
  };
  return $n_sci_Vector0$
}
/** @constructor */
function $c_sci_Vector2(_prefix1, len1, data2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector2__f_len1 = 0;
  this.sci_Vector2__f_data2 = null;
  this.sci_Vector2__f_len1 = len1;
  this.sci_Vector2__f_data2 = data2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector2.prototype = new $h_sci_BigVector();
$c_sci_Vector2.prototype.constructor = $c_sci_Vector2;
/** @constructor */
function $h_sci_Vector2() {
  /*<skip>*/
}
$h_sci_Vector2.prototype = $c_sci_Vector2.prototype;
$c_sci_Vector2.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < $n(this.sci_Vector2__f_data2).u.length) ? $n($n(this.sci_Vector2__f_data2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get((31 & io)))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector2.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector2__f_len1)) {
      var io = ((index - this.sci_Vector2__f_len1) | 0);
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      if ((i2 < $n(this.sci_Vector2__f_data2).u.length)) {
        var a2 = this.sci_Vector2__f_data2;
        var this$2 = $n(a2);
        var a2c = $n(this$2).clone__O();
        var $$x1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$3 = $n(a1);
        var a1c = $n(this$3).clone__O();
        $n(a1c).set(i1, elem);
        $$x1.set(i2, a1c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector2__f_len1;
        var x$4 = this.sci_BigVector__f_suffix1;
        var x$5 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$2, x$3, a2c, x$4, x$5)
      } else {
        var a1$1 = this.sci_BigVector__f_suffix1;
        var this$5 = $n(a1$1);
        var a1c$1 = $n(this$5).clone__O();
        $n(a1c$1).set(i1, elem);
        var x$7 = this.sci_Vector__f_prefix1;
        var x$8 = this.sci_Vector2__f_len1;
        var x$9 = this.sci_Vector2__f_data2;
        var x$10 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$7, x$8, x$9, a1c$1, x$10)
      }
    } else {
      var a1$2 = this.sci_Vector__f_prefix1;
      var this$7 = $n(a1$2);
      var a1c$2 = $n(this$7).clone__O();
      $n(a1c$2).set(index, elem);
      var len1 = this.sci_Vector2__f_len1;
      var data2 = this.sci_Vector2__f_data2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector2(a1c$2, len1, data2, suffix1, length0)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector2.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2)
  } else if (($n(this.sci_Vector2__f_data2).u.length < 30)) {
    var x$6 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$8 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$9 = this.sci_Vector__f_prefix1;
    var x$10 = this.sci_Vector2__f_len1;
    return new $c_sci_Vector2(x$9, x$10, x$6, a, x$8)
  } else {
    var $$x5 = this.sci_Vector__f_prefix1;
    var $$x4 = this.sci_Vector2__f_len1;
    var $$x3 = this.sci_Vector2__f_data2;
    var $$x2 = this.sci_Vector2__f_len1;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = this.sci_BigVector__f_suffix1;
    var a$1 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    $n(a$1).set(0, x);
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    return new $c_sci_Vector3($$x5, $$x4, $$x3, ((960 + $$x2) | 0), $$x1, a$1, a$2, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector2.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector2__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector2__f_len1) | 0);
    var x$3 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3)
  } else if (($n(this.sci_Vector2__f_data2).u.length < 30)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$8 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector2__f_data2), 2);
    var x$9 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$10 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(a, 1, x$8, x$10, x$9)
  } else {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x = this.sci_Vector__f_prefix1;
    var a$2 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    $n(a$2).set(0, x);
    return new $c_sci_Vector3(a$1, 1, a$2, ((1 + this.sci_Vector2__f_len1) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3, this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector2.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector2__f_data2, f), 2);
  var x$3 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$4 = this.sci_Vector2__f_len1;
  var x$5 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector2(x$1, x$4, x$2, x$3, x$5)
});
$c_sci_Vector2.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector2__f_data2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector2.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector2__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector2__f_len1) | 0);
    var x$3 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector2.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2)
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector2.prototype.vectorSliceCount__I = (function() {
  return 3
});
$c_sci_Vector2.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector2__f_data2;
      break
    }
    case 2: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector2.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector2.prototype.init__O = (function() {
  return this.init__sci_Vector()
});
$c_sci_Vector2.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector2.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector2.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem)
});
$c_sci_Vector2.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector2.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem)
});
$c_sci_Vector2.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < $n(this.sci_Vector2__f_data2).u.length) ? $n($n(this.sci_Vector2__f_data2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get((31 & io)))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
function $as_sci_Vector2(obj) {
  return (((obj instanceof $c_sci_Vector2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector2"))
}
function $isArrayOf_sci_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector2)))
}
function $asArrayOf_sci_Vector2(obj, depth) {
  return (($isArrayOf_sci_Vector2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector2;", depth))
}
var $d_sci_Vector2 = new $TypeData().initClass({
  sci_Vector2: 0
}, false, "scala.collection.immutable.Vector2", {
  sci_Vector2: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector2.prototype.$classData = $d_sci_Vector2;
/** @constructor */
function $c_sci_Vector3(_prefix1, len1, prefix2, len12, data3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector3__f_len1 = 0;
  this.sci_Vector3__f_prefix2 = null;
  this.sci_Vector3__f_len12 = 0;
  this.sci_Vector3__f_data3 = null;
  this.sci_Vector3__f_suffix2 = null;
  this.sci_Vector3__f_len1 = len1;
  this.sci_Vector3__f_prefix2 = prefix2;
  this.sci_Vector3__f_len12 = len12;
  this.sci_Vector3__f_data3 = data3;
  this.sci_Vector3__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector3.prototype = new $h_sci_BigVector();
$c_sci_Vector3.prototype.constructor = $c_sci_Vector3;
/** @constructor */
function $h_sci_Vector3() {
  /*<skip>*/
}
$h_sci_Vector3.prototype = $c_sci_Vector3.prototype;
$c_sci_Vector3.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < $n(this.sci_Vector3__f_data3).u.length) ? $n($n($n(this.sci_Vector3__f_data3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector3__f_suffix2).u.length) ? $n($n(this.sci_Vector3__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)))
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return $n($n(this.sci_Vector3__f_prefix2).get(((io$2 >>> 5) | 0))).get((31 & io$2))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector3.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector3__f_len12)) {
      var io = ((index - this.sci_Vector3__f_len12) | 0);
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i3 < $n(this.sci_Vector3__f_data3).u.length)) {
        var a3 = this.sci_Vector3__f_data3;
        var this$2 = $n(a3);
        var a3c = $n(this$2).clone__O();
        var $$x2 = $n(a3c);
        var a2 = $n(a3c).get(i3);
        var this$3 = $n(a2);
        var a2c = $n(this$3).clone__O();
        var $$x1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$4 = $n(a1);
        var a1c = $n(this$4).clone__O();
        $n(a1c).set(i1, elem);
        $$x1.set(i2, a1c);
        $$x2.set(i3, a2c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector3__f_len1;
        var x$4 = this.sci_Vector3__f_prefix2;
        var x$5 = this.sci_Vector3__f_len12;
        var x$6 = this.sci_Vector3__f_suffix2;
        var x$7 = this.sci_BigVector__f_suffix1;
        var x$8 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$2, x$3, x$4, x$5, a3c, x$6, x$7, x$8)
      } else if ((i2 < $n(this.sci_Vector3__f_suffix2).u.length)) {
        var a2$1 = this.sci_Vector3__f_suffix2;
        var this$6 = $n(a2$1);
        var a2c$1 = $n(this$6).clone__O();
        var $$x3 = $n(a2c$1);
        var a1$1 = $n(a2c$1).get(i2);
        var this$7 = $n(a1$1);
        var a1c$1 = $n(this$7).clone__O();
        $n(a1c$1).set(i1, elem);
        $$x3.set(i2, a1c$1);
        var x$10 = this.sci_Vector__f_prefix1;
        var x$11 = this.sci_Vector3__f_len1;
        var x$12 = this.sci_Vector3__f_prefix2;
        var x$13 = this.sci_Vector3__f_len12;
        var x$14 = this.sci_Vector3__f_data3;
        var x$15 = this.sci_BigVector__f_suffix1;
        var x$16 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$10, x$11, x$12, x$13, x$14, a2c$1, x$15, x$16)
      } else {
        var a1$2 = this.sci_BigVector__f_suffix1;
        var this$9 = $n(a1$2);
        var a1c$2 = $n(this$9).clone__O();
        $n(a1c$2).set(i1, elem);
        var x$18 = this.sci_Vector__f_prefix1;
        var x$19 = this.sci_Vector3__f_len1;
        var x$20 = this.sci_Vector3__f_prefix2;
        var x$21 = this.sci_Vector3__f_len12;
        var x$22 = this.sci_Vector3__f_data3;
        var x$23 = this.sci_Vector3__f_suffix2;
        var x$24 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$18, x$19, x$20, x$21, x$22, x$23, a1c$2, x$24)
      }
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      var a2$2 = this.sci_Vector3__f_prefix2;
      var idx2 = ((io$2 >>> 5) | 0);
      var idx1 = (31 & io$2);
      var this$11 = $n(a2$2);
      var a2c$2 = $n(this$11).clone__O();
      var $$x4 = $n(a2c$2);
      var a1$3 = $n(a2c$2).get(idx2);
      var this$12 = $n(a1$3);
      var a1c$3 = $n(this$12).clone__O();
      $n(a1c$3).set(idx1, elem);
      $$x4.set(idx2, a1c$3);
      var x$26 = this.sci_Vector__f_prefix1;
      var x$27 = this.sci_Vector3__f_len1;
      var x$28 = this.sci_Vector3__f_len12;
      var x$29 = this.sci_Vector3__f_data3;
      var x$30 = this.sci_Vector3__f_suffix2;
      var x$31 = this.sci_BigVector__f_suffix1;
      var x$32 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(x$26, x$27, a2c$2, x$28, x$29, x$30, x$31, x$32)
    } else {
      var a1$4 = this.sci_Vector__f_prefix1;
      var this$14 = $n(a1$4);
      var a1c$4 = $n(this$14).clone__O();
      $n(a1c$4).set(index, elem);
      var len1 = this.sci_Vector3__f_len1;
      var prefix2 = this.sci_Vector3__f_prefix2;
      var len12 = this.sci_Vector3__f_len12;
      var data3 = this.sci_Vector3__f_data3;
      var suffix2 = this.sci_Vector3__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(a1c$4, len1, prefix2, len12, data3, suffix2, suffix1, length0)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector3.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2)
  } else if (($n(this.sci_Vector3__f_suffix2).u.length < 31)) {
    var x$9 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$11 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$12 = this.sci_Vector__f_prefix1;
    var x$13 = this.sci_Vector3__f_len1;
    var x$14 = this.sci_Vector3__f_prefix2;
    var x$15 = this.sci_Vector3__f_len12;
    var x$16 = this.sci_Vector3__f_data3;
    return new $c_sci_Vector3(x$12, x$13, x$14, x$15, x$16, x$9, a, x$11)
  } else if (($n(this.sci_Vector3__f_data3).u.length < 30)) {
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_data3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector3__f_len1;
    var x$23 = this.sci_Vector3__f_prefix2;
    var x$24 = this.sci_Vector3__f_len12;
    return new $c_sci_Vector3(x$21, x$22, x$23, x$24, x$17, x$18, a$1, x$20)
  } else {
    var $$x8 = this.sci_Vector__f_prefix1;
    var $$x7 = this.sci_Vector3__f_len1;
    var $$x6 = this.sci_Vector3__f_prefix2;
    var $$x5 = this.sci_Vector3__f_len12;
    var $$x4 = this.sci_Vector3__f_data3;
    var $$x3 = this.sci_Vector3__f_len12;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a$2 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$2).set(0, x);
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    return new $c_sci_Vector4($$x8, $$x7, $$x6, $$x5, $$x4, ((30720 + $$x3) | 0), $$x2, a$2, $$x1, a$3, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector3.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector3__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector3__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$4 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4)
  } else if ((this.sci_Vector3__f_len12 < 1024)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$11 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var x$12 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$13 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$14 = this.sci_Vector3__f_data3;
    var x$15 = this.sci_Vector3__f_suffix2;
    var x$16 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a, 1, x$11, x$12, x$14, x$15, x$16, x$13)
  } else if (($n(this.sci_Vector3__f_data3).u.length < 30)) {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$21 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), this.sci_Vector3__f_data3), 3);
    var x$22 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$23 = this.sci_Vector3__f_suffix2;
    var x$24 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a$1, 1, x$19, 1, x$21, x$23, x$24, x$22)
  } else {
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$3).set(0, x);
    return new $c_sci_Vector4(a$2, 1, $$x1, 1, a$3, ((1 + this.sci_Vector3__f_len12) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4, this.sci_Vector3__f_data3, this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector3.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector3__f_data3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_suffix2, f), 2);
  var x$5 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$6 = this.sci_Vector3__f_len1;
  var x$7 = this.sci_Vector3__f_len12;
  var x$8 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector3(x$1, x$6, x$2, x$7, x$3, x$4, x$5, x$8)
});
$c_sci_Vector3.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector3__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector3__f_data3);
  b.consider__I__AO__V(2, this.sci_Vector3__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector3.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector3__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector3__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector3__f_len12) | 0);
    var x$4 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector3.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2)
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector3.prototype.vectorSliceCount__I = (function() {
  return 5
});
$c_sci_Vector3.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector3__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector3__f_data3;
      break
    }
    case 3: {
      return this.sci_Vector3__f_suffix2;
      break
    }
    case 4: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector3.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector3.prototype.init__O = (function() {
  return this.init__sci_Vector()
});
$c_sci_Vector3.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector3.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector3.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem)
});
$c_sci_Vector3.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector3.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem)
});
$c_sci_Vector3.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < $n(this.sci_Vector3__f_data3).u.length) ? $n($n($n(this.sci_Vector3__f_data3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector3__f_suffix2).u.length) ? $n($n(this.sci_Vector3__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)))
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return $n($n(this.sci_Vector3__f_prefix2).get(((io$2 >>> 5) | 0))).get((31 & io$2))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
function $as_sci_Vector3(obj) {
  return (((obj instanceof $c_sci_Vector3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector3"))
}
function $isArrayOf_sci_Vector3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector3)))
}
function $asArrayOf_sci_Vector3(obj, depth) {
  return (($isArrayOf_sci_Vector3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector3;", depth))
}
var $d_sci_Vector3 = new $TypeData().initClass({
  sci_Vector3: 0
}, false, "scala.collection.immutable.Vector3", {
  sci_Vector3: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector3.prototype.$classData = $d_sci_Vector3;
/** @constructor */
function $c_sci_Vector4(_prefix1, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector4__f_len1 = 0;
  this.sci_Vector4__f_prefix2 = null;
  this.sci_Vector4__f_len12 = 0;
  this.sci_Vector4__f_prefix3 = null;
  this.sci_Vector4__f_len123 = 0;
  this.sci_Vector4__f_data4 = null;
  this.sci_Vector4__f_suffix3 = null;
  this.sci_Vector4__f_suffix2 = null;
  this.sci_Vector4__f_len1 = len1;
  this.sci_Vector4__f_prefix2 = prefix2;
  this.sci_Vector4__f_len12 = len12;
  this.sci_Vector4__f_prefix3 = prefix3;
  this.sci_Vector4__f_len123 = len123;
  this.sci_Vector4__f_data4 = data4;
  this.sci_Vector4__f_suffix3 = suffix3;
  this.sci_Vector4__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector4.prototype = new $h_sci_BigVector();
$c_sci_Vector4.prototype.constructor = $c_sci_Vector4;
/** @constructor */
function $h_sci_Vector4() {
  /*<skip>*/
}
$h_sci_Vector4.prototype = $c_sci_Vector4.prototype;
$c_sci_Vector4.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < $n(this.sci_Vector4__f_data4).u.length) ? $n($n($n($n(this.sci_Vector4__f_data4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector4__f_suffix3).u.length) ? $n($n($n(this.sci_Vector4__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector4__f_suffix2).u.length) ? $n($n(this.sci_Vector4__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))))
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return $n($n($n(this.sci_Vector4__f_prefix3).get(((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2))
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return $n($n(this.sci_Vector4__f_prefix2).get(((io$3 >>> 5) | 0))).get((31 & io$3))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector4.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector4__f_len123)) {
      var io = ((index - this.sci_Vector4__f_len123) | 0);
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i4 < $n(this.sci_Vector4__f_data4).u.length)) {
        var a4 = this.sci_Vector4__f_data4;
        var this$2 = $n(a4);
        var a4c = $n(this$2).clone__O();
        var $$x3 = $n(a4c);
        var a3 = $n(a4c).get(i4);
        var this$3 = $n(a3);
        var a3c = $n(this$3).clone__O();
        var $$x2 = $n(a3c);
        var a2 = $n(a3c).get(i3);
        var this$4 = $n(a2);
        var a2c = $n(this$4).clone__O();
        var $$x1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$5 = $n(a1);
        var a1c = $n(this$5).clone__O();
        $n(a1c).set(i1, elem);
        $$x1.set(i2, a1c);
        $$x2.set(i3, a2c);
        $$x3.set(i4, a3c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector4__f_len1;
        var x$4 = this.sci_Vector4__f_prefix2;
        var x$5 = this.sci_Vector4__f_len12;
        var x$6 = this.sci_Vector4__f_prefix3;
        var x$7 = this.sci_Vector4__f_len123;
        var x$8 = this.sci_Vector4__f_suffix3;
        var x$9 = this.sci_Vector4__f_suffix2;
        var x$10 = this.sci_BigVector__f_suffix1;
        var x$11 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$2, x$3, x$4, x$5, x$6, x$7, a4c, x$8, x$9, x$10, x$11)
      } else if ((i3 < $n(this.sci_Vector4__f_suffix3).u.length)) {
        var a3$1 = this.sci_Vector4__f_suffix3;
        var this$7 = $n(a3$1);
        var a3c$1 = $n(this$7).clone__O();
        var $$x5 = $n(a3c$1);
        var a2$1 = $n(a3c$1).get(i3);
        var this$8 = $n(a2$1);
        var a2c$1 = $n(this$8).clone__O();
        var $$x4 = $n(a2c$1);
        var a1$1 = $n(a2c$1).get(i2);
        var this$9 = $n(a1$1);
        var a1c$1 = $n(this$9).clone__O();
        $n(a1c$1).set(i1, elem);
        $$x4.set(i2, a1c$1);
        $$x5.set(i3, a2c$1);
        var x$13 = this.sci_Vector__f_prefix1;
        var x$14 = this.sci_Vector4__f_len1;
        var x$15 = this.sci_Vector4__f_prefix2;
        var x$16 = this.sci_Vector4__f_len12;
        var x$17 = this.sci_Vector4__f_prefix3;
        var x$18 = this.sci_Vector4__f_len123;
        var x$19 = this.sci_Vector4__f_data4;
        var x$20 = this.sci_Vector4__f_suffix2;
        var x$21 = this.sci_BigVector__f_suffix1;
        var x$22 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$13, x$14, x$15, x$16, x$17, x$18, x$19, a3c$1, x$20, x$21, x$22)
      } else if ((i2 < $n(this.sci_Vector4__f_suffix2).u.length)) {
        var a2$2 = this.sci_Vector4__f_suffix2;
        var this$11 = $n(a2$2);
        var a2c$2 = $n(this$11).clone__O();
        var $$x6 = $n(a2c$2);
        var a1$2 = $n(a2c$2).get(i2);
        var this$12 = $n(a1$2);
        var a1c$2 = $n(this$12).clone__O();
        $n(a1c$2).set(i1, elem);
        $$x6.set(i2, a1c$2);
        var x$24 = this.sci_Vector__f_prefix1;
        var x$25 = this.sci_Vector4__f_len1;
        var x$26 = this.sci_Vector4__f_prefix2;
        var x$27 = this.sci_Vector4__f_len12;
        var x$28 = this.sci_Vector4__f_prefix3;
        var x$29 = this.sci_Vector4__f_len123;
        var x$30 = this.sci_Vector4__f_data4;
        var x$31 = this.sci_Vector4__f_suffix3;
        var x$32 = this.sci_BigVector__f_suffix1;
        var x$33 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, a2c$2, x$32, x$33)
      } else {
        var a1$3 = this.sci_BigVector__f_suffix1;
        var this$14 = $n(a1$3);
        var a1c$3 = $n(this$14).clone__O();
        $n(a1c$3).set(i1, elem);
        var x$35 = this.sci_Vector__f_prefix1;
        var x$36 = this.sci_Vector4__f_len1;
        var x$37 = this.sci_Vector4__f_prefix2;
        var x$38 = this.sci_Vector4__f_len12;
        var x$39 = this.sci_Vector4__f_prefix3;
        var x$40 = this.sci_Vector4__f_len123;
        var x$41 = this.sci_Vector4__f_data4;
        var x$42 = this.sci_Vector4__f_suffix3;
        var x$43 = this.sci_Vector4__f_suffix2;
        var x$44 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, a1c$3, x$44)
      }
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      var a3$2 = this.sci_Vector4__f_prefix3;
      var idx3 = ((io$2 >>> 10) | 0);
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var this$16 = $n(a3$2);
      var a3c$2 = $n(this$16).clone__O();
      var $$x8 = $n(a3c$2);
      var a2$3 = $n(a3c$2).get(idx3);
      var this$17 = $n(a2$3);
      var a2c$3 = $n(this$17).clone__O();
      var $$x7 = $n(a2c$3);
      var a1$4 = $n(a2c$3).get(idx2);
      var this$18 = $n(a1$4);
      var a1c$4 = $n(this$18).clone__O();
      $n(a1c$4).set(idx1, elem);
      $$x7.set(idx2, a1c$4);
      $$x8.set(idx3, a2c$3);
      var x$46 = this.sci_Vector__f_prefix1;
      var x$47 = this.sci_Vector4__f_len1;
      var x$48 = this.sci_Vector4__f_prefix2;
      var x$49 = this.sci_Vector4__f_len12;
      var x$50 = this.sci_Vector4__f_len123;
      var x$51 = this.sci_Vector4__f_data4;
      var x$52 = this.sci_Vector4__f_suffix3;
      var x$53 = this.sci_Vector4__f_suffix2;
      var x$54 = this.sci_BigVector__f_suffix1;
      var x$55 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$46, x$47, x$48, x$49, a3c$2, x$50, x$51, x$52, x$53, x$54, x$55)
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      var a2$4 = this.sci_Vector4__f_prefix2;
      var idx2$1 = ((io$3 >>> 5) | 0);
      var idx1$1 = (31 & io$3);
      var this$20 = $n(a2$4);
      var a2c$4 = $n(this$20).clone__O();
      var $$x9 = $n(a2c$4);
      var a1$5 = $n(a2c$4).get(idx2$1);
      var this$21 = $n(a1$5);
      var a1c$5 = $n(this$21).clone__O();
      $n(a1c$5).set(idx1$1, elem);
      $$x9.set(idx2$1, a1c$5);
      var x$57 = this.sci_Vector__f_prefix1;
      var x$58 = this.sci_Vector4__f_len1;
      var x$59 = this.sci_Vector4__f_len12;
      var x$60 = this.sci_Vector4__f_prefix3;
      var x$61 = this.sci_Vector4__f_len123;
      var x$62 = this.sci_Vector4__f_data4;
      var x$63 = this.sci_Vector4__f_suffix3;
      var x$64 = this.sci_Vector4__f_suffix2;
      var x$65 = this.sci_BigVector__f_suffix1;
      var x$66 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$57, x$58, a2c$4, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66)
    } else {
      var a1$6 = this.sci_Vector__f_prefix1;
      var this$23 = $n(a1$6);
      var a1c$6 = $n(this$23).clone__O();
      $n(a1c$6).set(index, elem);
      var len1 = this.sci_Vector4__f_len1;
      var prefix2 = this.sci_Vector4__f_prefix2;
      var len12 = this.sci_Vector4__f_len12;
      var prefix3 = this.sci_Vector4__f_prefix3;
      var len123 = this.sci_Vector4__f_len123;
      var data4 = this.sci_Vector4__f_data4;
      var suffix3 = this.sci_Vector4__f_suffix3;
      var suffix2 = this.sci_Vector4__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(a1c$6, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector4.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2)
  } else if (($n(this.sci_Vector4__f_suffix2).u.length < 31)) {
    var x$12 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$14 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$15 = this.sci_Vector__f_prefix1;
    var x$16 = this.sci_Vector4__f_len1;
    var x$17 = this.sci_Vector4__f_prefix2;
    var x$18 = this.sci_Vector4__f_len12;
    var x$19 = this.sci_Vector4__f_prefix3;
    var x$20 = this.sci_Vector4__f_len123;
    var x$21 = this.sci_Vector4__f_data4;
    var x$22 = this.sci_Vector4__f_suffix3;
    return new $c_sci_Vector4(x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$12, a, x$14)
  } else if (($n(this.sci_Vector4__f_suffix3).u.length < 31)) {
    var x$23 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$26 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$27 = this.sci_Vector__f_prefix1;
    var x$28 = this.sci_Vector4__f_len1;
    var x$29 = this.sci_Vector4__f_prefix2;
    var x$30 = this.sci_Vector4__f_len12;
    var x$31 = this.sci_Vector4__f_prefix3;
    var x$32 = this.sci_Vector4__f_len123;
    var x$33 = this.sci_Vector4__f_data4;
    return new $c_sci_Vector4(x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$23, x$24, a$1, x$26)
  } else if (($n(this.sci_Vector4__f_data4).u.length < 30)) {
    var x$34 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_data4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$35 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector4__f_len1;
    var x$41 = this.sci_Vector4__f_prefix2;
    var x$42 = this.sci_Vector4__f_len12;
    var x$43 = this.sci_Vector4__f_prefix3;
    var x$44 = this.sci_Vector4__f_len123;
    return new $c_sci_Vector4(x$39, x$40, x$41, x$42, x$43, x$44, x$34, x$35, x$36, a$2, x$38)
  } else {
    var $$x11 = this.sci_Vector__f_prefix1;
    var $$x10 = this.sci_Vector4__f_len1;
    var $$x9 = this.sci_Vector4__f_prefix2;
    var $$x8 = this.sci_Vector4__f_len12;
    var $$x7 = this.sci_Vector4__f_prefix3;
    var $$x6 = this.sci_Vector4__f_len123;
    var $$x5 = this.sci_Vector4__f_data4;
    var $$x4 = this.sci_Vector4__f_len123;
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$3).set(0, x);
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    $n(a$4).set(0, elem);
    return new $c_sci_Vector5($$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, ((983040 + $$x4) | 0), $$x3, a$3, $$x2, $$x1, a$4, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector4.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector4__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector4__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$5 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5)
  } else if ((this.sci_Vector4__f_len12 < 1024)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$14 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), 2);
    var x$15 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$16 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector4__f_prefix3;
    var x$19 = this.sci_Vector4__f_data4;
    var x$20 = this.sci_Vector4__f_suffix3;
    var x$21 = this.sci_Vector4__f_suffix2;
    var x$22 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a, 1, x$14, x$15, x$18, x$16, x$19, x$20, x$21, x$22, x$17)
  } else if ((this.sci_Vector4__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$27 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var x$28 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$29 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$30 = this.sci_Vector4__f_data4;
    var x$31 = this.sci_Vector4__f_suffix3;
    var x$32 = this.sci_Vector4__f_suffix2;
    var x$33 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$1, 1, x$25, 1, x$27, x$28, x$30, x$31, x$32, x$33, x$29)
  } else if (($n(this.sci_Vector4__f_data4).u.length < 30)) {
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$38 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$40 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), this.sci_Vector4__f_data4), 4);
    var x$41 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$42 = this.sci_Vector4__f_suffix3;
    var x$43 = this.sci_Vector4__f_suffix2;
    var x$44 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$2, 1, x$36, 1, x$38, 1, x$40, x$42, x$43, x$44, x$41)
  } else {
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$4).set(0, x);
    return new $c_sci_Vector5(a$3, 1, $$x2, 1, $$x1, 1, a$4, ((1 + this.sci_Vector4__f_len123) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5, this.sci_Vector4__f_data4, this.sci_Vector4__f_suffix3, this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector4.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector4__f_data4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_suffix3, f), 3);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_suffix2, f), 2);
  var x$7 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$8 = this.sci_Vector4__f_len1;
  var x$9 = this.sci_Vector4__f_len12;
  var x$10 = this.sci_Vector4__f_len123;
  var x$11 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector4(x$1, x$8, x$2, x$9, x$3, x$10, x$4, x$5, x$6, x$7, x$11)
});
$c_sci_Vector4.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector4__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector4__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector4__f_data4);
  b.consider__I__AO__V(3, this.sci_Vector4__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector4__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector4.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector4__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector4__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector4__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector4__f_len123) | 0);
    var x$5 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector4.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2)
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector4.prototype.vectorSliceCount__I = (function() {
  return 7
});
$c_sci_Vector4.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector4__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector4__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector4__f_data4;
      break
    }
    case 4: {
      return this.sci_Vector4__f_suffix3;
      break
    }
    case 5: {
      return this.sci_Vector4__f_suffix2;
      break
    }
    case 6: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector4.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector4.prototype.init__O = (function() {
  return this.init__sci_Vector()
});
$c_sci_Vector4.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector4.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector4.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem)
});
$c_sci_Vector4.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector4.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem)
});
$c_sci_Vector4.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < $n(this.sci_Vector4__f_data4).u.length) ? $n($n($n($n(this.sci_Vector4__f_data4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector4__f_suffix3).u.length) ? $n($n($n(this.sci_Vector4__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector4__f_suffix2).u.length) ? $n($n(this.sci_Vector4__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))))
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return $n($n($n(this.sci_Vector4__f_prefix3).get(((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2))
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return $n($n(this.sci_Vector4__f_prefix2).get(((io$3 >>> 5) | 0))).get((31 & io$3))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
function $as_sci_Vector4(obj) {
  return (((obj instanceof $c_sci_Vector4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector4"))
}
function $isArrayOf_sci_Vector4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector4)))
}
function $asArrayOf_sci_Vector4(obj, depth) {
  return (($isArrayOf_sci_Vector4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector4;", depth))
}
var $d_sci_Vector4 = new $TypeData().initClass({
  sci_Vector4: 0
}, false, "scala.collection.immutable.Vector4", {
  sci_Vector4: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector4.prototype.$classData = $d_sci_Vector4;
/** @constructor */
function $c_sci_Vector5(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector5__f_len1 = 0;
  this.sci_Vector5__f_prefix2 = null;
  this.sci_Vector5__f_len12 = 0;
  this.sci_Vector5__f_prefix3 = null;
  this.sci_Vector5__f_len123 = 0;
  this.sci_Vector5__f_prefix4 = null;
  this.sci_Vector5__f_len1234 = 0;
  this.sci_Vector5__f_data5 = null;
  this.sci_Vector5__f_suffix4 = null;
  this.sci_Vector5__f_suffix3 = null;
  this.sci_Vector5__f_suffix2 = null;
  this.sci_Vector5__f_len1 = len1;
  this.sci_Vector5__f_prefix2 = prefix2;
  this.sci_Vector5__f_len12 = len12;
  this.sci_Vector5__f_prefix3 = prefix3;
  this.sci_Vector5__f_len123 = len123;
  this.sci_Vector5__f_prefix4 = prefix4;
  this.sci_Vector5__f_len1234 = len1234;
  this.sci_Vector5__f_data5 = data5;
  this.sci_Vector5__f_suffix4 = suffix4;
  this.sci_Vector5__f_suffix3 = suffix3;
  this.sci_Vector5__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector5.prototype = new $h_sci_BigVector();
$c_sci_Vector5.prototype.constructor = $c_sci_Vector5;
/** @constructor */
function $h_sci_Vector5() {
  /*<skip>*/
}
$h_sci_Vector5.prototype = $c_sci_Vector5.prototype;
$c_sci_Vector5.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < $n(this.sci_Vector5__f_data5).u.length) ? $n($n($n($n($n(this.sci_Vector5__f_data5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector5__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector5__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector5__f_suffix3).u.length) ? $n($n($n(this.sci_Vector5__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector5__f_suffix2).u.length) ? $n($n(this.sci_Vector5__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)))))
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector5__f_prefix4).get(((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2))
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return $n($n($n(this.sci_Vector5__f_prefix3).get(((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3))
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return $n($n(this.sci_Vector5__f_prefix2).get(((io$4 >>> 5) | 0))).get((31 & io$4))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector5.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector5__f_len1234)) {
      var io = ((index - this.sci_Vector5__f_len1234) | 0);
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i5 < $n(this.sci_Vector5__f_data5).u.length)) {
        var a5 = this.sci_Vector5__f_data5;
        var this$2 = $n(a5);
        var a5c = $n(this$2).clone__O();
        var $$x4 = $n(a5c);
        var a4 = $n(a5c).get(i5);
        var this$3 = $n(a4);
        var a4c = $n(this$3).clone__O();
        var $$x3 = $n(a4c);
        var a3 = $n(a4c).get(i4);
        var this$4 = $n(a3);
        var a3c = $n(this$4).clone__O();
        var $$x2 = $n(a3c);
        var a2 = $n(a3c).get(i3);
        var this$5 = $n(a2);
        var a2c = $n(this$5).clone__O();
        var $$x1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$6 = $n(a1);
        var a1c = $n(this$6).clone__O();
        $n(a1c).set(i1, elem);
        $$x1.set(i2, a1c);
        $$x2.set(i3, a2c);
        $$x3.set(i4, a3c);
        $$x4.set(i5, a4c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector5__f_len1;
        var x$4 = this.sci_Vector5__f_prefix2;
        var x$5 = this.sci_Vector5__f_len12;
        var x$6 = this.sci_Vector5__f_prefix3;
        var x$7 = this.sci_Vector5__f_len123;
        var x$8 = this.sci_Vector5__f_prefix4;
        var x$9 = this.sci_Vector5__f_len1234;
        var x$10 = this.sci_Vector5__f_suffix4;
        var x$11 = this.sci_Vector5__f_suffix3;
        var x$12 = this.sci_Vector5__f_suffix2;
        var x$13 = this.sci_BigVector__f_suffix1;
        var x$14 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, a5c, x$10, x$11, x$12, x$13, x$14)
      } else if ((i4 < $n(this.sci_Vector5__f_suffix4).u.length)) {
        var a4$1 = this.sci_Vector5__f_suffix4;
        var this$8 = $n(a4$1);
        var a4c$1 = $n(this$8).clone__O();
        var $$x7 = $n(a4c$1);
        var a3$1 = $n(a4c$1).get(i4);
        var this$9 = $n(a3$1);
        var a3c$1 = $n(this$9).clone__O();
        var $$x6 = $n(a3c$1);
        var a2$1 = $n(a3c$1).get(i3);
        var this$10 = $n(a2$1);
        var a2c$1 = $n(this$10).clone__O();
        var $$x5 = $n(a2c$1);
        var a1$1 = $n(a2c$1).get(i2);
        var this$11 = $n(a1$1);
        var a1c$1 = $n(this$11).clone__O();
        $n(a1c$1).set(i1, elem);
        $$x5.set(i2, a1c$1);
        $$x6.set(i3, a2c$1);
        $$x7.set(i4, a3c$1);
        var x$16 = this.sci_Vector__f_prefix1;
        var x$17 = this.sci_Vector5__f_len1;
        var x$18 = this.sci_Vector5__f_prefix2;
        var x$19 = this.sci_Vector5__f_len12;
        var x$20 = this.sci_Vector5__f_prefix3;
        var x$21 = this.sci_Vector5__f_len123;
        var x$22 = this.sci_Vector5__f_prefix4;
        var x$23 = this.sci_Vector5__f_len1234;
        var x$24 = this.sci_Vector5__f_data5;
        var x$25 = this.sci_Vector5__f_suffix3;
        var x$26 = this.sci_Vector5__f_suffix2;
        var x$27 = this.sci_BigVector__f_suffix1;
        var x$28 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, a4c$1, x$25, x$26, x$27, x$28)
      } else if ((i3 < $n(this.sci_Vector5__f_suffix3).u.length)) {
        var a3$2 = this.sci_Vector5__f_suffix3;
        var this$13 = $n(a3$2);
        var a3c$2 = $n(this$13).clone__O();
        var $$x9 = $n(a3c$2);
        var a2$2 = $n(a3c$2).get(i3);
        var this$14 = $n(a2$2);
        var a2c$2 = $n(this$14).clone__O();
        var $$x8 = $n(a2c$2);
        var a1$2 = $n(a2c$2).get(i2);
        var this$15 = $n(a1$2);
        var a1c$2 = $n(this$15).clone__O();
        $n(a1c$2).set(i1, elem);
        $$x8.set(i2, a1c$2);
        $$x9.set(i3, a2c$2);
        var x$30 = this.sci_Vector__f_prefix1;
        var x$31 = this.sci_Vector5__f_len1;
        var x$32 = this.sci_Vector5__f_prefix2;
        var x$33 = this.sci_Vector5__f_len12;
        var x$34 = this.sci_Vector5__f_prefix3;
        var x$35 = this.sci_Vector5__f_len123;
        var x$36 = this.sci_Vector5__f_prefix4;
        var x$37 = this.sci_Vector5__f_len1234;
        var x$38 = this.sci_Vector5__f_data5;
        var x$39 = this.sci_Vector5__f_suffix4;
        var x$40 = this.sci_Vector5__f_suffix2;
        var x$41 = this.sci_BigVector__f_suffix1;
        var x$42 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$30, x$31, x$32, x$33, x$34, x$35, x$36, x$37, x$38, x$39, a3c$2, x$40, x$41, x$42)
      } else if ((i2 < $n(this.sci_Vector5__f_suffix2).u.length)) {
        var a2$3 = this.sci_Vector5__f_suffix2;
        var this$17 = $n(a2$3);
        var a2c$3 = $n(this$17).clone__O();
        var $$x10 = $n(a2c$3);
        var a1$3 = $n(a2c$3).get(i2);
        var this$18 = $n(a1$3);
        var a1c$3 = $n(this$18).clone__O();
        $n(a1c$3).set(i1, elem);
        $$x10.set(i2, a1c$3);
        var x$44 = this.sci_Vector__f_prefix1;
        var x$45 = this.sci_Vector5__f_len1;
        var x$46 = this.sci_Vector5__f_prefix2;
        var x$47 = this.sci_Vector5__f_len12;
        var x$48 = this.sci_Vector5__f_prefix3;
        var x$49 = this.sci_Vector5__f_len123;
        var x$50 = this.sci_Vector5__f_prefix4;
        var x$51 = this.sci_Vector5__f_len1234;
        var x$52 = this.sci_Vector5__f_data5;
        var x$53 = this.sci_Vector5__f_suffix4;
        var x$54 = this.sci_Vector5__f_suffix3;
        var x$55 = this.sci_BigVector__f_suffix1;
        var x$56 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$52, x$53, x$54, a2c$3, x$55, x$56)
      } else {
        var a1$4 = this.sci_BigVector__f_suffix1;
        var this$20 = $n(a1$4);
        var a1c$4 = $n(this$20).clone__O();
        $n(a1c$4).set(i1, elem);
        var x$58 = this.sci_Vector__f_prefix1;
        var x$59 = this.sci_Vector5__f_len1;
        var x$60 = this.sci_Vector5__f_prefix2;
        var x$61 = this.sci_Vector5__f_len12;
        var x$62 = this.sci_Vector5__f_prefix3;
        var x$63 = this.sci_Vector5__f_len123;
        var x$64 = this.sci_Vector5__f_prefix4;
        var x$65 = this.sci_Vector5__f_len1234;
        var x$66 = this.sci_Vector5__f_data5;
        var x$67 = this.sci_Vector5__f_suffix4;
        var x$68 = this.sci_Vector5__f_suffix3;
        var x$69 = this.sci_Vector5__f_suffix2;
        var x$70 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$69, a1c$4, x$70)
      }
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      var a4$2 = this.sci_Vector5__f_prefix4;
      var idx4 = ((io$2 >>> 15) | 0);
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var this$22 = $n(a4$2);
      var a4c$2 = $n(this$22).clone__O();
      var $$x13 = $n(a4c$2);
      var a3$3 = $n(a4c$2).get(idx4);
      var this$23 = $n(a3$3);
      var a3c$3 = $n(this$23).clone__O();
      var $$x12 = $n(a3c$3);
      var a2$4 = $n(a3c$3).get(idx3);
      var this$24 = $n(a2$4);
      var a2c$4 = $n(this$24).clone__O();
      var $$x11 = $n(a2c$4);
      var a1$5 = $n(a2c$4).get(idx2);
      var this$25 = $n(a1$5);
      var a1c$5 = $n(this$25).clone__O();
      $n(a1c$5).set(idx1, elem);
      $$x11.set(idx2, a1c$5);
      $$x12.set(idx3, a2c$4);
      $$x13.set(idx4, a3c$3);
      var x$72 = this.sci_Vector__f_prefix1;
      var x$73 = this.sci_Vector5__f_len1;
      var x$74 = this.sci_Vector5__f_prefix2;
      var x$75 = this.sci_Vector5__f_len12;
      var x$76 = this.sci_Vector5__f_prefix3;
      var x$77 = this.sci_Vector5__f_len123;
      var x$78 = this.sci_Vector5__f_len1234;
      var x$79 = this.sci_Vector5__f_data5;
      var x$80 = this.sci_Vector5__f_suffix4;
      var x$81 = this.sci_Vector5__f_suffix3;
      var x$82 = this.sci_Vector5__f_suffix2;
      var x$83 = this.sci_BigVector__f_suffix1;
      var x$84 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$72, x$73, x$74, x$75, x$76, x$77, a4c$2, x$78, x$79, x$80, x$81, x$82, x$83, x$84)
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      var a3$4 = this.sci_Vector5__f_prefix3;
      var idx3$1 = ((io$3 >>> 10) | 0);
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var this$27 = $n(a3$4);
      var a3c$4 = $n(this$27).clone__O();
      var $$x15 = $n(a3c$4);
      var a2$5 = $n(a3c$4).get(idx3$1);
      var this$28 = $n(a2$5);
      var a2c$5 = $n(this$28).clone__O();
      var $$x14 = $n(a2c$5);
      var a1$6 = $n(a2c$5).get(idx2$1);
      var this$29 = $n(a1$6);
      var a1c$6 = $n(this$29).clone__O();
      $n(a1c$6).set(idx1$1, elem);
      $$x14.set(idx2$1, a1c$6);
      $$x15.set(idx3$1, a2c$5);
      var x$86 = this.sci_Vector__f_prefix1;
      var x$87 = this.sci_Vector5__f_len1;
      var x$88 = this.sci_Vector5__f_prefix2;
      var x$89 = this.sci_Vector5__f_len12;
      var x$90 = this.sci_Vector5__f_len123;
      var x$91 = this.sci_Vector5__f_prefix4;
      var x$92 = this.sci_Vector5__f_len1234;
      var x$93 = this.sci_Vector5__f_data5;
      var x$94 = this.sci_Vector5__f_suffix4;
      var x$95 = this.sci_Vector5__f_suffix3;
      var x$96 = this.sci_Vector5__f_suffix2;
      var x$97 = this.sci_BigVector__f_suffix1;
      var x$98 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$86, x$87, x$88, x$89, a3c$4, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98)
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      var a2$6 = this.sci_Vector5__f_prefix2;
      var idx2$2 = ((io$4 >>> 5) | 0);
      var idx1$2 = (31 & io$4);
      var this$31 = $n(a2$6);
      var a2c$6 = $n(this$31).clone__O();
      var $$x16 = $n(a2c$6);
      var a1$7 = $n(a2c$6).get(idx2$2);
      var this$32 = $n(a1$7);
      var a1c$7 = $n(this$32).clone__O();
      $n(a1c$7).set(idx1$2, elem);
      $$x16.set(idx2$2, a1c$7);
      var x$100 = this.sci_Vector__f_prefix1;
      var x$101 = this.sci_Vector5__f_len1;
      var x$102 = this.sci_Vector5__f_len12;
      var x$103 = this.sci_Vector5__f_prefix3;
      var x$104 = this.sci_Vector5__f_len123;
      var x$105 = this.sci_Vector5__f_prefix4;
      var x$106 = this.sci_Vector5__f_len1234;
      var x$107 = this.sci_Vector5__f_data5;
      var x$108 = this.sci_Vector5__f_suffix4;
      var x$109 = this.sci_Vector5__f_suffix3;
      var x$110 = this.sci_Vector5__f_suffix2;
      var x$111 = this.sci_BigVector__f_suffix1;
      var x$112 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$100, x$101, a2c$6, x$102, x$103, x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, x$112)
    } else {
      var a1$8 = this.sci_Vector__f_prefix1;
      var this$34 = $n(a1$8);
      var a1c$8 = $n(this$34).clone__O();
      $n(a1c$8).set(index, elem);
      var len1 = this.sci_Vector5__f_len1;
      var prefix2 = this.sci_Vector5__f_prefix2;
      var len12 = this.sci_Vector5__f_len12;
      var prefix3 = this.sci_Vector5__f_prefix3;
      var len123 = this.sci_Vector5__f_len123;
      var prefix4 = this.sci_Vector5__f_prefix4;
      var len1234 = this.sci_Vector5__f_len1234;
      var data5 = this.sci_Vector5__f_data5;
      var suffix4 = this.sci_Vector5__f_suffix4;
      var suffix3 = this.sci_Vector5__f_suffix3;
      var suffix2 = this.sci_Vector5__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(a1c$8, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector5.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2)
  } else if (($n(this.sci_Vector5__f_suffix2).u.length < 31)) {
    var x$15 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector__f_prefix1;
    var x$19 = this.sci_Vector5__f_len1;
    var x$20 = this.sci_Vector5__f_prefix2;
    var x$21 = this.sci_Vector5__f_len12;
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_len123;
    var x$24 = this.sci_Vector5__f_prefix4;
    var x$25 = this.sci_Vector5__f_len1234;
    var x$26 = this.sci_Vector5__f_data5;
    var x$27 = this.sci_Vector5__f_suffix4;
    var x$28 = this.sci_Vector5__f_suffix3;
    return new $c_sci_Vector5(x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$15, a, x$17)
  } else if (($n(this.sci_Vector5__f_suffix3).u.length < 31)) {
    var x$29 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$30 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$32 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$33 = this.sci_Vector__f_prefix1;
    var x$34 = this.sci_Vector5__f_len1;
    var x$35 = this.sci_Vector5__f_prefix2;
    var x$36 = this.sci_Vector5__f_len12;
    var x$37 = this.sci_Vector5__f_prefix3;
    var x$38 = this.sci_Vector5__f_len123;
    var x$39 = this.sci_Vector5__f_prefix4;
    var x$40 = this.sci_Vector5__f_len1234;
    var x$41 = this.sci_Vector5__f_data5;
    var x$42 = this.sci_Vector5__f_suffix4;
    return new $c_sci_Vector5(x$33, x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$29, x$30, a$1, x$32)
  } else if (($n(this.sci_Vector5__f_suffix4).u.length < 31)) {
    var x$43 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$44 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$47 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$48 = this.sci_Vector__f_prefix1;
    var x$49 = this.sci_Vector5__f_len1;
    var x$50 = this.sci_Vector5__f_prefix2;
    var x$51 = this.sci_Vector5__f_len12;
    var x$52 = this.sci_Vector5__f_prefix3;
    var x$53 = this.sci_Vector5__f_len123;
    var x$54 = this.sci_Vector5__f_prefix4;
    var x$55 = this.sci_Vector5__f_len1234;
    var x$56 = this.sci_Vector5__f_data5;
    return new $c_sci_Vector5(x$48, x$49, x$50, x$51, x$52, x$53, x$54, x$55, x$56, x$43, x$44, x$45, a$2, x$47)
  } else if (($n(this.sci_Vector5__f_data5).u.length < 30)) {
    var x$57 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_data5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$58 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$60 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var x$62 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$63 = this.sci_Vector__f_prefix1;
    var x$64 = this.sci_Vector5__f_len1;
    var x$65 = this.sci_Vector5__f_prefix2;
    var x$66 = this.sci_Vector5__f_len12;
    var x$67 = this.sci_Vector5__f_prefix3;
    var x$68 = this.sci_Vector5__f_len123;
    var x$69 = this.sci_Vector5__f_prefix4;
    var x$70 = this.sci_Vector5__f_len1234;
    return new $c_sci_Vector5(x$63, x$64, x$65, x$66, x$67, x$68, x$69, x$70, x$57, x$58, x$59, x$60, a$3, x$62)
  } else {
    var $$x14 = this.sci_Vector__f_prefix1;
    var $$x13 = this.sci_Vector5__f_len1;
    var $$x12 = this.sci_Vector5__f_prefix2;
    var $$x11 = this.sci_Vector5__f_len12;
    var $$x10 = this.sci_Vector5__f_prefix3;
    var $$x9 = this.sci_Vector5__f_len123;
    var $$x8 = this.sci_Vector5__f_prefix4;
    var $$x7 = this.sci_Vector5__f_len1234;
    var $$x6 = this.sci_Vector5__f_data5;
    var $$x5 = this.sci_Vector5__f_len1234;
    var $$x4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$4).set(0, x);
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$5 = new $ac_O(1);
    $n(a$5).set(0, elem);
    return new $c_sci_Vector6($$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, ((31457280 + $$x5) | 0), $$x4, a$4, $$x3, $$x2, $$x1, a$5, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector5.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector5__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector5__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$6 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6)
  } else if ((this.sci_Vector5__f_len12 < 1024)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), 2);
    var x$18 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$19 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$20 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$21 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_prefix4;
    var x$24 = this.sci_Vector5__f_data5;
    var x$25 = this.sci_Vector5__f_suffix4;
    var x$26 = this.sci_Vector5__f_suffix3;
    var x$27 = this.sci_Vector5__f_suffix2;
    var x$28 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a, 1, x$17, x$18, x$22, x$19, x$23, x$20, x$24, x$25, x$26, x$27, x$28, x$21)
  } else if ((this.sci_Vector5__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$31 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$33 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), 3);
    var x$34 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$35 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$36 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$37 = this.sci_Vector5__f_prefix4;
    var x$38 = this.sci_Vector5__f_data5;
    var x$39 = this.sci_Vector5__f_suffix4;
    var x$40 = this.sci_Vector5__f_suffix3;
    var x$41 = this.sci_Vector5__f_suffix2;
    var x$42 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$1, 1, x$31, 1, x$33, x$34, x$37, x$35, x$38, x$39, x$40, x$41, x$42, x$36)
  } else if ((this.sci_Vector5__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$47 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$49 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var x$50 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$51 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$52 = this.sci_Vector5__f_data5;
    var x$53 = this.sci_Vector5__f_suffix4;
    var x$54 = this.sci_Vector5__f_suffix3;
    var x$55 = this.sci_Vector5__f_suffix2;
    var x$56 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$2, 1, x$45, 1, x$47, 1, x$49, x$50, x$52, x$53, x$54, x$55, x$56, x$51)
  } else if (($n(this.sci_Vector5__f_data5).u.length < 30)) {
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$61 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$63 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$65 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), this.sci_Vector5__f_data5), 5);
    var x$66 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$67 = this.sci_Vector5__f_suffix4;
    var x$68 = this.sci_Vector5__f_suffix3;
    var x$69 = this.sci_Vector5__f_suffix2;
    var x$70 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$3, 1, x$59, 1, x$61, 1, x$63, 1, x$65, x$67, x$68, x$69, x$70, x$66)
  } else {
    var a$4 = new $ac_O(1);
    $n(a$4).set(0, elem);
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var a$5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$5).set(0, x);
    return new $c_sci_Vector6(a$4, 1, $$x3, 1, $$x2, 1, $$x1, 1, a$5, ((1 + this.sci_Vector5__f_len1234) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6, this.sci_Vector5__f_data5, this.sci_Vector5__f_suffix4, this.sci_Vector5__f_suffix3, this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector5.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector5__f_data5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_suffix4, f), 4);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_suffix3, f), 3);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_suffix2, f), 2);
  var x$9 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$10 = this.sci_Vector5__f_len1;
  var x$11 = this.sci_Vector5__f_len12;
  var x$12 = this.sci_Vector5__f_len123;
  var x$13 = this.sci_Vector5__f_len1234;
  var x$14 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector5(x$1, x$10, x$2, x$11, x$3, x$12, x$4, x$13, x$5, x$6, x$7, x$8, x$9, x$14)
});
$c_sci_Vector5.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector5__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector5__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector5__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector5__f_data5);
  b.consider__I__AO__V(4, this.sci_Vector5__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector5__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector5__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector5.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector5__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector5__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector5__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector5__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector5__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector5.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2)
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector5.prototype.vectorSliceCount__I = (function() {
  return 9
});
$c_sci_Vector5.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector5__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector5__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector5__f_prefix4;
      break
    }
    case 4: {
      return this.sci_Vector5__f_data5;
      break
    }
    case 5: {
      return this.sci_Vector5__f_suffix4;
      break
    }
    case 6: {
      return this.sci_Vector5__f_suffix3;
      break
    }
    case 7: {
      return this.sci_Vector5__f_suffix2;
      break
    }
    case 8: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector5.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector5.prototype.init__O = (function() {
  return this.init__sci_Vector()
});
$c_sci_Vector5.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector5.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector5.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem)
});
$c_sci_Vector5.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector5.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem)
});
$c_sci_Vector5.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < $n(this.sci_Vector5__f_data5).u.length) ? $n($n($n($n($n(this.sci_Vector5__f_data5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector5__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector5__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector5__f_suffix3).u.length) ? $n($n($n(this.sci_Vector5__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector5__f_suffix2).u.length) ? $n($n(this.sci_Vector5__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)))))
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector5__f_prefix4).get(((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2))
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return $n($n($n(this.sci_Vector5__f_prefix3).get(((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3))
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return $n($n(this.sci_Vector5__f_prefix2).get(((io$4 >>> 5) | 0))).get((31 & io$4))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
function $as_sci_Vector5(obj) {
  return (((obj instanceof $c_sci_Vector5) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector5"))
}
function $isArrayOf_sci_Vector5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector5)))
}
function $asArrayOf_sci_Vector5(obj, depth) {
  return (($isArrayOf_sci_Vector5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector5;", depth))
}
var $d_sci_Vector5 = new $TypeData().initClass({
  sci_Vector5: 0
}, false, "scala.collection.immutable.Vector5", {
  sci_Vector5: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector5.prototype.$classData = $d_sci_Vector5;
/** @constructor */
function $c_sci_Vector6(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector6__f_len1 = 0;
  this.sci_Vector6__f_prefix2 = null;
  this.sci_Vector6__f_len12 = 0;
  this.sci_Vector6__f_prefix3 = null;
  this.sci_Vector6__f_len123 = 0;
  this.sci_Vector6__f_prefix4 = null;
  this.sci_Vector6__f_len1234 = 0;
  this.sci_Vector6__f_prefix5 = null;
  this.sci_Vector6__f_len12345 = 0;
  this.sci_Vector6__f_data6 = null;
  this.sci_Vector6__f_suffix5 = null;
  this.sci_Vector6__f_suffix4 = null;
  this.sci_Vector6__f_suffix3 = null;
  this.sci_Vector6__f_suffix2 = null;
  this.sci_Vector6__f_len1 = len1;
  this.sci_Vector6__f_prefix2 = prefix2;
  this.sci_Vector6__f_len12 = len12;
  this.sci_Vector6__f_prefix3 = prefix3;
  this.sci_Vector6__f_len123 = len123;
  this.sci_Vector6__f_prefix4 = prefix4;
  this.sci_Vector6__f_len1234 = len1234;
  this.sci_Vector6__f_prefix5 = prefix5;
  this.sci_Vector6__f_len12345 = len12345;
  this.sci_Vector6__f_data6 = data6;
  this.sci_Vector6__f_suffix5 = suffix5;
  this.sci_Vector6__f_suffix4 = suffix4;
  this.sci_Vector6__f_suffix3 = suffix3;
  this.sci_Vector6__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector6.prototype = new $h_sci_BigVector();
$c_sci_Vector6.prototype.constructor = $c_sci_Vector6;
/** @constructor */
function $h_sci_Vector6() {
  /*<skip>*/
}
$h_sci_Vector6.prototype = $c_sci_Vector6.prototype;
$c_sci_Vector6.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < $n(this.sci_Vector6__f_data6).u.length) ? $n($n($n($n($n($n(this.sci_Vector6__f_data6).get(i6)).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i5 < $n(this.sci_Vector6__f_suffix5).u.length) ? $n($n($n($n($n(this.sci_Vector6__f_suffix5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector6__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector6__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector6__f_suffix3).u.length) ? $n($n($n(this.sci_Vector6__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector6__f_suffix2).u.length) ? $n($n(this.sci_Vector6__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))))))
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return $n($n($n($n($n(this.sci_Vector6__f_prefix5).get(((io$2 >>> 20) | 0))).get((31 & ((io$2 >>> 15) | 0)))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2))
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector6__f_prefix4).get(((io$3 >>> 15) | 0))).get((31 & ((io$3 >>> 10) | 0)))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3))
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return $n($n($n(this.sci_Vector6__f_prefix3).get(((io$4 >>> 10) | 0))).get((31 & ((io$4 >>> 5) | 0)))).get((31 & io$4))
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return $n($n(this.sci_Vector6__f_prefix2).get(((io$5 >>> 5) | 0))).get((31 & io$5))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector6.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector6__f_len12345)) {
      var io = ((index - this.sci_Vector6__f_len12345) | 0);
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i6 < $n(this.sci_Vector6__f_data6).u.length)) {
        var a6 = this.sci_Vector6__f_data6;
        var this$2 = $n(a6);
        var a6c = $n(this$2).clone__O();
        var $$x5 = $n(a6c);
        var a5 = $n(a6c).get(i6);
        var this$3 = $n(a5);
        var a5c = $n(this$3).clone__O();
        var $$x4 = $n(a5c);
        var a4 = $n(a5c).get(i5);
        var this$4 = $n(a4);
        var a4c = $n(this$4).clone__O();
        var $$x3 = $n(a4c);
        var a3 = $n(a4c).get(i4);
        var this$5 = $n(a3);
        var a3c = $n(this$5).clone__O();
        var $$x2 = $n(a3c);
        var a2 = $n(a3c).get(i3);
        var this$6 = $n(a2);
        var a2c = $n(this$6).clone__O();
        var $$x1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$7 = $n(a1);
        var a1c = $n(this$7).clone__O();
        $n(a1c).set(i1, elem);
        $$x1.set(i2, a1c);
        $$x2.set(i3, a2c);
        $$x3.set(i4, a3c);
        $$x4.set(i5, a4c);
        $$x5.set(i6, a5c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector6__f_len1;
        var x$4 = this.sci_Vector6__f_prefix2;
        var x$5 = this.sci_Vector6__f_len12;
        var x$6 = this.sci_Vector6__f_prefix3;
        var x$7 = this.sci_Vector6__f_len123;
        var x$8 = this.sci_Vector6__f_prefix4;
        var x$9 = this.sci_Vector6__f_len1234;
        var x$10 = this.sci_Vector6__f_prefix5;
        var x$11 = this.sci_Vector6__f_len12345;
        var x$12 = this.sci_Vector6__f_suffix5;
        var x$13 = this.sci_Vector6__f_suffix4;
        var x$14 = this.sci_Vector6__f_suffix3;
        var x$15 = this.sci_Vector6__f_suffix2;
        var x$16 = this.sci_BigVector__f_suffix1;
        var x$17 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, a6c, x$12, x$13, x$14, x$15, x$16, x$17)
      } else if ((i5 < $n(this.sci_Vector6__f_suffix5).u.length)) {
        var a5$1 = this.sci_Vector6__f_suffix5;
        var this$9 = $n(a5$1);
        var a5c$1 = $n(this$9).clone__O();
        var $$x9 = $n(a5c$1);
        var a4$1 = $n(a5c$1).get(i5);
        var this$10 = $n(a4$1);
        var a4c$1 = $n(this$10).clone__O();
        var $$x8 = $n(a4c$1);
        var a3$1 = $n(a4c$1).get(i4);
        var this$11 = $n(a3$1);
        var a3c$1 = $n(this$11).clone__O();
        var $$x7 = $n(a3c$1);
        var a2$1 = $n(a3c$1).get(i3);
        var this$12 = $n(a2$1);
        var a2c$1 = $n(this$12).clone__O();
        var $$x6 = $n(a2c$1);
        var a1$1 = $n(a2c$1).get(i2);
        var this$13 = $n(a1$1);
        var a1c$1 = $n(this$13).clone__O();
        $n(a1c$1).set(i1, elem);
        $$x6.set(i2, a1c$1);
        $$x7.set(i3, a2c$1);
        $$x8.set(i4, a3c$1);
        $$x9.set(i5, a4c$1);
        var x$19 = this.sci_Vector__f_prefix1;
        var x$20 = this.sci_Vector6__f_len1;
        var x$21 = this.sci_Vector6__f_prefix2;
        var x$22 = this.sci_Vector6__f_len12;
        var x$23 = this.sci_Vector6__f_prefix3;
        var x$24 = this.sci_Vector6__f_len123;
        var x$25 = this.sci_Vector6__f_prefix4;
        var x$26 = this.sci_Vector6__f_len1234;
        var x$27 = this.sci_Vector6__f_prefix5;
        var x$28 = this.sci_Vector6__f_len12345;
        var x$29 = this.sci_Vector6__f_data6;
        var x$30 = this.sci_Vector6__f_suffix4;
        var x$31 = this.sci_Vector6__f_suffix3;
        var x$32 = this.sci_Vector6__f_suffix2;
        var x$33 = this.sci_BigVector__f_suffix1;
        var x$34 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, a5c$1, x$30, x$31, x$32, x$33, x$34)
      } else if ((i4 < $n(this.sci_Vector6__f_suffix4).u.length)) {
        var a4$2 = this.sci_Vector6__f_suffix4;
        var this$15 = $n(a4$2);
        var a4c$2 = $n(this$15).clone__O();
        var $$x12 = $n(a4c$2);
        var a3$2 = $n(a4c$2).get(i4);
        var this$16 = $n(a3$2);
        var a3c$2 = $n(this$16).clone__O();
        var $$x11 = $n(a3c$2);
        var a2$2 = $n(a3c$2).get(i3);
        var this$17 = $n(a2$2);
        var a2c$2 = $n(this$17).clone__O();
        var $$x10 = $n(a2c$2);
        var a1$2 = $n(a2c$2).get(i2);
        var this$18 = $n(a1$2);
        var a1c$2 = $n(this$18).clone__O();
        $n(a1c$2).set(i1, elem);
        $$x10.set(i2, a1c$2);
        $$x11.set(i3, a2c$2);
        $$x12.set(i4, a3c$2);
        var x$36 = this.sci_Vector__f_prefix1;
        var x$37 = this.sci_Vector6__f_len1;
        var x$38 = this.sci_Vector6__f_prefix2;
        var x$39 = this.sci_Vector6__f_len12;
        var x$40 = this.sci_Vector6__f_prefix3;
        var x$41 = this.sci_Vector6__f_len123;
        var x$42 = this.sci_Vector6__f_prefix4;
        var x$43 = this.sci_Vector6__f_len1234;
        var x$44 = this.sci_Vector6__f_prefix5;
        var x$45 = this.sci_Vector6__f_len12345;
        var x$46 = this.sci_Vector6__f_data6;
        var x$47 = this.sci_Vector6__f_suffix5;
        var x$48 = this.sci_Vector6__f_suffix3;
        var x$49 = this.sci_Vector6__f_suffix2;
        var x$50 = this.sci_BigVector__f_suffix1;
        var x$51 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, a4c$2, x$48, x$49, x$50, x$51)
      } else if ((i3 < $n(this.sci_Vector6__f_suffix3).u.length)) {
        var a3$3 = this.sci_Vector6__f_suffix3;
        var this$20 = $n(a3$3);
        var a3c$3 = $n(this$20).clone__O();
        var $$x14 = $n(a3c$3);
        var a2$3 = $n(a3c$3).get(i3);
        var this$21 = $n(a2$3);
        var a2c$3 = $n(this$21).clone__O();
        var $$x13 = $n(a2c$3);
        var a1$3 = $n(a2c$3).get(i2);
        var this$22 = $n(a1$3);
        var a1c$3 = $n(this$22).clone__O();
        $n(a1c$3).set(i1, elem);
        $$x13.set(i2, a1c$3);
        $$x14.set(i3, a2c$3);
        var x$53 = this.sci_Vector__f_prefix1;
        var x$54 = this.sci_Vector6__f_len1;
        var x$55 = this.sci_Vector6__f_prefix2;
        var x$56 = this.sci_Vector6__f_len12;
        var x$57 = this.sci_Vector6__f_prefix3;
        var x$58 = this.sci_Vector6__f_len123;
        var x$59 = this.sci_Vector6__f_prefix4;
        var x$60 = this.sci_Vector6__f_len1234;
        var x$61 = this.sci_Vector6__f_prefix5;
        var x$62 = this.sci_Vector6__f_len12345;
        var x$63 = this.sci_Vector6__f_data6;
        var x$64 = this.sci_Vector6__f_suffix5;
        var x$65 = this.sci_Vector6__f_suffix4;
        var x$66 = this.sci_Vector6__f_suffix2;
        var x$67 = this.sci_BigVector__f_suffix1;
        var x$68 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$53, x$54, x$55, x$56, x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, a3c$3, x$66, x$67, x$68)
      } else if ((i2 < $n(this.sci_Vector6__f_suffix2).u.length)) {
        var a2$4 = this.sci_Vector6__f_suffix2;
        var this$24 = $n(a2$4);
        var a2c$4 = $n(this$24).clone__O();
        var $$x15 = $n(a2c$4);
        var a1$4 = $n(a2c$4).get(i2);
        var this$25 = $n(a1$4);
        var a1c$4 = $n(this$25).clone__O();
        $n(a1c$4).set(i1, elem);
        $$x15.set(i2, a1c$4);
        var x$70 = this.sci_Vector__f_prefix1;
        var x$71 = this.sci_Vector6__f_len1;
        var x$72 = this.sci_Vector6__f_prefix2;
        var x$73 = this.sci_Vector6__f_len12;
        var x$74 = this.sci_Vector6__f_prefix3;
        var x$75 = this.sci_Vector6__f_len123;
        var x$76 = this.sci_Vector6__f_prefix4;
        var x$77 = this.sci_Vector6__f_len1234;
        var x$78 = this.sci_Vector6__f_prefix5;
        var x$79 = this.sci_Vector6__f_len12345;
        var x$80 = this.sci_Vector6__f_data6;
        var x$81 = this.sci_Vector6__f_suffix5;
        var x$82 = this.sci_Vector6__f_suffix4;
        var x$83 = this.sci_Vector6__f_suffix3;
        var x$84 = this.sci_BigVector__f_suffix1;
        var x$85 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$70, x$71, x$72, x$73, x$74, x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, a2c$4, x$84, x$85)
      } else {
        var a1$5 = this.sci_BigVector__f_suffix1;
        var this$27 = $n(a1$5);
        var a1c$5 = $n(this$27).clone__O();
        $n(a1c$5).set(i1, elem);
        var x$87 = this.sci_Vector__f_prefix1;
        var x$88 = this.sci_Vector6__f_len1;
        var x$89 = this.sci_Vector6__f_prefix2;
        var x$90 = this.sci_Vector6__f_len12;
        var x$91 = this.sci_Vector6__f_prefix3;
        var x$92 = this.sci_Vector6__f_len123;
        var x$93 = this.sci_Vector6__f_prefix4;
        var x$94 = this.sci_Vector6__f_len1234;
        var x$95 = this.sci_Vector6__f_prefix5;
        var x$96 = this.sci_Vector6__f_len12345;
        var x$97 = this.sci_Vector6__f_data6;
        var x$98 = this.sci_Vector6__f_suffix5;
        var x$99 = this.sci_Vector6__f_suffix4;
        var x$100 = this.sci_Vector6__f_suffix3;
        var x$101 = this.sci_Vector6__f_suffix2;
        var x$102 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$87, x$88, x$89, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, a1c$5, x$102)
      }
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      var a5$2 = this.sci_Vector6__f_prefix5;
      var idx5 = ((io$2 >>> 20) | 0);
      var idx4 = (31 & ((io$2 >>> 15) | 0));
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var this$29 = $n(a5$2);
      var a5c$2 = $n(this$29).clone__O();
      var $$x19 = $n(a5c$2);
      var a4$3 = $n(a5c$2).get(idx5);
      var this$30 = $n(a4$3);
      var a4c$3 = $n(this$30).clone__O();
      var $$x18 = $n(a4c$3);
      var a3$4 = $n(a4c$3).get(idx4);
      var this$31 = $n(a3$4);
      var a3c$4 = $n(this$31).clone__O();
      var $$x17 = $n(a3c$4);
      var a2$5 = $n(a3c$4).get(idx3);
      var this$32 = $n(a2$5);
      var a2c$5 = $n(this$32).clone__O();
      var $$x16 = $n(a2c$5);
      var a1$6 = $n(a2c$5).get(idx2);
      var this$33 = $n(a1$6);
      var a1c$6 = $n(this$33).clone__O();
      $n(a1c$6).set(idx1, elem);
      $$x16.set(idx2, a1c$6);
      $$x17.set(idx3, a2c$5);
      $$x18.set(idx4, a3c$4);
      $$x19.set(idx5, a4c$3);
      var x$104 = this.sci_Vector__f_prefix1;
      var x$105 = this.sci_Vector6__f_len1;
      var x$106 = this.sci_Vector6__f_prefix2;
      var x$107 = this.sci_Vector6__f_len12;
      var x$108 = this.sci_Vector6__f_prefix3;
      var x$109 = this.sci_Vector6__f_len123;
      var x$110 = this.sci_Vector6__f_prefix4;
      var x$111 = this.sci_Vector6__f_len1234;
      var x$112 = this.sci_Vector6__f_len12345;
      var x$113 = this.sci_Vector6__f_data6;
      var x$114 = this.sci_Vector6__f_suffix5;
      var x$115 = this.sci_Vector6__f_suffix4;
      var x$116 = this.sci_Vector6__f_suffix3;
      var x$117 = this.sci_Vector6__f_suffix2;
      var x$118 = this.sci_BigVector__f_suffix1;
      var x$119 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, a5c$2, x$112, x$113, x$114, x$115, x$116, x$117, x$118, x$119)
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      var a4$4 = this.sci_Vector6__f_prefix4;
      var idx4$1 = ((io$3 >>> 15) | 0);
      var idx3$1 = (31 & ((io$3 >>> 10) | 0));
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var this$35 = $n(a4$4);
      var a4c$4 = $n(this$35).clone__O();
      var $$x22 = $n(a4c$4);
      var a3$5 = $n(a4c$4).get(idx4$1);
      var this$36 = $n(a3$5);
      var a3c$5 = $n(this$36).clone__O();
      var $$x21 = $n(a3c$5);
      var a2$6 = $n(a3c$5).get(idx3$1);
      var this$37 = $n(a2$6);
      var a2c$6 = $n(this$37).clone__O();
      var $$x20 = $n(a2c$6);
      var a1$7 = $n(a2c$6).get(idx2$1);
      var this$38 = $n(a1$7);
      var a1c$7 = $n(this$38).clone__O();
      $n(a1c$7).set(idx1$1, elem);
      $$x20.set(idx2$1, a1c$7);
      $$x21.set(idx3$1, a2c$6);
      $$x22.set(idx4$1, a3c$5);
      var x$121 = this.sci_Vector__f_prefix1;
      var x$122 = this.sci_Vector6__f_len1;
      var x$123 = this.sci_Vector6__f_prefix2;
      var x$124 = this.sci_Vector6__f_len12;
      var x$125 = this.sci_Vector6__f_prefix3;
      var x$126 = this.sci_Vector6__f_len123;
      var x$127 = this.sci_Vector6__f_len1234;
      var x$128 = this.sci_Vector6__f_prefix5;
      var x$129 = this.sci_Vector6__f_len12345;
      var x$130 = this.sci_Vector6__f_data6;
      var x$131 = this.sci_Vector6__f_suffix5;
      var x$132 = this.sci_Vector6__f_suffix4;
      var x$133 = this.sci_Vector6__f_suffix3;
      var x$134 = this.sci_Vector6__f_suffix2;
      var x$135 = this.sci_BigVector__f_suffix1;
      var x$136 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$121, x$122, x$123, x$124, x$125, x$126, a4c$4, x$127, x$128, x$129, x$130, x$131, x$132, x$133, x$134, x$135, x$136)
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      var a3$6 = this.sci_Vector6__f_prefix3;
      var idx3$2 = ((io$4 >>> 10) | 0);
      var idx2$2 = (31 & ((io$4 >>> 5) | 0));
      var idx1$2 = (31 & io$4);
      var this$40 = $n(a3$6);
      var a3c$6 = $n(this$40).clone__O();
      var $$x24 = $n(a3c$6);
      var a2$7 = $n(a3c$6).get(idx3$2);
      var this$41 = $n(a2$7);
      var a2c$7 = $n(this$41).clone__O();
      var $$x23 = $n(a2c$7);
      var a1$8 = $n(a2c$7).get(idx2$2);
      var this$42 = $n(a1$8);
      var a1c$8 = $n(this$42).clone__O();
      $n(a1c$8).set(idx1$2, elem);
      $$x23.set(idx2$2, a1c$8);
      $$x24.set(idx3$2, a2c$7);
      var x$138 = this.sci_Vector__f_prefix1;
      var x$139 = this.sci_Vector6__f_len1;
      var x$140 = this.sci_Vector6__f_prefix2;
      var x$141 = this.sci_Vector6__f_len12;
      var x$142 = this.sci_Vector6__f_len123;
      var x$143 = this.sci_Vector6__f_prefix4;
      var x$144 = this.sci_Vector6__f_len1234;
      var x$145 = this.sci_Vector6__f_prefix5;
      var x$146 = this.sci_Vector6__f_len12345;
      var x$147 = this.sci_Vector6__f_data6;
      var x$148 = this.sci_Vector6__f_suffix5;
      var x$149 = this.sci_Vector6__f_suffix4;
      var x$150 = this.sci_Vector6__f_suffix3;
      var x$151 = this.sci_Vector6__f_suffix2;
      var x$152 = this.sci_BigVector__f_suffix1;
      var x$153 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$138, x$139, x$140, x$141, a3c$6, x$142, x$143, x$144, x$145, x$146, x$147, x$148, x$149, x$150, x$151, x$152, x$153)
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      var a2$8 = this.sci_Vector6__f_prefix2;
      var idx2$3 = ((io$5 >>> 5) | 0);
      var idx1$3 = (31 & io$5);
      var this$44 = $n(a2$8);
      var a2c$8 = $n(this$44).clone__O();
      var $$x25 = $n(a2c$8);
      var a1$9 = $n(a2c$8).get(idx2$3);
      var this$45 = $n(a1$9);
      var a1c$9 = $n(this$45).clone__O();
      $n(a1c$9).set(idx1$3, elem);
      $$x25.set(idx2$3, a1c$9);
      var x$155 = this.sci_Vector__f_prefix1;
      var x$156 = this.sci_Vector6__f_len1;
      var x$157 = this.sci_Vector6__f_len12;
      var x$158 = this.sci_Vector6__f_prefix3;
      var x$159 = this.sci_Vector6__f_len123;
      var x$160 = this.sci_Vector6__f_prefix4;
      var x$161 = this.sci_Vector6__f_len1234;
      var x$162 = this.sci_Vector6__f_prefix5;
      var x$163 = this.sci_Vector6__f_len12345;
      var x$164 = this.sci_Vector6__f_data6;
      var x$165 = this.sci_Vector6__f_suffix5;
      var x$166 = this.sci_Vector6__f_suffix4;
      var x$167 = this.sci_Vector6__f_suffix3;
      var x$168 = this.sci_Vector6__f_suffix2;
      var x$169 = this.sci_BigVector__f_suffix1;
      var x$170 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$155, x$156, a2c$8, x$157, x$158, x$159, x$160, x$161, x$162, x$163, x$164, x$165, x$166, x$167, x$168, x$169, x$170)
    } else {
      var a1$10 = this.sci_Vector__f_prefix1;
      var this$47 = $n(a1$10);
      var a1c$10 = $n(this$47).clone__O();
      $n(a1c$10).set(index, elem);
      var len1 = this.sci_Vector6__f_len1;
      var prefix2 = this.sci_Vector6__f_prefix2;
      var len12 = this.sci_Vector6__f_len12;
      var prefix3 = this.sci_Vector6__f_prefix3;
      var len123 = this.sci_Vector6__f_len123;
      var prefix4 = this.sci_Vector6__f_prefix4;
      var len1234 = this.sci_Vector6__f_len1234;
      var prefix5 = this.sci_Vector6__f_prefix5;
      var len12345 = this.sci_Vector6__f_len12345;
      var data6 = this.sci_Vector6__f_data6;
      var suffix5 = this.sci_Vector6__f_suffix5;
      var suffix4 = this.sci_Vector6__f_suffix4;
      var suffix3 = this.sci_Vector6__f_suffix3;
      var suffix2 = this.sci_Vector6__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(a1c$10, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
$c_sci_Vector6.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2)
  } else if (($n(this.sci_Vector6__f_suffix2).u.length < 31)) {
    var x$18 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector6__f_len1;
    var x$23 = this.sci_Vector6__f_prefix2;
    var x$24 = this.sci_Vector6__f_len12;
    var x$25 = this.sci_Vector6__f_prefix3;
    var x$26 = this.sci_Vector6__f_len123;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_len1234;
    var x$29 = this.sci_Vector6__f_prefix5;
    var x$30 = this.sci_Vector6__f_len12345;
    var x$31 = this.sci_Vector6__f_data6;
    var x$32 = this.sci_Vector6__f_suffix5;
    var x$33 = this.sci_Vector6__f_suffix4;
    var x$34 = this.sci_Vector6__f_suffix3;
    return new $c_sci_Vector6(x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$18, a, x$20)
  } else if (($n(this.sci_Vector6__f_suffix3).u.length < 31)) {
    var x$35 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector6__f_len1;
    var x$41 = this.sci_Vector6__f_prefix2;
    var x$42 = this.sci_Vector6__f_len12;
    var x$43 = this.sci_Vector6__f_prefix3;
    var x$44 = this.sci_Vector6__f_len123;
    var x$45 = this.sci_Vector6__f_prefix4;
    var x$46 = this.sci_Vector6__f_len1234;
    var x$47 = this.sci_Vector6__f_prefix5;
    var x$48 = this.sci_Vector6__f_len12345;
    var x$49 = this.sci_Vector6__f_data6;
    var x$50 = this.sci_Vector6__f_suffix5;
    var x$51 = this.sci_Vector6__f_suffix4;
    return new $c_sci_Vector6(x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$35, x$36, a$1, x$38)
  } else if (($n(this.sci_Vector6__f_suffix4).u.length < 31)) {
    var x$52 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$53 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$56 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$57 = this.sci_Vector__f_prefix1;
    var x$58 = this.sci_Vector6__f_len1;
    var x$59 = this.sci_Vector6__f_prefix2;
    var x$60 = this.sci_Vector6__f_len12;
    var x$61 = this.sci_Vector6__f_prefix3;
    var x$62 = this.sci_Vector6__f_len123;
    var x$63 = this.sci_Vector6__f_prefix4;
    var x$64 = this.sci_Vector6__f_len1234;
    var x$65 = this.sci_Vector6__f_prefix5;
    var x$66 = this.sci_Vector6__f_len12345;
    var x$67 = this.sci_Vector6__f_data6;
    var x$68 = this.sci_Vector6__f_suffix5;
    return new $c_sci_Vector6(x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$52, x$53, x$54, a$2, x$56)
  } else if (($n(this.sci_Vector6__f_suffix5).u.length < 31)) {
    var x$69 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$70 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$72 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var x$74 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$75 = this.sci_Vector__f_prefix1;
    var x$76 = this.sci_Vector6__f_len1;
    var x$77 = this.sci_Vector6__f_prefix2;
    var x$78 = this.sci_Vector6__f_len12;
    var x$79 = this.sci_Vector6__f_prefix3;
    var x$80 = this.sci_Vector6__f_len123;
    var x$81 = this.sci_Vector6__f_prefix4;
    var x$82 = this.sci_Vector6__f_len1234;
    var x$83 = this.sci_Vector6__f_prefix5;
    var x$84 = this.sci_Vector6__f_len12345;
    var x$85 = this.sci_Vector6__f_data6;
    return new $c_sci_Vector6(x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, x$84, x$85, x$69, x$70, x$71, x$72, a$3, x$74)
  } else if (($n(this.sci_Vector6__f_data6).u.length < 62)) {
    var x$86 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_data6, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))))), 6);
    var x$87 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$89 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    $n(a$4).set(0, elem);
    var x$92 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$93 = this.sci_Vector__f_prefix1;
    var x$94 = this.sci_Vector6__f_len1;
    var x$95 = this.sci_Vector6__f_prefix2;
    var x$96 = this.sci_Vector6__f_len12;
    var x$97 = this.sci_Vector6__f_prefix3;
    var x$98 = this.sci_Vector6__f_len123;
    var x$99 = this.sci_Vector6__f_prefix4;
    var x$100 = this.sci_Vector6__f_len1234;
    var x$101 = this.sci_Vector6__f_prefix5;
    var x$102 = this.sci_Vector6__f_len12345;
    return new $c_sci_Vector6(x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, x$102, x$86, x$87, x$88, x$89, x$90, a$4, x$92)
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_sci_Vector6.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector6__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector6__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$6 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$7 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7)
  } else if ((this.sci_Vector6__f_len12 < 1024)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$20 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), 2);
    var x$21 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$22 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$23 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$24 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$25 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$26 = this.sci_Vector6__f_prefix3;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_prefix5;
    var x$29 = this.sci_Vector6__f_data6;
    var x$30 = this.sci_Vector6__f_suffix5;
    var x$31 = this.sci_Vector6__f_suffix4;
    var x$32 = this.sci_Vector6__f_suffix3;
    var x$33 = this.sci_Vector6__f_suffix2;
    var x$34 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a, 1, x$20, x$21, x$26, x$22, x$27, x$23, x$28, x$24, x$29, x$30, x$31, x$32, x$33, x$34, x$25)
  } else if ((this.sci_Vector6__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$37 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$39 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), 3);
    var x$40 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$41 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$42 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$43 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$44 = this.sci_Vector6__f_prefix4;
    var x$45 = this.sci_Vector6__f_prefix5;
    var x$46 = this.sci_Vector6__f_data6;
    var x$47 = this.sci_Vector6__f_suffix5;
    var x$48 = this.sci_Vector6__f_suffix4;
    var x$49 = this.sci_Vector6__f_suffix3;
    var x$50 = this.sci_Vector6__f_suffix2;
    var x$51 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$1, 1, x$37, 1, x$39, x$40, x$44, x$41, x$45, x$42, x$46, x$47, x$48, x$49, x$50, x$51, x$43)
  } else if ((this.sci_Vector6__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$56 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$58 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), 4);
    var x$59 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$60 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$61 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$62 = this.sci_Vector6__f_prefix5;
    var x$63 = this.sci_Vector6__f_data6;
    var x$64 = this.sci_Vector6__f_suffix5;
    var x$65 = this.sci_Vector6__f_suffix4;
    var x$66 = this.sci_Vector6__f_suffix3;
    var x$67 = this.sci_Vector6__f_suffix2;
    var x$68 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$2, 1, x$54, 1, x$56, 1, x$58, x$59, x$62, x$60, x$63, x$64, x$65, x$66, x$67, x$68, x$61)
  } else if ((this.sci_Vector6__f_len12345 < 33554432)) {
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$73 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$75 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$77 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), 5);
    var x$78 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$79 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$80 = this.sci_Vector6__f_data6;
    var x$81 = this.sci_Vector6__f_suffix5;
    var x$82 = this.sci_Vector6__f_suffix4;
    var x$83 = this.sci_Vector6__f_suffix3;
    var x$84 = this.sci_Vector6__f_suffix2;
    var x$85 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$3, 1, x$71, 1, x$73, 1, x$75, 1, x$77, x$78, x$80, x$81, x$82, x$83, x$84, x$85, x$79)
  } else if (($n(this.sci_Vector6__f_data6).u.length < 62)) {
    var a$4 = new $ac_O(1);
    $n(a$4).set(0, elem);
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$92 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$94 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$96 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), this.sci_Vector6__f_data6), 6);
    var x$97 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$98 = this.sci_Vector6__f_suffix5;
    var x$99 = this.sci_Vector6__f_suffix4;
    var x$100 = this.sci_Vector6__f_suffix3;
    var x$101 = this.sci_Vector6__f_suffix2;
    var x$102 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$4, 1, x$88, 1, x$90, 1, x$92, 1, x$94, 1, x$96, x$98, x$99, x$100, x$101, x$102, x$97)
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_sci_Vector6.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_prefix5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(6, this.sci_Vector6__f_data6, f), 6);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_suffix5, f), 5);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_suffix4, f), 4);
  var x$9 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_suffix3, f), 3);
  var x$10 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_suffix2, f), 2);
  var x$11 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$12 = this.sci_Vector6__f_len1;
  var x$13 = this.sci_Vector6__f_len12;
  var x$14 = this.sci_Vector6__f_len123;
  var x$15 = this.sci_Vector6__f_len1234;
  var x$16 = this.sci_Vector6__f_len12345;
  var x$17 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector6(x$1, x$12, x$2, x$13, x$3, x$14, x$4, x$15, x$5, x$16, x$6, x$7, x$8, x$9, x$10, x$11, x$17)
});
$c_sci_Vector6.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector6__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector6__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector6__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector6__f_prefix5);
  b.consider__I__AO__V(6, this.sci_Vector6__f_data6);
  b.consider__I__AO__V(5, this.sci_Vector6__f_suffix5);
  b.consider__I__AO__V(4, this.sci_Vector6__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector6__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector6__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector6.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector6__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector6__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector6__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector6__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector6__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_Vector6__f_len12345) | 0);
    var x$7 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector6.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2)
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector6.prototype.vectorSliceCount__I = (function() {
  return 11
});
$c_sci_Vector6.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector6__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector6__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector6__f_prefix4;
      break
    }
    case 4: {
      return this.sci_Vector6__f_prefix5;
      break
    }
    case 5: {
      return this.sci_Vector6__f_data6;
      break
    }
    case 6: {
      return this.sci_Vector6__f_suffix5;
      break
    }
    case 7: {
      return this.sci_Vector6__f_suffix4;
      break
    }
    case 8: {
      return this.sci_Vector6__f_suffix3;
      break
    }
    case 9: {
      return this.sci_Vector6__f_suffix2;
      break
    }
    case 10: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector6.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector6.prototype.init__O = (function() {
  return this.init__sci_Vector()
});
$c_sci_Vector6.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector6.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector6.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem)
});
$c_sci_Vector6.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem)
});
$c_sci_Vector6.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem)
});
$c_sci_Vector6.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < $n(this.sci_Vector6__f_data6).u.length) ? $n($n($n($n($n($n(this.sci_Vector6__f_data6).get(i6)).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i5 < $n(this.sci_Vector6__f_suffix5).u.length) ? $n($n($n($n($n(this.sci_Vector6__f_suffix5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector6__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector6__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector6__f_suffix3).u.length) ? $n($n($n(this.sci_Vector6__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector6__f_suffix2).u.length) ? $n($n(this.sci_Vector6__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))))))
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return $n($n($n($n($n(this.sci_Vector6__f_prefix5).get(((io$2 >>> 20) | 0))).get((31 & ((io$2 >>> 15) | 0)))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2))
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector6__f_prefix4).get(((io$3 >>> 15) | 0))).get((31 & ((io$3 >>> 10) | 0)))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3))
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return $n($n($n(this.sci_Vector6__f_prefix3).get(((io$4 >>> 10) | 0))).get((31 & ((io$4 >>> 5) | 0)))).get((31 & io$4))
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return $n($n(this.sci_Vector6__f_prefix2).get(((io$5 >>> 5) | 0))).get((31 & io$5))
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index)
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index))
  }
});
function $as_sci_Vector6(obj) {
  return (((obj instanceof $c_sci_Vector6) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector6"))
}
function $isArrayOf_sci_Vector6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector6)))
}
function $asArrayOf_sci_Vector6(obj, depth) {
  return (($isArrayOf_sci_Vector6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector6;", depth))
}
var $d_sci_Vector6 = new $TypeData().initClass({
  sci_Vector6: 0
}, false, "scala.collection.immutable.Vector6", {
  sci_Vector6: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector6.prototype.$classData = $d_sci_Vector6;
function $ct_scm_StringBuilder__jl_StringBuilder__($thiz, underlying) {
  $thiz.scm_StringBuilder__f_underlying = underlying;
  return $thiz
}
function $ct_scm_StringBuilder__($thiz) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz
}
function $ct_scm_StringBuilder__I__($thiz, capacity) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), capacity));
  return $thiz
}
/** @constructor */
function $c_scm_StringBuilder() {
  this.scm_StringBuilder__f_underlying = null
}
$c_scm_StringBuilder.prototype = new $h_scm_AbstractSeq();
$c_scm_StringBuilder.prototype.constructor = $c_scm_StringBuilder;
/** @constructor */
function $h_scm_StringBuilder() {
  /*<skip>*/
}
$h_scm_StringBuilder.prototype = $c_scm_StringBuilder.prototype;
$c_scm_StringBuilder.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_scm_StringBuilder.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_scm_StringBuilder.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_scm_StringBuilder.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_scm_StringBuilder.prototype.prepended__O__O = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem)
});
$c_scm_StringBuilder.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_scm_StringBuilder.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_StringBuilder.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n)
});
$c_scm_StringBuilder.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_scm_StringBuilder.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this)
});
$c_scm_StringBuilder.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_scm_StringBuilder.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_scm_StringBuilder.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_scm_StringBuilder.prototype.lengthCompare__I__I = (function(len) {
  var x = $n(this.scm_StringBuilder__f_underlying).length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_StringBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_StringBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_StringBuilder.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()))
});
$c_scm_StringBuilder.prototype.length__I = (function() {
  return $n(this.scm_StringBuilder__f_underlying).length__I()
});
$c_scm_StringBuilder.prototype.knownSize__I = (function() {
  return $n(this.scm_StringBuilder__f_underlying).length__I()
});
$c_scm_StringBuilder.prototype.addOne__C__scm_StringBuilder = (function(x) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = $as_T(String.fromCharCode(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_scm_StringBuilder.prototype.toString__T = (function() {
  return $n(this.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_scm_StringBuilder.prototype.toArray__s_reflect_ClassTag__O = (function(ct) {
  var x1 = $n(ct).runtimeClass__jl_Class();
  return ((x1 === $d_C.getClassOf()) ? this.toCharArray__AC() : $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, ct))
});
$c_scm_StringBuilder.prototype.toCharArray__AC = (function() {
  var len = $n(this.scm_StringBuilder__f_underlying).length__I();
  var arr = new $ac_C(len);
  $n(this.scm_StringBuilder__f_underlying).getChars__I__I__AC__I__V(0, len, arr, 0);
  return arr
});
$c_scm_StringBuilder.prototype.append__O__scm_StringBuilder = (function(x) {
  var this$2 = $n(this.scm_StringBuilder__f_underlying);
  var str = ("" + x);
  this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this
});
$c_scm_StringBuilder.prototype.append__T__scm_StringBuilder = (function(s) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this
});
$c_scm_StringBuilder.prototype.appendAll__sc_IterableOnce__scm_StringBuilder = (function(xs) {
  if ((xs instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(xs);
    var this$3 = $n(this.scm_StringBuilder__f_underlying);
    $m_sci_WrappedString$();
    var str = $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
  } else if ((xs instanceof $c_scm_ArraySeq$ofChar)) {
    var x3 = $as_scm_ArraySeq$ofChar(xs);
    $n(this.scm_StringBuilder__f_underlying).append__AC__jl_StringBuilder($n(x3).scm_ArraySeq$ofChar__f_array)
  } else if ((xs instanceof $c_scm_StringBuilder)) {
    var x4 = $as_scm_StringBuilder(xs);
    var this$4 = $n(this.scm_StringBuilder__f_underlying);
    var s = $n(x4).scm_StringBuilder__f_underlying;
    this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s)
  } else {
    var ks = $n(xs).knownSize__I();
    if ((ks !== 0)) {
      var b = this.scm_StringBuilder__f_underlying;
      if ((ks > 0)) {
        $n(b);
        $n(b).length__I()
      };
      var it = $n(xs).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var this$5 = $n(b);
        var c = $uC($n(it).next__O());
        var str$1 = $as_T(String.fromCharCode(c));
        this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1)
      }
    }
  };
  return this
});
$c_scm_StringBuilder.prototype.append__I__scm_StringBuilder = (function(x) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = ("" + x);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this
});
$c_scm_StringBuilder.prototype.append__J__scm_StringBuilder = (function(x) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(x.RTLong__f_lo, x.RTLong__f_hi);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_scm_StringBuilder.prototype.append__C__scm_StringBuilder = (function(x) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = $as_T(String.fromCharCode(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_scm_StringBuilder.prototype.charAt__I__C = (function(index) {
  return $n(this.scm_StringBuilder__f_underlying).charAt__I__C(index)
});
$c_scm_StringBuilder.prototype.deleteCharAt__I__scm_StringBuilder = (function(index) {
  $n(this.scm_StringBuilder__f_underlying).deleteCharAt__I__jl_StringBuilder(index);
  return this
});
$c_scm_StringBuilder.prototype.setCharAt__I__C__scm_StringBuilder = (function(index, ch) {
  $n(this.scm_StringBuilder__f_underlying).setCharAt__I__C__V(index, ch);
  return this
});
$c_scm_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return $n(this.scm_StringBuilder__f_underlying).substring__I__I__T(start, end)
});
$c_scm_StringBuilder.prototype.isEmpty__Z = (function() {
  return ($n(this.scm_StringBuilder__f_underlying).length__I() === 0)
});
$c_scm_StringBuilder.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this)
});
$c_scm_StringBuilder.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_IndexedSeq$()
});
$c_scm_StringBuilder.prototype.result__O = (function() {
  return $n(this.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_scm_StringBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__C__scm_StringBuilder($uC(elem))
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll)
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll)
});
$c_scm_StringBuilder.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return $bC($n(this.scm_StringBuilder__f_underlying).charAt__I__C(i))
});
$c_scm_StringBuilder.prototype.apply__I__O = (function(i) {
  return $bC($n(this.scm_StringBuilder__f_underlying).charAt__I__C(i))
});
function $as_scm_StringBuilder(obj) {
  return (((obj instanceof $c_scm_StringBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.StringBuilder"))
}
function $isArrayOf_scm_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_StringBuilder)))
}
function $asArrayOf_scm_StringBuilder(obj, depth) {
  return (($isArrayOf_scm_StringBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.StringBuilder;", depth))
}
var $d_scm_StringBuilder = new $TypeData().initClass({
  scm_StringBuilder: 0
}, false, "scala.collection.mutable.StringBuilder", {
  scm_StringBuilder: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  jl_CharSequence: 1,
  Ljava_io_Serializable: 1
});
$c_scm_StringBuilder.prototype.$classData = $d_scm_StringBuilder;
/** @constructor */
function $c_sci_BitSet() {
  /*<skip>*/
}
$c_sci_BitSet.prototype = new $h_sci_AbstractSet();
$c_sci_BitSet.prototype.constructor = $c_sci_BitSet;
/** @constructor */
function $h_sci_BitSet() {
  /*<skip>*/
}
$h_sci_BitSet.prototype = $c_sci_BitSet.prototype;
$c_sci_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet"
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  return $as_sc_BitSet($f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps(this, that))
});
$c_sci_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$()
});
$c_sci_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0)
});
$c_sci_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this)
});
$c_sci_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this)
});
$c_sci_BitSet.prototype.foreach__F1__V = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f)
});
$c_sci_BitSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_BitSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_BitSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_BitSet.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_BitSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, false)
});
$c_sci_BitSet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, true)
});
$c_sci_BitSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_sci_BitSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_sci_SortedSet$()
});
$c_sci_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_sci_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_BitSet$().newBuilder__scm_Builder()
});
$c_sci_BitSet.prototype.incl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0")
  };
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    return this
  } else {
    var idx = (elem >> 6);
    var this$2 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$2.RTLong__f_lo | lo);
    var hi$1 = (this$2.RTLong__f_hi | hi);
    return this.updateWord__I__J__sci_BitSet(idx, new $c_RTLong(lo$1, hi$1))
  }
});
$c_sci_BitSet.prototype.excl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0")
  };
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var this$2 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (this$2.RTLong__f_lo & lo$1);
    var hi$2 = (this$2.RTLong__f_hi & hi$1);
    return this.updateWord__I__J__sci_BitSet(idx, new $c_RTLong(lo$2, hi$2))
  } else {
    return this
  }
});
$c_sci_BitSet.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sc_SortedSetOps$WithFilter(this, p)
});
$c_sci_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that)
});
$c_sci_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1)
});
$c_sci_BitSet.prototype.flatMap__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $as_sci_SortedSet($f_sc_StrictOptimizedSortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet(this, f, ev))
});
$c_sci_BitSet.prototype.map__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $as_sci_SortedSet($f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet(this, f, ev))
});
$c_sci_BitSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__I__sci_BitSet($uI(elem))
});
$c_sci_BitSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__I__sci_BitSet($uI(elem))
});
$c_sci_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll)
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll)
});
function $as_sci_BitSet(obj) {
  return (((obj instanceof $c_sci_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitSet"))
}
function $isArrayOf_sci_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitSet)))
}
function $asArrayOf_sci_BitSet(obj, depth) {
  return (($isArrayOf_sci_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitSet;", depth))
}
function $as_scm_LinkedHashMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashMap"))
}
function $isArrayOf_scm_LinkedHashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashMap)))
}
function $asArrayOf_scm_LinkedHashMap(obj, depth) {
  return (($isArrayOf_scm_LinkedHashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashMap;", depth))
}
function $p_scm_ListBuffer__copyElems__V($thiz) {
  var buf = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer($thiz);
  $thiz.scm_ListBuffer__f_first = $n(buf).scm_ListBuffer__f_first;
  $thiz.scm_ListBuffer__f_last0 = $n(buf).scm_ListBuffer__f_last0;
  $thiz.scm_ListBuffer__f_aliased = false
}
function $p_scm_ListBuffer__ensureUnaliased__V($thiz) {
  $thiz.scm_ListBuffer__f_mutationCount = ((1 + $thiz.scm_ListBuffer__f_mutationCount) | 0);
  if ($thiz.scm_ListBuffer__f_aliased) {
    $p_scm_ListBuffer__copyElems__V($thiz)
  }
}
function $p_scm_ListBuffer__reduceLengthBy__I__V($thiz, num) {
  $thiz.scm_ListBuffer__f_len = (($thiz.scm_ListBuffer__f_len - num) | 0);
  if (($thiz.scm_ListBuffer__f_len <= 0)) {
    $thiz.scm_ListBuffer__f_last0 = null
  }
}
function $p_scm_ListBuffer__locate__I__sci_$colon$colon($thiz, i) {
  if ((i === 0)) {
    return null
  } else if ((i === $thiz.scm_ListBuffer__f_len)) {
    return $thiz.scm_ListBuffer__f_last0
  } else {
    var j = (((-1) + i) | 0);
    var p = $thiz.scm_ListBuffer__f_first;
    while ((j > 0)) {
      p = $as_sci_List($n(p).tail__O());
      j = (((-1) + j) | 0)
    };
    return $as_sci_$colon$colon(p)
  }
}
function $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List($thiz, p) {
  return ((p === null) ? $thiz.scm_ListBuffer__f_first : $n(p).sci_$colon$colon__f_next)
}
/** @constructor */
function $c_scm_ListBuffer() {
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = null;
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = $m_sci_Nil$();
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0
}
$c_scm_ListBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ListBuffer.prototype.constructor = $c_scm_ListBuffer;
/** @constructor */
function $h_scm_ListBuffer() {
  /*<skip>*/
}
$h_scm_ListBuffer.prototype = $c_scm_ListBuffer.prototype;
$c_scm_ListBuffer.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_ListBuffer.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_scm_ListBuffer.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem)
});
$c_scm_ListBuffer.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem)
});
$c_scm_ListBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ListBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ListBuffer.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_ListBuffer.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_scm_ListBuffer.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_scm_ListBuffer.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_scm_ListBuffer.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_scm_ListBuffer.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_scm_ListBuffer.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_MutationTracker$CheckedIterator($n(this.scm_ListBuffer__f_first).iterator__sc_Iterator(), new $c_sjsr_AnonFunction0((() => this.scm_ListBuffer__f_mutationCount)))
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ListBuffer$()
});
$c_scm_ListBuffer.prototype.apply__I__O = (function(i) {
  var this$1 = $n(this.scm_ListBuffer__f_first);
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i)
});
$c_scm_ListBuffer.prototype.length__I = (function() {
  return this.scm_ListBuffer__f_len
});
$c_scm_ListBuffer.prototype.knownSize__I = (function() {
  return this.scm_ListBuffer__f_len
});
$c_scm_ListBuffer.prototype.isEmpty__Z = (function() {
  return (this.scm_ListBuffer__f_len === 0)
});
$c_scm_ListBuffer.prototype.toList__sci_List = (function() {
  this.scm_ListBuffer__f_aliased = (!this.isEmpty__Z());
  return this.scm_ListBuffer__f_first
});
$c_scm_ListBuffer.prototype.prependToList__sci_List__sci_List = (function(xs) {
  if (this.isEmpty__Z()) {
    return xs
  } else {
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_next = xs;
    return this.toList__sci_List()
  }
});
$c_scm_ListBuffer.prototype.addOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  var last1 = new $c_sci_$colon$colon(elem, $m_sci_Nil$());
  if ((this.scm_ListBuffer__f_len === 0)) {
    this.scm_ListBuffer__f_first = last1
  } else {
    $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_next = last1
  };
  this.scm_ListBuffer__f_last0 = last1;
  this.scm_ListBuffer__f_len = ((1 + this.scm_ListBuffer__f_len) | 0);
  return this
});
$c_scm_ListBuffer.prototype.scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = $n(xs).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var len = 1;
    var last0 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
    this.scm_ListBuffer__f_first = last0;
    while ($n(it).hasNext__Z()) {
      var last1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      $n(last0).sci_$colon$colon__f_next = last1;
      last0 = last1;
      len = ((1 + len) | 0)
    };
    this.scm_ListBuffer__f_len = len;
    this.scm_ListBuffer__f_last0 = last0
  };
  return this
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = $n(xs).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var fresh = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(it);
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    if ((this.scm_ListBuffer__f_len === 0)) {
      this.scm_ListBuffer__f_first = $n(fresh).scm_ListBuffer__f_first
    } else {
      $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_next = $n(fresh).scm_ListBuffer__f_first
    };
    this.scm_ListBuffer__f_last0 = $n(fresh).scm_ListBuffer__f_last0;
    this.scm_ListBuffer__f_len = ((this.scm_ListBuffer__f_len + $n(fresh).scm_ListBuffer__f_len) | 0)
  };
  return this
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if ((!this.isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n(this.scm_ListBuffer__f_first).head__O(), elem)) {
      this.scm_ListBuffer__f_first = $as_sci_List($n(this.scm_ListBuffer__f_first).tail__O());
      $p_scm_ListBuffer__reduceLengthBy__I__V(this, 1)
    } else {
      var cursor = this.scm_ListBuffer__f_first;
      while (((!$n($as_sci_List($n(cursor).tail__O())).isEmpty__Z()) && (!$m_sr_BoxesRunTime$().equals__O__O__Z($n($as_sc_IterableOps($n(cursor).tail__O())).head__O(), elem)))) {
        cursor = $as_sci_List($n(cursor).tail__O())
      };
      if ((!$n($as_sci_List($n(cursor).tail__O())).isEmpty__Z())) {
        var z = $as_sci_$colon$colon(cursor);
        var x = $n(z).sci_$colon$colon__f_next;
        var x$2 = this.scm_ListBuffer__f_last0;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          this.scm_ListBuffer__f_last0 = z
        };
        $n(z).sci_$colon$colon__f_next = $as_sci_List($n($as_sc_IterableOps($n(cursor).tail__O())).tail__O());
        $p_scm_ListBuffer__reduceLengthBy__I__V(this, 1)
      }
    }
  };
  return this
});
$c_scm_ListBuffer.prototype.remove__I__O = (function(idx) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if (((idx < 0) || (idx >= this.scm_ListBuffer__f_len))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (((-1) + this.scm_ListBuffer__f_len) | 0)) + ")"))
  };
  var p = $p_scm_ListBuffer__locate__I__sci_$colon$colon(this, idx);
  var nx = $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List(this, p);
  if ((p === null)) {
    this.scm_ListBuffer__f_first = $as_sci_List($n(nx).tail__O());
    if ($n(this.scm_ListBuffer__f_first).isEmpty__Z()) {
      this.scm_ListBuffer__f_last0 = null
    }
  } else {
    if ((this.scm_ListBuffer__f_last0 === nx)) {
      this.scm_ListBuffer__f_last0 = p
    };
    $n(p).sci_$colon$colon__f_next = $as_sci_List($n(nx).tail__O())
  };
  this.scm_ListBuffer__f_len = (((-1) + this.scm_ListBuffer__f_len) | 0);
  return $n(nx).head__O()
});
$c_scm_ListBuffer.prototype.last__O = (function() {
  if ((this.scm_ListBuffer__f_last0 === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty ListBuffer")
  } else {
    return $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_head
  }
});
$c_scm_ListBuffer.prototype.stringPrefix__T = (function() {
  return "ListBuffer"
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_ListBuffer(elem)
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return this.subtractOne__O__scm_ListBuffer(x)
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ListBuffer(xs)
});
$c_scm_ListBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ListBuffer(elem)
});
$c_scm_ListBuffer.prototype.result__O = (function() {
  return this.toList__sci_List()
});
$c_scm_ListBuffer.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = $n(this.scm_ListBuffer__f_first);
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i)
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ListBuffer$()
});
function $as_scm_ListBuffer(obj) {
  return (((obj instanceof $c_scm_ListBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ListBuffer"))
}
function $isArrayOf_scm_ListBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ListBuffer)))
}
function $asArrayOf_scm_ListBuffer(obj, depth) {
  return (($isArrayOf_scm_ListBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ListBuffer;", depth))
}
var $d_scm_ListBuffer = new $TypeData().initClass({
  scm_ListBuffer: 0
}, false, "scala.collection.mutable.ListBuffer", {
  scm_ListBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ListBuffer.prototype.$classData = $d_scm_ListBuffer;
/** @constructor */
function $c_sci_BitSet$BitSet1(elems) {
  this.sci_BitSet$BitSet1__f_elems = $L0;
  this.sci_BitSet$BitSet1__f_elems = elems
}
$c_sci_BitSet$BitSet1.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet1.prototype.constructor = $c_sci_BitSet$BitSet1;
/** @constructor */
function $h_sci_BitSet$BitSet1() {
  /*<skip>*/
}
$h_sci_BitSet$BitSet1.prototype = $c_sci_BitSet$BitSet1.prototype;
$c_sci_BitSet$BitSet1.prototype.nwords__I = (function() {
  return 1
});
$c_sci_BitSet$BitSet1.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet1__f_elems : $L0)
});
$c_sci_BitSet$BitSet1.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet1(w)
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet1__f_elems, w)
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J([this.sci_BitSet$BitSet1__f_elems]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
  }
});
$c_sci_BitSet$BitSet1.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var t = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet1__f_elems, 0);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (((lo === 0) && (hi === 0)) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(new $c_RTLong(lo, hi)))
});
var $d_sci_BitSet$BitSet1 = new $TypeData().initClass({
  sci_BitSet$BitSet1: 0
}, false, "scala.collection.immutable.BitSet$BitSet1", {
  sci_BitSet$BitSet1: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$BitSet1.prototype.$classData = $d_sci_BitSet$BitSet1;
/** @constructor */
function $c_sci_BitSet$BitSet2(elems0, elems1) {
  this.sci_BitSet$BitSet2__f_elems0 = $L0;
  this.sci_BitSet$BitSet2__f_elems1 = $L0;
  this.sci_BitSet$BitSet2__f_elems0 = elems0;
  this.sci_BitSet$BitSet2__f_elems1 = elems1
}
$c_sci_BitSet$BitSet2.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet2.prototype.constructor = $c_sci_BitSet$BitSet2;
/** @constructor */
function $h_sci_BitSet$BitSet2() {
  /*<skip>*/
}
$h_sci_BitSet$BitSet2.prototype = $c_sci_BitSet$BitSet2.prototype;
$c_sci_BitSet$BitSet2.prototype.nwords__I = (function() {
  return 2
});
$c_sci_BitSet$BitSet2.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet2__f_elems0 : ((idx === 1) ? this.sci_BitSet$BitSet2__f_elems1 : $L0))
});
$c_sci_BitSet$BitSet2.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet2(w, this.sci_BitSet$BitSet2__f_elems1)
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet2__f_elems0, w)
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J([this.sci_BitSet$BitSet2__f_elems0, this.sci_BitSet$BitSet2__f_elems1]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
  }
});
$c_sci_BitSet$BitSet2.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var t = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet2__f_elems0, 0);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet2__f_elems1, 1);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return (((lo$1 === 0) && (hi$1 === 0)) ? (((lo === 0) && (hi === 0)) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(new $c_RTLong(lo, hi))) : new $c_sci_BitSet$BitSet2(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1)))
});
var $d_sci_BitSet$BitSet2 = new $TypeData().initClass({
  sci_BitSet$BitSet2: 0
}, false, "scala.collection.immutable.BitSet$BitSet2", {
  sci_BitSet$BitSet2: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$BitSet2.prototype.$classData = $d_sci_BitSet$BitSet2;
/** @constructor */
function $c_sci_BitSet$BitSetN(elems) {
  this.sci_BitSet$BitSetN__f_elems = null;
  this.sci_BitSet$BitSetN__f_elems = elems
}
$c_sci_BitSet$BitSetN.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSetN.prototype.constructor = $c_sci_BitSet$BitSetN;
/** @constructor */
function $h_sci_BitSet$BitSetN() {
  /*<skip>*/
}
$h_sci_BitSet$BitSetN.prototype = $c_sci_BitSet$BitSetN.prototype;
$c_sci_BitSet$BitSetN.prototype.nwords__I = (function() {
  return $n(this.sci_BitSet$BitSetN__f_elems).u.length
});
$c_sci_BitSet$BitSetN.prototype.word__I__J = (function(idx) {
  return ((idx < this.nwords__I()) ? $n(this.sci_BitSet$BitSetN__f_elems).get(idx) : $L0)
});
$c_sci_BitSet$BitSetN.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(this.sci_BitSet$BitSetN__f_elems, idx, w);
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
});
$c_sci_BitSet$BitSetN.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var i = (((-1) + this.nwords__I()) | 0);
  var currentWord__lo = 0;
  var currentWord__hi = 0;
  var anyChanges = false;
  while (true) {
    if ((i >= 0)) {
      var this$1__lo = currentWord__lo;
      var this$1__hi = currentWord__hi;
      var $$x2 = ((this$1__lo === 0) && (this$1__hi === 0))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var t = this.word__I__J(i);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, new $c_RTLong(lo, hi), i);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$1;
      currentWord__lo = $$x1__lo;
      currentWord__hi = $$x1__hi;
      if (anyChanges) {
        anyChanges = true
      } else {
        var this$2__lo = currentWord__lo;
        var this$2__hi = currentWord__hi;
        anyChanges = (!((this$2__lo === lo) && (this$2__hi === hi)))
      };
      i = (((-1) + i) | 0)
    } else {
      break
    }
  };
  var x1 = i;
  switch (x1) {
    case (-1): {
      if (anyChanges) {
        var this$3__lo = currentWord__lo;
        var this$3__hi = currentWord__hi;
        if (((this$3__lo === 0) && (this$3__hi === 0))) {
          return $m_sci_BitSet$().sci_BitSet$__f_empty
        } else {
          return new $c_sci_BitSet$BitSet1(new $c_RTLong(currentWord__lo, currentWord__hi))
        }
      } else {
        return this
      };
      break
    }
    case 0: {
      var t$2 = this.word__I__J(0);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var t$3 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, new $c_RTLong(lo$2, hi$2), 0);
      var lo$3 = t$3.RTLong__f_lo;
      var hi$3 = t$3.RTLong__f_hi;
      anyChanges = (anyChanges || (!((lo$3 === lo$2) && (hi$3 === hi$2))));
      return (anyChanges ? new $c_sci_BitSet$BitSet2(new $c_RTLong(lo$3, hi$3), new $c_RTLong(currentWord__lo, currentWord__hi)) : this);
      break
    }
    default: {
      var minimumNonZeroIndex = ((1 + i) | 0);
      while (((!anyChanges) && (i >= 0))) {
        var t$4 = this.word__I__J(i);
        var lo$4 = t$4.RTLong__f_lo;
        var hi$4 = t$4.RTLong__f_hi;
        var t$5 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, new $c_RTLong(lo$4, hi$4), i);
        var lo$5 = t$5.RTLong__f_lo;
        var hi$5 = t$5.RTLong__f_hi;
        var $$x3__lo = lo$5;
        var $$x3__hi = hi$5;
        currentWord__lo = $$x3__lo;
        currentWord__hi = $$x3__hi;
        if (anyChanges) {
          anyChanges = true
        } else {
          var this$4__lo = currentWord__lo;
          var this$4__hi = currentWord__hi;
          anyChanges = (!((this$4__lo === lo$4) && (this$4__hi === hi$4)))
        };
        i = (((-1) + i) | 0)
      };
      if (anyChanges) {
        $m_sc_ArrayOps$();
        var xs = this.sci_BitSet$BitSetN__f_elems;
        var n = ((1 + minimumNonZeroIndex) | 0);
        var newArray = $asArrayOf_J($m_sc_ArrayOps$().slice$extension__O__I__I__O(xs, 0, n), 1);
        $n(newArray).set(((1 + i) | 0), new $c_RTLong(currentWord__lo, currentWord__hi));
        while ((i >= 0)) {
          $n(newArray).set(i, $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.word__I__J(i), i));
          i = (((-1) + i) | 0)
        };
        return new $c_sci_BitSet$BitSetN(newArray)
      } else {
        return this
      }
    }
  }
});
var $d_sci_BitSet$BitSetN = new $TypeData().initClass({
  sci_BitSet$BitSetN: 0
}, false, "scala.collection.immutable.BitSet$BitSetN", {
  sci_BitSet$BitSetN: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$BitSetN.prototype.$classData = $d_sci_BitSet$BitSetN;
function $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap($thiz, t) {
  return ((t === $thiz.sci_TreeMap__f_tree) ? $thiz : $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), t, $thiz.sci_TreeMap__f_ordering))
}
function $p_sci_TreeMap__countWhile__F1__I($thiz, p) {
  var result = 0;
  $m_sci_RedBlackTree$();
  var tree = $thiz.sci_TreeMap__f_tree;
  $m_sci_RedBlackTree$();
  var start = $m_s_None$();
  var evidence$16 = $thiz.sci_TreeMap__f_ordering;
  var it = new $c_sci_RedBlackTree$EntriesIterator(tree, start, evidence$16);
  while ((it.hasNext__Z() && $uZ($n(p).apply__O__O(it.next__O())))) {
    result = ((1 + result) | 0)
  };
  return result
}
function $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, tree, ordering) {
  $thiz.sci_TreeMap__f_tree = tree;
  $thiz.sci_TreeMap__f_ordering = ordering;
  return $thiz
}
function $ct_sci_TreeMap__s_math_Ordering__($thiz, ordering) {
  $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, null, ordering);
  return $thiz
}
/** @constructor */
function $c_sci_TreeMap() {
  this.sci_TreeMap__f_tree = null;
  this.sci_TreeMap__f_ordering = null
}
$c_sci_TreeMap.prototype = new $h_sci_AbstractMap();
$c_sci_TreeMap.prototype.constructor = $c_sci_TreeMap;
/** @constructor */
function $h_sci_TreeMap() {
  /*<skip>*/
}
$h_sci_TreeMap.prototype = $c_sci_TreeMap.prototype;
$c_sci_TreeMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f)
});
$c_sci_TreeMap.prototype.collect__s_PartialFunction__sc_IterableOps = (function(pf) {
  return $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this, pf)
});
$c_sci_TreeMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_TreeMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_TreeMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf)
});
$c_sci_TreeMap.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sci_TreeMap.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_TreeMap.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sci_TreeMap.prototype.stringPrefix__T = (function() {
  return "SortedMap"
});
$c_sci_TreeMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  var evidence$39 = this.sci_TreeMap__f_ordering;
  return new $c_sci_TreeMap$TreeMapBuilder(evidence$39)
});
$c_sci_TreeMap.prototype.ordering__s_math_Ordering = (function() {
  return this.sci_TreeMap__f_ordering
});
$c_sci_TreeMap.prototype.sortedMapFactory__sc_SortedMapFactory = (function() {
  return $m_sci_TreeMap$()
});
$c_sci_TreeMap.prototype.iterator__sc_Iterator = (function() {
  $m_sci_RedBlackTree$();
  var tree = this.sci_TreeMap__f_tree;
  $m_sci_RedBlackTree$();
  var start = $m_s_None$();
  var evidence$16 = this.sci_TreeMap__f_ordering;
  return new $c_sci_RedBlackTree$EntriesIterator(tree, start, evidence$16)
});
$c_sci_TreeMap.prototype.get__O__s_Option = (function(key) {
  return $m_sci_RedBlackTree$().get__sci_RedBlackTree$Tree__O__s_math_Ordering__s_Option(this.sci_TreeMap__f_tree, key, this.sci_TreeMap__f_ordering)
});
$c_sci_TreeMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var resultOrNull = $m_sci_RedBlackTree$().lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, key, this.sci_TreeMap__f_ordering);
  if ((resultOrNull === null)) {
    return $n(default$1).apply__O()
  } else {
    var this$1 = $n(resultOrNull);
    return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value
  }
});
$c_sci_TreeMap.prototype.removed__O__sci_TreeMap = (function(key) {
  return $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap(this, $m_sci_RedBlackTree$().delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, key, this.sci_TreeMap__f_ordering))
});
$c_sci_TreeMap.prototype.updated__O__O__sci_TreeMap = (function(key, value) {
  return $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap(this, $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, key, value, true, this.sci_TreeMap__f_ordering))
});
$c_sci_TreeMap.prototype.concat__sc_IterableOnce__sci_TreeMap = (function(that) {
  matchEnd5: {
    var $$x1;
    if ((that instanceof $c_sci_TreeMap)) {
      var x2 = $as_sci_TreeMap(that);
      var x = this.sci_TreeMap__f_ordering;
      var x$2 = $n(x2).sci_TreeMap__f_ordering;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var $$x1 = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, $n(x2).sci_TreeMap__f_tree, this.sci_TreeMap__f_ordering);
        break matchEnd5
      }
    };
    if ($is_sci_LinearSeq(that)) {
      var x3 = $as_sci_LinearSeq(that);
      if ($n(x3).isEmpty__Z()) {
        var $$x1 = this.sci_TreeMap__f_tree;
        break matchEnd5
      } else {
        var adder = new $c_sci_TreeMap$Adder(this);
        adder.addAll__sci_LinearSeq__V(x3);
        var $$x1 = adder.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(adder.sci_TreeMap$Adder__f_currentMutableTree);
        break matchEnd5
      }
    };
    var adder$2 = new $c_sci_TreeMap$Adder(this);
    var it = $n(that).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      adder$2.apply__T2__V($as_T2($n(it).next__O()))
    };
    var $$x1 = adder$2.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(adder$2.sci_TreeMap$Adder__f_currentMutableTree)
  };
  return $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap(this, $$x1)
});
$c_sci_TreeMap.prototype.foreach__F1__V = (function(f) {
  $m_sci_RedBlackTree$().foreach__sci_RedBlackTree$Tree__F1__V(this.sci_TreeMap__f_tree, f)
});
$c_sci_TreeMap.prototype.foreachEntry__F2__V = (function(f) {
  $m_sci_RedBlackTree$().foreachEntry__sci_RedBlackTree$Tree__F2__V(this.sci_TreeMap__f_tree, f)
});
$c_sci_TreeMap.prototype.size__I = (function() {
  return $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree)
});
$c_sci_TreeMap.prototype.knownSize__I = (function() {
  return $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree)
});
$c_sci_TreeMap.prototype.isEmpty__Z = (function() {
  return ($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree) === 0)
});
$c_sci_TreeMap.prototype.head__T2 = (function() {
  var smallest = $m_sci_RedBlackTree$().smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree);
  var this$1 = $n(smallest);
  var $$x1 = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
  var this$2 = $n(smallest);
  return $ct_T2__O__O__(new $c_T2(), $$x1, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value)
});
$c_sci_TreeMap.prototype.tail__sci_TreeMap = (function() {
  return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), $m_sci_RedBlackTree$().tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree), this.sci_TreeMap__f_ordering)
});
$c_sci_TreeMap.prototype.drop__I__sci_TreeMap = (function(n) {
  if ((n <= 0)) {
    return this
  } else if ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree))) {
    var evidence$36 = this.sci_TreeMap__f_ordering;
    return $ct_sci_TreeMap__s_math_Ordering__(new $c_sci_TreeMap(), evidence$36)
  } else {
    return $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), $m_sci_RedBlackTree$().drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, n, this.sci_TreeMap__f_ordering), this.sci_TreeMap__f_ordering)
  }
});
$c_sci_TreeMap.prototype.take__I__sci_TreeMap = (function(n) {
  if ((n <= 0)) {
    var evidence$36 = this.sci_TreeMap__f_ordering;
    return $ct_sci_TreeMap__s_math_Ordering__(new $c_sci_TreeMap(), evidence$36)
  } else {
    return ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree)) ? this : $ct_sci_TreeMap__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeMap(), $m_sci_RedBlackTree$().take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, n, this.sci_TreeMap__f_ordering), this.sci_TreeMap__f_ordering))
  }
});
$c_sci_TreeMap.prototype.dropRight__I__sci_TreeMap = (function(n) {
  return this.take__I__sci_TreeMap((($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeMap__f_tree) - ((n > 0) ? n : 0)) | 0))
});
$c_sci_TreeMap.prototype.dropWhile__F1__sci_TreeMap = (function(p) {
  return this.drop__I__sci_TreeMap($p_sci_TreeMap__countWhile__F1__I(this, p))
});
$c_sci_TreeMap.prototype.takeWhile__F1__sci_TreeMap = (function(p) {
  return this.take__I__sci_TreeMap($p_sci_TreeMap__countWhile__F1__I(this, p))
});
$c_sci_TreeMap.prototype.filter__F1__sci_TreeMap = (function(f) {
  return $p_sci_TreeMap__newMapOrSelf__sci_RedBlackTree$Tree__sci_TreeMap(this, $m_sci_RedBlackTree$().filterEntries__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree(this.sci_TreeMap__f_tree, new $c_sjsr_AnonFunction2(((k$2, v$2) => $uZ($n(f).apply__O__O($ct_T2__O__O__(new $c_T2(), k$2, v$2)))))))
});
$c_sci_TreeMap.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_sci_TreeMap)) {
    var x2 = $as_sci_TreeMap(obj);
    var x = this.sci_TreeMap__f_ordering;
    var x$2 = $n(x2).sci_TreeMap__f_ordering;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return $m_sci_RedBlackTree$().entriesEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z(this.sci_TreeMap__f_tree, $n(x2).sci_TreeMap__f_tree, this.sci_TreeMap__f_ordering)
    }
  };
  return $f_sc_SortedMap__equals__O__Z(this, obj)
});
$c_sci_TreeMap.prototype.className__T = (function() {
  return "TreeMap"
});
$c_sci_TreeMap.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sc_SortedMapOps$WithFilter(this, p)
});
$c_sci_TreeMap.prototype.withFilter__F1__sc_MapOps$WithFilter = (function(p) {
  return new $c_sc_SortedMapOps$WithFilter(this, p)
});
$c_sci_TreeMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_TreeMap$();
  var evidence$37 = this.sci_TreeMap__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap(coll, evidence$37)
});
$c_sci_TreeMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_TreeMap$();
  var evidence$37 = this.sci_TreeMap__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeMap(coll, evidence$37)
});
$c_sci_TreeMap.prototype.$plus__T2__sc_IterableOps = (function(kv) {
  var key = $n(kv)._1__O();
  var value = $n(kv)._2__O();
  return this.updated__O__O__sci_TreeMap(key, value)
});
$c_sci_TreeMap.prototype.$plus__T2__sci_MapOps = (function(kv) {
  var key = $n(kv)._1__O();
  var value = $n(kv)._2__O();
  return this.updated__O__O__sci_TreeMap(key, value)
});
$c_sci_TreeMap.prototype.withDefaultValue__O__sci_Map = (function(d) {
  return $f_sci_SortedMap__withDefaultValue__O__sci_SortedMap(this, d)
});
$c_sci_TreeMap.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_TreeMap(pred)
});
$c_sci_TreeMap.prototype.takeWhile__F1__O = (function(p) {
  return this.takeWhile__F1__sci_TreeMap(p)
});
$c_sci_TreeMap.prototype.dropWhile__F1__O = (function(p) {
  return this.dropWhile__F1__sci_TreeMap(p)
});
$c_sci_TreeMap.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_TreeMap(n)
});
$c_sci_TreeMap.prototype.take__I__O = (function(n) {
  return this.take__I__sci_TreeMap(n)
});
$c_sci_TreeMap.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_TreeMap(n)
});
$c_sci_TreeMap.prototype.tail__O = (function() {
  return this.tail__sci_TreeMap()
});
$c_sci_TreeMap.prototype.head__O = (function() {
  return this.head__T2()
});
$c_sci_TreeMap.prototype.concat__sc_IterableOnce__sc_Map = (function(xs) {
  return this.concat__sc_IterableOnce__sci_TreeMap(xs)
});
$c_sci_TreeMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_TreeMap(key, value)
});
$c_sci_TreeMap.prototype.updated__O__O__sci_Map = (function(key, value) {
  return this.updated__O__O__sci_TreeMap(key, value)
});
$c_sci_TreeMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_TreeMap(key)
});
$c_sci_TreeMap.prototype.keySet__sc_Set = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), this.sci_TreeMap__f_tree, this.sci_TreeMap__f_ordering)
});
$c_sci_TreeMap.prototype.keySet__sci_Set = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), this.sci_TreeMap__f_tree, this.sci_TreeMap__f_ordering)
});
function $as_sci_TreeMap(obj) {
  return (((obj instanceof $c_sci_TreeMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeMap"))
}
function $isArrayOf_sci_TreeMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeMap)))
}
function $asArrayOf_sci_TreeMap(obj, depth) {
  return (($isArrayOf_sci_TreeMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeMap;", depth))
}
var $d_sci_TreeMap = new $TypeData().initClass({
  sci_TreeMap: 0
}, false, "scala.collection.immutable.TreeMap", {
  sci_TreeMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_SortedMap: 1,
  sc_SortedMap: 1,
  sc_SortedMapOps: 1,
  sc_SortedOps: 1,
  sc_SortedMapFactoryDefaults: 1,
  sci_SortedMapOps: 1,
  sci_StrictOptimizedSortedMapOps: 1,
  sc_StrictOptimizedSortedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedMapOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_TreeMap.prototype.$classData = $d_sci_TreeMap;
function $p_scm_ArrayBuffer__reduceToSize__I__V($thiz, n) {
  $thiz.scm_ArrayBuffer__f_mutationCount = ((1 + $thiz.scm_ArrayBuffer__f_mutationCount) | 0);
  var a = $thiz.scm_ArrayBuffer__f_array;
  var toIndex = $thiz.scm_ArrayBuffer__f_size0;
  $m_ju_Arrays$().fill__AO__I__I__O__V(a, n, toIndex, null);
  $thiz.scm_ArrayBuffer__f_size0 = n
}
function $p_scm_ArrayBuffer__foldl__I__I__O__F2__O($thiz, start, end, z, op) {
  while (true) {
    if ((start === end)) {
      return z
    } else {
      var temp$start = ((1 + start) | 0);
      var temp$z = $n(op).apply__O__O__O(z, $n($thiz.scm_ArrayBuffer__f_array).get(start));
      start = temp$start;
      z = temp$z
    }
  }
}
function $ct_scm_ArrayBuffer__AO__I__($thiz, initialElements, initialSize) {
  $thiz.scm_ArrayBuffer__f_mutationCount = 0;
  $thiz.scm_ArrayBuffer__f_array = initialElements;
  $thiz.scm_ArrayBuffer__f_size0 = initialSize;
  return $thiz
}
function $ct_scm_ArrayBuffer__($thiz) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(16), 0);
  return $thiz
}
function $ct_scm_ArrayBuffer__I__($thiz, initialSize) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(((initialSize > 1) ? initialSize : 1)), 0);
  return $thiz
}
/** @constructor */
function $c_scm_ArrayBuffer() {
  this.scm_ArrayBuffer__f_mutationCount = 0;
  this.scm_ArrayBuffer__f_array = null;
  this.scm_ArrayBuffer__f_size0 = 0
}
$c_scm_ArrayBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayBuffer.prototype.constructor = $c_scm_ArrayBuffer;
/** @constructor */
function $h_scm_ArrayBuffer() {
  /*<skip>*/
}
$h_scm_ArrayBuffer.prototype = $c_scm_ArrayBuffer.prototype;
$c_scm_ArrayBuffer.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_scm_ArrayBuffer.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem)
});
$c_scm_ArrayBuffer.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem)
});
$c_scm_ArrayBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArrayBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArrayBuffer.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_ArrayBuffer.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_scm_ArrayBuffer.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_scm_ArrayBuffer.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_scm_ArrayBuffer.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_scm_ArrayBuffer.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_scm_ArrayBuffer.prototype.iterator__sc_Iterator = (function() {
  return $n(this.view__scm_ArrayBufferView()).iterator__sc_Iterator()
});
$c_scm_ArrayBuffer.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.view__scm_ArrayBufferView()).reverseIterator__sc_Iterator()
});
$c_scm_ArrayBuffer.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_scm_ArrayBuffer.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_scm_ArrayBuffer.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArrayBuffer.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this)
});
$c_scm_ArrayBuffer.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_scm_ArrayBuffer.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_scm_ArrayBuffer.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_scm_ArrayBuffer.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_ArrayBuffer__f_size0;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArrayBuffer.prototype.knownSize__I = (function() {
  return this.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBuffer.prototype.ensureSize__I__V = (function(n) {
  var $$x3 = $m_scm_ArrayBuffer$();
  var $$x2 = this.scm_ArrayBuffer__f_array;
  var $$x1 = this.scm_ArrayBuffer__f_size0;
  var hi = (n >> 31);
  this.scm_ArrayBuffer__f_array = $n($$x3).scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__J__AO($$x2, $$x1, new $c_RTLong(n, hi))
});
$c_scm_ArrayBuffer.prototype.ensureAdditionalSize__I__V = (function(n) {
  var $$x3 = $m_scm_ArrayBuffer$();
  var $$x2 = this.scm_ArrayBuffer__f_array;
  var $$x1 = this.scm_ArrayBuffer__f_size0;
  var value = this.scm_ArrayBuffer__f_size0;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value + n) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
  this.scm_ArrayBuffer__f_array = $n($$x3).scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__J__AO($$x2, $$x1, new $c_RTLong(lo, hi$2))
});
$c_scm_ArrayBuffer.prototype.apply__I__O = (function(n) {
  var hi = ((1 + n) | 0);
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((n + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  return $n(this.scm_ArrayBuffer__f_array).get(n)
});
$c_scm_ArrayBuffer.prototype.update__I__O__V = (function(index, elem) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  $n(this.scm_ArrayBuffer__f_array).set(index, elem)
});
$c_scm_ArrayBuffer.prototype.length__I = (function() {
  return this.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBuffer.prototype.view__scm_ArrayBufferView = (function() {
  return new $c_scm_ArrayBufferView(this, new $c_sjsr_AnonFunction0((() => this.scm_ArrayBuffer__f_mutationCount)))
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayBuffer$()
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_ArrayBuffer = (function(elem) {
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  this.ensureAdditionalSize__I__V(1);
  var oldSize = this.scm_ArrayBuffer__f_size0;
  this.scm_ArrayBuffer__f_size0 = ((1 + oldSize) | 0);
  this.update__I__O__V(oldSize, elem);
  return this
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_ArrayBuffer = (function(elems) {
  if ((elems instanceof $c_scm_ArrayBuffer)) {
    var x2 = $as_scm_ArrayBuffer(elems);
    var elemsLength = $n(x2).scm_ArrayBuffer__f_size0;
    if ((elemsLength > 0)) {
      this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
      this.ensureAdditionalSize__I__V(elemsLength);
      $m_s_Array$().copy__O__I__O__I__I__V($n(x2).scm_ArrayBuffer__f_array, 0, this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, elemsLength);
      this.scm_ArrayBuffer__f_size0 = ((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0)
    }
  } else {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems)
  };
  return this
});
$c_scm_ArrayBuffer.prototype.remove__I__O = (function(index) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  var res = this.apply__I__O(index);
  $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, ((1 + index) | 0), this.scm_ArrayBuffer__f_array, index, ((this.scm_ArrayBuffer__f_size0 - ((1 + index) | 0)) | 0));
  $p_scm_ArrayBuffer__reduceToSize__I__V(this, (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  return res
});
$c_scm_ArrayBuffer.prototype.stringPrefix__T = (function() {
  return "ArrayBuffer"
});
$c_scm_ArrayBuffer.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.scm_ArrayBuffer__f_size0;
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, 0, xs, start, copied)
  };
  return copied
});
$c_scm_ArrayBuffer.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 0, this.scm_ArrayBuffer__f_size0, z, op)
});
$c_scm_ArrayBuffer.prototype.reduceLeft__F2__O = (function(op) {
  return ((this.scm_ArrayBuffer__f_size0 > 0) ? $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 1, this.scm_ArrayBuffer__f_size0, $n(this.scm_ArrayBuffer__f_array).get(0), op) : $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op))
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuffer(xs)
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuffer(elem)
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArrayBuffer$()
});
$c_scm_ArrayBuffer.prototype.view__sc_SeqView = (function() {
  return this.view__scm_ArrayBufferView()
});
$c_scm_ArrayBuffer.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
function $as_scm_ArrayBuffer(obj) {
  return (((obj instanceof $c_scm_ArrayBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayBuffer"))
}
function $isArrayOf_scm_ArrayBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayBuffer)))
}
function $asArrayOf_scm_ArrayBuffer(obj, depth) {
  return (($isArrayOf_scm_ArrayBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayBuffer;", depth))
}
var $d_scm_ArrayBuffer = new $TypeData().initClass({
  scm_ArrayBuffer: 0
}, false, "scala.collection.mutable.ArrayBuffer", {
  scm_ArrayBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuffer.prototype.$classData = $d_scm_ArrayBuffer;
function $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__($thiz, tree, ordering) {
  $thiz.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree = tree;
  $thiz.scm_TreeSet__f_ordering = ordering;
  if ((ordering === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "ordering must not be null")
  };
  return $thiz
}
function $ct_scm_TreeSet__s_math_Ordering__($thiz, ord) {
  $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__($thiz, new $c_scm_RedBlackTree$Tree(null, 0), ord);
  return $thiz
}
/** @constructor */
function $c_scm_TreeSet() {
  this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree = null;
  this.scm_TreeSet__f_ordering = null
}
$c_scm_TreeSet.prototype = new $h_scm_AbstractSet();
$c_scm_TreeSet.prototype.constructor = $c_scm_TreeSet;
/** @constructor */
function $h_scm_TreeSet() {
  /*<skip>*/
}
$h_scm_TreeSet.prototype = $c_scm_TreeSet.prototype;
$c_scm_TreeSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  var evidence$12 = this.scm_TreeSet__f_ordering;
  var b = new $c_scm_TreeSet$$anon$1(evidence$12);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, this);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, that);
  return b.result__scm_TreeSet()
});
$c_scm_TreeSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_TreeSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_TreeSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_scm_TreeSet.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_scm_TreeSet.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_scm_TreeSet.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_scm_TreeSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_scm_TreeSet.prototype.stringPrefix__T = (function() {
  return "SortedSet"
});
$c_scm_TreeSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_scm_TreeSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  var evidence$12 = this.scm_TreeSet__f_ordering;
  return new $c_scm_TreeSet$$anon$1(evidence$12)
});
$c_scm_TreeSet.prototype.ordering__s_math_Ordering = (function() {
  return this.scm_TreeSet__f_ordering
});
$c_scm_TreeSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_scm_TreeSet$()
});
$c_scm_TreeSet.prototype.iterator__sc_Iterator = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  var start = $m_s_None$();
  var end = $m_s_None$();
  var evidence$4 = this.scm_TreeSet__f_ordering;
  return new $c_scm_RedBlackTree$KeysIterator(tree, start, end, evidence$4)
});
$c_scm_TreeSet.prototype.addOne__O__scm_TreeSet = (function(elem) {
  $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, null, this.scm_TreeSet__f_ordering);
  return this
});
$c_scm_TreeSet.prototype.subtractOne__O__scm_TreeSet = (function(elem) {
  $m_scm_RedBlackTree$().delete__scm_RedBlackTree$Tree__O__s_math_Ordering__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, this.scm_TreeSet__f_ordering);
  return this
});
$c_scm_TreeSet.prototype.contains__O__Z = (function(elem) {
  return $m_scm_RedBlackTree$().contains__scm_RedBlackTree$Tree__O__s_math_Ordering__Z(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, this.scm_TreeSet__f_ordering)
});
$c_scm_TreeSet.prototype.className__T = (function() {
  return "TreeSet"
});
$c_scm_TreeSet.prototype.size__I = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  return $n(tree).scm_RedBlackTree$Tree__f_size
});
$c_scm_TreeSet.prototype.knownSize__I = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  return $n(tree).scm_RedBlackTree$Tree__f_size
});
$c_scm_TreeSet.prototype.isEmpty__Z = (function() {
  return $m_scm_RedBlackTree$().isEmpty__scm_RedBlackTree$Tree__Z(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree)
});
$c_scm_TreeSet.prototype.head__O = (function() {
  return $n($m_scm_RedBlackTree$().minKey__scm_RedBlackTree$Tree__s_Option(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree)).get__O()
});
$c_scm_TreeSet.prototype.last__O = (function() {
  return $n($m_scm_RedBlackTree$().maxKey__scm_RedBlackTree$Tree__s_Option(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree)).get__O()
});
$c_scm_TreeSet.prototype.foreach__F1__V = (function(f) {
  $m_scm_RedBlackTree$().foreachKey__scm_RedBlackTree$Tree__F1__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, f)
});
$c_scm_TreeSet.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sc_SortedSetOps$WithFilter(this, p)
});
$c_scm_TreeSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_scm_TreeSet$();
  var evidence$5 = this.scm_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(coll, evidence$5)
});
$c_scm_TreeSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_scm_TreeSet$();
  var evidence$5 = this.scm_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(coll, evidence$5)
});
$c_scm_TreeSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_TreeSet(elem)
});
$c_scm_TreeSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_TreeSet(elem)
});
function $as_scm_TreeSet(obj) {
  return (((obj instanceof $c_scm_TreeSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.TreeSet"))
}
function $isArrayOf_scm_TreeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_TreeSet)))
}
function $asArrayOf_scm_TreeSet(obj, depth) {
  return (($isArrayOf_scm_TreeSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.TreeSet;", depth))
}
var $d_scm_TreeSet = new $TypeData().initClass({
  scm_TreeSet: 0
}, false, "scala.collection.mutable.TreeSet", {
  scm_TreeSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_TreeSet.prototype.$classData = $d_scm_TreeSet;
function $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, array) {
  $thiz.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = array;
  return $thiz
}
function $ct_sjs_js_WrappedArray__($thiz) {
  $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, []);
  return $thiz
}
/** @constructor */
function $c_sjs_js_WrappedArray() {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = null
}
$c_sjs_js_WrappedArray.prototype = new $h_scm_AbstractBuffer();
$c_sjs_js_WrappedArray.prototype.constructor = $c_sjs_js_WrappedArray;
/** @constructor */
function $h_sjs_js_WrappedArray() {
  /*<skip>*/
}
$h_sjs_js_WrappedArray.prototype = $c_sjs_js_WrappedArray.prototype;
$c_sjs_js_WrappedArray.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sjs_js_WrappedArray.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sjs_js_WrappedArray.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_sjs_js_WrappedArray.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sjs_js_WrappedArray.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_sjs_js_WrappedArray.prototype.prepended__O__O = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem)
});
$c_sjs_js_WrappedArray.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_sjs_js_WrappedArray.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sjs_js_WrappedArray.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n)
});
$c_sjs_js_WrappedArray.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_sjs_js_WrappedArray.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this)
});
$c_sjs_js_WrappedArray.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_sjs_js_WrappedArray.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_sjs_js_WrappedArray.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_sjs_js_WrappedArray.prototype.lengthCompare__I__I = (function(len) {
  var x = $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sjs_js_WrappedArray.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sjs_js_WrappedArray.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem)
});
$c_sjs_js_WrappedArray.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjs_js_WrappedArray.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sjs_js_WrappedArray.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_sjs_js_WrappedArray.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sjs_js_WrappedArray.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_sjs_js_WrappedArray.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjs_js_WrappedArray$()
});
$c_sjs_js_WrappedArray.prototype.apply__I__O = (function(index) {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index]
});
$c_sjs_js_WrappedArray.prototype.length__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)
});
$c_sjs_js_WrappedArray.prototype.knownSize__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)
});
$c_sjs_js_WrappedArray.prototype.remove__I__O = (function(n) {
  if (((n < 0) || (n >= $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.splice(n, 1)[0]
});
$c_sjs_js_WrappedArray.prototype.className__T = (function() {
  return "WrappedArray"
});
$c_sjs_js_WrappedArray.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this)
});
$c_sjs_js_WrappedArray.prototype.result__O = (function() {
  return this
});
$c_sjs_js_WrappedArray.prototype.addOne__O__scm_Growable = (function(elem) {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.push(elem);
  return this
});
$c_sjs_js_WrappedArray.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index]
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjs_js_WrappedArray$()
});
function $as_sjs_js_WrappedArray(obj) {
  return (((obj instanceof $c_sjs_js_WrappedArray) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.WrappedArray"))
}
function $isArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_WrappedArray)))
}
function $asArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (($isArrayOf_sjs_js_WrappedArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.WrappedArray;", depth))
}
var $d_sjs_js_WrappedArray = new $TypeData().initClass({
  sjs_js_WrappedArray: 0
}, false, "scala.scalajs.js.WrappedArray", {
  sjs_js_WrappedArray: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  scm_IndexedBuffer: 1,
  scm_Builder: 1,
  Ljava_io_Serializable: 1
});
$c_sjs_js_WrappedArray.prototype.$classData = $d_sjs_js_WrappedArray;
function $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, array, start, end) {
  var assertion = (($n(array).u.length & (((-1) + $n(array).u.length) | 0)) === 0);
  if ((!assertion)) {
    throw new $c_jl_AssertionError("assertion failed: Array.length must be power of 2")
  };
  var until = $n(array).u.length;
  if (((start < 0) || (start >= until))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((start + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"))
  };
  var until$1 = $n(array).u.length;
  if (((end < 0) || (end >= until$1))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((end + " is out of bounds (min 0, max ") + (((-1) + until$1) | 0)) + ")"))
  };
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end
}
function $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end) {
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end;
  $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, $thiz.scm_ArrayDeque__f_array, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end);
  return $thiz
}
function $ct_scm_ArrayDeque__I__($thiz, initialSize) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, $m_scm_ArrayDeque$().alloc__I__AO(initialSize), 0, 0);
  return $thiz
}
/** @constructor */
function $c_scm_ArrayDeque() {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0
}
$c_scm_ArrayDeque.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayDeque.prototype.constructor = $c_scm_ArrayDeque;
/** @constructor */
function $h_scm_ArrayDeque() {
  /*<skip>*/
}
$h_scm_ArrayDeque.prototype = $c_scm_ArrayDeque.prototype;
$c_scm_ArrayDeque.prototype.reverse__O = (function() {
  return $f_scm_ArrayDequeOps__reverse__O(this)
});
$c_scm_ArrayDeque.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_scm_ArrayDeque.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem)
});
$c_scm_ArrayDeque.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem)
});
$c_scm_ArrayDeque.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArrayDeque.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArrayDeque.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_ArrayDeque.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_scm_ArrayDeque.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_scm_ArrayDeque.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false)
});
$c_scm_ArrayDeque.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true)
});
$c_scm_ArrayDeque.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_scm_ArrayDeque.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_scm_ArrayDeque.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_scm_ArrayDeque.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this)
});
$c_scm_ArrayDeque.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n)
});
$c_scm_ArrayDeque.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArrayDeque.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this)
});
$c_scm_ArrayDeque.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this)
});
$c_scm_ArrayDeque.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this)
});
$c_scm_ArrayDeque.prototype.lengthCompare__I__I = (function(len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var x = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArrayDeque.prototype.knownSize__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))
});
$c_scm_ArrayDeque.prototype.apply__I__O = (function(idx) {
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var until = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"))
  };
  return $n(this.scm_ArrayDeque__f_array).get((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)))
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_ArrayDeque = (function(elem) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var hint = ((1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))) | 0);
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))) && (hint >= $n(this.scm_ArrayDeque__f_array).u.length))) {
    this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint)
  };
  $n(this.scm_ArrayDeque__f_array).set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end, elem);
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  return this
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_ArrayDeque = (function(elems) {
  var x1 = $n(elems).knownSize__I();
  if ((x1 > 0)) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var hint = ((x1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))) | 0);
    var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))) && (hint >= $n(this.scm_ArrayDeque__f_array).u.length))) {
      this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint)
    };
    var this$1 = $n($n(elems).iterator__sc_Iterator());
    while (this$1.hasNext__Z()) {
      var arg1 = this$1.next__O();
      $n(this.scm_ArrayDeque__f_array).set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end, arg1);
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))
    }
  } else {
    var this$2 = $n($n(elems).iterator__sc_Iterator());
    while (this$2.hasNext__Z()) {
      var arg1$1 = this$2.next__O();
      this.addOne__O__scm_ArrayDeque(arg1$1)
    }
  };
  return this
});
$c_scm_ArrayDeque.prototype.remove__I__I__V = (function(idx, count) {
  if ((count > 0)) {
    var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var until = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
    if (((idx < 0) || (idx >= until))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"))
    };
    var idx$2 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var n = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$2) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
    var a = ((n - idx) | 0);
    var removals = ((a < count) ? a : count);
    var finalLength = ((n - removals) | 0);
    var suffixStart = ((idx + removals) | 0);
    if ((($n(this.scm_ArrayDeque__f_array).u.length > 128) && ((((($n(this.scm_ArrayDeque__f_array).u.length - finalLength) | 0) - (finalLength >> 1)) | 0) > finalLength))) {
      var array2 = $m_scm_ArrayDeque$().alloc__I__AO(finalLength);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, array2, 0, idx);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, suffixStart, array2, idx, n);
      $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, finalLength)
    } else if (((idx << 1) <= finalLength)) {
      var i = (((-1) + suffixStart) | 0);
      while ((i >= removals)) {
        var idx$4 = i;
        var idx$3 = ((i - removals) | 0);
        var elem = $n(this.scm_ArrayDeque__f_array).get((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$3) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)));
        $n(this.scm_ArrayDeque__f_array).set((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$4) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)), elem);
        i = (((-1) + i) | 0)
      };
      while ((i >= 0)) {
        var idx$5 = i;
        $n(this.scm_ArrayDeque__f_array).set((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$5) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)), null);
        i = (((-1) + i) | 0)
      };
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + removals) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))
    } else {
      var i$2 = idx;
      while ((i$2 < finalLength)) {
        var idx$7 = i$2;
        var idx$6 = ((i$2 + removals) | 0);
        var elem$1 = $n(this.scm_ArrayDeque__f_array).get((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$6) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)));
        $n(this.scm_ArrayDeque__f_array).set((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$7) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)), elem$1);
        i$2 = ((1 + i$2) | 0)
      };
      while ((i$2 < n)) {
        var idx$8 = i$2;
        $n(this.scm_ArrayDeque__f_array).set((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$8) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)), null);
        i$2 = ((1 + i$2) | 0)
      };
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - removals) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))
    }
  } else {
    var requirement = (count === 0);
    if ((!requirement)) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "removing negative number of elements: ") + count))
    }
  }
});
$c_scm_ArrayDeque.prototype.remove__I__O = (function(idx) {
  var elem = this.apply__I__O(idx);
  this.remove__I__I__V(idx, 1);
  return elem
});
$c_scm_ArrayDeque.prototype.subtractOne__O__scm_ArrayDeque = (function(elem) {
  var idx = $f_sc_SeqOps__indexOf__O__I__I(this, elem, 0);
  if ((idx >= 0)) {
    this.remove__I__I__V(idx, 1)
  };
  return this
});
$c_scm_ArrayDeque.prototype.removeHead__Z__O = (function(resizeInternalRepr) {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty collection")
  } else {
    var elem = $n(this.scm_ArrayDeque__f_array).get(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start);
    $n(this.scm_ArrayDeque__f_array).set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start, null);
    this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
    if (resizeInternalRepr) {
      var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
      this.scala$collection$mutable$ArrayDeque$$resize__I__V((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)))
    };
    return elem
  }
});
$c_scm_ArrayDeque.prototype.length__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))
});
$c_scm_ArrayDeque.prototype.isEmpty__Z = (function() {
  return (this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start === this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end)
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayDeque$()
});
$c_scm_ArrayDeque.prototype.ofArray__AO__I__scm_ArrayDeque = (function(array, end) {
  return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, end)
});
$c_scm_ArrayDeque.prototype.copyToArray__O__I__I__I = (function(dest, destStart, len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var srcLen = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  var destLen = $m_jl_reflect_Array$().getLength__O__I(dest);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - destStart) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, destStart, len)
  };
  return copied
});
$c_scm_ArrayDeque.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$1) {
  var $$x1 = $n(evidence$1);
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var dest = $n($$x1).newArray__I__O((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)));
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var maxItems = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  return $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, maxItems)
});
$c_scm_ArrayDeque.prototype.scala$collection$mutable$ArrayDeque$$resize__I__V = (function(len) {
  if (((len >= $n(this.scm_ArrayDeque__f_array).u.length) || (($n(this.scm_ArrayDeque__f_array).u.length > 16) && ((($n(this.scm_ArrayDeque__f_array).u.length - len) | 0) > len)))) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var n = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
    var dest = $m_scm_ArrayDeque$().alloc__I__AO(len);
    var array2 = $asArrayOf_O($f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, n), 1);
    $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, n)
  }
});
$c_scm_ArrayDeque.prototype.stringPrefix__T = (function() {
  return "ArrayDeque"
});
$c_scm_ArrayDeque.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this)
});
$c_scm_ArrayDeque.prototype.ofArray__AO__I__O = (function(array, end) {
  return this.ofArray__AO__I__scm_ArrayDeque(array, end)
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_IterableFactory = (function() {
  return this.iterableFactory__sc_SeqFactory()
});
$c_scm_ArrayDeque.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_ArrayDeque(elem)
});
$c_scm_ArrayDeque.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return this.subtractOne__O__scm_ArrayDeque(x)
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayDeque(xs)
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayDeque(elem)
});
$c_scm_ArrayDeque.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
function $as_scm_ArrayDeque(obj) {
  return (((obj instanceof $c_scm_ArrayDeque) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayDeque"))
}
function $isArrayOf_scm_ArrayDeque(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayDeque)))
}
function $asArrayOf_scm_ArrayDeque(obj, depth) {
  return (($isArrayOf_scm_ArrayDeque(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayDeque;", depth))
}
var $d_scm_ArrayDeque = new $TypeData().initClass({
  scm_ArrayDeque: 0
}, false, "scala.collection.mutable.ArrayDeque", {
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayDeque.prototype.$classData = $d_scm_ArrayDeque;
function $ct_scm_BitSet__AJ__($thiz, elems) {
  $thiz.scm_BitSet__f_elems = elems;
  return $thiz
}
function $ct_scm_BitSet__I__($thiz, initSize) {
  var x = (((63 + initSize) | 0) >> 6);
  $ct_scm_BitSet__AJ__($thiz, new $ac_J(((x > 1) ? x : 1)));
  return $thiz
}
function $ct_scm_BitSet__($thiz) {
  $ct_scm_BitSet__I__($thiz, 0);
  return $thiz
}
/** @constructor */
function $c_scm_BitSet() {
  this.scm_BitSet__f_elems = null
}
$c_scm_BitSet.prototype = new $h_scm_AbstractSet();
$c_scm_BitSet.prototype.constructor = $c_scm_BitSet;
/** @constructor */
function $h_scm_BitSet() {
  /*<skip>*/
}
$h_scm_BitSet.prototype = $c_scm_BitSet.prototype;
$c_scm_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet"
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  var b = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(this);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(that);
  return $as_sc_BitSet($as_sc_SetOps(b.scm_GrowableBuilder__f_elems))
});
$c_scm_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$()
});
$c_scm_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0)
});
$c_scm_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this)
});
$c_scm_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this)
});
$c_scm_BitSet.prototype.foreach__F1__V = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f)
});
$c_scm_BitSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_BitSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_BitSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that)
});
$c_scm_BitSet.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_scm_BitSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__scm_BitSet(pred, false)
});
$c_scm_BitSet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__scm_BitSet(pred, true)
});
$c_scm_BitSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n)
});
$c_scm_BitSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_scm_SortedSet$()
});
$c_scm_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_scm_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()))
});
$c_scm_BitSet.prototype.nwords__I = (function() {
  return $n(this.scm_BitSet__f_elems).u.length
});
$c_scm_BitSet.prototype.word__I__J = (function(idx) {
  return ((idx < this.nwords__I()) ? $n(this.scm_BitSet__f_elems).get(idx) : $L0)
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__scm_BitSet = (function(elems) {
  return (($n(elems).u.length === 0) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : $ct_scm_BitSet__AJ__(new $c_scm_BitSet(), elems))
});
$c_scm_BitSet.prototype.addOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ((!$f_sc_BitSetOps__contains__I__Z(this, elem))) {
    var idx = (elem >> 6);
    var this$1 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$1.RTLong__f_lo | lo);
    var hi$1 = (this$1.RTLong__f_hi | hi);
    this.updateWord__I__J__V(idx, new $c_RTLong(lo$1, hi$1))
  };
  return this
});
$c_scm_BitSet.prototype.subtractOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var this$1 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (this$1.RTLong__f_lo & lo$1);
    var hi$2 = (this$1.RTLong__f_hi & hi$1);
    this.updateWord__I__J__V(idx, new $c_RTLong(lo$2, hi$2))
  };
  return this
});
$c_scm_BitSet.prototype.updateWord__I__J__V = (function(idx, w) {
  this.ensureCapacity__I__V(idx);
  $n(this.scm_BitSet__f_elems).set(idx, w)
});
$c_scm_BitSet.prototype.ensureCapacity__I__V = (function(idx) {
  $m_s_Predef$().require__Z__V((idx < 33554432));
  if ((idx >= this.nwords__I())) {
    var newlen = this.nwords__I();
    while ((idx >= newlen)) {
      var x = (newlen << 1);
      newlen = ((x < 33554432) ? x : 33554432)
    };
    var elems1 = new $ac_J(newlen);
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_BitSet__f_elems, 0, elems1, 0, this.nwords__I());
    this.scm_BitSet__f_elems = elems1
  }
});
$c_scm_BitSet.prototype.$bar$eq__sc_BitSet__scm_BitSet = (function(other) {
  this.ensureCapacity__I__V((((-1) + $n(other).nwords__I()) | 0));
  var i = 0;
  var othernwords = $n(other).nwords__I();
  while ((i < othernwords)) {
    var $$x2 = $n(this.scm_BitSet__f_elems);
    var $$x1 = i;
    var this$1 = $n(this.scm_BitSet__f_elems).get(i);
    var b = $n(other).word__I__J(i);
    var lo = (this$1.RTLong__f_lo | b.RTLong__f_lo);
    var hi = (this$1.RTLong__f_hi | b.RTLong__f_hi);
    $$x2.set($$x1, new $c_RTLong(lo, hi));
    i = ((1 + i) | 0)
  };
  return this
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_BitSet = (function(xs) {
  if ($is_sc_BitSet(xs)) {
    var x2 = $as_sc_BitSet(xs);
    return this.$bar$eq__sc_BitSet__scm_BitSet(x2)
  } else if ((xs instanceof $c_sci_Range)) {
    var x3 = $as_sci_Range(xs);
    var this$1 = $n(x3);
    if ((!this$1.sci_Range__f_isEmpty)) {
      var start = $n(x3).min__s_math_Ordering__I($m_s_math_Ordering$Int$());
      if ((start >= 0)) {
        var end = $n(x3).max__s_math_Ordering__I($m_s_math_Ordering$Int$());
        var endIdx = (end >> 6);
        this.ensureCapacity__I__V(endIdx);
        if ((($n(x3).sci_Range__f_step === 1) || ($n(x3).sci_Range__f_step === (-1)))) {
          var startIdx = (start >> 6);
          var wordStart = (startIdx << 6);
          var n = ((start - wordStart) | 0);
          var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
          var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
          if ((endIdx > startIdx)) {
            var ev$1 = this.scm_BitSet__f_elems;
            var $$x1 = $n(ev$1);
            var this$2 = $n(ev$1).get(startIdx);
            var lo$1 = (this$2.RTLong__f_lo | lo);
            var hi$1 = (this$2.RTLong__f_hi | hi);
            $$x1.set(startIdx, new $c_RTLong(lo$1, hi$1));
            var a = this.scm_BitSet__f_elems;
            var fromIndex = ((1 + startIdx) | 0);
            $m_ju_Arrays$().fill__AJ__I__I__J__V(a, fromIndex, endIdx, new $c_RTLong((-1), (-1)));
            var ev$2 = this.scm_BitSet__f_elems;
            var $$x2 = $n(ev$2);
            var this$3 = $n(ev$2).get(endIdx);
            var n$1 = ((63 - ((end - (endIdx << 6)) | 0)) | 0);
            var lo$2 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << ((31 - n$1) | 0))) : (((-1) >>> n$1) | 0));
            var hi$2 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
            var lo$3 = (this$3.RTLong__f_lo | lo$2);
            var hi$3 = (this$3.RTLong__f_hi | hi$2);
            $$x2.set(endIdx, new $c_RTLong(lo$3, hi$3))
          } else {
            var ev$3 = this.scm_BitSet__f_elems;
            var $$x3 = $n(ev$3);
            var this$4 = $n(ev$3).get(endIdx);
            var n$2 = ((63 - ((end - wordStart) | 0)) | 0);
            var lo$4 = (((32 & n$2) === 0) ? ((((-1) >>> n$2) | 0) | ((-2) << ((31 - n$2) | 0))) : (((-1) >>> n$2) | 0));
            var hi$4 = (((32 & n$2) === 0) ? (((-1) >>> n$2) | 0) : 0);
            var lo$5 = (lo & lo$4);
            var hi$5 = (hi & hi$4);
            var lo$6 = (this$4.RTLong__f_lo | lo$5);
            var hi$6 = (this$4.RTLong__f_hi | hi$5);
            $$x3.set(endIdx, new $c_RTLong(lo$6, hi$6))
          }
        } else {
          $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3)
        }
      } else {
        $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3)
      }
    };
    return this
  } else if ($is_sc_SortedSet(xs)) {
    var x4 = $as_sc_SortedSet(xs);
    var this$5 = $n(x4);
    if ((!this$5.isEmpty__Z())) {
      var ord = $n(x4).ordering__s_math_Ordering();
      if ((ord === $m_s_math_Ordering$Int$())) {
        var this$6 = $n(x4);
        this.ensureCapacity__I__V(($uI(this$6.last__O()) >> 6))
      } else {
        var this$7 = $m_s_math_Ordering$Int$();
        if ((ord === this$7.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)) {
          var this$8 = $n(x4);
          this.ensureCapacity__I__V(($uI(this$8.head__O()) >> 6))
        }
      };
      var iter = $n(x4).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        this.addOne__I__scm_BitSet($uI($n(iter).next__O()))
      }
    };
    return this
  } else {
    return $as_scm_BitSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_BitSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  if ($is_sc_BitSet(that)) {
    var x2 = $as_sc_BitSet(that);
    var thisnwords = this.nwords__I();
    var bsnwords = $n(x2).nwords__I();
    var minWords = ((thisnwords < bsnwords) ? thisnwords : bsnwords);
    var i = bsnwords;
    while ((i < thisnwords)) {
      var this$2 = this.word__I__J(i);
      if ((!((this$2.RTLong__f_lo === 0) && (this$2.RTLong__f_hi === 0)))) {
        return false
      };
      i = ((1 + i) | 0)
    };
    var j = 0;
    while ((j < minWords)) {
      var this$3 = this.word__I__J(j);
      var b = $n(x2).word__I__J(j);
      var lo = (~b.RTLong__f_lo);
      var hi = (~b.RTLong__f_hi);
      var lo$1 = (this$3.RTLong__f_lo & lo);
      var hi$1 = (this$3.RTLong__f_hi & hi);
      if ((!((lo$1 === 0) && (hi$1 === 0)))) {
        return false
      };
      j = ((1 + j) | 0)
    };
    return true
  } else {
    return $f_sc_IterableOnceOps__forall__F1__Z(this, that)
  }
});
$c_scm_BitSet.prototype.filterImpl__F1__Z__scm_BitSet = (function(pred, isFlipped) {
  var i = (((-1) + this.nwords__I()) | 0);
  var newArray = null;
  while ((i >= 0)) {
    var t = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.word__I__J(i), i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((!((lo === 0) && (hi === 0)))) {
      if ((newArray === null)) {
        newArray = new $ac_J(((1 + i) | 0))
      };
      $n(newArray).set(i, new $c_RTLong(lo, hi))
    };
    i = (((-1) + i) | 0)
  };
  return ((newArray === null) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : this.fromBitMaskNoCopy__AJ__scm_BitSet(newArray))
});
$c_scm_BitSet.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sc_SortedSetOps$WithFilter(this, p)
});
$c_scm_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that)
});
$c_scm_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1)
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_BitSet(xs)
});
$c_scm_BitSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__I__scm_BitSet($uI(elem))
});
$c_scm_BitSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__I__scm_BitSet($uI(elem))
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return this.fromBitMaskNoCopy__AJ__scm_BitSet(elems)
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll)
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll)
});
function $as_scm_BitSet(obj) {
  return (((obj instanceof $c_scm_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.BitSet"))
}
function $isArrayOf_scm_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_BitSet)))
}
function $asArrayOf_scm_BitSet(obj, depth) {
  return (($isArrayOf_scm_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.BitSet;", depth))
}
var $d_scm_BitSet = new $TypeData().initClass({
  scm_BitSet: 0
}, false, "scala.collection.mutable.BitSet", {
  scm_BitSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_BitSet.prototype.$classData = $d_scm_BitSet;
function $ct_scm_Queue__AO__I__I__($thiz, array, start, end) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end);
  return $thiz
}
function $ct_scm_Queue__I__($thiz, initialSize) {
  var array = $m_scm_ArrayDeque$().alloc__I__AO(initialSize);
  $ct_scm_ArrayDeque__AO__I__I__($thiz, array, 0, 0);
  return $thiz
}
/** @constructor */
function $c_scm_Queue() {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0
}
$c_scm_Queue.prototype = new $h_scm_ArrayDeque();
$c_scm_Queue.prototype.constructor = $c_scm_Queue;
/** @constructor */
function $h_scm_Queue() {
  /*<skip>*/
}
$h_scm_Queue.prototype = $c_scm_Queue.prototype;
$c_scm_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_Queue$()
});
$c_scm_Queue.prototype.stringPrefix__T = (function() {
  return "Queue"
});
$c_scm_Queue.prototype.ofArray__AO__I__O = (function(array, end) {
  return $ct_scm_Queue__AO__I__I__(new $c_scm_Queue(), array, 0, end)
});
$c_scm_Queue.prototype.ofArray__AO__I__scm_ArrayDeque = (function(array, end) {
  return $ct_scm_Queue__AO__I__I__(new $c_scm_Queue(), array, 0, end)
});
$c_scm_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Queue$()
});
function $as_scm_Queue(obj) {
  return (((obj instanceof $c_scm_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Queue"))
}
function $isArrayOf_scm_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Queue)))
}
function $asArrayOf_scm_Queue(obj, depth) {
  return (($isArrayOf_scm_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Queue;", depth))
}
var $d_scm_Queue = new $TypeData().initClass({
  scm_Queue: 0
}, false, "scala.collection.mutable.Queue", {
  scm_Queue: 1,
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Queue.prototype.$classData = $d_scm_Queue;
function $ct_Lcats_instances_AllInstancesBinCompat__($thiz) {
  $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  new $c_Lcats_kernel_instances_CharOrder();
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  new $c_Lcats_kernel_instances_BooleanOrder();
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_instances_Tuple2Instances__$init$__V($thiz);
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz);
  $f_Lcats_instances_EitherInstances__$init$__V($thiz);
  $f_Lcats_instances_EqInstances__$init$__V($thiz);
  $f_Lcats_instances_EquivInstances__$init$__V($thiz);
  $f_Lcats_instances_Function0Instances__$init$__V($thiz);
  $f_Lcats_instances_Function1Instances__$init$__V($thiz);
  $f_Lcats_instances_HashInstances__$init$__V($thiz);
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz);
  $f_Lcats_instances_LazyListInstances__$init$__V($thiz);
  $f_Lcats_instances_ListInstances__$init$__V($thiz);
  $f_Lcats_instances_OptionInstances__$init$__V($thiz);
  $f_Lcats_instances_OrderInstances__$init$__V($thiz);
  $f_Lcats_instances_OrderingInstances__$init$__V($thiz);
  $f_Lcats_instances_PartialOrderInstances__$init$__V($thiz);
  $f_Lcats_instances_PartialOrderingInstances__$init$__V($thiz);
  $f_Lcats_instances_QueueInstances__$init$__V($thiz);
  $f_Lcats_instances_SetInstances__$init$__V($thiz);
  $f_Lcats_instances_SortedSetInstances__$init$__V($thiz);
  $f_Lcats_instances_StreamInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  new $c_Lcats_kernel_instances_SymbolOrder();
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_UUIDInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_instances_VectorInstances__$init$__V($thiz);
  $f_Lcats_instances_FunctionInstancesBinCompat0__$init$__V($thiz);
  $f_Lcats_instances_Tuple2InstancesBinCompat0__$init$__V($thiz);
  $f_Lcats_instances_OptionInstancesBinCompat0__$init$__V($thiz);
  $f_Lcats_instances_ListInstancesBinCompat0__$init$__V($thiz);
  $f_Lcats_instances_VectorInstancesBinCompat0__$init$__V($thiz);
  $f_Lcats_instances_StreamInstancesBinCompat0__$init$__V($thiz);
  $f_Lcats_instances_MapInstancesBinCompat0__$init$__V($thiz);
  $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_instances_SortedSetInstancesBinCompat0__$init$__V($thiz);
  $f_Lcats_instances_SeqInstances__$init$__V($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcats_instances_AllInstancesBinCompat() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null
}
$c_Lcats_instances_AllInstancesBinCompat.prototype = new $h_O();
$c_Lcats_instances_AllInstancesBinCompat.prototype.constructor = $c_Lcats_instances_AllInstancesBinCompat;
/** @constructor */
function $h_Lcats_instances_AllInstancesBinCompat() {
  /*<skip>*/
}
$h_Lcats_instances_AllInstancesBinCompat.prototype = $c_Lcats_instances_AllInstancesBinCompat.prototype;
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SortedSetInstancesBinCompat0$_setter_$catsStdSemigroupalForSortedSet_$eq__Lcats_Semigroupal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$MapInstancesBinCompat0$_setter_$catsStdComposeForMap_$eq__Lcats_arrow_Compose__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$StreamInstancesBinCompat0$_setter_$catsStdTraverseFilterForStream_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$VectorInstancesBinCompat0$_setter_$catsStdTraverseFilterForVector_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$ListInstancesBinCompat0$_setter_$catsStdTraverseFilterForList_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$OptionInstancesBinCompat0$_setter_$catsStdTraverseFilterForOption_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Tuple2InstancesBinCompat0$_setter_$catsDataFunctorForPair_$eq__Lcats_Functor__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$FunctionInstancesBinCompat0$_setter_$catsSddDeferForFunction0_$eq__Lcats_Defer__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$VectorInstances$_setter_$catsStdInstancesForVector_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UUIDInstances$_setter_$catsKernelStdOrderForUUID_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$StreamInstances$_setter_$catsStdInstancesForStream_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SortedSetInstances$_setter_$catsStdInstancesForSortedSet_$eq__Lcats_Foldable__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SetInstances$_setter_$catsStdInstancesForSet_$eq__Lcats_UnorderedTraverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$QueueInstances$_setter_$catsStdInstancesForQueue_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$PartialOrderingInstances$_setter_$catsContravariantMonoidalForPartialOrdering_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$PartialOrderInstances$_setter_$catsContravariantMonoidalForPartialOrder_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$OrderingInstances$_setter_$catsContravariantMonoidalForOrdering_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$OrderInstances$_setter_$catsContravariantMonoidalForOrder_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$OptionInstances$_setter_$catsStdInstancesForOption_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$ListInstances$_setter_$catsStdInstancesForList_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForLazyList__Lcats_Traverse = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Traverse__V = (function(x$1) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = x$1
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$HashInstances$_setter_$catsContravariantForHash_$eq__Lcats_Contravariant__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$1) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = x$1
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function0Instances$_setter_$catsStdBimonadForFunction0_$eq__Lcats_Bimonad__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$EquivInstances$_setter_$catsContravariantMonoidalForEquiv_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$EqInstances$_setter_$catsContravariantMonoidalForEq_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$EitherInstances$_setter_$catsStdBitraverseForEither_$eq__Lcats_Bitraverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_PartialOrder__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Tuple2Instances$_setter_$catsStdBitraverseForTuple2_$eq__Lcats_Bitraverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
/** @constructor */
function $c_Lcats_instances_package$all$() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null;
  $ct_Lcats_instances_AllInstancesBinCompat__(this)
}
$c_Lcats_instances_package$all$.prototype = new $h_Lcats_instances_AllInstancesBinCompat();
$c_Lcats_instances_package$all$.prototype.constructor = $c_Lcats_instances_package$all$;
/** @constructor */
function $h_Lcats_instances_package$all$() {
  /*<skip>*/
}
$h_Lcats_instances_package$all$.prototype = $c_Lcats_instances_package$all$.prototype;
var $d_Lcats_instances_package$all$ = new $TypeData().initClass({
  Lcats_instances_package$all$: 0
}, false, "cats.instances.package$all$", {
  Lcats_instances_package$all$: 1,
  Lcats_instances_AllInstancesBinCompat: 1,
  O: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat6: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_instances_AllInstancesBinCompat7: 1,
  Lcats_instances_SeqInstances: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances2: 1
});
$c_Lcats_instances_package$all$.prototype.$classData = $d_Lcats_instances_package$all$;
var $n_Lcats_instances_package$all$;
function $m_Lcats_instances_package$all$() {
  if ((!$n_Lcats_instances_package$all$)) {
    $n_Lcats_instances_package$all$ = new $c_Lcats_instances_package$all$()
  };
  return $n_Lcats_instances_package$all$
}
/** @constructor */
function $c_Lcats_implicits$() {
  this.Lcats_implicits$__f_catsKernelStdOrderForString = null;
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = null;
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = null;
  $n_Lcats_implicits$ = this;
  $f_Lcats_kernel_instances_IntInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_ByteInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  new $c_Lcats_kernel_instances_CharOrder();
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_ShortInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_FloatInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  new $c_Lcats_kernel_instances_BooleanOrder();
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_UnitInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_instances_Tuple2Instances__$init$__V(this);
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V(this);
  $f_Lcats_instances_EitherInstances__$init$__V(this);
  $f_Lcats_instances_EqInstances__$init$__V(this);
  $f_Lcats_instances_EquivInstances__$init$__V(this);
  $f_Lcats_instances_Function0Instances__$init$__V(this);
  $f_Lcats_instances_Function1Instances__$init$__V(this);
  $f_Lcats_instances_HashInstances__$init$__V(this);
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_LazyListInstances__$init$__V(this);
  $f_Lcats_instances_ListInstances__$init$__V(this);
  $f_Lcats_instances_OptionInstances__$init$__V(this);
  $f_Lcats_instances_OrderInstances__$init$__V(this);
  $f_Lcats_instances_OrderingInstances__$init$__V(this);
  $f_Lcats_instances_PartialOrderInstances__$init$__V(this);
  $f_Lcats_instances_PartialOrderingInstances__$init$__V(this);
  $f_Lcats_instances_QueueInstances__$init$__V(this);
  $f_Lcats_instances_SetInstances__$init$__V(this);
  $f_Lcats_instances_SortedSetInstances__$init$__V(this);
  $f_Lcats_instances_StreamInstances__$init$__V(this);
  $f_Lcats_kernel_instances_StringInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  new $c_Lcats_kernel_instances_SymbolOrder();
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_kernel_instances_UUIDInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_instances_VectorInstances__$init$__V(this);
  $f_Lcats_instances_FunctionInstancesBinCompat0__$init$__V(this);
  $f_Lcats_instances_Tuple2InstancesBinCompat0__$init$__V(this);
  $f_Lcats_instances_OptionInstancesBinCompat0__$init$__V(this);
  $f_Lcats_instances_ListInstancesBinCompat0__$init$__V(this);
  $f_Lcats_instances_VectorInstancesBinCompat0__$init$__V(this);
  $f_Lcats_instances_StreamInstancesBinCompat0__$init$__V(this);
  $f_Lcats_instances_MapInstancesBinCompat0__$init$__V(this);
  $f_Lcats_kernel_instances_DurationInstances__$init$__V(this);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V(this);
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$3();
  $f_Lcats_instances_SortedSetInstancesBinCompat0__$init$__V(this)
}
$c_Lcats_implicits$.prototype = new $h_O();
$c_Lcats_implicits$.prototype.constructor = $c_Lcats_implicits$;
/** @constructor */
function $h_Lcats_implicits$() {
  /*<skip>*/
}
$h_Lcats_implicits$.prototype = $c_Lcats_implicits$.prototype;
$c_Lcats_implicits$.prototype.cats$instances$SortedSetInstancesBinCompat0$_setter_$catsStdSemigroupalForSortedSet_$eq__Lcats_Semigroupal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$MapInstancesBinCompat0$_setter_$catsStdComposeForMap_$eq__Lcats_arrow_Compose__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$StreamInstancesBinCompat0$_setter_$catsStdTraverseFilterForStream_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$VectorInstancesBinCompat0$_setter_$catsStdTraverseFilterForVector_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$ListInstancesBinCompat0$_setter_$catsStdTraverseFilterForList_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$OptionInstancesBinCompat0$_setter_$catsStdTraverseFilterForOption_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$Tuple2InstancesBinCompat0$_setter_$catsDataFunctorForPair_$eq__Lcats_Functor__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$FunctionInstancesBinCompat0$_setter_$catsSddDeferForFunction0_$eq__Lcats_Defer__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$VectorInstances$_setter_$catsStdInstancesForVector_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UUIDInstances$_setter_$catsKernelStdOrderForUUID_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Order__V = (function(x$1) {
  this.Lcats_implicits$__f_catsKernelStdOrderForString = x$1
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$StreamInstances$_setter_$catsStdInstancesForStream_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$SortedSetInstances$_setter_$catsStdInstancesForSortedSet_$eq__Lcats_Foldable__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$SetInstances$_setter_$catsStdInstancesForSet_$eq__Lcats_UnorderedTraverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$QueueInstances$_setter_$catsStdInstancesForQueue_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$PartialOrderingInstances$_setter_$catsContravariantMonoidalForPartialOrdering_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$PartialOrderInstances$_setter_$catsContravariantMonoidalForPartialOrder_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$OrderingInstances$_setter_$catsContravariantMonoidalForOrdering_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$OrderInstances$_setter_$catsContravariantMonoidalForOrder_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$OptionInstances$_setter_$catsStdInstancesForOption_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$ListInstances$_setter_$catsStdInstancesForList_$eq__Lcats_Traverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.catsStdInstancesForLazyList__Lcats_Traverse = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForLazyList
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Traverse__V = (function(x$1) {
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = x$1
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$HashInstances$_setter_$catsContravariantForHash_$eq__Lcats_Contravariant__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForFunction1
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$1) {
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = x$1
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$Function0Instances$_setter_$catsStdBimonadForFunction0_$eq__Lcats_Bimonad__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$EquivInstances$_setter_$catsContravariantMonoidalForEquiv_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$EqInstances$_setter_$catsContravariantMonoidalForEq_$eq__Lcats_ContravariantMonoidal__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$EitherInstances$_setter_$catsStdBitraverseForEither_$eq__Lcats_Bitraverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_PartialOrder__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$instances$Tuple2Instances$_setter_$catsStdBitraverseForTuple2_$eq__Lcats_Bitraverse__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_Order__V = (function(x$1) {
  /*<skip>*/
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$1) {
  /*<skip>*/
});
var $d_Lcats_implicits$ = new $TypeData().initClass({
  Lcats_implicits$: 0
}, false, "cats.implicits$", {
  Lcats_implicits$: 1,
  O: 1,
  Lcats_syntax_AllSyntax: 1,
  Lcats_syntax_AlternativeSyntax: 1,
  Lcats_syntax_AlignSyntax: 1,
  Lcats_Align$ToAlignOps: 1,
  Ljava_io_Serializable: 1,
  Lcats_syntax_ApplicativeSyntax: 1,
  Lcats_syntax_ApplicativeErrorSyntax: 1,
  Lcats_syntax_ApplySyntax: 1,
  Lcats_syntax_TupleSemigroupalSyntax: 1,
  Lcats_syntax_ArrowSyntax: 1,
  Lcats_arrow_Arrow$ToArrowOps: 1,
  Lcats_syntax_ArrowChoiceSyntax: 1,
  Lcats_arrow_ArrowChoice$ToArrowChoiceOps: 1,
  Lcats_syntax_BifunctorSyntax: 1,
  Lcats_Bifunctor$ToBifunctorOps: 1,
  Lcats_syntax_BifoldableSyntax: 1,
  Lcats_Bifoldable$ToBifoldableOps: 1,
  Lcats_syntax_BitraverseSyntax: 1,
  Lcats_syntax_BitraverseSyntax1: 1,
  Lcats_syntax_SemigroupalSyntax: 1,
  Lcats_syntax_CoflatMapSyntax: 1,
  Lcats_CoflatMap$ToCoflatMapOps: 1,
  Lcats_syntax_ComonadSyntax: 1,
  Lcats_Comonad$ToComonadOps: 1,
  Lcats_syntax_ComposeSyntax: 1,
  Lcats_arrow_Compose$ToComposeOps: 1,
  Lcats_syntax_ContravariantSyntax: 1,
  Lcats_Contravariant$ToContravariantOps: 1,
  Lcats_syntax_DistributiveSyntax: 1,
  Lcats_Distributive$ToDistributiveOps: 1,
  Lcats_syntax_ContravariantMonoidalSyntax: 1,
  Lcats_syntax_ContravariantSemigroupalSyntax: 1,
  Lcats_syntax_EitherKSyntax: 1,
  Lcats_syntax_EitherSyntax: 1,
  Lcats_syntax_EqSyntax: 1,
  Lcats_syntax_FlatMapSyntax: 1,
  Lcats_FlatMap$ToFlatMapOps: 1,
  Lcats_syntax_FoldableSyntax: 1,
  Lcats_Foldable$ToFoldableOps: 1,
  Lcats_UnorderedFoldable$ToUnorderedFoldableOps: 1,
  Lcats_syntax_FunctorSyntax: 1,
  Lcats_Functor$ToFunctorOps: 1,
  Lcats_syntax_GroupSyntax: 1,
  Lcats_syntax_SemigroupSyntax: 1,
  Lcats_syntax_HashSyntax: 1,
  Lcats_syntax_InvariantSyntax: 1,
  Lcats_Invariant$ToInvariantOps: 1,
  Lcats_syntax_IorSyntax: 1,
  Lcats_syntax_ListSyntax: 1,
  Lcats_syntax_MonadErrorSyntax: 1,
  Lcats_syntax_MonadSyntax: 1,
  Lcats_syntax_MonoidSyntax: 1,
  Lcats_syntax_OptionSyntax: 1,
  Lcats_syntax_OrderSyntax: 1,
  Lcats_syntax_PartialOrderSyntax: 1,
  Lcats_syntax_ParallelSyntax: 1,
  Lcats_syntax_TupleParallelSyntax: 1,
  Lcats_syntax_ProfunctorSyntax: 1,
  Lcats_arrow_Profunctor$ToProfunctorOps: 1,
  Lcats_syntax_ReducibleSyntax: 1,
  Lcats_Reducible$ToReducibleOps: 1,
  Lcats_syntax_SemigroupKSyntax: 1,
  Lcats_SemigroupK$ToSemigroupKOps: 1,
  Lcats_syntax_ShowSyntax: 1,
  Lcats_Show$ToShowOps: 1,
  Lcats_syntax_StrongSyntax: 1,
  Lcats_arrow_Strong$ToStrongOps: 1,
  Lcats_syntax_TraverseSyntax: 1,
  Lcats_Traverse$ToTraverseOps: 1,
  Lcats_syntax_NonEmptyTraverseSyntax: 1,
  Lcats_NonEmptyTraverse$ToNonEmptyTraverseOps: 1,
  Lcats_syntax_ValidatedSyntax: 1,
  Lcats_syntax_VectorSyntax: 1,
  Lcats_syntax_WriterSyntax: 1,
  Lcats_syntax_ParallelFoldMapASyntax: 1,
  Lcats_syntax_ParallelTraverseFilterSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat0: 1,
  Lcats_syntax_UnorderedTraverseSyntax: 1,
  Lcats_UnorderedTraverse$ToUnorderedTraverseOps: 1,
  Lcats_syntax_ApplicativeErrorExtension: 1,
  Lcats_syntax_TrySyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat1: 1,
  Lcats_syntax_FlatMapOptionSyntax: 1,
  Lcats_syntax_ChoiceSyntax: 1,
  Lcats_arrow_Choice$ToChoiceOps: 1,
  Lcats_syntax_NestedSyntax: 1,
  Lcats_syntax_BinestedSyntax: 1,
  Lcats_syntax_ParallelFlatSyntax: 1,
  Lcats_syntax_SetSyntax: 1,
  Lcats_syntax_ValidatedExtensionSyntax: 1,
  Lcats_syntax_RepresentableSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat2: 1,
  Lcats_syntax_ParallelTraverseSyntax: 1,
  Lcats_syntax_TraverseFilterSyntax: 1,
  Lcats_TraverseFilter$ToTraverseFilterOps: 1,
  Lcats_syntax_FunctorFilterSyntax: 1,
  Lcats_FunctorFilter$ToFunctorFilterOps: 1,
  Lcats_syntax_EitherSyntaxBinCompat0: 1,
  Lcats_syntax_ListSyntaxBinCompat0: 1,
  Lcats_syntax_ValidatedSyntaxBincompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat3: 1,
  Lcats_syntax_UnorderedFoldableSyntax: 1,
  Lcats_syntax_Function1Syntax: 1,
  Lcats_syntax_AllSyntaxBinCompat4: 1,
  Lcats_syntax_TraverseFilterSyntaxBinCompat0: 1,
  Lcats_syntax_ApplySyntaxBinCompat0: 1,
  Lcats_syntax_ParallelApplySyntax: 1,
  Lcats_syntax_FoldableSyntaxBinCompat0: 1,
  Lcats_syntax_ReducibleSyntaxBinCompat0: 1,
  Lcats_syntax_FoldableSyntaxBinCompat1: 1,
  Lcats_syntax_BitraverseSyntaxBinCompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat5: 1,
  Lcats_syntax_ParallelBitraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat6: 1,
  Lcats_syntax_ParallelUnorderedTraverseSyntax: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat6: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1
});
$c_Lcats_implicits$.prototype.$classData = $d_Lcats_implicits$;
var $n_Lcats_implicits$;
function $m_Lcats_implicits$() {
  if ((!$n_Lcats_implicits$)) {
    $n_Lcats_implicits$ = new $c_Lcats_implicits$()
  };
  return $n_Lcats_implicits$
}
$L0 = new $c_RTLong(0, 0);
$d_J.zero = $L0;
$sct_Ljava_time_zone_TzdbZoneRulesProvider__stinit__();
$sct_Llocales_cldr_data_LocalesProvider$__stinit__();
$s_Lreactbuild_analyze_cost_Main__main__AT__V(new ($d_T.getArrayOf().constr)([]));
//# sourceMappingURL=costanalyze-fastopt.js.map
